var kb3d = (function (exports) {
    'use strict';

    String.prototype.capitalize = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };
    const splitWordsRegex = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g;
    String.prototype.splitWords = function () {
        return this.match(splitWordsRegex) || [];
    };
    String.prototype.isEqual = function (str) {
        return (this ? this.toUpperCase() : undefined) === (str ? str.toUpperCase() : undefined);
    };
    String.prototype.equalsAny = function (...strings) {
        return strings && strings.some(s => s.isEqual(this));
    };
    String.prototype.toSentence = function () {
        return this.replace(/([A-Z])/g, ' $1') // insert a space before all caps
            .replace(/^./, function (str) {
            return str.toUpperCase();
        }) // uppercase the first character
            .trim(); //trip leading and trainling whitespace
    };
    Object.defineProperty(Array.prototype, 'sortBy', {
        enumerable: false,
        writable: true,
        value: function (predicate) {
            return this.sort((a, b) => {
                if (predicate(a) < predicate(b)) {
                    return -1;
                }
                else if (predicate(a) > predicate(b)) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        },
    });
    Object.defineProperty(Array.prototype, 'remove', {
        enumerable: false,
        writable: true,
        value: function (item) {
            const index = this.indexOf(item);
            if (index != -1) {
                return this.splice(this.indexOf(item), 1);
            }
        },
    });
    Object.defineProperty(Array.prototype, 'removeWhere', {
        enumerable: false,
        writable: true,
        value: function (predicate) {
            const removed = new Array();
            for (let i = this.length - 1; i >= 0; i--) {
                const item = this[i];
                if (predicate(item)) {
                    removed.push(...this.splice(i, 1));
                }
            }
            return removed;
        },
    });
    Object.defineProperty(Array.prototype, 'contains', {
        enumerable: false,
        writable: true,
        value: function (item) {
            const index = this.indexOf(item);
            return index != -1;
        },
    });
    Object.defineProperty(Array.prototype, 'selectMany', {
        enumerable: false,
        writable: true,
        value: function (selector) {
            return this.reduce((out, v) => {
                let vres = selector(v);
                if (vres != null) {
                    if (!Array.isArray(vres))
                        vres = [vres];
                    out.push(...vres);
                }
                return out;
            }, []);
        },
    });
    Object.defineProperty(Array.prototype, 'first', {
        enumerable: false,
        writable: true,
        value: function () {
            let item;
            if (this.length) {
                item = this[0];
            }
            return item;
        },
    });
    Object.defineProperty(Array.prototype, 'last', {
        enumerable: false,
        writable: true,
        value: function () {
            if (this.length) {
                return this[this.length - 1];
            }
            return undefined;
        },
    });
    Object.defineProperty(Array.prototype, 'getCommonOrNull', {
        enumerable: false,
        writable: true,
        value: function (valueDelegate) {
            const arr = this;
            if (this.length && arr.every(i => valueDelegate(i) == valueDelegate(arr[0]))) {
                return valueDelegate(arr[0]);
            }
            return null;
        },
    });
    Object.defineProperty(Array.prototype, 'toMap', {
        enumerable: false,
        writable: true,
        value: function (keySelector) {
            const m = new Map();
            for (const i of this) {
                m.set(keySelector(i), i);
            }
            return m;
        },
    });
    Object.defineProperty(Array.prototype, 'clear', {
        enumerable: false,
        writable: true,
        value: function () {
            if (this.length > 0) {
                this.splice(0, this.length);
            }
        },
    });
    Object.defineProperty(Array.prototype, 'reorder', {
        enumerable: false,
        writable: true,
        value: function (fromIndex, toIndex, undo) {
            if (undo) {
                if (fromIndex > toIndex) {
                    fromIndex--;
                }
                else {
                    toIndex++;
                }
            }
            const itemToMove = this[fromIndex];
            for (let i = fromIndex; i < this.length - 1; i++) {
                this[i] = this[i + 1];
            }
            if (toIndex > fromIndex) {
                toIndex--;
            }
            for (let i = this.length - 1; i > toIndex; i--) {
                this[i] = this[i - 1];
            }
            this[toIndex] = itemToMove;
        },
    });
    Object.defineProperty(Set.prototype, 'find', {
        enumerable: false,
        writable: true,
        value: function (predicate) {
            for (const i of this) {
                if (predicate(i))
                    return i;
            }
            return undefined;
        },
    });
    Object.defineProperty(Map.prototype, 'hasAny', {
        enumerable: false,
        writable: true,
        value: function (...keys) {
            return keys.some(k => this.has(k));
        },
    });

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    class Token {
        constructor(key) {
            this.key = key;
        }
        static withKey(key) {
            const token = this[key];
            if (!token)
                throw new Error(`Could not find token for key '${key}'`);
            return token;
        }
        static tryWithKey(key) {
            const token = this[key];
            return token;
        }
        static MapFrom(...tokens) {
            return new Map(tokens.map(t => [t, null]));
        }
        isPrimitive() {
            return Token.PrimitiveTokenMap.has(this);
        }
        isPrimitiveMesh() {
            return Token.PrimitiveMeshTokenMap.has(this);
        }
        isMesh() {
            return Token.MeshTokenMap.has(this);
        }
        isMeshOrGroup() {
            return Token.MeshAndGroupTokenMap.has(this);
        }
        isMaterial() {
            return Token.MaterialTokenMap.has(this);
        }
        isFeature() {
            return Token.FeatureTokenMap.has(this);
        }
        isTexture() {
            return Token.TextureLayerTokenMap.has(this);
        }
        isLight() {
            return Token.LightTokenMap.has(this);
        }
        isViewpoint() {
            return Token.ViewpointNode === this;
        }
        isMate() {
            return Token.MateNode === this;
        }
        isConnector() {
            return Token.Connector === this || Token.SketchControlPoint === this;
        }
        isAnnotation() {
            return Token.AnnotationTokenMap.has(this);
        }
        isNode() {
            return Token.NodeTokenMap.has(this);
        }
        isSceneNode() {
            return Token.SceneNode === this;
        }
        isSketchPath() {
            return Token.SketchPath === this;
        }
    }
    /** Services */
    Token.HttpService = new Token('HttpService');
    Token.MaterialService = new Token('MaterialService');
    Token.MeshService = new Token('MeshService');
    Token.JobService = new Token('JobService');
    Token.SceneService = new Token('SceneService');
    Token.FontService = new Token('FontService');
    Token.Ignore = new Token('Ignore');
    /** Roots */
    Token.SceneNode = new Token('SceneNode');
    Token.Kb3dObject = new Token('Kb3dObject');
    Token.ImportInfo = new Token('ImportInfo');
    /** Lights */
    Token.LightNode = new Token('LightNode');
    Token.DirectionalLightNode = new Token('DirectionalLightNode');
    Token.HemisphericLightNode = new Token('HemisphericLightNode');
    Token.PointLightNode = new Token('PointLightNode');
    Token.SpotLightNode = new Token('SpotLightNode');
    /** Meshes */
    Token.BoxNode = new Token('BoxNode');
    Token.CustomMeshNode = new Token('CustomMeshNode');
    Token.CylinderNode = new Token('CylinderNode');
    Token.ConeNode = new Token('ConeNode');
    Token.DiscNode = new Token('DiscNode');
    Token.PlaneNode = new Token('PlaneNode');
    Token.SphereNode = new Token('SphereNode');
    Token.TorusNode = new Token('TorusNode');
    Token.MeshNode = new Token('MeshNode');
    Token.PrimitiveMeshNode = new Token('PrimitiveMeshNode');
    Token.MeshGroupNode = new Token('MeshGroupNode');
    Token.SpaceNode = new Token('SpaceNode');
    Token.TextNode = new Token('TextNode');
    Token.SketchNode = new Token('SketchNode');
    Token.SketchPath = new Token('SketchPath');
    /** Dimensions */
    Token.AnnotationNode = new Token('AnnotationNode');
    Token.DimensionNode = new Token('DimensionNode');
    /** Primitives */
    Token.KbColor = new Token('KbColor');
    // public static KbColor4 = new Token<KbColor4>("KbColor4");
    Token.KbGeometry = new Token('KbGeometry');
    Token.KbQuaternion = new Token('KbQuaternion');
    Token.KbVector = new Token('KbVector');
    /** Materials */
    Token.MaterialNode = new Token('MaterialNode');
    Token.AdvancedMaterialNode = new Token('AdvancedMaterialNode');
    Token.MaterialMapping = new Token('MaterialMapping');
    /** Textures */
    Token.TextureLayer = new Token('TextureLayer');
    Token.FileTextureLayer = new Token('FileTextureLayer');
    Token.SvgTextureLayer = new Token('SvgTextureLayer');
    Token.TextTextureLayer = new Token('TextTextureLayer');
    Token.ColorFillTextureLayer = new Token('ColorFillTextureLayer');
    /** Viewpoints */
    Token.ViewpointNode = new Token('ViewpointNode');
    /** Features */
    Token.Feature = new Token('Feature');
    Token.BaseConnector = new Token('BaseConnector');
    Token.Connector = new Token('Connector');
    Token.SketchControlPoint = new Token('SketchControlPoint');
    Token.SubmeshFeature = new Token('SubmeshFeature');
    Token.MoveVerticesFeature = new Token('MoveVerticesFeature');
    Token.WeldVerticesFeature = new Token('WeldVerticesFeature');
    Token.DisplacementMapFeature = new Token('DisplacementMapFeature');
    Token.UvMapFeature = new Token('UvMapFeature');
    Token.LinearPatternFeature = new Token('LinearPatternFeature');
    Token.CircularPatternFeature = new Token('CircularPatternFeature');
    Token.JoinGeometryFeature = new Token('JoinGeometryFeature');
    Token.DeleteFacesFeature = new Token('DeleteFacesFeature');
    Token.NormalSmoothingFeature = new Token('NormalSmoothingFeature');
    Token.SliceFeature = new Token('SliceFeature');
    Token.MirrorFeature = new Token('MirrorFeature');
    Token.TransformFeature = new Token('TransformFeature');
    Token.ExtrudeFeature = new Token('ExtrudeFeature');
    Token.SweepFeature = new Token('SweepFeature');
    Token.MateNode = new Token('MateNode');
    Token.PrimitiveTokens = [Token.KbVector, Token.KbQuaternion, Token.KbColor];
    Token.PrimitiveTokenMap = Token.MapFrom(...Token.PrimitiveTokens);
    Token.PrimitiveMeshTokens = [
        Token.BoxNode,
        Token.CylinderNode,
        Token.ConeNode,
        Token.DiscNode,
        Token.PlaneNode,
        Token.SphereNode,
        Token.TorusNode,
    ];
    Token.PrimitiveMeshTokenMap = Token.MapFrom(...Token.PrimitiveMeshTokens);
    Token.MeshTokens = Token.PrimitiveMeshTokens.concat(Token.CustomMeshNode, Token.SketchNode, Token.TextNode);
    Token.MeshTokenMap = Token.MapFrom(...Token.MeshTokens);
    Token.MeshAndGroupTokens = Token.MeshTokens.concat(Token.MeshGroupNode);
    Token.MeshAndGroupTokenMap = Token.MapFrom(...Token.MeshAndGroupTokens);
    Token.SpaceTokens = Token.MeshAndGroupTokens.concat(Token.SceneNode);
    Token.SpaceTokenMap = Token.MapFrom(...Token.SpaceTokens);
    Token.MaterialTokens = [Token.AdvancedMaterialNode];
    Token.MaterialTokenMap = Token.MapFrom(...Token.MaterialTokens);
    Token.AnnotationTokens = [Token.AnnotationNode, Token.DimensionNode];
    Token.AnnotationTokenMap = Token.MapFrom(...Token.AnnotationTokens);
    Token.PositionalLightTokens = [Token.PointLightNode, Token.SpotLightNode];
    Token.GlobalLightTokens = [Token.DirectionalLightNode, Token.HemisphericLightNode];
    Token.LightTokens = [...Token.GlobalLightTokens, ...Token.PositionalLightTokens];
    Token.LightTokenMap = Token.MapFrom(...Token.LightTokens);
    Token.FeatureTokens = [
        Token.MoveVerticesFeature,
        Token.WeldVerticesFeature,
        Token.DisplacementMapFeature,
        Token.UvMapFeature,
        Token.SubmeshFeature,
        Token.LinearPatternFeature,
        Token.CircularPatternFeature,
        Token.JoinGeometryFeature,
        Token.DeleteFacesFeature,
        Token.NormalSmoothingFeature,
        Token.SliceFeature,
        Token.MirrorFeature,
        Token.TransformFeature,
        Token.ExtrudeFeature,
        Token.SweepFeature,
    ];
    Token.FeatureTokenMap = Token.MapFrom(...Token.FeatureTokens);
    Token.ConnectorTokens = [Token.Connector, Token.SketchControlPoint];
    Token.TextureLayerTokens = [
        Token.TextureLayer,
        Token.FileTextureLayer,
        Token.SvgTextureLayer,
        Token.TextTextureLayer,
        Token.ColorFillTextureLayer,
    ];
    Token.TextureLayerTokenMap = Token.MapFrom(...Token.TextureLayerTokens);
    Token.NodeTokens = [
        ...Token.SpaceTokens,
        ...Token.MaterialTokens,
        ...Token.LightTokens,
        ...Token.AnnotationTokens,
        Token.ViewpointNode,
        Token.MateNode,
    ];
    Token.NodeTokenMap = Token.MapFrom(...Token.NodeTokens);
    Token.BaseNodeTokens = [
        Token.SpaceNode,
        Token.MaterialNode,
        Token.LightNode,
        Token.ViewpointNode,
        Token.MateNode,
        Token.AnnotationNode,
    ];
    Token.AllTokens = Token.NodeTokens.concat(...Token.PrimitiveTokens, Token.FeatureTokens, Token.TextureLayerTokens, Token.ConnectorTokens, [Token.SketchPath]);
    Token.AllTokenMap = Token.MapFrom(...Token.AllTokens);

    const Kb3dModels = new Map();
    /**
     * Curry function to filter items in an array to items of a token type
     * @param classKey String key of the class you want to see if the instance is an instance of
     */
    function ofToken(token) {
        return (instance) => instanceOf(instance, token);
    }
    /**
     * Checks if the instance of a class given is an instance of the class represented by it's
     * injectable class key.  If the instance is an instance of a class that was not
     * decorated, or if the class represented by the key was not decorated, then this will
     * return false!
     * @param instance An instance of a class that was decorated
     * @param classKey String key of the class you want to see if the instance is an instance of
     */
    function instanceOf(instance, token) {
        if (!instance)
            return false;
        const model = Kb3dModels.get(token);
        return model ? instance instanceof model.classConstructor : false;
    }
    /** Curry-able version of instanceOf */
    function isInstanceOf(token) {
        return (instance) => instanceOf(instance, token);
    }
    function getToken(object) {
        const node = object;
        if (node.$type) {
            return Token.tryWithKey(node.$type);
        }
    }
    /**
     * Checks if the instance of a class given is an instance of the class represented by it's
     * injectable class key.  If the instance is an instance of a class that was not
     * decorated, or if the class represented by the key was not decorated, then this will
     * return false!
     * @param instance An instance of a class that was decorated
     * @param classKey String key of the class you want to see if the instance is an instance of
     */
    function instanceOfAny(instance, ...tokens) {
        if (!instance)
            return false;
        return tokens.some(t => instanceOf(instance, t));
    }

    (function (EChangeOperation) {
        // CreateAndPush and Remove correspond to functions in the custom KBArray class.
        // They use Push and Splice internally but also signify we need a
        // changeTracker destroy on undo and redo respectively and create on redo and undo respectively.
        EChangeOperation[EChangeOperation["Push"] = 0] = "Push";
        EChangeOperation[EChangeOperation["Pop"] = 1] = "Pop";
        EChangeOperation[EChangeOperation["Shift"] = 2] = "Shift";
        EChangeOperation[EChangeOperation["Unshift"] = 3] = "Unshift";
        EChangeOperation[EChangeOperation["Splice"] = 4] = "Splice";
        EChangeOperation[EChangeOperation["CreateAndPush"] = 5] = "CreateAndPush";
        EChangeOperation[EChangeOperation["Remove"] = 6] = "Remove";
    })(exports.EChangeOperation || (exports.EChangeOperation = {}));
    function isTrackedClass(object) {
        return object && typeof object === 'object' && '$changesTracked' in object;
    }
    function isTrackedArray(object) {
        return !!object.$isTracked;
    }
    function isTrackedInstance(instance, token) {
        if (!instance)
            return false;
        const model = Kb3dModels.get(token);
        return model ? instance instanceof model.classConstructor && isTrackedClass(instance) : false;
    }
    function isTrackedInstanceOfAny(instance, ...tokens) {
        if (!instance)
            return false;
        return tokens.some(t => isTrackedInstance(instance, t));
    }

    const changedItems = new Set();
    const deletedItems = new Set();
    /** This class syncs changes to the renderer to update the scene view */
    class SyncService {
        static registerChangedState(tracker, modified) {
            if (modified) {
                // If node was deleted, ignore further changes, unless the item was moved to a different parent
                if (!deletedItems.has(tracker) || tracker.changes.has('_parent')) {
                    changedItems.add(tracker);
                }
            }
            else {
                changedItems.delete(tracker);
            }
        }
        // When a new object is being created, the proxy being used to set the values will be the proxy of the parent of the class being created.
        // So, we need to make sure the changed items map is always pointing to the correct proxy (the proxy with the highest specificity)
        static registerNewObject(tracker) {
            changedItems.add(tracker);
        }
        static registerDeleted(tracker) {
            deletedItems.add(tracker);
        }
        static get hasChanges() {
            return changedItems.size > 0 || deletedItems.size > 0;
        }
        static getChangedNodes() {
            return [...changedItems.values()];
        }
        static getDeletedNodes() {
            return [...deletedItems.values()];
        }
        static nodeDeletionProcessed(tracker) {
            //when a node is deleted, we remove it from all the maps
            changedItems.delete(tracker);
            deletedItems.delete(tracker);
        }
        static nodeChangesProcessed(tracker) {
            //when node changes have been processed, we only remove it from the changedItems map
            changedItems.delete(tracker);
        }
    }

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isFunction(x) {
        return typeof x === 'function';
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var _enable_super_gross_mode_that_will_cause_bad_things = false;
    var config = {
        Promise: undefined,
        set useDeprecatedSynchronousErrorHandling(value) {
            if (value) {
                var error = /*@__PURE__*/ new Error();
                /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
            }
            _enable_super_gross_mode_that_will_cause_bad_things = value;
        },
        get useDeprecatedSynchronousErrorHandling() {
            return _enable_super_gross_mode_that_will_cause_bad_things;
        },
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function hostReportError(err) {
        setTimeout(function () { throw err; }, 0);
    }

    /** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
    var empty = {
        closed: true,
        next: function (value) { },
        error: function (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        },
        complete: function () { }
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var isArray = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isObject(x) {
        return x !== null && typeof x === 'object';
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
        function UnsubscriptionErrorImpl(errors) {
            Error.call(this);
            this.message = errors ?
                errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
            this.name = 'UnsubscriptionError';
            this.errors = errors;
            return this;
        }
        UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
        return UnsubscriptionErrorImpl;
    })();
    var UnsubscriptionError = UnsubscriptionErrorImpl;

    /** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
    var Subscription = /*@__PURE__*/ (function () {
        function Subscription(unsubscribe) {
            this.closed = false;
            this._parentOrParents = null;
            this._subscriptions = null;
            if (unsubscribe) {
                this._ctorUnsubscribe = true;
                this._unsubscribe = unsubscribe;
            }
        }
        Subscription.prototype.unsubscribe = function () {
            var errors;
            if (this.closed) {
                return;
            }
            var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
            this.closed = true;
            this._parentOrParents = null;
            this._subscriptions = null;
            if (_parentOrParents instanceof Subscription) {
                _parentOrParents.remove(this);
            }
            else if (_parentOrParents !== null) {
                for (var index = 0; index < _parentOrParents.length; ++index) {
                    var parent_1 = _parentOrParents[index];
                    parent_1.remove(this);
                }
            }
            if (isFunction(_unsubscribe)) {
                if (_ctorUnsubscribe) {
                    this._unsubscribe = undefined;
                }
                try {
                    _unsubscribe.call(this);
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
                }
            }
            if (isArray(_subscriptions)) {
                var index = -1;
                var len = _subscriptions.length;
                while (++index < len) {
                    var sub = _subscriptions[index];
                    if (isObject(sub)) {
                        try {
                            sub.unsubscribe();
                        }
                        catch (e) {
                            errors = errors || [];
                            if (e instanceof UnsubscriptionError) {
                                errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                            }
                            else {
                                errors.push(e);
                            }
                        }
                    }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        };
        Subscription.prototype.add = function (teardown) {
            var subscription = teardown;
            if (!teardown) {
                return Subscription.EMPTY;
            }
            switch (typeof teardown) {
                case 'function':
                    subscription = new Subscription(teardown);
                case 'object':
                    if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                        return subscription;
                    }
                    else if (this.closed) {
                        subscription.unsubscribe();
                        return subscription;
                    }
                    else if (!(subscription instanceof Subscription)) {
                        var tmp = subscription;
                        subscription = new Subscription();
                        subscription._subscriptions = [tmp];
                    }
                    break;
                default: {
                    throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
                }
            }
            var _parentOrParents = subscription._parentOrParents;
            if (_parentOrParents === null) {
                subscription._parentOrParents = this;
            }
            else if (_parentOrParents instanceof Subscription) {
                if (_parentOrParents === this) {
                    return subscription;
                }
                subscription._parentOrParents = [_parentOrParents, this];
            }
            else if (_parentOrParents.indexOf(this) === -1) {
                _parentOrParents.push(this);
            }
            else {
                return subscription;
            }
            var subscriptions = this._subscriptions;
            if (subscriptions === null) {
                this._subscriptions = [subscription];
            }
            else {
                subscriptions.push(subscription);
            }
            return subscription;
        };
        Subscription.prototype.remove = function (subscription) {
            var subscriptions = this._subscriptions;
            if (subscriptions) {
                var subscriptionIndex = subscriptions.indexOf(subscription);
                if (subscriptionIndex !== -1) {
                    subscriptions.splice(subscriptionIndex, 1);
                }
            }
        };
        Subscription.EMPTY = (function (empty) {
            empty.closed = true;
            return empty;
        }(new Subscription()));
        return Subscription;
    }());
    function flattenUnsubscriptionErrors(errors) {
        return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var rxSubscriber = /*@__PURE__*/ (function () {
        return typeof Symbol === 'function'
            ? /*@__PURE__*/ Symbol('rxSubscriber')
            : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
    })();

    /** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
    var Subscriber = /*@__PURE__*/ (function (_super) {
        __extends(Subscriber, _super);
        function Subscriber(destinationOrNext, error, complete) {
            var _this = _super.call(this) || this;
            _this.syncErrorValue = null;
            _this.syncErrorThrown = false;
            _this.syncErrorThrowable = false;
            _this.isStopped = false;
            switch (arguments.length) {
                case 0:
                    _this.destination = empty;
                    break;
                case 1:
                    if (!destinationOrNext) {
                        _this.destination = empty;
                        break;
                    }
                    if (typeof destinationOrNext === 'object') {
                        if (destinationOrNext instanceof Subscriber) {
                            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                            _this.destination = destinationOrNext;
                            destinationOrNext.add(_this);
                        }
                        else {
                            _this.syncErrorThrowable = true;
                            _this.destination = new SafeSubscriber(_this, destinationOrNext);
                        }
                        break;
                    }
                default:
                    _this.syncErrorThrowable = true;
                    _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                    break;
            }
            return _this;
        }
        Subscriber.prototype[rxSubscriber] = function () { return this; };
        Subscriber.create = function (next, error, complete) {
            var subscriber = new Subscriber(next, error, complete);
            subscriber.syncErrorThrowable = false;
            return subscriber;
        };
        Subscriber.prototype.next = function (value) {
            if (!this.isStopped) {
                this._next(value);
            }
        };
        Subscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                this.isStopped = true;
                this._error(err);
            }
        };
        Subscriber.prototype.complete = function () {
            if (!this.isStopped) {
                this.isStopped = true;
                this._complete();
            }
        };
        Subscriber.prototype.unsubscribe = function () {
            if (this.closed) {
                return;
            }
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
        };
        Subscriber.prototype._next = function (value) {
            this.destination.next(value);
        };
        Subscriber.prototype._error = function (err) {
            this.destination.error(err);
            this.unsubscribe();
        };
        Subscriber.prototype._complete = function () {
            this.destination.complete();
            this.unsubscribe();
        };
        Subscriber.prototype._unsubscribeAndRecycle = function () {
            var _parentOrParents = this._parentOrParents;
            this._parentOrParents = null;
            this.unsubscribe();
            this.closed = false;
            this.isStopped = false;
            this._parentOrParents = _parentOrParents;
            return this;
        };
        return Subscriber;
    }(Subscription));
    var SafeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SafeSubscriber, _super);
        function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
            var _this = _super.call(this) || this;
            _this._parentSubscriber = _parentSubscriber;
            var next;
            var context = _this;
            if (isFunction(observerOrNext)) {
                next = observerOrNext;
            }
            else if (observerOrNext) {
                next = observerOrNext.next;
                error = observerOrNext.error;
                complete = observerOrNext.complete;
                if (observerOrNext !== empty) {
                    context = Object.create(observerOrNext);
                    if (isFunction(context.unsubscribe)) {
                        _this.add(context.unsubscribe.bind(context));
                    }
                    context.unsubscribe = _this.unsubscribe.bind(_this);
                }
            }
            _this._context = context;
            _this._next = next;
            _this._error = error;
            _this._complete = complete;
            return _this;
        }
        SafeSubscriber.prototype.next = function (value) {
            if (!this.isStopped && this._next) {
                var _parentSubscriber = this._parentSubscriber;
                if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._next, value);
                }
                else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var _parentSubscriber = this._parentSubscriber;
                var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
                if (this._error) {
                    if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                        this.__tryOrUnsub(this._error, err);
                        this.unsubscribe();
                    }
                    else {
                        this.__tryOrSetError(_parentSubscriber, this._error, err);
                        this.unsubscribe();
                    }
                }
                else if (!_parentSubscriber.syncErrorThrowable) {
                    this.unsubscribe();
                    if (useDeprecatedSynchronousErrorHandling) {
                        throw err;
                    }
                    hostReportError(err);
                }
                else {
                    if (useDeprecatedSynchronousErrorHandling) {
                        _parentSubscriber.syncErrorValue = err;
                        _parentSubscriber.syncErrorThrown = true;
                    }
                    else {
                        hostReportError(err);
                    }
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.complete = function () {
            var _this = this;
            if (!this.isStopped) {
                var _parentSubscriber = this._parentSubscriber;
                if (this._complete) {
                    var wrappedComplete = function () { return _this._complete.call(_this._context); };
                    if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                        this.__tryOrUnsub(wrappedComplete);
                        this.unsubscribe();
                    }
                    else {
                        this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                        this.unsubscribe();
                    }
                }
                else {
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
            try {
                fn.call(this._context, value);
            }
            catch (err) {
                this.unsubscribe();
                if (config.useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                else {
                    hostReportError(err);
                }
            }
        };
        SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
            if (!config.useDeprecatedSynchronousErrorHandling) {
                throw new Error('bad call');
            }
            try {
                fn.call(this._context, value);
            }
            catch (err) {
                if (config.useDeprecatedSynchronousErrorHandling) {
                    parent.syncErrorValue = err;
                    parent.syncErrorThrown = true;
                    return true;
                }
                else {
                    hostReportError(err);
                    return true;
                }
            }
            return false;
        };
        SafeSubscriber.prototype._unsubscribe = function () {
            var _parentSubscriber = this._parentSubscriber;
            this._context = null;
            this._parentSubscriber = null;
            _parentSubscriber.unsubscribe();
        };
        return SafeSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
    function canReportError(observer) {
        while (observer) {
            var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
            if (closed_1 || isStopped) {
                return false;
            }
            else if (destination && destination instanceof Subscriber) {
                observer = destination;
            }
            else {
                observer = null;
            }
        }
        return true;
    }

    /** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
    function toSubscriber(nextOrObserver, error, complete) {
        if (nextOrObserver) {
            if (nextOrObserver instanceof Subscriber) {
                return nextOrObserver;
            }
            if (nextOrObserver[rxSubscriber]) {
                return nextOrObserver[rxSubscriber]();
            }
        }
        if (!nextOrObserver && !error && !complete) {
            return new Subscriber(empty);
        }
        return new Subscriber(nextOrObserver, error, complete);
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function identity(x) {
        return x;
    }

    /** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
    function pipeFromArray(fns) {
        if (fns.length === 0) {
            return identity;
        }
        if (fns.length === 1) {
            return fns[0];
        }
        return function piped(input) {
            return fns.reduce(function (prev, fn) { return fn(prev); }, input);
        };
    }

    /** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
    var Observable = /*@__PURE__*/ (function () {
        function Observable(subscribe) {
            this._isScalar = false;
            if (subscribe) {
                this._subscribe = subscribe;
            }
        }
        Observable.prototype.lift = function (operator) {
            var observable = new Observable();
            observable.source = this;
            observable.operator = operator;
            return observable;
        };
        Observable.prototype.subscribe = function (observerOrNext, error, complete) {
            var operator = this.operator;
            var sink = toSubscriber(observerOrNext, error, complete);
            if (operator) {
                sink.add(operator.call(sink, this.source));
            }
            else {
                sink.add(this.source || (config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                    this._subscribe(sink) :
                    this._trySubscribe(sink));
            }
            if (config.useDeprecatedSynchronousErrorHandling) {
                if (sink.syncErrorThrowable) {
                    sink.syncErrorThrowable = false;
                    if (sink.syncErrorThrown) {
                        throw sink.syncErrorValue;
                    }
                }
            }
            return sink;
        };
        Observable.prototype._trySubscribe = function (sink) {
            try {
                return this._subscribe(sink);
            }
            catch (err) {
                if (config.useDeprecatedSynchronousErrorHandling) {
                    sink.syncErrorThrown = true;
                    sink.syncErrorValue = err;
                }
                if (canReportError(sink)) {
                    sink.error(err);
                }
                else {
                    console.warn(err);
                }
            }
        };
        Observable.prototype.forEach = function (next, promiseCtor) {
            var _this = this;
            promiseCtor = getPromiseCtor(promiseCtor);
            return new promiseCtor(function (resolve, reject) {
                var subscription;
                subscription = _this.subscribe(function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        if (subscription) {
                            subscription.unsubscribe();
                        }
                    }
                }, reject, resolve);
            });
        };
        Observable.prototype._subscribe = function (subscriber) {
            var source = this.source;
            return source && source.subscribe(subscriber);
        };
        Observable.prototype[observable] = function () {
            return this;
        };
        Observable.prototype.pipe = function () {
            var operations = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                operations[_i] = arguments[_i];
            }
            if (operations.length === 0) {
                return this;
            }
            return pipeFromArray(operations)(this);
        };
        Observable.prototype.toPromise = function (promiseCtor) {
            var _this = this;
            promiseCtor = getPromiseCtor(promiseCtor);
            return new promiseCtor(function (resolve, reject) {
                var value;
                _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
            });
        };
        Observable.create = function (subscribe) {
            return new Observable(subscribe);
        };
        return Observable;
    }());
    function getPromiseCtor(promiseCtor) {
        if (!promiseCtor) {
            promiseCtor =  Promise;
        }
        if (!promiseCtor) {
            throw new Error('no Promise impl found');
        }
        return promiseCtor;
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
        function ObjectUnsubscribedErrorImpl() {
            Error.call(this);
            this.message = 'object unsubscribed';
            this.name = 'ObjectUnsubscribedError';
            return this;
        }
        ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
        return ObjectUnsubscribedErrorImpl;
    })();
    var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

    /** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
    var SubjectSubscription = /*@__PURE__*/ (function (_super) {
        __extends(SubjectSubscription, _super);
        function SubjectSubscription(subject, subscriber) {
            var _this = _super.call(this) || this;
            _this.subject = subject;
            _this.subscriber = subscriber;
            _this.closed = false;
            return _this;
        }
        SubjectSubscription.prototype.unsubscribe = function () {
            if (this.closed) {
                return;
            }
            this.closed = true;
            var subject = this.subject;
            var observers = subject.observers;
            this.subject = null;
            if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
                return;
            }
            var subscriberIndex = observers.indexOf(this.subscriber);
            if (subscriberIndex !== -1) {
                observers.splice(subscriberIndex, 1);
            }
        };
        return SubjectSubscription;
    }(Subscription));

    /** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */
    var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SubjectSubscriber, _super);
        function SubjectSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            return _this;
        }
        return SubjectSubscriber;
    }(Subscriber));
    var Subject = /*@__PURE__*/ (function (_super) {
        __extends(Subject, _super);
        function Subject() {
            var _this = _super.call(this) || this;
            _this.observers = [];
            _this.closed = false;
            _this.isStopped = false;
            _this.hasError = false;
            _this.thrownError = null;
            return _this;
        }
        Subject.prototype[rxSubscriber] = function () {
            return new SubjectSubscriber(this);
        };
        Subject.prototype.lift = function (operator) {
            var subject = new AnonymousSubject(this, this);
            subject.operator = operator;
            return subject;
        };
        Subject.prototype.next = function (value) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            if (!this.isStopped) {
                var observers = this.observers;
                var len = observers.length;
                var copy = observers.slice();
                for (var i = 0; i < len; i++) {
                    copy[i].next(value);
                }
            }
        };
        Subject.prototype.error = function (err) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            this.hasError = true;
            this.thrownError = err;
            this.isStopped = true;
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].error(err);
            }
            this.observers.length = 0;
        };
        Subject.prototype.complete = function () {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            this.isStopped = true;
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].complete();
            }
            this.observers.length = 0;
        };
        Subject.prototype.unsubscribe = function () {
            this.isStopped = true;
            this.closed = true;
            this.observers = null;
        };
        Subject.prototype._trySubscribe = function (subscriber) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else {
                return _super.prototype._trySubscribe.call(this, subscriber);
            }
        };
        Subject.prototype._subscribe = function (subscriber) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else if (this.hasError) {
                subscriber.error(this.thrownError);
                return Subscription.EMPTY;
            }
            else if (this.isStopped) {
                subscriber.complete();
                return Subscription.EMPTY;
            }
            else {
                this.observers.push(subscriber);
                return new SubjectSubscription(this, subscriber);
            }
        };
        Subject.prototype.asObservable = function () {
            var observable = new Observable();
            observable.source = this;
            return observable;
        };
        Subject.create = function (destination, source) {
            return new AnonymousSubject(destination, source);
        };
        return Subject;
    }(Observable));
    var AnonymousSubject = /*@__PURE__*/ (function (_super) {
        __extends(AnonymousSubject, _super);
        function AnonymousSubject(destination, source) {
            var _this = _super.call(this) || this;
            _this.destination = destination;
            _this.source = source;
            return _this;
        }
        AnonymousSubject.prototype.next = function (value) {
            var destination = this.destination;
            if (destination && destination.next) {
                destination.next(value);
            }
        };
        AnonymousSubject.prototype.error = function (err) {
            var destination = this.destination;
            if (destination && destination.error) {
                this.destination.error(err);
            }
        };
        AnonymousSubject.prototype.complete = function () {
            var destination = this.destination;
            if (destination && destination.complete) {
                this.destination.complete();
            }
        };
        AnonymousSubject.prototype._subscribe = function (subscriber) {
            var source = this.source;
            if (source) {
                return this.source.subscribe(subscriber);
            }
            else {
                return Subscription.EMPTY;
            }
        };
        return AnonymousSubject;
    }(Subject));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function refCount() {
        return function refCountOperatorFunction(source) {
            return source.lift(new RefCountOperator(source));
        };
    }
    var RefCountOperator = /*@__PURE__*/ (function () {
        function RefCountOperator(connectable) {
            this.connectable = connectable;
        }
        RefCountOperator.prototype.call = function (subscriber, source) {
            var connectable = this.connectable;
            connectable._refCount++;
            var refCounter = new RefCountSubscriber(subscriber, connectable);
            var subscription = source.subscribe(refCounter);
            if (!refCounter.closed) {
                refCounter.connection = connectable.connect();
            }
            return subscription;
        };
        return RefCountOperator;
    }());
    var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RefCountSubscriber, _super);
        function RefCountSubscriber(destination, connectable) {
            var _this = _super.call(this, destination) || this;
            _this.connectable = connectable;
            return _this;
        }
        RefCountSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (!connectable) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var refCount = connectable._refCount;
            if (refCount <= 0) {
                this.connection = null;
                return;
            }
            connectable._refCount = refCount - 1;
            if (refCount > 1) {
                this.connection = null;
                return;
            }
            var connection = this.connection;
            var sharedConnection = connectable._connection;
            this.connection = null;
            if (sharedConnection && (!connection || sharedConnection === connection)) {
                sharedConnection.unsubscribe();
            }
        };
        return RefCountSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */
    var ConnectableObservable = /*@__PURE__*/ (function (_super) {
        __extends(ConnectableObservable, _super);
        function ConnectableObservable(source, subjectFactory) {
            var _this = _super.call(this) || this;
            _this.source = source;
            _this.subjectFactory = subjectFactory;
            _this._refCount = 0;
            _this._isComplete = false;
            return _this;
        }
        ConnectableObservable.prototype._subscribe = function (subscriber) {
            return this.getSubject().subscribe(subscriber);
        };
        ConnectableObservable.prototype.getSubject = function () {
            var subject = this._subject;
            if (!subject || subject.isStopped) {
                this._subject = this.subjectFactory();
            }
            return this._subject;
        };
        ConnectableObservable.prototype.connect = function () {
            var connection = this._connection;
            if (!connection) {
                this._isComplete = false;
                connection = this._connection = new Subscription();
                connection.add(this.source
                    .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
                if (connection.closed) {
                    this._connection = null;
                    connection = Subscription.EMPTY;
                }
            }
            return connection;
        };
        ConnectableObservable.prototype.refCount = function () {
            return refCount()(this);
        };
        return ConnectableObservable;
    }(Observable));
    var connectableObservableDescriptor = /*@__PURE__*/ (function () {
        var connectableProto = ConnectableObservable.prototype;
        return {
            operator: { value: null },
            _refCount: { value: 0, writable: true },
            _subject: { value: null, writable: true },
            _connection: { value: null, writable: true },
            _subscribe: { value: connectableProto._subscribe },
            _isComplete: { value: connectableProto._isComplete, writable: true },
            getSubject: { value: connectableProto.getSubject },
            connect: { value: connectableProto.connect },
            refCount: { value: connectableProto.refCount }
        };
    })();
    var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ConnectableSubscriber, _super);
        function ConnectableSubscriber(destination, connectable) {
            var _this = _super.call(this, destination) || this;
            _this.connectable = connectable;
            return _this;
        }
        ConnectableSubscriber.prototype._error = function (err) {
            this._unsubscribe();
            _super.prototype._error.call(this, err);
        };
        ConnectableSubscriber.prototype._complete = function () {
            this.connectable._isComplete = true;
            this._unsubscribe();
            _super.prototype._complete.call(this);
        };
        ConnectableSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (connectable) {
                this.connectable = null;
                var connection = connectable._connection;
                connectable._refCount = 0;
                connectable._subject = null;
                connectable._connection = null;
                if (connection) {
                    connection.unsubscribe();
                }
            }
        };
        return ConnectableSubscriber;
    }(SubjectSubscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */
    var BehaviorSubject = /*@__PURE__*/ (function (_super) {
        __extends(BehaviorSubject, _super);
        function BehaviorSubject(_value) {
            var _this = _super.call(this) || this;
            _this._value = _value;
            return _this;
        }
        Object.defineProperty(BehaviorSubject.prototype, "value", {
            get: function () {
                return this.getValue();
            },
            enumerable: true,
            configurable: true
        });
        BehaviorSubject.prototype._subscribe = function (subscriber) {
            var subscription = _super.prototype._subscribe.call(this, subscriber);
            if (subscription && !subscription.closed) {
                subscriber.next(this._value);
            }
            return subscription;
        };
        BehaviorSubject.prototype.getValue = function () {
            if (this.hasError) {
                throw this.thrownError;
            }
            else if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else {
                return this._value;
            }
        };
        BehaviorSubject.prototype.next = function (value) {
            _super.prototype.next.call(this, this._value = value);
        };
        return BehaviorSubject;
    }(Subject));

    /** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
    var Action = /*@__PURE__*/ (function (_super) {
        __extends(Action, _super);
        function Action(scheduler, work) {
            return _super.call(this) || this;
        }
        Action.prototype.schedule = function (state, delay) {
            return this;
        };
        return Action;
    }(Subscription));

    /** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
    var AsyncAction = /*@__PURE__*/ (function (_super) {
        __extends(AsyncAction, _super);
        function AsyncAction(scheduler, work) {
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            _this.pending = false;
            return _this;
        }
        AsyncAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (this.closed) {
                return this;
            }
            this.state = state;
            var id = this.id;
            var scheduler = this.scheduler;
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, delay);
            }
            this.pending = true;
            this.delay = delay;
            this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
            return this;
        };
        AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return setInterval(scheduler.flush.bind(scheduler, this), delay);
        };
        AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay !== null && this.delay === delay && this.pending === false) {
                return id;
            }
            clearInterval(id);
            return undefined;
        };
        AsyncAction.prototype.execute = function (state, delay) {
            if (this.closed) {
                return new Error('executing a cancelled action');
            }
            this.pending = false;
            var error = this._execute(state, delay);
            if (error) {
                return error;
            }
            else if (this.pending === false && this.id != null) {
                this.id = this.recycleAsyncId(this.scheduler, this.id, null);
            }
        };
        AsyncAction.prototype._execute = function (state, delay) {
            var errored = false;
            var errorValue = undefined;
            try {
                this.work(state);
            }
            catch (e) {
                errored = true;
                errorValue = !!e && e || new Error(e);
            }
            if (errored) {
                this.unsubscribe();
                return errorValue;
            }
        };
        AsyncAction.prototype._unsubscribe = function () {
            var id = this.id;
            var scheduler = this.scheduler;
            var actions = scheduler.actions;
            var index = actions.indexOf(this);
            this.work = null;
            this.state = null;
            this.pending = false;
            this.scheduler = null;
            if (index !== -1) {
                actions.splice(index, 1);
            }
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
        };
        return AsyncAction;
    }(Action));

    /** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
    var QueueAction = /*@__PURE__*/ (function (_super) {
        __extends(QueueAction, _super);
        function QueueAction(scheduler, work) {
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            return _this;
        }
        QueueAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay > 0) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.delay = delay;
            this.state = state;
            this.scheduler.flush(this);
            return this;
        };
        QueueAction.prototype.execute = function (state, delay) {
            return (delay > 0 || this.closed) ?
                _super.prototype.execute.call(this, state, delay) :
                this._execute(state, delay);
        };
        QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            return scheduler.flush(this);
        };
        return QueueAction;
    }(AsyncAction));

    var Scheduler = /*@__PURE__*/ (function () {
        function Scheduler(SchedulerAction, now) {
            if (now === void 0) {
                now = Scheduler.now;
            }
            this.SchedulerAction = SchedulerAction;
            this.now = now;
        }
        Scheduler.prototype.schedule = function (work, delay, state) {
            if (delay === void 0) {
                delay = 0;
            }
            return new this.SchedulerAction(this, work).schedule(state, delay);
        };
        Scheduler.now = function () { return Date.now(); };
        return Scheduler;
    }());

    /** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
    var AsyncScheduler = /*@__PURE__*/ (function (_super) {
        __extends(AsyncScheduler, _super);
        function AsyncScheduler(SchedulerAction, now) {
            if (now === void 0) {
                now = Scheduler.now;
            }
            var _this = _super.call(this, SchedulerAction, function () {
                if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                    return AsyncScheduler.delegate.now();
                }
                else {
                    return now();
                }
            }) || this;
            _this.actions = [];
            _this.active = false;
            _this.scheduled = undefined;
            return _this;
        }
        AsyncScheduler.prototype.schedule = function (work, delay, state) {
            if (delay === void 0) {
                delay = 0;
            }
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
                return AsyncScheduler.delegate.schedule(work, delay, state);
            }
            else {
                return _super.prototype.schedule.call(this, work, delay, state);
            }
        };
        AsyncScheduler.prototype.flush = function (action) {
            var actions = this.actions;
            if (this.active) {
                actions.push(action);
                return;
            }
            var error;
            this.active = true;
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (action = actions.shift());
            this.active = false;
            if (error) {
                while (action = actions.shift()) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AsyncScheduler;
    }(Scheduler));

    /** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
    var QueueScheduler = /*@__PURE__*/ (function (_super) {
        __extends(QueueScheduler, _super);
        function QueueScheduler() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return QueueScheduler;
    }(AsyncScheduler));

    /** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */
    var queueScheduler = /*@__PURE__*/ new QueueScheduler(QueueAction);
    var queue = queueScheduler;

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
    var EMPTY = /*@__PURE__*/ new Observable(function (subscriber) { return subscriber.complete(); });
    function empty$1(scheduler) {
        return scheduler ? emptyScheduled(scheduler) : EMPTY;
    }
    function emptyScheduled(scheduler) {
        return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isScheduler(value) {
        return value && typeof value.schedule === 'function';
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var subscribeToArray = function (array) {
        return function (subscriber) {
            for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        };
    };

    /** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
    function scheduleArray(input, scheduler) {
        return new Observable(function (subscriber) {
            var sub = new Subscription();
            var i = 0;
            sub.add(scheduler.schedule(function () {
                if (i === input.length) {
                    subscriber.complete();
                    return;
                }
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    sub.add(this.schedule());
                }
            }));
            return sub;
        });
    }

    /** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */
    function fromArray(input, scheduler) {
        if (!scheduler) {
            return new Observable(subscribeToArray(input));
        }
        else {
            return scheduleArray(input, scheduler);
        }
    }

    /** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */
    function of() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var scheduler = args[args.length - 1];
        if (isScheduler(scheduler)) {
            args.pop();
            return scheduleArray(args, scheduler);
        }
        else {
            return fromArray(args);
        }
    }

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
    function throwError(error, scheduler) {
        if (!scheduler) {
            return new Observable(function (subscriber) { return subscriber.error(error); });
        }
        else {
            return new Observable(function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
        }
    }
    function dispatch(_a) {
        var error = _a.error, subscriber = _a.subscriber;
        subscriber.error(error);
    }

    /** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */
    var Notification = /*@__PURE__*/ (function () {
        function Notification(kind, value, error) {
            this.kind = kind;
            this.value = value;
            this.error = error;
            this.hasValue = kind === 'N';
        }
        Notification.prototype.observe = function (observer) {
            switch (this.kind) {
                case 'N':
                    return observer.next && observer.next(this.value);
                case 'E':
                    return observer.error && observer.error(this.error);
                case 'C':
                    return observer.complete && observer.complete();
            }
        };
        Notification.prototype.do = function (next, error, complete) {
            var kind = this.kind;
            switch (kind) {
                case 'N':
                    return next && next(this.value);
                case 'E':
                    return error && error(this.error);
                case 'C':
                    return complete && complete();
            }
        };
        Notification.prototype.accept = function (nextOrObserver, error, complete) {
            if (nextOrObserver && typeof nextOrObserver.next === 'function') {
                return this.observe(nextOrObserver);
            }
            else {
                return this.do(nextOrObserver, error, complete);
            }
        };
        Notification.prototype.toObservable = function () {
            var kind = this.kind;
            switch (kind) {
                case 'N':
                    return of(this.value);
                case 'E':
                    return throwError(this.error);
                case 'C':
                    return empty$1();
            }
            throw new Error('unexpected notification kind value');
        };
        Notification.createNext = function (value) {
            if (typeof value !== 'undefined') {
                return new Notification('N', value);
            }
            return Notification.undefinedValueNotification;
        };
        Notification.createError = function (err) {
            return new Notification('E', undefined, err);
        };
        Notification.createComplete = function () {
            return Notification.completeNotification;
        };
        Notification.completeNotification = new Notification('C');
        Notification.undefinedValueNotification = new Notification('N', undefined);
        return Notification;
    }());

    /** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
    var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ObserveOnSubscriber, _super);
        function ObserveOnSubscriber(destination, scheduler, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            var _this = _super.call(this, destination) || this;
            _this.scheduler = scheduler;
            _this.delay = delay;
            return _this;
        }
        ObserveOnSubscriber.dispatch = function (arg) {
            var notification = arg.notification, destination = arg.destination;
            notification.observe(destination);
            this.unsubscribe();
        };
        ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
            var destination = this.destination;
            destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
        };
        ObserveOnSubscriber.prototype._next = function (value) {
            this.scheduleMessage(Notification.createNext(value));
        };
        ObserveOnSubscriber.prototype._error = function (err) {
            this.scheduleMessage(Notification.createError(err));
            this.unsubscribe();
        };
        ObserveOnSubscriber.prototype._complete = function () {
            this.scheduleMessage(Notification.createComplete());
            this.unsubscribe();
        };
        return ObserveOnSubscriber;
    }(Subscriber));
    var ObserveOnMessage = /*@__PURE__*/ (function () {
        function ObserveOnMessage(notification, destination) {
            this.notification = notification;
            this.destination = destination;
        }
        return ObserveOnMessage;
    }());

    /** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */
    var ReplaySubject = /*@__PURE__*/ (function (_super) {
        __extends(ReplaySubject, _super);
        function ReplaySubject(bufferSize, windowTime, scheduler) {
            if (bufferSize === void 0) {
                bufferSize = Number.POSITIVE_INFINITY;
            }
            if (windowTime === void 0) {
                windowTime = Number.POSITIVE_INFINITY;
            }
            var _this = _super.call(this) || this;
            _this.scheduler = scheduler;
            _this._events = [];
            _this._infiniteTimeWindow = false;
            _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
            _this._windowTime = windowTime < 1 ? 1 : windowTime;
            if (windowTime === Number.POSITIVE_INFINITY) {
                _this._infiniteTimeWindow = true;
                _this.next = _this.nextInfiniteTimeWindow;
            }
            else {
                _this.next = _this.nextTimeWindow;
            }
            return _this;
        }
        ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
            if (!this.isStopped) {
                var _events = this._events;
                _events.push(value);
                if (_events.length > this._bufferSize) {
                    _events.shift();
                }
            }
            _super.prototype.next.call(this, value);
        };
        ReplaySubject.prototype.nextTimeWindow = function (value) {
            if (!this.isStopped) {
                this._events.push(new ReplayEvent(this._getNow(), value));
                this._trimBufferThenGetEvents();
            }
            _super.prototype.next.call(this, value);
        };
        ReplaySubject.prototype._subscribe = function (subscriber) {
            var _infiniteTimeWindow = this._infiniteTimeWindow;
            var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
            var scheduler = this.scheduler;
            var len = _events.length;
            var subscription;
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else if (this.isStopped || this.hasError) {
                subscription = Subscription.EMPTY;
            }
            else {
                this.observers.push(subscriber);
                subscription = new SubjectSubscription(this, subscriber);
            }
            if (scheduler) {
                subscriber.add(subscriber = new ObserveOnSubscriber(subscriber, scheduler));
            }
            if (_infiniteTimeWindow) {
                for (var i = 0; i < len && !subscriber.closed; i++) {
                    subscriber.next(_events[i]);
                }
            }
            else {
                for (var i = 0; i < len && !subscriber.closed; i++) {
                    subscriber.next(_events[i].value);
                }
            }
            if (this.hasError) {
                subscriber.error(this.thrownError);
            }
            else if (this.isStopped) {
                subscriber.complete();
            }
            return subscription;
        };
        ReplaySubject.prototype._getNow = function () {
            return (this.scheduler || queue).now();
        };
        ReplaySubject.prototype._trimBufferThenGetEvents = function () {
            var now = this._getNow();
            var _bufferSize = this._bufferSize;
            var _windowTime = this._windowTime;
            var _events = this._events;
            var eventsCount = _events.length;
            var spliceCount = 0;
            while (spliceCount < eventsCount) {
                if ((now - _events[spliceCount].time) < _windowTime) {
                    break;
                }
                spliceCount++;
            }
            if (eventsCount > _bufferSize) {
                spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
            }
            if (spliceCount > 0) {
                _events.splice(0, spliceCount);
            }
            return _events;
        };
        return ReplaySubject;
    }(Subject));
    var ReplayEvent = /*@__PURE__*/ (function () {
        function ReplayEvent(time, value) {
            this.time = time;
            this.value = value;
        }
        return ReplayEvent;
    }());

    /** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
    var asyncScheduler = /*@__PURE__*/ new AsyncScheduler(AsyncAction);
    var async = asyncScheduler;

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
        function ArgumentOutOfRangeErrorImpl() {
            Error.call(this);
            this.message = 'argument out of range';
            this.name = 'ArgumentOutOfRangeError';
            return this;
        }
        ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
        return ArgumentOutOfRangeErrorImpl;
    })();
    var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var EmptyErrorImpl = /*@__PURE__*/ (function () {
        function EmptyErrorImpl() {
            Error.call(this);
            this.message = 'no elements in sequence';
            this.name = 'EmptyError';
            return this;
        }
        EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
        return EmptyErrorImpl;
    })();
    var EmptyError = EmptyErrorImpl;

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function map(project, thisArg) {
        return function mapOperation(source) {
            if (typeof project !== 'function') {
                throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
            }
            return source.lift(new MapOperator(project, thisArg));
        };
    }
    var MapOperator = /*@__PURE__*/ (function () {
        function MapOperator(project, thisArg) {
            this.project = project;
            this.thisArg = thisArg;
        }
        MapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
        };
        return MapOperator;
    }());
    var MapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MapSubscriber, _super);
        function MapSubscriber(destination, project, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.count = 0;
            _this.thisArg = thisArg || _this;
            return _this;
        }
        MapSubscriber.prototype._next = function (value) {
            var result;
            try {
                result = this.project.call(this.thisArg, value, this.count++);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return MapSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var OuterSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(OuterSubscriber, _super);
        function OuterSubscriber() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(innerValue);
        };
        OuterSubscriber.prototype.notifyError = function (error, innerSub) {
            this.destination.error(error);
        };
        OuterSubscriber.prototype.notifyComplete = function (innerSub) {
            this.destination.complete();
        };
        return OuterSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var InnerSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(InnerSubscriber, _super);
        function InnerSubscriber(parent, outerValue, outerIndex) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            _this.outerValue = outerValue;
            _this.outerIndex = outerIndex;
            _this.index = 0;
            return _this;
        }
        InnerSubscriber.prototype._next = function (value) {
            this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
        };
        InnerSubscriber.prototype._error = function (error) {
            this.parent.notifyError(error, this);
            this.unsubscribe();
        };
        InnerSubscriber.prototype._complete = function () {
            this.parent.notifyComplete(this);
            this.unsubscribe();
        };
        return InnerSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
    var subscribeToPromise = function (promise) {
        return function (subscriber) {
            promise.then(function (value) {
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function (err) { return subscriber.error(err); })
                .then(null, hostReportError);
            return subscriber;
        };
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function getSymbolIterator() {
        if (typeof Symbol !== 'function' || !Symbol.iterator) {
            return '@@iterator';
        }
        return Symbol.iterator;
    }
    var iterator = /*@__PURE__*/ getSymbolIterator();

    /** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
    var subscribeToIterable = function (iterable) {
        return function (subscriber) {
            var iterator$1 = iterable[iterator]();
            do {
                var item = void 0;
                try {
                    item = iterator$1.next();
                }
                catch (err) {
                    subscriber.error(err);
                    return subscriber;
                }
                if (item.done) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(item.value);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
            if (typeof iterator$1.return === 'function') {
                subscriber.add(function () {
                    if (iterator$1.return) {
                        iterator$1.return();
                    }
                });
            }
            return subscriber;
        };
    };

    /** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
    var subscribeToObservable = function (obj) {
        return function (subscriber) {
            var obs = obj[observable]();
            if (typeof obs.subscribe !== 'function') {
                throw new TypeError('Provided object does not correctly implement Symbol.observable');
            }
            else {
                return obs.subscribe(subscriber);
            }
        };
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isPromise(value) {
        return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
    }

    /** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
    var subscribeTo = function (result) {
        if (!!result && typeof result[observable] === 'function') {
            return subscribeToObservable(result);
        }
        else if (isArrayLike(result)) {
            return subscribeToArray(result);
        }
        else if (isPromise(result)) {
            return subscribeToPromise(result);
        }
        else if (!!result && typeof result[iterator] === 'function') {
            return subscribeToIterable(result);
        }
        else {
            var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
            var msg = "You provided " + value + " where a stream was expected."
                + ' You can provide an Observable, Promise, Array, or Iterable.';
            throw new TypeError(msg);
        }
    };

    /** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */
    function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
        if (innerSubscriber === void 0) {
            innerSubscriber = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
        }
        if (innerSubscriber.closed) {
            return undefined;
        }
        if (result instanceof Observable) {
            return result.subscribe(innerSubscriber);
        }
        return subscribeTo(result)(innerSubscriber);
    }

    /** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */
    var NONE = {};
    function combineLatest() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i] = arguments[_i];
        }
        var resultSelector = undefined;
        var scheduler = undefined;
        if (isScheduler(observables[observables.length - 1])) {
            scheduler = observables.pop();
        }
        if (typeof observables[observables.length - 1] === 'function') {
            resultSelector = observables.pop();
        }
        if (observables.length === 1 && isArray(observables[0])) {
            observables = observables[0];
        }
        return fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
    }
    var CombineLatestOperator = /*@__PURE__*/ (function () {
        function CombineLatestOperator(resultSelector) {
            this.resultSelector = resultSelector;
        }
        CombineLatestOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
        };
        return CombineLatestOperator;
    }());
    var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(CombineLatestSubscriber, _super);
        function CombineLatestSubscriber(destination, resultSelector) {
            var _this = _super.call(this, destination) || this;
            _this.resultSelector = resultSelector;
            _this.active = 0;
            _this.values = [];
            _this.observables = [];
            return _this;
        }
        CombineLatestSubscriber.prototype._next = function (observable) {
            this.values.push(NONE);
            this.observables.push(observable);
        };
        CombineLatestSubscriber.prototype._complete = function () {
            var observables = this.observables;
            var len = observables.length;
            if (len === 0) {
                this.destination.complete();
            }
            else {
                this.active = len;
                this.toRespond = len;
                for (var i = 0; i < len; i++) {
                    var observable = observables[i];
                    this.add(subscribeToResult(this, observable, undefined, i));
                }
            }
        };
        CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
            if ((this.active -= 1) === 0) {
                this.destination.complete();
            }
        };
        CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
            var values = this.values;
            var oldVal = values[outerIndex];
            var toRespond = !this.toRespond
                ? 0
                : oldVal === NONE ? --this.toRespond : this.toRespond;
            values[outerIndex] = innerValue;
            if (toRespond === 0) {
                if (this.resultSelector) {
                    this._tryResultSelector(values);
                }
                else {
                    this.destination.next(values.slice());
                }
            }
        };
        CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
            var result;
            try {
                result = this.resultSelector.apply(this, values);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return CombineLatestSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */
    function scheduleObservable(input, scheduler) {
        return new Observable(function (subscriber) {
            var sub = new Subscription();
            sub.add(scheduler.schedule(function () {
                var observable$1 = input[observable]();
                sub.add(observable$1.subscribe({
                    next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                    error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                    complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
                }));
            }));
            return sub;
        });
    }

    /** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
    function schedulePromise(input, scheduler) {
        return new Observable(function (subscriber) {
            var sub = new Subscription();
            sub.add(scheduler.schedule(function () {
                return input.then(function (value) {
                    sub.add(scheduler.schedule(function () {
                        subscriber.next(value);
                        sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                    }));
                }, function (err) {
                    sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
                });
            }));
            return sub;
        });
    }

    /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */
    function scheduleIterable(input, scheduler) {
        if (!input) {
            throw new Error('Iterable cannot be null');
        }
        return new Observable(function (subscriber) {
            var sub = new Subscription();
            var iterator$1;
            sub.add(function () {
                if (iterator$1 && typeof iterator$1.return === 'function') {
                    iterator$1.return();
                }
            });
            sub.add(scheduler.schedule(function () {
                iterator$1 = input[iterator]();
                sub.add(scheduler.schedule(function () {
                    if (subscriber.closed) {
                        return;
                    }
                    var value;
                    var done;
                    try {
                        var result = iterator$1.next();
                        value = result.value;
                        done = result.done;
                    }
                    catch (err) {
                        subscriber.error(err);
                        return;
                    }
                    if (done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(value);
                        this.schedule();
                    }
                }));
            }));
            return sub;
        });
    }

    /** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
    function isInteropObservable(input) {
        return input && typeof input[observable] === 'function';
    }

    /** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
    function isIterable(input) {
        return input && typeof input[iterator] === 'function';
    }

    /** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */
    function scheduled(input, scheduler) {
        if (input != null) {
            if (isInteropObservable(input)) {
                return scheduleObservable(input, scheduler);
            }
            else if (isPromise(input)) {
                return schedulePromise(input, scheduler);
            }
            else if (isArrayLike(input)) {
                return scheduleArray(input, scheduler);
            }
            else if (isIterable(input) || typeof input === 'string') {
                return scheduleIterable(input, scheduler);
            }
        }
        throw new TypeError((input !== null && typeof input || input) + ' is not observable');
    }

    /** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
    function from(input, scheduler) {
        if (!scheduler) {
            if (input instanceof Observable) {
                return input;
            }
            return new Observable(subscribeTo(input));
        }
        else {
            return scheduled(input, scheduler);
        }
    }

    /** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
    var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SimpleInnerSubscriber, _super);
        function SimpleInnerSubscriber(parent) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            return _this;
        }
        SimpleInnerSubscriber.prototype._next = function (value) {
            this.parent.notifyNext(value);
        };
        SimpleInnerSubscriber.prototype._error = function (error) {
            this.parent.notifyError(error);
            this.unsubscribe();
        };
        SimpleInnerSubscriber.prototype._complete = function () {
            this.parent.notifyComplete();
            this.unsubscribe();
        };
        return SimpleInnerSubscriber;
    }(Subscriber));
    var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SimpleOuterSubscriber, _super);
        function SimpleOuterSubscriber() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
            this.destination.next(innerValue);
        };
        SimpleOuterSubscriber.prototype.notifyError = function (err) {
            this.destination.error(err);
        };
        SimpleOuterSubscriber.prototype.notifyComplete = function () {
            this.destination.complete();
        };
        return SimpleOuterSubscriber;
    }(Subscriber));
    function innerSubscribe(result, innerSubscriber) {
        if (innerSubscriber.closed) {
            return undefined;
        }
        if (result instanceof Observable) {
            return result.subscribe(innerSubscriber);
        }
        var subscription;
        try {
            subscription = subscribeTo(result)(innerSubscriber);
        }
        catch (error) {
            innerSubscriber.error(error);
        }
        return subscription;
    }

    /** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
    function mergeMap(project, resultSelector, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        if (typeof resultSelector === 'function') {
            return function (source) { return source.pipe(mergeMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
        }
        else if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
        }
        return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
    }
    var MergeMapOperator = /*@__PURE__*/ (function () {
        function MergeMapOperator(project, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            this.project = project;
            this.concurrent = concurrent;
        }
        MergeMapOperator.prototype.call = function (observer, source) {
            return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
        };
        return MergeMapOperator;
    }());
    var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MergeMapSubscriber, _super);
        function MergeMapSubscriber(destination, project, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.concurrent = concurrent;
            _this.hasCompleted = false;
            _this.buffer = [];
            _this.active = 0;
            _this.index = 0;
            return _this;
        }
        MergeMapSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
                this._tryNext(value);
            }
            else {
                this.buffer.push(value);
            }
        };
        MergeMapSubscriber.prototype._tryNext = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.active++;
            this._innerSub(result);
        };
        MergeMapSubscriber.prototype._innerSub = function (ish) {
            var innerSubscriber = new SimpleInnerSubscriber(this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = innerSubscribe(ish, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
                destination.add(innerSubscription);
            }
        };
        MergeMapSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
                this.destination.complete();
            }
            this.unsubscribe();
        };
        MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
            this.destination.next(innerValue);
        };
        MergeMapSubscriber.prototype.notifyComplete = function () {
            var buffer = this.buffer;
            this.active--;
            if (buffer.length > 0) {
                this._next(buffer.shift());
            }
            else if (this.active === 0 && this.hasCompleted) {
                this.destination.complete();
            }
        };
        return MergeMapSubscriber;
    }(SimpleOuterSubscriber));

    /** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */
    function mergeAll(concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        return mergeMap(identity, concurrent);
    }

    /** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */
    function concatAll() {
        return mergeAll(1);
    }

    /** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */
    function concat() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i] = arguments[_i];
        }
        return concatAll()(of.apply(void 0, observables));
    }

    /** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */
    function merge() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i] = arguments[_i];
        }
        var concurrent = Number.POSITIVE_INFINITY;
        var scheduler = null;
        var last = observables[observables.length - 1];
        if (isScheduler(last)) {
            scheduler = observables.pop();
            if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
                concurrent = observables.pop();
            }
        }
        else if (typeof last === 'number') {
            concurrent = observables.pop();
        }
        if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable) {
            return observables[0];
        }
        return mergeAll(concurrent)(fromArray(observables, scheduler));
    }

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function filter(predicate, thisArg) {
        return function filterOperatorFunction(source) {
            return source.lift(new FilterOperator(predicate, thisArg));
        };
    }
    var FilterOperator = /*@__PURE__*/ (function () {
        function FilterOperator(predicate, thisArg) {
            this.predicate = predicate;
            this.thisArg = thisArg;
        }
        FilterOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
        };
        return FilterOperator;
    }());
    var FilterSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(FilterSubscriber, _super);
        function FilterSubscriber(destination, predicate, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.thisArg = thisArg;
            _this.count = 0;
            return _this;
        }
        FilterSubscriber.prototype._next = function (value) {
            var result;
            try {
                result = this.predicate.call(this.thisArg, value, this.count++);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                this.destination.next(value);
            }
        };
        return FilterSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */
    function debounceTime(dueTime, scheduler) {
        if (scheduler === void 0) {
            scheduler = async;
        }
        return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
    }
    var DebounceTimeOperator = /*@__PURE__*/ (function () {
        function DebounceTimeOperator(dueTime, scheduler) {
            this.dueTime = dueTime;
            this.scheduler = scheduler;
        }
        DebounceTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
        };
        return DebounceTimeOperator;
    }());
    var DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DebounceTimeSubscriber, _super);
        function DebounceTimeSubscriber(destination, dueTime, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.dueTime = dueTime;
            _this.scheduler = scheduler;
            _this.debouncedSubscription = null;
            _this.lastValue = null;
            _this.hasValue = false;
            return _this;
        }
        DebounceTimeSubscriber.prototype._next = function (value) {
            this.clearDebounce();
            this.lastValue = value;
            this.hasValue = true;
            this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
        };
        DebounceTimeSubscriber.prototype._complete = function () {
            this.debouncedNext();
            this.destination.complete();
        };
        DebounceTimeSubscriber.prototype.debouncedNext = function () {
            this.clearDebounce();
            if (this.hasValue) {
                var lastValue = this.lastValue;
                this.lastValue = null;
                this.hasValue = false;
                this.destination.next(lastValue);
            }
        };
        DebounceTimeSubscriber.prototype.clearDebounce = function () {
            var debouncedSubscription = this.debouncedSubscription;
            if (debouncedSubscription !== null) {
                this.remove(debouncedSubscription);
                debouncedSubscription.unsubscribe();
                this.debouncedSubscription = null;
            }
        };
        return DebounceTimeSubscriber;
    }(Subscriber));
    function dispatchNext(subscriber) {
        subscriber.debouncedNext();
    }

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function defaultIfEmpty(defaultValue) {
        if (defaultValue === void 0) {
            defaultValue = null;
        }
        return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
    }
    var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
        function DefaultIfEmptyOperator(defaultValue) {
            this.defaultValue = defaultValue;
        }
        DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
        };
        return DefaultIfEmptyOperator;
    }());
    var DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DefaultIfEmptySubscriber, _super);
        function DefaultIfEmptySubscriber(destination, defaultValue) {
            var _this = _super.call(this, destination) || this;
            _this.defaultValue = defaultValue;
            _this.isEmpty = true;
            return _this;
        }
        DefaultIfEmptySubscriber.prototype._next = function (value) {
            this.isEmpty = false;
            this.destination.next(value);
        };
        DefaultIfEmptySubscriber.prototype._complete = function () {
            if (this.isEmpty) {
                this.destination.next(this.defaultValue);
            }
            this.destination.complete();
        };
        return DefaultIfEmptySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function distinctUntilChanged(compare, keySelector) {
        return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
    }
    var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
        function DistinctUntilChangedOperator(compare, keySelector) {
            this.compare = compare;
            this.keySelector = keySelector;
        }
        DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
        };
        return DistinctUntilChangedOperator;
    }());
    var DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DistinctUntilChangedSubscriber, _super);
        function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
            var _this = _super.call(this, destination) || this;
            _this.keySelector = keySelector;
            _this.hasKey = false;
            if (typeof compare === 'function') {
                _this.compare = compare;
            }
            return _this;
        }
        DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
            return x === y;
        };
        DistinctUntilChangedSubscriber.prototype._next = function (value) {
            var key;
            try {
                var keySelector = this.keySelector;
                key = keySelector ? keySelector(value) : value;
            }
            catch (err) {
                return this.destination.error(err);
            }
            var result = false;
            if (this.hasKey) {
                try {
                    var compare = this.compare;
                    result = compare(this.key, key);
                }
                catch (err) {
                    return this.destination.error(err);
                }
            }
            else {
                this.hasKey = true;
            }
            if (!result) {
                this.key = key;
                this.destination.next(value);
            }
        };
        return DistinctUntilChangedSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */
    function throwIfEmpty(errorFactory) {
        if (errorFactory === void 0) {
            errorFactory = defaultErrorFactory;
        }
        return function (source) {
            return source.lift(new ThrowIfEmptyOperator(errorFactory));
        };
    }
    var ThrowIfEmptyOperator = /*@__PURE__*/ (function () {
        function ThrowIfEmptyOperator(errorFactory) {
            this.errorFactory = errorFactory;
        }
        ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
        };
        return ThrowIfEmptyOperator;
    }());
    var ThrowIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ThrowIfEmptySubscriber, _super);
        function ThrowIfEmptySubscriber(destination, errorFactory) {
            var _this = _super.call(this, destination) || this;
            _this.errorFactory = errorFactory;
            _this.hasValue = false;
            return _this;
        }
        ThrowIfEmptySubscriber.prototype._next = function (value) {
            this.hasValue = true;
            this.destination.next(value);
        };
        ThrowIfEmptySubscriber.prototype._complete = function () {
            if (!this.hasValue) {
                var err = void 0;
                try {
                    err = this.errorFactory();
                }
                catch (e) {
                    err = e;
                }
                this.destination.error(err);
            }
            else {
                return this.destination.complete();
            }
        };
        return ThrowIfEmptySubscriber;
    }(Subscriber));
    function defaultErrorFactory() {
        return new EmptyError();
    }

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */
    function take(count) {
        return function (source) {
            if (count === 0) {
                return empty$1();
            }
            else {
                return source.lift(new TakeOperator(count));
            }
        };
    }
    var TakeOperator = /*@__PURE__*/ (function () {
        function TakeOperator(total) {
            this.total = total;
            if (this.total < 0) {
                throw new ArgumentOutOfRangeError;
            }
        }
        TakeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeSubscriber(subscriber, this.total));
        };
        return TakeOperator;
    }());
    var TakeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeSubscriber, _super);
        function TakeSubscriber(destination, total) {
            var _this = _super.call(this, destination) || this;
            _this.total = total;
            _this.count = 0;
            return _this;
        }
        TakeSubscriber.prototype._next = function (value) {
            var total = this.total;
            var count = ++this.count;
            if (count <= total) {
                this.destination.next(value);
                if (count === total) {
                    this.destination.complete();
                    this.unsubscribe();
                }
            }
        };
        return TakeSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */
    function finalize(callback) {
        return function (source) { return source.lift(new FinallyOperator(callback)); };
    }
    var FinallyOperator = /*@__PURE__*/ (function () {
        function FinallyOperator(callback) {
            this.callback = callback;
        }
        FinallyOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new FinallySubscriber(subscriber, this.callback));
        };
        return FinallyOperator;
    }());
    var FinallySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(FinallySubscriber, _super);
        function FinallySubscriber(destination, callback) {
            var _this = _super.call(this, destination) || this;
            _this.add(new Subscription(callback));
            return _this;
        }
        return FinallySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */
    function first(predicate, defaultValue) {
        var hasDefaultValue = arguments.length >= 2;
        return function (source) { return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity, take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError(); })); };
    }

    /** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */
    function multicast(subjectOrSubjectFactory, selector) {
        return function multicastOperatorFunction(source) {
            var subjectFactory;
            if (typeof subjectOrSubjectFactory === 'function') {
                subjectFactory = subjectOrSubjectFactory;
            }
            else {
                subjectFactory = function subjectFactory() {
                    return subjectOrSubjectFactory;
                };
            }
            if (typeof selector === 'function') {
                return source.lift(new MulticastOperator(subjectFactory, selector));
            }
            var connectable = Object.create(source, connectableObservableDescriptor);
            connectable.source = source;
            connectable.subjectFactory = subjectFactory;
            return connectable;
        };
    }
    var MulticastOperator = /*@__PURE__*/ (function () {
        function MulticastOperator(subjectFactory, selector) {
            this.subjectFactory = subjectFactory;
            this.selector = selector;
        }
        MulticastOperator.prototype.call = function (subscriber, source) {
            var selector = this.selector;
            var subject = this.subjectFactory();
            var subscription = selector(subject).subscribe(subscriber);
            subscription.add(source.subscribe(subject));
            return subscription;
        };
        return MulticastOperator;
    }());

    /** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */
    function shareSubjectFactory() {
        return new Subject();
    }
    function share() {
        return function (source) { return refCount()(multicast(shareSubjectFactory)(source)); };
    }

    /** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */
    function shareReplay(configOrBufferSize, windowTime, scheduler) {
        var config;
        if (configOrBufferSize && typeof configOrBufferSize === 'object') {
            config = configOrBufferSize;
        }
        else {
            config = {
                bufferSize: configOrBufferSize,
                windowTime: windowTime,
                refCount: false,
                scheduler: scheduler,
            };
        }
        return function (source) { return source.lift(shareReplayOperator(config)); };
    }
    function shareReplayOperator(_a) {
        var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
        var subject;
        var refCount = 0;
        var subscription;
        var hasError = false;
        var isComplete = false;
        return function shareReplayOperation(source) {
            refCount++;
            var innerSub;
            if (!subject || hasError) {
                hasError = false;
                subject = new ReplaySubject(bufferSize, windowTime, scheduler);
                innerSub = subject.subscribe(this);
                subscription = source.subscribe({
                    next: function (value) {
                        subject.next(value);
                    },
                    error: function (err) {
                        hasError = true;
                        subject.error(err);
                    },
                    complete: function () {
                        isComplete = true;
                        subscription = undefined;
                        subject.complete();
                    },
                });
                if (isComplete) {
                    subscription = undefined;
                }
            }
            else {
                innerSub = subject.subscribe(this);
            }
            this.add(function () {
                refCount--;
                innerSub.unsubscribe();
                innerSub = undefined;
                if (subscription && !isComplete && useRefCount && refCount === 0) {
                    subscription.unsubscribe();
                    subscription = undefined;
                    subject = undefined;
                }
            });
        };
    }

    /** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */
    function startWith() {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler(scheduler)) {
            array.pop();
            return function (source) { return concat(array, source, scheduler); };
        }
        else {
            return function (source) { return concat(array, source); };
        }
    }

    /** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
    function switchMap(project, resultSelector) {
        if (typeof resultSelector === 'function') {
            return function (source) { return source.pipe(switchMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
        }
        return function (source) { return source.lift(new SwitchMapOperator(project)); };
    }
    var SwitchMapOperator = /*@__PURE__*/ (function () {
        function SwitchMapOperator(project) {
            this.project = project;
        }
        SwitchMapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
        };
        return SwitchMapOperator;
    }());
    var SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SwitchMapSubscriber, _super);
        function SwitchMapSubscriber(destination, project) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.index = 0;
            return _this;
        }
        SwitchMapSubscriber.prototype._next = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            }
            catch (error) {
                this.destination.error(error);
                return;
            }
            this._innerSub(result);
        };
        SwitchMapSubscriber.prototype._innerSub = function (result) {
            var innerSubscription = this.innerSubscription;
            if (innerSubscription) {
                innerSubscription.unsubscribe();
            }
            var innerSubscriber = new SimpleInnerSubscriber(this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            this.innerSubscription = innerSubscribe(result, innerSubscriber);
            if (this.innerSubscription !== innerSubscriber) {
                destination.add(this.innerSubscription);
            }
        };
        SwitchMapSubscriber.prototype._complete = function () {
            var innerSubscription = this.innerSubscription;
            if (!innerSubscription || innerSubscription.closed) {
                _super.prototype._complete.call(this);
            }
            this.unsubscribe();
        };
        SwitchMapSubscriber.prototype._unsubscribe = function () {
            this.innerSubscription = undefined;
        };
        SwitchMapSubscriber.prototype.notifyComplete = function () {
            this.innerSubscription = undefined;
            if (this.isStopped) {
                _super.prototype._complete.call(this);
            }
        };
        SwitchMapSubscriber.prototype.notifyNext = function (innerValue) {
            this.destination.next(innerValue);
        };
        return SwitchMapSubscriber;
    }(SimpleOuterSubscriber));

    /** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
    function takeUntil(notifier) {
        return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
    }
    var TakeUntilOperator = /*@__PURE__*/ (function () {
        function TakeUntilOperator(notifier) {
            this.notifier = notifier;
        }
        TakeUntilOperator.prototype.call = function (subscriber, source) {
            var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
            var notifierSubscription = innerSubscribe(this.notifier, new SimpleInnerSubscriber(takeUntilSubscriber));
            if (notifierSubscription && !takeUntilSubscriber.seenValue) {
                takeUntilSubscriber.add(notifierSubscription);
                return source.subscribe(takeUntilSubscriber);
            }
            return takeUntilSubscriber;
        };
        return TakeUntilOperator;
    }());
    var TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeUntilSubscriber, _super);
        function TakeUntilSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.seenValue = false;
            return _this;
        }
        TakeUntilSubscriber.prototype.notifyNext = function () {
            this.seenValue = true;
            this.complete();
        };
        TakeUntilSubscriber.prototype.notifyComplete = function () {
        };
        return TakeUntilSubscriber;
    }(SimpleOuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function takeWhile(predicate, inclusive) {
        if (inclusive === void 0) {
            inclusive = false;
        }
        return function (source) {
            return source.lift(new TakeWhileOperator(predicate, inclusive));
        };
    }
    var TakeWhileOperator = /*@__PURE__*/ (function () {
        function TakeWhileOperator(predicate, inclusive) {
            this.predicate = predicate;
            this.inclusive = inclusive;
        }
        TakeWhileOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
        };
        return TakeWhileOperator;
    }());
    var TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeWhileSubscriber, _super);
        function TakeWhileSubscriber(destination, predicate, inclusive) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.inclusive = inclusive;
            _this.index = 0;
            return _this;
        }
        TakeWhileSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            var result;
            try {
                result = this.predicate(value, this.index++);
            }
            catch (err) {
                destination.error(err);
                return;
            }
            this.nextOrComplete(value, result);
        };
        TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
            var destination = this.destination;
            if (Boolean(predicateResult)) {
                destination.next(value);
            }
            else {
                if (this.inclusive) {
                    destination.next(value);
                }
                destination.complete();
            }
        };
        return TakeWhileSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
    var defaultThrottleConfig = {
        leading: true,
        trailing: false
    };

    /** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */
    function throttleTime(duration, scheduler, config) {
        if (scheduler === void 0) {
            scheduler = async;
        }
        if (config === void 0) {
            config = defaultThrottleConfig;
        }
        return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
    }
    var ThrottleTimeOperator = /*@__PURE__*/ (function () {
        function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
            this.duration = duration;
            this.scheduler = scheduler;
            this.leading = leading;
            this.trailing = trailing;
        }
        ThrottleTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
        };
        return ThrottleTimeOperator;
    }());
    var ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ThrottleTimeSubscriber, _super);
        function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
            var _this = _super.call(this, destination) || this;
            _this.duration = duration;
            _this.scheduler = scheduler;
            _this.leading = leading;
            _this.trailing = trailing;
            _this._hasTrailingValue = false;
            _this._trailingValue = null;
            return _this;
        }
        ThrottleTimeSubscriber.prototype._next = function (value) {
            if (this.throttled) {
                if (this.trailing) {
                    this._trailingValue = value;
                    this._hasTrailingValue = true;
                }
            }
            else {
                this.add(this.throttled = this.scheduler.schedule(dispatchNext$1, this.duration, { subscriber: this }));
                if (this.leading) {
                    this.destination.next(value);
                }
                else if (this.trailing) {
                    this._trailingValue = value;
                    this._hasTrailingValue = true;
                }
            }
        };
        ThrottleTimeSubscriber.prototype._complete = function () {
            if (this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this.destination.complete();
            }
            else {
                this.destination.complete();
            }
        };
        ThrottleTimeSubscriber.prototype.clearThrottle = function () {
            var throttled = this.throttled;
            if (throttled) {
                if (this.trailing && this._hasTrailingValue) {
                    this.destination.next(this._trailingValue);
                    this._trailingValue = null;
                    this._hasTrailingValue = false;
                }
                throttled.unsubscribe();
                this.remove(throttled);
                this.throttled = null;
            }
        };
        return ThrottleTimeSubscriber;
    }(Subscriber));
    function dispatchNext$1(arg) {
        var subscriber = arg.subscriber;
        subscriber.clearThrottle();
    }

    function isDefined(item) {
        return typeof item !== 'undefined' && item !== null;
    }
    function isObject$1(o) {
        return typeof o === 'object' && o != null;
    }
    /** Type guard for filtering out undefined */
    function omitUndefinedElements(item) {
        return item !== null && typeof item !== 'undefined';
    }
    const changesProcessed = new Subject();
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    function isGuid(str) {
        return guidRegex.test(str);
    }
    const absoluteUrlRegex = /^(?:[a-z]+:)?\/\//i;
    function isAbsoluteUrl(url) {
        return absoluteUrlRegex.test(url);
    }
    function appendOrIncrementNumber(name) {
        const lastNumber = name.replace(/\D*(\d*)\s*$/, '$1');
        if (lastNumber === '') {
            return name + ' 2';
        }
        else {
            return name.replace(/\d*\s*$/, (parseInt(lastNumber, 10) + 1).toString());
        }
    }
    /** UUID generation based on:  https://github.com/jchook/uuid-random/blob/master/index.js */
    class UUID {
        static initialize() {
            // Pre-calculate toString(16) for speed
            for (UUID.i = 0; UUID.i < 256; UUID.i++) {
                UUID.hexBytes[UUID.i] = (UUID.i + 0x100).toString(16).substr(1);
            }
        }
        // Buffer some random bytes for speed
        static randomBytesBuffered(n) {
            if (!UUID.buf || UUID.bufIdx + n > UUID.bufferSize) {
                UUID.bufIdx = 0;
                UUID.buf = crypto.getRandomValues(new Uint8Array(UUID.bufferSize));
            }
            return UUID.buf.slice(UUID.bufIdx, (UUID.bufIdx += n));
        }
        // uuid.bin
        static uuidBin() {
            const b = UUID.randomBytesBuffered(16);
            b[6] = (b[6] & 0x0f) | 0x40;
            b[8] = (b[8] & 0x3f) | 0x80;
            return b;
        }
        static generate() {
            const b = UUID.uuidBin();
            return (UUID.hexBytes[b[0]] +
                UUID.hexBytes[b[1]] +
                UUID.hexBytes[b[2]] +
                UUID.hexBytes[b[3]] +
                '-' +
                UUID.hexBytes[b[4]] +
                UUID.hexBytes[b[5]] +
                '-' +
                UUID.hexBytes[b[6]] +
                UUID.hexBytes[b[7]] +
                '-' +
                UUID.hexBytes[b[8]] +
                UUID.hexBytes[b[9]] +
                '-' +
                UUID.hexBytes[b[10]] +
                UUID.hexBytes[b[11]] +
                UUID.hexBytes[b[12]] +
                UUID.hexBytes[b[13]] +
                UUID.hexBytes[b[14]] +
                UUID.hexBytes[b[15]]);
        }
    }
    UUID.bufIdx = 0;
    UUID.hexBytes = new Array();
    UUID.bufferSize = 4096;
    UUID.initialize();

    class SceneHistory {
        constructor() {
            this.active = false;
            this.changes = [];
            this.undoneChanges = [];
            this.ignoreChangesFromObjects = new Set();
            this.state = new BehaviorSubject([]);
            this.undoneState = new BehaviorSubject([]);
        }
        updateState() {
            return this.state.next(this.getMergedChanges(this.changes));
        }
        updateUndoneState() {
            return this.undoneState.next(this.getMergedChanges(this.undoneChanges));
        }
        getMergedChanges(changes) {
            return changes.map((c, index) => {
                const changePart = Array.from(c.change.values());
                return {
                    description: c.description,
                    index,
                    nodes: changePart.map(node => node.node),
                    // Return a set of properties to drop duplicate array elements
                    properties: new Set(changePart.flatMap(node => node.properties.flatMap(property => property.name))).values(),
                };
            });
        }
        ignoreUntilStable(object) {
            if (this.ignoreChangesFromObjects.size === 0) {
                changesProcessed.pipe(take(1)).subscribe(() => {
                    this.ignoreChangesFromObjects.clear();
                });
            }
            this.ignoreChangesFromObjects.add(object);
        }
        start() {
            this.active = true;
        }
        stop() {
            this.active = false;
        }
        /**
         * Adds a change to the history. If you added an open-ended change
         * @param description
         * @param processFunction
         * @param undoFunction
         */
        addChange(description, processFunction, undoFunction) {
            // if (this.openChange) {
            //     console.warn(
            //         'Starting a new history change with a previous change still open. You may get a strange history state.',
            //         `Change still open: ${this.openChange.description}`,
            //         `New change: ${description}`
            //     );
            // }
            let newChange;
            if (!this.openChange) {
                newChange = this.openChange = {
                    change: new Map(),
                    description,
                    undoFunction,
                };
            }
            processFunction(false);
            const done = (description) => {
                if (this.openChange) {
                    if (this.openChange.change.size > 0 || this.openChange.undoFunction !== undefined) {
                        if (description) {
                            this.openChange.description = description;
                        }
                        this.changes.push(this.openChange);
                    }
                    delete this.openChange;
                    this.updateState();
                    if (this.undoneChanges.length > 0) {
                        this.undoneChanges.clear();
                        this.updateUndoneState();
                    }
                }
            };
            if (undoFunction) {
                this.openChange.redoFunction = () => processFunction(true);
                done();
            }
            else if (newChange) {
                changesProcessed.pipe(take(1)).subscribe(done);
            }
        }
        undo() {
            if (this.openChange) {
                throw Error("Can't undo while there are open changes");
            }
            if (this.changes.length < 1) {
                return;
            }
            const lastChangeSet = this.changes.pop();
            if (lastChangeSet) {
                this.undoneChanges.push(lastChangeSet);
                if (lastChangeSet.undoFunction) {
                    lastChangeSet.undoFunction();
                }
                else {
                    this.processChangeSet(lastChangeSet, change => {
                        // Undo changes in reverse so they are consistent with how they were added.
                        change.properties
                            .slice()
                            .reverse()
                            .forEach(property => {
                            const restore = property.previousValue;
                            switch (property.operation) {
                                case exports.EChangeOperation.CreateAndPush:
                                    change.node.pop(true);
                                    break;
                                case exports.EChangeOperation.Push:
                                    change.node.pop();
                                    break;
                                case exports.EChangeOperation.Unshift:
                                    change.node.shift();
                                    break;
                                case exports.EChangeOperation.Shift:
                                    change.node.unshift(property.previousValue);
                                    if (isTrackedClass(restore)) {
                                        restore.isModified = true;
                                    }
                                    break;
                                case exports.EChangeOperation.Pop:
                                    change.node.push(property.previousValue);
                                    if (isTrackedClass(restore)) {
                                        restore.isModified = true;
                                    }
                                    break;
                                case exports.EChangeOperation.Remove:
                                case exports.EChangeOperation.Splice:
                                    // Property name is the index of the splice
                                    // Remove all the added values, add back in the old ones
                                    change.node.splice(property.name, property.newValue.length, ...restore);
                                    if (Array.isArray(restore) && restore.length > 0) {
                                        restore.forEach(restoreItem => {
                                            if (isTrackedClass(restoreItem)) {
                                                restoreItem.isModified = true;
                                            }
                                        });
                                    }
                                    break;
                                default:
                                    change.node[property.name] = property.previousValue;
                            }
                        });
                    });
                }
                this.updateState();
                this.updateUndoneState();
            }
        }
        redo() {
            if (this.openChange) {
                throw Error("Can't redo while there are open changes");
            }
            if (this.undoneChanges.length < 1) {
                return;
            }
            const lastUndoneChangeSet = this.undoneChanges.pop();
            if (lastUndoneChangeSet) {
                this.changes.push(lastUndoneChangeSet);
                if (lastUndoneChangeSet.redoFunction) {
                    lastUndoneChangeSet.redoFunction();
                }
                else {
                    this.processChangeSet(lastUndoneChangeSet, change => {
                        // Redo changes in the initial order
                        change.properties.forEach(property => {
                            const restore = property.newValue;
                            switch (property.operation) {
                                case exports.EChangeOperation.CreateAndPush:
                                    change.node.createAndPush(property.newValue);
                                    if (isTrackedClass(restore)) {
                                        restore.isModified = true;
                                    }
                                    break;
                                case exports.EChangeOperation.Push:
                                    change.node.push(property.newValue);
                                    break;
                                case exports.EChangeOperation.Unshift:
                                    change.node.unshift(property.newValue);
                                    if (isTrackedClass(restore)) {
                                        restore.isModified = true;
                                    }
                                    break;
                                case exports.EChangeOperation.Shift:
                                    change.node.shift();
                                    break;
                                case exports.EChangeOperation.Pop:
                                    change.node.pop();
                                    break;
                                case exports.EChangeOperation.Remove:
                                    property.previousValue.length === 1 && change.node.remove(property.previousValue[0]);
                                    break;
                                case exports.EChangeOperation.Splice:
                                    change.node.splice(property.name, property.previousValue.length, ...restore);
                                    if (Array.isArray(restore) && restore.length > 0) {
                                        restore.forEach(restoreItem => {
                                            if (isTrackedClass(restoreItem)) {
                                                restoreItem.isModified = true;
                                            }
                                        });
                                    }
                                    break;
                                default:
                                    change.node[property.name] = property.newValue;
                            }
                        });
                    });
                }
                this.updateState();
                this.updateUndoneState();
            }
        }
        undoTo(index) {
            while (this.changes.length > index + 1) {
                this.undo();
            }
        }
        redoTo(index) {
            while (this.undoneChanges.length > index) {
                this.redo();
            }
        }
        // startGroupingAllChanges() {
        //     this.groupAllIncomingChanges = true;
        //     this.changes.push(new Map());
        // }
        // stopGroupingAllChanges() {
        //     this.groupAllIncomingChanges = false;
        //     this.removeLastChangeIfEmpty();
        //     this.updateState();
        // }
        // startGroupingObjectsChanges(objects: Array<Object>) {
        //     this.groupChangesInObjects = new Set(objects.filter<TrackedObject>(isTrackedClass));
        //     this.changes.push(new Map());
        // }
        // stopGroupingObjectsChanges() {
        //     this.groupChangesInObjects = undefined;
        //     this.removeLastChangeIfEmpty();
        // }
        changeEvent(object, property, value, originalValue, operation) {
            if (this.active &&
                (isTrackedClass(object) || Array.isArray(object)) &&
                value !== originalValue &&
                !this.ignoreChangesFromObjects.has(object)) {
                if (!this.openChange) {
                    return;
                }
                const openChange = this.openChange;
                let lastChangeOnObject = openChange.change.get(object);
                if (!lastChangeOnObject) {
                    lastChangeOnObject = { node: object, properties: [] };
                    openChange.change.set(object, lastChangeOnObject);
                }
                const lastChangeOnObjectProperty = lastChangeOnObject.properties.find(openChange => openChange.name === property);
                if (!lastChangeOnObjectProperty) {
                    lastChangeOnObject.properties.push({
                        name: property,
                        previousValue: originalValue,
                        newValue: value,
                        operation,
                    });
                }
                else {
                    lastChangeOnObjectProperty.newValue = value;
                }
            }
        }
        changeEvents(object, changes) {
            if (this.active &&
                (isTrackedClass(object) || Array.isArray(object)) &&
                !this.ignoreChangesFromObjects.has(object)) {
                changes.forEach(change => {
                    this.changeEvent(object, change.property, change.value, change.originalValue, change.operation);
                });
            }
        }
        removeLastChange(object, property) {
            // todo
        }
        processChangeSet(changeSet, process) {
            changeSet.change.forEach(change => process(change));
        }
    }
    const history = new SceneHistory();

    function nextTick() {
        changesProcessed.next();
    }
    const __arrayProtoFunctions = {};
    ['push', 'unshift', 'shift', 'pop', 'splice', 'reorder', 'clear'].forEach((arrayFunc) => {
        __arrayProtoFunctions[arrayFunc] = Array.prototype[arrayFunc];
        // We shouldn't need this code after the Vue update to 3.2. Was needed to fix reactivity on arrays for Vue
        // Delete this when no confirmed that there are no issues with reactivity in creator
        // Array.prototype[arrayFunc] = function(...args: any) {
        //     if(isTrackedArray(this)) {
        //         return TrackedArray.prototype[arrayFunc].apply(this, args);
        //     } else {
        //         return __arrayProtoFunctions[arrayFunc].apply(this, args);
        //     }
        // }
    });
    class TrackedArray extends Array {
        constructor(parentObj, propertyName, changesIgnored, historyIgnored, source) {
            super();
            this.parentObj = parentObj;
            this.propertyName = propertyName;
            this.changesIgnored = changesIgnored;
            this.historyIgnored = historyIgnored;
            this.$isTracked = true;
            if (source) {
                for (let i = 0; i < source.length; i++) {
                    __arrayProtoFunctions.push.call(this, source[i]);
                }
            }
        }
        push(...items) {
            if (!this.changesIgnored) {
                this.parentObj.setPropertyIsModified(this.propertyName, true);
                if (!this.historyIgnored) {
                    history.changeEvents(this, items.map(item => ({
                        property: this.length,
                        operation: exports.EChangeOperation.Push,
                        value: item,
                        originalValue: undefined,
                    })));
                }
            }
            const res = __arrayProtoFunctions.push.apply(this, items); // super.push(...items);
            for (const item of items) {
                this.parentObj.addedToChildArray(this.parentObj, item, this.propertyName);
            }
            return res;
        }
        unshift(...items) {
            if (!this.changesIgnored) {
                this.parentObj.setPropertyIsModified(this.propertyName, true);
                if (!this.historyIgnored) {
                    history.changeEvents(this, items.map(item => ({
                        property: 0,
                        operation: exports.EChangeOperation.Push,
                        value: item,
                        originalValue: undefined,
                    })));
                }
            }
            const res = __arrayProtoFunctions.unshift.apply(this, items); // super.unshift(...items);
            for (const item of items) {
                this.parentObj.addedToChildArray(this.parentObj, item, this.propertyName);
            }
            return res;
        }
        shift(destroy) {
            const result = __arrayProtoFunctions.shift.apply(this); // super.shift();
            if (!this.changesIgnored) {
                this.parentObj.setPropertyIsModified(this.propertyName, true);
                if (!this.historyIgnored) {
                    history.changeEvent(this, 0, undefined, result, exports.EChangeOperation.Shift);
                }
            }
            if (destroy && isTrackedClass(result)) {
                result.destroy();
            }
            this.parentObj.addedToChildArray(this.parentObj, result, this.propertyName);
            return result;
        }
        pop(destroy) {
            const result = __arrayProtoFunctions.pop.apply(this); // super.pop();
            if (!this.changesIgnored) {
                this.parentObj.setPropertyIsModified(this.propertyName, true);
                if (!this.historyIgnored) {
                    history.changeEvent(this, this.length, undefined, result, exports.EChangeOperation.Pop);
                }
            }
            if (destroy && isTrackedClass(result)) {
                result.destroy();
            }
            this.parentObj.addedToChildArray(this.parentObj, result, this.propertyName);
            return result;
        }
        splice(start, deleteCount, ...insert) {
            // const result = Array.prototype.splice.call(array, start, deleteCount || 0, ...insert);
            let result;
            if (insert.length === 0) {
                result = __arrayProtoFunctions.splice.apply(this, [start, deleteCount]); // super.splice(start, deleteCount);
            }
            else {
                result = __arrayProtoFunctions.splice.apply(this, [start, deleteCount || 0, ...insert]); // super.splice(start, deleteCount || 0, ...insert);
            }
            result.forEach(resultItem => {
                if (isTrackedClass(resultItem)) {
                    resultItem.destroy();
                }
            });
            for (const item of result) {
                this.parentObj.removedFromChildArray(this.parentObj, item, this.propertyName);
            }
            for (const item of insert) {
                this.parentObj.addedToChildArray(this.parentObj, item, this.propertyName);
            }
            if (!this.changesIgnored) {
                this.parentObj.setPropertyIsModified(this.propertyName, true);
                if (!this.historyIgnored) {
                    history.changeEvent(this, start, insert, result, exports.EChangeOperation.Splice);
                }
            }
            return result;
        }
        remove(item) {
            const index = this.indexOf(item);
            if (index > -1) {
                return this.splice(index, 1);
            }
            return [];
        }
        reorder(fromIndex, toIndex, undo) {
            __arrayProtoFunctions.reorder.apply(this, [fromIndex, toIndex, undo]);
            if (!this.changesIgnored) {
                this.parentObj.setPropertyIsModified(this.propertyName, true);
            }
        }
    }
    /** Decorator to track the properties of a class. Used in conjunction with the change tracker class.
     * Properties with this decorator will be watched by the change tracker
     * @param {Object}   options          decorator options object
     * @param {Function} options.onCreate function that is called when a new class instance is created. Called with the proxy object that was created.
     */
    function TrackChanges(options) {
        const onCreateCallback = options ? options.onCreate : undefined;
        const isPropertyEqualOverride = options ? options.isPropertyEqual : undefined;
        const onDestroy = options ? options.onDestroy : undefined;
        const addedToChildArray = options ? options.addedToChildArray : undefined;
        const removedFromChildArray = options ? options.removedFromChildArray : undefined;
        return (targetClass) => {
            const TrackedClass = class extends targetClass {
                get $changesTracked() {
                    return true;
                }
                setPropertyIsModified() { }
                destroy() { }
                constructor(...args) {
                    super(...args);
                    const trackingState = {
                        baseObject: this,
                        isModified: false,
                    };
                    if (typeof this.originalValues === 'undefined') {
                        Object.defineProperties(this, {
                            changes: {
                                value: new Map(),
                                enumerable: false,
                                writable: false,
                                configurable: false,
                            },
                            originalValues: {
                                value: new Map(),
                                enumerable: false,
                                writable: false,
                                configurable: false,
                            },
                            _trackChanges: {
                                value: false,
                                enumerable: false,
                                writable: true,
                                configurable: false,
                            },
                            isModified: {
                                configurable: false,
                                enumerable: false,
                                set: () => { },
                                get: () => trackingState.isModified,
                            },
                            commitChanges: {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: (inherited = false) => commitChanges(this, inherited),
                            },
                            setPropertyIsModified: {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: setPropertyIsModified,
                            },
                            destroy: {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: () => destroy(this),
                            },
                            trackChanges: {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: (active) => (this._trackChanges = active),
                            },
                            rawNode: {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: trackingState.baseObject,
                            },
                        });
                    }
                    const changedValuesMap = this.changes;
                    const originalValuesMap = this.originalValues;
                    const proxy = new Proxy(this, {
                        // get: (target, property) => {
                        //     if (property === 'isModified') {
                        //         return trackingState.isModified;
                        //     } else if (property === 'commitChanges') {
                        //         return (inherited: boolean = false) => commitChanges(target, inherited);
                        //     } else if (property === 'setPropertyIsModified') {
                        //         return setPropertyIsModified;
                        //     } else if (property === 'addedToChildArray') {
                        //         return addedToChildArray ? addedToChildArray : () => { }
                        //     } else if (property === 'removedFromChildArray') {
                        //         return removedFromChildArray ? removedFromChildArray : () => { }
                        //     } else if (property === 'destroy') {
                        //         return () => destroy(target);
                        //     } else if (property === 'trackChanges') {
                        //         return (active: boolean) => this._trackChanges = active;
                        //     } else if (property === 'rawNode') {
                        //         return trackingState.baseObject;
                        //     }
                        //     return target[property as string];
                        // },
                        set: (target, property, newValue) => {
                            // Allow clearing changes by setting is modified to false.
                            if (property === 'isModified') {
                                if (newValue === false && newValue !== trackingState.isModified) {
                                    originalValuesMap.clear();
                                    changedValuesMap.clear();
                                    updateIsModified();
                                }
                                else if (newValue === true) {
                                    for (const key in target) {
                                        setPropertyIsModified(key, true);
                                    }
                                }
                                return true;
                                // Throw type error on trying to redefine decorator functions
                            }
                            else if (property === 'setPropertyIsModified') {
                                return false;
                            }
                            else {
                                // If object is not being tracked, just set the value without tracking the changes
                                if (!this._trackChanges) {
                                    return Reflect.set(trackingState.baseObject, property, newValue);
                                }
                                const changesIgnored = Reflect.has(target, '_changesIgnoredProperties') &&
                                    Reflect.get(target, '_changesIgnoredProperties').has(property);
                                const historyIgnored = Reflect.has(target, '_historyIgnoredProperties') &&
                                    Reflect.get(target, '_historyIgnoredProperties').has(property);
                                // If the value is an array, then we have to proxy the array to pick up new array elements
                                // Important that this occurs even if the object is not being tracked because
                                // parent node management will break without the array proxy
                                if (Array.isArray(newValue)) {
                                    newValue = new TrackedArray(proxy, property.toString(), changesIgnored, historyIgnored, newValue);
                                }
                                if (!changesIgnored) {
                                    const originalValue = originalValuesMap.get(property.toString());
                                    const currentValue = Reflect.get(target, property);
                                    // If the new value is the same as previous, do nothing.
                                    if (isPropertyEqualOverride &&
                                        isPropertyEqualOverride(currentValue, newValue, property)) {
                                        return true;
                                    }
                                    else if (currentValue === newValue) {
                                        return true;
                                    }
                                    // Skip checks if originalValue is null. It means isModified is forced to be true until node is processed.
                                    if (originalValue !== null) {
                                        if (!originalValue) {
                                            // If the value is changed and was never changed before, register the change
                                            originalValuesMap.set(property.toString(), currentValue);
                                        }
                                        else {
                                            let isPropertyModified;
                                            // If the value was changed before, see if it's the same as the original value.
                                            let isEqualToOriginal;
                                            if (isPropertyEqualOverride) {
                                                isEqualToOriginal = isPropertyEqualOverride(originalValue, newValue, property);
                                            }
                                            if (typeof isEqualToOriginal !== 'undefined') {
                                                isPropertyModified = !isEqualToOriginal;
                                            }
                                            else {
                                                isPropertyModified = originalValue !== newValue;
                                            }
                                            // If the value is the same as the original, de-register the change
                                            if (!isPropertyModified) {
                                                originalValuesMap.delete(property.toString());
                                            }
                                        }
                                        updateIsModified();
                                    }
                                }
                                if (originalValuesMap.has(property.toString())) {
                                    changedValuesMap.set(property.toString(), newValue);
                                }
                                else {
                                    changedValuesMap.delete(property.toString());
                                }
                                return Reflect.set(trackingState.baseObject, property, newValue);
                            }
                        },
                    });
                    // Don't register changes in the history when creating new objects as they have to be registered as new objects instead.
                    history.ignoreUntilStable(proxy);
                    // The sync service won't have the right proxy object when a new object is created
                    SyncService.registerNewObject(proxy);
                    // The properties set on the object in the constructor won't be tracked because the original constructor runs before
                    // the object is proxied.
                    let trackedNewProperty = false;
                    for (const property in this) {
                        if (!this._changesIgnoredProperties || !this._changesIgnoredProperties.has(property)) {
                            if (Array.isArray(this[property])) {
                                const arrayHistoryIgnored = this._historyIgnoredProperties && this._historyIgnoredProperties.has(property);
                                // We've already filtered out change ignored properties above
                                this[property] = new TrackedArray(proxy, property.toString(), false, arrayHistoryIgnored, this[property]);
                            }
                            originalValuesMap.set(property, this[property]);
                            changedValuesMap.set(property, this[property]);
                            trackedNewProperty = true;
                        }
                    }
                    if (trackedNewProperty) {
                        updateIsModified();
                    }
                    if (onCreateCallback) {
                        onCreateCallback(proxy);
                    }
                    return proxy;
                    function updateIsModified() {
                        // If the original value map is not empty, we have some pending changes so this object is considered modified
                        if (trackingState.isModified !== originalValuesMap.size > 0) {
                            trackingState.isModified = originalValuesMap.size > 0;
                            SyncService.registerChangedState(proxy, trackingState.isModified);
                        }
                    }
                    function commitChanges(target, inherited) {
                        if (trackingState.isModified) {
                            if (!inherited) {
                                // Register the change on the history
                                originalValuesMap.forEach((oldValue, property) => {
                                    const historyIgnored = Reflect.has(target, '_historyIgnoredProperties') &&
                                        Reflect.get(target, '_historyIgnoredProperties').has(property);
                                    if (!historyIgnored) {
                                        history.changeEvent(proxy, property, trackingState.baseObject[property], oldValue);
                                    }
                                });
                                originalValuesMap.clear();
                                changedValuesMap.clear();
                            }
                            updateIsModified();
                        }
                        SyncService.nodeChangesProcessed(target);
                    }
                    function setPropertyIsModified(prop, modified) {
                        if (modified) {
                            // When forcing a property as modified, set the original value to null so it stays modified until processed (never matches)
                            originalValuesMap.set(prop, null);
                            changedValuesMap.set(prop, proxy[prop]);
                        }
                        else {
                            originalValuesMap.delete(prop);
                            changedValuesMap.delete(prop);
                        }
                        updateIsModified();
                    }
                    function destroy(target) {
                        if (onDestroy) {
                            onDestroy(proxy);
                        }
                        SyncService.registerDeleted(proxy);
                        const inheritedDestroyFunc = Object.getPrototypeOf(target).destroy;
                        if (typeof inheritedDestroyFunc === 'function') {
                            inheritedDestroyFunc();
                        }
                    }
                }
            };
            Object.defineProperties(TrackedClass.prototype, {
                addedToChildArray: {
                    configurable: false,
                    enumerable: false,
                    writable: false,
                    value: addedToChildArray ? addedToChildArray : () => { },
                },
                removedFromChildArray: {
                    configurable: false,
                    enumerable: false,
                    writable: false,
                    value: removedFromChildArray ? removedFromChildArray : () => { },
                },
            });
            return TrackedClass;
        };
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    function NodeReference(classRef, ...keys) {
        return (target, propertyKey, parameterIndex) => {
            if (typeof target.nodeReferences === 'undefined') {
                Object.defineProperty(target, 'nodeReferences', {
                    value: new Map(),
                    enumerable: false,
                    writable: false,
                    configurable: false,
                });
            }
            target.nodeReferences.set(propertyKey, {
                classRef,
                limitKeys: keys.length > 0 ? new Set(keys) : undefined,
            });
        };
    }
    /** Property decorator to ignore changes on some properties. The node will not be processed if only ignored properties change. */
    function IgnoreChanges(target, propertyKey, parameterIndex) {
        if (typeof target._changesIgnoredProperties === 'undefined') {
            Object.defineProperty(target, '_changesIgnoredProperties', {
                value: new Map(),
                enumerable: false,
                writable: false,
                configurable: false,
            });
        }
        target._changesIgnoredProperties.set(propertyKey, true);
    }
    /** Property decorator to ignore history on some properties. The property changing will not trigger history additions. */
    function IgnoreHistory(target, propertyKey, parameterIndex) {
        if (typeof target._historyIgnoredProperties === 'undefined') {
            Object.defineProperty(target, '_historyIgnoredProperties', {
                value: new Map(),
                enumerable: false,
                writable: false,
                configurable: false,
            });
        }
        target._historyIgnoredProperties.set(propertyKey, true);
    }

    function isKbVector(object) {
        return object && object.x !== undefined && object.y !== undefined && object.z !== undefined;
    }
    function isKbColor(object) {
        return (object && object.r !== undefined && object.g !== undefined && object.b !== undefined && object.a !== undefined);
    }
    function isKbQuaternion(object) {
        return (object && object.x !== undefined && object.y !== undefined && object.z !== undefined && object.w !== undefined);
    }
    function isPrimitive(object) {
        return isKbVector(object) || isKbColor(object) || isKbQuaternion(object);
    }

    /** Convenience decorator that sets up default options for Kb3dObjects with the change tracker */
    function TrackChangesNode(options = {}) {
        const origAddedToChildArray = options.addedToChildArray;
        options.addedToChildArray = (parent, item, arrayPropName) => {
            if (origAddedToChildArray)
                origAddedToChildArray(parent, item, arrayPropName);
            if (instanceOf(parent, Token.Kb3dObject) && instanceOf(item, Token.Kb3dObject)) {
                item._parent = parent;
                if (isTrackedClass(parent) && parent._trackChanges) {
                    item.calculateParents();
                }
            }
        };
        const origDestroy = options.onDestroy;
        options.onDestroy = (item) => {
            if (origDestroy)
                origDestroy(item);
            const children = item.getChildren();
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (isTrackedClass(child)) {
                    child.destroy();
                }
            }
            if (item._parent && instanceOf(item._parent, Token.Kb3dObject) && instanceOf(item, Token.Kb3dObject)) {
                if (item._parent._manager) {
                    item._parent._manager.unregister(item);
                }
            }
            item._parent = undefined;
            item.isModified = false;
        };
        if (!options.isPropertyEqual) {
            options.isPropertyEqual = (oldValue, newValue, propertyKey) => {
                let result;
                // Check equality on node properties by handling arrays and KB primitives. Fall back to strict equality checks for other values.
                if (Array.isArray(oldValue) && Array.isArray(newValue)) {
                    if (oldValue.length === newValue.length) {
                        let isEqual = true;
                        for (let i = 0; i < newValue.length; i++) {
                            if (newValue[i] !== oldValue[i]) {
                                isEqual = false;
                                break;
                            }
                        }
                        result = isEqual;
                    }
                    else {
                        result = false;
                    }
                }
                else if (isPrimitive(newValue)) {
                    result = typeof oldValue !== 'undefined' && newValue.equal(oldValue);
                }
                // console.log('checking equality', oldValue, newValue, result);
                return result;
            };
        }
        return TrackChanges(options);
    }

    function Kb3dModel(options) {
        if (!('trackChanges' in options))
            options.trackChanges = true; //if trackChanges was not provided, default to true
        const $type = options.token.key;
        return (constructor) => {
            //set the $type on the prototype so we can always retrieve it from an instance
            Object.defineProperty(constructor.prototype, '$type', {
                enumerable: false,
                writable: true,
                value: $type,
            });
            /** we bundle up the track changes decorator here as well, as we want our map storing the constructors of
             * our models to actually be storing the constructor of the track changes proxy... so that when a class
             * is constructed using "create" that it will actually create the proxy class.
             */
            if (options.trackChanges) {
                const trackChangesFactory = TrackChangesNode(options);
                const combinedConstructor = trackChangesFactory(constructor);
                options.classConstructor = combinedConstructor;
            }
            else {
                options.classConstructor = constructor;
            }
            Kb3dModels.set(options.token, options);
        };
    }
    function BaseKb3dModel(options) {
        return (constructor) => {
            options.classConstructor = constructor;
            Kb3dModels.set(options.token, options);
        };
    }

    /**
     * Applied to a getter or setter property, will make it enumerable
     */
    function Enumerable() {
        return function (target, propertyKey, descriptor) {
            descriptor.enumerable = true;
        };
    }

    const injectParameters = [];
    function Inject(token) {
        return (target, propertyKey, parameterIndex) => {
            injectParameters.push({
                token: token,
                classConstructor: target,
                parameterIndex,
                ignore: false,
            });
        };
    }
    function Ignore() {
        return (target, propertyKey, parameterIndex) => {
            injectParameters.push({
                token: Token.Ignore,
                classConstructor: target,
                parameterIndex,
                ignore: true,
            });
        };
    }
    function getConstructorParamsForModel(modelDef) {
        let constructor;
        if (modelDef.trackChanges) {
            constructor = Object.getPrototypeOf(modelDef.classConstructor);
        }
        else {
            constructor = modelDef.classConstructor;
        }
        const paramsForType = injectParameters.filter(i => i.classConstructor == constructor);
        paramsForType.sortBy(p => p.index);
        if (modelDef.classConstructor && paramsForType.length < modelDef.classConstructor.length) {
            throw new Error('You must decorate every constructor parameter with an @Inject or @Ignore decorator for type ' +
                modelDef.token.key);
        }
        return paramsForType;
    }

    function Kb3dService(options) {
        const $type = options.token.key;
        return (constructor) => {
            constructor.prototype.$type = $type;
            options.classConstructor = constructor;
            Kb3dModels.set(options.token, options);
        };
    }

    (function (eParentChangeBehavior) {
        eParentChangeBehavior[eParentChangeBehavior["PRESERVE_POSITION"] = 0] = "PRESERVE_POSITION";
        eParentChangeBehavior[eParentChangeBehavior["PRESERVE_PROPERTY"] = 1] = "PRESERVE_PROPERTY";
    })(exports.eParentChangeBehavior || (exports.eParentChangeBehavior = {}));

    (function (eNodeError) {
        eNodeError[eNodeError["FEATURE_REFERENCE"] = 0] = "FEATURE_REFERENCE";
        eNodeError[eNodeError["GEOMETRY_SAVE"] = 1] = "GEOMETRY_SAVE";
    })(exports.eNodeError || (exports.eNodeError = {}));
    /**
     * Base class for kb3d models.  Any model that has an id and $type should derive from this class
     */
    exports.Kb3dObject = class Kb3dObject {
        constructor() {
            this._level = -1;
            this._errors = [];
            this._selected = false;
            this._expanded = false;
            this.id = UUID.generate();
            this._dynamicId = UUID.generate();
        }
        get _token() {
            return Token.withKey(this.$type);
        }
        get _rootScene() {
            return this.__rootScene;
        }
        setRootScene(scene) {
            if (this.__rootScene !== scene) {
                this.__rootScene = scene;
                if (isTrackedClass(this)) {
                    this.trackChanges(!!scene);
                }
            }
        }
        get metadata() {
            if (!this._metadata)
                this._metadata = {};
            return this._metadata;
        }
        set metadata(val) {
            this._metadata = val;
        }
        clone() {
            if (this._manager) {
                return this._manager.clone(this);
            }
        }
        serialize() {
            if (this._manager) {
                return this._manager.serialize(this);
            }
        }
        serializeToJson(prettyPrint = false) {
            if (this._manager) {
                return this._manager.serializeToJson(this, { prettyPrint });
            }
            return '';
        }
        calculateParents(deletion = false, parent) {
            var _a, _b;
            // When a node is deleted and recreated, the children won't have parents because they were not re-added to the parent's arrays.
            // This solves that case by making sure the hierarchy is consistent from the top down
            if (parent && this._parent !== parent) {
                this._parent = parent;
            }
            if (this._parent) {
                this._level = this._parent._level == -1 ? -1 : this._parent._level + 1;
                this._parentScene = this._parent._parentScene;
                this.setRootScene(this._parent._rootScene);
                if (instanceOf(this, Token.SceneNode)) {
                    //it's a nested scene
                    this._parentScene = this;
                }
                else {
                    this._manager = this._parent._manager; // a nested scene uses it's own manager, but everything else should have the same as it's parent
                }
                if (this._parentScene && !deletion) {
                    (_a = this._manager) === null || _a === void 0 ? void 0 : _a.register(this);
                }
            }
            else if (instanceOf(this, Token.SceneNode) && !deletion) {
                this._level = 0;
                this._parentScene = this;
                this.setRootScene(this);
                (_b = this._manager) === null || _b === void 0 ? void 0 : _b.register(this);
            }
            else {
                this._level = -1; // -1 means this is not part of a scene node hierarchy
                // TODO add this change after release on Jan 13 2023, test to ensure it works
                // if(isTrackedClass(this)) {
                //     this.trackChanges(false);
                // }
            }
            for (const c of this.getChildren()) {
                c.calculateParents(deletion, this);
            }
        }
        /**
         * Derived classes that have children should override this
         */
        getChildren() {
            return [];
        }
        /**
         * Derived classes with children should override this
         */
        getChildArrayForType(token) {
            return undefined;
        }
        getChildArray(child) {
            return this.getChildArrayForType(Token.withKey(child.$type));
        }
        addChildren(...children) {
            var _a;
            for (const c of children) {
                (_a = this.getChildArray(c)) === null || _a === void 0 ? void 0 : _a.push(c);
            }
        }
        removeChildren(...children) {
            var _a;
            for (const c of children) {
                (_a = this.getChildArray(c)) === null || _a === void 0 ? void 0 : _a.remove(c);
            }
        }
        insertChildAfter(afterChild, newChild) {
            const arr1 = this.getChildArray(afterChild);
            const arr2 = this.getChildArray(newChild);
            if (!arr1 || !arr2)
                throw 'incompatible child';
            if (arr1 !== arr2)
                throw 'children mismatch';
            const index = arr1.indexOf(afterChild);
            if (index === -1)
                throw 'could not find given child';
            arr1.splice(index + 1, 0, newChild);
        }
        getAncestors() {
            const ancestors = new Array();
            let parent = this._parent;
            while (parent != null) {
                ancestors.push(parent);
                parent = parent._parent;
            }
            return ancestors;
        }
        getNamePath() {
            let path = '';
            let self = this;
            while (self && !instanceOf(self, Token.SceneNode)) {
                path = self.name + (path ? '/' + path : '');
                self = self._parent;
            }
            return path;
        }
        /**
         * Filters children recursively based on a condition.  This is an O(n) operation, so only use when performance is not paramount
         * @param predicate expression to test whether the object should be included
         * @param includeSelf whether to include this kb3dObject in the search
         * @param alwaysIncludeChildren if true, will always search children even if the parent resolves to false
         */
        filter(predicate, includeSelf = false, alwaysIncludeChildren = true) {
            const res = [];
            let included = true;
            if (includeSelf && predicate(this)) {
                res.push(this);
            }
            else {
                included = false;
            }
            if (included || alwaysIncludeChildren) {
                const children = this.getChildren();
                for (const child of children) {
                    res.push(...child.filter(predicate, true, alwaysIncludeChildren));
                }
            }
            return res;
        }
        /**
         * filters children by type given a list of type tokens
         * @param tokens
         */
        filterByType(...tokens) {
            return this.filter(node => instanceOfAny(node, ...tokens));
        }
        /**
         * filters children, but only those that qualify as nodes
         * @param predicate
         * @param includeSelf
         * @param alwaysIncludeChildren
         */
        filterNodes(predicate, includeSelf = false, alwaysIncludeChildren = true) {
            const nodePredicate = (node) => node.isNode() && predicate(node);
            return this.filter(nodePredicate, includeSelf, alwaysIncludeChildren);
        }
        isNode() {
            return this._token.isNode();
        }
    };
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "name", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "$type", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "_manager", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "_parentScene", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "__rootScene", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "_level", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "_errors", void 0);
    __decorate([
        IgnoreChanges
    ], exports.Kb3dObject.prototype, "_expanded", void 0);
    __decorate([
        Enumerable()
    ], exports.Kb3dObject.prototype, "metadata", null);
    exports.Kb3dObject = __decorate([
        BaseKb3dModel({
            token: Token.Kb3dObject,
        })
    ], exports.Kb3dObject);

    exports.BaseConnector = class BaseConnector extends exports.Kb3dObject {
        constructor() {
            super(...arguments);
            this._sketchControlPoints = [];
        }
        /** Extended by child classes to return the space node parent of this connector */
        getSpaceParent() {
            return undefined;
        }
    };
    exports.BaseConnector = __decorate([
        BaseKb3dModel({
            token: Token.BaseConnector,
        })
    ], exports.BaseConnector);

    var Feature_1;
    (function (eMeshChangeTypes) {
        eMeshChangeTypes[eMeshChangeTypes["VertexIndices"] = 0] = "VertexIndices";
        eMeshChangeTypes[eMeshChangeTypes["VertexPositions"] = 1] = "VertexPositions";
        eMeshChangeTypes[eMeshChangeTypes["VertexNormals"] = 2] = "VertexNormals";
        eMeshChangeTypes[eMeshChangeTypes["VertexUvs"] = 3] = "VertexUvs";
        eMeshChangeTypes[eMeshChangeTypes["Submeshes"] = 4] = "Submeshes";
        eMeshChangeTypes[eMeshChangeTypes["Transform"] = 5] = "Transform";
    })(exports.eMeshChangeTypes || (exports.eMeshChangeTypes = {}));
    const ALL_GEOMETRY = [
        exports.eMeshChangeTypes.VertexIndices,
        exports.eMeshChangeTypes.VertexPositions,
        exports.eMeshChangeTypes.VertexNormals,
        exports.eMeshChangeTypes.VertexUvs,
        exports.eMeshChangeTypes.Submeshes,
    ];
    const ALL_CHANGES = [...ALL_GEOMETRY, exports.eMeshChangeTypes.Transform];
    exports.Feature = Feature_1 = class Feature extends exports.Kb3dObject {
        get dependsOn() {
            return this.constructor._dependsOn;
        }
        get affects() {
            return this.constructor._affects;
        }
        get affectedBy() {
            return this.constructor._affectedBy;
        }
        constructor() {
            super();
            this._suppressed = false;
        }
        getAncestors() {
            return super.getAncestors();
        }
    };
    exports.Feature = Feature_1 = __decorate([
        BaseKb3dModel({
            token: Token.Feature,
        })
    ], exports.Feature);
    function isFeatureNode(node) {
        return instanceOf(node, Token.Feature);
    }

    let defaults = {
        AnnotationNode: {
            enabled: true,
            label: null,
            fontFamily: null,
            fontSize: 0.1,
            lineSpacing: 0,
            preloadFontStylesheet: "",
            color: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            targetId: null,
            billboard: false,
            isPickable: false,
            keepOnTop: false,
            lineStyle: "solid",
            horizontalTextAlign: "left",
            verticalBoxAlign: "middle",
            horizontalBoxAlign: "center",
            offset: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            name: null,
            metadata: {},
        },
        DimensionNode: {
            target2Id: null,
            lineCapStyle: "line",
            axis: "free",
            lineThickness: 0.05,
            dimensionGap: 0.1,
            dimensionUnitPrecision: 2,
            labelOffset: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            scaleWithCamera: false,
            enabled: true,
            label: null,
            fontFamily: null,
            fontSize: 0.1,
            lineSpacing: 0,
            preloadFontStylesheet: "",
            color: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            targetId: null,
            billboard: false,
            isPickable: false,
            keepOnTop: false,
            lineStyle: "solid",
            horizontalTextAlign: "left",
            verticalBoxAlign: "middle",
            horizontalBoxAlign: "center",
            offset: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            name: null,
            metadata: {},
        },
        BaseConnector: {
            positionMode: "boundingBox",
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            direction: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            angle: 0,
            positionZeroToOne: 0,
            interpolateDirection: true,
            name: null,
            metadata: {},
        },
        Connector: {
            enabled: true,
            positionMode: "boundingBox",
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            direction: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            angle: 0,
            positionZeroToOne: 0,
            interpolateDirection: true,
            name: null,
            metadata: {},
        },
        CircularPatternFeature: {
            arc: 360,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            axis: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            count: 1,
            meshId: null,
            distance: 1,
            addEndMesh: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        DeleteFacesFeature: {
            enabled: true,
            name: null,
            metadata: {},
        },
        DisplacementMapFeature: {
            minDisplacement: 0,
            maxDisplacement: 1,
            enabled: true,
            name: null,
            metadata: {},
        },
        ExtrudeFeature: {
            size: 0,
            capEnd: false,
            capStart: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        Feature: {
            enabled: true,
            name: null,
            metadata: {},
        },
        JoinGeometryFeature: {
            joinType: "cut",
            meshId: null,
            enabled: true,
            name: null,
            metadata: {},
        },
        LinearPatternFeature: {
            translation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            count: 1,
            meshId: null,
            distance: 1,
            addEndMesh: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        MirrorFeature: {
            cloneGeometry: false,
            intersect: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            normal: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            removeGeometry: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        MoveVerticesFeature: {
            translation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scale: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            center: "barycenter",
            enabled: true,
            name: null,
            metadata: {},
        },
        NormalSmoothingFeature: {
            smooth: true,
            enabled: true,
            name: null,
            metadata: {},
        },
        PatternFeature: {
            count: 1,
            meshId: null,
            distance: 1,
            addEndMesh: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        SliceFeature: {
            intersect: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            normal: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            removeGeometry: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        SubmeshFeature: {
            uvMapping: false,
            materialId: null,
            center: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            projectionAxis: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            angle: 0,
            scale: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            uTile: 1,
            vTile: 1,
            uOffset: 0,
            vOffset: 0,
            mode: "planar",
            enabled: true,
            name: null,
            metadata: {},
        },
        SweepFeature: {
            start: null,
            end: null,
            path: null,
            mitredExtrusion: false,
            size: 0,
            capEnd: false,
            capStart: false,
            enabled: true,
            name: null,
            metadata: {},
        },
        TransformFeature: {
            scale: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            enabled: true,
            name: null,
            metadata: {},
        },
        UvMapFeature: {
            center: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            projectionAxis: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            angle: 0,
            scale: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            uTile: 1,
            vTile: 1,
            uOffset: 0,
            vOffset: 0,
            mode: "planar",
            enabled: true,
            name: null,
            metadata: {},
        },
        WeldVerticesFeature: {
            enabled: true,
            name: null,
            metadata: {},
        },
        Kb3dObject: {
            name: null,
            metadata: {},
        },
        DirectionalLightNode: {
            direction: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            generatesShadows: false,
            shadowQuality: "medium",
            shadowResolution: "low",
            shadowFilter: "simple",
            processTransparency: false,
            intensity: 1,
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        HemisphericLightNode: {
            direction: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            groundColor: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            intensity: 1,
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        LightNode: {
            intensity: 1,
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        PointLightNode: {
            generatesShadows: false,
            shadowQuality: "medium",
            shadowResolution: "low",
            shadowFilter: "simple",
            processTransparency: false,
            intensity: 1,
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        ShadowLightNode: {
            generatesShadows: false,
            shadowQuality: "medium",
            shadowResolution: "low",
            shadowFilter: "simple",
            processTransparency: false,
            intensity: 1,
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        SpotLightNode: {
            coneAngle: 60,
            direction: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            generatesShadows: false,
            shadowQuality: "medium",
            shadowResolution: "low",
            shadowFilter: "simple",
            processTransparency: false,
            intensity: 1,
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        AdvancedMaterialNode: {
            workflowMode: "metallicRoughness",
            backFaceCulling: false,
            directIntensity: 1,
            emissiveIntensity: 1,
            environmentIntensity: 1,
            specularIntensity: 1,
            metallic: 0,
            roughness: 1,
            microSurface: 1,
            useSpecularOverAlpha: true,
            useRadianceOverAlpha: true,
            ambientColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            albedoColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            specularColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            reflectionColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            anisotropyEnabled: false,
            anisotropicDirection: { "$type": "KbVector", "x": 1.0, "y": 1.0, "z": 1.0 },
            anisotropicIntensity: 1,
            subsurfaceThickness: 1,
            subsurfaceRefractionEnabled: false,
            subsurfaceReflectionEnabled: false,
            reflectionType: "plane",
            probePositionTargetId: null,
            subsurfaceRefractionIndex: 1,
            subsurfaceRefractionIntensity: 1,
            subsurfaceRefractionLinkTransparency: false,
            subsurfaceTranslucencyEnabled: false,
            subsurfaceTranslucencyIntensity: 1,
            subsurfaceUseAlbedoForTintColor: true,
            subsurfaceTintColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            clearcoatEnabled: false,
            clearcoatIntensity: 1,
            clearcoatTintEnabled: false,
            clearcoatTintColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            clearcoatTintIntensity: 0.1,
            archived: false,
            location: "local",
            alpha: 1,
            zOffset: 0,
            doubleSided: false,
            legacyTextureStacking: true,
            viewMode: "shaded",
            emissiveColor: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            hasTransparency: false,
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        ColorFillTextureLayer: {
            color: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            width: 256,
            height: 256,
            enabled: true,
            strength: 1,
            tile: false,
            maintainAspect: false,
            useClippingMask: false,
            blendMode: "normal",
            horizontalAlign: "center",
            verticalAlign: "middle",
            horizontalFit: "none",
            verticalFit: "none",
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        FileTextureLayer: {
            width: 256,
            height: 256,
            flipNormalsRg: false,
            enabled: true,
            strength: 1,
            tile: false,
            maintainAspect: false,
            useClippingMask: false,
            blendMode: "normal",
            horizontalAlign: "center",
            verticalAlign: "middle",
            horizontalFit: "none",
            verticalFit: "none",
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        MaterialMapping: {
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        MaterialNode: {
            location: "local",
            alpha: 1,
            zOffset: 0,
            reflectionType: "plane",
            doubleSided: false,
            legacyTextureStacking: true,
            viewMode: "shaded",
            emissiveColor: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            hasTransparency: false,
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        SvgTextureLayer: {
            width: 256,
            height: 256,
            preloadFontStylesheet: "",
            enabled: true,
            strength: 1,
            tile: false,
            maintainAspect: false,
            useClippingMask: false,
            blendMode: "normal",
            horizontalAlign: "center",
            verticalAlign: "middle",
            horizontalFit: "none",
            verticalFit: "none",
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        TextTextureLayer: {
            text: "",
            color: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            enabled: true,
            strength: 1,
            tile: false,
            maintainAspect: false,
            useClippingMask: false,
            blendMode: "normal",
            horizontalAlign: "center",
            verticalAlign: "middle",
            horizontalFit: "none",
            verticalFit: "none",
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        TextureLayer: {
            enabled: true,
            strength: 1,
            tile: false,
            maintainAspect: false,
            useClippingMask: false,
            blendMode: "normal",
            horizontalAlign: "center",
            verticalAlign: "middle",
            horizontalFit: "none",
            verticalFit: "none",
            uOffset: 0,
            vOffset: 0,
            uScale: 1,
            vScale: 1,
            uAngle: 0,
            vAngle: 0,
            wAngle: 0,
            uPivot: 0.5,
            vPivot: 0.5,
            wPivot: 0.5,
            name: null,
            metadata: {},
        },
        MateNode: {
            enabled: true,
            connector1: null,
            connector2: null,
            mateType: "fastened",
            flip: false,
            offsetX: 0,
            offsetY: 0,
            offsetZ: 0,
            offsetAngle: 0,
            name: null,
            metadata: {},
        },
        BoxNode: {
            height: 1,
            width: 1,
            depth: 1,
            tessellation: 1,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        ConeNode: {
            height: 1,
            radiusTop: 0,
            radiusBottom: 0.5,
            tessellation: 24,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        CustomMeshNode: {
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        CylinderNode: {
            height: 1,
            radius: 0.5,
            arc: 360,
            tessellation: 24,
            subdivisions: 1,
            capMode: "both",
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        DiscNode: {
            radius: 0.5,
            tessellation: 64,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        GroundNode: {
            height: 1,
            width: 1,
            subdivisions: 1,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        MeshGroupNode: {
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        MeshNode: {
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        PlaneNode: {
            depth: 4,
            width: 4,
            segments: 1,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        PrimitiveMeshNode: {
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        SketchControlPoint: {
            positionMode: "absolute",
            direction2: { "$type": "KbVector", "x": 0.0, "y": -1.0, "z": 0.0 },
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            direction: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            angle: 0,
            positionZeroToOne: 0,
            interpolateDirection: true,
            name: null,
            metadata: {},
        },
        SketchNode: {
            normal: "y",
            addFace: false,
            closePath: false,
            tracePath: false,
            lineThickness: 1,
            pathColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            flipPath: false,
            clonePath: null,
            boundingXOverride: null,
            boundingYOverride: null,
            boundingZOverride: null,
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        SketchPath: {
            pathGroupKey: "default",
            holeForPathGroup: null,
            type: "points",
            tessellation: 16,
            name: null,
            metadata: {},
        },
        SpaceNode: {
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        SphereNode: {
            tessellation: 32,
            radius: 0.5,
            latitudeStart: 0,
            latitudeSlice: 180,
            arc: 360,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        TextNode: {
            curveRadius: 0,
            charSpacing: 1,
            text: "",
            fontFile: "",
            fontSize: 1,
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        TorusNode: {
            radius: 0.5,
            thickness: 0.25,
            arc: 360,
            latitudeStart: 0,
            latitudeSlice: 360,
            tessellation: 16,
            sideOrientation: "frontSide",
            materialId: null,
            flipSurfaceOrientation: false,
            receiveShadows: false,
            castShadows: false,
            isPickable: true,
            checkCollisions: false,
            opacity: 1,
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        SceneNode: {
            background: "transparent",
            environment: "library://adams_place_bridge",
            environmentBlur: 0.27,
            environmentIntensity: 1,
            backgroundColor: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 0.0 },
            ambientColor: { "$type": "KbColor", "r": 0.0, "g": 0.0, "b": 0.0, "a": 1.0 },
            renderMode: "shaded",
            edgeColor: { "$type": "KbColor", "r": 1.0, "g": 1.0, "b": 1.0, "a": 1.0 },
            edgeWidth: 1,
            edgeDisplayTolerance: 0.95,
            viewpointId: null,
            frameViewpoint: false,
            progressiveTextureLoad: true,
            enableDeferredSceneUpdates: true,
            enableGrid: false,
            enableGridAxes: false,
            gridSize: 10,
            gridStepSize: 1,
            gridMajorInterval: 1,
            gridNormal: "y",
            environmentRotation: 0,
            connectorSize: 0.1,
            enableFxaaPostProcess: false,
            enableLensEffectsPostProcess: false,
            enableSSAOPostProcess: false,
            textureSamplingMode: "trilinear",
            fullscreenEnabled: true,
            arEnabled: true,
            xrAllowScaling: false,
            unitsPerMeter: 1,
            xrAddShadow: true,
            xrLightingEstimation: false,
            enableHoverEffects: false,
            enableSceneOptimization: true,
            loadingExperience: "spinner",
            loadingImagePath: null,
            dimensionUnitScalar: 1,
            dimensionUnitSymbol: "m",
            conversionMap: {},
            visible: true,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            useEuler: false,
            eulerRotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAxis: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            rotationAngle: 0,
            scaling: 1,
            pivot: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fixed: false,
            name: null,
            metadata: {},
        },
        ViewpointNode: {
            type: "orbit",
            targetMode: "point",
            projection: "perspective",
            offsetX: 0,
            offsetY: 0,
            position: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            targetPoint: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            targetMeshId: null,
            rotation: { "$type": "KbVector", "x": 0.0, "y": 0.0, "z": 0.0 },
            fov: 50,
            allowOrbit: true,
            allowPan: true,
            allowZoom: true,
            limitMinimumTargetDistance: false,
            minTargetDistance: 0.001,
            maxTargetDistance: 10000,
            orbitAxis: { "$type": "KbVector", "x": 0.0, "y": 1.0, "z": 0.0 },
            limitLatOrbit: false,
            limitMinLatitude: 0,
            limitMaxLatitude: 180,
            limitLngOrbit: false,
            limitMinLongitude: -180,
            limitMaxLongitude: 180,
            name: null,
            metadata: {},
        },
    };

    exports.MaterialMapping = class MaterialMapping extends exports.Kb3dObject {
        constructor() {
            super(...arguments);
            this.uOffset = 0; // Define an offset on the texture to offset the u coordinates of the UVs
            this.vOffset = 0; // Define an offset on the texture to offset the v coordinates of the UVs
            this.uScale = 1; // Define an offset on the texture to scale the u coordinates of the UVs
            this.vScale = 1; // Define an offset on the texture to scale the v coordinates of the UVs
            this.uAngle = 0; // Define an offset on the texture to rotate around the u coordinates of the UVs
            this.vAngle = 0; // Define an offset on the texture to rotate around the v coordinates of the UVs
            this.wAngle = 0; // Define an offset on the texture to rotate around the w coordinates of the UVs
            this.uPivot = 0.5; // Defines the center of rotation (U)
            this.vPivot = 0.5; // Defines the center of rotation (V)
            this.wPivot = 0.5; // Defines the center of rotation (W)
        }
    };
    exports.MaterialMapping = __decorate([
        BaseKb3dModel({
            token: Token.MaterialMapping,
        })
    ], exports.MaterialMapping);

    const NEVER_INHERIT = new Set([
        '$type',
        'overriddenProperties',
        '_parentMaterial',
        'parentMaterialId',
        'location',
        'children',
        '_selected',
        '_expanded',
        'id',
        'name',
        'visible',
        '_parent',
        '_parentScene',
        '_rootScene',
        '_level',
    ]);
    exports.MaterialNode = class MaterialNode extends exports.MaterialMapping {
        constructor(_materialService) {
            super();
            this._materialService = _materialService;
            this._overriddenPropertiesSet = new Set();
            this._initialized = false;
        }
        get materials() {
            if (!this._materials)
                this._materials = [];
            return this._materials;
        }
        set materials(val) {
            this._materials = val;
        }
        get overriddenProperties() {
            if (!this._overriddenProperties)
                this._overriddenProperties = [];
            return this._overriddenProperties;
        }
        set overriddenProperties(val) {
            this._overriddenProperties = val;
        }
        get textures() {
            if (!this._textures)
                this._textures = [];
            return this._textures;
        }
        set textures(val) {
            this._textures = val;
        }
        init() {
            this.refreshParentMaterial();
            if (!this._initialized) {
                if (isTrackedClass(this)) {
                    // Always track changes on initialized materials because they may be global materials
                    this.trackChanges(true);
                    this.isModified = true;
                }
                this._initialized = true;
                this.textures.forEach(texture => {
                    texture.init(this);
                });
            }
        }
        getChildren() {
            return [...this.textures, ...this.materials];
        }
        getChildArrayForType(token) {
            if (token.isMaterial()) {
                return this.materials;
            }
            else if (token.isTexture()) {
                return this.textures;
            }
            else {
                throw 'unexpected token';
            }
        }
        overrideProperty(property) {
            if (this.parentMaterialId) {
                this._overriddenPropertiesSet.add(property);
            }
        }
        inheritProperty(property) {
            if (this.parentMaterialId) {
                this._overriddenPropertiesSet.delete(property);
                if (this._parentMaterial) {
                    this[property] =
                        this._parentMaterial[property] == null
                            ? defaults[this.$type][property]
                            : this._parentMaterial[property];
                }
            }
        }
        getTextureByName(name) {
            return [...this.textures].find(f => f.name.isEqual(name));
        }
        inheritFromMaterial(parentMat) {
            this.parentMaterialId = parentMat.id;
            this._parentMaterial = parentMat;
            if (!this._manager) {
                return;
            }
            const manager = this._manager;
            NEVER_INHERIT.forEach(prop => {
                this._overriddenPropertiesSet.add(prop);
            });
            for (const _key in parentMat) {
                const key = _key;
                if (!this._overriddenPropertiesSet.has(key)) {
                    //if this is a serialization of a texture node, then we need to deserialize it
                    if (Array.isArray(parentMat[key])) {
                        const currentTextures = this[key];
                        parentMat[key].forEach((tex, indexOnParent) => {
                            const texDef = { ...tex, name: `Base ${tex.name || tex.channel}` };
                            if (!texDef.id) {
                                texDef.id = `${parentMat.id}_${tex.channel}`;
                            }
                            const currentIndex = currentTextures.findIndex(currentTexture => currentTexture.id === texDef.id);
                            if (currentIndex < 0) {
                                const textureNode = manager.deserialize(texDef);
                                textureNode._external = true;
                                // If this material is already initialized, make sure the new texture is also initialized.
                                if (this._initialized) {
                                    textureNode.init(this);
                                }
                                currentTextures.splice(indexOnParent, 0, textureNode);
                            }
                        });
                    }
                    else {
                        this[key] =
                            parentMat[key] instanceof exports.Kb3dObject ? parentMat[key] : manager.deserialize(parentMat[key]);
                    }
                }
            }
        }
        refreshParentMaterial() {
            if (this.parentMaterialId) {
                this._materialService.getMaterialById(this.parentMaterialId).subscribe(parentMaterial => {
                    if (parentMaterial && parentMaterial.data) {
                        this.inheritFromMaterial(parentMaterial.data);
                    }
                });
            }
        }
        getMediaReferences() {
            const refs = new Array();
            for (const texture of this.textures) {
                if (instanceOf(texture, Token.FileTextureLayer) && texture.path && !isAbsoluteUrl(texture.path)) {
                    refs.push({
                        type: 'Media',
                        id: 'media/' + texture.path,
                    });
                }
            }
            return refs;
        }
    };
    __decorate([
        Enumerable()
    ], exports.MaterialNode.prototype, "materials", null);
    __decorate([
        IgnoreChanges
    ], exports.MaterialNode.prototype, "_initialized", void 0);
    __decorate([
        IgnoreChanges
    ], exports.MaterialNode.prototype, "location", void 0);
    __decorate([
        IgnoreChanges
    ], exports.MaterialNode.prototype, "parentMaterialId", void 0);
    __decorate([
        Enumerable()
    ], exports.MaterialNode.prototype, "overriddenProperties", null);
    __decorate([
        Enumerable()
    ], exports.MaterialNode.prototype, "textures", null);
    __decorate([
        IgnoreChanges
    ], exports.MaterialNode.prototype, "legacyTextureStacking", void 0);
    exports.MaterialNode = __decorate([
        BaseKb3dModel({
            token: Token.MaterialNode,
        })
    ], exports.MaterialNode);
    function isMaterialNode(node) {
        return instanceOfAny(node, ...Token.MaterialTokens);
    }

    function __decorate$1(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    /**
     * Class used to evaluate queries containing `and` and `or` operators
     */
    class AndOrNotEvaluator {
        /**
         * Evaluate a query
         * @param query defines the query to evaluate
         * @param evaluateCallback defines the callback used to filter result
         * @returns true if the query matches
         */
        static Eval(query, evaluateCallback) {
            if (!query.match(/\([^()]*\)/g)) {
                query = AndOrNotEvaluator._HandleParenthesisContent(query, evaluateCallback);
            }
            else {
                query = query.replace(/\([^()]*\)/g, (r) => {
                    // remove parenthesis
                    r = r.slice(1, r.length - 1);
                    return AndOrNotEvaluator._HandleParenthesisContent(r, evaluateCallback);
                });
            }
            if (query === "true") {
                return true;
            }
            if (query === "false") {
                return false;
            }
            return AndOrNotEvaluator.Eval(query, evaluateCallback);
        }
        static _HandleParenthesisContent(parenthesisContent, evaluateCallback) {
            evaluateCallback =
                evaluateCallback ||
                    ((r) => {
                        return r === "true" ? true : false;
                    });
            let result;
            const or = parenthesisContent.split("||");
            for (const i in or) {
                if (Object.prototype.hasOwnProperty.call(or, i)) {
                    let ori = AndOrNotEvaluator._SimplifyNegation(or[i].trim());
                    const and = ori.split("&&");
                    if (and.length > 1) {
                        for (let j = 0; j < and.length; ++j) {
                            const andj = AndOrNotEvaluator._SimplifyNegation(and[j].trim());
                            if (andj !== "true" && andj !== "false") {
                                if (andj[0] === "!") {
                                    result = !evaluateCallback(andj.substring(1));
                                }
                                else {
                                    result = evaluateCallback(andj);
                                }
                            }
                            else {
                                result = andj === "true" ? true : false;
                            }
                            if (!result) {
                                // no need to continue since 'false && ... && ...' will always return false
                                ori = "false";
                                break;
                            }
                        }
                    }
                    if (result || ori === "true") {
                        // no need to continue since 'true || ... || ...' will always return true
                        result = true;
                        break;
                    }
                    // result equals false (or undefined)
                    if (ori !== "true" && ori !== "false") {
                        if (ori[0] === "!") {
                            result = !evaluateCallback(ori.substring(1));
                        }
                        else {
                            result = evaluateCallback(ori);
                        }
                    }
                    else {
                        result = ori === "true" ? true : false;
                    }
                }
            }
            // the whole parenthesis scope is replaced by 'true' or 'false'
            return result ? "true" : "false";
        }
        static _SimplifyNegation(booleanString) {
            booleanString = booleanString.replace(/^[\s!]+/, (r) => {
                // remove whitespaces
                r = r.replace(/[\s]/g, () => "");
                return r.length % 2 ? "!" : "";
            });
            booleanString = booleanString.trim();
            if (booleanString === "!true") {
                booleanString = "false";
            }
            else if (booleanString === "!false") {
                booleanString = "true";
            }
            return booleanString;
        }
    }

    /**
     * Class used to store custom tags
     */
    class Tags {
        /**
         * Adds support for tags on the given object
         * @param obj defines the object to use
         */
        static EnableFor(obj) {
            obj._tags = obj._tags || {};
            obj.hasTags = () => {
                return Tags.HasTags(obj);
            };
            obj.addTags = (tagsString) => {
                return Tags.AddTagsTo(obj, tagsString);
            };
            obj.removeTags = (tagsString) => {
                return Tags.RemoveTagsFrom(obj, tagsString);
            };
            obj.matchesTagsQuery = (tagsQuery) => {
                return Tags.MatchesQuery(obj, tagsQuery);
            };
        }
        /**
         * Removes tags support
         * @param obj defines the object to use
         */
        static DisableFor(obj) {
            delete obj._tags;
            delete obj.hasTags;
            delete obj.addTags;
            delete obj.removeTags;
            delete obj.matchesTagsQuery;
        }
        /**
         * Gets a boolean indicating if the given object has tags
         * @param obj defines the object to use
         * @returns a boolean
         */
        static HasTags(obj) {
            if (!obj._tags) {
                return false;
            }
            const tags = obj._tags;
            for (const i in tags) {
                if (Object.prototype.hasOwnProperty.call(tags, i)) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Gets the tags available on a given object
         * @param obj defines the object to use
         * @param asString defines if the tags must be returned as a string instead of an array of strings
         * @returns the tags
         */
        static GetTags(obj, asString = true) {
            if (!obj._tags) {
                return null;
            }
            if (asString) {
                const tagsArray = [];
                for (const tag in obj._tags) {
                    if (Object.prototype.hasOwnProperty.call(obj._tags, tag) && obj._tags[tag] === true) {
                        tagsArray.push(tag);
                    }
                }
                return tagsArray.join(" ");
            }
            else {
                return obj._tags;
            }
        }
        /**
         * Adds tags to an object
         * @param obj defines the object to use
         * @param tagsString defines the tag string. The tags 'true' and 'false' are reserved and cannot be used as tags.
         * A tag cannot start with '||', '&&', and '!'. It cannot contain whitespaces
         */
        static AddTagsTo(obj, tagsString) {
            if (!tagsString) {
                return;
            }
            if (typeof tagsString !== "string") {
                return;
            }
            const tags = tagsString.split(" ");
            tags.forEach(function (tag) {
                Tags._AddTagTo(obj, tag);
            });
        }
        /**
         * @internal
         */
        static _AddTagTo(obj, tag) {
            tag = tag.trim();
            if (tag === "" || tag === "true" || tag === "false") {
                return;
            }
            if (tag.match(/[\s]/) || tag.match(/^([!]|([|]|[&]){2})/)) {
                return;
            }
            Tags.EnableFor(obj);
            obj._tags[tag] = true;
        }
        /**
         * Removes specific tags from a specific object
         * @param obj defines the object to use
         * @param tagsString defines the tags to remove
         */
        static RemoveTagsFrom(obj, tagsString) {
            if (!Tags.HasTags(obj)) {
                return;
            }
            const tags = tagsString.split(" ");
            for (const t in tags) {
                Tags._RemoveTagFrom(obj, tags[t]);
            }
        }
        /**
         * @internal
         */
        static _RemoveTagFrom(obj, tag) {
            delete obj._tags[tag];
        }
        /**
         * Defines if tags hosted on an object match a given query
         * @param obj defines the object to use
         * @param tagsQuery defines the tag query
         * @returns a boolean
         */
        static MatchesQuery(obj, tagsQuery) {
            if (tagsQuery === undefined) {
                return true;
            }
            if (tagsQuery === "") {
                return Tags.HasTags(obj);
            }
            return AndOrNotEvaluator.Eval(tagsQuery, (r) => Tags.HasTags(obj) && obj._tags[r]);
        }
    }

    /**
     * Scalar computation library
     */
    class Scalar {
        /**
         * Boolean : true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)
         * @param a number
         * @param b number
         * @param epsilon (default = 1.401298E-45)
         * @returns true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)
         */
        static WithinEpsilon(a, b, epsilon = 1.401298e-45) {
            return Math.abs(a - b) <= epsilon;
        }
        /**
         * Returns a string : the upper case translation of the number i to hexadecimal.
         * @param i number
         * @returns the upper case translation of the number i to hexadecimal.
         */
        static ToHex(i) {
            const str = i.toString(16);
            if (i <= 15) {
                return ("0" + str).toUpperCase();
            }
            return str.toUpperCase();
        }
        /**
         * Returns -1 if value is negative and +1 is value is positive.
         * @param value the value
         * @returns the value itself if it's equal to zero.
         */
        static Sign(value) {
            value = +value; // convert to a number
            if (value === 0 || isNaN(value)) {
                return value;
            }
            return value > 0 ? 1 : -1;
        }
        /**
         * Returns the value itself if it's between min and max.
         * Returns min if the value is lower than min.
         * Returns max if the value is greater than max.
         * @param value the value to clmap
         * @param min the min value to clamp to (default: 0)
         * @param max the max value to clamp to (default: 1)
         * @returns the clamped value
         */
        static Clamp(value, min = 0, max = 1) {
            return Math.min(max, Math.max(min, value));
        }
        /**
         * the log2 of value.
         * @param value the value to compute log2 of
         * @returns the log2 of value.
         */
        static Log2(value) {
            return Math.log(value) * Math.LOG2E;
        }
        /**
         * the floor part of a log2 value.
         * @param value the value to compute log2 of
         * @returns the log2 of value.
         */
        static ILog2(value) {
            if (Math.log2) {
                return Math.floor(Math.log2(value));
            }
            if (value < 0) {
                return NaN;
            }
            else if (value === 0) {
                return -Infinity;
            }
            let n = 0;
            if (value < 1) {
                while (value < 1) {
                    n++;
                    value = value * 2;
                }
                n = -n;
            }
            else if (value > 1) {
                while (value > 1) {
                    n++;
                    value = Math.floor(value / 2);
                }
            }
            return n;
        }
        /**
         * Loops the value, so that it is never larger than length and never smaller than 0.
         *
         * This is similar to the modulo operator but it works with floating point numbers.
         * For example, using 3.0 for t and 2.5 for length, the result would be 0.5.
         * With t = 5 and length = 2.5, the result would be 0.0.
         * Note, however, that the behaviour is not defined for negative numbers as it is for the modulo operator
         * @param value the value
         * @param length the length
         * @returns the looped value
         */
        static Repeat(value, length) {
            return value - Math.floor(value / length) * length;
        }
        /**
         * Normalize the value between 0.0 and 1.0 using min and max values
         * @param value value to normalize
         * @param min max to normalize between
         * @param max min to normalize between
         * @returns the normalized value
         */
        static Normalize(value, min, max) {
            return (value - min) / (max - min);
        }
        /**
         * Denormalize the value from 0.0 and 1.0 using min and max values
         * @param normalized value to denormalize
         * @param min max to denormalize between
         * @param max min to denormalize between
         * @returns the denormalized value
         */
        static Denormalize(normalized, min, max) {
            return normalized * (max - min) + min;
        }
        /**
         * Calculates the shortest difference between two given angles given in degrees.
         * @param current current angle in degrees
         * @param target target angle in degrees
         * @returns the delta
         */
        static DeltaAngle(current, target) {
            let num = Scalar.Repeat(target - current, 360.0);
            if (num > 180.0) {
                num -= 360.0;
            }
            return num;
        }
        /**
         * PingPongs the value t, so that it is never larger than length and never smaller than 0.
         * @param tx value
         * @param length length
         * @returns The returned value will move back and forth between 0 and length
         */
        static PingPong(tx, length) {
            const t = Scalar.Repeat(tx, length * 2.0);
            return length - Math.abs(t - length);
        }
        /**
         * Interpolates between min and max with smoothing at the limits.
         *
         * This function interpolates between min and max in a similar way to Lerp. However, the interpolation will gradually speed up
         * from the start and slow down toward the end. This is useful for creating natural-looking animation, fading and other transitions.
         * @param from from
         * @param to to
         * @param tx value
         * @returns the smooth stepped value
         */
        static SmoothStep(from, to, tx) {
            let t = Scalar.Clamp(tx);
            t = -2.0 * t * t * t + 3.0 * t * t;
            return to * t + from * (1.0 - t);
        }
        /**
         * Moves a value current towards target.
         *
         * This is essentially the same as Mathf.Lerp but instead the function will ensure that the speed never exceeds maxDelta.
         * Negative values of maxDelta pushes the value away from target.
         * @param current current value
         * @param target target value
         * @param maxDelta max distance to move
         * @returns resulting value
         */
        static MoveTowards(current, target, maxDelta) {
            let result = 0;
            if (Math.abs(target - current) <= maxDelta) {
                result = target;
            }
            else {
                result = current + Scalar.Sign(target - current) * maxDelta;
            }
            return result;
        }
        /**
         * Same as MoveTowards but makes sure the values interpolate correctly when they wrap around 360 degrees.
         *
         * Variables current and target are assumed to be in degrees. For optimization reasons, negative values of maxDelta
         *  are not supported and may cause oscillation. To push current away from a target angle, add 180 to that angle instead.
         * @param current current value
         * @param target target value
         * @param maxDelta max distance to move
         * @returns resulting angle
         */
        static MoveTowardsAngle(current, target, maxDelta) {
            const num = Scalar.DeltaAngle(current, target);
            let result = 0;
            if (-maxDelta < num && num < maxDelta) {
                result = target;
            }
            else {
                target = current + num;
                result = Scalar.MoveTowards(current, target, maxDelta);
            }
            return result;
        }
        /**
         * Creates a new scalar with values linearly interpolated of "amount" between the start scalar and the end scalar.
         * @param start start value
         * @param end target value
         * @param amount amount to lerp between
         * @returns the lerped value
         */
        static Lerp(start, end, amount) {
            return start + (end - start) * amount;
        }
        /**
         * Same as Lerp but makes sure the values interpolate correctly when they wrap around 360 degrees.
         * The parameter t is clamped to the range [0, 1]. Variables a and b are assumed to be in degrees.
         * @param start start value
         * @param end target value
         * @param amount amount to lerp between
         * @returns the lerped value
         */
        static LerpAngle(start, end, amount) {
            let num = Scalar.Repeat(end - start, 360.0);
            if (num > 180.0) {
                num -= 360.0;
            }
            return start + num * Scalar.Clamp(amount);
        }
        /**
         * Calculates the linear parameter t that produces the interpolant value within the range [a, b].
         * @param a start value
         * @param b target value
         * @param value value between a and b
         * @returns the inverseLerp value
         */
        static InverseLerp(a, b, value) {
            let result = 0;
            if (a != b) {
                result = Scalar.Clamp((value - a) / (b - a));
            }
            else {
                result = 0.0;
            }
            return result;
        }
        /**
         * Returns a new scalar located for "amount" (float) on the Hermite spline defined by the scalars "value1", "value3", "tangent1", "tangent2".
         * @see http://mathworld.wolfram.com/HermitePolynomial.html
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param amount defines the amount on the interpolation spline (between 0 and 1)
         * @returns hermite result
         */
        static Hermite(value1, tangent1, value2, tangent2, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
            const part2 = -2.0 * cubed + 3.0 * squared;
            const part3 = cubed - 2.0 * squared + amount;
            const part4 = cubed - squared;
            return value1 * part1 + value2 * part2 + tangent1 * part3 + tangent2 * part4;
        }
        /**
         * Returns a new scalar which is the 1st derivative of the Hermite spline defined by the scalars "value1", "value2", "tangent1", "tangent2".
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @returns 1st derivative
         */
        static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
            const t2 = time * time;
            return (t2 - time) * 6 * value1 + (3 * t2 - 4 * time + 1) * tangent1 + (-t2 + time) * 6 * value2 + (3 * t2 - 2 * time) * tangent2;
        }
        /**
         * Returns a random float number between and min and max values
         * @param min min value of random
         * @param max max value of random
         * @returns random value
         */
        static RandomRange(min, max) {
            if (min === max) {
                return min;
            }
            return Math.random() * (max - min) + min;
        }
        /**
         * This function returns percentage of a number in a given range.
         *
         * RangeToPercent(40,20,60) will return 0.5 (50%)
         * RangeToPercent(34,0,100) will return 0.34 (34%)
         * @param number to convert to percentage
         * @param min min range
         * @param max max range
         * @returns the percentage
         */
        static RangeToPercent(number, min, max) {
            return (number - min) / (max - min);
        }
        /**
         * This function returns number that corresponds to the percentage in a given range.
         *
         * PercentToRange(0.34,0,100) will return 34.
         * @param percent to convert to number
         * @param min min range
         * @param max max range
         * @returns the number
         */
        static PercentToRange(percent, min, max) {
            return (max - min) * percent + min;
        }
        /**
         * Returns the angle converted to equivalent value between -Math.PI and Math.PI radians.
         * @param angle The angle to normalize in radian.
         * @returns The converted angle.
         */
        static NormalizeRadians(angle) {
            // More precise but slower version kept for reference.
            // angle = angle % Tools.TwoPi;
            // angle = (angle + Tools.TwoPi) % Tools.TwoPi;
            //if (angle > Math.PI) {
            //	angle -= Tools.TwoPi;
            //}
            angle -= Scalar.TwoPi * Math.floor((angle + Math.PI) / Scalar.TwoPi);
            return angle;
        }
        /**
         * Returns the highest common factor of two integers.
         * @param a first parameter
         * @param b second parameter
         * @returns HCF of a and b
         */
        static HCF(a, b) {
            const r = a % b;
            if (r === 0) {
                return b;
            }
            return Scalar.HCF(b, r);
        }
    }
    /**
     * Two pi constants convenient for computation.
     */
    Scalar.TwoPi = Math.PI * 2;

    /**
     * Constant used to convert a value to gamma space
     * @ignorenaming
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const ToGammaSpace = 1 / 2.2;
    /**
     * Constant used to convert a value to linear space
     * @ignorenaming
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const ToLinearSpace = 2.2;
    /**
     * Constant Golden Ratio value in Babylon.js
     * @ignorenaming
     */
    const PHI = (1 + Math.sqrt(5)) / 2;
    /**
     * Constant used to define the minimal number value in Babylon.js
     * @ignorenaming
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const Epsilon = 0.001;

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * Class containing a set of static utilities functions for arrays.
     */
    class ArrayTools {
        /**
         * Returns an array of the given size filled with elements built from the given constructor and the parameters.
         * @param size the number of element to construct and put in the array.
         * @param itemBuilder a callback responsible for creating new instance of item. Called once per array entry.
         * @returns a new array filled with new objects.
         */
        static BuildArray(size, itemBuilder) {
            const a = [];
            for (let i = 0; i < size; ++i) {
                a.push(itemBuilder());
            }
            return a;
        }
        /**
         * Returns a tuple of the given size filled with elements built from the given constructor and the parameters.
         * @param size he number of element to construct and put in the tuple.
         * @param itemBuilder a callback responsible for creating new instance of item. Called once per tuple entry.
         * @returns a new tuple filled with new objects.
         */
        static BuildTuple(size, itemBuilder) {
            return ArrayTools.BuildArray(size, itemBuilder);
        }
    }
    /**
     * Observes a function and calls the given callback when it is called.
     * @param object Defines the object the function to observe belongs to.
     * @param functionName Defines the name of the function to observe.
     * @param callback Defines the callback to call when the function is called.
     * @returns A function to call to stop observing
     */
    function _observeArrayfunction(object, functionName, callback) {
        // Finds the function to observe
        const oldFunction = object[functionName];
        if (typeof oldFunction !== "function") {
            return null;
        }
        // Creates a new function that calls the callback and the old function
        const newFunction = function () {
            const previousLength = object.length;
            const returnValue = newFunction.previous.apply(object, arguments);
            callback(functionName, previousLength);
            return returnValue;
        };
        // Doublishly links the new function and the old function
        oldFunction.next = newFunction;
        newFunction.previous = oldFunction;
        // Replaces the old function with the new function
        object[functionName] = newFunction;
        // Returns a function to disable the hook
        return () => {
            // Only unhook if the function is still hooked
            const previous = newFunction.previous;
            if (!previous) {
                return;
            }
            // Finds the ref to the next function in the chain
            const next = newFunction.next;
            // If in the middle of the chain, link the previous and next functions
            if (next) {
                previous.next = next;
                next.previous = previous;
            }
            // If at the end of the chain, remove the reference to the previous function
            // and restore the previous function
            else {
                previous.next = undefined;
                object[functionName] = previous;
            }
            // Lose reference to the previous and next functions
            newFunction.next = undefined;
            newFunction.previous = undefined;
        };
    }
    /**
     * Defines the list of functions to proxy when observing an array.
     * The scope is currently reduced to the common functions used in the render target render list and the scene cameras.
     */
    const observedArrayFunctions = ["push", "splice", "pop", "shift", "unshift"];
    /**
     * Observes an array and notifies the given observer when the array is modified.
     * @param array Defines the array to observe
     * @param callback Defines the function to call when the array is modified (in the limit of the observed array functions)
     * @returns A function to call to stop observing the array
     * @internal
     */
    function _ObserveArray(array, callback) {
        // Observes all the required array functions and stores the unhook functions
        const unObserveFunctions = observedArrayFunctions.map((name) => {
            return _observeArrayfunction(array, name, callback);
        });
        // Returns a function that unhook all the observed functions
        return () => {
            unObserveFunctions.forEach((unObserveFunction) => {
                unObserveFunction === null || unObserveFunction === void 0 ? void 0 : unObserveFunction();
            });
        };
    }

    /** @internal */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _RegisteredTypes = {};
    /**
     * @internal
     */
    function RegisterClass(className, type) {
        _RegisteredTypes[className] = type;
    }
    /**
     * @internal
     */
    function GetClass(fqdn) {
        return _RegisteredTypes[fqdn];
    }

    /** @internal */
    class PerformanceConfigurator {
        /**
         * @internal
         */
        static SetMatrixPrecision(use64bits) {
            PerformanceConfigurator.MatrixTrackPrecisionChange = false;
            if (use64bits && !PerformanceConfigurator.MatrixUse64Bits) {
                if (PerformanceConfigurator.MatrixTrackedMatrices) {
                    for (let m = 0; m < PerformanceConfigurator.MatrixTrackedMatrices.length; ++m) {
                        const matrix = PerformanceConfigurator.MatrixTrackedMatrices[m];
                        const values = matrix._m;
                        matrix._m = new Array(16);
                        for (let i = 0; i < 16; ++i) {
                            matrix._m[i] = values[i];
                        }
                    }
                }
            }
            PerformanceConfigurator.MatrixUse64Bits = use64bits;
            PerformanceConfigurator.MatrixCurrentType = PerformanceConfigurator.MatrixUse64Bits ? Array : Float32Array;
            PerformanceConfigurator.MatrixTrackedMatrices = null; // reclaim some memory, as we don't need _TrackedMatrices anymore
        }
    }
    /** @internal */
    PerformanceConfigurator.MatrixUse64Bits = false;
    /** @internal */
    PerformanceConfigurator.MatrixTrackPrecisionChange = true;
    /** @internal */
    PerformanceConfigurator.MatrixCurrentType = Float32Array;
    /** @internal */
    PerformanceConfigurator.MatrixTrackedMatrices = [];

    /**
     * A class serves as a medium between the observable and its observers
     */
    class EventState {
        /**
         * Create a new EventState
         * @param mask defines the mask associated with this state
         * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
         * @param target defines the original target of the state
         * @param currentTarget defines the current target of the state
         */
        constructor(mask, skipNextObservers = false, target, currentTarget) {
            this.initialize(mask, skipNextObservers, target, currentTarget);
        }
        /**
         * Initialize the current event state
         * @param mask defines the mask associated with this state
         * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
         * @param target defines the original target of the state
         * @param currentTarget defines the current target of the state
         * @returns the current event state
         */
        initialize(mask, skipNextObservers = false, target, currentTarget) {
            this.mask = mask;
            this.skipNextObservers = skipNextObservers;
            this.target = target;
            this.currentTarget = currentTarget;
            return this;
        }
    }
    /**
     * Represent an Observer registered to a given Observable object.
     */
    class Observer {
        /**
         * Creates a new observer
         * @param callback defines the callback to call when the observer is notified
         * @param mask defines the mask of the observer (used to filter notifications)
         * @param scope defines the current scope used to restore the JS context
         */
        constructor(
        /**
         * Defines the callback to call when the observer is notified
         */
        callback, 
        /**
         * Defines the mask of the observer (used to filter notifications)
         */
        mask, 
        /**
         * Defines the current scope used to restore the JS context
         */
        scope = null) {
            this.callback = callback;
            this.mask = mask;
            this.scope = scope;
            /** @internal */
            this._willBeUnregistered = false;
            /**
             * Gets or sets a property defining that the observer as to be unregistered after the next notification
             */
            this.unregisterOnNextCall = false;
            /**
             * this function can be used to remove the observer from the observable.
             * It will be set by the observable that the observer belongs to.
             * @internal
             */
            this._remove = null;
        }
        /**
         * Remove the observer from its observable
         * This can be used instead of using the observable's remove function.
         */
        remove() {
            if (this._remove) {
                this._remove();
            }
        }
    }
    /**
     * The Observable class is a simple implementation of the Observable pattern.
     *
     * There's one slight particularity though: a given Observable can notify its observer using a particular mask value, only the Observers registered with this mask value will be notified.
     * This enable a more fine grained execution without having to rely on multiple different Observable objects.
     * For instance you may have a given Observable that have four different types of notifications: Move (mask = 0x01), Stop (mask = 0x02), Turn Right (mask = 0X04), Turn Left (mask = 0X08).
     * A given observer can register itself with only Move and Stop (mask = 0x03), then it will only be notified when one of these two occurs and will never be for Turn Left/Right.
     */
    class Observable$1 {
        /**
         * Create an observable from a Promise.
         * @param promise a promise to observe for fulfillment.
         * @param onErrorObservable an observable to notify if a promise was rejected.
         * @returns the new Observable
         */
        static FromPromise(promise, onErrorObservable) {
            const observable = new Observable$1();
            promise
                .then((ret) => {
                observable.notifyObservers(ret);
            })
                .catch((err) => {
                if (onErrorObservable) {
                    onErrorObservable.notifyObservers(err);
                }
                else {
                    throw err;
                }
            });
            return observable;
        }
        /**
         * Gets the list of observers
         * Note that observers that were recently deleted may still be present in the list because they are only really deleted on the next javascript tick!
         */
        get observers() {
            return this._observers;
        }
        /**
         * Creates a new observable
         * @param onObserverAdded defines a callback to call when a new observer is added
         * @param notifyIfTriggered If set to true the observable will notify when an observer was added if the observable was already triggered.
         */
        constructor(onObserverAdded, 
        /**
         * If set to true the observable will notify when an observer was added if the observable was already triggered.
         * This is helpful to single-state observables like the scene onReady or the dispose observable.
         */
        notifyIfTriggered = false) {
            this.notifyIfTriggered = notifyIfTriggered;
            this._observers = new Array();
            this._numObserversMarkedAsDeleted = 0;
            this._hasNotified = false;
            this._eventState = new EventState(0);
            if (onObserverAdded) {
                this._onObserverAdded = onObserverAdded;
            }
        }
        /**
         * Create a new Observer with the specified callback
         * @param callback the callback that will be executed for that Observer
         * @param mask the mask used to filter observers
         * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
         * @param scope optional scope for the callback to be called from
         * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
         * @returns the new observer created for the callback
         */
        add(callback, mask = -1, insertFirst = false, scope = null, unregisterOnFirstCall = false) {
            if (!callback) {
                return null;
            }
            const observer = new Observer(callback, mask, scope);
            observer.unregisterOnNextCall = unregisterOnFirstCall;
            if (insertFirst) {
                this._observers.unshift(observer);
            }
            else {
                this._observers.push(observer);
            }
            if (this._onObserverAdded) {
                this._onObserverAdded(observer);
            }
            // If the observable was already triggered and the observable is set to notify if triggered, notify the new observer
            if (this._hasNotified && this.notifyIfTriggered) {
                if (this._lastNotifiedValue !== undefined) {
                    this.notifyObserver(observer, this._lastNotifiedValue);
                }
            }
            // attach the remove function to the observer
            observer._remove = () => {
                this.remove(observer);
            };
            return observer;
        }
        /**
         * Create a new Observer with the specified callback and unregisters after the next notification
         * @param callback the callback that will be executed for that Observer
         * @returns the new observer created for the callback
         */
        addOnce(callback) {
            return this.add(callback, undefined, undefined, undefined, true);
        }
        /**
         * Remove an Observer from the Observable object
         * @param observer the instance of the Observer to remove
         * @returns false if it doesn't belong to this Observable
         */
        remove(observer) {
            if (!observer) {
                return false;
            }
            observer._remove = null;
            const index = this._observers.indexOf(observer);
            if (index !== -1) {
                this._deferUnregister(observer);
                return true;
            }
            return false;
        }
        /**
         * Remove a callback from the Observable object
         * @param callback the callback to remove
         * @param scope optional scope. If used only the callbacks with this scope will be removed
         * @returns false if it doesn't belong to this Observable
         */
        removeCallback(callback, scope) {
            for (let index = 0; index < this._observers.length; index++) {
                const observer = this._observers[index];
                if (observer._willBeUnregistered) {
                    continue;
                }
                if (observer.callback === callback && (!scope || scope === observer.scope)) {
                    this._deferUnregister(observer);
                    return true;
                }
            }
            return false;
        }
        /**
         * @internal
         */
        _deferUnregister(observer) {
            if (observer._willBeUnregistered) {
                return;
            }
            this._numObserversMarkedAsDeleted++;
            observer.unregisterOnNextCall = false;
            observer._willBeUnregistered = true;
            setTimeout(() => {
                this._remove(observer);
            }, 0);
        }
        // This should only be called when not iterating over _observers to avoid callback skipping.
        // Removes an observer from the _observer Array.
        _remove(observer, updateCounter = true) {
            if (!observer) {
                return false;
            }
            const index = this._observers.indexOf(observer);
            if (index !== -1) {
                if (updateCounter) {
                    this._numObserversMarkedAsDeleted--;
                }
                this._observers.splice(index, 1);
                return true;
            }
            return false;
        }
        /**
         * Moves the observable to the top of the observer list making it get called first when notified
         * @param observer the observer to move
         */
        makeObserverTopPriority(observer) {
            this._remove(observer, false);
            this._observers.unshift(observer);
        }
        /**
         * Moves the observable to the bottom of the observer list making it get called last when notified
         * @param observer the observer to move
         */
        makeObserverBottomPriority(observer) {
            this._remove(observer, false);
            this._observers.push(observer);
        }
        /**
         * Notify all Observers by calling their respective callback with the given data
         * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
         * @param eventData defines the data to send to all observers
         * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
         * @param target defines the original target of the state
         * @param currentTarget defines the current target of the state
         * @param userInfo defines any user info to send to observers
         * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
         */
        notifyObservers(eventData, mask = -1, target, currentTarget, userInfo) {
            // this prevents potential memory leaks - if an object is disposed but the observable doesn't get cleared.
            if (this.notifyIfTriggered) {
                this._hasNotified = true;
                this._lastNotifiedValue = eventData;
            }
            if (!this._observers.length) {
                return true;
            }
            const state = this._eventState;
            state.mask = mask;
            state.target = target;
            state.currentTarget = currentTarget;
            state.skipNextObservers = false;
            state.lastReturnValue = eventData;
            state.userInfo = userInfo;
            for (const obs of this._observers) {
                if (obs._willBeUnregistered) {
                    continue;
                }
                if (obs.mask & mask) {
                    if (obs.unregisterOnNextCall) {
                        this._deferUnregister(obs);
                    }
                    if (obs.scope) {
                        state.lastReturnValue = obs.callback.apply(obs.scope, [eventData, state]);
                    }
                    else {
                        state.lastReturnValue = obs.callback(eventData, state);
                    }
                }
                if (state.skipNextObservers) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Notify a specific observer
         * @param observer defines the observer to notify
         * @param eventData defines the data to be sent to each callback
         * @param mask is used to filter observers defaults to -1
         */
        notifyObserver(observer, eventData, mask = -1) {
            // this prevents potential memory leaks - if an object is disposed but the observable doesn't get cleared.
            if (this.notifyIfTriggered) {
                this._hasNotified = true;
                this._lastNotifiedValue = eventData;
            }
            if (observer._willBeUnregistered) {
                return;
            }
            const state = this._eventState;
            state.mask = mask;
            state.skipNextObservers = false;
            if (observer.unregisterOnNextCall) {
                this._deferUnregister(observer);
            }
            observer.callback(eventData, state);
        }
        /**
         * Gets a boolean indicating if the observable has at least one observer
         * @returns true is the Observable has at least one Observer registered
         */
        hasObservers() {
            return this._observers.length - this._numObserversMarkedAsDeleted > 0;
        }
        /**
         * Clear the list of observers
         */
        clear() {
            while (this._observers.length) {
                const o = this._observers.pop();
                if (o) {
                    o._remove = null;
                }
            }
            this._onObserverAdded = null;
            this._numObserversMarkedAsDeleted = 0;
            this.cleanLastNotifiedState();
        }
        /**
         * Clean the last notified state - both the internal last value and the has-notified flag
         */
        cleanLastNotifiedState() {
            this._hasNotified = false;
            this._lastNotifiedValue = undefined;
        }
        /**
         * Clone the current observable
         * @returns a new observable
         */
        clone() {
            const result = new Observable$1();
            result._observers = this._observers.slice(0);
            return result;
        }
        /**
         * Does this observable handles observer registered with a given mask
         * @param mask defines the mask to be tested
         * @returns whether or not one observer registered with the given mask is handled
         **/
        hasSpecificMask(mask = -1) {
            for (const obs of this._observers) {
                if (obs.mask & mask || obs.mask === mask) {
                    return true;
                }
            }
            return false;
        }
    }

    /**
     * The engine store class is responsible to hold all the instances of Engine and Scene created
     * during the life time of the application.
     */
    class EngineStore {
        /**
         * Gets the latest created engine
         */
        static get LastCreatedEngine() {
            if (this.Instances.length === 0) {
                return null;
            }
            return this.Instances[this.Instances.length - 1];
        }
        /**
         * Gets the latest created scene
         */
        static get LastCreatedScene() {
            return this._LastCreatedScene;
        }
    }
    /** Gets the list of created engines */
    EngineStore.Instances = new Array();
    /**
     * Notifies when an engine was disposed.
     * Mainly used for static/cache cleanup
     */
    EngineStore.OnEnginesDisposedObservable = new Observable$1();
    /** @internal */
    EngineStore._LastCreatedScene = null;
    /**
     * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
     * @ignorenaming
     */
    EngineStore.UseFallbackTexture = true;
    /**
     * Texture content used if a texture cannot loaded
     * @ignorenaming
     */
    EngineStore.FallbackTexture = "";

    /* eslint-disable @typescript-eslint/naming-convention */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _ExtractAsInt = (value) => {
        return parseInt(value.toString().replace(/\W/g, ""));
    };
    /**
     * Class representing a vector containing 2 coordinates
     * Example Playground - Overview -  https://playground.babylonjs.com/#QYBWV4#9
     */
    class Vector2 {
        /**
         * Creates a new Vector2 from the given x and y coordinates
         * @param x defines the first coordinate
         * @param y defines the second coordinate
         */
        constructor(
        /** defines the first coordinate */
        x = 0, 
        /** defines the second coordinate */
        y = 0) {
            this.x = x;
            this.y = y;
        }
        /**
         * Gets a string with the Vector2 coordinates
         * @returns a string with the Vector2 coordinates
         */
        toString() {
            return `{X: ${this.x} Y: ${this.y}}`;
        }
        /**
         * Gets class name
         * @returns the string "Vector2"
         */
        getClassName() {
            return "Vector2";
        }
        /**
         * Gets current vector hash code
         * @returns the Vector2 hash code as a number
         */
        getHashCode() {
            const x = _ExtractAsInt(this.x);
            const y = _ExtractAsInt(this.y);
            let hash = x;
            hash = (hash * 397) ^ y;
            return hash;
        }
        // Operators
        /**
         * Sets the Vector2 coordinates in the given array or Float32Array from the given index.
         * Example Playground https://playground.babylonjs.com/#QYBWV4#15
         * @param array defines the source array
         * @param index defines the offset in source array
         * @returns the current Vector2
         */
        toArray(array, index = 0) {
            array[index] = this.x;
            array[index + 1] = this.y;
            return this;
        }
        /**
         * Update the current vector from an array
         * Example Playground https://playground.babylonjs.com/#QYBWV4#39
         * @param array defines the destination array
         * @param index defines the offset in the destination array
         * @returns the current Vector2
         */
        fromArray(array, index = 0) {
            Vector2.FromArrayToRef(array, index, this);
            return this;
        }
        /**
         * Copy the current vector to an array
         * Example Playground https://playground.babylonjs.com/#QYBWV4#40
         * @returns a new array with 2 elements: the Vector2 coordinates.
         */
        asArray() {
            const result = new Array();
            this.toArray(result, 0);
            return result;
        }
        /**
         * Sets the Vector2 coordinates with the given Vector2 coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#24
         * @param source defines the source Vector2
         * @returns the current updated Vector2
         */
        copyFrom(source) {
            this.x = source.x;
            this.y = source.y;
            return this;
        }
        /**
         * Sets the Vector2 coordinates with the given floats
         * Example Playground https://playground.babylonjs.com/#QYBWV4#25
         * @param x defines the first coordinate
         * @param y defines the second coordinate
         * @returns the current updated Vector2
         */
        copyFromFloats(x, y) {
            this.x = x;
            this.y = y;
            return this;
        }
        /**
         * Sets the Vector2 coordinates with the given floats
         * Example Playground https://playground.babylonjs.com/#QYBWV4#62
         * @param x defines the first coordinate
         * @param y defines the second coordinate
         * @returns the current updated Vector2
         */
        set(x, y) {
            return this.copyFromFloats(x, y);
        }
        /**
         * Add another vector with the current one
         * Example Playground https://playground.babylonjs.com/#QYBWV4#11
         * @param otherVector defines the other vector
         * @returns a new Vector2 set with the addition of the current Vector2 and the given one coordinates
         */
        add(otherVector) {
            return new this.constructor(this.x + otherVector.x, this.y + otherVector.y);
        }
        /**
         * Sets the "result" coordinates with the addition of the current Vector2 and the given one coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#12
         * @param otherVector defines the other vector
         * @param result defines the target vector
         * @returns result input
         */
        addToRef(otherVector, result) {
            result.x = this.x + otherVector.x;
            result.y = this.y + otherVector.y;
            return result;
        }
        /**
         * Set the Vector2 coordinates by adding the given Vector2 coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#13
         * @param otherVector defines the other vector
         * @returns the current updated Vector2
         */
        addInPlace(otherVector) {
            this.x += otherVector.x;
            this.y += otherVector.y;
            return this;
        }
        /**
         * Gets a new Vector2 by adding the current Vector2 coordinates to the given Vector3 x, y coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#14
         * @param otherVector defines the other vector
         * @returns a new Vector2
         */
        addVector3(otherVector) {
            return new this.constructor(this.x + otherVector.x, this.y + otherVector.y);
        }
        /**
         * Gets a new Vector2 set with the subtracted coordinates of the given one from the current Vector2
         * Example Playground https://playground.babylonjs.com/#QYBWV4#61
         * @param otherVector defines the other vector
         * @returns a new Vector2
         */
        subtract(otherVector) {
            return new this.constructor(this.x - otherVector.x, this.y - otherVector.y);
        }
        /**
         * Sets the "result" coordinates with the subtraction of the given one from the current Vector2 coordinates.
         * Example Playground https://playground.babylonjs.com/#QYBWV4#63
         * @param otherVector defines the other vector
         * @param result defines the target vector
         * @returns result input
         */
        subtractToRef(otherVector, result) {
            result.x = this.x - otherVector.x;
            result.y = this.y - otherVector.y;
            return result;
        }
        /**
         * Sets the current Vector2 coordinates by subtracting from it the given one coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#88
         * @param otherVector defines the other vector
         * @returns the current updated Vector2
         */
        subtractInPlace(otherVector) {
            this.x -= otherVector.x;
            this.y -= otherVector.y;
            return this;
        }
        /**
         * Multiplies in place the current Vector2 coordinates by the given ones
         * Example Playground https://playground.babylonjs.com/#QYBWV4#43
         * @param otherVector defines the other vector
         * @returns the current updated Vector2
         */
        multiplyInPlace(otherVector) {
            this.x *= otherVector.x;
            this.y *= otherVector.y;
            return this;
        }
        /**
         * Returns a new Vector2 set with the multiplication of the current Vector2 and the given one coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#42
         * @param otherVector defines the other vector
         * @returns a new Vector2
         */
        multiply(otherVector) {
            return new this.constructor(this.x * otherVector.x, this.y * otherVector.y);
        }
        /**
         * Sets "result" coordinates with the multiplication of the current Vector2 and the given one coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#44
         * @param otherVector defines the other vector
         * @param result defines the target vector
         * @returns result input
         */
        multiplyToRef(otherVector, result) {
            result.x = this.x * otherVector.x;
            result.y = this.y * otherVector.y;
            return result;
        }
        /**
         * Gets a new Vector2 set with the Vector2 coordinates multiplied by the given floats
         * Example Playground https://playground.babylonjs.com/#QYBWV4#89
         * @param x defines the first coordinate
         * @param y defines the second coordinate
         * @returns a new Vector2
         */
        multiplyByFloats(x, y) {
            return new this.constructor(this.x * x, this.y * y);
        }
        /**
         * Returns a new Vector2 set with the Vector2 coordinates divided by the given one coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#27
         * @param otherVector defines the other vector
         * @returns a new Vector2
         */
        divide(otherVector) {
            return new this.constructor(this.x / otherVector.x, this.y / otherVector.y);
        }
        /**
         * Sets the "result" coordinates with the Vector2 divided by the given one coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#30
         * @param otherVector defines the other vector
         * @param result defines the target vector
         * @returns result input
         */
        divideToRef(otherVector, result) {
            result.x = this.x / otherVector.x;
            result.y = this.y / otherVector.y;
            return result;
        }
        /**
         * Divides the current Vector2 coordinates by the given ones
         * Example Playground https://playground.babylonjs.com/#QYBWV4#28
         * @param otherVector defines the other vector
         * @returns the current updated Vector2
         */
        divideInPlace(otherVector) {
            return this.divideToRef(otherVector, this);
        }
        /**
         * Gets a new Vector2 with current Vector2 negated coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#22
         * @returns a new Vector2
         */
        negate() {
            return new this.constructor(-this.x, -this.y);
        }
        /**
         * Negate this vector in place
         * Example Playground https://playground.babylonjs.com/#QYBWV4#23
         * @returns this
         */
        negateInPlace() {
            this.x *= -1;
            this.y *= -1;
            return this;
        }
        /**
         * Negate the current Vector2 and stores the result in the given vector "result" coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#41
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        negateToRef(result) {
            return result.copyFromFloats(this.x * -1, this.y * -1);
        }
        /**
         * Multiply the Vector2 coordinates by
         * Example Playground https://playground.babylonjs.com/#QYBWV4#59
         * @param scale defines the scaling factor
         * @returns the current updated Vector2
         */
        scaleInPlace(scale) {
            this.x *= scale;
            this.y *= scale;
            return this;
        }
        /**
         * Returns a new Vector2 scaled by "scale" from the current Vector2
         * Example Playground https://playground.babylonjs.com/#QYBWV4#52
         * @param scale defines the scaling factor
         * @returns a new Vector2
         */
        scale(scale) {
            const result = new this.constructor(0, 0);
            this.scaleToRef(scale, result);
            return result;
        }
        /**
         * Scale the current Vector2 values by a factor to a given Vector2
         * Example Playground https://playground.babylonjs.com/#QYBWV4#57
         * @param scale defines the scale factor
         * @param result defines the Vector2 object where to store the result
         * @returns result input
         */
        scaleToRef(scale, result) {
            result.x = this.x * scale;
            result.y = this.y * scale;
            return result;
        }
        /**
         * Scale the current Vector2 values by a factor and add the result to a given Vector2
         * Example Playground https://playground.babylonjs.com/#QYBWV4#58
         * @param scale defines the scale factor
         * @param result defines the Vector2 object where to store the result
         * @returns result input
         */
        scaleAndAddToRef(scale, result) {
            result.x += this.x * scale;
            result.y += this.y * scale;
            return result;
        }
        /**
         * Gets a boolean if two vectors are equals
         * Example Playground https://playground.babylonjs.com/#QYBWV4#31
         * @param otherVector defines the other vector
         * @returns true if the given vector coordinates strictly equal the current Vector2 ones
         */
        equals(otherVector) {
            return otherVector && this.x === otherVector.x && this.y === otherVector.y;
        }
        /**
         * Gets a boolean if two vectors are equals (using an epsilon value)
         * Example Playground https://playground.babylonjs.com/#QYBWV4#32
         * @param otherVector defines the other vector
         * @param epsilon defines the minimal distance to consider equality
         * @returns true if the given vector coordinates are close to the current ones by a distance of epsilon.
         */
        equalsWithEpsilon(otherVector, epsilon = Epsilon) {
            return otherVector && Scalar.WithinEpsilon(this.x, otherVector.x, epsilon) && Scalar.WithinEpsilon(this.y, otherVector.y, epsilon);
        }
        /**
         * Gets a new Vector2 from current Vector2 floored values
         * Example Playground https://playground.babylonjs.com/#QYBWV4#35
         * eg (1.2, 2.31) returns (1, 2)
         * @returns a new Vector2
         */
        floor() {
            return new this.constructor(Math.floor(this.x), Math.floor(this.y));
        }
        /**
         * Gets a new Vector2 from current Vector2 fractional values
         * Example Playground https://playground.babylonjs.com/#QYBWV4#34
         * eg (1.2, 2.31) returns (0.2, 0.31)
         * @returns a new Vector2
         */
        fract() {
            return new this.constructor(this.x - Math.floor(this.x), this.y - Math.floor(this.y));
        }
        /**
         * Rotate the current vector into a given result vector
         * Example Playground https://playground.babylonjs.com/#QYBWV4#49
         * @param angle defines the rotation angle
         * @param result defines the result vector where to store the rotated vector
         * @returns result input
         */
        rotateToRef(angle, result) {
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            const x = cos * this.x - sin * this.y;
            const y = sin * this.x + cos * this.y;
            result.x = x;
            result.y = y;
            return result;
        }
        // Properties
        /**
         * Gets the length of the vector
         * @returns the vector length (float)
         */
        length() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        }
        /**
         * Gets the vector squared length
         * @returns the vector squared length (float)
         */
        lengthSquared() {
            return this.x * this.x + this.y * this.y;
        }
        // Methods
        /**
         * Normalize the vector
         * Example Playground https://playground.babylonjs.com/#QYBWV4#48
         * @returns the current updated Vector2
         */
        normalize() {
            Vector2.NormalizeToRef(this, this);
            return this;
        }
        /**
         * Gets a new Vector2 copied from the Vector2
         * Example Playground https://playground.babylonjs.com/#QYBWV4#20
         * @returns a new Vector2
         */
        clone() {
            return new this.constructor(this.x, this.y);
        }
        // Statics
        /**
         * Gets a new Vector2(0, 0)
         * @returns a new Vector2
         */
        static Zero() {
            return new Vector2(0, 0);
        }
        /**
         * Gets a new Vector2(1, 1)
         * @returns a new Vector2
         */
        static One() {
            return new Vector2(1, 1);
        }
        /**
         * Returns a new Vector2 with random values between min and max
         * @param min the minimum random value
         * @param max the maximum random value
         * @returns a Vector2 with random values between min and max
         */
        static Random(min = 0, max = 1) {
            return new Vector2(Scalar.RandomRange(min, max), Scalar.RandomRange(min, max));
        }
        /**
         * Gets a zero Vector2 that must not be updated
         */
        static get ZeroReadOnly() {
            return Vector2._ZeroReadOnly;
        }
        /**
         * Gets a new Vector2 set from the given index element of the given array
         * Example Playground https://playground.babylonjs.com/#QYBWV4#79
         * @param array defines the data source
         * @param offset defines the offset in the data source
         * @returns a new Vector2
         */
        static FromArray(array, offset = 0) {
            return new Vector2(array[offset], array[offset + 1]);
        }
        /**
         * Sets "result" from the given index element of the given array
         * Example Playground https://playground.babylonjs.com/#QYBWV4#80
         * @param array defines the data source
         * @param offset defines the offset in the data source
         * @param result defines the target vector
         * @returns result input
         */
        static FromArrayToRef(array, offset, result) {
            result.x = array[offset];
            result.y = array[offset + 1];
            return result;
        }
        /**
         * Gets a new Vector2 located for "amount" (float) on the CatmullRom spline defined by the given four Vector2
         * Example Playground https://playground.babylonjs.com/#QYBWV4#65
         * @param value1 defines 1st point of control
         * @param value2 defines 2nd point of control
         * @param value3 defines 3rd point of control
         * @param value4 defines 4th point of control
         * @param amount defines the interpolation factor
         * @returns a new Vector2
         */
        static CatmullRom(value1, value2, value3, value4, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const x = 0.5 *
                (2.0 * value2.x +
                    (-value1.x + value3.x) * amount +
                    (2.0 * value1.x - 5.0 * value2.x + 4.0 * value3.x - value4.x) * squared +
                    (-value1.x + 3.0 * value2.x - 3.0 * value3.x + value4.x) * cubed);
            const y = 0.5 *
                (2.0 * value2.y +
                    (-value1.y + value3.y) * amount +
                    (2.0 * value1.y - 5.0 * value2.y + 4.0 * value3.y - value4.y) * squared +
                    (-value1.y + 3.0 * value2.y - 3.0 * value3.y + value4.y) * cubed);
            return new value1.constructor(x, y);
        }
        /**
         * Returns a new Vector2 set with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max".
         * If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate.
         * If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate
         * Example Playground https://playground.babylonjs.com/#QYBWV4#76
         * @param value defines the value to clamp
         * @param min defines the lower limit
         * @param max defines the upper limit
         * @returns a new Vector2
         */
        static Clamp(value, min, max) {
            let x = value.x;
            x = x > max.x ? max.x : x;
            x = x < min.x ? min.x : x;
            let y = value.y;
            y = y > max.y ? max.y : y;
            y = y < min.y ? min.y : y;
            return new value.constructor(x, y);
        }
        /**
         * Returns a new Vector2 located for "amount" (float) on the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2"
         * Example Playground https://playground.babylonjs.com/#QYBWV4#81
         * @param value1 defines the 1st control point
         * @param tangent1 defines the outgoing tangent
         * @param value2 defines the 2nd control point
         * @param tangent2 defines the incoming tangent
         * @param amount defines the interpolation factor
         * @returns a new Vector2
         */
        static Hermite(value1, tangent1, value2, tangent2, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
            const part2 = -2.0 * cubed + 3.0 * squared;
            const part3 = cubed - 2.0 * squared + amount;
            const part4 = cubed - squared;
            const x = value1.x * part1 + value2.x * part2 + tangent1.x * part3 + tangent2.x * part4;
            const y = value1.y * part1 + value2.y * part2 + tangent1.y * part3 + tangent2.y * part4;
            return new value1.constructor(x, y);
        }
        /**
         * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
         * Example Playground https://playground.babylonjs.com/#QYBWV4#82
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @returns 1st derivative
         */
        static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
            const result = new value1.constructor();
            this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
            return result;
        }
        /**
         * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
         * Example Playground https://playground.babylonjs.com/#QYBWV4#83
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @param result define where the derivative will be stored
         * @returns result input
         */
        static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
            const t2 = time * time;
            result.x = (t2 - time) * 6 * value1.x + (3 * t2 - 4 * time + 1) * tangent1.x + (-t2 + time) * 6 * value2.x + (3 * t2 - 2 * time) * tangent2.x;
            result.y = (t2 - time) * 6 * value1.y + (3 * t2 - 4 * time + 1) * tangent1.y + (-t2 + time) * 6 * value2.y + (3 * t2 - 2 * time) * tangent2.y;
            return result;
        }
        /**
         * Returns a new Vector2 located for "amount" (float) on the linear interpolation between the vector "start" adn the vector "end".
         * Example Playground https://playground.babylonjs.com/#QYBWV4#84
         * @param start defines the start vector
         * @param end defines the end vector
         * @param amount defines the interpolation factor
         * @returns a new Vector2
         */
        static Lerp(start, end, amount) {
            const x = start.x + (end.x - start.x) * amount;
            const y = start.y + (end.y - start.y) * amount;
            return new start.constructor(x, y);
        }
        /**
         * Gets the dot product of the vector "left" and the vector "right"
         * Example Playground https://playground.babylonjs.com/#QYBWV4#90
         * @param left defines first vector
         * @param right defines second vector
         * @returns the dot product (float)
         */
        static Dot(left, right) {
            return left.x * right.x + left.y * right.y;
        }
        /**
         * Returns a new Vector2 equal to the normalized given vector
         * Example Playground https://playground.babylonjs.com/#QYBWV4#46
         * @param vector defines the vector to normalize
         * @returns a new Vector2
         */
        static Normalize(vector) {
            const newVector = new vector.constructor();
            this.NormalizeToRef(vector, newVector);
            return newVector;
        }
        /**
         * Normalize a given vector into a second one
         * Example Playground https://playground.babylonjs.com/#QYBWV4#50
         * @param vector defines the vector to normalize
         * @param result defines the vector where to store the result
         * @returns result input
         */
        static NormalizeToRef(vector, result) {
            const len = vector.length();
            if (len === 0) {
                return result;
            }
            result.x = vector.x / len;
            result.y = vector.y / len;
            return result;
        }
        /**
         * Gets a new Vector2 set with the minimal coordinate values from the "left" and "right" vectors
         * Example Playground https://playground.babylonjs.com/#QYBWV4#86
         * @param left defines 1st vector
         * @param right defines 2nd vector
         * @returns a new Vector2
         */
        static Minimize(left, right) {
            const x = left.x < right.x ? left.x : right.x;
            const y = left.y < right.y ? left.y : right.y;
            return new left.constructor(x, y);
        }
        /**
         * Gets a new Vector2 set with the maximal coordinate values from the "left" and "right" vectors
         * Example Playground https://playground.babylonjs.com/#QYBWV4#86
         * @param left defines 1st vector
         * @param right defines 2nd vector
         * @returns a new Vector2
         */
        static Maximize(left, right) {
            const x = left.x > right.x ? left.x : right.x;
            const y = left.y > right.y ? left.y : right.y;
            return new left.constructor(x, y);
        }
        /**
         * Gets a new Vector2 set with the transformed coordinates of the given vector by the given transformation matrix
         * Example Playground https://playground.babylonjs.com/#QYBWV4#17
         * @param vector defines the vector to transform
         * @param transformation defines the matrix to apply
         * @returns a new Vector2
         */
        static Transform(vector, transformation) {
            const result = new vector.constructor();
            Vector2.TransformToRef(vector, transformation, result);
            return result;
        }
        /**
         * Transforms the given vector coordinates by the given transformation matrix and stores the result in the vector "result" coordinates
         * Example Playground https://playground.babylonjs.com/#QYBWV4#19
         * @param vector defines the vector to transform
         * @param transformation defines the matrix to apply
         * @param result defines the target vector
         * @returns result input
         */
        static TransformToRef(vector, transformation, result) {
            const m = transformation.m;
            const x = vector.x * m[0] + vector.y * m[4] + m[12];
            const y = vector.x * m[1] + vector.y * m[5] + m[13];
            result.x = x;
            result.y = y;
            return result;
        }
        /**
         * Determines if a given vector is included in a triangle
         * Example Playground https://playground.babylonjs.com/#QYBWV4#87
         * @param p defines the vector to test
         * @param p0 defines 1st triangle point
         * @param p1 defines 2nd triangle point
         * @param p2 defines 3rd triangle point
         * @returns true if the point "p" is in the triangle defined by the vectors "p0", "p1", "p2"
         */
        static PointInTriangle(p, p0, p1, p2) {
            const a = (1 / 2) * (-p1.y * p2.x + p0.y * (-p1.x + p2.x) + p0.x * (p1.y - p2.y) + p1.x * p2.y);
            const sign = a < 0 ? -1 : 1;
            const s = (p0.y * p2.x - p0.x * p2.y + (p2.y - p0.y) * p.x + (p0.x - p2.x) * p.y) * sign;
            const t = (p0.x * p1.y - p0.y * p1.x + (p0.y - p1.y) * p.x + (p1.x - p0.x) * p.y) * sign;
            return s > 0 && t > 0 && s + t < 2 * a * sign;
        }
        /**
         * Gets the distance between the vectors "value1" and "value2"
         * Example Playground https://playground.babylonjs.com/#QYBWV4#71
         * @param value1 defines first vector
         * @param value2 defines second vector
         * @returns the distance between vectors
         */
        static Distance(value1, value2) {
            return Math.sqrt(Vector2.DistanceSquared(value1, value2));
        }
        /**
         * Returns the squared distance between the vectors "value1" and "value2"
         * Example Playground https://playground.babylonjs.com/#QYBWV4#72
         * @param value1 defines first vector
         * @param value2 defines second vector
         * @returns the squared distance between vectors
         */
        static DistanceSquared(value1, value2) {
            const x = value1.x - value2.x;
            const y = value1.y - value2.y;
            return x * x + y * y;
        }
        /**
         * Gets a new Vector2 located at the center of the vectors "value1" and "value2"
         * Example Playground https://playground.babylonjs.com/#QYBWV4#86
         * Example Playground https://playground.babylonjs.com/#QYBWV4#66
         * @param value1 defines first vector
         * @param value2 defines second vector
         * @returns a new Vector2
         */
        static Center(value1, value2) {
            const result = new value1.constructor();
            return Vector2.CenterToRef(value1, value2, result);
        }
        /**
         * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
         * Example Playground https://playground.babylonjs.com/#QYBWV4#66
         * @param value1 defines first vector
         * @param value2 defines second vector
         * @param ref defines third vector
         * @returns ref
         */
        static CenterToRef(value1, value2, ref) {
            return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2);
        }
        /**
         * Gets the shortest distance (float) between the point "p" and the segment defined by the two points "segA" and "segB".
         * Example Playground https://playground.babylonjs.com/#QYBWV4#77
         * @param p defines the middle point
         * @param segA defines one point of the segment
         * @param segB defines the other point of the segment
         * @returns the shortest distance
         */
        static DistanceOfPointFromSegment(p, segA, segB) {
            const l2 = Vector2.DistanceSquared(segA, segB);
            if (l2 === 0.0) {
                return Vector2.Distance(p, segA);
            }
            const v = segB.subtract(segA);
            const t = Math.max(0, Math.min(1, Vector2.Dot(p.subtract(segA), v) / l2));
            const proj = segA.add(v.multiplyByFloats(t, t));
            return Vector2.Distance(p, proj);
        }
    }
    Vector2._ZeroReadOnly = Vector2.Zero();
    /**
     * Class used to store (x,y,z) vector representation
     * A Vector3 is the main object used in 3D geometry
     * It can represent either the coordinates of a point the space, either a direction
     * Reminder: js uses a left handed forward facing system
     * Example Playground - Overview - https://playground.babylonjs.com/#R1F8YU
     */
    class Vector3 {
        /** Gets or sets the x coordinate */
        get x() {
            return this._x;
        }
        set x(value) {
            this._x = value;
            this._isDirty = true;
        }
        /** Gets or sets the y coordinate */
        get y() {
            return this._y;
        }
        set y(value) {
            this._y = value;
            this._isDirty = true;
        }
        /** Gets or sets the z coordinate */
        get z() {
            return this._z;
        }
        set z(value) {
            this._z = value;
            this._isDirty = true;
        }
        /**
         * Creates a new Vector3 object from the given x, y, z (floats) coordinates.
         * @param x defines the first coordinates (on X axis)
         * @param y defines the second coordinates (on Y axis)
         * @param z defines the third coordinates (on Z axis)
         */
        constructor(x = 0, y = 0, z = 0) {
            /** @internal */
            this._isDirty = true;
            this._x = x;
            this._y = y;
            this._z = z;
        }
        /**
         * Creates a string representation of the Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#67
         * @returns a string with the Vector3 coordinates.
         */
        toString() {
            return `{X: ${this._x} Y: ${this._y} Z: ${this._z}}`;
        }
        /**
         * Gets the class name
         * @returns the string "Vector3"
         */
        getClassName() {
            return "Vector3";
        }
        /**
         * Creates the Vector3 hash code
         * @returns a number which tends to be unique between Vector3 instances
         */
        getHashCode() {
            const x = _ExtractAsInt(this._x);
            const y = _ExtractAsInt(this._y);
            const z = _ExtractAsInt(this._z);
            let hash = x;
            hash = (hash * 397) ^ y;
            hash = (hash * 397) ^ z;
            return hash;
        }
        // Operators
        /**
         * Creates an array containing three elements : the coordinates of the Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#10
         * @returns a new array of numbers
         */
        asArray() {
            const result = [];
            this.toArray(result, 0);
            return result;
        }
        /**
         * Populates the given array or Float32Array from the given index with the successive coordinates of the Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#65
         * @param array defines the destination array
         * @param index defines the offset in the destination array
         * @returns the current Vector3
         */
        toArray(array, index = 0) {
            array[index] = this._x;
            array[index + 1] = this._y;
            array[index + 2] = this._z;
            return this;
        }
        /**
         * Update the current vector from an array
         * Example Playground https://playground.babylonjs.com/#R1F8YU#24
         * @param array defines the destination array
         * @param index defines the offset in the destination array
         * @returns the current Vector3
         */
        fromArray(array, index = 0) {
            Vector3.FromArrayToRef(array, index, this);
            return this;
        }
        /**
         * Converts the current Vector3 into a quaternion (considering that the Vector3 contains Euler angles representation of a rotation)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#66
         * @returns a new Quaternion object, computed from the Vector3 coordinates
         */
        toQuaternion() {
            return Quaternion.RotationYawPitchRoll(this._y, this._x, this._z);
        }
        /**
         * Adds the given vector to the current Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#4
         * @param otherVector defines the second operand
         * @returns the current updated Vector3
         */
        addInPlace(otherVector) {
            return this.addInPlaceFromFloats(otherVector._x, otherVector._y, otherVector._z);
        }
        /**
         * Adds the given coordinates to the current Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#5
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the current updated Vector3
         */
        addInPlaceFromFloats(x, y, z) {
            this._x += x;
            this._y += y;
            this._z += z;
            this._isDirty = true;
            return this;
        }
        /**
         * Gets a new Vector3, result of the addition the current Vector3 and the given vector
         * Example Playground https://playground.babylonjs.com/#R1F8YU#3
         * @param otherVector defines the second operand
         * @returns the resulting Vector3
         */
        add(otherVector) {
            return new this.constructor(this._x + otherVector._x, this._y + otherVector._y, this._z + otherVector._z);
        }
        /**
         * Adds the current Vector3 to the given one and stores the result in the vector "result"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#6
         * @param otherVector defines the second operand
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        addToRef(otherVector, result) {
            return result.copyFromFloats(this._x + otherVector._x, this._y + otherVector._y, this._z + otherVector._z);
        }
        /**
         * Subtract the given vector from the current Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#61
         * @param otherVector defines the second operand
         * @returns the current updated Vector3
         */
        subtractInPlace(otherVector) {
            this._x -= otherVector._x;
            this._y -= otherVector._y;
            this._z -= otherVector._z;
            this._isDirty = true;
            return this;
        }
        /**
         * Returns a new Vector3, result of the subtraction of the given vector from the current Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#60
         * @param otherVector defines the second operand
         * @returns the resulting Vector3
         */
        subtract(otherVector) {
            return new this.constructor(this._x - otherVector._x, this._y - otherVector._y, this._z - otherVector._z);
        }
        /**
         * Subtracts the given vector from the current Vector3 and stores the result in the vector "result".
         * Example Playground https://playground.babylonjs.com/#R1F8YU#63
         * @param otherVector defines the second operand
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        subtractToRef(otherVector, result) {
            return this.subtractFromFloatsToRef(otherVector._x, otherVector._y, otherVector._z, result);
        }
        /**
         * Returns a new Vector3 set with the subtraction of the given floats from the current Vector3 coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#62
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the resulting Vector3
         */
        subtractFromFloats(x, y, z) {
            return new this.constructor(this._x - x, this._y - y, this._z - z);
        }
        /**
         * Subtracts the given floats from the current Vector3 coordinates and set the given vector "result" with this result
         * Example Playground https://playground.babylonjs.com/#R1F8YU#64
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        subtractFromFloatsToRef(x, y, z, result) {
            return result.copyFromFloats(this._x - x, this._y - y, this._z - z);
        }
        /**
         * Gets a new Vector3 set with the current Vector3 negated coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#35
         * @returns a new Vector3
         */
        negate() {
            return new this.constructor(-this._x, -this._y, -this._z);
        }
        /**
         * Negate this vector in place
         * Example Playground https://playground.babylonjs.com/#R1F8YU#36
         * @returns this
         */
        negateInPlace() {
            this._x *= -1;
            this._y *= -1;
            this._z *= -1;
            this._isDirty = true;
            return this;
        }
        /**
         * Negate the current Vector3 and stores the result in the given vector "result" coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#37
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        negateToRef(result) {
            return result.copyFromFloats(this._x * -1, this._y * -1, this._z * -1);
        }
        /**
         * Multiplies the Vector3 coordinates by the float "scale"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#56
         * @param scale defines the multiplier factor
         * @returns the current updated Vector3
         */
        scaleInPlace(scale) {
            this._x *= scale;
            this._y *= scale;
            this._z *= scale;
            this._isDirty = true;
            return this;
        }
        /**
         * Returns a new Vector3 set with the current Vector3 coordinates multiplied by the float "scale"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#53
         * @param scale defines the multiplier factor
         * @returns a new Vector3
         */
        scale(scale) {
            return new this.constructor(this._x * scale, this._y * scale, this._z * scale);
        }
        /**
         * Multiplies the current Vector3 coordinates by the float "scale" and stores the result in the given vector "result" coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#57
         * @param scale defines the multiplier factor
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        scaleToRef(scale, result) {
            return result.copyFromFloats(this._x * scale, this._y * scale, this._z * scale);
        }
        /**
         * Creates a vector normal (perpendicular) to the current Vector3 and stores the result in the given vector
         * Out of the infinite possibilities the normal chosen is the one formed by rotating the current vector
         * 90 degrees about an axis which lies perpendicular to the current vector
         * and its projection on the xz plane. In the case of a current vector in the xz plane
         * the normal is calculated to be along the y axis.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#230
         * Example Playground https://playground.babylonjs.com/#R1F8YU#231
         * @param result defines the Vector3 object where to store the resultant normal
         * returns the result
         */
        getNormalToRef(result) {
            /**
             * Calculates the spherical coordinates of the current vector
             * so saves on memory rather than importing whole Spherical Class
             */
            const radius = this.length();
            let theta = Math.acos(this.y / radius);
            const phi = Math.atan2(this.z, this.x);
            //makes angle 90 degs to current vector
            if (theta > Math.PI / 2) {
                theta -= Math.PI / 2;
            }
            else {
                theta += Math.PI / 2;
            }
            //Calculates resutant normal vector from spherical coordinate of perpendicular vector
            const x = radius * Math.sin(theta) * Math.cos(phi);
            const y = radius * Math.cos(theta);
            const z = radius * Math.sin(theta) * Math.sin(phi);
            result.set(x, y, z);
            return result;
        }
        /**
         * Rotates the vector using the given unit quaternion and stores the new vector in result
         * Example Playground https://playground.babylonjs.com/#R1F8YU#9
         * @param q the unit quaternion representing the rotation
         * @param result the output vector
         * @returns the result
         */
        applyRotationQuaternionToRef(q, result) {
            // Derived from https://raw.org/proof/vector-rotation-using-quaternions/
            const vx = this._x, vy = this._y, vz = this._z;
            const qx = q._x, qy = q._y, qz = q._z, qw = q._w;
            // t = 2q x v
            const tx = 2 * (qy * vz - qz * vy);
            const ty = 2 * (qz * vx - qx * vz);
            const tz = 2 * (qx * vy - qy * vx);
            // v + w t + q x t
            result._x = vx + qw * tx + qy * tz - qz * ty;
            result._y = vy + qw * ty + qz * tx - qx * tz;
            result._z = vz + qw * tz + qx * ty - qy * tx;
            result._isDirty = true;
            return result;
        }
        /**
         * Rotates the vector in place using the given unit quaternion
         * Example Playground https://playground.babylonjs.com/#R1F8YU#8
         * @param q the unit quaternion representing the rotation
         * @returns the current updated Vector3
         */
        applyRotationQuaternionInPlace(q) {
            return this.applyRotationQuaternionToRef(q, this);
        }
        /**
         * Rotates the vector using the given unit quaternion and returns the new vector
         * Example Playground https://playground.babylonjs.com/#R1F8YU#7
         * @param q the unit quaternion representing the rotation
         * @returns a new Vector3
         */
        applyRotationQuaternion(q) {
            return this.applyRotationQuaternionToRef(q, new this.constructor());
        }
        /**
         * Scale the current Vector3 values by a factor and add the result to a given Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#55
         * @param scale defines the scale factor
         * @param result defines the Vector3 object where to store the result
         * @returns result input
         */
        scaleAndAddToRef(scale, result) {
            return result.addInPlaceFromFloats(this._x * scale, this._y * scale, this._z * scale);
        }
        /**
         * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#48
         * @param plane defines the plane to project to
         * @param origin defines the origin of the projection ray
         * @returns the projected vector3
         */
        projectOnPlane(plane, origin) {
            const result = new this.constructor();
            this.projectOnPlaneToRef(plane, origin, result);
            return result;
        }
        /**
         * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#49
         * @param plane defines the plane to project to
         * @param origin defines the origin of the projection ray
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        projectOnPlaneToRef(plane, origin, result) {
            const n = plane.normal;
            const d = plane.d;
            const V = MathTmp.Vector3[0];
            // ray direction
            this.subtractToRef(origin, V);
            V.normalize();
            const denom = Vector3.Dot(V, n);
            //When the ray is close to parallel to the plane return infinity vector
            if (Math.abs(denom) < Math.pow(10, -10)) {
                result.setAll(Infinity);
            }
            else {
                const t = -(Vector3.Dot(origin, n) + d) / denom;
                // P = P0 + t*V
                const scaledV = V.scaleInPlace(t);
                origin.addToRef(scaledV, result);
            }
            return result;
        }
        /**
         * Returns true if the current Vector3 and the given vector coordinates are strictly equal
         * Example Playground https://playground.babylonjs.com/#R1F8YU#19
         * @param otherVector defines the second operand
         * @returns true if both vectors are equals
         */
        equals(otherVector) {
            return otherVector && this._x === otherVector._x && this._y === otherVector._y && this._z === otherVector._z;
        }
        /**
         * Returns true if the current Vector3 and the given vector coordinates are distant less than epsilon
         * Example Playground https://playground.babylonjs.com/#R1F8YU#21
         * @param otherVector defines the second operand
         * @param epsilon defines the minimal distance to define values as equals
         * @returns true if both vectors are distant less than epsilon
         */
        equalsWithEpsilon(otherVector, epsilon = Epsilon) {
            return (otherVector &&
                Scalar.WithinEpsilon(this._x, otherVector._x, epsilon) &&
                Scalar.WithinEpsilon(this._y, otherVector._y, epsilon) &&
                Scalar.WithinEpsilon(this._z, otherVector._z, epsilon));
        }
        /**
         * Returns true if the current Vector3 coordinates equals the given floats
         * Example Playground https://playground.babylonjs.com/#R1F8YU#20
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns true if both vectors are equal
         */
        equalsToFloats(x, y, z) {
            return this._x === x && this._y === y && this._z === z;
        }
        /**
         * Multiplies the current Vector3 coordinates by the given ones
         * Example Playground https://playground.babylonjs.com/#R1F8YU#32
         * @param otherVector defines the second operand
         * @returns the current updated Vector3
         */
        multiplyInPlace(otherVector) {
            this._x *= otherVector._x;
            this._y *= otherVector._y;
            this._z *= otherVector._z;
            this._isDirty = true;
            return this;
        }
        /**
         * Returns a new Vector3, result of the multiplication of the current Vector3 by the given vector
         * Example Playground https://playground.babylonjs.com/#R1F8YU#31
         * @param otherVector defines the second operand
         * @returns the new Vector3
         */
        multiply(otherVector) {
            return this.multiplyByFloats(otherVector._x, otherVector._y, otherVector._z);
        }
        /**
         * Multiplies the current Vector3 by the given one and stores the result in the given vector "result"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#33
         * @param otherVector defines the second operand
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        multiplyToRef(otherVector, result) {
            return result.copyFromFloats(this._x * otherVector._x, this._y * otherVector._y, this._z * otherVector._z);
        }
        /**
         * Returns a new Vector3 set with the result of the multiplication of the current Vector3 coordinates by the given floats
         * Example Playground https://playground.babylonjs.com/#R1F8YU#34
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the new Vector3
         */
        multiplyByFloats(x, y, z) {
            return new this.constructor(this._x * x, this._y * y, this._z * z);
        }
        /**
         * Returns a new Vector3 set with the result of the division of the current Vector3 coordinates by the given ones
         * Example Playground https://playground.babylonjs.com/#R1F8YU#16
         * @param otherVector defines the second operand
         * @returns the new Vector3
         */
        divide(otherVector) {
            return new this.constructor(this._x / otherVector._x, this._y / otherVector._y, this._z / otherVector._z);
        }
        /**
         * Divides the current Vector3 coordinates by the given ones and stores the result in the given vector "result"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#18
         * @param otherVector defines the second operand
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        divideToRef(otherVector, result) {
            return result.copyFromFloats(this._x / otherVector._x, this._y / otherVector._y, this._z / otherVector._z);
        }
        /**
         * Divides the current Vector3 coordinates by the given ones.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#17
         * @param otherVector defines the second operand
         * @returns the current updated Vector3
         */
        divideInPlace(otherVector) {
            return this.divideToRef(otherVector, this);
        }
        /**
         * Updates the current Vector3 with the minimal coordinate values between its and the given vector ones
         * Example Playground https://playground.babylonjs.com/#R1F8YU#29
         * @param other defines the second operand
         * @returns the current updated Vector3
         */
        minimizeInPlace(other) {
            return this.minimizeInPlaceFromFloats(other._x, other._y, other._z);
        }
        /**
         * Updates the current Vector3 with the maximal coordinate values between its and the given vector ones.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#27
         * @param other defines the second operand
         * @returns the current updated Vector3
         */
        maximizeInPlace(other) {
            return this.maximizeInPlaceFromFloats(other._x, other._y, other._z);
        }
        /**
         * Updates the current Vector3 with the minimal coordinate values between its and the given coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#30
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the current updated Vector3
         */
        minimizeInPlaceFromFloats(x, y, z) {
            if (x < this._x) {
                this.x = x;
            }
            if (y < this._y) {
                this.y = y;
            }
            if (z < this._z) {
                this.z = z;
            }
            return this;
        }
        /**
         * Updates the current Vector3 with the maximal coordinate values between its and the given coordinates.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#28
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the current updated Vector3
         */
        maximizeInPlaceFromFloats(x, y, z) {
            if (x > this._x) {
                this.x = x;
            }
            if (y > this._y) {
                this.y = y;
            }
            if (z > this._z) {
                this.z = z;
            }
            return this;
        }
        /**
         * Due to float precision, scale of a mesh could be uniform but float values are off by a small fraction
         * Check if is non uniform within a certain amount of decimal places to account for this
         * @param epsilon the amount the values can differ
         * @returns if the the vector is non uniform to a certain number of decimal places
         */
        isNonUniformWithinEpsilon(epsilon) {
            const absX = Math.abs(this._x);
            const absY = Math.abs(this._y);
            if (!Scalar.WithinEpsilon(absX, absY, epsilon)) {
                return true;
            }
            const absZ = Math.abs(this._z);
            if (!Scalar.WithinEpsilon(absX, absZ, epsilon)) {
                return true;
            }
            if (!Scalar.WithinEpsilon(absY, absZ, epsilon)) {
                return true;
            }
            return false;
        }
        /**
         * Gets a boolean indicating that the vector is non uniform meaning x, y or z are not all the same
         */
        get isNonUniform() {
            const absX = Math.abs(this._x);
            const absY = Math.abs(this._y);
            if (absX !== absY) {
                return true;
            }
            const absZ = Math.abs(this._z);
            if (absX !== absZ) {
                return true;
            }
            return false;
        }
        /**
         * Gets a new Vector3 from current Vector3 floored values
         * Example Playground https://playground.babylonjs.com/#R1F8YU#22
         * @returns a new Vector3
         */
        floor() {
            return new this.constructor(Math.floor(this._x), Math.floor(this._y), Math.floor(this._z));
        }
        /**
         * Gets a new Vector3 from current Vector3 fractional values
         * Example Playground https://playground.babylonjs.com/#R1F8YU#23
         * @returns a new Vector3
         */
        fract() {
            return new this.constructor(this._x - Math.floor(this._x), this._y - Math.floor(this._y), this._z - Math.floor(this._z));
        }
        // Properties
        /**
         * Gets the length of the Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#25
         * @returns the length of the Vector3
         */
        length() {
            return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z);
        }
        /**
         * Gets the squared length of the Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#26
         * @returns squared length of the Vector3
         */
        lengthSquared() {
            return this._x * this._x + this._y * this._y + this._z * this._z;
        }
        /**
         * Gets a boolean indicating if the vector contains a zero in one of its components
         * Example Playground https://playground.babylonjs.com/#R1F8YU#1
         */
        get hasAZeroComponent() {
            return this._x * this._y * this._z === 0;
        }
        /**
         * Normalize the current Vector3.
         * Please note that this is an in place operation.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#122
         * @returns the current updated Vector3
         */
        normalize() {
            return this.normalizeFromLength(this.length());
        }
        /**
         * Reorders the x y z properties of the vector in place
         * Example Playground https://playground.babylonjs.com/#R1F8YU#44
         * @param order new ordering of the properties (eg. for vector 1,2,3 with "ZYX" will produce 3,2,1)
         * @returns the current updated vector
         */
        reorderInPlace(order) {
            order = order.toLowerCase();
            if (order === "xyz") {
                return this;
            }
            MathTmp.Vector3[0].copyFrom(this);
            ["x", "y", "z"].forEach((val, i) => {
                this[val] = MathTmp.Vector3[0][order[i]];
            });
            return this;
        }
        /**
         * Rotates the vector around 0,0,0 by a quaternion
         * Example Playground https://playground.babylonjs.com/#R1F8YU#47
         * @param quaternion the rotation quaternion
         * @param result vector to store the result
         * @returns the resulting vector
         */
        rotateByQuaternionToRef(quaternion, result) {
            quaternion.toRotationMatrix(MathTmp.Matrix[0]);
            Vector3.TransformCoordinatesToRef(this, MathTmp.Matrix[0], result);
            return result;
        }
        /**
         * Rotates a vector around a given point
         * Example Playground https://playground.babylonjs.com/#R1F8YU#46
         * @param quaternion the rotation quaternion
         * @param point the point to rotate around
         * @param result vector to store the result
         * @returns the resulting vector
         */
        rotateByQuaternionAroundPointToRef(quaternion, point, result) {
            this.subtractToRef(point, MathTmp.Vector3[0]);
            MathTmp.Vector3[0].rotateByQuaternionToRef(quaternion, MathTmp.Vector3[0]);
            point.addToRef(MathTmp.Vector3[0], result);
            return result;
        }
        /**
         * Returns a new Vector3 as the cross product of the current vector and the "other" one
         * The cross product is then orthogonal to both current and "other"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#14
         * @param other defines the right operand
         * @returns the cross product
         */
        cross(other) {
            const result = new this.constructor();
            return Vector3.CrossToRef(this, other, result);
        }
        /**
         * Normalize the current Vector3 with the given input length.
         * Please note that this is an in place operation.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#123
         * @param len the length of the vector
         * @returns the current updated Vector3
         */
        normalizeFromLength(len) {
            if (len === 0 || len === 1.0) {
                return this;
            }
            return this.scaleInPlace(1.0 / len);
        }
        /**
         * Normalize the current Vector3 to a new vector
         * Example Playground https://playground.babylonjs.com/#R1F8YU#124
         * @returns the new Vector3
         */
        normalizeToNew() {
            const normalized = new this.constructor(0, 0, 0);
            this.normalizeToRef(normalized);
            return normalized;
        }
        /**
         * Normalize the current Vector3 to the reference
         * Example Playground https://playground.babylonjs.com/#R1F8YU#125
         * @param reference define the Vector3 to update
         * @returns the updated Vector3
         */
        normalizeToRef(reference) {
            const len = this.length();
            if (len === 0 || len === 1.0) {
                return reference.copyFromFloats(this._x, this._y, this._z);
            }
            return this.scaleToRef(1.0 / len, reference);
        }
        /**
         * Creates a new Vector3 copied from the current Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#11
         * @returns the new Vector3
         */
        clone() {
            return new this.constructor(this._x, this._y, this._z);
        }
        /**
         * Copies the given vector coordinates to the current Vector3 ones
         * Example Playground https://playground.babylonjs.com/#R1F8YU#12
         * @param source defines the source Vector3
         * @returns the current updated Vector3
         */
        copyFrom(source) {
            return this.copyFromFloats(source._x, source._y, source._z);
        }
        /**
         * Copies the given floats to the current Vector3 coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#13
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the current updated Vector3
         */
        copyFromFloats(x, y, z) {
            this._x = x;
            this._y = y;
            this._z = z;
            this._isDirty = true;
            return this;
        }
        /**
         * Copies the given floats to the current Vector3 coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#58
         * @param x defines the x coordinate of the operand
         * @param y defines the y coordinate of the operand
         * @param z defines the z coordinate of the operand
         * @returns the current updated Vector3
         */
        set(x, y, z) {
            return this.copyFromFloats(x, y, z);
        }
        /**
         * Copies the given float to the current Vector3 coordinates
         * Example Playground https://playground.babylonjs.com/#R1F8YU#59
         * @param v defines the x, y and z coordinates of the operand
         * @returns the current updated Vector3
         */
        setAll(v) {
            this._x = this._y = this._z = v;
            this._isDirty = true;
            return this;
        }
        // Statics
        /**
         * Get the clip factor between two vectors
         * Example Playground https://playground.babylonjs.com/#R1F8YU#126
         * @param vector0 defines the first operand
         * @param vector1 defines the second operand
         * @param axis defines the axis to use
         * @param size defines the size along the axis
         * @returns the clip factor
         */
        static GetClipFactor(vector0, vector1, axis, size) {
            const d0 = Vector3.Dot(vector0, axis) - size;
            const d1 = Vector3.Dot(vector1, axis) - size;
            const s = d0 / (d0 - d1);
            return s;
        }
        /**
         * Get angle between two vectors
         * Example Playground https://playground.babylonjs.com/#R1F8YU#86
         * @param vector0 the starting point
         * @param vector1 the ending point
         * @param normal direction of the normal
         * @returns the angle between vector0 and vector1
         */
        static GetAngleBetweenVectors(vector0, vector1, normal) {
            const v0 = vector0.normalizeToRef(MathTmp.Vector3[1]);
            const v1 = vector1.normalizeToRef(MathTmp.Vector3[2]);
            let dot = Vector3.Dot(v0, v1);
            // Vectors are normalized so dot will be in [-1, 1] (aside precision issues enough to break the result which explains the below clamp)
            dot = Scalar.Clamp(dot, -1, 1);
            const angle = Math.acos(dot);
            const n = MathTmp.Vector3[3];
            Vector3.CrossToRef(v0, v1, n);
            if (Vector3.Dot(n, normal) > 0) {
                return isNaN(angle) ? 0 : angle;
            }
            return isNaN(angle) ? -Math.PI : -Math.acos(dot);
        }
        /**
         * Get angle between two vectors projected on a plane
         * Example Playground https://playground.babylonjs.com/#R1F8YU#87
         * Expectation compute time: 0.01 ms (median) and 0.02 ms (percentile 95%)
         * @param vector0 angle between vector0 and vector1
         * @param vector1 angle between vector0 and vector1
         * @param normal Normal of the projection plane
         * @returns the angle in radians (float) between vector0 and vector1 projected on the plane with the specified normal
         */
        static GetAngleBetweenVectorsOnPlane(vector0, vector1, normal) {
            MathTmp.Vector3[0].copyFrom(vector0);
            const v0 = MathTmp.Vector3[0];
            MathTmp.Vector3[1].copyFrom(vector1);
            const v1 = MathTmp.Vector3[1];
            MathTmp.Vector3[2].copyFrom(normal);
            const vNormal = MathTmp.Vector3[2];
            const right = MathTmp.Vector3[3];
            const forward = MathTmp.Vector3[4];
            v0.normalize();
            v1.normalize();
            vNormal.normalize();
            Vector3.CrossToRef(vNormal, v0, right);
            Vector3.CrossToRef(right, vNormal, forward);
            const angle = Math.atan2(Vector3.Dot(v1, right), Vector3.Dot(v1, forward));
            return Scalar.NormalizeRadians(angle);
        }
        /**
         * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point and stores it in the ref Vector3
         * Example PG https://playground.babylonjs.com/#R1F8YU#189
         * @param start the starting point
         * @param target the target point
         * @param ref the vector3 to store the result
         * @returns ref in the form (pitch, yaw, 0)
         */
        static PitchYawRollToMoveBetweenPointsToRef(start, target, ref) {
            const diff = TmpVectors.Vector3[0];
            target.subtractToRef(start, diff);
            ref._y = Math.atan2(diff.x, diff.z) || 0;
            ref._x = Math.atan2(Math.sqrt(diff.x ** 2 + diff.z ** 2), diff.y) || 0;
            ref._z = 0;
            ref._isDirty = true;
            return ref;
        }
        /**
         * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point
         * Example PG https://playground.babylonjs.com/#R1F8YU#188
         * @param start the starting point
         * @param target the target point
         * @returns the rotation in the form (pitch, yaw, 0)
         */
        static PitchYawRollToMoveBetweenPoints(start, target) {
            const ref = Vector3.Zero();
            return Vector3.PitchYawRollToMoveBetweenPointsToRef(start, target, ref);
        }
        /**
         * Slerp between two vectors. See also `SmoothToRef`
         * Slerp is a spherical linear interpolation
         * giving a slow in and out effect
         * Example Playground 1 https://playground.babylonjs.com/#R1F8YU#108
         * Example Playground 2 https://playground.babylonjs.com/#R1F8YU#109
         * @param vector0 Start vector
         * @param vector1 End vector
         * @param slerp amount (will be clamped between 0 and 1)
         * @param result The slerped vector
         */
        static SlerpToRef(vector0, vector1, slerp, result) {
            slerp = Scalar.Clamp(slerp, 0, 1);
            const vector0Dir = MathTmp.Vector3[0];
            const vector1Dir = MathTmp.Vector3[1];
            vector0Dir.copyFrom(vector0);
            const vector0Length = vector0Dir.length();
            vector0Dir.normalizeFromLength(vector0Length);
            vector1Dir.copyFrom(vector1);
            const vector1Length = vector1Dir.length();
            vector1Dir.normalizeFromLength(vector1Length);
            const dot = Vector3.Dot(vector0Dir, vector1Dir);
            let scale0;
            let scale1;
            if (dot < 1 - Epsilon) {
                const omega = Math.acos(dot);
                const invSin = 1 / Math.sin(omega);
                scale0 = Math.sin((1 - slerp) * omega) * invSin;
                scale1 = Math.sin(slerp * omega) * invSin;
            }
            else {
                // Use linear interpolation
                scale0 = 1 - slerp;
                scale1 = slerp;
            }
            vector0Dir.scaleInPlace(scale0);
            vector1Dir.scaleInPlace(scale1);
            result.copyFrom(vector0Dir).addInPlace(vector1Dir);
            result.scaleInPlace(Scalar.Lerp(vector0Length, vector1Length, slerp));
            return result;
        }
        /**
         * Smooth interpolation between two vectors using Slerp
         * Example Playground https://playground.babylonjs.com/#R1F8YU#110
         * @param source source vector
         * @param goal goal vector
         * @param deltaTime current interpolation frame
         * @param lerpTime total interpolation time
         * @param result the smoothed vector
         */
        static SmoothToRef(source, goal, deltaTime, lerpTime, result) {
            Vector3.SlerpToRef(source, goal, lerpTime === 0 ? 1 : deltaTime / lerpTime, result);
            return result;
        }
        /**
         * Returns a new Vector3 set from the index "offset" of the given array
         * Example Playground https://playground.babylonjs.com/#R1F8YU#83
         * @param array defines the source array
         * @param offset defines the offset in the source array
         * @returns the new Vector3
         */
        static FromArray(array, offset = 0) {
            return new Vector3(array[offset], array[offset + 1], array[offset + 2]);
        }
        /**
         * Returns a new Vector3 set from the index "offset" of the given Float32Array
         * @param array defines the source array
         * @param offset defines the offset in the source array
         * @returns the new Vector3
         * @deprecated Please use FromArray instead.
         */
        static FromFloatArray(array, offset) {
            return Vector3.FromArray(array, offset);
        }
        /**
         * Sets the given vector "result" with the element values from the index "offset" of the given array
         * Example Playground https://playground.babylonjs.com/#R1F8YU#84
         * @param array defines the source array
         * @param offset defines the offset in the source array
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static FromArrayToRef(array, offset, result) {
            result._x = array[offset];
            result._y = array[offset + 1];
            result._z = array[offset + 2];
            result._isDirty = true;
            return result;
        }
        /**
         * Sets the given vector "result" with the element values from the index "offset" of the given Float32Array
         * @param array defines the source array
         * @param offset defines the offset in the source array
         * @param result defines the Vector3 where to store the result
         * @deprecated Please use FromArrayToRef instead.
         */
        static FromFloatArrayToRef(array, offset, result) {
            return Vector3.FromArrayToRef(array, offset, result);
        }
        /**
         * Sets the given vector "result" with the given floats.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#85
         * @param x defines the x coordinate of the source
         * @param y defines the y coordinate of the source
         * @param z defines the z coordinate of the source
         * @param result defines the Vector3 where to store the result
         */
        static FromFloatsToRef(x, y, z, result) {
            result.copyFromFloats(x, y, z);
            return result;
        }
        /**
         * Returns a new Vector3 set to (0.0, 0.0, 0.0)
         * @returns a new empty Vector3
         */
        static Zero() {
            return new Vector3(0.0, 0.0, 0.0);
        }
        /**
         * Returns a new Vector3 set to (1.0, 1.0, 1.0)
         * @returns a new Vector3
         */
        static One() {
            return new Vector3(1.0, 1.0, 1.0);
        }
        /**
         * Returns a new Vector3 set to (0.0, 1.0, 0.0)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#71
         * @returns a new up Vector3
         */
        static Up() {
            return new Vector3(0.0, 1.0, 0.0);
        }
        /**
         * Gets an up Vector3 that must not be updated
         */
        static get UpReadOnly() {
            return Vector3._UpReadOnly;
        }
        /**
         * Gets a down Vector3 that must not be updated
         */
        static get DownReadOnly() {
            return Vector3._DownReadOnly;
        }
        /**
         * Gets a right Vector3 that must not be updated
         */
        static get RightReadOnly() {
            return Vector3._RightReadOnly;
        }
        /**
         * Gets a left Vector3 that must not be updated
         */
        static get LeftReadOnly() {
            return Vector3._LeftReadOnly;
        }
        /**
         * Gets a forward Vector3 that must not be updated
         */
        static get LeftHandedForwardReadOnly() {
            return Vector3._LeftHandedForwardReadOnly;
        }
        /**
         * Gets a forward Vector3 that must not be updated
         */
        static get RightHandedForwardReadOnly() {
            return Vector3._RightHandedForwardReadOnly;
        }
        /**
         * Gets a backward Vector3 that must not be updated
         */
        static get LeftHandedBackwardReadOnly() {
            return Vector3._LeftHandedBackwardReadOnly;
        }
        /**
         * Gets a backward Vector3 that must not be updated
         */
        static get RightHandedBackwardReadOnly() {
            return Vector3._RightHandedBackwardReadOnly;
        }
        /**
         * Gets a zero Vector3 that must not be updated
         */
        static get ZeroReadOnly() {
            return Vector3._ZeroReadOnly;
        }
        /**
         * Gets a one Vector3 that must not be updated
         */
        static get OneReadOnly() {
            return Vector3._OneReadOnly;
        }
        /**
         * Returns a new Vector3 set to (0.0, -1.0, 0.0)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#71
         * @returns a new down Vector3
         */
        static Down() {
            return new Vector3(0.0, -1.0, 0.0);
        }
        /**
         * Returns a new Vector3 set to (0.0, 0.0, 1.0)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#71
         * @param rightHandedSystem is the scene right-handed (negative z)
         * @returns a new forward Vector3
         */
        static Forward(rightHandedSystem = false) {
            return new Vector3(0.0, 0.0, rightHandedSystem ? -1.0 : 1.0);
        }
        /**
         * Returns a new Vector3 set to (0.0, 0.0, -1.0)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#71
         * @param rightHandedSystem is the scene right-handed (negative-z)
         * @returns a new Backward Vector3
         */
        static Backward(rightHandedSystem = false) {
            return new Vector3(0.0, 0.0, rightHandedSystem ? 1.0 : -1.0);
        }
        /**
         * Returns a new Vector3 set to (1.0, 0.0, 0.0)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#71
         * @returns a new right Vector3
         */
        static Right() {
            return new Vector3(1.0, 0.0, 0.0);
        }
        /**
         * Returns a new Vector3 set to (-1.0, 0.0, 0.0)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#71
         * @returns a new left Vector3
         */
        static Left() {
            return new Vector3(-1.0, 0.0, 0.0);
        }
        /**
         * Returns a new Vector3 with random values between min and max
         * @param min the minimum random value
         * @param max the maximum random value
         * @returns a Vector3 with random values between min and max
         */
        static Random(min = 0, max = 1) {
            return new Vector3(Scalar.RandomRange(min, max), Scalar.RandomRange(min, max), Scalar.RandomRange(min, max));
        }
        /**
         * Returns a new Vector3 set with the result of the transformation by the given matrix of the given vector.
         * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#111
         * @param vector defines the Vector3 to transform
         * @param transformation defines the transformation matrix
         * @returns the transformed Vector3
         */
        static TransformCoordinates(vector, transformation) {
            const result = Vector3.Zero();
            Vector3.TransformCoordinatesToRef(vector, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
         * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#113
         * @param vector defines the Vector3 to transform
         * @param transformation defines the transformation matrix
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static TransformCoordinatesToRef(vector, transformation, result) {
            Vector3.TransformCoordinatesFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
         * This method computes transformed coordinates only, not transformed direction vectors
         * Example Playground https://playground.babylonjs.com/#R1F8YU#115
         * @param x define the x coordinate of the source vector
         * @param y define the y coordinate of the source vector
         * @param z define the z coordinate of the source vector
         * @param transformation defines the transformation matrix
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static TransformCoordinatesFromFloatsToRef(x, y, z, transformation, result) {
            const m = transformation.m;
            const rx = x * m[0] + y * m[4] + z * m[8] + m[12];
            const ry = x * m[1] + y * m[5] + z * m[9] + m[13];
            const rz = x * m[2] + y * m[6] + z * m[10] + m[14];
            const rw = 1 / (x * m[3] + y * m[7] + z * m[11] + m[15]);
            result._x = rx * rw;
            result._y = ry * rw;
            result._z = rz * rw;
            result._isDirty = true;
            return result;
        }
        /**
         * Returns a new Vector3 set with the result of the normal transformation by the given matrix of the given vector
         * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#112
         * @param vector defines the Vector3 to transform
         * @param transformation defines the transformation matrix
         * @returns the new Vector3
         */
        static TransformNormal(vector, transformation) {
            const result = Vector3.Zero();
            Vector3.TransformNormalToRef(vector, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector
         * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#114
         * @param vector defines the Vector3 to transform
         * @param transformation defines the transformation matrix
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static TransformNormalToRef(vector, transformation, result) {
            this.TransformNormalFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z)
         * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
         * Example Playground https://playground.babylonjs.com/#R1F8YU#116
         * @param x define the x coordinate of the source vector
         * @param y define the y coordinate of the source vector
         * @param z define the z coordinate of the source vector
         * @param transformation defines the transformation matrix
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static TransformNormalFromFloatsToRef(x, y, z, transformation, result) {
            const m = transformation.m;
            result._x = x * m[0] + y * m[4] + z * m[8];
            result._y = x * m[1] + y * m[5] + z * m[9];
            result._z = x * m[2] + y * m[6] + z * m[10];
            result._isDirty = true;
            return result;
        }
        /**
         * Returns a new Vector3 located for "amount" on the CatmullRom interpolation spline defined by the vectors "value1", "value2", "value3", "value4"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#69
         * @param value1 defines the first control point
         * @param value2 defines the second control point
         * @param value3 defines the third control point
         * @param value4 defines the fourth control point
         * @param amount defines the amount on the spline to use
         * @returns the new Vector3
         */
        static CatmullRom(value1, value2, value3, value4, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const x = 0.5 *
                (2.0 * value2._x +
                    (-value1._x + value3._x) * amount +
                    (2.0 * value1._x - 5.0 * value2._x + 4.0 * value3._x - value4._x) * squared +
                    (-value1._x + 3.0 * value2._x - 3.0 * value3._x + value4._x) * cubed);
            const y = 0.5 *
                (2.0 * value2._y +
                    (-value1._y + value3._y) * amount +
                    (2.0 * value1._y - 5.0 * value2._y + 4.0 * value3._y - value4._y) * squared +
                    (-value1._y + 3.0 * value2._y - 3.0 * value3._y + value4._y) * cubed);
            const z = 0.5 *
                (2.0 * value2._z +
                    (-value1._z + value3._z) * amount +
                    (2.0 * value1._z - 5.0 * value2._z + 4.0 * value3._z - value4._z) * squared +
                    (-value1._z + 3.0 * value2._z - 3.0 * value3._z + value4._z) * cubed);
            return new value1.constructor(x, y, z);
        }
        /**
         * Returns a new Vector3 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
         * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
         * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
         * Example Playground https://playground.babylonjs.com/#R1F8YU#76
         * @param value defines the current value
         * @param min defines the lower range value
         * @param max defines the upper range value
         * @returns the new Vector3
         */
        static Clamp(value, min, max) {
            const result = new value.constructor();
            Vector3.ClampToRef(value, min, max, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
         * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
         * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
         * Example Playground https://playground.babylonjs.com/#R1F8YU#77
         * @param value defines the current value
         * @param min defines the lower range value
         * @param max defines the upper range value
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static ClampToRef(value, min, max, result) {
            let x = value._x;
            x = x > max._x ? max._x : x;
            x = x < min._x ? min._x : x;
            let y = value._y;
            y = y > max._y ? max._y : y;
            y = y < min._y ? min._y : y;
            let z = value._z;
            z = z > max._z ? max._z : z;
            z = z < min._z ? min._z : z;
            result.copyFromFloats(x, y, z);
            return result;
        }
        /**
         * Checks if a given vector is inside a specific range
         * Example Playground https://playground.babylonjs.com/#R1F8YU#75
         * @param v defines the vector to test
         * @param min defines the minimum range
         * @param max defines the maximum range
         */
        static CheckExtends(v, min, max) {
            min.minimizeInPlace(v);
            max.maximizeInPlace(v);
        }
        /**
         * Returns a new Vector3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#89
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent vector
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent vector
         * @param amount defines the amount on the interpolation spline (between 0 and 1)
         * @returns the new Vector3
         */
        static Hermite(value1, tangent1, value2, tangent2, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
            const part2 = -2.0 * cubed + 3.0 * squared;
            const part3 = cubed - 2.0 * squared + amount;
            const part4 = cubed - squared;
            const x = value1._x * part1 + value2._x * part2 + tangent1._x * part3 + tangent2._x * part4;
            const y = value1._y * part1 + value2._y * part2 + tangent1._y * part3 + tangent2._y * part4;
            const z = value1._z * part1 + value2._z * part2 + tangent1._z * part3 + tangent2._z * part4;
            return new value1.constructor(x, y, z);
        }
        /**
         * Returns a new Vector3 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
         * Example Playground https://playground.babylonjs.com/#R1F8YU#90
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @returns 1st derivative
         */
        static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
            const result = new value1.constructor();
            this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
            return result;
        }
        /**
         * Update a Vector3 with the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
         * Example Playground https://playground.babylonjs.com/#R1F8YU#91
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @param result define where to store the derivative
         * @returns result input
         */
        static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
            const t2 = time * time;
            result._x = (t2 - time) * 6 * value1._x + (3 * t2 - 4 * time + 1) * tangent1._x + (-t2 + time) * 6 * value2._x + (3 * t2 - 2 * time) * tangent2._x;
            result._y = (t2 - time) * 6 * value1._y + (3 * t2 - 4 * time + 1) * tangent1._y + (-t2 + time) * 6 * value2._y + (3 * t2 - 2 * time) * tangent2._y;
            result._z = (t2 - time) * 6 * value1._z + (3 * t2 - 4 * time + 1) * tangent1._z + (-t2 + time) * 6 * value2._z + (3 * t2 - 2 * time) * tangent2._z;
            result._isDirty = true;
            return result;
        }
        /**
         * Returns a new Vector3 located for "amount" (float) on the linear interpolation between the vectors "start" and "end"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#95
         * @param start defines the start value
         * @param end defines the end value
         * @param amount max defines amount between both (between 0 and 1)
         * @returns the new Vector3
         */
        static Lerp(start, end, amount) {
            const result = new start.constructor(0, 0, 0);
            Vector3.LerpToRef(start, end, amount, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the result of the linear interpolation from the vector "start" for "amount" to the vector "end"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#93
         * @param start defines the start value
         * @param end defines the end value
         * @param amount max defines amount between both (between 0 and 1)
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static LerpToRef(start, end, amount, result) {
            result._x = start._x + (end._x - start._x) * amount;
            result._y = start._y + (end._y - start._y) * amount;
            result._z = start._z + (end._z - start._z) * amount;
            result._isDirty = true;
            return result;
        }
        /**
         * Returns the dot product (float) between the vectors "left" and "right"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#82
         * @param left defines the left operand
         * @param right defines the right operand
         * @returns the dot product
         */
        static Dot(left, right) {
            return left._x * right._x + left._y * right._y + left._z * right._z;
        }
        /**
         * Returns a new Vector3 as the cross product of the vectors "left" and "right"
         * The cross product is then orthogonal to both "left" and "right"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#15
         * @param left defines the left operand
         * @param right defines the right operand
         * @returns the cross product
         */
        static Cross(left, right) {
            const result = new left.constructor();
            Vector3.CrossToRef(left, right, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the cross product of "left" and "right"
         * The cross product is then orthogonal to both "left" and "right"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#78
         * @param left defines the left operand
         * @param right defines the right operand
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static CrossToRef(left, right, result) {
            const x = left._y * right._z - left._z * right._y;
            const y = left._z * right._x - left._x * right._z;
            const z = left._x * right._y - left._y * right._x;
            result.copyFromFloats(x, y, z);
            return result;
        }
        /**
         * Returns a new Vector3 as the normalization of the given vector
         * Example Playground https://playground.babylonjs.com/#R1F8YU#98
         * @param vector defines the Vector3 to normalize
         * @returns the new Vector3
         */
        static Normalize(vector) {
            const result = Vector3.Zero();
            Vector3.NormalizeToRef(vector, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the normalization of the given first vector
         * Example Playground https://playground.babylonjs.com/#R1F8YU#98
         * @param vector defines the Vector3 to normalize
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static NormalizeToRef(vector, result) {
            vector.normalizeToRef(result);
            return result;
        }
        /**
         * Project a Vector3 onto screen space
         * Example Playground https://playground.babylonjs.com/#R1F8YU#101
         * @param vector defines the Vector3 to project
         * @param world defines the world matrix to use
         * @param transform defines the transform (view x projection) matrix to use
         * @param viewport defines the screen viewport to use
         * @returns the new Vector3
         */
        static Project(vector, world, transform, viewport) {
            const result = new vector.constructor();
            Vector3.ProjectToRef(vector, world, transform, viewport, result);
            return result;
        }
        /**
         * Project a Vector3 onto screen space to reference
         * Example Playground https://playground.babylonjs.com/#R1F8YU#102
         * @param vector defines the Vector3 to project
         * @param world defines the world matrix to use
         * @param transform defines the transform (view x projection) matrix to use
         * @param viewport defines the screen viewport to use
         * @param result the vector in which the screen space will be stored
         * @returns result input
         */
        static ProjectToRef(vector, world, transform, viewport, result) {
            const cw = viewport.width;
            const ch = viewport.height;
            const cx = viewport.x;
            const cy = viewport.y;
            const viewportMatrix = MathTmp.Matrix[1];
            Matrix.FromValuesToRef(cw / 2.0, 0, 0, 0, 0, -ch / 2.0, 0, 0, 0, 0, 0.5, 0, cx + cw / 2.0, ch / 2.0 + cy, 0.5, 1, viewportMatrix);
            const matrix = MathTmp.Matrix[0];
            world.multiplyToRef(transform, matrix);
            matrix.multiplyToRef(viewportMatrix, matrix);
            Vector3.TransformCoordinatesToRef(vector, matrix, result);
            return result;
        }
        /**
         * Reflects a vector off the plane defined by a normalized normal
         * @param inDirection defines the vector direction
         * @param normal defines the normal - Must be normalized
         * @returns the resulting vector
         */
        static Reflect(inDirection, normal) {
            return this.ReflectToRef(inDirection, normal, new Vector3());
        }
        /**
         * Reflects a vector off the plane defined by a normalized normal to reference
         * @param inDirection defines the vector direction
         * @param normal defines the normal - Must be normalized
         * @param result defines the Vector3 where to store the result
         * @returns the resulting vector
         */
        static ReflectToRef(inDirection, normal, ref) {
            const tmp = TmpVectors.Vector3[0];
            tmp.copyFrom(normal).scaleInPlace(2 * Vector3.Dot(inDirection, normal));
            return ref.copyFrom(inDirection).subtractInPlace(tmp);
        }
        /**
         * @internal
         */
        static _UnprojectFromInvertedMatrixToRef(source, matrix, result) {
            Vector3.TransformCoordinatesToRef(source, matrix, result);
            const m = matrix.m;
            const num = source._x * m[3] + source._y * m[7] + source._z * m[11] + m[15];
            if (Scalar.WithinEpsilon(num, 1.0)) {
                result.scaleInPlace(1.0 / num);
            }
            return result;
        }
        /**
         * Unproject from screen space to object space
         * Example Playground https://playground.babylonjs.com/#R1F8YU#121
         * @param source defines the screen space Vector3 to use
         * @param viewportWidth defines the current width of the viewport
         * @param viewportHeight defines the current height of the viewport
         * @param world defines the world matrix to use (can be set to Identity to go to world space)
         * @param transform defines the transform (view x projection) matrix to use
         * @returns the new Vector3
         */
        static UnprojectFromTransform(source, viewportWidth, viewportHeight, world, transform) {
            return this.Unproject(source, viewportWidth, viewportHeight, world, transform, Matrix.IdentityReadOnly);
        }
        /**
         * Unproject from screen space to object space
         * Example Playground https://playground.babylonjs.com/#R1F8YU#117
         * @param source defines the screen space Vector3 to use
         * @param viewportWidth defines the current width of the viewport
         * @param viewportHeight defines the current height of the viewport
         * @param world defines the world matrix to use (can be set to Identity to go to world space)
         * @param view defines the view matrix to use
         * @param projection defines the projection matrix to use
         * @returns the new Vector3
         */
        static Unproject(source, viewportWidth, viewportHeight, world, view, projection) {
            const result = new source.constructor();
            Vector3.UnprojectToRef(source, viewportWidth, viewportHeight, world, view, projection, result);
            return result;
        }
        /**
         * Unproject from screen space to object space
         * Example Playground https://playground.babylonjs.com/#R1F8YU#119
         * @param source defines the screen space Vector3 to use
         * @param viewportWidth defines the current width of the viewport
         * @param viewportHeight defines the current height of the viewport
         * @param world defines the world matrix to use (can be set to Identity to go to world space)
         * @param view defines the view matrix to use
         * @param projection defines the projection matrix to use
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static UnprojectToRef(source, viewportWidth, viewportHeight, world, view, projection, result) {
            Vector3.UnprojectFloatsToRef(source._x, source._y, source._z, viewportWidth, viewportHeight, world, view, projection, result);
            return result;
        }
        /**
         * Unproject from screen space to object space
         * Example Playground https://playground.babylonjs.com/#R1F8YU#120
         * @param sourceX defines the screen space x coordinate to use
         * @param sourceY defines the screen space y coordinate to use
         * @param sourceZ defines the screen space z coordinate to use
         * @param viewportWidth defines the current width of the viewport
         * @param viewportHeight defines the current height of the viewport
         * @param world defines the world matrix to use (can be set to Identity to go to world space)
         * @param view defines the view matrix to use
         * @param projection defines the projection matrix to use
         * @param result defines the Vector3 where to store the result
         * @returns result input
         */
        static UnprojectFloatsToRef(sourceX, sourceY, sourceZ, viewportWidth, viewportHeight, world, view, projection, result) {
            var _a;
            const matrix = MathTmp.Matrix[0];
            world.multiplyToRef(view, matrix);
            matrix.multiplyToRef(projection, matrix);
            matrix.invert();
            const screenSource = MathTmp.Vector3[0];
            screenSource.x = (sourceX / viewportWidth) * 2 - 1;
            screenSource.y = -((sourceY / viewportHeight) * 2 - 1);
            if ((_a = EngineStore.LastCreatedEngine) === null || _a === void 0 ? void 0 : _a.isNDCHalfZRange) {
                screenSource.z = sourceZ;
            }
            else {
                screenSource.z = 2 * sourceZ - 1.0;
            }
            Vector3._UnprojectFromInvertedMatrixToRef(screenSource, matrix, result);
            return result;
        }
        /**
         * Gets the minimal coordinate values between two Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#97
         * @param left defines the first operand
         * @param right defines the second operand
         * @returns the new Vector3
         */
        static Minimize(left, right) {
            const min = new left.constructor();
            min.copyFrom(left);
            min.minimizeInPlace(right);
            return min;
        }
        /**
         * Gets the maximal coordinate values between two Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#96
         * @param left defines the first operand
         * @param right defines the second operand
         * @returns the new Vector3
         */
        static Maximize(left, right) {
            const max = new left.constructor();
            max.copyFrom(left);
            max.maximizeInPlace(right);
            return max;
        }
        /**
         * Returns the distance between the vectors "value1" and "value2"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#81
         * @param value1 defines the first operand
         * @param value2 defines the second operand
         * @returns the distance
         */
        static Distance(value1, value2) {
            return Math.sqrt(Vector3.DistanceSquared(value1, value2));
        }
        /**
         * Returns the squared distance between the vectors "value1" and "value2"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#80
         * @param value1 defines the first operand
         * @param value2 defines the second operand
         * @returns the squared distance
         */
        static DistanceSquared(value1, value2) {
            const x = value1._x - value2._x;
            const y = value1._y - value2._y;
            const z = value1._z - value2._z;
            return x * x + y * y + z * z;
        }
        /**
         * Projects "vector" on the triangle determined by its extremities "p0", "p1" and "p2", stores the result in "ref"
         * and returns the distance to the projected point.
         * Example Playground https://playground.babylonjs.com/#R1F8YU#104
         * From http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.104.4264&rep=rep1&type=pdf
         *
         * @param vector the vector to get distance from
         * @param p0 extremity of the triangle
         * @param p1 extremity of the triangle
         * @param p2 extremity of the triangle
         * @param ref variable to store the result to
         * @returns The distance between "ref" and "vector"
         */
        static ProjectOnTriangleToRef(vector, p0, p1, p2, ref) {
            const p1p0 = MathTmp.Vector3[0];
            const p2p0 = MathTmp.Vector3[1];
            const p2p1 = MathTmp.Vector3[2];
            const normal = MathTmp.Vector3[3];
            const vectorp0 = MathTmp.Vector3[4];
            // Triangle vectors
            p1.subtractToRef(p0, p1p0);
            p2.subtractToRef(p0, p2p0);
            p2.subtractToRef(p1, p2p1);
            const p1p0L = p1p0.length();
            const p2p0L = p2p0.length();
            const p2p1L = p2p1.length();
            if (p1p0L < Epsilon || p2p0L < Epsilon || p2p1L < Epsilon) {
                // This is a degenerate triangle. As we assume this is part of a non-degenerate mesh,
                // we will find a better intersection later.
                // Let's just return one of the extremities
                ref.copyFrom(p0);
                return Vector3.Distance(vector, p0);
            }
            // Compute normal and vector to p0
            vector.subtractToRef(p0, vectorp0);
            Vector3.CrossToRef(p1p0, p2p0, normal);
            const nl = normal.length();
            if (nl < Epsilon) {
                // Extremities are aligned, we are back on the case of a degenerate triangle
                ref.copyFrom(p0);
                return Vector3.Distance(vector, p0);
            }
            normal.normalizeFromLength(nl);
            let l = vectorp0.length();
            if (l < Epsilon) {
                // Vector is p0
                ref.copyFrom(p0);
                return 0;
            }
            vectorp0.normalizeFromLength(l);
            // Project to "proj" that lies on the triangle plane
            const cosA = Vector3.Dot(normal, vectorp0);
            const projVector = MathTmp.Vector3[5];
            const proj = MathTmp.Vector3[6];
            projVector.copyFrom(normal).scaleInPlace(-l * cosA);
            proj.copyFrom(vector).addInPlace(projVector);
            // Compute barycentric coordinates (v0, v1 and v2 are axis from barycenter to extremities)
            const v0 = MathTmp.Vector3[4];
            const v1 = MathTmp.Vector3[5];
            const v2 = MathTmp.Vector3[7];
            const tmp = MathTmp.Vector3[8];
            v0.copyFrom(p1p0).scaleInPlace(1 / p1p0L);
            tmp.copyFrom(p2p0).scaleInPlace(1 / p2p0L);
            v0.addInPlace(tmp).scaleInPlace(-1);
            v1.copyFrom(p1p0).scaleInPlace(-1 / p1p0L);
            tmp.copyFrom(p2p1).scaleInPlace(1 / p2p1L);
            v1.addInPlace(tmp).scaleInPlace(-1);
            v2.copyFrom(p2p1).scaleInPlace(-1 / p2p1L);
            tmp.copyFrom(p2p0).scaleInPlace(-1 / p2p0L);
            v2.addInPlace(tmp).scaleInPlace(-1);
            // Determines which edge of the triangle is closest to "proj"
            const projP = MathTmp.Vector3[9];
            let dot;
            projP.copyFrom(proj).subtractInPlace(p0);
            Vector3.CrossToRef(v0, projP, tmp);
            dot = Vector3.Dot(tmp, normal);
            const s0 = dot;
            projP.copyFrom(proj).subtractInPlace(p1);
            Vector3.CrossToRef(v1, projP, tmp);
            dot = Vector3.Dot(tmp, normal);
            const s1 = dot;
            projP.copyFrom(proj).subtractInPlace(p2);
            Vector3.CrossToRef(v2, projP, tmp);
            dot = Vector3.Dot(tmp, normal);
            const s2 = dot;
            const edge = MathTmp.Vector3[10];
            let e0, e1;
            if (s0 > 0 && s1 < 0) {
                edge.copyFrom(p1p0);
                e0 = p0;
                e1 = p1;
            }
            else if (s1 > 0 && s2 < 0) {
                edge.copyFrom(p2p1);
                e0 = p1;
                e1 = p2;
            }
            else {
                edge.copyFrom(p2p0).scaleInPlace(-1);
                e0 = p2;
                e1 = p0;
            }
            // Determines if "proj" lies inside the triangle
            const tmp2 = MathTmp.Vector3[9];
            const tmp3 = MathTmp.Vector3[4];
            e0.subtractToRef(proj, tmp);
            e1.subtractToRef(proj, tmp2);
            Vector3.CrossToRef(tmp, tmp2, tmp3);
            const isOutside = Vector3.Dot(tmp3, normal) < 0;
            // If inside, we already found the projected point, "proj"
            if (!isOutside) {
                ref.copyFrom(proj);
                return Math.abs(l * cosA);
            }
            // If outside, we find "triProj", the closest point from "proj" on the closest edge
            const r = MathTmp.Vector3[5];
            Vector3.CrossToRef(edge, tmp3, r);
            r.normalize();
            const e0proj = MathTmp.Vector3[9];
            e0proj.copyFrom(e0).subtractInPlace(proj);
            const e0projL = e0proj.length();
            if (e0projL < Epsilon) {
                // Proj is e0
                ref.copyFrom(e0);
                return Vector3.Distance(vector, e0);
            }
            e0proj.normalizeFromLength(e0projL);
            const cosG = Vector3.Dot(r, e0proj);
            const triProj = MathTmp.Vector3[7];
            triProj.copyFrom(proj).addInPlace(r.scaleInPlace(e0projL * cosG));
            // Now we clamp "triProj" so it lies between e0 and e1
            tmp.copyFrom(triProj).subtractInPlace(e0);
            l = edge.length();
            edge.normalizeFromLength(l);
            let t = Vector3.Dot(tmp, edge) / Math.max(l, Epsilon);
            t = Scalar.Clamp(t, 0, 1);
            triProj.copyFrom(e0).addInPlace(edge.scaleInPlace(t * l));
            ref.copyFrom(triProj);
            return Vector3.Distance(vector, triProj);
        }
        /**
         * Returns a new Vector3 located at the center between "value1" and "value2"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#72
         * @param value1 defines the first operand
         * @param value2 defines the second operand
         * @returns the new Vector3
         */
        static Center(value1, value2) {
            return Vector3.CenterToRef(value1, value2, Vector3.Zero());
        }
        /**
         * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
         * Example Playground https://playground.babylonjs.com/#R1F8YU#73
         * @param value1 defines first vector
         * @param value2 defines second vector
         * @param ref defines third vector
         * @returns ref
         */
        static CenterToRef(value1, value2, ref) {
            return ref.copyFromFloats((value1._x + value2._x) / 2, (value1._y + value2._y) / 2, (value1._z + value2._z) / 2);
        }
        /**
         * Given three orthogonal normalized left-handed oriented Vector3 axis in space (target system),
         * RotationFromAxis() returns the rotation Euler angles (ex : rotation.x, rotation.y, rotation.z) to apply
         * to something in order to rotate it from its local system to the given target system
         * Note: axis1, axis2 and axis3 are normalized during this operation
         * Example Playground https://playground.babylonjs.com/#R1F8YU#106
         * @param axis1 defines the first axis
         * @param axis2 defines the second axis
         * @param axis3 defines the third axis
         * @returns a new Vector3
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/target_align
         */
        static RotationFromAxis(axis1, axis2, axis3) {
            const rotation = new axis1.constructor();
            Vector3.RotationFromAxisToRef(axis1, axis2, axis3, rotation);
            return rotation;
        }
        /**
         * The same than RotationFromAxis but updates the given ref Vector3 parameter instead of returning a new Vector3
         * Example Playground https://playground.babylonjs.com/#R1F8YU#107
         * @param axis1 defines the first axis
         * @param axis2 defines the second axis
         * @param axis3 defines the third axis
         * @param ref defines the Vector3 where to store the result
         * @returns result input
         */
        static RotationFromAxisToRef(axis1, axis2, axis3, ref) {
            const quat = MathTmp.Quaternion[0];
            Quaternion.RotationQuaternionFromAxisToRef(axis1, axis2, axis3, quat);
            quat.toEulerAnglesToRef(ref);
            return ref;
        }
    }
    Vector3._UpReadOnly = Vector3.Up();
    Vector3._DownReadOnly = Vector3.Down();
    Vector3._LeftHandedForwardReadOnly = Vector3.Forward(false);
    Vector3._RightHandedForwardReadOnly = Vector3.Forward(true);
    Vector3._LeftHandedBackwardReadOnly = Vector3.Backward(false);
    Vector3._RightHandedBackwardReadOnly = Vector3.Backward(true);
    Vector3._RightReadOnly = Vector3.Right();
    Vector3._LeftReadOnly = Vector3.Left();
    Vector3._ZeroReadOnly = Vector3.Zero();
    Vector3._OneReadOnly = Vector3.One();
    /**
     * Vector4 class created for EulerAngle class conversion to Quaternion
     */
    class Vector4 {
        /**
         * Creates a Vector4 object from the given floats.
         * @param x x value of the vector
         * @param y y value of the vector
         * @param z z value of the vector
         * @param w w value of the vector
         */
        constructor(
        /** x value of the vector */
        x = 0, 
        /** y value of the vector */
        y = 0, 
        /** z value of the vector */
        z = 0, 
        /** w value of the vector */
        w = 0) {
            this.x = x;
            this.y = y;
            this.z = z;
            this.w = w;
        }
        /**
         * Returns the string with the Vector4 coordinates.
         * @returns a string containing all the vector values
         */
        toString() {
            return `{X: ${this.x} Y: ${this.y} Z: ${this.z} W: ${this.w}}`;
        }
        /**
         * Returns the string "Vector4".
         * @returns "Vector4"
         */
        getClassName() {
            return "Vector4";
        }
        /**
         * Returns the Vector4 hash code.
         * @returns a unique hash code
         */
        getHashCode() {
            const x = _ExtractAsInt(this.x);
            const y = _ExtractAsInt(this.y);
            const z = _ExtractAsInt(this.z);
            const w = _ExtractAsInt(this.w);
            let hash = x;
            hash = (hash * 397) ^ y;
            hash = (hash * 397) ^ z;
            hash = (hash * 397) ^ w;
            return hash;
        }
        // Operators
        /**
         * Returns a new array populated with 4 elements : the Vector4 coordinates.
         * @returns the resulting array
         */
        asArray() {
            const result = new Array();
            this.toArray(result, 0);
            return result;
        }
        /**
         * Populates the given array from the given index with the Vector4 coordinates.
         * @param array array to populate
         * @param index index of the array to start at (default: 0)
         * @returns the Vector4.
         */
        toArray(array, index) {
            if (index === undefined) {
                index = 0;
            }
            array[index] = this.x;
            array[index + 1] = this.y;
            array[index + 2] = this.z;
            array[index + 3] = this.w;
            return this;
        }
        /**
         * Update the current vector from an array
         * @param array defines the destination array
         * @param index defines the offset in the destination array
         * @returns the current Vector3
         */
        fromArray(array, index = 0) {
            Vector4.FromArrayToRef(array, index, this);
            return this;
        }
        /**
         * Adds the given vector to the current Vector4.
         * @param otherVector the vector to add
         * @returns the updated Vector4.
         */
        addInPlace(otherVector) {
            this.x += otherVector.x;
            this.y += otherVector.y;
            this.z += otherVector.z;
            this.w += otherVector.w;
            return this;
        }
        /**
         * Returns a new Vector4 as the result of the addition of the current Vector4 and the given one.
         * @param otherVector the vector to add
         * @returns the resulting vector
         */
        add(otherVector) {
            return new this.constructor(this.x + otherVector.x, this.y + otherVector.y, this.z + otherVector.z, this.w + otherVector.w);
        }
        /**
         * Updates the given vector "result" with the result of the addition of the current Vector4 and the given one.
         * @param otherVector the vector to add
         * @param result the vector to store the result
         * @returns result input
         */
        addToRef(otherVector, result) {
            result.x = this.x + otherVector.x;
            result.y = this.y + otherVector.y;
            result.z = this.z + otherVector.z;
            result.w = this.w + otherVector.w;
            return result;
        }
        /**
         * Subtract in place the given vector from the current Vector4.
         * @param otherVector the vector to subtract
         * @returns the updated Vector4.
         */
        subtractInPlace(otherVector) {
            this.x -= otherVector.x;
            this.y -= otherVector.y;
            this.z -= otherVector.z;
            this.w -= otherVector.w;
            return this;
        }
        /**
         * Returns a new Vector4 with the result of the subtraction of the given vector from the current Vector4.
         * @param otherVector the vector to add
         * @returns the new vector with the result
         */
        subtract(otherVector) {
            return new this.constructor(this.x - otherVector.x, this.y - otherVector.y, this.z - otherVector.z, this.w - otherVector.w);
        }
        /**
         * Sets the given vector "result" with the result of the subtraction of the given vector from the current Vector4.
         * @param otherVector the vector to subtract
         * @param result the vector to store the result
         * @returns result input
         */
        subtractToRef(otherVector, result) {
            result.x = this.x - otherVector.x;
            result.y = this.y - otherVector.y;
            result.z = this.z - otherVector.z;
            result.w = this.w - otherVector.w;
            return result;
        }
        /**
         * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.
         */
        /**
         * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.
         * @param x value to subtract
         * @param y value to subtract
         * @param z value to subtract
         * @param w value to subtract
         * @returns new vector containing the result
         */
        subtractFromFloats(x, y, z, w) {
            return new this.constructor(this.x - x, this.y - y, this.z - z, this.w - w);
        }
        /**
         * Sets the given vector "result" set with the result of the subtraction of the given floats from the current Vector4 coordinates.
         * @param x value to subtract
         * @param y value to subtract
         * @param z value to subtract
         * @param w value to subtract
         * @param result the vector to store the result in
         * @returns result input
         */
        subtractFromFloatsToRef(x, y, z, w, result) {
            result.x = this.x - x;
            result.y = this.y - y;
            result.z = this.z - z;
            result.w = this.w - w;
            return result;
        }
        /**
         * Returns a new Vector4 set with the current Vector4 negated coordinates.
         * @returns a new vector with the negated values
         */
        negate() {
            return new this.constructor(-this.x, -this.y, -this.z, -this.w);
        }
        /**
         * Negate this vector in place
         * @returns this
         */
        negateInPlace() {
            this.x *= -1;
            this.y *= -1;
            this.z *= -1;
            this.w *= -1;
            return this;
        }
        /**
         * Negate the current Vector4 and stores the result in the given vector "result" coordinates
         * @param result defines the Vector3 object where to store the result
         * @returns the result
         */
        negateToRef(result) {
            return result.copyFromFloats(this.x * -1, this.y * -1, this.z * -1, this.w * -1);
        }
        /**
         * Multiplies the current Vector4 coordinates by scale (float).
         * @param scale the number to scale with
         * @returns the updated Vector4.
         */
        scaleInPlace(scale) {
            this.x *= scale;
            this.y *= scale;
            this.z *= scale;
            this.w *= scale;
            return this;
        }
        /**
         * Returns a new Vector4 set with the current Vector4 coordinates multiplied by scale (float).
         * @param scale the number to scale with
         * @returns a new vector with the result
         */
        scale(scale) {
            return new this.constructor(this.x * scale, this.y * scale, this.z * scale, this.w * scale);
        }
        /**
         * Sets the given vector "result" with the current Vector4 coordinates multiplied by scale (float).
         * @param scale the number to scale with
         * @param result a vector to store the result in
         * @returns result input
         */
        scaleToRef(scale, result) {
            result.x = this.x * scale;
            result.y = this.y * scale;
            result.z = this.z * scale;
            result.w = this.w * scale;
            return result;
        }
        /**
         * Scale the current Vector4 values by a factor and add the result to a given Vector4
         * @param scale defines the scale factor
         * @param result defines the Vector4 object where to store the result
         * @returns result input
         */
        scaleAndAddToRef(scale, result) {
            result.x += this.x * scale;
            result.y += this.y * scale;
            result.z += this.z * scale;
            result.w += this.w * scale;
            return result;
        }
        /**
         * Boolean : True if the current Vector4 coordinates are stricly equal to the given ones.
         * @param otherVector the vector to compare against
         * @returns true if they are equal
         */
        equals(otherVector) {
            return otherVector && this.x === otherVector.x && this.y === otherVector.y && this.z === otherVector.z && this.w === otherVector.w;
        }
        /**
         * Boolean : True if the current Vector4 coordinates are each beneath the distance "epsilon" from the given vector ones.
         * @param otherVector vector to compare against
         * @param epsilon (Default: very small number)
         * @returns true if they are equal
         */
        equalsWithEpsilon(otherVector, epsilon = Epsilon) {
            return (otherVector &&
                Scalar.WithinEpsilon(this.x, otherVector.x, epsilon) &&
                Scalar.WithinEpsilon(this.y, otherVector.y, epsilon) &&
                Scalar.WithinEpsilon(this.z, otherVector.z, epsilon) &&
                Scalar.WithinEpsilon(this.w, otherVector.w, epsilon));
        }
        /**
         * Boolean : True if the given floats are strictly equal to the current Vector4 coordinates.
         * @param x x value to compare against
         * @param y y value to compare against
         * @param z z value to compare against
         * @param w w value to compare against
         * @returns true if equal
         */
        equalsToFloats(x, y, z, w) {
            return this.x === x && this.y === y && this.z === z && this.w === w;
        }
        /**
         * Multiplies in place the current Vector4 by the given one.
         * @param otherVector vector to multiple with
         * @returns the updated Vector4.
         */
        multiplyInPlace(otherVector) {
            this.x *= otherVector.x;
            this.y *= otherVector.y;
            this.z *= otherVector.z;
            this.w *= otherVector.w;
            return this;
        }
        /**
         * Returns a new Vector4 set with the multiplication result of the current Vector4 and the given one.
         * @param otherVector vector to multiple with
         * @returns resulting new vector
         */
        multiply(otherVector) {
            return new this.constructor(this.x * otherVector.x, this.y * otherVector.y, this.z * otherVector.z, this.w * otherVector.w);
        }
        /**
         * Updates the given vector "result" with the multiplication result of the current Vector4 and the given one.
         * @param otherVector vector to multiple with
         * @param result vector to store the result
         * @returns result input
         */
        multiplyToRef(otherVector, result) {
            result.x = this.x * otherVector.x;
            result.y = this.y * otherVector.y;
            result.z = this.z * otherVector.z;
            result.w = this.w * otherVector.w;
            return result;
        }
        /**
         * Returns a new Vector4 set with the multiplication result of the given floats and the current Vector4 coordinates.
         * @param x x value multiply with
         * @param y y value multiply with
         * @param z z value multiply with
         * @param w w value multiply with
         * @returns resulting new vector
         */
        multiplyByFloats(x, y, z, w) {
            return new this.constructor(this.x * x, this.y * y, this.z * z, this.w * w);
        }
        /**
         * Returns a new Vector4 set with the division result of the current Vector4 by the given one.
         * @param otherVector vector to devide with
         * @returns resulting new vector
         */
        divide(otherVector) {
            return new this.constructor(this.x / otherVector.x, this.y / otherVector.y, this.z / otherVector.z, this.w / otherVector.w);
        }
        /**
         * Updates the given vector "result" with the division result of the current Vector4 by the given one.
         * @param otherVector vector to devide with
         * @param result vector to store the result
         * @returns result input
         */
        divideToRef(otherVector, result) {
            result.x = this.x / otherVector.x;
            result.y = this.y / otherVector.y;
            result.z = this.z / otherVector.z;
            result.w = this.w / otherVector.w;
            return result;
        }
        /**
         * Divides the current Vector3 coordinates by the given ones.
         * @param otherVector vector to devide with
         * @returns the updated Vector3.
         */
        divideInPlace(otherVector) {
            return this.divideToRef(otherVector, this);
        }
        /**
         * Updates the Vector4 coordinates with the minimum values between its own and the given vector ones
         * @param other defines the second operand
         * @returns the current updated Vector4
         */
        minimizeInPlace(other) {
            if (other.x < this.x) {
                this.x = other.x;
            }
            if (other.y < this.y) {
                this.y = other.y;
            }
            if (other.z < this.z) {
                this.z = other.z;
            }
            if (other.w < this.w) {
                this.w = other.w;
            }
            return this;
        }
        /**
         * Updates the Vector4 coordinates with the maximum values between its own and the given vector ones
         * @param other defines the second operand
         * @returns the current updated Vector4
         */
        maximizeInPlace(other) {
            if (other.x > this.x) {
                this.x = other.x;
            }
            if (other.y > this.y) {
                this.y = other.y;
            }
            if (other.z > this.z) {
                this.z = other.z;
            }
            if (other.w > this.w) {
                this.w = other.w;
            }
            return this;
        }
        /**
         * Gets a new Vector4 from current Vector4 floored values
         * @returns a new Vector4
         */
        floor() {
            return new this.constructor(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z), Math.floor(this.w));
        }
        /**
         * Gets a new Vector4 from current Vector4 fractional values
         * @returns a new Vector4
         */
        fract() {
            return new this.constructor(this.x - Math.floor(this.x), this.y - Math.floor(this.y), this.z - Math.floor(this.z), this.w - Math.floor(this.w));
        }
        // Properties
        /**
         * Returns the Vector4 length (float).
         * @returns the length
         */
        length() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
        }
        /**
         * Returns the Vector4 squared length (float).
         * @returns the length squared
         */
        lengthSquared() {
            return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
        }
        // Methods
        /**
         * Normalizes in place the Vector4.
         * @returns the updated Vector4.
         */
        normalize() {
            const len = this.length();
            if (len === 0) {
                return this;
            }
            return this.scaleInPlace(1.0 / len);
        }
        /**
         * Returns a new Vector3 from the Vector4 (x, y, z) coordinates.
         * @returns this converted to a new vector3
         */
        toVector3() {
            return new Vector3(this.x, this.y, this.z);
        }
        /**
         * Returns a new Vector4 copied from the current one.
         * @returns the new cloned vector
         */
        clone() {
            return new this.constructor(this.x, this.y, this.z, this.w);
        }
        /**
         * Updates the current Vector4 with the given one coordinates.
         * @param source the source vector to copy from
         * @returns the updated Vector4.
         */
        copyFrom(source) {
            this.x = source.x;
            this.y = source.y;
            this.z = source.z;
            this.w = source.w;
            return this;
        }
        /**
         * Updates the current Vector4 coordinates with the given floats.
         * @param x float to copy from
         * @param y float to copy from
         * @param z float to copy from
         * @param w float to copy from
         * @returns the updated Vector4.
         */
        copyFromFloats(x, y, z, w) {
            this.x = x;
            this.y = y;
            this.z = z;
            this.w = w;
            return this;
        }
        /**
         * Updates the current Vector4 coordinates with the given floats.
         * @param x float to set from
         * @param y float to set from
         * @param z float to set from
         * @param w float to set from
         * @returns the updated Vector4.
         */
        set(x, y, z, w) {
            return this.copyFromFloats(x, y, z, w);
        }
        /**
         * Copies the given float to the current Vector3 coordinates
         * @param v defines the x, y, z and w coordinates of the operand
         * @returns the current updated Vector3
         */
        setAll(v) {
            this.x = this.y = this.z = this.w = v;
            return this;
        }
        // Statics
        /**
         * Returns a new Vector4 set from the starting index of the given array.
         * @param array the array to pull values from
         * @param offset the offset into the array to start at
         * @returns the new vector
         */
        static FromArray(array, offset) {
            if (!offset) {
                offset = 0;
            }
            return new Vector4(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
        }
        /**
         * Updates the given vector "result" from the starting index of the given array.
         * @param array the array to pull values from
         * @param offset the offset into the array to start at
         * @param result the vector to store the result in
         * @returns result input
         */
        static FromArrayToRef(array, offset, result) {
            result.x = array[offset];
            result.y = array[offset + 1];
            result.z = array[offset + 2];
            result.w = array[offset + 3];
            return result;
        }
        /**
         * Updates the given vector "result" from the starting index of the given Float32Array.
         * @param array the array to pull values from
         * @param offset the offset into the array to start at
         * @param result the vector to store the result in
         * @returns result input
         */
        static FromFloatArrayToRef(array, offset, result) {
            Vector4.FromArrayToRef(array, offset, result);
            return result;
        }
        /**
         * Updates the given vector "result" coordinates from the given floats.
         * @param x float to set from
         * @param y float to set from
         * @param z float to set from
         * @param w float to set from
         * @param result the vector to the floats in
         * @returns result input
         */
        static FromFloatsToRef(x, y, z, w, result) {
            result.x = x;
            result.y = y;
            result.z = z;
            result.w = w;
            return result;
        }
        /**
         * Returns a new Vector4 set to (0.0, 0.0, 0.0, 0.0)
         * @returns the new vector
         */
        static Zero() {
            return new Vector4(0.0, 0.0, 0.0, 0.0);
        }
        /**
         * Returns a new Vector4 set to (1.0, 1.0, 1.0, 1.0)
         * @returns the new vector
         */
        static One() {
            return new Vector4(1.0, 1.0, 1.0, 1.0);
        }
        /**
         * Returns a new Vector4 with random values between min and max
         * @param min the minimum random value
         * @param max the maximum random value
         * @returns a Vector4 with random values between min and max
         */
        static Random(min = 0, max = 1) {
            return new Vector4(Scalar.RandomRange(min, max), Scalar.RandomRange(min, max), Scalar.RandomRange(min, max), Scalar.RandomRange(min, max));
        }
        /**
         * Gets a zero Vector4 that must not be updated
         */
        static get ZeroReadOnly() {
            return Vector4._ZeroReadOnly;
        }
        /**
         * Returns a new normalized Vector4 from the given one.
         * @param vector the vector to normalize
         * @returns the vector
         */
        static Normalize(vector) {
            const result = Vector4.Zero();
            Vector4.NormalizeToRef(vector, result);
            return result;
        }
        /**
         * Updates the given vector "result" from the normalization of the given one.
         * @param vector the vector to normalize
         * @param result the vector to store the result in
         * @returns result input
         */
        static NormalizeToRef(vector, result) {
            result.copyFrom(vector);
            result.normalize();
            return result;
        }
        /**
         * Returns a vector with the minimum values from the left and right vectors
         * @param left left vector to minimize
         * @param right right vector to minimize
         * @returns a new vector with the minimum of the left and right vector values
         */
        static Minimize(left, right) {
            const min = new left.constructor();
            min.copyFrom(left);
            min.minimizeInPlace(right);
            return min;
        }
        /**
         * Returns a vector with the maximum values from the left and right vectors
         * @param left left vector to maximize
         * @param right right vector to maximize
         * @returns a new vector with the maximum of the left and right vector values
         */
        static Maximize(left, right) {
            const max = new left.constructor();
            max.copyFrom(left);
            max.maximizeInPlace(right);
            return max;
        }
        /**
         * Returns the distance (float) between the vectors "value1" and "value2".
         * @param value1 value to calulate the distance between
         * @param value2 value to calulate the distance between
         * @returns the distance between the two vectors
         */
        static Distance(value1, value2) {
            return Math.sqrt(Vector4.DistanceSquared(value1, value2));
        }
        /**
         * Returns the squared distance (float) between the vectors "value1" and "value2".
         * @param value1 value to calulate the distance between
         * @param value2 value to calulate the distance between
         * @returns the distance between the two vectors squared
         */
        static DistanceSquared(value1, value2) {
            const x = value1.x - value2.x;
            const y = value1.y - value2.y;
            const z = value1.z - value2.z;
            const w = value1.w - value2.w;
            return x * x + y * y + z * z + w * w;
        }
        /**
         * Returns a new Vector4 located at the center between the vectors "value1" and "value2".
         * @param value1 value to calulate the center between
         * @param value2 value to calulate the center between
         * @returns the center between the two vectors
         */
        static Center(value1, value2) {
            return Vector4.CenterToRef(value1, value2, Vector4.Zero());
        }
        /**
         * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
         * @param value1 defines first vector
         * @param value2 defines second vector
         * @param ref defines third vector
         * @returns ref
         */
        static CenterToRef(value1, value2, ref) {
            return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2, (value1.z + value2.z) / 2, (value1.w + value2.w) / 2);
        }
        /**
         * Returns a new Vector4 set with the result of the transformation by the given matrix of the given vector.
         * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
         * The difference with Vector3.TransformCoordinates is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
         * @param vector defines the Vector3 to transform
         * @param transformation defines the transformation matrix
         * @returns the transformed Vector4
         */
        static TransformCoordinates(vector, transformation) {
            const result = Vector4.Zero();
            Vector4.TransformCoordinatesToRef(vector, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
         * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
         * The difference with Vector3.TransformCoordinatesToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
         * @param vector defines the Vector3 to transform
         * @param transformation defines the transformation matrix
         * @param result defines the Vector4 where to store the result
         * @returns result input
         */
        static TransformCoordinatesToRef(vector, transformation, result) {
            Vector4.TransformCoordinatesFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
         * This method computes tranformed coordinates only, not transformed direction vectors
         * The difference with Vector3.TransformCoordinatesFromFloatsToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
         * @param x define the x coordinate of the source vector
         * @param y define the y coordinate of the source vector
         * @param z define the z coordinate of the source vector
         * @param transformation defines the transformation matrix
         * @param result defines the Vector4 where to store the result
         * @returns result input
         */
        static TransformCoordinatesFromFloatsToRef(x, y, z, transformation, result) {
            const m = transformation.m;
            const rx = x * m[0] + y * m[4] + z * m[8] + m[12];
            const ry = x * m[1] + y * m[5] + z * m[9] + m[13];
            const rz = x * m[2] + y * m[6] + z * m[10] + m[14];
            const rw = x * m[3] + y * m[7] + z * m[11] + m[15];
            result.x = rx;
            result.y = ry;
            result.z = rz;
            result.w = rw;
            return result;
        }
        /**
         * Returns a new Vector4 set with the result of the normal transformation by the given matrix of the given vector.
         * This methods computes transformed normalized direction vectors only.
         * @param vector the vector to transform
         * @param transformation the transformation matrix to apply
         * @returns the new vector
         */
        static TransformNormal(vector, transformation) {
            const result = new vector.constructor();
            Vector4.TransformNormalToRef(vector, transformation, result);
            return result;
        }
        /**
         * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector.
         * This methods computes transformed normalized direction vectors only.
         * @param vector the vector to transform
         * @param transformation the transformation matrix to apply
         * @param result the vector to store the result in
         * @returns result input
         */
        static TransformNormalToRef(vector, transformation, result) {
            const m = transformation.m;
            const x = vector.x * m[0] + vector.y * m[4] + vector.z * m[8];
            const y = vector.x * m[1] + vector.y * m[5] + vector.z * m[9];
            const z = vector.x * m[2] + vector.y * m[6] + vector.z * m[10];
            result.x = x;
            result.y = y;
            result.z = z;
            result.w = vector.w;
            return result;
        }
        /**
         * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z, w).
         * This methods computes transformed normalized direction vectors only.
         * @param x value to transform
         * @param y value to transform
         * @param z value to transform
         * @param w value to transform
         * @param transformation the transformation matrix to apply
         * @param result the vector to store the results in
         * @returns result input
         */
        static TransformNormalFromFloatsToRef(x, y, z, w, transformation, result) {
            const m = transformation.m;
            result.x = x * m[0] + y * m[4] + z * m[8];
            result.y = x * m[1] + y * m[5] + z * m[9];
            result.z = x * m[2] + y * m[6] + z * m[10];
            result.w = w;
            return result;
        }
        /**
         * Creates a new Vector4 from a Vector3
         * @param source defines the source data
         * @param w defines the 4th component (default is 0)
         * @returns a new Vector4
         */
        static FromVector3(source, w = 0) {
            return new Vector4(source._x, source._y, source._z, w);
        }
    }
    Vector4._ZeroReadOnly = Vector4.Zero();
    /**
     * Class used to store quaternion data
     * Example Playground - Overview - https://playground.babylonjs.com/#L49EJ7#100
     * @see https://en.wikipedia.org/wiki/Quaternion
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms
     */
    class Quaternion {
        /** Gets or sets the x coordinate */
        get x() {
            return this._x;
        }
        set x(value) {
            this._x = value;
            this._isDirty = true;
        }
        /** Gets or sets the y coordinate */
        get y() {
            return this._y;
        }
        set y(value) {
            this._y = value;
            this._isDirty = true;
        }
        /** Gets or sets the z coordinate */
        get z() {
            return this._z;
        }
        set z(value) {
            this._z = value;
            this._isDirty = true;
        }
        /** Gets or sets the w coordinate */
        get w() {
            return this._w;
        }
        set w(value) {
            this._w = value;
            this._isDirty = true;
        }
        /**
         * Creates a new Quaternion from the given floats
         * @param x defines the first component (0 by default)
         * @param y defines the second component (0 by default)
         * @param z defines the third component (0 by default)
         * @param w defines the fourth component (1.0 by default)
         */
        constructor(x = 0.0, y = 0.0, z = 0.0, w = 1.0) {
            /** @internal */
            this._isDirty = true;
            this._x = x;
            this._y = y;
            this._z = z;
            this._w = w;
        }
        /**
         * Gets a string representation for the current quaternion
         * @returns a string with the Quaternion coordinates
         */
        toString() {
            return `{X: ${this._x} Y: ${this._y} Z: ${this._z} W: ${this._w}}`;
        }
        /**
         * Gets the class name of the quaternion
         * @returns the string "Quaternion"
         */
        getClassName() {
            return "Quaternion";
        }
        /**
         * Gets a hash code for this quaternion
         * @returns the quaternion hash code
         */
        getHashCode() {
            const x = _ExtractAsInt(this._x);
            const y = _ExtractAsInt(this._y);
            const z = _ExtractAsInt(this._z);
            const w = _ExtractAsInt(this._w);
            let hash = x;
            hash = (hash * 397) ^ y;
            hash = (hash * 397) ^ z;
            hash = (hash * 397) ^ w;
            return hash;
        }
        /**
         * Copy the quaternion to an array
         * Example Playground https://playground.babylonjs.com/#L49EJ7#13
         * @returns a new array populated with 4 elements from the quaternion coordinates
         */
        asArray() {
            return [this._x, this._y, this._z, this._w];
        }
        /**
         * Stores from the starting index in the given array the Quaternion successive values
         * Example Playground https://playground.babylonjs.com/#L49EJ7#59
         * @param array defines the array where to store the x,y,z,w components
         * @param index defines an optional index in the target array to define where to start storing values
         * @returns the current Quaternion object
         */
        toArray(array, index = 0) {
            array[index] = this._x;
            array[index + 1] = this._y;
            array[index + 2] = this._z;
            array[index + 3] = this._w;
            return this;
        }
        /**
         * Check if two quaternions are equals
         * Example Playground https://playground.babylonjs.com/#L49EJ7#38
         * @param otherQuaternion defines the second operand
         * @returns true if the current quaternion and the given one coordinates are strictly equals
         */
        equals(otherQuaternion) {
            return otherQuaternion && this._x === otherQuaternion._x && this._y === otherQuaternion._y && this._z === otherQuaternion._z && this._w === otherQuaternion._w;
        }
        /**
         * Gets a boolean if two quaternions are equals (using an epsilon value)
         * Example Playground https://playground.babylonjs.com/#L49EJ7#37
         * @param otherQuaternion defines the other quaternion
         * @param epsilon defines the minimal distance to consider equality
         * @returns true if the given quaternion coordinates are close to the current ones by a distance of epsilon.
         */
        equalsWithEpsilon(otherQuaternion, epsilon = Epsilon) {
            return (otherQuaternion &&
                Scalar.WithinEpsilon(this._x, otherQuaternion._x, epsilon) &&
                Scalar.WithinEpsilon(this._y, otherQuaternion._y, epsilon) &&
                Scalar.WithinEpsilon(this._z, otherQuaternion._z, epsilon) &&
                Scalar.WithinEpsilon(this._w, otherQuaternion._w, epsilon));
        }
        /**
         * Clone the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#12
         * @returns a new quaternion copied from the current one
         */
        clone() {
            return new this.constructor(this._x, this._y, this._z, this._w);
        }
        /**
         * Copy a quaternion to the current one
         * Example Playground https://playground.babylonjs.com/#L49EJ7#86
         * @param other defines the other quaternion
         * @returns the updated current quaternion
         */
        copyFrom(other) {
            this._x = other._x;
            this._y = other._y;
            this._z = other._z;
            this._w = other._w;
            this._isDirty = true;
            return this;
        }
        /**
         * Updates the current quaternion with the given float coordinates
         * Example Playground https://playground.babylonjs.com/#L49EJ7#87
         * @param x defines the x coordinate
         * @param y defines the y coordinate
         * @param z defines the z coordinate
         * @param w defines the w coordinate
         * @returns the updated current quaternion
         */
        copyFromFloats(x, y, z, w) {
            this._x = x;
            this._y = y;
            this._z = z;
            this._w = w;
            this._isDirty = true;
            return this;
        }
        /**
         * Updates the current quaternion from the given float coordinates
         * Example Playground https://playground.babylonjs.com/#L49EJ7#56
         * @param x defines the x coordinate
         * @param y defines the y coordinate
         * @param z defines the z coordinate
         * @param w defines the w coordinate
         * @returns the updated current quaternion
         */
        set(x, y, z, w) {
            return this.copyFromFloats(x, y, z, w);
        }
        /**
         * Adds two quaternions
         * Example Playground https://playground.babylonjs.com/#L49EJ7#10
         * @param other defines the second operand
         * @returns a new quaternion as the addition result of the given one and the current quaternion
         */
        add(other) {
            return new this.constructor(this._x + other._x, this._y + other._y, this._z + other._z, this._w + other._w);
        }
        /**
         * Add a quaternion to the current one
         * Example Playground https://playground.babylonjs.com/#L49EJ7#11
         * @param other defines the quaternion to add
         * @returns the current quaternion
         */
        addInPlace(other) {
            this._x += other._x;
            this._y += other._y;
            this._z += other._z;
            this._w += other._w;
            this._isDirty = true;
            return this;
        }
        /**
         * Subtract two quaternions
         * Example Playground https://playground.babylonjs.com/#L49EJ7#57
         * @param other defines the second operand
         * @returns a new quaternion as the subtraction result of the given one from the current one
         */
        subtract(other) {
            return new this.constructor(this._x - other._x, this._y - other._y, this._z - other._z, this._w - other._w);
        }
        /**
         * Subtract a quaternion to the current one
         * Example Playground https://playground.babylonjs.com/#L49EJ7#58
         * @param other defines the quaternion to subtract
         * @returns the current quaternion
         */
        subtractInPlace(other) {
            this._x -= other._x;
            this._y -= other._y;
            this._z -= other._z;
            this._w -= other._w;
            this._isDirty = true;
            return this;
        }
        /**
         * Multiplies the current quaternion by a scale factor
         * Example Playground https://playground.babylonjs.com/#L49EJ7#88
         * @param value defines the scale factor
         * @returns a new quaternion set by multiplying the current quaternion coordinates by the float "scale"
         */
        scale(value) {
            return new this.constructor(this._x * value, this._y * value, this._z * value, this._w * value);
        }
        /**
         * Scale the current quaternion values by a factor and stores the result to a given quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#89
         * @param scale defines the scale factor
         * @param result defines the Quaternion object where to store the result
         * @returns result input
         */
        scaleToRef(scale, result) {
            result._x = this._x * scale;
            result._y = this._y * scale;
            result._z = this._z * scale;
            result._w = this._w * scale;
            result._isDirty = true;
            return result;
        }
        /**
         * Multiplies in place the current quaternion by a scale factor
         * Example Playground https://playground.babylonjs.com/#L49EJ7#90
         * @param value defines the scale factor
         * @returns the current modified quaternion
         */
        scaleInPlace(value) {
            this._x *= value;
            this._y *= value;
            this._z *= value;
            this._w *= value;
            this._isDirty = true;
            return this;
        }
        /**
         * Scale the current quaternion values by a factor and add the result to a given quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#91
         * @param scale defines the scale factor
         * @param result defines the Quaternion object where to store the result
         * @returns result input
         */
        scaleAndAddToRef(scale, result) {
            result._x += this._x * scale;
            result._y += this._y * scale;
            result._z += this._z * scale;
            result._w += this._w * scale;
            result._isDirty = true;
            return result;
        }
        /**
         * Multiplies two quaternions
         * Example Playground https://playground.babylonjs.com/#L49EJ7#43
         * @param q1 defines the second operand
         * @returns a new quaternion set as the multiplication result of the current one with the given one "q1"
         */
        multiply(q1) {
            const result = new this.constructor(0, 0, 0, 1.0);
            this.multiplyToRef(q1, result);
            return result;
        }
        /**
         * Sets the given "result" as the the multiplication result of the current one with the given one "q1"
         * Example Playground https://playground.babylonjs.com/#L49EJ7#45
         * @param q1 defines the second operand
         * @param result defines the target quaternion
         * @returns the current quaternion
         */
        multiplyToRef(q1, result) {
            const x = this._x * q1._w + this._y * q1._z - this._z * q1._y + this._w * q1._x;
            const y = -this._x * q1._z + this._y * q1._w + this._z * q1._x + this._w * q1._y;
            const z = this._x * q1._y - this._y * q1._x + this._z * q1._w + this._w * q1._z;
            const w = -this._x * q1._x - this._y * q1._y - this._z * q1._z + this._w * q1._w;
            result.copyFromFloats(x, y, z, w);
            return result;
        }
        /**
         * Updates the current quaternion with the multiplication of itself with the given one "q1"
         * Example Playground https://playground.babylonjs.com/#L49EJ7#46
         * @param q1 defines the second operand
         * @returns the currentupdated quaternion
         */
        multiplyInPlace(q1) {
            this.multiplyToRef(q1, this);
            return this;
        }
        /**
         * Conjugates the current quaternion and stores the result in the given quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#81
         * @param ref defines the target quaternion
         * @returns result input
         */
        conjugateToRef(ref) {
            ref.copyFromFloats(-this._x, -this._y, -this._z, this._w);
            return ref;
        }
        /**
         * Conjugates in place the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#82
         * @returns the current updated quaternion
         */
        conjugateInPlace() {
            this._x *= -1;
            this._y *= -1;
            this._z *= -1;
            this._isDirty = true;
            return this;
        }
        /**
         * Conjugates (1-q) the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#83
         * @returns a new quaternion
         */
        conjugate() {
            return new this.constructor(-this._x, -this._y, -this._z, this._w);
        }
        /**
         * Returns the inverse of the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#84
         * @returns a new quaternion
         */
        invert() {
            const conjugate = this.conjugate();
            const lengthSquared = this.lengthSquared();
            if (lengthSquared == 0 || lengthSquared == 1) {
                return conjugate;
            }
            conjugate.scaleInPlace(1 / lengthSquared);
            return conjugate;
        }
        /**
         * Invert in place the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#85
         * @returns this quaternion
         */
        invertInPlace() {
            this.conjugateInPlace();
            const lengthSquared = this.lengthSquared();
            if (lengthSquared == 0 || lengthSquared == 1) {
                return this;
            }
            this.scaleInPlace(1 / lengthSquared);
            return this;
        }
        /**
         * Gets squared length of current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#29
         * @returns the quaternion length (float)
         */
        lengthSquared() {
            return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
        }
        /**
         * Gets length of current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#28
         * @returns the quaternion length (float)
         */
        length() {
            return Math.sqrt(this.lengthSquared());
        }
        /**
         * Normalize in place the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#54
         * @returns the current updated quaternion
         */
        normalize() {
            const len = this.length();
            if (len === 0) {
                return this;
            }
            const inv = 1.0 / len;
            this.scaleInPlace(inv);
            return this;
        }
        /**
         * Normalize a copy of the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#55
         * @returns the normalized quaternion
         */
        normalizeToNew() {
            const len = this.length();
            if (len === 0) {
                return this.clone();
            }
            const inv = 1.0 / len;
            return this.scale(inv);
        }
        /**
         * Returns a new Vector3 set with the Euler angles translated from the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#32
         * @returns a new Vector3 containing the Euler angles
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
         */
        toEulerAngles() {
            const result = Vector3.Zero();
            this.toEulerAnglesToRef(result);
            return result;
        }
        /**
         * Sets the given vector3 "result" with the Euler angles translated from the current quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#31
         * @param result defines the vector which will be filled with the Euler angles
         * @returns result input
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
         */
        toEulerAnglesToRef(result) {
            const qz = this._z;
            const qx = this._x;
            const qy = this._y;
            const qw = this._w;
            const zAxisY = qy * qz - qx * qw;
            const limit = 0.4999999;
            if (zAxisY < -limit) {
                result._y = 2 * Math.atan2(qy, qw);
                result._x = Math.PI / 2;
                result._z = 0;
                result._isDirty = true;
            }
            else if (zAxisY > limit) {
                result._y = 2 * Math.atan2(qy, qw);
                result._x = -Math.PI / 2;
                result._z = 0;
                result._isDirty = true;
            }
            else {
                const sqw = qw * qw;
                const sqz = qz * qz;
                const sqx = qx * qx;
                const sqy = qy * qy;
                result._z = Math.atan2(2.0 * (qx * qy + qz * qw), -sqz - sqx + sqy + sqw);
                result._x = Math.asin(-2.0 * zAxisY);
                result._y = Math.atan2(2.0 * (qz * qx + qy * qw), sqz - sqx - sqy + sqw);
                result._isDirty = true;
            }
            return result;
        }
        /**
         * Updates the given rotation matrix with the current quaternion values
         * Example Playground https://playground.babylonjs.com/#L49EJ7#67
         * @param result defines the target matrix
         * @returns the current unchanged quaternion
         */
        toRotationMatrix(result) {
            Matrix.FromQuaternionToRef(this, result);
            return result;
        }
        /**
         * Updates the current quaternion from the given rotation matrix values
         * Example Playground https://playground.babylonjs.com/#L49EJ7#41
         * @param matrix defines the source matrix
         * @returns the current updated quaternion
         */
        fromRotationMatrix(matrix) {
            Quaternion.FromRotationMatrixToRef(matrix, this);
            return this;
        }
        // Statics
        /**
         * Creates a new quaternion from a rotation matrix
         * Example Playground https://playground.babylonjs.com/#L49EJ7#101
         * @param matrix defines the source matrix
         * @returns a new quaternion created from the given rotation matrix values
         */
        static FromRotationMatrix(matrix) {
            const result = new Quaternion();
            Quaternion.FromRotationMatrixToRef(matrix, result);
            return result;
        }
        /**
         * Updates the given quaternion with the given rotation matrix values
         * Example Playground https://playground.babylonjs.com/#L49EJ7#102
         * @param matrix defines the source matrix
         * @param result defines the target quaternion
         * @returns result input
         */
        static FromRotationMatrixToRef(matrix, result) {
            const data = matrix.m;
            const m11 = data[0], m12 = data[4], m13 = data[8];
            const m21 = data[1], m22 = data[5], m23 = data[9];
            const m31 = data[2], m32 = data[6], m33 = data[10];
            const trace = m11 + m22 + m33;
            let s;
            if (trace > 0) {
                s = 0.5 / Math.sqrt(trace + 1.0);
                result._w = 0.25 / s;
                result._x = (m32 - m23) * s;
                result._y = (m13 - m31) * s;
                result._z = (m21 - m12) * s;
                result._isDirty = true;
            }
            else if (m11 > m22 && m11 > m33) {
                s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                result._w = (m32 - m23) / s;
                result._x = 0.25 * s;
                result._y = (m12 + m21) / s;
                result._z = (m13 + m31) / s;
                result._isDirty = true;
            }
            else if (m22 > m33) {
                s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                result._w = (m13 - m31) / s;
                result._x = (m12 + m21) / s;
                result._y = 0.25 * s;
                result._z = (m23 + m32) / s;
                result._isDirty = true;
            }
            else {
                s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                result._w = (m21 - m12) / s;
                result._x = (m13 + m31) / s;
                result._y = (m23 + m32) / s;
                result._z = 0.25 * s;
                result._isDirty = true;
            }
            return result;
        }
        /**
         * Returns the dot product (float) between the quaternions "left" and "right"
         * Example Playground https://playground.babylonjs.com/#L49EJ7#61
         * @param left defines the left operand
         * @param right defines the right operand
         * @returns the dot product
         */
        static Dot(left, right) {
            return left._x * right._x + left._y * right._y + left._z * right._z + left._w * right._w;
        }
        /**
         * Checks if the orientations of two rotation quaternions are close to each other
         * Example Playground https://playground.babylonjs.com/#L49EJ7#60
         * @param quat0 defines the first quaternion to check
         * @param quat1 defines the second quaternion to check
         * @param epsilon defines closeness, 0 same orientation, 1 PI apart, default 0.1
         * @returns true if the two quaternions are close to each other within epsilon
         */
        static AreClose(quat0, quat1, epsilon = 0.1) {
            const dot = Quaternion.Dot(quat0, quat1);
            return 1 - dot * dot <= epsilon;
        }
        /**
         * Smooth interpolation between two quaternions using Slerp
         * Example Playground https://playground.babylonjs.com/#L49EJ7#93
         * @param source source quaternion
         * @param goal goal quaternion
         * @param deltaTime current interpolation frame
         * @param lerpTime total interpolation time
         * @param result the smoothed quaternion
         */
        static SmoothToRef(source, goal, deltaTime, lerpTime, result) {
            let slerp = lerpTime === 0 ? 1 : deltaTime / lerpTime;
            slerp = Scalar.Clamp(slerp, 0, 1);
            Quaternion.SlerpToRef(source, goal, slerp, result);
            return result;
        }
        /**
         * Creates an empty quaternion
         * @returns a new quaternion set to (0.0, 0.0, 0.0)
         */
        static Zero() {
            return new Quaternion(0.0, 0.0, 0.0, 0.0);
        }
        /**
         * Inverse a given quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#103
         * @param q defines the source quaternion
         * @returns a new quaternion as the inverted current quaternion
         */
        static Inverse(q) {
            return new q.constructor(-q._x, -q._y, -q._z, q._w);
        }
        /**
         * Inverse a given quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#104
         * @param q defines the source quaternion
         * @param result the quaternion the result will be stored in
         * @returns the result quaternion
         */
        static InverseToRef(q, result) {
            result.set(-q._x, -q._y, -q._z, q._w);
            return result;
        }
        /**
         * Creates an identity quaternion
         * @returns the identity quaternion
         */
        static Identity() {
            return new Quaternion(0.0, 0.0, 0.0, 1.0);
        }
        /**
         * Gets a boolean indicating if the given quaternion is identity
         * @param quaternion defines the quaternion to check
         * @returns true if the quaternion is identity
         */
        static IsIdentity(quaternion) {
            return quaternion && quaternion._x === 0 && quaternion._y === 0 && quaternion._z === 0 && quaternion._w === 1;
        }
        /**
         * Creates a quaternion from a rotation around an axis
         * Example Playground https://playground.babylonjs.com/#L49EJ7#72
         * @param axis defines the axis to use
         * @param angle defines the angle to use
         * @returns a new quaternion created from the given axis (Vector3) and angle in radians (float)
         */
        static RotationAxis(axis, angle) {
            return Quaternion.RotationAxisToRef(axis, angle, new Quaternion());
        }
        /**
         * Creates a rotation around an axis and stores it into the given quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#73
         * @param axis defines the axis to use
         * @param angle defines the angle to use
         * @param result defines the target quaternion
         * @returns the target quaternion
         */
        static RotationAxisToRef(axis, angle, result) {
            const sin = Math.sin(angle / 2);
            axis.normalize();
            result._w = Math.cos(angle / 2);
            result._x = axis._x * sin;
            result._y = axis._y * sin;
            result._z = axis._z * sin;
            result._isDirty = true;
            return result;
        }
        /**
         * Creates a new quaternion from data stored into an array
         * Example Playground https://playground.babylonjs.com/#L49EJ7#63
         * @param array defines the data source
         * @param offset defines the offset in the source array where the data starts
         * @returns a new quaternion
         */
        static FromArray(array, offset) {
            if (!offset) {
                offset = 0;
            }
            return new Quaternion(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
        }
        /**
         * Updates the given quaternion "result" from the starting index of the given array.
         * Example Playground https://playground.babylonjs.com/#L49EJ7#64
         * @param array the array to pull values from
         * @param offset the offset into the array to start at
         * @param result the quaternion to store the result in
         * @returns result input
         */
        static FromArrayToRef(array, offset, result) {
            result._x = array[offset];
            result._y = array[offset + 1];
            result._z = array[offset + 2];
            result._w = array[offset + 3];
            result._isDirty = true;
            return result;
        }
        /**
         * Create a quaternion from Euler rotation angles
         * Example Playground https://playground.babylonjs.com/#L49EJ7#33
         * @param x Pitch
         * @param y Yaw
         * @param z Roll
         * @returns the new Quaternion
         */
        static FromEulerAngles(x, y, z) {
            const q = new Quaternion();
            Quaternion.RotationYawPitchRollToRef(y, x, z, q);
            return q;
        }
        /**
         * Updates a quaternion from Euler rotation angles
         * Example Playground https://playground.babylonjs.com/#L49EJ7#34
         * @param x Pitch
         * @param y Yaw
         * @param z Roll
         * @param result the quaternion to store the result
         * @returns the updated quaternion
         */
        static FromEulerAnglesToRef(x, y, z, result) {
            Quaternion.RotationYawPitchRollToRef(y, x, z, result);
            return result;
        }
        /**
         * Create a quaternion from Euler rotation vector
         * Example Playground https://playground.babylonjs.com/#L49EJ7#35
         * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
         * @returns the new Quaternion
         */
        static FromEulerVector(vec) {
            const q = new Quaternion();
            Quaternion.RotationYawPitchRollToRef(vec._y, vec._x, vec._z, q);
            return q;
        }
        /**
         * Updates a quaternion from Euler rotation vector
         * Example Playground https://playground.babylonjs.com/#L49EJ7#36
         * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
         * @param result the quaternion to store the result
         * @returns the updated quaternion
         */
        static FromEulerVectorToRef(vec, result) {
            Quaternion.RotationYawPitchRollToRef(vec._y, vec._x, vec._z, result);
            return result;
        }
        /**
         * Updates a quaternion so that it rotates vector vecFrom to vector vecTo
         * Example Playground - https://playground.babylonjs.com/#L49EJ7#70
         * @param vecFrom defines the direction vector from which to rotate
         * @param vecTo defines the direction vector to which to rotate
         * @param result the quaternion to store the result
         * @param epsilon defines the minimal dot value to define vecs as opposite. Default: `BABYLON.Epsilon`
         * @returns the updated quaternion
         */
        static FromUnitVectorsToRef(vecFrom, vecTo, result, epsilon = Epsilon) {
            const r = Vector3.Dot(vecFrom, vecTo) + 1;
            if (r < epsilon) {
                if (Math.abs(vecFrom.x) > Math.abs(vecFrom.z)) {
                    result.set(-vecFrom.y, vecFrom.x, 0, 0);
                }
                else {
                    result.set(0, -vecFrom.z, vecFrom.y, 0);
                }
            }
            else {
                Vector3.CrossToRef(vecFrom, vecTo, TmpVectors.Vector3[0]);
                result.set(TmpVectors.Vector3[0].x, TmpVectors.Vector3[0].y, TmpVectors.Vector3[0].z, r);
            }
            return result.normalize();
        }
        /**
         * Creates a new quaternion from the given Euler float angles (y, x, z)
         * Example Playground https://playground.babylonjs.com/#L49EJ7#77
         * @param yaw defines the rotation around Y axis
         * @param pitch defines the rotation around X axis
         * @param roll defines the rotation around Z axis
         * @returns the new quaternion
         */
        static RotationYawPitchRoll(yaw, pitch, roll) {
            const q = new Quaternion();
            Quaternion.RotationYawPitchRollToRef(yaw, pitch, roll, q);
            return q;
        }
        /**
         * Creates a new rotation from the given Euler float angles (y, x, z) and stores it in the target quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#78
         * @param yaw defines the rotation around Y axis
         * @param pitch defines the rotation around X axis
         * @param roll defines the rotation around Z axis
         * @param result defines the target quaternion
         * @returns result input
         */
        static RotationYawPitchRollToRef(yaw, pitch, roll, result) {
            // Produces a quaternion from Euler angles in the z-y-x orientation (Tait-Bryan angles)
            const halfRoll = roll * 0.5;
            const halfPitch = pitch * 0.5;
            const halfYaw = yaw * 0.5;
            const sinRoll = Math.sin(halfRoll);
            const cosRoll = Math.cos(halfRoll);
            const sinPitch = Math.sin(halfPitch);
            const cosPitch = Math.cos(halfPitch);
            const sinYaw = Math.sin(halfYaw);
            const cosYaw = Math.cos(halfYaw);
            result._x = cosYaw * sinPitch * cosRoll + sinYaw * cosPitch * sinRoll;
            result._y = sinYaw * cosPitch * cosRoll - cosYaw * sinPitch * sinRoll;
            result._z = cosYaw * cosPitch * sinRoll - sinYaw * sinPitch * cosRoll;
            result._w = cosYaw * cosPitch * cosRoll + sinYaw * sinPitch * sinRoll;
            result._isDirty = true;
            return result;
        }
        /**
         * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation
         * Example Playground https://playground.babylonjs.com/#L49EJ7#68
         * @param alpha defines the rotation around first axis
         * @param beta defines the rotation around second axis
         * @param gamma defines the rotation around third axis
         * @returns the new quaternion
         */
        static RotationAlphaBetaGamma(alpha, beta, gamma) {
            const result = new Quaternion();
            Quaternion.RotationAlphaBetaGammaToRef(alpha, beta, gamma, result);
            return result;
        }
        /**
         * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation and stores it in the target quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#69
         * @param alpha defines the rotation around first axis
         * @param beta defines the rotation around second axis
         * @param gamma defines the rotation around third axis
         * @param result defines the target quaternion
         * @returns result input
         */
        static RotationAlphaBetaGammaToRef(alpha, beta, gamma, result) {
            // Produces a quaternion from Euler angles in the z-x-z orientation
            const halfGammaPlusAlpha = (gamma + alpha) * 0.5;
            const halfGammaMinusAlpha = (gamma - alpha) * 0.5;
            const halfBeta = beta * 0.5;
            result._x = Math.cos(halfGammaMinusAlpha) * Math.sin(halfBeta);
            result._y = Math.sin(halfGammaMinusAlpha) * Math.sin(halfBeta);
            result._z = Math.sin(halfGammaPlusAlpha) * Math.cos(halfBeta);
            result._w = Math.cos(halfGammaPlusAlpha) * Math.cos(halfBeta);
            result._isDirty = true;
            return result;
        }
        /**
         * Creates a new quaternion containing the rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation)
         * Example Playground https://playground.babylonjs.com/#L49EJ7#75
         * @param axis1 defines the first axis
         * @param axis2 defines the second axis
         * @param axis3 defines the third axis
         * @returns the new quaternion
         */
        static RotationQuaternionFromAxis(axis1, axis2, axis3) {
            const quat = new Quaternion(0.0, 0.0, 0.0, 0.0);
            Quaternion.RotationQuaternionFromAxisToRef(axis1, axis2, axis3, quat);
            return quat;
        }
        /**
         * Creates a rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation) and stores it in the target quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#76
         * @param axis1 defines the first axis
         * @param axis2 defines the second axis
         * @param axis3 defines the third axis
         * @param ref defines the target quaternion
         * @returns result input
         */
        static RotationQuaternionFromAxisToRef(axis1, axis2, axis3, ref) {
            const rotMat = MathTmp.Matrix[0];
            Matrix.FromXYZAxesToRef(axis1.normalize(), axis2.normalize(), axis3.normalize(), rotMat);
            Quaternion.FromRotationMatrixToRef(rotMat, ref);
            return ref;
        }
        /**
         * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
         * This function works in left handed mode
         * Example Playground https://playground.babylonjs.com/#L49EJ7#96
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @returns A new quaternion oriented toward the specified forward and up.
         */
        static FromLookDirectionLH(forward, up) {
            const quat = new Quaternion();
            Quaternion.FromLookDirectionLHToRef(forward, up, quat);
            return quat;
        }
        /**
         * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
         * This function works in left handed mode
         * Example Playground https://playground.babylonjs.com/#L49EJ7#97
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @param ref defines the target quaternion.
         * @returns result input
         */
        static FromLookDirectionLHToRef(forward, up, ref) {
            const rotMat = MathTmp.Matrix[0];
            Matrix.LookDirectionLHToRef(forward, up, rotMat);
            Quaternion.FromRotationMatrixToRef(rotMat, ref);
            return ref;
        }
        /**
         * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
         * This function works in right handed mode
         * Example Playground https://playground.babylonjs.com/#L49EJ7#98
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @returns A new quaternion oriented toward the specified forward and up.
         */
        static FromLookDirectionRH(forward, up) {
            const quat = new Quaternion();
            Quaternion.FromLookDirectionRHToRef(forward, up, quat);
            return quat;
        }
        /**
         * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
         * This function works in right handed mode
         * Example Playground https://playground.babylonjs.com/#L49EJ7#105
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @param ref defines the target quaternion.
         * @returns result input
         */
        static FromLookDirectionRHToRef(forward, up, ref) {
            const rotMat = MathTmp.Matrix[0];
            Matrix.LookDirectionRHToRef(forward, up, rotMat);
            return Quaternion.FromRotationMatrixToRef(rotMat, ref);
        }
        /**
         * Interpolates between two quaternions
         * Example Playground https://playground.babylonjs.com/#L49EJ7#79
         * @param left defines first quaternion
         * @param right defines second quaternion
         * @param amount defines the gradient to use
         * @returns the new interpolated quaternion
         */
        static Slerp(left, right, amount) {
            const result = Quaternion.Identity();
            Quaternion.SlerpToRef(left, right, amount, result);
            return result;
        }
        /**
         * Interpolates between two quaternions and stores it into a target quaternion
         * Example Playground https://playground.babylonjs.com/#L49EJ7#92
         * @param left defines first quaternion
         * @param right defines second quaternion
         * @param amount defines the gradient to use
         * @param result defines the target quaternion
         * @returns result input
         */
        static SlerpToRef(left, right, amount, result) {
            let num2;
            let num3;
            let num4 = left._x * right._x + left._y * right._y + left._z * right._z + left._w * right._w;
            let flag = false;
            if (num4 < 0) {
                flag = true;
                num4 = -num4;
            }
            if (num4 > 0.999999) {
                num3 = 1 - amount;
                num2 = flag ? -amount : amount;
            }
            else {
                const num5 = Math.acos(num4);
                const num6 = 1.0 / Math.sin(num5);
                num3 = Math.sin((1.0 - amount) * num5) * num6;
                num2 = flag ? -Math.sin(amount * num5) * num6 : Math.sin(amount * num5) * num6;
            }
            result._x = num3 * left._x + num2 * right._x;
            result._y = num3 * left._y + num2 * right._y;
            result._z = num3 * left._z + num2 * right._z;
            result._w = num3 * left._w + num2 * right._w;
            result._isDirty = true;
            return result;
        }
        /**
         * Interpolate between two quaternions using Hermite interpolation
         * Example Playground https://playground.babylonjs.com/#L49EJ7#47
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-quaternion-spline
         * @param value1 defines first quaternion
         * @param tangent1 defines the incoming tangent
         * @param value2 defines second quaternion
         * @param tangent2 defines the outgoing tangent
         * @param amount defines the target quaternion
         * @returns the new interpolated quaternion
         */
        static Hermite(value1, tangent1, value2, tangent2, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
            const part2 = -2.0 * cubed + 3.0 * squared;
            const part3 = cubed - 2.0 * squared + amount;
            const part4 = cubed - squared;
            const x = value1._x * part1 + value2._x * part2 + tangent1._x * part3 + tangent2._x * part4;
            const y = value1._y * part1 + value2._y * part2 + tangent1._y * part3 + tangent2._y * part4;
            const z = value1._z * part1 + value2._z * part2 + tangent1._z * part3 + tangent2._z * part4;
            const w = value1._w * part1 + value2._w * part2 + tangent1._w * part3 + tangent2._w * part4;
            return new value1.constructor(x, y, z, w);
        }
        /**
         * Returns a new Quaternion which is the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
         * Example Playground https://playground.babylonjs.com/#L49EJ7#48
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @returns 1st derivative
         */
        static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
            const result = new value1.constructor();
            this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
            return result;
        }
        /**
         * Update a Quaternion with the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
         * Example Playground https://playground.babylonjs.com/#L49EJ7#49
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @param result define where to store the derivative
         * @returns result input
         */
        static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
            const t2 = time * time;
            result._x = (t2 - time) * 6 * value1._x + (3 * t2 - 4 * time + 1) * tangent1._x + (-t2 + time) * 6 * value2._x + (3 * t2 - 2 * time) * tangent2._x;
            result._y = (t2 - time) * 6 * value1._y + (3 * t2 - 4 * time + 1) * tangent1._y + (-t2 + time) * 6 * value2._y + (3 * t2 - 2 * time) * tangent2._y;
            result._z = (t2 - time) * 6 * value1._z + (3 * t2 - 4 * time + 1) * tangent1._z + (-t2 + time) * 6 * value2._z + (3 * t2 - 2 * time) * tangent2._z;
            result._w = (t2 - time) * 6 * value1._w + (3 * t2 - 4 * time + 1) * tangent1._w + (-t2 + time) * 6 * value2._w + (3 * t2 - 2 * time) * tangent2._w;
            result._isDirty = true;
            return result;
        }
    }
    /**
     * Class used to store matrix data (4x4)
     * Note on matrix definitions in Babylon.js for setting values directly
     * rather than using one of the methods available.
     * Matrix size is given by rows x columns.
     * A Vector3 is a 1 X 3 matrix [x, y, z].
     *
     * In Babylon.js multiplying a 1 x 3 matrix by a 4 x 4 matrix
     * is done using BABYLON.Vector4.TransformCoordinates(Vector3, Matrix).
     * and extending the passed Vector3 to a Vector4, V = [x, y, z, 1].
     * Let M be a matrix with elements m(row, column), so that
     * m(2, 3) is the element in row 2 column 3 of M.
     *
     * Multiplication is of the form VM and has the resulting Vector4
     * VM = [xm(0, 0) + ym(1, 0) + zm(2, 0) + m(3, 0), xm(0, 1) + ym(1, 1) + zm(2, 1) + m(3, 1), xm(0, 2) + ym(1, 2) + zm(2, 2) + m(3, 2), xm(0, 3) + ym(1, 3) + zm(2, 3) + m(3, 3)].
     * On the web you will find many examples that use the opposite convention of MV,
     * in which case to make use of the examples you will need to transpose the matrix.
     *
     * Example Playground - Overview Linear Algebra - https://playground.babylonjs.com/#AV9X17
     * Example Playground - Overview Transformation - https://playground.babylonjs.com/#AV9X17#1
     * Example Playground - Overview Projection - https://playground.babylonjs.com/#AV9X17#2
     */
    class Matrix {
        /**
         * Gets the precision of matrix computations
         */
        static get Use64Bits() {
            return PerformanceConfigurator.MatrixUse64Bits;
        }
        /**
         * Gets the internal data of the matrix
         */
        get m() {
            return this._m;
        }
        /**
         * Update the updateFlag to indicate that the matrix has been updated
         */
        markAsUpdated() {
            this.updateFlag = Matrix._UpdateFlagSeed++;
            this._isIdentity = false;
            this._isIdentity3x2 = false;
            this._isIdentityDirty = true;
            this._isIdentity3x2Dirty = true;
        }
        _updateIdentityStatus(isIdentity, isIdentityDirty = false, isIdentity3x2 = false, isIdentity3x2Dirty = true) {
            this._isIdentity = isIdentity;
            this._isIdentity3x2 = isIdentity || isIdentity3x2;
            this._isIdentityDirty = this._isIdentity ? false : isIdentityDirty;
            this._isIdentity3x2Dirty = this._isIdentity3x2 ? false : isIdentity3x2Dirty;
        }
        /**
         * Creates an empty matrix (filled with zeros)
         */
        constructor() {
            this._isIdentity = false;
            this._isIdentityDirty = true;
            this._isIdentity3x2 = true;
            this._isIdentity3x2Dirty = true;
            /**
             * Gets the update flag of the matrix which is an unique number for the matrix.
             * It will be incremented every time the matrix data change.
             * You can use it to speed the comparison between two versions of the same matrix.
             */
            this.updateFlag = -1;
            if (PerformanceConfigurator.MatrixTrackPrecisionChange) {
                PerformanceConfigurator.MatrixTrackedMatrices.push(this);
            }
            this._m = new PerformanceConfigurator.MatrixCurrentType(16);
            this.markAsUpdated();
        }
        // Properties
        /**
         * Check if the current matrix is identity
         * @returns true is the matrix is the identity matrix
         */
        isIdentity() {
            if (this._isIdentityDirty) {
                this._isIdentityDirty = false;
                const m = this._m;
                this._isIdentity =
                    m[0] === 1.0 &&
                        m[1] === 0.0 &&
                        m[2] === 0.0 &&
                        m[3] === 0.0 &&
                        m[4] === 0.0 &&
                        m[5] === 1.0 &&
                        m[6] === 0.0 &&
                        m[7] === 0.0 &&
                        m[8] === 0.0 &&
                        m[9] === 0.0 &&
                        m[10] === 1.0 &&
                        m[11] === 0.0 &&
                        m[12] === 0.0 &&
                        m[13] === 0.0 &&
                        m[14] === 0.0 &&
                        m[15] === 1.0;
            }
            return this._isIdentity;
        }
        /**
         * Check if the current matrix is identity as a texture matrix (3x2 store in 4x4)
         * @returns true is the matrix is the identity matrix
         */
        isIdentityAs3x2() {
            if (this._isIdentity3x2Dirty) {
                this._isIdentity3x2Dirty = false;
                if (this._m[0] !== 1.0 || this._m[5] !== 1.0 || this._m[15] !== 1.0) {
                    this._isIdentity3x2 = false;
                }
                else if (this._m[1] !== 0.0 ||
                    this._m[2] !== 0.0 ||
                    this._m[3] !== 0.0 ||
                    this._m[4] !== 0.0 ||
                    this._m[6] !== 0.0 ||
                    this._m[7] !== 0.0 ||
                    this._m[8] !== 0.0 ||
                    this._m[9] !== 0.0 ||
                    this._m[10] !== 0.0 ||
                    this._m[11] !== 0.0 ||
                    this._m[12] !== 0.0 ||
                    this._m[13] !== 0.0 ||
                    this._m[14] !== 0.0) {
                    this._isIdentity3x2 = false;
                }
                else {
                    this._isIdentity3x2 = true;
                }
            }
            return this._isIdentity3x2;
        }
        /**
         * Gets the determinant of the matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#34
         * @returns the matrix determinant
         */
        determinant() {
            if (this._isIdentity === true) {
                return 1;
            }
            const m = this._m;
            const m00 = m[0], m01 = m[1], m02 = m[2], m03 = m[3];
            const m10 = m[4], m11 = m[5], m12 = m[6], m13 = m[7];
            const m20 = m[8], m21 = m[9], m22 = m[10], m23 = m[11];
            const m30 = m[12], m31 = m[13], m32 = m[14], m33 = m[15];
            // https://en.wikipedia.org/wiki/Laplace_expansion
            // to compute the deterrminant of a 4x4 Matrix we compute the cofactors of any row or column,
            // then we multiply each Cofactor by its corresponding matrix value and sum them all to get the determinant
            // Cofactor(i, j) = sign(i,j) * det(Minor(i, j))
            // where
            //  - sign(i,j) = (i+j) % 2 === 0 ? 1 : -1
            //  - Minor(i, j) is the 3x3 matrix we get by removing row i and column j from current Matrix
            //
            // Here we do that for the 1st row.
            const det_22_33 = m22 * m33 - m32 * m23;
            const det_21_33 = m21 * m33 - m31 * m23;
            const det_21_32 = m21 * m32 - m31 * m22;
            const det_20_33 = m20 * m33 - m30 * m23;
            const det_20_32 = m20 * m32 - m22 * m30;
            const det_20_31 = m20 * m31 - m30 * m21;
            const cofact_00 = +(m11 * det_22_33 - m12 * det_21_33 + m13 * det_21_32);
            const cofact_01 = -(m10 * det_22_33 - m12 * det_20_33 + m13 * det_20_32);
            const cofact_02 = +(m10 * det_21_33 - m11 * det_20_33 + m13 * det_20_31);
            const cofact_03 = -(m10 * det_21_32 - m11 * det_20_32 + m12 * det_20_31);
            return m00 * cofact_00 + m01 * cofact_01 + m02 * cofact_02 + m03 * cofact_03;
        }
        // Methods
        /**
         * Returns the matrix as a Float32Array or Array<number>
         * Example Playground - https://playground.babylonjs.com/#AV9X17#49
         * @returns the matrix underlying array
         */
        toArray() {
            return this._m;
        }
        /**
         * Returns the matrix as a Float32Array or Array<number>
         * Example Playground - https://playground.babylonjs.com/#AV9X17#114
         * @returns the matrix underlying array.
         */
        asArray() {
            return this._m;
        }
        /**
         * Inverts the current matrix in place
         * Example Playground - https://playground.babylonjs.com/#AV9X17#118
         * @returns the current inverted matrix
         */
        invert() {
            this.invertToRef(this);
            return this;
        }
        /**
         * Sets all the matrix elements to zero
         * @returns the current matrix
         */
        reset() {
            Matrix.FromValuesToRef(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, this);
            this._updateIdentityStatus(false);
            return this;
        }
        /**
         * Adds the current matrix with a second one
         * Example Playground - https://playground.babylonjs.com/#AV9X17#44
         * @param other defines the matrix to add
         * @returns a new matrix as the addition of the current matrix and the given one
         */
        add(other) {
            const result = new this.constructor();
            this.addToRef(other, result);
            return result;
        }
        /**
         * Sets the given matrix "result" to the addition of the current matrix and the given one
         * Example Playground - https://playground.babylonjs.com/#AV9X17#45
         * @param other defines the matrix to add
         * @param result defines the target matrix
         * @returns result input
         */
        addToRef(other, result) {
            const m = this._m;
            const resultM = result._m;
            const otherM = other.m;
            for (let index = 0; index < 16; index++) {
                resultM[index] = m[index] + otherM[index];
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Adds in place the given matrix to the current matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#46
         * @param other defines the second operand
         * @returns the current updated matrix
         */
        addToSelf(other) {
            const m = this._m;
            const otherM = other.m;
            for (let index = 0; index < 16; index++) {
                m[index] += otherM[index];
            }
            this.markAsUpdated();
            return this;
        }
        /**
         * Sets the given matrix to the current inverted Matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#119
         * @param other defines the target matrix
         * @returns result input
         */
        invertToRef(other) {
            if (this._isIdentity === true) {
                Matrix.IdentityToRef(other);
                return other;
            }
            // the inverse of a Matrix is the transpose of cofactor matrix divided by the determinant
            const m = this._m;
            const m00 = m[0], m01 = m[1], m02 = m[2], m03 = m[3];
            const m10 = m[4], m11 = m[5], m12 = m[6], m13 = m[7];
            const m20 = m[8], m21 = m[9], m22 = m[10], m23 = m[11];
            const m30 = m[12], m31 = m[13], m32 = m[14], m33 = m[15];
            const det_22_33 = m22 * m33 - m32 * m23;
            const det_21_33 = m21 * m33 - m31 * m23;
            const det_21_32 = m21 * m32 - m31 * m22;
            const det_20_33 = m20 * m33 - m30 * m23;
            const det_20_32 = m20 * m32 - m22 * m30;
            const det_20_31 = m20 * m31 - m30 * m21;
            const cofact_00 = +(m11 * det_22_33 - m12 * det_21_33 + m13 * det_21_32);
            const cofact_01 = -(m10 * det_22_33 - m12 * det_20_33 + m13 * det_20_32);
            const cofact_02 = +(m10 * det_21_33 - m11 * det_20_33 + m13 * det_20_31);
            const cofact_03 = -(m10 * det_21_32 - m11 * det_20_32 + m12 * det_20_31);
            const det = m00 * cofact_00 + m01 * cofact_01 + m02 * cofact_02 + m03 * cofact_03;
            if (det === 0) {
                // not invertible
                other.copyFrom(this);
                return other;
            }
            const detInv = 1 / det;
            const det_12_33 = m12 * m33 - m32 * m13;
            const det_11_33 = m11 * m33 - m31 * m13;
            const det_11_32 = m11 * m32 - m31 * m12;
            const det_10_33 = m10 * m33 - m30 * m13;
            const det_10_32 = m10 * m32 - m30 * m12;
            const det_10_31 = m10 * m31 - m30 * m11;
            const det_12_23 = m12 * m23 - m22 * m13;
            const det_11_23 = m11 * m23 - m21 * m13;
            const det_11_22 = m11 * m22 - m21 * m12;
            const det_10_23 = m10 * m23 - m20 * m13;
            const det_10_22 = m10 * m22 - m20 * m12;
            const det_10_21 = m10 * m21 - m20 * m11;
            const cofact_10 = -(m01 * det_22_33 - m02 * det_21_33 + m03 * det_21_32);
            const cofact_11 = +(m00 * det_22_33 - m02 * det_20_33 + m03 * det_20_32);
            const cofact_12 = -(m00 * det_21_33 - m01 * det_20_33 + m03 * det_20_31);
            const cofact_13 = +(m00 * det_21_32 - m01 * det_20_32 + m02 * det_20_31);
            const cofact_20 = +(m01 * det_12_33 - m02 * det_11_33 + m03 * det_11_32);
            const cofact_21 = -(m00 * det_12_33 - m02 * det_10_33 + m03 * det_10_32);
            const cofact_22 = +(m00 * det_11_33 - m01 * det_10_33 + m03 * det_10_31);
            const cofact_23 = -(m00 * det_11_32 - m01 * det_10_32 + m02 * det_10_31);
            const cofact_30 = -(m01 * det_12_23 - m02 * det_11_23 + m03 * det_11_22);
            const cofact_31 = +(m00 * det_12_23 - m02 * det_10_23 + m03 * det_10_22);
            const cofact_32 = -(m00 * det_11_23 - m01 * det_10_23 + m03 * det_10_21);
            const cofact_33 = +(m00 * det_11_22 - m01 * det_10_22 + m02 * det_10_21);
            Matrix.FromValuesToRef(cofact_00 * detInv, cofact_10 * detInv, cofact_20 * detInv, cofact_30 * detInv, cofact_01 * detInv, cofact_11 * detInv, cofact_21 * detInv, cofact_31 * detInv, cofact_02 * detInv, cofact_12 * detInv, cofact_22 * detInv, cofact_32 * detInv, cofact_03 * detInv, cofact_13 * detInv, cofact_23 * detInv, cofact_33 * detInv, other);
            return other;
        }
        /**
         * add a value at the specified position in the current Matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#47
         * @param index the index of the value within the matrix. between 0 and 15.
         * @param value the value to be added
         * @returns the current updated matrix
         */
        addAtIndex(index, value) {
            this._m[index] += value;
            this.markAsUpdated();
            return this;
        }
        /**
         * mutiply the specified position in the current Matrix by a value
         * @param index the index of the value within the matrix. between 0 and 15.
         * @param value the value to be added
         * @returns the current updated matrix
         */
        multiplyAtIndex(index, value) {
            this._m[index] *= value;
            this.markAsUpdated();
            return this;
        }
        /**
         * Inserts the translation vector (using 3 floats) in the current matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#120
         * @param x defines the 1st component of the translation
         * @param y defines the 2nd component of the translation
         * @param z defines the 3rd component of the translation
         * @returns the current updated matrix
         */
        setTranslationFromFloats(x, y, z) {
            this._m[12] = x;
            this._m[13] = y;
            this._m[14] = z;
            this.markAsUpdated();
            return this;
        }
        /**
         * Adds the translation vector (using 3 floats) in the current matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#20
         * Example Playground - https://playground.babylonjs.com/#AV9X17#48
         * @param x defines the 1st component of the translation
         * @param y defines the 2nd component of the translation
         * @param z defines the 3rd component of the translation
         * @returns the current updated matrix
         */
        addTranslationFromFloats(x, y, z) {
            this._m[12] += x;
            this._m[13] += y;
            this._m[14] += z;
            this.markAsUpdated();
            return this;
        }
        /**
         * Inserts the translation vector in the current matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#121
         * @param vector3 defines the translation to insert
         * @returns the current updated matrix
         */
        setTranslation(vector3) {
            return this.setTranslationFromFloats(vector3._x, vector3._y, vector3._z);
        }
        /**
         * Gets the translation value of the current matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#122
         * @returns a new Vector3 as the extracted translation from the matrix
         */
        getTranslation() {
            return new Vector3(this._m[12], this._m[13], this._m[14]);
        }
        /**
         * Fill a Vector3 with the extracted translation from the matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#123
         * @param result defines the Vector3 where to store the translation
         * @returns the current matrix
         */
        getTranslationToRef(result) {
            result.x = this._m[12];
            result.y = this._m[13];
            result.z = this._m[14];
            return result;
        }
        /**
         * Remove rotation and scaling part from the matrix
         * @returns the updated matrix
         */
        removeRotationAndScaling() {
            const m = this.m;
            Matrix.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, m[12], m[13], m[14], m[15], this);
            this._updateIdentityStatus(m[12] === 0 && m[13] === 0 && m[14] === 0 && m[15] === 1);
            return this;
        }
        /**
         * Multiply two matrices
         * Example Playground - https://playground.babylonjs.com/#AV9X17#15
         * A.multiply(B) means apply B to A so result is B x A
         * @param other defines the second operand
         * @returns a new matrix set with the multiplication result of the current Matrix and the given one
         */
        multiply(other) {
            const result = new this.constructor();
            this.multiplyToRef(other, result);
            return result;
        }
        /**
         * Copy the current matrix from the given one
         * Example Playground - https://playground.babylonjs.com/#AV9X17#21
         * @param other defines the source matrix
         * @returns the current updated matrix
         */
        copyFrom(other) {
            other.copyToArray(this._m);
            const o = other;
            this.updateFlag = o.updateFlag;
            this._updateIdentityStatus(o._isIdentity, o._isIdentityDirty, o._isIdentity3x2, o._isIdentity3x2Dirty);
            return this;
        }
        /**
         * Populates the given array from the starting index with the current matrix values
         * @param array defines the target array
         * @param offset defines the offset in the target array where to start storing values
         * @returns the current matrix
         */
        copyToArray(array, offset = 0) {
            const source = this._m;
            array[offset] = source[0];
            array[offset + 1] = source[1];
            array[offset + 2] = source[2];
            array[offset + 3] = source[3];
            array[offset + 4] = source[4];
            array[offset + 5] = source[5];
            array[offset + 6] = source[6];
            array[offset + 7] = source[7];
            array[offset + 8] = source[8];
            array[offset + 9] = source[9];
            array[offset + 10] = source[10];
            array[offset + 11] = source[11];
            array[offset + 12] = source[12];
            array[offset + 13] = source[13];
            array[offset + 14] = source[14];
            array[offset + 15] = source[15];
            return this;
        }
        /**
         * Sets the given matrix "result" with the multiplication result of the current Matrix and the given one
         * A.multiplyToRef(B, R) means apply B to A and store in R and R = B x A
         * Example Playground - https://playground.babylonjs.com/#AV9X17#16
         * @param other defines the second operand
         * @param result defines the matrix where to store the multiplication
         * @returns result input
         */
        multiplyToRef(other, result) {
            if (this._isIdentity) {
                result.copyFrom(other);
                return result;
            }
            if (other._isIdentity) {
                result.copyFrom(this);
                return result;
            }
            this.multiplyToArray(other, result._m, 0);
            result.markAsUpdated();
            return result;
        }
        /**
         * Sets the Float32Array "result" from the given index "offset" with the multiplication of the current matrix and the given one
         * @param other defines the second operand
         * @param result defines the array where to store the multiplication
         * @param offset defines the offset in the target array where to start storing values
         * @returns the current matrix
         */
        multiplyToArray(other, result, offset) {
            const m = this._m;
            const otherM = other.m;
            const tm0 = m[0], tm1 = m[1], tm2 = m[2], tm3 = m[3];
            const tm4 = m[4], tm5 = m[5], tm6 = m[6], tm7 = m[7];
            const tm8 = m[8], tm9 = m[9], tm10 = m[10], tm11 = m[11];
            const tm12 = m[12], tm13 = m[13], tm14 = m[14], tm15 = m[15];
            const om0 = otherM[0], om1 = otherM[1], om2 = otherM[2], om3 = otherM[3];
            const om4 = otherM[4], om5 = otherM[5], om6 = otherM[6], om7 = otherM[7];
            const om8 = otherM[8], om9 = otherM[9], om10 = otherM[10], om11 = otherM[11];
            const om12 = otherM[12], om13 = otherM[13], om14 = otherM[14], om15 = otherM[15];
            result[offset] = tm0 * om0 + tm1 * om4 + tm2 * om8 + tm3 * om12;
            result[offset + 1] = tm0 * om1 + tm1 * om5 + tm2 * om9 + tm3 * om13;
            result[offset + 2] = tm0 * om2 + tm1 * om6 + tm2 * om10 + tm3 * om14;
            result[offset + 3] = tm0 * om3 + tm1 * om7 + tm2 * om11 + tm3 * om15;
            result[offset + 4] = tm4 * om0 + tm5 * om4 + tm6 * om8 + tm7 * om12;
            result[offset + 5] = tm4 * om1 + tm5 * om5 + tm6 * om9 + tm7 * om13;
            result[offset + 6] = tm4 * om2 + tm5 * om6 + tm6 * om10 + tm7 * om14;
            result[offset + 7] = tm4 * om3 + tm5 * om7 + tm6 * om11 + tm7 * om15;
            result[offset + 8] = tm8 * om0 + tm9 * om4 + tm10 * om8 + tm11 * om12;
            result[offset + 9] = tm8 * om1 + tm9 * om5 + tm10 * om9 + tm11 * om13;
            result[offset + 10] = tm8 * om2 + tm9 * om6 + tm10 * om10 + tm11 * om14;
            result[offset + 11] = tm8 * om3 + tm9 * om7 + tm10 * om11 + tm11 * om15;
            result[offset + 12] = tm12 * om0 + tm13 * om4 + tm14 * om8 + tm15 * om12;
            result[offset + 13] = tm12 * om1 + tm13 * om5 + tm14 * om9 + tm15 * om13;
            result[offset + 14] = tm12 * om2 + tm13 * om6 + tm14 * om10 + tm15 * om14;
            result[offset + 15] = tm12 * om3 + tm13 * om7 + tm14 * om11 + tm15 * om15;
            return this;
        }
        /**
         * Check equality between this matrix and a second one
         * @param value defines the second matrix to compare
         * @returns true is the current matrix and the given one values are strictly equal
         */
        equals(value) {
            const other = value;
            if (!other) {
                return false;
            }
            if (this._isIdentity || other._isIdentity) {
                if (!this._isIdentityDirty && !other._isIdentityDirty) {
                    return this._isIdentity && other._isIdentity;
                }
            }
            const m = this.m;
            const om = other.m;
            return (m[0] === om[0] &&
                m[1] === om[1] &&
                m[2] === om[2] &&
                m[3] === om[3] &&
                m[4] === om[4] &&
                m[5] === om[5] &&
                m[6] === om[6] &&
                m[7] === om[7] &&
                m[8] === om[8] &&
                m[9] === om[9] &&
                m[10] === om[10] &&
                m[11] === om[11] &&
                m[12] === om[12] &&
                m[13] === om[13] &&
                m[14] === om[14] &&
                m[15] === om[15]);
        }
        /**
         * Clone the current matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#18
         * @returns a new matrix from the current matrix
         */
        clone() {
            const matrix = new this.constructor();
            matrix.copyFrom(this);
            return matrix;
        }
        /**
         * Returns the name of the current matrix class
         * @returns the string "Matrix"
         */
        getClassName() {
            return "Matrix";
        }
        /**
         * Gets the hash code of the current matrix
         * @returns the hash code
         */
        getHashCode() {
            let hash = _ExtractAsInt(this._m[0]);
            for (let i = 1; i < 16; i++) {
                hash = (hash * 397) ^ _ExtractAsInt(this._m[i]);
            }
            return hash;
        }
        /**
         * Decomposes the current Matrix into a translation, rotation and scaling components of the provided node
         * Example Playground - https://playground.babylonjs.com/#AV9X17#13
         * @param node the node to decompose the matrix to
         * @returns true if operation was successful
         */
        decomposeToTransformNode(node) {
            node.rotationQuaternion = node.rotationQuaternion || new Quaternion();
            return this.decompose(node.scaling, node.rotationQuaternion, node.position);
        }
        /**
         * Decomposes the current Matrix into a translation, rotation and scaling components
         * Example Playground - https://playground.babylonjs.com/#AV9X17#12
         * @param scale defines the scale vector3 given as a reference to update
         * @param rotation defines the rotation quaternion given as a reference to update
         * @param translation defines the translation vector3 given as a reference to update
         * @param preserveScalingNode Use scaling sign coming from this node. Otherwise scaling sign might change.
         * @returns true if operation was successful
         */
        decompose(scale, rotation, translation, preserveScalingNode) {
            if (this._isIdentity) {
                if (translation) {
                    translation.setAll(0);
                }
                if (scale) {
                    scale.setAll(1);
                }
                if (rotation) {
                    rotation.copyFromFloats(0, 0, 0, 1);
                }
                return true;
            }
            const m = this._m;
            if (translation) {
                translation.copyFromFloats(m[12], m[13], m[14]);
            }
            scale = scale || MathTmp.Vector3[0];
            scale.x = Math.sqrt(m[0] * m[0] + m[1] * m[1] + m[2] * m[2]);
            scale.y = Math.sqrt(m[4] * m[4] + m[5] * m[5] + m[6] * m[6]);
            scale.z = Math.sqrt(m[8] * m[8] + m[9] * m[9] + m[10] * m[10]);
            if (preserveScalingNode) {
                const signX = preserveScalingNode.scaling.x < 0 ? -1 : 1;
                const signY = preserveScalingNode.scaling.y < 0 ? -1 : 1;
                const signZ = preserveScalingNode.scaling.z < 0 ? -1 : 1;
                scale.x *= signX;
                scale.y *= signY;
                scale.z *= signZ;
            }
            else {
                if (this.determinant() <= 0) {
                    scale.y *= -1;
                }
            }
            if (scale._x === 0 || scale._y === 0 || scale._z === 0) {
                if (rotation) {
                    rotation.copyFromFloats(0.0, 0.0, 0.0, 1.0);
                }
                return false;
            }
            if (rotation) {
                const sx = 1 / scale._x, sy = 1 / scale._y, sz = 1 / scale._z;
                Matrix.FromValuesToRef(m[0] * sx, m[1] * sx, m[2] * sx, 0.0, m[4] * sy, m[5] * sy, m[6] * sy, 0.0, m[8] * sz, m[9] * sz, m[10] * sz, 0.0, 0.0, 0.0, 0.0, 1.0, MathTmp.Matrix[0]);
                Quaternion.FromRotationMatrixToRef(MathTmp.Matrix[0], rotation);
            }
            return true;
        }
        /**
         * Gets specific row of the matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#36
         * @param index defines the number of the row to get
         * @returns the index-th row of the current matrix as a new Vector4
         */
        getRow(index) {
            if (index < 0 || index > 3) {
                return null;
            }
            const i = index * 4;
            return new Vector4(this._m[i + 0], this._m[i + 1], this._m[i + 2], this._m[i + 3]);
        }
        /**
         * Gets specific row of the matrix to ref
         * Example Playground - https://playground.babylonjs.com/#AV9X17#36
         * @param index defines the number of the row to get
         * @param rowVector vector to store the index-th row of the current matrix
         * @returns result input
         */
        getRowToRef(index, rowVector) {
            if (index >= 0 && index < 3) {
                const i = index * 4;
                rowVector.x = this._m[i + 0];
                rowVector.y = this._m[i + 1];
                rowVector.z = this._m[i + 2];
                rowVector.w = this._m[i + 3];
            }
            return rowVector;
        }
        /**
         * Sets the index-th row of the current matrix to the vector4 values
         * Example Playground - https://playground.babylonjs.com/#AV9X17#36
         * @param index defines the number of the row to set
         * @param row defines the target vector4
         * @returns the updated current matrix
         */
        setRow(index, row) {
            return this.setRowFromFloats(index, row.x, row.y, row.z, row.w);
        }
        /**
         * Compute the transpose of the matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#40
         * @returns the new transposed matrix
         */
        transpose() {
            const result = new this.constructor();
            Matrix.TransposeToRef(this, result);
            return result;
        }
        /**
         * Compute the transpose of the matrix and store it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#41
         * @param result defines the target matrix
         * @returns result input
         */
        transposeToRef(result) {
            Matrix.TransposeToRef(this, result);
            return result;
        }
        /**
         * Sets the index-th row of the current matrix with the given 4 x float values
         * Example Playground - https://playground.babylonjs.com/#AV9X17#36
         * @param index defines the row index
         * @param x defines the x component to set
         * @param y defines the y component to set
         * @param z defines the z component to set
         * @param w defines the w component to set
         * @returns the updated current matrix
         */
        setRowFromFloats(index, x, y, z, w) {
            if (index < 0 || index > 3) {
                return this;
            }
            const i = index * 4;
            this._m[i + 0] = x;
            this._m[i + 1] = y;
            this._m[i + 2] = z;
            this._m[i + 3] = w;
            this.markAsUpdated();
            return this;
        }
        /**
         * Compute a new matrix set with the current matrix values multiplied by scale (float)
         * @param scale defines the scale factor
         * @returns a new matrix
         */
        scale(scale) {
            const result = new this.constructor();
            this.scaleToRef(scale, result);
            return result;
        }
        /**
         * Scale the current matrix values by a factor to a given result matrix
         * @param scale defines the scale factor
         * @param result defines the matrix to store the result
         * @returns result input
         */
        scaleToRef(scale, result) {
            for (let index = 0; index < 16; index++) {
                result._m[index] = this._m[index] * scale;
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Scale the current matrix values by a factor and add the result to a given matrix
         * @param scale defines the scale factor
         * @param result defines the Matrix to store the result
         * @returns result input
         */
        scaleAndAddToRef(scale, result) {
            for (let index = 0; index < 16; index++) {
                result._m[index] += this._m[index] * scale;
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Writes to the given matrix a normal matrix, computed from this one (using values from identity matrix for fourth row and column).
         * Example Playground - https://playground.babylonjs.com/#AV9X17#17
         * @param ref matrix to store the result
         */
        toNormalMatrix(ref) {
            const tmp = MathTmp.Matrix[0];
            this.invertToRef(tmp);
            tmp.transposeToRef(ref);
            const m = ref._m;
            Matrix.FromValuesToRef(m[0], m[1], m[2], 0.0, m[4], m[5], m[6], 0.0, m[8], m[9], m[10], 0.0, 0.0, 0.0, 0.0, 1.0, ref);
            return ref;
        }
        /**
         * Gets only rotation part of the current matrix
         * @returns a new matrix sets to the extracted rotation matrix from the current one
         */
        getRotationMatrix() {
            const result = new this.constructor();
            this.getRotationMatrixToRef(result);
            return result;
        }
        /**
         * Extracts the rotation matrix from the current one and sets it as the given "result"
         * @param result defines the target matrix to store data to
         * @returns result input
         */
        getRotationMatrixToRef(result) {
            const scale = MathTmp.Vector3[0];
            if (!this.decompose(scale)) {
                Matrix.IdentityToRef(result);
                return result;
            }
            const m = this._m;
            const sx = 1 / scale._x, sy = 1 / scale._y, sz = 1 / scale._z;
            Matrix.FromValuesToRef(m[0] * sx, m[1] * sx, m[2] * sx, 0.0, m[4] * sy, m[5] * sy, m[6] * sy, 0.0, m[8] * sz, m[9] * sz, m[10] * sz, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            return result;
        }
        /**
         * Toggles model matrix from being right handed to left handed in place and vice versa
         */
        toggleModelMatrixHandInPlace() {
            const m = this._m;
            m[2] *= -1;
            m[6] *= -1;
            m[8] *= -1;
            m[9] *= -1;
            m[14] *= -1;
            this.markAsUpdated();
            return this;
        }
        /**
         * Toggles projection matrix from being right handed to left handed in place and vice versa
         */
        toggleProjectionMatrixHandInPlace() {
            const m = this._m;
            m[8] *= -1;
            m[9] *= -1;
            m[10] *= -1;
            m[11] *= -1;
            this.markAsUpdated();
            return this;
        }
        // Statics
        /**
         * Creates a matrix from an array
         * Example Playground - https://playground.babylonjs.com/#AV9X17#42
         * @param array defines the source array
         * @param offset defines an offset in the source array
         * @returns a new Matrix set from the starting index of the given array
         */
        static FromArray(array, offset = 0) {
            const result = new Matrix();
            Matrix.FromArrayToRef(array, offset, result);
            return result;
        }
        /**
         * Copy the content of an array into a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#43
         * @param array defines the source array
         * @param offset defines an offset in the source array
         * @param result defines the target matrix
         * @returns result input
         */
        static FromArrayToRef(array, offset, result) {
            for (let index = 0; index < 16; index++) {
                result._m[index] = array[index + offset];
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Stores an array into a matrix after having multiplied each component by a given factor
         * Example Playground - https://playground.babylonjs.com/#AV9X17#50
         * @param array defines the source array
         * @param offset defines the offset in the source array
         * @param scale defines the scaling factor
         * @param result defines the target matrix
         * @returns result input
         */
        static FromFloat32ArrayToRefScaled(array, offset, scale, result) {
            for (let index = 0; index < 16; index++) {
                result._m[index] = array[index + offset] * scale;
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Gets an identity matrix that must not be updated
         */
        static get IdentityReadOnly() {
            return Matrix._IdentityReadOnly;
        }
        /**
         * Stores a list of values (16) inside a given matrix
         * @param initialM11 defines 1st value of 1st row
         * @param initialM12 defines 2nd value of 1st row
         * @param initialM13 defines 3rd value of 1st row
         * @param initialM14 defines 4th value of 1st row
         * @param initialM21 defines 1st value of 2nd row
         * @param initialM22 defines 2nd value of 2nd row
         * @param initialM23 defines 3rd value of 2nd row
         * @param initialM24 defines 4th value of 2nd row
         * @param initialM31 defines 1st value of 3rd row
         * @param initialM32 defines 2nd value of 3rd row
         * @param initialM33 defines 3rd value of 3rd row
         * @param initialM34 defines 4th value of 3rd row
         * @param initialM41 defines 1st value of 4th row
         * @param initialM42 defines 2nd value of 4th row
         * @param initialM43 defines 3rd value of 4th row
         * @param initialM44 defines 4th value of 4th row
         * @param result defines the target matrix
         * @returns result input
         */
        static FromValuesToRef(initialM11, initialM12, initialM13, initialM14, initialM21, initialM22, initialM23, initialM24, initialM31, initialM32, initialM33, initialM34, initialM41, initialM42, initialM43, initialM44, result) {
            const m = result._m;
            m[0] = initialM11;
            m[1] = initialM12;
            m[2] = initialM13;
            m[3] = initialM14;
            m[4] = initialM21;
            m[5] = initialM22;
            m[6] = initialM23;
            m[7] = initialM24;
            m[8] = initialM31;
            m[9] = initialM32;
            m[10] = initialM33;
            m[11] = initialM34;
            m[12] = initialM41;
            m[13] = initialM42;
            m[14] = initialM43;
            m[15] = initialM44;
            result.markAsUpdated();
        }
        /**
         * Creates new matrix from a list of values (16)
         * @param initialM11 defines 1st value of 1st row
         * @param initialM12 defines 2nd value of 1st row
         * @param initialM13 defines 3rd value of 1st row
         * @param initialM14 defines 4th value of 1st row
         * @param initialM21 defines 1st value of 2nd row
         * @param initialM22 defines 2nd value of 2nd row
         * @param initialM23 defines 3rd value of 2nd row
         * @param initialM24 defines 4th value of 2nd row
         * @param initialM31 defines 1st value of 3rd row
         * @param initialM32 defines 2nd value of 3rd row
         * @param initialM33 defines 3rd value of 3rd row
         * @param initialM34 defines 4th value of 3rd row
         * @param initialM41 defines 1st value of 4th row
         * @param initialM42 defines 2nd value of 4th row
         * @param initialM43 defines 3rd value of 4th row
         * @param initialM44 defines 4th value of 4th row
         * @returns the new matrix
         */
        static FromValues(initialM11, initialM12, initialM13, initialM14, initialM21, initialM22, initialM23, initialM24, initialM31, initialM32, initialM33, initialM34, initialM41, initialM42, initialM43, initialM44) {
            const result = new Matrix();
            const m = result._m;
            m[0] = initialM11;
            m[1] = initialM12;
            m[2] = initialM13;
            m[3] = initialM14;
            m[4] = initialM21;
            m[5] = initialM22;
            m[6] = initialM23;
            m[7] = initialM24;
            m[8] = initialM31;
            m[9] = initialM32;
            m[10] = initialM33;
            m[11] = initialM34;
            m[12] = initialM41;
            m[13] = initialM42;
            m[14] = initialM43;
            m[15] = initialM44;
            result.markAsUpdated();
            return result;
        }
        /**
         * Creates a new matrix composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
         * Example Playground - https://playground.babylonjs.com/#AV9X17#24
         * @param scale defines the scale vector3
         * @param rotation defines the rotation quaternion
         * @param translation defines the translation vector3
         * @returns a new matrix
         */
        static Compose(scale, rotation, translation) {
            const result = new Matrix();
            Matrix.ComposeToRef(scale, rotation, translation, result);
            return result;
        }
        /**
         * Sets a matrix to a value composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
         * Example Playground - https://playground.babylonjs.com/#AV9X17#25
         * @param scale defines the scale vector3
         * @param rotation defines the rotation quaternion
         * @param translation defines the translation vector3
         * @param result defines the target matrix
         * @returns result input
         */
        static ComposeToRef(scale, rotation, translation, result) {
            const m = result._m;
            const x = rotation._x, y = rotation._y, z = rotation._z, w = rotation._w;
            const x2 = x + x, y2 = y + y, z2 = z + z;
            const xx = x * x2, xy = x * y2, xz = x * z2;
            const yy = y * y2, yz = y * z2, zz = z * z2;
            const wx = w * x2, wy = w * y2, wz = w * z2;
            const sx = scale._x, sy = scale._y, sz = scale._z;
            m[0] = (1 - (yy + zz)) * sx;
            m[1] = (xy + wz) * sx;
            m[2] = (xz - wy) * sx;
            m[3] = 0;
            m[4] = (xy - wz) * sy;
            m[5] = (1 - (xx + zz)) * sy;
            m[6] = (yz + wx) * sy;
            m[7] = 0;
            m[8] = (xz + wy) * sz;
            m[9] = (yz - wx) * sz;
            m[10] = (1 - (xx + yy)) * sz;
            m[11] = 0;
            m[12] = translation._x;
            m[13] = translation._y;
            m[14] = translation._z;
            m[15] = 1;
            result.markAsUpdated();
            return result;
        }
        /**
         * Creates a new identity matrix
         * @returns a new identity matrix
         */
        static Identity() {
            const identity = Matrix.FromValues(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
            identity._updateIdentityStatus(true);
            return identity;
        }
        /**
         * Creates a new identity matrix and stores the result in a given matrix
         * @param result defines the target matrix
         * @returns result input
         */
        static IdentityToRef(result) {
            Matrix.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            result._updateIdentityStatus(true);
            return result;
        }
        /**
         * Creates a new zero matrix
         * @returns a new zero matrix
         */
        static Zero() {
            const zero = Matrix.FromValues(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0);
            zero._updateIdentityStatus(false);
            return zero;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the X axis
         * Example Playground - https://playground.babylonjs.com/#AV9X17#97
         * @param angle defines the angle (in radians) to use
         * @returns the new matrix
         */
        static RotationX(angle) {
            const result = new Matrix();
            Matrix.RotationXToRef(angle, result);
            return result;
        }
        /**
         * Creates a new matrix as the invert of a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#124
         * @param source defines the source matrix
         * @returns the new matrix
         */
        static Invert(source) {
            const result = new source.constructor();
            source.invertToRef(result);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the X axis and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#98
         * @param angle defines the angle (in radians) to use
         * @param result defines the target matrix
         * @returns result input
         */
        static RotationXToRef(angle, result) {
            const s = Math.sin(angle);
            const c = Math.cos(angle);
            Matrix.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, c, s, 0.0, 0.0, -s, c, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            result._updateIdentityStatus(c === 1 && s === 0);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the Y axis
         * Example Playground - https://playground.babylonjs.com/#AV9X17#99
         * @param angle defines the angle (in radians) to use
         * @returns the new matrix
         */
        static RotationY(angle) {
            const result = new Matrix();
            Matrix.RotationYToRef(angle, result);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the Y axis and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#100
         * @param angle defines the angle (in radians) to use
         * @param result defines the target matrix
         * @returns result input
         */
        static RotationYToRef(angle, result) {
            const s = Math.sin(angle);
            const c = Math.cos(angle);
            Matrix.FromValuesToRef(c, 0.0, -s, 0.0, 0.0, 1.0, 0.0, 0.0, s, 0.0, c, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            result._updateIdentityStatus(c === 1 && s === 0);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the Z axis
         * Example Playground - https://playground.babylonjs.com/#AV9X17#101
         * @param angle defines the angle (in radians) to use
         * @returns the new matrix
         */
        static RotationZ(angle) {
            const result = new Matrix();
            Matrix.RotationZToRef(angle, result);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the Z axis and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#102
         * @param angle defines the angle (in radians) to use
         * @param result defines the target matrix
         * @returns result input
         */
        static RotationZToRef(angle, result) {
            const s = Math.sin(angle);
            const c = Math.cos(angle);
            Matrix.FromValuesToRef(c, s, 0.0, 0.0, -s, c, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            result._updateIdentityStatus(c === 1 && s === 0);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the given axis
         * Example Playground - https://playground.babylonjs.com/#AV9X17#96
         * @param axis defines the axis to use
         * @param angle defines the angle (in radians) to use
         * @returns the new matrix
         */
        static RotationAxis(axis, angle) {
            const result = new Matrix();
            Matrix.RotationAxisToRef(axis, angle, result);
            return result;
        }
        /**
         * Creates a new rotation matrix for "angle" radians around the given axis and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#94
         * @param axis defines the axis to use
         * @param angle defines the angle (in radians) to use
         * @param result defines the target matrix
         * @returns result input
         */
        static RotationAxisToRef(axis, angle, result) {
            const s = Math.sin(-angle);
            const c = Math.cos(-angle);
            const c1 = 1 - c;
            axis.normalize();
            const m = result._m;
            m[0] = axis._x * axis._x * c1 + c;
            m[1] = axis._x * axis._y * c1 - axis._z * s;
            m[2] = axis._x * axis._z * c1 + axis._y * s;
            m[3] = 0.0;
            m[4] = axis._y * axis._x * c1 + axis._z * s;
            m[5] = axis._y * axis._y * c1 + c;
            m[6] = axis._y * axis._z * c1 - axis._x * s;
            m[7] = 0.0;
            m[8] = axis._z * axis._x * c1 - axis._y * s;
            m[9] = axis._z * axis._y * c1 + axis._x * s;
            m[10] = axis._z * axis._z * c1 + c;
            m[11] = 0.0;
            m[12] = 0.0;
            m[13] = 0.0;
            m[14] = 0.0;
            m[15] = 1.0;
            result.markAsUpdated();
            return result;
        }
        /**
         * Takes normalised vectors and returns a rotation matrix to align "from" with "to".
         * Taken from http://www.iquilezles.org/www/articles/noacos/noacos.htm
         * Example Playground - https://playground.babylonjs.com/#AV9X17#93
         * @param from defines the vector to align
         * @param to defines the vector to align to
         * @param result defines the target matrix
         * @returns result input
         */
        static RotationAlignToRef(from, to, result) {
            const c = Vector3.Dot(to, from);
            const m = result._m;
            if (c < -1 + Epsilon) {
                // from and to are colinear and opposite direction.
                // compute a PI rotation on Z axis
                m[0] = -1;
                m[1] = 0;
                m[2] = 0;
                m[3] = 0;
                m[4] = 0;
                m[5] = -1;
                m[6] = 0;
                m[7] = 0;
                m[8] = 0;
                m[9] = 0;
                m[10] = 1;
                m[11] = 0;
            }
            else {
                const v = Vector3.Cross(to, from);
                const k = 1 / (1 + c);
                m[0] = v._x * v._x * k + c;
                m[1] = v._y * v._x * k - v._z;
                m[2] = v._z * v._x * k + v._y;
                m[3] = 0;
                m[4] = v._x * v._y * k + v._z;
                m[5] = v._y * v._y * k + c;
                m[6] = v._z * v._y * k - v._x;
                m[7] = 0;
                m[8] = v._x * v._z * k - v._y;
                m[9] = v._y * v._z * k + v._x;
                m[10] = v._z * v._z * k + c;
                m[11] = 0;
            }
            m[12] = 0;
            m[13] = 0;
            m[14] = 0;
            m[15] = 1;
            result.markAsUpdated();
            return result;
        }
        /**
         * Creates a rotation matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#103
         * Example Playground - https://playground.babylonjs.com/#AV9X17#105
         * @param yaw defines the yaw angle in radians (Y axis)
         * @param pitch defines the pitch angle in radians (X axis)
         * @param roll defines the roll angle in radians (Z axis)
         * @returns the new rotation matrix
         */
        static RotationYawPitchRoll(yaw, pitch, roll) {
            const result = new Matrix();
            Matrix.RotationYawPitchRollToRef(yaw, pitch, roll, result);
            return result;
        }
        /**
         * Creates a rotation matrix and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#104
         * @param yaw defines the yaw angle in radians (Y axis)
         * @param pitch defines the pitch angle in radians (X axis)
         * @param roll defines the roll angle in radians (Z axis)
         * @param result defines the target matrix
         * @returns result input
         */
        static RotationYawPitchRollToRef(yaw, pitch, roll, result) {
            Quaternion.RotationYawPitchRollToRef(yaw, pitch, roll, MathTmp.Quaternion[0]);
            MathTmp.Quaternion[0].toRotationMatrix(result);
            return result;
        }
        /**
         * Creates a scaling matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#107
         * @param x defines the scale factor on X axis
         * @param y defines the scale factor on Y axis
         * @param z defines the scale factor on Z axis
         * @returns the new matrix
         */
        static Scaling(x, y, z) {
            const result = new Matrix();
            Matrix.ScalingToRef(x, y, z, result);
            return result;
        }
        /**
         * Creates a scaling matrix and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#108
         * @param x defines the scale factor on X axis
         * @param y defines the scale factor on Y axis
         * @param z defines the scale factor on Z axis
         * @param result defines the target matrix
         * @returns result input
         */
        static ScalingToRef(x, y, z, result) {
            Matrix.FromValuesToRef(x, 0.0, 0.0, 0.0, 0.0, y, 0.0, 0.0, 0.0, 0.0, z, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            result._updateIdentityStatus(x === 1 && y === 1 && z === 1);
            return result;
        }
        /**
         * Creates a translation matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#109
         * @param x defines the translation on X axis
         * @param y defines the translation on Y axis
         * @param z defines the translationon Z axis
         * @returns the new matrix
         */
        static Translation(x, y, z) {
            const result = new Matrix();
            Matrix.TranslationToRef(x, y, z, result);
            return result;
        }
        /**
         * Creates a translation matrix and stores it in a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#110
         * @param x defines the translation on X axis
         * @param y defines the translation on Y axis
         * @param z defines the translationon Z axis
         * @param result defines the target matrix
         * @returns result input
         */
        static TranslationToRef(x, y, z, result) {
            Matrix.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, x, y, z, 1.0, result);
            result._updateIdentityStatus(x === 0 && y === 0 && z === 0);
            return result;
        }
        /**
         * Returns a new Matrix whose values are the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
         * Example Playground - https://playground.babylonjs.com/#AV9X17#55
         * @param startValue defines the start value
         * @param endValue defines the end value
         * @param gradient defines the gradient factor
         * @returns the new matrix
         */
        static Lerp(startValue, endValue, gradient) {
            const result = new startValue.constructor();
            Matrix.LerpToRef(startValue, endValue, gradient, result);
            return result;
        }
        /**
         * Set the given matrix "result" as the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
         * Example Playground - https://playground.babylonjs.com/#AV9X17#54
         * @param startValue defines the start value
         * @param endValue defines the end value
         * @param gradient defines the gradient factor
         * @param result defines the Matrix object where to store data
         * @returns result input
         */
        static LerpToRef(startValue, endValue, gradient, result) {
            const resultM = result._m;
            const startM = startValue.m;
            const endM = endValue.m;
            for (let index = 0; index < 16; index++) {
                resultM[index] = startM[index] * (1.0 - gradient) + endM[index] * gradient;
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Builds a new matrix whose values are computed by:
         * * decomposing the the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
         * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
         * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
         * Example Playground - https://playground.babylonjs.com/#AV9X17#22
         * Example Playground - https://playground.babylonjs.com/#AV9X17#51
         * @param startValue defines the first matrix
         * @param endValue defines the second matrix
         * @param gradient defines the gradient between the two matrices
         * @returns the new matrix
         */
        static DecomposeLerp(startValue, endValue, gradient) {
            const result = new startValue.constructor();
            Matrix.DecomposeLerpToRef(startValue, endValue, gradient, result);
            return result;
        }
        /**
         * Update a matrix to values which are computed by:
         * * decomposing the the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
         * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
         * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
         * Example Playground - https://playground.babylonjs.com/#AV9X17#23
         * Example Playground - https://playground.babylonjs.com/#AV9X17#53
         * @param startValue defines the first matrix
         * @param endValue defines the second matrix
         * @param gradient defines the gradient between the two matrices
         * @param result defines the target matrix
         * @returns result input
         */
        static DecomposeLerpToRef(startValue, endValue, gradient, result) {
            const startScale = MathTmp.Vector3[0];
            const startRotation = MathTmp.Quaternion[0];
            const startTranslation = MathTmp.Vector3[1];
            startValue.decompose(startScale, startRotation, startTranslation);
            const endScale = MathTmp.Vector3[2];
            const endRotation = MathTmp.Quaternion[1];
            const endTranslation = MathTmp.Vector3[3];
            endValue.decompose(endScale, endRotation, endTranslation);
            const resultScale = MathTmp.Vector3[4];
            Vector3.LerpToRef(startScale, endScale, gradient, resultScale);
            const resultRotation = MathTmp.Quaternion[2];
            Quaternion.SlerpToRef(startRotation, endRotation, gradient, resultRotation);
            const resultTranslation = MathTmp.Vector3[5];
            Vector3.LerpToRef(startTranslation, endTranslation, gradient, resultTranslation);
            Matrix.ComposeToRef(resultScale, resultRotation, resultTranslation, result);
            return result;
        }
        /**
         * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
         * This function generates a matrix suitable for a left handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#58
         * Example Playground - https://playground.babylonjs.com/#AV9X17#59
         * @param eye defines the final position of the entity
         * @param target defines where the entity should look at
         * @param up defines the up vector for the entity
         * @returns the new matrix
         */
        static LookAtLH(eye, target, up) {
            const result = new Matrix();
            Matrix.LookAtLHToRef(eye, target, up, result);
            return result;
        }
        /**
         * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
         * This function generates a matrix suitable for a left handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#60
         * Example Playground - https://playground.babylonjs.com/#AV9X17#61
         * @param eye defines the final position of the entity
         * @param target defines where the entity should look at
         * @param up defines the up vector for the entity
         * @param result defines the target matrix
         * @returns result input
         */
        static LookAtLHToRef(eye, target, up, result) {
            const xAxis = MathTmp.Vector3[0];
            const yAxis = MathTmp.Vector3[1];
            const zAxis = MathTmp.Vector3[2];
            // Z axis
            target.subtractToRef(eye, zAxis);
            zAxis.normalize();
            // X axis
            Vector3.CrossToRef(up, zAxis, xAxis);
            const xSquareLength = xAxis.lengthSquared();
            if (xSquareLength === 0) {
                xAxis.x = 1.0;
            }
            else {
                xAxis.normalizeFromLength(Math.sqrt(xSquareLength));
            }
            // Y axis
            Vector3.CrossToRef(zAxis, xAxis, yAxis);
            yAxis.normalize();
            // Eye angles
            const ex = -Vector3.Dot(xAxis, eye);
            const ey = -Vector3.Dot(yAxis, eye);
            const ez = -Vector3.Dot(zAxis, eye);
            Matrix.FromValuesToRef(xAxis._x, yAxis._x, zAxis._x, 0.0, xAxis._y, yAxis._y, zAxis._y, 0.0, xAxis._z, yAxis._z, zAxis._z, 0.0, ex, ey, ez, 1.0, result);
        }
        /**
         * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
         * This function generates a matrix suitable for a right handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#62
         * Example Playground - https://playground.babylonjs.com/#AV9X17#63
         * @param eye defines the final position of the entity
         * @param target defines where the entity should look at
         * @param up defines the up vector for the entity
         * @returns the new matrix
         */
        static LookAtRH(eye, target, up) {
            const result = new Matrix();
            Matrix.LookAtRHToRef(eye, target, up, result);
            return result;
        }
        /**
         * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
         * This function generates a matrix suitable for a right handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#64
         * Example Playground - https://playground.babylonjs.com/#AV9X17#65
         * @param eye defines the final position of the entity
         * @param target defines where the entity should look at
         * @param up defines the up vector for the entity
         * @param result defines the target matrix
         * @returns result input
         */
        static LookAtRHToRef(eye, target, up, result) {
            const xAxis = MathTmp.Vector3[0];
            const yAxis = MathTmp.Vector3[1];
            const zAxis = MathTmp.Vector3[2];
            // Z axis
            eye.subtractToRef(target, zAxis);
            zAxis.normalize();
            // X axis
            Vector3.CrossToRef(up, zAxis, xAxis);
            const xSquareLength = xAxis.lengthSquared();
            if (xSquareLength === 0) {
                xAxis.x = 1.0;
            }
            else {
                xAxis.normalizeFromLength(Math.sqrt(xSquareLength));
            }
            // Y axis
            Vector3.CrossToRef(zAxis, xAxis, yAxis);
            yAxis.normalize();
            // Eye angles
            const ex = -Vector3.Dot(xAxis, eye);
            const ey = -Vector3.Dot(yAxis, eye);
            const ez = -Vector3.Dot(zAxis, eye);
            Matrix.FromValuesToRef(xAxis._x, yAxis._x, zAxis._x, 0.0, xAxis._y, yAxis._y, zAxis._y, 0.0, xAxis._z, yAxis._z, zAxis._z, 0.0, ex, ey, ez, 1.0, result);
            return result;
        }
        /**
         * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
         * This function generates a matrix suitable for a left handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#66
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @returns the new matrix
         */
        static LookDirectionLH(forward, up) {
            const result = new Matrix();
            Matrix.LookDirectionLHToRef(forward, up, result);
            return result;
        }
        /**
         * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
         * This function generates a matrix suitable for a left handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#67
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @param result defines the target matrix
         * @returns result input
         */
        static LookDirectionLHToRef(forward, up, result) {
            const back = MathTmp.Vector3[0];
            back.copyFrom(forward);
            back.scaleInPlace(-1);
            const left = MathTmp.Vector3[1];
            Vector3.CrossToRef(up, back, left);
            // Generate the rotation matrix.
            Matrix.FromValuesToRef(left._x, left._y, left._z, 0.0, up._x, up._y, up._z, 0.0, back._x, back._y, back._z, 0.0, 0, 0, 0, 1.0, result);
            return result;
        }
        /**
         * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
         * This function generates a matrix suitable for a right handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#68
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @returns the new matrix
         */
        static LookDirectionRH(forward, up) {
            const result = new Matrix();
            Matrix.LookDirectionRHToRef(forward, up, result);
            return result;
        }
        /**
         * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
         * This function generates a matrix suitable for a right handed coordinate system
         * Example Playground - https://playground.babylonjs.com/#AV9X17#69
         * @param forward defines the forward direction - Must be normalized and orthogonal to up.
         * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
         * @param result defines the target matrix
         * @returns result input
         */
        static LookDirectionRHToRef(forward, up, result) {
            const right = MathTmp.Vector3[2];
            Vector3.CrossToRef(up, forward, right);
            // Generate the rotation matrix.
            Matrix.FromValuesToRef(right._x, right._y, right._z, 0.0, up._x, up._y, up._z, 0.0, forward._x, forward._y, forward._z, 0.0, 0, 0, 0, 1.0, result);
            return result;
        }
        /**
         * Create a left-handed orthographic projection matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#70
         * @param width defines the viewport width
         * @param height defines the viewport height
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @returns a new matrix as a left-handed orthographic projection matrix
         */
        static OrthoLH(width, height, znear, zfar, halfZRange) {
            const matrix = new Matrix();
            Matrix.OrthoLHToRef(width, height, znear, zfar, matrix, halfZRange);
            return matrix;
        }
        /**
         * Store a left-handed orthographic projection to a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#71
         * @param width defines the viewport width
         * @param height defines the viewport height
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param result defines the target matrix
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @returns result input
         */
        static OrthoLHToRef(width, height, znear, zfar, result, halfZRange) {
            const n = znear;
            const f = zfar;
            const a = 2.0 / width;
            const b = 2.0 / height;
            const c = 2.0 / (f - n);
            const d = -(f + n) / (f - n);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, 0.0, 0.0, d, 1.0, result);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result._updateIdentityStatus(a === 1 && b === 1 && c === 1 && d === 0);
            return result;
        }
        /**
         * Create a left-handed orthographic projection matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#72
         * @param left defines the viewport left coordinate
         * @param right defines the viewport right coordinate
         * @param bottom defines the viewport bottom coordinate
         * @param top defines the viewport top coordinate
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @returns a new matrix as a left-handed orthographic projection matrix
         */
        static OrthoOffCenterLH(left, right, bottom, top, znear, zfar, halfZRange) {
            const matrix = new Matrix();
            Matrix.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, matrix, halfZRange);
            return matrix;
        }
        /**
         * Stores a left-handed orthographic projection into a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#73
         * @param left defines the viewport left coordinate
         * @param right defines the viewport right coordinate
         * @param bottom defines the viewport bottom coordinate
         * @param top defines the viewport top coordinate
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param result defines the target matrix
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @returns result input
         */
        static OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange) {
            const n = znear;
            const f = zfar;
            const a = 2.0 / (right - left);
            const b = 2.0 / (top - bottom);
            const c = 2.0 / (f - n);
            const d = -(f + n) / (f - n);
            const i0 = (left + right) / (left - right);
            const i1 = (top + bottom) / (bottom - top);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, i0, i1, d, 1.0, result);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Creates a right-handed orthographic projection matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#76
         * @param left defines the viewport left coordinate
         * @param right defines the viewport right coordinate
         * @param bottom defines the viewport bottom coordinate
         * @param top defines the viewport top coordinate
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @returns a new matrix as a right-handed orthographic projection matrix
         */
        static OrthoOffCenterRH(left, right, bottom, top, znear, zfar, halfZRange) {
            const matrix = new Matrix();
            Matrix.OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, matrix, halfZRange);
            return matrix;
        }
        /**
         * Stores a right-handed orthographic projection into a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#77
         * @param left defines the viewport left coordinate
         * @param right defines the viewport right coordinate
         * @param bottom defines the viewport bottom coordinate
         * @param top defines the viewport top coordinate
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param result defines the target matrix
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @returns result input
         */
        static OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, result, halfZRange) {
            Matrix.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
            result._m[10] *= -1; // No need to call markAsUpdated as previous function already called it and let _isIdentityDirty to true
            return result;
        }
        /**
         * Creates a left-handed perspective projection matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#85
         * @param width defines the viewport width
         * @param height defines the viewport height
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @returns a new matrix as a left-handed perspective projection matrix
         */
        static PerspectiveLH(width, height, znear, zfar, halfZRange, projectionPlaneTilt = 0) {
            const matrix = new Matrix();
            const n = znear;
            const f = zfar;
            const a = (2.0 * n) / width;
            const b = (2.0 * n) / height;
            const c = (f + n) / (f - n);
            const d = (-2.0 * f * n) / (f - n);
            const rot = Math.tan(projectionPlaneTilt);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, 1.0, 0.0, 0.0, d, 0.0, matrix);
            if (halfZRange) {
                matrix.multiplyToRef(mtxConvertNDCToHalfZRange, matrix);
            }
            matrix._updateIdentityStatus(false);
            return matrix;
        }
        /**
         * Creates a left-handed perspective projection matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#78
         * @param fov defines the horizontal field of view
         * @param aspect defines the aspect ratio
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
         * @returns a new matrix as a left-handed perspective projection matrix
         */
        static PerspectiveFovLH(fov, aspect, znear, zfar, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
            const matrix = new Matrix();
            Matrix.PerspectiveFovLHToRef(fov, aspect, znear, zfar, matrix, true, halfZRange, projectionPlaneTilt, reverseDepthBufferMode);
            return matrix;
        }
        /**
         * Stores a left-handed perspective projection into a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#81
         * @param fov defines the horizontal field of view
         * @param aspect defines the aspect ratio
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
         * @param result defines the target matrix
         * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
         * @returns result input
         */
        static PerspectiveFovLHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
            const n = znear;
            const f = zfar;
            const t = 1.0 / Math.tan(fov * 0.5);
            const a = isVerticalFovFixed ? t / aspect : t;
            const b = isVerticalFovFixed ? t : t * aspect;
            const c = reverseDepthBufferMode && n === 0 ? -1 : f !== 0 ? (f + n) / (f - n) : 1;
            const d = reverseDepthBufferMode && n === 0 ? 2 * f : f !== 0 ? (-2.0 * f * n) / (f - n) : -2 * n;
            const rot = Math.tan(projectionPlaneTilt);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, 1.0, 0.0, 0.0, d, 0.0, result);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result._updateIdentityStatus(false);
            return result;
        }
        /**
         * Stores a left-handed perspective projection into a given matrix with depth reversed
         * Example Playground - https://playground.babylonjs.com/#AV9X17#89
         * @param fov defines the horizontal field of view
         * @param aspect defines the aspect ratio
         * @param znear defines the near clip plane
         * @param zfar not used as infinity is used as far clip
         * @param result defines the target matrix
         * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @returns result input
         */
        static PerspectiveFovReverseLHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0) {
            const t = 1.0 / Math.tan(fov * 0.5);
            const a = isVerticalFovFixed ? t / aspect : t;
            const b = isVerticalFovFixed ? t : t * aspect;
            const rot = Math.tan(projectionPlaneTilt);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, -znear, 1.0, 0.0, 0.0, 1.0, 0.0, result);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result._updateIdentityStatus(false);
            return result;
        }
        /**
         * Creates a right-handed perspective projection matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#83
         * @param fov defines the horizontal field of view
         * @param aspect defines the aspect ratio
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
         * @returns a new matrix as a right-handed perspective projection matrix
         */
        static PerspectiveFovRH(fov, aspect, znear, zfar, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
            const matrix = new Matrix();
            Matrix.PerspectiveFovRHToRef(fov, aspect, znear, zfar, matrix, true, halfZRange, projectionPlaneTilt, reverseDepthBufferMode);
            return matrix;
        }
        /**
         * Stores a right-handed perspective projection into a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#84
         * @param fov defines the horizontal field of view
         * @param aspect defines the aspect ratio
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
         * @param result defines the target matrix
         * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
         * @returns result input
         */
        static PerspectiveFovRHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
            //alternatively this could be expressed as:
            //    m = PerspectiveFovLHToRef
            //    m[10] *= -1.0;
            //    m[11] *= -1.0;
            const n = znear;
            const f = zfar;
            const t = 1.0 / Math.tan(fov * 0.5);
            const a = isVerticalFovFixed ? t / aspect : t;
            const b = isVerticalFovFixed ? t : t * aspect;
            const c = reverseDepthBufferMode && n === 0 ? 1 : f !== 0 ? -(f + n) / (f - n) : -1;
            const d = reverseDepthBufferMode && n === 0 ? 2 * f : f !== 0 ? (-2 * f * n) / (f - n) : -2 * n;
            const rot = Math.tan(projectionPlaneTilt);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, -1.0, 0.0, 0.0, d, 0.0, result);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result._updateIdentityStatus(false);
            return result;
        }
        /**
         * Stores a right-handed perspective projection into a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#90
         * @param fov defines the horizontal field of view
         * @param aspect defines the aspect ratio
         * @param znear defines the near clip plane
         * @param zfar not used as infinity is used as far clip
         * @param result defines the target matrix
         * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @returns result input
         */
        static PerspectiveFovReverseRHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0) {
            const t = 1.0 / Math.tan(fov * 0.5);
            const a = isVerticalFovFixed ? t / aspect : t;
            const b = isVerticalFovFixed ? t : t * aspect;
            const rot = Math.tan(projectionPlaneTilt);
            Matrix.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, -znear, -1.0, 0.0, 0.0, -1.0, 0.0, result);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result._updateIdentityStatus(false);
            return result;
        }
        /**
         * Stores a perspective projection for WebVR info a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#92
         * @param fov defines the field of view
         * @param fov.upDegrees
         * @param fov.downDegrees
         * @param fov.leftDegrees
         * @param fov.rightDegrees
         * @param znear defines the near clip plane
         * @param zfar defines the far clip plane
         * @param result defines the target matrix
         * @param rightHanded defines if the matrix must be in right-handed mode (false by default)
         * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
         * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
         * @returns result input
         */
        static PerspectiveFovWebVRToRef(fov, znear, zfar, result, rightHanded = false, halfZRange, projectionPlaneTilt = 0) {
            const rightHandedFactor = rightHanded ? -1 : 1;
            const upTan = Math.tan((fov.upDegrees * Math.PI) / 180.0);
            const downTan = Math.tan((fov.downDegrees * Math.PI) / 180.0);
            const leftTan = Math.tan((fov.leftDegrees * Math.PI) / 180.0);
            const rightTan = Math.tan((fov.rightDegrees * Math.PI) / 180.0);
            const xScale = 2.0 / (leftTan + rightTan);
            const yScale = 2.0 / (upTan + downTan);
            const rot = Math.tan(projectionPlaneTilt);
            const m = result._m;
            m[0] = xScale;
            m[1] = m[2] = m[3] = m[4] = 0.0;
            m[5] = yScale;
            m[6] = 0.0;
            m[7] = rot;
            m[8] = (leftTan - rightTan) * xScale * 0.5;
            m[9] = -((upTan - downTan) * yScale * 0.5);
            m[10] = -zfar / (znear - zfar);
            m[11] = 1.0 * rightHandedFactor;
            m[12] = m[13] = m[15] = 0.0;
            m[14] = -(2.0 * zfar * znear) / (zfar - znear);
            if (halfZRange) {
                result.multiplyToRef(mtxConvertNDCToHalfZRange, result);
            }
            result.markAsUpdated();
            return result;
        }
        /**
         * Computes a complete transformation matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#113
         * @param viewport defines the viewport to use
         * @param world defines the world matrix
         * @param view defines the view matrix
         * @param projection defines the projection matrix
         * @param zmin defines the near clip plane
         * @param zmax defines the far clip plane
         * @returns the transformation matrix
         */
        static GetFinalMatrix(viewport, world, view, projection, zmin, zmax) {
            const cw = viewport.width;
            const ch = viewport.height;
            const cx = viewport.x;
            const cy = viewport.y;
            const viewportMatrix = Matrix.FromValues(cw / 2.0, 0.0, 0.0, 0.0, 0.0, -ch / 2.0, 0.0, 0.0, 0.0, 0.0, zmax - zmin, 0.0, cx + cw / 2.0, ch / 2.0 + cy, zmin, 1.0);
            const matrix = new world.constructor();
            world.multiplyToRef(view, matrix);
            matrix.multiplyToRef(projection, matrix);
            return matrix.multiplyToRef(viewportMatrix, matrix);
        }
        /**
         * Extracts a 2x2 matrix from a given matrix and store the result in a Float32Array
         * @param matrix defines the matrix to use
         * @returns a new Float32Array array with 4 elements : the 2x2 matrix extracted from the given matrix
         */
        static GetAsMatrix2x2(matrix) {
            const m = matrix.m;
            const arr = [m[0], m[1], m[4], m[5]];
            return PerformanceConfigurator.MatrixUse64Bits ? arr : new Float32Array(arr);
        }
        /**
         * Extracts a 3x3 matrix from a given matrix and store the result in a Float32Array
         * @param matrix defines the matrix to use
         * @returns a new Float32Array array with 9 elements : the 3x3 matrix extracted from the given matrix
         */
        static GetAsMatrix3x3(matrix) {
            const m = matrix.m;
            const arr = [m[0], m[1], m[2], m[4], m[5], m[6], m[8], m[9], m[10]];
            return PerformanceConfigurator.MatrixUse64Bits ? arr : new Float32Array(arr);
        }
        /**
         * Compute the transpose of a given matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#111
         * @param matrix defines the matrix to transpose
         * @returns the new matrix
         */
        static Transpose(matrix) {
            const result = new matrix.constructor();
            Matrix.TransposeToRef(matrix, result);
            return result;
        }
        /**
         * Compute the transpose of a matrix and store it in a target matrix
         * Example Playground - https://playground.babylonjs.com/#AV9X17#112
         * @param matrix defines the matrix to transpose
         * @param result defines the target matrix
         * @returns result input
         */
        static TransposeToRef(matrix, result) {
            const rm = result._m;
            const mm = matrix.m;
            rm[0] = mm[0];
            rm[1] = mm[4];
            rm[2] = mm[8];
            rm[3] = mm[12];
            rm[4] = mm[1];
            rm[5] = mm[5];
            rm[6] = mm[9];
            rm[7] = mm[13];
            rm[8] = mm[2];
            rm[9] = mm[6];
            rm[10] = mm[10];
            rm[11] = mm[14];
            rm[12] = mm[3];
            rm[13] = mm[7];
            rm[14] = mm[11];
            rm[15] = mm[15];
            result.markAsUpdated();
            // identity-ness does not change when transposing
            result._updateIdentityStatus(matrix._isIdentity, matrix._isIdentityDirty);
            return result;
        }
        /**
         * Computes a reflection matrix from a plane
         * Example Playground - https://playground.babylonjs.com/#AV9X17#87
         * @param plane defines the reflection plane
         * @returns a new matrix
         */
        static Reflection(plane) {
            const matrix = new Matrix();
            Matrix.ReflectionToRef(plane, matrix);
            return matrix;
        }
        /**
         * Computes a reflection matrix from a plane
         * Example Playground - https://playground.babylonjs.com/#AV9X17#88
         * @param plane defines the reflection plane
         * @param result defines the target matrix
         * @returns result input
         */
        static ReflectionToRef(plane, result) {
            plane.normalize();
            const x = plane.normal.x;
            const y = plane.normal.y;
            const z = plane.normal.z;
            const temp = -2 * x;
            const temp2 = -2 * y;
            const temp3 = -2 * z;
            Matrix.FromValuesToRef(temp * x + 1, temp2 * x, temp3 * x, 0.0, temp * y, temp2 * y + 1, temp3 * y, 0.0, temp * z, temp2 * z, temp3 * z + 1, 0.0, temp * plane.d, temp2 * plane.d, temp3 * plane.d, 1.0, result);
            return result;
        }
        /**
         * Sets the given matrix as a rotation matrix composed from the 3 left handed axes
         * @param xaxis defines the value of the 1st axis
         * @param yaxis defines the value of the 2nd axis
         * @param zaxis defines the value of the 3rd axis
         * @param result defines the target matrix
         * @returns result input
         */
        static FromXYZAxesToRef(xaxis, yaxis, zaxis, result) {
            Matrix.FromValuesToRef(xaxis._x, xaxis._y, xaxis._z, 0.0, yaxis._x, yaxis._y, yaxis._z, 0.0, zaxis._x, zaxis._y, zaxis._z, 0.0, 0.0, 0.0, 0.0, 1.0, result);
            return result;
        }
        /**
         * Creates a rotation matrix from a quaternion and stores it in a target matrix
         * @param quat defines the quaternion to use
         * @param result defines the target matrix
         * @returns result input
         */
        static FromQuaternionToRef(quat, result) {
            const xx = quat._x * quat._x;
            const yy = quat._y * quat._y;
            const zz = quat._z * quat._z;
            const xy = quat._x * quat._y;
            const zw = quat._z * quat._w;
            const zx = quat._z * quat._x;
            const yw = quat._y * quat._w;
            const yz = quat._y * quat._z;
            const xw = quat._x * quat._w;
            result._m[0] = 1.0 - 2.0 * (yy + zz);
            result._m[1] = 2.0 * (xy + zw);
            result._m[2] = 2.0 * (zx - yw);
            result._m[3] = 0.0;
            result._m[4] = 2.0 * (xy - zw);
            result._m[5] = 1.0 - 2.0 * (zz + xx);
            result._m[6] = 2.0 * (yz + xw);
            result._m[7] = 0.0;
            result._m[8] = 2.0 * (zx + yw);
            result._m[9] = 2.0 * (yz - xw);
            result._m[10] = 1.0 - 2.0 * (yy + xx);
            result._m[11] = 0.0;
            result._m[12] = 0.0;
            result._m[13] = 0.0;
            result._m[14] = 0.0;
            result._m[15] = 1.0;
            result.markAsUpdated();
            return result;
        }
    }
    Matrix._UpdateFlagSeed = 0;
    Matrix._IdentityReadOnly = Matrix.Identity();
    /**
     * @internal
     * Same as Tmp but not exported to keep it only for math functions to avoid conflicts
     */
    class MathTmp {
    }
    MathTmp.Vector3 = ArrayTools.BuildTuple(11, Vector3.Zero);
    MathTmp.Matrix = ArrayTools.BuildTuple(2, Matrix.Identity);
    MathTmp.Quaternion = ArrayTools.BuildTuple(3, Quaternion.Zero);
    /**
     * @internal
     */
    class TmpVectors {
    }
    TmpVectors.Vector2 = ArrayTools.BuildTuple(3, Vector2.Zero); // 3 temp Vector2 at once should be enough
    TmpVectors.Vector3 = ArrayTools.BuildTuple(13, Vector3.Zero); // 13 temp Vector3 at once should be enough
    TmpVectors.Vector4 = ArrayTools.BuildTuple(3, Vector4.Zero); // 3 temp Vector4 at once should be enough
    TmpVectors.Quaternion = ArrayTools.BuildTuple(2, Quaternion.Zero); // 2 temp Quaternion at once should be enough
    TmpVectors.Matrix = ArrayTools.BuildTuple(8, Matrix.Identity); // 8 temp Matrices at once should be enough
    RegisterClass("BABYLON.Vector2", Vector2);
    RegisterClass("BABYLON.Vector3", Vector3);
    RegisterClass("BABYLON.Vector4", Vector4);
    RegisterClass("BABYLON.Matrix", Matrix);
    const mtxConvertNDCToHalfZRange = Matrix.FromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0.5, 0, 0, 0, 0.5, 1);

    /**
     * @internal
     */
    function _WarnImport(name) {
        return `${name} needs to be imported before as it contains a side-effect required by your code.`;
    }

    function colorChannelToLinearSpace(color) {
        return Math.pow(color, ToLinearSpace);
    }
    function colorChannelToLinearSpaceExact(color) {
        if (color <= 0.04045) {
            return 0.0773993808 * color;
        }
        return Math.pow(0.947867299 * (color + 0.055), 2.4);
    }
    function colorChannelToGammaSpace(color) {
        return Math.pow(color, ToGammaSpace);
    }
    function colorChannelToGammaSpaceExact(color) {
        if (color <= 0.0031308) {
            return 12.92 * color;
        }
        return 1.055 * Math.pow(color, 0.41666) - 0.055;
    }
    /**
     * Class used to hold a RGB color
     */
    class Color3 {
        /**
         * Creates a new Color3 object from red, green, blue values, all between 0 and 1
         * @param r defines the red component (between 0 and 1, default is 0)
         * @param g defines the green component (between 0 and 1, default is 0)
         * @param b defines the blue component (between 0 and 1, default is 0)
         */
        constructor(
        /**
         * Defines the red component (between 0 and 1, default is 0)
         */
        r = 0, 
        /**
         * Defines the green component (between 0 and 1, default is 0)
         */
        g = 0, 
        /**
         * Defines the blue component (between 0 and 1, default is 0)
         */
        b = 0) {
            this.r = r;
            this.g = g;
            this.b = b;
        }
        /**
         * Creates a string with the Color3 current values
         * @returns the string representation of the Color3 object
         */
        toString() {
            return "{R: " + this.r + " G:" + this.g + " B:" + this.b + "}";
        }
        /**
         * Returns the string "Color3"
         * @returns "Color3"
         */
        getClassName() {
            return "Color3";
        }
        /**
         * Compute the Color3 hash code
         * @returns an unique number that can be used to hash Color3 objects
         */
        getHashCode() {
            let hash = (this.r * 255) | 0;
            hash = (hash * 397) ^ ((this.g * 255) | 0);
            hash = (hash * 397) ^ ((this.b * 255) | 0);
            return hash;
        }
        // Operators
        /**
         * Stores in the given array from the given starting index the red, green, blue values as successive elements
         * @param array defines the array where to store the r,g,b components
         * @param index defines an optional index in the target array to define where to start storing values
         * @returns the current Color3 object
         */
        toArray(array, index = 0) {
            array[index] = this.r;
            array[index + 1] = this.g;
            array[index + 2] = this.b;
            return this;
        }
        /**
         * Update the current color with values stored in an array from the starting index of the given array
         * @param array defines the source array
         * @param offset defines an offset in the source array
         * @returns the current Color3 object
         */
        fromArray(array, offset = 0) {
            Color3.FromArrayToRef(array, offset, this);
            return this;
        }
        /**
         * Returns a new Color4 object from the current Color3 and the given alpha
         * @param alpha defines the alpha component on the new Color4 object (default is 1)
         * @returns a new Color4 object
         */
        toColor4(alpha = 1) {
            return new Color4(this.r, this.g, this.b, alpha);
        }
        /**
         * Returns a new array populated with 3 numeric elements : red, green and blue values
         * @returns the new array
         */
        asArray() {
            return [this.r, this.g, this.b];
        }
        /**
         * Returns the luminance value
         * @returns a float value
         */
        toLuminance() {
            return this.r * 0.3 + this.g * 0.59 + this.b * 0.11;
        }
        /**
         * Multiply each Color3 rgb values by the given Color3 rgb values in a new Color3 object
         * @param otherColor defines the second operand
         * @returns the new Color3 object
         */
        multiply(otherColor) {
            return new Color3(this.r * otherColor.r, this.g * otherColor.g, this.b * otherColor.b);
        }
        /**
         * Multiply the rgb values of the Color3 and the given Color3 and stores the result in the object "result"
         * @param otherColor defines the second operand
         * @param result defines the Color3 object where to store the result
         * @returns the current Color3
         */
        multiplyToRef(otherColor, result) {
            result.r = this.r * otherColor.r;
            result.g = this.g * otherColor.g;
            result.b = this.b * otherColor.b;
            return this;
        }
        /**
         * Determines equality between Color3 objects
         * @param otherColor defines the second operand
         * @returns true if the rgb values are equal to the given ones
         */
        equals(otherColor) {
            return otherColor && this.r === otherColor.r && this.g === otherColor.g && this.b === otherColor.b;
        }
        /**
         * Determines equality between the current Color3 object and a set of r,b,g values
         * @param r defines the red component to check
         * @param g defines the green component to check
         * @param b defines the blue component to check
         * @returns true if the rgb values are equal to the given ones
         */
        equalsFloats(r, g, b) {
            return this.r === r && this.g === g && this.b === b;
        }
        /**
         * Creates a new Color3 with the current Color3 values multiplied by scale
         * @param scale defines the scaling factor to apply
         * @returns a new Color3 object
         */
        scale(scale) {
            return new Color3(this.r * scale, this.g * scale, this.b * scale);
        }
        /**
         * Multiplies the Color3 values by the float "scale"
         * @param scale defines the scaling factor to apply
         * @returns the current updated Color3
         */
        scaleInPlace(scale) {
            this.r *= scale;
            this.g *= scale;
            this.b *= scale;
            return this;
        }
        /**
         * Multiplies the rgb values by scale and stores the result into "result"
         * @param scale defines the scaling factor
         * @param result defines the Color3 object where to store the result
         * @returns the unmodified current Color3
         */
        scaleToRef(scale, result) {
            result.r = this.r * scale;
            result.g = this.g * scale;
            result.b = this.b * scale;
            return this;
        }
        /**
         * Scale the current Color3 values by a factor and add the result to a given Color3
         * @param scale defines the scale factor
         * @param result defines color to store the result into
         * @returns the unmodified current Color3
         */
        scaleAndAddToRef(scale, result) {
            result.r += this.r * scale;
            result.g += this.g * scale;
            result.b += this.b * scale;
            return this;
        }
        /**
         * Clamps the rgb values by the min and max values and stores the result into "result"
         * @param min defines minimum clamping value (default is 0)
         * @param max defines maximum clamping value (default is 1)
         * @param result defines color to store the result into
         * @returns the original Color3
         */
        clampToRef(min = 0, max = 1, result) {
            result.r = Scalar.Clamp(this.r, min, max);
            result.g = Scalar.Clamp(this.g, min, max);
            result.b = Scalar.Clamp(this.b, min, max);
            return this;
        }
        /**
         * Creates a new Color3 set with the added values of the current Color3 and of the given one
         * @param otherColor defines the second operand
         * @returns the new Color3
         */
        add(otherColor) {
            return new Color3(this.r + otherColor.r, this.g + otherColor.g, this.b + otherColor.b);
        }
        /**
         * Stores the result of the addition of the current Color3 and given one rgb values into "result"
         * @param otherColor defines the second operand
         * @param result defines Color3 object to store the result into
         * @returns the unmodified current Color3
         */
        addToRef(otherColor, result) {
            result.r = this.r + otherColor.r;
            result.g = this.g + otherColor.g;
            result.b = this.b + otherColor.b;
            return this;
        }
        /**
         * Returns a new Color3 set with the subtracted values of the given one from the current Color3
         * @param otherColor defines the second operand
         * @returns the new Color3
         */
        subtract(otherColor) {
            return new Color3(this.r - otherColor.r, this.g - otherColor.g, this.b - otherColor.b);
        }
        /**
         * Stores the result of the subtraction of given one from the current Color3 rgb values into "result"
         * @param otherColor defines the second operand
         * @param result defines Color3 object to store the result into
         * @returns the unmodified current Color3
         */
        subtractToRef(otherColor, result) {
            result.r = this.r - otherColor.r;
            result.g = this.g - otherColor.g;
            result.b = this.b - otherColor.b;
            return this;
        }
        /**
         * Copy the current object
         * @returns a new Color3 copied the current one
         */
        clone() {
            return new Color3(this.r, this.g, this.b);
        }
        /**
         * Copies the rgb values from the source in the current Color3
         * @param source defines the source Color3 object
         * @returns the updated Color3 object
         */
        copyFrom(source) {
            this.r = source.r;
            this.g = source.g;
            this.b = source.b;
            return this;
        }
        /**
         * Updates the Color3 rgb values from the given floats
         * @param r defines the red component to read from
         * @param g defines the green component to read from
         * @param b defines the blue component to read from
         * @returns the current Color3 object
         */
        copyFromFloats(r, g, b) {
            this.r = r;
            this.g = g;
            this.b = b;
            return this;
        }
        /**
         * Updates the Color3 rgb values from the given floats
         * @param r defines the red component to read from
         * @param g defines the green component to read from
         * @param b defines the blue component to read from
         * @returns the current Color3 object
         */
        set(r, g, b) {
            return this.copyFromFloats(r, g, b);
        }
        /**
         * Compute the Color3 hexadecimal code as a string
         * @returns a string containing the hexadecimal representation of the Color3 object
         */
        toHexString() {
            const intR = Math.round(this.r * 255);
            const intG = Math.round(this.g * 255);
            const intB = Math.round(this.b * 255);
            return "#" + Scalar.ToHex(intR) + Scalar.ToHex(intG) + Scalar.ToHex(intB);
        }
        /**
         * Converts current color in rgb space to HSV values
         * @returns a new color3 representing the HSV values
         */
        toHSV() {
            const result = new Color3();
            this.toHSVToRef(result);
            return result;
        }
        /**
         * Converts current color in rgb space to HSV values
         * @param result defines the Color3 where to store the HSV values
         */
        toHSVToRef(result) {
            const r = this.r;
            const g = this.g;
            const b = this.b;
            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            let h = 0;
            let s = 0;
            const v = max;
            const dm = max - min;
            if (max !== 0) {
                s = dm / max;
            }
            if (max != min) {
                if (max == r) {
                    h = (g - b) / dm;
                    if (g < b) {
                        h += 6;
                    }
                }
                else if (max == g) {
                    h = (b - r) / dm + 2;
                }
                else if (max == b) {
                    h = (r - g) / dm + 4;
                }
                h *= 60;
            }
            result.r = h;
            result.g = s;
            result.b = v;
        }
        /**
         * Computes a new Color3 converted from the current one to linear space
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns a new Color3 object
         */
        toLinearSpace(exact = false) {
            const convertedColor = new Color3();
            this.toLinearSpaceToRef(convertedColor, exact);
            return convertedColor;
        }
        /**
         * Converts the Color3 values to linear space and stores the result in "convertedColor"
         * @param convertedColor defines the Color3 object where to store the linear space version
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns the unmodified Color3
         */
        toLinearSpaceToRef(convertedColor, exact = false) {
            if (exact) {
                convertedColor.r = colorChannelToLinearSpaceExact(this.r);
                convertedColor.g = colorChannelToLinearSpaceExact(this.g);
                convertedColor.b = colorChannelToLinearSpaceExact(this.b);
            }
            else {
                convertedColor.r = colorChannelToLinearSpace(this.r);
                convertedColor.g = colorChannelToLinearSpace(this.g);
                convertedColor.b = colorChannelToLinearSpace(this.b);
            }
            return this;
        }
        /**
         * Computes a new Color3 converted from the current one to gamma space
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns a new Color3 object
         */
        toGammaSpace(exact = false) {
            const convertedColor = new Color3();
            this.toGammaSpaceToRef(convertedColor, exact);
            return convertedColor;
        }
        /**
         * Converts the Color3 values to gamma space and stores the result in "convertedColor"
         * @param convertedColor defines the Color3 object where to store the gamma space version
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns the unmodified Color3
         */
        toGammaSpaceToRef(convertedColor, exact = false) {
            if (exact) {
                convertedColor.r = colorChannelToGammaSpaceExact(this.r);
                convertedColor.g = colorChannelToGammaSpaceExact(this.g);
                convertedColor.b = colorChannelToGammaSpaceExact(this.b);
            }
            else {
                convertedColor.r = colorChannelToGammaSpace(this.r);
                convertedColor.g = colorChannelToGammaSpace(this.g);
                convertedColor.b = colorChannelToGammaSpace(this.b);
            }
            return this;
        }
        /**
         * Converts Hue, saturation and value to a Color3 (RGB)
         * @param hue defines the hue (value between 0 and 360)
         * @param saturation defines the saturation (value between 0 and 1)
         * @param value defines the value (value between 0 and 1)
         * @param result defines the Color3 where to store the RGB values
         */
        static HSVtoRGBToRef(hue, saturation, value, result) {
            const chroma = value * saturation;
            const h = hue / 60;
            const x = chroma * (1 - Math.abs((h % 2) - 1));
            let r = 0;
            let g = 0;
            let b = 0;
            if (h >= 0 && h <= 1) {
                r = chroma;
                g = x;
            }
            else if (h >= 1 && h <= 2) {
                r = x;
                g = chroma;
            }
            else if (h >= 2 && h <= 3) {
                g = chroma;
                b = x;
            }
            else if (h >= 3 && h <= 4) {
                g = x;
                b = chroma;
            }
            else if (h >= 4 && h <= 5) {
                r = x;
                b = chroma;
            }
            else if (h >= 5 && h <= 6) {
                r = chroma;
                b = x;
            }
            const m = value - chroma;
            result.set(r + m, g + m, b + m);
        }
        /**
         * Converts Hue, saturation and value to a new Color3 (RGB)
         * @param hue defines the hue (value between 0 and 360)
         * @param saturation defines the saturation (value between 0 and 1)
         * @param value defines the value (value between 0 and 1)
         * @returns a new Color3 object
         */
        static FromHSV(hue, saturation, value) {
            const result = new Color3(0, 0, 0);
            Color3.HSVtoRGBToRef(hue, saturation, value, result);
            return result;
        }
        /**
         * Creates a new Color3 from the string containing valid hexadecimal values
         * @param hex defines a string containing valid hexadecimal values
         * @returns a new Color3 object
         */
        static FromHexString(hex) {
            if (hex.substring(0, 1) !== "#" || hex.length !== 7) {
                return new Color3(0, 0, 0);
            }
            const r = parseInt(hex.substring(1, 3), 16);
            const g = parseInt(hex.substring(3, 5), 16);
            const b = parseInt(hex.substring(5, 7), 16);
            return Color3.FromInts(r, g, b);
        }
        /**
         * Creates a new Color3 from the starting index of the given array
         * @param array defines the source array
         * @param offset defines an offset in the source array
         * @returns a new Color3 object
         */
        static FromArray(array, offset = 0) {
            return new Color3(array[offset], array[offset + 1], array[offset + 2]);
        }
        /**
         * Creates a new Color3 from the starting index element of the given array
         * @param array defines the source array to read from
         * @param offset defines the offset in the source array
         * @param result defines the target Color3 object
         */
        static FromArrayToRef(array, offset = 0, result) {
            result.r = array[offset];
            result.g = array[offset + 1];
            result.b = array[offset + 2];
        }
        /**
         * Creates a new Color3 from integer values (< 256)
         * @param r defines the red component to read from (value between 0 and 255)
         * @param g defines the green component to read from (value between 0 and 255)
         * @param b defines the blue component to read from (value between 0 and 255)
         * @returns a new Color3 object
         */
        static FromInts(r, g, b) {
            return new Color3(r / 255.0, g / 255.0, b / 255.0);
        }
        /**
         * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
         * @param start defines the start Color3 value
         * @param end defines the end Color3 value
         * @param amount defines the gradient value between start and end
         * @returns a new Color3 object
         */
        static Lerp(start, end, amount) {
            const result = new Color3(0.0, 0.0, 0.0);
            Color3.LerpToRef(start, end, amount, result);
            return result;
        }
        /**
         * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
         * @param left defines the start value
         * @param right defines the end value
         * @param amount defines the gradient factor
         * @param result defines the Color3 object where to store the result
         */
        static LerpToRef(left, right, amount, result) {
            result.r = left.r + (right.r - left.r) * amount;
            result.g = left.g + (right.g - left.g) * amount;
            result.b = left.b + (right.b - left.b) * amount;
        }
        /**
         * Returns a new Color3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent Color3
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent Color3
         * @param amount defines the amount on the interpolation spline (between 0 and 1)
         * @returns the new Color3
         */
        static Hermite(value1, tangent1, value2, tangent2, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
            const part2 = -2.0 * cubed + 3.0 * squared;
            const part3 = cubed - 2.0 * squared + amount;
            const part4 = cubed - squared;
            const r = value1.r * part1 + value2.r * part2 + tangent1.r * part3 + tangent2.r * part4;
            const g = value1.g * part1 + value2.g * part2 + tangent1.g * part3 + tangent2.g * part4;
            const b = value1.b * part1 + value2.b * part2 + tangent1.b * part3 + tangent2.b * part4;
            return new Color3(r, g, b);
        }
        /**
         * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @returns 1st derivative
         */
        static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
            const result = Color3.Black();
            this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
            return result;
        }
        /**
         * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @param result define where to store the derivative
         */
        static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
            const t2 = time * time;
            result.r = (t2 - time) * 6 * value1.r + (3 * t2 - 4 * time + 1) * tangent1.r + (-t2 + time) * 6 * value2.r + (3 * t2 - 2 * time) * tangent2.r;
            result.g = (t2 - time) * 6 * value1.g + (3 * t2 - 4 * time + 1) * tangent1.g + (-t2 + time) * 6 * value2.g + (3 * t2 - 2 * time) * tangent2.g;
            result.b = (t2 - time) * 6 * value1.b + (3 * t2 - 4 * time + 1) * tangent1.b + (-t2 + time) * 6 * value2.b + (3 * t2 - 2 * time) * tangent2.b;
        }
        /**
         * Returns a Color3 value containing a red color
         * @returns a new Color3 object
         */
        static Red() {
            return new Color3(1, 0, 0);
        }
        /**
         * Returns a Color3 value containing a green color
         * @returns a new Color3 object
         */
        static Green() {
            return new Color3(0, 1, 0);
        }
        /**
         * Returns a Color3 value containing a blue color
         * @returns a new Color3 object
         */
        static Blue() {
            return new Color3(0, 0, 1);
        }
        /**
         * Returns a Color3 value containing a black color
         * @returns a new Color3 object
         */
        static Black() {
            return new Color3(0, 0, 0);
        }
        /**
         * Gets a Color3 value containing a black color that must not be updated
         */
        static get BlackReadOnly() {
            return Color3._BlackReadOnly;
        }
        /**
         * Returns a Color3 value containing a white color
         * @returns a new Color3 object
         */
        static White() {
            return new Color3(1, 1, 1);
        }
        /**
         * Returns a Color3 value containing a purple color
         * @returns a new Color3 object
         */
        static Purple() {
            return new Color3(0.5, 0, 0.5);
        }
        /**
         * Returns a Color3 value containing a magenta color
         * @returns a new Color3 object
         */
        static Magenta() {
            return new Color3(1, 0, 1);
        }
        /**
         * Returns a Color3 value containing a yellow color
         * @returns a new Color3 object
         */
        static Yellow() {
            return new Color3(1, 1, 0);
        }
        /**
         * Returns a Color3 value containing a gray color
         * @returns a new Color3 object
         */
        static Gray() {
            return new Color3(0.5, 0.5, 0.5);
        }
        /**
         * Returns a Color3 value containing a teal color
         * @returns a new Color3 object
         */
        static Teal() {
            return new Color3(0, 1.0, 1.0);
        }
        /**
         * Returns a Color3 value containing a random color
         * @returns a new Color3 object
         */
        static Random() {
            return new Color3(Math.random(), Math.random(), Math.random());
        }
    }
    // Statics
    Color3._BlackReadOnly = Color3.Black();
    /**
     * Class used to hold a RBGA color
     */
    class Color4 {
        /**
         * Creates a new Color4 object from red, green, blue values, all between 0 and 1
         * @param r defines the red component (between 0 and 1, default is 0)
         * @param g defines the green component (between 0 and 1, default is 0)
         * @param b defines the blue component (between 0 and 1, default is 0)
         * @param a defines the alpha component (between 0 and 1, default is 1)
         */
        constructor(
        /**
         * Defines the red component (between 0 and 1, default is 0)
         */
        r = 0, 
        /**
         * Defines the green component (between 0 and 1, default is 0)
         */
        g = 0, 
        /**
         * Defines the blue component (between 0 and 1, default is 0)
         */
        b = 0, 
        /**
         * Defines the alpha component (between 0 and 1, default is 1)
         */
        a = 1) {
            this.r = r;
            this.g = g;
            this.b = b;
            this.a = a;
        }
        // Operators
        /**
         * Adds in place the given Color4 values to the current Color4 object
         * @param right defines the second operand
         * @returns the current updated Color4 object
         */
        addInPlace(right) {
            this.r += right.r;
            this.g += right.g;
            this.b += right.b;
            this.a += right.a;
            return this;
        }
        /**
         * Creates a new array populated with 4 numeric elements : red, green, blue, alpha values
         * @returns the new array
         */
        asArray() {
            return [this.r, this.g, this.b, this.a];
        }
        /**
         * Stores from the starting index in the given array the Color4 successive values
         * @param array defines the array where to store the r,g,b components
         * @param index defines an optional index in the target array to define where to start storing values
         * @returns the current Color4 object
         */
        toArray(array, index = 0) {
            array[index] = this.r;
            array[index + 1] = this.g;
            array[index + 2] = this.b;
            array[index + 3] = this.a;
            return this;
        }
        /**
         * Update the current color with values stored in an array from the starting index of the given array
         * @param array defines the source array
         * @param offset defines an offset in the source array
         * @returns the current Color4 object
         */
        fromArray(array, offset = 0) {
            Color4.FromArrayToRef(array, offset, this);
            return this;
        }
        /**
         * Determines equality between Color4 objects
         * @param otherColor defines the second operand
         * @returns true if the rgba values are equal to the given ones
         */
        equals(otherColor) {
            return otherColor && this.r === otherColor.r && this.g === otherColor.g && this.b === otherColor.b && this.a === otherColor.a;
        }
        /**
         * Creates a new Color4 set with the added values of the current Color4 and of the given one
         * @param right defines the second operand
         * @returns a new Color4 object
         */
        add(right) {
            return new Color4(this.r + right.r, this.g + right.g, this.b + right.b, this.a + right.a);
        }
        /**
         * Creates a new Color4 set with the subtracted values of the given one from the current Color4
         * @param right defines the second operand
         * @returns a new Color4 object
         */
        subtract(right) {
            return new Color4(this.r - right.r, this.g - right.g, this.b - right.b, this.a - right.a);
        }
        /**
         * Subtracts the given ones from the current Color4 values and stores the results in "result"
         * @param right defines the second operand
         * @param result defines the Color4 object where to store the result
         * @returns the current Color4 object
         */
        subtractToRef(right, result) {
            result.r = this.r - right.r;
            result.g = this.g - right.g;
            result.b = this.b - right.b;
            result.a = this.a - right.a;
            return this;
        }
        /**
         * Creates a new Color4 with the current Color4 values multiplied by scale
         * @param scale defines the scaling factor to apply
         * @returns a new Color4 object
         */
        scale(scale) {
            return new Color4(this.r * scale, this.g * scale, this.b * scale, this.a * scale);
        }
        /**
         * Multiplies the Color4 values by the float "scale"
         * @param scale defines the scaling factor to apply
         * @returns the current updated Color4
         */
        scaleInPlace(scale) {
            this.r *= scale;
            this.g *= scale;
            this.b *= scale;
            this.a *= scale;
            return this;
        }
        /**
         * Multiplies the current Color4 values by scale and stores the result in "result"
         * @param scale defines the scaling factor to apply
         * @param result defines the Color4 object where to store the result
         * @returns the current unmodified Color4
         */
        scaleToRef(scale, result) {
            result.r = this.r * scale;
            result.g = this.g * scale;
            result.b = this.b * scale;
            result.a = this.a * scale;
            return this;
        }
        /**
         * Scale the current Color4 values by a factor and add the result to a given Color4
         * @param scale defines the scale factor
         * @param result defines the Color4 object where to store the result
         * @returns the unmodified current Color4
         */
        scaleAndAddToRef(scale, result) {
            result.r += this.r * scale;
            result.g += this.g * scale;
            result.b += this.b * scale;
            result.a += this.a * scale;
            return this;
        }
        /**
         * Clamps the rgb values by the min and max values and stores the result into "result"
         * @param min defines minimum clamping value (default is 0)
         * @param max defines maximum clamping value (default is 1)
         * @param result defines color to store the result into.
         * @returns the current Color4
         */
        clampToRef(min = 0, max = 1, result) {
            result.r = Scalar.Clamp(this.r, min, max);
            result.g = Scalar.Clamp(this.g, min, max);
            result.b = Scalar.Clamp(this.b, min, max);
            result.a = Scalar.Clamp(this.a, min, max);
            return this;
        }
        /**
         * Multiply an Color4 value by another and return a new Color4 object
         * @param color defines the Color4 value to multiply by
         * @returns a new Color4 object
         */
        multiply(color) {
            return new Color4(this.r * color.r, this.g * color.g, this.b * color.b, this.a * color.a);
        }
        /**
         * Multiply a Color4 value by another and push the result in a reference value
         * @param color defines the Color4 value to multiply by
         * @param result defines the Color4 to fill the result in
         * @returns the result Color4
         */
        multiplyToRef(color, result) {
            result.r = this.r * color.r;
            result.g = this.g * color.g;
            result.b = this.b * color.b;
            result.a = this.a * color.a;
            return result;
        }
        /**
         * Creates a string with the Color4 current values
         * @returns the string representation of the Color4 object
         */
        toString() {
            return "{R: " + this.r + " G:" + this.g + " B:" + this.b + " A:" + this.a + "}";
        }
        /**
         * Returns the string "Color4"
         * @returns "Color4"
         */
        getClassName() {
            return "Color4";
        }
        /**
         * Compute the Color4 hash code
         * @returns an unique number that can be used to hash Color4 objects
         */
        getHashCode() {
            let hash = (this.r * 255) | 0;
            hash = (hash * 397) ^ ((this.g * 255) | 0);
            hash = (hash * 397) ^ ((this.b * 255) | 0);
            hash = (hash * 397) ^ ((this.a * 255) | 0);
            return hash;
        }
        /**
         * Creates a new Color4 copied from the current one
         * @returns a new Color4 object
         */
        clone() {
            return new Color4(this.r, this.g, this.b, this.a);
        }
        /**
         * Copies the given Color4 values into the current one
         * @param source defines the source Color4 object
         * @returns the current updated Color4 object
         */
        copyFrom(source) {
            this.r = source.r;
            this.g = source.g;
            this.b = source.b;
            this.a = source.a;
            return this;
        }
        /**
         * Copies the given float values into the current one
         * @param r defines the red component to read from
         * @param g defines the green component to read from
         * @param b defines the blue component to read from
         * @param a defines the alpha component to read from
         * @returns the current updated Color4 object
         */
        copyFromFloats(r, g, b, a) {
            this.r = r;
            this.g = g;
            this.b = b;
            this.a = a;
            return this;
        }
        /**
         * Copies the given float values into the current one
         * @param r defines the red component to read from
         * @param g defines the green component to read from
         * @param b defines the blue component to read from
         * @param a defines the alpha component to read from
         * @returns the current updated Color4 object
         */
        set(r, g, b, a) {
            return this.copyFromFloats(r, g, b, a);
        }
        /**
         * Compute the Color4 hexadecimal code as a string
         * @param returnAsColor3 defines if the string should only contains RGB values (off by default)
         * @returns a string containing the hexadecimal representation of the Color4 object
         */
        toHexString(returnAsColor3 = false) {
            const intR = Math.round(this.r * 255);
            const intG = Math.round(this.g * 255);
            const intB = Math.round(this.b * 255);
            if (returnAsColor3) {
                return "#" + Scalar.ToHex(intR) + Scalar.ToHex(intG) + Scalar.ToHex(intB);
            }
            const intA = Math.round(this.a * 255);
            return "#" + Scalar.ToHex(intR) + Scalar.ToHex(intG) + Scalar.ToHex(intB) + Scalar.ToHex(intA);
        }
        /**
         * Computes a new Color4 converted from the current one to linear space
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns a new Color4 object
         */
        toLinearSpace(exact = false) {
            const convertedColor = new Color4();
            this.toLinearSpaceToRef(convertedColor, exact);
            return convertedColor;
        }
        /**
         * Converts the Color4 values to linear space and stores the result in "convertedColor"
         * @param convertedColor defines the Color4 object where to store the linear space version
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns the unmodified Color4
         */
        toLinearSpaceToRef(convertedColor, exact = false) {
            if (exact) {
                convertedColor.r = colorChannelToLinearSpaceExact(this.r);
                convertedColor.g = colorChannelToLinearSpaceExact(this.g);
                convertedColor.b = colorChannelToLinearSpaceExact(this.b);
            }
            else {
                convertedColor.r = colorChannelToLinearSpace(this.r);
                convertedColor.g = colorChannelToLinearSpace(this.g);
                convertedColor.b = colorChannelToLinearSpace(this.b);
            }
            convertedColor.a = this.a;
            return this;
        }
        /**
         * Computes a new Color4 converted from the current one to gamma space
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns a new Color4 object
         */
        toGammaSpace(exact = false) {
            const convertedColor = new Color4();
            this.toGammaSpaceToRef(convertedColor, exact);
            return convertedColor;
        }
        /**
         * Converts the Color4 values to gamma space and stores the result in "convertedColor"
         * @param convertedColor defines the Color4 object where to store the gamma space version
         * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
         * @returns the unmodified Color4
         */
        toGammaSpaceToRef(convertedColor, exact = false) {
            if (exact) {
                convertedColor.r = colorChannelToGammaSpaceExact(this.r);
                convertedColor.g = colorChannelToGammaSpaceExact(this.g);
                convertedColor.b = colorChannelToGammaSpaceExact(this.b);
            }
            else {
                convertedColor.r = colorChannelToGammaSpace(this.r);
                convertedColor.g = colorChannelToGammaSpace(this.g);
                convertedColor.b = colorChannelToGammaSpace(this.b);
            }
            convertedColor.a = this.a;
            return this;
        }
        // Statics
        /**
         * Creates a new Color4 from the string containing valid hexadecimal values.
         *
         * A valid hex string is either in the format #RRGGBB or #RRGGBBAA.
         *
         * When a hex string without alpha is passed, the resulting Color4 has
         * its alpha value set to 1.0.
         *
         * An invalid string results in a Color with all its channels set to 0.0,
         * i.e. "transparent black".
         *
         * @param hex defines a string containing valid hexadecimal values
         * @returns a new Color4 object
         */
        static FromHexString(hex) {
            if (hex.substring(0, 1) !== "#" || (hex.length !== 9 && hex.length !== 7)) {
                return new Color4(0.0, 0.0, 0.0, 0.0);
            }
            const r = parseInt(hex.substring(1, 3), 16);
            const g = parseInt(hex.substring(3, 5), 16);
            const b = parseInt(hex.substring(5, 7), 16);
            const a = hex.length === 9 ? parseInt(hex.substring(7, 9), 16) : 255;
            return Color4.FromInts(r, g, b, a);
        }
        /**
         * Creates a new Color4 object set with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
         * @param left defines the start value
         * @param right defines the end value
         * @param amount defines the gradient factor
         * @returns a new Color4 object
         */
        static Lerp(left, right, amount) {
            const result = new Color4(0.0, 0.0, 0.0, 0.0);
            Color4.LerpToRef(left, right, amount, result);
            return result;
        }
        /**
         * Set the given "result" with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
         * @param left defines the start value
         * @param right defines the end value
         * @param amount defines the gradient factor
         * @param result defines the Color4 object where to store data
         */
        static LerpToRef(left, right, amount, result) {
            result.r = left.r + (right.r - left.r) * amount;
            result.g = left.g + (right.g - left.g) * amount;
            result.b = left.b + (right.b - left.b) * amount;
            result.a = left.a + (right.a - left.a) * amount;
        }
        /**
         * Interpolate between two Color4 using Hermite interpolation
         * @param value1 defines first Color4
         * @param tangent1 defines the incoming tangent
         * @param value2 defines second Color4
         * @param tangent2 defines the outgoing tangent
         * @param amount defines the target Color4
         * @returns the new interpolated Color4
         */
        static Hermite(value1, tangent1, value2, tangent2, amount) {
            const squared = amount * amount;
            const cubed = amount * squared;
            const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
            const part2 = -2.0 * cubed + 3.0 * squared;
            const part3 = cubed - 2.0 * squared + amount;
            const part4 = cubed - squared;
            const r = value1.r * part1 + value2.r * part2 + tangent1.r * part3 + tangent2.r * part4;
            const g = value1.g * part1 + value2.g * part2 + tangent1.g * part3 + tangent2.g * part4;
            const b = value1.b * part1 + value2.b * part2 + tangent1.b * part3 + tangent2.b * part4;
            const a = value1.a * part1 + value2.a * part2 + tangent1.a * part3 + tangent2.a * part4;
            return new Color4(r, g, b, a);
        }
        /**
         * Returns a new Color4 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @returns 1st derivative
         */
        static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
            const result = new Color4();
            this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
            return result;
        }
        /**
         * Update a Color4 with the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
         * @param value1 defines the first control point
         * @param tangent1 defines the first tangent
         * @param value2 defines the second control point
         * @param tangent2 defines the second tangent
         * @param time define where the derivative must be done
         * @param result define where to store the derivative
         */
        static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
            const t2 = time * time;
            result.r = (t2 - time) * 6 * value1.r + (3 * t2 - 4 * time + 1) * tangent1.r + (-t2 + time) * 6 * value2.r + (3 * t2 - 2 * time) * tangent2.r;
            result.g = (t2 - time) * 6 * value1.g + (3 * t2 - 4 * time + 1) * tangent1.g + (-t2 + time) * 6 * value2.g + (3 * t2 - 2 * time) * tangent2.g;
            result.b = (t2 - time) * 6 * value1.b + (3 * t2 - 4 * time + 1) * tangent1.b + (-t2 + time) * 6 * value2.b + (3 * t2 - 2 * time) * tangent2.b;
            result.a = (t2 - time) * 6 * value1.a + (3 * t2 - 4 * time + 1) * tangent1.a + (-t2 + time) * 6 * value2.a + (3 * t2 - 2 * time) * tangent2.a;
        }
        /**
         * Creates a new Color4 from a Color3 and an alpha value
         * @param color3 defines the source Color3 to read from
         * @param alpha defines the alpha component (1.0 by default)
         * @returns a new Color4 object
         */
        static FromColor3(color3, alpha = 1.0) {
            return new Color4(color3.r, color3.g, color3.b, alpha);
        }
        /**
         * Creates a new Color4 from the starting index element of the given array
         * @param array defines the source array to read from
         * @param offset defines the offset in the source array
         * @returns a new Color4 object
         */
        static FromArray(array, offset = 0) {
            return new Color4(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
        }
        /**
         * Creates a new Color4 from the starting index element of the given array
         * @param array defines the source array to read from
         * @param offset defines the offset in the source array
         * @param result defines the target Color4 object
         */
        static FromArrayToRef(array, offset = 0, result) {
            result.r = array[offset];
            result.g = array[offset + 1];
            result.b = array[offset + 2];
            result.a = array[offset + 3];
        }
        /**
         * Creates a new Color3 from integer values (< 256)
         * @param r defines the red component to read from (value between 0 and 255)
         * @param g defines the green component to read from (value between 0 and 255)
         * @param b defines the blue component to read from (value between 0 and 255)
         * @param a defines the alpha component to read from (value between 0 and 255)
         * @returns a new Color3 object
         */
        static FromInts(r, g, b, a) {
            return new Color4(r / 255.0, g / 255.0, b / 255.0, a / 255.0);
        }
        /**
         * Check the content of a given array and convert it to an array containing RGBA data
         * If the original array was already containing count * 4 values then it is returned directly
         * @param colors defines the array to check
         * @param count defines the number of RGBA data to expect
         * @returns an array containing count * 4 values (RGBA)
         */
        static CheckColors4(colors, count) {
            // Check if color3 was used
            if (colors.length === count * 3) {
                const colors4 = [];
                for (let index = 0; index < colors.length; index += 3) {
                    const newIndex = (index / 3) * 4;
                    colors4[newIndex] = colors[index];
                    colors4[newIndex + 1] = colors[index + 1];
                    colors4[newIndex + 2] = colors[index + 2];
                    colors4[newIndex + 3] = 1.0;
                }
                return colors4;
            }
            return colors;
        }
    }
    /**
     * @internal
     */
    class TmpColors {
    }
    TmpColors.Color3 = ArrayTools.BuildArray(3, Color3.Black);
    TmpColors.Color4 = ArrayTools.BuildArray(3, () => new Color4(0, 0, 0, 0));
    RegisterClass("BABYLON.Color3", Color3);
    RegisterClass("BABYLON.Color4", Color4);

    /* eslint-disable @typescript-eslint/no-unused-vars */
    const __decoratorInitialStore = {};
    const __mergedStore = {};
    const _copySource = function (creationFunction, source, instanciate, options = {}) {
        const destination = creationFunction();
        // Tags
        if (Tags && Tags.HasTags(source)) {
            Tags.AddTagsTo(destination, Tags.GetTags(source, true));
        }
        const classStore = getMergedStore(destination);
        // Map from source texture uniqueId to destination texture
        const textureMap = {};
        // Properties
        for (const property in classStore) {
            const propertyDescriptor = classStore[property];
            const sourceProperty = source[property];
            const propertyType = propertyDescriptor.type;
            if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || SerializationHelper.AllowLoadingUniqueId)) {
                switch (propertyType) {
                    case 0: // Value
                    case 6: // Mesh reference
                    case 11: // Camera reference
                        destination[property] = sourceProperty;
                        break;
                    case 1: // Texture
                        if (options.cloneTexturesOnlyOnce && textureMap[sourceProperty.uniqueId]) {
                            destination[property] = textureMap[sourceProperty.uniqueId];
                        }
                        else {
                            destination[property] = instanciate || sourceProperty.isRenderTarget ? sourceProperty : sourceProperty.clone();
                            textureMap[sourceProperty.uniqueId] = destination[property];
                        }
                        break;
                    case 2: // Color3
                    case 3: // FresnelParameters
                    case 4: // Vector2
                    case 5: // Vector3
                    case 7: // Color Curves
                    case 10: // Quaternion
                    case 12: // Matrix
                        destination[property] = instanciate ? sourceProperty : sourceProperty.clone();
                        break;
                }
            }
        }
        return destination;
    };
    function getDirectStore(target) {
        const classKey = target.getClassName();
        if (!__decoratorInitialStore[classKey]) {
            __decoratorInitialStore[classKey] = {};
        }
        return __decoratorInitialStore[classKey];
    }
    /**
     * Return the list of properties flagged as serializable
     * @param target host object
     */
    function getMergedStore(target) {
        const classKey = target.getClassName();
        if (__mergedStore[classKey]) {
            return __mergedStore[classKey];
        }
        __mergedStore[classKey] = {};
        const store = __mergedStore[classKey];
        let currentTarget = target;
        let currentKey = classKey;
        while (currentKey) {
            const initialStore = __decoratorInitialStore[currentKey];
            for (const property in initialStore) {
                store[property] = initialStore[property];
            }
            let parent;
            let done = false;
            do {
                parent = Object.getPrototypeOf(currentTarget);
                if (!parent.getClassName) {
                    done = true;
                    break;
                }
                if (parent.getClassName() !== currentKey) {
                    break;
                }
                currentTarget = parent;
            } while (parent);
            if (done) {
                break;
            }
            currentKey = parent.getClassName();
            currentTarget = parent;
        }
        return store;
    }
    function generateSerializableMember(type, sourceName) {
        return (target, propertyKey) => {
            const classStore = getDirectStore(target);
            if (!classStore[propertyKey]) {
                classStore[propertyKey] = { type: type, sourceName: sourceName };
            }
        };
    }
    function generateExpandMember(setCallback, targetKey = null) {
        return (target, propertyKey) => {
            const key = targetKey || "_" + propertyKey;
            Object.defineProperty(target, propertyKey, {
                get: function () {
                    return this[key];
                },
                set: function (value) {
                    // does this object (i.e. vector3) has an equals function? use it!
                    // Note - not using "with epsilon" here, it is expected te behave like the internal cache does.
                    if (typeof this.equals === "function") {
                        if (this.equals(value)) {
                            return;
                        }
                    }
                    if (this[key] === value) {
                        return;
                    }
                    this[key] = value;
                    target[setCallback].apply(this);
                },
                enumerable: true,
                configurable: true,
            });
        };
    }
    function expandToProperty(callback, targetKey = null) {
        return generateExpandMember(callback, targetKey);
    }
    function serialize(sourceName) {
        return generateSerializableMember(0, sourceName); // value member
    }
    function serializeAsTexture(sourceName) {
        return generateSerializableMember(1, sourceName); // texture member
    }
    function serializeAsColor3(sourceName) {
        return generateSerializableMember(2, sourceName); // color3 member
    }
    function serializeAsFresnelParameters(sourceName) {
        return generateSerializableMember(3, sourceName); // fresnel parameters member
    }
    function serializeAsVector2(sourceName) {
        return generateSerializableMember(4, sourceName); // vector2 member
    }
    function serializeAsVector3(sourceName) {
        return generateSerializableMember(5, sourceName); // vector3 member
    }
    function serializeAsMeshReference(sourceName) {
        return generateSerializableMember(6, sourceName); // mesh reference member
    }
    function serializeAsColorCurves(sourceName) {
        return generateSerializableMember(7, sourceName); // color curves
    }
    function serializeAsColor4(sourceName) {
        return generateSerializableMember(8, sourceName); // color 4
    }
    function serializeAsImageProcessingConfiguration(sourceName) {
        return generateSerializableMember(9, sourceName); // image processing
    }
    function serializeAsQuaternion(sourceName) {
        return generateSerializableMember(10, sourceName); // quaternion member
    }
    function serializeAsMatrix(sourceName) {
        return generateSerializableMember(12, sourceName); // matrix member
    }
    /**
     * Decorator used to define property that can be serialized as reference to a camera
     * @param sourceName defines the name of the property to decorate
     */
    function serializeAsCameraReference(sourceName) {
        return generateSerializableMember(11, sourceName); // camera reference member
    }
    /**
     * Class used to help serialization objects
     */
    class SerializationHelper {
        /**
         * Appends the serialized animations from the source animations
         * @param source Source containing the animations
         * @param destination Target to store the animations
         */
        static AppendSerializedAnimations(source, destination) {
            if (source.animations) {
                destination.animations = [];
                for (let animationIndex = 0; animationIndex < source.animations.length; animationIndex++) {
                    const animation = source.animations[animationIndex];
                    destination.animations.push(animation.serialize());
                }
            }
        }
        /**
         * Static function used to serialized a specific entity
         * @param entity defines the entity to serialize
         * @param serializationObject defines the optional target object where serialization data will be stored
         * @returns a JSON compatible object representing the serialization of the entity
         */
        static Serialize(entity, serializationObject) {
            if (!serializationObject) {
                serializationObject = {};
            }
            // Tags
            if (Tags) {
                serializationObject.tags = Tags.GetTags(entity);
            }
            const serializedProperties = getMergedStore(entity);
            // Properties
            for (const property in serializedProperties) {
                const propertyDescriptor = serializedProperties[property];
                const targetPropertyName = propertyDescriptor.sourceName || property;
                const propertyType = propertyDescriptor.type;
                const sourceProperty = entity[property];
                if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || SerializationHelper.AllowLoadingUniqueId)) {
                    switch (propertyType) {
                        case 0: // Value
                            serializationObject[targetPropertyName] = sourceProperty;
                            break;
                        case 1: // Texture
                            serializationObject[targetPropertyName] = sourceProperty.serialize();
                            break;
                        case 2: // Color3
                            serializationObject[targetPropertyName] = sourceProperty.asArray();
                            break;
                        case 3: // FresnelParameters
                            serializationObject[targetPropertyName] = sourceProperty.serialize();
                            break;
                        case 4: // Vector2
                            serializationObject[targetPropertyName] = sourceProperty.asArray();
                            break;
                        case 5: // Vector3
                            serializationObject[targetPropertyName] = sourceProperty.asArray();
                            break;
                        case 6: // Mesh reference
                            serializationObject[targetPropertyName] = sourceProperty.id;
                            break;
                        case 7: // Color Curves
                            serializationObject[targetPropertyName] = sourceProperty.serialize();
                            break;
                        case 8: // Color 4
                            serializationObject[targetPropertyName] = sourceProperty.asArray();
                            break;
                        case 9: // Image Processing
                            serializationObject[targetPropertyName] = sourceProperty.serialize();
                            break;
                        case 10: // Quaternion
                            serializationObject[targetPropertyName] = sourceProperty.asArray();
                            break;
                        case 11: // Camera reference
                            serializationObject[targetPropertyName] = sourceProperty.id;
                            break;
                        case 12: // Matrix
                            serializationObject[targetPropertyName] = sourceProperty.asArray();
                            break;
                    }
                }
            }
            return serializationObject;
        }
        /**
         * Given a source json and a destination object in a scene, this function will parse the source and will try to apply its content to the destination object
         * @param source the source json data
         * @param destination the destination object
         * @param scene the scene where the object is
         * @param rootUrl root url to use to load assets
         */
        static ParseProperties(source, destination, scene, rootUrl) {
            if (!rootUrl) {
                rootUrl = "";
            }
            const classStore = getMergedStore(destination);
            // Properties
            for (const property in classStore) {
                const propertyDescriptor = classStore[property];
                const sourceProperty = source[propertyDescriptor.sourceName || property];
                const propertyType = propertyDescriptor.type;
                if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || SerializationHelper.AllowLoadingUniqueId)) {
                    const dest = destination;
                    switch (propertyType) {
                        case 0: // Value
                            dest[property] = sourceProperty;
                            break;
                        case 1: // Texture
                            if (scene) {
                                dest[property] = SerializationHelper._TextureParser(sourceProperty, scene, rootUrl);
                            }
                            break;
                        case 2: // Color3
                            dest[property] = Color3.FromArray(sourceProperty);
                            break;
                        case 3: // FresnelParameters
                            dest[property] = SerializationHelper._FresnelParametersParser(sourceProperty);
                            break;
                        case 4: // Vector2
                            dest[property] = Vector2.FromArray(sourceProperty);
                            break;
                        case 5: // Vector3
                            dest[property] = Vector3.FromArray(sourceProperty);
                            break;
                        case 6: // Mesh reference
                            if (scene) {
                                dest[property] = scene.getLastMeshById(sourceProperty);
                            }
                            break;
                        case 7: // Color Curves
                            dest[property] = SerializationHelper._ColorCurvesParser(sourceProperty);
                            break;
                        case 8: // Color 4
                            dest[property] = Color4.FromArray(sourceProperty);
                            break;
                        case 9: // Image Processing
                            dest[property] = SerializationHelper._ImageProcessingConfigurationParser(sourceProperty);
                            break;
                        case 10: // Quaternion
                            dest[property] = Quaternion.FromArray(sourceProperty);
                            break;
                        case 11: // Camera reference
                            if (scene) {
                                dest[property] = scene.getCameraById(sourceProperty);
                            }
                            break;
                        case 12: // Matrix
                            dest[property] = Matrix.FromArray(sourceProperty);
                            break;
                    }
                }
            }
        }
        /**
         * Creates a new entity from a serialization data object
         * @param creationFunction defines a function used to instanciated the new entity
         * @param source defines the source serialization data
         * @param scene defines the hosting scene
         * @param rootUrl defines the root url for resources
         * @returns a new entity
         */
        static Parse(creationFunction, source, scene, rootUrl = null) {
            const destination = creationFunction();
            // Tags
            if (Tags) {
                Tags.AddTagsTo(destination, source.tags);
            }
            SerializationHelper.ParseProperties(source, destination, scene, rootUrl);
            return destination;
        }
        /**
         * Clones an object
         * @param creationFunction defines the function used to instanciate the new object
         * @param source defines the source object
         * @returns the cloned object
         */
        static Clone(creationFunction, source, options = {}) {
            return _copySource(creationFunction, source, false, options);
        }
        /**
         * Instanciates a new object based on a source one (some data will be shared between both object)
         * @param creationFunction defines the function used to instanciate the new object
         * @param source defines the source object
         * @returns the new object
         */
        static Instanciate(creationFunction, source) {
            return _copySource(creationFunction, source, true);
        }
    }
    /**
     * Gets or sets a boolean to indicate if the UniqueId property should be serialized
     */
    SerializationHelper.AllowLoadingUniqueId = false;
    /**
     * @internal
     */
    SerializationHelper._ImageProcessingConfigurationParser = (sourceProperty) => {
        throw _WarnImport("ImageProcessingConfiguration");
    };
    /**
     * @internal
     */
    SerializationHelper._FresnelParametersParser = (sourceProperty) => {
        throw _WarnImport("FresnelParameters");
    };
    /**
     * @internal
     */
    SerializationHelper._ColorCurvesParser = (sourceProperty) => {
        throw _WarnImport("ColorCurves");
    };
    /**
     * @internal
     */
    SerializationHelper._TextureParser = (sourceProperty, scene, rootUrl) => {
        throw _WarnImport("Texture");
    };
    /**
     * Decorator used to redirect a function to a native implementation if available.
     * @internal
     */
    function nativeOverride(target, propertyKey, descriptor, predicate) {
        // Cache the original JS function for later.
        const jsFunc = descriptor.value;
        // Override the JS function to check for a native override on first invocation. Setting descriptor.value overrides the function at the early stage of code being loaded/imported.
        descriptor.value = (...params) => {
            // Assume the resolved function will be the original JS function, then we will check for the Babylon Native context.
            let func = jsFunc;
            // Check if we are executing in a Babylon Native context (e.g. check the presence of the _native global property) and if so also check if a function override is available.
            if (typeof _native !== "undefined" && _native[propertyKey]) {
                const nativeFunc = _native[propertyKey];
                // If a predicate was provided, then we'll need to invoke the predicate on each invocation of the underlying function to determine whether to call the native function or the JS function.
                if (predicate) {
                    // The resolved function will execute the predicate and then either execute the native function or the JS function.
                    func = (...params) => (predicate(...params) ? nativeFunc(...params) : jsFunc(...params));
                }
                else {
                    // The resolved function will directly execute the native function.
                    func = nativeFunc;
                }
            }
            // Override the JS function again with the final resolved target function.
            target[propertyKey] = func;
            // The JS function has now been overridden based on whether we're executing in the context of Babylon Native, but we still need to invoke that function.
            // Future invocations of the function will just directly invoke the final overridden function, not any of the decorator setup logic above.
            return func(...params);
        };
    }
    /**
     * Decorator factory that applies the nativeOverride decorator, but determines whether to redirect to the native implementation based on a filter function that evaluates the function arguments.
     * @param predicate
     * @example @nativeOverride.filter((...[arg1]: Parameters<typeof someClass.someMethod>) => arg1.length > 20)
     *          public someMethod(arg1: string, arg2: number): string {
     * @internal
     */
    nativeOverride.filter = function (predicate) {
        return (target, propertyKey, descriptor) => nativeOverride(target, propertyKey, descriptor, predicate);
    };

    /** @internal */
    class _InternalNodeDataInfo {
        constructor() {
            this._doNotSerialize = false;
            this._isDisposed = false;
            this._sceneRootNodesIndex = -1;
            this._isEnabled = true;
            this._isParentEnabled = true;
            this._isReady = true;
            this._onEnabledStateChangedObservable = new Observable$1();
            this._onClonedObservable = new Observable$1();
        }
    }
    /**
     * Node is the basic class for all scene objects (Mesh, Light, Camera.)
     */
    class Node {
        /**
         * Add a new node constructor
         * @param type defines the type name of the node to construct
         * @param constructorFunc defines the constructor function
         */
        static AddNodeConstructor(type, constructorFunc) {
            this._NodeConstructors[type] = constructorFunc;
        }
        /**
         * Returns a node constructor based on type name
         * @param type defines the type name
         * @param name defines the new node name
         * @param scene defines the hosting scene
         * @param options defines optional options to transmit to constructors
         * @returns the new constructor or null
         */
        static Construct(type, name, scene, options) {
            const constructorFunc = this._NodeConstructors[type];
            if (!constructorFunc) {
                return null;
            }
            return constructorFunc(name, scene, options);
        }
        /**
         * Gets or sets the accessibility tag to describe the node for accessibility purpose.
         */
        set accessibilityTag(value) {
            this._accessibilityTag = value;
            this.onAccessibilityTagChangedObservable.notifyObservers(value);
        }
        get accessibilityTag() {
            return this._accessibilityTag;
        }
        /**
         * Gets or sets a boolean used to define if the node must be serialized
         */
        get doNotSerialize() {
            if (this._nodeDataStorage._doNotSerialize) {
                return true;
            }
            if (this._parentNode) {
                return this._parentNode.doNotSerialize;
            }
            return false;
        }
        set doNotSerialize(value) {
            this._nodeDataStorage._doNotSerialize = value;
        }
        /**
         * Gets a boolean indicating if the node has been disposed
         * @returns true if the node was disposed
         */
        isDisposed() {
            return this._nodeDataStorage._isDisposed;
        }
        /**
         * Gets or sets the parent of the node (without keeping the current position in the scene)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
         */
        set parent(parent) {
            if (this._parentNode === parent) {
                return;
            }
            const previousParentNode = this._parentNode;
            // Remove self from list of children of parent
            if (this._parentNode && this._parentNode._children !== undefined && this._parentNode._children !== null) {
                const index = this._parentNode._children.indexOf(this);
                if (index !== -1) {
                    this._parentNode._children.splice(index, 1);
                }
                if (!parent && !this._nodeDataStorage._isDisposed) {
                    this._addToSceneRootNodes();
                }
            }
            // Store new parent
            this._parentNode = parent;
            // Add as child to new parent
            if (this._parentNode) {
                if (this._parentNode._children === undefined || this._parentNode._children === null) {
                    this._parentNode._children = new Array();
                }
                this._parentNode._children.push(this);
                if (!previousParentNode) {
                    this._removeFromSceneRootNodes();
                }
            }
            // Enabled state
            this._syncParentEnabledState();
        }
        get parent() {
            return this._parentNode;
        }
        /**
         * @internal
         */
        _serializeAsParent(serializationObject) {
            serializationObject.parentId = this.uniqueId;
        }
        /** @internal */
        _addToSceneRootNodes() {
            if (this._nodeDataStorage._sceneRootNodesIndex === -1) {
                this._nodeDataStorage._sceneRootNodesIndex = this._scene.rootNodes.length;
                this._scene.rootNodes.push(this);
            }
        }
        /** @internal */
        _removeFromSceneRootNodes() {
            if (this._nodeDataStorage._sceneRootNodesIndex !== -1) {
                const rootNodes = this._scene.rootNodes;
                const lastIdx = rootNodes.length - 1;
                rootNodes[this._nodeDataStorage._sceneRootNodesIndex] = rootNodes[lastIdx];
                rootNodes[this._nodeDataStorage._sceneRootNodesIndex]._nodeDataStorage._sceneRootNodesIndex = this._nodeDataStorage._sceneRootNodesIndex;
                this._scene.rootNodes.pop();
                this._nodeDataStorage._sceneRootNodesIndex = -1;
            }
        }
        /**
         * Gets or sets the animation properties override
         */
        get animationPropertiesOverride() {
            if (!this._animationPropertiesOverride) {
                return this._scene.animationPropertiesOverride;
            }
            return this._animationPropertiesOverride;
        }
        set animationPropertiesOverride(value) {
            this._animationPropertiesOverride = value;
        }
        /**
         * Gets a string identifying the name of the class
         * @returns "Node" string
         */
        getClassName() {
            return "Node";
        }
        /**
         * Sets a callback that will be raised when the node will be disposed
         */
        set onDispose(callback) {
            if (this._onDisposeObserver) {
                this.onDisposeObservable.remove(this._onDisposeObserver);
            }
            this._onDisposeObserver = this.onDisposeObservable.add(callback);
        }
        /**
         * An event triggered when the enabled state of the node changes
         */
        get onEnabledStateChangedObservable() {
            return this._nodeDataStorage._onEnabledStateChangedObservable;
        }
        /**
         * An event triggered when the node is cloned
         */
        get onClonedObservable() {
            return this._nodeDataStorage._onClonedObservable;
        }
        /**
         * Creates a new Node
         * @param name the name and id to be given to this node
         * @param scene the scene this node will be added to
         */
        constructor(name, scene = null) {
            this._isDirty = false;
            this._nodeDataStorage = new _InternalNodeDataInfo();
            /**
             * Gets or sets a string used to store user defined state for the node
             */
            this.state = "";
            /**
             * Gets or sets an object used to store user defined information for the node
             */
            this.metadata = null;
            /**
             * For internal use only. Please do not use.
             */
            this.reservedDataStore = null;
            this._accessibilityTag = null;
            this.onAccessibilityTagChangedObservable = new Observable$1();
            /** @internal */
            this._parentContainer = null;
            /**
             * Gets a list of Animations associated with the node
             */
            this.animations = new Array();
            this._ranges = {};
            /**
             * Callback raised when the node is ready to be used
             */
            this.onReady = null;
            /** @internal */
            this._currentRenderId = -1;
            this._parentUpdateId = -1;
            /** @internal */
            this._childUpdateId = -1;
            /** @internal */
            this._waitingParentId = null;
            /** @internal */
            this._waitingParentInstanceIndex = null;
            /** @internal */
            this._waitingParsedUniqueId = null;
            /** @internal */
            this._cache = {};
            this._parentNode = null;
            /** @internal */
            this._children = null;
            /** @internal */
            this._worldMatrix = Matrix.Identity();
            /** @internal */
            this._worldMatrixDeterminant = 0;
            /** @internal */
            this._worldMatrixDeterminantIsDirty = true;
            this._animationPropertiesOverride = null;
            /** @internal */
            this._isNode = true;
            /**
             * An event triggered when the mesh is disposed
             */
            this.onDisposeObservable = new Observable$1();
            this._onDisposeObserver = null;
            // Behaviors
            this._behaviors = new Array();
            this.name = name;
            this.id = name;
            this._scene = (scene || EngineStore.LastCreatedScene);
            this.uniqueId = this._scene.getUniqueId();
            this._initCache();
        }
        /**
         * Gets the scene of the node
         * @returns a scene
         */
        getScene() {
            return this._scene;
        }
        /**
         * Gets the engine of the node
         * @returns a Engine
         */
        getEngine() {
            return this._scene.getEngine();
        }
        /**
         * Attach a behavior to the node
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
         * @param behavior defines the behavior to attach
         * @param attachImmediately defines that the behavior must be attached even if the scene is still loading
         * @returns the current Node
         */
        addBehavior(behavior, attachImmediately = false) {
            const index = this._behaviors.indexOf(behavior);
            if (index !== -1) {
                return this;
            }
            behavior.init();
            if (this._scene.isLoading && !attachImmediately) {
                // We defer the attach when the scene will be loaded
                this._scene.onDataLoadedObservable.addOnce(() => {
                    behavior.attach(this);
                });
            }
            else {
                behavior.attach(this);
            }
            this._behaviors.push(behavior);
            return this;
        }
        /**
         * Remove an attached behavior
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
         * @param behavior defines the behavior to attach
         * @returns the current Node
         */
        removeBehavior(behavior) {
            const index = this._behaviors.indexOf(behavior);
            if (index === -1) {
                return this;
            }
            this._behaviors[index].detach();
            this._behaviors.splice(index, 1);
            return this;
        }
        /**
         * Gets the list of attached behaviors
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
         */
        get behaviors() {
            return this._behaviors;
        }
        /**
         * Gets an attached behavior by name
         * @param name defines the name of the behavior to look for
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
         * @returns null if behavior was not found else the requested behavior
         */
        getBehaviorByName(name) {
            for (const behavior of this._behaviors) {
                if (behavior.name === name) {
                    return behavior;
                }
            }
            return null;
        }
        /**
         * Returns the latest update of the World matrix
         * @returns a Matrix
         */
        getWorldMatrix() {
            if (this._currentRenderId !== this._scene.getRenderId()) {
                this.computeWorldMatrix();
            }
            return this._worldMatrix;
        }
        /** @internal */
        _getWorldMatrixDeterminant() {
            if (this._worldMatrixDeterminantIsDirty) {
                this._worldMatrixDeterminantIsDirty = false;
                this._worldMatrixDeterminant = this._worldMatrix.determinant();
            }
            return this._worldMatrixDeterminant;
        }
        /**
         * Returns directly the latest state of the mesh World matrix.
         * A Matrix is returned.
         */
        get worldMatrixFromCache() {
            return this._worldMatrix;
        }
        // override it in derived class if you add new variables to the cache
        // and call the parent class method
        /** @internal */
        _initCache() {
            this._cache = {};
            this._cache.parent = undefined;
        }
        /**
         * @internal
         */
        updateCache(force) {
            if (!force && this.isSynchronized()) {
                return;
            }
            this._cache.parent = this.parent;
            this._updateCache();
        }
        /**
         * @internal
         */
        _getActionManagerForTrigger(trigger, _initialCall = true) {
            if (!this.parent) {
                return null;
            }
            return this.parent._getActionManagerForTrigger(trigger, false);
        }
        // override it in derived class if you add new variables to the cache
        // and call the parent class method if !ignoreParentClass
        /**
         * @internal
         */
        _updateCache(_ignoreParentClass) { }
        // override it in derived class if you add new variables to the cache
        /** @internal */
        _isSynchronized() {
            return true;
        }
        /** @internal */
        _markSyncedWithParent() {
            if (this._parentNode) {
                this._parentUpdateId = this._parentNode._childUpdateId;
            }
        }
        /** @internal */
        isSynchronizedWithParent() {
            if (!this._parentNode) {
                return true;
            }
            if (this._parentNode._isDirty || this._parentUpdateId !== this._parentNode._childUpdateId) {
                return false;
            }
            return this._parentNode.isSynchronized();
        }
        /** @internal */
        isSynchronized() {
            if (this._cache.parent !== this._parentNode) {
                this._cache.parent = this._parentNode;
                return false;
            }
            if (this._parentNode && !this.isSynchronizedWithParent()) {
                return false;
            }
            return this._isSynchronized();
        }
        /**
         * Is this node ready to be used/rendered
         * @param _completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
         * @returns true if the node is ready
         */
        isReady(_completeCheck = false) {
            return this._nodeDataStorage._isReady;
        }
        /**
         * Flag the  node as dirty (Forcing it to update everything)
         * @param _property helps children apply precise "dirtyfication"
         * @returns this node
         */
        markAsDirty(_property) {
            this._currentRenderId = Number.MAX_VALUE;
            this._isDirty = true;
            return this;
        }
        /**
         * Is this node enabled?
         * If the node has a parent, all ancestors will be checked and false will be returned if any are false (not enabled), otherwise will return true
         * @param checkAncestors indicates if this method should check the ancestors. The default is to check the ancestors. If set to false, the method will return the value of this node without checking ancestors
         * @returns whether this node (and its parent) is enabled
         */
        isEnabled(checkAncestors = true) {
            if (checkAncestors === false) {
                return this._nodeDataStorage._isEnabled;
            }
            if (!this._nodeDataStorage._isEnabled) {
                return false;
            }
            return this._nodeDataStorage._isParentEnabled;
        }
        /** @internal */
        _syncParentEnabledState() {
            this._nodeDataStorage._isParentEnabled = this._parentNode ? this._parentNode.isEnabled() : true;
            if (this._children) {
                this._children.forEach((c) => {
                    c._syncParentEnabledState(); // Force children to update accordingly
                });
            }
        }
        /**
         * Set the enabled state of this node
         * @param value defines the new enabled state
         */
        setEnabled(value) {
            if (this._nodeDataStorage._isEnabled === value) {
                return;
            }
            this._nodeDataStorage._isEnabled = value;
            this._syncParentEnabledState();
            this._nodeDataStorage._onEnabledStateChangedObservable.notifyObservers(value);
        }
        /**
         * Is this node a descendant of the given node?
         * The function will iterate up the hierarchy until the ancestor was found or no more parents defined
         * @param ancestor defines the parent node to inspect
         * @returns a boolean indicating if this node is a descendant of the given node
         */
        isDescendantOf(ancestor) {
            if (this.parent) {
                if (this.parent === ancestor) {
                    return true;
                }
                return this.parent.isDescendantOf(ancestor);
            }
            return false;
        }
        /**
         * @internal
         */
        _getDescendants(results, directDescendantsOnly = false, predicate) {
            if (!this._children) {
                return;
            }
            for (let index = 0; index < this._children.length; index++) {
                const item = this._children[index];
                if (!predicate || predicate(item)) {
                    results.push(item);
                }
                if (!directDescendantsOnly) {
                    item._getDescendants(results, false, predicate);
                }
            }
        }
        /**
         * Will return all nodes that have this node as ascendant
         * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
         * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
         * @returns all children nodes of all types
         */
        getDescendants(directDescendantsOnly, predicate) {
            const results = new Array();
            this._getDescendants(results, directDescendantsOnly, predicate);
            return results;
        }
        /**
         * Get all child-meshes of this node
         * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: false)
         * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
         * @returns an array of AbstractMesh
         */
        getChildMeshes(directDescendantsOnly, predicate) {
            const results = [];
            this._getDescendants(results, directDescendantsOnly, (node) => {
                return (!predicate || predicate(node)) && node.cullingStrategy !== undefined;
            });
            return results;
        }
        /**
         * Get all direct children of this node
         * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
         * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: true)
         * @returns an array of Node
         */
        getChildren(predicate, directDescendantsOnly = true) {
            return this.getDescendants(directDescendantsOnly, predicate);
        }
        /**
         * @internal
         */
        _setReady(state) {
            if (state === this._nodeDataStorage._isReady) {
                return;
            }
            if (!state) {
                this._nodeDataStorage._isReady = false;
                return;
            }
            if (this.onReady) {
                this.onReady(this);
            }
            this._nodeDataStorage._isReady = true;
        }
        /**
         * Get an animation by name
         * @param name defines the name of the animation to look for
         * @returns null if not found else the requested animation
         */
        getAnimationByName(name) {
            for (let i = 0; i < this.animations.length; i++) {
                const animation = this.animations[i];
                if (animation.name === name) {
                    return animation;
                }
            }
            return null;
        }
        /**
         * Creates an animation range for this node
         * @param name defines the name of the range
         * @param from defines the starting key
         * @param to defines the end key
         */
        createAnimationRange(name, from, to) {
            // check name not already in use
            if (!this._ranges[name]) {
                this._ranges[name] = Node._AnimationRangeFactory(name, from, to);
                for (let i = 0, nAnimations = this.animations.length; i < nAnimations; i++) {
                    if (this.animations[i]) {
                        this.animations[i].createRange(name, from, to);
                    }
                }
            }
        }
        /**
         * Delete a specific animation range
         * @param name defines the name of the range to delete
         * @param deleteFrames defines if animation frames from the range must be deleted as well
         */
        deleteAnimationRange(name, deleteFrames = true) {
            for (let i = 0, nAnimations = this.animations.length; i < nAnimations; i++) {
                if (this.animations[i]) {
                    this.animations[i].deleteRange(name, deleteFrames);
                }
            }
            this._ranges[name] = null; // said much faster than 'delete this._range[name]'
        }
        /**
         * Get an animation range by name
         * @param name defines the name of the animation range to look for
         * @returns null if not found else the requested animation range
         */
        getAnimationRange(name) {
            return this._ranges[name] || null;
        }
        /**
         * Clone the current node
         * @param name Name of the new clone
         * @param newParent New parent for the clone
         * @param doNotCloneChildren Do not clone children hierarchy
         * @returns the new transform node
         */
        clone(name, newParent, doNotCloneChildren) {
            const result = SerializationHelper.Clone(() => new Node(name, this.getScene()), this);
            if (newParent) {
                result.parent = newParent;
            }
            if (!doNotCloneChildren) {
                // Children
                const directDescendants = this.getDescendants(true);
                for (let index = 0; index < directDescendants.length; index++) {
                    const child = directDescendants[index];
                    child.clone(name + "." + child.name, result);
                }
            }
            return result;
        }
        /**
         * Gets the list of all animation ranges defined on this node
         * @returns an array
         */
        getAnimationRanges() {
            const animationRanges = [];
            let name;
            for (name in this._ranges) {
                animationRanges.push(this._ranges[name]);
            }
            return animationRanges;
        }
        /**
         * Will start the animation sequence
         * @param name defines the range frames for animation sequence
         * @param loop defines if the animation should loop (false by default)
         * @param speedRatio defines the speed factor in which to run the animation (1 by default)
         * @param onAnimationEnd defines a function to be executed when the animation ended (undefined by default)
         * @returns the object created for this animation. If range does not exist, it will return null
         */
        beginAnimation(name, loop, speedRatio, onAnimationEnd) {
            const range = this.getAnimationRange(name);
            if (!range) {
                return null;
            }
            return this._scene.beginAnimation(this, range.from, range.to, loop, speedRatio, onAnimationEnd);
        }
        /**
         * Serialize animation ranges into a JSON compatible object
         * @returns serialization object
         */
        serializeAnimationRanges() {
            const serializationRanges = [];
            for (const name in this._ranges) {
                const localRange = this._ranges[name];
                if (!localRange) {
                    continue;
                }
                const range = {};
                range.name = name;
                range.from = localRange.from;
                range.to = localRange.to;
                serializationRanges.push(range);
            }
            return serializationRanges;
        }
        /**
         * Computes the world matrix of the node
         * @param _force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
         * @returns the world matrix
         */
        computeWorldMatrix(_force) {
            if (!this._worldMatrix) {
                this._worldMatrix = Matrix.Identity();
            }
            return this._worldMatrix;
        }
        /**
         * Releases resources associated with this node.
         * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
         * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            this._nodeDataStorage._isDisposed = true;
            if (!doNotRecurse) {
                const nodes = this.getDescendants(true);
                for (const node of nodes) {
                    node.dispose(doNotRecurse, disposeMaterialAndTextures);
                }
            }
            if (!this.parent) {
                this._removeFromSceneRootNodes();
            }
            else {
                this.parent = null;
            }
            // Callback
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
            this.onEnabledStateChangedObservable.clear();
            this.onClonedObservable.clear();
            // Behaviors
            for (const behavior of this._behaviors) {
                behavior.detach();
            }
            this._behaviors.length = 0;
            this.metadata = null;
        }
        /**
         * Parse animation range data from a serialization object and store them into a given node
         * @param node defines where to store the animation ranges
         * @param parsedNode defines the serialization object to read data from
         * @param _scene defines the hosting scene
         */
        static ParseAnimationRanges(node, parsedNode, _scene) {
            if (parsedNode.ranges) {
                for (let index = 0; index < parsedNode.ranges.length; index++) {
                    const data = parsedNode.ranges[index];
                    node.createAnimationRange(data.name, data.from, data.to);
                }
            }
        }
        /**
         * Return the minimum and maximum world vectors of the entire hierarchy under current node
         * @param includeDescendants Include bounding info from descendants as well (true by default)
         * @param predicate defines a callback function that can be customize to filter what meshes should be included in the list used to compute the bounding vectors
         * @returns the new bounding vectors
         */
        getHierarchyBoundingVectors(includeDescendants = true, predicate = null) {
            // Ensures that all world matrix will be recomputed.
            this.getScene().incrementRenderId();
            this.computeWorldMatrix(true);
            let min;
            let max;
            const thisAbstractMesh = this;
            if (thisAbstractMesh.getBoundingInfo && thisAbstractMesh.subMeshes) {
                // If this is an abstract mesh get its bounding info
                const boundingInfo = thisAbstractMesh.getBoundingInfo();
                min = boundingInfo.boundingBox.minimumWorld.clone();
                max = boundingInfo.boundingBox.maximumWorld.clone();
            }
            else {
                min = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
                max = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
            }
            if (includeDescendants) {
                const descendants = this.getDescendants(false);
                for (const descendant of descendants) {
                    const childMesh = descendant;
                    childMesh.computeWorldMatrix(true);
                    // Filters meshes based on custom predicate function.
                    if (predicate && !predicate(childMesh)) {
                        continue;
                    }
                    //make sure we have the needed params to get mix and max
                    if (!childMesh.getBoundingInfo || childMesh.getTotalVertices() === 0) {
                        continue;
                    }
                    const childBoundingInfo = childMesh.getBoundingInfo();
                    const boundingBox = childBoundingInfo.boundingBox;
                    const minBox = boundingBox.minimumWorld;
                    const maxBox = boundingBox.maximumWorld;
                    Vector3.CheckExtends(minBox, min, max);
                    Vector3.CheckExtends(maxBox, min, max);
                }
            }
            return {
                min: min,
                max: max,
            };
        }
    }
    /**
     * @internal
     */
    Node._AnimationRangeFactory = (_name, _from, _to) => {
        throw _WarnImport("AnimationRange");
    };
    Node._NodeConstructors = {};
    __decorate$1([
        serialize()
    ], Node.prototype, "name", void 0);
    __decorate$1([
        serialize()
    ], Node.prototype, "id", void 0);
    __decorate$1([
        serialize()
    ], Node.prototype, "uniqueId", void 0);
    __decorate$1([
        serialize()
    ], Node.prototype, "state", void 0);
    __decorate$1([
        serialize()
    ], Node.prototype, "metadata", void 0);

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * Checks if the window object exists
     * @returns true if the window object exists
     */
    function IsWindowObjectExist() {
        return typeof window !== "undefined";
    }
    /**
     * Checks if the navigator object exists
     * @returns true if the navigator object exists
     */
    function IsNavigatorAvailable() {
        return typeof navigator !== "undefined";
    }
    /**
     * Check if the document object exists
     * @returns true if the document object exists
     */
    function IsDocumentAvailable() {
        return typeof document !== "undefined";
    }
    /**
     * Extracts text content from a DOM element hierarchy
     * @param element defines the root element
     * @returns a string
     */
    function GetDOMTextContent(element) {
        let result = "";
        let child = element.firstChild;
        while (child) {
            if (child.nodeType === 3) {
                result += child.textContent;
            }
            child = child.nextSibling;
        }
        return result;
    }

    /**
     * Logger used throughout the application to allow configuration of
     * the log level required for the messages.
     */
    class Logger {
        static _CheckLimit(message, limit) {
            let entry = Logger._LogLimitOutputs[message];
            if (!entry) {
                entry = { limit, current: 1 };
                Logger._LogLimitOutputs[message] = entry;
            }
            else {
                entry.current++;
            }
            return entry.current <= entry.limit;
        }
        static _GenerateLimitMessage(message, level = 1) {
            var _a;
            const entry = Logger._LogLimitOutputs[message];
            if (!entry || !Logger.MessageLimitReached) {
                return;
            }
            const type = this._Levels[level];
            if (entry.current === entry.limit) {
                Logger[type.name](Logger.MessageLimitReached.replace(/%LIMIT%/g, "" + entry.limit).replace(/%TYPE%/g, (_a = type.name) !== null && _a !== void 0 ? _a : ""));
            }
        }
        static _AddLogEntry(entry) {
            Logger._LogCache = entry + Logger._LogCache;
            if (Logger.OnNewCacheEntry) {
                Logger.OnNewCacheEntry(entry);
            }
        }
        static _FormatMessage(message) {
            const padStr = (i) => (i < 10 ? "0" + i : "" + i);
            const date = new Date();
            return "[" + padStr(date.getHours()) + ":" + padStr(date.getMinutes()) + ":" + padStr(date.getSeconds()) + "]: " + message;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static _LogDisabled(message, limit) {
            // nothing to do
        }
        static _LogEnabled(level = 1, message, limit) {
            if (limit !== undefined && !Logger._CheckLimit(message, limit)) {
                return;
            }
            const formattedMessage = Logger._FormatMessage(message);
            const type = this._Levels[level];
            type.logFunc && type.logFunc("BJS - " + formattedMessage);
            const entry = `<div style='color:${type.color}'>${formattedMessage}</div><br>`;
            Logger._AddLogEntry(entry);
            Logger._GenerateLimitMessage(message, level);
        }
        /**
         * Gets current log cache (list of logs)
         */
        static get LogCache() {
            return Logger._LogCache;
        }
        /**
         * Clears the log cache
         */
        static ClearLogCache() {
            Logger._LogCache = "";
            Logger._LogLimitOutputs = {};
            Logger.errorsCount = 0;
        }
        /**
         * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
         */
        static set LogLevels(level) {
            Logger.Log = Logger._LogDisabled;
            Logger.Warn = Logger._LogDisabled;
            Logger.Error = Logger._LogDisabled;
            [Logger.MessageLogLevel, Logger.WarningLogLevel, Logger.ErrorLogLevel].forEach((l) => {
                if ((level & l) === l) {
                    const type = this._Levels[l];
                    Logger[type.name] = Logger._LogEnabled.bind(Logger, l);
                }
            });
        }
    }
    /**
     * No log
     */
    Logger.NoneLogLevel = 0;
    /**
     * Only message logs
     */
    Logger.MessageLogLevel = 1;
    /**
     * Only warning logs
     */
    Logger.WarningLogLevel = 2;
    /**
     * Only error logs
     */
    Logger.ErrorLogLevel = 4;
    /**
     * All logs
     */
    Logger.AllLogLevel = 7;
    /**
     * Message to display when a message has been logged too many times
     */
    Logger.MessageLimitReached = "Too many %TYPE%s (%LIMIT%), no more %TYPE%s will be reported for this message.";
    Logger._LogCache = "";
    Logger._LogLimitOutputs = {};
    // levels according to the (binary) numbering.
    Logger._Levels = [
        {},
        { color: "white", logFunc: console.log, name: "Log" },
        { color: "orange", logFunc: console.warn, name: "Warn" },
        {},
        { color: "red", logFunc: console.error, name: "Error" },
    ];
    /**
     * Gets a value indicating the number of loading errors
     * @ignorenaming
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Logger.errorsCount = 0;
    /**
     * Log a message to the console
     */
    Logger.Log = Logger._LogEnabled.bind(Logger, Logger.MessageLogLevel);
    /**
     * Write a warning message to the console
     */
    Logger.Warn = Logger._LogEnabled.bind(Logger, Logger.WarningLogLevel);
    /**
     * Write an error message to the console
     */
    Logger.Error = Logger._LogEnabled.bind(Logger, Logger.ErrorLogLevel);

    const CloneValue = (source, destinationObject) => {
        if (!source) {
            return null;
        }
        if (source.getClassName && source.getClassName() === "Mesh") {
            return null;
        }
        if (source.getClassName && (source.getClassName() === "SubMesh" || source.getClassName() === "PhysicsBody")) {
            return source.clone(destinationObject);
        }
        else if (source.clone) {
            return source.clone();
        }
        else if (Array.isArray(source)) {
            return source.slice();
        }
        return null;
    };
    function GetAllPropertyNames(obj) {
        const props = [];
        do {
            Object.getOwnPropertyNames(obj).forEach(function (prop) {
                if (props.indexOf(prop) === -1) {
                    props.push(prop);
                }
            });
        } while ((obj = Object.getPrototypeOf(obj)));
        return props;
    }
    /**
     * Class containing a set of static utilities functions for deep copy.
     */
    class DeepCopier {
        /**
         * Tries to copy an object by duplicating every property
         * @param source defines the source object
         * @param destination defines the target object
         * @param doNotCopyList defines a list of properties to avoid
         * @param mustCopyList defines a list of properties to copy (even if they start with _)
         */
        static DeepCopy(source, destination, doNotCopyList, mustCopyList) {
            const properties = GetAllPropertyNames(source);
            for (const prop of properties) {
                if (prop[0] === "_" && (!mustCopyList || mustCopyList.indexOf(prop) === -1)) {
                    continue;
                }
                if (prop.endsWith("Observable")) {
                    continue;
                }
                if (doNotCopyList && doNotCopyList.indexOf(prop) !== -1) {
                    continue;
                }
                const sourceValue = source[prop];
                const typeOfSourceValue = typeof sourceValue;
                if (typeOfSourceValue === "function") {
                    continue;
                }
                try {
                    if (typeOfSourceValue === "object") {
                        if (sourceValue instanceof Uint8Array) {
                            destination[prop] = Uint8Array.from(sourceValue);
                        }
                        else if (sourceValue instanceof Array) {
                            destination[prop] = [];
                            if (sourceValue.length > 0) {
                                if (typeof sourceValue[0] == "object") {
                                    for (let index = 0; index < sourceValue.length; index++) {
                                        const clonedValue = CloneValue(sourceValue[index], destination);
                                        if (destination[prop].indexOf(clonedValue) === -1) {
                                            // Test if auto inject was not done
                                            destination[prop].push(clonedValue);
                                        }
                                    }
                                }
                                else {
                                    destination[prop] = sourceValue.slice(0);
                                }
                            }
                        }
                        else {
                            destination[prop] = CloneValue(sourceValue, destination);
                        }
                    }
                    else {
                        destination[prop] = sourceValue;
                    }
                }
                catch (e) {
                    // Log a warning (it could be because of a read-only property)
                    Logger.Warn(e.message);
                }
            }
        }
    }

    /**
     * Class containing a set of static utilities functions for precision date
     */
    class PrecisionDate {
        /**
         * Gets either window.performance.now() if supported or Date.now() else
         */
        static get Now() {
            if (IsWindowObjectExist() && window.performance && window.performance.now) {
                return window.performance.now();
            }
            return Date.now();
        }
    }

    /** @internal */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function createXMLHttpRequest() {
        // If running in Babylon Native, then defer to the native XMLHttpRequest, which has the same public contract
        if (typeof _native !== "undefined" && _native.XMLHttpRequest) {
            return new _native.XMLHttpRequest();
        }
        else {
            return new XMLHttpRequest();
        }
    }
    /**
     * Extended version of XMLHttpRequest with support for customizations (headers, ...)
     */
    class WebRequest {
        constructor() {
            this._xhr = createXMLHttpRequest();
            this._requestURL = "";
        }
        _injectCustomRequestHeaders() {
            if (this._shouldSkipRequestModifications(this._requestURL)) {
                return;
            }
            for (const key in WebRequest.CustomRequestHeaders) {
                const val = WebRequest.CustomRequestHeaders[key];
                if (val) {
                    this._xhr.setRequestHeader(key, val);
                }
            }
        }
        _shouldSkipRequestModifications(url) {
            return WebRequest.SkipRequestModificationForBabylonCDN && (url.includes("preview.babylonjs.com") || url.includes("cdn.babylonjs.com"));
        }
        /**
         * Gets or sets a function to be called when loading progress changes
         */
        get onprogress() {
            return this._xhr.onprogress;
        }
        set onprogress(value) {
            this._xhr.onprogress = value;
        }
        /**
         * Returns client's state
         */
        get readyState() {
            return this._xhr.readyState;
        }
        /**
         * Returns client's status
         */
        get status() {
            return this._xhr.status;
        }
        /**
         * Returns client's status as a text
         */
        get statusText() {
            return this._xhr.statusText;
        }
        /**
         * Returns client's response
         */
        get response() {
            return this._xhr.response;
        }
        /**
         * Returns client's response url
         */
        get responseURL() {
            return this._xhr.responseURL;
        }
        /**
         * Returns client's response as text
         */
        get responseText() {
            return this._xhr.responseText;
        }
        /**
         * Gets or sets the expected response type
         */
        get responseType() {
            return this._xhr.responseType;
        }
        set responseType(value) {
            this._xhr.responseType = value;
        }
        /**
         * Gets or sets the timeout value in milliseconds
         */
        get timeout() {
            return this._xhr.timeout;
        }
        set timeout(value) {
            this._xhr.timeout = value;
        }
        addEventListener(type, listener, options) {
            this._xhr.addEventListener(type, listener, options);
        }
        removeEventListener(type, listener, options) {
            this._xhr.removeEventListener(type, listener, options);
        }
        /**
         * Cancels any network activity
         */
        abort() {
            this._xhr.abort();
        }
        /**
         * Initiates the request. The optional argument provides the request body. The argument is ignored if request method is GET or HEAD
         * @param body defines an optional request body
         */
        send(body) {
            if (WebRequest.CustomRequestHeaders) {
                this._injectCustomRequestHeaders();
            }
            this._xhr.send(body);
        }
        /**
         * Sets the request method, request URL
         * @param method defines the method to use (GET, POST, etc..)
         * @param url defines the url to connect with
         */
        open(method, url) {
            for (const update of WebRequest.CustomRequestModifiers) {
                if (this._shouldSkipRequestModifications(url)) {
                    return;
                }
                update(this._xhr, url);
            }
            // Clean url
            url = url.replace("file:http:", "http:");
            url = url.replace("file:https:", "https:");
            this._requestURL = url;
            return this._xhr.open(method, url, true);
        }
        /**
         * Sets the value of a request header.
         * @param name The name of the header whose value is to be set
         * @param value The value to set as the body of the header
         */
        setRequestHeader(name, value) {
            this._xhr.setRequestHeader(name, value);
        }
        /**
         * Get the string containing the text of a particular header's value.
         * @param name The name of the header
         * @returns The string containing the text of the given header name
         */
        getResponseHeader(name) {
            return this._xhr.getResponseHeader(name);
        }
    }
    /**
     * Custom HTTP Request Headers to be sent with XMLHttpRequests
     * i.e. when loading files, where the server/service expects an Authorization header
     */
    WebRequest.CustomRequestHeaders = {};
    /**
     * Add callback functions in this array to update all the requests before they get sent to the network
     */
    WebRequest.CustomRequestModifiers = new Array();
    WebRequest.SkipRequestModificationForBabylonCDN = true;

    /**
     * Class used to help managing file picking and drag'n'drop
     * File Storage
     */
    class FilesInputStore {
    }
    /**
     * List of files ready to be loaded
     */
    FilesInputStore.FilesToLoad = {};

    /**
     * Class used to define a retry strategy when error happens while loading assets
     */
    class RetryStrategy {
        /**
         * Function used to defines an exponential back off strategy
         * @param maxRetries defines the maximum number of retries (3 by default)
         * @param baseInterval defines the interval between retries
         * @returns the strategy function to use
         */
        static ExponentialBackoff(maxRetries = 3, baseInterval = 500) {
            return (url, request, retryIndex) => {
                if (request.status !== 0 || retryIndex >= maxRetries || url.indexOf("file:") !== -1) {
                    return -1;
                }
                return Math.pow(2, retryIndex) * baseInterval;
            };
        }
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * Base error. Due to limitations of typedoc-check and missing documentation
     * in lib.es5.d.ts, cannot extend Error directly for RuntimeError.
     * @ignore
     */
    class BaseError extends Error {
    }
    // See https://stackoverflow.com/questions/12915412/how-do-i-extend-a-host-object-e-g-error-in-typescript
    // and https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // Polyfill for Object.setPrototypeOf if necessary.
    BaseError._setPrototypeOf = Object.setPrototypeOf ||
        ((o, proto) => {
            o.__proto__ = proto;
            return o;
        });
    /* IMP! DO NOT CHANGE THE NUMBERING OF EXISTING ERROR CODES */
    /**
     * Error codes for BaseError
     */
    const ErrorCodes = {
        // Mesh errors 0-999
        /** Invalid or empty mesh vertex positions. */
        MeshInvalidPositionsError: 0,
        // Texture errors 1000-1999
        /** Unsupported texture found. */
        UnsupportedTextureError: 1000,
        // GLTFLoader errors 2000-2999
        /** Unexpected magic number found in GLTF file header. */
        GLTFLoaderUnexpectedMagicError: 2000,
        // SceneLoader errors 3000-3999
        /** SceneLoader generic error code. Ideally wraps the inner exception. */
        SceneLoaderError: 3000,
        // File related errors 4000-4999
        /** Load file error */
        LoadFileError: 4000,
        /** Request file error */
        RequestFileError: 4001,
        /** Read file error */
        ReadFileError: 4002,
    };
    /**
     * Application runtime error
     */
    class RuntimeError extends BaseError {
        /**
         * Creates a new RuntimeError
         * @param message defines the message of the error
         * @param errorCode the error code
         * @param innerError the error that caused the outer error
         */
        constructor(message, errorCode, innerError) {
            super(message);
            this.errorCode = errorCode;
            this.innerError = innerError;
            this.name = "RuntimeError";
            BaseError._setPrototypeOf(this, RuntimeError.prototype);
        }
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * Encode a buffer to a base64 string
     * @param buffer defines the buffer to encode
     * @returns the encoded string
     */
    const EncodeArrayBufferToBase64 = (buffer) => {
        const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        let output = "";
        let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        let i = 0;
        const bytes = ArrayBuffer.isView(buffer) ? new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) : new Uint8Array(buffer);
        while (i < bytes.length) {
            chr1 = bytes[i++];
            chr2 = i < bytes.length ? bytes[i++] : Number.NaN;
            chr3 = i < bytes.length ? bytes[i++] : Number.NaN;
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            }
            else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        }
        return output;
    };
    /**
     * Converts a given base64 string as an ASCII encoded stream of data
     * @param base64Data The base64 encoded string to decode
     * @returns Decoded ASCII string
     */
    const DecodeBase64ToString = (base64Data) => {
        return atob(base64Data);
    };
    /**
     * Converts a given base64 string into an ArrayBuffer of raw byte data
     * @param base64Data The base64 encoded string to decode
     * @returns ArrayBuffer of byte data
     */
    const DecodeBase64ToBinary = (base64Data) => {
        const decodedString = DecodeBase64ToString(base64Data);
        const bufferLength = decodedString.length;
        const bufferView = new Uint8Array(new ArrayBuffer(bufferLength));
        for (let i = 0; i < bufferLength; i++) {
            bufferView[i] = decodedString.charCodeAt(i);
        }
        return bufferView.buffer;
    };

    const defaultAttributeKeywordName = "attribute";
    const defaultVaryingKeywordName = "varying";
    /** @internal */
    class ShaderCodeNode {
        constructor() {
            this.children = [];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isValid(preprocessors) {
            return true;
        }
        process(preprocessors, options) {
            var _a, _b, _c, _d, _e, _f, _g;
            let result = "";
            if (this.line) {
                let value = this.line;
                const processor = options.processor;
                if (processor) {
                    // This must be done before other replacements to avoid mistakenly changing something that was already changed.
                    if (processor.lineProcessor) {
                        value = processor.lineProcessor(value, options.isFragment, options.processingContext);
                    }
                    const attributeKeyword = (_b = (_a = options.processor) === null || _a === void 0 ? void 0 : _a.attributeKeywordName) !== null && _b !== void 0 ? _b : defaultAttributeKeywordName;
                    const varyingKeyword = options.isFragment && ((_c = options.processor) === null || _c === void 0 ? void 0 : _c.varyingFragmentKeywordName)
                        ? (_d = options.processor) === null || _d === void 0 ? void 0 : _d.varyingFragmentKeywordName
                        : !options.isFragment && ((_e = options.processor) === null || _e === void 0 ? void 0 : _e.varyingVertexKeywordName)
                            ? (_f = options.processor) === null || _f === void 0 ? void 0 : _f.varyingVertexKeywordName
                            : defaultVaryingKeywordName;
                    if (!options.isFragment && processor.attributeProcessor && this.line.startsWith(attributeKeyword)) {
                        value = processor.attributeProcessor(this.line, preprocessors, options.processingContext);
                    }
                    else if (processor.varyingProcessor &&
                        (((_g = processor.varyingCheck) === null || _g === void 0 ? void 0 : _g.call(processor, this.line, options.isFragment)) || (!processor.varyingCheck && this.line.startsWith(varyingKeyword)))) {
                        value = processor.varyingProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                    }
                    else if (processor.uniformProcessor && processor.uniformRegexp && processor.uniformRegexp.test(this.line)) {
                        if (!options.lookForClosingBracketForUniformBuffer) {
                            value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                        }
                    }
                    else if (processor.uniformBufferProcessor && processor.uniformBufferRegexp && processor.uniformBufferRegexp.test(this.line)) {
                        if (!options.lookForClosingBracketForUniformBuffer) {
                            value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                            options.lookForClosingBracketForUniformBuffer = true;
                        }
                    }
                    else if (processor.textureProcessor && processor.textureRegexp && processor.textureRegexp.test(this.line)) {
                        value = processor.textureProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                    }
                    else if ((processor.uniformProcessor || processor.uniformBufferProcessor) && this.line.startsWith("uniform") && !options.lookForClosingBracketForUniformBuffer) {
                        const regex = /uniform\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/;
                        if (regex.test(this.line)) {
                            // uniform
                            if (processor.uniformProcessor) {
                                value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                            }
                        }
                        else {
                            // Uniform buffer
                            if (processor.uniformBufferProcessor) {
                                value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                                options.lookForClosingBracketForUniformBuffer = true;
                            }
                        }
                    }
                    if (options.lookForClosingBracketForUniformBuffer && this.line.indexOf("}") !== -1) {
                        options.lookForClosingBracketForUniformBuffer = false;
                        if (processor.endOfUniformBufferProcessor) {
                            value = processor.endOfUniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                        }
                    }
                }
                result += value + "\n";
            }
            this.children.forEach((child) => {
                result += child.process(preprocessors, options);
            });
            if (this.additionalDefineKey) {
                preprocessors[this.additionalDefineKey] = this.additionalDefineValue || "true";
            }
            return result;
        }
    }

    /** @internal */
    class ShaderCodeCursor {
        constructor() {
            this._lines = [];
        }
        get currentLine() {
            return this._lines[this.lineIndex];
        }
        get canRead() {
            return this.lineIndex < this._lines.length - 1;
        }
        set lines(value) {
            this._lines.length = 0;
            for (const line of value) {
                // Skip empty lines
                if (!line || line === "\r") {
                    continue;
                }
                // Prevent removing line break in macros.
                if (line[0] === "#") {
                    this._lines.push(line);
                    continue;
                }
                // Do not split single line comments
                const trimmedLine = line.trim();
                if (!trimmedLine) {
                    continue;
                }
                if (trimmedLine.startsWith("//")) {
                    this._lines.push(line);
                    continue;
                }
                // Work with semicolon in the line
                const semicolonIndex = trimmedLine.indexOf(";");
                if (semicolonIndex === -1) {
                    // No semicolon in the line
                    this._lines.push(trimmedLine);
                }
                else if (semicolonIndex === trimmedLine.length - 1) {
                    // Single semicolon at the end of the line
                    // If trimmedLine == ";", we must not push, to be backward compatible with the old code!
                    if (trimmedLine.length > 1) {
                        this._lines.push(trimmedLine);
                    }
                }
                else {
                    // Semicolon in the middle of the line
                    const split = line.split(";");
                    for (let index = 0; index < split.length; index++) {
                        let subLine = split[index];
                        if (!subLine) {
                            continue;
                        }
                        subLine = subLine.trim();
                        if (!subLine) {
                            continue;
                        }
                        this._lines.push(subLine + (index !== split.length - 1 ? ";" : ""));
                    }
                }
            }
        }
    }

    /** @internal */
    class ShaderCodeConditionNode extends ShaderCodeNode {
        process(preprocessors, options) {
            for (let index = 0; index < this.children.length; index++) {
                const node = this.children[index];
                if (node.isValid(preprocessors)) {
                    return node.process(preprocessors, options);
                }
            }
            return "";
        }
    }

    /** @internal */
    class ShaderCodeTestNode extends ShaderCodeNode {
        isValid(preprocessors) {
            return this.testExpression.isTrue(preprocessors);
        }
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    /** @internal */
    class ShaderDefineExpression {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isTrue(preprocessors) {
            return true;
        }
        static postfixToInfix(postfix) {
            const stack = [];
            for (const c of postfix) {
                if (ShaderDefineExpression._OperatorPriority[c] === undefined) {
                    stack.push(c);
                }
                else {
                    const v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
                    stack.length -= 2;
                    stack.push(`(${v2}${c}${v1})`);
                }
            }
            return stack[stack.length - 1];
        }
        /**
         * Converts an infix expression to a postfix expression.
         *
         * This method is used to transform infix expressions, which are more human-readable,
         * into postfix expressions, also known as Reverse Polish Notation (RPN), that can be
         * evaluated more efficiently by a computer. The conversion is based on the operator
         * priority defined in _OperatorPriority.
         *
         * The function employs a stack-based algorithm for the conversion and caches the result
         * to improve performance. The cache keeps track of each converted expression's access time
         * to manage the cache size and optimize memory usage. When the cache size exceeds a specified
         * limit, the least recently accessed items in the cache are deleted.
         *
         * The cache mechanism is particularly helpful for shader compilation, where the same infix
         * expressions might be encountered repeatedly, hence the caching can speed up the process.
         *
         * @param infix - The infix expression to be converted.
         * @returns The postfix expression as an array of strings.
         */
        static infixToPostfix(infix) {
            // Is infix already in cache
            const cacheItem = ShaderDefineExpression._InfixToPostfixCache.get(infix);
            if (cacheItem) {
                cacheItem.accessTime = Date.now();
                return cacheItem.result;
            }
            // Is infix contain any operator
            if (!infix.includes("&&") && !infix.includes("||") && !infix.includes(")") && !infix.includes("(")) {
                return [infix];
            }
            const result = [];
            let stackIdx = -1;
            const pushOperand = () => {
                operand = operand.trim();
                if (operand !== "") {
                    result.push(operand);
                    operand = "";
                }
            };
            const push = (s) => {
                if (stackIdx < ShaderDefineExpression._Stack.length - 1) {
                    ShaderDefineExpression._Stack[++stackIdx] = s;
                }
            };
            const peek = () => ShaderDefineExpression._Stack[stackIdx];
            const pop = () => (stackIdx === -1 ? "!!INVALID EXPRESSION!!" : ShaderDefineExpression._Stack[stackIdx--]);
            let idx = 0, operand = "";
            while (idx < infix.length) {
                const c = infix.charAt(idx), token = idx < infix.length - 1 ? infix.substr(idx, 2) : "";
                if (c === "(") {
                    operand = "";
                    push(c);
                }
                else if (c === ")") {
                    pushOperand();
                    while (stackIdx !== -1 && peek() !== "(") {
                        result.push(pop());
                    }
                    pop();
                }
                else if (ShaderDefineExpression._OperatorPriority[token] > 1) {
                    pushOperand();
                    while (stackIdx !== -1 && ShaderDefineExpression._OperatorPriority[peek()] >= ShaderDefineExpression._OperatorPriority[token]) {
                        result.push(pop());
                    }
                    push(token);
                    idx++;
                }
                else {
                    operand += c;
                }
                idx++;
            }
            pushOperand();
            while (stackIdx !== -1) {
                if (peek() === "(") {
                    pop();
                }
                else {
                    result.push(pop());
                }
            }
            // If the cache is at capacity, clear it before adding a new item
            if (ShaderDefineExpression._InfixToPostfixCache.size >= ShaderDefineExpression.InfixToPostfixCacheLimitSize) {
                ShaderDefineExpression.ClearCache();
            }
            // Add the new item to the cache, including the current time as the last access time
            ShaderDefineExpression._InfixToPostfixCache.set(infix, { result, accessTime: Date.now() });
            return result;
        }
        static ClearCache() {
            // Convert the cache to an array and sort by last access time
            const sortedCache = Array.from(ShaderDefineExpression._InfixToPostfixCache.entries()).sort((a, b) => a[1].accessTime - b[1].accessTime);
            // Remove the least recently accessed half of the cache
            for (let i = 0; i < ShaderDefineExpression.InfixToPostfixCacheCleanupSize; i++) {
                ShaderDefineExpression._InfixToPostfixCache.delete(sortedCache[i][0]);
            }
        }
    }
    /**
     * Cache items count limit for the InfixToPostfix cache.
     * It uses to improve the performance of the shader compilation.
     * For details see PR: https://github.com/BabylonJS/Babylon.js/pull/13936
     */
    ShaderDefineExpression.InfixToPostfixCacheLimitSize = 50000;
    /**
     * When the cache size is exceeded, a cache cleanup will be triggered
     * and the cache will be reduced by the size specified
     * in the InfixToPostfixCacheCleanupSize variable, removing entries
     * that have not been accessed the longest.
     */
    ShaderDefineExpression.InfixToPostfixCacheCleanupSize = 25000;
    ShaderDefineExpression._InfixToPostfixCache = new Map();
    ShaderDefineExpression._OperatorPriority = {
        ")": 0,
        "(": 1,
        "||": 2,
        "&&": 3,
    };
    ShaderDefineExpression._Stack = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""];

    /** @internal */
    class ShaderDefineIsDefinedOperator extends ShaderDefineExpression {
        constructor(define, not = false) {
            super();
            this.define = define;
            this.not = not;
        }
        isTrue(preprocessors) {
            let condition = preprocessors[this.define] !== undefined;
            if (this.not) {
                condition = !condition;
            }
            return condition;
        }
    }

    /** @internal */
    class ShaderDefineOrOperator extends ShaderDefineExpression {
        isTrue(preprocessors) {
            return this.leftOperand.isTrue(preprocessors) || this.rightOperand.isTrue(preprocessors);
        }
    }

    /** @internal */
    class ShaderDefineAndOperator extends ShaderDefineExpression {
        isTrue(preprocessors) {
            return this.leftOperand.isTrue(preprocessors) && this.rightOperand.isTrue(preprocessors);
        }
    }

    /** @internal */
    class ShaderDefineArithmeticOperator extends ShaderDefineExpression {
        constructor(define, operand, testValue) {
            super();
            this.define = define;
            this.operand = operand;
            this.testValue = testValue;
        }
        isTrue(preprocessors) {
            let value = preprocessors[this.define];
            if (value === undefined) {
                value = this.define;
            }
            let condition = false;
            const left = parseInt(value);
            const right = parseInt(this.testValue);
            switch (this.operand) {
                case ">":
                    condition = left > right;
                    break;
                case "<":
                    condition = left < right;
                    break;
                case "<=":
                    condition = left <= right;
                    break;
                case ">=":
                    condition = left >= right;
                    break;
                case "==":
                    condition = left === right;
                    break;
                case "!=":
                    condition = left !== right;
                    break;
            }
            return condition;
        }
    }

    /**
     * Language of the shader code
     */
    var ShaderLanguage;
    (function (ShaderLanguage) {
        /** language is GLSL (used by WebGL) */
        ShaderLanguage[ShaderLanguage["GLSL"] = 0] = "GLSL";
        /** language is WGSL (used by WebGPU) */
        ShaderLanguage[ShaderLanguage["WGSL"] = 1] = "WGSL";
    })(ShaderLanguage || (ShaderLanguage = {}));

    /* eslint-disable @typescript-eslint/no-unused-vars */
    const regexSE = /defined\s*?\((.+?)\)/g;
    const regexSERevert = /defined\s*?\[(.+?)\]/g;
    const regexShaderInclude = /#include\s?<(.+)>(\((.*)\))*(\[(.*)\])*/g;
    const regexShaderDecl = /__decl__/;
    const regexLightX = /light\{X\}.(\w*)/g;
    const regexX = /\{X\}/g;
    const reusableMatches = [];
    /** @internal */
    class ShaderProcessor {
        static Initialize(options) {
            if (options.processor && options.processor.initializeShaders) {
                options.processor.initializeShaders(options.processingContext);
            }
        }
        static Process(sourceCode, options, callback, engine) {
            var _a;
            if ((_a = options.processor) === null || _a === void 0 ? void 0 : _a.preProcessShaderCode) {
                sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
            }
            this._ProcessIncludes(sourceCode, options, (codeWithIncludes) => {
                if (options.processCodeAfterIncludes) {
                    codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes);
                }
                const migratedCode = this._ProcessShaderConversion(codeWithIncludes, options, engine);
                callback(migratedCode, codeWithIncludes);
            });
        }
        static PreProcess(sourceCode, options, callback, engine) {
            var _a;
            if ((_a = options.processor) === null || _a === void 0 ? void 0 : _a.preProcessShaderCode) {
                sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
            }
            this._ProcessIncludes(sourceCode, options, (codeWithIncludes) => {
                if (options.processCodeAfterIncludes) {
                    codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes);
                }
                const migratedCode = this._ApplyPreProcessing(codeWithIncludes, options, engine);
                callback(migratedCode, codeWithIncludes);
            });
        }
        static Finalize(vertexCode, fragmentCode, options) {
            if (!options.processor || !options.processor.finalizeShaders) {
                return { vertexCode, fragmentCode };
            }
            return options.processor.finalizeShaders(vertexCode, fragmentCode, options.processingContext);
        }
        static _ProcessPrecision(source, options) {
            var _a;
            if ((_a = options.processor) === null || _a === void 0 ? void 0 : _a.noPrecision) {
                return source;
            }
            const shouldUseHighPrecisionShader = options.shouldUseHighPrecisionShader;
            if (source.indexOf("precision highp float") === -1) {
                if (!shouldUseHighPrecisionShader) {
                    source = "precision mediump float;\n" + source;
                }
                else {
                    source = "precision highp float;\n" + source;
                }
            }
            else {
                if (!shouldUseHighPrecisionShader) {
                    // Moving highp to mediump
                    source = source.replace("precision highp float", "precision mediump float");
                }
            }
            return source;
        }
        static _ExtractOperation(expression) {
            const regex = /defined\((.+)\)/;
            const match = regex.exec(expression);
            if (match && match.length) {
                return new ShaderDefineIsDefinedOperator(match[1].trim(), expression[0] === "!");
            }
            const operators = ["==", "!=", ">=", "<=", "<", ">"];
            let operator = "";
            let indexOperator = 0;
            for (operator of operators) {
                indexOperator = expression.indexOf(operator);
                if (indexOperator > -1) {
                    break;
                }
            }
            if (indexOperator === -1) {
                return new ShaderDefineIsDefinedOperator(expression);
            }
            const define = expression.substring(0, indexOperator).trim();
            const value = expression.substring(indexOperator + operator.length).trim();
            return new ShaderDefineArithmeticOperator(define, operator, value);
        }
        static _BuildSubExpression(expression) {
            expression = expression.replace(regexSE, "defined[$1]");
            const postfix = ShaderDefineExpression.infixToPostfix(expression);
            const stack = [];
            for (const c of postfix) {
                if (c !== "||" && c !== "&&") {
                    stack.push(c);
                }
                else if (stack.length >= 2) {
                    let v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
                    stack.length -= 2;
                    const operator = c == "&&" ? new ShaderDefineAndOperator() : new ShaderDefineOrOperator();
                    if (typeof v1 === "string") {
                        v1 = v1.replace(regexSERevert, "defined($1)");
                    }
                    if (typeof v2 === "string") {
                        v2 = v2.replace(regexSERevert, "defined($1)");
                    }
                    operator.leftOperand = typeof v2 === "string" ? this._ExtractOperation(v2) : v2;
                    operator.rightOperand = typeof v1 === "string" ? this._ExtractOperation(v1) : v1;
                    stack.push(operator);
                }
            }
            let result = stack[stack.length - 1];
            if (typeof result === "string") {
                result = result.replace(regexSERevert, "defined($1)");
            }
            // note: stack.length !== 1 if there was an error in the parsing
            return typeof result === "string" ? this._ExtractOperation(result) : result;
        }
        static _BuildExpression(line, start) {
            const node = new ShaderCodeTestNode();
            const command = line.substring(0, start);
            let expression = line.substring(start);
            expression = expression.substring(0, (expression.indexOf("//") + 1 || expression.length + 1) - 1).trim();
            if (command === "#ifdef") {
                node.testExpression = new ShaderDefineIsDefinedOperator(expression);
            }
            else if (command === "#ifndef") {
                node.testExpression = new ShaderDefineIsDefinedOperator(expression, true);
            }
            else {
                node.testExpression = this._BuildSubExpression(expression);
            }
            return node;
        }
        static _MoveCursorWithinIf(cursor, rootNode, ifNode) {
            let line = cursor.currentLine;
            while (this._MoveCursor(cursor, ifNode)) {
                line = cursor.currentLine;
                const first5 = line.substring(0, 5).toLowerCase();
                if (first5 === "#else") {
                    const elseNode = new ShaderCodeNode();
                    rootNode.children.push(elseNode);
                    this._MoveCursor(cursor, elseNode);
                    return;
                }
                else if (first5 === "#elif") {
                    const elifNode = this._BuildExpression(line, 5);
                    rootNode.children.push(elifNode);
                    ifNode = elifNode;
                }
            }
        }
        static _MoveCursor(cursor, rootNode) {
            while (cursor.canRead) {
                cursor.lineIndex++;
                const line = cursor.currentLine;
                if (line.indexOf("#") >= 0) {
                    const matches = ShaderProcessor._MoveCursorRegex.exec(line);
                    if (matches && matches.length) {
                        const keyword = matches[0];
                        switch (keyword) {
                            case "#ifdef": {
                                const newRootNode = new ShaderCodeConditionNode();
                                rootNode.children.push(newRootNode);
                                const ifNode = this._BuildExpression(line, 6);
                                newRootNode.children.push(ifNode);
                                this._MoveCursorWithinIf(cursor, newRootNode, ifNode);
                                break;
                            }
                            case "#else":
                            case "#elif":
                                return true;
                            case "#endif":
                                return false;
                            case "#ifndef": {
                                const newRootNode = new ShaderCodeConditionNode();
                                rootNode.children.push(newRootNode);
                                const ifNode = this._BuildExpression(line, 7);
                                newRootNode.children.push(ifNode);
                                this._MoveCursorWithinIf(cursor, newRootNode, ifNode);
                                break;
                            }
                            case "#if": {
                                const newRootNode = new ShaderCodeConditionNode();
                                const ifNode = this._BuildExpression(line, 3);
                                rootNode.children.push(newRootNode);
                                newRootNode.children.push(ifNode);
                                this._MoveCursorWithinIf(cursor, newRootNode, ifNode);
                                break;
                            }
                        }
                        continue;
                    }
                }
                const newNode = new ShaderCodeNode();
                newNode.line = line;
                rootNode.children.push(newNode);
                // Detect additional defines
                if (line[0] === "#" && line[1] === "d") {
                    const split = line.replace(";", "").split(" ");
                    newNode.additionalDefineKey = split[1];
                    if (split.length === 3) {
                        newNode.additionalDefineValue = split[2];
                    }
                }
            }
            return false;
        }
        static _EvaluatePreProcessors(sourceCode, preprocessors, options) {
            const rootNode = new ShaderCodeNode();
            const cursor = new ShaderCodeCursor();
            cursor.lineIndex = -1;
            cursor.lines = sourceCode.split("\n");
            // Decompose (We keep it in 2 steps so it is easier to maintain and perf hit is insignificant)
            this._MoveCursor(cursor, rootNode);
            // Recompose
            return rootNode.process(preprocessors, options);
        }
        static _PreparePreProcessors(options, engine) {
            var _a;
            const defines = options.defines;
            const preprocessors = {};
            for (const define of defines) {
                const keyValue = define.replace("#define", "").replace(";", "").trim();
                const split = keyValue.split(" ");
                preprocessors[split[0]] = split.length > 1 ? split[1] : "";
            }
            if (((_a = options.processor) === null || _a === void 0 ? void 0 : _a.shaderLanguage) === ShaderLanguage.GLSL) {
                preprocessors["GL_ES"] = "true";
            }
            preprocessors["__VERSION__"] = options.version;
            preprocessors[options.platformName] = "true";
            engine._getGlobalDefines(preprocessors);
            return preprocessors;
        }
        static _ProcessShaderConversion(sourceCode, options, engine) {
            let preparedSourceCode = this._ProcessPrecision(sourceCode, options);
            if (!options.processor) {
                return preparedSourceCode;
            }
            // Already converted
            if (options.processor.shaderLanguage === ShaderLanguage.GLSL && preparedSourceCode.indexOf("#version 3") !== -1) {
                preparedSourceCode = preparedSourceCode.replace("#version 300 es", "");
                if (!options.processor.parseGLES3) {
                    return preparedSourceCode;
                }
            }
            const defines = options.defines;
            const preprocessors = this._PreparePreProcessors(options, engine);
            // General pre processing
            if (options.processor.preProcessor) {
                preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext);
            }
            preparedSourceCode = this._EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
            // Post processing
            if (options.processor.postProcessor) {
                preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine);
            }
            // Inline functions tagged with #define inline
            if (engine._features.needShaderCodeInlining) {
                preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
            }
            return preparedSourceCode;
        }
        static _ApplyPreProcessing(sourceCode, options, engine) {
            var _a, _b;
            let preparedSourceCode = sourceCode;
            const defines = options.defines;
            const preprocessors = this._PreparePreProcessors(options, engine);
            // General pre processing
            if ((_a = options.processor) === null || _a === void 0 ? void 0 : _a.preProcessor) {
                preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext);
            }
            preparedSourceCode = this._EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
            // Post processing
            if ((_b = options.processor) === null || _b === void 0 ? void 0 : _b.postProcessor) {
                preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine);
            }
            // Inline functions tagged with #define inline
            if (engine._features.needShaderCodeInlining) {
                preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
            }
            return preparedSourceCode;
        }
        /** @internal */
        static _ProcessIncludes(sourceCode, options, callback) {
            reusableMatches.length = 0;
            let match;
            // stay back-compat to the old matchAll syntax
            while ((match = regexShaderInclude.exec(sourceCode)) !== null) {
                reusableMatches.push(match);
            }
            let returnValue = String(sourceCode);
            let parts = [sourceCode];
            let keepProcessing = false;
            for (const match of reusableMatches) {
                let includeFile = match[1];
                // Uniform declaration
                if (includeFile.indexOf("__decl__") !== -1) {
                    includeFile = includeFile.replace(regexShaderDecl, "");
                    if (options.supportsUniformBuffers) {
                        includeFile = includeFile.replace("Vertex", "Ubo").replace("Fragment", "Ubo");
                    }
                    includeFile = includeFile + "Declaration";
                }
                if (options.includesShadersStore[includeFile]) {
                    // Substitution
                    let includeContent = options.includesShadersStore[includeFile];
                    if (match[2]) {
                        const splits = match[3].split(",");
                        for (let index = 0; index < splits.length; index += 2) {
                            const source = new RegExp(splits[index], "g");
                            const dest = splits[index + 1];
                            includeContent = includeContent.replace(source, dest);
                        }
                    }
                    if (match[4]) {
                        const indexString = match[5];
                        if (indexString.indexOf("..") !== -1) {
                            const indexSplits = indexString.split("..");
                            const minIndex = parseInt(indexSplits[0]);
                            let maxIndex = parseInt(indexSplits[1]);
                            let sourceIncludeContent = includeContent.slice(0);
                            includeContent = "";
                            if (isNaN(maxIndex)) {
                                maxIndex = options.indexParameters[indexSplits[1]];
                            }
                            for (let i = minIndex; i < maxIndex; i++) {
                                if (!options.supportsUniformBuffers) {
                                    // Ubo replacement
                                    sourceIncludeContent = sourceIncludeContent.replace(regexLightX, (str, p1) => {
                                        return p1 + "{X}";
                                    });
                                }
                                includeContent += sourceIncludeContent.replace(regexX, i.toString()) + "\n";
                            }
                        }
                        else {
                            if (!options.supportsUniformBuffers) {
                                // Ubo replacement
                                includeContent = includeContent.replace(regexLightX, (str, p1) => {
                                    return p1 + "{X}";
                                });
                            }
                            includeContent = includeContent.replace(regexX, indexString);
                        }
                    }
                    // Replace
                    // Split all parts on match[0] and intersperse the parts with the include content
                    const newParts = [];
                    for (const part of parts) {
                        const splitPart = part.split(match[0]);
                        for (let i = 0; i < splitPart.length - 1; i++) {
                            newParts.push(splitPart[i]);
                            newParts.push(includeContent);
                        }
                        newParts.push(splitPart[splitPart.length - 1]);
                    }
                    parts = newParts;
                    keepProcessing = keepProcessing || includeContent.indexOf("#include<") >= 0 || includeContent.indexOf("#include <") >= 0;
                }
                else {
                    const includeShaderUrl = options.shadersRepository + "ShadersInclude/" + includeFile + ".fx";
                    ShaderProcessor._FileToolsLoadFile(includeShaderUrl, (fileContent) => {
                        options.includesShadersStore[includeFile] = fileContent;
                        this._ProcessIncludes(parts.join(""), options, callback);
                    });
                    return;
                }
            }
            reusableMatches.length = 0;
            returnValue = parts.join("");
            if (keepProcessing) {
                this._ProcessIncludes(returnValue.toString(), options, callback);
            }
            else {
                callback(returnValue);
            }
        }
        /**
         * Loads a file from a url
         * @param url url to load
         * @param onSuccess callback called when the file successfully loads
         * @param onProgress callback called while file is loading (if the server supports this mode)
         * @param offlineProvider defines the offline provider for caching
         * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
         * @param onError callback called when the file fails to load
         * @returns a file request object
         * @internal
         */
        static _FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
            throw _WarnImport("FileTools");
        }
    }
    ShaderProcessor._MoveCursorRegex = /(#ifdef)|(#else)|(#elif)|(#endif)|(#ifndef)|(#if)/;

    /**
     * Defines the shader related stores and directory
     */
    class ShaderStore {
        /**
         * Gets the shaders repository path for a given shader language
         * @param shaderLanguage the shader language
         * @returns the path to the shaders repository
         */
        static GetShadersRepository(shaderLanguage = ShaderLanguage.GLSL) {
            return shaderLanguage === ShaderLanguage.GLSL ? ShaderStore.ShadersRepository : ShaderStore.ShadersRepositoryWGSL;
        }
        /**
         * Gets the shaders store of a given shader language
         * @param shaderLanguage the shader language
         * @returns the shaders store
         */
        static GetShadersStore(shaderLanguage = ShaderLanguage.GLSL) {
            return shaderLanguage === ShaderLanguage.GLSL ? ShaderStore.ShadersStore : ShaderStore.ShadersStoreWGSL;
        }
        /**
         * Gets the include shaders store of a given shader language
         * @param shaderLanguage the shader language
         * @returns the include shaders store
         */
        static GetIncludesShadersStore(shaderLanguage = ShaderLanguage.GLSL) {
            return shaderLanguage === ShaderLanguage.GLSL ? ShaderStore.IncludesShadersStore : ShaderStore.IncludesShadersStoreWGSL;
        }
    }
    /**
     * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
     */
    ShaderStore.ShadersRepository = "src/Shaders/";
    /**
     * Store of each shader (The can be looked up using effect.key)
     */
    ShaderStore.ShadersStore = {};
    /**
     * Store of each included file for a shader (The can be looked up using effect.key)
     */
    ShaderStore.IncludesShadersStore = {};
    /**
     * Gets or sets the relative url used to load shaders (WGSL) if using the engine in non-minified mode
     */
    ShaderStore.ShadersRepositoryWGSL = "src/ShadersWGSL/";
    /**
     * Store of each shader  (WGSL)
     */
    ShaderStore.ShadersStoreWGSL = {};
    /**
     * Store of each included file for a shader (WGSL)
     */
    ShaderStore.IncludesShadersStoreWGSL = {};

    /**
     * Effect containing vertex and fragment shader that can be executed on an object.
     */
    class Effect {
        /**
         * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
         */
        static get ShadersRepository() {
            return ShaderStore.ShadersRepository;
        }
        static set ShadersRepository(repo) {
            ShaderStore.ShadersRepository = repo;
        }
        /**
         * Observable that will be called when effect is bound.
         */
        get onBindObservable() {
            if (!this._onBindObservable) {
                this._onBindObservable = new Observable$1();
            }
            return this._onBindObservable;
        }
        /**
         * Instantiates an effect.
         * An effect can be used to create/manage/execute vertex and fragment shaders.
         * @param baseName Name of the effect.
         * @param attributesNamesOrOptions List of attribute names that will be passed to the shader or set of all options to create the effect.
         * @param uniformsNamesOrEngine List of uniform variable names that will be passed to the shader or the engine that will be used to render effect.
         * @param samplers List of sampler variables that will be passed to the shader.
         * @param engine Engine to be used to render the effect
         * @param defines Define statements to be added to the shader.
         * @param fallbacks Possible fallbacks for this effect to improve performance when needed.
         * @param onCompiled Callback that will be called when the shader is compiled.
         * @param onError Callback that will be called if an error occurs during shader compilation.
         * @param indexParameters Parameters to be used with Babylons include syntax to iterate over an array (eg. {lights: 10})
         * @param key Effect Key identifying uniquely compiled shader variants
         * @param shaderLanguage the language the shader is written in (default: GLSL)
         */
        constructor(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers = null, engine, defines = null, fallbacks = null, onCompiled = null, onError = null, indexParameters, key = "", shaderLanguage = ShaderLanguage.GLSL) {
            var _a, _b, _c;
            /**
             * Name of the effect.
             */
            this.name = null;
            /**
             * String container all the define statements that should be set on the shader.
             */
            this.defines = "";
            /**
             * Callback that will be called when the shader is compiled.
             */
            this.onCompiled = null;
            /**
             * Callback that will be called if an error occurs during shader compilation.
             */
            this.onError = null;
            /**
             * Callback that will be called when effect is bound.
             */
            this.onBind = null;
            /**
             * Unique ID of the effect.
             */
            this.uniqueId = 0;
            /**
             * Observable that will be called when the shader is compiled.
             * It is recommended to use executeWhenCompile() or to make sure that scene.isReady() is called to get this observable raised.
             */
            this.onCompileObservable = new Observable$1();
            /**
             * Observable that will be called if an error occurs during shader compilation.
             */
            this.onErrorObservable = new Observable$1();
            /** @internal */
            this._onBindObservable = null;
            /**
             * @internal
             * Specifies if the effect was previously ready
             */
            this._wasPreviouslyReady = false;
            /**
             * @internal
             * Forces the code from bindForSubMesh to be fully run the next time it is called
             * It is used in frozen mode to make sure the effect is properly rebound when a new effect is created
             */
            this._forceRebindOnNextCall = false;
            /**
             * @internal
             * Specifies if the effect was previously using instances
             */
            this._wasPreviouslyUsingInstances = null;
            this._isDisposed = false;
            /** @internal */
            this._bonesComputationForcedToCPU = false;
            /** @internal */
            this._uniformBuffersNames = {};
            /** @internal */
            this._multiTarget = false;
            this._samplers = {};
            this._isReady = false;
            this._compilationError = "";
            this._allFallbacksProcessed = false;
            this._uniforms = {};
            /**
             * Key for the effect.
             * @internal
             */
            this._key = "";
            this._fallbacks = null;
            this._vertexSourceCodeOverride = "";
            this._fragmentSourceCodeOverride = "";
            this._transformFeedbackVaryings = null;
            /**
             * Compiled shader to webGL program.
             * @internal
             */
            this._pipelineContext = null;
            /** @internal */
            this._vertexSourceCode = "";
            /** @internal */
            this._fragmentSourceCode = "";
            /** @internal */
            this._vertexSourceCodeBeforeMigration = "";
            /** @internal */
            this._fragmentSourceCodeBeforeMigration = "";
            /** @internal */
            this._rawVertexSourceCode = "";
            /** @internal */
            this._rawFragmentSourceCode = "";
            this.name = baseName;
            this._key = key;
            let processCodeAfterIncludes = undefined;
            let processFinalCode = null;
            if (attributesNamesOrOptions.attributes) {
                const options = attributesNamesOrOptions;
                this._engine = uniformsNamesOrEngine;
                this._attributesNames = options.attributes;
                this._uniformsNames = options.uniformsNames.concat(options.samplers);
                this._samplerList = options.samplers.slice();
                this.defines = options.defines;
                this.onError = options.onError;
                this.onCompiled = options.onCompiled;
                this._fallbacks = options.fallbacks;
                this._indexParameters = options.indexParameters;
                this._transformFeedbackVaryings = options.transformFeedbackVaryings || null;
                this._multiTarget = !!options.multiTarget;
                this._shaderLanguage = (_a = options.shaderLanguage) !== null && _a !== void 0 ? _a : ShaderLanguage.GLSL;
                if (options.uniformBuffersNames) {
                    this._uniformBuffersNamesList = options.uniformBuffersNames.slice();
                    for (let i = 0; i < options.uniformBuffersNames.length; i++) {
                        this._uniformBuffersNames[options.uniformBuffersNames[i]] = i;
                    }
                }
                processFinalCode = (_b = options.processFinalCode) !== null && _b !== void 0 ? _b : null;
                processCodeAfterIncludes = (_c = options.processCodeAfterIncludes) !== null && _c !== void 0 ? _c : undefined;
            }
            else {
                this._engine = engine;
                this.defines = defines == null ? "" : defines;
                this._uniformsNames = uniformsNamesOrEngine.concat(samplers);
                this._samplerList = samplers ? samplers.slice() : [];
                this._attributesNames = attributesNamesOrOptions;
                this._uniformBuffersNamesList = [];
                this._shaderLanguage = shaderLanguage;
                this.onError = onError;
                this.onCompiled = onCompiled;
                this._indexParameters = indexParameters;
                this._fallbacks = fallbacks;
            }
            this._attributeLocationByName = {};
            this.uniqueId = Effect._UniqueIdSeed++;
            let vertexSource;
            let fragmentSource;
            const hostDocument = IsWindowObjectExist() ? this._engine.getHostDocument() : null;
            if (baseName.vertexSource) {
                vertexSource = "source:" + baseName.vertexSource;
            }
            else if (baseName.vertexElement) {
                vertexSource = hostDocument ? hostDocument.getElementById(baseName.vertexElement) : null;
                if (!vertexSource) {
                    vertexSource = baseName.vertexElement;
                }
            }
            else {
                vertexSource = baseName.vertex || baseName;
            }
            if (baseName.fragmentSource) {
                fragmentSource = "source:" + baseName.fragmentSource;
            }
            else if (baseName.fragmentElement) {
                fragmentSource = hostDocument ? hostDocument.getElementById(baseName.fragmentElement) : null;
                if (!fragmentSource) {
                    fragmentSource = baseName.fragmentElement;
                }
            }
            else {
                fragmentSource = baseName.fragment || baseName;
            }
            this._processingContext = this._engine._getShaderProcessingContext(this._shaderLanguage);
            let processorOptions = {
                defines: this.defines.split("\n"),
                indexParameters: this._indexParameters,
                isFragment: false,
                shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
                processor: this._engine._getShaderProcessor(this._shaderLanguage),
                supportsUniformBuffers: this._engine.supportsUniformBuffers,
                shadersRepository: ShaderStore.GetShadersRepository(this._shaderLanguage),
                includesShadersStore: ShaderStore.GetIncludesShadersStore(this._shaderLanguage),
                version: (this._engine.version * 100).toString(),
                platformName: this._engine.shaderPlatformName,
                processingContext: this._processingContext,
                isNDCHalfZRange: this._engine.isNDCHalfZRange,
                useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
                processCodeAfterIncludes,
            };
            const shaderCodes = [undefined, undefined];
            const shadersLoaded = () => {
                if (shaderCodes[0] && shaderCodes[1]) {
                    processorOptions.isFragment = true;
                    const [migratedVertexCode, fragmentCode] = shaderCodes;
                    ShaderProcessor.Process(fragmentCode, processorOptions, (migratedFragmentCode, codeBeforeMigration) => {
                        this._fragmentSourceCodeBeforeMigration = codeBeforeMigration;
                        if (processFinalCode) {
                            migratedFragmentCode = processFinalCode("fragment", migratedFragmentCode);
                        }
                        const finalShaders = ShaderProcessor.Finalize(migratedVertexCode, migratedFragmentCode, processorOptions);
                        processorOptions = null;
                        this._useFinalCode(finalShaders.vertexCode, finalShaders.fragmentCode, baseName);
                    }, this._engine);
                }
            };
            this._loadShader(vertexSource, "Vertex", "", (vertexCode) => {
                ShaderProcessor.Initialize(processorOptions);
                ShaderProcessor.Process(vertexCode, processorOptions, (migratedVertexCode, codeBeforeMigration) => {
                    this._rawVertexSourceCode = vertexCode;
                    this._vertexSourceCodeBeforeMigration = codeBeforeMigration;
                    if (processFinalCode) {
                        migratedVertexCode = processFinalCode("vertex", migratedVertexCode);
                    }
                    shaderCodes[0] = migratedVertexCode;
                    shadersLoaded();
                }, this._engine);
            });
            this._loadShader(fragmentSource, "Fragment", "Pixel", (fragmentCode) => {
                this._rawFragmentSourceCode = fragmentCode;
                shaderCodes[1] = fragmentCode;
                shadersLoaded();
            });
        }
        _useFinalCode(migratedVertexCode, migratedFragmentCode, baseName) {
            if (baseName) {
                const vertex = baseName.vertexElement || baseName.vertex || baseName.spectorName || baseName;
                const fragment = baseName.fragmentElement || baseName.fragment || baseName.spectorName || baseName;
                this._vertexSourceCode = (this._shaderLanguage === ShaderLanguage.WGSL ? "//" : "") + "#define SHADER_NAME vertex:" + vertex + "\n" + migratedVertexCode;
                this._fragmentSourceCode = (this._shaderLanguage === ShaderLanguage.WGSL ? "//" : "") + "#define SHADER_NAME fragment:" + fragment + "\n" + migratedFragmentCode;
            }
            else {
                this._vertexSourceCode = migratedVertexCode;
                this._fragmentSourceCode = migratedFragmentCode;
            }
            this._prepareEffect();
        }
        /**
         * Unique key for this effect
         */
        get key() {
            return this._key;
        }
        /**
         * If the effect has been compiled and prepared.
         * @returns if the effect is compiled and prepared.
         */
        isReady() {
            try {
                return this._isReadyInternal();
            }
            catch (_a) {
                return false;
            }
        }
        _isReadyInternal() {
            if (this._isReady) {
                return true;
            }
            if (this._pipelineContext) {
                return this._pipelineContext.isReady;
            }
            return false;
        }
        /**
         * The engine the effect was initialized with.
         * @returns the engine.
         */
        getEngine() {
            return this._engine;
        }
        /**
         * The pipeline context for this effect
         * @returns the associated pipeline context
         */
        getPipelineContext() {
            return this._pipelineContext;
        }
        /**
         * The set of names of attribute variables for the shader.
         * @returns An array of attribute names.
         */
        getAttributesNames() {
            return this._attributesNames;
        }
        /**
         * Returns the attribute at the given index.
         * @param index The index of the attribute.
         * @returns The location of the attribute.
         */
        getAttributeLocation(index) {
            return this._attributes[index];
        }
        /**
         * Returns the attribute based on the name of the variable.
         * @param name of the attribute to look up.
         * @returns the attribute location.
         */
        getAttributeLocationByName(name) {
            return this._attributeLocationByName[name];
        }
        /**
         * The number of attributes.
         * @returns the number of attributes.
         */
        getAttributesCount() {
            return this._attributes.length;
        }
        /**
         * Gets the index of a uniform variable.
         * @param uniformName of the uniform to look up.
         * @returns the index.
         */
        getUniformIndex(uniformName) {
            return this._uniformsNames.indexOf(uniformName);
        }
        /**
         * Returns the attribute based on the name of the variable.
         * @param uniformName of the uniform to look up.
         * @returns the location of the uniform.
         */
        getUniform(uniformName) {
            return this._uniforms[uniformName];
        }
        /**
         * Returns an array of sampler variable names
         * @returns The array of sampler variable names.
         */
        getSamplers() {
            return this._samplerList;
        }
        /**
         * Returns an array of uniform variable names
         * @returns The array of uniform variable names.
         */
        getUniformNames() {
            return this._uniformsNames;
        }
        /**
         * Returns an array of uniform buffer variable names
         * @returns The array of uniform buffer variable names.
         */
        getUniformBuffersNames() {
            return this._uniformBuffersNamesList;
        }
        /**
         * Returns the index parameters used to create the effect
         * @returns The index parameters object
         */
        getIndexParameters() {
            return this._indexParameters;
        }
        /**
         * The error from the last compilation.
         * @returns the error string.
         */
        getCompilationError() {
            return this._compilationError;
        }
        /**
         * Gets a boolean indicating that all fallbacks were used during compilation
         * @returns true if all fallbacks were used
         */
        allFallbacksProcessed() {
            return this._allFallbacksProcessed;
        }
        /**
         * Adds a callback to the onCompiled observable and call the callback immediately if already ready.
         * @param func The callback to be used.
         */
        executeWhenCompiled(func) {
            if (this.isReady()) {
                func(this);
                return;
            }
            this.onCompileObservable.add((effect) => {
                func(effect);
            });
            if (!this._pipelineContext || this._pipelineContext.isAsync) {
                setTimeout(() => {
                    this._checkIsReady(null);
                }, 16);
            }
        }
        _checkIsReady(previousPipelineContext) {
            try {
                if (this._isReadyInternal()) {
                    return;
                }
            }
            catch (e) {
                this._processCompilationErrors(e, previousPipelineContext);
                return;
            }
            if (this._isDisposed) {
                return;
            }
            setTimeout(() => {
                this._checkIsReady(previousPipelineContext);
            }, 16);
        }
        _loadShader(shader, key, optionalKey, callback) {
            if (typeof HTMLElement !== "undefined") {
                // DOM element ?
                if (shader instanceof HTMLElement) {
                    const shaderCode = GetDOMTextContent(shader);
                    callback(shaderCode);
                    return;
                }
            }
            // Direct source ?
            if (shader.substr(0, 7) === "source:") {
                callback(shader.substr(7));
                return;
            }
            // Base64 encoded ?
            if (shader.substr(0, 7) === "base64:") {
                const shaderBinary = window.atob(shader.substr(7));
                callback(shaderBinary);
                return;
            }
            const shaderStore = ShaderStore.GetShadersStore(this._shaderLanguage);
            // Is in local store ?
            if (shaderStore[shader + key + "Shader"]) {
                callback(shaderStore[shader + key + "Shader"]);
                return;
            }
            if (optionalKey && shaderStore[shader + optionalKey + "Shader"]) {
                callback(shaderStore[shader + optionalKey + "Shader"]);
                return;
            }
            let shaderUrl;
            if (shader[0] === "." || shader[0] === "/" || shader.indexOf("http") > -1) {
                shaderUrl = shader;
            }
            else {
                shaderUrl = ShaderStore.GetShadersRepository(this._shaderLanguage) + shader;
            }
            // Vertex shader
            this._engine._loadFile(shaderUrl + "." + key.toLowerCase() + ".fx", callback);
        }
        /**
         * Gets the vertex shader source code of this effect
         * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
         */
        get vertexSourceCode() {
            var _a, _b;
            return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride
                ? this._vertexSourceCodeOverride
                : (_b = (_a = this._pipelineContext) === null || _a === void 0 ? void 0 : _a._getVertexShaderCode()) !== null && _b !== void 0 ? _b : this._vertexSourceCode;
        }
        /**
         * Gets the fragment shader source code of this effect
         * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
         */
        get fragmentSourceCode() {
            var _a, _b;
            return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride
                ? this._fragmentSourceCodeOverride
                : (_b = (_a = this._pipelineContext) === null || _a === void 0 ? void 0 : _a._getFragmentShaderCode()) !== null && _b !== void 0 ? _b : this._fragmentSourceCode;
        }
        /**
         * Gets the vertex shader source code before migration.
         * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
         * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
         */
        get vertexSourceCodeBeforeMigration() {
            return this._vertexSourceCodeBeforeMigration;
        }
        /**
         * Gets the fragment shader source code before migration.
         * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
         * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
         */
        get fragmentSourceCodeBeforeMigration() {
            return this._fragmentSourceCodeBeforeMigration;
        }
        /**
         * Gets the vertex shader source code before it has been modified by any processing
         */
        get rawVertexSourceCode() {
            return this._rawVertexSourceCode;
        }
        /**
         * Gets the fragment shader source code before it has been modified by any processing
         */
        get rawFragmentSourceCode() {
            return this._rawFragmentSourceCode;
        }
        /**
         * Recompiles the webGL program
         * @param vertexSourceCode The source code for the vertex shader.
         * @param fragmentSourceCode The source code for the fragment shader.
         * @param onCompiled Callback called when completed.
         * @param onError Callback called on error.
         * @internal
         */
        _rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError) {
            this._isReady = false;
            this._vertexSourceCodeOverride = vertexSourceCode;
            this._fragmentSourceCodeOverride = fragmentSourceCode;
            this.onError = (effect, error) => {
                if (onError) {
                    onError(error);
                }
            };
            this.onCompiled = () => {
                const scenes = this.getEngine().scenes;
                if (scenes) {
                    for (let i = 0; i < scenes.length; i++) {
                        scenes[i].markAllMaterialsAsDirty(63);
                    }
                }
                this._pipelineContext._handlesSpectorRebuildCallback(onCompiled);
            };
            this._fallbacks = null;
            this._prepareEffect();
        }
        /**
         * Prepares the effect
         * @internal
         */
        _prepareEffect() {
            const attributesNames = this._attributesNames;
            const defines = this.defines;
            const previousPipelineContext = this._pipelineContext;
            this._isReady = false;
            try {
                const engine = this._engine;
                this._pipelineContext = engine.createPipelineContext(this._processingContext);
                this._pipelineContext._name = this._key;
                const rebuildRebind = this._rebuildProgram.bind(this);
                if (this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride) {
                    engine._preparePipelineContext(this._pipelineContext, this._vertexSourceCodeOverride, this._fragmentSourceCodeOverride, true, this._rawVertexSourceCode, this._rawFragmentSourceCode, rebuildRebind, null, this._transformFeedbackVaryings, this._key);
                }
                else {
                    engine._preparePipelineContext(this._pipelineContext, this._vertexSourceCode, this._fragmentSourceCode, false, this._rawVertexSourceCode, this._rawFragmentSourceCode, rebuildRebind, defines, this._transformFeedbackVaryings, this._key);
                }
                engine._executeWhenRenderingStateIsCompiled(this._pipelineContext, () => {
                    this._attributes = [];
                    this._pipelineContext._fillEffectInformation(this, this._uniformBuffersNames, this._uniformsNames, this._uniforms, this._samplerList, this._samplers, attributesNames, this._attributes);
                    // Caches attribute locations.
                    if (attributesNames) {
                        for (let i = 0; i < attributesNames.length; i++) {
                            const name = attributesNames[i];
                            this._attributeLocationByName[name] = this._attributes[i];
                        }
                    }
                    engine.bindSamplers(this);
                    this._compilationError = "";
                    this._isReady = true;
                    if (this.onCompiled) {
                        this.onCompiled(this);
                    }
                    this.onCompileObservable.notifyObservers(this);
                    this.onCompileObservable.clear();
                    // Unbind mesh reference in fallbacks
                    if (this._fallbacks) {
                        this._fallbacks.unBindMesh();
                    }
                    if (previousPipelineContext) {
                        this.getEngine()._deletePipelineContext(previousPipelineContext);
                    }
                });
                if (this._pipelineContext.isAsync) {
                    this._checkIsReady(previousPipelineContext);
                }
            }
            catch (e) {
                this._processCompilationErrors(e, previousPipelineContext);
            }
        }
        _getShaderCodeAndErrorLine(code, error, isFragment) {
            const regexp = isFragment ? /FRAGMENT SHADER ERROR: 0:(\d+?):/ : /VERTEX SHADER ERROR: 0:(\d+?):/;
            let errorLine = null;
            if (error && code) {
                const res = error.match(regexp);
                if (res && res.length === 2) {
                    const lineNumber = parseInt(res[1]);
                    const lines = code.split("\n", -1);
                    if (lines.length >= lineNumber) {
                        errorLine = `Offending line [${lineNumber}] in ${isFragment ? "fragment" : "vertex"} code: ${lines[lineNumber - 1]}`;
                    }
                }
            }
            return [code, errorLine];
        }
        _processCompilationErrors(e, previousPipelineContext = null) {
            var _a, _b, _c;
            this._compilationError = e.message;
            const attributesNames = this._attributesNames;
            const fallbacks = this._fallbacks;
            // Let's go through fallbacks then
            Logger.Error("Unable to compile effect:");
            Logger.Error("Uniforms: " +
                this._uniformsNames.map(function (uniform) {
                    return " " + uniform;
                }));
            Logger.Error("Attributes: " +
                attributesNames.map(function (attribute) {
                    return " " + attribute;
                }));
            Logger.Error("Defines:\n" + this.defines);
            if (Effect.LogShaderCodeOnCompilationError) {
                let lineErrorVertex = null, lineErrorFragment = null, code = null;
                if ((_a = this._pipelineContext) === null || _a === void 0 ? void 0 : _a._getVertexShaderCode()) {
                    [code, lineErrorVertex] = this._getShaderCodeAndErrorLine(this._pipelineContext._getVertexShaderCode(), this._compilationError, false);
                    if (code) {
                        Logger.Error("Vertex code:");
                        Logger.Error(code);
                    }
                }
                if ((_b = this._pipelineContext) === null || _b === void 0 ? void 0 : _b._getFragmentShaderCode()) {
                    [code, lineErrorFragment] = this._getShaderCodeAndErrorLine((_c = this._pipelineContext) === null || _c === void 0 ? void 0 : _c._getFragmentShaderCode(), this._compilationError, true);
                    if (code) {
                        Logger.Error("Fragment code:");
                        Logger.Error(code);
                    }
                }
                if (lineErrorVertex) {
                    Logger.Error(lineErrorVertex);
                }
                if (lineErrorFragment) {
                    Logger.Error(lineErrorFragment);
                }
            }
            Logger.Error("Error: " + this._compilationError);
            const notifyErrors = () => {
                if (this.onError) {
                    this.onError(this, this._compilationError);
                }
                this.onErrorObservable.notifyObservers(this);
            };
            // In case a previous compilation was successful, we need to restore the previous pipeline context
            if (previousPipelineContext) {
                this._pipelineContext = previousPipelineContext;
                this._isReady = true;
                notifyErrors();
            }
            // Lets try to compile fallbacks as long as we have some.
            if (fallbacks) {
                this._pipelineContext = null;
                if (fallbacks.hasMoreFallbacks) {
                    this._allFallbacksProcessed = false;
                    Logger.Error("Trying next fallback.");
                    this.defines = fallbacks.reduce(this.defines, this);
                    this._prepareEffect();
                }
                else {
                    // Sorry we did everything we can
                    this._allFallbacksProcessed = true;
                    notifyErrors();
                    this.onErrorObservable.clear();
                    // Unbind mesh reference in fallbacks
                    if (this._fallbacks) {
                        this._fallbacks.unBindMesh();
                    }
                }
            }
            else {
                this._allFallbacksProcessed = true;
                // In case of error, without any prior successful compilation, let s notify observers
                if (!previousPipelineContext) {
                    notifyErrors();
                }
            }
        }
        /**
         * Checks if the effect is supported. (Must be called after compilation)
         */
        get isSupported() {
            return this._compilationError === "";
        }
        /**
         * Binds a texture to the engine to be used as output of the shader.
         * @param channel Name of the output variable.
         * @param texture Texture to bind.
         * @internal
         */
        _bindTexture(channel, texture) {
            this._engine._bindTexture(this._samplers[channel], texture, channel);
        }
        /**
         * Sets a texture on the engine to be used in the shader.
         * @param channel Name of the sampler variable.
         * @param texture Texture to set.
         */
        setTexture(channel, texture) {
            this._engine.setTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
        }
        /**
         * Sets a depth stencil texture from a render target on the engine to be used in the shader.
         * @param channel Name of the sampler variable.
         * @param texture Texture to set.
         */
        setDepthStencilTexture(channel, texture) {
            this._engine.setDepthStencilTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
        }
        /**
         * Sets an array of textures on the engine to be used in the shader.
         * @param channel Name of the variable.
         * @param textures Textures to set.
         */
        setTextureArray(channel, textures) {
            const exName = channel + "Ex";
            if (this._samplerList.indexOf(exName + "0") === -1) {
                const initialPos = this._samplerList.indexOf(channel);
                for (let index = 1; index < textures.length; index++) {
                    const currentExName = exName + (index - 1).toString();
                    this._samplerList.splice(initialPos + index, 0, currentExName);
                }
                // Reset every channels
                let channelIndex = 0;
                for (const key of this._samplerList) {
                    this._samplers[key] = channelIndex;
                    channelIndex += 1;
                }
            }
            this._engine.setTextureArray(this._samplers[channel], this._uniforms[channel], textures, channel);
        }
        /**
         * Sets a texture to be the input of the specified post process. (To use the output, pass in the next post process in the pipeline)
         * @param channel Name of the sampler variable.
         * @param postProcess Post process to get the input texture from.
         */
        setTextureFromPostProcess(channel, postProcess) {
            this._engine.setTextureFromPostProcess(this._samplers[channel], postProcess, channel);
        }
        /**
         * (Warning! setTextureFromPostProcessOutput may be desired instead)
         * Sets the input texture of the passed in post process to be input of this effect. (To use the output of the passed in post process use setTextureFromPostProcessOutput)
         * @param channel Name of the sampler variable.
         * @param postProcess Post process to get the output texture from.
         */
        setTextureFromPostProcessOutput(channel, postProcess) {
            this._engine.setTextureFromPostProcessOutput(this._samplers[channel], postProcess, channel);
        }
        /**
         * Binds a buffer to a uniform.
         * @param buffer Buffer to bind.
         * @param name Name of the uniform variable to bind to.
         */
        bindUniformBuffer(buffer, name) {
            const bufferName = this._uniformBuffersNames[name];
            if (bufferName === undefined || (Effect._BaseCache[bufferName] === buffer && this._engine._features.useUBOBindingCache)) {
                return;
            }
            Effect._BaseCache[bufferName] = buffer;
            this._engine.bindUniformBufferBase(buffer, bufferName, name);
        }
        /**
         * Binds block to a uniform.
         * @param blockName Name of the block to bind.
         * @param index Index to bind.
         */
        bindUniformBlock(blockName, index) {
            this._engine.bindUniformBlock(this._pipelineContext, blockName, index);
        }
        /**
         * Sets an integer value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param value Value to be set.
         * @returns this effect.
         */
        setInt(uniformName, value) {
            this._pipelineContext.setInt(uniformName, value);
            return this;
        }
        /**
         * Sets an int2 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First int in int2.
         * @param y Second int in int2.
         * @returns this effect.
         */
        setInt2(uniformName, x, y) {
            this._pipelineContext.setInt2(uniformName, x, y);
            return this;
        }
        /**
         * Sets an int3 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First int in int3.
         * @param y Second int in int3.
         * @param z Third int in int3.
         * @returns this effect.
         */
        setInt3(uniformName, x, y, z) {
            this._pipelineContext.setInt3(uniformName, x, y, z);
            return this;
        }
        /**
         * Sets an int4 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First int in int4.
         * @param y Second int in int4.
         * @param z Third int in int4.
         * @param w Fourth int in int4.
         * @returns this effect.
         */
        setInt4(uniformName, x, y, z, w) {
            this._pipelineContext.setInt4(uniformName, x, y, z, w);
            return this;
        }
        /**
         * Sets an int array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setIntArray(uniformName, array) {
            this._pipelineContext.setIntArray(uniformName, array);
            return this;
        }
        /**
         * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setIntArray2(uniformName, array) {
            this._pipelineContext.setIntArray2(uniformName, array);
            return this;
        }
        /**
         * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setIntArray3(uniformName, array) {
            this._pipelineContext.setIntArray3(uniformName, array);
            return this;
        }
        /**
         * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setIntArray4(uniformName, array) {
            this._pipelineContext.setIntArray4(uniformName, array);
            return this;
        }
        /**
         * Sets an unsigned integer value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param value Value to be set.
         * @returns this effect.
         */
        setUInt(uniformName, value) {
            this._pipelineContext.setInt(uniformName, value);
            return this;
        }
        /**
         * Sets an unsigned int2 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First unsigned int in uint2.
         * @param y Second unsigned int in uint2.
         * @returns this effect.
         */
        setUInt2(uniformName, x, y) {
            this._pipelineContext.setInt2(uniformName, x, y);
            return this;
        }
        /**
         * Sets an unsigned int3 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First unsigned int in uint3.
         * @param y Second unsigned int in uint3.
         * @param z Third unsigned int in uint3.
         * @returns this effect.
         */
        setUInt3(uniformName, x, y, z) {
            this._pipelineContext.setInt3(uniformName, x, y, z);
            return this;
        }
        /**
         * Sets an unsigned int4 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First unsigned int in uint4.
         * @param y Second unsigned int in uint4.
         * @param z Third unsigned int in uint4.
         * @param w Fourth unsigned int in uint4.
         * @returns this effect.
         */
        setUInt4(uniformName, x, y, z, w) {
            this._pipelineContext.setInt4(uniformName, x, y, z, w);
            return this;
        }
        /**
         * Sets an unsigned int array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setUIntArray(uniformName, array) {
            this._pipelineContext.setUIntArray(uniformName, array);
            return this;
        }
        /**
         * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setUIntArray2(uniformName, array) {
            this._pipelineContext.setUIntArray2(uniformName, array);
            return this;
        }
        /**
         * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setUIntArray3(uniformName, array) {
            this._pipelineContext.setUIntArray3(uniformName, array);
            return this;
        }
        /**
         * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setUIntArray4(uniformName, array) {
            this._pipelineContext.setUIntArray4(uniformName, array);
            return this;
        }
        /**
         * Sets an float array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setFloatArray(uniformName, array) {
            this._pipelineContext.setArray(uniformName, array);
            return this;
        }
        /**
         * Sets an float array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setFloatArray2(uniformName, array) {
            this._pipelineContext.setArray2(uniformName, array);
            return this;
        }
        /**
         * Sets an float array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setFloatArray3(uniformName, array) {
            this._pipelineContext.setArray3(uniformName, array);
            return this;
        }
        /**
         * Sets an float array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setFloatArray4(uniformName, array) {
            this._pipelineContext.setArray4(uniformName, array);
            return this;
        }
        /**
         * Sets an array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setArray(uniformName, array) {
            this._pipelineContext.setArray(uniformName, array);
            return this;
        }
        /**
         * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setArray2(uniformName, array) {
            this._pipelineContext.setArray2(uniformName, array);
            return this;
        }
        /**
         * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setArray3(uniformName, array) {
            this._pipelineContext.setArray3(uniformName, array);
            return this;
        }
        /**
         * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setArray4(uniformName, array) {
            this._pipelineContext.setArray4(uniformName, array);
            return this;
        }
        /**
         * Sets matrices on a uniform variable.
         * @param uniformName Name of the variable.
         * @param matrices matrices to be set.
         * @returns this effect.
         */
        setMatrices(uniformName, matrices) {
            this._pipelineContext.setMatrices(uniformName, matrices);
            return this;
        }
        /**
         * Sets matrix on a uniform variable.
         * @param uniformName Name of the variable.
         * @param matrix matrix to be set.
         * @returns this effect.
         */
        setMatrix(uniformName, matrix) {
            this._pipelineContext.setMatrix(uniformName, matrix);
            return this;
        }
        /**
         * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
         * @param uniformName Name of the variable.
         * @param matrix matrix to be set.
         * @returns this effect.
         */
        setMatrix3x3(uniformName, matrix) {
            // the cast is ok because it is gl.uniformMatrix3fv() which is called at the end, and this function accepts Float32Array and Array<number>
            this._pipelineContext.setMatrix3x3(uniformName, matrix);
            return this;
        }
        /**
         * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
         * @param uniformName Name of the variable.
         * @param matrix matrix to be set.
         * @returns this effect.
         */
        setMatrix2x2(uniformName, matrix) {
            // the cast is ok because it is gl.uniformMatrix3fv() which is called at the end, and this function accepts Float32Array and Array<number>
            this._pipelineContext.setMatrix2x2(uniformName, matrix);
            return this;
        }
        /**
         * Sets a float on a uniform variable.
         * @param uniformName Name of the variable.
         * @param value value to be set.
         * @returns this effect.
         */
        setFloat(uniformName, value) {
            this._pipelineContext.setFloat(uniformName, value);
            return this;
        }
        /**
         * Sets a boolean on a uniform variable.
         * @param uniformName Name of the variable.
         * @param bool value to be set.
         * @returns this effect.
         */
        setBool(uniformName, bool) {
            this._pipelineContext.setInt(uniformName, bool ? 1 : 0);
            return this;
        }
        /**
         * Sets a Vector2 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param vector2 vector2 to be set.
         * @returns this effect.
         */
        setVector2(uniformName, vector2) {
            this._pipelineContext.setVector2(uniformName, vector2);
            return this;
        }
        /**
         * Sets a float2 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First float in float2.
         * @param y Second float in float2.
         * @returns this effect.
         */
        setFloat2(uniformName, x, y) {
            this._pipelineContext.setFloat2(uniformName, x, y);
            return this;
        }
        /**
         * Sets a Vector3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param vector3 Value to be set.
         * @returns this effect.
         */
        setVector3(uniformName, vector3) {
            this._pipelineContext.setVector3(uniformName, vector3);
            return this;
        }
        /**
         * Sets a float3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First float in float3.
         * @param y Second float in float3.
         * @param z Third float in float3.
         * @returns this effect.
         */
        setFloat3(uniformName, x, y, z) {
            this._pipelineContext.setFloat3(uniformName, x, y, z);
            return this;
        }
        /**
         * Sets a Vector4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param vector4 Value to be set.
         * @returns this effect.
         */
        setVector4(uniformName, vector4) {
            this._pipelineContext.setVector4(uniformName, vector4);
            return this;
        }
        /**
         * Sets a Quaternion on a uniform variable.
         * @param uniformName Name of the variable.
         * @param quaternion Value to be set.
         * @returns this effect.
         */
        setQuaternion(uniformName, quaternion) {
            this._pipelineContext.setQuaternion(uniformName, quaternion);
            return this;
        }
        /**
         * Sets a float4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First float in float4.
         * @param y Second float in float4.
         * @param z Third float in float4.
         * @param w Fourth float in float4.
         * @returns this effect.
         */
        setFloat4(uniformName, x, y, z, w) {
            this._pipelineContext.setFloat4(uniformName, x, y, z, w);
            return this;
        }
        /**
         * Sets a Color3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param color3 Value to be set.
         * @returns this effect.
         */
        setColor3(uniformName, color3) {
            this._pipelineContext.setColor3(uniformName, color3);
            return this;
        }
        /**
         * Sets a Color4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param color3 Value to be set.
         * @param alpha Alpha value to be set.
         * @returns this effect.
         */
        setColor4(uniformName, color3, alpha) {
            this._pipelineContext.setColor4(uniformName, color3, alpha);
            return this;
        }
        /**
         * Sets a Color4 on a uniform variable
         * @param uniformName defines the name of the variable
         * @param color4 defines the value to be set
         * @returns this effect.
         */
        setDirectColor4(uniformName, color4) {
            this._pipelineContext.setDirectColor4(uniformName, color4);
            return this;
        }
        /**
         * Release all associated resources.
         **/
        dispose() {
            if (this._pipelineContext) {
                this._pipelineContext.dispose();
            }
            this._engine._releaseEffect(this);
            this._isDisposed = true;
        }
        /**
         * This function will add a new shader to the shader store
         * @param name the name of the shader
         * @param pixelShader optional pixel shader content
         * @param vertexShader optional vertex shader content
         * @param shaderLanguage the language the shader is written in (default: GLSL)
         */
        static RegisterShader(name, pixelShader, vertexShader, shaderLanguage = ShaderLanguage.GLSL) {
            if (pixelShader) {
                ShaderStore.GetShadersStore(shaderLanguage)[`${name}PixelShader`] = pixelShader;
            }
            if (vertexShader) {
                ShaderStore.GetShadersStore(shaderLanguage)[`${name}VertexShader`] = vertexShader;
            }
        }
        /**
         * Resets the cache of effects.
         */
        static ResetCache() {
            Effect._BaseCache = {};
        }
    }
    /**
     * Enable logging of the shader code when a compilation error occurs
     */
    Effect.LogShaderCodeOnCompilationError = true;
    Effect._UniqueIdSeed = 0;
    Effect._BaseCache = {};
    /**
     * Store of each shader (The can be looked up using effect.key)
     */
    Effect.ShadersStore = ShaderStore.ShadersStore;
    /**
     * Store of each included file for a shader (The can be looked up using effect.key)
     */
    Effect.IncludesShadersStore = ShaderStore.IncludesShadersStore;

    /**
     * @internal
     **/
    class DepthCullingState {
        /**
         * Initializes the state.
         * @param reset
         */
        constructor(reset = true) {
            this._isDepthTestDirty = false;
            this._isDepthMaskDirty = false;
            this._isDepthFuncDirty = false;
            this._isCullFaceDirty = false;
            this._isCullDirty = false;
            this._isZOffsetDirty = false;
            this._isFrontFaceDirty = false;
            if (reset) {
                this.reset();
            }
        }
        get isDirty() {
            return (this._isDepthFuncDirty ||
                this._isDepthTestDirty ||
                this._isDepthMaskDirty ||
                this._isCullFaceDirty ||
                this._isCullDirty ||
                this._isZOffsetDirty ||
                this._isFrontFaceDirty);
        }
        get zOffset() {
            return this._zOffset;
        }
        set zOffset(value) {
            if (this._zOffset === value) {
                return;
            }
            this._zOffset = value;
            this._isZOffsetDirty = true;
        }
        get zOffsetUnits() {
            return this._zOffsetUnits;
        }
        set zOffsetUnits(value) {
            if (this._zOffsetUnits === value) {
                return;
            }
            this._zOffsetUnits = value;
            this._isZOffsetDirty = true;
        }
        get cullFace() {
            return this._cullFace;
        }
        set cullFace(value) {
            if (this._cullFace === value) {
                return;
            }
            this._cullFace = value;
            this._isCullFaceDirty = true;
        }
        get cull() {
            return this._cull;
        }
        set cull(value) {
            if (this._cull === value) {
                return;
            }
            this._cull = value;
            this._isCullDirty = true;
        }
        get depthFunc() {
            return this._depthFunc;
        }
        set depthFunc(value) {
            if (this._depthFunc === value) {
                return;
            }
            this._depthFunc = value;
            this._isDepthFuncDirty = true;
        }
        get depthMask() {
            return this._depthMask;
        }
        set depthMask(value) {
            if (this._depthMask === value) {
                return;
            }
            this._depthMask = value;
            this._isDepthMaskDirty = true;
        }
        get depthTest() {
            return this._depthTest;
        }
        set depthTest(value) {
            if (this._depthTest === value) {
                return;
            }
            this._depthTest = value;
            this._isDepthTestDirty = true;
        }
        get frontFace() {
            return this._frontFace;
        }
        set frontFace(value) {
            if (this._frontFace === value) {
                return;
            }
            this._frontFace = value;
            this._isFrontFaceDirty = true;
        }
        reset() {
            this._depthMask = true;
            this._depthTest = true;
            this._depthFunc = null;
            this._cullFace = null;
            this._cull = null;
            this._zOffset = 0;
            this._zOffsetUnits = 0;
            this._frontFace = null;
            this._isDepthTestDirty = true;
            this._isDepthMaskDirty = true;
            this._isDepthFuncDirty = false;
            this._isCullFaceDirty = false;
            this._isCullDirty = false;
            this._isZOffsetDirty = true;
            this._isFrontFaceDirty = false;
        }
        apply(gl) {
            if (!this.isDirty) {
                return;
            }
            // Cull
            if (this._isCullDirty) {
                if (this.cull) {
                    gl.enable(gl.CULL_FACE);
                }
                else {
                    gl.disable(gl.CULL_FACE);
                }
                this._isCullDirty = false;
            }
            // Cull face
            if (this._isCullFaceDirty) {
                gl.cullFace(this.cullFace);
                this._isCullFaceDirty = false;
            }
            // Depth mask
            if (this._isDepthMaskDirty) {
                gl.depthMask(this.depthMask);
                this._isDepthMaskDirty = false;
            }
            // Depth test
            if (this._isDepthTestDirty) {
                if (this.depthTest) {
                    gl.enable(gl.DEPTH_TEST);
                }
                else {
                    gl.disable(gl.DEPTH_TEST);
                }
                this._isDepthTestDirty = false;
            }
            // Depth func
            if (this._isDepthFuncDirty) {
                gl.depthFunc(this.depthFunc);
                this._isDepthFuncDirty = false;
            }
            // zOffset
            if (this._isZOffsetDirty) {
                if (this.zOffset || this.zOffsetUnits) {
                    gl.enable(gl.POLYGON_OFFSET_FILL);
                    gl.polygonOffset(this.zOffset, this.zOffsetUnits);
                }
                else {
                    gl.disable(gl.POLYGON_OFFSET_FILL);
                }
                this._isZOffsetDirty = false;
            }
            // Front face
            if (this._isFrontFaceDirty) {
                gl.frontFace(this.frontFace);
                this._isFrontFaceDirty = false;
            }
        }
    }

    /**
     * @internal
     **/
    class StencilState {
        constructor() {
            this.reset();
        }
        reset() {
            this.enabled = false;
            this.mask = 0xff;
            this.func = StencilState.ALWAYS;
            this.funcRef = 1;
            this.funcMask = 0xff;
            this.opStencilFail = StencilState.KEEP;
            this.opDepthFail = StencilState.KEEP;
            this.opStencilDepthPass = StencilState.REPLACE;
        }
        get stencilFunc() {
            return this.func;
        }
        set stencilFunc(value) {
            this.func = value;
        }
        get stencilFuncRef() {
            return this.funcRef;
        }
        set stencilFuncRef(value) {
            this.funcRef = value;
        }
        get stencilFuncMask() {
            return this.funcMask;
        }
        set stencilFuncMask(value) {
            this.funcMask = value;
        }
        get stencilOpStencilFail() {
            return this.opStencilFail;
        }
        set stencilOpStencilFail(value) {
            this.opStencilFail = value;
        }
        get stencilOpDepthFail() {
            return this.opDepthFail;
        }
        set stencilOpDepthFail(value) {
            this.opDepthFail = value;
        }
        get stencilOpStencilDepthPass() {
            return this.opStencilDepthPass;
        }
        set stencilOpStencilDepthPass(value) {
            this.opStencilDepthPass = value;
        }
        get stencilMask() {
            return this.mask;
        }
        set stencilMask(value) {
            this.mask = value;
        }
        get stencilTest() {
            return this.enabled;
        }
        set stencilTest(value) {
            this.enabled = value;
        }
    }
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */
    StencilState.ALWAYS = 519;
    /** Passed to stencilOperation to specify that stencil value must be kept */
    StencilState.KEEP = 7680;
    /** Passed to stencilOperation to specify that stencil value must be replaced */
    StencilState.REPLACE = 7681;

    /**
     * @internal
     **/
    class AlphaState {
        /**
         * Initializes the state.
         */
        constructor() {
            this._blendFunctionParameters = new Array(4);
            this._blendEquationParameters = new Array(2);
            this._blendConstants = new Array(4);
            this._isBlendConstantsDirty = false;
            this._alphaBlend = false;
            this._isAlphaBlendDirty = false;
            this._isBlendFunctionParametersDirty = false;
            this._isBlendEquationParametersDirty = false;
            this.reset();
        }
        get isDirty() {
            return this._isAlphaBlendDirty || this._isBlendFunctionParametersDirty || this._isBlendEquationParametersDirty;
        }
        get alphaBlend() {
            return this._alphaBlend;
        }
        set alphaBlend(value) {
            if (this._alphaBlend === value) {
                return;
            }
            this._alphaBlend = value;
            this._isAlphaBlendDirty = true;
        }
        setAlphaBlendConstants(r, g, b, a) {
            if (this._blendConstants[0] === r && this._blendConstants[1] === g && this._blendConstants[2] === b && this._blendConstants[3] === a) {
                return;
            }
            this._blendConstants[0] = r;
            this._blendConstants[1] = g;
            this._blendConstants[2] = b;
            this._blendConstants[3] = a;
            this._isBlendConstantsDirty = true;
        }
        setAlphaBlendFunctionParameters(value0, value1, value2, value3) {
            if (this._blendFunctionParameters[0] === value0 &&
                this._blendFunctionParameters[1] === value1 &&
                this._blendFunctionParameters[2] === value2 &&
                this._blendFunctionParameters[3] === value3) {
                return;
            }
            this._blendFunctionParameters[0] = value0;
            this._blendFunctionParameters[1] = value1;
            this._blendFunctionParameters[2] = value2;
            this._blendFunctionParameters[3] = value3;
            this._isBlendFunctionParametersDirty = true;
        }
        setAlphaEquationParameters(rgb, alpha) {
            if (this._blendEquationParameters[0] === rgb && this._blendEquationParameters[1] === alpha) {
                return;
            }
            this._blendEquationParameters[0] = rgb;
            this._blendEquationParameters[1] = alpha;
            this._isBlendEquationParametersDirty = true;
        }
        reset() {
            this._alphaBlend = false;
            this._blendFunctionParameters[0] = null;
            this._blendFunctionParameters[1] = null;
            this._blendFunctionParameters[2] = null;
            this._blendFunctionParameters[3] = null;
            this._blendEquationParameters[0] = null;
            this._blendEquationParameters[1] = null;
            this._blendConstants[0] = null;
            this._blendConstants[1] = null;
            this._blendConstants[2] = null;
            this._blendConstants[3] = null;
            this._isAlphaBlendDirty = true;
            this._isBlendFunctionParametersDirty = false;
            this._isBlendEquationParametersDirty = false;
            this._isBlendConstantsDirty = false;
        }
        apply(gl) {
            if (!this.isDirty) {
                return;
            }
            // Alpha blend
            if (this._isAlphaBlendDirty) {
                if (this._alphaBlend) {
                    gl.enable(gl.BLEND);
                }
                else {
                    gl.disable(gl.BLEND);
                }
                this._isAlphaBlendDirty = false;
            }
            // Alpha function
            if (this._isBlendFunctionParametersDirty) {
                gl.blendFuncSeparate(this._blendFunctionParameters[0], this._blendFunctionParameters[1], this._blendFunctionParameters[2], this._blendFunctionParameters[3]);
                this._isBlendFunctionParametersDirty = false;
            }
            // Alpha equation
            if (this._isBlendEquationParametersDirty) {
                gl.blendEquationSeparate(this._blendEquationParameters[0], this._blendEquationParameters[1]);
                this._isBlendEquationParametersDirty = false;
            }
            // Constants
            if (this._isBlendConstantsDirty) {
                gl.blendColor(this._blendConstants[0], this._blendConstants[1], this._blendConstants[2], this._blendConstants[3]);
                this._isBlendConstantsDirty = false;
            }
        }
    }

    /**
     * Class used to store a texture sampler data
     */
    class TextureSampler {
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapU() {
            return this._cachedWrapU;
        }
        set wrapU(value) {
            this._cachedWrapU = value;
        }
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapV() {
            return this._cachedWrapV;
        }
        set wrapV(value) {
            this._cachedWrapV = value;
        }
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapR() {
            return this._cachedWrapR;
        }
        set wrapR(value) {
            this._cachedWrapR = value;
        }
        /**
         * With compliant hardware and browser (supporting anisotropic filtering)
         * this defines the level of anisotropic filtering in the texture.
         * The higher the better but the slower.
         */
        get anisotropicFilteringLevel() {
            return this._cachedAnisotropicFilteringLevel;
        }
        set anisotropicFilteringLevel(value) {
            this._cachedAnisotropicFilteringLevel = value;
        }
        /**
         * Gets or sets the comparison function (513, 514, etc). Set 0 to not use a comparison function
         */
        get comparisonFunction() {
            return this._comparisonFunction;
        }
        set comparisonFunction(value) {
            this._comparisonFunction = value;
        }
        /**
         * Indicates to use the mip maps (if available on the texture).
         * Thanks to this flag, you can instruct the sampler to not sample the mipmaps even if they exist (and if the sampling mode is set to a value that normally samples the mipmaps!)
         */
        get useMipMaps() {
            return this._useMipMaps;
        }
        set useMipMaps(value) {
            this._useMipMaps = value;
        }
        /**
         * Creates a Sampler instance
         */
        constructor() {
            /**
             * Gets the sampling mode of the texture
             */
            this.samplingMode = -1;
            this._useMipMaps = true;
            /** @internal */
            this._cachedWrapU = null;
            /** @internal */
            this._cachedWrapV = null;
            /** @internal */
            this._cachedWrapR = null;
            /** @internal */
            this._cachedAnisotropicFilteringLevel = null;
            /** @internal */
            this._comparisonFunction = 0;
        }
        /**
         * Sets all the parameters of the sampler
         * @param wrapU u address mode (default: TEXTURE_WRAP_ADDRESSMODE)
         * @param wrapV v address mode (default: TEXTURE_WRAP_ADDRESSMODE)
         * @param wrapR r address mode (default: TEXTURE_WRAP_ADDRESSMODE)
         * @param anisotropicFilteringLevel anisotropic level (default: 1)
         * @param samplingMode sampling mode (default: 2)
         * @param comparisonFunction comparison function (default: 0 - no comparison function)
         * @returns the current sampler instance
         */
        setParameters(wrapU = 1, wrapV = 1, wrapR = 1, anisotropicFilteringLevel = 1, samplingMode = 2, comparisonFunction = 0) {
            this._cachedWrapU = wrapU;
            this._cachedWrapV = wrapV;
            this._cachedWrapR = wrapR;
            this._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
            this.samplingMode = samplingMode;
            this._comparisonFunction = comparisonFunction;
            return this;
        }
        /**
         * Compares this sampler with another one
         * @param other sampler to compare with
         * @returns true if the samplers have the same parametres, else false
         */
        compareSampler(other) {
            return (this._cachedWrapU === other._cachedWrapU &&
                this._cachedWrapV === other._cachedWrapV &&
                this._cachedWrapR === other._cachedWrapR &&
                this._cachedAnisotropicFilteringLevel === other._cachedAnisotropicFilteringLevel &&
                this.samplingMode === other.samplingMode &&
                this._comparisonFunction === other._comparisonFunction &&
                this._useMipMaps === other._useMipMaps);
        }
    }

    /**
     * Defines the source of the internal texture
     */
    var InternalTextureSource;
    (function (InternalTextureSource) {
        /**
         * The source of the texture data is unknown
         */
        InternalTextureSource[InternalTextureSource["Unknown"] = 0] = "Unknown";
        /**
         * Texture data comes from an URL
         */
        InternalTextureSource[InternalTextureSource["Url"] = 1] = "Url";
        /**
         * Texture data is only used for temporary storage
         */
        InternalTextureSource[InternalTextureSource["Temp"] = 2] = "Temp";
        /**
         * Texture data comes from raw data (ArrayBuffer)
         */
        InternalTextureSource[InternalTextureSource["Raw"] = 3] = "Raw";
        /**
         * Texture content is dynamic (video or dynamic texture)
         */
        InternalTextureSource[InternalTextureSource["Dynamic"] = 4] = "Dynamic";
        /**
         * Texture content is generated by rendering to it
         */
        InternalTextureSource[InternalTextureSource["RenderTarget"] = 5] = "RenderTarget";
        /**
         * Texture content is part of a multi render target process
         */
        InternalTextureSource[InternalTextureSource["MultiRenderTarget"] = 6] = "MultiRenderTarget";
        /**
         * Texture data comes from a cube data file
         */
        InternalTextureSource[InternalTextureSource["Cube"] = 7] = "Cube";
        /**
         * Texture data comes from a raw cube data
         */
        InternalTextureSource[InternalTextureSource["CubeRaw"] = 8] = "CubeRaw";
        /**
         * Texture data come from a prefiltered cube data file
         */
        InternalTextureSource[InternalTextureSource["CubePrefiltered"] = 9] = "CubePrefiltered";
        /**
         * Texture content is raw 3D data
         */
        InternalTextureSource[InternalTextureSource["Raw3D"] = 10] = "Raw3D";
        /**
         * Texture content is raw 2D array data
         */
        InternalTextureSource[InternalTextureSource["Raw2DArray"] = 11] = "Raw2DArray";
        /**
         * Texture content is a depth/stencil texture
         */
        InternalTextureSource[InternalTextureSource["DepthStencil"] = 12] = "DepthStencil";
        /**
         * Texture data comes from a raw cube data encoded with RGBD
         */
        InternalTextureSource[InternalTextureSource["CubeRawRGBD"] = 13] = "CubeRawRGBD";
        /**
         * Texture content is a depth texture
         */
        InternalTextureSource[InternalTextureSource["Depth"] = 14] = "Depth";
    })(InternalTextureSource || (InternalTextureSource = {}));
    /**
     * Class used to store data associated with WebGL texture data for the engine
     * This class should not be used directly
     */
    class InternalTexture extends TextureSampler {
        /**
         * Gets a boolean indicating if the texture uses mipmaps
         * TODO implements useMipMaps as a separate setting from generateMipMaps
         */
        get useMipMaps() {
            return this.generateMipMaps;
        }
        set useMipMaps(value) {
            this.generateMipMaps = value;
        }
        /** Gets the unique id of the internal texture */
        get uniqueId() {
            return this._uniqueId;
        }
        /** @internal */
        _setUniqueId(id) {
            this._uniqueId = id;
        }
        /**
         * Gets the Engine the texture belongs to.
         * @returns The babylon engine
         */
        getEngine() {
            return this._engine;
        }
        /**
         * Gets the data source type of the texture
         */
        get source() {
            return this._source;
        }
        /**
         * Creates a new InternalTexture
         * @param engine defines the engine to use
         * @param source defines the type of data that will be used
         * @param delayAllocation if the texture allocation should be delayed (default: false)
         */
        constructor(engine, source, delayAllocation = false) {
            super();
            /**
             * Defines if the texture is ready
             */
            this.isReady = false;
            /**
             * Defines if the texture is a cube texture
             */
            this.isCube = false;
            /**
             * Defines if the texture contains 3D data
             */
            this.is3D = false;
            /**
             * Defines if the texture contains 2D array data
             */
            this.is2DArray = false;
            /**
             * Defines if the texture contains multiview data
             */
            this.isMultiview = false;
            /**
             * Gets the URL used to load this texture
             */
            this.url = "";
            /**
             * Gets a boolean indicating if the texture needs mipmaps generation
             */
            this.generateMipMaps = false;
            /**
             * Gets the number of samples used by the texture (WebGL2+ only)
             */
            this.samples = 0;
            /**
             * Gets the type of the texture (int, float...)
             */
            this.type = -1;
            /**
             * Gets the format of the texture (RGB, RGBA...)
             */
            this.format = -1;
            /**
             * Observable called when the texture is loaded
             */
            this.onLoadedObservable = new Observable$1();
            /**
             * Observable called when the texture load is raising an error
             */
            this.onErrorObservable = new Observable$1();
            /**
             * If this callback is defined it will be called instead of the default _rebuild function
             */
            this.onRebuildCallback = null;
            /**
             * Gets the width of the texture
             */
            this.width = 0;
            /**
             * Gets the height of the texture
             */
            this.height = 0;
            /**
             * Gets the depth of the texture
             */
            this.depth = 0;
            /**
             * Gets the initial width of the texture (It could be rescaled if the current system does not support non power of two textures)
             */
            this.baseWidth = 0;
            /**
             * Gets the initial height of the texture (It could be rescaled if the current system does not support non power of two textures)
             */
            this.baseHeight = 0;
            /**
             * Gets the initial depth of the texture (It could be rescaled if the current system does not support non power of two textures)
             */
            this.baseDepth = 0;
            /**
             * Gets a boolean indicating if the texture is inverted on Y axis
             */
            this.invertY = false;
            // Private
            /** @internal */
            this._invertVScale = false;
            /** @internal */
            this._associatedChannel = -1;
            /** @internal */
            this._source = InternalTextureSource.Unknown;
            /** @internal */
            this._buffer = null;
            /** @internal */
            this._bufferView = null;
            /** @internal */
            this._bufferViewArray = null;
            /** @internal */
            this._bufferViewArrayArray = null;
            /** @internal */
            this._size = 0;
            /** @internal */
            this._extension = "";
            /** @internal */
            this._files = null;
            /** @internal */
            this._workingCanvas = null;
            /** @internal */
            this._workingContext = null;
            /** @internal */
            this._cachedCoordinatesMode = null;
            /** @internal */
            this._isDisabled = false;
            /** @internal */
            this._compression = null;
            /** @internal */
            this._sphericalPolynomial = null;
            /** @internal */
            this._sphericalPolynomialPromise = null;
            /** @internal */
            this._sphericalPolynomialComputed = false;
            /** @internal */
            this._lodGenerationScale = 0;
            /** @internal */
            this._lodGenerationOffset = 0;
            /** @internal */
            this._useSRGBBuffer = false;
            // The following three fields helps sharing generated fixed LODs for texture filtering
            // In environment not supporting the textureLOD extension like EDGE. They are for internal use only.
            // They are at the level of the gl texture to benefit from the cache.
            /** @internal */
            this._lodTextureHigh = null;
            /** @internal */
            this._lodTextureMid = null;
            /** @internal */
            this._lodTextureLow = null;
            /** @internal */
            this._isRGBD = false;
            /** @internal */
            this._linearSpecularLOD = false;
            /** @internal */
            this._irradianceTexture = null;
            /** @internal */
            this._hardwareTexture = null;
            /** @internal */
            this._maxLodLevel = null;
            /** @internal */
            this._references = 1;
            /** @internal */
            this._gammaSpace = null;
            this._engine = engine;
            this._source = source;
            this._uniqueId = InternalTexture._Counter++;
            if (!delayAllocation) {
                this._hardwareTexture = engine._createHardwareTexture();
            }
        }
        /**
         * Increments the number of references (ie. the number of Texture that point to it)
         */
        incrementReferences() {
            this._references++;
        }
        /**
         * Change the size of the texture (not the size of the content)
         * @param width defines the new width
         * @param height defines the new height
         * @param depth defines the new depth (1 by default)
         */
        updateSize(width, height, depth = 1) {
            this._engine.updateTextureDimensions(this, width, height, depth);
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.baseWidth = width;
            this.baseHeight = height;
            this.baseDepth = depth;
            this._size = width * height * depth;
        }
        /** @internal */
        _rebuild() {
            var _a;
            this.isReady = false;
            this._cachedCoordinatesMode = null;
            this._cachedWrapU = null;
            this._cachedWrapV = null;
            this._cachedWrapR = null;
            this._cachedAnisotropicFilteringLevel = null;
            if (this.onRebuildCallback) {
                const data = this.onRebuildCallback(this);
                const swapAndSetIsReady = (proxyInternalTexture) => {
                    proxyInternalTexture._swapAndDie(this, false);
                    this.isReady = data.isReady;
                };
                if (data.isAsync) {
                    data.proxy.then(swapAndSetIsReady);
                }
                else {
                    swapAndSetIsReady(data.proxy);
                }
                return;
            }
            let proxy;
            switch (this.source) {
                case InternalTextureSource.Temp:
                    break;
                case InternalTextureSource.Url:
                    proxy = this._engine.createTexture((_a = this._originalUrl) !== null && _a !== void 0 ? _a : this.url, !this.generateMipMaps, this.invertY, null, this.samplingMode, 
                    // Do not use Proxy here as it could be fully synchronous
                    // and proxy would be undefined.
                    (temp) => {
                        temp._swapAndDie(this, false);
                        this.isReady = true;
                    }, null, this._buffer, undefined, this.format, this._extension, undefined, undefined, undefined, this._useSRGBBuffer);
                    return;
                case InternalTextureSource.Raw:
                    proxy = this._engine.createRawTexture(this._bufferView, this.baseWidth, this.baseHeight, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type, undefined, this._useSRGBBuffer);
                    proxy._swapAndDie(this, false);
                    this.isReady = true;
                    break;
                case InternalTextureSource.Raw3D:
                    proxy = this._engine.createRawTexture3D(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
                    proxy._swapAndDie(this, false);
                    this.isReady = true;
                    break;
                case InternalTextureSource.Raw2DArray:
                    proxy = this._engine.createRawTexture2DArray(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
                    proxy._swapAndDie(this, false);
                    this.isReady = true;
                    break;
                case InternalTextureSource.Dynamic:
                    proxy = this._engine.createDynamicTexture(this.baseWidth, this.baseHeight, this.generateMipMaps, this.samplingMode);
                    proxy._swapAndDie(this, false);
                    this._engine.updateDynamicTexture(this, this._engine.getRenderingCanvas(), this.invertY, undefined, undefined, true);
                    // The engine will make sure to update content so no need to flag it as isReady = true
                    break;
                case InternalTextureSource.Cube:
                    proxy = this._engine.createCubeTexture(this.url, null, this._files, !this.generateMipMaps, () => {
                        proxy._swapAndDie(this, false);
                        this.isReady = true;
                    }, null, this.format, this._extension, false, 0, 0, null, undefined, this._useSRGBBuffer);
                    return;
                case InternalTextureSource.CubeRaw:
                    proxy = this._engine.createRawCubeTexture(this._bufferViewArray, this.width, this.format, this.type, this.generateMipMaps, this.invertY, this.samplingMode, this._compression);
                    proxy._swapAndDie(this, false);
                    this.isReady = true;
                    break;
                case InternalTextureSource.CubeRawRGBD:
                    // This case is being handeled by the environment texture tools and is not a part of the rebuild process.
                    // To use CubeRawRGBD use updateRGBDAsync on the cube texture.
                    return;
                case InternalTextureSource.CubePrefiltered:
                    proxy = this._engine.createPrefilteredCubeTexture(this.url, null, this._lodGenerationScale, this._lodGenerationOffset, (proxy) => {
                        if (proxy) {
                            proxy._swapAndDie(this, false);
                        }
                        this.isReady = true;
                    }, null, this.format, this._extension);
                    proxy._sphericalPolynomial = this._sphericalPolynomial;
                    return;
            }
        }
        /**
         * @internal
         */
        _swapAndDie(target, swapAll = true) {
            // TODO what about refcount on target?
            var _a;
            (_a = this._hardwareTexture) === null || _a === void 0 ? void 0 : _a.setUsage(target._source, this.generateMipMaps, this.isCube, this.width, this.height);
            target._hardwareTexture = this._hardwareTexture;
            if (swapAll) {
                target._isRGBD = this._isRGBD;
            }
            if (this._lodTextureHigh) {
                if (target._lodTextureHigh) {
                    target._lodTextureHigh.dispose();
                }
                target._lodTextureHigh = this._lodTextureHigh;
            }
            if (this._lodTextureMid) {
                if (target._lodTextureMid) {
                    target._lodTextureMid.dispose();
                }
                target._lodTextureMid = this._lodTextureMid;
            }
            if (this._lodTextureLow) {
                if (target._lodTextureLow) {
                    target._lodTextureLow.dispose();
                }
                target._lodTextureLow = this._lodTextureLow;
            }
            if (this._irradianceTexture) {
                if (target._irradianceTexture) {
                    target._irradianceTexture.dispose();
                }
                target._irradianceTexture = this._irradianceTexture;
            }
            const cache = this._engine.getLoadedTexturesCache();
            let index = cache.indexOf(this);
            if (index !== -1) {
                cache.splice(index, 1);
            }
            index = cache.indexOf(target);
            if (index === -1) {
                cache.push(target);
            }
        }
        /**
         * Dispose the current allocated resources
         */
        dispose() {
            this._references--;
            this.onLoadedObservable.clear();
            this.onErrorObservable.clear();
            if (this._references === 0) {
                this._engine._releaseTexture(this);
                this._hardwareTexture = null;
            }
        }
    }
    /** @internal */
    InternalTexture._Counter = 0;

    /** @internal */
    class WebGLShaderProcessor {
        constructor() {
            this.shaderLanguage = ShaderLanguage.GLSL;
        }
        postProcessor(code, defines, isFragment, processingContext, engine) {
            // Remove extensions
            if (!engine.getCaps().drawBuffersExtension) {
                // even if enclosed in #if/#endif, IE11 does parse the #extension declaration, so we need to remove it altogether
                const regex = /#extension.+GL_EXT_draw_buffers.+(enable|require)/g;
                code = code.replace(regex, "");
            }
            return code;
        }
    }

    const varyingRegex = /(flat\s)?\s*varying\s*.*/;
    /** @internal */
    class WebGL2ShaderProcessor {
        constructor() {
            this.shaderLanguage = ShaderLanguage.GLSL;
        }
        attributeProcessor(attribute) {
            return attribute.replace("attribute", "in");
        }
        varyingCheck(varying, _isFragment) {
            return varyingRegex.test(varying);
        }
        varyingProcessor(varying, isFragment) {
            return varying.replace("varying", isFragment ? "in" : "out");
        }
        postProcessor(code, defines, isFragment) {
            const hasDrawBuffersExtension = code.search(/#extension.+GL_EXT_draw_buffers.+require/) !== -1;
            // Remove extensions
            const regex = /#extension.+(GL_OVR_multiview2|GL_OES_standard_derivatives|GL_EXT_shader_texture_lod|GL_EXT_frag_depth|GL_EXT_draw_buffers).+(enable|require)/g;
            code = code.replace(regex, "");
            // Replace instructions
            code = code.replace(/texture2D\s*\(/g, "texture(");
            if (isFragment) {
                const hasOutput = code.search(/layout *\(location *= *0\) *out/g) !== -1;
                code = code.replace(/texture2DLodEXT\s*\(/g, "textureLod(");
                code = code.replace(/textureCubeLodEXT\s*\(/g, "textureLod(");
                code = code.replace(/textureCube\s*\(/g, "texture(");
                code = code.replace(/gl_FragDepthEXT/g, "gl_FragDepth");
                code = code.replace(/gl_FragColor/g, "glFragColor");
                code = code.replace(/gl_FragData/g, "glFragData");
                code = code.replace(/void\s+?main\s*\(/g, (hasDrawBuffersExtension || hasOutput ? "" : "layout(location = 0) out vec4 glFragColor;\n") + "void main(");
            }
            else {
                const hasMultiviewExtension = defines.indexOf("#define MULTIVIEW") !== -1;
                if (hasMultiviewExtension) {
                    return "#extension GL_OVR_multiview2 : require\nlayout (num_views = 2) in;\n" + code;
                }
            }
            return code;
        }
    }

    /**
     * Class used to store gfx data (like WebGLBuffer)
     */
    class DataBuffer {
        /**
         * Gets the underlying buffer
         */
        get underlyingResource() {
            return null;
        }
        /**
         * Constructs the buffer
         */
        constructor() {
            /**
             * Gets or sets the number of objects referencing this buffer
             */
            this.references = 0;
            /** Gets or sets the size of the underlying buffer */
            this.capacity = 0;
            /**
             * Gets or sets a boolean indicating if the buffer contains 32bits indices
             */
            this.is32Bits = false;
            this.uniqueId = DataBuffer._Counter++;
        }
    }
    DataBuffer._Counter = 0;

    /** @internal */
    class WebGLDataBuffer extends DataBuffer {
        constructor(resource) {
            super();
            this._buffer = resource;
        }
        get underlyingResource() {
            return this._buffer;
        }
    }

    /** @internal */
    class WebGLPipelineContext {
        constructor() {
            this._valueCache = {};
            this.vertexCompilationError = null;
            this.fragmentCompilationError = null;
            this.programLinkError = null;
            this.programValidationError = null;
            /** @internal */
            this._isDisposed = false;
        }
        get isAsync() {
            return this.isParallelCompiled;
        }
        get isReady() {
            if (this.program) {
                if (this.isParallelCompiled) {
                    return this.engine._isRenderingStateCompiled(this);
                }
                return true;
            }
            return false;
        }
        _handlesSpectorRebuildCallback(onCompiled) {
            if (onCompiled && this.program) {
                onCompiled(this.program);
            }
        }
        _fillEffectInformation(effect, uniformBuffersNames, uniformsNames, uniforms, samplerList, samplers, attributesNames, attributes) {
            const engine = this.engine;
            if (engine.supportsUniformBuffers) {
                for (const name in uniformBuffersNames) {
                    effect.bindUniformBlock(name, uniformBuffersNames[name]);
                }
            }
            const effectAvailableUniforms = this.engine.getUniforms(this, uniformsNames);
            effectAvailableUniforms.forEach((uniform, index) => {
                uniforms[uniformsNames[index]] = uniform;
            });
            this._uniforms = uniforms;
            let index;
            for (index = 0; index < samplerList.length; index++) {
                const sampler = effect.getUniform(samplerList[index]);
                if (sampler == null) {
                    samplerList.splice(index, 1);
                    index--;
                }
            }
            samplerList.forEach((name, index) => {
                samplers[name] = index;
            });
            for (const attr of engine.getAttributes(this, attributesNames)) {
                attributes.push(attr);
            }
        }
        /**
         * Release all associated resources.
         **/
        dispose() {
            this._uniforms = {};
            this._isDisposed = true;
        }
        /**
         * @internal
         */
        _cacheMatrix(uniformName, matrix) {
            const cache = this._valueCache[uniformName];
            const flag = matrix.updateFlag;
            if (cache !== undefined && cache === flag) {
                return false;
            }
            this._valueCache[uniformName] = flag;
            return true;
        }
        /**
         * @internal
         */
        _cacheFloat2(uniformName, x, y) {
            let cache = this._valueCache[uniformName];
            if (!cache || cache.length !== 2) {
                cache = [x, y];
                this._valueCache[uniformName] = cache;
                return true;
            }
            let changed = false;
            if (cache[0] !== x) {
                cache[0] = x;
                changed = true;
            }
            if (cache[1] !== y) {
                cache[1] = y;
                changed = true;
            }
            return changed;
        }
        /**
         * @internal
         */
        _cacheFloat3(uniformName, x, y, z) {
            let cache = this._valueCache[uniformName];
            if (!cache || cache.length !== 3) {
                cache = [x, y, z];
                this._valueCache[uniformName] = cache;
                return true;
            }
            let changed = false;
            if (cache[0] !== x) {
                cache[0] = x;
                changed = true;
            }
            if (cache[1] !== y) {
                cache[1] = y;
                changed = true;
            }
            if (cache[2] !== z) {
                cache[2] = z;
                changed = true;
            }
            return changed;
        }
        /**
         * @internal
         */
        _cacheFloat4(uniformName, x, y, z, w) {
            let cache = this._valueCache[uniformName];
            if (!cache || cache.length !== 4) {
                cache = [x, y, z, w];
                this._valueCache[uniformName] = cache;
                return true;
            }
            let changed = false;
            if (cache[0] !== x) {
                cache[0] = x;
                changed = true;
            }
            if (cache[1] !== y) {
                cache[1] = y;
                changed = true;
            }
            if (cache[2] !== z) {
                cache[2] = z;
                changed = true;
            }
            if (cache[3] !== w) {
                cache[3] = w;
                changed = true;
            }
            return changed;
        }
        /**
         * Sets an integer value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param value Value to be set.
         */
        setInt(uniformName, value) {
            const cache = this._valueCache[uniformName];
            if (cache !== undefined && cache === value) {
                return;
            }
            if (this.engine.setInt(this._uniforms[uniformName], value)) {
                this._valueCache[uniformName] = value;
            }
        }
        /**
         * Sets a int2 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First int in int2.
         * @param y Second int in int2.
         */
        setInt2(uniformName, x, y) {
            if (this._cacheFloat2(uniformName, x, y)) {
                if (!this.engine.setInt2(this._uniforms[uniformName], x, y)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a int3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First int in int3.
         * @param y Second int in int3.
         * @param z Third int in int3.
         */
        setInt3(uniformName, x, y, z) {
            if (this._cacheFloat3(uniformName, x, y, z)) {
                if (!this.engine.setInt3(this._uniforms[uniformName], x, y, z)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a int4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First int in int4.
         * @param y Second int in int4.
         * @param z Third int in int4.
         * @param w Fourth int in int4.
         */
        setInt4(uniformName, x, y, z, w) {
            if (this._cacheFloat4(uniformName, x, y, z, w)) {
                if (!this.engine.setInt4(this._uniforms[uniformName], x, y, z, w)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets an int array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setIntArray(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setIntArray(this._uniforms[uniformName], array);
        }
        /**
         * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setIntArray2(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setIntArray2(this._uniforms[uniformName], array);
        }
        /**
         * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setIntArray3(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setIntArray3(this._uniforms[uniformName], array);
        }
        /**
         * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setIntArray4(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setIntArray4(this._uniforms[uniformName], array);
        }
        /**
         * Sets an unsigned integer value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param value Value to be set.
         */
        setUInt(uniformName, value) {
            const cache = this._valueCache[uniformName];
            if (cache !== undefined && cache === value) {
                return;
            }
            if (this.engine.setUInt(this._uniforms[uniformName], value)) {
                this._valueCache[uniformName] = value;
            }
        }
        /**
         * Sets an unsigned int2 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First unsigned int in uint2.
         * @param y Second unsigned int in uint2.
         */
        setUInt2(uniformName, x, y) {
            if (this._cacheFloat2(uniformName, x, y)) {
                if (!this.engine.setUInt2(this._uniforms[uniformName], x, y)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets an unsigned int3 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First unsigned int in uint3.
         * @param y Second unsigned int in uint3.
         * @param z Third unsigned int in uint3.
         */
        setUInt3(uniformName, x, y, z) {
            if (this._cacheFloat3(uniformName, x, y, z)) {
                if (!this.engine.setUInt3(this._uniforms[uniformName], x, y, z)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets an unsigned int4 value on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First unsigned int in uint4.
         * @param y Second unsigned int in uint4.
         * @param z Third unsigned int in uint4.
         * @param w Fourth unsigned int in uint4.
         */
        setUInt4(uniformName, x, y, z, w) {
            if (this._cacheFloat4(uniformName, x, y, z, w)) {
                if (!this.engine.setUInt4(this._uniforms[uniformName], x, y, z, w)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets an unsigned int array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setUIntArray(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setUIntArray(this._uniforms[uniformName], array);
        }
        /**
         * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setUIntArray2(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setUIntArray2(this._uniforms[uniformName], array);
        }
        /**
         * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setUIntArray3(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setUIntArray3(this._uniforms[uniformName], array);
        }
        /**
         * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setUIntArray4(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setUIntArray4(this._uniforms[uniformName], array);
        }
        /**
         * Sets an array on a uniform variable.
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setArray(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setArray(this._uniforms[uniformName], array);
        }
        /**
         * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setArray2(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setArray2(this._uniforms[uniformName], array);
        }
        /**
         * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         * @returns this effect.
         */
        setArray3(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setArray3(this._uniforms[uniformName], array);
        }
        /**
         * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
         * @param uniformName Name of the variable.
         * @param array array to be set.
         */
        setArray4(uniformName, array) {
            this._valueCache[uniformName] = null;
            this.engine.setArray4(this._uniforms[uniformName], array);
        }
        /**
         * Sets matrices on a uniform variable.
         * @param uniformName Name of the variable.
         * @param matrices matrices to be set.
         */
        setMatrices(uniformName, matrices) {
            if (!matrices) {
                return;
            }
            this._valueCache[uniformName] = null;
            this.engine.setMatrices(this._uniforms[uniformName], matrices);
        }
        /**
         * Sets matrix on a uniform variable.
         * @param uniformName Name of the variable.
         * @param matrix matrix to be set.
         */
        setMatrix(uniformName, matrix) {
            if (this._cacheMatrix(uniformName, matrix)) {
                if (!this.engine.setMatrices(this._uniforms[uniformName], matrix.toArray())) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
         * @param uniformName Name of the variable.
         * @param matrix matrix to be set.
         */
        setMatrix3x3(uniformName, matrix) {
            this._valueCache[uniformName] = null;
            this.engine.setMatrix3x3(this._uniforms[uniformName], matrix);
        }
        /**
         * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
         * @param uniformName Name of the variable.
         * @param matrix matrix to be set.
         */
        setMatrix2x2(uniformName, matrix) {
            this._valueCache[uniformName] = null;
            this.engine.setMatrix2x2(this._uniforms[uniformName], matrix);
        }
        /**
         * Sets a float on a uniform variable.
         * @param uniformName Name of the variable.
         * @param value value to be set.
         * @returns this effect.
         */
        setFloat(uniformName, value) {
            const cache = this._valueCache[uniformName];
            if (cache !== undefined && cache === value) {
                return;
            }
            if (this.engine.setFloat(this._uniforms[uniformName], value)) {
                this._valueCache[uniformName] = value;
            }
        }
        /**
         * Sets a Vector2 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param vector2 vector2 to be set.
         */
        setVector2(uniformName, vector2) {
            if (this._cacheFloat2(uniformName, vector2.x, vector2.y)) {
                if (!this.engine.setFloat2(this._uniforms[uniformName], vector2.x, vector2.y)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a float2 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First float in float2.
         * @param y Second float in float2.
         */
        setFloat2(uniformName, x, y) {
            if (this._cacheFloat2(uniformName, x, y)) {
                if (!this.engine.setFloat2(this._uniforms[uniformName], x, y)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a Vector3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param vector3 Value to be set.
         */
        setVector3(uniformName, vector3) {
            if (this._cacheFloat3(uniformName, vector3.x, vector3.y, vector3.z)) {
                if (!this.engine.setFloat3(this._uniforms[uniformName], vector3.x, vector3.y, vector3.z)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a float3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First float in float3.
         * @param y Second float in float3.
         * @param z Third float in float3.
         */
        setFloat3(uniformName, x, y, z) {
            if (this._cacheFloat3(uniformName, x, y, z)) {
                if (!this.engine.setFloat3(this._uniforms[uniformName], x, y, z)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a Vector4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param vector4 Value to be set.
         */
        setVector4(uniformName, vector4) {
            if (this._cacheFloat4(uniformName, vector4.x, vector4.y, vector4.z, vector4.w)) {
                if (!this.engine.setFloat4(this._uniforms[uniformName], vector4.x, vector4.y, vector4.z, vector4.w)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a Quaternion on a uniform variable.
         * @param uniformName Name of the variable.
         * @param quaternion Value to be set.
         */
        setQuaternion(uniformName, quaternion) {
            if (this._cacheFloat4(uniformName, quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
                if (!this.engine.setFloat4(this._uniforms[uniformName], quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a float4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param x First float in float4.
         * @param y Second float in float4.
         * @param z Third float in float4.
         * @param w Fourth float in float4.
         * @returns this effect.
         */
        setFloat4(uniformName, x, y, z, w) {
            if (this._cacheFloat4(uniformName, x, y, z, w)) {
                if (!this.engine.setFloat4(this._uniforms[uniformName], x, y, z, w)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a Color3 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param color3 Value to be set.
         */
        setColor3(uniformName, color3) {
            if (this._cacheFloat3(uniformName, color3.r, color3.g, color3.b)) {
                if (!this.engine.setFloat3(this._uniforms[uniformName], color3.r, color3.g, color3.b)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a Color4 on a uniform variable.
         * @param uniformName Name of the variable.
         * @param color3 Value to be set.
         * @param alpha Alpha value to be set.
         */
        setColor4(uniformName, color3, alpha) {
            if (this._cacheFloat4(uniformName, color3.r, color3.g, color3.b, alpha)) {
                if (!this.engine.setFloat4(this._uniforms[uniformName], color3.r, color3.g, color3.b, alpha)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        /**
         * Sets a Color4 on a uniform variable
         * @param uniformName defines the name of the variable
         * @param color4 defines the value to be set
         */
        setDirectColor4(uniformName, color4) {
            if (this._cacheFloat4(uniformName, color4.r, color4.g, color4.b, color4.a)) {
                if (!this.engine.setFloat4(this._uniforms[uniformName], color4.r, color4.g, color4.b, color4.a)) {
                    this._valueCache[uniformName] = null;
                }
            }
        }
        _getVertexShaderCode() {
            return this.vertexShader ? this.engine._getShaderSource(this.vertexShader) : null;
        }
        _getFragmentShaderCode() {
            return this.fragmentShader ? this.engine._getShaderSource(this.fragmentShader) : null;
        }
    }

    /** @internal */
    class WebGLHardwareTexture {
        get underlyingResource() {
            return this._webGLTexture;
        }
        constructor(existingTexture = null, context) {
            // There can be multiple buffers for a single WebGL texture because different layers of a 2DArrayTexture / 3DTexture
            // or different faces of a cube texture can be bound to different render targets at the same time.
            this._MSAARenderBuffers = null;
            this._context = context;
            if (!existingTexture) {
                existingTexture = context.createTexture();
                if (!existingTexture) {
                    throw new Error("Unable to create webGL texture");
                }
            }
            this.set(existingTexture);
        }
        setUsage() { }
        set(hardwareTexture) {
            this._webGLTexture = hardwareTexture;
        }
        reset() {
            this._webGLTexture = null;
            this._MSAARenderBuffers = null;
        }
        addMSAARenderBuffer(buffer) {
            if (!this._MSAARenderBuffers) {
                this._MSAARenderBuffers = [];
            }
            this._MSAARenderBuffers.push(buffer);
        }
        releaseMSAARenderBuffers() {
            if (this._MSAARenderBuffers) {
                for (const buffer of this._MSAARenderBuffers) {
                    this._context.deleteRenderbuffer(buffer);
                }
                this._MSAARenderBuffers = null;
            }
        }
        release() {
            this.releaseMSAARenderBuffers();
            if (this._webGLTexture) {
                this._context.deleteTexture(this._webGLTexture);
            }
            this.reset();
        }
    }

    /** @internal */
    class DrawWrapper {
        static IsWrapper(effect) {
            return effect.getPipelineContext === undefined;
        }
        static GetEffect(effect) {
            return effect.getPipelineContext === undefined ? effect.effect : effect;
        }
        constructor(engine, createMaterialContext = true) {
            this.effect = null;
            this.defines = null;
            this.drawContext = engine.createDrawContext();
            if (createMaterialContext) {
                this.materialContext = engine.createMaterialContext();
            }
        }
        setEffect(effect, defines, resetContext = true) {
            var _a;
            this.effect = effect;
            if (defines !== undefined) {
                this.defines = defines;
            }
            if (resetContext) {
                (_a = this.drawContext) === null || _a === void 0 ? void 0 : _a.reset();
            }
        }
        dispose() {
            var _a;
            (_a = this.drawContext) === null || _a === void 0 ? void 0 : _a.dispose();
        }
    }

    /**
     * @internal
     **/
    class StencilStateComposer {
        get isDirty() {
            return this._isStencilTestDirty || this._isStencilMaskDirty || this._isStencilFuncDirty || this._isStencilOpDirty;
        }
        get func() {
            return this._func;
        }
        set func(value) {
            if (this._func === value) {
                return;
            }
            this._func = value;
            this._isStencilFuncDirty = true;
        }
        get funcRef() {
            return this._funcRef;
        }
        set funcRef(value) {
            if (this._funcRef === value) {
                return;
            }
            this._funcRef = value;
            this._isStencilFuncDirty = true;
        }
        get funcMask() {
            return this._funcMask;
        }
        set funcMask(value) {
            if (this._funcMask === value) {
                return;
            }
            this._funcMask = value;
            this._isStencilFuncDirty = true;
        }
        get opStencilFail() {
            return this._opStencilFail;
        }
        set opStencilFail(value) {
            if (this._opStencilFail === value) {
                return;
            }
            this._opStencilFail = value;
            this._isStencilOpDirty = true;
        }
        get opDepthFail() {
            return this._opDepthFail;
        }
        set opDepthFail(value) {
            if (this._opDepthFail === value) {
                return;
            }
            this._opDepthFail = value;
            this._isStencilOpDirty = true;
        }
        get opStencilDepthPass() {
            return this._opStencilDepthPass;
        }
        set opStencilDepthPass(value) {
            if (this._opStencilDepthPass === value) {
                return;
            }
            this._opStencilDepthPass = value;
            this._isStencilOpDirty = true;
        }
        get mask() {
            return this._mask;
        }
        set mask(value) {
            if (this._mask === value) {
                return;
            }
            this._mask = value;
            this._isStencilMaskDirty = true;
        }
        get enabled() {
            return this._enabled;
        }
        set enabled(value) {
            if (this._enabled === value) {
                return;
            }
            this._enabled = value;
            this._isStencilTestDirty = true;
        }
        constructor(reset = true) {
            this._isStencilTestDirty = false;
            this._isStencilMaskDirty = false;
            this._isStencilFuncDirty = false;
            this._isStencilOpDirty = false;
            this.useStencilGlobalOnly = false;
            if (reset) {
                this.reset();
            }
        }
        reset() {
            var _a;
            this.stencilMaterial = undefined;
            (_a = this.stencilGlobal) === null || _a === void 0 ? void 0 : _a.reset();
            this._isStencilTestDirty = true;
            this._isStencilMaskDirty = true;
            this._isStencilFuncDirty = true;
            this._isStencilOpDirty = true;
        }
        apply(gl) {
            var _a;
            if (!gl) {
                return;
            }
            const stencilMaterialEnabled = !this.useStencilGlobalOnly && !!((_a = this.stencilMaterial) === null || _a === void 0 ? void 0 : _a.enabled);
            this.enabled = stencilMaterialEnabled ? this.stencilMaterial.enabled : this.stencilGlobal.enabled;
            this.func = stencilMaterialEnabled ? this.stencilMaterial.func : this.stencilGlobal.func;
            this.funcRef = stencilMaterialEnabled ? this.stencilMaterial.funcRef : this.stencilGlobal.funcRef;
            this.funcMask = stencilMaterialEnabled ? this.stencilMaterial.funcMask : this.stencilGlobal.funcMask;
            this.opStencilFail = stencilMaterialEnabled ? this.stencilMaterial.opStencilFail : this.stencilGlobal.opStencilFail;
            this.opDepthFail = stencilMaterialEnabled ? this.stencilMaterial.opDepthFail : this.stencilGlobal.opDepthFail;
            this.opStencilDepthPass = stencilMaterialEnabled ? this.stencilMaterial.opStencilDepthPass : this.stencilGlobal.opStencilDepthPass;
            this.mask = stencilMaterialEnabled ? this.stencilMaterial.mask : this.stencilGlobal.mask;
            if (!this.isDirty) {
                return;
            }
            // Stencil test
            if (this._isStencilTestDirty) {
                if (this.enabled) {
                    gl.enable(gl.STENCIL_TEST);
                }
                else {
                    gl.disable(gl.STENCIL_TEST);
                }
                this._isStencilTestDirty = false;
            }
            // Stencil mask
            if (this._isStencilMaskDirty) {
                gl.stencilMask(this.mask);
                this._isStencilMaskDirty = false;
            }
            // Stencil func
            if (this._isStencilFuncDirty) {
                gl.stencilFunc(this.func, this.funcRef, this.funcMask);
                this._isStencilFuncDirty = false;
            }
            // Stencil op
            if (this._isStencilOpDirty) {
                gl.stencilOp(this.opStencilFail, this.opDepthFail, this.opStencilDepthPass);
                this._isStencilOpDirty = false;
            }
        }
    }

    /* eslint-disable @typescript-eslint/no-unused-vars */
    /**
     * Keeps track of all the buffer info used in engine.
     */
    class BufferPointer {
    }
    /**
     * The base engine class (root of all engines)
     */
    class ThinEngine {
        /**
         * Returns the current npm package of the sdk
         */
        // Not mixed with Version for tooling purpose.
        static get NpmPackage() {
            return "babylonjs@6.15.0";
        }
        /**
         * Returns the current version of the framework
         */
        static get Version() {
            return "6.15.0";
        }
        /**
         * Returns a string describing the current engine
         */
        get description() {
            let description = this.name + this.webGLVersion;
            if (this._caps.parallelShaderCompile) {
                description += " - Parallel shader compilation";
            }
            return description;
        }
        /**
         * Gets or sets the name of the engine
         */
        get name() {
            return this._name;
        }
        set name(value) {
            this._name = value;
        }
        /**
         * Returns the version of the engine
         */
        get version() {
            return this._webGLVersion;
        }
        get isDisposed() {
            return this._isDisposed;
        }
        /**
         * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
         */
        static get ShadersRepository() {
            return Effect.ShadersRepository;
        }
        static set ShadersRepository(value) {
            Effect.ShadersRepository = value;
        }
        /**
         * @internal
         */
        _getShaderProcessor(shaderLanguage) {
            return this._shaderProcessor;
        }
        /**
         * Gets or sets a boolean indicating if depth buffer should be reverse, going from far to near.
         * This can provide greater z depth for distant objects.
         */
        get useReverseDepthBuffer() {
            return this._useReverseDepthBuffer;
        }
        set useReverseDepthBuffer(useReverse) {
            if (useReverse === this._useReverseDepthBuffer) {
                return;
            }
            this._useReverseDepthBuffer = useReverse;
            if (useReverse) {
                this._depthCullingState.depthFunc = 518;
            }
            else {
                this._depthCullingState.depthFunc = 515;
            }
        }
        /**
         * Gets the current frame id
         */
        get frameId() {
            return this._frameId;
        }
        /**
         * Gets a boolean indicating that the engine supports uniform buffers
         * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
         */
        get supportsUniformBuffers() {
            return this.webGLVersion > 1 && !this.disableUniformBuffers;
        }
        /**
         * Gets the options used for engine creation
         * @returns EngineOptions object
         */
        getCreationOptions() {
            return this._creationOptions;
        }
        /** @internal */
        get _shouldUseHighPrecisionShader() {
            return !!(this._caps.highPrecisionShaderSupported && this._highPrecisionShadersAllowed);
        }
        /**
         * Gets a boolean indicating that only power of 2 textures are supported
         * Please note that you can still use non power of 2 textures but in this case the engine will forcefully convert them
         */
        get needPOTTextures() {
            return this._webGLVersion < 2 || this.forcePOTTextures;
        }
        /**
         * Gets the list of current active render loop functions
         * @returns an array with the current render loop functions
         */
        get activeRenderLoops() {
            return this._activeRenderLoops;
        }
        /**
         * Gets or sets a boolean indicating if resources should be retained to be able to handle context lost events
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#handling-webgl-context-lost
         */
        get doNotHandleContextLost() {
            return this._doNotHandleContextLost;
        }
        set doNotHandleContextLost(value) {
            this._doNotHandleContextLost = value;
        }
        get _supportsHardwareTextureRescaling() {
            return false;
        }
        /**
         * sets the object from which width and height will be taken from when getting render width and height
         * Will fallback to the gl object
         * @param dimensions the framebuffer width and height that will be used.
         */
        set framebufferDimensionsObject(dimensions) {
            this._framebufferDimensionsObject = dimensions;
        }
        /**
         * Gets the current viewport
         */
        get currentViewport() {
            return this._cachedViewport;
        }
        /**
         * Gets the default empty texture
         */
        get emptyTexture() {
            if (!this._emptyTexture) {
                this._emptyTexture = this.createRawTexture(new Uint8Array(4), 1, 1, 5, false, false, 1);
            }
            return this._emptyTexture;
        }
        /**
         * Gets the default empty 3D texture
         */
        get emptyTexture3D() {
            if (!this._emptyTexture3D) {
                this._emptyTexture3D = this.createRawTexture3D(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
            }
            return this._emptyTexture3D;
        }
        /**
         * Gets the default empty 2D array texture
         */
        get emptyTexture2DArray() {
            if (!this._emptyTexture2DArray) {
                this._emptyTexture2DArray = this.createRawTexture2DArray(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
            }
            return this._emptyTexture2DArray;
        }
        /**
         * Gets the default empty cube texture
         */
        get emptyCubeTexture() {
            if (!this._emptyCubeTexture) {
                const faceData = new Uint8Array(4);
                const cubeData = [faceData, faceData, faceData, faceData, faceData, faceData];
                this._emptyCubeTexture = this.createRawCubeTexture(cubeData, 1, 5, 0, false, false, 1);
            }
            return this._emptyCubeTexture;
        }
        /**
         * Gets a boolean indicating if the engine runs in WebGPU or not.
         */
        get isWebGPU() {
            return this._isWebGPU;
        }
        /**
         * Gets the shader platform name used by the effects.
         */
        get shaderPlatformName() {
            return this._shaderPlatformName;
        }
        /**
         * Enables or disables the snapshot rendering mode
         * Note that the WebGL engine does not support snapshot rendering so setting the value won't have any effect for this engine
         */
        get snapshotRendering() {
            return false;
        }
        set snapshotRendering(activate) {
            // WebGL engine does not support snapshot rendering
        }
        /**
         * Gets or sets the snapshot rendering mode
         */
        get snapshotRenderingMode() {
            return this._snapshotRenderingMode;
        }
        set snapshotRenderingMode(mode) {
            this._snapshotRenderingMode = mode;
        }
        /**
         * Creates a new snapshot at the next frame using the current snapshotRenderingMode
         */
        snapshotRenderingReset() {
            this.snapshotRendering = false;
        }
        static _CreateCanvas(width, height) {
            if (typeof document === "undefined") {
                return new OffscreenCanvas(width, height);
            }
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            return canvas;
        }
        /**
         * Create a canvas. This method is overridden by other engines
         * @param width width
         * @param height height
         * @returns ICanvas interface
         */
        createCanvas(width, height) {
            return ThinEngine._CreateCanvas(width, height);
        }
        /**
         * Create an image to use with canvas
         * @returns IImage interface
         */
        createCanvasImage() {
            return document.createElement("img");
        }
        /**
         * Creates a new engine
         * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
         * @param antialias defines enable antialiasing (default: false)
         * @param options defines further options to be sent to the getContext() function
         * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
         */
        constructor(canvasOrContext, antialias, options, adaptToDeviceRatio) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            /** @internal */
            this._name = "WebGL";
            this._isDisposed = false;
            /**
             * Gets or sets a boolean that indicates if textures must be forced to power of 2 size even if not required
             */
            this.forcePOTTextures = false;
            /**
             * Gets a boolean indicating if the engine is currently rendering in fullscreen mode
             */
            this.isFullscreen = false;
            /**
             * Gets or sets a boolean indicating if back faces must be culled. If false, front faces are culled instead (true by default)
             * If non null, this takes precedence over the value from the material
             */
            this.cullBackFaces = null;
            /**
             * Gets or sets a boolean indicating if the engine must keep rendering even if the window is not in foreground
             */
            this.renderEvenInBackground = true;
            /**
             * Gets or sets a boolean indicating that cache can be kept between frames
             */
            this.preventCacheWipeBetweenFrames = false;
            /** Gets or sets a boolean indicating if the engine should validate programs after compilation */
            this.validateShaderPrograms = false;
            this._useReverseDepthBuffer = false;
            /**
             * Indicates if the z range in NDC space is 0..1 (value: true) or -1..1 (value: false)
             */
            this.isNDCHalfZRange = false;
            /**
             * Indicates that the origin of the texture/framebuffer space is the bottom left corner. If false, the origin is top left
             */
            this.hasOriginBottomLeft = true;
            /**
             * Gets or sets a boolean indicating that uniform buffers must be disabled even if they are supported
             */
            this.disableUniformBuffers = false;
            /**
             * An event triggered when the engine is disposed.
             */
            this.onDisposeObservable = new Observable$1();
            this._frameId = 0;
            /** @internal */
            this._uniformBuffers = new Array();
            /** @internal */
            this._storageBuffers = new Array();
            /** @internal */
            this._webGLVersion = 1.0;
            this._windowIsBackground = false;
            this._highPrecisionShadersAllowed = true;
            /** @internal */
            this._badOS = false;
            /** @internal */
            this._badDesktopOS = false;
            this._renderingQueueLaunched = false;
            this._activeRenderLoops = new Array();
            // Lost context
            /**
             * Observable signaled when a context lost event is raised
             */
            this.onContextLostObservable = new Observable$1();
            /**
             * Observable signaled when a context restored event is raised
             */
            this.onContextRestoredObservable = new Observable$1();
            this._contextWasLost = false;
            /** @internal */
            this._doNotHandleContextLost = false;
            /**
             * Gets or sets a boolean indicating that vertex array object must be disabled even if they are supported
             */
            this.disableVertexArrayObjects = false;
            // States
            /** @internal */
            this._colorWrite = true;
            /** @internal */
            this._colorWriteChanged = true;
            /** @internal */
            this._depthCullingState = new DepthCullingState();
            /** @internal */
            this._stencilStateComposer = new StencilStateComposer();
            /** @internal */
            this._stencilState = new StencilState();
            /** @internal */
            this._alphaState = new AlphaState();
            /** @internal */
            this._alphaMode = 1;
            /** @internal */
            this._alphaEquation = 0;
            // Cache
            /** @internal */
            this._internalTexturesCache = new Array();
            /** @internal */
            this._renderTargetWrapperCache = new Array();
            /** @internal */
            this._activeChannel = 0;
            this._currentTextureChannel = -1;
            /** @internal */
            this._boundTexturesCache = {};
            this._compiledEffects = {};
            this._vertexAttribArraysEnabled = [];
            this._uintIndicesCurrentlySet = false;
            this._currentBoundBuffer = new Array();
            /** @internal */
            this._currentFramebuffer = null;
            /** @internal */
            this._dummyFramebuffer = null;
            this._currentBufferPointers = new Array();
            this._currentInstanceLocations = new Array();
            this._currentInstanceBuffers = new Array();
            this._vaoRecordInProgress = false;
            this._mustWipeVertexAttributes = false;
            this._nextFreeTextureSlots = new Array();
            this._maxSimultaneousTextures = 0;
            this._maxMSAASamplesOverride = null;
            this._activeRequests = new Array();
            /**
             * If set to true zooming in and out in the browser will rescale the hardware-scaling correctly.
             */
            this.adaptToDeviceRatio = false;
            /** @internal */
            this._lastDevicePixelRatio = 1.0;
            /** @internal */
            this._transformTextureUrl = null;
            /**
             * Gets information about the current host
             */
            this.hostInformation = {
                isMobile: false,
            };
            /**
             * Defines whether the engine has been created with the premultipliedAlpha option on or not.
             */
            this.premultipliedAlpha = true;
            /**
             * Observable event triggered before each texture is initialized
             */
            this.onBeforeTextureInitObservable = new Observable$1();
            /** @internal */
            this._isWebGPU = false;
            this._snapshotRenderingMode = 0;
            this._viewportCached = { x: 0, y: 0, z: 0, w: 0 };
            this._unpackFlipYCached = null;
            /**
             * In case you are sharing the context with other applications, it might
             * be interested to not cache the unpack flip y state to ensure a consistent
             * value would be set.
             */
            this.enableUnpackFlipYCached = true;
            this._boundUniforms = {};
            this.startTime = PrecisionDate.Now;
            let canvas = null;
            options = options || {};
            this._creationOptions = options;
            // Save this off for use in resize().
            this.adaptToDeviceRatio = adaptToDeviceRatio !== null && adaptToDeviceRatio !== void 0 ? adaptToDeviceRatio : false;
            this._stencilStateComposer.stencilGlobal = this._stencilState;
            PerformanceConfigurator.SetMatrixPrecision(!!options.useHighPrecisionMatrix);
            options.antialias = antialias !== null && antialias !== void 0 ? antialias : options.antialias;
            options.deterministicLockstep = (_a = options.deterministicLockstep) !== null && _a !== void 0 ? _a : false;
            options.lockstepMaxSteps = (_b = options.lockstepMaxSteps) !== null && _b !== void 0 ? _b : 4;
            options.timeStep = (_c = options.timeStep) !== null && _c !== void 0 ? _c : 1 / 60;
            options.audioEngine = (_d = options.audioEngine) !== null && _d !== void 0 ? _d : true;
            options.stencil = (_e = options.stencil) !== null && _e !== void 0 ? _e : true;
            this._audioContext = (_g = (_f = options.audioEngineOptions) === null || _f === void 0 ? void 0 : _f.audioContext) !== null && _g !== void 0 ? _g : null;
            this._audioDestination = (_j = (_h = options.audioEngineOptions) === null || _h === void 0 ? void 0 : _h.audioDestination) !== null && _j !== void 0 ? _j : null;
            this.premultipliedAlpha = (_k = options.premultipliedAlpha) !== null && _k !== void 0 ? _k : true;
            this.useExactSrgbConversions = (_l = options.useExactSrgbConversions) !== null && _l !== void 0 ? _l : false;
            this._doNotHandleContextLost = !!options.doNotHandleContextLost;
            this._isStencilEnable = options.stencil ? true : false;
            // Viewport
            adaptToDeviceRatio = adaptToDeviceRatio || options.adaptToDeviceRatio || false;
            const devicePixelRatio = IsWindowObjectExist() ? window.devicePixelRatio || 1.0 : 1.0;
            const limitDeviceRatio = options.limitDeviceRatio || devicePixelRatio;
            this._hardwareScalingLevel = adaptToDeviceRatio ? 1.0 / Math.min(limitDeviceRatio, devicePixelRatio) : 1.0;
            this._lastDevicePixelRatio = devicePixelRatio;
            if (!canvasOrContext) {
                return;
            }
            if (canvasOrContext.getContext) {
                canvas = canvasOrContext;
                this._renderingCanvas = canvas;
                if (options.preserveDrawingBuffer === undefined) {
                    options.preserveDrawingBuffer = false;
                }
                if (options.xrCompatible === undefined) {
                    options.xrCompatible = true;
                }
                // Exceptions
                if (navigator && navigator.userAgent) {
                    this._setupMobileChecks();
                    const ua = navigator.userAgent;
                    for (const exception of ThinEngine.ExceptionList) {
                        const key = exception.key;
                        const targets = exception.targets;
                        const check = new RegExp(key);
                        if (check.test(ua)) {
                            if (exception.capture && exception.captureConstraint) {
                                const capture = exception.capture;
                                const constraint = exception.captureConstraint;
                                const regex = new RegExp(capture);
                                const matches = regex.exec(ua);
                                if (matches && matches.length > 0) {
                                    const capturedValue = parseInt(matches[matches.length - 1]);
                                    if (capturedValue >= constraint) {
                                        continue;
                                    }
                                }
                            }
                            for (const target of targets) {
                                switch (target) {
                                    case "uniformBuffer":
                                        this.disableUniformBuffers = true;
                                        break;
                                    case "vao":
                                        this.disableVertexArrayObjects = true;
                                        break;
                                    case "antialias":
                                        options.antialias = false;
                                        break;
                                    case "maxMSAASamples":
                                        this._maxMSAASamplesOverride = 1;
                                        break;
                                }
                            }
                        }
                    }
                }
                // Context lost
                if (!this._doNotHandleContextLost) {
                    this._onContextLost = (evt) => {
                        evt.preventDefault();
                        this._contextWasLost = true;
                        Logger.Warn("WebGL context lost.");
                        this.onContextLostObservable.notifyObservers(this);
                    };
                    this._onContextRestored = () => {
                        this._restoreEngineAfterContextLost(this._initGLContext.bind(this));
                    };
                    canvas.addEventListener("webglcontextlost", this._onContextLost, false);
                    canvas.addEventListener("webglcontextrestored", this._onContextRestored, false);
                    options.powerPreference = options.powerPreference || "high-performance";
                }
                // Detect if we are running on a faulty buggy desktop OS.
                this._badDesktopOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (this._badDesktopOS) {
                    options.xrCompatible = false;
                }
                // GL
                if (!options.disableWebGL2Support) {
                    try {
                        this._gl = (canvas.getContext("webgl2", options) || canvas.getContext("experimental-webgl2", options));
                        if (this._gl) {
                            this._webGLVersion = 2.0;
                            this._shaderPlatformName = "WEBGL2";
                            // Prevent weird browsers to lie (yeah that happens!)
                            if (!this._gl.deleteQuery) {
                                this._webGLVersion = 1.0;
                                this._shaderPlatformName = "WEBGL1";
                            }
                        }
                    }
                    catch (e) {
                        // Do nothing
                    }
                }
                if (!this._gl) {
                    if (!canvas) {
                        throw new Error("The provided canvas is null or undefined.");
                    }
                    try {
                        this._gl = (canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options));
                    }
                    catch (e) {
                        throw new Error("WebGL not supported");
                    }
                }
                if (!this._gl) {
                    throw new Error("WebGL not supported");
                }
            }
            else {
                this._gl = canvasOrContext;
                this._renderingCanvas = this._gl.canvas;
                if (this._gl.renderbufferStorageMultisample) {
                    this._webGLVersion = 2.0;
                    this._shaderPlatformName = "WEBGL2";
                }
                else {
                    this._shaderPlatformName = "WEBGL1";
                }
                const attributes = this._gl.getContextAttributes();
                if (attributes) {
                    options.stencil = attributes.stencil;
                }
            }
            // Ensures a consistent color space unpacking of textures cross browser.
            this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE);
            if (options.useHighPrecisionFloats !== undefined) {
                this._highPrecisionShadersAllowed = options.useHighPrecisionFloats;
            }
            this.resize();
            this._initGLContext();
            this._initFeatures();
            // Prepare buffer pointers
            for (let i = 0; i < this._caps.maxVertexAttribs; i++) {
                this._currentBufferPointers[i] = new BufferPointer();
            }
            // Shader processor
            this._shaderProcessor = this.webGLVersion > 1 ? new WebGL2ShaderProcessor() : new WebGLShaderProcessor();
            // Detect if we are running on a faulty buggy OS.
            this._badOS = /iPad/i.test(navigator.userAgent) || /iPhone/i.test(navigator.userAgent);
            // Starting with iOS 14, we can trust the browser
            // let matches = navigator.userAgent.match(/Version\/(\d+)/);
            // if (matches && matches.length === 2) {
            //     if (parseInt(matches[1]) >= 14) {
            //         this._badOS = false;
            //     }
            // }
            const versionToLog = `Babylon.js v${ThinEngine.Version}`;
            console.log(versionToLog + ` - ${this.description}`);
            // Check setAttribute in case of workers
            if (this._renderingCanvas && this._renderingCanvas.setAttribute) {
                this._renderingCanvas.setAttribute("data-engine", versionToLog);
            }
        }
        _setupMobileChecks() {
            if (!(navigator && navigator.userAgent)) {
                return;
            }
            // Function to check if running on mobile device
            this._checkForMobile = () => {
                const currentUA = navigator.userAgent;
                this.hostInformation.isMobile =
                    currentUA.indexOf("Mobile") !== -1 ||
                        // Needed for iOS 13+ detection on iPad (inspired by solution from https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
                        (currentUA.indexOf("Mac") !== -1 && IsDocumentAvailable() && "ontouchend" in document);
            };
            // Set initial isMobile value
            this._checkForMobile();
            // Set up event listener to check when window is resized (used to get emulator activation to work properly)
            if (IsWindowObjectExist()) {
                window.addEventListener("resize", this._checkForMobile);
            }
        }
        _restoreEngineAfterContextLost(initEngine) {
            // Adding a timeout to avoid race condition at browser level
            setTimeout(async () => {
                var _a;
                this._dummyFramebuffer = null;
                const depthTest = this._depthCullingState.depthTest; // backup those values because the call to initEngine / wipeCaches will reset them
                const depthFunc = this._depthCullingState.depthFunc;
                const depthMask = this._depthCullingState.depthMask;
                const stencilTest = this._stencilState.stencilTest;
                // Rebuild context
                await initEngine();
                // Ensure webgl and engine states are matching
                this.wipeCaches(true);
                // Rebuild effects
                this._rebuildEffects();
                (_a = this._rebuildComputeEffects) === null || _a === void 0 ? void 0 : _a.call(this);
                // Note:
                //  The call to _rebuildBuffers must be made before the call to _rebuildInternalTextures because in the process of _rebuildBuffers the buffers used by the post process managers will be rebuilt
                //  and we may need to use the post process manager of the scene during _rebuildInternalTextures (in WebGL1, non-POT textures are rescaled using a post process + post process manager of the scene)
                // Rebuild buffers
                this._rebuildBuffers();
                // Rebuild textures
                this._rebuildInternalTextures();
                // Rebuild textures
                this._rebuildRenderTargetWrappers();
                // Reset engine states after all the buffer/textures/... have been rebuilt
                this.wipeCaches(true);
                this._depthCullingState.depthTest = depthTest;
                this._depthCullingState.depthFunc = depthFunc;
                this._depthCullingState.depthMask = depthMask;
                this._stencilState.stencilTest = stencilTest;
                Logger.Warn(this.name + " context successfully restored.");
                this.onContextRestoredObservable.notifyObservers(this);
                this._contextWasLost = false;
            }, 0);
        }
        /**
         * Shared initialization across engines types.
         * @param canvas The canvas associated with this instance of the engine.
         */
        _sharedInit(canvas) {
            this._renderingCanvas = canvas;
        }
        /**
         * @internal
         */
        _getShaderProcessingContext(shaderLanguage) {
            return null;
        }
        _rebuildInternalTextures() {
            const currentState = this._internalTexturesCache.slice(); // Do a copy because the rebuild will add proxies
            for (const internalTexture of currentState) {
                internalTexture._rebuild();
            }
        }
        _rebuildRenderTargetWrappers() {
            const currentState = this._renderTargetWrapperCache.slice(); // Do a copy because the rebuild will add proxies
            for (const renderTargetWrapper of currentState) {
                renderTargetWrapper._rebuild();
            }
        }
        _rebuildEffects() {
            for (const key in this._compiledEffects) {
                const effect = this._compiledEffects[key];
                effect._pipelineContext = null; // because _prepareEffect will try to dispose this pipeline before recreating it and that would lead to webgl errors
                effect._wasPreviouslyReady = false;
                effect._prepareEffect();
            }
            Effect.ResetCache();
        }
        /**
         * Gets a boolean indicating if all created effects are ready
         * @returns true if all effects are ready
         */
        areAllEffectsReady() {
            for (const key in this._compiledEffects) {
                const effect = this._compiledEffects[key];
                if (!effect.isReady()) {
                    return false;
                }
            }
            return true;
        }
        _rebuildBuffers() {
            // Uniforms
            for (const uniformBuffer of this._uniformBuffers) {
                uniformBuffer._rebuild();
            }
            // Storage buffers
            for (const storageBuffer of this._storageBuffers) {
                storageBuffer._rebuild();
            }
        }
        _initGLContext() {
            var _a;
            // Caps
            this._caps = {
                maxTexturesImageUnits: this._gl.getParameter(this._gl.MAX_TEXTURE_IMAGE_UNITS),
                maxCombinedTexturesImageUnits: this._gl.getParameter(this._gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                maxVertexTextureImageUnits: this._gl.getParameter(this._gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
                maxTextureSize: this._gl.getParameter(this._gl.MAX_TEXTURE_SIZE),
                maxSamples: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_SAMPLES) : 1,
                maxCubemapTextureSize: this._gl.getParameter(this._gl.MAX_CUBE_MAP_TEXTURE_SIZE),
                maxRenderTextureSize: this._gl.getParameter(this._gl.MAX_RENDERBUFFER_SIZE),
                maxVertexAttribs: this._gl.getParameter(this._gl.MAX_VERTEX_ATTRIBS),
                maxVaryingVectors: this._gl.getParameter(this._gl.MAX_VARYING_VECTORS),
                maxFragmentUniformVectors: this._gl.getParameter(this._gl.MAX_FRAGMENT_UNIFORM_VECTORS),
                maxVertexUniformVectors: this._gl.getParameter(this._gl.MAX_VERTEX_UNIFORM_VECTORS),
                parallelShaderCompile: this._gl.getExtension("KHR_parallel_shader_compile") || undefined,
                standardDerivatives: this._webGLVersion > 1 || this._gl.getExtension("OES_standard_derivatives") !== null,
                maxAnisotropy: 1,
                astc: this._gl.getExtension("WEBGL_compressed_texture_astc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_astc"),
                bptc: this._gl.getExtension("EXT_texture_compression_bptc") || this._gl.getExtension("WEBKIT_EXT_texture_compression_bptc"),
                s3tc: this._gl.getExtension("WEBGL_compressed_texture_s3tc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc"),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                s3tc_srgb: this._gl.getExtension("WEBGL_compressed_texture_s3tc_srgb") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc_srgb"),
                pvrtc: this._gl.getExtension("WEBGL_compressed_texture_pvrtc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
                etc1: this._gl.getExtension("WEBGL_compressed_texture_etc1") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc1"),
                etc2: this._gl.getExtension("WEBGL_compressed_texture_etc") ||
                    this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc") ||
                    this._gl.getExtension("WEBGL_compressed_texture_es3_0"),
                textureAnisotropicFilterExtension: this._gl.getExtension("EXT_texture_filter_anisotropic") ||
                    this._gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic") ||
                    this._gl.getExtension("MOZ_EXT_texture_filter_anisotropic"),
                uintIndices: this._webGLVersion > 1 || this._gl.getExtension("OES_element_index_uint") !== null,
                fragmentDepthSupported: this._webGLVersion > 1 || this._gl.getExtension("EXT_frag_depth") !== null,
                highPrecisionShaderSupported: false,
                timerQuery: this._gl.getExtension("EXT_disjoint_timer_query_webgl2") || this._gl.getExtension("EXT_disjoint_timer_query"),
                supportOcclusionQuery: this._webGLVersion > 1,
                canUseTimestampForTimerQuery: false,
                drawBuffersExtension: false,
                maxMSAASamples: 1,
                colorBufferFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_float")),
                colorBufferHalfFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_half_float")),
                textureFloat: this._webGLVersion > 1 || this._gl.getExtension("OES_texture_float") ? true : false,
                textureHalfFloat: this._webGLVersion > 1 || this._gl.getExtension("OES_texture_half_float") ? true : false,
                textureHalfFloatRender: false,
                textureFloatLinearFiltering: false,
                textureFloatRender: false,
                textureHalfFloatLinearFiltering: false,
                vertexArrayObject: false,
                instancedArrays: false,
                textureLOD: this._webGLVersion > 1 || this._gl.getExtension("EXT_shader_texture_lod") ? true : false,
                texelFetch: this._webGLVersion !== 1,
                blendMinMax: false,
                multiview: this._gl.getExtension("OVR_multiview2"),
                oculusMultiview: this._gl.getExtension("OCULUS_multiview"),
                depthTextureExtension: false,
                canUseGLInstanceID: this._webGLVersion > 1,
                canUseGLVertexID: this._webGLVersion > 1,
                supportComputeShaders: false,
                supportSRGBBuffers: false,
                supportTransformFeedbacks: this._webGLVersion > 1,
                textureMaxLevel: this._webGLVersion > 1,
                texture2DArrayMaxLayerCount: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_ARRAY_TEXTURE_LAYERS) : 128,
                disableMorphTargetTexture: false,
            };
            // Infos
            this._glVersion = this._gl.getParameter(this._gl.VERSION);
            const rendererInfo = this._gl.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo != null) {
                this._glRenderer = this._gl.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL);
                this._glVendor = this._gl.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL);
            }
            if (!this._glVendor) {
                this._glVendor = this._gl.getParameter(this._gl.VENDOR) || "Unknown vendor";
            }
            if (!this._glRenderer) {
                this._glRenderer = this._gl.getParameter(this._gl.RENDERER) || "Unknown renderer";
            }
            // Constants
            if (this._gl.HALF_FLOAT_OES !== 0x8d61) {
                this._gl.HALF_FLOAT_OES = 0x8d61; // Half floating-point type (16-bit).
            }
            if (this._gl.RGBA16F !== 0x881a) {
                this._gl.RGBA16F = 0x881a; // RGBA 16-bit floating-point color-renderable internal sized format.
            }
            if (this._gl.RGBA32F !== 0x8814) {
                this._gl.RGBA32F = 0x8814; // RGBA 32-bit floating-point color-renderable internal sized format.
            }
            if (this._gl.DEPTH24_STENCIL8 !== 35056) {
                this._gl.DEPTH24_STENCIL8 = 35056;
            }
            // Extensions
            if (this._caps.timerQuery) {
                if (this._webGLVersion === 1) {
                    this._gl.getQuery = this._caps.timerQuery.getQueryEXT.bind(this._caps.timerQuery);
                }
                // WebGLQuery casted to number to avoid TS error
                this._caps.canUseTimestampForTimerQuery = ((_a = this._gl.getQuery(this._caps.timerQuery.TIMESTAMP_EXT, this._caps.timerQuery.QUERY_COUNTER_BITS_EXT)) !== null && _a !== void 0 ? _a : 0) > 0;
            }
            this._caps.maxAnisotropy = this._caps.textureAnisotropicFilterExtension
                ? this._gl.getParameter(this._caps.textureAnisotropicFilterExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
                : 0;
            this._caps.textureFloatLinearFiltering = this._caps.textureFloat && this._gl.getExtension("OES_texture_float_linear") ? true : false;
            this._caps.textureFloatRender = this._caps.textureFloat && this._canRenderToFloatFramebuffer() ? true : false;
            this._caps.textureHalfFloatLinearFiltering =
                this._webGLVersion > 1 || (this._caps.textureHalfFloat && this._gl.getExtension("OES_texture_half_float_linear")) ? true : false;
            // Compressed formats
            if (this._caps.astc) {
                this._gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = this._caps.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
            }
            if (this._caps.bptc) {
                this._gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT = this._caps.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
            }
            if (this._caps.s3tc_srgb) {
                this._gl.COMPRESSED_SRGB_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
            }
            if (this._caps.etc2) {
                this._gl.COMPRESSED_SRGB8_ETC2 = this._caps.etc2.COMPRESSED_SRGB8_ETC2;
                this._gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = this._caps.etc2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
            }
            // Checks if some of the format renders first to allow the use of webgl inspector.
            if (this._webGLVersion > 1) {
                if (this._gl.HALF_FLOAT_OES !== 0x140b) {
                    this._gl.HALF_FLOAT_OES = 0x140b;
                }
            }
            this._caps.textureHalfFloatRender = this._caps.textureHalfFloat && this._canRenderToHalfFloatFramebuffer();
            // Draw buffers
            if (this._webGLVersion > 1) {
                this._caps.drawBuffersExtension = true;
                this._caps.maxMSAASamples = this._maxMSAASamplesOverride !== null ? this._maxMSAASamplesOverride : this._gl.getParameter(this._gl.MAX_SAMPLES);
            }
            else {
                const drawBuffersExtension = this._gl.getExtension("WEBGL_draw_buffers");
                if (drawBuffersExtension !== null) {
                    this._caps.drawBuffersExtension = true;
                    this._gl.drawBuffers = drawBuffersExtension.drawBuffersWEBGL.bind(drawBuffersExtension);
                    this._gl.DRAW_FRAMEBUFFER = this._gl.FRAMEBUFFER;
                    for (let i = 0; i < 16; i++) {
                        this._gl["COLOR_ATTACHMENT" + i + "_WEBGL"] = drawBuffersExtension["COLOR_ATTACHMENT" + i + "_WEBGL"];
                    }
                }
            }
            // Depth Texture
            if (this._webGLVersion > 1) {
                this._caps.depthTextureExtension = true;
            }
            else {
                const depthTextureExtension = this._gl.getExtension("WEBGL_depth_texture");
                if (depthTextureExtension != null) {
                    this._caps.depthTextureExtension = true;
                    this._gl.UNSIGNED_INT_24_8 = depthTextureExtension.UNSIGNED_INT_24_8_WEBGL;
                }
            }
            // Vertex array object
            if (this.disableVertexArrayObjects) {
                this._caps.vertexArrayObject = false;
            }
            else if (this._webGLVersion > 1) {
                this._caps.vertexArrayObject = true;
            }
            else {
                const vertexArrayObjectExtension = this._gl.getExtension("OES_vertex_array_object");
                if (vertexArrayObjectExtension != null) {
                    this._caps.vertexArrayObject = true;
                    this._gl.createVertexArray = vertexArrayObjectExtension.createVertexArrayOES.bind(vertexArrayObjectExtension);
                    this._gl.bindVertexArray = vertexArrayObjectExtension.bindVertexArrayOES.bind(vertexArrayObjectExtension);
                    this._gl.deleteVertexArray = vertexArrayObjectExtension.deleteVertexArrayOES.bind(vertexArrayObjectExtension);
                }
            }
            // Instances count
            if (this._webGLVersion > 1) {
                this._caps.instancedArrays = true;
            }
            else {
                const instanceExtension = this._gl.getExtension("ANGLE_instanced_arrays");
                if (instanceExtension != null) {
                    this._caps.instancedArrays = true;
                    this._gl.drawArraysInstanced = instanceExtension.drawArraysInstancedANGLE.bind(instanceExtension);
                    this._gl.drawElementsInstanced = instanceExtension.drawElementsInstancedANGLE.bind(instanceExtension);
                    this._gl.vertexAttribDivisor = instanceExtension.vertexAttribDivisorANGLE.bind(instanceExtension);
                }
                else {
                    this._caps.instancedArrays = false;
                }
            }
            if (this._gl.getShaderPrecisionFormat) {
                const vertexhighp = this._gl.getShaderPrecisionFormat(this._gl.VERTEX_SHADER, this._gl.HIGH_FLOAT);
                const fragmenthighp = this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT);
                if (vertexhighp && fragmenthighp) {
                    this._caps.highPrecisionShaderSupported = vertexhighp.precision !== 0 && fragmenthighp.precision !== 0;
                }
            }
            if (this._webGLVersion > 1) {
                this._caps.blendMinMax = true;
            }
            else {
                const blendMinMaxExtension = this._gl.getExtension("EXT_blend_minmax");
                if (blendMinMaxExtension != null) {
                    this._caps.blendMinMax = true;
                    this._gl.MAX = blendMinMaxExtension.MAX_EXT;
                    this._gl.MIN = blendMinMaxExtension.MIN_EXT;
                }
            }
            // sRGB buffers
            // only run this if not already set to true (in the constructor, for example)
            if (!this._caps.supportSRGBBuffers) {
                if (this._webGLVersion > 1) {
                    this._caps.supportSRGBBuffers = true;
                    this._glSRGBExtensionValues = {
                        SRGB: WebGL2RenderingContext.SRGB,
                        SRGB8: WebGL2RenderingContext.SRGB8,
                        SRGB8_ALPHA8: WebGL2RenderingContext.SRGB8_ALPHA8,
                    };
                }
                else {
                    const sRGBExtension = this._gl.getExtension("EXT_sRGB");
                    if (sRGBExtension != null) {
                        this._caps.supportSRGBBuffers = true;
                        this._glSRGBExtensionValues = {
                            SRGB: sRGBExtension.SRGB_EXT,
                            SRGB8: sRGBExtension.SRGB_ALPHA_EXT,
                            SRGB8_ALPHA8: sRGBExtension.SRGB_ALPHA_EXT,
                        };
                    }
                }
                // take into account the forced state that was provided in options
                // When the issue in angle/chrome is fixed the flag should be taken into account only when it is explicitly defined
                this._caps.supportSRGBBuffers = this._caps.supportSRGBBuffers && !!(this._creationOptions && this._creationOptions.forceSRGBBufferSupportState);
            }
            // Depth buffer
            this._depthCullingState.depthTest = true;
            this._depthCullingState.depthFunc = this._gl.LEQUAL;
            this._depthCullingState.depthMask = true;
            // Texture maps
            this._maxSimultaneousTextures = this._caps.maxCombinedTexturesImageUnits;
            for (let slot = 0; slot < this._maxSimultaneousTextures; slot++) {
                this._nextFreeTextureSlots.push(slot);
            }
            if (this._glRenderer === "Mali-G72") {
                // Overcome a bug when using a texture to store morph targets on Mali-G72
                this._caps.disableMorphTargetTexture = true;
            }
        }
        _initFeatures() {
            this._features = {
                forceBitmapOverHTMLImageElement: false,
                supportRenderAndCopyToLodForFloatTextures: this._webGLVersion !== 1,
                supportDepthStencilTexture: this._webGLVersion !== 1,
                supportShadowSamplers: this._webGLVersion !== 1,
                uniformBufferHardCheckMatrix: false,
                allowTexturePrefiltering: this._webGLVersion !== 1,
                trackUbosInFrame: false,
                checkUbosContentBeforeUpload: false,
                supportCSM: this._webGLVersion !== 1,
                basisNeedsPOT: this._webGLVersion === 1,
                support3DTextures: this._webGLVersion !== 1,
                needTypeSuffixInShaderConstants: this._webGLVersion !== 1,
                supportMSAA: this._webGLVersion !== 1,
                supportSSAO2: this._webGLVersion !== 1,
                supportExtendedTextureFormats: this._webGLVersion !== 1,
                supportSwitchCaseInShader: this._webGLVersion !== 1,
                supportSyncTextureRead: true,
                needsInvertingBitmap: true,
                useUBOBindingCache: true,
                needShaderCodeInlining: false,
                needToAlwaysBindUniformBuffers: false,
                supportRenderPasses: false,
                supportSpriteInstancing: true,
                _collectUbosUpdatedInFrame: false,
            };
        }
        /**
         * Gets version of the current webGL context
         * Keep it for back compat - use version instead
         */
        get webGLVersion() {
            return this._webGLVersion;
        }
        /**
         * Gets a string identifying the name of the class
         * @returns "Engine" string
         */
        getClassName() {
            return "ThinEngine";
        }
        /**
         * Returns true if the stencil buffer has been enabled through the creation option of the context.
         */
        get isStencilEnable() {
            return this._isStencilEnable;
        }
        /** @internal */
        _prepareWorkingCanvas() {
            if (this._workingCanvas) {
                return;
            }
            this._workingCanvas = this.createCanvas(1, 1);
            const context = this._workingCanvas.getContext("2d");
            if (context) {
                this._workingContext = context;
            }
        }
        /**
         * Reset the texture cache to empty state
         */
        resetTextureCache() {
            for (const key in this._boundTexturesCache) {
                if (!Object.prototype.hasOwnProperty.call(this._boundTexturesCache, key)) {
                    continue;
                }
                this._boundTexturesCache[key] = null;
            }
            this._currentTextureChannel = -1;
        }
        /**
         * Gets an object containing information about the current engine context
         * @returns an object containing the vendor, the renderer and the version of the current engine context
         */
        getInfo() {
            return this.getGlInfo();
        }
        /**
         * Gets an object containing information about the current webGL context
         * @returns an object containing the vendor, the renderer and the version of the current webGL context
         */
        getGlInfo() {
            return {
                vendor: this._glVendor,
                renderer: this._glRenderer,
                version: this._glVersion,
            };
        }
        /**
         * Defines the hardware scaling level.
         * By default the hardware scaling level is computed from the window device ratio.
         * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
         * @param level defines the level to use
         */
        setHardwareScalingLevel(level) {
            this._hardwareScalingLevel = level;
            this.resize();
        }
        /**
         * Gets the current hardware scaling level.
         * By default the hardware scaling level is computed from the window device ratio.
         * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
         * @returns a number indicating the current hardware scaling level
         */
        getHardwareScalingLevel() {
            return this._hardwareScalingLevel;
        }
        /**
         * Gets the list of loaded textures
         * @returns an array containing all loaded textures
         */
        getLoadedTexturesCache() {
            return this._internalTexturesCache;
        }
        /**
         * Gets the object containing all engine capabilities
         * @returns the EngineCapabilities object
         */
        getCaps() {
            return this._caps;
        }
        /**
         * stop executing a render loop function and remove it from the execution array
         * @param renderFunction defines the function to be removed. If not provided all functions will be removed.
         */
        stopRenderLoop(renderFunction) {
            if (!renderFunction) {
                this._activeRenderLoops.length = 0;
                this._cancelFrame();
                return;
            }
            const index = this._activeRenderLoops.indexOf(renderFunction);
            if (index >= 0) {
                this._activeRenderLoops.splice(index, 1);
                if (this._activeRenderLoops.length == 0) {
                    this._cancelFrame();
                }
            }
        }
        _cancelFrame() {
            if (this._renderingQueueLaunched && this._frameHandler) {
                this._renderingQueueLaunched = false;
                if (!IsWindowObjectExist()) {
                    if (typeof cancelAnimationFrame === "function") {
                        return cancelAnimationFrame(this._frameHandler);
                    }
                }
                else {
                    const { cancelAnimationFrame } = this.getHostWindow() || window;
                    if (typeof cancelAnimationFrame === "function") {
                        return cancelAnimationFrame(this._frameHandler);
                    }
                }
                return clearTimeout(this._frameHandler);
            }
        }
        /** @internal */
        _renderLoop() {
            if (!this._contextWasLost) {
                let shouldRender = true;
                if (this._isDisposed || (!this.renderEvenInBackground && this._windowIsBackground)) {
                    shouldRender = false;
                }
                if (shouldRender) {
                    // Start new frame
                    this.beginFrame();
                    for (let index = 0; index < this._activeRenderLoops.length; index++) {
                        const renderFunction = this._activeRenderLoops[index];
                        renderFunction();
                    }
                    // Present
                    this.endFrame();
                }
            }
            if (this._activeRenderLoops.length > 0) {
                this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
            }
            else {
                this._renderingQueueLaunched = false;
            }
        }
        /**
         * Gets the HTML canvas attached with the current webGL context
         * @returns a HTML canvas
         */
        getRenderingCanvas() {
            return this._renderingCanvas;
        }
        /**
         * Gets the audio context specified in engine initialization options
         * @returns an Audio Context
         */
        getAudioContext() {
            return this._audioContext;
        }
        /**
         * Gets the audio destination specified in engine initialization options
         * @returns an audio destination node
         */
        getAudioDestination() {
            return this._audioDestination;
        }
        /**
         * Gets host window
         * @returns the host window object
         */
        getHostWindow() {
            if (!IsWindowObjectExist()) {
                return null;
            }
            if (this._renderingCanvas && this._renderingCanvas.ownerDocument && this._renderingCanvas.ownerDocument.defaultView) {
                return this._renderingCanvas.ownerDocument.defaultView;
            }
            return window;
        }
        /**
         * Gets the current render width
         * @param useScreen defines if screen size must be used (or the current render target if any)
         * @returns a number defining the current render width
         */
        getRenderWidth(useScreen = false) {
            if (!useScreen && this._currentRenderTarget) {
                return this._currentRenderTarget.width;
            }
            return this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferWidth : this._gl.drawingBufferWidth;
        }
        /**
         * Gets the current render height
         * @param useScreen defines if screen size must be used (or the current render target if any)
         * @returns a number defining the current render height
         */
        getRenderHeight(useScreen = false) {
            if (!useScreen && this._currentRenderTarget) {
                return this._currentRenderTarget.height;
            }
            return this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferHeight : this._gl.drawingBufferHeight;
        }
        /**
         * Can be used to override the current requestAnimationFrame requester.
         * @internal
         */
        _queueNewFrame(bindedRenderFunction, requester) {
            return ThinEngine.QueueNewFrame(bindedRenderFunction, requester);
        }
        /**
         * Register and execute a render loop. The engine can have more than one render function
         * @param renderFunction defines the function to continuously execute
         */
        runRenderLoop(renderFunction) {
            if (this._activeRenderLoops.indexOf(renderFunction) !== -1) {
                return;
            }
            this._activeRenderLoops.push(renderFunction);
            if (!this._renderingQueueLaunched) {
                this._renderingQueueLaunched = true;
                this._boundRenderFunction = this._renderLoop.bind(this);
                this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
            }
        }
        /**
         * Clear the current render buffer or the current render target (if any is set up)
         * @param color defines the color to use
         * @param backBuffer defines if the back buffer must be cleared
         * @param depth defines if the depth buffer must be cleared
         * @param stencil defines if the stencil buffer must be cleared
         */
        clear(color, backBuffer, depth, stencil = false) {
            var _a, _b;
            const useStencilGlobalOnly = this.stencilStateComposer.useStencilGlobalOnly;
            this.stencilStateComposer.useStencilGlobalOnly = true; // make sure the stencil mask is coming from the global stencil and not from a material (effect) which would currently be in effect
            this.applyStates();
            this.stencilStateComposer.useStencilGlobalOnly = useStencilGlobalOnly;
            let mode = 0;
            if (backBuffer && color) {
                let setBackBufferColor = true;
                if (this._currentRenderTarget) {
                    const textureFormat = (_a = this._currentRenderTarget.texture) === null || _a === void 0 ? void 0 : _a.format;
                    if (textureFormat === 8 ||
                        textureFormat === 9 ||
                        textureFormat === 10 ||
                        textureFormat === 11) {
                        const textureType = (_b = this._currentRenderTarget.texture) === null || _b === void 0 ? void 0 : _b.type;
                        if (textureType === 7 || textureType === 5) {
                            ThinEngine._TempClearColorUint32[0] = color.r * 255;
                            ThinEngine._TempClearColorUint32[1] = color.g * 255;
                            ThinEngine._TempClearColorUint32[2] = color.b * 255;
                            ThinEngine._TempClearColorUint32[3] = color.a * 255;
                            this._gl.clearBufferuiv(this._gl.COLOR, 0, ThinEngine._TempClearColorUint32);
                            setBackBufferColor = false;
                        }
                        else {
                            ThinEngine._TempClearColorInt32[0] = color.r * 255;
                            ThinEngine._TempClearColorInt32[1] = color.g * 255;
                            ThinEngine._TempClearColorInt32[2] = color.b * 255;
                            ThinEngine._TempClearColorInt32[3] = color.a * 255;
                            this._gl.clearBufferiv(this._gl.COLOR, 0, ThinEngine._TempClearColorInt32);
                            setBackBufferColor = false;
                        }
                    }
                }
                if (setBackBufferColor) {
                    this._gl.clearColor(color.r, color.g, color.b, color.a !== undefined ? color.a : 1.0);
                    mode |= this._gl.COLOR_BUFFER_BIT;
                }
            }
            if (depth) {
                if (this.useReverseDepthBuffer) {
                    this._depthCullingState.depthFunc = this._gl.GEQUAL;
                    this._gl.clearDepth(0.0);
                }
                else {
                    this._gl.clearDepth(1.0);
                }
                mode |= this._gl.DEPTH_BUFFER_BIT;
            }
            if (stencil) {
                this._gl.clearStencil(0);
                mode |= this._gl.STENCIL_BUFFER_BIT;
            }
            this._gl.clear(mode);
        }
        /**
         * @internal
         */
        _viewport(x, y, width, height) {
            if (x !== this._viewportCached.x || y !== this._viewportCached.y || width !== this._viewportCached.z || height !== this._viewportCached.w) {
                this._viewportCached.x = x;
                this._viewportCached.y = y;
                this._viewportCached.z = width;
                this._viewportCached.w = height;
                this._gl.viewport(x, y, width, height);
            }
        }
        /**
         * Set the WebGL's viewport
         * @param viewport defines the viewport element to be used
         * @param requiredWidth defines the width required for rendering. If not provided the rendering canvas' width is used
         * @param requiredHeight defines the height required for rendering. If not provided the rendering canvas' height is used
         */
        setViewport(viewport, requiredWidth, requiredHeight) {
            const width = requiredWidth || this.getRenderWidth();
            const height = requiredHeight || this.getRenderHeight();
            const x = viewport.x || 0;
            const y = viewport.y || 0;
            this._cachedViewport = viewport;
            this._viewport(x * width, y * height, width * viewport.width, height * viewport.height);
        }
        /**
         * Begin a new frame
         */
        beginFrame() { }
        /**
         * Enf the current frame
         */
        endFrame() {
            // Force a flush in case we are using a bad OS.
            if (this._badOS) {
                this.flushFramebuffer();
            }
            this._frameId++;
        }
        /**
         * Resize the view according to the canvas' size
         * @param forceSetSize true to force setting the sizes of the underlying canvas
         */
        resize(forceSetSize = false) {
            let width;
            let height;
            // Re-query hardware scaling level to handle zoomed-in resizing.
            if (this.adaptToDeviceRatio) {
                const devicePixelRatio = IsWindowObjectExist() ? window.devicePixelRatio || 1.0 : 1.0;
                const changeRatio = this._lastDevicePixelRatio / devicePixelRatio;
                this._lastDevicePixelRatio = devicePixelRatio;
                this._hardwareScalingLevel *= changeRatio;
            }
            if (IsWindowObjectExist() && IsDocumentAvailable()) {
                // make sure it is a Node object, and is a part of the document.
                if (this._renderingCanvas) {
                    const boundingRect = this._renderingCanvas.getBoundingClientRect
                        ? this._renderingCanvas.getBoundingClientRect()
                        : {
                            // fallback to last solution in case the function doesn't exist
                            width: this._renderingCanvas.width * this._hardwareScalingLevel,
                            height: this._renderingCanvas.height * this._hardwareScalingLevel,
                        };
                    width = this._renderingCanvas.clientWidth || boundingRect.width || this._renderingCanvas.width || 100;
                    height = this._renderingCanvas.clientHeight || boundingRect.height || this._renderingCanvas.height || 100;
                }
                else {
                    width = window.innerWidth;
                    height = window.innerHeight;
                }
            }
            else {
                width = this._renderingCanvas ? this._renderingCanvas.width : 100;
                height = this._renderingCanvas ? this._renderingCanvas.height : 100;
            }
            this.setSize(width / this._hardwareScalingLevel, height / this._hardwareScalingLevel, forceSetSize);
        }
        /**
         * Force a specific size of the canvas
         * @param width defines the new canvas' width
         * @param height defines the new canvas' height
         * @param forceSetSize true to force setting the sizes of the underlying canvas
         * @returns true if the size was changed
         */
        setSize(width, height, forceSetSize = false) {
            if (!this._renderingCanvas) {
                return false;
            }
            width = width | 0;
            height = height | 0;
            if (!forceSetSize && this._renderingCanvas.width === width && this._renderingCanvas.height === height) {
                return false;
            }
            this._renderingCanvas.width = width;
            this._renderingCanvas.height = height;
            return true;
        }
        /**
         * Binds the frame buffer to the specified texture.
         * @param rtWrapper The render target wrapper to render to
         * @param faceIndex The face of the texture to render to in case of cube texture and if the render target wrapper is not a multi render target
         * @param requiredWidth The width of the target to render to
         * @param requiredHeight The height of the target to render to
         * @param forceFullscreenViewport Forces the viewport to be the entire texture/screen if true
         * @param lodLevel Defines the lod level to bind to the frame buffer
         * @param layer Defines the 2d array index to bind to the frame buffer if the render target wrapper is not a multi render target
         */
        bindFramebuffer(rtWrapper, faceIndex = 0, requiredWidth, requiredHeight, forceFullscreenViewport, lodLevel = 0, layer = 0) {
            var _a, _b, _c, _d, _e;
            const webglRTWrapper = rtWrapper;
            if (this._currentRenderTarget) {
                this.unBindFramebuffer(this._currentRenderTarget);
            }
            this._currentRenderTarget = rtWrapper;
            this._bindUnboundFramebuffer(webglRTWrapper._MSAAFramebuffer ? webglRTWrapper._MSAAFramebuffer : webglRTWrapper._framebuffer);
            const gl = this._gl;
            if (!rtWrapper.isMulti) {
                if (rtWrapper.is2DArray) {
                    gl.framebufferTextureLayer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, (_a = rtWrapper.texture._hardwareTexture) === null || _a === void 0 ? void 0 : _a.underlyingResource, lodLevel, layer);
                }
                else if (rtWrapper.isCube) {
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, (_b = rtWrapper.texture._hardwareTexture) === null || _b === void 0 ? void 0 : _b.underlyingResource, lodLevel);
                }
            }
            const depthStencilTexture = rtWrapper._depthStencilTexture;
            if (depthStencilTexture) {
                const attachment = rtWrapper._depthStencilTextureWithStencil ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                if (rtWrapper.is2DArray) {
                    gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, (_c = depthStencilTexture._hardwareTexture) === null || _c === void 0 ? void 0 : _c.underlyingResource, lodLevel, layer);
                }
                else if (rtWrapper.isCube) {
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, (_d = depthStencilTexture._hardwareTexture) === null || _d === void 0 ? void 0 : _d.underlyingResource, lodLevel);
                }
                else {
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, (_e = depthStencilTexture._hardwareTexture) === null || _e === void 0 ? void 0 : _e.underlyingResource, lodLevel);
                }
            }
            if (this._cachedViewport && !forceFullscreenViewport) {
                this.setViewport(this._cachedViewport, requiredWidth, requiredHeight);
            }
            else {
                if (!requiredWidth) {
                    requiredWidth = rtWrapper.width;
                    if (lodLevel) {
                        requiredWidth = requiredWidth / Math.pow(2, lodLevel);
                    }
                }
                if (!requiredHeight) {
                    requiredHeight = rtWrapper.height;
                    if (lodLevel) {
                        requiredHeight = requiredHeight / Math.pow(2, lodLevel);
                    }
                }
                this._viewport(0, 0, requiredWidth, requiredHeight);
            }
            this.wipeCaches();
        }
        /**
         * Set various states to the webGL context
         * @param culling defines culling state: true to enable culling, false to disable it
         * @param zOffset defines the value to apply to zOffset (0 by default)
         * @param force defines if states must be applied even if cache is up to date
         * @param reverseSide defines if culling must be reversed (CCW if false, CW if true)
         * @param cullBackFaces true to cull back faces, false to cull front faces (if culling is enabled)
         * @param stencil stencil states to set
         * @param zOffsetUnits defines the value to apply to zOffsetUnits (0 by default)
         */
        setState(culling, zOffset = 0, force, reverseSide = false, cullBackFaces, stencil, zOffsetUnits = 0) {
            var _a, _b;
            // Culling
            if (this._depthCullingState.cull !== culling || force) {
                this._depthCullingState.cull = culling;
            }
            // Cull face
            const cullFace = ((_b = (_a = this.cullBackFaces) !== null && _a !== void 0 ? _a : cullBackFaces) !== null && _b !== void 0 ? _b : true) ? this._gl.BACK : this._gl.FRONT;
            if (this._depthCullingState.cullFace !== cullFace || force) {
                this._depthCullingState.cullFace = cullFace;
            }
            // Z offset
            this.setZOffset(zOffset);
            this.setZOffsetUnits(zOffsetUnits);
            // Front face
            const frontFace = reverseSide ? this._gl.CW : this._gl.CCW;
            if (this._depthCullingState.frontFace !== frontFace || force) {
                this._depthCullingState.frontFace = frontFace;
            }
            this._stencilStateComposer.stencilMaterial = stencil;
        }
        /**
         * Gets a boolean indicating if depth testing is enabled
         * @returns the current state
         */
        getDepthBuffer() {
            return this._depthCullingState.depthTest;
        }
        /**
         * Enable or disable depth buffering
         * @param enable defines the state to set
         */
        setDepthBuffer(enable) {
            this._depthCullingState.depthTest = enable;
        }
        /**
         * Set the z offset Factor to apply to current rendering
         * @param value defines the offset to apply
         */
        setZOffset(value) {
            this._depthCullingState.zOffset = this.useReverseDepthBuffer ? -value : value;
        }
        /**
         * Gets the current value of the zOffset Factor
         * @returns the current zOffset Factor state
         */
        getZOffset() {
            const zOffset = this._depthCullingState.zOffset;
            return this.useReverseDepthBuffer ? -zOffset : zOffset;
        }
        /**
         * Set the z offset Units to apply to current rendering
         * @param value defines the offset to apply
         */
        setZOffsetUnits(value) {
            this._depthCullingState.zOffsetUnits = this.useReverseDepthBuffer ? -value : value;
        }
        /**
         * Gets the current value of the zOffset Units
         * @returns the current zOffset Units state
         */
        getZOffsetUnits() {
            const zOffsetUnits = this._depthCullingState.zOffsetUnits;
            return this.useReverseDepthBuffer ? -zOffsetUnits : zOffsetUnits;
        }
        /**
         * @internal
         */
        _bindUnboundFramebuffer(framebuffer) {
            if (this._currentFramebuffer !== framebuffer) {
                this._gl.bindFramebuffer(this._gl.FRAMEBUFFER, framebuffer);
                this._currentFramebuffer = framebuffer;
            }
        }
        /** @internal */
        _currentFrameBufferIsDefaultFrameBuffer() {
            return this._currentFramebuffer === null;
        }
        /**
         * Generates the mipmaps for a texture
         * @param texture texture to generate the mipmaps for
         */
        generateMipmaps(texture) {
            this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
            this._gl.generateMipmap(this._gl.TEXTURE_2D);
            this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        }
        /**
         * Unbind the current render target texture from the webGL context
         * @param texture defines the render target wrapper to unbind
         * @param disableGenerateMipMaps defines a boolean indicating that mipmaps must not be generated
         * @param onBeforeUnbind defines a function which will be called before the effective unbind
         */
        unBindFramebuffer(texture, disableGenerateMipMaps = false, onBeforeUnbind) {
            var _a;
            const webglRTWrapper = texture;
            this._currentRenderTarget = null;
            // If MSAA, we need to bitblt back to main texture
            const gl = this._gl;
            if (webglRTWrapper._MSAAFramebuffer) {
                if (texture.isMulti) {
                    // This texture is part of a MRT texture, we need to treat all attachments
                    this.unBindMultiColorAttachmentFramebuffer(texture, disableGenerateMipMaps, onBeforeUnbind);
                    return;
                }
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, webglRTWrapper._MSAAFramebuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, webglRTWrapper._framebuffer);
                gl.blitFramebuffer(0, 0, texture.width, texture.height, 0, 0, texture.width, texture.height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
            }
            if (((_a = texture.texture) === null || _a === void 0 ? void 0 : _a.generateMipMaps) && !disableGenerateMipMaps && !texture.isCube) {
                this.generateMipmaps(texture.texture);
            }
            if (onBeforeUnbind) {
                if (webglRTWrapper._MSAAFramebuffer) {
                    // Bind the correct framebuffer
                    this._bindUnboundFramebuffer(webglRTWrapper._framebuffer);
                }
                onBeforeUnbind();
            }
            this._bindUnboundFramebuffer(null);
        }
        /**
         * Force a webGL flush (ie. a flush of all waiting webGL commands)
         */
        flushFramebuffer() {
            this._gl.flush();
        }
        /**
         * Unbind the current render target and bind the default framebuffer
         */
        restoreDefaultFramebuffer() {
            if (this._currentRenderTarget) {
                this.unBindFramebuffer(this._currentRenderTarget);
            }
            else {
                this._bindUnboundFramebuffer(null);
            }
            if (this._cachedViewport) {
                this.setViewport(this._cachedViewport);
            }
            this.wipeCaches();
        }
        // VBOs
        /** @internal */
        _resetVertexBufferBinding() {
            this.bindArrayBuffer(null);
            this._cachedVertexBuffers = null;
        }
        /**
         * Creates a vertex buffer
         * @param data the data for the vertex buffer
         * @returns the new WebGL static buffer
         */
        createVertexBuffer(data) {
            return this._createVertexBuffer(data, this._gl.STATIC_DRAW);
        }
        _createVertexBuffer(data, usage) {
            const vbo = this._gl.createBuffer();
            if (!vbo) {
                throw new Error("Unable to create vertex buffer");
            }
            const dataBuffer = new WebGLDataBuffer(vbo);
            this.bindArrayBuffer(dataBuffer);
            if (data instanceof Array) {
                this._gl.bufferData(this._gl.ARRAY_BUFFER, new Float32Array(data), usage);
            }
            else {
                this._gl.bufferData(this._gl.ARRAY_BUFFER, data, usage);
            }
            this._resetVertexBufferBinding();
            dataBuffer.references = 1;
            return dataBuffer;
        }
        /**
         * Creates a dynamic vertex buffer
         * @param data the data for the dynamic vertex buffer
         * @returns the new WebGL dynamic buffer
         */
        createDynamicVertexBuffer(data) {
            return this._createVertexBuffer(data, this._gl.DYNAMIC_DRAW);
        }
        _resetIndexBufferBinding() {
            this.bindIndexBuffer(null);
            this._cachedIndexBuffer = null;
        }
        /**
         * Creates a new index buffer
         * @param indices defines the content of the index buffer
         * @param updatable defines if the index buffer must be updatable
         * @returns a new webGL buffer
         */
        createIndexBuffer(indices, updatable) {
            const vbo = this._gl.createBuffer();
            const dataBuffer = new WebGLDataBuffer(vbo);
            if (!vbo) {
                throw new Error("Unable to create index buffer");
            }
            this.bindIndexBuffer(dataBuffer);
            const data = this._normalizeIndexData(indices);
            this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, data, updatable ? this._gl.DYNAMIC_DRAW : this._gl.STATIC_DRAW);
            this._resetIndexBufferBinding();
            dataBuffer.references = 1;
            dataBuffer.is32Bits = data.BYTES_PER_ELEMENT === 4;
            return dataBuffer;
        }
        _normalizeIndexData(indices) {
            const bytesPerElement = indices.BYTES_PER_ELEMENT;
            if (bytesPerElement === 2) {
                return indices;
            }
            // Check 32 bit support
            if (this._caps.uintIndices) {
                if (indices instanceof Uint32Array) {
                    return indices;
                }
                else {
                    // number[] or Int32Array, check if 32 bit is necessary
                    for (let index = 0; index < indices.length; index++) {
                        if (indices[index] >= 65535) {
                            return new Uint32Array(indices);
                        }
                    }
                    return new Uint16Array(indices);
                }
            }
            // No 32 bit support, force conversion to 16 bit (values greater 16 bit are lost)
            return new Uint16Array(indices);
        }
        /**
         * Bind a webGL buffer to the webGL context
         * @param buffer defines the buffer to bind
         */
        bindArrayBuffer(buffer) {
            if (!this._vaoRecordInProgress) {
                this._unbindVertexArrayObject();
            }
            this._bindBuffer(buffer, this._gl.ARRAY_BUFFER);
        }
        /**
         * Bind a specific block at a given index in a specific shader program
         * @param pipelineContext defines the pipeline context to use
         * @param blockName defines the block name
         * @param index defines the index where to bind the block
         */
        bindUniformBlock(pipelineContext, blockName, index) {
            const program = pipelineContext.program;
            const uniformLocation = this._gl.getUniformBlockIndex(program, blockName);
            this._gl.uniformBlockBinding(program, uniformLocation, index);
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        bindIndexBuffer(buffer) {
            if (!this._vaoRecordInProgress) {
                this._unbindVertexArrayObject();
            }
            this._bindBuffer(buffer, this._gl.ELEMENT_ARRAY_BUFFER);
        }
        _bindBuffer(buffer, target) {
            if (this._vaoRecordInProgress || this._currentBoundBuffer[target] !== buffer) {
                this._gl.bindBuffer(target, buffer ? buffer.underlyingResource : null);
                this._currentBoundBuffer[target] = buffer;
            }
        }
        /**
         * update the bound buffer with the given data
         * @param data defines the data to update
         */
        updateArrayBuffer(data) {
            this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
        }
        _vertexAttribPointer(buffer, indx, size, type, normalized, stride, offset) {
            const pointer = this._currentBufferPointers[indx];
            if (!pointer) {
                return;
            }
            let changed = false;
            if (!pointer.active) {
                changed = true;
                pointer.active = true;
                pointer.index = indx;
                pointer.size = size;
                pointer.type = type;
                pointer.normalized = normalized;
                pointer.stride = stride;
                pointer.offset = offset;
                pointer.buffer = buffer;
            }
            else {
                if (pointer.buffer !== buffer) {
                    pointer.buffer = buffer;
                    changed = true;
                }
                if (pointer.size !== size) {
                    pointer.size = size;
                    changed = true;
                }
                if (pointer.type !== type) {
                    pointer.type = type;
                    changed = true;
                }
                if (pointer.normalized !== normalized) {
                    pointer.normalized = normalized;
                    changed = true;
                }
                if (pointer.stride !== stride) {
                    pointer.stride = stride;
                    changed = true;
                }
                if (pointer.offset !== offset) {
                    pointer.offset = offset;
                    changed = true;
                }
            }
            if (changed || this._vaoRecordInProgress) {
                this.bindArrayBuffer(buffer);
                if (type === this._gl.UNSIGNED_INT || type === this._gl.INT) {
                    this._gl.vertexAttribIPointer(indx, size, type, stride, offset);
                }
                else {
                    this._gl.vertexAttribPointer(indx, size, type, normalized, stride, offset);
                }
            }
        }
        /**
         * @internal
         */
        _bindIndexBufferWithCache(indexBuffer) {
            if (indexBuffer == null) {
                return;
            }
            if (this._cachedIndexBuffer !== indexBuffer) {
                this._cachedIndexBuffer = indexBuffer;
                this.bindIndexBuffer(indexBuffer);
                this._uintIndicesCurrentlySet = indexBuffer.is32Bits;
            }
        }
        _bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers) {
            const attributes = effect.getAttributesNames();
            if (!this._vaoRecordInProgress) {
                this._unbindVertexArrayObject();
            }
            this.unbindAllAttributes();
            for (let index = 0; index < attributes.length; index++) {
                const order = effect.getAttributeLocation(index);
                if (order >= 0) {
                    const ai = attributes[index];
                    let vertexBuffer = null;
                    if (overrideVertexBuffers) {
                        vertexBuffer = overrideVertexBuffers[ai];
                    }
                    if (!vertexBuffer) {
                        vertexBuffer = vertexBuffers[ai];
                    }
                    if (!vertexBuffer) {
                        continue;
                    }
                    this._gl.enableVertexAttribArray(order);
                    if (!this._vaoRecordInProgress) {
                        this._vertexAttribArraysEnabled[order] = true;
                    }
                    const buffer = vertexBuffer.getBuffer();
                    if (buffer) {
                        this._vertexAttribPointer(buffer, order, vertexBuffer.getSize(), vertexBuffer.type, vertexBuffer.normalized, vertexBuffer.byteStride, vertexBuffer.byteOffset);
                        if (vertexBuffer.getIsInstanced()) {
                            this._gl.vertexAttribDivisor(order, vertexBuffer.getInstanceDivisor());
                            if (!this._vaoRecordInProgress) {
                                this._currentInstanceLocations.push(order);
                                this._currentInstanceBuffers.push(buffer);
                            }
                        }
                    }
                }
            }
        }
        /**
         * Records a vertex array object
         * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
         * @param vertexBuffers defines the list of vertex buffers to store
         * @param indexBuffer defines the index buffer to store
         * @param effect defines the effect to store
         * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
         * @returns the new vertex array object
         */
        recordVertexArrayObject(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
            const vao = this._gl.createVertexArray();
            if (!vao) {
                throw new Error("Unable to create VAO");
            }
            this._vaoRecordInProgress = true;
            this._gl.bindVertexArray(vao);
            this._mustWipeVertexAttributes = true;
            this._bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers);
            this.bindIndexBuffer(indexBuffer);
            this._vaoRecordInProgress = false;
            this._gl.bindVertexArray(null);
            return vao;
        }
        /**
         * Bind a specific vertex array object
         * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
         * @param vertexArrayObject defines the vertex array object to bind
         * @param indexBuffer defines the index buffer to bind
         */
        bindVertexArrayObject(vertexArrayObject, indexBuffer) {
            if (this._cachedVertexArrayObject !== vertexArrayObject) {
                this._cachedVertexArrayObject = vertexArrayObject;
                this._gl.bindVertexArray(vertexArrayObject);
                this._cachedVertexBuffers = null;
                this._cachedIndexBuffer = null;
                this._uintIndicesCurrentlySet = indexBuffer != null && indexBuffer.is32Bits;
                this._mustWipeVertexAttributes = true;
            }
        }
        /**
         * Bind webGl buffers directly to the webGL context
         * @param vertexBuffer defines the vertex buffer to bind
         * @param indexBuffer defines the index buffer to bind
         * @param vertexDeclaration defines the vertex declaration to use with the vertex buffer
         * @param vertexStrideSize defines the vertex stride of the vertex buffer
         * @param effect defines the effect associated with the vertex buffer
         */
        bindBuffersDirectly(vertexBuffer, indexBuffer, vertexDeclaration, vertexStrideSize, effect) {
            if (this._cachedVertexBuffers !== vertexBuffer || this._cachedEffectForVertexBuffers !== effect) {
                this._cachedVertexBuffers = vertexBuffer;
                this._cachedEffectForVertexBuffers = effect;
                const attributesCount = effect.getAttributesCount();
                this._unbindVertexArrayObject();
                this.unbindAllAttributes();
                let offset = 0;
                for (let index = 0; index < attributesCount; index++) {
                    if (index < vertexDeclaration.length) {
                        const order = effect.getAttributeLocation(index);
                        if (order >= 0) {
                            this._gl.enableVertexAttribArray(order);
                            this._vertexAttribArraysEnabled[order] = true;
                            this._vertexAttribPointer(vertexBuffer, order, vertexDeclaration[index], this._gl.FLOAT, false, vertexStrideSize, offset);
                        }
                        offset += vertexDeclaration[index] * 4;
                    }
                }
            }
            this._bindIndexBufferWithCache(indexBuffer);
        }
        _unbindVertexArrayObject() {
            if (!this._cachedVertexArrayObject) {
                return;
            }
            this._cachedVertexArrayObject = null;
            this._gl.bindVertexArray(null);
        }
        /**
         * Bind a list of vertex buffers to the webGL context
         * @param vertexBuffers defines the list of vertex buffers to bind
         * @param indexBuffer defines the index buffer to bind
         * @param effect defines the effect associated with the vertex buffers
         * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
         */
        bindBuffers(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
            if (this._cachedVertexBuffers !== vertexBuffers || this._cachedEffectForVertexBuffers !== effect) {
                this._cachedVertexBuffers = vertexBuffers;
                this._cachedEffectForVertexBuffers = effect;
                this._bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers);
            }
            this._bindIndexBufferWithCache(indexBuffer);
        }
        /**
         * Unbind all instance attributes
         */
        unbindInstanceAttributes() {
            let boundBuffer;
            for (let i = 0, ul = this._currentInstanceLocations.length; i < ul; i++) {
                const instancesBuffer = this._currentInstanceBuffers[i];
                if (boundBuffer != instancesBuffer && instancesBuffer.references) {
                    boundBuffer = instancesBuffer;
                    this.bindArrayBuffer(instancesBuffer);
                }
                const offsetLocation = this._currentInstanceLocations[i];
                this._gl.vertexAttribDivisor(offsetLocation, 0);
            }
            this._currentInstanceBuffers.length = 0;
            this._currentInstanceLocations.length = 0;
        }
        /**
         * Release and free the memory of a vertex array object
         * @param vao defines the vertex array object to delete
         */
        releaseVertexArrayObject(vao) {
            this._gl.deleteVertexArray(vao);
        }
        /**
         * @internal
         */
        _releaseBuffer(buffer) {
            buffer.references--;
            if (buffer.references === 0) {
                this._deleteBuffer(buffer);
                return true;
            }
            return false;
        }
        _deleteBuffer(buffer) {
            this._gl.deleteBuffer(buffer.underlyingResource);
        }
        /**
         * Update the content of a webGL buffer used with instantiation and bind it to the webGL context
         * @param instancesBuffer defines the webGL buffer to update and bind
         * @param data defines the data to store in the buffer
         * @param offsetLocations defines the offsets or attributes information used to determine where data must be stored in the buffer
         */
        updateAndBindInstancesBuffer(instancesBuffer, data, offsetLocations) {
            this.bindArrayBuffer(instancesBuffer);
            if (data) {
                this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
            }
            if (offsetLocations[0].index !== undefined) {
                this.bindInstancesBuffer(instancesBuffer, offsetLocations, true);
            }
            else {
                for (let index = 0; index < 4; index++) {
                    const offsetLocation = offsetLocations[index];
                    if (!this._vertexAttribArraysEnabled[offsetLocation]) {
                        this._gl.enableVertexAttribArray(offsetLocation);
                        this._vertexAttribArraysEnabled[offsetLocation] = true;
                    }
                    this._vertexAttribPointer(instancesBuffer, offsetLocation, 4, this._gl.FLOAT, false, 64, index * 16);
                    this._gl.vertexAttribDivisor(offsetLocation, 1);
                    this._currentInstanceLocations.push(offsetLocation);
                    this._currentInstanceBuffers.push(instancesBuffer);
                }
            }
        }
        /**
         * Bind the content of a webGL buffer used with instantiation
         * @param instancesBuffer defines the webGL buffer to bind
         * @param attributesInfo defines the offsets or attributes information used to determine where data must be stored in the buffer
         * @param computeStride defines Whether to compute the strides from the info or use the default 0
         */
        bindInstancesBuffer(instancesBuffer, attributesInfo, computeStride = true) {
            this.bindArrayBuffer(instancesBuffer);
            let stride = 0;
            if (computeStride) {
                for (let i = 0; i < attributesInfo.length; i++) {
                    const ai = attributesInfo[i];
                    stride += ai.attributeSize * 4;
                }
            }
            for (let i = 0; i < attributesInfo.length; i++) {
                const ai = attributesInfo[i];
                if (ai.index === undefined) {
                    ai.index = this._currentEffect.getAttributeLocationByName(ai.attributeName);
                }
                if (ai.index < 0) {
                    continue;
                }
                if (!this._vertexAttribArraysEnabled[ai.index]) {
                    this._gl.enableVertexAttribArray(ai.index);
                    this._vertexAttribArraysEnabled[ai.index] = true;
                }
                this._vertexAttribPointer(instancesBuffer, ai.index, ai.attributeSize, ai.attributeType || this._gl.FLOAT, ai.normalized || false, stride, ai.offset);
                this._gl.vertexAttribDivisor(ai.index, ai.divisor === undefined ? 1 : ai.divisor);
                this._currentInstanceLocations.push(ai.index);
                this._currentInstanceBuffers.push(instancesBuffer);
            }
        }
        /**
         * Disable the instance attribute corresponding to the name in parameter
         * @param name defines the name of the attribute to disable
         */
        disableInstanceAttributeByName(name) {
            if (!this._currentEffect) {
                return;
            }
            const attributeLocation = this._currentEffect.getAttributeLocationByName(name);
            this.disableInstanceAttribute(attributeLocation);
        }
        /**
         * Disable the instance attribute corresponding to the location in parameter
         * @param attributeLocation defines the attribute location of the attribute to disable
         */
        disableInstanceAttribute(attributeLocation) {
            let shouldClean = false;
            let index;
            while ((index = this._currentInstanceLocations.indexOf(attributeLocation)) !== -1) {
                this._currentInstanceLocations.splice(index, 1);
                this._currentInstanceBuffers.splice(index, 1);
                shouldClean = true;
                index = this._currentInstanceLocations.indexOf(attributeLocation);
            }
            if (shouldClean) {
                this._gl.vertexAttribDivisor(attributeLocation, 0);
                this.disableAttributeByIndex(attributeLocation);
            }
        }
        /**
         * Disable the attribute corresponding to the location in parameter
         * @param attributeLocation defines the attribute location of the attribute to disable
         */
        disableAttributeByIndex(attributeLocation) {
            this._gl.disableVertexAttribArray(attributeLocation);
            this._vertexAttribArraysEnabled[attributeLocation] = false;
            this._currentBufferPointers[attributeLocation].active = false;
        }
        /**
         * Send a draw order
         * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
         * @param indexStart defines the starting index
         * @param indexCount defines the number of index to draw
         * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
         */
        draw(useTriangles, indexStart, indexCount, instancesCount) {
            this.drawElementsType(useTriangles ? 0 : 1, indexStart, indexCount, instancesCount);
        }
        /**
         * Draw a list of points
         * @param verticesStart defines the index of first vertex to draw
         * @param verticesCount defines the count of vertices to draw
         * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
         */
        drawPointClouds(verticesStart, verticesCount, instancesCount) {
            this.drawArraysType(2, verticesStart, verticesCount, instancesCount);
        }
        /**
         * Draw a list of unindexed primitives
         * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
         * @param verticesStart defines the index of first vertex to draw
         * @param verticesCount defines the count of vertices to draw
         * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
         */
        drawUnIndexed(useTriangles, verticesStart, verticesCount, instancesCount) {
            this.drawArraysType(useTriangles ? 0 : 1, verticesStart, verticesCount, instancesCount);
        }
        /**
         * Draw a list of indexed primitives
         * @param fillMode defines the primitive to use
         * @param indexStart defines the starting index
         * @param indexCount defines the number of index to draw
         * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
         */
        drawElementsType(fillMode, indexStart, indexCount, instancesCount) {
            // Apply states
            this.applyStates();
            this._reportDrawCall();
            // Render
            const drawMode = this._drawMode(fillMode);
            const indexFormat = this._uintIndicesCurrentlySet ? this._gl.UNSIGNED_INT : this._gl.UNSIGNED_SHORT;
            const mult = this._uintIndicesCurrentlySet ? 4 : 2;
            if (instancesCount) {
                this._gl.drawElementsInstanced(drawMode, indexCount, indexFormat, indexStart * mult, instancesCount);
            }
            else {
                this._gl.drawElements(drawMode, indexCount, indexFormat, indexStart * mult);
            }
        }
        /**
         * Draw a list of unindexed primitives
         * @param fillMode defines the primitive to use
         * @param verticesStart defines the index of first vertex to draw
         * @param verticesCount defines the count of vertices to draw
         * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
         */
        drawArraysType(fillMode, verticesStart, verticesCount, instancesCount) {
            // Apply states
            this.applyStates();
            this._reportDrawCall();
            const drawMode = this._drawMode(fillMode);
            if (instancesCount) {
                this._gl.drawArraysInstanced(drawMode, verticesStart, verticesCount, instancesCount);
            }
            else {
                this._gl.drawArrays(drawMode, verticesStart, verticesCount);
            }
        }
        _drawMode(fillMode) {
            switch (fillMode) {
                // Triangle views
                case 0:
                    return this._gl.TRIANGLES;
                case 2:
                    return this._gl.POINTS;
                case 1:
                    return this._gl.LINES;
                // Draw modes
                case 3:
                    return this._gl.POINTS;
                case 4:
                    return this._gl.LINES;
                case 5:
                    return this._gl.LINE_LOOP;
                case 6:
                    return this._gl.LINE_STRIP;
                case 7:
                    return this._gl.TRIANGLE_STRIP;
                case 8:
                    return this._gl.TRIANGLE_FAN;
                default:
                    return this._gl.TRIANGLES;
            }
        }
        /** @internal */
        _reportDrawCall() {
            // Will be implemented by children
        }
        // Shaders
        /**
         * @internal
         */
        _releaseEffect(effect) {
            if (this._compiledEffects[effect._key]) {
                delete this._compiledEffects[effect._key];
            }
            const pipelineContext = effect.getPipelineContext();
            if (pipelineContext) {
                this._deletePipelineContext(pipelineContext);
            }
        }
        /**
         * @internal
         */
        _deletePipelineContext(pipelineContext) {
            const webGLPipelineContext = pipelineContext;
            if (webGLPipelineContext && webGLPipelineContext.program) {
                webGLPipelineContext.program.__SPECTOR_rebuildProgram = null;
                this._gl.deleteProgram(webGLPipelineContext.program);
            }
        }
        /** @internal */
        _getGlobalDefines(defines) {
            if (defines) {
                if (this.isNDCHalfZRange) {
                    defines["IS_NDC_HALF_ZRANGE"] = "";
                }
                else {
                    delete defines["IS_NDC_HALF_ZRANGE"];
                }
                if (this.useReverseDepthBuffer) {
                    defines["USE_REVERSE_DEPTHBUFFER"] = "";
                }
                else {
                    delete defines["USE_REVERSE_DEPTHBUFFER"];
                }
                if (this.useExactSrgbConversions) {
                    defines["USE_EXACT_SRGB_CONVERSIONS"] = "";
                }
                else {
                    delete defines["USE_EXACT_SRGB_CONVERSIONS"];
                }
                return;
            }
            else {
                let s = "";
                if (this.isNDCHalfZRange) {
                    s += "#define IS_NDC_HALF_ZRANGE";
                }
                if (this.useReverseDepthBuffer) {
                    if (s) {
                        s += "\n";
                    }
                    s += "#define USE_REVERSE_DEPTHBUFFER";
                }
                if (this.useExactSrgbConversions) {
                    if (s) {
                        s += "\n";
                    }
                    s += "#define USE_EXACT_SRGB_CONVERSIONS";
                }
                return s;
            }
        }
        /**
         * Create a new effect (used to store vertex/fragment shaders)
         * @param baseName defines the base name of the effect (The name of file without .fragment.fx or .vertex.fx)
         * @param attributesNamesOrOptions defines either a list of attribute names or an IEffectCreationOptions object
         * @param uniformsNamesOrEngine defines either a list of uniform names or the engine to use
         * @param samplers defines an array of string used to represent textures
         * @param defines defines the string containing the defines to use to compile the shaders
         * @param fallbacks defines the list of potential fallbacks to use if shader compilation fails
         * @param onCompiled defines a function to call when the effect creation is successful
         * @param onError defines a function to call when the effect creation has failed
         * @param indexParameters defines an object containing the index values to use to compile shaders (like the maximum number of simultaneous lights)
         * @param shaderLanguage the language the shader is written in (default: GLSL)
         * @returns the new Effect
         */
        createEffect(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, defines, fallbacks, onCompiled, onError, indexParameters, shaderLanguage = ShaderLanguage.GLSL) {
            var _a;
            const vertex = baseName.vertexElement || baseName.vertex || baseName.vertexToken || baseName.vertexSource || baseName;
            const fragment = baseName.fragmentElement || baseName.fragment || baseName.fragmentToken || baseName.fragmentSource || baseName;
            const globalDefines = this._getGlobalDefines();
            let fullDefines = (_a = defines !== null && defines !== void 0 ? defines : attributesNamesOrOptions.defines) !== null && _a !== void 0 ? _a : "";
            if (globalDefines) {
                fullDefines += globalDefines;
            }
            const name = vertex + "+" + fragment + "@" + fullDefines;
            if (this._compiledEffects[name]) {
                const compiledEffect = this._compiledEffects[name];
                if (onCompiled && compiledEffect.isReady()) {
                    onCompiled(compiledEffect);
                }
                return compiledEffect;
            }
            const effect = new Effect(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, this, defines, fallbacks, onCompiled, onError, indexParameters, name, shaderLanguage);
            this._compiledEffects[name] = effect;
            return effect;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static _ConcatenateShader(source, defines, shaderVersion = "") {
            return shaderVersion + (defines ? defines + "\n" : "") + source;
        }
        _compileShader(source, type, defines, shaderVersion) {
            return this._compileRawShader(ThinEngine._ConcatenateShader(source, defines, shaderVersion), type);
        }
        _compileRawShader(source, type) {
            const gl = this._gl;
            const shader = gl.createShader(type === "vertex" ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
            if (!shader) {
                let error = gl.NO_ERROR;
                let tempError = gl.NO_ERROR;
                while ((tempError = gl.getError()) !== gl.NO_ERROR) {
                    error = tempError;
                }
                throw new Error(`Something went wrong while creating a gl ${type} shader object. gl error=${error}, gl isContextLost=${gl.isContextLost()}, _contextWasLost=${this._contextWasLost}`);
            }
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            return shader;
        }
        /**
         * @internal
         */
        _getShaderSource(shader) {
            return this._gl.getShaderSource(shader);
        }
        /**
         * Directly creates a webGL program
         * @param pipelineContext  defines the pipeline context to attach to
         * @param vertexCode defines the vertex shader code to use
         * @param fragmentCode defines the fragment shader code to use
         * @param context defines the webGL context to use (if not set, the current one will be used)
         * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
         * @returns the new webGL program
         */
        createRawShaderProgram(pipelineContext, vertexCode, fragmentCode, context, transformFeedbackVaryings = null) {
            context = context || this._gl;
            const vertexShader = this._compileRawShader(vertexCode, "vertex");
            const fragmentShader = this._compileRawShader(fragmentCode, "fragment");
            return this._createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings);
        }
        /**
         * Creates a webGL program
         * @param pipelineContext  defines the pipeline context to attach to
         * @param vertexCode  defines the vertex shader code to use
         * @param fragmentCode defines the fragment shader code to use
         * @param defines defines the string containing the defines to use to compile the shaders
         * @param context defines the webGL context to use (if not set, the current one will be used)
         * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
         * @returns the new webGL program
         */
        createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null) {
            context = context || this._gl;
            const shaderVersion = this._webGLVersion > 1 ? "#version 300 es\n#define WEBGL2 \n" : "";
            const vertexShader = this._compileShader(vertexCode, "vertex", defines, shaderVersion);
            const fragmentShader = this._compileShader(fragmentCode, "fragment", defines, shaderVersion);
            return this._createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings);
        }
        /**
         * Inline functions in shader code that are marked to be inlined
         * @param code code to inline
         * @returns inlined code
         */
        inlineShaderCode(code) {
            // no inlining needed in the WebGL engine
            return code;
        }
        /**
         * Creates a new pipeline context
         * @param shaderProcessingContext defines the shader processing context used during the processing if available
         * @returns the new pipeline
         */
        createPipelineContext(shaderProcessingContext) {
            const pipelineContext = new WebGLPipelineContext();
            pipelineContext.engine = this;
            if (this._caps.parallelShaderCompile) {
                pipelineContext.isParallelCompiled = true;
            }
            return pipelineContext;
        }
        /**
         * Creates a new material context
         * @returns the new context
         */
        createMaterialContext() {
            return undefined;
        }
        /**
         * Creates a new draw context
         * @returns the new context
         */
        createDrawContext() {
            return undefined;
        }
        _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings = null) {
            const shaderProgram = context.createProgram();
            pipelineContext.program = shaderProgram;
            if (!shaderProgram) {
                throw new Error("Unable to create program");
            }
            context.attachShader(shaderProgram, vertexShader);
            context.attachShader(shaderProgram, fragmentShader);
            context.linkProgram(shaderProgram);
            pipelineContext.context = context;
            pipelineContext.vertexShader = vertexShader;
            pipelineContext.fragmentShader = fragmentShader;
            if (!pipelineContext.isParallelCompiled) {
                this._finalizePipelineContext(pipelineContext);
            }
            return shaderProgram;
        }
        _finalizePipelineContext(pipelineContext) {
            const context = pipelineContext.context;
            const vertexShader = pipelineContext.vertexShader;
            const fragmentShader = pipelineContext.fragmentShader;
            const program = pipelineContext.program;
            const linked = context.getProgramParameter(program, context.LINK_STATUS);
            if (!linked) {
                // Get more info
                // Vertex
                if (!this._gl.getShaderParameter(vertexShader, this._gl.COMPILE_STATUS)) {
                    const log = this._gl.getShaderInfoLog(vertexShader);
                    if (log) {
                        pipelineContext.vertexCompilationError = log;
                        throw new Error("VERTEX SHADER " + log);
                    }
                }
                // Fragment
                if (!this._gl.getShaderParameter(fragmentShader, this._gl.COMPILE_STATUS)) {
                    const log = this._gl.getShaderInfoLog(fragmentShader);
                    if (log) {
                        pipelineContext.fragmentCompilationError = log;
                        throw new Error("FRAGMENT SHADER " + log);
                    }
                }
                const error = context.getProgramInfoLog(program);
                if (error) {
                    pipelineContext.programLinkError = error;
                    throw new Error(error);
                }
            }
            if (this.validateShaderPrograms) {
                context.validateProgram(program);
                const validated = context.getProgramParameter(program, context.VALIDATE_STATUS);
                if (!validated) {
                    const error = context.getProgramInfoLog(program);
                    if (error) {
                        pipelineContext.programValidationError = error;
                        throw new Error(error);
                    }
                }
            }
            context.deleteShader(vertexShader);
            context.deleteShader(fragmentShader);
            pipelineContext.vertexShader = undefined;
            pipelineContext.fragmentShader = undefined;
            if (pipelineContext.onCompiled) {
                pipelineContext.onCompiled();
                pipelineContext.onCompiled = undefined;
            }
        }
        /**
         * @internal
         */
        _preparePipelineContext(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, rawVertexSourceCode, rawFragmentSourceCode, rebuildRebind, defines, transformFeedbackVaryings, key) {
            const webGLRenderingState = pipelineContext;
            if (createAsRaw) {
                webGLRenderingState.program = this.createRawShaderProgram(webGLRenderingState, vertexSourceCode, fragmentSourceCode, undefined, transformFeedbackVaryings);
            }
            else {
                webGLRenderingState.program = this.createShaderProgram(webGLRenderingState, vertexSourceCode, fragmentSourceCode, defines, undefined, transformFeedbackVaryings);
            }
            webGLRenderingState.program.__SPECTOR_rebuildProgram = rebuildRebind;
        }
        /**
         * @internal
         */
        _isRenderingStateCompiled(pipelineContext) {
            const webGLPipelineContext = pipelineContext;
            if (this._isDisposed || webGLPipelineContext._isDisposed) {
                return false;
            }
            if (this._gl.getProgramParameter(webGLPipelineContext.program, this._caps.parallelShaderCompile.COMPLETION_STATUS_KHR)) {
                this._finalizePipelineContext(webGLPipelineContext);
                return true;
            }
            return false;
        }
        /**
         * @internal
         */
        _executeWhenRenderingStateIsCompiled(pipelineContext, action) {
            const webGLPipelineContext = pipelineContext;
            if (!webGLPipelineContext.isParallelCompiled) {
                action();
                return;
            }
            const oldHandler = webGLPipelineContext.onCompiled;
            if (oldHandler) {
                webGLPipelineContext.onCompiled = () => {
                    oldHandler();
                    action();
                };
            }
            else {
                webGLPipelineContext.onCompiled = action;
            }
        }
        /**
         * Gets the list of webGL uniform locations associated with a specific program based on a list of uniform names
         * @param pipelineContext defines the pipeline context to use
         * @param uniformsNames defines the list of uniform names
         * @returns an array of webGL uniform locations
         */
        getUniforms(pipelineContext, uniformsNames) {
            const results = new Array();
            const webGLPipelineContext = pipelineContext;
            for (let index = 0; index < uniformsNames.length; index++) {
                results.push(this._gl.getUniformLocation(webGLPipelineContext.program, uniformsNames[index]));
            }
            return results;
        }
        /**
         * Gets the list of active attributes for a given webGL program
         * @param pipelineContext defines the pipeline context to use
         * @param attributesNames defines the list of attribute names to get
         * @returns an array of indices indicating the offset of each attribute
         */
        getAttributes(pipelineContext, attributesNames) {
            const results = [];
            const webGLPipelineContext = pipelineContext;
            for (let index = 0; index < attributesNames.length; index++) {
                try {
                    results.push(this._gl.getAttribLocation(webGLPipelineContext.program, attributesNames[index]));
                }
                catch (e) {
                    results.push(-1);
                }
            }
            return results;
        }
        /**
         * Activates an effect, making it the current one (ie. the one used for rendering)
         * @param effect defines the effect to activate
         */
        enableEffect(effect) {
            effect = effect !== null && DrawWrapper.IsWrapper(effect) ? effect.effect : effect; // get only the effect, we don't need a Wrapper in the WebGL engine
            if (!effect || effect === this._currentEffect) {
                return;
            }
            this._stencilStateComposer.stencilMaterial = undefined;
            effect = effect;
            // Use program
            this.bindSamplers(effect);
            this._currentEffect = effect;
            if (effect.onBind) {
                effect.onBind(effect);
            }
            if (effect._onBindObservable) {
                effect._onBindObservable.notifyObservers(effect);
            }
        }
        /**
         * Set the value of an uniform to a number (int)
         * @param uniform defines the webGL uniform location where to store the value
         * @param value defines the int number to store
         * @returns true if the value was set
         */
        setInt(uniform, value) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform1i(uniform, value);
            return true;
        }
        /**
         * Set the value of an uniform to a int2
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @returns true if the value was set
         */
        setInt2(uniform, x, y) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform2i(uniform, x, y);
            return true;
        }
        /**
         * Set the value of an uniform to a int3
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @param z defines the 3rd component of the value
         * @returns true if the value was set
         */
        setInt3(uniform, x, y, z) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform3i(uniform, x, y, z);
            return true;
        }
        /**
         * Set the value of an uniform to a int4
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @param z defines the 3rd component of the value
         * @param w defines the 4th component of the value
         * @returns true if the value was set
         */
        setInt4(uniform, x, y, z, w) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform4i(uniform, x, y, z, w);
            return true;
        }
        /**
         * Set the value of an uniform to an array of int32
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of int32 to store
         * @returns true if the value was set
         */
        setIntArray(uniform, array) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform1iv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of int32 (stored as vec2)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of int32 to store
         * @returns true if the value was set
         */
        setIntArray2(uniform, array) {
            if (!uniform || array.length % 2 !== 0) {
                return false;
            }
            this._gl.uniform2iv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of int32 (stored as vec3)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of int32 to store
         * @returns true if the value was set
         */
        setIntArray3(uniform, array) {
            if (!uniform || array.length % 3 !== 0) {
                return false;
            }
            this._gl.uniform3iv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of int32 (stored as vec4)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of int32 to store
         * @returns true if the value was set
         */
        setIntArray4(uniform, array) {
            if (!uniform || array.length % 4 !== 0) {
                return false;
            }
            this._gl.uniform4iv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to a number (unsigned int)
         * @param uniform defines the webGL uniform location where to store the value
         * @param value defines the unsigned int number to store
         * @returns true if the value was set
         */
        setUInt(uniform, value) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform1ui(uniform, value);
            return true;
        }
        /**
         * Set the value of an uniform to a unsigned int2
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @returns true if the value was set
         */
        setUInt2(uniform, x, y) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform2ui(uniform, x, y);
            return true;
        }
        /**
         * Set the value of an uniform to a unsigned int3
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @param z defines the 3rd component of the value
         * @returns true if the value was set
         */
        setUInt3(uniform, x, y, z) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform3ui(uniform, x, y, z);
            return true;
        }
        /**
         * Set the value of an uniform to a unsigned int4
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @param z defines the 3rd component of the value
         * @param w defines the 4th component of the value
         * @returns true if the value was set
         */
        setUInt4(uniform, x, y, z, w) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform4ui(uniform, x, y, z, w);
            return true;
        }
        /**
         * Set the value of an uniform to an array of unsigned int32
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of unsigned int32 to store
         * @returns true if the value was set
         */
        setUIntArray(uniform, array) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform1uiv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of unsigned int32 (stored as vec2)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of unsigned int32 to store
         * @returns true if the value was set
         */
        setUIntArray2(uniform, array) {
            if (!uniform || array.length % 2 !== 0) {
                return false;
            }
            this._gl.uniform2uiv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of unsigned int32 (stored as vec3)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of unsigned int32 to store
         * @returns true if the value was set
         */
        setUIntArray3(uniform, array) {
            if (!uniform || array.length % 3 !== 0) {
                return false;
            }
            this._gl.uniform3uiv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of unsigned int32 (stored as vec4)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of unsigned int32 to store
         * @returns true if the value was set
         */
        setUIntArray4(uniform, array) {
            if (!uniform || array.length % 4 !== 0) {
                return false;
            }
            this._gl.uniform4uiv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of number
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of number to store
         * @returns true if the value was set
         */
        setArray(uniform, array) {
            if (!uniform) {
                return false;
            }
            if (array.length < 1) {
                return false;
            }
            this._gl.uniform1fv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of number (stored as vec2)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of number to store
         * @returns true if the value was set
         */
        setArray2(uniform, array) {
            if (!uniform || array.length % 2 !== 0) {
                return false;
            }
            this._gl.uniform2fv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of number (stored as vec3)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of number to store
         * @returns true if the value was set
         */
        setArray3(uniform, array) {
            if (!uniform || array.length % 3 !== 0) {
                return false;
            }
            this._gl.uniform3fv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of number (stored as vec4)
         * @param uniform defines the webGL uniform location where to store the value
         * @param array defines the array of number to store
         * @returns true if the value was set
         */
        setArray4(uniform, array) {
            if (!uniform || array.length % 4 !== 0) {
                return false;
            }
            this._gl.uniform4fv(uniform, array);
            return true;
        }
        /**
         * Set the value of an uniform to an array of float32 (stored as matrices)
         * @param uniform defines the webGL uniform location where to store the value
         * @param matrices defines the array of float32 to store
         * @returns true if the value was set
         */
        setMatrices(uniform, matrices) {
            if (!uniform) {
                return false;
            }
            this._gl.uniformMatrix4fv(uniform, false, matrices);
            return true;
        }
        /**
         * Set the value of an uniform to a matrix (3x3)
         * @param uniform defines the webGL uniform location where to store the value
         * @param matrix defines the Float32Array representing the 3x3 matrix to store
         * @returns true if the value was set
         */
        setMatrix3x3(uniform, matrix) {
            if (!uniform) {
                return false;
            }
            this._gl.uniformMatrix3fv(uniform, false, matrix);
            return true;
        }
        /**
         * Set the value of an uniform to a matrix (2x2)
         * @param uniform defines the webGL uniform location where to store the value
         * @param matrix defines the Float32Array representing the 2x2 matrix to store
         * @returns true if the value was set
         */
        setMatrix2x2(uniform, matrix) {
            if (!uniform) {
                return false;
            }
            this._gl.uniformMatrix2fv(uniform, false, matrix);
            return true;
        }
        /**
         * Set the value of an uniform to a number (float)
         * @param uniform defines the webGL uniform location where to store the value
         * @param value defines the float number to store
         * @returns true if the value was transferred
         */
        setFloat(uniform, value) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform1f(uniform, value);
            return true;
        }
        /**
         * Set the value of an uniform to a vec2
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @returns true if the value was set
         */
        setFloat2(uniform, x, y) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform2f(uniform, x, y);
            return true;
        }
        /**
         * Set the value of an uniform to a vec3
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @param z defines the 3rd component of the value
         * @returns true if the value was set
         */
        setFloat3(uniform, x, y, z) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform3f(uniform, x, y, z);
            return true;
        }
        /**
         * Set the value of an uniform to a vec4
         * @param uniform defines the webGL uniform location where to store the value
         * @param x defines the 1st component of the value
         * @param y defines the 2nd component of the value
         * @param z defines the 3rd component of the value
         * @param w defines the 4th component of the value
         * @returns true if the value was set
         */
        setFloat4(uniform, x, y, z, w) {
            if (!uniform) {
                return false;
            }
            this._gl.uniform4f(uniform, x, y, z, w);
            return true;
        }
        // States
        /**
         * Apply all cached states (depth, culling, stencil and alpha)
         */
        applyStates() {
            this._depthCullingState.apply(this._gl);
            this._stencilStateComposer.apply(this._gl);
            this._alphaState.apply(this._gl);
            if (this._colorWriteChanged) {
                this._colorWriteChanged = false;
                const enable = this._colorWrite;
                this._gl.colorMask(enable, enable, enable, enable);
            }
        }
        /**
         * Enable or disable color writing
         * @param enable defines the state to set
         */
        setColorWrite(enable) {
            if (enable !== this._colorWrite) {
                this._colorWriteChanged = true;
                this._colorWrite = enable;
            }
        }
        /**
         * Gets a boolean indicating if color writing is enabled
         * @returns the current color writing state
         */
        getColorWrite() {
            return this._colorWrite;
        }
        /**
         * Gets the depth culling state manager
         */
        get depthCullingState() {
            return this._depthCullingState;
        }
        /**
         * Gets the alpha state manager
         */
        get alphaState() {
            return this._alphaState;
        }
        /**
         * Gets the stencil state manager
         */
        get stencilState() {
            return this._stencilState;
        }
        /**
         * Gets the stencil state composer
         */
        get stencilStateComposer() {
            return this._stencilStateComposer;
        }
        // Textures
        /**
         * Clears the list of texture accessible through engine.
         * This can help preventing texture load conflict due to name collision.
         */
        clearInternalTexturesCache() {
            this._internalTexturesCache.length = 0;
        }
        /**
         * Force the entire cache to be cleared
         * You should not have to use this function unless your engine needs to share the webGL context with another engine
         * @param bruteForce defines a boolean to force clearing ALL caches (including stencil, detoh and alpha states)
         */
        wipeCaches(bruteForce) {
            if (this.preventCacheWipeBetweenFrames && !bruteForce) {
                return;
            }
            this._currentEffect = null;
            this._viewportCached.x = 0;
            this._viewportCached.y = 0;
            this._viewportCached.z = 0;
            this._viewportCached.w = 0;
            // Done before in case we clean the attributes
            this._unbindVertexArrayObject();
            if (bruteForce) {
                this._currentProgram = null;
                this.resetTextureCache();
                this._stencilStateComposer.reset();
                this._depthCullingState.reset();
                this._depthCullingState.depthFunc = this._gl.LEQUAL;
                this._alphaState.reset();
                this._alphaMode = 1;
                this._alphaEquation = 0;
                this._colorWrite = true;
                this._colorWriteChanged = true;
                this._unpackFlipYCached = null;
                this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE);
                this._gl.pixelStorei(this._gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
                this._mustWipeVertexAttributes = true;
                this.unbindAllAttributes();
            }
            this._resetVertexBufferBinding();
            this._cachedIndexBuffer = null;
            this._cachedEffectForVertexBuffers = null;
            this.bindIndexBuffer(null);
        }
        /**
         * @internal
         */
        _getSamplingParameters(samplingMode, generateMipMaps) {
            const gl = this._gl;
            let magFilter = gl.NEAREST;
            let minFilter = gl.NEAREST;
            switch (samplingMode) {
                case 11:
                    magFilter = gl.LINEAR;
                    if (generateMipMaps) {
                        minFilter = gl.LINEAR_MIPMAP_NEAREST;
                    }
                    else {
                        minFilter = gl.LINEAR;
                    }
                    break;
                case 3:
                    magFilter = gl.LINEAR;
                    if (generateMipMaps) {
                        minFilter = gl.LINEAR_MIPMAP_LINEAR;
                    }
                    else {
                        minFilter = gl.LINEAR;
                    }
                    break;
                case 8:
                    magFilter = gl.NEAREST;
                    if (generateMipMaps) {
                        minFilter = gl.NEAREST_MIPMAP_LINEAR;
                    }
                    else {
                        minFilter = gl.NEAREST;
                    }
                    break;
                case 4:
                    magFilter = gl.NEAREST;
                    if (generateMipMaps) {
                        minFilter = gl.NEAREST_MIPMAP_NEAREST;
                    }
                    else {
                        minFilter = gl.NEAREST;
                    }
                    break;
                case 5:
                    magFilter = gl.NEAREST;
                    if (generateMipMaps) {
                        minFilter = gl.LINEAR_MIPMAP_NEAREST;
                    }
                    else {
                        minFilter = gl.LINEAR;
                    }
                    break;
                case 6:
                    magFilter = gl.NEAREST;
                    if (generateMipMaps) {
                        minFilter = gl.LINEAR_MIPMAP_LINEAR;
                    }
                    else {
                        minFilter = gl.LINEAR;
                    }
                    break;
                case 7:
                    magFilter = gl.NEAREST;
                    minFilter = gl.LINEAR;
                    break;
                case 1:
                    magFilter = gl.NEAREST;
                    minFilter = gl.NEAREST;
                    break;
                case 9:
                    magFilter = gl.LINEAR;
                    if (generateMipMaps) {
                        minFilter = gl.NEAREST_MIPMAP_NEAREST;
                    }
                    else {
                        minFilter = gl.NEAREST;
                    }
                    break;
                case 10:
                    magFilter = gl.LINEAR;
                    if (generateMipMaps) {
                        minFilter = gl.NEAREST_MIPMAP_LINEAR;
                    }
                    else {
                        minFilter = gl.NEAREST;
                    }
                    break;
                case 2:
                    magFilter = gl.LINEAR;
                    minFilter = gl.LINEAR;
                    break;
                case 12:
                    magFilter = gl.LINEAR;
                    minFilter = gl.NEAREST;
                    break;
            }
            return {
                min: minFilter,
                mag: magFilter,
            };
        }
        /** @internal */
        _createTexture() {
            const texture = this._gl.createTexture();
            if (!texture) {
                throw new Error("Unable to create texture");
            }
            return texture;
        }
        /** @internal */
        _createHardwareTexture() {
            return new WebGLHardwareTexture(this._createTexture(), this._gl);
        }
        /**
         * Creates an internal texture without binding it to a framebuffer
         * @internal
         * @param size defines the size of the texture
         * @param options defines the options used to create the texture
         * @param delayGPUTextureCreation true to delay the texture creation the first time it is really needed. false to create it right away
         * @param source source type of the texture
         * @returns a new internal texture
         */
        _createInternalTexture(size, options, delayGPUTextureCreation = true, source = InternalTextureSource.Unknown) {
            var _a;
            let generateMipMaps = false;
            let type = 0;
            let samplingMode = 3;
            let format = 5;
            let useSRGBBuffer = false;
            let samples = 1;
            let label;
            if (options !== undefined && typeof options === "object") {
                generateMipMaps = !!options.generateMipMaps;
                type = options.type === undefined ? 0 : options.type;
                samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
                format = options.format === undefined ? 5 : options.format;
                useSRGBBuffer = options.useSRGBBuffer === undefined ? false : options.useSRGBBuffer;
                samples = (_a = options.samples) !== null && _a !== void 0 ? _a : 1;
                label = options.label;
            }
            else {
                generateMipMaps = !!options;
            }
            useSRGBBuffer && (useSRGBBuffer = this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU));
            if (type === 1 && !this._caps.textureFloatLinearFiltering) {
                // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
                samplingMode = 1;
            }
            else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) {
                // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
                samplingMode = 1;
            }
            if (type === 1 && !this._caps.textureFloat) {
                type = 0;
                Logger.Warn("Float textures are not supported. Type forced to TEXTURETYPE_UNSIGNED_BYTE");
            }
            const gl = this._gl;
            const texture = new InternalTexture(this, source);
            const width = size.width || size;
            const height = size.height || size;
            const layers = size.layers || 0;
            const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
            const target = layers !== 0 ? gl.TEXTURE_2D_ARRAY : gl.TEXTURE_2D;
            const sizedFormat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
            const internalFormat = this._getInternalFormat(format);
            const textureType = this._getWebGLTextureType(type);
            // Bind
            this._bindTextureDirectly(target, texture);
            if (layers !== 0) {
                texture.is2DArray = true;
                gl.texImage3D(target, 0, sizedFormat, width, height, layers, 0, internalFormat, textureType, null);
            }
            else {
                gl.texImage2D(target, 0, sizedFormat, width, height, 0, internalFormat, textureType, null);
            }
            gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filters.mag);
            gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filters.min);
            gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            // MipMaps
            if (generateMipMaps) {
                this._gl.generateMipmap(target);
            }
            this._bindTextureDirectly(target, null);
            texture._useSRGBBuffer = useSRGBBuffer;
            texture.baseWidth = width;
            texture.baseHeight = height;
            texture.width = width;
            texture.height = height;
            texture.depth = layers;
            texture.isReady = true;
            texture.samples = samples;
            texture.generateMipMaps = generateMipMaps;
            texture.samplingMode = samplingMode;
            texture.type = type;
            texture.format = format;
            texture.label = label;
            this._internalTexturesCache.push(texture);
            return texture;
        }
        /**
         * @internal
         */
        _getUseSRGBBuffer(useSRGBBuffer, noMipmap) {
            // Generating mipmaps for sRGB textures is not supported in WebGL1 so we must disable the support if mipmaps is enabled
            return useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU || noMipmap);
        }
        _createTextureBase(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, prepareTexture, prepareTextureProcessFunction, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, useSRGBBuffer) {
            url = url || "";
            const fromData = url.substr(0, 5) === "data:";
            const fromBlob = url.substr(0, 5) === "blob:";
            const isBase64 = fromData && url.indexOf(";base64,") !== -1;
            const texture = fallback ? fallback : new InternalTexture(this, InternalTextureSource.Url);
            if (texture !== fallback) {
                texture.label = url.substring(0, 60); // default label, can be overriden by the caller
            }
            const originalUrl = url;
            if (this._transformTextureUrl && !isBase64 && !fallback && !buffer) {
                url = this._transformTextureUrl(url);
            }
            if (originalUrl !== url) {
                texture._originalUrl = originalUrl;
            }
            // establish the file extension, if possible
            const lastDot = url.lastIndexOf(".");
            let extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
            let loader = null;
            // Remove query string
            const queryStringIndex = extension.indexOf("?");
            if (queryStringIndex > -1) {
                extension = extension.split("?")[0];
            }
            for (const availableLoader of ThinEngine._TextureLoaders) {
                if (availableLoader.canLoad(extension, mimeType)) {
                    loader = availableLoader;
                    break;
                }
            }
            if (scene) {
                scene.addPendingData(texture);
            }
            texture.url = url;
            texture.generateMipMaps = !noMipmap;
            texture.samplingMode = samplingMode;
            texture.invertY = invertY;
            texture._useSRGBBuffer = this._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
            if (!this._doNotHandleContextLost) {
                // Keep a link to the buffer only if we plan to handle context lost
                texture._buffer = buffer;
            }
            let onLoadObserver = null;
            if (onLoad && !fallback) {
                onLoadObserver = texture.onLoadedObservable.add(onLoad);
            }
            if (!fallback) {
                this._internalTexturesCache.push(texture);
            }
            const onInternalError = (message, exception) => {
                if (scene) {
                    scene.removePendingData(texture);
                }
                if (url === originalUrl) {
                    if (onLoadObserver) {
                        texture.onLoadedObservable.remove(onLoadObserver);
                    }
                    if (EngineStore.UseFallbackTexture) {
                        this._createTextureBase(EngineStore.FallbackTexture, noMipmap, texture.invertY, scene, samplingMode, null, onError, prepareTexture, prepareTextureProcessFunction, buffer, texture);
                    }
                    message = (message || "Unknown error") + (EngineStore.UseFallbackTexture ? " - Fallback texture was used" : "");
                    texture.onErrorObservable.notifyObservers({ message, exception });
                    if (onError) {
                        onError(message, exception);
                    }
                }
                else {
                    // fall back to the original url if the transformed url fails to load
                    Logger.Warn(`Failed to load ${url}, falling back to ${originalUrl}`);
                    this._createTextureBase(originalUrl, noMipmap, texture.invertY, scene, samplingMode, onLoad, onError, prepareTexture, prepareTextureProcessFunction, buffer, texture, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
                }
            };
            // processing for non-image formats
            if (loader) {
                const callback = (data) => {
                    loader.loadData(data, texture, (width, height, loadMipmap, isCompressed, done, loadFailed) => {
                        if (loadFailed) {
                            onInternalError("TextureLoader failed to load data");
                        }
                        else {
                            prepareTexture(texture, extension, scene, { width, height }, texture.invertY, !loadMipmap, isCompressed, () => {
                                done();
                                return false;
                            }, samplingMode);
                        }
                    }, loaderOptions);
                };
                if (!buffer) {
                    this._loadFile(url, (data) => callback(new Uint8Array(data)), undefined, scene ? scene.offlineProvider : undefined, true, (request, exception) => {
                        onInternalError("Unable to load " + (request ? request.responseURL : url, exception));
                    });
                }
                else {
                    if (buffer instanceof ArrayBuffer) {
                        callback(new Uint8Array(buffer));
                    }
                    else if (ArrayBuffer.isView(buffer)) {
                        callback(buffer);
                    }
                    else {
                        if (onError) {
                            onError("Unable to load: only ArrayBuffer or ArrayBufferView is supported", null);
                        }
                    }
                }
            }
            else {
                const onload = (img) => {
                    if (fromBlob && !this._doNotHandleContextLost) {
                        // We need to store the image if we need to rebuild the texture
                        // in case of a webgl context lost
                        texture._buffer = img;
                    }
                    prepareTexture(texture, extension, scene, img, texture.invertY, noMipmap, false, prepareTextureProcessFunction, samplingMode);
                };
                // According to the WebGL spec section 6.10, ImageBitmaps must be inverted on creation.
                // So, we pass imageOrientation to _FileToolsLoadImage() as it may create an ImageBitmap.
                if (!fromData || isBase64) {
                    if (buffer && (typeof buffer.decoding === "string" || buffer.close)) {
                        onload(buffer);
                    }
                    else {
                        ThinEngine._FileToolsLoadImage(url, onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? { imageOrientation: "flipY" } : undefined);
                    }
                }
                else if (typeof buffer === "string" || buffer instanceof ArrayBuffer || ArrayBuffer.isView(buffer) || buffer instanceof Blob) {
                    ThinEngine._FileToolsLoadImage(buffer, onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? { imageOrientation: "flipY" } : undefined);
                }
                else if (buffer) {
                    onload(buffer);
                }
            }
            return texture;
        }
        /**
         * Usually called from Texture.ts.
         * Passed information to create a WebGLTexture
         * @param url defines a value which contains one of the following:
         * * A conventional http URL, e.g. 'http://...' or 'file://...'
         * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
         * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
         * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
         * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
         * @param scene needed for loading to the correct scene
         * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
         * @param onLoad optional callback to be called upon successful completion
         * @param onError optional callback to be called upon failure
         * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
         * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
         * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
         * @param forcedExtension defines the extension to use to pick the right loader
         * @param mimeType defines an optional mime type
         * @param loaderOptions options to be passed to the loader
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
         * @returns a InternalTexture for assignment back into BABYLON.Texture
         */
        createTexture(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, creationFlags, useSRGBBuffer) {
            return this._createTextureBase(url, noMipmap, invertY, scene, samplingMode, onLoad, onError, this._prepareWebGLTexture.bind(this), (potWidth, potHeight, img, extension, texture, continuationCallback) => {
                const gl = this._gl;
                const isPot = img.width === potWidth && img.height === potHeight;
                const internalFormat = format
                    ? this._getInternalFormat(format, texture._useSRGBBuffer)
                    : extension === ".jpg" && !texture._useSRGBBuffer
                        ? gl.RGB
                        : texture._useSRGBBuffer
                            ? this._glSRGBExtensionValues.SRGB8_ALPHA8
                            : gl.RGBA;
                let texelFormat = format ? this._getInternalFormat(format) : extension === ".jpg" && !texture._useSRGBBuffer ? gl.RGB : gl.RGBA;
                if (texture._useSRGBBuffer && this.webGLVersion === 1) {
                    texelFormat = internalFormat;
                }
                if (isPot) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, img);
                    return false;
                }
                const maxTextureSize = this._caps.maxTextureSize;
                if (img.width > maxTextureSize || img.height > maxTextureSize || !this._supportsHardwareTextureRescaling) {
                    this._prepareWorkingCanvas();
                    if (!this._workingCanvas || !this._workingContext) {
                        return false;
                    }
                    this._workingCanvas.width = potWidth;
                    this._workingCanvas.height = potHeight;
                    this._workingContext.drawImage(img, 0, 0, img.width, img.height, 0, 0, potWidth, potHeight);
                    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, this._workingCanvas);
                    texture.width = potWidth;
                    texture.height = potHeight;
                    return false;
                }
                else {
                    // Using shaders when possible to rescale because canvas.drawImage is lossy
                    const source = new InternalTexture(this, InternalTextureSource.Temp);
                    this._bindTextureDirectly(gl.TEXTURE_2D, source, true);
                    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, img);
                    this._rescaleTexture(source, texture, scene, internalFormat, () => {
                        this._releaseTexture(source);
                        this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
                        continuationCallback();
                    });
                }
                return true;
            }, buffer, fallback, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
        }
        /**
         * Loads an image as an HTMLImageElement.
         * @param input url string, ArrayBuffer, or Blob to load
         * @param onLoad callback called when the image successfully loads
         * @param onError callback called when the image fails to load
         * @param offlineProvider offline provider for caching
         * @param mimeType optional mime type
         * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
         * @returns the HTMLImageElement of the loaded image
         * @internal
         */
        static _FileToolsLoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
            throw _WarnImport("FileTools");
        }
        /**
         * @internal
         */
        _rescaleTexture(source, destination, scene, internalFormat, onComplete) { }
        /**
         * Creates a raw texture
         * @param data defines the data to store in the texture
         * @param width defines the width of the texture
         * @param height defines the height of the texture
         * @param format defines the format of the data
         * @param generateMipMaps defines if the engine should generate the mip levels
         * @param invertY defines if data must be stored with Y axis inverted
         * @param samplingMode defines the required sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
         * @param compression defines the compression used (null by default)
         * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
         * @returns the raw texture inside an InternalTexture
         */
        createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, creationFlags = 0, useSRGBBuffer = false) {
            throw _WarnImport("Engine.RawTexture");
        }
        /**
         * Creates a new raw cube texture
         * @param data defines the array of data to use to create each face
         * @param size defines the size of the textures
         * @param format defines the format of the data
         * @param type defines the type of the data (like Engine.TEXTURETYPE_UNSIGNED_INT)
         * @param generateMipMaps  defines if the engine should generate the mip levels
         * @param invertY defines if data must be stored with Y axis inverted
         * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
         * @param compression defines the compression used (null by default)
         * @returns the cube texture as an InternalTexture
         */
        createRawCubeTexture(data, size, format, type, generateMipMaps, invertY, samplingMode, compression = null) {
            throw _WarnImport("Engine.RawTexture");
        }
        /**
         * Creates a new raw 3D texture
         * @param data defines the data used to create the texture
         * @param width defines the width of the texture
         * @param height defines the height of the texture
         * @param depth defines the depth of the texture
         * @param format defines the format of the texture
         * @param generateMipMaps defines if the engine must generate mip levels
         * @param invertY defines if data must be stored with Y axis inverted
         * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
         * @param compression defines the compressed used (can be null)
         * @param textureType defines the compressed used (can be null)
         * @returns a new raw 3D texture (stored in an InternalTexture)
         */
        createRawTexture3D(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
            throw _WarnImport("Engine.RawTexture");
        }
        /**
         * Creates a new raw 2D array texture
         * @param data defines the data used to create the texture
         * @param width defines the width of the texture
         * @param height defines the height of the texture
         * @param depth defines the number of layers of the texture
         * @param format defines the format of the texture
         * @param generateMipMaps defines if the engine must generate mip levels
         * @param invertY defines if data must be stored with Y axis inverted
         * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
         * @param compression defines the compressed used (can be null)
         * @param textureType defines the compressed used (can be null)
         * @returns a new raw 2D array texture (stored in an InternalTexture)
         */
        createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
            throw _WarnImport("Engine.RawTexture");
        }
        /**
         * @internal
         */
        _unpackFlipY(value) {
            if (this._unpackFlipYCached !== value) {
                this._gl.pixelStorei(this._gl.UNPACK_FLIP_Y_WEBGL, value ? 1 : 0);
                if (this.enableUnpackFlipYCached) {
                    this._unpackFlipYCached = value;
                }
            }
        }
        /** @internal */
        _getUnpackAlignement() {
            return this._gl.getParameter(this._gl.UNPACK_ALIGNMENT);
        }
        _getTextureTarget(texture) {
            if (texture.isCube) {
                return this._gl.TEXTURE_CUBE_MAP;
            }
            else if (texture.is3D) {
                return this._gl.TEXTURE_3D;
            }
            else if (texture.is2DArray || texture.isMultiview) {
                return this._gl.TEXTURE_2D_ARRAY;
            }
            return this._gl.TEXTURE_2D;
        }
        /**
         * Update the sampling mode of a given texture
         * @param samplingMode defines the required sampling mode
         * @param texture defines the texture to update
         * @param generateMipMaps defines whether to generate mipmaps for the texture
         */
        updateTextureSamplingMode(samplingMode, texture, generateMipMaps = false) {
            const target = this._getTextureTarget(texture);
            const filters = this._getSamplingParameters(samplingMode, texture.useMipMaps || generateMipMaps);
            this._setTextureParameterInteger(target, this._gl.TEXTURE_MAG_FILTER, filters.mag, texture);
            this._setTextureParameterInteger(target, this._gl.TEXTURE_MIN_FILTER, filters.min);
            if (generateMipMaps) {
                texture.generateMipMaps = true;
                this._gl.generateMipmap(target);
            }
            this._bindTextureDirectly(target, null);
            texture.samplingMode = samplingMode;
        }
        /**
         * Update the dimensions of a texture
         * @param texture texture to update
         * @param width new width of the texture
         * @param height new height of the texture
         * @param depth new depth of the texture
         */
        updateTextureDimensions(texture, width, height, depth = 1) { }
        /**
         * Update the sampling mode of a given texture
         * @param texture defines the texture to update
         * @param wrapU defines the texture wrap mode of the u coordinates
         * @param wrapV defines the texture wrap mode of the v coordinates
         * @param wrapR defines the texture wrap mode of the r coordinates
         */
        updateTextureWrappingMode(texture, wrapU, wrapV = null, wrapR = null) {
            const target = this._getTextureTarget(texture);
            if (wrapU !== null) {
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(wrapU), texture);
                texture._cachedWrapU = wrapU;
            }
            if (wrapV !== null) {
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(wrapV), texture);
                texture._cachedWrapV = wrapV;
            }
            if ((texture.is2DArray || texture.is3D) && wrapR !== null) {
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(wrapR), texture);
                texture._cachedWrapR = wrapR;
            }
            this._bindTextureDirectly(target, null);
        }
        /**
         * @internal
         */
        _setupDepthStencilTexture(internalTexture, size, generateStencil, bilinearFiltering, comparisonFunction, samples = 1) {
            const width = size.width || size;
            const height = size.height || size;
            const layers = size.layers || 0;
            internalTexture.baseWidth = width;
            internalTexture.baseHeight = height;
            internalTexture.width = width;
            internalTexture.height = height;
            internalTexture.is2DArray = layers > 0;
            internalTexture.depth = layers;
            internalTexture.isReady = true;
            internalTexture.samples = samples;
            internalTexture.generateMipMaps = false;
            internalTexture.samplingMode = bilinearFiltering ? 2 : 1;
            internalTexture.type = 0;
            internalTexture._comparisonFunction = comparisonFunction;
            const gl = this._gl;
            const target = this._getTextureTarget(internalTexture);
            const samplingParameters = this._getSamplingParameters(internalTexture.samplingMode, false);
            gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, samplingParameters.mag);
            gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, samplingParameters.min);
            gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            // TEXTURE_COMPARE_FUNC/MODE are only availble in WebGL2.
            if (this.webGLVersion > 1) {
                if (comparisonFunction === 0) {
                    gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, 515);
                    gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.NONE);
                }
                else {
                    gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                    gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
                }
            }
        }
        /**
         * @internal
         */
        _uploadCompressedDataToTextureDirectly(texture, internalFormat, width, height, data, faceIndex = 0, lod = 0) {
            const gl = this._gl;
            let target = gl.TEXTURE_2D;
            if (texture.isCube) {
                target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
            }
            if (texture._useSRGBBuffer) {
                switch (internalFormat) {
                    case 37492:
                    case 36196:
                        // Note, if using ETC1 and sRGB is requested, this will use ETC2 if available.
                        if (this._caps.etc2) {
                            internalFormat = gl.COMPRESSED_SRGB8_ETC2;
                        }
                        else {
                            texture._useSRGBBuffer = false;
                        }
                        break;
                    case 37496:
                        if (this._caps.etc2) {
                            internalFormat = gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
                        }
                        else {
                            texture._useSRGBBuffer = false;
                        }
                        break;
                    case 36492:
                        internalFormat = gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
                        break;
                    case 37808:
                        internalFormat = gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
                        break;
                    case 33776:
                        if (this._caps.s3tc_srgb) {
                            internalFormat = gl.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                        }
                        else {
                            // S3TC sRGB extension not supported
                            texture._useSRGBBuffer = false;
                        }
                        break;
                    case 33777:
                        if (this._caps.s3tc_srgb) {
                            internalFormat = gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                        }
                        else {
                            // S3TC sRGB extension not supported
                            texture._useSRGBBuffer = false;
                        }
                        break;
                    case 33779:
                        if (this._caps.s3tc_srgb) {
                            internalFormat = gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                        }
                        else {
                            // S3TC sRGB extension not supported
                            texture._useSRGBBuffer = false;
                        }
                        break;
                    default:
                        // We don't support a sRGB format corresponding to internalFormat, so revert to non sRGB format
                        texture._useSRGBBuffer = false;
                        break;
                }
            }
            this._gl.compressedTexImage2D(target, lod, internalFormat, width, height, 0, data);
        }
        /**
         * @internal
         */
        _uploadDataToTextureDirectly(texture, imageData, faceIndex = 0, lod = 0, babylonInternalFormat, useTextureWidthAndHeight = false) {
            const gl = this._gl;
            const textureType = this._getWebGLTextureType(texture.type);
            const format = this._getInternalFormat(texture.format);
            const internalFormat = babylonInternalFormat === undefined
                ? this._getRGBABufferInternalSizedFormat(texture.type, texture.format, texture._useSRGBBuffer)
                : this._getInternalFormat(babylonInternalFormat, texture._useSRGBBuffer);
            this._unpackFlipY(texture.invertY);
            let target = gl.TEXTURE_2D;
            if (texture.isCube) {
                target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
            }
            const lodMaxWidth = Math.round(Math.log(texture.width) * Math.LOG2E);
            const lodMaxHeight = Math.round(Math.log(texture.height) * Math.LOG2E);
            const width = useTextureWidthAndHeight ? texture.width : Math.pow(2, Math.max(lodMaxWidth - lod, 0));
            const height = useTextureWidthAndHeight ? texture.height : Math.pow(2, Math.max(lodMaxHeight - lod, 0));
            gl.texImage2D(target, lod, internalFormat, width, height, 0, format, textureType, imageData);
        }
        /**
         * Update a portion of an internal texture
         * @param texture defines the texture to update
         * @param imageData defines the data to store into the texture
         * @param xOffset defines the x coordinates of the update rectangle
         * @param yOffset defines the y coordinates of the update rectangle
         * @param width defines the width of the update rectangle
         * @param height defines the height of the update rectangle
         * @param faceIndex defines the face index if texture is a cube (0 by default)
         * @param lod defines the lod level to update (0 by default)
         * @param generateMipMaps defines whether to generate mipmaps or not
         */
        updateTextureData(texture, imageData, xOffset, yOffset, width, height, faceIndex = 0, lod = 0, generateMipMaps = false) {
            const gl = this._gl;
            const textureType = this._getWebGLTextureType(texture.type);
            const format = this._getInternalFormat(texture.format);
            this._unpackFlipY(texture.invertY);
            let targetForBinding = gl.TEXTURE_2D;
            let target = gl.TEXTURE_2D;
            if (texture.isCube) {
                target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
                targetForBinding = gl.TEXTURE_CUBE_MAP;
            }
            this._bindTextureDirectly(targetForBinding, texture, true);
            gl.texSubImage2D(target, lod, xOffset, yOffset, width, height, format, textureType, imageData);
            if (generateMipMaps) {
                this._gl.generateMipmap(target);
            }
            this._bindTextureDirectly(targetForBinding, null);
        }
        /**
         * @internal
         */
        _uploadArrayBufferViewToTexture(texture, imageData, faceIndex = 0, lod = 0) {
            const gl = this._gl;
            const bindTarget = texture.isCube ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D;
            this._bindTextureDirectly(bindTarget, texture, true);
            this._uploadDataToTextureDirectly(texture, imageData, faceIndex, lod);
            this._bindTextureDirectly(bindTarget, null, true);
        }
        _prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode) {
            const gl = this._gl;
            if (!gl) {
                return;
            }
            const filters = this._getSamplingParameters(samplingMode, !noMipmap);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filters.mag);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filters.min);
            if (!noMipmap && !isCompressed) {
                gl.generateMipmap(gl.TEXTURE_2D);
            }
            this._bindTextureDirectly(gl.TEXTURE_2D, null);
            // this.resetTextureCache();
            if (scene) {
                scene.removePendingData(texture);
            }
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
        }
        _prepareWebGLTexture(texture, extension, scene, img, invertY, noMipmap, isCompressed, processFunction, samplingMode = 3) {
            const maxTextureSize = this.getCaps().maxTextureSize;
            const potWidth = Math.min(maxTextureSize, this.needPOTTextures ? ThinEngine.GetExponentOfTwo(img.width, maxTextureSize) : img.width);
            const potHeight = Math.min(maxTextureSize, this.needPOTTextures ? ThinEngine.GetExponentOfTwo(img.height, maxTextureSize) : img.height);
            const gl = this._gl;
            if (!gl) {
                return;
            }
            if (!texture._hardwareTexture) {
                //  this.resetTextureCache();
                if (scene) {
                    scene.removePendingData(texture);
                }
                return;
            }
            this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
            this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
            texture.baseWidth = img.width;
            texture.baseHeight = img.height;
            texture.width = potWidth;
            texture.height = potHeight;
            texture.isReady = true;
            if (processFunction(potWidth, potHeight, img, extension, texture, () => {
                this._prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode);
            })) {
                // Returning as texture needs extra async steps
                return;
            }
            this._prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode);
        }
        /**
         * @internal
         */
        _setupFramebufferDepthAttachments(generateStencilBuffer, generateDepthBuffer, width, height, samples = 1) {
            const gl = this._gl;
            // Create the depth/stencil buffer
            if (generateStencilBuffer && generateDepthBuffer) {
                return this._createRenderBuffer(width, height, samples, gl.DEPTH_STENCIL, gl.DEPTH24_STENCIL8, gl.DEPTH_STENCIL_ATTACHMENT);
            }
            if (generateDepthBuffer) {
                let depthFormat = gl.DEPTH_COMPONENT16;
                if (this._webGLVersion > 1) {
                    depthFormat = gl.DEPTH_COMPONENT32F;
                }
                return this._createRenderBuffer(width, height, samples, depthFormat, depthFormat, gl.DEPTH_ATTACHMENT);
            }
            if (generateStencilBuffer) {
                return this._createRenderBuffer(width, height, samples, gl.STENCIL_INDEX8, gl.STENCIL_INDEX8, gl.STENCIL_ATTACHMENT);
            }
            return null;
        }
        /**
         * @internal
         */
        _createRenderBuffer(width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer = true) {
            const gl = this._gl;
            const renderBuffer = gl.createRenderbuffer();
            return this._updateRenderBuffer(renderBuffer, width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer);
        }
        _updateRenderBuffer(renderBuffer, width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer = true) {
            const gl = this._gl;
            gl.bindRenderbuffer(gl.RENDERBUFFER, renderBuffer);
            if (samples > 1 && gl.renderbufferStorageMultisample) {
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, msInternalFormat, width, height);
            }
            else {
                gl.renderbufferStorage(gl.RENDERBUFFER, internalFormat, width, height);
            }
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, renderBuffer);
            if (unbindBuffer) {
                gl.bindRenderbuffer(gl.RENDERBUFFER, null);
            }
            return renderBuffer;
        }
        /**
         * @internal
         */
        _releaseTexture(texture) {
            var _a;
            this._deleteTexture((_a = texture._hardwareTexture) === null || _a === void 0 ? void 0 : _a.underlyingResource);
            // Unbind channels
            this.unbindAllTextures();
            const index = this._internalTexturesCache.indexOf(texture);
            if (index !== -1) {
                this._internalTexturesCache.splice(index, 1);
            }
            // Integrated fixed lod samplers.
            if (texture._lodTextureHigh) {
                texture._lodTextureHigh.dispose();
            }
            if (texture._lodTextureMid) {
                texture._lodTextureMid.dispose();
            }
            if (texture._lodTextureLow) {
                texture._lodTextureLow.dispose();
            }
            // Integrated irradiance map.
            if (texture._irradianceTexture) {
                texture._irradianceTexture.dispose();
            }
        }
        /**
         * @internal
         */
        _releaseRenderTargetWrapper(rtWrapper) {
            const index = this._renderTargetWrapperCache.indexOf(rtWrapper);
            if (index !== -1) {
                this._renderTargetWrapperCache.splice(index, 1);
            }
        }
        _deleteTexture(texture) {
            if (texture) {
                this._gl.deleteTexture(texture);
            }
        }
        _setProgram(program) {
            if (this._currentProgram !== program) {
                this._gl.useProgram(program);
                this._currentProgram = program;
            }
        }
        /**
         * Binds an effect to the webGL context
         * @param effect defines the effect to bind
         */
        bindSamplers(effect) {
            const webGLPipelineContext = effect.getPipelineContext();
            this._setProgram(webGLPipelineContext.program);
            const samplers = effect.getSamplers();
            for (let index = 0; index < samplers.length; index++) {
                const uniform = effect.getUniform(samplers[index]);
                if (uniform) {
                    this._boundUniforms[index] = uniform;
                }
            }
            this._currentEffect = null;
        }
        _activateCurrentTexture() {
            if (this._currentTextureChannel !== this._activeChannel) {
                this._gl.activeTexture(this._gl.TEXTURE0 + this._activeChannel);
                this._currentTextureChannel = this._activeChannel;
            }
        }
        /**
         * @internal
         */
        _bindTextureDirectly(target, texture, forTextureDataUpdate = false, force = false) {
            var _a, _b;
            let wasPreviouslyBound = false;
            const isTextureForRendering = texture && texture._associatedChannel > -1;
            if (forTextureDataUpdate && isTextureForRendering) {
                this._activeChannel = texture._associatedChannel;
            }
            const currentTextureBound = this._boundTexturesCache[this._activeChannel];
            if (currentTextureBound !== texture || force) {
                this._activateCurrentTexture();
                if (texture && texture.isMultiview) {
                    //this._gl.bindTexture(target, texture ? texture._colorTextureArray : null);
                    console.error(target, texture);
                    throw "_bindTextureDirectly called with a multiview texture!";
                }
                else {
                    this._gl.bindTexture(target, (_b = (_a = texture === null || texture === void 0 ? void 0 : texture._hardwareTexture) === null || _a === void 0 ? void 0 : _a.underlyingResource) !== null && _b !== void 0 ? _b : null);
                }
                this._boundTexturesCache[this._activeChannel] = texture;
                if (texture) {
                    texture._associatedChannel = this._activeChannel;
                }
            }
            else if (forTextureDataUpdate) {
                wasPreviouslyBound = true;
                this._activateCurrentTexture();
            }
            if (isTextureForRendering && !forTextureDataUpdate) {
                this._bindSamplerUniformToChannel(texture._associatedChannel, this._activeChannel);
            }
            return wasPreviouslyBound;
        }
        /**
         * @internal
         */
        _bindTexture(channel, texture, name) {
            if (channel === undefined) {
                return;
            }
            if (texture) {
                texture._associatedChannel = channel;
            }
            this._activeChannel = channel;
            const target = texture ? this._getTextureTarget(texture) : this._gl.TEXTURE_2D;
            this._bindTextureDirectly(target, texture);
        }
        /**
         * Unbind all textures from the webGL context
         */
        unbindAllTextures() {
            for (let channel = 0; channel < this._maxSimultaneousTextures; channel++) {
                this._activeChannel = channel;
                this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
                this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
                if (this.webGLVersion > 1) {
                    this._bindTextureDirectly(this._gl.TEXTURE_3D, null);
                    this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null);
                }
            }
        }
        /**
         * Sets a texture to the according uniform.
         * @param channel The texture channel
         * @param uniform The uniform to set
         * @param texture The texture to apply
         * @param name The name of the uniform in the effect
         */
        setTexture(channel, uniform, texture, name) {
            if (channel === undefined) {
                return;
            }
            if (uniform) {
                this._boundUniforms[channel] = uniform;
            }
            this._setTexture(channel, texture);
        }
        _bindSamplerUniformToChannel(sourceSlot, destination) {
            const uniform = this._boundUniforms[sourceSlot];
            if (!uniform || uniform._currentState === destination) {
                return;
            }
            this._gl.uniform1i(uniform, destination);
            uniform._currentState = destination;
        }
        _getTextureWrapMode(mode) {
            switch (mode) {
                case 1:
                    return this._gl.REPEAT;
                case 0:
                    return this._gl.CLAMP_TO_EDGE;
                case 2:
                    return this._gl.MIRRORED_REPEAT;
            }
            return this._gl.REPEAT;
        }
        _setTexture(channel, texture, isPartOfTextureArray = false, depthStencilTexture = false, name = "") {
            // Not ready?
            if (!texture) {
                if (this._boundTexturesCache[channel] != null) {
                    this._activeChannel = channel;
                    this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
                    this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
                    if (this.webGLVersion > 1) {
                        this._bindTextureDirectly(this._gl.TEXTURE_3D, null);
                        this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null);
                    }
                }
                return false;
            }
            // Video
            if (texture.video) {
                this._activeChannel = channel;
                const videoInternalTexture = texture.getInternalTexture();
                if (videoInternalTexture) {
                    videoInternalTexture._associatedChannel = channel;
                }
                texture.update();
            }
            else if (texture.delayLoadState === 4) {
                // Delay loading
                texture.delayLoad();
                return false;
            }
            let internalTexture;
            if (depthStencilTexture) {
                internalTexture = texture.depthStencilTexture;
            }
            else if (texture.isReady()) {
                internalTexture = texture.getInternalTexture();
            }
            else if (texture.isCube) {
                internalTexture = this.emptyCubeTexture;
            }
            else if (texture.is3D) {
                internalTexture = this.emptyTexture3D;
            }
            else if (texture.is2DArray) {
                internalTexture = this.emptyTexture2DArray;
            }
            else {
                internalTexture = this.emptyTexture;
            }
            if (!isPartOfTextureArray && internalTexture) {
                internalTexture._associatedChannel = channel;
            }
            let needToBind = true;
            if (this._boundTexturesCache[channel] === internalTexture) {
                if (!isPartOfTextureArray) {
                    this._bindSamplerUniformToChannel(internalTexture._associatedChannel, channel);
                }
                needToBind = false;
            }
            this._activeChannel = channel;
            const target = this._getTextureTarget(internalTexture);
            if (needToBind) {
                this._bindTextureDirectly(target, internalTexture, isPartOfTextureArray);
            }
            if (internalTexture && !internalTexture.isMultiview) {
                // CUBIC_MODE and SKYBOX_MODE both require CLAMP_TO_EDGE.  All other modes use REPEAT.
                if (internalTexture.isCube && internalTexture._cachedCoordinatesMode !== texture.coordinatesMode) {
                    internalTexture._cachedCoordinatesMode = texture.coordinatesMode;
                    const textureWrapMode = texture.coordinatesMode !== 3 && texture.coordinatesMode !== 5
                        ? 1
                        : 0;
                    texture.wrapU = textureWrapMode;
                    texture.wrapV = textureWrapMode;
                }
                if (internalTexture._cachedWrapU !== texture.wrapU) {
                    internalTexture._cachedWrapU = texture.wrapU;
                    this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(texture.wrapU), internalTexture);
                }
                if (internalTexture._cachedWrapV !== texture.wrapV) {
                    internalTexture._cachedWrapV = texture.wrapV;
                    this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(texture.wrapV), internalTexture);
                }
                if (internalTexture.is3D && internalTexture._cachedWrapR !== texture.wrapR) {
                    internalTexture._cachedWrapR = texture.wrapR;
                    this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(texture.wrapR), internalTexture);
                }
                this._setAnisotropicLevel(target, internalTexture, texture.anisotropicFilteringLevel);
            }
            return true;
        }
        /**
         * Sets an array of texture to the webGL context
         * @param channel defines the channel where the texture array must be set
         * @param uniform defines the associated uniform location
         * @param textures defines the array of textures to bind
         * @param name name of the channel
         */
        setTextureArray(channel, uniform, textures, name) {
            if (channel === undefined || !uniform) {
                return;
            }
            if (!this._textureUnits || this._textureUnits.length !== textures.length) {
                this._textureUnits = new Int32Array(textures.length);
            }
            for (let i = 0; i < textures.length; i++) {
                const texture = textures[i].getInternalTexture();
                if (texture) {
                    this._textureUnits[i] = channel + i;
                    texture._associatedChannel = channel + i;
                }
                else {
                    this._textureUnits[i] = -1;
                }
            }
            this._gl.uniform1iv(uniform, this._textureUnits);
            for (let index = 0; index < textures.length; index++) {
                this._setTexture(this._textureUnits[index], textures[index], true);
            }
        }
        /**
         * @internal
         */
        _setAnisotropicLevel(target, internalTexture, anisotropicFilteringLevel) {
            const anisotropicFilterExtension = this._caps.textureAnisotropicFilterExtension;
            if (internalTexture.samplingMode !== 11 &&
                internalTexture.samplingMode !== 3 &&
                internalTexture.samplingMode !== 2) {
                anisotropicFilteringLevel = 1; // Forcing the anisotropic to 1 because else webgl will force filters to linear
            }
            if (anisotropicFilterExtension && internalTexture._cachedAnisotropicFilteringLevel !== anisotropicFilteringLevel) {
                this._setTextureParameterFloat(target, anisotropicFilterExtension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(anisotropicFilteringLevel, this._caps.maxAnisotropy), internalTexture);
                internalTexture._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
            }
        }
        _setTextureParameterFloat(target, parameter, value, texture) {
            this._bindTextureDirectly(target, texture, true, true);
            this._gl.texParameterf(target, parameter, value);
        }
        _setTextureParameterInteger(target, parameter, value, texture) {
            if (texture) {
                this._bindTextureDirectly(target, texture, true, true);
            }
            this._gl.texParameteri(target, parameter, value);
        }
        /**
         * Unbind all vertex attributes from the webGL context
         */
        unbindAllAttributes() {
            if (this._mustWipeVertexAttributes) {
                this._mustWipeVertexAttributes = false;
                for (let i = 0; i < this._caps.maxVertexAttribs; i++) {
                    this.disableAttributeByIndex(i);
                }
                return;
            }
            for (let i = 0, ul = this._vertexAttribArraysEnabled.length; i < ul; i++) {
                if (i >= this._caps.maxVertexAttribs || !this._vertexAttribArraysEnabled[i]) {
                    continue;
                }
                this.disableAttributeByIndex(i);
            }
        }
        /**
         * Force the engine to release all cached effects. This means that next effect compilation will have to be done completely even if a similar effect was already compiled
         */
        releaseEffects() {
            for (const name in this._compiledEffects) {
                const webGLPipelineContext = this._compiledEffects[name].getPipelineContext();
                this._deletePipelineContext(webGLPipelineContext);
            }
            this._compiledEffects = {};
        }
        /**
         * Dispose and release all associated resources
         */
        dispose() {
            var _a;
            this._isDisposed = true;
            this.stopRenderLoop();
            // Clear observables
            if (this.onBeforeTextureInitObservable) {
                this.onBeforeTextureInitObservable.clear();
            }
            // Empty texture
            if (this._emptyTexture) {
                this._releaseTexture(this._emptyTexture);
                this._emptyTexture = null;
            }
            if (this._emptyCubeTexture) {
                this._releaseTexture(this._emptyCubeTexture);
                this._emptyCubeTexture = null;
            }
            if (this._dummyFramebuffer) {
                this._gl.deleteFramebuffer(this._dummyFramebuffer);
            }
            // Release effects
            this.releaseEffects();
            (_a = this.releaseComputeEffects) === null || _a === void 0 ? void 0 : _a.call(this);
            // Unbind
            this.unbindAllAttributes();
            this._boundUniforms = {};
            // Events
            if (IsWindowObjectExist()) {
                if (this._renderingCanvas) {
                    if (!this._doNotHandleContextLost) {
                        this._renderingCanvas.removeEventListener("webglcontextlost", this._onContextLost);
                        this._renderingCanvas.removeEventListener("webglcontextrestored", this._onContextRestored);
                    }
                    window.removeEventListener("resize", this._checkForMobile);
                }
            }
            this._workingCanvas = null;
            this._workingContext = null;
            this._currentBufferPointers.length = 0;
            this._renderingCanvas = null;
            this._currentProgram = null;
            this._boundRenderFunction = null;
            Effect.ResetCache();
            // Abort active requests
            for (const request of this._activeRequests) {
                request.abort();
            }
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
        }
        /**
         * Attach a new callback raised when context lost event is fired
         * @param callback defines the callback to call
         */
        attachContextLostEvent(callback) {
            if (this._renderingCanvas) {
                this._renderingCanvas.addEventListener("webglcontextlost", callback, false);
            }
        }
        /**
         * Attach a new callback raised when context restored event is fired
         * @param callback defines the callback to call
         */
        attachContextRestoredEvent(callback) {
            if (this._renderingCanvas) {
                this._renderingCanvas.addEventListener("webglcontextrestored", callback, false);
            }
        }
        /**
         * Get the current error code of the webGL context
         * @returns the error code
         * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getError
         */
        getError() {
            return this._gl.getError();
        }
        _canRenderToFloatFramebuffer() {
            if (this._webGLVersion > 1) {
                return this._caps.colorBufferFloat;
            }
            return this._canRenderToFramebuffer(1);
        }
        _canRenderToHalfFloatFramebuffer() {
            if (this._webGLVersion > 1) {
                return this._caps.colorBufferFloat;
            }
            return this._canRenderToFramebuffer(2);
        }
        // Thank you : http://stackoverflow.com/questions/28827511/webgl-ios-render-to-floating-point-texture
        _canRenderToFramebuffer(type) {
            const gl = this._gl;
            //clear existing errors
            // eslint-disable-next-line no-empty
            while (gl.getError() !== gl.NO_ERROR) { }
            let successful = true;
            const texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, this._getRGBABufferInternalSizedFormat(type), 1, 1, 0, gl.RGBA, this._getWebGLTextureType(type), null);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            const fb = gl.createFramebuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
            const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
            successful = successful && status === gl.FRAMEBUFFER_COMPLETE;
            successful = successful && gl.getError() === gl.NO_ERROR;
            //try render by clearing frame buffer's color buffer
            if (successful) {
                gl.clear(gl.COLOR_BUFFER_BIT);
                successful = successful && gl.getError() === gl.NO_ERROR;
            }
            //try reading from frame to ensure render occurs (just creating the FBO is not sufficient to determine if rendering is supported)
            if (successful) {
                //in practice it's sufficient to just read from the backbuffer rather than handle potentially issues reading from the texture
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                const readFormat = gl.RGBA;
                const readType = gl.UNSIGNED_BYTE;
                const buffer = new Uint8Array(4);
                gl.readPixels(0, 0, 1, 1, readFormat, readType, buffer);
                successful = successful && gl.getError() === gl.NO_ERROR;
            }
            //clean up
            gl.deleteTexture(texture);
            gl.deleteFramebuffer(fb);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            //clear accumulated errors
            // eslint-disable-next-line no-empty
            while (!successful && gl.getError() !== gl.NO_ERROR) { }
            return successful;
        }
        /**
         * @internal
         */
        _getWebGLTextureType(type) {
            if (this._webGLVersion === 1) {
                switch (type) {
                    case 1:
                        return this._gl.FLOAT;
                    case 2:
                        return this._gl.HALF_FLOAT_OES;
                    case 0:
                        return this._gl.UNSIGNED_BYTE;
                    case 8:
                        return this._gl.UNSIGNED_SHORT_4_4_4_4;
                    case 9:
                        return this._gl.UNSIGNED_SHORT_5_5_5_1;
                    case 10:
                        return this._gl.UNSIGNED_SHORT_5_6_5;
                }
                return this._gl.UNSIGNED_BYTE;
            }
            switch (type) {
                case 3:
                    return this._gl.BYTE;
                case 0:
                    return this._gl.UNSIGNED_BYTE;
                case 4:
                    return this._gl.SHORT;
                case 5:
                    return this._gl.UNSIGNED_SHORT;
                case 6:
                    return this._gl.INT;
                case 7: // Refers to UNSIGNED_INT
                    return this._gl.UNSIGNED_INT;
                case 1:
                    return this._gl.FLOAT;
                case 2:
                    return this._gl.HALF_FLOAT;
                case 8:
                    return this._gl.UNSIGNED_SHORT_4_4_4_4;
                case 9:
                    return this._gl.UNSIGNED_SHORT_5_5_5_1;
                case 10:
                    return this._gl.UNSIGNED_SHORT_5_6_5;
                case 11:
                    return this._gl.UNSIGNED_INT_2_10_10_10_REV;
                case 12:
                    return this._gl.UNSIGNED_INT_24_8;
                case 13:
                    return this._gl.UNSIGNED_INT_10F_11F_11F_REV;
                case 14:
                    return this._gl.UNSIGNED_INT_5_9_9_9_REV;
                case 15:
                    return this._gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
            }
            return this._gl.UNSIGNED_BYTE;
        }
        /**
         * @internal
         */
        _getInternalFormat(format, useSRGBBuffer = false) {
            let internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
            switch (format) {
                case 0:
                    internalFormat = this._gl.ALPHA;
                    break;
                case 1:
                    internalFormat = this._gl.LUMINANCE;
                    break;
                case 2:
                    internalFormat = this._gl.LUMINANCE_ALPHA;
                    break;
                case 6:
                    internalFormat = this._gl.RED;
                    break;
                case 7:
                    internalFormat = this._gl.RG;
                    break;
                case 4:
                    internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
                    break;
                case 5:
                    internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
                    break;
            }
            if (this._webGLVersion > 1) {
                switch (format) {
                    case 8:
                        internalFormat = this._gl.RED_INTEGER;
                        break;
                    case 9:
                        internalFormat = this._gl.RG_INTEGER;
                        break;
                    case 10:
                        internalFormat = this._gl.RGB_INTEGER;
                        break;
                    case 11:
                        internalFormat = this._gl.RGBA_INTEGER;
                        break;
                }
            }
            return internalFormat;
        }
        /**
         * @internal
         */
        _getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer = false) {
            if (this._webGLVersion === 1) {
                if (format !== undefined) {
                    switch (format) {
                        case 0:
                            return this._gl.ALPHA;
                        case 1:
                            return this._gl.LUMINANCE;
                        case 2:
                            return this._gl.LUMINANCE_ALPHA;
                        case 4:
                            return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
                    }
                }
                return this._gl.RGBA;
            }
            switch (type) {
                case 3:
                    switch (format) {
                        case 6:
                            return this._gl.R8_SNORM;
                        case 7:
                            return this._gl.RG8_SNORM;
                        case 4:
                            return this._gl.RGB8_SNORM;
                        case 8:
                            return this._gl.R8I;
                        case 9:
                            return this._gl.RG8I;
                        case 10:
                            return this._gl.RGB8I;
                        case 11:
                            return this._gl.RGBA8I;
                        default:
                            return this._gl.RGBA8_SNORM;
                    }
                case 0:
                    switch (format) {
                        case 6:
                            return this._gl.R8;
                        case 7:
                            return this._gl.RG8;
                        case 4:
                            return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8 : this._gl.RGB8; // By default. Other possibilities are RGB565, SRGB8.
                        case 5:
                            return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8; // By default. Other possibilities are RGB5_A1, RGBA4, SRGB8_ALPHA8.
                        case 8:
                            return this._gl.R8UI;
                        case 9:
                            return this._gl.RG8UI;
                        case 10:
                            return this._gl.RGB8UI;
                        case 11:
                            return this._gl.RGBA8UI;
                        case 0:
                            return this._gl.ALPHA;
                        case 1:
                            return this._gl.LUMINANCE;
                        case 2:
                            return this._gl.LUMINANCE_ALPHA;
                        default:
                            return this._gl.RGBA8;
                    }
                case 4:
                    switch (format) {
                        case 8:
                            return this._gl.R16I;
                        case 9:
                            return this._gl.RG16I;
                        case 10:
                            return this._gl.RGB16I;
                        case 11:
                            return this._gl.RGBA16I;
                        default:
                            return this._gl.RGBA16I;
                    }
                case 5:
                    switch (format) {
                        case 8:
                            return this._gl.R16UI;
                        case 9:
                            return this._gl.RG16UI;
                        case 10:
                            return this._gl.RGB16UI;
                        case 11:
                            return this._gl.RGBA16UI;
                        default:
                            return this._gl.RGBA16UI;
                    }
                case 6:
                    switch (format) {
                        case 8:
                            return this._gl.R32I;
                        case 9:
                            return this._gl.RG32I;
                        case 10:
                            return this._gl.RGB32I;
                        case 11:
                            return this._gl.RGBA32I;
                        default:
                            return this._gl.RGBA32I;
                    }
                case 7: // Refers to UNSIGNED_INT
                    switch (format) {
                        case 8:
                            return this._gl.R32UI;
                        case 9:
                            return this._gl.RG32UI;
                        case 10:
                            return this._gl.RGB32UI;
                        case 11:
                            return this._gl.RGBA32UI;
                        default:
                            return this._gl.RGBA32UI;
                    }
                case 1:
                    switch (format) {
                        case 6:
                            return this._gl.R32F; // By default. Other possibility is R16F.
                        case 7:
                            return this._gl.RG32F; // By default. Other possibility is RG16F.
                        case 4:
                            return this._gl.RGB32F; // By default. Other possibilities are RGB16F, R11F_G11F_B10F, RGB9_E5.
                        case 5:
                            return this._gl.RGBA32F; // By default. Other possibility is RGBA16F.
                        default:
                            return this._gl.RGBA32F;
                    }
                case 2:
                    switch (format) {
                        case 6:
                            return this._gl.R16F;
                        case 7:
                            return this._gl.RG16F;
                        case 4:
                            return this._gl.RGB16F; // By default. Other possibilities are R11F_G11F_B10F, RGB9_E5.
                        case 5:
                            return this._gl.RGBA16F;
                        default:
                            return this._gl.RGBA16F;
                    }
                case 10:
                    return this._gl.RGB565;
                case 13:
                    return this._gl.R11F_G11F_B10F;
                case 14:
                    return this._gl.RGB9_E5;
                case 8:
                    return this._gl.RGBA4;
                case 9:
                    return this._gl.RGB5_A1;
                case 11:
                    switch (format) {
                        case 5:
                            return this._gl.RGB10_A2; // By default. Other possibility is RGB5_A1.
                        case 11:
                            return this._gl.RGB10_A2UI;
                        default:
                            return this._gl.RGB10_A2;
                    }
            }
            return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8;
        }
        /**
         * @internal
         */
        _getRGBAMultiSampleBufferFormat(type, format = 5) {
            switch (type) {
                case 1:
                    switch (format) {
                        case 6:
                            return this._gl.R32F;
                        default:
                            return this._gl.RGBA32F;
                    }
                case 2:
                    switch (format) {
                        case 6:
                            return this._gl.R16F;
                        default:
                            return this._gl.RGBA16F;
                    }
            }
            return this._gl.RGBA8;
        }
        /**
         * @internal
         */
        _loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
            const request = ThinEngine._FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
            this._activeRequests.push(request);
            request.onCompleteObservable.add((request) => {
                this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
            });
            return request;
        }
        /**
         * Loads a file from a url
         * @param url url to load
         * @param onSuccess callback called when the file successfully loads
         * @param onProgress callback called while file is loading (if the server supports this mode)
         * @param offlineProvider defines the offline provider for caching
         * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
         * @param onError callback called when the file fails to load
         * @returns a file request object
         * @internal
         */
        static _FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
            throw _WarnImport("FileTools");
        }
        /**
         * Reads pixels from the current frame buffer. Please note that this function can be slow
         * @param x defines the x coordinate of the rectangle where pixels must be read
         * @param y defines the y coordinate of the rectangle where pixels must be read
         * @param width defines the width of the rectangle where pixels must be read
         * @param height defines the height of the rectangle where pixels must be read
         * @param hasAlpha defines whether the output should have alpha or not (defaults to true)
         * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
         * @returns a ArrayBufferView promise (Uint8Array) containing RGBA colors
         */
        readPixels(x, y, width, height, hasAlpha = true, flushRenderer = true) {
            const numChannels = hasAlpha ? 4 : 3;
            const format = hasAlpha ? this._gl.RGBA : this._gl.RGB;
            const data = new Uint8Array(height * width * numChannels);
            if (flushRenderer) {
                this.flushFramebuffer();
            }
            this._gl.readPixels(x, y, width, height, format, this._gl.UNSIGNED_BYTE, data);
            return Promise.resolve(data);
        }
        /**
         * Gets a Promise<boolean> indicating if the engine can be instantiated (ie. if a webGL context can be found)
         */
        static get IsSupportedAsync() {
            return Promise.resolve(this.isSupported());
        }
        /**
         * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
         */
        static get IsSupported() {
            return this.isSupported(); // Backward compat
        }
        /**
         * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
         * @returns true if the engine can be created
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static isSupported() {
            if (this._HasMajorPerformanceCaveat !== null) {
                return !this._HasMajorPerformanceCaveat; // We know it is performant so WebGL is supported
            }
            if (this._IsSupported === null) {
                try {
                    const tempcanvas = this._CreateCanvas(1, 1);
                    const gl = tempcanvas.getContext("webgl") || tempcanvas.getContext("experimental-webgl");
                    this._IsSupported = gl != null && !!window.WebGLRenderingContext;
                }
                catch (e) {
                    this._IsSupported = false;
                }
            }
            return this._IsSupported;
        }
        /**
         * Gets a boolean indicating if the engine can be instantiated on a performant device (ie. if a webGL context can be found and it does not use a slow implementation)
         */
        static get HasMajorPerformanceCaveat() {
            if (this._HasMajorPerformanceCaveat === null) {
                try {
                    const tempcanvas = this._CreateCanvas(1, 1);
                    const gl = tempcanvas.getContext("webgl", { failIfMajorPerformanceCaveat: true }) ||
                        tempcanvas.getContext("experimental-webgl", { failIfMajorPerformanceCaveat: true });
                    this._HasMajorPerformanceCaveat = !gl;
                }
                catch (e) {
                    this._HasMajorPerformanceCaveat = false;
                }
            }
            return this._HasMajorPerformanceCaveat;
        }
        /**
         * Find the next highest power of two.
         * @param x Number to start search from.
         * @returns Next highest power of two.
         */
        static CeilingPOT(x) {
            x--;
            x |= x >> 1;
            x |= x >> 2;
            x |= x >> 4;
            x |= x >> 8;
            x |= x >> 16;
            x++;
            return x;
        }
        /**
         * Find the next lowest power of two.
         * @param x Number to start search from.
         * @returns Next lowest power of two.
         */
        static FloorPOT(x) {
            x = x | (x >> 1);
            x = x | (x >> 2);
            x = x | (x >> 4);
            x = x | (x >> 8);
            x = x | (x >> 16);
            return x - (x >> 1);
        }
        /**
         * Find the nearest power of two.
         * @param x Number to start search from.
         * @returns Next nearest power of two.
         */
        static NearestPOT(x) {
            const c = ThinEngine.CeilingPOT(x);
            const f = ThinEngine.FloorPOT(x);
            return c - x > x - f ? f : c;
        }
        /**
         * Get the closest exponent of two
         * @param value defines the value to approximate
         * @param max defines the maximum value to return
         * @param mode defines how to define the closest value
         * @returns closest exponent of two of the given value
         */
        static GetExponentOfTwo(value, max, mode = 2) {
            let pot;
            switch (mode) {
                case 1:
                    pot = ThinEngine.FloorPOT(value);
                    break;
                case 2:
                    pot = ThinEngine.NearestPOT(value);
                    break;
                case 3:
                default:
                    pot = ThinEngine.CeilingPOT(value);
                    break;
            }
            return Math.min(pot, max);
        }
        /**
         * Queue a new function into the requested animation frame pool (ie. this function will be executed by the browser (or the javascript engine) for the next frame)
         * @param func - the function to be called
         * @param requester - the object that will request the next frame. Falls back to window.
         * @returns frame number
         */
        static QueueNewFrame(func, requester) {
            // Note that there is kind of a typing issue here, as `setTimeout` might return something else than a number (NodeJs returns a NodeJS.Timeout object).
            // Also if the global `requestAnimationFrame`'s returnType is number, `requester.requestPostAnimationFrame` and `requester.requestAnimationFrame` types
            // are `any`.
            if (!IsWindowObjectExist()) {
                if (typeof requestAnimationFrame === "function") {
                    return requestAnimationFrame(func);
                }
            }
            else {
                const { requestAnimationFrame } = requester || window;
                if (typeof requestAnimationFrame === "function") {
                    return requestAnimationFrame(func);
                }
            }
            // fallback to the global `setTimeout`.
            // In most cases (aka in the browser), `window` is the global object, so instead of calling `window.setTimeout` we could call the global `setTimeout`.
            return setTimeout(func, 16);
        }
        /**
         * Gets host document
         * @returns the host document object
         */
        getHostDocument() {
            if (this._renderingCanvas && this._renderingCanvas.ownerDocument) {
                return this._renderingCanvas.ownerDocument;
            }
            return IsDocumentAvailable() ? document : null;
        }
    }
    ThinEngine._TempClearColorUint32 = new Uint32Array(4);
    ThinEngine._TempClearColorInt32 = new Int32Array(4);
    /** Use this array to turn off some WebGL2 features on known buggy browsers version */
    ThinEngine.ExceptionList = [
        { key: "Chrome/63.0", capture: "63\\.0\\.3239\\.(\\d+)", captureConstraint: 108, targets: ["uniformBuffer"] },
        { key: "Firefox/58", capture: null, captureConstraint: null, targets: ["uniformBuffer"] },
        { key: "Firefox/59", capture: null, captureConstraint: null, targets: ["uniformBuffer"] },
        { key: "Chrome/72.+?Mobile", capture: null, captureConstraint: null, targets: ["vao"] },
        { key: "Chrome/73.+?Mobile", capture: null, captureConstraint: null, targets: ["vao"] },
        { key: "Chrome/74.+?Mobile", capture: null, captureConstraint: null, targets: ["vao"] },
        { key: "Mac OS.+Chrome/71", capture: null, captureConstraint: null, targets: ["vao"] },
        { key: "Mac OS.+Chrome/72", capture: null, captureConstraint: null, targets: ["vao"] },
        { key: "Mac OS.+Chrome", capture: null, captureConstraint: null, targets: ["uniformBuffer"] },
        // desktop osx safari 15.4
        { key: ".*AppleWebKit.*(15.4).*Safari", capture: null, captureConstraint: null, targets: ["antialias", "maxMSAASamples"] },
        // mobile browsers using safari 15.4 on ios
        { key: ".*(15.4).*AppleWebKit.*Safari", capture: null, captureConstraint: null, targets: ["antialias", "maxMSAASamples"] },
    ];
    /** @internal */
    ThinEngine._TextureLoaders = [];
    // Updatable statics so stick with vars here
    /**
     * Gets or sets the epsilon value used by collision engine
     */
    ThinEngine.CollisionsEpsilon = 0.001;
    // Statics
    ThinEngine._IsSupported = null;
    ThinEngine._HasMajorPerformanceCaveat = null;

    /**
     * Class used to provide helper for timing
     */
    class TimingTools {
        /**
         * Polyfill for setImmediate
         * @param action defines the action to execute after the current execution block
         */
        static SetImmediate(action) {
            if (IsWindowObjectExist() && window.setImmediate) {
                window.setImmediate(action);
            }
            else {
                setTimeout(action, 1);
            }
        }
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    const Base64DataUrlRegEx = new RegExp(/^data:([^,]+\/[^,]+)?;base64,/i);
    /** @ignore */
    class LoadFileError extends RuntimeError {
        /**
         * Creates a new LoadFileError
         * @param message defines the message of the error
         * @param object defines the optional web request
         */
        constructor(message, object) {
            super(message, ErrorCodes.LoadFileError);
            this.name = "LoadFileError";
            BaseError._setPrototypeOf(this, LoadFileError.prototype);
            if (object instanceof WebRequest) {
                this.request = object;
            }
            else {
                this.file = object;
            }
        }
    }
    /** @ignore */
    class RequestFileError extends RuntimeError {
        /**
         * Creates a new LoadFileError
         * @param message defines the message of the error
         * @param request defines the optional web request
         */
        constructor(message, request) {
            super(message, ErrorCodes.RequestFileError);
            this.request = request;
            this.name = "RequestFileError";
            BaseError._setPrototypeOf(this, RequestFileError.prototype);
        }
    }
    /** @ignore */
    class ReadFileError extends RuntimeError {
        /**
         * Creates a new ReadFileError
         * @param message defines the message of the error
         * @param file defines the optional file
         */
        constructor(message, file) {
            super(message, ErrorCodes.ReadFileError);
            this.file = file;
            this.name = "ReadFileError";
            BaseError._setPrototypeOf(this, ReadFileError.prototype);
        }
    }
    /**
     * @internal
     */
    const FileToolsOptions = {
        /**
         * Gets or sets the retry strategy to apply when an error happens while loading an asset.
         * When defining this function, return the wait time before trying again or return -1 to
         * stop retrying and error out.
         */
        DefaultRetryStrategy: RetryStrategy.ExponentialBackoff(),
        /**
         * Gets or sets the base URL to use to load assets
         */
        BaseUrl: "",
        /**
         * Default behaviour for cors in the application.
         * It can be a string if the expected behavior is identical in the entire app.
         * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
         */
        CorsBehavior: "anonymous",
        /**
         * Gets or sets a function used to pre-process url before using them to load assets
         * @param url
         */
        PreprocessUrl: (url) => {
            return url;
        },
    };
    /**
     * Removes unwanted characters from an url
     * @param url defines the url to clean
     * @returns the cleaned url
     */
    const _CleanUrl = (url) => {
        url = url.replace(/#/gm, "%23");
        return url;
    };
    /**
     * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
     * @param url define the url we are trying
     * @param element define the dom element where to configure the cors policy
     * @internal
     */
    const SetCorsBehavior = (url, element) => {
        if (url && url.indexOf("data:") === 0) {
            return;
        }
        if (FileToolsOptions.CorsBehavior) {
            if (typeof FileToolsOptions.CorsBehavior === "string" || FileToolsOptions.CorsBehavior instanceof String) {
                element.crossOrigin = FileToolsOptions.CorsBehavior;
            }
            else {
                const result = FileToolsOptions.CorsBehavior(url);
                if (result) {
                    element.crossOrigin = result;
                }
            }
        }
    };
    /**
     * Loads an image as an HTMLImageElement.
     * @param input url string, ArrayBuffer, or Blob to load
     * @param onLoad callback called when the image successfully loads
     * @param onError callback called when the image fails to load
     * @param offlineProvider offline provider for caching
     * @param mimeType optional mime type
     * @param imageBitmapOptions
     * @returns the HTMLImageElement of the loaded image
     * @internal
     */
    const LoadImage = (input, onLoad, onError, offlineProvider, mimeType = "", imageBitmapOptions) => {
        var _a;
        let url;
        let usingObjectURL = false;
        if (input instanceof ArrayBuffer || ArrayBuffer.isView(input)) {
            if (typeof Blob !== "undefined" && typeof URL !== "undefined") {
                url = URL.createObjectURL(new Blob([input], { type: mimeType }));
                usingObjectURL = true;
            }
            else {
                url = `data:${mimeType};base64,` + EncodeArrayBufferToBase64(input);
            }
        }
        else if (input instanceof Blob) {
            url = URL.createObjectURL(input);
            usingObjectURL = true;
        }
        else {
            url = _CleanUrl(input);
            url = FileToolsOptions.PreprocessUrl(input);
        }
        const engine = EngineStore.LastCreatedEngine;
        const onErrorHandler = (exception) => {
            if (onError) {
                const inputText = url || input.toString();
                onError(`Error while trying to load image: ${inputText.indexOf("http") === 0 || inputText.length <= 128 ? inputText : inputText.slice(0, 128) + "..."}`, exception);
            }
        };
        if (typeof Image === "undefined" || ((_a = engine === null || engine === void 0 ? void 0 : engine._features.forceBitmapOverHTMLImageElement) !== null && _a !== void 0 ? _a : false)) {
            LoadFile(url, (data) => {
                engine
                    .createImageBitmap(new Blob([data], { type: mimeType }), Object.assign({ premultiplyAlpha: "none" }, imageBitmapOptions))
                    .then((imgBmp) => {
                    onLoad(imgBmp);
                    if (usingObjectURL) {
                        URL.revokeObjectURL(url);
                    }
                })
                    .catch((reason) => {
                    if (onError) {
                        onError("Error while trying to load image: " + input, reason);
                    }
                });
            }, undefined, offlineProvider || undefined, true, (request, exception) => {
                onErrorHandler(exception);
            });
            return null;
        }
        const img = new Image();
        SetCorsBehavior(url, img);
        const handlersList = [];
        const loadHandlersList = () => {
            handlersList.forEach((handler) => {
                handler.target.addEventListener(handler.name, handler.handler);
            });
        };
        const unloadHandlersList = () => {
            handlersList.forEach((handler) => {
                handler.target.removeEventListener(handler.name, handler.handler);
            });
            handlersList.length = 0;
        };
        const loadHandler = () => {
            unloadHandlersList();
            onLoad(img);
            // Must revoke the URL after calling onLoad to avoid security exceptions in
            // certain scenarios (e.g. when hosted in vscode).
            if (usingObjectURL && img.src) {
                URL.revokeObjectURL(img.src);
            }
        };
        const errorHandler = (err) => {
            unloadHandlersList();
            onErrorHandler(err);
            if (usingObjectURL && img.src) {
                URL.revokeObjectURL(img.src);
            }
        };
        const cspHandler = (err) => {
            if (err.blockedURI !== img.src) {
                return;
            }
            unloadHandlersList();
            const cspException = new Error(`CSP violation of policy ${err.effectiveDirective} ${err.blockedURI}. Current policy is ${err.originalPolicy}`);
            EngineStore.UseFallbackTexture = false;
            onErrorHandler(cspException);
            if (usingObjectURL && img.src) {
                URL.revokeObjectURL(img.src);
            }
            img.src = "";
        };
        handlersList.push({ target: img, name: "load", handler: loadHandler });
        handlersList.push({ target: img, name: "error", handler: errorHandler });
        handlersList.push({ target: document, name: "securitypolicyviolation", handler: cspHandler });
        loadHandlersList();
        const fromBlob = url.substring(0, 5) === "blob:";
        const fromData = url.substring(0, 5) === "data:";
        const noOfflineSupport = () => {
            if (fromBlob || fromData) {
                img.src = url;
            }
            else {
                LoadFile(url, (data, _, contentType) => {
                    const type = !mimeType && contentType ? contentType : mimeType;
                    const blob = new Blob([data], { type });
                    const url = URL.createObjectURL(blob);
                    usingObjectURL = true;
                    img.src = url;
                }, undefined, offlineProvider || undefined, true, (request, exception) => {
                    onErrorHandler(exception);
                });
            }
        };
        const loadFromOfflineSupport = () => {
            if (offlineProvider) {
                offlineProvider.loadImage(url, img);
            }
        };
        if (!fromBlob && !fromData && offlineProvider && offlineProvider.enableTexturesOffline) {
            offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
        }
        else {
            if (url.indexOf("file:") !== -1) {
                const textureName = decodeURIComponent(url.substring(5).toLowerCase());
                if (FilesInputStore.FilesToLoad[textureName] && typeof URL !== "undefined") {
                    try {
                        let blobURL;
                        try {
                            blobURL = URL.createObjectURL(FilesInputStore.FilesToLoad[textureName]);
                        }
                        catch (ex) {
                            // Chrome doesn't support oneTimeOnly parameter
                            blobURL = URL.createObjectURL(FilesInputStore.FilesToLoad[textureName]);
                        }
                        img.src = blobURL;
                        usingObjectURL = true;
                    }
                    catch (e) {
                        img.src = "";
                    }
                    return img;
                }
            }
            noOfflineSupport();
        }
        return img;
    };
    /**
     * Reads a file from a File object
     * @param file defines the file to load
     * @param onSuccess defines the callback to call when data is loaded
     * @param onProgress defines the callback to call during loading process
     * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
     * @param onError defines the callback to call when an error occurs
     * @returns a file request object
     * @internal
     */
    const ReadFile = (file, onSuccess, onProgress, useArrayBuffer, onError) => {
        const reader = new FileReader();
        const fileRequest = {
            onCompleteObservable: new Observable$1(),
            abort: () => reader.abort(),
        };
        reader.onloadend = () => fileRequest.onCompleteObservable.notifyObservers(fileRequest);
        if (onError) {
            reader.onerror = () => {
                onError(new ReadFileError(`Unable to read ${file.name}`, file));
            };
        }
        reader.onload = (e) => {
            //target doesn't have result from ts 1.3
            onSuccess(e.target["result"]);
        };
        if (onProgress) {
            reader.onprogress = onProgress;
        }
        if (!useArrayBuffer) {
            // Asynchronous read
            reader.readAsText(file);
        }
        else {
            reader.readAsArrayBuffer(file);
        }
        return fileRequest;
    };
    /**
     * Loads a file from a url, a data url, or a file url
     * @param fileOrUrl file, url, data url, or file url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @param onOpened
     * @returns a file request object
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const LoadFile = (fileOrUrl, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened) => {
        if (fileOrUrl.name) {
            return ReadFile(fileOrUrl, onSuccess, onProgress, useArrayBuffer, onError
                ? (error) => {
                    onError(undefined, error);
                }
                : undefined);
        }
        const url = fileOrUrl;
        // If file and file input are set
        if (url.indexOf("file:") !== -1) {
            let fileName = decodeURIComponent(url.substring(5).toLowerCase());
            if (fileName.indexOf("./") === 0) {
                fileName = fileName.substring(2);
            }
            const file = FilesInputStore.FilesToLoad[fileName];
            if (file) {
                return ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError ? (error) => onError(undefined, new LoadFileError(error.message, error.file)) : undefined);
            }
        }
        // For a Base64 Data URL
        const { match, type } = TestBase64DataUrl(url);
        if (match) {
            const fileRequest = {
                onCompleteObservable: new Observable$1(),
                abort: () => () => { },
            };
            try {
                const data = useArrayBuffer ? DecodeBase64UrlToBinary(url) : DecodeBase64UrlToString(url);
                onSuccess(data, undefined, type);
            }
            catch (error) {
                if (onError) {
                    onError(undefined, error);
                }
                else {
                    Logger.Error(error.message || "Failed to parse the Data URL");
                }
            }
            TimingTools.SetImmediate(() => {
                fileRequest.onCompleteObservable.notifyObservers(fileRequest);
            });
            return fileRequest;
        }
        return RequestFile(url, (data, request) => {
            onSuccess(data, request === null || request === void 0 ? void 0 : request.responseURL, request === null || request === void 0 ? void 0 : request.getResponseHeader("content-type"));
        }, onProgress, offlineProvider, useArrayBuffer, onError
            ? (error) => {
                onError(error.request, new LoadFileError(error.message, error.request));
            }
            : undefined, onOpened);
    };
    /**
     * Loads a file from a url
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @param onOpened callback called when the web request is opened
     * @returns a file request object
     * @internal
     */
    const RequestFile = (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened) => {
        url = _CleanUrl(url);
        url = FileToolsOptions.PreprocessUrl(url);
        const loadUrl = FileToolsOptions.BaseUrl + url;
        let aborted = false;
        const fileRequest = {
            onCompleteObservable: new Observable$1(),
            abort: () => (aborted = true),
        };
        const requestFile = () => {
            let request = new WebRequest();
            let retryHandle = null;
            let onReadyStateChange;
            const unbindEvents = () => {
                if (!request) {
                    return;
                }
                if (onProgress) {
                    request.removeEventListener("progress", onProgress);
                }
                if (onReadyStateChange) {
                    request.removeEventListener("readystatechange", onReadyStateChange);
                }
                request.removeEventListener("loadend", onLoadEnd);
            };
            let onLoadEnd = () => {
                unbindEvents();
                fileRequest.onCompleteObservable.notifyObservers(fileRequest);
                fileRequest.onCompleteObservable.clear();
                onProgress = undefined;
                onReadyStateChange = null;
                onLoadEnd = null;
                onError = undefined;
                onOpened = undefined;
                onSuccess = undefined;
            };
            fileRequest.abort = () => {
                aborted = true;
                if (onLoadEnd) {
                    onLoadEnd();
                }
                if (request && request.readyState !== (XMLHttpRequest.DONE || 4)) {
                    request.abort();
                }
                if (retryHandle !== null) {
                    clearTimeout(retryHandle);
                    retryHandle = null;
                }
                request = null;
            };
            const handleError = (error) => {
                const message = error.message || "Unknown error";
                if (onError && request) {
                    onError(new RequestFileError(message, request));
                }
                else {
                    Logger.Error(message);
                }
            };
            const retryLoop = (retryIndex) => {
                if (!request) {
                    return;
                }
                request.open("GET", loadUrl);
                if (onOpened) {
                    try {
                        onOpened(request);
                    }
                    catch (e) {
                        handleError(e);
                        return;
                    }
                }
                if (useArrayBuffer) {
                    request.responseType = "arraybuffer";
                }
                if (onProgress) {
                    request.addEventListener("progress", onProgress);
                }
                if (onLoadEnd) {
                    request.addEventListener("loadend", onLoadEnd);
                }
                onReadyStateChange = () => {
                    if (aborted || !request) {
                        return;
                    }
                    // In case of undefined state in some browsers.
                    if (request.readyState === (XMLHttpRequest.DONE || 4)) {
                        // Some browsers have issues where onreadystatechange can be called multiple times with the same value.
                        if (onReadyStateChange) {
                            request.removeEventListener("readystatechange", onReadyStateChange);
                        }
                        if ((request.status >= 200 && request.status < 300) || (request.status === 0 && (!IsWindowObjectExist() || IsFileURL()))) {
                            try {
                                if (onSuccess) {
                                    onSuccess(useArrayBuffer ? request.response : request.responseText, request);
                                }
                            }
                            catch (e) {
                                handleError(e);
                            }
                            return;
                        }
                        const retryStrategy = FileToolsOptions.DefaultRetryStrategy;
                        if (retryStrategy) {
                            const waitTime = retryStrategy(loadUrl, request, retryIndex);
                            if (waitTime !== -1) {
                                // Prevent the request from completing for retry.
                                unbindEvents();
                                request = new WebRequest();
                                retryHandle = setTimeout(() => retryLoop(retryIndex + 1), waitTime);
                                return;
                            }
                        }
                        const error = new RequestFileError("Error status: " + request.status + " " + request.statusText + " - Unable to load " + loadUrl, request);
                        if (onError) {
                            onError(error);
                        }
                    }
                };
                request.addEventListener("readystatechange", onReadyStateChange);
                request.send();
            };
            retryLoop(0);
        };
        // Caching all files
        if (offlineProvider && offlineProvider.enableSceneOffline) {
            const noOfflineSupport = (request) => {
                if (request && request.status > 400) {
                    if (onError) {
                        onError(request);
                    }
                }
                else {
                    requestFile();
                }
            };
            const loadFromOfflineSupport = () => {
                // TODO: database needs to support aborting and should return a IFileRequest
                if (offlineProvider) {
                    offlineProvider.loadFile(FileToolsOptions.BaseUrl + url, (data) => {
                        if (!aborted && onSuccess) {
                            onSuccess(data);
                        }
                        fileRequest.onCompleteObservable.notifyObservers(fileRequest);
                    }, onProgress
                        ? (event) => {
                            if (!aborted && onProgress) {
                                onProgress(event);
                            }
                        }
                        : undefined, noOfflineSupport, useArrayBuffer);
                }
            };
            offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
        }
        else {
            requestFile();
        }
        return fileRequest;
    };
    /**
     * Checks if the loaded document was accessed via `file:`-Protocol.
     * @returns boolean
     * @internal
     */
    const IsFileURL = () => {
        return typeof location !== "undefined" && location.protocol === "file:";
    };
    /**
     * Test if the given uri is a valid base64 data url
     * @param uri The uri to test
     * @returns True if the uri is a base64 data url or false otherwise
     * @internal
     */
    const IsBase64DataUrl = (uri) => {
        return Base64DataUrlRegEx.test(uri);
    };
    const TestBase64DataUrl = (uri) => {
        const results = Base64DataUrlRegEx.exec(uri);
        if (results === null || results.length === 0) {
            return { match: false, type: "" };
        }
        else {
            const type = results[0].replace("data:", "").replace("base64,", "");
            return { match: true, type };
        }
    };
    /**
     * Decode the given base64 uri.
     * @param uri The uri to decode
     * @returns The decoded base64 data.
     * @internal
     */
    function DecodeBase64UrlToBinary(uri) {
        return DecodeBase64ToBinary(uri.split(",")[1]);
    }
    /**
     * Decode the given base64 uri into a UTF-8 encoded string.
     * @param uri The uri to decode
     * @returns The decoded base64 data.
     * @internal
     */
    const DecodeBase64UrlToString = (uri) => {
        return DecodeBase64ToString(uri.split(",")[1]);
    };
    /**
     * This will be executed automatically for UMD and es5.
     * If esm dev wants the side effects to execute they will have to run it manually
     * Once we build native modules those need to be exported.
     * @internal
     */
    const initSideEffects = () => {
        ThinEngine._FileToolsLoadImage = LoadImage;
        ThinEngine._FileToolsLoadFile = LoadFile;
        ShaderProcessor._FileToolsLoadFile = LoadFile;
    };
    initSideEffects();
    // deprecated
    /**
     * FileTools defined as any.
     * This should not be imported or used in future releases or in any module in the framework
     * @internal
     * @deprecated import the needed function from fileTools.ts
     */
    let FileTools;
    /**
     * @param DecodeBase64UrlToBinary
     * @param DecodeBase64UrlToString
     * @param FileToolsOptions
     * @internal
     */
    const _injectLTSFileTools = (DecodeBase64UrlToBinary, DecodeBase64UrlToString, FileToolsOptions, IsBase64DataUrl, IsFileURL, LoadFile, LoadImage, ReadFile, RequestFile, SetCorsBehavior) => {
        /**
         * Backwards compatibility.
         * @internal
         * @deprecated
         */
        FileTools = {
            DecodeBase64UrlToBinary,
            DecodeBase64UrlToString,
            DefaultRetryStrategy: FileToolsOptions.DefaultRetryStrategy,
            BaseUrl: FileToolsOptions.BaseUrl,
            CorsBehavior: FileToolsOptions.CorsBehavior,
            PreprocessUrl: FileToolsOptions.PreprocessUrl,
            IsBase64DataUrl,
            IsFileURL,
            LoadFile,
            LoadImage,
            ReadFile,
            RequestFile,
            SetCorsBehavior,
        };
        Object.defineProperty(FileTools, "DefaultRetryStrategy", {
            get: function () {
                return FileToolsOptions.DefaultRetryStrategy;
            },
            set: function (value) {
                FileToolsOptions.DefaultRetryStrategy = value;
            },
        });
        Object.defineProperty(FileTools, "BaseUrl", {
            get: function () {
                return FileToolsOptions.BaseUrl;
            },
            set: function (value) {
                FileToolsOptions.BaseUrl = value;
            },
        });
        Object.defineProperty(FileTools, "PreprocessUrl", {
            get: function () {
                return FileToolsOptions.PreprocessUrl;
            },
            set: function (value) {
                FileToolsOptions.PreprocessUrl = value;
            },
        });
        Object.defineProperty(FileTools, "CorsBehavior", {
            get: function () {
                return FileToolsOptions.CorsBehavior;
            },
            set: function (value) {
                FileToolsOptions.CorsBehavior = value;
            },
        });
    };
    _injectLTSFileTools(DecodeBase64UrlToBinary, DecodeBase64UrlToString, FileToolsOptions, IsBase64DataUrl, IsFileURL, LoadFile, LoadImage, ReadFile, RequestFile, SetCorsBehavior);

    /**
     * Class used to enable instantiation of objects by class name
     */
    class InstantiationTools {
        /**
         * Tries to instantiate a new object from a given class name
         * @param className defines the class name to instantiate
         * @returns the new object or null if the system was not able to do the instantiation
         */
        static Instantiate(className) {
            if (this.RegisteredExternalClasses && this.RegisteredExternalClasses[className]) {
                return this.RegisteredExternalClasses[className];
            }
            const internalClass = GetClass(className);
            if (internalClass) {
                return internalClass;
            }
            Logger.Warn(className + " not found, you may have missed an import.");
            const arr = className.split(".");
            let fn = window || this;
            for (let i = 0, len = arr.length; i < len; i++) {
                fn = fn[arr[i]];
            }
            if (typeof fn !== "function") {
                return null;
            }
            return fn;
        }
    }
    /**
     * Use this object to register external classes like custom textures or material
     * to allow the loaders to instantiate them
     */
    InstantiationTools.RegisteredExternalClasses = {};

    /**
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a pseudo random id
     */
    function RandomGUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0, v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    /**
     * Class containing a set of static utilities functions
     */
    class Tools {
        /**
         * Gets or sets the base URL to use to load assets
         */
        static get BaseUrl() {
            return FileToolsOptions.BaseUrl;
        }
        static set BaseUrl(value) {
            FileToolsOptions.BaseUrl = value;
        }
        /**
         * Gets or sets the retry strategy to apply when an error happens while loading an asset
         */
        static get DefaultRetryStrategy() {
            return FileToolsOptions.DefaultRetryStrategy;
        }
        static set DefaultRetryStrategy(strategy) {
            FileToolsOptions.DefaultRetryStrategy = strategy;
        }
        /**
         * Default behaviour for cors in the application.
         * It can be a string if the expected behavior is identical in the entire app.
         * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
         */
        static get CorsBehavior() {
            return FileToolsOptions.CorsBehavior;
        }
        static set CorsBehavior(value) {
            FileToolsOptions.CorsBehavior = value;
        }
        /**
         * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
         * @ignorenaming
         */
        static get UseFallbackTexture() {
            return EngineStore.UseFallbackTexture;
        }
        static set UseFallbackTexture(value) {
            EngineStore.UseFallbackTexture = value;
        }
        /**
         * Use this object to register external classes like custom textures or material
         * to allow the loaders to instantiate them
         */
        static get RegisteredExternalClasses() {
            return InstantiationTools.RegisteredExternalClasses;
        }
        static set RegisteredExternalClasses(classes) {
            InstantiationTools.RegisteredExternalClasses = classes;
        }
        /**
         * Texture content used if a texture cannot loaded
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static get fallbackTexture() {
            return EngineStore.FallbackTexture;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static set fallbackTexture(value) {
            EngineStore.FallbackTexture = value;
        }
        /**
         * Read the content of a byte array at a specified coordinates (taking in account wrapping)
         * @param u defines the coordinate on X axis
         * @param v defines the coordinate on Y axis
         * @param width defines the width of the source data
         * @param height defines the height of the source data
         * @param pixels defines the source byte array
         * @param color defines the output color
         */
        static FetchToRef(u, v, width, height, pixels, color) {
            const wrappedU = (Math.abs(u) * width) % width | 0;
            const wrappedV = (Math.abs(v) * height) % height | 0;
            const position = (wrappedU + wrappedV * width) * 4;
            color.r = pixels[position] / 255;
            color.g = pixels[position + 1] / 255;
            color.b = pixels[position + 2] / 255;
            color.a = pixels[position + 3] / 255;
        }
        /**
         * Interpolates between a and b via alpha
         * @param a The lower value (returned when alpha = 0)
         * @param b The upper value (returned when alpha = 1)
         * @param alpha The interpolation-factor
         * @returns The mixed value
         */
        static Mix(a, b, alpha) {
            return a * (1 - alpha) + b * alpha;
        }
        /**
         * Tries to instantiate a new object from a given class name
         * @param className defines the class name to instantiate
         * @returns the new object or null if the system was not able to do the instantiation
         */
        static Instantiate(className) {
            return InstantiationTools.Instantiate(className);
        }
        /**
         * Polyfill for setImmediate
         * @param action defines the action to execute after the current execution block
         */
        static SetImmediate(action) {
            TimingTools.SetImmediate(action);
        }
        /**
         * Function indicating if a number is an exponent of 2
         * @param value defines the value to test
         * @returns true if the value is an exponent of 2
         */
        static IsExponentOfTwo(value) {
            let count = 1;
            do {
                count *= 2;
            } while (count < value);
            return count === value;
        }
        /**
         * Returns the nearest 32-bit single precision float representation of a Number
         * @param value A Number.  If the parameter is of a different type, it will get converted
         * to a number or to NaN if it cannot be converted
         * @returns number
         */
        static FloatRound(value) {
            if (Math.fround) {
                return Math.fround(value);
            }
            return (Tools._TmpFloatArray[0] = value), Tools._TmpFloatArray[0];
        }
        /**
         * Extracts the filename from a path
         * @param path defines the path to use
         * @returns the filename
         */
        static GetFilename(path) {
            const index = path.lastIndexOf("/");
            if (index < 0) {
                return path;
            }
            return path.substring(index + 1);
        }
        /**
         * Extracts the "folder" part of a path (everything before the filename).
         * @param uri The URI to extract the info from
         * @param returnUnchangedIfNoSlash Do not touch the URI if no slashes are present
         * @returns The "folder" part of the path
         */
        static GetFolderPath(uri, returnUnchangedIfNoSlash = false) {
            const index = uri.lastIndexOf("/");
            if (index < 0) {
                if (returnUnchangedIfNoSlash) {
                    return uri;
                }
                return "";
            }
            return uri.substring(0, index + 1);
        }
        /**
         * Convert an angle in radians to degrees
         * @param angle defines the angle to convert
         * @returns the angle in degrees
         */
        static ToDegrees(angle) {
            return (angle * 180) / Math.PI;
        }
        /**
         * Convert an angle in degrees to radians
         * @param angle defines the angle to convert
         * @returns the angle in radians
         */
        static ToRadians(angle) {
            return (angle * Math.PI) / 180;
        }
        /**
         * Smooth angle changes (kind of low-pass filter), in particular for device orientation "shaking"
         * Use trigonometric functions to avoid discontinuity (0/360, -180/180)
         * @param previousAngle defines last angle value, in degrees
         * @param newAngle defines new angle value, in degrees
         * @param smoothFactor defines smoothing sensitivity; min 0: no smoothing, max 1: new data ignored
         * @returns the angle in degrees
         */
        static SmoothAngleChange(previousAngle, newAngle, smoothFactor = 0.9) {
            const previousAngleRad = this.ToRadians(previousAngle);
            const newAngleRad = this.ToRadians(newAngle);
            return this.ToDegrees(Math.atan2((1 - smoothFactor) * Math.sin(newAngleRad) + smoothFactor * Math.sin(previousAngleRad), (1 - smoothFactor) * Math.cos(newAngleRad) + smoothFactor * Math.cos(previousAngleRad)));
        }
        /**
         * Returns an array if obj is not an array
         * @param obj defines the object to evaluate as an array
         * @param allowsNullUndefined defines a boolean indicating if obj is allowed to be null or undefined
         * @returns either obj directly if obj is an array or a new array containing obj
         */
        static MakeArray(obj, allowsNullUndefined) {
            if (allowsNullUndefined !== true && (obj === undefined || obj == null)) {
                return null;
            }
            return Array.isArray(obj) ? obj : [obj];
        }
        /**
         * Gets the pointer prefix to use
         * @param engine defines the engine we are finding the prefix for
         * @returns "pointer" if touch is enabled. Else returns "mouse"
         */
        static GetPointerPrefix(engine) {
            let eventPrefix = "pointer";
            // Check if pointer events are supported
            if (IsWindowObjectExist() && !window.PointerEvent) {
                eventPrefix = "mouse";
            }
            // Special Fallback MacOS Safari...
            if (engine._badDesktopOS &&
                !engine._badOS &&
                // And not ipad pros who claim to be macs...
                !(document && "ontouchend" in document)) {
                eventPrefix = "mouse";
            }
            return eventPrefix;
        }
        /**
         * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
         * @param url define the url we are trying
         * @param element define the dom element where to configure the cors policy
         * @param element.crossOrigin
         */
        static SetCorsBehavior(url, element) {
            SetCorsBehavior(url, element);
        }
        /**
         * Sets the referrerPolicy behavior on a dom element.
         * @param referrerPolicy define the referrer policy to use
         * @param element define the dom element where to configure the referrer policy
         * @param element.referrerPolicy
         */
        static SetReferrerPolicyBehavior(referrerPolicy, element) {
            element.referrerPolicy = referrerPolicy;
        }
        // External files
        /**
         * Removes unwanted characters from an url
         * @param url defines the url to clean
         * @returns the cleaned url
         */
        static CleanUrl(url) {
            url = url.replace(/#/gm, "%23");
            return url;
        }
        /**
         * Gets or sets a function used to pre-process url before using them to load assets
         */
        static get PreprocessUrl() {
            return FileToolsOptions.PreprocessUrl;
        }
        static set PreprocessUrl(processor) {
            FileToolsOptions.PreprocessUrl = processor;
        }
        /**
         * Loads an image as an HTMLImageElement.
         * @param input url string, ArrayBuffer, or Blob to load
         * @param onLoad callback called when the image successfully loads
         * @param onError callback called when the image fails to load
         * @param offlineProvider offline provider for caching
         * @param mimeType optional mime type
         * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
         * @returns the HTMLImageElement of the loaded image
         */
        static LoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
            return LoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions);
        }
        /**
         * Loads a file from a url
         * @param url url string, ArrayBuffer, or Blob to load
         * @param onSuccess callback called when the file successfully loads
         * @param onProgress callback called while file is loading (if the server supports this mode)
         * @param offlineProvider defines the offline provider for caching
         * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
         * @param onError callback called when the file fails to load
         * @returns a file request object
         */
        static LoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
            return LoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        }
        /**
         * Loads a file from a url
         * @param url the file url to load
         * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
         * @returns a promise containing an ArrayBuffer corresponding to the loaded file
         */
        static LoadFileAsync(url, useArrayBuffer = true) {
            return new Promise((resolve, reject) => {
                LoadFile(url, (data) => {
                    resolve(data);
                }, undefined, undefined, useArrayBuffer, (request, exception) => {
                    reject(exception);
                });
            });
        }
        /**
         * Load a script (identified by an url). When the url returns, the
         * content of this file is added into a new script element, attached to the DOM (body element)
         * @param scriptUrl defines the url of the script to laod
         * @param onSuccess defines the callback called when the script is loaded
         * @param onError defines the callback to call if an error occurs
         * @param scriptId defines the id of the script element
         */
        static LoadScript(scriptUrl, onSuccess, onError, scriptId) {
            if (typeof importScripts === "function") {
                try {
                    importScripts(scriptUrl);
                    onSuccess();
                }
                catch (e) {
                    onError === null || onError === void 0 ? void 0 : onError(`Unable to load script '${scriptUrl}' in worker`, e);
                }
                return;
            }
            else if (!IsWindowObjectExist()) {
                onError === null || onError === void 0 ? void 0 : onError(`Cannot load script '${scriptUrl}' outside of a window or a worker`);
                return;
            }
            const head = document.getElementsByTagName("head")[0];
            const script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            script.setAttribute("src", scriptUrl);
            if (scriptId) {
                script.id = scriptId;
            }
            script.onload = () => {
                if (onSuccess) {
                    onSuccess();
                }
            };
            script.onerror = (e) => {
                if (onError) {
                    onError(`Unable to load script '${scriptUrl}'`, e);
                }
            };
            head.appendChild(script);
        }
        /**
         * Load an asynchronous script (identified by an url). When the url returns, the
         * content of this file is added into a new script element, attached to the DOM (body element)
         * @param scriptUrl defines the url of the script to laod
         * @returns a promise request object
         */
        static LoadScriptAsync(scriptUrl) {
            return new Promise((resolve, reject) => {
                this.LoadScript(scriptUrl, () => {
                    resolve();
                }, (message, exception) => {
                    reject(exception || new Error(message));
                });
            });
        }
        /**
         * Loads a file from a blob
         * @param fileToLoad defines the blob to use
         * @param callback defines the callback to call when data is loaded
         * @param progressCallback defines the callback to call during loading process
         * @returns a file request object
         */
        static ReadFileAsDataURL(fileToLoad, callback, progressCallback) {
            const reader = new FileReader();
            const request = {
                onCompleteObservable: new Observable$1(),
                abort: () => reader.abort(),
            };
            reader.onloadend = () => {
                request.onCompleteObservable.notifyObservers(request);
            };
            reader.onload = (e) => {
                //target doesn't have result from ts 1.3
                callback(e.target["result"]);
            };
            reader.onprogress = progressCallback;
            reader.readAsDataURL(fileToLoad);
            return request;
        }
        /**
         * Reads a file from a File object
         * @param file defines the file to load
         * @param onSuccess defines the callback to call when data is loaded
         * @param onProgress defines the callback to call during loading process
         * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
         * @param onError defines the callback to call when an error occurs
         * @returns a file request object
         */
        static ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
            return ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError);
        }
        /**
         * Creates a data url from a given string content
         * @param content defines the content to convert
         * @returns the new data url link
         */
        static FileAsURL(content) {
            const fileBlob = new Blob([content]);
            const url = window.URL;
            const link = url.createObjectURL(fileBlob);
            return link;
        }
        /**
         * Format the given number to a specific decimal format
         * @param value defines the number to format
         * @param decimals defines the number of decimals to use
         * @returns the formatted string
         */
        static Format(value, decimals = 2) {
            return value.toFixed(decimals);
        }
        /**
         * Tries to copy an object by duplicating every property
         * @param source defines the source object
         * @param destination defines the target object
         * @param doNotCopyList defines a list of properties to avoid
         * @param mustCopyList defines a list of properties to copy (even if they start with _)
         */
        static DeepCopy(source, destination, doNotCopyList, mustCopyList) {
            DeepCopier.DeepCopy(source, destination, doNotCopyList, mustCopyList);
        }
        /**
         * Gets a boolean indicating if the given object has no own property
         * @param obj defines the object to test
         * @returns true if object has no own property
         */
        static IsEmpty(obj) {
            for (const i in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, i)) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Function used to register events at window level
         * @param windowElement defines the Window object to use
         * @param events defines the events to register
         */
        static RegisterTopRootEvents(windowElement, events) {
            for (let index = 0; index < events.length; index++) {
                const event = events[index];
                windowElement.addEventListener(event.name, event.handler, false);
                try {
                    if (window.parent) {
                        window.parent.addEventListener(event.name, event.handler, false);
                    }
                }
                catch (e) {
                    // Silently fails...
                }
            }
        }
        /**
         * Function used to unregister events from window level
         * @param windowElement defines the Window object to use
         * @param events defines the events to unregister
         */
        static UnregisterTopRootEvents(windowElement, events) {
            for (let index = 0; index < events.length; index++) {
                const event = events[index];
                windowElement.removeEventListener(event.name, event.handler);
                try {
                    if (windowElement.parent) {
                        windowElement.parent.removeEventListener(event.name, event.handler);
                    }
                }
                catch (e) {
                    // Silently fails...
                }
            }
        }
        /**
         * Dumps the current bound framebuffer
         * @param width defines the rendering width
         * @param height defines the rendering height
         * @param engine defines the hosting engine
         * @param successCallback defines the callback triggered once the data are available
         * @param mimeType defines the mime type of the result
         * @param fileName defines the filename to download. If present, the result will automatically be downloaded
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         * @returns a void promise
         */
        static async DumpFramebuffer(width, height, engine, successCallback, mimeType = "image/png", fileName, quality) {
            throw _WarnImport("DumpTools");
        }
        /**
         * Dumps an array buffer
         * @param width defines the rendering width
         * @param height defines the rendering height
         * @param data the data array
         * @param successCallback defines the callback triggered once the data are available
         * @param mimeType defines the mime type of the result
         * @param fileName defines the filename to download. If present, the result will automatically be downloaded
         * @param invertY true to invert the picture in the Y dimension
         * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         */
        static DumpData(width, height, data, successCallback, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
            throw _WarnImport("DumpTools");
        }
        /**
         * Dumps an array buffer
         * @param width defines the rendering width
         * @param height defines the rendering height
         * @param data the data array
         * @param mimeType defines the mime type of the result
         * @param fileName defines the filename to download. If present, the result will automatically be downloaded
         * @param invertY true to invert the picture in the Y dimension
         * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         * @returns a promise that resolve to the final data
         */
        static DumpDataAsync(width, height, data, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
            throw _WarnImport("DumpTools");
        }
        static _IsOffScreenCanvas(canvas) {
            return canvas.convertToBlob !== undefined;
        }
        /**
         * Converts the canvas data to blob.
         * This acts as a polyfill for browsers not supporting the to blob function.
         * @param canvas Defines the canvas to extract the data from (can be an offscreen canvas)
         * @param successCallback Defines the callback triggered once the data are available
         * @param mimeType Defines the mime type of the result
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         */
        static ToBlob(canvas, successCallback, mimeType = "image/png", quality) {
            // We need HTMLCanvasElement.toBlob for HD screenshots
            if (!Tools._IsOffScreenCanvas(canvas) && !canvas.toBlob) {
                //  low performance polyfill based on toDataURL (https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob)
                canvas.toBlob = function (callback, type, quality) {
                    setTimeout(() => {
                        const binStr = atob(this.toDataURL(type, quality).split(",")[1]), len = binStr.length, arr = new Uint8Array(len);
                        for (let i = 0; i < len; i++) {
                            arr[i] = binStr.charCodeAt(i);
                        }
                        callback(new Blob([arr]));
                    });
                };
            }
            if (Tools._IsOffScreenCanvas(canvas)) {
                canvas
                    .convertToBlob({
                    type: mimeType,
                    quality,
                })
                    .then((blob) => successCallback(blob));
            }
            else {
                canvas.toBlob(function (blob) {
                    successCallback(blob);
                }, mimeType, quality);
            }
        }
        /**
         * Download a Blob object
         * @param blob the Blob object
         * @param fileName the file name to download
         * @returns
         */
        static DownloadBlob(blob, fileName) {
            //Creating a link if the browser have the download attribute on the a tag, to automatically start download generated image.
            if ("download" in document.createElement("a")) {
                if (!fileName) {
                    const date = new Date();
                    const stringDate = (date.getFullYear() + "-" + (date.getMonth() + 1)).slice(2) + "-" + date.getDate() + "_" + date.getHours() + "-" + ("0" + date.getMinutes()).slice(-2);
                    fileName = "screenshot_" + stringDate + ".png";
                }
                Tools.Download(blob, fileName);
            }
            else {
                if (blob && typeof URL !== "undefined") {
                    const url = URL.createObjectURL(blob);
                    const newWindow = window.open("");
                    if (!newWindow) {
                        return;
                    }
                    const img = newWindow.document.createElement("img");
                    img.onload = function () {
                        // no longer need to read the blob so it's revoked
                        URL.revokeObjectURL(url);
                    };
                    img.src = url;
                    newWindow.document.body.appendChild(img);
                }
            }
        }
        /**
         * Encodes the canvas data to base 64, or automatically downloads the result if `fileName` is defined.
         * @param canvas The canvas to get the data from, which can be an offscreen canvas.
         * @param successCallback The callback which is triggered once the data is available. If `fileName` is defined, the callback will be invoked after the download occurs, and the `data` argument will be an empty string.
         * @param mimeType The mime type of the result.
         * @param fileName The name of the file to download. If defined, the result will automatically be downloaded. If not defined, and `successCallback` is also not defined, the result will automatically be downloaded with an auto-generated file name.
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         */
        static EncodeScreenshotCanvasData(canvas, successCallback, mimeType = "image/png", fileName, quality) {
            if (typeof fileName === "string" || !successCallback) {
                this.ToBlob(canvas, function (blob) {
                    if (blob) {
                        Tools.DownloadBlob(blob, fileName);
                    }
                    if (successCallback) {
                        successCallback("");
                    }
                }, mimeType, quality);
            }
            else if (successCallback) {
                if (Tools._IsOffScreenCanvas(canvas)) {
                    canvas
                        .convertToBlob({
                        type: mimeType,
                        quality,
                    })
                        .then((blob) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = () => {
                            const base64data = reader.result;
                            successCallback(base64data);
                        };
                    });
                    return;
                }
                const base64Image = canvas.toDataURL(mimeType, quality);
                successCallback(base64Image);
            }
        }
        /**
         * Downloads a blob in the browser
         * @param blob defines the blob to download
         * @param fileName defines the name of the downloaded file
         */
        static Download(blob, fileName) {
            if (typeof URL === "undefined") {
                return;
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            a.href = url;
            a.download = fileName;
            a.addEventListener("click", () => {
                if (a.parentElement) {
                    a.parentElement.removeChild(a);
                }
            });
            a.click();
            window.URL.revokeObjectURL(url);
        }
        /**
         * Will return the right value of the noPreventDefault variable
         * Needed to keep backwards compatibility to the old API.
         *
         * @param args arguments passed to the attachControl function
         * @returns the correct value for noPreventDefault
         */
        static BackCompatCameraNoPreventDefault(args) {
            // is it used correctly?
            if (typeof args[0] === "boolean") {
                return args[0];
            }
            else if (typeof args[1] === "boolean") {
                return args[1];
            }
            return false;
        }
        /**
         * Captures a screenshot of the current rendering
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
         * @param engine defines the rendering engine
         * @param camera defines the source camera
         * @param size This parameter can be set to a single number or to an object with the
         * following (optional) properties: precision, width, height. If a single number is passed,
         * it will be used for both width and height. If an object is passed, the screenshot size
         * will be derived from the parameters. The precision property is a multiplier allowing
         * rendering at a higher or lower resolution
         * @param successCallback defines the callback receives a single parameter which contains the
         * screenshot as a string of base64-encoded characters. This string can be assigned to the
         * src parameter of an <img> to display it
         * @param mimeType defines the MIME type of the screenshot image (default: image/png).
         * Check your browser for supported MIME types
         * @param forceDownload force the system to download the image even if a successCallback is provided
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static CreateScreenshot(engine, camera, size, successCallback, mimeType = "image/png", forceDownload = false, quality) {
            throw _WarnImport("ScreenshotTools");
        }
        /**
         * Captures a screenshot of the current rendering
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
         * @param engine defines the rendering engine
         * @param camera defines the source camera
         * @param size This parameter can be set to a single number or to an object with the
         * following (optional) properties: precision, width, height. If a single number is passed,
         * it will be used for both width and height. If an object is passed, the screenshot size
         * will be derived from the parameters. The precision property is a multiplier allowing
         * rendering at a higher or lower resolution
         * @param mimeType defines the MIME type of the screenshot image (default: image/png).
         * Check your browser for supported MIME types
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         * @returns screenshot as a string of base64-encoded characters. This string can be assigned
         * to the src parameter of an <img> to display it
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static CreateScreenshotAsync(engine, camera, size, mimeType = "image/png", quality) {
            throw _WarnImport("ScreenshotTools");
        }
        /**
         * Generates an image screenshot from the specified camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
         * @param engine The engine to use for rendering
         * @param camera The camera to use for rendering
         * @param size This parameter can be set to a single number or to an object with the
         * following (optional) properties: precision, width, height. If a single number is passed,
         * it will be used for both width and height. If an object is passed, the screenshot size
         * will be derived from the parameters. The precision property is a multiplier allowing
         * rendering at a higher or lower resolution
         * @param successCallback The callback receives a single parameter which contains the
         * screenshot as a string of base64-encoded characters. This string can be assigned to the
         * src parameter of an <img> to display it
         * @param mimeType The MIME type of the screenshot image (default: image/png).
         * Check your browser for supported MIME types
         * @param samples Texture samples (default: 1)
         * @param antialiasing Whether antialiasing should be turned on or not (default: false)
         * @param fileName A name for for the downloaded file.
         * @param renderSprites Whether the sprites should be rendered or not (default: false)
         * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
         * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static CreateScreenshotUsingRenderTarget(engine, camera, size, successCallback, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality) {
            throw _WarnImport("ScreenshotTools");
        }
        /**
         * Generates an image screenshot from the specified camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
         * @param engine The engine to use for rendering
         * @param camera The camera to use for rendering
         * @param size This parameter can be set to a single number or to an object with the
         * following (optional) properties: precision, width, height. If a single number is passed,
         * it will be used for both width and height. If an object is passed, the screenshot size
         * will be derived from the parameters. The precision property is a multiplier allowing
         * rendering at a higher or lower resolution
         * @param mimeType The MIME type of the screenshot image (default: image/png).
         * Check your browser for supported MIME types
         * @param samples Texture samples (default: 1)
         * @param antialiasing Whether antialiasing should be turned on or not (default: false)
         * @param fileName A name for for the downloaded file.
         * @returns screenshot as a string of base64-encoded characters. This string can be assigned
         * @param renderSprites Whether the sprites should be rendered or not (default: false)
         * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
         * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         * to the src parameter of an <img> to display it
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static CreateScreenshotUsingRenderTargetAsync(engine, camera, size, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality) {
            throw _WarnImport("ScreenshotTools");
        }
        /**
         * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
         * Be aware Math.random() could cause collisions, but:
         * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
         * @returns a pseudo random id
         */
        static RandomId() {
            return RandomGUID();
        }
        /**
         * Test if the given uri is a base64 string
         * @deprecated Please use FileTools.IsBase64DataUrl instead.
         * @param uri The uri to test
         * @returns True if the uri is a base64 string or false otherwise
         */
        static IsBase64(uri) {
            return IsBase64DataUrl(uri);
        }
        /**
         * Decode the given base64 uri.
         * @deprecated Please use FileTools.DecodeBase64UrlToBinary instead.
         * @param uri The uri to decode
         * @returns The decoded base64 data.
         */
        static DecodeBase64(uri) {
            return DecodeBase64UrlToBinary(uri);
        }
        /**
         * Gets a value indicating the number of loading errors
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static get errorsCount() {
            return Logger.errorsCount;
        }
        /**
         * Log a message to the console
         * @param message defines the message to log
         */
        static Log(message) {
            Logger.Log(message);
        }
        /**
         * Write a warning message to the console
         * @param message defines the message to log
         */
        static Warn(message) {
            Logger.Warn(message);
        }
        /**
         * Write an error message to the console
         * @param message defines the message to log
         */
        static Error(message) {
            Logger.Error(message);
        }
        /**
         * Gets current log cache (list of logs)
         */
        static get LogCache() {
            return Logger.LogCache;
        }
        /**
         * Clears the log cache
         */
        static ClearLogCache() {
            Logger.ClearLogCache();
        }
        /**
         * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
         */
        static set LogLevels(level) {
            Logger.LogLevels = level;
        }
        /**
         * Sets the current performance log level
         */
        static set PerformanceLogLevel(level) {
            if ((level & Tools.PerformanceUserMarkLogLevel) === Tools.PerformanceUserMarkLogLevel) {
                Tools.StartPerformanceCounter = Tools._StartUserMark;
                Tools.EndPerformanceCounter = Tools._EndUserMark;
                return;
            }
            if ((level & Tools.PerformanceConsoleLogLevel) === Tools.PerformanceConsoleLogLevel) {
                Tools.StartPerformanceCounter = Tools._StartPerformanceConsole;
                Tools.EndPerformanceCounter = Tools._EndPerformanceConsole;
                return;
            }
            Tools.StartPerformanceCounter = Tools._StartPerformanceCounterDisabled;
            Tools.EndPerformanceCounter = Tools._EndPerformanceCounterDisabled;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static _StartPerformanceCounterDisabled(counterName, condition) { }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static _EndPerformanceCounterDisabled(counterName, condition) { }
        static _StartUserMark(counterName, condition = true) {
            if (!Tools._Performance) {
                if (!IsWindowObjectExist()) {
                    return;
                }
                Tools._Performance = window.performance;
            }
            if (!condition || !Tools._Performance.mark) {
                return;
            }
            Tools._Performance.mark(counterName + "-Begin");
        }
        static _EndUserMark(counterName, condition = true) {
            if (!condition || !Tools._Performance.mark) {
                return;
            }
            Tools._Performance.mark(counterName + "-End");
            Tools._Performance.measure(counterName, counterName + "-Begin", counterName + "-End");
        }
        static _StartPerformanceConsole(counterName, condition = true) {
            if (!condition) {
                return;
            }
            Tools._StartUserMark(counterName, condition);
            if (console.time) {
                console.time(counterName);
            }
        }
        static _EndPerformanceConsole(counterName, condition = true) {
            if (!condition) {
                return;
            }
            Tools._EndUserMark(counterName, condition);
            console.timeEnd(counterName);
        }
        /**
         * Gets either window.performance.now() if supported or Date.now() else
         */
        static get Now() {
            return PrecisionDate.Now;
        }
        /**
         * This method will return the name of the class used to create the instance of the given object.
         * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator.
         * @param object the object to get the class name from
         * @param isType defines if the object is actually a type
         * @returns the name of the class, will be "object" for a custom data type not using the @className decorator
         */
        static GetClassName(object, isType = false) {
            let name = null;
            if (!isType && object.getClassName) {
                name = object.getClassName();
            }
            else {
                if (object instanceof Object) {
                    const classObj = isType ? object : Object.getPrototypeOf(object);
                    name = classObj.constructor["__bjsclassName__"];
                }
                if (!name) {
                    name = typeof object;
                }
            }
            return name;
        }
        /**
         * Gets the first element of an array satisfying a given predicate
         * @param array defines the array to browse
         * @param predicate defines the predicate to use
         * @returns null if not found or the element
         */
        static First(array, predicate) {
            for (const el of array) {
                if (predicate(el)) {
                    return el;
                }
            }
            return null;
        }
        /**
         * This method will return the name of the full name of the class, including its owning module (if any).
         * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator or implementing a method getClassName():string (in which case the module won't be specified).
         * @param object the object to get the class name from
         * @param isType defines if the object is actually a type
         * @returns a string that can have two forms: "moduleName.className" if module was specified when the class' Name was registered or "className" if there was not module specified.
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static getFullClassName(object, isType = false) {
            let className = null;
            let moduleName = null;
            if (!isType && object.getClassName) {
                className = object.getClassName();
            }
            else {
                if (object instanceof Object) {
                    const classObj = isType ? object : Object.getPrototypeOf(object);
                    className = classObj.constructor["__bjsclassName__"];
                    moduleName = classObj.constructor["__bjsmoduleName__"];
                }
                if (!className) {
                    className = typeof object;
                }
            }
            if (!className) {
                return null;
            }
            return (moduleName != null ? moduleName + "." : "") + className;
        }
        /**
         * Returns a promise that resolves after the given amount of time.
         * @param delay Number of milliseconds to delay
         * @returns Promise that resolves after the given amount of time
         */
        static DelayAsync(delay) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, delay);
            });
        }
        /**
         * Utility function to detect if the current user agent is Safari
         * @returns whether or not the current user agent is safari
         */
        static IsSafari() {
            if (!IsNavigatorAvailable()) {
                return false;
            }
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }
    }
    /**
     * Enable/Disable Custom HTTP Request Headers globally.
     * default = false
     * @see CustomRequestHeaders
     */
    Tools.UseCustomRequestHeaders = false;
    /**
     * Custom HTTP Request Headers to be sent with XMLHttpRequests
     * i.e. when loading files, where the server/service expects an Authorization header
     */
    Tools.CustomRequestHeaders = WebRequest.CustomRequestHeaders;
    Tools._TmpFloatArray = new Float32Array(1);
    /**
     * Extracts text content from a DOM element hierarchy
     * Back Compat only, please use GetDOMTextContent instead.
     */
    Tools.GetDOMTextContent = GetDOMTextContent;
    Tools.GetAbsoluteUrl = typeof document === "object"
        ? (url) => {
            const a = document.createElement("a");
            a.href = url;
            return a.href;
        }
        : typeof URL === "function" && typeof location === "object"
            ? (url) => new URL(url, location.origin).href
            : () => {
                throw new Error("Unable to get absolute URL. Override BABYLON.Tools.GetAbsoluteUrl to a custom implementation for the current context.");
            };
    // Logs
    /**
     * No log
     */
    Tools.NoneLogLevel = Logger.NoneLogLevel;
    /**
     * Only message logs
     */
    Tools.MessageLogLevel = Logger.MessageLogLevel;
    /**
     * Only warning logs
     */
    Tools.WarningLogLevel = Logger.WarningLogLevel;
    /**
     * Only error logs
     */
    Tools.ErrorLogLevel = Logger.ErrorLogLevel;
    /**
     * All logs
     */
    Tools.AllLogLevel = Logger.AllLogLevel;
    /**
     * Checks if the window object exists
     * Back Compat only, please use IsWindowObjectExist instead.
     */
    Tools.IsWindowObjectExist = IsWindowObjectExist;
    // Performances
    /**
     * No performance log
     */
    Tools.PerformanceNoneLogLevel = 0;
    /**
     * Use user marks to log performance
     */
    Tools.PerformanceUserMarkLogLevel = 1;
    /**
     * Log performance to the console
     */
    Tools.PerformanceConsoleLogLevel = 2;
    /**
     * Starts a performance counter
     */
    Tools.StartPerformanceCounter = Tools._StartPerformanceCounterDisabled;
    /**
     * Ends a specific performance counter
     */
    Tools.EndPerformanceCounter = Tools._EndPerformanceCounterDisabled;
    /**
     * An implementation of a loop for asynchronous functions.
     */
    class AsyncLoop {
        /**
         * Constructor.
         * @param iterations the number of iterations.
         * @param func the function to run each iteration
         * @param successCallback the callback that will be called upon successful execution
         * @param offset starting offset.
         */
        constructor(
        /**
         * Defines the number of iterations for the loop
         */
        iterations, func, successCallback, offset = 0) {
            this.iterations = iterations;
            this.index = offset - 1;
            this._done = false;
            this._fn = func;
            this._successCallback = successCallback;
        }
        /**
         * Execute the next iteration. Must be called after the last iteration was finished.
         */
        executeNext() {
            if (!this._done) {
                if (this.index + 1 < this.iterations) {
                    ++this.index;
                    this._fn(this);
                }
                else {
                    this.breakLoop();
                }
            }
        }
        /**
         * Break the loop and run the success callback.
         */
        breakLoop() {
            this._done = true;
            this._successCallback();
        }
        /**
         * Create and run an async loop.
         * @param iterations the number of iterations.
         * @param fn the function to run each iteration
         * @param successCallback the callback that will be called upon successful execution
         * @param offset starting offset.
         * @returns the created async loop object
         */
        static Run(iterations, fn, successCallback, offset = 0) {
            const loop = new AsyncLoop(iterations, fn, successCallback, offset);
            loop.executeNext();
            return loop;
        }
        /**
         * A for-loop that will run a given number of iterations synchronous and the rest async.
         * @param iterations total number of iterations
         * @param syncedIterations number of synchronous iterations in each async iteration.
         * @param fn the function to call each iteration.
         * @param callback a success call back that will be called when iterating stops.
         * @param breakFunction a break condition (optional)
         * @param timeout timeout settings for the setTimeout function. default - 0.
         * @returns the created async loop object
         */
        static SyncAsyncForLoop(iterations, syncedIterations, fn, callback, breakFunction, timeout = 0) {
            return AsyncLoop.Run(Math.ceil(iterations / syncedIterations), (loop) => {
                if (breakFunction && breakFunction()) {
                    loop.breakLoop();
                }
                else {
                    setTimeout(() => {
                        for (let i = 0; i < syncedIterations; ++i) {
                            const iteration = loop.index * syncedIterations + i;
                            if (iteration >= iterations) {
                                break;
                            }
                            fn(iteration);
                            if (breakFunction && breakFunction()) {
                                loop.breakLoop();
                                break;
                            }
                        }
                        loop.executeNext();
                    }, timeout);
                }
            }, callback);
        }
    }
    // Will only be define if Tools is imported freeing up some space when only engine is required
    EngineStore.FallbackTexture =
        "data:image/jpg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4QBmRXhpZgAATU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAAExAAIAAAAQAAAATgAAAAAAAABgAAAAAQAAAGAAAAABcGFpbnQubmV0IDQuMC41AP/bAEMABAIDAwMCBAMDAwQEBAQFCQYFBQUFCwgIBgkNCw0NDQsMDA4QFBEODxMPDAwSGBITFRYXFxcOERkbGRYaFBYXFv/bAEMBBAQEBQUFCgYGChYPDA8WFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFv/AABEIAQABAAMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APH6KKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FCiiigD6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++gooooA+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gUKKKKAPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76CiiigD5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BQooooA+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/voKKKKAPl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FCiiigD6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++gooooA+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gUKKKKAPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76CiiigD5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BQooooA+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/voKKKKAPl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FCiiigD6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++gooooA+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gUKKKKAPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76Pl+iiivuj+BT6gooor4U/vo+X6KKK+6P4FPqCiiivhT++j5fooor7o/gU+oKKKK+FP76P//Z";

    /* eslint-disable @typescript-eslint/naming-convention */
    // "Coroutines are computer program components that generalize subroutines for non-preemptive multitasking, by allowing execution to be suspended and resumed."
    // https://en.wikipedia.org/wiki/Coroutine
    // The inline scheduler simply steps the coroutine synchronously. This is useful for running a coroutine synchronously, and also as a helper function for other schedulers.
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function inlineScheduler(coroutine, onStep, onError) {
        try {
            const step = coroutine.next();
            if (step.done) {
                onStep(step);
            }
            else if (!step.value) {
                // NOTE: The properties of step have been narrowed, but the type of step itself is not narrowed, so the cast below is the most type safe way to deal with this without instantiating a new object to hold the values.
                onStep(step);
            }
            else {
                step.value.then(() => {
                    step.value = undefined;
                    onStep(step);
                }, onError);
            }
        }
        catch (error) {
            onError(error);
        }
    }
    // The yielding scheduler steps the coroutine synchronously until the specified time interval has elapsed, then yields control so other operations can be performed.
    // A single instance of a yielding scheduler could be shared across multiple coroutines to yield when their collective work exceeds the threshold.
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function createYieldingScheduler(yieldAfterMS = 25) {
        let startTime;
        return (coroutine, onStep, onError) => {
            const currentTime = performance.now();
            if (startTime === undefined || currentTime - startTime > yieldAfterMS) {
                // If this is the first coroutine step, or if the time interval has elapsed, record a new start time, and schedule the coroutine step to happen later, effectively yielding control of the execution context.
                startTime = currentTime;
                setTimeout(() => {
                    inlineScheduler(coroutine, onStep, onError);
                }, 0);
            }
            else {
                // Otherwise it is not time to yield yet, so step the coroutine synchronously.
                inlineScheduler(coroutine, onStep, onError);
            }
        };
    }
    // Runs the specified coroutine with the specified scheduler. The success or error callback will be invoked when the coroutine finishes.
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function runCoroutine(coroutine, scheduler, onSuccess, onError, abortSignal) {
        const resume = () => {
            let reschedule;
            const onStep = (stepResult) => {
                if (stepResult.done) {
                    // If the coroutine is done, report success.
                    onSuccess(stepResult.value);
                }
                else {
                    // If the coroutine is not done, resume the coroutine (via the scheduler).
                    if (reschedule === undefined) {
                        // If reschedule is undefined at this point, then the coroutine must have stepped synchronously, so just flag another loop iteration.
                        reschedule = true;
                    }
                    else {
                        // If reschedule is defined at this point, then the coroutine must have stepped asynchronously, so call resume to restart the step loop.
                        resume();
                    }
                }
            };
            do {
                reschedule = undefined;
                if (!abortSignal || !abortSignal.aborted) {
                    scheduler(coroutine, onStep, onError);
                }
                else {
                    onError(new Error("Aborted"));
                }
                if (reschedule === undefined) {
                    // If reschedule is undefined at this point, then the coroutine must have stepped asynchronously, so stop looping and let the coroutine be resumed later.
                    reschedule = false;
                }
            } while (reschedule);
        };
        resume();
    }
    // Runs the specified coroutine synchronously.
    /**
     * @internal
     */
    function runCoroutineSync(coroutine, abortSignal) {
        // Run the coroutine with the inline scheduler, storing the returned value, or re-throwing the error (since the error callback will be called synchronously by the inline scheduler).
        let result;
        runCoroutine(coroutine, inlineScheduler, (r) => (result = r), (e) => {
            throw e;
        }, abortSignal);
        // Synchronously return the result of the coroutine.
        return result;
    }
    // Runs the specified coroutine asynchronously with the specified scheduler.
    /**
     * @internal
     */
    function runCoroutineAsync(coroutine, scheduler, abortSignal) {
        // Run the coroutine with a yielding scheduler, resolving or rejecting the result promise when the coroutine finishes.
        return new Promise((resolve, reject) => {
            runCoroutine(coroutine, scheduler, resolve, reject, abortSignal);
        });
    }
    /**
     * Given a function that returns a Coroutine<T>, produce a function with the same parameters that returns a T.
     * The returned function runs the coroutine synchronously.
     * @param coroutineFactory A function that returns a Coroutine<T>.
     * @param abortSignal
     * @returns A function that runs the coroutine synchronously.
     * @internal
     */
    function makeSyncFunction(coroutineFactory, abortSignal) {
        return (...params) => {
            // Run the coroutine synchronously.
            return runCoroutineSync(coroutineFactory(...params), abortSignal);
        };
    }

    /**
     * Defines an GC Friendly array where the backfield array do not shrink to prevent over allocations.
     */
    class SmartArray {
        /**
         * Instantiates a Smart Array.
         * @param capacity defines the default capacity of the array.
         */
        constructor(capacity) {
            /**
             * The active length of the array.
             */
            this.length = 0;
            this.data = new Array(capacity);
            this._id = SmartArray._GlobalId++;
        }
        /**
         * Pushes a value at the end of the active data.
         * @param value defines the object to push in the array.
         */
        push(value) {
            this.data[this.length++] = value;
            if (this.length > this.data.length) {
                this.data.length *= 2;
            }
        }
        /**
         * Iterates over the active data and apply the lambda to them.
         * @param func defines the action to apply on each value.
         */
        forEach(func) {
            for (let index = 0; index < this.length; index++) {
                func(this.data[index]);
            }
        }
        /**
         * Sorts the full sets of data.
         * @param compareFn defines the comparison function to apply.
         */
        sort(compareFn) {
            this.data.sort(compareFn);
        }
        /**
         * Resets the active data to an empty array.
         */
        reset() {
            this.length = 0;
        }
        /**
         * Releases all the data from the array as well as the array.
         */
        dispose() {
            this.reset();
            if (this.data) {
                this.data.length = 0;
            }
        }
        /**
         * Concats the active data with a given array.
         * @param array defines the data to concatenate with.
         */
        concat(array) {
            if (array.length === 0) {
                return;
            }
            if (this.length + array.length > this.data.length) {
                this.data.length = (this.length + array.length) * 2;
            }
            for (let index = 0; index < array.length; index++) {
                this.data[this.length++] = (array.data || array)[index];
            }
        }
        /**
         * Returns the position of a value in the active data.
         * @param value defines the value to find the index for
         * @returns the index if found in the active data otherwise -1
         */
        indexOf(value) {
            const position = this.data.indexOf(value);
            if (position >= this.length) {
                return -1;
            }
            return position;
        }
        /**
         * Returns whether an element is part of the active data.
         * @param value defines the value to look for
         * @returns true if found in the active data otherwise false
         */
        contains(value) {
            return this.indexOf(value) !== -1;
        }
    }
    // Statics
    SmartArray._GlobalId = 0;
    /**
     * Defines an GC Friendly array where the backfield array do not shrink to prevent over allocations.
     * The data in this array can only be present once
     */
    class SmartArrayNoDuplicate extends SmartArray {
        constructor() {
            super(...arguments);
            this._duplicateId = 0;
        }
        /**
         * Pushes a value at the end of the active data.
         * THIS DOES NOT PREVENT DUPPLICATE DATA
         * @param value defines the object to push in the array.
         */
        push(value) {
            super.push(value);
            if (!value.__smartArrayFlags) {
                value.__smartArrayFlags = {};
            }
            value.__smartArrayFlags[this._id] = this._duplicateId;
        }
        /**
         * Pushes a value at the end of the active data.
         * If the data is already present, it won t be added again
         * @param value defines the object to push in the array.
         * @returns true if added false if it was already present
         */
        pushNoDuplicate(value) {
            if (value.__smartArrayFlags && value.__smartArrayFlags[this._id] === this._duplicateId) {
                return false;
            }
            this.push(value);
            return true;
        }
        /**
         * Resets the active data to an empty array.
         */
        reset() {
            super.reset();
            this._duplicateId++;
        }
        /**
         * Concats the active data with a given array.
         * This ensures no duplicate will be present in the result.
         * @param array defines the data to concatenate with.
         */
        concatWithNoDuplicate(array) {
            if (array.length === 0) {
                return;
            }
            if (this.length + array.length > this.data.length) {
                this.data.length = (this.length + array.length) * 2;
            }
            for (let index = 0; index < array.length; index++) {
                const item = (array.data || array)[index];
                this.pushNoDuplicate(item);
            }
        }
    }

    /**
     * Class used to represent a viewport on screen
     */
    class Viewport {
        /**
         * Creates a Viewport object located at (x, y) and sized (width, height)
         * @param x defines viewport left coordinate
         * @param y defines viewport top coordinate
         * @param width defines the viewport width
         * @param height defines the viewport height
         */
        constructor(
        /** viewport left coordinate */
        x, 
        /** viewport top coordinate */
        y, 
        /**viewport width */
        width, 
        /** viewport height */
        height) {
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
        }
        /**
         * Creates a new viewport using absolute sizing (from 0-> width, 0-> height instead of 0->1)
         * @param renderWidth defines the rendering width
         * @param renderHeight defines the rendering height
         * @returns a new Viewport
         */
        toGlobal(renderWidth, renderHeight) {
            return new Viewport(this.x * renderWidth, this.y * renderHeight, this.width * renderWidth, this.height * renderHeight);
        }
        /**
         * Stores absolute viewport value into a target viewport (from 0-> width, 0-> height instead of 0->1)
         * @param renderWidth defines the rendering width
         * @param renderHeight defines the rendering height
         * @param ref defines the target viewport
         * @returns the current viewport
         */
        toGlobalToRef(renderWidth, renderHeight, ref) {
            ref.x = this.x * renderWidth;
            ref.y = this.y * renderHeight;
            ref.width = this.width * renderWidth;
            ref.height = this.height * renderHeight;
            return this;
        }
        /**
         * Returns a new Viewport copied from the current one
         * @returns a new Viewport
         */
        clone() {
            return new Viewport(this.x, this.y, this.width, this.height);
        }
    }

    /**
     * Represents a plane by the equation ax + by + cz + d = 0
     */
    class Plane {
        /**
         * Creates a Plane object according to the given floats a, b, c, d and the plane equation : ax + by + cz + d = 0
         * @param a a component of the plane
         * @param b b component of the plane
         * @param c c component of the plane
         * @param d d component of the plane
         */
        constructor(a, b, c, d) {
            this.normal = new Vector3(a, b, c);
            this.d = d;
        }
        /**
         * @returns the plane coordinates as a new array of 4 elements [a, b, c, d].
         */
        asArray() {
            return [this.normal.x, this.normal.y, this.normal.z, this.d];
        }
        // Methods
        /**
         * @returns a new plane copied from the current Plane.
         */
        clone() {
            return new Plane(this.normal.x, this.normal.y, this.normal.z, this.d);
        }
        /**
         * @returns the string "Plane".
         */
        getClassName() {
            return "Plane";
        }
        /**
         * @returns the Plane hash code.
         */
        getHashCode() {
            let hash = this.normal.getHashCode();
            hash = (hash * 397) ^ (this.d | 0);
            return hash;
        }
        /**
         * Normalize the current Plane in place.
         * @returns the updated Plane.
         */
        normalize() {
            const norm = Math.sqrt(this.normal.x * this.normal.x + this.normal.y * this.normal.y + this.normal.z * this.normal.z);
            let magnitude = 0.0;
            if (norm !== 0) {
                magnitude = 1.0 / norm;
            }
            this.normal.x *= magnitude;
            this.normal.y *= magnitude;
            this.normal.z *= magnitude;
            this.d *= magnitude;
            return this;
        }
        /**
         * Applies a transformation the plane and returns the result
         * @param transformation the transformation matrix to be applied to the plane
         * @returns a new Plane as the result of the transformation of the current Plane by the given matrix.
         */
        transform(transformation) {
            const invertedMatrix = Plane._TmpMatrix;
            transformation.invertToRef(invertedMatrix);
            const m = invertedMatrix.m;
            const x = this.normal.x;
            const y = this.normal.y;
            const z = this.normal.z;
            const d = this.d;
            const normalX = x * m[0] + y * m[1] + z * m[2] + d * m[3];
            const normalY = x * m[4] + y * m[5] + z * m[6] + d * m[7];
            const normalZ = x * m[8] + y * m[9] + z * m[10] + d * m[11];
            const finalD = x * m[12] + y * m[13] + z * m[14] + d * m[15];
            return new Plane(normalX, normalY, normalZ, finalD);
        }
        /**
         * Compute the dot product between the point and the plane normal
         * @param point point to calculate the dot product with
         * @returns the dot product (float) of the point coordinates and the plane normal.
         */
        dotCoordinate(point) {
            return this.normal.x * point.x + this.normal.y * point.y + this.normal.z * point.z + this.d;
        }
        /**
         * Updates the current Plane from the plane defined by the three given points.
         * @param point1 one of the points used to construct the plane
         * @param point2 one of the points used to construct the plane
         * @param point3 one of the points used to construct the plane
         * @returns the updated Plane.
         */
        copyFromPoints(point1, point2, point3) {
            const x1 = point2.x - point1.x;
            const y1 = point2.y - point1.y;
            const z1 = point2.z - point1.z;
            const x2 = point3.x - point1.x;
            const y2 = point3.y - point1.y;
            const z2 = point3.z - point1.z;
            const yz = y1 * z2 - z1 * y2;
            const xz = z1 * x2 - x1 * z2;
            const xy = x1 * y2 - y1 * x2;
            const pyth = Math.sqrt(yz * yz + xz * xz + xy * xy);
            let invPyth;
            if (pyth !== 0) {
                invPyth = 1.0 / pyth;
            }
            else {
                invPyth = 0.0;
            }
            this.normal.x = yz * invPyth;
            this.normal.y = xz * invPyth;
            this.normal.z = xy * invPyth;
            this.d = -(this.normal.x * point1.x + this.normal.y * point1.y + this.normal.z * point1.z);
            return this;
        }
        /**
         * Checks if the plane is facing a given direction (meaning if the plane's normal is pointing in the opposite direction of the given vector).
         * Note that for this function to work as expected you should make sure that:
         *   - direction and the plane normal are normalized
         *   - epsilon is a number just bigger than -1, something like -0.99 for eg
         * @param direction the direction to check if the plane is facing
         * @param epsilon value the dot product is compared against (returns true if dot <= epsilon)
         * @returns True if the plane is facing the given direction
         */
        isFrontFacingTo(direction, epsilon) {
            const dot = Vector3.Dot(this.normal, direction);
            return dot <= epsilon;
        }
        /**
         * Calculates the distance to a point
         * @param point point to calculate distance to
         * @returns the signed distance (float) from the given point to the Plane.
         */
        signedDistanceTo(point) {
            return Vector3.Dot(point, this.normal) + this.d;
        }
        // Statics
        /**
         * Creates a plane from an  array
         * @param array the array to create a plane from
         * @returns a new Plane from the given array.
         */
        static FromArray(array) {
            return new Plane(array[0], array[1], array[2], array[3]);
        }
        /**
         * Creates a plane from three points
         * @param point1 point used to create the plane
         * @param point2 point used to create the plane
         * @param point3 point used to create the plane
         * @returns a new Plane defined by the three given points.
         */
        static FromPoints(point1, point2, point3) {
            const result = new Plane(0.0, 0.0, 0.0, 0.0);
            result.copyFromPoints(point1, point2, point3);
            return result;
        }
        /**
         * Creates a plane from an origin point and a normal
         * @param origin origin of the plane to be constructed
         * @param normal normal of the plane to be constructed
         * @returns a new Plane the normal vector to this plane at the given origin point.
         * Note : the vector "normal" is updated because normalized.
         */
        static FromPositionAndNormal(origin, normal) {
            const result = new Plane(0.0, 0.0, 0.0, 0.0);
            normal.normalize();
            result.normal = normal;
            result.d = -(normal.x * origin.x + normal.y * origin.y + normal.z * origin.z);
            return result;
        }
        /**
         * Calculates the distance from a plane and a point
         * @param origin origin of the plane to be constructed
         * @param normal normal of the plane to be constructed
         * @param point point to calculate distance to
         * @returns the signed distance between the plane defined by the normal vector at the "origin"" point and the given other point.
         */
        static SignedDistanceToPlaneFromPositionAndNormal(origin, normal, point) {
            const d = -(normal.x * origin.x + normal.y * origin.y + normal.z * origin.z);
            return Vector3.Dot(point, normal) + d;
        }
    }
    Plane._TmpMatrix = Matrix.Identity();

    /**
     * Represents a camera frustum
     */
    class Frustum {
        /**
         * Gets the planes representing the frustum
         * @param transform matrix to be applied to the returned planes
         * @returns a new array of 6 Frustum planes computed by the given transformation matrix.
         */
        static GetPlanes(transform) {
            const frustumPlanes = [];
            for (let index = 0; index < 6; index++) {
                frustumPlanes.push(new Plane(0.0, 0.0, 0.0, 0.0));
            }
            Frustum.GetPlanesToRef(transform, frustumPlanes);
            return frustumPlanes;
        }
        /**
         * Gets the near frustum plane transformed by the transform matrix
         * @param transform transformation matrix to be applied to the resulting frustum plane
         * @param frustumPlane the resulting frustum plane
         */
        static GetNearPlaneToRef(transform, frustumPlane) {
            const m = transform.m;
            frustumPlane.normal.x = m[3] + m[2];
            frustumPlane.normal.y = m[7] + m[6];
            frustumPlane.normal.z = m[11] + m[10];
            frustumPlane.d = m[15] + m[14];
            frustumPlane.normalize();
        }
        /**
         * Gets the far frustum plane transformed by the transform matrix
         * @param transform transformation matrix to be applied to the resulting frustum plane
         * @param frustumPlane the resulting frustum plane
         */
        static GetFarPlaneToRef(transform, frustumPlane) {
            const m = transform.m;
            frustumPlane.normal.x = m[3] - m[2];
            frustumPlane.normal.y = m[7] - m[6];
            frustumPlane.normal.z = m[11] - m[10];
            frustumPlane.d = m[15] - m[14];
            frustumPlane.normalize();
        }
        /**
         * Gets the left frustum plane transformed by the transform matrix
         * @param transform transformation matrix to be applied to the resulting frustum plane
         * @param frustumPlane the resulting frustum plane
         */
        static GetLeftPlaneToRef(transform, frustumPlane) {
            const m = transform.m;
            frustumPlane.normal.x = m[3] + m[0];
            frustumPlane.normal.y = m[7] + m[4];
            frustumPlane.normal.z = m[11] + m[8];
            frustumPlane.d = m[15] + m[12];
            frustumPlane.normalize();
        }
        /**
         * Gets the right frustum plane transformed by the transform matrix
         * @param transform transformation matrix to be applied to the resulting frustum plane
         * @param frustumPlane the resulting frustum plane
         */
        static GetRightPlaneToRef(transform, frustumPlane) {
            const m = transform.m;
            frustumPlane.normal.x = m[3] - m[0];
            frustumPlane.normal.y = m[7] - m[4];
            frustumPlane.normal.z = m[11] - m[8];
            frustumPlane.d = m[15] - m[12];
            frustumPlane.normalize();
        }
        /**
         * Gets the top frustum plane transformed by the transform matrix
         * @param transform transformation matrix to be applied to the resulting frustum plane
         * @param frustumPlane the resulting frustum plane
         */
        static GetTopPlaneToRef(transform, frustumPlane) {
            const m = transform.m;
            frustumPlane.normal.x = m[3] - m[1];
            frustumPlane.normal.y = m[7] - m[5];
            frustumPlane.normal.z = m[11] - m[9];
            frustumPlane.d = m[15] - m[13];
            frustumPlane.normalize();
        }
        /**
         * Gets the bottom frustum plane transformed by the transform matrix
         * @param transform transformation matrix to be applied to the resulting frustum plane
         * @param frustumPlane the resulting frustum plane
         */
        static GetBottomPlaneToRef(transform, frustumPlane) {
            const m = transform.m;
            frustumPlane.normal.x = m[3] + m[1];
            frustumPlane.normal.y = m[7] + m[5];
            frustumPlane.normal.z = m[11] + m[9];
            frustumPlane.d = m[15] + m[13];
            frustumPlane.normalize();
        }
        /**
         * Sets the given array "frustumPlanes" with the 6 Frustum planes computed by the given transformation matrix.
         * @param transform transformation matrix to be applied to the resulting frustum planes
         * @param frustumPlanes the resulting frustum planes
         */
        static GetPlanesToRef(transform, frustumPlanes) {
            // Near
            Frustum.GetNearPlaneToRef(transform, frustumPlanes[0]);
            // Far
            Frustum.GetFarPlaneToRef(transform, frustumPlanes[1]);
            // Left
            Frustum.GetLeftPlaneToRef(transform, frustumPlanes[2]);
            // Right
            Frustum.GetRightPlaneToRef(transform, frustumPlanes[3]);
            // Top
            Frustum.GetTopPlaneToRef(transform, frustumPlanes[4]);
            // Bottom
            Frustum.GetBottomPlaneToRef(transform, frustumPlanes[5]);
        }
        /**
         * Tests if a point is located between the frustum planes.
         * @param point defines the point to test
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if the point is located between the frustum planes
         */
        static IsPointInFrustum(point, frustumPlanes) {
            for (let i = 0; i < 6; i++) {
                if (frustumPlanes[i].dotCoordinate(point) < 0) {
                    return false;
                }
            }
            return true;
        }
    }

    /**
     * This is the base class of all the camera used in the application.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
     */
    class Camera extends Node {
        /**
         * Define the current local position of the camera in the scene
         */
        get position() {
            return this._position;
        }
        set position(newPosition) {
            this._position = newPosition;
        }
        /**
         * The vector the camera should consider as up.
         * (default is Vector3(0, 1, 0) aka Vector3.Up())
         */
        set upVector(vec) {
            this._upVector = vec;
        }
        get upVector() {
            return this._upVector;
        }
        /**
         * The screen area in scene units squared
         */
        get screenArea() {
            var _a, _b, _c, _d;
            let x = 0;
            let y = 0;
            if (this.mode === Camera.PERSPECTIVE_CAMERA) {
                if (this.fovMode === Camera.FOVMODE_VERTICAL_FIXED) {
                    y = this.minZ * 2 * Math.tan(this.fov / 2);
                    x = this.getEngine().getAspectRatio(this) * y;
                }
                else {
                    x = this.minZ * 2 * Math.tan(this.fov / 2);
                    y = x / this.getEngine().getAspectRatio(this);
                }
            }
            else {
                const halfWidth = this.getEngine().getRenderWidth() / 2.0;
                const halfHeight = this.getEngine().getRenderHeight() / 2.0;
                x = ((_a = this.orthoRight) !== null && _a !== void 0 ? _a : halfWidth) - ((_b = this.orthoLeft) !== null && _b !== void 0 ? _b : -halfWidth);
                y = ((_c = this.orthoTop) !== null && _c !== void 0 ? _c : halfHeight) - ((_d = this.orthoBottom) !== null && _d !== void 0 ? _d : -halfHeight);
            }
            return x * y;
        }
        set orthoLeft(value) {
            this._orthoLeft = value;
            for (const rigCamera of this._rigCameras) {
                rigCamera.orthoLeft = value;
            }
        }
        get orthoLeft() {
            return this._orthoLeft;
        }
        set orthoRight(value) {
            this._orthoRight = value;
            for (const rigCamera of this._rigCameras) {
                rigCamera.orthoRight = value;
            }
        }
        get orthoRight() {
            return this._orthoRight;
        }
        set orthoBottom(value) {
            this._orthoBottom = value;
            for (const rigCamera of this._rigCameras) {
                rigCamera.orthoBottom = value;
            }
        }
        get orthoBottom() {
            return this._orthoBottom;
        }
        set orthoTop(value) {
            this._orthoTop = value;
            for (const rigCamera of this._rigCameras) {
                rigCamera.orthoTop = value;
            }
        }
        get orthoTop() {
            return this._orthoTop;
        }
        set mode(mode) {
            this._mode = mode;
            // Pass the mode down to the rig cameras
            for (const rigCamera of this._rigCameras) {
                rigCamera.mode = mode;
            }
        }
        get mode() {
            return this._mode;
        }
        /**
         * Instantiates a new camera object.
         * This should not be used directly but through the inherited cameras: ArcRotate, Free...
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
         * @param name Defines the name of the camera in the scene
         * @param position Defines the position of the camera
         * @param scene Defines the scene the camera belongs too
         * @param setActiveOnSceneIfNoneActive Defines if the camera should be set as active after creation if no other camera have been defined in the scene
         */
        constructor(name, position, scene, setActiveOnSceneIfNoneActive = true) {
            super(name, scene);
            /** @internal */
            this._position = Vector3.Zero();
            this._upVector = Vector3.Up();
            /**
             * Define the current limit on the left side for an orthographic camera
             * In scene unit
             */
            this._orthoLeft = null;
            /**
             * Define the current limit on the right side for an orthographic camera
             * In scene unit
             */
            this._orthoRight = null;
            /**
             * Define the current limit on the bottom side for an orthographic camera
             * In scene unit
             */
            this._orthoBottom = null;
            /**
             * Define the current limit on the top side for an orthographic camera
             * In scene unit
             */
            this._orthoTop = null;
            /**
             * Field Of View is set in Radians. (default is 0.8)
             */
            this.fov = 0.8;
            /**
             * Projection plane tilt around the X axis (horizontal), set in Radians. (default is 0)
             * Can be used to make vertical lines in world space actually vertical on the screen.
             * See https://forum.babylonjs.com/t/add-vertical-shift-to-3ds-max-exporter-babylon-cameras/17480
             */
            this.projectionPlaneTilt = 0;
            /**
             * Define the minimum distance the camera can see from.
             * This is important to note that the depth buffer are not infinite and the closer it starts
             * the more your scene might encounter depth fighting issue.
             */
            this.minZ = 1;
            /**
             * Define the maximum distance the camera can see to.
             * This is important to note that the depth buffer are not infinite and the further it end
             * the more your scene might encounter depth fighting issue.
             */
            this.maxZ = 10000.0;
            /**
             * Define the default inertia of the camera.
             * This helps giving a smooth feeling to the camera movement.
             */
            this.inertia = 0.9;
            /**
             * Define the mode of the camera (Camera.PERSPECTIVE_CAMERA or Camera.ORTHOGRAPHIC_CAMERA)
             */
            this._mode = Camera.PERSPECTIVE_CAMERA;
            /**
             * Define whether the camera is intermediate.
             * This is useful to not present the output directly to the screen in case of rig without post process for instance
             */
            this.isIntermediate = false;
            /**
             * Define the viewport of the camera.
             * This correspond to the portion of the screen the camera will render to in normalized 0 to 1 unit.
             */
            this.viewport = new Viewport(0, 0, 1.0, 1.0);
            /**
             * Restricts the camera to viewing objects with the same layerMask.
             * A camera with a layerMask of 1 will render mesh.layerMask & camera.layerMask!== 0
             */
            this.layerMask = 0x0fffffff;
            /**
             * fovMode sets the camera frustum bounds to the viewport bounds. (default is FOVMODE_VERTICAL_FIXED)
             */
            this.fovMode = Camera.FOVMODE_VERTICAL_FIXED;
            /**
             * Rig mode of the camera.
             * This is useful to create the camera with two "eyes" instead of one to create VR or stereoscopic scenes.
             * This is normally controlled byt the camera themselves as internal use.
             */
            this.cameraRigMode = Camera.RIG_MODE_NONE;
            /**
             * Defines the list of custom render target which are rendered to and then used as the input to this camera's render. Eg. display another camera view on a TV in the main scene
             * This is pretty helpful if you wish to make a camera render to a texture you could reuse somewhere
             * else in the scene. (Eg. security camera)
             *
             * To change the final output target of the camera, camera.outputRenderTarget should be used instead (eg. webXR renders to a render target corresponding to an HMD)
             */
            this.customRenderTargets = new Array();
            /**
             * When set, the camera will render to this render target instead of the default canvas
             *
             * If the desire is to use the output of a camera as a texture in the scene consider using camera.customRenderTargets instead
             */
            this.outputRenderTarget = null;
            /**
             * Observable triggered when the camera view matrix has changed.
             */
            this.onViewMatrixChangedObservable = new Observable$1();
            /**
             * Observable triggered when the camera Projection matrix has changed.
             */
            this.onProjectionMatrixChangedObservable = new Observable$1();
            /**
             * Observable triggered when the inputs have been processed.
             */
            this.onAfterCheckInputsObservable = new Observable$1();
            /**
             * Observable triggered when reset has been called and applied to the camera.
             */
            this.onRestoreStateObservable = new Observable$1();
            /**
             * Is this camera a part of a rig system?
             */
            this.isRigCamera = false;
            /** @internal */
            this._rigCameras = new Array();
            this._webvrViewMatrix = Matrix.Identity();
            /** @internal */
            this._skipRendering = false;
            /** @internal */
            this._projectionMatrix = new Matrix();
            /** @internal */
            this._postProcesses = new Array();
            /** @internal */
            this._activeMeshes = new SmartArray(256);
            this._globalPosition = Vector3.Zero();
            /** @internal */
            this._computedViewMatrix = Matrix.Identity();
            this._doNotComputeProjectionMatrix = false;
            this._transformMatrix = Matrix.Zero();
            this._refreshFrustumPlanes = true;
            this._absoluteRotation = Quaternion.Identity();
            /** @internal */
            this._isCamera = true;
            /** @internal */
            this._isLeftCamera = false;
            /** @internal */
            this._isRightCamera = false;
            this.getScene().addCamera(this);
            if (setActiveOnSceneIfNoneActive && !this.getScene().activeCamera) {
                this.getScene().activeCamera = this;
            }
            this.position = position;
            this.renderPassId = this.getScene().getEngine().createRenderPassId(`Camera ${name}`);
        }
        /**
         * Store current camera state (fov, position, etc..)
         * @returns the camera
         */
        storeState() {
            this._stateStored = true;
            this._storedFov = this.fov;
            return this;
        }
        /**
         * Restores the camera state values if it has been stored. You must call storeState() first
         */
        _restoreStateValues() {
            if (!this._stateStored) {
                return false;
            }
            this.fov = this._storedFov;
            return true;
        }
        /**
         * Restored camera state. You must call storeState() first.
         * @returns true if restored and false otherwise
         */
        restoreState() {
            if (this._restoreStateValues()) {
                this.onRestoreStateObservable.notifyObservers(this);
                return true;
            }
            return false;
        }
        /**
         * Gets the class name of the camera.
         * @returns the class name
         */
        getClassName() {
            return "Camera";
        }
        /**
         * Gets a string representation of the camera useful for debug purpose.
         * @param fullDetails Defines that a more verbose level of logging is required
         * @returns the string representation
         */
        toString(fullDetails) {
            let ret = "Name: " + this.name;
            ret += ", type: " + this.getClassName();
            if (this.animations) {
                for (let i = 0; i < this.animations.length; i++) {
                    ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
                }
            }
            return ret;
        }
        /**
         * Automatically tilts the projection plane, using `projectionPlaneTilt`, to correct the perspective effect on vertical lines.
         */
        applyVerticalCorrection() {
            const rot = this.absoluteRotation.toEulerAngles();
            this.projectionPlaneTilt = this._scene.useRightHandedSystem ? -rot.x : rot.x;
        }
        /**
         * Gets the current world space position of the camera.
         */
        get globalPosition() {
            return this._globalPosition;
        }
        /**
         * Gets the list of active meshes this frame (meshes no culled or excluded by lod s in the frame)
         * @returns the active meshe list
         */
        getActiveMeshes() {
            return this._activeMeshes;
        }
        /**
         * Check whether a mesh is part of the current active mesh list of the camera
         * @param mesh Defines the mesh to check
         * @returns true if active, false otherwise
         */
        isActiveMesh(mesh) {
            return this._activeMeshes.indexOf(mesh) !== -1;
        }
        /**
         * Is this camera ready to be used/rendered
         * @param completeCheck defines if a complete check (including post processes) has to be done (false by default)
         * @returns true if the camera is ready
         */
        isReady(completeCheck = false) {
            if (completeCheck) {
                for (const pp of this._postProcesses) {
                    if (pp && !pp.isReady()) {
                        return false;
                    }
                }
            }
            return super.isReady(completeCheck);
        }
        /** @internal */
        _initCache() {
            super._initCache();
            this._cache.position = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cache.upVector = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cache.mode = undefined;
            this._cache.minZ = undefined;
            this._cache.maxZ = undefined;
            this._cache.fov = undefined;
            this._cache.fovMode = undefined;
            this._cache.aspectRatio = undefined;
            this._cache.orthoLeft = undefined;
            this._cache.orthoRight = undefined;
            this._cache.orthoBottom = undefined;
            this._cache.orthoTop = undefined;
            this._cache.renderWidth = undefined;
            this._cache.renderHeight = undefined;
        }
        /**
         * @internal
         */
        _updateCache(ignoreParentClass) {
            if (!ignoreParentClass) {
                super._updateCache();
            }
            this._cache.position.copyFrom(this.position);
            this._cache.upVector.copyFrom(this.upVector);
        }
        /** @internal */
        _isSynchronized() {
            return this._isSynchronizedViewMatrix() && this._isSynchronizedProjectionMatrix();
        }
        /** @internal */
        _isSynchronizedViewMatrix() {
            if (!super._isSynchronized()) {
                return false;
            }
            return this._cache.position.equals(this.position) && this._cache.upVector.equals(this.upVector) && this.isSynchronizedWithParent();
        }
        /** @internal */
        _isSynchronizedProjectionMatrix() {
            let check = this._cache.mode === this.mode && this._cache.minZ === this.minZ && this._cache.maxZ === this.maxZ;
            if (!check) {
                return false;
            }
            const engine = this.getEngine();
            if (this.mode === Camera.PERSPECTIVE_CAMERA) {
                check =
                    this._cache.fov === this.fov &&
                        this._cache.fovMode === this.fovMode &&
                        this._cache.aspectRatio === engine.getAspectRatio(this) &&
                        this._cache.projectionPlaneTilt === this.projectionPlaneTilt;
            }
            else {
                check =
                    this._cache.orthoLeft === this.orthoLeft &&
                        this._cache.orthoRight === this.orthoRight &&
                        this._cache.orthoBottom === this.orthoBottom &&
                        this._cache.orthoTop === this.orthoTop &&
                        this._cache.renderWidth === engine.getRenderWidth() &&
                        this._cache.renderHeight === engine.getRenderHeight();
            }
            return check;
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * This function is here because typescript removes the typing of the last function.
         * @param _ignored defines an ignored parameter kept for backward compatibility.
         * @param _noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(_ignored, _noPreventDefault) { }
        /**
         * Detach the current controls from the specified dom element.
         * This function is here because typescript removes the typing of the last function.
         * @param _ignored defines an ignored parameter kept for backward compatibility.
         */
        detachControl(_ignored) { }
        /**
         * Update the camera state according to the different inputs gathered during the frame.
         */
        update() {
            this._checkInputs();
            if (this.cameraRigMode !== Camera.RIG_MODE_NONE) {
                this._updateRigCameras();
            }
            // Attempt to update the camera's view and projection matrices.
            // This call is being made because these matrices are no longer being updated
            // as a part of the picking ray process (in addition to scene.render).
            this.getViewMatrix();
            this.getProjectionMatrix();
        }
        /** @internal */
        _checkInputs() {
            this.onAfterCheckInputsObservable.notifyObservers(this);
        }
        /** @internal */
        get rigCameras() {
            return this._rigCameras;
        }
        /**
         * Gets the post process used by the rig cameras
         */
        get rigPostProcess() {
            return this._rigPostProcess;
        }
        /**
         * Internal, gets the first post process.
         * @returns the first post process to be run on this camera.
         */
        _getFirstPostProcess() {
            for (let ppIndex = 0; ppIndex < this._postProcesses.length; ppIndex++) {
                if (this._postProcesses[ppIndex] !== null) {
                    return this._postProcesses[ppIndex];
                }
            }
            return null;
        }
        _cascadePostProcessesToRigCams() {
            // invalidate framebuffer
            const firstPostProcess = this._getFirstPostProcess();
            if (firstPostProcess) {
                firstPostProcess.markTextureDirty();
            }
            // glue the rigPostProcess to the end of the user postprocesses & assign to each sub-camera
            for (let i = 0, len = this._rigCameras.length; i < len; i++) {
                const cam = this._rigCameras[i];
                const rigPostProcess = cam._rigPostProcess;
                // for VR rig, there does not have to be a post process
                if (rigPostProcess) {
                    const isPass = rigPostProcess.getEffectName() === "pass";
                    if (isPass) {
                        // any rig which has a PassPostProcess for rig[0], cannot be isIntermediate when there are also user postProcesses
                        cam.isIntermediate = this._postProcesses.length === 0;
                    }
                    cam._postProcesses = this._postProcesses.slice(0).concat(rigPostProcess);
                    rigPostProcess.markTextureDirty();
                }
                else {
                    cam._postProcesses = this._postProcesses.slice(0);
                }
            }
        }
        /**
         * Attach a post process to the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
         * @param postProcess The post process to attach to the camera
         * @param insertAt The position of the post process in case several of them are in use in the scene
         * @returns the position the post process has been inserted at
         */
        attachPostProcess(postProcess, insertAt = null) {
            if (!postProcess.isReusable() && this._postProcesses.indexOf(postProcess) > -1) {
                Logger.Error("You're trying to reuse a post process not defined as reusable.");
                return 0;
            }
            if (insertAt == null || insertAt < 0) {
                this._postProcesses.push(postProcess);
            }
            else if (this._postProcesses[insertAt] === null) {
                this._postProcesses[insertAt] = postProcess;
            }
            else {
                this._postProcesses.splice(insertAt, 0, postProcess);
            }
            this._cascadePostProcessesToRigCams(); // also ensures framebuffer invalidated
            // Update prePass
            if (this._scene.prePassRenderer) {
                this._scene.prePassRenderer.markAsDirty();
            }
            return this._postProcesses.indexOf(postProcess);
        }
        /**
         * Detach a post process to the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
         * @param postProcess The post process to detach from the camera
         */
        detachPostProcess(postProcess) {
            const idx = this._postProcesses.indexOf(postProcess);
            if (idx !== -1) {
                this._postProcesses[idx] = null;
            }
            // Update prePass
            if (this._scene.prePassRenderer) {
                this._scene.prePassRenderer.markAsDirty();
            }
            this._cascadePostProcessesToRigCams(); // also ensures framebuffer invalidated
        }
        /**
         * Gets the current world matrix of the camera
         */
        getWorldMatrix() {
            if (this._isSynchronizedViewMatrix()) {
                return this._worldMatrix;
            }
            // Getting the the view matrix will also compute the world matrix.
            this.getViewMatrix();
            return this._worldMatrix;
        }
        /** @internal */
        _getViewMatrix() {
            return Matrix.Identity();
        }
        /**
         * Gets the current view matrix of the camera.
         * @param force forces the camera to recompute the matrix without looking at the cached state
         * @returns the view matrix
         */
        getViewMatrix(force) {
            if (!force && this._isSynchronizedViewMatrix()) {
                return this._computedViewMatrix;
            }
            this.updateCache();
            this._computedViewMatrix = this._getViewMatrix();
            this._currentRenderId = this.getScene().getRenderId();
            this._childUpdateId++;
            this._refreshFrustumPlanes = true;
            if (this._cameraRigParams && this._cameraRigParams.vrPreViewMatrix) {
                this._computedViewMatrix.multiplyToRef(this._cameraRigParams.vrPreViewMatrix, this._computedViewMatrix);
            }
            // Notify parent camera if rig camera is changed
            if (this.parent && this.parent.onViewMatrixChangedObservable) {
                this.parent.onViewMatrixChangedObservable.notifyObservers(this.parent);
            }
            this.onViewMatrixChangedObservable.notifyObservers(this);
            this._computedViewMatrix.invertToRef(this._worldMatrix);
            return this._computedViewMatrix;
        }
        /**
         * Freeze the projection matrix.
         * It will prevent the cache check of the camera projection compute and can speed up perf
         * if no parameter of the camera are meant to change
         * @param projection Defines manually a projection if necessary
         */
        freezeProjectionMatrix(projection) {
            this._doNotComputeProjectionMatrix = true;
            if (projection !== undefined) {
                this._projectionMatrix = projection;
            }
        }
        /**
         * Unfreeze the projection matrix if it has previously been freezed by freezeProjectionMatrix.
         */
        unfreezeProjectionMatrix() {
            this._doNotComputeProjectionMatrix = false;
        }
        /**
         * Gets the current projection matrix of the camera.
         * @param force forces the camera to recompute the matrix without looking at the cached state
         * @returns the projection matrix
         */
        getProjectionMatrix(force) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (this._doNotComputeProjectionMatrix || (!force && this._isSynchronizedProjectionMatrix())) {
                return this._projectionMatrix;
            }
            // Cache
            this._cache.mode = this.mode;
            this._cache.minZ = this.minZ;
            this._cache.maxZ = this.maxZ;
            // Matrix
            this._refreshFrustumPlanes = true;
            const engine = this.getEngine();
            const scene = this.getScene();
            const reverseDepth = engine.useReverseDepthBuffer;
            if (this.mode === Camera.PERSPECTIVE_CAMERA) {
                this._cache.fov = this.fov;
                this._cache.fovMode = this.fovMode;
                this._cache.aspectRatio = engine.getAspectRatio(this);
                this._cache.projectionPlaneTilt = this.projectionPlaneTilt;
                if (this.minZ <= 0) {
                    this.minZ = 0.1;
                }
                let getProjectionMatrix;
                if (scene.useRightHandedSystem) {
                    getProjectionMatrix = Matrix.PerspectiveFovRHToRef;
                }
                else {
                    getProjectionMatrix = Matrix.PerspectiveFovLHToRef;
                }
                getProjectionMatrix(this.fov, engine.getAspectRatio(this), reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, this.fovMode === Camera.FOVMODE_VERTICAL_FIXED, engine.isNDCHalfZRange, this.projectionPlaneTilt, reverseDepth);
            }
            else {
                const halfWidth = engine.getRenderWidth() / 2.0;
                const halfHeight = engine.getRenderHeight() / 2.0;
                if (scene.useRightHandedSystem) {
                    Matrix.OrthoOffCenterRHToRef((_a = this.orthoLeft) !== null && _a !== void 0 ? _a : -halfWidth, (_b = this.orthoRight) !== null && _b !== void 0 ? _b : halfWidth, (_c = this.orthoBottom) !== null && _c !== void 0 ? _c : -halfHeight, (_d = this.orthoTop) !== null && _d !== void 0 ? _d : halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
                }
                else {
                    Matrix.OrthoOffCenterLHToRef((_e = this.orthoLeft) !== null && _e !== void 0 ? _e : -halfWidth, (_f = this.orthoRight) !== null && _f !== void 0 ? _f : halfWidth, (_g = this.orthoBottom) !== null && _g !== void 0 ? _g : -halfHeight, (_h = this.orthoTop) !== null && _h !== void 0 ? _h : halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
                }
                this._cache.orthoLeft = this.orthoLeft;
                this._cache.orthoRight = this.orthoRight;
                this._cache.orthoBottom = this.orthoBottom;
                this._cache.orthoTop = this.orthoTop;
                this._cache.renderWidth = engine.getRenderWidth();
                this._cache.renderHeight = engine.getRenderHeight();
            }
            this.onProjectionMatrixChangedObservable.notifyObservers(this);
            return this._projectionMatrix;
        }
        /**
         * Gets the transformation matrix (ie. the multiplication of view by projection matrices)
         * @returns a Matrix
         */
        getTransformationMatrix() {
            this._computedViewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
            return this._transformMatrix;
        }
        _updateFrustumPlanes() {
            if (!this._refreshFrustumPlanes) {
                return;
            }
            this.getTransformationMatrix();
            if (!this._frustumPlanes) {
                this._frustumPlanes = Frustum.GetPlanes(this._transformMatrix);
            }
            else {
                Frustum.GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
            }
            this._refreshFrustumPlanes = false;
        }
        /**
         * Checks if a cullable object (mesh...) is in the camera frustum
         * This checks the bounding box center. See isCompletelyInFrustum for a full bounding check
         * @param target The object to check
         * @param checkRigCameras If the rig cameras should be checked (eg. with webVR camera both eyes should be checked) (Default: false)
         * @returns true if the object is in frustum otherwise false
         */
        isInFrustum(target, checkRigCameras = false) {
            this._updateFrustumPlanes();
            if (checkRigCameras && this.rigCameras.length > 0) {
                let result = false;
                this.rigCameras.forEach((cam) => {
                    cam._updateFrustumPlanes();
                    result = result || target.isInFrustum(cam._frustumPlanes);
                });
                return result;
            }
            else {
                return target.isInFrustum(this._frustumPlanes);
            }
        }
        /**
         * Checks if a cullable object (mesh...) is in the camera frustum
         * Unlike isInFrustum this checks the full bounding box
         * @param target The object to check
         * @returns true if the object is in frustum otherwise false
         */
        isCompletelyInFrustum(target) {
            this._updateFrustumPlanes();
            return target.isCompletelyInFrustum(this._frustumPlanes);
        }
        /**
         * Gets a ray in the forward direction from the camera.
         * @param length Defines the length of the ray to create
         * @param transform Defines the transform to apply to the ray, by default the world matrix is used to create a workd space ray
         * @param origin Defines the start point of the ray which defaults to the camera position
         * @returns the forward ray
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getForwardRay(length = 100, transform, origin) {
            throw _WarnImport("Ray");
        }
        /**
         * Gets a ray in the forward direction from the camera.
         * @param refRay the ray to (re)use when setting the values
         * @param length Defines the length of the ray to create
         * @param transform Defines the transform to apply to the ray, by default the world matrx is used to create a workd space ray
         * @param origin Defines the start point of the ray which defaults to the camera position
         * @returns the forward ray
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getForwardRayToRef(refRay, length = 100, transform, origin) {
            throw _WarnImport("Ray");
        }
        /**
         * Releases resources associated with this node.
         * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
         * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            // Observables
            this.onViewMatrixChangedObservable.clear();
            this.onProjectionMatrixChangedObservable.clear();
            this.onAfterCheckInputsObservable.clear();
            this.onRestoreStateObservable.clear();
            // Inputs
            if (this.inputs) {
                this.inputs.clear();
            }
            // Animations
            this.getScene().stopAnimation(this);
            // Remove from scene
            this.getScene().removeCamera(this);
            while (this._rigCameras.length > 0) {
                const camera = this._rigCameras.pop();
                if (camera) {
                    camera.dispose();
                }
            }
            if (this._parentContainer) {
                const index = this._parentContainer.cameras.indexOf(this);
                if (index > -1) {
                    this._parentContainer.cameras.splice(index, 1);
                }
                this._parentContainer = null;
            }
            // Postprocesses
            if (this._rigPostProcess) {
                this._rigPostProcess.dispose(this);
                this._rigPostProcess = null;
                this._postProcesses.length = 0;
            }
            else if (this.cameraRigMode !== Camera.RIG_MODE_NONE) {
                this._rigPostProcess = null;
                this._postProcesses.length = 0;
            }
            else {
                let i = this._postProcesses.length;
                while (--i >= 0) {
                    const postProcess = this._postProcesses[i];
                    if (postProcess) {
                        postProcess.dispose(this);
                    }
                }
            }
            // Render targets
            let i = this.customRenderTargets.length;
            while (--i >= 0) {
                this.customRenderTargets[i].dispose();
            }
            this.customRenderTargets.length = 0;
            // Active Meshes
            this._activeMeshes.dispose();
            this.getScene().getEngine().releaseRenderPassId(this.renderPassId);
            super.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        /**
         * Gets the left camera of a rig setup in case of Rigged Camera
         */
        get isLeftCamera() {
            return this._isLeftCamera;
        }
        /**
         * Gets the right camera of a rig setup in case of Rigged Camera
         */
        get isRightCamera() {
            return this._isRightCamera;
        }
        /**
         * Gets the left camera of a rig setup in case of Rigged Camera
         */
        get leftCamera() {
            if (this._rigCameras.length < 1) {
                return null;
            }
            return this._rigCameras[0];
        }
        /**
         * Gets the right camera of a rig setup in case of Rigged Camera
         */
        get rightCamera() {
            if (this._rigCameras.length < 2) {
                return null;
            }
            return this._rigCameras[1];
        }
        /**
         * Gets the left camera target of a rig setup in case of Rigged Camera
         * @returns the target position
         */
        getLeftTarget() {
            if (this._rigCameras.length < 1) {
                return null;
            }
            return this._rigCameras[0].getTarget();
        }
        /**
         * Gets the right camera target of a rig setup in case of Rigged Camera
         * @returns the target position
         */
        getRightTarget() {
            if (this._rigCameras.length < 2) {
                return null;
            }
            return this._rigCameras[1].getTarget();
        }
        /**
         * @internal
         */
        setCameraRigMode(mode, rigParams) {
            if (this.cameraRigMode === mode) {
                return;
            }
            while (this._rigCameras.length > 0) {
                const camera = this._rigCameras.pop();
                if (camera) {
                    camera.dispose();
                }
            }
            this.cameraRigMode = mode;
            this._cameraRigParams = {};
            //we have to implement stereo camera calcultating left and right viewpoints from interaxialDistance and target,
            //not from a given angle as it is now, but until that complete code rewriting provisional stereoHalfAngle value is introduced
            this._cameraRigParams.interaxialDistance = rigParams.interaxialDistance || 0.0637;
            this._cameraRigParams.stereoHalfAngle = Tools.ToRadians(this._cameraRigParams.interaxialDistance / 0.0637);
            // create the rig cameras, unless none
            if (this.cameraRigMode !== Camera.RIG_MODE_NONE) {
                const leftCamera = this.createRigCamera(this.name + "_L", 0);
                if (leftCamera) {
                    leftCamera._isLeftCamera = true;
                }
                const rightCamera = this.createRigCamera(this.name + "_R", 1);
                if (rightCamera) {
                    rightCamera._isRightCamera = true;
                }
                if (leftCamera && rightCamera) {
                    this._rigCameras.push(leftCamera);
                    this._rigCameras.push(rightCamera);
                }
            }
            this._setRigMode(rigParams);
            this._cascadePostProcessesToRigCams();
            this.update();
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _setRigMode(rigParams) {
            // no-op
        }
        /** @internal */
        _getVRProjectionMatrix() {
            Matrix.PerspectiveFovLHToRef(this._cameraRigParams.vrMetrics.aspectRatioFov, this._cameraRigParams.vrMetrics.aspectRatio, this.minZ, this.maxZ, this._cameraRigParams.vrWorkMatrix, true, this.getEngine().isNDCHalfZRange);
            this._cameraRigParams.vrWorkMatrix.multiplyToRef(this._cameraRigParams.vrHMatrix, this._projectionMatrix);
            return this._projectionMatrix;
        }
        _updateCameraRotationMatrix() {
            //Here for WebVR
        }
        _updateWebVRCameraRotationMatrix() {
            //Here for WebVR
        }
        /**
         * This function MUST be overwritten by the different WebVR cameras available.
         * The context in which it is running is the RIG camera. So 'this' is the TargetCamera, left or right.
         * @internal
         */
        _getWebVRProjectionMatrix() {
            return Matrix.Identity();
        }
        /**
         * This function MUST be overwritten by the different WebVR cameras available.
         * The context in which it is running is the RIG camera. So 'this' is the TargetCamera, left or right.
         * @internal
         */
        _getWebVRViewMatrix() {
            return Matrix.Identity();
        }
        /**
         * @internal
         */
        setCameraRigParameter(name, value) {
            if (!this._cameraRigParams) {
                this._cameraRigParams = {};
            }
            this._cameraRigParams[name] = value;
            //provisionnally:
            if (name === "interaxialDistance") {
                this._cameraRigParams.stereoHalfAngle = Tools.ToRadians(value / 0.0637);
            }
        }
        /**
         * needs to be overridden by children so sub has required properties to be copied
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createRigCamera(name, cameraIndex) {
            return null;
        }
        /**
         * May need to be overridden by children
         * @internal
         */
        _updateRigCameras() {
            for (let i = 0; i < this._rigCameras.length; i++) {
                this._rigCameras[i].minZ = this.minZ;
                this._rigCameras[i].maxZ = this.maxZ;
                this._rigCameras[i].fov = this.fov;
                this._rigCameras[i].upVector.copyFrom(this.upVector);
            }
            // only update viewport when ANAGLYPH
            if (this.cameraRigMode === Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH) {
                this._rigCameras[0].viewport = this._rigCameras[1].viewport = this.viewport;
            }
        }
        /** @internal */
        _setupInputs() { }
        /**
         * Serialiaze the camera setup to a json representation
         * @returns the JSON representation
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this);
            serializationObject.uniqueId = this.uniqueId;
            // Type
            serializationObject.type = this.getClassName();
            // Parent
            if (this.parent) {
                this.parent._serializeAsParent(serializationObject);
            }
            if (this.inputs) {
                this.inputs.serialize(serializationObject);
            }
            // Animations
            SerializationHelper.AppendSerializedAnimations(this, serializationObject);
            serializationObject.ranges = this.serializeAnimationRanges();
            serializationObject.isEnabled = this.isEnabled();
            return serializationObject;
        }
        /**
         * Clones the current camera.
         * @param name The cloned camera name
         * @param newParent The cloned camera's new parent (none by default)
         * @returns the cloned camera
         */
        clone(name, newParent = null) {
            const camera = SerializationHelper.Clone(Camera.GetConstructorFromName(this.getClassName(), name, this.getScene(), this.interaxialDistance, this.isStereoscopicSideBySide), this);
            camera.name = name;
            camera.parent = newParent;
            this.onClonedObservable.notifyObservers(camera);
            return camera;
        }
        /**
         * Gets the direction of the camera relative to a given local axis.
         * @param localAxis Defines the reference axis to provide a relative direction.
         * @returns the direction
         */
        getDirection(localAxis) {
            const result = Vector3.Zero();
            this.getDirectionToRef(localAxis, result);
            return result;
        }
        /**
         * Returns the current camera absolute rotation
         */
        get absoluteRotation() {
            this.getWorldMatrix().decompose(undefined, this._absoluteRotation);
            return this._absoluteRotation;
        }
        /**
         * Gets the direction of the camera relative to a given local axis into a passed vector.
         * @param localAxis Defines the reference axis to provide a relative direction.
         * @param result Defines the vector to store the result in
         */
        getDirectionToRef(localAxis, result) {
            Vector3.TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
        }
        /**
         * Gets a camera constructor for a given camera type
         * @param type The type of the camera to construct (should be equal to one of the camera class name)
         * @param name The name of the camera the result will be able to instantiate
         * @param scene The scene the result will construct the camera in
         * @param interaxial_distance In case of stereoscopic setup, the distance between both eyes
         * @param isStereoscopicSideBySide In case of stereoscopic setup, should the sereo be side b side
         * @returns a factory method to construct the camera
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static GetConstructorFromName(type, name, scene, interaxial_distance = 0, isStereoscopicSideBySide = true) {
            const constructorFunc = Node.Construct(type, name, scene, {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                interaxial_distance: interaxial_distance,
                isStereoscopicSideBySide: isStereoscopicSideBySide,
            });
            if (constructorFunc) {
                return constructorFunc;
            }
            // Default to universal camera
            return () => Camera._CreateDefaultParsedCamera(name, scene);
        }
        /**
         * Compute the world  matrix of the camera.
         * @returns the camera world matrix
         */
        computeWorldMatrix() {
            return this.getWorldMatrix();
        }
        /**
         * Parse a JSON and creates the camera from the parsed information
         * @param parsedCamera The JSON to parse
         * @param scene The scene to instantiate the camera in
         * @returns the newly constructed camera
         */
        static Parse(parsedCamera, scene) {
            const type = parsedCamera.type;
            const construct = Camera.GetConstructorFromName(type, parsedCamera.name, scene, parsedCamera.interaxial_distance, parsedCamera.isStereoscopicSideBySide);
            const camera = SerializationHelper.Parse(construct, parsedCamera, scene);
            // Parent
            if (parsedCamera.parentId !== undefined) {
                camera._waitingParentId = parsedCamera.parentId;
            }
            // Parent instance index
            if (parsedCamera.parentInstanceIndex !== undefined) {
                camera._waitingParentInstanceIndex = parsedCamera.parentInstanceIndex;
            }
            //If camera has an input manager, let it parse inputs settings
            if (camera.inputs) {
                camera.inputs.parse(parsedCamera);
                camera._setupInputs();
            }
            if (parsedCamera.upVector) {
                camera.upVector = Vector3.FromArray(parsedCamera.upVector); // need to force the upVector
            }
            if (camera.setPosition) {
                // need to force position
                camera.position.copyFromFloats(0, 0, 0);
                camera.setPosition(Vector3.FromArray(parsedCamera.position));
            }
            // Target
            if (parsedCamera.target) {
                if (camera.setTarget) {
                    camera.setTarget(Vector3.FromArray(parsedCamera.target));
                }
            }
            // Apply 3d rig, when found
            if (parsedCamera.cameraRigMode) {
                const rigParams = parsedCamera.interaxial_distance ? { interaxialDistance: parsedCamera.interaxial_distance } : {};
                camera.setCameraRigMode(parsedCamera.cameraRigMode, rigParams);
            }
            // Animations
            if (parsedCamera.animations) {
                for (let animationIndex = 0; animationIndex < parsedCamera.animations.length; animationIndex++) {
                    const parsedAnimation = parsedCamera.animations[animationIndex];
                    const internalClass = GetClass("BABYLON.Animation");
                    if (internalClass) {
                        camera.animations.push(internalClass.Parse(parsedAnimation));
                    }
                }
                Node.ParseAnimationRanges(camera, parsedCamera, scene);
            }
            if (parsedCamera.autoAnimate) {
                scene.beginAnimation(camera, parsedCamera.autoAnimateFrom, parsedCamera.autoAnimateTo, parsedCamera.autoAnimateLoop, parsedCamera.autoAnimateSpeed || 1.0);
            }
            // Check if isEnabled is defined to be back compatible with prior serialized versions.
            if (parsedCamera.isEnabled !== undefined) {
                camera.setEnabled(parsedCamera.isEnabled);
            }
            return camera;
        }
    }
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Camera._CreateDefaultParsedCamera = (name, scene) => {
        throw _WarnImport("UniversalCamera");
    };
    /**
     * This is the default projection mode used by the cameras.
     * It helps recreating a feeling of perspective and better appreciate depth.
     * This is the best way to simulate real life cameras.
     */
    Camera.PERSPECTIVE_CAMERA = 0;
    /**
     * This helps creating camera with an orthographic mode.
     * Orthographic is commonly used in engineering as a means to produce object specifications that communicate dimensions unambiguously, each line of 1 unit length (cm, meter..whatever) will appear to have the same length everywhere on the drawing. This allows the drafter to dimension only a subset of lines and let the reader know that other lines of that length on the drawing are also that length in reality. Every parallel line in the drawing is also parallel in the object.
     */
    Camera.ORTHOGRAPHIC_CAMERA = 1;
    /**
     * This is the default FOV mode for perspective cameras.
     * This setting aligns the upper and lower bounds of the viewport to the upper and lower bounds of the camera frustum.
     */
    Camera.FOVMODE_VERTICAL_FIXED = 0;
    /**
     * This setting aligns the left and right bounds of the viewport to the left and right bounds of the camera frustum.
     */
    Camera.FOVMODE_HORIZONTAL_FIXED = 1;
    /**
     * This specifies there is no need for a camera rig.
     * Basically only one eye is rendered corresponding to the camera.
     */
    Camera.RIG_MODE_NONE = 0;
    /**
     * Simulates a camera Rig with one blue eye and one red eye.
     * This can be use with 3d blue and red glasses.
     */
    Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
    /**
     * Defines that both eyes of the camera will be rendered side by side with a parallel target.
     */
    Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
    /**
     * Defines that both eyes of the camera will be rendered side by side with a none parallel target.
     */
    Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
    /**
     * Defines that both eyes of the camera will be rendered over under each other.
     */
    Camera.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
    /**
     * Defines that both eyes of the camera will be rendered on successive lines interlaced for passive 3d monitors.
     */
    Camera.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
    /**
     * Defines that both eyes of the camera should be renderered in a VR mode (carbox).
     */
    Camera.RIG_MODE_VR = 20;
    /**
     * Defines that both eyes of the camera should be renderered in a VR mode (webVR).
     */
    Camera.RIG_MODE_WEBVR = 21;
    /**
     * Custom rig mode allowing rig cameras to be populated manually with any number of cameras
     */
    Camera.RIG_MODE_CUSTOM = 22;
    /**
     * Defines if by default attaching controls should prevent the default javascript event to continue.
     */
    Camera.ForceAttachControlToAlwaysPreventDefault = false;
    __decorate$1([
        serializeAsVector3("position")
    ], Camera.prototype, "_position", void 0);
    __decorate$1([
        serializeAsVector3("upVector")
    ], Camera.prototype, "_upVector", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "orthoLeft", null);
    __decorate$1([
        serialize()
    ], Camera.prototype, "orthoRight", null);
    __decorate$1([
        serialize()
    ], Camera.prototype, "orthoBottom", null);
    __decorate$1([
        serialize()
    ], Camera.prototype, "orthoTop", null);
    __decorate$1([
        serialize()
    ], Camera.prototype, "fov", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "projectionPlaneTilt", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "minZ", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "maxZ", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "inertia", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "mode", null);
    __decorate$1([
        serialize()
    ], Camera.prototype, "layerMask", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "fovMode", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "cameraRigMode", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "interaxialDistance", void 0);
    __decorate$1([
        serialize()
    ], Camera.prototype, "isStereoscopicSideBySide", void 0);

    /**
     * This class implement a typical dictionary using a string as key and the generic type T as value.
     * The underlying implementation relies on an associative array to ensure the best performances.
     * The value can be anything including 'null' but except 'undefined'
     */
    class StringDictionary {
        constructor() {
            this._count = 0;
            this._data = {};
        }
        /**
         * This will clear this dictionary and copy the content from the 'source' one.
         * If the T value is a custom object, it won't be copied/cloned, the same object will be used
         * @param source the dictionary to take the content from and copy to this dictionary
         */
        copyFrom(source) {
            this.clear();
            source.forEach((t, v) => this.add(t, v));
        }
        /**
         * Get a value based from its key
         * @param key the given key to get the matching value from
         * @returns the value if found, otherwise undefined is returned
         */
        get(key) {
            const val = this._data[key];
            if (val !== undefined) {
                return val;
            }
            return undefined;
        }
        /**
         * Get a value from its key or add it if it doesn't exist.
         * This method will ensure you that a given key/data will be present in the dictionary.
         * @param key the given key to get the matching value from
         * @param factory the factory that will create the value if the key is not present in the dictionary.
         * The factory will only be invoked if there's no data for the given key.
         * @returns the value corresponding to the key.
         */
        getOrAddWithFactory(key, factory) {
            let val = this.get(key);
            if (val !== undefined) {
                return val;
            }
            val = factory(key);
            if (val) {
                this.add(key, val);
            }
            return val;
        }
        /**
         * Get a value from its key if present in the dictionary otherwise add it
         * @param key the key to get the value from
         * @param val if there's no such key/value pair in the dictionary add it with this value
         * @returns the value corresponding to the key
         */
        getOrAdd(key, val) {
            const curVal = this.get(key);
            if (curVal !== undefined) {
                return curVal;
            }
            this.add(key, val);
            return val;
        }
        /**
         * Check if there's a given key in the dictionary
         * @param key the key to check for
         * @returns true if the key is present, false otherwise
         */
        contains(key) {
            return this._data[key] !== undefined;
        }
        /**
         * Add a new key and its corresponding value
         * @param key the key to add
         * @param value the value corresponding to the key
         * @returns true if the operation completed successfully, false if we couldn't insert the key/value because there was already this key in the dictionary
         */
        add(key, value) {
            if (this._data[key] !== undefined) {
                return false;
            }
            this._data[key] = value;
            ++this._count;
            return true;
        }
        /**
         * Update a specific value associated to a key
         * @param key defines the key to use
         * @param value defines the value to store
         * @returns true if the value was updated (or false if the key was not found)
         */
        set(key, value) {
            if (this._data[key] === undefined) {
                return false;
            }
            this._data[key] = value;
            return true;
        }
        /**
         * Get the element of the given key and remove it from the dictionary
         * @param key defines the key to search
         * @returns the value associated with the key or null if not found
         */
        getAndRemove(key) {
            const val = this.get(key);
            if (val !== undefined) {
                delete this._data[key];
                --this._count;
                return val;
            }
            return null;
        }
        /**
         * Remove a key/value from the dictionary.
         * @param key the key to remove
         * @returns true if the item was successfully deleted, false if no item with such key exist in the dictionary
         */
        remove(key) {
            if (this.contains(key)) {
                delete this._data[key];
                --this._count;
                return true;
            }
            return false;
        }
        /**
         * Clear the whole content of the dictionary
         */
        clear() {
            this._data = {};
            this._count = 0;
        }
        /**
         * Gets the current count
         */
        get count() {
            return this._count;
        }
        /**
         * Execute a callback on each key/val of the dictionary.
         * Note that you can remove any element in this dictionary in the callback implementation
         * @param callback the callback to execute on a given key/value pair
         */
        forEach(callback) {
            for (const cur in this._data) {
                const val = this._data[cur];
                callback(cur, val);
            }
        }
        /**
         * Execute a callback on every occurrence of the dictionary until it returns a valid TRes object.
         * If the callback returns null or undefined the method will iterate to the next key/value pair
         * Note that you can remove any element in this dictionary in the callback implementation
         * @param callback the callback to execute, if it return a valid T instanced object the enumeration will stop and the object will be returned
         * @returns the first item
         */
        first(callback) {
            for (const cur in this._data) {
                const val = this._data[cur];
                const res = callback(cur, val);
                if (res) {
                    return res;
                }
            }
            return null;
        }
    }

    /**
     * Base class of the scene acting as a container for the different elements composing a scene.
     * This class is dynamically extended by the different components of the scene increasing
     * flexibility and reducing coupling
     */
    class AbstractScene {
        constructor() {
            /**
             * Gets the list of root nodes (ie. nodes with no parent)
             */
            this.rootNodes = new Array();
            /** All of the cameras added to this scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
             */
            this.cameras = new Array();
            /**
             * All of the lights added to this scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
             */
            this.lights = new Array();
            /**
             * All of the (abstract) meshes added to this scene
             */
            this.meshes = new Array();
            /**
             * The list of skeletons added to the scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
             */
            this.skeletons = new Array();
            /**
             * All of the particle systems added to this scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro
             */
            this.particleSystems = new Array();
            /**
             * Gets a list of Animations associated with the scene
             */
            this.animations = [];
            /**
             * All of the animation groups added to this scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/groupAnimations
             */
            this.animationGroups = new Array();
            /**
             * All of the multi-materials added to this scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
             */
            this.multiMaterials = new Array();
            /**
             * All of the materials added to this scene
             * In the context of a Scene, it is not supposed to be modified manually.
             * Any addition or removal should be done using the addMaterial and removeMaterial Scene methods.
             * Note also that the order of the Material within the array is not significant and might change.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
             */
            this.materials = new Array();
            /**
             * The list of morph target managers added to the scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph
             */
            this.morphTargetManagers = new Array();
            /**
             * The list of geometries used in the scene.
             */
            this.geometries = new Array();
            /**
             * All of the transform nodes added to this scene
             * In the context of a Scene, it is not supposed to be modified manually.
             * Any addition or removal should be done using the addTransformNode and removeTransformNode Scene methods.
             * Note also that the order of the TransformNode within the array is not significant and might change.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/transform_node
             */
            this.transformNodes = new Array();
            /**
             * ActionManagers available on the scene.
             * @deprecated
             */
            this.actionManagers = new Array();
            /**
             * Textures to keep.
             */
            this.textures = new Array();
            /** @internal */
            this._environmentTexture = null;
            /**
             * The list of postprocesses added to the scene
             */
            this.postProcesses = new Array();
        }
        /**
         * Adds a parser in the list of available ones
         * @param name Defines the name of the parser
         * @param parser Defines the parser to add
         */
        static AddParser(name, parser) {
            this._BabylonFileParsers[name] = parser;
        }
        /**
         * Gets a general parser from the list of available ones
         * @param name Defines the name of the parser
         * @returns the requested parser or null
         */
        static GetParser(name) {
            if (this._BabylonFileParsers[name]) {
                return this._BabylonFileParsers[name];
            }
            return null;
        }
        /**
         * Adds n individual parser in the list of available ones
         * @param name Defines the name of the parser
         * @param parser Defines the parser to add
         */
        static AddIndividualParser(name, parser) {
            this._IndividualBabylonFileParsers[name] = parser;
        }
        /**
         * Gets an individual parser from the list of available ones
         * @param name Defines the name of the parser
         * @returns the requested parser or null
         */
        static GetIndividualParser(name) {
            if (this._IndividualBabylonFileParsers[name]) {
                return this._IndividualBabylonFileParsers[name];
            }
            return null;
        }
        /**
         * Parser json data and populate both a scene and its associated container object
         * @param jsonData Defines the data to parse
         * @param scene Defines the scene to parse the data for
         * @param container Defines the container attached to the parsing sequence
         * @param rootUrl Defines the root url of the data
         */
        static Parse(jsonData, scene, container, rootUrl) {
            for (const parserName in this._BabylonFileParsers) {
                if (Object.prototype.hasOwnProperty.call(this._BabylonFileParsers, parserName)) {
                    this._BabylonFileParsers[parserName](jsonData, scene, container, rootUrl);
                }
            }
        }
        /**
         * Texture used in all pbr material as the reflection texture.
         * As in the majority of the scene they are the same (exception for multi room and so on),
         * this is easier to reference from here than from all the materials.
         */
        get environmentTexture() {
            return this._environmentTexture;
        }
        set environmentTexture(value) {
            this._environmentTexture = value;
        }
        /**
         * @returns all meshes, lights, cameras, transformNodes and bones
         */
        getNodes() {
            let nodes = new Array();
            nodes = nodes.concat(this.meshes);
            nodes = nodes.concat(this.lights);
            nodes = nodes.concat(this.cameras);
            nodes = nodes.concat(this.transformNodes); // dummies
            this.skeletons.forEach((skeleton) => (nodes = nodes.concat(skeleton.bones)));
            return nodes;
        }
    }
    /**
     * Stores the list of available parsers in the application.
     */
    AbstractScene._BabylonFileParsers = {};
    /**
     * Stores the list of available individual parsers in the application.
     */
    AbstractScene._IndividualBabylonFileParsers = {};

    /**
     * Manages the defines for the Material
     */
    class MaterialDefines {
        /**
         * Creates a new instance
         * @param externalProperties list of external properties to inject into the object
         */
        constructor(externalProperties) {
            /** @internal */
            this._keys = [];
            this._isDirty = true;
            /** @internal */
            this._areLightsDirty = true;
            /** @internal */
            this._areLightsDisposed = false;
            /** @internal */
            this._areAttributesDirty = true;
            /** @internal */
            this._areTexturesDirty = true;
            /** @internal */
            this._areFresnelDirty = true;
            /** @internal */
            this._areMiscDirty = true;
            /** @internal */
            this._arePrePassDirty = true;
            /** @internal */
            this._areImageProcessingDirty = true;
            /** @internal */
            this._normals = false;
            /** @internal */
            this._uvs = false;
            /** @internal */
            this._needNormals = false;
            /** @internal */
            this._needUVs = false;
            this._externalProperties = externalProperties;
            // Initialize External Properties
            if (externalProperties) {
                for (const prop in externalProperties) {
                    if (Object.prototype.hasOwnProperty.call(externalProperties, prop)) {
                        this._setDefaultValue(prop);
                    }
                }
            }
        }
        /**
         * Specifies if the material needs to be re-calculated
         */
        get isDirty() {
            return this._isDirty;
        }
        /**
         * Marks the material to indicate that it has been re-calculated
         */
        markAsProcessed() {
            this._isDirty = false;
            this._areAttributesDirty = false;
            this._areTexturesDirty = false;
            this._areFresnelDirty = false;
            this._areLightsDirty = false;
            this._areLightsDisposed = false;
            this._areMiscDirty = false;
            this._arePrePassDirty = false;
            this._areImageProcessingDirty = false;
        }
        /**
         * Marks the material to indicate that it needs to be re-calculated
         */
        markAsUnprocessed() {
            this._isDirty = true;
        }
        /**
         * Marks the material to indicate all of its defines need to be re-calculated
         */
        markAllAsDirty() {
            this._areTexturesDirty = true;
            this._areAttributesDirty = true;
            this._areLightsDirty = true;
            this._areFresnelDirty = true;
            this._areMiscDirty = true;
            this._arePrePassDirty = false;
            this._areImageProcessingDirty = true;
            this._isDirty = true;
        }
        /**
         * Marks the material to indicate that image processing needs to be re-calculated
         */
        markAsImageProcessingDirty() {
            this._areImageProcessingDirty = true;
            this._isDirty = true;
        }
        /**
         * Marks the material to indicate the lights need to be re-calculated
         * @param disposed Defines whether the light is dirty due to dispose or not
         */
        markAsLightDirty(disposed = false) {
            this._areLightsDirty = true;
            this._areLightsDisposed = this._areLightsDisposed || disposed;
            this._isDirty = true;
        }
        /**
         * Marks the attribute state as changed
         */
        markAsAttributesDirty() {
            this._areAttributesDirty = true;
            this._isDirty = true;
        }
        /**
         * Marks the texture state as changed
         */
        markAsTexturesDirty() {
            this._areTexturesDirty = true;
            this._isDirty = true;
        }
        /**
         * Marks the fresnel state as changed
         */
        markAsFresnelDirty() {
            this._areFresnelDirty = true;
            this._isDirty = true;
        }
        /**
         * Marks the misc state as changed
         */
        markAsMiscDirty() {
            this._areMiscDirty = true;
            this._isDirty = true;
        }
        /**
         * Marks the prepass state as changed
         */
        markAsPrePassDirty() {
            this._arePrePassDirty = true;
            this._isDirty = true;
        }
        /**
         * Rebuilds the material defines
         */
        rebuild() {
            this._keys.length = 0;
            for (const key of Object.keys(this)) {
                if (key[0] === "_") {
                    continue;
                }
                this._keys.push(key);
            }
            if (this._externalProperties) {
                for (const name in this._externalProperties) {
                    if (this._keys.indexOf(name) === -1) {
                        this._keys.push(name);
                    }
                }
            }
        }
        /**
         * Specifies if two material defines are equal
         * @param other - A material define instance to compare to
         * @returns - Boolean indicating if the material defines are equal (true) or not (false)
         */
        isEqual(other) {
            if (this._keys.length !== other._keys.length) {
                return false;
            }
            for (let index = 0; index < this._keys.length; index++) {
                const prop = this._keys[index];
                if (this[prop] !== other[prop]) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Clones this instance's defines to another instance
         * @param other - material defines to clone values to
         */
        cloneTo(other) {
            if (this._keys.length !== other._keys.length) {
                other._keys = this._keys.slice(0);
            }
            for (let index = 0; index < this._keys.length; index++) {
                const prop = this._keys[index];
                other[prop] = this[prop];
            }
        }
        /**
         * Resets the material define values
         */
        reset() {
            this._keys.forEach((prop) => this._setDefaultValue(prop));
        }
        _setDefaultValue(prop) {
            var _a, _b, _c, _d, _e;
            const type = (_c = (_b = (_a = this._externalProperties) === null || _a === void 0 ? void 0 : _a[prop]) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : typeof this[prop];
            const defValue = (_e = (_d = this._externalProperties) === null || _d === void 0 ? void 0 : _d[prop]) === null || _e === void 0 ? void 0 : _e.default;
            switch (type) {
                case "number":
                    this[prop] = defValue !== null && defValue !== void 0 ? defValue : 0;
                    break;
                case "string":
                    this[prop] = defValue !== null && defValue !== void 0 ? defValue : "";
                    break;
                default:
                    this[prop] = defValue !== null && defValue !== void 0 ? defValue : false;
                    break;
            }
        }
        /**
         * Converts the material define values to a string
         * @returns - String of material define information
         */
        toString() {
            let result = "";
            for (let index = 0; index < this._keys.length; index++) {
                const prop = this._keys[index];
                const value = this[prop];
                const type = typeof value;
                switch (type) {
                    case "number":
                    case "string":
                        result += "#define " + prop + " " + value + "\n";
                        break;
                    default:
                        if (value) {
                            result += "#define " + prop + "\n";
                        }
                        break;
                }
            }
            return result;
        }
    }

    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */
    class ColorCurves {
        constructor() {
            this._dirty = true;
            this._tempColor = new Color4(0, 0, 0, 0);
            this._globalCurve = new Color4(0, 0, 0, 0);
            this._highlightsCurve = new Color4(0, 0, 0, 0);
            this._midtonesCurve = new Color4(0, 0, 0, 0);
            this._shadowsCurve = new Color4(0, 0, 0, 0);
            this._positiveCurve = new Color4(0, 0, 0, 0);
            this._negativeCurve = new Color4(0, 0, 0, 0);
            this._globalHue = 30;
            this._globalDensity = 0;
            this._globalSaturation = 0;
            this._globalExposure = 0;
            this._highlightsHue = 30;
            this._highlightsDensity = 0;
            this._highlightsSaturation = 0;
            this._highlightsExposure = 0;
            this._midtonesHue = 30;
            this._midtonesDensity = 0;
            this._midtonesSaturation = 0;
            this._midtonesExposure = 0;
            this._shadowsHue = 30;
            this._shadowsDensity = 0;
            this._shadowsSaturation = 0;
            this._shadowsExposure = 0;
        }
        /**
         * Gets the global Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        get globalHue() {
            return this._globalHue;
        }
        /**
         * Sets the global Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        set globalHue(value) {
            this._globalHue = value;
            this._dirty = true;
        }
        /**
         * Gets the global Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        get globalDensity() {
            return this._globalDensity;
        }
        /**
         * Sets the global Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        set globalDensity(value) {
            this._globalDensity = value;
            this._dirty = true;
        }
        /**
         * Gets the global Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        get globalSaturation() {
            return this._globalSaturation;
        }
        /**
         * Sets the global Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        set globalSaturation(value) {
            this._globalSaturation = value;
            this._dirty = true;
        }
        /**
         * Gets the global Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        get globalExposure() {
            return this._globalExposure;
        }
        /**
         * Sets the global Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        set globalExposure(value) {
            this._globalExposure = value;
            this._dirty = true;
        }
        /**
         * Gets the highlights Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        get highlightsHue() {
            return this._highlightsHue;
        }
        /**
         * Sets the highlights Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        set highlightsHue(value) {
            this._highlightsHue = value;
            this._dirty = true;
        }
        /**
         * Gets the highlights Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        get highlightsDensity() {
            return this._highlightsDensity;
        }
        /**
         * Sets the highlights Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        set highlightsDensity(value) {
            this._highlightsDensity = value;
            this._dirty = true;
        }
        /**
         * Gets the highlights Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        get highlightsSaturation() {
            return this._highlightsSaturation;
        }
        /**
         * Sets the highlights Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        set highlightsSaturation(value) {
            this._highlightsSaturation = value;
            this._dirty = true;
        }
        /**
         * Gets the highlights Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        get highlightsExposure() {
            return this._highlightsExposure;
        }
        /**
         * Sets the highlights Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        set highlightsExposure(value) {
            this._highlightsExposure = value;
            this._dirty = true;
        }
        /**
         * Gets the midtones Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        get midtonesHue() {
            return this._midtonesHue;
        }
        /**
         * Sets the midtones Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        set midtonesHue(value) {
            this._midtonesHue = value;
            this._dirty = true;
        }
        /**
         * Gets the midtones Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        get midtonesDensity() {
            return this._midtonesDensity;
        }
        /**
         * Sets the midtones Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        set midtonesDensity(value) {
            this._midtonesDensity = value;
            this._dirty = true;
        }
        /**
         * Gets the midtones Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        get midtonesSaturation() {
            return this._midtonesSaturation;
        }
        /**
         * Sets the midtones Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        set midtonesSaturation(value) {
            this._midtonesSaturation = value;
            this._dirty = true;
        }
        /**
         * Gets the midtones Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        get midtonesExposure() {
            return this._midtonesExposure;
        }
        /**
         * Sets the midtones Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        set midtonesExposure(value) {
            this._midtonesExposure = value;
            this._dirty = true;
        }
        /**
         * Gets the shadows Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        get shadowsHue() {
            return this._shadowsHue;
        }
        /**
         * Sets the shadows Hue value.
         * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
         */
        set shadowsHue(value) {
            this._shadowsHue = value;
            this._dirty = true;
        }
        /**
         * Gets the shadows Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        get shadowsDensity() {
            return this._shadowsDensity;
        }
        /**
         * Sets the shadows Density value.
         * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
         * Values less than zero provide a filter of opposite hue.
         */
        set shadowsDensity(value) {
            this._shadowsDensity = value;
            this._dirty = true;
        }
        /**
         * Gets the shadows Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        get shadowsSaturation() {
            return this._shadowsSaturation;
        }
        /**
         * Sets the shadows Saturation value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
         */
        set shadowsSaturation(value) {
            this._shadowsSaturation = value;
            this._dirty = true;
        }
        /**
         * Gets the shadows Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        get shadowsExposure() {
            return this._shadowsExposure;
        }
        /**
         * Sets the shadows Exposure value.
         * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
         */
        set shadowsExposure(value) {
            this._shadowsExposure = value;
            this._dirty = true;
        }
        /**
         * Returns the class name
         * @returns The class name
         */
        getClassName() {
            return "ColorCurves";
        }
        /**
         * Binds the color curves to the shader.
         * @param colorCurves The color curve to bind
         * @param effect The effect to bind to
         * @param positiveUniform The positive uniform shader parameter
         * @param neutralUniform The neutral uniform shader parameter
         * @param negativeUniform The negative uniform shader parameter
         */
        static Bind(colorCurves, effect, positiveUniform = "vCameraColorCurvePositive", neutralUniform = "vCameraColorCurveNeutral", negativeUniform = "vCameraColorCurveNegative") {
            if (colorCurves._dirty) {
                colorCurves._dirty = false;
                // Fill in global info.
                colorCurves._getColorGradingDataToRef(colorCurves._globalHue, colorCurves._globalDensity, colorCurves._globalSaturation, colorCurves._globalExposure, colorCurves._globalCurve);
                // Compute highlights info.
                colorCurves._getColorGradingDataToRef(colorCurves._highlightsHue, colorCurves._highlightsDensity, colorCurves._highlightsSaturation, colorCurves._highlightsExposure, colorCurves._tempColor);
                colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._highlightsCurve);
                // Compute midtones info.
                colorCurves._getColorGradingDataToRef(colorCurves._midtonesHue, colorCurves._midtonesDensity, colorCurves._midtonesSaturation, colorCurves._midtonesExposure, colorCurves._tempColor);
                colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._midtonesCurve);
                // Compute shadows info.
                colorCurves._getColorGradingDataToRef(colorCurves._shadowsHue, colorCurves._shadowsDensity, colorCurves._shadowsSaturation, colorCurves._shadowsExposure, colorCurves._tempColor);
                colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._shadowsCurve);
                // Compute deltas (neutral is midtones).
                colorCurves._highlightsCurve.subtractToRef(colorCurves._midtonesCurve, colorCurves._positiveCurve);
                colorCurves._midtonesCurve.subtractToRef(colorCurves._shadowsCurve, colorCurves._negativeCurve);
            }
            if (effect) {
                effect.setFloat4(positiveUniform, colorCurves._positiveCurve.r, colorCurves._positiveCurve.g, colorCurves._positiveCurve.b, colorCurves._positiveCurve.a);
                effect.setFloat4(neutralUniform, colorCurves._midtonesCurve.r, colorCurves._midtonesCurve.g, colorCurves._midtonesCurve.b, colorCurves._midtonesCurve.a);
                effect.setFloat4(negativeUniform, colorCurves._negativeCurve.r, colorCurves._negativeCurve.g, colorCurves._negativeCurve.b, colorCurves._negativeCurve.a);
            }
        }
        /**
         * Prepare the list of uniforms associated with the ColorCurves effects.
         * @param uniformsList The list of uniforms used in the effect
         */
        static PrepareUniforms(uniformsList) {
            uniformsList.push("vCameraColorCurveNeutral", "vCameraColorCurvePositive", "vCameraColorCurveNegative");
        }
        /**
         * Returns color grading data based on a hue, density, saturation and exposure value.
         * @param hue
         * @param density
         * @param saturation The saturation.
         * @param exposure The exposure.
         * @param result The result data container.
         */
        _getColorGradingDataToRef(hue, density, saturation, exposure, result) {
            if (hue == null) {
                return;
            }
            hue = ColorCurves._Clamp(hue, 0, 360);
            density = ColorCurves._Clamp(density, -100, 100);
            saturation = ColorCurves._Clamp(saturation, -100, 100);
            exposure = ColorCurves._Clamp(exposure, -100, 100);
            // Remap the slider/config filter density with non-linear mapping and also scale by half
            // so that the maximum filter density is only 50% control. This provides fine control
            // for small values and reasonable range.
            density = ColorCurves._ApplyColorGradingSliderNonlinear(density);
            density *= 0.5;
            exposure = ColorCurves._ApplyColorGradingSliderNonlinear(exposure);
            if (density < 0) {
                density *= -1;
                hue = (hue + 180) % 360;
            }
            ColorCurves._FromHSBToRef(hue, density, 50 + 0.25 * exposure, result);
            result.scaleToRef(2, result);
            result.a = 1 + 0.01 * saturation;
        }
        /**
         * Takes an input slider value and returns an adjusted value that provides extra control near the centre.
         * @param value The input slider value in range [-100,100].
         * @returns Adjusted value.
         */
        static _ApplyColorGradingSliderNonlinear(value) {
            value /= 100;
            let x = Math.abs(value);
            x = Math.pow(x, 2);
            if (value < 0) {
                x *= -1;
            }
            x *= 100;
            return x;
        }
        /**
         * Returns an RGBA Color4 based on Hue, Saturation and Brightness (also referred to as value, HSV).
         * @param hue The hue (H) input.
         * @param saturation The saturation (S) input.
         * @param brightness The brightness (B) input.
         * @param result
         * @result An RGBA color represented as Vector4.
         */
        static _FromHSBToRef(hue, saturation, brightness, result) {
            let h = ColorCurves._Clamp(hue, 0, 360);
            const s = ColorCurves._Clamp(saturation / 100, 0, 1);
            const v = ColorCurves._Clamp(brightness / 100, 0, 1);
            if (s === 0) {
                result.r = v;
                result.g = v;
                result.b = v;
            }
            else {
                // sector 0 to 5
                h /= 60;
                const i = Math.floor(h);
                // fractional part of h
                const f = h - i;
                const p = v * (1 - s);
                const q = v * (1 - s * f);
                const t = v * (1 - s * (1 - f));
                switch (i) {
                    case 0:
                        result.r = v;
                        result.g = t;
                        result.b = p;
                        break;
                    case 1:
                        result.r = q;
                        result.g = v;
                        result.b = p;
                        break;
                    case 2:
                        result.r = p;
                        result.g = v;
                        result.b = t;
                        break;
                    case 3:
                        result.r = p;
                        result.g = q;
                        result.b = v;
                        break;
                    case 4:
                        result.r = t;
                        result.g = p;
                        result.b = v;
                        break;
                    default:
                        // case 5:
                        result.r = v;
                        result.g = p;
                        result.b = q;
                        break;
                }
            }
            result.a = 1;
        }
        /**
         * Returns a value clamped between min and max
         * @param value The value to clamp
         * @param min The minimum of value
         * @param max The maximum of value
         * @returns The clamped value.
         */
        static _Clamp(value, min, max) {
            return Math.min(Math.max(value, min), max);
        }
        /**
         * Clones the current color curve instance.
         * @returns The cloned curves
         */
        clone() {
            return SerializationHelper.Clone(() => new ColorCurves(), this);
        }
        /**
         * Serializes the current color curve instance to a json representation.
         * @returns a JSON representation
         */
        serialize() {
            return SerializationHelper.Serialize(this);
        }
        /**
         * Parses the color curve from a json representation.
         * @param source the JSON source to parse
         * @returns The parsed curves
         */
        static Parse(source) {
            return SerializationHelper.Parse(() => new ColorCurves(), source, null, null);
        }
    }
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_globalHue", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_globalDensity", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_globalSaturation", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_globalExposure", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_highlightsHue", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_highlightsDensity", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_highlightsSaturation", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_highlightsExposure", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_midtonesHue", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_midtonesDensity", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_midtonesSaturation", void 0);
    __decorate$1([
        serialize()
    ], ColorCurves.prototype, "_midtonesExposure", void 0);
    // References the dependencies.
    SerializationHelper._ColorCurvesParser = ColorCurves.Parse;

    /**
     * @internal
     */
    class ImageProcessingConfigurationDefines extends MaterialDefines {
        constructor() {
            super();
            this.IMAGEPROCESSING = false;
            this.VIGNETTE = false;
            this.VIGNETTEBLENDMODEMULTIPLY = false;
            this.VIGNETTEBLENDMODEOPAQUE = false;
            this.TONEMAPPING = false;
            this.TONEMAPPING_ACES = false;
            this.CONTRAST = false;
            this.COLORCURVES = false;
            this.COLORGRADING = false;
            this.COLORGRADING3D = false;
            this.SAMPLER3DGREENDEPTH = false;
            this.SAMPLER3DBGRMAP = false;
            this.DITHER = false;
            this.IMAGEPROCESSINGPOSTPROCESS = false;
            this.EXPOSURE = false;
            this.SKIPFINALCOLORCLAMP = false;
            this.rebuild();
        }
    }
    /**
     * This groups together the common properties used for image processing either in direct forward pass
     * or through post processing effect depending on the use of the image processing pipeline in your scene
     * or not.
     */
    class ImageProcessingConfiguration {
        constructor() {
            /**
             * Color curves setup used in the effect if colorCurvesEnabled is set to true
             */
            this.colorCurves = new ColorCurves();
            this._colorCurvesEnabled = false;
            this._colorGradingEnabled = false;
            this._colorGradingWithGreenDepth = true;
            this._colorGradingBGR = true;
            /** @internal */
            this._exposure = 1.0;
            this._toneMappingEnabled = false;
            this._toneMappingType = ImageProcessingConfiguration.TONEMAPPING_STANDARD;
            this._contrast = 1.0;
            /**
             * Vignette stretch size.
             */
            this.vignetteStretch = 0;
            /**
             * Vignette center X Offset.
             */
            this.vignetteCenterX = 0;
            /**
             * Vignette center Y Offset.
             */
            this.vignetteCenterY = 0;
            /**
             * Vignette weight or intensity of the vignette effect.
             */
            this.vignetteWeight = 1.5;
            /**
             * Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
             * if vignetteEnabled is set to true.
             */
            this.vignetteColor = new Color4(0, 0, 0, 0);
            /**
             * Camera field of view used by the Vignette effect.
             */
            this.vignetteCameraFov = 0.5;
            this._vignetteBlendMode = ImageProcessingConfiguration.VIGNETTEMODE_MULTIPLY;
            this._vignetteEnabled = false;
            this._ditheringEnabled = false;
            this._ditheringIntensity = 1.0 / 255.0;
            /** @internal */
            this._skipFinalColorClamp = false;
            /** @internal */
            this._applyByPostProcess = false;
            this._isEnabled = true;
            /**
             * An event triggered when the configuration changes and requires Shader to Update some parameters.
             */
            this.onUpdateParameters = new Observable$1();
        }
        /**
         * Gets whether the color curves effect is enabled.
         */
        get colorCurvesEnabled() {
            return this._colorCurvesEnabled;
        }
        /**
         * Sets whether the color curves effect is enabled.
         */
        set colorCurvesEnabled(value) {
            if (this._colorCurvesEnabled === value) {
                return;
            }
            this._colorCurvesEnabled = value;
            this._updateParameters();
        }
        /**
         * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
         */
        get colorGradingTexture() {
            return this._colorGradingTexture;
        }
        /**
         * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
         */
        set colorGradingTexture(value) {
            if (this._colorGradingTexture === value) {
                return;
            }
            this._colorGradingTexture = value;
            this._updateParameters();
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        get colorGradingEnabled() {
            return this._colorGradingEnabled;
        }
        /**
         * Sets whether the color grading effect is enabled.
         */
        set colorGradingEnabled(value) {
            if (this._colorGradingEnabled === value) {
                return;
            }
            this._colorGradingEnabled = value;
            this._updateParameters();
        }
        /**
         * Gets whether the color grading effect is using a green depth for the 3d Texture.
         */
        get colorGradingWithGreenDepth() {
            return this._colorGradingWithGreenDepth;
        }
        /**
         * Sets whether the color grading effect is using a green depth for the 3d Texture.
         */
        set colorGradingWithGreenDepth(value) {
            if (this._colorGradingWithGreenDepth === value) {
                return;
            }
            this._colorGradingWithGreenDepth = value;
            this._updateParameters();
        }
        /**
         * Gets whether the color grading texture contains BGR values.
         */
        get colorGradingBGR() {
            return this._colorGradingBGR;
        }
        /**
         * Sets whether the color grading texture contains BGR values.
         */
        set colorGradingBGR(value) {
            if (this._colorGradingBGR === value) {
                return;
            }
            this._colorGradingBGR = value;
            this._updateParameters();
        }
        /**
         * Gets the Exposure used in the effect.
         */
        get exposure() {
            return this._exposure;
        }
        /**
         * Sets the Exposure used in the effect.
         */
        set exposure(value) {
            if (this._exposure === value) {
                return;
            }
            this._exposure = value;
            this._updateParameters();
        }
        /**
         * Gets whether the tone mapping effect is enabled.
         */
        get toneMappingEnabled() {
            return this._toneMappingEnabled;
        }
        /**
         * Sets whether the tone mapping effect is enabled.
         */
        set toneMappingEnabled(value) {
            if (this._toneMappingEnabled === value) {
                return;
            }
            this._toneMappingEnabled = value;
            this._updateParameters();
        }
        /**
         * Gets the type of tone mapping effect.
         */
        get toneMappingType() {
            return this._toneMappingType;
        }
        /**
         * Sets the type of tone mapping effect used in BabylonJS.
         */
        set toneMappingType(value) {
            if (this._toneMappingType === value) {
                return;
            }
            this._toneMappingType = value;
            this._updateParameters();
        }
        /**
         * Gets the contrast used in the effect.
         */
        get contrast() {
            return this._contrast;
        }
        /**
         * Sets the contrast used in the effect.
         */
        set contrast(value) {
            if (this._contrast === value) {
                return;
            }
            this._contrast = value;
            this._updateParameters();
        }
        /**
         * Back Compat: Vignette center Y Offset.
         * @deprecated use vignetteCenterY instead
         */
        get vignetteCentreY() {
            return this.vignetteCenterY;
        }
        set vignetteCentreY(value) {
            this.vignetteCenterY = value;
        }
        /**
         * Back Compat: Vignette center X Offset.
         * @deprecated use vignetteCenterX instead
         */
        get vignetteCentreX() {
            return this.vignetteCenterX;
        }
        set vignetteCentreX(value) {
            this.vignetteCenterX = value;
        }
        /**
         * Gets the vignette blend mode allowing different kind of effect.
         */
        get vignetteBlendMode() {
            return this._vignetteBlendMode;
        }
        /**
         * Sets the vignette blend mode allowing different kind of effect.
         */
        set vignetteBlendMode(value) {
            if (this._vignetteBlendMode === value) {
                return;
            }
            this._vignetteBlendMode = value;
            this._updateParameters();
        }
        /**
         * Gets whether the vignette effect is enabled.
         */
        get vignetteEnabled() {
            return this._vignetteEnabled;
        }
        /**
         * Sets whether the vignette effect is enabled.
         */
        set vignetteEnabled(value) {
            if (this._vignetteEnabled === value) {
                return;
            }
            this._vignetteEnabled = value;
            this._updateParameters();
        }
        /**
         * Gets whether the dithering effect is enabled.
         * The dithering effect can be used to reduce banding.
         */
        get ditheringEnabled() {
            return this._ditheringEnabled;
        }
        /**
         * Sets whether the dithering effect is enabled.
         * The dithering effect can be used to reduce banding.
         */
        set ditheringEnabled(value) {
            if (this._ditheringEnabled === value) {
                return;
            }
            this._ditheringEnabled = value;
            this._updateParameters();
        }
        /**
         * Gets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
         */
        get ditheringIntensity() {
            return this._ditheringIntensity;
        }
        /**
         * Sets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
         */
        set ditheringIntensity(value) {
            if (this._ditheringIntensity === value) {
                return;
            }
            this._ditheringIntensity = value;
            this._updateParameters();
        }
        /**
         * If apply by post process is set to true, setting this to true will skip the the final color clamp step in the fragment shader
         * Applies to PBR materials.
         */
        get skipFinalColorClamp() {
            return this._skipFinalColorClamp;
        }
        /**
         * If apply by post process is set to true, setting this to true will skip the the final color clamp step in the fragment shader
         * Applies to PBR materials.
         */
        set skipFinalColorClamp(value) {
            if (this._skipFinalColorClamp === value) {
                return;
            }
            this._skipFinalColorClamp = value;
            this._updateParameters();
        }
        /**
         * Gets whether the image processing is applied through a post process or not.
         */
        get applyByPostProcess() {
            return this._applyByPostProcess;
        }
        /**
         * Sets whether the image processing is applied through a post process or not.
         */
        set applyByPostProcess(value) {
            if (this._applyByPostProcess === value) {
                return;
            }
            this._applyByPostProcess = value;
            this._updateParameters();
        }
        /**
         * Gets whether the image processing is enabled or not.
         */
        get isEnabled() {
            return this._isEnabled;
        }
        /**
         * Sets whether the image processing is enabled or not.
         */
        set isEnabled(value) {
            if (this._isEnabled === value) {
                return;
            }
            this._isEnabled = value;
            this._updateParameters();
        }
        /**
         * Method called each time the image processing information changes requires to recompile the effect.
         */
        _updateParameters() {
            this.onUpdateParameters.notifyObservers(this);
        }
        /**
         * Gets the current class name.
         * @returns "ImageProcessingConfiguration"
         */
        getClassName() {
            return "ImageProcessingConfiguration";
        }
        /**
         * Prepare the list of uniforms associated with the Image Processing effects.
         * @param uniforms The list of uniforms used in the effect
         * @param defines the list of defines currently in use
         */
        static PrepareUniforms(uniforms, defines) {
            if (defines.EXPOSURE) {
                uniforms.push("exposureLinear");
            }
            if (defines.CONTRAST) {
                uniforms.push("contrast");
            }
            if (defines.COLORGRADING) {
                uniforms.push("colorTransformSettings");
            }
            if (defines.VIGNETTE || defines.DITHER) {
                uniforms.push("vInverseScreenSize");
            }
            if (defines.VIGNETTE) {
                uniforms.push("vignetteSettings1");
                uniforms.push("vignetteSettings2");
            }
            if (defines.COLORCURVES) {
                ColorCurves.PrepareUniforms(uniforms);
            }
            if (defines.DITHER) {
                uniforms.push("ditherIntensity");
            }
        }
        /**
         * Prepare the list of samplers associated with the Image Processing effects.
         * @param samplersList The list of uniforms used in the effect
         * @param defines the list of defines currently in use
         */
        static PrepareSamplers(samplersList, defines) {
            if (defines.COLORGRADING) {
                samplersList.push("txColorTransform");
            }
        }
        /**
         * Prepare the list of defines associated to the shader.
         * @param defines the list of defines to complete
         * @param forPostProcess Define if we are currently in post process mode or not
         */
        prepareDefines(defines, forPostProcess = false) {
            if (forPostProcess !== this.applyByPostProcess || !this._isEnabled) {
                defines.VIGNETTE = false;
                defines.TONEMAPPING = false;
                defines.TONEMAPPING_ACES = false;
                defines.CONTRAST = false;
                defines.EXPOSURE = false;
                defines.COLORCURVES = false;
                defines.COLORGRADING = false;
                defines.COLORGRADING3D = false;
                defines.DITHER = false;
                defines.IMAGEPROCESSING = false;
                defines.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp;
                defines.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess && this._isEnabled;
                return;
            }
            defines.VIGNETTE = this.vignetteEnabled;
            defines.VIGNETTEBLENDMODEMULTIPLY = this.vignetteBlendMode === ImageProcessingConfiguration._VIGNETTEMODE_MULTIPLY;
            defines.VIGNETTEBLENDMODEOPAQUE = !defines.VIGNETTEBLENDMODEMULTIPLY;
            defines.TONEMAPPING = this.toneMappingEnabled;
            switch (this._toneMappingType) {
                case ImageProcessingConfiguration.TONEMAPPING_ACES:
                    defines.TONEMAPPING_ACES = true;
                    break;
                default:
                    defines.TONEMAPPING_ACES = false;
                    break;
            }
            defines.CONTRAST = this.contrast !== 1.0;
            defines.EXPOSURE = this.exposure !== 1.0;
            defines.COLORCURVES = this.colorCurvesEnabled && !!this.colorCurves;
            defines.COLORGRADING = this.colorGradingEnabled && !!this.colorGradingTexture;
            if (defines.COLORGRADING) {
                defines.COLORGRADING3D = this.colorGradingTexture.is3D;
            }
            else {
                defines.COLORGRADING3D = false;
            }
            defines.SAMPLER3DGREENDEPTH = this.colorGradingWithGreenDepth;
            defines.SAMPLER3DBGRMAP = this.colorGradingBGR;
            defines.DITHER = this._ditheringEnabled;
            defines.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess;
            defines.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp;
            defines.IMAGEPROCESSING = defines.VIGNETTE || defines.TONEMAPPING || defines.CONTRAST || defines.EXPOSURE || defines.COLORCURVES || defines.COLORGRADING || defines.DITHER;
        }
        /**
         * Returns true if all the image processing information are ready.
         * @returns True if ready, otherwise, false
         */
        isReady() {
            // Color Grading texture can not be none blocking.
            return !this.colorGradingEnabled || !this.colorGradingTexture || this.colorGradingTexture.isReady();
        }
        /**
         * Binds the image processing to the shader.
         * @param effect The effect to bind to
         * @param overrideAspectRatio Override the aspect ratio of the effect
         */
        bind(effect, overrideAspectRatio) {
            // Color Curves
            if (this._colorCurvesEnabled && this.colorCurves) {
                ColorCurves.Bind(this.colorCurves, effect);
            }
            // Vignette and dither handled together due to common uniform.
            if (this._vignetteEnabled || this._ditheringEnabled) {
                const inverseWidth = 1 / effect.getEngine().getRenderWidth();
                const inverseHeight = 1 / effect.getEngine().getRenderHeight();
                effect.setFloat2("vInverseScreenSize", inverseWidth, inverseHeight);
                if (this._ditheringEnabled) {
                    effect.setFloat("ditherIntensity", 0.5 * this._ditheringIntensity);
                }
                if (this._vignetteEnabled) {
                    const aspectRatio = overrideAspectRatio != null ? overrideAspectRatio : inverseHeight / inverseWidth;
                    let vignetteScaleY = Math.tan(this.vignetteCameraFov * 0.5);
                    let vignetteScaleX = vignetteScaleY * aspectRatio;
                    const vignetteScaleGeometricMean = Math.sqrt(vignetteScaleX * vignetteScaleY);
                    vignetteScaleX = Tools.Mix(vignetteScaleX, vignetteScaleGeometricMean, this.vignetteStretch);
                    vignetteScaleY = Tools.Mix(vignetteScaleY, vignetteScaleGeometricMean, this.vignetteStretch);
                    effect.setFloat4("vignetteSettings1", vignetteScaleX, vignetteScaleY, -vignetteScaleX * this.vignetteCenterX, -vignetteScaleY * this.vignetteCenterY);
                    const vignettePower = -2.0 * this.vignetteWeight;
                    effect.setFloat4("vignetteSettings2", this.vignetteColor.r, this.vignetteColor.g, this.vignetteColor.b, vignettePower);
                }
            }
            // Exposure
            effect.setFloat("exposureLinear", this.exposure);
            // Contrast
            effect.setFloat("contrast", this.contrast);
            // Color transform settings
            if (this.colorGradingTexture) {
                effect.setTexture("txColorTransform", this.colorGradingTexture);
                const textureSize = this.colorGradingTexture.getSize().height;
                effect.setFloat4("colorTransformSettings", (textureSize - 1) / textureSize, // textureScale
                0.5 / textureSize, // textureOffset
                textureSize, // textureSize
                this.colorGradingTexture.level // weight
                );
            }
        }
        /**
         * Clones the current image processing instance.
         * @returns The cloned image processing
         */
        clone() {
            return SerializationHelper.Clone(() => new ImageProcessingConfiguration(), this);
        }
        /**
         * Serializes the current image processing instance to a json representation.
         * @returns a JSON representation
         */
        serialize() {
            return SerializationHelper.Serialize(this);
        }
        /**
         * Parses the image processing from a json representation.
         * @param source the JSON source to parse
         * @returns The parsed image processing
         */
        static Parse(source) {
            const parsed = SerializationHelper.Parse(() => new ImageProcessingConfiguration(), source, null, null);
            // Backward compatibility
            if (source.vignetteCentreX !== undefined) {
                parsed.vignetteCenterX = source.vignetteCentreX;
            }
            if (source.vignetteCentreY !== undefined) {
                parsed.vignetteCenterY = source.vignetteCentreY;
            }
            return parsed;
        }
        /**
         * Used to apply the vignette as a mix with the pixel color.
         */
        static get VIGNETTEMODE_MULTIPLY() {
            return this._VIGNETTEMODE_MULTIPLY;
        }
        /**
         * Used to apply the vignette as a replacement of the pixel color.
         */
        static get VIGNETTEMODE_OPAQUE() {
            return this._VIGNETTEMODE_OPAQUE;
        }
    }
    /**
     * Default tone mapping applied in BabylonJS.
     */
    ImageProcessingConfiguration.TONEMAPPING_STANDARD = 0;
    /**
     * ACES Tone mapping (used by default in unreal and unity). This can help getting closer
     * to other engines rendering to increase portability.
     */
    ImageProcessingConfiguration.TONEMAPPING_ACES = 1;
    // Static constants associated to the image processing.
    ImageProcessingConfiguration._VIGNETTEMODE_MULTIPLY = 0;
    ImageProcessingConfiguration._VIGNETTEMODE_OPAQUE = 1;
    __decorate$1([
        serializeAsColorCurves()
    ], ImageProcessingConfiguration.prototype, "colorCurves", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_colorCurvesEnabled", void 0);
    __decorate$1([
        serializeAsTexture("colorGradingTexture")
    ], ImageProcessingConfiguration.prototype, "_colorGradingTexture", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_colorGradingEnabled", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_colorGradingWithGreenDepth", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_colorGradingBGR", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_exposure", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_toneMappingEnabled", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_toneMappingType", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_contrast", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "vignetteStretch", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "vignetteCenterX", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "vignetteCenterY", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "vignetteWeight", void 0);
    __decorate$1([
        serializeAsColor4()
    ], ImageProcessingConfiguration.prototype, "vignetteColor", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "vignetteCameraFov", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_vignetteBlendMode", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_vignetteEnabled", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_ditheringEnabled", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_ditheringIntensity", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_skipFinalColorClamp", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_applyByPostProcess", void 0);
    __decorate$1([
        serialize()
    ], ImageProcessingConfiguration.prototype, "_isEnabled", void 0);
    // References the dependencies.
    SerializationHelper._ImageProcessingConfigurationParser = ImageProcessingConfiguration.Parse;

    ThinEngine.prototype.createUniformBuffer = function (elements) {
        const ubo = this._gl.createBuffer();
        if (!ubo) {
            throw new Error("Unable to create uniform buffer");
        }
        const result = new WebGLDataBuffer(ubo);
        this.bindUniformBuffer(result);
        if (elements instanceof Float32Array) {
            this._gl.bufferData(this._gl.UNIFORM_BUFFER, elements, this._gl.STATIC_DRAW);
        }
        else {
            this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(elements), this._gl.STATIC_DRAW);
        }
        this.bindUniformBuffer(null);
        result.references = 1;
        return result;
    };
    ThinEngine.prototype.createDynamicUniformBuffer = function (elements) {
        const ubo = this._gl.createBuffer();
        if (!ubo) {
            throw new Error("Unable to create dynamic uniform buffer");
        }
        const result = new WebGLDataBuffer(ubo);
        this.bindUniformBuffer(result);
        if (elements instanceof Float32Array) {
            this._gl.bufferData(this._gl.UNIFORM_BUFFER, elements, this._gl.DYNAMIC_DRAW);
        }
        else {
            this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(elements), this._gl.DYNAMIC_DRAW);
        }
        this.bindUniformBuffer(null);
        result.references = 1;
        return result;
    };
    ThinEngine.prototype.updateUniformBuffer = function (uniformBuffer, elements, offset, count) {
        this.bindUniformBuffer(uniformBuffer);
        if (offset === undefined) {
            offset = 0;
        }
        if (count === undefined) {
            if (elements instanceof Float32Array) {
                this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, offset, elements);
            }
            else {
                this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, offset, new Float32Array(elements));
            }
        }
        else {
            if (elements instanceof Float32Array) {
                this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, elements.subarray(offset, offset + count));
            }
            else {
                this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, new Float32Array(elements).subarray(offset, offset + count));
            }
        }
        this.bindUniformBuffer(null);
    };
    ThinEngine.prototype.bindUniformBuffer = function (buffer) {
        this._gl.bindBuffer(this._gl.UNIFORM_BUFFER, buffer ? buffer.underlyingResource : null);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ThinEngine.prototype.bindUniformBufferBase = function (buffer, location, name) {
        this._gl.bindBufferBase(this._gl.UNIFORM_BUFFER, location, buffer ? buffer.underlyingResource : null);
    };
    ThinEngine.prototype.bindUniformBlock = function (pipelineContext, blockName, index) {
        const program = pipelineContext.program;
        const uniformLocation = this._gl.getUniformBlockIndex(program, blockName);
        if (uniformLocation !== 0xffffffff) {
            this._gl.uniformBlockBinding(program, uniformLocation, index);
        }
    };

    /**
     * Uniform buffer objects.
     *
     * Handles blocks of uniform on the GPU.
     *
     * If WebGL 2 is not available, this class falls back on traditional setUniformXXX calls.
     *
     * For more information, please refer to :
     * https://www.khronos.org/opengl/wiki/Uniform_Buffer_Object
     */
    class UniformBuffer {
        /**
         * Instantiates a new Uniform buffer objects.
         *
         * Handles blocks of uniform on the GPU.
         *
         * If WebGL 2 is not available, this class falls back on traditional setUniformXXX calls.
         *
         * For more information, please refer to :
         * @see https://www.khronos.org/opengl/wiki/Uniform_Buffer_Object
         * @param engine Define the engine the buffer is associated with
         * @param data Define the data contained in the buffer
         * @param dynamic Define if the buffer is updatable
         * @param name to assign to the buffer (debugging purpose)
         * @param forceNoUniformBuffer define that this object must not rely on UBO objects
         */
        constructor(engine, data, dynamic, name, forceNoUniformBuffer = false) {
            // Matrix cache
            this._valueCache = {};
            this._engine = engine;
            this._noUBO = !engine.supportsUniformBuffers || forceNoUniformBuffer;
            this._dynamic = dynamic;
            this._name = name !== null && name !== void 0 ? name : "no-name";
            this._data = data || [];
            this._uniformLocations = {};
            this._uniformSizes = {};
            this._uniformArraySizes = {};
            this._uniformLocationPointer = 0;
            this._needSync = false;
            if (this._engine._features.trackUbosInFrame) {
                this._buffers = [];
                this._bufferIndex = -1;
                this._createBufferOnWrite = false;
                this._currentFrameId = 0;
            }
            if (this._noUBO) {
                this.updateMatrix3x3 = this._updateMatrix3x3ForEffect;
                this.updateMatrix2x2 = this._updateMatrix2x2ForEffect;
                this.updateFloat = this._updateFloatForEffect;
                this.updateFloat2 = this._updateFloat2ForEffect;
                this.updateFloat3 = this._updateFloat3ForEffect;
                this.updateFloat4 = this._updateFloat4ForEffect;
                this.updateFloatArray = this._updateFloatArrayForEffect;
                this.updateArray = this._updateArrayForEffect;
                this.updateIntArray = this._updateIntArrayForEffect;
                this.updateUIntArray = this._updateUIntArrayForEffect;
                this.updateMatrix = this._updateMatrixForEffect;
                this.updateMatrices = this._updateMatricesForEffect;
                this.updateVector3 = this._updateVector3ForEffect;
                this.updateVector4 = this._updateVector4ForEffect;
                this.updateColor3 = this._updateColor3ForEffect;
                this.updateColor4 = this._updateColor4ForEffect;
                this.updateDirectColor4 = this._updateDirectColor4ForEffect;
                this.updateInt = this._updateIntForEffect;
                this.updateInt2 = this._updateInt2ForEffect;
                this.updateInt3 = this._updateInt3ForEffect;
                this.updateInt4 = this._updateInt4ForEffect;
                this.updateUInt = this._updateUIntForEffect;
                this.updateUInt2 = this._updateUInt2ForEffect;
                this.updateUInt3 = this._updateUInt3ForEffect;
                this.updateUInt4 = this._updateUInt4ForEffect;
            }
            else {
                this._engine._uniformBuffers.push(this);
                this.updateMatrix3x3 = this._updateMatrix3x3ForUniform;
                this.updateMatrix2x2 = this._updateMatrix2x2ForUniform;
                this.updateFloat = this._updateFloatForUniform;
                this.updateFloat2 = this._updateFloat2ForUniform;
                this.updateFloat3 = this._updateFloat3ForUniform;
                this.updateFloat4 = this._updateFloat4ForUniform;
                this.updateFloatArray = this._updateFloatArrayForUniform;
                this.updateArray = this._updateArrayForUniform;
                this.updateIntArray = this._updateIntArrayForUniform;
                this.updateUIntArray = this._updateUIntArrayForUniform;
                this.updateMatrix = this._updateMatrixForUniform;
                this.updateMatrices = this._updateMatricesForUniform;
                this.updateVector3 = this._updateVector3ForUniform;
                this.updateVector4 = this._updateVector4ForUniform;
                this.updateColor3 = this._updateColor3ForUniform;
                this.updateColor4 = this._updateColor4ForUniform;
                this.updateDirectColor4 = this._updateDirectColor4ForUniform;
                this.updateInt = this._updateIntForUniform;
                this.updateInt2 = this._updateInt2ForUniform;
                this.updateInt3 = this._updateInt3ForUniform;
                this.updateInt4 = this._updateInt4ForUniform;
                this.updateUInt = this._updateUIntForUniform;
                this.updateUInt2 = this._updateUInt2ForUniform;
                this.updateUInt3 = this._updateUInt3ForUniform;
                this.updateUInt4 = this._updateUInt4ForUniform;
            }
        }
        /**
         * Indicates if the buffer is using the WebGL2 UBO implementation,
         * or just falling back on setUniformXXX calls.
         */
        get useUbo() {
            return !this._noUBO;
        }
        /**
         * Indicates if the WebGL underlying uniform buffer is in sync
         * with the javascript cache data.
         */
        get isSync() {
            return !this._needSync;
        }
        /**
         * Indicates if the WebGL underlying uniform buffer is dynamic.
         * Also, a dynamic UniformBuffer will disable cache verification and always
         * update the underlying WebGL uniform buffer to the GPU.
         * @returns if Dynamic, otherwise false
         */
        isDynamic() {
            return this._dynamic !== undefined;
        }
        /**
         * The data cache on JS side.
         * @returns the underlying data as a float array
         */
        getData() {
            return this._bufferData;
        }
        /**
         * The underlying WebGL Uniform buffer.
         * @returns the webgl buffer
         */
        getBuffer() {
            return this._buffer;
        }
        /**
         * std140 layout specifies how to align data within an UBO structure.
         * See https://khronos.org/registry/OpenGL/specs/gl/glspec45.core.pdf#page=159
         * for specs.
         * @param size
         */
        _fillAlignment(size) {
            // This code has been simplified because we only use floats, vectors of 1, 2, 3, 4 components
            // and 4x4 matrices
            // TODO : change if other types are used
            let alignment;
            if (size <= 2) {
                alignment = size;
            }
            else {
                alignment = 4;
            }
            if (this._uniformLocationPointer % alignment !== 0) {
                const oldPointer = this._uniformLocationPointer;
                this._uniformLocationPointer += alignment - (this._uniformLocationPointer % alignment);
                const diff = this._uniformLocationPointer - oldPointer;
                for (let i = 0; i < diff; i++) {
                    this._data.push(0);
                }
            }
        }
        /**
         * Adds an uniform in the buffer.
         * Warning : the subsequents calls of this function must be in the same order as declared in the shader
         * for the layout to be correct ! The addUniform function only handles types like float, vec2, vec3, vec4, mat4,
         * meaning size=1,2,3,4 or 16. It does not handle struct types.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param size Data size, or data directly.
         * @param arraySize The number of elements in the array, 0 if not an array.
         */
        addUniform(name, size, arraySize = 0) {
            if (this._noUBO) {
                return;
            }
            if (this._uniformLocations[name] !== undefined) {
                // Already existing uniform
                return;
            }
            // This function must be called in the order of the shader layout !
            // size can be the size of the uniform, or data directly
            let data;
            // std140 FTW...
            if (arraySize > 0) {
                if (size instanceof Array) {
                    throw "addUniform should not be use with Array in UBO: " + name;
                }
                this._fillAlignment(4);
                this._uniformArraySizes[name] = { strideSize: size, arraySize };
                if (size == 16) {
                    size = size * arraySize;
                }
                else {
                    const perElementPadding = 4 - size;
                    const totalPadding = perElementPadding * arraySize;
                    size = size * arraySize + totalPadding;
                }
                data = [];
                // Fill with zeros
                for (let i = 0; i < size; i++) {
                    data.push(0);
                }
            }
            else {
                if (size instanceof Array) {
                    data = size;
                    size = data.length;
                }
                else {
                    size = size;
                    data = [];
                    // Fill with zeros
                    for (let i = 0; i < size; i++) {
                        data.push(0);
                    }
                }
                this._fillAlignment(size);
            }
            this._uniformSizes[name] = size;
            this._uniformLocations[name] = this._uniformLocationPointer;
            this._uniformLocationPointer += size;
            for (let i = 0; i < size; i++) {
                this._data.push(data[i]);
            }
            this._needSync = true;
        }
        /**
         * Adds a Matrix 4x4 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param mat A 4x4 matrix.
         */
        addMatrix(name, mat) {
            this.addUniform(name, Array.prototype.slice.call(mat.toArray()));
        }
        /**
         * Adds a vec2 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param x Define the x component value of the vec2
         * @param y Define the y component value of the vec2
         */
        addFloat2(name, x, y) {
            const temp = [x, y];
            this.addUniform(name, temp);
        }
        /**
         * Adds a vec3 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param x Define the x component value of the vec3
         * @param y Define the y component value of the vec3
         * @param z Define the z component value of the vec3
         */
        addFloat3(name, x, y, z) {
            const temp = [x, y, z];
            this.addUniform(name, temp);
        }
        /**
         * Adds a vec3 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param color Define the vec3 from a Color
         */
        addColor3(name, color) {
            const temp = [color.r, color.g, color.b];
            this.addUniform(name, temp);
        }
        /**
         * Adds a vec4 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param color Define the rgb components from a Color
         * @param alpha Define the a component of the vec4
         */
        addColor4(name, color, alpha) {
            const temp = [color.r, color.g, color.b, alpha];
            this.addUniform(name, temp);
        }
        /**
         * Adds a vec3 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         * @param vector Define the vec3 components from a Vector
         */
        addVector3(name, vector) {
            const temp = [vector.x, vector.y, vector.z];
            this.addUniform(name, temp);
        }
        /**
         * Adds a Matrix 3x3 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         */
        addMatrix3x3(name) {
            this.addUniform(name, 12);
        }
        /**
         * Adds a Matrix 2x2 to the uniform buffer.
         * @param name Name of the uniform, as used in the uniform block in the shader.
         */
        addMatrix2x2(name) {
            this.addUniform(name, 8);
        }
        /**
         * Effectively creates the WebGL Uniform Buffer, once layout is completed with `addUniform`.
         */
        create() {
            if (this._noUBO) {
                return;
            }
            if (this._buffer) {
                return; // nothing to do
            }
            // See spec, alignment must be filled as a vec4
            this._fillAlignment(4);
            this._bufferData = new Float32Array(this._data);
            this._rebuild();
            this._needSync = true;
        }
        /** @internal */
        _rebuild() {
            if (this._noUBO || !this._bufferData) {
                return;
            }
            if (this._dynamic) {
                this._buffer = this._engine.createDynamicUniformBuffer(this._bufferData);
            }
            else {
                this._buffer = this._engine.createUniformBuffer(this._bufferData);
            }
            if (this._engine._features.trackUbosInFrame) {
                this._buffers.push([this._buffer, this._engine._features.checkUbosContentBeforeUpload ? this._bufferData.slice() : undefined]);
                this._bufferIndex = this._buffers.length - 1;
                this._createBufferOnWrite = false;
            }
        }
        /** @internal */
        get _numBuffers() {
            return this._buffers.length;
        }
        /** @internal */
        get _indexBuffer() {
            return this._bufferIndex;
        }
        /** Gets the name of this buffer */
        get name() {
            return this._name;
        }
        /** Gets the current effect */
        get currentEffect() {
            return this._currentEffect;
        }
        _buffersEqual(buf1, buf2) {
            for (let i = 0; i < buf1.length; ++i) {
                if (buf1[i] !== buf2[i]) {
                    return false;
                }
            }
            return true;
        }
        _copyBuffer(src, dst) {
            for (let i = 0; i < src.length; ++i) {
                dst[i] = src[i];
            }
        }
        /**
         * Updates the WebGL Uniform Buffer on the GPU.
         * If the `dynamic` flag is set to true, no cache comparison is done.
         * Otherwise, the buffer will be updated only if the cache differs.
         */
        update() {
            if (this._noUBO) {
                return;
            }
            this.bindUniformBuffer();
            if (!this._buffer) {
                this.create();
                return;
            }
            if (!this._dynamic && !this._needSync) {
                this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
                return;
            }
            if (this._buffers && this._buffers.length > 1 && this._buffers[this._bufferIndex][1]) {
                if (this._buffersEqual(this._bufferData, this._buffers[this._bufferIndex][1])) {
                    this._needSync = false;
                    this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
                    return;
                }
                else {
                    this._copyBuffer(this._bufferData, this._buffers[this._bufferIndex][1]);
                }
            }
            this._engine.updateUniformBuffer(this._buffer, this._bufferData);
            if (this._engine._features._collectUbosUpdatedInFrame) {
                if (!UniformBuffer._UpdatedUbosInFrame[this._name]) {
                    UniformBuffer._UpdatedUbosInFrame[this._name] = 0;
                }
                UniformBuffer._UpdatedUbosInFrame[this._name]++;
            }
            this._needSync = false;
            this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
        }
        _createNewBuffer() {
            if (this._bufferIndex + 1 < this._buffers.length) {
                this._bufferIndex++;
                this._buffer = this._buffers[this._bufferIndex][0];
                this._createBufferOnWrite = false;
                this._needSync = true;
            }
            else {
                this._rebuild();
            }
        }
        _checkNewFrame() {
            if (this._engine._features.trackUbosInFrame && this._currentFrameId !== this._engine.frameId) {
                this._currentFrameId = this._engine.frameId;
                this._createBufferOnWrite = false;
                if (this._buffers && this._buffers.length > 0) {
                    this._needSync = this._bufferIndex !== 0;
                    this._bufferIndex = 0;
                    this._buffer = this._buffers[this._bufferIndex][0];
                }
                else {
                    this._bufferIndex = -1;
                }
            }
        }
        /**
         * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
         * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
         * @param data Define the flattened data
         * @param size Define the size of the data.
         */
        updateUniform(uniformName, data, size) {
            this._checkNewFrame();
            let location = this._uniformLocations[uniformName];
            if (location === undefined) {
                if (this._buffer) {
                    // Cannot add an uniform if the buffer is already created
                    Logger.Error("Cannot add an uniform after UBO has been created.");
                    return;
                }
                this.addUniform(uniformName, size);
                location = this._uniformLocations[uniformName];
            }
            if (!this._buffer) {
                this.create();
            }
            if (!this._dynamic) {
                // Cache for static uniform buffers
                let changed = false;
                for (let i = 0; i < size; i++) {
                    // We are checking the matrix cache before calling updateUniform so we do not need to check it here
                    // Hence the test for size === 16 to simply commit the matrix values
                    if ((size === 16 && !this._engine._features.uniformBufferHardCheckMatrix) || this._bufferData[location + i] !== Tools.FloatRound(data[i])) {
                        changed = true;
                        if (this._createBufferOnWrite) {
                            this._createNewBuffer();
                        }
                        this._bufferData[location + i] = data[i];
                    }
                }
                this._needSync = this._needSync || changed;
            }
            else {
                // No cache for dynamic
                for (let i = 0; i < size; i++) {
                    this._bufferData[location + i] = data[i];
                }
            }
        }
        /**
         * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
         * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
         * @param data Define the flattened data
         * @param size Define the size of the data.
         */
        updateUniformArray(uniformName, data, size) {
            this._checkNewFrame();
            const location = this._uniformLocations[uniformName];
            if (location === undefined) {
                Logger.Error("Cannot add an uniform Array dynamically. Please, add it using addUniform and make sure that uniform buffers are supported by the current engine.");
                return;
            }
            if (!this._buffer) {
                this.create();
            }
            const arraySizes = this._uniformArraySizes[uniformName];
            if (!this._dynamic) {
                // Cache for static uniform buffers
                let changed = false;
                let countToFour = 0;
                let baseStride = 0;
                for (let i = 0; i < size; i++) {
                    if (this._bufferData[location + baseStride * 4 + countToFour] !== Tools.FloatRound(data[i])) {
                        changed = true;
                        if (this._createBufferOnWrite) {
                            this._createNewBuffer();
                        }
                        this._bufferData[location + baseStride * 4 + countToFour] = data[i];
                    }
                    countToFour++;
                    if (countToFour === arraySizes.strideSize) {
                        for (; countToFour < 4; countToFour++) {
                            this._bufferData[location + baseStride * 4 + countToFour] = 0;
                        }
                        countToFour = 0;
                        baseStride++;
                    }
                }
                this._needSync = this._needSync || changed;
            }
            else {
                // No cache for dynamic
                for (let i = 0; i < size; i++) {
                    this._bufferData[location + i] = data[i];
                }
            }
        }
        _cacheMatrix(name, matrix) {
            this._checkNewFrame();
            const cache = this._valueCache[name];
            const flag = matrix.updateFlag;
            if (cache !== undefined && cache === flag) {
                return false;
            }
            this._valueCache[name] = flag;
            return true;
        }
        // Update methods
        _updateMatrix3x3ForUniform(name, matrix) {
            // To match std140, matrix must be realigned
            for (let i = 0; i < 3; i++) {
                UniformBuffer._TempBuffer[i * 4] = matrix[i * 3];
                UniformBuffer._TempBuffer[i * 4 + 1] = matrix[i * 3 + 1];
                UniformBuffer._TempBuffer[i * 4 + 2] = matrix[i * 3 + 2];
                UniformBuffer._TempBuffer[i * 4 + 3] = 0.0;
            }
            this.updateUniform(name, UniformBuffer._TempBuffer, 12);
        }
        _updateMatrix3x3ForEffect(name, matrix) {
            this._currentEffect.setMatrix3x3(name, matrix);
        }
        _updateMatrix2x2ForEffect(name, matrix) {
            this._currentEffect.setMatrix2x2(name, matrix);
        }
        _updateMatrix2x2ForUniform(name, matrix) {
            // To match std140, matrix must be realigned
            for (let i = 0; i < 2; i++) {
                UniformBuffer._TempBuffer[i * 4] = matrix[i * 2];
                UniformBuffer._TempBuffer[i * 4 + 1] = matrix[i * 2 + 1];
                UniformBuffer._TempBuffer[i * 4 + 2] = 0.0;
                UniformBuffer._TempBuffer[i * 4 + 3] = 0.0;
            }
            this.updateUniform(name, UniformBuffer._TempBuffer, 8);
        }
        _updateFloatForEffect(name, x) {
            this._currentEffect.setFloat(name, x);
        }
        _updateFloatForUniform(name, x) {
            UniformBuffer._TempBuffer[0] = x;
            this.updateUniform(name, UniformBuffer._TempBuffer, 1);
        }
        _updateFloat2ForEffect(name, x, y, suffix = "") {
            this._currentEffect.setFloat2(name + suffix, x, y);
        }
        _updateFloat2ForUniform(name, x, y) {
            UniformBuffer._TempBuffer[0] = x;
            UniformBuffer._TempBuffer[1] = y;
            this.updateUniform(name, UniformBuffer._TempBuffer, 2);
        }
        _updateFloat3ForEffect(name, x, y, z, suffix = "") {
            this._currentEffect.setFloat3(name + suffix, x, y, z);
        }
        _updateFloat3ForUniform(name, x, y, z) {
            UniformBuffer._TempBuffer[0] = x;
            UniformBuffer._TempBuffer[1] = y;
            UniformBuffer._TempBuffer[2] = z;
            this.updateUniform(name, UniformBuffer._TempBuffer, 3);
        }
        _updateFloat4ForEffect(name, x, y, z, w, suffix = "") {
            this._currentEffect.setFloat4(name + suffix, x, y, z, w);
        }
        _updateFloat4ForUniform(name, x, y, z, w) {
            UniformBuffer._TempBuffer[0] = x;
            UniformBuffer._TempBuffer[1] = y;
            UniformBuffer._TempBuffer[2] = z;
            UniformBuffer._TempBuffer[3] = w;
            this.updateUniform(name, UniformBuffer._TempBuffer, 4);
        }
        _updateFloatArrayForEffect(name, array) {
            this._currentEffect.setFloatArray(name, array);
        }
        _updateFloatArrayForUniform(name, array) {
            this.updateUniformArray(name, array, array.length);
        }
        _updateArrayForEffect(name, array) {
            this._currentEffect.setArray(name, array);
        }
        _updateArrayForUniform(name, array) {
            this.updateUniformArray(name, array, array.length);
        }
        _updateIntArrayForEffect(name, array) {
            this._currentEffect.setIntArray(name, array);
        }
        _updateIntArrayForUniform(name, array) {
            UniformBuffer._TempBufferInt32View.set(array);
            this.updateUniformArray(name, UniformBuffer._TempBuffer, array.length);
        }
        _updateUIntArrayForEffect(name, array) {
            this._currentEffect.setUIntArray(name, array);
        }
        _updateUIntArrayForUniform(name, array) {
            UniformBuffer._TempBufferUInt32View.set(array);
            this.updateUniformArray(name, UniformBuffer._TempBuffer, array.length);
        }
        _updateMatrixForEffect(name, mat) {
            this._currentEffect.setMatrix(name, mat);
        }
        _updateMatrixForUniform(name, mat) {
            if (this._cacheMatrix(name, mat)) {
                this.updateUniform(name, mat.toArray(), 16);
            }
        }
        _updateMatricesForEffect(name, mat) {
            this._currentEffect.setMatrices(name, mat);
        }
        _updateMatricesForUniform(name, mat) {
            this.updateUniform(name, mat, mat.length);
        }
        _updateVector3ForEffect(name, vector) {
            this._currentEffect.setVector3(name, vector);
        }
        _updateVector3ForUniform(name, vector) {
            UniformBuffer._TempBuffer[0] = vector.x;
            UniformBuffer._TempBuffer[1] = vector.y;
            UniformBuffer._TempBuffer[2] = vector.z;
            this.updateUniform(name, UniformBuffer._TempBuffer, 3);
        }
        _updateVector4ForEffect(name, vector) {
            this._currentEffect.setVector4(name, vector);
        }
        _updateVector4ForUniform(name, vector) {
            UniformBuffer._TempBuffer[0] = vector.x;
            UniformBuffer._TempBuffer[1] = vector.y;
            UniformBuffer._TempBuffer[2] = vector.z;
            UniformBuffer._TempBuffer[3] = vector.w;
            this.updateUniform(name, UniformBuffer._TempBuffer, 4);
        }
        _updateColor3ForEffect(name, color, suffix = "") {
            this._currentEffect.setColor3(name + suffix, color);
        }
        _updateColor3ForUniform(name, color) {
            UniformBuffer._TempBuffer[0] = color.r;
            UniformBuffer._TempBuffer[1] = color.g;
            UniformBuffer._TempBuffer[2] = color.b;
            this.updateUniform(name, UniformBuffer._TempBuffer, 3);
        }
        _updateColor4ForEffect(name, color, alpha, suffix = "") {
            this._currentEffect.setColor4(name + suffix, color, alpha);
        }
        _updateDirectColor4ForEffect(name, color, suffix = "") {
            this._currentEffect.setDirectColor4(name + suffix, color);
        }
        _updateColor4ForUniform(name, color, alpha) {
            UniformBuffer._TempBuffer[0] = color.r;
            UniformBuffer._TempBuffer[1] = color.g;
            UniformBuffer._TempBuffer[2] = color.b;
            UniformBuffer._TempBuffer[3] = alpha;
            this.updateUniform(name, UniformBuffer._TempBuffer, 4);
        }
        _updateDirectColor4ForUniform(name, color) {
            UniformBuffer._TempBuffer[0] = color.r;
            UniformBuffer._TempBuffer[1] = color.g;
            UniformBuffer._TempBuffer[2] = color.b;
            UniformBuffer._TempBuffer[3] = color.a;
            this.updateUniform(name, UniformBuffer._TempBuffer, 4);
        }
        _updateIntForEffect(name, x, suffix = "") {
            this._currentEffect.setInt(name + suffix, x);
        }
        _updateIntForUniform(name, x) {
            UniformBuffer._TempBufferInt32View[0] = x;
            this.updateUniform(name, UniformBuffer._TempBuffer, 1);
        }
        _updateInt2ForEffect(name, x, y, suffix = "") {
            this._currentEffect.setInt2(name + suffix, x, y);
        }
        _updateInt2ForUniform(name, x, y) {
            UniformBuffer._TempBufferInt32View[0] = x;
            UniformBuffer._TempBufferInt32View[1] = y;
            this.updateUniform(name, UniformBuffer._TempBuffer, 2);
        }
        _updateInt3ForEffect(name, x, y, z, suffix = "") {
            this._currentEffect.setInt3(name + suffix, x, y, z);
        }
        _updateInt3ForUniform(name, x, y, z) {
            UniformBuffer._TempBufferInt32View[0] = x;
            UniformBuffer._TempBufferInt32View[1] = y;
            UniformBuffer._TempBufferInt32View[2] = z;
            this.updateUniform(name, UniformBuffer._TempBuffer, 3);
        }
        _updateInt4ForEffect(name, x, y, z, w, suffix = "") {
            this._currentEffect.setInt4(name + suffix, x, y, z, w);
        }
        _updateInt4ForUniform(name, x, y, z, w) {
            UniformBuffer._TempBufferInt32View[0] = x;
            UniformBuffer._TempBufferInt32View[1] = y;
            UniformBuffer._TempBufferInt32View[2] = z;
            UniformBuffer._TempBufferInt32View[3] = w;
            this.updateUniform(name, UniformBuffer._TempBuffer, 4);
        }
        _updateUIntForEffect(name, x, suffix = "") {
            this._currentEffect.setUInt(name + suffix, x);
        }
        _updateUIntForUniform(name, x) {
            UniformBuffer._TempBufferUInt32View[0] = x;
            this.updateUniform(name, UniformBuffer._TempBuffer, 1);
        }
        _updateUInt2ForEffect(name, x, y, suffix = "") {
            this._currentEffect.setUInt2(name + suffix, x, y);
        }
        _updateUInt2ForUniform(name, x, y) {
            UniformBuffer._TempBufferUInt32View[0] = x;
            UniformBuffer._TempBufferUInt32View[1] = y;
            this.updateUniform(name, UniformBuffer._TempBuffer, 2);
        }
        _updateUInt3ForEffect(name, x, y, z, suffix = "") {
            this._currentEffect.setUInt3(name + suffix, x, y, z);
        }
        _updateUInt3ForUniform(name, x, y, z) {
            UniformBuffer._TempBufferUInt32View[0] = x;
            UniformBuffer._TempBufferUInt32View[1] = y;
            UniformBuffer._TempBufferUInt32View[2] = z;
            this.updateUniform(name, UniformBuffer._TempBuffer, 3);
        }
        _updateUInt4ForEffect(name, x, y, z, w, suffix = "") {
            this._currentEffect.setUInt4(name + suffix, x, y, z, w);
        }
        _updateUInt4ForUniform(name, x, y, z, w) {
            UniformBuffer._TempBufferUInt32View[0] = x;
            UniformBuffer._TempBufferUInt32View[1] = y;
            UniformBuffer._TempBufferUInt32View[2] = z;
            UniformBuffer._TempBufferUInt32View[3] = w;
            this.updateUniform(name, UniformBuffer._TempBuffer, 4);
        }
        /**
         * Sets a sampler uniform on the effect.
         * @param name Define the name of the sampler.
         * @param texture Define the texture to set in the sampler
         */
        setTexture(name, texture) {
            this._currentEffect.setTexture(name, texture);
        }
        /**
         * Directly updates the value of the uniform in the cache AND on the GPU.
         * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
         * @param data Define the flattened data
         */
        updateUniformDirectly(uniformName, data) {
            this.updateUniform(uniformName, data, data.length);
            this.update();
        }
        /**
         * Associates an effect to this uniform buffer
         * @param effect Define the effect to associate the buffer to
         * @param name Name of the uniform block in the shader.
         */
        bindToEffect(effect, name) {
            this._currentEffect = effect;
            this._currentEffectName = name;
        }
        /**
         * Binds the current (GPU) buffer to the effect
         */
        bindUniformBuffer() {
            if (!this._noUBO && this._buffer && this._currentEffect) {
                this._currentEffect.bindUniformBuffer(this._buffer, this._currentEffectName);
            }
        }
        /**
         * Dissociates the current effect from this uniform buffer
         */
        unbindEffect() {
            this._currentEffect = undefined;
            this._currentEffectName = undefined;
        }
        /**
         * Sets the current state of the class (_bufferIndex, _buffer) to point to the data buffer passed in parameter if this buffer is one of the buffers handled by the class (meaning if it can be found in the _buffers array)
         * This method is meant to be able to update a buffer at any time: just call setDataBuffer to set the class in the right state, call some updateXXX methods and then call udpate() => that will update the GPU buffer on the graphic card
         * @param dataBuffer buffer to look for
         * @returns true if the buffer has been found and the class internal state points to it, else false
         */
        setDataBuffer(dataBuffer) {
            if (!this._buffers) {
                return this._buffer === dataBuffer;
            }
            for (let b = 0; b < this._buffers.length; ++b) {
                const buffer = this._buffers[b];
                if (buffer[0] === dataBuffer) {
                    this._bufferIndex = b;
                    this._buffer = dataBuffer;
                    this._createBufferOnWrite = false;
                    this._currentEffect = undefined;
                    return true;
                }
            }
            return false;
        }
        /**
         * Disposes the uniform buffer.
         */
        dispose() {
            if (this._noUBO) {
                return;
            }
            const uniformBuffers = this._engine._uniformBuffers;
            const index = uniformBuffers.indexOf(this);
            if (index !== -1) {
                uniformBuffers[index] = uniformBuffers[uniformBuffers.length - 1];
                uniformBuffers.pop();
            }
            if (this._engine._features.trackUbosInFrame && this._buffers) {
                for (let i = 0; i < this._buffers.length; ++i) {
                    const buffer = this._buffers[i][0];
                    this._engine._releaseBuffer(buffer);
                }
            }
            else if (this._buffer && this._engine._releaseBuffer(this._buffer)) {
                this._buffer = null;
            }
        }
    }
    /** @internal */
    UniformBuffer._UpdatedUbosInFrame = {};
    // Pool for avoiding memory leaks
    UniformBuffer._MAX_UNIFORM_SIZE = 256;
    UniformBuffer._TempBuffer = new Float32Array(UniformBuffer._MAX_UNIFORM_SIZE);
    UniformBuffer._TempBufferInt32View = new Int32Array(UniformBuffer._TempBuffer.buffer);
    UniformBuffer._TempBufferUInt32View = new Uint32Array(UniformBuffer._TempBuffer.buffer);

    /**
     * Class used to store data that will be store in GPU memory
     */
    class Buffer$1 {
        /**
         * Constructor
         * @param engine the engine
         * @param data the data to use for this buffer
         * @param updatable whether the data is updatable
         * @param stride the stride (optional)
         * @param postponeInternalCreation whether to postpone creating the internal WebGL buffer (optional)
         * @param instanced whether the buffer is instanced (optional)
         * @param useBytes set to true if the stride in in bytes (optional)
         * @param divisor sets an optional divisor for instances (1 by default)
         */
        constructor(engine, data, updatable, stride = 0, postponeInternalCreation = false, instanced = false, useBytes = false, divisor) {
            this._isAlreadyOwned = false;
            if (engine.getScene) {
                // old versions of VertexBuffer accepted 'mesh' instead of 'engine'
                this._engine = engine.getScene().getEngine();
            }
            else {
                this._engine = engine;
            }
            this._updatable = updatable;
            this._instanced = instanced;
            this._divisor = divisor || 1;
            if (data instanceof DataBuffer) {
                this._data = null;
                this._buffer = data;
            }
            else {
                this._data = data;
                this._buffer = null;
            }
            this.byteStride = useBytes ? stride : stride * Float32Array.BYTES_PER_ELEMENT;
            if (!postponeInternalCreation) {
                // by default
                this.create();
            }
        }
        /**
         * Create a new VertexBuffer based on the current buffer
         * @param kind defines the vertex buffer kind (position, normal, etc.)
         * @param offset defines offset in the buffer (0 by default)
         * @param size defines the size in floats of attributes (position is 3 for instance)
         * @param stride defines the stride size in floats in the buffer (the offset to apply to reach next value when data is interleaved)
         * @param instanced defines if the vertex buffer contains indexed data
         * @param useBytes defines if the offset and stride are in bytes     *
         * @param divisor sets an optional divisor for instances (1 by default)
         * @returns the new vertex buffer
         */
        createVertexBuffer(kind, offset, size, stride, instanced, useBytes = false, divisor) {
            const byteOffset = useBytes ? offset : offset * Float32Array.BYTES_PER_ELEMENT;
            const byteStride = stride ? (useBytes ? stride : stride * Float32Array.BYTES_PER_ELEMENT) : this.byteStride;
            // a lot of these parameters are ignored as they are overridden by the buffer
            return new VertexBuffer(this._engine, this, kind, this._updatable, true, byteStride, instanced === undefined ? this._instanced : instanced, byteOffset, size, undefined, undefined, true, this._divisor || divisor);
        }
        // Properties
        /**
         * Gets a boolean indicating if the Buffer is updatable?
         * @returns true if the buffer is updatable
         */
        isUpdatable() {
            return this._updatable;
        }
        /**
         * Gets current buffer's data
         * @returns a DataArray or null
         */
        getData() {
            return this._data;
        }
        /**
         * Gets underlying native buffer
         * @returns underlying native buffer
         */
        getBuffer() {
            return this._buffer;
        }
        /**
         * Gets the stride in float32 units (i.e. byte stride / 4).
         * May not be an integer if the byte stride is not divisible by 4.
         * @returns the stride in float32 units
         * @deprecated Please use byteStride instead.
         */
        getStrideSize() {
            return this.byteStride / Float32Array.BYTES_PER_ELEMENT;
        }
        // Methods
        /**
         * Store data into the buffer. Creates the buffer if not used already.
         * If the buffer was already used, it will be updated only if it is updatable, otherwise it will do nothing.
         * @param data defines the data to store
         */
        create(data = null) {
            if (!data && this._buffer) {
                return; // nothing to do
            }
            data = data || this._data;
            if (!data) {
                return;
            }
            if (!this._buffer) {
                // create buffer
                if (this._updatable) {
                    this._buffer = this._engine.createDynamicVertexBuffer(data);
                    this._data = data;
                }
                else {
                    this._buffer = this._engine.createVertexBuffer(data);
                }
            }
            else if (this._updatable) {
                // update buffer
                this._engine.updateDynamicVertexBuffer(this._buffer, data);
                this._data = data;
            }
        }
        /** @internal */
        _rebuild() {
            this._buffer = null;
            this.create(this._data);
        }
        /**
         * Update current buffer data
         * @param data defines the data to store
         */
        update(data) {
            this.create(data);
        }
        /**
         * Updates the data directly.
         * @param data the new data
         * @param offset the new offset
         * @param vertexCount the vertex count (optional)
         * @param useBytes set to true if the offset is in bytes
         */
        updateDirectly(data, offset, vertexCount, useBytes = false) {
            if (!this._buffer) {
                return;
            }
            if (this._updatable) {
                // update buffer
                this._engine.updateDynamicVertexBuffer(this._buffer, data, useBytes ? offset : offset * Float32Array.BYTES_PER_ELEMENT, vertexCount ? vertexCount * this.byteStride : undefined);
                if (offset === 0 && vertexCount === undefined) {
                    // Keep the data if we easily can
                    this._data = data;
                }
                else {
                    this._data = null;
                }
            }
        }
        /** @internal */
        _increaseReferences() {
            if (!this._buffer) {
                return;
            }
            if (!this._isAlreadyOwned) {
                this._isAlreadyOwned = true;
                return;
            }
            this._buffer.references++;
        }
        /**
         * Release all resources
         */
        dispose() {
            if (!this._buffer) {
                return;
            }
            if (this._engine._releaseBuffer(this._buffer)) {
                this._buffer = null;
                this._data = null;
            }
        }
    }
    /**
     * Specialized buffer used to store vertex data
     */
    class VertexBuffer {
        /**
         * Gets or sets the instance divisor when in instanced mode
         */
        get instanceDivisor() {
            return this._instanceDivisor;
        }
        set instanceDivisor(value) {
            const isInstanced = value != 0;
            this._instanceDivisor = value;
            if (isInstanced !== this._instanced) {
                this._instanced = isInstanced;
                this._computeHashCode();
            }
        }
        /**
         * Constructor
         * @param engine the engine
         * @param data the data to use for this vertex buffer
         * @param kind the vertex buffer kind
         * @param updatable whether the data is updatable
         * @param postponeInternalCreation whether to postpone creating the internal WebGL buffer (optional)
         * @param stride the stride (optional)
         * @param instanced whether the buffer is instanced (optional)
         * @param offset the offset of the data (optional)
         * @param size the number of components (optional)
         * @param type the type of the component (optional)
         * @param normalized whether the data contains normalized data (optional)
         * @param useBytes set to true if stride and offset are in bytes (optional)
         * @param divisor defines the instance divisor to use (1 by default)
         * @param takeBufferOwnership defines if the buffer should be released when the vertex buffer is disposed
         */
        constructor(engine, data, kind, updatable, postponeInternalCreation, stride, instanced, offset, size, type, normalized = false, useBytes = false, divisor = 1, takeBufferOwnership = false) {
            if (data instanceof Buffer$1) {
                this._buffer = data;
                this._ownsBuffer = takeBufferOwnership;
            }
            else {
                this._buffer = new Buffer$1(engine, data, updatable, stride, postponeInternalCreation, instanced, useBytes);
                this._ownsBuffer = true;
            }
            this.uniqueId = VertexBuffer._Counter++;
            this._kind = kind;
            if (type == undefined) {
                const vertexData = this.getData();
                this.type = VertexBuffer.FLOAT;
                if (vertexData instanceof Int8Array) {
                    this.type = VertexBuffer.BYTE;
                }
                else if (vertexData instanceof Uint8Array) {
                    this.type = VertexBuffer.UNSIGNED_BYTE;
                }
                else if (vertexData instanceof Int16Array) {
                    this.type = VertexBuffer.SHORT;
                }
                else if (vertexData instanceof Uint16Array) {
                    this.type = VertexBuffer.UNSIGNED_SHORT;
                }
                else if (vertexData instanceof Int32Array) {
                    this.type = VertexBuffer.INT;
                }
                else if (vertexData instanceof Uint32Array) {
                    this.type = VertexBuffer.UNSIGNED_INT;
                }
            }
            else {
                this.type = type;
            }
            const typeByteLength = VertexBuffer.GetTypeByteLength(this.type);
            if (useBytes) {
                this._size = size || (stride ? stride / typeByteLength : VertexBuffer.DeduceStride(kind));
                this.byteStride = stride || this._buffer.byteStride || this._size * typeByteLength;
                this.byteOffset = offset || 0;
            }
            else {
                this._size = size || stride || VertexBuffer.DeduceStride(kind);
                this.byteStride = stride ? stride * typeByteLength : this._buffer.byteStride || this._size * typeByteLength;
                this.byteOffset = (offset || 0) * typeByteLength;
            }
            this.normalized = normalized;
            this._instanced = instanced !== undefined ? instanced : false;
            this._instanceDivisor = instanced ? divisor : 0;
            this._computeHashCode();
        }
        _computeHashCode() {
            // note: cast to any because the property is declared readonly
            this.hashCode =
                ((this.type - 5120) << 0) +
                    ((this.normalized ? 1 : 0) << 3) +
                    (this._size << 4) +
                    ((this._instanced ? 1 : 0) << 6) +
                    /* keep 5 bits free */
                    (this.byteStride << 12);
        }
        /** @internal */
        _rebuild() {
            if (!this._buffer) {
                return;
            }
            this._buffer._rebuild();
        }
        /**
         * Returns the kind of the VertexBuffer (string)
         * @returns a string
         */
        getKind() {
            return this._kind;
        }
        // Properties
        /**
         * Gets a boolean indicating if the VertexBuffer is updatable?
         * @returns true if the buffer is updatable
         */
        isUpdatable() {
            return this._buffer.isUpdatable();
        }
        /**
         * Gets current buffer's data
         * @returns a DataArray or null
         */
        getData() {
            return this._buffer.getData();
        }
        /**
         * Gets current buffer's data as a float array. Float data is constructed if the vertex buffer data cannot be returned directly.
         * @param totalVertices number of vertices in the buffer to take into account
         * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
         * @returns a float array containing vertex data
         */
        getFloatData(totalVertices, forceCopy) {
            const data = this.getData();
            if (!data) {
                return null;
            }
            const tightlyPackedByteStride = this.getSize() * VertexBuffer.GetTypeByteLength(this.type);
            const count = totalVertices * this.getSize();
            if (this.type !== VertexBuffer.FLOAT || this.byteStride !== tightlyPackedByteStride) {
                const copy = new Float32Array(count);
                this.forEach(count, (value, index) => (copy[index] = value));
                return copy;
            }
            if (!(data instanceof Array || data instanceof Float32Array) || this.byteOffset !== 0 || data.length !== count) {
                if (data instanceof Array) {
                    const offset = this.byteOffset / 4;
                    return data.slice(offset, offset + count);
                }
                else if (data instanceof ArrayBuffer) {
                    return new Float32Array(data, this.byteOffset, count);
                }
                else {
                    let offset = data.byteOffset + this.byteOffset;
                    if (forceCopy) {
                        const result = new Float32Array(count);
                        const source = new Float32Array(data.buffer, offset, count);
                        result.set(source);
                        return result;
                    }
                    // Protect against bad data
                    const remainder = offset % 4;
                    if (remainder) {
                        offset = Math.max(0, offset - remainder);
                    }
                    return new Float32Array(data.buffer, offset, count);
                }
            }
            if (forceCopy) {
                return data.slice();
            }
            return data;
        }
        /**
         * Gets underlying native buffer
         * @returns underlying native buffer
         */
        getBuffer() {
            return this._buffer.getBuffer();
        }
        /**
         * Gets the stride in float32 units (i.e. byte stride / 4).
         * May not be an integer if the byte stride is not divisible by 4.
         * @returns the stride in float32 units
         * @deprecated Please use byteStride instead.
         */
        getStrideSize() {
            return this.byteStride / VertexBuffer.GetTypeByteLength(this.type);
        }
        /**
         * Returns the offset as a multiple of the type byte length.
         * @returns the offset in bytes
         * @deprecated Please use byteOffset instead.
         */
        getOffset() {
            return this.byteOffset / VertexBuffer.GetTypeByteLength(this.type);
        }
        /**
         * Returns the number of components or the byte size per vertex attribute
         * @param sizeInBytes If true, returns the size in bytes or else the size in number of components of the vertex attribute (default: false)
         * @returns the number of components
         */
        getSize(sizeInBytes = false) {
            return sizeInBytes ? this._size * VertexBuffer.GetTypeByteLength(this.type) : this._size;
        }
        /**
         * Gets a boolean indicating is the internal buffer of the VertexBuffer is instanced
         * @returns true if this buffer is instanced
         */
        getIsInstanced() {
            return this._instanced;
        }
        /**
         * Returns the instancing divisor, zero for non-instanced (integer).
         * @returns a number
         */
        getInstanceDivisor() {
            return this._instanceDivisor;
        }
        // Methods
        /**
         * Store data into the buffer. If the buffer was already used it will be either recreated or updated depending on isUpdatable property
         * @param data defines the data to store
         */
        create(data) {
            this._buffer.create(data);
        }
        /**
         * Updates the underlying buffer according to the passed numeric array or Float32Array.
         * This function will create a new buffer if the current one is not updatable
         * @param data defines the data to store
         */
        update(data) {
            this._buffer.update(data);
        }
        /**
         * Updates directly the underlying WebGLBuffer according to the passed numeric array or Float32Array.
         * Returns the directly updated WebGLBuffer.
         * @param data the new data
         * @param offset the new offset
         * @param useBytes set to true if the offset is in bytes
         */
        updateDirectly(data, offset, useBytes = false) {
            this._buffer.updateDirectly(data, offset, undefined, useBytes);
        }
        /**
         * Disposes the VertexBuffer and the underlying WebGLBuffer.
         */
        dispose() {
            if (this._ownsBuffer) {
                this._buffer.dispose();
            }
        }
        /**
         * Enumerates each value of this vertex buffer as numbers.
         * @param count the number of values to enumerate
         * @param callback the callback function called for each value
         */
        forEach(count, callback) {
            VertexBuffer.ForEach(this._buffer.getData(), this.byteOffset, this.byteStride, this._size, this.type, count, this.normalized, callback);
        }
        /**
         * Deduces the stride given a kind.
         * @param kind The kind string to deduce
         * @returns The deduced stride
         */
        static DeduceStride(kind) {
            switch (kind) {
                case VertexBuffer.UVKind:
                case VertexBuffer.UV2Kind:
                case VertexBuffer.UV3Kind:
                case VertexBuffer.UV4Kind:
                case VertexBuffer.UV5Kind:
                case VertexBuffer.UV6Kind:
                    return 2;
                case VertexBuffer.NormalKind:
                case VertexBuffer.PositionKind:
                    return 3;
                case VertexBuffer.ColorKind:
                case VertexBuffer.MatricesIndicesKind:
                case VertexBuffer.MatricesIndicesExtraKind:
                case VertexBuffer.MatricesWeightsKind:
                case VertexBuffer.MatricesWeightsExtraKind:
                case VertexBuffer.TangentKind:
                    return 4;
                default:
                    throw new Error("Invalid kind '" + kind + "'");
            }
        }
        /**
         * Gets the byte length of the given type.
         * @param type the type
         * @returns the number of bytes
         */
        static GetTypeByteLength(type) {
            switch (type) {
                case VertexBuffer.BYTE:
                case VertexBuffer.UNSIGNED_BYTE:
                    return 1;
                case VertexBuffer.SHORT:
                case VertexBuffer.UNSIGNED_SHORT:
                    return 2;
                case VertexBuffer.INT:
                case VertexBuffer.UNSIGNED_INT:
                case VertexBuffer.FLOAT:
                    return 4;
                default:
                    throw new Error(`Invalid type '${type}'`);
            }
        }
        /**
         * Enumerates each value of the given parameters as numbers.
         * @param data the data to enumerate
         * @param byteOffset the byte offset of the data
         * @param byteStride the byte stride of the data
         * @param componentCount the number of components per element
         * @param componentType the type of the component
         * @param count the number of values to enumerate
         * @param normalized whether the data is normalized
         * @param callback the callback function called for each value
         */
        static ForEach(data, byteOffset, byteStride, componentCount, componentType, count, normalized, callback) {
            if (data instanceof Array) {
                let offset = byteOffset / 4;
                const stride = byteStride / 4;
                for (let index = 0; index < count; index += componentCount) {
                    for (let componentIndex = 0; componentIndex < componentCount; componentIndex++) {
                        callback(data[offset + componentIndex], index + componentIndex);
                    }
                    offset += stride;
                }
            }
            else {
                const dataView = data instanceof ArrayBuffer ? new DataView(data) : new DataView(data.buffer, data.byteOffset, data.byteLength);
                const componentByteLength = VertexBuffer.GetTypeByteLength(componentType);
                for (let index = 0; index < count; index += componentCount) {
                    let componentByteOffset = byteOffset;
                    for (let componentIndex = 0; componentIndex < componentCount; componentIndex++) {
                        const value = VertexBuffer._GetFloatValue(dataView, componentType, componentByteOffset, normalized);
                        callback(value, index + componentIndex);
                        componentByteOffset += componentByteLength;
                    }
                    byteOffset += byteStride;
                }
            }
        }
        static _GetFloatValue(dataView, type, byteOffset, normalized) {
            switch (type) {
                case VertexBuffer.BYTE: {
                    let value = dataView.getInt8(byteOffset);
                    if (normalized) {
                        value = Math.max(value / 127, -1);
                    }
                    return value;
                }
                case VertexBuffer.UNSIGNED_BYTE: {
                    let value = dataView.getUint8(byteOffset);
                    if (normalized) {
                        value = value / 255;
                    }
                    return value;
                }
                case VertexBuffer.SHORT: {
                    let value = dataView.getInt16(byteOffset, true);
                    if (normalized) {
                        value = Math.max(value / 32767, -1);
                    }
                    return value;
                }
                case VertexBuffer.UNSIGNED_SHORT: {
                    let value = dataView.getUint16(byteOffset, true);
                    if (normalized) {
                        value = value / 65535;
                    }
                    return value;
                }
                case VertexBuffer.INT: {
                    return dataView.getInt32(byteOffset, true);
                }
                case VertexBuffer.UNSIGNED_INT: {
                    return dataView.getUint32(byteOffset, true);
                }
                case VertexBuffer.FLOAT: {
                    return dataView.getFloat32(byteOffset, true);
                }
                default: {
                    throw new Error(`Invalid component type ${type}`);
                }
            }
        }
    }
    VertexBuffer._Counter = 0;
    /**
     * The byte type.
     */
    VertexBuffer.BYTE = 5120;
    /**
     * The unsigned byte type.
     */
    VertexBuffer.UNSIGNED_BYTE = 5121;
    /**
     * The short type.
     */
    VertexBuffer.SHORT = 5122;
    /**
     * The unsigned short type.
     */
    VertexBuffer.UNSIGNED_SHORT = 5123;
    /**
     * The integer type.
     */
    VertexBuffer.INT = 5124;
    /**
     * The unsigned integer type.
     */
    VertexBuffer.UNSIGNED_INT = 5125;
    /**
     * The float type.
     */
    VertexBuffer.FLOAT = 5126;
    // Enums
    /**
     * Positions
     */
    VertexBuffer.PositionKind = "position";
    /**
     * Normals
     */
    VertexBuffer.NormalKind = "normal";
    /**
     * Tangents
     */
    VertexBuffer.TangentKind = "tangent";
    /**
     * Texture coordinates
     */
    VertexBuffer.UVKind = "uv";
    /**
     * Texture coordinates 2
     */
    VertexBuffer.UV2Kind = "uv2";
    /**
     * Texture coordinates 3
     */
    VertexBuffer.UV3Kind = "uv3";
    /**
     * Texture coordinates 4
     */
    VertexBuffer.UV4Kind = "uv4";
    /**
     * Texture coordinates 5
     */
    VertexBuffer.UV5Kind = "uv5";
    /**
     * Texture coordinates 6
     */
    VertexBuffer.UV6Kind = "uv6";
    /**
     * Colors
     */
    VertexBuffer.ColorKind = "color";
    /**
     * Instance Colors
     */
    VertexBuffer.ColorInstanceKind = "instanceColor";
    /**
     * Matrix indices (for bones)
     */
    VertexBuffer.MatricesIndicesKind = "matricesIndices";
    /**
     * Matrix weights (for bones)
     */
    VertexBuffer.MatricesWeightsKind = "matricesWeights";
    /**
     * Additional matrix indices (for bones)
     */
    VertexBuffer.MatricesIndicesExtraKind = "matricesIndicesExtra";
    /**
     * Additional matrix weights (for bones)
     */
    VertexBuffer.MatricesWeightsExtraKind = "matricesWeightsExtra";

    /**
     * Information about the result of picking within a scene
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/picking_collisions
     */
    class PickingInfo {
        constructor() {
            /**
             * If the pick collided with an object
             */
            this.hit = false;
            /**
             * Distance away where the pick collided
             */
            this.distance = 0;
            /**
             * The location of pick collision
             */
            this.pickedPoint = null;
            /**
             * The mesh corresponding the pick collision
             */
            this.pickedMesh = null;
            /** (See getTextureCoordinates) The barycentric U coordinate that is used when calculating the texture coordinates of the collision.*/
            this.bu = 0;
            /** (See getTextureCoordinates) The barycentric V coordinate that is used when calculating the texture coordinates of the collision.*/
            this.bv = 0;
            /** The index of the face on the mesh that was picked, or the index of the Line if the picked Mesh is a LinesMesh */
            this.faceId = -1;
            /** The index of the face on the subMesh that was picked, or the index of the Line if the picked Mesh is a LinesMesh */
            this.subMeshFaceId = -1;
            /** Id of the submesh that was picked */
            this.subMeshId = 0;
            /** If a sprite was picked, this will be the sprite the pick collided with */
            this.pickedSprite = null;
            /** If we are picking a mesh with thin instance, this will give you the picked thin instance */
            this.thinInstanceIndex = -1;
            /**
             * The ray that was used to perform the picking.
             */
            this.ray = null;
            /**
             * If a mesh was used to do the picking (eg. 6dof controller) as a "near interaction", this will be populated.
             */
            this.originMesh = null;
            /**
             * The aim-space transform of the input used for picking, if it is an XR input source.
             */
            this.aimTransform = null;
            /**
             * The grip-space transform of the input used for picking, if it is an XR input source.
             * Some XR sources, such as input coming from head mounted displays, do not have this.
             */
            this.gripTransform = null;
        }
        /**
         * Gets the normal corresponding to the face the pick collided with
         * @param useWorldCoordinates If the resulting normal should be relative to the world (default: false)
         * @param useVerticesNormals If the vertices normals should be used to calculate the normal instead of the normal map (default: true)
         * @returns The normal corresponding to the face the pick collided with
         * @remarks Note that the returned normal will always point towards the picking ray.
         */
        getNormal(useWorldCoordinates = false, useVerticesNormals = true) {
            if (!this.pickedMesh || (useVerticesNormals && !this.pickedMesh.isVerticesDataPresent(VertexBuffer.NormalKind))) {
                return null;
            }
            let indices = this.pickedMesh.getIndices();
            if ((indices === null || indices === void 0 ? void 0 : indices.length) === 0) {
                indices = null;
            }
            let result;
            const tmp0 = TmpVectors.Vector3[0];
            const tmp1 = TmpVectors.Vector3[1];
            const tmp2 = TmpVectors.Vector3[2];
            if (useVerticesNormals) {
                const normals = this.pickedMesh.getVerticesData(VertexBuffer.NormalKind);
                let normal0 = indices
                    ? Vector3.FromArrayToRef(normals, indices[this.faceId * 3] * 3, tmp0)
                    : tmp0.copyFromFloats(normals[this.faceId * 3 * 3], normals[this.faceId * 3 * 3 + 1], normals[this.faceId * 3 * 3 + 2]);
                let normal1 = indices
                    ? Vector3.FromArrayToRef(normals, indices[this.faceId * 3 + 1] * 3, tmp1)
                    : tmp1.copyFromFloats(normals[(this.faceId * 3 + 1) * 3], normals[(this.faceId * 3 + 1) * 3 + 1], normals[(this.faceId * 3 + 1) * 3 + 2]);
                let normal2 = indices
                    ? Vector3.FromArrayToRef(normals, indices[this.faceId * 3 + 2] * 3, tmp2)
                    : tmp2.copyFromFloats(normals[(this.faceId * 3 + 2) * 3], normals[(this.faceId * 3 + 2) * 3 + 1], normals[(this.faceId * 3 + 2) * 3 + 2]);
                normal0 = normal0.scale(this.bu);
                normal1 = normal1.scale(this.bv);
                normal2 = normal2.scale(1.0 - this.bu - this.bv);
                result = new Vector3(normal0.x + normal1.x + normal2.x, normal0.y + normal1.y + normal2.y, normal0.z + normal1.z + normal2.z);
            }
            else {
                const positions = this.pickedMesh.getVerticesData(VertexBuffer.PositionKind);
                const vertex1 = indices
                    ? Vector3.FromArrayToRef(positions, indices[this.faceId * 3] * 3, tmp0)
                    : tmp0.copyFromFloats(positions[this.faceId * 3 * 3], positions[this.faceId * 3 * 3 + 1], positions[this.faceId * 3 * 3 + 2]);
                const vertex2 = indices
                    ? Vector3.FromArrayToRef(positions, indices[this.faceId * 3 + 1] * 3, tmp1)
                    : tmp1.copyFromFloats(positions[(this.faceId * 3 + 1) * 3], positions[(this.faceId * 3 + 1) * 3 + 1], positions[(this.faceId * 3 + 1) * 3 + 2]);
                const vertex3 = indices
                    ? Vector3.FromArrayToRef(positions, indices[this.faceId * 3 + 2] * 3, tmp2)
                    : tmp2.copyFromFloats(positions[(this.faceId * 3 + 2) * 3], positions[(this.faceId * 3 + 2) * 3 + 1], positions[(this.faceId * 3 + 2) * 3 + 2]);
                const p1p2 = vertex1.subtract(vertex2);
                const p3p2 = vertex3.subtract(vertex2);
                result = Vector3.Cross(p1p2, p3p2);
            }
            const transformNormalToWorld = (pickedMesh, n) => {
                let wm = pickedMesh.getWorldMatrix();
                if (pickedMesh.nonUniformScaling) {
                    TmpVectors.Matrix[0].copyFrom(wm);
                    wm = TmpVectors.Matrix[0];
                    wm.setTranslationFromFloats(0, 0, 0);
                    wm.invert();
                    wm.transposeToRef(TmpVectors.Matrix[1]);
                    wm = TmpVectors.Matrix[1];
                }
                Vector3.TransformNormalToRef(n, wm, n);
            };
            if (useWorldCoordinates) {
                transformNormalToWorld(this.pickedMesh, result);
            }
            if (this.ray) {
                const normalForDirectionChecking = TmpVectors.Vector3[0].copyFrom(result);
                if (!useWorldCoordinates) {
                    // the normal has not been transformed to world space as part as the normal processing, so we must do it now
                    transformNormalToWorld(this.pickedMesh, normalForDirectionChecking);
                }
                // Flip the normal if the picking ray is in the same direction.
                if (Vector3.Dot(normalForDirectionChecking, this.ray.direction) > 0) {
                    result.negateInPlace();
                }
            }
            result.normalize();
            return result;
        }
        /**
         * Gets the texture coordinates of where the pick occurred
         * @param uvSet The UV set to use to calculate the texture coordinates (default: VertexBuffer.UVKind)
         * @returns The vector containing the coordinates of the texture
         */
        getTextureCoordinates(uvSet = VertexBuffer.UVKind) {
            if (!this.pickedMesh || !this.pickedMesh.isVerticesDataPresent(uvSet)) {
                return null;
            }
            const indices = this.pickedMesh.getIndices();
            if (!indices) {
                return null;
            }
            const uvs = this.pickedMesh.getVerticesData(uvSet);
            if (!uvs) {
                return null;
            }
            let uv0 = Vector2.FromArray(uvs, indices[this.faceId * 3] * 2);
            let uv1 = Vector2.FromArray(uvs, indices[this.faceId * 3 + 1] * 2);
            let uv2 = Vector2.FromArray(uvs, indices[this.faceId * 3 + 2] * 2);
            uv0 = uv0.scale(this.bu);
            uv1 = uv1.scale(this.bv);
            uv2 = uv2.scale(1.0 - this.bu - this.bv);
            return new Vector2(uv0.x + uv1.x + uv2.x, uv0.y + uv1.y + uv2.y);
        }
    }

    /**
     * ActionEvent is the event being sent when an action is triggered.
     */
    class ActionEvent {
        /**
         * Creates a new ActionEvent
         * @param source The mesh or sprite that triggered the action
         * @param pointerX The X mouse cursor position at the time of the event
         * @param pointerY The Y mouse cursor position at the time of the event
         * @param meshUnderPointer The mesh that is currently pointed at (can be null)
         * @param sourceEvent the original (browser) event that triggered the ActionEvent
         * @param additionalData additional data for the event
         */
        constructor(
        /** The mesh or sprite that triggered the action */
        source, 
        /** The X mouse cursor position at the time of the event */
        pointerX, 
        /** The Y mouse cursor position at the time of the event */
        pointerY, 
        /** The mesh that is currently pointed at (can be null) */
        meshUnderPointer, 
        /** the original (browser) event that triggered the ActionEvent */
        sourceEvent, 
        /** additional data for the event */
        additionalData) {
            this.source = source;
            this.pointerX = pointerX;
            this.pointerY = pointerY;
            this.meshUnderPointer = meshUnderPointer;
            this.sourceEvent = sourceEvent;
            this.additionalData = additionalData;
        }
        /**
         * Helper function to auto-create an ActionEvent from a source mesh.
         * @param source The source mesh that triggered the event
         * @param evt The original (browser) event
         * @param additionalData additional data for the event
         * @returns the new ActionEvent
         */
        static CreateNew(source, evt, additionalData) {
            const scene = source.getScene();
            return new ActionEvent(source, scene.pointerX, scene.pointerY, scene.meshUnderPointer || source, evt, additionalData);
        }
        /**
         * Helper function to auto-create an ActionEvent from a source sprite
         * @param source The source sprite that triggered the event
         * @param scene Scene associated with the sprite
         * @param evt The original (browser) event
         * @param additionalData additional data for the event
         * @returns the new ActionEvent
         */
        static CreateNewFromSprite(source, scene, evt, additionalData) {
            return new ActionEvent(source, scene.pointerX, scene.pointerY, scene.meshUnderPointer, evt, additionalData);
        }
        /**
         * Helper function to auto-create an ActionEvent from a scene. If triggered by a mesh use ActionEvent.CreateNew
         * @param scene the scene where the event occurred
         * @param evt The original (browser) event
         * @returns the new ActionEvent
         */
        static CreateNewFromScene(scene, evt) {
            return new ActionEvent(null, scene.pointerX, scene.pointerY, scene.meshUnderPointer, evt);
        }
        /**
         * Helper function to auto-create an ActionEvent from a primitive
         * @param prim defines the target primitive
         * @param pointerPos defines the pointer position
         * @param evt The original (browser) event
         * @param additionalData additional data for the event
         * @returns the new ActionEvent
         */
        static CreateNewFromPrimitive(prim, pointerPos, evt, additionalData) {
            return new ActionEvent(prim, pointerPos.x, pointerPos.y, null, evt, additionalData);
        }
    }

    /**
     * PostProcessManager is used to manage one or more post processes or post process pipelines
     * See https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses
     */
    class PostProcessManager {
        /**
         * Creates a new instance PostProcess
         * @param scene The scene that the post process is associated with.
         */
        constructor(scene) {
            this._vertexBuffers = {};
            this._scene = scene;
        }
        _prepareBuffers() {
            if (this._vertexBuffers[VertexBuffer.PositionKind]) {
                return;
            }
            // VBO
            const vertices = [];
            vertices.push(1, 1);
            vertices.push(-1, 1);
            vertices.push(-1, -1);
            vertices.push(1, -1);
            this._vertexBuffers[VertexBuffer.PositionKind] = new VertexBuffer(this._scene.getEngine(), vertices, VertexBuffer.PositionKind, false, false, 2);
            this._buildIndexBuffer();
        }
        _buildIndexBuffer() {
            // Indices
            const indices = [];
            indices.push(0);
            indices.push(1);
            indices.push(2);
            indices.push(0);
            indices.push(2);
            indices.push(3);
            this._indexBuffer = this._scene.getEngine().createIndexBuffer(indices);
        }
        /**
         * Rebuilds the vertex buffers of the manager.
         * @internal
         */
        _rebuild() {
            const vb = this._vertexBuffers[VertexBuffer.PositionKind];
            if (!vb) {
                return;
            }
            vb._rebuild();
            this._buildIndexBuffer();
        }
        // Methods
        /**
         * Prepares a frame to be run through a post process.
         * @param sourceTexture The input texture to the post processes. (default: null)
         * @param postProcesses An array of post processes to be run. (default: null)
         * @returns True if the post processes were able to be run.
         * @internal
         */
        _prepareFrame(sourceTexture = null, postProcesses = null) {
            const camera = this._scene.activeCamera;
            if (!camera) {
                return false;
            }
            postProcesses = postProcesses || camera._postProcesses.filter((pp) => {
                return pp != null;
            });
            if (!postProcesses || postProcesses.length === 0 || !this._scene.postProcessesEnabled) {
                return false;
            }
            postProcesses[0].activate(camera, sourceTexture, postProcesses !== null && postProcesses !== undefined);
            return true;
        }
        /**
         * Manually render a set of post processes to a texture.
         * Please note, the frame buffer won't be unbound after the call in case you have more render to do.
         * @param postProcesses An array of post processes to be run.
         * @param targetTexture The render target wrapper to render to.
         * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight
         * @param faceIndex defines the face to render to if a cubemap is defined as the target
         * @param lodLevel defines which lod of the texture to render to
         * @param doNotBindFrambuffer If set to true, assumes that the framebuffer has been bound previously
         */
        directRender(postProcesses, targetTexture = null, forceFullscreenViewport = false, faceIndex = 0, lodLevel = 0, doNotBindFrambuffer = false) {
            var _a;
            const engine = this._scene.getEngine();
            for (let index = 0; index < postProcesses.length; index++) {
                if (index < postProcesses.length - 1) {
                    postProcesses[index + 1].activate(this._scene.activeCamera, targetTexture === null || targetTexture === void 0 ? void 0 : targetTexture.texture);
                }
                else {
                    if (targetTexture) {
                        engine.bindFramebuffer(targetTexture, faceIndex, undefined, undefined, forceFullscreenViewport, lodLevel);
                    }
                    else if (!doNotBindFrambuffer) {
                        engine.restoreDefaultFramebuffer();
                    }
                    (_a = engine._debugInsertMarker) === null || _a === void 0 ? void 0 : _a.call(engine, `post process ${postProcesses[index].name} output`);
                }
                const pp = postProcesses[index];
                const effect = pp.apply();
                if (effect) {
                    pp.onBeforeRenderObservable.notifyObservers(effect);
                    // VBOs
                    this._prepareBuffers();
                    engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
                    // Draw order
                    engine.drawElementsType(0, 0, 6);
                    pp.onAfterRenderObservable.notifyObservers(effect);
                }
            }
            // Restore depth buffer
            engine.setDepthBuffer(true);
            engine.setDepthWrite(true);
        }
        /**
         * Finalize the result of the output of the postprocesses.
         * @param doNotPresent If true the result will not be displayed to the screen.
         * @param targetTexture The render target wrapper to render to.
         * @param faceIndex The index of the face to bind the target texture to.
         * @param postProcesses The array of post processes to render.
         * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight (default: false)
         * @internal
         */
        _finalizeFrame(doNotPresent, targetTexture, faceIndex, postProcesses, forceFullscreenViewport = false) {
            var _a;
            const camera = this._scene.activeCamera;
            if (!camera) {
                return;
            }
            postProcesses = postProcesses || camera._postProcesses.filter((pp) => {
                return pp != null;
            });
            if (postProcesses.length === 0 || !this._scene.postProcessesEnabled) {
                return;
            }
            const engine = this._scene.getEngine();
            for (let index = 0, len = postProcesses.length; index < len; index++) {
                const pp = postProcesses[index];
                if (index < len - 1) {
                    pp._outputTexture = postProcesses[index + 1].activate(camera, targetTexture === null || targetTexture === void 0 ? void 0 : targetTexture.texture);
                }
                else {
                    if (targetTexture) {
                        engine.bindFramebuffer(targetTexture, faceIndex, undefined, undefined, forceFullscreenViewport);
                        pp._outputTexture = targetTexture;
                    }
                    else {
                        engine.restoreDefaultFramebuffer();
                        pp._outputTexture = null;
                    }
                    (_a = engine._debugInsertMarker) === null || _a === void 0 ? void 0 : _a.call(engine, `post process ${postProcesses[index].name} output`);
                }
                if (doNotPresent) {
                    break;
                }
                const effect = pp.apply();
                if (effect) {
                    pp.onBeforeRenderObservable.notifyObservers(effect);
                    // VBOs
                    this._prepareBuffers();
                    engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
                    // Draw order
                    engine.drawElementsType(0, 0, 6);
                    pp.onAfterRenderObservable.notifyObservers(effect);
                }
            }
            // Restore states
            engine.setDepthBuffer(true);
            engine.setDepthWrite(true);
            engine.setAlphaMode(0);
        }
        /**
         * Disposes of the post process manager.
         */
        dispose() {
            const buffer = this._vertexBuffers[VertexBuffer.PositionKind];
            if (buffer) {
                buffer.dispose();
                this._vertexBuffers[VertexBuffer.PositionKind] = null;
            }
            if (this._indexBuffer) {
                this._scene.getEngine()._releaseBuffer(this._indexBuffer);
                this._indexBuffer = null;
            }
        }
    }

    /**
     * This represents the object necessary to create a rendering group.
     * This is exclusively used and created by the rendering manager.
     * To modify the behavior, you use the available helpers in your scene or meshes.
     * @internal
     */
    class RenderingGroup {
        /**
         * Set the opaque sort comparison function.
         * If null the sub meshes will be render in the order they were created
         */
        set opaqueSortCompareFn(value) {
            if (value) {
                this._opaqueSortCompareFn = value;
            }
            else {
                this._opaqueSortCompareFn = RenderingGroup.PainterSortCompare;
            }
            this._renderOpaque = this._renderOpaqueSorted;
        }
        /**
         * Set the alpha test sort comparison function.
         * If null the sub meshes will be render in the order they were created
         */
        set alphaTestSortCompareFn(value) {
            if (value) {
                this._alphaTestSortCompareFn = value;
            }
            else {
                this._alphaTestSortCompareFn = RenderingGroup.PainterSortCompare;
            }
            this._renderAlphaTest = this._renderAlphaTestSorted;
        }
        /**
         * Set the transparent sort comparison function.
         * If null the sub meshes will be render in the order they were created
         */
        set transparentSortCompareFn(value) {
            if (value) {
                this._transparentSortCompareFn = value;
            }
            else {
                this._transparentSortCompareFn = RenderingGroup.defaultTransparentSortCompare;
            }
            this._renderTransparent = this._renderTransparentSorted;
        }
        /**
         * Creates a new rendering group.
         * @param index The rendering group index
         * @param scene
         * @param opaqueSortCompareFn The opaque sort comparison function. If null no order is applied
         * @param alphaTestSortCompareFn The alpha test sort comparison function. If null no order is applied
         * @param transparentSortCompareFn The transparent sort comparison function. If null back to front + alpha index sort is applied
         */
        constructor(index, scene, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
            this.index = index;
            this._opaqueSubMeshes = new SmartArray(256);
            this._transparentSubMeshes = new SmartArray(256);
            this._alphaTestSubMeshes = new SmartArray(256);
            this._depthOnlySubMeshes = new SmartArray(256);
            this._particleSystems = new SmartArray(256);
            this._spriteManagers = new SmartArray(256);
            /** @internal */
            this._empty = true;
            /** @internal */
            this._edgesRenderers = new SmartArrayNoDuplicate(16);
            this._scene = scene;
            this.opaqueSortCompareFn = opaqueSortCompareFn;
            this.alphaTestSortCompareFn = alphaTestSortCompareFn;
            this.transparentSortCompareFn = transparentSortCompareFn;
        }
        /**
         * Render all the sub meshes contained in the group.
         * @param customRenderFunction Used to override the default render behaviour of the group.
         * @param renderSprites
         * @param renderParticles
         * @param activeMeshes
         * @returns true if rendered some submeshes.
         */
        render(customRenderFunction, renderSprites, renderParticles, activeMeshes) {
            if (customRenderFunction) {
                customRenderFunction(this._opaqueSubMeshes, this._alphaTestSubMeshes, this._transparentSubMeshes, this._depthOnlySubMeshes);
                return;
            }
            const engine = this._scene.getEngine();
            // Depth only
            if (this._depthOnlySubMeshes.length !== 0) {
                engine.setColorWrite(false);
                this._renderAlphaTest(this._depthOnlySubMeshes);
                engine.setColorWrite(true);
            }
            // Opaque
            if (this._opaqueSubMeshes.length !== 0) {
                this._renderOpaque(this._opaqueSubMeshes);
            }
            // Alpha test
            if (this._alphaTestSubMeshes.length !== 0) {
                this._renderAlphaTest(this._alphaTestSubMeshes);
            }
            const stencilState = engine.getStencilBuffer();
            engine.setStencilBuffer(false);
            // Sprites
            if (renderSprites) {
                this._renderSprites();
            }
            // Particles
            if (renderParticles) {
                this._renderParticles(activeMeshes);
            }
            if (this.onBeforeTransparentRendering) {
                this.onBeforeTransparentRendering();
            }
            // Transparent
            if (this._transparentSubMeshes.length !== 0 || this._scene.useOrderIndependentTransparency) {
                engine.setStencilBuffer(stencilState);
                if (this._scene.useOrderIndependentTransparency) {
                    const excludedMeshes = this._scene.depthPeelingRenderer.render(this._transparentSubMeshes);
                    if (excludedMeshes.length) {
                        // Render leftover meshes that could not be processed by depth peeling
                        this._renderTransparent(excludedMeshes);
                    }
                }
                else {
                    this._renderTransparent(this._transparentSubMeshes);
                }
                engine.setAlphaMode(0);
            }
            // Set back stencil to false in case it changes before the edge renderer.
            engine.setStencilBuffer(false);
            // Edges
            if (this._edgesRenderers.length) {
                for (let edgesRendererIndex = 0; edgesRendererIndex < this._edgesRenderers.length; edgesRendererIndex++) {
                    this._edgesRenderers.data[edgesRendererIndex].render();
                }
                engine.setAlphaMode(0);
            }
            // Restore Stencil state.
            engine.setStencilBuffer(stencilState);
        }
        /**
         * Renders the opaque submeshes in the order from the opaqueSortCompareFn.
         * @param subMeshes The submeshes to render
         */
        _renderOpaqueSorted(subMeshes) {
            return RenderingGroup._RenderSorted(subMeshes, this._opaqueSortCompareFn, this._scene.activeCamera, false);
        }
        /**
         * Renders the opaque submeshes in the order from the alphatestSortCompareFn.
         * @param subMeshes The submeshes to render
         */
        _renderAlphaTestSorted(subMeshes) {
            return RenderingGroup._RenderSorted(subMeshes, this._alphaTestSortCompareFn, this._scene.activeCamera, false);
        }
        /**
         * Renders the opaque submeshes in the order from the transparentSortCompareFn.
         * @param subMeshes The submeshes to render
         */
        _renderTransparentSorted(subMeshes) {
            return RenderingGroup._RenderSorted(subMeshes, this._transparentSortCompareFn, this._scene.activeCamera, true);
        }
        /**
         * Renders the submeshes in a specified order.
         * @param subMeshes The submeshes to sort before render
         * @param sortCompareFn The comparison function use to sort
         * @param camera The camera position use to preprocess the submeshes to help sorting
         * @param transparent Specifies to activate blending if true
         */
        static _RenderSorted(subMeshes, sortCompareFn, camera, transparent) {
            let subIndex = 0;
            let subMesh;
            const cameraPosition = camera ? camera.globalPosition : RenderingGroup._ZeroVector;
            if (transparent) {
                for (; subIndex < subMeshes.length; subIndex++) {
                    subMesh = subMeshes.data[subIndex];
                    subMesh._alphaIndex = subMesh.getMesh().alphaIndex;
                    subMesh._distanceToCamera = Vector3.Distance(subMesh.getBoundingInfo().boundingSphere.centerWorld, cameraPosition);
                }
            }
            const sortedArray = subMeshes.length === subMeshes.data.length ? subMeshes.data : subMeshes.data.slice(0, subMeshes.length);
            if (sortCompareFn) {
                sortedArray.sort(sortCompareFn);
            }
            const scene = sortedArray[0].getMesh().getScene();
            for (subIndex = 0; subIndex < sortedArray.length; subIndex++) {
                subMesh = sortedArray[subIndex];
                if (scene._activeMeshesFrozenButKeepClipping && !subMesh.isInFrustum(scene._frustumPlanes)) {
                    continue;
                }
                if (transparent) {
                    const material = subMesh.getMaterial();
                    if (material && material.needDepthPrePass) {
                        const engine = material.getScene().getEngine();
                        engine.setColorWrite(false);
                        engine.setAlphaMode(0);
                        subMesh.render(false);
                        engine.setColorWrite(true);
                    }
                }
                subMesh.render(transparent);
            }
        }
        /**
         * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
         * are rendered back to front if in the same alpha index.
         *
         * @param a The first submesh
         * @param b The second submesh
         * @returns The result of the comparison
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static defaultTransparentSortCompare(a, b) {
            // Alpha index first
            if (a._alphaIndex > b._alphaIndex) {
                return 1;
            }
            if (a._alphaIndex < b._alphaIndex) {
                return -1;
            }
            // Then distance to camera
            return RenderingGroup.backToFrontSortCompare(a, b);
        }
        /**
         * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
         * are rendered back to front.
         *
         * @param a The first submesh
         * @param b The second submesh
         * @returns The result of the comparison
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static backToFrontSortCompare(a, b) {
            // Then distance to camera
            if (a._distanceToCamera < b._distanceToCamera) {
                return 1;
            }
            if (a._distanceToCamera > b._distanceToCamera) {
                return -1;
            }
            return 0;
        }
        /**
         * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
         * are rendered front to back (prevent overdraw).
         *
         * @param a The first submesh
         * @param b The second submesh
         * @returns The result of the comparison
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static frontToBackSortCompare(a, b) {
            // Then distance to camera
            if (a._distanceToCamera < b._distanceToCamera) {
                return -1;
            }
            if (a._distanceToCamera > b._distanceToCamera) {
                return 1;
            }
            return 0;
        }
        /**
         * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
         * are grouped by material then geometry.
         *
         * @param a The first submesh
         * @param b The second submesh
         * @returns The result of the comparison
         */
        static PainterSortCompare(a, b) {
            const meshA = a.getMesh();
            const meshB = b.getMesh();
            if (meshA.material && meshB.material) {
                return meshA.material.uniqueId - meshB.material.uniqueId;
            }
            return meshA.uniqueId - meshB.uniqueId;
        }
        /**
         * Resets the different lists of submeshes to prepare a new frame.
         */
        prepare() {
            this._opaqueSubMeshes.reset();
            this._transparentSubMeshes.reset();
            this._alphaTestSubMeshes.reset();
            this._depthOnlySubMeshes.reset();
            this._particleSystems.reset();
            this.prepareSprites();
            this._edgesRenderers.reset();
            this._empty = true;
        }
        /**
         * Resets the different lists of sprites to prepare a new frame.
         */
        prepareSprites() {
            this._spriteManagers.reset();
        }
        dispose() {
            this._opaqueSubMeshes.dispose();
            this._transparentSubMeshes.dispose();
            this._alphaTestSubMeshes.dispose();
            this._depthOnlySubMeshes.dispose();
            this._particleSystems.dispose();
            this._spriteManagers.dispose();
            this._edgesRenderers.dispose();
        }
        /**
         * Inserts the submesh in its correct queue depending on its material.
         * @param subMesh The submesh to dispatch
         * @param [mesh] Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
         * @param [material] Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
         */
        dispatch(subMesh, mesh, material) {
            // Get mesh and materials if not provided
            if (mesh === undefined) {
                mesh = subMesh.getMesh();
            }
            if (material === undefined) {
                material = subMesh.getMaterial();
            }
            if (material === null || material === undefined) {
                return;
            }
            if (material.needAlphaBlendingForMesh(mesh)) {
                // Transparent
                this._transparentSubMeshes.push(subMesh);
            }
            else if (material.needAlphaTesting()) {
                // Alpha test
                if (material.needDepthPrePass) {
                    this._depthOnlySubMeshes.push(subMesh);
                }
                this._alphaTestSubMeshes.push(subMesh);
            }
            else {
                if (material.needDepthPrePass) {
                    this._depthOnlySubMeshes.push(subMesh);
                }
                this._opaqueSubMeshes.push(subMesh); // Opaque
            }
            mesh._renderingGroup = this;
            if (mesh._edgesRenderer && mesh._edgesRenderer.isEnabled) {
                this._edgesRenderers.pushNoDuplicate(mesh._edgesRenderer);
            }
            this._empty = false;
        }
        dispatchSprites(spriteManager) {
            this._spriteManagers.push(spriteManager);
            this._empty = false;
        }
        dispatchParticles(particleSystem) {
            this._particleSystems.push(particleSystem);
            this._empty = false;
        }
        _renderParticles(activeMeshes) {
            if (this._particleSystems.length === 0) {
                return;
            }
            // Particles
            const activeCamera = this._scene.activeCamera;
            this._scene.onBeforeParticlesRenderingObservable.notifyObservers(this._scene);
            for (let particleIndex = 0; particleIndex < this._particleSystems.length; particleIndex++) {
                const particleSystem = this._particleSystems.data[particleIndex];
                if ((activeCamera && activeCamera.layerMask & particleSystem.layerMask) === 0) {
                    continue;
                }
                const emitter = particleSystem.emitter;
                if (!emitter.position || !activeMeshes || activeMeshes.indexOf(emitter) !== -1) {
                    this._scene._activeParticles.addCount(particleSystem.render(), false);
                }
            }
            this._scene.onAfterParticlesRenderingObservable.notifyObservers(this._scene);
        }
        _renderSprites() {
            if (!this._scene.spritesEnabled || this._spriteManagers.length === 0) {
                return;
            }
            // Sprites
            const activeCamera = this._scene.activeCamera;
            this._scene.onBeforeSpritesRenderingObservable.notifyObservers(this._scene);
            for (let id = 0; id < this._spriteManagers.length; id++) {
                const spriteManager = this._spriteManagers.data[id];
                if ((activeCamera && activeCamera.layerMask & spriteManager.layerMask) !== 0) {
                    spriteManager.render();
                }
            }
            this._scene.onAfterSpritesRenderingObservable.notifyObservers(this._scene);
        }
    }
    RenderingGroup._ZeroVector = Vector3.Zero();

    /**
     * This class is used by the onRenderingGroupObservable
     */
    class RenderingGroupInfo {
    }
    /**
     * This is the manager responsible of all the rendering for meshes sprites and particles.
     * It is enable to manage the different groups as well as the different necessary sort functions.
     * This should not be used directly aside of the few static configurations
     */
    class RenderingManager {
        /**
         * Gets or sets a boolean indicating that the manager will not reset between frames.
         * This means that if a mesh becomes invisible or transparent it will not be visible until this boolean is set to false again.
         * By default, the rendering manager will dispatch all active meshes per frame (moving them to the transparent, opaque or alpha testing lists).
         * By turning this property on, you will accelerate the rendering by keeping all these lists unchanged between frames.
         */
        get maintainStateBetweenFrames() {
            return this._maintainStateBetweenFrames;
        }
        set maintainStateBetweenFrames(value) {
            if (value === this._maintainStateBetweenFrames) {
                return;
            }
            this._maintainStateBetweenFrames = value;
            // Restore wasDispatched flags when switching to maintainStateBetweenFrames to false
            if (!this._maintainStateBetweenFrames) {
                for (const mesh of this._scene.meshes) {
                    if (mesh.subMeshes) {
                        for (const subMesh of mesh.subMeshes) {
                            subMesh._wasDispatched = false;
                        }
                    }
                }
                if (this._scene.spriteManagers) {
                    for (const spriteManager of this._scene.spriteManagers) {
                        spriteManager._wasDispatched = false;
                    }
                }
                for (const particleSystem of this._scene.particleSystems) {
                    particleSystem._wasDispatched = false;
                }
            }
        }
        /**
         * Instantiates a new rendering group for a particular scene
         * @param scene Defines the scene the groups belongs to
         */
        constructor(scene) {
            /**
             * @internal
             */
            this._useSceneAutoClearSetup = false;
            this._renderingGroups = new Array();
            this._autoClearDepthStencil = {};
            this._customOpaqueSortCompareFn = {};
            this._customAlphaTestSortCompareFn = {};
            this._customTransparentSortCompareFn = {};
            this._renderingGroupInfo = new RenderingGroupInfo();
            this._maintainStateBetweenFrames = false;
            this._scene = scene;
            for (let i = RenderingManager.MIN_RENDERINGGROUPS; i < RenderingManager.MAX_RENDERINGGROUPS; i++) {
                this._autoClearDepthStencil[i] = { autoClear: true, depth: true, stencil: true };
            }
        }
        /**
         * Gets the rendering group with the specified id.
         */
        getRenderingGroup(id) {
            const renderingGroupId = id || 0;
            this._prepareRenderingGroup(renderingGroupId);
            return this._renderingGroups[renderingGroupId];
        }
        _clearDepthStencilBuffer(depth = true, stencil = true) {
            if (this._depthStencilBufferAlreadyCleaned) {
                return;
            }
            this._scene.getEngine().clear(null, false, depth, stencil);
            this._depthStencilBufferAlreadyCleaned = true;
        }
        /**
         * Renders the entire managed groups. This is used by the scene or the different render targets.
         * @internal
         */
        render(customRenderFunction, activeMeshes, renderParticles, renderSprites) {
            // Update the observable context (not null as it only goes away on dispose)
            const info = this._renderingGroupInfo;
            info.scene = this._scene;
            info.camera = this._scene.activeCamera;
            // Dispatch sprites
            if (this._scene.spriteManagers && renderSprites) {
                for (let index = 0; index < this._scene.spriteManagers.length; index++) {
                    const manager = this._scene.spriteManagers[index];
                    this.dispatchSprites(manager);
                }
            }
            // Render
            for (let index = RenderingManager.MIN_RENDERINGGROUPS; index < RenderingManager.MAX_RENDERINGGROUPS; index++) {
                this._depthStencilBufferAlreadyCleaned = index === RenderingManager.MIN_RENDERINGGROUPS;
                const renderingGroup = this._renderingGroups[index];
                if (!renderingGroup || renderingGroup._empty) {
                    continue;
                }
                const renderingGroupMask = Math.pow(2, index);
                info.renderingGroupId = index;
                // Before Observable
                this._scene.onBeforeRenderingGroupObservable.notifyObservers(info, renderingGroupMask);
                // Clear depth/stencil if needed
                if (RenderingManager.AUTOCLEAR) {
                    const autoClear = this._useSceneAutoClearSetup ? this._scene.getAutoClearDepthStencilSetup(index) : this._autoClearDepthStencil[index];
                    if (autoClear && autoClear.autoClear) {
                        this._clearDepthStencilBuffer(autoClear.depth, autoClear.stencil);
                    }
                }
                // Render
                for (const step of this._scene._beforeRenderingGroupDrawStage) {
                    step.action(index);
                }
                renderingGroup.render(customRenderFunction, renderSprites, renderParticles, activeMeshes);
                for (const step of this._scene._afterRenderingGroupDrawStage) {
                    step.action(index);
                }
                // After Observable
                this._scene.onAfterRenderingGroupObservable.notifyObservers(info, renderingGroupMask);
            }
        }
        /**
         * Resets the different information of the group to prepare a new frame
         * @internal
         */
        reset() {
            if (this.maintainStateBetweenFrames) {
                return;
            }
            for (let index = RenderingManager.MIN_RENDERINGGROUPS; index < RenderingManager.MAX_RENDERINGGROUPS; index++) {
                const renderingGroup = this._renderingGroups[index];
                if (renderingGroup) {
                    renderingGroup.prepare();
                }
            }
        }
        /**
         * Resets the sprites information of the group to prepare a new frame
         * @internal
         */
        resetSprites() {
            if (this.maintainStateBetweenFrames) {
                return;
            }
            for (let index = RenderingManager.MIN_RENDERINGGROUPS; index < RenderingManager.MAX_RENDERINGGROUPS; index++) {
                const renderingGroup = this._renderingGroups[index];
                if (renderingGroup) {
                    renderingGroup.prepareSprites();
                }
            }
        }
        /**
         * Dispose and release the group and its associated resources.
         * @internal
         */
        dispose() {
            this.freeRenderingGroups();
            this._renderingGroups.length = 0;
            this._renderingGroupInfo = null;
        }
        /**
         * Clear the info related to rendering groups preventing retention points during dispose.
         */
        freeRenderingGroups() {
            for (let index = RenderingManager.MIN_RENDERINGGROUPS; index < RenderingManager.MAX_RENDERINGGROUPS; index++) {
                const renderingGroup = this._renderingGroups[index];
                if (renderingGroup) {
                    renderingGroup.dispose();
                }
            }
        }
        _prepareRenderingGroup(renderingGroupId) {
            if (this._renderingGroups[renderingGroupId] === undefined) {
                this._renderingGroups[renderingGroupId] = new RenderingGroup(renderingGroupId, this._scene, this._customOpaqueSortCompareFn[renderingGroupId], this._customAlphaTestSortCompareFn[renderingGroupId], this._customTransparentSortCompareFn[renderingGroupId]);
            }
        }
        /**
         * Add a sprite manager to the rendering manager in order to render it this frame.
         * @param spriteManager Define the sprite manager to render
         */
        dispatchSprites(spriteManager) {
            if (this.maintainStateBetweenFrames && spriteManager._wasDispatched) {
                return;
            }
            spriteManager._wasDispatched = true;
            this.getRenderingGroup(spriteManager.renderingGroupId).dispatchSprites(spriteManager);
        }
        /**
         * Add a particle system to the rendering manager in order to render it this frame.
         * @param particleSystem Define the particle system to render
         */
        dispatchParticles(particleSystem) {
            if (this.maintainStateBetweenFrames && particleSystem._wasDispatched) {
                return;
            }
            particleSystem._wasDispatched = true;
            this.getRenderingGroup(particleSystem.renderingGroupId).dispatchParticles(particleSystem);
        }
        /**
         * Add a submesh to the manager in order to render it this frame
         * @param subMesh The submesh to dispatch
         * @param mesh Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
         * @param material Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
         */
        dispatch(subMesh, mesh, material) {
            if (mesh === undefined) {
                mesh = subMesh.getMesh();
            }
            if (this.maintainStateBetweenFrames && subMesh._wasDispatched) {
                return;
            }
            subMesh._wasDispatched = true;
            this.getRenderingGroup(mesh.renderingGroupId).dispatch(subMesh, mesh, material);
        }
        /**
         * Overrides the default sort function applied in the rendering group to prepare the meshes.
         * This allowed control for front to back rendering or reversely depending of the special needs.
         *
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
         * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
         * @param transparentSortCompareFn The transparent queue comparison function use to sort.
         */
        setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
            this._customOpaqueSortCompareFn[renderingGroupId] = opaqueSortCompareFn;
            this._customAlphaTestSortCompareFn[renderingGroupId] = alphaTestSortCompareFn;
            this._customTransparentSortCompareFn[renderingGroupId] = transparentSortCompareFn;
            if (this._renderingGroups[renderingGroupId]) {
                const group = this._renderingGroups[renderingGroupId];
                group.opaqueSortCompareFn = this._customOpaqueSortCompareFn[renderingGroupId];
                group.alphaTestSortCompareFn = this._customAlphaTestSortCompareFn[renderingGroupId];
                group.transparentSortCompareFn = this._customTransparentSortCompareFn[renderingGroupId];
            }
        }
        /**
         * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
         *
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
         * @param depth Automatically clears depth between groups if true and autoClear is true.
         * @param stencil Automatically clears stencil between groups if true and autoClear is true.
         */
        setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
            this._autoClearDepthStencil[renderingGroupId] = {
                autoClear: autoClearDepthStencil,
                depth: depth,
                stencil: stencil,
            };
        }
        /**
         * Gets the current auto clear configuration for one rendering group of the rendering
         * manager.
         * @param index the rendering group index to get the information for
         * @returns The auto clear setup for the requested rendering group
         */
        getAutoClearDepthStencilSetup(index) {
            return this._autoClearDepthStencil[index];
        }
    }
    /**
     * The max id used for rendering groups (not included)
     */
    RenderingManager.MAX_RENDERINGGROUPS = 4;
    /**
     * The min id used for rendering groups (included)
     */
    RenderingManager.MIN_RENDERINGGROUPS = 0;
    /**
     * Used to globally prevent autoclearing scenes.
     */
    RenderingManager.AUTOCLEAR = true;

    /**
     * Groups all the scene component constants in one place to ease maintenance.
     * @internal
     */
    class SceneComponentConstants {
    }
    SceneComponentConstants.NAME_EFFECTLAYER = "EffectLayer";
    SceneComponentConstants.NAME_LAYER = "Layer";
    SceneComponentConstants.NAME_LENSFLARESYSTEM = "LensFlareSystem";
    SceneComponentConstants.NAME_BOUNDINGBOXRENDERER = "BoundingBoxRenderer";
    SceneComponentConstants.NAME_PARTICLESYSTEM = "ParticleSystem";
    SceneComponentConstants.NAME_GAMEPAD = "Gamepad";
    SceneComponentConstants.NAME_SIMPLIFICATIONQUEUE = "SimplificationQueue";
    SceneComponentConstants.NAME_GEOMETRYBUFFERRENDERER = "GeometryBufferRenderer";
    SceneComponentConstants.NAME_PREPASSRENDERER = "PrePassRenderer";
    SceneComponentConstants.NAME_DEPTHRENDERER = "DepthRenderer";
    SceneComponentConstants.NAME_DEPTHPEELINGRENDERER = "DepthPeelingRenderer";
    SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER = "PostProcessRenderPipelineManager";
    SceneComponentConstants.NAME_SPRITE = "Sprite";
    SceneComponentConstants.NAME_SUBSURFACE = "SubSurface";
    SceneComponentConstants.NAME_OUTLINERENDERER = "Outline";
    SceneComponentConstants.NAME_PROCEDURALTEXTURE = "ProceduralTexture";
    SceneComponentConstants.NAME_SHADOWGENERATOR = "ShadowGenerator";
    SceneComponentConstants.NAME_OCTREE = "Octree";
    SceneComponentConstants.NAME_PHYSICSENGINE = "PhysicsEngine";
    SceneComponentConstants.NAME_AUDIO = "Audio";
    SceneComponentConstants.NAME_FLUIDRENDERER = "FluidRenderer";
    SceneComponentConstants.STEP_ISREADYFORMESH_EFFECTLAYER = 0;
    SceneComponentConstants.STEP_BEFOREEVALUATEACTIVEMESH_BOUNDINGBOXRENDERER = 0;
    SceneComponentConstants.STEP_EVALUATESUBMESH_BOUNDINGBOXRENDERER = 0;
    SceneComponentConstants.STEP_PREACTIVEMESH_BOUNDINGBOXRENDERER = 0;
    SceneComponentConstants.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER = 1;
    SceneComponentConstants.STEP_BEFORECAMERADRAW_PREPASS = 0;
    SceneComponentConstants.STEP_BEFORECAMERADRAW_EFFECTLAYER = 1;
    SceneComponentConstants.STEP_BEFORECAMERADRAW_LAYER = 2;
    SceneComponentConstants.STEP_BEFORERENDERTARGETDRAW_PREPASS = 0;
    SceneComponentConstants.STEP_BEFORERENDERTARGETDRAW_LAYER = 1;
    SceneComponentConstants.STEP_BEFORERENDERINGMESH_PREPASS = 0;
    SceneComponentConstants.STEP_BEFORERENDERINGMESH_OUTLINE = 1;
    SceneComponentConstants.STEP_AFTERRENDERINGMESH_PREPASS = 0;
    SceneComponentConstants.STEP_AFTERRENDERINGMESH_OUTLINE = 1;
    SceneComponentConstants.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW = 0;
    SceneComponentConstants.STEP_AFTERRENDERINGGROUPDRAW_BOUNDINGBOXRENDERER = 1;
    SceneComponentConstants.STEP_BEFORECAMERAUPDATE_SIMPLIFICATIONQUEUE = 0;
    SceneComponentConstants.STEP_BEFORECAMERAUPDATE_GAMEPAD = 1;
    SceneComponentConstants.STEP_BEFORECLEAR_PROCEDURALTEXTURE = 0;
    SceneComponentConstants.STEP_BEFORECLEAR_PREPASS = 1;
    SceneComponentConstants.STEP_BEFORERENDERTARGETCLEAR_PREPASS = 0;
    SceneComponentConstants.STEP_AFTERRENDERTARGETDRAW_PREPASS = 0;
    SceneComponentConstants.STEP_AFTERRENDERTARGETDRAW_LAYER = 1;
    SceneComponentConstants.STEP_AFTERCAMERADRAW_PREPASS = 0;
    SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER = 1;
    SceneComponentConstants.STEP_AFTERCAMERADRAW_LENSFLARESYSTEM = 2;
    SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW = 3;
    SceneComponentConstants.STEP_AFTERCAMERADRAW_LAYER = 4;
    SceneComponentConstants.STEP_AFTERCAMERADRAW_FLUIDRENDERER = 5;
    SceneComponentConstants.STEP_AFTERCAMERAPOSTPROCESS_LAYER = 0;
    SceneComponentConstants.STEP_AFTERRENDERTARGETPOSTPROCESS_LAYER = 0;
    SceneComponentConstants.STEP_AFTERRENDER_AUDIO = 0;
    SceneComponentConstants.STEP_GATHERRENDERTARGETS_DEPTHRENDERER = 0;
    SceneComponentConstants.STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER = 1;
    SceneComponentConstants.STEP_GATHERRENDERTARGETS_SHADOWGENERATOR = 2;
    SceneComponentConstants.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER = 3;
    SceneComponentConstants.STEP_GATHERACTIVECAMERARENDERTARGETS_DEPTHRENDERER = 0;
    SceneComponentConstants.STEP_GATHERACTIVECAMERARENDERTARGETS_FLUIDRENDERER = 1;
    SceneComponentConstants.STEP_POINTERMOVE_SPRITE = 0;
    SceneComponentConstants.STEP_POINTERDOWN_SPRITE = 0;
    SceneComponentConstants.STEP_POINTERUP_SPRITE = 0;
    /**
     * Representation of a stage in the scene (Basically a list of ordered steps)
     * @internal
     */
    class Stage extends Array {
        /**
         * Hide ctor from the rest of the world.
         * @param items The items to add.
         */
        constructor(items) {
            super(...items);
        }
        /**
         * Creates a new Stage.
         * @returns A new instance of a Stage
         */
        static Create() {
            return Object.create(Stage.prototype);
        }
        /**
         * Registers a step in an ordered way in the targeted stage.
         * @param index Defines the position to register the step in
         * @param component Defines the component attached to the step
         * @param action Defines the action to launch during the step
         */
        registerStep(index, component, action) {
            let i = 0;
            let maxIndex = Number.MAX_VALUE;
            for (; i < this.length; i++) {
                const step = this[i];
                maxIndex = step.index;
                if (index < maxIndex) {
                    break;
                }
            }
            this.splice(i, 0, { index, component, action: action.bind(component) });
        }
        /**
         * Clears all the steps from the stage.
         */
        clear() {
            this.length = 0;
        }
    }

    /**
     * Gather the list of pointer event types as constants.
     */
    class PointerEventTypes {
    }
    /**
     * The pointerdown event is fired when a pointer becomes active. For mouse, it is fired when the device transitions from no buttons depressed to at least one button depressed. For touch, it is fired when physical contact is made with the digitizer. For pen, it is fired when the stylus makes physical contact with the digitizer.
     */
    PointerEventTypes.POINTERDOWN = 0x01;
    /**
     * The pointerup event is fired when a pointer is no longer active.
     */
    PointerEventTypes.POINTERUP = 0x02;
    /**
     * The pointermove event is fired when a pointer changes coordinates.
     */
    PointerEventTypes.POINTERMOVE = 0x04;
    /**
     * The pointerwheel event is fired when a mouse wheel has been rotated.
     */
    PointerEventTypes.POINTERWHEEL = 0x08;
    /**
     * The pointerpick event is fired when a mesh or sprite has been picked by the pointer.
     */
    PointerEventTypes.POINTERPICK = 0x10;
    /**
     * The pointertap event is fired when a the object has been touched and released without drag.
     */
    PointerEventTypes.POINTERTAP = 0x20;
    /**
     * The pointerdoubletap event is fired when a the object has been touched and released twice without drag.
     */
    PointerEventTypes.POINTERDOUBLETAP = 0x40;
    /**
     * Base class of pointer info types.
     */
    class PointerInfoBase {
        /**
         * Instantiates the base class of pointers info.
         * @param type Defines the type of event (PointerEventTypes)
         * @param event Defines the related dom event
         */
        constructor(
        /**
         * Defines the type of event (PointerEventTypes)
         */
        type, 
        /**
         * Defines the related dom event
         */
        event) {
            this.type = type;
            this.event = event;
        }
    }
    /**
     * This class is used to store pointer related info for the onPrePointerObservable event.
     * Set the skipOnPointerObservable property to true if you want the engine to stop any process after this event is triggered, even not calling onPointerObservable
     */
    class PointerInfoPre extends PointerInfoBase {
        /**
         * Instantiates a PointerInfoPre to store pointer related info to the onPrePointerObservable event.
         * @param type Defines the type of event (PointerEventTypes)
         * @param event Defines the related dom event
         * @param localX Defines the local x coordinates of the pointer when the event occured
         * @param localY Defines the local y coordinates of the pointer when the event occured
         */
        constructor(type, event, localX, localY) {
            super(type, event);
            /**
             * Ray from a pointer if available (eg. 6dof controller)
             */
            this.ray = null;
            /**
             * The original picking info that was used to trigger the pointer event
             */
            this.originalPickingInfo = null;
            this.skipOnPointerObservable = false;
            this.localPosition = new Vector2(localX, localY);
        }
    }
    /**
     * This type contains all the data related to a pointer event in Babylon.js.
     * The event member is an instance of PointerEvent for all types except PointerWheel and is of type MouseWheelEvent when type equals PointerWheel. The different event types can be found in the PointerEventTypes class.
     */
    class PointerInfo extends PointerInfoBase {
        /**
         * Defines the picking info associated with this PointerInfo object (if applicable)
         */
        get pickInfo() {
            if (!this._pickInfo) {
                this._generatePickInfo();
            }
            return this._pickInfo;
        }
        /**
         * Instantiates a PointerInfo to store pointer related info to the onPointerObservable event.
         * @param type Defines the type of event (PointerEventTypes)
         * @param event Defines the related dom event
         * @param pickInfo Defines the picking info associated to the info (if any)
         * @param inputManager Defines the InputManager to use if there is no pickInfo
         */
        constructor(type, event, pickInfo, inputManager = null) {
            super(type, event);
            this._pickInfo = pickInfo;
            this._inputManager = inputManager;
        }
        /**
         * Generates the picking info if needed
         */
        /** @internal */
        _generatePickInfo() {
            if (this._inputManager) {
                this._pickInfo = this._inputManager._pickMove(this.event);
                this._inputManager._setRayOnPointerInfo(this._pickInfo, this.event);
                this._inputManager = null;
            }
        }
    }

    /**
     * Abstract class used to decouple action Manager from scene and meshes.
     * Do not instantiate.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions
     */
    class AbstractActionManager {
        constructor() {
            /** Gets the cursor to use when hovering items */
            this.hoverCursor = "";
            /** Gets the list of actions */
            this.actions = new Array();
            /**
             * Gets or sets a boolean indicating that the manager is recursive meaning that it can trigger action from children
             */
            this.isRecursive = false;
        }
        /**
         * Does exist one action manager with at least one trigger
         **/
        static get HasTriggers() {
            for (const t in AbstractActionManager.Triggers) {
                if (Object.prototype.hasOwnProperty.call(AbstractActionManager.Triggers, t)) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Does exist one action manager with at least one pick trigger
         **/
        static get HasPickTriggers() {
            for (const t in AbstractActionManager.Triggers) {
                if (Object.prototype.hasOwnProperty.call(AbstractActionManager.Triggers, t)) {
                    const tAsInt = parseInt(t);
                    if (tAsInt >= 1 && tAsInt <= 7) {
                        return true;
                    }
                }
            }
            return false;
        }
        /**
         * Does exist one action manager that handles actions of a given trigger
         * @param trigger defines the trigger to be tested
         * @returns a boolean indicating whether the trigger is handled by at least one action manager
         **/
        static HasSpecificTrigger(trigger) {
            for (const t in AbstractActionManager.Triggers) {
                if (Object.prototype.hasOwnProperty.call(AbstractActionManager.Triggers, t)) {
                    const tAsInt = parseInt(t);
                    if (tAsInt === trigger) {
                        return true;
                    }
                }
            }
            return false;
        }
    }
    /** Gets the list of active triggers */
    AbstractActionManager.Triggers = {};

    /**
     * Gather the list of keyboard event types as constants.
     */
    class KeyboardEventTypes {
    }
    /**
     * The keydown event is fired when a key becomes active (pressed).
     */
    KeyboardEventTypes.KEYDOWN = 0x01;
    /**
     * The keyup event is fired when a key has been released.
     */
    KeyboardEventTypes.KEYUP = 0x02;
    /**
     * This class is used to store keyboard related info for the onKeyboardObservable event.
     */
    class KeyboardInfo {
        /**
         * Instantiates a new keyboard info.
         * This class is used to store keyboard related info for the onKeyboardObservable event.
         * @param type Defines the type of event (KeyboardEventTypes)
         * @param event Defines the related dom event
         */
        constructor(
        /**
         * Defines the type of event (KeyboardEventTypes)
         */
        type, 
        /**
         * Defines the related dom event
         */
        event) {
            this.type = type;
            this.event = event;
        }
    }
    /**
     * This class is used to store keyboard related info for the onPreKeyboardObservable event.
     * Set the skipOnKeyboardObservable property to true if you want the engine to stop any process after this event is triggered, even not calling onKeyboardObservable
     */
    class KeyboardInfoPre extends KeyboardInfo {
        /**
         * Defines whether the engine should skip the next onKeyboardObservable associated to this pre.
         * @deprecated use skipOnKeyboardObservable property instead
         */
        get skipOnPointerObservable() {
            return this.skipOnKeyboardObservable;
        }
        set skipOnPointerObservable(value) {
            this.skipOnKeyboardObservable = value;
        }
        /**
         * Instantiates a new keyboard pre info.
         * This class is used to store keyboard related info for the onPreKeyboardObservable event.
         * @param type Defines the type of event (KeyboardEventTypes)
         * @param event Defines the related dom event
         */
        constructor(
        /**
         * Defines the type of event (KeyboardEventTypes)
         */
        type, 
        /**
         * Defines the related dom event
         */
        event) {
            super(type, event);
            this.type = type;
            this.event = event;
            this.skipOnKeyboardObservable = false;
        }
    }

    /**
     * Enum for Device Types
     */
    var DeviceType;
    (function (DeviceType) {
        /** Generic */
        DeviceType[DeviceType["Generic"] = 0] = "Generic";
        /** Keyboard */
        DeviceType[DeviceType["Keyboard"] = 1] = "Keyboard";
        /** Mouse */
        DeviceType[DeviceType["Mouse"] = 2] = "Mouse";
        /** Touch Pointers */
        DeviceType[DeviceType["Touch"] = 3] = "Touch";
        /** PS4 Dual Shock */
        DeviceType[DeviceType["DualShock"] = 4] = "DualShock";
        /** Xbox */
        DeviceType[DeviceType["Xbox"] = 5] = "Xbox";
        /** Switch Controller */
        DeviceType[DeviceType["Switch"] = 6] = "Switch";
        /** PS5 DualSense */
        DeviceType[DeviceType["DualSense"] = 7] = "DualSense";
    })(DeviceType || (DeviceType = {}));
    // Device Enums
    /**
     * Enum for All Pointers (Touch/Mouse)
     */
    var PointerInput;
    (function (PointerInput) {
        /** Horizontal Axis (Not used in events/observables; only in polling) */
        PointerInput[PointerInput["Horizontal"] = 0] = "Horizontal";
        /** Vertical Axis (Not used in events/observables; only in polling) */
        PointerInput[PointerInput["Vertical"] = 1] = "Vertical";
        /** Left Click or Touch */
        PointerInput[PointerInput["LeftClick"] = 2] = "LeftClick";
        /** Middle Click */
        PointerInput[PointerInput["MiddleClick"] = 3] = "MiddleClick";
        /** Right Click */
        PointerInput[PointerInput["RightClick"] = 4] = "RightClick";
        /** Browser Back */
        PointerInput[PointerInput["BrowserBack"] = 5] = "BrowserBack";
        /** Browser Forward */
        PointerInput[PointerInput["BrowserForward"] = 6] = "BrowserForward";
        /** Mouse Wheel X */
        PointerInput[PointerInput["MouseWheelX"] = 7] = "MouseWheelX";
        /** Mouse Wheel Y */
        PointerInput[PointerInput["MouseWheelY"] = 8] = "MouseWheelY";
        /** Mouse Wheel Z */
        PointerInput[PointerInput["MouseWheelZ"] = 9] = "MouseWheelZ";
        /** Used in events/observables to identify if x/y changes occurred */
        PointerInput[PointerInput["Move"] = 12] = "Move";
    })(PointerInput || (PointerInput = {}));
    /** @internal */
    var NativePointerInput;
    (function (NativePointerInput) {
        /** Horizontal Axis */
        NativePointerInput[NativePointerInput["Horizontal"] = 0] = "Horizontal";
        /** Vertical Axis */
        NativePointerInput[NativePointerInput["Vertical"] = 1] = "Vertical";
        /** Left Click or Touch */
        NativePointerInput[NativePointerInput["LeftClick"] = 2] = "LeftClick";
        /** Middle Click */
        NativePointerInput[NativePointerInput["MiddleClick"] = 3] = "MiddleClick";
        /** Right Click */
        NativePointerInput[NativePointerInput["RightClick"] = 4] = "RightClick";
        /** Browser Back */
        NativePointerInput[NativePointerInput["BrowserBack"] = 5] = "BrowserBack";
        /** Browser Forward */
        NativePointerInput[NativePointerInput["BrowserForward"] = 6] = "BrowserForward";
        /** Mouse Wheel X */
        NativePointerInput[NativePointerInput["MouseWheelX"] = 7] = "MouseWheelX";
        /** Mouse Wheel Y */
        NativePointerInput[NativePointerInput["MouseWheelY"] = 8] = "MouseWheelY";
        /** Mouse Wheel Z */
        NativePointerInput[NativePointerInput["MouseWheelZ"] = 9] = "MouseWheelZ";
        /** Delta X */
        NativePointerInput[NativePointerInput["DeltaHorizontal"] = 10] = "DeltaHorizontal";
        /** Delta Y */
        NativePointerInput[NativePointerInput["DeltaVertical"] = 11] = "DeltaVertical";
    })(NativePointerInput || (NativePointerInput = {}));
    /**
     * Enum for Dual Shock Gamepad
     */
    var DualShockInput;
    (function (DualShockInput) {
        /** Cross */
        DualShockInput[DualShockInput["Cross"] = 0] = "Cross";
        /** Circle */
        DualShockInput[DualShockInput["Circle"] = 1] = "Circle";
        /** Square */
        DualShockInput[DualShockInput["Square"] = 2] = "Square";
        /** Triangle */
        DualShockInput[DualShockInput["Triangle"] = 3] = "Triangle";
        /** L1 */
        DualShockInput[DualShockInput["L1"] = 4] = "L1";
        /** R1 */
        DualShockInput[DualShockInput["R1"] = 5] = "R1";
        /** L2 */
        DualShockInput[DualShockInput["L2"] = 6] = "L2";
        /** R2 */
        DualShockInput[DualShockInput["R2"] = 7] = "R2";
        /** Share */
        DualShockInput[DualShockInput["Share"] = 8] = "Share";
        /** Options */
        DualShockInput[DualShockInput["Options"] = 9] = "Options";
        /** L3 */
        DualShockInput[DualShockInput["L3"] = 10] = "L3";
        /** R3 */
        DualShockInput[DualShockInput["R3"] = 11] = "R3";
        /** DPadUp */
        DualShockInput[DualShockInput["DPadUp"] = 12] = "DPadUp";
        /** DPadDown */
        DualShockInput[DualShockInput["DPadDown"] = 13] = "DPadDown";
        /** DPadLeft */
        DualShockInput[DualShockInput["DPadLeft"] = 14] = "DPadLeft";
        /** DRight */
        DualShockInput[DualShockInput["DPadRight"] = 15] = "DPadRight";
        /** Home */
        DualShockInput[DualShockInput["Home"] = 16] = "Home";
        /** TouchPad */
        DualShockInput[DualShockInput["TouchPad"] = 17] = "TouchPad";
        /** LStickXAxis */
        DualShockInput[DualShockInput["LStickXAxis"] = 18] = "LStickXAxis";
        /** LStickYAxis */
        DualShockInput[DualShockInput["LStickYAxis"] = 19] = "LStickYAxis";
        /** RStickXAxis */
        DualShockInput[DualShockInput["RStickXAxis"] = 20] = "RStickXAxis";
        /** RStickYAxis */
        DualShockInput[DualShockInput["RStickYAxis"] = 21] = "RStickYAxis";
    })(DualShockInput || (DualShockInput = {}));
    /**
     * Enum for Dual Sense Gamepad
     */
    var DualSenseInput;
    (function (DualSenseInput) {
        /** Cross */
        DualSenseInput[DualSenseInput["Cross"] = 0] = "Cross";
        /** Circle */
        DualSenseInput[DualSenseInput["Circle"] = 1] = "Circle";
        /** Square */
        DualSenseInput[DualSenseInput["Square"] = 2] = "Square";
        /** Triangle */
        DualSenseInput[DualSenseInput["Triangle"] = 3] = "Triangle";
        /** L1 */
        DualSenseInput[DualSenseInput["L1"] = 4] = "L1";
        /** R1 */
        DualSenseInput[DualSenseInput["R1"] = 5] = "R1";
        /** L2 */
        DualSenseInput[DualSenseInput["L2"] = 6] = "L2";
        /** R2 */
        DualSenseInput[DualSenseInput["R2"] = 7] = "R2";
        /** Create */
        DualSenseInput[DualSenseInput["Create"] = 8] = "Create";
        /** Options */
        DualSenseInput[DualSenseInput["Options"] = 9] = "Options";
        /** L3 */
        DualSenseInput[DualSenseInput["L3"] = 10] = "L3";
        /** R3 */
        DualSenseInput[DualSenseInput["R3"] = 11] = "R3";
        /** DPadUp */
        DualSenseInput[DualSenseInput["DPadUp"] = 12] = "DPadUp";
        /** DPadDown */
        DualSenseInput[DualSenseInput["DPadDown"] = 13] = "DPadDown";
        /** DPadLeft */
        DualSenseInput[DualSenseInput["DPadLeft"] = 14] = "DPadLeft";
        /** DRight */
        DualSenseInput[DualSenseInput["DPadRight"] = 15] = "DPadRight";
        /** Home */
        DualSenseInput[DualSenseInput["Home"] = 16] = "Home";
        /** TouchPad */
        DualSenseInput[DualSenseInput["TouchPad"] = 17] = "TouchPad";
        /** LStickXAxis */
        DualSenseInput[DualSenseInput["LStickXAxis"] = 18] = "LStickXAxis";
        /** LStickYAxis */
        DualSenseInput[DualSenseInput["LStickYAxis"] = 19] = "LStickYAxis";
        /** RStickXAxis */
        DualSenseInput[DualSenseInput["RStickXAxis"] = 20] = "RStickXAxis";
        /** RStickYAxis */
        DualSenseInput[DualSenseInput["RStickYAxis"] = 21] = "RStickYAxis";
    })(DualSenseInput || (DualSenseInput = {}));
    /**
     * Enum for Xbox Gamepad
     */
    var XboxInput;
    (function (XboxInput) {
        /** A */
        XboxInput[XboxInput["A"] = 0] = "A";
        /** B */
        XboxInput[XboxInput["B"] = 1] = "B";
        /** X */
        XboxInput[XboxInput["X"] = 2] = "X";
        /** Y */
        XboxInput[XboxInput["Y"] = 3] = "Y";
        /** LB */
        XboxInput[XboxInput["LB"] = 4] = "LB";
        /** RB */
        XboxInput[XboxInput["RB"] = 5] = "RB";
        /** LT */
        XboxInput[XboxInput["LT"] = 6] = "LT";
        /** RT */
        XboxInput[XboxInput["RT"] = 7] = "RT";
        /** Back */
        XboxInput[XboxInput["Back"] = 8] = "Back";
        /** Start */
        XboxInput[XboxInput["Start"] = 9] = "Start";
        /** LS */
        XboxInput[XboxInput["LS"] = 10] = "LS";
        /** RS */
        XboxInput[XboxInput["RS"] = 11] = "RS";
        /** DPadUp */
        XboxInput[XboxInput["DPadUp"] = 12] = "DPadUp";
        /** DPadDown */
        XboxInput[XboxInput["DPadDown"] = 13] = "DPadDown";
        /** DPadLeft */
        XboxInput[XboxInput["DPadLeft"] = 14] = "DPadLeft";
        /** DRight */
        XboxInput[XboxInput["DPadRight"] = 15] = "DPadRight";
        /** Home */
        XboxInput[XboxInput["Home"] = 16] = "Home";
        /** LStickXAxis */
        XboxInput[XboxInput["LStickXAxis"] = 17] = "LStickXAxis";
        /** LStickYAxis */
        XboxInput[XboxInput["LStickYAxis"] = 18] = "LStickYAxis";
        /** RStickXAxis */
        XboxInput[XboxInput["RStickXAxis"] = 19] = "RStickXAxis";
        /** RStickYAxis */
        XboxInput[XboxInput["RStickYAxis"] = 20] = "RStickYAxis";
    })(XboxInput || (XboxInput = {}));
    /**
     * Enum for Switch (Pro/JoyCon L+R) Gamepad
     */
    var SwitchInput;
    (function (SwitchInput) {
        /** B */
        SwitchInput[SwitchInput["B"] = 0] = "B";
        /** A */
        SwitchInput[SwitchInput["A"] = 1] = "A";
        /** Y */
        SwitchInput[SwitchInput["Y"] = 2] = "Y";
        /** X */
        SwitchInput[SwitchInput["X"] = 3] = "X";
        /** L */
        SwitchInput[SwitchInput["L"] = 4] = "L";
        /** R */
        SwitchInput[SwitchInput["R"] = 5] = "R";
        /** ZL */
        SwitchInput[SwitchInput["ZL"] = 6] = "ZL";
        /** ZR */
        SwitchInput[SwitchInput["ZR"] = 7] = "ZR";
        /** Minus */
        SwitchInput[SwitchInput["Minus"] = 8] = "Minus";
        /** Plus */
        SwitchInput[SwitchInput["Plus"] = 9] = "Plus";
        /** LS */
        SwitchInput[SwitchInput["LS"] = 10] = "LS";
        /** RS */
        SwitchInput[SwitchInput["RS"] = 11] = "RS";
        /** DPadUp */
        SwitchInput[SwitchInput["DPadUp"] = 12] = "DPadUp";
        /** DPadDown */
        SwitchInput[SwitchInput["DPadDown"] = 13] = "DPadDown";
        /** DPadLeft */
        SwitchInput[SwitchInput["DPadLeft"] = 14] = "DPadLeft";
        /** DRight */
        SwitchInput[SwitchInput["DPadRight"] = 15] = "DPadRight";
        /** Home */
        SwitchInput[SwitchInput["Home"] = 16] = "Home";
        /** Capture */
        SwitchInput[SwitchInput["Capture"] = 17] = "Capture";
        /** LStickXAxis */
        SwitchInput[SwitchInput["LStickXAxis"] = 18] = "LStickXAxis";
        /** LStickYAxis */
        SwitchInput[SwitchInput["LStickYAxis"] = 19] = "LStickYAxis";
        /** RStickXAxis */
        SwitchInput[SwitchInput["RStickXAxis"] = 20] = "RStickXAxis";
        /** RStickYAxis */
        SwitchInput[SwitchInput["RStickYAxis"] = 21] = "RStickYAxis";
    })(SwitchInput || (SwitchInput = {}));

    /**
     * Event Types
     */
    var DeviceInputEventType;
    (function (DeviceInputEventType) {
        // Pointers
        /** PointerMove */
        DeviceInputEventType[DeviceInputEventType["PointerMove"] = 0] = "PointerMove";
        /** PointerDown */
        DeviceInputEventType[DeviceInputEventType["PointerDown"] = 1] = "PointerDown";
        /** PointerUp */
        DeviceInputEventType[DeviceInputEventType["PointerUp"] = 2] = "PointerUp";
    })(DeviceInputEventType || (DeviceInputEventType = {}));
    /**
     * Constants used for Events
     */
    class EventConstants {
    }
    /**
     * Pixel delta for Wheel Events (Default)
     */
    EventConstants.DOM_DELTA_PIXEL = 0x00;
    /**
     * Line delta for Wheel Events
     */
    EventConstants.DOM_DELTA_LINE = 0x01;
    /**
     * Page delta for Wheel Events
     */
    EventConstants.DOM_DELTA_PAGE = 0x02;

    /**
     * Class to wrap DeviceInputSystem data into an event object
     */
    class DeviceEventFactory {
        /**
         * Create device input events based on provided type and slot
         *
         * @param deviceType Type of device
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         * @param currentState Current value for given input
         * @param deviceInputSystem Reference to DeviceInputSystem
         * @param elementToAttachTo HTMLElement to reference as target for inputs
         * @returns IUIEvent object
         */
        static CreateDeviceEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId) {
            switch (deviceType) {
                case DeviceType.Keyboard:
                    return this._CreateKeyboardEvent(inputIndex, currentState, deviceInputSystem, elementToAttachTo);
                case DeviceType.Mouse:
                    if (inputIndex === PointerInput.MouseWheelX || inputIndex === PointerInput.MouseWheelY || inputIndex === PointerInput.MouseWheelZ) {
                        return this._CreateWheelEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
                    }
                // eslint-disable-next-line no-fallthrough
                case DeviceType.Touch:
                    return this._CreatePointerEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId);
                default:
                    throw `Unable to generate event for device ${DeviceType[deviceType]}`;
            }
        }
        /**
         * Creates pointer event
         *
         * @param deviceType Type of device
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         * @param currentState Current value for given input
         * @param deviceInputSystem Reference to DeviceInputSystem
         * @param elementToAttachTo HTMLElement to reference as target for inputs
         * @returns IUIEvent object (Pointer)
         */
        static _CreatePointerEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId) {
            const evt = this._CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
            if (deviceType === DeviceType.Mouse) {
                evt.deviceType = DeviceType.Mouse;
                evt.pointerId = 1;
                evt.pointerType = "mouse";
            }
            else {
                evt.deviceType = DeviceType.Touch;
                evt.pointerId = pointerId !== null && pointerId !== void 0 ? pointerId : deviceSlot;
                evt.pointerType = "touch";
            }
            let buttons = 0;
            // Populate buttons property with current state of all mouse buttons
            // Uses values found on: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
            buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, PointerInput.LeftClick);
            buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, PointerInput.RightClick) * 2;
            buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, PointerInput.MiddleClick) * 4;
            evt.buttons = buttons;
            if (inputIndex === PointerInput.Move) {
                evt.type = "pointermove";
            }
            else if (inputIndex >= PointerInput.LeftClick && inputIndex <= PointerInput.RightClick) {
                evt.type = currentState === 1 ? "pointerdown" : "pointerup";
                evt.button = inputIndex - 2;
            }
            return evt;
        }
        /**
         * Create Mouse Wheel Event
         * @param deviceType Type of device
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         * @param currentState Current value for given input
         * @param deviceInputSystem Reference to DeviceInputSystem
         * @param elementToAttachTo HTMLElement to reference as target for inputs
         * @returns IUIEvent object (Wheel)
         */
        static _CreateWheelEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
            const evt = this._CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
            // While WheelEvents don't generally have a pointerId, we used to add one in the InputManager
            // This line has been added to make the InputManager more platform-agnostic
            // Similar code exists in the WebDeviceInputSystem to handle browser created events
            evt.pointerId = 1;
            evt.type = "wheel";
            evt.deltaMode = EventConstants.DOM_DELTA_PIXEL;
            evt.deltaX = 0;
            evt.deltaY = 0;
            evt.deltaZ = 0;
            switch (inputIndex) {
                case PointerInput.MouseWheelX:
                    evt.deltaX = currentState;
                    break;
                case PointerInput.MouseWheelY:
                    evt.deltaY = currentState;
                    break;
                case PointerInput.MouseWheelZ:
                    evt.deltaZ = currentState;
                    break;
            }
            return evt;
        }
        /**
         * Create Mouse Event
         * @param deviceType Type of device
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         * @param currentState Current value for given input
         * @param deviceInputSystem Reference to DeviceInputSystem
         * @param elementToAttachTo HTMLElement to reference as target for inputs
         * @returns IUIEvent object (Mouse)
         */
        static _CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
            const evt = this._CreateEvent(elementToAttachTo);
            const pointerX = deviceInputSystem.pollInput(deviceType, deviceSlot, PointerInput.Horizontal);
            const pointerY = deviceInputSystem.pollInput(deviceType, deviceSlot, PointerInput.Vertical);
            // Handle offsets/deltas based on existence of HTMLElement
            if (elementToAttachTo) {
                evt.movementX = 0;
                evt.movementY = 0;
                evt.offsetX = evt.movementX - elementToAttachTo.getBoundingClientRect().x;
                evt.offsetY = evt.movementY - elementToAttachTo.getBoundingClientRect().y;
            }
            else {
                evt.movementX = deviceInputSystem.pollInput(deviceType, deviceSlot, NativePointerInput.DeltaHorizontal); // DeltaHorizontal
                evt.movementY = deviceInputSystem.pollInput(deviceType, deviceSlot, NativePointerInput.DeltaVertical); // DeltaVertical
                evt.offsetX = 0;
                evt.offsetY = 0;
            }
            this._CheckNonCharacterKeys(evt, deviceInputSystem);
            evt.clientX = pointerX;
            evt.clientY = pointerY;
            evt.x = pointerX;
            evt.y = pointerY;
            evt.deviceType = deviceType;
            evt.deviceSlot = deviceSlot;
            evt.inputIndex = inputIndex;
            return evt;
        }
        /**
         * Create Keyboard Event
         * @param inputIndex Id of input to be checked
         * @param currentState Current value for given input
         * @param deviceInputSystem Reference to DeviceInputSystem
         * @param elementToAttachTo HTMLElement to reference as target for inputs
         * @returns IEvent object (Keyboard)
         */
        static _CreateKeyboardEvent(inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
            const evt = this._CreateEvent(elementToAttachTo);
            this._CheckNonCharacterKeys(evt, deviceInputSystem);
            evt.deviceType = DeviceType.Keyboard;
            evt.deviceSlot = 0;
            evt.inputIndex = inputIndex;
            evt.type = currentState === 1 ? "keydown" : "keyup";
            evt.key = String.fromCharCode(inputIndex);
            evt.keyCode = inputIndex;
            return evt;
        }
        /**
         * Add parameters for non-character keys (Ctrl, Alt, Meta, Shift)
         * @param evt Event object to add parameters to
         * @param deviceInputSystem DeviceInputSystem to pull values from
         */
        static _CheckNonCharacterKeys(evt, deviceInputSystem) {
            const isKeyboardActive = deviceInputSystem.isDeviceAvailable(DeviceType.Keyboard);
            const altKey = isKeyboardActive && deviceInputSystem.pollInput(DeviceType.Keyboard, 0, 18) === 1;
            const ctrlKey = isKeyboardActive && deviceInputSystem.pollInput(DeviceType.Keyboard, 0, 17) === 1;
            const metaKey = isKeyboardActive &&
                (deviceInputSystem.pollInput(DeviceType.Keyboard, 0, 91) === 1 ||
                    deviceInputSystem.pollInput(DeviceType.Keyboard, 0, 92) === 1 ||
                    deviceInputSystem.pollInput(DeviceType.Keyboard, 0, 93) === 1);
            const shiftKey = isKeyboardActive && deviceInputSystem.pollInput(DeviceType.Keyboard, 0, 16) === 1;
            evt.altKey = altKey;
            evt.ctrlKey = ctrlKey;
            evt.metaKey = metaKey;
            evt.shiftKey = shiftKey;
        }
        /**
         * Create base event object
         * @param elementToAttachTo Value to use as event target
         * @returns
         */
        static _CreateEvent(elementToAttachTo) {
            const evt = {};
            evt.preventDefault = () => { };
            evt.target = elementToAttachTo;
            return evt;
        }
    }

    /** @internal */
    class NativeDeviceInputSystem {
        constructor(onDeviceConnected, onDeviceDisconnected, onInputChanged) {
            this._nativeInput = _native.DeviceInputSystem
                ? new _native.DeviceInputSystem(onDeviceConnected, onDeviceDisconnected, (deviceType, deviceSlot, inputIndex, currentState) => {
                    const evt = DeviceEventFactory.CreateDeviceEvent(deviceType, deviceSlot, inputIndex, currentState, this);
                    onInputChanged(deviceType, deviceSlot, evt);
                })
                : this._createDummyNativeInput();
        }
        // Public functions
        /**
         * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
         * @param deviceType Enum specifying device type
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         * @returns Current value of input
         */
        pollInput(deviceType, deviceSlot, inputIndex) {
            return this._nativeInput.pollInput(deviceType, deviceSlot, inputIndex);
        }
        /**
         * Check for a specific device in the DeviceInputSystem
         * @param deviceType Type of device to check for
         * @returns bool with status of device's existence
         */
        isDeviceAvailable(deviceType) {
            //TODO: FIx native side first
            return deviceType === DeviceType.Mouse || deviceType === DeviceType.Touch;
        }
        /**
         * Dispose of all the observables
         */
        dispose() {
            this._nativeInput.dispose();
        }
        /**
         * For versions of BabylonNative that don't have the NativeInput plugin initialized, create a dummy version
         * @returns Object with dummy functions
         */
        _createDummyNativeInput() {
            const nativeInput = {
                pollInput: () => {
                    return 0;
                },
                isDeviceAvailable: () => {
                    return false;
                },
                dispose: () => { },
            };
            return nativeInput;
        }
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const MAX_KEYCODES = 255;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const MAX_POINTER_INPUTS = Object.keys(PointerInput).length / 2;
    /** @internal */
    class WebDeviceInputSystem {
        constructor(engine, onDeviceConnected, onDeviceDisconnected, onInputChanged) {
            // Private Members
            this._inputs = [];
            this._keyboardActive = false;
            this._pointerActive = false;
            this._usingSafari = Tools.IsSafari();
            // Found solution for determining if MacOS is being used here:
            // https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
            this._usingMacOS = IsNavigatorAvailable() && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._keyboardDownEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._keyboardUpEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._keyboardBlurEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._pointerMoveEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._pointerDownEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._pointerUpEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._pointerCancelEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._pointerWheelEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._pointerBlurEvent = (evt) => { };
            this._eventsAttached = false;
            this._mouseId = -1;
            this._isUsingFirefox = IsNavigatorAvailable() && navigator.userAgent && navigator.userAgent.indexOf("Firefox") !== -1;
            this._maxTouchPoints = 0;
            this._pointerInputClearObserver = null;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._gamepadConnectedEvent = (evt) => { };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._gamepadDisconnectedEvent = (evt) => { };
            this._eventPrefix = Tools.GetPointerPrefix(engine);
            this._engine = engine;
            this._onDeviceConnected = onDeviceConnected;
            this._onDeviceDisconnected = onDeviceDisconnected;
            this._onInputChanged = onInputChanged;
            // If we need a pointerId, set one for future use
            this._mouseId = this._isUsingFirefox ? 0 : 1;
            this._enableEvents();
            if (this._usingMacOS) {
                this._metaKeys = [];
            }
            // Set callback to enable event handler switching when inputElement changes
            if (!this._engine._onEngineViewChanged) {
                this._engine._onEngineViewChanged = () => {
                    this._enableEvents();
                };
            }
        }
        // Public functions
        /**
         * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
         * @param deviceType Enum specifying device type
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         * @returns Current value of input
         */
        pollInput(deviceType, deviceSlot, inputIndex) {
            const device = this._inputs[deviceType][deviceSlot];
            if (!device) {
                throw `Unable to find device ${DeviceType[deviceType]}`;
            }
            if (deviceType >= DeviceType.DualShock && deviceType <= DeviceType.DualSense) {
                this._updateDevice(deviceType, deviceSlot, inputIndex);
            }
            const currentValue = device[inputIndex];
            if (currentValue === undefined) {
                throw `Unable to find input ${inputIndex} for device ${DeviceType[deviceType]} in slot ${deviceSlot}`;
            }
            if (inputIndex === PointerInput.Move) {
                Tools.Warn(`Unable to provide information for PointerInput.Move.  Try using PointerInput.Horizontal or PointerInput.Vertical for move data.`);
            }
            return currentValue;
        }
        /**
         * Check for a specific device in the DeviceInputSystem
         * @param deviceType Type of device to check for
         * @returns bool with status of device's existence
         */
        isDeviceAvailable(deviceType) {
            return this._inputs[deviceType] !== undefined;
        }
        /**
         * Dispose of all the eventlisteners
         */
        dispose() {
            // Callbacks
            this._onDeviceConnected = () => { };
            this._onDeviceDisconnected = () => { };
            this._onInputChanged = () => { };
            delete this._engine._onEngineViewChanged;
            if (this._elementToAttachTo) {
                this._disableEvents();
            }
        }
        /**
         * Enable listening for user input events
         */
        _enableEvents() {
            const inputElement = this === null || this === void 0 ? void 0 : this._engine.getInputElement();
            if (inputElement && (!this._eventsAttached || this._elementToAttachTo !== inputElement)) {
                // Remove events before adding to avoid double events or simultaneous events on multiple canvases
                this._disableEvents();
                // If the inputs array has already been created, zero it out to before setting up events
                if (this._inputs) {
                    for (const inputs of this._inputs) {
                        if (inputs) {
                            for (const deviceSlotKey in inputs) {
                                const deviceSlot = +deviceSlotKey;
                                const device = inputs[deviceSlot];
                                if (device) {
                                    for (let inputIndex = 0; inputIndex < device.length; inputIndex++) {
                                        device[inputIndex] = 0;
                                    }
                                }
                            }
                        }
                    }
                }
                this._elementToAttachTo = inputElement;
                // Set tab index for the inputElement to the engine's canvasTabIndex, if and only if the element's tab index is -1
                this._elementToAttachTo.tabIndex = this._elementToAttachTo.tabIndex !== -1 ? this._elementToAttachTo.tabIndex : this._engine.canvasTabIndex;
                this._handleKeyActions();
                this._handlePointerActions();
                this._handleGamepadActions();
                this._eventsAttached = true;
                // Check for devices that are already connected but aren't registered. Currently, only checks for gamepads and mouse
                this._checkForConnectedDevices();
            }
        }
        /**
         * Disable listening for user input events
         */
        _disableEvents() {
            if (this._elementToAttachTo) {
                // Blur Events
                this._elementToAttachTo.removeEventListener("blur", this._keyboardBlurEvent);
                this._elementToAttachTo.removeEventListener("blur", this._pointerBlurEvent);
                // Keyboard Events
                this._elementToAttachTo.removeEventListener("keydown", this._keyboardDownEvent);
                this._elementToAttachTo.removeEventListener("keyup", this._keyboardUpEvent);
                // Pointer Events
                this._elementToAttachTo.removeEventListener(this._eventPrefix + "move", this._pointerMoveEvent);
                this._elementToAttachTo.removeEventListener(this._eventPrefix + "down", this._pointerDownEvent);
                this._elementToAttachTo.removeEventListener(this._eventPrefix + "up", this._pointerUpEvent);
                this._elementToAttachTo.removeEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent);
                this._elementToAttachTo.removeEventListener(this._wheelEventName, this._pointerWheelEvent);
                // Gamepad Events
                window.removeEventListener("gamepadconnected", this._gamepadConnectedEvent);
                window.removeEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
            }
            if (this._pointerInputClearObserver) {
                this._engine.onEndFrameObservable.remove(this._pointerInputClearObserver);
            }
            this._eventsAttached = false;
        }
        /**
         * Checks for existing connections to devices and register them, if necessary
         * Currently handles gamepads and mouse
         */
        _checkForConnectedDevices() {
            if (navigator.getGamepads) {
                const gamepads = navigator.getGamepads();
                for (const gamepad of gamepads) {
                    if (gamepad) {
                        this._addGamePad(gamepad);
                    }
                }
            }
            // If the device in use has mouse capabilities, pre-register mouse
            if (typeof matchMedia === "function" && matchMedia("(pointer:fine)").matches) {
                // This will provide a dummy value for the cursor position and is expected to be overridden when the first mouse event happens.
                // There isn't any good way to get the current position outside of a pointer event so that's why this was done.
                this._addPointerDevice(DeviceType.Mouse, 0, 0, 0);
            }
        }
        // Private functions
        /**
         * Add a gamepad to the DeviceInputSystem
         * @param gamepad A single DOM Gamepad object
         */
        _addGamePad(gamepad) {
            const deviceType = this._getGamepadDeviceType(gamepad.id);
            const deviceSlot = gamepad.index;
            this._gamepads = this._gamepads || new Array(gamepad.index + 1);
            this._registerDevice(deviceType, deviceSlot, gamepad.buttons.length + gamepad.axes.length);
            this._gamepads[deviceSlot] = deviceType;
        }
        /**
         * Add pointer device to DeviceInputSystem
         * @param deviceType Type of Pointer to add
         * @param deviceSlot Pointer ID (0 for mouse, pointerId for Touch)
         * @param currentX Current X at point of adding
         * @param currentY Current Y at point of adding
         */
        _addPointerDevice(deviceType, deviceSlot, currentX, currentY) {
            if (!this._pointerActive) {
                this._pointerActive = true;
            }
            this._registerDevice(deviceType, deviceSlot, MAX_POINTER_INPUTS);
            const pointer = this._inputs[deviceType][deviceSlot]; /* initialize our pointer position immediately after registration */
            pointer[0] = currentX;
            pointer[1] = currentY;
        }
        /**
         * Add device and inputs to device array
         * @param deviceType Enum specifying device type
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param numberOfInputs Number of input entries to create for given device
         */
        _registerDevice(deviceType, deviceSlot, numberOfInputs) {
            if (deviceSlot === undefined) {
                throw `Unable to register device ${DeviceType[deviceType]} to undefined slot.`;
            }
            if (!this._inputs[deviceType]) {
                this._inputs[deviceType] = {};
            }
            if (!this._inputs[deviceType][deviceSlot]) {
                const device = new Array(numberOfInputs);
                device.fill(0);
                this._inputs[deviceType][deviceSlot] = device;
                this._onDeviceConnected(deviceType, deviceSlot);
            }
        }
        /**
         * Given a specific device name, remove that device from the device map
         * @param deviceType Enum specifying device type
         * @param deviceSlot "Slot" or index that device is referenced in
         */
        _unregisterDevice(deviceType, deviceSlot) {
            if (this._inputs[deviceType][deviceSlot]) {
                delete this._inputs[deviceType][deviceSlot];
                this._onDeviceDisconnected(deviceType, deviceSlot);
            }
        }
        /**
         * Handle all actions that come from keyboard interaction
         */
        _handleKeyActions() {
            this._keyboardDownEvent = (evt) => {
                if (!this._keyboardActive) {
                    this._keyboardActive = true;
                    this._registerDevice(DeviceType.Keyboard, 0, MAX_KEYCODES);
                }
                const kbKey = this._inputs[DeviceType.Keyboard][0];
                if (kbKey) {
                    kbKey[evt.keyCode] = 1;
                    const deviceEvent = evt;
                    deviceEvent.inputIndex = evt.keyCode;
                    if (this._usingMacOS && evt.metaKey && evt.key !== "Meta") {
                        if (!this._metaKeys.includes(evt.keyCode)) {
                            this._metaKeys.push(evt.keyCode);
                        }
                    }
                    this._onInputChanged(DeviceType.Keyboard, 0, deviceEvent);
                }
            };
            this._keyboardUpEvent = (evt) => {
                if (!this._keyboardActive) {
                    this._keyboardActive = true;
                    this._registerDevice(DeviceType.Keyboard, 0, MAX_KEYCODES);
                }
                const kbKey = this._inputs[DeviceType.Keyboard][0];
                if (kbKey) {
                    kbKey[evt.keyCode] = 0;
                    const deviceEvent = evt;
                    deviceEvent.inputIndex = evt.keyCode;
                    if (this._usingMacOS && evt.key === "Meta" && this._metaKeys.length > 0) {
                        for (const keyCode of this._metaKeys) {
                            const deviceEvent = DeviceEventFactory.CreateDeviceEvent(DeviceType.Keyboard, 0, keyCode, 0, this, this._elementToAttachTo);
                            kbKey[keyCode] = 0;
                            this._onInputChanged(DeviceType.Keyboard, 0, deviceEvent);
                        }
                        this._metaKeys.splice(0, this._metaKeys.length);
                    }
                    this._onInputChanged(DeviceType.Keyboard, 0, deviceEvent);
                }
            };
            this._keyboardBlurEvent = () => {
                if (this._keyboardActive) {
                    const kbKey = this._inputs[DeviceType.Keyboard][0];
                    for (let i = 0; i < kbKey.length; i++) {
                        if (kbKey[i] !== 0) {
                            kbKey[i] = 0;
                            const deviceEvent = DeviceEventFactory.CreateDeviceEvent(DeviceType.Keyboard, 0, i, 0, this, this._elementToAttachTo);
                            this._onInputChanged(DeviceType.Keyboard, 0, deviceEvent);
                        }
                    }
                    if (this._usingMacOS) {
                        this._metaKeys.splice(0, this._metaKeys.length);
                    }
                }
            };
            this._elementToAttachTo.addEventListener("keydown", this._keyboardDownEvent);
            this._elementToAttachTo.addEventListener("keyup", this._keyboardUpEvent);
            this._elementToAttachTo.addEventListener("blur", this._keyboardBlurEvent);
        }
        /**
         * Handle all actions that come from pointer interaction
         */
        _handlePointerActions() {
            // If maxTouchPoints is defined, use that value.  Otherwise, allow for a minimum for supported gestures like pinch
            this._maxTouchPoints = (IsNavigatorAvailable() && navigator.maxTouchPoints) || 2;
            if (!this._activeTouchIds) {
                this._activeTouchIds = new Array(this._maxTouchPoints);
            }
            for (let i = 0; i < this._maxTouchPoints; i++) {
                this._activeTouchIds[i] = -1;
            }
            this._pointerMoveEvent = (evt) => {
                const deviceType = this._getPointerType(evt);
                const deviceSlot = deviceType === DeviceType.Mouse ? 0 : this._activeTouchIds.indexOf(evt.pointerId);
                if (!this._inputs[deviceType]) {
                    this._inputs[deviceType] = {};
                }
                if (!this._inputs[deviceType][deviceSlot]) {
                    this._addPointerDevice(deviceType, deviceSlot, evt.clientX, evt.clientY);
                }
                const pointer = this._inputs[deviceType][deviceSlot];
                if (pointer) {
                    const deviceEvent = evt;
                    deviceEvent.inputIndex = PointerInput.Move;
                    pointer[PointerInput.Horizontal] = evt.clientX;
                    pointer[PointerInput.Vertical] = evt.clientY;
                    if (evt.pointerId === undefined) {
                        evt.pointerId = this._mouseId;
                    }
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    // Lets Propagate the event for move with same position.
                    if (!this._usingSafari && evt.button !== -1) {
                        deviceEvent.inputIndex = evt.button + 2;
                        pointer[evt.button + 2] = pointer[evt.button + 2] ? 0 : 1; // Reverse state of button if evt.button has value
                        this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    }
                }
            };
            this._pointerDownEvent = (evt) => {
                const deviceType = this._getPointerType(evt);
                let deviceSlot = deviceType === DeviceType.Mouse ? 0 : evt.pointerId;
                if (deviceType === DeviceType.Touch) {
                    const idx = this._activeTouchIds.indexOf(-1);
                    if (idx >= 0) {
                        deviceSlot = idx;
                        this._activeTouchIds[idx] = evt.pointerId;
                    }
                    else {
                        // We can't find an open slot to store new pointer so just return (can only support max number of touches)
                        Tools.Warn(`Max number of touches exceeded.  Ignoring touches in excess of ${this._maxTouchPoints}`);
                        return;
                    }
                }
                if (!this._inputs[deviceType]) {
                    this._inputs[deviceType] = {};
                }
                if (!this._inputs[deviceType][deviceSlot]) {
                    this._addPointerDevice(deviceType, deviceSlot, evt.clientX, evt.clientY);
                }
                else if (deviceType === DeviceType.Touch) {
                    this._onDeviceConnected(deviceType, deviceSlot);
                }
                const pointer = this._inputs[deviceType][deviceSlot];
                if (pointer) {
                    const previousHorizontal = pointer[PointerInput.Horizontal];
                    const previousVertical = pointer[PointerInput.Vertical];
                    if (deviceType === DeviceType.Mouse) {
                        // Mouse; Set pointerId if undefined
                        if (evt.pointerId === undefined) {
                            evt.pointerId = this._mouseId;
                        }
                        if (!document.pointerLockElement) {
                            try {
                                this._elementToAttachTo.setPointerCapture(this._mouseId);
                            }
                            catch (e) {
                                // DO NOTHING
                            }
                        }
                    }
                    else {
                        // Touch; Since touches are dynamically assigned, only set capture if we have an id
                        if (evt.pointerId && !document.pointerLockElement) {
                            try {
                                this._elementToAttachTo.setPointerCapture(evt.pointerId);
                            }
                            catch (e) {
                                // DO NOTHING
                            }
                        }
                    }
                    pointer[PointerInput.Horizontal] = evt.clientX;
                    pointer[PointerInput.Vertical] = evt.clientY;
                    pointer[evt.button + 2] = 1;
                    const deviceEvent = evt;
                    // NOTE: The +2 used here to is because PointerInput has the same value progression for its mouse buttons as PointerEvent.button
                    // However, we have our X and Y values front-loaded to group together the touch inputs but not break this progression
                    // EG. ([X, Y, Left-click], Middle-click, etc...)
                    deviceEvent.inputIndex = evt.button + 2;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    if (previousHorizontal !== evt.clientX || previousVertical !== evt.clientY) {
                        deviceEvent.inputIndex = PointerInput.Move;
                        this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    }
                }
            };
            this._pointerUpEvent = (evt) => {
                var _a, _b, _c, _d, _e;
                const deviceType = this._getPointerType(evt);
                const deviceSlot = deviceType === DeviceType.Mouse ? 0 : this._activeTouchIds.indexOf(evt.pointerId);
                if (deviceType === DeviceType.Touch) {
                    if (deviceSlot === -1) {
                        return;
                    }
                    else {
                        this._activeTouchIds[deviceSlot] = -1;
                    }
                }
                const pointer = (_a = this._inputs[deviceType]) === null || _a === void 0 ? void 0 : _a[deviceSlot];
                if (pointer && pointer[evt.button + 2] !== 0) {
                    const previousHorizontal = pointer[PointerInput.Horizontal];
                    const previousVertical = pointer[PointerInput.Vertical];
                    pointer[PointerInput.Horizontal] = evt.clientX;
                    pointer[PointerInput.Vertical] = evt.clientY;
                    pointer[evt.button + 2] = 0;
                    const deviceEvent = evt;
                    if (evt.pointerId === undefined) {
                        evt.pointerId = this._mouseId;
                    }
                    if (previousHorizontal !== evt.clientX || previousVertical !== evt.clientY) {
                        deviceEvent.inputIndex = PointerInput.Move;
                        this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    }
                    // NOTE: The +2 used here to is because PointerInput has the same value progression for its mouse buttons as PointerEvent.button
                    // However, we have our X and Y values front-loaded to group together the touch inputs but not break this progression
                    // EG. ([X, Y, Left-click], Middle-click, etc...)
                    deviceEvent.inputIndex = evt.button + 2;
                    if (deviceType === DeviceType.Mouse && this._mouseId >= 0 && ((_c = (_b = this._elementToAttachTo).hasPointerCapture) === null || _c === void 0 ? void 0 : _c.call(_b, this._mouseId))) {
                        this._elementToAttachTo.releasePointerCapture(this._mouseId);
                    }
                    else if (evt.pointerId && ((_e = (_d = this._elementToAttachTo).hasPointerCapture) === null || _e === void 0 ? void 0 : _e.call(_d, evt.pointerId))) {
                        this._elementToAttachTo.releasePointerCapture(evt.pointerId);
                    }
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    if (deviceType === DeviceType.Touch) {
                        this._onDeviceDisconnected(deviceType, deviceSlot);
                    }
                }
            };
            this._pointerCancelEvent = (evt) => {
                var _a, _b, _c, _d;
                if (evt.pointerType === "mouse") {
                    const pointer = this._inputs[DeviceType.Mouse][0];
                    if (this._mouseId >= 0 && ((_b = (_a = this._elementToAttachTo).hasPointerCapture) === null || _b === void 0 ? void 0 : _b.call(_a, this._mouseId))) {
                        this._elementToAttachTo.releasePointerCapture(this._mouseId);
                    }
                    for (let inputIndex = PointerInput.LeftClick; inputIndex <= PointerInput.BrowserForward; inputIndex++) {
                        if (pointer[inputIndex] === 1) {
                            pointer[inputIndex] = 0;
                            const deviceEvent = DeviceEventFactory.CreateDeviceEvent(DeviceType.Mouse, 0, inputIndex, 0, this, this._elementToAttachTo);
                            this._onInputChanged(DeviceType.Mouse, 0, deviceEvent);
                        }
                    }
                }
                else {
                    const deviceSlot = this._activeTouchIds.indexOf(evt.pointerId);
                    if ((_d = (_c = this._elementToAttachTo).hasPointerCapture) === null || _d === void 0 ? void 0 : _d.call(_c, evt.pointerId)) {
                        this._elementToAttachTo.releasePointerCapture(evt.pointerId);
                    }
                    this._inputs[DeviceType.Touch][deviceSlot][PointerInput.LeftClick] = 0;
                    const deviceEvent = DeviceEventFactory.CreateDeviceEvent(DeviceType.Touch, deviceSlot, PointerInput.LeftClick, 0, this, this._elementToAttachTo, evt.pointerId);
                    this._onInputChanged(DeviceType.Touch, deviceSlot, deviceEvent);
                    this._activeTouchIds[deviceSlot] = -1;
                    this._onDeviceDisconnected(DeviceType.Touch, deviceSlot);
                }
            };
            // Set Wheel Event Name, code originally from scene.inputManager
            this._wheelEventName =
                "onwheel" in document.createElement("div")
                    ? "wheel" // Modern browsers support "wheel"
                    : document.onmousewheel !== undefined
                        ? "mousewheel" // Webkit and IE support at least "mousewheel"
                        : "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox
            // Code originally in scene.inputManager.ts
            // Chrome reports warning in console if wheel listener doesn't set an explicit passive option.
            // IE11 only supports captureEvent:boolean, not options:object, and it defaults to false.
            // Feature detection technique copied from: https://github.com/github/eventlistener-polyfill (MIT license)
            let passiveSupported = false;
            const noop = function () { };
            try {
                const options = Object.defineProperty({}, "passive", {
                    get: function () {
                        passiveSupported = true;
                    },
                });
                this._elementToAttachTo.addEventListener("test", noop, options);
                this._elementToAttachTo.removeEventListener("test", noop, options);
            }
            catch (e) {
                /* */
            }
            this._pointerBlurEvent = () => {
                var _a, _b, _c, _d, _e;
                // Handle mouse buttons
                if (this.isDeviceAvailable(DeviceType.Mouse)) {
                    const pointer = this._inputs[DeviceType.Mouse][0];
                    if (this._mouseId >= 0 && ((_b = (_a = this._elementToAttachTo).hasPointerCapture) === null || _b === void 0 ? void 0 : _b.call(_a, this._mouseId))) {
                        this._elementToAttachTo.releasePointerCapture(this._mouseId);
                    }
                    for (let inputIndex = PointerInput.LeftClick; inputIndex <= PointerInput.BrowserForward; inputIndex++) {
                        if (pointer[inputIndex] === 1) {
                            pointer[inputIndex] = 0;
                            const deviceEvent = DeviceEventFactory.CreateDeviceEvent(DeviceType.Mouse, 0, inputIndex, 0, this, this._elementToAttachTo);
                            this._onInputChanged(DeviceType.Mouse, 0, deviceEvent);
                        }
                    }
                }
                // Handle Active Touches
                if (this.isDeviceAvailable(DeviceType.Touch)) {
                    const pointer = this._inputs[DeviceType.Touch];
                    for (let deviceSlot = 0; deviceSlot < this._activeTouchIds.length; deviceSlot++) {
                        const pointerId = this._activeTouchIds[deviceSlot];
                        if ((_d = (_c = this._elementToAttachTo).hasPointerCapture) === null || _d === void 0 ? void 0 : _d.call(_c, pointerId)) {
                            this._elementToAttachTo.releasePointerCapture(pointerId);
                        }
                        if (pointerId !== -1 && ((_e = pointer[deviceSlot]) === null || _e === void 0 ? void 0 : _e[PointerInput.LeftClick]) === 1) {
                            pointer[deviceSlot][PointerInput.LeftClick] = 0;
                            const deviceEvent = DeviceEventFactory.CreateDeviceEvent(DeviceType.Touch, deviceSlot, PointerInput.LeftClick, 0, this, this._elementToAttachTo, pointerId);
                            this._onInputChanged(DeviceType.Touch, deviceSlot, deviceEvent);
                            this._activeTouchIds[deviceSlot] = -1;
                            this._onDeviceDisconnected(DeviceType.Touch, deviceSlot);
                        }
                    }
                }
            };
            this._pointerWheelEvent = (evt) => {
                const deviceType = DeviceType.Mouse;
                const deviceSlot = 0;
                if (!this._inputs[deviceType]) {
                    this._inputs[deviceType] = [];
                }
                if (!this._inputs[deviceType][deviceSlot]) {
                    this._pointerActive = true;
                    this._registerDevice(deviceType, deviceSlot, MAX_POINTER_INPUTS);
                }
                const pointer = this._inputs[deviceType][deviceSlot];
                if (pointer) {
                    pointer[PointerInput.MouseWheelX] = evt.deltaX || 0;
                    pointer[PointerInput.MouseWheelY] = evt.deltaY || evt.wheelDelta || 0;
                    pointer[PointerInput.MouseWheelZ] = evt.deltaZ || 0;
                    const deviceEvent = evt;
                    // By default, there is no pointerId for mouse wheel events so we'll add one here
                    // This logic was originally in the InputManager but was added here to make the
                    // InputManager more platform-agnostic
                    if (evt.pointerId === undefined) {
                        evt.pointerId = this._mouseId;
                    }
                    if (pointer[PointerInput.MouseWheelX] !== 0) {
                        deviceEvent.inputIndex = PointerInput.MouseWheelX;
                        this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    }
                    if (pointer[PointerInput.MouseWheelY] !== 0) {
                        deviceEvent.inputIndex = PointerInput.MouseWheelY;
                        this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    }
                    if (pointer[PointerInput.MouseWheelZ] !== 0) {
                        deviceEvent.inputIndex = PointerInput.MouseWheelZ;
                        this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                    }
                }
            };
            this._elementToAttachTo.addEventListener(this._eventPrefix + "move", this._pointerMoveEvent);
            this._elementToAttachTo.addEventListener(this._eventPrefix + "down", this._pointerDownEvent);
            this._elementToAttachTo.addEventListener(this._eventPrefix + "up", this._pointerUpEvent);
            this._elementToAttachTo.addEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent);
            this._elementToAttachTo.addEventListener("blur", this._pointerBlurEvent);
            this._elementToAttachTo.addEventListener(this._wheelEventName, this._pointerWheelEvent, passiveSupported ? { passive: false } : false);
            // Since there's no up or down event for mouse wheel or delta x/y, clear mouse values at end of frame
            this._pointerInputClearObserver = this._engine.onEndFrameObservable.add(() => {
                if (this.isDeviceAvailable(DeviceType.Mouse)) {
                    const pointer = this._inputs[DeviceType.Mouse][0];
                    pointer[PointerInput.MouseWheelX] = 0;
                    pointer[PointerInput.MouseWheelY] = 0;
                    pointer[PointerInput.MouseWheelZ] = 0;
                }
            });
        }
        /**
         * Handle all actions that come from gamepad interaction
         */
        _handleGamepadActions() {
            this._gamepadConnectedEvent = (evt) => {
                this._addGamePad(evt.gamepad);
            };
            this._gamepadDisconnectedEvent = (evt) => {
                if (this._gamepads) {
                    const deviceType = this._getGamepadDeviceType(evt.gamepad.id);
                    const deviceSlot = evt.gamepad.index;
                    this._unregisterDevice(deviceType, deviceSlot);
                    delete this._gamepads[deviceSlot];
                }
            };
            window.addEventListener("gamepadconnected", this._gamepadConnectedEvent);
            window.addEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
        }
        /**
         * Update all non-event based devices with each frame
         * @param deviceType Enum specifying device type
         * @param deviceSlot "Slot" or index that device is referenced in
         * @param inputIndex Id of input to be checked
         */
        _updateDevice(deviceType, deviceSlot, inputIndex) {
            // Gamepads
            const gp = navigator.getGamepads()[deviceSlot];
            if (gp && deviceType === this._gamepads[deviceSlot]) {
                const device = this._inputs[deviceType][deviceSlot];
                if (inputIndex >= gp.buttons.length) {
                    device[inputIndex] = gp.axes[inputIndex - gp.buttons.length].valueOf();
                }
                else {
                    device[inputIndex] = gp.buttons[inputIndex].value;
                }
            }
        }
        /**
         * Gets DeviceType from the device name
         * @param deviceName Name of Device from DeviceInputSystem
         * @returns DeviceType enum value
         */
        _getGamepadDeviceType(deviceName) {
            if (deviceName.indexOf("054c") !== -1) {
                // DualShock 4 Gamepad
                return deviceName.indexOf("0ce6") !== -1 ? DeviceType.DualSense : DeviceType.DualShock;
            }
            else if (deviceName.indexOf("Xbox One") !== -1 || deviceName.search("Xbox 360") !== -1 || deviceName.search("xinput") !== -1) {
                // Xbox Gamepad
                return DeviceType.Xbox;
            }
            else if (deviceName.indexOf("057e") !== -1) {
                // Switch Gamepad
                return DeviceType.Switch;
            }
            return DeviceType.Generic;
        }
        /**
         * Get DeviceType from a given pointer/mouse/touch event.
         * @param evt PointerEvent to evaluate
         * @returns DeviceType interpreted from event
         */
        _getPointerType(evt) {
            let deviceType = DeviceType.Mouse;
            if (evt.pointerType === "touch" || evt.pointerType === "pen" || evt.touches) {
                deviceType = DeviceType.Touch;
            }
            return deviceType;
        }
    }

    /**
     * Class that handles all input for a specific device
     */
    class DeviceSource {
        /**
         * Default Constructor
         * @param deviceInputSystem - Reference to DeviceInputSystem
         * @param deviceType - Type of device
         * @param deviceSlot - "Slot" or index that device is referenced in
         */
        constructor(deviceInputSystem, 
        /** Type of device */
        deviceType, 
        /** "Slot" or index that device is referenced in */
        deviceSlot = 0) {
            this.deviceType = deviceType;
            this.deviceSlot = deviceSlot;
            // Public Members
            /**
             * Observable to handle device input changes per device
             */
            this.onInputChangedObservable = new Observable$1();
            this._deviceInputSystem = deviceInputSystem;
        }
        /**
         * Get input for specific input
         * @param inputIndex - index of specific input on device
         * @returns Input value from DeviceInputSystem
         */
        getInput(inputIndex) {
            return this._deviceInputSystem.pollInput(this.deviceType, this.deviceSlot, inputIndex);
        }
    }

    /** @internal */
    class InternalDeviceSourceManager {
        constructor(engine) {
            this._registeredManagers = new Array();
            this._refCount = 0;
            // Public Functions
            this.registerManager = (manager) => {
                for (let deviceType = 0; deviceType < this._devices.length; deviceType++) {
                    const device = this._devices[deviceType];
                    for (const deviceSlotKey in device) {
                        const deviceSlot = +deviceSlotKey;
                        manager._addDevice(new DeviceSource(this._deviceInputSystem, deviceType, deviceSlot));
                    }
                }
                this._registeredManagers.push(manager);
            };
            this.unregisterManager = (manager) => {
                const idx = this._registeredManagers.indexOf(manager);
                if (idx > -1) {
                    this._registeredManagers.splice(idx, 1);
                }
            };
            const numberOfDeviceTypes = Object.keys(DeviceType).length / 2;
            this._devices = new Array(numberOfDeviceTypes);
            const onDeviceConnected = (deviceType, deviceSlot) => {
                if (!this._devices[deviceType]) {
                    this._devices[deviceType] = new Array();
                }
                if (!this._devices[deviceType][deviceSlot]) {
                    this._devices[deviceType][deviceSlot] = deviceSlot;
                }
                for (const manager of this._registeredManagers) {
                    const deviceSource = new DeviceSource(this._deviceInputSystem, deviceType, deviceSlot);
                    manager._addDevice(deviceSource);
                }
            };
            const onDeviceDisconnected = (deviceType, deviceSlot) => {
                var _a;
                if ((_a = this._devices[deviceType]) === null || _a === void 0 ? void 0 : _a[deviceSlot]) {
                    delete this._devices[deviceType][deviceSlot];
                }
                for (const manager of this._registeredManagers) {
                    manager._removeDevice(deviceType, deviceSlot);
                }
            };
            const onInputChanged = (deviceType, deviceSlot, eventData) => {
                if (eventData) {
                    for (const manager of this._registeredManagers) {
                        manager._onInputChanged(deviceType, deviceSlot, eventData);
                    }
                }
            };
            if (typeof _native !== "undefined") {
                this._deviceInputSystem = new NativeDeviceInputSystem(onDeviceConnected, onDeviceDisconnected, onInputChanged);
            }
            else {
                this._deviceInputSystem = new WebDeviceInputSystem(engine, onDeviceConnected, onDeviceDisconnected, onInputChanged);
            }
        }
        dispose() {
            this._deviceInputSystem.dispose();
        }
    }

    /**
     * Class to keep track of devices
     */
    class DeviceSourceManager {
        // Public Functions
        /**
         * Gets a DeviceSource, given a type and slot
         * @param deviceType - Type of Device
         * @param deviceSlot - Slot or ID of device
         * @returns DeviceSource
         */
        getDeviceSource(deviceType, deviceSlot) {
            if (deviceSlot === undefined) {
                if (this._firstDevice[deviceType] === undefined) {
                    return null;
                }
                deviceSlot = this._firstDevice[deviceType];
            }
            if (!this._devices[deviceType] || this._devices[deviceType][deviceSlot] === undefined) {
                return null;
            }
            return this._devices[deviceType][deviceSlot];
        }
        /**
         * Gets an array of DeviceSource objects for a given device type
         * @param deviceType - Type of Device
         * @returns All available DeviceSources of a given type
         */
        getDeviceSources(deviceType) {
            // If device type hasn't had any devices connected yet, return empty array.
            if (!this._devices[deviceType]) {
                return [];
            }
            return this._devices[deviceType].filter((source) => {
                return !!source;
            });
        }
        /**
         * Default constructor
         * @param engine - Used to get canvas (if applicable)
         */
        constructor(engine) {
            const numberOfDeviceTypes = Object.keys(DeviceType).length / 2;
            this._devices = new Array(numberOfDeviceTypes);
            this._firstDevice = new Array(numberOfDeviceTypes);
            this._engine = engine;
            if (!this._engine._deviceSourceManager) {
                this._engine._deviceSourceManager = new InternalDeviceSourceManager(engine);
            }
            this._engine._deviceSourceManager._refCount++;
            // Observables
            this.onDeviceConnectedObservable = new Observable$1((observer) => {
                for (const devices of this._devices) {
                    if (devices) {
                        for (const device of devices) {
                            if (device) {
                                this.onDeviceConnectedObservable.notifyObserver(observer, device);
                            }
                        }
                    }
                }
            });
            this.onDeviceDisconnectedObservable = new Observable$1();
            this._engine._deviceSourceManager.registerManager(this);
            this._onDisposeObserver = engine.onDisposeObservable.add(() => {
                this.dispose();
            });
        }
        /**
         * Dispose of DeviceSourceManager
         */
        dispose() {
            // Null out observable refs
            this.onDeviceConnectedObservable.clear();
            this.onDeviceDisconnectedObservable.clear();
            if (this._engine._deviceSourceManager) {
                this._engine._deviceSourceManager.unregisterManager(this);
                if (--this._engine._deviceSourceManager._refCount < 1) {
                    this._engine._deviceSourceManager.dispose();
                    delete this._engine._deviceSourceManager;
                }
            }
            this._engine.onDisposeObservable.remove(this._onDisposeObserver);
        }
        // Hidden Functions
        /**
         * @param deviceSource - Source to add
         * @internal
         */
        _addDevice(deviceSource) {
            if (!this._devices[deviceSource.deviceType]) {
                this._devices[deviceSource.deviceType] = new Array();
            }
            if (!this._devices[deviceSource.deviceType][deviceSource.deviceSlot]) {
                this._devices[deviceSource.deviceType][deviceSource.deviceSlot] = deviceSource;
                this._updateFirstDevices(deviceSource.deviceType);
            }
            this.onDeviceConnectedObservable.notifyObservers(deviceSource);
        }
        /**
         * @param deviceType - DeviceType
         * @param deviceSlot - DeviceSlot
         * @internal
         */
        _removeDevice(deviceType, deviceSlot) {
            var _a, _b;
            const deviceSource = (_a = this._devices[deviceType]) === null || _a === void 0 ? void 0 : _a[deviceSlot]; // Grab local reference to use before removing from devices
            this.onDeviceDisconnectedObservable.notifyObservers(deviceSource);
            if ((_b = this._devices[deviceType]) === null || _b === void 0 ? void 0 : _b[deviceSlot]) {
                delete this._devices[deviceType][deviceSlot];
            }
            // Even if we don't delete a device, we should still check for the first device as things may have gotten out of sync.
            this._updateFirstDevices(deviceType);
        }
        /**
         * @param deviceType - DeviceType
         * @param deviceSlot - DeviceSlot
         * @param eventData - Event
         * @internal
         */
        _onInputChanged(deviceType, deviceSlot, eventData) {
            var _a, _b;
            (_b = (_a = this._devices[deviceType]) === null || _a === void 0 ? void 0 : _a[deviceSlot]) === null || _b === void 0 ? void 0 : _b.onInputChangedObservable.notifyObservers(eventData);
        }
        // Private Functions
        _updateFirstDevices(type) {
            switch (type) {
                case DeviceType.Keyboard:
                case DeviceType.Mouse:
                    this._firstDevice[type] = 0;
                    break;
                case DeviceType.Touch:
                case DeviceType.DualSense:
                case DeviceType.DualShock:
                case DeviceType.Xbox:
                case DeviceType.Switch:
                case DeviceType.Generic: {
                    delete this._firstDevice[type];
                    // eslint-disable-next-line no-case-declarations
                    const devices = this._devices[type];
                    if (devices) {
                        for (let i = 0; i < devices.length; i++) {
                            if (devices[i]) {
                                this._firstDevice[type] = i;
                                break;
                            }
                        }
                    }
                    break;
                }
            }
        }
    }

    /** @internal */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _ClickInfo {
        constructor() {
            this._singleClick = false;
            this._doubleClick = false;
            this._hasSwiped = false;
            this._ignore = false;
        }
        get singleClick() {
            return this._singleClick;
        }
        get doubleClick() {
            return this._doubleClick;
        }
        get hasSwiped() {
            return this._hasSwiped;
        }
        get ignore() {
            return this._ignore;
        }
        set singleClick(b) {
            this._singleClick = b;
        }
        set doubleClick(b) {
            this._doubleClick = b;
        }
        set hasSwiped(b) {
            this._hasSwiped = b;
        }
        set ignore(b) {
            this._ignore = b;
        }
    }
    /**
     * Class used to manage all inputs for the scene.
     */
    class InputManager {
        /**
         * Creates a new InputManager
         * @param scene - defines the hosting scene
         */
        constructor(scene) {
            /** This is a defensive check to not allow control attachment prior to an already active one. If already attached, previous control is unattached before attaching the new one. */
            this._alreadyAttached = false;
            this._meshPickProceed = false;
            this._currentPickResult = null;
            this._previousPickResult = null;
            this._totalPointersPressed = 0;
            this._doubleClickOccured = false;
            this._isSwiping = false;
            this._swipeButtonPressed = -1;
            this._skipPointerTap = false;
            this._isMultiTouchGesture = false;
            this._pointerX = 0;
            this._pointerY = 0;
            this._startingPointerPosition = new Vector2(0, 0);
            this._previousStartingPointerPosition = new Vector2(0, 0);
            this._startingPointerTime = 0;
            this._previousStartingPointerTime = 0;
            this._pointerCaptures = {};
            this._meshUnderPointerId = {};
            this._movePointerInfo = null;
            this._cameraObserverCount = 0;
            this._delayedClicks = [null, null, null, null, null];
            this._deviceSourceManager = null;
            this._scene = scene || EngineStore.LastCreatedScene;
            if (!this._scene) {
                return;
            }
        }
        /**
         * Gets the mesh that is currently under the pointer
         * @returns Mesh that the pointer is pointer is hovering over
         */
        get meshUnderPointer() {
            if (this._movePointerInfo) {
                // Because _pointerOverMesh is populated as part of _pickMove, we need to force a pick to update it.
                // Calling _pickMove calls _setCursorAndPointerOverMesh which calls setPointerOverMesh
                this._movePointerInfo._generatePickInfo();
                // Once we have what we need, we can clear _movePointerInfo because we don't need it anymore
                this._movePointerInfo = null;
            }
            return this._pointerOverMesh;
        }
        /**
         * When using more than one pointer (for example in XR) you can get the mesh under the specific pointer
         * @param pointerId - the pointer id to use
         * @returns The mesh under this pointer id or null if not found
         */
        getMeshUnderPointerByPointerId(pointerId) {
            return this._meshUnderPointerId[pointerId] || null;
        }
        /**
         * Gets the pointer coordinates in 2D without any translation (ie. straight out of the pointer event)
         * @returns Vector with X/Y values directly from pointer event
         */
        get unTranslatedPointer() {
            return new Vector2(this._unTranslatedPointerX, this._unTranslatedPointerY);
        }
        /**
         * Gets or sets the current on-screen X position of the pointer
         * @returns Translated X with respect to screen
         */
        get pointerX() {
            return this._pointerX;
        }
        set pointerX(value) {
            this._pointerX = value;
        }
        /**
         * Gets or sets the current on-screen Y position of the pointer
         * @returns Translated Y with respect to screen
         */
        get pointerY() {
            return this._pointerY;
        }
        set pointerY(value) {
            this._pointerY = value;
        }
        _updatePointerPosition(evt) {
            const canvasRect = this._scene.getEngine().getInputElementClientRect();
            if (!canvasRect) {
                return;
            }
            this._pointerX = evt.clientX - canvasRect.left;
            this._pointerY = evt.clientY - canvasRect.top;
            this._unTranslatedPointerX = this._pointerX;
            this._unTranslatedPointerY = this._pointerY;
        }
        _processPointerMove(pickResult, evt) {
            const scene = this._scene;
            const engine = scene.getEngine();
            const canvas = engine.getInputElement();
            if (canvas) {
                canvas.tabIndex = engine.canvasTabIndex;
                // Restore pointer
                if (!scene.doNotHandleCursors) {
                    canvas.style.cursor = scene.defaultCursor;
                }
            }
            this._setCursorAndPointerOverMesh(pickResult, evt, scene);
            for (const step of scene._pointerMoveStage) {
                // If _pointerMoveState is defined, we have an active spriteManager and can't use Lazy Picking
                // Therefore, we need to force a pick to update the pickResult
                pickResult = pickResult || this._pickMove(evt);
                const isMeshPicked = (pickResult === null || pickResult === void 0 ? void 0 : pickResult.pickedMesh) ? true : false;
                pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, isMeshPicked, canvas);
            }
            const type = evt.inputIndex >= PointerInput.MouseWheelX && evt.inputIndex <= PointerInput.MouseWheelZ ? PointerEventTypes.POINTERWHEEL : PointerEventTypes.POINTERMOVE;
            if (scene.onPointerMove) {
                // Because of lazy picking, we need to force a pick to update the pickResult
                pickResult = pickResult || this._pickMove(evt);
                scene.onPointerMove(evt, pickResult, type);
            }
            let pointerInfo;
            if (pickResult) {
                pointerInfo = new PointerInfo(type, evt, pickResult);
                this._setRayOnPointerInfo(pickResult, evt);
            }
            else {
                pointerInfo = new PointerInfo(type, evt, null, this);
                this._movePointerInfo = pointerInfo;
            }
            if (scene.onPointerObservable.hasObservers()) {
                scene.onPointerObservable.notifyObservers(pointerInfo, type);
            }
        }
        // Pointers handling
        /** @internal */
        _setRayOnPointerInfo(pickInfo, event) {
            const scene = this._scene;
            if (pickInfo && scene._pickingAvailable) {
                if (!pickInfo.ray) {
                    pickInfo.ray = scene.createPickingRay(event.offsetX, event.offsetY, Matrix.Identity(), scene.activeCamera);
                }
            }
        }
        /** @internal */
        _addCameraPointerObserver(observer, mask) {
            this._cameraObserverCount++;
            return this._scene.onPointerObservable.add(observer, mask);
        }
        /** @internal */
        _removeCameraPointerObserver(observer) {
            this._cameraObserverCount--;
            return this._scene.onPointerObservable.remove(observer);
        }
        _checkForPicking() {
            return !!(this._scene.onPointerObservable.observers.length > this._cameraObserverCount || this._scene.onPointerPick);
        }
        _checkPrePointerObservable(pickResult, evt, type) {
            const scene = this._scene;
            const pi = new PointerInfoPre(type, evt, this._unTranslatedPointerX, this._unTranslatedPointerY);
            if (pickResult) {
                pi.originalPickingInfo = pickResult;
                pi.ray = pickResult.ray;
                if (pickResult.originMesh) {
                    pi.nearInteractionPickingInfo = pickResult;
                }
            }
            scene.onPrePointerObservable.notifyObservers(pi, type);
            if (pi.skipOnPointerObservable) {
                return true;
            }
            else {
                return false;
            }
        }
        /** @internal */
        _pickMove(evt) {
            const scene = this._scene;
            const pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerMovePredicate, scene.pointerMoveFastCheck, scene.cameraToUseForPointers, scene.pointerMoveTrianglePredicate);
            this._setCursorAndPointerOverMesh(pickResult, evt, scene);
            return pickResult;
        }
        _setCursorAndPointerOverMesh(pickResult, evt, scene) {
            const engine = scene.getEngine();
            const canvas = engine.getInputElement();
            if (pickResult === null || pickResult === void 0 ? void 0 : pickResult.pickedMesh) {
                this.setPointerOverMesh(pickResult.pickedMesh, evt.pointerId, pickResult, evt);
                if (!scene.doNotHandleCursors && canvas && this._pointerOverMesh) {
                    const actionManager = this._pointerOverMesh._getActionManagerForTrigger();
                    if (actionManager && actionManager.hasPointerTriggers) {
                        canvas.style.cursor = actionManager.hoverCursor || scene.hoverCursor;
                    }
                }
            }
            else {
                this.setPointerOverMesh(null, evt.pointerId, pickResult, evt);
            }
        }
        /**
         * Use this method to simulate a pointer move on a mesh
         * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
         * @param pickResult - pickingInfo of the object wished to simulate pointer event on
         * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
         */
        simulatePointerMove(pickResult, pointerEventInit) {
            const evt = new PointerEvent("pointermove", pointerEventInit);
            evt.inputIndex = PointerInput.Move;
            if (this._checkPrePointerObservable(pickResult, evt, PointerEventTypes.POINTERMOVE)) {
                return;
            }
            this._processPointerMove(pickResult, evt);
        }
        /**
         * Use this method to simulate a pointer down on a mesh
         * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
         * @param pickResult - pickingInfo of the object wished to simulate pointer event on
         * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
         */
        simulatePointerDown(pickResult, pointerEventInit) {
            const evt = new PointerEvent("pointerdown", pointerEventInit);
            evt.inputIndex = evt.button + 2;
            if (this._checkPrePointerObservable(pickResult, evt, PointerEventTypes.POINTERDOWN)) {
                return;
            }
            this._processPointerDown(pickResult, evt);
        }
        _processPointerDown(pickResult, evt) {
            const scene = this._scene;
            if (pickResult === null || pickResult === void 0 ? void 0 : pickResult.pickedMesh) {
                this._pickedDownMesh = pickResult.pickedMesh;
                const actionManager = pickResult.pickedMesh._getActionManagerForTrigger();
                if (actionManager) {
                    if (actionManager.hasPickTriggers) {
                        actionManager.processTrigger(5, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                        switch (evt.button) {
                            case 0:
                                actionManager.processTrigger(2, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                                break;
                            case 1:
                                actionManager.processTrigger(4, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                                break;
                            case 2:
                                actionManager.processTrigger(3, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                                break;
                        }
                    }
                    if (actionManager.hasSpecificTrigger(8)) {
                        window.setTimeout(() => {
                            const pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, (mesh) => ((mesh.isPickable &&
                                mesh.isVisible &&
                                mesh.isReady() &&
                                mesh.actionManager &&
                                mesh.actionManager.hasSpecificTrigger(8) &&
                                mesh === this._pickedDownMesh)), false, scene.cameraToUseForPointers);
                            if ((pickResult === null || pickResult === void 0 ? void 0 : pickResult.pickedMesh) && actionManager) {
                                if (this._totalPointersPressed !== 0 && Date.now() - this._startingPointerTime > InputManager.LongPressDelay && !this._isPointerSwiping()) {
                                    this._startingPointerTime = 0;
                                    actionManager.processTrigger(8, ActionEvent.CreateNew(pickResult.pickedMesh, evt));
                                }
                            }
                        }, InputManager.LongPressDelay);
                    }
                }
            }
            else {
                for (const step of scene._pointerDownStage) {
                    pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, evt, false);
                }
            }
            let pointerInfo;
            const type = PointerEventTypes.POINTERDOWN;
            if (pickResult) {
                if (scene.onPointerDown) {
                    scene.onPointerDown(evt, pickResult, type);
                }
                pointerInfo = new PointerInfo(type, evt, pickResult);
                this._setRayOnPointerInfo(pickResult, evt);
            }
            else {
                pointerInfo = new PointerInfo(type, evt, null, this);
            }
            if (scene.onPointerObservable.hasObservers()) {
                scene.onPointerObservable.notifyObservers(pointerInfo, type);
            }
        }
        /**
         * @internal
         * @internals Boolean if delta for pointer exceeds drag movement threshold
         */
        _isPointerSwiping() {
            return this._isSwiping;
        }
        /**
         * Use this method to simulate a pointer up on a mesh
         * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
         * @param pickResult - pickingInfo of the object wished to simulate pointer event on
         * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
         * @param doubleTap - indicates that the pointer up event should be considered as part of a double click (false by default)
         */
        simulatePointerUp(pickResult, pointerEventInit, doubleTap) {
            const evt = new PointerEvent("pointerup", pointerEventInit);
            evt.inputIndex = PointerInput.Move;
            const clickInfo = new _ClickInfo();
            if (doubleTap) {
                clickInfo.doubleClick = true;
            }
            else {
                clickInfo.singleClick = true;
            }
            if (this._checkPrePointerObservable(pickResult, evt, PointerEventTypes.POINTERUP)) {
                return;
            }
            this._processPointerUp(pickResult, evt, clickInfo);
        }
        _processPointerUp(pickResult, evt, clickInfo) {
            const scene = this._scene;
            if (pickResult === null || pickResult === void 0 ? void 0 : pickResult.pickedMesh) {
                this._pickedUpMesh = pickResult.pickedMesh;
                if (this._pickedDownMesh === this._pickedUpMesh) {
                    if (scene.onPointerPick) {
                        scene.onPointerPick(evt, pickResult);
                    }
                    if (clickInfo.singleClick && !clickInfo.ignore && scene.onPointerObservable.observers.length > this._cameraObserverCount) {
                        const type = PointerEventTypes.POINTERPICK;
                        const pi = new PointerInfo(type, evt, pickResult);
                        this._setRayOnPointerInfo(pickResult, evt);
                        scene.onPointerObservable.notifyObservers(pi, type);
                    }
                }
                const actionManager = pickResult.pickedMesh._getActionManagerForTrigger();
                if (actionManager && !clickInfo.ignore) {
                    actionManager.processTrigger(7, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                    if (!clickInfo.hasSwiped && clickInfo.singleClick) {
                        actionManager.processTrigger(1, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                    }
                    const doubleClickActionManager = pickResult.pickedMesh._getActionManagerForTrigger(6);
                    if (clickInfo.doubleClick && doubleClickActionManager) {
                        doubleClickActionManager.processTrigger(6, ActionEvent.CreateNew(pickResult.pickedMesh, evt, pickResult));
                    }
                }
            }
            else {
                if (!clickInfo.ignore) {
                    for (const step of scene._pointerUpStage) {
                        pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, evt, clickInfo.doubleClick);
                    }
                }
            }
            if (this._pickedDownMesh && this._pickedDownMesh !== this._pickedUpMesh) {
                const pickedDownActionManager = this._pickedDownMesh._getActionManagerForTrigger(16);
                if (pickedDownActionManager) {
                    pickedDownActionManager.processTrigger(16, ActionEvent.CreateNew(this._pickedDownMesh, evt));
                }
            }
            if (!clickInfo.ignore) {
                const pi = new PointerInfo(PointerEventTypes.POINTERUP, evt, pickResult);
                // Set ray on picking info.  Note that this info will also be reused for the tap notification.
                this._setRayOnPointerInfo(pickResult, evt);
                scene.onPointerObservable.notifyObservers(pi, PointerEventTypes.POINTERUP);
                if (scene.onPointerUp) {
                    scene.onPointerUp(evt, pickResult, PointerEventTypes.POINTERUP);
                }
                if (!clickInfo.hasSwiped && !this._skipPointerTap && !this._isMultiTouchGesture) {
                    let type = 0;
                    if (clickInfo.singleClick) {
                        type = PointerEventTypes.POINTERTAP;
                    }
                    else if (clickInfo.doubleClick) {
                        type = PointerEventTypes.POINTERDOUBLETAP;
                    }
                    if (type) {
                        const pi = new PointerInfo(type, evt, pickResult);
                        if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) {
                            scene.onPointerObservable.notifyObservers(pi, type);
                        }
                    }
                }
            }
        }
        /**
         * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
         * @param pointerId - defines the pointer id to use in a multi-touch scenario (0 by default)
         * @returns true if the pointer was captured
         */
        isPointerCaptured(pointerId = 0) {
            return this._pointerCaptures[pointerId];
        }
        /**
         * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
         * @param attachUp - defines if you want to attach events to pointerup
         * @param attachDown - defines if you want to attach events to pointerdown
         * @param attachMove - defines if you want to attach events to pointermove
         * @param elementToAttachTo - defines the target DOM element to attach to (will use the canvas by default)
         */
        attachControl(attachUp = true, attachDown = true, attachMove = true, elementToAttachTo = null) {
            const scene = this._scene;
            const engine = scene.getEngine();
            if (!elementToAttachTo) {
                elementToAttachTo = engine.getInputElement();
            }
            if (this._alreadyAttached) {
                this.detachControl();
            }
            if (elementToAttachTo) {
                this._alreadyAttachedTo = elementToAttachTo;
            }
            this._deviceSourceManager = new DeviceSourceManager(engine);
            // Because this is only called from _initClickEvent, which is called in _onPointerUp, we'll use the pointerUpPredicate for the pick call
            this._initActionManager = (act) => {
                if (!this._meshPickProceed) {
                    const pickResult = scene.skipPointerUpPicking || (scene._registeredActions === 0 && !this._checkForPicking() && !scene.onPointerUp)
                        ? null
                        : scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerUpPredicate, scene.pointerUpFastCheck, scene.cameraToUseForPointers);
                    this._currentPickResult = pickResult;
                    if (pickResult) {
                        act = pickResult.hit && pickResult.pickedMesh ? pickResult.pickedMesh._getActionManagerForTrigger() : null;
                    }
                    this._meshPickProceed = true;
                }
                return act;
            };
            this._delayedSimpleClick = (btn, clickInfo, cb) => {
                // double click delay is over and that no double click has been raised since, or the 2 consecutive keys pressed are different
                if ((Date.now() - this._previousStartingPointerTime > InputManager.DoubleClickDelay && !this._doubleClickOccured) || btn !== this._previousButtonPressed) {
                    this._doubleClickOccured = false;
                    clickInfo.singleClick = true;
                    clickInfo.ignore = false;
                    // If we have a delayed click, we need to resolve the TAP event
                    if (this._delayedClicks[btn]) {
                        const evt = this._delayedClicks[btn].evt;
                        const type = PointerEventTypes.POINTERTAP;
                        const pi = new PointerInfo(type, evt, this._currentPickResult);
                        if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) {
                            scene.onPointerObservable.notifyObservers(pi, type);
                        }
                        // Clear the delayed click
                        this._delayedClicks[btn] = null;
                    }
                }
            };
            this._initClickEvent = (obs1, obs2, evt, cb) => {
                var _a, _b;
                const clickInfo = new _ClickInfo();
                this._currentPickResult = null;
                let act = null;
                let checkPicking = obs1.hasSpecificMask(PointerEventTypes.POINTERPICK) ||
                    obs2.hasSpecificMask(PointerEventTypes.POINTERPICK) ||
                    obs1.hasSpecificMask(PointerEventTypes.POINTERTAP) ||
                    obs2.hasSpecificMask(PointerEventTypes.POINTERTAP) ||
                    obs1.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP) ||
                    obs2.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP);
                if (!checkPicking && AbstractActionManager) {
                    act = this._initActionManager(act, clickInfo);
                    if (act) {
                        checkPicking = act.hasPickTriggers;
                    }
                }
                let needToIgnoreNext = false;
                if (checkPicking) {
                    const btn = evt.button;
                    clickInfo.hasSwiped = this._isPointerSwiping();
                    if (!clickInfo.hasSwiped) {
                        let checkSingleClickImmediately = !InputManager.ExclusiveDoubleClickMode;
                        if (!checkSingleClickImmediately) {
                            checkSingleClickImmediately = !obs1.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP) && !obs2.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP);
                            if (checkSingleClickImmediately && !AbstractActionManager.HasSpecificTrigger(6)) {
                                act = this._initActionManager(act, clickInfo);
                                if (act) {
                                    checkSingleClickImmediately = !act.hasSpecificTrigger(6);
                                }
                            }
                        }
                        if (checkSingleClickImmediately) {
                            // single click detected if double click delay is over or two different successive keys pressed without exclusive double click or no double click required
                            if (Date.now() - this._previousStartingPointerTime > InputManager.DoubleClickDelay || btn !== this._previousButtonPressed) {
                                clickInfo.singleClick = true;
                                cb(clickInfo, this._currentPickResult);
                                needToIgnoreNext = true;
                            }
                        }
                        // at least one double click is required to be check and exclusive double click is enabled
                        else {
                            // Queue up a delayed click, just in case this isn't a double click
                            // It should be noted that while this delayed event happens
                            // because of user input, it shouldn't be considered as a direct,
                            // timing-dependent result of that input.  It's meant to just fire the TAP event
                            const delayedClick = {
                                evt: evt,
                                clickInfo: clickInfo,
                                timeoutId: window.setTimeout(this._delayedSimpleClick.bind(this, btn, clickInfo, cb), InputManager.DoubleClickDelay),
                            };
                            this._delayedClicks[btn] = delayedClick;
                        }
                        let checkDoubleClick = obs1.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP) || obs2.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP);
                        if (!checkDoubleClick && AbstractActionManager.HasSpecificTrigger(6)) {
                            act = this._initActionManager(act, clickInfo);
                            if (act) {
                                checkDoubleClick = act.hasSpecificTrigger(6);
                            }
                        }
                        if (checkDoubleClick) {
                            // two successive keys pressed are equal, double click delay is not over and double click has not just occurred
                            if (btn === this._previousButtonPressed && Date.now() - this._previousStartingPointerTime < InputManager.DoubleClickDelay && !this._doubleClickOccured) {
                                // pointer has not moved for 2 clicks, it's a double click
                                if (!clickInfo.hasSwiped && !this._isPointerSwiping()) {
                                    this._previousStartingPointerTime = 0;
                                    this._doubleClickOccured = true;
                                    clickInfo.doubleClick = true;
                                    clickInfo.ignore = false;
                                    // If we have a pending click, we need to cancel it
                                    if (InputManager.ExclusiveDoubleClickMode && this._delayedClicks[btn]) {
                                        clearTimeout((_a = this._delayedClicks[btn]) === null || _a === void 0 ? void 0 : _a.timeoutId);
                                        this._delayedClicks[btn] = null;
                                    }
                                    cb(clickInfo, this._currentPickResult);
                                }
                                // if the two successive clicks are too far, it's just two simple clicks
                                else {
                                    this._doubleClickOccured = false;
                                    this._previousStartingPointerTime = this._startingPointerTime;
                                    this._previousStartingPointerPosition.x = this._startingPointerPosition.x;
                                    this._previousStartingPointerPosition.y = this._startingPointerPosition.y;
                                    this._previousButtonPressed = btn;
                                    if (InputManager.ExclusiveDoubleClickMode) {
                                        // If we have a delayed click, we need to cancel it
                                        if (this._delayedClicks[btn]) {
                                            clearTimeout((_b = this._delayedClicks[btn]) === null || _b === void 0 ? void 0 : _b.timeoutId);
                                            this._delayedClicks[btn] = null;
                                        }
                                        cb(clickInfo, this._previousPickResult);
                                    }
                                    else {
                                        cb(clickInfo, this._currentPickResult);
                                    }
                                }
                                needToIgnoreNext = true;
                            }
                            // just the first click of the double has been raised
                            else {
                                this._doubleClickOccured = false;
                                this._previousStartingPointerTime = this._startingPointerTime;
                                this._previousStartingPointerPosition.x = this._startingPointerPosition.x;
                                this._previousStartingPointerPosition.y = this._startingPointerPosition.y;
                                this._previousButtonPressed = btn;
                            }
                        }
                    }
                }
                // Even if ExclusiveDoubleClickMode is true, we need to always handle
                // up events at time of execution, unless we're explicitly ignoring them.
                if (!needToIgnoreNext) {
                    cb(clickInfo, this._currentPickResult);
                }
            };
            this._onPointerMove = (evt) => {
                this._updatePointerPosition(evt);
                // Check if pointer leaves DragMovementThreshold range to determine if swipe is occurring
                if (!this._isSwiping && this._swipeButtonPressed !== -1) {
                    this._isSwiping =
                        Math.abs(this._startingPointerPosition.x - this._pointerX) > InputManager.DragMovementThreshold ||
                            Math.abs(this._startingPointerPosition.y - this._pointerY) > InputManager.DragMovementThreshold;
                }
                // Because there's a race condition between pointermove and pointerlockchange events, we need to
                // verify that the pointer is still locked after each pointermove event.
                if (engine.isPointerLock) {
                    engine._verifyPointerLock();
                }
                // PreObservable support
                if (this._checkPrePointerObservable(null, evt, evt.inputIndex >= PointerInput.MouseWheelX && evt.inputIndex <= PointerInput.MouseWheelZ ? PointerEventTypes.POINTERWHEEL : PointerEventTypes.POINTERMOVE)) {
                    return;
                }
                if (!scene.cameraToUseForPointers && !scene.activeCamera) {
                    return;
                }
                if (scene.skipPointerMovePicking) {
                    this._processPointerMove(new PickingInfo(), evt);
                    return;
                }
                if (!scene.pointerMovePredicate) {
                    scene.pointerMovePredicate = (mesh) => mesh.isPickable &&
                        mesh.isVisible &&
                        mesh.isReady() &&
                        mesh.isEnabled() &&
                        (mesh.enablePointerMoveEvents || scene.constantlyUpdateMeshUnderPointer || mesh._getActionManagerForTrigger() !== null) &&
                        (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
                }
                const pickResult = scene._registeredActions > 0 || scene.constantlyUpdateMeshUnderPointer ? this._pickMove(evt) : null;
                this._processPointerMove(pickResult, evt);
            };
            this._onPointerDown = (evt) => {
                var _a;
                this._totalPointersPressed++;
                this._pickedDownMesh = null;
                this._meshPickProceed = false;
                // If ExclusiveDoubleClickMode is true, we need to resolve any pending delayed clicks
                if (InputManager.ExclusiveDoubleClickMode) {
                    for (let i = 0; i < this._delayedClicks.length; i++) {
                        if (this._delayedClicks[i]) {
                            // If the button that was pressed is the same as the one that was released,
                            // just clear the timer.  This will be resolved in the up event.
                            if (evt.button === i) {
                                clearTimeout((_a = this._delayedClicks[i]) === null || _a === void 0 ? void 0 : _a.timeoutId);
                            }
                            else {
                                // Otherwise, we need to resolve the click
                                const clickInfo = this._delayedClicks[i].clickInfo;
                                this._doubleClickOccured = false;
                                clickInfo.singleClick = true;
                                clickInfo.ignore = false;
                                const prevEvt = this._delayedClicks[i].evt;
                                const type = PointerEventTypes.POINTERTAP;
                                const pi = new PointerInfo(type, prevEvt, this._currentPickResult);
                                if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) {
                                    scene.onPointerObservable.notifyObservers(pi, type);
                                }
                                // Clear the delayed click
                                this._delayedClicks[i] = null;
                            }
                        }
                    }
                }
                this._updatePointerPosition(evt);
                if (this._swipeButtonPressed === -1) {
                    this._swipeButtonPressed = evt.button;
                }
                if (scene.preventDefaultOnPointerDown && elementToAttachTo) {
                    evt.preventDefault();
                    elementToAttachTo.focus();
                }
                this._startingPointerPosition.x = this._pointerX;
                this._startingPointerPosition.y = this._pointerY;
                this._startingPointerTime = Date.now();
                // PreObservable support
                if (this._checkPrePointerObservable(null, evt, PointerEventTypes.POINTERDOWN)) {
                    return;
                }
                if (!scene.cameraToUseForPointers && !scene.activeCamera) {
                    return;
                }
                this._pointerCaptures[evt.pointerId] = true;
                if (!scene.pointerDownPredicate) {
                    scene.pointerDownPredicate = (mesh) => {
                        return (mesh.isPickable &&
                            mesh.isVisible &&
                            mesh.isReady() &&
                            mesh.isEnabled() &&
                            (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0));
                    };
                }
                // Meshes
                this._pickedDownMesh = null;
                let pickResult;
                if (scene.skipPointerDownPicking || (scene._registeredActions === 0 && !this._checkForPicking() && !scene.onPointerDown)) {
                    pickResult = new PickingInfo();
                }
                else {
                    pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerDownPredicate, scene.pointerDownFastCheck, scene.cameraToUseForPointers);
                }
                this._processPointerDown(pickResult, evt);
            };
            this._onPointerUp = (evt) => {
                if (this._totalPointersPressed === 0) {
                    // We are attaching the pointer up to windows because of a bug in FF
                    return; // So we need to test it the pointer down was pressed before.
                }
                this._totalPointersPressed--;
                this._pickedUpMesh = null;
                this._meshPickProceed = false;
                this._updatePointerPosition(evt);
                if (scene.preventDefaultOnPointerUp && elementToAttachTo) {
                    evt.preventDefault();
                    elementToAttachTo.focus();
                }
                this._initClickEvent(scene.onPrePointerObservable, scene.onPointerObservable, evt, (clickInfo, pickResult) => {
                    // PreObservable support
                    if (scene.onPrePointerObservable.hasObservers()) {
                        this._skipPointerTap = false;
                        if (!clickInfo.ignore) {
                            if (this._checkPrePointerObservable(null, evt, PointerEventTypes.POINTERUP)) {
                                // If we're skipping the next observable, we need to reset the swipe state before returning
                                if (this._swipeButtonPressed === evt.button) {
                                    this._isSwiping = false;
                                    this._swipeButtonPressed = -1;
                                }
                                // If we're going to skip the POINTERUP, we need to reset the pointer capture
                                if (evt.buttons === 0) {
                                    this._pointerCaptures[evt.pointerId] = false;
                                }
                                return;
                            }
                            if (!clickInfo.hasSwiped) {
                                if (clickInfo.singleClick && scene.onPrePointerObservable.hasSpecificMask(PointerEventTypes.POINTERTAP)) {
                                    if (this._checkPrePointerObservable(null, evt, PointerEventTypes.POINTERTAP)) {
                                        this._skipPointerTap = true;
                                    }
                                }
                                if (clickInfo.doubleClick && scene.onPrePointerObservable.hasSpecificMask(PointerEventTypes.POINTERDOUBLETAP)) {
                                    if (this._checkPrePointerObservable(null, evt, PointerEventTypes.POINTERDOUBLETAP)) {
                                        this._skipPointerTap = true;
                                    }
                                }
                            }
                        }
                    }
                    // There should be a pointer captured at this point so if there isn't we should reset and return
                    if (!this._pointerCaptures[evt.pointerId]) {
                        if (this._swipeButtonPressed === evt.button) {
                            this._isSwiping = false;
                            this._swipeButtonPressed = -1;
                        }
                        return;
                    }
                    // Only release capture if all buttons are released
                    if (evt.buttons === 0) {
                        this._pointerCaptures[evt.pointerId] = false;
                    }
                    if (!scene.cameraToUseForPointers && !scene.activeCamera) {
                        return;
                    }
                    if (!scene.pointerUpPredicate) {
                        scene.pointerUpPredicate = (mesh) => {
                            return (mesh.isPickable &&
                                mesh.isVisible &&
                                mesh.isReady() &&
                                mesh.isEnabled() &&
                                (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0));
                        };
                    }
                    // Meshes
                    if (!this._meshPickProceed && ((AbstractActionManager && AbstractActionManager.HasTriggers) || this._checkForPicking() || scene.onPointerUp)) {
                        this._initActionManager(null, clickInfo);
                    }
                    if (!pickResult) {
                        pickResult = this._currentPickResult;
                    }
                    this._processPointerUp(pickResult, evt, clickInfo);
                    this._previousPickResult = this._currentPickResult;
                    if (this._swipeButtonPressed === evt.button) {
                        this._isSwiping = false;
                        this._swipeButtonPressed = -1;
                    }
                });
            };
            this._onKeyDown = (evt) => {
                const type = KeyboardEventTypes.KEYDOWN;
                if (scene.onPreKeyboardObservable.hasObservers()) {
                    const pi = new KeyboardInfoPre(type, evt);
                    scene.onPreKeyboardObservable.notifyObservers(pi, type);
                    if (pi.skipOnKeyboardObservable) {
                        return;
                    }
                }
                if (scene.onKeyboardObservable.hasObservers()) {
                    const pi = new KeyboardInfo(type, evt);
                    scene.onKeyboardObservable.notifyObservers(pi, type);
                }
                if (scene.actionManager) {
                    scene.actionManager.processTrigger(14, ActionEvent.CreateNewFromScene(scene, evt));
                }
            };
            this._onKeyUp = (evt) => {
                const type = KeyboardEventTypes.KEYUP;
                if (scene.onPreKeyboardObservable.hasObservers()) {
                    const pi = new KeyboardInfoPre(type, evt);
                    scene.onPreKeyboardObservable.notifyObservers(pi, type);
                    if (pi.skipOnKeyboardObservable) {
                        return;
                    }
                }
                if (scene.onKeyboardObservable.hasObservers()) {
                    const pi = new KeyboardInfo(type, evt);
                    scene.onKeyboardObservable.notifyObservers(pi, type);
                }
                if (scene.actionManager) {
                    scene.actionManager.processTrigger(15, ActionEvent.CreateNewFromScene(scene, evt));
                }
            };
            // If a device connects that we can handle, wire up the observable
            this._deviceSourceManager.onDeviceConnectedObservable.add((deviceSource) => {
                if (deviceSource.deviceType === DeviceType.Mouse) {
                    deviceSource.onInputChangedObservable.add((eventData) => {
                        if (eventData.inputIndex === PointerInput.LeftClick ||
                            eventData.inputIndex === PointerInput.MiddleClick ||
                            eventData.inputIndex === PointerInput.RightClick ||
                            eventData.inputIndex === PointerInput.BrowserBack ||
                            eventData.inputIndex === PointerInput.BrowserForward) {
                            if (attachDown && deviceSource.getInput(eventData.inputIndex) === 1) {
                                this._onPointerDown(eventData);
                            }
                            else if (attachUp && deviceSource.getInput(eventData.inputIndex) === 0) {
                                this._onPointerUp(eventData);
                            }
                        }
                        else if (attachMove) {
                            if (eventData.inputIndex === PointerInput.Move) {
                                this._onPointerMove(eventData);
                            }
                            else if (eventData.inputIndex === PointerInput.MouseWheelX ||
                                eventData.inputIndex === PointerInput.MouseWheelY ||
                                eventData.inputIndex === PointerInput.MouseWheelZ) {
                                this._onPointerMove(eventData);
                            }
                        }
                    });
                }
                else if (deviceSource.deviceType === DeviceType.Touch) {
                    deviceSource.onInputChangedObservable.add((eventData) => {
                        if (eventData.inputIndex === PointerInput.LeftClick) {
                            if (attachDown && deviceSource.getInput(eventData.inputIndex) === 1) {
                                this._onPointerDown(eventData);
                                if (this._totalPointersPressed > 1) {
                                    this._isMultiTouchGesture = true;
                                }
                            }
                            else if (attachUp && deviceSource.getInput(eventData.inputIndex) === 0) {
                                this._onPointerUp(eventData);
                                if (this._totalPointersPressed === 0) {
                                    this._isMultiTouchGesture = false;
                                }
                            }
                        }
                        if (attachMove && eventData.inputIndex === PointerInput.Move) {
                            this._onPointerMove(eventData);
                        }
                    });
                }
                else if (deviceSource.deviceType === DeviceType.Keyboard) {
                    deviceSource.onInputChangedObservable.add((eventData) => {
                        if (eventData.type === "keydown") {
                            this._onKeyDown(eventData);
                        }
                        else if (eventData.type === "keyup") {
                            this._onKeyUp(eventData);
                        }
                    });
                }
            });
            this._alreadyAttached = true;
        }
        /**
         * Detaches all event handlers
         */
        detachControl() {
            if (this._alreadyAttached) {
                this._deviceSourceManager.dispose();
                this._deviceSourceManager = null;
                // Cursor
                if (this._alreadyAttachedTo && !this._scene.doNotHandleCursors) {
                    this._alreadyAttachedTo.style.cursor = this._scene.defaultCursor;
                }
                this._alreadyAttached = false;
                this._alreadyAttachedTo = null;
            }
        }
        /**
         * Force the value of meshUnderPointer
         * @param mesh - defines the mesh to use
         * @param pointerId - optional pointer id when using more than one pointer. Defaults to 0
         * @param pickResult - optional pickingInfo data used to find mesh
         * @param evt - optional pointer event
         */
        setPointerOverMesh(mesh, pointerId = 0, pickResult, evt) {
            if (this._meshUnderPointerId[pointerId] === mesh && (!mesh || !mesh._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting)) {
                return;
            }
            const underPointerMesh = this._meshUnderPointerId[pointerId];
            let actionManager;
            if (underPointerMesh) {
                actionManager = underPointerMesh._getActionManagerForTrigger(10);
                if (actionManager) {
                    actionManager.processTrigger(10, ActionEvent.CreateNew(underPointerMesh, evt, { pointerId }));
                }
            }
            if (mesh) {
                this._meshUnderPointerId[pointerId] = mesh;
                this._pointerOverMesh = mesh;
                actionManager = mesh._getActionManagerForTrigger(9);
                if (actionManager) {
                    actionManager.processTrigger(9, ActionEvent.CreateNew(mesh, evt, { pointerId, pickResult }));
                }
            }
            else {
                delete this._meshUnderPointerId[pointerId];
                this._pointerOverMesh = null;
            }
        }
        /**
         * Gets the mesh under the pointer
         * @returns a Mesh or null if no mesh is under the pointer
         */
        getPointerOverMesh() {
            return this.meshUnderPointer;
        }
        /**
         * @param mesh - Mesh to invalidate
         * @internal
         */
        _invalidateMesh(mesh) {
            if (this._pointerOverMesh === mesh) {
                this._pointerOverMesh = null;
            }
            if (this._pickedDownMesh === mesh) {
                this._pickedDownMesh = null;
            }
            if (this._pickedUpMesh === mesh) {
                this._pickedUpMesh = null;
            }
            for (const pointerId in this._meshUnderPointerId) {
                if (this._meshUnderPointerId[pointerId] === mesh) {
                    delete this._meshUnderPointerId[pointerId];
                }
            }
        }
    }
    /** The distance in pixel that you have to move to prevent some events */
    InputManager.DragMovementThreshold = 10; // in pixels
    /** Time in milliseconds to wait to raise long press events if button is still pressed */
    InputManager.LongPressDelay = 500; // in milliseconds
    /** Time in milliseconds with two consecutive clicks will be considered as a double click */
    InputManager.DoubleClickDelay = 300; // in milliseconds
    /**
     * This flag will modify the behavior so that, when true, a click will happen if and only if
     * another click DOES NOT happen within the DoubleClickDelay time frame.  If another click does
     * happen within that time frame, the first click will not fire an event and and a double click will occur.
     */
    InputManager.ExclusiveDoubleClickMode = false;

    /**
     * This class is used to track a performance counter which is number based.
     * The user has access to many properties which give statistics of different nature.
     *
     * The implementer can track two kinds of Performance Counter: time and count.
     * For time you can optionally call fetchNewFrame() to notify the start of a new frame to monitor, then call beginMonitoring() to start and endMonitoring() to record the lapsed time. endMonitoring takes a newFrame parameter for you to specify if the monitored time should be set for a new frame or accumulated to the current frame being monitored.
     * For count you first have to call fetchNewFrame() to notify the start of a new frame to monitor, then call addCount() how many time required to increment the count value you monitor.
     */
    class PerfCounter {
        /**
         * Returns the smallest value ever
         */
        get min() {
            return this._min;
        }
        /**
         * Returns the biggest value ever
         */
        get max() {
            return this._max;
        }
        /**
         * Returns the average value since the performance counter is running
         */
        get average() {
            return this._average;
        }
        /**
         * Returns the average value of the last second the counter was monitored
         */
        get lastSecAverage() {
            return this._lastSecAverage;
        }
        /**
         * Returns the current value
         */
        get current() {
            return this._current;
        }
        /**
         * Gets the accumulated total
         */
        get total() {
            return this._totalAccumulated;
        }
        /**
         * Gets the total value count
         */
        get count() {
            return this._totalValueCount;
        }
        /**
         * Creates a new counter
         */
        constructor() {
            this._startMonitoringTime = 0;
            this._min = 0;
            this._max = 0;
            this._average = 0;
            this._lastSecAverage = 0;
            this._current = 0;
            this._totalValueCount = 0;
            this._totalAccumulated = 0;
            this._lastSecAccumulated = 0;
            this._lastSecTime = 0;
            this._lastSecValueCount = 0;
        }
        /**
         * Call this method to start monitoring a new frame.
         * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the start of the frame, then beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
         */
        fetchNewFrame() {
            this._totalValueCount++;
            this._current = 0;
            this._lastSecValueCount++;
        }
        /**
         * Call this method to monitor a count of something (e.g. mesh drawn in viewport count)
         * @param newCount the count value to add to the monitored count
         * @param fetchResult true when it's the last time in the frame you add to the counter and you wish to update the statistics properties (min/max/average), false if you only want to update statistics.
         */
        addCount(newCount, fetchResult) {
            if (!PerfCounter.Enabled) {
                return;
            }
            this._current += newCount;
            if (fetchResult) {
                this._fetchResult();
            }
        }
        /**
         * Start monitoring this performance counter
         */
        beginMonitoring() {
            if (!PerfCounter.Enabled) {
                return;
            }
            this._startMonitoringTime = PrecisionDate.Now;
        }
        /**
         * Compute the time lapsed since the previous beginMonitoring() call.
         * @param newFrame true by default to fetch the result and monitor a new frame, if false the time monitored will be added to the current frame counter
         */
        endMonitoring(newFrame = true) {
            if (!PerfCounter.Enabled) {
                return;
            }
            if (newFrame) {
                this.fetchNewFrame();
            }
            const currentTime = PrecisionDate.Now;
            this._current = currentTime - this._startMonitoringTime;
            if (newFrame) {
                this._fetchResult();
            }
        }
        /**
         * Call this method to end the monitoring of a frame.
         * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the end of the frame, after beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
         */
        endFrame() {
            this._fetchResult();
        }
        _fetchResult() {
            this._totalAccumulated += this._current;
            this._lastSecAccumulated += this._current;
            // Min/Max update
            this._min = Math.min(this._min, this._current);
            this._max = Math.max(this._max, this._current);
            this._average = this._totalAccumulated / this._totalValueCount;
            // Reset last sec?
            const now = PrecisionDate.Now;
            if (now - this._lastSecTime > 1000) {
                this._lastSecAverage = this._lastSecAccumulated / this._lastSecValueCount;
                this._lastSecTime = now;
                this._lastSecAccumulated = 0;
                this._lastSecValueCount = 0;
            }
        }
    }
    /**
     * Gets or sets a global boolean to turn on and off all the counters
     */
    PerfCounter.Enabled = true;

    /**
     * Helper class used to generate session unique ID
     */
    class UniqueIdGenerator {
        /**
         * Gets an unique (relatively to the current scene) Id
         */
        static get UniqueId() {
            const result = this._UniqueIdCounter;
            this._UniqueIdCounter++;
            return result;
        }
    }
    // Statics
    UniqueIdGenerator._UniqueIdCounter = 1;

    /** Defines the cross module constantsused by lights to avoid circular dependencies */
    class LightConstants {
        /**
         * Sort function to order lights for rendering.
         * @param a First Light object to compare to second.
         * @param b Second Light object to compare first.
         * @returns -1 to reduce's a's index relative to be, 0 for no change, 1 to increase a's index relative to b.
         */
        static CompareLightsPriority(a, b) {
            //shadow-casting lights have priority over non-shadow-casting lights
            //the renderPriority is a secondary sort criterion
            if (a.shadowEnabled !== b.shadowEnabled) {
                return (b.shadowEnabled ? 1 : 0) - (a.shadowEnabled ? 1 : 0);
            }
            return b.renderPriority - a.renderPriority;
        }
    }
    /**
     * Falloff Default: light is falling off following the material specification:
     * standard material is using standard falloff whereas pbr material can request special falloff per materials.
     */
    LightConstants.FALLOFF_DEFAULT = 0;
    /**
     * Falloff Physical: light is falling off following the inverse squared distance law.
     */
    LightConstants.FALLOFF_PHYSICAL = 1;
    /**
     * Falloff gltf: light is falling off as described in the gltf moving to PBR document
     * to enhance interoperability with other engines.
     */
    LightConstants.FALLOFF_GLTF = 2;
    /**
     * Falloff Standard: light is falling off like in the standard material
     * to enhance interoperability with other materials.
     */
    LightConstants.FALLOFF_STANDARD = 3;
    //lightmapMode Consts
    /**
     * If every light affecting the material is in this lightmapMode,
     * material.lightmapTexture adds or multiplies
     * (depends on material.useLightmapAsShadowmap)
     * after every other light calculations.
     */
    LightConstants.LIGHTMAP_DEFAULT = 0;
    /**
     * material.lightmapTexture as only diffuse lighting from this light
     * adds only specular lighting from this light
     * adds dynamic shadows
     */
    LightConstants.LIGHTMAP_SPECULAR = 1;
    /**
     * material.lightmapTexture as only lighting
     * no light calculation from this light
     * only adds dynamic shadows from this light
     */
    LightConstants.LIGHTMAP_SHADOWSONLY = 2;
    // Intensity Mode Consts
    /**
     * Each light type uses the default quantity according to its type:
     *      point/spot lights use luminous intensity
     *      directional lights use illuminance
     */
    LightConstants.INTENSITYMODE_AUTOMATIC = 0;
    /**
     * lumen (lm)
     */
    LightConstants.INTENSITYMODE_LUMINOUSPOWER = 1;
    /**
     * candela (lm/sr)
     */
    LightConstants.INTENSITYMODE_LUMINOUSINTENSITY = 2;
    /**
     * lux (lm/m^2)
     */
    LightConstants.INTENSITYMODE_ILLUMINANCE = 3;
    /**
     * nit (cd/m^2)
     */
    LightConstants.INTENSITYMODE_LUMINANCE = 4;
    // Light types ids const.
    /**
     * Light type const id of the point light.
     */
    LightConstants.LIGHTTYPEID_POINTLIGHT = 0;
    /**
     * Light type const id of the directional light.
     */
    LightConstants.LIGHTTYPEID_DIRECTIONALLIGHT = 1;
    /**
     * Light type const id of the spot light.
     */
    LightConstants.LIGHTTYPEID_SPOTLIGHT = 2;
    /**
     * Light type const id of the hemispheric light.
     */
    LightConstants.LIGHTTYPEID_HEMISPHERICLIGHT = 3;

    /**
     * Class used to store configuration data associated with pointer picking
     */
    class PointerPickingConfiguration {
        constructor() {
            /**
             * Gets or sets a predicate used to select candidate meshes for a pointer down event
             */
            this.pointerDownFastCheck = false;
            /**
             * Gets or sets a predicate used to select candidate meshes for a pointer up event
             */
            this.pointerUpFastCheck = false;
            /**
             * Gets or sets a predicate used to select candidate meshes for a pointer move event
             */
            this.pointerMoveFastCheck = false;
            /**
             * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
             */
            this.skipPointerMovePicking = false;
            /**
             * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
             */
            this.skipPointerDownPicking = false;
            /**
             * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
             */
            this.skipPointerUpPicking = false;
        }
    }

    /**
     * Define how the scene should favor performance over ease of use
     */
    var ScenePerformancePriority;
    (function (ScenePerformancePriority) {
        /** Default mode. No change. Performance will be treated as less important than backward compatibility */
        ScenePerformancePriority[ScenePerformancePriority["BackwardCompatible"] = 0] = "BackwardCompatible";
        /** Some performance options will be turned on trying to strike a balance between perf and ease of use */
        ScenePerformancePriority[ScenePerformancePriority["Intermediate"] = 1] = "Intermediate";
        /** Performance will be top priority */
        ScenePerformancePriority[ScenePerformancePriority["Aggressive"] = 2] = "Aggressive";
    })(ScenePerformancePriority || (ScenePerformancePriority = {}));
    /**
     * Represents a scene to be rendered by the engine.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene
     */
    class Scene extends AbstractScene {
        /**
         * Factory used to create the default material.
         * @param scene The scene to create the material for
         * @returns The default material
         */
        static DefaultMaterialFactory(scene) {
            throw _WarnImport("StandardMaterial");
        }
        /**
         * Factory used to create the a collision coordinator.
         * @returns The collision coordinator
         */
        static CollisionCoordinatorFactory() {
            throw _WarnImport("DefaultCollisionCoordinator");
        }
        /**
         * Texture used in all pbr material as the reflection texture.
         * As in the majority of the scene they are the same (exception for multi room and so on),
         * this is easier to reference from here than from all the materials.
         */
        get environmentTexture() {
            return this._environmentTexture;
        }
        /**
         * Texture used in all pbr material as the reflection texture.
         * As in the majority of the scene they are the same (exception for multi room and so on),
         * this is easier to set here than in all the materials.
         */
        set environmentTexture(value) {
            if (this._environmentTexture === value) {
                return;
            }
            this._environmentTexture = value;
            this.markAllMaterialsAsDirty(1);
        }
        /**
         * Default image processing configuration used either in the rendering
         * Forward main pass or through the imageProcessingPostProcess if present.
         * As in the majority of the scene they are the same (exception for multi camera),
         * this is easier to reference from here than from all the materials and post process.
         *
         * No setter as we it is a shared configuration, you can set the values instead.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Gets or sets a value indicating how to treat performance relatively to ease of use and backward compatibility
         */
        get performancePriority() {
            return this._performancePriority;
        }
        set performancePriority(value) {
            if (value === this._performancePriority) {
                return;
            }
            this._performancePriority = value;
            switch (value) {
                case ScenePerformancePriority.BackwardCompatible:
                    this.skipFrustumClipping = false;
                    this._renderingManager.maintainStateBetweenFrames = false;
                    this.skipPointerMovePicking = false;
                    this.autoClear = true;
                    break;
                case ScenePerformancePriority.Intermediate:
                    this.skipFrustumClipping = false;
                    this._renderingManager.maintainStateBetweenFrames = false;
                    this.skipPointerMovePicking = true;
                    this.autoClear = false;
                    break;
                case ScenePerformancePriority.Aggressive:
                    this.skipFrustumClipping = true;
                    this._renderingManager.maintainStateBetweenFrames = true;
                    this.skipPointerMovePicking = true;
                    this.autoClear = false;
                    break;
            }
            this.onScenePerformancePriorityChangedObservable.notifyObservers(value);
        }
        /**
         * Gets or sets a boolean indicating if all rendering must be done in wireframe
         */
        set forceWireframe(value) {
            if (this._forceWireframe === value) {
                return;
            }
            this._forceWireframe = value;
            this.markAllMaterialsAsDirty(16);
        }
        get forceWireframe() {
            return this._forceWireframe;
        }
        /**
         * Gets or sets a boolean indicating if we should skip the frustum clipping part of the active meshes selection
         */
        set skipFrustumClipping(value) {
            if (this._skipFrustumClipping === value) {
                return;
            }
            this._skipFrustumClipping = value;
        }
        get skipFrustumClipping() {
            return this._skipFrustumClipping;
        }
        /**
         * Gets or sets a boolean indicating if all rendering must be done in point cloud
         */
        set forcePointsCloud(value) {
            if (this._forcePointsCloud === value) {
                return;
            }
            this._forcePointsCloud = value;
            this.markAllMaterialsAsDirty(16);
        }
        get forcePointsCloud() {
            return this._forcePointsCloud;
        }
        /**
         * Gets or sets the animation properties override
         */
        get animationPropertiesOverride() {
            return this._animationPropertiesOverride;
        }
        set animationPropertiesOverride(value) {
            this._animationPropertiesOverride = value;
        }
        /** Sets a function to be executed when this scene is disposed. */
        set onDispose(callback) {
            if (this._onDisposeObserver) {
                this.onDisposeObservable.remove(this._onDisposeObserver);
            }
            this._onDisposeObserver = this.onDisposeObservable.add(callback);
        }
        /** Sets a function to be executed before rendering this scene */
        set beforeRender(callback) {
            if (this._onBeforeRenderObserver) {
                this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
            }
            if (callback) {
                this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
            }
        }
        /** Sets a function to be executed after rendering this scene */
        set afterRender(callback) {
            if (this._onAfterRenderObserver) {
                this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
            }
            if (callback) {
                this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
            }
        }
        /** Sets a function to be executed before rendering a camera*/
        set beforeCameraRender(callback) {
            if (this._onBeforeCameraRenderObserver) {
                this.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
            }
            this._onBeforeCameraRenderObserver = this.onBeforeCameraRenderObservable.add(callback);
        }
        /** Sets a function to be executed after rendering a camera*/
        set afterCameraRender(callback) {
            if (this._onAfterCameraRenderObserver) {
                this.onAfterCameraRenderObservable.remove(this._onAfterCameraRenderObserver);
            }
            this._onAfterCameraRenderObserver = this.onAfterCameraRenderObservable.add(callback);
        }
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer down event
         */
        get pointerDownPredicate() {
            return this._pointerPickingConfiguration.pointerDownPredicate;
        }
        set pointerDownPredicate(value) {
            this._pointerPickingConfiguration.pointerDownPredicate = value;
        }
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer up event
         */
        get pointerUpPredicate() {
            return this._pointerPickingConfiguration.pointerUpPredicate;
        }
        set pointerUpPredicate(value) {
            this._pointerPickingConfiguration.pointerUpPredicate = value;
        }
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer move event
         */
        get pointerMovePredicate() {
            return this._pointerPickingConfiguration.pointerMovePredicate;
        }
        set pointerMovePredicate(value) {
            this._pointerPickingConfiguration.pointerMovePredicate = value;
        }
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer down event
         */
        get pointerDownFastCheck() {
            return this._pointerPickingConfiguration.pointerDownFastCheck;
        }
        set pointerDownFastCheck(value) {
            this._pointerPickingConfiguration.pointerDownFastCheck = value;
        }
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer up event
         */
        get pointerUpFastCheck() {
            return this._pointerPickingConfiguration.pointerUpFastCheck;
        }
        set pointerUpFastCheck(value) {
            this._pointerPickingConfiguration.pointerUpFastCheck = value;
        }
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer move event
         */
        get pointerMoveFastCheck() {
            return this._pointerPickingConfiguration.pointerMoveFastCheck;
        }
        set pointerMoveFastCheck(value) {
            this._pointerPickingConfiguration.pointerMoveFastCheck = value;
        }
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
         */
        get skipPointerMovePicking() {
            return this._pointerPickingConfiguration.skipPointerMovePicking;
        }
        set skipPointerMovePicking(value) {
            this._pointerPickingConfiguration.skipPointerMovePicking = value;
        }
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
         */
        get skipPointerDownPicking() {
            return this._pointerPickingConfiguration.skipPointerDownPicking;
        }
        set skipPointerDownPicking(value) {
            this._pointerPickingConfiguration.skipPointerDownPicking = value;
        }
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
         */
        get skipPointerUpPicking() {
            return this._pointerPickingConfiguration.skipPointerUpPicking;
        }
        set skipPointerUpPicking(value) {
            this._pointerPickingConfiguration.skipPointerUpPicking = value;
        }
        /**
         * Gets the pointer coordinates without any translation (ie. straight out of the pointer event)
         */
        get unTranslatedPointer() {
            return this._inputManager.unTranslatedPointer;
        }
        /**
         * Gets or sets the distance in pixel that you have to move to prevent some events. Default is 10 pixels
         */
        static get DragMovementThreshold() {
            return InputManager.DragMovementThreshold;
        }
        static set DragMovementThreshold(value) {
            InputManager.DragMovementThreshold = value;
        }
        /**
         * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 500 ms
         */
        static get LongPressDelay() {
            return InputManager.LongPressDelay;
        }
        static set LongPressDelay(value) {
            InputManager.LongPressDelay = value;
        }
        /**
         * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 300 ms
         */
        static get DoubleClickDelay() {
            return InputManager.DoubleClickDelay;
        }
        static set DoubleClickDelay(value) {
            InputManager.DoubleClickDelay = value;
        }
        /** If you need to check double click without raising a single click at first click, enable this flag */
        static get ExclusiveDoubleClickMode() {
            return InputManager.ExclusiveDoubleClickMode;
        }
        static set ExclusiveDoubleClickMode(value) {
            InputManager.ExclusiveDoubleClickMode = value;
        }
        /**
         * Bind the current view position to an effect.
         * @param effect The effect to be bound
         * @param variableName name of the shader variable that will hold the eye position
         * @param isVector3 true to indicates that variableName is a Vector3 and not a Vector4
         * @returns the computed eye position
         */
        bindEyePosition(effect, variableName = "vEyePosition", isVector3 = false) {
            var _a;
            const eyePosition = this._forcedViewPosition
                ? this._forcedViewPosition
                : this._mirroredCameraPosition
                    ? this._mirroredCameraPosition
                    : (_a = this.activeCamera.globalPosition) !== null && _a !== void 0 ? _a : this.activeCamera.devicePosition;
            const invertNormal = this.useRightHandedSystem === (this._mirroredCameraPosition != null);
            TmpVectors.Vector4[0].set(eyePosition.x, eyePosition.y, eyePosition.z, invertNormal ? -1 : 1);
            if (effect) {
                if (isVector3) {
                    effect.setFloat3(variableName, TmpVectors.Vector4[0].x, TmpVectors.Vector4[0].y, TmpVectors.Vector4[0].z);
                }
                else {
                    effect.setVector4(variableName, TmpVectors.Vector4[0]);
                }
            }
            return TmpVectors.Vector4[0];
        }
        /**
         * Update the scene ubo before it can be used in rendering processing
         * @returns the scene UniformBuffer
         */
        finalizeSceneUbo() {
            const ubo = this.getSceneUniformBuffer();
            const eyePosition = this.bindEyePosition(null);
            ubo.updateFloat4("vEyePosition", eyePosition.x, eyePosition.y, eyePosition.z, eyePosition.w);
            ubo.update();
            return ubo;
        }
        /**
         * Gets or sets a boolean indicating if the scene must use right-handed coordinates system
         */
        set useRightHandedSystem(value) {
            if (this._useRightHandedSystem === value) {
                return;
            }
            this._useRightHandedSystem = value;
            this.markAllMaterialsAsDirty(16);
        }
        get useRightHandedSystem() {
            return this._useRightHandedSystem;
        }
        /**
         * Sets the step Id used by deterministic lock step
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         * @param newStepId defines the step Id
         */
        setStepId(newStepId) {
            this._currentStepId = newStepId;
        }
        /**
         * Gets the step Id used by deterministic lock step
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         * @returns the step Id
         */
        getStepId() {
            return this._currentStepId;
        }
        /**
         * Gets the internal step used by deterministic lock step
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         * @returns the internal step
         */
        getInternalStep() {
            return this._currentInternalStep;
        }
        /**
         * Gets or sets a boolean indicating if fog is enabled on this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is true)
         */
        set fogEnabled(value) {
            if (this._fogEnabled === value) {
                return;
            }
            this._fogEnabled = value;
            this.markAllMaterialsAsDirty(16);
        }
        get fogEnabled() {
            return this._fogEnabled;
        }
        /**
         * Gets or sets the fog mode to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * | mode | value |
         * | --- | --- |
         * | FOGMODE_NONE | 0 |
         * | FOGMODE_EXP | 1 |
         * | FOGMODE_EXP2 | 2 |
         * | FOGMODE_LINEAR | 3 |
         */
        set fogMode(value) {
            if (this._fogMode === value) {
                return;
            }
            this._fogMode = value;
            this.markAllMaterialsAsDirty(16);
        }
        get fogMode() {
            return this._fogMode;
        }
        /**
         * Flag indicating that the frame buffer binding is handled by another component
         */
        get prePass() {
            return !!this.prePassRenderer && this.prePassRenderer.defaultRT.enabled;
        }
        /**
         * Gets or sets a boolean indicating if shadows are enabled on this scene
         */
        set shadowsEnabled(value) {
            if (this._shadowsEnabled === value) {
                return;
            }
            this._shadowsEnabled = value;
            this.markAllMaterialsAsDirty(2);
        }
        get shadowsEnabled() {
            return this._shadowsEnabled;
        }
        /**
         * Gets or sets a boolean indicating if lights are enabled on this scene
         */
        set lightsEnabled(value) {
            if (this._lightsEnabled === value) {
                return;
            }
            this._lightsEnabled = value;
            this.markAllMaterialsAsDirty(2);
        }
        get lightsEnabled() {
            return this._lightsEnabled;
        }
        /** All of the active cameras added to this scene. */
        get activeCameras() {
            return this._activeCameras;
        }
        set activeCameras(cameras) {
            if (this._unObserveActiveCameras) {
                this._unObserveActiveCameras();
                this._unObserveActiveCameras = null;
            }
            if (cameras) {
                this._unObserveActiveCameras = _ObserveArray(cameras, () => {
                    this.onActiveCamerasChanged.notifyObservers(this);
                });
            }
            this._activeCameras = cameras;
        }
        /** Gets or sets the current active camera */
        get activeCamera() {
            return this._activeCamera;
        }
        set activeCamera(value) {
            if (value === this._activeCamera) {
                return;
            }
            this._activeCamera = value;
            this.onActiveCameraChanged.notifyObservers(this);
        }
        /** The default material used on meshes when no material is affected */
        get defaultMaterial() {
            if (!this._defaultMaterial) {
                this._defaultMaterial = Scene.DefaultMaterialFactory(this);
            }
            return this._defaultMaterial;
        }
        /** The default material used on meshes when no material is affected */
        set defaultMaterial(value) {
            this._defaultMaterial = value;
        }
        /**
         * Gets or sets a boolean indicating if textures are enabled on this scene
         */
        set texturesEnabled(value) {
            if (this._texturesEnabled === value) {
                return;
            }
            this._texturesEnabled = value;
            this.markAllMaterialsAsDirty(1);
        }
        get texturesEnabled() {
            return this._texturesEnabled;
        }
        /**
         * Gets or sets a boolean indicating if skeletons are enabled on this scene
         */
        set skeletonsEnabled(value) {
            if (this._skeletonsEnabled === value) {
                return;
            }
            this._skeletonsEnabled = value;
            this.markAllMaterialsAsDirty(8);
        }
        get skeletonsEnabled() {
            return this._skeletonsEnabled;
        }
        /** @internal */
        get collisionCoordinator() {
            if (!this._collisionCoordinator) {
                this._collisionCoordinator = Scene.CollisionCoordinatorFactory();
                this._collisionCoordinator.init(this);
            }
            return this._collisionCoordinator;
        }
        /**
         * Gets the scene's rendering manager
         */
        get renderingManager() {
            return this._renderingManager;
        }
        /**
         * Gets the list of frustum planes (built from the active camera)
         */
        get frustumPlanes() {
            return this._frustumPlanes;
        }
        /**
         * Registers the transient components if needed.
         */
        _registerTransientComponents() {
            // Register components that have been associated lately to the scene.
            if (this._transientComponents.length > 0) {
                for (const component of this._transientComponents) {
                    component.register();
                }
                this._transientComponents.length = 0;
            }
        }
        /**
         * @internal
         * Add a component to the scene.
         * Note that the ccomponent could be registered on th next frame if this is called after
         * the register component stage.
         * @param component Defines the component to add to the scene
         */
        _addComponent(component) {
            this._components.push(component);
            this._transientComponents.push(component);
            const serializableComponent = component;
            if (serializableComponent.addFromContainer && serializableComponent.serialize) {
                this._serializableComponents.push(serializableComponent);
            }
        }
        /**
         * @internal
         * Gets a component from the scene.
         * @param name defines the name of the component to retrieve
         * @returns the component or null if not present
         */
        _getComponent(name) {
            for (const component of this._components) {
                if (component.name === name) {
                    return component;
                }
            }
            return null;
        }
        /**
         * Creates a new Scene
         * @param engine defines the engine to use to render this scene
         * @param options defines the scene options
         */
        constructor(engine, options) {
            super();
            // Members
            /** @internal */
            this._inputManager = new InputManager(this);
            /** Define this parameter if you are using multiple cameras and you want to specify which one should be used for pointer position */
            this.cameraToUseForPointers = null;
            /** @internal */
            this._isScene = true;
            /** @internal */
            this._blockEntityCollection = false;
            /**
             * Gets or sets a boolean that indicates if the scene must clear the render buffer before rendering a frame
             */
            this.autoClear = true;
            /**
             * Gets or sets a boolean that indicates if the scene must clear the depth and stencil buffers before rendering a frame
             */
            this.autoClearDepthAndStencil = true;
            /**
             * Defines the color used to clear the render buffer (Default is (0.2, 0.2, 0.3, 1.0))
             */
            this.clearColor = new Color4(0.2, 0.2, 0.3, 1.0);
            /**
             * Defines the color used to simulate the ambient color (Default is (0, 0, 0))
             */
            this.ambientColor = new Color3(0, 0, 0);
            /**
             * Intensity of the environment in all pbr material.
             * This dims or reinforces the IBL lighting overall (reflection and diffuse).
             * As in the majority of the scene they are the same (exception for multi room and so on),
             * this is easier to reference from here than from all the materials.
             */
            this.environmentIntensity = 1;
            this._performancePriority = ScenePerformancePriority.BackwardCompatible;
            /**
             * Observable triggered when the performance priority is changed
             */
            this.onScenePerformancePriorityChangedObservable = new Observable$1();
            this._forceWireframe = false;
            this._skipFrustumClipping = false;
            this._forcePointsCloud = false;
            /**
             * Gets or sets a boolean indicating if animations are enabled
             */
            this.animationsEnabled = true;
            this._animationPropertiesOverride = null;
            /**
             * Gets or sets a boolean indicating if a constant deltatime has to be used
             * This is mostly useful for testing purposes when you do not want the animations to scale with the framerate
             */
            this.useConstantAnimationDeltaTime = false;
            /**
             * Gets or sets a boolean indicating if the scene must keep the meshUnderPointer property updated
             * Please note that it requires to run a ray cast through the scene on every frame
             */
            this.constantlyUpdateMeshUnderPointer = false;
            /**
             * Defines the HTML cursor to use when hovering over interactive elements
             */
            this.hoverCursor = "pointer";
            /**
             * Defines the HTML default cursor to use (empty by default)
             */
            this.defaultCursor = "";
            /**
             * Defines whether cursors are handled by the scene.
             */
            this.doNotHandleCursors = false;
            /**
             * This is used to call preventDefault() on pointer down
             * in order to block unwanted artifacts like system double clicks
             */
            this.preventDefaultOnPointerDown = true;
            /**
             * This is used to call preventDefault() on pointer up
             * in order to block unwanted artifacts like system double clicks
             */
            this.preventDefaultOnPointerUp = true;
            // Metadata
            /**
             * Gets or sets user defined metadata
             */
            this.metadata = null;
            /**
             * For internal use only. Please do not use.
             */
            this.reservedDataStore = null;
            /**
             * Use this array to add regular expressions used to disable offline support for specific urls
             */
            this.disableOfflineSupportExceptionRules = new Array();
            /**
             * An event triggered when the scene is disposed.
             */
            this.onDisposeObservable = new Observable$1();
            this._onDisposeObserver = null;
            /**
             * An event triggered before rendering the scene (right after animations and physics)
             */
            this.onBeforeRenderObservable = new Observable$1();
            this._onBeforeRenderObserver = null;
            /**
             * An event triggered after rendering the scene
             */
            this.onAfterRenderObservable = new Observable$1();
            /**
             * An event triggered after rendering the scene for an active camera (When scene.render is called this will be called after each camera)
             * This is triggered for each "sub" camera in a Camera Rig unlike onAfterCameraRenderObservable
             */
            this.onAfterRenderCameraObservable = new Observable$1();
            this._onAfterRenderObserver = null;
            /**
             * An event triggered before animating the scene
             */
            this.onBeforeAnimationsObservable = new Observable$1();
            /**
             * An event triggered after animations processing
             */
            this.onAfterAnimationsObservable = new Observable$1();
            /**
             * An event triggered before draw calls are ready to be sent
             */
            this.onBeforeDrawPhaseObservable = new Observable$1();
            /**
             * An event triggered after draw calls have been sent
             */
            this.onAfterDrawPhaseObservable = new Observable$1();
            /**
             * An event triggered when the scene is ready
             */
            this.onReadyObservable = new Observable$1();
            /**
             * An event triggered before rendering a camera
             */
            this.onBeforeCameraRenderObservable = new Observable$1();
            this._onBeforeCameraRenderObserver = null;
            /**
             * An event triggered after rendering a camera
             * This is triggered for the full rig Camera only unlike onAfterRenderCameraObservable
             */
            this.onAfterCameraRenderObservable = new Observable$1();
            this._onAfterCameraRenderObserver = null;
            /**
             * An event triggered when active meshes evaluation is about to start
             */
            this.onBeforeActiveMeshesEvaluationObservable = new Observable$1();
            /**
             * An event triggered when active meshes evaluation is done
             */
            this.onAfterActiveMeshesEvaluationObservable = new Observable$1();
            /**
             * An event triggered when particles rendering is about to start
             * Note: This event can be trigger more than once per frame (because particles can be rendered by render target textures as well)
             */
            this.onBeforeParticlesRenderingObservable = new Observable$1();
            /**
             * An event triggered when particles rendering is done
             * Note: This event can be trigger more than once per frame (because particles can be rendered by render target textures as well)
             */
            this.onAfterParticlesRenderingObservable = new Observable$1();
            /**
             * An event triggered when SceneLoader.Append or SceneLoader.Load or SceneLoader.ImportMesh were successfully executed
             */
            this.onDataLoadedObservable = new Observable$1();
            /**
             * An event triggered when a camera is created
             */
            this.onNewCameraAddedObservable = new Observable$1();
            /**
             * An event triggered when a camera is removed
             */
            this.onCameraRemovedObservable = new Observable$1();
            /**
             * An event triggered when a light is created
             */
            this.onNewLightAddedObservable = new Observable$1();
            /**
             * An event triggered when a light is removed
             */
            this.onLightRemovedObservable = new Observable$1();
            /**
             * An event triggered when a geometry is created
             */
            this.onNewGeometryAddedObservable = new Observable$1();
            /**
             * An event triggered when a geometry is removed
             */
            this.onGeometryRemovedObservable = new Observable$1();
            /**
             * An event triggered when a transform node is created
             */
            this.onNewTransformNodeAddedObservable = new Observable$1();
            /**
             * An event triggered when a transform node is removed
             */
            this.onTransformNodeRemovedObservable = new Observable$1();
            /**
             * An event triggered when a mesh is created
             */
            this.onNewMeshAddedObservable = new Observable$1();
            /**
             * An event triggered when a mesh is removed
             */
            this.onMeshRemovedObservable = new Observable$1();
            /**
             * An event triggered when a skeleton is created
             */
            this.onNewSkeletonAddedObservable = new Observable$1();
            /**
             * An event triggered when a skeleton is removed
             */
            this.onSkeletonRemovedObservable = new Observable$1();
            /**
             * An event triggered when a material is created
             */
            this.onNewMaterialAddedObservable = new Observable$1();
            /**
             * An event triggered when a multi material is created
             */
            this.onNewMultiMaterialAddedObservable = new Observable$1();
            /**
             * An event triggered when a material is removed
             */
            this.onMaterialRemovedObservable = new Observable$1();
            /**
             * An event triggered when a multi material is removed
             */
            this.onMultiMaterialRemovedObservable = new Observable$1();
            /**
             * An event triggered when a texture is created
             */
            this.onNewTextureAddedObservable = new Observable$1();
            /**
             * An event triggered when a texture is removed
             */
            this.onTextureRemovedObservable = new Observable$1();
            /**
             * An event triggered when render targets are about to be rendered
             * Can happen multiple times per frame.
             */
            this.onBeforeRenderTargetsRenderObservable = new Observable$1();
            /**
             * An event triggered when render targets were rendered.
             * Can happen multiple times per frame.
             */
            this.onAfterRenderTargetsRenderObservable = new Observable$1();
            /**
             * An event triggered before calculating deterministic simulation step
             */
            this.onBeforeStepObservable = new Observable$1();
            /**
             * An event triggered after calculating deterministic simulation step
             */
            this.onAfterStepObservable = new Observable$1();
            /**
             * An event triggered when the activeCamera property is updated
             */
            this.onActiveCameraChanged = new Observable$1();
            /**
             * An event triggered when the activeCameras property is updated
             */
            this.onActiveCamerasChanged = new Observable$1();
            /**
             * This Observable will be triggered before rendering each renderingGroup of each rendered camera.
             * The RenderingGroupInfo class contains all the information about the context in which the observable is called
             * If you wish to register an Observer only for a given set of renderingGroup, use the mask with a combination of the renderingGroup index elevated to the power of two (1 for renderingGroup 0, 2 for renderingrOup1, 4 for 2 and 8 for 3)
             */
            this.onBeforeRenderingGroupObservable = new Observable$1();
            /**
             * This Observable will be triggered after rendering each renderingGroup of each rendered camera.
             * The RenderingGroupInfo class contains all the information about the context in which the observable is called
             * If you wish to register an Observer only for a given set of renderingGroup, use the mask with a combination of the renderingGroup index elevated to the power of two (1 for renderingGroup 0, 2 for renderingrOup1, 4 for 2 and 8 for 3)
             */
            this.onAfterRenderingGroupObservable = new Observable$1();
            /**
             * This Observable will when a mesh has been imported into the scene.
             */
            this.onMeshImportedObservable = new Observable$1();
            /**
             * This Observable will when an animation file has been imported into the scene.
             */
            this.onAnimationFileImportedObservable = new Observable$1();
            // Animations
            /** @internal */
            this._registeredForLateAnimationBindings = new SmartArrayNoDuplicate(256);
            // Pointers
            this._pointerPickingConfiguration = new PointerPickingConfiguration();
            /**
             * This observable event is triggered when any ponter event is triggered. It is registered during Scene.attachControl() and it is called BEFORE the 3D engine process anything (mesh/sprite picking for instance).
             * You have the possibility to skip the process and the call to onPointerObservable by setting PointerInfoPre.skipOnPointerObservable to true
             */
            this.onPrePointerObservable = new Observable$1();
            /**
             * Observable event triggered each time an input event is received from the rendering canvas
             */
            this.onPointerObservable = new Observable$1();
            // Keyboard
            /**
             * This observable event is triggered when any keyboard event si raised and registered during Scene.attachControl()
             * You have the possibility to skip the process and the call to onKeyboardObservable by setting KeyboardInfoPre.skipOnPointerObservable to true
             */
            this.onPreKeyboardObservable = new Observable$1();
            /**
             * Observable event triggered each time an keyboard event is received from the hosting window
             */
            this.onKeyboardObservable = new Observable$1();
            // Coordinates system
            this._useRightHandedSystem = false;
            // Deterministic lockstep
            this._timeAccumulator = 0;
            this._currentStepId = 0;
            this._currentInternalStep = 0;
            // Fog
            this._fogEnabled = true;
            this._fogMode = Scene.FOGMODE_NONE;
            /**
             * Gets or sets the fog color to use
             * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
             * (Default is Color3(0.2, 0.2, 0.3))
             */
            this.fogColor = new Color3(0.2, 0.2, 0.3);
            /**
             * Gets or sets the fog density to use
             * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
             * (Default is 0.1)
             */
            this.fogDensity = 0.1;
            /**
             * Gets or sets the fog start distance to use
             * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
             * (Default is 0)
             */
            this.fogStart = 0;
            /**
             * Gets or sets the fog end distance to use
             * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
             * (Default is 1000)
             */
            this.fogEnd = 1000.0;
            /**
             * Flag indicating if we need to store previous matrices when rendering
             */
            this.needsPreviousWorldMatrices = false;
            // Lights
            this._shadowsEnabled = true;
            this._lightsEnabled = true;
            this._unObserveActiveCameras = null;
            // Textures
            this._texturesEnabled = true;
            // Physics
            /**
             * Gets or sets a boolean indicating if physic engines are enabled on this scene
             */
            this.physicsEnabled = true;
            // Particles
            /**
             * Gets or sets a boolean indicating if particles are enabled on this scene
             */
            this.particlesEnabled = true;
            // Sprites
            /**
             * Gets or sets a boolean indicating if sprites are enabled on this scene
             */
            this.spritesEnabled = true;
            // Skeletons
            this._skeletonsEnabled = true;
            // Lens flares
            /**
             * Gets or sets a boolean indicating if lens flares are enabled on this scene
             */
            this.lensFlaresEnabled = true;
            // Collisions
            /**
             * Gets or sets a boolean indicating if collisions are enabled on this scene
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
             */
            this.collisionsEnabled = true;
            /**
             * Defines the gravity applied to this scene (used only for collisions)
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
             */
            this.gravity = new Vector3(0, -9.807, 0);
            // Postprocesses
            /**
             * Gets or sets a boolean indicating if postprocesses are enabled on this scene
             */
            this.postProcessesEnabled = true;
            // Customs render targets
            /**
             * Gets or sets a boolean indicating if render targets are enabled on this scene
             */
            this.renderTargetsEnabled = true;
            /**
             * Gets or sets a boolean indicating if next render targets must be dumped as image for debugging purposes
             * We recommend not using it and instead rely on Spector.js: http://spector.babylonjs.com
             */
            this.dumpNextRenderTargets = false;
            /**
             * The list of user defined render targets added to the scene
             */
            this.customRenderTargets = new Array();
            /**
             * Gets the list of meshes imported to the scene through SceneLoader
             */
            this.importedMeshesFiles = new Array();
            // Probes
            /**
             * Gets or sets a boolean indicating if probes are enabled on this scene
             */
            this.probesEnabled = true;
            this._meshesForIntersections = new SmartArrayNoDuplicate(256);
            // Procedural textures
            /**
             * Gets or sets a boolean indicating if procedural textures are enabled on this scene
             */
            this.proceduralTexturesEnabled = true;
            // Performance counters
            this._totalVertices = new PerfCounter();
            /** @internal */
            this._activeIndices = new PerfCounter();
            /** @internal */
            this._activeParticles = new PerfCounter();
            /** @internal */
            this._activeBones = new PerfCounter();
            /** @internal */
            this._animationTime = 0;
            /**
             * Gets or sets a general scale for animation speed
             * @see https://www.babylonjs-playground.com/#IBU2W7#3
             */
            this.animationTimeScale = 1;
            this._renderId = 0;
            this._frameId = 0;
            this._executeWhenReadyTimeoutId = null;
            this._intermediateRendering = false;
            this._defaultFrameBufferCleared = false;
            this._viewUpdateFlag = -1;
            this._projectionUpdateFlag = -1;
            /** @internal */
            this._toBeDisposed = new Array(256);
            this._activeRequests = new Array();
            /** @internal */
            this._pendingData = new Array();
            this._isDisposed = false;
            /**
             * Gets or sets a boolean indicating that all submeshes of active meshes must be rendered
             * Use this boolean to avoid computing frustum clipping on submeshes (This could help when you are CPU bound)
             */
            this.dispatchAllSubMeshesOfActiveMeshes = false;
            this._activeMeshes = new SmartArray(256);
            this._processedMaterials = new SmartArray(256);
            this._renderTargets = new SmartArrayNoDuplicate(256);
            this._materialsRenderTargets = new SmartArrayNoDuplicate(256);
            /** @internal */
            this._activeParticleSystems = new SmartArray(256);
            this._activeSkeletons = new SmartArrayNoDuplicate(32);
            this._softwareSkinnedMeshes = new SmartArrayNoDuplicate(32);
            /** @internal */
            this._activeAnimatables = new Array();
            this._transformMatrix = Matrix.Zero();
            /**
             * Gets or sets a boolean indicating if lights must be sorted by priority (off by default)
             * This is useful if there are more lights that the maximum simulteanous authorized
             */
            this.requireLightSorting = false;
            /**
             * @internal
             * Backing store of defined scene components.
             */
            this._components = [];
            /**
             * @internal
             * Backing store of defined scene components.
             */
            this._serializableComponents = [];
            /**
             * List of components to register on the next registration step.
             */
            this._transientComponents = [];
            /**
             * @internal
             * Defines the actions happening before camera updates.
             */
            this._beforeCameraUpdateStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening before clear the canvas.
             */
            this._beforeClearStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening before clear the canvas.
             */
            this._beforeRenderTargetClearStage = Stage.Create();
            /**
             * @internal
             * Defines the actions when collecting render targets for the frame.
             */
            this._gatherRenderTargetsStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening for one camera in the frame.
             */
            this._gatherActiveCameraRenderTargetsStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening during the per mesh ready checks.
             */
            this._isReadyForMeshStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening before evaluate active mesh checks.
             */
            this._beforeEvaluateActiveMeshStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening during the evaluate sub mesh checks.
             */
            this._evaluateSubMeshStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening during the active mesh stage.
             */
            this._preActiveMeshStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening during the per camera render target step.
             */
            this._cameraDrawRenderTargetStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just before the active camera is drawing.
             */
            this._beforeCameraDrawStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just before a render target is drawing.
             */
            this._beforeRenderTargetDrawStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just before a rendering group is drawing.
             */
            this._beforeRenderingGroupDrawStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just before a mesh is drawing.
             */
            this._beforeRenderingMeshStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just after a mesh has been drawn.
             */
            this._afterRenderingMeshStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just after a rendering group has been drawn.
             */
            this._afterRenderingGroupDrawStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just after the active camera has been drawn.
             */
            this._afterCameraDrawStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just after the post processing
             */
            this._afterCameraPostProcessStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just after a render target has been drawn.
             */
            this._afterRenderTargetDrawStage = Stage.Create();
            /**
             * Defines the actions happening just after the post processing on a render target
             */
            this._afterRenderTargetPostProcessStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening just after rendering all cameras and computing intersections.
             */
            this._afterRenderStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening when a pointer move event happens.
             */
            this._pointerMoveStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening when a pointer down event happens.
             */
            this._pointerDownStage = Stage.Create();
            /**
             * @internal
             * Defines the actions happening when a pointer up event happens.
             */
            this._pointerUpStage = Stage.Create();
            /**
             * an optional map from Geometry Id to Geometry index in the 'geometries' array
             */
            this._geometriesByUniqueId = null;
            this._defaultMeshCandidates = {
                data: [],
                length: 0,
            };
            this._defaultSubMeshCandidates = {
                data: [],
                length: 0,
            };
            this._preventFreeActiveMeshesAndRenderingGroups = false;
            /** @internal */
            this._activeMeshesFrozen = false;
            /** @internal */
            this._activeMeshesFrozenButKeepClipping = false;
            this._skipEvaluateActiveMeshesCompletely = false;
            /** @internal */
            this._allowPostProcessClearColor = true;
            /**
             * User updatable function that will return a deterministic frame time when engine is in deterministic lock step mode
             */
            this.getDeterministicFrameTime = () => {
                return this._engine.getTimeStep();
            };
            /** @internal */
            this._registeredActions = 0;
            this._blockMaterialDirtyMechanism = false;
            /**
             * Internal perfCollector instance used for sharing between inspector and playground.
             * Marked as protected to allow sharing between prototype extensions, but disallow access at toplevel.
             */
            this._perfCollector = null;
            this.activeCameras = new Array();
            const fullOptions = Object.assign({ useGeometryUniqueIdsMap: true, useMaterialMeshMap: true, useClonedMeshMap: true, virtual: false }, options);
            this._engine = engine || EngineStore.LastCreatedEngine;
            if (!fullOptions.virtual) {
                EngineStore._LastCreatedScene = this;
                this._engine.scenes.push(this);
            }
            else {
                this._engine._virtualScenes.push(this);
            }
            this._uid = null;
            this._renderingManager = new RenderingManager(this);
            if (PostProcessManager) {
                this.postProcessManager = new PostProcessManager(this);
            }
            if (IsWindowObjectExist()) {
                this.attachControl();
            }
            // Uniform Buffer
            this._createUbo();
            // Default Image processing definition
            if (ImageProcessingConfiguration) {
                this._imageProcessingConfiguration = new ImageProcessingConfiguration();
            }
            this.setDefaultCandidateProviders();
            if (fullOptions.useGeometryUniqueIdsMap) {
                this._geometriesByUniqueId = {};
            }
            this.useMaterialMeshMap = fullOptions.useMaterialMeshMap;
            this.useClonedMeshMap = fullOptions.useClonedMeshMap;
            if (!options || !options.virtual) {
                this._engine.onNewSceneAddedObservable.notifyObservers(this);
            }
        }
        /**
         * Gets a string identifying the name of the class
         * @returns "Scene" string
         */
        getClassName() {
            return "Scene";
        }
        /**
         * @internal
         */
        _getDefaultMeshCandidates() {
            this._defaultMeshCandidates.data = this.meshes;
            this._defaultMeshCandidates.length = this.meshes.length;
            return this._defaultMeshCandidates;
        }
        /**
         * @internal
         */
        _getDefaultSubMeshCandidates(mesh) {
            this._defaultSubMeshCandidates.data = mesh.subMeshes;
            this._defaultSubMeshCandidates.length = mesh.subMeshes.length;
            return this._defaultSubMeshCandidates;
        }
        /**
         * Sets the default candidate providers for the scene.
         * This sets the getActiveMeshCandidates, getActiveSubMeshCandidates, getIntersectingSubMeshCandidates
         * and getCollidingSubMeshCandidates to their default function
         */
        setDefaultCandidateProviders() {
            this.getActiveMeshCandidates = this._getDefaultMeshCandidates.bind(this);
            this.getActiveSubMeshCandidates = this._getDefaultSubMeshCandidates.bind(this);
            this.getIntersectingSubMeshCandidates = this._getDefaultSubMeshCandidates.bind(this);
            this.getCollidingSubMeshCandidates = this._getDefaultSubMeshCandidates.bind(this);
        }
        /**
         * Gets the mesh that is currently under the pointer
         */
        get meshUnderPointer() {
            return this._inputManager.meshUnderPointer;
        }
        /**
         * Gets or sets the current on-screen X position of the pointer
         */
        get pointerX() {
            return this._inputManager.pointerX;
        }
        set pointerX(value) {
            this._inputManager.pointerX = value;
        }
        /**
         * Gets or sets the current on-screen Y position of the pointer
         */
        get pointerY() {
            return this._inputManager.pointerY;
        }
        set pointerY(value) {
            this._inputManager.pointerY = value;
        }
        /**
         * Gets the cached material (ie. the latest rendered one)
         * @returns the cached material
         */
        getCachedMaterial() {
            return this._cachedMaterial;
        }
        /**
         * Gets the cached effect (ie. the latest rendered one)
         * @returns the cached effect
         */
        getCachedEffect() {
            return this._cachedEffect;
        }
        /**
         * Gets the cached visibility state (ie. the latest rendered one)
         * @returns the cached visibility state
         */
        getCachedVisibility() {
            return this._cachedVisibility;
        }
        /**
         * Gets a boolean indicating if the current material / effect / visibility must be bind again
         * @param material defines the current material
         * @param effect defines the current effect
         * @param visibility defines the current visibility state
         * @returns true if one parameter is not cached
         */
        isCachedMaterialInvalid(material, effect, visibility = 1) {
            return this._cachedEffect !== effect || this._cachedMaterial !== material || this._cachedVisibility !== visibility;
        }
        /**
         * Gets the engine associated with the scene
         * @returns an Engine
         */
        getEngine() {
            return this._engine;
        }
        /**
         * Gets the total number of vertices rendered per frame
         * @returns the total number of vertices rendered per frame
         */
        getTotalVertices() {
            return this._totalVertices.current;
        }
        /**
         * Gets the performance counter for total vertices
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
         */
        get totalVerticesPerfCounter() {
            return this._totalVertices;
        }
        /**
         * Gets the total number of active indices rendered per frame (You can deduce the number of rendered triangles by dividing this number by 3)
         * @returns the total number of active indices rendered per frame
         */
        getActiveIndices() {
            return this._activeIndices.current;
        }
        /**
         * Gets the performance counter for active indices
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
         */
        get totalActiveIndicesPerfCounter() {
            return this._activeIndices;
        }
        /**
         * Gets the total number of active particles rendered per frame
         * @returns the total number of active particles rendered per frame
         */
        getActiveParticles() {
            return this._activeParticles.current;
        }
        /**
         * Gets the performance counter for active particles
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
         */
        get activeParticlesPerfCounter() {
            return this._activeParticles;
        }
        /**
         * Gets the total number of active bones rendered per frame
         * @returns the total number of active bones rendered per frame
         */
        getActiveBones() {
            return this._activeBones.current;
        }
        /**
         * Gets the performance counter for active bones
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
         */
        get activeBonesPerfCounter() {
            return this._activeBones;
        }
        /**
         * Gets the array of active meshes
         * @returns an array of AbstractMesh
         */
        getActiveMeshes() {
            return this._activeMeshes;
        }
        /**
         * Gets the animation ratio (which is 1.0 is the scene renders at 60fps and 2 if the scene renders at 30fps, etc.)
         * @returns a number
         */
        getAnimationRatio() {
            return this._animationRatio !== undefined ? this._animationRatio : 1;
        }
        /**
         * Gets an unique Id for the current render phase
         * @returns a number
         */
        getRenderId() {
            return this._renderId;
        }
        /**
         * Gets an unique Id for the current frame
         * @returns a number
         */
        getFrameId() {
            return this._frameId;
        }
        /** Call this function if you want to manually increment the render Id*/
        incrementRenderId() {
            this._renderId++;
        }
        _createUbo() {
            this.setSceneUniformBuffer(this.createSceneUniformBuffer());
        }
        /**
         * Use this method to simulate a pointer move on a mesh
         * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
         * @param pickResult pickingInfo of the object wished to simulate pointer event on
         * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
         * @returns the current scene
         */
        simulatePointerMove(pickResult, pointerEventInit) {
            this._inputManager.simulatePointerMove(pickResult, pointerEventInit);
            return this;
        }
        /**
         * Use this method to simulate a pointer down on a mesh
         * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
         * @param pickResult pickingInfo of the object wished to simulate pointer event on
         * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
         * @returns the current scene
         */
        simulatePointerDown(pickResult, pointerEventInit) {
            this._inputManager.simulatePointerDown(pickResult, pointerEventInit);
            return this;
        }
        /**
         * Use this method to simulate a pointer up on a mesh
         * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
         * @param pickResult pickingInfo of the object wished to simulate pointer event on
         * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
         * @param doubleTap indicates that the pointer up event should be considered as part of a double click (false by default)
         * @returns the current scene
         */
        simulatePointerUp(pickResult, pointerEventInit, doubleTap) {
            this._inputManager.simulatePointerUp(pickResult, pointerEventInit, doubleTap);
            return this;
        }
        /**
         * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
         * @param pointerId defines the pointer id to use in a multi-touch scenario (0 by default)
         * @returns true if the pointer was captured
         */
        isPointerCaptured(pointerId = 0) {
            return this._inputManager.isPointerCaptured(pointerId);
        }
        /**
         * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
         * @param attachUp defines if you want to attach events to pointerup
         * @param attachDown defines if you want to attach events to pointerdown
         * @param attachMove defines if you want to attach events to pointermove
         */
        attachControl(attachUp = true, attachDown = true, attachMove = true) {
            this._inputManager.attachControl(attachUp, attachDown, attachMove);
        }
        /** Detaches all event handlers*/
        detachControl() {
            this._inputManager.detachControl();
        }
        /**
         * This function will check if the scene can be rendered (textures are loaded, shaders are compiled)
         * Delay loaded resources are not taking in account
         * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: true)
         * @returns true if all required resources are ready
         */
        isReady(checkRenderTargets = true) {
            var _a, _b, _c;
            if (this._isDisposed) {
                return false;
            }
            let index;
            const engine = this.getEngine();
            const currentRenderPassId = engine.currentRenderPassId;
            engine.currentRenderPassId = (_b = (_a = this.activeCamera) === null || _a === void 0 ? void 0 : _a.renderPassId) !== null && _b !== void 0 ? _b : currentRenderPassId;
            let isReady = true;
            // Pending data
            if (this._pendingData.length > 0) {
                isReady = false;
            }
            // Ensures that the pre-pass renderer is enabled if it is to be enabled.
            (_c = this.prePassRenderer) === null || _c === void 0 ? void 0 : _c.update();
            // Meshes
            if (checkRenderTargets) {
                this._processedMaterials.reset();
                this._materialsRenderTargets.reset();
            }
            for (index = 0; index < this.meshes.length; index++) {
                const mesh = this.meshes[index];
                if (!mesh.subMeshes || mesh.subMeshes.length === 0) {
                    continue;
                }
                // Do not stop at the first encountered "unready" object as we want to ensure
                // all materials are starting off their compilation in parallel.
                if (!mesh.isReady(true)) {
                    isReady = false;
                    continue;
                }
                const hardwareInstancedRendering = mesh.hasThinInstances ||
                    mesh.getClassName() === "InstancedMesh" ||
                    mesh.getClassName() === "InstancedLinesMesh" ||
                    (engine.getCaps().instancedArrays && mesh.instances.length > 0);
                // Is Ready For Mesh
                for (const step of this._isReadyForMeshStage) {
                    if (!step.action(mesh, hardwareInstancedRendering)) {
                        isReady = false;
                    }
                }
                if (!checkRenderTargets) {
                    continue;
                }
                const mat = mesh.material || this.defaultMaterial;
                if (mat) {
                    if (mat._storeEffectOnSubMeshes) {
                        for (const subMesh of mesh.subMeshes) {
                            const material = subMesh.getMaterial();
                            if (material && material.hasRenderTargetTextures && material.getRenderTargetTextures != null) {
                                if (this._processedMaterials.indexOf(material) === -1) {
                                    this._processedMaterials.push(material);
                                    this._materialsRenderTargets.concatWithNoDuplicate(material.getRenderTargetTextures());
                                }
                            }
                        }
                    }
                    else {
                        if (mat.hasRenderTargetTextures && mat.getRenderTargetTextures != null) {
                            if (this._processedMaterials.indexOf(mat) === -1) {
                                this._processedMaterials.push(mat);
                                this._materialsRenderTargets.concatWithNoDuplicate(mat.getRenderTargetTextures());
                            }
                        }
                    }
                }
            }
            // Render targets
            if (checkRenderTargets) {
                for (index = 0; index < this._materialsRenderTargets.length; ++index) {
                    const rtt = this._materialsRenderTargets.data[index];
                    if (!rtt.isReadyForRendering()) {
                        isReady = false;
                    }
                }
            }
            // Geometries
            for (index = 0; index < this.geometries.length; index++) {
                const geometry = this.geometries[index];
                if (geometry.delayLoadState === 2) {
                    isReady = false;
                }
            }
            // Post-processes
            if (this.activeCameras && this.activeCameras.length > 0) {
                for (const camera of this.activeCameras) {
                    if (!camera.isReady(true)) {
                        isReady = false;
                    }
                }
            }
            else if (this.activeCamera) {
                if (!this.activeCamera.isReady(true)) {
                    isReady = false;
                }
            }
            // Particles
            for (const particleSystem of this.particleSystems) {
                if (!particleSystem.isReady()) {
                    isReady = false;
                }
            }
            // Layers
            if (this.layers) {
                for (const layer of this.layers) {
                    if (!layer.isReady()) {
                        isReady = false;
                    }
                }
            }
            // Effects
            if (!engine.areAllEffectsReady()) {
                isReady = false;
            }
            engine.currentRenderPassId = currentRenderPassId;
            return isReady;
        }
        /** Resets all cached information relative to material (including effect and visibility) */
        resetCachedMaterial() {
            this._cachedMaterial = null;
            this._cachedEffect = null;
            this._cachedVisibility = null;
        }
        /**
         * Registers a function to be called before every frame render
         * @param func defines the function to register
         */
        registerBeforeRender(func) {
            this.onBeforeRenderObservable.add(func);
        }
        /**
         * Unregisters a function called before every frame render
         * @param func defines the function to unregister
         */
        unregisterBeforeRender(func) {
            this.onBeforeRenderObservable.removeCallback(func);
        }
        /**
         * Registers a function to be called after every frame render
         * @param func defines the function to register
         */
        registerAfterRender(func) {
            this.onAfterRenderObservable.add(func);
        }
        /**
         * Unregisters a function called after every frame render
         * @param func defines the function to unregister
         */
        unregisterAfterRender(func) {
            this.onAfterRenderObservable.removeCallback(func);
        }
        _executeOnceBeforeRender(func) {
            const execFunc = () => {
                func();
                setTimeout(() => {
                    this.unregisterBeforeRender(execFunc);
                });
            };
            this.registerBeforeRender(execFunc);
        }
        /**
         * The provided function will run before render once and will be disposed afterwards.
         * A timeout delay can be provided so that the function will be executed in N ms.
         * The timeout is using the browser's native setTimeout so time percision cannot be guaranteed.
         * @param func The function to be executed.
         * @param timeout optional delay in ms
         */
        executeOnceBeforeRender(func, timeout) {
            if (timeout !== undefined) {
                setTimeout(() => {
                    this._executeOnceBeforeRender(func);
                }, timeout);
            }
            else {
                this._executeOnceBeforeRender(func);
            }
        }
        /**
         * This function can help adding any object to the list of data awaited to be ready in order to check for a complete scene loading.
         * @param data defines the object to wait for
         */
        addPendingData(data) {
            this._pendingData.push(data);
        }
        /**
         * Remove a pending data from the loading list which has previously been added with addPendingData.
         * @param data defines the object to remove from the pending list
         */
        removePendingData(data) {
            const wasLoading = this.isLoading;
            const index = this._pendingData.indexOf(data);
            if (index !== -1) {
                this._pendingData.splice(index, 1);
            }
            if (wasLoading && !this.isLoading) {
                this.onDataLoadedObservable.notifyObservers(this);
            }
        }
        /**
         * Returns the number of items waiting to be loaded
         * @returns the number of items waiting to be loaded
         */
        getWaitingItemsCount() {
            return this._pendingData.length;
        }
        /**
         * Returns a boolean indicating if the scene is still loading data
         */
        get isLoading() {
            return this._pendingData.length > 0;
        }
        /**
         * Registers a function to be executed when the scene is ready
         * @param func - the function to be executed
         * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
         */
        executeWhenReady(func, checkRenderTargets = false) {
            this.onReadyObservable.addOnce(func);
            if (this._executeWhenReadyTimeoutId !== null) {
                return;
            }
            this._checkIsReady(checkRenderTargets);
        }
        /**
         * Returns a promise that resolves when the scene is ready
         * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
         * @returns A promise that resolves when the scene is ready
         */
        whenReadyAsync(checkRenderTargets = false) {
            return new Promise((resolve) => {
                this.executeWhenReady(() => {
                    resolve();
                }, checkRenderTargets);
            });
        }
        /**
         * @internal
         */
        _checkIsReady(checkRenderTargets = false) {
            this._registerTransientComponents();
            if (this.isReady(checkRenderTargets)) {
                this.onReadyObservable.notifyObservers(this);
                this.onReadyObservable.clear();
                this._executeWhenReadyTimeoutId = null;
                return;
            }
            if (this._isDisposed) {
                this.onReadyObservable.clear();
                this._executeWhenReadyTimeoutId = null;
                return;
            }
            this._executeWhenReadyTimeoutId = setTimeout(() => {
                // Ensure materials effects are checked outside render loops
                this.incrementRenderId();
                this._checkIsReady(checkRenderTargets);
            }, 100);
        }
        /**
         * Gets all animatable attached to the scene
         */
        get animatables() {
            return this._activeAnimatables;
        }
        /**
         * Resets the last animation time frame.
         * Useful to override when animations start running when loading a scene for the first time.
         */
        resetLastAnimationTimeFrame() {
            this._animationTimeLast = PrecisionDate.Now;
        }
        // Matrix
        /**
         * Gets the current view matrix
         * @returns a Matrix
         */
        getViewMatrix() {
            return this._viewMatrix;
        }
        /**
         * Gets the current projection matrix
         * @returns a Matrix
         */
        getProjectionMatrix() {
            return this._projectionMatrix;
        }
        /**
         * Gets the current transform matrix
         * @returns a Matrix made of View * Projection
         */
        getTransformMatrix() {
            return this._transformMatrix;
        }
        /**
         * Sets the current transform matrix
         * @param viewL defines the View matrix to use
         * @param projectionL defines the Projection matrix to use
         * @param viewR defines the right View matrix to use (if provided)
         * @param projectionR defines the right Projection matrix to use (if provided)
         */
        setTransformMatrix(viewL, projectionL, viewR, projectionR) {
            // clear the multiviewSceneUbo if no viewR and projectionR are defined
            if (!viewR && !projectionR && this._multiviewSceneUbo) {
                this._multiviewSceneUbo.dispose();
                this._multiviewSceneUbo = null;
            }
            if (this._viewUpdateFlag === viewL.updateFlag && this._projectionUpdateFlag === projectionL.updateFlag) {
                return;
            }
            this._viewUpdateFlag = viewL.updateFlag;
            this._projectionUpdateFlag = projectionL.updateFlag;
            this._viewMatrix = viewL;
            this._projectionMatrix = projectionL;
            this._viewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
            // Update frustum
            if (!this._frustumPlanes) {
                this._frustumPlanes = Frustum.GetPlanes(this._transformMatrix);
            }
            else {
                Frustum.GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
            }
            if (this._multiviewSceneUbo && this._multiviewSceneUbo.useUbo) {
                this._updateMultiviewUbo(viewR, projectionR);
            }
            else if (this._sceneUbo.useUbo) {
                this._sceneUbo.updateMatrix("viewProjection", this._transformMatrix);
                this._sceneUbo.updateMatrix("view", this._viewMatrix);
                this._sceneUbo.updateMatrix("projection", this._projectionMatrix);
            }
        }
        /**
         * Gets the uniform buffer used to store scene data
         * @returns a UniformBuffer
         */
        getSceneUniformBuffer() {
            return this._multiviewSceneUbo ? this._multiviewSceneUbo : this._sceneUbo;
        }
        /**
         * Creates a scene UBO
         * @param name name of the uniform buffer (optional, for debugging purpose only)
         * @returns a new ubo
         */
        createSceneUniformBuffer(name) {
            const sceneUbo = new UniformBuffer(this._engine, undefined, false, name !== null && name !== void 0 ? name : "scene");
            sceneUbo.addUniform("viewProjection", 16);
            sceneUbo.addUniform("view", 16);
            sceneUbo.addUniform("projection", 16);
            sceneUbo.addUniform("vEyePosition", 4);
            return sceneUbo;
        }
        /**
         * Sets the scene ubo
         * @param ubo the ubo to set for the scene
         */
        setSceneUniformBuffer(ubo) {
            this._sceneUbo = ubo;
            this._viewUpdateFlag = -1;
            this._projectionUpdateFlag = -1;
        }
        /**
         * Gets an unique (relatively to the current scene) Id
         * @returns an unique number for the scene
         */
        getUniqueId() {
            return UniqueIdGenerator.UniqueId;
        }
        /**
         * Add a mesh to the list of scene's meshes
         * @param newMesh defines the mesh to add
         * @param recursive if all child meshes should also be added to the scene
         */
        addMesh(newMesh, recursive = false) {
            if (this._blockEntityCollection) {
                return;
            }
            this.meshes.push(newMesh);
            newMesh._resyncLightSources();
            if (!newMesh.parent) {
                newMesh._addToSceneRootNodes();
            }
            this.onNewMeshAddedObservable.notifyObservers(newMesh);
            if (recursive) {
                newMesh.getChildMeshes().forEach((m) => {
                    this.addMesh(m);
                });
            }
        }
        /**
         * Remove a mesh for the list of scene's meshes
         * @param toRemove defines the mesh to remove
         * @param recursive if all child meshes should also be removed from the scene
         * @returns the index where the mesh was in the mesh list
         */
        removeMesh(toRemove, recursive = false) {
            const index = this.meshes.indexOf(toRemove);
            if (index !== -1) {
                // Remove from the scene if mesh found
                this.meshes[index] = this.meshes[this.meshes.length - 1];
                this.meshes.pop();
                if (!toRemove.parent) {
                    toRemove._removeFromSceneRootNodes();
                }
            }
            this._inputManager._invalidateMesh(toRemove);
            this.onMeshRemovedObservable.notifyObservers(toRemove);
            if (recursive) {
                toRemove.getChildMeshes().forEach((m) => {
                    this.removeMesh(m);
                });
            }
            return index;
        }
        /**
         * Add a transform node to the list of scene's transform nodes
         * @param newTransformNode defines the transform node to add
         */
        addTransformNode(newTransformNode) {
            if (this._blockEntityCollection) {
                return;
            }
            if (newTransformNode.getScene() === this && newTransformNode._indexInSceneTransformNodesArray !== -1) {
                // Already there?
                return;
            }
            newTransformNode._indexInSceneTransformNodesArray = this.transformNodes.length;
            this.transformNodes.push(newTransformNode);
            if (!newTransformNode.parent) {
                newTransformNode._addToSceneRootNodes();
            }
            this.onNewTransformNodeAddedObservable.notifyObservers(newTransformNode);
        }
        /**
         * Remove a transform node for the list of scene's transform nodes
         * @param toRemove defines the transform node to remove
         * @returns the index where the transform node was in the transform node list
         */
        removeTransformNode(toRemove) {
            const index = toRemove._indexInSceneTransformNodesArray;
            if (index !== -1) {
                if (index !== this.transformNodes.length - 1) {
                    const lastNode = this.transformNodes[this.transformNodes.length - 1];
                    this.transformNodes[index] = lastNode;
                    lastNode._indexInSceneTransformNodesArray = index;
                }
                toRemove._indexInSceneTransformNodesArray = -1;
                this.transformNodes.pop();
                if (!toRemove.parent) {
                    toRemove._removeFromSceneRootNodes();
                }
            }
            this.onTransformNodeRemovedObservable.notifyObservers(toRemove);
            return index;
        }
        /**
         * Remove a skeleton for the list of scene's skeletons
         * @param toRemove defines the skeleton to remove
         * @returns the index where the skeleton was in the skeleton list
         */
        removeSkeleton(toRemove) {
            const index = this.skeletons.indexOf(toRemove);
            if (index !== -1) {
                // Remove from the scene if found
                this.skeletons.splice(index, 1);
                this.onSkeletonRemovedObservable.notifyObservers(toRemove);
                // Clean active container
                this._executeActiveContainerCleanup(this._activeSkeletons);
            }
            return index;
        }
        /**
         * Remove a morph target for the list of scene's morph targets
         * @param toRemove defines the morph target to remove
         * @returns the index where the morph target was in the morph target list
         */
        removeMorphTargetManager(toRemove) {
            const index = this.morphTargetManagers.indexOf(toRemove);
            if (index !== -1) {
                // Remove from the scene if found
                this.morphTargetManagers.splice(index, 1);
            }
            return index;
        }
        /**
         * Remove a light for the list of scene's lights
         * @param toRemove defines the light to remove
         * @returns the index where the light was in the light list
         */
        removeLight(toRemove) {
            const index = this.lights.indexOf(toRemove);
            if (index !== -1) {
                // Remove from meshes
                for (const mesh of this.meshes) {
                    mesh._removeLightSource(toRemove, false);
                }
                // Remove from the scene if mesh found
                this.lights.splice(index, 1);
                this.sortLightsByPriority();
                if (!toRemove.parent) {
                    toRemove._removeFromSceneRootNodes();
                }
            }
            this.onLightRemovedObservable.notifyObservers(toRemove);
            return index;
        }
        /**
         * Remove a camera for the list of scene's cameras
         * @param toRemove defines the camera to remove
         * @returns the index where the camera was in the camera list
         */
        removeCamera(toRemove) {
            const index = this.cameras.indexOf(toRemove);
            if (index !== -1) {
                // Remove from the scene if mesh found
                this.cameras.splice(index, 1);
                if (!toRemove.parent) {
                    toRemove._removeFromSceneRootNodes();
                }
            }
            // Remove from activeCameras
            if (this.activeCameras) {
                const index2 = this.activeCameras.indexOf(toRemove);
                if (index2 !== -1) {
                    // Remove from the scene if mesh found
                    this.activeCameras.splice(index2, 1);
                }
            }
            // Reset the activeCamera
            if (this.activeCamera === toRemove) {
                if (this.cameras.length > 0) {
                    this.activeCamera = this.cameras[0];
                }
                else {
                    this.activeCamera = null;
                }
            }
            this.onCameraRemovedObservable.notifyObservers(toRemove);
            return index;
        }
        /**
         * Remove a particle system for the list of scene's particle systems
         * @param toRemove defines the particle system to remove
         * @returns the index where the particle system was in the particle system list
         */
        removeParticleSystem(toRemove) {
            const index = this.particleSystems.indexOf(toRemove);
            if (index !== -1) {
                this.particleSystems.splice(index, 1);
                // Clean active container
                this._executeActiveContainerCleanup(this._activeParticleSystems);
            }
            return index;
        }
        /**
         * Remove a animation for the list of scene's animations
         * @param toRemove defines the animation to remove
         * @returns the index where the animation was in the animation list
         */
        removeAnimation(toRemove) {
            const index = this.animations.indexOf(toRemove);
            if (index !== -1) {
                this.animations.splice(index, 1);
            }
            return index;
        }
        /**
         * Will stop the animation of the given target
         * @param target - the target
         * @param animationName - the name of the animation to stop (all animations will be stopped if both this and targetMask are empty)
         * @param targetMask - a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
         */
        stopAnimation(target, animationName, targetMask) {
            // Do nothing as code will be provided by animation component
        }
        /**
         * Removes the given animation group from this scene.
         * @param toRemove The animation group to remove
         * @returns The index of the removed animation group
         */
        removeAnimationGroup(toRemove) {
            const index = this.animationGroups.indexOf(toRemove);
            if (index !== -1) {
                this.animationGroups.splice(index, 1);
            }
            return index;
        }
        /**
         * Removes the given multi-material from this scene.
         * @param toRemove The multi-material to remove
         * @returns The index of the removed multi-material
         */
        removeMultiMaterial(toRemove) {
            const index = this.multiMaterials.indexOf(toRemove);
            if (index !== -1) {
                this.multiMaterials.splice(index, 1);
            }
            this.onMultiMaterialRemovedObservable.notifyObservers(toRemove);
            return index;
        }
        /**
         * Removes the given material from this scene.
         * @param toRemove The material to remove
         * @returns The index of the removed material
         */
        removeMaterial(toRemove) {
            const index = toRemove._indexInSceneMaterialArray;
            if (index !== -1 && index < this.materials.length) {
                if (index !== this.materials.length - 1) {
                    const lastMaterial = this.materials[this.materials.length - 1];
                    this.materials[index] = lastMaterial;
                    lastMaterial._indexInSceneMaterialArray = index;
                }
                toRemove._indexInSceneMaterialArray = -1;
                this.materials.pop();
            }
            this.onMaterialRemovedObservable.notifyObservers(toRemove);
            return index;
        }
        /**
         * Removes the given action manager from this scene.
         * @deprecated
         * @param toRemove The action manager to remove
         * @returns The index of the removed action manager
         */
        removeActionManager(toRemove) {
            const index = this.actionManagers.indexOf(toRemove);
            if (index !== -1) {
                this.actionManagers.splice(index, 1);
            }
            return index;
        }
        /**
         * Removes the given texture from this scene.
         * @param toRemove The texture to remove
         * @returns The index of the removed texture
         */
        removeTexture(toRemove) {
            const index = this.textures.indexOf(toRemove);
            if (index !== -1) {
                this.textures.splice(index, 1);
            }
            this.onTextureRemovedObservable.notifyObservers(toRemove);
            return index;
        }
        /**
         * Adds the given light to this scene
         * @param newLight The light to add
         */
        addLight(newLight) {
            if (this._blockEntityCollection) {
                return;
            }
            this.lights.push(newLight);
            this.sortLightsByPriority();
            if (!newLight.parent) {
                newLight._addToSceneRootNodes();
            }
            // Add light to all meshes (To support if the light is removed and then re-added)
            for (const mesh of this.meshes) {
                if (mesh.lightSources.indexOf(newLight) === -1) {
                    mesh.lightSources.push(newLight);
                    mesh._resyncLightSources();
                }
            }
            this.onNewLightAddedObservable.notifyObservers(newLight);
        }
        /**
         * Sorts the list list based on light priorities
         */
        sortLightsByPriority() {
            if (this.requireLightSorting) {
                this.lights.sort(LightConstants.CompareLightsPriority);
            }
        }
        /**
         * Adds the given camera to this scene
         * @param newCamera The camera to add
         */
        addCamera(newCamera) {
            if (this._blockEntityCollection) {
                return;
            }
            this.cameras.push(newCamera);
            this.onNewCameraAddedObservable.notifyObservers(newCamera);
            if (!newCamera.parent) {
                newCamera._addToSceneRootNodes();
            }
        }
        /**
         * Adds the given skeleton to this scene
         * @param newSkeleton The skeleton to add
         */
        addSkeleton(newSkeleton) {
            if (this._blockEntityCollection) {
                return;
            }
            this.skeletons.push(newSkeleton);
            this.onNewSkeletonAddedObservable.notifyObservers(newSkeleton);
        }
        /**
         * Adds the given particle system to this scene
         * @param newParticleSystem The particle system to add
         */
        addParticleSystem(newParticleSystem) {
            if (this._blockEntityCollection) {
                return;
            }
            this.particleSystems.push(newParticleSystem);
        }
        /**
         * Adds the given animation to this scene
         * @param newAnimation The animation to add
         */
        addAnimation(newAnimation) {
            if (this._blockEntityCollection) {
                return;
            }
            this.animations.push(newAnimation);
        }
        /**
         * Adds the given animation group to this scene.
         * @param newAnimationGroup The animation group to add
         */
        addAnimationGroup(newAnimationGroup) {
            if (this._blockEntityCollection) {
                return;
            }
            this.animationGroups.push(newAnimationGroup);
        }
        /**
         * Adds the given multi-material to this scene
         * @param newMultiMaterial The multi-material to add
         */
        addMultiMaterial(newMultiMaterial) {
            if (this._blockEntityCollection) {
                return;
            }
            this.multiMaterials.push(newMultiMaterial);
            this.onNewMultiMaterialAddedObservable.notifyObservers(newMultiMaterial);
        }
        /**
         * Adds the given material to this scene
         * @param newMaterial The material to add
         */
        addMaterial(newMaterial) {
            if (this._blockEntityCollection) {
                return;
            }
            if (newMaterial.getScene() === this && newMaterial._indexInSceneMaterialArray !== -1) {
                // Already there??
                return;
            }
            newMaterial._indexInSceneMaterialArray = this.materials.length;
            this.materials.push(newMaterial);
            this.onNewMaterialAddedObservable.notifyObservers(newMaterial);
        }
        /**
         * Adds the given morph target to this scene
         * @param newMorphTargetManager The morph target to add
         */
        addMorphTargetManager(newMorphTargetManager) {
            if (this._blockEntityCollection) {
                return;
            }
            this.morphTargetManagers.push(newMorphTargetManager);
        }
        /**
         * Adds the given geometry to this scene
         * @param newGeometry The geometry to add
         */
        addGeometry(newGeometry) {
            if (this._blockEntityCollection) {
                return;
            }
            if (this._geometriesByUniqueId) {
                this._geometriesByUniqueId[newGeometry.uniqueId] = this.geometries.length;
            }
            this.geometries.push(newGeometry);
        }
        /**
         * Adds the given action manager to this scene
         * @deprecated
         * @param newActionManager The action manager to add
         */
        addActionManager(newActionManager) {
            this.actionManagers.push(newActionManager);
        }
        /**
         * Adds the given texture to this scene.
         * @param newTexture The texture to add
         */
        addTexture(newTexture) {
            if (this._blockEntityCollection) {
                return;
            }
            this.textures.push(newTexture);
            this.onNewTextureAddedObservable.notifyObservers(newTexture);
        }
        /**
         * Switch active camera
         * @param newCamera defines the new active camera
         * @param attachControl defines if attachControl must be called for the new active camera (default: true)
         */
        switchActiveCamera(newCamera, attachControl = true) {
            const canvas = this._engine.getInputElement();
            if (!canvas) {
                return;
            }
            if (this.activeCamera) {
                this.activeCamera.detachControl();
            }
            this.activeCamera = newCamera;
            if (attachControl) {
                newCamera.attachControl();
            }
        }
        /**
         * sets the active camera of the scene using its Id
         * @param id defines the camera's Id
         * @returns the new active camera or null if none found.
         */
        setActiveCameraById(id) {
            const camera = this.getCameraById(id);
            if (camera) {
                this.activeCamera = camera;
                return camera;
            }
            return null;
        }
        /**
         * sets the active camera of the scene using its name
         * @param name defines the camera's name
         * @returns the new active camera or null if none found.
         */
        setActiveCameraByName(name) {
            const camera = this.getCameraByName(name);
            if (camera) {
                this.activeCamera = camera;
                return camera;
            }
            return null;
        }
        /**
         * get an animation group using its name
         * @param name defines the material's name
         * @returns the animation group or null if none found.
         */
        getAnimationGroupByName(name) {
            for (let index = 0; index < this.animationGroups.length; index++) {
                if (this.animationGroups[index].name === name) {
                    return this.animationGroups[index];
                }
            }
            return null;
        }
        _getMaterial(allowMultiMaterials, predicate) {
            for (let index = 0; index < this.materials.length; index++) {
                const material = this.materials[index];
                if (predicate(material)) {
                    return material;
                }
            }
            if (allowMultiMaterials) {
                for (let index = 0; index < this.multiMaterials.length; index++) {
                    const material = this.multiMaterials[index];
                    if (predicate(material)) {
                        return material;
                    }
                }
            }
            return null;
        }
        /**
         * Get a material using its unique id
         * @param uniqueId defines the material's unique id
         * @param allowMultiMaterials determines whether multimaterials should be considered
         * @returns the material or null if none found.
         */
        getMaterialByUniqueID(uniqueId, allowMultiMaterials = false) {
            return this._getMaterial(allowMultiMaterials, (m) => m.uniqueId === uniqueId);
        }
        /**
         * get a material using its id
         * @param id defines the material's Id
         * @param allowMultiMaterials determines whether multimaterials should be considered
         * @returns the material or null if none found.
         */
        getMaterialById(id, allowMultiMaterials = false) {
            return this._getMaterial(allowMultiMaterials, (m) => m.id === id);
        }
        /**
         * Gets a material using its name
         * @param name defines the material's name
         * @param allowMultiMaterials determines whether multimaterials should be considered
         * @returns the material or null if none found.
         */
        getMaterialByName(name, allowMultiMaterials = false) {
            return this._getMaterial(allowMultiMaterials, (m) => m.name === name);
        }
        /**
         * Gets a last added material using a given id
         * @param id defines the material's id
         * @param allowMultiMaterials determines whether multimaterials should be considered
         * @returns the last material with the given id or null if none found.
         */
        getLastMaterialById(id, allowMultiMaterials = false) {
            for (let index = this.materials.length - 1; index >= 0; index--) {
                if (this.materials[index].id === id) {
                    return this.materials[index];
                }
            }
            if (allowMultiMaterials) {
                for (let index = this.multiMaterials.length - 1; index >= 0; index--) {
                    if (this.multiMaterials[index].id === id) {
                        return this.multiMaterials[index];
                    }
                }
            }
            return null;
        }
        /**
         * Get a texture using its unique id
         * @param uniqueId defines the texture's unique id
         * @returns the texture or null if none found.
         */
        getTextureByUniqueId(uniqueId) {
            for (let index = 0; index < this.textures.length; index++) {
                if (this.textures[index].uniqueId === uniqueId) {
                    return this.textures[index];
                }
            }
            return null;
        }
        /**
         * Gets a texture using its name
         * @param name defines the texture's name
         * @returns the texture or null if none found.
         */
        getTextureByName(name) {
            for (let index = 0; index < this.textures.length; index++) {
                if (this.textures[index].name === name) {
                    return this.textures[index];
                }
            }
            return null;
        }
        /**
         * Gets a camera using its Id
         * @param id defines the Id to look for
         * @returns the camera or null if not found
         */
        getCameraById(id) {
            for (let index = 0; index < this.cameras.length; index++) {
                if (this.cameras[index].id === id) {
                    return this.cameras[index];
                }
            }
            return null;
        }
        /**
         * Gets a camera using its unique Id
         * @param uniqueId defines the unique Id to look for
         * @returns the camera or null if not found
         */
        getCameraByUniqueId(uniqueId) {
            for (let index = 0; index < this.cameras.length; index++) {
                if (this.cameras[index].uniqueId === uniqueId) {
                    return this.cameras[index];
                }
            }
            return null;
        }
        /**
         * Gets a camera using its name
         * @param name defines the camera's name
         * @returns the camera or null if none found.
         */
        getCameraByName(name) {
            for (let index = 0; index < this.cameras.length; index++) {
                if (this.cameras[index].name === name) {
                    return this.cameras[index];
                }
            }
            return null;
        }
        /**
         * Gets a bone using its Id
         * @param id defines the bone's Id
         * @returns the bone or null if not found
         */
        getBoneById(id) {
            for (let skeletonIndex = 0; skeletonIndex < this.skeletons.length; skeletonIndex++) {
                const skeleton = this.skeletons[skeletonIndex];
                for (let boneIndex = 0; boneIndex < skeleton.bones.length; boneIndex++) {
                    if (skeleton.bones[boneIndex].id === id) {
                        return skeleton.bones[boneIndex];
                    }
                }
            }
            return null;
        }
        /**
         * Gets a bone using its id
         * @param name defines the bone's name
         * @returns the bone or null if not found
         */
        getBoneByName(name) {
            for (let skeletonIndex = 0; skeletonIndex < this.skeletons.length; skeletonIndex++) {
                const skeleton = this.skeletons[skeletonIndex];
                for (let boneIndex = 0; boneIndex < skeleton.bones.length; boneIndex++) {
                    if (skeleton.bones[boneIndex].name === name) {
                        return skeleton.bones[boneIndex];
                    }
                }
            }
            return null;
        }
        /**
         * Gets a light node using its name
         * @param name defines the the light's name
         * @returns the light or null if none found.
         */
        getLightByName(name) {
            for (let index = 0; index < this.lights.length; index++) {
                if (this.lights[index].name === name) {
                    return this.lights[index];
                }
            }
            return null;
        }
        /**
         * Gets a light node using its Id
         * @param id defines the light's Id
         * @returns the light or null if none found.
         */
        getLightById(id) {
            for (let index = 0; index < this.lights.length; index++) {
                if (this.lights[index].id === id) {
                    return this.lights[index];
                }
            }
            return null;
        }
        /**
         * Gets a light node using its scene-generated unique Id
         * @param uniqueId defines the light's unique Id
         * @returns the light or null if none found.
         */
        getLightByUniqueId(uniqueId) {
            for (let index = 0; index < this.lights.length; index++) {
                if (this.lights[index].uniqueId === uniqueId) {
                    return this.lights[index];
                }
            }
            return null;
        }
        /**
         * Gets a particle system by Id
         * @param id defines the particle system Id
         * @returns the corresponding system or null if none found
         */
        getParticleSystemById(id) {
            for (let index = 0; index < this.particleSystems.length; index++) {
                if (this.particleSystems[index].id === id) {
                    return this.particleSystems[index];
                }
            }
            return null;
        }
        /**
         * Gets a geometry using its Id
         * @param id defines the geometry's Id
         * @returns the geometry or null if none found.
         */
        getGeometryById(id) {
            for (let index = 0; index < this.geometries.length; index++) {
                if (this.geometries[index].id === id) {
                    return this.geometries[index];
                }
            }
            return null;
        }
        _getGeometryByUniqueId(uniqueId) {
            if (this._geometriesByUniqueId) {
                const index = this._geometriesByUniqueId[uniqueId];
                if (index !== undefined) {
                    return this.geometries[index];
                }
            }
            else {
                for (let index = 0; index < this.geometries.length; index++) {
                    if (this.geometries[index].uniqueId === uniqueId) {
                        return this.geometries[index];
                    }
                }
            }
            return null;
        }
        /**
         * Add a new geometry to this scene
         * @param geometry defines the geometry to be added to the scene.
         * @param force defines if the geometry must be pushed even if a geometry with this id already exists
         * @returns a boolean defining if the geometry was added or not
         */
        pushGeometry(geometry, force) {
            if (!force && this._getGeometryByUniqueId(geometry.uniqueId)) {
                return false;
            }
            this.addGeometry(geometry);
            this.onNewGeometryAddedObservable.notifyObservers(geometry);
            return true;
        }
        /**
         * Removes an existing geometry
         * @param geometry defines the geometry to be removed from the scene
         * @returns a boolean defining if the geometry was removed or not
         */
        removeGeometry(geometry) {
            let index;
            if (this._geometriesByUniqueId) {
                index = this._geometriesByUniqueId[geometry.uniqueId];
                if (index === undefined) {
                    return false;
                }
            }
            else {
                index = this.geometries.indexOf(geometry);
                if (index < 0) {
                    return false;
                }
            }
            if (index !== this.geometries.length - 1) {
                const lastGeometry = this.geometries[this.geometries.length - 1];
                if (lastGeometry) {
                    this.geometries[index] = lastGeometry;
                    if (this._geometriesByUniqueId) {
                        this._geometriesByUniqueId[lastGeometry.uniqueId] = index;
                    }
                }
            }
            if (this._geometriesByUniqueId) {
                this._geometriesByUniqueId[geometry.uniqueId] = undefined;
            }
            this.geometries.pop();
            this.onGeometryRemovedObservable.notifyObservers(geometry);
            return true;
        }
        /**
         * Gets the list of geometries attached to the scene
         * @returns an array of Geometry
         */
        getGeometries() {
            return this.geometries;
        }
        /**
         * Gets the first added mesh found of a given Id
         * @param id defines the Id to search for
         * @returns the mesh found or null if not found at all
         */
        getMeshById(id) {
            for (let index = 0; index < this.meshes.length; index++) {
                if (this.meshes[index].id === id) {
                    return this.meshes[index];
                }
            }
            return null;
        }
        /**
         * Gets a list of meshes using their Id
         * @param id defines the Id to search for
         * @returns a list of meshes
         */
        getMeshesById(id) {
            return this.meshes.filter(function (m) {
                return m.id === id;
            });
        }
        /**
         * Gets the first added transform node found of a given Id
         * @param id defines the Id to search for
         * @returns the found transform node or null if not found at all.
         */
        getTransformNodeById(id) {
            for (let index = 0; index < this.transformNodes.length; index++) {
                if (this.transformNodes[index].id === id) {
                    return this.transformNodes[index];
                }
            }
            return null;
        }
        /**
         * Gets a transform node with its auto-generated unique Id
         * @param uniqueId defines the unique Id to search for
         * @returns the found transform node or null if not found at all.
         */
        getTransformNodeByUniqueId(uniqueId) {
            for (let index = 0; index < this.transformNodes.length; index++) {
                if (this.transformNodes[index].uniqueId === uniqueId) {
                    return this.transformNodes[index];
                }
            }
            return null;
        }
        /**
         * Gets a list of transform nodes using their Id
         * @param id defines the Id to search for
         * @returns a list of transform nodes
         */
        getTransformNodesById(id) {
            return this.transformNodes.filter(function (m) {
                return m.id === id;
            });
        }
        /**
         * Gets a mesh with its auto-generated unique Id
         * @param uniqueId defines the unique Id to search for
         * @returns the found mesh or null if not found at all.
         */
        getMeshByUniqueId(uniqueId) {
            for (let index = 0; index < this.meshes.length; index++) {
                if (this.meshes[index].uniqueId === uniqueId) {
                    return this.meshes[index];
                }
            }
            return null;
        }
        /**
         * Gets a the last added mesh using a given Id
         * @param id defines the Id to search for
         * @returns the found mesh or null if not found at all.
         */
        getLastMeshById(id) {
            for (let index = this.meshes.length - 1; index >= 0; index--) {
                if (this.meshes[index].id === id) {
                    return this.meshes[index];
                }
            }
            return null;
        }
        /**
         * Gets a the last transform node using a given Id
         * @param id defines the Id to search for
         * @returns the found mesh or null if not found at all.
         */
        getLastTransformNodeById(id) {
            for (let index = this.transformNodes.length - 1; index >= 0; index--) {
                if (this.transformNodes[index].id === id) {
                    return this.transformNodes[index];
                }
            }
            return null;
        }
        /**
         * Gets a the last added node (Mesh, Camera, Light) using a given Id
         * @param id defines the Id to search for
         * @returns the found node or null if not found at all
         */
        getLastEntryById(id) {
            let index;
            for (index = this.meshes.length - 1; index >= 0; index--) {
                if (this.meshes[index].id === id) {
                    return this.meshes[index];
                }
            }
            for (index = this.transformNodes.length - 1; index >= 0; index--) {
                if (this.transformNodes[index].id === id) {
                    return this.transformNodes[index];
                }
            }
            for (index = this.cameras.length - 1; index >= 0; index--) {
                if (this.cameras[index].id === id) {
                    return this.cameras[index];
                }
            }
            for (index = this.lights.length - 1; index >= 0; index--) {
                if (this.lights[index].id === id) {
                    return this.lights[index];
                }
            }
            return null;
        }
        /**
         * Gets a node (Mesh, Camera, Light) using a given Id
         * @param id defines the Id to search for
         * @returns the found node or null if not found at all
         */
        getNodeById(id) {
            const mesh = this.getMeshById(id);
            if (mesh) {
                return mesh;
            }
            const transformNode = this.getTransformNodeById(id);
            if (transformNode) {
                return transformNode;
            }
            const light = this.getLightById(id);
            if (light) {
                return light;
            }
            const camera = this.getCameraById(id);
            if (camera) {
                return camera;
            }
            const bone = this.getBoneById(id);
            if (bone) {
                return bone;
            }
            return null;
        }
        /**
         * Gets a node (Mesh, Camera, Light) using a given name
         * @param name defines the name to search for
         * @returns the found node or null if not found at all.
         */
        getNodeByName(name) {
            const mesh = this.getMeshByName(name);
            if (mesh) {
                return mesh;
            }
            const transformNode = this.getTransformNodeByName(name);
            if (transformNode) {
                return transformNode;
            }
            const light = this.getLightByName(name);
            if (light) {
                return light;
            }
            const camera = this.getCameraByName(name);
            if (camera) {
                return camera;
            }
            const bone = this.getBoneByName(name);
            if (bone) {
                return bone;
            }
            return null;
        }
        /**
         * Gets a mesh using a given name
         * @param name defines the name to search for
         * @returns the found mesh or null if not found at all.
         */
        getMeshByName(name) {
            for (let index = 0; index < this.meshes.length; index++) {
                if (this.meshes[index].name === name) {
                    return this.meshes[index];
                }
            }
            return null;
        }
        /**
         * Gets a transform node using a given name
         * @param name defines the name to search for
         * @returns the found transform node or null if not found at all.
         */
        getTransformNodeByName(name) {
            for (let index = 0; index < this.transformNodes.length; index++) {
                if (this.transformNodes[index].name === name) {
                    return this.transformNodes[index];
                }
            }
            return null;
        }
        /**
         * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
         * @param id defines the Id to search for
         * @returns the found skeleton or null if not found at all.
         */
        getLastSkeletonById(id) {
            for (let index = this.skeletons.length - 1; index >= 0; index--) {
                if (this.skeletons[index].id === id) {
                    return this.skeletons[index];
                }
            }
            return null;
        }
        /**
         * Gets a skeleton using a given auto generated unique id
         * @param  uniqueId defines the unique id to search for
         * @returns the found skeleton or null if not found at all.
         */
        getSkeletonByUniqueId(uniqueId) {
            for (let index = 0; index < this.skeletons.length; index++) {
                if (this.skeletons[index].uniqueId === uniqueId) {
                    return this.skeletons[index];
                }
            }
            return null;
        }
        /**
         * Gets a skeleton using a given id (if many are found, this function will pick the first one)
         * @param id defines the id to search for
         * @returns the found skeleton or null if not found at all.
         */
        getSkeletonById(id) {
            for (let index = 0; index < this.skeletons.length; index++) {
                if (this.skeletons[index].id === id) {
                    return this.skeletons[index];
                }
            }
            return null;
        }
        /**
         * Gets a skeleton using a given name
         * @param name defines the name to search for
         * @returns the found skeleton or null if not found at all.
         */
        getSkeletonByName(name) {
            for (let index = 0; index < this.skeletons.length; index++) {
                if (this.skeletons[index].name === name) {
                    return this.skeletons[index];
                }
            }
            return null;
        }
        /**
         * Gets a morph target manager  using a given id (if many are found, this function will pick the last one)
         * @param id defines the id to search for
         * @returns the found morph target manager or null if not found at all.
         */
        getMorphTargetManagerById(id) {
            for (let index = 0; index < this.morphTargetManagers.length; index++) {
                if (this.morphTargetManagers[index].uniqueId === id) {
                    return this.morphTargetManagers[index];
                }
            }
            return null;
        }
        /**
         * Gets a morph target using a given id (if many are found, this function will pick the first one)
         * @param id defines the id to search for
         * @returns the found morph target or null if not found at all.
         */
        getMorphTargetById(id) {
            for (let managerIndex = 0; managerIndex < this.morphTargetManagers.length; ++managerIndex) {
                const morphTargetManager = this.morphTargetManagers[managerIndex];
                for (let index = 0; index < morphTargetManager.numTargets; ++index) {
                    const target = morphTargetManager.getTarget(index);
                    if (target.id === id) {
                        return target;
                    }
                }
            }
            return null;
        }
        /**
         * Gets a morph target using a given name (if many are found, this function will pick the first one)
         * @param name defines the name to search for
         * @returns the found morph target or null if not found at all.
         */
        getMorphTargetByName(name) {
            for (let managerIndex = 0; managerIndex < this.morphTargetManagers.length; ++managerIndex) {
                const morphTargetManager = this.morphTargetManagers[managerIndex];
                for (let index = 0; index < morphTargetManager.numTargets; ++index) {
                    const target = morphTargetManager.getTarget(index);
                    if (target.name === name) {
                        return target;
                    }
                }
            }
            return null;
        }
        /**
         * Gets a post process using a given name (if many are found, this function will pick the first one)
         * @param name defines the name to search for
         * @returns the found post process or null if not found at all.
         */
        getPostProcessByName(name) {
            for (let postProcessIndex = 0; postProcessIndex < this.postProcesses.length; ++postProcessIndex) {
                const postProcess = this.postProcesses[postProcessIndex];
                if (postProcess.name === name) {
                    return postProcess;
                }
            }
            return null;
        }
        /**
         * Gets a boolean indicating if the given mesh is active
         * @param mesh defines the mesh to look for
         * @returns true if the mesh is in the active list
         */
        isActiveMesh(mesh) {
            return this._activeMeshes.indexOf(mesh) !== -1;
        }
        /**
         * Return a unique id as a string which can serve as an identifier for the scene
         */
        get uid() {
            if (!this._uid) {
                this._uid = Tools.RandomId();
            }
            return this._uid;
        }
        /**
         * Add an externally attached data from its key.
         * This method call will fail and return false, if such key already exists.
         * If you don't care and just want to get the data no matter what, use the more convenient getOrAddExternalDataWithFactory() method.
         * @param key the unique key that identifies the data
         * @param data the data object to associate to the key for this Engine instance
         * @returns true if no such key were already present and the data was added successfully, false otherwise
         */
        addExternalData(key, data) {
            if (!this._externalData) {
                this._externalData = new StringDictionary();
            }
            return this._externalData.add(key, data);
        }
        /**
         * Get an externally attached data from its key
         * @param key the unique key that identifies the data
         * @returns the associated data, if present (can be null), or undefined if not present
         */
        getExternalData(key) {
            if (!this._externalData) {
                return null;
            }
            return this._externalData.get(key);
        }
        /**
         * Get an externally attached data from its key, create it using a factory if it's not already present
         * @param key the unique key that identifies the data
         * @param factory the factory that will be called to create the instance if and only if it doesn't exists
         * @returns the associated data, can be null if the factory returned null.
         */
        getOrAddExternalDataWithFactory(key, factory) {
            if (!this._externalData) {
                this._externalData = new StringDictionary();
            }
            return this._externalData.getOrAddWithFactory(key, factory);
        }
        /**
         * Remove an externally attached data from the Engine instance
         * @param key the unique key that identifies the data
         * @returns true if the data was successfully removed, false if it doesn't exist
         */
        removeExternalData(key) {
            return this._externalData.remove(key);
        }
        _evaluateSubMesh(subMesh, mesh, initialMesh, forcePush) {
            if (forcePush || subMesh.isInFrustum(this._frustumPlanes)) {
                for (const step of this._evaluateSubMeshStage) {
                    step.action(mesh, subMesh);
                }
                const material = subMesh.getMaterial();
                if (material !== null && material !== undefined) {
                    // Render targets
                    if (material.hasRenderTargetTextures && material.getRenderTargetTextures != null) {
                        if (this._processedMaterials.indexOf(material) === -1) {
                            this._processedMaterials.push(material);
                            this._materialsRenderTargets.concatWithNoDuplicate(material.getRenderTargetTextures());
                        }
                    }
                    // Dispatch
                    this._renderingManager.dispatch(subMesh, mesh, material);
                }
            }
        }
        /**
         * Clear the processed materials smart array preventing retention point in material dispose.
         */
        freeProcessedMaterials() {
            this._processedMaterials.dispose();
        }
        /** Gets or sets a boolean blocking all the calls to freeActiveMeshes and freeRenderingGroups
         * It can be used in order to prevent going through methods freeRenderingGroups and freeActiveMeshes several times to improve performance
         * when disposing several meshes in a row or a hierarchy of meshes.
         * When used, it is the responsibility of the user to blockfreeActiveMeshesAndRenderingGroups back to false.
         */
        get blockfreeActiveMeshesAndRenderingGroups() {
            return this._preventFreeActiveMeshesAndRenderingGroups;
        }
        set blockfreeActiveMeshesAndRenderingGroups(value) {
            if (this._preventFreeActiveMeshesAndRenderingGroups === value) {
                return;
            }
            if (value) {
                this.freeActiveMeshes();
                this.freeRenderingGroups();
            }
            this._preventFreeActiveMeshesAndRenderingGroups = value;
        }
        /**
         * Clear the active meshes smart array preventing retention point in mesh dispose.
         */
        freeActiveMeshes() {
            if (this.blockfreeActiveMeshesAndRenderingGroups) {
                return;
            }
            this._activeMeshes.dispose();
            if (this.activeCamera && this.activeCamera._activeMeshes) {
                this.activeCamera._activeMeshes.dispose();
            }
            if (this.activeCameras) {
                for (let i = 0; i < this.activeCameras.length; i++) {
                    const activeCamera = this.activeCameras[i];
                    if (activeCamera && activeCamera._activeMeshes) {
                        activeCamera._activeMeshes.dispose();
                    }
                }
            }
        }
        /**
         * Clear the info related to rendering groups preventing retention points during dispose.
         */
        freeRenderingGroups() {
            if (this.blockfreeActiveMeshesAndRenderingGroups) {
                return;
            }
            if (this._renderingManager) {
                this._renderingManager.freeRenderingGroups();
            }
            if (this.textures) {
                for (let i = 0; i < this.textures.length; i++) {
                    const texture = this.textures[i];
                    if (texture && texture.renderList) {
                        texture.freeRenderingGroups();
                    }
                }
            }
        }
        /** @internal */
        _isInIntermediateRendering() {
            return this._intermediateRendering;
        }
        /**
         * Use this function to stop evaluating active meshes. The current list will be keep alive between frames
         * @param skipEvaluateActiveMeshes defines an optional boolean indicating that the evaluate active meshes step must be completely skipped
         * @param onSuccess optional success callback
         * @param onError optional error callback
         * @param freezeMeshes defines if meshes should be frozen (true by default)
         * @param keepFrustumCulling defines if you want to keep running the frustum clipping (false by default)
         * @returns the current scene
         */
        freezeActiveMeshes(skipEvaluateActiveMeshes = false, onSuccess, onError, freezeMeshes = true, keepFrustumCulling = false) {
            this.executeWhenReady(() => {
                if (!this.activeCamera) {
                    onError && onError("No active camera found");
                    return;
                }
                if (!this._frustumPlanes) {
                    this.updateTransformMatrix();
                }
                this._evaluateActiveMeshes();
                this._activeMeshesFrozen = true;
                this._activeMeshesFrozenButKeepClipping = keepFrustumCulling;
                this._skipEvaluateActiveMeshesCompletely = skipEvaluateActiveMeshes;
                if (freezeMeshes) {
                    for (let index = 0; index < this._activeMeshes.length; index++) {
                        this._activeMeshes.data[index]._freeze();
                    }
                }
                onSuccess && onSuccess();
            });
            return this;
        }
        /**
         * Use this function to restart evaluating active meshes on every frame
         * @returns the current scene
         */
        unfreezeActiveMeshes() {
            for (let index = 0; index < this.meshes.length; index++) {
                const mesh = this.meshes[index];
                if (mesh._internalAbstractMeshDataInfo) {
                    mesh._internalAbstractMeshDataInfo._isActive = false;
                }
            }
            for (let index = 0; index < this._activeMeshes.length; index++) {
                this._activeMeshes.data[index]._unFreeze();
            }
            this._activeMeshesFrozen = false;
            return this;
        }
        _executeActiveContainerCleanup(container) {
            const isInFastMode = this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1;
            if (!isInFastMode && this._activeMeshesFrozen && this._activeMeshes.length) {
                return; // Do not execute in frozen mode
            }
            // We need to ensure we are not in the rendering loop
            this.onBeforeRenderObservable.addOnce(() => container.dispose());
        }
        _evaluateActiveMeshes() {
            var _a;
            if (this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1) {
                if (this._activeMeshes.length > 0) {
                    (_a = this.activeCamera) === null || _a === void 0 ? void 0 : _a._activeMeshes.reset();
                    this._activeMeshes.reset();
                    this._renderingManager.reset();
                    this._processedMaterials.reset();
                    this._activeParticleSystems.reset();
                    this._activeSkeletons.reset();
                    this._softwareSkinnedMeshes.reset();
                }
                return;
            }
            if (this._activeMeshesFrozen && this._activeMeshes.length) {
                if (!this._skipEvaluateActiveMeshesCompletely) {
                    const len = this._activeMeshes.length;
                    for (let i = 0; i < len; i++) {
                        const mesh = this._activeMeshes.data[i];
                        mesh.computeWorldMatrix();
                    }
                }
                if (this._activeParticleSystems) {
                    const psLength = this._activeParticleSystems.length;
                    for (let i = 0; i < psLength; i++) {
                        this._activeParticleSystems.data[i].animate();
                    }
                }
                this._renderingManager.resetSprites();
                return;
            }
            if (!this.activeCamera) {
                return;
            }
            this.onBeforeActiveMeshesEvaluationObservable.notifyObservers(this);
            this.activeCamera._activeMeshes.reset();
            this._activeMeshes.reset();
            this._renderingManager.reset();
            this._processedMaterials.reset();
            this._activeParticleSystems.reset();
            this._activeSkeletons.reset();
            this._softwareSkinnedMeshes.reset();
            this._materialsRenderTargets.reset();
            for (const step of this._beforeEvaluateActiveMeshStage) {
                step.action();
            }
            // Determine mesh candidates
            const meshes = this.getActiveMeshCandidates();
            // Check each mesh
            const len = meshes.length;
            for (let i = 0; i < len; i++) {
                const mesh = meshes.data[i];
                mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate = false;
                if (mesh.isBlocked) {
                    continue;
                }
                this._totalVertices.addCount(mesh.getTotalVertices(), false);
                if (!mesh.isReady() || !mesh.isEnabled() || mesh.scaling.hasAZeroComponent) {
                    continue;
                }
                mesh.computeWorldMatrix();
                // Intersections
                if (mesh.actionManager && mesh.actionManager.hasSpecificTriggers2(12, 13)) {
                    this._meshesForIntersections.pushNoDuplicate(mesh);
                }
                // Switch to current LOD
                let meshToRender = this.customLODSelector ? this.customLODSelector(mesh, this.activeCamera) : mesh.getLOD(this.activeCamera);
                mesh._internalAbstractMeshDataInfo._currentLOD = meshToRender;
                mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate = true;
                if (meshToRender === undefined || meshToRender === null) {
                    continue;
                }
                // Compute world matrix if LOD is billboard
                if (meshToRender !== mesh && meshToRender.billboardMode !== 0) {
                    meshToRender.computeWorldMatrix();
                }
                mesh._preActivate();
                if (mesh.isVisible &&
                    mesh.visibility > 0 &&
                    (mesh.layerMask & this.activeCamera.layerMask) !== 0 &&
                    (this._skipFrustumClipping || mesh.alwaysSelectAsActiveMesh || mesh.isInFrustum(this._frustumPlanes))) {
                    this._activeMeshes.push(mesh);
                    this.activeCamera._activeMeshes.push(mesh);
                    if (meshToRender !== mesh) {
                        meshToRender._activate(this._renderId, false);
                    }
                    for (const step of this._preActiveMeshStage) {
                        step.action(mesh);
                    }
                    if (mesh._activate(this._renderId, false)) {
                        if (!mesh.isAnInstance) {
                            meshToRender._internalAbstractMeshDataInfo._onlyForInstances = false;
                        }
                        else {
                            if (mesh._internalAbstractMeshDataInfo._actAsRegularMesh) {
                                meshToRender = mesh;
                            }
                        }
                        meshToRender._internalAbstractMeshDataInfo._isActive = true;
                        this._activeMesh(mesh, meshToRender);
                    }
                    mesh._postActivate();
                }
            }
            this.onAfterActiveMeshesEvaluationObservable.notifyObservers(this);
            // Particle systems
            if (this.particlesEnabled) {
                this.onBeforeParticlesRenderingObservable.notifyObservers(this);
                for (let particleIndex = 0; particleIndex < this.particleSystems.length; particleIndex++) {
                    const particleSystem = this.particleSystems[particleIndex];
                    if (!particleSystem.isStarted() || !particleSystem.emitter) {
                        continue;
                    }
                    const emitter = particleSystem.emitter;
                    if (!emitter.position || emitter.isEnabled()) {
                        this._activeParticleSystems.push(particleSystem);
                        particleSystem.animate();
                        this._renderingManager.dispatchParticles(particleSystem);
                    }
                }
                this.onAfterParticlesRenderingObservable.notifyObservers(this);
            }
        }
        _activeMesh(sourceMesh, mesh) {
            if (this._skeletonsEnabled && mesh.skeleton !== null && mesh.skeleton !== undefined) {
                if (this._activeSkeletons.pushNoDuplicate(mesh.skeleton)) {
                    mesh.skeleton.prepare();
                    this._activeBones.addCount(mesh.skeleton.bones.length, false);
                }
                if (!mesh.computeBonesUsingShaders) {
                    this._softwareSkinnedMeshes.pushNoDuplicate(mesh);
                }
            }
            let forcePush = sourceMesh.hasInstances || sourceMesh.isAnInstance || this.dispatchAllSubMeshesOfActiveMeshes || this._skipFrustumClipping || mesh.alwaysSelectAsActiveMesh;
            if (mesh && mesh.subMeshes && mesh.subMeshes.length > 0) {
                const subMeshes = this.getActiveSubMeshCandidates(mesh);
                const len = subMeshes.length;
                forcePush = forcePush || len === 1;
                for (let i = 0; i < len; i++) {
                    const subMesh = subMeshes.data[i];
                    this._evaluateSubMesh(subMesh, mesh, sourceMesh, forcePush);
                }
            }
        }
        /**
         * Update the transform matrix to update from the current active camera
         * @param force defines a boolean used to force the update even if cache is up to date
         */
        updateTransformMatrix(force) {
            if (!this.activeCamera) {
                return;
            }
            if (this.activeCamera._renderingMultiview) {
                const leftCamera = this.activeCamera._rigCameras[0];
                const rightCamera = this.activeCamera._rigCameras[1];
                this.setTransformMatrix(leftCamera.getViewMatrix(), leftCamera.getProjectionMatrix(force), rightCamera.getViewMatrix(), rightCamera.getProjectionMatrix(force));
            }
            else {
                this.setTransformMatrix(this.activeCamera.getViewMatrix(), this.activeCamera.getProjectionMatrix(force));
            }
        }
        _bindFrameBuffer(camera, clear = true) {
            if (camera && camera._multiviewTexture) {
                camera._multiviewTexture._bindFrameBuffer();
            }
            else if (camera && camera.outputRenderTarget) {
                camera.outputRenderTarget._bindFrameBuffer();
            }
            else {
                if (!this._engine._currentFrameBufferIsDefaultFrameBuffer()) {
                    this._engine.restoreDefaultFramebuffer();
                }
            }
            if (clear) {
                this._clearFrameBuffer(camera);
            }
        }
        _clearFrameBuffer(camera) {
            // we assume the framebuffer currently bound is the right one
            if (camera && camera._multiviewTexture) ;
            else if (camera && camera.outputRenderTarget && !camera._renderingMultiview) {
                const rtt = camera.outputRenderTarget;
                if (rtt.onClearObservable.hasObservers()) {
                    rtt.onClearObservable.notifyObservers(this._engine);
                }
                else if (!rtt.skipInitialClear) {
                    if (this.autoClear) {
                        this._engine.clear(rtt.clearColor || this.clearColor, !rtt._cleared, true, true);
                    }
                    rtt._cleared = true;
                }
            }
            else {
                if (!this._defaultFrameBufferCleared) {
                    this._defaultFrameBufferCleared = true;
                    this._clear();
                }
                else {
                    this._engine.clear(null, false, true, true);
                }
            }
        }
        /**
         * @internal
         */
        _renderForCamera(camera, rigParent, bindFrameBuffer = true) {
            var _a, _b, _c;
            if (camera && camera._skipRendering) {
                return;
            }
            const engine = this._engine;
            // Use _activeCamera instead of activeCamera to avoid onActiveCameraChanged
            this._activeCamera = camera;
            if (!this.activeCamera) {
                throw new Error("Active camera not set");
            }
            // Viewport
            engine.setViewport(this.activeCamera.viewport);
            // Camera
            this.resetCachedMaterial();
            this._renderId++;
            if (!this.prePass && bindFrameBuffer) {
                let skipInitialClear = true;
                if (camera._renderingMultiview && camera.outputRenderTarget) {
                    skipInitialClear = camera.outputRenderTarget.skipInitialClear;
                    if (this.autoClear) {
                        this._defaultFrameBufferCleared = false;
                        camera.outputRenderTarget.skipInitialClear = false;
                    }
                }
                this._bindFrameBuffer(this._activeCamera);
                if (camera._renderingMultiview && camera.outputRenderTarget) {
                    camera.outputRenderTarget.skipInitialClear = skipInitialClear;
                }
            }
            this.updateTransformMatrix();
            this.onBeforeCameraRenderObservable.notifyObservers(this.activeCamera);
            // Meshes
            this._evaluateActiveMeshes();
            // Software skinning
            for (let softwareSkinnedMeshIndex = 0; softwareSkinnedMeshIndex < this._softwareSkinnedMeshes.length; softwareSkinnedMeshIndex++) {
                const mesh = this._softwareSkinnedMeshes.data[softwareSkinnedMeshIndex];
                mesh.applySkeleton(mesh.skeleton);
            }
            // Render targets
            this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
            this._renderTargets.concatWithNoDuplicate(this._materialsRenderTargets);
            if (camera.customRenderTargets && camera.customRenderTargets.length > 0) {
                this._renderTargets.concatWithNoDuplicate(camera.customRenderTargets);
            }
            if (rigParent && rigParent.customRenderTargets && rigParent.customRenderTargets.length > 0) {
                this._renderTargets.concatWithNoDuplicate(rigParent.customRenderTargets);
            }
            if (this.environmentTexture && this.environmentTexture.isRenderTarget) {
                this._renderTargets.pushNoDuplicate(this.environmentTexture);
            }
            // Collects render targets from external components.
            for (const step of this._gatherActiveCameraRenderTargetsStage) {
                step.action(this._renderTargets);
            }
            let needRebind = false;
            if (this.renderTargetsEnabled) {
                this._intermediateRendering = true;
                if (this._renderTargets.length > 0) {
                    Tools.StartPerformanceCounter("Render targets", this._renderTargets.length > 0);
                    for (let renderIndex = 0; renderIndex < this._renderTargets.length; renderIndex++) {
                        const renderTarget = this._renderTargets.data[renderIndex];
                        if (renderTarget._shouldRender()) {
                            this._renderId++;
                            const hasSpecialRenderTargetCamera = renderTarget.activeCamera && renderTarget.activeCamera !== this.activeCamera;
                            renderTarget.render(hasSpecialRenderTargetCamera, this.dumpNextRenderTargets);
                            needRebind = true;
                        }
                    }
                    Tools.EndPerformanceCounter("Render targets", this._renderTargets.length > 0);
                    this._renderId++;
                }
                for (const step of this._cameraDrawRenderTargetStage) {
                    needRebind = step.action(this.activeCamera) || needRebind;
                }
                this._intermediateRendering = false;
            }
            this._engine.currentRenderPassId = (_c = (_b = (_a = camera.outputRenderTarget) === null || _a === void 0 ? void 0 : _a.renderPassId) !== null && _b !== void 0 ? _b : camera.renderPassId) !== null && _c !== void 0 ? _c : 0;
            // Restore framebuffer after rendering to targets
            if (needRebind && !this.prePass) {
                this._bindFrameBuffer(this._activeCamera, false);
            }
            this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
            // Prepare Frame
            if (this.postProcessManager && !camera._multiviewTexture && !this.prePass) {
                this.postProcessManager._prepareFrame();
            }
            // Before Camera Draw
            for (const step of this._beforeCameraDrawStage) {
                step.action(this.activeCamera);
            }
            // Render
            this.onBeforeDrawPhaseObservable.notifyObservers(this);
            if (engine.snapshotRendering && engine.snapshotRenderingMode === 1) {
                this.finalizeSceneUbo();
            }
            this._renderingManager.render(null, null, true, true);
            this.onAfterDrawPhaseObservable.notifyObservers(this);
            // After Camera Draw
            for (const step of this._afterCameraDrawStage) {
                step.action(this.activeCamera);
            }
            // Finalize frame
            if (this.postProcessManager && !camera._multiviewTexture) {
                // if the camera has an output render target, render the post process to the render target
                const texture = camera.outputRenderTarget ? camera.outputRenderTarget.renderTarget : undefined;
                this.postProcessManager._finalizeFrame(camera.isIntermediate, texture);
            }
            // After post process
            for (const step of this._afterCameraPostProcessStage) {
                step.action(this.activeCamera);
            }
            // Reset some special arrays
            this._renderTargets.reset();
            this.onAfterCameraRenderObservable.notifyObservers(this.activeCamera);
        }
        _processSubCameras(camera, bindFrameBuffer = true) {
            if (camera.cameraRigMode === 0 || camera._renderingMultiview) {
                if (camera._renderingMultiview && !this._multiviewSceneUbo) {
                    this._createMultiviewUbo();
                }
                this._renderForCamera(camera, undefined, bindFrameBuffer);
                this.onAfterRenderCameraObservable.notifyObservers(camera);
                return;
            }
            if (camera._useMultiviewToSingleView) {
                this._renderMultiviewToSingleView(camera);
            }
            else {
                // rig cameras
                this.onBeforeCameraRenderObservable.notifyObservers(camera);
                for (let index = 0; index < camera._rigCameras.length; index++) {
                    this._renderForCamera(camera._rigCameras[index], camera);
                }
            }
            // Use _activeCamera instead of activeCamera to avoid onActiveCameraChanged
            this._activeCamera = camera;
            this.updateTransformMatrix();
            this.onAfterRenderCameraObservable.notifyObservers(camera);
        }
        _checkIntersections() {
            for (let index = 0; index < this._meshesForIntersections.length; index++) {
                const sourceMesh = this._meshesForIntersections.data[index];
                if (!sourceMesh.actionManager) {
                    continue;
                }
                for (let actionIndex = 0; sourceMesh.actionManager && actionIndex < sourceMesh.actionManager.actions.length; actionIndex++) {
                    const action = sourceMesh.actionManager.actions[actionIndex];
                    if (action.trigger === 12 || action.trigger === 13) {
                        const parameters = action.getTriggerParameter();
                        const otherMesh = parameters.mesh ? parameters.mesh : parameters;
                        const areIntersecting = otherMesh.intersectsMesh(sourceMesh, parameters.usePreciseIntersection);
                        const currentIntersectionInProgress = sourceMesh._intersectionsInProgress.indexOf(otherMesh);
                        if (areIntersecting && currentIntersectionInProgress === -1) {
                            if (action.trigger === 12) {
                                action._executeCurrent(ActionEvent.CreateNew(sourceMesh, undefined, otherMesh));
                                sourceMesh._intersectionsInProgress.push(otherMesh);
                            }
                            else if (action.trigger === 13) {
                                sourceMesh._intersectionsInProgress.push(otherMesh);
                            }
                        }
                        else if (!areIntersecting && currentIntersectionInProgress > -1) {
                            //They intersected, and now they don't.
                            //is this trigger an exit trigger? execute an event.
                            if (action.trigger === 13) {
                                action._executeCurrent(ActionEvent.CreateNew(sourceMesh, undefined, otherMesh));
                            }
                            //if this is an exit trigger, or no exit trigger exists, remove the id from the intersection in progress array.
                            if (!sourceMesh.actionManager.hasSpecificTrigger(13, (parameter) => {
                                const parameterMesh = parameter.mesh ? parameter.mesh : parameter;
                                return otherMesh === parameterMesh;
                            }) ||
                                action.trigger === 13) {
                                sourceMesh._intersectionsInProgress.splice(currentIntersectionInProgress, 1);
                            }
                        }
                    }
                }
            }
        }
        /**
         * @internal
         */
        _advancePhysicsEngineStep(step) {
            // Do nothing. Code will be replaced if physics engine component is referenced
        }
        /** @internal */
        _animate() {
            // Nothing to do as long as Animatable have not been imported.
        }
        /** Execute all animations (for a frame) */
        animate() {
            if (this._engine.isDeterministicLockStep()) {
                let deltaTime = Math.max(Scene.MinDeltaTime, Math.min(this._engine.getDeltaTime(), Scene.MaxDeltaTime)) + this._timeAccumulator;
                const defaultFrameTime = this._engine.getTimeStep();
                const defaultFPS = 1000.0 / defaultFrameTime / 1000.0;
                let stepsTaken = 0;
                const maxSubSteps = this._engine.getLockstepMaxSteps();
                let internalSteps = Math.floor(deltaTime / defaultFrameTime);
                internalSteps = Math.min(internalSteps, maxSubSteps);
                while (deltaTime > 0 && stepsTaken < internalSteps) {
                    this.onBeforeStepObservable.notifyObservers(this);
                    // Animations
                    this._animationRatio = defaultFrameTime * defaultFPS;
                    this._animate();
                    this.onAfterAnimationsObservable.notifyObservers(this);
                    // Physics
                    if (this.physicsEnabled) {
                        this._advancePhysicsEngineStep(defaultFrameTime);
                    }
                    this.onAfterStepObservable.notifyObservers(this);
                    this._currentStepId++;
                    stepsTaken++;
                    deltaTime -= defaultFrameTime;
                }
                this._timeAccumulator = deltaTime < 0 ? 0 : deltaTime;
            }
            else {
                // Animations
                const deltaTime = this.useConstantAnimationDeltaTime ? 16 : Math.max(Scene.MinDeltaTime, Math.min(this._engine.getDeltaTime(), Scene.MaxDeltaTime));
                this._animationRatio = deltaTime * (60.0 / 1000.0);
                this._animate();
                this.onAfterAnimationsObservable.notifyObservers(this);
                // Physics
                if (this.physicsEnabled) {
                    this._advancePhysicsEngineStep(deltaTime);
                }
            }
        }
        _clear() {
            if (this.autoClearDepthAndStencil || this.autoClear) {
                this._engine.clear(this.clearColor, this.autoClear || this.forceWireframe || this.forcePointsCloud, this.autoClearDepthAndStencil, this.autoClearDepthAndStencil);
            }
        }
        _checkCameraRenderTarget(camera) {
            var _a;
            if ((camera === null || camera === void 0 ? void 0 : camera.outputRenderTarget) && !(camera === null || camera === void 0 ? void 0 : camera.isRigCamera)) {
                camera.outputRenderTarget._cleared = false;
            }
            if ((_a = camera === null || camera === void 0 ? void 0 : camera.rigCameras) === null || _a === void 0 ? void 0 : _a.length) {
                for (let i = 0; i < camera.rigCameras.length; ++i) {
                    const rtt = camera.rigCameras[i].outputRenderTarget;
                    if (rtt) {
                        rtt._cleared = false;
                    }
                }
            }
        }
        /**
         * Resets the draw wrappers cache of all meshes
         * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
         */
        resetDrawCache(passId) {
            if (!this.meshes) {
                return;
            }
            for (const mesh of this.meshes) {
                mesh.resetDrawCache(passId);
            }
        }
        /**
         * Render the scene
         * @param updateCameras defines a boolean indicating if cameras must update according to their inputs (true by default)
         * @param ignoreAnimations defines a boolean indicating if animations should not be executed (false by default)
         */
        render(updateCameras = true, ignoreAnimations = false) {
            var _a, _b, _c;
            if (this.isDisposed) {
                return;
            }
            if (this.onReadyObservable.hasObservers() && this._executeWhenReadyTimeoutId === null) {
                this._checkIsReady();
            }
            this._frameId++;
            this._defaultFrameBufferCleared = false;
            this._checkCameraRenderTarget(this.activeCamera);
            if ((_a = this.activeCameras) === null || _a === void 0 ? void 0 : _a.length) {
                this.activeCameras.forEach(this._checkCameraRenderTarget);
            }
            // Register components that have been associated lately to the scene.
            this._registerTransientComponents();
            this._activeParticles.fetchNewFrame();
            this._totalVertices.fetchNewFrame();
            this._activeIndices.fetchNewFrame();
            this._activeBones.fetchNewFrame();
            this._meshesForIntersections.reset();
            this.resetCachedMaterial();
            this.onBeforeAnimationsObservable.notifyObservers(this);
            // Actions
            if (this.actionManager) {
                this.actionManager.processTrigger(11);
            }
            // Animations
            if (!ignoreAnimations) {
                this.animate();
            }
            // Before camera update steps
            for (const step of this._beforeCameraUpdateStage) {
                step.action();
            }
            // Update Cameras
            if (updateCameras) {
                if (this.activeCameras && this.activeCameras.length > 0) {
                    for (let cameraIndex = 0; cameraIndex < this.activeCameras.length; cameraIndex++) {
                        const camera = this.activeCameras[cameraIndex];
                        camera.update();
                        if (camera.cameraRigMode !== 0) {
                            // rig cameras
                            for (let index = 0; index < camera._rigCameras.length; index++) {
                                camera._rigCameras[index].update();
                            }
                        }
                    }
                }
                else if (this.activeCamera) {
                    this.activeCamera.update();
                    if (this.activeCamera.cameraRigMode !== 0) {
                        // rig cameras
                        for (let index = 0; index < this.activeCamera._rigCameras.length; index++) {
                            this.activeCamera._rigCameras[index].update();
                        }
                    }
                }
            }
            // Before render
            this.onBeforeRenderObservable.notifyObservers(this);
            const engine = this.getEngine();
            // Customs render targets
            this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
            const currentActiveCamera = ((_b = this.activeCameras) === null || _b === void 0 ? void 0 : _b.length) ? this.activeCameras[0] : this.activeCamera;
            if (this.renderTargetsEnabled) {
                Tools.StartPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0);
                this._intermediateRendering = true;
                for (let customIndex = 0; customIndex < this.customRenderTargets.length; customIndex++) {
                    const renderTarget = this.customRenderTargets[customIndex];
                    if (renderTarget._shouldRender()) {
                        this._renderId++;
                        this.activeCamera = renderTarget.activeCamera || this.activeCamera;
                        if (!this.activeCamera) {
                            throw new Error("Active camera not set");
                        }
                        // Viewport
                        engine.setViewport(this.activeCamera.viewport);
                        // Camera
                        this.updateTransformMatrix();
                        renderTarget.render(currentActiveCamera !== this.activeCamera, this.dumpNextRenderTargets);
                    }
                }
                Tools.EndPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0);
                this._intermediateRendering = false;
                this._renderId++;
            }
            this._engine.currentRenderPassId = (_c = currentActiveCamera === null || currentActiveCamera === void 0 ? void 0 : currentActiveCamera.renderPassId) !== null && _c !== void 0 ? _c : 0;
            // Restore back buffer
            this.activeCamera = currentActiveCamera;
            if (this._activeCamera && this._activeCamera.cameraRigMode !== 22 && !this.prePass) {
                this._bindFrameBuffer(this._activeCamera, false);
            }
            this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
            for (const step of this._beforeClearStage) {
                step.action();
            }
            // Clear
            this._clearFrameBuffer(this.activeCamera);
            // Collects render targets from external components.
            for (const step of this._gatherRenderTargetsStage) {
                step.action(this._renderTargets);
            }
            // Multi-cameras?
            if (this.activeCameras && this.activeCameras.length > 0) {
                for (let cameraIndex = 0; cameraIndex < this.activeCameras.length; cameraIndex++) {
                    this._processSubCameras(this.activeCameras[cameraIndex], cameraIndex > 0);
                }
            }
            else {
                if (!this.activeCamera) {
                    throw new Error("No camera defined");
                }
                this._processSubCameras(this.activeCamera, !!this.activeCamera.outputRenderTarget);
            }
            // Intersection checks
            this._checkIntersections();
            // Executes the after render stage actions.
            for (const step of this._afterRenderStage) {
                step.action();
            }
            // After render
            if (this.afterRender) {
                this.afterRender();
            }
            this.onAfterRenderObservable.notifyObservers(this);
            // Cleaning
            if (this._toBeDisposed.length) {
                for (let index = 0; index < this._toBeDisposed.length; index++) {
                    const data = this._toBeDisposed[index];
                    if (data) {
                        data.dispose();
                    }
                }
                this._toBeDisposed.length = 0;
            }
            if (this.dumpNextRenderTargets) {
                this.dumpNextRenderTargets = false;
            }
            this._activeBones.addCount(0, true);
            this._activeIndices.addCount(0, true);
            this._activeParticles.addCount(0, true);
            this._engine.restoreDefaultFramebuffer();
        }
        /**
         * Freeze all materials
         * A frozen material will not be updatable but should be faster to render
         * Note: multimaterials will not be frozen, but their submaterials will
         */
        freezeMaterials() {
            for (let i = 0; i < this.materials.length; i++) {
                this.materials[i].freeze();
            }
        }
        /**
         * Unfreeze all materials
         * A frozen material will not be updatable but should be faster to render
         */
        unfreezeMaterials() {
            for (let i = 0; i < this.materials.length; i++) {
                this.materials[i].unfreeze();
            }
        }
        /**
         * Releases all held resources
         */
        dispose() {
            if (this.isDisposed) {
                return;
            }
            this.beforeRender = null;
            this.afterRender = null;
            this.metadata = null;
            this.skeletons.length = 0;
            this.morphTargetManagers.length = 0;
            this._transientComponents.length = 0;
            this._isReadyForMeshStage.clear();
            this._beforeEvaluateActiveMeshStage.clear();
            this._evaluateSubMeshStage.clear();
            this._preActiveMeshStage.clear();
            this._cameraDrawRenderTargetStage.clear();
            this._beforeCameraDrawStage.clear();
            this._beforeRenderTargetDrawStage.clear();
            this._beforeRenderingGroupDrawStage.clear();
            this._beforeRenderingMeshStage.clear();
            this._afterRenderingMeshStage.clear();
            this._afterRenderingGroupDrawStage.clear();
            this._afterCameraDrawStage.clear();
            this._afterRenderTargetDrawStage.clear();
            this._afterRenderStage.clear();
            this._beforeCameraUpdateStage.clear();
            this._beforeClearStage.clear();
            this._gatherRenderTargetsStage.clear();
            this._gatherActiveCameraRenderTargetsStage.clear();
            this._pointerMoveStage.clear();
            this._pointerDownStage.clear();
            this._pointerUpStage.clear();
            this.importedMeshesFiles = new Array();
            if (this.stopAllAnimations) {
                // Ensures that no animatable notifies a callback that could start a new animation group, constantly adding new animatables to the active list...
                this._activeAnimatables.forEach((animatable) => {
                    animatable.onAnimationEndObservable.clear();
                    animatable.onAnimationEnd = null;
                });
                this.stopAllAnimations();
            }
            this.resetCachedMaterial();
            // Smart arrays
            if (this.activeCamera) {
                this.activeCamera._activeMeshes.dispose();
                this.activeCamera = null;
            }
            this.activeCameras = null;
            this._activeMeshes.dispose();
            this._renderingManager.dispose();
            this._processedMaterials.dispose();
            this._activeParticleSystems.dispose();
            this._activeSkeletons.dispose();
            this._softwareSkinnedMeshes.dispose();
            this._renderTargets.dispose();
            this._materialsRenderTargets.dispose();
            this._registeredForLateAnimationBindings.dispose();
            this._meshesForIntersections.dispose();
            this._toBeDisposed.length = 0;
            // Abort active requests
            const activeRequests = this._activeRequests.slice();
            for (const request of activeRequests) {
                request.abort();
            }
            this._activeRequests.length = 0;
            // Events
            try {
                this.onDisposeObservable.notifyObservers(this);
            }
            catch (e) {
                console.error("An error occurred while calling onDisposeObservable!", e);
            }
            this.detachControl();
            // Detach cameras
            const canvas = this._engine.getInputElement();
            if (canvas) {
                for (let index = 0; index < this.cameras.length; index++) {
                    this.cameras[index].detachControl();
                }
            }
            // Release animation groups
            this._disposeList(this.animationGroups);
            // Release lights
            this._disposeList(this.lights);
            // Release meshes
            this._disposeList(this.meshes, (item) => item.dispose(true));
            this._disposeList(this.transformNodes, (item) => item.dispose(true));
            // Release cameras
            const cameras = this.cameras;
            this._disposeList(cameras);
            // Release materials
            if (this._defaultMaterial) {
                this._defaultMaterial.dispose();
            }
            this._disposeList(this.multiMaterials);
            this._disposeList(this.materials);
            // Release particles
            this._disposeList(this.particleSystems);
            // Release postProcesses
            this._disposeList(this.postProcesses);
            // Release textures
            this._disposeList(this.textures);
            // Release morph targets
            this._disposeList(this.morphTargetManagers);
            // Release UBO
            this._sceneUbo.dispose();
            if (this._multiviewSceneUbo) {
                this._multiviewSceneUbo.dispose();
            }
            // Post-processes
            this.postProcessManager.dispose();
            // Components
            this._disposeList(this._components);
            // Remove from engine
            let index = this._engine.scenes.indexOf(this);
            if (index > -1) {
                this._engine.scenes.splice(index, 1);
            }
            if (EngineStore._LastCreatedScene === this) {
                if (this._engine.scenes.length > 0) {
                    EngineStore._LastCreatedScene = this._engine.scenes[this._engine.scenes.length - 1];
                }
                else {
                    EngineStore._LastCreatedScene = null;
                }
            }
            index = this._engine._virtualScenes.indexOf(this);
            if (index > -1) {
                this._engine._virtualScenes.splice(index, 1);
            }
            this._engine.wipeCaches(true);
            this.onDisposeObservable.clear();
            this.onBeforeRenderObservable.clear();
            this.onAfterRenderObservable.clear();
            this.onBeforeRenderTargetsRenderObservable.clear();
            this.onAfterRenderTargetsRenderObservable.clear();
            this.onAfterStepObservable.clear();
            this.onBeforeStepObservable.clear();
            this.onBeforeActiveMeshesEvaluationObservable.clear();
            this.onAfterActiveMeshesEvaluationObservable.clear();
            this.onBeforeParticlesRenderingObservable.clear();
            this.onAfterParticlesRenderingObservable.clear();
            this.onBeforeDrawPhaseObservable.clear();
            this.onAfterDrawPhaseObservable.clear();
            this.onBeforeAnimationsObservable.clear();
            this.onAfterAnimationsObservable.clear();
            this.onDataLoadedObservable.clear();
            this.onBeforeRenderingGroupObservable.clear();
            this.onAfterRenderingGroupObservable.clear();
            this.onMeshImportedObservable.clear();
            this.onBeforeCameraRenderObservable.clear();
            this.onAfterCameraRenderObservable.clear();
            this.onAfterRenderCameraObservable.clear();
            this.onReadyObservable.clear();
            this.onNewCameraAddedObservable.clear();
            this.onCameraRemovedObservable.clear();
            this.onNewLightAddedObservable.clear();
            this.onLightRemovedObservable.clear();
            this.onNewGeometryAddedObservable.clear();
            this.onGeometryRemovedObservable.clear();
            this.onNewTransformNodeAddedObservable.clear();
            this.onTransformNodeRemovedObservable.clear();
            this.onNewMeshAddedObservable.clear();
            this.onMeshRemovedObservable.clear();
            this.onNewSkeletonAddedObservable.clear();
            this.onSkeletonRemovedObservable.clear();
            this.onNewMaterialAddedObservable.clear();
            this.onNewMultiMaterialAddedObservable.clear();
            this.onMaterialRemovedObservable.clear();
            this.onMultiMaterialRemovedObservable.clear();
            this.onNewTextureAddedObservable.clear();
            this.onTextureRemovedObservable.clear();
            this.onPrePointerObservable.clear();
            this.onPointerObservable.clear();
            this.onPreKeyboardObservable.clear();
            this.onKeyboardObservable.clear();
            this.onActiveCameraChanged.clear();
            this.onScenePerformancePriorityChangedObservable.clear();
            this._isDisposed = true;
        }
        _disposeList(items, callback) {
            const itemsCopy = items.slice(0);
            callback = callback !== null && callback !== void 0 ? callback : ((item) => item.dispose());
            for (const item of itemsCopy) {
                callback(item);
            }
            items.length = 0;
        }
        /**
         * Gets if the scene is already disposed
         */
        get isDisposed() {
            return this._isDisposed;
        }
        /**
         * Call this function to reduce memory footprint of the scene.
         * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
         */
        clearCachedVertexData() {
            for (let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++) {
                const mesh = this.meshes[meshIndex];
                const geometry = mesh.geometry;
                if (geometry) {
                    geometry.clearCachedData();
                }
            }
        }
        /**
         * This function will remove the local cached buffer data from texture.
         * It will save memory but will prevent the texture from being rebuilt
         */
        cleanCachedTextureBuffer() {
            for (const baseTexture of this.textures) {
                const buffer = baseTexture._buffer;
                if (buffer) {
                    baseTexture._buffer = null;
                }
            }
        }
        /**
         * Get the world extend vectors with an optional filter
         *
         * @param filterPredicate the predicate - which meshes should be included when calculating the world size
         * @returns {{ min: Vector3; max: Vector3 }} min and max vectors
         */
        getWorldExtends(filterPredicate) {
            const min = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            const max = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
            filterPredicate = filterPredicate || (() => true);
            this.meshes.filter(filterPredicate).forEach((mesh) => {
                mesh.computeWorldMatrix(true);
                if (!mesh.subMeshes || mesh.subMeshes.length === 0 || mesh.infiniteDistance) {
                    return;
                }
                const boundingInfo = mesh.getBoundingInfo();
                const minBox = boundingInfo.boundingBox.minimumWorld;
                const maxBox = boundingInfo.boundingBox.maximumWorld;
                Vector3.CheckExtends(minBox, min, max);
                Vector3.CheckExtends(maxBox, min, max);
            });
            return {
                min: min,
                max: max,
            };
        }
        // Picking
        /**
         * Creates a ray that can be used to pick in the scene
         * @param x defines the x coordinate of the origin (on-screen)
         * @param y defines the y coordinate of the origin (on-screen)
         * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
         * @param camera defines the camera to use for the picking
         * @param cameraViewSpace defines if picking will be done in view space (false by default)
         * @returns a Ray
         */
        createPickingRay(x, y, world, camera, cameraViewSpace = false) {
            throw _WarnImport("Ray");
        }
        /**
         * Creates a ray that can be used to pick in the scene
         * @param x defines the x coordinate of the origin (on-screen)
         * @param y defines the y coordinate of the origin (on-screen)
         * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
         * @param result defines the ray where to store the picking ray
         * @param camera defines the camera to use for the picking
         * @param cameraViewSpace defines if picking will be done in view space (false by default)
         * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
         * @returns the current scene
         */
        createPickingRayToRef(x, y, world, result, camera, cameraViewSpace = false, enableDistantPicking = false) {
            throw _WarnImport("Ray");
        }
        /**
         * Creates a ray that can be used to pick in the scene
         * @param x defines the x coordinate of the origin (on-screen)
         * @param y defines the y coordinate of the origin (on-screen)
         * @param camera defines the camera to use for the picking
         * @returns a Ray
         */
        createPickingRayInCameraSpace(x, y, camera) {
            throw _WarnImport("Ray");
        }
        /**
         * Creates a ray that can be used to pick in the scene
         * @param x defines the x coordinate of the origin (on-screen)
         * @param y defines the y coordinate of the origin (on-screen)
         * @param result defines the ray where to store the picking ray
         * @param camera defines the camera to use for the picking
         * @returns the current scene
         */
        createPickingRayInCameraSpaceToRef(x, y, result, camera) {
            throw _WarnImport("Ray");
        }
        /** @internal */
        get _pickingAvailable() {
            return false;
        }
        /** Launch a ray to try to pick a mesh in the scene
         * @param x position on screen
         * @param y position on screen
         * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
         * @param fastCheck defines if the first intersection will be used (and not the closest)
         * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @returns a PickingInfo
         */
        pick(x, y, predicate, fastCheck, camera, trianglePredicate) {
            // Dummy info if picking as not been imported
            return new PickingInfo();
        }
        /** Launch a ray to try to pick a mesh in the scene using only bounding information of the main mesh (not using submeshes)
         * @param x position on screen
         * @param y position on screen
         * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
         * @param fastCheck defines if the first intersection will be used (and not the closest)
         * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
         * @returns a PickingInfo (Please note that some info will not be set like distance, bv, bu and everything that cannot be capture by only using bounding infos)
         */
        pickWithBoundingInfo(x, y, predicate, fastCheck, camera) {
            // Dummy info if picking as not been imported
            return new PickingInfo();
        }
        /**
         * Use the given ray to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
         * irrespective of orientation.
         * @param ray The ray to use to pick meshes
         * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must have isPickable set to true
         * @param fastCheck defines if the first intersection will be used (and not the closest)
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @returns a PickingInfo
         */
        pickWithRay(ray, predicate, fastCheck, trianglePredicate) {
            throw _WarnImport("Ray");
        }
        /**
         * Launch a ray to try to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
         * irrespective of orientation.
         * @param x X position on screen
         * @param y Y position on screen
         * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
         * @param camera camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @returns an array of PickingInfo
         */
        multiPick(x, y, predicate, camera, trianglePredicate) {
            throw _WarnImport("Ray");
        }
        /**
         * Launch a ray to try to pick a mesh in the scene
         * @param ray Ray to use
         * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @returns an array of PickingInfo
         */
        multiPickWithRay(ray, predicate, trianglePredicate) {
            throw _WarnImport("Ray");
        }
        /**
         * Force the value of meshUnderPointer
         * @param mesh defines the mesh to use
         * @param pointerId optional pointer id when using more than one pointer
         * @param pickResult optional pickingInfo data used to find mesh
         */
        setPointerOverMesh(mesh, pointerId, pickResult) {
            this._inputManager.setPointerOverMesh(mesh, pointerId, pickResult);
        }
        /**
         * Gets the mesh under the pointer
         * @returns a Mesh or null if no mesh is under the pointer
         */
        getPointerOverMesh() {
            return this._inputManager.getPointerOverMesh();
        }
        // Misc.
        /** @internal */
        _rebuildGeometries() {
            for (const geometry of this.geometries) {
                geometry._rebuild();
            }
            for (const mesh of this.meshes) {
                mesh._rebuild();
            }
            if (this.postProcessManager) {
                this.postProcessManager._rebuild();
            }
            for (const component of this._components) {
                component.rebuild();
            }
            for (const system of this.particleSystems) {
                system.rebuild();
            }
            if (this.spriteManagers) {
                for (const spriteMgr of this.spriteManagers) {
                    spriteMgr.rebuild();
                }
            }
        }
        /** @internal */
        _rebuildTextures() {
            for (const texture of this.textures) {
                texture._rebuild();
            }
            this.markAllMaterialsAsDirty(1);
        }
        // Tags
        _getByTags(list, tagsQuery, forEach) {
            if (tagsQuery === undefined) {
                // returns the complete list (could be done with Tags.MatchesQuery but no need to have a for-loop here)
                return list;
            }
            const listByTags = [];
            forEach =
                forEach ||
                    ((item) => {
                        return;
                    });
            for (const i in list) {
                const item = list[i];
                if (Tags && Tags.MatchesQuery(item, tagsQuery)) {
                    listByTags.push(item);
                    forEach(item);
                }
            }
            return listByTags;
        }
        /**
         * Get a list of meshes by tags
         * @param tagsQuery defines the tags query to use
         * @param forEach defines a predicate used to filter results
         * @returns an array of Mesh
         */
        getMeshesByTags(tagsQuery, forEach) {
            return this._getByTags(this.meshes, tagsQuery, forEach);
        }
        /**
         * Get a list of cameras by tags
         * @param tagsQuery defines the tags query to use
         * @param forEach defines a predicate used to filter results
         * @returns an array of Camera
         */
        getCamerasByTags(tagsQuery, forEach) {
            return this._getByTags(this.cameras, tagsQuery, forEach);
        }
        /**
         * Get a list of lights by tags
         * @param tagsQuery defines the tags query to use
         * @param forEach defines a predicate used to filter results
         * @returns an array of Light
         */
        getLightsByTags(tagsQuery, forEach) {
            return this._getByTags(this.lights, tagsQuery, forEach);
        }
        /**
         * Get a list of materials by tags
         * @param tagsQuery defines the tags query to use
         * @param forEach defines a predicate used to filter results
         * @returns an array of Material
         */
        getMaterialByTags(tagsQuery, forEach) {
            return this._getByTags(this.materials, tagsQuery, forEach).concat(this._getByTags(this.multiMaterials, tagsQuery, forEach));
        }
        /**
         * Get a list of transform nodes by tags
         * @param tagsQuery defines the tags query to use
         * @param forEach defines a predicate used to filter results
         * @returns an array of TransformNode
         */
        getTransformNodesByTags(tagsQuery, forEach) {
            return this._getByTags(this.transformNodes, tagsQuery, forEach);
        }
        /**
         * Overrides the default sort function applied in the rendering group to prepare the meshes.
         * This allowed control for front to back rendering or reversly depending of the special needs.
         *
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
         * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
         * @param transparentSortCompareFn The transparent queue comparison function use to sort.
         */
        setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
            this._renderingManager.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
        }
        /**
         * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
         *
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
         * @param depth Automatically clears depth between groups if true and autoClear is true.
         * @param stencil Automatically clears stencil between groups if true and autoClear is true.
         */
        setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
            this._renderingManager.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth, stencil);
        }
        /**
         * Gets the current auto clear configuration for one rendering group of the rendering
         * manager.
         * @param index the rendering group index to get the information for
         * @returns The auto clear setup for the requested rendering group
         */
        getAutoClearDepthStencilSetup(index) {
            return this._renderingManager.getAutoClearDepthStencilSetup(index);
        }
        /** Gets or sets a boolean blocking all the calls to markAllMaterialsAsDirty (ie. the materials won't be updated if they are out of sync) */
        get blockMaterialDirtyMechanism() {
            return this._blockMaterialDirtyMechanism;
        }
        set blockMaterialDirtyMechanism(value) {
            if (this._blockMaterialDirtyMechanism === value) {
                return;
            }
            this._blockMaterialDirtyMechanism = value;
            if (!value) {
                // Do a complete update
                this.markAllMaterialsAsDirty(63);
            }
        }
        /**
         * Will flag all materials as dirty to trigger new shader compilation
         * @param flag defines the flag used to specify which material part must be marked as dirty
         * @param predicate If not null, it will be used to specify if a material has to be marked as dirty
         */
        markAllMaterialsAsDirty(flag, predicate) {
            if (this._blockMaterialDirtyMechanism) {
                return;
            }
            for (const material of this.materials) {
                if (predicate && !predicate(material)) {
                    continue;
                }
                material.markAsDirty(flag);
            }
        }
        /**
         * @internal
         */
        _loadFile(fileOrUrl, onSuccess, onProgress, useOfflineSupport, useArrayBuffer, onError, onOpened) {
            const request = LoadFile(fileOrUrl, onSuccess, onProgress, useOfflineSupport ? this.offlineProvider : undefined, useArrayBuffer, onError, onOpened);
            this._activeRequests.push(request);
            request.onCompleteObservable.add((request) => {
                this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
            });
            return request;
        }
        /**
         * @internal
         */
        _loadFileAsync(fileOrUrl, onProgress, useOfflineSupport, useArrayBuffer, onOpened) {
            return new Promise((resolve, reject) => {
                this._loadFile(fileOrUrl, (data) => {
                    resolve(data);
                }, onProgress, useOfflineSupport, useArrayBuffer, (request, exception) => {
                    reject(exception);
                }, onOpened);
            });
        }
        /**
         * @internal
         */
        _requestFile(url, onSuccess, onProgress, useOfflineSupport, useArrayBuffer, onError, onOpened) {
            const request = RequestFile(url, onSuccess, onProgress, useOfflineSupport ? this.offlineProvider : undefined, useArrayBuffer, onError, onOpened);
            this._activeRequests.push(request);
            request.onCompleteObservable.add((request) => {
                this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
            });
            return request;
        }
        /**
         * @internal
         */
        _requestFileAsync(url, onProgress, useOfflineSupport, useArrayBuffer, onOpened) {
            return new Promise((resolve, reject) => {
                this._requestFile(url, (data) => {
                    resolve(data);
                }, onProgress, useOfflineSupport, useArrayBuffer, (error) => {
                    reject(error);
                }, onOpened);
            });
        }
        /**
         * @internal
         */
        _readFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
            const request = ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError);
            this._activeRequests.push(request);
            request.onCompleteObservable.add((request) => {
                this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
            });
            return request;
        }
        /**
         * @internal
         */
        _readFileAsync(file, onProgress, useArrayBuffer) {
            return new Promise((resolve, reject) => {
                this._readFile(file, (data) => {
                    resolve(data);
                }, onProgress, useArrayBuffer, (error) => {
                    reject(error);
                });
            });
        }
        /**
         * This method gets the performance collector belonging to the scene, which is generally shared with the inspector.
         * @returns the perf collector belonging to the scene.
         */
        getPerfCollector() {
            throw _WarnImport("performanceViewerSceneExtension");
        }
        // deprecated
        /**
         * Sets the active camera of the scene using its Id
         * @param id defines the camera's Id
         * @returns the new active camera or null if none found.
         * @deprecated Please use setActiveCameraById instead
         */
        setActiveCameraByID(id) {
            return this.setActiveCameraById(id);
        }
        /**
         * Get a material using its id
         * @param id defines the material's Id
         * @returns the material or null if none found.
         * @deprecated Please use getMaterialById instead
         */
        getMaterialByID(id) {
            return this.getMaterialById(id);
        }
        /**
         * Gets a the last added material using a given id
         * @param id defines the material's Id
         * @returns the last material with the given id or null if none found.
         * @deprecated Please use getLastMaterialById instead
         */
        getLastMaterialByID(id) {
            return this.getLastMaterialById(id);
        }
        /**
         * Get a texture using its unique id
         * @param uniqueId defines the texture's unique id
         * @returns the texture or null if none found.
         * @deprecated Please use getTextureByUniqueId instead
         */
        getTextureByUniqueID(uniqueId) {
            return this.getTextureByUniqueId(uniqueId);
        }
        /**
         * Gets a camera using its Id
         * @param id defines the Id to look for
         * @returns the camera or null if not found
         * @deprecated Please use getCameraById instead
         */
        getCameraByID(id) {
            return this.getCameraById(id);
        }
        /**
         * Gets a camera using its unique Id
         * @param uniqueId defines the unique Id to look for
         * @returns the camera or null if not found
         * @deprecated Please use getCameraByUniqueId instead
         */
        getCameraByUniqueID(uniqueId) {
            return this.getCameraByUniqueId(uniqueId);
        }
        /**
         * Gets a bone using its Id
         * @param id defines the bone's Id
         * @returns the bone or null if not found
         * @deprecated Please use getBoneById instead
         */
        getBoneByID(id) {
            return this.getBoneById(id);
        }
        /**
         * Gets a light node using its Id
         * @param id defines the light's Id
         * @returns the light or null if none found.
         * @deprecated Please use getLightById instead
         */
        getLightByID(id) {
            return this.getLightById(id);
        }
        /**
         * Gets a light node using its scene-generated unique Id
         * @param uniqueId defines the light's unique Id
         * @returns the light or null if none found.
         * @deprecated Please use getLightByUniqueId instead
         */
        getLightByUniqueID(uniqueId) {
            return this.getLightByUniqueId(uniqueId);
        }
        /**
         * Gets a particle system by Id
         * @param id defines the particle system Id
         * @returns the corresponding system or null if none found
         * @deprecated Please use getParticleSystemById instead
         */
        getParticleSystemByID(id) {
            return this.getParticleSystemById(id);
        }
        /**
         * Gets a geometry using its Id
         * @param id defines the geometry's Id
         * @returns the geometry or null if none found.
         * @deprecated Please use getGeometryById instead
         */
        getGeometryByID(id) {
            return this.getGeometryById(id);
        }
        /**
         * Gets the first added mesh found of a given Id
         * @param id defines the Id to search for
         * @returns the mesh found or null if not found at all
         * @deprecated Please use getMeshById instead
         */
        getMeshByID(id) {
            return this.getMeshById(id);
        }
        /**
         * Gets a mesh with its auto-generated unique Id
         * @param uniqueId defines the unique Id to search for
         * @returns the found mesh or null if not found at all.
         * @deprecated Please use getMeshByUniqueId instead
         */
        getMeshByUniqueID(uniqueId) {
            return this.getMeshByUniqueId(uniqueId);
        }
        /**
         * Gets a the last added mesh using a given Id
         * @param id defines the Id to search for
         * @returns the found mesh or null if not found at all.
         * @deprecated Please use getLastMeshById instead
         */
        getLastMeshByID(id) {
            return this.getLastMeshById(id);
        }
        /**
         * Gets a list of meshes using their Id
         * @param id defines the Id to search for
         * @returns a list of meshes
         * @deprecated Please use getMeshesById instead
         */
        getMeshesByID(id) {
            return this.getMeshesById(id);
        }
        /**
         * Gets the first added transform node found of a given Id
         * @param id defines the Id to search for
         * @returns the found transform node or null if not found at all.
         * @deprecated Please use getTransformNodeById instead
         */
        getTransformNodeByID(id) {
            return this.getTransformNodeById(id);
        }
        /**
         * Gets a transform node with its auto-generated unique Id
         * @param uniqueId defines the unique Id to search for
         * @returns the found transform node or null if not found at all.
         * @deprecated Please use getTransformNodeByUniqueId instead
         */
        getTransformNodeByUniqueID(uniqueId) {
            return this.getTransformNodeByUniqueId(uniqueId);
        }
        /**
         * Gets a list of transform nodes using their Id
         * @param id defines the Id to search for
         * @returns a list of transform nodes
         * @deprecated Please use getTransformNodesById instead
         */
        getTransformNodesByID(id) {
            return this.getTransformNodesById(id);
        }
        /**
         * Gets a node (Mesh, Camera, Light) using a given Id
         * @param id defines the Id to search for
         * @returns the found node or null if not found at all
         * @deprecated Please use getNodeById instead
         */
        getNodeByID(id) {
            return this.getNodeById(id);
        }
        /**
         * Gets a the last added node (Mesh, Camera, Light) using a given Id
         * @param id defines the Id to search for
         * @returns the found node or null if not found at all
         * @deprecated Please use getLastEntryById instead
         */
        getLastEntryByID(id) {
            return this.getLastEntryById(id);
        }
        /**
         * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
         * @param id defines the Id to search for
         * @returns the found skeleton or null if not found at all.
         * @deprecated Please use getLastSkeletonById instead
         */
        getLastSkeletonByID(id) {
            return this.getLastSkeletonById(id);
        }
    }
    /** The fog is deactivated */
    Scene.FOGMODE_NONE = 0;
    /** The fog density is following an exponential function */
    Scene.FOGMODE_EXP = 1;
    /** The fog density is following an exponential function faster than FOGMODE_EXP */
    Scene.FOGMODE_EXP2 = 2;
    /** The fog density is following a linear function. */
    Scene.FOGMODE_LINEAR = 3;
    /**
     * Gets or sets the minimum deltatime when deterministic lock step is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     */
    Scene.MinDeltaTime = 1.0;
    /**
     * Gets or sets the maximum deltatime when deterministic lock step is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     */
    Scene.MaxDeltaTime = 1000.0;

    /**
     * @internal
     */
    class IntersectionInfo {
        constructor(bu, bv, distance) {
            this.bu = bu;
            this.bv = bv;
            this.distance = distance;
            this.faceId = 0;
            this.subMeshId = 0;
        }
    }

    /**
     * Class used to store bounding box information
     */
    class BoundingBox {
        /**
         * Creates a new bounding box
         * @param min defines the minimum vector (in local space)
         * @param max defines the maximum vector (in local space)
         * @param worldMatrix defines the new world matrix
         */
        constructor(min, max, worldMatrix) {
            /**
             * Gets the 8 vectors representing the bounding box in local space
             */
            this.vectors = ArrayTools.BuildArray(8, Vector3.Zero);
            /**
             * Gets the center of the bounding box in local space
             */
            this.center = Vector3.Zero();
            /**
             * Gets the center of the bounding box in world space
             */
            this.centerWorld = Vector3.Zero();
            /**
             * Gets the extend size in local space
             */
            this.extendSize = Vector3.Zero();
            /**
             * Gets the extend size in world space
             */
            this.extendSizeWorld = Vector3.Zero();
            /**
             * Gets the OBB (object bounding box) directions
             */
            this.directions = ArrayTools.BuildArray(3, Vector3.Zero);
            /**
             * Gets the 8 vectors representing the bounding box in world space
             */
            this.vectorsWorld = ArrayTools.BuildArray(8, Vector3.Zero);
            /**
             * Gets the minimum vector in world space
             */
            this.minimumWorld = Vector3.Zero();
            /**
             * Gets the maximum vector in world space
             */
            this.maximumWorld = Vector3.Zero();
            /**
             * Gets the minimum vector in local space
             */
            this.minimum = Vector3.Zero();
            /**
             * Gets the maximum vector in local space
             */
            this.maximum = Vector3.Zero();
            /** @internal */
            this._drawWrapperFront = null;
            /** @internal */
            this._drawWrapperBack = null;
            this.reConstruct(min, max, worldMatrix);
        }
        // Methods
        /**
         * Recreates the entire bounding box from scratch as if we call the constructor in place
         * @param min defines the new minimum vector (in local space)
         * @param max defines the new maximum vector (in local space)
         * @param worldMatrix defines the new world matrix
         */
        reConstruct(min, max, worldMatrix) {
            const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
            const vectors = this.vectors;
            this.minimum.copyFromFloats(minX, minY, minZ);
            this.maximum.copyFromFloats(maxX, maxY, maxZ);
            vectors[0].copyFromFloats(minX, minY, minZ);
            vectors[1].copyFromFloats(maxX, maxY, maxZ);
            vectors[2].copyFromFloats(maxX, minY, minZ);
            vectors[3].copyFromFloats(minX, maxY, minZ);
            vectors[4].copyFromFloats(minX, minY, maxZ);
            vectors[5].copyFromFloats(maxX, maxY, minZ);
            vectors[6].copyFromFloats(minX, maxY, maxZ);
            vectors[7].copyFromFloats(maxX, minY, maxZ);
            // OBB
            max.addToRef(min, this.center).scaleInPlace(0.5);
            max.subtractToRef(min, this.extendSize).scaleInPlace(0.5);
            this._worldMatrix = worldMatrix || Matrix.IdentityReadOnly;
            this._update(this._worldMatrix);
        }
        /**
         * Scale the current bounding box by applying a scale factor
         * @param factor defines the scale factor to apply
         * @returns the current bounding box
         */
        scale(factor) {
            const tmpVectors = BoundingBox._TmpVector3;
            const diff = this.maximum.subtractToRef(this.minimum, tmpVectors[0]);
            const len = diff.length();
            diff.normalizeFromLength(len);
            const distance = len * factor;
            const newRadius = diff.scaleInPlace(distance * 0.5);
            const min = this.center.subtractToRef(newRadius, tmpVectors[1]);
            const max = this.center.addToRef(newRadius, tmpVectors[2]);
            this.reConstruct(min, max, this._worldMatrix);
            return this;
        }
        /**
         * Gets the world matrix of the bounding box
         * @returns a matrix
         */
        getWorldMatrix() {
            return this._worldMatrix;
        }
        /**
         * @internal
         */
        _update(world) {
            const minWorld = this.minimumWorld;
            const maxWorld = this.maximumWorld;
            const directions = this.directions;
            const vectorsWorld = this.vectorsWorld;
            const vectors = this.vectors;
            if (!world.isIdentity()) {
                minWorld.setAll(Number.MAX_VALUE);
                maxWorld.setAll(-Number.MAX_VALUE);
                for (let index = 0; index < 8; ++index) {
                    const v = vectorsWorld[index];
                    Vector3.TransformCoordinatesToRef(vectors[index], world, v);
                    minWorld.minimizeInPlace(v);
                    maxWorld.maximizeInPlace(v);
                }
                // Extend
                maxWorld.subtractToRef(minWorld, this.extendSizeWorld).scaleInPlace(0.5);
                maxWorld.addToRef(minWorld, this.centerWorld).scaleInPlace(0.5);
            }
            else {
                minWorld.copyFrom(this.minimum);
                maxWorld.copyFrom(this.maximum);
                for (let index = 0; index < 8; ++index) {
                    vectorsWorld[index].copyFrom(vectors[index]);
                }
                // Extend
                this.extendSizeWorld.copyFrom(this.extendSize);
                this.centerWorld.copyFrom(this.center);
            }
            Vector3.FromArrayToRef(world.m, 0, directions[0]);
            Vector3.FromArrayToRef(world.m, 4, directions[1]);
            Vector3.FromArrayToRef(world.m, 8, directions[2]);
            this._worldMatrix = world;
        }
        /**
         * Tests if the bounding box is intersecting the frustum planes
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if there is an intersection
         */
        isInFrustum(frustumPlanes) {
            return BoundingBox.IsInFrustum(this.vectorsWorld, frustumPlanes);
        }
        /**
         * Tests if the bounding box is entirely inside the frustum planes
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if there is an inclusion
         */
        isCompletelyInFrustum(frustumPlanes) {
            return BoundingBox.IsCompletelyInFrustum(this.vectorsWorld, frustumPlanes);
        }
        /**
         * Tests if a point is inside the bounding box
         * @param point defines the point to test
         * @returns true if the point is inside the bounding box
         */
        intersectsPoint(point) {
            const min = this.minimumWorld;
            const max = this.maximumWorld;
            const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
            const pointX = point.x, pointY = point.y, pointZ = point.z;
            const delta = -Epsilon;
            if (maxX - pointX < delta || delta > pointX - minX) {
                return false;
            }
            if (maxY - pointY < delta || delta > pointY - minY) {
                return false;
            }
            if (maxZ - pointZ < delta || delta > pointZ - minZ) {
                return false;
            }
            return true;
        }
        /**
         * Tests if the bounding box intersects with a bounding sphere
         * @param sphere defines the sphere to test
         * @returns true if there is an intersection
         */
        intersectsSphere(sphere) {
            return BoundingBox.IntersectsSphere(this.minimumWorld, this.maximumWorld, sphere.centerWorld, sphere.radiusWorld);
        }
        /**
         * Tests if the bounding box intersects with a box defined by a min and max vectors
         * @param min defines the min vector to use
         * @param max defines the max vector to use
         * @returns true if there is an intersection
         */
        intersectsMinMax(min, max) {
            const myMin = this.minimumWorld;
            const myMax = this.maximumWorld;
            const myMinX = myMin.x, myMinY = myMin.y, myMinZ = myMin.z, myMaxX = myMax.x, myMaxY = myMax.y, myMaxZ = myMax.z;
            const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
            if (myMaxX < minX || myMinX > maxX) {
                return false;
            }
            if (myMaxY < minY || myMinY > maxY) {
                return false;
            }
            if (myMaxZ < minZ || myMinZ > maxZ) {
                return false;
            }
            return true;
        }
        /**
         * Disposes the resources of the class
         */
        dispose() {
            var _a, _b;
            (_a = this._drawWrapperFront) === null || _a === void 0 ? void 0 : _a.dispose();
            (_b = this._drawWrapperBack) === null || _b === void 0 ? void 0 : _b.dispose();
        }
        // Statics
        /**
         * Tests if two bounding boxes are intersections
         * @param box0 defines the first box to test
         * @param box1 defines the second box to test
         * @returns true if there is an intersection
         */
        static Intersects(box0, box1) {
            return box0.intersectsMinMax(box1.minimumWorld, box1.maximumWorld);
        }
        /**
         * Tests if a bounding box defines by a min/max vectors intersects a sphere
         * @param minPoint defines the minimum vector of the bounding box
         * @param maxPoint defines the maximum vector of the bounding box
         * @param sphereCenter defines the sphere center
         * @param sphereRadius defines the sphere radius
         * @returns true if there is an intersection
         */
        static IntersectsSphere(minPoint, maxPoint, sphereCenter, sphereRadius) {
            const vector = BoundingBox._TmpVector3[0];
            Vector3.ClampToRef(sphereCenter, minPoint, maxPoint, vector);
            const num = Vector3.DistanceSquared(sphereCenter, vector);
            return num <= sphereRadius * sphereRadius;
        }
        /**
         * Tests if a bounding box defined with 8 vectors is entirely inside frustum planes
         * @param boundingVectors defines an array of 8 vectors representing a bounding box
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if there is an inclusion
         */
        static IsCompletelyInFrustum(boundingVectors, frustumPlanes) {
            for (let p = 0; p < 6; ++p) {
                const frustumPlane = frustumPlanes[p];
                for (let i = 0; i < 8; ++i) {
                    if (frustumPlane.dotCoordinate(boundingVectors[i]) < 0) {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * Tests if a bounding box defined with 8 vectors intersects frustum planes
         * @param boundingVectors defines an array of 8 vectors representing a bounding box
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if there is an intersection
         */
        static IsInFrustum(boundingVectors, frustumPlanes) {
            for (let p = 0; p < 6; ++p) {
                let canReturnFalse = true;
                const frustumPlane = frustumPlanes[p];
                for (let i = 0; i < 8; ++i) {
                    if (frustumPlane.dotCoordinate(boundingVectors[i]) >= 0) {
                        canReturnFalse = false;
                        break;
                    }
                }
                if (canReturnFalse) {
                    return false;
                }
            }
            return true;
        }
    }
    BoundingBox._TmpVector3 = ArrayTools.BuildArray(3, Vector3.Zero);

    /**
     * Class used to store bounding sphere information
     */
    class BoundingSphere {
        /**
         * Creates a new bounding sphere
         * @param min defines the minimum vector (in local space)
         * @param max defines the maximum vector (in local space)
         * @param worldMatrix defines the new world matrix
         */
        constructor(min, max, worldMatrix) {
            /**
             * Gets the center of the bounding sphere in local space
             */
            this.center = Vector3.Zero();
            /**
             * Gets the center of the bounding sphere in world space
             */
            this.centerWorld = Vector3.Zero();
            /**
             * Gets the minimum vector in local space
             */
            this.minimum = Vector3.Zero();
            /**
             * Gets the maximum vector in local space
             */
            this.maximum = Vector3.Zero();
            this.reConstruct(min, max, worldMatrix);
        }
        /**
         * Recreates the entire bounding sphere from scratch as if we call the constructor in place
         * @param min defines the new minimum vector (in local space)
         * @param max defines the new maximum vector (in local space)
         * @param worldMatrix defines the new world matrix
         */
        reConstruct(min, max, worldMatrix) {
            this.minimum.copyFrom(min);
            this.maximum.copyFrom(max);
            const distance = Vector3.Distance(min, max);
            max.addToRef(min, this.center).scaleInPlace(0.5);
            this.radius = distance * 0.5;
            this._update(worldMatrix || Matrix.IdentityReadOnly);
        }
        /**
         * Scale the current bounding sphere by applying a scale factor
         * @param factor defines the scale factor to apply
         * @returns the current bounding box
         */
        scale(factor) {
            const newRadius = this.radius * factor;
            const tmpVectors = BoundingSphere._TmpVector3;
            const tempRadiusVector = tmpVectors[0].setAll(newRadius);
            const min = this.center.subtractToRef(tempRadiusVector, tmpVectors[1]);
            const max = this.center.addToRef(tempRadiusVector, tmpVectors[2]);
            this.reConstruct(min, max, this._worldMatrix);
            return this;
        }
        /**
         * Gets the world matrix of the bounding box
         * @returns a matrix
         */
        getWorldMatrix() {
            return this._worldMatrix;
        }
        // Methods
        /**
         * @internal
         */
        _update(worldMatrix) {
            if (!worldMatrix.isIdentity()) {
                Vector3.TransformCoordinatesToRef(this.center, worldMatrix, this.centerWorld);
                const tempVector = BoundingSphere._TmpVector3[0];
                Vector3.TransformNormalFromFloatsToRef(1.0, 1.0, 1.0, worldMatrix, tempVector);
                this.radiusWorld = Math.max(Math.abs(tempVector.x), Math.abs(tempVector.y), Math.abs(tempVector.z)) * this.radius;
            }
            else {
                this.centerWorld.copyFrom(this.center);
                this.radiusWorld = this.radius;
            }
        }
        /**
         * Tests if the bounding sphere is intersecting the frustum planes
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if there is an intersection
         */
        isInFrustum(frustumPlanes) {
            const center = this.centerWorld;
            const radius = this.radiusWorld;
            for (let i = 0; i < 6; i++) {
                if (frustumPlanes[i].dotCoordinate(center) <= -radius) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Tests if the bounding sphere center is in between the frustum planes.
         * Used for optimistic fast inclusion.
         * @param frustumPlanes defines the frustum planes to test
         * @returns true if the sphere center is in between the frustum planes
         */
        isCenterInFrustum(frustumPlanes) {
            const center = this.centerWorld;
            for (let i = 0; i < 6; i++) {
                if (frustumPlanes[i].dotCoordinate(center) < 0) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Tests if a point is inside the bounding sphere
         * @param point defines the point to test
         * @returns true if the point is inside the bounding sphere
         */
        intersectsPoint(point) {
            const squareDistance = Vector3.DistanceSquared(this.centerWorld, point);
            if (this.radiusWorld * this.radiusWorld < squareDistance) {
                return false;
            }
            return true;
        }
        // Statics
        /**
         * Checks if two sphere intersect
         * @param sphere0 sphere 0
         * @param sphere1 sphere 1
         * @returns true if the spheres intersect
         */
        static Intersects(sphere0, sphere1) {
            const squareDistance = Vector3.DistanceSquared(sphere0.centerWorld, sphere1.centerWorld);
            const radiusSum = sphere0.radiusWorld + sphere1.radiusWorld;
            if (radiusSum * radiusSum < squareDistance) {
                return false;
            }
            return true;
        }
        /**
         * Creates a sphere from a center and a radius
         * @param center The center
         * @param radius radius
         * @param matrix Optional worldMatrix
         * @returns The sphere
         */
        static CreateFromCenterAndRadius(center, radius, matrix) {
            this._TmpVector3[0].copyFrom(center);
            this._TmpVector3[1].copyFromFloats(0, 0, radius);
            this._TmpVector3[2].copyFrom(center);
            this._TmpVector3[0].addInPlace(this._TmpVector3[1]);
            this._TmpVector3[2].subtractInPlace(this._TmpVector3[1]);
            const sphere = new BoundingSphere(this._TmpVector3[0], this._TmpVector3[2]);
            if (matrix) {
                sphere._worldMatrix = matrix;
            }
            else {
                sphere._worldMatrix = Matrix.Identity();
            }
            return sphere;
        }
    }
    BoundingSphere._TmpVector3 = ArrayTools.BuildArray(3, Vector3.Zero);

    const _result0 = { min: 0, max: 0 };
    const _result1 = { min: 0, max: 0 };
    const computeBoxExtents = (axis, box, result) => {
        const p = Vector3.Dot(box.centerWorld, axis);
        const r0 = Math.abs(Vector3.Dot(box.directions[0], axis)) * box.extendSize.x;
        const r1 = Math.abs(Vector3.Dot(box.directions[1], axis)) * box.extendSize.y;
        const r2 = Math.abs(Vector3.Dot(box.directions[2], axis)) * box.extendSize.z;
        const r = r0 + r1 + r2;
        result.min = p - r;
        result.max = p + r;
    };
    const axisOverlap = (axis, box0, box1) => {
        computeBoxExtents(axis, box0, _result0);
        computeBoxExtents(axis, box1, _result1);
        return !(_result0.min > _result1.max || _result1.min > _result0.max);
    };
    /**
     * Info for a bounding data of a mesh
     */
    class BoundingInfo {
        /**
         * Constructs bounding info
         * @param minimum min vector of the bounding box/sphere
         * @param maximum max vector of the bounding box/sphere
         * @param worldMatrix defines the new world matrix
         */
        constructor(minimum, maximum, worldMatrix) {
            this._isLocked = false;
            this.boundingBox = new BoundingBox(minimum, maximum, worldMatrix);
            this.boundingSphere = new BoundingSphere(minimum, maximum, worldMatrix);
        }
        /**
         * Recreates the entire bounding info from scratch as if we call the constructor in place
         * @param min defines the new minimum vector (in local space)
         * @param max defines the new maximum vector (in local space)
         * @param worldMatrix defines the new world matrix
         */
        reConstruct(min, max, worldMatrix) {
            this.boundingBox.reConstruct(min, max, worldMatrix);
            this.boundingSphere.reConstruct(min, max, worldMatrix);
        }
        /**
         * min vector of the bounding box/sphere
         */
        get minimum() {
            return this.boundingBox.minimum;
        }
        /**
         * max vector of the bounding box/sphere
         */
        get maximum() {
            return this.boundingBox.maximum;
        }
        /**
         * If the info is locked and won't be updated to avoid perf overhead
         */
        get isLocked() {
            return this._isLocked;
        }
        set isLocked(value) {
            this._isLocked = value;
        }
        // Methods
        /**
         * Updates the bounding sphere and box
         * @param world world matrix to be used to update
         */
        update(world) {
            if (this._isLocked) {
                return;
            }
            this.boundingBox._update(world);
            this.boundingSphere._update(world);
        }
        /**
         * Recreate the bounding info to be centered around a specific point given a specific extend.
         * @param center New center of the bounding info
         * @param extend New extend of the bounding info
         * @returns the current bounding info
         */
        centerOn(center, extend) {
            const minimum = BoundingInfo._TmpVector3[0].copyFrom(center).subtractInPlace(extend);
            const maximum = BoundingInfo._TmpVector3[1].copyFrom(center).addInPlace(extend);
            this.boundingBox.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
            this.boundingSphere.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
            return this;
        }
        /**
         * Grows the bounding info to include the given point.
         * @param point The point that will be included in the current bounding info (in local space)
         * @returns the current bounding info
         */
        encapsulate(point) {
            const minimum = Vector3.Minimize(this.minimum, point);
            const maximum = Vector3.Maximize(this.maximum, point);
            this.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
            return this;
        }
        /**
         * Grows the bounding info to encapsulate the given bounding info.
         * @param toEncapsulate The bounding info that will be encapsulated in the current bounding info
         * @returns the current bounding info
         */
        encapsulateBoundingInfo(toEncapsulate) {
            const invw = TmpVectors.Matrix[0];
            this.boundingBox.getWorldMatrix().invertToRef(invw);
            const v = TmpVectors.Vector3[0];
            Vector3.TransformCoordinatesToRef(toEncapsulate.boundingBox.minimumWorld, invw, v);
            this.encapsulate(v);
            Vector3.TransformCoordinatesToRef(toEncapsulate.boundingBox.maximumWorld, invw, v);
            this.encapsulate(v);
            return this;
        }
        /**
         * Scale the current bounding info by applying a scale factor
         * @param factor defines the scale factor to apply
         * @returns the current bounding info
         */
        scale(factor) {
            this.boundingBox.scale(factor);
            this.boundingSphere.scale(factor);
            return this;
        }
        /**
         * Returns `true` if the bounding info is within the frustum defined by the passed array of planes.
         * @param frustumPlanes defines the frustum to test
         * @param strategy defines the strategy to use for the culling (default is BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD)
         * The different strategies available are:
         * * BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD most accurate but slower @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_STANDARD
         * * BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY faster but less accurate @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
         * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
         * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
         * @returns true if the bounding info is in the frustum planes
         */
        isInFrustum(frustumPlanes, strategy = 0) {
            const inclusionTest = strategy === 2 || strategy === 3;
            if (inclusionTest) {
                if (this.boundingSphere.isCenterInFrustum(frustumPlanes)) {
                    return true;
                }
            }
            if (!this.boundingSphere.isInFrustum(frustumPlanes)) {
                return false;
            }
            const bSphereOnlyTest = strategy === 1 || strategy === 3;
            if (bSphereOnlyTest) {
                return true;
            }
            return this.boundingBox.isInFrustum(frustumPlanes);
        }
        /**
         * Gets the world distance between the min and max points of the bounding box
         */
        get diagonalLength() {
            const boundingBox = this.boundingBox;
            const diag = boundingBox.maximumWorld.subtractToRef(boundingBox.minimumWorld, BoundingInfo._TmpVector3[0]);
            return diag.length();
        }
        /**
         * Checks if a cullable object (mesh...) is in the camera frustum
         * Unlike isInFrustum this checks the full bounding box
         * @param frustumPlanes Camera near/planes
         * @returns true if the object is in frustum otherwise false
         */
        isCompletelyInFrustum(frustumPlanes) {
            return this.boundingBox.isCompletelyInFrustum(frustumPlanes);
        }
        /**
         * @internal
         */
        _checkCollision(collider) {
            return collider._canDoCollision(this.boundingSphere.centerWorld, this.boundingSphere.radiusWorld, this.boundingBox.minimumWorld, this.boundingBox.maximumWorld);
        }
        /**
         * Checks if a point is inside the bounding box and bounding sphere or the mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
         * @param point the point to check intersection with
         * @returns if the point intersects
         */
        intersectsPoint(point) {
            if (!this.boundingSphere.centerWorld) {
                return false;
            }
            if (!this.boundingSphere.intersectsPoint(point)) {
                return false;
            }
            if (!this.boundingBox.intersectsPoint(point)) {
                return false;
            }
            return true;
        }
        /**
         * Checks if another bounding info intersects the bounding box and bounding sphere or the mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
         * @param boundingInfo the bounding info to check intersection with
         * @param precise if the intersection should be done using OBB
         * @returns if the bounding info intersects
         */
        intersects(boundingInfo, precise) {
            if (!BoundingSphere.Intersects(this.boundingSphere, boundingInfo.boundingSphere)) {
                return false;
            }
            if (!BoundingBox.Intersects(this.boundingBox, boundingInfo.boundingBox)) {
                return false;
            }
            if (!precise) {
                return true;
            }
            const box0 = this.boundingBox;
            const box1 = boundingInfo.boundingBox;
            if (!axisOverlap(box0.directions[0], box0, box1)) {
                return false;
            }
            if (!axisOverlap(box0.directions[1], box0, box1)) {
                return false;
            }
            if (!axisOverlap(box0.directions[2], box0, box1)) {
                return false;
            }
            if (!axisOverlap(box1.directions[0], box0, box1)) {
                return false;
            }
            if (!axisOverlap(box1.directions[1], box0, box1)) {
                return false;
            }
            if (!axisOverlap(box1.directions[2], box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[0], box1.directions[0]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[0], box1.directions[1]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[0], box1.directions[2]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[1], box1.directions[0]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[1], box1.directions[1]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[1], box1.directions[2]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[2], box1.directions[0]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[2], box1.directions[1]), box0, box1)) {
                return false;
            }
            if (!axisOverlap(Vector3.Cross(box0.directions[2], box1.directions[2]), box0, box1)) {
                return false;
            }
            return true;
        }
    }
    BoundingInfo._TmpVector3 = ArrayTools.BuildArray(2, Vector3.Zero);

    // This helper class is only here so we can apply the nativeOverride decorator to functions.
    class MathHelpers {
        static extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, minimum, maximum) {
            for (let index = indexStart; index < indexStart + indexCount; index++) {
                const offset = indices[index] * 3;
                const x = positions[offset];
                const y = positions[offset + 1];
                const z = positions[offset + 2];
                minimum.minimizeInPlaceFromFloats(x, y, z);
                maximum.maximizeInPlaceFromFloats(x, y, z);
            }
        }
        static extractMinAndMax(positions, start, count, stride, minimum, maximum) {
            for (let index = start, offset = start * stride; index < start + count; index++, offset += stride) {
                const x = positions[offset];
                const y = positions[offset + 1];
                const z = positions[offset + 2];
                minimum.minimizeInPlaceFromFloats(x, y, z);
                maximum.maximizeInPlaceFromFloats(x, y, z);
            }
        }
    }
    __decorate$1([
        nativeOverride.filter((...[positions, indices]) => !Array.isArray(positions) && !Array.isArray(indices))
        // eslint-disable-next-line @typescript-eslint/naming-convention
    ], MathHelpers, "extractMinAndMaxIndexed", null);
    __decorate$1([
        nativeOverride.filter((...[positions]) => !Array.isArray(positions))
        // eslint-disable-next-line @typescript-eslint/naming-convention
    ], MathHelpers, "extractMinAndMax", null);
    /**
     * Extracts minimum and maximum values from a list of indexed positions
     * @param positions defines the positions to use
     * @param indices defines the indices to the positions
     * @param indexStart defines the start index
     * @param indexCount defines the end index
     * @param bias defines bias value to add to the result
     * @returns minimum and maximum values
     */
    function extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, bias = null) {
        const minimum = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const maximum = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        MathHelpers.extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, minimum, maximum);
        if (bias) {
            minimum.x -= minimum.x * bias.x + bias.y;
            minimum.y -= minimum.y * bias.x + bias.y;
            minimum.z -= minimum.z * bias.x + bias.y;
            maximum.x += maximum.x * bias.x + bias.y;
            maximum.y += maximum.y * bias.x + bias.y;
            maximum.z += maximum.z * bias.x + bias.y;
        }
        return {
            minimum: minimum,
            maximum: maximum,
        };
    }
    /**
     * Extracts minimum and maximum values from a list of positions
     * @param positions defines the positions to use
     * @param start defines the start index in the positions array
     * @param count defines the number of positions to handle
     * @param bias defines bias value to add to the result
     * @param stride defines the stride size to use (distance between two positions in the positions array)
     * @returns minimum and maximum values
     */
    function extractMinAndMax(positions, start, count, bias = null, stride) {
        const minimum = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const maximum = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        if (!stride) {
            stride = 3;
        }
        MathHelpers.extractMinAndMax(positions, start, count, stride, minimum, maximum);
        if (bias) {
            minimum.x -= minimum.x * bias.x + bias.y;
            minimum.y -= minimum.y * bias.x + bias.y;
            minimum.z -= minimum.z * bias.x + bias.y;
            maximum.x += maximum.x * bias.x + bias.y;
            maximum.y += maximum.y * bias.x + bias.y;
            maximum.z += maximum.z * bias.x + bias.y;
        }
        return {
            minimum: minimum,
            maximum: maximum,
        };
    }

    /**
     * Defines a subdivision inside a mesh
     */
    class SubMesh {
        /**
         * Gets material defines used by the effect associated to the sub mesh
         */
        get materialDefines() {
            var _a;
            return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.defines : (_a = this._getDrawWrapper()) === null || _a === void 0 ? void 0 : _a.defines;
        }
        /**
         * Sets material defines used by the effect associated to the sub mesh
         */
        set materialDefines(defines) {
            var _a;
            const drawWrapper = (_a = this._mainDrawWrapperOverride) !== null && _a !== void 0 ? _a : this._getDrawWrapper(undefined, true);
            drawWrapper.defines = defines;
        }
        /**
         * @internal
         */
        _getDrawWrapper(passId, createIfNotExisting = false) {
            passId = passId !== null && passId !== void 0 ? passId : this._engine.currentRenderPassId;
            let drawWrapper = this._drawWrappers[passId];
            if (!drawWrapper && createIfNotExisting) {
                this._drawWrappers[passId] = drawWrapper = new DrawWrapper(this._mesh.getScene().getEngine());
            }
            return drawWrapper;
        }
        /**
         * @internal
         */
        _removeDrawWrapper(passId, disposeWrapper = true) {
            var _a;
            if (disposeWrapper) {
                (_a = this._drawWrappers[passId]) === null || _a === void 0 ? void 0 : _a.dispose();
            }
            this._drawWrappers[passId] = undefined;
        }
        /**
         * Gets associated (main) effect (possibly the effect override if defined)
         */
        get effect() {
            var _a, _b;
            return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.effect : (_b = (_a = this._getDrawWrapper()) === null || _a === void 0 ? void 0 : _a.effect) !== null && _b !== void 0 ? _b : null;
        }
        /** @internal */
        get _drawWrapper() {
            var _a;
            return (_a = this._mainDrawWrapperOverride) !== null && _a !== void 0 ? _a : this._getDrawWrapper(undefined, true);
        }
        /** @internal */
        get _drawWrapperOverride() {
            return this._mainDrawWrapperOverride;
        }
        /**
         * @internal
         */
        _setMainDrawWrapperOverride(wrapper) {
            this._mainDrawWrapperOverride = wrapper;
        }
        /**
         * Sets associated effect (effect used to render this submesh)
         * @param effect defines the effect to associate with
         * @param defines defines the set of defines used to compile this effect
         * @param materialContext material context associated to the effect
         * @param resetContext true to reset the draw context
         */
        setEffect(effect, defines = null, materialContext, resetContext = true) {
            const drawWrapper = this._drawWrapper;
            drawWrapper.setEffect(effect, defines, resetContext);
            if (materialContext !== undefined) {
                drawWrapper.materialContext = materialContext;
            }
            if (!effect) {
                drawWrapper.defines = null;
                drawWrapper.materialContext = undefined;
            }
        }
        /**
         * Resets the draw wrappers cache
         * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
         */
        resetDrawCache(passId) {
            if (this._drawWrappers) {
                if (passId !== undefined) {
                    this._removeDrawWrapper(passId);
                    return;
                }
                else {
                    for (const drawWrapper of this._drawWrappers) {
                        drawWrapper === null || drawWrapper === void 0 ? void 0 : drawWrapper.dispose();
                    }
                }
            }
            this._drawWrappers = [];
        }
        /**
         * Add a new submesh to a mesh
         * @param materialIndex defines the material index to use
         * @param verticesStart defines vertex index start
         * @param verticesCount defines vertices count
         * @param indexStart defines index start
         * @param indexCount defines indices count
         * @param mesh defines the parent mesh
         * @param renderingMesh defines an optional rendering mesh
         * @param createBoundingBox defines if bounding box should be created for this submesh
         * @returns the new submesh
         */
        static AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox = true) {
            return new SubMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox);
        }
        /**
         * Creates a new submesh
         * @param materialIndex defines the material index to use
         * @param verticesStart defines vertex index start
         * @param verticesCount defines vertices count
         * @param indexStart defines index start
         * @param indexCount defines indices count
         * @param mesh defines the parent mesh
         * @param renderingMesh defines an optional rendering mesh
         * @param createBoundingBox defines if bounding box should be created for this submesh
         * @param addToMesh defines a boolean indicating that the submesh must be added to the mesh.subMeshes array (true by default)
         */
        constructor(
        /** the material index to use */
        materialIndex, 
        /** vertex index start */
        verticesStart, 
        /** vertices count */
        verticesCount, 
        /** index start */
        indexStart, 
        /** indices count */
        indexCount, mesh, renderingMesh, createBoundingBox = true, addToMesh = true) {
            this.materialIndex = materialIndex;
            this.verticesStart = verticesStart;
            this.verticesCount = verticesCount;
            this.indexStart = indexStart;
            this.indexCount = indexCount;
            this._mainDrawWrapperOverride = null;
            /** @internal */
            this._linesIndexCount = 0;
            this._linesIndexBuffer = null;
            /** @internal */
            this._lastColliderWorldVertices = null;
            /** @internal */
            this._lastColliderTransformMatrix = null;
            /** @internal */
            this._wasDispatched = false;
            /** @internal */
            this._renderId = 0;
            /** @internal */
            this._alphaIndex = 0;
            /** @internal */
            this._distanceToCamera = 0;
            this._currentMaterial = null;
            this._mesh = mesh;
            this._renderingMesh = renderingMesh || mesh;
            if (addToMesh) {
                mesh.subMeshes.push(this);
            }
            this._engine = this._mesh.getScene().getEngine();
            this.resetDrawCache();
            this._trianglePlanes = [];
            this._id = mesh.subMeshes.length - 1;
            if (createBoundingBox) {
                this.refreshBoundingInfo();
                mesh.computeWorldMatrix(true);
            }
        }
        /**
         * Returns true if this submesh covers the entire parent mesh
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        get IsGlobal() {
            return this.verticesStart === 0 && this.verticesCount === this._mesh.getTotalVertices() && this.indexStart === 0 && this.indexCount === this._mesh.getTotalIndices();
        }
        /**
         * Returns the submesh BoundingInfo object
         * @returns current bounding info (or mesh's one if the submesh is global)
         */
        getBoundingInfo() {
            if (this.IsGlobal) {
                return this._mesh.getBoundingInfo();
            }
            return this._boundingInfo;
        }
        /**
         * Sets the submesh BoundingInfo
         * @param boundingInfo defines the new bounding info to use
         * @returns the SubMesh
         */
        setBoundingInfo(boundingInfo) {
            this._boundingInfo = boundingInfo;
            return this;
        }
        /**
         * Returns the mesh of the current submesh
         * @returns the parent mesh
         */
        getMesh() {
            return this._mesh;
        }
        /**
         * Returns the rendering mesh of the submesh
         * @returns the rendering mesh (could be different from parent mesh)
         */
        getRenderingMesh() {
            return this._renderingMesh;
        }
        /**
         * Returns the replacement mesh of the submesh
         * @returns the replacement mesh (could be different from parent mesh)
         */
        getReplacementMesh() {
            return this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
        }
        /**
         * Returns the effective mesh of the submesh
         * @returns the effective mesh (could be different from parent mesh)
         */
        getEffectiveMesh() {
            const replacementMesh = this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
            return replacementMesh ? replacementMesh : this._renderingMesh;
        }
        /**
         * Returns the submesh material
         * @param getDefaultMaterial Defines whether or not to get the default material if nothing has been defined.
         * @returns null or the current material
         */
        getMaterial(getDefaultMaterial = true) {
            var _a;
            const rootMaterial = (_a = this._renderingMesh.getMaterialForRenderPass(this._engine.currentRenderPassId)) !== null && _a !== void 0 ? _a : this._renderingMesh.material;
            if (!rootMaterial) {
                return getDefaultMaterial ? this._mesh.getScene().defaultMaterial : null;
            }
            else if (this._isMultiMaterial(rootMaterial)) {
                const effectiveMaterial = rootMaterial.getSubMaterial(this.materialIndex);
                if (this._currentMaterial !== effectiveMaterial) {
                    this._currentMaterial = effectiveMaterial;
                    this.resetDrawCache();
                }
                return effectiveMaterial;
            }
            return rootMaterial;
        }
        _isMultiMaterial(material) {
            return material.getSubMaterial !== undefined;
        }
        // Methods
        /**
         * Sets a new updated BoundingInfo object to the submesh
         * @param data defines an optional position array to use to determine the bounding info
         * @returns the SubMesh
         */
        refreshBoundingInfo(data = null) {
            this._lastColliderWorldVertices = null;
            if (this.IsGlobal || !this._renderingMesh || !this._renderingMesh.geometry) {
                return this;
            }
            if (!data) {
                data = this._renderingMesh.getVerticesData(VertexBuffer.PositionKind);
            }
            if (!data) {
                this._boundingInfo = this._mesh.getBoundingInfo();
                return this;
            }
            const indices = this._renderingMesh.getIndices();
            let extend;
            //is this the only submesh?
            if (this.indexStart === 0 && this.indexCount === indices.length) {
                const boundingInfo = this._renderingMesh.getBoundingInfo();
                //the rendering mesh's bounding info can be used, it is the standard submesh for all indices.
                extend = { minimum: boundingInfo.minimum.clone(), maximum: boundingInfo.maximum.clone() };
            }
            else {
                extend = extractMinAndMaxIndexed(data, indices, this.indexStart, this.indexCount, this._renderingMesh.geometry.boundingBias);
            }
            if (this._boundingInfo) {
                this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
            }
            else {
                this._boundingInfo = new BoundingInfo(extend.minimum, extend.maximum);
            }
            return this;
        }
        /**
         * @internal
         */
        _checkCollision(collider) {
            const boundingInfo = this.getBoundingInfo();
            return boundingInfo._checkCollision(collider);
        }
        /**
         * Updates the submesh BoundingInfo
         * @param world defines the world matrix to use to update the bounding info
         * @returns the submesh
         */
        updateBoundingInfo(world) {
            let boundingInfo = this.getBoundingInfo();
            if (!boundingInfo) {
                this.refreshBoundingInfo();
                boundingInfo = this.getBoundingInfo();
            }
            if (boundingInfo) {
                boundingInfo.update(world);
            }
            return this;
        }
        /**
         * True is the submesh bounding box intersects the frustum defined by the passed array of planes.
         * @param frustumPlanes defines the frustum planes
         * @returns true if the submesh is intersecting with the frustum
         */
        isInFrustum(frustumPlanes) {
            const boundingInfo = this.getBoundingInfo();
            if (!boundingInfo) {
                return false;
            }
            return boundingInfo.isInFrustum(frustumPlanes, this._mesh.cullingStrategy);
        }
        /**
         * True is the submesh bounding box is completely inside the frustum defined by the passed array of planes
         * @param frustumPlanes defines the frustum planes
         * @returns true if the submesh is inside the frustum
         */
        isCompletelyInFrustum(frustumPlanes) {
            const boundingInfo = this.getBoundingInfo();
            if (!boundingInfo) {
                return false;
            }
            return boundingInfo.isCompletelyInFrustum(frustumPlanes);
        }
        /**
         * Renders the submesh
         * @param enableAlphaMode defines if alpha needs to be used
         * @returns the submesh
         */
        render(enableAlphaMode) {
            this._renderingMesh.render(this, enableAlphaMode, this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : undefined);
            return this;
        }
        /**
         * @internal
         */
        _getLinesIndexBuffer(indices, engine) {
            if (!this._linesIndexBuffer) {
                const linesIndices = [];
                for (let index = this.indexStart; index < this.indexStart + this.indexCount; index += 3) {
                    linesIndices.push(indices[index], indices[index + 1], indices[index + 1], indices[index + 2], indices[index + 2], indices[index]);
                }
                this._linesIndexBuffer = engine.createIndexBuffer(linesIndices);
                this._linesIndexCount = linesIndices.length;
            }
            return this._linesIndexBuffer;
        }
        /**
         * Checks if the submesh intersects with a ray
         * @param ray defines the ray to test
         * @returns true is the passed ray intersects the submesh bounding box
         */
        canIntersects(ray) {
            const boundingInfo = this.getBoundingInfo();
            if (!boundingInfo) {
                return false;
            }
            return ray.intersectsBox(boundingInfo.boundingBox);
        }
        /**
         * Intersects current submesh with a ray
         * @param ray defines the ray to test
         * @param positions defines mesh's positions array
         * @param indices defines mesh's indices array
         * @param fastCheck defines if the first intersection will be used (and not the closest)
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @returns intersection info or null if no intersection
         */
        intersects(ray, positions, indices, fastCheck, trianglePredicate) {
            const material = this.getMaterial();
            if (!material) {
                return null;
            }
            let step = 3;
            let checkStopper = false;
            switch (material.fillMode) {
                case 3:
                case 5:
                case 6:
                case 8:
                    return null;
                case 7:
                    step = 1;
                    checkStopper = true;
                    break;
            }
            // LineMesh first as it's also a Mesh...
            if (material.fillMode === 4) {
                // Check if mesh is unindexed
                if (!indices.length) {
                    return this._intersectUnIndexedLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
                }
                return this._intersectLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
            }
            else {
                // Check if mesh is unindexed
                if (!indices.length && this._mesh._unIndexed) {
                    return this._intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate);
                }
                return this._intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate);
            }
        }
        /**
         * @internal
         */
        _intersectLines(ray, positions, indices, intersectionThreshold, fastCheck) {
            let intersectInfo = null;
            // Line test
            for (let index = this.indexStart; index < this.indexStart + this.indexCount; index += 2) {
                const p0 = positions[indices[index]];
                const p1 = positions[indices[index + 1]];
                const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
                if (length < 0) {
                    continue;
                }
                if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
                    intersectInfo = new IntersectionInfo(null, null, length);
                    intersectInfo.faceId = index / 2;
                    if (fastCheck) {
                        break;
                    }
                }
            }
            return intersectInfo;
        }
        /**
         * @internal
         */
        _intersectUnIndexedLines(ray, positions, indices, intersectionThreshold, fastCheck) {
            let intersectInfo = null;
            // Line test
            for (let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 2) {
                const p0 = positions[index];
                const p1 = positions[index + 1];
                const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
                if (length < 0) {
                    continue;
                }
                if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
                    intersectInfo = new IntersectionInfo(null, null, length);
                    intersectInfo.faceId = index / 2;
                    if (fastCheck) {
                        break;
                    }
                }
            }
            return intersectInfo;
        }
        /**
         * @internal
         */
        _intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate) {
            let intersectInfo = null;
            // Triangles test
            let faceId = -1;
            for (let index = this.indexStart; index < this.indexStart + this.indexCount - (3 - step); index += step) {
                faceId++;
                const indexA = indices[index];
                const indexB = indices[index + 1];
                const indexC = indices[index + 2];
                if (checkStopper && indexC === 0xffffffff) {
                    index += 2;
                    continue;
                }
                const p0 = positions[indexA];
                const p1 = positions[indexB];
                const p2 = positions[indexC];
                // stay defensive and don't check against undefined positions.
                if (!p0 || !p1 || !p2) {
                    continue;
                }
                if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, indexA, indexB, indexC)) {
                    continue;
                }
                const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
                if (currentIntersectInfo) {
                    if (currentIntersectInfo.distance < 0) {
                        continue;
                    }
                    if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                        intersectInfo = currentIntersectInfo;
                        intersectInfo.faceId = faceId;
                        if (fastCheck) {
                            break;
                        }
                    }
                }
            }
            return intersectInfo;
        }
        /**
         * @internal
         */
        _intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate) {
            let intersectInfo = null;
            // Triangles test
            for (let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 3) {
                const p0 = positions[index];
                const p1 = positions[index + 1];
                const p2 = positions[index + 2];
                if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, -1, -1, -1)) {
                    continue;
                }
                const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
                if (currentIntersectInfo) {
                    if (currentIntersectInfo.distance < 0) {
                        continue;
                    }
                    if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                        intersectInfo = currentIntersectInfo;
                        intersectInfo.faceId = index / 3;
                        if (fastCheck) {
                            break;
                        }
                    }
                }
            }
            return intersectInfo;
        }
        /** @internal */
        _rebuild() {
            if (this._linesIndexBuffer) {
                this._linesIndexBuffer = null;
            }
        }
        // Clone
        /**
         * Creates a new submesh from the passed mesh
         * @param newMesh defines the new hosting mesh
         * @param newRenderingMesh defines an optional rendering mesh
         * @returns the new submesh
         */
        clone(newMesh, newRenderingMesh) {
            const result = new SubMesh(this.materialIndex, this.verticesStart, this.verticesCount, this.indexStart, this.indexCount, newMesh, newRenderingMesh, false);
            if (!this.IsGlobal) {
                const boundingInfo = this.getBoundingInfo();
                if (!boundingInfo) {
                    return result;
                }
                result._boundingInfo = new BoundingInfo(boundingInfo.minimum, boundingInfo.maximum);
            }
            return result;
        }
        // Dispose
        /**
         * Release associated resources
         */
        dispose() {
            if (this._linesIndexBuffer) {
                this._mesh.getScene().getEngine()._releaseBuffer(this._linesIndexBuffer);
                this._linesIndexBuffer = null;
            }
            // Remove from mesh
            const index = this._mesh.subMeshes.indexOf(this);
            this._mesh.subMeshes.splice(index, 1);
            this.resetDrawCache();
        }
        /**
         * Gets the class name
         * @returns the string "SubMesh".
         */
        getClassName() {
            return "SubMesh";
        }
        // Statics
        /**
         * Creates a new submesh from indices data
         * @param materialIndex the index of the main mesh material
         * @param startIndex the index where to start the copy in the mesh indices array
         * @param indexCount the number of indices to copy then from the startIndex
         * @param mesh the main mesh to create the submesh from
         * @param renderingMesh the optional rendering mesh
         * @param createBoundingBox defines if bounding box should be created for this submesh
         * @returns a new submesh
         */
        static CreateFromIndices(materialIndex, startIndex, indexCount, mesh, renderingMesh, createBoundingBox = true) {
            let minVertexIndex = Number.MAX_VALUE;
            let maxVertexIndex = -Number.MAX_VALUE;
            const whatWillRender = renderingMesh || mesh;
            const indices = whatWillRender.getIndices();
            for (let index = startIndex; index < startIndex + indexCount; index++) {
                const vertexIndex = indices[index];
                if (vertexIndex < minVertexIndex) {
                    minVertexIndex = vertexIndex;
                }
                if (vertexIndex > maxVertexIndex) {
                    maxVertexIndex = vertexIndex;
                }
            }
            return new SubMesh(materialIndex, minVertexIndex, maxVertexIndex - minVertexIndex + 1, startIndex, indexCount, mesh, renderingMesh, createBoundingBox);
        }
    }

    /** Class used to attach material info to sub section of a vertex data class */
    class VertexDataMaterialInfo {
    }
    /**
     * This class contains the various kinds of data on every vertex of a mesh used in determining its shape and appearance
     */
    class VertexData {
        constructor() {
            this._applyTo = makeSyncFunction(this._applyToCoroutine.bind(this));
        }
        /**
         * Uses the passed data array to set the set the values for the specified kind of data
         * @param data a linear array of floating numbers
         * @param kind the type of data that is being set, eg positions, colors etc
         */
        set(data, kind) {
            if (!data.length) {
                Logger.Warn(`Setting vertex data kind '${kind}' with an empty array`);
            }
            switch (kind) {
                case VertexBuffer.PositionKind:
                    this.positions = data;
                    break;
                case VertexBuffer.NormalKind:
                    this.normals = data;
                    break;
                case VertexBuffer.TangentKind:
                    this.tangents = data;
                    break;
                case VertexBuffer.UVKind:
                    this.uvs = data;
                    break;
                case VertexBuffer.UV2Kind:
                    this.uvs2 = data;
                    break;
                case VertexBuffer.UV3Kind:
                    this.uvs3 = data;
                    break;
                case VertexBuffer.UV4Kind:
                    this.uvs4 = data;
                    break;
                case VertexBuffer.UV5Kind:
                    this.uvs5 = data;
                    break;
                case VertexBuffer.UV6Kind:
                    this.uvs6 = data;
                    break;
                case VertexBuffer.ColorKind:
                    this.colors = data;
                    break;
                case VertexBuffer.MatricesIndicesKind:
                    this.matricesIndices = data;
                    break;
                case VertexBuffer.MatricesWeightsKind:
                    this.matricesWeights = data;
                    break;
                case VertexBuffer.MatricesIndicesExtraKind:
                    this.matricesIndicesExtra = data;
                    break;
                case VertexBuffer.MatricesWeightsExtraKind:
                    this.matricesWeightsExtra = data;
                    break;
            }
        }
        /**
         * Associates the vertexData to the passed Mesh.
         * Sets it as updatable or not (default `false`)
         * @param mesh the mesh the vertexData is applied to
         * @param updatable when used and having the value true allows new data to update the vertexData
         * @returns the VertexData
         */
        applyToMesh(mesh, updatable) {
            this._applyTo(mesh, updatable, false);
            return this;
        }
        /**
         * Associates the vertexData to the passed Geometry.
         * Sets it as updatable or not (default `false`)
         * @param geometry the geometry the vertexData is applied to
         * @param updatable when used and having the value true allows new data to update the vertexData
         * @returns VertexData
         */
        applyToGeometry(geometry, updatable) {
            this._applyTo(geometry, updatable, false);
            return this;
        }
        /**
         * Updates the associated mesh
         * @param mesh the mesh to be updated
         * @returns VertexData
         */
        updateMesh(mesh) {
            this._update(mesh);
            return this;
        }
        /**
         * Updates the associated geometry
         * @param geometry the geometry to be updated
         * @returns VertexData.
         */
        updateGeometry(geometry) {
            this._update(geometry);
            return this;
        }
        /**
         * @internal
         */
        *_applyToCoroutine(meshOrGeometry, updatable = false, isAsync) {
            if (this.positions) {
                meshOrGeometry.setVerticesData(VertexBuffer.PositionKind, this.positions, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.normals) {
                meshOrGeometry.setVerticesData(VertexBuffer.NormalKind, this.normals, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.tangents) {
                meshOrGeometry.setVerticesData(VertexBuffer.TangentKind, this.tangents, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.uvs) {
                meshOrGeometry.setVerticesData(VertexBuffer.UVKind, this.uvs, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.uvs2) {
                meshOrGeometry.setVerticesData(VertexBuffer.UV2Kind, this.uvs2, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.uvs3) {
                meshOrGeometry.setVerticesData(VertexBuffer.UV3Kind, this.uvs3, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.uvs4) {
                meshOrGeometry.setVerticesData(VertexBuffer.UV4Kind, this.uvs4, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.uvs5) {
                meshOrGeometry.setVerticesData(VertexBuffer.UV5Kind, this.uvs5, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.uvs6) {
                meshOrGeometry.setVerticesData(VertexBuffer.UV6Kind, this.uvs6, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.colors) {
                meshOrGeometry.setVerticesData(VertexBuffer.ColorKind, this.colors, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.matricesIndices) {
                meshOrGeometry.setVerticesData(VertexBuffer.MatricesIndicesKind, this.matricesIndices, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.matricesWeights) {
                meshOrGeometry.setVerticesData(VertexBuffer.MatricesWeightsKind, this.matricesWeights, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.matricesIndicesExtra) {
                meshOrGeometry.setVerticesData(VertexBuffer.MatricesIndicesExtraKind, this.matricesIndicesExtra, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.matricesWeightsExtra) {
                meshOrGeometry.setVerticesData(VertexBuffer.MatricesWeightsExtraKind, this.matricesWeightsExtra, updatable);
                if (isAsync) {
                    yield;
                }
            }
            if (this.indices) {
                meshOrGeometry.setIndices(this.indices, null, updatable);
                if (isAsync) {
                    yield;
                }
            }
            else {
                meshOrGeometry.setIndices([], null);
            }
            if (meshOrGeometry.subMeshes && this.materialInfos && this.materialInfos.length > 1) {
                const mesh = meshOrGeometry;
                mesh.subMeshes = [];
                for (const matInfo of this.materialInfos) {
                    new SubMesh(matInfo.materialIndex, matInfo.verticesStart, matInfo.verticesCount, matInfo.indexStart, matInfo.indexCount, mesh);
                }
            }
            return this;
        }
        _update(meshOrGeometry, updateExtends, makeItUnique) {
            if (this.positions) {
                meshOrGeometry.updateVerticesData(VertexBuffer.PositionKind, this.positions, updateExtends, makeItUnique);
            }
            if (this.normals) {
                meshOrGeometry.updateVerticesData(VertexBuffer.NormalKind, this.normals, updateExtends, makeItUnique);
            }
            if (this.tangents) {
                meshOrGeometry.updateVerticesData(VertexBuffer.TangentKind, this.tangents, updateExtends, makeItUnique);
            }
            if (this.uvs) {
                meshOrGeometry.updateVerticesData(VertexBuffer.UVKind, this.uvs, updateExtends, makeItUnique);
            }
            if (this.uvs2) {
                meshOrGeometry.updateVerticesData(VertexBuffer.UV2Kind, this.uvs2, updateExtends, makeItUnique);
            }
            if (this.uvs3) {
                meshOrGeometry.updateVerticesData(VertexBuffer.UV3Kind, this.uvs3, updateExtends, makeItUnique);
            }
            if (this.uvs4) {
                meshOrGeometry.updateVerticesData(VertexBuffer.UV4Kind, this.uvs4, updateExtends, makeItUnique);
            }
            if (this.uvs5) {
                meshOrGeometry.updateVerticesData(VertexBuffer.UV5Kind, this.uvs5, updateExtends, makeItUnique);
            }
            if (this.uvs6) {
                meshOrGeometry.updateVerticesData(VertexBuffer.UV6Kind, this.uvs6, updateExtends, makeItUnique);
            }
            if (this.colors) {
                meshOrGeometry.updateVerticesData(VertexBuffer.ColorKind, this.colors, updateExtends, makeItUnique);
            }
            if (this.matricesIndices) {
                meshOrGeometry.updateVerticesData(VertexBuffer.MatricesIndicesKind, this.matricesIndices, updateExtends, makeItUnique);
            }
            if (this.matricesWeights) {
                meshOrGeometry.updateVerticesData(VertexBuffer.MatricesWeightsKind, this.matricesWeights, updateExtends, makeItUnique);
            }
            if (this.matricesIndicesExtra) {
                meshOrGeometry.updateVerticesData(VertexBuffer.MatricesIndicesExtraKind, this.matricesIndicesExtra, updateExtends, makeItUnique);
            }
            if (this.matricesWeightsExtra) {
                meshOrGeometry.updateVerticesData(VertexBuffer.MatricesWeightsExtraKind, this.matricesWeightsExtra, updateExtends, makeItUnique);
            }
            if (this.indices) {
                meshOrGeometry.setIndices(this.indices, null);
            }
            return this;
        }
        static _TransformVector3Coordinates(coordinates, transformation, offset = 0, length = coordinates.length) {
            const coordinate = TmpVectors.Vector3[0];
            const transformedCoordinate = TmpVectors.Vector3[1];
            for (let index = offset; index < offset + length; index += 3) {
                Vector3.FromArrayToRef(coordinates, index, coordinate);
                Vector3.TransformCoordinatesToRef(coordinate, transformation, transformedCoordinate);
                coordinates[index] = transformedCoordinate.x;
                coordinates[index + 1] = transformedCoordinate.y;
                coordinates[index + 2] = transformedCoordinate.z;
            }
        }
        static _TransformVector3Normals(normals, transformation, offset = 0, length = normals.length) {
            const normal = TmpVectors.Vector3[0];
            const transformedNormal = TmpVectors.Vector3[1];
            for (let index = offset; index < offset + length; index += 3) {
                Vector3.FromArrayToRef(normals, index, normal);
                Vector3.TransformNormalToRef(normal, transformation, transformedNormal);
                normals[index] = transformedNormal.x;
                normals[index + 1] = transformedNormal.y;
                normals[index + 2] = transformedNormal.z;
            }
        }
        static _TransformVector4Normals(normals, transformation, offset = 0, length = normals.length) {
            const normal = TmpVectors.Vector4[0];
            const transformedNormal = TmpVectors.Vector4[1];
            for (let index = offset; index < offset + length; index += 4) {
                Vector4.FromArrayToRef(normals, index, normal);
                Vector4.TransformNormalToRef(normal, transformation, transformedNormal);
                normals[index] = transformedNormal.x;
                normals[index + 1] = transformedNormal.y;
                normals[index + 2] = transformedNormal.z;
                normals[index + 3] = transformedNormal.w;
            }
        }
        static _FlipFaces(indices, offset = 0, length = indices.length) {
            for (let index = offset; index < offset + length; index += 3) {
                const tmp = indices[index + 1];
                indices[index + 1] = indices[index + 2];
                indices[index + 2] = tmp;
            }
        }
        /**
         * Transforms each position and each normal of the vertexData according to the passed Matrix
         * @param matrix the transforming matrix
         * @returns the VertexData
         */
        transform(matrix) {
            const flip = matrix.determinant() < 0;
            if (this.positions) {
                VertexData._TransformVector3Coordinates(this.positions, matrix);
            }
            if (this.normals) {
                VertexData._TransformVector3Normals(this.normals, matrix);
            }
            if (this.tangents) {
                VertexData._TransformVector4Normals(this.tangents, matrix);
            }
            if (flip && this.indices) {
                VertexData._FlipFaces(this.indices);
            }
            return this;
        }
        /**
         * Generates an array of vertex data where each vertex data only has one material info
         * @returns An array of VertexData
         */
        splitBasedOnMaterialID() {
            if (!this.materialInfos || this.materialInfos.length < 2) {
                return [this];
            }
            const result = new Array();
            for (const materialInfo of this.materialInfos) {
                const vertexData = new VertexData();
                if (this.positions) {
                    vertexData.positions = this.positions.slice(materialInfo.verticesStart * 3, (materialInfo.verticesCount + materialInfo.verticesStart) * 3);
                }
                if (this.normals) {
                    vertexData.normals = this.normals.slice(materialInfo.verticesStart * 3, (materialInfo.verticesCount + materialInfo.verticesStart) * 3);
                }
                if (this.tangents) {
                    vertexData.tangents = this.tangents.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
                }
                if (this.colors) {
                    vertexData.colors = this.colors.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
                }
                if (this.uvs) {
                    vertexData.uvs = this.uvs.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
                }
                if (this.uvs2) {
                    vertexData.uvs2 = this.uvs2.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
                }
                if (this.uvs3) {
                    vertexData.uvs3 = this.uvs3.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
                }
                if (this.uvs4) {
                    vertexData.uvs4 = this.uvs4.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
                }
                if (this.uvs5) {
                    vertexData.uvs5 = this.uvs5.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
                }
                if (this.uvs6) {
                    vertexData.uvs6 = this.uvs6.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
                }
                if (this.matricesIndices) {
                    vertexData.matricesIndices = this.matricesIndices.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
                }
                if (this.matricesIndicesExtra) {
                    vertexData.matricesIndicesExtra = this.matricesIndicesExtra.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
                }
                if (this.matricesWeights) {
                    vertexData.matricesWeights = this.matricesWeights.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
                }
                if (this.matricesWeightsExtra) {
                    vertexData.matricesWeightsExtra = this.matricesWeightsExtra.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
                }
                if (this.indices) {
                    vertexData.indices = [];
                    for (let index = materialInfo.indexStart; index < materialInfo.indexStart + materialInfo.indexCount; index++) {
                        vertexData.indices.push(this.indices[index] - materialInfo.verticesStart);
                    }
                }
                const newMaterialInfo = new VertexDataMaterialInfo();
                newMaterialInfo.indexStart = 0;
                newMaterialInfo.indexCount = vertexData.indices ? vertexData.indices.length : 0;
                newMaterialInfo.materialIndex = materialInfo.materialIndex;
                newMaterialInfo.verticesStart = 0;
                newMaterialInfo.verticesCount = (vertexData.positions ? vertexData.positions.length : 0) / 3;
                vertexData.materialInfos = [newMaterialInfo];
                result.push(vertexData);
            }
            return result;
        }
        /**
         * Merges the passed VertexData into the current one
         * @param others the VertexData to be merged into the current one
         * @param use32BitsIndices defines a boolean indicating if indices must be store in a 32 bits array
         * @param forceCloneIndices defines a boolean indicating if indices are forced to be cloned
         * @param mergeMaterialIds defines a boolean indicating if we need to merge the material infos
         * @param enableCompletion defines a boolean indicating if the vertex data should be completed to be compatible
         * @returns the modified VertexData
         */
        merge(others, use32BitsIndices = false, forceCloneIndices = false, mergeMaterialIds = false, enableCompletion = false) {
            const vertexDatas = Array.isArray(others)
                ? others.map((other) => {
                    return { vertexData: other };
                })
                : [{ vertexData: others }];
            return runCoroutineSync(this._mergeCoroutine(undefined, vertexDatas, use32BitsIndices, false, forceCloneIndices, mergeMaterialIds, enableCompletion));
        }
        /**
         * @internal
         */
        *_mergeCoroutine(transform, vertexDatas, use32BitsIndices = false, isAsync, forceCloneIndices, mergeMaterialIds = false, enableCompletion = false) {
            var _a, _b, _c, _d;
            this._validate();
            let others = vertexDatas.map((vertexData) => vertexData.vertexData);
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let root = this;
            for (const other of others) {
                if (!other) {
                    continue;
                }
                other._validate();
                if (!enableCompletion) {
                    if (!this.normals !== !other.normals ||
                        !this.tangents !== !other.tangents ||
                        !this.uvs !== !other.uvs ||
                        !this.uvs2 !== !other.uvs2 ||
                        !this.uvs3 !== !other.uvs3 ||
                        !this.uvs4 !== !other.uvs4 ||
                        !this.uvs5 !== !other.uvs5 ||
                        !this.uvs6 !== !other.uvs6 ||
                        !this.colors !== !other.colors ||
                        !this.matricesIndices !== !other.matricesIndices ||
                        !this.matricesWeights !== !other.matricesWeights ||
                        !this.matricesIndicesExtra !== !other.matricesIndicesExtra ||
                        !this.matricesWeightsExtra !== !other.matricesWeightsExtra) {
                        throw new Error("Cannot merge vertex data that do not have the same set of attributes");
                    }
                }
                else {
                    if (!this.normals !== !other.normals) {
                        if (!this.normals) {
                            this.normals = Array.from(other.normals);
                        }
                        else {
                            other.normals = Array.from(this.normals);
                        }
                    }
                    if (!this.tangents !== !other.tangents) {
                        if (!this.tangents) {
                            this.tangents = Array.from(other.tangents);
                        }
                        else {
                            other.tangents = Array.from(this.tangents);
                        }
                    }
                    if (!this.uvs !== !other.uvs) {
                        if (!this.uvs) {
                            this.uvs = Array.from(other.uvs);
                        }
                        else {
                            other.uvs = Array.from(this.uvs);
                        }
                    }
                    if (!this.uvs2 !== !other.uvs2) {
                        if (!this.uvs2) {
                            this.uvs2 = Array.from(other.uvs2);
                        }
                        else {
                            other.uvs2 = Array.from(this.uvs2);
                        }
                    }
                    if (!this.uvs3 !== !other.uvs3) {
                        if (!this.uvs3) {
                            this.uvs3 = Array.from(other.uvs3);
                        }
                        else {
                            other.uvs3 = Array.from(this.uvs3);
                        }
                    }
                    if (!this.uvs4 !== !other.uvs4) {
                        if (!this.uvs4) {
                            this.uvs4 = Array.from(other.uvs4);
                        }
                        else {
                            other.uvs4 = Array.from(this.uvs4);
                        }
                    }
                    if (!this.uvs5 !== !other.uvs5) {
                        if (!this.uvs5) {
                            this.uvs5 = Array.from(other.uvs5);
                        }
                        else {
                            other.uvs5 = Array.from(this.uvs5);
                        }
                    }
                    if (!this.uvs6 !== !other.uvs6) {
                        if (!this.uvs6) {
                            this.uvs6 = Array.from(other.uvs6);
                        }
                        else {
                            other.uvs6 = Array.from(this.uvs6);
                        }
                    }
                    if (!this.colors !== !other.colors) {
                        if (!this.colors) {
                            this.colors = Array.from(other.colors);
                        }
                        else {
                            other.colors = Array.from(this.colors);
                        }
                    }
                    if (!this.matricesIndices !== !other.matricesIndices) {
                        if (!this.matricesIndices) {
                            this.matricesIndices = Array.from(other.matricesIndices);
                        }
                        else {
                            other.matricesIndices = Array.from(this.matricesIndices);
                        }
                    }
                    if (!this.matricesWeights !== !other.matricesWeights) {
                        if (!this.matricesWeights) {
                            this.matricesWeights = Array.from(other.matricesWeights);
                        }
                        else {
                            other.matricesWeights = Array.from(this.matricesWeights);
                        }
                    }
                    if (!this.matricesIndicesExtra !== !other.matricesIndicesExtra) {
                        if (!this.matricesIndicesExtra) {
                            this.matricesIndicesExtra = Array.from(other.matricesIndicesExtra);
                        }
                        else {
                            other.matricesIndicesExtra = Array.from(this.matricesIndicesExtra);
                        }
                    }
                    if (!this.matricesWeightsExtra !== !other.matricesWeightsExtra) {
                        if (!this.matricesWeightsExtra) {
                            this.matricesWeightsExtra = Array.from(other.matricesWeightsExtra);
                        }
                        else {
                            other.matricesWeightsExtra = Array.from(this.matricesWeightsExtra);
                        }
                    }
                }
            }
            if (mergeMaterialIds) {
                // Merge material infos
                let materialIndex = 0;
                let indexOffset = 0;
                let vertexOffset = 0;
                const materialInfos = [];
                let currentMaterialInfo = null;
                const vertexDataList = [];
                // We need to split vertexData with more than one materialInfo
                for (const split of this.splitBasedOnMaterialID()) {
                    vertexDataList.push({ vertexData: split, transform: transform });
                }
                for (const vertexData of vertexDatas) {
                    for (const split of vertexData.vertexData.splitBasedOnMaterialID()) {
                        vertexDataList.push({ vertexData: split, transform: vertexData.transform });
                    }
                }
                // Sort by material IDs
                vertexDataList.sort((a, b) => {
                    const matInfoA = a.vertexData.materialInfos ? a.vertexData.materialInfos[0].materialIndex : 0;
                    const matInfoB = b.vertexData.materialInfos ? b.vertexData.materialInfos[0].materialIndex : 0;
                    if (matInfoA > matInfoB) {
                        return 1;
                    }
                    if (matInfoA === matInfoB) {
                        return 0;
                    }
                    return -1;
                });
                // Build the new material info
                for (const vertexDataSource of vertexDataList) {
                    const vertexData = vertexDataSource.vertexData;
                    if (vertexData.materialInfos) {
                        materialIndex = vertexData.materialInfos[0].materialIndex;
                    }
                    else {
                        materialIndex = 0;
                    }
                    if (currentMaterialInfo && currentMaterialInfo.materialIndex === materialIndex) {
                        currentMaterialInfo.indexCount += vertexData.indices.length;
                        currentMaterialInfo.verticesCount += vertexData.positions.length / 3;
                    }
                    else {
                        const materialInfo = new VertexDataMaterialInfo();
                        materialInfo.materialIndex = materialIndex;
                        materialInfo.indexStart = indexOffset;
                        materialInfo.indexCount = vertexData.indices.length;
                        materialInfo.verticesStart = vertexOffset;
                        materialInfo.verticesCount = vertexData.positions.length / 3;
                        materialInfos.push(materialInfo);
                        currentMaterialInfo = materialInfo;
                    }
                    indexOffset += vertexData.indices.length;
                    vertexOffset += vertexData.positions.length / 3;
                }
                // Extract sorted values
                const first = vertexDataList.splice(0, 1)[0];
                root = first.vertexData;
                transform = first.transform;
                others = vertexDataList.map((v) => v.vertexData);
                vertexDatas = vertexDataList;
                this.materialInfos = materialInfos;
            }
            // Merge geometries
            const totalIndices = others.reduce((indexSum, vertexData) => { var _a, _b; return indexSum + ((_b = (_a = vertexData.indices) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); }, (_b = (_a = root.indices) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
            const sliceIndices = forceCloneIndices || others.some((vertexData) => vertexData.indices === root.indices);
            let indices = sliceIndices ? (_c = root.indices) === null || _c === void 0 ? void 0 : _c.slice() : root.indices;
            if (totalIndices > 0) {
                let indicesOffset = (_d = indices === null || indices === void 0 ? void 0 : indices.length) !== null && _d !== void 0 ? _d : 0;
                if (!indices) {
                    indices = new Array(totalIndices);
                }
                if (indices.length !== totalIndices) {
                    if (Array.isArray(indices)) {
                        indices.length = totalIndices;
                    }
                    else {
                        const temp = use32BitsIndices || indices instanceof Uint32Array ? new Uint32Array(totalIndices) : new Uint16Array(totalIndices);
                        temp.set(indices);
                        indices = temp;
                    }
                    if (transform && transform.determinant() < 0) {
                        VertexData._FlipFaces(indices, 0, indicesOffset);
                    }
                }
                let positionsOffset = root.positions ? root.positions.length / 3 : 0;
                for (const { vertexData: other, transform } of vertexDatas) {
                    if (other.indices) {
                        for (let index = 0; index < other.indices.length; index++) {
                            indices[indicesOffset + index] = other.indices[index] + positionsOffset;
                        }
                        if (transform && transform.determinant() < 0) {
                            VertexData._FlipFaces(indices, indicesOffset, other.indices.length);
                        }
                        // The call to _validate already checked for positions
                        positionsOffset += other.positions.length / 3;
                        indicesOffset += other.indices.length;
                        if (isAsync) {
                            yield;
                        }
                    }
                }
            }
            this.indices = indices;
            this.positions = VertexData._MergeElement(VertexBuffer.PositionKind, root.positions, transform, vertexDatas.map((other) => [other.vertexData.positions, other.transform]));
            if (isAsync) {
                yield;
            }
            if (root.normals) {
                this.normals = VertexData._MergeElement(VertexBuffer.NormalKind, root.normals, transform, vertexDatas.map((other) => [other.vertexData.normals, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.tangents) {
                this.tangents = VertexData._MergeElement(VertexBuffer.TangentKind, root.tangents, transform, vertexDatas.map((other) => [other.vertexData.tangents, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.uvs) {
                this.uvs = VertexData._MergeElement(VertexBuffer.UVKind, root.uvs, transform, vertexDatas.map((other) => [other.vertexData.uvs, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.uvs2) {
                this.uvs2 = VertexData._MergeElement(VertexBuffer.UV2Kind, root.uvs2, transform, vertexDatas.map((other) => [other.vertexData.uvs2, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.uvs3) {
                this.uvs3 = VertexData._MergeElement(VertexBuffer.UV3Kind, root.uvs3, transform, vertexDatas.map((other) => [other.vertexData.uvs3, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.uvs4) {
                this.uvs4 = VertexData._MergeElement(VertexBuffer.UV4Kind, root.uvs4, transform, vertexDatas.map((other) => [other.vertexData.uvs4, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.uvs5) {
                this.uvs5 = VertexData._MergeElement(VertexBuffer.UV5Kind, root.uvs5, transform, vertexDatas.map((other) => [other.vertexData.uvs5, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.uvs6) {
                this.uvs6 = VertexData._MergeElement(VertexBuffer.UV6Kind, root.uvs6, transform, vertexDatas.map((other) => [other.vertexData.uvs6, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.colors) {
                this.colors = VertexData._MergeElement(VertexBuffer.ColorKind, root.colors, transform, vertexDatas.map((other) => [other.vertexData.colors, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.matricesIndices) {
                this.matricesIndices = VertexData._MergeElement(VertexBuffer.MatricesIndicesKind, root.matricesIndices, transform, vertexDatas.map((other) => [other.vertexData.matricesIndices, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.matricesWeights) {
                this.matricesWeights = VertexData._MergeElement(VertexBuffer.MatricesWeightsKind, root.matricesWeights, transform, vertexDatas.map((other) => [other.vertexData.matricesWeights, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.matricesIndicesExtra) {
                this.matricesIndicesExtra = VertexData._MergeElement(VertexBuffer.MatricesIndicesExtraKind, root.matricesIndicesExtra, transform, vertexDatas.map((other) => [other.vertexData.matricesIndicesExtra, other.transform]));
                if (isAsync) {
                    yield;
                }
            }
            if (root.matricesWeightsExtra) {
                this.matricesWeightsExtra = VertexData._MergeElement(VertexBuffer.MatricesWeightsExtraKind, root.matricesWeightsExtra, transform, vertexDatas.map((other) => [other.vertexData.matricesWeightsExtra, other.transform]));
            }
            return this;
        }
        static _MergeElement(kind, source, transform, others) {
            const nonNullOthers = others.filter((other) => other[0] !== null && other[0] !== undefined);
            // If there is no source to copy and no other non-null sources then skip this element.
            if (!source && nonNullOthers.length == 0) {
                return source;
            }
            if (!source) {
                return this._MergeElement(kind, nonNullOthers[0][0], nonNullOthers[0][1], nonNullOthers.slice(1));
            }
            const len = nonNullOthers.reduce((sumLen, elements) => sumLen + elements[0].length, source.length);
            const transformRange = kind === VertexBuffer.PositionKind
                ? VertexData._TransformVector3Coordinates
                : kind === VertexBuffer.NormalKind
                    ? VertexData._TransformVector3Normals
                    : kind === VertexBuffer.TangentKind
                        ? VertexData._TransformVector4Normals
                        : () => { };
            if (source instanceof Float32Array) {
                // use non-loop method when the source is Float32Array
                const ret32 = new Float32Array(len);
                ret32.set(source);
                transform && transformRange(ret32, transform, 0, source.length);
                let offset = source.length;
                for (const [vertexData, transform] of nonNullOthers) {
                    ret32.set(vertexData, offset);
                    transform && transformRange(ret32, transform, offset, vertexData.length);
                    offset += vertexData.length;
                }
                return ret32;
            }
            else {
                // don't use concat as it is super slow, just loop for other cases
                const ret = new Array(len);
                for (let i = 0; i < source.length; i++) {
                    ret[i] = source[i];
                }
                transform && transformRange(ret, transform, 0, source.length);
                let offset = source.length;
                for (const [vertexData, transform] of nonNullOthers) {
                    for (let i = 0; i < vertexData.length; i++) {
                        ret[offset + i] = vertexData[i];
                    }
                    transform && transformRange(ret, transform, offset, vertexData.length);
                    offset += vertexData.length;
                }
                return ret;
            }
        }
        _validate() {
            if (!this.positions) {
                throw new RuntimeError("Positions are required", ErrorCodes.MeshInvalidPositionsError);
            }
            const getElementCount = (kind, values) => {
                const stride = VertexBuffer.DeduceStride(kind);
                if (values.length % stride !== 0) {
                    throw new Error("The " + kind + "s array count must be a multiple of " + stride);
                }
                return values.length / stride;
            };
            const positionsElementCount = getElementCount(VertexBuffer.PositionKind, this.positions);
            const validateElementCount = (kind, values) => {
                const elementCount = getElementCount(kind, values);
                if (elementCount !== positionsElementCount) {
                    throw new Error("The " + kind + "s element count (" + elementCount + ") does not match the positions count (" + positionsElementCount + ")");
                }
            };
            if (this.normals) {
                validateElementCount(VertexBuffer.NormalKind, this.normals);
            }
            if (this.tangents) {
                validateElementCount(VertexBuffer.TangentKind, this.tangents);
            }
            if (this.uvs) {
                validateElementCount(VertexBuffer.UVKind, this.uvs);
            }
            if (this.uvs2) {
                validateElementCount(VertexBuffer.UV2Kind, this.uvs2);
            }
            if (this.uvs3) {
                validateElementCount(VertexBuffer.UV3Kind, this.uvs3);
            }
            if (this.uvs4) {
                validateElementCount(VertexBuffer.UV4Kind, this.uvs4);
            }
            if (this.uvs5) {
                validateElementCount(VertexBuffer.UV5Kind, this.uvs5);
            }
            if (this.uvs6) {
                validateElementCount(VertexBuffer.UV6Kind, this.uvs6);
            }
            if (this.colors) {
                validateElementCount(VertexBuffer.ColorKind, this.colors);
            }
            if (this.matricesIndices) {
                validateElementCount(VertexBuffer.MatricesIndicesKind, this.matricesIndices);
            }
            if (this.matricesWeights) {
                validateElementCount(VertexBuffer.MatricesWeightsKind, this.matricesWeights);
            }
            if (this.matricesIndicesExtra) {
                validateElementCount(VertexBuffer.MatricesIndicesExtraKind, this.matricesIndicesExtra);
            }
            if (this.matricesWeightsExtra) {
                validateElementCount(VertexBuffer.MatricesWeightsExtraKind, this.matricesWeightsExtra);
            }
        }
        /**
         * Clone the current vertex data
         * @returns a copy of the current data
         */
        clone() {
            const serializationObject = this.serialize();
            return VertexData.Parse(serializationObject);
        }
        /**
         * Serializes the VertexData
         * @returns a serialized object
         */
        serialize() {
            const serializationObject = {};
            if (this.positions) {
                serializationObject.positions = Array.from(this.positions);
            }
            if (this.normals) {
                serializationObject.normals = Array.from(this.normals);
            }
            if (this.tangents) {
                serializationObject.tangents = Array.from(this.tangents);
            }
            if (this.uvs) {
                serializationObject.uvs = Array.from(this.uvs);
            }
            if (this.uvs2) {
                serializationObject.uvs2 = Array.from(this.uvs2);
            }
            if (this.uvs3) {
                serializationObject.uvs3 = Array.from(this.uvs3);
            }
            if (this.uvs4) {
                serializationObject.uvs4 = Array.from(this.uvs4);
            }
            if (this.uvs5) {
                serializationObject.uvs5 = Array.from(this.uvs5);
            }
            if (this.uvs6) {
                serializationObject.uvs6 = Array.from(this.uvs6);
            }
            if (this.colors) {
                serializationObject.colors = Array.from(this.colors);
            }
            if (this.matricesIndices) {
                serializationObject.matricesIndices = Array.from(this.matricesIndices);
                serializationObject.matricesIndices._isExpanded = true;
            }
            if (this.matricesWeights) {
                serializationObject.matricesWeights = Array.from(this.matricesWeights);
            }
            if (this.matricesIndicesExtra) {
                serializationObject.matricesIndicesExtra = Array.from(this.matricesIndicesExtra);
                serializationObject.matricesIndicesExtra._isExpanded = true;
            }
            if (this.matricesWeightsExtra) {
                serializationObject.matricesWeightsExtra = Array.from(this.matricesWeightsExtra);
            }
            serializationObject.indices = Array.from(this.indices);
            if (this.materialInfos) {
                serializationObject.materialInfos = [];
                for (const materialInfo of this.materialInfos) {
                    const materialInfoSerializationObject = {
                        indexStart: materialInfo.indexStart,
                        indexCount: materialInfo.indexCount,
                        materialIndex: materialInfo.materialIndex,
                        verticesStart: materialInfo.verticesStart,
                        verticesCount: materialInfo.verticesCount,
                    };
                    serializationObject.materialInfos.push(materialInfoSerializationObject);
                }
            }
            return serializationObject;
        }
        // Statics
        /**
         * Extracts the vertexData from a mesh
         * @param mesh the mesh from which to extract the VertexData
         * @param copyWhenShared defines if the VertexData must be cloned when shared between multiple meshes, optional, default false
         * @param forceCopy indicating that the VertexData must be cloned, optional, default false
         * @returns the object VertexData associated to the passed mesh
         */
        static ExtractFromMesh(mesh, copyWhenShared, forceCopy) {
            return VertexData._ExtractFrom(mesh, copyWhenShared, forceCopy);
        }
        /**
         * Extracts the vertexData from the geometry
         * @param geometry the geometry from which to extract the VertexData
         * @param copyWhenShared defines if the VertexData must be cloned when the geometry is shared between multiple meshes, optional, default false
         * @param forceCopy indicating that the VertexData must be cloned, optional, default false
         * @returns the object VertexData associated to the passed mesh
         */
        static ExtractFromGeometry(geometry, copyWhenShared, forceCopy) {
            return VertexData._ExtractFrom(geometry, copyWhenShared, forceCopy);
        }
        static _ExtractFrom(meshOrGeometry, copyWhenShared, forceCopy) {
            const result = new VertexData();
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.PositionKind)) {
                result.positions = meshOrGeometry.getVerticesData(VertexBuffer.PositionKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                result.normals = meshOrGeometry.getVerticesData(VertexBuffer.NormalKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.TangentKind)) {
                result.tangents = meshOrGeometry.getVerticesData(VertexBuffer.TangentKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.UVKind)) {
                result.uvs = meshOrGeometry.getVerticesData(VertexBuffer.UVKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.UV2Kind)) {
                result.uvs2 = meshOrGeometry.getVerticesData(VertexBuffer.UV2Kind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.UV3Kind)) {
                result.uvs3 = meshOrGeometry.getVerticesData(VertexBuffer.UV3Kind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.UV4Kind)) {
                result.uvs4 = meshOrGeometry.getVerticesData(VertexBuffer.UV4Kind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.UV5Kind)) {
                result.uvs5 = meshOrGeometry.getVerticesData(VertexBuffer.UV5Kind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.UV6Kind)) {
                result.uvs6 = meshOrGeometry.getVerticesData(VertexBuffer.UV6Kind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.ColorKind)) {
                result.colors = meshOrGeometry.getVerticesData(VertexBuffer.ColorKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.MatricesIndicesKind)) {
                result.matricesIndices = meshOrGeometry.getVerticesData(VertexBuffer.MatricesIndicesKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.MatricesWeightsKind)) {
                result.matricesWeights = meshOrGeometry.getVerticesData(VertexBuffer.MatricesWeightsKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.MatricesIndicesExtraKind)) {
                result.matricesIndicesExtra = meshOrGeometry.getVerticesData(VertexBuffer.MatricesIndicesExtraKind, copyWhenShared, forceCopy);
            }
            if (meshOrGeometry.isVerticesDataPresent(VertexBuffer.MatricesWeightsExtraKind)) {
                result.matricesWeightsExtra = meshOrGeometry.getVerticesData(VertexBuffer.MatricesWeightsExtraKind, copyWhenShared, forceCopy);
            }
            result.indices = meshOrGeometry.getIndices(copyWhenShared, forceCopy);
            return result;
        }
        /**
         * Creates the VertexData for a Ribbon
         * @param options an object used to set the following optional parameters for the ribbon, required but can be empty
         * * pathArray array of paths, each of which an array of successive Vector3
         * * closeArray creates a seam between the first and the last paths of the pathArray, optional, default false
         * * closePath creates a seam between the first and the last points of each path of the path array, optional, default false
         * * offset a positive integer, only used when pathArray contains a single path (offset = 10 means the point 1 is joined to the point 11), default rounded half size of the pathArray length
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * * invertUV swaps in the U and V coordinates when applying a texture, optional, default false
         * * uvs a linear array, of length 2 * number of vertices, of custom UV values, optional
         * * colors a linear array, of length 4 * number of vertices, of custom color values, optional
         * @param options.pathArray
         * @param options.closeArray
         * @param options.closePath
         * @param options.offset
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @param options.invertUV
         * @param options.uvs
         * @param options.colors
         * @returns the VertexData of the ribbon
         * @deprecated use CreateRibbonVertexData instead
         */
        static CreateRibbon(options) {
            throw _WarnImport("ribbonBuilder");
        }
        /**
         * Creates the VertexData for a box
         * @param options an object used to set the following optional parameters for the box, required but can be empty
         * * size sets the width, height and depth of the box to the value of size, optional default 1
         * * width sets the width (x direction) of the box, overwrites the width set by size, optional, default size
         * * height sets the height (y direction) of the box, overwrites the height set by size, optional, default size
         * * depth sets the depth (z direction) of the box, overwrites the depth set by size, optional, default size
         * * faceUV an array of 6 Vector4 elements used to set different images to each box side
         * * faceColors an array of 6 Color3 elements used to set different colors to each box side
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.size
         * @param options.width
         * @param options.height
         * @param options.depth
         * @param options.faceUV
         * @param options.faceColors
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the box
         * @deprecated Please use CreateBoxVertexData from the BoxBuilder file instead
         */
        static CreateBox(options) {
            throw _WarnImport("boxBuilder");
        }
        /**
         * Creates the VertexData for a tiled box
         * @param options an object used to set the following optional parameters for the box, required but can be empty
         * * faceTiles sets the pattern, tile size and number of tiles for a face
         * * faceUV an array of 6 Vector4 elements used to set different images to each box side
         * * faceColors an array of 6 Color3 elements used to set different colors to each box side
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * @param options.pattern
         * @param options.width
         * @param options.height
         * @param options.depth
         * @param options.tileSize
         * @param options.tileWidth
         * @param options.tileHeight
         * @param options.alignHorizontal
         * @param options.alignVertical
         * @param options.faceUV
         * @param options.faceColors
         * @param options.sideOrientation
         * @returns the VertexData of the box
         * @deprecated Please use CreateTiledBoxVertexData instead
         */
        static CreateTiledBox(options) {
            throw _WarnImport("tiledBoxBuilder");
        }
        /**
         * Creates the VertexData for a tiled plane
         * @param options an object used to set the following optional parameters for the box, required but can be empty
         * * pattern a limited pattern arrangement depending on the number
         * * tileSize sets the width, height and depth of the tile to the value of size, optional default 1
         * * tileWidth sets the width (x direction) of the tile, overwrites the width set by size, optional, default size
         * * tileHeight sets the height (y direction) of the tile, overwrites the height set by size, optional, default size
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.pattern
         * @param options.tileSize
         * @param options.tileWidth
         * @param options.tileHeight
         * @param options.size
         * @param options.width
         * @param options.height
         * @param options.alignHorizontal
         * @param options.alignVertical
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the tiled plane
         * @deprecated use CreateTiledPlaneVertexData instead
         */
        static CreateTiledPlane(options) {
            throw _WarnImport("tiledPlaneBuilder");
        }
        /**
         * Creates the VertexData for an ellipsoid, defaults to a sphere
         * @param options an object used to set the following optional parameters for the box, required but can be empty
         * * segments sets the number of horizontal strips optional, default 32
         * * diameter sets the axes dimensions, diameterX, diameterY and diameterZ to the value of diameter, optional default 1
         * * diameterX sets the diameterX (x direction) of the ellipsoid, overwrites the diameterX set by diameter, optional, default diameter
         * * diameterY sets the diameterY (y direction) of the ellipsoid, overwrites the diameterY set by diameter, optional, default diameter
         * * diameterZ sets the diameterZ (z direction) of the ellipsoid, overwrites the diameterZ set by diameter, optional, default diameter
         * * arc a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the circumference (latitude) given by the arc value, optional, default 1
         * * slice a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the height (latitude) given by the arc value, optional, default 1
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.segments
         * @param options.diameter
         * @param options.diameterX
         * @param options.diameterY
         * @param options.diameterZ
         * @param options.arc
         * @param options.slice
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the ellipsoid
         * @deprecated use CreateSphereVertexData instead
         */
        static CreateSphere(options) {
            throw _WarnImport("sphereBuilder");
        }
        /**
         * Creates the VertexData for a cylinder, cone or prism
         * @param options an object used to set the following optional parameters for the box, required but can be empty
         * * height sets the height (y direction) of the cylinder, optional, default 2
         * * diameterTop sets the diameter of the top of the cone, overwrites diameter,  optional, default diameter
         * * diameterBottom sets the diameter of the bottom of the cone, overwrites diameter,  optional, default diameter
         * * diameter sets the diameter of the top and bottom of the cone, optional default 1
         * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
         * * subdivisions` the number of rings along the cylinder height, optional, default 1
         * * arc a number from 0 to 1, to create an unclosed cylinder based on the fraction of the circumference given by the arc value, optional, default 1
         * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
         * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
         * * hasRings when true makes each subdivision independently treated as a face for faceUV and faceColors, optional, default false
         * * enclose when true closes an open cylinder by adding extra flat faces between the height axis and vertical edges, think cut cake
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.height
         * @param options.diameterTop
         * @param options.diameterBottom
         * @param options.diameter
         * @param options.tessellation
         * @param options.subdivisions
         * @param options.arc
         * @param options.faceColors
         * @param options.faceUV
         * @param options.hasRings
         * @param options.enclose
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the cylinder, cone or prism
         * @deprecated please use CreateCylinderVertexData instead
         */
        static CreateCylinder(options) {
            throw _WarnImport("cylinderBuilder");
        }
        /**
         * Creates the VertexData for a torus
         * @param options an object used to set the following optional parameters for the box, required but can be empty
         * * diameter the diameter of the torus, optional default 1
         * * thickness the diameter of the tube forming the torus, optional default 0.5
         * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.diameter
         * @param options.thickness
         * @param options.tessellation
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the torus
         * @deprecated use CreateTorusVertexData instead
         */
        static CreateTorus(options) {
            throw _WarnImport("torusBuilder");
        }
        /**
         * Creates the VertexData of the LineSystem
         * @param options an object used to set the following optional parameters for the LineSystem, required but can be empty
         *  - lines an array of lines, each line being an array of successive Vector3
         *  - colors an array of line colors, each of the line colors being an array of successive Color4, one per line point
         * @param options.lines
         * @param options.colors
         * @returns the VertexData of the LineSystem
         * @deprecated use CreateLineSystemVertexData instead
         */
        static CreateLineSystem(options) {
            throw _WarnImport("linesBuilder");
        }
        /**
         * Create the VertexData for a DashedLines
         * @param options an object used to set the following optional parameters for the DashedLines, required but can be empty
         *  - points an array successive Vector3
         *  - dashSize the size of the dashes relative to the dash number, optional, default 3
         *  - gapSize the size of the gap between two successive dashes relative to the dash number, optional, default 1
         *  - dashNb the intended total number of dashes, optional, default 200
         * @param options.points
         * @param options.dashSize
         * @param options.gapSize
         * @param options.dashNb
         * @returns the VertexData for the DashedLines
         * @deprecated use CreateDashedLinesVertexData instead
         */
        static CreateDashedLines(options) {
            throw _WarnImport("linesBuilder");
        }
        /**
         * Creates the VertexData for a Ground
         * @param options an object used to set the following optional parameters for the Ground, required but can be empty
         *  - width the width (x direction) of the ground, optional, default 1
         *  - height the height (z direction) of the ground, optional, default 1
         *  - subdivisions the number of subdivisions per side, optional, default 1
         * @param options.width
         * @param options.height
         * @param options.subdivisions
         * @param options.subdivisionsX
         * @param options.subdivisionsY
         * @returns the VertexData of the Ground
         * @deprecated Please use CreateGroundVertexData instead
         */
        static CreateGround(options) {
            throw _WarnImport("groundBuilder");
        }
        /**
         * Creates the VertexData for a TiledGround by subdividing the ground into tiles
         * @param options an object used to set the following optional parameters for the Ground, required but can be empty
         * * xmin the ground minimum X coordinate, optional, default -1
         * * zmin the ground minimum Z coordinate, optional, default -1
         * * xmax the ground maximum X coordinate, optional, default 1
         * * zmax the ground maximum Z coordinate, optional, default 1
         * * subdivisions a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the ground width and height creating 'tiles', default {w: 6, h: 6}
         * * precision a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the tile width and height, default {w: 2, h: 2}
         * @param options.xmin
         * @param options.zmin
         * @param options.xmax
         * @param options.zmax
         * @param options.subdivisions
         * @param options.subdivisions.w
         * @param options.subdivisions.h
         * @param options.precision
         * @param options.precision.w
         * @param options.precision.h
         * @returns the VertexData of the TiledGround
         * @deprecated use CreateTiledGroundVertexData instead
         */
        static CreateTiledGround(options) {
            throw _WarnImport("groundBuilder");
        }
        /**
         * Creates the VertexData of the Ground designed from a heightmap
         * @param options an object used to set the following parameters for the Ground, required and provided by CreateGroundFromHeightMap
         * * width the width (x direction) of the ground
         * * height the height (z direction) of the ground
         * * subdivisions the number of subdivisions per side
         * * minHeight the minimum altitude on the ground, optional, default 0
         * * maxHeight the maximum altitude on the ground, optional default 1
         * * colorFilter the filter to apply to the image pixel colors to compute the height, optional Color3, default (0.3, 0.59, 0.11)
         * * buffer the array holding the image color data
         * * bufferWidth the width of image
         * * bufferHeight the height of image
         * * alphaFilter Remove any data where the alpha channel is below this value, defaults 0 (all data visible)
         * @param options.width
         * @param options.height
         * @param options.subdivisions
         * @param options.minHeight
         * @param options.maxHeight
         * @param options.colorFilter
         * @param options.buffer
         * @param options.bufferWidth
         * @param options.bufferHeight
         * @param options.alphaFilter
         * @returns the VertexData of the Ground designed from a heightmap
         * @deprecated use CreateGroundFromHeightMapVertexData instead
         */
        static CreateGroundFromHeightMap(options) {
            throw _WarnImport("groundBuilder");
        }
        /**
         * Creates the VertexData for a Plane
         * @param options an object used to set the following optional parameters for the plane, required but can be empty
         * * size sets the width and height of the plane to the value of size, optional default 1
         * * width sets the width (x direction) of the plane, overwrites the width set by size, optional, default size
         * * height sets the height (y direction) of the plane, overwrites the height set by size, optional, default size
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.size
         * @param options.width
         * @param options.height
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the box
         * @deprecated use CreatePlaneVertexData instead
         */
        static CreatePlane(options) {
            throw _WarnImport("planeBuilder");
        }
        /**
         * Creates the VertexData of the Disc or regular Polygon
         * @param options an object used to set the following optional parameters for the disc, required but can be empty
         * * radius the radius of the disc, optional default 0.5
         * * tessellation the number of polygon sides, optional, default 64
         * * arc a number from 0 to 1, to create an unclosed polygon based on the fraction of the circumference given by the arc value, optional, default 1
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.radius
         * @param options.tessellation
         * @param options.arc
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the box
         * @deprecated use CreateDiscVertexData instead
         */
        static CreateDisc(options) {
            throw _WarnImport("discBuilder");
        }
        /**
         * Creates the VertexData for an irregular Polygon in the XoZ plane using a mesh built by polygonTriangulation.build()
         * All parameters are provided by CreatePolygon as needed
         * @param polygon a mesh built from polygonTriangulation.build()
         * @param sideOrientation takes the values Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * @param fUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
         * @param fColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
         * @param frontUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * @param backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param wrap a boolean, default false, when true and fUVs used texture is wrapped around all sides, when false texture is applied side
         * @returns the VertexData of the Polygon
         * @deprecated use CreatePolygonVertexData instead
         */
        static CreatePolygon(polygon, sideOrientation, fUV, fColors, frontUVs, backUVs, wrap) {
            throw _WarnImport("polygonBuilder");
        }
        /**
         * Creates the VertexData of the IcoSphere
         * @param options an object used to set the following optional parameters for the IcoSphere, required but can be empty
         * * radius the radius of the IcoSphere, optional default 1
         * * radiusX allows stretching in the x direction, optional, default radius
         * * radiusY allows stretching in the y direction, optional, default radius
         * * radiusZ allows stretching in the z direction, optional, default radius
         * * flat when true creates a flat shaded mesh, optional, default true
         * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.radius
         * @param options.radiusX
         * @param options.radiusY
         * @param options.radiusZ
         * @param options.flat
         * @param options.subdivisions
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the IcoSphere
         * @deprecated use CreateIcoSphereVertexData instead
         */
        static CreateIcoSphere(options) {
            throw _WarnImport("icoSphereBuilder");
        }
        // inspired from // http://stemkoski.github.io/Three.js/Polyhedra.html
        /**
         * Creates the VertexData for a Polyhedron
         * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
         * * type provided types are:
         *  * 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
         *  * 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
         * * size the size of the IcoSphere, optional default 1
         * * sizeX allows stretching in the x direction, optional, default size
         * * sizeY allows stretching in the y direction, optional, default size
         * * sizeZ allows stretching in the z direction, optional, default size
         * * custom a number that overwrites the type to create from an extended set of polyhedron from https://www.babylonjs-playground.com/#21QRSK#15 with minimised editor
         * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
         * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
         * * flat when true creates a flat shaded mesh, optional, default true
         * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.type
         * @param options.size
         * @param options.sizeX
         * @param options.sizeY
         * @param options.sizeZ
         * @param options.custom
         * @param options.faceUV
         * @param options.faceColors
         * @param options.flat
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the Polyhedron
         * @deprecated use CreatePolyhedronVertexData instead
         */
        static CreatePolyhedron(options) {
            throw _WarnImport("polyhedronBuilder");
        }
        /**
         * Creates the VertexData for a Capsule, inspired from https://github.com/maximeq/three-js-capsule-geometry/blob/master/src/CapsuleBufferGeometry.js
         * @param options an object used to set the following optional parameters for the capsule, required but can be empty
         * @returns the VertexData of the Capsule
         * @deprecated Please use CreateCapsuleVertexData from the capsuleBuilder file instead
         */
        static CreateCapsule(options = {
            orientation: Vector3.Up(),
            subdivisions: 2,
            tessellation: 16,
            height: 1,
            radius: 0.25,
            capSubdivisions: 6,
        }) {
            throw _WarnImport("capsuleBuilder");
        }
        // based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3D/src/away3d/primitives/TorusKnot.as?spec=svn2473&r=2473
        /**
         * Creates the VertexData for a TorusKnot
         * @param options an object used to set the following optional parameters for the TorusKnot, required but can be empty
         * * radius the radius of the torus knot, optional, default 2
         * * tube the thickness of the tube, optional, default 0.5
         * * radialSegments the number of sides on each tube segments, optional, default 32
         * * tubularSegments the number of tubes to decompose the knot into, optional, default 32
         * * p the number of windings around the z axis, optional,  default 2
         * * q the number of windings around the x axis, optional,  default 3
         * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
         * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
         * @param options.radius
         * @param options.tube
         * @param options.radialSegments
         * @param options.tubularSegments
         * @param options.p
         * @param options.q
         * @param options.sideOrientation
         * @param options.frontUVs
         * @param options.backUVs
         * @returns the VertexData of the Torus Knot
         * @deprecated use CreateTorusKnotVertexData instead
         */
        static CreateTorusKnot(options) {
            throw _WarnImport("torusKnotBuilder");
        }
        // Tools
        /**
         * Compute normals for given positions and indices
         * @param positions an array of vertex positions, [...., x, y, z, ......]
         * @param indices an array of indices in groups of three for each triangular facet, [...., i, j, k, ......]
         * @param normals an array of vertex normals, [...., x, y, z, ......]
         * @param options an object used to set the following optional parameters for the TorusKnot, optional
         * * facetNormals : optional array of facet normals (vector3)
         * * facetPositions : optional array of facet positions (vector3)
         * * facetPartitioning : optional partitioning array. facetPositions is required for facetPartitioning computation
         * * ratio : optional partitioning ratio / bounding box, required for facetPartitioning computation
         * * bInfo : optional bounding info, required for facetPartitioning computation
         * * bbSize : optional bounding box size data, required for facetPartitioning computation
         * * subDiv : optional partitioning data about subdivisions on  each axis (int), required for facetPartitioning computation
         * * useRightHandedSystem: optional boolean to for right handed system computation
         * * depthSort : optional boolean to enable the facet depth sort computation
         * * distanceTo : optional Vector3 to compute the facet depth from this location
         * * depthSortedFacets : optional array of depthSortedFacets to store the facet distances from the reference location
         * @param options.facetNormals
         * @param options.facetPositions
         * @param options.facetPartitioning
         * @param options.ratio
         * @param options.bInfo
         * @param options.bbSize
         * @param options.subDiv
         * @param options.useRightHandedSystem
         * @param options.depthSort
         * @param options.distanceTo
         * @param options.depthSortedFacets
         */
        static ComputeNormals(positions, indices, normals, options) {
            // temporary scalar variables
            let index = 0; // facet index
            let p1p2x = 0.0; // p1p2 vector x coordinate
            let p1p2y = 0.0; // p1p2 vector y coordinate
            let p1p2z = 0.0; // p1p2 vector z coordinate
            let p3p2x = 0.0; // p3p2 vector x coordinate
            let p3p2y = 0.0; // p3p2 vector y coordinate
            let p3p2z = 0.0; // p3p2 vector z coordinate
            let faceNormalx = 0.0; // facet normal x coordinate
            let faceNormaly = 0.0; // facet normal y coordinate
            let faceNormalz = 0.0; // facet normal z coordinate
            let length = 0.0; // facet normal length before normalization
            let v1x = 0; // vector1 x index in the positions array
            let v1y = 0; // vector1 y index in the positions array
            let v1z = 0; // vector1 z index in the positions array
            let v2x = 0; // vector2 x index in the positions array
            let v2y = 0; // vector2 y index in the positions array
            let v2z = 0; // vector2 z index in the positions array
            let v3x = 0; // vector3 x index in the positions array
            let v3y = 0; // vector3 y index in the positions array
            let v3z = 0; // vector3 z index in the positions array
            let computeFacetNormals = false;
            let computeFacetPositions = false;
            let computeFacetPartitioning = false;
            let computeDepthSort = false;
            let faceNormalSign = 1;
            let ratio = 0;
            let distanceTo = null;
            if (options) {
                computeFacetNormals = options.facetNormals ? true : false;
                computeFacetPositions = options.facetPositions ? true : false;
                computeFacetPartitioning = options.facetPartitioning ? true : false;
                faceNormalSign = options.useRightHandedSystem === true ? -1 : 1;
                ratio = options.ratio || 0;
                computeDepthSort = options.depthSort ? true : false;
                distanceTo = options.distanceTo;
                if (computeDepthSort) {
                    if (distanceTo === undefined) {
                        distanceTo = Vector3.Zero();
                    }
                }
            }
            // facetPartitioning reinit if needed
            let xSubRatio = 0;
            let ySubRatio = 0;
            let zSubRatio = 0;
            let subSq = 0;
            if (computeFacetPartitioning && options && options.bbSize) {
                //let bbSizeMax = options.bbSize.x > options.bbSize.y ? options.bbSize.x : options.bbSize.y;
                //bbSizeMax = bbSizeMax > options.bbSize.z ? bbSizeMax : options.bbSize.z;
                xSubRatio = (options.subDiv.X * ratio) / options.bbSize.x;
                ySubRatio = (options.subDiv.Y * ratio) / options.bbSize.y;
                zSubRatio = (options.subDiv.Z * ratio) / options.bbSize.z;
                subSq = options.subDiv.max * options.subDiv.max;
                options.facetPartitioning.length = 0;
            }
            // reset the normals
            for (index = 0; index < positions.length; index++) {
                normals[index] = 0.0;
            }
            // Loop : 1 indice triplet = 1 facet
            const nbFaces = (indices.length / 3) | 0;
            for (index = 0; index < nbFaces; index++) {
                // get the indexes of the coordinates of each vertex of the facet
                v1x = indices[index * 3] * 3;
                v1y = v1x + 1;
                v1z = v1x + 2;
                v2x = indices[index * 3 + 1] * 3;
                v2y = v2x + 1;
                v2z = v2x + 2;
                v3x = indices[index * 3 + 2] * 3;
                v3y = v3x + 1;
                v3z = v3x + 2;
                p1p2x = positions[v1x] - positions[v2x]; // compute two vectors per facet : p1p2 and p3p2
                p1p2y = positions[v1y] - positions[v2y];
                p1p2z = positions[v1z] - positions[v2z];
                p3p2x = positions[v3x] - positions[v2x];
                p3p2y = positions[v3y] - positions[v2y];
                p3p2z = positions[v3z] - positions[v2z];
                // compute the face normal with the cross product
                faceNormalx = faceNormalSign * (p1p2y * p3p2z - p1p2z * p3p2y);
                faceNormaly = faceNormalSign * (p1p2z * p3p2x - p1p2x * p3p2z);
                faceNormalz = faceNormalSign * (p1p2x * p3p2y - p1p2y * p3p2x);
                // normalize this normal and store it in the array facetData
                length = Math.sqrt(faceNormalx * faceNormalx + faceNormaly * faceNormaly + faceNormalz * faceNormalz);
                length = length === 0 ? 1.0 : length;
                faceNormalx /= length;
                faceNormaly /= length;
                faceNormalz /= length;
                if (computeFacetNormals && options) {
                    options.facetNormals[index].x = faceNormalx;
                    options.facetNormals[index].y = faceNormaly;
                    options.facetNormals[index].z = faceNormalz;
                }
                if (computeFacetPositions && options) {
                    // compute and the facet barycenter coordinates in the array facetPositions
                    options.facetPositions[index].x = (positions[v1x] + positions[v2x] + positions[v3x]) / 3.0;
                    options.facetPositions[index].y = (positions[v1y] + positions[v2y] + positions[v3y]) / 3.0;
                    options.facetPositions[index].z = (positions[v1z] + positions[v2z] + positions[v3z]) / 3.0;
                }
                if (computeFacetPartitioning && options) {
                    // store the facet indexes in arrays in the main facetPartitioning array :
                    // compute each facet vertex (+ facet barycenter) index in the partiniong array
                    const ox = Math.floor((options.facetPositions[index].x - options.bInfo.minimum.x * ratio) * xSubRatio);
                    const oy = Math.floor((options.facetPositions[index].y - options.bInfo.minimum.y * ratio) * ySubRatio);
                    const oz = Math.floor((options.facetPositions[index].z - options.bInfo.minimum.z * ratio) * zSubRatio);
                    const b1x = Math.floor((positions[v1x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                    const b1y = Math.floor((positions[v1y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                    const b1z = Math.floor((positions[v1z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                    const b2x = Math.floor((positions[v2x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                    const b2y = Math.floor((positions[v2y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                    const b2z = Math.floor((positions[v2z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                    const b3x = Math.floor((positions[v3x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                    const b3y = Math.floor((positions[v3y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                    const b3z = Math.floor((positions[v3z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                    const block_idx_v1 = b1x + options.subDiv.max * b1y + subSq * b1z;
                    const block_idx_v2 = b2x + options.subDiv.max * b2y + subSq * b2z;
                    const block_idx_v3 = b3x + options.subDiv.max * b3y + subSq * b3z;
                    const block_idx_o = ox + options.subDiv.max * oy + subSq * oz;
                    options.facetPartitioning[block_idx_o] = options.facetPartitioning[block_idx_o] ? options.facetPartitioning[block_idx_o] : new Array();
                    options.facetPartitioning[block_idx_v1] = options.facetPartitioning[block_idx_v1] ? options.facetPartitioning[block_idx_v1] : new Array();
                    options.facetPartitioning[block_idx_v2] = options.facetPartitioning[block_idx_v2] ? options.facetPartitioning[block_idx_v2] : new Array();
                    options.facetPartitioning[block_idx_v3] = options.facetPartitioning[block_idx_v3] ? options.facetPartitioning[block_idx_v3] : new Array();
                    // push each facet index in each block containing the vertex
                    options.facetPartitioning[block_idx_v1].push(index);
                    if (block_idx_v2 != block_idx_v1) {
                        options.facetPartitioning[block_idx_v2].push(index);
                    }
                    if (!(block_idx_v3 == block_idx_v2 || block_idx_v3 == block_idx_v1)) {
                        options.facetPartitioning[block_idx_v3].push(index);
                    }
                    if (!(block_idx_o == block_idx_v1 || block_idx_o == block_idx_v2 || block_idx_o == block_idx_v3)) {
                        options.facetPartitioning[block_idx_o].push(index);
                    }
                }
                if (computeDepthSort && options && options.facetPositions) {
                    const dsf = options.depthSortedFacets[index];
                    dsf.ind = index * 3;
                    dsf.sqDistance = Vector3.DistanceSquared(options.facetPositions[index], distanceTo);
                }
                // compute the normals anyway
                normals[v1x] += faceNormalx; // accumulate all the normals per face
                normals[v1y] += faceNormaly;
                normals[v1z] += faceNormalz;
                normals[v2x] += faceNormalx;
                normals[v2y] += faceNormaly;
                normals[v2z] += faceNormalz;
                normals[v3x] += faceNormalx;
                normals[v3y] += faceNormaly;
                normals[v3z] += faceNormalz;
            }
            // last normalization of each normal
            for (index = 0; index < normals.length / 3; index++) {
                faceNormalx = normals[index * 3];
                faceNormaly = normals[index * 3 + 1];
                faceNormalz = normals[index * 3 + 2];
                length = Math.sqrt(faceNormalx * faceNormalx + faceNormaly * faceNormaly + faceNormalz * faceNormalz);
                length = length === 0 ? 1.0 : length;
                faceNormalx /= length;
                faceNormaly /= length;
                faceNormalz /= length;
                normals[index * 3] = faceNormalx;
                normals[index * 3 + 1] = faceNormaly;
                normals[index * 3 + 2] = faceNormalz;
            }
        }
        /**
         * @internal
         */
        static _ComputeSides(sideOrientation, positions, indices, normals, uvs, frontUVs, backUVs) {
            const li = indices.length;
            const ln = normals.length;
            let i;
            let n;
            sideOrientation = sideOrientation || VertexData.DEFAULTSIDE;
            switch (sideOrientation) {
                case VertexData.FRONTSIDE:
                    // nothing changed
                    break;
                case VertexData.BACKSIDE:
                    // indices
                    for (i = 0; i < li; i += 3) {
                        const tmp = indices[i];
                        indices[i] = indices[i + 2];
                        indices[i + 2] = tmp;
                    }
                    // normals
                    for (n = 0; n < ln; n++) {
                        normals[n] = -normals[n];
                    }
                    break;
                case VertexData.DOUBLESIDE: {
                    // positions
                    const lp = positions.length;
                    const l = lp / 3;
                    for (let p = 0; p < lp; p++) {
                        positions[lp + p] = positions[p];
                    }
                    // indices
                    for (i = 0; i < li; i += 3) {
                        indices[i + li] = indices[i + 2] + l;
                        indices[i + 1 + li] = indices[i + 1] + l;
                        indices[i + 2 + li] = indices[i] + l;
                    }
                    // normals
                    for (n = 0; n < ln; n++) {
                        normals[ln + n] = -normals[n];
                    }
                    // uvs
                    const lu = uvs.length;
                    let u = 0;
                    for (u = 0; u < lu; u++) {
                        uvs[u + lu] = uvs[u];
                    }
                    frontUVs = frontUVs ? frontUVs : new Vector4(0.0, 0.0, 1.0, 1.0);
                    backUVs = backUVs ? backUVs : new Vector4(0.0, 0.0, 1.0, 1.0);
                    u = 0;
                    for (i = 0; i < lu / 2; i++) {
                        uvs[u] = frontUVs.x + (frontUVs.z - frontUVs.x) * uvs[u];
                        uvs[u + 1] = frontUVs.y + (frontUVs.w - frontUVs.y) * uvs[u + 1];
                        uvs[u + lu] = backUVs.x + (backUVs.z - backUVs.x) * uvs[u + lu];
                        uvs[u + lu + 1] = backUVs.y + (backUVs.w - backUVs.y) * uvs[u + lu + 1];
                        u += 2;
                    }
                    break;
                }
            }
        }
        /**
         * Creates a VertexData from serialized data
         * @param parsedVertexData the parsed data from an imported file
         * @returns a VertexData
         */
        static Parse(parsedVertexData) {
            const vertexData = new VertexData();
            // positions
            const positions = parsedVertexData.positions;
            if (positions) {
                vertexData.set(positions, VertexBuffer.PositionKind);
            }
            // normals
            const normals = parsedVertexData.normals;
            if (normals) {
                vertexData.set(normals, VertexBuffer.NormalKind);
            }
            // tangents
            const tangents = parsedVertexData.tangents;
            if (tangents) {
                vertexData.set(tangents, VertexBuffer.TangentKind);
            }
            // uvs
            const uvs = parsedVertexData.uvs;
            if (uvs) {
                vertexData.set(uvs, VertexBuffer.UVKind);
            }
            // uv2s
            const uvs2 = parsedVertexData.uvs2;
            if (uvs2) {
                vertexData.set(uvs2, VertexBuffer.UV2Kind);
            }
            // uv3s
            const uvs3 = parsedVertexData.uvs3;
            if (uvs3) {
                vertexData.set(uvs3, VertexBuffer.UV3Kind);
            }
            // uv4s
            const uvs4 = parsedVertexData.uvs4;
            if (uvs4) {
                vertexData.set(uvs4, VertexBuffer.UV4Kind);
            }
            // uv5s
            const uvs5 = parsedVertexData.uvs5;
            if (uvs5) {
                vertexData.set(uvs5, VertexBuffer.UV5Kind);
            }
            // uv6s
            const uvs6 = parsedVertexData.uvs6;
            if (uvs6) {
                vertexData.set(uvs6, VertexBuffer.UV6Kind);
            }
            // colors
            const colors = parsedVertexData.colors;
            if (colors) {
                vertexData.set(Color4.CheckColors4(colors, positions.length / 3), VertexBuffer.ColorKind);
            }
            // matricesIndices
            const matricesIndices = parsedVertexData.matricesIndices;
            if (matricesIndices) {
                vertexData.set(matricesIndices, VertexBuffer.MatricesIndicesKind);
            }
            // matricesWeights
            const matricesWeights = parsedVertexData.matricesWeights;
            if (matricesWeights) {
                vertexData.set(matricesWeights, VertexBuffer.MatricesWeightsKind);
            }
            // indices
            const indices = parsedVertexData.indices;
            if (indices) {
                vertexData.indices = indices;
            }
            // MaterialInfos
            const materialInfos = parsedVertexData.materialInfos;
            if (materialInfos) {
                vertexData.materialInfos = [];
                for (const materialInfoFromJSON of materialInfos) {
                    const materialInfo = new VertexDataMaterialInfo();
                    materialInfo.indexCount = materialInfoFromJSON.indexCount;
                    materialInfo.indexStart = materialInfoFromJSON.indexStart;
                    materialInfo.verticesCount = materialInfoFromJSON.verticesCount;
                    materialInfo.verticesStart = materialInfoFromJSON.verticesStart;
                    materialInfo.materialIndex = materialInfoFromJSON.materialIndex;
                    vertexData.materialInfos.push(materialInfo);
                }
            }
            return vertexData;
        }
        /**
         * Applies VertexData created from the imported parameters to the geometry
         * @param parsedVertexData the parsed data from an imported file
         * @param geometry the geometry to apply the VertexData to
         */
        static ImportVertexData(parsedVertexData, geometry) {
            const vertexData = VertexData.Parse(parsedVertexData);
            geometry.setAllVerticesData(vertexData, parsedVertexData.updatable);
        }
    }
    /**
     * Mesh side orientation : usually the external or front surface
     */
    VertexData.FRONTSIDE = 0;
    /**
     * Mesh side orientation : usually the internal or back surface
     */
    VertexData.BACKSIDE = 1;
    /**
     * Mesh side orientation : both internal and external or front and back surfaces
     */
    VertexData.DOUBLESIDE = 2;
    /**
     * Mesh side orientation : by default, `FRONTSIDE`
     */
    VertexData.DEFAULTSIDE = 0;
    __decorate$1([
        nativeOverride.filter((...[coordinates]) => !Array.isArray(coordinates))
    ], VertexData, "_TransformVector3Coordinates", null);
    __decorate$1([
        nativeOverride.filter((...[normals]) => !Array.isArray(normals))
    ], VertexData, "_TransformVector3Normals", null);
    __decorate$1([
        nativeOverride.filter((...[normals]) => !Array.isArray(normals))
    ], VertexData, "_TransformVector4Normals", null);
    __decorate$1([
        nativeOverride.filter((...[indices]) => !Array.isArray(indices))
    ], VertexData, "_FlipFaces", null);

    /**
     * Class used to represent data loading progression
     */
    class SceneLoaderFlags {
        /**
         * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
         */
        static get ForceFullSceneLoadingForIncremental() {
            return SceneLoaderFlags._ForceFullSceneLoadingForIncremental;
        }
        static set ForceFullSceneLoadingForIncremental(value) {
            SceneLoaderFlags._ForceFullSceneLoadingForIncremental = value;
        }
        /**
         * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
         */
        static get ShowLoadingScreen() {
            return SceneLoaderFlags._ShowLoadingScreen;
        }
        static set ShowLoadingScreen(value) {
            SceneLoaderFlags._ShowLoadingScreen = value;
        }
        /**
         * Defines the current logging level (while loading the scene)
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static get loggingLevel() {
            return SceneLoaderFlags._LoggingLevel;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static set loggingLevel(value) {
            SceneLoaderFlags._LoggingLevel = value;
        }
        /**
         * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
         */
        static get CleanBoneMatrixWeights() {
            return SceneLoaderFlags._CleanBoneMatrixWeights;
        }
        static set CleanBoneMatrixWeights(value) {
            SceneLoaderFlags._CleanBoneMatrixWeights = value;
        }
    }
    // Flags
    SceneLoaderFlags._ForceFullSceneLoadingForIncremental = false;
    SceneLoaderFlags._ShowLoadingScreen = true;
    SceneLoaderFlags._CleanBoneMatrixWeights = false;
    SceneLoaderFlags._LoggingLevel = 0;

    /**
     * Options used to control default behaviors regarding compatibility support
     */
    class CompatibilityOptions {
    }
    /**
     * Defines if the system should use OpenGL convention for UVs when creating geometry or loading .babylon files (false by default)
     */
    CompatibilityOptions.UseOpenGLOrientationForUV = false;

    /**
     * Class used to store geometry data (vertex buffers + index buffer)
     */
    class Geometry {
        /**
         *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
         */
        get boundingBias() {
            return this._boundingBias;
        }
        /**
         *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
         */
        set boundingBias(value) {
            if (this._boundingBias) {
                this._boundingBias.copyFrom(value);
            }
            else {
                this._boundingBias = value.clone();
            }
            this._updateBoundingInfo(true, null);
        }
        /**
         * Static function used to attach a new empty geometry to a mesh
         * @param mesh defines the mesh to attach the geometry to
         * @returns the new Geometry
         */
        static CreateGeometryForMesh(mesh) {
            const geometry = new Geometry(Geometry.RandomId(), mesh.getScene());
            geometry.applyToMesh(mesh);
            return geometry;
        }
        /** Get the list of meshes using this geometry */
        get meshes() {
            return this._meshes;
        }
        /**
         * Creates a new geometry
         * @param id defines the unique ID
         * @param scene defines the hosting scene
         * @param vertexData defines the VertexData used to get geometry data
         * @param updatable defines if geometry must be updatable (false by default)
         * @param mesh defines the mesh that will be associated with the geometry
         */
        constructor(id, scene, vertexData, updatable = false, mesh = null) {
            /**
             * Gets the delay loading state of the geometry (none by default which means not delayed)
             */
            this.delayLoadState = 0;
            this._totalVertices = 0;
            this._isDisposed = false;
            this._indexBufferIsUpdatable = false;
            this._positionsCache = [];
            /** @internal */
            this._parentContainer = null;
            /**
             * If set to true (false by default), the bounding info applied to the meshes sharing this geometry will be the bounding info defined at the class level
             * and won't be computed based on the vertex positions (which is what we get when useBoundingInfoFromGeometry = false)
             */
            this.useBoundingInfoFromGeometry = false;
            this._scene = scene || EngineStore.LastCreatedScene;
            if (!this._scene) {
                return;
            }
            this.id = id;
            this.uniqueId = this._scene.getUniqueId();
            this._engine = this._scene.getEngine();
            this._meshes = [];
            //Init vertex buffer cache
            this._vertexBuffers = {};
            this._indices = [];
            this._updatable = updatable;
            // vertexData
            if (vertexData) {
                this.setAllVerticesData(vertexData, updatable);
            }
            else {
                this._totalVertices = 0;
            }
            if (this._engine.getCaps().vertexArrayObject) {
                this._vertexArrayObjects = {};
            }
            // applyToMesh
            if (mesh) {
                this.applyToMesh(mesh);
                mesh.computeWorldMatrix(true);
            }
        }
        /**
         * Gets the current extend of the geometry
         */
        get extend() {
            return this._extend;
        }
        /**
         * Gets the hosting scene
         * @returns the hosting Scene
         */
        getScene() {
            return this._scene;
        }
        /**
         * Gets the hosting engine
         * @returns the hosting Engine
         */
        getEngine() {
            return this._engine;
        }
        /**
         * Defines if the geometry is ready to use
         * @returns true if the geometry is ready to be used
         */
        isReady() {
            return this.delayLoadState === 1 || this.delayLoadState === 0;
        }
        /**
         * Gets a value indicating that the geometry should not be serialized
         */
        get doNotSerialize() {
            for (let index = 0; index < this._meshes.length; index++) {
                if (!this._meshes[index].doNotSerialize) {
                    return false;
                }
            }
            return true;
        }
        /** @internal */
        _rebuild() {
            if (this._vertexArrayObjects) {
                this._vertexArrayObjects = {};
            }
            // Index buffer
            if (this._meshes.length !== 0 && this._indices) {
                this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable);
            }
            // Vertex buffers
            for (const key in this._vertexBuffers) {
                const vertexBuffer = this._vertexBuffers[key];
                vertexBuffer._rebuild();
            }
        }
        /**
         * Affects all geometry data in one call
         * @param vertexData defines the geometry data
         * @param updatable defines if the geometry must be flagged as updatable (false as default)
         */
        setAllVerticesData(vertexData, updatable) {
            vertexData.applyToGeometry(this, updatable);
            this._notifyUpdate();
        }
        /**
         * Set specific vertex data
         * @param kind defines the data kind (Position, normal, etc...)
         * @param data defines the vertex data to use
         * @param updatable defines if the vertex must be flagged as updatable (false as default)
         * @param stride defines the stride to use (0 by default). This value is deduced from the kind value if not specified
         */
        setVerticesData(kind, data, updatable = false, stride) {
            if (updatable && Array.isArray(data)) {
                // to avoid converting to Float32Array at each draw call in engine.updateDynamicVertexBuffer, we make the conversion a single time here
                data = new Float32Array(data);
            }
            const buffer = new VertexBuffer(this._engine, data, kind, updatable, this._meshes.length === 0, stride);
            this.setVerticesBuffer(buffer);
        }
        /**
         * Removes a specific vertex data
         * @param kind defines the data kind (Position, normal, etc...)
         */
        removeVerticesData(kind) {
            if (this._vertexBuffers[kind]) {
                this._vertexBuffers[kind].dispose();
                delete this._vertexBuffers[kind];
            }
            if (this._vertexArrayObjects) {
                this._disposeVertexArrayObjects();
            }
        }
        /**
         * Affect a vertex buffer to the geometry. the vertexBuffer.getKind() function is used to determine where to store the data
         * @param buffer defines the vertex buffer to use
         * @param totalVertices defines the total number of vertices for position kind (could be null)
         * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
         */
        setVerticesBuffer(buffer, totalVertices = null, disposeExistingBuffer = true) {
            const kind = buffer.getKind();
            if (this._vertexBuffers[kind] && disposeExistingBuffer) {
                this._vertexBuffers[kind].dispose();
            }
            if (buffer._buffer) {
                buffer._buffer._increaseReferences();
            }
            this._vertexBuffers[kind] = buffer;
            const meshes = this._meshes;
            const numOfMeshes = meshes.length;
            if (kind === VertexBuffer.PositionKind) {
                const data = buffer.getData();
                if (totalVertices != null) {
                    this._totalVertices = totalVertices;
                }
                else {
                    if (data != null) {
                        this._totalVertices = data.length / (buffer.type === VertexBuffer.BYTE ? buffer.byteStride : buffer.byteStride / 4);
                    }
                }
                this._updateExtend(data);
                this._resetPointsArrayCache();
                for (let index = 0; index < numOfMeshes; index++) {
                    const mesh = meshes[index];
                    mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                    mesh._createGlobalSubMesh(mesh.isUnIndexed);
                    mesh.computeWorldMatrix(true);
                    mesh.synchronizeInstances();
                }
            }
            this._notifyUpdate(kind);
        }
        /**
         * Update a specific vertex buffer
         * This function will directly update the underlying DataBuffer according to the passed numeric array or Float32Array
         * It will do nothing if the buffer is not updatable
         * @param kind defines the data kind (Position, normal, etc...)
         * @param data defines the data to use
         * @param offset defines the offset in the target buffer where to store the data
         * @param useBytes set to true if the offset is in bytes
         */
        updateVerticesDataDirectly(kind, data, offset, useBytes = false) {
            const vertexBuffer = this.getVertexBuffer(kind);
            if (!vertexBuffer) {
                return;
            }
            vertexBuffer.updateDirectly(data, offset, useBytes);
            this._notifyUpdate(kind);
        }
        /**
         * Update a specific vertex buffer
         * This function will create a new buffer if the current one is not updatable
         * @param kind defines the data kind (Position, normal, etc...)
         * @param data defines the data to use
         * @param updateExtends defines if the geometry extends must be recomputed (false by default)
         */
        updateVerticesData(kind, data, updateExtends = false) {
            const vertexBuffer = this.getVertexBuffer(kind);
            if (!vertexBuffer) {
                return;
            }
            vertexBuffer.update(data);
            if (kind === VertexBuffer.PositionKind) {
                this._updateBoundingInfo(updateExtends, data);
            }
            this._notifyUpdate(kind);
        }
        _updateBoundingInfo(updateExtends, data) {
            if (updateExtends) {
                this._updateExtend(data);
            }
            this._resetPointsArrayCache();
            if (updateExtends) {
                const meshes = this._meshes;
                for (const mesh of meshes) {
                    if (mesh.hasBoundingInfo) {
                        mesh.getBoundingInfo().reConstruct(this._extend.minimum, this._extend.maximum);
                    }
                    else {
                        mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                    }
                    const subMeshes = mesh.subMeshes;
                    for (const subMesh of subMeshes) {
                        subMesh.refreshBoundingInfo();
                    }
                }
            }
        }
        /**
         * @internal
         */
        _bind(effect, indexToBind, overrideVertexBuffers, overrideVertexArrayObjects) {
            if (!effect) {
                return;
            }
            if (indexToBind === undefined) {
                indexToBind = this._indexBuffer;
            }
            const vbs = this.getVertexBuffers();
            if (!vbs) {
                return;
            }
            if (indexToBind != this._indexBuffer || (!this._vertexArrayObjects && !overrideVertexArrayObjects)) {
                this._engine.bindBuffers(vbs, indexToBind, effect, overrideVertexBuffers);
                return;
            }
            const vaos = overrideVertexArrayObjects ? overrideVertexArrayObjects : this._vertexArrayObjects;
            // Using VAO
            if (!vaos[effect.key]) {
                vaos[effect.key] = this._engine.recordVertexArrayObject(vbs, indexToBind, effect, overrideVertexBuffers);
            }
            this._engine.bindVertexArrayObject(vaos[effect.key], indexToBind);
        }
        /**
         * Gets total number of vertices
         * @returns the total number of vertices
         */
        getTotalVertices() {
            if (!this.isReady()) {
                return 0;
            }
            return this._totalVertices;
        }
        /**
         * Gets a specific vertex data attached to this geometry. Float data is constructed if the vertex buffer data cannot be returned directly.
         * @param kind defines the data kind (Position, normal, etc...)
         * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
         * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
         * @returns a float array containing vertex data
         */
        getVerticesData(kind, copyWhenShared, forceCopy) {
            const vertexBuffer = this.getVertexBuffer(kind);
            if (!vertexBuffer) {
                return null;
            }
            return vertexBuffer.getFloatData(this._totalVertices, forceCopy || (copyWhenShared && this._meshes.length !== 1));
        }
        /**
         * Returns a boolean defining if the vertex data for the requested `kind` is updatable
         * @param kind defines the data kind (Position, normal, etc...)
         * @returns true if the vertex buffer with the specified kind is updatable
         */
        isVertexBufferUpdatable(kind) {
            const vb = this._vertexBuffers[kind];
            if (!vb) {
                return false;
            }
            return vb.isUpdatable();
        }
        /**
         * Gets a specific vertex buffer
         * @param kind defines the data kind (Position, normal, etc...)
         * @returns a VertexBuffer
         */
        getVertexBuffer(kind) {
            if (!this.isReady()) {
                return null;
            }
            return this._vertexBuffers[kind];
        }
        /**
         * Returns all vertex buffers
         * @returns an object holding all vertex buffers indexed by kind
         */
        getVertexBuffers() {
            if (!this.isReady()) {
                return null;
            }
            return this._vertexBuffers;
        }
        /**
         * Gets a boolean indicating if specific vertex buffer is present
         * @param kind defines the data kind (Position, normal, etc...)
         * @returns true if data is present
         */
        isVerticesDataPresent(kind) {
            if (!this._vertexBuffers) {
                if (this._delayInfo) {
                    return this._delayInfo.indexOf(kind) !== -1;
                }
                return false;
            }
            return this._vertexBuffers[kind] !== undefined;
        }
        /**
         * Gets a list of all attached data kinds (Position, normal, etc...)
         * @returns a list of string containing all kinds
         */
        getVerticesDataKinds() {
            const result = [];
            let kind;
            if (!this._vertexBuffers && this._delayInfo) {
                for (kind in this._delayInfo) {
                    result.push(kind);
                }
            }
            else {
                for (kind in this._vertexBuffers) {
                    result.push(kind);
                }
            }
            return result;
        }
        /**
         * Update index buffer
         * @param indices defines the indices to store in the index buffer
         * @param offset defines the offset in the target buffer where to store the data
         * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
         */
        updateIndices(indices, offset, gpuMemoryOnly = false) {
            if (!this._indexBuffer) {
                return;
            }
            if (!this._indexBufferIsUpdatable) {
                this.setIndices(indices, null, true);
            }
            else {
                const needToUpdateSubMeshes = indices.length !== this._indices.length;
                if (!gpuMemoryOnly) {
                    this._indices = indices.slice();
                }
                this._engine.updateDynamicIndexBuffer(this._indexBuffer, indices, offset);
                if (needToUpdateSubMeshes) {
                    for (const mesh of this._meshes) {
                        mesh._createGlobalSubMesh(true);
                    }
                }
            }
        }
        /**
         * Creates a new index buffer
         * @param indices defines the indices to store in the index buffer
         * @param totalVertices defines the total number of vertices (could be null)
         * @param updatable defines if the index buffer must be flagged as updatable (false by default)
         */
        setIndices(indices, totalVertices = null, updatable = false) {
            if (this._indexBuffer) {
                this._engine._releaseBuffer(this._indexBuffer);
            }
            this._indices = indices;
            this._indexBufferIsUpdatable = updatable;
            if (this._meshes.length !== 0 && this._indices) {
                this._indexBuffer = this._engine.createIndexBuffer(this._indices, updatable);
            }
            if (totalVertices != undefined) {
                // including null and undefined
                this._totalVertices = totalVertices;
            }
            for (const mesh of this._meshes) {
                mesh._createGlobalSubMesh(true);
                mesh.synchronizeInstances();
            }
            this._notifyUpdate();
        }
        /**
         * Return the total number of indices
         * @returns the total number of indices
         */
        getTotalIndices() {
            if (!this.isReady()) {
                return 0;
            }
            return this._indices.length;
        }
        /**
         * Gets the index buffer array
         * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
         * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
         * @returns the index buffer array
         */
        getIndices(copyWhenShared, forceCopy) {
            if (!this.isReady()) {
                return null;
            }
            const orig = this._indices;
            if (!forceCopy && (!copyWhenShared || this._meshes.length === 1)) {
                return orig;
            }
            else {
                return orig.slice();
            }
        }
        /**
         * Gets the index buffer
         * @returns the index buffer
         */
        getIndexBuffer() {
            if (!this.isReady()) {
                return null;
            }
            return this._indexBuffer;
        }
        /**
         * @internal
         */
        _releaseVertexArrayObject(effect = null) {
            if (!effect || !this._vertexArrayObjects) {
                return;
            }
            if (this._vertexArrayObjects[effect.key]) {
                this._engine.releaseVertexArrayObject(this._vertexArrayObjects[effect.key]);
                delete this._vertexArrayObjects[effect.key];
            }
        }
        /**
         * Release the associated resources for a specific mesh
         * @param mesh defines the source mesh
         * @param shouldDispose defines if the geometry must be disposed if there is no more mesh pointing to it
         */
        releaseForMesh(mesh, shouldDispose) {
            const meshes = this._meshes;
            const index = meshes.indexOf(mesh);
            if (index === -1) {
                return;
            }
            meshes.splice(index, 1);
            if (this._vertexArrayObjects) {
                mesh._invalidateInstanceVertexArrayObject();
            }
            mesh._geometry = null;
            if (meshes.length === 0 && shouldDispose) {
                this.dispose();
            }
        }
        /**
         * Apply current geometry to a given mesh
         * @param mesh defines the mesh to apply geometry to
         */
        applyToMesh(mesh) {
            if (mesh._geometry === this) {
                return;
            }
            const previousGeometry = mesh._geometry;
            if (previousGeometry) {
                previousGeometry.releaseForMesh(mesh);
            }
            if (this._vertexArrayObjects) {
                mesh._invalidateInstanceVertexArrayObject();
            }
            const meshes = this._meshes;
            // must be done before setting vertexBuffers because of mesh._createGlobalSubMesh()
            mesh._geometry = this;
            mesh._internalAbstractMeshDataInfo._positions = null;
            this._scene.pushGeometry(this);
            meshes.push(mesh);
            if (this.isReady()) {
                this._applyToMesh(mesh);
            }
            else if (this._boundingInfo) {
                mesh.setBoundingInfo(this._boundingInfo);
            }
        }
        _updateExtend(data = null) {
            if (this.useBoundingInfoFromGeometry && this._boundingInfo) {
                this._extend = {
                    minimum: this._boundingInfo.minimum.clone(),
                    maximum: this._boundingInfo.maximum.clone(),
                };
            }
            else {
                if (!data) {
                    data = this.getVerticesData(VertexBuffer.PositionKind);
                    // This can happen if the buffer comes from a Hardware Buffer where
                    // The data have not been uploaded by Babylon. (ex: Compute Shaders and Storage Buffers)
                    if (!data) {
                        return;
                    }
                }
                this._extend = extractMinAndMax(data, 0, this._totalVertices, this.boundingBias, 3);
            }
        }
        _applyToMesh(mesh) {
            const numOfMeshes = this._meshes.length;
            // vertexBuffers
            for (const kind in this._vertexBuffers) {
                if (numOfMeshes === 1) {
                    this._vertexBuffers[kind].create();
                }
                if (kind === VertexBuffer.PositionKind) {
                    if (!this._extend) {
                        this._updateExtend();
                    }
                    mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                    mesh._createGlobalSubMesh(mesh.isUnIndexed);
                    //bounding info was just created again, world matrix should be applied again.
                    mesh._updateBoundingInfo();
                }
            }
            // indexBuffer
            if (numOfMeshes === 1 && this._indices && this._indices.length > 0) {
                this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable);
            }
            // morphTargets
            mesh._syncGeometryWithMorphTargetManager();
            // instances
            mesh.synchronizeInstances();
        }
        _notifyUpdate(kind) {
            if (this.onGeometryUpdated) {
                this.onGeometryUpdated(this, kind);
            }
            if (this._vertexArrayObjects) {
                this._disposeVertexArrayObjects();
            }
            for (const mesh of this._meshes) {
                mesh._markSubMeshesAsAttributesDirty();
            }
        }
        /**
         * Load the geometry if it was flagged as delay loaded
         * @param scene defines the hosting scene
         * @param onLoaded defines a callback called when the geometry is loaded
         */
        load(scene, onLoaded) {
            if (this.delayLoadState === 2) {
                return;
            }
            if (this.isReady()) {
                if (onLoaded) {
                    onLoaded();
                }
                return;
            }
            this.delayLoadState = 2;
            this._queueLoad(scene, onLoaded);
        }
        _queueLoad(scene, onLoaded) {
            if (!this.delayLoadingFile) {
                return;
            }
            scene.addPendingData(this);
            scene._loadFile(this.delayLoadingFile, (data) => {
                if (!this._delayLoadingFunction) {
                    return;
                }
                this._delayLoadingFunction(JSON.parse(data), this);
                this.delayLoadState = 1;
                this._delayInfo = [];
                scene.removePendingData(this);
                const meshes = this._meshes;
                const numOfMeshes = meshes.length;
                for (let index = 0; index < numOfMeshes; index++) {
                    this._applyToMesh(meshes[index]);
                }
                if (onLoaded) {
                    onLoaded();
                }
            }, undefined, true);
        }
        /**
         * Invert the geometry to move from a right handed system to a left handed one.
         */
        toLeftHanded() {
            // Flip faces
            const tIndices = this.getIndices(false);
            if (tIndices != null && tIndices.length > 0) {
                for (let i = 0; i < tIndices.length; i += 3) {
                    const tTemp = tIndices[i + 0];
                    tIndices[i + 0] = tIndices[i + 2];
                    tIndices[i + 2] = tTemp;
                }
                this.setIndices(tIndices);
            }
            // Negate position.z
            const tPositions = this.getVerticesData(VertexBuffer.PositionKind, false);
            if (tPositions != null && tPositions.length > 0) {
                for (let i = 0; i < tPositions.length; i += 3) {
                    tPositions[i + 2] = -tPositions[i + 2];
                }
                this.setVerticesData(VertexBuffer.PositionKind, tPositions, false);
            }
            // Negate normal.z
            const tNormals = this.getVerticesData(VertexBuffer.NormalKind, false);
            if (tNormals != null && tNormals.length > 0) {
                for (let i = 0; i < tNormals.length; i += 3) {
                    tNormals[i + 2] = -tNormals[i + 2];
                }
                this.setVerticesData(VertexBuffer.NormalKind, tNormals, false);
            }
        }
        // Cache
        /** @internal */
        _resetPointsArrayCache() {
            this._positions = null;
        }
        /** @internal */
        _generatePointsArray() {
            if (this._positions) {
                return true;
            }
            const data = this.getVerticesData(VertexBuffer.PositionKind);
            if (!data || data.length === 0) {
                return false;
            }
            for (let index = this._positionsCache.length * 3, arrayIdx = this._positionsCache.length; index < data.length; index += 3, ++arrayIdx) {
                this._positionsCache[arrayIdx] = Vector3.FromArray(data, index);
            }
            for (let index = 0, arrayIdx = 0; index < data.length; index += 3, ++arrayIdx) {
                this._positionsCache[arrayIdx].set(data[0 + index], data[1 + index], data[2 + index]);
            }
            // just in case the number of positions was reduced, splice the array
            this._positionsCache.length = data.length / 3;
            this._positions = this._positionsCache;
            return true;
        }
        /**
         * Gets a value indicating if the geometry is disposed
         * @returns true if the geometry was disposed
         */
        isDisposed() {
            return this._isDisposed;
        }
        _disposeVertexArrayObjects() {
            if (this._vertexArrayObjects) {
                for (const kind in this._vertexArrayObjects) {
                    this._engine.releaseVertexArrayObject(this._vertexArrayObjects[kind]);
                }
                this._vertexArrayObjects = {}; // Will trigger a rebuild of the VAO if supported
                const meshes = this._meshes;
                const numOfMeshes = meshes.length;
                for (let index = 0; index < numOfMeshes; index++) {
                    meshes[index]._invalidateInstanceVertexArrayObject();
                }
            }
        }
        /**
         * Free all associated resources
         */
        dispose() {
            const meshes = this._meshes;
            const numOfMeshes = meshes.length;
            let index;
            for (index = 0; index < numOfMeshes; index++) {
                this.releaseForMesh(meshes[index]);
            }
            this._meshes.length = 0;
            this._disposeVertexArrayObjects();
            for (const kind in this._vertexBuffers) {
                this._vertexBuffers[kind].dispose();
            }
            this._vertexBuffers = {};
            this._totalVertices = 0;
            if (this._indexBuffer) {
                this._engine._releaseBuffer(this._indexBuffer);
            }
            this._indexBuffer = null;
            this._indices = [];
            this.delayLoadState = 0;
            this.delayLoadingFile = null;
            this._delayLoadingFunction = null;
            this._delayInfo = [];
            this._boundingInfo = null;
            this._scene.removeGeometry(this);
            if (this._parentContainer) {
                const index = this._parentContainer.geometries.indexOf(this);
                if (index > -1) {
                    this._parentContainer.geometries.splice(index, 1);
                }
                this._parentContainer = null;
            }
            this._isDisposed = true;
        }
        /**
         * Clone the current geometry into a new geometry
         * @param id defines the unique ID of the new geometry
         * @returns a new geometry object
         */
        copy(id) {
            const vertexData = new VertexData();
            vertexData.indices = [];
            const indices = this.getIndices();
            if (indices) {
                for (let index = 0; index < indices.length; index++) {
                    vertexData.indices.push(indices[index]);
                }
            }
            let updatable = false;
            let stopChecking = false;
            let kind;
            for (kind in this._vertexBuffers) {
                // using slice() to make a copy of the array and not just reference it
                const data = this.getVerticesData(kind);
                if (data) {
                    if (data instanceof Float32Array) {
                        vertexData.set(new Float32Array(data), kind);
                    }
                    else {
                        vertexData.set(data.slice(0), kind);
                    }
                    if (!stopChecking) {
                        const vb = this.getVertexBuffer(kind);
                        if (vb) {
                            updatable = vb.isUpdatable();
                            stopChecking = !updatable;
                        }
                    }
                }
            }
            const geometry = new Geometry(id, this._scene, vertexData, updatable);
            geometry.delayLoadState = this.delayLoadState;
            geometry.delayLoadingFile = this.delayLoadingFile;
            geometry._delayLoadingFunction = this._delayLoadingFunction;
            for (kind in this._delayInfo) {
                geometry._delayInfo = geometry._delayInfo || [];
                geometry._delayInfo.push(kind);
            }
            // Bounding info
            geometry._boundingInfo = new BoundingInfo(this._extend.minimum, this._extend.maximum);
            return geometry;
        }
        /**
         * Serialize the current geometry info (and not the vertices data) into a JSON object
         * @returns a JSON representation of the current geometry data (without the vertices data)
         */
        serialize() {
            const serializationObject = {};
            serializationObject.id = this.id;
            serializationObject.uniqueId = this.uniqueId;
            serializationObject.updatable = this._updatable;
            if (Tags && Tags.HasTags(this)) {
                serializationObject.tags = Tags.GetTags(this);
            }
            return serializationObject;
        }
        _toNumberArray(origin) {
            if (Array.isArray(origin)) {
                return origin;
            }
            else {
                return Array.prototype.slice.call(origin);
            }
        }
        /**
         * Release any memory retained by the cached data on the Geometry.
         *
         * Call this function to reduce memory footprint of the mesh.
         * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
         */
        clearCachedData() {
            this._indices = [];
            this._resetPointsArrayCache();
            for (const vbName in this._vertexBuffers) {
                if (!Object.prototype.hasOwnProperty.call(this._vertexBuffers, vbName)) {
                    continue;
                }
                this._vertexBuffers[vbName]._buffer._data = null;
            }
        }
        /**
         * Serialize all vertices data into a JSON object
         * @returns a JSON representation of the current geometry data
         */
        serializeVerticeData() {
            const serializationObject = this.serialize();
            if (this.isVerticesDataPresent(VertexBuffer.PositionKind)) {
                serializationObject.positions = this._toNumberArray(this.getVerticesData(VertexBuffer.PositionKind));
                if (this.isVertexBufferUpdatable(VertexBuffer.PositionKind)) {
                    serializationObject.positions._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                serializationObject.normals = this._toNumberArray(this.getVerticesData(VertexBuffer.NormalKind));
                if (this.isVertexBufferUpdatable(VertexBuffer.NormalKind)) {
                    serializationObject.normals._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.TangentKind)) {
                serializationObject.tangents = this._toNumberArray(this.getVerticesData(VertexBuffer.TangentKind));
                if (this.isVertexBufferUpdatable(VertexBuffer.TangentKind)) {
                    serializationObject.tangents._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.UVKind)) {
                serializationObject.uvs = this._toNumberArray(this.getVerticesData(VertexBuffer.UVKind));
                if (this.isVertexBufferUpdatable(VertexBuffer.UVKind)) {
                    serializationObject.uvs._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.UV2Kind)) {
                serializationObject.uv2s = this._toNumberArray(this.getVerticesData(VertexBuffer.UV2Kind));
                if (this.isVertexBufferUpdatable(VertexBuffer.UV2Kind)) {
                    serializationObject.uv2s._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.UV3Kind)) {
                serializationObject.uv3s = this._toNumberArray(this.getVerticesData(VertexBuffer.UV3Kind));
                if (this.isVertexBufferUpdatable(VertexBuffer.UV3Kind)) {
                    serializationObject.uv3s._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.UV4Kind)) {
                serializationObject.uv4s = this._toNumberArray(this.getVerticesData(VertexBuffer.UV4Kind));
                if (this.isVertexBufferUpdatable(VertexBuffer.UV4Kind)) {
                    serializationObject.uv4s._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.UV5Kind)) {
                serializationObject.uv5s = this._toNumberArray(this.getVerticesData(VertexBuffer.UV5Kind));
                if (this.isVertexBufferUpdatable(VertexBuffer.UV5Kind)) {
                    serializationObject.uv5s._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.UV6Kind)) {
                serializationObject.uv6s = this._toNumberArray(this.getVerticesData(VertexBuffer.UV6Kind));
                if (this.isVertexBufferUpdatable(VertexBuffer.UV6Kind)) {
                    serializationObject.uv6s._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.ColorKind)) {
                serializationObject.colors = this._toNumberArray(this.getVerticesData(VertexBuffer.ColorKind));
                if (this.isVertexBufferUpdatable(VertexBuffer.ColorKind)) {
                    serializationObject.colors._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.MatricesIndicesKind)) {
                serializationObject.matricesIndices = this._toNumberArray(this.getVerticesData(VertexBuffer.MatricesIndicesKind));
                serializationObject.matricesIndices._isExpanded = true;
                if (this.isVertexBufferUpdatable(VertexBuffer.MatricesIndicesKind)) {
                    serializationObject.matricesIndices._updatable = true;
                }
            }
            if (this.isVerticesDataPresent(VertexBuffer.MatricesWeightsKind)) {
                serializationObject.matricesWeights = this._toNumberArray(this.getVerticesData(VertexBuffer.MatricesWeightsKind));
                if (this.isVertexBufferUpdatable(VertexBuffer.MatricesWeightsKind)) {
                    serializationObject.matricesWeights._updatable = true;
                }
            }
            serializationObject.indices = this._toNumberArray(this.getIndices());
            return serializationObject;
        }
        // Statics
        /**
         * Extracts a clone of a mesh geometry
         * @param mesh defines the source mesh
         * @param id defines the unique ID of the new geometry object
         * @returns the new geometry object
         */
        static ExtractFromMesh(mesh, id) {
            const geometry = mesh._geometry;
            if (!geometry) {
                return null;
            }
            return geometry.copy(id);
        }
        /**
         * You should now use Tools.RandomId(), this method is still here for legacy reasons.
         * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
         * Be aware Math.random() could cause collisions, but:
         * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
         * @returns a string containing a new GUID
         */
        static RandomId() {
            return Tools.RandomId();
        }
        static _GetGeometryByLoadedUniqueId(uniqueId, scene) {
            for (let index = 0; index < scene.geometries.length; index++) {
                if (scene.geometries[index]._loadedUniqueId === uniqueId) {
                    return scene.geometries[index];
                }
            }
            return null;
        }
        /**
         * @internal
         */
        static _ImportGeometry(parsedGeometry, mesh) {
            const scene = mesh.getScene();
            // Geometry
            const geometryUniqueId = parsedGeometry.geometryUniqueId;
            const geometryId = parsedGeometry.geometryId;
            if (geometryUniqueId || geometryId) {
                const geometry = geometryUniqueId ? this._GetGeometryByLoadedUniqueId(geometryUniqueId, scene) : scene.getGeometryById(geometryId);
                if (geometry) {
                    geometry.applyToMesh(mesh);
                }
            }
            else if (parsedGeometry instanceof ArrayBuffer) {
                const binaryInfo = mesh._binaryInfo;
                if (binaryInfo.positionsAttrDesc && binaryInfo.positionsAttrDesc.count > 0) {
                    const positionsData = new Float32Array(parsedGeometry, binaryInfo.positionsAttrDesc.offset, binaryInfo.positionsAttrDesc.count);
                    mesh.setVerticesData(VertexBuffer.PositionKind, positionsData, false);
                }
                if (binaryInfo.normalsAttrDesc && binaryInfo.normalsAttrDesc.count > 0) {
                    const normalsData = new Float32Array(parsedGeometry, binaryInfo.normalsAttrDesc.offset, binaryInfo.normalsAttrDesc.count);
                    mesh.setVerticesData(VertexBuffer.NormalKind, normalsData, false);
                }
                if (binaryInfo.tangetsAttrDesc && binaryInfo.tangetsAttrDesc.count > 0) {
                    const tangentsData = new Float32Array(parsedGeometry, binaryInfo.tangetsAttrDesc.offset, binaryInfo.tangetsAttrDesc.count);
                    mesh.setVerticesData(VertexBuffer.TangentKind, tangentsData, false);
                }
                if (binaryInfo.uvsAttrDesc && binaryInfo.uvsAttrDesc.count > 0) {
                    const uvsData = new Float32Array(parsedGeometry, binaryInfo.uvsAttrDesc.offset, binaryInfo.uvsAttrDesc.count);
                    if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                        for (let index = 1; index < uvsData.length; index += 2) {
                            uvsData[index] = 1 - uvsData[index];
                        }
                    }
                    mesh.setVerticesData(VertexBuffer.UVKind, uvsData, false);
                }
                if (binaryInfo.uvs2AttrDesc && binaryInfo.uvs2AttrDesc.count > 0) {
                    const uvs2Data = new Float32Array(parsedGeometry, binaryInfo.uvs2AttrDesc.offset, binaryInfo.uvs2AttrDesc.count);
                    if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                        for (let index = 1; index < uvs2Data.length; index += 2) {
                            uvs2Data[index] = 1 - uvs2Data[index];
                        }
                    }
                    mesh.setVerticesData(VertexBuffer.UV2Kind, uvs2Data, false);
                }
                if (binaryInfo.uvs3AttrDesc && binaryInfo.uvs3AttrDesc.count > 0) {
                    const uvs3Data = new Float32Array(parsedGeometry, binaryInfo.uvs3AttrDesc.offset, binaryInfo.uvs3AttrDesc.count);
                    if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                        for (let index = 1; index < uvs3Data.length; index += 2) {
                            uvs3Data[index] = 1 - uvs3Data[index];
                        }
                    }
                    mesh.setVerticesData(VertexBuffer.UV3Kind, uvs3Data, false);
                }
                if (binaryInfo.uvs4AttrDesc && binaryInfo.uvs4AttrDesc.count > 0) {
                    const uvs4Data = new Float32Array(parsedGeometry, binaryInfo.uvs4AttrDesc.offset, binaryInfo.uvs4AttrDesc.count);
                    if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                        for (let index = 1; index < uvs4Data.length; index += 2) {
                            uvs4Data[index] = 1 - uvs4Data[index];
                        }
                    }
                    mesh.setVerticesData(VertexBuffer.UV4Kind, uvs4Data, false);
                }
                if (binaryInfo.uvs5AttrDesc && binaryInfo.uvs5AttrDesc.count > 0) {
                    const uvs5Data = new Float32Array(parsedGeometry, binaryInfo.uvs5AttrDesc.offset, binaryInfo.uvs5AttrDesc.count);
                    if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                        for (let index = 1; index < uvs5Data.length; index += 2) {
                            uvs5Data[index] = 1 - uvs5Data[index];
                        }
                    }
                    mesh.setVerticesData(VertexBuffer.UV5Kind, uvs5Data, false);
                }
                if (binaryInfo.uvs6AttrDesc && binaryInfo.uvs6AttrDesc.count > 0) {
                    const uvs6Data = new Float32Array(parsedGeometry, binaryInfo.uvs6AttrDesc.offset, binaryInfo.uvs6AttrDesc.count);
                    if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                        for (let index = 1; index < uvs6Data.length; index += 2) {
                            uvs6Data[index] = 1 - uvs6Data[index];
                        }
                    }
                    mesh.setVerticesData(VertexBuffer.UV6Kind, uvs6Data, false);
                }
                if (binaryInfo.colorsAttrDesc && binaryInfo.colorsAttrDesc.count > 0) {
                    const colorsData = new Float32Array(parsedGeometry, binaryInfo.colorsAttrDesc.offset, binaryInfo.colorsAttrDesc.count);
                    mesh.setVerticesData(VertexBuffer.ColorKind, colorsData, false, binaryInfo.colorsAttrDesc.stride);
                }
                if (binaryInfo.matricesIndicesAttrDesc && binaryInfo.matricesIndicesAttrDesc.count > 0) {
                    const matricesIndicesData = new Int32Array(parsedGeometry, binaryInfo.matricesIndicesAttrDesc.offset, binaryInfo.matricesIndicesAttrDesc.count);
                    const floatIndices = [];
                    for (let i = 0; i < matricesIndicesData.length; i++) {
                        const index = matricesIndicesData[i];
                        floatIndices.push(index & 0x000000ff);
                        floatIndices.push((index & 0x0000ff00) >> 8);
                        floatIndices.push((index & 0x00ff0000) >> 16);
                        floatIndices.push((index >> 24) & 0xff); // & 0xFF to convert to v + 256 if v < 0
                    }
                    mesh.setVerticesData(VertexBuffer.MatricesIndicesKind, floatIndices, false);
                }
                if (binaryInfo.matricesIndicesExtraAttrDesc && binaryInfo.matricesIndicesExtraAttrDesc.count > 0) {
                    const matricesIndicesData = new Int32Array(parsedGeometry, binaryInfo.matricesIndicesExtraAttrDesc.offset, binaryInfo.matricesIndicesExtraAttrDesc.count);
                    const floatIndices = [];
                    for (let i = 0; i < matricesIndicesData.length; i++) {
                        const index = matricesIndicesData[i];
                        floatIndices.push(index & 0x000000ff);
                        floatIndices.push((index & 0x0000ff00) >> 8);
                        floatIndices.push((index & 0x00ff0000) >> 16);
                        floatIndices.push((index >> 24) & 0xff); // & 0xFF to convert to v + 256 if v < 0
                    }
                    mesh.setVerticesData(VertexBuffer.MatricesIndicesExtraKind, floatIndices, false);
                }
                if (binaryInfo.matricesWeightsAttrDesc && binaryInfo.matricesWeightsAttrDesc.count > 0) {
                    const matricesWeightsData = new Float32Array(parsedGeometry, binaryInfo.matricesWeightsAttrDesc.offset, binaryInfo.matricesWeightsAttrDesc.count);
                    mesh.setVerticesData(VertexBuffer.MatricesWeightsKind, matricesWeightsData, false);
                }
                if (binaryInfo.indicesAttrDesc && binaryInfo.indicesAttrDesc.count > 0) {
                    const indicesData = new Int32Array(parsedGeometry, binaryInfo.indicesAttrDesc.offset, binaryInfo.indicesAttrDesc.count);
                    mesh.setIndices(indicesData, null);
                }
                if (binaryInfo.subMeshesAttrDesc && binaryInfo.subMeshesAttrDesc.count > 0) {
                    const subMeshesData = new Int32Array(parsedGeometry, binaryInfo.subMeshesAttrDesc.offset, binaryInfo.subMeshesAttrDesc.count * 5);
                    mesh.subMeshes = [];
                    for (let i = 0; i < binaryInfo.subMeshesAttrDesc.count; i++) {
                        const materialIndex = subMeshesData[i * 5 + 0];
                        const verticesStart = subMeshesData[i * 5 + 1];
                        const verticesCount = subMeshesData[i * 5 + 2];
                        const indexStart = subMeshesData[i * 5 + 3];
                        const indexCount = subMeshesData[i * 5 + 4];
                        SubMesh.AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh);
                    }
                }
            }
            else if (parsedGeometry.positions && parsedGeometry.normals && parsedGeometry.indices) {
                mesh.setVerticesData(VertexBuffer.PositionKind, parsedGeometry.positions, parsedGeometry.positions._updatable);
                mesh.setVerticesData(VertexBuffer.NormalKind, parsedGeometry.normals, parsedGeometry.normals._updatable);
                if (parsedGeometry.tangents) {
                    mesh.setVerticesData(VertexBuffer.TangentKind, parsedGeometry.tangents, parsedGeometry.tangents._updatable);
                }
                if (parsedGeometry.uvs) {
                    mesh.setVerticesData(VertexBuffer.UVKind, parsedGeometry.uvs, parsedGeometry.uvs._updatable);
                }
                if (parsedGeometry.uvs2) {
                    mesh.setVerticesData(VertexBuffer.UV2Kind, parsedGeometry.uvs2, parsedGeometry.uvs2._updatable);
                }
                if (parsedGeometry.uvs3) {
                    mesh.setVerticesData(VertexBuffer.UV3Kind, parsedGeometry.uvs3, parsedGeometry.uvs3._updatable);
                }
                if (parsedGeometry.uvs4) {
                    mesh.setVerticesData(VertexBuffer.UV4Kind, parsedGeometry.uvs4, parsedGeometry.uvs4._updatable);
                }
                if (parsedGeometry.uvs5) {
                    mesh.setVerticesData(VertexBuffer.UV5Kind, parsedGeometry.uvs5, parsedGeometry.uvs5._updatable);
                }
                if (parsedGeometry.uvs6) {
                    mesh.setVerticesData(VertexBuffer.UV6Kind, parsedGeometry.uvs6, parsedGeometry.uvs6._updatable);
                }
                if (parsedGeometry.colors) {
                    mesh.setVerticesData(VertexBuffer.ColorKind, Color4.CheckColors4(parsedGeometry.colors, parsedGeometry.positions.length / 3), parsedGeometry.colors._updatable);
                }
                if (parsedGeometry.matricesIndices) {
                    if (!parsedGeometry.matricesIndices._isExpanded) {
                        const floatIndices = [];
                        for (let i = 0; i < parsedGeometry.matricesIndices.length; i++) {
                            const matricesIndex = parsedGeometry.matricesIndices[i];
                            floatIndices.push(matricesIndex & 0x000000ff);
                            floatIndices.push((matricesIndex & 0x0000ff00) >> 8);
                            floatIndices.push((matricesIndex & 0x00ff0000) >> 16);
                            floatIndices.push((matricesIndex >> 24) & 0xff); // & 0xFF to convert to v + 256 if v < 0
                        }
                        mesh.setVerticesData(VertexBuffer.MatricesIndicesKind, floatIndices, parsedGeometry.matricesIndices._updatable);
                    }
                    else {
                        delete parsedGeometry.matricesIndices._isExpanded;
                        mesh.setVerticesData(VertexBuffer.MatricesIndicesKind, parsedGeometry.matricesIndices, parsedGeometry.matricesIndices._updatable);
                    }
                }
                if (parsedGeometry.matricesIndicesExtra) {
                    if (!parsedGeometry.matricesIndicesExtra._isExpanded) {
                        const floatIndices = [];
                        for (let i = 0; i < parsedGeometry.matricesIndicesExtra.length; i++) {
                            const matricesIndex = parsedGeometry.matricesIndicesExtra[i];
                            floatIndices.push(matricesIndex & 0x000000ff);
                            floatIndices.push((matricesIndex & 0x0000ff00) >> 8);
                            floatIndices.push((matricesIndex & 0x00ff0000) >> 16);
                            floatIndices.push((matricesIndex >> 24) & 0xff); // & 0xFF to convert to v + 256 if v < 0
                        }
                        mesh.setVerticesData(VertexBuffer.MatricesIndicesExtraKind, floatIndices, parsedGeometry.matricesIndicesExtra._updatable);
                    }
                    else {
                        delete parsedGeometry.matricesIndices._isExpanded;
                        mesh.setVerticesData(VertexBuffer.MatricesIndicesExtraKind, parsedGeometry.matricesIndicesExtra, parsedGeometry.matricesIndicesExtra._updatable);
                    }
                }
                if (parsedGeometry.matricesWeights) {
                    Geometry._CleanMatricesWeights(parsedGeometry, mesh);
                    mesh.setVerticesData(VertexBuffer.MatricesWeightsKind, parsedGeometry.matricesWeights, parsedGeometry.matricesWeights._updatable);
                }
                if (parsedGeometry.matricesWeightsExtra) {
                    mesh.setVerticesData(VertexBuffer.MatricesWeightsExtraKind, parsedGeometry.matricesWeightsExtra, parsedGeometry.matricesWeights._updatable);
                }
                mesh.setIndices(parsedGeometry.indices, null);
            }
            // SubMeshes
            if (parsedGeometry.subMeshes) {
                mesh.subMeshes = [];
                for (let subIndex = 0; subIndex < parsedGeometry.subMeshes.length; subIndex++) {
                    const parsedSubMesh = parsedGeometry.subMeshes[subIndex];
                    SubMesh.AddToMesh(parsedSubMesh.materialIndex, parsedSubMesh.verticesStart, parsedSubMesh.verticesCount, parsedSubMesh.indexStart, parsedSubMesh.indexCount, mesh);
                }
            }
            // Flat shading
            if (mesh._shouldGenerateFlatShading) {
                mesh.convertToFlatShadedMesh();
                mesh._shouldGenerateFlatShading = false;
            }
            // Update
            mesh.computeWorldMatrix(true);
            scene.onMeshImportedObservable.notifyObservers(mesh);
        }
        static _CleanMatricesWeights(parsedGeometry, mesh) {
            const epsilon = 1e-3;
            if (!SceneLoaderFlags.CleanBoneMatrixWeights) {
                return;
            }
            let noInfluenceBoneIndex = 0.0;
            if (parsedGeometry.skeletonId > -1) {
                const skeleton = mesh.getScene().getLastSkeletonById(parsedGeometry.skeletonId);
                if (!skeleton) {
                    return;
                }
                noInfluenceBoneIndex = skeleton.bones.length;
            }
            else {
                return;
            }
            const matricesIndices = mesh.getVerticesData(VertexBuffer.MatricesIndicesKind);
            const matricesIndicesExtra = mesh.getVerticesData(VertexBuffer.MatricesIndicesExtraKind);
            const matricesWeights = parsedGeometry.matricesWeights;
            const matricesWeightsExtra = parsedGeometry.matricesWeightsExtra;
            const influencers = parsedGeometry.numBoneInfluencer;
            const size = matricesWeights.length;
            for (let i = 0; i < size; i += 4) {
                let weight = 0.0;
                let firstZeroWeight = -1;
                for (let j = 0; j < 4; j++) {
                    const w = matricesWeights[i + j];
                    weight += w;
                    if (w < epsilon && firstZeroWeight < 0) {
                        firstZeroWeight = j;
                    }
                }
                if (matricesWeightsExtra) {
                    for (let j = 0; j < 4; j++) {
                        const w = matricesWeightsExtra[i + j];
                        weight += w;
                        if (w < epsilon && firstZeroWeight < 0) {
                            firstZeroWeight = j + 4;
                        }
                    }
                }
                if (firstZeroWeight < 0 || firstZeroWeight > influencers - 1) {
                    firstZeroWeight = influencers - 1;
                }
                if (weight > epsilon) {
                    const mweight = 1.0 / weight;
                    for (let j = 0; j < 4; j++) {
                        matricesWeights[i + j] *= mweight;
                    }
                    if (matricesWeightsExtra) {
                        for (let j = 0; j < 4; j++) {
                            matricesWeightsExtra[i + j] *= mweight;
                        }
                    }
                }
                else {
                    if (firstZeroWeight >= 4) {
                        matricesWeightsExtra[i + firstZeroWeight - 4] = 1.0 - weight;
                        matricesIndicesExtra[i + firstZeroWeight - 4] = noInfluenceBoneIndex;
                    }
                    else {
                        matricesWeights[i + firstZeroWeight] = 1.0 - weight;
                        matricesIndices[i + firstZeroWeight] = noInfluenceBoneIndex;
                    }
                }
            }
            mesh.setVerticesData(VertexBuffer.MatricesIndicesKind, matricesIndices);
            if (parsedGeometry.matricesWeightsExtra) {
                mesh.setVerticesData(VertexBuffer.MatricesIndicesExtraKind, matricesIndicesExtra);
            }
        }
        /**
         * Create a new geometry from persisted data (Using .babylon file format)
         * @param parsedVertexData defines the persisted data
         * @param scene defines the hosting scene
         * @param rootUrl defines the root url to use to load assets (like delayed data)
         * @returns the new geometry object
         */
        static Parse(parsedVertexData, scene, rootUrl) {
            const geometry = new Geometry(parsedVertexData.id, scene, undefined, parsedVertexData.updatable);
            geometry._loadedUniqueId = parsedVertexData.uniqueId;
            if (Tags) {
                Tags.AddTagsTo(geometry, parsedVertexData.tags);
            }
            if (parsedVertexData.delayLoadingFile) {
                geometry.delayLoadState = 4;
                geometry.delayLoadingFile = rootUrl + parsedVertexData.delayLoadingFile;
                geometry._boundingInfo = new BoundingInfo(Vector3.FromArray(parsedVertexData.boundingBoxMinimum), Vector3.FromArray(parsedVertexData.boundingBoxMaximum));
                geometry._delayInfo = [];
                if (parsedVertexData.hasUVs) {
                    geometry._delayInfo.push(VertexBuffer.UVKind);
                }
                if (parsedVertexData.hasUVs2) {
                    geometry._delayInfo.push(VertexBuffer.UV2Kind);
                }
                if (parsedVertexData.hasUVs3) {
                    geometry._delayInfo.push(VertexBuffer.UV3Kind);
                }
                if (parsedVertexData.hasUVs4) {
                    geometry._delayInfo.push(VertexBuffer.UV4Kind);
                }
                if (parsedVertexData.hasUVs5) {
                    geometry._delayInfo.push(VertexBuffer.UV5Kind);
                }
                if (parsedVertexData.hasUVs6) {
                    geometry._delayInfo.push(VertexBuffer.UV6Kind);
                }
                if (parsedVertexData.hasColors) {
                    geometry._delayInfo.push(VertexBuffer.ColorKind);
                }
                if (parsedVertexData.hasMatricesIndices) {
                    geometry._delayInfo.push(VertexBuffer.MatricesIndicesKind);
                }
                if (parsedVertexData.hasMatricesWeights) {
                    geometry._delayInfo.push(VertexBuffer.MatricesWeightsKind);
                }
                geometry._delayLoadingFunction = VertexData.ImportVertexData;
            }
            else {
                VertexData.ImportVertexData(parsedVertexData, geometry);
            }
            scene.pushGeometry(geometry, true);
            return geometry;
        }
    }

    /**
     * Performance monitor tracks rolling average frame-time and frame-time variance over a user defined sliding-window
     */
    class PerformanceMonitor {
        /**
         * constructor
         * @param frameSampleSize The number of samples required to saturate the sliding window
         */
        constructor(frameSampleSize = 30) {
            this._enabled = true;
            this._rollingFrameTime = new RollingAverage(frameSampleSize);
        }
        /**
         * Samples current frame
         * @param timeMs A timestamp in milliseconds of the current frame to compare with other frames
         */
        sampleFrame(timeMs = PrecisionDate.Now) {
            if (!this._enabled) {
                return;
            }
            if (this._lastFrameTimeMs != null) {
                const dt = timeMs - this._lastFrameTimeMs;
                this._rollingFrameTime.add(dt);
            }
            this._lastFrameTimeMs = timeMs;
        }
        /**
         * Returns the average frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
         */
        get averageFrameTime() {
            return this._rollingFrameTime.average;
        }
        /**
         * Returns the variance frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
         */
        get averageFrameTimeVariance() {
            return this._rollingFrameTime.variance;
        }
        /**
         * Returns the frame time of the most recent frame
         */
        get instantaneousFrameTime() {
            return this._rollingFrameTime.history(0);
        }
        /**
         * Returns the average framerate in frames per second over the sliding window (or the subset of frames sampled so far)
         */
        get averageFPS() {
            return 1000.0 / this._rollingFrameTime.average;
        }
        /**
         * Returns the average framerate in frames per second using the most recent frame time
         */
        get instantaneousFPS() {
            const history = this._rollingFrameTime.history(0);
            if (history === 0) {
                return 0;
            }
            return 1000.0 / history;
        }
        /**
         * Returns true if enough samples have been taken to completely fill the sliding window
         */
        get isSaturated() {
            return this._rollingFrameTime.isSaturated();
        }
        /**
         * Enables contributions to the sliding window sample set
         */
        enable() {
            this._enabled = true;
        }
        /**
         * Disables contributions to the sliding window sample set
         * Samples will not be interpolated over the disabled period
         */
        disable() {
            this._enabled = false;
            //clear last sample to avoid interpolating over the disabled period when next enabled
            this._lastFrameTimeMs = null;
        }
        /**
         * Returns true if sampling is enabled
         */
        get isEnabled() {
            return this._enabled;
        }
        /**
         * Resets performance monitor
         */
        reset() {
            //clear last sample to avoid interpolating over the disabled period when next enabled
            this._lastFrameTimeMs = null;
            //wipe record
            this._rollingFrameTime.reset();
        }
    }
    /**
     * RollingAverage
     *
     * Utility to efficiently compute the rolling average and variance over a sliding window of samples
     */
    class RollingAverage {
        /**
         * constructor
         * @param length The number of samples required to saturate the sliding window
         */
        constructor(length) {
            this._samples = new Array(length);
            this.reset();
        }
        /**
         * Adds a sample to the sample set
         * @param v The sample value
         */
        add(v) {
            //http://en.wikipedia.org/wiki/Algorithms_for_calculating_variance
            let delta;
            //we need to check if we've already wrapped round
            if (this.isSaturated()) {
                //remove bottom of stack from mean
                const bottomValue = this._samples[this._pos];
                delta = bottomValue - this.average;
                this.average -= delta / (this._sampleCount - 1);
                this._m2 -= delta * (bottomValue - this.average);
            }
            else {
                this._sampleCount++;
            }
            //add new value to mean
            delta = v - this.average;
            this.average += delta / this._sampleCount;
            this._m2 += delta * (v - this.average);
            //set the new variance
            this.variance = this._m2 / (this._sampleCount - 1);
            this._samples[this._pos] = v;
            this._pos++;
            this._pos %= this._samples.length; //positive wrap around
        }
        /**
         * Returns previously added values or null if outside of history or outside the sliding window domain
         * @param i Index in history. For example, pass 0 for the most recent value and 1 for the value before that
         * @returns Value previously recorded with add() or null if outside of range
         */
        history(i) {
            if (i >= this._sampleCount || i >= this._samples.length) {
                return 0;
            }
            const i0 = this._wrapPosition(this._pos - 1.0);
            return this._samples[this._wrapPosition(i0 - i)];
        }
        /**
         * Returns true if enough samples have been taken to completely fill the sliding window
         * @returns true if sample-set saturated
         */
        isSaturated() {
            return this._sampleCount >= this._samples.length;
        }
        /**
         * Resets the rolling average (equivalent to 0 samples taken so far)
         */
        reset() {
            this.average = 0;
            this.variance = 0;
            this._sampleCount = 0;
            this._pos = 0;
            this._m2 = 0;
        }
        /**
         * Wraps a value around the sample range boundaries
         * @param i Position in sample range, for example if the sample length is 5, and i is -3, then 2 will be returned.
         * @returns Wrapped position in sample range
         */
        _wrapPosition(i) {
            const max = this._samples.length;
            return ((i % max) + max) % max;
        }
    }

    ThinEngine.prototype.setAlphaConstants = function (r, g, b, a) {
        this._alphaState.setAlphaBlendConstants(r, g, b, a);
    };
    ThinEngine.prototype.setAlphaMode = function (mode, noDepthWriteChange = false) {
        if (this._alphaMode === mode) {
            if (!noDepthWriteChange) {
                // Make sure we still have the correct depth mask according to the alpha mode (a transparent material could have forced writting to the depth buffer, for instance)
                const depthMask = mode === 0;
                if (this.depthCullingState.depthMask !== depthMask) {
                    this.depthCullingState.depthMask = depthMask;
                }
            }
            return;
        }
        switch (mode) {
            case 0:
                this._alphaState.alphaBlend = false;
                break;
            case 7:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 8:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
                this._alphaState.alphaBlend = true;
                break;
            case 2:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 6:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ZERO, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 1:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 3:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ZERO, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 4:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_COLOR, this._gl.ZERO, this._gl.ONE, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 5:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 9:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.CONSTANT_COLOR, this._gl.ONE_MINUS_CONSTANT_COLOR, this._gl.CONSTANT_ALPHA, this._gl.ONE_MINUS_CONSTANT_ALPHA);
                this._alphaState.alphaBlend = true;
                break;
            case 10:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
                this._alphaState.alphaBlend = true;
                break;
            case 11:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 12:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ZERO);
                this._alphaState.alphaBlend = true;
                break;
            case 13:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE_MINUS_DST_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA);
                this._alphaState.alphaBlend = true;
                break;
            case 14:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
                this._alphaState.alphaBlend = true;
                break;
            case 15:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ZERO);
                this._alphaState.alphaBlend = true;
                break;
            case 16:
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ZERO, this._gl.ONE);
                this._alphaState.alphaBlend = true;
                break;
            case 17:
                // Same as ALPHA_COMBINE but accumulates (1 - alpha) values in the alpha channel for a later readout in order independant transparency
                this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
                this._alphaState.alphaBlend = true;
                break;
        }
        if (!noDepthWriteChange) {
            this.depthCullingState.depthMask = mode === 0;
        }
        this._alphaMode = mode;
    };
    ThinEngine.prototype.getAlphaMode = function () {
        return this._alphaMode;
    };
    ThinEngine.prototype.setAlphaEquation = function (equation) {
        if (this._alphaEquation === equation) {
            return;
        }
        switch (equation) {
            case 0:
                this._alphaState.setAlphaEquationParameters(32774, 32774);
                break;
            case 1:
                this._alphaState.setAlphaEquationParameters(32778, 32778);
                break;
            case 2:
                this._alphaState.setAlphaEquationParameters(32779, 32779);
                break;
            case 3:
                this._alphaState.setAlphaEquationParameters(32776, 32776);
                break;
            case 4:
                this._alphaState.setAlphaEquationParameters(32775, 32775);
                break;
            case 5:
                this._alphaState.setAlphaEquationParameters(32775, 32774);
                break;
        }
        this._alphaEquation = equation;
    };
    ThinEngine.prototype.getAlphaEquation = function () {
        return this._alphaEquation;
    };

    /**
     * Allocate a typed array depending on a texture type. Optionally can copy existing data in the buffer.
     * @param type type of the texture
     * @param sizeOrDstBuffer size of the array OR an existing buffer that will be used as the destination of the copy (if copyBuffer is provided)
     * @param sizeInBytes true if the size of the array is given in bytes, false if it is the number of elements of the array
     * @param copyBuffer if provided, buffer to copy into the destination buffer (either a newly allocated buffer if sizeOrDstBuffer is a number or use sizeOrDstBuffer as the destination buffer otherwise)
     * @returns the allocated buffer or sizeOrDstBuffer if the latter is an ArrayBuffer
     */
    function allocateAndCopyTypedBuffer(type, sizeOrDstBuffer, sizeInBytes = false, copyBuffer) {
        switch (type) {
            case 3: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int8Array(sizeOrDstBuffer) : new Int8Array(sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Int8Array(copyBuffer));
                }
                return buffer;
            }
            case 0: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Uint8Array(copyBuffer));
                }
                return buffer;
            }
            case 4: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int16Array(sizeOrDstBuffer) : new Int16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Int16Array(copyBuffer));
                }
                return buffer;
            }
            case 5:
            case 8:
            case 9:
            case 10:
            case 2: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint16Array(sizeOrDstBuffer) : new Uint16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Uint16Array(copyBuffer));
                }
                return buffer;
            }
            case 6: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int32Array(sizeOrDstBuffer) : new Int32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Int32Array(copyBuffer));
                }
                return buffer;
            }
            case 7:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint32Array(sizeOrDstBuffer) : new Uint32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Uint32Array(copyBuffer));
                }
                return buffer;
            }
            case 1: {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Float32Array(sizeOrDstBuffer) : new Float32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) {
                    buffer.set(new Float32Array(copyBuffer));
                }
                return buffer;
            }
        }
        const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);
        if (copyBuffer) {
            buffer.set(new Uint8Array(copyBuffer));
        }
        return buffer;
    }
    ThinEngine.prototype._readTexturePixelsSync = function (texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
        var _a, _b;
        const gl = this._gl;
        if (!gl) {
            throw new Error("Engine does not have gl rendering context.");
        }
        if (!this._dummyFramebuffer) {
            const dummy = gl.createFramebuffer();
            if (!dummy) {
                throw new Error("Unable to create dummy framebuffer");
            }
            this._dummyFramebuffer = dummy;
        }
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._dummyFramebuffer);
        if (faceIndex > -1) {
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, (_a = texture._hardwareTexture) === null || _a === void 0 ? void 0 : _a.underlyingResource, level);
        }
        else {
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, (_b = texture._hardwareTexture) === null || _b === void 0 ? void 0 : _b.underlyingResource, level);
        }
        let readType = texture.type !== undefined ? this._getWebGLTextureType(texture.type) : gl.UNSIGNED_BYTE;
        if (!noDataConversion) {
            switch (readType) {
                case gl.UNSIGNED_BYTE:
                    if (!buffer) {
                        buffer = new Uint8Array(4 * width * height);
                    }
                    readType = gl.UNSIGNED_BYTE;
                    break;
                default:
                    if (!buffer) {
                        buffer = new Float32Array(4 * width * height);
                    }
                    readType = gl.FLOAT;
                    break;
            }
        }
        else if (!buffer) {
            buffer = allocateAndCopyTypedBuffer(texture.type, 4 * width * height);
        }
        if (flushRenderer) {
            this.flushFramebuffer();
        }
        gl.readPixels(x, y, width, height, gl.RGBA, readType, buffer);
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._currentFramebuffer);
        return buffer;
    };
    ThinEngine.prototype._readTexturePixels = function (texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
        return Promise.resolve(this._readTexturePixelsSync(texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion, x, y));
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ThinEngine.prototype.updateDynamicIndexBuffer = function (indexBuffer, indices, offset = 0) {
        // Force cache update
        this._currentBoundBuffer[this._gl.ELEMENT_ARRAY_BUFFER] = null;
        this.bindIndexBuffer(indexBuffer);
        let view;
        if (indexBuffer.is32Bits) {
            // anything else than Uint32Array needs to be converted to Uint32Array
            view = indices instanceof Uint32Array ? indices : new Uint32Array(indices);
        }
        else {
            // anything else than Uint16Array needs to be converted to Uint16Array
            view = indices instanceof Uint16Array ? indices : new Uint16Array(indices);
        }
        this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, view, this._gl.DYNAMIC_DRAW);
        this._resetIndexBufferBinding();
    };
    ThinEngine.prototype.updateDynamicVertexBuffer = function (vertexBuffer, data, byteOffset, byteLength) {
        this.bindArrayBuffer(vertexBuffer);
        if (byteOffset === undefined) {
            byteOffset = 0;
        }
        const dataLength = data.byteLength || data.length;
        if (byteLength === undefined || (byteLength >= dataLength && byteOffset === 0)) {
            if (data instanceof Array) {
                this._gl.bufferSubData(this._gl.ARRAY_BUFFER, byteOffset, new Float32Array(data));
            }
            else {
                this._gl.bufferSubData(this._gl.ARRAY_BUFFER, byteOffset, data);
            }
        }
        else {
            if (data instanceof Array) {
                this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, new Float32Array(data).subarray(byteOffset, byteOffset + byteLength));
            }
            else {
                if (data instanceof ArrayBuffer) {
                    data = new Uint8Array(data, byteOffset, byteLength);
                }
                else {
                    data = new Uint8Array(data.buffer, data.byteOffset + byteOffset, byteLength);
                }
                this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
            }
        }
        this._resetVertexBufferBinding();
    };

    /**
     * The engine class is responsible for interfacing with all lower-level APIs such as WebGL and Audio
     */
    class Engine extends ThinEngine {
        /**
         * Returns the current npm package of the sdk
         */
        // Not mixed with Version for tooling purpose.
        static get NpmPackage() {
            return ThinEngine.NpmPackage;
        }
        /**
         * Returns the current version of the framework
         */
        static get Version() {
            return ThinEngine.Version;
        }
        /** Gets the list of created engines */
        static get Instances() {
            return EngineStore.Instances;
        }
        /**
         * Gets the latest created engine
         */
        static get LastCreatedEngine() {
            return EngineStore.LastCreatedEngine;
        }
        /**
         * Gets the latest created scene
         */
        static get LastCreatedScene() {
            return EngineStore.LastCreatedScene;
        }
        /** @internal */
        /**
         * Engine abstraction for loading and creating an image bitmap from a given source string.
         * @param imageSource source to load the image from.
         * @param options An object that sets options for the image's extraction.
         * @returns ImageBitmap.
         */
        _createImageBitmapFromSource(imageSource, options) {
            const promise = new Promise((resolve, reject) => {
                const image = new Image();
                image.onload = () => {
                    image.decode().then(() => {
                        this.createImageBitmap(image, options).then((imageBitmap) => {
                            resolve(imageBitmap);
                        });
                    });
                };
                image.onerror = () => {
                    reject(`Error loading image ${image.src}`);
                };
                image.src = imageSource;
            });
            return promise;
        }
        /**
         * Engine abstraction for createImageBitmap
         * @param image source for image
         * @param options An object that sets options for the image's extraction.
         * @returns ImageBitmap
         */
        createImageBitmap(image, options) {
            return createImageBitmap(image, options);
        }
        /**
         * Resize an image and returns the image data as an uint8array
         * @param image image to resize
         * @param bufferWidth destination buffer width
         * @param bufferHeight destination buffer height
         * @returns an uint8array containing RGBA values of bufferWidth * bufferHeight size
         */
        resizeImageBitmap(image, bufferWidth, bufferHeight) {
            const canvas = this.createCanvas(bufferWidth, bufferHeight);
            const context = canvas.getContext("2d");
            if (!context) {
                throw new Error("Unable to get 2d context for resizeImageBitmap");
            }
            context.drawImage(image, 0, 0);
            // Create VertexData from map data
            // Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949
            const buffer = context.getImageData(0, 0, bufferWidth, bufferHeight).data;
            return buffer;
        }
        /**
         * Will flag all materials in all scenes in all engines as dirty to trigger new shader compilation
         * @param flag defines which part of the materials must be marked as dirty
         * @param predicate defines a predicate used to filter which materials should be affected
         */
        static MarkAllMaterialsAsDirty(flag, predicate) {
            for (let engineIndex = 0; engineIndex < Engine.Instances.length; engineIndex++) {
                const engine = Engine.Instances[engineIndex];
                for (let sceneIndex = 0; sceneIndex < engine.scenes.length; sceneIndex++) {
                    engine.scenes[sceneIndex].markAllMaterialsAsDirty(flag, predicate);
                }
            }
        }
        /**
         * Method called to create the default loading screen.
         * This can be overridden in your own app.
         * @param canvas The rendering canvas element
         * @returns The loading screen
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static DefaultLoadingScreenFactory(canvas) {
            throw _WarnImport("LoadingScreen");
        }
        get _supportsHardwareTextureRescaling() {
            return !!Engine._RescalePostProcessFactory;
        }
        /**
         * Gets the performance monitor attached to this engine
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#engineinstrumentation
         */
        get performanceMonitor() {
            return this._performanceMonitor;
        }
        /**
         * (WebGPU only) True (default) to be in compatibility mode, meaning rendering all existing scenes without artifacts (same rendering than WebGL).
         * Setting the property to false will improve performances but may not work in some scenes if some precautions are not taken.
         * See https://doc.babylonjs.com/setup/support/webGPU/webGPUOptimization/webGPUNonCompatibilityMode for more details
         */
        get compatibilityMode() {
            return this._compatibilityMode;
        }
        set compatibilityMode(mode) {
            // not supported in WebGL
            this._compatibilityMode = true;
        }
        // Events
        /**
         * Gets the HTML element used to attach event listeners
         * @returns a HTML element
         */
        getInputElement() {
            return this._renderingCanvas;
        }
        /**
         * Creates a new engine
         * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
         * @param antialias defines enable antialiasing (default: false)
         * @param options defines further options to be sent to the getContext() function
         * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
         */
        constructor(canvasOrContext, antialias, options, adaptToDeviceRatio = false) {
            super(canvasOrContext, antialias, options, adaptToDeviceRatio);
            // Members
            /**
             * Gets or sets a boolean to enable/disable IndexedDB support and avoid XHR on .manifest
             **/
            this.enableOfflineSupport = false;
            /**
             * Gets or sets a boolean to enable/disable checking manifest if IndexedDB support is enabled (js will always consider the database is up to date)
             **/
            this.disableManifestCheck = false;
            /**
             * Gets or sets a boolean to enable/disable the context menu (right-click) from appearing on the main canvas
             */
            this.disableContextMenu = true;
            /**
             * Gets the list of created scenes
             */
            this.scenes = new Array();
            /** @internal */
            this._virtualScenes = new Array();
            /**
             * Event raised when a new scene is created
             */
            this.onNewSceneAddedObservable = new Observable$1();
            /**
             * Gets the list of created postprocesses
             */
            this.postProcesses = new Array();
            /**
             * Gets a boolean indicating if the pointer is currently locked
             */
            this.isPointerLock = false;
            // Observables
            /**
             * Observable event triggered each time the rendering canvas is resized
             */
            this.onResizeObservable = new Observable$1();
            /**
             * Observable event triggered each time the canvas loses focus
             */
            this.onCanvasBlurObservable = new Observable$1();
            /**
             * Observable event triggered each time the canvas gains focus
             */
            this.onCanvasFocusObservable = new Observable$1();
            /**
             * Observable event triggered each time the canvas receives pointerout event
             */
            this.onCanvasPointerOutObservable = new Observable$1();
            /**
             * Observable raised when the engine begins a new frame
             */
            this.onBeginFrameObservable = new Observable$1();
            /**
             * If set, will be used to request the next animation frame for the render loop
             */
            this.customAnimationFrameRequester = null;
            /**
             * Observable raised when the engine ends the current frame
             */
            this.onEndFrameObservable = new Observable$1();
            /**
             * Observable raised when the engine is about to compile a shader
             */
            this.onBeforeShaderCompilationObservable = new Observable$1();
            /**
             * Observable raised when the engine has just compiled a shader
             */
            this.onAfterShaderCompilationObservable = new Observable$1();
            // Deterministic lockstepMaxSteps
            this._deterministicLockstep = false;
            this._lockstepMaxSteps = 4;
            this._timeStep = 1 / 60;
            // FPS
            this._fps = 60;
            this._deltaTime = 0;
            /** @internal */
            this._drawCalls = new PerfCounter();
            /** Gets or sets the tab index to set to the rendering canvas. 1 is the minimum value to set to be able to capture keyboard events */
            this.canvasTabIndex = 1;
            /**
             * Turn this value on if you want to pause FPS computation when in background
             */
            this.disablePerformanceMonitorInBackground = false;
            this._performanceMonitor = new PerformanceMonitor();
            this._compatibilityMode = true;
            /**
             * Gets or sets the current render pass id
             */
            this.currentRenderPassId = 0;
            this._renderPassNames = ["main"];
            Engine.Instances.push(this);
            if (!canvasOrContext) {
                return;
            }
            this._features.supportRenderPasses = true;
            options = this._creationOptions;
            if (canvasOrContext.getContext) {
                const canvas = canvasOrContext;
                this._sharedInit(canvas);
                this._connectVREvents();
            }
            // Load WebVR Devices
            this._prepareVRComponent();
            if (options.autoEnableWebVR) {
                this.initWebVR();
            }
        }
        _initGLContext() {
            super._initGLContext();
            this._rescalePostProcess = null;
        }
        /**
         * Shared initialization across engines types.
         * @param canvas The canvas associated with this instance of the engine.
         */
        _sharedInit(canvas) {
            super._sharedInit(canvas);
            this._onCanvasFocus = () => {
                this.onCanvasFocusObservable.notifyObservers(this);
            };
            this._onCanvasBlur = () => {
                this.onCanvasBlurObservable.notifyObservers(this);
            };
            this._onCanvasContextMenu = (evt) => {
                if (this.disableContextMenu) {
                    evt.preventDefault();
                }
            };
            canvas.addEventListener("focus", this._onCanvasFocus);
            canvas.addEventListener("blur", this._onCanvasBlur);
            canvas.addEventListener("contextmenu", this._onCanvasContextMenu);
            this._onBlur = () => {
                if (this.disablePerformanceMonitorInBackground) {
                    this._performanceMonitor.disable();
                }
                this._windowIsBackground = true;
            };
            this._onFocus = () => {
                if (this.disablePerformanceMonitorInBackground) {
                    this._performanceMonitor.enable();
                }
                this._windowIsBackground = false;
            };
            this._onCanvasPointerOut = (ev) => {
                // Check that the element at the point of the pointer out isn't the canvas and if it isn't, notify observers
                // Note: This is a workaround for a bug with Safari
                if (document.elementFromPoint(ev.clientX, ev.clientY) !== canvas) {
                    this.onCanvasPointerOutObservable.notifyObservers(ev);
                }
            };
            const hostWindow = this.getHostWindow(); // it calls IsWindowObjectExist()
            if (hostWindow && typeof hostWindow.addEventListener === "function") {
                hostWindow.addEventListener("blur", this._onBlur);
                hostWindow.addEventListener("focus", this._onFocus);
            }
            canvas.addEventListener("pointerout", this._onCanvasPointerOut);
            if (!this._creationOptions.doNotHandleTouchAction) {
                this._disableTouchAction();
            }
            // Create Audio Engine if needed.
            if (!Engine.audioEngine && this._creationOptions.audioEngine && Engine.AudioEngineFactory) {
                Engine.audioEngine = Engine.AudioEngineFactory(this.getRenderingCanvas(), this.getAudioContext(), this.getAudioDestination());
            }
            if (IsDocumentAvailable()) {
                // Fullscreen
                this._onFullscreenChange = () => {
                    this.isFullscreen = !!document.fullscreenElement;
                    // Pointer lock
                    if (this.isFullscreen && this._pointerLockRequested && canvas) {
                        Engine._RequestPointerlock(canvas);
                    }
                };
                document.addEventListener("fullscreenchange", this._onFullscreenChange, false);
                document.addEventListener("webkitfullscreenchange", this._onFullscreenChange, false);
                // Pointer lock
                this._onPointerLockChange = () => {
                    this.isPointerLock = document.pointerLockElement === canvas;
                };
                document.addEventListener("pointerlockchange", this._onPointerLockChange, false);
                document.addEventListener("webkitpointerlockchange", this._onPointerLockChange, false);
            }
            this.enableOfflineSupport = Engine.OfflineProviderFactory !== undefined;
            this._deterministicLockstep = !!this._creationOptions.deterministicLockstep;
            this._lockstepMaxSteps = this._creationOptions.lockstepMaxSteps || 0;
            this._timeStep = this._creationOptions.timeStep || 1 / 60;
        }
        /** @internal */
        _verifyPointerLock() {
            var _a;
            (_a = this._onPointerLockChange) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        /**
         * Gets current aspect ratio
         * @param viewportOwner defines the camera to use to get the aspect ratio
         * @param useScreen defines if screen size must be used (or the current render target if any)
         * @returns a number defining the aspect ratio
         */
        getAspectRatio(viewportOwner, useScreen = false) {
            const viewport = viewportOwner.viewport;
            return (this.getRenderWidth(useScreen) * viewport.width) / (this.getRenderHeight(useScreen) * viewport.height);
        }
        /**
         * Gets current screen aspect ratio
         * @returns a number defining the aspect ratio
         */
        getScreenAspectRatio() {
            return this.getRenderWidth(true) / this.getRenderHeight(true);
        }
        /**
         * Gets the client rect of the HTML canvas attached with the current webGL context
         * @returns a client rectangle
         */
        getRenderingCanvasClientRect() {
            if (!this._renderingCanvas) {
                return null;
            }
            return this._renderingCanvas.getBoundingClientRect();
        }
        /**
         * Gets the client rect of the HTML element used for events
         * @returns a client rectangle
         */
        getInputElementClientRect() {
            if (!this._renderingCanvas) {
                return null;
            }
            return this.getInputElement().getBoundingClientRect();
        }
        /**
         * Gets a boolean indicating that the engine is running in deterministic lock step mode
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         * @returns true if engine is in deterministic lock step mode
         */
        isDeterministicLockStep() {
            return this._deterministicLockstep;
        }
        /**
         * Gets the max steps when engine is running in deterministic lock step
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         * @returns the max steps
         */
        getLockstepMaxSteps() {
            return this._lockstepMaxSteps;
        }
        /**
         * Returns the time in ms between steps when using deterministic lock step.
         * @returns time step in (ms)
         */
        getTimeStep() {
            return this._timeStep * 1000;
        }
        /**
         * Force the mipmap generation for the given render target texture
         * @param texture defines the render target texture to use
         * @param unbind defines whether or not to unbind the texture after generation. Defaults to true.
         */
        generateMipMapsForCubemap(texture, unbind = true) {
            if (texture.generateMipMaps) {
                const gl = this._gl;
                this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
                gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
                if (unbind) {
                    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
                }
            }
        }
        /** States */
        /**
         * Gets a boolean indicating if depth writing is enabled
         * @returns the current depth writing state
         */
        getDepthWrite() {
            return this._depthCullingState.depthMask;
        }
        /**
         * Enable or disable depth writing
         * @param enable defines the state to set
         */
        setDepthWrite(enable) {
            this._depthCullingState.depthMask = enable;
        }
        /**
         * Gets a boolean indicating if stencil buffer is enabled
         * @returns the current stencil buffer state
         */
        getStencilBuffer() {
            return this._stencilState.stencilTest;
        }
        /**
         * Enable or disable the stencil buffer
         * @param enable defines if the stencil buffer must be enabled or disabled
         */
        setStencilBuffer(enable) {
            this._stencilState.stencilTest = enable;
        }
        /**
         * Gets the current stencil mask
         * @returns a number defining the new stencil mask to use
         */
        getStencilMask() {
            return this._stencilState.stencilMask;
        }
        /**
         * Sets the current stencil mask
         * @param mask defines the new stencil mask to use
         */
        setStencilMask(mask) {
            this._stencilState.stencilMask = mask;
        }
        /**
         * Gets the current stencil function
         * @returns a number defining the stencil function to use
         */
        getStencilFunction() {
            return this._stencilState.stencilFunc;
        }
        /**
         * Gets the current stencil reference value
         * @returns a number defining the stencil reference value to use
         */
        getStencilFunctionReference() {
            return this._stencilState.stencilFuncRef;
        }
        /**
         * Gets the current stencil mask
         * @returns a number defining the stencil mask to use
         */
        getStencilFunctionMask() {
            return this._stencilState.stencilFuncMask;
        }
        /**
         * Sets the current stencil function
         * @param stencilFunc defines the new stencil function to use
         */
        setStencilFunction(stencilFunc) {
            this._stencilState.stencilFunc = stencilFunc;
        }
        /**
         * Sets the current stencil reference
         * @param reference defines the new stencil reference to use
         */
        setStencilFunctionReference(reference) {
            this._stencilState.stencilFuncRef = reference;
        }
        /**
         * Sets the current stencil mask
         * @param mask defines the new stencil mask to use
         */
        setStencilFunctionMask(mask) {
            this._stencilState.stencilFuncMask = mask;
        }
        /**
         * Gets the current stencil operation when stencil fails
         * @returns a number defining stencil operation to use when stencil fails
         */
        getStencilOperationFail() {
            return this._stencilState.stencilOpStencilFail;
        }
        /**
         * Gets the current stencil operation when depth fails
         * @returns a number defining stencil operation to use when depth fails
         */
        getStencilOperationDepthFail() {
            return this._stencilState.stencilOpDepthFail;
        }
        /**
         * Gets the current stencil operation when stencil passes
         * @returns a number defining stencil operation to use when stencil passes
         */
        getStencilOperationPass() {
            return this._stencilState.stencilOpStencilDepthPass;
        }
        /**
         * Sets the stencil operation to use when stencil fails
         * @param operation defines the stencil operation to use when stencil fails
         */
        setStencilOperationFail(operation) {
            this._stencilState.stencilOpStencilFail = operation;
        }
        /**
         * Sets the stencil operation to use when depth fails
         * @param operation defines the stencil operation to use when depth fails
         */
        setStencilOperationDepthFail(operation) {
            this._stencilState.stencilOpDepthFail = operation;
        }
        /**
         * Sets the stencil operation to use when stencil passes
         * @param operation defines the stencil operation to use when stencil passes
         */
        setStencilOperationPass(operation) {
            this._stencilState.stencilOpStencilDepthPass = operation;
        }
        /**
         * Sets a boolean indicating if the dithering state is enabled or disabled
         * @param value defines the dithering state
         */
        setDitheringState(value) {
            if (value) {
                this._gl.enable(this._gl.DITHER);
            }
            else {
                this._gl.disable(this._gl.DITHER);
            }
        }
        /**
         * Sets a boolean indicating if the rasterizer state is enabled or disabled
         * @param value defines the rasterizer state
         */
        setRasterizerState(value) {
            if (value) {
                this._gl.disable(this._gl.RASTERIZER_DISCARD);
            }
            else {
                this._gl.enable(this._gl.RASTERIZER_DISCARD);
            }
        }
        /**
         * Gets the current depth function
         * @returns a number defining the depth function
         */
        getDepthFunction() {
            return this._depthCullingState.depthFunc;
        }
        /**
         * Sets the current depth function
         * @param depthFunc defines the function to use
         */
        setDepthFunction(depthFunc) {
            this._depthCullingState.depthFunc = depthFunc;
        }
        /**
         * Sets the current depth function to GREATER
         */
        setDepthFunctionToGreater() {
            this.setDepthFunction(516);
        }
        /**
         * Sets the current depth function to GEQUAL
         */
        setDepthFunctionToGreaterOrEqual() {
            this.setDepthFunction(518);
        }
        /**
         * Sets the current depth function to LESS
         */
        setDepthFunctionToLess() {
            this.setDepthFunction(513);
        }
        /**
         * Sets the current depth function to LEQUAL
         */
        setDepthFunctionToLessOrEqual() {
            this.setDepthFunction(515);
        }
        /**
         * Caches the the state of the stencil buffer
         */
        cacheStencilState() {
            this._cachedStencilBuffer = this.getStencilBuffer();
            this._cachedStencilFunction = this.getStencilFunction();
            this._cachedStencilMask = this.getStencilMask();
            this._cachedStencilOperationPass = this.getStencilOperationPass();
            this._cachedStencilOperationFail = this.getStencilOperationFail();
            this._cachedStencilOperationDepthFail = this.getStencilOperationDepthFail();
            this._cachedStencilReference = this.getStencilFunctionReference();
        }
        /**
         * Restores the state of the stencil buffer
         */
        restoreStencilState() {
            this.setStencilFunction(this._cachedStencilFunction);
            this.setStencilMask(this._cachedStencilMask);
            this.setStencilBuffer(this._cachedStencilBuffer);
            this.setStencilOperationPass(this._cachedStencilOperationPass);
            this.setStencilOperationFail(this._cachedStencilOperationFail);
            this.setStencilOperationDepthFail(this._cachedStencilOperationDepthFail);
            this.setStencilFunctionReference(this._cachedStencilReference);
        }
        /**
         * Directly set the WebGL Viewport
         * @param x defines the x coordinate of the viewport (in screen space)
         * @param y defines the y coordinate of the viewport (in screen space)
         * @param width defines the width of the viewport (in screen space)
         * @param height defines the height of the viewport (in screen space)
         * @returns the current viewport Object (if any) that is being replaced by this call. You can restore this viewport later on to go back to the original state
         */
        setDirectViewport(x, y, width, height) {
            const currentViewport = this._cachedViewport;
            this._cachedViewport = null;
            this._viewport(x, y, width, height);
            return currentViewport;
        }
        /**
         * Executes a scissor clear (ie. a clear on a specific portion of the screen)
         * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
         * @param y defines the y-coordinate of the corner of the clear rectangle
         * @param width defines the width of the clear rectangle
         * @param height defines the height of the clear rectangle
         * @param clearColor defines the clear color
         */
        scissorClear(x, y, width, height, clearColor) {
            this.enableScissor(x, y, width, height);
            this.clear(clearColor, true, true, true);
            this.disableScissor();
        }
        /**
         * Enable scissor test on a specific rectangle (ie. render will only be executed on a specific portion of the screen)
         * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
         * @param y defines the y-coordinate of the corner of the clear rectangle
         * @param width defines the width of the clear rectangle
         * @param height defines the height of the clear rectangle
         */
        enableScissor(x, y, width, height) {
            const gl = this._gl;
            // Change state
            gl.enable(gl.SCISSOR_TEST);
            gl.scissor(x, y, width, height);
        }
        /**
         * Disable previously set scissor test rectangle
         */
        disableScissor() {
            const gl = this._gl;
            gl.disable(gl.SCISSOR_TEST);
        }
        /**
         * @internal
         */
        _reportDrawCall(numDrawCalls = 1) {
            this._drawCalls.addCount(numDrawCalls, false);
        }
        /**
         * Initializes a webVR display and starts listening to display change events
         * The onVRDisplayChangedObservable will be notified upon these changes
         * @returns The onVRDisplayChangedObservable
         */
        initWebVR() {
            throw _WarnImport("WebVRCamera");
        }
        /** @internal */
        _prepareVRComponent() {
            // Do nothing as the engine side effect will overload it
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _connectVREvents(canvas, document) {
            // Do nothing as the engine side effect will overload it
        }
        /** @internal */
        _submitVRFrame() {
            // Do nothing as the engine side effect will overload it
        }
        /**
         * Call this function to leave webVR mode
         * Will do nothing if webVR is not supported or if there is no webVR device
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/webVRCamera
         */
        disableVR() {
            // Do nothing as the engine side effect will overload it
        }
        /**
         * Gets a boolean indicating that the system is in VR mode and is presenting
         * @returns true if VR mode is engaged
         */
        isVRPresenting() {
            return false;
        }
        /** @internal */
        _requestVRFrame() {
            // Do nothing as the engine side effect will overload it
        }
        /**
         * @internal
         */
        _loadFileAsync(url, offlineProvider, useArrayBuffer) {
            return new Promise((resolve, reject) => {
                this._loadFile(url, (data) => {
                    resolve(data);
                }, undefined, offlineProvider, useArrayBuffer, (request, exception) => {
                    reject(exception);
                });
            });
        }
        /**
         * Gets the source code of the vertex shader associated with a specific webGL program
         * @param program defines the program to use
         * @returns a string containing the source code of the vertex shader associated with the program
         */
        getVertexShaderSource(program) {
            const shaders = this._gl.getAttachedShaders(program);
            if (!shaders) {
                return null;
            }
            return this._gl.getShaderSource(shaders[0]);
        }
        /**
         * Gets the source code of the fragment shader associated with a specific webGL program
         * @param program defines the program to use
         * @returns a string containing the source code of the fragment shader associated with the program
         */
        getFragmentShaderSource(program) {
            const shaders = this._gl.getAttachedShaders(program);
            if (!shaders) {
                return null;
            }
            return this._gl.getShaderSource(shaders[1]);
        }
        /**
         * Sets a depth stencil texture from a render target to the according uniform.
         * @param channel The texture channel
         * @param uniform The uniform to set
         * @param texture The render target texture containing the depth stencil texture to apply
         * @param name The texture name
         */
        setDepthStencilTexture(channel, uniform, texture, name) {
            if (channel === undefined) {
                return;
            }
            if (uniform) {
                this._boundUniforms[channel] = uniform;
            }
            if (!texture || !texture.depthStencilTexture) {
                this._setTexture(channel, null, undefined, undefined, name);
            }
            else {
                this._setTexture(channel, texture, false, true, name);
            }
        }
        /**
         * Sets a texture to the webGL context from a postprocess
         * @param channel defines the channel to use
         * @param postProcess defines the source postprocess
         * @param name name of the channel
         */
        setTextureFromPostProcess(channel, postProcess, name) {
            var _a;
            let postProcessInput = null;
            if (postProcess) {
                if (postProcess._forcedOutputTexture) {
                    postProcessInput = postProcess._forcedOutputTexture;
                }
                else if (postProcess._textures.data[postProcess._currentRenderTextureInd]) {
                    postProcessInput = postProcess._textures.data[postProcess._currentRenderTextureInd];
                }
            }
            this._bindTexture(channel, (_a = postProcessInput === null || postProcessInput === void 0 ? void 0 : postProcessInput.texture) !== null && _a !== void 0 ? _a : null, name);
        }
        /**
         * Binds the output of the passed in post process to the texture channel specified
         * @param channel The channel the texture should be bound to
         * @param postProcess The post process which's output should be bound
         * @param name name of the channel
         */
        setTextureFromPostProcessOutput(channel, postProcess, name) {
            var _a, _b;
            this._bindTexture(channel, (_b = (_a = postProcess === null || postProcess === void 0 ? void 0 : postProcess._outputTexture) === null || _a === void 0 ? void 0 : _a.texture) !== null && _b !== void 0 ? _b : null, name);
        }
        _rebuildBuffers() {
            // Index / Vertex
            for (const scene of this.scenes) {
                scene.resetCachedMaterial();
                scene._rebuildGeometries();
                scene._rebuildTextures();
            }
            for (const scene of this._virtualScenes) {
                scene.resetCachedMaterial();
                scene._rebuildGeometries();
                scene._rebuildTextures();
            }
            super._rebuildBuffers();
        }
        /** @internal */
        _renderFrame() {
            for (let index = 0; index < this._activeRenderLoops.length; index++) {
                const renderFunction = this._activeRenderLoops[index];
                renderFunction();
            }
        }
        _cancelFrame() {
            if (this._renderingQueueLaunched && this.customAnimationFrameRequester) {
                this._renderingQueueLaunched = false;
                const { cancelAnimationFrame } = this.customAnimationFrameRequester;
                if (cancelAnimationFrame) {
                    cancelAnimationFrame(this.customAnimationFrameRequester.requestID);
                }
            }
            else {
                super._cancelFrame();
            }
        }
        _renderLoop() {
            if (!this._contextWasLost) {
                let shouldRender = true;
                if (this.isDisposed || (!this.renderEvenInBackground && this._windowIsBackground)) {
                    shouldRender = false;
                }
                if (shouldRender) {
                    // Start new frame
                    this.beginFrame();
                    // Child canvases
                    if (!this._renderViews()) {
                        // Main frame
                        this._renderFrame();
                    }
                    // Present
                    this.endFrame();
                }
            }
            if (this._activeRenderLoops.length > 0) {
                // Register new frame
                if (this.customAnimationFrameRequester) {
                    this.customAnimationFrameRequester.requestID = this._queueNewFrame(this.customAnimationFrameRequester.renderFunction || this._boundRenderFunction, this.customAnimationFrameRequester);
                    this._frameHandler = this.customAnimationFrameRequester.requestID;
                }
                else if (this.isVRPresenting()) {
                    this._requestVRFrame();
                }
                else {
                    this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
                }
            }
            else {
                this._renderingQueueLaunched = false;
            }
        }
        /** @internal */
        _renderViews() {
            return false;
        }
        /**
         * Toggle full screen mode
         * @param requestPointerLock defines if a pointer lock should be requested from the user
         */
        switchFullscreen(requestPointerLock) {
            if (this.isFullscreen) {
                this.exitFullscreen();
            }
            else {
                this.enterFullscreen(requestPointerLock);
            }
        }
        /**
         * Enters full screen mode
         * @param requestPointerLock defines if a pointer lock should be requested from the user
         */
        enterFullscreen(requestPointerLock) {
            if (!this.isFullscreen) {
                this._pointerLockRequested = requestPointerLock;
                if (this._renderingCanvas) {
                    Engine._RequestFullscreen(this._renderingCanvas);
                }
            }
        }
        /**
         * Exits full screen mode
         */
        exitFullscreen() {
            if (this.isFullscreen) {
                Engine._ExitFullscreen();
            }
        }
        /**
         * Enters Pointerlock mode
         */
        enterPointerlock() {
            if (this._renderingCanvas) {
                Engine._RequestPointerlock(this._renderingCanvas);
            }
        }
        /**
         * Exits Pointerlock mode
         */
        exitPointerlock() {
            Engine._ExitPointerlock();
        }
        /**
         * Begin a new frame
         */
        beginFrame() {
            this._measureFps();
            this.onBeginFrameObservable.notifyObservers(this);
            super.beginFrame();
        }
        /**
         * End the current frame
         */
        endFrame() {
            super.endFrame();
            this._submitVRFrame();
            this.onEndFrameObservable.notifyObservers(this);
        }
        /**
         * Resize the view according to the canvas' size
         * @param forceSetSize true to force setting the sizes of the underlying canvas
         */
        resize(forceSetSize = false) {
            // We're not resizing the size of the canvas while in VR mode & presenting
            if (this.isVRPresenting()) {
                return;
            }
            super.resize(forceSetSize);
        }
        /**
         * Force a specific size of the canvas
         * @param width defines the new canvas' width
         * @param height defines the new canvas' height
         * @param forceSetSize true to force setting the sizes of the underlying canvas
         * @returns true if the size was changed
         */
        setSize(width, height, forceSetSize = false) {
            if (!this._renderingCanvas) {
                return false;
            }
            if (!super.setSize(width, height, forceSetSize)) {
                return false;
            }
            if (this.scenes) {
                for (let index = 0; index < this.scenes.length; index++) {
                    const scene = this.scenes[index];
                    for (let camIndex = 0; camIndex < scene.cameras.length; camIndex++) {
                        const cam = scene.cameras[camIndex];
                        cam._currentRenderId = 0;
                    }
                }
                if (this.onResizeObservable.hasObservers()) {
                    this.onResizeObservable.notifyObservers(this);
                }
            }
            return true;
        }
        _deletePipelineContext(pipelineContext) {
            const webGLPipelineContext = pipelineContext;
            if (webGLPipelineContext && webGLPipelineContext.program) {
                if (webGLPipelineContext.transformFeedback) {
                    this.deleteTransformFeedback(webGLPipelineContext.transformFeedback);
                    webGLPipelineContext.transformFeedback = null;
                }
            }
            super._deletePipelineContext(pipelineContext);
        }
        createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null) {
            context = context || this._gl;
            this.onBeforeShaderCompilationObservable.notifyObservers(this);
            const program = super.createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings);
            this.onAfterShaderCompilationObservable.notifyObservers(this);
            return program;
        }
        _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings = null) {
            const shaderProgram = context.createProgram();
            pipelineContext.program = shaderProgram;
            if (!shaderProgram) {
                throw new Error("Unable to create program");
            }
            context.attachShader(shaderProgram, vertexShader);
            context.attachShader(shaderProgram, fragmentShader);
            if (this.webGLVersion > 1 && transformFeedbackVaryings) {
                const transformFeedback = this.createTransformFeedback();
                this.bindTransformFeedback(transformFeedback);
                this.setTranformFeedbackVaryings(shaderProgram, transformFeedbackVaryings);
                pipelineContext.transformFeedback = transformFeedback;
            }
            context.linkProgram(shaderProgram);
            if (this.webGLVersion > 1 && transformFeedbackVaryings) {
                this.bindTransformFeedback(null);
            }
            pipelineContext.context = context;
            pipelineContext.vertexShader = vertexShader;
            pipelineContext.fragmentShader = fragmentShader;
            if (!pipelineContext.isParallelCompiled) {
                this._finalizePipelineContext(pipelineContext);
            }
            return shaderProgram;
        }
        /**
         * @internal
         */
        _releaseTexture(texture) {
            super._releaseTexture(texture);
        }
        /**
         * @internal
         */
        _releaseRenderTargetWrapper(rtWrapper) {
            super._releaseRenderTargetWrapper(rtWrapper);
            // Set output texture of post process to null if the framebuffer has been released/disposed
            this.scenes.forEach((scene) => {
                scene.postProcesses.forEach((postProcess) => {
                    if (postProcess._outputTexture === rtWrapper) {
                        postProcess._outputTexture = null;
                    }
                });
                scene.cameras.forEach((camera) => {
                    camera._postProcesses.forEach((postProcess) => {
                        if (postProcess) {
                            if (postProcess._outputTexture === rtWrapper) {
                                postProcess._outputTexture = null;
                            }
                        }
                    });
                });
            });
        }
        /**
         * Gets the names of the render passes that are currently created
         * @returns list of the render pass names
         */
        getRenderPassNames() {
            return this._renderPassNames;
        }
        /**
         * Gets the name of the current render pass
         * @returns name of the current render pass
         */
        getCurrentRenderPassName() {
            return this._renderPassNames[this.currentRenderPassId];
        }
        /**
         * Creates a render pass id
         * @param name Name of the render pass (for debug purpose only)
         * @returns the id of the new render pass
         */
        createRenderPassId(name) {
            // Note: render pass id == 0 is always for the main render pass
            const id = ++Engine._RenderPassIdCounter;
            this._renderPassNames[id] = name !== null && name !== void 0 ? name : "NONAME";
            return id;
        }
        /**
         * Releases a render pass id
         * @param id id of the render pass to release
         */
        releaseRenderPassId(id) {
            this._renderPassNames[id] = undefined;
            for (let s = 0; s < this.scenes.length; ++s) {
                const scene = this.scenes[s];
                for (let m = 0; m < scene.meshes.length; ++m) {
                    const mesh = scene.meshes[m];
                    if (mesh.subMeshes) {
                        for (let b = 0; b < mesh.subMeshes.length; ++b) {
                            const subMesh = mesh.subMeshes[b];
                            subMesh._removeDrawWrapper(id);
                        }
                    }
                }
            }
        }
        /**
         * @internal
         * Rescales a texture
         * @param source input texture
         * @param destination destination texture
         * @param scene scene to use to render the resize
         * @param internalFormat format to use when resizing
         * @param onComplete callback to be called when resize has completed
         */
        _rescaleTexture(source, destination, scene, internalFormat, onComplete) {
            this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, this._gl.LINEAR);
            this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, this._gl.LINEAR);
            this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_S, this._gl.CLAMP_TO_EDGE);
            this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_T, this._gl.CLAMP_TO_EDGE);
            const rtt = this.createRenderTargetTexture({
                width: destination.width,
                height: destination.height,
            }, {
                generateMipMaps: false,
                type: 0,
                samplingMode: 2,
                generateDepthBuffer: false,
                generateStencilBuffer: false,
            });
            if (!this._rescalePostProcess && Engine._RescalePostProcessFactory) {
                this._rescalePostProcess = Engine._RescalePostProcessFactory(this);
            }
            if (this._rescalePostProcess) {
                this._rescalePostProcess.externalTextureSamplerBinding = true;
                this._rescalePostProcess.getEffect().executeWhenCompiled(() => {
                    this._rescalePostProcess.onApply = function (effect) {
                        effect._bindTexture("textureSampler", source);
                    };
                    let hostingScene = scene;
                    if (!hostingScene) {
                        hostingScene = this.scenes[this.scenes.length - 1];
                    }
                    hostingScene.postProcessManager.directRender([this._rescalePostProcess], rtt, true);
                    this._bindTextureDirectly(this._gl.TEXTURE_2D, destination, true);
                    this._gl.copyTexImage2D(this._gl.TEXTURE_2D, 0, internalFormat, 0, 0, destination.width, destination.height, 0);
                    this.unBindFramebuffer(rtt);
                    rtt.dispose();
                    if (onComplete) {
                        onComplete();
                    }
                });
            }
        }
        // FPS
        /**
         * Gets the current framerate
         * @returns a number representing the framerate
         */
        getFps() {
            return this._fps;
        }
        /**
         * Gets the time spent between current and previous frame
         * @returns a number representing the delta time in ms
         */
        getDeltaTime() {
            return this._deltaTime;
        }
        _measureFps() {
            this._performanceMonitor.sampleFrame();
            this._fps = this._performanceMonitor.averageFPS;
            this._deltaTime = this._performanceMonitor.instantaneousFrameTime || 0;
        }
        /**
         * Wraps an external web gl texture in a Babylon texture.
         * @param texture defines the external texture
         * @param hasMipMaps defines whether the external texture has mip maps (default: false)
         * @param samplingMode defines the sampling mode for the external texture (default: 3)
         * @returns the babylon internal texture
         */
        wrapWebGLTexture(texture, hasMipMaps = false, samplingMode = 3) {
            const hardwareTexture = new WebGLHardwareTexture(texture, this._gl);
            const internalTexture = new InternalTexture(this, InternalTextureSource.Unknown, true);
            internalTexture._hardwareTexture = hardwareTexture;
            internalTexture.isReady = true;
            internalTexture.useMipMaps = hasMipMaps;
            this.updateTextureSamplingMode(samplingMode, internalTexture);
            return internalTexture;
        }
        /**
         * @internal
         */
        _uploadImageToTexture(texture, image, faceIndex = 0, lod = 0) {
            const gl = this._gl;
            const textureType = this._getWebGLTextureType(texture.type);
            const format = this._getInternalFormat(texture.format);
            const internalFormat = this._getRGBABufferInternalSizedFormat(texture.type, format);
            const bindTarget = texture.isCube ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D;
            this._bindTextureDirectly(bindTarget, texture, true);
            this._unpackFlipY(texture.invertY);
            let target = gl.TEXTURE_2D;
            if (texture.isCube) {
                target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
            }
            gl.texImage2D(target, lod, internalFormat, format, textureType, image);
            this._bindTextureDirectly(bindTarget, null, true);
        }
        /**
         * Updates a depth texture Comparison Mode and Function.
         * If the comparison Function is equal to 0, the mode will be set to none.
         * Otherwise, this only works in webgl 2 and requires a shadow sampler in the shader.
         * @param texture The texture to set the comparison function for
         * @param comparisonFunction The comparison function to set, 0 if no comparison required
         */
        updateTextureComparisonFunction(texture, comparisonFunction) {
            if (this.webGLVersion === 1) {
                Logger.Error("WebGL 1 does not support texture comparison.");
                return;
            }
            const gl = this._gl;
            if (texture.isCube) {
                this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, texture, true);
                if (comparisonFunction === 0) {
                    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_FUNC, 515);
                    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_MODE, gl.NONE);
                }
                else {
                    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
                }
                this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
            }
            else {
                this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
                if (comparisonFunction === 0) {
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_FUNC, 515);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_MODE, gl.NONE);
                }
                else {
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
                }
                this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
            }
            texture._comparisonFunction = comparisonFunction;
        }
        /**
         * Creates a webGL buffer to use with instantiation
         * @param capacity defines the size of the buffer
         * @returns the webGL buffer
         */
        createInstancesBuffer(capacity) {
            const buffer = this._gl.createBuffer();
            if (!buffer) {
                throw new Error("Unable to create instance buffer");
            }
            const result = new WebGLDataBuffer(buffer);
            result.capacity = capacity;
            this.bindArrayBuffer(result);
            this._gl.bufferData(this._gl.ARRAY_BUFFER, capacity, this._gl.DYNAMIC_DRAW);
            result.references = 1;
            return result;
        }
        /**
         * Delete a webGL buffer used with instantiation
         * @param buffer defines the webGL buffer to delete
         */
        deleteInstancesBuffer(buffer) {
            this._gl.deleteBuffer(buffer);
        }
        _clientWaitAsync(sync, flags = 0, intervalms = 10) {
            const gl = this._gl;
            return new Promise((resolve, reject) => {
                const check = () => {
                    const res = gl.clientWaitSync(sync, flags, 0);
                    if (res == gl.WAIT_FAILED) {
                        reject();
                        return;
                    }
                    if (res == gl.TIMEOUT_EXPIRED) {
                        setTimeout(check, intervalms);
                        return;
                    }
                    resolve();
                };
                check();
            });
        }
        /**
         * @internal
         */
        _readPixelsAsync(x, y, w, h, format, type, outputBuffer) {
            if (this._webGLVersion < 2) {
                throw new Error("_readPixelsAsync only work on WebGL2+");
            }
            const gl = this._gl;
            const buf = gl.createBuffer();
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
            gl.bufferData(gl.PIXEL_PACK_BUFFER, outputBuffer.byteLength, gl.STREAM_READ);
            gl.readPixels(x, y, w, h, format, type, 0);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
            const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
            if (!sync) {
                return null;
            }
            gl.flush();
            return this._clientWaitAsync(sync, 0, 10).then(() => {
                gl.deleteSync(sync);
                gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
                gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, outputBuffer);
                gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
                gl.deleteBuffer(buf);
                return outputBuffer;
            });
        }
        dispose() {
            this.hideLoadingUI();
            this.onNewSceneAddedObservable.clear();
            // Release postProcesses
            while (this.postProcesses.length) {
                this.postProcesses[0].dispose();
            }
            // Rescale PP
            if (this._rescalePostProcess) {
                this._rescalePostProcess.dispose();
            }
            // Release scenes
            while (this.scenes.length) {
                this.scenes[0].dispose();
            }
            while (this._virtualScenes.length) {
                this._virtualScenes[0].dispose();
            }
            // Release audio engine
            if (EngineStore.Instances.length === 1 && Engine.audioEngine) {
                Engine.audioEngine.dispose();
                Engine.audioEngine = null;
            }
            //WebVR
            this.disableVR();
            // Events
            const hostWindow = this.getHostWindow(); // it calls IsWindowObjectExist()
            if (hostWindow && typeof hostWindow.removeEventListener === "function") {
                hostWindow.removeEventListener("blur", this._onBlur);
                hostWindow.removeEventListener("focus", this._onFocus);
            }
            if (this._renderingCanvas) {
                this._renderingCanvas.removeEventListener("focus", this._onCanvasFocus);
                this._renderingCanvas.removeEventListener("blur", this._onCanvasBlur);
                this._renderingCanvas.removeEventListener("pointerout", this._onCanvasPointerOut);
                this._renderingCanvas.removeEventListener("contextmenu", this._onCanvasContextMenu);
            }
            if (IsDocumentAvailable()) {
                document.removeEventListener("fullscreenchange", this._onFullscreenChange);
                document.removeEventListener("mozfullscreenchange", this._onFullscreenChange);
                document.removeEventListener("webkitfullscreenchange", this._onFullscreenChange);
                document.removeEventListener("msfullscreenchange", this._onFullscreenChange);
                document.removeEventListener("pointerlockchange", this._onPointerLockChange);
                document.removeEventListener("mspointerlockchange", this._onPointerLockChange);
                document.removeEventListener("mozpointerlockchange", this._onPointerLockChange);
                document.removeEventListener("webkitpointerlockchange", this._onPointerLockChange);
            }
            super.dispose();
            // Remove from Instances
            const index = EngineStore.Instances.indexOf(this);
            if (index >= 0) {
                EngineStore.Instances.splice(index, 1);
            }
            // no more engines left in the engine store? Notify!
            if (!Engine.Instances.length) {
                EngineStore.OnEnginesDisposedObservable.notifyObservers(this);
            }
            // Observables
            this.onResizeObservable.clear();
            this.onCanvasBlurObservable.clear();
            this.onCanvasFocusObservable.clear();
            this.onCanvasPointerOutObservable.clear();
            this.onBeginFrameObservable.clear();
            this.onEndFrameObservable.clear();
        }
        _disableTouchAction() {
            if (!this._renderingCanvas || !this._renderingCanvas.setAttribute) {
                return;
            }
            this._renderingCanvas.setAttribute("touch-action", "none");
            this._renderingCanvas.style.touchAction = "none";
            this._renderingCanvas.style.webkitTapHighlightColor = "transparent";
        }
        // Loading screen
        /**
         * Display the loading screen
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */
        displayLoadingUI() {
            if (!IsWindowObjectExist()) {
                return;
            }
            const loadingScreen = this.loadingScreen;
            if (loadingScreen) {
                loadingScreen.displayLoadingUI();
            }
        }
        /**
         * Hide the loading screen
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */
        hideLoadingUI() {
            if (!IsWindowObjectExist()) {
                return;
            }
            const loadingScreen = this._loadingScreen;
            if (loadingScreen) {
                loadingScreen.hideLoadingUI();
            }
        }
        /**
         * Gets the current loading screen object
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */
        get loadingScreen() {
            if (!this._loadingScreen && this._renderingCanvas) {
                this._loadingScreen = Engine.DefaultLoadingScreenFactory(this._renderingCanvas);
            }
            return this._loadingScreen;
        }
        /**
         * Sets the current loading screen object
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */
        set loadingScreen(loadingScreen) {
            this._loadingScreen = loadingScreen;
        }
        /**
         * Sets the current loading screen text
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */
        set loadingUIText(text) {
            this.loadingScreen.loadingUIText = text;
        }
        /**
         * Sets the current loading screen background color
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */
        set loadingUIBackgroundColor(color) {
            this.loadingScreen.loadingUIBackgroundColor = color;
        }
        /**
         * creates and returns a new video element
         * @param constraints video constraints
         * @returns video element
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createVideoElement(constraints) {
            return document.createElement("video");
        }
        /** Pointerlock and fullscreen */
        /**
         * Ask the browser to promote the current element to pointerlock mode
         * @param element defines the DOM element to promote
         */
        static _RequestPointerlock(element) {
            if (element.requestPointerLock) {
                // In some browsers, requestPointerLock returns a promise.
                // Handle possible rejections to avoid an unhandled top-level exception.
                const promise = element.requestPointerLock();
                if (promise instanceof Promise)
                    promise
                        .then(() => {
                        element.focus();
                    })
                        .catch(() => { });
                else
                    element.focus();
            }
        }
        /**
         * Asks the browser to exit pointerlock mode
         */
        static _ExitPointerlock() {
            if (document.exitPointerLock) {
                document.exitPointerLock();
            }
        }
        /**
         * Ask the browser to promote the current element to fullscreen rendering mode
         * @param element defines the DOM element to promote
         */
        static _RequestFullscreen(element) {
            const requestFunction = element.requestFullscreen || element.webkitRequestFullscreen;
            if (!requestFunction) {
                return;
            }
            requestFunction.call(element);
        }
        /**
         * Asks the browser to exit fullscreen mode
         */
        static _ExitFullscreen() {
            const anyDoc = document;
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (anyDoc.webkitCancelFullScreen) {
                anyDoc.webkitCancelFullScreen();
            }
        }
        /**
         * Get Font size information
         * @param font font name
         * @returns an object containing ascent, height and descent
         */
        getFontOffset(font) {
            const text = document.createElement("span");
            text.innerHTML = "Hg";
            text.setAttribute("style", `font: ${font} !important`);
            const block = document.createElement("div");
            block.style.display = "inline-block";
            block.style.width = "1px";
            block.style.height = "0px";
            block.style.verticalAlign = "bottom";
            const div = document.createElement("div");
            div.style.whiteSpace = "nowrap";
            div.appendChild(text);
            div.appendChild(block);
            document.body.appendChild(div);
            let fontAscent = 0;
            let fontHeight = 0;
            try {
                fontHeight = block.getBoundingClientRect().top - text.getBoundingClientRect().top;
                block.style.verticalAlign = "baseline";
                fontAscent = block.getBoundingClientRect().top - text.getBoundingClientRect().top;
            }
            finally {
                document.body.removeChild(div);
            }
            return { ascent: fontAscent, height: fontHeight, descent: fontHeight - fontAscent };
        }
    }
    // Const statics
    /** Defines that alpha blending is disabled */
    Engine.ALPHA_DISABLE = 0;
    /** Defines that alpha blending to SRC ALPHA * SRC + DEST */
    Engine.ALPHA_ADD = 1;
    /** Defines that alpha blending to SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */
    Engine.ALPHA_COMBINE = 2;
    /** Defines that alpha blending to DEST - SRC * DEST */
    Engine.ALPHA_SUBTRACT = 3;
    /** Defines that alpha blending to SRC * DEST */
    Engine.ALPHA_MULTIPLY = 4;
    /** Defines that alpha blending to SRC ALPHA * SRC + (1 - SRC) * DEST */
    Engine.ALPHA_MAXIMIZED = 5;
    /** Defines that alpha blending to SRC + DEST */
    Engine.ALPHA_ONEONE = 6;
    /** Defines that alpha blending to SRC + (1 - SRC ALPHA) * DEST */
    Engine.ALPHA_PREMULTIPLIED = 7;
    /**
     * Defines that alpha blending to SRC + (1 - SRC ALPHA) * DEST
     * Alpha will be set to (1 - SRC ALPHA) * DEST ALPHA
     */
    Engine.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
    /** Defines that alpha blending to CST * SRC + (1 - CST) * DEST */
    Engine.ALPHA_INTERPOLATE = 9;
    /**
     * Defines that alpha blending to SRC + (1 - SRC) * DEST
     * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DEST ALPHA
     */
    Engine.ALPHA_SCREENMODE = 10;
    /** Defines that the resource is not delayed*/
    Engine.DELAYLOADSTATE_NONE = 0;
    /** Defines that the resource was successfully delay loaded */
    Engine.DELAYLOADSTATE_LOADED = 1;
    /** Defines that the resource is currently delay loading */
    Engine.DELAYLOADSTATE_LOADING = 2;
    /** Defines that the resource is delayed and has not started loading */
    Engine.DELAYLOADSTATE_NOTLOADED = 4;
    // Depht or Stencil test Constants.
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass. i.e. Nothing will be drawn */
    Engine.NEVER = 512;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */
    Engine.ALWAYS = 519;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value */
    Engine.LESS = 513;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value */
    Engine.EQUAL = 514;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value */
    Engine.LEQUAL = 515;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value */
    Engine.GREATER = 516;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value */
    Engine.GEQUAL = 518;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value */
    Engine.NOTEQUAL = 517;
    // Stencil Actions Constants.
    /** Passed to stencilOperation to specify that stencil value must be kept */
    Engine.KEEP = 7680;
    /** Passed to stencilOperation to specify that stencil value must be replaced */
    Engine.REPLACE = 7681;
    /** Passed to stencilOperation to specify that stencil value must be incremented */
    Engine.INCR = 7682;
    /** Passed to stencilOperation to specify that stencil value must be decremented */
    Engine.DECR = 7683;
    /** Passed to stencilOperation to specify that stencil value must be inverted */
    Engine.INVERT = 5386;
    /** Passed to stencilOperation to specify that stencil value must be incremented with wrapping */
    Engine.INCR_WRAP = 34055;
    /** Passed to stencilOperation to specify that stencil value must be decremented with wrapping */
    Engine.DECR_WRAP = 34056;
    /** Texture is not repeating outside of 0..1 UVs */
    Engine.TEXTURE_CLAMP_ADDRESSMODE = 0;
    /** Texture is repeating outside of 0..1 UVs */
    Engine.TEXTURE_WRAP_ADDRESSMODE = 1;
    /** Texture is repeating and mirrored */
    Engine.TEXTURE_MIRROR_ADDRESSMODE = 2;
    /** ALPHA */
    Engine.TEXTUREFORMAT_ALPHA = 0;
    /** LUMINANCE */
    Engine.TEXTUREFORMAT_LUMINANCE = 1;
    /** LUMINANCE_ALPHA */
    Engine.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
    /** RGB */
    Engine.TEXTUREFORMAT_RGB = 4;
    /** RGBA */
    Engine.TEXTUREFORMAT_RGBA = 5;
    /** RED */
    Engine.TEXTUREFORMAT_RED = 6;
    /** RED (2nd reference) */
    Engine.TEXTUREFORMAT_R = 6;
    /** RG */
    Engine.TEXTUREFORMAT_RG = 7;
    /** RED_INTEGER */
    Engine.TEXTUREFORMAT_RED_INTEGER = 8;
    /** RED_INTEGER (2nd reference) */
    Engine.TEXTUREFORMAT_R_INTEGER = 8;
    /** RG_INTEGER */
    Engine.TEXTUREFORMAT_RG_INTEGER = 9;
    /** RGB_INTEGER */
    Engine.TEXTUREFORMAT_RGB_INTEGER = 10;
    /** RGBA_INTEGER */
    Engine.TEXTUREFORMAT_RGBA_INTEGER = 11;
    /** UNSIGNED_BYTE */
    Engine.TEXTURETYPE_UNSIGNED_BYTE = 0;
    /** UNSIGNED_BYTE (2nd reference) */
    Engine.TEXTURETYPE_UNSIGNED_INT = 0;
    /** FLOAT */
    Engine.TEXTURETYPE_FLOAT = 1;
    /** HALF_FLOAT */
    Engine.TEXTURETYPE_HALF_FLOAT = 2;
    /** BYTE */
    Engine.TEXTURETYPE_BYTE = 3;
    /** SHORT */
    Engine.TEXTURETYPE_SHORT = 4;
    /** UNSIGNED_SHORT */
    Engine.TEXTURETYPE_UNSIGNED_SHORT = 5;
    /** INT */
    Engine.TEXTURETYPE_INT = 6;
    /** UNSIGNED_INT */
    Engine.TEXTURETYPE_UNSIGNED_INTEGER = 7;
    /** UNSIGNED_SHORT_4_4_4_4 */
    Engine.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
    /** UNSIGNED_SHORT_5_5_5_1 */
    Engine.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
    /** UNSIGNED_SHORT_5_6_5 */
    Engine.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
    /** UNSIGNED_INT_2_10_10_10_REV */
    Engine.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
    /** UNSIGNED_INT_24_8 */
    Engine.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
    /** UNSIGNED_INT_10F_11F_11F_REV */
    Engine.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
    /** UNSIGNED_INT_5_9_9_9_REV */
    Engine.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
    /** FLOAT_32_UNSIGNED_INT_24_8_REV */
    Engine.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
    /** nearest is mag = nearest and min = nearest and mip = none */
    Engine.TEXTURE_NEAREST_SAMPLINGMODE = 1;
    /** Bilinear is mag = linear and min = linear and mip = nearest */
    Engine.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
    /** Trilinear is mag = linear and min = linear and mip = linear */
    Engine.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
    /** nearest is mag = nearest and min = nearest and mip = linear */
    Engine.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
    /** Bilinear is mag = linear and min = linear and mip = nearest */
    Engine.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
    /** Trilinear is mag = linear and min = linear and mip = linear */
    Engine.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
    /** mag = nearest and min = nearest and mip = nearest */
    Engine.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
    /** mag = nearest and min = linear and mip = nearest */
    Engine.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
    /** mag = nearest and min = linear and mip = linear */
    Engine.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
    /** mag = nearest and min = linear and mip = none */
    Engine.TEXTURE_NEAREST_LINEAR = 7;
    /** mag = nearest and min = nearest and mip = none */
    Engine.TEXTURE_NEAREST_NEAREST = 1;
    /** mag = linear and min = nearest and mip = nearest */
    Engine.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
    /** mag = linear and min = nearest and mip = linear */
    Engine.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
    /** mag = linear and min = linear and mip = none */
    Engine.TEXTURE_LINEAR_LINEAR = 2;
    /** mag = linear and min = nearest and mip = none */
    Engine.TEXTURE_LINEAR_NEAREST = 12;
    /** Explicit coordinates mode */
    Engine.TEXTURE_EXPLICIT_MODE = 0;
    /** Spherical coordinates mode */
    Engine.TEXTURE_SPHERICAL_MODE = 1;
    /** Planar coordinates mode */
    Engine.TEXTURE_PLANAR_MODE = 2;
    /** Cubic coordinates mode */
    Engine.TEXTURE_CUBIC_MODE = 3;
    /** Projection coordinates mode */
    Engine.TEXTURE_PROJECTION_MODE = 4;
    /** Skybox coordinates mode */
    Engine.TEXTURE_SKYBOX_MODE = 5;
    /** Inverse Cubic coordinates mode */
    Engine.TEXTURE_INVCUBIC_MODE = 6;
    /** Equirectangular coordinates mode */
    Engine.TEXTURE_EQUIRECTANGULAR_MODE = 7;
    /** Equirectangular Fixed coordinates mode */
    Engine.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
    /** Equirectangular Fixed Mirrored coordinates mode */
    Engine.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
    // Texture rescaling mode
    /** Defines that texture rescaling will use a floor to find the closer power of 2 size */
    Engine.SCALEMODE_FLOOR = 1;
    /** Defines that texture rescaling will look for the nearest power of 2 size */
    Engine.SCALEMODE_NEAREST = 2;
    /** Defines that texture rescaling will use a ceil to find the closer power of 2 size */
    Engine.SCALEMODE_CEILING = 3;
    /**
     * Method called to create the default rescale post process on each engine.
     */
    Engine._RescalePostProcessFactory = null;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Engine._RenderPassIdCounter = 0;

    /** Defines supported spaces */
    var Space;
    (function (Space) {
        /** Local (object) space */
        Space[Space["LOCAL"] = 0] = "LOCAL";
        /** World space */
        Space[Space["WORLD"] = 1] = "WORLD";
        /** Bone space */
        Space[Space["BONE"] = 2] = "BONE";
    })(Space || (Space = {}));
    /** Defines the 3 main axes */
    class Axis {
    }
    /** X axis */
    Axis.X = new Vector3(1.0, 0.0, 0.0);
    /** Y axis */
    Axis.Y = new Vector3(0.0, 1.0, 0.0);
    /** Z axis */
    Axis.Z = new Vector3(0.0, 0.0, 1.0);
    /**
     * Defines cartesian components.
     */
    var Coordinate;
    (function (Coordinate) {
        /** X axis */
        Coordinate[Coordinate["X"] = 0] = "X";
        /** Y axis */
        Coordinate[Coordinate["Y"] = 1] = "Y";
        /** Z axis */
        Coordinate[Coordinate["Z"] = 2] = "Z";
    })(Coordinate || (Coordinate = {}));

    const convertRHSToLHS = Matrix.Compose(Vector3.One(), Quaternion.FromEulerAngles(0, Math.PI, 0), Vector3.Zero());
    /**
     * A TransformNode is an object that is not rendered but can be used as a center of transformation. This can decrease memory usage and increase rendering speed compared to using an empty mesh as a parent and is less complicated than using a pivot matrix.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/transform_node
     */
    class TransformNode extends Node {
        /**
         * Gets or sets the billboard mode. Default is 0.
         *
         * | Value | Type | Description |
         * | --- | --- | --- |
         * | 0 | BILLBOARDMODE_NONE |  |
         * | 1 | BILLBOARDMODE_X |  |
         * | 2 | BILLBOARDMODE_Y |  |
         * | 4 | BILLBOARDMODE_Z |  |
         * | 7 | BILLBOARDMODE_ALL |  |
         *
         */
        get billboardMode() {
            return this._billboardMode;
        }
        set billboardMode(value) {
            if (this._billboardMode === value) {
                return;
            }
            this._billboardMode = value;
            this._cache.useBillboardPosition = (this._billboardMode & TransformNode.BILLBOARDMODE_USE_POSITION) !== 0;
            this._computeUseBillboardPath();
        }
        /**
         * Gets or sets a boolean indicating that parent rotation should be preserved when using billboards.
         * This could be useful for glTF objects where parent rotation helps converting from right handed to left handed
         */
        get preserveParentRotationForBillboard() {
            return this._preserveParentRotationForBillboard;
        }
        set preserveParentRotationForBillboard(value) {
            if (value === this._preserveParentRotationForBillboard) {
                return;
            }
            this._preserveParentRotationForBillboard = value;
            this._computeUseBillboardPath();
        }
        _computeUseBillboardPath() {
            this._cache.useBillboardPath = this._billboardMode !== TransformNode.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
        }
        /**
         * Gets or sets the distance of the object to max, often used by skybox
         */
        get infiniteDistance() {
            return this._infiniteDistance;
        }
        set infiniteDistance(value) {
            if (this._infiniteDistance === value) {
                return;
            }
            this._infiniteDistance = value;
        }
        constructor(name, scene = null, isPure = true) {
            super(name, scene);
            this._forward = new Vector3(0, 0, 1);
            this._up = new Vector3(0, 1, 0);
            this._right = new Vector3(1, 0, 0);
            // Properties
            this._position = Vector3.Zero();
            this._rotation = Vector3.Zero();
            this._rotationQuaternion = null;
            this._scaling = Vector3.One();
            this._transformToBoneReferal = null;
            this._isAbsoluteSynced = false;
            this._billboardMode = TransformNode.BILLBOARDMODE_NONE;
            this._preserveParentRotationForBillboard = false;
            /**
             * Multiplication factor on scale x/y/z when computing the world matrix. Eg. for a 1x1x1 cube setting this to 2 will make it a 2x2x2 cube
             */
            this.scalingDeterminant = 1;
            this._infiniteDistance = false;
            /**
             * Gets or sets a boolean indicating that non uniform scaling (when at least one component is different from others) should be ignored.
             * By default the system will update normals to compensate
             */
            this.ignoreNonUniformScaling = false;
            /**
             * Gets or sets a boolean indicating that even if rotationQuaternion is defined, you can keep updating rotation property and Babylon.js will just mix both
             */
            this.reIntegrateRotationIntoRotationQuaternion = false;
            // Cache
            /** @internal */
            this._poseMatrix = null;
            /** @internal */
            this._localMatrix = Matrix.Zero();
            this._usePivotMatrix = false;
            this._absolutePosition = Vector3.Zero();
            this._absoluteScaling = Vector3.Zero();
            this._absoluteRotationQuaternion = Quaternion.Identity();
            this._pivotMatrix = Matrix.Identity();
            /** @internal */
            this._postMultiplyPivotMatrix = false;
            this._isWorldMatrixFrozen = false;
            /** @internal */
            this._indexInSceneTransformNodesArray = -1;
            /**
             * An event triggered after the world matrix is updated
             */
            this.onAfterWorldMatrixUpdateObservable = new Observable$1();
            this._nonUniformScaling = false;
            if (isPure) {
                this.getScene().addTransformNode(this);
            }
        }
        /**
         * Gets a string identifying the name of the class
         * @returns "TransformNode" string
         */
        getClassName() {
            return "TransformNode";
        }
        /**
         * Gets or set the node position (default is (0.0, 0.0, 0.0))
         */
        get position() {
            return this._position;
        }
        set position(newPosition) {
            this._position = newPosition;
            this._isDirty = true;
        }
        /**
         * return true if a pivot has been set
         * @returns true if a pivot matrix is used
         */
        isUsingPivotMatrix() {
            return this._usePivotMatrix;
        }
        /**
         * Gets or sets the rotation property : a Vector3 defining the rotation value in radians around each local axis X, Y, Z  (default is (0.0, 0.0, 0.0)).
         * If rotation quaternion is set, this Vector3 will be ignored and copy from the quaternion
         */
        get rotation() {
            return this._rotation;
        }
        set rotation(newRotation) {
            this._rotation = newRotation;
            this._rotationQuaternion = null;
            this._isDirty = true;
        }
        /**
         * Gets or sets the scaling property : a Vector3 defining the node scaling along each local axis X, Y, Z (default is (1.0, 1.0, 1.0)).
         */
        get scaling() {
            return this._scaling;
        }
        set scaling(newScaling) {
            this._scaling = newScaling;
            this._isDirty = true;
        }
        /**
         * Gets or sets the rotation Quaternion property : this a Quaternion object defining the node rotation by using a unit quaternion (undefined by default, but can be null).
         * If set, only the rotationQuaternion is then used to compute the node rotation (ie. node.rotation will be ignored)
         */
        get rotationQuaternion() {
            return this._rotationQuaternion;
        }
        set rotationQuaternion(quaternion) {
            this._rotationQuaternion = quaternion;
            //reset the rotation vector.
            if (quaternion) {
                this._rotation.setAll(0.0);
            }
            this._isDirty = true;
        }
        /**
         * The forward direction of that transform in world space.
         */
        get forward() {
            Vector3.TransformNormalFromFloatsToRef(0, 0, this.getScene().useRightHandedSystem ? -1.0 : 1.0, this.getWorldMatrix(), this._forward);
            return this._forward.normalize();
        }
        /**
         * The up direction of that transform in world space.
         */
        get up() {
            Vector3.TransformNormalFromFloatsToRef(0, 1, 0, this.getWorldMatrix(), this._up);
            return this._up.normalize();
        }
        /**
         * The right direction of that transform in world space.
         */
        get right() {
            Vector3.TransformNormalFromFloatsToRef(this.getScene().useRightHandedSystem ? -1.0 : 1.0, 0, 0, this.getWorldMatrix(), this._right);
            return this._right.normalize();
        }
        /**
         * Copies the parameter passed Matrix into the mesh Pose matrix.
         * @param matrix the matrix to copy the pose from
         * @returns this TransformNode.
         */
        updatePoseMatrix(matrix) {
            if (!this._poseMatrix) {
                this._poseMatrix = matrix.clone();
                return this;
            }
            this._poseMatrix.copyFrom(matrix);
            return this;
        }
        /**
         * Returns the mesh Pose matrix.
         * @returns the pose matrix
         */
        getPoseMatrix() {
            if (!this._poseMatrix) {
                this._poseMatrix = Matrix.Identity();
            }
            return this._poseMatrix;
        }
        /** @internal */
        _isSynchronized() {
            const cache = this._cache;
            if (this._billboardMode !== cache.billboardMode || this._billboardMode !== TransformNode.BILLBOARDMODE_NONE) {
                return false;
            }
            if (cache.pivotMatrixUpdated) {
                return false;
            }
            if (this._infiniteDistance) {
                return false;
            }
            if (this._position._isDirty) {
                return false;
            }
            if (this._scaling._isDirty) {
                return false;
            }
            if ((this._rotationQuaternion && this._rotationQuaternion._isDirty) || this._rotation._isDirty) {
                return false;
            }
            return true;
        }
        /** @internal */
        _initCache() {
            super._initCache();
            const cache = this._cache;
            cache.localMatrixUpdated = false;
            cache.billboardMode = -1;
            cache.infiniteDistance = false;
            cache.useBillboardPosition = false;
            cache.useBillboardPath = false;
        }
        /**
         * Returns the current mesh absolute position.
         * Returns a Vector3.
         */
        get absolutePosition() {
            return this.getAbsolutePosition();
        }
        /**
         * Returns the current mesh absolute scaling.
         * Returns a Vector3.
         */
        get absoluteScaling() {
            this._syncAbsoluteScalingAndRotation();
            return this._absoluteScaling;
        }
        /**
         * Returns the current mesh absolute rotation.
         * Returns a Quaternion.
         */
        get absoluteRotationQuaternion() {
            this._syncAbsoluteScalingAndRotation();
            return this._absoluteRotationQuaternion;
        }
        /**
         * Sets a new matrix to apply before all other transformation
         * @param matrix defines the transform matrix
         * @returns the current TransformNode
         */
        setPreTransformMatrix(matrix) {
            return this.setPivotMatrix(matrix, false);
        }
        /**
         * Sets a new pivot matrix to the current node
         * @param matrix defines the new pivot matrix to use
         * @param postMultiplyPivotMatrix defines if the pivot matrix must be cancelled in the world matrix. When this parameter is set to true (default), the inverse of the pivot matrix is also applied at the end to cancel the transformation effect
         * @returns the current TransformNode
         */
        setPivotMatrix(matrix, postMultiplyPivotMatrix = true) {
            this._pivotMatrix.copyFrom(matrix);
            this._usePivotMatrix = !this._pivotMatrix.isIdentity();
            this._cache.pivotMatrixUpdated = true;
            this._postMultiplyPivotMatrix = postMultiplyPivotMatrix;
            if (this._postMultiplyPivotMatrix) {
                if (!this._pivotMatrixInverse) {
                    this._pivotMatrixInverse = Matrix.Invert(this._pivotMatrix);
                }
                else {
                    this._pivotMatrix.invertToRef(this._pivotMatrixInverse);
                }
            }
            return this;
        }
        /**
         * Returns the mesh pivot matrix.
         * Default : Identity.
         * @returns the matrix
         */
        getPivotMatrix() {
            return this._pivotMatrix;
        }
        /**
         * Instantiate (when possible) or clone that node with its hierarchy
         * @param newParent defines the new parent to use for the instance (or clone)
         * @param options defines options to configure how copy is done
         * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
         * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
         * @returns an instance (or a clone) of the current node with its hierarchy
         */
        instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
            const clone = this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true);
            if (clone) {
                if (onNewNodeCreated) {
                    onNewNodeCreated(this, clone);
                }
            }
            for (const child of this.getChildTransformNodes(true)) {
                child.instantiateHierarchy(clone, options, onNewNodeCreated);
            }
            return clone;
        }
        /**
         * Prevents the World matrix to be computed any longer
         * @param newWorldMatrix defines an optional matrix to use as world matrix
         * @param decompose defines whether to decompose the given newWorldMatrix or directly assign
         * @returns the TransformNode.
         */
        freezeWorldMatrix(newWorldMatrix = null, decompose = false) {
            if (newWorldMatrix) {
                if (decompose) {
                    this._rotation.setAll(0);
                    this._rotationQuaternion = this._rotationQuaternion || Quaternion.Identity();
                    newWorldMatrix.decompose(this._scaling, this._rotationQuaternion, this._position);
                    this.computeWorldMatrix(true);
                }
                else {
                    this._worldMatrix = newWorldMatrix;
                    this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]);
                    this._afterComputeWorldMatrix();
                }
            }
            else {
                this._isWorldMatrixFrozen = false; // no guarantee world is not already frozen, switch off temporarily
                this.computeWorldMatrix(true);
            }
            this._isDirty = false;
            this._isWorldMatrixFrozen = true;
            return this;
        }
        /**
         * Allows back the World matrix computation.
         * @returns the TransformNode.
         */
        unfreezeWorldMatrix() {
            this._isWorldMatrixFrozen = false;
            this.computeWorldMatrix(true);
            return this;
        }
        /**
         * True if the World matrix has been frozen.
         */
        get isWorldMatrixFrozen() {
            return this._isWorldMatrixFrozen;
        }
        /**
         * Returns the mesh absolute position in the World.
         * @returns a Vector3.
         */
        getAbsolutePosition() {
            this.computeWorldMatrix();
            return this._absolutePosition;
        }
        /**
         * Sets the mesh absolute position in the World from a Vector3 or an Array(3).
         * @param absolutePosition the absolute position to set
         * @returns the TransformNode.
         */
        setAbsolutePosition(absolutePosition) {
            if (!absolutePosition) {
                return this;
            }
            let absolutePositionX;
            let absolutePositionY;
            let absolutePositionZ;
            if (absolutePosition.x === undefined) {
                if (arguments.length < 3) {
                    return this;
                }
                absolutePositionX = arguments[0];
                absolutePositionY = arguments[1];
                absolutePositionZ = arguments[2];
            }
            else {
                absolutePositionX = absolutePosition.x;
                absolutePositionY = absolutePosition.y;
                absolutePositionZ = absolutePosition.z;
            }
            if (this.parent) {
                const invertParentWorldMatrix = TmpVectors.Matrix[0];
                this.parent.getWorldMatrix().invertToRef(invertParentWorldMatrix);
                Vector3.TransformCoordinatesFromFloatsToRef(absolutePositionX, absolutePositionY, absolutePositionZ, invertParentWorldMatrix, this.position);
            }
            else {
                this.position.x = absolutePositionX;
                this.position.y = absolutePositionY;
                this.position.z = absolutePositionZ;
            }
            this._absolutePosition.copyFrom(absolutePosition);
            return this;
        }
        /**
         * Sets the mesh position in its local space.
         * @param vector3 the position to set in localspace
         * @returns the TransformNode.
         */
        setPositionWithLocalVector(vector3) {
            this.computeWorldMatrix();
            this.position = Vector3.TransformNormal(vector3, this._localMatrix);
            return this;
        }
        /**
         * Returns the mesh position in the local space from the current World matrix values.
         * @returns a new Vector3.
         */
        getPositionExpressedInLocalSpace() {
            this.computeWorldMatrix();
            const invLocalWorldMatrix = TmpVectors.Matrix[0];
            this._localMatrix.invertToRef(invLocalWorldMatrix);
            return Vector3.TransformNormal(this.position, invLocalWorldMatrix);
        }
        /**
         * Translates the mesh along the passed Vector3 in its local space.
         * @param vector3 the distance to translate in localspace
         * @returns the TransformNode.
         */
        locallyTranslate(vector3) {
            this.computeWorldMatrix(true);
            this.position = Vector3.TransformCoordinates(vector3, this._localMatrix);
            return this;
        }
        /**
         * Orients a mesh towards a target point. Mesh must be drawn facing user.
         * @param targetPoint the position (must be in same space as current mesh) to look at
         * @param yawCor optional yaw (y-axis) correction in radians
         * @param pitchCor optional pitch (x-axis) correction in radians
         * @param rollCor optional roll (z-axis) correction in radians
         * @param space the chosen space of the target
         * @returns the TransformNode.
         */
        lookAt(targetPoint, yawCor = 0, pitchCor = 0, rollCor = 0, space = Space.LOCAL) {
            const dv = TransformNode._LookAtVectorCache;
            const pos = space === Space.LOCAL ? this.position : this.getAbsolutePosition();
            targetPoint.subtractToRef(pos, dv);
            this.setDirection(dv, yawCor, pitchCor, rollCor);
            // Correct for parent's rotation offset
            if (space === Space.WORLD && this.parent) {
                if (this.rotationQuaternion) {
                    // Get local rotation matrix of the looking object
                    const rotationMatrix = TmpVectors.Matrix[0];
                    this.rotationQuaternion.toRotationMatrix(rotationMatrix);
                    // Offset rotation by parent's inverted rotation matrix to correct in world space
                    const parentRotationMatrix = TmpVectors.Matrix[1];
                    this.parent.getWorldMatrix().getRotationMatrixToRef(parentRotationMatrix);
                    parentRotationMatrix.invert();
                    rotationMatrix.multiplyToRef(parentRotationMatrix, rotationMatrix);
                    this.rotationQuaternion.fromRotationMatrix(rotationMatrix);
                }
                else {
                    // Get local rotation matrix of the looking object
                    const quaternionRotation = TmpVectors.Quaternion[0];
                    Quaternion.FromEulerVectorToRef(this.rotation, quaternionRotation);
                    const rotationMatrix = TmpVectors.Matrix[0];
                    quaternionRotation.toRotationMatrix(rotationMatrix);
                    // Offset rotation by parent's inverted rotation matrix to correct in world space
                    const parentRotationMatrix = TmpVectors.Matrix[1];
                    this.parent.getWorldMatrix().getRotationMatrixToRef(parentRotationMatrix);
                    parentRotationMatrix.invert();
                    rotationMatrix.multiplyToRef(parentRotationMatrix, rotationMatrix);
                    quaternionRotation.fromRotationMatrix(rotationMatrix);
                    quaternionRotation.toEulerAnglesToRef(this.rotation);
                }
            }
            return this;
        }
        /**
         * Returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
         * This Vector3 is expressed in the World space.
         * @param localAxis axis to rotate
         * @returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
         */
        getDirection(localAxis) {
            const result = Vector3.Zero();
            this.getDirectionToRef(localAxis, result);
            return result;
        }
        /**
         * Sets the Vector3 "result" as the rotated Vector3 "localAxis" in the same rotation than the mesh.
         * localAxis is expressed in the mesh local space.
         * result is computed in the World space from the mesh World matrix.
         * @param localAxis axis to rotate
         * @param result the resulting transformnode
         * @returns this TransformNode.
         */
        getDirectionToRef(localAxis, result) {
            Vector3.TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
            return this;
        }
        /**
         * Sets this transform node rotation to the given local axis.
         * @param localAxis the axis in local space
         * @param yawCor optional yaw (y-axis) correction in radians
         * @param pitchCor optional pitch (x-axis) correction in radians
         * @param rollCor optional roll (z-axis) correction in radians
         * @returns this TransformNode
         */
        setDirection(localAxis, yawCor = 0, pitchCor = 0, rollCor = 0) {
            const yaw = -Math.atan2(localAxis.z, localAxis.x) + Math.PI / 2;
            const len = Math.sqrt(localAxis.x * localAxis.x + localAxis.z * localAxis.z);
            const pitch = -Math.atan2(localAxis.y, len);
            if (this.rotationQuaternion) {
                Quaternion.RotationYawPitchRollToRef(yaw + yawCor, pitch + pitchCor, rollCor, this.rotationQuaternion);
            }
            else {
                this.rotation.x = pitch + pitchCor;
                this.rotation.y = yaw + yawCor;
                this.rotation.z = rollCor;
            }
            return this;
        }
        /**
         * Sets a new pivot point to the current node
         * @param point defines the new pivot point to use
         * @param space defines if the point is in world or local space (local by default)
         * @returns the current TransformNode
         */
        setPivotPoint(point, space = Space.LOCAL) {
            if (this.getScene().getRenderId() == 0) {
                this.computeWorldMatrix(true);
            }
            const wm = this.getWorldMatrix();
            if (space == Space.WORLD) {
                const tmat = TmpVectors.Matrix[0];
                wm.invertToRef(tmat);
                point = Vector3.TransformCoordinates(point, tmat);
            }
            return this.setPivotMatrix(Matrix.Translation(-point.x, -point.y, -point.z), true);
        }
        /**
         * Returns a new Vector3 set with the mesh pivot point coordinates in the local space.
         * @returns the pivot point
         */
        getPivotPoint() {
            const point = Vector3.Zero();
            this.getPivotPointToRef(point);
            return point;
        }
        /**
         * Sets the passed Vector3 "result" with the coordinates of the mesh pivot point in the local space.
         * @param result the vector3 to store the result
         * @returns this TransformNode.
         */
        getPivotPointToRef(result) {
            result.x = -this._pivotMatrix.m[12];
            result.y = -this._pivotMatrix.m[13];
            result.z = -this._pivotMatrix.m[14];
            return this;
        }
        /**
         * Returns a new Vector3 set with the mesh pivot point World coordinates.
         * @returns a new Vector3 set with the mesh pivot point World coordinates.
         */
        getAbsolutePivotPoint() {
            const point = Vector3.Zero();
            this.getAbsolutePivotPointToRef(point);
            return point;
        }
        /**
         * Sets the Vector3 "result" coordinates with the mesh pivot point World coordinates.
         * @param result vector3 to store the result
         * @returns this TransformNode.
         */
        getAbsolutePivotPointToRef(result) {
            this.getPivotPointToRef(result);
            Vector3.TransformCoordinatesToRef(result, this.getWorldMatrix(), result);
            return this;
        }
        /**
         * Flag the transform node as dirty (Forcing it to update everything)
         * @param property if set to "rotation" the objects rotationQuaternion will be set to null
         * @returns this  node
         */
        markAsDirty(property) {
            if (this._isDirty) {
                return this;
            }
            // We need to explicitly update the children
            // as the scene.evaluateActiveMeshes will not poll the transform nodes
            if (this._children) {
                for (const child of this._children) {
                    child.markAsDirty(property);
                }
            }
            return super.markAsDirty(property);
        }
        /**
         * Defines the passed node as the parent of the current node.
         * The node will remain exactly where it is and its position / rotation will be updated accordingly.
         * Note that if the mesh has a pivot matrix / point defined it will be applied after the parent was updated.
         * In that case the node will not remain in the same space as it is, as the pivot will be applied.
         * To avoid this, you can set updatePivot to true and the pivot will be updated to identity
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
         * @param node the node ot set as the parent
         * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
         * @param updatePivot if true, update the pivot matrix to keep the node in the same space as before
         * @returns this TransformNode.
         */
        setParent(node, preserveScalingSign = false, updatePivot = false) {
            if (!node && !this.parent) {
                return this;
            }
            const quatRotation = TmpVectors.Quaternion[0];
            const position = TmpVectors.Vector3[0];
            const scale = TmpVectors.Vector3[1];
            const invParentMatrix = TmpVectors.Matrix[1];
            Matrix.IdentityToRef(invParentMatrix);
            const composedMatrix = TmpVectors.Matrix[0];
            this.computeWorldMatrix(true);
            let currentRotation = this.rotationQuaternion;
            if (!currentRotation) {
                currentRotation = TransformNode._TmpRotation;
                Quaternion.RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, currentRotation);
            }
            // current global transformation without pivot
            Matrix.ComposeToRef(this.scaling, currentRotation, this.position, composedMatrix);
            if (this.parent) {
                composedMatrix.multiplyToRef(this.parent.computeWorldMatrix(true), composedMatrix);
            }
            // is a node was set, calculate the difference between this and the node
            if (node) {
                node.computeWorldMatrix(true).invertToRef(invParentMatrix);
                composedMatrix.multiplyToRef(invParentMatrix, composedMatrix);
            }
            composedMatrix.decompose(scale, quatRotation, position, preserveScalingSign ? this : undefined);
            if (this.rotationQuaternion) {
                this.rotationQuaternion.copyFrom(quatRotation);
            }
            else {
                quatRotation.toEulerAnglesToRef(this.rotation);
            }
            this.scaling.copyFrom(scale);
            this.position.copyFrom(position);
            this.parent = node;
            if (updatePivot) {
                this.setPivotMatrix(Matrix.Identity());
            }
            return this;
        }
        /**
         * True if the scaling property of this object is non uniform eg. (1,2,1)
         */
        get nonUniformScaling() {
            return this._nonUniformScaling;
        }
        /**
         * @internal
         */
        _updateNonUniformScalingState(value) {
            if (this._nonUniformScaling === value) {
                return false;
            }
            this._nonUniformScaling = value;
            return true;
        }
        /**
         * Attach the current TransformNode to another TransformNode associated with a bone
         * @param bone Bone affecting the TransformNode
         * @param affectedTransformNode TransformNode associated with the bone
         * @returns this object
         */
        attachToBone(bone, affectedTransformNode) {
            this._currentParentWhenAttachingToBone = this.parent;
            this._transformToBoneReferal = affectedTransformNode;
            this.parent = bone;
            bone.getSkeleton().prepare(); // make sure bone.getFinalMatrix() is up to date
            if (bone.getFinalMatrix().determinant() < 0) {
                this.scalingDeterminant *= -1;
            }
            return this;
        }
        /**
         * Detach the transform node if its associated with a bone
         * @param resetToPreviousParent Indicates if the parent that was in effect when attachToBone was called should be set back or if we should set parent to null instead (defaults to the latter)
         * @returns this object
         */
        detachFromBone(resetToPreviousParent = false) {
            if (!this.parent) {
                if (resetToPreviousParent) {
                    this.parent = this._currentParentWhenAttachingToBone;
                }
                return this;
            }
            if (this.parent.getWorldMatrix().determinant() < 0) {
                this.scalingDeterminant *= -1;
            }
            this._transformToBoneReferal = null;
            if (resetToPreviousParent) {
                this.parent = this._currentParentWhenAttachingToBone;
            }
            else {
                this.parent = null;
            }
            return this;
        }
        /**
         * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in the given space.
         * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
         * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
         * The passed axis is also normalized.
         * @param axis the axis to rotate around
         * @param amount the amount to rotate in radians
         * @param space Space to rotate in (Default: local)
         * @returns the TransformNode.
         */
        rotate(axis, amount, space) {
            axis.normalize();
            if (!this.rotationQuaternion) {
                this.rotationQuaternion = this.rotation.toQuaternion();
                this.rotation.setAll(0);
            }
            let rotationQuaternion;
            if (!space || space === Space.LOCAL) {
                rotationQuaternion = Quaternion.RotationAxisToRef(axis, amount, TransformNode._RotationAxisCache);
                this.rotationQuaternion.multiplyToRef(rotationQuaternion, this.rotationQuaternion);
            }
            else {
                if (this.parent) {
                    const invertParentWorldMatrix = TmpVectors.Matrix[0];
                    this.parent.getWorldMatrix().invertToRef(invertParentWorldMatrix);
                    axis = Vector3.TransformNormal(axis, invertParentWorldMatrix);
                }
                rotationQuaternion = Quaternion.RotationAxisToRef(axis, amount, TransformNode._RotationAxisCache);
                rotationQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
            }
            return this;
        }
        /**
         * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in world space.
         * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
         * The passed axis is also normalized. .
         * Method is based on http://www.euclideanspace.com/maths/geometry/affine/aroundPoint/index.htm
         * @param point the point to rotate around
         * @param axis the axis to rotate around
         * @param amount the amount to rotate in radians
         * @returns the TransformNode
         */
        rotateAround(point, axis, amount) {
            axis.normalize();
            if (!this.rotationQuaternion) {
                this.rotationQuaternion = Quaternion.RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z);
                this.rotation.setAll(0);
            }
            const tmpVector = TmpVectors.Vector3[0];
            const finalScale = TmpVectors.Vector3[1];
            const finalTranslation = TmpVectors.Vector3[2];
            const finalRotation = TmpVectors.Quaternion[0];
            const translationMatrix = TmpVectors.Matrix[0]; // T
            const translationMatrixInv = TmpVectors.Matrix[1]; // T'
            const rotationMatrix = TmpVectors.Matrix[2]; // R
            const finalMatrix = TmpVectors.Matrix[3]; // T' x R x T
            point.subtractToRef(this.position, tmpVector);
            Matrix.TranslationToRef(tmpVector.x, tmpVector.y, tmpVector.z, translationMatrix); // T
            Matrix.TranslationToRef(-tmpVector.x, -tmpVector.y, -tmpVector.z, translationMatrixInv); // T'
            Matrix.RotationAxisToRef(axis, amount, rotationMatrix); // R
            translationMatrixInv.multiplyToRef(rotationMatrix, finalMatrix); // T' x R
            finalMatrix.multiplyToRef(translationMatrix, finalMatrix); // T' x R x T
            finalMatrix.decompose(finalScale, finalRotation, finalTranslation);
            this.position.addInPlace(finalTranslation);
            finalRotation.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
            return this;
        }
        /**
         * Translates the mesh along the axis vector for the passed distance in the given space.
         * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
         * @param axis the axis to translate in
         * @param distance the distance to translate
         * @param space Space to rotate in (Default: local)
         * @returns the TransformNode.
         */
        translate(axis, distance, space) {
            const displacementVector = axis.scale(distance);
            if (!space || space === Space.LOCAL) {
                const tempV3 = this.getPositionExpressedInLocalSpace().add(displacementVector);
                this.setPositionWithLocalVector(tempV3);
            }
            else {
                this.setAbsolutePosition(this.getAbsolutePosition().add(displacementVector));
            }
            return this;
        }
        /**
         * Adds a rotation step to the mesh current rotation.
         * x, y, z are Euler angles expressed in radians.
         * This methods updates the current mesh rotation, either mesh.rotation, either mesh.rotationQuaternion if it's set.
         * This means this rotation is made in the mesh local space only.
         * It's useful to set a custom rotation order different from the BJS standard one YXZ.
         * Example : this rotates the mesh first around its local X axis, then around its local Z axis, finally around its local Y axis.
         * ```javascript
         * mesh.addRotation(x1, 0, 0).addRotation(0, 0, z2).addRotation(0, 0, y3);
         * ```
         * Note that `addRotation()` accumulates the passed rotation values to the current ones and computes the .rotation or .rotationQuaternion updated values.
         * Under the hood, only quaternions are used. So it's a little faster is you use .rotationQuaternion because it doesn't need to translate them back to Euler angles.
         * @param x Rotation to add
         * @param y Rotation to add
         * @param z Rotation to add
         * @returns the TransformNode.
         */
        addRotation(x, y, z) {
            let rotationQuaternion;
            if (this.rotationQuaternion) {
                rotationQuaternion = this.rotationQuaternion;
            }
            else {
                rotationQuaternion = TmpVectors.Quaternion[1];
                Quaternion.RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, rotationQuaternion);
            }
            const accumulation = TmpVectors.Quaternion[0];
            Quaternion.RotationYawPitchRollToRef(y, x, z, accumulation);
            rotationQuaternion.multiplyInPlace(accumulation);
            if (!this.rotationQuaternion) {
                rotationQuaternion.toEulerAnglesToRef(this.rotation);
            }
            return this;
        }
        /**
         * @internal
         */
        _getEffectiveParent() {
            return this.parent;
        }
        /**
         * Returns whether the transform node world matrix computation needs the camera information to be computed.
         * This is the case when the node is a billboard or has an infinite distance for instance.
         * @returns true if the world matrix computation needs the camera information to be computed
         */
        isWorldMatrixCameraDependent() {
            return (this._infiniteDistance && !this.parent) || (this._billboardMode !== TransformNode.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard);
        }
        /**
         * Computes the world matrix of the node
         * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
         * @param camera defines the camera used if different from the scene active camera (This is used with modes like Billboard or infinite distance)
         * @returns the world matrix
         */
        computeWorldMatrix(force = false, camera = null) {
            if (this._isWorldMatrixFrozen && !this._isDirty) {
                return this._worldMatrix;
            }
            const currentRenderId = this.getScene().getRenderId();
            if (!this._isDirty && !force && (this._currentRenderId === currentRenderId || this.isSynchronized())) {
                this._currentRenderId = currentRenderId;
                return this._worldMatrix;
            }
            camera = camera || this.getScene().activeCamera;
            this._updateCache();
            const cache = this._cache;
            cache.pivotMatrixUpdated = false;
            cache.billboardMode = this.billboardMode;
            cache.infiniteDistance = this.infiniteDistance;
            cache.parent = this._parentNode;
            this._currentRenderId = currentRenderId;
            this._childUpdateId += 1;
            this._isDirty = false;
            this._position._isDirty = false;
            this._rotation._isDirty = false;
            this._scaling._isDirty = false;
            const parent = this._getEffectiveParent();
            // Scaling
            const scaling = TransformNode._TmpScaling;
            let translation = this._position;
            // Translation
            if (this._infiniteDistance) {
                if (!this.parent && camera) {
                    const cameraWorldMatrix = camera.getWorldMatrix();
                    const cameraGlobalPosition = new Vector3(cameraWorldMatrix.m[12], cameraWorldMatrix.m[13], cameraWorldMatrix.m[14]);
                    translation = TransformNode._TmpTranslation;
                    translation.copyFromFloats(this._position.x + cameraGlobalPosition.x, this._position.y + cameraGlobalPosition.y, this._position.z + cameraGlobalPosition.z);
                }
            }
            // Scaling
            scaling.copyFromFloats(this._scaling.x * this.scalingDeterminant, this._scaling.y * this.scalingDeterminant, this._scaling.z * this.scalingDeterminant);
            // Rotation
            let rotation;
            if (this._rotationQuaternion) {
                this._rotationQuaternion._isDirty = false;
                rotation = this._rotationQuaternion;
                if (this.reIntegrateRotationIntoRotationQuaternion) {
                    const len = this.rotation.lengthSquared();
                    if (len) {
                        this._rotationQuaternion.multiplyInPlace(Quaternion.RotationYawPitchRoll(this._rotation.y, this._rotation.x, this._rotation.z));
                        this._rotation.copyFromFloats(0, 0, 0);
                    }
                }
            }
            else {
                rotation = TransformNode._TmpRotation;
                Quaternion.RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, rotation);
            }
            // Compose
            if (this._usePivotMatrix) {
                const scaleMatrix = TmpVectors.Matrix[1];
                Matrix.ScalingToRef(scaling.x, scaling.y, scaling.z, scaleMatrix);
                // Rotation
                const rotationMatrix = TmpVectors.Matrix[0];
                rotation.toRotationMatrix(rotationMatrix);
                // Composing transformations
                this._pivotMatrix.multiplyToRef(scaleMatrix, TmpVectors.Matrix[4]);
                TmpVectors.Matrix[4].multiplyToRef(rotationMatrix, this._localMatrix);
                // Post multiply inverse of pivotMatrix
                if (this._postMultiplyPivotMatrix) {
                    this._localMatrix.multiplyToRef(this._pivotMatrixInverse, this._localMatrix);
                }
                this._localMatrix.addTranslationFromFloats(translation.x, translation.y, translation.z);
            }
            else {
                Matrix.ComposeToRef(scaling, rotation, translation, this._localMatrix);
            }
            // Parent
            if (parent && parent.getWorldMatrix) {
                if (force) {
                    parent.computeWorldMatrix(force);
                }
                if (cache.useBillboardPath) {
                    if (this._transformToBoneReferal) {
                        parent.getWorldMatrix().multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), TmpVectors.Matrix[7]);
                    }
                    else {
                        TmpVectors.Matrix[7].copyFrom(parent.getWorldMatrix());
                    }
                    // Extract scaling and translation from parent
                    const translation = TmpVectors.Vector3[5];
                    const scale = TmpVectors.Vector3[6];
                    const orientation = TmpVectors.Quaternion[0];
                    TmpVectors.Matrix[7].decompose(scale, orientation, translation);
                    Matrix.ScalingToRef(scale.x, scale.y, scale.z, TmpVectors.Matrix[7]);
                    TmpVectors.Matrix[7].setTranslation(translation);
                    if (TransformNode.BillboardUseParentOrientation) {
                        // set localMatrix translation to be transformed against parent's orientation.
                        this._position.applyRotationQuaternionToRef(orientation, translation);
                        this._localMatrix.setTranslation(translation);
                    }
                    this._localMatrix.multiplyToRef(TmpVectors.Matrix[7], this._worldMatrix);
                }
                else {
                    if (this._transformToBoneReferal) {
                        this._localMatrix.multiplyToRef(parent.getWorldMatrix(), TmpVectors.Matrix[6]);
                        TmpVectors.Matrix[6].multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), this._worldMatrix);
                    }
                    else {
                        this._localMatrix.multiplyToRef(parent.getWorldMatrix(), this._worldMatrix);
                    }
                }
                this._markSyncedWithParent();
            }
            else {
                this._worldMatrix.copyFrom(this._localMatrix);
            }
            // Billboarding based on camera orientation (testing PG:http://www.babylonjs-playground.com/#UJEIL#13)
            if (cache.useBillboardPath && camera && this.billboardMode && !cache.useBillboardPosition) {
                const storedTranslation = TmpVectors.Vector3[0];
                this._worldMatrix.getTranslationToRef(storedTranslation); // Save translation
                // Cancel camera rotation
                TmpVectors.Matrix[1].copyFrom(camera.getViewMatrix());
                if (this._scene.useRightHandedSystem) {
                    TmpVectors.Matrix[1].multiplyToRef(convertRHSToLHS, TmpVectors.Matrix[1]);
                }
                TmpVectors.Matrix[1].setTranslationFromFloats(0, 0, 0);
                TmpVectors.Matrix[1].invertToRef(TmpVectors.Matrix[0]);
                if ((this.billboardMode & TransformNode.BILLBOARDMODE_ALL) !== TransformNode.BILLBOARDMODE_ALL) {
                    TmpVectors.Matrix[0].decompose(undefined, TmpVectors.Quaternion[0], undefined);
                    const eulerAngles = TmpVectors.Vector3[1];
                    TmpVectors.Quaternion[0].toEulerAnglesToRef(eulerAngles);
                    if ((this.billboardMode & TransformNode.BILLBOARDMODE_X) !== TransformNode.BILLBOARDMODE_X) {
                        eulerAngles.x = 0;
                    }
                    if ((this.billboardMode & TransformNode.BILLBOARDMODE_Y) !== TransformNode.BILLBOARDMODE_Y) {
                        eulerAngles.y = 0;
                    }
                    if ((this.billboardMode & TransformNode.BILLBOARDMODE_Z) !== TransformNode.BILLBOARDMODE_Z) {
                        eulerAngles.z = 0;
                    }
                    Matrix.RotationYawPitchRollToRef(eulerAngles.y, eulerAngles.x, eulerAngles.z, TmpVectors.Matrix[0]);
                }
                this._worldMatrix.setTranslationFromFloats(0, 0, 0);
                this._worldMatrix.multiplyToRef(TmpVectors.Matrix[0], this._worldMatrix);
                // Restore translation
                this._worldMatrix.setTranslation(TmpVectors.Vector3[0]);
            }
            // Billboarding based on camera position
            else if (cache.useBillboardPath && camera && cache.useBillboardPosition) {
                const storedTranslation = TmpVectors.Vector3[0];
                // Save translation
                this._worldMatrix.getTranslationToRef(storedTranslation);
                // Compute camera position in local space
                const cameraPosition = camera.globalPosition;
                this._worldMatrix.invertToRef(TmpVectors.Matrix[1]);
                const camInObjSpace = TmpVectors.Vector3[1];
                Vector3.TransformCoordinatesToRef(cameraPosition, TmpVectors.Matrix[1], camInObjSpace);
                camInObjSpace.normalize();
                // Find the lookAt info in local space
                const yaw = -Math.atan2(camInObjSpace.z, camInObjSpace.x) + Math.PI / 2;
                const len = Math.sqrt(camInObjSpace.x * camInObjSpace.x + camInObjSpace.z * camInObjSpace.z);
                const pitch = -Math.atan2(camInObjSpace.y, len);
                Quaternion.RotationYawPitchRollToRef(yaw, pitch, 0, TmpVectors.Quaternion[0]);
                if ((this.billboardMode & TransformNode.BILLBOARDMODE_ALL) !== TransformNode.BILLBOARDMODE_ALL) {
                    const eulerAngles = TmpVectors.Vector3[1];
                    TmpVectors.Quaternion[0].toEulerAnglesToRef(eulerAngles);
                    if ((this.billboardMode & TransformNode.BILLBOARDMODE_X) !== TransformNode.BILLBOARDMODE_X) {
                        eulerAngles.x = 0;
                    }
                    if ((this.billboardMode & TransformNode.BILLBOARDMODE_Y) !== TransformNode.BILLBOARDMODE_Y) {
                        eulerAngles.y = 0;
                    }
                    if ((this.billboardMode & TransformNode.BILLBOARDMODE_Z) !== TransformNode.BILLBOARDMODE_Z) {
                        eulerAngles.z = 0;
                    }
                    Matrix.RotationYawPitchRollToRef(eulerAngles.y, eulerAngles.x, eulerAngles.z, TmpVectors.Matrix[0]);
                }
                else {
                    Matrix.FromQuaternionToRef(TmpVectors.Quaternion[0], TmpVectors.Matrix[0]);
                }
                // Cancel translation
                this._worldMatrix.setTranslationFromFloats(0, 0, 0);
                // Rotate according to lookat (diff from local to lookat)
                this._worldMatrix.multiplyToRef(TmpVectors.Matrix[0], this._worldMatrix);
                // Restore translation
                this._worldMatrix.setTranslation(TmpVectors.Vector3[0]);
            }
            // Normal matrix
            if (!this.ignoreNonUniformScaling) {
                if (this._scaling.isNonUniformWithinEpsilon(0.000001)) {
                    this._updateNonUniformScalingState(true);
                }
                else if (parent && parent._nonUniformScaling) {
                    this._updateNonUniformScalingState(parent._nonUniformScaling);
                }
                else {
                    this._updateNonUniformScalingState(false);
                }
            }
            else {
                this._updateNonUniformScalingState(false);
            }
            this._afterComputeWorldMatrix();
            // Absolute position
            this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]);
            this._isAbsoluteSynced = false;
            // Callbacks
            this.onAfterWorldMatrixUpdateObservable.notifyObservers(this);
            if (!this._poseMatrix) {
                this._poseMatrix = Matrix.Invert(this._worldMatrix);
            }
            // Cache the determinant
            this._worldMatrixDeterminantIsDirty = true;
            return this._worldMatrix;
        }
        /**
         * Resets this nodeTransform's local matrix to Matrix.Identity().
         * @param independentOfChildren indicates if all child nodeTransform's world-space transform should be preserved.
         */
        resetLocalMatrix(independentOfChildren = true) {
            this.computeWorldMatrix();
            if (independentOfChildren) {
                const children = this.getChildren();
                for (let i = 0; i < children.length; ++i) {
                    const child = children[i];
                    if (child) {
                        child.computeWorldMatrix();
                        const bakedMatrix = TmpVectors.Matrix[0];
                        child._localMatrix.multiplyToRef(this._localMatrix, bakedMatrix);
                        const tmpRotationQuaternion = TmpVectors.Quaternion[0];
                        bakedMatrix.decompose(child.scaling, tmpRotationQuaternion, child.position);
                        if (child.rotationQuaternion) {
                            child.rotationQuaternion.copyFrom(tmpRotationQuaternion);
                        }
                        else {
                            tmpRotationQuaternion.toEulerAnglesToRef(child.rotation);
                        }
                    }
                }
            }
            this.scaling.copyFromFloats(1, 1, 1);
            this.position.copyFromFloats(0, 0, 0);
            this.rotation.copyFromFloats(0, 0, 0);
            //only if quaternion is already set
            if (this.rotationQuaternion) {
                this.rotationQuaternion = Quaternion.Identity();
            }
            this._worldMatrix = Matrix.Identity();
        }
        _afterComputeWorldMatrix() { }
        /**
         * If you'd like to be called back after the mesh position, rotation or scaling has been updated.
         * @param func callback function to add
         *
         * @returns the TransformNode.
         */
        registerAfterWorldMatrixUpdate(func) {
            this.onAfterWorldMatrixUpdateObservable.add(func);
            return this;
        }
        /**
         * Removes a registered callback function.
         * @param func callback function to remove
         * @returns the TransformNode.
         */
        unregisterAfterWorldMatrixUpdate(func) {
            this.onAfterWorldMatrixUpdateObservable.removeCallback(func);
            return this;
        }
        /**
         * Gets the position of the current mesh in camera space
         * @param camera defines the camera to use
         * @returns a position
         */
        getPositionInCameraSpace(camera = null) {
            if (!camera) {
                camera = this.getScene().activeCamera;
            }
            return Vector3.TransformCoordinates(this.getAbsolutePosition(), camera.getViewMatrix());
        }
        /**
         * Returns the distance from the mesh to the active camera
         * @param camera defines the camera to use
         * @returns the distance
         */
        getDistanceToCamera(camera = null) {
            if (!camera) {
                camera = this.getScene().activeCamera;
            }
            return this.getAbsolutePosition().subtract(camera.globalPosition).length();
        }
        /**
         * Clone the current transform node
         * @param name Name of the new clone
         * @param newParent New parent for the clone
         * @param doNotCloneChildren Do not clone children hierarchy
         * @returns the new transform node
         */
        clone(name, newParent, doNotCloneChildren) {
            const result = SerializationHelper.Clone(() => new TransformNode(name, this.getScene()), this);
            result.name = name;
            result.id = name;
            if (newParent) {
                result.parent = newParent;
            }
            if (!doNotCloneChildren) {
                // Children
                const directDescendants = this.getDescendants(true);
                for (let index = 0; index < directDescendants.length; index++) {
                    const child = directDescendants[index];
                    if (child.clone) {
                        child.clone(name + "." + child.name, result);
                    }
                }
            }
            return result;
        }
        /**
         * Serializes the objects information.
         * @param currentSerializationObject defines the object to serialize in
         * @returns the serialized object
         */
        serialize(currentSerializationObject) {
            const serializationObject = SerializationHelper.Serialize(this, currentSerializationObject);
            serializationObject.type = this.getClassName();
            serializationObject.uniqueId = this.uniqueId;
            // Parent
            if (this.parent) {
                this.parent._serializeAsParent(serializationObject);
            }
            serializationObject.localMatrix = this.getPivotMatrix().asArray();
            serializationObject.isEnabled = this.isEnabled();
            return serializationObject;
        }
        // Statics
        /**
         * Returns a new TransformNode object parsed from the source provided.
         * @param parsedTransformNode is the source.
         * @param scene the scene the object belongs to
         * @param rootUrl is a string, it's the root URL to prefix the `delayLoadingFile` property with
         * @returns a new TransformNode object parsed from the source provided.
         */
        static Parse(parsedTransformNode, scene, rootUrl) {
            const transformNode = SerializationHelper.Parse(() => new TransformNode(parsedTransformNode.name, scene), parsedTransformNode, scene, rootUrl);
            if (parsedTransformNode.localMatrix) {
                transformNode.setPreTransformMatrix(Matrix.FromArray(parsedTransformNode.localMatrix));
            }
            else if (parsedTransformNode.pivotMatrix) {
                transformNode.setPivotMatrix(Matrix.FromArray(parsedTransformNode.pivotMatrix));
            }
            transformNode.setEnabled(parsedTransformNode.isEnabled);
            transformNode._waitingParsedUniqueId = parsedTransformNode.uniqueId;
            // Parent
            if (parsedTransformNode.parentId !== undefined) {
                transformNode._waitingParentId = parsedTransformNode.parentId;
            }
            if (parsedTransformNode.parentInstanceIndex !== undefined) {
                transformNode._waitingParentInstanceIndex = parsedTransformNode.parentInstanceIndex;
            }
            return transformNode;
        }
        /**
         * Get all child-transformNodes of this node
         * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
         * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
         * @returns an array of TransformNode
         */
        getChildTransformNodes(directDescendantsOnly, predicate) {
            const results = [];
            this._getDescendants(results, directDescendantsOnly, (node) => {
                return (!predicate || predicate(node)) && node instanceof TransformNode;
            });
            return results;
        }
        /**
         * Releases resources associated with this transform node.
         * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
         * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            // Animations
            this.getScene().stopAnimation(this);
            // Remove from scene
            this.getScene().removeTransformNode(this);
            if (this._parentContainer) {
                const index = this._parentContainer.transformNodes.indexOf(this);
                if (index > -1) {
                    this._parentContainer.transformNodes.splice(index, 1);
                }
                this._parentContainer = null;
            }
            this.onAfterWorldMatrixUpdateObservable.clear();
            if (doNotRecurse) {
                const transformNodes = this.getChildTransformNodes(true);
                for (const transformNode of transformNodes) {
                    transformNode.parent = null;
                    transformNode.computeWorldMatrix(true);
                }
            }
            super.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        /**
         * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
         * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
         * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
         * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
         * @returns the current mesh
         */
        normalizeToUnitCube(includeDescendants = true, ignoreRotation = false, predicate) {
            let storedRotation = null;
            let storedRotationQuaternion = null;
            if (ignoreRotation) {
                if (this.rotationQuaternion) {
                    storedRotationQuaternion = this.rotationQuaternion.clone();
                    this.rotationQuaternion.copyFromFloats(0, 0, 0, 1);
                }
                else if (this.rotation) {
                    storedRotation = this.rotation.clone();
                    this.rotation.copyFromFloats(0, 0, 0);
                }
            }
            const boundingVectors = this.getHierarchyBoundingVectors(includeDescendants, predicate);
            const sizeVec = boundingVectors.max.subtract(boundingVectors.min);
            const maxDimension = Math.max(sizeVec.x, sizeVec.y, sizeVec.z);
            if (maxDimension === 0) {
                return this;
            }
            const scale = 1 / maxDimension;
            this.scaling.scaleInPlace(scale);
            if (ignoreRotation) {
                if (this.rotationQuaternion && storedRotationQuaternion) {
                    this.rotationQuaternion.copyFrom(storedRotationQuaternion);
                }
                else if (this.rotation && storedRotation) {
                    this.rotation.copyFrom(storedRotation);
                }
            }
            return this;
        }
        _syncAbsoluteScalingAndRotation() {
            if (!this._isAbsoluteSynced) {
                this._worldMatrix.decompose(this._absoluteScaling, this._absoluteRotationQuaternion);
                this._isAbsoluteSynced = true;
            }
        }
    }
    // Statics
    /**
     * Object will not rotate to face the camera
     */
    TransformNode.BILLBOARDMODE_NONE = 0;
    /**
     * Object will rotate to face the camera but only on the x axis
     */
    TransformNode.BILLBOARDMODE_X = 1;
    /**
     * Object will rotate to face the camera but only on the y axis
     */
    TransformNode.BILLBOARDMODE_Y = 2;
    /**
     * Object will rotate to face the camera but only on the z axis
     */
    TransformNode.BILLBOARDMODE_Z = 4;
    /**
     * Object will rotate to face the camera
     */
    TransformNode.BILLBOARDMODE_ALL = 7;
    /**
     * Object will rotate to face the camera's position instead of orientation
     */
    TransformNode.BILLBOARDMODE_USE_POSITION = 128;
    /**
     * Child transform with Billboard flags should or should not apply parent rotation (default if off)
     */
    TransformNode.BillboardUseParentOrientation = false;
    TransformNode._TmpRotation = Quaternion.Zero();
    TransformNode._TmpScaling = Vector3.Zero();
    TransformNode._TmpTranslation = Vector3.Zero();
    TransformNode._LookAtVectorCache = new Vector3(0, 0, 0);
    TransformNode._RotationAxisCache = new Quaternion();
    __decorate$1([
        serializeAsVector3("position")
    ], TransformNode.prototype, "_position", void 0);
    __decorate$1([
        serializeAsVector3("rotation")
    ], TransformNode.prototype, "_rotation", void 0);
    __decorate$1([
        serializeAsQuaternion("rotationQuaternion")
    ], TransformNode.prototype, "_rotationQuaternion", void 0);
    __decorate$1([
        serializeAsVector3("scaling")
    ], TransformNode.prototype, "_scaling", void 0);
    __decorate$1([
        serialize("billboardMode")
    ], TransformNode.prototype, "_billboardMode", void 0);
    __decorate$1([
        serialize()
    ], TransformNode.prototype, "scalingDeterminant", void 0);
    __decorate$1([
        serialize("infiniteDistance")
    ], TransformNode.prototype, "_infiniteDistance", void 0);
    __decorate$1([
        serialize()
    ], TransformNode.prototype, "ignoreNonUniformScaling", void 0);
    __decorate$1([
        serialize()
    ], TransformNode.prototype, "reIntegrateRotationIntoRotationQuaternion", void 0);

    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _MeshCollisionData {
        constructor() {
            this._checkCollisions = false;
            this._collisionMask = -1;
            this._collisionGroup = -1;
            this._surroundingMeshes = null;
            this._collider = null;
            this._oldPositionForCollisions = new Vector3(0, 0, 0);
            this._diffPositionForCollisions = new Vector3(0, 0, 0);
            this._collisionResponse = true;
        }
    }

    /** @internal */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _FacetDataStorage {
        constructor() {
            this.facetNb = 0; // facet number
            this.partitioningSubdivisions = 10; // number of subdivisions per axis in the partitioning space
            this.partitioningBBoxRatio = 1.01; // the partitioning array space is by default 1% bigger than the bounding box
            this.facetDataEnabled = false; // is the facet data feature enabled on this mesh ?
            this.facetParameters = {}; // keep a reference to the object parameters to avoid memory re-allocation
            this.bbSize = Vector3.Zero(); // bbox size approximated for facet data
            this.subDiv = {
                // actual number of subdivisions per axis for ComputeNormals()
                max: 1,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                X: 1,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                Y: 1,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                Z: 1,
            };
            this.facetDepthSort = false; // is the facet depth sort to be computed
            this.facetDepthSortEnabled = false; // is the facet depth sort initialized
        }
    }
    /**
     * @internal
     **/
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _InternalAbstractMeshDataInfo {
        constructor() {
            this._hasVertexAlpha = false;
            this._useVertexColors = true;
            this._numBoneInfluencers = 4;
            this._applyFog = true;
            this._receiveShadows = false;
            this._facetData = new _FacetDataStorage();
            this._visibility = 1.0;
            this._skeleton = null;
            this._layerMask = 0x0fffffff;
            this._computeBonesUsingShaders = true;
            this._isActive = false;
            this._onlyForInstances = false;
            this._isActiveIntermediate = false;
            this._onlyForInstancesIntermediate = false;
            this._actAsRegularMesh = false;
            this._currentLOD = null;
            this._currentLODIsUpToDate = false;
            this._collisionRetryCount = 3;
            this._morphTargetManager = null;
            this._renderingGroupId = 0;
            this._bakedVertexAnimationManager = null;
            this._material = null;
            this._positions = null;
            this._pointerOverDisableMeshTesting = false;
            // Collisions
            this._meshCollisionData = new _MeshCollisionData();
            this._enableDistantPicking = false;
            /** @internal
             * Bounding info that is unnafected by the addition of thin instances
             */
            this._rawBoundingInfo = null;
        }
    }
    /**
     * Class used to store all common mesh properties
     */
    class AbstractMesh extends TransformNode {
        /**
         * No billboard
         */
        static get BILLBOARDMODE_NONE() {
            return TransformNode.BILLBOARDMODE_NONE;
        }
        /** Billboard on X axis */
        static get BILLBOARDMODE_X() {
            return TransformNode.BILLBOARDMODE_X;
        }
        /** Billboard on Y axis */
        static get BILLBOARDMODE_Y() {
            return TransformNode.BILLBOARDMODE_Y;
        }
        /** Billboard on Z axis */
        static get BILLBOARDMODE_Z() {
            return TransformNode.BILLBOARDMODE_Z;
        }
        /** Billboard on all axes */
        static get BILLBOARDMODE_ALL() {
            return TransformNode.BILLBOARDMODE_ALL;
        }
        /** Billboard on using position instead of orientation */
        static get BILLBOARDMODE_USE_POSITION() {
            return TransformNode.BILLBOARDMODE_USE_POSITION;
        }
        /**
         * Gets the number of facets in the mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
         */
        get facetNb() {
            return this._internalAbstractMeshDataInfo._facetData.facetNb;
        }
        /**
         * Gets or set the number (integer) of subdivisions per axis in the partitioning space
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
         */
        get partitioningSubdivisions() {
            return this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions;
        }
        set partitioningSubdivisions(nb) {
            this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions = nb;
        }
        /**
         * The ratio (float) to apply to the bounding box size to set to the partitioning space.
         * Ex : 1.01 (default) the partitioning space is 1% bigger than the bounding box
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
         */
        get partitioningBBoxRatio() {
            return this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio;
        }
        set partitioningBBoxRatio(ratio) {
            this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio = ratio;
        }
        /**
         * Gets or sets a boolean indicating that the facets must be depth sorted on next call to `updateFacetData()`.
         * Works only for updatable meshes.
         * Doesn't work with multi-materials
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
         */
        get mustDepthSortFacets() {
            return this._internalAbstractMeshDataInfo._facetData.facetDepthSort;
        }
        set mustDepthSortFacets(sort) {
            this._internalAbstractMeshDataInfo._facetData.facetDepthSort = sort;
        }
        /**
         * The location (Vector3) where the facet depth sort must be computed from.
         * By default, the active camera position.
         * Used only when facet depth sort is enabled
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
         */
        get facetDepthSortFrom() {
            return this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom;
        }
        set facetDepthSortFrom(location) {
            this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom = location;
        }
        /** number of collision detection tries. Change this value if not all collisions are detected and handled properly */
        get collisionRetryCount() {
            return this._internalAbstractMeshDataInfo._collisionRetryCount;
        }
        set collisionRetryCount(retryCount) {
            this._internalAbstractMeshDataInfo._collisionRetryCount = retryCount;
        }
        /**
         * gets a boolean indicating if facetData is enabled
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
         */
        get isFacetDataEnabled() {
            return this._internalAbstractMeshDataInfo._facetData.facetDataEnabled;
        }
        /**
         * Gets or sets the morph target manager
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/morphTargets
         */
        get morphTargetManager() {
            return this._internalAbstractMeshDataInfo._morphTargetManager;
        }
        set morphTargetManager(value) {
            if (this._internalAbstractMeshDataInfo._morphTargetManager === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._morphTargetManager = value;
            this._syncGeometryWithMorphTargetManager();
        }
        /**
         * Gets or sets the baked vertex animation manager
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/baked_texture_animations
         */
        get bakedVertexAnimationManager() {
            return this._internalAbstractMeshDataInfo._bakedVertexAnimationManager;
        }
        set bakedVertexAnimationManager(value) {
            if (this._internalAbstractMeshDataInfo._bakedVertexAnimationManager === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._bakedVertexAnimationManager = value;
            this._markSubMeshesAsAttributesDirty();
        }
        /** @internal */
        _syncGeometryWithMorphTargetManager() { }
        /**
         * @internal
         */
        _updateNonUniformScalingState(value) {
            if (!super._updateNonUniformScalingState(value)) {
                return false;
            }
            this._markSubMeshesAsMiscDirty();
            return true;
        }
        /** @internal */
        get rawBoundingInfo() {
            return this._internalAbstractMeshDataInfo._rawBoundingInfo;
        }
        set rawBoundingInfo(boundingInfo) {
            this._internalAbstractMeshDataInfo._rawBoundingInfo = boundingInfo;
        }
        /** Set a function to call when this mesh collides with another one */
        set onCollide(callback) {
            if (this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver) {
                this.onCollideObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver);
            }
            this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver = this.onCollideObservable.add(callback);
        }
        /** Set a function to call when the collision's position changes */
        set onCollisionPositionChange(callback) {
            if (this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver) {
                this.onCollisionPositionChangeObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver);
            }
            this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver = this.onCollisionPositionChangeObservable.add(callback);
        }
        /**
         * Gets or sets mesh visibility between 0 and 1 (default is 1)
         */
        get visibility() {
            return this._internalAbstractMeshDataInfo._visibility;
        }
        /**
         * Gets or sets mesh visibility between 0 and 1 (default is 1)
         */
        set visibility(value) {
            if (this._internalAbstractMeshDataInfo._visibility === value) {
                return;
            }
            const oldValue = this._internalAbstractMeshDataInfo._visibility;
            this._internalAbstractMeshDataInfo._visibility = value;
            if ((oldValue === 1 && value !== 1) || (oldValue !== 1 && value === 1)) {
                this._markSubMeshesAsDirty((defines) => {
                    defines.markAsMiscDirty();
                    defines.markAsPrePassDirty();
                });
            }
        }
        /**
         * Gets or sets the property which disables the test that is checking that the mesh under the pointer is the same than the previous time we tested for it (default: false).
         * Set this property to true if you want thin instances picking to be reported accurately when moving over the mesh.
         * Note that setting this property to true will incur some performance penalties when dealing with pointer events for this mesh so use it sparingly.
         */
        get pointerOverDisableMeshTesting() {
            return this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting;
        }
        set pointerOverDisableMeshTesting(disable) {
            this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting = disable;
        }
        /**
         * Specifies the rendering group id for this mesh (0 by default)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#rendering-groups
         */
        get renderingGroupId() {
            return this._internalAbstractMeshDataInfo._renderingGroupId;
        }
        set renderingGroupId(value) {
            this._internalAbstractMeshDataInfo._renderingGroupId = value;
        }
        /** Gets or sets current material */
        get material() {
            return this._internalAbstractMeshDataInfo._material;
        }
        set material(value) {
            if (this._internalAbstractMeshDataInfo._material === value) {
                return;
            }
            // remove from material mesh map id needed
            if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) {
                this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = undefined;
            }
            this._internalAbstractMeshDataInfo._material = value;
            if (value && value.meshMap) {
                value.meshMap[this.uniqueId] = this;
            }
            if (this.onMaterialChangedObservable.hasObservers()) {
                this.onMaterialChangedObservable.notifyObservers(this);
            }
            if (!this.subMeshes) {
                return;
            }
            this.resetDrawCache();
            this._unBindEffect();
        }
        /**
         * Gets the material used to render the mesh in a specific render pass
         * @param renderPassId render pass id
         * @returns material used for the render pass. If no specific material is used for this render pass, undefined is returned (meaning mesh.material is used for this pass)
         */
        getMaterialForRenderPass(renderPassId) {
            var _a;
            return (_a = this._internalAbstractMeshDataInfo._materialForRenderPass) === null || _a === void 0 ? void 0 : _a[renderPassId];
        }
        /**
         * Sets the material to be used to render the mesh in a specific render pass
         * @param renderPassId render pass id
         * @param material material to use for this render pass. If undefined is passed, no specific material will be used for this render pass but the regular material will be used instead (mesh.material)
         */
        setMaterialForRenderPass(renderPassId, material) {
            this.resetDrawCache(renderPassId);
            if (!this._internalAbstractMeshDataInfo._materialForRenderPass) {
                this._internalAbstractMeshDataInfo._materialForRenderPass = [];
            }
            this._internalAbstractMeshDataInfo._materialForRenderPass[renderPassId] = material;
        }
        /**
         * Gets or sets a boolean indicating that this mesh can receive realtime shadows
         * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
         */
        get receiveShadows() {
            return this._internalAbstractMeshDataInfo._receiveShadows;
        }
        set receiveShadows(value) {
            if (this._internalAbstractMeshDataInfo._receiveShadows === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._receiveShadows = value;
            this._markSubMeshesAsLightDirty();
        }
        /** Gets or sets a boolean indicating that this mesh contains vertex color data with alpha values */
        get hasVertexAlpha() {
            return this._internalAbstractMeshDataInfo._hasVertexAlpha;
        }
        set hasVertexAlpha(value) {
            if (this._internalAbstractMeshDataInfo._hasVertexAlpha === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._hasVertexAlpha = value;
            this._markSubMeshesAsAttributesDirty();
            this._markSubMeshesAsMiscDirty();
        }
        /** Gets or sets a boolean indicating that this mesh needs to use vertex color data to render (if this kind of vertex data is available in the geometry) */
        get useVertexColors() {
            return this._internalAbstractMeshDataInfo._useVertexColors;
        }
        set useVertexColors(value) {
            if (this._internalAbstractMeshDataInfo._useVertexColors === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._useVertexColors = value;
            this._markSubMeshesAsAttributesDirty();
        }
        /**
         * Gets or sets a boolean indicating that bone animations must be computed by the GPU (true by default)
         */
        get computeBonesUsingShaders() {
            return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
        }
        set computeBonesUsingShaders(value) {
            if (this._internalAbstractMeshDataInfo._computeBonesUsingShaders === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._computeBonesUsingShaders = value;
            this._markSubMeshesAsAttributesDirty();
        }
        /** Gets or sets the number of allowed bone influences per vertex (4 by default) */
        get numBoneInfluencers() {
            return this._internalAbstractMeshDataInfo._numBoneInfluencers;
        }
        set numBoneInfluencers(value) {
            if (this._internalAbstractMeshDataInfo._numBoneInfluencers === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._numBoneInfluencers = value;
            this._markSubMeshesAsAttributesDirty();
        }
        /** Gets or sets a boolean indicating that this mesh will allow fog to be rendered on it (true by default) */
        get applyFog() {
            return this._internalAbstractMeshDataInfo._applyFog;
        }
        set applyFog(value) {
            if (this._internalAbstractMeshDataInfo._applyFog === value) {
                return;
            }
            this._internalAbstractMeshDataInfo._applyFog = value;
            this._markSubMeshesAsMiscDirty();
        }
        /** When enabled, decompose picking matrices for better precision with large values for mesh position and scling */
        get enableDistantPicking() {
            return this._internalAbstractMeshDataInfo._enableDistantPicking;
        }
        set enableDistantPicking(value) {
            this._internalAbstractMeshDataInfo._enableDistantPicking = value;
        }
        /**
         * Gets or sets the current layer mask (default is 0x0FFFFFFF)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/layerMasksAndMultiCam
         */
        get layerMask() {
            return this._internalAbstractMeshDataInfo._layerMask;
        }
        set layerMask(value) {
            if (value === this._internalAbstractMeshDataInfo._layerMask) {
                return;
            }
            this._internalAbstractMeshDataInfo._layerMask = value;
            this._resyncLightSources();
        }
        /**
         * Gets or sets a collision mask used to mask collisions (default is -1).
         * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
         */
        get collisionMask() {
            return this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask;
        }
        set collisionMask(mask) {
            this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask = !isNaN(mask) ? mask : -1;
        }
        /**
         * Gets or sets a collision response flag (default is true).
         * when collisionResponse is false, events are still triggered but colliding entity has no response
         * This helps creating trigger volume when user wants collision feedback events but not position/velocity
         * to respond to the collision.
         */
        get collisionResponse() {
            return this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse;
        }
        set collisionResponse(response) {
            this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse = response;
        }
        /**
         * Gets or sets the current collision group mask (-1 by default).
         * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
         */
        get collisionGroup() {
            return this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup;
        }
        set collisionGroup(mask) {
            this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup = !isNaN(mask) ? mask : -1;
        }
        /**
         * Gets or sets current surrounding meshes (null by default).
         *
         * By default collision detection is tested against every mesh in the scene.
         * It is possible to set surroundingMeshes to a defined list of meshes and then only these specified
         * meshes will be tested for the collision.
         *
         * Note: if set to an empty array no collision will happen when this mesh is moved.
         */
        get surroundingMeshes() {
            return this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes;
        }
        set surroundingMeshes(meshes) {
            this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes = meshes;
        }
        /** Gets the list of lights affecting that mesh */
        get lightSources() {
            return this._lightSources;
        }
        /** @internal */
        get _positions() {
            return null;
        }
        /**
         * Gets or sets a skeleton to apply skinning transformations
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
         */
        set skeleton(value) {
            const skeleton = this._internalAbstractMeshDataInfo._skeleton;
            if (skeleton && skeleton.needInitialSkinMatrix) {
                skeleton._unregisterMeshWithPoseMatrix(this);
            }
            if (value && value.needInitialSkinMatrix) {
                value._registerMeshWithPoseMatrix(this);
            }
            this._internalAbstractMeshDataInfo._skeleton = value;
            if (!this._internalAbstractMeshDataInfo._skeleton) {
                this._bonesTransformMatrices = null;
            }
            this._markSubMeshesAsAttributesDirty();
        }
        get skeleton() {
            return this._internalAbstractMeshDataInfo._skeleton;
        }
        // Constructor
        /**
         * Creates a new AbstractMesh
         * @param name defines the name of the mesh
         * @param scene defines the hosting scene
         */
        constructor(name, scene = null) {
            super(name, scene, false);
            // Internal data
            /** @internal */
            this._internalAbstractMeshDataInfo = new _InternalAbstractMeshDataInfo();
            /** @internal */
            this._waitingMaterialId = null;
            /**
             * The culling strategy to use to check whether the mesh must be rendered or not.
             * This value can be changed at any time and will be used on the next render mesh selection.
             * The possible values are :
             * - AbstractMesh.CULLINGSTRATEGY_STANDARD
             * - AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
             * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
             * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
             * Please read each static variable documentation to get details about the culling process.
             * */
            this.cullingStrategy = AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;
            // Events
            /**
             * An event triggered when this mesh collides with another one
             */
            this.onCollideObservable = new Observable$1();
            /**
             * An event triggered when the collision's position changes
             */
            this.onCollisionPositionChangeObservable = new Observable$1();
            /**
             * An event triggered when material is changed
             */
            this.onMaterialChangedObservable = new Observable$1();
            // Properties
            /**
             * Gets or sets the orientation for POV movement & rotation
             */
            this.definedFacingForward = true;
            /** @internal */
            this._occlusionQuery = null;
            /** @internal */
            this._renderingGroup = null;
            /** Gets or sets the alpha index used to sort transparent meshes
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#alpha-index
             */
            this.alphaIndex = Number.MAX_VALUE;
            /**
             * Gets or sets a boolean indicating if the mesh is visible (renderable). Default is true
             */
            this.isVisible = true;
            /**
             * Gets or sets a boolean indicating if the mesh can be picked (by scene.pick for instance or through actions). Default is true
             */
            this.isPickable = true;
            /**
             * Gets or sets a boolean indicating if the mesh can be near picked. Default is false
             */
            this.isNearPickable = false;
            /**
             * Gets or sets a boolean indicating if the mesh can be near grabbed. Default is false
             */
            this.isNearGrabbable = false;
            /** Gets or sets a boolean indicating that bounding boxes of subMeshes must be rendered as well (false by default) */
            this.showSubMeshesBoundingBox = false;
            /** Gets or sets a boolean indicating if the mesh must be considered as a ray blocker for lens flares (false by default)
             * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
             */
            this.isBlocker = false;
            /**
             * Gets or sets a boolean indicating that pointer move events must be supported on this mesh (false by default)
             */
            this.enablePointerMoveEvents = false;
            /** Defines color to use when rendering outline */
            this.outlineColor = Color3.Red();
            /** Define width to use when rendering outline */
            this.outlineWidth = 0.02;
            /** Defines color to use when rendering overlay */
            this.overlayColor = Color3.Red();
            /** Defines alpha to use when rendering overlay */
            this.overlayAlpha = 0.5;
            /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes selection (true by default) */
            this.useOctreeForRenderingSelection = true;
            /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes picking (true by default) */
            this.useOctreeForPicking = true;
            /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes collision (true by default) */
            this.useOctreeForCollisions = true;
            /**
             * True if the mesh must be rendered in any case (this will shortcut the frustum clipping phase)
             */
            this.alwaysSelectAsActiveMesh = false;
            /**
             * Gets or sets a boolean indicating that the bounding info does not need to be kept in sync (for performance reason)
             */
            this.doNotSyncBoundingInfo = false;
            /**
             * Gets or sets the current action manager
             * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions
             */
            this.actionManager = null;
            /**
             * Gets or sets the ellipsoid used to impersonate this mesh when using collision engine (default is (0.5, 1, 0.5))
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
             */
            this.ellipsoid = new Vector3(0.5, 1, 0.5);
            /**
             * Gets or sets the ellipsoid offset used to impersonate this mesh when using collision engine (default is (0, 0, 0))
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
             */
            this.ellipsoidOffset = new Vector3(0, 0, 0);
            // Edges
            /**
             * Defines edge width used when edgesRenderer is enabled
             * @see https://www.babylonjs-playground.com/#10OJSG#13
             */
            this.edgesWidth = 1;
            /**
             * Defines edge color used when edgesRenderer is enabled
             * @see https://www.babylonjs-playground.com/#10OJSG#13
             */
            this.edgesColor = new Color4(1, 0, 0, 1);
            /** @internal */
            this._edgesRenderer = null;
            /** @internal */
            this._masterMesh = null;
            this._boundingInfo = null;
            this._boundingInfoIsDirty = true;
            /** @internal */
            this._renderId = 0;
            /** @internal */
            this._intersectionsInProgress = new Array();
            /** @internal */
            this._unIndexed = false;
            /** @internal */
            this._lightSources = new Array();
            // Loading properties
            /** @internal */
            this._waitingData = {
                lods: null,
                actions: null,
                freezeWorldMatrix: null,
            };
            /** @internal */
            this._bonesTransformMatrices = null;
            /** @internal */
            this._transformMatrixTexture = null;
            /**
             * An event triggered when the mesh is rebuilt.
             */
            this.onRebuildObservable = new Observable$1();
            this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null) => {
                newPosition.subtractToRef(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions);
                if (this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions.length() > Engine.CollisionsEpsilon) {
                    this.position.addInPlace(this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions);
                }
                if (collidedMesh) {
                    this.onCollideObservable.notifyObservers(collidedMesh);
                }
                this.onCollisionPositionChangeObservable.notifyObservers(this.position);
            };
            scene = this.getScene();
            scene.addMesh(this);
            this._resyncLightSources();
            // Mesh Uniform Buffer.
            this._uniformBuffer = new UniformBuffer(this.getScene().getEngine(), undefined, undefined, name, !this.getScene().getEngine().isWebGPU);
            this._buildUniformLayout();
            switch (scene.performancePriority) {
                case ScenePerformancePriority.Aggressive:
                    this.doNotSyncBoundingInfo = true;
                // eslint-disable-next-line no-fallthrough
                case ScenePerformancePriority.Intermediate:
                    this.alwaysSelectAsActiveMesh = true;
                    this.isPickable = false;
                    break;
            }
        }
        _buildUniformLayout() {
            this._uniformBuffer.addUniform("world", 16);
            this._uniformBuffer.addUniform("visibility", 1);
            this._uniformBuffer.create();
        }
        /**
         * Transfer the mesh values to its UBO.
         * @param world The world matrix associated with the mesh
         */
        transferToEffect(world) {
            const ubo = this._uniformBuffer;
            ubo.updateMatrix("world", world);
            ubo.updateFloat("visibility", this._internalAbstractMeshDataInfo._visibility);
            ubo.update();
        }
        /**
         * Gets the mesh uniform buffer.
         * @returns the uniform buffer of the mesh.
         */
        getMeshUniformBuffer() {
            return this._uniformBuffer;
        }
        /**
         * Returns the string "AbstractMesh"
         * @returns "AbstractMesh"
         */
        getClassName() {
            return "AbstractMesh";
        }
        /**
         * Gets a string representation of the current mesh
         * @param fullDetails defines a boolean indicating if full details must be included
         * @returns a string representation of the current mesh
         */
        toString(fullDetails) {
            let ret = "Name: " + this.name + ", isInstance: " + (this.getClassName() !== "InstancedMesh" ? "YES" : "NO");
            ret += ", # of submeshes: " + (this.subMeshes ? this.subMeshes.length : 0);
            const skeleton = this._internalAbstractMeshDataInfo._skeleton;
            if (skeleton) {
                ret += ", skeleton: " + skeleton.name;
            }
            if (fullDetails) {
                ret += ", billboard mode: " + ["NONE", "X", "Y", null, "Z", null, null, "ALL"][this.billboardMode];
                ret += ", freeze wrld mat: " + (this._isWorldMatrixFrozen || this._waitingData.freezeWorldMatrix ? "YES" : "NO");
            }
            return ret;
        }
        /**
         * @internal
         */
        _getEffectiveParent() {
            if (this._masterMesh && this.billboardMode !== TransformNode.BILLBOARDMODE_NONE) {
                return this._masterMesh;
            }
            return super._getEffectiveParent();
        }
        /**
         * @internal
         */
        _getActionManagerForTrigger(trigger, initialCall = true) {
            if (this.actionManager && (initialCall || this.actionManager.isRecursive)) {
                if (trigger) {
                    if (this.actionManager.hasSpecificTrigger(trigger)) {
                        return this.actionManager;
                    }
                }
                else {
                    return this.actionManager;
                }
            }
            if (!this.parent) {
                return null;
            }
            return this.parent._getActionManagerForTrigger(trigger, false);
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _rebuild(dispose = false) {
            this.onRebuildObservable.notifyObservers(this);
            if (this._occlusionQuery !== null) {
                this._occlusionQuery = null;
            }
            if (!this.subMeshes) {
                return;
            }
            for (const subMesh of this.subMeshes) {
                subMesh._rebuild();
            }
        }
        /** @internal */
        _resyncLightSources() {
            this._lightSources.length = 0;
            for (const light of this.getScene().lights) {
                if (!light.isEnabled()) {
                    continue;
                }
                if (light.canAffectMesh(this)) {
                    this._lightSources.push(light);
                }
            }
            this._markSubMeshesAsLightDirty();
        }
        /**
         * @internal
         */
        _resyncLightSource(light) {
            const isIn = light.isEnabled() && light.canAffectMesh(this);
            const index = this._lightSources.indexOf(light);
            let removed = false;
            if (index === -1) {
                if (!isIn) {
                    return;
                }
                this._lightSources.push(light);
            }
            else {
                if (isIn) {
                    return;
                }
                removed = true;
                this._lightSources.splice(index, 1);
            }
            this._markSubMeshesAsLightDirty(removed);
        }
        /** @internal */
        _unBindEffect() {
            for (const subMesh of this.subMeshes) {
                subMesh.setEffect(null);
            }
        }
        /**
         * @internal
         */
        _removeLightSource(light, dispose) {
            const index = this._lightSources.indexOf(light);
            if (index === -1) {
                return;
            }
            this._lightSources.splice(index, 1);
            this._markSubMeshesAsLightDirty(dispose);
        }
        _markSubMeshesAsDirty(func) {
            if (!this.subMeshes) {
                return;
            }
            for (const subMesh of this.subMeshes) {
                for (let i = 0; i < subMesh._drawWrappers.length; ++i) {
                    const drawWrapper = subMesh._drawWrappers[i];
                    if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) {
                        continue;
                    }
                    func(drawWrapper.defines);
                }
            }
        }
        /**
         * @internal
         */
        _markSubMeshesAsLightDirty(dispose = false) {
            this._markSubMeshesAsDirty((defines) => defines.markAsLightDirty(dispose));
        }
        /** @internal */
        _markSubMeshesAsAttributesDirty() {
            this._markSubMeshesAsDirty((defines) => defines.markAsAttributesDirty());
        }
        /** @internal */
        _markSubMeshesAsMiscDirty() {
            this._markSubMeshesAsDirty((defines) => defines.markAsMiscDirty());
        }
        /**
         * Flag the AbstractMesh as dirty (Forcing it to update everything)
         * @param property if set to "rotation" the objects rotationQuaternion will be set to null
         * @returns this AbstractMesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        markAsDirty(property) {
            this._currentRenderId = Number.MAX_VALUE;
            this._isDirty = true;
            return this;
        }
        /**
         * Resets the draw wrappers cache for all submeshes of this abstract mesh
         * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
         */
        resetDrawCache(passId) {
            if (!this.subMeshes) {
                return;
            }
            for (const subMesh of this.subMeshes) {
                subMesh.resetDrawCache(passId);
            }
        }
        // Methods
        /**
         * Returns true if the mesh is blocked. Implemented by child classes
         */
        get isBlocked() {
            return false;
        }
        /**
         * Returns the mesh itself by default. Implemented by child classes
         * @param camera defines the camera to use to pick the right LOD level
         * @returns the currentAbstractMesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getLOD(camera) {
            return this;
        }
        /**
         * Returns 0 by default. Implemented by child classes
         * @returns an integer
         */
        getTotalVertices() {
            return 0;
        }
        /**
         * Returns a positive integer : the total number of indices in this mesh geometry.
         * @returns the number of indices or zero if the mesh has no geometry.
         */
        getTotalIndices() {
            return 0;
        }
        /**
         * Returns null by default. Implemented by child classes
         * @returns null
         */
        getIndices() {
            return null;
        }
        /**
         * Returns the array of the requested vertex data kind. Implemented by child classes
         * @param kind defines the vertex data kind to use
         * @returns null
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getVerticesData(kind) {
            return null;
        }
        /**
         * Sets the vertex data of the mesh geometry for the requested `kind`.
         * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
         * Note that a new underlying VertexBuffer object is created each call.
         * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
         * @param kind defines vertex data kind:
         * * VertexBuffer.PositionKind
         * * VertexBuffer.UVKind
         * * VertexBuffer.UV2Kind
         * * VertexBuffer.UV3Kind
         * * VertexBuffer.UV4Kind
         * * VertexBuffer.UV5Kind
         * * VertexBuffer.UV6Kind
         * * VertexBuffer.ColorKind
         * * VertexBuffer.MatricesIndicesKind
         * * VertexBuffer.MatricesIndicesExtraKind
         * * VertexBuffer.MatricesWeightsKind
         * * VertexBuffer.MatricesWeightsExtraKind
         * @param data defines the data source
         * @param updatable defines if the data must be flagged as updatable (or static)
         * @param stride defines the vertex stride (size of an entire vertex). Can be null and in this case will be deduced from vertex data kind
         * @returns the current mesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setVerticesData(kind, data, updatable, stride) {
            return this;
        }
        /**
         * Updates the existing vertex data of the mesh geometry for the requested `kind`.
         * If the mesh has no geometry, it is simply returned as it is.
         * @param kind defines vertex data kind:
         * * VertexBuffer.PositionKind
         * * VertexBuffer.UVKind
         * * VertexBuffer.UV2Kind
         * * VertexBuffer.UV3Kind
         * * VertexBuffer.UV4Kind
         * * VertexBuffer.UV5Kind
         * * VertexBuffer.UV6Kind
         * * VertexBuffer.ColorKind
         * * VertexBuffer.MatricesIndicesKind
         * * VertexBuffer.MatricesIndicesExtraKind
         * * VertexBuffer.MatricesWeightsKind
         * * VertexBuffer.MatricesWeightsExtraKind
         * @param data defines the data source
         * @param updateExtends If `kind` is `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed
         * @param makeItUnique If true, a new global geometry is created from this data and is set to the mesh
         * @returns the current mesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateVerticesData(kind, data, updateExtends, makeItUnique) {
            return this;
        }
        /**
         * Sets the mesh indices,
         * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
         * @param indices Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array)
         * @param totalVertices Defines the total number of vertices
         * @returns the current mesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setIndices(indices, totalVertices) {
            return this;
        }
        /**
         * Gets a boolean indicating if specific vertex data is present
         * @param kind defines the vertex data kind to use
         * @returns true is data kind is present
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isVerticesDataPresent(kind) {
            return false;
        }
        /**
         * Returns the mesh BoundingInfo object or creates a new one and returns if it was undefined.
         * Note that it returns a shallow bounding of the mesh (i.e. it does not include children).
         * However, if the mesh contains thin instances, it will be expanded to include them. If you want the "raw" bounding data instead, then use `getRawBoundingInfo()`.
         * To get the full bounding of all children, call `getHierarchyBoundingVectors` instead.
         * @returns a BoundingInfo
         */
        getBoundingInfo() {
            if (this._masterMesh) {
                return this._masterMesh.getBoundingInfo();
            }
            if (this._boundingInfoIsDirty) {
                this._boundingInfoIsDirty = false;
                // this._boundingInfo is being created if undefined
                this._updateBoundingInfo();
            }
            // cannot be null.
            return this._boundingInfo;
        }
        /**
         * Returns the bounding info unnafected by instance data.
         * @returns the bounding info of the mesh unaffected by instance data.
         */
        getRawBoundingInfo() {
            var _a;
            return (_a = this.rawBoundingInfo) !== null && _a !== void 0 ? _a : this.getBoundingInfo();
        }
        /**
         * Overwrite the current bounding info
         * @param boundingInfo defines the new bounding info
         * @returns the current mesh
         */
        setBoundingInfo(boundingInfo) {
            this._boundingInfo = boundingInfo;
            return this;
        }
        /**
         * Returns true if there is already a bounding info
         */
        get hasBoundingInfo() {
            return this._boundingInfo !== null;
        }
        /**
         * Creates a new bounding info for the mesh
         * @param minimum min vector of the bounding box/sphere
         * @param maximum max vector of the bounding box/sphere
         * @param worldMatrix defines the new world matrix
         * @returns the new bounding info
         */
        buildBoundingInfo(minimum, maximum, worldMatrix) {
            this._boundingInfo = new BoundingInfo(minimum, maximum, worldMatrix);
            return this._boundingInfo;
        }
        /**
         * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
         * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
         * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
         * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
         * @returns the current mesh
         */
        normalizeToUnitCube(includeDescendants = true, ignoreRotation = false, predicate) {
            return super.normalizeToUnitCube(includeDescendants, ignoreRotation, predicate);
        }
        /** Gets a boolean indicating if this mesh has skinning data and an attached skeleton */
        get useBones() {
            return ((this.skeleton &&
                this.getScene().skeletonsEnabled &&
                this.isVerticesDataPresent(VertexBuffer.MatricesIndicesKind) &&
                this.isVerticesDataPresent(VertexBuffer.MatricesWeightsKind)));
        }
        /** @internal */
        _preActivate() { }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _preActivateForIntermediateRendering(renderId) { }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _activate(renderId, intermediateRendering) {
            this._renderId = renderId;
            return true;
        }
        /** @internal */
        _postActivate() {
            // Do nothing
        }
        /** @internal */
        _freeze() {
            // Do nothing
        }
        /** @internal */
        _unFreeze() {
            // Do nothing
        }
        /**
         * Gets the current world matrix
         * @returns a Matrix
         */
        getWorldMatrix() {
            if (this._masterMesh && this.billboardMode === TransformNode.BILLBOARDMODE_NONE) {
                return this._masterMesh.getWorldMatrix();
            }
            return super.getWorldMatrix();
        }
        /** @internal */
        _getWorldMatrixDeterminant() {
            if (this._masterMesh) {
                return this._masterMesh._getWorldMatrixDeterminant();
            }
            return super._getWorldMatrixDeterminant();
        }
        /**
         * Gets a boolean indicating if this mesh is an instance or a regular mesh
         */
        get isAnInstance() {
            return false;
        }
        /**
         * Gets a boolean indicating if this mesh has instances
         */
        get hasInstances() {
            return false;
        }
        /**
         * Gets a boolean indicating if this mesh has thin instances
         */
        get hasThinInstances() {
            return false;
        }
        // ================================== Point of View Movement =================================
        /**
         * Perform relative position change from the point of view of behind the front of the mesh.
         * This is performed taking into account the meshes current rotation, so you do not have to care.
         * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
         * @param amountRight defines the distance on the right axis
         * @param amountUp defines the distance on the up axis
         * @param amountForward defines the distance on the forward axis
         * @returns the current mesh
         */
        movePOV(amountRight, amountUp, amountForward) {
            this.position.addInPlace(this.calcMovePOV(amountRight, amountUp, amountForward));
            return this;
        }
        /**
         * Calculate relative position change from the point of view of behind the front of the mesh.
         * This is performed taking into account the meshes current rotation, so you do not have to care.
         * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
         * @param amountRight defines the distance on the right axis
         * @param amountUp defines the distance on the up axis
         * @param amountForward defines the distance on the forward axis
         * @returns the new displacement vector
         */
        calcMovePOV(amountRight, amountUp, amountForward) {
            const rotMatrix = new Matrix();
            const rotQuaternion = this.rotationQuaternion ? this.rotationQuaternion : Quaternion.RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z);
            rotQuaternion.toRotationMatrix(rotMatrix);
            const translationDelta = Vector3.Zero();
            const defForwardMult = this.definedFacingForward ? -1 : 1;
            Vector3.TransformCoordinatesFromFloatsToRef(amountRight * defForwardMult, amountUp, amountForward * defForwardMult, rotMatrix, translationDelta);
            return translationDelta;
        }
        // ================================== Point of View Rotation =================================
        /**
         * Perform relative rotation change from the point of view of behind the front of the mesh.
         * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
         * @param flipBack defines the flip
         * @param twirlClockwise defines the twirl
         * @param tiltRight defines the tilt
         * @returns the current mesh
         */
        rotatePOV(flipBack, twirlClockwise, tiltRight) {
            this.rotation.addInPlace(this.calcRotatePOV(flipBack, twirlClockwise, tiltRight));
            return this;
        }
        /**
         * Calculate relative rotation change from the point of view of behind the front of the mesh.
         * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
         * @param flipBack defines the flip
         * @param twirlClockwise defines the twirl
         * @param tiltRight defines the tilt
         * @returns the new rotation vector
         */
        calcRotatePOV(flipBack, twirlClockwise, tiltRight) {
            const defForwardMult = this.definedFacingForward ? 1 : -1;
            return new Vector3(flipBack * defForwardMult, twirlClockwise, tiltRight * defForwardMult);
        }
        /**
         * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
         * This means the mesh underlying bounding box and sphere are recomputed.
         * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
         * @param applyMorph  defines whether to apply the morph target before computing the bounding info
         * @returns the current mesh
         */
        refreshBoundingInfo(applySkeleton = false, applyMorph = false) {
            if (this._boundingInfo && this._boundingInfo.isLocked) {
                return this;
            }
            this._refreshBoundingInfo(this._getPositionData(applySkeleton, applyMorph), null);
            return this;
        }
        /**
         * @internal
         */
        _refreshBoundingInfo(data, bias) {
            if (data) {
                const extend = extractMinAndMax(data, 0, this.getTotalVertices(), bias);
                if (this._boundingInfo) {
                    this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
                }
                else {
                    this._boundingInfo = new BoundingInfo(extend.minimum, extend.maximum);
                }
            }
            if (this.subMeshes) {
                for (let index = 0; index < this.subMeshes.length; index++) {
                    this.subMeshes[index].refreshBoundingInfo(data);
                }
            }
            this._updateBoundingInfo();
        }
        /**
         * Internal function to get buffer data and possibly apply morphs and normals
         * @param applySkeleton
         * @param applyMorph
         * @param data
         * @param kind the kind of data you want. Can be Normal or Position
         */
        _getData(applySkeleton = false, applyMorph = false, data, kind = VertexBuffer.PositionKind) {
            data = data !== null && data !== void 0 ? data : this.getVerticesData(kind).slice();
            if (data && applyMorph && this.morphTargetManager) {
                let faceIndexCount = 0;
                let positionIndex = 0;
                for (let vertexCount = 0; vertexCount < data.length; vertexCount++) {
                    for (let targetCount = 0; targetCount < this.morphTargetManager.numTargets; targetCount++) {
                        const targetMorph = this.morphTargetManager.getTarget(targetCount);
                        const influence = targetMorph.influence;
                        if (influence > 0.0) {
                            const morphTargetPositions = targetMorph.getPositions();
                            if (morphTargetPositions) {
                                data[vertexCount] += (morphTargetPositions[vertexCount] - data[vertexCount]) * influence;
                            }
                        }
                    }
                    faceIndexCount++;
                    if (kind === VertexBuffer.PositionKind) {
                        if (this._positions && faceIndexCount === 3) {
                            // We want to merge into positions every 3 indices starting (but not 0)
                            faceIndexCount = 0;
                            const index = positionIndex * 3;
                            this._positions[positionIndex++].copyFromFloats(data[index], data[index + 1], data[index + 2]);
                        }
                    }
                }
            }
            if (data && applySkeleton && this.skeleton) {
                const matricesIndicesData = this.getVerticesData(VertexBuffer.MatricesIndicesKind);
                const matricesWeightsData = this.getVerticesData(VertexBuffer.MatricesWeightsKind);
                if (matricesWeightsData && matricesIndicesData) {
                    const needExtras = this.numBoneInfluencers > 4;
                    const matricesIndicesExtraData = needExtras ? this.getVerticesData(VertexBuffer.MatricesIndicesExtraKind) : null;
                    const matricesWeightsExtraData = needExtras ? this.getVerticesData(VertexBuffer.MatricesWeightsExtraKind) : null;
                    const skeletonMatrices = this.skeleton.getTransformMatrices(this);
                    const tempVector = TmpVectors.Vector3[0];
                    const finalMatrix = TmpVectors.Matrix[0];
                    const tempMatrix = TmpVectors.Matrix[1];
                    let matWeightIdx = 0;
                    for (let index = 0; index < data.length; index += 3, matWeightIdx += 4) {
                        finalMatrix.reset();
                        let inf;
                        let weight;
                        for (inf = 0; inf < 4; inf++) {
                            weight = matricesWeightsData[matWeightIdx + inf];
                            if (weight > 0) {
                                Matrix.FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesData[matWeightIdx + inf] * 16), weight, tempMatrix);
                                finalMatrix.addToSelf(tempMatrix);
                            }
                        }
                        if (needExtras) {
                            for (inf = 0; inf < 4; inf++) {
                                weight = matricesWeightsExtraData[matWeightIdx + inf];
                                if (weight > 0) {
                                    Matrix.FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesExtraData[matWeightIdx + inf] * 16), weight, tempMatrix);
                                    finalMatrix.addToSelf(tempMatrix);
                                }
                            }
                        }
                        if (kind === VertexBuffer.NormalKind) {
                            Vector3.TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], finalMatrix, tempVector);
                        }
                        else {
                            Vector3.TransformCoordinatesFromFloatsToRef(data[index], data[index + 1], data[index + 2], finalMatrix, tempVector);
                        }
                        tempVector.toArray(data, index);
                        if (kind === VertexBuffer.PositionKind && this._positions) {
                            this._positions[index / 3].copyFrom(tempVector);
                        }
                    }
                }
            }
            return data;
        }
        /**
         * Get the normals vertex data and optionally apply skeleton and morphing.
         * @param applySkeleton defines whether to apply the skeleton
         * @param applyMorph  defines whether to apply the morph target
         * @returns the normals data
         */
        getNormalsData(applySkeleton = false, applyMorph = false) {
            return this._getData(applySkeleton, applyMorph, null, VertexBuffer.NormalKind);
        }
        /**
         * Get the position vertex data and optionally apply skeleton and morphing.
         * @param applySkeleton defines whether to apply the skeleton
         * @param applyMorph  defines whether to apply the morph target
         * @param data defines the position data to apply the skeleton and morph to
         * @returns the position data
         */
        getPositionData(applySkeleton = false, applyMorph = false, data) {
            return this._getData(applySkeleton, applyMorph, data, VertexBuffer.PositionKind);
        }
        /**
         * @internal
         */
        _getPositionData(applySkeleton, applyMorph) {
            var _a;
            let data = this.getVerticesData(VertexBuffer.PositionKind);
            if (this._internalAbstractMeshDataInfo._positions) {
                this._internalAbstractMeshDataInfo._positions = null;
            }
            if (data && ((applySkeleton && this.skeleton) || (applyMorph && this.morphTargetManager))) {
                data = data.slice();
                this._generatePointsArray();
                if (this._positions) {
                    const pos = this._positions;
                    this._internalAbstractMeshDataInfo._positions = new Array(pos.length);
                    for (let i = 0; i < pos.length; i++) {
                        this._internalAbstractMeshDataInfo._positions[i] = ((_a = pos[i]) === null || _a === void 0 ? void 0 : _a.clone()) || new Vector3();
                    }
                }
                return this.getPositionData(applySkeleton, applyMorph, data);
            }
            return data;
        }
        /** @internal */
        _updateBoundingInfo() {
            if (this._boundingInfo) {
                this._boundingInfo.update(this.worldMatrixFromCache);
            }
            else {
                this._boundingInfo = new BoundingInfo(Vector3.Zero(), Vector3.Zero(), this.worldMatrixFromCache);
            }
            this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
            return this;
        }
        /**
         * @internal
         */
        _updateSubMeshesBoundingInfo(matrix) {
            if (!this.subMeshes) {
                return this;
            }
            const count = this.subMeshes.length;
            for (let subIndex = 0; subIndex < count; subIndex++) {
                const subMesh = this.subMeshes[subIndex];
                if (count > 1 || !subMesh.IsGlobal) {
                    subMesh.updateBoundingInfo(matrix);
                }
            }
            return this;
        }
        /** @internal */
        _afterComputeWorldMatrix() {
            if (this.doNotSyncBoundingInfo) {
                return;
            }
            // Bounding info
            this._boundingInfoIsDirty = true;
        }
        /**
         * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
         * A mesh is in the frustum if its bounding box intersects the frustum
         * @param frustumPlanes defines the frustum to test
         * @returns true if the mesh is in the frustum planes
         */
        isInFrustum(frustumPlanes) {
            return this.getBoundingInfo().isInFrustum(frustumPlanes, this.cullingStrategy);
        }
        /**
         * Returns `true` if the mesh is completely in the frustum defined be the passed array of planes.
         * A mesh is completely in the frustum if its bounding box it completely inside the frustum.
         * @param frustumPlanes defines the frustum to test
         * @returns true if the mesh is completely in the frustum planes
         */
        isCompletelyInFrustum(frustumPlanes) {
            return this.getBoundingInfo().isCompletelyInFrustum(frustumPlanes);
        }
        /**
         * True if the mesh intersects another mesh or a SolidParticle object
         * @param mesh defines a target mesh or SolidParticle to test
         * @param precise Unless the parameter `precise` is set to `true` the intersection is computed according to Axis Aligned Bounding Boxes (AABB), else according to OBB (Oriented BBoxes)
         * @param includeDescendants Can be set to true to test if the mesh defined in parameters intersects with the current mesh or any child meshes
         * @returns true if there is an intersection
         */
        intersectsMesh(mesh, precise = false, includeDescendants) {
            const boundingInfo = this.getBoundingInfo();
            const otherBoundingInfo = mesh.getBoundingInfo();
            if (boundingInfo.intersects(otherBoundingInfo, precise)) {
                return true;
            }
            if (includeDescendants) {
                for (const child of this.getChildMeshes()) {
                    if (child.intersectsMesh(mesh, precise, true)) {
                        return true;
                    }
                }
            }
            return false;
        }
        /**
         * Returns true if the passed point (Vector3) is inside the mesh bounding box
         * @param point defines the point to test
         * @returns true if there is an intersection
         */
        intersectsPoint(point) {
            return this.getBoundingInfo().intersectsPoint(point);
        }
        // Collisions
        /**
         * Gets or sets a boolean indicating that this mesh can be used in the collision engine
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */
        get checkCollisions() {
            return this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions;
        }
        set checkCollisions(collisionEnabled) {
            this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions = collisionEnabled;
        }
        /**
         * Gets Collider object used to compute collisions (not physics)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */
        get collider() {
            return this._internalAbstractMeshDataInfo._meshCollisionData._collider;
        }
        /**
         * Move the mesh using collision engine
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         * @param displacement defines the requested displacement vector
         * @returns the current mesh
         */
        moveWithCollisions(displacement) {
            const globalPosition = this.getAbsolutePosition();
            globalPosition.addToRef(this.ellipsoidOffset, this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions);
            const coordinator = this.getScene().collisionCoordinator;
            if (!this._internalAbstractMeshDataInfo._meshCollisionData._collider) {
                this._internalAbstractMeshDataInfo._meshCollisionData._collider = coordinator.createCollider();
            }
            this._internalAbstractMeshDataInfo._meshCollisionData._collider._radius = this.ellipsoid;
            coordinator.getNewPosition(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, displacement, this._internalAbstractMeshDataInfo._meshCollisionData._collider, this.collisionRetryCount, this, this._onCollisionPositionChange, this.uniqueId);
            return this;
        }
        // Collisions
        /**
         * @internal
         */
        _collideForSubMesh(subMesh, transformMatrix, collider) {
            var _a;
            this._generatePointsArray();
            if (!this._positions) {
                return this;
            }
            // Transformation
            if (!subMesh._lastColliderWorldVertices || !subMesh._lastColliderTransformMatrix.equals(transformMatrix)) {
                subMesh._lastColliderTransformMatrix = transformMatrix.clone();
                subMesh._lastColliderWorldVertices = [];
                subMesh._trianglePlanes = [];
                const start = subMesh.verticesStart;
                const end = subMesh.verticesStart + subMesh.verticesCount;
                for (let i = start; i < end; i++) {
                    subMesh._lastColliderWorldVertices.push(Vector3.TransformCoordinates(this._positions[i], transformMatrix));
                }
            }
            // Collide
            collider._collide(subMesh._trianglePlanes, subMesh._lastColliderWorldVertices, this.getIndices(), subMesh.indexStart, subMesh.indexStart + subMesh.indexCount, subMesh.verticesStart, !!subMesh.getMaterial(), this, this._shouldConvertRHS(), ((_a = subMesh.getMaterial()) === null || _a === void 0 ? void 0 : _a.fillMode) === 7);
            return this;
        }
        /**
         * @internal
         */
        _processCollisionsForSubMeshes(collider, transformMatrix) {
            const subMeshes = this._scene.getCollidingSubMeshCandidates(this, collider);
            const len = subMeshes.length;
            for (let index = 0; index < len; index++) {
                const subMesh = subMeshes.data[index];
                // Bounding test
                if (len > 1 && !subMesh._checkCollision(collider)) {
                    continue;
                }
                this._collideForSubMesh(subMesh, transformMatrix, collider);
            }
            return this;
        }
        /** @internal */
        _shouldConvertRHS() {
            return false;
        }
        /**
         * @internal
         */
        _checkCollision(collider) {
            // Bounding box test
            if (!this.getBoundingInfo()._checkCollision(collider)) {
                return this;
            }
            // Transformation matrix
            const collisionsScalingMatrix = TmpVectors.Matrix[0];
            const collisionsTransformMatrix = TmpVectors.Matrix[1];
            Matrix.ScalingToRef(1.0 / collider._radius.x, 1.0 / collider._radius.y, 1.0 / collider._radius.z, collisionsScalingMatrix);
            this.worldMatrixFromCache.multiplyToRef(collisionsScalingMatrix, collisionsTransformMatrix);
            this._processCollisionsForSubMeshes(collider, collisionsTransformMatrix);
            return this;
        }
        // Picking
        /** @internal */
        _generatePointsArray() {
            return false;
        }
        /**
         * Checks if the passed Ray intersects with the mesh. A mesh triangle can be picked both from its front and back sides,
         * irrespective of orientation.
         * @param ray defines the ray to use. It should be in the mesh's LOCAL coordinate space.
         * @param fastCheck defines if fast mode (but less precise) must be used (false by default)
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
         * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
         * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
         * @returns the picking info
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
         */
        intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
            const pickingInfo = new PickingInfo();
            const className = this.getClassName();
            const intersectionThreshold = className === "InstancedLinesMesh" || className === "LinesMesh" || className === "GreasedLineMesh" ? this.intersectionThreshold : 0;
            const boundingInfo = this.getBoundingInfo();
            if (!this.subMeshes) {
                return pickingInfo;
            }
            if (!skipBoundingInfo &&
                (!ray.intersectsSphere(boundingInfo.boundingSphere, intersectionThreshold) || !ray.intersectsBox(boundingInfo.boundingBox, intersectionThreshold))) {
                return pickingInfo;
            }
            if (onlyBoundingInfo) {
                pickingInfo.hit = skipBoundingInfo ? false : true;
                pickingInfo.pickedMesh = skipBoundingInfo ? null : this;
                pickingInfo.distance = skipBoundingInfo ? 0 : Vector3.Distance(ray.origin, boundingInfo.boundingSphere.center);
                pickingInfo.subMeshId = 0;
                return pickingInfo;
            }
            if (!this._generatePointsArray()) {
                return pickingInfo;
            }
            let intersectInfo = null;
            const subMeshes = this._scene.getIntersectingSubMeshCandidates(this, ray);
            const len = subMeshes.length;
            // Check if all submeshes are using a material that don't allow picking (point/lines rendering)
            // if no submesh can be picked that way, then fallback to BBox picking
            let anySubmeshSupportIntersect = false;
            for (let index = 0; index < len; index++) {
                const subMesh = subMeshes.data[index];
                const material = subMesh.getMaterial();
                if (!material) {
                    continue;
                }
                if (material.fillMode == 7 ||
                    material.fillMode == 0 ||
                    material.fillMode == 1 ||
                    material.fillMode == 2 ||
                    material.fillMode == 4) {
                    anySubmeshSupportIntersect = true;
                    break;
                }
            }
            // no sub mesh support intersection, fallback to BBox that has already be done
            if (!anySubmeshSupportIntersect) {
                pickingInfo.hit = true;
                pickingInfo.pickedMesh = this;
                pickingInfo.distance = Vector3.Distance(ray.origin, boundingInfo.boundingSphere.center);
                pickingInfo.subMeshId = -1;
                return pickingInfo;
            }
            // at least 1 submesh supports intersection, keep going
            for (let index = 0; index < len; index++) {
                const subMesh = subMeshes.data[index];
                // Bounding test
                if (len > 1 && !subMesh.canIntersects(ray)) {
                    continue;
                }
                const currentIntersectInfo = subMesh.intersects(ray, this._positions, this.getIndices(), fastCheck, trianglePredicate);
                if (currentIntersectInfo) {
                    if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                        intersectInfo = currentIntersectInfo;
                        intersectInfo.subMeshId = index;
                        if (fastCheck) {
                            break;
                        }
                    }
                }
            }
            if (intersectInfo) {
                // Get picked point
                const world = worldToUse !== null && worldToUse !== void 0 ? worldToUse : this.getWorldMatrix();
                const worldOrigin = TmpVectors.Vector3[0];
                const direction = TmpVectors.Vector3[1];
                Vector3.TransformCoordinatesToRef(ray.origin, world, worldOrigin);
                ray.direction.scaleToRef(intersectInfo.distance, direction);
                const worldDirection = Vector3.TransformNormal(direction, world);
                const pickedPoint = worldDirection.addInPlace(worldOrigin);
                // Return result
                pickingInfo.hit = true;
                pickingInfo.distance = Vector3.Distance(worldOrigin, pickedPoint);
                pickingInfo.pickedPoint = pickedPoint;
                pickingInfo.pickedMesh = this;
                pickingInfo.bu = intersectInfo.bu || 0;
                pickingInfo.bv = intersectInfo.bv || 0;
                pickingInfo.subMeshFaceId = intersectInfo.faceId;
                pickingInfo.faceId = intersectInfo.faceId + subMeshes.data[intersectInfo.subMeshId].indexStart / (this.getClassName().indexOf("LinesMesh") !== -1 ? 2 : 3);
                pickingInfo.subMeshId = intersectInfo.subMeshId;
                return pickingInfo;
            }
            return pickingInfo;
        }
        /**
         * Clones the current mesh
         * @param name defines the mesh name
         * @param newParent defines the new mesh parent
         * @param doNotCloneChildren defines a boolean indicating that children must not be cloned (false by default)
         * @returns the new mesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clone(name, newParent, doNotCloneChildren) {
            return null;
        }
        /**
         * Disposes all the submeshes of the current meshnp
         * @returns the current mesh
         */
        releaseSubMeshes() {
            if (this.subMeshes) {
                while (this.subMeshes.length) {
                    this.subMeshes[0].dispose();
                }
            }
            else {
                this.subMeshes = new Array();
            }
            return this;
        }
        /**
         * Releases resources associated with this abstract mesh.
         * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
         * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            let index;
            // mesh map release.
            if (this._scene.useMaterialMeshMap) {
                // remove from material mesh map id needed
                if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) {
                    this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = undefined;
                }
            }
            // Smart Array Retainers.
            this.getScene().freeActiveMeshes();
            this.getScene().freeRenderingGroups();
            // Action manager
            if (this.actionManager !== undefined && this.actionManager !== null) {
                this.actionManager.dispose();
                this.actionManager = null;
            }
            // Skeleton
            this._internalAbstractMeshDataInfo._skeleton = null;
            if (this._transformMatrixTexture) {
                this._transformMatrixTexture.dispose();
                this._transformMatrixTexture = null;
            }
            // Intersections in progress
            for (index = 0; index < this._intersectionsInProgress.length; index++) {
                const other = this._intersectionsInProgress[index];
                const pos = other._intersectionsInProgress.indexOf(this);
                other._intersectionsInProgress.splice(pos, 1);
            }
            this._intersectionsInProgress.length = 0;
            // Lights
            const lights = this.getScene().lights;
            lights.forEach((light) => {
                let meshIndex = light.includedOnlyMeshes.indexOf(this);
                if (meshIndex !== -1) {
                    light.includedOnlyMeshes.splice(meshIndex, 1);
                }
                meshIndex = light.excludedMeshes.indexOf(this);
                if (meshIndex !== -1) {
                    light.excludedMeshes.splice(meshIndex, 1);
                }
                // Shadow generators
                const generators = light.getShadowGenerators();
                if (generators) {
                    const iterator = generators.values();
                    for (let key = iterator.next(); key.done !== true; key = iterator.next()) {
                        const generator = key.value;
                        const shadowMap = generator.getShadowMap();
                        if (shadowMap && shadowMap.renderList) {
                            meshIndex = shadowMap.renderList.indexOf(this);
                            if (meshIndex !== -1) {
                                shadowMap.renderList.splice(meshIndex, 1);
                            }
                        }
                    }
                }
            });
            // SubMeshes
            if (this.getClassName() !== "InstancedMesh" || this.getClassName() !== "InstancedLinesMesh") {
                this.releaseSubMeshes();
            }
            // Query
            const engine = this.getScene().getEngine();
            if (this._occlusionQuery !== null) {
                this.isOcclusionQueryInProgress = false;
                engine.deleteQuery(this._occlusionQuery);
                this._occlusionQuery = null;
            }
            // Engine
            engine.wipeCaches();
            // Remove from scene
            this.getScene().removeMesh(this);
            if (this._parentContainer) {
                const index = this._parentContainer.meshes.indexOf(this);
                if (index > -1) {
                    this._parentContainer.meshes.splice(index, 1);
                }
                this._parentContainer = null;
            }
            if (disposeMaterialAndTextures) {
                if (this.material) {
                    if (this.material.getClassName() === "MultiMaterial") {
                        this.material.dispose(false, true, true);
                    }
                    else {
                        this.material.dispose(false, true);
                    }
                }
            }
            if (!doNotRecurse) {
                // Particles
                for (index = 0; index < this.getScene().particleSystems.length; index++) {
                    if (this.getScene().particleSystems[index].emitter === this) {
                        this.getScene().particleSystems[index].dispose();
                        index--;
                    }
                }
            }
            // facet data
            if (this._internalAbstractMeshDataInfo._facetData.facetDataEnabled) {
                this.disableFacetData();
            }
            this._uniformBuffer.dispose();
            this.onAfterWorldMatrixUpdateObservable.clear();
            this.onCollideObservable.clear();
            this.onCollisionPositionChangeObservable.clear();
            this.onRebuildObservable.clear();
            super.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        /**
         * Adds the passed mesh as a child to the current mesh
         * @param mesh defines the child mesh
         * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
         * @returns the current mesh
         */
        addChild(mesh, preserveScalingSign = false) {
            mesh.setParent(this, preserveScalingSign);
            return this;
        }
        /**
         * Removes the passed mesh from the current mesh children list
         * @param mesh defines the child mesh
         * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
         * @returns the current mesh
         */
        removeChild(mesh, preserveScalingSign = false) {
            mesh.setParent(null, preserveScalingSign);
            return this;
        }
        // Facet data
        /** @internal */
        _initFacetData() {
            const data = this._internalAbstractMeshDataInfo._facetData;
            if (!data.facetNormals) {
                data.facetNormals = new Array();
            }
            if (!data.facetPositions) {
                data.facetPositions = new Array();
            }
            if (!data.facetPartitioning) {
                data.facetPartitioning = new Array();
            }
            data.facetNb = (this.getIndices().length / 3) | 0;
            data.partitioningSubdivisions = data.partitioningSubdivisions ? data.partitioningSubdivisions : 10; // default nb of partitioning subdivisions = 10
            data.partitioningBBoxRatio = data.partitioningBBoxRatio ? data.partitioningBBoxRatio : 1.01; // default ratio 1.01 = the partitioning is 1% bigger than the bounding box
            for (let f = 0; f < data.facetNb; f++) {
                data.facetNormals[f] = Vector3.Zero();
                data.facetPositions[f] = Vector3.Zero();
            }
            data.facetDataEnabled = true;
            return this;
        }
        /**
         * Updates the mesh facetData arrays and the internal partitioning when the mesh is morphed or updated.
         * This method can be called within the render loop.
         * You don't need to call this method by yourself in the render loop when you update/morph a mesh with the methods CreateXXX() as they automatically manage this computation
         * @returns the current mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        updateFacetData() {
            const data = this._internalAbstractMeshDataInfo._facetData;
            if (!data.facetDataEnabled) {
                this._initFacetData();
            }
            const positions = this.getVerticesData(VertexBuffer.PositionKind);
            const indices = this.getIndices();
            const normals = this.getVerticesData(VertexBuffer.NormalKind);
            const bInfo = this.getBoundingInfo();
            if (data.facetDepthSort && !data.facetDepthSortEnabled) {
                // init arrays, matrix and sort function on first call
                data.facetDepthSortEnabled = true;
                if (indices instanceof Uint16Array) {
                    data.depthSortedIndices = new Uint16Array(indices);
                }
                else if (indices instanceof Uint32Array) {
                    data.depthSortedIndices = new Uint32Array(indices);
                }
                else {
                    let needs32bits = false;
                    for (let i = 0; i < indices.length; i++) {
                        if (indices[i] > 65535) {
                            needs32bits = true;
                            break;
                        }
                    }
                    if (needs32bits) {
                        data.depthSortedIndices = new Uint32Array(indices);
                    }
                    else {
                        data.depthSortedIndices = new Uint16Array(indices);
                    }
                }
                data.facetDepthSortFunction = function (f1, f2) {
                    return f2.sqDistance - f1.sqDistance;
                };
                if (!data.facetDepthSortFrom) {
                    const camera = this.getScene().activeCamera;
                    data.facetDepthSortFrom = camera ? camera.position : Vector3.Zero();
                }
                data.depthSortedFacets = [];
                for (let f = 0; f < data.facetNb; f++) {
                    const depthSortedFacet = { ind: f * 3, sqDistance: 0.0 };
                    data.depthSortedFacets.push(depthSortedFacet);
                }
                data.invertedMatrix = Matrix.Identity();
                data.facetDepthSortOrigin = Vector3.Zero();
            }
            data.bbSize.x = bInfo.maximum.x - bInfo.minimum.x > Epsilon ? bInfo.maximum.x - bInfo.minimum.x : Epsilon;
            data.bbSize.y = bInfo.maximum.y - bInfo.minimum.y > Epsilon ? bInfo.maximum.y - bInfo.minimum.y : Epsilon;
            data.bbSize.z = bInfo.maximum.z - bInfo.minimum.z > Epsilon ? bInfo.maximum.z - bInfo.minimum.z : Epsilon;
            let bbSizeMax = data.bbSize.x > data.bbSize.y ? data.bbSize.x : data.bbSize.y;
            bbSizeMax = bbSizeMax > data.bbSize.z ? bbSizeMax : data.bbSize.z;
            data.subDiv.max = data.partitioningSubdivisions;
            data.subDiv.X = Math.floor((data.subDiv.max * data.bbSize.x) / bbSizeMax); // adjust the number of subdivisions per axis
            data.subDiv.Y = Math.floor((data.subDiv.max * data.bbSize.y) / bbSizeMax); // according to each bbox size per axis
            data.subDiv.Z = Math.floor((data.subDiv.max * data.bbSize.z) / bbSizeMax);
            data.subDiv.X = data.subDiv.X < 1 ? 1 : data.subDiv.X; // at least one subdivision
            data.subDiv.Y = data.subDiv.Y < 1 ? 1 : data.subDiv.Y;
            data.subDiv.Z = data.subDiv.Z < 1 ? 1 : data.subDiv.Z;
            // set the parameters for ComputeNormals()
            data.facetParameters.facetNormals = this.getFacetLocalNormals();
            data.facetParameters.facetPositions = this.getFacetLocalPositions();
            data.facetParameters.facetPartitioning = this.getFacetLocalPartitioning();
            data.facetParameters.bInfo = bInfo;
            data.facetParameters.bbSize = data.bbSize;
            data.facetParameters.subDiv = data.subDiv;
            data.facetParameters.ratio = this.partitioningBBoxRatio;
            data.facetParameters.depthSort = data.facetDepthSort;
            if (data.facetDepthSort && data.facetDepthSortEnabled) {
                this.computeWorldMatrix(true);
                this._worldMatrix.invertToRef(data.invertedMatrix);
                Vector3.TransformCoordinatesToRef(data.facetDepthSortFrom, data.invertedMatrix, data.facetDepthSortOrigin);
                data.facetParameters.distanceTo = data.facetDepthSortOrigin;
            }
            data.facetParameters.depthSortedFacets = data.depthSortedFacets;
            if (normals) {
                VertexData.ComputeNormals(positions, indices, normals, data.facetParameters);
            }
            if (data.facetDepthSort && data.facetDepthSortEnabled) {
                data.depthSortedFacets.sort(data.facetDepthSortFunction);
                const l = (data.depthSortedIndices.length / 3) | 0;
                for (let f = 0; f < l; f++) {
                    const sind = data.depthSortedFacets[f].ind;
                    data.depthSortedIndices[f * 3] = indices[sind];
                    data.depthSortedIndices[f * 3 + 1] = indices[sind + 1];
                    data.depthSortedIndices[f * 3 + 2] = indices[sind + 2];
                }
                this.updateIndices(data.depthSortedIndices, undefined, true);
            }
            return this;
        }
        /**
         * Returns the facetLocalNormals array.
         * The normals are expressed in the mesh local spac
         * @returns an array of Vector3
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetLocalNormals() {
            const facetData = this._internalAbstractMeshDataInfo._facetData;
            if (!facetData.facetNormals) {
                this.updateFacetData();
            }
            return facetData.facetNormals;
        }
        /**
         * Returns the facetLocalPositions array.
         * The facet positions are expressed in the mesh local space
         * @returns an array of Vector3
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetLocalPositions() {
            const facetData = this._internalAbstractMeshDataInfo._facetData;
            if (!facetData.facetPositions) {
                this.updateFacetData();
            }
            return facetData.facetPositions;
        }
        /**
         * Returns the facetLocalPartitioning array
         * @returns an array of array of numbers
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetLocalPartitioning() {
            const facetData = this._internalAbstractMeshDataInfo._facetData;
            if (!facetData.facetPartitioning) {
                this.updateFacetData();
            }
            return facetData.facetPartitioning;
        }
        /**
         * Returns the i-th facet position in the world system.
         * This method allocates a new Vector3 per call
         * @param i defines the facet index
         * @returns a new Vector3
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetPosition(i) {
            const pos = Vector3.Zero();
            this.getFacetPositionToRef(i, pos);
            return pos;
        }
        /**
         * Sets the reference Vector3 with the i-th facet position in the world system
         * @param i defines the facet index
         * @param ref defines the target vector
         * @returns the current mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetPositionToRef(i, ref) {
            const localPos = this.getFacetLocalPositions()[i];
            const world = this.getWorldMatrix();
            Vector3.TransformCoordinatesToRef(localPos, world, ref);
            return this;
        }
        /**
         * Returns the i-th facet normal in the world system.
         * This method allocates a new Vector3 per call
         * @param i defines the facet index
         * @returns a new Vector3
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetNormal(i) {
            const norm = Vector3.Zero();
            this.getFacetNormalToRef(i, norm);
            return norm;
        }
        /**
         * Sets the reference Vector3 with the i-th facet normal in the world system
         * @param i defines the facet index
         * @param ref defines the target vector
         * @returns the current mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetNormalToRef(i, ref) {
            const localNorm = this.getFacetLocalNormals()[i];
            Vector3.TransformNormalToRef(localNorm, this.getWorldMatrix(), ref);
            return this;
        }
        /**
         * Returns the facets (in an array) in the same partitioning block than the one the passed coordinates are located (expressed in the mesh local system)
         * @param x defines x coordinate
         * @param y defines y coordinate
         * @param z defines z coordinate
         * @returns the array of facet indexes
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetsAtLocalCoordinates(x, y, z) {
            const bInfo = this.getBoundingInfo();
            const data = this._internalAbstractMeshDataInfo._facetData;
            const ox = Math.floor(((x - bInfo.minimum.x * data.partitioningBBoxRatio) * data.subDiv.X * data.partitioningBBoxRatio) / data.bbSize.x);
            const oy = Math.floor(((y - bInfo.minimum.y * data.partitioningBBoxRatio) * data.subDiv.Y * data.partitioningBBoxRatio) / data.bbSize.y);
            const oz = Math.floor(((z - bInfo.minimum.z * data.partitioningBBoxRatio) * data.subDiv.Z * data.partitioningBBoxRatio) / data.bbSize.z);
            if (ox < 0 || ox > data.subDiv.max || oy < 0 || oy > data.subDiv.max || oz < 0 || oz > data.subDiv.max) {
                return null;
            }
            return data.facetPartitioning[ox + data.subDiv.max * oy + data.subDiv.max * data.subDiv.max * oz];
        }
        /**
         * Returns the closest mesh facet index at (x,y,z) World coordinates, null if not found
         * @param x defines x coordinate
         * @param y defines y coordinate
         * @param z defines z coordinate
         * @param projected sets as the (x,y,z) world projection on the facet
         * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
         * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
         * @returns the face index if found (or null instead)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getClosestFacetAtCoordinates(x, y, z, projected, checkFace = false, facing = true) {
            const world = this.getWorldMatrix();
            const invMat = TmpVectors.Matrix[5];
            world.invertToRef(invMat);
            const invVect = TmpVectors.Vector3[8];
            Vector3.TransformCoordinatesFromFloatsToRef(x, y, z, invMat, invVect); // transform (x,y,z) to coordinates in the mesh local space
            const closest = this.getClosestFacetAtLocalCoordinates(invVect.x, invVect.y, invVect.z, projected, checkFace, facing);
            if (projected) {
                // transform the local computed projected vector to world coordinates
                Vector3.TransformCoordinatesFromFloatsToRef(projected.x, projected.y, projected.z, world, projected);
            }
            return closest;
        }
        /**
         * Returns the closest mesh facet index at (x,y,z) local coordinates, null if not found
         * @param x defines x coordinate
         * @param y defines y coordinate
         * @param z defines z coordinate
         * @param projected sets as the (x,y,z) local projection on the facet
         * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
         * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
         * @returns the face index if found (or null instead)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getClosestFacetAtLocalCoordinates(x, y, z, projected, checkFace = false, facing = true) {
            let closest = null;
            let tmpx = 0.0;
            let tmpy = 0.0;
            let tmpz = 0.0;
            let d = 0.0; // tmp dot facet normal * facet position
            let t0 = 0.0;
            let projx = 0.0;
            let projy = 0.0;
            let projz = 0.0;
            // Get all the facets in the same partitioning block than (x, y, z)
            const facetPositions = this.getFacetLocalPositions();
            const facetNormals = this.getFacetLocalNormals();
            const facetsInBlock = this.getFacetsAtLocalCoordinates(x, y, z);
            if (!facetsInBlock) {
                return null;
            }
            // Get the closest facet to (x, y, z)
            let shortest = Number.MAX_VALUE; // init distance vars
            let tmpDistance = shortest;
            let fib; // current facet in the block
            let norm; // current facet normal
            let p0; // current facet barycenter position
            // loop on all the facets in the current partitioning block
            for (let idx = 0; idx < facetsInBlock.length; idx++) {
                fib = facetsInBlock[idx];
                norm = facetNormals[fib];
                p0 = facetPositions[fib];
                d = (x - p0.x) * norm.x + (y - p0.y) * norm.y + (z - p0.z) * norm.z;
                if (!checkFace || (checkFace && facing && d >= 0.0) || (checkFace && !facing && d <= 0.0)) {
                    // compute (x,y,z) projection on the facet = (projx, projy, projz)
                    d = norm.x * p0.x + norm.y * p0.y + norm.z * p0.z;
                    t0 = -(norm.x * x + norm.y * y + norm.z * z - d) / (norm.x * norm.x + norm.y * norm.y + norm.z * norm.z);
                    projx = x + norm.x * t0;
                    projy = y + norm.y * t0;
                    projz = z + norm.z * t0;
                    tmpx = projx - x;
                    tmpy = projy - y;
                    tmpz = projz - z;
                    tmpDistance = tmpx * tmpx + tmpy * tmpy + tmpz * tmpz; // compute length between (x, y, z) and its projection on the facet
                    if (tmpDistance < shortest) {
                        // just keep the closest facet to (x, y, z)
                        shortest = tmpDistance;
                        closest = fib;
                        if (projected) {
                            projected.x = projx;
                            projected.y = projy;
                            projected.z = projz;
                        }
                    }
                }
            }
            return closest;
        }
        /**
         * Returns the object "parameter" set with all the expected parameters for facetData computation by ComputeNormals()
         * @returns the parameters
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        getFacetDataParameters() {
            return this._internalAbstractMeshDataInfo._facetData.facetParameters;
        }
        /**
         * Disables the feature FacetData and frees the related memory
         * @returns the current mesh
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
         */
        disableFacetData() {
            const facetData = this._internalAbstractMeshDataInfo._facetData;
            if (facetData.facetDataEnabled) {
                facetData.facetDataEnabled = false;
                facetData.facetPositions = new Array();
                facetData.facetNormals = new Array();
                facetData.facetPartitioning = new Array();
                facetData.facetParameters = null;
                facetData.depthSortedIndices = new Uint32Array(0);
            }
            return this;
        }
        /**
         * Updates the AbstractMesh indices array
         * @param indices defines the data source
         * @param offset defines the offset in the index buffer where to store the new data (can be null)
         * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
         * @returns the current mesh
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateIndices(indices, offset, gpuMemoryOnly = false) {
            return this;
        }
        /**
         * Creates new normals data for the mesh
         * @param updatable defines if the normal vertex buffer must be flagged as updatable
         * @returns the current mesh
         */
        createNormals(updatable) {
            const positions = this.getVerticesData(VertexBuffer.PositionKind);
            const indices = this.getIndices();
            let normals;
            if (this.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                normals = this.getVerticesData(VertexBuffer.NormalKind);
            }
            else {
                normals = [];
            }
            VertexData.ComputeNormals(positions, indices, normals, { useRightHandedSystem: this.getScene().useRightHandedSystem });
            this.setVerticesData(VertexBuffer.NormalKind, normals, updatable);
            return this;
        }
        /**
         * Align the mesh with a normal
         * @param normal defines the normal to use
         * @param upDirection can be used to redefined the up vector to use (will use the (0, 1, 0) by default)
         * @returns the current mesh
         */
        alignWithNormal(normal, upDirection) {
            if (!upDirection) {
                upDirection = Axis.Y;
            }
            const axisX = TmpVectors.Vector3[0];
            const axisZ = TmpVectors.Vector3[1];
            Vector3.CrossToRef(upDirection, normal, axisZ);
            Vector3.CrossToRef(normal, axisZ, axisX);
            if (this.rotationQuaternion) {
                Quaternion.RotationQuaternionFromAxisToRef(axisX, normal, axisZ, this.rotationQuaternion);
            }
            else {
                Vector3.RotationFromAxisToRef(axisX, normal, axisZ, this.rotation);
            }
            return this;
        }
        /** @internal */
        _checkOcclusionQuery() {
            // Will be replaced by correct code if Occlusion queries are referenced
            return false;
        }
        /**
         * Disables the mesh edge rendering mode
         * @returns the currentAbstractMesh
         */
        disableEdgesRendering() {
            throw _WarnImport("EdgesRenderer");
        }
        /**
         * Enables the edge rendering mode on the mesh.
         * This mode makes the mesh edges visible
         * @param epsilon defines the maximal distance between two angles to detect a face
         * @param checkVerticesInsteadOfIndices indicates that we should check vertex list directly instead of faces
         * @param options options to the edge renderer
         * @returns the currentAbstractMesh
         * @see https://www.babylonjs-playground.com/#19O9TU#0
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        enableEdgesRendering(epsilon, checkVerticesInsteadOfIndices, options) {
            throw _WarnImport("EdgesRenderer");
        }
        /**
         * This function returns all of the particle systems in the scene that use the mesh as an emitter.
         * @returns an array of particle systems in the scene that use the mesh as an emitter
         */
        getConnectedParticleSystems() {
            return this._scene.particleSystems.filter((particleSystem) => particleSystem.emitter === this);
        }
    }
    /** No occlusion */
    AbstractMesh.OCCLUSION_TYPE_NONE = 0;
    /** Occlusion set to optimistic */
    AbstractMesh.OCCLUSION_TYPE_OPTIMISTIC = 1;
    /** Occlusion set to strict */
    AbstractMesh.OCCLUSION_TYPE_STRICT = 2;
    /** Use an accurate occlusion algorithm */
    AbstractMesh.OCCLUSION_ALGORITHM_TYPE_ACCURATE = 0;
    /** Use a conservative occlusion algorithm */
    AbstractMesh.OCCLUSION_ALGORITHM_TYPE_CONSERVATIVE = 1;
    /** Default culling strategy : this is an exclusion test and it's the more accurate.
     *  Test order :
     *  Is the bounding sphere outside the frustum ?
     *  If not, are the bounding box vertices outside the frustum ?
     *  It not, then the cullable object is in the frustum.
     */
    AbstractMesh.CULLINGSTRATEGY_STANDARD = 0;
    /** Culling strategy : Bounding Sphere Only.
     *  This is an exclusion test. It's faster than the standard strategy because the bounding box is not tested.
     *  It's also less accurate than the standard because some not visible objects can still be selected.
     *  Test : is the bounding sphere outside the frustum ?
     *  If not, then the cullable object is in the frustum.
     */
    AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
    /** Culling strategy : Optimistic Inclusion.
     *  This in an inclusion test first, then the standard exclusion test.
     *  This can be faster when a cullable object is expected to be almost always in the camera frustum.
     *  This could also be a little slower than the standard test when the tested object center is not the frustum but one of its bounding box vertex is still inside.
     *  Anyway, it's as accurate as the standard strategy.
     *  Test :
     *  Is the cullable object bounding sphere center in the frustum ?
     *  If not, apply the default culling strategy.
     */
    AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
    /** Culling strategy : Optimistic Inclusion then Bounding Sphere Only.
     *  This in an inclusion test first, then the bounding sphere only exclusion test.
     *  This can be the fastest test when a cullable object is expected to be almost always in the camera frustum.
     *  This could also be a little slower than the BoundingSphereOnly strategy when the tested object center is not in the frustum but its bounding sphere still intersects it.
     *  It's less accurate than the standard strategy and as accurate as the BoundingSphereOnly strategy.
     *  Test :
     *  Is the cullable object bounding sphere center in the frustum ?
     *  If not, apply the Bounding Sphere Only strategy. No Bounding Box is tested here.
     */
    AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
    RegisterClass("BABYLON.AbstractMesh", AbstractMesh);

    /** @internal */
    function addClipPlaneUniforms(uniforms) {
        if (uniforms.indexOf("vClipPlane") === -1) {
            uniforms.push("vClipPlane");
        }
        if (uniforms.indexOf("vClipPlane2") === -1) {
            uniforms.push("vClipPlane2");
        }
        if (uniforms.indexOf("vClipPlane3") === -1) {
            uniforms.push("vClipPlane3");
        }
        if (uniforms.indexOf("vClipPlane4") === -1) {
            uniforms.push("vClipPlane4");
        }
        if (uniforms.indexOf("vClipPlane5") === -1) {
            uniforms.push("vClipPlane5");
        }
        if (uniforms.indexOf("vClipPlane6") === -1) {
            uniforms.push("vClipPlane6");
        }
    }
    /** @internal */
    function prepareStringDefinesForClipPlanes(primaryHolder, secondaryHolder, defines) {
        var _a, _b, _c, _d, _e, _f;
        const clipPlane = !!((_a = primaryHolder.clipPlane) !== null && _a !== void 0 ? _a : secondaryHolder.clipPlane);
        const clipPlane2 = !!((_b = primaryHolder.clipPlane2) !== null && _b !== void 0 ? _b : secondaryHolder.clipPlane2);
        const clipPlane3 = !!((_c = primaryHolder.clipPlane3) !== null && _c !== void 0 ? _c : secondaryHolder.clipPlane3);
        const clipPlane4 = !!((_d = primaryHolder.clipPlane4) !== null && _d !== void 0 ? _d : secondaryHolder.clipPlane4);
        const clipPlane5 = !!((_e = primaryHolder.clipPlane5) !== null && _e !== void 0 ? _e : secondaryHolder.clipPlane5);
        const clipPlane6 = !!((_f = primaryHolder.clipPlane6) !== null && _f !== void 0 ? _f : secondaryHolder.clipPlane6);
        if (clipPlane)
            defines.push("#define CLIPPLANE");
        if (clipPlane2)
            defines.push("#define CLIPPLANE2");
        if (clipPlane3)
            defines.push("#define CLIPPLANE3");
        if (clipPlane4)
            defines.push("#define CLIPPLANE4");
        if (clipPlane5)
            defines.push("#define CLIPPLANE5");
        if (clipPlane6)
            defines.push("#define CLIPPLANE6");
    }
    /** @internal */
    function prepareDefinesForClipPlanes(primaryHolder, secondaryHolder, defines) {
        var _a, _b, _c, _d, _e, _f;
        let changed = false;
        const clipPlane = !!((_a = primaryHolder.clipPlane) !== null && _a !== void 0 ? _a : secondaryHolder.clipPlane);
        const clipPlane2 = !!((_b = primaryHolder.clipPlane2) !== null && _b !== void 0 ? _b : secondaryHolder.clipPlane2);
        const clipPlane3 = !!((_c = primaryHolder.clipPlane3) !== null && _c !== void 0 ? _c : secondaryHolder.clipPlane3);
        const clipPlane4 = !!((_d = primaryHolder.clipPlane4) !== null && _d !== void 0 ? _d : secondaryHolder.clipPlane4);
        const clipPlane5 = !!((_e = primaryHolder.clipPlane5) !== null && _e !== void 0 ? _e : secondaryHolder.clipPlane5);
        const clipPlane6 = !!((_f = primaryHolder.clipPlane6) !== null && _f !== void 0 ? _f : secondaryHolder.clipPlane6);
        // Do not factorize this code, it breaks browsers optimizations.
        if (defines["CLIPPLANE"] !== clipPlane) {
            defines["CLIPPLANE"] = clipPlane;
            changed = true;
        }
        if (defines["CLIPPLANE2"] !== clipPlane2) {
            defines["CLIPPLANE2"] = clipPlane2;
            changed = true;
        }
        if (defines["CLIPPLANE3"] !== clipPlane3) {
            defines["CLIPPLANE3"] = clipPlane3;
            changed = true;
        }
        if (defines["CLIPPLANE4"] !== clipPlane4) {
            defines["CLIPPLANE4"] = clipPlane4;
            changed = true;
        }
        if (defines["CLIPPLANE5"] !== clipPlane5) {
            defines["CLIPPLANE5"] = clipPlane5;
            changed = true;
        }
        if (defines["CLIPPLANE6"] !== clipPlane6) {
            defines["CLIPPLANE6"] = clipPlane6;
            changed = true;
        }
        return changed;
    }
    /** @internal */
    function bindClipPlane(effect, primaryHolder, secondaryHolder) {
        var _a, _b, _c, _d, _e, _f;
        let clipPlane = (_a = primaryHolder.clipPlane) !== null && _a !== void 0 ? _a : secondaryHolder.clipPlane;
        setClipPlane(effect, "vClipPlane", clipPlane);
        clipPlane = (_b = primaryHolder.clipPlane2) !== null && _b !== void 0 ? _b : secondaryHolder.clipPlane2;
        setClipPlane(effect, "vClipPlane2", clipPlane);
        clipPlane = (_c = primaryHolder.clipPlane3) !== null && _c !== void 0 ? _c : secondaryHolder.clipPlane3;
        setClipPlane(effect, "vClipPlane3", clipPlane);
        clipPlane = (_d = primaryHolder.clipPlane4) !== null && _d !== void 0 ? _d : secondaryHolder.clipPlane4;
        setClipPlane(effect, "vClipPlane4", clipPlane);
        clipPlane = (_e = primaryHolder.clipPlane5) !== null && _e !== void 0 ? _e : secondaryHolder.clipPlane5;
        setClipPlane(effect, "vClipPlane5", clipPlane);
        clipPlane = (_f = primaryHolder.clipPlane6) !== null && _f !== void 0 ? _f : secondaryHolder.clipPlane6;
        setClipPlane(effect, "vClipPlane6", clipPlane);
    }
    function setClipPlane(effect, uniformName, clipPlane) {
        if (clipPlane) {
            effect.setFloat4(uniformName, clipPlane.normal.x, clipPlane.normal.y, clipPlane.normal.z, clipPlane.d);
        }
    }

    /**
     * "Static Class" containing the most commonly used helper while dealing with material for rendering purpose.
     *
     * It contains the basic tools to help defining defines, binding uniform for the common part of the materials.
     *
     * This works by convention in BabylonJS but is meant to be use only with shader following the in place naming rules and conventions.
     */
    class MaterialHelper {
        /**
         * Binds the scene's uniform buffer to the effect.
         * @param effect defines the effect to bind to the scene uniform buffer
         * @param sceneUbo defines the uniform buffer storing scene data
         */
        static BindSceneUniformBuffer(effect, sceneUbo) {
            sceneUbo.bindToEffect(effect, "Scene");
        }
        /**
         * Helps preparing the defines values about the UVs in used in the effect.
         * UVs are shared as much as we can across channels in the shaders.
         * @param texture The texture we are preparing the UVs for
         * @param defines The defines to update
         * @param key The channel key "diffuse", "specular"... used in the shader
         */
        static PrepareDefinesForMergedUV(texture, defines, key) {
            defines._needUVs = true;
            defines[key] = true;
            if (texture.optimizeUVAllocation && texture.getTextureMatrix().isIdentityAs3x2()) {
                defines[key + "DIRECTUV"] = texture.coordinatesIndex + 1;
                defines["MAINUV" + (texture.coordinatesIndex + 1)] = true;
            }
            else {
                defines[key + "DIRECTUV"] = 0;
            }
        }
        /**
         * Binds a texture matrix value to its corresponding uniform
         * @param texture The texture to bind the matrix for
         * @param uniformBuffer The uniform buffer receiving the data
         * @param key The channel key "diffuse", "specular"... used in the shader
         */
        static BindTextureMatrix(texture, uniformBuffer, key) {
            const matrix = texture.getTextureMatrix();
            uniformBuffer.updateMatrix(key + "Matrix", matrix);
        }
        /**
         * Gets the current status of the fog (should it be enabled?)
         * @param mesh defines the mesh to evaluate for fog support
         * @param scene defines the hosting scene
         * @returns true if fog must be enabled
         */
        static GetFogState(mesh, scene) {
            return scene.fogEnabled && mesh.applyFog && scene.fogMode !== Scene.FOGMODE_NONE;
        }
        /**
         * Helper used to prepare the list of defines associated with misc. values for shader compilation
         * @param mesh defines the current mesh
         * @param scene defines the current scene
         * @param useLogarithmicDepth defines if logarithmic depth has to be turned on
         * @param pointsCloud defines if point cloud rendering has to be turned on
         * @param fogEnabled defines if fog has to be turned on
         * @param alphaTest defines if alpha testing has to be turned on
         * @param defines defines the current list of defines
         * @param applyDecalAfterDetail Defines if the decal is applied after or before the detail
         */
        static PrepareDefinesForMisc(mesh, scene, useLogarithmicDepth, pointsCloud, fogEnabled, alphaTest, defines, applyDecalAfterDetail = false) {
            if (defines._areMiscDirty) {
                defines["LOGARITHMICDEPTH"] = useLogarithmicDepth;
                defines["POINTSIZE"] = pointsCloud;
                defines["FOG"] = fogEnabled && this.GetFogState(mesh, scene);
                defines["NONUNIFORMSCALING"] = mesh.nonUniformScaling;
                defines["ALPHATEST"] = alphaTest;
                defines["DECAL_AFTER_DETAIL"] = applyDecalAfterDetail;
            }
        }
        /**
         * Helper used to prepare the defines relative to the active camera
         * @param scene defines the current scene
         * @param defines specifies the list of active defines
         * @returns true if the defines have been updated, else false
         */
        static PrepareDefinesForCamera(scene, defines) {
            let changed = false;
            if (scene.activeCamera) {
                const wasOrtho = defines["CAMERA_ORTHOGRAPHIC"] ? 1 : 0;
                const wasPersp = defines["CAMERA_PERSPECTIVE"] ? 1 : 0;
                const isOrtho = scene.activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA ? 1 : 0;
                const isPersp = scene.activeCamera.mode === Camera.PERSPECTIVE_CAMERA ? 1 : 0;
                if (wasOrtho ^ isOrtho || wasPersp ^ isPersp) {
                    defines["CAMERA_ORTHOGRAPHIC"] = isOrtho === 1;
                    defines["CAMERA_PERSPECTIVE"] = isPersp === 1;
                    changed = true;
                }
            }
            return changed;
        }
        /**
         * Helper used to prepare the list of defines associated with frame values for shader compilation
         * @param scene defines the current scene
         * @param engine defines the current engine
         * @param material defines the material we are compiling the shader for
         * @param defines specifies the list of active defines
         * @param useInstances defines if instances have to be turned on
         * @param useClipPlane defines if clip plane have to be turned on
         * @param useThinInstances defines if thin instances have to be turned on
         */
        static PrepareDefinesForFrameBoundValues(scene, engine, material, defines, useInstances, useClipPlane = null, useThinInstances = false) {
            let changed = MaterialHelper.PrepareDefinesForCamera(scene, defines);
            if (useClipPlane !== false) {
                changed = prepareDefinesForClipPlanes(material, scene, defines);
            }
            if (defines["DEPTHPREPASS"] !== !engine.getColorWrite()) {
                defines["DEPTHPREPASS"] = !defines["DEPTHPREPASS"];
                changed = true;
            }
            if (defines["INSTANCES"] !== useInstances) {
                defines["INSTANCES"] = useInstances;
                changed = true;
            }
            if (defines["THIN_INSTANCES"] !== useThinInstances) {
                defines["THIN_INSTANCES"] = useThinInstances;
                changed = true;
            }
            if (changed) {
                defines.markAsUnprocessed();
            }
        }
        /**
         * Prepares the defines for bones
         * @param mesh The mesh containing the geometry data we will draw
         * @param defines The defines to update
         */
        static PrepareDefinesForBones(mesh, defines) {
            if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
                defines["NUM_BONE_INFLUENCERS"] = mesh.numBoneInfluencers;
                const materialSupportsBoneTexture = defines["BONETEXTURE"] !== undefined;
                if (mesh.skeleton.isUsingTextureForMatrices && materialSupportsBoneTexture) {
                    defines["BONETEXTURE"] = true;
                }
                else {
                    defines["BonesPerMesh"] = mesh.skeleton.bones.length + 1;
                    defines["BONETEXTURE"] = materialSupportsBoneTexture ? false : undefined;
                    const prePassRenderer = mesh.getScene().prePassRenderer;
                    if (prePassRenderer && prePassRenderer.enabled) {
                        const nonExcluded = prePassRenderer.excludedSkinnedMesh.indexOf(mesh) === -1;
                        defines["BONES_VELOCITY_ENABLED"] = nonExcluded;
                    }
                }
            }
            else {
                defines["NUM_BONE_INFLUENCERS"] = 0;
                defines["BonesPerMesh"] = 0;
                if (defines["BONETEXTURE"] !== undefined) {
                    defines["BONETEXTURE"] = false;
                }
            }
        }
        /**
         * Prepares the defines for morph targets
         * @param mesh The mesh containing the geometry data we will draw
         * @param defines The defines to update
         */
        static PrepareDefinesForMorphTargets(mesh, defines) {
            const manager = mesh.morphTargetManager;
            if (manager) {
                defines["MORPHTARGETS_UV"] = manager.supportsUVs && defines["UV1"];
                defines["MORPHTARGETS_TANGENT"] = manager.supportsTangents && defines["TANGENT"];
                defines["MORPHTARGETS_NORMAL"] = manager.supportsNormals && defines["NORMAL"];
                defines["MORPHTARGETS"] = manager.numInfluencers > 0;
                defines["NUM_MORPH_INFLUENCERS"] = manager.numInfluencers;
                defines["MORPHTARGETS_TEXTURE"] = manager.isUsingTextureForTargets;
            }
            else {
                defines["MORPHTARGETS_UV"] = false;
                defines["MORPHTARGETS_TANGENT"] = false;
                defines["MORPHTARGETS_NORMAL"] = false;
                defines["MORPHTARGETS"] = false;
                defines["NUM_MORPH_INFLUENCERS"] = 0;
            }
        }
        /**
         * Prepares the defines for baked vertex animation
         * @param mesh The mesh containing the geometry data we will draw
         * @param defines The defines to update
         */
        static PrepareDefinesForBakedVertexAnimation(mesh, defines) {
            const manager = mesh.bakedVertexAnimationManager;
            defines["BAKED_VERTEX_ANIMATION_TEXTURE"] = manager && manager.isEnabled ? true : false;
        }
        /**
         * Prepares the defines used in the shader depending on the attributes data available in the mesh
         * @param mesh The mesh containing the geometry data we will draw
         * @param defines The defines to update
         * @param useVertexColor Precise whether vertex colors should be used or not (override mesh info)
         * @param useBones Precise whether bones should be used or not (override mesh info)
         * @param useMorphTargets Precise whether morph targets should be used or not (override mesh info)
         * @param useVertexAlpha Precise whether vertex alpha should be used or not (override mesh info)
         * @param useBakedVertexAnimation Precise whether baked vertex animation should be used or not (override mesh info)
         * @returns false if defines are considered not dirty and have not been checked
         */
        static PrepareDefinesForAttributes(mesh, defines, useVertexColor, useBones, useMorphTargets = false, useVertexAlpha = true, useBakedVertexAnimation = true) {
            if (!defines._areAttributesDirty && defines._needNormals === defines._normals && defines._needUVs === defines._uvs) {
                return false;
            }
            defines._normals = defines._needNormals;
            defines._uvs = defines._needUVs;
            defines["NORMAL"] = defines._needNormals && mesh.isVerticesDataPresent(VertexBuffer.NormalKind);
            if (defines._needNormals && mesh.isVerticesDataPresent(VertexBuffer.TangentKind)) {
                defines["TANGENT"] = true;
            }
            for (let i = 1; i <= 6; ++i) {
                defines["UV" + i] = defines._needUVs ? mesh.isVerticesDataPresent(`uv${i === 1 ? "" : i}`) : false;
            }
            if (useVertexColor) {
                const hasVertexColors = mesh.useVertexColors && mesh.isVerticesDataPresent(VertexBuffer.ColorKind);
                defines["VERTEXCOLOR"] = hasVertexColors;
                defines["VERTEXALPHA"] = mesh.hasVertexAlpha && hasVertexColors && useVertexAlpha;
            }
            if (mesh.isVerticesDataPresent(VertexBuffer.ColorInstanceKind) && (mesh.hasInstances || mesh.hasThinInstances)) {
                defines["INSTANCESCOLOR"] = true;
            }
            if (useBones) {
                this.PrepareDefinesForBones(mesh, defines);
            }
            if (useMorphTargets) {
                this.PrepareDefinesForMorphTargets(mesh, defines);
            }
            if (useBakedVertexAnimation) {
                this.PrepareDefinesForBakedVertexAnimation(mesh, defines);
            }
            return true;
        }
        /**
         * Prepares the defines related to multiview
         * @param scene The scene we are intending to draw
         * @param defines The defines to update
         */
        static PrepareDefinesForMultiview(scene, defines) {
            if (scene.activeCamera) {
                const previousMultiview = defines.MULTIVIEW;
                defines.MULTIVIEW = scene.activeCamera.outputRenderTarget !== null && scene.activeCamera.outputRenderTarget.getViewCount() > 1;
                if (defines.MULTIVIEW != previousMultiview) {
                    defines.markAsUnprocessed();
                }
            }
        }
        /**
         * Prepares the defines related to order independant transparency
         * @param scene The scene we are intending to draw
         * @param defines The defines to update
         * @param needAlphaBlending Determines if the material needs alpha blending
         */
        static PrepareDefinesForOIT(scene, defines, needAlphaBlending) {
            const previousDefine = defines.ORDER_INDEPENDENT_TRANSPARENCY;
            const previousDefine16Bits = defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS;
            defines.ORDER_INDEPENDENT_TRANSPARENCY = scene.useOrderIndependentTransparency && needAlphaBlending;
            defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = !scene.getEngine().getCaps().textureFloatLinearFiltering;
            if (previousDefine !== defines.ORDER_INDEPENDENT_TRANSPARENCY || previousDefine16Bits !== defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS) {
                defines.markAsUnprocessed();
            }
        }
        /**
         * Prepares the defines related to the prepass
         * @param scene The scene we are intending to draw
         * @param defines The defines to update
         * @param canRenderToMRT Indicates if this material renders to several textures in the prepass
         */
        static PrepareDefinesForPrePass(scene, defines, canRenderToMRT) {
            const previousPrePass = defines.PREPASS;
            if (!defines._arePrePassDirty) {
                return;
            }
            const texturesList = [
                {
                    type: 1,
                    define: "PREPASS_POSITION",
                    index: "PREPASS_POSITION_INDEX",
                },
                {
                    type: 2,
                    define: "PREPASS_VELOCITY",
                    index: "PREPASS_VELOCITY_INDEX",
                },
                {
                    type: 3,
                    define: "PREPASS_REFLECTIVITY",
                    index: "PREPASS_REFLECTIVITY_INDEX",
                },
                {
                    type: 0,
                    define: "PREPASS_IRRADIANCE",
                    index: "PREPASS_IRRADIANCE_INDEX",
                },
                {
                    type: 7,
                    define: "PREPASS_ALBEDO_SQRT",
                    index: "PREPASS_ALBEDO_SQRT_INDEX",
                },
                {
                    type: 5,
                    define: "PREPASS_DEPTH",
                    index: "PREPASS_DEPTH_INDEX",
                },
                {
                    type: 6,
                    define: "PREPASS_NORMAL",
                    index: "PREPASS_NORMAL_INDEX",
                },
            ];
            if (scene.prePassRenderer && scene.prePassRenderer.enabled && canRenderToMRT) {
                defines.PREPASS = true;
                defines.SCENE_MRT_COUNT = scene.prePassRenderer.mrtCount;
                for (let i = 0; i < texturesList.length; i++) {
                    const index = scene.prePassRenderer.getIndex(texturesList[i].type);
                    if (index !== -1) {
                        defines[texturesList[i].define] = true;
                        defines[texturesList[i].index] = index;
                    }
                    else {
                        defines[texturesList[i].define] = false;
                    }
                }
            }
            else {
                defines.PREPASS = false;
                for (let i = 0; i < texturesList.length; i++) {
                    defines[texturesList[i].define] = false;
                }
            }
            if (defines.PREPASS != previousPrePass) {
                defines.markAsUnprocessed();
                defines.markAsImageProcessingDirty();
            }
        }
        /**
         * Prepares the defines related to the light information passed in parameter
         * @param scene The scene we are intending to draw
         * @param mesh The mesh the effect is compiling for
         * @param light The light the effect is compiling for
         * @param lightIndex The index of the light
         * @param defines The defines to update
         * @param specularSupported Specifies whether specular is supported or not (override lights data)
         * @param state Defines the current state regarding what is needed (normals, etc...)
         * @param state.needNormals
         * @param state.needRebuild
         * @param state.shadowEnabled
         * @param state.specularEnabled
         * @param state.lightmapMode
         */
        static PrepareDefinesForLight(scene, mesh, light, lightIndex, defines, specularSupported, state) {
            var _a;
            state.needNormals = true;
            if (defines["LIGHT" + lightIndex] === undefined) {
                state.needRebuild = true;
            }
            defines["LIGHT" + lightIndex] = true;
            defines["SPOTLIGHT" + lightIndex] = false;
            defines["HEMILIGHT" + lightIndex] = false;
            defines["POINTLIGHT" + lightIndex] = false;
            defines["DIRLIGHT" + lightIndex] = false;
            light.prepareLightSpecificDefines(defines, lightIndex);
            // FallOff.
            defines["LIGHT_FALLOFF_PHYSICAL" + lightIndex] = false;
            defines["LIGHT_FALLOFF_GLTF" + lightIndex] = false;
            defines["LIGHT_FALLOFF_STANDARD" + lightIndex] = false;
            switch (light.falloffType) {
                case LightConstants.FALLOFF_GLTF:
                    defines["LIGHT_FALLOFF_GLTF" + lightIndex] = true;
                    break;
                case LightConstants.FALLOFF_PHYSICAL:
                    defines["LIGHT_FALLOFF_PHYSICAL" + lightIndex] = true;
                    break;
                case LightConstants.FALLOFF_STANDARD:
                    defines["LIGHT_FALLOFF_STANDARD" + lightIndex] = true;
                    break;
            }
            // Specular
            if (specularSupported && !light.specular.equalsFloats(0, 0, 0)) {
                state.specularEnabled = true;
            }
            // Shadows
            defines["SHADOW" + lightIndex] = false;
            defines["SHADOWCSM" + lightIndex] = false;
            defines["SHADOWCSMDEBUG" + lightIndex] = false;
            defines["SHADOWCSMNUM_CASCADES" + lightIndex] = false;
            defines["SHADOWCSMUSESHADOWMAXZ" + lightIndex] = false;
            defines["SHADOWCSMNOBLEND" + lightIndex] = false;
            defines["SHADOWCSM_RIGHTHANDED" + lightIndex] = false;
            defines["SHADOWPCF" + lightIndex] = false;
            defines["SHADOWPCSS" + lightIndex] = false;
            defines["SHADOWPOISSON" + lightIndex] = false;
            defines["SHADOWESM" + lightIndex] = false;
            defines["SHADOWCLOSEESM" + lightIndex] = false;
            defines["SHADOWCUBE" + lightIndex] = false;
            defines["SHADOWLOWQUALITY" + lightIndex] = false;
            defines["SHADOWMEDIUMQUALITY" + lightIndex] = false;
            if (mesh && mesh.receiveShadows && scene.shadowsEnabled && light.shadowEnabled) {
                const shadowGenerator = (_a = light.getShadowGenerator(scene.activeCamera)) !== null && _a !== void 0 ? _a : light.getShadowGenerator();
                if (shadowGenerator) {
                    const shadowMap = shadowGenerator.getShadowMap();
                    if (shadowMap) {
                        if (shadowMap.renderList && shadowMap.renderList.length > 0) {
                            state.shadowEnabled = true;
                            shadowGenerator.prepareDefines(defines, lightIndex);
                        }
                    }
                }
            }
            if (light.lightmapMode != LightConstants.LIGHTMAP_DEFAULT) {
                state.lightmapMode = true;
                defines["LIGHTMAPEXCLUDED" + lightIndex] = true;
                defines["LIGHTMAPNOSPECULAR" + lightIndex] = light.lightmapMode == LightConstants.LIGHTMAP_SHADOWSONLY;
            }
            else {
                defines["LIGHTMAPEXCLUDED" + lightIndex] = false;
                defines["LIGHTMAPNOSPECULAR" + lightIndex] = false;
            }
        }
        /**
         * Prepares the defines related to the light information passed in parameter
         * @param scene The scene we are intending to draw
         * @param mesh The mesh the effect is compiling for
         * @param defines The defines to update
         * @param specularSupported Specifies whether specular is supported or not (override lights data)
         * @param maxSimultaneousLights Specifies how manuy lights can be added to the effect at max
         * @param disableLighting Specifies whether the lighting is disabled (override scene and light)
         * @returns true if normals will be required for the rest of the effect
         */
        static PrepareDefinesForLights(scene, mesh, defines, specularSupported, maxSimultaneousLights = 4, disableLighting = false) {
            if (!defines._areLightsDirty) {
                return defines._needNormals;
            }
            let lightIndex = 0;
            const state = {
                needNormals: defines._needNormals,
                needRebuild: false,
                lightmapMode: false,
                shadowEnabled: false,
                specularEnabled: false,
            };
            if (scene.lightsEnabled && !disableLighting) {
                for (const light of mesh.lightSources) {
                    this.PrepareDefinesForLight(scene, mesh, light, lightIndex, defines, specularSupported, state);
                    lightIndex++;
                    if (lightIndex === maxSimultaneousLights) {
                        break;
                    }
                }
            }
            defines["SPECULARTERM"] = state.specularEnabled;
            defines["SHADOWS"] = state.shadowEnabled;
            // Resetting all other lights if any
            for (let index = lightIndex; index < maxSimultaneousLights; index++) {
                if (defines["LIGHT" + index] !== undefined) {
                    defines["LIGHT" + index] = false;
                    defines["HEMILIGHT" + index] = false;
                    defines["POINTLIGHT" + index] = false;
                    defines["DIRLIGHT" + index] = false;
                    defines["SPOTLIGHT" + index] = false;
                    defines["SHADOW" + index] = false;
                    defines["SHADOWCSM" + index] = false;
                    defines["SHADOWCSMDEBUG" + index] = false;
                    defines["SHADOWCSMNUM_CASCADES" + index] = false;
                    defines["SHADOWCSMUSESHADOWMAXZ" + index] = false;
                    defines["SHADOWCSMNOBLEND" + index] = false;
                    defines["SHADOWCSM_RIGHTHANDED" + index] = false;
                    defines["SHADOWPCF" + index] = false;
                    defines["SHADOWPCSS" + index] = false;
                    defines["SHADOWPOISSON" + index] = false;
                    defines["SHADOWESM" + index] = false;
                    defines["SHADOWCLOSEESM" + index] = false;
                    defines["SHADOWCUBE" + index] = false;
                    defines["SHADOWLOWQUALITY" + index] = false;
                    defines["SHADOWMEDIUMQUALITY" + index] = false;
                }
            }
            const caps = scene.getEngine().getCaps();
            if (defines["SHADOWFLOAT"] === undefined) {
                state.needRebuild = true;
            }
            defines["SHADOWFLOAT"] =
                state.shadowEnabled && ((caps.textureFloatRender && caps.textureFloatLinearFiltering) || (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering));
            defines["LIGHTMAPEXCLUDED"] = state.lightmapMode;
            if (state.needRebuild) {
                defines.rebuild();
            }
            return state.needNormals;
        }
        /**
         * Prepares the uniforms and samplers list to be used in the effect (for a specific light)
         * @param lightIndex defines the light index
         * @param uniformsList The uniform list
         * @param samplersList The sampler list
         * @param projectedLightTexture defines if projected texture must be used
         * @param uniformBuffersList defines an optional list of uniform buffers
         * @param updateOnlyBuffersList True to only update the uniformBuffersList array
         */
        static PrepareUniformsAndSamplersForLight(lightIndex, uniformsList, samplersList, projectedLightTexture, uniformBuffersList = null, updateOnlyBuffersList = false) {
            if (uniformBuffersList) {
                uniformBuffersList.push("Light" + lightIndex);
            }
            if (updateOnlyBuffersList) {
                return;
            }
            uniformsList.push("vLightData" + lightIndex, "vLightDiffuse" + lightIndex, "vLightSpecular" + lightIndex, "vLightDirection" + lightIndex, "vLightFalloff" + lightIndex, "vLightGround" + lightIndex, "lightMatrix" + lightIndex, "shadowsInfo" + lightIndex, "depthValues" + lightIndex);
            samplersList.push("shadowSampler" + lightIndex);
            samplersList.push("depthSampler" + lightIndex);
            uniformsList.push("viewFrustumZ" + lightIndex, "cascadeBlendFactor" + lightIndex, "lightSizeUVCorrection" + lightIndex, "depthCorrection" + lightIndex, "penumbraDarkness" + lightIndex, "frustumLengths" + lightIndex);
            if (projectedLightTexture) {
                samplersList.push("projectionLightSampler" + lightIndex);
                uniformsList.push("textureProjectionMatrix" + lightIndex);
            }
        }
        /**
         * Prepares the uniforms and samplers list to be used in the effect
         * @param uniformsListOrOptions The uniform names to prepare or an EffectCreationOptions containing the list and extra information
         * @param samplersList The sampler list
         * @param defines The defines helping in the list generation
         * @param maxSimultaneousLights The maximum number of simultaneous light allowed in the effect
         */
        static PrepareUniformsAndSamplersList(uniformsListOrOptions, samplersList, defines, maxSimultaneousLights = 4) {
            let uniformsList;
            let uniformBuffersList = null;
            if (uniformsListOrOptions.uniformsNames) {
                const options = uniformsListOrOptions;
                uniformsList = options.uniformsNames;
                uniformBuffersList = options.uniformBuffersNames;
                samplersList = options.samplers;
                defines = options.defines;
                maxSimultaneousLights = options.maxSimultaneousLights || 0;
            }
            else {
                uniformsList = uniformsListOrOptions;
                if (!samplersList) {
                    samplersList = [];
                }
            }
            for (let lightIndex = 0; lightIndex < maxSimultaneousLights; lightIndex++) {
                if (!defines["LIGHT" + lightIndex]) {
                    break;
                }
                this.PrepareUniformsAndSamplersForLight(lightIndex, uniformsList, samplersList, defines["PROJECTEDLIGHTTEXTURE" + lightIndex], uniformBuffersList);
            }
            if (defines["NUM_MORPH_INFLUENCERS"]) {
                uniformsList.push("morphTargetInfluences");
            }
            if (defines["BAKED_VERTEX_ANIMATION_TEXTURE"]) {
                uniformsList.push("bakedVertexAnimationSettings");
                uniformsList.push("bakedVertexAnimationTextureSizeInverted");
                uniformsList.push("bakedVertexAnimationTime");
                samplersList.push("bakedVertexAnimationTexture");
            }
        }
        /**
         * This helps decreasing rank by rank the shadow quality (0 being the highest rank and quality)
         * @param defines The defines to update while falling back
         * @param fallbacks The authorized effect fallbacks
         * @param maxSimultaneousLights The maximum number of lights allowed
         * @param rank the current rank of the Effect
         * @returns The newly affected rank
         */
        static HandleFallbacksForShadows(defines, fallbacks, maxSimultaneousLights = 4, rank = 0) {
            let lightFallbackRank = 0;
            for (let lightIndex = 0; lightIndex < maxSimultaneousLights; lightIndex++) {
                if (!defines["LIGHT" + lightIndex]) {
                    break;
                }
                if (lightIndex > 0) {
                    lightFallbackRank = rank + lightIndex;
                    fallbacks.addFallback(lightFallbackRank, "LIGHT" + lightIndex);
                }
                if (!defines["SHADOWS"]) {
                    if (defines["SHADOW" + lightIndex]) {
                        fallbacks.addFallback(rank, "SHADOW" + lightIndex);
                    }
                    if (defines["SHADOWPCF" + lightIndex]) {
                        fallbacks.addFallback(rank, "SHADOWPCF" + lightIndex);
                    }
                    if (defines["SHADOWPCSS" + lightIndex]) {
                        fallbacks.addFallback(rank, "SHADOWPCSS" + lightIndex);
                    }
                    if (defines["SHADOWPOISSON" + lightIndex]) {
                        fallbacks.addFallback(rank, "SHADOWPOISSON" + lightIndex);
                    }
                    if (defines["SHADOWESM" + lightIndex]) {
                        fallbacks.addFallback(rank, "SHADOWESM" + lightIndex);
                    }
                    if (defines["SHADOWCLOSEESM" + lightIndex]) {
                        fallbacks.addFallback(rank, "SHADOWCLOSEESM" + lightIndex);
                    }
                }
            }
            return lightFallbackRank++;
        }
        /**
         * Prepares the list of attributes required for morph targets according to the effect defines.
         * @param attribs The current list of supported attribs
         * @param mesh The mesh to prepare the morph targets attributes for
         * @param influencers The number of influencers
         */
        static PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, influencers) {
            this._TmpMorphInfluencers.NUM_MORPH_INFLUENCERS = influencers;
            this.PrepareAttributesForMorphTargets(attribs, mesh, this._TmpMorphInfluencers);
        }
        /**
         * Prepares the list of attributes required for morph targets according to the effect defines.
         * @param attribs The current list of supported attribs
         * @param mesh The mesh to prepare the morph targets attributes for
         * @param defines The current Defines of the effect
         */
        static PrepareAttributesForMorphTargets(attribs, mesh, defines) {
            const influencers = defines["NUM_MORPH_INFLUENCERS"];
            if (influencers > 0 && EngineStore.LastCreatedEngine) {
                const maxAttributesCount = EngineStore.LastCreatedEngine.getCaps().maxVertexAttribs;
                const manager = mesh.morphTargetManager;
                if (manager === null || manager === void 0 ? void 0 : manager.isUsingTextureForTargets) {
                    return;
                }
                const normal = manager && manager.supportsNormals && defines["NORMAL"];
                const tangent = manager && manager.supportsTangents && defines["TANGENT"];
                const uv = manager && manager.supportsUVs && defines["UV1"];
                for (let index = 0; index < influencers; index++) {
                    attribs.push(VertexBuffer.PositionKind + index);
                    if (normal) {
                        attribs.push(VertexBuffer.NormalKind + index);
                    }
                    if (tangent) {
                        attribs.push(VertexBuffer.TangentKind + index);
                    }
                    if (uv) {
                        attribs.push(VertexBuffer.UVKind + "_" + index);
                    }
                    if (attribs.length > maxAttributesCount) {
                        Logger.Error("Cannot add more vertex attributes for mesh " + mesh.name);
                    }
                }
            }
        }
        /**
         * Prepares the list of attributes required for baked vertex animations according to the effect defines.
         * @param attribs The current list of supported attribs
         * @param mesh The mesh to prepare the morph targets attributes for
         * @param defines The current Defines of the effect
         */
        static PrepareAttributesForBakedVertexAnimation(attribs, mesh, defines) {
            const enabled = defines["BAKED_VERTEX_ANIMATION_TEXTURE"] && defines["INSTANCES"];
            if (enabled) {
                attribs.push("bakedVertexAnimationSettingsInstanced");
            }
        }
        /**
         * Prepares the list of attributes required for bones according to the effect defines.
         * @param attribs The current list of supported attribs
         * @param mesh The mesh to prepare the bones attributes for
         * @param defines The current Defines of the effect
         * @param fallbacks The current effect fallback strategy
         */
        static PrepareAttributesForBones(attribs, mesh, defines, fallbacks) {
            if (defines["NUM_BONE_INFLUENCERS"] > 0) {
                fallbacks.addCPUSkinningFallback(0, mesh);
                attribs.push(VertexBuffer.MatricesIndicesKind);
                attribs.push(VertexBuffer.MatricesWeightsKind);
                if (defines["NUM_BONE_INFLUENCERS"] > 4) {
                    attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                    attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                }
            }
        }
        /**
         * Check and prepare the list of attributes required for instances according to the effect defines.
         * @param attribs The current list of supported attribs
         * @param defines The current MaterialDefines of the effect
         */
        static PrepareAttributesForInstances(attribs, defines) {
            if (defines["INSTANCES"] || defines["THIN_INSTANCES"]) {
                this.PushAttributesForInstances(attribs, !!defines["PREPASS_VELOCITY"]);
            }
            if (defines.INSTANCESCOLOR) {
                attribs.push(VertexBuffer.ColorInstanceKind);
            }
        }
        /**
         * Add the list of attributes required for instances to the attribs array.
         * @param attribs The current list of supported attribs
         * @param needsPreviousMatrices If the shader needs previous matrices
         */
        static PushAttributesForInstances(attribs, needsPreviousMatrices = false) {
            attribs.push("world0");
            attribs.push("world1");
            attribs.push("world2");
            attribs.push("world3");
            if (needsPreviousMatrices) {
                attribs.push("previousWorld0");
                attribs.push("previousWorld1");
                attribs.push("previousWorld2");
                attribs.push("previousWorld3");
            }
        }
        /**
         * Binds the light information to the effect.
         * @param light The light containing the generator
         * @param effect The effect we are binding the data to
         * @param lightIndex The light index in the effect used to render
         */
        static BindLightProperties(light, effect, lightIndex) {
            light.transferToEffect(effect, lightIndex + "");
        }
        /**
         * Binds the lights information from the scene to the effect for the given mesh.
         * @param light Light to bind
         * @param lightIndex Light index
         * @param scene The scene where the light belongs to
         * @param effect The effect we are binding the data to
         * @param useSpecular Defines if specular is supported
         * @param receiveShadows Defines if the effect (mesh) we bind the light for receives shadows
         */
        static BindLight(light, lightIndex, scene, effect, useSpecular, receiveShadows = true) {
            light._bindLight(lightIndex, scene, effect, useSpecular, receiveShadows);
        }
        /**
         * Binds the lights information from the scene to the effect for the given mesh.
         * @param scene The scene the lights belongs to
         * @param mesh The mesh we are binding the information to render
         * @param effect The effect we are binding the data to
         * @param defines The generated defines for the effect
         * @param maxSimultaneousLights The maximum number of light that can be bound to the effect
         */
        static BindLights(scene, mesh, effect, defines, maxSimultaneousLights = 4) {
            const len = Math.min(mesh.lightSources.length, maxSimultaneousLights);
            for (let i = 0; i < len; i++) {
                const light = mesh.lightSources[i];
                this.BindLight(light, i, scene, effect, typeof defines === "boolean" ? defines : defines["SPECULARTERM"], mesh.receiveShadows);
            }
        }
        /**
         * Binds the fog information from the scene to the effect for the given mesh.
         * @param scene The scene the lights belongs to
         * @param mesh The mesh we are binding the information to render
         * @param effect The effect we are binding the data to
         * @param linearSpace Defines if the fog effect is applied in linear space
         */
        static BindFogParameters(scene, mesh, effect, linearSpace = false) {
            if (scene.fogEnabled && mesh.applyFog && scene.fogMode !== Scene.FOGMODE_NONE) {
                effect.setFloat4("vFogInfos", scene.fogMode, scene.fogStart, scene.fogEnd, scene.fogDensity);
                // Convert fog color to linear space if used in a linear space computed shader.
                if (linearSpace) {
                    scene.fogColor.toLinearSpaceToRef(this._TempFogColor, scene.getEngine().useExactSrgbConversions);
                    effect.setColor3("vFogColor", this._TempFogColor);
                }
                else {
                    effect.setColor3("vFogColor", scene.fogColor);
                }
            }
        }
        /**
         * Binds the bones information from the mesh to the effect.
         * @param mesh The mesh we are binding the information to render
         * @param effect The effect we are binding the data to
         * @param prePassConfiguration Configuration for the prepass, in case prepass is activated
         */
        static BindBonesParameters(mesh, effect, prePassConfiguration) {
            if (!effect || !mesh) {
                return;
            }
            if (mesh.computeBonesUsingShaders && effect._bonesComputationForcedToCPU) {
                mesh.computeBonesUsingShaders = false;
            }
            if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
                const skeleton = mesh.skeleton;
                if (skeleton.isUsingTextureForMatrices && effect.getUniformIndex("boneTextureWidth") > -1) {
                    const boneTexture = skeleton.getTransformMatrixTexture(mesh);
                    effect.setTexture("boneSampler", boneTexture);
                    effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                }
                else {
                    const matrices = skeleton.getTransformMatrices(mesh);
                    if (matrices) {
                        effect.setMatrices("mBones", matrices);
                        if (prePassConfiguration && mesh.getScene().prePassRenderer && mesh.getScene().prePassRenderer.getIndex(2)) {
                            if (!prePassConfiguration.previousBones[mesh.uniqueId]) {
                                prePassConfiguration.previousBones[mesh.uniqueId] = matrices.slice();
                            }
                            effect.setMatrices("mPreviousBones", prePassConfiguration.previousBones[mesh.uniqueId]);
                            MaterialHelper._CopyBonesTransformationMatrices(matrices, prePassConfiguration.previousBones[mesh.uniqueId]);
                        }
                    }
                }
            }
        }
        // Copies the bones transformation matrices into the target array and returns the target's reference
        static _CopyBonesTransformationMatrices(source, target) {
            target.set(source);
            return target;
        }
        /**
         * Binds the morph targets information from the mesh to the effect.
         * @param abstractMesh The mesh we are binding the information to render
         * @param effect The effect we are binding the data to
         */
        static BindMorphTargetParameters(abstractMesh, effect) {
            const manager = abstractMesh.morphTargetManager;
            if (!abstractMesh || !manager) {
                return;
            }
            effect.setFloatArray("morphTargetInfluences", manager.influences);
        }
        /**
         * Binds the logarithmic depth information from the scene to the effect for the given defines.
         * @param defines The generated defines used in the effect
         * @param effect The effect we are binding the data to
         * @param scene The scene we are willing to render with logarithmic scale for
         */
        static BindLogDepth(defines, effect, scene) {
            if (!defines || defines["LOGARITHMICDEPTH"] || (defines.indexOf && defines.indexOf("LOGARITHMICDEPTH") >= 0)) {
                const camera = scene.activeCamera;
                if (camera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                    Logger.Error("Logarithmic depth is not compatible with orthographic cameras!", 20);
                }
                effect.setFloat("logarithmicDepthConstant", 2.0 / (Math.log(camera.maxZ + 1.0) / Math.LN2));
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MaterialHelper._TmpMorphInfluencers = { NUM_MORPH_INFLUENCERS: 0 };
    MaterialHelper._TempFogColor = Color3.Black();

    /**
     * Class that holds the different stencil states of a material
     * Usage example: https://playground.babylonjs.com/#CW5PRI#10
     */
    class MaterialStencilState {
        /**
         * Creates a material stencil state instance
         */
        constructor() {
            this.reset();
        }
        /**
         * Resets all the stencil states to default values
         */
        reset() {
            this.enabled = false;
            this.mask = 0xff;
            this.func = 519;
            this.funcRef = 1;
            this.funcMask = 0xff;
            this.opStencilFail = 7680;
            this.opDepthFail = 7680;
            this.opStencilDepthPass = 7681;
        }
        /**
         * Gets or sets the stencil function
         */
        get func() {
            return this._func;
        }
        set func(value) {
            this._func = value;
        }
        /**
         * Gets or sets the stencil function reference
         */
        get funcRef() {
            return this._funcRef;
        }
        set funcRef(value) {
            this._funcRef = value;
        }
        /**
         * Gets or sets the stencil function mask
         */
        get funcMask() {
            return this._funcMask;
        }
        set funcMask(value) {
            this._funcMask = value;
        }
        /**
         * Gets or sets the operation when the stencil test fails
         */
        get opStencilFail() {
            return this._opStencilFail;
        }
        set opStencilFail(value) {
            this._opStencilFail = value;
        }
        /**
         * Gets or sets the operation when the depth test fails
         */
        get opDepthFail() {
            return this._opDepthFail;
        }
        set opDepthFail(value) {
            this._opDepthFail = value;
        }
        /**
         * Gets or sets the operation when the stencil+depth test succeeds
         */
        get opStencilDepthPass() {
            return this._opStencilDepthPass;
        }
        set opStencilDepthPass(value) {
            this._opStencilDepthPass = value;
        }
        /**
         * Gets or sets the stencil mask
         */
        get mask() {
            return this._mask;
        }
        set mask(value) {
            this._mask = value;
        }
        /**
         * Enables or disables the stencil test
         */
        get enabled() {
            return this._enabled;
        }
        set enabled(value) {
            this._enabled = value;
        }
        /**
         * Get the current class name, useful for serialization or dynamic coding.
         * @returns "MaterialStencilState"
         */
        getClassName() {
            return "MaterialStencilState";
        }
        /**
         * Makes a duplicate of the current configuration into another one.
         * @param stencilState defines stencil state where to copy the info
         */
        copyTo(stencilState) {
            SerializationHelper.Clone(() => stencilState, this);
        }
        /**
         * Serializes this stencil configuration.
         * @returns - An object with the serialized config.
         */
        serialize() {
            return SerializationHelper.Serialize(this);
        }
        /**
         * Parses a stencil state configuration from a serialized object.
         * @param source - Serialized object.
         * @param scene Defines the scene we are parsing for
         * @param rootUrl Defines the rootUrl to load from
         */
        parse(source, scene, rootUrl) {
            SerializationHelper.Parse(() => this, source, scene, rootUrl);
        }
    }
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "func", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "funcRef", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "funcMask", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "opStencilFail", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "opDepthFail", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "opStencilDepthPass", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "mask", null);
    __decorate$1([
        serialize()
    ], MaterialStencilState.prototype, "enabled", null);

    /**
     * @internal
     */
    var MaterialPluginEvent;
    (function (MaterialPluginEvent) {
        MaterialPluginEvent[MaterialPluginEvent["Created"] = 1] = "Created";
        MaterialPluginEvent[MaterialPluginEvent["Disposed"] = 2] = "Disposed";
        MaterialPluginEvent[MaterialPluginEvent["GetDefineNames"] = 4] = "GetDefineNames";
        MaterialPluginEvent[MaterialPluginEvent["PrepareUniformBuffer"] = 8] = "PrepareUniformBuffer";
        MaterialPluginEvent[MaterialPluginEvent["IsReadyForSubMesh"] = 16] = "IsReadyForSubMesh";
        MaterialPluginEvent[MaterialPluginEvent["PrepareDefines"] = 32] = "PrepareDefines";
        MaterialPluginEvent[MaterialPluginEvent["BindForSubMesh"] = 64] = "BindForSubMesh";
        MaterialPluginEvent[MaterialPluginEvent["PrepareEffect"] = 128] = "PrepareEffect";
        MaterialPluginEvent[MaterialPluginEvent["GetAnimatables"] = 256] = "GetAnimatables";
        MaterialPluginEvent[MaterialPluginEvent["GetActiveTextures"] = 512] = "GetActiveTextures";
        MaterialPluginEvent[MaterialPluginEvent["HasTexture"] = 1024] = "HasTexture";
        MaterialPluginEvent[MaterialPluginEvent["FillRenderTargetTextures"] = 2048] = "FillRenderTargetTextures";
        MaterialPluginEvent[MaterialPluginEvent["HasRenderTargetTextures"] = 4096] = "HasRenderTargetTextures";
        MaterialPluginEvent[MaterialPluginEvent["HardBindForSubMesh"] = 8192] = "HardBindForSubMesh";
    })(MaterialPluginEvent || (MaterialPluginEvent = {}));

    /**
     * Base class for the main features of a material in Babylon.js
     */
    class Material {
        /**
         * If the material can be rendered to several textures with MRT extension
         */
        get canRenderToMRT() {
            // By default, shaders are not compatible with MRTs
            // Base classes should override that if their shader supports MRT
            return false;
        }
        /**
         * Sets the alpha value of the material
         */
        set alpha(value) {
            if (this._alpha === value) {
                return;
            }
            const oldValue = this._alpha;
            this._alpha = value;
            // Only call dirty when there is a state change (no alpha / alpha)
            if (oldValue === 1 || value === 1) {
                this.markAsDirty(Material.MiscDirtyFlag + Material.PrePassDirtyFlag);
            }
        }
        /**
         * Gets the alpha value of the material
         */
        get alpha() {
            return this._alpha;
        }
        /**
         * Sets the culling state (true to enable culling, false to disable)
         */
        set backFaceCulling(value) {
            if (this._backFaceCulling === value) {
                return;
            }
            this._backFaceCulling = value;
            this.markAsDirty(Material.TextureDirtyFlag);
        }
        /**
         * Gets the culling state
         */
        get backFaceCulling() {
            return this._backFaceCulling;
        }
        /**
         * Sets the type of faces that should be culled (true for back faces, false for front faces)
         */
        set cullBackFaces(value) {
            if (this._cullBackFaces === value) {
                return;
            }
            this._cullBackFaces = value;
            this.markAsDirty(Material.TextureDirtyFlag);
        }
        /**
         * Gets the type of faces that should be culled
         */
        get cullBackFaces() {
            return this._cullBackFaces;
        }
        /**
         * Block the dirty-mechanism for this specific material
         * When set to false after being true the material will be marked as dirty.
         */
        get blockDirtyMechanism() {
            return this._blockDirtyMechanism;
        }
        set blockDirtyMechanism(value) {
            if (this._blockDirtyMechanism === value) {
                return;
            }
            this._blockDirtyMechanism = value;
            if (!value) {
                this.markDirty();
            }
        }
        /**
         * This allows you to modify the material without marking it as dirty after every change.
         * This function should be used if you need to make more than one dirty-enabling change to the material - adding a texture, setting a new fill mode and so on.
         * The callback will pass the material as an argument, so you can make your changes to it.
         * @param callback the callback to be executed that will update the material
         */
        atomicMaterialsUpdate(callback) {
            this.blockDirtyMechanism = true;
            try {
                callback(this);
            }
            finally {
                this.blockDirtyMechanism = false;
            }
        }
        /**
         * Gets a boolean indicating that current material needs to register RTT
         */
        get hasRenderTargetTextures() {
            this._eventInfo.hasRenderTargetTextures = false;
            this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
            return this._eventInfo.hasRenderTargetTextures;
        }
        /**
         * Called during a dispose event
         */
        set onDispose(callback) {
            if (this._onDisposeObserver) {
                this.onDisposeObservable.remove(this._onDisposeObserver);
            }
            this._onDisposeObserver = this.onDisposeObservable.add(callback);
        }
        /**
         * An event triggered when the material is bound
         */
        get onBindObservable() {
            if (!this._onBindObservable) {
                this._onBindObservable = new Observable$1();
            }
            return this._onBindObservable;
        }
        /**
         * Called during a bind event
         */
        set onBind(callback) {
            if (this._onBindObserver) {
                this.onBindObservable.remove(this._onBindObserver);
            }
            this._onBindObserver = this.onBindObservable.add(callback);
        }
        /**
         * An event triggered when the material is unbound
         */
        get onUnBindObservable() {
            if (!this._onUnBindObservable) {
                this._onUnBindObservable = new Observable$1();
            }
            return this._onUnBindObservable;
        }
        /**
         * An event triggered when the effect is (re)created
         */
        get onEffectCreatedObservable() {
            if (!this._onEffectCreatedObservable) {
                this._onEffectCreatedObservable = new Observable$1();
            }
            return this._onEffectCreatedObservable;
        }
        /**
         * Sets the value of the alpha mode.
         *
         * | Value | Type | Description |
         * | --- | --- | --- |
         * | 0 | ALPHA_DISABLE |   |
         * | 1 | ALPHA_ADD |   |
         * | 2 | ALPHA_COMBINE |   |
         * | 3 | ALPHA_SUBTRACT |   |
         * | 4 | ALPHA_MULTIPLY |   |
         * | 5 | ALPHA_MAXIMIZED |   |
         * | 6 | ALPHA_ONEONE |   |
         * | 7 | ALPHA_PREMULTIPLIED |   |
         * | 8 | ALPHA_PREMULTIPLIED_PORTERDUFF |   |
         * | 9 | ALPHA_INTERPOLATE |   |
         * | 10 | ALPHA_SCREENMODE |   |
         *
         */
        set alphaMode(value) {
            if (this._alphaMode === value) {
                return;
            }
            this._alphaMode = value;
            this.markAsDirty(Material.TextureDirtyFlag);
        }
        /**
         * Gets the value of the alpha mode
         */
        get alphaMode() {
            return this._alphaMode;
        }
        /**
         * Sets the need depth pre-pass value
         */
        set needDepthPrePass(value) {
            if (this._needDepthPrePass === value) {
                return;
            }
            this._needDepthPrePass = value;
            if (this._needDepthPrePass) {
                this.checkReadyOnEveryCall = true;
            }
        }
        /**
         * Gets the depth pre-pass value
         */
        get needDepthPrePass() {
            return this._needDepthPrePass;
        }
        /**
         * Can this material render to prepass
         */
        get isPrePassCapable() {
            return false;
        }
        /**
         * Sets the state for enabling fog
         */
        set fogEnabled(value) {
            if (this._fogEnabled === value) {
                return;
            }
            this._fogEnabled = value;
            this.markAsDirty(Material.MiscDirtyFlag);
        }
        /**
         * Gets the value of the fog enabled state
         */
        get fogEnabled() {
            return this._fogEnabled;
        }
        get wireframe() {
            switch (this._fillMode) {
                case Material.WireFrameFillMode:
                case Material.LineListDrawMode:
                case Material.LineLoopDrawMode:
                case Material.LineStripDrawMode:
                    return true;
            }
            return this._scene.forceWireframe;
        }
        /**
         * Sets the state of wireframe mode
         */
        set wireframe(value) {
            this.fillMode = value ? Material.WireFrameFillMode : Material.TriangleFillMode;
        }
        /**
         * Gets the value specifying if point clouds are enabled
         */
        get pointsCloud() {
            switch (this._fillMode) {
                case Material.PointFillMode:
                case Material.PointListDrawMode:
                    return true;
            }
            return this._scene.forcePointsCloud;
        }
        /**
         * Sets the state of point cloud mode
         */
        set pointsCloud(value) {
            this.fillMode = value ? Material.PointFillMode : Material.TriangleFillMode;
        }
        /**
         * Gets the material fill mode
         */
        get fillMode() {
            return this._fillMode;
        }
        /**
         * Sets the material fill mode
         */
        set fillMode(value) {
            if (this._fillMode === value) {
                return;
            }
            this._fillMode = value;
            this.markAsDirty(Material.MiscDirtyFlag);
        }
        /** @internal */
        _getDrawWrapper() {
            return this._drawWrapper;
        }
        /**
         * @internal
         */
        _setDrawWrapper(drawWrapper) {
            this._drawWrapper = drawWrapper;
        }
        /**
         * Creates a material instance
         * @param name defines the name of the material
         * @param scene defines the scene to reference
         * @param doNotAdd specifies if the material should be added to the scene
         */
        constructor(name, scene, doNotAdd) {
            /**
             * Custom shadow depth material to use for shadow rendering instead of the in-built one
             */
            this.shadowDepthWrapper = null;
            /**
             * Gets or sets a boolean indicating that the material is allowed (if supported) to do shader hot swapping.
             * This means that the material can keep using a previous shader while a new one is being compiled.
             * This is mostly used when shader parallel compilation is supported (true by default)
             */
            this.allowShaderHotSwapping = true;
            /**
             * Gets or sets user defined metadata
             */
            this.metadata = null;
            /**
             * For internal use only. Please do not use.
             */
            this.reservedDataStore = null;
            /**
             * Specifies if the ready state should be checked on each call
             */
            this.checkReadyOnEveryCall = false;
            /**
             * Specifies if the ready state should be checked once
             */
            this.checkReadyOnlyOnce = false;
            /**
             * The state of the material
             */
            this.state = "";
            /**
             * The alpha value of the material
             */
            this._alpha = 1.0;
            /**
             * Specifies if back face culling is enabled
             */
            this._backFaceCulling = true;
            /**
             * Specifies if back or front faces should be culled (when culling is enabled)
             */
            this._cullBackFaces = true;
            this._blockDirtyMechanism = false;
            /**
             * Callback triggered when the material is compiled
             */
            this.onCompiled = null;
            /**
             * Callback triggered when an error occurs
             */
            this.onError = null;
            /**
             * Callback triggered to get the render target textures
             */
            this.getRenderTargetTextures = null;
            /**
             * Specifies if the material should be serialized
             */
            this.doNotSerialize = false;
            /**
             * @internal
             */
            this._storeEffectOnSubMeshes = false;
            /**
             * Stores the animations for the material
             */
            this.animations = null;
            /**
             * An event triggered when the material is disposed
             */
            this.onDisposeObservable = new Observable$1();
            /**
             * An observer which watches for dispose events
             */
            this._onDisposeObserver = null;
            this._onUnBindObservable = null;
            /**
             * An observer which watches for bind events
             */
            this._onBindObserver = null;
            /**
             * Stores the value of the alpha mode
             */
            this._alphaMode = 2;
            /**
             * Stores the state of the need depth pre-pass value
             */
            this._needDepthPrePass = false;
            /**
             * Specifies if depth writing should be disabled
             */
            this.disableDepthWrite = false;
            /**
             * Specifies if color writing should be disabled
             */
            this.disableColorWrite = false;
            /**
             * Specifies if depth writing should be forced
             */
            this.forceDepthWrite = false;
            /**
             * Specifies the depth function that should be used. 0 means the default engine function
             */
            this.depthFunction = 0;
            /**
             * Specifies if there should be a separate pass for culling
             */
            this.separateCullingPass = false;
            /**
             * Stores the state specifying if fog should be enabled
             */
            this._fogEnabled = true;
            /**
             * Stores the size of points
             */
            this.pointSize = 1.0;
            /**
             * Stores the z offset Factor value
             */
            this.zOffset = 0;
            /**
             * Stores the z offset Units value
             */
            this.zOffsetUnits = 0;
            /**
             * Gives access to the stencil properties of the material
             */
            this.stencil = new MaterialStencilState();
            /**
             * Specifies if uniform buffers should be used
             */
            this._useUBO = false;
            /**
             * Stores the fill mode state
             */
            this._fillMode = Material.TriangleFillMode;
            /**
             * Specifies if the depth write state should be cached
             */
            this._cachedDepthWriteState = false;
            /**
             * Specifies if the color write state should be cached
             */
            this._cachedColorWriteState = false;
            /**
             * Specifies if the depth function state should be cached
             */
            this._cachedDepthFunctionState = 0;
            /** @internal */
            this._indexInSceneMaterialArray = -1;
            /** @internal */
            this.meshMap = null;
            /** @internal */
            this._parentContainer = null;
            /** @internal */
            this._uniformBufferLayoutBuilt = false;
            this._eventInfo = {}; // will be initialized before each event notification
            /** @internal */
            this._callbackPluginEventGeneric = () => void 0;
            /** @internal */
            this._callbackPluginEventIsReadyForSubMesh = () => void 0;
            /** @internal */
            this._callbackPluginEventPrepareDefines = () => void 0;
            /** @internal */
            this._callbackPluginEventPrepareDefinesBeforeAttributes = () => void 0;
            /** @internal */
            this._callbackPluginEventHardBindForSubMesh = () => void 0;
            /** @internal */
            this._callbackPluginEventBindForSubMesh = () => void 0;
            /** @internal */
            this._callbackPluginEventHasRenderTargetTextures = () => void 0;
            /** @internal */
            this._callbackPluginEventFillRenderTargetTextures = () => void 0;
            /**
             * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
             */
            this._forceAlphaTest = false;
            /**
             * The transparency mode of the material.
             */
            this._transparencyMode = null;
            this.name = name;
            const setScene = scene || EngineStore.LastCreatedScene;
            if (!setScene) {
                return;
            }
            this._scene = setScene;
            this._dirtyCallbacks = {};
            this._dirtyCallbacks[1] = this._markAllSubMeshesAsTexturesDirty.bind(this);
            this._dirtyCallbacks[2] = this._markAllSubMeshesAsLightsDirty.bind(this);
            this._dirtyCallbacks[4] = this._markAllSubMeshesAsFresnelDirty.bind(this);
            this._dirtyCallbacks[8] = this._markAllSubMeshesAsAttributesDirty.bind(this);
            this._dirtyCallbacks[16] = this._markAllSubMeshesAsMiscDirty.bind(this);
            this._dirtyCallbacks[32] = this._markAllSubMeshesAsPrePassDirty.bind(this);
            this._dirtyCallbacks[63] = this._markAllSubMeshesAsAllDirty.bind(this);
            this.id = name || Tools.RandomId();
            this.uniqueId = this._scene.getUniqueId();
            this._materialContext = this._scene.getEngine().createMaterialContext();
            this._drawWrapper = new DrawWrapper(this._scene.getEngine(), false);
            this._drawWrapper.materialContext = this._materialContext;
            if (this._scene.useRightHandedSystem) {
                this.sideOrientation = Material.ClockWiseSideOrientation;
            }
            else {
                this.sideOrientation = Material.CounterClockWiseSideOrientation;
            }
            this._uniformBuffer = new UniformBuffer(this._scene.getEngine(), undefined, undefined, name);
            this._useUBO = this.getScene().getEngine().supportsUniformBuffers;
            if (!doNotAdd) {
                this._scene.addMaterial(this);
            }
            if (this._scene.useMaterialMeshMap) {
                this.meshMap = {};
            }
            Material.OnEventObservable.notifyObservers(this, MaterialPluginEvent.Created);
        }
        /**
         * Returns a string representation of the current material
         * @param fullDetails defines a boolean indicating which levels of logging is desired
         * @returns a string with material information
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        toString(fullDetails) {
            const ret = "Name: " + this.name;
            return ret;
        }
        /**
         * Gets the class name of the material
         * @returns a string with the class name of the material
         */
        getClassName() {
            return "Material";
        }
        /** @internal */
        get _isMaterial() {
            return true;
        }
        /**
         * Specifies if updates for the material been locked
         */
        get isFrozen() {
            return this.checkReadyOnlyOnce;
        }
        /**
         * Locks updates for the material
         */
        freeze() {
            this.markDirty();
            this.checkReadyOnlyOnce = true;
        }
        /**
         * Unlocks updates for the material
         */
        unfreeze() {
            this.markDirty();
            this.checkReadyOnlyOnce = false;
        }
        /**
         * Specifies if the material is ready to be used
         * @param mesh defines the mesh to check
         * @param useInstances specifies if instances should be used
         * @returns a boolean indicating if the material is ready to be used
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isReady(mesh, useInstances) {
            return true;
        }
        /**
         * Specifies that the submesh is ready to be used
         * @param mesh defines the mesh to check
         * @param subMesh defines which submesh to check
         * @param useInstances specifies that instances should be used
         * @returns a boolean indicating that the submesh is ready or not
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isReadyForSubMesh(mesh, subMesh, useInstances) {
            const defines = subMesh.materialDefines;
            if (!defines) {
                return false;
            }
            this._eventInfo.isReadyForSubMesh = true;
            this._eventInfo.defines = defines;
            this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
            return this._eventInfo.isReadyForSubMesh;
        }
        /**
         * Returns the material effect
         * @returns the effect associated with the material
         */
        getEffect() {
            return this._drawWrapper.effect;
        }
        /**
         * Returns the current scene
         * @returns a Scene
         */
        getScene() {
            return this._scene;
        }
        /**
         * Gets the current transparency mode.
         */
        get transparencyMode() {
            return this._transparencyMode;
        }
        /**
         * Sets the transparency mode of the material.
         *
         * | Value | Type                                | Description |
         * | ----- | ----------------------------------- | ----------- |
         * | 0     | OPAQUE                              |             |
         * | 1     | ALPHATEST                           |             |
         * | 2     | ALPHABLEND                          |             |
         * | 3     | ALPHATESTANDBLEND                   |             |
         *
         */
        set transparencyMode(value) {
            if (this._transparencyMode === value) {
                return;
            }
            this._transparencyMode = value;
            this._forceAlphaTest = value === Material.MATERIAL_ALPHATESTANDBLEND;
            this._markAllSubMeshesAsTexturesAndMiscDirty();
        }
        /**
         * Returns true if alpha blending should be disabled.
         */
        get _disableAlphaBlending() {
            return this._transparencyMode === Material.MATERIAL_OPAQUE || this._transparencyMode === Material.MATERIAL_ALPHATEST;
        }
        /**
         * Specifies whether or not this material should be rendered in alpha blend mode.
         * @returns a boolean specifying if alpha blending is needed
         */
        needAlphaBlending() {
            if (this._disableAlphaBlending) {
                return false;
            }
            return this.alpha < 1.0;
        }
        /**
         * Specifies if the mesh will require alpha blending
         * @param mesh defines the mesh to check
         * @returns a boolean specifying if alpha blending is needed for the mesh
         */
        needAlphaBlendingForMesh(mesh) {
            if (mesh.visibility < 1.0) {
                return true;
            }
            if (this._disableAlphaBlending) {
                return false;
            }
            return mesh.hasVertexAlpha || this.needAlphaBlending();
        }
        /**
         * Specifies whether or not this material should be rendered in alpha test mode.
         * @returns a boolean specifying if an alpha test is needed.
         */
        needAlphaTesting() {
            if (this._forceAlphaTest) {
                return true;
            }
            return false;
        }
        /**
         * Specifies if material alpha testing should be turned on for the mesh
         * @param mesh defines the mesh to check
         */
        _shouldTurnAlphaTestOn(mesh) {
            return !this.needAlphaBlendingForMesh(mesh) && this.needAlphaTesting();
        }
        /**
         * Gets the texture used for the alpha test
         * @returns the texture to use for alpha testing
         */
        getAlphaTestTexture() {
            return null;
        }
        /**
         * Marks the material to indicate that it needs to be re-calculated
         * @param forceMaterialDirty - Forces the material to be marked as dirty for all components (same as this.markAsDirty(Material.AllDirtyFlag)). You should use this flag if the material is frozen and you want to force a recompilation.
         */
        markDirty(forceMaterialDirty = false) {
            const meshes = this.getScene().meshes;
            for (const mesh of meshes) {
                if (!mesh.subMeshes) {
                    continue;
                }
                for (const subMesh of mesh.subMeshes) {
                    if (subMesh.getMaterial() !== this) {
                        continue;
                    }
                    if (!subMesh.effect) {
                        continue;
                    }
                    subMesh.effect._wasPreviouslyReady = false;
                    subMesh.effect._wasPreviouslyUsingInstances = null;
                    subMesh.effect._forceRebindOnNextCall = forceMaterialDirty;
                }
            }
            if (forceMaterialDirty) {
                this.markAsDirty(Material.AllDirtyFlag);
            }
        }
        /**
         * @internal
         */
        _preBind(effect, overrideOrientation = null) {
            const engine = this._scene.getEngine();
            const orientation = overrideOrientation == null ? this.sideOrientation : overrideOrientation;
            const reverse = orientation === Material.ClockWiseSideOrientation;
            engine.enableEffect(effect ? effect : this._getDrawWrapper());
            engine.setState(this.backFaceCulling, this.zOffset, false, reverse, this._scene._mirroredCameraPosition ? !this.cullBackFaces : this.cullBackFaces, this.stencil, this.zOffsetUnits);
            return reverse;
        }
        /**
         * Binds the material to the mesh
         * @param world defines the world transformation matrix
         * @param mesh defines the mesh to bind the material to
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bind(world, mesh) { }
        /**
         * Initializes the uniform buffer layout for the shader.
         */
        buildUniformLayout() {
            const ubo = this._uniformBuffer;
            this._eventInfo.ubo = ubo;
            this._callbackPluginEventGeneric(MaterialPluginEvent.PrepareUniformBuffer, this._eventInfo);
            ubo.create();
            this._uniformBufferLayoutBuilt = true;
        }
        /**
         * Binds the submesh to the material
         * @param world defines the world transformation matrix
         * @param mesh defines the mesh containing the submesh
         * @param subMesh defines the submesh to bind the material to
         */
        bindForSubMesh(world, mesh, subMesh) {
            const effect = subMesh.effect;
            if (!effect) {
                return;
            }
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventBindForSubMesh(this._eventInfo);
            effect._forceRebindOnNextCall = false;
        }
        /**
         * Binds the world matrix to the material
         * @param world defines the world transformation matrix
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bindOnlyWorldMatrix(world) { }
        /**
         * Binds the view matrix to the effect
         * @param effect defines the effect to bind the view matrix to
         */
        bindView(effect) {
            if (!this._useUBO) {
                effect.setMatrix("view", this.getScene().getViewMatrix());
            }
            else {
                this._needToBindSceneUbo = true;
            }
        }
        /**
         * Binds the view projection and projection matrices to the effect
         * @param effect defines the effect to bind the view projection and projection matrices to
         */
        bindViewProjection(effect) {
            if (!this._useUBO) {
                effect.setMatrix("viewProjection", this.getScene().getTransformMatrix());
                effect.setMatrix("projection", this.getScene().getProjectionMatrix());
            }
            else {
                this._needToBindSceneUbo = true;
            }
        }
        /**
         * Binds the view matrix to the effect
         * @param effect defines the effect to bind the view matrix to
         * @param variableName name of the shader variable that will hold the eye position
         */
        bindEyePosition(effect, variableName) {
            if (!this._useUBO) {
                this._scene.bindEyePosition(effect, variableName);
            }
            else {
                this._needToBindSceneUbo = true;
            }
        }
        /**
         * Processes to execute after binding the material to a mesh
         * @param mesh defines the rendered mesh
         * @param effect
         */
        _afterBind(mesh, effect = null) {
            this._scene._cachedMaterial = this;
            if (this._needToBindSceneUbo) {
                if (effect) {
                    this._needToBindSceneUbo = false;
                    MaterialHelper.BindSceneUniformBuffer(effect, this.getScene().getSceneUniformBuffer());
                    this._scene.finalizeSceneUbo();
                }
            }
            if (mesh) {
                this._scene._cachedVisibility = mesh.visibility;
            }
            else {
                this._scene._cachedVisibility = 1;
            }
            if (this._onBindObservable && mesh) {
                this._onBindObservable.notifyObservers(mesh);
            }
            if (this.disableDepthWrite) {
                const engine = this._scene.getEngine();
                this._cachedDepthWriteState = engine.getDepthWrite();
                engine.setDepthWrite(false);
            }
            if (this.disableColorWrite) {
                const engine = this._scene.getEngine();
                this._cachedColorWriteState = engine.getColorWrite();
                engine.setColorWrite(false);
            }
            if (this.depthFunction !== 0) {
                const engine = this._scene.getEngine();
                this._cachedDepthFunctionState = engine.getDepthFunction() || 0;
                engine.setDepthFunction(this.depthFunction);
            }
        }
        /**
         * Unbinds the material from the mesh
         */
        unbind() {
            if (this._onUnBindObservable) {
                this._onUnBindObservable.notifyObservers(this);
            }
            if (this.depthFunction !== 0) {
                const engine = this._scene.getEngine();
                engine.setDepthFunction(this._cachedDepthFunctionState);
            }
            if (this.disableDepthWrite) {
                const engine = this._scene.getEngine();
                engine.setDepthWrite(this._cachedDepthWriteState);
            }
            if (this.disableColorWrite) {
                const engine = this._scene.getEngine();
                engine.setColorWrite(this._cachedColorWriteState);
            }
        }
        /**
         * Returns the animatable textures.
         * @returns - Array of animatable textures.
         */
        getAnimatables() {
            this._eventInfo.animatables = [];
            this._callbackPluginEventGeneric(MaterialPluginEvent.GetAnimatables, this._eventInfo);
            return this._eventInfo.animatables;
        }
        /**
         * Gets the active textures from the material
         * @returns an array of textures
         */
        getActiveTextures() {
            this._eventInfo.activeTextures = [];
            this._callbackPluginEventGeneric(MaterialPluginEvent.GetActiveTextures, this._eventInfo);
            return this._eventInfo.activeTextures;
        }
        /**
         * Specifies if the material uses a texture
         * @param texture defines the texture to check against the material
         * @returns a boolean specifying if the material uses the texture
         */
        hasTexture(texture) {
            this._eventInfo.hasTexture = false;
            this._eventInfo.texture = texture;
            this._callbackPluginEventGeneric(MaterialPluginEvent.HasTexture, this._eventInfo);
            return this._eventInfo.hasTexture;
        }
        /**
         * Makes a duplicate of the material, and gives it a new name
         * @param name defines the new name for the duplicated material
         * @returns the cloned material
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clone(name) {
            return null;
        }
        _clonePlugins(targetMaterial, rootUrl) {
            const serializationObject = {};
            // Create plugins in targetMaterial in case they don't exist
            this._serializePlugins(serializationObject);
            Material._parsePlugins(serializationObject, targetMaterial, this._scene, rootUrl);
            // Copy the properties of the current plugins to the cloned material's plugins
            if (this.pluginManager) {
                for (const plugin of this.pluginManager._plugins) {
                    const targetPlugin = targetMaterial.pluginManager.getPlugin(plugin.name);
                    plugin.copyTo(targetPlugin);
                }
            }
        }
        /**
         * Gets the meshes bound to the material
         * @returns an array of meshes bound to the material
         */
        getBindedMeshes() {
            if (this.meshMap) {
                const result = new Array();
                for (const meshId in this.meshMap) {
                    const mesh = this.meshMap[meshId];
                    if (mesh) {
                        result.push(mesh);
                    }
                }
                return result;
            }
            else {
                const meshes = this._scene.meshes;
                return meshes.filter((mesh) => mesh.material === this);
            }
        }
        /**
         * Force shader compilation
         * @param mesh defines the mesh associated with this material
         * @param onCompiled defines a function to execute once the material is compiled
         * @param options defines the options to configure the compilation
         * @param onError defines a function to execute if the material fails compiling
         */
        forceCompilation(mesh, onCompiled, options, onError) {
            const localOptions = Object.assign({ clipPlane: false, useInstances: false }, options);
            const scene = this.getScene();
            const currentHotSwapingState = this.allowShaderHotSwapping;
            this.allowShaderHotSwapping = false; // Turned off to let us evaluate the real compilation state
            const checkReady = () => {
                if (!this._scene || !this._scene.getEngine()) {
                    return;
                }
                const clipPlaneState = scene.clipPlane;
                if (localOptions.clipPlane) {
                    scene.clipPlane = new Plane(0, 0, 0, 1);
                }
                if (this._storeEffectOnSubMeshes) {
                    let allDone = true, lastError = null;
                    if (mesh.subMeshes) {
                        const tempSubMesh = new SubMesh(0, 0, 0, 0, 0, mesh, undefined, false, false);
                        if (tempSubMesh.materialDefines) {
                            tempSubMesh.materialDefines._renderId = -1;
                        }
                        if (!this.isReadyForSubMesh(mesh, tempSubMesh, localOptions.useInstances)) {
                            if (tempSubMesh.effect && tempSubMesh.effect.getCompilationError() && tempSubMesh.effect.allFallbacksProcessed()) {
                                lastError = tempSubMesh.effect.getCompilationError();
                            }
                            else {
                                allDone = false;
                                setTimeout(checkReady, 16);
                            }
                        }
                    }
                    if (allDone) {
                        this.allowShaderHotSwapping = currentHotSwapingState;
                        if (lastError) {
                            if (onError) {
                                onError(lastError);
                            }
                        }
                        if (onCompiled) {
                            onCompiled(this);
                        }
                    }
                }
                else {
                    if (this.isReady()) {
                        this.allowShaderHotSwapping = currentHotSwapingState;
                        if (onCompiled) {
                            onCompiled(this);
                        }
                    }
                    else {
                        setTimeout(checkReady, 16);
                    }
                }
                if (localOptions.clipPlane) {
                    scene.clipPlane = clipPlaneState;
                }
            };
            checkReady();
        }
        /**
         * Force shader compilation
         * @param mesh defines the mesh that will use this material
         * @param options defines additional options for compiling the shaders
         * @returns a promise that resolves when the compilation completes
         */
        forceCompilationAsync(mesh, options) {
            return new Promise((resolve, reject) => {
                this.forceCompilation(mesh, () => {
                    resolve();
                }, options, (reason) => {
                    reject(reason);
                });
            });
        }
        /**
         * Marks a define in the material to indicate that it needs to be re-computed
         * @param flag defines a flag used to determine which parts of the material have to be marked as dirty
         */
        markAsDirty(flag) {
            if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
                return;
            }
            Material._DirtyCallbackArray.length = 0;
            if (flag & Material.TextureDirtyFlag) {
                Material._DirtyCallbackArray.push(Material._TextureDirtyCallBack);
            }
            if (flag & Material.LightDirtyFlag) {
                Material._DirtyCallbackArray.push(Material._LightsDirtyCallBack);
            }
            if (flag & Material.FresnelDirtyFlag) {
                Material._DirtyCallbackArray.push(Material._FresnelDirtyCallBack);
            }
            if (flag & Material.AttributesDirtyFlag) {
                Material._DirtyCallbackArray.push(Material._AttributeDirtyCallBack);
            }
            if (flag & Material.MiscDirtyFlag) {
                Material._DirtyCallbackArray.push(Material._MiscDirtyCallBack);
            }
            if (flag & Material.PrePassDirtyFlag) {
                Material._DirtyCallbackArray.push(Material._PrePassDirtyCallBack);
            }
            if (Material._DirtyCallbackArray.length) {
                this._markAllSubMeshesAsDirty(Material._RunDirtyCallBacks);
            }
            this.getScene().resetCachedMaterial();
        }
        /**
         * Resets the draw wrappers cache for all submeshes that are using this material
         */
        resetDrawCache() {
            const meshes = this.getScene().meshes;
            for (const mesh of meshes) {
                if (!mesh.subMeshes) {
                    continue;
                }
                for (const subMesh of mesh.subMeshes) {
                    if (subMesh.getMaterial() !== this) {
                        continue;
                    }
                    subMesh.resetDrawCache();
                }
            }
        }
        /**
         * Marks all submeshes of a material to indicate that their material defines need to be re-calculated
         * @param func defines a function which checks material defines against the submeshes
         */
        _markAllSubMeshesAsDirty(func) {
            if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
                return;
            }
            const meshes = this.getScene().meshes;
            for (const mesh of meshes) {
                if (!mesh.subMeshes) {
                    continue;
                }
                for (const subMesh of mesh.subMeshes) {
                    // We want to skip the submeshes which are not using this material or which have not yet rendered at least once
                    if (subMesh.getMaterial(false) !== this) {
                        continue;
                    }
                    for (const drawWrapper of subMesh._drawWrappers) {
                        if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) {
                            continue;
                        }
                        if (this._materialContext === drawWrapper.materialContext) {
                            func(drawWrapper.defines);
                        }
                    }
                }
            }
        }
        /**
         * Indicates that the scene should check if the rendering now needs a prepass
         */
        _markScenePrePassDirty() {
            if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
                return;
            }
            const prePassRenderer = this.getScene().enablePrePassRenderer();
            if (prePassRenderer) {
                prePassRenderer.markAsDirty();
            }
        }
        /**
         * Indicates that we need to re-calculated for all submeshes
         */
        _markAllSubMeshesAsAllDirty() {
            this._markAllSubMeshesAsDirty(Material._AllDirtyCallBack);
        }
        /**
         * Indicates that image processing needs to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsImageProcessingDirty() {
            this._markAllSubMeshesAsDirty(Material._ImageProcessingDirtyCallBack);
        }
        /**
         * Indicates that textures need to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsTexturesDirty() {
            this._markAllSubMeshesAsDirty(Material._TextureDirtyCallBack);
        }
        /**
         * Indicates that fresnel needs to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsFresnelDirty() {
            this._markAllSubMeshesAsDirty(Material._FresnelDirtyCallBack);
        }
        /**
         * Indicates that fresnel and misc need to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsFresnelAndMiscDirty() {
            this._markAllSubMeshesAsDirty(Material._FresnelAndMiscDirtyCallBack);
        }
        /**
         * Indicates that lights need to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsLightsDirty() {
            this._markAllSubMeshesAsDirty(Material._LightsDirtyCallBack);
        }
        /**
         * Indicates that attributes need to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsAttributesDirty() {
            this._markAllSubMeshesAsDirty(Material._AttributeDirtyCallBack);
        }
        /**
         * Indicates that misc needs to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsMiscDirty() {
            this._markAllSubMeshesAsDirty(Material._MiscDirtyCallBack);
        }
        /**
         * Indicates that prepass needs to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsPrePassDirty() {
            this._markAllSubMeshesAsDirty(Material._MiscDirtyCallBack);
        }
        /**
         * Indicates that textures and misc need to be re-calculated for all submeshes
         */
        _markAllSubMeshesAsTexturesAndMiscDirty() {
            this._markAllSubMeshesAsDirty(Material._TextureAndMiscDirtyCallBack);
        }
        _checkScenePerformancePriority() {
            if (this._scene.performancePriority !== ScenePerformancePriority.BackwardCompatible) {
                this.checkReadyOnlyOnce = true;
                // re-set the flag when the perf priority changes
                const observer = this._scene.onScenePerformancePriorityChangedObservable.addOnce(() => {
                    this.checkReadyOnlyOnce = false;
                });
                // if this material is disposed before the scene is disposed, cleanup the observer
                this.onDisposeObservable.add(() => {
                    this._scene.onScenePerformancePriorityChangedObservable.remove(observer);
                });
            }
        }
        /**
         * Sets the required values to the prepass renderer.
         * @param prePassRenderer defines the prepass renderer to setup.
         * @returns true if the pre pass is needed.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setPrePassRenderer(prePassRenderer) {
            // Do Nothing by default
            return false;
        }
        /**
         * Disposes the material
         * @param forceDisposeEffect specifies if effects should be forcefully disposed
         * @param forceDisposeTextures specifies if textures should be forcefully disposed
         * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
         */
        dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
            const scene = this.getScene();
            // Animations
            scene.stopAnimation(this);
            scene.freeProcessedMaterials();
            // Remove from scene
            scene.removeMaterial(this);
            this._eventInfo.forceDisposeTextures = forceDisposeTextures;
            this._callbackPluginEventGeneric(MaterialPluginEvent.Disposed, this._eventInfo);
            if (this._parentContainer) {
                const index = this._parentContainer.materials.indexOf(this);
                if (index > -1) {
                    this._parentContainer.materials.splice(index, 1);
                }
                this._parentContainer = null;
            }
            if (notBoundToMesh !== true) {
                // Remove from meshes
                if (this.meshMap) {
                    for (const meshId in this.meshMap) {
                        const mesh = this.meshMap[meshId];
                        if (mesh) {
                            mesh.material = null; // will set the entry in the map to undefined
                            this.releaseVertexArrayObject(mesh, forceDisposeEffect);
                        }
                    }
                }
                else {
                    const meshes = scene.meshes;
                    for (const mesh of meshes) {
                        if (mesh.material === this && !mesh.sourceMesh) {
                            mesh.material = null;
                            this.releaseVertexArrayObject(mesh, forceDisposeEffect);
                        }
                    }
                }
            }
            this._uniformBuffer.dispose();
            // Shader are kept in cache for further use but we can get rid of this by using forceDisposeEffect
            if (forceDisposeEffect && this._drawWrapper.effect) {
                if (!this._storeEffectOnSubMeshes) {
                    this._drawWrapper.effect.dispose();
                }
                this._drawWrapper.effect = null;
            }
            this.metadata = null;
            // Callback
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
            if (this._onBindObservable) {
                this._onBindObservable.clear();
            }
            if (this._onUnBindObservable) {
                this._onUnBindObservable.clear();
            }
            if (this._onEffectCreatedObservable) {
                this._onEffectCreatedObservable.clear();
            }
            if (this._eventInfo) {
                this._eventInfo = {};
            }
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        releaseVertexArrayObject(mesh, forceDisposeEffect) {
            if (mesh.geometry) {
                const geometry = mesh.geometry;
                if (this._storeEffectOnSubMeshes) {
                    for (const subMesh of mesh.subMeshes) {
                        geometry._releaseVertexArrayObject(subMesh.effect);
                        if (forceDisposeEffect && subMesh.effect) {
                            subMesh.effect.dispose();
                        }
                    }
                }
                else {
                    geometry._releaseVertexArrayObject(this._drawWrapper.effect);
                }
            }
        }
        /**
         * Serializes this material
         * @returns the serialized material object
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this);
            serializationObject.stencil = this.stencil.serialize();
            serializationObject.uniqueId = this.uniqueId;
            this._serializePlugins(serializationObject);
            return serializationObject;
        }
        _serializePlugins(serializationObject) {
            serializationObject.plugins = {};
            if (this.pluginManager) {
                for (const plugin of this.pluginManager._plugins) {
                    serializationObject.plugins[plugin.getClassName()] = plugin.serialize();
                }
            }
        }
        /**
         * Creates a material from parsed material data
         * @param parsedMaterial defines parsed material data
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures
         * @returns a new material
         */
        static Parse(parsedMaterial, scene, rootUrl) {
            if (!parsedMaterial.customType) {
                parsedMaterial.customType = "BABYLON.StandardMaterial";
            }
            else if (parsedMaterial.customType === "BABYLON.PBRMaterial" && parsedMaterial.overloadedAlbedo) {
                parsedMaterial.customType = "BABYLON.LegacyPBRMaterial";
                if (!BABYLON.LegacyPBRMaterial) {
                    Logger.Error("Your scene is trying to load a legacy version of the PBRMaterial, please, include it from the materials library.");
                    return null;
                }
            }
            const materialType = Tools.Instantiate(parsedMaterial.customType);
            const material = materialType.Parse(parsedMaterial, scene, rootUrl);
            material._loadedUniqueId = parsedMaterial.uniqueId;
            return material;
        }
        static _parsePlugins(serializationObject, material, scene, rootUrl) {
            var _a;
            if (!serializationObject.plugins) {
                return;
            }
            for (const pluginClassName in serializationObject.plugins) {
                const pluginData = serializationObject.plugins[pluginClassName];
                let plugin = (_a = material.pluginManager) === null || _a === void 0 ? void 0 : _a.getPlugin(pluginData.name);
                if (!plugin) {
                    const pluginClassType = Tools.Instantiate("BABYLON." + pluginClassName);
                    if (pluginClassType) {
                        plugin = new pluginClassType(material);
                    }
                }
                plugin === null || plugin === void 0 ? void 0 : plugin.parse(pluginData, scene, rootUrl);
            }
        }
    }
    /**
     * Returns the triangle fill mode
     */
    Material.TriangleFillMode = 0;
    /**
     * Returns the wireframe mode
     */
    Material.WireFrameFillMode = 1;
    /**
     * Returns the point fill mode
     */
    Material.PointFillMode = 2;
    /**
     * Returns the point list draw mode
     */
    Material.PointListDrawMode = 3;
    /**
     * Returns the line list draw mode
     */
    Material.LineListDrawMode = 4;
    /**
     * Returns the line loop draw mode
     */
    Material.LineLoopDrawMode = 5;
    /**
     * Returns the line strip draw mode
     */
    Material.LineStripDrawMode = 6;
    /**
     * Returns the triangle strip draw mode
     */
    Material.TriangleStripDrawMode = 7;
    /**
     * Returns the triangle fan draw mode
     */
    Material.TriangleFanDrawMode = 8;
    /**
     * Stores the clock-wise side orientation
     */
    Material.ClockWiseSideOrientation = 0;
    /**
     * Stores the counter clock-wise side orientation
     */
    Material.CounterClockWiseSideOrientation = 1;
    /**
     * The dirty texture flag value
     */
    Material.TextureDirtyFlag = 1;
    /**
     * The dirty light flag value
     */
    Material.LightDirtyFlag = 2;
    /**
     * The dirty fresnel flag value
     */
    Material.FresnelDirtyFlag = 4;
    /**
     * The dirty attribute flag value
     */
    Material.AttributesDirtyFlag = 8;
    /**
     * The dirty misc flag value
     */
    Material.MiscDirtyFlag = 16;
    /**
     * The dirty prepass flag value
     */
    Material.PrePassDirtyFlag = 32;
    /**
     * The all dirty flag value
     */
    Material.AllDirtyFlag = 63;
    /**
     * MaterialTransparencyMode: No transparency mode, Alpha channel is not use.
     */
    Material.MATERIAL_OPAQUE = 0;
    /**
     * MaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
     */
    Material.MATERIAL_ALPHATEST = 1;
    /**
     * MaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
     */
    Material.MATERIAL_ALPHABLEND = 2;
    /**
     * MaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
     * They are also discarded below the alpha cutoff threshold to improve performances.
     */
    Material.MATERIAL_ALPHATESTANDBLEND = 3;
    /**
     * The Whiteout method is used to blend normals.
     * Details of the algorithm can be found here: https://blog.selfshadow.com/publications/blending-in-detail/
     */
    Material.MATERIAL_NORMALBLENDMETHOD_WHITEOUT = 0;
    /**
     * The Reoriented Normal Mapping method is used to blend normals.
     * Details of the algorithm can be found here: https://blog.selfshadow.com/publications/blending-in-detail/
     */
    Material.MATERIAL_NORMALBLENDMETHOD_RNM = 1;
    /**
     * Event observable which raises global events common to all materials (like MaterialPluginEvent.Created)
     */
    Material.OnEventObservable = new Observable$1();
    Material._AllDirtyCallBack = (defines) => defines.markAllAsDirty();
    Material._ImageProcessingDirtyCallBack = (defines) => defines.markAsImageProcessingDirty();
    Material._TextureDirtyCallBack = (defines) => defines.markAsTexturesDirty();
    Material._FresnelDirtyCallBack = (defines) => defines.markAsFresnelDirty();
    Material._MiscDirtyCallBack = (defines) => defines.markAsMiscDirty();
    Material._PrePassDirtyCallBack = (defines) => defines.markAsPrePassDirty();
    Material._LightsDirtyCallBack = (defines) => defines.markAsLightDirty();
    Material._AttributeDirtyCallBack = (defines) => defines.markAsAttributesDirty();
    Material._FresnelAndMiscDirtyCallBack = (defines) => {
        Material._FresnelDirtyCallBack(defines);
        Material._MiscDirtyCallBack(defines);
    };
    Material._TextureAndMiscDirtyCallBack = (defines) => {
        Material._TextureDirtyCallBack(defines);
        Material._MiscDirtyCallBack(defines);
    };
    Material._DirtyCallbackArray = [];
    Material._RunDirtyCallBacks = (defines) => {
        for (const cb of Material._DirtyCallbackArray) {
            cb(defines);
        }
    };
    __decorate$1([
        serialize()
    ], Material.prototype, "id", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "uniqueId", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "name", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "metadata", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "checkReadyOnEveryCall", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "checkReadyOnlyOnce", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "state", void 0);
    __decorate$1([
        serialize("alpha")
    ], Material.prototype, "_alpha", void 0);
    __decorate$1([
        serialize("backFaceCulling")
    ], Material.prototype, "_backFaceCulling", void 0);
    __decorate$1([
        serialize("cullBackFaces")
    ], Material.prototype, "_cullBackFaces", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "sideOrientation", void 0);
    __decorate$1([
        serialize("alphaMode")
    ], Material.prototype, "_alphaMode", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "_needDepthPrePass", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "disableDepthWrite", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "disableColorWrite", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "forceDepthWrite", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "depthFunction", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "separateCullingPass", void 0);
    __decorate$1([
        serialize("fogEnabled")
    ], Material.prototype, "_fogEnabled", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "pointSize", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "zOffset", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "zOffsetUnits", void 0);
    __decorate$1([
        serialize()
    ], Material.prototype, "pointsCloud", null);
    __decorate$1([
        serialize()
    ], Material.prototype, "fillMode", null);
    __decorate$1([
        serialize()
    ], Material.prototype, "transparencyMode", null);

    /**
     * A multi-material is used to apply different materials to different parts of the same object without the need of
     * separate meshes. This can be use to improve performances.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
     */
    class MultiMaterial extends Material {
        /**
         * Gets or Sets the list of Materials used within the multi material.
         * They need to be ordered according to the submeshes order in the associated mesh
         */
        get subMaterials() {
            return this._subMaterials;
        }
        set subMaterials(value) {
            this._subMaterials = value;
            this._hookArray(value);
        }
        /**
         * Function used to align with Node.getChildren()
         * @returns the list of Materials used within the multi material
         */
        getChildren() {
            return this.subMaterials;
        }
        /**
         * Instantiates a new Multi Material
         * A multi-material is used to apply different materials to different parts of the same object without the need of
         * separate meshes. This can be use to improve performances.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
         * @param name Define the name in the scene
         * @param scene Define the scene the material belongs to
         */
        constructor(name, scene) {
            super(name, scene, true);
            /** @internal */
            this._waitingSubMaterialsUniqueIds = [];
            this.getScene().addMultiMaterial(this);
            this.subMaterials = new Array();
            this._storeEffectOnSubMeshes = true; // multimaterial is considered like a push material
        }
        _hookArray(array) {
            const oldPush = array.push;
            array.push = (...items) => {
                const result = oldPush.apply(array, items);
                this._markAllSubMeshesAsTexturesDirty();
                return result;
            };
            const oldSplice = array.splice;
            array.splice = (index, deleteCount) => {
                const deleted = oldSplice.apply(array, [index, deleteCount]);
                this._markAllSubMeshesAsTexturesDirty();
                return deleted;
            };
        }
        /**
         * Get one of the submaterial by its index in the submaterials array
         * @param index The index to look the sub material at
         * @returns The Material if the index has been defined
         */
        getSubMaterial(index) {
            if (index < 0 || index >= this.subMaterials.length) {
                return this.getScene().defaultMaterial;
            }
            return this.subMaterials[index];
        }
        /**
         * Get the list of active textures for the whole sub materials list.
         * @returns All the textures that will be used during the rendering
         */
        getActiveTextures() {
            return super.getActiveTextures().concat(...this.subMaterials.map((subMaterial) => {
                if (subMaterial) {
                    return subMaterial.getActiveTextures();
                }
                else {
                    return [];
                }
            }));
        }
        /**
         * Specifies if any sub-materials of this multi-material use a given texture.
         * @param texture Defines the texture to check against this multi-material's sub-materials.
         * @returns A boolean specifying if any sub-material of this multi-material uses the texture.
         */
        hasTexture(texture) {
            var _a;
            if (super.hasTexture(texture)) {
                return true;
            }
            for (let i = 0; i < this.subMaterials.length; i++) {
                if ((_a = this.subMaterials[i]) === null || _a === void 0 ? void 0 : _a.hasTexture(texture)) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Gets the current class name of the material e.g. "MultiMaterial"
         * Mainly use in serialization.
         * @returns the class name
         */
        getClassName() {
            return "MultiMaterial";
        }
        /**
         * Checks if the material is ready to render the requested sub mesh
         * @param mesh Define the mesh the submesh belongs to
         * @param subMesh Define the sub mesh to look readiness for
         * @param useInstances Define whether or not the material is used with instances
         * @returns true if ready, otherwise false
         */
        isReadyForSubMesh(mesh, subMesh, useInstances) {
            for (let index = 0; index < this.subMaterials.length; index++) {
                const subMaterial = this.subMaterials[index];
                if (subMaterial) {
                    if (subMaterial._storeEffectOnSubMeshes) {
                        if (!subMaterial.isReadyForSubMesh(mesh, subMesh, useInstances)) {
                            return false;
                        }
                        continue;
                    }
                    if (!subMaterial.isReady(mesh)) {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * Clones the current material and its related sub materials
         * @param name Define the name of the newly cloned material
         * @param cloneChildren Define if submaterial will be cloned or shared with the parent instance
         * @returns the cloned material
         */
        clone(name, cloneChildren) {
            const newMultiMaterial = new MultiMaterial(name, this.getScene());
            for (let index = 0; index < this.subMaterials.length; index++) {
                let subMaterial = null;
                const current = this.subMaterials[index];
                if (cloneChildren && current) {
                    subMaterial = current.clone(name + "-" + current.name);
                }
                else {
                    subMaterial = this.subMaterials[index];
                }
                newMultiMaterial.subMaterials.push(subMaterial);
            }
            return newMultiMaterial;
        }
        /**
         * Serializes the materials into a JSON representation.
         * @returns the JSON representation
         */
        serialize() {
            const serializationObject = {};
            serializationObject.name = this.name;
            serializationObject.id = this.id;
            serializationObject.uniqueId = this.uniqueId;
            if (Tags) {
                serializationObject.tags = Tags.GetTags(this);
            }
            serializationObject.materialsUniqueIds = [];
            serializationObject.materials = [];
            for (let matIndex = 0; matIndex < this.subMaterials.length; matIndex++) {
                const subMat = this.subMaterials[matIndex];
                if (subMat) {
                    serializationObject.materialsUniqueIds.push(subMat.uniqueId);
                    serializationObject.materials.push(subMat.id);
                }
                else {
                    serializationObject.materialsUniqueIds.push(null);
                    serializationObject.materials.push(null);
                }
            }
            return serializationObject;
        }
        /**
         * Dispose the material and release its associated resources
         * @param forceDisposeEffect Define if we want to force disposing the associated effect (if false the shader is not released and could be reuse later on)
         * @param forceDisposeTextures Define if we want to force disposing the associated textures (if false, they will not be disposed and can still be use elsewhere in the app)
         * @param forceDisposeChildren Define if we want to force disposing the associated submaterials (if false, they will not be disposed and can still be use elsewhere in the app)
         */
        dispose(forceDisposeEffect, forceDisposeTextures, forceDisposeChildren) {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            if (forceDisposeChildren) {
                for (let index = 0; index < this.subMaterials.length; index++) {
                    const subMaterial = this.subMaterials[index];
                    if (subMaterial) {
                        subMaterial.dispose(forceDisposeEffect, forceDisposeTextures);
                    }
                }
            }
            const index = scene.multiMaterials.indexOf(this);
            if (index >= 0) {
                scene.multiMaterials.splice(index, 1);
            }
            super.dispose(forceDisposeEffect, forceDisposeTextures);
        }
        /**
         * Creates a MultiMaterial from parsed MultiMaterial data.
         * @param parsedMultiMaterial defines parsed MultiMaterial data.
         * @param scene defines the hosting scene
         * @returns a new MultiMaterial
         */
        static ParseMultiMaterial(parsedMultiMaterial, scene) {
            const multiMaterial = new MultiMaterial(parsedMultiMaterial.name, scene);
            multiMaterial.id = parsedMultiMaterial.id;
            multiMaterial._loadedUniqueId = parsedMultiMaterial.uniqueId;
            if (Tags) {
                Tags.AddTagsTo(multiMaterial, parsedMultiMaterial.tags);
            }
            if (parsedMultiMaterial.materialsUniqueIds) {
                multiMaterial._waitingSubMaterialsUniqueIds = parsedMultiMaterial.materialsUniqueIds;
            }
            else {
                parsedMultiMaterial.materials.forEach((subMatId) => multiMaterial.subMaterials.push(scene.getLastMaterialById(subMatId)));
            }
            return multiMaterial;
        }
    }
    RegisterClass("BABYLON.MultiMaterial", MultiMaterial);

    /**
     * Class used to represent a specific level of detail of a mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     */
    class MeshLODLevel {
        /**
         * Creates a new LOD level
         * @param distanceOrScreenCoverage defines either the distance or the screen coverage where this level should start being displayed
         * @param mesh defines the mesh to use to render this level
         */
        constructor(
        /** Either distance from the center of the object to show this level or the screen coverage if `useLODScreenCoverage` is set to `true` on the mesh*/
        distanceOrScreenCoverage, 
        /** Defines the mesh to use to render this level */
        mesh) {
            this.distanceOrScreenCoverage = distanceOrScreenCoverage;
            this.mesh = mesh;
        }
    }

    /**
     * @internal
     **/
    class _CreationDataStorage {
    }
    /**
     * @internal
     **/
    class _InstanceDataStorage {
        constructor() {
            this.visibleInstances = {};
            this.batchCache = new _InstancesBatch();
            this.batchCacheReplacementModeInFrozenMode = new _InstancesBatch();
            this.instancesBufferSize = 32 * 16 * 4; // let's start with a maximum of 32 instances
        }
    }
    /**
     * @internal
     **/
    class _InstancesBatch {
        constructor() {
            this.mustReturn = false;
            this.visibleInstances = new Array();
            this.renderSelf = new Array();
            this.hardwareInstancedRendering = new Array();
        }
    }
    /**
     * @internal
     **/
    class _ThinInstanceDataStorage {
        constructor() {
            this.instancesCount = 0;
            this.matrixBuffer = null;
            this.previousMatrixBuffer = null;
            this.matrixBufferSize = 32 * 16; // let's start with a maximum of 32 thin instances
            this.matrixData = null;
            this.boundingVectors = [];
            this.worldMatrices = null;
        }
    }
    /**
     * @internal
     **/
    class _InternalMeshDataInfo {
        constructor() {
            this._areNormalsFrozen = false; // Will be used by ribbons mainly
            // Will be used to save a source mesh reference, If any
            this._source = null;
            // Will be used to for fast cloned mesh lookup
            this.meshMap = null;
            this._preActivateId = -1;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this._LODLevels = new Array();
            /** Alternative definition of LOD level, using screen coverage instead of distance */
            this._useLODScreenCoverage = false;
            this._effectiveMaterial = null;
            this._forcedInstanceCount = 0;
            this._overrideRenderingFillMode = null;
        }
    }
    /**
     * Class used to represent renderable models
     */
    class Mesh extends AbstractMesh {
        /**
         * Gets the default side orientation.
         * @param orientation the orientation to value to attempt to get
         * @returns the default orientation
         * @internal
         */
        static _GetDefaultSideOrientation(orientation) {
            return orientation || Mesh.FRONTSIDE; // works as Mesh.FRONTSIDE is 0
        }
        /**
         * Determines if the LOD levels are intended to be calculated using screen coverage (surface area ratio) instead of distance.
         */
        get useLODScreenCoverage() {
            return this._internalMeshDataInfo._useLODScreenCoverage;
        }
        set useLODScreenCoverage(value) {
            this._internalMeshDataInfo._useLODScreenCoverage = value;
            this._sortLODLevels();
        }
        get computeBonesUsingShaders() {
            return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
        }
        set computeBonesUsingShaders(value) {
            if (this._internalAbstractMeshDataInfo._computeBonesUsingShaders === value) {
                return;
            }
            if (value && this._internalMeshDataInfo._sourcePositions) {
                // switch from software to GPU computation: we need to reset the vertex and normal buffers that have been updated by the software process
                this.setVerticesData(VertexBuffer.PositionKind, this._internalMeshDataInfo._sourcePositions, true);
                if (this._internalMeshDataInfo._sourceNormals) {
                    this.setVerticesData(VertexBuffer.NormalKind, this._internalMeshDataInfo._sourceNormals, true);
                }
                this._internalMeshDataInfo._sourcePositions = null;
                this._internalMeshDataInfo._sourceNormals = null;
            }
            this._internalAbstractMeshDataInfo._computeBonesUsingShaders = value;
            this._markSubMeshesAsAttributesDirty();
        }
        /**
         * An event triggered before rendering the mesh
         */
        get onBeforeRenderObservable() {
            if (!this._internalMeshDataInfo._onBeforeRenderObservable) {
                this._internalMeshDataInfo._onBeforeRenderObservable = new Observable$1();
            }
            return this._internalMeshDataInfo._onBeforeRenderObservable;
        }
        /**
         * An event triggered before binding the mesh
         */
        get onBeforeBindObservable() {
            if (!this._internalMeshDataInfo._onBeforeBindObservable) {
                this._internalMeshDataInfo._onBeforeBindObservable = new Observable$1();
            }
            return this._internalMeshDataInfo._onBeforeBindObservable;
        }
        /**
         * An event triggered after rendering the mesh
         */
        get onAfterRenderObservable() {
            if (!this._internalMeshDataInfo._onAfterRenderObservable) {
                this._internalMeshDataInfo._onAfterRenderObservable = new Observable$1();
            }
            return this._internalMeshDataInfo._onAfterRenderObservable;
        }
        /**
         * An event triggeredbetween rendering pass when using separateCullingPass = true
         */
        get onBetweenPassObservable() {
            if (!this._internalMeshDataInfo._onBetweenPassObservable) {
                this._internalMeshDataInfo._onBetweenPassObservable = new Observable$1();
            }
            return this._internalMeshDataInfo._onBetweenPassObservable;
        }
        /**
         * An event triggered before drawing the mesh
         */
        get onBeforeDrawObservable() {
            if (!this._internalMeshDataInfo._onBeforeDrawObservable) {
                this._internalMeshDataInfo._onBeforeDrawObservable = new Observable$1();
            }
            return this._internalMeshDataInfo._onBeforeDrawObservable;
        }
        /**
         * Sets a callback to call before drawing the mesh. It is recommended to use onBeforeDrawObservable instead
         */
        set onBeforeDraw(callback) {
            if (this._onBeforeDrawObserver) {
                this.onBeforeDrawObservable.remove(this._onBeforeDrawObserver);
            }
            this._onBeforeDrawObserver = this.onBeforeDrawObservable.add(callback);
        }
        get hasInstances() {
            return this.instances.length > 0;
        }
        get hasThinInstances() {
            var _a;
            return ((_a = this._thinInstanceDataStorage.instancesCount) !== null && _a !== void 0 ? _a : 0) > 0;
        }
        /**
         * Gets or sets the forced number of instances to display.
         * If 0 (default value), the number of instances is not forced and depends on the draw type
         * (regular / instance / thin instances mesh)
         */
        get forcedInstanceCount() {
            return this._internalMeshDataInfo._forcedInstanceCount;
        }
        set forcedInstanceCount(count) {
            this._internalMeshDataInfo._forcedInstanceCount = count;
        }
        /**
         * Use this property to override the Material's fillMode value
         */
        get overrideRenderingFillMode() {
            return this._internalMeshDataInfo._overrideRenderingFillMode;
        }
        set overrideRenderingFillMode(fillMode) {
            this._internalMeshDataInfo._overrideRenderingFillMode = fillMode;
        }
        /**
         * Gets the source mesh (the one used to clone this one from)
         */
        get source() {
            return this._internalMeshDataInfo._source;
        }
        /**
         * Gets the list of clones of this mesh
         * The scene must have been constructed with useClonedMeshMap=true for this to work!
         * Note that useClonedMeshMap=true is the default setting
         */
        get cloneMeshMap() {
            return this._internalMeshDataInfo.meshMap;
        }
        /**
         * Gets or sets a boolean indicating that this mesh does not use index buffer
         */
        get isUnIndexed() {
            return this._unIndexed;
        }
        set isUnIndexed(value) {
            if (this._unIndexed !== value) {
                this._unIndexed = value;
                this._markSubMeshesAsAttributesDirty();
            }
        }
        /** Gets the array buffer used to store the instanced buffer used for instances' world matrices */
        get worldMatrixInstancedBuffer() {
            return this._instanceDataStorage.instancesData;
        }
        /** Gets the array buffer used to store the instanced buffer used for instances' previous world matrices */
        get previousWorldMatrixInstancedBuffer() {
            return this._instanceDataStorage.instancesPreviousData;
        }
        /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */
        get manualUpdateOfWorldMatrixInstancedBuffer() {
            return this._instanceDataStorage.manualUpdate;
        }
        set manualUpdateOfWorldMatrixInstancedBuffer(value) {
            this._instanceDataStorage.manualUpdate = value;
        }
        /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */
        get manualUpdateOfPreviousWorldMatrixInstancedBuffer() {
            return this._instanceDataStorage.previousManualUpdate;
        }
        set manualUpdateOfPreviousWorldMatrixInstancedBuffer(value) {
            this._instanceDataStorage.previousManualUpdate = value;
        }
        /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices must be performed in all cases (and notably even in frozen mode) */
        get forceWorldMatrixInstancedBufferUpdate() {
            return this._instanceDataStorage.forceMatrixUpdates;
        }
        set forceWorldMatrixInstancedBufferUpdate(value) {
            this._instanceDataStorage.forceMatrixUpdates = value;
        }
        /**
         * @constructor
         * @param name The value used by scene.getMeshByName() to do a lookup.
         * @param scene The scene to add this mesh to.
         * @param parent The parent of this mesh, if it has one
         * @param source An optional Mesh from which geometry is shared, cloned.
         * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
         *                  When false, achieved by calling a clone(), also passing False.
         *                  This will make creation of children, recursive.
         * @param clonePhysicsImpostor When cloning, include cloning mesh physics impostor, default True.
         */
        constructor(name, scene = null, parent = null, source = null, doNotCloneChildren, clonePhysicsImpostor = true) {
            super(name, scene);
            // Internal data
            this._internalMeshDataInfo = new _InternalMeshDataInfo();
            // Members
            /**
             * Gets the delay loading state of the mesh (when delay loading is turned on)
             * @see https://doc.babylonjs.com/features/featuresDeepDive/importers/incrementalLoading
             */
            this.delayLoadState = 0;
            /**
             * Gets the list of instances created from this mesh
             * it is not supposed to be modified manually.
             * Note also that the order of the InstancedMesh wihin the array is not significant and might change.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
             */
            this.instances = new Array();
            // Private
            /** @internal */
            this._creationDataStorage = null;
            /** @internal */
            this._geometry = null;
            /** @internal */
            this._instanceDataStorage = new _InstanceDataStorage();
            /** @internal */
            this._thinInstanceDataStorage = new _ThinInstanceDataStorage();
            /** @internal */
            this._shouldGenerateFlatShading = false;
            // Use by builder only to know what orientation were the mesh build in.
            /** @internal */
            this._originalBuilderSideOrientation = Mesh.DEFAULTSIDE;
            /**
             * Use this property to change the original side orientation defined at construction time
             */
            this.overrideMaterialSideOrientation = null;
            /**
             * Gets or sets a boolean indicating whether to render ignoring the active camera's max z setting. (false by default)
             * You should not mix meshes that have this property set to true with meshes that have it set to false if they all write
             * to the depth buffer, because the z-values are not comparable in the two cases and you will get rendering artifacts if you do.
             * You can set the property to true for meshes that do not write to the depth buffer, or set the same value (either false or true) otherwise.
             * Note this will reduce performance when set to true.
             */
            this.ignoreCameraMaxZ = false;
            scene = this.getScene();
            this._onBeforeDraw = (isInstance, world, effectiveMaterial) => {
                if (isInstance && effectiveMaterial) {
                    if (this._uniformBuffer) {
                        this.transferToEffect(world);
                    }
                    else {
                        effectiveMaterial.bindOnlyWorldMatrix(world);
                    }
                }
            };
            if (source) {
                // Geometry
                if (source._geometry) {
                    source._geometry.applyToMesh(this);
                }
                // Deep copy
                DeepCopier.DeepCopy(source, this, [
                    "name",
                    "material",
                    "skeleton",
                    "instances",
                    "parent",
                    "uniqueId",
                    "source",
                    "metadata",
                    "morphTargetManager",
                    "hasInstances",
                    "worldMatrixInstancedBuffer",
                    "previousWorldMatrixInstancedBuffer",
                    "hasLODLevels",
                    "geometry",
                    "isBlocked",
                    "areNormalsFrozen",
                    "facetNb",
                    "isFacetDataEnabled",
                    "lightSources",
                    "useBones",
                    "isAnInstance",
                    "collider",
                    "edgesRenderer",
                    "forward",
                    "up",
                    "right",
                    "absolutePosition",
                    "absoluteScaling",
                    "absoluteRotationQuaternion",
                    "isWorldMatrixFrozen",
                    "nonUniformScaling",
                    "behaviors",
                    "worldMatrixFromCache",
                    "hasThinInstances",
                    "cloneMeshMap",
                    "hasBoundingInfo",
                    "physicsBody",
                    "physicsImpostor",
                ], ["_poseMatrix"]);
                // Source mesh
                this._internalMeshDataInfo._source = source;
                if (scene.useClonedMeshMap) {
                    if (!source._internalMeshDataInfo.meshMap) {
                        source._internalMeshDataInfo.meshMap = {};
                    }
                    source._internalMeshDataInfo.meshMap[this.uniqueId] = this;
                }
                // Construction Params
                // Clone parameters allowing mesh to be updated in case of parametric shapes.
                this._originalBuilderSideOrientation = source._originalBuilderSideOrientation;
                this._creationDataStorage = source._creationDataStorage;
                // Animation ranges
                if (source._ranges) {
                    const ranges = source._ranges;
                    for (const name in ranges) {
                        if (!Object.prototype.hasOwnProperty.call(ranges, name)) {
                            continue;
                        }
                        if (!ranges[name]) {
                            continue;
                        }
                        this.createAnimationRange(name, ranges[name].from, ranges[name].to);
                    }
                }
                // Metadata
                if (source.metadata && source.metadata.clone) {
                    this.metadata = source.metadata.clone();
                }
                else {
                    this.metadata = source.metadata;
                }
                this._internalMetadata = source._internalMetadata;
                // Tags
                if (Tags && Tags.HasTags(source)) {
                    Tags.AddTagsTo(this, Tags.GetTags(source, true));
                }
                // Enabled. We shouldn't need to check the source's ancestors, as this mesh
                // will have the same ones.
                this.setEnabled(source.isEnabled(false));
                // Parent
                this.parent = source.parent;
                // Pivot
                this.setPivotMatrix(source.getPivotMatrix());
                this.id = name + "." + source.id;
                // Material
                this.material = source.material;
                if (!doNotCloneChildren) {
                    // Children
                    const directDescendants = source.getDescendants(true);
                    for (let index = 0; index < directDescendants.length; index++) {
                        const child = directDescendants[index];
                        if (child.clone) {
                            child.clone(name + "." + child.name, this);
                        }
                    }
                }
                // Morphs
                if (source.morphTargetManager) {
                    this.morphTargetManager = source.morphTargetManager;
                }
                // Physics clone
                if (scene.getPhysicsEngine) {
                    const physicsEngine = scene.getPhysicsEngine();
                    if (clonePhysicsImpostor && physicsEngine) {
                        if (physicsEngine.getPluginVersion() === 1) {
                            const impostor = physicsEngine.getImpostorForPhysicsObject(source);
                            if (impostor) {
                                this.physicsImpostor = impostor.clone(this);
                            }
                        }
                        else if (physicsEngine.getPluginVersion() === 2) {
                            if (source.physicsBody) {
                                source.physicsBody.clone(this);
                            }
                        }
                    }
                }
                // Particles
                for (let index = 0; index < scene.particleSystems.length; index++) {
                    const system = scene.particleSystems[index];
                    if (system.emitter === source) {
                        system.clone(system.name, this);
                    }
                }
                // Skeleton
                this.skeleton = source.skeleton;
                this.refreshBoundingInfo(true, true);
                this.computeWorldMatrix(true);
            }
            // Parent
            if (parent !== null) {
                this.parent = parent;
            }
            this._instanceDataStorage.hardwareInstancedRendering = this.getEngine().getCaps().instancedArrays;
            this._internalMeshDataInfo._onMeshReadyObserverAdded = (observer) => {
                // only notify once! then unregister the observer
                observer.unregisterOnNextCall = true;
                if (this.isReady(true)) {
                    this.onMeshReadyObservable.notifyObservers(this);
                }
                else {
                    if (!this._internalMeshDataInfo._checkReadinessObserver) {
                        this._internalMeshDataInfo._checkReadinessObserver = this._scene.onBeforeRenderObservable.add(() => {
                            // check for complete readiness
                            if (this.isReady(true)) {
                                this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver);
                                this._internalMeshDataInfo._checkReadinessObserver = null;
                                this.onMeshReadyObservable.notifyObservers(this);
                            }
                        });
                    }
                }
            };
            this.onMeshReadyObservable = new Observable$1(this._internalMeshDataInfo._onMeshReadyObserverAdded);
            if (source) {
                source.onClonedObservable.notifyObservers(this);
            }
        }
        instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
            const instance = this.getTotalVertices() === 0 || (options && options.doNotInstantiate && (options.doNotInstantiate === true || options.doNotInstantiate(this)))
                ? this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true)
                : this.createInstance("instance of " + (this.name || this.id));
            instance.parent = newParent || this.parent;
            instance.position = this.position.clone();
            instance.scaling = this.scaling.clone();
            if (this.rotationQuaternion) {
                instance.rotationQuaternion = this.rotationQuaternion.clone();
            }
            else {
                instance.rotation = this.rotation.clone();
            }
            if (onNewNodeCreated) {
                onNewNodeCreated(this, instance);
            }
            for (const child of this.getChildTransformNodes(true)) {
                // instancedMesh should have a different sourced mesh
                if (child.getClassName() === "InstancedMesh" && instance.getClassName() === "Mesh" && child.sourceMesh === this) {
                    child.instantiateHierarchy(instance, {
                        doNotInstantiate: (options && options.doNotInstantiate) || false,
                        newSourcedMesh: instance,
                    }, onNewNodeCreated);
                }
                else {
                    child.instantiateHierarchy(instance, options, onNewNodeCreated);
                }
            }
            return instance;
        }
        /**
         * Gets the class name
         * @returns the string "Mesh".
         */
        getClassName() {
            return "Mesh";
        }
        /** @internal */
        get _isMesh() {
            return true;
        }
        /**
         * Returns a description of this mesh
         * @param fullDetails define if full details about this mesh must be used
         * @returns a descriptive string representing this mesh
         */
        toString(fullDetails) {
            let ret = super.toString(fullDetails);
            ret += ", n vertices: " + this.getTotalVertices();
            ret += ", parent: " + (this._waitingParentId ? this._waitingParentId : this.parent ? this.parent.name : "NONE");
            if (this.animations) {
                for (let i = 0; i < this.animations.length; i++) {
                    ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
                }
            }
            if (fullDetails) {
                if (this._geometry) {
                    const ib = this.getIndices();
                    const vb = this.getVerticesData(VertexBuffer.PositionKind);
                    if (vb && ib) {
                        ret += ", flat shading: " + (vb.length / 3 === ib.length ? "YES" : "NO");
                    }
                }
                else {
                    ret += ", flat shading: UNKNOWN";
                }
            }
            return ret;
        }
        /** @internal */
        _unBindEffect() {
            super._unBindEffect();
            for (const instance of this.instances) {
                instance._unBindEffect();
            }
        }
        /**
         * Gets a boolean indicating if this mesh has LOD
         */
        get hasLODLevels() {
            return this._internalMeshDataInfo._LODLevels.length > 0;
        }
        /**
         * Gets the list of MeshLODLevel associated with the current mesh
         * @returns an array of MeshLODLevel
         */
        getLODLevels() {
            return this._internalMeshDataInfo._LODLevels;
        }
        _sortLODLevels() {
            const sortingOrderFactor = this._internalMeshDataInfo._useLODScreenCoverage ? -1 : 1;
            this._internalMeshDataInfo._LODLevels.sort((a, b) => {
                if (a.distanceOrScreenCoverage < b.distanceOrScreenCoverage) {
                    return sortingOrderFactor;
                }
                if (a.distanceOrScreenCoverage > b.distanceOrScreenCoverage) {
                    return -sortingOrderFactor;
                }
                return 0;
            });
        }
        /**
         * Add a mesh as LOD level triggered at the given distance.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
         * @param distanceOrScreenCoverage Either distance from the center of the object to show this level or the screen coverage if `useScreenCoverage` is set to `true`.
         * If screen coverage, value is a fraction of the screen's total surface, between 0 and 1.
         * Example Playground for distance https://playground.babylonjs.com/#QE7KM#197
         * Example Playground for screen coverage https://playground.babylonjs.com/#QE7KM#196
         * @param mesh The mesh to be added as LOD level (can be null)
         * @returns This mesh (for chaining)
         */
        addLODLevel(distanceOrScreenCoverage, mesh) {
            if (mesh && mesh._masterMesh) {
                Logger.Warn("You cannot use a mesh as LOD level twice");
                return this;
            }
            const level = new MeshLODLevel(distanceOrScreenCoverage, mesh);
            this._internalMeshDataInfo._LODLevels.push(level);
            if (mesh) {
                mesh._masterMesh = this;
            }
            this._sortLODLevels();
            return this;
        }
        /**
         * Returns the LOD level mesh at the passed distance or null if not found.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
         * @param distance The distance from the center of the object to show this level
         * @returns a Mesh or `null`
         */
        getLODLevelAtDistance(distance) {
            const internalDataInfo = this._internalMeshDataInfo;
            for (let index = 0; index < internalDataInfo._LODLevels.length; index++) {
                const level = internalDataInfo._LODLevels[index];
                if (level.distanceOrScreenCoverage === distance) {
                    return level.mesh;
                }
            }
            return null;
        }
        /**
         * Remove a mesh from the LOD array
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
         * @param mesh defines the mesh to be removed
         * @returns This mesh (for chaining)
         */
        removeLODLevel(mesh) {
            const internalDataInfo = this._internalMeshDataInfo;
            for (let index = 0; index < internalDataInfo._LODLevels.length; index++) {
                if (internalDataInfo._LODLevels[index].mesh === mesh) {
                    internalDataInfo._LODLevels.splice(index, 1);
                    if (mesh) {
                        mesh._masterMesh = null;
                    }
                }
            }
            this._sortLODLevels();
            return this;
        }
        /**
         * Returns the registered LOD mesh distant from the parameter `camera` position if any, else returns the current mesh.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
         * @param camera defines the camera to use to compute distance
         * @param boundingSphere defines a custom bounding sphere to use instead of the one from this mesh
         * @returns This mesh (for chaining)
         */
        getLOD(camera, boundingSphere) {
            const internalDataInfo = this._internalMeshDataInfo;
            if (!internalDataInfo._LODLevels || internalDataInfo._LODLevels.length === 0) {
                return this;
            }
            const bSphere = boundingSphere || this.getBoundingInfo().boundingSphere;
            const distanceToCamera = camera.mode === Camera.ORTHOGRAPHIC_CAMERA ? camera.minZ : bSphere.centerWorld.subtract(camera.globalPosition).length();
            let compareValue = distanceToCamera;
            let compareSign = 1;
            if (internalDataInfo._useLODScreenCoverage) {
                const screenArea = camera.screenArea;
                let meshArea = (bSphere.radiusWorld * camera.minZ) / distanceToCamera;
                meshArea = meshArea * meshArea * Math.PI;
                compareValue = meshArea / screenArea;
                compareSign = -1;
            }
            if (compareSign * internalDataInfo._LODLevels[internalDataInfo._LODLevels.length - 1].distanceOrScreenCoverage > compareSign * compareValue) {
                if (this.onLODLevelSelection) {
                    this.onLODLevelSelection(compareValue, this, this);
                }
                return this;
            }
            for (let index = 0; index < internalDataInfo._LODLevels.length; index++) {
                const level = internalDataInfo._LODLevels[index];
                if (compareSign * level.distanceOrScreenCoverage < compareSign * compareValue) {
                    if (level.mesh) {
                        if (level.mesh.delayLoadState === 4) {
                            level.mesh._checkDelayState();
                            return this;
                        }
                        if (level.mesh.delayLoadState === 2) {
                            return this;
                        }
                        level.mesh._preActivate();
                        level.mesh._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
                    }
                    if (this.onLODLevelSelection) {
                        this.onLODLevelSelection(compareValue, this, level.mesh);
                    }
                    return level.mesh;
                }
            }
            if (this.onLODLevelSelection) {
                this.onLODLevelSelection(compareValue, this, this);
            }
            return this;
        }
        /**
         * Gets the mesh internal Geometry object
         */
        get geometry() {
            return this._geometry;
        }
        /**
         * Returns the total number of vertices within the mesh geometry or zero if the mesh has no geometry.
         * @returns the total number of vertices
         */
        getTotalVertices() {
            if (this._geometry === null || this._geometry === undefined) {
                return 0;
            }
            return this._geometry.getTotalVertices();
        }
        /**
         * Returns the content of an associated vertex buffer
         * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param copyWhenShared defines a boolean indicating that if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one
         * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
         * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
         * @returns a FloatArray or null if the mesh has no geometry or no vertex buffer for this kind.
         */
        getVerticesData(kind, copyWhenShared, forceCopy, bypassInstanceData) {
            var _a, _b;
            if (!this._geometry) {
                return null;
            }
            let data = bypassInstanceData
                ? undefined
                : (_b = (_a = this._userInstancedBuffersStorage) === null || _a === void 0 ? void 0 : _a.vertexBuffers[kind]) === null || _b === void 0 ? void 0 : _b.getFloatData(this.instances.length + 1, // +1 because the master mesh is not included in the instances array
                forceCopy || (copyWhenShared && this._geometry.meshes.length !== 1));
            if (!data) {
                data = this._geometry.getVerticesData(kind, copyWhenShared, forceCopy);
            }
            return data;
        }
        /**
         * Returns the mesh VertexBuffer object from the requested `kind`
         * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.NormalKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
         * @returns a FloatArray or null if the mesh has no vertex buffer for this kind.
         */
        getVertexBuffer(kind, bypassInstanceData) {
            var _a, _b;
            if (!this._geometry) {
                return null;
            }
            return (_b = (bypassInstanceData ? undefined : (_a = this._userInstancedBuffersStorage) === null || _a === void 0 ? void 0 : _a.vertexBuffers[kind])) !== null && _b !== void 0 ? _b : this._geometry.getVertexBuffer(kind);
        }
        /**
         * Tests if a specific vertex buffer is associated with this mesh
         * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.NormalKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
         * @returns a boolean
         */
        isVerticesDataPresent(kind, bypassInstanceData) {
            var _a;
            if (!this._geometry) {
                if (this._delayInfo) {
                    return this._delayInfo.indexOf(kind) !== -1;
                }
                return false;
            }
            return (!bypassInstanceData && ((_a = this._userInstancedBuffersStorage) === null || _a === void 0 ? void 0 : _a.vertexBuffers[kind]) !== undefined) || this._geometry.isVerticesDataPresent(kind);
        }
        /**
         * Returns a boolean defining if the vertex data for the requested `kind` is updatable.
         * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
         * @returns a boolean
         */
        isVertexBufferUpdatable(kind, bypassInstanceData) {
            var _a;
            if (!this._geometry) {
                if (this._delayInfo) {
                    return this._delayInfo.indexOf(kind) !== -1;
                }
                return false;
            }
            if (!bypassInstanceData) {
                const buffer = (_a = this._userInstancedBuffersStorage) === null || _a === void 0 ? void 0 : _a.vertexBuffers[kind];
                if (buffer) {
                    return buffer.isUpdatable();
                }
            }
            return this._geometry.isVertexBufferUpdatable(kind);
        }
        /**
         * Returns a string which contains the list of existing `kinds` of Vertex Data associated with this mesh.
         * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
         * @returns an array of strings
         */
        getVerticesDataKinds(bypassInstanceData) {
            if (!this._geometry) {
                const result = new Array();
                if (this._delayInfo) {
                    this._delayInfo.forEach(function (kind) {
                        result.push(kind);
                    });
                }
                return result;
            }
            const kinds = this._geometry.getVerticesDataKinds();
            if (!bypassInstanceData && this._userInstancedBuffersStorage) {
                for (const kind in this._userInstancedBuffersStorage.vertexBuffers) {
                    if (kinds.indexOf(kind) === -1) {
                        kinds.push(kind);
                    }
                }
            }
            return kinds;
        }
        /**
         * Returns a positive integer : the total number of indices in this mesh geometry.
         * @returns the numner of indices or zero if the mesh has no geometry.
         */
        getTotalIndices() {
            if (!this._geometry) {
                return 0;
            }
            return this._geometry.getTotalIndices();
        }
        /**
         * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
         * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
         * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
         * @returns the indices array or an empty array if the mesh has no geometry
         */
        getIndices(copyWhenShared, forceCopy) {
            if (!this._geometry) {
                return [];
            }
            return this._geometry.getIndices(copyWhenShared, forceCopy);
        }
        get isBlocked() {
            return this._masterMesh !== null && this._masterMesh !== undefined;
        }
        /**
         * Determine if the current mesh is ready to be rendered
         * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
         * @param forceInstanceSupport will check if the mesh will be ready when used with instances (false by default)
         * @returns true if all associated assets are ready (material, textures, shaders)
         */
        isReady(completeCheck = false, forceInstanceSupport = false) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (this.delayLoadState === 2) {
                return false;
            }
            if (!super.isReady(completeCheck)) {
                return false;
            }
            if (!this.subMeshes || this.subMeshes.length === 0) {
                return true;
            }
            if (!completeCheck) {
                return true;
            }
            const engine = this.getEngine();
            const scene = this.getScene();
            const hardwareInstancedRendering = forceInstanceSupport || (engine.getCaps().instancedArrays && (this.instances.length > 0 || this.hasThinInstances));
            this.computeWorldMatrix();
            const mat = this.material || scene.defaultMaterial;
            if (mat) {
                if (mat._storeEffectOnSubMeshes) {
                    for (const subMesh of this.subMeshes) {
                        const effectiveMaterial = subMesh.getMaterial();
                        if (effectiveMaterial) {
                            if (effectiveMaterial._storeEffectOnSubMeshes) {
                                if (!effectiveMaterial.isReadyForSubMesh(this, subMesh, hardwareInstancedRendering)) {
                                    return false;
                                }
                            }
                            else {
                                if (!effectiveMaterial.isReady(this, hardwareInstancedRendering)) {
                                    return false;
                                }
                            }
                        }
                    }
                }
                else {
                    if (!mat.isReady(this, hardwareInstancedRendering)) {
                        return false;
                    }
                }
            }
            // Shadows
            const currentRenderPassId = engine.currentRenderPassId;
            for (const light of this.lightSources) {
                const generators = light.getShadowGenerators();
                if (!generators) {
                    continue;
                }
                const iterator = generators.values();
                for (let key = iterator.next(); key.done !== true; key = iterator.next()) {
                    const generator = key.value;
                    if (generator && (!((_a = generator.getShadowMap()) === null || _a === void 0 ? void 0 : _a.renderList) || (((_b = generator.getShadowMap()) === null || _b === void 0 ? void 0 : _b.renderList) && ((_d = (_c = generator.getShadowMap()) === null || _c === void 0 ? void 0 : _c.renderList) === null || _d === void 0 ? void 0 : _d.indexOf(this)) !== -1))) {
                        const shadowMap = generator.getShadowMap();
                        const renderPassIds = (_e = shadowMap.renderPassIds) !== null && _e !== void 0 ? _e : [engine.currentRenderPassId];
                        for (let p = 0; p < renderPassIds.length; ++p) {
                            engine.currentRenderPassId = renderPassIds[p];
                            for (const subMesh of this.subMeshes) {
                                if (!generator.isReady(subMesh, hardwareInstancedRendering, (_g = (_f = subMesh.getMaterial()) === null || _f === void 0 ? void 0 : _f.needAlphaBlendingForMesh(this)) !== null && _g !== void 0 ? _g : false)) {
                                    engine.currentRenderPassId = currentRenderPassId;
                                    return false;
                                }
                            }
                        }
                        engine.currentRenderPassId = currentRenderPassId;
                    }
                }
            }
            // LOD
            for (const lod of this._internalMeshDataInfo._LODLevels) {
                if (lod.mesh && !lod.mesh.isReady(hardwareInstancedRendering)) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Gets a boolean indicating if the normals aren't to be recomputed on next mesh `positions` array update. This property is pertinent only for updatable parametric shapes.
         */
        get areNormalsFrozen() {
            return this._internalMeshDataInfo._areNormalsFrozen;
        }
        /**
         * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It prevents the mesh normals from being recomputed on next `positions` array update.
         * @returns the current mesh
         */
        freezeNormals() {
            this._internalMeshDataInfo._areNormalsFrozen = true;
            return this;
        }
        /**
         * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It reactivates the mesh normals computation if it was previously frozen
         * @returns the current mesh
         */
        unfreezeNormals() {
            this._internalMeshDataInfo._areNormalsFrozen = false;
            return this;
        }
        /**
         * Sets a value overriding the instance count. Only applicable when custom instanced InterleavedVertexBuffer are used rather than InstancedMeshs
         */
        set overridenInstanceCount(count) {
            this._instanceDataStorage.overridenInstanceCount = count;
        }
        // Methods
        /** @internal */
        _preActivate() {
            const internalDataInfo = this._internalMeshDataInfo;
            const sceneRenderId = this.getScene().getRenderId();
            if (internalDataInfo._preActivateId === sceneRenderId) {
                return this;
            }
            internalDataInfo._preActivateId = sceneRenderId;
            this._instanceDataStorage.visibleInstances = null;
            return this;
        }
        /**
         * @internal
         */
        _preActivateForIntermediateRendering(renderId) {
            if (this._instanceDataStorage.visibleInstances) {
                this._instanceDataStorage.visibleInstances.intermediateDefaultRenderId = renderId;
            }
            return this;
        }
        /**
         * @internal
         */
        _registerInstanceForRenderId(instance, renderId) {
            if (!this._instanceDataStorage.visibleInstances) {
                this._instanceDataStorage.visibleInstances = {
                    defaultRenderId: renderId,
                    selfDefaultRenderId: this._renderId,
                };
            }
            if (!this._instanceDataStorage.visibleInstances[renderId]) {
                if (this._instanceDataStorage.previousRenderId !== undefined && this._instanceDataStorage.isFrozen) {
                    this._instanceDataStorage.visibleInstances[this._instanceDataStorage.previousRenderId] = null;
                }
                this._instanceDataStorage.previousRenderId = renderId;
                this._instanceDataStorage.visibleInstances[renderId] = new Array();
            }
            this._instanceDataStorage.visibleInstances[renderId].push(instance);
            return this;
        }
        _afterComputeWorldMatrix() {
            super._afterComputeWorldMatrix();
            if (!this.hasThinInstances) {
                return;
            }
            if (!this.doNotSyncBoundingInfo) {
                this.thinInstanceRefreshBoundingInfo(false);
            }
        }
        /** @internal */
        _postActivate() {
            if (this.edgesShareWithInstances && this.edgesRenderer && this.edgesRenderer.isEnabled && this._renderingGroup) {
                this._renderingGroup._edgesRenderers.pushNoDuplicate(this.edgesRenderer);
                this.edgesRenderer.customInstances.push(this.getWorldMatrix());
            }
        }
        /**
         * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
         * This means the mesh underlying bounding box and sphere are recomputed.
         * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
         * @param applyMorph  defines whether to apply the morph target before computing the bounding info
         * @returns the current mesh
         */
        refreshBoundingInfo(applySkeleton = false, applyMorph = false) {
            if (this.hasBoundingInfo && this.getBoundingInfo().isLocked) {
                return this;
            }
            const bias = this.geometry ? this.geometry.boundingBias : null;
            this._refreshBoundingInfo(this._getPositionData(applySkeleton, applyMorph), bias);
            return this;
        }
        /**
         * @internal
         */
        _createGlobalSubMesh(force) {
            const totalVertices = this.getTotalVertices();
            if (!totalVertices || !this.getIndices()) {
                return null;
            }
            // Check if we need to recreate the submeshes
            if (this.subMeshes && this.subMeshes.length > 0) {
                const ib = this.getIndices();
                if (!ib) {
                    return null;
                }
                const totalIndices = ib.length;
                let needToRecreate = false;
                if (force) {
                    needToRecreate = true;
                }
                else {
                    for (const submesh of this.subMeshes) {
                        if (submesh.indexStart + submesh.indexCount > totalIndices) {
                            needToRecreate = true;
                            break;
                        }
                        if (submesh.verticesStart + submesh.verticesCount > totalVertices) {
                            needToRecreate = true;
                            break;
                        }
                    }
                }
                if (!needToRecreate) {
                    return this.subMeshes[0];
                }
            }
            this.releaseSubMeshes();
            return new SubMesh(0, 0, totalVertices, 0, this.getTotalIndices(), this);
        }
        /**
         * This function will subdivide the mesh into multiple submeshes
         * @param count defines the expected number of submeshes
         */
        subdivide(count) {
            if (count < 1) {
                return;
            }
            const totalIndices = this.getTotalIndices();
            let subdivisionSize = (totalIndices / count) | 0;
            let offset = 0;
            // Ensure that subdivisionSize is a multiple of 3
            while (subdivisionSize % 3 !== 0) {
                subdivisionSize++;
            }
            this.releaseSubMeshes();
            for (let index = 0; index < count; index++) {
                if (offset >= totalIndices) {
                    break;
                }
                SubMesh.CreateFromIndices(0, offset, index === count - 1 ? totalIndices - offset : subdivisionSize, this, undefined, false);
                offset += subdivisionSize;
            }
            this.refreshBoundingInfo();
            this.synchronizeInstances();
        }
        /**
         * Copy a FloatArray into a specific associated vertex buffer
         * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param data defines the data source
         * @param updatable defines if the updated vertex buffer must be flagged as updatable
         * @param stride defines the data stride size (can be null)
         * @returns the current mesh
         */
        setVerticesData(kind, data, updatable = false, stride) {
            if (!this._geometry) {
                const vertexData = new VertexData();
                vertexData.set(data, kind);
                const scene = this.getScene();
                new Geometry(Geometry.RandomId(), scene, vertexData, updatable, this);
            }
            else {
                this._geometry.setVerticesData(kind, data, updatable, stride);
            }
            return this;
        }
        /**
         * Delete a vertex buffer associated with this mesh
         * @param kind defines which buffer to delete (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         */
        removeVerticesData(kind) {
            if (!this._geometry) {
                return;
            }
            this._geometry.removeVerticesData(kind);
        }
        /**
         * Flags an associated vertex buffer as updatable
         * @param kind defines which buffer to use (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param updatable defines if the updated vertex buffer must be flagged as updatable
         */
        markVerticesDataAsUpdatable(kind, updatable = true) {
            const vb = this.getVertexBuffer(kind);
            if (!vb || vb.isUpdatable() === updatable) {
                return;
            }
            this.setVerticesData(kind, this.getVerticesData(kind), updatable);
        }
        /**
         * Sets the mesh global Vertex Buffer
         * @param buffer defines the buffer to use
         * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
         * @returns the current mesh
         */
        setVerticesBuffer(buffer, disposeExistingBuffer = true) {
            if (!this._geometry) {
                this._geometry = Geometry.CreateGeometryForMesh(this);
            }
            this._geometry.setVerticesBuffer(buffer, null, disposeExistingBuffer);
            return this;
        }
        /**
         * Update a specific associated vertex buffer
         * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         * @param data defines the data source
         * @param updateExtends defines if extends info of the mesh must be updated (can be null). This is mostly useful for "position" kind
         * @param makeItUnique defines if the geometry associated with the mesh must be cloned to make the change only for this mesh (and not all meshes associated with the same geometry)
         * @returns the current mesh
         */
        updateVerticesData(kind, data, updateExtends, makeItUnique) {
            if (!this._geometry) {
                return this;
            }
            if (!makeItUnique) {
                this._geometry.updateVerticesData(kind, data, updateExtends);
            }
            else {
                this.makeGeometryUnique();
                this.updateVerticesData(kind, data, updateExtends, false);
            }
            return this;
        }
        /**
         * This method updates the vertex positions of an updatable mesh according to the `positionFunction` returned values.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#other-shapes-updatemeshpositions
         * @param positionFunction is a simple JS function what is passed the mesh `positions` array. It doesn't need to return anything
         * @param computeNormals is a boolean (default true) to enable/disable the mesh normal recomputation after the vertex position update
         * @returns the current mesh
         */
        updateMeshPositions(positionFunction, computeNormals = true) {
            const positions = this.getVerticesData(VertexBuffer.PositionKind);
            if (!positions) {
                return this;
            }
            positionFunction(positions);
            this.updateVerticesData(VertexBuffer.PositionKind, positions, false, false);
            if (computeNormals) {
                const indices = this.getIndices();
                const normals = this.getVerticesData(VertexBuffer.NormalKind);
                if (!normals) {
                    return this;
                }
                VertexData.ComputeNormals(positions, indices, normals);
                this.updateVerticesData(VertexBuffer.NormalKind, normals, false, false);
            }
            return this;
        }
        /**
         * Creates a un-shared specific occurence of the geometry for the mesh.
         * @returns the current mesh
         */
        makeGeometryUnique() {
            if (!this._geometry) {
                return this;
            }
            if (this._geometry.meshes.length === 1) {
                return this;
            }
            const oldGeometry = this._geometry;
            const geometry = this._geometry.copy(Geometry.RandomId());
            oldGeometry.releaseForMesh(this, true);
            geometry.applyToMesh(this);
            return this;
        }
        /**
         * Set the index buffer of this mesh
         * @param indices defines the source data
         * @param totalVertices defines the total number of vertices referenced by this index data (can be null)
         * @param updatable defines if the updated index buffer must be flagged as updatable (default is false)
         * @returns the current mesh
         */
        setIndices(indices, totalVertices = null, updatable = false) {
            if (!this._geometry) {
                const vertexData = new VertexData();
                vertexData.indices = indices;
                const scene = this.getScene();
                new Geometry(Geometry.RandomId(), scene, vertexData, updatable, this);
            }
            else {
                this._geometry.setIndices(indices, totalVertices, updatable);
            }
            return this;
        }
        /**
         * Update the current index buffer
         * @param indices defines the source data
         * @param offset defines the offset in the index buffer where to store the new data (can be null)
         * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
         * @returns the current mesh
         */
        updateIndices(indices, offset, gpuMemoryOnly = false) {
            if (!this._geometry) {
                return this;
            }
            this._geometry.updateIndices(indices, offset, gpuMemoryOnly);
            return this;
        }
        /**
         * Invert the geometry to move from a right handed system to a left handed one.
         * @returns the current mesh
         */
        toLeftHanded() {
            if (!this._geometry) {
                return this;
            }
            this._geometry.toLeftHanded();
            return this;
        }
        /**
         * @internal
         */
        _bind(subMesh, effect, fillMode, allowInstancedRendering = true) {
            if (!this._geometry) {
                return this;
            }
            const engine = this.getScene().getEngine();
            // Morph targets
            if (this.morphTargetManager && this.morphTargetManager.isUsingTextureForTargets) {
                this.morphTargetManager._bind(effect);
            }
            // Wireframe
            let indexToBind;
            if (this._unIndexed) {
                indexToBind = null;
            }
            else {
                switch (this._getRenderingFillMode(fillMode)) {
                    case Material.PointFillMode:
                        indexToBind = null;
                        break;
                    case Material.WireFrameFillMode:
                        indexToBind = subMesh._getLinesIndexBuffer(this.getIndices(), engine);
                        break;
                    default:
                    case Material.TriangleFillMode:
                        indexToBind = this._geometry.getIndexBuffer();
                        break;
                }
            }
            // VBOs
            if (!allowInstancedRendering || !this._userInstancedBuffersStorage || this.hasThinInstances) {
                this._geometry._bind(effect, indexToBind);
            }
            else {
                this._geometry._bind(effect, indexToBind, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects);
            }
            return this;
        }
        /**
         * @internal
         */
        _draw(subMesh, fillMode, instancesCount) {
            if (!this._geometry || !this._geometry.getVertexBuffers() || (!this._unIndexed && !this._geometry.getIndexBuffer())) {
                return this;
            }
            if (this._internalMeshDataInfo._onBeforeDrawObservable) {
                this._internalMeshDataInfo._onBeforeDrawObservable.notifyObservers(this);
            }
            const scene = this.getScene();
            const engine = scene.getEngine();
            if (this._unIndexed || fillMode == Material.PointFillMode) {
                // or triangles as points
                engine.drawArraysType(fillMode, subMesh.verticesStart, subMesh.verticesCount, this.forcedInstanceCount || instancesCount);
            }
            else if (fillMode == Material.WireFrameFillMode) {
                // Triangles as wireframe
                engine.drawElementsType(fillMode, 0, subMesh._linesIndexCount, this.forcedInstanceCount || instancesCount);
            }
            else {
                engine.drawElementsType(fillMode, subMesh.indexStart, subMesh.indexCount, this.forcedInstanceCount || instancesCount);
            }
            return this;
        }
        /**
         * Registers for this mesh a javascript function called just before the rendering process
         * @param func defines the function to call before rendering this mesh
         * @returns the current mesh
         */
        registerBeforeRender(func) {
            this.onBeforeRenderObservable.add(func);
            return this;
        }
        /**
         * Disposes a previously registered javascript function called before the rendering
         * @param func defines the function to remove
         * @returns the current mesh
         */
        unregisterBeforeRender(func) {
            this.onBeforeRenderObservable.removeCallback(func);
            return this;
        }
        /**
         * Registers for this mesh a javascript function called just after the rendering is complete
         * @param func defines the function to call after rendering this mesh
         * @returns the current mesh
         */
        registerAfterRender(func) {
            this.onAfterRenderObservable.add(func);
            return this;
        }
        /**
         * Disposes a previously registered javascript function called after the rendering.
         * @param func defines the function to remove
         * @returns the current mesh
         */
        unregisterAfterRender(func) {
            this.onAfterRenderObservable.removeCallback(func);
            return this;
        }
        /**
         * @internal
         */
        _getInstancesRenderList(subMeshId, isReplacementMode = false) {
            if (this._instanceDataStorage.isFrozen) {
                if (isReplacementMode) {
                    this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.hardwareInstancedRendering[subMeshId] = false;
                    this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.renderSelf[subMeshId] = true;
                    return this._instanceDataStorage.batchCacheReplacementModeInFrozenMode;
                }
                if (this._instanceDataStorage.previousBatch) {
                    return this._instanceDataStorage.previousBatch;
                }
            }
            const scene = this.getScene();
            const isInIntermediateRendering = scene._isInIntermediateRendering();
            const onlyForInstances = isInIntermediateRendering
                ? this._internalAbstractMeshDataInfo._onlyForInstancesIntermediate
                : this._internalAbstractMeshDataInfo._onlyForInstances;
            const batchCache = this._instanceDataStorage.batchCache;
            batchCache.mustReturn = false;
            batchCache.renderSelf[subMeshId] = isReplacementMode || (!onlyForInstances && this.isEnabled() && this.isVisible);
            batchCache.visibleInstances[subMeshId] = null;
            if (this._instanceDataStorage.visibleInstances && !isReplacementMode) {
                const visibleInstances = this._instanceDataStorage.visibleInstances;
                const currentRenderId = scene.getRenderId();
                const defaultRenderId = isInIntermediateRendering ? visibleInstances.intermediateDefaultRenderId : visibleInstances.defaultRenderId;
                batchCache.visibleInstances[subMeshId] = visibleInstances[currentRenderId];
                if (!batchCache.visibleInstances[subMeshId] && defaultRenderId) {
                    batchCache.visibleInstances[subMeshId] = visibleInstances[defaultRenderId];
                }
            }
            batchCache.hardwareInstancedRendering[subMeshId] =
                !isReplacementMode &&
                    this._instanceDataStorage.hardwareInstancedRendering &&
                    batchCache.visibleInstances[subMeshId] !== null &&
                    batchCache.visibleInstances[subMeshId] !== undefined;
            this._instanceDataStorage.previousBatch = batchCache;
            return batchCache;
        }
        /**
         * @internal
         */
        _renderWithInstances(subMesh, fillMode, batch, effect, engine) {
            var _a;
            const visibleInstances = batch.visibleInstances[subMesh._id];
            const visibleInstanceCount = visibleInstances ? visibleInstances.length : 0;
            const instanceStorage = this._instanceDataStorage;
            const currentInstancesBufferSize = instanceStorage.instancesBufferSize;
            let instancesBuffer = instanceStorage.instancesBuffer;
            let instancesPreviousBuffer = instanceStorage.instancesPreviousBuffer;
            const matricesCount = visibleInstanceCount + 1;
            const bufferSize = matricesCount * 16 * 4;
            while (instanceStorage.instancesBufferSize < bufferSize) {
                instanceStorage.instancesBufferSize *= 2;
            }
            if (!instanceStorage.instancesData || currentInstancesBufferSize != instanceStorage.instancesBufferSize) {
                instanceStorage.instancesData = new Float32Array(instanceStorage.instancesBufferSize / 4);
            }
            if ((this._scene.needsPreviousWorldMatrices && !instanceStorage.instancesPreviousData) || currentInstancesBufferSize != instanceStorage.instancesBufferSize) {
                instanceStorage.instancesPreviousData = new Float32Array(instanceStorage.instancesBufferSize / 4);
            }
            let offset = 0;
            let instancesCount = 0;
            const renderSelf = batch.renderSelf[subMesh._id];
            const needUpdateBuffer = !instancesBuffer ||
                currentInstancesBufferSize !== instanceStorage.instancesBufferSize ||
                (this._scene.needsPreviousWorldMatrices && !instanceStorage.instancesPreviousBuffer);
            if (!this._instanceDataStorage.manualUpdate && (!instanceStorage.isFrozen || needUpdateBuffer)) {
                const world = this.getWorldMatrix();
                if (renderSelf) {
                    if (this._scene.needsPreviousWorldMatrices) {
                        if (!instanceStorage.masterMeshPreviousWorldMatrix) {
                            instanceStorage.masterMeshPreviousWorldMatrix = world.clone();
                            instanceStorage.masterMeshPreviousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                        }
                        else {
                            instanceStorage.masterMeshPreviousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                            instanceStorage.masterMeshPreviousWorldMatrix.copyFrom(world);
                        }
                    }
                    world.copyToArray(instanceStorage.instancesData, offset);
                    offset += 16;
                    instancesCount++;
                }
                if (visibleInstances) {
                    if (Mesh.INSTANCEDMESH_SORT_TRANSPARENT && this._scene.activeCamera && ((_a = subMesh.getMaterial()) === null || _a === void 0 ? void 0 : _a.needAlphaBlendingForMesh(subMesh.getRenderingMesh()))) {
                        const cameraPosition = this._scene.activeCamera.globalPosition;
                        for (let instanceIndex = 0; instanceIndex < visibleInstances.length; instanceIndex++) {
                            const instanceMesh = visibleInstances[instanceIndex];
                            instanceMesh._distanceToCamera = Vector3.Distance(instanceMesh.getBoundingInfo().boundingSphere.centerWorld, cameraPosition);
                        }
                        visibleInstances.sort((m1, m2) => {
                            return m1._distanceToCamera > m2._distanceToCamera ? -1 : m1._distanceToCamera < m2._distanceToCamera ? 1 : 0;
                        });
                    }
                    for (let instanceIndex = 0; instanceIndex < visibleInstances.length; instanceIndex++) {
                        const instance = visibleInstances[instanceIndex];
                        const matrix = instance.getWorldMatrix();
                        matrix.copyToArray(instanceStorage.instancesData, offset);
                        if (this._scene.needsPreviousWorldMatrices) {
                            if (!instance._previousWorldMatrix) {
                                instance._previousWorldMatrix = matrix.clone();
                                instance._previousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                            }
                            else {
                                instance._previousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                                instance._previousWorldMatrix.copyFrom(matrix);
                            }
                        }
                        offset += 16;
                        instancesCount++;
                    }
                }
            }
            else {
                instancesCount = (renderSelf ? 1 : 0) + visibleInstanceCount;
            }
            if (needUpdateBuffer) {
                if (instancesBuffer) {
                    instancesBuffer.dispose();
                }
                if (instancesPreviousBuffer) {
                    instancesPreviousBuffer.dispose();
                }
                instancesBuffer = new Buffer$1(engine, instanceStorage.instancesData, true, 16, false, true);
                instanceStorage.instancesBuffer = instancesBuffer;
                if (!this._userInstancedBuffersStorage) {
                    this._userInstancedBuffersStorage = {
                        data: {},
                        vertexBuffers: {},
                        strides: {},
                        sizes: {},
                        vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : undefined,
                    };
                }
                this._userInstancedBuffersStorage.vertexBuffers["world0"] = instancesBuffer.createVertexBuffer("world0", 0, 4);
                this._userInstancedBuffersStorage.vertexBuffers["world1"] = instancesBuffer.createVertexBuffer("world1", 4, 4);
                this._userInstancedBuffersStorage.vertexBuffers["world2"] = instancesBuffer.createVertexBuffer("world2", 8, 4);
                this._userInstancedBuffersStorage.vertexBuffers["world3"] = instancesBuffer.createVertexBuffer("world3", 12, 4);
                if (this._scene.needsPreviousWorldMatrices) {
                    instancesPreviousBuffer = new Buffer$1(engine, instanceStorage.instancesPreviousData, true, 16, false, true);
                    instanceStorage.instancesPreviousBuffer = instancesPreviousBuffer;
                    this._userInstancedBuffersStorage.vertexBuffers["previousWorld0"] = instancesPreviousBuffer.createVertexBuffer("previousWorld0", 0, 4);
                    this._userInstancedBuffersStorage.vertexBuffers["previousWorld1"] = instancesPreviousBuffer.createVertexBuffer("previousWorld1", 4, 4);
                    this._userInstancedBuffersStorage.vertexBuffers["previousWorld2"] = instancesPreviousBuffer.createVertexBuffer("previousWorld2", 8, 4);
                    this._userInstancedBuffersStorage.vertexBuffers["previousWorld3"] = instancesPreviousBuffer.createVertexBuffer("previousWorld3", 12, 4);
                }
                this._invalidateInstanceVertexArrayObject();
            }
            else {
                if (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) {
                    instancesBuffer.updateDirectly(instanceStorage.instancesData, 0, instancesCount);
                    if (this._scene.needsPreviousWorldMatrices && (!this._instanceDataStorage.manualUpdate || this._instanceDataStorage.previousManualUpdate)) {
                        instancesPreviousBuffer.updateDirectly(instanceStorage.instancesPreviousData, 0, instancesCount);
                    }
                }
            }
            this._processInstancedBuffers(visibleInstances, renderSelf);
            // Stats
            this.getScene()._activeIndices.addCount(subMesh.indexCount * instancesCount, false);
            // Draw
            if (engine._currentDrawContext) {
                engine._currentDrawContext.useInstancing = true;
            }
            this._bind(subMesh, effect, fillMode);
            this._draw(subMesh, fillMode, instancesCount);
            // Write current matrices as previous matrices in case of manual update
            // Default behaviour when previous matrices are not specified explicitly
            // Will break if instances number/order changes
            if (this._scene.needsPreviousWorldMatrices &&
                !needUpdateBuffer &&
                this._instanceDataStorage.manualUpdate &&
                (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) &&
                !this._instanceDataStorage.previousManualUpdate) {
                instancesPreviousBuffer.updateDirectly(instanceStorage.instancesData, 0, instancesCount);
            }
            engine.unbindInstanceAttributes();
            return this;
        }
        /**
         * @internal
         */
        _renderWithThinInstances(subMesh, fillMode, effect, engine) {
            var _a, _b;
            // Stats
            const instancesCount = (_b = (_a = this._thinInstanceDataStorage) === null || _a === void 0 ? void 0 : _a.instancesCount) !== null && _b !== void 0 ? _b : 0;
            this.getScene()._activeIndices.addCount(subMesh.indexCount * instancesCount, false);
            // Draw
            if (engine._currentDrawContext) {
                engine._currentDrawContext.useInstancing = true;
            }
            this._bind(subMesh, effect, fillMode);
            this._draw(subMesh, fillMode, instancesCount);
            // Write current matrices as previous matrices
            // Default behaviour when previous matrices are not specified explicitly
            // Will break if instances number/order changes
            if (this._scene.needsPreviousWorldMatrices && !this._thinInstanceDataStorage.previousMatrixData && this._thinInstanceDataStorage.matrixData) {
                if (!this._thinInstanceDataStorage.previousMatrixBuffer) {
                    this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", this._thinInstanceDataStorage.matrixData, false);
                }
                else {
                    this._thinInstanceDataStorage.previousMatrixBuffer.updateDirectly(this._thinInstanceDataStorage.matrixData, 0, instancesCount);
                }
            }
            engine.unbindInstanceAttributes();
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _processInstancedBuffers(visibleInstances, renderSelf) {
            // Do nothing
        }
        /**
         * @internal
         */
        _processRendering(renderingMesh, subMesh, effect, fillMode, batch, hardwareInstancedRendering, onBeforeDraw, effectiveMaterial) {
            const scene = this.getScene();
            const engine = scene.getEngine();
            fillMode = this._getRenderingFillMode(fillMode);
            if (hardwareInstancedRendering && subMesh.getRenderingMesh().hasThinInstances) {
                this._renderWithThinInstances(subMesh, fillMode, effect, engine);
                return this;
            }
            if (hardwareInstancedRendering) {
                this._renderWithInstances(subMesh, fillMode, batch, effect, engine);
            }
            else {
                if (engine._currentDrawContext) {
                    engine._currentDrawContext.useInstancing = false;
                }
                let instanceCount = 0;
                if (batch.renderSelf[subMesh._id]) {
                    // Draw
                    if (onBeforeDraw) {
                        onBeforeDraw(false, renderingMesh.getWorldMatrix(), effectiveMaterial);
                    }
                    instanceCount++;
                    this._draw(subMesh, fillMode, this._instanceDataStorage.overridenInstanceCount);
                }
                const visibleInstancesForSubMesh = batch.visibleInstances[subMesh._id];
                if (visibleInstancesForSubMesh) {
                    const visibleInstanceCount = visibleInstancesForSubMesh.length;
                    instanceCount += visibleInstanceCount;
                    // Stats
                    for (let instanceIndex = 0; instanceIndex < visibleInstanceCount; instanceIndex++) {
                        const instance = visibleInstancesForSubMesh[instanceIndex];
                        // World
                        const world = instance.getWorldMatrix();
                        if (onBeforeDraw) {
                            onBeforeDraw(true, world, effectiveMaterial);
                        }
                        // Draw
                        this._draw(subMesh, fillMode);
                    }
                }
                // Stats
                scene._activeIndices.addCount(subMesh.indexCount * instanceCount, false);
            }
            return this;
        }
        /**
         * @internal
         */
        _rebuild(dispose = false) {
            if (this._instanceDataStorage.instancesBuffer) {
                // Dispose instance buffer to be recreated in _renderWithInstances when rendered
                if (dispose) {
                    this._instanceDataStorage.instancesBuffer.dispose();
                }
                this._instanceDataStorage.instancesBuffer = null;
            }
            if (this._userInstancedBuffersStorage) {
                for (const kind in this._userInstancedBuffersStorage.vertexBuffers) {
                    const buffer = this._userInstancedBuffersStorage.vertexBuffers[kind];
                    if (buffer) {
                        // Dispose instance buffer to be recreated in _renderWithInstances when rendered
                        if (dispose) {
                            buffer.dispose();
                        }
                        this._userInstancedBuffersStorage.vertexBuffers[kind] = null;
                    }
                }
                if (this._userInstancedBuffersStorage.vertexArrayObjects) {
                    this._userInstancedBuffersStorage.vertexArrayObjects = {};
                }
            }
            this._internalMeshDataInfo._effectiveMaterial = null;
            super._rebuild(dispose);
        }
        /** @internal */
        _freeze() {
            if (!this.subMeshes) {
                return;
            }
            // Prepare batches
            for (let index = 0; index < this.subMeshes.length; index++) {
                this._getInstancesRenderList(index);
            }
            this._internalMeshDataInfo._effectiveMaterial = null;
            this._instanceDataStorage.isFrozen = true;
        }
        /** @internal */
        _unFreeze() {
            this._instanceDataStorage.isFrozen = false;
            this._instanceDataStorage.previousBatch = null;
        }
        /**
         * Triggers the draw call for the mesh. Usually, you don't need to call this method by your own because the mesh rendering is handled by the scene rendering manager
         * @param subMesh defines the subMesh to render
         * @param enableAlphaMode defines if alpha mode can be changed
         * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering
         * @returns the current mesh
         */
        render(subMesh, enableAlphaMode, effectiveMeshReplacement) {
            var _a, _b, _c;
            const scene = this.getScene();
            if (this._internalAbstractMeshDataInfo._isActiveIntermediate) {
                this._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            }
            else {
                this._internalAbstractMeshDataInfo._isActive = false;
            }
            if (this._checkOcclusionQuery() && !this._occlusionDataStorage.forceRenderingWhenOccluded) {
                return this;
            }
            // Managing instances
            const batch = this._getInstancesRenderList(subMesh._id, !!effectiveMeshReplacement);
            if (batch.mustReturn) {
                return this;
            }
            // Checking geometry state
            if (!this._geometry || !this._geometry.getVertexBuffers() || (!this._unIndexed && !this._geometry.getIndexBuffer())) {
                return this;
            }
            const engine = scene.getEngine();
            let oldCameraMaxZ = 0;
            let oldCamera = null;
            if (this.ignoreCameraMaxZ && scene.activeCamera && !scene._isInIntermediateRendering()) {
                oldCameraMaxZ = scene.activeCamera.maxZ;
                oldCamera = scene.activeCamera;
                scene.activeCamera.maxZ = 0;
                scene.updateTransformMatrix(true);
            }
            if (this._internalMeshDataInfo._onBeforeRenderObservable) {
                this._internalMeshDataInfo._onBeforeRenderObservable.notifyObservers(this);
            }
            const renderingMesh = subMesh.getRenderingMesh();
            const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] ||
                renderingMesh.hasThinInstances ||
                (!!this._userInstancedBuffersStorage && !subMesh.getMesh()._internalAbstractMeshDataInfo._actAsRegularMesh);
            const instanceDataStorage = this._instanceDataStorage;
            const material = subMesh.getMaterial();
            if (!material) {
                if (oldCamera) {
                    oldCamera.maxZ = oldCameraMaxZ;
                    scene.updateTransformMatrix(true);
                }
                return this;
            }
            // Material
            if (!instanceDataStorage.isFrozen || !this._internalMeshDataInfo._effectiveMaterial || this._internalMeshDataInfo._effectiveMaterial !== material) {
                if (material._storeEffectOnSubMeshes) {
                    if (!material.isReadyForSubMesh(this, subMesh, hardwareInstancedRendering)) {
                        if (oldCamera) {
                            oldCamera.maxZ = oldCameraMaxZ;
                            scene.updateTransformMatrix(true);
                        }
                        return this;
                    }
                }
                else if (!material.isReady(this, hardwareInstancedRendering)) {
                    if (oldCamera) {
                        oldCamera.maxZ = oldCameraMaxZ;
                        scene.updateTransformMatrix(true);
                    }
                    return this;
                }
                this._internalMeshDataInfo._effectiveMaterial = material;
            }
            else if ((material._storeEffectOnSubMeshes && !((_a = subMesh.effect) === null || _a === void 0 ? void 0 : _a._wasPreviouslyReady)) ||
                (!material._storeEffectOnSubMeshes && !((_b = material.getEffect()) === null || _b === void 0 ? void 0 : _b._wasPreviouslyReady))) {
                if (oldCamera) {
                    oldCamera.maxZ = oldCameraMaxZ;
                    scene.updateTransformMatrix(true);
                }
                return this;
            }
            // Alpha mode
            if (enableAlphaMode) {
                engine.setAlphaMode(this._internalMeshDataInfo._effectiveMaterial.alphaMode);
            }
            let drawWrapper;
            if (this._internalMeshDataInfo._effectiveMaterial._storeEffectOnSubMeshes) {
                drawWrapper = subMesh._drawWrapper;
            }
            else {
                drawWrapper = this._internalMeshDataInfo._effectiveMaterial._getDrawWrapper();
            }
            const effect = (_c = drawWrapper === null || drawWrapper === void 0 ? void 0 : drawWrapper.effect) !== null && _c !== void 0 ? _c : null;
            for (const step of scene._beforeRenderingMeshStage) {
                step.action(this, subMesh, batch, effect);
            }
            if (!drawWrapper || !effect) {
                if (oldCamera) {
                    oldCamera.maxZ = oldCameraMaxZ;
                    scene.updateTransformMatrix(true);
                }
                return this;
            }
            const effectiveMesh = effectiveMeshReplacement || this;
            let sideOrientation;
            if (!instanceDataStorage.isFrozen && (this._internalMeshDataInfo._effectiveMaterial.backFaceCulling || this.overrideMaterialSideOrientation !== null)) {
                const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
                sideOrientation = this.overrideMaterialSideOrientation;
                if (sideOrientation == null) {
                    sideOrientation = this._internalMeshDataInfo._effectiveMaterial.sideOrientation;
                }
                if (mainDeterminant < 0) {
                    sideOrientation = sideOrientation === Material.ClockWiseSideOrientation ? Material.CounterClockWiseSideOrientation : Material.ClockWiseSideOrientation;
                }
                instanceDataStorage.sideOrientation = sideOrientation;
            }
            else {
                sideOrientation = instanceDataStorage.sideOrientation;
            }
            const reverse = this._internalMeshDataInfo._effectiveMaterial._preBind(drawWrapper, sideOrientation);
            if (this._internalMeshDataInfo._effectiveMaterial.forceDepthWrite) {
                engine.setDepthWrite(true);
            }
            // Bind
            const effectiveMaterial = this._internalMeshDataInfo._effectiveMaterial;
            const fillMode = effectiveMaterial.fillMode;
            if (this._internalMeshDataInfo._onBeforeBindObservable) {
                this._internalMeshDataInfo._onBeforeBindObservable.notifyObservers(this);
            }
            if (!hardwareInstancedRendering) {
                // Binding will be done later because we need to add more info to the VB
                this._bind(subMesh, effect, fillMode, false);
            }
            const world = effectiveMesh.getWorldMatrix();
            if (effectiveMaterial._storeEffectOnSubMeshes) {
                effectiveMaterial.bindForSubMesh(world, this, subMesh);
            }
            else {
                effectiveMaterial.bind(world, this);
            }
            if (!effectiveMaterial.backFaceCulling && effectiveMaterial.separateCullingPass) {
                engine.setState(true, effectiveMaterial.zOffset, false, !reverse, effectiveMaterial.cullBackFaces, effectiveMaterial.stencil, effectiveMaterial.zOffsetUnits);
                this._processRendering(this, subMesh, effect, fillMode, batch, hardwareInstancedRendering, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial);
                engine.setState(true, effectiveMaterial.zOffset, false, reverse, effectiveMaterial.cullBackFaces, effectiveMaterial.stencil, effectiveMaterial.zOffsetUnits);
                if (this._internalMeshDataInfo._onBetweenPassObservable) {
                    this._internalMeshDataInfo._onBetweenPassObservable.notifyObservers(subMesh);
                }
            }
            // Draw
            this._processRendering(this, subMesh, effect, fillMode, batch, hardwareInstancedRendering, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial);
            // Unbind
            this._internalMeshDataInfo._effectiveMaterial.unbind();
            for (const step of scene._afterRenderingMeshStage) {
                step.action(this, subMesh, batch, effect);
            }
            if (this._internalMeshDataInfo._onAfterRenderObservable) {
                this._internalMeshDataInfo._onAfterRenderObservable.notifyObservers(this);
            }
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            if (scene.performancePriority === ScenePerformancePriority.Aggressive && !instanceDataStorage.isFrozen) {
                this._freeze();
            }
            return this;
        }
        /**
         *   Renormalize the mesh and patch it up if there are no weights
         *   Similar to normalization by adding the weights compute the reciprocal and multiply all elements, this wil ensure that everything adds to 1.
         *   However in the case of zero weights then we set just a single influence to 1.
         *   We check in the function for extra's present and if so we use the normalizeSkinWeightsWithExtras rather than the FourWeights version.
         */
        cleanMatrixWeights() {
            if (this.isVerticesDataPresent(VertexBuffer.MatricesWeightsKind)) {
                if (this.isVerticesDataPresent(VertexBuffer.MatricesWeightsExtraKind)) {
                    this._normalizeSkinWeightsAndExtra();
                }
                else {
                    this._normalizeSkinFourWeights();
                }
            }
        }
        // faster 4 weight version.
        _normalizeSkinFourWeights() {
            const matricesWeights = this.getVerticesData(VertexBuffer.MatricesWeightsKind);
            const numWeights = matricesWeights.length;
            for (let a = 0; a < numWeights; a += 4) {
                // accumulate weights
                const t = matricesWeights[a] + matricesWeights[a + 1] + matricesWeights[a + 2] + matricesWeights[a + 3];
                // check for invalid weight and just set it to 1.
                if (t === 0) {
                    matricesWeights[a] = 1;
                }
                else {
                    // renormalize so everything adds to 1 use reciprocal
                    const recip = 1 / t;
                    matricesWeights[a] *= recip;
                    matricesWeights[a + 1] *= recip;
                    matricesWeights[a + 2] *= recip;
                    matricesWeights[a + 3] *= recip;
                }
            }
            this.setVerticesData(VertexBuffer.MatricesWeightsKind, matricesWeights);
        }
        // handle special case of extra verts.  (in theory gltf can handle 12 influences)
        _normalizeSkinWeightsAndExtra() {
            const matricesWeightsExtra = this.getVerticesData(VertexBuffer.MatricesWeightsExtraKind);
            const matricesWeights = this.getVerticesData(VertexBuffer.MatricesWeightsKind);
            const numWeights = matricesWeights.length;
            for (let a = 0; a < numWeights; a += 4) {
                // accumulate weights
                let t = matricesWeights[a] + matricesWeights[a + 1] + matricesWeights[a + 2] + matricesWeights[a + 3];
                t += matricesWeightsExtra[a] + matricesWeightsExtra[a + 1] + matricesWeightsExtra[a + 2] + matricesWeightsExtra[a + 3];
                // check for invalid weight and just set it to 1.
                if (t === 0) {
                    matricesWeights[a] = 1;
                }
                else {
                    // renormalize so everything adds to 1 use reciprocal
                    const recip = 1 / t;
                    matricesWeights[a] *= recip;
                    matricesWeights[a + 1] *= recip;
                    matricesWeights[a + 2] *= recip;
                    matricesWeights[a + 3] *= recip;
                    // same goes for extras
                    matricesWeightsExtra[a] *= recip;
                    matricesWeightsExtra[a + 1] *= recip;
                    matricesWeightsExtra[a + 2] *= recip;
                    matricesWeightsExtra[a + 3] *= recip;
                }
            }
            this.setVerticesData(VertexBuffer.MatricesWeightsKind, matricesWeights);
            this.setVerticesData(VertexBuffer.MatricesWeightsKind, matricesWeightsExtra);
        }
        /**
         * ValidateSkinning is used to determine that a mesh has valid skinning data along with skin metrics, if missing weights,
         * or not normalized it is returned as invalid mesh the string can be used for console logs, or on screen messages to let
         * the user know there was an issue with importing the mesh
         * @returns a validation object with skinned, valid and report string
         */
        validateSkinning() {
            const matricesWeightsExtra = this.getVerticesData(VertexBuffer.MatricesWeightsExtraKind);
            const matricesWeights = this.getVerticesData(VertexBuffer.MatricesWeightsKind);
            if (matricesWeights === null || this.skeleton == null) {
                return { skinned: false, valid: true, report: "not skinned" };
            }
            const numWeights = matricesWeights.length;
            let numberNotSorted = 0;
            let missingWeights = 0;
            let maxUsedWeights = 0;
            let numberNotNormalized = 0;
            const numInfluences = matricesWeightsExtra === null ? 4 : 8;
            const usedWeightCounts = new Array();
            for (let a = 0; a <= numInfluences; a++) {
                usedWeightCounts[a] = 0;
            }
            const toleranceEpsilon = 0.001;
            for (let a = 0; a < numWeights; a += 4) {
                let lastWeight = matricesWeights[a];
                let t = lastWeight;
                let usedWeights = t === 0 ? 0 : 1;
                for (let b = 1; b < numInfluences; b++) {
                    const d = b < 4 ? matricesWeights[a + b] : matricesWeightsExtra[a + b - 4];
                    if (d > lastWeight) {
                        numberNotSorted++;
                    }
                    if (d !== 0) {
                        usedWeights++;
                    }
                    t += d;
                    lastWeight = d;
                }
                // count the buffer weights usage
                usedWeightCounts[usedWeights]++;
                // max influences
                if (usedWeights > maxUsedWeights) {
                    maxUsedWeights = usedWeights;
                }
                // check for invalid weight and just set it to 1.
                if (t === 0) {
                    missingWeights++;
                }
                else {
                    // renormalize so everything adds to 1 use reciprocal
                    const recip = 1 / t;
                    let tolerance = 0;
                    for (let b = 0; b < numInfluences; b++) {
                        if (b < 4) {
                            tolerance += Math.abs(matricesWeights[a + b] - matricesWeights[a + b] * recip);
                        }
                        else {
                            tolerance += Math.abs(matricesWeightsExtra[a + b - 4] - matricesWeightsExtra[a + b - 4] * recip);
                        }
                    }
                    // arbitrary epsilon value for dictating not normalized
                    if (tolerance > toleranceEpsilon) {
                        numberNotNormalized++;
                    }
                }
            }
            // validate bone indices are in range of the skeleton
            const numBones = this.skeleton.bones.length;
            const matricesIndices = this.getVerticesData(VertexBuffer.MatricesIndicesKind);
            const matricesIndicesExtra = this.getVerticesData(VertexBuffer.MatricesIndicesExtraKind);
            let numBadBoneIndices = 0;
            for (let a = 0; a < numWeights; a += 4) {
                for (let b = 0; b < numInfluences; b++) {
                    const index = b < 4 ? matricesIndices[a + b] : matricesIndicesExtra[a + b - 4];
                    if (index >= numBones || index < 0) {
                        numBadBoneIndices++;
                    }
                }
            }
            // log mesh stats
            const output = "Number of Weights = " +
                numWeights / 4 +
                "\nMaximum influences = " +
                maxUsedWeights +
                "\nMissing Weights = " +
                missingWeights +
                "\nNot Sorted = " +
                numberNotSorted +
                "\nNot Normalized = " +
                numberNotNormalized +
                "\nWeightCounts = [" +
                usedWeightCounts +
                "]" +
                "\nNumber of bones = " +
                numBones +
                "\nBad Bone Indices = " +
                numBadBoneIndices;
            return { skinned: true, valid: missingWeights === 0 && numberNotNormalized === 0 && numBadBoneIndices === 0, report: output };
        }
        /** @internal */
        _checkDelayState() {
            const scene = this.getScene();
            if (this._geometry) {
                this._geometry.load(scene);
            }
            else if (this.delayLoadState === 4) {
                this.delayLoadState = 2;
                this._queueLoad(scene);
            }
            return this;
        }
        _queueLoad(scene) {
            scene.addPendingData(this);
            const getBinaryData = this.delayLoadingFile.indexOf(".babylonbinarymeshdata") !== -1;
            Tools.LoadFile(this.delayLoadingFile, (data) => {
                if (data instanceof ArrayBuffer) {
                    this._delayLoadingFunction(data, this);
                }
                else {
                    this._delayLoadingFunction(JSON.parse(data), this);
                }
                this.instances.forEach((instance) => {
                    instance.refreshBoundingInfo();
                    instance._syncSubMeshes();
                });
                this.delayLoadState = 1;
                scene.removePendingData(this);
            }, () => { }, scene.offlineProvider, getBinaryData);
            return this;
        }
        /**
         * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
         * A mesh is in the frustum if its bounding box intersects the frustum
         * @param frustumPlanes defines the frustum to test
         * @returns true if the mesh is in the frustum planes
         */
        isInFrustum(frustumPlanes) {
            if (this.delayLoadState === 2) {
                return false;
            }
            if (!super.isInFrustum(frustumPlanes)) {
                return false;
            }
            this._checkDelayState();
            return true;
        }
        /**
         * Sets the mesh material by the material or multiMaterial `id` property
         * @param id is a string identifying the material or the multiMaterial
         * @returns the current mesh
         */
        setMaterialById(id) {
            const materials = this.getScene().materials;
            let index;
            for (index = materials.length - 1; index > -1; index--) {
                if (materials[index].id === id) {
                    this.material = materials[index];
                    return this;
                }
            }
            // Multi
            const multiMaterials = this.getScene().multiMaterials;
            for (index = multiMaterials.length - 1; index > -1; index--) {
                if (multiMaterials[index].id === id) {
                    this.material = multiMaterials[index];
                    return this;
                }
            }
            return this;
        }
        /**
         * Returns as a new array populated with the mesh material and/or skeleton, if any.
         * @returns an array of IAnimatable
         */
        getAnimatables() {
            const results = new Array();
            if (this.material) {
                results.push(this.material);
            }
            if (this.skeleton) {
                results.push(this.skeleton);
            }
            return results;
        }
        /**
         * Modifies the mesh geometry according to the passed transformation matrix.
         * This method returns nothing, but it really modifies the mesh even if it's originally not set as updatable.
         * The mesh normals are modified using the same transformation.
         * Note that, under the hood, this method sets a new VertexBuffer each call.
         * @param transform defines the transform matrix to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
         * @returns the current mesh
         */
        bakeTransformIntoVertices(transform) {
            // Position
            if (!this.isVerticesDataPresent(VertexBuffer.PositionKind)) {
                return this;
            }
            const submeshes = this.subMeshes.splice(0);
            this._resetPointsArrayCache();
            let data = this.getVerticesData(VertexBuffer.PositionKind);
            const temp = Vector3.Zero();
            let index;
            for (index = 0; index < data.length; index += 3) {
                Vector3.TransformCoordinatesFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).toArray(data, index);
            }
            this.setVerticesData(VertexBuffer.PositionKind, data, this.getVertexBuffer(VertexBuffer.PositionKind).isUpdatable());
            // Normals
            if (this.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                data = this.getVerticesData(VertexBuffer.NormalKind);
                for (index = 0; index < data.length; index += 3) {
                    Vector3.TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp)
                        .normalize()
                        .toArray(data, index);
                }
                this.setVerticesData(VertexBuffer.NormalKind, data, this.getVertexBuffer(VertexBuffer.NormalKind).isUpdatable());
            }
            // flip faces?
            if (transform.determinant() < 0) {
                this.flipFaces();
            }
            // Restore submeshes
            this.releaseSubMeshes();
            this.subMeshes = submeshes;
            return this;
        }
        /**
         * Modifies the mesh geometry according to its own current World Matrix.
         * The mesh World Matrix is then reset.
         * This method returns nothing but really modifies the mesh even if it's originally not set as updatable.
         * Note that, under the hood, this method sets a new VertexBuffer each call.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
         * @param bakeIndependentlyOfChildren indicates whether to preserve all child nodes' World Matrix during baking
         * @returns the current mesh
         */
        bakeCurrentTransformIntoVertices(bakeIndependentlyOfChildren = true) {
            this.bakeTransformIntoVertices(this.computeWorldMatrix(true));
            this.resetLocalMatrix(bakeIndependentlyOfChildren);
            return this;
        }
        // Cache
        /** @internal */
        get _positions() {
            if (this._internalAbstractMeshDataInfo._positions) {
                return this._internalAbstractMeshDataInfo._positions;
            }
            if (this._geometry) {
                return this._geometry._positions;
            }
            return null;
        }
        /** @internal */
        _resetPointsArrayCache() {
            if (this._geometry) {
                this._geometry._resetPointsArrayCache();
            }
            return this;
        }
        /** @internal */
        _generatePointsArray() {
            if (this._geometry) {
                return this._geometry._generatePointsArray();
            }
            return false;
        }
        /**
         * Returns a new Mesh object generated from the current mesh properties.
         * This method must not get confused with createInstance()
         * @param name is a string, the name given to the new mesh
         * @param newParent can be any Node object (default `null`)
         * @param doNotCloneChildren allows/denies the recursive cloning of the original mesh children if any (default `false`)
         * @param clonePhysicsImpostor allows/denies the cloning in the same time of the original mesh `body` used by the physics engine, if any (default `true`)
         * @returns a new mesh
         */
        clone(name = "", newParent = null, doNotCloneChildren, clonePhysicsImpostor = true) {
            return new Mesh(name, this.getScene(), newParent, this, doNotCloneChildren, clonePhysicsImpostor);
        }
        /**
         * Releases resources associated with this mesh.
         * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
         * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            this.morphTargetManager = null;
            if (this._geometry) {
                this._geometry.releaseForMesh(this, true);
            }
            const internalDataInfo = this._internalMeshDataInfo;
            if (internalDataInfo._onBeforeDrawObservable) {
                internalDataInfo._onBeforeDrawObservable.clear();
            }
            if (internalDataInfo._onBeforeBindObservable) {
                internalDataInfo._onBeforeBindObservable.clear();
            }
            if (internalDataInfo._onBeforeRenderObservable) {
                internalDataInfo._onBeforeRenderObservable.clear();
            }
            if (internalDataInfo._onAfterRenderObservable) {
                internalDataInfo._onAfterRenderObservable.clear();
            }
            if (internalDataInfo._onBetweenPassObservable) {
                internalDataInfo._onBetweenPassObservable.clear();
            }
            // Sources
            if (this._scene.useClonedMeshMap) {
                if (internalDataInfo.meshMap) {
                    for (const uniqueId in internalDataInfo.meshMap) {
                        const mesh = internalDataInfo.meshMap[uniqueId];
                        if (mesh) {
                            mesh._internalMeshDataInfo._source = null;
                            internalDataInfo.meshMap[uniqueId] = undefined;
                        }
                    }
                }
                if (internalDataInfo._source && internalDataInfo._source._internalMeshDataInfo.meshMap) {
                    internalDataInfo._source._internalMeshDataInfo.meshMap[this.uniqueId] = undefined;
                }
            }
            else {
                const meshes = this.getScene().meshes;
                for (const abstractMesh of meshes) {
                    const mesh = abstractMesh;
                    if (mesh._internalMeshDataInfo && mesh._internalMeshDataInfo._source && mesh._internalMeshDataInfo._source === this) {
                        mesh._internalMeshDataInfo._source = null;
                    }
                }
            }
            internalDataInfo._source = null;
            this._instanceDataStorage.visibleInstances = {};
            // Instances
            this._disposeInstanceSpecificData();
            // Thin instances
            this._disposeThinInstanceSpecificData();
            if (this._internalMeshDataInfo._checkReadinessObserver) {
                this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver);
            }
            super.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        /** @internal */
        _disposeInstanceSpecificData() {
            // Do nothing
        }
        /** @internal */
        _disposeThinInstanceSpecificData() {
            // Do nothing
        }
        /** @internal */
        _invalidateInstanceVertexArrayObject() {
            // Do nothing
        }
        /**
         * Modifies the mesh geometry according to a displacement map.
         * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
         * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
         * @param url is a string, the URL from the image file is to be downloaded.
         * @param minHeight is the lower limit of the displacement.
         * @param maxHeight is the upper limit of the displacement.
         * @param onSuccess is an optional Javascript function to be called just after the mesh is modified. It is passed the modified mesh and must return nothing.
         * @param uvOffset is an optional vector2 used to offset UV.
         * @param uvScale is an optional vector2 used to scale UV.
         * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
         * @returns the Mesh.
         */
        applyDisplacementMap(url, minHeight, maxHeight, onSuccess, uvOffset, uvScale, forceUpdate = false) {
            const scene = this.getScene();
            const onload = (img) => {
                // Getting height map data
                const heightMapWidth = img.width;
                const heightMapHeight = img.height;
                const canvas = this.getEngine().createCanvas(heightMapWidth, heightMapHeight);
                const context = canvas.getContext("2d");
                context.drawImage(img, 0, 0);
                // Create VertexData from map data
                //Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949
                const buffer = context.getImageData(0, 0, heightMapWidth, heightMapHeight).data;
                this.applyDisplacementMapFromBuffer(buffer, heightMapWidth, heightMapHeight, minHeight, maxHeight, uvOffset, uvScale, forceUpdate);
                //execute success callback, if set
                if (onSuccess) {
                    onSuccess(this);
                }
            };
            Tools.LoadImage(url, onload, () => { }, scene.offlineProvider);
            return this;
        }
        /**
         * Modifies the mesh geometry according to a displacementMap buffer.
         * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
         * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
         * @param buffer is a `Uint8Array` buffer containing series of `Uint8` lower than 255, the red, green, blue and alpha values of each successive pixel.
         * @param heightMapWidth is the width of the buffer image.
         * @param heightMapHeight is the height of the buffer image.
         * @param minHeight is the lower limit of the displacement.
         * @param maxHeight is the upper limit of the displacement.
         * @param uvOffset is an optional vector2 used to offset UV.
         * @param uvScale is an optional vector2 used to scale UV.
         * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
         * @returns the Mesh.
         */
        applyDisplacementMapFromBuffer(buffer, heightMapWidth, heightMapHeight, minHeight, maxHeight, uvOffset, uvScale, forceUpdate = false) {
            if (!this.isVerticesDataPresent(VertexBuffer.PositionKind) || !this.isVerticesDataPresent(VertexBuffer.NormalKind) || !this.isVerticesDataPresent(VertexBuffer.UVKind)) {
                Logger.Warn("Cannot call applyDisplacementMap: Given mesh is not complete. Position, Normal or UV are missing");
                return this;
            }
            const positions = this.getVerticesData(VertexBuffer.PositionKind, true, true);
            const normals = this.getVerticesData(VertexBuffer.NormalKind);
            const uvs = this.getVerticesData(VertexBuffer.UVKind);
            let position = Vector3.Zero();
            const normal = Vector3.Zero();
            const uv = Vector2.Zero();
            uvOffset = uvOffset || Vector2.Zero();
            uvScale = uvScale || new Vector2(1, 1);
            for (let index = 0; index < positions.length; index += 3) {
                Vector3.FromArrayToRef(positions, index, position);
                Vector3.FromArrayToRef(normals, index, normal);
                Vector2.FromArrayToRef(uvs, (index / 3) * 2, uv);
                // Compute height
                const u = (Math.abs(uv.x * uvScale.x + (uvOffset.x % 1)) * (heightMapWidth - 1)) % heightMapWidth | 0;
                const v = (Math.abs(uv.y * uvScale.y + (uvOffset.y % 1)) * (heightMapHeight - 1)) % heightMapHeight | 0;
                const pos = (u + v * heightMapWidth) * 4;
                const r = buffer[pos] / 255.0;
                const g = buffer[pos + 1] / 255.0;
                const b = buffer[pos + 2] / 255.0;
                const gradient = r * 0.3 + g * 0.59 + b * 0.11;
                normal.normalize();
                normal.scaleInPlace(minHeight + (maxHeight - minHeight) * gradient);
                position = position.add(normal);
                position.toArray(positions, index);
            }
            VertexData.ComputeNormals(positions, this.getIndices(), normals);
            if (forceUpdate) {
                this.setVerticesData(VertexBuffer.PositionKind, positions);
                this.setVerticesData(VertexBuffer.NormalKind, normals);
                this.setVerticesData(VertexBuffer.UVKind, uvs);
            }
            else {
                this.updateVerticesData(VertexBuffer.PositionKind, positions);
                this.updateVerticesData(VertexBuffer.NormalKind, normals);
            }
            return this;
        }
        _getFlattenedNormals(indices, positions) {
            const normals = new Float32Array(indices.length * 3);
            let normalsCount = 0;
            // Decide if normals should be flipped
            const flipNormalGeneration = this.overrideMaterialSideOrientation ===
                (this._scene.useRightHandedSystem ? 1 : 0);
            // Generate new normals
            for (let index = 0; index < indices.length; index += 3) {
                const p1 = Vector3.FromArray(positions, indices[index] * 3);
                const p2 = Vector3.FromArray(positions, indices[index + 1] * 3);
                const p3 = Vector3.FromArray(positions, indices[index + 2] * 3);
                const p1p2 = p1.subtract(p2);
                const p3p2 = p3.subtract(p2);
                const normal = Vector3.Normalize(Vector3.Cross(p1p2, p3p2));
                if (flipNormalGeneration) {
                    normal.scaleInPlace(-1);
                }
                // Store same normals for every vertex
                for (let localIndex = 0; localIndex < 3; localIndex++) {
                    normals[normalsCount++] = normal.x;
                    normals[normalsCount++] = normal.y;
                    normals[normalsCount++] = normal.z;
                }
            }
            return normals;
        }
        _convertToUnIndexedMesh(flattenNormals = false) {
            const kinds = this.getVerticesDataKinds();
            const indices = this.getIndices();
            const data = {};
            const separateVertices = (data, stride) => {
                const newData = new Float32Array(indices.length * stride);
                let count = 0;
                for (let index = 0; index < indices.length; index++) {
                    for (let offset = 0; offset < stride; offset++) {
                        newData[count++] = data[indices[index] * stride + offset];
                    }
                }
                return newData;
            };
            // Save previous submeshes
            const previousSubmeshes = this.geometry ? this.subMeshes.slice(0) : [];
            // Cache vertex data
            for (const kind of kinds) {
                data[kind] = this.getVerticesData(kind);
            }
            // Update vertex data
            for (const kind of kinds) {
                const vertexBuffer = this.getVertexBuffer(kind);
                const stride = vertexBuffer.getStrideSize();
                if (flattenNormals && kind === VertexBuffer.NormalKind) {
                    const normals = this._getFlattenedNormals(indices, data[VertexBuffer.PositionKind]);
                    this.setVerticesData(VertexBuffer.NormalKind, normals, vertexBuffer.isUpdatable(), stride);
                }
                else {
                    this.setVerticesData(kind, separateVertices(data[kind], stride), vertexBuffer.isUpdatable(), stride);
                }
            }
            // Update morph targets
            if (this.morphTargetManager) {
                for (let targetIndex = 0; targetIndex < this.morphTargetManager.numTargets; targetIndex++) {
                    const target = this.morphTargetManager.getTarget(targetIndex);
                    const positions = target.getPositions();
                    target.setPositions(separateVertices(positions, 3));
                    const normals = target.getNormals();
                    if (normals) {
                        target.setNormals(flattenNormals ? this._getFlattenedNormals(indices, positions) : separateVertices(normals, 3));
                    }
                    const tangents = target.getTangents();
                    if (tangents) {
                        target.setTangents(separateVertices(tangents, 3));
                    }
                    const uvs = target.getUVs();
                    if (uvs) {
                        target.setUVs(separateVertices(uvs, 2));
                    }
                }
                this.morphTargetManager.synchronize();
            }
            // Update indices
            for (let index = 0; index < indices.length; index++) {
                indices[index] = index;
            }
            this.setIndices(indices);
            this._unIndexed = true;
            // Update submeshes
            this.releaseSubMeshes();
            for (const previousOne of previousSubmeshes) {
                SubMesh.AddToMesh(previousOne.materialIndex, previousOne.indexStart, previousOne.indexCount, previousOne.indexStart, previousOne.indexCount, this);
            }
            this.synchronizeInstances();
            return this;
        }
        /**
         * Modify the mesh to get a flat shading rendering.
         * This means each mesh facet will then have its own normals. Usually new vertices are added in the mesh geometry to get this result.
         * Warning : the mesh is really modified even if not set originally as updatable and, under the hood, a new VertexBuffer is allocated.
         * @returns current mesh
         */
        convertToFlatShadedMesh() {
            return this._convertToUnIndexedMesh(true);
        }
        /**
         * This method removes all the mesh indices and add new vertices (duplication) in order to unfold facets into buffers.
         * In other words, more vertices, no more indices and a single bigger VBO.
         * The mesh is really modified even if not set originally as updatable. Under the hood, a new VertexBuffer is allocated.
         * @returns current mesh
         */
        convertToUnIndexedMesh() {
            return this._convertToUnIndexedMesh();
        }
        /**
         * Inverses facet orientations.
         * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
         * @param flipNormals will also inverts the normals
         * @returns current mesh
         */
        flipFaces(flipNormals = false) {
            const vertex_data = VertexData.ExtractFromMesh(this);
            let i;
            if (flipNormals && this.isVerticesDataPresent(VertexBuffer.NormalKind) && vertex_data.normals) {
                for (i = 0; i < vertex_data.normals.length; i++) {
                    vertex_data.normals[i] *= -1;
                }
            }
            if (vertex_data.indices) {
                let temp;
                for (i = 0; i < vertex_data.indices.length; i += 3) {
                    // reassign indices
                    temp = vertex_data.indices[i + 1];
                    vertex_data.indices[i + 1] = vertex_data.indices[i + 2];
                    vertex_data.indices[i + 2] = temp;
                }
            }
            vertex_data.applyToMesh(this, this.isVertexBufferUpdatable(VertexBuffer.PositionKind));
            return this;
        }
        /**
         * Increase the number of facets and hence vertices in a mesh
         * Vertex normals are interpolated from existing vertex normals
         * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
         * @param numberPerEdge the number of new vertices to add to each edge of a facet, optional default 1
         */
        increaseVertices(numberPerEdge = 1) {
            const vertex_data = VertexData.ExtractFromMesh(this);
            const currentIndices = vertex_data.indices && !Array.isArray(vertex_data.indices) && Array.from ? Array.from(vertex_data.indices) : vertex_data.indices;
            const positions = vertex_data.positions && !Array.isArray(vertex_data.positions) && Array.from ? Array.from(vertex_data.positions) : vertex_data.positions;
            const uvs = vertex_data.uvs && !Array.isArray(vertex_data.uvs) && Array.from ? Array.from(vertex_data.uvs) : vertex_data.uvs;
            const normals = vertex_data.normals && !Array.isArray(vertex_data.normals) && Array.from ? Array.from(vertex_data.normals) : vertex_data.normals;
            if (!currentIndices || !positions) {
                Logger.Warn("Couldn't increase number of vertices : VertexData must contain at least indices and positions");
            }
            else {
                vertex_data.indices = currentIndices;
                vertex_data.positions = positions;
                if (uvs) {
                    vertex_data.uvs = uvs;
                }
                if (normals) {
                    vertex_data.normals = normals;
                }
                const segments = numberPerEdge + 1; //segments per current facet edge, become sides of new facets
                const tempIndices = new Array();
                for (let i = 0; i < segments + 1; i++) {
                    tempIndices[i] = new Array();
                }
                let a; //vertex index of one end of a side
                let b; //vertex index of other end of the side
                const deltaPosition = new Vector3(0, 0, 0);
                const deltaNormal = new Vector3(0, 0, 0);
                const deltaUV = new Vector2(0, 0);
                const indices = new Array();
                const vertexIndex = new Array();
                const side = new Array();
                let len;
                let positionPtr = positions.length;
                let uvPtr;
                if (uvs) {
                    uvPtr = uvs.length;
                }
                let normalsPtr;
                if (normals) {
                    normalsPtr = normals.length;
                }
                for (let i = 0; i < currentIndices.length; i += 3) {
                    vertexIndex[0] = currentIndices[i];
                    vertexIndex[1] = currentIndices[i + 1];
                    vertexIndex[2] = currentIndices[i + 2];
                    for (let j = 0; j < 3; j++) {
                        a = vertexIndex[j];
                        b = vertexIndex[(j + 1) % 3];
                        if (side[a] === undefined && side[b] === undefined) {
                            side[a] = new Array();
                            side[b] = new Array();
                        }
                        else {
                            if (side[a] === undefined) {
                                side[a] = new Array();
                            }
                            if (side[b] === undefined) {
                                side[b] = new Array();
                            }
                        }
                        if (side[a][b] === undefined && side[b][a] === undefined) {
                            side[a][b] = [];
                            deltaPosition.x = (positions[3 * b] - positions[3 * a]) / segments;
                            deltaPosition.y = (positions[3 * b + 1] - positions[3 * a + 1]) / segments;
                            deltaPosition.z = (positions[3 * b + 2] - positions[3 * a + 2]) / segments;
                            if (normals) {
                                deltaNormal.x = (normals[3 * b] - normals[3 * a]) / segments;
                                deltaNormal.y = (normals[3 * b + 1] - normals[3 * a + 1]) / segments;
                                deltaNormal.z = (normals[3 * b + 2] - normals[3 * a + 2]) / segments;
                            }
                            if (uvs) {
                                deltaUV.x = (uvs[2 * b] - uvs[2 * a]) / segments;
                                deltaUV.y = (uvs[2 * b + 1] - uvs[2 * a + 1]) / segments;
                            }
                            side[a][b].push(a);
                            for (let k = 1; k < segments; k++) {
                                side[a][b].push(positions.length / 3);
                                positions[positionPtr++] = positions[3 * a] + k * deltaPosition.x;
                                positions[positionPtr++] = positions[3 * a + 1] + k * deltaPosition.y;
                                positions[positionPtr++] = positions[3 * a + 2] + k * deltaPosition.z;
                                if (normals) {
                                    normals[normalsPtr++] = normals[3 * a] + k * deltaNormal.x;
                                    normals[normalsPtr++] = normals[3 * a + 1] + k * deltaNormal.y;
                                    normals[normalsPtr++] = normals[3 * a + 2] + k * deltaNormal.z;
                                }
                                if (uvs) {
                                    uvs[uvPtr++] = uvs[2 * a] + k * deltaUV.x;
                                    uvs[uvPtr++] = uvs[2 * a + 1] + k * deltaUV.y;
                                }
                            }
                            side[a][b].push(b);
                            side[b][a] = new Array();
                            len = side[a][b].length;
                            for (let idx = 0; idx < len; idx++) {
                                side[b][a][idx] = side[a][b][len - 1 - idx];
                            }
                        }
                    }
                    //Calculate positions, normals and uvs of new internal vertices
                    tempIndices[0][0] = currentIndices[i];
                    tempIndices[1][0] = side[currentIndices[i]][currentIndices[i + 1]][1];
                    tempIndices[1][1] = side[currentIndices[i]][currentIndices[i + 2]][1];
                    for (let k = 2; k < segments; k++) {
                        tempIndices[k][0] = side[currentIndices[i]][currentIndices[i + 1]][k];
                        tempIndices[k][k] = side[currentIndices[i]][currentIndices[i + 2]][k];
                        deltaPosition.x = (positions[3 * tempIndices[k][k]] - positions[3 * tempIndices[k][0]]) / k;
                        deltaPosition.y = (positions[3 * tempIndices[k][k] + 1] - positions[3 * tempIndices[k][0] + 1]) / k;
                        deltaPosition.z = (positions[3 * tempIndices[k][k] + 2] - positions[3 * tempIndices[k][0] + 2]) / k;
                        if (normals) {
                            deltaNormal.x = (normals[3 * tempIndices[k][k]] - normals[3 * tempIndices[k][0]]) / k;
                            deltaNormal.y = (normals[3 * tempIndices[k][k] + 1] - normals[3 * tempIndices[k][0] + 1]) / k;
                            deltaNormal.z = (normals[3 * tempIndices[k][k] + 2] - normals[3 * tempIndices[k][0] + 2]) / k;
                        }
                        if (uvs) {
                            deltaUV.x = (uvs[2 * tempIndices[k][k]] - uvs[2 * tempIndices[k][0]]) / k;
                            deltaUV.y = (uvs[2 * tempIndices[k][k] + 1] - uvs[2 * tempIndices[k][0] + 1]) / k;
                        }
                        for (let j = 1; j < k; j++) {
                            tempIndices[k][j] = positions.length / 3;
                            positions[positionPtr++] = positions[3 * tempIndices[k][0]] + j * deltaPosition.x;
                            positions[positionPtr++] = positions[3 * tempIndices[k][0] + 1] + j * deltaPosition.y;
                            positions[positionPtr++] = positions[3 * tempIndices[k][0] + 2] + j * deltaPosition.z;
                            if (normals) {
                                normals[normalsPtr++] = normals[3 * tempIndices[k][0]] + j * deltaNormal.x;
                                normals[normalsPtr++] = normals[3 * tempIndices[k][0] + 1] + j * deltaNormal.y;
                                normals[normalsPtr++] = normals[3 * tempIndices[k][0] + 2] + j * deltaNormal.z;
                            }
                            if (uvs) {
                                uvs[uvPtr++] = uvs[2 * tempIndices[k][0]] + j * deltaUV.x;
                                uvs[uvPtr++] = uvs[2 * tempIndices[k][0] + 1] + j * deltaUV.y;
                            }
                        }
                    }
                    tempIndices[segments] = side[currentIndices[i + 1]][currentIndices[i + 2]];
                    // reform indices
                    indices.push(tempIndices[0][0], tempIndices[1][0], tempIndices[1][1]);
                    for (let k = 1; k < segments; k++) {
                        let j;
                        for (j = 0; j < k; j++) {
                            indices.push(tempIndices[k][j], tempIndices[k + 1][j], tempIndices[k + 1][j + 1]);
                            indices.push(tempIndices[k][j], tempIndices[k + 1][j + 1], tempIndices[k][j + 1]);
                        }
                        indices.push(tempIndices[k][j], tempIndices[k + 1][j], tempIndices[k + 1][j + 1]);
                    }
                }
                vertex_data.indices = indices;
                vertex_data.applyToMesh(this, this.isVertexBufferUpdatable(VertexBuffer.PositionKind));
            }
        }
        /**
         * Force adjacent facets to share vertices and remove any facets that have all vertices in a line
         * This will undo any application of covertToFlatShadedMesh
         * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
         */
        forceSharedVertices() {
            const vertex_data = VertexData.ExtractFromMesh(this);
            const currentUVs = vertex_data.uvs;
            const currentIndices = vertex_data.indices;
            const currentPositions = vertex_data.positions;
            const currentColors = vertex_data.colors;
            const currentMatrixIndices = vertex_data.matricesIndices;
            const currentMatrixWeights = vertex_data.matricesWeights;
            const currentMatrixIndicesExtra = vertex_data.matricesIndicesExtra;
            const currentMatrixWeightsExtra = vertex_data.matricesWeightsExtra;
            if (currentIndices === void 0 || currentPositions === void 0 || currentIndices === null || currentPositions === null) {
                Logger.Warn("VertexData contains empty entries");
            }
            else {
                const positions = new Array();
                const indices = new Array();
                const uvs = new Array();
                const colors = new Array();
                const matrixIndices = new Array();
                const matrixWeights = new Array();
                const matrixIndicesExtra = new Array();
                const matrixWeightsExtra = new Array();
                let pstring = new Array(); //lists facet vertex positions (a,b,c) as string "a|b|c"
                let indexPtr = 0; // pointer to next available index value
                const uniquePositions = {}; // unique vertex positions
                let ptr; // pointer to element in uniquePositions
                let facet;
                for (let i = 0; i < currentIndices.length; i += 3) {
                    facet = [currentIndices[i], currentIndices[i + 1], currentIndices[i + 2]]; //facet vertex indices
                    pstring = new Array();
                    for (let j = 0; j < 3; j++) {
                        pstring[j] = "";
                        for (let k = 0; k < 3; k++) {
                            //small values make 0
                            if (Math.abs(currentPositions[3 * facet[j] + k]) < 0.00000001) {
                                currentPositions[3 * facet[j] + k] = 0;
                            }
                            pstring[j] += currentPositions[3 * facet[j] + k] + "|";
                        }
                    }
                    //check facet vertices to see that none are repeated
                    // do not process any facet that has a repeated vertex, ie is a line
                    if (!(pstring[0] == pstring[1] || pstring[0] == pstring[2] || pstring[1] == pstring[2])) {
                        //for each facet position check if already listed in uniquePositions
                        // if not listed add to uniquePositions and set index pointer
                        // if listed use its index in uniquePositions and new index pointer
                        for (let j = 0; j < 3; j++) {
                            ptr = uniquePositions[pstring[j]];
                            if (ptr === undefined) {
                                uniquePositions[pstring[j]] = indexPtr;
                                ptr = indexPtr++;
                                //not listed so add individual x, y, z coordinates to positions
                                for (let k = 0; k < 3; k++) {
                                    positions.push(currentPositions[3 * facet[j] + k]);
                                }
                                if (currentColors !== null && currentColors !== void 0) {
                                    for (let k = 0; k < 4; k++) {
                                        colors.push(currentColors[4 * facet[j] + k]);
                                    }
                                }
                                if (currentUVs !== null && currentUVs !== void 0) {
                                    for (let k = 0; k < 2; k++) {
                                        uvs.push(currentUVs[2 * facet[j] + k]);
                                    }
                                }
                                if (currentMatrixIndices !== null && currentMatrixIndices !== void 0) {
                                    for (let k = 0; k < 4; k++) {
                                        matrixIndices.push(currentMatrixIndices[4 * facet[j] + k]);
                                    }
                                }
                                if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) {
                                    for (let k = 0; k < 4; k++) {
                                        matrixWeights.push(currentMatrixWeights[4 * facet[j] + k]);
                                    }
                                }
                                if (currentMatrixIndicesExtra !== null && currentMatrixIndicesExtra !== void 0) {
                                    for (let k = 0; k < 4; k++) {
                                        matrixIndicesExtra.push(currentMatrixIndicesExtra[4 * facet[j] + k]);
                                    }
                                }
                                if (currentMatrixWeightsExtra !== null && currentMatrixWeightsExtra !== void 0) {
                                    for (let k = 0; k < 4; k++) {
                                        matrixWeightsExtra.push(currentMatrixWeightsExtra[4 * facet[j] + k]);
                                    }
                                }
                            }
                            // add new index pointer to indices array
                            indices.push(ptr);
                        }
                    }
                }
                const normals = new Array();
                VertexData.ComputeNormals(positions, indices, normals);
                //create new vertex data object and update
                vertex_data.positions = positions;
                vertex_data.indices = indices;
                vertex_data.normals = normals;
                if (currentUVs !== null && currentUVs !== void 0) {
                    vertex_data.uvs = uvs;
                }
                if (currentColors !== null && currentColors !== void 0) {
                    vertex_data.colors = colors;
                }
                if (currentMatrixIndices !== null && currentMatrixIndices !== void 0) {
                    vertex_data.matricesIndices = matrixIndices;
                }
                if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) {
                    vertex_data.matricesWeights = matrixWeights;
                }
                if (currentMatrixIndicesExtra !== null && currentMatrixIndicesExtra !== void 0) {
                    vertex_data.matricesIndicesExtra = matrixIndicesExtra;
                }
                if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) {
                    vertex_data.matricesWeightsExtra = matrixWeightsExtra;
                }
                vertex_data.applyToMesh(this, this.isVertexBufferUpdatable(VertexBuffer.PositionKind));
            }
        }
        // Instances
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/naming-convention
        static _instancedMeshFactory(name, mesh) {
            throw _WarnImport("InstancedMesh");
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static _PhysicsImpostorParser(scene, physicObject, jsonObject) {
            throw _WarnImport("PhysicsImpostor");
        }
        /**
         * Creates a new InstancedMesh object from the mesh model.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
         * @param name defines the name of the new instance
         * @returns a new InstancedMesh
         */
        createInstance(name) {
            return Mesh._instancedMeshFactory(name, this);
        }
        /**
         * Synchronises all the mesh instance submeshes to the current mesh submeshes, if any.
         * After this call, all the mesh instances have the same submeshes than the current mesh.
         * @returns the current mesh
         */
        synchronizeInstances() {
            for (let instanceIndex = 0; instanceIndex < this.instances.length; instanceIndex++) {
                const instance = this.instances[instanceIndex];
                instance._syncSubMeshes();
            }
            return this;
        }
        /**
         * Optimization of the mesh's indices, in case a mesh has duplicated vertices.
         * The function will only reorder the indices and will not remove unused vertices to avoid problems with submeshes.
         * This should be used together with the simplification to avoid disappearing triangles.
         * @param successCallback an optional success callback to be called after the optimization finished.
         * @returns the current mesh
         */
        optimizeIndices(successCallback) {
            const indices = this.getIndices();
            const positions = this.getVerticesData(VertexBuffer.PositionKind);
            if (!positions || !indices) {
                return this;
            }
            const vectorPositions = new Array();
            for (let pos = 0; pos < positions.length; pos = pos + 3) {
                vectorPositions.push(Vector3.FromArray(positions, pos));
            }
            const dupes = new Array();
            AsyncLoop.SyncAsyncForLoop(vectorPositions.length, 40, (iteration) => {
                const realPos = vectorPositions.length - 1 - iteration;
                const testedPosition = vectorPositions[realPos];
                for (let j = 0; j < realPos; ++j) {
                    const againstPosition = vectorPositions[j];
                    if (testedPosition.equals(againstPosition)) {
                        dupes[realPos] = j;
                        break;
                    }
                }
            }, () => {
                for (let i = 0; i < indices.length; ++i) {
                    indices[i] = dupes[indices[i]] || indices[i];
                }
                //indices are now reordered
                const originalSubMeshes = this.subMeshes.slice(0);
                this.setIndices(indices);
                this.subMeshes = originalSubMeshes;
                if (successCallback) {
                    successCallback(this);
                }
            });
            return this;
        }
        /**
         * Serialize current mesh
         * @param serializationObject defines the object which will receive the serialization data
         */
        serialize(serializationObject = {}) {
            serializationObject.name = this.name;
            serializationObject.id = this.id;
            serializationObject.uniqueId = this.uniqueId;
            serializationObject.type = this.getClassName();
            if (Tags && Tags.HasTags(this)) {
                serializationObject.tags = Tags.GetTags(this);
            }
            serializationObject.position = this.position.asArray();
            if (this.rotationQuaternion) {
                serializationObject.rotationQuaternion = this.rotationQuaternion.asArray();
            }
            else if (this.rotation) {
                serializationObject.rotation = this.rotation.asArray();
            }
            serializationObject.scaling = this.scaling.asArray();
            if (this._postMultiplyPivotMatrix) {
                serializationObject.pivotMatrix = this.getPivotMatrix().asArray();
            }
            else {
                serializationObject.localMatrix = this.getPivotMatrix().asArray();
            }
            serializationObject.isEnabled = this.isEnabled(false);
            serializationObject.isVisible = this.isVisible;
            serializationObject.infiniteDistance = this.infiniteDistance;
            serializationObject.pickable = this.isPickable;
            serializationObject.receiveShadows = this.receiveShadows;
            serializationObject.billboardMode = this.billboardMode;
            serializationObject.visibility = this.visibility;
            serializationObject.checkCollisions = this.checkCollisions;
            serializationObject.isBlocker = this.isBlocker;
            serializationObject.overrideMaterialSideOrientation = this.overrideMaterialSideOrientation;
            // Parent
            if (this.parent) {
                this.parent._serializeAsParent(serializationObject);
            }
            // Geometry
            serializationObject.isUnIndexed = this.isUnIndexed;
            const geometry = this._geometry;
            if (geometry && this.subMeshes) {
                serializationObject.geometryUniqueId = geometry.uniqueId;
                serializationObject.geometryId = geometry.id;
                // SubMeshes
                serializationObject.subMeshes = [];
                for (let subIndex = 0; subIndex < this.subMeshes.length; subIndex++) {
                    const subMesh = this.subMeshes[subIndex];
                    serializationObject.subMeshes.push({
                        materialIndex: subMesh.materialIndex,
                        verticesStart: subMesh.verticesStart,
                        verticesCount: subMesh.verticesCount,
                        indexStart: subMesh.indexStart,
                        indexCount: subMesh.indexCount,
                    });
                }
            }
            // Material
            if (this.material) {
                if (!this.material.doNotSerialize) {
                    serializationObject.materialUniqueId = this.material.uniqueId;
                    serializationObject.materialId = this.material.id; // back compat
                }
            }
            else {
                this.material = null;
                serializationObject.materialUniqueId = this._scene.defaultMaterial.uniqueId;
                serializationObject.materialId = this._scene.defaultMaterial.id; // back compat
            }
            // Morph targets
            if (this.morphTargetManager) {
                serializationObject.morphTargetManagerId = this.morphTargetManager.uniqueId;
            }
            // Skeleton
            if (this.skeleton) {
                serializationObject.skeletonId = this.skeleton.id;
                serializationObject.numBoneInfluencers = this.numBoneInfluencers;
            }
            // Physics
            //TODO implement correct serialization for physics impostors.
            if (this.getScene()._getComponent(SceneComponentConstants.NAME_PHYSICSENGINE)) {
                const impostor = this.getPhysicsImpostor();
                if (impostor) {
                    serializationObject.physicsMass = impostor.getParam("mass");
                    serializationObject.physicsFriction = impostor.getParam("friction");
                    serializationObject.physicsRestitution = impostor.getParam("mass");
                    serializationObject.physicsImpostor = impostor.type;
                }
            }
            // Metadata
            if (this.metadata) {
                serializationObject.metadata = this.metadata;
            }
            // Instances
            serializationObject.instances = [];
            for (let index = 0; index < this.instances.length; index++) {
                const instance = this.instances[index];
                if (instance.doNotSerialize) {
                    continue;
                }
                const serializationInstance = {
                    name: instance.name,
                    id: instance.id,
                    isEnabled: instance.isEnabled(false),
                    isVisible: instance.isVisible,
                    isPickable: instance.isPickable,
                    checkCollisions: instance.checkCollisions,
                    position: instance.position.asArray(),
                    scaling: instance.scaling.asArray(),
                };
                if (instance.parent) {
                    instance.parent._serializeAsParent(serializationInstance);
                }
                if (instance.rotationQuaternion) {
                    serializationInstance.rotationQuaternion = instance.rotationQuaternion.asArray();
                }
                else if (instance.rotation) {
                    serializationInstance.rotation = instance.rotation.asArray();
                }
                // Physics
                //TODO implement correct serialization for physics impostors.
                if (this.getScene()._getComponent(SceneComponentConstants.NAME_PHYSICSENGINE)) {
                    const impostor = instance.getPhysicsImpostor();
                    if (impostor) {
                        serializationInstance.physicsMass = impostor.getParam("mass");
                        serializationInstance.physicsFriction = impostor.getParam("friction");
                        serializationInstance.physicsRestitution = impostor.getParam("mass");
                        serializationInstance.physicsImpostor = impostor.type;
                    }
                }
                // Metadata
                if (instance.metadata) {
                    serializationInstance.metadata = instance.metadata;
                }
                // Action Manager
                if (instance.actionManager) {
                    serializationInstance.actions = instance.actionManager.serialize(instance.name);
                }
                serializationObject.instances.push(serializationInstance);
                // Animations
                SerializationHelper.AppendSerializedAnimations(instance, serializationInstance);
                serializationInstance.ranges = instance.serializeAnimationRanges();
            }
            // Thin instances
            if (this._thinInstanceDataStorage.instancesCount && this._thinInstanceDataStorage.matrixData) {
                serializationObject.thinInstances = {
                    instancesCount: this._thinInstanceDataStorage.instancesCount,
                    matrixData: Array.from(this._thinInstanceDataStorage.matrixData),
                    matrixBufferSize: this._thinInstanceDataStorage.matrixBufferSize,
                    enablePicking: this.thinInstanceEnablePicking,
                };
                if (this._userThinInstanceBuffersStorage) {
                    const userThinInstance = {
                        data: {},
                        sizes: {},
                        strides: {},
                    };
                    for (const kind in this._userThinInstanceBuffersStorage.data) {
                        userThinInstance.data[kind] = Array.from(this._userThinInstanceBuffersStorage.data[kind]);
                        userThinInstance.sizes[kind] = this._userThinInstanceBuffersStorage.sizes[kind];
                        userThinInstance.strides[kind] = this._userThinInstanceBuffersStorage.strides[kind];
                    }
                    serializationObject.thinInstances.userThinInstance = userThinInstance;
                }
            }
            // Animations
            SerializationHelper.AppendSerializedAnimations(this, serializationObject);
            serializationObject.ranges = this.serializeAnimationRanges();
            // Layer mask
            serializationObject.layerMask = this.layerMask;
            // Alpha
            serializationObject.alphaIndex = this.alphaIndex;
            serializationObject.hasVertexAlpha = this.hasVertexAlpha;
            // Overlay
            serializationObject.overlayAlpha = this.overlayAlpha;
            serializationObject.overlayColor = this.overlayColor.asArray();
            serializationObject.renderOverlay = this.renderOverlay;
            // Fog
            serializationObject.applyFog = this.applyFog;
            // Action Manager
            if (this.actionManager) {
                serializationObject.actions = this.actionManager.serialize(this.name);
            }
            return serializationObject;
        }
        /** @internal */
        _syncGeometryWithMorphTargetManager() {
            if (!this.geometry) {
                return;
            }
            this._markSubMeshesAsAttributesDirty();
            const morphTargetManager = this._internalAbstractMeshDataInfo._morphTargetManager;
            if (morphTargetManager && morphTargetManager.vertexCount) {
                if (morphTargetManager.vertexCount !== this.getTotalVertices()) {
                    Logger.Error("Mesh is incompatible with morph targets. Targets and mesh must all have the same vertices count.");
                    this.morphTargetManager = null;
                    return;
                }
                if (morphTargetManager.isUsingTextureForTargets) {
                    return;
                }
                for (let index = 0; index < morphTargetManager.numInfluencers; index++) {
                    const morphTarget = morphTargetManager.getActiveTarget(index);
                    const positions = morphTarget.getPositions();
                    if (!positions) {
                        Logger.Error("Invalid morph target. Target must have positions.");
                        return;
                    }
                    this.geometry.setVerticesData(VertexBuffer.PositionKind + index, positions, false, 3);
                    const normals = morphTarget.getNormals();
                    if (normals) {
                        this.geometry.setVerticesData(VertexBuffer.NormalKind + index, normals, false, 3);
                    }
                    const tangents = morphTarget.getTangents();
                    if (tangents) {
                        this.geometry.setVerticesData(VertexBuffer.TangentKind + index, tangents, false, 3);
                    }
                    const uvs = morphTarget.getUVs();
                    if (uvs) {
                        this.geometry.setVerticesData(VertexBuffer.UVKind + "_" + index, uvs, false, 2);
                    }
                }
            }
            else {
                let index = 0;
                // Positions
                while (this.geometry.isVerticesDataPresent(VertexBuffer.PositionKind + index)) {
                    this.geometry.removeVerticesData(VertexBuffer.PositionKind + index);
                    if (this.geometry.isVerticesDataPresent(VertexBuffer.NormalKind + index)) {
                        this.geometry.removeVerticesData(VertexBuffer.NormalKind + index);
                    }
                    if (this.geometry.isVerticesDataPresent(VertexBuffer.TangentKind + index)) {
                        this.geometry.removeVerticesData(VertexBuffer.TangentKind + index);
                    }
                    if (this.geometry.isVerticesDataPresent(VertexBuffer.UVKind + index)) {
                        this.geometry.removeVerticesData(VertexBuffer.UVKind + "_" + index);
                    }
                    index++;
                }
            }
        }
        /**
         * Returns a new Mesh object parsed from the source provided.
         * @param parsedMesh is the source
         * @param scene defines the hosting scene
         * @param rootUrl is the root URL to prefix the `delayLoadingFile` property with
         * @returns a new Mesh
         */
        static Parse(parsedMesh, scene, rootUrl) {
            let mesh;
            if (parsedMesh.type && parsedMesh.type === "LinesMesh") {
                mesh = Mesh._LinesMeshParser(parsedMesh, scene);
            }
            else if (parsedMesh.type && parsedMesh.type === "GroundMesh") {
                mesh = Mesh._GroundMeshParser(parsedMesh, scene);
            }
            else if (parsedMesh.type && parsedMesh.type === "GoldbergMesh") {
                mesh = Mesh._GoldbergMeshParser(parsedMesh, scene);
            }
            else if (parsedMesh.type && parsedMesh.type === "GreasedLineMesh") {
                mesh = Mesh._GreasedLineMeshParser(parsedMesh, scene);
            }
            else if (parsedMesh.type && parsedMesh.type === "TrailMesh") {
                mesh = Mesh._TrailMeshParser(parsedMesh, scene);
            }
            else {
                mesh = new Mesh(parsedMesh.name, scene);
            }
            mesh.id = parsedMesh.id;
            mesh._waitingParsedUniqueId = parsedMesh.uniqueId;
            if (Tags) {
                Tags.AddTagsTo(mesh, parsedMesh.tags);
            }
            mesh.position = Vector3.FromArray(parsedMesh.position);
            if (parsedMesh.metadata !== undefined) {
                mesh.metadata = parsedMesh.metadata;
            }
            if (parsedMesh.rotationQuaternion) {
                mesh.rotationQuaternion = Quaternion.FromArray(parsedMesh.rotationQuaternion);
            }
            else if (parsedMesh.rotation) {
                mesh.rotation = Vector3.FromArray(parsedMesh.rotation);
            }
            mesh.scaling = Vector3.FromArray(parsedMesh.scaling);
            if (parsedMesh.localMatrix) {
                mesh.setPreTransformMatrix(Matrix.FromArray(parsedMesh.localMatrix));
            }
            else if (parsedMesh.pivotMatrix) {
                mesh.setPivotMatrix(Matrix.FromArray(parsedMesh.pivotMatrix));
            }
            mesh.setEnabled(parsedMesh.isEnabled);
            mesh.isVisible = parsedMesh.isVisible;
            mesh.infiniteDistance = parsedMesh.infiniteDistance;
            mesh.showBoundingBox = parsedMesh.showBoundingBox;
            mesh.showSubMeshesBoundingBox = parsedMesh.showSubMeshesBoundingBox;
            if (parsedMesh.applyFog !== undefined) {
                mesh.applyFog = parsedMesh.applyFog;
            }
            if (parsedMesh.pickable !== undefined) {
                mesh.isPickable = parsedMesh.pickable;
            }
            if (parsedMesh.alphaIndex !== undefined) {
                mesh.alphaIndex = parsedMesh.alphaIndex;
            }
            mesh.receiveShadows = parsedMesh.receiveShadows;
            if (parsedMesh.billboardMode !== undefined) {
                mesh.billboardMode = parsedMesh.billboardMode;
            }
            if (parsedMesh.visibility !== undefined) {
                mesh.visibility = parsedMesh.visibility;
            }
            mesh.checkCollisions = parsedMesh.checkCollisions;
            mesh.overrideMaterialSideOrientation = parsedMesh.overrideMaterialSideOrientation;
            if (parsedMesh.isBlocker !== undefined) {
                mesh.isBlocker = parsedMesh.isBlocker;
            }
            mesh._shouldGenerateFlatShading = parsedMesh.useFlatShading;
            // freezeWorldMatrix
            if (parsedMesh.freezeWorldMatrix) {
                mesh._waitingData.freezeWorldMatrix = parsedMesh.freezeWorldMatrix;
            }
            // Parent
            if (parsedMesh.parentId !== undefined) {
                mesh._waitingParentId = parsedMesh.parentId;
            }
            if (parsedMesh.parentInstanceIndex !== undefined) {
                mesh._waitingParentInstanceIndex = parsedMesh.parentInstanceIndex;
            }
            // Actions
            if (parsedMesh.actions !== undefined) {
                mesh._waitingData.actions = parsedMesh.actions;
            }
            // Overlay
            if (parsedMesh.overlayAlpha !== undefined) {
                mesh.overlayAlpha = parsedMesh.overlayAlpha;
            }
            if (parsedMesh.overlayColor !== undefined) {
                mesh.overlayColor = Color3.FromArray(parsedMesh.overlayColor);
            }
            if (parsedMesh.renderOverlay !== undefined) {
                mesh.renderOverlay = parsedMesh.renderOverlay;
            }
            // Geometry
            mesh.isUnIndexed = !!parsedMesh.isUnIndexed;
            mesh.hasVertexAlpha = parsedMesh.hasVertexAlpha;
            if (parsedMesh.delayLoadingFile) {
                mesh.delayLoadState = 4;
                mesh.delayLoadingFile = rootUrl + parsedMesh.delayLoadingFile;
                mesh.buildBoundingInfo(Vector3.FromArray(parsedMesh.boundingBoxMinimum), Vector3.FromArray(parsedMesh.boundingBoxMaximum));
                if (parsedMesh._binaryInfo) {
                    mesh._binaryInfo = parsedMesh._binaryInfo;
                }
                mesh._delayInfo = [];
                if (parsedMesh.hasUVs) {
                    mesh._delayInfo.push(VertexBuffer.UVKind);
                }
                if (parsedMesh.hasUVs2) {
                    mesh._delayInfo.push(VertexBuffer.UV2Kind);
                }
                if (parsedMesh.hasUVs3) {
                    mesh._delayInfo.push(VertexBuffer.UV3Kind);
                }
                if (parsedMesh.hasUVs4) {
                    mesh._delayInfo.push(VertexBuffer.UV4Kind);
                }
                if (parsedMesh.hasUVs5) {
                    mesh._delayInfo.push(VertexBuffer.UV5Kind);
                }
                if (parsedMesh.hasUVs6) {
                    mesh._delayInfo.push(VertexBuffer.UV6Kind);
                }
                if (parsedMesh.hasColors) {
                    mesh._delayInfo.push(VertexBuffer.ColorKind);
                }
                if (parsedMesh.hasMatricesIndices) {
                    mesh._delayInfo.push(VertexBuffer.MatricesIndicesKind);
                }
                if (parsedMesh.hasMatricesWeights) {
                    mesh._delayInfo.push(VertexBuffer.MatricesWeightsKind);
                }
                mesh._delayLoadingFunction = Geometry._ImportGeometry;
                if (SceneLoaderFlags.ForceFullSceneLoadingForIncremental) {
                    mesh._checkDelayState();
                }
            }
            else {
                Geometry._ImportGeometry(parsedMesh, mesh);
            }
            // Material
            if (parsedMesh.materialUniqueId) {
                mesh._waitingMaterialId = parsedMesh.materialUniqueId;
            }
            else if (parsedMesh.materialId) {
                mesh._waitingMaterialId = parsedMesh.materialId;
            }
            // Morph targets
            if (parsedMesh.morphTargetManagerId > -1) {
                mesh.morphTargetManager = scene.getMorphTargetManagerById(parsedMesh.morphTargetManagerId);
            }
            // Skeleton
            if (parsedMesh.skeletonId !== undefined && parsedMesh.skeletonId !== null) {
                mesh.skeleton = scene.getLastSkeletonById(parsedMesh.skeletonId);
                if (parsedMesh.numBoneInfluencers) {
                    mesh.numBoneInfluencers = parsedMesh.numBoneInfluencers;
                }
            }
            // Animations
            if (parsedMesh.animations) {
                for (let animationIndex = 0; animationIndex < parsedMesh.animations.length; animationIndex++) {
                    const parsedAnimation = parsedMesh.animations[animationIndex];
                    const internalClass = GetClass("BABYLON.Animation");
                    if (internalClass) {
                        mesh.animations.push(internalClass.Parse(parsedAnimation));
                    }
                }
                Node.ParseAnimationRanges(mesh, parsedMesh, scene);
            }
            if (parsedMesh.autoAnimate) {
                scene.beginAnimation(mesh, parsedMesh.autoAnimateFrom, parsedMesh.autoAnimateTo, parsedMesh.autoAnimateLoop, parsedMesh.autoAnimateSpeed || 1.0);
            }
            // Layer Mask
            if (parsedMesh.layerMask && !isNaN(parsedMesh.layerMask)) {
                mesh.layerMask = Math.abs(parseInt(parsedMesh.layerMask));
            }
            else {
                mesh.layerMask = 0x0fffffff;
            }
            // Physics
            if (parsedMesh.physicsImpostor) {
                Mesh._PhysicsImpostorParser(scene, mesh, parsedMesh);
            }
            // Levels
            if (parsedMesh.lodMeshIds) {
                mesh._waitingData.lods = {
                    ids: parsedMesh.lodMeshIds,
                    distances: parsedMesh.lodDistances ? parsedMesh.lodDistances : null,
                    coverages: parsedMesh.lodCoverages ? parsedMesh.lodCoverages : null,
                };
            }
            // Instances
            if (parsedMesh.instances) {
                for (let index = 0; index < parsedMesh.instances.length; index++) {
                    const parsedInstance = parsedMesh.instances[index];
                    const instance = mesh.createInstance(parsedInstance.name);
                    if (parsedInstance.id) {
                        instance.id = parsedInstance.id;
                    }
                    if (Tags) {
                        if (parsedInstance.tags) {
                            Tags.AddTagsTo(instance, parsedInstance.tags);
                        }
                        else {
                            Tags.AddTagsTo(instance, parsedMesh.tags);
                        }
                    }
                    instance.position = Vector3.FromArray(parsedInstance.position);
                    if (parsedInstance.metadata !== undefined) {
                        instance.metadata = parsedInstance.metadata;
                    }
                    if (parsedInstance.parentId !== undefined) {
                        instance._waitingParentId = parsedInstance.parentId;
                    }
                    if (parsedInstance.parentInstanceIndex !== undefined) {
                        instance._waitingParentInstanceIndex = parsedInstance.parentInstanceIndex;
                    }
                    if (parsedInstance.isEnabled !== undefined && parsedInstance.isEnabled !== null) {
                        instance.setEnabled(parsedInstance.isEnabled);
                    }
                    if (parsedInstance.isVisible !== undefined && parsedInstance.isVisible !== null) {
                        instance.isVisible = parsedInstance.isVisible;
                    }
                    if (parsedInstance.isPickable !== undefined && parsedInstance.isPickable !== null) {
                        instance.isPickable = parsedInstance.isPickable;
                    }
                    if (parsedInstance.rotationQuaternion) {
                        instance.rotationQuaternion = Quaternion.FromArray(parsedInstance.rotationQuaternion);
                    }
                    else if (parsedInstance.rotation) {
                        instance.rotation = Vector3.FromArray(parsedInstance.rotation);
                    }
                    instance.scaling = Vector3.FromArray(parsedInstance.scaling);
                    if (parsedInstance.checkCollisions != undefined && parsedInstance.checkCollisions != null) {
                        instance.checkCollisions = parsedInstance.checkCollisions;
                    }
                    if (parsedInstance.pickable != undefined && parsedInstance.pickable != null) {
                        instance.isPickable = parsedInstance.pickable;
                    }
                    if (parsedInstance.showBoundingBox != undefined && parsedInstance.showBoundingBox != null) {
                        instance.showBoundingBox = parsedInstance.showBoundingBox;
                    }
                    if (parsedInstance.showSubMeshesBoundingBox != undefined && parsedInstance.showSubMeshesBoundingBox != null) {
                        instance.showSubMeshesBoundingBox = parsedInstance.showSubMeshesBoundingBox;
                    }
                    if (parsedInstance.alphaIndex != undefined && parsedInstance.showSubMeshesBoundingBox != null) {
                        instance.alphaIndex = parsedInstance.alphaIndex;
                    }
                    // Physics
                    if (parsedInstance.physicsImpostor) {
                        Mesh._PhysicsImpostorParser(scene, instance, parsedInstance);
                    }
                    // Actions
                    if (parsedInstance.actions !== undefined) {
                        instance._waitingData.actions = parsedInstance.actions;
                    }
                    // Animation
                    if (parsedInstance.animations) {
                        for (let animationIndex = 0; animationIndex < parsedInstance.animations.length; animationIndex++) {
                            const parsedAnimation = parsedInstance.animations[animationIndex];
                            const internalClass = GetClass("BABYLON.Animation");
                            if (internalClass) {
                                instance.animations.push(internalClass.Parse(parsedAnimation));
                            }
                        }
                        Node.ParseAnimationRanges(instance, parsedInstance, scene);
                        if (parsedInstance.autoAnimate) {
                            scene.beginAnimation(instance, parsedInstance.autoAnimateFrom, parsedInstance.autoAnimateTo, parsedInstance.autoAnimateLoop, parsedInstance.autoAnimateSpeed || 1.0);
                        }
                    }
                }
            }
            // Thin instances
            if (parsedMesh.thinInstances) {
                const thinInstances = parsedMesh.thinInstances;
                mesh.thinInstanceEnablePicking = !!thinInstances.enablePicking;
                if (thinInstances.matrixData) {
                    mesh.thinInstanceSetBuffer("matrix", new Float32Array(thinInstances.matrixData), 16, false);
                    mesh._thinInstanceDataStorage.matrixBufferSize = thinInstances.matrixBufferSize;
                    mesh._thinInstanceDataStorage.instancesCount = thinInstances.instancesCount;
                }
                else {
                    mesh._thinInstanceDataStorage.matrixBufferSize = thinInstances.matrixBufferSize;
                }
                if (parsedMesh.thinInstances.userThinInstance) {
                    const userThinInstance = parsedMesh.thinInstances.userThinInstance;
                    for (const kind in userThinInstance.data) {
                        mesh.thinInstanceSetBuffer(kind, new Float32Array(userThinInstance.data[kind]), userThinInstance.strides[kind], false);
                        mesh._userThinInstanceBuffersStorage.sizes[kind] = userThinInstance.sizes[kind];
                    }
                }
            }
            return mesh;
        }
        // Skeletons
        /**
         * Prepare internal position array for software CPU skinning
         * @returns original positions used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh
         */
        setPositionsForCPUSkinning() {
            const internalDataInfo = this._internalMeshDataInfo;
            if (!internalDataInfo._sourcePositions) {
                const source = this.getVerticesData(VertexBuffer.PositionKind);
                if (!source) {
                    return internalDataInfo._sourcePositions;
                }
                internalDataInfo._sourcePositions = new Float32Array(source);
                if (!this.isVertexBufferUpdatable(VertexBuffer.PositionKind)) {
                    this.setVerticesData(VertexBuffer.PositionKind, source, true);
                }
            }
            return internalDataInfo._sourcePositions;
        }
        /**
         * Prepare internal normal array for software CPU skinning
         * @returns original normals used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh.
         */
        setNormalsForCPUSkinning() {
            const internalDataInfo = this._internalMeshDataInfo;
            if (!internalDataInfo._sourceNormals) {
                const source = this.getVerticesData(VertexBuffer.NormalKind);
                if (!source) {
                    return internalDataInfo._sourceNormals;
                }
                internalDataInfo._sourceNormals = new Float32Array(source);
                if (!this.isVertexBufferUpdatable(VertexBuffer.NormalKind)) {
                    this.setVerticesData(VertexBuffer.NormalKind, source, true);
                }
            }
            return internalDataInfo._sourceNormals;
        }
        /**
         * Updates the vertex buffer by applying transformation from the bones
         * @param skeleton defines the skeleton to apply to current mesh
         * @returns the current mesh
         */
        applySkeleton(skeleton) {
            if (!this.geometry) {
                return this;
            }
            if (this.geometry._softwareSkinningFrameId == this.getScene().getFrameId()) {
                return this;
            }
            this.geometry._softwareSkinningFrameId = this.getScene().getFrameId();
            if (!this.isVerticesDataPresent(VertexBuffer.PositionKind)) {
                return this;
            }
            if (!this.isVerticesDataPresent(VertexBuffer.MatricesIndicesKind)) {
                return this;
            }
            if (!this.isVerticesDataPresent(VertexBuffer.MatricesWeightsKind)) {
                return this;
            }
            const hasNormals = this.isVerticesDataPresent(VertexBuffer.NormalKind);
            const internalDataInfo = this._internalMeshDataInfo;
            if (!internalDataInfo._sourcePositions) {
                const submeshes = this.subMeshes.slice();
                this.setPositionsForCPUSkinning();
                this.subMeshes = submeshes;
            }
            if (hasNormals && !internalDataInfo._sourceNormals) {
                this.setNormalsForCPUSkinning();
            }
            // positionsData checks for not being Float32Array will only pass at most once
            let positionsData = this.getVerticesData(VertexBuffer.PositionKind);
            if (!positionsData) {
                return this;
            }
            if (!(positionsData instanceof Float32Array)) {
                positionsData = new Float32Array(positionsData);
            }
            // normalsData checks for not being Float32Array will only pass at most once
            let normalsData = this.getVerticesData(VertexBuffer.NormalKind);
            if (hasNormals) {
                if (!normalsData) {
                    return this;
                }
                if (!(normalsData instanceof Float32Array)) {
                    normalsData = new Float32Array(normalsData);
                }
            }
            const matricesIndicesData = this.getVerticesData(VertexBuffer.MatricesIndicesKind);
            const matricesWeightsData = this.getVerticesData(VertexBuffer.MatricesWeightsKind);
            if (!matricesWeightsData || !matricesIndicesData) {
                return this;
            }
            const needExtras = this.numBoneInfluencers > 4;
            const matricesIndicesExtraData = needExtras ? this.getVerticesData(VertexBuffer.MatricesIndicesExtraKind) : null;
            const matricesWeightsExtraData = needExtras ? this.getVerticesData(VertexBuffer.MatricesWeightsExtraKind) : null;
            const skeletonMatrices = skeleton.getTransformMatrices(this);
            const tempVector3 = Vector3.Zero();
            const finalMatrix = new Matrix();
            const tempMatrix = new Matrix();
            let matWeightIdx = 0;
            let inf;
            for (let index = 0; index < positionsData.length; index += 3, matWeightIdx += 4) {
                let weight;
                for (inf = 0; inf < 4; inf++) {
                    weight = matricesWeightsData[matWeightIdx + inf];
                    if (weight > 0) {
                        Matrix.FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesData[matWeightIdx + inf] * 16), weight, tempMatrix);
                        finalMatrix.addToSelf(tempMatrix);
                    }
                }
                if (needExtras) {
                    for (inf = 0; inf < 4; inf++) {
                        weight = matricesWeightsExtraData[matWeightIdx + inf];
                        if (weight > 0) {
                            Matrix.FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesExtraData[matWeightIdx + inf] * 16), weight, tempMatrix);
                            finalMatrix.addToSelf(tempMatrix);
                        }
                    }
                }
                Vector3.TransformCoordinatesFromFloatsToRef(internalDataInfo._sourcePositions[index], internalDataInfo._sourcePositions[index + 1], internalDataInfo._sourcePositions[index + 2], finalMatrix, tempVector3);
                tempVector3.toArray(positionsData, index);
                if (hasNormals) {
                    Vector3.TransformNormalFromFloatsToRef(internalDataInfo._sourceNormals[index], internalDataInfo._sourceNormals[index + 1], internalDataInfo._sourceNormals[index + 2], finalMatrix, tempVector3);
                    tempVector3.toArray(normalsData, index);
                }
                finalMatrix.reset();
            }
            this.updateVerticesData(VertexBuffer.PositionKind, positionsData);
            if (hasNormals) {
                this.updateVerticesData(VertexBuffer.NormalKind, normalsData);
            }
            return this;
        }
        // Tools
        /**
         * Returns an object containing a min and max Vector3 which are the minimum and maximum vectors of each mesh bounding box from the passed array, in the world coordinates
         * @param meshes defines the list of meshes to scan
         * @returns an object `{min:` Vector3`, max:` Vector3`}`
         */
        static MinMax(meshes) {
            let minVector = null;
            let maxVector = null;
            meshes.forEach(function (mesh) {
                const boundingInfo = mesh.getBoundingInfo();
                const boundingBox = boundingInfo.boundingBox;
                if (!minVector || !maxVector) {
                    minVector = boundingBox.minimumWorld;
                    maxVector = boundingBox.maximumWorld;
                }
                else {
                    minVector.minimizeInPlace(boundingBox.minimumWorld);
                    maxVector.maximizeInPlace(boundingBox.maximumWorld);
                }
            });
            if (!minVector || !maxVector) {
                return {
                    min: Vector3.Zero(),
                    max: Vector3.Zero(),
                };
            }
            return {
                min: minVector,
                max: maxVector,
            };
        }
        /**
         * Returns the center of the `{min:` Vector3`, max:` Vector3`}` or the center of MinMax vector3 computed from a mesh array
         * @param meshesOrMinMaxVector could be an array of meshes or a `{min:` Vector3`, max:` Vector3`}` object
         * @returns a vector3
         */
        static Center(meshesOrMinMaxVector) {
            const minMaxVector = meshesOrMinMaxVector instanceof Array ? Mesh.MinMax(meshesOrMinMaxVector) : meshesOrMinMaxVector;
            return Vector3.Center(minMaxVector.min, minMaxVector.max);
        }
        /**
         * Merge the array of meshes into a single mesh for performance reasons.
         * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
         * @param disposeSource when true (default), dispose of the vertices from the source meshes.
         * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
         * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
         * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
         * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
         * @returns a new mesh
         */
        static MergeMeshes(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials) {
            return runCoroutineSync(Mesh._MergeMeshesCoroutine(meshes, disposeSource, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, false));
        }
        /**
         * Merge the array of meshes into a single mesh for performance reasons.
         * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
         * @param disposeSource when true (default), dispose of the vertices from the source meshes.
         * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
         * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
         * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
         * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
         * @returns a new mesh
         */
        static MergeMeshesAsync(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials) {
            return runCoroutineAsync(Mesh._MergeMeshesCoroutine(meshes, disposeSource, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, true), createYieldingScheduler());
        }
        static *_MergeMeshesCoroutine(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, isAsync) {
            // Remove any null/undefined entries from the mesh array
            meshes = meshes.filter(Boolean);
            if (meshes.length === 0) {
                return null;
            }
            let index;
            if (!allow32BitsIndices) {
                let totalVertices = 0;
                // Counting vertices
                for (index = 0; index < meshes.length; index++) {
                    totalVertices += meshes[index].getTotalVertices();
                    if (totalVertices >= 65536) {
                        Logger.Warn("Cannot merge meshes because resulting mesh will have more than 65536 vertices. Please use allow32BitsIndices = true to use 32 bits indices");
                        return null;
                    }
                }
            }
            if (multiMultiMaterials) {
                subdivideWithSubMeshes = false;
            }
            const materialArray = new Array();
            const materialIndexArray = new Array();
            // Merge
            const indiceArray = new Array();
            const currentOverrideMaterialSideOrientation = meshes[0].overrideMaterialSideOrientation;
            for (index = 0; index < meshes.length; index++) {
                const mesh = meshes[index];
                if (mesh.isAnInstance) {
                    Logger.Warn("Cannot merge instance meshes.");
                    return null;
                }
                if (currentOverrideMaterialSideOrientation !== mesh.overrideMaterialSideOrientation) {
                    Logger.Warn("Cannot merge meshes with different overrideMaterialSideOrientation values.");
                    return null;
                }
                if (subdivideWithSubMeshes) {
                    indiceArray.push(mesh.getTotalIndices());
                }
                if (multiMultiMaterials) {
                    if (mesh.material) {
                        const material = mesh.material;
                        if (material instanceof MultiMaterial) {
                            for (let matIndex = 0; matIndex < material.subMaterials.length; matIndex++) {
                                if (materialArray.indexOf(material.subMaterials[matIndex]) < 0) {
                                    materialArray.push(material.subMaterials[matIndex]);
                                }
                            }
                            for (let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++) {
                                materialIndexArray.push(materialArray.indexOf(material.subMaterials[mesh.subMeshes[subIndex].materialIndex]));
                                indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                            }
                        }
                        else {
                            if (materialArray.indexOf(material) < 0) {
                                materialArray.push(material);
                            }
                            for (let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++) {
                                materialIndexArray.push(materialArray.indexOf(material));
                                indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                            }
                        }
                    }
                    else {
                        for (let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++) {
                            materialIndexArray.push(0);
                            indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                        }
                    }
                }
            }
            const source = meshes[0];
            const getVertexDataFromMesh = (mesh) => {
                const wm = mesh.computeWorldMatrix(true);
                const vertexData = VertexData.ExtractFromMesh(mesh, false, false);
                return { vertexData, transform: wm };
            };
            const { vertexData: sourceVertexData, transform: sourceTransform } = getVertexDataFromMesh(source);
            if (isAsync) {
                yield;
            }
            const meshVertexDatas = new Array(meshes.length - 1);
            for (let i = 1; i < meshes.length; i++) {
                meshVertexDatas[i - 1] = getVertexDataFromMesh(meshes[i]);
                if (isAsync) {
                    yield;
                }
            }
            const mergeCoroutine = sourceVertexData._mergeCoroutine(sourceTransform, meshVertexDatas, allow32BitsIndices, isAsync, !disposeSource);
            let mergeCoroutineStep = mergeCoroutine.next();
            while (!mergeCoroutineStep.done) {
                if (isAsync) {
                    yield;
                }
                mergeCoroutineStep = mergeCoroutine.next();
            }
            const vertexData = mergeCoroutineStep.value;
            if (!meshSubclass) {
                meshSubclass = new Mesh(source.name + "_merged", source.getScene());
            }
            const applyToCoroutine = vertexData._applyToCoroutine(meshSubclass, undefined, isAsync);
            let applyToCoroutineStep = applyToCoroutine.next();
            while (!applyToCoroutineStep.done) {
                if (isAsync) {
                    yield;
                }
                applyToCoroutineStep = applyToCoroutine.next();
            }
            // Setting properties
            meshSubclass.checkCollisions = source.checkCollisions;
            meshSubclass.overrideMaterialSideOrientation = source.overrideMaterialSideOrientation;
            // Cleaning
            if (disposeSource) {
                for (index = 0; index < meshes.length; index++) {
                    meshes[index].dispose();
                }
            }
            // Subdivide
            if (subdivideWithSubMeshes || multiMultiMaterials) {
                //-- removal of global submesh
                meshSubclass.releaseSubMeshes();
                index = 0;
                let offset = 0;
                //-- apply subdivision according to index table
                while (index < indiceArray.length) {
                    SubMesh.CreateFromIndices(0, offset, indiceArray[index], meshSubclass, undefined, false);
                    offset += indiceArray[index];
                    index++;
                }
                for (const subMesh of meshSubclass.subMeshes) {
                    subMesh.refreshBoundingInfo();
                }
                meshSubclass.computeWorldMatrix(true);
            }
            if (multiMultiMaterials) {
                const newMultiMaterial = new MultiMaterial(source.name + "_merged", source.getScene());
                newMultiMaterial.subMaterials = materialArray;
                for (let subIndex = 0; subIndex < meshSubclass.subMeshes.length; subIndex++) {
                    meshSubclass.subMeshes[subIndex].materialIndex = materialIndexArray[subIndex];
                }
                meshSubclass.material = newMultiMaterial;
            }
            else {
                meshSubclass.material = source.material;
            }
            return meshSubclass;
        }
        /**
         * @internal
         */
        addInstance(instance) {
            instance._indexInSourceMeshInstanceArray = this.instances.length;
            this.instances.push(instance);
        }
        /**
         * @internal
         */
        removeInstance(instance) {
            // Remove from mesh
            const index = instance._indexInSourceMeshInstanceArray;
            if (index != -1) {
                if (index !== this.instances.length - 1) {
                    const last = this.instances[this.instances.length - 1];
                    this.instances[index] = last;
                    last._indexInSourceMeshInstanceArray = index;
                }
                instance._indexInSourceMeshInstanceArray = -1;
                this.instances.pop();
            }
        }
        /** @internal */
        _shouldConvertRHS() {
            return this.overrideMaterialSideOrientation === Material.CounterClockWiseSideOrientation;
        }
        /** @internal */
        _getRenderingFillMode(fillMode) {
            var _a;
            const scene = this.getScene();
            if (scene.forcePointsCloud)
                return Material.PointFillMode;
            if (scene.forceWireframe)
                return Material.WireFrameFillMode;
            return (_a = this.overrideRenderingFillMode) !== null && _a !== void 0 ? _a : fillMode;
        }
        // deprecated methods
        /**
         * Sets the mesh material by the material or multiMaterial `id` property
         * @param id is a string identifying the material or the multiMaterial
         * @returns the current mesh
         * @deprecated Please use MeshBuilder instead Please use setMaterialById instead
         */
        setMaterialByID(id) {
            return this.setMaterialById(id);
        }
        /**
         * Creates a ribbon mesh.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
         * @param name defines the name of the mesh to create
         * @param pathArray is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry.
         * @param closeArray creates a seam between the first and the last paths of the path array (default is false)
         * @param closePath creates a seam between the first and the last points of each path of the path array
         * @param offset is taken in account only if the `pathArray` is containing a single path
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @param instance defines an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#ribbon)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateRibbon(name, pathArray, closeArray, closePath, offset, scene, updatable, sideOrientation, instance) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a plane polygonal mesh.  By default, this is a disc.
         * @param name defines the name of the mesh to create
         * @param radius sets the radius size (float) of the polygon (default 0.5)
         * @param tessellation sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateDisc(name, radius, tessellation, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a box mesh.
         * @param name defines the name of the mesh to create
         * @param size sets the size (float) of each box side (default 1)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateBox(name, size, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a sphere mesh.
         * @param name defines the name of the mesh to create
         * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
         * @param diameter sets the diameter size (float) of the sphere (default 1)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateSphere(name, segments, diameter, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a hemisphere mesh.
         * @param name defines the name of the mesh to create
         * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
         * @param diameter sets the diameter size (float) of the sphere (default 1)
         * @param scene defines the hosting scene
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateHemisphere(name, segments, diameter, scene) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a cylinder or a cone mesh.
         * @param name defines the name of the mesh to create
         * @param height sets the height size (float) of the cylinder/cone (float, default 2)
         * @param diameterTop set the top cap diameter (floats, default 1)
         * @param diameterBottom set the bottom cap diameter (floats, default 1). This value can't be zero
         * @param tessellation sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance
         * @param subdivisions sets the number of rings along the cylinder height (positive integer, default 1)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateCylinder(name, height, diameterTop, diameterBottom, tessellation, subdivisions, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        // Torus  (Code from SharpDX.org)
        /**
         * Creates a torus mesh.
         * @param name defines the name of the mesh to create
         * @param diameter sets the diameter size (float) of the torus (default 1)
         * @param thickness sets the diameter size of the tube of the torus (float, default 0.5)
         * @param tessellation sets the number of torus sides (positive integer, default 16)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateTorus(name, diameter, thickness, tessellation, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a torus knot mesh.
         * @param name defines the name of the mesh to create
         * @param radius sets the global radius size (float) of the torus knot (default 2)
         * @param tube sets the diameter size of the tube of the torus (float, default 0.5)
         * @param radialSegments sets the number of sides on each tube segments (positive integer, default 32)
         * @param tubularSegments sets the number of tubes to decompose the knot into (positive integer, default 32)
         * @param p the number of windings on X axis (positive integers, default 2)
         * @param q the number of windings on Y axis (positive integers, default 3)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateTorusKnot(name, radius, tube, radialSegments, tubularSegments, p, q, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a line mesh..
         * @param name defines the name of the mesh to create
         * @param points is an array successive Vector3
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines).
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateLines(name, points, scene, updatable, instance) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a dashed line mesh.
         * @param name defines the name of the mesh to create
         * @param points is an array successive Vector3
         * @param dashSize is the size of the dashes relatively the dash number (positive float, default 3)
         * @param gapSize is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
         * @param dashNb is the intended total number of dashes (positive integer, default 200)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateDashedLines(name, points, dashSize, gapSize, dashNb, scene, updatable, instance) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a polygon mesh.Please consider using the same method from the MeshBuilder class instead
         * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh.
         * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors.
         * You can set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
         * Remember you can only change the shape positions, not their number when updating a polygon.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#non-regular-polygon
         * @param name defines the name of the mesh to create
         * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
         * @param scene defines the hosting scene
         * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @param earcutInjection can be used to inject your own earcut reference
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreatePolygon(name, shape, scene, holes, updatable, sideOrientation, earcutInjection) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates an extruded polygon mesh, with depth in the Y direction..
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-non-regular-polygon
         * @param name defines the name of the mesh to create
         * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
         * @param depth defines the height of extrusion
         * @param scene defines the hosting scene
         * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @param earcutInjection can be used to inject your own earcut reference
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static ExtrudePolygon(name, shape, depth, scene, holes, updatable, sideOrientation, earcutInjection) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates an extruded shape mesh.
         * The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
         * @param name defines the name of the mesh to create
         * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
         * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
         * @param scale is the value to scale the shape
         * @param rotation is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve
         * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#extruded-shape)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static ExtrudeShape(name, shape, path, scale, rotation, cap, scene, updatable, sideOrientation, instance) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates an custom extruded shape mesh.
         * The custom extrusion is a parametric shape.
         * It has no predefined shape. Its final shape will depend on the input parameters.
         *
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
         * @param name defines the name of the mesh to create
         * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
         * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
         * @param scaleFunction is a custom Javascript function called on each path point
         * @param rotationFunction is a custom Javascript function called on each path point
         * @param ribbonCloseArray forces the extrusion underlying ribbon to close all the paths in its `pathArray`
         * @param ribbonClosePath forces the extrusion underlying ribbon to close its `pathArray`
         * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#extruded-shape)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static ExtrudeShapeCustom(name, shape, path, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, scene, updatable, sideOrientation, instance) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates lathe mesh.
         * The lathe is a shape with a symmetry axis : a 2D model shape is rotated around this axis to design the lathe.
         * @param name defines the name of the mesh to create
         * @param shape is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
         * @param radius is the radius value of the lathe
         * @param tessellation is the side number of the lathe.
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateLathe(name, shape, radius, tessellation, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a plane mesh.
         * @param name defines the name of the mesh to create
         * @param size sets the size (float) of both sides of the plane at once (default 1)
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreatePlane(name, size, scene, updatable, sideOrientation) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a ground mesh.
         * @param name defines the name of the mesh to create
         * @param width set the width of the ground
         * @param height set the height of the ground
         * @param subdivisions sets the number of subdivisions per side
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateGround(name, width, height, subdivisions, scene, updatable) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a tiled ground mesh.
         * @param name defines the name of the mesh to create
         * @param xmin set the ground minimum X coordinate
         * @param zmin set the ground minimum Y coordinate
         * @param xmax set the ground maximum X coordinate
         * @param zmax set the ground maximum Z coordinate
         * @param subdivisions is an object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
         * @param precision is an object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateTiledGround(name, xmin, zmin, xmax, zmax, subdivisions, precision, scene, updatable) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a ground mesh from a height map.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/height_map
         * @param name defines the name of the mesh to create
         * @param url sets the URL of the height map image resource
         * @param width set the ground width size
         * @param height set the ground height size
         * @param subdivisions sets the number of subdivision per side
         * @param minHeight is the minimum altitude on the ground
         * @param maxHeight is the maximum altitude on the ground
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param onReady  is a callback function that will be called  once the mesh is built (the height map download can last some time)
         * @param alphaFilter will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateGroundFromHeightMap(name, url, width, height, subdivisions, minHeight, maxHeight, scene, updatable, onReady, alphaFilter) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a tube mesh.
         * The tube is a parametric shape.
         * It has no predefined shape. Its final shape will depend on the input parameters.
         *
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
         * @param name defines the name of the mesh to create
         * @param path is a required array of successive Vector3. It is the curve used as the axis of the tube
         * @param radius sets the tube radius size
         * @param tessellation is the number of sides on the tubular surface
         * @param radiusFunction is a custom function. If it is not null, it overrides the parameter `radius`. This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path
         * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
         * @param scene defines the hosting scene
         * @param updatable defines if the mesh must be flagged as updatable
         * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
         * @param instance is an instance of an existing Tube object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#tube)
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateTube(name, path, radius, tessellation, radiusFunction, cap, scene, updatable, sideOrientation, instance) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a polyhedron mesh.
         *.
         * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embedded types. Please refer to the type sheet in the tutorial to choose the wanted type
         * * The parameter `size` (positive float, default 1) sets the polygon size
         * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
         * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overwrittes the parameter `type`
         * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
         * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
         * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
         * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
         * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
         * @param name defines the name of the mesh to create
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreatePolyhedron(name, options, scene) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
         * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
         * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value than `radius`)
         * * The parameter `subdivisions` sets the number of subdivisions (positive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
         * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
         * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra#icosphere
         * @param name defines the name of the mesh
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateIcoSphere(name, options, scene) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Creates a decal mesh.
         *.
         * A decal is a mesh usually applied as a model onto the surface of another mesh
         * @param name  defines the name of the mesh
         * @param sourceMesh defines the mesh receiving the decal
         * @param position sets the position of the decal in world coordinates
         * @param normal sets the normal of the mesh where the decal is applied onto in world coordinates
         * @param size sets the decal scaling
         * @param angle sets the angle to rotate the decal
         * @returns a new Mesh
         * @deprecated Please use MeshBuilder instead
         */
        static CreateDecal(name, sourceMesh, position, normal, size, angle) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /** Creates a Capsule Mesh
         * @param name defines the name of the mesh.
         * @param options the constructors options used to shape the mesh.
         * @param scene defines the scene the mesh is scoped to.
         * @returns the capsule mesh
         * @see https://doc.babylonjs.com/how_to/capsule_shape
         * @deprecated Please use MeshBuilder instead
         */
        static CreateCapsule(name, options, scene) {
            throw new Error("Import MeshBuilder to populate this function");
        }
        /**
         * Extends a mesh to a Goldberg mesh
         * Warning  the mesh to convert MUST be an import of a perviously exported Goldberg mesh
         * @param mesh the mesh to convert
         * @returns the extended mesh
         * @deprecated Please use ExtendMeshToGoldberg instead
         */
        static ExtendToGoldberg(mesh) {
            throw new Error("Import MeshBuilder to populate this function");
        }
    }
    // Consts
    /**
     * Mesh side orientation : usually the external or front surface
     */
    Mesh.FRONTSIDE = VertexData.FRONTSIDE;
    /**
     * Mesh side orientation : usually the internal or back surface
     */
    Mesh.BACKSIDE = VertexData.BACKSIDE;
    /**
     * Mesh side orientation : both internal and external or front and back surfaces
     */
    Mesh.DOUBLESIDE = VertexData.DOUBLESIDE;
    /**
     * Mesh side orientation : by default, `FRONTSIDE`
     */
    Mesh.DEFAULTSIDE = VertexData.DEFAULTSIDE;
    /**
     * Mesh cap setting : no cap
     */
    Mesh.NO_CAP = 0;
    /**
     * Mesh cap setting : one cap at the beginning of the mesh
     */
    Mesh.CAP_START = 1;
    /**
     * Mesh cap setting : one cap at the end of the mesh
     */
    Mesh.CAP_END = 2;
    /**
     * Mesh cap setting : two caps, one at the beginning  and one at the end of the mesh
     */
    Mesh.CAP_ALL = 3;
    /**
     * Mesh pattern setting : no flip or rotate
     */
    Mesh.NO_FLIP = 0;
    /**
     * Mesh pattern setting : flip (reflect in y axis) alternate tiles on each row or column
     */
    Mesh.FLIP_TILE = 1;
    /**
     * Mesh pattern setting : rotate (180degs) alternate tiles on each row or column
     */
    Mesh.ROTATE_TILE = 2;
    /**
     * Mesh pattern setting : flip (reflect in y axis) all tiles on alternate rows
     */
    Mesh.FLIP_ROW = 3;
    /**
     * Mesh pattern setting : rotate (180degs) all tiles on alternate rows
     */
    Mesh.ROTATE_ROW = 4;
    /**
     * Mesh pattern setting : flip and rotate alternate tiles on each row or column
     */
    Mesh.FLIP_N_ROTATE_TILE = 5;
    /**
     * Mesh pattern setting : rotate pattern and rotate
     */
    Mesh.FLIP_N_ROTATE_ROW = 6;
    /**
     * Mesh tile positioning : part tiles same on left/right or top/bottom
     */
    Mesh.CENTER = 0;
    /**
     * Mesh tile positioning : part tiles on left
     */
    Mesh.LEFT = 1;
    /**
     * Mesh tile positioning : part tiles on right
     */
    Mesh.RIGHT = 2;
    /**
     * Mesh tile positioning : part tiles on top
     */
    Mesh.TOP = 3;
    /**
     * Mesh tile positioning : part tiles on bottom
     */
    Mesh.BOTTOM = 4;
    /**
     * Indicates that the instanced meshes should be sorted from back to front before rendering if their material is transparent
     */
    Mesh.INSTANCEDMESH_SORT_TRANSPARENT = false;
    // Statics
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Mesh._GroundMeshParser = (parsedMesh, scene) => {
        throw _WarnImport("GroundMesh");
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Mesh._GoldbergMeshParser = (parsedMesh, scene) => {
        throw _WarnImport("GoldbergMesh");
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Mesh._LinesMeshParser = (parsedMesh, scene) => {
        throw _WarnImport("LinesMesh");
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Mesh._GreasedLineMeshParser = (parsedMesh, scene) => {
        throw _WarnImport("GreasedLineMesh");
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Mesh._TrailMeshParser = (parsedMesh, scene) => {
        throw _WarnImport("TrailMesh");
    };
    RegisterClass("BABYLON.Mesh", Mesh);

    /**
     * The autoRotation behavior (AutoRotationBehavior) is designed to create a smooth rotation of an ArcRotateCamera when there is no user interaction.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
     */
    class AutoRotationBehavior {
        constructor() {
            this._zoomStopsAnimation = false;
            this._idleRotationSpeed = 0.05;
            this._idleRotationWaitTime = 2000;
            this._idleRotationSpinupTime = 2000;
            this.targetAlpha = null;
            this._isPointerDown = false;
            this._lastFrameTime = null;
            this._lastInteractionTime = -Infinity;
            this._cameraRotationSpeed = 0;
            this._lastFrameRadius = 0;
        }
        /**
         * Gets the name of the behavior.
         */
        get name() {
            return "AutoRotation";
        }
        /**
         * Sets the flag that indicates if user zooming should stop animation.
         */
        set zoomStopsAnimation(flag) {
            this._zoomStopsAnimation = flag;
        }
        /**
         * Gets the flag that indicates if user zooming should stop animation.
         */
        get zoomStopsAnimation() {
            return this._zoomStopsAnimation;
        }
        /**
         * Sets the default speed at which the camera rotates around the model.
         */
        set idleRotationSpeed(speed) {
            this._idleRotationSpeed = speed;
        }
        /**
         * Gets the default speed at which the camera rotates around the model.
         */
        get idleRotationSpeed() {
            return this._idleRotationSpeed;
        }
        /**
         * Sets the time (in milliseconds) to wait after user interaction before the camera starts rotating.
         */
        set idleRotationWaitTime(time) {
            this._idleRotationWaitTime = time;
        }
        /**
         * Gets the time (milliseconds) to wait after user interaction before the camera starts rotating.
         */
        get idleRotationWaitTime() {
            return this._idleRotationWaitTime;
        }
        /**
         * Sets the time (milliseconds) to take to spin up to the full idle rotation speed.
         */
        set idleRotationSpinupTime(time) {
            this._idleRotationSpinupTime = time;
        }
        /**
         * Gets the time (milliseconds) to take to spin up to the full idle rotation speed.
         */
        get idleRotationSpinupTime() {
            return this._idleRotationSpinupTime;
        }
        /**
         * Gets a value indicating if the camera is currently rotating because of this behavior
         */
        get rotationInProgress() {
            return Math.abs(this._cameraRotationSpeed) > 0;
        }
        /**
         * Initializes the behavior.
         */
        init() {
            // Do nothing
        }
        /**
         * Attaches the behavior to its arc rotate camera.
         * @param camera Defines the camera to attach the behavior to
         */
        attach(camera) {
            this._attachedCamera = camera;
            const scene = this._attachedCamera.getScene();
            this._onPrePointerObservableObserver = scene.onPrePointerObservable.add((pointerInfoPre) => {
                if (pointerInfoPre.type === PointerEventTypes.POINTERDOWN) {
                    this._isPointerDown = true;
                    return;
                }
                if (pointerInfoPre.type === PointerEventTypes.POINTERUP) {
                    this._isPointerDown = false;
                }
            });
            this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(() => {
                if (this._reachTargetAlpha()) {
                    return;
                }
                const now = PrecisionDate.Now;
                let dt = 0;
                if (this._lastFrameTime != null) {
                    dt = now - this._lastFrameTime;
                }
                this._lastFrameTime = now;
                // Stop the animation if there is user interaction and the animation should stop for this interaction
                this._applyUserInteraction();
                const timeToRotation = now - this._lastInteractionTime - this._idleRotationWaitTime;
                const scale = Math.max(Math.min(timeToRotation / this._idleRotationSpinupTime, 1), 0);
                this._cameraRotationSpeed = this._idleRotationSpeed * scale;
                // Step camera rotation by rotation speed
                if (this._attachedCamera) {
                    this._attachedCamera.alpha -= this._cameraRotationSpeed * (dt / 1000);
                }
            });
        }
        /**
         * Detaches the behavior from its current arc rotate camera.
         */
        detach() {
            if (!this._attachedCamera) {
                return;
            }
            const scene = this._attachedCamera.getScene();
            if (this._onPrePointerObservableObserver) {
                scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
            }
            this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
            this._attachedCamera = null;
        }
        /**
         * Force-reset the last interaction time
         * @param customTime an optional time that will be used instead of the current last interaction time. For example `Date.now()`
         */
        resetLastInteractionTime(customTime) {
            this._lastInteractionTime = customTime !== null && customTime !== void 0 ? customTime : PrecisionDate.Now;
        }
        /**
         * Returns true if camera alpha reaches the target alpha
         * @returns true if camera alpha reaches the target alpha
         */
        _reachTargetAlpha() {
            if (this._attachedCamera && this.targetAlpha) {
                return Math.abs(this._attachedCamera.alpha - this.targetAlpha) < Epsilon;
            }
            return false;
        }
        /**
         * Returns true if user is scrolling.
         * @returns true if user is scrolling.
         */
        _userIsZooming() {
            if (!this._attachedCamera) {
                return false;
            }
            return this._attachedCamera.inertialRadiusOffset !== 0;
        }
        _shouldAnimationStopForInteraction() {
            if (!this._attachedCamera) {
                return false;
            }
            let zoomHasHitLimit = false;
            if (this._lastFrameRadius === this._attachedCamera.radius && this._attachedCamera.inertialRadiusOffset !== 0) {
                zoomHasHitLimit = true;
            }
            // Update the record of previous radius - works as an approx. indicator of hitting radius limits
            this._lastFrameRadius = this._attachedCamera.radius;
            return this._zoomStopsAnimation ? zoomHasHitLimit : this._userIsZooming();
        }
        /**
         *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
         */
        _applyUserInteraction() {
            if (this._userIsMoving() && !this._shouldAnimationStopForInteraction()) {
                this._lastInteractionTime = PrecisionDate.Now;
            }
        }
        // Tools
        _userIsMoving() {
            if (!this._attachedCamera) {
                return false;
            }
            return (this._attachedCamera.inertialAlphaOffset !== 0 ||
                this._attachedCamera.inertialBetaOffset !== 0 ||
                this._attachedCamera.inertialRadiusOffset !== 0 ||
                this._attachedCamera.inertialPanningX !== 0 ||
                this._attachedCamera.inertialPanningY !== 0 ||
                this._isPointerDown);
        }
    }

    /**
     * Defines potential orientation for back face culling
     */
    var Orientation;
    (function (Orientation) {
        /**
         * Clockwise
         */
        Orientation[Orientation["CW"] = 0] = "CW";
        /** Counter clockwise */
        Orientation[Orientation["CCW"] = 1] = "CCW";
    })(Orientation || (Orientation = {}));
    /**
     * Defines angle representation
     */
    class Angle {
        /**
         * Creates an Angle object of "radians" radians (float).
         * @param radians the angle in radians
         */
        constructor(radians) {
            this._radians = radians;
            if (this._radians < 0.0) {
                this._radians += 2.0 * Math.PI;
            }
        }
        /**
         * Get value in degrees
         * @returns the Angle value in degrees (float)
         */
        degrees() {
            return (this._radians * 180.0) / Math.PI;
        }
        /**
         * Get value in radians
         * @returns the Angle value in radians (float)
         */
        radians() {
            return this._radians;
        }
        /**
         * Gets a new Angle object valued with the gradient angle, in radians, of the line joining two points
         * @param a defines first point as the origin
         * @param b defines point
         * @returns a new Angle
         */
        static BetweenTwoPoints(a, b) {
            const delta = b.subtract(a);
            const theta = Math.atan2(delta.y, delta.x);
            return new Angle(theta);
        }
        /**
         * Gets a new Angle object from the given float in radians
         * @param radians defines the angle value in radians
         * @returns a new Angle
         */
        static FromRadians(radians) {
            return new Angle(radians);
        }
        /**
         * Gets a new Angle object from the given float in degrees
         * @param degrees defines the angle value in degrees
         * @returns a new Angle
         */
        static FromDegrees(degrees) {
            return new Angle((degrees * Math.PI) / 180.0);
        }
    }
    /**
     * This represents an arc in a 2d space.
     */
    class Arc2 {
        /**
         * Creates an Arc object from the three given points : start, middle and end.
         * @param startPoint Defines the start point of the arc
         * @param midPoint Defines the middle point of the arc
         * @param endPoint Defines the end point of the arc
         */
        constructor(
        /** Defines the start point of the arc */
        startPoint, 
        /** Defines the mid point of the arc */
        midPoint, 
        /** Defines the end point of the arc */
        endPoint) {
            this.startPoint = startPoint;
            this.midPoint = midPoint;
            this.endPoint = endPoint;
            const temp = Math.pow(midPoint.x, 2) + Math.pow(midPoint.y, 2);
            const startToMid = (Math.pow(startPoint.x, 2) + Math.pow(startPoint.y, 2) - temp) / 2;
            const midToEnd = (temp - Math.pow(endPoint.x, 2) - Math.pow(endPoint.y, 2)) / 2;
            const det = (startPoint.x - midPoint.x) * (midPoint.y - endPoint.y) - (midPoint.x - endPoint.x) * (startPoint.y - midPoint.y);
            this.centerPoint = new Vector2((startToMid * (midPoint.y - endPoint.y) - midToEnd * (startPoint.y - midPoint.y)) / det, ((startPoint.x - midPoint.x) * midToEnd - (midPoint.x - endPoint.x) * startToMid) / det);
            this.radius = this.centerPoint.subtract(this.startPoint).length();
            this.startAngle = Angle.BetweenTwoPoints(this.centerPoint, this.startPoint);
            const a1 = this.startAngle.degrees();
            let a2 = Angle.BetweenTwoPoints(this.centerPoint, this.midPoint).degrees();
            let a3 = Angle.BetweenTwoPoints(this.centerPoint, this.endPoint).degrees();
            // angles correction
            if (a2 - a1 > +180.0) {
                a2 -= 360.0;
            }
            if (a2 - a1 < -180.0) {
                a2 += 360.0;
            }
            if (a3 - a2 > +180.0) {
                a3 -= 360.0;
            }
            if (a3 - a2 < -180.0) {
                a3 += 360.0;
            }
            this.orientation = a2 - a1 < 0 ? Orientation.CW : Orientation.CCW;
            this.angle = Angle.FromDegrees(this.orientation === Orientation.CW ? a1 - a3 : a3 - a1);
        }
    }
    /**
     * Represents a 2D path made up of multiple 2D points
     */
    class Path2 {
        /**
         * Creates a Path2 object from the starting 2D coordinates x and y.
         * @param x the starting points x value
         * @param y the starting points y value
         */
        constructor(x, y) {
            this._points = new Array();
            this._length = 0.0;
            /**
             * If the path start and end point are the same
             */
            this.closed = false;
            this._points.push(new Vector2(x, y));
        }
        /**
         * Adds a new segment until the given coordinates (x, y) to the current Path2.
         * @param x the added points x value
         * @param y the added points y value
         * @returns the updated Path2.
         */
        addLineTo(x, y) {
            if (this.closed) {
                return this;
            }
            const newPoint = new Vector2(x, y);
            const previousPoint = this._points[this._points.length - 1];
            this._points.push(newPoint);
            this._length += newPoint.subtract(previousPoint).length();
            return this;
        }
        /**
         * Adds _numberOfSegments_ segments according to the arc definition (middle point coordinates, end point coordinates, the arc start point being the current Path2 last point) to the current Path2.
         * @param midX middle point x value
         * @param midY middle point y value
         * @param endX end point x value
         * @param endY end point y value
         * @param numberOfSegments (default: 36)
         * @returns the updated Path2.
         */
        addArcTo(midX, midY, endX, endY, numberOfSegments = 36) {
            if (this.closed) {
                return this;
            }
            const startPoint = this._points[this._points.length - 1];
            const midPoint = new Vector2(midX, midY);
            const endPoint = new Vector2(endX, endY);
            const arc = new Arc2(startPoint, midPoint, endPoint);
            let increment = arc.angle.radians() / numberOfSegments;
            if (arc.orientation === Orientation.CW) {
                increment *= -1;
            }
            let currentAngle = arc.startAngle.radians() + increment;
            for (let i = 0; i < numberOfSegments; i++) {
                const x = Math.cos(currentAngle) * arc.radius + arc.centerPoint.x;
                const y = Math.sin(currentAngle) * arc.radius + arc.centerPoint.y;
                this.addLineTo(x, y);
                currentAngle += increment;
            }
            return this;
        }
        /**
         * Adds _numberOfSegments_ segments according to the quadratic curve definition to the current Path2.
         * @param controlX control point x value
         * @param controlY control point y value
         * @param endX end point x value
         * @param endY end point y value
         * @param numberOfSegments (default: 36)
         * @returns the updated Path2.
         */
        addQuadraticCurveTo(controlX, controlY, endX, endY, numberOfSegments = 36) {
            if (this.closed) {
                return this;
            }
            const equation = (t, val0, val1, val2) => {
                const res = (1.0 - t) * (1.0 - t) * val0 + 2.0 * t * (1.0 - t) * val1 + t * t * val2;
                return res;
            };
            const startPoint = this._points[this._points.length - 1];
            for (let i = 0; i <= numberOfSegments; i++) {
                const step = i / numberOfSegments;
                const x = equation(step, startPoint.x, controlX, endX);
                const y = equation(step, startPoint.y, controlY, endY);
                this.addLineTo(x, y);
            }
            return this;
        }
        /**
         * Adds _numberOfSegments_ segments according to the bezier curve definition to the current Path2.
         * @param originTangentX tangent vector at the origin point x value
         * @param originTangentY tangent vector at the origin point y value
         * @param destinationTangentX tangent vector at the destination point x value
         * @param destinationTangentY tangent vector at the destination point y value
         * @param endX end point x value
         * @param endY end point y value
         * @param numberOfSegments (default: 36)
         * @returns the updated Path2.
         */
        addBezierCurveTo(originTangentX, originTangentY, destinationTangentX, destinationTangentY, endX, endY, numberOfSegments = 36) {
            if (this.closed) {
                return this;
            }
            const equation = (t, val0, val1, val2, val3) => {
                const res = (1.0 - t) * (1.0 - t) * (1.0 - t) * val0 + 3.0 * t * (1.0 - t) * (1.0 - t) * val1 + 3.0 * t * t * (1.0 - t) * val2 + t * t * t * val3;
                return res;
            };
            const startPoint = this._points[this._points.length - 1];
            for (let i = 0; i <= numberOfSegments; i++) {
                const step = i / numberOfSegments;
                const x = equation(step, startPoint.x, originTangentX, destinationTangentX, endX);
                const y = equation(step, startPoint.y, originTangentY, destinationTangentY, endY);
                this.addLineTo(x, y);
            }
            return this;
        }
        /**
         * Defines if a given point is inside the polygon defines by the path
         * @param point defines the point to test
         * @returns true if the point is inside
         */
        isPointInside(point) {
            let isInside = false;
            const count = this._points.length;
            for (let p = count - 1, q = 0; q < count; p = q++) {
                let edgeLow = this._points[p];
                let edgeHigh = this._points[q];
                let edgeDx = edgeHigh.x - edgeLow.x;
                let edgeDy = edgeHigh.y - edgeLow.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // Not parallel
                    if (edgeDy < 0) {
                        edgeLow = this._points[q];
                        edgeDx = -edgeDx;
                        edgeHigh = this._points[p];
                        edgeDy = -edgeDy;
                    }
                    if (point.y < edgeLow.y || point.y > edgeHigh.y) {
                        continue;
                    }
                    if (point.y === edgeLow.y && point.x === edgeLow.x) {
                        return true;
                    }
                    else {
                        const perpEdge = edgeDy * (point.x - edgeLow.x) - edgeDx * (point.y - edgeLow.y);
                        if (perpEdge === 0) {
                            return true;
                        }
                        if (perpEdge < 0) {
                            continue;
                        }
                        isInside = !isInside;
                    }
                }
                else {
                    // parallel or collinear
                    if (point.y !== edgeLow.y) {
                        continue;
                    }
                    if ((edgeHigh.x <= point.x && point.x <= edgeLow.x) || (edgeLow.x <= point.x && point.x <= edgeHigh.x)) {
                        return true;
                    }
                }
            }
            return isInside;
        }
        /**
         * Closes the Path2.
         * @returns the Path2.
         */
        close() {
            this.closed = true;
            return this;
        }
        /**
         * Gets the sum of the distance between each sequential point in the path
         * @returns the Path2 total length (float).
         */
        length() {
            let result = this._length;
            if (this.closed) {
                const lastPoint = this._points[this._points.length - 1];
                const firstPoint = this._points[0];
                result += firstPoint.subtract(lastPoint).length();
            }
            return result;
        }
        /**
         * Gets the area of the polygon defined by the path
         * @returns area value
         */
        area() {
            const n = this._points.length;
            let value = 0.0;
            for (let p = n - 1, q = 0; q < n; p = q++) {
                value += this._points[p].x * this._points[q].y - this._points[q].x * this._points[p].y;
            }
            return value * 0.5;
        }
        /**
         * Gets the points which construct the path
         * @returns the Path2 internal array of points.
         */
        getPoints() {
            return this._points;
        }
        /**
         * Retreives the point at the distance aways from the starting point
         * @param normalizedLengthPosition the length along the path to retrieve the point from
         * @returns a new Vector2 located at a percentage of the Path2 total length on this path.
         */
        getPointAtLengthPosition(normalizedLengthPosition) {
            if (normalizedLengthPosition < 0 || normalizedLengthPosition > 1) {
                return Vector2.Zero();
            }
            const lengthPosition = normalizedLengthPosition * this.length();
            let previousOffset = 0;
            for (let i = 0; i < this._points.length; i++) {
                const j = (i + 1) % this._points.length;
                const a = this._points[i];
                const b = this._points[j];
                const bToA = b.subtract(a);
                const nextOffset = bToA.length() + previousOffset;
                if (lengthPosition >= previousOffset && lengthPosition <= nextOffset) {
                    const dir = bToA.normalize();
                    const localOffset = lengthPosition - previousOffset;
                    return new Vector2(a.x + dir.x * localOffset, a.y + dir.y * localOffset);
                }
                previousOffset = nextOffset;
            }
            return Vector2.Zero();
        }
        /**
         * Creates a new path starting from an x and y position
         * @param x starting x value
         * @param y starting y value
         * @returns a new Path2 starting at the coordinates (x, y).
         */
        static StartingAt(x, y) {
            return new Path2(x, y);
        }
    }
    /**
     * Represents a 3D path made up of multiple 3D points
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/path3D
     */
    class Path3D {
        /**
         * new Path3D(path, normal, raw)
         * Creates a Path3D. A Path3D is a logical math object, so not a mesh.
         * please read the description in the tutorial : https://doc.babylonjs.com/features/featuresDeepDive/mesh/path3D
         * @param path an array of Vector3, the curve axis of the Path3D
         * @param firstNormal (options) Vector3, the first wanted normal to the curve. Ex (0, 1, 0) for a vertical normal.
         * @param raw (optional, default false) : boolean, if true the returned Path3D isn't normalized. Useful to depict path acceleration or speed.
         * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path.
         */
        constructor(
        /**
         * an array of Vector3, the curve axis of the Path3D
         */
        path, firstNormal = null, raw, alignTangentsWithPath = false) {
            this.path = path;
            this._curve = new Array();
            this._distances = new Array();
            this._tangents = new Array();
            this._normals = new Array();
            this._binormals = new Array();
            // holds interpolated point data
            this._pointAtData = {
                id: 0,
                point: Vector3.Zero(),
                previousPointArrayIndex: 0,
                position: 0,
                subPosition: 0,
                interpolateReady: false,
                interpolationMatrix: Matrix.Identity(),
            };
            for (let p = 0; p < path.length; p++) {
                this._curve[p] = path[p].clone(); // hard copy
            }
            this._raw = raw || false;
            this._alignTangentsWithPath = alignTangentsWithPath;
            this._compute(firstNormal, alignTangentsWithPath);
        }
        /**
         * Returns the Path3D array of successive Vector3 designing its curve.
         * @returns the Path3D array of successive Vector3 designing its curve.
         */
        getCurve() {
            return this._curve;
        }
        /**
         * Returns the Path3D array of successive Vector3 designing its curve.
         * @returns the Path3D array of successive Vector3 designing its curve.
         */
        getPoints() {
            return this._curve;
        }
        /**
         * @returns the computed length (float) of the path.
         */
        length() {
            return this._distances[this._distances.length - 1];
        }
        /**
         * Returns an array populated with tangent vectors on each Path3D curve point.
         * @returns an array populated with tangent vectors on each Path3D curve point.
         */
        getTangents() {
            return this._tangents;
        }
        /**
         * Returns an array populated with normal vectors on each Path3D curve point.
         * @returns an array populated with normal vectors on each Path3D curve point.
         */
        getNormals() {
            return this._normals;
        }
        /**
         * Returns an array populated with binormal vectors on each Path3D curve point.
         * @returns an array populated with binormal vectors on each Path3D curve point.
         */
        getBinormals() {
            return this._binormals;
        }
        /**
         * Returns an array populated with distances (float) of the i-th point from the first curve point.
         * @returns an array populated with distances (float) of the i-th point from the first curve point.
         */
        getDistances() {
            return this._distances;
        }
        /**
         * Returns an interpolated point along this path
         * @param position the position of the point along this path, from 0.0 to 1.0
         * @returns a new Vector3 as the point
         */
        getPointAt(position) {
            return this._updatePointAtData(position).point;
        }
        /**
         * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
         * @param position the position of the point along this path, from 0.0 to 1.0
         * @param interpolated (optional, default false) : boolean, if true returns an interpolated tangent instead of the tangent of the previous path point.
         * @returns a tangent vector corresponding to the interpolated Path3D curve point, if not interpolated, the tangent is taken from the precomputed tangents array.
         */
        getTangentAt(position, interpolated = false) {
            this._updatePointAtData(position, interpolated);
            return interpolated ? Vector3.TransformCoordinates(Vector3.Forward(), this._pointAtData.interpolationMatrix) : this._tangents[this._pointAtData.previousPointArrayIndex];
        }
        /**
         * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
         * @param position the position of the point along this path, from 0.0 to 1.0
         * @param interpolated (optional, default false) : boolean, if true returns an interpolated normal instead of the normal of the previous path point.
         * @returns a normal vector corresponding to the interpolated Path3D curve point, if not interpolated, the normal is taken from the precomputed normals array.
         */
        getNormalAt(position, interpolated = false) {
            this._updatePointAtData(position, interpolated);
            return interpolated ? Vector3.TransformCoordinates(Vector3.Right(), this._pointAtData.interpolationMatrix) : this._normals[this._pointAtData.previousPointArrayIndex];
        }
        /**
         * Returns the binormal vector of an interpolated Path3D curve point at the specified position along this path.
         * @param position the position of the point along this path, from 0.0 to 1.0
         * @param interpolated (optional, default false) : boolean, if true returns an interpolated binormal instead of the binormal of the previous path point.
         * @returns a binormal vector corresponding to the interpolated Path3D curve point, if not interpolated, the binormal is taken from the precomputed binormals array.
         */
        getBinormalAt(position, interpolated = false) {
            this._updatePointAtData(position, interpolated);
            return interpolated ? Vector3.TransformCoordinates(Vector3.UpReadOnly, this._pointAtData.interpolationMatrix) : this._binormals[this._pointAtData.previousPointArrayIndex];
        }
        /**
         * Returns the distance (float) of an interpolated Path3D curve point at the specified position along this path.
         * @param position the position of the point along this path, from 0.0 to 1.0
         * @returns the distance of the interpolated Path3D curve point at the specified position along this path.
         */
        getDistanceAt(position) {
            return this.length() * position;
        }
        /**
         * Returns the array index of the previous point of an interpolated point along this path
         * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
         * @returns the array index
         */
        getPreviousPointIndexAt(position) {
            this._updatePointAtData(position);
            return this._pointAtData.previousPointArrayIndex;
        }
        /**
         * Returns the position of an interpolated point relative to the two path points it lies between, from 0.0 (point A) to 1.0 (point B)
         * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
         * @returns the sub position
         */
        getSubPositionAt(position) {
            this._updatePointAtData(position);
            return this._pointAtData.subPosition;
        }
        /**
         * Returns the position of the closest virtual point on this path to an arbitrary Vector3, from 0.0 to 1.0
         * @param target the vector of which to get the closest position to
         * @returns the position of the closest virtual point on this path to the target vector
         */
        getClosestPositionTo(target) {
            let smallestDistance = Number.MAX_VALUE;
            let closestPosition = 0.0;
            for (let i = 0; i < this._curve.length - 1; i++) {
                const point = this._curve[i + 0];
                const tangent = this._curve[i + 1].subtract(point).normalize();
                const subLength = this._distances[i + 1] - this._distances[i + 0];
                const subPosition = Math.min((Math.max(Vector3.Dot(tangent, target.subtract(point).normalize()), 0.0) * Vector3.Distance(point, target)) / subLength, 1.0);
                const distance = Vector3.Distance(point.add(tangent.scale(subPosition * subLength)), target);
                if (distance < smallestDistance) {
                    smallestDistance = distance;
                    closestPosition = (this._distances[i + 0] + subLength * subPosition) / this.length();
                }
            }
            return closestPosition;
        }
        /**
         * Returns a sub path (slice) of this path
         * @param start the position of the fist path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
         * @param end the position of the last path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
         * @returns a sub path (slice) of this path
         */
        slice(start = 0.0, end = 1.0) {
            if (start < 0.0) {
                start = 1 - ((start * -1.0) % 1.0);
            }
            if (end < 0.0) {
                end = 1 - ((end * -1.0) % 1.0);
            }
            if (start > end) {
                const _start = start;
                start = end;
                end = _start;
            }
            const curvePoints = this.getCurve();
            const startPoint = this.getPointAt(start);
            let startIndex = this.getPreviousPointIndexAt(start);
            const endPoint = this.getPointAt(end);
            const endIndex = this.getPreviousPointIndexAt(end) + 1;
            const slicePoints = [];
            if (start !== 0.0) {
                startIndex++;
                slicePoints.push(startPoint);
            }
            slicePoints.push(...curvePoints.slice(startIndex, endIndex));
            if (end !== 1.0 || start === 1.0) {
                slicePoints.push(endPoint);
            }
            return new Path3D(slicePoints, this.getNormalAt(start), this._raw, this._alignTangentsWithPath);
        }
        /**
         * Forces the Path3D tangent, normal, binormal and distance recomputation.
         * @param path path which all values are copied into the curves points
         * @param firstNormal which should be projected onto the curve
         * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path
         * @returns the same object updated.
         */
        update(path, firstNormal = null, alignTangentsWithPath = false) {
            for (let p = 0; p < path.length; p++) {
                this._curve[p].x = path[p].x;
                this._curve[p].y = path[p].y;
                this._curve[p].z = path[p].z;
            }
            this._compute(firstNormal, alignTangentsWithPath);
            return this;
        }
        // private function compute() : computes tangents, normals and binormals
        _compute(firstNormal, alignTangentsWithPath = false) {
            const l = this._curve.length;
            if (l < 2) {
                return;
            }
            // first and last tangents
            this._tangents[0] = this._getFirstNonNullVector(0);
            if (!this._raw) {
                this._tangents[0].normalize();
            }
            this._tangents[l - 1] = this._curve[l - 1].subtract(this._curve[l - 2]);
            if (!this._raw) {
                this._tangents[l - 1].normalize();
            }
            // normals and binormals at first point : arbitrary vector with _normalVector()
            const tg0 = this._tangents[0];
            const pp0 = this._normalVector(tg0, firstNormal);
            this._normals[0] = pp0;
            if (!this._raw) {
                this._normals[0].normalize();
            }
            this._binormals[0] = Vector3.Cross(tg0, this._normals[0]);
            if (!this._raw) {
                this._binormals[0].normalize();
            }
            this._distances[0] = 0.0;
            // normals and binormals : next points
            let prev; // previous vector (segment)
            let cur; // current vector (segment)
            let curTang; // current tangent
            // previous normal
            let prevNor; // previous normal
            let prevBinor; // previous binormal
            for (let i = 1; i < l; i++) {
                // tangents
                prev = this._getLastNonNullVector(i);
                if (i < l - 1) {
                    cur = this._getFirstNonNullVector(i);
                    this._tangents[i] = alignTangentsWithPath ? cur : prev.add(cur);
                    this._tangents[i].normalize();
                }
                this._distances[i] = this._distances[i - 1] + this._curve[i].subtract(this._curve[i - 1]).length();
                // normals and binormals
                // http://www.cs.cmu.edu/afs/andrew/scs/cs/15-462/web/old/asst2camera.html
                curTang = this._tangents[i];
                prevBinor = this._binormals[i - 1];
                this._normals[i] = Vector3.Cross(prevBinor, curTang);
                if (!this._raw) {
                    if (this._normals[i].length() === 0) {
                        prevNor = this._normals[i - 1];
                        this._normals[i] = prevNor.clone();
                    }
                    else {
                        this._normals[i].normalize();
                    }
                }
                this._binormals[i] = Vector3.Cross(curTang, this._normals[i]);
                if (!this._raw) {
                    this._binormals[i].normalize();
                }
            }
            this._pointAtData.id = NaN;
        }
        // private function getFirstNonNullVector(index)
        // returns the first non null vector from index : curve[index + N].subtract(curve[index])
        _getFirstNonNullVector(index) {
            let i = 1;
            let nNVector = this._curve[index + i].subtract(this._curve[index]);
            while (nNVector.length() === 0 && index + i + 1 < this._curve.length) {
                i++;
                nNVector = this._curve[index + i].subtract(this._curve[index]);
            }
            return nNVector;
        }
        // private function getLastNonNullVector(index)
        // returns the last non null vector from index : curve[index].subtract(curve[index - N])
        _getLastNonNullVector(index) {
            let i = 1;
            let nLVector = this._curve[index].subtract(this._curve[index - i]);
            while (nLVector.length() === 0 && index > i + 1) {
                i++;
                nLVector = this._curve[index].subtract(this._curve[index - i]);
            }
            return nLVector;
        }
        // private function normalVector(v0, vt, va) :
        // returns an arbitrary point in the plane defined by the point v0 and the vector vt orthogonal to this plane
        // if va is passed, it returns the va projection on the plane orthogonal to vt at the point v0
        _normalVector(vt, va) {
            let normal0;
            let tgl = vt.length();
            if (tgl === 0.0) {
                tgl = 1.0;
            }
            if (va === undefined || va === null) {
                let point;
                if (!Scalar.WithinEpsilon(Math.abs(vt.y) / tgl, 1.0, Epsilon)) {
                    // search for a point in the plane
                    point = new Vector3(0.0, -1.0, 0.0);
                }
                else if (!Scalar.WithinEpsilon(Math.abs(vt.x) / tgl, 1.0, Epsilon)) {
                    point = new Vector3(1.0, 0.0, 0.0);
                }
                else if (!Scalar.WithinEpsilon(Math.abs(vt.z) / tgl, 1.0, Epsilon)) {
                    point = new Vector3(0.0, 0.0, 1.0);
                }
                else {
                    point = Vector3.Zero();
                }
                normal0 = Vector3.Cross(vt, point);
            }
            else {
                normal0 = Vector3.Cross(vt, va);
                Vector3.CrossToRef(normal0, vt, normal0);
            }
            normal0.normalize();
            return normal0;
        }
        /**
         * Updates the point at data for an interpolated point along this curve
         * @param position the position of the point along this curve, from 0.0 to 1.0
         * @param interpolateTNB
         * @interpolateTNB whether to compute the interpolated tangent, normal and binormal
         * @returns the (updated) point at data
         */
        _updatePointAtData(position, interpolateTNB = false) {
            // set an id for caching the result
            if (this._pointAtData.id === position) {
                if (!this._pointAtData.interpolateReady) {
                    this._updateInterpolationMatrix();
                }
                return this._pointAtData;
            }
            else {
                this._pointAtData.id = position;
            }
            const curvePoints = this.getPoints();
            // clamp position between 0.0 and 1.0
            if (position <= 0.0) {
                return this._setPointAtData(0.0, 0.0, curvePoints[0], 0, interpolateTNB);
            }
            else if (position >= 1.0) {
                return this._setPointAtData(1.0, 1.0, curvePoints[curvePoints.length - 1], curvePoints.length - 1, interpolateTNB);
            }
            let previousPoint = curvePoints[0];
            let currentPoint;
            let currentLength = 0.0;
            const targetLength = position * this.length();
            for (let i = 1; i < curvePoints.length; i++) {
                currentPoint = curvePoints[i];
                const distance = Vector3.Distance(previousPoint, currentPoint);
                currentLength += distance;
                if (currentLength === targetLength) {
                    return this._setPointAtData(position, 1.0, currentPoint, i, interpolateTNB);
                }
                else if (currentLength > targetLength) {
                    const toLength = currentLength - targetLength;
                    const diff = toLength / distance;
                    const dir = previousPoint.subtract(currentPoint);
                    const point = currentPoint.add(dir.scaleInPlace(diff));
                    return this._setPointAtData(position, 1 - diff, point, i - 1, interpolateTNB);
                }
                previousPoint = currentPoint;
            }
            return this._pointAtData;
        }
        /**
         * Updates the point at data from the specified parameters
         * @param position where along the path the interpolated point is, from 0.0 to 1.0
         * @param subPosition
         * @param point the interpolated point
         * @param parentIndex the index of an existing curve point that is on, or else positionally the first behind, the interpolated point
         * @param interpolateTNB
         */
        _setPointAtData(position, subPosition, point, parentIndex, interpolateTNB) {
            this._pointAtData.point = point;
            this._pointAtData.position = position;
            this._pointAtData.subPosition = subPosition;
            this._pointAtData.previousPointArrayIndex = parentIndex;
            this._pointAtData.interpolateReady = interpolateTNB;
            if (interpolateTNB) {
                this._updateInterpolationMatrix();
            }
            return this._pointAtData;
        }
        /**
         * Updates the point at interpolation matrix for the tangents, normals and binormals
         */
        _updateInterpolationMatrix() {
            this._pointAtData.interpolationMatrix = Matrix.Identity();
            const parentIndex = this._pointAtData.previousPointArrayIndex;
            if (parentIndex !== this._tangents.length - 1) {
                const index = parentIndex + 1;
                const tangentFrom = this._tangents[parentIndex].clone();
                const normalFrom = this._normals[parentIndex].clone();
                const binormalFrom = this._binormals[parentIndex].clone();
                const tangentTo = this._tangents[index].clone();
                const normalTo = this._normals[index].clone();
                const binormalTo = this._binormals[index].clone();
                const quatFrom = Quaternion.RotationQuaternionFromAxis(normalFrom, binormalFrom, tangentFrom);
                const quatTo = Quaternion.RotationQuaternionFromAxis(normalTo, binormalTo, tangentTo);
                const quatAt = Quaternion.Slerp(quatFrom, quatTo, this._pointAtData.subPosition);
                quatAt.toRotationMatrix(this._pointAtData.interpolationMatrix);
            }
        }
    }
    /**
     * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space.
     * A Curve3 is designed from a series of successive Vector3.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves
     */
    class Curve3 {
        /**
         * Returns a Curve3 object along a Quadratic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#quadratic-bezier-curve
         * @param v0 (Vector3) the origin point of the Quadratic Bezier
         * @param v1 (Vector3) the control point
         * @param v2 (Vector3) the end point of the Quadratic Bezier
         * @param nbPoints (integer) the wanted number of points in the curve
         * @returns the created Curve3
         */
        static CreateQuadraticBezier(v0, v1, v2, nbPoints) {
            nbPoints = nbPoints > 2 ? nbPoints : 3;
            const bez = new Array();
            const equation = (t, val0, val1, val2) => {
                const res = (1.0 - t) * (1.0 - t) * val0 + 2.0 * t * (1.0 - t) * val1 + t * t * val2;
                return res;
            };
            for (let i = 0; i <= nbPoints; i++) {
                bez.push(new Vector3(equation(i / nbPoints, v0.x, v1.x, v2.x), equation(i / nbPoints, v0.y, v1.y, v2.y), equation(i / nbPoints, v0.z, v1.z, v2.z)));
            }
            return new Curve3(bez);
        }
        /**
         * Returns a Curve3 object along a Cubic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#cubic-bezier-curve
         * @param v0 (Vector3) the origin point of the Cubic Bezier
         * @param v1 (Vector3) the first control point
         * @param v2 (Vector3) the second control point
         * @param v3 (Vector3) the end point of the Cubic Bezier
         * @param nbPoints (integer) the wanted number of points in the curve
         * @returns the created Curve3
         */
        static CreateCubicBezier(v0, v1, v2, v3, nbPoints) {
            nbPoints = nbPoints > 3 ? nbPoints : 4;
            const bez = new Array();
            const equation = (t, val0, val1, val2, val3) => {
                const res = (1.0 - t) * (1.0 - t) * (1.0 - t) * val0 + 3.0 * t * (1.0 - t) * (1.0 - t) * val1 + 3.0 * t * t * (1.0 - t) * val2 + t * t * t * val3;
                return res;
            };
            for (let i = 0; i <= nbPoints; i++) {
                bez.push(new Vector3(equation(i / nbPoints, v0.x, v1.x, v2.x, v3.x), equation(i / nbPoints, v0.y, v1.y, v2.y, v3.y), equation(i / nbPoints, v0.z, v1.z, v2.z, v3.z)));
            }
            return new Curve3(bez);
        }
        /**
         * Returns a Curve3 object along a Hermite Spline curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-spline
         * @param p1 (Vector3) the origin point of the Hermite Spline
         * @param t1 (Vector3) the tangent vector at the origin point
         * @param p2 (Vector3) the end point of the Hermite Spline
         * @param t2 (Vector3) the tangent vector at the end point
         * @param nSeg (integer) the number of curve segments or nSeg + 1 points in the array
         * @returns the created Curve3
         */
        static CreateHermiteSpline(p1, t1, p2, t2, nSeg) {
            const hermite = new Array();
            const step = 1.0 / nSeg;
            for (let i = 0; i <= nSeg; i++) {
                hermite.push(Vector3.Hermite(p1, t1, p2, t2, i * step));
            }
            return new Curve3(hermite);
        }
        /**
         * Returns a Curve3 object along a CatmullRom Spline curve :
         * @param points (array of Vector3) the points the spline must pass through. At least, four points required
         * @param nbPoints (integer) the wanted number of points between each curve control points
         * @param closed (boolean) optional with default false, when true forms a closed loop from the points
         * @returns the created Curve3
         */
        static CreateCatmullRomSpline(points, nbPoints, closed) {
            const catmullRom = new Array();
            const step = 1.0 / nbPoints;
            let amount = 0.0;
            if (closed) {
                const pointsCount = points.length;
                for (let i = 0; i < pointsCount; i++) {
                    amount = 0;
                    for (let c = 0; c < nbPoints; c++) {
                        catmullRom.push(Vector3.CatmullRom(points[i % pointsCount], points[(i + 1) % pointsCount], points[(i + 2) % pointsCount], points[(i + 3) % pointsCount], amount));
                        amount += step;
                    }
                }
                catmullRom.push(catmullRom[0]);
            }
            else {
                const totalPoints = new Array();
                totalPoints.push(points[0].clone());
                Array.prototype.push.apply(totalPoints, points);
                totalPoints.push(points[points.length - 1].clone());
                let i = 0;
                for (; i < totalPoints.length - 3; i++) {
                    amount = 0;
                    for (let c = 0; c < nbPoints; c++) {
                        catmullRom.push(Vector3.CatmullRom(totalPoints[i], totalPoints[i + 1], totalPoints[i + 2], totalPoints[i + 3], amount));
                        amount += step;
                    }
                }
                i--;
                catmullRom.push(Vector3.CatmullRom(totalPoints[i], totalPoints[i + 1], totalPoints[i + 2], totalPoints[i + 3], amount));
            }
            return new Curve3(catmullRom);
        }
        /**
         * Returns a Curve3 object along an arc through three vector3 points:
         * The three points should not be colinear. When they are the Curve3 is empty.
         * @param first (Vector3) the first point the arc must pass through.
         * @param second (Vector3) the second point the arc must pass through.
         * @param third (Vector3) the third point the arc must pass through.
         * @param steps (number) the larger the number of steps the more detailed the arc.
         * @param closed (boolean) optional with default false, when true forms the chord from the first and third point
         * @param fullCircle Circle (boolean) optional with default false, when true forms the complete circle through the three points
         * @returns the created Curve3
         */
        static ArcThru3Points(first, second, third, steps = 32, closed = false, fullCircle = false) {
            const arc = new Array();
            const vec1 = second.subtract(first);
            const vec2 = third.subtract(second);
            const vec3 = first.subtract(third);
            const zAxis = Vector3.Cross(vec1, vec2);
            const len4 = zAxis.length();
            if (len4 < Math.pow(10, -8)) {
                return new Curve3(arc); // colinear points arc is empty
            }
            const len1_sq = vec1.lengthSquared();
            const len2_sq = vec2.lengthSquared();
            const len3_sq = vec3.lengthSquared();
            const len4_sq = zAxis.lengthSquared();
            const len1 = vec1.length();
            const len2 = vec2.length();
            const len3 = vec3.length();
            const radius = (0.5 * len1 * len2 * len3) / len4;
            const dot1 = Vector3.Dot(vec1, vec3);
            const dot2 = Vector3.Dot(vec1, vec2);
            const dot3 = Vector3.Dot(vec2, vec3);
            const a = (-0.5 * len2_sq * dot1) / len4_sq;
            const b = (-0.5 * len3_sq * dot2) / len4_sq;
            const c = (-0.5 * len1_sq * dot3) / len4_sq;
            const center = first.scale(a).add(second.scale(b)).add(third.scale(c));
            const radiusVec = first.subtract(center);
            const xAxis = radiusVec.normalize();
            const yAxis = Vector3.Cross(zAxis, xAxis).normalize();
            if (fullCircle) {
                const dStep = (2 * Math.PI) / steps;
                for (let theta = 0; theta <= 2 * Math.PI; theta += dStep) {
                    arc.push(center.add(xAxis.scale(radius * Math.cos(theta)).add(yAxis.scale(radius * Math.sin(theta)))));
                }
                arc.push(first);
            }
            else {
                const dStep = 1 / steps;
                let theta = 0;
                let point = Vector3.Zero();
                do {
                    point = center.add(xAxis.scale(radius * Math.cos(theta)).add(yAxis.scale(radius * Math.sin(theta))));
                    arc.push(point);
                    theta += dStep;
                } while (!point.equalsWithEpsilon(third, radius * dStep * 1.1));
                arc.push(third);
                if (closed) {
                    arc.push(first);
                }
            }
            return new Curve3(arc);
        }
        /**
         * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space.
         * A Curve3 is designed from a series of successive Vector3.
         * Tuto : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#curve3-object
         * @param points points which make up the curve
         */
        constructor(points) {
            this._length = 0.0;
            this._points = points;
            this._length = this._computeLength(points);
        }
        /**
         * @returns the Curve3 stored array of successive Vector3
         */
        getPoints() {
            return this._points;
        }
        /**
         * @returns the computed length (float) of the curve.
         */
        length() {
            return this._length;
        }
        /**
         * Returns a new instance of Curve3 object : var curve = curveA.continue(curveB);
         * This new Curve3 is built by translating and sticking the curveB at the end of the curveA.
         * curveA and curveB keep unchanged.
         * @param curve the curve to continue from this curve
         * @returns the newly constructed curve
         */
        continue(curve) {
            const lastPoint = this._points[this._points.length - 1];
            const continuedPoints = this._points.slice();
            const curvePoints = curve.getPoints();
            for (let i = 1; i < curvePoints.length; i++) {
                continuedPoints.push(curvePoints[i].subtract(curvePoints[0]).add(lastPoint));
            }
            const continuedCurve = new Curve3(continuedPoints);
            return continuedCurve;
        }
        _computeLength(path) {
            let l = 0;
            for (let i = 1; i < path.length; i++) {
                l += path[i].subtract(path[i - 1]).length();
            }
            return l;
        }
    }

    /**
     * Base class used for every default easing function.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#easing-functions
     */
    class EasingFunction {
        constructor() {
            this._easingMode = EasingFunction.EASINGMODE_EASEIN;
        }
        /**
         * Sets the easing mode of the current function.
         * @param easingMode Defines the willing mode (EASINGMODE_EASEIN, EASINGMODE_EASEOUT or EASINGMODE_EASEINOUT)
         */
        setEasingMode(easingMode) {
            const n = Math.min(Math.max(easingMode, 0), 2);
            this._easingMode = n;
        }
        /**
         * Gets the current easing mode.
         * @returns the easing mode
         */
        getEasingMode() {
            return this._easingMode;
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        easeInCore(gradient) {
            throw new Error("You must implement this method");
        }
        /**
         * Given an input gradient between 0 and 1, this returns the corresponding value
         * of the easing function.
         * @param gradient Defines the value between 0 and 1 we want the easing value for
         * @returns the corresponding value on the curve defined by the easing function
         */
        ease(gradient) {
            switch (this._easingMode) {
                case EasingFunction.EASINGMODE_EASEIN:
                    return this.easeInCore(gradient);
                case EasingFunction.EASINGMODE_EASEOUT:
                    return 1 - this.easeInCore(1 - gradient);
            }
            if (gradient >= 0.5) {
                return (1 - this.easeInCore((1 - gradient) * 2)) * 0.5 + 0.5;
            }
            return this.easeInCore(gradient * 2) * 0.5;
        }
    }
    /**
     * Interpolation follows the mathematical formula associated with the easing function.
     */
    EasingFunction.EASINGMODE_EASEIN = 0;
    /**
     * Interpolation follows 100% interpolation minus the output of the formula associated with the easing function.
     */
    EasingFunction.EASINGMODE_EASEOUT = 1;
    /**
     * Interpolation uses EaseIn for the first half of the animation and EaseOut for the second half.
     */
    EasingFunction.EASINGMODE_EASEINOUT = 2;
    /**
     * Easing function with a circle shape (see link below).
     * @see https://easings.net/#easeInCirc
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#easing-functions
     */
    class CircleEase extends EasingFunction {
        /**
         * @internal
         */
        easeInCore(gradient) {
            gradient = Math.max(0, Math.min(1, gradient));
            return 1.0 - Math.sqrt(1.0 - gradient * gradient);
        }
    }
    /**
     * Easing function with a ease back shape (see link below).
     * @see https://easings.net/#easeInBack
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#easing-functions
     */
    class BackEase extends EasingFunction {
        /**
         * Instantiates a back ease easing
         * @see https://easings.net/#easeInBack
         * @param amplitude Defines the amplitude of the function
         */
        constructor(
        /** Defines the amplitude of the function */
        amplitude = 1) {
            super();
            this.amplitude = amplitude;
        }
        /**
         * @internal
         */
        easeInCore(gradient) {
            const num = Math.max(0, this.amplitude);
            return Math.pow(gradient, 3.0) - gradient * num * Math.sin(3.1415926535897931 * gradient);
        }
    }
    /**
     * Easing function with an exponential shape (see link below).
     * @see https://easings.net/#easeInExpo
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#easing-functions
     */
    class ExponentialEase extends EasingFunction {
        /**
         * Instantiates an exponential easing function
         * @see https://easings.net/#easeInExpo
         * @param exponent Defines the exponent of the function
         */
        constructor(
        /** Defines the exponent of the function */
        exponent = 2) {
            super();
            this.exponent = exponent;
        }
        /**
         * @internal
         */
        easeInCore(gradient) {
            if (this.exponent <= 0) {
                return gradient;
            }
            return (Math.exp(this.exponent * gradient) - 1.0) / (Math.exp(this.exponent) - 1.0);
        }
    }
    /**
     * Easing function with a power of 2 shape (see link below).
     * @see https://easings.net/#easeInQuad
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#easing-functions
     */
    class QuadraticEase extends EasingFunction {
        /**
         * @internal
         */
        easeInCore(gradient) {
            return gradient * gradient;
        }
    }
    /**
     * Easing function with a sin shape (see link below).
     * @see https://easings.net/#easeInSine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#easing-functions
     */
    class SineEase extends EasingFunction {
        /**
         * @internal
         */
        easeInCore(gradient) {
            return 1.0 - Math.sin(1.5707963267948966 * (1.0 - gradient));
        }
    }

    /**
     * Enum for the animation key frame interpolation type
     */
    var AnimationKeyInterpolation;
    (function (AnimationKeyInterpolation) {
        /**
         * Use tangents to interpolate between start and end values.
         */
        AnimationKeyInterpolation[AnimationKeyInterpolation["NONE"] = 0] = "NONE";
        /**
         * Do not interpolate between keys and use the start key value only. Tangents are ignored
         */
        AnimationKeyInterpolation[AnimationKeyInterpolation["STEP"] = 1] = "STEP";
    })(AnimationKeyInterpolation || (AnimationKeyInterpolation = {}));

    /**
     * Represents the range of an animation
     */
    class AnimationRange {
        /**
         * Initializes the range of an animation
         * @param name The name of the animation range
         * @param from The starting frame of the animation
         * @param to The ending frame of the animation
         */
        constructor(
        /**The name of the animation range**/
        name, 
        /**The starting frame of the animation */
        from, 
        /**The ending frame of the animation*/
        to) {
            this.name = name;
            this.from = from;
            this.to = to;
        }
        /**
         * Makes a copy of the animation range
         * @returns A copy of the animation range
         */
        clone() {
            return new AnimationRange(this.name, this.from, this.to);
        }
    }

    /**
     * Size containing width and height
     */
    class Size {
        /**
         * Creates a Size object from the given width and height (floats).
         * @param width width of the new size
         * @param height height of the new size
         */
        constructor(width, height) {
            this.width = width;
            this.height = height;
        }
        /**
         * Returns a string with the Size width and height
         * @returns a string with the Size width and height
         */
        toString() {
            return `{W: ${this.width}, H: ${this.height}}`;
        }
        /**
         * "Size"
         * @returns the string "Size"
         */
        getClassName() {
            return "Size";
        }
        /**
         * Returns the Size hash code.
         * @returns a hash code for a unique width and height
         */
        getHashCode() {
            let hash = this.width | 0;
            hash = (hash * 397) ^ (this.height | 0);
            return hash;
        }
        /**
         * Updates the current size from the given one.
         * @param src the given size
         */
        copyFrom(src) {
            this.width = src.width;
            this.height = src.height;
        }
        /**
         * Updates in place the current Size from the given floats.
         * @param width width of the new size
         * @param height height of the new size
         * @returns the updated Size.
         */
        copyFromFloats(width, height) {
            this.width = width;
            this.height = height;
            return this;
        }
        /**
         * Updates in place the current Size from the given floats.
         * @param width width to set
         * @param height height to set
         * @returns the updated Size.
         */
        set(width, height) {
            return this.copyFromFloats(width, height);
        }
        /**
         * Multiplies the width and height by numbers
         * @param w factor to multiple the width by
         * @param h factor to multiple the height by
         * @returns a new Size set with the multiplication result of the current Size and the given floats.
         */
        multiplyByFloats(w, h) {
            return new Size(this.width * w, this.height * h);
        }
        /**
         * Clones the size
         * @returns a new Size copied from the given one.
         */
        clone() {
            return new Size(this.width, this.height);
        }
        /**
         * True if the current Size and the given one width and height are strictly equal.
         * @param other the other size to compare against
         * @returns True if the current Size and the given one width and height are strictly equal.
         */
        equals(other) {
            if (!other) {
                return false;
            }
            return this.width === other.width && this.height === other.height;
        }
        /**
         * The surface of the Size : width * height (float).
         */
        get surface() {
            return this.width * this.height;
        }
        /**
         * Create a new size of zero
         * @returns a new Size set to (0.0, 0.0)
         */
        static Zero() {
            return new Size(0.0, 0.0);
        }
        /**
         * Sums the width and height of two sizes
         * @param otherSize size to add to this size
         * @returns a new Size set as the addition result of the current Size and the given one.
         */
        add(otherSize) {
            const r = new Size(this.width + otherSize.width, this.height + otherSize.height);
            return r;
        }
        /**
         * Subtracts the width and height of two
         * @param otherSize size to subtract to this size
         * @returns a new Size set as the subtraction result of  the given one from the current Size.
         */
        subtract(otherSize) {
            const r = new Size(this.width - otherSize.width, this.height - otherSize.height);
            return r;
        }
        /**
         * Creates a new Size set at the linear interpolation "amount" between "start" and "end"
         * @param start starting size to lerp between
         * @param end end size to lerp between
         * @param amount amount to lerp between the start and end values
         * @returns a new Size set at the linear interpolation "amount" between "start" and "end"
         */
        static Lerp(start, end, amount) {
            const w = start.width + (end.width - start.width) * amount;
            const h = start.height + (end.height - start.height) * amount;
            return new Size(w, h);
        }
    }

    /**
     * Class used to store any kind of animation
     */
    class Animation {
        /**
         * @internal Internal use
         */
        static _PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction) {
            let dataType = undefined;
            if (!isNaN(parseFloat(from)) && isFinite(from)) {
                dataType = Animation.ANIMATIONTYPE_FLOAT;
            }
            else if (from instanceof Quaternion) {
                dataType = Animation.ANIMATIONTYPE_QUATERNION;
            }
            else if (from instanceof Vector3) {
                dataType = Animation.ANIMATIONTYPE_VECTOR3;
            }
            else if (from instanceof Vector2) {
                dataType = Animation.ANIMATIONTYPE_VECTOR2;
            }
            else if (from instanceof Color3) {
                dataType = Animation.ANIMATIONTYPE_COLOR3;
            }
            else if (from instanceof Color4) {
                dataType = Animation.ANIMATIONTYPE_COLOR4;
            }
            else if (from instanceof Size) {
                dataType = Animation.ANIMATIONTYPE_SIZE;
            }
            if (dataType == undefined) {
                return null;
            }
            const animation = new Animation(name, targetProperty, framePerSecond, dataType, loopMode);
            const keys = [
                { frame: 0, value: from },
                { frame: totalFrame, value: to },
            ];
            animation.setKeys(keys);
            if (easingFunction !== undefined) {
                animation.setEasingFunction(easingFunction);
            }
            return animation;
        }
        /**
         * Sets up an animation
         * @param property The property to animate
         * @param animationType The animation type to apply
         * @param framePerSecond The frames per second of the animation
         * @param easingFunction The easing function used in the animation
         * @returns The created animation
         */
        static CreateAnimation(property, animationType, framePerSecond, easingFunction) {
            const animation = new Animation(property + "Animation", property, framePerSecond, animationType, Animation.ANIMATIONLOOPMODE_CONSTANT);
            animation.setEasingFunction(easingFunction);
            return animation;
        }
        /**
         * Create and start an animation on a node
         * @param name defines the name of the global animation that will be run on all nodes
         * @param target defines the target where the animation will take place
         * @param targetProperty defines property to animate
         * @param framePerSecond defines the number of frame per second yo use
         * @param totalFrame defines the number of frames in total
         * @param from defines the initial value
         * @param to defines the final value
         * @param loopMode defines which loop mode you want to use (off by default)
         * @param easingFunction defines the easing function to use (linear by default)
         * @param onAnimationEnd defines the callback to call when animation end
         * @param scene defines the hosting scene
         * @returns the animatable created for this animation
         */
        static CreateAndStartAnimation(name, target, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd, scene) {
            const animation = Animation._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
            if (!animation) {
                return null;
            }
            if (target.getScene) {
                scene = target.getScene();
            }
            if (!scene) {
                return null;
            }
            return scene.beginDirectAnimation(target, [animation], 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
        }
        /**
         * Create and start an animation on a node and its descendants
         * @param name defines the name of the global animation that will be run on all nodes
         * @param node defines the root node where the animation will take place
         * @param directDescendantsOnly if true only direct descendants will be used, if false direct and also indirect (children of children, an so on in a recursive manner) descendants will be used
         * @param targetProperty defines property to animate
         * @param framePerSecond defines the number of frame per second to use
         * @param totalFrame defines the number of frames in total
         * @param from defines the initial value
         * @param to defines the final value
         * @param loopMode defines which loop mode you want to use (off by default)
         * @param easingFunction defines the easing function to use (linear by default)
         * @param onAnimationEnd defines the callback to call when an animation ends (will be called once per node)
         * @returns the list of animatables created for all nodes
         * @example https://www.babylonjs-playground.com/#MH0VLI
         */
        static CreateAndStartHierarchyAnimation(name, node, directDescendantsOnly, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd) {
            const animation = Animation._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
            if (!animation) {
                return null;
            }
            const scene = node.getScene();
            return scene.beginDirectHierarchyAnimation(node, directDescendantsOnly, [animation], 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
        }
        /**
         * Creates a new animation, merges it with the existing animations and starts it
         * @param name Name of the animation
         * @param node Node which contains the scene that begins the animations
         * @param targetProperty Specifies which property to animate
         * @param framePerSecond The frames per second of the animation
         * @param totalFrame The total number of frames
         * @param from The frame at the beginning of the animation
         * @param to The frame at the end of the animation
         * @param loopMode Specifies the loop mode of the animation
         * @param easingFunction (Optional) The easing function of the animation, which allow custom mathematical formulas for animations
         * @param onAnimationEnd Callback to run once the animation is complete
         * @returns Nullable animation
         */
        static CreateMergeAndStartAnimation(name, node, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd) {
            const animation = Animation._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
            if (!animation) {
                return null;
            }
            node.animations.push(animation);
            return node.getScene().beginAnimation(node, 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
        }
        /**
         * Convert the keyframes for all animations belonging to the group to be relative to a given reference frame.
         * @param sourceAnimation defines the Animation containing keyframes to convert
         * @param referenceFrame defines the frame that keyframes in the range will be relative to
         * @param range defines the name of the AnimationRange belonging to the Animation to convert
         * @param cloneOriginal defines whether or not to clone the animation and convert the clone or convert the original animation (default is false)
         * @param clonedName defines the name of the resulting cloned Animation if cloneOriginal is true
         * @returns a new Animation if cloneOriginal is true or the original Animation if cloneOriginal is false
         */
        static MakeAnimationAdditive(sourceAnimation, referenceFrame = 0, range, cloneOriginal = false, clonedName) {
            let animation = sourceAnimation;
            if (cloneOriginal) {
                animation = sourceAnimation.clone();
                animation.name = clonedName || animation.name;
            }
            if (!animation._keys.length) {
                return animation;
            }
            referenceFrame = referenceFrame >= 0 ? referenceFrame : 0;
            let startIndex = 0;
            const firstKey = animation._keys[0];
            let endIndex = animation._keys.length - 1;
            const lastKey = animation._keys[endIndex];
            const valueStore = {
                referenceValue: firstKey.value,
                referencePosition: TmpVectors.Vector3[0],
                referenceQuaternion: TmpVectors.Quaternion[0],
                referenceScaling: TmpVectors.Vector3[1],
                keyPosition: TmpVectors.Vector3[2],
                keyQuaternion: TmpVectors.Quaternion[1],
                keyScaling: TmpVectors.Vector3[3],
            };
            let referenceFound = false;
            let from = firstKey.frame;
            let to = lastKey.frame;
            if (range) {
                const rangeValue = animation.getRange(range);
                if (rangeValue) {
                    from = rangeValue.from;
                    to = rangeValue.to;
                }
            }
            let fromKeyFound = firstKey.frame === from;
            let toKeyFound = lastKey.frame === to;
            // There's only one key, so use it
            if (animation._keys.length === 1) {
                const value = animation._getKeyValue(animation._keys[0]);
                valueStore.referenceValue = value.clone ? value.clone() : value;
                referenceFound = true;
            }
            // Reference frame is before the first frame, so just use the first frame
            else if (referenceFrame <= firstKey.frame) {
                const value = animation._getKeyValue(firstKey.value);
                valueStore.referenceValue = value.clone ? value.clone() : value;
                referenceFound = true;
            }
            // Reference frame is after the last frame, so just use the last frame
            else if (referenceFrame >= lastKey.frame) {
                const value = animation._getKeyValue(lastKey.value);
                valueStore.referenceValue = value.clone ? value.clone() : value;
                referenceFound = true;
            }
            // Find key bookends, create them if they don't exist
            let index = 0;
            while (!referenceFound || !fromKeyFound || (!toKeyFound && index < animation._keys.length - 1)) {
                const currentKey = animation._keys[index];
                const nextKey = animation._keys[index + 1];
                // If reference frame wasn't found yet, check if we can interpolate to it
                if (!referenceFound && referenceFrame >= currentKey.frame && referenceFrame <= nextKey.frame) {
                    let value;
                    if (referenceFrame === currentKey.frame) {
                        value = animation._getKeyValue(currentKey.value);
                    }
                    else if (referenceFrame === nextKey.frame) {
                        value = animation._getKeyValue(nextKey.value);
                    }
                    else {
                        const animationState = {
                            key: index,
                            repeatCount: 0,
                            loopMode: this.ANIMATIONLOOPMODE_CONSTANT,
                        };
                        value = animation._interpolate(referenceFrame, animationState);
                    }
                    valueStore.referenceValue = value.clone ? value.clone() : value;
                    referenceFound = true;
                }
                // If from key wasn't found yet, check if we can interpolate to it
                if (!fromKeyFound && from >= currentKey.frame && from <= nextKey.frame) {
                    if (from === currentKey.frame) {
                        startIndex = index;
                    }
                    else if (from === nextKey.frame) {
                        startIndex = index + 1;
                    }
                    else {
                        const animationState = {
                            key: index,
                            repeatCount: 0,
                            loopMode: this.ANIMATIONLOOPMODE_CONSTANT,
                        };
                        const value = animation._interpolate(from, animationState);
                        const key = {
                            frame: from,
                            value: value.clone ? value.clone() : value,
                        };
                        animation._keys.splice(index + 1, 0, key);
                        startIndex = index + 1;
                    }
                    fromKeyFound = true;
                }
                // If to key wasn't found yet, check if we can interpolate to it
                if (!toKeyFound && to >= currentKey.frame && to <= nextKey.frame) {
                    if (to === currentKey.frame) {
                        endIndex = index;
                    }
                    else if (to === nextKey.frame) {
                        endIndex = index + 1;
                    }
                    else {
                        const animationState = {
                            key: index,
                            repeatCount: 0,
                            loopMode: this.ANIMATIONLOOPMODE_CONSTANT,
                        };
                        const value = animation._interpolate(to, animationState);
                        const key = {
                            frame: to,
                            value: value.clone ? value.clone() : value,
                        };
                        animation._keys.splice(index + 1, 0, key);
                        endIndex = index + 1;
                    }
                    toKeyFound = true;
                }
                index++;
            }
            // Conjugate the quaternion
            if (animation.dataType === Animation.ANIMATIONTYPE_QUATERNION) {
                valueStore.referenceValue.normalize().conjugateInPlace();
            }
            // Decompose matrix and conjugate the quaternion
            else if (animation.dataType === Animation.ANIMATIONTYPE_MATRIX) {
                valueStore.referenceValue.decompose(valueStore.referenceScaling, valueStore.referenceQuaternion, valueStore.referencePosition);
                valueStore.referenceQuaternion.normalize().conjugateInPlace();
            }
            // Subtract the reference value from all of the key values
            for (index = startIndex; index <= endIndex; index++) {
                const key = animation._keys[index];
                // If this key was duplicated to create a frame 0 key, skip it because its value has already been updated
                if (index && animation.dataType !== Animation.ANIMATIONTYPE_FLOAT && key.value === firstKey.value) {
                    continue;
                }
                switch (animation.dataType) {
                    case Animation.ANIMATIONTYPE_MATRIX:
                        key.value.decompose(valueStore.keyScaling, valueStore.keyQuaternion, valueStore.keyPosition);
                        valueStore.keyPosition.subtractInPlace(valueStore.referencePosition);
                        valueStore.keyScaling.divideInPlace(valueStore.referenceScaling);
                        valueStore.referenceQuaternion.multiplyToRef(valueStore.keyQuaternion, valueStore.keyQuaternion);
                        Matrix.ComposeToRef(valueStore.keyScaling, valueStore.keyQuaternion, valueStore.keyPosition, key.value);
                        break;
                    case Animation.ANIMATIONTYPE_QUATERNION:
                        valueStore.referenceValue.multiplyToRef(key.value, key.value);
                        break;
                    case Animation.ANIMATIONTYPE_VECTOR2:
                    case Animation.ANIMATIONTYPE_VECTOR3:
                    case Animation.ANIMATIONTYPE_COLOR3:
                    case Animation.ANIMATIONTYPE_COLOR4:
                        key.value.subtractToRef(valueStore.referenceValue, key.value);
                        break;
                    case Animation.ANIMATIONTYPE_SIZE:
                        key.value.width -= valueStore.referenceValue.width;
                        key.value.height -= valueStore.referenceValue.height;
                        break;
                    default:
                        key.value -= valueStore.referenceValue;
                }
            }
            return animation;
        }
        /**
         * Transition property of an host to the target Value
         * @param property The property to transition
         * @param targetValue The target Value of the property
         * @param host The object where the property to animate belongs
         * @param scene Scene used to run the animation
         * @param frameRate Framerate (in frame/s) to use
         * @param transition The transition type we want to use
         * @param duration The duration of the animation, in milliseconds
         * @param onAnimationEnd Callback trigger at the end of the animation
         * @returns Nullable animation
         */
        static TransitionTo(property, targetValue, host, scene, frameRate, transition, duration, onAnimationEnd = null) {
            if (duration <= 0) {
                host[property] = targetValue;
                if (onAnimationEnd) {
                    onAnimationEnd();
                }
                return null;
            }
            const endFrame = frameRate * (duration / 1000);
            transition.setKeys([
                {
                    frame: 0,
                    value: host[property].clone ? host[property].clone() : host[property],
                },
                {
                    frame: endFrame,
                    value: targetValue,
                },
            ]);
            if (!host.animations) {
                host.animations = [];
            }
            host.animations.push(transition);
            const animation = scene.beginAnimation(host, 0, endFrame, false);
            animation.onAnimationEnd = onAnimationEnd;
            return animation;
        }
        /**
         * Return the array of runtime animations currently using this animation
         */
        get runtimeAnimations() {
            return this._runtimeAnimations;
        }
        /**
         * Specifies if any of the runtime animations are currently running
         */
        get hasRunningRuntimeAnimations() {
            for (const runtimeAnimation of this._runtimeAnimations) {
                if (!runtimeAnimation.isStopped()) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Initializes the animation
         * @param name Name of the animation
         * @param targetProperty Property to animate
         * @param framePerSecond The frames per second of the animation
         * @param dataType The data type of the animation
         * @param loopMode The loop mode of the animation
         * @param enableBlending Specifies if blending should be enabled
         */
        constructor(
        /**Name of the animation */
        name, 
        /**Property to animate */
        targetProperty, 
        /**The frames per second of the animation */
        framePerSecond, 
        /**The data type of the animation */
        dataType, 
        /**The loop mode of the animation */
        loopMode, 
        /**Specifies if blending should be enabled */
        enableBlending) {
            this.name = name;
            this.targetProperty = targetProperty;
            this.framePerSecond = framePerSecond;
            this.dataType = dataType;
            this.loopMode = loopMode;
            this.enableBlending = enableBlending;
            /**
             * Stores the easing function of the animation
             */
            this._easingFunction = null;
            /**
             * @internal Internal use only
             */
            this._runtimeAnimations = new Array();
            /**
             * The set of event that will be linked to this animation
             */
            this._events = new Array();
            /**
             * Stores the blending speed of the animation
             */
            this.blendingSpeed = 0.01;
            /**
             * Stores the animation ranges for the animation
             */
            this._ranges = {};
            this.targetPropertyPath = targetProperty.split(".");
            this.dataType = dataType;
            this.loopMode = loopMode === undefined ? Animation.ANIMATIONLOOPMODE_CYCLE : loopMode;
            this.uniqueId = Animation._UniqueIdGenerator++;
        }
        // Methods
        /**
         * Converts the animation to a string
         * @param fullDetails support for multiple levels of logging within scene loading
         * @returns String form of the animation
         */
        toString(fullDetails) {
            let ret = "Name: " + this.name + ", property: " + this.targetProperty;
            ret += ", datatype: " + ["Float", "Vector3", "Quaternion", "Matrix", "Color3", "Vector2"][this.dataType];
            ret += ", nKeys: " + (this._keys ? this._keys.length : "none");
            ret += ", nRanges: " + (this._ranges ? Object.keys(this._ranges).length : "none");
            if (fullDetails) {
                ret += ", Ranges: {";
                let first = true;
                for (const name in this._ranges) {
                    if (first) {
                        ret += ", ";
                        first = false;
                    }
                    ret += name;
                }
                ret += "}";
            }
            return ret;
        }
        /**
         * Add an event to this animation
         * @param event Event to add
         */
        addEvent(event) {
            this._events.push(event);
            this._events.sort((a, b) => a.frame - b.frame);
        }
        /**
         * Remove all events found at the given frame
         * @param frame The frame to remove events from
         */
        removeEvents(frame) {
            for (let index = 0; index < this._events.length; index++) {
                if (this._events[index].frame === frame) {
                    this._events.splice(index, 1);
                    index--;
                }
            }
        }
        /**
         * Retrieves all the events from the animation
         * @returns Events from the animation
         */
        getEvents() {
            return this._events;
        }
        /**
         * Creates an animation range
         * @param name Name of the animation range
         * @param from Starting frame of the animation range
         * @param to Ending frame of the animation
         */
        createRange(name, from, to) {
            // check name not already in use; could happen for bones after serialized
            if (!this._ranges[name]) {
                this._ranges[name] = new AnimationRange(name, from, to);
            }
        }
        /**
         * Deletes an animation range by name
         * @param name Name of the animation range to delete
         * @param deleteFrames Specifies if the key frames for the range should also be deleted (true) or not (false)
         */
        deleteRange(name, deleteFrames = true) {
            const range = this._ranges[name];
            if (!range) {
                return;
            }
            if (deleteFrames) {
                const from = range.from;
                const to = range.to;
                // this loop MUST go high to low for multiple splices to work
                for (let key = this._keys.length - 1; key >= 0; key--) {
                    if (this._keys[key].frame >= from && this._keys[key].frame <= to) {
                        this._keys.splice(key, 1);
                    }
                }
            }
            this._ranges[name] = null; // said much faster than 'delete this._range[name]'
        }
        /**
         * Gets the animation range by name, or null if not defined
         * @param name Name of the animation range
         * @returns Nullable animation range
         */
        getRange(name) {
            return this._ranges[name];
        }
        /**
         * Gets the key frames from the animation
         * @returns The key frames of the animation
         */
        getKeys() {
            return this._keys;
        }
        /**
         * Gets the highest frame rate of the animation
         * @returns Highest frame rate of the animation
         */
        getHighestFrame() {
            let ret = 0;
            for (let key = 0, nKeys = this._keys.length; key < nKeys; key++) {
                if (ret < this._keys[key].frame) {
                    ret = this._keys[key].frame;
                }
            }
            return ret;
        }
        /**
         * Gets the easing function of the animation
         * @returns Easing function of the animation
         */
        getEasingFunction() {
            return this._easingFunction;
        }
        /**
         * Sets the easing function of the animation
         * @param easingFunction A custom mathematical formula for animation
         */
        setEasingFunction(easingFunction) {
            this._easingFunction = easingFunction;
        }
        /**
         * Interpolates a scalar linearly
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated scalar value
         */
        floatInterpolateFunction(startValue, endValue, gradient) {
            return Scalar.Lerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a scalar cubically
         * @param startValue Start value of the animation curve
         * @param outTangent End tangent of the animation
         * @param endValue End value of the animation curve
         * @param inTangent Start tangent of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated scalar value
         */
        floatInterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
            return Scalar.Hermite(startValue, outTangent, endValue, inTangent, gradient);
        }
        /**
         * Interpolates a quaternion using a spherical linear interpolation
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated quaternion value
         */
        quaternionInterpolateFunction(startValue, endValue, gradient) {
            return Quaternion.Slerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a quaternion cubically
         * @param startValue Start value of the animation curve
         * @param outTangent End tangent of the animation curve
         * @param endValue End value of the animation curve
         * @param inTangent Start tangent of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated quaternion value
         */
        quaternionInterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
            return Quaternion.Hermite(startValue, outTangent, endValue, inTangent, gradient).normalize();
        }
        /**
         * Interpolates a Vector3 linearly
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate (value between 0 and 1)
         * @returns Interpolated scalar value
         */
        vector3InterpolateFunction(startValue, endValue, gradient) {
            return Vector3.Lerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a Vector3 cubically
         * @param startValue Start value of the animation curve
         * @param outTangent End tangent of the animation
         * @param endValue End value of the animation curve
         * @param inTangent Start tangent of the animation curve
         * @param gradient Scalar amount to interpolate (value between 0 and 1)
         * @returns InterpolatedVector3 value
         */
        vector3InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
            return Vector3.Hermite(startValue, outTangent, endValue, inTangent, gradient);
        }
        /**
         * Interpolates a Vector2 linearly
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate (value between 0 and 1)
         * @returns Interpolated Vector2 value
         */
        vector2InterpolateFunction(startValue, endValue, gradient) {
            return Vector2.Lerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a Vector2 cubically
         * @param startValue Start value of the animation curve
         * @param outTangent End tangent of the animation
         * @param endValue End value of the animation curve
         * @param inTangent Start tangent of the animation curve
         * @param gradient Scalar amount to interpolate (value between 0 and 1)
         * @returns Interpolated Vector2 value
         */
        vector2InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
            return Vector2.Hermite(startValue, outTangent, endValue, inTangent, gradient);
        }
        /**
         * Interpolates a size linearly
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated Size value
         */
        sizeInterpolateFunction(startValue, endValue, gradient) {
            return Size.Lerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a Color3 linearly
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated Color3 value
         */
        color3InterpolateFunction(startValue, endValue, gradient) {
            return Color3.Lerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a Color3 cubically
         * @param startValue Start value of the animation curve
         * @param outTangent End tangent of the animation
         * @param endValue End value of the animation curve
         * @param inTangent Start tangent of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns interpolated value
         */
        color3InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
            return Color3.Hermite(startValue, outTangent, endValue, inTangent, gradient);
        }
        /**
         * Interpolates a Color4 linearly
         * @param startValue Start value of the animation curve
         * @param endValue End value of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns Interpolated Color3 value
         */
        color4InterpolateFunction(startValue, endValue, gradient) {
            return Color4.Lerp(startValue, endValue, gradient);
        }
        /**
         * Interpolates a Color4 cubically
         * @param startValue Start value of the animation curve
         * @param outTangent End tangent of the animation
         * @param endValue End value of the animation curve
         * @param inTangent Start tangent of the animation curve
         * @param gradient Scalar amount to interpolate
         * @returns interpolated value
         */
        color4InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
            return Color4.Hermite(startValue, outTangent, endValue, inTangent, gradient);
        }
        /**
         * @internal Internal use only
         */
        _getKeyValue(value) {
            if (typeof value === "function") {
                return value();
            }
            return value;
        }
        /**
         * Evaluate the animation value at a given frame
         * @param currentFrame defines the frame where we want to evaluate the animation
         * @returns the animation value
         */
        evaluate(currentFrame) {
            return this._interpolate(currentFrame, {
                key: 0,
                repeatCount: 0,
                loopMode: Animation.ANIMATIONLOOPMODE_CONSTANT,
            });
        }
        /**
         * @internal Internal use only
         */
        _interpolate(currentFrame, state) {
            if (state.loopMode === Animation.ANIMATIONLOOPMODE_CONSTANT && state.repeatCount > 0) {
                return state.highLimitValue.clone ? state.highLimitValue.clone() : state.highLimitValue;
            }
            const keys = this._keys;
            const keysLength = keys.length;
            let key = state.key;
            while (key >= 0 && currentFrame < keys[key].frame) {
                --key;
            }
            while (key + 1 <= keysLength - 1 && currentFrame >= keys[key + 1].frame) {
                ++key;
            }
            state.key = key;
            if (key < 0) {
                return this._getKeyValue(keys[0].value);
            }
            else if (key + 1 > keysLength - 1) {
                return this._getKeyValue(keys[keysLength - 1].value);
            }
            const startKey = keys[key];
            const endKey = keys[key + 1];
            const startValue = this._getKeyValue(startKey.value);
            const endValue = this._getKeyValue(endKey.value);
            if (startKey.interpolation === AnimationKeyInterpolation.STEP) {
                if (endKey.frame > currentFrame) {
                    return startValue;
                }
                else {
                    return endValue;
                }
            }
            const useTangent = startKey.outTangent !== undefined && endKey.inTangent !== undefined;
            const frameDelta = endKey.frame - startKey.frame;
            // gradient : percent of currentFrame between the frame inf and the frame sup
            let gradient = (currentFrame - startKey.frame) / frameDelta;
            // check for easingFunction and correction of gradient
            const easingFunction = this.getEasingFunction();
            if (easingFunction !== null) {
                gradient = easingFunction.ease(gradient);
            }
            switch (this.dataType) {
                // Float
                case Animation.ANIMATIONTYPE_FLOAT: {
                    const floatValue = useTangent
                        ? this.floatInterpolateFunctionWithTangents(startValue, startKey.outTangent * frameDelta, endValue, endKey.inTangent * frameDelta, gradient)
                        : this.floatInterpolateFunction(startValue, endValue, gradient);
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return floatValue;
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return state.offsetValue * state.repeatCount + floatValue;
                    }
                    break;
                }
                // Quaternion
                case Animation.ANIMATIONTYPE_QUATERNION: {
                    const quatValue = useTangent
                        ? this.quaternionInterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient)
                        : this.quaternionInterpolateFunction(startValue, endValue, gradient);
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return quatValue;
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return quatValue.addInPlace(state.offsetValue.scale(state.repeatCount));
                    }
                    return quatValue;
                }
                // Vector3
                case Animation.ANIMATIONTYPE_VECTOR3: {
                    const vec3Value = useTangent
                        ? this.vector3InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient)
                        : this.vector3InterpolateFunction(startValue, endValue, gradient);
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return vec3Value;
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return vec3Value.add(state.offsetValue.scale(state.repeatCount));
                    }
                    break;
                }
                // Vector2
                case Animation.ANIMATIONTYPE_VECTOR2: {
                    const vec2Value = useTangent
                        ? this.vector2InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient)
                        : this.vector2InterpolateFunction(startValue, endValue, gradient);
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return vec2Value;
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return vec2Value.add(state.offsetValue.scale(state.repeatCount));
                    }
                    break;
                }
                // Size
                case Animation.ANIMATIONTYPE_SIZE: {
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return this.sizeInterpolateFunction(startValue, endValue, gradient);
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return this.sizeInterpolateFunction(startValue, endValue, gradient).add(state.offsetValue.scale(state.repeatCount));
                    }
                    break;
                }
                // Color3
                case Animation.ANIMATIONTYPE_COLOR3: {
                    const color3Value = useTangent
                        ? this.color3InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient)
                        : this.color3InterpolateFunction(startValue, endValue, gradient);
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return color3Value;
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return color3Value.add(state.offsetValue.scale(state.repeatCount));
                    }
                    break;
                }
                // Color4
                case Animation.ANIMATIONTYPE_COLOR4: {
                    const color4Value = useTangent
                        ? this.color4InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient)
                        : this.color4InterpolateFunction(startValue, endValue, gradient);
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO:
                            return color4Value;
                        case Animation.ANIMATIONLOOPMODE_RELATIVE:
                            return color4Value.add(state.offsetValue.scale(state.repeatCount));
                    }
                    break;
                }
                // Matrix
                case Animation.ANIMATIONTYPE_MATRIX: {
                    switch (state.loopMode) {
                        case Animation.ANIMATIONLOOPMODE_CYCLE:
                        case Animation.ANIMATIONLOOPMODE_CONSTANT:
                        case Animation.ANIMATIONLOOPMODE_YOYO: {
                            if (Animation.AllowMatricesInterpolation) {
                                return this.matrixInterpolateFunction(startValue, endValue, gradient, state.workValue);
                            }
                            return startValue;
                        }
                        case Animation.ANIMATIONLOOPMODE_RELATIVE: {
                            return startValue;
                        }
                    }
                    break;
                }
            }
            return 0;
        }
        /**
         * Defines the function to use to interpolate matrices
         * @param startValue defines the start matrix
         * @param endValue defines the end matrix
         * @param gradient defines the gradient between both matrices
         * @param result defines an optional target matrix where to store the interpolation
         * @returns the interpolated matrix
         */
        matrixInterpolateFunction(startValue, endValue, gradient, result) {
            if (Animation.AllowMatrixDecomposeForInterpolation) {
                if (result) {
                    Matrix.DecomposeLerpToRef(startValue, endValue, gradient, result);
                    return result;
                }
                return Matrix.DecomposeLerp(startValue, endValue, gradient);
            }
            if (result) {
                Matrix.LerpToRef(startValue, endValue, gradient, result);
                return result;
            }
            return Matrix.Lerp(startValue, endValue, gradient);
        }
        /**
         * Makes a copy of the animation
         * @returns Cloned animation
         */
        clone() {
            const clone = new Animation(this.name, this.targetPropertyPath.join("."), this.framePerSecond, this.dataType, this.loopMode);
            clone.enableBlending = this.enableBlending;
            clone.blendingSpeed = this.blendingSpeed;
            if (this._keys) {
                clone.setKeys(this._keys);
            }
            if (this._ranges) {
                clone._ranges = {};
                for (const name in this._ranges) {
                    const range = this._ranges[name];
                    if (!range) {
                        continue;
                    }
                    clone._ranges[name] = range.clone();
                }
            }
            return clone;
        }
        /**
         * Sets the key frames of the animation
         * @param values The animation key frames to set
         */
        setKeys(values) {
            this._keys = values.slice(0);
        }
        /**
         * Serializes the animation to an object
         * @returns Serialized object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.name = this.name;
            serializationObject.property = this.targetProperty;
            serializationObject.framePerSecond = this.framePerSecond;
            serializationObject.dataType = this.dataType;
            serializationObject.loopBehavior = this.loopMode;
            serializationObject.enableBlending = this.enableBlending;
            serializationObject.blendingSpeed = this.blendingSpeed;
            const dataType = this.dataType;
            serializationObject.keys = [];
            const keys = this.getKeys();
            for (let index = 0; index < keys.length; index++) {
                const animationKey = keys[index];
                const key = {};
                key.frame = animationKey.frame;
                switch (dataType) {
                    case Animation.ANIMATIONTYPE_FLOAT:
                        key.values = [animationKey.value];
                        if (animationKey.inTangent !== undefined) {
                            key.values.push(animationKey.inTangent);
                        }
                        if (animationKey.outTangent !== undefined) {
                            if (animationKey.inTangent === undefined) {
                                key.values.push(undefined);
                            }
                            key.values.push(animationKey.outTangent);
                        }
                        if (animationKey.interpolation !== undefined) {
                            if (animationKey.inTangent === undefined) {
                                key.values.push(undefined);
                            }
                            if (animationKey.outTangent === undefined) {
                                key.values.push(undefined);
                            }
                            key.values.push(animationKey.interpolation);
                        }
                        break;
                    case Animation.ANIMATIONTYPE_QUATERNION:
                    case Animation.ANIMATIONTYPE_MATRIX:
                    case Animation.ANIMATIONTYPE_VECTOR3:
                    case Animation.ANIMATIONTYPE_COLOR3:
                    case Animation.ANIMATIONTYPE_COLOR4:
                        key.values = animationKey.value.asArray();
                        if (animationKey.inTangent != undefined) {
                            key.values.push(animationKey.inTangent.asArray());
                        }
                        if (animationKey.outTangent != undefined) {
                            if (animationKey.inTangent === undefined) {
                                key.values.push(undefined);
                            }
                            key.values.push(animationKey.outTangent.asArray());
                        }
                        if (animationKey.interpolation !== undefined) {
                            if (animationKey.inTangent === undefined) {
                                key.values.push(undefined);
                            }
                            if (animationKey.outTangent === undefined) {
                                key.values.push(undefined);
                            }
                            key.values.push(animationKey.interpolation);
                        }
                        break;
                }
                serializationObject.keys.push(key);
            }
            serializationObject.ranges = [];
            for (const name in this._ranges) {
                const source = this._ranges[name];
                if (!source) {
                    continue;
                }
                const range = {};
                range.name = name;
                range.from = source.from;
                range.to = source.to;
                serializationObject.ranges.push(range);
            }
            return serializationObject;
        }
        /**
         * @internal
         */
        static _UniversalLerp(left, right, amount) {
            const constructor = left.constructor;
            if (constructor.Lerp) {
                // Lerp supported
                return constructor.Lerp(left, right, amount);
            }
            else if (constructor.Slerp) {
                // Slerp supported
                return constructor.Slerp(left, right, amount);
            }
            else if (left.toFixed) {
                // Number
                return left * (1.0 - amount) + amount * right;
            }
            else {
                // Blending not supported
                return right;
            }
        }
        /**
         * Parses an animation object and creates an animation
         * @param parsedAnimation Parsed animation object
         * @returns Animation object
         */
        static Parse(parsedAnimation) {
            const animation = new Animation(parsedAnimation.name, parsedAnimation.property, parsedAnimation.framePerSecond, parsedAnimation.dataType, parsedAnimation.loopBehavior);
            const dataType = parsedAnimation.dataType;
            const keys = [];
            let data;
            let index;
            if (parsedAnimation.enableBlending) {
                animation.enableBlending = parsedAnimation.enableBlending;
            }
            if (parsedAnimation.blendingSpeed) {
                animation.blendingSpeed = parsedAnimation.blendingSpeed;
            }
            for (index = 0; index < parsedAnimation.keys.length; index++) {
                const key = parsedAnimation.keys[index];
                let inTangent = undefined;
                let outTangent = undefined;
                let interpolation = undefined;
                switch (dataType) {
                    case Animation.ANIMATIONTYPE_FLOAT:
                        data = key.values[0];
                        if (key.values.length >= 2) {
                            inTangent = key.values[1];
                        }
                        if (key.values.length >= 3) {
                            outTangent = key.values[2];
                        }
                        if (key.values.length >= 4) {
                            interpolation = key.values[3];
                        }
                        break;
                    case Animation.ANIMATIONTYPE_QUATERNION:
                        data = Quaternion.FromArray(key.values);
                        if (key.values.length >= 8) {
                            const _inTangent = Quaternion.FromArray(key.values.slice(4, 8));
                            if (!_inTangent.equals(Quaternion.Zero())) {
                                inTangent = _inTangent;
                            }
                        }
                        if (key.values.length >= 12) {
                            const _outTangent = Quaternion.FromArray(key.values.slice(8, 12));
                            if (!_outTangent.equals(Quaternion.Zero())) {
                                outTangent = _outTangent;
                            }
                        }
                        if (key.values.length >= 13) {
                            interpolation = key.values[12];
                        }
                        break;
                    case Animation.ANIMATIONTYPE_MATRIX:
                        data = Matrix.FromArray(key.values);
                        if (key.values.length >= 17) {
                            interpolation = key.values[16];
                        }
                        break;
                    case Animation.ANIMATIONTYPE_COLOR3:
                        data = Color3.FromArray(key.values);
                        if (key.values[3]) {
                            inTangent = Color3.FromArray(key.values[3]);
                        }
                        if (key.values[4]) {
                            outTangent = Color3.FromArray(key.values[4]);
                        }
                        if (key.values[5]) {
                            interpolation = key.values[5];
                        }
                        break;
                    case Animation.ANIMATIONTYPE_COLOR4:
                        data = Color4.FromArray(key.values);
                        if (key.values[4]) {
                            inTangent = Color4.FromArray(key.values[4]);
                        }
                        if (key.values[5]) {
                            outTangent = Color4.FromArray(key.values[5]);
                        }
                        if (key.values[6]) {
                            interpolation = Color4.FromArray(key.values[6]);
                        }
                        break;
                    case Animation.ANIMATIONTYPE_VECTOR3:
                    default:
                        data = Vector3.FromArray(key.values);
                        if (key.values[3]) {
                            inTangent = Vector3.FromArray(key.values[3]);
                        }
                        if (key.values[4]) {
                            outTangent = Vector3.FromArray(key.values[4]);
                        }
                        if (key.values[5]) {
                            interpolation = key.values[5];
                        }
                        break;
                }
                const keyData = {};
                keyData.frame = key.frame;
                keyData.value = data;
                if (inTangent != undefined) {
                    keyData.inTangent = inTangent;
                }
                if (outTangent != undefined) {
                    keyData.outTangent = outTangent;
                }
                if (interpolation != undefined) {
                    keyData.interpolation = interpolation;
                }
                keys.push(keyData);
            }
            animation.setKeys(keys);
            if (parsedAnimation.ranges) {
                for (index = 0; index < parsedAnimation.ranges.length; index++) {
                    data = parsedAnimation.ranges[index];
                    animation.createRange(data.name, data.from, data.to);
                }
            }
            return animation;
        }
        /**
         * Appends the serialized animations from the source animations
         * @param source Source containing the animations
         * @param destination Target to store the animations
         */
        static AppendSerializedAnimations(source, destination) {
            SerializationHelper.AppendSerializedAnimations(source, destination);
        }
        /**
         * Creates a new animation or an array of animations from a snippet saved in a remote file
         * @param name defines the name of the animation to create (can be null or empty to use the one from the json data)
         * @param url defines the url to load from
         * @returns a promise that will resolve to the new animation or an array of animations
         */
        static ParseFromFileAsync(name, url) {
            return new Promise((resolve, reject) => {
                const request = new WebRequest();
                request.addEventListener("readystatechange", () => {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                            let serializationObject = JSON.parse(request.responseText);
                            if (serializationObject.animations) {
                                serializationObject = serializationObject.animations;
                            }
                            if (serializationObject.length) {
                                const output = new Array();
                                for (const serializedAnimation of serializationObject) {
                                    output.push(this.Parse(serializedAnimation));
                                }
                                resolve(output);
                            }
                            else {
                                const output = this.Parse(serializationObject);
                                if (name) {
                                    output.name = name;
                                }
                                resolve(output);
                            }
                        }
                        else {
                            reject("Unable to load the animation");
                        }
                    }
                });
                request.open("GET", url);
                request.send();
            });
        }
        /**
         * Creates an animation or an array of animations from a snippet saved by the Inspector
         * @param snippetId defines the snippet to load
         * @returns a promise that will resolve to the new animation or a new array of animations
         */
        static ParseFromSnippetAsync(snippetId) {
            return new Promise((resolve, reject) => {
                const request = new WebRequest();
                request.addEventListener("readystatechange", () => {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                            const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                            if (snippet.animations) {
                                const serializationObject = JSON.parse(snippet.animations);
                                const outputs = new Array();
                                for (const serializedAnimation of serializationObject.animations) {
                                    const output = this.Parse(serializedAnimation);
                                    output.snippetId = snippetId;
                                    outputs.push(output);
                                }
                                resolve(outputs);
                            }
                            else {
                                const serializationObject = JSON.parse(snippet.animation);
                                const output = this.Parse(serializationObject);
                                output.snippetId = snippetId;
                                resolve(output);
                            }
                        }
                        else {
                            reject("Unable to load the snippet " + snippetId);
                        }
                    }
                });
                request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
                request.send();
            });
        }
    }
    Animation._UniqueIdGenerator = 0;
    /**
     * Use matrix interpolation instead of using direct key value when animating matrices
     */
    Animation.AllowMatricesInterpolation = false;
    /**
     * When matrix interpolation is enabled, this boolean forces the system to use Matrix.DecomposeLerp instead of Matrix.Lerp. Interpolation is more precise but slower
     */
    Animation.AllowMatrixDecomposeForInterpolation = true;
    /** Define the Url to load snippets */
    Animation.SnippetUrl = `https://snippet.babylonjs.com`;
    // Statics
    /**
     * Float animation type
     */
    Animation.ANIMATIONTYPE_FLOAT = 0;
    /**
     * Vector3 animation type
     */
    Animation.ANIMATIONTYPE_VECTOR3 = 1;
    /**
     * Quaternion animation type
     */
    Animation.ANIMATIONTYPE_QUATERNION = 2;
    /**
     * Matrix animation type
     */
    Animation.ANIMATIONTYPE_MATRIX = 3;
    /**
     * Color3 animation type
     */
    Animation.ANIMATIONTYPE_COLOR3 = 4;
    /**
     * Color3 animation type
     */
    Animation.ANIMATIONTYPE_COLOR4 = 7;
    /**
     * Vector2 animation type
     */
    Animation.ANIMATIONTYPE_VECTOR2 = 5;
    /**
     * Size animation type
     */
    Animation.ANIMATIONTYPE_SIZE = 6;
    /**
     * Relative Loop Mode
     */
    Animation.ANIMATIONLOOPMODE_RELATIVE = 0;
    /**
     * Cycle Loop Mode
     */
    Animation.ANIMATIONLOOPMODE_CYCLE = 1;
    /**
     * Constant Loop Mode
     */
    Animation.ANIMATIONLOOPMODE_CONSTANT = 2;
    /**
     * Yoyo Loop Mode
     */
    Animation.ANIMATIONLOOPMODE_YOYO = 4;
    /**
     * Creates an animation or an array of animations from a snippet saved by the Inspector
     * @deprecated Please use ParseFromSnippetAsync instead
     * @param snippetId defines the snippet to load
     * @returns a promise that will resolve to the new animation or a new array of animations
     */
    Animation.CreateFromSnippetAsync = Animation.ParseFromSnippetAsync;
    RegisterClass("BABYLON.Animation", Animation);
    Node._AnimationRangeFactory = (name, from, to) => new AnimationRange(name, from, to);

    /**
     * Add a bouncing effect to an ArcRotateCamera when reaching a specified minimum and maximum radius
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
     */
    class BouncingBehavior {
        constructor() {
            /**
             * The duration of the animation, in milliseconds
             */
            this.transitionDuration = 450;
            /**
             * Length of the distance animated by the transition when lower radius is reached
             */
            this.lowerRadiusTransitionRange = 2;
            /**
             * Length of the distance animated by the transition when upper radius is reached
             */
            this.upperRadiusTransitionRange = -2;
            this._autoTransitionRange = false;
            // Animations
            this._radiusIsAnimating = false;
            this._radiusBounceTransition = null;
            this._animatables = new Array();
        }
        /**
         * Gets the name of the behavior.
         */
        get name() {
            return "Bouncing";
        }
        /**
         * Gets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
         */
        get autoTransitionRange() {
            return this._autoTransitionRange;
        }
        /**
         * Sets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
         * Transition ranges will be set to 5% of the bounding box diagonal in world space
         */
        set autoTransitionRange(value) {
            if (this._autoTransitionRange === value) {
                return;
            }
            this._autoTransitionRange = value;
            const camera = this._attachedCamera;
            if (!camera) {
                return;
            }
            if (value) {
                this._onMeshTargetChangedObserver = camera.onMeshTargetChangedObservable.add((mesh) => {
                    if (!mesh) {
                        return;
                    }
                    mesh.computeWorldMatrix(true);
                    const diagonal = mesh.getBoundingInfo().diagonalLength;
                    this.lowerRadiusTransitionRange = diagonal * 0.05;
                    this.upperRadiusTransitionRange = diagonal * 0.05;
                });
            }
            else if (this._onMeshTargetChangedObserver) {
                camera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
            }
        }
        /**
         * Initializes the behavior.
         */
        init() {
            // Do nothing
        }
        /**
         * Attaches the behavior to its arc rotate camera.
         * @param camera Defines the camera to attach the behavior to
         */
        attach(camera) {
            this._attachedCamera = camera;
            this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(() => {
                if (!this._attachedCamera) {
                    return;
                }
                // Add the bounce animation to the lower radius limit
                if (this._isRadiusAtLimit(this._attachedCamera.lowerRadiusLimit)) {
                    this._applyBoundRadiusAnimation(this.lowerRadiusTransitionRange);
                }
                // Add the bounce animation to the upper radius limit
                if (this._isRadiusAtLimit(this._attachedCamera.upperRadiusLimit)) {
                    this._applyBoundRadiusAnimation(this.upperRadiusTransitionRange);
                }
            });
        }
        /**
         * Detaches the behavior from its current arc rotate camera.
         */
        detach() {
            if (!this._attachedCamera) {
                return;
            }
            if (this._onAfterCheckInputsObserver) {
                this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
            }
            if (this._onMeshTargetChangedObserver) {
                this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
            }
            this._attachedCamera = null;
        }
        /**
         * Checks if the camera radius is at the specified limit. Takes into account animation locks.
         * @param radiusLimit The limit to check against.
         * @returns Bool to indicate if at limit.
         */
        _isRadiusAtLimit(radiusLimit) {
            if (!this._attachedCamera) {
                return false;
            }
            if (this._attachedCamera.radius === radiusLimit && !this._radiusIsAnimating) {
                return true;
            }
            return false;
        }
        /**
         * Applies an animation to the radius of the camera, extending by the radiusDelta.
         * @param radiusDelta The delta by which to animate to. Can be negative.
         */
        _applyBoundRadiusAnimation(radiusDelta) {
            if (!this._attachedCamera) {
                return;
            }
            if (!this._radiusBounceTransition) {
                BouncingBehavior.EasingFunction.setEasingMode(BouncingBehavior.EasingMode);
                this._radiusBounceTransition = Animation.CreateAnimation("radius", Animation.ANIMATIONTYPE_FLOAT, 60, BouncingBehavior.EasingFunction);
            }
            // Prevent zoom until bounce has completed
            this._cachedWheelPrecision = this._attachedCamera.wheelPrecision;
            this._attachedCamera.wheelPrecision = Infinity;
            this._attachedCamera.inertialRadiusOffset = 0;
            // Animate to the radius limit
            this.stopAllAnimations();
            this._radiusIsAnimating = true;
            const animatable = Animation.TransitionTo("radius", this._attachedCamera.radius + radiusDelta, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusBounceTransition, this.transitionDuration, () => this._clearAnimationLocks());
            if (animatable) {
                this._animatables.push(animatable);
            }
        }
        /**
         * Removes all animation locks. Allows new animations to be added to any of the camera properties.
         */
        _clearAnimationLocks() {
            this._radiusIsAnimating = false;
            if (this._attachedCamera) {
                this._attachedCamera.wheelPrecision = this._cachedWheelPrecision;
            }
        }
        /**
         * Stops and removes all animations that have been applied to the camera
         */
        stopAllAnimations() {
            if (this._attachedCamera) {
                this._attachedCamera.animations = [];
            }
            while (this._animatables.length) {
                this._animatables[0].onAnimationEnd = null;
                this._animatables[0].stop();
                this._animatables.shift();
            }
        }
    }
    /**
     * The easing function used by animations
     */
    BouncingBehavior.EasingFunction = new BackEase(0.3);
    /**
     * The easing mode used by animations
     */
    BouncingBehavior.EasingMode = EasingFunction.EASINGMODE_EASEOUT;

    /**
     * The framing behavior (FramingBehavior) is designed to automatically position an ArcRotateCamera when its target is set to a mesh. It is also useful if you want to prevent the camera to go under a virtual horizontal plane.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
     */
    class FramingBehavior {
        constructor() {
            /**
             * An event triggered when the animation to zoom on target mesh has ended
             */
            this.onTargetFramingAnimationEndObservable = new Observable$1();
            this._mode = FramingBehavior.FitFrustumSidesMode;
            this._radiusScale = 1.0;
            this._positionScale = 0.5;
            this._defaultElevation = 0.3;
            this._elevationReturnTime = 1500;
            this._elevationReturnWaitTime = 1000;
            this._zoomStopsAnimation = false;
            this._framingTime = 1500;
            /**
             * Define if the behavior should automatically change the configured
             * camera limits and sensibilities.
             */
            this.autoCorrectCameraLimitsAndSensibility = true;
            this._isPointerDown = false;
            this._lastInteractionTime = -Infinity;
            // Framing control
            this._animatables = new Array();
            this._betaIsAnimating = false;
        }
        /**
         * Gets the name of the behavior.
         */
        get name() {
            return "Framing";
        }
        /**
         * Sets the current mode used by the behavior
         */
        set mode(mode) {
            this._mode = mode;
        }
        /**
         * Gets current mode used by the behavior.
         */
        get mode() {
            return this._mode;
        }
        /**
         * Sets the scale applied to the radius (1 by default)
         */
        set radiusScale(radius) {
            this._radiusScale = radius;
        }
        /**
         * Gets the scale applied to the radius
         */
        get radiusScale() {
            return this._radiusScale;
        }
        /**
         * Sets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
         */
        set positionScale(scale) {
            this._positionScale = scale;
        }
        /**
         * Gets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
         */
        get positionScale() {
            return this._positionScale;
        }
        /**
         * Sets the angle above/below the horizontal plane to return to when the return to default elevation idle
         * behaviour is triggered, in radians.
         */
        set defaultElevation(elevation) {
            this._defaultElevation = elevation;
        }
        /**
         * Gets the angle above/below the horizontal plane to return to when the return to default elevation idle
         * behaviour is triggered, in radians.
         */
        get defaultElevation() {
            return this._defaultElevation;
        }
        /**
         * Sets the time (in milliseconds) taken to return to the default beta position.
         * Negative value indicates camera should not return to default.
         */
        set elevationReturnTime(speed) {
            this._elevationReturnTime = speed;
        }
        /**
         * Gets the time (in milliseconds) taken to return to the default beta position.
         * Negative value indicates camera should not return to default.
         */
        get elevationReturnTime() {
            return this._elevationReturnTime;
        }
        /**
         * Sets the delay (in milliseconds) taken before the camera returns to the default beta position.
         */
        set elevationReturnWaitTime(time) {
            this._elevationReturnWaitTime = time;
        }
        /**
         * Gets the delay (in milliseconds) taken before the camera returns to the default beta position.
         */
        get elevationReturnWaitTime() {
            return this._elevationReturnWaitTime;
        }
        /**
         * Sets the flag that indicates if user zooming should stop animation.
         */
        set zoomStopsAnimation(flag) {
            this._zoomStopsAnimation = flag;
        }
        /**
         * Gets the flag that indicates if user zooming should stop animation.
         */
        get zoomStopsAnimation() {
            return this._zoomStopsAnimation;
        }
        /**
         * Sets the transition time when framing the mesh, in milliseconds
         */
        set framingTime(time) {
            this._framingTime = time;
        }
        /**
         * Gets the transition time when framing the mesh, in milliseconds
         */
        get framingTime() {
            return this._framingTime;
        }
        /**
         * Initializes the behavior.
         */
        init() {
            // Do nothing
        }
        /**
         * Attaches the behavior to its arc rotate camera.
         * @param camera Defines the camera to attach the behavior to
         */
        attach(camera) {
            this._attachedCamera = camera;
            const scene = this._attachedCamera.getScene();
            FramingBehavior.EasingFunction.setEasingMode(FramingBehavior.EasingMode);
            this._onPrePointerObservableObserver = scene.onPrePointerObservable.add((pointerInfoPre) => {
                if (pointerInfoPre.type === PointerEventTypes.POINTERDOWN) {
                    this._isPointerDown = true;
                    return;
                }
                if (pointerInfoPre.type === PointerEventTypes.POINTERUP) {
                    this._isPointerDown = false;
                }
            });
            this._onMeshTargetChangedObserver = camera.onMeshTargetChangedObservable.add((mesh) => {
                if (mesh) {
                    this.zoomOnMesh(mesh, undefined, () => {
                        this.onTargetFramingAnimationEndObservable.notifyObservers();
                    });
                }
            });
            this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(() => {
                // Stop the animation if there is user interaction and the animation should stop for this interaction
                this._applyUserInteraction();
                // Maintain the camera above the ground. If the user pulls the camera beneath the ground plane, lift it
                // back to the default position after a given timeout
                this._maintainCameraAboveGround();
            });
        }
        /**
         * Detaches the behavior from its current arc rotate camera.
         */
        detach() {
            if (!this._attachedCamera) {
                return;
            }
            const scene = this._attachedCamera.getScene();
            if (this._onPrePointerObservableObserver) {
                scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
            }
            if (this._onAfterCheckInputsObserver) {
                this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
            }
            if (this._onMeshTargetChangedObserver) {
                this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
            }
            this._attachedCamera = null;
        }
        /**
         * Targets the given mesh and updates zoom level accordingly.
         * @param mesh  The mesh to target.
         * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
         * @param onAnimationEnd Callback triggered at the end of the framing animation
         */
        zoomOnMesh(mesh, focusOnOriginXZ = false, onAnimationEnd = null) {
            mesh.computeWorldMatrix(true);
            const boundingBox = mesh.getBoundingInfo().boundingBox;
            this.zoomOnBoundingInfo(boundingBox.minimumWorld, boundingBox.maximumWorld, focusOnOriginXZ, onAnimationEnd);
        }
        /**
         * Targets the given mesh with its children and updates zoom level accordingly.
         * @param mesh  The mesh to target.
         * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
         * @param onAnimationEnd Callback triggered at the end of the framing animation
         */
        zoomOnMeshHierarchy(mesh, focusOnOriginXZ = false, onAnimationEnd = null) {
            mesh.computeWorldMatrix(true);
            const boundingBox = mesh.getHierarchyBoundingVectors(true);
            this.zoomOnBoundingInfo(boundingBox.min, boundingBox.max, focusOnOriginXZ, onAnimationEnd);
        }
        /**
         * Targets the given meshes with their children and updates zoom level accordingly.
         * @param meshes  The mesh to target.
         * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
         * @param onAnimationEnd Callback triggered at the end of the framing animation
         */
        zoomOnMeshesHierarchy(meshes, focusOnOriginXZ = false, onAnimationEnd = null) {
            const min = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            const max = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
            for (let i = 0; i < meshes.length; i++) {
                const boundingInfo = meshes[i].getHierarchyBoundingVectors(true);
                Vector3.CheckExtends(boundingInfo.min, min, max);
                Vector3.CheckExtends(boundingInfo.max, min, max);
            }
            this.zoomOnBoundingInfo(min, max, focusOnOriginXZ, onAnimationEnd);
        }
        /**
         * Targets the bounding box info defined by its extends and updates zoom level accordingly.
         * @param minimumWorld Determines the smaller position of the bounding box extend
         * @param maximumWorld Determines the bigger position of the bounding box extend
         * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
         * @param onAnimationEnd Callback triggered at the end of the framing animation
         * @returns true if the zoom was done
         */
        zoomOnBoundingInfo(minimumWorld, maximumWorld, focusOnOriginXZ = false, onAnimationEnd = null) {
            let zoomTarget;
            if (!this._attachedCamera) {
                return false;
            }
            // Find target by interpolating from bottom of bounding box in world-space to top via framingPositionY
            const bottom = minimumWorld.y;
            const top = maximumWorld.y;
            const zoomTargetY = bottom + (top - bottom) * this._positionScale;
            const radiusWorld = maximumWorld.subtract(minimumWorld).scale(0.5);
            if (focusOnOriginXZ) {
                zoomTarget = new Vector3(0, zoomTargetY, 0);
            }
            else {
                const centerWorld = minimumWorld.add(radiusWorld);
                zoomTarget = new Vector3(centerWorld.x, zoomTargetY, centerWorld.z);
            }
            if (!this._vectorTransition) {
                this._vectorTransition = Animation.CreateAnimation("target", Animation.ANIMATIONTYPE_VECTOR3, 60, FramingBehavior.EasingFunction);
            }
            this._betaIsAnimating = true;
            let animatable = Animation.TransitionTo("target", zoomTarget, this._attachedCamera, this._attachedCamera.getScene(), 60, this._vectorTransition, this._framingTime);
            if (animatable) {
                this._animatables.push(animatable);
            }
            // sets the radius and lower radius bounds
            // Small delta ensures camera is not always at lower zoom limit.
            let radius = 0;
            if (this._mode === FramingBehavior.FitFrustumSidesMode) {
                const position = this._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld);
                if (this.autoCorrectCameraLimitsAndSensibility) {
                    this._attachedCamera.lowerRadiusLimit = radiusWorld.length() + this._attachedCamera.minZ;
                }
                radius = position;
            }
            else if (this._mode === FramingBehavior.IgnoreBoundsSizeMode) {
                radius = this._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld);
                if (this.autoCorrectCameraLimitsAndSensibility && this._attachedCamera.lowerRadiusLimit === null) {
                    this._attachedCamera.lowerRadiusLimit = this._attachedCamera.minZ;
                }
            }
            // Set sensibilities
            if (this.autoCorrectCameraLimitsAndSensibility) {
                const extend = maximumWorld.subtract(minimumWorld).length();
                this._attachedCamera.panningSensibility = 5000 / extend;
                this._attachedCamera.wheelPrecision = 100 / radius;
            }
            // transition to new radius
            if (!this._radiusTransition) {
                this._radiusTransition = Animation.CreateAnimation("radius", Animation.ANIMATIONTYPE_FLOAT, 60, FramingBehavior.EasingFunction);
            }
            animatable = Animation.TransitionTo("radius", radius, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusTransition, this._framingTime, () => {
                this.stopAllAnimations();
                if (onAnimationEnd) {
                    onAnimationEnd();
                }
                if (this._attachedCamera && this._attachedCamera.useInputToRestoreState) {
                    this._attachedCamera.storeState();
                }
            });
            if (animatable) {
                this._animatables.push(animatable);
            }
            return true;
        }
        /**
         * Calculates the lowest radius for the camera based on the bounding box of the mesh.
         * @param minimumWorld
         * @param maximumWorld
         * @returns The minimum distance from the primary mesh's center point at which the camera must be kept in order
         *		 to fully enclose the mesh in the viewing frustum.
         */
        _calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld) {
            const size = maximumWorld.subtract(minimumWorld);
            const boxVectorGlobalDiagonal = size.length();
            const frustumSlope = this._getFrustumSlope();
            // Formula for setting distance
            // (Good explanation: http://stackoverflow.com/questions/2866350/move-camera-to-fit-3d-scene)
            const radiusWithoutFraming = boxVectorGlobalDiagonal * 0.5;
            // Horizon distance
            const radius = radiusWithoutFraming * this._radiusScale;
            const distanceForHorizontalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlope.x * frustumSlope.x));
            const distanceForVerticalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlope.y * frustumSlope.y));
            let distance = Math.max(distanceForHorizontalFrustum, distanceForVerticalFrustum);
            const camera = this._attachedCamera;
            if (!camera) {
                return 0;
            }
            if (camera.lowerRadiusLimit && this._mode === FramingBehavior.IgnoreBoundsSizeMode) {
                // Don't exceed the requested limit
                distance = distance < camera.lowerRadiusLimit ? camera.lowerRadiusLimit : distance;
            }
            // Don't exceed the upper radius limit
            if (camera.upperRadiusLimit) {
                distance = distance > camera.upperRadiusLimit ? camera.upperRadiusLimit : distance;
            }
            return distance;
        }
        /**
         * Keeps the camera above the ground plane. If the user pulls the camera below the ground plane, the camera
         * is automatically returned to its default position (expected to be above ground plane).
         */
        _maintainCameraAboveGround() {
            if (this._elevationReturnTime < 0) {
                return;
            }
            const timeSinceInteraction = PrecisionDate.Now - this._lastInteractionTime;
            const defaultBeta = Math.PI * 0.5 - this._defaultElevation;
            const limitBeta = Math.PI * 0.5;
            // Bring the camera back up if below the ground plane
            if (this._attachedCamera && !this._betaIsAnimating && this._attachedCamera.beta > limitBeta && timeSinceInteraction >= this._elevationReturnWaitTime) {
                this._betaIsAnimating = true;
                //Transition to new position
                this.stopAllAnimations();
                if (!this._betaTransition) {
                    this._betaTransition = Animation.CreateAnimation("beta", Animation.ANIMATIONTYPE_FLOAT, 60, FramingBehavior.EasingFunction);
                }
                const animatabe = Animation.TransitionTo("beta", defaultBeta, this._attachedCamera, this._attachedCamera.getScene(), 60, this._betaTransition, this._elevationReturnTime, () => {
                    this._clearAnimationLocks();
                    this.stopAllAnimations();
                });
                if (animatabe) {
                    this._animatables.push(animatabe);
                }
            }
        }
        /**
         * Returns the frustum slope based on the canvas ratio and camera FOV
         * @returns The frustum slope represented as a Vector2 with X and Y slopes
         */
        _getFrustumSlope() {
            // Calculate the viewport ratio
            // Aspect Ratio is Height/Width.
            const camera = this._attachedCamera;
            if (!camera) {
                return Vector2.Zero();
            }
            const engine = camera.getScene().getEngine();
            const aspectRatio = engine.getAspectRatio(camera);
            // Camera FOV is the vertical field of view (top-bottom) in radians.
            // Slope of the frustum top/bottom planes in view space, relative to the forward vector.
            const frustumSlopeY = Math.tan(camera.fov / 2);
            // Slope of the frustum left/right planes in view space, relative to the forward vector.
            // Provides the amount that one side (e.g. left) of the frustum gets wider for every unit
            // along the forward vector.
            const frustumSlopeX = frustumSlopeY * aspectRatio;
            return new Vector2(frustumSlopeX, frustumSlopeY);
        }
        /**
         * Removes all animation locks. Allows new animations to be added to any of the arcCamera properties.
         */
        _clearAnimationLocks() {
            this._betaIsAnimating = false;
        }
        /**
         *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
         */
        _applyUserInteraction() {
            if (this.isUserIsMoving) {
                this._lastInteractionTime = PrecisionDate.Now;
                this.stopAllAnimations();
                this._clearAnimationLocks();
            }
        }
        /**
         * Stops and removes all animations that have been applied to the camera
         */
        stopAllAnimations() {
            if (this._attachedCamera) {
                this._attachedCamera.animations = [];
            }
            while (this._animatables.length) {
                if (this._animatables[0]) {
                    this._animatables[0].onAnimationEnd = null;
                    this._animatables[0].stop();
                }
                this._animatables.shift();
            }
        }
        /**
         * Gets a value indicating if the user is moving the camera
         */
        get isUserIsMoving() {
            if (!this._attachedCamera) {
                return false;
            }
            return (this._attachedCamera.inertialAlphaOffset !== 0 ||
                this._attachedCamera.inertialBetaOffset !== 0 ||
                this._attachedCamera.inertialRadiusOffset !== 0 ||
                this._attachedCamera.inertialPanningX !== 0 ||
                this._attachedCamera.inertialPanningY !== 0 ||
                this._isPointerDown);
        }
    }
    /**
     * The easing function used by animations
     */
    FramingBehavior.EasingFunction = new ExponentialEase();
    /**
     * The easing mode used by animations
     */
    FramingBehavior.EasingMode = EasingFunction.EASINGMODE_EASEINOUT;
    // Statics
    /**
     * The camera can move all the way towards the mesh.
     */
    FramingBehavior.IgnoreBoundsSizeMode = 0;
    /**
     * The camera is not allowed to zoom closer to the mesh than the point at which the adjusted bounding sphere touches the frustum sides
     */
    FramingBehavior.FitFrustumSidesMode = 1;

    /**
     * A target camera takes a mesh or position as a target and continues to look at it while it moves.
     * This is the base of the follow, arc rotate cameras and Free camera
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
     */
    class TargetCamera extends Camera {
        /**
         * Instantiates a target camera that takes a mesh or position as a target and continues to look at it while it moves.
         * This is the base of the follow, arc rotate cameras and Free camera
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
         * @param name Defines the name of the camera in the scene
         * @param position Defines the start position of the camera in the scene
         * @param scene Defines the scene the camera belongs to
         * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
         */
        constructor(name, position, scene, setActiveOnSceneIfNoneActive = true) {
            super(name, position, scene, setActiveOnSceneIfNoneActive);
            this._tmpUpVector = Vector3.Zero();
            this._tmpTargetVector = Vector3.Zero();
            /**
             * Define the current direction the camera is moving to
             */
            this.cameraDirection = new Vector3(0, 0, 0);
            /**
             * Define the current rotation the camera is rotating to
             */
            this.cameraRotation = new Vector2(0, 0);
            /** Gets or sets a boolean indicating that the scaling of the parent hierarchy will not be taken in account by the camera */
            this.ignoreParentScaling = false;
            /**
             * When set, the up vector of the camera will be updated by the rotation of the camera
             */
            this.updateUpVectorFromRotation = false;
            this._tmpQuaternion = new Quaternion();
            /**
             * Define the current rotation of the camera
             */
            this.rotation = new Vector3(0, 0, 0);
            /**
             * Define the current speed of the camera
             */
            this.speed = 2.0;
            /**
             * Add constraint to the camera to prevent it to move freely in all directions and
             * around all axis.
             */
            this.noRotationConstraint = false;
            /**
             * Reverses mouselook direction to 'natural' panning as opposed to traditional direct
             * panning
             */
            this.invertRotation = false;
            /**
             * Speed multiplier for inverse camera panning
             */
            this.inverseRotationSpeed = 0.2;
            /**
             * Define the current target of the camera as an object or a position.
             * Please note that locking a target will disable panning.
             */
            this.lockedTarget = null;
            /** @internal */
            this._currentTarget = Vector3.Zero();
            /** @internal */
            this._initialFocalDistance = 1;
            /** @internal */
            this._viewMatrix = Matrix.Zero();
            /** @internal */
            this._camMatrix = Matrix.Zero();
            /** @internal */
            this._cameraTransformMatrix = Matrix.Zero();
            /** @internal */
            this._cameraRotationMatrix = Matrix.Zero();
            /** @internal */
            this._referencePoint = new Vector3(0, 0, 1);
            /** @internal */
            this._transformedReferencePoint = Vector3.Zero();
            this._deferredPositionUpdate = new Vector3();
            this._deferredRotationQuaternionUpdate = new Quaternion();
            this._deferredRotationUpdate = new Vector3();
            this._deferredUpdated = false;
            this._deferOnly = false;
            this._defaultUp = Vector3.Up();
            this._cachedRotationZ = 0;
            this._cachedQuaternionRotationZ = 0;
        }
        /**
         * Gets the position in front of the camera at a given distance.
         * @param distance The distance from the camera we want the position to be
         * @returns the position
         */
        getFrontPosition(distance) {
            this.getWorldMatrix();
            const direction = this.getTarget().subtract(this.position);
            direction.normalize();
            direction.scaleInPlace(distance);
            return this.globalPosition.add(direction);
        }
        /** @internal */
        _getLockedTargetPosition() {
            if (!this.lockedTarget) {
                return null;
            }
            if (this.lockedTarget.absolutePosition) {
                const lockedTarget = this.lockedTarget;
                const m = lockedTarget.computeWorldMatrix();
                // in some cases the absolute position resets externally, but doesn't update since the matrix is cached.
                m.getTranslationToRef(lockedTarget.absolutePosition);
            }
            return this.lockedTarget.absolutePosition || this.lockedTarget;
        }
        /**
         * Store current camera state of the camera (fov, position, rotation, etc..)
         * @returns the camera
         */
        storeState() {
            this._storedPosition = this.position.clone();
            this._storedRotation = this.rotation.clone();
            if (this.rotationQuaternion) {
                this._storedRotationQuaternion = this.rotationQuaternion.clone();
            }
            return super.storeState();
        }
        /**
         * Restored camera state. You must call storeState() first
         * @returns whether it was successful or not
         * @internal
         */
        _restoreStateValues() {
            if (!super._restoreStateValues()) {
                return false;
            }
            this.position = this._storedPosition.clone();
            this.rotation = this._storedRotation.clone();
            if (this.rotationQuaternion) {
                this.rotationQuaternion = this._storedRotationQuaternion.clone();
            }
            this.cameraDirection.copyFromFloats(0, 0, 0);
            this.cameraRotation.copyFromFloats(0, 0);
            return true;
        }
        /** @internal */
        _initCache() {
            super._initCache();
            this._cache.lockedTarget = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cache.rotation = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cache.rotationQuaternion = new Quaternion(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        }
        /**
         * @internal
         */
        _updateCache(ignoreParentClass) {
            if (!ignoreParentClass) {
                super._updateCache();
            }
            const lockedTargetPosition = this._getLockedTargetPosition();
            if (!lockedTargetPosition) {
                this._cache.lockedTarget = null;
            }
            else {
                if (!this._cache.lockedTarget) {
                    this._cache.lockedTarget = lockedTargetPosition.clone();
                }
                else {
                    this._cache.lockedTarget.copyFrom(lockedTargetPosition);
                }
            }
            this._cache.rotation.copyFrom(this.rotation);
            if (this.rotationQuaternion) {
                this._cache.rotationQuaternion.copyFrom(this.rotationQuaternion);
            }
        }
        // Synchronized
        /** @internal */
        _isSynchronizedViewMatrix() {
            if (!super._isSynchronizedViewMatrix()) {
                return false;
            }
            const lockedTargetPosition = this._getLockedTargetPosition();
            return ((this._cache.lockedTarget ? this._cache.lockedTarget.equals(lockedTargetPosition) : !lockedTargetPosition) &&
                (this.rotationQuaternion ? this.rotationQuaternion.equals(this._cache.rotationQuaternion) : this._cache.rotation.equals(this.rotation)));
        }
        // Methods
        /** @internal */
        _computeLocalCameraSpeed() {
            const engine = this.getEngine();
            return this.speed * Math.sqrt(engine.getDeltaTime() / (engine.getFps() * 100.0));
        }
        // Target
        /**
         * Defines the target the camera should look at.
         * @param target Defines the new target as a Vector
         */
        setTarget(target) {
            this.upVector.normalize();
            this._initialFocalDistance = target.subtract(this.position).length();
            if (this.position.z === target.z) {
                this.position.z += Epsilon;
            }
            this._referencePoint.normalize().scaleInPlace(this._initialFocalDistance);
            Matrix.LookAtLHToRef(this.position, target, this._defaultUp, this._camMatrix);
            this._camMatrix.invert();
            this.rotation.x = Math.atan(this._camMatrix.m[6] / this._camMatrix.m[10]);
            const vDir = target.subtract(this.position);
            if (vDir.x >= 0.0) {
                this.rotation.y = -Math.atan(vDir.z / vDir.x) + Math.PI / 2.0;
            }
            else {
                this.rotation.y = -Math.atan(vDir.z / vDir.x) - Math.PI / 2.0;
            }
            this.rotation.z = 0;
            if (isNaN(this.rotation.x)) {
                this.rotation.x = 0;
            }
            if (isNaN(this.rotation.y)) {
                this.rotation.y = 0;
            }
            if (isNaN(this.rotation.z)) {
                this.rotation.z = 0;
            }
            if (this.rotationQuaternion) {
                Quaternion.RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this.rotationQuaternion);
            }
        }
        /**
         * Defines the target point of the camera.
         * The camera looks towards it form the radius distance.
         */
        get target() {
            return this.getTarget();
        }
        set target(value) {
            this.setTarget(value);
        }
        /**
         * Return the current target position of the camera. This value is expressed in local space.
         * @returns the target position
         */
        getTarget() {
            return this._currentTarget;
        }
        /** @internal */
        _decideIfNeedsToMove() {
            return Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
        }
        /** @internal */
        _updatePosition() {
            if (this.parent) {
                this.parent.getWorldMatrix().invertToRef(TmpVectors.Matrix[0]);
                Vector3.TransformNormalToRef(this.cameraDirection, TmpVectors.Matrix[0], TmpVectors.Vector3[0]);
                this._deferredPositionUpdate.addInPlace(TmpVectors.Vector3[0]);
                if (!this._deferOnly) {
                    this.position.copyFrom(this._deferredPositionUpdate);
                }
                else {
                    this._deferredUpdated = true;
                }
                return;
            }
            this._deferredPositionUpdate.addInPlace(this.cameraDirection);
            if (!this._deferOnly) {
                this.position.copyFrom(this._deferredPositionUpdate);
            }
            else {
                this._deferredUpdated = true;
            }
        }
        /** @internal */
        _checkInputs() {
            const directionMultiplier = this.invertRotation ? -this.inverseRotationSpeed : 1.0;
            const needToMove = this._decideIfNeedsToMove();
            const needToRotate = this.cameraRotation.x || this.cameraRotation.y;
            this._deferredUpdated = false;
            this._deferredRotationUpdate.copyFrom(this.rotation);
            this._deferredPositionUpdate.copyFrom(this.position);
            if (this.rotationQuaternion) {
                this._deferredRotationQuaternionUpdate.copyFrom(this.rotationQuaternion);
            }
            // Move
            if (needToMove) {
                this._updatePosition();
            }
            // Rotate
            if (needToRotate) {
                //rotate, if quaternion is set and rotation was used
                if (this.rotationQuaternion) {
                    this.rotationQuaternion.toEulerAnglesToRef(this._deferredRotationUpdate);
                }
                this._deferredRotationUpdate.x += this.cameraRotation.x * directionMultiplier;
                this._deferredRotationUpdate.y += this.cameraRotation.y * directionMultiplier;
                // Apply constraints
                if (!this.noRotationConstraint) {
                    const limit = 1.570796;
                    if (this._deferredRotationUpdate.x > limit) {
                        this._deferredRotationUpdate.x = limit;
                    }
                    if (this._deferredRotationUpdate.x < -limit) {
                        this._deferredRotationUpdate.x = -limit;
                    }
                }
                if (!this._deferOnly) {
                    this.rotation.copyFrom(this._deferredRotationUpdate);
                }
                else {
                    this._deferredUpdated = true;
                }
                //rotate, if quaternion is set and rotation was used
                if (this.rotationQuaternion) {
                    const len = this._deferredRotationUpdate.lengthSquared();
                    if (len) {
                        Quaternion.RotationYawPitchRollToRef(this._deferredRotationUpdate.y, this._deferredRotationUpdate.x, this._deferredRotationUpdate.z, this._deferredRotationQuaternionUpdate);
                        if (!this._deferOnly) {
                            this.rotationQuaternion.copyFrom(this._deferredRotationQuaternionUpdate);
                        }
                        else {
                            this._deferredUpdated = true;
                        }
                    }
                }
            }
            // Inertia
            if (needToMove) {
                if (Math.abs(this.cameraDirection.x) < this.speed * Epsilon) {
                    this.cameraDirection.x = 0;
                }
                if (Math.abs(this.cameraDirection.y) < this.speed * Epsilon) {
                    this.cameraDirection.y = 0;
                }
                if (Math.abs(this.cameraDirection.z) < this.speed * Epsilon) {
                    this.cameraDirection.z = 0;
                }
                this.cameraDirection.scaleInPlace(this.inertia);
            }
            if (needToRotate) {
                if (Math.abs(this.cameraRotation.x) < this.speed * Epsilon) {
                    this.cameraRotation.x = 0;
                }
                if (Math.abs(this.cameraRotation.y) < this.speed * Epsilon) {
                    this.cameraRotation.y = 0;
                }
                this.cameraRotation.scaleInPlace(this.inertia);
            }
            super._checkInputs();
        }
        _updateCameraRotationMatrix() {
            if (this.rotationQuaternion) {
                this.rotationQuaternion.toRotationMatrix(this._cameraRotationMatrix);
            }
            else {
                Matrix.RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this._cameraRotationMatrix);
            }
        }
        /**
         * Update the up vector to apply the rotation of the camera (So if you changed the camera rotation.z this will let you update the up vector as well)
         * @returns the current camera
         */
        _rotateUpVectorWithCameraRotationMatrix() {
            Vector3.TransformNormalToRef(this._defaultUp, this._cameraRotationMatrix, this.upVector);
            return this;
        }
        /** @internal */
        _getViewMatrix() {
            if (this.lockedTarget) {
                this.setTarget(this._getLockedTargetPosition());
            }
            // Compute
            this._updateCameraRotationMatrix();
            // Apply the changed rotation to the upVector
            if (this.rotationQuaternion && this._cachedQuaternionRotationZ != this.rotationQuaternion.z) {
                this._rotateUpVectorWithCameraRotationMatrix();
                this._cachedQuaternionRotationZ = this.rotationQuaternion.z;
            }
            else if (this._cachedRotationZ !== this.rotation.z) {
                this._rotateUpVectorWithCameraRotationMatrix();
                this._cachedRotationZ = this.rotation.z;
            }
            Vector3.TransformCoordinatesToRef(this._referencePoint, this._cameraRotationMatrix, this._transformedReferencePoint);
            // Computing target and final matrix
            this.position.addToRef(this._transformedReferencePoint, this._currentTarget);
            if (this.updateUpVectorFromRotation) {
                if (this.rotationQuaternion) {
                    Axis.Y.rotateByQuaternionToRef(this.rotationQuaternion, this.upVector);
                }
                else {
                    Quaternion.FromEulerVectorToRef(this.rotation, this._tmpQuaternion);
                    Axis.Y.rotateByQuaternionToRef(this._tmpQuaternion, this.upVector);
                }
            }
            this._computeViewMatrix(this.position, this._currentTarget, this.upVector);
            return this._viewMatrix;
        }
        _computeViewMatrix(position, target, up) {
            if (this.ignoreParentScaling) {
                if (this.parent) {
                    const parentWorldMatrix = this.parent.getWorldMatrix();
                    Vector3.TransformCoordinatesToRef(position, parentWorldMatrix, this._globalPosition);
                    Vector3.TransformCoordinatesToRef(target, parentWorldMatrix, this._tmpTargetVector);
                    Vector3.TransformNormalToRef(up, parentWorldMatrix, this._tmpUpVector);
                    this._markSyncedWithParent();
                }
                else {
                    this._globalPosition.copyFrom(position);
                    this._tmpTargetVector.copyFrom(target);
                    this._tmpUpVector.copyFrom(up);
                }
                if (this.getScene().useRightHandedSystem) {
                    Matrix.LookAtRHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
                }
                else {
                    Matrix.LookAtLHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
                }
                return;
            }
            if (this.getScene().useRightHandedSystem) {
                Matrix.LookAtRHToRef(position, target, up, this._viewMatrix);
            }
            else {
                Matrix.LookAtLHToRef(position, target, up, this._viewMatrix);
            }
            if (this.parent) {
                const parentWorldMatrix = this.parent.getWorldMatrix();
                this._viewMatrix.invert();
                this._viewMatrix.multiplyToRef(parentWorldMatrix, this._viewMatrix);
                this._viewMatrix.getTranslationToRef(this._globalPosition);
                this._viewMatrix.invert();
                this._markSyncedWithParent();
            }
            else {
                this._globalPosition.copyFrom(position);
            }
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createRigCamera(name, cameraIndex) {
            if (this.cameraRigMode !== Camera.RIG_MODE_NONE) {
                const rigCamera = new TargetCamera(name, this.position.clone(), this.getScene());
                rigCamera.isRigCamera = true;
                rigCamera.rigParent = this;
                if (this.cameraRigMode === Camera.RIG_MODE_VR || this.cameraRigMode === Camera.RIG_MODE_WEBVR) {
                    if (!this.rotationQuaternion) {
                        this.rotationQuaternion = new Quaternion();
                    }
                    rigCamera._cameraRigParams = {};
                    rigCamera.rotationQuaternion = new Quaternion();
                }
                rigCamera.mode = this.mode;
                rigCamera.orthoLeft = this.orthoLeft;
                rigCamera.orthoRight = this.orthoRight;
                rigCamera.orthoTop = this.orthoTop;
                rigCamera.orthoBottom = this.orthoBottom;
                return rigCamera;
            }
            return null;
        }
        /**
         * @internal
         */
        _updateRigCameras() {
            const camLeft = this._rigCameras[0];
            const camRight = this._rigCameras[1];
            this.computeWorldMatrix();
            switch (this.cameraRigMode) {
                case Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH:
                case Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
                case Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                case Camera.RIG_MODE_STEREOSCOPIC_OVERUNDER:
                case Camera.RIG_MODE_STEREOSCOPIC_INTERLACED: {
                    //provisionnaly using _cameraRigParams.stereoHalfAngle instead of calculations based on _cameraRigParams.interaxialDistance:
                    const leftSign = this.cameraRigMode === Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? 1 : -1;
                    const rightSign = this.cameraRigMode === Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? -1 : 1;
                    this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * leftSign, camLeft);
                    this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * rightSign, camRight);
                    break;
                }
                case Camera.RIG_MODE_VR:
                    if (camLeft.rotationQuaternion) {
                        camLeft.rotationQuaternion.copyFrom(this.rotationQuaternion);
                        camRight.rotationQuaternion.copyFrom(this.rotationQuaternion);
                    }
                    else {
                        camLeft.rotation.copyFrom(this.rotation);
                        camRight.rotation.copyFrom(this.rotation);
                    }
                    camLeft.position.copyFrom(this.position);
                    camRight.position.copyFrom(this.position);
                    break;
            }
            super._updateRigCameras();
        }
        _getRigCamPositionAndTarget(halfSpace, rigCamera) {
            const target = this.getTarget();
            target.subtractToRef(this.position, TargetCamera._TargetFocalPoint);
            TargetCamera._TargetFocalPoint.normalize().scaleInPlace(this._initialFocalDistance);
            const newFocalTarget = TargetCamera._TargetFocalPoint.addInPlace(this.position);
            Matrix.TranslationToRef(-newFocalTarget.x, -newFocalTarget.y, -newFocalTarget.z, TargetCamera._TargetTransformMatrix);
            TargetCamera._TargetTransformMatrix.multiplyToRef(Matrix.RotationAxis(rigCamera.upVector, halfSpace), TargetCamera._RigCamTransformMatrix);
            Matrix.TranslationToRef(newFocalTarget.x, newFocalTarget.y, newFocalTarget.z, TargetCamera._TargetTransformMatrix);
            TargetCamera._RigCamTransformMatrix.multiplyToRef(TargetCamera._TargetTransformMatrix, TargetCamera._RigCamTransformMatrix);
            Vector3.TransformCoordinatesToRef(this.position, TargetCamera._RigCamTransformMatrix, rigCamera.position);
            rigCamera.setTarget(newFocalTarget);
        }
        /**
         * Gets the current object class name.
         * @returns the class name
         */
        getClassName() {
            return "TargetCamera";
        }
    }
    TargetCamera._RigCamTransformMatrix = new Matrix();
    TargetCamera._TargetTransformMatrix = new Matrix();
    TargetCamera._TargetFocalPoint = new Vector3();
    __decorate$1([
        serializeAsVector3()
    ], TargetCamera.prototype, "rotation", void 0);
    __decorate$1([
        serialize()
    ], TargetCamera.prototype, "speed", void 0);
    __decorate$1([
        serializeAsMeshReference("lockedTargetId")
    ], TargetCamera.prototype, "lockedTarget", void 0);

    /**
     * @ignore
     * This is a list of all the different input types that are available in the application.
     * Fo instance: ArcRotateCameraGamepadInput...
     */
    // eslint-disable-next-line no-var, @typescript-eslint/naming-convention
    var CameraInputTypes = {};
    /**
     * This represents the input manager used within a camera.
     * It helps dealing with all the different kind of input attached to a camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class CameraInputsManager {
        /**
         * Instantiate a new Camera Input Manager.
         * @param camera Defines the camera the input manager belongs to
         */
        constructor(camera) {
            /**
             * Defines the dom element the camera is collecting inputs from.
             * This is null if the controls have not been attached.
             */
            this.attachedToElement = false;
            this.attached = {};
            this.camera = camera;
            this.checkInputs = () => { };
        }
        /**
         * Add an input method to a camera
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
         * @param input Camera input method
         */
        add(input) {
            const type = input.getSimpleName();
            if (this.attached[type]) {
                Logger.Warn("camera input of type " + type + " already exists on camera");
                return;
            }
            this.attached[type] = input;
            input.camera = this.camera;
            // for checkInputs, we are dynamically creating a function
            // the goal is to avoid the performance penalty of looping for inputs in the render loop
            if (input.checkInputs) {
                this.checkInputs = this._addCheckInputs(input.checkInputs.bind(input));
            }
            if (this.attachedToElement) {
                input.attachControl(this.noPreventDefault);
            }
        }
        /**
         * Remove a specific input method from a camera
         * example: camera.inputs.remove(camera.inputs.attached.mouse);
         * @param inputToRemove camera input method
         */
        remove(inputToRemove) {
            for (const cam in this.attached) {
                const input = this.attached[cam];
                if (input === inputToRemove) {
                    input.detachControl();
                    input.camera = null;
                    delete this.attached[cam];
                    this.rebuildInputCheck();
                    return;
                }
            }
        }
        /**
         * Remove a specific input type from a camera
         * example: camera.inputs.remove("ArcRotateCameraGamepadInput");
         * @param inputType the type of the input to remove
         */
        removeByType(inputType) {
            for (const cam in this.attached) {
                const input = this.attached[cam];
                if (input.getClassName() === inputType) {
                    input.detachControl();
                    input.camera = null;
                    delete this.attached[cam];
                    this.rebuildInputCheck();
                }
            }
        }
        _addCheckInputs(fn) {
            const current = this.checkInputs;
            return () => {
                current();
                fn();
            };
        }
        /**
         * Attach the input controls to the currently attached dom element to listen the events from.
         * @param input Defines the input to attach
         */
        attachInput(input) {
            if (this.attachedToElement) {
                input.attachControl(this.noPreventDefault);
            }
        }
        /**
         * Attach the current manager inputs controls to a specific dom element to listen the events from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachElement(noPreventDefault = false) {
            if (this.attachedToElement) {
                return;
            }
            noPreventDefault = Camera.ForceAttachControlToAlwaysPreventDefault ? false : noPreventDefault;
            this.attachedToElement = true;
            this.noPreventDefault = noPreventDefault;
            for (const cam in this.attached) {
                this.attached[cam].attachControl(noPreventDefault);
            }
        }
        /**
         * Detach the current manager inputs controls from a specific dom element.
         * @param disconnect Defines whether the input should be removed from the current list of attached inputs
         */
        detachElement(disconnect = false) {
            for (const cam in this.attached) {
                this.attached[cam].detachControl();
                if (disconnect) {
                    this.attached[cam].camera = null;
                }
            }
            this.attachedToElement = false;
        }
        /**
         * Rebuild the dynamic inputCheck function from the current list of
         * defined inputs in the manager.
         */
        rebuildInputCheck() {
            this.checkInputs = () => { };
            for (const cam in this.attached) {
                const input = this.attached[cam];
                if (input.checkInputs) {
                    this.checkInputs = this._addCheckInputs(input.checkInputs.bind(input));
                }
            }
        }
        /**
         * Remove all attached input methods from a camera
         */
        clear() {
            if (this.attachedToElement) {
                this.detachElement(true);
            }
            this.attached = {};
            this.attachedToElement = false;
            this.checkInputs = () => { };
        }
        /**
         * Serialize the current input manager attached to a camera.
         * This ensures than once parsed,
         * the input associated to the camera will be identical to the current ones
         * @param serializedCamera Defines the camera serialization JSON the input serialization should write to
         */
        serialize(serializedCamera) {
            const inputs = {};
            for (const cam in this.attached) {
                const input = this.attached[cam];
                const res = SerializationHelper.Serialize(input);
                inputs[input.getClassName()] = res;
            }
            serializedCamera.inputsmgr = inputs;
        }
        /**
         * Parses an input manager serialized JSON to restore the previous list of inputs
         * and states associated to a camera.
         * @param parsedCamera Defines the JSON to parse
         */
        parse(parsedCamera) {
            const parsedInputs = parsedCamera.inputsmgr;
            if (parsedInputs) {
                this.clear();
                for (const n in parsedInputs) {
                    const construct = CameraInputTypes[n];
                    if (construct) {
                        const parsedinput = parsedInputs[n];
                        const input = SerializationHelper.Parse(() => {
                            return new construct();
                        }, parsedinput, null);
                        this.add(input);
                    }
                }
            }
            else {
                //2016-03-08 this part is for managing backward compatibility
                for (const n in this.attached) {
                    const construct = CameraInputTypes[this.attached[n].getClassName()];
                    if (construct) {
                        const input = SerializationHelper.Parse(() => {
                            return new construct();
                        }, parsedCamera, null);
                        this.remove(this.attached[n]);
                        this.add(input);
                    }
                }
            }
        }
    }

    /**
     * Base class for Camera Pointer Inputs.
     * See FollowCameraPointersInput in src/Cameras/Inputs/followCameraPointersInput.ts
     * for example usage.
     */
    class BaseCameraPointersInput {
        constructor() {
            this._currentActiveButton = -1;
            /**
             * Defines the buttons associated with the input to handle camera move.
             */
            this.buttons = [0, 1, 2];
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            const engine = this.camera.getEngine();
            const element = engine.getInputElement();
            let previousPinchSquaredDistance = 0;
            let previousMultiTouchPanPosition = null;
            this._pointA = null;
            this._pointB = null;
            this._altKey = false;
            this._ctrlKey = false;
            this._metaKey = false;
            this._shiftKey = false;
            this._buttonsPressed = 0;
            this._pointerInput = (p) => {
                var _a, _b;
                const evt = p.event;
                const isTouch = evt.pointerType === "touch";
                if (engine.isInVRExclusivePointerMode) {
                    return;
                }
                if (p.type !== PointerEventTypes.POINTERMOVE && this.buttons.indexOf(evt.button) === -1) {
                    return;
                }
                const srcElement = evt.target;
                this._altKey = evt.altKey;
                this._ctrlKey = evt.ctrlKey;
                this._metaKey = evt.metaKey;
                this._shiftKey = evt.shiftKey;
                this._buttonsPressed = evt.buttons;
                if (engine.isPointerLock) {
                    const offsetX = evt.movementX;
                    const offsetY = evt.movementY;
                    this.onTouch(null, offsetX, offsetY);
                    this._pointA = null;
                    this._pointB = null;
                }
                else if (p.type !== PointerEventTypes.POINTERDOWN && isTouch && ((_a = this._pointA) === null || _a === void 0 ? void 0 : _a.pointerId) !== evt.pointerId && ((_b = this._pointB) === null || _b === void 0 ? void 0 : _b.pointerId) !== evt.pointerId) {
                    return; // If we get a non-down event for a touch that we're not tracking, ignore it
                }
                else if (p.type === PointerEventTypes.POINTERDOWN && (this._currentActiveButton === -1 || isTouch)) {
                    try {
                        srcElement === null || srcElement === void 0 ? void 0 : srcElement.setPointerCapture(evt.pointerId);
                    }
                    catch (e) {
                        //Nothing to do with the error. Execution will continue.
                    }
                    if (this._pointA === null) {
                        this._pointA = {
                            x: evt.clientX,
                            y: evt.clientY,
                            pointerId: evt.pointerId,
                            type: evt.pointerType,
                        };
                    }
                    else if (this._pointB === null) {
                        this._pointB = {
                            x: evt.clientX,
                            y: evt.clientY,
                            pointerId: evt.pointerId,
                            type: evt.pointerType,
                        };
                    }
                    else {
                        return; // We are already tracking two pointers so ignore this one
                    }
                    if (this._currentActiveButton === -1 && !isTouch) {
                        this._currentActiveButton = evt.button;
                    }
                    this.onButtonDown(evt);
                    if (!noPreventDefault) {
                        evt.preventDefault();
                        element && element.focus();
                    }
                }
                else if (p.type === PointerEventTypes.POINTERDOUBLETAP) {
                    this.onDoubleTap(evt.pointerType);
                }
                else if (p.type === PointerEventTypes.POINTERUP && (this._currentActiveButton === evt.button || isTouch)) {
                    try {
                        srcElement === null || srcElement === void 0 ? void 0 : srcElement.releasePointerCapture(evt.pointerId);
                    }
                    catch (e) {
                        //Nothing to do with the error.
                    }
                    if (!isTouch) {
                        this._pointB = null; // Mouse and pen are mono pointer
                    }
                    //would be better to use pointers.remove(evt.pointerId) for multitouch gestures,
                    //but emptying completely pointers collection is required to fix a bug on iPhone :
                    //when changing orientation while pinching camera,
                    //one pointer stay pressed forever if we don't release all pointers
                    //will be ok to put back pointers.remove(evt.pointerId); when iPhone bug corrected
                    if (engine._badOS) {
                        this._pointA = this._pointB = null;
                    }
                    else {
                        //only remove the impacted pointer in case of multitouch allowing on most
                        //platforms switching from rotate to zoom and pan seamlessly.
                        if (this._pointB && this._pointA && this._pointA.pointerId == evt.pointerId) {
                            this._pointA = this._pointB;
                            this._pointB = null;
                        }
                        else if (this._pointA && this._pointB && this._pointB.pointerId == evt.pointerId) {
                            this._pointB = null;
                        }
                        else {
                            this._pointA = this._pointB = null;
                        }
                    }
                    if (previousPinchSquaredDistance !== 0 || previousMultiTouchPanPosition) {
                        // Previous pinch data is populated but a button has been lifted
                        // so pinch has ended.
                        this.onMultiTouch(this._pointA, this._pointB, previousPinchSquaredDistance, 0, // pinchSquaredDistance
                        previousMultiTouchPanPosition, null // multiTouchPanPosition
                        );
                        previousPinchSquaredDistance = 0;
                        previousMultiTouchPanPosition = null;
                    }
                    this._currentActiveButton = -1;
                    this.onButtonUp(evt);
                    if (!noPreventDefault) {
                        evt.preventDefault();
                    }
                }
                else if (p.type === PointerEventTypes.POINTERMOVE) {
                    if (!noPreventDefault) {
                        evt.preventDefault();
                    }
                    // One button down
                    if (this._pointA && this._pointB === null) {
                        const offsetX = evt.clientX - this._pointA.x;
                        const offsetY = evt.clientY - this._pointA.y;
                        this.onTouch(this._pointA, offsetX, offsetY);
                        this._pointA.x = evt.clientX;
                        this._pointA.y = evt.clientY;
                    }
                    // Two buttons down: pinch
                    else if (this._pointA && this._pointB) {
                        const ed = this._pointA.pointerId === evt.pointerId ? this._pointA : this._pointB;
                        ed.x = evt.clientX;
                        ed.y = evt.clientY;
                        const distX = this._pointA.x - this._pointB.x;
                        const distY = this._pointA.y - this._pointB.y;
                        const pinchSquaredDistance = distX * distX + distY * distY;
                        const multiTouchPanPosition = {
                            x: (this._pointA.x + this._pointB.x) / 2,
                            y: (this._pointA.y + this._pointB.y) / 2,
                            pointerId: evt.pointerId,
                            type: p.type,
                        };
                        this.onMultiTouch(this._pointA, this._pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition);
                        previousMultiTouchPanPosition = multiTouchPanPosition;
                        previousPinchSquaredDistance = pinchSquaredDistance;
                    }
                }
            };
            this._observer = this.camera
                .getScene()
                ._inputManager._addCameraPointerObserver(this._pointerInput, PointerEventTypes.POINTERDOWN | PointerEventTypes.POINTERUP | PointerEventTypes.POINTERMOVE | PointerEventTypes.POINTERDOUBLETAP);
            this._onLostFocus = () => {
                this._pointA = this._pointB = null;
                previousPinchSquaredDistance = 0;
                previousMultiTouchPanPosition = null;
                this.onLostFocus();
            };
            this._contextMenuBind = this.onContextMenu.bind(this);
            element && element.addEventListener("contextmenu", this._contextMenuBind, false);
            const hostWindow = this.camera.getScene().getEngine().getHostWindow();
            if (hostWindow) {
                Tools.RegisterTopRootEvents(hostWindow, [{ name: "blur", handler: this._onLostFocus }]);
            }
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._onLostFocus) {
                const hostWindow = this.camera.getScene().getEngine().getHostWindow();
                if (hostWindow) {
                    Tools.UnregisterTopRootEvents(hostWindow, [{ name: "blur", handler: this._onLostFocus }]);
                }
            }
            if (this._observer) {
                this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
                this._observer = null;
                if (this._contextMenuBind) {
                    const inputElement = this.camera.getScene().getEngine().getInputElement();
                    inputElement && inputElement.removeEventListener("contextmenu", this._contextMenuBind);
                }
                this._onLostFocus = null;
            }
            this._altKey = false;
            this._ctrlKey = false;
            this._metaKey = false;
            this._shiftKey = false;
            this._buttonsPressed = 0;
            this._currentActiveButton = -1;
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "BaseCameraPointersInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "pointers";
        }
        /**
         * Called on pointer POINTERDOUBLETAP event.
         * Override this method to provide functionality on POINTERDOUBLETAP event.
         * @param type
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onDoubleTap(type) { }
        /**
         * Called on pointer POINTERMOVE event if only a single touch is active.
         * Override this method to provide functionality.
         * @param point
         * @param offsetX
         * @param offsetY
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onTouch(point, offsetX, offsetY) { }
        /**
         * Called on pointer POINTERMOVE event if multiple touches are active.
         * Override this method to provide functionality.
         * @param _pointA
         * @param _pointB
         * @param previousPinchSquaredDistance
         * @param pinchSquaredDistance
         * @param previousMultiTouchPanPosition
         * @param multiTouchPanPosition
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onMultiTouch(_pointA, _pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) { }
        /**
         * Called on JS contextmenu event.
         * Override this method to provide functionality.
         * @param evt
         */
        onContextMenu(evt) {
            evt.preventDefault();
        }
        /**
         * Called each time a new POINTERDOWN event occurs. Ie, for each button
         * press.
         * Override this method to provide functionality.
         * @param evt
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onButtonDown(evt) { }
        /**
         * Called each time a new POINTERUP event occurs. Ie, for each button
         * release.
         * Override this method to provide functionality.
         * @param evt
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onButtonUp(evt) { }
        /**
         * Called when window becomes inactive.
         * Override this method to provide functionality.
         */
        onLostFocus() { }
    }
    __decorate$1([
        serialize()
    ], BaseCameraPointersInput.prototype, "buttons", void 0);

    /**
     * Manage the pointers inputs to control an arc rotate camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class ArcRotateCameraPointersInput extends BaseCameraPointersInput {
        constructor() {
            super(...arguments);
            /**
             * Defines the buttons associated with the input to handle camera move.
             */
            this.buttons = [0, 1, 2];
            /**
             * Defines the pointer angular sensibility  along the X axis or how fast is
             * the camera rotating.
             */
            this.angularSensibilityX = 1000.0;
            /**
             * Defines the pointer angular sensibility along the Y axis or how fast is
             * the camera rotating.
             */
            this.angularSensibilityY = 1000.0;
            /**
             * Defines the pointer pinch precision or how fast is the camera zooming.
             */
            this.pinchPrecision = 12.0;
            /**
             * pinchDeltaPercentage will be used instead of pinchPrecision if different
             * from 0.
             * It defines the percentage of current camera.radius to use as delta when
             * pinch zoom is used.
             */
            this.pinchDeltaPercentage = 0;
            /**
             * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
             * that any object in the plane at the camera's target point will scale
             * perfectly with finger motion.
             * Overrides pinchDeltaPercentage and pinchPrecision.
             */
            this.useNaturalPinchZoom = false;
            /**
             * Defines whether zoom (2 fingers pinch) is enabled through multitouch
             */
            this.pinchZoom = true;
            /**
             * Defines the pointer panning sensibility or how fast is the camera moving.
             */
            this.panningSensibility = 1000.0;
            /**
             * Defines whether panning (2 fingers swipe) is enabled through multitouch.
             */
            this.multiTouchPanning = true;
            /**
             * Defines whether panning is enabled for both pan (2 fingers swipe) and
             * zoom (pinch) through multitouch.
             */
            this.multiTouchPanAndZoom = true;
            /**
             * Revers pinch action direction.
             */
            this.pinchInwards = true;
            this._isPanClick = false;
            this._twoFingerActivityCount = 0;
            this._isPinching = false;
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "ArcRotateCameraPointersInput";
        }
        /**
         * Move camera from multi touch panning positions.
         * @param previousMultiTouchPanPosition
         * @param multiTouchPanPosition
         */
        _computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition) {
            if (this.panningSensibility !== 0 && previousMultiTouchPanPosition && multiTouchPanPosition) {
                const moveDeltaX = multiTouchPanPosition.x - previousMultiTouchPanPosition.x;
                const moveDeltaY = multiTouchPanPosition.y - previousMultiTouchPanPosition.y;
                this.camera.inertialPanningX += -moveDeltaX / this.panningSensibility;
                this.camera.inertialPanningY += moveDeltaY / this.panningSensibility;
            }
        }
        /**
         * Move camera from pinch zoom distances.
         * @param previousPinchSquaredDistance
         * @param pinchSquaredDistance
         */
        _computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance) {
            const radius = this.camera.radius || ArcRotateCameraPointersInput.MinimumRadiusForPinch;
            if (this.useNaturalPinchZoom) {
                this.camera.radius = (radius * Math.sqrt(previousPinchSquaredDistance)) / Math.sqrt(pinchSquaredDistance);
            }
            else if (this.pinchDeltaPercentage) {
                this.camera.inertialRadiusOffset += (pinchSquaredDistance - previousPinchSquaredDistance) * 0.001 * radius * this.pinchDeltaPercentage;
            }
            else {
                this.camera.inertialRadiusOffset +=
                    (pinchSquaredDistance - previousPinchSquaredDistance) /
                        ((this.pinchPrecision * (this.pinchInwards ? 1 : -1) * (this.angularSensibilityX + this.angularSensibilityY)) / 2);
            }
        }
        /**
         * Called on pointer POINTERMOVE event if only a single touch is active.
         * @param point
         * @param offsetX
         * @param offsetY
         */
        onTouch(point, offsetX, offsetY) {
            if (this.panningSensibility !== 0 && ((this._ctrlKey && this.camera._useCtrlForPanning) || this._isPanClick)) {
                this.camera.inertialPanningX += -offsetX / this.panningSensibility;
                this.camera.inertialPanningY += offsetY / this.panningSensibility;
            }
            else {
                this.camera.inertialAlphaOffset -= offsetX / this.angularSensibilityX;
                this.camera.inertialBetaOffset -= offsetY / this.angularSensibilityY;
            }
        }
        /**
         * Called on pointer POINTERDOUBLETAP event.
         */
        onDoubleTap() {
            if (this.camera.useInputToRestoreState) {
                this.camera.restoreState();
            }
        }
        /**
         * Called on pointer POINTERMOVE event if multiple touches are active.
         * @param pointA
         * @param pointB
         * @param previousPinchSquaredDistance
         * @param pinchSquaredDistance
         * @param previousMultiTouchPanPosition
         * @param multiTouchPanPosition
         */
        onMultiTouch(pointA, pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) {
            if (previousPinchSquaredDistance === 0 && previousMultiTouchPanPosition === null) {
                // First time this method is called for new pinch.
                // Next time this is called there will be a
                // previousPinchSquaredDistance and pinchSquaredDistance to compare.
                return;
            }
            if (pinchSquaredDistance === 0 && multiTouchPanPosition === null) {
                // Last time this method is called at the end of a pinch.
                return;
            }
            // Zoom and panning enabled together
            if (this.multiTouchPanAndZoom) {
                this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
                this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
                // Zoom and panning enabled but only one at a time
            }
            else if (this.multiTouchPanning && this.pinchZoom) {
                this._twoFingerActivityCount++;
                if (this._isPinching ||
                    (this._twoFingerActivityCount < 20 && Math.abs(Math.sqrt(pinchSquaredDistance) - Math.sqrt(previousPinchSquaredDistance)) > this.camera.pinchToPanMaxDistance)) {
                    // Since pinch has not been active long, assume we intend to zoom.
                    this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
                    // Since we are pinching, remain pinching on next iteration.
                    this._isPinching = true;
                }
                else {
                    // Pause between pinch starting and moving implies not a zoom event. Pan instead.
                    this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
                }
                // Panning enabled, zoom disabled
            }
            else if (this.multiTouchPanning) {
                this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
                // Zoom enabled, panning disabled
            }
            else if (this.pinchZoom) {
                this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
            }
        }
        /**
         * Called each time a new POINTERDOWN event occurs. Ie, for each button
         * press.
         * @param evt
         */
        onButtonDown(evt) {
            this._isPanClick = evt.button === this.camera._panningMouseButton;
        }
        /**
         * Called each time a new POINTERUP event occurs. Ie, for each button
         * release.
         */
        onButtonUp() {
            this._twoFingerActivityCount = 0;
            this._isPinching = false;
        }
        /**
         * Called when window becomes inactive.
         */
        onLostFocus() {
            this._isPanClick = false;
            this._twoFingerActivityCount = 0;
            this._isPinching = false;
        }
    }
    /**
     * The minimum radius used for pinch, to avoid radius lock at 0
     */
    ArcRotateCameraPointersInput.MinimumRadiusForPinch = 0.001;
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "buttons", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "angularSensibilityX", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "angularSensibilityY", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "pinchPrecision", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "pinchDeltaPercentage", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "useNaturalPinchZoom", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "pinchZoom", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "panningSensibility", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "multiTouchPanning", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraPointersInput.prototype, "multiTouchPanAndZoom", void 0);
    CameraInputTypes["ArcRotateCameraPointersInput"] = ArcRotateCameraPointersInput;

    /**
     * Manage the keyboard inputs to control the movement of an arc rotate camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class ArcRotateCameraKeyboardMoveInput {
        constructor() {
            /**
             * Defines the list of key codes associated with the up action (increase alpha)
             */
            this.keysUp = [38];
            /**
             * Defines the list of key codes associated with the down action (decrease alpha)
             */
            this.keysDown = [40];
            /**
             * Defines the list of key codes associated with the left action (increase beta)
             */
            this.keysLeft = [37];
            /**
             * Defines the list of key codes associated with the right action (decrease beta)
             */
            this.keysRight = [39];
            /**
             * Defines the list of key codes associated with the reset action.
             * Those keys reset the camera to its last stored state (with the method camera.storeState())
             */
            this.keysReset = [220];
            /**
             * Defines the panning sensibility of the inputs.
             * (How fast is the camera panning)
             */
            this.panningSensibility = 50.0;
            /**
             * Defines the zooming sensibility of the inputs.
             * (How fast is the camera zooming)
             */
            this.zoomingSensibility = 25.0;
            /**
             * Defines whether maintaining the alt key down switch the movement mode from
             * orientation to zoom.
             */
            this.useAltToZoom = true;
            /**
             * Rotation speed of the camera
             */
            this.angularSpeed = 0.01;
            this._keys = new Array();
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            // was there a second variable defined?
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            if (this._onCanvasBlurObserver) {
                return;
            }
            this._scene = this.camera.getScene();
            this._engine = this._scene.getEngine();
            this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(() => {
                this._keys.length = 0;
            });
            this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info) => {
                const evt = info.event;
                if (!evt.metaKey) {
                    if (info.type === KeyboardEventTypes.KEYDOWN) {
                        this._ctrlPressed = evt.ctrlKey;
                        this._altPressed = evt.altKey;
                        if (this.keysUp.indexOf(evt.keyCode) !== -1 ||
                            this.keysDown.indexOf(evt.keyCode) !== -1 ||
                            this.keysLeft.indexOf(evt.keyCode) !== -1 ||
                            this.keysRight.indexOf(evt.keyCode) !== -1 ||
                            this.keysReset.indexOf(evt.keyCode) !== -1) {
                            const index = this._keys.indexOf(evt.keyCode);
                            if (index === -1) {
                                this._keys.push(evt.keyCode);
                            }
                            if (evt.preventDefault) {
                                if (!noPreventDefault) {
                                    evt.preventDefault();
                                }
                            }
                        }
                    }
                    else {
                        if (this.keysUp.indexOf(evt.keyCode) !== -1 ||
                            this.keysDown.indexOf(evt.keyCode) !== -1 ||
                            this.keysLeft.indexOf(evt.keyCode) !== -1 ||
                            this.keysRight.indexOf(evt.keyCode) !== -1 ||
                            this.keysReset.indexOf(evt.keyCode) !== -1) {
                            const index = this._keys.indexOf(evt.keyCode);
                            if (index >= 0) {
                                this._keys.splice(index, 1);
                            }
                            if (evt.preventDefault) {
                                if (!noPreventDefault) {
                                    evt.preventDefault();
                                }
                            }
                        }
                    }
                }
            });
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._scene) {
                if (this._onKeyboardObserver) {
                    this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
                }
                if (this._onCanvasBlurObserver) {
                    this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
                }
                this._onKeyboardObserver = null;
                this._onCanvasBlurObserver = null;
            }
            this._keys.length = 0;
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            if (this._onKeyboardObserver) {
                const camera = this.camera;
                for (let index = 0; index < this._keys.length; index++) {
                    const keyCode = this._keys[index];
                    if (this.keysLeft.indexOf(keyCode) !== -1) {
                        if (this._ctrlPressed && this.camera._useCtrlForPanning) {
                            camera.inertialPanningX -= 1 / this.panningSensibility;
                        }
                        else {
                            camera.inertialAlphaOffset -= this.angularSpeed;
                        }
                    }
                    else if (this.keysUp.indexOf(keyCode) !== -1) {
                        if (this._ctrlPressed && this.camera._useCtrlForPanning) {
                            camera.inertialPanningY += 1 / this.panningSensibility;
                        }
                        else if (this._altPressed && this.useAltToZoom) {
                            camera.inertialRadiusOffset += 1 / this.zoomingSensibility;
                        }
                        else {
                            camera.inertialBetaOffset -= this.angularSpeed;
                        }
                    }
                    else if (this.keysRight.indexOf(keyCode) !== -1) {
                        if (this._ctrlPressed && this.camera._useCtrlForPanning) {
                            camera.inertialPanningX += 1 / this.panningSensibility;
                        }
                        else {
                            camera.inertialAlphaOffset += this.angularSpeed;
                        }
                    }
                    else if (this.keysDown.indexOf(keyCode) !== -1) {
                        if (this._ctrlPressed && this.camera._useCtrlForPanning) {
                            camera.inertialPanningY -= 1 / this.panningSensibility;
                        }
                        else if (this._altPressed && this.useAltToZoom) {
                            camera.inertialRadiusOffset -= 1 / this.zoomingSensibility;
                        }
                        else {
                            camera.inertialBetaOffset += this.angularSpeed;
                        }
                    }
                    else if (this.keysReset.indexOf(keyCode) !== -1) {
                        if (camera.useInputToRestoreState) {
                            camera.restoreState();
                        }
                    }
                }
            }
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "ArcRotateCameraKeyboardMoveInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "keyboard";
        }
    }
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "keysUp", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "keysDown", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "keysLeft", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "keysRight", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "keysReset", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "panningSensibility", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "zoomingSensibility", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "useAltToZoom", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraKeyboardMoveInput.prototype, "angularSpeed", void 0);
    CameraInputTypes["ArcRotateCameraKeyboardMoveInput"] = ArcRotateCameraKeyboardMoveInput;

    /**
     * Firefox uses a different scheme to report scroll distances to other
     * browsers. Rather than use complicated methods to calculate the exact
     * multiple we need to apply, let's just cheat and use a constant.
     * https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode
     * https://stackoverflow.com/questions/20110224/what-is-the-height-of-a-line-in-a-wheel-event-deltamode-dom-delta-line
     */
    const ffMultiplier = 40;
    /**
     * Manage the mouse wheel inputs to control an arc rotate camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class ArcRotateCameraMouseWheelInput {
        constructor() {
            /**
             * Gets or Set the mouse wheel precision or how fast is the camera zooming.
             */
            this.wheelPrecision = 3.0;
            /**
             * Gets or Set the boolean value that controls whether or not the mouse wheel
             * zooms to the location of the mouse pointer or not.  The default is false.
             */
            this.zoomToMouseLocation = false;
            /**
             * wheelDeltaPercentage will be used instead of wheelPrecision if different from 0.
             * It defines the percentage of current camera.radius to use as delta when wheel is used.
             */
            this.wheelDeltaPercentage = 0;
            /**
             * If set, this function will be used to set the radius delta that will be added to the current camera radius
             */
            this.customComputeDeltaFromMouseWheel = null;
            this._inertialPanning = Vector3.Zero();
        }
        _computeDeltaFromMouseWheelLegacyEvent(mouseWheelDelta, radius) {
            let delta = 0;
            const wheelDelta = mouseWheelDelta * 0.01 * this.wheelDeltaPercentage * radius;
            if (mouseWheelDelta > 0) {
                delta = wheelDelta / (1.0 + this.wheelDeltaPercentage);
            }
            else {
                delta = wheelDelta * (1.0 + this.wheelDeltaPercentage);
            }
            return delta;
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            this._wheel = (p) => {
                //sanity check - this should be a PointerWheel event.
                if (p.type !== PointerEventTypes.POINTERWHEEL) {
                    return;
                }
                const event = p.event;
                let delta = 0;
                const platformScale = event.deltaMode === EventConstants.DOM_DELTA_LINE ? ffMultiplier : 1; // If this happens to be set to DOM_DELTA_LINE, adjust accordingly
                const wheelDelta = -(event.deltaY * platformScale);
                if (this.customComputeDeltaFromMouseWheel) {
                    delta = this.customComputeDeltaFromMouseWheel(wheelDelta, this, event);
                }
                else {
                    if (this.wheelDeltaPercentage) {
                        delta = this._computeDeltaFromMouseWheelLegacyEvent(wheelDelta, this.camera.radius);
                        // If zooming in, estimate the target radius and use that to compute the delta for inertia
                        // this will stop multiple scroll events zooming in from adding too much inertia
                        if (delta > 0) {
                            let estimatedTargetRadius = this.camera.radius;
                            let targetInertia = this.camera.inertialRadiusOffset + delta;
                            for (let i = 0; i < 20 && Math.abs(targetInertia) > 0.001; i++) {
                                estimatedTargetRadius -= targetInertia;
                                targetInertia *= this.camera.inertia;
                            }
                            estimatedTargetRadius = Scalar.Clamp(estimatedTargetRadius, 0, Number.MAX_VALUE);
                            delta = this._computeDeltaFromMouseWheelLegacyEvent(wheelDelta, estimatedTargetRadius);
                        }
                    }
                    else {
                        delta = wheelDelta / (this.wheelPrecision * 40);
                    }
                }
                if (delta) {
                    if (this.zoomToMouseLocation) {
                        // If we are zooming to the mouse location, then we need to get the hit plane at the start of the zoom gesture if it doesn't exist
                        // The hit plane is normally calculated after the first motion and each time there's motion so if we don't do this first,
                        // the first zoom will be to the center of the screen
                        if (!this._hitPlane) {
                            this._updateHitPlane();
                        }
                        this._zoomToMouse(delta);
                    }
                    else {
                        this.camera.inertialRadiusOffset += delta;
                    }
                }
                if (event.preventDefault) {
                    if (!noPreventDefault) {
                        event.preventDefault();
                    }
                }
            };
            this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, PointerEventTypes.POINTERWHEEL);
            if (this.zoomToMouseLocation) {
                this._inertialPanning.setAll(0);
            }
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._observer) {
                this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
                this._observer = null;
                this._wheel = null;
            }
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            if (!this.zoomToMouseLocation) {
                return;
            }
            const camera = this.camera;
            const motion = 0.0 + camera.inertialAlphaOffset + camera.inertialBetaOffset + camera.inertialRadiusOffset;
            if (motion) {
                // if zooming is still happening as a result of inertia, then we also need to update
                // the hit plane.
                this._updateHitPlane();
                // Note we cannot  use arcRotateCamera.inertialPlanning here because arcRotateCamera panning
                // uses a different panningInertia which could cause this panning to get out of sync with
                // the zooming, and for this to work they must be exactly in sync.
                camera.target.addInPlace(this._inertialPanning);
                this._inertialPanning.scaleInPlace(camera.inertia);
                this._zeroIfClose(this._inertialPanning);
            }
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "ArcRotateCameraMouseWheelInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "mousewheel";
        }
        _updateHitPlane() {
            const camera = this.camera;
            const direction = camera.target.subtract(camera.position);
            this._hitPlane = Plane.FromPositionAndNormal(camera.target, direction);
        }
        // Get position on the hit plane
        _getPosition() {
            var _a;
            const camera = this.camera;
            const scene = camera.getScene();
            // since the _hitPlane is always updated to be orthogonal to the camera position vector
            // we don't have to worry about this ray shooting off to infinity. This ray creates
            // a vector defining where we want to zoom to.
            const ray = scene.createPickingRay(scene.pointerX, scene.pointerY, Matrix.Identity(), camera, false);
            // Since the camera is the origin of the picking ray, we need to offset it by the camera's offset manually
            ray.origin.x -= camera.targetScreenOffset.x;
            ray.origin.y -= camera.targetScreenOffset.y;
            let distance = 0;
            if (this._hitPlane) {
                distance = (_a = ray.intersectsPlane(this._hitPlane)) !== null && _a !== void 0 ? _a : 0;
            }
            // not using this ray again, so modifying its vectors here is fine
            return ray.origin.addInPlace(ray.direction.scaleInPlace(distance));
        }
        _zoomToMouse(delta) {
            var _a, _b;
            const camera = this.camera;
            const inertiaComp = 1 - camera.inertia;
            if (camera.lowerRadiusLimit) {
                const lowerLimit = (_a = camera.lowerRadiusLimit) !== null && _a !== void 0 ? _a : 0;
                if (camera.radius - (camera.inertialRadiusOffset + delta) / inertiaComp < lowerLimit) {
                    delta = (camera.radius - lowerLimit) * inertiaComp - camera.inertialRadiusOffset;
                }
            }
            if (camera.upperRadiusLimit) {
                const upperLimit = (_b = camera.upperRadiusLimit) !== null && _b !== void 0 ? _b : 0;
                if (camera.radius - (camera.inertialRadiusOffset + delta) / inertiaComp > upperLimit) {
                    delta = (camera.radius - upperLimit) * inertiaComp - camera.inertialRadiusOffset;
                }
            }
            const zoomDistance = delta / inertiaComp;
            const ratio = zoomDistance / camera.radius;
            const vec = this._getPosition();
            // Now this vector tells us how much we also need to pan the camera
            // so the targeted mouse location becomes the center of zooming.
            const directionToZoomLocation = TmpVectors.Vector3[6];
            vec.subtractToRef(camera.target, directionToZoomLocation);
            directionToZoomLocation.scaleInPlace(ratio);
            directionToZoomLocation.scaleInPlace(inertiaComp);
            this._inertialPanning.addInPlace(directionToZoomLocation);
            camera.inertialRadiusOffset += delta;
        }
        // Sets x y or z of passed in vector to zero if less than Epsilon.
        _zeroIfClose(vec) {
            if (Math.abs(vec.x) < Epsilon) {
                vec.x = 0;
            }
            if (Math.abs(vec.y) < Epsilon) {
                vec.y = 0;
            }
            if (Math.abs(vec.z) < Epsilon) {
                vec.z = 0;
            }
        }
    }
    __decorate$1([
        serialize()
    ], ArcRotateCameraMouseWheelInput.prototype, "wheelPrecision", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraMouseWheelInput.prototype, "zoomToMouseLocation", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraMouseWheelInput.prototype, "wheelDeltaPercentage", void 0);
    CameraInputTypes["ArcRotateCameraMouseWheelInput"] = ArcRotateCameraMouseWheelInput;

    /**
     * Default Inputs manager for the ArcRotateCamera.
     * It groups all the default supported inputs for ease of use.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class ArcRotateCameraInputsManager extends CameraInputsManager {
        /**
         * Instantiates a new ArcRotateCameraInputsManager.
         * @param camera Defines the camera the inputs belong to
         */
        constructor(camera) {
            super(camera);
        }
        /**
         * Add mouse wheel input support to the input manager.
         * @returns the current input manager
         */
        addMouseWheel() {
            this.add(new ArcRotateCameraMouseWheelInput());
            return this;
        }
        /**
         * Add pointers input support to the input manager.
         * @returns the current input manager
         */
        addPointers() {
            this.add(new ArcRotateCameraPointersInput());
            return this;
        }
        /**
         * Add keyboard input support to the input manager.
         * @returns the current input manager
         */
        addKeyboard() {
            this.add(new ArcRotateCameraKeyboardMoveInput());
            return this;
        }
    }

    Node.AddNodeConstructor("ArcRotateCamera", (name, scene) => {
        return () => new ArcRotateCamera(name, 0, 0, 1.0, Vector3.Zero(), scene);
    });
    /**
     * This represents an orbital type of camera.
     *
     * This camera always points towards a given target position and can be rotated around that target with the target as the centre of rotation. It can be controlled with cursors and mouse, or with touch events.
     * Think of this camera as one orbiting its target position, or more imaginatively as a spy satellite orbiting the earth. Its position relative to the target (earth) can be set by three parameters, alpha (radians) the longitudinal rotation, beta (radians) the latitudinal rotation and radius the distance from the target position.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#arc-rotate-camera
     */
    class ArcRotateCamera extends TargetCamera {
        /**
         * Defines the target point of the camera.
         * The camera looks towards it from the radius distance.
         */
        get target() {
            return this._target;
        }
        set target(value) {
            this.setTarget(value);
        }
        /**
         * Defines the target mesh of the camera.
         * The camera looks towards it from the radius distance.
         * Please note that setting a target host will disable panning.
         */
        get targetHost() {
            return this._targetHost;
        }
        set targetHost(value) {
            if (value) {
                this.setTarget(value);
            }
        }
        /**
         * Return the current target position of the camera. This value is expressed in local space.
         * @returns the target position
         */
        getTarget() {
            return this.target;
        }
        /**
         * Define the current local position of the camera in the scene
         */
        get position() {
            return this._position;
        }
        set position(newPosition) {
            this.setPosition(newPosition);
        }
        /**
         * The vector the camera should consider as up. (default is Vector3(0, 1, 0) as returned by Vector3.Up())
         * Setting this will copy the given vector to the camera's upVector, and set rotation matrices to and from Y up.
         * DO NOT set the up vector using copyFrom or copyFromFloats, as this bypasses setting the above matrices.
         */
        set upVector(vec) {
            if (!this._upToYMatrix) {
                this._yToUpMatrix = new Matrix();
                this._upToYMatrix = new Matrix();
                this._upVector = Vector3.Zero();
            }
            vec.normalize();
            this._upVector.copyFrom(vec);
            this.setMatUp();
        }
        get upVector() {
            return this._upVector;
        }
        /**
         * Sets the Y-up to camera up-vector rotation matrix, and the up-vector to Y-up rotation matrix.
         */
        setMatUp() {
            // from y-up to custom-up (used in _getViewMatrix)
            Matrix.RotationAlignToRef(Vector3.UpReadOnly, this._upVector, this._yToUpMatrix);
            // from custom-up to y-up (used in rebuildAnglesAndRadius)
            Matrix.RotationAlignToRef(this._upVector, Vector3.UpReadOnly, this._upToYMatrix);
        }
        //-- begin properties for backward compatibility for inputs
        /**
         * Gets or Set the pointer angular sensibility  along the X axis or how fast is the camera rotating.
         */
        get angularSensibilityX() {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                return pointers.angularSensibilityX;
            }
            return 0;
        }
        set angularSensibilityX(value) {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                pointers.angularSensibilityX = value;
            }
        }
        /**
         * Gets or Set the pointer angular sensibility along the Y axis or how fast is the camera rotating.
         */
        get angularSensibilityY() {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                return pointers.angularSensibilityY;
            }
            return 0;
        }
        set angularSensibilityY(value) {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                pointers.angularSensibilityY = value;
            }
        }
        /**
         * Gets or Set the pointer pinch precision or how fast is the camera zooming.
         */
        get pinchPrecision() {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                return pointers.pinchPrecision;
            }
            return 0;
        }
        set pinchPrecision(value) {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                pointers.pinchPrecision = value;
            }
        }
        /**
         * Gets or Set the pointer pinch delta percentage or how fast is the camera zooming.
         * It will be used instead of pinchDeltaPrecision if different from 0.
         * It defines the percentage of current camera.radius to use as delta when pinch zoom is used.
         */
        get pinchDeltaPercentage() {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                return pointers.pinchDeltaPercentage;
            }
            return 0;
        }
        set pinchDeltaPercentage(value) {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                pointers.pinchDeltaPercentage = value;
            }
        }
        /**
         * Gets or Set the pointer use natural pinch zoom to override the pinch precision
         * and pinch delta percentage.
         * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
         * that any object in the plane at the camera's target point will scale
         * perfectly with finger motion.
         */
        get useNaturalPinchZoom() {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                return pointers.useNaturalPinchZoom;
            }
            return false;
        }
        set useNaturalPinchZoom(value) {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                pointers.useNaturalPinchZoom = value;
            }
        }
        /**
         * Gets or Set the pointer panning sensibility or how fast is the camera moving.
         */
        get panningSensibility() {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                return pointers.panningSensibility;
            }
            return 0;
        }
        set panningSensibility(value) {
            const pointers = this.inputs.attached["pointers"];
            if (pointers) {
                pointers.panningSensibility = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control beta angle in a positive direction.
         */
        get keysUp() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysUp;
            }
            return [];
        }
        set keysUp(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysUp = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control beta angle in a negative direction.
         */
        get keysDown() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysDown;
            }
            return [];
        }
        set keysDown(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysDown = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control alpha angle in a negative direction.
         */
        get keysLeft() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysLeft;
            }
            return [];
        }
        set keysLeft(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysLeft = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control alpha angle in a positive direction.
         */
        get keysRight() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysRight;
            }
            return [];
        }
        set keysRight(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysRight = value;
            }
        }
        /**
         * Gets or Set the mouse wheel precision or how fast is the camera zooming.
         */
        get wheelPrecision() {
            const mousewheel = this.inputs.attached["mousewheel"];
            if (mousewheel) {
                return mousewheel.wheelPrecision;
            }
            return 0;
        }
        set wheelPrecision(value) {
            const mousewheel = this.inputs.attached["mousewheel"];
            if (mousewheel) {
                mousewheel.wheelPrecision = value;
            }
        }
        /**
         * Gets or Set the boolean value that controls whether or not the mouse wheel
         * zooms to the location of the mouse pointer or not.  The default is false.
         */
        get zoomToMouseLocation() {
            const mousewheel = this.inputs.attached["mousewheel"];
            if (mousewheel) {
                return mousewheel.zoomToMouseLocation;
            }
            return false;
        }
        set zoomToMouseLocation(value) {
            const mousewheel = this.inputs.attached["mousewheel"];
            if (mousewheel) {
                mousewheel.zoomToMouseLocation = value;
            }
        }
        /**
         * Gets or Set the mouse wheel delta percentage or how fast is the camera zooming.
         * It will be used instead of pinchDeltaPrecision if different from 0.
         * It defines the percentage of current camera.radius to use as delta when pinch zoom is used.
         */
        get wheelDeltaPercentage() {
            const mousewheel = this.inputs.attached["mousewheel"];
            if (mousewheel) {
                return mousewheel.wheelDeltaPercentage;
            }
            return 0;
        }
        set wheelDeltaPercentage(value) {
            const mousewheel = this.inputs.attached["mousewheel"];
            if (mousewheel) {
                mousewheel.wheelDeltaPercentage = value;
            }
        }
        /**
         * Gets the bouncing behavior of the camera if it has been enabled.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
         */
        get bouncingBehavior() {
            return this._bouncingBehavior;
        }
        /**
         * Defines if the bouncing behavior of the camera is enabled on the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
         */
        get useBouncingBehavior() {
            return this._bouncingBehavior != null;
        }
        set useBouncingBehavior(value) {
            if (value === this.useBouncingBehavior) {
                return;
            }
            if (value) {
                this._bouncingBehavior = new BouncingBehavior();
                this.addBehavior(this._bouncingBehavior);
            }
            else if (this._bouncingBehavior) {
                this.removeBehavior(this._bouncingBehavior);
                this._bouncingBehavior = null;
            }
        }
        /**
         * Gets the framing behavior of the camera if it has been enabled.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
         */
        get framingBehavior() {
            return this._framingBehavior;
        }
        /**
         * Defines if the framing behavior of the camera is enabled on the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
         */
        get useFramingBehavior() {
            return this._framingBehavior != null;
        }
        set useFramingBehavior(value) {
            if (value === this.useFramingBehavior) {
                return;
            }
            if (value) {
                this._framingBehavior = new FramingBehavior();
                this.addBehavior(this._framingBehavior);
            }
            else if (this._framingBehavior) {
                this.removeBehavior(this._framingBehavior);
                this._framingBehavior = null;
            }
        }
        /**
         * Gets the auto rotation behavior of the camera if it has been enabled.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
         */
        get autoRotationBehavior() {
            return this._autoRotationBehavior;
        }
        /**
         * Defines if the auto rotation behavior of the camera is enabled on the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
         */
        get useAutoRotationBehavior() {
            return this._autoRotationBehavior != null;
        }
        set useAutoRotationBehavior(value) {
            if (value === this.useAutoRotationBehavior) {
                return;
            }
            if (value) {
                this._autoRotationBehavior = new AutoRotationBehavior();
                this.addBehavior(this._autoRotationBehavior);
            }
            else if (this._autoRotationBehavior) {
                this.removeBehavior(this._autoRotationBehavior);
                this._autoRotationBehavior = null;
            }
        }
        /**
         * Instantiates a new ArcRotateCamera in a given scene
         * @param name Defines the name of the camera
         * @param alpha Defines the camera rotation along the longitudinal axis
         * @param beta Defines the camera rotation along the latitudinal axis
         * @param radius Defines the camera distance from its target
         * @param target Defines the camera target
         * @param scene Defines the scene the camera belongs to
         * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
         */
        constructor(name, alpha, beta, radius, target, scene, setActiveOnSceneIfNoneActive = true) {
            super(name, Vector3.Zero(), scene, setActiveOnSceneIfNoneActive);
            /**
             * Current inertia value on the longitudinal axis.
             * The bigger this number the longer it will take for the camera to stop.
             */
            this.inertialAlphaOffset = 0;
            /**
             * Current inertia value on the latitudinal axis.
             * The bigger this number the longer it will take for the camera to stop.
             */
            this.inertialBetaOffset = 0;
            /**
             * Current inertia value on the radius axis.
             * The bigger this number the longer it will take for the camera to stop.
             */
            this.inertialRadiusOffset = 0;
            /**
             * Minimum allowed angle on the longitudinal axis.
             * This can help limiting how the Camera is able to move in the scene.
             */
            this.lowerAlphaLimit = null;
            /**
             * Maximum allowed angle on the longitudinal axis.
             * This can help limiting how the Camera is able to move in the scene.
             */
            this.upperAlphaLimit = null;
            /**
             * Minimum allowed angle on the latitudinal axis.
             * This can help limiting how the Camera is able to move in the scene.
             */
            this.lowerBetaLimit = 0.01;
            /**
             * Maximum allowed angle on the latitudinal axis.
             * This can help limiting how the Camera is able to move in the scene.
             */
            this.upperBetaLimit = Math.PI - 0.01;
            /**
             * Minimum allowed distance of the camera to the target (The camera can not get closer).
             * This can help limiting how the Camera is able to move in the scene.
             */
            this.lowerRadiusLimit = null;
            /**
             * Maximum allowed distance of the camera to the target (The camera can not get further).
             * This can help limiting how the Camera is able to move in the scene.
             */
            this.upperRadiusLimit = null;
            /**
             * Defines the current inertia value used during panning of the camera along the X axis.
             */
            this.inertialPanningX = 0;
            /**
             * Defines the current inertia value used during panning of the camera along the Y axis.
             */
            this.inertialPanningY = 0;
            /**
             * Defines the distance used to consider the camera in pan mode vs pinch/zoom.
             * Basically if your fingers moves away from more than this distance you will be considered
             * in pinch mode.
             */
            this.pinchToPanMaxDistance = 20;
            /**
             * Defines the maximum distance the camera can pan.
             * This could help keeping the camera always in your scene.
             */
            this.panningDistanceLimit = null;
            /**
             * Defines the target of the camera before panning.
             */
            this.panningOriginTarget = Vector3.Zero();
            /**
             * Defines the value of the inertia used during panning.
             * 0 would mean stop inertia and one would mean no deceleration at all.
             */
            this.panningInertia = 0.9;
            //-- end properties for backward compatibility for inputs
            /**
             * Defines how much the radius should be scaled while zooming on a particular mesh (through the zoomOn function)
             */
            this.zoomOnFactor = 1;
            /**
             * Defines a screen offset for the camera position.
             */
            this.targetScreenOffset = Vector2.Zero();
            /**
             * Allows the camera to be completely reversed.
             * If false the camera can not arrive upside down.
             */
            this.allowUpsideDown = true;
            /**
             * Define if double tap/click is used to restore the previously saved state of the camera.
             */
            this.useInputToRestoreState = true;
            /** @internal */
            this._viewMatrix = new Matrix();
            /**
             * Defines the allowed panning axis.
             */
            this.panningAxis = new Vector3(1, 1, 0);
            this._transformedDirection = new Vector3();
            /**
             * Defines if camera will eliminate transform on y axis.
             */
            this.mapPanning = false;
            /**
             * Observable triggered when the mesh target has been changed on the camera.
             */
            this.onMeshTargetChangedObservable = new Observable$1();
            /**
             * Defines whether the camera should check collision with the objects oh the scene.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#how-can-i-do-this-
             */
            this.checkCollisions = false;
            /**
             * Defines the collision radius of the camera.
             * This simulates a sphere around the camera.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#arcrotatecamera
             */
            this.collisionRadius = new Vector3(0.5, 0.5, 0.5);
            this._previousPosition = Vector3.Zero();
            this._collisionVelocity = Vector3.Zero();
            this._newPosition = Vector3.Zero();
            this._computationVector = Vector3.Zero();
            this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null) => {
                if (!collidedMesh) {
                    this._previousPosition.copyFrom(this._position);
                }
                else {
                    this.setPosition(newPosition);
                    if (this.onCollide) {
                        this.onCollide(collidedMesh);
                    }
                }
                // Recompute because of constraints
                const cosa = Math.cos(this.alpha);
                const sina = Math.sin(this.alpha);
                const cosb = Math.cos(this.beta);
                let sinb = Math.sin(this.beta);
                if (sinb === 0) {
                    sinb = 0.0001;
                }
                const target = this._getTargetPosition();
                this._computationVector.copyFromFloats(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb);
                target.addToRef(this._computationVector, this._newPosition);
                this._position.copyFrom(this._newPosition);
                let up = this.upVector;
                if (this.allowUpsideDown && this.beta < 0) {
                    up = up.clone();
                    up = up.negate();
                }
                this._computeViewMatrix(this._position, target, up);
                this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x);
                this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
                this._collisionTriggered = false;
            };
            this._target = Vector3.Zero();
            if (target) {
                this.setTarget(target);
            }
            this.alpha = alpha;
            this.beta = beta;
            this.radius = radius;
            this.getViewMatrix();
            this.inputs = new ArcRotateCameraInputsManager(this);
            this.inputs.addKeyboard().addMouseWheel().addPointers();
        }
        // Cache
        /** @internal */
        _initCache() {
            super._initCache();
            this._cache._target = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cache.alpha = undefined;
            this._cache.beta = undefined;
            this._cache.radius = undefined;
            this._cache.targetScreenOffset = Vector2.Zero();
        }
        /**
         * @internal
         */
        _updateCache(ignoreParentClass) {
            if (!ignoreParentClass) {
                super._updateCache();
            }
            this._cache._target.copyFrom(this._getTargetPosition());
            this._cache.alpha = this.alpha;
            this._cache.beta = this.beta;
            this._cache.radius = this.radius;
            this._cache.targetScreenOffset.copyFrom(this.targetScreenOffset);
        }
        _getTargetPosition() {
            if (this._targetHost && this._targetHost.getAbsolutePosition) {
                const pos = this._targetHost.getAbsolutePosition();
                if (this._targetBoundingCenter) {
                    pos.addToRef(this._targetBoundingCenter, this._target);
                }
                else {
                    this._target.copyFrom(pos);
                }
            }
            const lockedTargetPosition = this._getLockedTargetPosition();
            if (lockedTargetPosition) {
                return lockedTargetPosition;
            }
            return this._target;
        }
        /**
         * Stores the current state of the camera (alpha, beta, radius and target)
         * @returns the camera itself
         */
        storeState() {
            this._storedAlpha = this.alpha;
            this._storedBeta = this.beta;
            this._storedRadius = this.radius;
            this._storedTarget = this._getTargetPosition().clone();
            this._storedTargetScreenOffset = this.targetScreenOffset.clone();
            return super.storeState();
        }
        /**
         * @internal
         * Restored camera state. You must call storeState() first
         */
        _restoreStateValues() {
            if (!super._restoreStateValues()) {
                return false;
            }
            this.setTarget(this._storedTarget.clone());
            this.alpha = this._storedAlpha;
            this.beta = this._storedBeta;
            this.radius = this._storedRadius;
            this.targetScreenOffset = this._storedTargetScreenOffset.clone();
            this.inertialAlphaOffset = 0;
            this.inertialBetaOffset = 0;
            this.inertialRadiusOffset = 0;
            this.inertialPanningX = 0;
            this.inertialPanningY = 0;
            return true;
        }
        // Synchronized
        /** @internal */
        _isSynchronizedViewMatrix() {
            if (!super._isSynchronizedViewMatrix()) {
                return false;
            }
            return (this._cache._target.equals(this._getTargetPosition()) &&
                this._cache.alpha === this.alpha &&
                this._cache.beta === this.beta &&
                this._cache.radius === this.radius &&
                this._cache.targetScreenOffset.equals(this.targetScreenOffset));
        }
        /**
         * Attached controls to the current camera.
         * @param ignored defines an ignored parameter kept for backward compatibility.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         * @param useCtrlForPanning  Defines whether ctrl is used for panning within the controls
         * @param panningMouseButton Defines whether panning is allowed through mouse click button
         */
        attachControl(ignored, noPreventDefault, useCtrlForPanning = true, panningMouseButton = 2) {
            // eslint-disable-next-line prefer-rest-params
            const args = arguments;
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(args);
            this._useCtrlForPanning = useCtrlForPanning;
            this._panningMouseButton = panningMouseButton;
            // backwards compatibility
            if (typeof args[0] === "boolean") {
                if (args.length > 1) {
                    this._useCtrlForPanning = args[1];
                }
                if (args.length > 2) {
                    this._panningMouseButton = args[2];
                }
            }
            this.inputs.attachElement(noPreventDefault);
            this._reset = () => {
                this.inertialAlphaOffset = 0;
                this.inertialBetaOffset = 0;
                this.inertialRadiusOffset = 0;
                this.inertialPanningX = 0;
                this.inertialPanningY = 0;
            };
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            this.inputs.detachElement();
            if (this._reset) {
                this._reset();
            }
        }
        /** @internal */
        _checkInputs() {
            //if (async) collision inspection was triggered, don't update the camera's position - until the collision callback was called.
            if (this._collisionTriggered) {
                return;
            }
            this.inputs.checkInputs();
            // Inertia
            if (this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0 || this.inertialRadiusOffset !== 0) {
                const directionModifier = this.invertRotation ? -1 : 1;
                let inertialAlphaOffset = this.inertialAlphaOffset;
                if (this.beta <= 0) {
                    inertialAlphaOffset *= -1;
                }
                if (this.getScene().useRightHandedSystem) {
                    inertialAlphaOffset *= -1;
                }
                if (this.parent && this.parent._getWorldMatrixDeterminant() < 0) {
                    inertialAlphaOffset *= -1;
                }
                this.alpha += inertialAlphaOffset * directionModifier;
                this.beta += this.inertialBetaOffset * directionModifier;
                this.radius -= this.inertialRadiusOffset;
                this.inertialAlphaOffset *= this.inertia;
                this.inertialBetaOffset *= this.inertia;
                this.inertialRadiusOffset *= this.inertia;
                if (Math.abs(this.inertialAlphaOffset) < Epsilon) {
                    this.inertialAlphaOffset = 0;
                }
                if (Math.abs(this.inertialBetaOffset) < Epsilon) {
                    this.inertialBetaOffset = 0;
                }
                if (Math.abs(this.inertialRadiusOffset) < this.speed * Epsilon) {
                    this.inertialRadiusOffset = 0;
                }
            }
            // Panning inertia
            if (this.inertialPanningX !== 0 || this.inertialPanningY !== 0) {
                const localDirection = new Vector3(this.inertialPanningX, this.inertialPanningY, this.inertialPanningY);
                this._viewMatrix.invertToRef(this._cameraTransformMatrix);
                localDirection.multiplyInPlace(this.panningAxis);
                Vector3.TransformNormalToRef(localDirection, this._cameraTransformMatrix, this._transformedDirection);
                // Eliminate y if mapPanning is enabled
                if (this.mapPanning || !this.panningAxis.y) {
                    this._transformedDirection.y = 0;
                }
                if (!this._targetHost) {
                    if (this.panningDistanceLimit) {
                        this._transformedDirection.addInPlace(this._target);
                        const distanceSquared = Vector3.DistanceSquared(this._transformedDirection, this.panningOriginTarget);
                        if (distanceSquared <= this.panningDistanceLimit * this.panningDistanceLimit) {
                            this._target.copyFrom(this._transformedDirection);
                        }
                    }
                    else {
                        this._target.addInPlace(this._transformedDirection);
                    }
                }
                this.inertialPanningX *= this.panningInertia;
                this.inertialPanningY *= this.panningInertia;
                if (Math.abs(this.inertialPanningX) < this.speed * Epsilon) {
                    this.inertialPanningX = 0;
                }
                if (Math.abs(this.inertialPanningY) < this.speed * Epsilon) {
                    this.inertialPanningY = 0;
                }
            }
            // Limits
            this._checkLimits();
            super._checkInputs();
        }
        _checkLimits() {
            if (this.lowerBetaLimit === null || this.lowerBetaLimit === undefined) {
                if (this.allowUpsideDown && this.beta > Math.PI) {
                    this.beta = this.beta - 2 * Math.PI;
                }
            }
            else {
                if (this.beta < this.lowerBetaLimit) {
                    this.beta = this.lowerBetaLimit;
                }
            }
            if (this.upperBetaLimit === null || this.upperBetaLimit === undefined) {
                if (this.allowUpsideDown && this.beta < -Math.PI) {
                    this.beta = this.beta + 2 * Math.PI;
                }
            }
            else {
                if (this.beta > this.upperBetaLimit) {
                    this.beta = this.upperBetaLimit;
                }
            }
            if (this.lowerAlphaLimit !== null && this.alpha < this.lowerAlphaLimit) {
                this.alpha = this.lowerAlphaLimit;
            }
            if (this.upperAlphaLimit !== null && this.alpha > this.upperAlphaLimit) {
                this.alpha = this.upperAlphaLimit;
            }
            if (this.lowerRadiusLimit !== null && this.radius < this.lowerRadiusLimit) {
                this.radius = this.lowerRadiusLimit;
                this.inertialRadiusOffset = 0;
            }
            if (this.upperRadiusLimit !== null && this.radius > this.upperRadiusLimit) {
                this.radius = this.upperRadiusLimit;
                this.inertialRadiusOffset = 0;
            }
        }
        /**
         * Rebuilds angles (alpha, beta) and radius from the give position and target
         */
        rebuildAnglesAndRadius() {
            this._position.subtractToRef(this._getTargetPosition(), this._computationVector);
            // need to rotate to Y up equivalent if up vector not Axis.Y
            if (this._upVector.x !== 0 || this._upVector.y !== 1.0 || this._upVector.z !== 0) {
                Vector3.TransformCoordinatesToRef(this._computationVector, this._upToYMatrix, this._computationVector);
            }
            this.radius = this._computationVector.length();
            if (this.radius === 0) {
                this.radius = 0.0001; // Just to avoid division by zero
            }
            // Alpha
            const previousAlpha = this.alpha;
            if (this._computationVector.x === 0 && this._computationVector.z === 0) {
                this.alpha = Math.PI / 2; // avoid division by zero when looking along up axis, and set to acos(0)
            }
            else {
                this.alpha = Math.acos(this._computationVector.x / Math.sqrt(Math.pow(this._computationVector.x, 2) + Math.pow(this._computationVector.z, 2)));
            }
            if (this._computationVector.z < 0) {
                this.alpha = 2 * Math.PI - this.alpha;
            }
            // Calculate the number of revolutions between the new and old alpha values.
            const alphaCorrectionTurns = Math.round((previousAlpha - this.alpha) / (2.0 * Math.PI));
            // Adjust alpha so that its numerical representation is the closest one to the old value.
            this.alpha += alphaCorrectionTurns * 2.0 * Math.PI;
            // Beta
            this.beta = Math.acos(this._computationVector.y / this.radius);
            this._checkLimits();
        }
        /**
         * Use a position to define the current camera related information like alpha, beta and radius
         * @param position Defines the position to set the camera at
         */
        setPosition(position) {
            if (this._position.equals(position)) {
                return;
            }
            this._position.copyFrom(position);
            this.rebuildAnglesAndRadius();
        }
        /**
         * Defines the target the camera should look at.
         * This will automatically adapt alpha beta and radius to fit within the new target.
         * Please note that setting a target as a mesh will disable panning.
         * @param target Defines the new target as a Vector or a mesh
         * @param toBoundingCenter In case of a mesh target, defines whether to target the mesh position or its bounding information center
         * @param allowSamePosition If false, prevents reapplying the new computed position if it is identical to the current one (optim)
         * @param cloneAlphaBetaRadius If true, replicate the current setup (alpha, beta, radius) on the new target
         */
        setTarget(target, toBoundingCenter = false, allowSamePosition = false, cloneAlphaBetaRadius = false) {
            var _a;
            cloneAlphaBetaRadius = (_a = this.overrideCloneAlphaBetaRadius) !== null && _a !== void 0 ? _a : cloneAlphaBetaRadius;
            if (target.getBoundingInfo) {
                if (toBoundingCenter) {
                    this._targetBoundingCenter = target.getBoundingInfo().boundingBox.centerWorld.clone();
                }
                else {
                    this._targetBoundingCenter = null;
                }
                target.computeWorldMatrix();
                this._targetHost = target;
                this._target = this._getTargetPosition();
                this.onMeshTargetChangedObservable.notifyObservers(this._targetHost);
            }
            else {
                const newTarget = target;
                const currentTarget = this._getTargetPosition();
                if (currentTarget && !allowSamePosition && currentTarget.equals(newTarget)) {
                    return;
                }
                this._targetHost = null;
                this._target = newTarget;
                this._targetBoundingCenter = null;
                this.onMeshTargetChangedObservable.notifyObservers(null);
            }
            if (!cloneAlphaBetaRadius) {
                this.rebuildAnglesAndRadius();
            }
        }
        /** @internal */
        _getViewMatrix() {
            // Compute
            const cosa = Math.cos(this.alpha);
            const sina = Math.sin(this.alpha);
            const cosb = Math.cos(this.beta);
            let sinb = Math.sin(this.beta);
            if (sinb === 0) {
                sinb = 0.0001;
            }
            if (this.radius === 0) {
                this.radius = 0.0001; // Just to avoid division by zero
            }
            const target = this._getTargetPosition();
            this._computationVector.copyFromFloats(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb);
            // Rotate according to up vector
            if (this._upVector.x !== 0 || this._upVector.y !== 1.0 || this._upVector.z !== 0) {
                Vector3.TransformCoordinatesToRef(this._computationVector, this._yToUpMatrix, this._computationVector);
            }
            target.addToRef(this._computationVector, this._newPosition);
            if (this.getScene().collisionsEnabled && this.checkCollisions) {
                const coordinator = this.getScene().collisionCoordinator;
                if (!this._collider) {
                    this._collider = coordinator.createCollider();
                }
                this._collider._radius = this.collisionRadius;
                this._newPosition.subtractToRef(this._position, this._collisionVelocity);
                this._collisionTriggered = true;
                coordinator.getNewPosition(this._position, this._collisionVelocity, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
            }
            else {
                this._position.copyFrom(this._newPosition);
                let up = this.upVector;
                if (this.allowUpsideDown && sinb < 0) {
                    up = up.negate();
                }
                this._computeViewMatrix(this._position, target, up);
                this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x);
                this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
            }
            this._currentTarget = target;
            return this._viewMatrix;
        }
        /**
         * Zooms on a mesh to be at the min distance where we could see it fully in the current viewport.
         * @param meshes Defines the mesh to zoom on
         * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
         */
        zoomOn(meshes, doNotUpdateMaxZ = false) {
            meshes = meshes || this.getScene().meshes;
            const minMaxVector = Mesh.MinMax(meshes);
            const distance = Vector3.Distance(minMaxVector.min, minMaxVector.max);
            this.radius = distance * this.zoomOnFactor;
            this.focusOn({ min: minMaxVector.min, max: minMaxVector.max, distance: distance }, doNotUpdateMaxZ);
        }
        /**
         * Focus on a mesh or a bounding box. This adapts the target and maxRadius if necessary but does not update the current radius.
         * The target will be changed but the radius
         * @param meshesOrMinMaxVectorAndDistance Defines the mesh or bounding info to focus on
         * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
         */
        focusOn(meshesOrMinMaxVectorAndDistance, doNotUpdateMaxZ = false) {
            let meshesOrMinMaxVector;
            let distance;
            if (meshesOrMinMaxVectorAndDistance.min === undefined) {
                // meshes
                const meshes = meshesOrMinMaxVectorAndDistance || this.getScene().meshes;
                meshesOrMinMaxVector = Mesh.MinMax(meshes);
                distance = Vector3.Distance(meshesOrMinMaxVector.min, meshesOrMinMaxVector.max);
            }
            else {
                //minMaxVector and distance
                const minMaxVectorAndDistance = meshesOrMinMaxVectorAndDistance;
                meshesOrMinMaxVector = minMaxVectorAndDistance;
                distance = minMaxVectorAndDistance.distance;
            }
            this._target = Mesh.Center(meshesOrMinMaxVector);
            if (!doNotUpdateMaxZ) {
                this.maxZ = distance * 2;
            }
        }
        /**
         * @override
         * Override Camera.createRigCamera
         */
        createRigCamera(name, cameraIndex) {
            let alphaShift = 0;
            switch (this.cameraRigMode) {
                case Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH:
                case Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
                case Camera.RIG_MODE_STEREOSCOPIC_OVERUNDER:
                case Camera.RIG_MODE_STEREOSCOPIC_INTERLACED:
                case Camera.RIG_MODE_VR:
                    alphaShift = this._cameraRigParams.stereoHalfAngle * (cameraIndex === 0 ? 1 : -1);
                    break;
                case Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                    alphaShift = this._cameraRigParams.stereoHalfAngle * (cameraIndex === 0 ? -1 : 1);
                    break;
            }
            const rigCam = new ArcRotateCamera(name, this.alpha + alphaShift, this.beta, this.radius, this._target, this.getScene());
            rigCam._cameraRigParams = {};
            rigCam.isRigCamera = true;
            rigCam.rigParent = this;
            rigCam.upVector = this.upVector;
            rigCam.mode = this.mode;
            rigCam.orthoLeft = this.orthoLeft;
            rigCam.orthoRight = this.orthoRight;
            rigCam.orthoBottom = this.orthoBottom;
            rigCam.orthoTop = this.orthoTop;
            return rigCam;
        }
        /**
         * @internal
         * @override
         * Override Camera._updateRigCameras
         */
        _updateRigCameras() {
            const camLeft = this._rigCameras[0];
            const camRight = this._rigCameras[1];
            camLeft.beta = camRight.beta = this.beta;
            switch (this.cameraRigMode) {
                case Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH:
                case Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
                case Camera.RIG_MODE_STEREOSCOPIC_OVERUNDER:
                case Camera.RIG_MODE_STEREOSCOPIC_INTERLACED:
                case Camera.RIG_MODE_VR:
                    camLeft.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
                    camRight.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
                    break;
                case Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                    camLeft.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
                    camRight.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
                    break;
            }
            super._updateRigCameras();
        }
        /**
         * Destroy the camera and release the current resources hold by it.
         */
        dispose() {
            this.inputs.clear();
            super.dispose();
        }
        /**
         * Gets the current object class name.
         * @returns the class name
         */
        getClassName() {
            return "ArcRotateCamera";
        }
    }
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "alpha", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "beta", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "radius", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "overrideCloneAlphaBetaRadius", void 0);
    __decorate$1([
        serializeAsVector3("target")
    ], ArcRotateCamera.prototype, "_target", void 0);
    __decorate$1([
        serializeAsMeshReference("targetHost")
    ], ArcRotateCamera.prototype, "_targetHost", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "inertialAlphaOffset", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "inertialBetaOffset", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "inertialRadiusOffset", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "lowerAlphaLimit", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "upperAlphaLimit", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "lowerBetaLimit", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "upperBetaLimit", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "lowerRadiusLimit", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "upperRadiusLimit", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "inertialPanningX", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "inertialPanningY", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "pinchToPanMaxDistance", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "panningDistanceLimit", void 0);
    __decorate$1([
        serializeAsVector3()
    ], ArcRotateCamera.prototype, "panningOriginTarget", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "panningInertia", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "zoomToMouseLocation", null);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "zoomOnFactor", void 0);
    __decorate$1([
        serializeAsVector2()
    ], ArcRotateCamera.prototype, "targetScreenOffset", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "allowUpsideDown", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCamera.prototype, "useInputToRestoreState", void 0);

    /**
     * Class representing a ray with position and direction
     */
    class Ray {
        /**
         * Creates a new ray
         * @param origin origin point
         * @param direction direction
         * @param length length of the ray
         */
        constructor(
        /** origin point */
        origin, 
        /** direction */
        direction, 
        /** length of the ray */
        length = Number.MAX_VALUE) {
            this.origin = origin;
            this.direction = direction;
            this.length = length;
        }
        // Methods
        /**
         * Clone the current ray
         * @returns a new ray
         */
        clone() {
            return new Ray(this.origin.clone(), this.direction.clone(), this.length);
        }
        /**
         * Checks if the ray intersects a box
         * This does not account for the ray length by design to improve perfs.
         * @param minimum bound of the box
         * @param maximum bound of the box
         * @param intersectionTreshold extra extend to be added to the box in all direction
         * @returns if the box was hit
         */
        intersectsBoxMinMax(minimum, maximum, intersectionTreshold = 0) {
            const newMinimum = Ray._TmpVector3[0].copyFromFloats(minimum.x - intersectionTreshold, minimum.y - intersectionTreshold, minimum.z - intersectionTreshold);
            const newMaximum = Ray._TmpVector3[1].copyFromFloats(maximum.x + intersectionTreshold, maximum.y + intersectionTreshold, maximum.z + intersectionTreshold);
            let d = 0.0;
            let maxValue = Number.MAX_VALUE;
            let inv;
            let min;
            let max;
            let temp;
            if (Math.abs(this.direction.x) < 0.0000001) {
                if (this.origin.x < newMinimum.x || this.origin.x > newMaximum.x) {
                    return false;
                }
            }
            else {
                inv = 1.0 / this.direction.x;
                min = (newMinimum.x - this.origin.x) * inv;
                max = (newMaximum.x - this.origin.x) * inv;
                if (max === -Infinity) {
                    max = Infinity;
                }
                if (min > max) {
                    temp = min;
                    min = max;
                    max = temp;
                }
                d = Math.max(min, d);
                maxValue = Math.min(max, maxValue);
                if (d > maxValue) {
                    return false;
                }
            }
            if (Math.abs(this.direction.y) < 0.0000001) {
                if (this.origin.y < newMinimum.y || this.origin.y > newMaximum.y) {
                    return false;
                }
            }
            else {
                inv = 1.0 / this.direction.y;
                min = (newMinimum.y - this.origin.y) * inv;
                max = (newMaximum.y - this.origin.y) * inv;
                if (max === -Infinity) {
                    max = Infinity;
                }
                if (min > max) {
                    temp = min;
                    min = max;
                    max = temp;
                }
                d = Math.max(min, d);
                maxValue = Math.min(max, maxValue);
                if (d > maxValue) {
                    return false;
                }
            }
            if (Math.abs(this.direction.z) < 0.0000001) {
                if (this.origin.z < newMinimum.z || this.origin.z > newMaximum.z) {
                    return false;
                }
            }
            else {
                inv = 1.0 / this.direction.z;
                min = (newMinimum.z - this.origin.z) * inv;
                max = (newMaximum.z - this.origin.z) * inv;
                if (max === -Infinity) {
                    max = Infinity;
                }
                if (min > max) {
                    temp = min;
                    min = max;
                    max = temp;
                }
                d = Math.max(min, d);
                maxValue = Math.min(max, maxValue);
                if (d > maxValue) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Checks if the ray intersects a box
         * This does not account for the ray lenght by design to improve perfs.
         * @param box the bounding box to check
         * @param intersectionTreshold extra extend to be added to the BoundingBox in all direction
         * @returns if the box was hit
         */
        intersectsBox(box, intersectionTreshold = 0) {
            return this.intersectsBoxMinMax(box.minimum, box.maximum, intersectionTreshold);
        }
        /**
         * If the ray hits a sphere
         * @param sphere the bounding sphere to check
         * @param intersectionTreshold extra extend to be added to the BoundingSphere in all direction
         * @returns true if it hits the sphere
         */
        intersectsSphere(sphere, intersectionTreshold = 0) {
            const x = sphere.center.x - this.origin.x;
            const y = sphere.center.y - this.origin.y;
            const z = sphere.center.z - this.origin.z;
            const pyth = x * x + y * y + z * z;
            const radius = sphere.radius + intersectionTreshold;
            const rr = radius * radius;
            if (pyth <= rr) {
                return true;
            }
            const dot = x * this.direction.x + y * this.direction.y + z * this.direction.z;
            if (dot < 0.0) {
                return false;
            }
            const temp = pyth - dot * dot;
            return temp <= rr;
        }
        /**
         * If the ray hits a triange
         * @param vertex0 triangle vertex
         * @param vertex1 triangle vertex
         * @param vertex2 triangle vertex
         * @returns intersection information if hit
         */
        intersectsTriangle(vertex0, vertex1, vertex2) {
            const edge1 = Ray._TmpVector3[0];
            const edge2 = Ray._TmpVector3[1];
            const pvec = Ray._TmpVector3[2];
            const tvec = Ray._TmpVector3[3];
            const qvec = Ray._TmpVector3[4];
            vertex1.subtractToRef(vertex0, edge1);
            vertex2.subtractToRef(vertex0, edge2);
            Vector3.CrossToRef(this.direction, edge2, pvec);
            const det = Vector3.Dot(edge1, pvec);
            if (det === 0) {
                return null;
            }
            const invdet = 1 / det;
            this.origin.subtractToRef(vertex0, tvec);
            const bv = Vector3.Dot(tvec, pvec) * invdet;
            if (bv < 0 || bv > 1.0) {
                return null;
            }
            Vector3.CrossToRef(tvec, edge1, qvec);
            const bw = Vector3.Dot(this.direction, qvec) * invdet;
            if (bw < 0 || bv + bw > 1.0) {
                return null;
            }
            //check if the distance is longer than the predefined length.
            const distance = Vector3.Dot(edge2, qvec) * invdet;
            if (distance > this.length) {
                return null;
            }
            return new IntersectionInfo(1 - bv - bw, bv, distance);
        }
        /**
         * Checks if ray intersects a plane
         * @param plane the plane to check
         * @returns the distance away it was hit
         */
        intersectsPlane(plane) {
            let distance;
            const result1 = Vector3.Dot(plane.normal, this.direction);
            if (Math.abs(result1) < 9.99999997475243e-7) {
                return null;
            }
            else {
                const result2 = Vector3.Dot(plane.normal, this.origin);
                distance = (-plane.d - result2) / result1;
                if (distance < 0.0) {
                    if (distance < -9.99999997475243e-7) {
                        return null;
                    }
                    else {
                        return 0;
                    }
                }
                return distance;
            }
        }
        /**
         * Calculate the intercept of a ray on a given axis
         * @param axis to check 'x' | 'y' | 'z'
         * @param offset from axis interception (i.e. an offset of 1y is intercepted above ground)
         * @returns a vector containing the coordinates where 'axis' is equal to zero (else offset), or null if there is no intercept.
         */
        intersectsAxis(axis, offset = 0) {
            switch (axis) {
                case "y": {
                    const t = (this.origin.y - offset) / this.direction.y;
                    if (t > 0) {
                        return null;
                    }
                    return new Vector3(this.origin.x + this.direction.x * -t, offset, this.origin.z + this.direction.z * -t);
                }
                case "x": {
                    const t = (this.origin.x - offset) / this.direction.x;
                    if (t > 0) {
                        return null;
                    }
                    return new Vector3(offset, this.origin.y + this.direction.y * -t, this.origin.z + this.direction.z * -t);
                }
                case "z": {
                    const t = (this.origin.z - offset) / this.direction.z;
                    if (t > 0) {
                        return null;
                    }
                    return new Vector3(this.origin.x + this.direction.x * -t, this.origin.y + this.direction.y * -t, offset);
                }
                default:
                    return null;
            }
        }
        /**
         * Checks if ray intersects a mesh. The ray is defined in WORLD space. A mesh triangle can be picked both from its front and back sides,
         * irrespective of orientation.
         * @param mesh the mesh to check
         * @param fastCheck defines if the first intersection will be used (and not the closest)
         * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
         * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
         * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
         * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
         * @returns picking info of the intersection
         */
        intersectsMesh(mesh, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
            const tm = TmpVectors.Matrix[0];
            mesh.getWorldMatrix().invertToRef(tm);
            if (this._tmpRay) {
                Ray.TransformToRef(this, tm, this._tmpRay);
            }
            else {
                this._tmpRay = Ray.Transform(this, tm);
            }
            return mesh.intersects(this._tmpRay, fastCheck, trianglePredicate, onlyBoundingInfo, worldToUse, skipBoundingInfo);
        }
        /**
         * Checks if ray intersects a mesh
         * @param meshes the meshes to check
         * @param fastCheck defines if the first intersection will be used (and not the closest)
         * @param results array to store result in
         * @returns Array of picking infos
         */
        intersectsMeshes(meshes, fastCheck, results) {
            if (results) {
                results.length = 0;
            }
            else {
                results = [];
            }
            for (let i = 0; i < meshes.length; i++) {
                const pickInfo = this.intersectsMesh(meshes[i], fastCheck);
                if (pickInfo.hit) {
                    results.push(pickInfo);
                }
            }
            results.sort(this._comparePickingInfo);
            return results;
        }
        _comparePickingInfo(pickingInfoA, pickingInfoB) {
            if (pickingInfoA.distance < pickingInfoB.distance) {
                return -1;
            }
            else if (pickingInfoA.distance > pickingInfoB.distance) {
                return 1;
            }
            else {
                return 0;
            }
        }
        /**
         * Intersection test between the ray and a given segment within a given tolerance (threshold)
         * @param sega the first point of the segment to test the intersection against
         * @param segb the second point of the segment to test the intersection against
         * @param threshold the tolerance margin, if the ray doesn't intersect the segment but is close to the given threshold, the intersection is successful
         * @returns the distance from the ray origin to the intersection point if there's intersection, or -1 if there's no intersection
         */
        intersectionSegment(sega, segb, threshold) {
            const o = this.origin;
            const u = TmpVectors.Vector3[0];
            const rsegb = TmpVectors.Vector3[1];
            const v = TmpVectors.Vector3[2];
            const w = TmpVectors.Vector3[3];
            segb.subtractToRef(sega, u);
            this.direction.scaleToRef(Ray._Rayl, v);
            o.addToRef(v, rsegb);
            sega.subtractToRef(o, w);
            const a = Vector3.Dot(u, u); // always >= 0
            const b = Vector3.Dot(u, v);
            const c = Vector3.Dot(v, v); // always >= 0
            const d = Vector3.Dot(u, w);
            const e = Vector3.Dot(v, w);
            const D = a * c - b * b; // always >= 0
            let sN, sD = D; // sc = sN / sD, default sD = D >= 0
            let tN, tD = D; // tc = tN / tD, default tD = D >= 0
            // compute the line parameters of the two closest points
            if (D < Ray._Smallnum) {
                // the lines are almost parallel
                sN = 0.0; // force using point P0 on segment S1
                sD = 1.0; // to prevent possible division by 0.0 later
                tN = e;
                tD = c;
            }
            else {
                // get the closest points on the infinite lines
                sN = b * e - c * d;
                tN = a * e - b * d;
                if (sN < 0.0) {
                    // sc < 0 => the s=0 edge is visible
                    sN = 0.0;
                    tN = e;
                    tD = c;
                }
                else if (sN > sD) {
                    // sc > 1 => the s=1 edge is visible
                    sN = sD;
                    tN = e + b;
                    tD = c;
                }
            }
            if (tN < 0.0) {
                // tc < 0 => the t=0 edge is visible
                tN = 0.0;
                // recompute sc for this edge
                if (-d < 0.0) {
                    sN = 0.0;
                }
                else if (-d > a) {
                    sN = sD;
                }
                else {
                    sN = -d;
                    sD = a;
                }
            }
            else if (tN > tD) {
                // tc > 1 => the t=1 edge is visible
                tN = tD;
                // recompute sc for this edge
                if (-d + b < 0.0) {
                    sN = 0;
                }
                else if (-d + b > a) {
                    sN = sD;
                }
                else {
                    sN = -d + b;
                    sD = a;
                }
            }
            // finally do the division to get sc and tc
            const sc = Math.abs(sN) < Ray._Smallnum ? 0.0 : sN / sD;
            const tc = Math.abs(tN) < Ray._Smallnum ? 0.0 : tN / tD;
            // get the difference of the two closest points
            const qtc = TmpVectors.Vector3[4];
            v.scaleToRef(tc, qtc);
            const qsc = TmpVectors.Vector3[5];
            u.scaleToRef(sc, qsc);
            qsc.addInPlace(w);
            const dP = TmpVectors.Vector3[6];
            qsc.subtractToRef(qtc, dP); // = S1(sc) - S2(tc)
            const isIntersected = tc > 0 && tc <= this.length && dP.lengthSquared() < threshold * threshold; // return intersection result
            if (isIntersected) {
                return qsc.length();
            }
            return -1;
        }
        /**
         * Update the ray from viewport position
         * @param x position
         * @param y y position
         * @param viewportWidth viewport width
         * @param viewportHeight viewport height
         * @param world world matrix
         * @param view view matrix
         * @param projection projection matrix
         * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
         * @returns this ray updated
         */
        update(x, y, viewportWidth, viewportHeight, world, view, projection, enableDistantPicking = false) {
            if (enableDistantPicking) {
                // With world matrices having great values (like 8000000000 on 1 or more scaling or position axis),
                // multiplying view/projection/world and doing invert will result in loss of float precision in the matrix.
                // One way to fix it is to compute the ray with world at identity then transform the ray in object space.
                // This is slower (2 matrix inverts instead of 1) but precision is preserved.
                // This is hidden behind `EnableDistantPicking` flag (default is false)
                if (!Ray._RayDistant) {
                    Ray._RayDistant = Ray.Zero();
                }
                Ray._RayDistant.unprojectRayToRef(x, y, viewportWidth, viewportHeight, Matrix.IdentityReadOnly, view, projection);
                const tm = TmpVectors.Matrix[0];
                world.invertToRef(tm);
                Ray.TransformToRef(Ray._RayDistant, tm, this);
            }
            else {
                this.unprojectRayToRef(x, y, viewportWidth, viewportHeight, world, view, projection);
            }
            return this;
        }
        // Statics
        /**
         * Creates a ray with origin and direction of 0,0,0
         * @returns the new ray
         */
        static Zero() {
            return new Ray(Vector3.Zero(), Vector3.Zero());
        }
        /**
         * Creates a new ray from screen space and viewport
         * @param x position
         * @param y y position
         * @param viewportWidth viewport width
         * @param viewportHeight viewport height
         * @param world world matrix
         * @param view view matrix
         * @param projection projection matrix
         * @returns new ray
         */
        static CreateNew(x, y, viewportWidth, viewportHeight, world, view, projection) {
            const result = Ray.Zero();
            return result.update(x, y, viewportWidth, viewportHeight, world, view, projection);
        }
        /**
         * Function will create a new transformed ray starting from origin and ending at the end point. Ray's length will be set, and ray will be
         * transformed to the given world matrix.
         * @param origin The origin point
         * @param end The end point
         * @param world a matrix to transform the ray to. Default is the identity matrix.
         * @returns the new ray
         */
        static CreateNewFromTo(origin, end, world = Matrix.IdentityReadOnly) {
            const direction = end.subtract(origin);
            const length = Math.sqrt(direction.x * direction.x + direction.y * direction.y + direction.z * direction.z);
            direction.normalize();
            return Ray.Transform(new Ray(origin, direction, length), world);
        }
        /**
         * Transforms a ray by a matrix
         * @param ray ray to transform
         * @param matrix matrix to apply
         * @returns the resulting new ray
         */
        static Transform(ray, matrix) {
            const result = new Ray(new Vector3(0, 0, 0), new Vector3(0, 0, 0));
            Ray.TransformToRef(ray, matrix, result);
            return result;
        }
        /**
         * Transforms a ray by a matrix
         * @param ray ray to transform
         * @param matrix matrix to apply
         * @param result ray to store result in
         */
        static TransformToRef(ray, matrix, result) {
            Vector3.TransformCoordinatesToRef(ray.origin, matrix, result.origin);
            Vector3.TransformNormalToRef(ray.direction, matrix, result.direction);
            result.length = ray.length;
            const dir = result.direction;
            const len = dir.length();
            if (!(len === 0 || len === 1)) {
                const num = 1.0 / len;
                dir.x *= num;
                dir.y *= num;
                dir.z *= num;
                result.length *= len;
            }
        }
        /**
         * Unproject a ray from screen space to object space
         * @param sourceX defines the screen space x coordinate to use
         * @param sourceY defines the screen space y coordinate to use
         * @param viewportWidth defines the current width of the viewport
         * @param viewportHeight defines the current height of the viewport
         * @param world defines the world matrix to use (can be set to Identity to go to world space)
         * @param view defines the view matrix to use
         * @param projection defines the projection matrix to use
         */
        unprojectRayToRef(sourceX, sourceY, viewportWidth, viewportHeight, world, view, projection) {
            const matrix = TmpVectors.Matrix[0];
            world.multiplyToRef(view, matrix);
            matrix.multiplyToRef(projection, matrix);
            matrix.invert();
            const engine = EngineStore.LastCreatedEngine;
            const nearScreenSource = TmpVectors.Vector3[0];
            nearScreenSource.x = (sourceX / viewportWidth) * 2 - 1;
            nearScreenSource.y = -((sourceY / viewportHeight) * 2 - 1);
            nearScreenSource.z = (engine === null || engine === void 0 ? void 0 : engine.useReverseDepthBuffer) ? 1 : (engine === null || engine === void 0 ? void 0 : engine.isNDCHalfZRange) ? 0 : -1;
            // far Z need to be close but < to 1 or camera projection matrix with maxZ = 0 will NaN
            const farScreenSource = TmpVectors.Vector3[1].copyFromFloats(nearScreenSource.x, nearScreenSource.y, 1.0 - 1e-8);
            const nearVec3 = TmpVectors.Vector3[2];
            const farVec3 = TmpVectors.Vector3[3];
            Vector3._UnprojectFromInvertedMatrixToRef(nearScreenSource, matrix, nearVec3);
            Vector3._UnprojectFromInvertedMatrixToRef(farScreenSource, matrix, farVec3);
            this.origin.copyFrom(nearVec3);
            farVec3.subtractToRef(nearVec3, this.direction);
            this.direction.normalize();
        }
    }
    Ray._TmpVector3 = ArrayTools.BuildArray(6, Vector3.Zero);
    Ray._RayDistant = Ray.Zero();
    Ray._Smallnum = 0.00000001;
    Ray._Rayl = 10e8;
    Scene.prototype.createPickingRay = function (x, y, world, camera, cameraViewSpace = false) {
        const result = Ray.Zero();
        this.createPickingRayToRef(x, y, world, result, camera, cameraViewSpace);
        return result;
    };
    Scene.prototype.createPickingRayToRef = function (x, y, world, result, camera, cameraViewSpace = false, enableDistantPicking = false) {
        const engine = this.getEngine();
        if (!camera) {
            if (!this.activeCamera) {
                return this;
            }
            camera = this.activeCamera;
        }
        const cameraViewport = camera.viewport;
        const viewport = cameraViewport.toGlobal(engine.getRenderWidth(), engine.getRenderHeight());
        // Moving coordinates to local viewport world
        x = x / engine.getHardwareScalingLevel() - viewport.x;
        y = y / engine.getHardwareScalingLevel() - (engine.getRenderHeight() - viewport.y - viewport.height);
        result.update(x, y, viewport.width, viewport.height, world ? world : Matrix.IdentityReadOnly, cameraViewSpace ? Matrix.IdentityReadOnly : camera.getViewMatrix(), camera.getProjectionMatrix(), enableDistantPicking);
        return this;
    };
    Scene.prototype.createPickingRayInCameraSpace = function (x, y, camera) {
        const result = Ray.Zero();
        this.createPickingRayInCameraSpaceToRef(x, y, result, camera);
        return result;
    };
    Scene.prototype.createPickingRayInCameraSpaceToRef = function (x, y, result, camera) {
        if (!PickingInfo) {
            return this;
        }
        const engine = this.getEngine();
        if (!camera) {
            if (!this.activeCamera) {
                throw new Error("Active camera not set");
            }
            camera = this.activeCamera;
        }
        const cameraViewport = camera.viewport;
        const viewport = cameraViewport.toGlobal(engine.getRenderWidth(), engine.getRenderHeight());
        const identity = Matrix.Identity();
        // Moving coordinates to local viewport world
        x = x / engine.getHardwareScalingLevel() - viewport.x;
        y = y / engine.getHardwareScalingLevel() - (engine.getRenderHeight() - viewport.y - viewport.height);
        result.update(x, y, viewport.width, viewport.height, identity, identity, camera.getProjectionMatrix());
        return this;
    };
    Scene.prototype._internalPickForMesh = function (pickingInfo, rayFunction, mesh, world, fastCheck, onlyBoundingInfo, trianglePredicate, skipBoundingInfo) {
        const ray = rayFunction(world, mesh.enableDistantPicking);
        const result = mesh.intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo, world, skipBoundingInfo);
        if (!result || !result.hit) {
            return null;
        }
        if (!fastCheck && pickingInfo != null && result.distance >= pickingInfo.distance) {
            return null;
        }
        return result;
    };
    Scene.prototype._internalPick = function (rayFunction, predicate, fastCheck, onlyBoundingInfo, trianglePredicate) {
        let pickingInfo = null;
        const computeWorldMatrixForCamera = !!(this.activeCameras && this.activeCameras.length > 1 && this.cameraToUseForPointers !== this.activeCamera);
        const currentCamera = this.cameraToUseForPointers || this.activeCamera;
        for (let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++) {
            const mesh = this.meshes[meshIndex];
            if (predicate) {
                if (!predicate(mesh)) {
                    continue;
                }
            }
            else if (!mesh.isEnabled() || !mesh.isVisible || !mesh.isPickable) {
                continue;
            }
            const forceCompute = computeWorldMatrixForCamera && mesh.isWorldMatrixCameraDependent();
            const world = mesh.computeWorldMatrix(forceCompute, currentCamera);
            if (mesh.hasThinInstances && mesh.thinInstanceEnablePicking) {
                // first check if the ray intersects the whole bounding box/sphere of the mesh
                const result = this._internalPickForMesh(pickingInfo, rayFunction, mesh, world, true, true, trianglePredicate);
                if (result) {
                    if (onlyBoundingInfo) {
                        // the user only asked for a bounding info check so we can return
                        return result;
                    }
                    const tmpMatrix = TmpVectors.Matrix[1];
                    const thinMatrices = mesh.thinInstanceGetWorldMatrices();
                    for (let index = 0; index < thinMatrices.length; index++) {
                        const thinMatrix = thinMatrices[index];
                        thinMatrix.multiplyToRef(world, tmpMatrix);
                        const result = this._internalPickForMesh(pickingInfo, rayFunction, mesh, tmpMatrix, fastCheck, onlyBoundingInfo, trianglePredicate, true);
                        if (result) {
                            pickingInfo = result;
                            pickingInfo.thinInstanceIndex = index;
                            if (fastCheck) {
                                return pickingInfo;
                            }
                        }
                    }
                }
            }
            else {
                const result = this._internalPickForMesh(pickingInfo, rayFunction, mesh, world, fastCheck, onlyBoundingInfo, trianglePredicate);
                if (result) {
                    pickingInfo = result;
                    if (fastCheck) {
                        return pickingInfo;
                    }
                }
            }
        }
        return pickingInfo || new PickingInfo();
    };
    Scene.prototype._internalMultiPick = function (rayFunction, predicate, trianglePredicate) {
        if (!PickingInfo) {
            return null;
        }
        const pickingInfos = new Array();
        const computeWorldMatrixForCamera = !!(this.activeCameras && this.activeCameras.length > 1 && this.cameraToUseForPointers !== this.activeCamera);
        const currentCamera = this.cameraToUseForPointers || this.activeCamera;
        for (let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++) {
            const mesh = this.meshes[meshIndex];
            if (predicate) {
                if (!predicate(mesh)) {
                    continue;
                }
            }
            else if (!mesh.isEnabled() || !mesh.isVisible || !mesh.isPickable) {
                continue;
            }
            const forceCompute = computeWorldMatrixForCamera && mesh.isWorldMatrixCameraDependent();
            const world = mesh.computeWorldMatrix(forceCompute, currentCamera);
            if (mesh.hasThinInstances && mesh.thinInstanceEnablePicking) {
                const result = this._internalPickForMesh(null, rayFunction, mesh, world, true, true, trianglePredicate);
                if (result) {
                    const tmpMatrix = TmpVectors.Matrix[1];
                    const thinMatrices = mesh.thinInstanceGetWorldMatrices();
                    for (let index = 0; index < thinMatrices.length; index++) {
                        const thinMatrix = thinMatrices[index];
                        thinMatrix.multiplyToRef(world, tmpMatrix);
                        const result = this._internalPickForMesh(null, rayFunction, mesh, tmpMatrix, false, false, trianglePredicate, true);
                        if (result) {
                            result.thinInstanceIndex = index;
                            pickingInfos.push(result);
                        }
                    }
                }
            }
            else {
                const result = this._internalPickForMesh(null, rayFunction, mesh, world, false, false, trianglePredicate);
                if (result) {
                    pickingInfos.push(result);
                }
            }
        }
        return pickingInfos;
    };
    Scene.prototype.pickWithBoundingInfo = function (x, y, predicate, fastCheck, camera) {
        if (!PickingInfo) {
            return null;
        }
        const result = this._internalPick((world) => {
            if (!this._tempPickingRay) {
                this._tempPickingRay = Ray.Zero();
            }
            this.createPickingRayToRef(x, y, world, this._tempPickingRay, camera || null);
            return this._tempPickingRay;
        }, predicate, fastCheck, true);
        if (result) {
            result.ray = this.createPickingRay(x, y, Matrix.Identity(), camera || null);
        }
        return result;
    };
    Object.defineProperty(Scene.prototype, "_pickingAvailable", {
        get: () => true,
        enumerable: false,
        configurable: false,
    });
    Scene.prototype.pick = function (x, y, predicate, fastCheck, camera, trianglePredicate, _enableDistantPicking = false) {
        const result = this._internalPick((world, enableDistantPicking) => {
            if (!this._tempPickingRay) {
                this._tempPickingRay = Ray.Zero();
            }
            this.createPickingRayToRef(x, y, world, this._tempPickingRay, camera || null, false, enableDistantPicking);
            return this._tempPickingRay;
        }, predicate, fastCheck, false, trianglePredicate);
        if (result) {
            result.ray = this.createPickingRay(x, y, Matrix.Identity(), camera || null);
        }
        return result;
    };
    Scene.prototype.pickWithRay = function (ray, predicate, fastCheck, trianglePredicate) {
        const result = this._internalPick((world) => {
            if (!this._pickWithRayInverseMatrix) {
                this._pickWithRayInverseMatrix = Matrix.Identity();
            }
            world.invertToRef(this._pickWithRayInverseMatrix);
            if (!this._cachedRayForTransform) {
                this._cachedRayForTransform = Ray.Zero();
            }
            Ray.TransformToRef(ray, this._pickWithRayInverseMatrix, this._cachedRayForTransform);
            return this._cachedRayForTransform;
        }, predicate, fastCheck, false, trianglePredicate);
        if (result) {
            result.ray = ray;
        }
        return result;
    };
    Scene.prototype.multiPick = function (x, y, predicate, camera, trianglePredicate) {
        return this._internalMultiPick((world) => this.createPickingRay(x, y, world, camera || null), predicate, trianglePredicate);
    };
    Scene.prototype.multiPickWithRay = function (ray, predicate, trianglePredicate) {
        return this._internalMultiPick((world) => {
            if (!this._pickWithRayInverseMatrix) {
                this._pickWithRayInverseMatrix = Matrix.Identity();
            }
            world.invertToRef(this._pickWithRayInverseMatrix);
            if (!this._cachedRayForTransform) {
                this._cachedRayForTransform = Ray.Zero();
            }
            Ray.TransformToRef(ray, this._pickWithRayInverseMatrix, this._cachedRayForTransform);
            return this._cachedRayForTransform;
        }, predicate, trianglePredicate);
    };
    Camera.prototype.getForwardRay = function (length = 100, transform, origin) {
        return this.getForwardRayToRef(new Ray(Vector3.Zero(), Vector3.Zero(), length), length, transform, origin);
    };
    Camera.prototype.getForwardRayToRef = function (refRay, length = 100, transform, origin) {
        if (!transform) {
            transform = this.getWorldMatrix();
        }
        refRay.length = length;
        if (!origin) {
            refRay.origin.copyFrom(this.position);
        }
        else {
            refRay.origin.copyFrom(origin);
        }
        TmpVectors.Vector3[2].set(0, 0, this._scene.useRightHandedSystem ? -1 : 1);
        Vector3.TransformNormalToRef(TmpVectors.Vector3[2], transform, TmpVectors.Vector3[3]);
        Vector3.NormalizeToRef(TmpVectors.Vector3[3], refRay.direction);
        return refRay;
    };

    /* eslint-disable @typescript-eslint/naming-convention */
    // https://dickyjim.wordpress.com/2013/09/04/spherical-harmonics-for-beginners/
    // http://silviojemma.com/public/papers/lighting/spherical-harmonic-lighting.pdf
    // https://www.ppsloan.org/publications/StupidSH36.pdf
    // http://cseweb.ucsd.edu/~ravir/papers/envmap/envmap.pdf
    // https://www.ppsloan.org/publications/SHJCGT.pdf
    // https://www.ppsloan.org/publications/shdering.pdf
    // https://google.github.io/filament/Filament.md.html#annex/sphericalharmonics
    // https://patapom.com/blog/SHPortal/
    // https://imdoingitwrong.wordpress.com/2011/04/14/spherical-harmonics-wtf/
    // Using real SH basis:
    //  m>0             m   m
    // y   = sqrt(2) * K * P * cos(m*phi) * cos(theta)
    //  l               l   l
    //
    //  m<0             m   |m|
    // y   = sqrt(2) * K * P * sin(m*phi) * cos(theta)
    //  l               l   l
    //
    //  m=0   0   0
    // y   = K * P * trigono terms
    //  l     l   l
    //
    //  m       (2l + 1)(l - |m|)!
    // K = sqrt(------------------)
    //  l           4pi(l + |m|)!
    //
    // and P by recursion:
    //
    // P00(x) = 1
    // P01(x) = x
    // Pll(x) = (-1^l)(2l - 1)!!(1-x*x)^(1/2)
    //          ((2l - 1)x[Pl-1/m]-(l + m - 1)[Pl-2/m])
    // Plm(x) = ---------------------------------------
    //                         l - m
    // Leaving the trigonometric terms aside we can precompute the constants to :
    const SH3ylmBasisConstants = [
        Math.sqrt(1 / (4 * Math.PI)),
        -Math.sqrt(3 / (4 * Math.PI)),
        Math.sqrt(3 / (4 * Math.PI)),
        -Math.sqrt(3 / (4 * Math.PI)),
        Math.sqrt(15 / (4 * Math.PI)),
        -Math.sqrt(15 / (4 * Math.PI)),
        Math.sqrt(5 / (16 * Math.PI)),
        -Math.sqrt(15 / (4 * Math.PI)),
        Math.sqrt(15 / (16 * Math.PI)), // l22
    ];
    // cm = cos(m * phi)
    // sm = sin(m * phi)
    // {x,y,z} = {cos(phi)sin(theta), sin(phi)sin(theta), cos(theta)}
    // By recursion on using trigo identities:
    const SH3ylmBasisTrigonometricTerms = [
        () => 1,
        (direction) => direction.y,
        (direction) => direction.z,
        (direction) => direction.x,
        (direction) => direction.x * direction.y,
        (direction) => direction.y * direction.z,
        (direction) => 3 * direction.z * direction.z - 1,
        (direction) => direction.x * direction.z,
        (direction) => direction.x * direction.x - direction.y * direction.y, // l22
    ];
    // Wrap the full compute
    const applySH3 = (lm, direction) => {
        return SH3ylmBasisConstants[lm] * SH3ylmBasisTrigonometricTerms[lm](direction);
    };
    // Derived from the integration of the a kernel convolution to SH.
    // Great explanation here: https://patapom.com/blog/SHPortal/#about-distant-radiance-and-irradiance-environments
    const SHCosKernelConvolution = [Math.PI, (2 * Math.PI) / 3, (2 * Math.PI) / 3, (2 * Math.PI) / 3, Math.PI / 4, Math.PI / 4, Math.PI / 4, Math.PI / 4, Math.PI / 4];
    /**
     * Class representing spherical harmonics coefficients to the 3rd degree
     */
    class SphericalHarmonics {
        constructor() {
            /**
             * Defines whether or not the harmonics have been prescaled for rendering.
             */
            this.preScaled = false;
            /**
             * The l0,0 coefficients of the spherical harmonics
             */
            this.l00 = Vector3.Zero();
            /**
             * The l1,-1 coefficients of the spherical harmonics
             */
            this.l1_1 = Vector3.Zero();
            /**
             * The l1,0 coefficients of the spherical harmonics
             */
            this.l10 = Vector3.Zero();
            /**
             * The l1,1 coefficients of the spherical harmonics
             */
            this.l11 = Vector3.Zero();
            /**
             * The l2,-2 coefficients of the spherical harmonics
             */
            this.l2_2 = Vector3.Zero();
            /**
             * The l2,-1 coefficients of the spherical harmonics
             */
            this.l2_1 = Vector3.Zero();
            /**
             * The l2,0 coefficients of the spherical harmonics
             */
            this.l20 = Vector3.Zero();
            /**
             * The l2,1 coefficients of the spherical harmonics
             */
            this.l21 = Vector3.Zero();
            /**
             * The l2,2 coefficients of the spherical harmonics
             */
            this.l22 = Vector3.Zero();
        }
        /**
         * Adds a light to the spherical harmonics
         * @param direction the direction of the light
         * @param color the color of the light
         * @param deltaSolidAngle the delta solid angle of the light
         */
        addLight(direction, color, deltaSolidAngle) {
            TmpVectors.Vector3[0].set(color.r, color.g, color.b);
            const colorVector = TmpVectors.Vector3[0];
            const c = TmpVectors.Vector3[1];
            colorVector.scaleToRef(deltaSolidAngle, c);
            c.scaleToRef(applySH3(0, direction), TmpVectors.Vector3[2]);
            this.l00.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(1, direction), TmpVectors.Vector3[2]);
            this.l1_1.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(2, direction), TmpVectors.Vector3[2]);
            this.l10.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(3, direction), TmpVectors.Vector3[2]);
            this.l11.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(4, direction), TmpVectors.Vector3[2]);
            this.l2_2.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(5, direction), TmpVectors.Vector3[2]);
            this.l2_1.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(6, direction), TmpVectors.Vector3[2]);
            this.l20.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(7, direction), TmpVectors.Vector3[2]);
            this.l21.addInPlace(TmpVectors.Vector3[2]);
            c.scaleToRef(applySH3(8, direction), TmpVectors.Vector3[2]);
            this.l22.addInPlace(TmpVectors.Vector3[2]);
        }
        /**
         * Scales the spherical harmonics by the given amount
         * @param scale the amount to scale
         */
        scaleInPlace(scale) {
            this.l00.scaleInPlace(scale);
            this.l1_1.scaleInPlace(scale);
            this.l10.scaleInPlace(scale);
            this.l11.scaleInPlace(scale);
            this.l2_2.scaleInPlace(scale);
            this.l2_1.scaleInPlace(scale);
            this.l20.scaleInPlace(scale);
            this.l21.scaleInPlace(scale);
            this.l22.scaleInPlace(scale);
        }
        /**
         * Convert from incident radiance (Li) to irradiance (E) by applying convolution with the cosine-weighted hemisphere.
         *
         * ```
         * E_lm = A_l * L_lm
         * ```
         *
         * In spherical harmonics this convolution amounts to scaling factors for each frequency band.
         * This corresponds to equation 5 in "An Efficient Representation for Irradiance Environment Maps", where
         * the scaling factors are given in equation 9.
         */
        convertIncidentRadianceToIrradiance() {
            // Constant (Band 0)
            this.l00.scaleInPlace(SHCosKernelConvolution[0]);
            // Linear (Band 1)
            this.l1_1.scaleInPlace(SHCosKernelConvolution[1]);
            this.l10.scaleInPlace(SHCosKernelConvolution[2]);
            this.l11.scaleInPlace(SHCosKernelConvolution[3]);
            // Quadratic (Band 2)
            this.l2_2.scaleInPlace(SHCosKernelConvolution[4]);
            this.l2_1.scaleInPlace(SHCosKernelConvolution[5]);
            this.l20.scaleInPlace(SHCosKernelConvolution[6]);
            this.l21.scaleInPlace(SHCosKernelConvolution[7]);
            this.l22.scaleInPlace(SHCosKernelConvolution[8]);
        }
        /**
         * Convert from irradiance to outgoing radiance for Lambertian BDRF, suitable for efficient shader evaluation.
         *
         * ```
         * L = (1/pi) * E * rho
         * ```
         *
         * This is done by an additional scale by 1/pi, so is a fairly trivial operation but important conceptually.
         */
        convertIrradianceToLambertianRadiance() {
            this.scaleInPlace(1.0 / Math.PI);
            // The resultant SH now represents outgoing radiance, so includes the Lambert 1/pi normalisation factor but without albedo (rho) applied
            // (The pixel shader must apply albedo after texture fetches, etc).
        }
        /**
         * Integrates the reconstruction coefficients directly in to the SH preventing further
         * required operations at run time.
         *
         * This is simply done by scaling back the SH with Ylm constants parameter.
         * The trigonometric part being applied by the shader at run time.
         */
        preScaleForRendering() {
            this.preScaled = true;
            this.l00.scaleInPlace(SH3ylmBasisConstants[0]);
            this.l1_1.scaleInPlace(SH3ylmBasisConstants[1]);
            this.l10.scaleInPlace(SH3ylmBasisConstants[2]);
            this.l11.scaleInPlace(SH3ylmBasisConstants[3]);
            this.l2_2.scaleInPlace(SH3ylmBasisConstants[4]);
            this.l2_1.scaleInPlace(SH3ylmBasisConstants[5]);
            this.l20.scaleInPlace(SH3ylmBasisConstants[6]);
            this.l21.scaleInPlace(SH3ylmBasisConstants[7]);
            this.l22.scaleInPlace(SH3ylmBasisConstants[8]);
        }
        /**
         * update the spherical harmonics coefficients from the given array
         * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
         * @returns the spherical harmonics (this)
         */
        updateFromArray(data) {
            Vector3.FromArrayToRef(data[0], 0, this.l00);
            Vector3.FromArrayToRef(data[1], 0, this.l1_1);
            Vector3.FromArrayToRef(data[2], 0, this.l10);
            Vector3.FromArrayToRef(data[3], 0, this.l11);
            Vector3.FromArrayToRef(data[4], 0, this.l2_2);
            Vector3.FromArrayToRef(data[5], 0, this.l2_1);
            Vector3.FromArrayToRef(data[6], 0, this.l20);
            Vector3.FromArrayToRef(data[7], 0, this.l21);
            Vector3.FromArrayToRef(data[8], 0, this.l22);
            return this;
        }
        /**
         * update the spherical harmonics coefficients from the given floats array
         * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
         * @returns the spherical harmonics (this)
         */
        updateFromFloatsArray(data) {
            Vector3.FromFloatsToRef(data[0], data[1], data[2], this.l00);
            Vector3.FromFloatsToRef(data[3], data[4], data[5], this.l1_1);
            Vector3.FromFloatsToRef(data[6], data[7], data[8], this.l10);
            Vector3.FromFloatsToRef(data[9], data[10], data[11], this.l11);
            Vector3.FromFloatsToRef(data[12], data[13], data[14], this.l2_2);
            Vector3.FromFloatsToRef(data[15], data[16], data[17], this.l2_1);
            Vector3.FromFloatsToRef(data[18], data[19], data[20], this.l20);
            Vector3.FromFloatsToRef(data[21], data[22], data[23], this.l21);
            Vector3.FromFloatsToRef(data[24], data[25], data[26], this.l22);
            return this;
        }
        /**
         * Constructs a spherical harmonics from an array.
         * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
         * @returns the spherical harmonics
         */
        static FromArray(data) {
            const sh = new SphericalHarmonics();
            return sh.updateFromArray(data);
        }
        // Keep for references.
        /**
         * Gets the spherical harmonics from polynomial
         * @param polynomial the spherical polynomial
         * @returns the spherical harmonics
         */
        static FromPolynomial(polynomial) {
            const result = new SphericalHarmonics();
            result.l00 = polynomial.xx.scale(0.376127).add(polynomial.yy.scale(0.376127)).add(polynomial.zz.scale(0.376126));
            result.l1_1 = polynomial.y.scale(0.977204);
            result.l10 = polynomial.z.scale(0.977204);
            result.l11 = polynomial.x.scale(0.977204);
            result.l2_2 = polynomial.xy.scale(1.16538);
            result.l2_1 = polynomial.yz.scale(1.16538);
            result.l20 = polynomial.zz.scale(1.34567).subtract(polynomial.xx.scale(0.672834)).subtract(polynomial.yy.scale(0.672834));
            result.l21 = polynomial.zx.scale(1.16538);
            result.l22 = polynomial.xx.scale(1.16538).subtract(polynomial.yy.scale(1.16538));
            result.l1_1.scaleInPlace(-1);
            result.l11.scaleInPlace(-1);
            result.l2_1.scaleInPlace(-1);
            result.l21.scaleInPlace(-1);
            result.scaleInPlace(Math.PI);
            return result;
        }
    }
    /**
     * Class representing spherical polynomial coefficients to the 3rd degree
     */
    class SphericalPolynomial {
        constructor() {
            /**
             * The x coefficients of the spherical polynomial
             */
            this.x = Vector3.Zero();
            /**
             * The y coefficients of the spherical polynomial
             */
            this.y = Vector3.Zero();
            /**
             * The z coefficients of the spherical polynomial
             */
            this.z = Vector3.Zero();
            /**
             * The xx coefficients of the spherical polynomial
             */
            this.xx = Vector3.Zero();
            /**
             * The yy coefficients of the spherical polynomial
             */
            this.yy = Vector3.Zero();
            /**
             * The zz coefficients of the spherical polynomial
             */
            this.zz = Vector3.Zero();
            /**
             * The xy coefficients of the spherical polynomial
             */
            this.xy = Vector3.Zero();
            /**
             * The yz coefficients of the spherical polynomial
             */
            this.yz = Vector3.Zero();
            /**
             * The zx coefficients of the spherical polynomial
             */
            this.zx = Vector3.Zero();
        }
        /**
         * The spherical harmonics used to create the polynomials.
         */
        get preScaledHarmonics() {
            if (!this._harmonics) {
                this._harmonics = SphericalHarmonics.FromPolynomial(this);
            }
            if (!this._harmonics.preScaled) {
                this._harmonics.preScaleForRendering();
            }
            return this._harmonics;
        }
        /**
         * Adds an ambient color to the spherical polynomial
         * @param color the color to add
         */
        addAmbient(color) {
            TmpVectors.Vector3[0].copyFromFloats(color.r, color.g, color.b);
            const colorVector = TmpVectors.Vector3[0];
            this.xx.addInPlace(colorVector);
            this.yy.addInPlace(colorVector);
            this.zz.addInPlace(colorVector);
        }
        /**
         * Scales the spherical polynomial by the given amount
         * @param scale the amount to scale
         */
        scaleInPlace(scale) {
            this.x.scaleInPlace(scale);
            this.y.scaleInPlace(scale);
            this.z.scaleInPlace(scale);
            this.xx.scaleInPlace(scale);
            this.yy.scaleInPlace(scale);
            this.zz.scaleInPlace(scale);
            this.yz.scaleInPlace(scale);
            this.zx.scaleInPlace(scale);
            this.xy.scaleInPlace(scale);
        }
        /**
         * Updates the spherical polynomial from harmonics
         * @param harmonics the spherical harmonics
         * @returns the spherical polynomial
         */
        updateFromHarmonics(harmonics) {
            this._harmonics = harmonics;
            this.x.copyFrom(harmonics.l11);
            this.x.scaleInPlace(1.02333).scaleInPlace(-1);
            this.y.copyFrom(harmonics.l1_1);
            this.y.scaleInPlace(1.02333).scaleInPlace(-1);
            this.z.copyFrom(harmonics.l10);
            this.z.scaleInPlace(1.02333);
            this.xx.copyFrom(harmonics.l00);
            TmpVectors.Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.247708);
            TmpVectors.Vector3[1].copyFrom(harmonics.l22).scaleInPlace(0.429043);
            this.xx.scaleInPlace(0.886277).subtractInPlace(TmpVectors.Vector3[0]).addInPlace(TmpVectors.Vector3[1]);
            this.yy.copyFrom(harmonics.l00);
            this.yy.scaleInPlace(0.886277).subtractInPlace(TmpVectors.Vector3[0]).subtractInPlace(TmpVectors.Vector3[1]);
            this.zz.copyFrom(harmonics.l00);
            TmpVectors.Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.495417);
            this.zz.scaleInPlace(0.886277).addInPlace(TmpVectors.Vector3[0]);
            this.yz.copyFrom(harmonics.l2_1);
            this.yz.scaleInPlace(0.858086).scaleInPlace(-1);
            this.zx.copyFrom(harmonics.l21);
            this.zx.scaleInPlace(0.858086).scaleInPlace(-1);
            this.xy.copyFrom(harmonics.l2_2);
            this.xy.scaleInPlace(0.858086);
            this.scaleInPlace(1.0 / Math.PI);
            return this;
        }
        /**
         * Gets the spherical polynomial from harmonics
         * @param harmonics the spherical harmonics
         * @returns the spherical polynomial
         */
        static FromHarmonics(harmonics) {
            const result = new SphericalPolynomial();
            return result.updateFromHarmonics(harmonics);
        }
        /**
         * Constructs a spherical polynomial from an array.
         * @param data defines the 9x3 coefficients (x, y, z, xx, yy, zz, yz, zx, xy)
         * @returns the spherical polynomial
         */
        static FromArray(data) {
            const sp = new SphericalPolynomial();
            Vector3.FromArrayToRef(data[0], 0, sp.x);
            Vector3.FromArrayToRef(data[1], 0, sp.y);
            Vector3.FromArrayToRef(data[2], 0, sp.z);
            Vector3.FromArrayToRef(data[3], 0, sp.xx);
            Vector3.FromArrayToRef(data[4], 0, sp.yy);
            Vector3.FromArrayToRef(data[5], 0, sp.zz);
            Vector3.FromArrayToRef(data[6], 0, sp.yz);
            Vector3.FromArrayToRef(data[7], 0, sp.zx);
            Vector3.FromArrayToRef(data[8], 0, sp.xy);
            return sp;
        }
    }

    const ray1 = Ray.Zero();
    const vector1 = Vector3.Zero();
    const vector2 = Vector3.Zero();
    const vector3 = Vector3.Zero();
    function getCameraPositionWithOffset(camera) {
        if (camera instanceof ArcRotateCamera) {
            camera.getForwardRayToRef(ray1);
            Vector3.CrossToRef(ray1.direction, Vector3.Up(), vector1);
            Vector3.CrossToRef(ray1.direction, vector1, vector2);
            vector1.normalize().scaleInPlace(-camera.targetScreenOffset.x);
            vector2.normalize().scaleInPlace(camera.targetScreenOffset.y);
            vector3.copyFrom(camera.globalPosition);
            vector3.addInPlace(vector1).addInPlace(vector2);
            return vector3;
        }
        else {
            return camera.globalPosition;
        }
    }
    function toRadians(degrees) {
        const scalar = Math.PI / 180;
        return degrees * scalar;
    }
    function roundVectorToPlaces(vector, significance = 1, direction) {
        vector.x = roundToPlaces(vector.x, significance, direction);
        vector.y = roundToPlaces(vector.y, significance, direction);
        vector.z = roundToPlaces(vector.z, significance, direction);
    }
    function roundToPlaces(value, significance = 1, direction = 'round') {
        const isRound = Math.round(value / significance) * significance === value;
        if (isRound) {
            return value;
        }
        const n = (value / significance) * (1 + Number.EPSILON);
        let tmp;
        if (direction === 'ceil') {
            tmp = Math.ceil(n);
        }
        else if (direction === 'floor') {
            tmp = Math.floor(n);
        }
        else {
            tmp = Math.round(n);
        }
        return tmp * significance;
    }
    function rotationToVector(toVector, fromVector) {
        const result = new Quaternion();
        if (!fromVector) {
            fromVector = new Vector3(0, 1, 0);
        }
        rotationToVectorToRef(toVector, fromVector, result);
        return result;
    }
    function transformVectorWithQuat(vector, quat) {
        const transform = new Matrix();
        quat.toRotationMatrix(transform);
        const transformVector = Vector3.TransformCoordinates(vector, transform);
        return transformVector;
    }
    function applyTransformToVector(vector, transform) {
        const v = new Vector3(vector.x, vector.y, vector.z);
        const matrix = Matrix.Compose(new Vector3(1, 1, 1), Quaternion.Identity(), v);
        return applyTransformToSpace(matrix, transform);
    }
    function applyTransformToSpace(worldTransform, inSpace) {
        if (!inSpace) {
            inSpace = Matrix.Identity();
        }
        const inSpaceInv = inSpace.clone().invert();
        if (Array.isArray(worldTransform)) {
            worldTransform = Matrix.FromArray(worldTransform);
        }
        const spaceTransform = inSpace.multiply(worldTransform);
        spaceTransform.multiplyToRef(inSpaceInv, spaceTransform);
        const t = new Vector3();
        const q = new Quaternion();
        const s = new Vector3();
        spaceTransform.decompose(s, q, t);
        return {
            position: { x: t.x, y: t.y, z: t.z },
            rotation: exports.KbQuaternion.FromQuat(q),
            scaling: { x: s.x, y: s.y, z: s.z },
        };
        // const fromSpaceRotation = fromSpace.rotationQuaternion ? fromSpace.rotationQuaternion : Quaternion.Identity();
        // const toSpaceRotation = toSpace.rotationQuaternion ? toSpace.rotationQuaternion : Quaternion.Identity();
        // const fromSpaceRotationInverse = fromSpaceRotation.clone().invert();
        // const toSpaceRotationInverse = toSpaceRotation.clone().invert();
        // const q1 = q.clone().multiply(fromSpaceRotationInverse);
        // const q2 = toSpaceRotationInverse.multiply(q1);
        // const q3 = q2.multiply(toSpaceRotation);
        // return q3;
    }
    function computeLocalTransform(node) {
        let rotation;
        if (node.useEuler) {
            rotation = Quaternion.FromEulerAngles(toRadians(node.eulerRotation.x), toRadians(node.eulerRotation.y), toRadians(node.eulerRotation.z));
        }
        else {
            rotation = Quaternion.RotationAxis(node.rotationAxis.toVec3(), node.rotationAngle * (Math.PI / 180));
        }
        const pivotTransform = node.pivot ? Matrix.Translation(-node.pivot.x, -node.pivot.y, -node.pivot.z) : undefined;
        const scalingTransform = Matrix.Scaling(node.scaling, node.scaling, node.scaling);
        const rotationTransform = new Matrix();
        Matrix.FromQuaternionToRef(rotation, rotationTransform);
        const translationTransform = Matrix.Translation(node.position.x, node.position.y, node.position.z);
        const transform = Matrix.Identity();
        if (pivotTransform) {
            transform.multiplyToRef(pivotTransform, transform);
        }
        transform.multiplyToRef(scalingTransform, transform);
        transform.multiplyToRef(rotationTransform, transform);
        transform.multiplyToRef(translationTransform, transform);
        if (pivotTransform) {
            transform.multiplyToRef(pivotTransform.invert(), transform);
        }
        return transform;
    }
    function rotationToVectorToRef(_toVector, _fromVector, result) {
        const toVector = _toVector.clone().normalize();
        const fromVector = _fromVector.clone().normalize();
        if (Vector3.Dot(fromVector, toVector) > 0.9999999) {
            result.set(0, 0, 0, 1); // Identity Quaternion
        }
        if (Vector3.Dot(fromVector, toVector) < -0.9999999) {
            // Rotate 180 degrees about arbitrary axis
            return Quaternion.RotationAxisToRef(Vector3.Right().equals(toVector) ? Vector3.Up().cross(toVector) : Vector3.Right().cross(toVector), Math.PI, result);
        }
        const rotAxis = toVector.cross(fromVector);
        const w = -Math.acos(Vector3.Dot(fromVector, toVector));
        return Quaternion.RotationAxisToRef(rotAxis, w, result);
    }
    function degreeToRadian(vectorDegree, optionalResult) {
        optionalResult = optionalResult || new Vector3();
        if (vectorDegree !== optionalResult) {
            optionalResult.copyFrom(vectorDegree);
        }
        return multiplyScalar(optionalResult, Math.PI / 180);
    }
    function multiplyScalar(vec, scalar) {
        vec.x *= scalar;
        vec.y *= scalar;
        vec.z *= scalar;
        return vec;
    }
    function computeNormal(normals) {
        const vertex1 = normals[0];
        const vertex2 = normals[1];
        const vertex3 = normals[2];
        const p1p2 = vertex1.subtract(vertex2);
        const p3p2 = vertex3.subtract(vertex2);
        const normal = Vector3.Normalize(Vector3.Cross(p1p2, p3p2));
        return normal;
    }
    function applyMatrix4(thisVect, m) {
        const x = thisVect.x, y = thisVect.y, z = thisVect.z;
        const e = m.asArray();
        thisVect.x = e[0] * x + e[4] * y + e[8] * z + e[12];
        thisVect.y = e[1] * x + e[5] * y + e[9] * z + e[13];
        thisVect.z = e[2] * x + e[6] * y + e[10] * z + e[14];
        return thisVect;
    }
    function mathClamp(x, a, b) {
        return x < a ? a : x > b ? b : x;
    }
    function makeRotationAxis(axis, angle) {
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        const matrix = Matrix.FromValues(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return matrix;
    }
    function getRotationBtwVectors(u, v) {
        //http://lolengine.net/blog/2014/02/24/quaternion-from-two-vectors-final
        v.clone().normalize();
        u.clone().normalize();
        const dot = Vector3.Dot(u, v);
        const k = 1; //we are using unit vectors, so just use "1" instead of:  Math.sqrt(u.length()^2 * v.length()^2);
        let w = k + dot;
        let r;
        if (w < 0.0000001) {
            /* If u and v are exactly opposite, rotate 180 degrees
             * around an arbitrary orthogonal axis. Axis normalisation
             * can happen later, when we normalise the quaternion. */
            w = 0;
            r = Math.abs(u.x) > Math.abs(u.z) ? new Vector3(-u.y, u.x, 0) : new Vector3(0, -u.z, u.y);
        }
        else {
            r = Vector3.Cross(u, v);
        }
        return new Quaternion(r.x, r.y, r.z, w).normalize();
    }
    function addArrays(arrayA, arrayB) {
        if (arrayA.length == 0) {
            return arrayB;
        }
        if (arrayB.length == 0) {
            return arrayA;
        }
        const result = [];
        const n = Math.min(arrayA.length, arrayB.length);
        for (let i = 0; i < n; i++) {
            result[i] = arrayA[i] + arrayB[i];
        }
        return result;
    }
    (function (AxisType) {
        AxisType[AxisType["X"] = 1] = "X";
        AxisType[AxisType["Y"] = 2] = "Y";
        AxisType[AxisType["Z"] = 3] = "Z";
        AxisType[AxisType["Custom"] = 4] = "Custom";
    })(exports.AxisType || (exports.AxisType = {}));

    var KbVector_1;
    exports.KbVector = KbVector_1 = class KbVector {
        constructor(x, y, z) {
            this.x = x;
            this.y = y;
            this.z = z;
            if (!isFinite(x) || isNaN(x)) {
                this.x = 0;
                console.error('Error: Non numeric or infinite value detected in x-value of a vector, please check snapcode for mistakes.');
            }
            if (!isFinite(y) || isNaN(y)) {
                this.y = 0;
                console.error('Error: Non numeric or infinite value detected in y-value of a vector, please check snapcode for mistakes.');
            }
            if (!isFinite(z) || isNaN(z)) {
                this.z = 0;
                console.error('Error: Non numeric or infinite value detected in z-value of a vector, please check snapcode for mistakes.');
            }
        }
        add(v) {
            return new KbVector_1(this.x + v.x, this.y + v.y, this.z + v.z);
        }
        subtract(v) {
            return new KbVector_1(this.x - v.x, this.y - v.y, this.z - v.z);
        }
        multiply(v) {
            return new KbVector_1(this.x * v.x, this.y * v.y, this.z * v.z);
        }
        divide(v) {
            const newX = v.x !== 0 ? this.x / v.x : 0;
            const newY = v.y !== 0 ? this.y / v.y : 0;
            const newZ = v.z !== 0 ? this.z / v.z : 0;
            return new KbVector_1(newX, newY, newZ);
        }
        crossProduct(v) {
            const x = this.y * v.z - this.z * v.y;
            const y = this.z * v.x - this.x * v.z;
            const z = this.x * v.y - this.y * v.x;
            return new KbVector_1(x, y, z);
        }
        dotProduct(v) {
            return this.x * v.x + this.y * v.y + this.z * v.z;
        }
        length() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        }
        normalize() {
            const l = this.length();
            if (l === 0 || l === 1.0) {
                return this.clone();
            }
            return this.scale(1.0 / l);
        }
        scale(s) {
            return new KbVector_1(this.x * s, this.y * s, this.z * s);
        }
        equal(v) {
            return v.x == this.x && v.y == this.y && v.z == this.z;
        }
        clone() {
            return new KbVector_1(this.x, this.y, this.z);
        }
        assign(v) {
            return new KbVector_1(typeof v.x === 'number' ? v.x : this.x, typeof v.y === 'number' ? v.y : this.y, typeof v.z === 'number' ? v.z : this.z);
        }
        shiftClone(component, amount) {
            if (component === 'x') {
                return new KbVector_1(amount, this.y, this.z);
            }
            else if (component === 'y') {
                return new KbVector_1(this.x, amount, this.z);
            }
            else {
                return new KbVector_1(this.x, this.y, amount);
            }
        }
        toString() {
            return `{ x: ${this.x}, y: ${this.y}, z: ${this.z} }`;
        }
        toObject() {
            return { x: this.x, y: this.y, z: this.z };
        }
        round(significance = 1, direction) {
            return new KbVector_1(roundToPlaces(this.x, significance, direction), roundToPlaces(this.y, significance, direction), roundToPlaces(this.z, significance, direction));
        }
        static Zero() {
            return new KbVector_1(0, 0, 0);
        }
        static Identity() {
            return new KbVector_1(1, 1, 1);
        }
        static From(v) {
            return new KbVector_1(v.x, v.y, v.z);
        }
    };
    exports.KbVector = KbVector_1 = __decorate([
        Kb3dModel({
            token: Token.KbVector,
            trackChanges: false,
            create: args => new KbVector_1(args.x || 0, args.y || 0, args.z || 0),
        }),
        __param(0, Ignore()),
        __param(1, Ignore()),
        __param(2, Ignore())
    ], exports.KbVector);

    var KbQuaternion_1;
    exports.KbQuaternion = KbQuaternion_1 = class KbQuaternion {
        constructor(x, y, z, w) {
            this.x = x;
            this.y = y;
            this.z = z;
            this.w = w;
            if (this.w > 1) {
                this.w = 1;
            }
            if (this.w < -1) {
                this.w = -1;
            }
        }
        clone() {
            return new KbQuaternion_1(this.x, this.y, this.z, this.w);
        }
        assign(v) {
            return new KbQuaternion_1(typeof v.x === 'number' ? v.x : this.x, typeof v.y === 'number' ? v.y : this.y, typeof v.z === 'number' ? v.z : this.z, typeof v.w === 'number' ? v.w : this.w);
        }
        toEuler() {
            let x, y, z;
            const qz = this.z;
            const qx = this.x;
            const qy = this.y;
            const qw = this.w;
            const sqw = qw * qw;
            const sqz = qz * qz;
            const sqx = qx * qx;
            const sqy = qy * qy;
            const zAxisY = qy * qz - qx * qw;
            const limit = 0.4999999;
            if (zAxisY < -limit) {
                y = 2 * Math.atan2(qy, qw);
                x = Math.PI / 2;
                z = 0;
            }
            else if (zAxisY > limit) {
                y = 2 * Math.atan2(qy, qw);
                x = -Math.PI / 2;
                z = 0;
            }
            else {
                z = Math.atan2(2.0 * (qx * qy + qz * qw), -sqz - sqx + sqy + sqw);
                x = Math.asin(-2.0 * (qz * qy - qx * qw));
                y = Math.atan2(2.0 * (qz * qx + qy * qw), sqz - sqx - sqy + sqw);
            }
            const scalar = 180 / Math.PI;
            return new exports.KbVector(x * scalar, y * scalar, z * scalar);
        }
        multiply(q) {
            const x = this.x * q.w + this.y * q.z - this.z * q.y + this.w * q.x;
            const y = -this.x * q.z + this.y * q.w + this.z * q.x + this.w * q.y;
            const z = this.x * q.y - this.y * q.x + this.z * q.w + this.w * q.z;
            const w = -this.x * q.x - this.y * q.y - this.z * q.z + this.w * q.w;
            return new KbQuaternion_1(x, y, z, w);
        }
        equal(q) {
            return (!!q &&
                basicallyEqual(q.x, this.x) &&
                basicallyEqual(q.y, this.y) &&
                basicallyEqual(q.z, this.z) &&
                basicallyEqual(q.w, this.w));
        }
        toObject() {
            return { x: this.x, y: this.y, z: this.z, w: this.w };
        }
        getAngle() {
            return this._getRadAngle() * (180 / Math.PI);
        }
        _getRadAngle() {
            return Math.acos(this.w) * 2;
        }
        getAxis() {
            const angle = this._getRadAngle();
            const sin = Math.sin(angle / 2);
            if (sin === 0) {
                return exports.KbVector.Zero();
            }
            else {
                return new exports.KbVector(this.x / sin, this.y / sin, this.z / sin).normalize();
            }
        }
        static FromRotationAxis(axis, angle) {
            // var sin = Math.sin(angle / 2);
            // axis.normalize();
            // result.w = Math.cos(angle / 2);
            // result.x = axis._x * sin;
            // result.y = axis._y * sin;
            // result.z = axis._z * sin;
            const rad = (angle * Math.PI) / 180;
            const sin = Math.sin(rad / 2);
            const nAxis = axis.normalize();
            const result = new KbQuaternion_1(nAxis.x * sin, nAxis.y * sin, nAxis.z * sin, Math.cos(rad / 2));
            return result;
        }
        static FromYawPitchRoll(dV) {
            const v = dV.scale(Math.PI / 180);
            const halfRoll = v.z * 0.5;
            const halfPitch = v.x * 0.5;
            const halfYaw = v.y * 0.5;
            const sinRoll = Math.sin(halfRoll);
            const cosRoll = Math.cos(halfRoll);
            const sinPitch = Math.sin(halfPitch);
            const cosPitch = Math.cos(halfPitch);
            const sinYaw = Math.sin(halfYaw);
            const cosYaw = Math.cos(halfYaw);
            const result = new KbQuaternion_1(cosYaw * sinPitch * cosRoll + sinYaw * cosPitch * sinRoll, sinYaw * cosPitch * cosRoll - cosYaw * sinPitch * sinRoll, cosYaw * cosPitch * sinRoll - sinYaw * sinPitch * cosRoll, cosYaw * cosPitch * cosRoll + sinYaw * sinPitch * sinRoll);
            return result;
        }
        static Identity() {
            return new KbQuaternion_1(0, 0, 0, 1);
        }
        static From(q) {
            return new KbQuaternion_1(q.x, q.y, q.z, q.w);
        }
    };
    exports.KbQuaternion = KbQuaternion_1 = __decorate([
        Kb3dModel({
            token: Token.KbQuaternion,
            trackChanges: false,
            create: args => new KbQuaternion_1(args.x || 0, args.y || 0, args.z || 0, args.w || 1),
        }),
        __param(0, Ignore()),
        __param(1, Ignore()),
        __param(2, Ignore()),
        __param(3, Ignore())
    ], exports.KbQuaternion);
    function basicallyEqual(a, b) {
        return Math.abs(a - b) < 0.0000000001; // To deal with floating point errors
    }

    exports.SpaceNode = class SpaceNode extends exports.Kb3dObject {
        constructor() {
            super();
            this._showPivot = false;
            // this._rotationQuaternion = nodeConfig.rotationQuaternion ? KbQuaternion.FromVec3(nodeConfig.rotationQuaternion) : KbQuaternion.Identity();
            // this._rotation = this._rotationQuaternion.toEuler();
        }
        getRotationQuaternion() {
            if (this.useEuler && this.eulerRotation) {
                return exports.KbQuaternion.FromYawPitchRoll(this.eulerRotation);
            }
            else if (this.rotationAxis && this.rotationAngle !== undefined) {
                return exports.KbQuaternion.FromRotationAxis(this.rotationAxis, this.rotationAngle);
            }
            return exports.KbQuaternion.Identity();
        }
        setRotationQuaternion(q) {
            if (this.useEuler) {
                this.eulerRotation = q.toEuler();
            }
            else {
                this.rotationAngle = q.getAngle();
                this.rotationAxis = q.getAxis();
            }
        }
        get features() {
            if (!this._features)
                this._features = [];
            return this._features;
        }
        set features(val) {
            this._features = val;
        }
        get connectors() {
            if (!this._connectors)
                this._connectors = [];
            return this._connectors;
        }
        set connectors(val) {
            this._connectors = val;
        }
        getChildren() {
            return [...this.features, ...this.connectors];
        }
        getChildArrayForType(token) {
            if (token.isFeature()) {
                return this.features;
            }
            else if (token == Token.Connector) {
                return this.connectors;
            }
            else {
                throw Error('unexpected token');
            }
        }
        getAncestors() {
            return super.getAncestors();
        }
        copyPropertiesTo(target) {
            target.name = this.name;
            target.visible = this.visible;
            target.position = this.position;
            target.useEuler = this.useEuler;
            target.eulerRotation = this.eulerRotation;
            target.rotationAngle = this.rotationAngle;
            target.rotationAxis = this.rotationAxis;
            target.scaling = this.scaling;
            target.pivot = this.pivot;
            target.fixed = this.fixed;
            target._primeMover = this._primeMover;
            target._showPivot = this._showPivot;
            target.preTransform = this.preTransform;
        }
        getFeatureByName(name) {
            return [...this.features, ...this.connectors].find(f => f.name.isEqual(name));
        }
        rotate(axis, angle) {
            axis.normalize();
            const q = exports.KbQuaternion.FromRotationAxis(axis, angle);
            this.setRotationQuaternion(this.getRotationQuaternion().multiply(q));
        }
    };
    __decorate([
        Enumerable()
    ], exports.SpaceNode.prototype, "features", null);
    __decorate([
        Enumerable()
    ], exports.SpaceNode.prototype, "connectors", null);
    exports.SpaceNode = __decorate([
        BaseKb3dModel({
            token: Token.SpaceNode,
        })
    ], exports.SpaceNode);

    var MeshNode_1;
    exports.MeshNode = MeshNode_1 = class MeshNode extends exports.SpaceNode {
        constructor() {
            super();
            this._polygonCount = 0;
            this._verticesCount = 0;
            this.materialId = null;
        }
        getSpaceChildren() {
            return new Array();
        }
        copyPropertiesTo(target) {
            super.copyPropertiesTo(target);
            if (target instanceof MeshNode_1) {
                target.flipSurfaceOrientation = this.flipSurfaceOrientation;
                target.receiveShadows = this.receiveShadows;
                target.castShadows = this.castShadows;
                target.checkCollisions = this.checkCollisions;
                target.materialId = this.materialId;
                target.opacity = this.opacity;
            }
        }
    };
    __decorate([
        NodeReference(exports.MaterialNode, '')
    ], exports.MeshNode.prototype, "materialId", void 0);
    exports.MeshNode = MeshNode_1 = __decorate([
        BaseKb3dModel({
            token: Token.MeshNode,
        })
    ], exports.MeshNode);

    var PrimitiveMeshNode_1;
    exports.PrimitiveMeshNode = PrimitiveMeshNode_1 = class PrimitiveMeshNode extends exports.MeshNode {
        constructor() {
            super();
        }
        copyPropertiesTo(target) {
            super.copyPropertiesTo(target);
            if (target instanceof PrimitiveMeshNode_1) {
                target.uvOverrides = this.uvOverrides;
                target.sideOrientation = this.sideOrientation;
            }
        }
    };
    exports.PrimitiveMeshNode = PrimitiveMeshNode_1 = __decorate([
        BaseKb3dModel({
            token: Token.PrimitiveMeshNode,
        })
    ], exports.PrimitiveMeshNode);

    exports.BoxNode = class BoxNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.BoxNode = __decorate([
        Kb3dModel({
            token: Token.BoxNode,
        })
    ], exports.BoxNode);
    function isBoxMesh(node) {
        return instanceOf(node, Token.BoxNode);
    }

    exports.ConeNode = class ConeNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.ConeNode = __decorate([
        Kb3dModel({
            token: Token.ConeNode,
        })
    ], exports.ConeNode);
    function isConeMesh(node) {
        return instanceOf(node, Token.ConeNode);
    }

    var CustomMeshNode_1;
    /**
     * A Mesh Node. Must be a descendant of the MeshRoot node.
     * @param {Object} nodeConfig The configuration object of the node.
     * @param {string} nodeConfig.name The name of the node. Required.
     * @param {Object} parent The parent of this node. Optional, but mesh nodes should have parents if they are to be displayed.
     * @property
     */
    exports.CustomMeshNode = CustomMeshNode_1 = class CustomMeshNode extends exports.MeshNode {
        constructor() {
            super();
            /** Loading state of mesh. Used to keep track of when a request is in flight */
            this._loading = null;
        }
        get hasGeometry() {
            return this.geometryId != null && this.geometryId != '';
        }
        get geometryLoaded() {
            return this._geometry != null;
        }
        copyPropertiesTo(target) {
            super.copyPropertiesTo(target);
            if (target instanceof CustomMeshNode_1) {
                target.geometryId = this.geometryId;
            }
        }
    };
    __decorate([
        IgnoreChanges
    ], exports.CustomMeshNode.prototype, "_loading", void 0);
    exports.CustomMeshNode = CustomMeshNode_1 = __decorate([
        Kb3dModel({
            token: Token.CustomMeshNode,
        })
    ], exports.CustomMeshNode);

    exports.CylinderNode = class CylinderNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.CylinderNode = __decorate([
        Kb3dModel({
            token: Token.CylinderNode,
        })
    ], exports.CylinderNode);
    function isCylinderMesh(node) {
        return instanceOf(node, Token.CylinderNode);
    }

    exports.DiscNode = class DiscNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.DiscNode = __decorate([
        Kb3dModel({
            token: Token.DiscNode,
        })
    ], exports.DiscNode);
    function isDiscMesh(node) {
        return instanceOf(node, Token.DiscNode);
    }

    exports.MeshGroupNode = class MeshGroupNode extends exports.SpaceNode {
        constructor() {
            super();
        }
        get meshes() {
            if (!this._meshes)
                this._meshes = [];
            return this._meshes;
        }
        set meshes(val) {
            this._meshes = val;
        }
        getChildren() {
            return super.getChildren().concat(this.meshes);
        }
        getChildArrayForType(token) {
            if (token.isMeshOrGroup() || token.isLight()) {
                return this.meshes;
            }
            else if (token.isConnector()) {
                return this.connectors;
            }
            else {
                throw 'unexpected token';
            }
        }
        getSpaceChildren() {
            return this.meshes;
        }
    };
    __decorate([
        Enumerable()
    ], exports.MeshGroupNode.prototype, "meshes", null);
    exports.MeshGroupNode = __decorate([
        Kb3dModel({
            token: Token.MeshGroupNode,
        })
    ], exports.MeshGroupNode);

    function isMeshGroupNode(node) {
        return instanceOf(node, Token.MeshGroupNode);
    }
    function isCustomMeshNode(node) {
        return instanceOf(node, Token.CustomMeshNode);
    }
    function isSketchNode(node) {
        return instanceOf(node, Token.SketchNode);
    }
    function isTextNode(node) {
        return instanceOf(node, Token.TextNode);
    }
    function isSketchControlPoint(node) {
        return instanceOf(node, Token.SketchControlPoint);
    }
    function isMeshNode(node) {
        return instanceOfAny(node, ...Token.MeshTokens);
    }
    function isPrimitiveMeshNode(node) {
        return instanceOf(node, Token.PrimitiveMeshNode);
    }
    function isSpaceNode(node) {
        return instanceOf(node, Token.SpaceNode);
    }
    function isPickable(node) {
        if (node instanceof exports.SpaceNode || node instanceof exports.AnnotationNode) {
            return true;
        }
        else {
            return false;
        }
    }
    function isTrackedMeshNode(node) {
        return isMeshNode(node) && isTrackedInstanceOfAny(node, ...Token.MeshAndGroupTokens);
    }

    exports.PlaneNode = class PlaneNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.PlaneNode = __decorate([
        Kb3dModel({
            token: Token.PlaneNode,
        })
    ], exports.PlaneNode);
    function isPlaneMesh(node) {
        return instanceOf(node, Token.PlaneNode);
    }

    var KbColor_1;
    exports.KbColor = KbColor_1 = class KbColor {
        constructor(r, g, b, a = 1) {
            this.r = r;
            this.g = g;
            this.b = b;
            this.a = a;
        }
        clone() {
            return new KbColor_1(this.r, this.g, this.b, this.a);
        }
        assign(c) {
            return new KbColor_1(typeof c.r === 'number' ? c.r : this.r, typeof c.g === 'number' ? c.g : this.g, typeof c.b === 'number' ? c.b : this.b, typeof c.a === 'number' ? c.a : this.a);
        }
        equal(c) {
            return !!c && c.r == this.r && c.g == this.g && c.b == this.b && c.a == this.a;
        }
        cssString() {
            if (this.a < 1) {
                return `rgba(${this.r * 255}, ${this.g * 255}, ${this.b * 255}, ${this.a})`;
            }
            else {
                return `rgb(${this.r * 255}, ${this.g * 255}, ${this.b * 255})`;
            }
        }
        toObject() {
            return { r: this.r, g: this.g, b: this.b, a: this.a };
        }
        toIntObject() {
            return { r: this.r * 255, g: this.g * 255, b: this.b * 255, a: this.a };
        }
        static From(c) {
            return new KbColor_1(c.r, c.g, c.b, c.a);
        }
        static FromIntObject(c) {
            return new KbColor_1(c.r / 255, c.g / 255, c.b / 255, c.a != null ? c.a : 1);
        }
        static White() {
            return new KbColor_1(1, 1, 1, 1);
        }
        static Black() {
            return new KbColor_1(0, 0, 0, 1);
        }
        static Transparent() {
            return new KbColor_1(0, 0, 0, 0);
        }
        static Green() {
            return new KbColor_1(0, 1, 0);
        }
        static Red() {
            return new KbColor_1(1, 0, 0);
        }
        static KbmaxOrange() {
            return new KbColor_1(227 / 255, 131 / 255, 28 / 255);
        }
        static KbmaxBlue() {
            return new KbColor_1(8 / 255, 72 / 255, 96 / 255);
        }
    };
    exports.KbColor = KbColor_1 = __decorate([
        Kb3dModel({
            token: Token.KbColor,
            trackChanges: false,
            create: args => new KbColor_1(args.r || 0, args.g || 0, args.b || 0, args.a),
        }),
        __param(0, Ignore()),
        __param(1, Ignore()),
        __param(2, Ignore()),
        __param(3, Ignore())
    ], exports.KbColor);

    var KbGeometry_1;
    const NEW_GEOMETRY = 'NEW_GEOMETRY';
    const MAX_INT16 = 32767;
    const MAX_UINT16 = 65535;
    exports.KbGeometry = KbGeometry_1 = class KbGeometry {
        /**
         * A geometry object. Geometries are immutable, once they are created they should not be modified.
         */
        constructor() {
            this.shared = false;
        }
        clone() {
            const newGeometry = new KbGeometry_1();
            newGeometry.indices = this.indices;
            newGeometry.positions = this.positions;
            newGeometry.normals = this.normals;
            newGeometry.tangents = this.tangents;
            newGeometry.uvs = this.uvs;
            return newGeometry;
        }
        /**
         * Freeze a geometry to enforce the immutability of geometries
         */
        // freeze() {
        //     Object.freeze(this);
        //     Object.freeze(this.vertexData);
        // }
        // update(vertexData: Partial<KBVertexData & IUvData>) {
        //     const newVertexData = { ...this.vertexData, ...vertexData };
        //     const newGeometry = new KbGeometry(newVertexData, this.id);
        //     return newGeometry;
        // }
        extractFromBinary(fileData, meshNode) {
            const dataView = new DataView(fileData);
            let curPos;
            // indices
            const indicesOffset = dataView.getInt32(0, true);
            curPos = 4;
            const indicesDataSize = dataView.getInt32(curPos, true);
            curPos += 4;
            let indices;
            if (indicesDataSize === 16) {
                const indices16 = new Uint16Array(fileData, curPos, indicesOffset / 2);
                indices = Uint32Array.from(indices16);
                curPos += indicesOffset;
            }
            else if (indicesDataSize === 32) {
                indices = new Uint32Array(fileData, curPos, indicesOffset / 4);
                curPos += indicesOffset;
            }
            else {
                throw Error('Unknown indices data size ' + meshNode.name);
            }
            // positions
            const posOffset = dataView.getInt32(curPos, true);
            curPos += 4;
            const posDataSize = dataView.getInt32(curPos, true);
            curPos += 4;
            const posRatio = dataView.getInt32(curPos, true);
            curPos += 4;
            let positions;
            if (posDataSize === 32) {
                positions = new Float32Array(fileData.slice(curPos, curPos + posOffset));
                for (let i = 0; i < positions.length; i++) {
                    positions[i] /= posRatio;
                }
                curPos += posOffset;
            }
            else {
                throw Error('Invalid positions in binary ' + meshNode.name);
            }
            // normals
            const norOffset = dataView.getInt32(curPos, true);
            curPos += 4;
            const norDataSize = dataView.getInt32(curPos, true);
            curPos += 4;
            const norRatio = dataView.getInt32(curPos, true);
            curPos += 4;
            let normals;
            if (norDataSize === 16) {
                const normalsInt = new Int16Array(fileData.slice(curPos, curPos + norOffset));
                normals = new Float32Array(normalsInt.length);
                for (let i = 0; i < normalsInt.length; i++) {
                    normals[i] = normalsInt[i] / norRatio;
                }
                curPos += norOffset;
            }
            else {
                throw Error('Invalid normals in binary ' + meshNode.name);
            }
            const uvsOffset = dataView.getInt32(curPos, true);
            curPos += 4;
            const uvsDataSize = dataView.getInt32(curPos, true);
            curPos += 4;
            const uvsRatio = dataView.getInt32(curPos, true);
            curPos += 4;
            let uvs;
            if (uvsDataSize === 16) {
                const uvsInt = new Int16Array(fileData.slice(curPos, curPos + uvsOffset));
                uvs = new Float32Array(uvsInt.length);
                for (let i = 0; i < uvsInt.length; i++) {
                    uvs[i] = uvsInt[i] / uvsRatio;
                }
                curPos += uvsOffset;
            }
            else {
                throw Error('Invalid uvs in binary ' + meshNode.name);
            }
            // Error reporting
            if (indices.length % 3 > 0) {
                console.warn('Incomplete indices triangles in mesh ' + meshNode.name);
            }
            if (positions.length % 3 > 0) {
                console.warn('Incomplete position vectors in mesh ' + meshNode.name);
            }
            if (normals.length % 3 > 0) {
                console.warn('Incomplete normal vectors in mesh ' + meshNode.name);
            }
            if (uvs.length % 2 > 0) {
                console.warn('Incomplete uv vectors in mesh ' + meshNode.name);
            }
            if (uvs.length > 0 && positions.length !== normals.length) {
                console.warn('Normals and Positions array size mismatch in ' + meshNode.name);
            }
            if (uvs.length > 0 && positions.length / 3 !== uvs.length / 2) {
                console.warn('UV array size mismatch in ' + meshNode.name);
            }
            // End error reporting
            this.positions = positions;
            this.indices = indices;
            if (normals.length > 0) {
                this.normals = normals;
            }
            if (uvs.length > 0) {
                this.uvs = uvs;
            }
        }
        toBinary() {
            if (!this.positions || !this.indices) {
                return;
            }
            const positions = this.positions;
            const indices = this.indices;
            const normals = this.normals || new Float32Array([]);
            const uvs = this.uvs || new Float32Array([]);
            let fileLen = 0;
            let indicesOffset = 8; // indices data markers
            let indicesBits = 0;
            let indicesLength = 0;
            let posOffset = 0;
            let posBits = 0;
            let posLength = 0;
            let normalsOffset = 0;
            let normalsBits = 0;
            let normalsLength = 0;
            let uvsOffset = 0;
            let uvsBits = 0;
            let uvsLength = 0;
            // calculate the total size of the array
            fileLen += indicesOffset;
            if (canFitInUInt16Bit(indices)) {
                // write a 16bit array
                indicesBits = 16;
                indicesLength = indices.length * 2;
                fileLen += indicesLength;
            }
            else {
                // write a 32bit array
                indicesBits = 32;
                indicesLength = indices.length * 4;
                fileLen += indicesLength;
            }
            fileLen += 12; // position data markers
            posOffset = fileLen;
            posBits = 32;
            fileLen += positions.length * 4;
            posLength = positions.length * 4;
            fileLen += 12; // normals data markers
            normalsOffset = fileLen;
            // write the normals 16 bit array
            normalsBits = 16;
            fileLen += normals.length * 2;
            normalsLength = normals.length * 2;
            fileLen += 12; // uv data markers
            uvsOffset = fileLen;
            uvsBits = 16;
            fileLen += uvs.length * 2;
            uvsLength = uvs.length * 2;
            // create the buffer that represent the binary file
            const buffer = new ArrayBuffer(fileLen);
            const bufferView = new DataView(buffer);
            // let's write the data into the bufferView
            // write the indices
            bufferView.setInt32(indicesOffset - 8, indicesLength, true); // NOTICE that by default JS is big endian, but since our servers are x86 we are little endian
            bufferView.setInt32(indicesOffset - 4, indicesBits, true);
            if (indicesBits == 16) {
                for (let i = 0; i < indices.length; i++) {
                    bufferView.setUint16(indicesOffset, indices[i], true);
                    indicesOffset += 2;
                }
            }
            else if (indicesBits == 32) {
                for (let i = 0; i < indices.length; i++) {
                    bufferView.setUint32(indicesOffset, indices[i], true);
                    indicesOffset += 4;
                }
            }
            // write the positions
            bufferView.setInt32(posOffset - 12, posLength, true);
            bufferView.setInt32(posOffset - 8, posBits, true);
            bufferView.setInt32(posOffset - 4, 1, true); // ratio
            if (posBits == 32) {
                for (let i = 0; i < positions.length; i++) {
                    bufferView.setFloat32(posOffset, positions[i], true);
                    posOffset += 4;
                }
            }
            else {
                console.error('Fix me - non-32bit positions not supported');
            }
            // write the normals
            bufferView.setInt32(normalsOffset - 12, normalsLength, true);
            bufferView.setInt32(normalsOffset - 8, normalsBits, true);
            bufferView.setInt32(normalsOffset - 4, MAX_INT16, true);
            if (normalsBits == 16) {
                for (let i = 0; i < normals.length; i++) {
                    const n = floatToIntStore(normals[i], MAX_INT16);
                    bufferView.setInt16(normalsOffset, n, true);
                    normalsOffset += 2;
                }
            }
            else {
                console.error('Fix me - non-16bit normals not supported');
            }
            // write the UVs
            bufferView.setInt32(uvsOffset - 12, uvsLength, true);
            bufferView.setInt32(uvsOffset - 8, uvsBits, true);
            bufferView.setInt32(uvsOffset - 4, MAX_INT16, true);
            if (uvsBits == 16) {
                for (let i = 0; i < uvs.length; i++) {
                    const n = floatToIntStore(uvs[i], MAX_INT16);
                    bufferView.setInt16(uvsOffset, n, true);
                    uvsOffset += 2;
                }
            }
            else {
                console.error('Fix me - non-16bit uvs not supported');
            }
            return buffer;
        }
    };
    exports.KbGeometry = KbGeometry_1 = __decorate([
        Kb3dModel({
            token: Token.KbGeometry,
            trackChanges: false,
        })
    ], exports.KbGeometry);
    // function canFitInInt16Bit(inArray: Float32Array): boolean {
    //     for (let i = 0; i < inArray.length; i++) {
    //         const val = inArray[i];
    //         if (val > 327.68 || val < -327.68) {
    //             return false;
    //         }
    //     }
    //     return true;
    // }
    // function canFitInInt8Bit(inArray: Float32Array): boolean {
    //     for (let i = 0; i < inArray.length; i++) {
    //         const val = inArray[i];
    //         if (val > 1.28 || val < -1.28) {
    //             return false;
    //         }
    //     }
    //     return true;
    // }
    function canFitInUInt16Bit(inArray) {
        for (let i = 0; i < inArray.length; i++) {
            const val = inArray[i];
            if (val > MAX_UINT16) {
                return false;
            }
        }
        return true;
    }
    function floatToIntStore(float, maxInt, maxVal = 1) {
        // this function convert a value between -327.68 and 327.68 to an int 16. we use the convention to have only 2 decimal numbers
        float = (Math.min(Math.max(-maxVal, float), maxVal) * maxInt) / maxVal;
        const outVal = Math.trunc(float);
        return outVal;
    }

    var SketchNode_1;
    exports.SketchNode = SketchNode_1 = class SketchNode extends exports.MeshNode {
        constructor() {
            super();
            this._boundingBoxMin = exports.KbVector.Zero();
            this._boundingBoxMax = exports.KbVector.Zero();
            this._boundingBoxChanges = new Subject();
            this._controlPoints = [];
            this._lineSegmentStartingPoints = [];
            // todo remove
            this._sketchPoints = new Float32Array();
            this.paths = [];
            /** Whether to generate a face for this path */
            this.addFace = false;
            this.closePath = false;
            this.flipPath = false;
            this.tracePath = false;
        }
        getChildren() {
            return super.getChildren().concat(this.paths);
        }
        getChildArrayForType(token) {
            if (token.isSketchPath()) {
                return this.paths;
            }
            else {
                return super.getChildArrayForType(token);
            }
        }
        getBoundingBox() {
            const min = new exports.KbVector(this.boundingXOverride == null ? this._boundingBoxMin.x : -this.boundingXOverride / 2, this.boundingYOverride == null ? this._boundingBoxMin.y : -this.boundingYOverride / 2, this.boundingZOverride == null ? this._boundingBoxMin.z : -this.boundingZOverride / 2);
            const max = new exports.KbVector(this.boundingXOverride == null ? this._boundingBoxMax.x : this.boundingXOverride / 2, this.boundingYOverride == null ? this._boundingBoxMax.y : this.boundingYOverride / 2, this.boundingZOverride == null ? this._boundingBoxMax.z : this.boundingZOverride / 2);
            const centerBB = this._boundingBoxMin.add(this._boundingBoxMax).scale(0.5);
            const center = new exports.KbVector(this.boundingXOverride == null ? centerBB.x : 0, this.boundingYOverride == null ? centerBB.y : 0, this.boundingZOverride == null ? centerBB.z : 0);
            return {
                min,
                max,
                center,
            };
        }
        getSketchLength() {
            let sketchLength = 0;
            this.paths.forEach(path => {
                let lastPosition = undefined;
                path._points.forEach(point => {
                    if (!lastPosition) {
                        lastPosition = point;
                    }
                    else {
                        const currentPos = point;
                        const distance = Math.sqrt(Math.pow(lastPosition.x - currentPos.x, 2) +
                            Math.pow(lastPosition.y - currentPos.y, 2) +
                            Math.pow(lastPosition.z - currentPos.z, 2));
                        sketchLength += distance;
                        lastPosition = currentPos;
                    }
                });
            });
            return sketchLength;
        }
    };
    __decorate([
        NodeReference(SketchNode_1)
    ], exports.SketchNode.prototype, "clonePath", void 0);
    exports.SketchNode = SketchNode_1 = __decorate([
        Kb3dModel({
            token: Token.SketchNode,
        })
    ], exports.SketchNode);

    exports.SketchPath = class SketchPath extends exports.Kb3dObject {
        constructor() {
            super(...arguments);
            /** Path control points */
            this.controlPoints = [];
            /** How smooth to make this path when rasterizing to geometry */
            this.tessellation = 16;
            /** For grouping paths as one contiguous shape. Only required for hole-path matching */
            this.pathGroupKey = 'default';
            this._expanded = false;
            this._points = [];
        }
        getChildren() {
            return super.getChildren().concat(this.controlPoints);
        }
        getChildArrayForType(token) {
            if (token.isConnector()) {
                return this.controlPoints;
            }
            else {
                return super.getChildArrayForType(token);
            }
        }
        getAncestors() {
            return super.getAncestors();
        }
    };
    exports.SketchPath = __decorate([
        Kb3dModel({
            token: Token.SketchPath,
        })
    ], exports.SketchPath);

    exports.SphereNode = class SphereNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.SphereNode = __decorate([
        Kb3dModel({
            token: Token.SphereNode,
        })
    ], exports.SphereNode);
    function isSphereMesh(node) {
        return instanceOf(node, Token.SphereNode);
    }

    exports.TextNode = class TextNode extends exports.MeshNode {
        constructor() {
            super(...arguments);
            this.curveRadius = 0;
            this.charSpacing = 1;
            this.text = '';
        }
    };
    exports.TextNode = __decorate([
        Kb3dModel({
            token: Token.TextNode,
        })
    ], exports.TextNode);

    exports.TorusNode = class TorusNode extends exports.PrimitiveMeshNode {
        constructor() {
            super();
        }
    };
    exports.TorusNode = __decorate([
        Kb3dModel({
            token: Token.TorusNode,
        })
    ], exports.TorusNode);
    function isTorusMesh(node) {
        return instanceOf(node, Token.TorusNode);
    }

    class PatternFeature extends exports.Feature {
    }
    PatternFeature._affects = new Set(ALL_GEOMETRY);
    PatternFeature._affectedBy = new Set(ALL_GEOMETRY);
    __decorate([
        NodeReference(exports.SketchNode)
    ], PatternFeature.prototype, "meshId", void 0);
    function isPattern(o) {
        return instanceOfAny(o, Token.LinearPatternFeature, Token.CircularPatternFeature);
    }

    exports.CircularPatternFeature = class CircularPatternFeature extends PatternFeature {
    };
    exports.CircularPatternFeature._affects = new Set(ALL_GEOMETRY);
    exports.CircularPatternFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.CircularPatternFeature = __decorate([
        Kb3dModel({
            token: Token.CircularPatternFeature,
        })
    ], exports.CircularPatternFeature);
    function isCircularPattern(o) {
        return instanceOf(o, Token.CircularPatternFeature);
    }

    exports.Connector = class Connector extends exports.BaseConnector {
        getAncestors() {
            return super.getAncestors();
        }
        getSpaceParent() {
            return this._parent;
        }
    };
    exports.Connector = __decorate([
        Kb3dModel({
            token: Token.Connector,
        })
    ], exports.Connector);
    function isConnector(o) {
        return instanceOf(o, Token.Connector);
    }

    exports.DeleteFacesFeature = class DeleteFacesFeature extends exports.Feature {
        constructor() {
            super(...arguments);
            this.vertexGroups = [];
        }
    };
    exports.DeleteFacesFeature._dependsOn = new Set([exports.eMeshChangeTypes.VertexIndices]);
    exports.DeleteFacesFeature._affects = new Set([exports.eMeshChangeTypes.VertexIndices, exports.eMeshChangeTypes.Submeshes]);
    exports.DeleteFacesFeature._affectedBy = new Set([exports.eMeshChangeTypes.VertexIndices, exports.eMeshChangeTypes.Submeshes]);
    exports.DeleteFacesFeature = __decorate([
        Kb3dModel({
            token: Token.DeleteFacesFeature,
        })
    ], exports.DeleteFacesFeature);

    exports.DisplacementMapFeature = class DisplacementMapFeature extends exports.Feature {
        constructor(_materialService) {
            super();
            this._materialService = _materialService;
            this._initialized = false;
        }
        get textures() {
            if (!this._textures)
                this._textures = [];
            return this._textures;
        }
        set textures(val) {
            this._textures = val;
        }
        getChildren() {
            return [...this.textures];
        }
        getChildArrayForType(token) {
            if (token.isTexture()) {
                return this.textures;
            }
            else {
                throw 'unexpected token';
            }
        }
    };
    exports.DisplacementMapFeature._affects = new Set([exports.eMeshChangeTypes.VertexNormals, exports.eMeshChangeTypes.VertexPositions]);
    exports.DisplacementMapFeature._affectedBy = new Set(ALL_GEOMETRY);
    __decorate([
        Enumerable()
    ], exports.DisplacementMapFeature.prototype, "textures", null);
    exports.DisplacementMapFeature = __decorate([
        Kb3dModel({
            token: Token.DisplacementMapFeature,
        }),
        __param(0, Inject(Token.MaterialService))
    ], exports.DisplacementMapFeature);

    exports.ExtrudeFeature = class ExtrudeFeature extends exports.Feature {
        constructor() {
            super(...arguments);
            this.vertexGroups = [];
        }
    };
    exports.ExtrudeFeature._affects = new Set(ALL_GEOMETRY);
    exports.ExtrudeFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.ExtrudeFeature = __decorate([
        Kb3dModel({
            token: Token.ExtrudeFeature,
        })
    ], exports.ExtrudeFeature);

    exports.JoinGeometryFeature = class JoinGeometryFeature extends exports.Feature {
    };
    exports.JoinGeometryFeature._affects = new Set(ALL_GEOMETRY);
    exports.JoinGeometryFeature._affectedBy = new Set(ALL_CHANGES);
    __decorate([
        NodeReference(exports.MeshNode)
    ], exports.JoinGeometryFeature.prototype, "meshId", void 0);
    exports.JoinGeometryFeature = __decorate([
        Kb3dModel({
            token: Token.JoinGeometryFeature,
        })
    ], exports.JoinGeometryFeature);

    exports.LinearPatternFeature = class LinearPatternFeature extends PatternFeature {
    };
    exports.LinearPatternFeature._affects = new Set(ALL_GEOMETRY);
    exports.LinearPatternFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.LinearPatternFeature = __decorate([
        Kb3dModel({
            token: Token.LinearPatternFeature,
        })
    ], exports.LinearPatternFeature);
    function isLinearPattern(o) {
        return instanceOf(o, Token.LinearPatternFeature);
    }

    exports.SliceFeature = class SliceFeature extends exports.Feature {
    };
    exports.SliceFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.SliceFeature._affects = new Set(ALL_GEOMETRY);
    exports.SliceFeature = __decorate([
        Kb3dModel({
            token: Token.SliceFeature,
        })
    ], exports.SliceFeature);

    exports.MirrorFeature = class MirrorFeature extends exports.SliceFeature {
    };
    exports.MirrorFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.MirrorFeature._affects = new Set(ALL_GEOMETRY);
    exports.MirrorFeature = __decorate([
        Kb3dModel({
            token: Token.MirrorFeature,
        })
    ], exports.MirrorFeature);

    exports.MoveVerticesFeature = class MoveVerticesFeature extends exports.Feature {
        constructor() {
            super(...arguments);
            this._previewParticleSize = 0.005;
        }
        get vertexIndices() {
            if (!this._vertexIndices)
                this._vertexIndices = [];
            return this._vertexIndices;
        }
        set vertexIndices(val) {
            this._vertexIndices = val;
        }
    };
    exports.MoveVerticesFeature._dependsOn = new Set([exports.eMeshChangeTypes.VertexIndices]);
    exports.MoveVerticesFeature._affectedBy = new Set([exports.eMeshChangeTypes.VertexPositions]);
    exports.MoveVerticesFeature._affects = new Set([exports.eMeshChangeTypes.VertexPositions]);
    __decorate([
        IgnoreChanges
    ], exports.MoveVerticesFeature.prototype, "_vertexIndices", void 0);
    __decorate([
        Enumerable()
    ], exports.MoveVerticesFeature.prototype, "vertexIndices", null);
    exports.MoveVerticesFeature = __decorate([
        Kb3dModel({
            token: Token.MoveVerticesFeature,
        })
    ], exports.MoveVerticesFeature);

    exports.NormalSmoothingFeature = class NormalSmoothingFeature extends exports.Feature {
        constructor() {
            super(...arguments);
            this.vertexGroups = [];
            this.smooth = true;
        }
    };
    //static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    exports.NormalSmoothingFeature._affects = new Set(ALL_GEOMETRY);
    exports.NormalSmoothingFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.NormalSmoothingFeature = __decorate([
        Kb3dModel({
            token: Token.NormalSmoothingFeature,
        })
    ], exports.NormalSmoothingFeature);

    (function (eContainerItemLayout) {
        eContainerItemLayout["horizontal"] = "horizontal";
        eContainerItemLayout["vertical"] = "vertical";
        eContainerItemLayout["absolute"] = "absolute";
    })(exports.eContainerItemLayout || (exports.eContainerItemLayout = {}));
    (function (eContainerChildAlignment) {
        eContainerChildAlignment["inherit"] = "inherit";
        eContainerChildAlignment["stretch"] = "stretch";
        eContainerChildAlignment["start"] = "start";
        eContainerChildAlignment["center"] = "center";
        eContainerChildAlignment["end"] = "end";
    })(exports.eContainerChildAlignment || (exports.eContainerChildAlignment = {}));
    (function (eContainerItemAlignment) {
        eContainerItemAlignment["stretch"] = "stretch";
        eContainerItemAlignment["start"] = "start";
        eContainerItemAlignment["center"] = "center";
        eContainerItemAlignment["end"] = "end";
    })(exports.eContainerItemAlignment || (exports.eContainerItemAlignment = {}));
    (function (eContainerItemJustify) {
        eContainerItemJustify["start"] = "start";
        eContainerItemJustify["center"] = "center";
        eContainerItemJustify["end"] = "end";
    })(exports.eContainerItemJustify || (exports.eContainerItemJustify = {}));
    (function (eScroll) {
        eScroll["none"] = "none";
        eScroll["auto"] = "auto";
        eScroll["x"] = "x";
        eScroll["y"] = "y";
    })(exports.eScroll || (exports.eScroll = {}));
    (function (eRelativeSize) {
        eRelativeSize["auto"] = "auto";
        eRelativeSize["x1"] = "x1";
        eRelativeSize["x2"] = "x2";
        eRelativeSize["x3"] = "x3";
        eRelativeSize["x4"] = "x4";
        eRelativeSize["x5"] = "x5";
        eRelativeSize["x6"] = "x6";
        eRelativeSize["x7"] = "x7";
        eRelativeSize["x8"] = "x8";
        eRelativeSize["x9"] = "x9";
        eRelativeSize["x10"] = "x10";
        eRelativeSize["x11"] = "x11";
        eRelativeSize["x12"] = "x12";
        eRelativeSize["custom"] = "custom";
    })(exports.eRelativeSize || (exports.eRelativeSize = {}));
    (function (ePadding) {
        ePadding["none"] = "none";
        ePadding["small"] = "small";
        ePadding["medium"] = "medium";
        ePadding["large"] = "large";
    })(exports.ePadding || (exports.ePadding = {}));
    (function (eColorShade) {
        eColorShade["default"] = "default";
        eColorShade["lighter1"] = "lighter1";
        eColorShade["lighter2"] = "lighter2";
        eColorShade["lighter3"] = "lighter3";
        eColorShade["lighter4"] = "lighter4";
        eColorShade["darker1"] = "darker1";
        eColorShade["darker2"] = "darker2";
        eColorShade["darker3"] = "darker3";
        eColorShade["darker4"] = "darker4";
    })(exports.eColorShade || (exports.eColorShade = {}));
    (function (eBackgroundColor) {
        eBackgroundColor["background"] = "background";
        eBackgroundColor["primary"] = "primary";
        eBackgroundColor["accent"] = "accent";
        eBackgroundColor["warning"] = "warning";
        eBackgroundColor["success"] = "success";
        eBackgroundColor["input"] = "input";
        eBackgroundColor["header"] = "header";
    })(exports.eBackgroundColor || (exports.eBackgroundColor = {}));
    (function (eElevation) {
        eElevation["none"] = "none";
        eElevation["z1"] = "z1";
        eElevation["z2"] = "z2";
        eElevation["z3"] = "z3";
        eElevation["z4"] = "z4";
        eElevation["z5"] = "z5";
        eElevation["z6"] = "z6";
        eElevation["z7"] = "z7";
        eElevation["z8"] = "z8";
    })(exports.eElevation || (exports.eElevation = {}));
    (function (eRuleType) {
        eRuleType["value"] = "value";
        eRuleType["visibility"] = "visibility";
        eRuleType["validation"] = "validation";
        eRuleType["pricing"] = "pricing";
        eRuleType["message"] = "message";
        eRuleType["loaded"] = "loaded";
        eRuleType["submit"] = "submit";
        eRuleType["pageChanged"] = "pageChanged";
        eRuleType["tabChanged"] = "tabChanged";
        eRuleType["expanderChanged"] = "expanderChanged";
        eRuleType["output"] = "output";
        eRuleType["action"] = "action";
        eRuleType["function"] = "function";
        eRuleType["global"] = "global";
        eRuleType["globalEvent"] = "globalEvent";
        eRuleType["safeFunction"] = "safeFunction";
        eRuleType["naming"] = "naming";
        eRuleType["field"] = "field";
        eRuleType["button"] = "button";
        eRuleType["svgViewer"] = "svgViewer";
        eRuleType["html"] = "html";
        eRuleType["dragStart"] = "dragStart";
        eRuleType["dragMove"] = "dragMove";
        eRuleType["dragEnd"] = "dragEnd";
        eRuleType["optionFilter"] = "optionFilter";
        eRuleType["nested"] = "nested";
        eRuleType["resize"] = "resize";
        eRuleType["nestedSetSelected"] = "nestedSetSelected";
        eRuleType["keyboard"] = "keyboard";
        eRuleType["manufacture"] = "manufacture";
        eRuleType["kineticDocumentRules"] = "kineticDocumentRules";
        eRuleType["layout"] = "layout";
        eRuleType["configuratorAdded"] = "configuratorAdded";
        eRuleType["configuratorRemoved"] = "configuratorRemoved";
        eRuleType["configuratorCopied"] = "configuratorCopied";
        eRuleType["product"] = "product";
        eRuleType["workflow"] = "workflow";
        eRuleType["beforeBuild"] = "beforeBuild";
        eRuleType["globalDefinition"] = "globalDefinition";
        eRuleType["quote"] = "quote";
        eRuleType["scene"] = "scene";
        eRuleType["sceneLoaded"] = "sceneLoaded";
        eRuleType["xrEnter"] = "xrEnter";
        eRuleType["xrExit"] = "xrExit";
    })(exports.eRuleType || (exports.eRuleType = {}));
    (function (eToolbarPosition) {
        eToolbarPosition["hidden"] = "hidden";
        eToolbarPosition["topLeft"] = "topLeft";
        eToolbarPosition["topRight"] = "topRight";
        eToolbarPosition["bottomLeft"] = "bottomLeft";
        eToolbarPosition["bottomRight"] = "bottomRight";
    })(exports.eToolbarPosition || (exports.eToolbarPosition = {}));
    (function (eValidationTiming) {
        eValidationTiming["always"] = "always";
        eValidationTiming["onTouched"] = "onTouched";
    })(exports.eValidationTiming || (exports.eValidationTiming = {}));
    (function (eViewerMode) {
        eViewerMode["none"] = "none";
        eViewerMode["media"] = "media";
        eViewerMode["scene"] = "scene";
    })(exports.eViewerMode || (exports.eViewerMode = {}));
    (function (ePosition) {
        ePosition["left"] = "left";
        ePosition["right"] = "right";
    })(exports.ePosition || (exports.ePosition = {}));
    (function (eIconStyle) {
        eIconStyle["none"] = "none";
        eIconStyle["icon"] = "icon";
        eIconStyle["media"] = "media";
    })(exports.eIconStyle || (exports.eIconStyle = {}));
    (function (eExportType) {
        eExportType["_custom"] = "_custom";
        eExportType["pdf"] = "pdf";
        eExportType["bmp"] = "bmp";
        eExportType["doc"] = "doc";
        eExportType["docm"] = "docm";
        eExportType["dot"] = "dot";
        eExportType["dotm"] = "dotm";
        eExportType["dotx"] = "dotx";
        eExportType["emf"] = "emf";
        eExportType["epub"] = "epub";
        eExportType["html"] = "html";
        eExportType["jpg"] = "jpg";
        eExportType["gif"] = "gif";
        eExportType["tiff"] = "tiff";
        eExportType["dwf"] = "dwf";
        eExportType["edrw"] = "edrw";
        eExportType["png"] = "png";
        eExportType["odt"] = "odt";
        eExportType["rtf"] = "rtf";
        eExportType["tif"] = "tif";
        eExportType["xaml"] = "xaml";
        eExportType["xps"] = "xps";
        eExportType["ods"] = "ods";
        eExportType["svg"] = "svg";
        eExportType["txt"] = "txt";
        eExportType["easm"] = "easm";
        eExportType["prt"] = "prt";
        eExportType["g"] = "g";
        eExportType["dwg"] = "dwg";
        eExportType["dxf"] = "dxf";
        eExportType["sldprt"] = "sldprt";
        eExportType["sldasm"] = "sldasm";
        eExportType["slddrw"] = "slddrw";
        eExportType["sldlfp"] = "sldlfp";
        eExportType["x_t"] = "x_t";
        eExportType["x_b"] = "x_b";
        eExportType["igs"] = "igs";
        eExportType["stl"] = "stl";
        eExportType["wrl"] = "wrl";
        eExportType["u3d"] = "u3d";
        eExportType["psd"] = "psd";
        eExportType["ai"] = "ai";
        eExportType["cgr"] = "cgr";
        eExportType["asm"] = "asm";
        eExportType["hcg"] = "hcg";
        eExportType["hsf"] = "hsf";
        eExportType["sat"] = "sat";
        eExportType["stp"] = "stp";
        eExportType["step"] = "step";
        eExportType["vda"] = "vda";
        eExportType["neu"] = "neu";
        eExportType["iv"] = "iv";
        eExportType["slp"] = "slp";
        eExportType["eps"] = "eps";
        eExportType["catproduct"] = "catproduct";
        eExportType["jt"] = "jt";
        eExportType["zgl"] = "zgl";
        eExportType["xgl"] = "xgl";
        eExportType["csv"] = "csv";
        eExportType["xml"] = "xml";
    })(exports.eExportType || (exports.eExportType = {}));
    (function (eHotspotSource) {
        eHotspotSource["none"] = "none";
        eHotspotSource["text"] = "text";
        eHotspotSource["media"] = "media";
        eHotspotSource["element"] = "element";
    })(exports.eHotspotSource || (exports.eHotspotSource = {}));
    (function (eHotspotAttach) {
        eHotspotAttach["topLeft"] = "topLeft";
        eHotspotAttach["top"] = "top";
        eHotspotAttach["topRight"] = "topRight";
        eHotspotAttach["left"] = "left";
        eHotspotAttach["center"] = "center";
        eHotspotAttach["right"] = "right";
        eHotspotAttach["bottomLeft"] = "bottomLeft";
        eHotspotAttach["bottom"] = "bottom";
        eHotspotAttach["bottomRight"] = "bottomRight";
    })(exports.eHotspotAttach || (exports.eHotspotAttach = {}));
    (function (eHotspotPosition) {
        eHotspotPosition["manual"] = "manual";
        eHotspotPosition["target"] = "target";
    })(exports.eHotspotPosition || (exports.eHotspotPosition = {}));
    (function (eHotspotShape) {
        eHotspotShape["circle"] = "circle";
        eHotspotShape["circleWithText"] = "circleWithText";
        eHotspotShape["image"] = "image";
        eHotspotShape["mesh"] = "mesh";
        eHotspotShape["text"] = "text";
    })(exports.eHotspotShape || (exports.eHotspotShape = {}));
    (function (eAnimationEasing) {
        eAnimationEasing["linear"] = "linear";
        eAnimationEasing["easeInQuad"] = "easeInQuad";
        eAnimationEasing["easeOutQuad"] = "easeOutQuad";
        eAnimationEasing["easeInOutQuad"] = "easeInOutQuad";
        eAnimationEasing["easeInCubic"] = "easeInCubic";
        eAnimationEasing["easeOutCubic"] = "easeOutCubic";
        eAnimationEasing["easeInOutCubic"] = "easeInOutCubic";
        eAnimationEasing["easeInQuart"] = "easeInQuart";
        eAnimationEasing["easeOutQuart"] = "easeOutQuart";
        eAnimationEasing["easeInOutQuart"] = "easeInOutQuart";
        eAnimationEasing["easeInQuint"] = "easeInQuint";
        eAnimationEasing["easeOutQuint"] = "easeOutQuint";
        eAnimationEasing["easeInOutQuint"] = "easeInOutQuint";
        eAnimationEasing["easeInSine"] = "easeInSine";
        eAnimationEasing["easeOutSine"] = "easeOutSine";
        eAnimationEasing["easeInOutSine"] = "easeInOutSine";
        eAnimationEasing["easeInExpo"] = "easeInExpo";
        eAnimationEasing["easeOutExpo"] = "easeOutExpo";
        eAnimationEasing["easeInOutExpo"] = "easeInOutExpo";
        eAnimationEasing["easeInCirc"] = "easeInCirc";
        eAnimationEasing["easeOutCirc"] = "easeOutCirc";
        eAnimationEasing["easeInOutCirc"] = "easeInOutCirc";
        eAnimationEasing["easeInElastic"] = "easeInElastic";
        eAnimationEasing["easeOutElastic"] = "easeOutElastic";
        eAnimationEasing["easeInOutElastic"] = "easeInOutElastic";
        eAnimationEasing["easeInBack"] = "easeInBack";
        eAnimationEasing["easeOutBack"] = "easeOutBack";
        eAnimationEasing["easeInOutBack"] = "easeInOutBack";
        eAnimationEasing["easeInBounce"] = "easeInBounce";
        eAnimationEasing["easeOutBounce"] = "easeOutBounce";
        eAnimationEasing["easeInOutBounce"] = "easeInOutBounce";
    })(exports.eAnimationEasing || (exports.eAnimationEasing = {}));
    (function (eQueryMode) {
        eQueryMode["none"] = "none";
        eQueryMode["table"] = "table";
        eQueryMode["database"] = "database";
        eQueryMode["array"] = "array";
        eQueryMode["optionFilter"] = "optionFilter";
        eQueryMode["parentOptionFilter"] = "parentOptionFilter";
    })(exports.eQueryMode || (exports.eQueryMode = {}));
    (function (eOptionFilterSource) {
        eOptionFilterSource["table"] = "table";
        eOptionFilterSource["database"] = "database";
        eOptionFilterSource["query"] = "query";
        eOptionFilterSource["safeFunction"] = "safeFunction";
        eOptionFilterSource["optionFilter"] = "optionFilter";
    })(exports.eOptionFilterSource || (exports.eOptionFilterSource = {}));
    (function (eOutputType) {
        eOutputType["none"] = "none";
        eOutputType["word"] = "word";
        eOutputType["excel"] = "excel";
        eOutputType["image"] = "image";
        eOutputType["solidworks"] = "solidworks";
        eOutputType["inventor"] = "inventor";
        eOutputType["creo"] = "creo";
        eOutputType["creo3"] = "creo3";
        eOutputType["cadDrawing"] = "cadDrawing";
        eOutputType["bom"] = "bom";
        eOutputType["sceneRender"] = "sceneRender";
        eOutputType["pdf"] = "pdf";
        eOutputType["salesforce"] = "salesforce";
        eOutputType["autoCad"] = "autoCad";
        eOutputType["zip"] = "zip";
        eOutputType["svg"] = "svg";
        eOutputType["text"] = "text";
    })(exports.eOutputType || (exports.eOutputType = {}));
    (function (eOutputFieldType) {
        eOutputFieldType["wordText"] = "wordText";
        eOutputFieldType["wordContainer"] = "wordContainer";
        eOutputFieldType["wordImage"] = "wordImage";
        eOutputFieldType["wordList"] = "wordList";
        eOutputFieldType["excelSheet"] = "excelSheet";
        eOutputFieldType["excelCell"] = "excelCell";
        eOutputFieldType["excelImage"] = "excelImage";
        eOutputFieldType["excelTable"] = "excelTable";
        eOutputFieldType["excelChart"] = "excelChart";
        eOutputFieldType["cadReplaceComponent"] = "cadReplaceComponent";
        eOutputFieldType["cadAngleMate"] = "cadAngleMate";
        eOutputFieldType["cadCoincidentMate"] = "cadCoincidentMate";
        eOutputFieldType["cadCoordinateSystemMate"] = "cadCoordinateSystemMate";
        eOutputFieldType["cadDistanceMate"] = "cadDistanceMate";
        eOutputFieldType["cadPositionConstraint"] = "cadPositionConstraint";
        eOutputFieldType["cadDimension"] = "cadDimension";
        eOutputFieldType["cadFeature"] = "cadFeature";
        eOutputFieldType["cadLibFeature"] = "cadLibFeature";
        eOutputFieldType["cadCustomProperty"] = "cadCustomProperty";
        eOutputFieldType["cadComponent"] = "cadComponent";
        eOutputFieldType["cadDrawingView"] = "cadDrawingView";
        eOutputFieldType["cadDrawingSheet"] = "cadDrawingSheet";
        eOutputFieldType["cadDrawingAnnotation"] = "cadDrawingAnnotation";
        eOutputFieldType["cadDynamicDrawingDimension"] = "cadDynamicDrawingDimension";
        eOutputFieldType["cadDynamicDrawingAnnotation"] = "cadDynamicDrawingAnnotation";
        eOutputFieldType["cadDynamicComponent"] = "cadDynamicComponent";
        eOutputFieldType["cadNestedComponent"] = "cadNestedComponent";
        eOutputFieldType["cadScaleFeature"] = "cadScaleFeature";
        eOutputFieldType["cadAnnotation"] = "cadAnnotation";
        eOutputFieldType["cadText"] = "cadText";
        eOutputFieldType["cadParameter"] = "cadParameter";
        eOutputFieldType["cadRepresentation"] = "cadRepresentation";
        eOutputFieldType["cadPoint"] = "cadPoint";
        eOutputFieldType["cadLayer"] = "cadLayer";
        eOutputFieldType["bomMapping"] = "bomMapping";
        eOutputFieldType["salesForceObject"] = "salesForceObject";
        eOutputFieldType["cadDrawingDimension"] = "cadDrawingDimension";
        eOutputFieldType["pdfSection"] = "pdfSection";
        eOutputFieldType["cadLibReference"] = "cadLibReference";
        eOutputFieldType["cadLibDimension"] = "cadLibDimension";
        eOutputFieldType["cadBlock"] = "cadBlock";
        eOutputFieldType["cadBlockArray"] = "cadBlockArray";
        eOutputFieldType["zipSection"] = "zipSection";
    })(exports.eOutputFieldType || (exports.eOutputFieldType = {}));
    (function (eSingleOptionBehavior) {
        eSingleOptionBehavior["nothing"] = "nothing";
        eSingleOptionBehavior["disable"] = "disable";
        eSingleOptionBehavior["hide"] = "hide";
    })(exports.eSingleOptionBehavior || (exports.eSingleOptionBehavior = {}));
    (function (eConfiguratorImageSource) {
        eConfiguratorImageSource["none"] = "none";
        eConfiguratorImageSource["media"] = "media";
        eConfiguratorImageSource["scene"] = "scene";
    })(exports.eConfiguratorImageSource || (exports.eConfiguratorImageSource = {}));
    (function (eTextColor) {
        eTextColor["normal"] = "normal";
        eTextColor["header"] = "header";
        eTextColor["primary"] = "primary";
        eTextColor["accent"] = "accent";
        eTextColor["error"] = "error";
        eTextColor["success"] = "success";
    })(exports.eTextColor || (exports.eTextColor = {}));
    (function (eConfiguratorEntityType) {
        eConfiguratorEntityType["product"] = "product";
        eConfiguratorEntityType["quoteHeader"] = "quoteHeader";
    })(exports.eConfiguratorEntityType || (exports.eConfiguratorEntityType = {}));
    (function (eBackground) {
        eBackground["color"] = "color";
        eBackground["transparent"] = "transparent";
        eBackground["environment"] = "environment";
    })(exports.eBackground || (exports.eBackground = {}));
    (function (eSideOrientation) {
        eSideOrientation["frontSide"] = "frontSide";
        eSideOrientation["backSide"] = "backSide";
        eSideOrientation["doubleSide"] = "doubleSide";
    })(exports.eSideOrientation || (exports.eSideOrientation = {}));
    (function (eUvMode) {
        eUvMode["planar"] = "planar";
        eUvMode["box"] = "box";
        eUvMode["cylindrical"] = "cylindrical";
        eUvMode["spherical"] = "spherical";
        eUvMode["useExisting"] = "useExisting";
    })(exports.eUvMode || (exports.eUvMode = {}));
    (function (eMaterialViewMode) {
        eMaterialViewMode["shaded"] = "shaded";
        eMaterialViewMode["edges"] = "edges";
        eMaterialViewMode["wireframe"] = "wireframe";
    })(exports.eMaterialViewMode || (exports.eMaterialViewMode = {}));
    (function (eMaterialLocation) {
        eMaterialLocation["local"] = "local";
        eMaterialLocation["global"] = "global";
        eMaterialLocation["library"] = "library";
    })(exports.eMaterialLocation || (exports.eMaterialLocation = {}));
    (function (eAlphaMode) {
        eAlphaMode["disable"] = "disable";
        eAlphaMode["add"] = "add";
        eAlphaMode["combine"] = "combine";
        eAlphaMode["subtract"] = "subtract";
        eAlphaMode["multiply"] = "multiply";
    })(exports.eAlphaMode || (exports.eAlphaMode = {}));
    (function (eViewpointType) {
        eViewpointType["orbit"] = "orbit";
        eViewpointType["firstPerson"] = "firstPerson";
        eViewpointType["overhead"] = "overhead";
    })(exports.eViewpointType || (exports.eViewpointType = {}));
    (function (eViewpointProjection) {
        eViewpointProjection["perspective"] = "perspective";
        eViewpointProjection["orthographic"] = "orthographic";
    })(exports.eViewpointProjection || (exports.eViewpointProjection = {}));
    (function (eViewpointTargetMode) {
        eViewpointTargetMode["rotation"] = "rotation";
        eViewpointTargetMode["point"] = "point";
        eViewpointTargetMode["mesh"] = "mesh";
    })(exports.eViewpointTargetMode || (exports.eViewpointTargetMode = {}));
    (function (eConnectorPositionMode) {
        eConnectorPositionMode["boundingBox"] = "boundingBox";
        eConnectorPositionMode["absolute"] = "absolute";
        eConnectorPositionMode["moveAlongSketch"] = "moveAlongSketch";
    })(exports.eConnectorPositionMode || (exports.eConnectorPositionMode = {}));
    (function (eDragMode) {
        eDragMode["plane"] = "plane";
        eDragMode["free"] = "free";
        eDragMode["surface"] = "surface";
    })(exports.eDragMode || (exports.eDragMode = {}));
    (function (eConnectionMode) {
        eConnectionMode["none"] = "none";
        eConnectionMode["world"] = "world";
        eConnectionMode["screen"] = "screen";
    })(exports.eConnectionMode || (exports.eConnectionMode = {}));
    (function (eEasing) {
        eEasing["linear"] = "linear";
        eEasing["quadraticIn"] = "quadraticIn";
        eEasing["quadraticOut"] = "quadraticOut";
        eEasing["quadraticInOut"] = "quadraticInOut";
        eEasing["cubicIn"] = "cubicIn";
        eEasing["cubicOut"] = "cubicOut";
        eEasing["cubicInOut"] = "cubicInOut";
        eEasing["quarticIn"] = "quarticIn";
        eEasing["quarticOut"] = "quarticOut";
        eEasing["quarticInOut"] = "quarticInOut";
        eEasing["quinticIn"] = "quinticIn";
        eEasing["quinticOut"] = "quinticOut";
        eEasing["quinticInOut"] = "quinticInOut";
        eEasing["sinusoidalIn"] = "sinusoidalIn";
        eEasing["sinusoidalOut"] = "sinusoidalOut";
        eEasing["sinusoidalInOut"] = "sinusoidalInOut";
        eEasing["exponentialIn"] = "exponentialIn";
        eEasing["exponentialOut"] = "exponentialOut";
        eEasing["exponentialInOut"] = "exponentialInOut";
        eEasing["circularIn"] = "circularIn";
        eEasing["circularOut"] = "circularOut";
        eEasing["circularInOut"] = "circularInOut";
        eEasing["elasticIn"] = "elasticIn";
        eEasing["elasticOut"] = "elasticOut";
        eEasing["elasticInOut"] = "elasticInOut";
        eEasing["backIn"] = "backIn";
        eEasing["backOut"] = "backOut";
        eEasing["backInOut"] = "backInOut";
        eEasing["bounceIn"] = "bounceIn";
        eEasing["bounceOut"] = "bounceOut";
        eEasing["bounceInOut"] = "bounceInOut";
    })(exports.eEasing || (exports.eEasing = {}));
    (function (eCylinderCap) {
        eCylinderCap["none"] = "none";
        eCylinderCap["start"] = "start";
        eCylinderCap["end"] = "end";
        eCylinderCap["both"] = "both";
    })(exports.eCylinderCap || (exports.eCylinderCap = {}));
    (function (eJoinType) {
        eJoinType["union"] = "union";
        eJoinType["intersect"] = "intersect";
        eJoinType["cut"] = "cut";
    })(exports.eJoinType || (exports.eJoinType = {}));
    (function (eShadowQuality) {
        eShadowQuality["low"] = "low";
        eShadowQuality["medium"] = "medium";
        eShadowQuality["high"] = "high";
    })(exports.eShadowQuality || (exports.eShadowQuality = {}));
    (function (eShadowResolution) {
        eShadowResolution["low"] = "low";
        eShadowResolution["medium"] = "medium";
        eShadowResolution["high"] = "high";
    })(exports.eShadowResolution || (exports.eShadowResolution = {}));
    (function (eShadowFilter) {
        eShadowFilter["none"] = "none";
        eShadowFilter["simple"] = "simple";
        eShadowFilter["advanced"] = "advanced";
    })(exports.eShadowFilter || (exports.eShadowFilter = {}));
    (function (eMaterialWorkflow) {
        eMaterialWorkflow["metallicRoughness"] = "metallicRoughness";
        eMaterialWorkflow["specularGlossiness"] = "specularGlossiness";
    })(exports.eMaterialWorkflow || (exports.eMaterialWorkflow = {}));
    (function (eFeatureCenter) {
        eFeatureCenter["barycenter"] = "barycenter";
        eFeatureCenter["meshPivotPoint"] = "meshPivotPoint";
    })(exports.eFeatureCenter || (exports.eFeatureCenter = {}));
    (function (eJobStatus) {
        eJobStatus["none"] = "none";
        eJobStatus["waiting"] = "waiting";
        eJobStatus["queued"] = "queued";
        eJobStatus["working"] = "working";
        eJobStatus["complete"] = "complete";
        eJobStatus["failed"] = "failed";
    })(exports.eJobStatus || (exports.eJobStatus = {}));
    (function (eJobType) {
        eJobType["build"] = "build";
        eJobType["render"] = "render";
        eJobType["notification"] = "notification";
        eJobType["upsertProductsToSfdc"] = "upsertProductsToSfdc";
        eJobType["pullSfdcProducts"] = "pullSfdcProducts";
        eJobType["submitFromSfdcCpq"] = "submitFromSfdcCpq";
        eJobType["completeBuildState"] = "completeBuildState";
        eJobType["cleanDb"] = "cleanDb";
        eJobType["deployment"] = "deployment";
        eJobType["sceneImport"] = "sceneImport";
        eJobType["sceneExport"] = "sceneExport";
        eJobType["sceneConvert"] = "sceneConvert";
        eJobType["completeQuoteProductBuild"] = "completeQuoteProductBuild";
        eJobType["configuratorExport"] = "configuratorExport";
        eJobType["configuratorImport"] = "configuratorImport";
    })(exports.eJobType || (exports.eJobType = {}));
    (function (eEnvironment) {
        eEnvironment["prod"] = "prod";
        eEnvironment["test"] = "test";
        eEnvironment["dev"] = "dev";
    })(exports.eEnvironment || (exports.eEnvironment = {}));
    (function (eImportType) {
        eImportType["external"] = "external";
        eImportType["kb3d"] = "kb3d";
    })(exports.eImportType || (exports.eImportType = {}));
    (function (eQueueMessageType) {
        eQueueMessageType["builder"] = "builder";
        eQueueMessageType["cleanDb"] = "cleanDb";
        eQueueMessageType["completeBuildState"] = "completeBuildState";
        eQueueMessageType["notification"] = "notification";
        eQueueMessageType["render"] = "render";
        eQueueMessageType["pullSfdcProducts"] = "pullSfdcProducts";
        eQueueMessageType["upsertProductsToSfdc"] = "upsertProductsToSfdc";
        eQueueMessageType["submitFromSfdcCpq"] = "submitFromSfdcCpq";
        eQueueMessageType["deployment"] = "deployment";
        eQueueMessageType["completeQuoteProductBuild"] = "completeQuoteProductBuild";
        eQueueMessageType["sceneImport"] = "sceneImport";
        eQueueMessageType["sceneExport"] = "sceneExport";
        eQueueMessageType["sceneConvert"] = "sceneConvert";
    })(exports.eQueueMessageType || (exports.eQueueMessageType = {}));
    (function (eMateType) {
        eMateType["fastened"] = "fastened";
        eMateType["revolute"] = "revolute";
        eMateType["slider"] = "slider";
        eMateType["planar"] = "planar";
        eMateType["cylindrical"] = "cylindrical";
        eMateType["ball"] = "ball";
        eMateType["parallel"] = "parallel";
    })(exports.eMateType || (exports.eMateType = {}));
    (function (eValidationType) {
        eValidationType["error"] = "error";
        eValidationType["warning"] = "warning";
        eValidationType["info"] = "info";
    })(exports.eValidationType || (exports.eValidationType = {}));
    (function (eValidationSource) {
        eValidationSource["snap"] = "snap";
        eValidationSource["configurator"] = "configurator";
        eValidationSource["scene"] = "scene";
    })(exports.eValidationSource || (exports.eValidationSource = {}));
    (function (eTextureChannel) {
        eTextureChannel["emissive"] = "emissive";
        eTextureChannel["albedo"] = "albedo";
        eTextureChannel["ambient"] = "ambient";
        eTextureChannel["opacity"] = "opacity";
        eTextureChannel["reflection"] = "reflection";
        eTextureChannel["specular"] = "specular";
        eTextureChannel["metallic"] = "metallic";
        eTextureChannel["roughness"] = "roughness";
        eTextureChannel["glossiness"] = "glossiness";
        eTextureChannel["normal"] = "normal";
        eTextureChannel["ambientOcclusion"] = "ambientOcclusion";
        eTextureChannel["anisotropyTangent"] = "anisotropyTangent";
        eTextureChannel["subsurfaceThickness"] = "subsurfaceThickness";
        eTextureChannel["clearCoatNormal"] = "clearCoatNormal";
    })(exports.eTextureChannel || (exports.eTextureChannel = {}));
    (function (eTextureHorizontalAlign) {
        eTextureHorizontalAlign["left"] = "left";
        eTextureHorizontalAlign["center"] = "center";
        eTextureHorizontalAlign["right"] = "right";
    })(exports.eTextureHorizontalAlign || (exports.eTextureHorizontalAlign = {}));
    (function (eTextureVerticalAlign) {
        eTextureVerticalAlign["top"] = "top";
        eTextureVerticalAlign["middle"] = "middle";
        eTextureVerticalAlign["bottom"] = "bottom";
    })(exports.eTextureVerticalAlign || (exports.eTextureVerticalAlign = {}));
    (function (eTextureFit) {
        eTextureFit["none"] = "none";
        eTextureFit["stretch"] = "stretch";
        eTextureFit["contain"] = "contain";
    })(exports.eTextureFit || (exports.eTextureFit = {}));
    (function (eTextureBlendMode) {
        eTextureBlendMode["normal"] = "normal";
        eTextureBlendMode["multiply"] = "multiply";
        eTextureBlendMode["screen"] = "screen";
        eTextureBlendMode["overlay"] = "overlay";
        eTextureBlendMode["darken"] = "darken";
        eTextureBlendMode["lighten"] = "lighten";
        eTextureBlendMode["hue"] = "hue";
        eTextureBlendMode["saturation"] = "saturation";
        eTextureBlendMode["color"] = "color";
        eTextureBlendMode["luminosity"] = "luminosity";
        eTextureBlendMode["difference"] = "difference";
        eTextureBlendMode["mask"] = "mask";
        eTextureBlendMode["vector"] = "vector";
    })(exports.eTextureBlendMode || (exports.eTextureBlendMode = {}));
    (function (eTextureWrapAddressMode) {
        eTextureWrapAddressMode["repeat"] = "repeat";
        eTextureWrapAddressMode["clamp"] = "clamp";
    })(exports.eTextureWrapAddressMode || (exports.eTextureWrapAddressMode = {}));
    (function (eAnnotationLineStyle) {
        eAnnotationLineStyle["solid"] = "solid";
        eAnnotationLineStyle["dashed"] = "dashed";
        eAnnotationLineStyle["dotted"] = "dotted";
        eAnnotationLineStyle["none"] = "none";
    })(exports.eAnnotationLineStyle || (exports.eAnnotationLineStyle = {}));
    (function (eDimensionLineCapStyle) {
        eDimensionLineCapStyle["none"] = "none";
        eDimensionLineCapStyle["arrow"] = "arrow";
        eDimensionLineCapStyle["line"] = "line";
    })(exports.eDimensionLineCapStyle || (exports.eDimensionLineCapStyle = {}));
    (function (eDimensionAxis) {
        eDimensionAxis["free"] = "free";
        eDimensionAxis["x"] = "x";
        eDimensionAxis["y"] = "y";
        eDimensionAxis["z"] = "z";
    })(exports.eDimensionAxis || (exports.eDimensionAxis = {}));
    (function (eLoadingExperience) {
        eLoadingExperience["none"] = "none";
        eLoadingExperience["fade"] = "fade";
        eLoadingExperience["spinner"] = "spinner";
        eLoadingExperience["image"] = "image";
    })(exports.eLoadingExperience || (exports.eLoadingExperience = {}));
    (function (eReflectionType) {
        eReflectionType["plane"] = "plane";
        eReflectionType["probe"] = "probe";
    })(exports.eReflectionType || (exports.eReflectionType = {}));
    (function (eRenderMode) {
        eRenderMode["shaded"] = "shaded";
        eRenderMode["wireframe"] = "wireframe";
        eRenderMode["edge"] = "edge";
        eRenderMode["hiddenEdges"] = "hiddenEdges";
    })(exports.eRenderMode || (exports.eRenderMode = {}));
    (function (eTextureSamplingMode) {
        eTextureSamplingMode["nearest"] = "nearest";
        eTextureSamplingMode["bilinear"] = "bilinear";
        eTextureSamplingMode["trilinear"] = "trilinear";
    })(exports.eTextureSamplingMode || (exports.eTextureSamplingMode = {}));
    (function (eAxis) {
        eAxis["x"] = "x";
        eAxis["y"] = "y";
        eAxis["z"] = "z";
    })(exports.eAxis || (exports.eAxis = {}));
    (function (eSketchPathType) {
        eSketchPathType["points"] = "points";
        eSketchPathType["arcThrough3Points"] = "arcThrough3Points";
        eSketchPathType["centerRadiusCircle"] = "centerRadiusCircle";
        eSketchPathType["catmullRom"] = "catmullRom";
        eSketchPathType["cubicBezier"] = "cubicBezier";
        eSketchPathType["quadraticBezier"] = "quadraticBezier";
        eSketchPathType["hermite"] = "hermite";
    })(exports.eSketchPathType || (exports.eSketchPathType = {}));
    (function (eFilterControl) {
        eFilterControl["none"] = "none";
        eFilterControl["text"] = "text";
        eFilterControl["select"] = "select";
        eFilterControl["multiSelect"] = "multiSelect";
        eFilterControl["dateRange"] = "dateRange";
        eFilterControl["numberRange"] = "numberRange";
        eFilterControl["suggest"] = "suggest";
        eFilterControl["checkbox"] = "checkbox";
    })(exports.eFilterControl || (exports.eFilterControl = {}));
    (function (eFilterSource) {
        eFilterSource["none"] = "none";
        eFilterSource["enum"] = "enum";
        eFilterSource["properties"] = "properties";
        eFilterSource["users"] = "users";
        eFilterSource["states"] = "states";
        eFilterSource["configurators"] = "configurators";
        eFilterSource["fields"] = "fields";
        eFilterSource["customers"] = "customers";
        eFilterSource["roles"] = "roles";
        eFilterSource["productSorts"] = "productSorts";
        eFilterSource["manufacturers"] = "manufacturers";
        eFilterSource["attributes"] = "attributes";
        eFilterSource["suggestContacts"] = "suggestContacts";
        eFilterSource["suggestCustomers"] = "suggestCustomers";
        eFilterSource["suggestQuotes"] = "suggestQuotes";
        eFilterSource["suggestProducts"] = "suggestProducts";
        eFilterSource["headerFields"] = "headerFields";
    })(exports.eFilterSource || (exports.eFilterSource = {}));
    (function (eFilterType) {
        eFilterType["property"] = "property";
        eFilterType["fieldValue"] = "fieldValue";
        eFilterType["sort"] = "sort";
        eFilterType["attribute"] = "attribute";
        eFilterType["headerValue"] = "headerValue";
    })(exports.eFilterType || (exports.eFilterType = {}));
    (function (eFieldType) {
        eFieldType["text"] = "text";
        eFieldType["number"] = "number";
        eFieldType["boolean"] = "boolean";
        eFieldType["color"] = "color";
        eFieldType["date"] = "date";
        eFieldType["upload"] = "upload";
        eFieldType["textArray"] = "textArray";
        eFieldType["numberArray"] = "numberArray";
        eFieldType["colorArray"] = "colorArray";
    })(exports.eFieldType || (exports.eFieldType = {}));

    var _kb3dEnums = /*#__PURE__*/Object.freeze({
        __proto__: null,
        get eContainerItemLayout () { return exports.eContainerItemLayout; },
        get eContainerChildAlignment () { return exports.eContainerChildAlignment; },
        get eContainerItemAlignment () { return exports.eContainerItemAlignment; },
        get eContainerItemJustify () { return exports.eContainerItemJustify; },
        get eScroll () { return exports.eScroll; },
        get eRelativeSize () { return exports.eRelativeSize; },
        get ePadding () { return exports.ePadding; },
        get eColorShade () { return exports.eColorShade; },
        get eBackgroundColor () { return exports.eBackgroundColor; },
        get eElevation () { return exports.eElevation; },
        get eRuleType () { return exports.eRuleType; },
        get eToolbarPosition () { return exports.eToolbarPosition; },
        get eValidationTiming () { return exports.eValidationTiming; },
        get eViewerMode () { return exports.eViewerMode; },
        get ePosition () { return exports.ePosition; },
        get eIconStyle () { return exports.eIconStyle; },
        get eExportType () { return exports.eExportType; },
        get eHotspotSource () { return exports.eHotspotSource; },
        get eHotspotAttach () { return exports.eHotspotAttach; },
        get eHotspotPosition () { return exports.eHotspotPosition; },
        get eHotspotShape () { return exports.eHotspotShape; },
        get eAnimationEasing () { return exports.eAnimationEasing; },
        get eQueryMode () { return exports.eQueryMode; },
        get eOptionFilterSource () { return exports.eOptionFilterSource; },
        get eOutputType () { return exports.eOutputType; },
        get eOutputFieldType () { return exports.eOutputFieldType; },
        get eSingleOptionBehavior () { return exports.eSingleOptionBehavior; },
        get eConfiguratorImageSource () { return exports.eConfiguratorImageSource; },
        get eTextColor () { return exports.eTextColor; },
        get eConfiguratorEntityType () { return exports.eConfiguratorEntityType; },
        get eBackground () { return exports.eBackground; },
        get eSideOrientation () { return exports.eSideOrientation; },
        get eUvMode () { return exports.eUvMode; },
        get eMaterialViewMode () { return exports.eMaterialViewMode; },
        get eMaterialLocation () { return exports.eMaterialLocation; },
        get eAlphaMode () { return exports.eAlphaMode; },
        get eViewpointType () { return exports.eViewpointType; },
        get eViewpointProjection () { return exports.eViewpointProjection; },
        get eViewpointTargetMode () { return exports.eViewpointTargetMode; },
        get eConnectorPositionMode () { return exports.eConnectorPositionMode; },
        get eDragMode () { return exports.eDragMode; },
        get eConnectionMode () { return exports.eConnectionMode; },
        get eEasing () { return exports.eEasing; },
        get eCylinderCap () { return exports.eCylinderCap; },
        get eJoinType () { return exports.eJoinType; },
        get eShadowQuality () { return exports.eShadowQuality; },
        get eShadowResolution () { return exports.eShadowResolution; },
        get eShadowFilter () { return exports.eShadowFilter; },
        get eMaterialWorkflow () { return exports.eMaterialWorkflow; },
        get eFeatureCenter () { return exports.eFeatureCenter; },
        get eJobStatus () { return exports.eJobStatus; },
        get eJobType () { return exports.eJobType; },
        get eEnvironment () { return exports.eEnvironment; },
        get eImportType () { return exports.eImportType; },
        get eQueueMessageType () { return exports.eQueueMessageType; },
        get eMateType () { return exports.eMateType; },
        get eValidationType () { return exports.eValidationType; },
        get eValidationSource () { return exports.eValidationSource; },
        get eTextureChannel () { return exports.eTextureChannel; },
        get eTextureHorizontalAlign () { return exports.eTextureHorizontalAlign; },
        get eTextureVerticalAlign () { return exports.eTextureVerticalAlign; },
        get eTextureFit () { return exports.eTextureFit; },
        get eTextureBlendMode () { return exports.eTextureBlendMode; },
        get eTextureWrapAddressMode () { return exports.eTextureWrapAddressMode; },
        get eAnnotationLineStyle () { return exports.eAnnotationLineStyle; },
        get eDimensionLineCapStyle () { return exports.eDimensionLineCapStyle; },
        get eDimensionAxis () { return exports.eDimensionAxis; },
        get eLoadingExperience () { return exports.eLoadingExperience; },
        get eReflectionType () { return exports.eReflectionType; },
        get eRenderMode () { return exports.eRenderMode; },
        get eTextureSamplingMode () { return exports.eTextureSamplingMode; },
        get eAxis () { return exports.eAxis; },
        get eSketchPathType () { return exports.eSketchPathType; },
        get eFilterControl () { return exports.eFilterControl; },
        get eFilterSource () { return exports.eFilterSource; },
        get eFilterType () { return exports.eFilterType; },
        get eFieldType () { return exports.eFieldType; }
    });

    exports.SketchControlPoint = class SketchControlPoint extends exports.BaseConnector {
        constructor() {
            super(...arguments);
            this.enabled = true; // non-configurable
            this.positionMode = exports.eConnectorPositionMode.absolute;
        }
        getSketch() {
            var _a;
            return (_a = this._parent) === null || _a === void 0 ? void 0 : _a._parent;
        }
        getSpaceParent() {
            return this.getSketch();
        }
        getAncestors() {
            return super.getAncestors();
        }
    };
    exports.SketchControlPoint = __decorate([
        Kb3dModel({
            token: Token.SketchControlPoint,
        })
    ], exports.SketchControlPoint);

    exports.UvMapFeature = class UvMapFeature extends exports.Feature {
        constructor() {
            var _a;
            super(...arguments);
            this.worldPosition = (_a = this._parent) === null || _a === void 0 ? void 0 : _a.position;
        }
    };
    exports.UvMapFeature._affects = new Set(ALL_GEOMETRY);
    exports.UvMapFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.UvMapFeature = __decorate([
        Kb3dModel({
            token: Token.UvMapFeature,
        })
    ], exports.UvMapFeature);

    exports.SubmeshFeature = class SubmeshFeature extends exports.UvMapFeature {
        constructor() {
            super(...arguments);
            this.vertexGroups = [];
        }
    };
    exports.SubmeshFeature._dependsOn = new Set([exports.eMeshChangeTypes.VertexIndices]);
    exports.SubmeshFeature._affects = new Set(ALL_GEOMETRY);
    exports.SubmeshFeature._affectedBy = new Set(ALL_GEOMETRY);
    exports.SubmeshFeature = __decorate([
        Kb3dModel({
            token: Token.SubmeshFeature,
        })
    ], exports.SubmeshFeature);
    function isSubmesh(o) {
        return instanceOf(o, Token.SubmeshFeature);
    }

    exports.SweepFeature = class SweepFeature extends exports.ExtrudeFeature {
        constructor() {
            super(...arguments);
            this.size = 0;
        }
    };
    exports.SweepFeature._affects = new Set(ALL_GEOMETRY);
    exports.SweepFeature._affectedBy = new Set([...ALL_GEOMETRY, exports.eMeshChangeTypes.Transform]);
    __decorate([
        NodeReference(exports.BaseConnector)
    ], exports.SweepFeature.prototype, "start", void 0);
    __decorate([
        NodeReference(exports.BaseConnector)
    ], exports.SweepFeature.prototype, "end", void 0);
    __decorate([
        NodeReference(exports.SketchNode)
    ], exports.SweepFeature.prototype, "path", void 0);
    exports.SweepFeature = __decorate([
        Kb3dModel({
            token: Token.SweepFeature,
        })
    ], exports.SweepFeature);

    exports.TransformFeature = class TransformFeature extends exports.Feature {
    };
    exports.TransformFeature._affectedBy = new Set([exports.eMeshChangeTypes.Transform, exports.eMeshChangeTypes.VertexPositions]);
    exports.TransformFeature._affects = new Set([exports.eMeshChangeTypes.VertexPositions]);
    exports.TransformFeature = __decorate([
        Kb3dModel({
            token: Token.TransformFeature,
        })
    ], exports.TransformFeature);

    exports.WeldVerticesFeature = class WeldVerticesFeature extends exports.Feature {
        get vertexIndices() {
            if (!this._vertexIndices)
                this._vertexIndices = [];
            return this._vertexIndices;
        }
        set vertexIndices(val) {
            this._vertexIndices = val;
        }
    };
    exports.WeldVerticesFeature._dependsOn = new Set([exports.eMeshChangeTypes.VertexIndices]);
    exports.WeldVerticesFeature._affectedBy = new Set([exports.eMeshChangeTypes.VertexPositions, exports.eMeshChangeTypes.VertexIndices]);
    exports.WeldVerticesFeature._affects = new Set([
        exports.eMeshChangeTypes.VertexPositions,
        exports.eMeshChangeTypes.VertexIndices,
        exports.eMeshChangeTypes.VertexUvs,
        exports.eMeshChangeTypes.VertexNormals,
        exports.eMeshChangeTypes.Submeshes,
    ]);
    __decorate([
        IgnoreChanges
    ], exports.WeldVerticesFeature.prototype, "_vertexIndices", void 0);
    __decorate([
        Enumerable()
    ], exports.WeldVerticesFeature.prototype, "vertexIndices", null);
    exports.WeldVerticesFeature = __decorate([
        Kb3dModel({
            token: Token.WeldVerticesFeature,
        })
    ], exports.WeldVerticesFeature);

    exports.AnnotationNode = class AnnotationNode extends exports.Kb3dObject {
        constructor() {
            super();
            this.label = '';
            this.preloadFontStylesheet = '';
        }
    };
    __decorate([
        NodeReference(exports.Connector, 'position', 'direction', 'angle')
    ], exports.AnnotationNode.prototype, "targetId", void 0);
    exports.AnnotationNode = __decorate([
        Kb3dModel({
            token: Token.AnnotationNode,
        })
    ], exports.AnnotationNode);
    function isAnnotation(node) {
        return instanceOfAny(node, Token.AnnotationNode, Token.DimensionNode);
    }

    exports.DimensionNode = class DimensionNode extends exports.AnnotationNode {
        constructor() {
            super();
        }
    };
    __decorate([
        NodeReference(exports.Connector, 'position')
    ], exports.DimensionNode.prototype, "target2Id", void 0);
    exports.DimensionNode = __decorate([
        Kb3dModel({
            token: Token.DimensionNode,
        })
    ], exports.DimensionNode);

    (function (eHandler) {
        eHandler["click"] = "click";
        eHandler["doubleClick"] = "doubleClick";
        eHandler["draggable"] = "draggable";
        eHandler["hotspot"] = "hotspot";
        eHandler["boundingBox"] = "boundingBox";
    })(exports.eHandler || (exports.eHandler = {}));
    /** A 2 layer map that stores values by a key 1st, then a 2nd level of a string tag, then an array of values */
    class TagArrayMap {
        constructor() {
            this._db = new Map();
        }
        get(key, tag) {
            var _a;
            const v = (_a = this._db.get(key)) === null || _a === void 0 ? void 0 : _a.get(tag);
            return v || [];
        }
        deleteByKeyValue(key, value) {
            const e = this._db.get(key);
            if (e) {
                for (const values of e.values()) {
                    values.removeWhere(v => v == value);
                }
                this.deleteEntryIfEmpty(key);
            }
        }
        getByKey(key) {
            if (this._db.has(key)) {
                return this._db.get(key).all();
            }
            return [];
        }
        set(key, tag, value) {
            var _a;
            if (!this._db.has(key))
                this._db.set(key, new ArrayMap());
            (_a = this._db.get(key)) === null || _a === void 0 ? void 0 : _a.add(tag, value);
        }
        deleteByTag(...tags) {
            const result = [];
            for (const [key, value] of this._db.entries()) {
                const nodeResult = {};
                result.push({ node: key, handlers: nodeResult });
                for (const tag of tags) {
                    const handler = value.get(tag);
                    if (handler) {
                        nodeResult[tag] = handler;
                    }
                    value.delete(tag);
                }
                this.deleteEntryIfEmpty(key);
            }
            return result;
        }
        delete(key, tag) {
            const e = this._db.get(key);
            if (e) {
                const result = e.get(tag);
                e.delete(tag);
                this.deleteEntryIfEmpty(key);
                return result;
            }
            return [];
        }
        deleteByKey(key) {
            const handlers = this._db.get(key);
            const result = {};
            if (handlers) {
                handlers.forEach((value, key) => {
                    result[key] = value;
                });
            }
            this._db.delete(key);
            return result;
        }
        clear() {
            this._db.clear();
        }
        has(key, tag) {
            return this.get(key, tag).length > 0;
        }
        deleteEntryIfEmpty(key) {
            const e = this._db.get(key);
            if (e && !e.size)
                this._db.delete(key);
        }
    }
    class ArrayMap extends Map {
        get(key) {
            return super.get(key) || [];
        }
        add(key, ...values) {
            if (!this.has(key)) {
                super.set(key, [...values]);
            }
            else {
                this.get(key).push(...values);
            }
        }
        removeValue(key, ...values) {
            const arr = super.get(key);
            if (arr) {
                arr.removeWhere(i => values.some(v => v == i));
            }
        }
        all() {
            return [...this.values()].flat();
        }
    }
    class SetMap extends Map {
        get(key) {
            const set = super.get(key);
            if (!set)
                super.set(key, new Set());
            return super.get(key);
        }
        add(key, ...values) {
            const s = this.get(key);
            for (const v of values)
                s.add(v);
        }
        removeValue(key, ...values) {
            const s = super.get(key);
            if (s) {
                for (const v of values)
                    s.delete(v);
            }
        }
        all() {
            return [...this.values()].flat();
        }
    }
    class HandlerMap extends TagArrayMap {
        constructor(manager) {
            super();
            this.manager = manager;
        }
        add(idNameOrNode, tag, handler) {
            let nodes = new Array();
            if (typeof idNameOrNode == 'string') {
                nodes = this.manager.getNodesByIdOrName(idNameOrNode, true);
            }
            else {
                nodes.push(idNameOrNode);
            }
            for (const n of nodes) {
                if (isPickable(n)) {
                    this.set(n, tag, handler);
                }
            }
        }
    }

    exports.ImportInfo = class ImportInfo {
    };
    exports.ImportInfo = __decorate([
        Kb3dModel({
            token: Token.ImportInfo,
            trackChanges: false,
        })
    ], exports.ImportInfo);

    const fontFilesLoading = new Map();
    const stylesheetsLoading = new Map();
    const fontFamilySrcs = new Map();
    class FontService {
        constructor(httpService, assetRoot = '') {
            this.httpService = httpService;
            this.assetRoot = assetRoot;
            /** Can be both the font face name as well as the font file URL */
            this.readyFonts = new Map();
        }
        loadFont(stylesheetUrl, fontFamilies) {
            const fontFaceSet = document.fonts;
            if (typeof fontFaceSet === 'undefined') {
                return Promise.reject('FontFaceSet api not available');
            }
            return this.loadStylesheet(stylesheetUrl).then(() => this.loadFontFamily(fontFaceSet, fontFamilies));
        }
        loadFontByFile(path) {
            const absPath = isAbsoluteUrl(path) ? path : this.getAbsoluteFontPath(path);
            let loadPromise;
            if (fontFilesLoading.has(absPath)) {
                loadPromise = fontFilesLoading.get(absPath);
            }
            else {
                const promise = this.httpService.getPublicStatic(absPath, 'arraybuffer');
                fontFilesLoading.set(absPath, promise);
                loadPromise = promise;
            }
            return loadPromise.then(buffer => {
                if (buffer.byteLength === 0) {
                    return Promise.reject('Could not fetch font');
                }
                else {
                    this.readyFonts.set(path, buffer);
                }
                return buffer;
            });
        }
        loadFontData(stylesheetUrl, fontFamilies) {
            return this.loadStylesheet(stylesheetUrl).then(() => this.getFontData(fontFamilies));
        }
        getAbsoluteFontPath(relativePath) {
            return `${this.assetRoot}/media/${relativePath}`; //it's a relative path to the media folder
        }
        loadStylesheet(stylesheetUrl) {
            let stylesheetLoad = stylesheetsLoading.get(stylesheetUrl);
            if (!stylesheetLoad) {
                stylesheetLoad = this.httpService.getPublicStatic(stylesheetUrl).then(res => {
                    // Parse the css and store the srcs to the font files
                    const fontFaces = res.matchAll(/@font-face\s*{([\s\S]*?)}/gm);
                    for (const face of fontFaces) {
                        const fontFamilyMatch = face[1].match(/font-family\s*:\s*['"]?(.*?)['"]?[;,\n]/m);
                        if (fontFamilyMatch) {
                            const fontFamilyName = fontFamilyMatch[1];
                            const srcMatch = face[1].match(/src\s*:.*?url\s*\([\s"']*(.*?)[\s"']*\)/m);
                            if (srcMatch) {
                                const fontSrc = srcMatch[1];
                                fontFamilySrcs.set(fontFamilyName.trim().toLowerCase(), fontSrc.trim());
                            }
                        }
                    }
                });
                stylesheetsLoading.set(stylesheetUrl, stylesheetLoad);
            }
            return stylesheetLoad;
        }
        getFontData(fontFamilies) {
            const loadFaces = [];
            const loadPromises = [];
            fontFamilies.forEach(fontFamily => {
                const fontSrc = fontFamilySrcs.get(fontFamily.trim().toLowerCase());
                if (!fontSrc) {
                    console.warn(`Font family ${fontFamily} not found. Is it being loaded by the preloaded stylesheet?`);
                }
                else if (fontFilesLoading.has(fontFamily)) {
                    loadPromises.push(fontFilesLoading.get(fontFamily));
                    loadFaces.push(fontFamily);
                }
                else {
                    const promise = this.httpService.getPublicStatic(fontSrc, 'arraybuffer');
                    fontFilesLoading.set(fontFamily, promise);
                    loadPromises.push(promise);
                    loadFaces.push(fontFamily);
                }
            });
            const resMap = {};
            return Promise.all(loadPromises).then(buffers => {
                buffers.forEach((buffer, index) => {
                    resMap[loadFaces[index]] = buffer;
                    this.readyFonts.set(loadFaces[index], buffer);
                });
                return resMap;
            });
        }
        loadFontFamily(fontFaceSet, fontFamilies) {
            return this.getFontData(fontFamilies).then(resultData => {
                const resultFonts = [];
                fontFamilies.forEach(fontFamily => {
                    if (resultData[fontFamily]) {
                        const newFontFace = new FontFace(fontFamily, resultData[fontFamily]);
                        // @ts-expect-error TS 5.1.6 definition does not include add on FontFaceSet
                        fontFaceSet.add(newFontFace);
                        resultFonts.push(newFontFace);
                    }
                    else {
                        console.warn('Could not load font ' + fontFamily);
                    }
                });
                return resultFonts;
            });
        }
    }

    (function (eContentType) {
        eContentType["json"] = "application/json";
        eContentType["formData"] = "multipart/form-data";
    })(exports.eContentType || (exports.eContentType = {}));
    const ABORTED = 'ABORTED';
    class HttpService {
        constructor(environment) {
            this.environment = environment;
            this.trackedAssetCalls = new Array();
            this.deferredAssetCalls = new Array();
            this.httpCallsToAbort = new Map();
            this.deferredExecuted = false;
        }
        addCacheParams(url) {
            return this.getUrlWithParams(url, this.getEnvironmentCacheParams());
        }
        get(url, params, trackAssetCall = true) {
            if (!isAbsoluteUrl(url) && this.environment) {
                // api calls in the test and prod environments should send the last deploy,
                // which allows the browser cache to store results for some calls
                if (this.environment) {
                    const addParams = this.getEnvironmentCacheParams();
                    params = params ? { ...params, ...addParams } : addParams;
                }
            }
            const u = this.getUrlWithParams(url, params);
            const p = this.fetchWrapper(u, 'GET');
            if (trackAssetCall) {
                this.trackAssetCall(p);
            }
            return p;
        }
        getPublicStatic(url, type = 'text', params, trackAssetCall = true) {
            const u = this.getUrlWithParams(url, params);
            const requestInit = {
                method: 'GET',
                credentials: 'omit',
            };
            const p = fetch(u, requestInit).then(res => {
                if (type === 'text') {
                    return res.text();
                }
                else if (type === 'blob') {
                    return res.blob();
                }
                else if (type === 'arraybuffer') {
                    return res.arrayBuffer();
                }
                else {
                    return res.json();
                }
            });
            if (trackAssetCall) {
                this.trackAssetCall(p);
            }
            return p;
        }
        post(url, body, contentType = exports.eContentType.json) {
            return this.fetchWrapper(url, 'POST', body, contentType);
        }
        put(url, body, contentType = exports.eContentType.json) {
            return this.fetchWrapper(url, 'PUT', body, contentType);
        }
        delete(url, params) {
            const u = this.getUrlWithParams(url, params);
            return this.fetchWrapper(u, 'DELETE');
        }
        getBinary(url, responseType, trackAssetCall, appendCacheParameters = false, abortSubject) {
            const xhr = new XMLHttpRequest();
            if (appendCacheParameters && !isAbsoluteUrl(url) && this.environment) {
                if (this.environment) {
                    const addParams = this.getEnvironmentCacheParams();
                    url = this.getUrlWithParams(url, addParams);
                }
            }
            const abortSub = abortSubject === null || abortSubject === void 0 ? void 0 : abortSubject.subscribe(() => {
                xhr.abort();
            });
            const p = new Promise((resolve, reject) => {
                xhr.open('GET', url, true);
                xhr.responseType = responseType;
                xhr.onload = function (oEvent) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        const allHeaders = xhr.getAllResponseHeaders();
                        let height = null, width = null;
                        if (allHeaders.match(/Original-Height/i)) {
                            height = xhr.getResponseHeader('X-Original-Height');
                            width = xhr.getResponseHeader('X-Original-Width');
                        }
                        const response = {
                            data: xhr.response,
                        };
                        if (height && width) {
                            response.height = parseInt(height);
                            response.width = parseInt(width);
                        }
                        resolve(response);
                    }
                    else {
                        reject(xhr.statusText);
                    }
                    abortSub === null || abortSub === void 0 ? void 0 : abortSub.unsubscribe();
                };
                xhr.onerror = e => {
                    reject(e);
                    abortSub === null || abortSub === void 0 ? void 0 : abortSub.unsubscribe();
                };
                xhr.onabort = () => {
                    reject(ABORTED);
                    // do nothing
                };
                xhr.send(null);
            });
            if (trackAssetCall) {
                this.trackAssetCall(p);
            }
            return p;
        }
        /**
         * delays execution of parameter function until all blocking assets have been loaded for the scene.
         * executes immediately if scene is already loaded.
         */
        defer(func, priority = 100) {
            if (this.deferredExecuted) {
                return func();
            }
            else {
                return new Promise((resolve, reject) => {
                    this.deferredAssetCalls.push({ func, resolve, reject, priority });
                });
            }
        }
        executeDeferredCalls() {
            this.deferredAssetCalls.sort((a, b) => a.priority - b.priority);
            for (const call of this.deferredAssetCalls) {
                call.func().then(call.resolve).catch(call.reject);
            }
            this.deferredAssetCalls = [];
            this.deferredExecuted = true;
        }
        trackAssetCall(p) {
            const trackedPromise = p.finally(() => {
                this.trackedAssetCalls.remove(trackedPromise);
            });
            this.trackedAssetCalls.push(trackedPromise);
        }
        getEnvironmentCacheParams() {
            if (this.environment) {
                const params = {};
                if (this.environment.lastDeploy) {
                    params.d = this.environment.lastDeploy.toString();
                }
                if (this.environment.cacheBuster) {
                    params.v = this.environment.cacheBuster;
                }
                return params;
            }
            return {};
        }
        getUrlWithParams(url, params) {
            if (!params)
                return url;
            const urlParams = new URLSearchParams(Object.entries(params));
            let prefix = '?';
            if (url.match(/\?/)) {
                prefix = '&';
            }
            return `${url}${prefix}${urlParams.toString()}`;
        }
        fetchWrapper(url, method, body, contentType = exports.eContentType.json) {
            const headers = new Headers();
            const requestInit = {
                method,
                headers,
                credentials: 'include',
            };
            if (method.equalsAny('POST', 'PUT')) {
                if (contentType == exports.eContentType.json) {
                    headers.append('Content-Type', contentType);
                    requestInit.body = JSON.stringify(body);
                }
                else if (contentType == exports.eContentType.formData) {
                    requestInit.body = body;
                }
            }
            const p = fetch(url, requestInit).then(r => {
                if (r.ok) {
                    return r.json().catch(() => body);
                }
                else {
                    throw new Error(JSON.stringify(r));
                }
            });
            return p;
        }
    }

    const MOBILE_WIDTH = 847;
    function isMobile() {
        return window != null && window.innerWidth < MOBILE_WIDTH;
    }

    function getRotatedDimensions(width, height, rAngle) {
        const rad = (rAngle * Math.PI) / 180;
        return {
            width: width * Math.cos(rad) + height * Math.sin(rad),
            height: width * Math.sin(rad) + height * Math.cos(rad),
        };
    }
    function scaleImagePreserveAspect(targetWidth, targetHeight, naturalWidth, naturalHeight) {
        let drawWidth, drawHeight;
        const imageWidth = naturalWidth || 256;
        const imageHeight = naturalHeight || 256;
        if (imageWidth > imageHeight) {
            drawWidth = targetWidth;
            drawHeight = (imageHeight / imageWidth) * targetWidth;
        }
        else {
            drawWidth = (imageWidth / imageHeight) * targetHeight;
            drawHeight = targetHeight;
        }
        return {
            drawWidth: Math.ceil(drawWidth),
            drawHeight: Math.ceil(drawHeight),
        };
    }
    function getBinClampedSize(width, height, rounding = 'floor') {
        if (rounding === 'floor') {
            const log2 = Math.min(Math.log2(width), Math.log2(height));
            return Math.pow(2, Math.floor(log2));
        }
        else {
            const log2 = Math.max(Math.log2(width), Math.log2(height));
            return Math.pow(2, Math.ceil(log2));
        }
    }
    function isIOS() {
        // return true;
        const iosQuirkPresent = function () {
            const audio = new Audio();
            audio.volume = 0.5;
            return audio.volume === 1; // volume cannot be changed from "1" on iOS 12 and below
        };
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const isAppleDevice = navigator.userAgent.includes('Macintosh');
        const isTouchScreen = navigator.maxTouchPoints >= 1; // true for iOS 13 (and hopefully beyond)
        return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
    }

    const KBMAXPREFIX = '____kbm____';
    const LOCAL_ENVIRONMENT_DOMAIN = 'library://';

    const SLOW_NETWORK_THRESHOLD = 100; // kB per second
    let slowWarningThrown = false;
    function attachLoadingTimer(p) {
        const startTime = performance.now();
        p.then(result => {
            if (slowWarningThrown) {
                return;
            }
            let fileSize = 0;
            const endTime = performance.now();
            if ('byteLength' in result.data) {
                fileSize = result.data.byteLength;
            }
            else if ('size' in result.data) {
                fileSize = result.data.size;
            }
            if (startTime && endTime && fileSize > 50000) {
                const resultTime = endTime - startTime; // in milliseconds
                // if download speed is less than 100 kB per second, throw slow loading warning
                if (fileSize / resultTime < SLOW_NETWORK_THRESHOLD) {
                    console.warn('Slow network detected. Scene experience may be degraded.');
                    slowWarningThrown = true;
                }
            }
        }).catch(() => {
            // Do nothing
        });
        return p;
    }

    const LIBRARY_PATH = '%LIBRARY%';
    // If this is a raster image, we store the bitmap. If this is an SVG, then we store the blob so it can be resized efficiently
    const textureCache = new Map();
    const materialCache = new Map();
    const TEXTURE_SIZES = [128, 256, 512, 1024, 2048, null];
    const LIBRARY_TEXTURE_SIZES = [256, 256, 512, 1024, 2048, 2048];
    const LIBRARY_ENV_SIZES = [128, 256, 512, 1024];
    const LIBRARY_MOBILE_ENV_SIZES = [128, 128, 256, 512];
    const MAX_DETAIL_LEVEL = 5;
    exports.MaterialService = class MaterialService {
        constructor(httpService, assetRoot, forceFullSizeTextures = false) {
            this.httpService = httpService;
            this.assetRoot = assetRoot;
            this.forceFullSizeTextures = forceFullSizeTextures;
            this.trackedAssetCalls = new Array();
            this.materialUpdateChannel = new Map();
            this.abortSubjects = new Map();
            this.textureDetailLevel = MAX_DETAIL_LEVEL;
            if (forceFullSizeTextures) {
                this.textureDetailLevel = -1;
            }
            else if (window.screen.width <= 1024 || window.screen.height <= 1024) {
                this.textureDetailLevel = 2;
            }
        }
        getMaterialLibraryCategories() {
            const categoryIds = Object.keys(materialDefinitionSet);
            return categoryIds.map(id => ({
                id,
                label: materialDefinitionSet[id].label,
            }));
        }
        getMaterialLibraryOptions(category) {
            return LibraryMaterialsByCategory.get(category) || [];
        }
        getMaterialById(guid) {
            if (materialCache.has(guid)) {
                return materialCache.get(guid);
            }
            else {
                let obs;
                const material = LibraryMaterials.get(guid);
                if (material) {
                    //it's a library  material
                    obs = of(material
                    //asapScheduler
                    );
                }
                else {
                    //maybe a global material
                    obs = from(this.httpService.get(`/api/materials/${guid}`));
                }
                const updateChannel = new BehaviorSubject(null);
                this.materialUpdateChannel.set(guid, updateChannel);
                obs = combineLatest([obs, updateChannel])
                    .pipe(map(([material, updatedMaterial]) => {
                    if (!material) {
                        return undefined;
                    }
                    return { ...material, ...(updatedMaterial || {}) };
                }))
                    .pipe(shareReplay(1));
                materialCache.set(guid, obs);
                return obs;
            }
        }
        getTexturePath(node, detailLevel) {
            let width = null;
            let height = null;
            if (!node.path) {
                return '';
            }
            if (detailLevel === undefined) {
                detailLevel = this.textureDetailLevel;
            }
            detailLevel = Math.min(MAX_DETAIL_LEVEL, detailLevel);
            if (node.path.startsWith(LIBRARY_PATH)) {
                return this.getLibraryTexturePath(node.path, detailLevel);
            }
            else if (!isAbsoluteUrl(node.path)) {
                const url = this.getAbsoluteTexturePath(node.path);
                if (detailLevel >= 0) {
                    width = TEXTURE_SIZES[detailLevel];
                }
                if (detailLevel >= 0) {
                    height = TEXTURE_SIZES[detailLevel];
                }
                const params = [];
                if (width != null)
                    params.push(`width=${width}`);
                if (height != null)
                    params.push(`height=${height}`);
                if (params.length > 0) {
                    return url + '?' + params.join('&');
                }
                else {
                    return url;
                }
            }
            else {
                return node.path;
            }
        }
        getTextureImage(node, trackAssetCall = true) {
            const initialUrl = this.getTexturePath(node, 0);
            const url = this.getTexturePath(node);
            let bitmapObs;
            if (textureCache.has(url)) {
                bitmapObs = textureCache.get(url);
            }
            else {
                bitmapObs = new Observable(subject => {
                    const activeLinkAbort = this.abortSubjects.get(node._dynamicId);
                    // if there already is an httpService call on this node. Abort the previous one
                    if (activeLinkAbort) {
                        activeLinkAbort.next();
                    }
                    const abortTextureLoad = new Subject();
                    this.abortSubjects.set(node._dynamicId, abortTextureLoad);
                    // Textures are absolute so we have to add the cache params before passing to http service
                    // With this code library textures are always progressively loaded regardless of the scene setting because they do not have a root scene
                    // revisit this if we want to change this behavior but it is non-trivial to do so
                    if (this.forceFullSizeTextures || (node._rootScene && !node._rootScene.progressiveTextureLoad)) {
                        const cacheParamUrl = this.assetRoot && url.startsWith(this.assetRoot) ? this.httpService.addCacheParams(url) : url;
                        attachLoadingTimer(this.httpService.getBinary(cacheParamUrl, 'blob', false, true, abortTextureLoad)).then(blobResult => {
                            // clear the abort once the full image is loaded
                            const activeLinkAbort = this.abortSubjects.get(node._dynamicId);
                            if (activeLinkAbort) {
                                activeLinkAbort.complete();
                                this.abortSubjects.delete(node._dynamicId);
                            }
                            processImageBlob(blobResult).then(result => {
                                if (result) {
                                    subject.next({ bitmap: result, url: cacheParamUrl });
                                    subject.complete();
                                }
                            });
                        }, err => {
                            if (err !== ABORTED) {
                                console.warn(`Could not load texture ${cacheParamUrl}: ` + err.toString());
                            }
                            subject.complete();
                        });
                    }
                    else {
                        const initialCacheParamUrl = this.assetRoot && url.startsWith(this.assetRoot)
                            ? this.httpService.addCacheParams(initialUrl)
                            : initialUrl;
                        const loadStartTime = performance.now();
                        attachLoadingTimer(this.httpService.getBinary(initialCacheParamUrl, 'blob', false, true, abortTextureLoad)).then(initialBlobResult => {
                            processImageBlob(initialBlobResult).then(result => {
                                const loadTime = performance.now() - loadStartTime;
                                if (loadTime > 2000) {
                                    console.warn(`Texture ${initialCacheParamUrl} took ${loadTime}ms to load`);
                                }
                                if (result) {
                                    subject.next({ bitmap: result, url: initialCacheParamUrl });
                                }
                                const cacheParamUrl = this.assetRoot && url.startsWith(this.assetRoot)
                                    ? this.httpService.addCacheParams(url)
                                    : url;
                                this.httpService
                                    .defer(() => this.httpService.getBinary(cacheParamUrl, 'blob', false, true, abortTextureLoad))
                                    .then(blobResult => {
                                    // clear the abort once the full image is loaded
                                    const activeLinkAbort = this.abortSubjects.get(node._dynamicId);
                                    if (activeLinkAbort) {
                                        activeLinkAbort.complete();
                                        this.abortSubjects.delete(node._dynamicId);
                                    }
                                    processImageBlob(blobResult).then(result => {
                                        if (result) {
                                            subject.next({ bitmap: result, url: cacheParamUrl });
                                            subject.complete();
                                        }
                                    });
                                }, err => {
                                    if (err !== ABORTED) {
                                        console.warn(`Could not load texture ${cacheParamUrl}: ` + err.toString());
                                    }
                                    subject.complete();
                                });
                            });
                        }, err => {
                            if (err !== ABORTED) {
                                console.warn(`Could not load texture ${initialCacheParamUrl}: ` + err.toString());
                            }
                            subject.complete();
                        });
                    }
                }).pipe(shareReplay(1));
            }
            function processImageBlob(blob) {
                if (blob && blob.data) {
                    if (blob.data.type === 'image/svg+xml') {
                        return Promise.resolve(blob.data);
                    }
                    else {
                        if (blob.data.type.match(/image/)) {
                            const opts = blob.width && blob.height
                                ? {
                                    resizeWidth: blob.width,
                                    resizeHeight: blob.height,
                                    resizeQuality: 'medium',
                                }
                                : undefined;
                            return createImageBitmap(blob.data, opts).then(bitmap => {
                                return Promise.resolve(bitmap);
                            });
                        }
                        else {
                            console.warn('source file is not an image: ', url);
                        }
                    }
                }
                return Promise.resolve(null);
            }
            textureCache.set(url, bitmapObs);
            const obs = bitmapObs.pipe(switchMap(res => {
                /** bitmap is returned as blob for SVGs and imageBitmap for raster images */
                if (res.bitmap instanceof Blob) {
                    const blobToConvert = res.bitmap;
                    return new Promise((resolve, reject) => {
                        const imageElement = document.createElement('img');
                        const blobUrl = URL.createObjectURL(blobToConvert);
                        imageElement.onload = () => {
                            // Figure out what resolution to actually draw the SVG at to fit within the envelope
                            const scaled = scaleImagePreserveAspect(node.width, node.height, imageElement.naturalWidth, imageElement.naturalHeight);
                            createImageBitmap(imageElement, {
                                resizeWidth: scaled.drawWidth,
                                resizeHeight: scaled.drawHeight,
                            }).then(bitmap => {
                                resolve({ bitmap: bitmap, url: res.url });
                            });
                        };
                        imageElement.onerror = e => {
                            reject(e);
                        };
                        imageElement.src = blobUrl;
                    });
                }
                else {
                    return of({ bitmap: res.bitmap, url: res.url });
                }
            }));
            if (trackAssetCall) {
                this.trackAssetCall(obs.pipe(take(1)).toPromise());
            }
            return obs;
        }
        getLibraryTexturePath(relativePath, quality = 0) {
            const path = relativePath.substring(LIBRARY_PATH.length);
            let res;
            if (quality < 0) {
                res = LIBRARY_TEXTURE_SIZES[LIBRARY_TEXTURE_SIZES.length - 1];
            }
            else {
                res = LIBRARY_TEXTURE_SIZES[quality];
            }
            return `${this.assetRoot}/assets/textures/${path}_${res}.jpg`;
        }
        getAbsoluteTexturePath(relativePath) {
            return `${this.assetRoot}/media/${relativePath}`; //it's a relative path to the media folder
        }
        getAbsoluteEnvironmentPath(path, quality) {
            if (path) {
                let url;
                if (path.startsWith(LOCAL_ENVIRONMENT_DOMAIN)) {
                    const res = isMobile() ? LIBRARY_MOBILE_ENV_SIZES[quality] : LIBRARY_ENV_SIZES[quality];
                    url = `${this.assetRoot}/assets/environments/${path.replace(LOCAL_ENVIRONMENT_DOMAIN, '')}_${res}.env`;
                }
                else {
                    url = this.getAbsoluteTexturePath(path);
                }
                return this.httpService.addCacheParams(url);
            }
            return '';
        }
        searchMaterialByName(name, loadArchivedMaterials) {
            var _a;
            const archivedFilter = { type: 'property', property: 'archived', values: [false] };
            const searchArgs = { query: name + '*', sortField: 'Name', filters: [], descending: false };
            if (!loadArchivedMaterials) {
                (_a = searchArgs.filters) === null || _a === void 0 ? void 0 : _a.push(archivedFilter);
            }
            let result = null;
            if (name) {
                result = this.httpService.post('/api/materials/search', searchArgs);
            }
            return result;
        }
        getMaterialNameList() {
            const archivedFilter = { type: 'property', property: 'archived', values: [false] };
            const searchArgs = { fields: ['Guid', 'Name'], take: 10000, filters: [archivedFilter] };
            return this.httpService.post('/api/materials/search', searchArgs);
        }
        setMaterialCache(guid, mat) {
            materialCache.set(guid, of(mat));
        }
        trackAssetCall(p) {
            const trackedPromise = p.finally(() => {
                this.trackedAssetCalls.remove(trackedPromise);
            });
            this.trackedAssetCalls.push(trackedPromise);
        }
    };
    exports.MaterialService = __decorate([
        Kb3dService({
            token: Token.MaterialService,
        })
    ], exports.MaterialService);
    const LibraryMaterials = new Map();
    const LibraryMaterialsByCategory = new Map();
    const LibraryEnvironments = new Array();
    const LibraryEnvironmentsMap = new Map();
    function makeLibraryMaterial(tag, index) {
        //pad the index string with zeros
        let indexStr = index + '';
        while (indexStr.length < 2)
            indexStr = '0' + indexStr;
        const iname = tag + indexStr;
        const baseUrl = `${tag}/${iname}`;
        return {
            id: -1,
            name: iname,
            guid: iname,
            tags: [{ name: tag }],
            data: {
                $type: Token.AdvancedMaterialNode.key,
                name: iname,
                id: iname,
                location: exports.eMaterialLocation.library,
                textures: [
                    {
                        $type: 'FileTextureLayer',
                        channel: exports.eTextureChannel.ambientOcclusion,
                        path: `${LIBRARY_PATH}${baseUrl}_ao`,
                    },
                    {
                        $type: 'FileTextureLayer',
                        channel: exports.eTextureChannel.albedo,
                        path: `${LIBRARY_PATH}${baseUrl}_col`,
                    },
                    {
                        $type: 'FileTextureLayer',
                        channel: exports.eTextureChannel.metallic,
                        path: `${LIBRARY_PATH}${baseUrl}_met`,
                    },
                    {
                        $type: 'FileTextureLayer',
                        channel: exports.eTextureChannel.normal,
                        path: `${LIBRARY_PATH}${baseUrl}_nrm`,
                    },
                    {
                        $type: 'FileTextureLayer',
                        channel: exports.eTextureChannel.roughness,
                        path: `${LIBRARY_PATH}${baseUrl}_rgh`,
                    },
                    //{ $type: "FileTextureLayer", channel: eTextureChannel.displacement, path: `${LIBRARY_PATH}${baseUrl}_disp` },
                ],
            },
        };
    }
    function fillLibraryMaterialsMap() {
        for (const tag in materialDefinitionSet) {
            const entry = materialDefinitionSet[tag];
            for (let index = 1; index <= entry.count; index++) {
                const mat = makeLibraryMaterial(tag, index);
                const matData = mat.data;
                matData.roughness = 1;
                matData.metallic = 0;
                if (entry.omit) {
                    const omit = entry.omit;
                    matData.textures = matData.textures.filter(t => {
                        if (omit[t.channel]) {
                            if (omit[t.channel] === true) {
                                return false;
                            }
                            if (Array.isArray(omit[t.channel]) && omit[t.channel].some(i => i === index)) {
                                return false;
                            }
                        }
                        return true;
                    });
                }
                // Metallic is multiplied against the texture, so if the material has a metallic texture then set metallic to 1.
                if (matData.textures.findIndex(t => t.channel === exports.eTextureChannel.metallic) > -1) {
                    matData.metallic = 1;
                }
                if (entry.props) {
                    for (const p in entry.props) {
                        mat.data[p] = entry.props[p];
                    }
                }
                LibraryMaterials.set(mat.guid, mat);
                let categoryList = LibraryMaterialsByCategory.get(tag);
                if (!categoryList) {
                    categoryList = [];
                }
                categoryList.push(mat);
                LibraryMaterialsByCategory.set(tag, categoryList);
            }
        }
    }
    const materialDefinitionSet = {
        asphalt: {
            label: 'Asphalt',
            count: 15,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 9, 10, 11, 12, 13, 14, 15],
            },
        },
        bark: {
            label: 'Bark',
            count: 6,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1],
            },
        },
        bricks: {
            label: 'Bricks',
            count: 17,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 3, 4],
            },
        },
        chipboard: {
            label: 'Chipboard',
            count: 3,
            omit: {
                [exports.eTextureChannel.metallic]: true,
            },
        },
        concrete: {
            label: 'Concrete',
            count: 17,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 12, 14, 15, 16, 17],
                [exports.eTextureChannel.roughness]: [1],
            },
        },
        corrugatedsteel: {
            label: 'Corrugated Steel',
            count: 5,
        },
        diamondplate: {
            label: 'Diamond Plate',
            count: 4,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
                [exports.eTextureChannel.albedo]: [4],
            },
        },
        fabric: {
            label: 'Fabric',
            count: 29,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
                [exports.eTextureChannel.metallic]: true,
            },
        },
        gravel: {
            label: 'Gravel',
            count: 8,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2],
            },
        },
        ground: {
            label: 'Ground',
            count: 28,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 3, 17],
            },
        },
        ice: {
            label: 'Ice',
            count: 4,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        leather: {
            label: 'Leather',
            count: 14,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14],
            },
        },
        marble: {
            label: 'Marble',
            count: 5,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        metal: {
            label: 'Metal',
            count: 27,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        metalplates: {
            label: 'Metal Plate',
            count: 3,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        paint: {
            label: 'Paint',
            count: 6,
            omit: {
                [exports.eTextureChannel.metallic]: true,
            },
        },
        paintedmetal: {
            label: 'Painted Metal',
            count: 5,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        paintedplaster: {
            label: 'Painted Plaster',
            count: 5,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
                [exports.eTextureChannel.metallic]: true,
            },
        },
        pavingstones: {
            label: 'Paving Stones',
            count: 41,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 3, 4],
            },
        },
        pipe: {
            label: 'Pipe',
            count: 4,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        planks: {
            label: 'Planks',
            count: 9,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: [1, 2],
            },
        },
        plastic: {
            label: 'Plastic',
            count: 5,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        rock: {
            label: 'Rock',
            count: 14,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 6, 7, 8, 9],
                [exports.eTextureChannel.albedo]: [4],
            },
        },
        rocks: {
            label: 'Rocks',
            count: 6,
            omit: {
                [exports.eTextureChannel.metallic]: true,
            },
        },
        roofingtiles: {
            label: 'Roofing Tiles',
            count: 5,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        rust: {
            label: 'Rust',
            count: 5,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
            },
        },
        scratches: {
            label: 'Scratches',
            count: 5,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.albedo]: true,
            },
        },
        terrazzo: {
            label: 'Terrazzo',
            count: 8,
            omit: {
                [exports.eTextureChannel.ambientOcclusion]: true,
                [exports.eTextureChannel.metallic]: true,
            },
        },
        tiles: {
            label: 'Tiles',
            count: 37,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [
                    1, 2, 3, 4, 5, 12, 13, 14, 15, 20, 21, 22, 23, 24, 25, 29, 30, 31, 32, 33, 34, 35, 36, 37,
                ],
            },
        },
        wood: {
            label: 'Wood',
            count: 20,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            },
        },
        woodfloor: {
            label: 'Wood Floor',
            count: 28,
            omit: {
                [exports.eTextureChannel.metallic]: true,
                [exports.eTextureChannel.ambientOcclusion]: [1, 2, 4, 5, 6, 8],
            },
        },
        woodsiding: {
            label: 'Wood Siding',
            count: 8,
            omit: {
                [exports.eTextureChannel.metallic]: [5, 6, 7],
            },
        },
    };
    fillLibraryMaterialsMap();
    /** create library environments */
    for (const env of [
        // "country",
        // "environment",
        // "forest",
        // "night",
        // "parking",
        // "room",
        'adams_place_bridge',
        'aerodynamics_workshop',
        'autoshop',
        'ballroom',
        'boiler_room',
        'cape_hill',
        'colorful_studio',
        'fireplace',
        'greenwich_park',
        'hospital_room',
        'industrial_pipe_and_valve',
        'leadenhall_market',
        'machine_shop',
        'modern_buildings_night',
        'museum_of_ethnography',
        'mutianyu',
        'old_bus_depot',
        'photo_studio',
        'preller_drive',
        'red_wall',
        'rooitou_park',
        'royal_esplanade',
        'schadowplatz',
        'small_cathedral',
        'spruit_sunrise',
        'studio_small',
        'surgery',
        'venice_sunset',
        'winter_evening',
        'wooden_lounge',
    ]) {
        const label = env
            .split('_')
            .map(s => s.capitalize())
            .join(' ');
        const o = {
            name: env,
            label,
            path: `${LOCAL_ENVIRONMENT_DOMAIN}${env}`,
            previewUrl: `environments/${env}.jpg`,
        };
        LibraryEnvironments.push(o);
        LibraryEnvironmentsMap.set(o.path, o);
    }

    const geometryCache = new Map();
    class MeshService {
        constructor(httpService, assetRoot) {
            this.httpService = httpService;
            this.assetRoot = assetRoot;
        }
        /**
         * Loads the geometry for a mesh node and adds it to the node, mutating the node object.
         * @param meshNode Mesh node to load geometry for
         */
        hydrateGeometry(meshNode) {
            if (!isCustomMeshNode(meshNode) || !meshNode.geometryId) {
                return Promise.resolve(meshNode);
            }
            else {
                let request = geometryCache.get(meshNode.geometryId);
                let shared = false;
                if (!request) {
                    request = attachLoadingTimer(this.httpService.getBinary(`${this.assetRoot}/meshes/${meshNode.geometryId}`, 'arraybuffer', true)).then(response => {
                        if (response && response.data) {
                            const geometry = meshNode._manager.create(Token.KbGeometry);
                            geometry.extractFromBinary(response.data, meshNode);
                            return geometry;
                        }
                        return Promise.reject();
                    }, err => {
                        console.error(`Geometry for "${meshNode.name}" could not be loaded`, err);
                        return null;
                    });
                    geometryCache.set(meshNode.geometryId, request);
                }
                else {
                    shared = true;
                }
                return request.then(geometry => {
                    if (geometry) {
                        if (shared) {
                            geometry.shared = true;
                        }
                        meshNode._geometry = geometry;
                    }
                    return meshNode;
                });
            }
        }
    }

    exports.LightNode = class LightNode extends exports.SpaceNode {
        constructor() {
            super();
        }
        getSpaceChildren() {
            return [];
        }
    };
    exports.LightNode = __decorate([
        BaseKb3dModel({
            token: Token.LightNode,
        })
    ], exports.LightNode);
    function isLightNode(node) {
        return instanceOfAny(node, ...Token.LightTokens);
    }

    exports.SceneNode = class SceneNode extends exports.MeshGroupNode {
        constructor() {
            super();
            this._forceGrid = false;
        }
        get materials() {
            if (!this._materials)
                this._materials = [];
            return this._materials;
        }
        set materials(val) {
            this._materials = val;
        }
        get lights() {
            if (!this._lights)
                this._lights = [];
            return this._lights;
        }
        set lights(val) {
            this._lights = val;
        }
        get viewpoints() {
            if (!this._viewpoints)
                this._viewpoints = [];
            return this._viewpoints;
        }
        set viewpoints(val) {
            this._viewpoints = val;
        }
        get scenes() {
            if (!this._scenes)
                this._scenes = [];
            return this._scenes;
        }
        set scenes(val) {
            this._scenes = val;
        }
        get mates() {
            if (!this._mates)
                this._mates = [];
            return this._mates;
        }
        set mates(val) {
            this._mates = val;
        }
        get annotations() {
            if (!this._annotations)
                this._annotations = [];
            return this._annotations;
        }
        set annotations(val) {
            this._annotations = val;
        }
        get importHistory() {
            if (!this._importHistory)
                this._importHistory = [];
            return this._importHistory;
        }
        set importHistory(val) {
            this._importHistory = val;
        }
        get exportHistory() {
            if (!this._exportHistory)
                this._exportHistory = [];
            return this._importHistory;
        }
        set exportHistory(val) {
            this._exportHistory = val;
        }
        getChildren() {
            return [
                ...this.meshes,
                ...this.materials,
                ...this.lights,
                ...this.viewpoints,
                ...this.mates,
                ...this.connectors,
                ...this.annotations,
            ];
        }
        getChildArrayForType(token) {
            if (token.isMeshOrGroup() || token.isLight()) {
                return this.meshes;
            }
            else if (token.isMaterial()) {
                return this.materials;
            }
            else if (token.isViewpoint()) {
                return this.viewpoints;
            }
            else if (token.isMate()) {
                return this.mates;
            }
            else if (token.isConnector()) {
                return this.connectors;
            }
            else if (token.isAnnotation()) {
                return this.annotations;
            }
            else {
                throw 'unexpected token';
            }
        }
        getChildArray(node) {
            if (Token.withKey(node.$type).isLight()) {
                // Lights can be defined as meshes but can be in the light array as well, so we have to check there
                if (this.lights.contains(node)) {
                    return this.lights;
                }
            }
            return super.getChildArray(node);
        }
        isNested() {
            return this._parent != null;
        }
        runOnAllScenes(action) {
            action(this);
            for (const nested of this.scenes) {
                nested.runOnAllScenes(action);
            }
        }
        getSpaceChildren() {
            return this.meshes.concat(this.scenes);
        }
        getNestedPathTo(node) {
            let path = node.id;
            let parent = node._parentScene;
            let isPath = false;
            while (parent) {
                if (parent === this)
                    break;
                path = parent.nestedId + '/' + path;
                isPath = true;
                parent = parent._parent;
            }
            return `${isPath ? '@' : ''}${path}`;
        }
        getAllConnectors() {
            const connectors = new Array();
            this.runOnAllScenes(s => {
                connectors.push(...s._manager.getByToken(Token.Connector).filter(c => c.enabled));
            });
            return connectors;
        }
        getAllSketchControlPoints() {
            const points = new Array();
            this.runOnAllScenes(s => {
                points.push(...s._manager.getByToken(Token.SketchControlPoint).filter(c => c.enabled));
            });
            return points;
        }
    };
    __decorate([
        IgnoreChanges
    ], exports.SceneNode.prototype, "conversionMap", void 0);
    __decorate([
        IgnoreChanges
    ], exports.SceneNode.prototype, "_configurator", void 0);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "materials", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "lights", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "viewpoints", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "scenes", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "mates", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "annotations", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "importHistory", null);
    __decorate([
        Enumerable()
    ], exports.SceneNode.prototype, "exportHistory", null);
    exports.SceneNode = __decorate([
        Kb3dModel({
            token: Token.SceneNode,
        })
    ], exports.SceneNode);
    function isSceneNode(node) {
        return instanceOf(node, Token.SceneNode);
    }

    const SET_TYPE = '__set';
    /** contains all kb3dobjects keyed by their dynamic Id, to fetch nodes from the 3d engine ID */
    const dynamicDb = new Map();
    function getByDynamicId(dynamicId, throwOnNotFound = false) {
        if (throwOnNotFound && !dynamicDb.has(dynamicId)) {
            throw `kb3d object with id ${dynamicId} not found`;
        }
        return dynamicDb.get(dynamicId);
    }
    (function (ImportOperation) {
        ImportOperation[ImportOperation["ignore"] = 0] = "ignore";
        ImportOperation[ImportOperation["add"] = 1] = "add";
        ImportOperation[ImportOperation["replace"] = 2] = "replace";
    })(exports.ImportOperation || (exports.ImportOperation = {}));
    class Kb3dManager {
        constructor(options) {
            this.isDevEnvironment = true;
            /** contains all kb3dobjects */
            this._db = new Map();
            /** contains all objects keyed by their token */
            this._tokenDb = new SetMap();
            /** contains all nodes (but not other kinds of objects) */
            this._nodeDb = new Map();
            /** holds a cache of name searches that have been performed with their results */
            this._nameSearchCache = new Map();
            /** contains nested scenes keyed by their nestedId */
            this._nestedSceneDb = new Map();
            /** holds a cache of click handlers that have been added to nodes in the context of this manager */
            this.clickHandlers = new HandlerMap(this);
            this.doubleClickHandlers = new HandlerMap(this);
            this.draggables = new HandlerMap(this);
            this.hotspotClickHandlers = new TagArrayMap();
            this.boundingboxChangeHandlers = new HandlerMap(this);
            //if no services are provided, then use the default services
            if (options && options.services) {
                this.services = options.services;
            }
            else {
                const httpService = new HttpService(options === null || options === void 0 ? void 0 : options.environment);
                if ((options === null || options === void 0 ? void 0 : options.environment) && options.environment.lastDeploy) {
                    this.isDevEnvironment = false;
                }
                this.services = new Map([
                    [Token.HttpService, httpService],
                    [
                        Token.MaterialService,
                        new exports.MaterialService(httpService, options === null || options === void 0 ? void 0 : options.assetRoot, options === null || options === void 0 ? void 0 : options.forceFullSizeTextures),
                    ],
                    [Token.MeshService, new MeshService(httpService, options === null || options === void 0 ? void 0 : options.assetRoot)],
                    [Token.FontService, new FontService(httpService, options === null || options === void 0 ? void 0 : options.assetRoot)],
                ]);
            }
        }
        getService(serviceToken) {
            return this.services.get(serviceToken);
        }
        dispose() {
            /**only clear items out of the dynamic db that were part of this manager (as it is static and holds dynamic ids for all managers) */
            for (const [, value] of this._db) {
                dynamicDb.delete(value._dynamicId);
            }
            this._db.clear();
            this._nodeDb.clear();
            this.clickHandlers.clear();
            this.doubleClickHandlers.clear();
            this.draggables.clear();
            this.hotspotClickHandlers.clear();
            this.boundingboxChangeHandlers.clear();
            this._nameSearchCache.clear();
            this._tokenDb.clear();
            this._nestedSceneDb.clear();
        }
        /**
         * Accepts either a node id or a name to search for nodes.  If using
         * node name wildcards * are allowed.  The action provided will be run
         * on each of the matching nodes, with the args passed in to that action.
         * @param idOrName
         * @param action
         * @param args
         * @param useCache
         */
        runOnNodes(idOrName, action, args, useCache = true) {
            if (isGuid(idOrName)) {
                const node = this.getById(idOrName);
                if (node)
                    action(node, args);
            }
            else {
                const nodes = this.getNodesByName(idOrName, useCache);
                for (const node of nodes) {
                    action(node, args);
                }
            }
        }
        // @child1/xxxxx-xxxxxx-xxxx
        getById(id) {
            if (id && id.startsWith('@')) {
                //it's a nested path id
                const segments = id.split('/');
                const nestedId = segments.shift().substring(1).toLowerCase();
                const nestedScene = this._nestedSceneDb.get(nestedId);
                if (nestedScene) {
                    let subId = segments.join('/');
                    if (segments.length > 1)
                        subId = '@' + subId;
                    return nestedScene._manager.getNodeByIdOrName(subId);
                }
            }
            else {
                return this._db.get(id);
            }
        }
        getAll() {
            return [...this._db.values()];
        }
        getAllNodes() {
            return [...this._nodeDb.values()];
        }
        /**
         * Accepts either a node id or a name to search for nodes.  Only returns the first
         * matching node. If using node name wildcards * are allowed.
         * @param idOrName
         * @param useCache
         */
        getNodeByIdOrName(idOrName, useCache = true) {
            if (typeof idOrName == 'string') {
                if (isGuid(idOrName) || idOrName.startsWith('@')) {
                    return this.getById(idOrName);
                }
                else {
                    return this.getFirstNodeByName(idOrName, useCache);
                }
            }
            else if (idOrName instanceof exports.Kb3dObject) {
                return idOrName;
            }
        }
        /**
         * Accepts either a node id or a name to search for nodes.  If using
         * node name wildcards * are allowed.
         * @param idOrName
         * @param useCache
         */
        getNodesByIdOrName(idOrName, useCache = true) {
            const res = [];
            if (typeof idOrName == 'string') {
                if (isGuid(idOrName)) {
                    const n = this.getById(idOrName);
                    if (n)
                        res.push(n);
                }
                else {
                    res.push(...this.getNodesByName(idOrName, useCache));
                }
            }
            else if (idOrName instanceof exports.Kb3dObject) {
                res.push(idOrName);
            }
            return res;
        }
        /**
         * Get's the first node that matches the name given.  Wildcards * are allowed.
         * @param name
         * @param useCache
         */
        getFirstNodeByName(name, useCache = true) {
            const nodes = this.getNodesByName(name, useCache);
            if (nodes && nodes.length) {
                return nodes[0];
            }
        }
        /**
         * Returns a list of nodes that match the name given.
         * Wildcards * are allowed.
         * Results will be fed from a search cache if useCache is true
         * @param name
         * @param useCache
         */
        getNodesByName(name, useCache = true) {
            if (useCache && this._nameSearchCache.has(name)) {
                return this._nameSearchCache.get(name);
            }
            const results = new Array();
            const re = this.getWildcardRegex(name);
            for (const [, node] of this._db) {
                if (re.test(node.name)) {
                    results.push(node);
                }
            }
            this._nameSearchCache.set(name, results);
            return results;
        }
        getNodesContainingName(name, useCache = true) {
            if (useCache && this._nameSearchCache.has(name)) {
                return this._nameSearchCache.get(name);
            }
            const results = new Array();
            const re = this.getWildcardRegex(name);
            for (const [, node] of this._db) {
                if (re.test(node.name)) {
                    results.push(node);
                }
            }
            this._nameSearchCache.set(name, results);
            return results;
        }
        getByToken(token) {
            return [...this._tokenDb.get(token).values()];
        }
        getByTokens(...tokens) {
            return tokens.flatMap(t => [...this._tokenDb.get(t).values()]);
        }
        /** escapes the given string so that any special characters will be processed literally in a regex search */
        escapeRegex(str) {
            return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
        }
        /**
         * Given a string with wildcards *, will provide a regex that can be used to
         * match strings.
         * @param rule
         */
        getWildcardRegex(rule) {
            // "."  => Find a single character, except newline or line terminator
            // ".*" => Matches any string that contains zero or more characters
            rule = rule.split('*').map(this.escapeRegex).join('.*');
            // "^"  => Matches any string with the following at the beginning of it
            // "$"  => Matches any string with that in front at the end of it
            rule = '^' + rule + '$';
            //Create a regular expression object for matching string
            return new RegExp(rule, 'i');
        }
        /**
         * absorbs a kb3d object that already exists into the manager.
         * @param o
         */
        register(o) {
            if (o instanceof exports.Kb3dObject) {
                if (!this._db.has(o.id)) {
                    if (isTrackedClass(o)) {
                        o.isModified = true; //force a full round of change detection if this is a newly registered object
                    }
                }
                this._db.set(o.id, o);
                dynamicDb.set(o._dynamicId, o);
                this._tokenDb.add(Token.withKey(o.$type), o);
                if (o.isNode()) {
                    this._nodeDb.set(o.id, o);
                }
            }
        }
        unregister(o) {
            if (o instanceof exports.Kb3dObject) {
                this.clickHandlers.deleteByKey(o);
                this.doubleClickHandlers.deleteByKey(o);
                this.draggables.deleteByKey(o);
                this.boundingboxChangeHandlers.deleteByKey(o);
                this._db.delete(o.id);
                dynamicDb.delete(o._dynamicId);
                this._tokenDb.removeValue(Token.withKey(o.$type), o);
                if (o.isNode()) {
                    this._nodeDb.delete(o.id);
                }
                if (o instanceof exports.SceneNode && o.isNested()) {
                    this._nestedSceneDb.delete(o.nestedId);
                }
            }
        }
        /**
         * Creates an instance of a kb3d model, given a token
         * and an anonymous object in the shape of the model that
         * can be used to set properties on it.
         *
         * As part of the creation process, we do things in this order:
         *
         * 1. Create an instance of the class.  If a create function was provided
         *    in the decorator for the class, that is used to create the instance.
         *    If not, then it's created by calling the constructor of the class
         *    with no arguments.
         * 2. We then apply default values to the properties of the class
         * 3. We then apply the args that were passed in to set properties on the class
         * 4. We then register the object into the map using it's id so it can be quickly retrieved
         */
        create(token, args = {}, options) {
            var _a;
            options = { includeChildNodes: true, ...options };
            const modelDef = Kb3dModels.get(token);
            if (!modelDef) {
                throw `could not find model with token: ${token.key}`;
            }
            const constructorParameters = getConstructorParamsForModel(modelDef);
            const hydratedParameters = [];
            for (const i of constructorParameters) {
                if (!i.ignore) {
                    const service = (_a = this.services) === null || _a === void 0 ? void 0 : _a.get(i.token);
                    if (!service) {
                        throw `Injected service of type '${i.token.key} could not be found to inject into the constructor of type '${token.key}`;
                    }
                    hydratedParameters.push(service);
                }
            }
            let model;
            if (modelDef.create) {
                model = modelDef.create(args);
            }
            else {
                model = new modelDef.classConstructor(...hydratedParameters);
            }
            //now initialize the model for when no create function was given
            if (!modelDef.create) {
                this.initializeModel(isTrackedClass(model) ? model.rawNode : model, args, modelDef, options);
            }
            if (model instanceof exports.SceneNode) {
                model._manager = this;
                model.calculateParents(); //because calculateParents also registers the item, we must call this after initialization, otherwise it won't have the right id
            }
            if (modelDef.afterCreate) {
                modelDef.afterCreate(model);
            }
            //need to clear the name cache since we just created a new node
            //no need to clear if the node is a primitive as they are never fetched by name
            if (!token.isPrimitive()) {
                this._nameSearchCache.clear();
            }
            return model;
        }
        serializeToJson(instance, options) {
            const o = this.serialize(instance, options);
            const json = JSON.stringify(o, null, (options === null || options === void 0 ? void 0 : options.prettyPrint) ? 2 : undefined);
            return json;
        }
        serialize(instance, options) {
            options = {
                includeChildNodes: true,
                isRoot: true,
                omitDefaultValues: true,
                ...options,
            };
            let result = { $type: instance.$type };
            const defaultValues = defaults[instance.$type];
            for (const key in instance) {
                if (
                // Never persist properties beginning with an underscore
                key.substr(0, 1) !== '_' &&
                    // If a property is the same as a default value, remove it
                    (!options.omitDefaultValues ||
                        !defaultValues ||
                        !this.shallowEquals(defaultValues[key], instance[key]))) {
                    if (!isObject$1(instance[key])) {
                        // For primitives, just copy the values over
                        result[key] = instance[key];
                    }
                    else if (Array.isArray(instance[key])) {
                        const sourceArray = instance[key];
                        if (sourceArray.length && typeof sourceArray[0] !== 'object') {
                            //it's an array of primitives
                            result[key] = sourceArray.slice(0); //clone the array of primitives
                        }
                        else {
                            result[key] = []; //make sure there is an array on target prop.  Recreate it if one is there already.
                            for (const sourceItem of sourceArray) {
                                if (!sourceItem.$type ||
                                    !Token.withKey(sourceItem.$type).isNode() ||
                                    options.includeChildNodes) {
                                    // exclude it if it's a kb3d model and includeChildren is false
                                    const targetItem = this.serialize(sourceItem, { ...options, isRoot: false });
                                    if (targetItem) {
                                        result[key].push(targetItem);
                                    }
                                }
                            }
                        }
                    }
                    else if (instance[key] instanceof Map) {
                        console.error('implement serializing maps');
                    }
                    else if (instance[key] instanceof Set) {
                        result[key] = {
                            $type: SET_TYPE,
                            values: Array.from(instance[key].values()),
                        };
                    }
                    else {
                        // For anything else, try deserializing. The deserializer will just copy the property if it is not a serialized class.
                        result[key] = this.serialize(instance[key], { ...options, isRoot: false });
                    }
                }
            }
            if (instance.$type) {
                const modelDef = Kb3dModels.get(Token.withKey(instance.$type));
                if (modelDef && modelDef.onSerializing) {
                    const include = modelDef.onSerializing(instance, result);
                    // Always serialize the object if it is the root object. Otherwise, let the class decide.
                    if (include === false && !options.isRoot) {
                        result = undefined;
                    }
                }
            }
            return result;
        }
        /**
         * See notes for the create() function as this is virtually the same.
         * The only difference is that the type here is discovered through the $type
         * property of the args object instead of an explicit token.
         * @param object
         */
        deserialize(object, options) {
            if (!object || !object.$type) {
                return object;
            }
            else if (object.$type === SET_TYPE) {
                return new Set(object.values);
            }
            return this.create(Token.withKey(object.$type), object, options);
        }
        deserializeJson(json) {
            const object = JSON.parse(json);
            return this.deserialize(object);
        }
        clone(objectToClone) {
            //make sure it's a kb3d model
            if (!objectToClone)
                throw 'no object provided to clone';
            if (!('$type' in objectToClone)) {
                throw 'object passed to clone function must be a kb3d model and have a $type defined';
            }
            const json = this.serializeToJson(objectToClone);
            const object = JSON.parse(json);
            return this.deserialize(object, { issueNewIds: true });
        }
        nestScene(nestedId, parent, serializedNested = {}) {
            const nestedMan = new Kb3dManager({ services: this.services });
            if (serializedNested.lights) {
                serializedNested.lights.clear();
            }
            const nested = nestedMan.create(Token.SceneNode, serializedNested);
            nested.nestedId = nestedId.replace('/', '');
            parent.scenes.push(nested);
            this._nestedSceneDb.set(nested.nestedId.toLowerCase(), nested);
            return nested;
        }
        getNodeNamePathMap() {
            const meshMap = new Map();
            const matMap = new Map();
            const lightMap = new Map();
            const allNodes = this._nodeDb.values();
            for (const n of allNodes) {
                if (isLightNode(n)) {
                    lightMap.set(n.getNamePath(), n);
                }
                else if (isMaterialNode(n)) {
                    matMap.set(n.getNamePath(), n);
                }
                else {
                    meshMap.set(n.getNamePath(), n);
                }
            }
            return {
                meshes: meshMap,
                lights: lightMap,
                materials: matMap,
            };
        }
        previewImport(parent, imported) {
            const sceneNode = parent._parentScene;
            if (!sceneNode || !imported.scene)
                return;
            const nMap = this.getNodeNamePathMap();
            const processNode = (node, parentNamePath) => {
                const token = Token.withKey(node['$type']);
                const namePath = token !== Token.SceneNode && node.name
                    ? [parentNamePath, node.name].filter(Boolean).join('/')
                    : parentNamePath;
                let matchingNode;
                if (token.isLight()) {
                    matchingNode = nMap.lights.get(namePath);
                }
                else if (token.isMaterial()) {
                    matchingNode = nMap.materials.get(namePath);
                }
                else {
                    matchingNode = nMap.meshes.get(namePath);
                }
                const p = {
                    node,
                    type: Token.withKey(node['$type']),
                    namePath,
                    matchingNode,
                    operation: matchingNode ? exports.ImportOperation.replace : exports.ImportOperation.add,
                };
                p.children = ['meshes', 'materials', 'lights', 'viewpoints'].flatMap(childProp => {
                    const childArr = node[childProp];
                    return childArr
                        ? childArr.map(c => {
                            const cNode = processNode(c, childProp === 'meshes' ? namePath : '');
                            cNode.parent = p;
                            return cNode;
                        })
                        : [];
                });
                return p;
            };
            const pathToImportParent = parent.getNamePath();
            imported.scene['$type'] = 'SceneNode';
            return processNode(imported.scene, pathToImportParent).children;
        }
        import(previews, parentNode, root = true) {
            const nMap = this.getNodeNamePathMap();
            // Materials have to come first so we know how they reconnect to the meshes to them
            previews.sort((a, b) => {
                if (a.type.isMaterial() && !b.type.isMaterial()) {
                    return -1;
                }
                else {
                    return 0;
                }
            });
            for (const p of previews) {
                if (p.operation !== exports.ImportOperation.ignore) {
                    let thisNode;
                    if (p.operation === exports.ImportOperation.add || !p.matchingNode) {
                        const parentPath = p.namePath.substring(0, p.namePath.lastIndexOf('/'));
                        let parent;
                        if (!parentPath) {
                            parent = parentNode;
                        }
                        else if (p.type.isLight()) {
                            parent = nMap.lights.get(parentPath);
                        }
                        else if (p.type.isMaterial()) {
                            parent = nMap.materials.get(parentPath);
                        }
                        else {
                            parent = nMap.meshes.get(parentPath);
                        }
                        const newNode = this.deserialize(p.node, { includeChildNodes: false });
                        if (instanceOfAny(newNode, ...Token.GlobalLightTokens) &&
                            instanceOf(parentNode, Token.SceneNode)) {
                            parentNode.lights.push(newNode);
                        }
                        else if ((parent === null || parent === void 0 ? void 0 : parent.id) === parentNode.id) {
                            parentNode === null || parentNode === void 0 ? void 0 : parentNode.addChildren(newNode);
                        }
                        thisNode = newNode;
                    }
                    else {
                        // replace
                        const originalId = p.matchingNode.id;
                        const matchingMeshNode = isMeshNode(p.matchingNode) ? p.matchingNode : undefined;
                        const originalMaterialId = matchingMeshNode ? matchingMeshNode.materialId : undefined;
                        this.assign(p.matchingNode, p.node, { includeChildNodes: false });
                        p.matchingNode.id = originalId;
                        // If the new materialId from the import exists, that means the material was imported and added and can be used.
                        // If the new materialId from the import does not exist, use the old materialId because the material was updated but
                        // kept the original ID.
                        if (matchingMeshNode && originalMaterialId && matchingMeshNode.materialId) {
                            if (!this.getById(matchingMeshNode.materialId)) {
                                matchingMeshNode.materialId = originalMaterialId;
                            }
                        }
                        // Trigger change detection on this existing node
                        if (isTrackedClass(p.matchingNode)) {
                            p.matchingNode.isModified = true;
                        }
                        thisNode = p.matchingNode;
                    }
                    if (thisNode instanceof exports.SpaceNode || thisNode instanceof exports.MaterialNode) {
                        this.import(p.children, thisNode, false);
                    }
                    else if (p.children && p.children.length > 0) {
                        throw Error('Children on non-space node or non-material-node, how did this happen');
                    }
                }
            }
        }
        initializeModel(model, args, modelDef, options) {
            this.setModelDefaultValues(model);
            this.assign(model, args, options);
        }
        setModelDefaultValues(o) {
            const values = defaults[o.$type];
            if (values) {
                for (const prop in values) {
                    if (values[prop] && values[prop].$type) {
                        o[prop] = this.deserialize(values[prop]);
                    }
                    else if (isObject$1(values[prop])) {
                        o[prop] = { ...values[prop] }; //need to clone the object from default values otherwise the class and defaults will both be pointing to same instance!
                    }
                    else {
                        o[prop] = values[prop];
                    }
                }
            }
        }
        assign(model, args, options) {
            options = {
                includeChildNodes: true,
                issueNewIds: false,
                copyingToDifferentNode: false,
                ...options,
            };
            if (args) {
                if (options.copyingToDifferentNode) {
                    // If we are using assign to copy properties from one node to another, serialize the data
                    if (args instanceof exports.Kb3dObject) {
                        const defaultValues = { $type: args.$type };
                        this.setModelDefaultValues(defaultValues);
                        args = { ...defaultValues, ...this.serialize(args) };
                    }
                }
                for (const prop in args) {
                    // Never persist properties beginning with an underscore
                    if (prop.substr(0, 1) == '_')
                        continue;
                    if (options.copyingToDifferentNode) {
                        if ((prop.isEqual('id') && model.id) || prop.isEqual('$type')) {
                            continue; // skip id's if copying to an existing node so the node retains its ID
                        }
                    }
                    if (options.issueNewIds && prop.isEqual('id') && args.$type)
                        continue; //skip id's if options specify so it will use the new one it generates during construction
                    const sourceProp = args[prop];
                    if (typeof model === 'undefined') {
                        throw Error(); // this should never happen, this means a reference is being lost somewhere
                    }
                    if (prop === 'parent' || sourceProp === model[prop]) {
                        // Don't break parent relationships
                        continue; // Don't break parent relationships
                    }
                    if (!isObject$1(args[prop])) {
                        // For primitives, just copy the values over
                        model[prop] = args[prop];
                    }
                    else if (Array.isArray(sourceProp)) {
                        // make sure there is an array on target prop.  Recreate it if one is there already.
                        if (model[prop]) {
                            if (options.includeChildNodes ||
                                !(model[prop].length > 0 &&
                                    model[prop][0].$type &&
                                    Token.withKey(model[prop][0].$type).isNode())) {
                                model[prop].clear();
                            }
                        }
                        else {
                            model[prop] = [];
                        }
                        for (const sourceItem of sourceProp) {
                            let targetItem;
                            if (sourceItem.$type) {
                                //it's one of our types so deserialize it
                                if (options.includeChildNodes || !Token.withKey(sourceItem.$type).isNode()) {
                                    targetItem = this.deserialize(sourceItem, options);
                                    model[prop].push(targetItem);
                                }
                            }
                            else if (isObject$1(sourceItem)) {
                                targetItem = {};
                                model[prop].push(targetItem);
                                this.assign(targetItem, sourceItem, options);
                            }
                            else {
                                //primitive type
                                model[prop].push(sourceItem);
                            }
                        }
                    }
                    else {
                        if (sourceProp.$type) {
                            //it's one of our types so deserialize it
                            if (options.includeChildNodes || !Token.withKey(sourceProp.$type).isNode()) {
                                model[prop] = this.deserialize(sourceProp, options);
                            }
                        }
                        else if (isObject$1(sourceProp)) {
                            const targetItem = {};
                            model[prop] = targetItem;
                            this.assign(targetItem, sourceProp, options);
                        }
                        else {
                            //primitive type
                            model[prop] = sourceProp;
                        }
                    }
                }
            }
        }
        shallowEquals(a, b) {
            if (!isObject$1(a)) {
                return a === b;
            }
            for (const aProp in a) {
                if (aProp.substring(0, 1) !== '_') {
                    if (!(aProp in b)) {
                        return false;
                    }
                    if (a[aProp] !== b[aProp]) {
                        return false;
                    }
                }
            }
            for (const bProp in b) {
                if (bProp.substring(0, 1) !== '_') {
                    if (!(bProp in a)) {
                        return false;
                    }
                    if (b[bProp] !== a[bProp]) {
                        return false;
                    }
                }
            }
            return true;
        }
    }

    class ShadowLightNode extends exports.LightNode {
        constructor() {
            super();
        }
    }

    exports.DirectionalLightNode = class DirectionalLightNode extends ShadowLightNode {
        constructor() {
            super();
        }
    };
    exports.DirectionalLightNode = __decorate([
        Kb3dModel({
            token: Token.DirectionalLightNode,
        })
    ], exports.DirectionalLightNode);

    exports.HemisphericLightNode = class HemisphericLightNode extends exports.LightNode {
        constructor() {
            super();
        }
    };
    exports.HemisphericLightNode = __decorate([
        Kb3dModel({
            token: Token.HemisphericLightNode,
        })
    ], exports.HemisphericLightNode);

    exports.PointLightNode = class PointLightNode extends ShadowLightNode {
        constructor() {
            super();
        }
    };
    exports.PointLightNode = __decorate([
        Kb3dModel({
            token: Token.PointLightNode,
        })
    ], exports.PointLightNode);

    exports.SpotLightNode = class SpotLightNode extends exports.DirectionalLightNode {
        constructor() {
            super();
        }
    };
    exports.SpotLightNode = __decorate([
        Kb3dModel({
            token: Token.SpotLightNode,
        })
    ], exports.SpotLightNode);

    exports.TextureLayer = class TextureLayer extends exports.MaterialMapping {
        constructor() {
            super(...arguments);
            this._init = false;
            this._external = false;
        }
        init(parent) {
            if (!this._init) {
                this._parent = parent;
                // Normally this function is called when the node is added to an array on the parent, but textures live in defined properties on a material.
                // So we have to explicitly call it here, on texture init. The texture won't be doing anything before init anyways.
                this.calculateParents();
                if (isTrackedClass(this)) {
                    // Always track changes on initialized textures because they may be attached to global materials
                    this.trackChanges(true);
                    this._init = true;
                }
            }
        }
    };
    __decorate([
        IgnoreHistory
    ], exports.TextureLayer.prototype, "_init", void 0);
    __decorate([
        IgnoreHistory
    ], exports.TextureLayer.prototype, "_external", void 0);
    exports.TextureLayer = __decorate([
        BaseKb3dModel({
            token: Token.TextureLayer,
        })
    ], exports.TextureLayer);
    function isTextureLayer(node) {
        return instanceOfAny(node, ...Token.TextureLayerTokens);
    }

    exports.AdvancedMaterialNode = class AdvancedMaterialNode extends exports.MaterialNode {
        constructor(_materialService) {
            super(_materialService);
            this._initialized = false;
            this._initialized = false;
        }
        get materials() {
            if (!this._materials)
                this._materials = [];
            return this._materials;
        }
        set materials(val) {
            this._materials = val;
        }
    };
    __decorate([
        Enumerable()
    ], exports.AdvancedMaterialNode.prototype, "materials", null);
    __decorate([
        IgnoreChanges
    ], exports.AdvancedMaterialNode.prototype, "_initialized", void 0);
    exports.AdvancedMaterialNode = __decorate([
        Kb3dModel({
            token: Token.AdvancedMaterialNode,
            onSerializing: (node, o) => {
                var _a;
                if (node.parentMaterialId == null) {
                    return true;
                }
                // remove any textures that are from the parent material
                o.textures = (_a = o.textures) === null || _a === void 0 ? void 0 : _a.filter(texture => !texture._external);
                // remove any properties from the serialization that are inherited from a global or library material
                const keys = Object.keys(o);
                for (const p of keys) {
                    if (node._overriddenPropertiesSet && !node._overriddenPropertiesSet.has(p) && p !== 'textures') {
                        delete o[p];
                    }
                }
                if (node._overriddenPropertiesSet) {
                    o.overriddenProperties = Array.from(node._overriddenPropertiesSet).map(val => val.toString());
                }
                return node.location == exports.eMaterialLocation.local;
            },
            addedToChildArray: (node, child) => {
                if (child instanceof exports.TextureLayer) {
                    if (node._initialized) {
                        child.init(node);
                    }
                }
            },
            afterCreate: node => {
                node.overriddenProperties.forEach(val => node._overriddenPropertiesSet.add(val));
                node.calculateParents(); //parents need to be calculated again because the texture children don't exist yet the first time it is run
                node.refreshParentMaterial();
            },
        }),
        __param(0, Inject(Token.MaterialService))
    ], exports.AdvancedMaterialNode);

    exports.ColorFillTextureLayer = class ColorFillTextureLayer extends exports.TextureLayer {
    };
    exports.ColorFillTextureLayer = __decorate([
        Kb3dModel({
            token: Token.ColorFillTextureLayer,
        })
    ], exports.ColorFillTextureLayer);

    exports.FileTextureLayer = class FileTextureLayer extends exports.TextureLayer {
        constructor() {
            super(...arguments);
            this.path = '';
            this._needsImageUpdate = false;
            this.flipNormalsRg = false;
        }
    };
    __decorate([
        IgnoreChanges
    ], exports.FileTextureLayer.prototype, "_needsImageUpdate", void 0);
    __decorate([
        IgnoreHistory
    ], exports.FileTextureLayer.prototype, "_buffer", void 0);
    exports.FileTextureLayer = __decorate([
        Kb3dModel({
            token: Token.FileTextureLayer,
            onSerializing: (node, o) => {
                return !node._external; // TODO Copy this to other layer types
            },
        })
    ], exports.FileTextureLayer);

    exports.SvgTextureLayer = class SvgTextureLayer extends exports.TextureLayer {
        constructor() {
            super(...arguments);
            this.svgXml = '';
            this.height = 256;
            this.width = 256;
            this.preloadFontStylesheet = '';
        }
    };
    exports.SvgTextureLayer = __decorate([
        Kb3dModel({
            token: Token.SvgTextureLayer,
        })
    ], exports.SvgTextureLayer);

    exports.TextTextureLayer = class TextTextureLayer extends exports.TextureLayer {
    };
    exports.TextTextureLayer = __decorate([
        Kb3dModel({
            token: Token.TextTextureLayer,
        })
    ], exports.TextTextureLayer);

    exports.MateNode = class MateNode extends exports.Kb3dObject {
        constructor() {
            super();
        }
        getC1() {
            var _a;
            return (_a = this._manager) === null || _a === void 0 ? void 0 : _a.getById(this.connector1);
        }
        getC2() {
            var _a;
            return (_a = this._manager) === null || _a === void 0 ? void 0 : _a.getById(this.connector2);
        }
        isActive() {
            return this.enabled && this.getC1() != null && this.getC2() != null;
        }
    };
    __decorate([
        NodeReference(exports.BaseConnector, 'position', 'direction', 'angle')
    ], exports.MateNode.prototype, "connector1", void 0);
    __decorate([
        NodeReference(exports.BaseConnector, 'position', 'direction', 'angle')
    ], exports.MateNode.prototype, "connector2", void 0);
    __decorate([
        IgnoreChanges
    ], exports.MateNode.prototype, "_swap", void 0);
    exports.MateNode = __decorate([
        Kb3dModel({
            token: Token.MateNode,
            validate: (n, v) => {
                var _a, _b, _c, _d, _e, _f, _g;
                if (n.changes.hasAny('connector1', 'connector2')) {
                    v.assert(n, 'connector1', n.connector1 != null && ((_a = n._manager) === null || _a === void 0 ? void 0 : _a.getById(n.connector1)) != null, 'Connector is required');
                    v.assert(n, 'connector2', n.connector2 != null && ((_b = n._manager) === null || _b === void 0 ? void 0 : _b.getById(n.connector2)) != null, 'Connector is required');
                    v.assert(n, 'connector2', ((_d = (_c = n._manager) === null || _c === void 0 ? void 0 : _c.getById(n.connector1)) === null || _d === void 0 ? void 0 : _d._parent) !== ((_f = (_e = n._manager) === null || _e === void 0 ? void 0 : _e.getById(n.connector2)) === null || _f === void 0 ? void 0 : _f._parent) ||
                        ((_g = n._manager) === null || _g === void 0 ? void 0 : _g.getById(n.connector1)) == null, 'Connectors cannot have the same parent node');
                }
            },
        })
    ], exports.MateNode);
    function isMate(node) {
        return instanceOf(node, Token.MateNode);
    }

    class Validator {
        constructor() {
            this.vmap = new Map();
        }
        getAll() {
            return this.vmap;
        }
        validateNode(node) {
            const model = Kb3dModels.get(node._token);
            if (model && model.validate) {
                model.validate(node, this);
            }
        }
        nodeIsValid(node) {
            return (!this.vmap.has(node.id) ||
                !this.vmap.get(node.id).size ||
                [...this.vmap.get(node.id).values()].every(a => a == null || a.length == 0));
        }
        getErrors(nodeId, prop) {
            var _a;
            return (_a = this.vmap.get(nodeId)) === null || _a === void 0 ? void 0 : _a.get(prop);
        }
        /** removes all validation errors for the given property */
        clearProp(node, prop) {
            var _a;
            if (this.vmap.has(node.id) && this.vmap.get(node.id).has(prop)) {
                (_a = this.vmap.get(node.id)) === null || _a === void 0 ? void 0 : _a.delete(prop);
            }
            return this;
        }
        /** removes a specific validation errors for the given property */
        clearPropError(node, prop, ...errors) {
            return this.clearPropErrorWhere(node, prop, e => e.equalsAny(...errors));
        }
        clearPropErrorWhere(node, prop, predicate) {
            var _a, _b;
            if (this.vmap.has(node.id) && this.vmap.get(node.id).has(prop)) {
                (_b = (_a = this.vmap
                    .get(node.id)) === null || _a === void 0 ? void 0 : _a.get(prop)) === null || _b === void 0 ? void 0 : _b.removeWhere(e => predicate(e));
            }
            return this;
        }
        clearNode(node) {
            this.vmap.delete(node.id);
        }
        addError(node, prop, ...errors) {
            if (!this.vmap.has(node.id)) {
                this.vmap.set(node.id, new Map());
            }
            const entry = this.vmap.get(node.id);
            const sprop = prop;
            if (!entry.has(sprop)) {
                entry.set(sprop, [...errors]);
            }
            else {
                const existingErrors = entry.get(sprop);
                for (const err of errors) {
                    if (!existingErrors.contains(err)) {
                        existingErrors.push(err);
                    }
                }
            }
            return this;
        }
        assert(node, prop, expression, ...errors) {
            if (expression) {
                this.clearPropError(node, prop, ...errors);
            }
            else {
                this.addError(node, prop, ...errors);
            }
            return this;
        }
    }

    exports.ViewpointNode = class ViewpointNode extends exports.Kb3dObject {
        constructor() {
            super();
            this.offsetX = 0; // For panning
            this.offsetY = 0;
            this.allowOrbit = true;
            this.allowPan = true;
            this.allowZoom = true;
            this.limitMinimumTargetDistance = false;
            this.limitLatOrbit = false;
            this.limitLngOrbit = false;
            this.type = exports.eViewpointType.orbit;
            this.targetMode = exports.eViewpointTargetMode.point;
            this.position = exports.KbVector.Zero();
            this.rotation = exports.KbVector.Zero();
            this.targetPoint = exports.KbVector.Zero();
            this.fov = defaults.ViewpointNode.fov;
            this.projection = exports.eViewpointProjection.perspective;
        }
        get type() {
            return this._type;
        }
        set type(newType) {
            this._type = newType;
            switch (newType) {
                case exports.eViewpointType.firstPerson:
                    this.targetMode = exports.eViewpointTargetMode.rotation;
                    this.projection = exports.eViewpointProjection.perspective;
                    break;
            }
        }
    };
    __decorate([
        Enumerable()
    ], exports.ViewpointNode.prototype, "type", null);
    exports.ViewpointNode = __decorate([
        Kb3dModel({
            token: Token.ViewpointNode,
            onSerializing: (node, o) => {
                // remove any target properties not relevant to the target mode
                if (node.targetMode === exports.eViewpointTargetMode.rotation) {
                    delete o.targetPoint;
                    delete node.targetMeshId;
                }
                else if (node.targetMode === exports.eViewpointTargetMode.point) {
                    delete o.rotation;
                    delete node.targetMeshId;
                }
                else if (node.targetMode === exports.eViewpointTargetMode.mesh) {
                    delete o.targetPoint;
                    delete o.rotation;
                }
                return true;
            },
            validate: (n, v) => {
                var _a;
                if (n.changes.hasAny('targetMode', 'targetMeshId')) {
                    const exp = n.targetMode != exports.eViewpointTargetMode.mesh ||
                        (n.targetMeshId != null && ((_a = n._manager) === null || _a === void 0 ? void 0 : _a.getById(n.targetMeshId)) != null);
                    v.assert(n, 'targetMeshId', exp, 'Target mesh required');
                }
            },
        })
    ], exports.ViewpointNode);
    function isViewpointNode(node) {
        return instanceOf(node, Token.ViewpointNode);
    }

    /**
     * Does a topological sort of directed graph with cycle detection and warning.
     * @param nodes a map where the key is the node and value is an array containing the nodes the key node depends on
     * @param nameSelector function that returns a descriptive name for the node
     */
    function topologicalSort(nodes, nameSelector) {
        const visited = new Set();
        const path = new Set();
        const sorted = new Set();
        const cycles = new Array();
        for (const [node] of nodes) {
            recurse(nodes, nameSelector, node, visited, path, sorted, cycles);
        }
        // console.log(`Original graph: ${getDescriptor(nameSelector, ...nodes.keys())}`);
        // console.log(`Sorted graph:  ${getDescriptor(nameSelector, ...sorted)}`);
        return {
            sorted,
            cycles,
        };
    }
    function recurse(nodes, nameSelector, node, visited, path, sorted, cycles) {
        if (path.has(node)) {
            const items = [...path].reverse();
            cycles.push(items);
            //console.warn(`Cycle detected:  ${getDescriptor(nameSelector, ...path, node)}`);
        }
        if (visited.has(node))
            return;
        visited.add(node);
        path.add(node);
        const edges = nodes.get(node);
        if (edges) {
            for (const edge of edges) {
                recurse(nodes, nameSelector, edge, visited, path, sorted, cycles);
            }
        }
        path.delete(node);
        sorted.add(node);
    }
    // function getDescriptor(nameSelector: (n: any) => string, ...nodes: any[]){
    //     return nodes.map(n => nameSelector(n)).join(" -> ");
    // }

    /**
     * Base class of all the textures in babylon.
     * It groups all the common properties required to work with Thin Engine.
     */
    class ThinTexture {
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapU() {
            return this._wrapU;
        }
        set wrapU(value) {
            this._wrapU = value;
        }
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapV() {
            return this._wrapV;
        }
        set wrapV(value) {
            this._wrapV = value;
        }
        /**
         * How a texture is mapped.
         * Unused in thin texture mode.
         */
        get coordinatesMode() {
            return 0;
        }
        /**
         * Define if the texture is a cube texture or if false a 2d texture.
         */
        get isCube() {
            if (!this._texture) {
                return false;
            }
            return this._texture.isCube;
        }
        set isCube(value) {
            if (!this._texture) {
                return;
            }
            this._texture.isCube = value;
        }
        /**
         * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
         */
        get is3D() {
            if (!this._texture) {
                return false;
            }
            return this._texture.is3D;
        }
        set is3D(value) {
            if (!this._texture) {
                return;
            }
            this._texture.is3D = value;
        }
        /**
         * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
         */
        get is2DArray() {
            if (!this._texture) {
                return false;
            }
            return this._texture.is2DArray;
        }
        set is2DArray(value) {
            if (!this._texture) {
                return;
            }
            this._texture.is2DArray = value;
        }
        /**
         * Get the class name of the texture.
         * @returns "ThinTexture"
         */
        getClassName() {
            return "ThinTexture";
        }
        static _IsRenderTargetWrapper(texture) {
            return (texture === null || texture === void 0 ? void 0 : texture._shareDepth) !== undefined;
        }
        /**
         * Instantiates a new ThinTexture.
         * Base class of all the textures in babylon.
         * This can be used as an internal texture wrapper in ThinEngine to benefit from the cache
         * @param internalTexture Define the internalTexture to wrap. You can also pass a RenderTargetWrapper, in which case the texture will be the render target's texture
         */
        constructor(internalTexture) {
            this._wrapU = 1;
            this._wrapV = 1;
            /**
             * | Value | Type               | Description |
             * | ----- | ------------------ | ----------- |
             * | 0     | CLAMP_ADDRESSMODE  |             |
             * | 1     | WRAP_ADDRESSMODE   |             |
             * | 2     | MIRROR_ADDRESSMODE |             |
             */
            this.wrapR = 1;
            /**
             * With compliant hardware and browser (supporting anisotropic filtering)
             * this defines the level of anisotropic filtering in the texture.
             * The higher the better but the slower. This defaults to 4 as it seems to be the best tradeoff.
             */
            this.anisotropicFilteringLevel = 4;
            /**
             * Define the current state of the loading sequence when in delayed load mode.
             */
            this.delayLoadState = 0;
            /** @internal */
            this._texture = null;
            this._engine = null;
            this._cachedSize = Size.Zero();
            this._cachedBaseSize = Size.Zero();
            /** @internal */
            this._initialSamplingMode = 2;
            this._texture = ThinTexture._IsRenderTargetWrapper(internalTexture) ? internalTexture.texture : internalTexture;
            if (this._texture) {
                this._engine = this._texture.getEngine();
            }
        }
        /**
         * Get if the texture is ready to be used (downloaded, converted, mip mapped...).
         * @returns true if fully ready
         */
        isReady() {
            if (this.delayLoadState === 4) {
                this.delayLoad();
                return false;
            }
            if (this._texture) {
                return this._texture.isReady;
            }
            return false;
        }
        /**
         * Triggers the load sequence in delayed load mode.
         */
        delayLoad() { }
        /**
         * Get the underlying lower level texture from Babylon.
         * @returns the internal texture
         */
        getInternalTexture() {
            return this._texture;
        }
        /**
         * Get the size of the texture.
         * @returns the texture size.
         */
        getSize() {
            if (this._texture) {
                if (this._texture.width) {
                    this._cachedSize.width = this._texture.width;
                    this._cachedSize.height = this._texture.height;
                    return this._cachedSize;
                }
                if (this._texture._size) {
                    this._cachedSize.width = this._texture._size;
                    this._cachedSize.height = this._texture._size;
                    return this._cachedSize;
                }
            }
            return this._cachedSize;
        }
        /**
         * Get the base size of the texture.
         * It can be different from the size if the texture has been resized for POT for instance
         * @returns the base size
         */
        getBaseSize() {
            if (!this.isReady() || !this._texture) {
                this._cachedBaseSize.width = 0;
                this._cachedBaseSize.height = 0;
                return this._cachedBaseSize;
            }
            if (this._texture._size) {
                this._cachedBaseSize.width = this._texture._size;
                this._cachedBaseSize.height = this._texture._size;
                return this._cachedBaseSize;
            }
            this._cachedBaseSize.width = this._texture.baseWidth;
            this._cachedBaseSize.height = this._texture.baseHeight;
            return this._cachedBaseSize;
        }
        /**
         * Get the current sampling mode associated with the texture.
         */
        get samplingMode() {
            if (!this._texture) {
                return this._initialSamplingMode;
            }
            return this._texture.samplingMode;
        }
        /**
         * Update the sampling mode of the texture.
         * Default is Trilinear mode.
         *
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 1     | NEAREST_SAMPLINGMODE or NEAREST_NEAREST_MIPLINEAR  | Nearest is: mag = nearest, min = nearest, mip = linear |
         * | 2     | BILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPNEAREST | Bilinear is: mag = linear, min = linear, mip = nearest |
         * | 3     | TRILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPLINEAR | Trilinear is: mag = linear, min = linear, mip = linear |
         * | 4     | NEAREST_NEAREST_MIPNEAREST |             |
         * | 5    | NEAREST_LINEAR_MIPNEAREST |             |
         * | 6    | NEAREST_LINEAR_MIPLINEAR |             |
         * | 7    | NEAREST_LINEAR |             |
         * | 8    | NEAREST_NEAREST |             |
         * | 9   | LINEAR_NEAREST_MIPNEAREST |             |
         * | 10   | LINEAR_NEAREST_MIPLINEAR |             |
         * | 11   | LINEAR_LINEAR |             |
         * | 12   | LINEAR_NEAREST |             |
         *
         *    > _mag_: magnification filter (close to the viewer)
         *    > _min_: minification filter (far from the viewer)
         *    > _mip_: filter used between mip map levels
         *@param samplingMode Define the new sampling mode of the texture
         */
        updateSamplingMode(samplingMode) {
            if (this._texture && this._engine) {
                this._engine.updateTextureSamplingMode(samplingMode, this._texture);
            }
        }
        /**
         * Release and destroy the underlying lower level texture aka internalTexture.
         */
        releaseInternalTexture() {
            if (this._texture) {
                this._texture.dispose();
                this._texture = null;
            }
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            if (this._texture) {
                this.releaseInternalTexture();
                this._engine = null;
            }
        }
    }

    /**
     * Base class of all the textures in babylon.
     * It groups all the common properties the materials, post process, lights... might need
     * in order to make a correct use of the texture.
     */
    class BaseTexture extends ThinTexture {
        /**
         * Define if the texture is having a usable alpha value (can be use for transparency or glossiness for instance).
         */
        set hasAlpha(value) {
            if (this._hasAlpha === value) {
                return;
            }
            this._hasAlpha = value;
            if (this._scene) {
                this._scene.markAllMaterialsAsDirty(1, (mat) => {
                    return mat.hasTexture(this);
                });
            }
        }
        get hasAlpha() {
            return this._hasAlpha;
        }
        /**
         * Defines if the alpha value should be determined via the rgb values.
         * If true the luminance of the pixel might be used to find the corresponding alpha value.
         */
        set getAlphaFromRGB(value) {
            if (this._getAlphaFromRGB === value) {
                return;
            }
            this._getAlphaFromRGB = value;
            if (this._scene) {
                this._scene.markAllMaterialsAsDirty(1, (mat) => {
                    return mat.hasTexture(this);
                });
            }
        }
        get getAlphaFromRGB() {
            return this._getAlphaFromRGB;
        }
        /**
         * Define the UV channel to use starting from 0 and defaulting to 0.
         * This is part of the texture as textures usually maps to one uv set.
         */
        set coordinatesIndex(value) {
            if (this._coordinatesIndex === value) {
                return;
            }
            this._coordinatesIndex = value;
            if (this._scene) {
                this._scene.markAllMaterialsAsDirty(1, (mat) => {
                    return mat.hasTexture(this);
                });
            }
        }
        get coordinatesIndex() {
            return this._coordinatesIndex;
        }
        /**
         * How a texture is mapped.
         *
         * | Value | Type                                | Description |
         * | ----- | ----------------------------------- | ----------- |
         * | 0     | EXPLICIT_MODE                       |             |
         * | 1     | SPHERICAL_MODE                      |             |
         * | 2     | PLANAR_MODE                         |             |
         * | 3     | CUBIC_MODE                          |             |
         * | 4     | PROJECTION_MODE                     |             |
         * | 5     | SKYBOX_MODE                         |             |
         * | 6     | INVCUBIC_MODE                       |             |
         * | 7     | EQUIRECTANGULAR_MODE                |             |
         * | 8     | FIXED_EQUIRECTANGULAR_MODE          |             |
         * | 9     | FIXED_EQUIRECTANGULAR_MIRRORED_MODE |             |
         */
        set coordinatesMode(value) {
            if (this._coordinatesMode === value) {
                return;
            }
            this._coordinatesMode = value;
            if (this._scene) {
                this._scene.markAllMaterialsAsDirty(1, (mat) => {
                    return mat.hasTexture(this);
                });
            }
        }
        get coordinatesMode() {
            return this._coordinatesMode;
        }
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapU() {
            return this._wrapU;
        }
        set wrapU(value) {
            this._wrapU = value;
        }
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */
        get wrapV() {
            return this._wrapV;
        }
        set wrapV(value) {
            this._wrapV = value;
        }
        /**
         * Define if the texture is a cube texture or if false a 2d texture.
         */
        get isCube() {
            if (!this._texture) {
                return this._isCube;
            }
            return this._texture.isCube;
        }
        set isCube(value) {
            if (!this._texture) {
                this._isCube = value;
            }
            else {
                this._texture.isCube = value;
            }
        }
        /**
         * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
         */
        get is3D() {
            if (!this._texture) {
                return false;
            }
            return this._texture.is3D;
        }
        set is3D(value) {
            if (!this._texture) {
                return;
            }
            this._texture.is3D = value;
        }
        /**
         * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
         */
        get is2DArray() {
            if (!this._texture) {
                return false;
            }
            return this._texture.is2DArray;
        }
        set is2DArray(value) {
            if (!this._texture) {
                return;
            }
            this._texture.is2DArray = value;
        }
        /**
         * Define if the texture contains data in gamma space (most of the png/jpg aside bump).
         * HDR texture are usually stored in linear space.
         * This only impacts the PBR and Background materials
         */
        get gammaSpace() {
            if (!this._texture) {
                return this._gammaSpace;
            }
            else {
                if (this._texture._gammaSpace === null) {
                    this._texture._gammaSpace = this._gammaSpace;
                }
            }
            return this._texture._gammaSpace && !this._texture._useSRGBBuffer;
        }
        set gammaSpace(gamma) {
            if (!this._texture) {
                if (this._gammaSpace === gamma) {
                    return;
                }
                this._gammaSpace = gamma;
            }
            else {
                if (this._texture._gammaSpace === gamma) {
                    return;
                }
                this._texture._gammaSpace = gamma;
            }
            this._markAllSubMeshesAsTexturesDirty();
        }
        /**
         * Gets or sets whether or not the texture contains RGBD data.
         */
        get isRGBD() {
            return this._texture != null && this._texture._isRGBD;
        }
        set isRGBD(value) {
            if (this._texture) {
                this._texture._isRGBD = value;
            }
        }
        /**
         * Are mip maps generated for this texture or not.
         */
        get noMipmap() {
            return false;
        }
        /**
         * With prefiltered texture, defined the offset used during the prefiltering steps.
         */
        get lodGenerationOffset() {
            if (this._texture) {
                return this._texture._lodGenerationOffset;
            }
            return 0.0;
        }
        set lodGenerationOffset(value) {
            if (this._texture) {
                this._texture._lodGenerationOffset = value;
            }
        }
        /**
         * With prefiltered texture, defined the scale used during the prefiltering steps.
         */
        get lodGenerationScale() {
            if (this._texture) {
                return this._texture._lodGenerationScale;
            }
            return 0.0;
        }
        set lodGenerationScale(value) {
            if (this._texture) {
                this._texture._lodGenerationScale = value;
            }
        }
        /**
         * With prefiltered texture, defined if the specular generation is based on a linear ramp.
         * By default we are using a log2 of the linear roughness helping to keep a better resolution for
         * average roughness values.
         */
        get linearSpecularLOD() {
            if (this._texture) {
                return this._texture._linearSpecularLOD;
            }
            return false;
        }
        set linearSpecularLOD(value) {
            if (this._texture) {
                this._texture._linearSpecularLOD = value;
            }
        }
        /**
         * In case a better definition than spherical harmonics is required for the diffuse part of the environment.
         * You can set the irradiance texture to rely on a texture instead of the spherical approach.
         * This texture need to have the same characteristics than its parent (Cube vs 2d, coordinates mode, Gamma/Linear, RGBD).
         */
        get irradianceTexture() {
            if (this._texture) {
                return this._texture._irradianceTexture;
            }
            return null;
        }
        set irradianceTexture(value) {
            if (this._texture) {
                this._texture._irradianceTexture = value;
            }
        }
        /**
         * Define the unique id of the texture in the scene.
         */
        get uid() {
            if (!this._uid) {
                this._uid = RandomGUID();
            }
            return this._uid;
        }
        /**
         * Return a string representation of the texture.
         * @returns the texture as a string
         */
        toString() {
            return this.name;
        }
        /**
         * Get the class name of the texture.
         * @returns "BaseTexture"
         */
        getClassName() {
            return "BaseTexture";
        }
        /**
         * Callback triggered when the texture has been disposed.
         * Kept for back compatibility, you can use the onDisposeObservable instead.
         */
        set onDispose(callback) {
            if (this._onDisposeObserver) {
                this.onDisposeObservable.remove(this._onDisposeObserver);
            }
            this._onDisposeObserver = this.onDisposeObservable.add(callback);
        }
        /**
         * Define if the texture is preventing a material to render or not.
         * If not and the texture is not ready, the engine will use a default black texture instead.
         */
        get isBlocking() {
            return true;
        }
        /**
         * Was there any loading error?
         */
        get loadingError() {
            return this._loadingError;
        }
        /**
         * If a loading error occurred this object will be populated with information about the error.
         */
        get errorObject() {
            return this._errorObject;
        }
        /**
         * Instantiates a new BaseTexture.
         * Base class of all the textures in babylon.
         * It groups all the common properties the materials, post process, lights... might need
         * in order to make a correct use of the texture.
         * @param sceneOrEngine Define the scene or engine the texture belongs to
         * @param internalTexture Define the internal texture associated with the texture
         */
        constructor(sceneOrEngine, internalTexture = null) {
            super(null);
            /**
             * Gets or sets an object used to store user defined information.
             */
            this.metadata = null;
            /**
             * For internal use only. Please do not use.
             */
            this.reservedDataStore = null;
            this._hasAlpha = false;
            this._getAlphaFromRGB = false;
            /**
             * Intensity or strength of the texture.
             * It is commonly used by materials to fine tune the intensity of the texture
             */
            this.level = 1;
            this._coordinatesIndex = 0;
            /**
             * Gets or sets a boolean indicating that the texture should try to reduce shader code if there is no UV manipulation.
             * (ie. when texture.getTextureMatrix().isIdentityAs3x2() returns true)
             */
            this.optimizeUVAllocation = true;
            this._coordinatesMode = 0;
            /**
             * | Value | Type               | Description |
             * | ----- | ------------------ | ----------- |
             * | 0     | CLAMP_ADDRESSMODE  |             |
             * | 1     | WRAP_ADDRESSMODE   |             |
             * | 2     | MIRROR_ADDRESSMODE |             |
             */
            this.wrapR = 1;
            /**
             * With compliant hardware and browser (supporting anisotropic filtering)
             * this defines the level of anisotropic filtering in the texture.
             * The higher the better but the slower. This defaults to 4 as it seems to be the best tradeoff.
             */
            this.anisotropicFilteringLevel = BaseTexture.DEFAULT_ANISOTROPIC_FILTERING_LEVEL;
            /** @internal */
            this._isCube = false;
            this._gammaSpace = true;
            /**
             * Is Z inverted in the texture (useful in a cube texture).
             */
            this.invertZ = false;
            /**
             * @internal
             */
            this.lodLevelInAlpha = false;
            /**
             * Define if the texture is a render target.
             */
            this.isRenderTarget = false;
            /** @internal */
            this._prefiltered = false;
            /** @internal */
            this._forceSerialize = false;
            /**
             * Define the list of animation attached to the texture.
             */
            this.animations = new Array();
            /**
             * An event triggered when the texture is disposed.
             */
            this.onDisposeObservable = new Observable$1();
            this._onDisposeObserver = null;
            this._scene = null;
            /** @internal */
            this._uid = null;
            /** @internal */
            this._parentContainer = null;
            this._loadingError = false;
            if (sceneOrEngine) {
                if (BaseTexture._IsScene(sceneOrEngine)) {
                    this._scene = sceneOrEngine;
                }
                else {
                    this._engine = sceneOrEngine;
                }
            }
            else {
                this._scene = EngineStore.LastCreatedScene;
            }
            if (this._scene) {
                this.uniqueId = this._scene.getUniqueId();
                this._scene.addTexture(this);
                this._engine = this._scene.getEngine();
            }
            this._texture = internalTexture;
            this._uid = null;
        }
        /**
         * Get the scene the texture belongs to.
         * @returns the scene or null if undefined
         */
        getScene() {
            return this._scene;
        }
        /** @internal */
        _getEngine() {
            return this._engine;
        }
        /**
         * Checks if the texture has the same transform matrix than another texture
         * @param texture texture to check against
         * @returns true if the transforms are the same, else false
         */
        checkTransformsAreIdentical(texture) {
            return texture !== null;
        }
        /**
         * Get the texture transform matrix used to offset tile the texture for instance.
         * @returns the transformation matrix
         */
        getTextureMatrix() {
            return Matrix.IdentityReadOnly;
        }
        /**
         * Get the texture reflection matrix used to rotate/transform the reflection.
         * @returns the reflection matrix
         */
        getReflectionTextureMatrix() {
            return Matrix.IdentityReadOnly;
        }
        /**
         * Gets a suitable rotate/transform matrix when the texture is used for refraction.
         * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
         * @returns The refraction matrix
         */
        getRefractionTextureMatrix() {
            return this.getReflectionTextureMatrix();
        }
        /**
         * Get if the texture is ready to be consumed (either it is ready or it is not blocking)
         * @returns true if ready, not blocking or if there was an error loading the texture
         */
        isReadyOrNotBlocking() {
            return !this.isBlocking || this.isReady() || this.loadingError;
        }
        /**
         * Scales the texture if is `canRescale()`
         * @param ratio the resize factor we want to use to rescale
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        scale(ratio) { }
        /**
         * Get if the texture can rescale.
         */
        get canRescale() {
            return false;
        }
        /**
         * @internal
         */
        _getFromCache(url, noMipmap, sampling, invertY, useSRGBBuffer, isCube) {
            const engine = this._getEngine();
            if (!engine) {
                return null;
            }
            const correctedUseSRGBBuffer = engine._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
            const texturesCache = engine.getLoadedTexturesCache();
            for (let index = 0; index < texturesCache.length; index++) {
                const texturesCacheEntry = texturesCache[index];
                if (useSRGBBuffer === undefined || correctedUseSRGBBuffer === texturesCacheEntry._useSRGBBuffer) {
                    if (invertY === undefined || invertY === texturesCacheEntry.invertY) {
                        if (texturesCacheEntry.url === url && texturesCacheEntry.generateMipMaps === !noMipmap) {
                            if (!sampling || sampling === texturesCacheEntry.samplingMode) {
                                if (isCube === undefined || isCube === texturesCacheEntry.isCube) {
                                    texturesCacheEntry.incrementReferences();
                                    return texturesCacheEntry;
                                }
                            }
                        }
                    }
                }
            }
            return null;
        }
        /** @internal */
        _rebuild() { }
        /**
         * Clones the texture.
         * @returns the cloned texture
         */
        clone() {
            return null;
        }
        /**
         * Get the texture underlying type (INT, FLOAT...)
         */
        get textureType() {
            if (!this._texture) {
                return 0;
            }
            return this._texture.type !== undefined ? this._texture.type : 0;
        }
        /**
         * Get the texture underlying format (RGB, RGBA...)
         */
        get textureFormat() {
            if (!this._texture) {
                return 5;
            }
            return this._texture.format !== undefined ? this._texture.format : 5;
        }
        /**
         * Indicates that textures need to be re-calculated for all materials
         */
        _markAllSubMeshesAsTexturesDirty() {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            scene.markAllMaterialsAsDirty(1);
        }
        /**
         * Reads the pixels stored in the webgl texture and returns them as an ArrayBuffer.
         * This will returns an RGBA array buffer containing either in values (0-255) or
         * float values (0-1) depending of the underlying buffer type.
         * @param faceIndex defines the face of the texture to read (in case of cube texture)
         * @param level defines the LOD level of the texture to read (in case of Mip Maps)
         * @param buffer defines a user defined buffer to fill with data (can be null)
         * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
         * @param noDataConversion false to convert the data to Uint8Array (if texture type is UNSIGNED_BYTE) or to Float32Array (if texture type is anything but UNSIGNED_BYTE). If true, the type of the generated buffer (if buffer==null) will depend on the type of the texture
         * @param x defines the region x coordinates to start reading from (default to 0)
         * @param y defines the region y coordinates to start reading from (default to 0)
         * @param width defines the region width to read from (default to the texture size at level)
         * @param height defines the region width to read from (default to the texture size at level)
         * @returns The Array buffer promise containing the pixels data.
         */
        readPixels(faceIndex = 0, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0, width = Number.MAX_VALUE, height = Number.MAX_VALUE) {
            if (!this._texture) {
                return null;
            }
            const engine = this._getEngine();
            if (!engine) {
                return null;
            }
            const size = this.getSize();
            let maxWidth = size.width;
            let maxHeight = size.height;
            if (level !== 0) {
                maxWidth = maxWidth / Math.pow(2, level);
                maxHeight = maxHeight / Math.pow(2, level);
                maxWidth = Math.round(maxWidth);
                maxHeight = Math.round(maxHeight);
            }
            width = Math.min(maxWidth, width);
            height = Math.min(maxHeight, height);
            try {
                if (this._texture.isCube) {
                    return engine._readTexturePixels(this._texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion, x, y);
                }
                return engine._readTexturePixels(this._texture, width, height, -1, level, buffer, flushRenderer, noDataConversion, x, y);
            }
            catch (e) {
                return null;
            }
        }
        /**
         * @internal
         */
        _readPixelsSync(faceIndex = 0, level = 0, buffer = null, flushRenderer = true, noDataConversion = false) {
            if (!this._texture) {
                return null;
            }
            const size = this.getSize();
            let width = size.width;
            let height = size.height;
            const engine = this._getEngine();
            if (!engine) {
                return null;
            }
            if (level != 0) {
                width = width / Math.pow(2, level);
                height = height / Math.pow(2, level);
                width = Math.round(width);
                height = Math.round(height);
            }
            try {
                if (this._texture.isCube) {
                    return engine._readTexturePixelsSync(this._texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion);
                }
                return engine._readTexturePixelsSync(this._texture, width, height, -1, level, buffer, flushRenderer, noDataConversion);
            }
            catch (e) {
                return null;
            }
        }
        /** @internal */
        get _lodTextureHigh() {
            if (this._texture) {
                return this._texture._lodTextureHigh;
            }
            return null;
        }
        /** @internal */
        get _lodTextureMid() {
            if (this._texture) {
                return this._texture._lodTextureMid;
            }
            return null;
        }
        /** @internal */
        get _lodTextureLow() {
            if (this._texture) {
                return this._texture._lodTextureLow;
            }
            return null;
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            if (this._scene) {
                // Animations
                if (this._scene.stopAnimation) {
                    this._scene.stopAnimation(this);
                }
                // Remove from scene
                this._scene.removePendingData(this);
                const index = this._scene.textures.indexOf(this);
                if (index >= 0) {
                    this._scene.textures.splice(index, 1);
                }
                this._scene.onTextureRemovedObservable.notifyObservers(this);
                this._scene = null;
                if (this._parentContainer) {
                    const index = this._parentContainer.textures.indexOf(this);
                    if (index > -1) {
                        this._parentContainer.textures.splice(index, 1);
                    }
                    this._parentContainer = null;
                }
            }
            // Callback
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
            this.metadata = null;
            super.dispose();
        }
        /**
         * Serialize the texture into a JSON representation that can be parsed later on.
         * @param allowEmptyName True to force serialization even if name is empty. Default: false
         * @returns the JSON representation of the texture
         */
        serialize(allowEmptyName = false) {
            if (!this.name && !allowEmptyName) {
                return null;
            }
            const serializationObject = SerializationHelper.Serialize(this);
            // Animations
            SerializationHelper.AppendSerializedAnimations(this, serializationObject);
            return serializationObject;
        }
        /**
         * Helper function to be called back once a list of texture contains only ready textures.
         * @param textures Define the list of textures to wait for
         * @param callback Define the callback triggered once the entire list will be ready
         */
        static WhenAllReady(textures, callback) {
            let numRemaining = textures.length;
            if (numRemaining === 0) {
                callback();
                return;
            }
            for (let i = 0; i < textures.length; i++) {
                const texture = textures[i];
                if (texture.isReady()) {
                    if (--numRemaining === 0) {
                        callback();
                    }
                }
                else {
                    const onLoadObservable = texture.onLoadObservable;
                    if (onLoadObservable) {
                        onLoadObservable.addOnce(() => {
                            if (--numRemaining === 0) {
                                callback();
                            }
                        });
                    }
                    else {
                        if (--numRemaining === 0) {
                            callback();
                        }
                    }
                }
            }
        }
        static _IsScene(sceneOrEngine) {
            return sceneOrEngine.getClassName() === "Scene";
        }
    }
    /**
     * Default anisotropic filtering level for the application.
     * It is set to 4 as a good tradeoff between perf and quality.
     */
    BaseTexture.DEFAULT_ANISOTROPIC_FILTERING_LEVEL = 4;
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "uniqueId", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "name", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "metadata", void 0);
    __decorate$1([
        serialize("hasAlpha")
    ], BaseTexture.prototype, "_hasAlpha", void 0);
    __decorate$1([
        serialize("getAlphaFromRGB")
    ], BaseTexture.prototype, "_getAlphaFromRGB", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "level", void 0);
    __decorate$1([
        serialize("coordinatesIndex")
    ], BaseTexture.prototype, "_coordinatesIndex", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "optimizeUVAllocation", void 0);
    __decorate$1([
        serialize("coordinatesMode")
    ], BaseTexture.prototype, "_coordinatesMode", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "wrapU", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "wrapV", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "wrapR", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "anisotropicFilteringLevel", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "isCube", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "is3D", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "is2DArray", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "gammaSpace", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "invertZ", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "lodLevelInAlpha", void 0);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "lodGenerationOffset", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "lodGenerationScale", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "linearSpecularLOD", null);
    __decorate$1([
        serializeAsTexture()
    ], BaseTexture.prototype, "irradianceTexture", null);
    __decorate$1([
        serialize()
    ], BaseTexture.prototype, "isRenderTarget", void 0);

    /**
     * Transform some pixel data to a base64 string
     * @param pixels defines the pixel data to transform to base64
     * @param size defines the width and height of the (texture) data
     * @param invertY true if the data must be inverted for the Y coordinate during the conversion
     * @returns The base64 encoded string or null
     */
    function GenerateBase64StringFromPixelData(pixels, size, invertY = false) {
        const width = size.width;
        const height = size.height;
        if (pixels instanceof Float32Array) {
            let len = pixels.byteLength / pixels.BYTES_PER_ELEMENT;
            const npixels = new Uint8Array(len);
            while (--len >= 0) {
                let val = pixels[len];
                if (val < 0) {
                    val = 0;
                }
                else if (val > 1) {
                    val = 1;
                }
                npixels[len] = val * 255;
            }
            pixels = npixels;
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            return null;
        }
        const imageData = ctx.createImageData(width, height);
        const castData = imageData.data;
        castData.set(pixels);
        ctx.putImageData(imageData, 0, 0);
        if (invertY) {
            const canvas2 = document.createElement("canvas");
            canvas2.width = width;
            canvas2.height = height;
            const ctx2 = canvas2.getContext("2d");
            if (!ctx2) {
                return null;
            }
            ctx2.translate(0, height);
            ctx2.scale(1, -1);
            ctx2.drawImage(canvas, 0, 0);
            return canvas2.toDataURL("image/png");
        }
        return canvas.toDataURL("image/png");
    }
    /**
     * Reads the pixels stored in the webgl texture and returns them as a base64 string
     * @param texture defines the texture to read pixels from
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @returns The base64 encoded string or null
     */
    function GenerateBase64StringFromTexture(texture, faceIndex = 0, level = 0) {
        const internalTexture = texture.getInternalTexture();
        if (!internalTexture) {
            return null;
        }
        const pixels = texture._readPixelsSync(faceIndex, level);
        if (!pixels) {
            return null;
        }
        return GenerateBase64StringFromPixelData(pixels, texture.getSize(), internalTexture.invertY);
    }
    /**
     * Reads the pixels stored in the webgl texture and returns them as a base64 string
     * @param texture defines the texture to read pixels from
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @returns The base64 encoded string or null wrapped in a promise
     */
    async function GenerateBase64StringFromTextureAsync(texture, faceIndex = 0, level = 0) {
        const internalTexture = texture.getInternalTexture();
        if (!internalTexture) {
            return null;
        }
        const pixels = await texture.readPixels(faceIndex, level);
        if (!pixels) {
            return null;
        }
        return GenerateBase64StringFromPixelData(pixels, texture.getSize(), internalTexture.invertY);
    }

    /**
     * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#texture
     */
    class Texture extends BaseTexture {
        /**
         * Are mip maps generated for this texture or not.
         */
        get noMipmap() {
            return this._noMipmap;
        }
        /** Returns the texture mime type if it was defined by a loader (undefined else) */
        get mimeType() {
            return this._mimeType;
        }
        /**
         * Is the texture preventing material to render while loading.
         * If false, a default texture will be used instead of the loading one during the preparation step.
         */
        set isBlocking(value) {
            this._isBlocking = value;
        }
        get isBlocking() {
            return this._isBlocking;
        }
        /**
         * Gets a boolean indicating if the texture needs to be inverted on the y axis during loading
         */
        get invertY() {
            return this._invertY;
        }
        /**
         * Instantiates a new texture.
         * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#texture
         * @param url defines the url of the picture to load as a texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
         * @param invertY defines if the texture needs to be inverted on the y axis during loading
         * @param samplingMode defines the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
         * @param onLoad defines a callback triggered when the texture has been loaded
         * @param onError defines a callback triggered when an error occurred during the loading session
         * @param buffer defines the buffer to load the texture from in case the texture is loaded from a buffer representation
         * @param deleteBuffer defines if the buffer we are loading the texture from should be deleted after load
         * @param format defines the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
         * @param mimeType defines an optional mime type information
         * @param loaderOptions options to be passed to the loader
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @param forcedExtension defines the extension to use to pick the right loader
         */
        constructor(url, sceneOrEngine, noMipmapOrOptions, invertY, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, buffer = null, deleteBuffer = false, format, mimeType, loaderOptions, creationFlags, forcedExtension) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            super(sceneOrEngine);
            /**
             * Define the url of the texture.
             */
            this.url = null;
            /**
             * Define an offset on the texture to offset the u coordinates of the UVs
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#offsetting
             */
            this.uOffset = 0;
            /**
             * Define an offset on the texture to offset the v coordinates of the UVs
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#offsetting
             */
            this.vOffset = 0;
            /**
             * Define an offset on the texture to scale the u coordinates of the UVs
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#tiling
             */
            this.uScale = 1.0;
            /**
             * Define an offset on the texture to scale the v coordinates of the UVs
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#tiling
             */
            this.vScale = 1.0;
            /**
             * Define an offset on the texture to rotate around the u coordinates of the UVs
             * The angle is defined in radians.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
             */
            this.uAng = 0;
            /**
             * Define an offset on the texture to rotate around the v coordinates of the UVs
             * The angle is defined in radians.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
             */
            this.vAng = 0;
            /**
             * Define an offset on the texture to rotate around the w coordinates of the UVs (in case of 3d texture)
             * The angle is defined in radians.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
             */
            this.wAng = 0;
            /**
             * Defines the center of rotation (U)
             */
            this.uRotationCenter = 0.5;
            /**
             * Defines the center of rotation (V)
             */
            this.vRotationCenter = 0.5;
            /**
             * Defines the center of rotation (W)
             */
            this.wRotationCenter = 0.5;
            /**
             * Sets this property to true to avoid deformations when rotating the texture with non-uniform scaling
             */
            this.homogeneousRotationInUVTransform = false;
            /**
             * List of inspectable custom properties (used by the Inspector)
             * @see https://doc.babylonjs.com/toolsAndResources/inspector#extensibility
             */
            this.inspectableCustomProperties = null;
            /** @internal */
            this._noMipmap = false;
            /** @internal */
            this._invertY = false;
            this._rowGenerationMatrix = null;
            this._cachedTextureMatrix = null;
            this._projectionModeMatrix = null;
            this._t0 = null;
            this._t1 = null;
            this._t2 = null;
            this._cachedUOffset = -1;
            this._cachedVOffset = -1;
            this._cachedUScale = 0;
            this._cachedVScale = 0;
            this._cachedUAng = -1;
            this._cachedVAng = -1;
            this._cachedWAng = -1;
            this._cachedReflectionProjectionMatrixId = -1;
            this._cachedURotationCenter = -1;
            this._cachedVRotationCenter = -1;
            this._cachedWRotationCenter = -1;
            this._cachedHomogeneousRotationInUVTransform = false;
            this._cachedReflectionTextureMatrix = null;
            this._cachedReflectionUOffset = -1;
            this._cachedReflectionVOffset = -1;
            this._cachedReflectionUScale = 0;
            this._cachedReflectionVScale = 0;
            this._cachedReflectionCoordinatesMode = -1;
            /** @internal */
            this._buffer = null;
            this._deleteBuffer = false;
            this._format = null;
            this._delayedOnLoad = null;
            this._delayedOnError = null;
            /**
             * Observable triggered once the texture has been loaded.
             */
            this.onLoadObservable = new Observable$1();
            this._isBlocking = true;
            this.name = url || "";
            this.url = url;
            let noMipmap;
            let useSRGBBuffer = false;
            let internalTexture = null;
            if (typeof noMipmapOrOptions === "object" && noMipmapOrOptions !== null) {
                noMipmap = (_a = noMipmapOrOptions.noMipmap) !== null && _a !== void 0 ? _a : false;
                invertY = (_b = noMipmapOrOptions.invertY) !== null && _b !== void 0 ? _b : (CompatibilityOptions.UseOpenGLOrientationForUV ? false : true);
                samplingMode = (_c = noMipmapOrOptions.samplingMode) !== null && _c !== void 0 ? _c : Texture.TRILINEAR_SAMPLINGMODE;
                onLoad = (_d = noMipmapOrOptions.onLoad) !== null && _d !== void 0 ? _d : null;
                onError = (_e = noMipmapOrOptions.onError) !== null && _e !== void 0 ? _e : null;
                buffer = (_f = noMipmapOrOptions.buffer) !== null && _f !== void 0 ? _f : null;
                deleteBuffer = (_g = noMipmapOrOptions.deleteBuffer) !== null && _g !== void 0 ? _g : false;
                format = noMipmapOrOptions.format;
                mimeType = noMipmapOrOptions.mimeType;
                loaderOptions = noMipmapOrOptions.loaderOptions;
                creationFlags = noMipmapOrOptions.creationFlags;
                useSRGBBuffer = (_h = noMipmapOrOptions.useSRGBBuffer) !== null && _h !== void 0 ? _h : false;
                internalTexture = (_j = noMipmapOrOptions.internalTexture) !== null && _j !== void 0 ? _j : null;
            }
            else {
                noMipmap = !!noMipmapOrOptions;
            }
            this._noMipmap = noMipmap;
            this._invertY = invertY === undefined ? (CompatibilityOptions.UseOpenGLOrientationForUV ? false : true) : invertY;
            this._initialSamplingMode = samplingMode;
            this._buffer = buffer;
            this._deleteBuffer = deleteBuffer;
            this._mimeType = mimeType;
            this._loaderOptions = loaderOptions;
            this._creationFlags = creationFlags;
            this._useSRGBBuffer = useSRGBBuffer;
            this._forcedExtension = forcedExtension;
            if (format) {
                this._format = format;
            }
            const scene = this.getScene();
            const engine = this._getEngine();
            if (!engine) {
                return;
            }
            engine.onBeforeTextureInitObservable.notifyObservers(this);
            const load = () => {
                if (this._texture) {
                    if (this._texture._invertVScale) {
                        this.vScale *= -1;
                        this.vOffset += 1;
                    }
                    // Update texture to match internal texture's wrapping
                    if (this._texture._cachedWrapU !== null) {
                        this.wrapU = this._texture._cachedWrapU;
                        this._texture._cachedWrapU = null;
                    }
                    if (this._texture._cachedWrapV !== null) {
                        this.wrapV = this._texture._cachedWrapV;
                        this._texture._cachedWrapV = null;
                    }
                    if (this._texture._cachedWrapR !== null) {
                        this.wrapR = this._texture._cachedWrapR;
                        this._texture._cachedWrapR = null;
                    }
                }
                if (this.onLoadObservable.hasObservers()) {
                    this.onLoadObservable.notifyObservers(this);
                }
                if (onLoad) {
                    onLoad();
                }
                if (!this.isBlocking && scene) {
                    scene.resetCachedMaterial();
                }
            };
            const errorHandler = (message, exception) => {
                this._loadingError = true;
                this._errorObject = { message, exception };
                if (onError) {
                    onError(message, exception);
                }
                Texture.OnTextureLoadErrorObservable.notifyObservers(this);
            };
            if (!this.url && !internalTexture) {
                this._delayedOnLoad = load;
                this._delayedOnError = errorHandler;
                return;
            }
            this._texture = internalTexture !== null && internalTexture !== void 0 ? internalTexture : this._getFromCache(this.url, noMipmap, samplingMode, this._invertY, useSRGBBuffer);
            if (!this._texture) {
                if (!scene || !scene.useDelayedTextureLoading) {
                    try {
                        this._texture = engine.createTexture(this.url, noMipmap, this._invertY, scene, samplingMode, load, errorHandler, this._buffer, undefined, this._format, this._forcedExtension, mimeType, loaderOptions, creationFlags, useSRGBBuffer);
                    }
                    catch (e) {
                        errorHandler("error loading", e);
                        throw e;
                    }
                    if (deleteBuffer) {
                        this._buffer = null;
                    }
                }
                else {
                    this.delayLoadState = 4;
                    this._delayedOnLoad = load;
                    this._delayedOnError = errorHandler;
                }
            }
            else {
                if (this._texture.isReady) {
                    TimingTools.SetImmediate(() => load());
                }
                else {
                    const loadObserver = this._texture.onLoadedObservable.add(load);
                    this._texture.onErrorObservable.add((e) => {
                        var _a;
                        errorHandler(e.message, e.exception);
                        (_a = this._texture) === null || _a === void 0 ? void 0 : _a.onLoadedObservable.remove(loadObserver);
                    });
                }
            }
        }
        /**
         * Update the url (and optional buffer) of this texture if url was null during construction.
         * @param url the url of the texture
         * @param buffer the buffer of the texture (defaults to null)
         * @param onLoad callback called when the texture is loaded  (defaults to null)
         * @param forcedExtension defines the extension to use to pick the right loader
         */
        updateURL(url, buffer = null, onLoad, forcedExtension) {
            if (this.url) {
                this.releaseInternalTexture();
                this.getScene().markAllMaterialsAsDirty(1);
            }
            if (!this.name || this.name.startsWith("data:")) {
                this.name = url;
            }
            this.url = url;
            this._buffer = buffer;
            this._forcedExtension = forcedExtension;
            this.delayLoadState = 4;
            if (onLoad) {
                this._delayedOnLoad = onLoad;
            }
            this.delayLoad();
        }
        /**
         * Finish the loading sequence of a texture flagged as delayed load.
         * @internal
         */
        delayLoad() {
            if (this.delayLoadState !== 4) {
                return;
            }
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            this.delayLoadState = 1;
            this._texture = this._getFromCache(this.url, this._noMipmap, this.samplingMode, this._invertY, this._useSRGBBuffer);
            if (!this._texture) {
                this._texture = scene
                    .getEngine()
                    .createTexture(this.url, this._noMipmap, this._invertY, scene, this.samplingMode, this._delayedOnLoad, this._delayedOnError, this._buffer, null, this._format, this._forcedExtension, this._mimeType, this._loaderOptions, this._creationFlags, this._useSRGBBuffer);
                if (this._deleteBuffer) {
                    this._buffer = null;
                }
            }
            else {
                if (this._delayedOnLoad) {
                    if (this._texture.isReady) {
                        TimingTools.SetImmediate(this._delayedOnLoad);
                    }
                    else {
                        this._texture.onLoadedObservable.add(this._delayedOnLoad);
                    }
                }
            }
            this._delayedOnLoad = null;
            this._delayedOnError = null;
        }
        _prepareRowForTextureGeneration(x, y, z, t) {
            x *= this._cachedUScale;
            y *= this._cachedVScale;
            x -= this.uRotationCenter * this._cachedUScale;
            y -= this.vRotationCenter * this._cachedVScale;
            z -= this.wRotationCenter;
            Vector3.TransformCoordinatesFromFloatsToRef(x, y, z, this._rowGenerationMatrix, t);
            t.x += this.uRotationCenter * this._cachedUScale + this._cachedUOffset;
            t.y += this.vRotationCenter * this._cachedVScale + this._cachedVOffset;
            t.z += this.wRotationCenter;
        }
        /**
         * Checks if the texture has the same transform matrix than another texture
         * @param texture texture to check against
         * @returns true if the transforms are the same, else false
         */
        checkTransformsAreIdentical(texture) {
            return (texture !== null &&
                this.uOffset === texture.uOffset &&
                this.vOffset === texture.vOffset &&
                this.uScale === texture.uScale &&
                this.vScale === texture.vScale &&
                this.uAng === texture.uAng &&
                this.vAng === texture.vAng &&
                this.wAng === texture.wAng);
        }
        /**
         * Get the current texture matrix which includes the requested offsetting, tiling and rotation components.
         * @param uBase
         * @returns the transform matrix of the texture.
         */
        getTextureMatrix(uBase = 1) {
            if (this.uOffset === this._cachedUOffset &&
                this.vOffset === this._cachedVOffset &&
                this.uScale * uBase === this._cachedUScale &&
                this.vScale === this._cachedVScale &&
                this.uAng === this._cachedUAng &&
                this.vAng === this._cachedVAng &&
                this.wAng === this._cachedWAng &&
                this.uRotationCenter === this._cachedURotationCenter &&
                this.vRotationCenter === this._cachedVRotationCenter &&
                this.wRotationCenter === this._cachedWRotationCenter &&
                this.homogeneousRotationInUVTransform === this._cachedHomogeneousRotationInUVTransform) {
                return this._cachedTextureMatrix;
            }
            this._cachedUOffset = this.uOffset;
            this._cachedVOffset = this.vOffset;
            this._cachedUScale = this.uScale * uBase;
            this._cachedVScale = this.vScale;
            this._cachedUAng = this.uAng;
            this._cachedVAng = this.vAng;
            this._cachedWAng = this.wAng;
            this._cachedURotationCenter = this.uRotationCenter;
            this._cachedVRotationCenter = this.vRotationCenter;
            this._cachedWRotationCenter = this.wRotationCenter;
            this._cachedHomogeneousRotationInUVTransform = this.homogeneousRotationInUVTransform;
            if (!this._cachedTextureMatrix || !this._rowGenerationMatrix) {
                this._cachedTextureMatrix = Matrix.Zero();
                this._rowGenerationMatrix = new Matrix();
                this._t0 = Vector3.Zero();
                this._t1 = Vector3.Zero();
                this._t2 = Vector3.Zero();
            }
            Matrix.RotationYawPitchRollToRef(this.vAng, this.uAng, this.wAng, this._rowGenerationMatrix);
            if (this.homogeneousRotationInUVTransform) {
                Matrix.TranslationToRef(-this._cachedURotationCenter, -this._cachedVRotationCenter, -this._cachedWRotationCenter, TmpVectors.Matrix[0]);
                Matrix.TranslationToRef(this._cachedURotationCenter, this._cachedVRotationCenter, this._cachedWRotationCenter, TmpVectors.Matrix[1]);
                Matrix.ScalingToRef(this._cachedUScale, this._cachedVScale, 0, TmpVectors.Matrix[2]);
                Matrix.TranslationToRef(this._cachedUOffset, this._cachedVOffset, 0, TmpVectors.Matrix[3]);
                TmpVectors.Matrix[0].multiplyToRef(this._rowGenerationMatrix, this._cachedTextureMatrix);
                this._cachedTextureMatrix.multiplyToRef(TmpVectors.Matrix[1], this._cachedTextureMatrix);
                this._cachedTextureMatrix.multiplyToRef(TmpVectors.Matrix[2], this._cachedTextureMatrix);
                this._cachedTextureMatrix.multiplyToRef(TmpVectors.Matrix[3], this._cachedTextureMatrix);
                // copy the translation row to the 3rd row of the matrix so that we don't need to update the shaders (which expects the translation to be on the 3rd row)
                this._cachedTextureMatrix.setRowFromFloats(2, this._cachedTextureMatrix.m[12], this._cachedTextureMatrix.m[13], this._cachedTextureMatrix.m[14], 1);
            }
            else {
                this._prepareRowForTextureGeneration(0, 0, 0, this._t0);
                this._prepareRowForTextureGeneration(1.0, 0, 0, this._t1);
                this._prepareRowForTextureGeneration(0, 1.0, 0, this._t2);
                this._t1.subtractInPlace(this._t0);
                this._t2.subtractInPlace(this._t0);
                Matrix.FromValuesToRef(this._t1.x, this._t1.y, this._t1.z, 0.0, this._t2.x, this._t2.y, this._t2.z, 0.0, this._t0.x, this._t0.y, this._t0.z, 0.0, 0.0, 0.0, 0.0, 1.0, this._cachedTextureMatrix);
            }
            const scene = this.getScene();
            if (!scene) {
                return this._cachedTextureMatrix;
            }
            if (this.optimizeUVAllocation) {
                // We flag the materials that are using this texture as "texture dirty" because depending on the fact that the matrix is the identity or not, some defines
                // will get different values (see MaterialHelper.PrepareDefinesForMergedUV), meaning we should regenerate the effect accordingly
                scene.markAllMaterialsAsDirty(1, (mat) => {
                    return mat.hasTexture(this);
                });
            }
            return this._cachedTextureMatrix;
        }
        /**
         * Get the current matrix used to apply reflection. This is useful to rotate an environment texture for instance.
         * @returns The reflection texture transform
         */
        getReflectionTextureMatrix() {
            const scene = this.getScene();
            if (!scene) {
                return this._cachedReflectionTextureMatrix;
            }
            if (this.uOffset === this._cachedReflectionUOffset &&
                this.vOffset === this._cachedReflectionVOffset &&
                this.uScale === this._cachedReflectionUScale &&
                this.vScale === this._cachedReflectionVScale &&
                this.coordinatesMode === this._cachedReflectionCoordinatesMode) {
                if (this.coordinatesMode === Texture.PROJECTION_MODE) {
                    if (this._cachedReflectionProjectionMatrixId === scene.getProjectionMatrix().updateFlag) {
                        return this._cachedReflectionTextureMatrix;
                    }
                }
                else {
                    return this._cachedReflectionTextureMatrix;
                }
            }
            if (!this._cachedReflectionTextureMatrix) {
                this._cachedReflectionTextureMatrix = Matrix.Zero();
            }
            if (!this._projectionModeMatrix) {
                this._projectionModeMatrix = Matrix.Zero();
            }
            const flagMaterialsAsTextureDirty = this._cachedReflectionCoordinatesMode !== this.coordinatesMode;
            this._cachedReflectionUOffset = this.uOffset;
            this._cachedReflectionVOffset = this.vOffset;
            this._cachedReflectionUScale = this.uScale;
            this._cachedReflectionVScale = this.vScale;
            this._cachedReflectionCoordinatesMode = this.coordinatesMode;
            switch (this.coordinatesMode) {
                case Texture.PLANAR_MODE: {
                    Matrix.IdentityToRef(this._cachedReflectionTextureMatrix);
                    this._cachedReflectionTextureMatrix[0] = this.uScale;
                    this._cachedReflectionTextureMatrix[5] = this.vScale;
                    this._cachedReflectionTextureMatrix[12] = this.uOffset;
                    this._cachedReflectionTextureMatrix[13] = this.vOffset;
                    break;
                }
                case Texture.PROJECTION_MODE: {
                    Matrix.FromValuesToRef(0.5, 0.0, 0.0, 0.0, 0.0, -0.5, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.5, 0.5, 1.0, 1.0, this._projectionModeMatrix);
                    const projectionMatrix = scene.getProjectionMatrix();
                    this._cachedReflectionProjectionMatrixId = projectionMatrix.updateFlag;
                    projectionMatrix.multiplyToRef(this._projectionModeMatrix, this._cachedReflectionTextureMatrix);
                    break;
                }
                default:
                    Matrix.IdentityToRef(this._cachedReflectionTextureMatrix);
                    break;
            }
            if (flagMaterialsAsTextureDirty) {
                // We flag the materials that are using this texture as "texture dirty" if the coordinatesMode has changed.
                // Indeed, this property is used to set the value of some defines used to generate the effect (in material.isReadyForSubMesh), so we must make sure this code will be re-executed and the effect recreated if necessary
                scene.markAllMaterialsAsDirty(1, (mat) => {
                    return mat.getActiveTextures().indexOf(this) !== -1;
                });
            }
            return this._cachedReflectionTextureMatrix;
        }
        /**
         * Clones the texture.
         * @returns the cloned texture
         */
        clone() {
            const options = {
                noMipmap: this._noMipmap,
                invertY: this._invertY,
                samplingMode: this.samplingMode,
                onLoad: undefined,
                onError: undefined,
                buffer: this._texture ? this._texture._buffer : undefined,
                deleteBuffer: this._deleteBuffer,
                format: this.textureFormat,
                mimeType: this.mimeType,
                loaderOptions: this._loaderOptions,
                creationFlags: this._creationFlags,
                useSRGBBuffer: this._useSRGBBuffer,
            };
            return SerializationHelper.Clone(() => {
                return new Texture(this._texture ? this._texture.url : null, this.getScene(), options);
            }, this);
        }
        /**
         * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
         * @returns The JSON representation of the texture
         */
        serialize() {
            var _a, _b;
            const savedName = this.name;
            if (!Texture.SerializeBuffers) {
                if (this.name.startsWith("data:")) {
                    this.name = "";
                }
            }
            if (this.name.startsWith("data:") && this.url === this.name) {
                this.url = "";
            }
            const serializationObject = super.serialize(Texture._SerializeInternalTextureUniqueId);
            if (!serializationObject) {
                return null;
            }
            if (Texture.SerializeBuffers || Texture.ForceSerializeBuffers) {
                if (typeof this._buffer === "string" && this._buffer.substr(0, 5) === "data:") {
                    serializationObject.base64String = this._buffer;
                    serializationObject.name = serializationObject.name.replace("data:", "");
                }
                else if (this.url && this.url.startsWith("data:") && this._buffer instanceof Uint8Array) {
                    serializationObject.base64String = "data:image/png;base64," + EncodeArrayBufferToBase64(this._buffer);
                }
                else if (Texture.ForceSerializeBuffers || (this.url && this.url.startsWith("blob:")) || this._forceSerialize) {
                    serializationObject.base64String =
                        !this._engine || this._engine._features.supportSyncTextureRead ? GenerateBase64StringFromTexture(this) : GenerateBase64StringFromTextureAsync(this);
                }
            }
            serializationObject.invertY = this._invertY;
            serializationObject.samplingMode = this.samplingMode;
            serializationObject._creationFlags = this._creationFlags;
            serializationObject._useSRGBBuffer = this._useSRGBBuffer;
            if (Texture._SerializeInternalTextureUniqueId) {
                serializationObject.internalTextureUniqueId = (_b = (_a = this._texture) === null || _a === void 0 ? void 0 : _a.uniqueId) !== null && _b !== void 0 ? _b : undefined;
            }
            this.name = savedName;
            return serializationObject;
        }
        /**
         * Get the current class name of the texture useful for serialization or dynamic coding.
         * @returns "Texture"
         */
        getClassName() {
            return "Texture";
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            super.dispose();
            this.onLoadObservable.clear();
            this._delayedOnLoad = null;
            this._delayedOnError = null;
            this._buffer = null;
        }
        /**
         * Parse the JSON representation of a texture in order to recreate the texture in the given scene.
         * @param parsedTexture Define the JSON representation of the texture
         * @param scene Define the scene the parsed texture should be instantiated in
         * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
         * @returns The parsed texture if successful
         */
        static Parse(parsedTexture, scene, rootUrl) {
            if (parsedTexture.customType) {
                const customTexture = InstantiationTools.Instantiate(parsedTexture.customType);
                // Update Sampling Mode
                const parsedCustomTexture = customTexture.Parse(parsedTexture, scene, rootUrl);
                if (parsedTexture.samplingMode && parsedCustomTexture.updateSamplingMode && parsedCustomTexture._samplingMode) {
                    if (parsedCustomTexture._samplingMode !== parsedTexture.samplingMode) {
                        parsedCustomTexture.updateSamplingMode(parsedTexture.samplingMode);
                    }
                }
                return parsedCustomTexture;
            }
            if (parsedTexture.isCube && !parsedTexture.isRenderTarget) {
                return Texture._CubeTextureParser(parsedTexture, scene, rootUrl);
            }
            const hasInternalTextureUniqueId = parsedTexture.internalTextureUniqueId !== undefined;
            if (!parsedTexture.name && !parsedTexture.isRenderTarget && !hasInternalTextureUniqueId) {
                return null;
            }
            let internalTexture;
            if (hasInternalTextureUniqueId) {
                const cache = scene.getEngine().getLoadedTexturesCache();
                for (const texture of cache) {
                    if (texture.uniqueId === parsedTexture.internalTextureUniqueId) {
                        internalTexture = texture;
                        break;
                    }
                }
            }
            const onLoaded = (texture) => {
                var _a;
                // Clear cache
                if (texture && texture._texture) {
                    texture._texture._cachedWrapU = null;
                    texture._texture._cachedWrapV = null;
                    texture._texture._cachedWrapR = null;
                }
                // Update Sampling Mode
                if (parsedTexture.samplingMode) {
                    const sampling = parsedTexture.samplingMode;
                    if (texture && texture.samplingMode !== sampling) {
                        texture.updateSamplingMode(sampling);
                    }
                }
                // Animations
                if (texture && parsedTexture.animations) {
                    for (let animationIndex = 0; animationIndex < parsedTexture.animations.length; animationIndex++) {
                        const parsedAnimation = parsedTexture.animations[animationIndex];
                        const internalClass = GetClass("BABYLON.Animation");
                        if (internalClass) {
                            texture.animations.push(internalClass.Parse(parsedAnimation));
                        }
                    }
                }
                if (hasInternalTextureUniqueId && !internalTexture) {
                    (_a = texture === null || texture === void 0 ? void 0 : texture._texture) === null || _a === void 0 ? void 0 : _a._setUniqueId(parsedTexture.internalTextureUniqueId);
                }
            };
            const texture = SerializationHelper.Parse(() => {
                var _a, _b, _c;
                let generateMipMaps = true;
                if (parsedTexture.noMipmap) {
                    generateMipMaps = false;
                }
                if (parsedTexture.mirrorPlane) {
                    const mirrorTexture = Texture._CreateMirror(parsedTexture.name, parsedTexture.renderTargetSize, scene, generateMipMaps);
                    mirrorTexture._waitingRenderList = parsedTexture.renderList;
                    mirrorTexture.mirrorPlane = Plane.FromArray(parsedTexture.mirrorPlane);
                    onLoaded(mirrorTexture);
                    return mirrorTexture;
                }
                else if (parsedTexture.isRenderTarget) {
                    let renderTargetTexture = null;
                    if (parsedTexture.isCube) {
                        // Search for an existing reflection probe (which contains a cube render target texture)
                        if (scene.reflectionProbes) {
                            for (let index = 0; index < scene.reflectionProbes.length; index++) {
                                const probe = scene.reflectionProbes[index];
                                if (probe.name === parsedTexture.name) {
                                    return probe.cubeTexture;
                                }
                            }
                        }
                    }
                    else {
                        renderTargetTexture = Texture._CreateRenderTargetTexture(parsedTexture.name, parsedTexture.renderTargetSize, scene, generateMipMaps, (_a = parsedTexture._creationFlags) !== null && _a !== void 0 ? _a : 0);
                        renderTargetTexture._waitingRenderList = parsedTexture.renderList;
                    }
                    onLoaded(renderTargetTexture);
                    return renderTargetTexture;
                }
                else {
                    let texture;
                    if (parsedTexture.base64String && !internalTexture) {
                        // name and url are the same to ensure caching happens from the actual base64 string
                        texture = Texture.CreateFromBase64String(parsedTexture.base64String, parsedTexture.base64String, scene, !generateMipMaps, parsedTexture.invertY, parsedTexture.samplingMode, () => {
                            onLoaded(texture);
                        }, (_b = parsedTexture._creationFlags) !== null && _b !== void 0 ? _b : 0, (_c = parsedTexture._useSRGBBuffer) !== null && _c !== void 0 ? _c : false);
                        // prettier name to fit with the loaded data
                        texture.name = parsedTexture.name;
                    }
                    else {
                        let url;
                        if (parsedTexture.name && (parsedTexture.name.indexOf("://") > 0 || parsedTexture.name.startsWith("data:"))) {
                            url = parsedTexture.name;
                        }
                        else {
                            url = rootUrl + parsedTexture.name;
                        }
                        if (parsedTexture.url && (parsedTexture.url.startsWith("data:") || Texture.UseSerializedUrlIfAny)) {
                            url = parsedTexture.url;
                        }
                        const options = {
                            noMipmap: !generateMipMaps,
                            invertY: parsedTexture.invertY,
                            samplingMode: parsedTexture.samplingMode,
                            onLoad: () => {
                                onLoaded(texture);
                            },
                            internalTexture,
                        };
                        texture = new Texture(url, scene, options);
                    }
                    return texture;
                }
            }, parsedTexture, scene);
            return texture;
        }
        /**
         * Creates a texture from its base 64 representation.
         * @param data Define the base64 payload without the data: prefix
         * @param name Define the name of the texture in the scene useful fo caching purpose for instance
         * @param scene Define the scene the texture should belong to
         * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
         * @param invertY define if the texture needs to be inverted on the y axis during loading
         * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
         * @param onLoad define a callback triggered when the texture has been loaded
         * @param onError define a callback triggered when an error occurred during the loading session
         * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @returns the created texture
         */
        static CreateFromBase64String(data, name, scene, noMipmapOrOptions, invertY, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, format = 5, creationFlags) {
            return new Texture("data:" + name, scene, noMipmapOrOptions, invertY, samplingMode, onLoad, onError, data, false, format, undefined, undefined, creationFlags);
        }
        /**
         * Creates a texture from its data: representation. (data: will be added in case only the payload has been passed in)
         * @param name Define the name of the texture in the scene useful fo caching purpose for instance
         * @param buffer define the buffer to load the texture from in case the texture is loaded from a buffer representation
         * @param scene Define the scene the texture should belong to
         * @param deleteBuffer define if the buffer we are loading the texture from should be deleted after load
         * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
         * @param invertY define if the texture needs to be inverted on the y axis during loading
         * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
         * @param onLoad define a callback triggered when the texture has been loaded
         * @param onError define a callback triggered when an error occurred during the loading session
         * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @returns the created texture
         */
        static LoadFromDataString(name, buffer, scene, deleteBuffer = false, noMipmapOrOptions, invertY = true, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, format = 5, creationFlags) {
            if (name.substr(0, 5) !== "data:") {
                name = "data:" + name;
            }
            return new Texture(name, scene, noMipmapOrOptions, invertY, samplingMode, onLoad, onError, buffer, deleteBuffer, format, undefined, undefined, creationFlags);
        }
    }
    /**
     * Gets or sets a general boolean used to indicate that textures containing direct data (buffers) must be saved as part of the serialization process
     */
    Texture.SerializeBuffers = true;
    /**
     * Gets or sets a general boolean used to indicate that texture buffers must be saved as part of the serialization process.
     * If no buffer exists, one will be created as base64 string from the internal webgl data.
     */
    Texture.ForceSerializeBuffers = false;
    /**
     * This observable will notify when any texture had a loading error
     */
    Texture.OnTextureLoadErrorObservable = new Observable$1();
    /** @internal */
    Texture._SerializeInternalTextureUniqueId = false;
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Texture._CubeTextureParser = (jsonTexture, scene, rootUrl) => {
        throw _WarnImport("CubeTexture");
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Texture._CreateMirror = (name, renderTargetSize, scene, generateMipMaps) => {
        throw _WarnImport("MirrorTexture");
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Texture._CreateRenderTargetTexture = (name, renderTargetSize, scene, generateMipMaps, creationFlags) => {
        throw _WarnImport("RenderTargetTexture");
    };
    /** nearest is mag = nearest and min = nearest and no mip */
    Texture.NEAREST_SAMPLINGMODE = 1;
    /** nearest is mag = nearest and min = nearest and mip = linear */
    Texture.NEAREST_NEAREST_MIPLINEAR = 8; // nearest is mag = nearest and min = nearest and mip = linear
    /** Bilinear is mag = linear and min = linear and no mip */
    Texture.BILINEAR_SAMPLINGMODE = 2;
    /** Bilinear is mag = linear and min = linear and mip = nearest */
    Texture.LINEAR_LINEAR_MIPNEAREST = 11; // Bilinear is mag = linear and min = linear and mip = nearest
    /** Trilinear is mag = linear and min = linear and mip = linear */
    Texture.TRILINEAR_SAMPLINGMODE = 3;
    /** Trilinear is mag = linear and min = linear and mip = linear */
    Texture.LINEAR_LINEAR_MIPLINEAR = 3; // Trilinear is mag = linear and min = linear and mip = linear
    /** mag = nearest and min = nearest and mip = nearest */
    Texture.NEAREST_NEAREST_MIPNEAREST = 4;
    /** mag = nearest and min = linear and mip = nearest */
    Texture.NEAREST_LINEAR_MIPNEAREST = 5;
    /** mag = nearest and min = linear and mip = linear */
    Texture.NEAREST_LINEAR_MIPLINEAR = 6;
    /** mag = nearest and min = linear and mip = none */
    Texture.NEAREST_LINEAR = 7;
    /** mag = nearest and min = nearest and mip = none */
    Texture.NEAREST_NEAREST = 1;
    /** mag = linear and min = nearest and mip = nearest */
    Texture.LINEAR_NEAREST_MIPNEAREST = 9;
    /** mag = linear and min = nearest and mip = linear */
    Texture.LINEAR_NEAREST_MIPLINEAR = 10;
    /** mag = linear and min = linear and mip = none */
    Texture.LINEAR_LINEAR = 2;
    /** mag = linear and min = nearest and mip = none */
    Texture.LINEAR_NEAREST = 12;
    /** Explicit coordinates mode */
    Texture.EXPLICIT_MODE = 0;
    /** Spherical coordinates mode */
    Texture.SPHERICAL_MODE = 1;
    /** Planar coordinates mode */
    Texture.PLANAR_MODE = 2;
    /** Cubic coordinates mode */
    Texture.CUBIC_MODE = 3;
    /** Projection coordinates mode */
    Texture.PROJECTION_MODE = 4;
    /** Inverse Cubic coordinates mode */
    Texture.SKYBOX_MODE = 5;
    /** Inverse Cubic coordinates mode */
    Texture.INVCUBIC_MODE = 6;
    /** Equirectangular coordinates mode */
    Texture.EQUIRECTANGULAR_MODE = 7;
    /** Equirectangular Fixed coordinates mode */
    Texture.FIXED_EQUIRECTANGULAR_MODE = 8;
    /** Equirectangular Fixed Mirrored coordinates mode */
    Texture.FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
    /** Texture is not repeating outside of 0..1 UVs */
    Texture.CLAMP_ADDRESSMODE = 0;
    /** Texture is repeating outside of 0..1 UVs */
    Texture.WRAP_ADDRESSMODE = 1;
    /** Texture is repeating and mirrored */
    Texture.MIRROR_ADDRESSMODE = 2;
    /**
     * Gets or sets a boolean which defines if the texture url must be build from the serialized URL instead of just using the name and loading them side by side with the scene file
     */
    Texture.UseSerializedUrlIfAny = false;
    __decorate$1([
        serialize()
    ], Texture.prototype, "url", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "uOffset", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "vOffset", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "uScale", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "vScale", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "uAng", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "vAng", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "wAng", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "uRotationCenter", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "vRotationCenter", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "wRotationCenter", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "homogeneousRotationInUVTransform", void 0);
    __decorate$1([
        serialize()
    ], Texture.prototype, "isBlocking", null);
    // References the dependencies.
    RegisterClass("BABYLON.Texture", Texture);
    SerializationHelper._TextureParser = Texture.Parse;

    /**
     * Configuration needed for prepass-capable materials
     */
    class PrePassConfiguration {
        constructor() {
            /**
             * Previous world matrices of meshes carrying this material
             * Used for computing velocity
             */
            this.previousWorldMatrices = {};
            /**
             * Previous bones of meshes carrying this material
             * Used for computing velocity
             */
            this.previousBones = {};
        }
        /**
         * Add the required uniforms to the current list.
         * @param uniforms defines the current uniform list.
         */
        static AddUniforms(uniforms) {
            uniforms.push("previousWorld", "previousViewProjection", "mPreviousBones");
        }
        /**
         * Add the required samplers to the current list.
         * @param samplers defines the current sampler list.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static AddSamplers(samplers) {
            // pass
        }
        /**
         * Binds the material data.
         * @param effect defines the effect to update
         * @param scene defines the scene the material belongs to.
         * @param mesh The mesh
         * @param world World matrix of this mesh
         * @param isFrozen Is the material frozen
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bindForSubMesh(effect, scene, mesh, world, isFrozen) {
            if (scene.prePassRenderer && scene.prePassRenderer.enabled && scene.prePassRenderer.currentRTisSceneRT) {
                if (scene.prePassRenderer.getIndex(2) !== -1) {
                    if (!this.previousWorldMatrices[mesh.uniqueId]) {
                        this.previousWorldMatrices[mesh.uniqueId] = world.clone();
                    }
                    if (!this.previousViewProjection) {
                        this.previousViewProjection = scene.getTransformMatrix().clone();
                        this.currentViewProjection = scene.getTransformMatrix().clone();
                    }
                    const engine = scene.getEngine();
                    if (this.currentViewProjection.updateFlag !== scene.getTransformMatrix().updateFlag) {
                        // First update of the prepass configuration for this rendering pass
                        this._lastUpdateFrameId = engine.frameId;
                        this.previousViewProjection.copyFrom(this.currentViewProjection);
                        this.currentViewProjection.copyFrom(scene.getTransformMatrix());
                    }
                    else if (this._lastUpdateFrameId !== engine.frameId) {
                        // The scene transformation did not change from the previous frame (so no camera motion), we must update previousViewProjection accordingly
                        this._lastUpdateFrameId = engine.frameId;
                        this.previousViewProjection.copyFrom(this.currentViewProjection);
                    }
                    effect.setMatrix("previousWorld", this.previousWorldMatrices[mesh.uniqueId]);
                    effect.setMatrix("previousViewProjection", this.previousViewProjection);
                    this.previousWorldMatrices[mesh.uniqueId] = world.clone();
                }
            }
        }
    }

    /**
     * Base class of materials working in push mode in babylon JS
     * @internal
     */
    class PushMaterial extends Material {
        constructor(name, scene, storeEffectOnSubMeshes = true) {
            super(name, scene);
            this._normalMatrix = new Matrix();
            this._storeEffectOnSubMeshes = storeEffectOnSubMeshes;
        }
        getEffect() {
            return this._storeEffectOnSubMeshes ? this._activeEffect : super.getEffect();
        }
        isReady(mesh, useInstances) {
            if (!mesh) {
                return false;
            }
            if (!this._storeEffectOnSubMeshes) {
                return true;
            }
            if (!mesh.subMeshes || mesh.subMeshes.length === 0) {
                return true;
            }
            return this.isReadyForSubMesh(mesh, mesh.subMeshes[0], useInstances);
        }
        _isReadyForSubMesh(subMesh) {
            const defines = subMesh.materialDefines;
            if (!this.checkReadyOnEveryCall && subMesh.effect && defines) {
                if (defines._renderId === this.getScene().getRenderId()) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Binds the given world matrix to the active effect
         *
         * @param world the matrix to bind
         */
        bindOnlyWorldMatrix(world) {
            this._activeEffect.setMatrix("world", world);
        }
        /**
         * Binds the given normal matrix to the active effect
         *
         * @param normalMatrix the matrix to bind
         */
        bindOnlyNormalMatrix(normalMatrix) {
            this._activeEffect.setMatrix("normalMatrix", normalMatrix);
        }
        bind(world, mesh) {
            if (!mesh) {
                return;
            }
            this.bindForSubMesh(world, mesh, mesh.subMeshes[0]);
        }
        _afterBind(mesh, effect = null) {
            super._afterBind(mesh, effect);
            this.getScene()._cachedEffect = effect;
            if (effect) {
                effect._forceRebindOnNextCall = false;
            }
        }
        _mustRebind(scene, effect, visibility = 1) {
            return scene.isCachedMaterialInvalid(this, effect, visibility);
        }
        dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
            this._activeEffect = undefined;
            super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
        }
    }

    /**
     * This groups all the flags used to control the materials channel.
     */
    class MaterialFlags {
        /**
         * Are diffuse textures enabled in the application.
         */
        static get DiffuseTextureEnabled() {
            return this._DiffuseTextureEnabled;
        }
        static set DiffuseTextureEnabled(value) {
            if (this._DiffuseTextureEnabled === value) {
                return;
            }
            this._DiffuseTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are detail textures enabled in the application.
         */
        static get DetailTextureEnabled() {
            return this._DetailTextureEnabled;
        }
        static set DetailTextureEnabled(value) {
            if (this._DetailTextureEnabled === value) {
                return;
            }
            this._DetailTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are decal maps enabled in the application.
         */
        static get DecalMapEnabled() {
            return this._DecalMapEnabled;
        }
        static set DecalMapEnabled(value) {
            if (this._DecalMapEnabled === value) {
                return;
            }
            this._DecalMapEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are ambient textures enabled in the application.
         */
        static get AmbientTextureEnabled() {
            return this._AmbientTextureEnabled;
        }
        static set AmbientTextureEnabled(value) {
            if (this._AmbientTextureEnabled === value) {
                return;
            }
            this._AmbientTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are opacity textures enabled in the application.
         */
        static get OpacityTextureEnabled() {
            return this._OpacityTextureEnabled;
        }
        static set OpacityTextureEnabled(value) {
            if (this._OpacityTextureEnabled === value) {
                return;
            }
            this._OpacityTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are reflection textures enabled in the application.
         */
        static get ReflectionTextureEnabled() {
            return this._ReflectionTextureEnabled;
        }
        static set ReflectionTextureEnabled(value) {
            if (this._ReflectionTextureEnabled === value) {
                return;
            }
            this._ReflectionTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are emissive textures enabled in the application.
         */
        static get EmissiveTextureEnabled() {
            return this._EmissiveTextureEnabled;
        }
        static set EmissiveTextureEnabled(value) {
            if (this._EmissiveTextureEnabled === value) {
                return;
            }
            this._EmissiveTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are specular textures enabled in the application.
         */
        static get SpecularTextureEnabled() {
            return this._SpecularTextureEnabled;
        }
        static set SpecularTextureEnabled(value) {
            if (this._SpecularTextureEnabled === value) {
                return;
            }
            this._SpecularTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are bump textures enabled in the application.
         */
        static get BumpTextureEnabled() {
            return this._BumpTextureEnabled;
        }
        static set BumpTextureEnabled(value) {
            if (this._BumpTextureEnabled === value) {
                return;
            }
            this._BumpTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are lightmap textures enabled in the application.
         */
        static get LightmapTextureEnabled() {
            return this._LightmapTextureEnabled;
        }
        static set LightmapTextureEnabled(value) {
            if (this._LightmapTextureEnabled === value) {
                return;
            }
            this._LightmapTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are refraction textures enabled in the application.
         */
        static get RefractionTextureEnabled() {
            return this._RefractionTextureEnabled;
        }
        static set RefractionTextureEnabled(value) {
            if (this._RefractionTextureEnabled === value) {
                return;
            }
            this._RefractionTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are color grading textures enabled in the application.
         */
        static get ColorGradingTextureEnabled() {
            return this._ColorGradingTextureEnabled;
        }
        static set ColorGradingTextureEnabled(value) {
            if (this._ColorGradingTextureEnabled === value) {
                return;
            }
            this._ColorGradingTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are fresnels enabled in the application.
         */
        static get FresnelEnabled() {
            return this._FresnelEnabled;
        }
        static set FresnelEnabled(value) {
            if (this._FresnelEnabled === value) {
                return;
            }
            this._FresnelEnabled = value;
            Engine.MarkAllMaterialsAsDirty(4);
        }
        /**
         * Are clear coat textures enabled in the application.
         */
        static get ClearCoatTextureEnabled() {
            return this._ClearCoatTextureEnabled;
        }
        static set ClearCoatTextureEnabled(value) {
            if (this._ClearCoatTextureEnabled === value) {
                return;
            }
            this._ClearCoatTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are clear coat bump textures enabled in the application.
         */
        static get ClearCoatBumpTextureEnabled() {
            return this._ClearCoatBumpTextureEnabled;
        }
        static set ClearCoatBumpTextureEnabled(value) {
            if (this._ClearCoatBumpTextureEnabled === value) {
                return;
            }
            this._ClearCoatBumpTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are clear coat tint textures enabled in the application.
         */
        static get ClearCoatTintTextureEnabled() {
            return this._ClearCoatTintTextureEnabled;
        }
        static set ClearCoatTintTextureEnabled(value) {
            if (this._ClearCoatTintTextureEnabled === value) {
                return;
            }
            this._ClearCoatTintTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are sheen textures enabled in the application.
         */
        static get SheenTextureEnabled() {
            return this._SheenTextureEnabled;
        }
        static set SheenTextureEnabled(value) {
            if (this._SheenTextureEnabled === value) {
                return;
            }
            this._SheenTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are anisotropic textures enabled in the application.
         */
        static get AnisotropicTextureEnabled() {
            return this._AnisotropicTextureEnabled;
        }
        static set AnisotropicTextureEnabled(value) {
            if (this._AnisotropicTextureEnabled === value) {
                return;
            }
            this._AnisotropicTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are thickness textures enabled in the application.
         */
        static get ThicknessTextureEnabled() {
            return this._ThicknessTextureEnabled;
        }
        static set ThicknessTextureEnabled(value) {
            if (this._ThicknessTextureEnabled === value) {
                return;
            }
            this._ThicknessTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are refraction intensity textures enabled in the application.
         */
        static get RefractionIntensityTextureEnabled() {
            return this._ThicknessTextureEnabled;
        }
        static set RefractionIntensityTextureEnabled(value) {
            if (this._RefractionIntensityTextureEnabled === value) {
                return;
            }
            this._RefractionIntensityTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are translucency intensity textures enabled in the application.
         */
        static get TranslucencyIntensityTextureEnabled() {
            return this._ThicknessTextureEnabled;
        }
        static set TranslucencyIntensityTextureEnabled(value) {
            if (this._TranslucencyIntensityTextureEnabled === value) {
                return;
            }
            this._TranslucencyIntensityTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
        /**
         * Are translucency intensity textures enabled in the application.
         */
        static get IridescenceTextureEnabled() {
            return this._IridescenceTextureEnabled;
        }
        static set IridescenceTextureEnabled(value) {
            if (this._IridescenceTextureEnabled === value) {
                return;
            }
            this._IridescenceTextureEnabled = value;
            Engine.MarkAllMaterialsAsDirty(1);
        }
    }
    // Flags used to enable or disable a type of texture for all Standard Materials
    MaterialFlags._DiffuseTextureEnabled = true;
    MaterialFlags._DetailTextureEnabled = true;
    MaterialFlags._DecalMapEnabled = true;
    MaterialFlags._AmbientTextureEnabled = true;
    MaterialFlags._OpacityTextureEnabled = true;
    MaterialFlags._ReflectionTextureEnabled = true;
    MaterialFlags._EmissiveTextureEnabled = true;
    MaterialFlags._SpecularTextureEnabled = true;
    MaterialFlags._BumpTextureEnabled = true;
    MaterialFlags._LightmapTextureEnabled = true;
    MaterialFlags._RefractionTextureEnabled = true;
    MaterialFlags._ColorGradingTextureEnabled = true;
    MaterialFlags._FresnelEnabled = true;
    MaterialFlags._ClearCoatTextureEnabled = true;
    MaterialFlags._ClearCoatBumpTextureEnabled = true;
    MaterialFlags._ClearCoatTintTextureEnabled = true;
    MaterialFlags._SheenTextureEnabled = true;
    MaterialFlags._AnisotropicTextureEnabled = true;
    MaterialFlags._ThicknessTextureEnabled = true;
    MaterialFlags._RefractionIntensityTextureEnabled = true;
    MaterialFlags._TranslucencyIntensityTextureEnabled = true;
    MaterialFlags._IridescenceTextureEnabled = true;

    // Do not edit.
    const name = "decalFragmentDeclaration";
    const shader = `#ifdef DECAL
uniform vec4 vDecalInfos;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name] = shader;

    // Do not edit.
    const name$1 = "defaultFragmentDeclaration";
    const shader$1 = `uniform vec4 vEyePosition;uniform vec4 vDiffuseColor;
#ifdef SPECULARTERM
uniform vec4 vSpecularColor;
#endif
uniform vec3 vEmissiveColor;uniform vec3 vAmbientColor;uniform float visibility;
#ifdef DIFFUSE
uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY 
uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#ifdef ALPHATEST
uniform float alphaCutOff;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(REFRACTION) || defined(PREPASS)
uniform mat4 view;
#endif
#ifdef REFRACTION
uniform vec4 vRefractionInfos;
#ifndef REFRACTIONMAP_3D
uniform mat4 refractionMatrix;
#endif
#ifdef REFRACTIONFRESNEL
uniform vec4 refractionLeftColor;uniform vec4 refractionRightColor;
#endif
#if defined(USE_LOCAL_REFRACTIONMAP_CUBIC) && defined(REFRACTIONMAP_3D)
uniform vec3 vRefractionPosition;uniform vec3 vRefractionSize; 
#endif
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;
#endif
#ifdef DIFFUSEFRESNEL
uniform vec4 diffuseLeftColor;uniform vec4 diffuseRightColor;
#endif
#ifdef OPACITYFRESNEL
uniform vec4 opacityParts;
#endif
#ifdef EMISSIVEFRESNEL
uniform vec4 emissiveLeftColor;uniform vec4 emissiveRightColor;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;
#if defined(REFLECTIONMAP_PLANAR) || defined(REFLECTIONMAP_CUBIC) || defined(REFLECTIONMAP_PROJECTION) || defined(REFLECTIONMAP_EQUIRECTANGULAR) || defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_SKYBOX)
uniform mat4 reflectionMatrix;
#endif
#ifndef REFLECTIONMAP_SKYBOX
#if defined(USE_LOCAL_REFLECTIONMAP_CUBIC) && defined(REFLECTIONMAP_CUBIC)
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize; 
#endif
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 reflectionLeftColor;uniform vec4 reflectionRightColor;
#endif
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;
#endif
#include<decalFragmentDeclaration>
#define ADDITIONAL_FRAGMENT_DECLARATION
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1] = shader$1;

    // Do not edit.
    const name$2 = "sceneUboDeclaration";
    const shader$2 = `layout(std140,column_major) uniform;uniform Scene {mat4 viewProjection;
#ifdef MULTIVIEW
mat4 viewProjectionR;
#endif 
mat4 view;mat4 projection;vec4 vEyePosition;};
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2] = shader$2;

    // Do not edit.
    const name$3 = "meshUboDeclaration";
    const shader$3 = `#ifdef WEBGL2
uniform mat4 world;uniform float visibility;
#else
layout(std140,column_major) uniform;uniform Mesh
{mat4 world;float visibility;};
#endif
#define WORLD_UBO
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$3] = shader$3;

    // Do not edit.
    const name$4 = "defaultUboDeclaration";
    const shader$4 = `layout(std140,column_major) uniform;uniform Material
{vec4 diffuseLeftColor;vec4 diffuseRightColor;vec4 opacityParts;vec4 reflectionLeftColor;vec4 reflectionRightColor;vec4 refractionLeftColor;vec4 refractionRightColor;vec4 emissiveLeftColor;vec4 emissiveRightColor;vec2 vDiffuseInfos;vec2 vAmbientInfos;vec2 vOpacityInfos;vec2 vReflectionInfos;vec3 vReflectionPosition;vec3 vReflectionSize;vec2 vEmissiveInfos;vec2 vLightmapInfos;vec2 vSpecularInfos;vec3 vBumpInfos;mat4 diffuseMatrix;mat4 ambientMatrix;mat4 opacityMatrix;mat4 reflectionMatrix;mat4 emissiveMatrix;mat4 lightmapMatrix;mat4 specularMatrix;mat4 bumpMatrix;vec2 vTangentSpaceParams;float pointSize;float alphaCutOff;mat4 refractionMatrix;vec4 vRefractionInfos;vec3 vRefractionPosition;vec3 vRefractionSize;vec4 vSpecularColor;vec3 vEmissiveColor;vec4 vDiffuseColor;vec3 vAmbientColor;
#define ADDITIONAL_UBO_DECLARATION
};
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$4] = shader$4;

    // Do not edit.
    const name$5 = "prePassDeclaration";
    const shader$5 = `#ifdef PREPASS
#extension GL_EXT_draw_buffers : require
layout(location=0) out highp vec4 glFragData[{X}];highp vec4 gl_FragColor;
#ifdef PREPASS_DEPTH
varying highp vec3 vViewPos;
#endif
#ifdef PREPASS_VELOCITY
varying highp vec4 vCurrentPosition;varying highp vec4 vPreviousPosition;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$5] = shader$5;

    // Do not edit.
    const name$6 = "oitDeclaration";
    const shader$6 = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
#extension GL_EXT_draw_buffers : require
layout(location=0) out vec2 depth; 
layout(location=1) out vec4 frontColor;layout(location=2) out vec4 backColor;
#define MAX_DEPTH 99999.0
highp vec4 gl_FragColor;uniform sampler2D oitDepthSampler;uniform sampler2D oitFrontColorSampler;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$6] = shader$6;

    // Do not edit.
    const name$7 = "mainUVVaryingDeclaration";
    const shader$7 = `#ifdef MAINUV{X}
varying vec2 vMainUV{X};
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$7] = shader$7;

    // Do not edit.
    const name$8 = "helperFunctions";
    const shader$8 = `const float PI=3.1415926535897932384626433832795;const float HALF_MIN=5.96046448e-08; 
const float LinearEncodePowerApprox=2.2;const float GammaEncodePowerApprox=1.0/LinearEncodePowerApprox;const vec3 LuminanceEncodeApprox=vec3(0.2126,0.7152,0.0722);const float Epsilon=0.0000001;
#define saturate(x) clamp(x,0.0,1.0)
#define absEps(x) abs(x)+Epsilon
#define maxEps(x) max(x,Epsilon)
#define saturateEps(x) clamp(x,Epsilon,1.0)
mat3 transposeMat3(mat3 inMatrix) {vec3 i0=inMatrix[0];vec3 i1=inMatrix[1];vec3 i2=inMatrix[2];mat3 outMatrix=mat3(
vec3(i0.x,i1.x,i2.x),
vec3(i0.y,i1.y,i2.y),
vec3(i0.z,i1.z,i2.z)
);return outMatrix;}
mat3 inverseMat3(mat3 inMatrix) {float a00=inMatrix[0][0],a01=inMatrix[0][1],a02=inMatrix[0][2];float a10=inMatrix[1][0],a11=inMatrix[1][1],a12=inMatrix[1][2];float a20=inMatrix[2][0],a21=inMatrix[2][1],a22=inMatrix[2][2];float b01=a22*a11-a12*a21;float b11=-a22*a10+a12*a20;float b21=a21*a10-a11*a20;float det=a00*b01+a01*b11+a02*b21;return mat3(b01,(-a22*a01+a02*a21),(a12*a01-a02*a11),
b11,(a22*a00-a02*a20),(-a12*a00+a02*a10),
b21,(-a21*a00+a01*a20),(a11*a00-a01*a10))/det;}
#if USE_EXACT_SRGB_CONVERSIONS
vec3 toLinearSpaceExact(vec3 color)
{vec3 nearZeroSection=0.0773993808*color;vec3 remainingSection=pow(0.947867299*(color+vec3(0.055)),vec3(2.4));
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.04045)));
#else
return
vec3(
color.r<=0.04045 ? nearZeroSection.r : remainingSection.r,
color.g<=0.04045 ? nearZeroSection.g : remainingSection.g,
color.b<=0.04045 ? nearZeroSection.b : remainingSection.b);
#endif
}
vec3 toGammaSpaceExact(vec3 color)
{vec3 nearZeroSection=12.92*color;vec3 remainingSection=1.055*pow(color,vec3(0.41666))-vec3(0.055);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.0031308)));
#else
return
vec3(
color.r<=0.0031308 ? nearZeroSection.r : remainingSection.r,
color.g<=0.0031308 ? nearZeroSection.g : remainingSection.g,
color.b<=0.0031308 ? nearZeroSection.b : remainingSection.b);
#endif
}
#endif
float toLinearSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=0.0773993808*color;float remainingSection=pow(0.947867299*(color+0.055),2.4);return color<=0.04045 ? nearZeroSection : remainingSection;
#else
return pow(color,LinearEncodePowerApprox);
#endif
}
vec3 toLinearSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toLinearSpaceExact(color);
#else
return pow(color,vec3(LinearEncodePowerApprox));
#endif
}
vec4 toLinearSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toLinearSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(LinearEncodePowerApprox)),color.a);
#endif
}
float toGammaSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=12.92*color;float remainingSection=1.055*pow(color,0.41666)-0.055;return color<=0.0031308 ? nearZeroSection : remainingSection;
#else
return pow(color,GammaEncodePowerApprox);
#endif
}
vec3 toGammaSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toGammaSpaceExact(color);
#else
return pow(color,vec3(GammaEncodePowerApprox));
#endif
}
vec4 toGammaSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toGammaSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(GammaEncodePowerApprox)),color.a);
#endif
}
float square(float value)
{return value*value;}
vec3 square(vec3 value)
{return value*value;}
float pow5(float value) {float sq=value*value;return sq*sq*value;}
float getLuminance(vec3 color)
{return clamp(dot(color,LuminanceEncodeApprox),0.,1.);}
float getRand(vec2 seed) {return fract(sin(dot(seed.xy ,vec2(12.9898,78.233)))*43758.5453);}
float dither(vec2 seed,float varianceAmount) {float rand=getRand(seed);float normVariance=varianceAmount/255.0;float dither=mix(-normVariance,normVariance,rand);return dither;}
const float rgbdMaxRange=255.0;vec4 toRGBD(vec3 color) {float maxRGB=maxEps(max(color.r,max(color.g,color.b)));float D =max(rgbdMaxRange/maxRGB,1.);D =clamp(floor(D)/255.0,0.,1.);vec3 rgb=color.rgb*D;rgb=toGammaSpace(rgb);return vec4(clamp(rgb,0.,1.),D); }
vec3 fromRGBD(vec4 rgbd) {rgbd.rgb=toLinearSpace(rgbd.rgb);return rgbd.rgb/rgbd.a;}
vec3 parallaxCorrectNormal( vec3 vertexPos,vec3 origVec,vec3 cubeSize,vec3 cubePos ) {vec3 invOrigVec=vec3(1.0,1.0,1.0)/origVec;vec3 halfSize=cubeSize*0.5;vec3 intersecAtMaxPlane=(cubePos+halfSize-vertexPos)*invOrigVec;vec3 intersecAtMinPlane=(cubePos-halfSize-vertexPos)*invOrigVec;vec3 largestIntersec=max(intersecAtMaxPlane,intersecAtMinPlane);float distance=min(min(largestIntersec.x,largestIntersec.y),largestIntersec.z);vec3 intersectPositionWS=vertexPos+origVec*distance;return intersectPositionWS-cubePos;}
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$8] = shader$8;

    // Do not edit.
    const name$9 = "lightFragmentDeclaration";
    const shader$9 = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowSampler{X};uniform highp sampler2DArray depthSampler{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowSampler{X};
#else
uniform highp sampler2DArray shadowSampler{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowSampler{X};
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowSampler{X};uniform highp sampler2D depthSampler{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowSampler{X};
#else
uniform sampler2D shadowSampler{X};
#endif
uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightSampler{X};
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$9] = shader$9;

    // Do not edit.
    const name$a = "lightUboDeclaration";
    const shader$a = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightSampler{X};
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowSampler{X};uniform highp sampler2DArray depthSampler{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowSampler{X};
#else
uniform highp sampler2DArray shadowSampler{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowSampler{X}; 
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowSampler{X};uniform highp sampler2D depthSampler{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowSampler{X};
#else
uniform sampler2D shadowSampler{X};
#endif
uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$a] = shader$a;

    // Do not edit.
    const name$b = "lightsFragmentFunctions";
    const shader$b = `struct lightingInfo
{vec3 diffuse;
#ifdef SPECULARTERM
vec3 specular;
#endif
#ifdef NDOTL
float ndl;
#endif
};lightingInfo computeLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 lightVectorW;float attenuation=1.0;if (lightData.w==0.)
{vec3 direction=lightData.xyz-vPositionW;attenuation=max(0.,1.0-length(direction)/range);lightVectorW=normalize(direction);}
else
{lightVectorW=normalize(-lightData.xyz);}
float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
lightingInfo computeSpotLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec4 lightDirection,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 direction=lightData.xyz-vPositionW;vec3 lightVectorW=normalize(direction);float attenuation=max(0.,1.0-length(direction)/range);float cosAngle=max(0.,dot(lightDirection.xyz,-lightVectorW));if (cosAngle>=lightDirection.w)
{cosAngle=max(0.,pow(cosAngle,lightData.w));attenuation*=cosAngle;float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
result.diffuse=vec3(0.);
#ifdef SPECULARTERM
result.specular=vec3(0.);
#endif
#ifdef NDOTL
result.ndl=0.;
#endif
return result;}
lightingInfo computeHemisphericLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,vec3 groundColor,float glossiness) {lightingInfo result;float ndl=dot(vNormal,lightData.xyz)*0.5+0.5;
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=mix(groundColor,diffuseColor,ndl);
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightData.xyz);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor;
#endif
return result;}
#define inline
vec3 computeProjectionTextureDiffuseLighting(sampler2D projectionLightSampler,mat4 textureProjectionMatrix){vec4 strq=textureProjectionMatrix*vec4(vPositionW,1.0);strq/=strq.w;vec3 textureColor=texture2D(projectionLightSampler,strq.xy).rgb;return textureColor;}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$b] = shader$b;

    // Do not edit.
    const name$c = "shadowsFragmentFunctions";
    const shader$c = `#ifdef SHADOWS
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
#ifndef SHADOWFLOAT
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}
#endif
float computeFallOff(float value,vec2 clipSpace,float frustumEdgeFalloff)
{float mask=smoothstep(1.0-frustumEdgeFalloff,1.00000012,clamp(dot(clipSpace,clipSpace),0.,1.));return mix(value,1.0,mask);}
#define inline
float computeShadowCube(vec3 lightPosition,samplerCube shadowSampler,float darkness,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadow=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadow=textureCube(shadowSampler,directionToLight).x;
#endif
return depth>shadow ? darkness : 1.0;}
#define inline
float computeShadowWithPoissonSamplingCube(vec3 lightPosition,samplerCube shadowSampler,float mapSize,float darkness,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;float visibility=1.;vec3 poissonDisk[4];poissonDisk[0]=vec3(-1.0,1.0,-1.0);poissonDisk[1]=vec3(1.0,-1.0,-1.0);poissonDisk[2]=vec3(-1.0,-1.0,-1.0);poissonDisk[3]=vec3(1.0,-1.0,1.0);
#ifndef SHADOWFLOAT
if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize))<depth) visibility-=0.25;
#else
if (textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize).x<depth) visibility-=0.25;
#endif
return min(1.0,visibility+darkness);}
#define inline
float computeShadowWithESMCube(vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness); 
return esm;}
#define inline
float computeShadowWithCloseESMCube(vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return esm;}
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define inline
float computeShadowCSM(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);vec3 uvLayer=vec3(uv.x,uv.y,layer);float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(texture2D(shadowSampler,uvLayer));
#else
float shadow=texture2D(shadowSampler,uvLayer).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}
#endif
#define inline
float computeShadow(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadow=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}}
#define inline
float computeShadowWithPoissonSampling(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float mapSize,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);float visibility=1.;vec2 poissonDisk[4];poissonDisk[0]=vec2(-0.94201624,-0.39906216);poissonDisk[1]=vec2(0.94558609,-0.76890725);poissonDisk[2]=vec2(-0.094184101,-0.92938870);poissonDisk[3]=vec2(0.34495938,0.29387760);
#ifndef SHADOWFLOAT
if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;
#else
if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;
#endif
return computeFallOff(min(1.0,visibility+darkness),clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithCloseESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0); 
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#ifdef IS_NDC_HALF_ZRANGE
#define ZINCLIP clipSpace.z
#else
#define ZINCLIP uvDepth.z
#endif
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define GREATEST_LESS_THAN_ONE 0.99999994
#define inline
float computeShadowWithCSMPCF1(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float shadow=texture2D(shadowSampler,uvDepthLayer);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF3(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF5(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw2.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow+=uvw2.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[1]),layer,uvDepth.z));shadow+=uvw0.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[2]),layer,uvDepth.z));shadow+=uvw1.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[2]),layer,uvDepth.z));shadow+=uvw2.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[2]),layer,uvDepth.z));shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithPCF1(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float shadow=TEXTUREFUNC(shadowSampler,uvDepth,0.);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF3(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF5(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw2.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow+=uvw2.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[1]),uvDepth.z),0.);shadow+=uvw0.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[2]),uvDepth.z),0.);shadow+=uvw1.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[2]),uvDepth.z),0.);shadow+=uvw2.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[2]),uvDepth.z),0.);shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
const vec3 PoissonSamplers32[64]=vec3[64](
vec3(0.06407013,0.05409927,0.),
vec3(0.7366577,0.5789394,0.),
vec3(-0.6270542,-0.5320278,0.),
vec3(-0.4096107,0.8411095,0.),
vec3(0.6849564,-0.4990818,0.),
vec3(-0.874181,-0.04579735,0.),
vec3(0.9989998,0.0009880066,0.),
vec3(-0.004920578,-0.9151649,0.),
vec3(0.1805763,0.9747483,0.),
vec3(-0.2138451,0.2635818,0.),
vec3(0.109845,0.3884785,0.),
vec3(0.06876755,-0.3581074,0.),
vec3(0.374073,-0.7661266,0.),
vec3(0.3079132,-0.1216763,0.),
vec3(-0.3794335,-0.8271583,0.),
vec3(-0.203878,-0.07715034,0.),
vec3(0.5912697,0.1469799,0.),
vec3(-0.88069,0.3031784,0.),
vec3(0.5040108,0.8283722,0.),
vec3(-0.5844124,0.5494877,0.),
vec3(0.6017799,-0.1726654,0.),
vec3(-0.5554981,0.1559997,0.),
vec3(-0.3016369,-0.3900928,0.),
vec3(-0.5550632,-0.1723762,0.),
vec3(0.925029,0.2995041,0.),
vec3(-0.2473137,0.5538505,0.),
vec3(0.9183037,-0.2862392,0.),
vec3(0.2469421,0.6718712,0.),
vec3(0.3916397,-0.4328209,0.),
vec3(-0.03576927,-0.6220032,0.),
vec3(-0.04661255,0.7995201,0.),
vec3(0.4402924,0.3640312,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.)
);const vec3 PoissonSamplers64[64]=vec3[64](
vec3(-0.613392,0.617481,0.),
vec3(0.170019,-0.040254,0.),
vec3(-0.299417,0.791925,0.),
vec3(0.645680,0.493210,0.),
vec3(-0.651784,0.717887,0.),
vec3(0.421003,0.027070,0.),
vec3(-0.817194,-0.271096,0.),
vec3(-0.705374,-0.668203,0.),
vec3(0.977050,-0.108615,0.),
vec3(0.063326,0.142369,0.),
vec3(0.203528,0.214331,0.),
vec3(-0.667531,0.326090,0.),
vec3(-0.098422,-0.295755,0.),
vec3(-0.885922,0.215369,0.),
vec3(0.566637,0.605213,0.),
vec3(0.039766,-0.396100,0.),
vec3(0.751946,0.453352,0.),
vec3(0.078707,-0.715323,0.),
vec3(-0.075838,-0.529344,0.),
vec3(0.724479,-0.580798,0.),
vec3(0.222999,-0.215125,0.),
vec3(-0.467574,-0.405438,0.),
vec3(-0.248268,-0.814753,0.),
vec3(0.354411,-0.887570,0.),
vec3(0.175817,0.382366,0.),
vec3(0.487472,-0.063082,0.),
vec3(-0.084078,0.898312,0.),
vec3(0.488876,-0.783441,0.),
vec3(0.470016,0.217933,0.),
vec3(-0.696890,-0.549791,0.),
vec3(-0.149693,0.605762,0.),
vec3(0.034211,0.979980,0.),
vec3(0.503098,-0.308878,0.),
vec3(-0.016205,-0.872921,0.),
vec3(0.385784,-0.393902,0.),
vec3(-0.146886,-0.859249,0.),
vec3(0.643361,0.164098,0.),
vec3(0.634388,-0.049471,0.),
vec3(-0.688894,0.007843,0.),
vec3(0.464034,-0.188818,0.),
vec3(-0.440840,0.137486,0.),
vec3(0.364483,0.511704,0.),
vec3(0.034028,0.325968,0.),
vec3(0.099094,-0.308023,0.),
vec3(0.693960,-0.366253,0.),
vec3(0.678884,-0.204688,0.),
vec3(0.001801,0.780328,0.),
vec3(0.145177,-0.898984,0.),
vec3(0.062655,-0.611866,0.),
vec3(0.315226,-0.604297,0.),
vec3(-0.780145,0.486251,0.),
vec3(-0.371868,0.882138,0.),
vec3(0.200476,0.494430,0.),
vec3(-0.494552,-0.711051,0.),
vec3(0.612476,0.705252,0.),
vec3(-0.578845,-0.768792,0.),
vec3(-0.772454,-0.090976,0.),
vec3(0.504440,0.372295,0.),
vec3(0.155736,0.065157,0.),
vec3(0.391522,0.849605,0.),
vec3(-0.620106,-0.328104,0.),
vec3(0.789239,-0.419965,0.),
vec3(-0.545396,0.538133,0.),
vec3(-0.178564,-0.596057,0.)
);
#define inline
float computeShadowWithCSMPCSS(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=texture2D(depthSampler,vec3(uvDepth.xy+(lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse*PoissonSamplers32[i].xy),layer)).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)*depthCorrection+AAOffset);vec4 filterRadius=vec4(penumbraRatio*lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse,0.,0.);float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec4 offset=vec4(poissonSamplers[i],0.);offset=vec4(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.,0.);shadow+=texture2D(shadowSampler,uvDepthLayer+offset*filterRadius);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,min((depthMetric-avgBlockerDepth)*depthCorrection*penumbraDarkness,1.));shadow=mix(darkness,1.,shadow);if (numBlocker<1.0) {return 1.0;}
else
{return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCSS(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=TEXTUREFUNC(depthSampler,uvDepth.xy+(lightSizeUV*shadowMapSizeInverse*PoissonSamplers32[i].xy),0.).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
if (numBlocker<1.0) {return 1.0;}
else
{float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)+AAOffset);float filterRadius=penumbraRatio*lightSizeUV*shadowMapSizeInverse;float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec3 offset=poissonSamplers[i];offset=vec3(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.);shadow+=TEXTUREFUNC(shadowSampler,uvDepth+offset*filterRadius,0.);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,depthMetric-avgBlockerDepth);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}}
#define inline
float computeShadowWithPCSS16(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS32(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS64(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64);}
#define inline
float computeShadowWithCSMPCSS16(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS32(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS64(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$c] = shader$c;

    // Do not edit.
    const name$d = "samplerFragmentDeclaration";
    const shader$d = `#ifdef _DEFINENAME_
#if _DEFINENAME_DIRECTUV==1
#define v_VARYINGNAME_UV vMainUV1
#elif _DEFINENAME_DIRECTUV==2
#define v_VARYINGNAME_UV vMainUV2
#elif _DEFINENAME_DIRECTUV==3
#define v_VARYINGNAME_UV vMainUV3
#elif _DEFINENAME_DIRECTUV==4
#define v_VARYINGNAME_UV vMainUV4
#elif _DEFINENAME_DIRECTUV==5
#define v_VARYINGNAME_UV vMainUV5
#elif _DEFINENAME_DIRECTUV==6
#define v_VARYINGNAME_UV vMainUV6
#else
varying vec2 v_VARYINGNAME_UV;
#endif
uniform sampler2D _SAMPLERNAME_Sampler;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$d] = shader$d;

    // Do not edit.
    const name$e = "fresnelFunction";
    const shader$e = `#ifdef FRESNEL
float computeFresnelTerm(vec3 viewDirection,vec3 worldNormal,float bias,float power)
{float fresnelTerm=pow(bias+abs(dot(viewDirection,worldNormal)),power);return clamp(fresnelTerm,0.,1.);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$e] = shader$e;

    // Do not edit.
    const name$f = "reflectionFunction";
    const shader$f = `vec3 computeFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0); }
vec3 computeMirroredFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(1.0-s,t,0); }
vec3 computeEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 cameraToVertex=normalize(worldPos.xyz-eyePosition);vec3 r=normalize(reflect(cameraToVertex,worldNormal));r=vec3(reflectionMatrix*vec4(r,0));float lon=atan(r.z,r.x);float lat=acos(r.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0);}
vec3 computeSphericalCoords(vec4 worldPos,vec3 worldNormal,mat4 view,mat4 reflectionMatrix)
{vec3 viewDir=normalize(vec3(view*worldPos));vec3 viewNormal=normalize(vec3(view*vec4(worldNormal,0.0)));vec3 r=reflect(viewDir,viewNormal);r=vec3(reflectionMatrix*vec4(r,0));r.z=r.z-1.0;float m=2.0*length(r);return vec3(r.x/m+0.5,1.0-r.y/m-0.5,0);}
vec3 computePlanarCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=worldPos.xyz-eyePosition;vec3 coords=normalize(reflect(viewDir,worldNormal));return vec3(reflectionMatrix*vec4(coords,1));}
vec3 computeCubicCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeCubicLocalCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix,vec3 reflectionSize,vec3 reflectionPosition)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=parallaxCorrectNormal(worldPos.xyz,coords,reflectionSize,reflectionPosition);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeProjectionCoords(vec4 worldPos,mat4 view,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*(view*worldPos));}
vec3 computeSkyBoxCoords(vec3 positionW,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*vec4(positionW,1.));}
#ifdef REFLECTION
vec3 computeReflectionCoords(vec4 worldPos,vec3 worldNormal)
{
#ifdef REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeMirroredFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR
return computeEquirectangularCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SPHERICAL
return computeSphericalCoords(worldPos,worldNormal,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_PLANAR
return computePlanarCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_CUBIC
#ifdef USE_LOCAL_REFLECTIONMAP_CUBIC
return computeCubicLocalCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix,vReflectionSize,vReflectionPosition);
#else
return computeCubicCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#endif
#ifdef REFLECTIONMAP_PROJECTION
return computeProjectionCoords(worldPos,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SKYBOX
return computeSkyBoxCoords(vPositionUVW,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_EXPLICIT
return vec3(0,0,0);
#endif
}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$f] = shader$f;

    // Do not edit.
    const name$g = "imageProcessingDeclaration";
    const shader$g = `#ifdef EXPOSURE
uniform float exposureLinear;
#endif
#ifdef CONTRAST
uniform float contrast;
#endif
#if defined(VIGNETTE) || defined(DITHER)
uniform vec2 vInverseScreenSize;
#endif
#ifdef VIGNETTE
uniform vec4 vignetteSettings1;uniform vec4 vignetteSettings2;
#endif
#ifdef COLORCURVES
uniform vec4 vCameraColorCurveNegative;uniform vec4 vCameraColorCurveNeutral;uniform vec4 vCameraColorCurvePositive;
#endif
#ifdef COLORGRADING
#ifdef COLORGRADING3D
uniform highp sampler3D txColorTransform;
#else
uniform sampler2D txColorTransform;
#endif
uniform vec4 colorTransformSettings;
#endif
#ifdef DITHER
uniform float ditherIntensity;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$g] = shader$g;

    // Do not edit.
    const name$h = "imageProcessingFunctions";
    const shader$h = `#if defined(COLORGRADING) && !defined(COLORGRADING3D)
/** 
* Polyfill for SAMPLE_TEXTURE_3D,which is unsupported in WebGL.
* sampler3dSetting.x=textureOffset (0.5/textureSize).
* sampler3dSetting.y=textureSize.
*/
#define inline
vec3 sampleTexture3D(sampler2D colorTransform,vec3 color,vec2 sampler3dSetting)
{float sliceSize=2.0*sampler3dSetting.x; 
#ifdef SAMPLER3DGREENDEPTH
float sliceContinuous=(color.g-sampler3dSetting.x)*sampler3dSetting.y;
#else
float sliceContinuous=(color.b-sampler3dSetting.x)*sampler3dSetting.y;
#endif
float sliceInteger=floor(sliceContinuous);float sliceFraction=sliceContinuous-sliceInteger;
#ifdef SAMPLER3DGREENDEPTH
vec2 sliceUV=color.rb;
#else
vec2 sliceUV=color.rg;
#endif
sliceUV.x*=sliceSize;sliceUV.x+=sliceInteger*sliceSize;sliceUV=saturate(sliceUV);vec4 slice0Color=texture2D(colorTransform,sliceUV);sliceUV.x+=sliceSize;sliceUV=saturate(sliceUV);vec4 slice1Color=texture2D(colorTransform,sliceUV);vec3 result=mix(slice0Color.rgb,slice1Color.rgb,sliceFraction);
#ifdef SAMPLER3DBGRMAP
color.rgb=result.rgb;
#else
color.rgb=result.bgr;
#endif
return color;}
#endif
#ifdef TONEMAPPING_ACES
const mat3 ACESInputMat=mat3(
vec3(0.59719,0.07600,0.02840),
vec3(0.35458,0.90834,0.13383),
vec3(0.04823,0.01566,0.83777)
);const mat3 ACESOutputMat=mat3(
vec3( 1.60475,-0.10208,-0.00327),
vec3(-0.53108, 1.10813,-0.07276),
vec3(-0.07367,-0.00605, 1.07602)
);vec3 RRTAndODTFit(vec3 v)
{vec3 a=v*(v+0.0245786)-0.000090537;vec3 b=v*(0.983729*v+0.4329510)+0.238081;return a/b;}
vec3 ACESFitted(vec3 color)
{color=ACESInputMat*color;color=RRTAndODTFit(color);color=ACESOutputMat*color;color=saturate(color);return color;}
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_DEFINITIONS
vec4 applyImageProcessing(vec4 result) {
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATSTART
#ifdef EXPOSURE
result.rgb*=exposureLinear;
#endif
#ifdef VIGNETTE
vec2 viewportXY=gl_FragCoord.xy*vInverseScreenSize;viewportXY=viewportXY*2.0-1.0;vec3 vignetteXY1=vec3(viewportXY*vignetteSettings1.xy+vignetteSettings1.zw,1.0);float vignetteTerm=dot(vignetteXY1,vignetteXY1);float vignette=pow(vignetteTerm,vignetteSettings2.w);vec3 vignetteColor=vignetteSettings2.rgb;
#ifdef VIGNETTEBLENDMODEMULTIPLY
vec3 vignetteColorMultiplier=mix(vignetteColor,vec3(1,1,1),vignette);result.rgb*=vignetteColorMultiplier;
#endif
#ifdef VIGNETTEBLENDMODEOPAQUE
result.rgb=mix(vignetteColor,result.rgb,vignette);
#endif
#endif
#ifdef TONEMAPPING
#ifdef TONEMAPPING_ACES
result.rgb=ACESFitted(result.rgb);
#else
const float tonemappingCalibration=1.590579;result.rgb=1.0-exp2(-tonemappingCalibration*result.rgb);
#endif
#endif
result.rgb=toGammaSpace(result.rgb);result.rgb=saturate(result.rgb);
#ifdef CONTRAST
vec3 resultHighContrast=result.rgb*result.rgb*(3.0-2.0*result.rgb);if (contrast<1.0) {result.rgb=mix(vec3(0.5,0.5,0.5),result.rgb,contrast);} else {result.rgb=mix(result.rgb,resultHighContrast,contrast-1.0);}
#endif
#ifdef COLORGRADING
vec3 colorTransformInput=result.rgb*colorTransformSettings.xxx+colorTransformSettings.yyy;
#ifdef COLORGRADING3D
vec3 colorTransformOutput=texture(txColorTransform,colorTransformInput).rgb;
#else
vec3 colorTransformOutput=sampleTexture3D(txColorTransform,colorTransformInput,colorTransformSettings.yz).rgb;
#endif
result.rgb=mix(result.rgb,colorTransformOutput,colorTransformSettings.www);
#endif
#ifdef COLORCURVES
float luma=getLuminance(result.rgb);vec2 curveMix=clamp(vec2(luma*3.0-1.5,luma*-3.0+1.5),vec2(0.0),vec2(1.0));vec4 colorCurve=vCameraColorCurveNeutral+curveMix.x*vCameraColorCurvePositive-curveMix.y*vCameraColorCurveNegative;result.rgb*=colorCurve.rgb;result.rgb=mix(vec3(luma),result.rgb,colorCurve.a);
#endif
#ifdef DITHER
float rand=getRand(gl_FragCoord.xy*vInverseScreenSize);float dither=mix(-ditherIntensity,ditherIntensity,rand);result.rgb=saturate(result.rgb+vec3(dither));
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATEND
return result;}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$h] = shader$h;

    // Do not edit.
    const name$i = "bumpFragmentMainFunctions";
    const shader$i = `#if defined(BUMP) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC) || defined(DETAIL)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#ifdef OBJECTSPACE_NORMALMAP
uniform mat4 normalMatrix;
#if defined(WEBGL2) || defined(WEBGPU)
mat4 toNormalMatrix(mat4 wMatrix)
{mat4 ret=inverse(wMatrix);ret=transpose(ret);ret[0][3]=0.;ret[1][3]=0.;ret[2][3]=0.;ret[3]=vec4(0.,0.,0.,1.);return ret;}
#else
mat4 toNormalMatrix(mat4 m)
{float
a00=m[0][0],a01=m[0][1],a02=m[0][2],a03=m[0][3],
a10=m[1][0],a11=m[1][1],a12=m[1][2],a13=m[1][3],
a20=m[2][0],a21=m[2][1],a22=m[2][2],a23=m[2][3],
a30=m[3][0],a31=m[3][1],a32=m[3][2],a33=m[3][3],
b00=a00*a11-a01*a10,
b01=a00*a12-a02*a10,
b02=a00*a13-a03*a10,
b03=a01*a12-a02*a11,
b04=a01*a13-a03*a11,
b05=a02*a13-a03*a12,
b06=a20*a31-a21*a30,
b07=a20*a32-a22*a30,
b08=a20*a33-a23*a30,
b09=a21*a32-a22*a31,
b10=a21*a33-a23*a31,
b11=a22*a33-a23*a32,
det=b00*b11-b01*b10+b02*b09+b03*b08-b04*b07+b05*b06;mat4 mi=mat4(
a11*b11-a12*b10+a13*b09,
a02*b10-a01*b11-a03*b09,
a31*b05-a32*b04+a33*b03,
a22*b04-a21*b05-a23*b03,
a12*b08-a10*b11-a13*b07,
a00*b11-a02*b08+a03*b07,
a32*b02-a30*b05-a33*b01,
a20*b05-a22*b02+a23*b01,
a10*b10-a11*b08+a13*b06,
a01*b08-a00*b10-a03*b06,
a30*b04-a31*b02+a33*b00,
a21*b02-a20*b04-a23*b00,
a11*b07-a10*b09-a12*b06,
a00*b09-a01*b07+a02*b06,
a31*b01-a30*b03-a32*b00,
a20*b03-a21*b01+a22*b00)/det;return mat4(mi[0][0],mi[1][0],mi[2][0],mi[3][0],
mi[0][1],mi[1][1],mi[2][1],mi[3][1],
mi[0][2],mi[1][2],mi[2][2],mi[3][2],
mi[0][3],mi[1][3],mi[2][3],mi[3][3]);}
#endif
#endif
vec3 perturbNormalBase(mat3 cotangentFrame,vec3 normal,float scale)
{
#ifdef NORMALXYSCALE
normal=normalize(normal*vec3(scale,scale,1.0));
#endif
return normalize(cotangentFrame*normal);}
vec3 perturbNormal(mat3 cotangentFrame,vec3 textureSample,float scale)
{return perturbNormalBase(cotangentFrame,textureSample*2.0-1.0,scale);}
mat3 cotangent_frame(vec3 normal,vec3 p,vec2 uv,vec2 tangentSpaceParams)
{vec3 dp1=dFdx(p);vec3 dp2=dFdy(p);vec2 duv1=dFdx(uv);vec2 duv2=dFdy(uv);vec3 dp2perp=cross(dp2,normal);vec3 dp1perp=cross(normal,dp1);vec3 tangent=dp2perp*duv1.x+dp1perp*duv2.x;vec3 bitangent=dp2perp*duv1.y+dp1perp*duv2.y;tangent*=tangentSpaceParams.x;bitangent*=tangentSpaceParams.y;float det=max(dot(tangent,tangent),dot(bitangent,bitangent));float invmax=det==0.0 ? 0.0 : inversesqrt(det);return mat3(tangent*invmax,bitangent*invmax,normal);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$i] = shader$i;

    // Do not edit.
    const name$j = "bumpFragmentFunctions";
    const shader$j = `#if defined(BUMP)
#include<samplerFragmentDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_SAMPLERNAME_,bump)
#endif
#if defined(DETAIL)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_SAMPLERNAME_,detail)
#endif
#if defined(BUMP) && defined(PARALLAX)
const float minSamples=4.;const float maxSamples=15.;const int iMaxSamples=15;vec2 parallaxOcclusion(vec3 vViewDirCoT,vec3 vNormalCoT,vec2 texCoord,float parallaxScale) {float parallaxLimit=length(vViewDirCoT.xy)/vViewDirCoT.z;parallaxLimit*=parallaxScale;vec2 vOffsetDir=normalize(vViewDirCoT.xy);vec2 vMaxOffset=vOffsetDir*parallaxLimit;float numSamples=maxSamples+(dot(vViewDirCoT,vNormalCoT)*(minSamples-maxSamples));float stepSize=1.0/numSamples;float currRayHeight=1.0;vec2 vCurrOffset=vec2(0,0);vec2 vLastOffset=vec2(0,0);float lastSampledHeight=1.0;float currSampledHeight=1.0;bool keepWorking=true;for (int i=0; i<iMaxSamples; i++)
{currSampledHeight=texture2D(bumpSampler,texCoord+vCurrOffset).w;if (!keepWorking)
{}
else if (currSampledHeight>currRayHeight)
{float delta1=currSampledHeight-currRayHeight;float delta2=(currRayHeight+stepSize)-lastSampledHeight;float ratio=delta1/(delta1+delta2);vCurrOffset=(ratio)* vLastOffset+(1.0-ratio)*vCurrOffset;keepWorking=false;}
else
{currRayHeight-=stepSize;vLastOffset=vCurrOffset;vCurrOffset+=stepSize*vMaxOffset;lastSampledHeight=currSampledHeight;}}
return vCurrOffset;}
vec2 parallaxOffset(vec3 viewDir,float heightScale)
{float height=texture2D(bumpSampler,vBumpUV).w;vec2 texCoordOffset=heightScale*viewDir.xy*height;return -texCoordOffset;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$j] = shader$j;

    // Do not edit.
    const name$k = "clipPlaneFragmentDeclaration";
    const shader$k = `#ifdef CLIPPLANE
varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
varying float fClipDistance6;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$k] = shader$k;

    // Do not edit.
    const name$l = "logDepthDeclaration";
    const shader$l = `#ifdef LOGARITHMICDEPTH
uniform float logarithmicDepthConstant;varying float vFragmentDepth;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$l] = shader$l;

    // Do not edit.
    const name$m = "fogFragmentDeclaration";
    const shader$m = `#ifdef FOG
#define FOGMODE_NONE 0.
#define FOGMODE_EXP 1.
#define FOGMODE_EXP2 2.
#define FOGMODE_LINEAR 3.
#define E 2.71828
uniform vec4 vFogInfos;uniform vec3 vFogColor;varying vec3 vFogDistance;float CalcFogFactor()
{float fogCoeff=1.0;float fogStart=vFogInfos.y;float fogEnd=vFogInfos.z;float fogDensity=vFogInfos.w;float fogDistance=length(vFogDistance);if (FOGMODE_LINEAR==vFogInfos.x)
{fogCoeff=(fogEnd-fogDistance)/(fogEnd-fogStart);}
else if (FOGMODE_EXP==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDensity);}
else if (FOGMODE_EXP2==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDistance*fogDensity*fogDensity);}
return clamp(fogCoeff,0.0,1.0);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$m] = shader$m;

    // Do not edit.
    const name$n = "clipPlaneFragment";
    const shader$n = `#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
if (false) {}
#endif
#ifdef CLIPPLANE
else if (fClipDistance>0.0)
{discard;}
#endif
#ifdef CLIPPLANE2
else if (fClipDistance2>0.0)
{discard;}
#endif
#ifdef CLIPPLANE3
else if (fClipDistance3>0.0)
{discard;}
#endif
#ifdef CLIPPLANE4
else if (fClipDistance4>0.0)
{discard;}
#endif
#ifdef CLIPPLANE5
else if (fClipDistance5>0.0)
{discard;}
#endif
#ifdef CLIPPLANE6
else if (fClipDistance6>0.0)
{discard;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$n] = shader$n;

    // Do not edit.
    const name$o = "bumpFragment";
    const shader$o = `vec2 uvOffset=vec2(0.0,0.0);
#if defined(BUMP) || defined(PARALLAX) || defined(DETAIL)
#ifdef NORMALXYSCALE
float normalScale=1.0;
#elif defined(BUMP)
float normalScale=vBumpInfos.y;
#else
float normalScale=1.0;
#endif
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#elif defined(BUMP)
vec2 TBNUV=gl_FrontFacing ? vBumpUV : -vBumpUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vTangentSpaceParams);
#else
vec2 TBNUV=gl_FrontFacing ? vDetailUV : -vDetailUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vec2(1.,1.));
#endif
#elif defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#else
vec2 TBNUV=gl_FrontFacing ? vMainUV1 : -vMainUV1;mat3 TBN=cotangent_frame(normalW,vPositionW,TBNUV,vec2(1.,1.));
#endif
#endif
#ifdef PARALLAX
mat3 invTBN=transposeMat3(TBN);
#ifdef PARALLAXOCCLUSION
uvOffset=parallaxOcclusion(invTBN*-viewDirectionW,invTBN*normalW,vBumpUV,vBumpInfos.z);
#else
uvOffset=parallaxOffset(invTBN*viewDirectionW,vBumpInfos.z);
#endif
#endif
#ifdef DETAIL
vec4 detailColor=texture2D(detailSampler,vDetailUV+uvOffset);vec2 detailNormalRG=detailColor.wy*2.0-1.0;float detailNormalB=sqrt(1.-saturate(dot(detailNormalRG,detailNormalRG)));vec3 detailNormal=vec3(detailNormalRG,detailNormalB);
#endif
#ifdef BUMP
#ifdef OBJECTSPACE_NORMALMAP
#define CUSTOM_FRAGMENT_BUMP_FRAGMENT
normalW=normalize(texture2D(bumpSampler,vBumpUV).xyz *2.0-1.0);normalW=normalize(mat3(normalMatrix)*normalW);
#elif !defined(DETAIL)
normalW=perturbNormal(TBN,texture2D(bumpSampler,vBumpUV+uvOffset).xyz,vBumpInfos.y);
#else
vec3 bumpNormal=texture2D(bumpSampler,vBumpUV+uvOffset).xyz*2.0-1.0;
#if DETAIL_NORMALBLENDMETHOD==0 
detailNormal.xy*=vDetailInfos.z;vec3 blendedNormal=normalize(vec3(bumpNormal.xy+detailNormal.xy,bumpNormal.z*detailNormal.z));
#elif DETAIL_NORMALBLENDMETHOD==1 
detailNormal.xy*=vDetailInfos.z;bumpNormal+=vec3(0.0,0.0,1.0);detailNormal*=vec3(-1.0,-1.0,1.0);vec3 blendedNormal=bumpNormal*dot(bumpNormal,detailNormal)/bumpNormal.z-detailNormal;
#endif
normalW=perturbNormalBase(TBN,blendedNormal,vBumpInfos.y);
#endif
#elif defined(DETAIL)
detailNormal.xy*=vDetailInfos.z;normalW=perturbNormalBase(TBN,detailNormal,vDetailInfos.z);
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$o] = shader$o;

    // Do not edit.
    const name$p = "decalFragment";
    const shader$p = `#ifdef DECAL
#ifdef GAMMADECAL
decalColor.rgb=toLinearSpace(decalColor.rgb);
#endif
#ifdef DECAL_SMOOTHALPHA
decalColor.a*=decalColor.a;
#endif
surfaceAlbedo.rgb=mix(surfaceAlbedo.rgb,decalColor.rgb,decalColor.a);
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$p] = shader$p;

    // Do not edit.
    const name$q = "depthPrePass";
    const shader$q = `#ifdef DEPTHPREPASS
gl_FragColor=vec4(0.,0.,0.,1.0);return;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$q] = shader$q;

    // Do not edit.
    const name$r = "lightFragment";
    const shader$r = `#ifdef LIGHT{X}
#if defined(SHADOWONLY) || defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X}) && defined(LIGHTMAPNOSPECULAR{X})
#else
#ifdef PBR
#ifdef SPOTLIGHT{X}
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(POINTLIGHT{X})
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(HEMILIGHT{X})
preInfo=computeHemisphericPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(DIRLIGHT{X})
preInfo=computeDirectionalPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#endif
preInfo.NdotV=NdotV;
#ifdef SPOTLIGHT{X}
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);preInfo.attenuation*=computeDirectionalLightFalloff_GLTF(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);preInfo.attenuation*=computeDirectionalLightFalloff_Physical(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);preInfo.attenuation*=computeDirectionalLightFalloff_Standard(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);preInfo.attenuation*=computeDirectionalLightFalloff(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#endif
#elif defined(POINTLIGHT{X})
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);
#endif
#else
preInfo.attenuation=1.0;
#endif
#ifdef HEMILIGHT{X}
preInfo.roughness=roughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(roughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#ifdef IRIDESCENCE
preInfo.iridescenceIntensity=iridescenceIntensity;
#endif
#ifdef HEMILIGHT{X}
info.diffuse=computeHemisphericDiffuseLighting(preInfo,light{X}.vLightDiffuse.rgb,light{X}.vLightGround);
#elif defined(SS_TRANSLUCENCY)
info.diffuse=computeDiffuseAndTransmittedLighting(preInfo,light{X}.vLightDiffuse.rgb,subSurfaceOut.transmittance);
#else
info.diffuse=computeDiffuseLighting(preInfo,light{X}.vLightDiffuse.rgb);
#endif
#ifdef SPECULARTERM
#ifdef ANISOTROPIC
info.specular=computeAnisotropicSpecularLighting(preInfo,viewDirectionW,normalW,anisotropicOut.anisotropicTangent,anisotropicOut.anisotropicBitangent,anisotropicOut.anisotropy,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#else
info.specular=computeSpecularLighting(preInfo,normalW,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#endif
#endif
#ifdef SHEEN
#ifdef SHEEN_LINKWITHALBEDO
preInfo.roughness=sheenOut.sheenIntensity;
#else
#ifdef HEMILIGHT{X}
preInfo.roughness=sheenOut.sheenRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(sheenOut.sheenRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#endif
info.sheen=computeSheenLighting(preInfo,normalW,sheenOut.sheenColor,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#endif
#ifdef CLEARCOAT
#ifdef HEMILIGHT{X}
preInfo.roughness=clearcoatOut.clearCoatRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(clearcoatOut.clearCoatRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
info.clearCoat=computeClearCoatLighting(preInfo,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatAARoughnessFactors.x,clearcoatOut.clearCoatIntensity,light{X}.vLightDiffuse.rgb);
#ifdef CLEARCOAT_TINT
absorption=computeClearCoatLightingAbsorption(clearcoatOut.clearCoatNdotVRefract,preInfo.L,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatColor,clearcoatOut.clearCoatThickness,clearcoatOut.clearCoatIntensity);info.diffuse*=absorption;
#ifdef SPECULARTERM
info.specular*=absorption;
#endif
#endif
info.diffuse*=info.clearCoat.w;
#ifdef SPECULARTERM
info.specular*=info.clearCoat.w;
#endif
#ifdef SHEEN
info.sheen*=info.clearCoat.w;
#endif
#endif
#else
#ifdef SPOTLIGHT{X}
info=computeSpotLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDirection,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightDiffuse.a,glossiness);
#elif defined(HEMILIGHT{X})
info=computeHemisphericLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightGround,glossiness);
#elif defined(POINTLIGHT{X}) || defined(DIRLIGHT{X})
info=computeLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightDiffuse.a,glossiness);
#endif
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
info.diffuse*=computeProjectionTextureDiffuseLighting(projectionLightSampler{X},textureProjectionMatrix{X});
#endif
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) 
{
#ifdef SHADOWCSM_RIGHTHANDED{X}
diff{X}=viewFrustumZ{X}[i]+vPositionFromCamera{X}.z;
#else
diff{X}=viewFrustumZ{X}[i]-vPositionFromCamera{X}.z;
#endif
if (diff{X}>=0.) {index{X}=i;break;}}
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
if (index{X}>=0)
#endif
{
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
shadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
shadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=vec3(shadow)*vCascadeColorsMultiplier{X}[index{X}];
#endif
#ifndef SHADOWCSMNOBLEND{X}
float frustumLength=frustumLengths{X}[index{X}];float diffRatio=clamp(diff{X}/frustumLength,0.,1.)*cascadeBlendFactor{X};if (index{X}<(SHADOWCSMNUM_CASCADES{X}-1) && diffRatio<1.)
{index{X}+=1;float nextShadow=0.;
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
nextShadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
nextShadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
nextShadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
shadow=mix(nextShadow,shadow,diffRatio);
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=mix(vec3(nextShadow)*vCascadeColorsMultiplier{X}[index{X}],shadowDebug{X},diffRatio);
#endif
}
#endif
}
#elif defined(SHADOWCLOSEESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithCloseESMCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithCloseESM(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithESMCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithESM(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPOISSON{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithPoissonSamplingCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadowWithPoissonSampling(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCF1(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCF3(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCF5(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCSS16(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCSS32(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCSS64(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#else
#if defined(SHADOWCUBE{X})
shadow=computeShadowCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadow(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#endif
#ifdef SHADOWONLY
#ifndef SHADOWINUSE
#define SHADOWINUSE
#endif
globalShadow+=shadow;shadowLightCount+=1.0;
#endif
#else
shadow=1.;
#endif
#ifndef SHADOWONLY
#ifdef CUSTOMUSERLIGHTING
diffuseBase+=computeCustomDiffuseLighting(info,diffuseBase,shadow);
#ifdef SPECULARTERM
specularBase+=computeCustomSpecularLighting(info,specularBase,shadow);
#endif
#elif defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X})
diffuseBase+=lightmapColor.rgb*shadow;
#ifdef SPECULARTERM
#ifndef LIGHTMAPNOSPECULAR{X}
specularBase+=info.specular*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef CLEARCOAT
#ifndef LIGHTMAPNOSPECULAR{X}
clearCoatBase+=info.clearCoat.rgb*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef SHEEN
#ifndef LIGHTMAPNOSPECULAR{X}
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#else
#ifdef SHADOWCSMDEBUG{X}
diffuseBase+=info.diffuse*shadowDebug{X};
#else 
diffuseBase+=info.diffuse*shadow;
#endif
#ifdef SPECULARTERM
specularBase+=info.specular*shadow;
#endif
#ifdef CLEARCOAT
clearCoatBase+=info.clearCoat.rgb*shadow;
#endif
#ifdef SHEEN
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$r] = shader$r;

    // Do not edit.
    const name$s = "logDepthFragment";
    const shader$s = `#ifdef LOGARITHMICDEPTH
gl_FragDepthEXT=log2(vFragmentDepth)*logarithmicDepthConstant*0.5;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$s] = shader$s;

    // Do not edit.
    const name$t = "fogFragment";
    const shader$t = `#ifdef FOG
float fog=CalcFogFactor();
#ifdef PBR
fog=toLinearSpace(fog);
#endif
color.rgb=mix(vFogColor,color.rgb,fog);
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$t] = shader$t;

    // Do not edit.
    const name$u = "oitFragment";
    const shader$u = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
float fragDepth=gl_FragCoord.z; 
#ifdef ORDER_INDEPENDENT_TRANSPARENCY_16BITS
uint halfFloat=packHalf2x16(vec2(fragDepth));vec2 full=unpackHalf2x16(halfFloat);fragDepth=full.x;
#endif
ivec2 fragCoord=ivec2(gl_FragCoord.xy);vec2 lastDepth=texelFetch(oitDepthSampler,fragCoord,0).rg;vec4 lastFrontColor=texelFetch(oitFrontColorSampler,fragCoord,0);depth.rg=vec2(-MAX_DEPTH);frontColor=lastFrontColor;backColor=vec4(0.0);
#ifdef USE_REVERSE_DEPTHBUFFER
float furthestDepth=-lastDepth.x;float nearestDepth=lastDepth.y;
#else
float nearestDepth=-lastDepth.x;float furthestDepth=lastDepth.y;
#endif
float alphaMultiplier=1.0-lastFrontColor.a;
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth>nearestDepth || fragDepth<furthestDepth) {
#else
if (fragDepth<nearestDepth || fragDepth>furthestDepth) {
#endif
return;}
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth<nearestDepth && fragDepth>furthestDepth) {
#else
if (fragDepth>nearestDepth && fragDepth<furthestDepth) {
#endif
depth.rg=vec2(-fragDepth,fragDepth);return;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$u] = shader$u;

    // Do not edit.
    const name$v = "defaultPixelShader";
    const shader$v = `#include<__decl__defaultFragment>
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
#include<prePassDeclaration>[SCENE_MRT_COUNT]
#include<oitDeclaration>
#define CUSTOM_FRAGMENT_BEGIN
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#define RECIPROCAL_PI2 0.15915494
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<mainUVVaryingDeclaration>[1..7]
#include<helperFunctions>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<samplerFragmentDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_SAMPLERNAME_,diffuse)
#include<samplerFragmentDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_SAMPLERNAME_,ambient)
#include<samplerFragmentDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_SAMPLERNAME_,opacity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_SAMPLERNAME_,emissive)
#include<samplerFragmentDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_SAMPLERNAME_,lightmap)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_SAMPLERNAME_,decal)
#ifdef REFRACTION
#ifdef REFRACTIONMAP_3D
uniform samplerCube refractionCubeSampler;
#else
uniform sampler2D refraction2DSampler;
#endif
#endif
#if defined(SPECULARTERM)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_SAMPLERNAME_,specular)
#endif
#include<fresnelFunction>
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
uniform samplerCube reflectionCubeSampler;
#else
uniform sampler2D reflection2DSampler;
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#include<reflectionFunction>
#endif
#include<imageProcessingDeclaration>
#include<imageProcessingFunctions>
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);vec4 baseColor=vec4(1.,1.,1.,1.);vec3 diffuseColor=vDiffuseColor.rgb;float alpha=vDiffuseColor.a;
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=normalize(-cross(dFdx(vPositionW),dFdy(vPositionW)));
#endif
#include<bumpFragment>
#ifdef TWOSIDEDLIGHTING
normalW=gl_FrontFacing ? normalW : -normalW;
#endif
#ifdef DIFFUSE
baseColor=texture2D(diffuseSampler,vDiffuseUV+uvOffset);
#if defined(ALPHATEST) && !defined(ALPHATEST_AFTERALLALPHACOMPUTATIONS)
if (baseColor.a<alphaCutOff)
discard;
#endif
#ifdef ALPHAFROMDIFFUSE
alpha*=baseColor.a;
#endif
#define CUSTOM_FRAGMENT_UPDATE_ALPHA
baseColor.rgb*=vDiffuseInfos.y;
#endif
#if defined(DECAL) && !defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#include<depthPrePass>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
baseColor.rgb*=vColor.rgb;
#endif
#ifdef DETAIL
baseColor.rgb=baseColor.rgb*2.0*mix(0.5,detailColor.r,vDetailInfos.y);
#endif
#if defined(DECAL) && defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#define CUSTOM_FRAGMENT_UPDATE_DIFFUSE
vec3 baseAmbientColor=vec3(1.,1.,1.);
#ifdef AMBIENT
baseAmbientColor=texture2D(ambientSampler,vAmbientUV+uvOffset).rgb*vAmbientInfos.y;
#endif
#define CUSTOM_FRAGMENT_BEFORE_LIGHTS
#ifdef SPECULARTERM
float glossiness=vSpecularColor.a;vec3 specularColor=vSpecularColor.rgb;
#ifdef SPECULAR
vec4 specularMapColor=texture2D(specularSampler,vSpecularUV+uvOffset);specularColor=specularMapColor.rgb;
#ifdef GLOSSINESS
glossiness=glossiness*specularMapColor.a;
#endif
#endif
#else
float glossiness=0.;
#endif
vec3 diffuseBase=vec3(0.,0.,0.);lightingInfo info;
#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);
#endif
float shadow=1.;
#ifdef LIGHTMAP
vec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);
#ifdef RGBDLIGHTMAP
lightmapColor.rgb=fromRGBD(lightmapColor);
#endif
lightmapColor.rgb*=vLightmapInfos.y;
#endif
#include<lightFragment>[0..maxSimultaneousLights]
vec4 refractionColor=vec4(0.,0.,0.,1.);
#ifdef REFRACTION
vec3 refractionVector=normalize(refract(-viewDirectionW,normalW,vRefractionInfos.y));
#ifdef REFRACTIONMAP_3D
#ifdef USE_LOCAL_REFRACTIONMAP_CUBIC
refractionVector=parallaxCorrectNormal(vPositionW,refractionVector,vRefractionSize,vRefractionPosition);
#endif
refractionVector.y=refractionVector.y*vRefractionInfos.w;vec4 refractionLookup=textureCube(refractionCubeSampler,refractionVector);if (dot(refractionVector,viewDirectionW)<1.0) {refractionColor=refractionLookup;}
#else
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*vRefractionInfos.z,1.0)));vec2 refractionCoords=vRefractionUVW.xy/vRefractionUVW.z;refractionCoords.y=1.0-refractionCoords.y;refractionColor=texture2D(refraction2DSampler,refractionCoords);
#endif
#ifdef RGBDREFRACTION
refractionColor.rgb=fromRGBD(refractionColor);
#endif
#ifdef IS_REFRACTION_LINEAR
refractionColor.rgb=toGammaSpace(refractionColor.rgb);
#endif
refractionColor.rgb*=vRefractionInfos.x;
#endif
vec4 reflectionColor=vec4(0.,0.,0.,1.);
#ifdef REFLECTION
vec3 vReflectionUVW=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
vReflectionUVW.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
#ifdef ROUGHNESS
float bias=vReflectionInfos.y;
#ifdef SPECULARTERM
#ifdef SPECULAR
#ifdef GLOSSINESS
bias*=(1.0-specularMapColor.a);
#endif
#endif
#endif
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW,bias);
#else
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW);
#endif
#else
vec2 coords=vReflectionUVW.xy;
#ifdef REFLECTIONMAP_PROJECTION
coords/=vReflectionUVW.z;
#endif
coords.y=1.0-coords.y;reflectionColor=texture2D(reflection2DSampler,coords);
#endif
#ifdef RGBDREFLECTION
reflectionColor.rgb=fromRGBD(reflectionColor);
#endif
#ifdef IS_REFLECTION_LINEAR
reflectionColor.rgb=toGammaSpace(reflectionColor.rgb);
#endif
reflectionColor.rgb*=vReflectionInfos.x;
#ifdef REFLECTIONFRESNEL
float reflectionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,reflectionRightColor.a,reflectionLeftColor.a);
#ifdef REFLECTIONFRESNELFROMSPECULAR
#ifdef SPECULARTERM
reflectionColor.rgb*=specularColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#endif
#endif
#ifdef REFRACTIONFRESNEL
float refractionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,refractionRightColor.a,refractionLeftColor.a);refractionColor.rgb*=refractionLeftColor.rgb*(1.0-refractionFresnelTerm)+refractionFresnelTerm*refractionRightColor.rgb;
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vOpacityUV+uvOffset);
#ifdef OPACITYRGB
opacityMap.rgb=opacityMap.rgb*vec3(0.3,0.59,0.11);alpha*=(opacityMap.x+opacityMap.y+opacityMap.z)* vOpacityInfos.y;
#else
alpha*=opacityMap.a*vOpacityInfos.y;
#endif
#endif
#if defined(VERTEXALPHA) || defined(INSTANCESCOLOR) && defined(INSTANCES)
alpha*=vColor.a;
#endif
#ifdef OPACITYFRESNEL
float opacityFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,opacityParts.z,opacityParts.w);alpha+=opacityParts.x*(1.0-opacityFresnelTerm)+opacityFresnelTerm*opacityParts.y;
#endif
#ifdef ALPHATEST
#ifdef ALPHATEST_AFTERALLALPHACOMPUTATIONS
if (alpha<alphaCutOff)
discard;
#endif
#ifndef ALPHABLEND
alpha=1.0;
#endif
#endif
vec3 emissiveColor=vEmissiveColor;
#ifdef EMISSIVE
emissiveColor+=texture2D(emissiveSampler,vEmissiveUV+uvOffset).rgb*vEmissiveInfos.y;
#endif
#ifdef EMISSIVEFRESNEL
float emissiveFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,emissiveRightColor.a,emissiveLeftColor.a);emissiveColor*=emissiveLeftColor.rgb*(1.0-emissiveFresnelTerm)+emissiveFresnelTerm*emissiveRightColor.rgb;
#endif
#ifdef DIFFUSEFRESNEL
float diffuseFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,diffuseRightColor.a,diffuseLeftColor.a);diffuseBase*=diffuseLeftColor.rgb*(1.0-diffuseFresnelTerm)+diffuseFresnelTerm*diffuseRightColor.rgb;
#endif
#ifdef EMISSIVEASILLUMINATION
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
#ifdef LINKEMISSIVEWITHDIFFUSE
vec3 finalDiffuse=clamp((diffuseBase+emissiveColor)*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+emissiveColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#endif
#endif
#ifdef SPECULARTERM
vec3 finalSpecular=specularBase*specularColor;
#ifdef SPECULAROVERALPHA
alpha=clamp(alpha+dot(finalSpecular,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#else
vec3 finalSpecular=vec3(0.0);
#endif
#ifdef REFLECTIONOVERALPHA
alpha=clamp(alpha+dot(reflectionColor.rgb,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#ifdef EMISSIVEASILLUMINATION
vec4 color=vec4(clamp(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+emissiveColor+refractionColor.rgb,0.0,1.0),alpha);
#else
vec4 color=vec4(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+refractionColor.rgb,alpha);
#endif
#ifdef LIGHTMAP
#ifndef LIGHTMAPEXCLUDED
#ifdef USELIGHTMAPASSHADOWMAP
color.rgb*=lightmapColor.rgb;
#else
color.rgb+=lightmapColor.rgb;
#endif
#endif
#endif
#define CUSTOM_FRAGMENT_BEFORE_FOG
color.rgb=max(color.rgb,0.);
#include<logDepthFragment>
#include<fogFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
color.rgb=toLinearSpace(color.rgb);
#else
#ifdef IMAGEPROCESSING
color.rgb=toLinearSpace(color.rgb);color=applyImageProcessing(color);
#endif
#endif
color.a*=visibility;
#ifdef PREMULTIPLYALPHA
color.rgb*=color.a;
#endif
#define CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR
#ifdef PREPASS
float writeGeometryInfo=color.a>0.4 ? 1.0 : 0.0;gl_FragData[0]=color; 
#ifdef PREPASS_POSITION
gl_FragData[PREPASS_POSITION_INDEX]=vec4(vPositionW,writeGeometryInfo);
#endif
#ifdef PREPASS_VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[PREPASS_VELOCITY_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_IRRADIANCE
gl_FragData[PREPASS_IRRADIANCE_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_DEPTH
gl_FragData[PREPASS_DEPTH_INDEX]=vec4(vViewPos.z,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_NORMAL
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalize((view*vec4(normalW,0.0)).rgb),writeGeometryInfo); 
#endif
#ifdef PREPASS_ALBEDO_SQRT
gl_FragData[PREPASS_ALBEDO_SQRT_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_REFLECTIVITY
#if defined(SPECULARTERM)
#if defined(SPECULAR)
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularMapColor))*writeGeometryInfo; 
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularColor),1.0)*writeGeometryInfo;
#endif
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(0.0,0.0,0.0,1.0)*writeGeometryInfo;
#endif
#endif
#endif
#if !defined(PREPASS) || defined(WEBGL2)
gl_FragColor=color;
#endif
#include<oitFragment>
#if ORDER_INDEPENDENT_TRANSPARENCY
if (fragDepth==nearestDepth) {frontColor.rgb+=color.rgb*color.a*alphaMultiplier;frontColor.a=1.0-alphaMultiplier*(1.0-color.a);} else {backColor+=color;}
#endif
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$v] = shader$v;

    // Do not edit.
    const name$w = "decalVertexDeclaration";
    const shader$w = `#ifdef DECAL
uniform vec4 vDecalInfos;uniform mat4 decalMatrix;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$w] = shader$w;

    // Do not edit.
    const name$x = "defaultVertexDeclaration";
    const shader$x = `uniform mat4 viewProjection;uniform mat4 view;
#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform mat4 ambientMatrix;uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY
uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;uniform mat4 emissiveMatrix;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;uniform mat4 lightmapMatrix;
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;uniform mat4 specularMatrix;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform mat4 bumpMatrix;
#endif
#ifdef REFLECTION
uniform mat4 reflectionMatrix;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;uniform mat4 detailMatrix;
#endif
#include<decalVertexDeclaration>
#define ADDITIONAL_VERTEX_DECLARATION
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$x] = shader$x;

    // Do not edit.
    const name$y = "uvAttributeDeclaration";
    const shader$y = `#ifdef UV{X}
attribute vec2 uv{X};
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$y] = shader$y;

    // Do not edit.
    const name$z = "bonesDeclaration";
    const shader$z = `#if NUM_BONE_INFLUENCERS>0
attribute vec4 matricesIndices;attribute vec4 matricesWeights;
#if NUM_BONE_INFLUENCERS>4
attribute vec4 matricesIndicesExtra;attribute vec4 matricesWeightsExtra;
#endif
#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#ifdef BONETEXTURE
uniform sampler2D boneSampler;uniform float boneTextureWidth;
#else
uniform mat4 mBones[BonesPerMesh];
#ifdef BONES_VELOCITY_ENABLED
uniform mat4 mPreviousBones[BonesPerMesh];
#endif
#endif
#ifdef BONETEXTURE
#define inline
mat4 readMatrixFromRawSampler(sampler2D smp,float index)
{float offset=index *4.0;float dx=1.0/boneTextureWidth;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),0.));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),0.));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),0.));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),0.));return mat4(m0,m1,m2,m3);}
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$z] = shader$z;

    // Do not edit.
    const name$A = "bakedVertexAnimationDeclaration";
    const shader$A = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
uniform float bakedVertexAnimationTime;uniform vec2 bakedVertexAnimationTextureSizeInverted;uniform vec4 bakedVertexAnimationSettings;uniform sampler2D bakedVertexAnimationTexture;
#ifdef INSTANCES
attribute vec4 bakedVertexAnimationSettingsInstanced;
#endif
#define inline
mat4 readMatrixFromRawSamplerVAT(sampler2D smp,float index,float frame)
{float offset=index*4.0;float frameUV=(frame+0.5)*bakedVertexAnimationTextureSizeInverted.y;float dx=bakedVertexAnimationTextureSizeInverted.x;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),frameUV));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),frameUV));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),frameUV));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),frameUV));return mat4(m0,m1,m2,m3);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$A] = shader$A;

    // Do not edit.
    const name$B = "instancesDeclaration";
    const shader$B = `#ifdef INSTANCES
attribute vec4 world0;attribute vec4 world1;attribute vec4 world2;attribute vec4 world3;
#ifdef INSTANCESCOLOR
attribute vec4 instanceColor;
#endif
#if defined(THIN_INSTANCES) && !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
attribute vec4 previousWorld0;attribute vec4 previousWorld1;attribute vec4 previousWorld2;attribute vec4 previousWorld3;
#ifdef THIN_INSTANCES
uniform mat4 previousWorld;
#endif
#endif
#else
#if !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
uniform mat4 previousWorld;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$B] = shader$B;

    // Do not edit.
    const name$C = "prePassVertexDeclaration";
    const shader$C = `#ifdef PREPASS
#ifdef PREPASS_DEPTH
varying vec3 vViewPos;
#endif
#ifdef PREPASS_VELOCITY
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$C] = shader$C;

    // Do not edit.
    const name$D = "samplerVertexDeclaration";
    const shader$D = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
varying vec2 v_VARYINGNAME_UV;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$D] = shader$D;

    // Do not edit.
    const name$E = "bumpVertexDeclaration";
    const shader$E = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$E] = shader$E;

    // Do not edit.
    const name$F = "clipPlaneVertexDeclaration";
    const shader$F = `#ifdef CLIPPLANE
uniform vec4 vClipPlane;varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
uniform vec4 vClipPlane2;varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
uniform vec4 vClipPlane3;varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
uniform vec4 vClipPlane4;varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
uniform vec4 vClipPlane5;varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
uniform vec4 vClipPlane6;varying float fClipDistance6;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$F] = shader$F;

    // Do not edit.
    const name$G = "fogVertexDeclaration";
    const shader$G = `#ifdef FOG
varying vec3 vFogDistance;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$G] = shader$G;

    // Do not edit.
    const name$H = "lightVxFragmentDeclaration";
    const shader$H = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$H] = shader$H;

    // Do not edit.
    const name$I = "lightVxUboDeclaration";
    const shader$I = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$I] = shader$I;

    // Do not edit.
    const name$J = "morphTargetsVertexGlobalDeclaration";
    const shader$J = `#ifdef MORPHTARGETS
uniform float morphTargetInfluences[NUM_MORPH_INFLUENCERS];
#ifdef MORPHTARGETS_TEXTURE 
precision mediump sampler2DArray; 
uniform float morphTargetTextureIndices[NUM_MORPH_INFLUENCERS];uniform vec3 morphTargetTextureInfo;uniform sampler2DArray morphTargets;vec3 readVector3FromRawSampler(int targetIndex,float vertexIndex)
{ 
float y=floor(vertexIndex/morphTargetTextureInfo.y);float x=vertexIndex-y*morphTargetTextureInfo.y;vec3 textureUV=vec3((x+0.5)/morphTargetTextureInfo.y,(y+0.5)/morphTargetTextureInfo.z,morphTargetTextureIndices[targetIndex]);return texture(morphTargets,textureUV).xyz;}
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$J] = shader$J;

    // Do not edit.
    const name$K = "morphTargetsVertexDeclaration";
    const shader$K = `#ifdef MORPHTARGETS
#ifndef MORPHTARGETS_TEXTURE
attribute vec3 position{X};
#ifdef MORPHTARGETS_NORMAL
attribute vec3 normal{X};
#endif
#ifdef MORPHTARGETS_TANGENT
attribute vec3 tangent{X};
#endif
#ifdef MORPHTARGETS_UV
attribute vec2 uv_{X};
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$K] = shader$K;

    // Do not edit.
    const name$L = "morphTargetsVertexGlobal";
    const shader$L = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
float vertexID;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$L] = shader$L;

    // Do not edit.
    const name$M = "morphTargetsVertex";
    const shader$M = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE 
vertexID=float(gl_VertexID)*morphTargetTextureInfo.x;positionUpdated+=(readVector3FromRawSampler({X},vertexID)-position)*morphTargetInfluences[{X}];vertexID+=1.0;
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(readVector3FromRawSampler({X},vertexID) -normal)*morphTargetInfluences[{X}];vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(readVector3FromRawSampler({X},vertexID).xy-uv)*morphTargetInfluences[{X}];vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(readVector3FromRawSampler({X},vertexID) -tangent.xyz)*morphTargetInfluences[{X}];
#endif
#else
positionUpdated+=(position{X}-position)*morphTargetInfluences[{X}];
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(normal{X}-normal)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(tangent{X}-tangent.xyz)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(uv_{X}-uv)*morphTargetInfluences[{X}];
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$M] = shader$M;

    // Do not edit.
    const name$N = "instancesVertex";
    const shader$N = `#ifdef INSTANCES
mat4 finalWorld=mat4(world0,world1,world2,world3);
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
mat4 finalPreviousWorld=mat4(previousWorld0,previousWorld1,previousWorld2,previousWorld3);
#endif
#ifdef THIN_INSTANCES
finalWorld=world*finalWorld;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
finalPreviousWorld=previousWorld*finalPreviousWorld;
#endif
#endif
#else
mat4 finalWorld=world;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
mat4 finalPreviousWorld=previousWorld;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$N] = shader$N;

    // Do not edit.
    const name$O = "bonesVertex";
    const shader$O = `#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#if NUM_BONE_INFLUENCERS>0
mat4 influence;
#ifdef BONETEXTURE
influence=readMatrixFromRawSampler(boneSampler,matricesIndices[0])*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[1])*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[2])*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[3])*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[0])*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[1])*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[2])*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[3])*matricesWeightsExtra[3];
#endif
#else
influence=mBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=mBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=mBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=mBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=mBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=mBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=mBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=mBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
#endif
finalWorld=finalWorld*influence;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$O] = shader$O;

    // Do not edit.
    const name$P = "bakedVertexAnimation";
    const shader$P = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
{
#ifdef INSTANCES
#define BVASNAME bakedVertexAnimationSettingsInstanced
#else
#define BVASNAME bakedVertexAnimationSettings
#endif
float VATStartFrame=BVASNAME.x;float VATEndFrame=BVASNAME.y;float VATOffsetFrame=BVASNAME.z;float VATSpeed=BVASNAME.w;float totalFrames=VATEndFrame-VATStartFrame+1.0;float time=bakedVertexAnimationTime*VATSpeed/totalFrames;float frameCorrection=time<1.0 ? 0.0 : 1.0;float numOfFrames=totalFrames-frameCorrection;float VATFrameNum=fract(time)*numOfFrames;VATFrameNum=mod(VATFrameNum+VATOffsetFrame,numOfFrames);VATFrameNum=floor(VATFrameNum);VATFrameNum+=VATStartFrame+frameCorrection;mat4 VATInfluence;VATInfluence=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[0],VATFrameNum)*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[1],VATFrameNum)*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[2],VATFrameNum)*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[3],VATFrameNum)*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[0],VATFrameNum)*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[1],VATFrameNum)*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[2],VATFrameNum)*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[3],VATFrameNum)*matricesWeightsExtra[3];
#endif
finalWorld=finalWorld*VATInfluence;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$P] = shader$P;

    // Do not edit.
    const name$Q = "prePassVertex";
    const shader$Q = `#ifdef PREPASS_DEPTH
vViewPos=(view*worldPos).rgb;
#endif
#if defined(PREPASS_VELOCITY) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*worldPos;
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif 
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif 
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif 
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif 
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif 
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$Q] = shader$Q;

    // Do not edit.
    const name$R = "uvVariableDeclaration";
    const shader$R = `#if !defined(UV{X}) && defined(MAINUV{X})
vec2 uv{X}=vec2(0.,0.);
#endif
#ifdef MAINUV{X}
vMainUV{X}=uv{X};
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$R] = shader$R;

    // Do not edit.
    const name$S = "samplerVertexImplementation";
    const shader$S = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
if (v_INFONAME_==0.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uvUpdated,1.0,0.0));}
#ifdef UV2
else if (v_INFONAME_==1.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv2,1.0,0.0));}
#endif
#ifdef UV3
else if (v_INFONAME_==2.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv3,1.0,0.0));}
#endif
#ifdef UV4
else if (v_INFONAME_==3.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv4,1.0,0.0));}
#endif
#ifdef UV5
else if (v_INFONAME_==4.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv5,1.0,0.0));}
#endif
#ifdef UV6
else if (v_INFONAME_==5.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv6,1.0,0.0));}
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$S] = shader$S;

    // Do not edit.
    const name$T = "bumpVertex";
    const shader$T = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
vec3 tbnNormal=normalize(normalUpdated);vec3 tbnTangent=normalize(tangentUpdated.xyz);vec3 tbnBitangent=cross(tbnNormal,tbnTangent)*tangentUpdated.w;vTBN=mat3(finalWorld)*mat3(tbnTangent,tbnBitangent,tbnNormal);
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$T] = shader$T;

    // Do not edit.
    const name$U = "clipPlaneVertex";
    const shader$U = `#ifdef CLIPPLANE
fClipDistance=dot(worldPos,vClipPlane);
#endif
#ifdef CLIPPLANE2
fClipDistance2=dot(worldPos,vClipPlane2);
#endif
#ifdef CLIPPLANE3
fClipDistance3=dot(worldPos,vClipPlane3);
#endif
#ifdef CLIPPLANE4
fClipDistance4=dot(worldPos,vClipPlane4);
#endif
#ifdef CLIPPLANE5
fClipDistance5=dot(worldPos,vClipPlane5);
#endif
#ifdef CLIPPLANE6
fClipDistance6=dot(worldPos,vClipPlane6);
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$U] = shader$U;

    // Do not edit.
    const name$V = "fogVertex";
    const shader$V = `#ifdef FOG
vFogDistance=(view*worldPos).xyz;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$V] = shader$V;

    // Do not edit.
    const name$W = "shadowsVertex";
    const shader$W = `#ifdef SHADOWS
#if defined(SHADOWCSM{X})
vPositionFromCamera{X}=view*worldPos;for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) {vPositionFromLight{X}[i]=lightMatrix{X}[i]*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}[i]=(-vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}[i]=(vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
}
#elif defined(SHADOW{X}) && !defined(SHADOWCUBE{X})
vPositionFromLight{X}=lightMatrix{X}*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}=(-vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}=(vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$W] = shader$W;

    // Do not edit.
    const name$X = "vertexColorMixing";
    const shader$X = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
vColor=vec4(1.0);
#ifdef VERTEXCOLOR
#ifdef VERTEXALPHA
vColor*=color;
#else
vColor.rgb*=color.rgb;
#endif
#endif
#ifdef INSTANCESCOLOR
vColor*=instanceColor;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$X] = shader$X;

    // Do not edit.
    const name$Y = "pointCloudVertex";
    const shader$Y = `#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$Y] = shader$Y;

    // Do not edit.
    const name$Z = "logDepthVertex";
    const shader$Z = `#ifdef LOGARITHMICDEPTH
vFragmentDepth=1.0+gl_Position.w;gl_Position.z=log2(max(0.000001,vFragmentDepth))*logarithmicDepthConstant;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$Z] = shader$Z;

    // Do not edit.
    const name$_ = "defaultVertexShader";
    const shader$_ = `#include<__decl__defaultVertex>
#define CUSTOM_VERTEX_BEGIN
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#ifdef TANGENT
attribute vec4 tangent;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#include<uvAttributeDeclaration>[2..7]
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<helperFunctions>
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
#include<prePassVertexDeclaration>
#include<mainUVVaryingDeclaration>[1..7]
#include<samplerVertexDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse)
#include<samplerVertexDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail)
#include<samplerVertexDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient)
#include<samplerVertexDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity)
#include<samplerVertexDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive)
#include<samplerVertexDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap)
#if defined(SPECULARTERM)
#include<samplerVertexDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular)
#endif
#include<samplerVertexDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump)
#include<samplerVertexDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal)
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<bumpVertexDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#ifdef TANGENT
vec4 tangentUpdated=tangent;
#endif
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=positionUpdated;
#endif
#define CUSTOM_VERTEX_UPDATE_POSITION
#define CUSTOM_VERTEX_UPDATE_NORMAL
#include<instancesVertex>
#if defined(PREPASS) && defined(PREPASS_VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normalWorld[0],normalWorld[0]),dot(normalWorld[1],normalWorld[1]),dot(normalWorld[2],normalWorld[2]));vNormalW=normalize(normalWorld*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normalUpdated);
#endif
#endif
#define CUSTOM_VERTEX_UPDATE_WORLDPOS
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
vPositionW=vec3(worldPos);
#include<prePassVertex>
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(positionUpdated,0.0)));
#endif
#ifndef UV1
vec2 uvUpdated=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uvUpdated;
#endif
#include<uvVariableDeclaration>[2..7]
#include<samplerVertexImplementation>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_MATRIXNAME_,diffuse,_INFONAME_,DiffuseInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_MATRIXNAME_,detail,_INFONAME_,DetailInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_MATRIXNAME_,ambient,_INFONAME_,AmbientInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_MATRIXNAME_,opacity,_INFONAME_,OpacityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_MATRIXNAME_,emissive,_INFONAME_,EmissiveInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_MATRIXNAME_,lightmap,_INFONAME_,LightmapInfos.x)
#if defined(SPECULARTERM)
#include<samplerVertexImplementation>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_MATRIXNAME_,specular,_INFONAME_,SpecularInfos.x)
#endif
#include<samplerVertexImplementation>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_MATRIXNAME_,bump,_INFONAME_,BumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_MATRIXNAME_,decal,_INFONAME_,DecalInfos.x)
#include<bumpVertex>
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#include<pointCloudVertex>
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$_] = shader$_;

    /**
     * EffectFallbacks can be used to add fallbacks (properties to disable) to certain properties when desired to improve performance.
     * (Eg. Start at high quality with reflection and fog, if fps is low, remove reflection, if still low remove fog)
     */
    class EffectFallbacks {
        constructor() {
            this._defines = {};
            this._currentRank = 32;
            this._maxRank = -1;
            this._mesh = null;
        }
        /**
         * Removes the fallback from the bound mesh.
         */
        unBindMesh() {
            this._mesh = null;
        }
        /**
         * Adds a fallback on the specified property.
         * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
         * @param define The name of the define in the shader
         */
        addFallback(rank, define) {
            if (!this._defines[rank]) {
                if (rank < this._currentRank) {
                    this._currentRank = rank;
                }
                if (rank > this._maxRank) {
                    this._maxRank = rank;
                }
                this._defines[rank] = new Array();
            }
            this._defines[rank].push(define);
        }
        /**
         * Sets the mesh to use CPU skinning when needing to fallback.
         * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
         * @param mesh The mesh to use the fallbacks.
         */
        addCPUSkinningFallback(rank, mesh) {
            this._mesh = mesh;
            if (rank < this._currentRank) {
                this._currentRank = rank;
            }
            if (rank > this._maxRank) {
                this._maxRank = rank;
            }
        }
        /**
         * Checks to see if more fallbacks are still available.
         */
        get hasMoreFallbacks() {
            return this._currentRank <= this._maxRank;
        }
        /**
         * Removes the defines that should be removed when falling back.
         * @param currentDefines defines the current define statements for the shader.
         * @param effect defines the current effect we try to compile
         * @returns The resulting defines with defines of the current rank removed.
         */
        reduce(currentDefines, effect) {
            // First we try to switch to CPU skinning
            if (this._mesh && this._mesh.computeBonesUsingShaders && this._mesh.numBoneInfluencers > 0) {
                this._mesh.computeBonesUsingShaders = false;
                currentDefines = currentDefines.replace("#define NUM_BONE_INFLUENCERS " + this._mesh.numBoneInfluencers, "#define NUM_BONE_INFLUENCERS 0");
                effect._bonesComputationForcedToCPU = true;
                const scene = this._mesh.getScene();
                for (let index = 0; index < scene.meshes.length; index++) {
                    const otherMesh = scene.meshes[index];
                    if (!otherMesh.material) {
                        if (!this._mesh.material && otherMesh.computeBonesUsingShaders && otherMesh.numBoneInfluencers > 0) {
                            otherMesh.computeBonesUsingShaders = false;
                        }
                        continue;
                    }
                    if (!otherMesh.computeBonesUsingShaders || otherMesh.numBoneInfluencers === 0) {
                        continue;
                    }
                    if (otherMesh.material.getEffect() === effect) {
                        otherMesh.computeBonesUsingShaders = false;
                    }
                    else if (otherMesh.subMeshes) {
                        for (const subMesh of otherMesh.subMeshes) {
                            const subMeshEffect = subMesh.effect;
                            if (subMeshEffect === effect) {
                                otherMesh.computeBonesUsingShaders = false;
                                break;
                            }
                        }
                    }
                }
            }
            else {
                const currentFallbacks = this._defines[this._currentRank];
                if (currentFallbacks) {
                    for (let index = 0; index < currentFallbacks.length; index++) {
                        currentDefines = currentDefines.replace("#define " + currentFallbacks[index], "");
                    }
                }
                this._currentRank++;
            }
            return currentDefines;
        }
    }

    const rxOption = new RegExp("^([gimus]+)!");
    /**
     * Class that manages the plugins of a material
     * @since 5.0
     */
    class MaterialPluginManager {
        /**
         * Creates a new instance of the plugin manager
         * @param material material that this manager will manage the plugins for
         */
        constructor(material) {
            /** @internal */
            this._plugins = [];
            this._activePlugins = [];
            this._activePluginsForExtraEvents = [];
            this._material = material;
            this._scene = material.getScene();
            this._engine = this._scene.getEngine();
        }
        /**
         * @internal
         */
        _addPlugin(plugin) {
            for (let i = 0; i < this._plugins.length; ++i) {
                if (this._plugins[i].name === plugin.name) {
                    return false;
                }
            }
            if (this._material._uniformBufferLayoutBuilt) {
                throw `The plugin "${plugin.name}" can't be added to the material "${this._material.name}" because this material has already been used for rendering! Please add plugins to materials before any rendering with this material occurs.`;
            }
            const pluginClassName = plugin.getClassName();
            if (!MaterialPluginManager._MaterialPluginClassToMainDefine[pluginClassName]) {
                MaterialPluginManager._MaterialPluginClassToMainDefine[pluginClassName] = "MATERIALPLUGIN_" + ++MaterialPluginManager._MaterialPluginCounter;
            }
            this._material._callbackPluginEventGeneric = this._handlePluginEvent.bind(this);
            this._plugins.push(plugin);
            this._plugins.sort((a, b) => a.priority - b.priority);
            this._codeInjectionPoints = {};
            const defineNamesFromPlugins = {};
            defineNamesFromPlugins[MaterialPluginManager._MaterialPluginClassToMainDefine[pluginClassName]] = {
                type: "boolean",
                default: true,
            };
            for (const plugin of this._plugins) {
                plugin.collectDefines(defineNamesFromPlugins);
                this._collectPointNames("vertex", plugin.getCustomCode("vertex"));
                this._collectPointNames("fragment", plugin.getCustomCode("fragment"));
            }
            this._defineNamesFromPlugins = defineNamesFromPlugins;
            return true;
        }
        /**
         * @internal
         */
        _activatePlugin(plugin) {
            if (this._activePlugins.indexOf(plugin) === -1) {
                this._activePlugins.push(plugin);
                this._activePlugins.sort((a, b) => a.priority - b.priority);
                this._material._callbackPluginEventIsReadyForSubMesh = this._handlePluginEventIsReadyForSubMesh.bind(this);
                this._material._callbackPluginEventPrepareDefinesBeforeAttributes = this._handlePluginEventPrepareDefinesBeforeAttributes.bind(this);
                this._material._callbackPluginEventPrepareDefines = this._handlePluginEventPrepareDefines.bind(this);
                this._material._callbackPluginEventBindForSubMesh = this._handlePluginEventBindForSubMesh.bind(this);
                if (plugin.registerForExtraEvents) {
                    this._activePluginsForExtraEvents.push(plugin);
                    this._activePluginsForExtraEvents.sort((a, b) => a.priority - b.priority);
                    this._material._callbackPluginEventHasRenderTargetTextures = this._handlePluginEventHasRenderTargetTextures.bind(this);
                    this._material._callbackPluginEventFillRenderTargetTextures = this._handlePluginEventFillRenderTargetTextures.bind(this);
                    this._material._callbackPluginEventHardBindForSubMesh = this._handlePluginEventHardBindForSubMesh.bind(this);
                }
            }
        }
        /**
         * Gets a plugin from the list of plugins managed by this manager
         * @param name name of the plugin
         * @returns the plugin if found, else null
         */
        getPlugin(name) {
            for (let i = 0; i < this._plugins.length; ++i) {
                if (this._plugins[i].name === name) {
                    return this._plugins[i];
                }
            }
            return null;
        }
        _handlePluginEventIsReadyForSubMesh(eventData) {
            let isReady = true;
            for (const plugin of this._activePlugins) {
                isReady = isReady && plugin.isReadyForSubMesh(eventData.defines, this._scene, this._engine, eventData.subMesh);
            }
            eventData.isReadyForSubMesh = isReady;
        }
        _handlePluginEventPrepareDefinesBeforeAttributes(eventData) {
            for (const plugin of this._activePlugins) {
                plugin.prepareDefinesBeforeAttributes(eventData.defines, this._scene, eventData.mesh);
            }
        }
        _handlePluginEventPrepareDefines(eventData) {
            for (const plugin of this._activePlugins) {
                plugin.prepareDefines(eventData.defines, this._scene, eventData.mesh);
            }
        }
        _handlePluginEventHardBindForSubMesh(eventData) {
            for (const plugin of this._activePluginsForExtraEvents) {
                plugin.hardBindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, eventData.subMesh);
            }
        }
        _handlePluginEventBindForSubMesh(eventData) {
            for (const plugin of this._activePlugins) {
                plugin.bindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, eventData.subMesh);
            }
        }
        _handlePluginEventHasRenderTargetTextures(eventData) {
            let hasRenderTargetTextures = false;
            for (const plugin of this._activePluginsForExtraEvents) {
                hasRenderTargetTextures = plugin.hasRenderTargetTextures();
                if (hasRenderTargetTextures) {
                    break;
                }
            }
            eventData.hasRenderTargetTextures = hasRenderTargetTextures;
        }
        _handlePluginEventFillRenderTargetTextures(eventData) {
            for (const plugin of this._activePluginsForExtraEvents) {
                plugin.fillRenderTargetTextures(eventData.renderTargets);
            }
        }
        _handlePluginEvent(id, info) {
            var _a;
            switch (id) {
                case MaterialPluginEvent.GetActiveTextures: {
                    const eventData = info;
                    for (const plugin of this._activePlugins) {
                        plugin.getActiveTextures(eventData.activeTextures);
                    }
                    break;
                }
                case MaterialPluginEvent.GetAnimatables: {
                    const eventData = info;
                    for (const plugin of this._activePlugins) {
                        plugin.getAnimatables(eventData.animatables);
                    }
                    break;
                }
                case MaterialPluginEvent.HasTexture: {
                    const eventData = info;
                    let hasTexture = false;
                    for (const plugin of this._activePlugins) {
                        hasTexture = plugin.hasTexture(eventData.texture);
                        if (hasTexture) {
                            break;
                        }
                    }
                    eventData.hasTexture = hasTexture;
                    break;
                }
                case MaterialPluginEvent.Disposed: {
                    const eventData = info;
                    for (const plugin of this._plugins) {
                        plugin.dispose(eventData.forceDisposeTextures);
                    }
                    break;
                }
                case MaterialPluginEvent.GetDefineNames: {
                    const eventData = info;
                    eventData.defineNames = this._defineNamesFromPlugins;
                    break;
                }
                case MaterialPluginEvent.PrepareEffect: {
                    const eventData = info;
                    for (const plugin of this._activePlugins) {
                        eventData.fallbackRank = plugin.addFallbacks(eventData.defines, eventData.fallbacks, eventData.fallbackRank);
                        plugin.getAttributes(eventData.attributes, this._scene, eventData.mesh);
                    }
                    if (this._uniformList.length > 0) {
                        eventData.uniforms.push(...this._uniformList);
                    }
                    if (this._samplerList.length > 0) {
                        eventData.samplers.push(...this._samplerList);
                    }
                    if (this._uboList.length > 0) {
                        eventData.uniformBuffersNames.push(...this._uboList);
                    }
                    eventData.customCode = this._injectCustomCode(eventData, eventData.customCode);
                    break;
                }
                case MaterialPluginEvent.PrepareUniformBuffer: {
                    const eventData = info;
                    this._uboDeclaration = "";
                    this._vertexDeclaration = "";
                    this._fragmentDeclaration = "";
                    this._uniformList = [];
                    this._samplerList = [];
                    this._uboList = [];
                    for (const plugin of this._plugins) {
                        const uniforms = plugin.getUniforms();
                        if (uniforms) {
                            if (uniforms.ubo) {
                                for (const uniform of uniforms.ubo) {
                                    if (uniform.size && uniform.type) {
                                        const arraySize = (_a = uniform.arraySize) !== null && _a !== void 0 ? _a : 0;
                                        eventData.ubo.addUniform(uniform.name, uniform.size, arraySize);
                                        this._uboDeclaration += `${uniform.type} ${uniform.name}${arraySize > 0 ? `[${arraySize}]` : ""};\n`;
                                    }
                                    this._uniformList.push(uniform.name);
                                }
                            }
                            if (uniforms.vertex) {
                                this._vertexDeclaration += uniforms.vertex + "\n";
                            }
                            if (uniforms.fragment) {
                                this._fragmentDeclaration += uniforms.fragment + "\n";
                            }
                        }
                        plugin.getSamplers(this._samplerList);
                        plugin.getUniformBuffersNames(this._uboList);
                    }
                    break;
                }
            }
        }
        _collectPointNames(shaderType, customCode) {
            if (!customCode) {
                return;
            }
            for (const pointName in customCode) {
                if (!this._codeInjectionPoints[shaderType]) {
                    this._codeInjectionPoints[shaderType] = {};
                }
                this._codeInjectionPoints[shaderType][pointName] = true;
            }
        }
        _injectCustomCode(eventData, existingCallback) {
            return (shaderType, code) => {
                var _a, _b;
                if (existingCallback) {
                    code = existingCallback(shaderType, code);
                }
                if (this._uboDeclaration) {
                    code = code.replace("#define ADDITIONAL_UBO_DECLARATION", this._uboDeclaration);
                }
                if (this._vertexDeclaration) {
                    code = code.replace("#define ADDITIONAL_VERTEX_DECLARATION", this._vertexDeclaration);
                }
                if (this._fragmentDeclaration) {
                    code = code.replace("#define ADDITIONAL_FRAGMENT_DECLARATION", this._fragmentDeclaration);
                }
                const points = (_a = this._codeInjectionPoints) === null || _a === void 0 ? void 0 : _a[shaderType];
                if (!points) {
                    return code;
                }
                let processorOptions = null;
                for (let pointName in points) {
                    let injectedCode = "";
                    for (const plugin of this._activePlugins) {
                        let customCode = (_b = plugin.getCustomCode(shaderType)) === null || _b === void 0 ? void 0 : _b[pointName];
                        if (!customCode) {
                            continue;
                        }
                        if (plugin.resolveIncludes) {
                            if (processorOptions === null) {
                                const shaderLanguage = ShaderLanguage.GLSL;
                                processorOptions = {
                                    defines: [],
                                    indexParameters: eventData.indexParameters,
                                    isFragment: false,
                                    shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
                                    processor: undefined,
                                    supportsUniformBuffers: this._engine.supportsUniformBuffers,
                                    shadersRepository: ShaderStore.GetShadersRepository(shaderLanguage),
                                    includesShadersStore: ShaderStore.GetIncludesShadersStore(shaderLanguage),
                                    version: undefined,
                                    platformName: this._engine.shaderPlatformName,
                                    processingContext: undefined,
                                    isNDCHalfZRange: this._engine.isNDCHalfZRange,
                                    useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
                                    processCodeAfterIncludes: undefined, // not used by _ProcessIncludes
                                };
                            }
                            processorOptions.isFragment = shaderType === "fragment";
                            ShaderProcessor._ProcessIncludes(customCode, processorOptions, (code) => (customCode = code));
                        }
                        injectedCode += customCode + "\n";
                    }
                    if (injectedCode.length > 0) {
                        if (pointName.charAt(0) === "!") {
                            // pointName is a regular expression
                            pointName = pointName.substring(1);
                            let regexFlags = "g";
                            if (pointName.charAt(0) === "!") {
                                // no flags
                                regexFlags = "";
                                pointName = pointName.substring(1);
                            }
                            else {
                                // get the flag(s)
                                const matchOption = rxOption.exec(pointName);
                                if (matchOption && matchOption.length >= 2) {
                                    regexFlags = matchOption[1];
                                    pointName = pointName.substring(regexFlags.length + 1);
                                }
                            }
                            if (regexFlags.indexOf("g") < 0) {
                                // we force the "g" flag so that the regexp object is stateful!
                                regexFlags += "g";
                            }
                            const sourceCode = code;
                            const rx = new RegExp(pointName, regexFlags);
                            let match = rx.exec(sourceCode);
                            while (match !== null) {
                                let newCode = injectedCode;
                                for (let i = 0; i < match.length; ++i) {
                                    newCode = newCode.replace("$" + i, match[i]);
                                }
                                code = code.replace(match[0], newCode);
                                match = rx.exec(sourceCode);
                            }
                        }
                        else {
                            const fullPointName = "#define " + pointName;
                            code = code.replace(fullPointName, "\n" + injectedCode + "\n" + fullPointName);
                        }
                    }
                }
                return code;
            };
        }
    }
    /** Map a plugin class name to a #define name (used in the vertex/fragment shaders as a marker of the plugin usage) */
    MaterialPluginManager._MaterialPluginClassToMainDefine = {};
    MaterialPluginManager._MaterialPluginCounter = 0;
    (() => {
        EngineStore.OnEnginesDisposedObservable.add(() => {
            UnregisterAllMaterialPlugins();
        });
    })();
    const plugins = [];
    let observer = null;
    /**
     * Clear the list of global material plugins
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function UnregisterAllMaterialPlugins() {
        plugins.length = 0;
        Material.OnEventObservable.remove(observer);
        observer = null;
    }

    /**
     * Base class for material plugins.
     * @since 5.0
     */
    class MaterialPluginBase {
        _enable(enable) {
            if (enable) {
                this._pluginManager._activatePlugin(this);
            }
        }
        /**
         * Creates a new material plugin
         * @param material parent material of the plugin
         * @param name name of the plugin
         * @param priority priority of the plugin
         * @param defines list of defines used by the plugin. The value of the property is the default value for this property
         * @param addToPluginList true to add the plugin to the list of plugins managed by the material plugin manager of the material (default: true)
         * @param enable true to enable the plugin (it is handy if the plugin does not handle properties to switch its current activation)
         * @param resolveIncludes Indicates that any #include directive in the plugin code must be replaced by the corresponding code (default: false)
         */
        constructor(material, name, priority, defines, addToPluginList = true, enable = false, resolveIncludes = false) {
            /**
             * Defines the priority of the plugin. Lower numbers run first.
             */
            this.priority = 500;
            /**
             * Indicates that any #include directive in the plugin code must be replaced by the corresponding code.
             */
            this.resolveIncludes = false;
            /**
             * Indicates that this plugin should be notified for the extra events (HasRenderTargetTextures / FillRenderTargetTextures / HardBindForSubMesh)
             */
            this.registerForExtraEvents = false;
            this._material = material;
            this.name = name;
            this.priority = priority;
            this.resolveIncludes = resolveIncludes;
            if (!material.pluginManager) {
                material.pluginManager = new MaterialPluginManager(material);
                material.onDisposeObservable.add(() => {
                    material.pluginManager = undefined;
                });
            }
            this._pluginDefineNames = defines;
            this._pluginManager = material.pluginManager;
            if (addToPluginList) {
                this._pluginManager._addPlugin(this);
            }
            if (enable) {
                this._enable(true);
            }
            this.markAllDefinesAsDirty = material._dirtyCallbacks[63];
        }
        /**
         * Gets the current class name useful for serialization or dynamic coding.
         * @returns The class name.
         */
        getClassName() {
            return "MaterialPluginBase";
        }
        /**
         * Specifies that the submesh is ready to be used.
         * @param defines the list of "defines" to update.
         * @param scene defines the scene the material belongs to.
         * @param engine the engine this scene belongs to.
         * @param subMesh the submesh to check for readiness
         * @returns - boolean indicating that the submesh is ready or not.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isReadyForSubMesh(defines, scene, engine, subMesh) {
            return true;
        }
        /**
         * Binds the material data (this function is called even if mustRebind() returns false)
         * @param uniformBuffer defines the Uniform buffer to fill in.
         * @param scene defines the scene the material belongs to.
         * @param engine defines the engine the material belongs to.
         * @param subMesh the submesh to bind data for
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        hardBindForSubMesh(uniformBuffer, scene, engine, subMesh) { }
        /**
         * Binds the material data.
         * @param uniformBuffer defines the Uniform buffer to fill in.
         * @param scene defines the scene the material belongs to.
         * @param engine the engine this scene belongs to.
         * @param subMesh the submesh to bind data for
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bindForSubMesh(uniformBuffer, scene, engine, subMesh) { }
        /**
         * Disposes the resources of the material.
         * @param forceDisposeTextures - Forces the disposal of all textures.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        dispose(forceDisposeTextures) { }
        /**
         * Returns a list of custom shader code fragments to customize the shader.
         * @param shaderType "vertex" or "fragment"
         * @returns null if no code to be added, or a list of pointName =\> code.
         * Note that `pointName` can also be a regular expression if it starts with a `!`.
         * In that case, the string found by the regular expression (if any) will be
         * replaced by the code provided.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getCustomCode(shaderType) {
            return null;
        }
        /**
         * Collects all defines.
         * @param defines The object to append to.
         */
        collectDefines(defines) {
            if (!this._pluginDefineNames) {
                return;
            }
            for (const key of Object.keys(this._pluginDefineNames)) {
                if (key[0] === "_") {
                    continue;
                }
                const type = typeof this._pluginDefineNames[key];
                defines[key] = {
                    type: type === "number" ? "number" : type === "string" ? "string" : type === "boolean" ? "boolean" : "object",
                    default: this._pluginDefineNames[key],
                };
            }
        }
        /**
         * Sets the defines for the next rendering. Called before MaterialHelper.PrepareDefinesForAttributes is called.
         * @param defines the list of "defines" to update.
         * @param scene defines the scene to the material belongs to.
         * @param mesh the mesh being rendered
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        prepareDefinesBeforeAttributes(defines, scene, mesh) { }
        /**
         * Sets the defines for the next rendering
         * @param defines the list of "defines" to update.
         * @param scene defines the scene to the material belongs to.
         * @param mesh the mesh being rendered
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        prepareDefines(defines, scene, mesh) { }
        /**
         * Checks to see if a texture is used in the material.
         * @param texture - Base texture to use.
         * @returns - Boolean specifying if a texture is used in the material.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        hasTexture(texture) {
            return false;
        }
        /**
         * Gets a boolean indicating that current material needs to register RTT
         * @returns true if this uses a render target otherwise false.
         */
        hasRenderTargetTextures() {
            return false;
        }
        /**
         * Fills the list of render target textures.
         * @param renderTargets the list of render targets to update
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fillRenderTargetTextures(renderTargets) { }
        /**
         * Returns an array of the actively used textures.
         * @param activeTextures Array of BaseTextures
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getActiveTextures(activeTextures) { }
        /**
         * Returns the animatable textures.
         * @param animatables Array of animatable textures.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getAnimatables(animatables) { }
        /**
         * Add fallbacks to the effect fallbacks list.
         * @param defines defines the Base texture to use.
         * @param fallbacks defines the current fallback list.
         * @param currentRank defines the current fallback rank.
         * @returns the new fallback rank.
         */
        addFallbacks(defines, fallbacks, currentRank) {
            return currentRank;
        }
        /**
         * Gets the samplers used by the plugin.
         * @param samplers list that the sampler names should be added to.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getSamplers(samplers) { }
        /**
         * Gets the attributes used by the plugin.
         * @param attributes list that the attribute names should be added to.
         * @param scene the scene that the material belongs to.
         * @param mesh the mesh being rendered.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getAttributes(attributes, scene, mesh) { }
        /**
         * Gets the uniform buffers names added by the plugin.
         * @param ubos list that the ubo names should be added to.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getUniformBuffersNames(ubos) { }
        /**
         * Gets the description of the uniforms to add to the ubo (if engine supports ubos) or to inject directly in the vertex/fragment shaders (if engine does not support ubos)
         * @returns the description of the uniforms
         */
        getUniforms() {
            return {};
        }
        /**
         * Makes a duplicate of the current configuration into another one.
         * @param plugin define the config where to copy the info
         */
        copyTo(plugin) {
            SerializationHelper.Clone(() => plugin, this);
        }
        /**
         * Serializes this plugin configuration.
         * @returns - An object with the serialized config.
         */
        serialize() {
            return SerializationHelper.Serialize(this);
        }
        /**
         * Parses a plugin configuration from a serialized object.
         * @param source - Serialized object.
         * @param scene Defines the scene we are parsing for
         * @param rootUrl Defines the rootUrl to load from
         */
        parse(source, scene, rootUrl) {
            SerializationHelper.Parse(() => this, source, scene, rootUrl);
        }
    }
    __decorate$1([
        serialize()
    ], MaterialPluginBase.prototype, "name", void 0);
    __decorate$1([
        serialize()
    ], MaterialPluginBase.prototype, "priority", void 0);
    __decorate$1([
        serialize()
    ], MaterialPluginBase.prototype, "resolveIncludes", void 0);
    __decorate$1([
        serialize()
    ], MaterialPluginBase.prototype, "registerForExtraEvents", void 0);

    /**
     * @internal
     */
    class MaterialDetailMapDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.DETAIL = false;
            this.DETAILDIRECTUV = 0;
            this.DETAIL_NORMALBLENDMETHOD = 0;
        }
    }
    /**
     * Plugin that implements the detail map component of a material
     *
     * Inspired from:
     *   Unity: https://docs.unity3d.com/Packages/com.unity.render-pipelines.high-definition@9.0/manual/Mask-Map-and-Detail-Map.html and https://docs.unity3d.com/Manual/StandardShaderMaterialParameterDetail.html
     *   Unreal: https://docs.unrealengine.com/en-US/Engine/Rendering/Materials/HowTo/DetailTexturing/index.html
     *   Cryengine: https://docs.cryengine.com/display/SDKDOC2/Detail+Maps
     */
    class DetailMapConfiguration extends MaterialPluginBase {
        /** @internal */
        _markAllSubMeshesAsTexturesDirty() {
            this._enable(this._isEnabled);
            this._internalMarkAllSubMeshesAsTexturesDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "DetailMap", 140, new MaterialDetailMapDefines(), addToPluginList);
            this._texture = null;
            /**
             * Defines how strongly the detail diffuse/albedo channel is blended with the regular diffuse/albedo texture
             * Bigger values mean stronger blending
             */
            this.diffuseBlendLevel = 1;
            /**
             * Defines how strongly the detail roughness channel is blended with the regular roughness value
             * Bigger values mean stronger blending. Only used with PBR materials
             */
            this.roughnessBlendLevel = 1;
            /**
             * Defines how strong the bump effect from the detail map is
             * Bigger values mean stronger effect
             */
            this.bumpLevel = 1;
            this._normalBlendMethod = Material.MATERIAL_NORMALBLENDMETHOD_WHITEOUT;
            this._isEnabled = false;
            /**
             * Enable or disable the detail map on this material
             */
            this.isEnabled = false;
            this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        }
        isReadyForSubMesh(defines, scene, engine) {
            if (!this._isEnabled) {
                return true;
            }
            if (defines._areTexturesDirty && scene.texturesEnabled) {
                if (engine.getCaps().standardDerivatives && this._texture && MaterialFlags.DetailTextureEnabled) {
                    // Detail texture cannot be not blocking.
                    if (!this._texture.isReady()) {
                        return false;
                    }
                }
            }
            return true;
        }
        prepareDefines(defines, scene) {
            if (this._isEnabled) {
                defines.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
                const engine = scene.getEngine();
                if (defines._areTexturesDirty) {
                    if (engine.getCaps().standardDerivatives && this._texture && MaterialFlags.DetailTextureEnabled && this._isEnabled) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._texture, defines, "DETAIL");
                        defines.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
                    }
                    else {
                        defines.DETAIL = false;
                    }
                }
            }
            else {
                defines.DETAIL = false;
            }
        }
        bindForSubMesh(uniformBuffer, scene) {
            if (!this._isEnabled) {
                return;
            }
            const isFrozen = this._material.isFrozen;
            if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
                if (this._texture && MaterialFlags.DetailTextureEnabled) {
                    uniformBuffer.updateFloat4("vDetailInfos", this._texture.coordinatesIndex, this.diffuseBlendLevel, this.bumpLevel, this.roughnessBlendLevel);
                    MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "detail");
                }
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._texture && MaterialFlags.DetailTextureEnabled) {
                    uniformBuffer.setTexture("detailSampler", this._texture);
                }
            }
        }
        hasTexture(texture) {
            if (this._texture === texture) {
                return true;
            }
            return false;
        }
        getActiveTextures(activeTextures) {
            if (this._texture) {
                activeTextures.push(this._texture);
            }
        }
        getAnimatables(animatables) {
            if (this._texture && this._texture.animations && this._texture.animations.length > 0) {
                animatables.push(this._texture);
            }
        }
        dispose(forceDisposeTextures) {
            var _a;
            if (forceDisposeTextures) {
                (_a = this._texture) === null || _a === void 0 ? void 0 : _a.dispose();
            }
        }
        getClassName() {
            return "DetailMapConfiguration";
        }
        getSamplers(samplers) {
            samplers.push("detailSampler");
        }
        getUniforms() {
            return {
                ubo: [
                    { name: "vDetailInfos", size: 4, type: "vec4" },
                    { name: "detailMatrix", size: 16, type: "mat4" },
                ],
            };
        }
    }
    __decorate$1([
        serializeAsTexture("detailTexture"),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], DetailMapConfiguration.prototype, "texture", void 0);
    __decorate$1([
        serialize()
    ], DetailMapConfiguration.prototype, "diffuseBlendLevel", void 0);
    __decorate$1([
        serialize()
    ], DetailMapConfiguration.prototype, "roughnessBlendLevel", void 0);
    __decorate$1([
        serialize()
    ], DetailMapConfiguration.prototype, "bumpLevel", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], DetailMapConfiguration.prototype, "normalBlendMethod", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], DetailMapConfiguration.prototype, "isEnabled", void 0);

    const onCreatedEffectParameters = { effect: null, subMesh: null };
    /** @internal */
    class StandardMaterialDefines extends MaterialDefines {
        /**
         * Initializes the Standard Material defines.
         * @param externalProperties The external properties
         */
        constructor(externalProperties) {
            super(externalProperties);
            this.MAINUV1 = false;
            this.MAINUV2 = false;
            this.MAINUV3 = false;
            this.MAINUV4 = false;
            this.MAINUV5 = false;
            this.MAINUV6 = false;
            this.DIFFUSE = false;
            this.DIFFUSEDIRECTUV = 0;
            this.BAKED_VERTEX_ANIMATION_TEXTURE = false;
            this.AMBIENT = false;
            this.AMBIENTDIRECTUV = 0;
            this.OPACITY = false;
            this.OPACITYDIRECTUV = 0;
            this.OPACITYRGB = false;
            this.REFLECTION = false;
            this.EMISSIVE = false;
            this.EMISSIVEDIRECTUV = 0;
            this.SPECULAR = false;
            this.SPECULARDIRECTUV = 0;
            this.BUMP = false;
            this.BUMPDIRECTUV = 0;
            this.PARALLAX = false;
            this.PARALLAXOCCLUSION = false;
            this.SPECULAROVERALPHA = false;
            this.CLIPPLANE = false;
            this.CLIPPLANE2 = false;
            this.CLIPPLANE3 = false;
            this.CLIPPLANE4 = false;
            this.CLIPPLANE5 = false;
            this.CLIPPLANE6 = false;
            this.ALPHATEST = false;
            this.DEPTHPREPASS = false;
            this.ALPHAFROMDIFFUSE = false;
            this.POINTSIZE = false;
            this.FOG = false;
            this.SPECULARTERM = false;
            this.DIFFUSEFRESNEL = false;
            this.OPACITYFRESNEL = false;
            this.REFLECTIONFRESNEL = false;
            this.REFRACTIONFRESNEL = false;
            this.EMISSIVEFRESNEL = false;
            this.FRESNEL = false;
            this.NORMAL = false;
            this.TANGENT = false;
            this.UV1 = false;
            this.UV2 = false;
            this.UV3 = false;
            this.UV4 = false;
            this.UV5 = false;
            this.UV6 = false;
            this.VERTEXCOLOR = false;
            this.VERTEXALPHA = false;
            this.NUM_BONE_INFLUENCERS = 0;
            this.BonesPerMesh = 0;
            this.BONETEXTURE = false;
            this.BONES_VELOCITY_ENABLED = false;
            this.INSTANCES = false;
            this.THIN_INSTANCES = false;
            this.INSTANCESCOLOR = false;
            this.GLOSSINESS = false;
            this.ROUGHNESS = false;
            this.EMISSIVEASILLUMINATION = false;
            this.LINKEMISSIVEWITHDIFFUSE = false;
            this.REFLECTIONFRESNELFROMSPECULAR = false;
            this.LIGHTMAP = false;
            this.LIGHTMAPDIRECTUV = 0;
            this.OBJECTSPACE_NORMALMAP = false;
            this.USELIGHTMAPASSHADOWMAP = false;
            this.REFLECTIONMAP_3D = false;
            this.REFLECTIONMAP_SPHERICAL = false;
            this.REFLECTIONMAP_PLANAR = false;
            this.REFLECTIONMAP_CUBIC = false;
            this.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
            this.USE_LOCAL_REFRACTIONMAP_CUBIC = false;
            this.REFLECTIONMAP_PROJECTION = false;
            this.REFLECTIONMAP_SKYBOX = false;
            this.REFLECTIONMAP_EXPLICIT = false;
            this.REFLECTIONMAP_EQUIRECTANGULAR = false;
            this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
            this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
            this.REFLECTIONMAP_OPPOSITEZ = false;
            this.INVERTCUBICMAP = false;
            this.LOGARITHMICDEPTH = false;
            this.REFRACTION = false;
            this.REFRACTIONMAP_3D = false;
            this.REFLECTIONOVERALPHA = false;
            this.TWOSIDEDLIGHTING = false;
            this.SHADOWFLOAT = false;
            this.MORPHTARGETS = false;
            this.MORPHTARGETS_NORMAL = false;
            this.MORPHTARGETS_TANGENT = false;
            this.MORPHTARGETS_UV = false;
            this.NUM_MORPH_INFLUENCERS = 0;
            this.MORPHTARGETS_TEXTURE = false;
            this.NONUNIFORMSCALING = false; // https://playground.babylonjs.com#V6DWIH
            this.PREMULTIPLYALPHA = false; // https://playground.babylonjs.com#LNVJJ7
            this.ALPHATEST_AFTERALLALPHACOMPUTATIONS = false;
            this.ALPHABLEND = true;
            this.PREPASS = false;
            this.PREPASS_IRRADIANCE = false;
            this.PREPASS_IRRADIANCE_INDEX = -1;
            this.PREPASS_ALBEDO_SQRT = false;
            this.PREPASS_ALBEDO_SQRT_INDEX = -1;
            this.PREPASS_DEPTH = false;
            this.PREPASS_DEPTH_INDEX = -1;
            this.PREPASS_NORMAL = false;
            this.PREPASS_NORMAL_INDEX = -1;
            this.PREPASS_POSITION = false;
            this.PREPASS_POSITION_INDEX = -1;
            this.PREPASS_VELOCITY = false;
            this.PREPASS_VELOCITY_INDEX = -1;
            this.PREPASS_REFLECTIVITY = false;
            this.PREPASS_REFLECTIVITY_INDEX = -1;
            this.SCENE_MRT_COUNT = 0;
            this.RGBDLIGHTMAP = false;
            this.RGBDREFLECTION = false;
            this.RGBDREFRACTION = false;
            this.IMAGEPROCESSING = false;
            this.VIGNETTE = false;
            this.VIGNETTEBLENDMODEMULTIPLY = false;
            this.VIGNETTEBLENDMODEOPAQUE = false;
            this.TONEMAPPING = false;
            this.TONEMAPPING_ACES = false;
            this.CONTRAST = false;
            this.COLORCURVES = false;
            this.COLORGRADING = false;
            this.COLORGRADING3D = false;
            this.SAMPLER3DGREENDEPTH = false;
            this.SAMPLER3DBGRMAP = false;
            this.DITHER = false;
            this.IMAGEPROCESSINGPOSTPROCESS = false;
            this.SKIPFINALCOLORCLAMP = false;
            this.MULTIVIEW = false;
            this.ORDER_INDEPENDENT_TRANSPARENCY = false;
            this.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = false;
            this.CAMERA_ORTHOGRAPHIC = false;
            this.CAMERA_PERSPECTIVE = false;
            /**
             * If the reflection texture on this material is in linear color space
             * @internal
             */
            this.IS_REFLECTION_LINEAR = false;
            /**
             * If the refraction texture on this material is in linear color space
             * @internal
             */
            this.IS_REFRACTION_LINEAR = false;
            this.EXPOSURE = false;
            this.DECAL_AFTER_DETAIL = false;
            this.rebuild();
        }
        setReflectionMode(modeToEnable) {
            const modes = [
                "REFLECTIONMAP_CUBIC",
                "REFLECTIONMAP_EXPLICIT",
                "REFLECTIONMAP_PLANAR",
                "REFLECTIONMAP_PROJECTION",
                "REFLECTIONMAP_PROJECTION",
                "REFLECTIONMAP_SKYBOX",
                "REFLECTIONMAP_SPHERICAL",
                "REFLECTIONMAP_EQUIRECTANGULAR",
                "REFLECTIONMAP_EQUIRECTANGULAR_FIXED",
                "REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED",
            ];
            for (const mode of modes) {
                this[mode] = mode === modeToEnable;
            }
        }
    }
    /**
     * This is the default material used in Babylon. It is the best trade off between quality
     * and performances.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
     */
    class StandardMaterial extends PushMaterial {
        /**
         * Gets the image processing configuration used either in this material.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Sets the Default image processing configuration used either in the this material.
         *
         * If sets to null, the scene one is in use.
         */
        set imageProcessingConfiguration(value) {
            this._attachImageProcessingConfiguration(value);
            // Ensure the effect will be rebuilt.
            this._markAllSubMeshesAsTexturesDirty();
        }
        /**
         * Attaches a new image processing configuration to the Standard Material.
         * @param configuration
         */
        _attachImageProcessingConfiguration(configuration) {
            if (configuration === this._imageProcessingConfiguration) {
                return;
            }
            // Detaches observer
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            // Pick the scene configuration if needed
            if (!configuration) {
                this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
            }
            else {
                this._imageProcessingConfiguration = configuration;
            }
            // Attaches observer
            if (this._imageProcessingConfiguration) {
                this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
                    this._markAllSubMeshesAsImageProcessingDirty();
                });
            }
        }
        /**
         * Can this material render to prepass
         */
        get isPrePassCapable() {
            return !this.disableDepthWrite;
        }
        /**
         * Gets whether the color curves effect is enabled.
         */
        get cameraColorCurvesEnabled() {
            return this.imageProcessingConfiguration.colorCurvesEnabled;
        }
        /**
         * Sets whether the color curves effect is enabled.
         */
        set cameraColorCurvesEnabled(value) {
            this.imageProcessingConfiguration.colorCurvesEnabled = value;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        get cameraColorGradingEnabled() {
            return this.imageProcessingConfiguration.colorGradingEnabled;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        set cameraColorGradingEnabled(value) {
            this.imageProcessingConfiguration.colorGradingEnabled = value;
        }
        /**
         * Gets whether tonemapping is enabled or not.
         */
        get cameraToneMappingEnabled() {
            return this._imageProcessingConfiguration.toneMappingEnabled;
        }
        /**
         * Sets whether tonemapping is enabled or not
         */
        set cameraToneMappingEnabled(value) {
            this._imageProcessingConfiguration.toneMappingEnabled = value;
        }
        /**
         * The camera exposure used on this material.
         * This property is here and not in the camera to allow controlling exposure without full screen post process.
         * This corresponds to a photographic exposure.
         */
        get cameraExposure() {
            return this._imageProcessingConfiguration.exposure;
        }
        /**
         * The camera exposure used on this material.
         * This property is here and not in the camera to allow controlling exposure without full screen post process.
         * This corresponds to a photographic exposure.
         */
        set cameraExposure(value) {
            this._imageProcessingConfiguration.exposure = value;
        }
        /**
         * Gets The camera contrast used on this material.
         */
        get cameraContrast() {
            return this._imageProcessingConfiguration.contrast;
        }
        /**
         * Sets The camera contrast used on this material.
         */
        set cameraContrast(value) {
            this._imageProcessingConfiguration.contrast = value;
        }
        /**
         * Gets the Color Grading 2D Lookup Texture.
         */
        get cameraColorGradingTexture() {
            return this._imageProcessingConfiguration.colorGradingTexture;
        }
        /**
         * Sets the Color Grading 2D Lookup Texture.
         */
        set cameraColorGradingTexture(value) {
            this._imageProcessingConfiguration.colorGradingTexture = value;
        }
        /**
         * The color grading curves provide additional color adjustmnent that is applied after any color grading transform (3D LUT).
         * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
         * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
         * corresponding to low luminance, medium luminance, and high luminance areas respectively.
         */
        get cameraColorCurves() {
            return this._imageProcessingConfiguration.colorCurves;
        }
        /**
         * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
         * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
         * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
         * corresponding to low luminance, medium luminance, and high luminance areas respectively.
         */
        set cameraColorCurves(value) {
            this._imageProcessingConfiguration.colorCurves = value;
        }
        /**
         * Can this material render to several textures at once
         */
        get canRenderToMRT() {
            return true;
        }
        /**
         * Instantiates a new standard material.
         * This is the default material used in Babylon. It is the best trade off between quality
         * and performances.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
         * @param name Define the name of the material in the scene
         * @param scene Define the scene the material belong to
         */
        constructor(name, scene) {
            super(name, scene);
            this._diffuseTexture = null;
            this._ambientTexture = null;
            this._opacityTexture = null;
            this._reflectionTexture = null;
            this._emissiveTexture = null;
            this._specularTexture = null;
            this._bumpTexture = null;
            this._lightmapTexture = null;
            this._refractionTexture = null;
            /**
             * The color of the material lit by the environmental background lighting.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#ambient-color-example
             */
            this.ambientColor = new Color3(0, 0, 0);
            /**
             * The basic color of the material as viewed under a light.
             */
            this.diffuseColor = new Color3(1, 1, 1);
            /**
             * Define how the color and intensity of the highlight given by the light in the material.
             */
            this.specularColor = new Color3(1, 1, 1);
            /**
             * Define the color of the material as if self lit.
             * This will be mixed in the final result even in the absence of light.
             */
            this.emissiveColor = new Color3(0, 0, 0);
            /**
             * Defines how sharp are the highlights in the material.
             * The bigger the value the sharper giving a more glossy feeling to the result.
             * Reversely, the smaller the value the blurrier giving a more rough feeling to the result.
             */
            this.specularPower = 64;
            this._useAlphaFromDiffuseTexture = false;
            this._useEmissiveAsIllumination = false;
            this._linkEmissiveWithDiffuse = false;
            this._useSpecularOverAlpha = false;
            this._useReflectionOverAlpha = false;
            this._disableLighting = false;
            this._useObjectSpaceNormalMap = false;
            this._useParallax = false;
            this._useParallaxOcclusion = false;
            /**
             * Apply a scaling factor that determine which "depth" the height map should reprensent. A value between 0.05 and 0.1 is reasonnable in Parallax, you can reach 0.2 using Parallax Occlusion.
             */
            this.parallaxScaleBias = 0.05;
            this._roughness = 0;
            /**
             * In case of refraction, define the value of the index of refraction.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#how-to-obtain-reflections-and-refractions
             */
            this.indexOfRefraction = 0.98;
            /**
             * Invert the refraction texture alongside the y axis.
             * It can be useful with procedural textures or probe for instance.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#how-to-obtain-reflections-and-refractions
             */
            this.invertRefractionY = true;
            /**
             * Defines the alpha limits in alpha test mode.
             */
            this.alphaCutOff = 0.4;
            this._useLightmapAsShadowmap = false;
            this._useReflectionFresnelFromSpecular = false;
            this._useGlossinessFromSpecularMapAlpha = false;
            this._maxSimultaneousLights = 4;
            this._invertNormalMapX = false;
            this._invertNormalMapY = false;
            this._twoSidedLighting = false;
            this._applyDecalMapAfterDetailMap = false;
            this._renderTargets = new SmartArray(16);
            this._worldViewProjectionMatrix = Matrix.Zero();
            this._globalAmbientColor = new Color3(0, 0, 0);
            this._cacheHasRenderTargetTextures = false;
            this.detailMap = new DetailMapConfiguration(this);
            // Setup the default processing configuration to the scene.
            this._attachImageProcessingConfiguration(null);
            this.prePassConfiguration = new PrePassConfiguration();
            this.getRenderTargetTextures = () => {
                this._renderTargets.reset();
                if (StandardMaterial.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                    this._renderTargets.push(this._reflectionTexture);
                }
                if (StandardMaterial.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) {
                    this._renderTargets.push(this._refractionTexture);
                }
                this._eventInfo.renderTargets = this._renderTargets;
                this._callbackPluginEventFillRenderTargetTextures(this._eventInfo);
                return this._renderTargets;
            };
        }
        /**
         * Gets a boolean indicating that current material needs to register RTT
         */
        get hasRenderTargetTextures() {
            if (StandardMaterial.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                return true;
            }
            if (StandardMaterial.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) {
                return true;
            }
            return this._cacheHasRenderTargetTextures;
        }
        /**
         * Gets the current class name of the material e.g. "StandardMaterial"
         * Mainly use in serialization.
         * @returns the class name
         */
        getClassName() {
            return "StandardMaterial";
        }
        /**
         * In case the depth buffer does not allow enough depth precision for your scene (might be the case in large scenes)
         * You can try switching to logarithmic depth.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/logarithmicDepthBuffer
         */
        get useLogarithmicDepth() {
            return this._useLogarithmicDepth;
        }
        set useLogarithmicDepth(value) {
            this._useLogarithmicDepth = value && this.getScene().getEngine().getCaps().fragmentDepthSupported;
            this._markAllSubMeshesAsMiscDirty();
        }
        /**
         * Specifies if the material will require alpha blending
         * @returns a boolean specifying if alpha blending is needed
         */
        needAlphaBlending() {
            if (this._disableAlphaBlending) {
                return false;
            }
            return (this.alpha < 1.0 ||
                this._opacityTexture != null ||
                this._shouldUseAlphaFromDiffuseTexture() ||
                (this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled));
        }
        /**
         * Specifies if this material should be rendered in alpha test mode
         * @returns a boolean specifying if an alpha test is needed.
         */
        needAlphaTesting() {
            if (this._forceAlphaTest) {
                return true;
            }
            return this._hasAlphaChannel() && (this._transparencyMode == null || this._transparencyMode === Material.MATERIAL_ALPHATEST);
        }
        /**
         * Specifies whether or not the alpha value of the diffuse texture should be used for alpha blending.
         */
        _shouldUseAlphaFromDiffuseTexture() {
            return this._diffuseTexture != null && this._diffuseTexture.hasAlpha && this._useAlphaFromDiffuseTexture && this._transparencyMode !== Material.MATERIAL_OPAQUE;
        }
        /**
         * Specifies whether or not there is a usable alpha channel for transparency.
         */
        _hasAlphaChannel() {
            return (this._diffuseTexture != null && this._diffuseTexture.hasAlpha) || this._opacityTexture != null;
        }
        /**
         * Get the texture used for alpha test purpose.
         * @returns the diffuse texture in case of the standard material.
         */
        getAlphaTestTexture() {
            return this._diffuseTexture;
        }
        /**
         * Get if the submesh is ready to be used and all its information available.
         * Child classes can use it to update shaders
         * @param mesh defines the mesh to check
         * @param subMesh defines which submesh to check
         * @param useInstances specifies that instances should be used
         * @returns a boolean indicating that the submesh is ready or not
         */
        isReadyForSubMesh(mesh, subMesh, useInstances = false) {
            if (!this._uniformBufferLayoutBuilt) {
                this.buildUniformLayout();
            }
            if (subMesh.effect && this.isFrozen) {
                if (subMesh.effect._wasPreviouslyReady && subMesh.effect._wasPreviouslyUsingInstances === useInstances) {
                    return true;
                }
            }
            if (!subMesh.materialDefines) {
                this._callbackPluginEventGeneric(MaterialPluginEvent.GetDefineNames, this._eventInfo);
                subMesh.materialDefines = new StandardMaterialDefines(this._eventInfo.defineNames);
            }
            const scene = this.getScene();
            const defines = subMesh.materialDefines;
            if (this._isReadyForSubMesh(subMesh)) {
                return true;
            }
            const engine = scene.getEngine();
            // Lights
            defines._needNormals = MaterialHelper.PrepareDefinesForLights(scene, mesh, defines, true, this._maxSimultaneousLights, this._disableLighting);
            // Multiview
            MaterialHelper.PrepareDefinesForMultiview(scene, defines);
            // PrePass
            const oit = this.needAlphaBlendingForMesh(mesh) && this.getScene().useOrderIndependentTransparency;
            MaterialHelper.PrepareDefinesForPrePass(scene, defines, this.canRenderToMRT && !oit);
            // Order independant transparency
            MaterialHelper.PrepareDefinesForOIT(scene, defines, oit);
            // Textures
            if (defines._areTexturesDirty) {
                this._eventInfo.hasRenderTargetTextures = false;
                this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
                this._cacheHasRenderTargetTextures = this._eventInfo.hasRenderTargetTextures;
                defines._needUVs = false;
                for (let i = 1; i <= 6; ++i) {
                    defines["MAINUV" + i] = false;
                }
                if (scene.texturesEnabled) {
                    defines.DIFFUSEDIRECTUV = 0;
                    defines.BUMPDIRECTUV = 0;
                    defines.AMBIENTDIRECTUV = 0;
                    defines.OPACITYDIRECTUV = 0;
                    defines.EMISSIVEDIRECTUV = 0;
                    defines.SPECULARDIRECTUV = 0;
                    defines.LIGHTMAPDIRECTUV = 0;
                    if (this._diffuseTexture && StandardMaterial.DiffuseTextureEnabled) {
                        if (!this._diffuseTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._diffuseTexture, defines, "DIFFUSE");
                        }
                    }
                    else {
                        defines.DIFFUSE = false;
                    }
                    if (this._ambientTexture && StandardMaterial.AmbientTextureEnabled) {
                        if (!this._ambientTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._ambientTexture, defines, "AMBIENT");
                        }
                    }
                    else {
                        defines.AMBIENT = false;
                    }
                    if (this._opacityTexture && StandardMaterial.OpacityTextureEnabled) {
                        if (!this._opacityTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._opacityTexture, defines, "OPACITY");
                            defines.OPACITYRGB = this._opacityTexture.getAlphaFromRGB;
                        }
                    }
                    else {
                        defines.OPACITY = false;
                    }
                    if (this._reflectionTexture && StandardMaterial.ReflectionTextureEnabled) {
                        if (!this._reflectionTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            defines._needNormals = true;
                            defines.REFLECTION = true;
                            defines.ROUGHNESS = this._roughness > 0;
                            defines.REFLECTIONOVERALPHA = this._useReflectionOverAlpha;
                            defines.INVERTCUBICMAP = this._reflectionTexture.coordinatesMode === Texture.INVCUBIC_MODE;
                            defines.REFLECTIONMAP_3D = this._reflectionTexture.isCube;
                            defines.REFLECTIONMAP_OPPOSITEZ =
                                defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !this._reflectionTexture.invertZ : this._reflectionTexture.invertZ;
                            defines.RGBDREFLECTION = this._reflectionTexture.isRGBD;
                            switch (this._reflectionTexture.coordinatesMode) {
                                case Texture.EXPLICIT_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_EXPLICIT");
                                    break;
                                case Texture.PLANAR_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_PLANAR");
                                    break;
                                case Texture.PROJECTION_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_PROJECTION");
                                    break;
                                case Texture.SKYBOX_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_SKYBOX");
                                    break;
                                case Texture.SPHERICAL_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_SPHERICAL");
                                    break;
                                case Texture.EQUIRECTANGULAR_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR");
                                    break;
                                case Texture.FIXED_EQUIRECTANGULAR_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR_FIXED");
                                    break;
                                case Texture.FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                                    defines.setReflectionMode("REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED");
                                    break;
                                case Texture.CUBIC_MODE:
                                case Texture.INVCUBIC_MODE:
                                default:
                                    defines.setReflectionMode("REFLECTIONMAP_CUBIC");
                                    break;
                            }
                            defines.USE_LOCAL_REFLECTIONMAP_CUBIC = this._reflectionTexture.boundingBoxSize ? true : false;
                        }
                    }
                    else {
                        defines.REFLECTION = false;
                        defines.REFLECTIONMAP_OPPOSITEZ = false;
                    }
                    if (this._emissiveTexture && StandardMaterial.EmissiveTextureEnabled) {
                        if (!this._emissiveTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._emissiveTexture, defines, "EMISSIVE");
                        }
                    }
                    else {
                        defines.EMISSIVE = false;
                    }
                    if (this._lightmapTexture && StandardMaterial.LightmapTextureEnabled) {
                        if (!this._lightmapTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._lightmapTexture, defines, "LIGHTMAP");
                            defines.USELIGHTMAPASSHADOWMAP = this._useLightmapAsShadowmap;
                            defines.RGBDLIGHTMAP = this._lightmapTexture.isRGBD;
                        }
                    }
                    else {
                        defines.LIGHTMAP = false;
                    }
                    if (this._specularTexture && StandardMaterial.SpecularTextureEnabled) {
                        if (!this._specularTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._specularTexture, defines, "SPECULAR");
                            defines.GLOSSINESS = this._useGlossinessFromSpecularMapAlpha;
                        }
                    }
                    else {
                        defines.SPECULAR = false;
                    }
                    if (scene.getEngine().getCaps().standardDerivatives && this._bumpTexture && StandardMaterial.BumpTextureEnabled) {
                        // Bump texture can not be not blocking.
                        if (!this._bumpTexture.isReady()) {
                            return false;
                        }
                        else {
                            MaterialHelper.PrepareDefinesForMergedUV(this._bumpTexture, defines, "BUMP");
                            defines.PARALLAX = this._useParallax;
                            defines.PARALLAXOCCLUSION = this._useParallaxOcclusion;
                        }
                        defines.OBJECTSPACE_NORMALMAP = this._useObjectSpaceNormalMap;
                    }
                    else {
                        defines.BUMP = false;
                        defines.PARALLAX = false;
                        defines.PARALLAXOCCLUSION = false;
                    }
                    if (this._refractionTexture && StandardMaterial.RefractionTextureEnabled) {
                        if (!this._refractionTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        else {
                            defines._needUVs = true;
                            defines.REFRACTION = true;
                            defines.REFRACTIONMAP_3D = this._refractionTexture.isCube;
                            defines.RGBDREFRACTION = this._refractionTexture.isRGBD;
                            defines.USE_LOCAL_REFRACTIONMAP_CUBIC = this._refractionTexture.boundingBoxSize ? true : false;
                        }
                    }
                    else {
                        defines.REFRACTION = false;
                    }
                    defines.TWOSIDEDLIGHTING = !this._backFaceCulling && this._twoSidedLighting;
                }
                else {
                    defines.DIFFUSE = false;
                    defines.AMBIENT = false;
                    defines.OPACITY = false;
                    defines.REFLECTION = false;
                    defines.EMISSIVE = false;
                    defines.LIGHTMAP = false;
                    defines.BUMP = false;
                    defines.REFRACTION = false;
                }
                defines.ALPHAFROMDIFFUSE = this._shouldUseAlphaFromDiffuseTexture();
                defines.EMISSIVEASILLUMINATION = this._useEmissiveAsIllumination;
                defines.LINKEMISSIVEWITHDIFFUSE = this._linkEmissiveWithDiffuse;
                defines.SPECULAROVERALPHA = this._useSpecularOverAlpha;
                defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
                defines.ALPHATEST_AFTERALLALPHACOMPUTATIONS = this.transparencyMode !== null;
                defines.ALPHABLEND = this.transparencyMode === null || this.needAlphaBlendingForMesh(mesh); // check on null for backward compatibility
            }
            this._eventInfo.isReadyForSubMesh = true;
            this._eventInfo.defines = defines;
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
            if (!this._eventInfo.isReadyForSubMesh) {
                return false;
            }
            if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
                if (!this._imageProcessingConfiguration.isReady()) {
                    return false;
                }
                this._imageProcessingConfiguration.prepareDefines(defines);
                defines.IS_REFLECTION_LINEAR = this.reflectionTexture != null && !this.reflectionTexture.gammaSpace;
                defines.IS_REFRACTION_LINEAR = this.refractionTexture != null && !this.refractionTexture.gammaSpace;
            }
            if (defines._areFresnelDirty) {
                if (StandardMaterial.FresnelEnabled) {
                    // Fresnel
                    if (this._diffuseFresnelParameters ||
                        this._opacityFresnelParameters ||
                        this._emissiveFresnelParameters ||
                        this._refractionFresnelParameters ||
                        this._reflectionFresnelParameters) {
                        defines.DIFFUSEFRESNEL = this._diffuseFresnelParameters && this._diffuseFresnelParameters.isEnabled;
                        defines.OPACITYFRESNEL = this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled;
                        defines.REFLECTIONFRESNEL = this._reflectionFresnelParameters && this._reflectionFresnelParameters.isEnabled;
                        defines.REFLECTIONFRESNELFROMSPECULAR = this._useReflectionFresnelFromSpecular;
                        defines.REFRACTIONFRESNEL = this._refractionFresnelParameters && this._refractionFresnelParameters.isEnabled;
                        defines.EMISSIVEFRESNEL = this._emissiveFresnelParameters && this._emissiveFresnelParameters.isEnabled;
                        defines._needNormals = true;
                        defines.FRESNEL = true;
                    }
                }
                else {
                    defines.FRESNEL = false;
                }
            }
            // Misc.
            MaterialHelper.PrepareDefinesForMisc(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh) || this._forceAlphaTest, defines, this._applyDecalMapAfterDetailMap);
            // Values that need to be evaluated on every frame
            MaterialHelper.PrepareDefinesForFrameBoundValues(scene, engine, this, defines, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
            // External config
            this._eventInfo.defines = defines;
            this._eventInfo.mesh = mesh;
            this._callbackPluginEventPrepareDefinesBeforeAttributes(this._eventInfo);
            // Attribs
            MaterialHelper.PrepareDefinesForAttributes(mesh, defines, true, true, true);
            // External config
            this._callbackPluginEventPrepareDefines(this._eventInfo);
            // Get correct effect
            let forceWasNotReadyPreviously = false;
            if (defines.isDirty) {
                const lightDisposed = defines._areLightsDisposed;
                defines.markAsProcessed();
                // Fallbacks
                const fallbacks = new EffectFallbacks();
                if (defines.REFLECTION) {
                    fallbacks.addFallback(0, "REFLECTION");
                }
                if (defines.SPECULAR) {
                    fallbacks.addFallback(0, "SPECULAR");
                }
                if (defines.BUMP) {
                    fallbacks.addFallback(0, "BUMP");
                }
                if (defines.PARALLAX) {
                    fallbacks.addFallback(1, "PARALLAX");
                }
                if (defines.PARALLAXOCCLUSION) {
                    fallbacks.addFallback(0, "PARALLAXOCCLUSION");
                }
                if (defines.SPECULAROVERALPHA) {
                    fallbacks.addFallback(0, "SPECULAROVERALPHA");
                }
                if (defines.FOG) {
                    fallbacks.addFallback(1, "FOG");
                }
                if (defines.POINTSIZE) {
                    fallbacks.addFallback(0, "POINTSIZE");
                }
                if (defines.LOGARITHMICDEPTH) {
                    fallbacks.addFallback(0, "LOGARITHMICDEPTH");
                }
                MaterialHelper.HandleFallbacksForShadows(defines, fallbacks, this._maxSimultaneousLights);
                if (defines.SPECULARTERM) {
                    fallbacks.addFallback(0, "SPECULARTERM");
                }
                if (defines.DIFFUSEFRESNEL) {
                    fallbacks.addFallback(1, "DIFFUSEFRESNEL");
                }
                if (defines.OPACITYFRESNEL) {
                    fallbacks.addFallback(2, "OPACITYFRESNEL");
                }
                if (defines.REFLECTIONFRESNEL) {
                    fallbacks.addFallback(3, "REFLECTIONFRESNEL");
                }
                if (defines.EMISSIVEFRESNEL) {
                    fallbacks.addFallback(4, "EMISSIVEFRESNEL");
                }
                if (defines.FRESNEL) {
                    fallbacks.addFallback(4, "FRESNEL");
                }
                if (defines.MULTIVIEW) {
                    fallbacks.addFallback(0, "MULTIVIEW");
                }
                //Attributes
                const attribs = [VertexBuffer.PositionKind];
                if (defines.NORMAL) {
                    attribs.push(VertexBuffer.NormalKind);
                }
                if (defines.TANGENT) {
                    attribs.push(VertexBuffer.TangentKind);
                }
                for (let i = 1; i <= 6; ++i) {
                    if (defines["UV" + i]) {
                        attribs.push(`uv${i === 1 ? "" : i}`);
                    }
                }
                if (defines.VERTEXCOLOR) {
                    attribs.push(VertexBuffer.ColorKind);
                }
                MaterialHelper.PrepareAttributesForBones(attribs, mesh, defines, fallbacks);
                MaterialHelper.PrepareAttributesForInstances(attribs, defines);
                MaterialHelper.PrepareAttributesForMorphTargets(attribs, mesh, defines);
                MaterialHelper.PrepareAttributesForBakedVertexAnimation(attribs, mesh, defines);
                let shaderName = "default";
                const uniforms = [
                    "world",
                    "view",
                    "viewProjection",
                    "vEyePosition",
                    "vLightsType",
                    "vAmbientColor",
                    "vDiffuseColor",
                    "vSpecularColor",
                    "vEmissiveColor",
                    "visibility",
                    "vFogInfos",
                    "vFogColor",
                    "pointSize",
                    "vDiffuseInfos",
                    "vAmbientInfos",
                    "vOpacityInfos",
                    "vReflectionInfos",
                    "vEmissiveInfos",
                    "vSpecularInfos",
                    "vBumpInfos",
                    "vLightmapInfos",
                    "vRefractionInfos",
                    "mBones",
                    "diffuseMatrix",
                    "ambientMatrix",
                    "opacityMatrix",
                    "reflectionMatrix",
                    "emissiveMatrix",
                    "specularMatrix",
                    "bumpMatrix",
                    "normalMatrix",
                    "lightmapMatrix",
                    "refractionMatrix",
                    "diffuseLeftColor",
                    "diffuseRightColor",
                    "opacityParts",
                    "reflectionLeftColor",
                    "reflectionRightColor",
                    "emissiveLeftColor",
                    "emissiveRightColor",
                    "refractionLeftColor",
                    "refractionRightColor",
                    "vReflectionPosition",
                    "vReflectionSize",
                    "vRefractionPosition",
                    "vRefractionSize",
                    "logarithmicDepthConstant",
                    "vTangentSpaceParams",
                    "alphaCutOff",
                    "boneTextureWidth",
                    "morphTargetTextureInfo",
                    "morphTargetTextureIndices",
                ];
                const samplers = [
                    "diffuseSampler",
                    "ambientSampler",
                    "opacitySampler",
                    "reflectionCubeSampler",
                    "reflection2DSampler",
                    "emissiveSampler",
                    "specularSampler",
                    "bumpSampler",
                    "lightmapSampler",
                    "refractionCubeSampler",
                    "refraction2DSampler",
                    "boneSampler",
                    "morphTargets",
                    "oitDepthSampler",
                    "oitFrontColorSampler",
                ];
                const uniformBuffers = ["Material", "Scene", "Mesh"];
                const indexParameters = { maxSimultaneousLights: this._maxSimultaneousLights, maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS };
                this._eventInfo.fallbacks = fallbacks;
                this._eventInfo.fallbackRank = 0;
                this._eventInfo.defines = defines;
                this._eventInfo.uniforms = uniforms;
                this._eventInfo.attributes = attribs;
                this._eventInfo.samplers = samplers;
                this._eventInfo.uniformBuffersNames = uniformBuffers;
                this._eventInfo.customCode = undefined;
                this._eventInfo.mesh = mesh;
                this._eventInfo.indexParameters = indexParameters;
                this._callbackPluginEventGeneric(MaterialPluginEvent.PrepareEffect, this._eventInfo);
                PrePassConfiguration.AddUniforms(uniforms);
                PrePassConfiguration.AddSamplers(samplers);
                if (ImageProcessingConfiguration) {
                    ImageProcessingConfiguration.PrepareUniforms(uniforms, defines);
                    ImageProcessingConfiguration.PrepareSamplers(samplers, defines);
                }
                MaterialHelper.PrepareUniformsAndSamplersList({
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: defines,
                    maxSimultaneousLights: this._maxSimultaneousLights,
                });
                addClipPlaneUniforms(uniforms);
                const csnrOptions = {};
                if (this.customShaderNameResolve) {
                    shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs, csnrOptions);
                }
                const join = defines.toString();
                const previousEffect = subMesh.effect;
                let effect = scene.getEngine().createEffect(shaderName, {
                    attributes: attribs,
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: join,
                    fallbacks: fallbacks,
                    onCompiled: this.onCompiled,
                    onError: this.onError,
                    indexParameters,
                    processFinalCode: csnrOptions.processFinalCode,
                    processCodeAfterIncludes: this._eventInfo.customCode,
                    multiTarget: defines.PREPASS,
                }, engine);
                this._eventInfo.customCode = undefined;
                if (effect) {
                    if (this._onEffectCreatedObservable) {
                        onCreatedEffectParameters.effect = effect;
                        onCreatedEffectParameters.subMesh = subMesh;
                        this._onEffectCreatedObservable.notifyObservers(onCreatedEffectParameters);
                    }
                    // Use previous effect while new one is compiling
                    if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                        effect = previousEffect;
                        defines.markAsUnprocessed();
                        forceWasNotReadyPreviously = this.isFrozen;
                        if (lightDisposed) {
                            // re register in case it takes more than one frame.
                            defines._areLightsDisposed = true;
                            return false;
                        }
                    }
                    else {
                        scene.resetCachedMaterial();
                        subMesh.setEffect(effect, defines, this._materialContext);
                    }
                }
            }
            if (!subMesh.effect || !subMesh.effect.isReady()) {
                return false;
            }
            defines._renderId = scene.getRenderId();
            subMesh.effect._wasPreviouslyReady = forceWasNotReadyPreviously ? false : true;
            subMesh.effect._wasPreviouslyUsingInstances = useInstances;
            this._checkScenePerformancePriority();
            return true;
        }
        /**
         * Builds the material UBO layouts.
         * Used internally during the effect preparation.
         */
        buildUniformLayout() {
            // Order is important !
            const ubo = this._uniformBuffer;
            ubo.addUniform("diffuseLeftColor", 4);
            ubo.addUniform("diffuseRightColor", 4);
            ubo.addUniform("opacityParts", 4);
            ubo.addUniform("reflectionLeftColor", 4);
            ubo.addUniform("reflectionRightColor", 4);
            ubo.addUniform("refractionLeftColor", 4);
            ubo.addUniform("refractionRightColor", 4);
            ubo.addUniform("emissiveLeftColor", 4);
            ubo.addUniform("emissiveRightColor", 4);
            ubo.addUniform("vDiffuseInfos", 2);
            ubo.addUniform("vAmbientInfos", 2);
            ubo.addUniform("vOpacityInfos", 2);
            ubo.addUniform("vReflectionInfos", 2);
            ubo.addUniform("vReflectionPosition", 3);
            ubo.addUniform("vReflectionSize", 3);
            ubo.addUniform("vEmissiveInfos", 2);
            ubo.addUniform("vLightmapInfos", 2);
            ubo.addUniform("vSpecularInfos", 2);
            ubo.addUniform("vBumpInfos", 3);
            ubo.addUniform("diffuseMatrix", 16);
            ubo.addUniform("ambientMatrix", 16);
            ubo.addUniform("opacityMatrix", 16);
            ubo.addUniform("reflectionMatrix", 16);
            ubo.addUniform("emissiveMatrix", 16);
            ubo.addUniform("lightmapMatrix", 16);
            ubo.addUniform("specularMatrix", 16);
            ubo.addUniform("bumpMatrix", 16);
            ubo.addUniform("vTangentSpaceParams", 2);
            ubo.addUniform("pointSize", 1);
            ubo.addUniform("alphaCutOff", 1);
            ubo.addUniform("refractionMatrix", 16);
            ubo.addUniform("vRefractionInfos", 4);
            ubo.addUniform("vRefractionPosition", 3);
            ubo.addUniform("vRefractionSize", 3);
            ubo.addUniform("vSpecularColor", 4);
            ubo.addUniform("vEmissiveColor", 3);
            ubo.addUniform("vDiffuseColor", 4);
            ubo.addUniform("vAmbientColor", 3);
            super.buildUniformLayout();
        }
        /**
         * Binds the submesh to this material by preparing the effect and shader to draw
         * @param world defines the world transformation matrix
         * @param mesh defines the mesh containing the submesh
         * @param subMesh defines the submesh to bind the material to
         */
        bindForSubMesh(world, mesh, subMesh) {
            var _a;
            const scene = this.getScene();
            const defines = subMesh.materialDefines;
            if (!defines) {
                return;
            }
            const effect = subMesh.effect;
            if (!effect) {
                return;
            }
            this._activeEffect = effect;
            // Matrices Mesh.
            mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
            mesh.transferToEffect(world);
            // Binding unconditionally
            this._uniformBuffer.bindToEffect(effect, "Material");
            this.prePassConfiguration.bindForSubMesh(this._activeEffect, scene, mesh, world, this.isFrozen);
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventHardBindForSubMesh(this._eventInfo);
            // Normal Matrix
            if (defines.OBJECTSPACE_NORMALMAP) {
                world.toNormalMatrix(this._normalMatrix);
                this.bindOnlyNormalMatrix(this._normalMatrix);
            }
            const mustRebind = effect._forceRebindOnNextCall || this._mustRebind(scene, effect, mesh.visibility);
            // Bones
            MaterialHelper.BindBonesParameters(mesh, effect);
            const ubo = this._uniformBuffer;
            if (mustRebind) {
                this.bindViewProjection(effect);
                if (!ubo.useUbo || !this.isFrozen || !ubo.isSync || effect._forceRebindOnNextCall) {
                    if (StandardMaterial.FresnelEnabled && defines.FRESNEL) {
                        // Fresnel
                        if (this.diffuseFresnelParameters && this.diffuseFresnelParameters.isEnabled) {
                            ubo.updateColor4("diffuseLeftColor", this.diffuseFresnelParameters.leftColor, this.diffuseFresnelParameters.power);
                            ubo.updateColor4("diffuseRightColor", this.diffuseFresnelParameters.rightColor, this.diffuseFresnelParameters.bias);
                        }
                        if (this.opacityFresnelParameters && this.opacityFresnelParameters.isEnabled) {
                            ubo.updateColor4("opacityParts", new Color3(this.opacityFresnelParameters.leftColor.toLuminance(), this.opacityFresnelParameters.rightColor.toLuminance(), this.opacityFresnelParameters.bias), this.opacityFresnelParameters.power);
                        }
                        if (this.reflectionFresnelParameters && this.reflectionFresnelParameters.isEnabled) {
                            ubo.updateColor4("reflectionLeftColor", this.reflectionFresnelParameters.leftColor, this.reflectionFresnelParameters.power);
                            ubo.updateColor4("reflectionRightColor", this.reflectionFresnelParameters.rightColor, this.reflectionFresnelParameters.bias);
                        }
                        if (this.refractionFresnelParameters && this.refractionFresnelParameters.isEnabled) {
                            ubo.updateColor4("refractionLeftColor", this.refractionFresnelParameters.leftColor, this.refractionFresnelParameters.power);
                            ubo.updateColor4("refractionRightColor", this.refractionFresnelParameters.rightColor, this.refractionFresnelParameters.bias);
                        }
                        if (this.emissiveFresnelParameters && this.emissiveFresnelParameters.isEnabled) {
                            ubo.updateColor4("emissiveLeftColor", this.emissiveFresnelParameters.leftColor, this.emissiveFresnelParameters.power);
                            ubo.updateColor4("emissiveRightColor", this.emissiveFresnelParameters.rightColor, this.emissiveFresnelParameters.bias);
                        }
                    }
                    // Textures
                    if (scene.texturesEnabled) {
                        if (this._diffuseTexture && StandardMaterial.DiffuseTextureEnabled) {
                            ubo.updateFloat2("vDiffuseInfos", this._diffuseTexture.coordinatesIndex, this._diffuseTexture.level);
                            MaterialHelper.BindTextureMatrix(this._diffuseTexture, ubo, "diffuse");
                        }
                        if (this._ambientTexture && StandardMaterial.AmbientTextureEnabled) {
                            ubo.updateFloat2("vAmbientInfos", this._ambientTexture.coordinatesIndex, this._ambientTexture.level);
                            MaterialHelper.BindTextureMatrix(this._ambientTexture, ubo, "ambient");
                        }
                        if (this._opacityTexture && StandardMaterial.OpacityTextureEnabled) {
                            ubo.updateFloat2("vOpacityInfos", this._opacityTexture.coordinatesIndex, this._opacityTexture.level);
                            MaterialHelper.BindTextureMatrix(this._opacityTexture, ubo, "opacity");
                        }
                        if (this._hasAlphaChannel()) {
                            ubo.updateFloat("alphaCutOff", this.alphaCutOff);
                        }
                        if (this._reflectionTexture && StandardMaterial.ReflectionTextureEnabled) {
                            ubo.updateFloat2("vReflectionInfos", this._reflectionTexture.level, this.roughness);
                            ubo.updateMatrix("reflectionMatrix", this._reflectionTexture.getReflectionTextureMatrix());
                            if (this._reflectionTexture.boundingBoxSize) {
                                const cubeTexture = this._reflectionTexture;
                                ubo.updateVector3("vReflectionPosition", cubeTexture.boundingBoxPosition);
                                ubo.updateVector3("vReflectionSize", cubeTexture.boundingBoxSize);
                            }
                        }
                        if (this._emissiveTexture && StandardMaterial.EmissiveTextureEnabled) {
                            ubo.updateFloat2("vEmissiveInfos", this._emissiveTexture.coordinatesIndex, this._emissiveTexture.level);
                            MaterialHelper.BindTextureMatrix(this._emissiveTexture, ubo, "emissive");
                        }
                        if (this._lightmapTexture && StandardMaterial.LightmapTextureEnabled) {
                            ubo.updateFloat2("vLightmapInfos", this._lightmapTexture.coordinatesIndex, this._lightmapTexture.level);
                            MaterialHelper.BindTextureMatrix(this._lightmapTexture, ubo, "lightmap");
                        }
                        if (this._specularTexture && StandardMaterial.SpecularTextureEnabled) {
                            ubo.updateFloat2("vSpecularInfos", this._specularTexture.coordinatesIndex, this._specularTexture.level);
                            MaterialHelper.BindTextureMatrix(this._specularTexture, ubo, "specular");
                        }
                        if (this._bumpTexture && scene.getEngine().getCaps().standardDerivatives && StandardMaterial.BumpTextureEnabled) {
                            ubo.updateFloat3("vBumpInfos", this._bumpTexture.coordinatesIndex, 1.0 / this._bumpTexture.level, this.parallaxScaleBias);
                            MaterialHelper.BindTextureMatrix(this._bumpTexture, ubo, "bump");
                            if (scene._mirroredCameraPosition) {
                                ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? 1.0 : -1.0, this._invertNormalMapY ? 1.0 : -1.0);
                            }
                            else {
                                ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? -1.0 : 1.0, this._invertNormalMapY ? -1.0 : 1.0);
                            }
                        }
                        if (this._refractionTexture && StandardMaterial.RefractionTextureEnabled) {
                            let depth = 1.0;
                            if (!this._refractionTexture.isCube) {
                                ubo.updateMatrix("refractionMatrix", this._refractionTexture.getReflectionTextureMatrix());
                                if (this._refractionTexture.depth) {
                                    depth = this._refractionTexture.depth;
                                }
                            }
                            ubo.updateFloat4("vRefractionInfos", this._refractionTexture.level, this.indexOfRefraction, depth, this.invertRefractionY ? -1 : 1);
                            if (this._refractionTexture.boundingBoxSize) {
                                const cubeTexture = this._refractionTexture;
                                ubo.updateVector3("vRefractionPosition", cubeTexture.boundingBoxPosition);
                                ubo.updateVector3("vRefractionSize", cubeTexture.boundingBoxSize);
                            }
                        }
                    }
                    // Point size
                    if (this.pointsCloud) {
                        ubo.updateFloat("pointSize", this.pointSize);
                    }
                    if (defines.SPECULARTERM) {
                        ubo.updateColor4("vSpecularColor", this.specularColor, this.specularPower);
                    }
                    ubo.updateColor3("vEmissiveColor", StandardMaterial.EmissiveTextureEnabled ? this.emissiveColor : Color3.BlackReadOnly);
                    ubo.updateColor4("vDiffuseColor", this.diffuseColor, this.alpha);
                    scene.ambientColor.multiplyToRef(this.ambientColor, this._globalAmbientColor);
                    ubo.updateColor3("vAmbientColor", this._globalAmbientColor);
                }
                // Textures
                if (scene.texturesEnabled) {
                    if (this._diffuseTexture && StandardMaterial.DiffuseTextureEnabled) {
                        effect.setTexture("diffuseSampler", this._diffuseTexture);
                    }
                    if (this._ambientTexture && StandardMaterial.AmbientTextureEnabled) {
                        effect.setTexture("ambientSampler", this._ambientTexture);
                    }
                    if (this._opacityTexture && StandardMaterial.OpacityTextureEnabled) {
                        effect.setTexture("opacitySampler", this._opacityTexture);
                    }
                    if (this._reflectionTexture && StandardMaterial.ReflectionTextureEnabled) {
                        if (this._reflectionTexture.isCube) {
                            effect.setTexture("reflectionCubeSampler", this._reflectionTexture);
                        }
                        else {
                            effect.setTexture("reflection2DSampler", this._reflectionTexture);
                        }
                    }
                    if (this._emissiveTexture && StandardMaterial.EmissiveTextureEnabled) {
                        effect.setTexture("emissiveSampler", this._emissiveTexture);
                    }
                    if (this._lightmapTexture && StandardMaterial.LightmapTextureEnabled) {
                        effect.setTexture("lightmapSampler", this._lightmapTexture);
                    }
                    if (this._specularTexture && StandardMaterial.SpecularTextureEnabled) {
                        effect.setTexture("specularSampler", this._specularTexture);
                    }
                    if (this._bumpTexture && scene.getEngine().getCaps().standardDerivatives && StandardMaterial.BumpTextureEnabled) {
                        effect.setTexture("bumpSampler", this._bumpTexture);
                    }
                    if (this._refractionTexture && StandardMaterial.RefractionTextureEnabled) {
                        if (this._refractionTexture.isCube) {
                            effect.setTexture("refractionCubeSampler", this._refractionTexture);
                        }
                        else {
                            effect.setTexture("refraction2DSampler", this._refractionTexture);
                        }
                    }
                }
                // OIT with depth peeling
                if (this.getScene().useOrderIndependentTransparency && this.needAlphaBlendingForMesh(mesh)) {
                    this.getScene().depthPeelingRenderer.bind(effect);
                }
                this._eventInfo.subMesh = subMesh;
                this._callbackPluginEventBindForSubMesh(this._eventInfo);
                // Clip plane
                bindClipPlane(effect, this, scene);
                // Colors
                this.bindEyePosition(effect);
            }
            else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) {
                this._needToBindSceneUbo = true;
            }
            if (mustRebind || !this.isFrozen) {
                // Lights
                if (scene.lightsEnabled && !this._disableLighting) {
                    MaterialHelper.BindLights(scene, mesh, effect, defines, this._maxSimultaneousLights);
                }
                // View
                if ((scene.fogEnabled && mesh.applyFog && scene.fogMode !== Scene.FOGMODE_NONE) ||
                    this._reflectionTexture ||
                    this._refractionTexture ||
                    mesh.receiveShadows ||
                    defines.PREPASS) {
                    this.bindView(effect);
                }
                // Fog
                MaterialHelper.BindFogParameters(scene, mesh, effect);
                // Morph targets
                if (defines.NUM_MORPH_INFLUENCERS) {
                    MaterialHelper.BindMorphTargetParameters(mesh, effect);
                }
                if (defines.BAKED_VERTEX_ANIMATION_TEXTURE) {
                    (_a = mesh.bakedVertexAnimationManager) === null || _a === void 0 ? void 0 : _a.bind(effect, defines.INSTANCES);
                }
                // Log. depth
                if (this.useLogarithmicDepth) {
                    MaterialHelper.BindLogDepth(defines, effect, scene);
                }
                // image processing
                if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) {
                    this._imageProcessingConfiguration.bind(this._activeEffect);
                }
            }
            this._afterBind(mesh, this._activeEffect);
            ubo.update();
        }
        /**
         * Get the list of animatables in the material.
         * @returns the list of animatables object used in the material
         */
        getAnimatables() {
            const results = super.getAnimatables();
            if (this._diffuseTexture && this._diffuseTexture.animations && this._diffuseTexture.animations.length > 0) {
                results.push(this._diffuseTexture);
            }
            if (this._ambientTexture && this._ambientTexture.animations && this._ambientTexture.animations.length > 0) {
                results.push(this._ambientTexture);
            }
            if (this._opacityTexture && this._opacityTexture.animations && this._opacityTexture.animations.length > 0) {
                results.push(this._opacityTexture);
            }
            if (this._reflectionTexture && this._reflectionTexture.animations && this._reflectionTexture.animations.length > 0) {
                results.push(this._reflectionTexture);
            }
            if (this._emissiveTexture && this._emissiveTexture.animations && this._emissiveTexture.animations.length > 0) {
                results.push(this._emissiveTexture);
            }
            if (this._specularTexture && this._specularTexture.animations && this._specularTexture.animations.length > 0) {
                results.push(this._specularTexture);
            }
            if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) {
                results.push(this._bumpTexture);
            }
            if (this._lightmapTexture && this._lightmapTexture.animations && this._lightmapTexture.animations.length > 0) {
                results.push(this._lightmapTexture);
            }
            if (this._refractionTexture && this._refractionTexture.animations && this._refractionTexture.animations.length > 0) {
                results.push(this._refractionTexture);
            }
            return results;
        }
        /**
         * Gets the active textures from the material
         * @returns an array of textures
         */
        getActiveTextures() {
            const activeTextures = super.getActiveTextures();
            if (this._diffuseTexture) {
                activeTextures.push(this._diffuseTexture);
            }
            if (this._ambientTexture) {
                activeTextures.push(this._ambientTexture);
            }
            if (this._opacityTexture) {
                activeTextures.push(this._opacityTexture);
            }
            if (this._reflectionTexture) {
                activeTextures.push(this._reflectionTexture);
            }
            if (this._emissiveTexture) {
                activeTextures.push(this._emissiveTexture);
            }
            if (this._specularTexture) {
                activeTextures.push(this._specularTexture);
            }
            if (this._bumpTexture) {
                activeTextures.push(this._bumpTexture);
            }
            if (this._lightmapTexture) {
                activeTextures.push(this._lightmapTexture);
            }
            if (this._refractionTexture) {
                activeTextures.push(this._refractionTexture);
            }
            return activeTextures;
        }
        /**
         * Specifies if the material uses a texture
         * @param texture defines the texture to check against the material
         * @returns a boolean specifying if the material uses the texture
         */
        hasTexture(texture) {
            if (super.hasTexture(texture)) {
                return true;
            }
            if (this._diffuseTexture === texture) {
                return true;
            }
            if (this._ambientTexture === texture) {
                return true;
            }
            if (this._opacityTexture === texture) {
                return true;
            }
            if (this._reflectionTexture === texture) {
                return true;
            }
            if (this._emissiveTexture === texture) {
                return true;
            }
            if (this._specularTexture === texture) {
                return true;
            }
            if (this._bumpTexture === texture) {
                return true;
            }
            if (this._lightmapTexture === texture) {
                return true;
            }
            if (this._refractionTexture === texture) {
                return true;
            }
            return false;
        }
        /**
         * Disposes the material
         * @param forceDisposeEffect specifies if effects should be forcefully disposed
         * @param forceDisposeTextures specifies if textures should be forcefully disposed
         */
        dispose(forceDisposeEffect, forceDisposeTextures) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (forceDisposeTextures) {
                (_a = this._diffuseTexture) === null || _a === void 0 ? void 0 : _a.dispose();
                (_b = this._ambientTexture) === null || _b === void 0 ? void 0 : _b.dispose();
                (_c = this._opacityTexture) === null || _c === void 0 ? void 0 : _c.dispose();
                (_d = this._reflectionTexture) === null || _d === void 0 ? void 0 : _d.dispose();
                (_e = this._emissiveTexture) === null || _e === void 0 ? void 0 : _e.dispose();
                (_f = this._specularTexture) === null || _f === void 0 ? void 0 : _f.dispose();
                (_g = this._bumpTexture) === null || _g === void 0 ? void 0 : _g.dispose();
                (_h = this._lightmapTexture) === null || _h === void 0 ? void 0 : _h.dispose();
                (_j = this._refractionTexture) === null || _j === void 0 ? void 0 : _j.dispose();
            }
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            super.dispose(forceDisposeEffect, forceDisposeTextures);
        }
        /**
         * Makes a duplicate of the material, and gives it a new name
         * @param name defines the new name for the duplicated material
         * @param cloneTexturesOnlyOnce - if a texture is used in more than one channel (e.g diffuse and opacity), only clone it once and reuse it on the other channels. Default false.
         * @param rootUrl defines the root URL to use to load textures
         * @returns the cloned material
         */
        clone(name, cloneTexturesOnlyOnce = true, rootUrl = "") {
            const result = SerializationHelper.Clone(() => new StandardMaterial(name, this.getScene()), this, { cloneTexturesOnlyOnce });
            result.name = name;
            result.id = name;
            this.stencil.copyTo(result.stencil);
            this._clonePlugins(result, rootUrl);
            return result;
        }
        /**
         * Creates a standard material from parsed material data
         * @param source defines the JSON representation of the material
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @returns a new standard material
         */
        static Parse(source, scene, rootUrl) {
            const material = SerializationHelper.Parse(() => new StandardMaterial(source.name, scene), source, scene, rootUrl);
            if (source.stencil) {
                material.stencil.parse(source.stencil, scene, rootUrl);
            }
            Material._parsePlugins(source, material, scene, rootUrl);
            return material;
        }
        // Flags used to enable or disable a type of texture for all Standard Materials
        /**
         * Are diffuse textures enabled in the application.
         */
        static get DiffuseTextureEnabled() {
            return MaterialFlags.DiffuseTextureEnabled;
        }
        static set DiffuseTextureEnabled(value) {
            MaterialFlags.DiffuseTextureEnabled = value;
        }
        /**
         * Are detail textures enabled in the application.
         */
        static get DetailTextureEnabled() {
            return MaterialFlags.DetailTextureEnabled;
        }
        static set DetailTextureEnabled(value) {
            MaterialFlags.DetailTextureEnabled = value;
        }
        /**
         * Are ambient textures enabled in the application.
         */
        static get AmbientTextureEnabled() {
            return MaterialFlags.AmbientTextureEnabled;
        }
        static set AmbientTextureEnabled(value) {
            MaterialFlags.AmbientTextureEnabled = value;
        }
        /**
         * Are opacity textures enabled in the application.
         */
        static get OpacityTextureEnabled() {
            return MaterialFlags.OpacityTextureEnabled;
        }
        static set OpacityTextureEnabled(value) {
            MaterialFlags.OpacityTextureEnabled = value;
        }
        /**
         * Are reflection textures enabled in the application.
         */
        static get ReflectionTextureEnabled() {
            return MaterialFlags.ReflectionTextureEnabled;
        }
        static set ReflectionTextureEnabled(value) {
            MaterialFlags.ReflectionTextureEnabled = value;
        }
        /**
         * Are emissive textures enabled in the application.
         */
        static get EmissiveTextureEnabled() {
            return MaterialFlags.EmissiveTextureEnabled;
        }
        static set EmissiveTextureEnabled(value) {
            MaterialFlags.EmissiveTextureEnabled = value;
        }
        /**
         * Are specular textures enabled in the application.
         */
        static get SpecularTextureEnabled() {
            return MaterialFlags.SpecularTextureEnabled;
        }
        static set SpecularTextureEnabled(value) {
            MaterialFlags.SpecularTextureEnabled = value;
        }
        /**
         * Are bump textures enabled in the application.
         */
        static get BumpTextureEnabled() {
            return MaterialFlags.BumpTextureEnabled;
        }
        static set BumpTextureEnabled(value) {
            MaterialFlags.BumpTextureEnabled = value;
        }
        /**
         * Are lightmap textures enabled in the application.
         */
        static get LightmapTextureEnabled() {
            return MaterialFlags.LightmapTextureEnabled;
        }
        static set LightmapTextureEnabled(value) {
            MaterialFlags.LightmapTextureEnabled = value;
        }
        /**
         * Are refraction textures enabled in the application.
         */
        static get RefractionTextureEnabled() {
            return MaterialFlags.RefractionTextureEnabled;
        }
        static set RefractionTextureEnabled(value) {
            MaterialFlags.RefractionTextureEnabled = value;
        }
        /**
         * Are color grading textures enabled in the application.
         */
        static get ColorGradingTextureEnabled() {
            return MaterialFlags.ColorGradingTextureEnabled;
        }
        static set ColorGradingTextureEnabled(value) {
            MaterialFlags.ColorGradingTextureEnabled = value;
        }
        /**
         * Are fresnels enabled in the application.
         */
        static get FresnelEnabled() {
            return MaterialFlags.FresnelEnabled;
        }
        static set FresnelEnabled(value) {
            MaterialFlags.FresnelEnabled = value;
        }
    }
    __decorate$1([
        serializeAsTexture("diffuseTexture")
    ], StandardMaterial.prototype, "_diffuseTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], StandardMaterial.prototype, "diffuseTexture", void 0);
    __decorate$1([
        serializeAsTexture("ambientTexture")
    ], StandardMaterial.prototype, "_ambientTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "ambientTexture", void 0);
    __decorate$1([
        serializeAsTexture("opacityTexture")
    ], StandardMaterial.prototype, "_opacityTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], StandardMaterial.prototype, "opacityTexture", void 0);
    __decorate$1([
        serializeAsTexture("reflectionTexture")
    ], StandardMaterial.prototype, "_reflectionTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "reflectionTexture", void 0);
    __decorate$1([
        serializeAsTexture("emissiveTexture")
    ], StandardMaterial.prototype, "_emissiveTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "emissiveTexture", void 0);
    __decorate$1([
        serializeAsTexture("specularTexture")
    ], StandardMaterial.prototype, "_specularTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "specularTexture", void 0);
    __decorate$1([
        serializeAsTexture("bumpTexture")
    ], StandardMaterial.prototype, "_bumpTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "bumpTexture", void 0);
    __decorate$1([
        serializeAsTexture("lightmapTexture")
    ], StandardMaterial.prototype, "_lightmapTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "lightmapTexture", void 0);
    __decorate$1([
        serializeAsTexture("refractionTexture")
    ], StandardMaterial.prototype, "_refractionTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "refractionTexture", void 0);
    __decorate$1([
        serializeAsColor3("ambient")
    ], StandardMaterial.prototype, "ambientColor", void 0);
    __decorate$1([
        serializeAsColor3("diffuse")
    ], StandardMaterial.prototype, "diffuseColor", void 0);
    __decorate$1([
        serializeAsColor3("specular")
    ], StandardMaterial.prototype, "specularColor", void 0);
    __decorate$1([
        serializeAsColor3("emissive")
    ], StandardMaterial.prototype, "emissiveColor", void 0);
    __decorate$1([
        serialize()
    ], StandardMaterial.prototype, "specularPower", void 0);
    __decorate$1([
        serialize("useAlphaFromDiffuseTexture")
    ], StandardMaterial.prototype, "_useAlphaFromDiffuseTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], StandardMaterial.prototype, "useAlphaFromDiffuseTexture", void 0);
    __decorate$1([
        serialize("useEmissiveAsIllumination")
    ], StandardMaterial.prototype, "_useEmissiveAsIllumination", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useEmissiveAsIllumination", void 0);
    __decorate$1([
        serialize("linkEmissiveWithDiffuse")
    ], StandardMaterial.prototype, "_linkEmissiveWithDiffuse", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "linkEmissiveWithDiffuse", void 0);
    __decorate$1([
        serialize("useSpecularOverAlpha")
    ], StandardMaterial.prototype, "_useSpecularOverAlpha", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useSpecularOverAlpha", void 0);
    __decorate$1([
        serialize("useReflectionOverAlpha")
    ], StandardMaterial.prototype, "_useReflectionOverAlpha", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useReflectionOverAlpha", void 0);
    __decorate$1([
        serialize("disableLighting")
    ], StandardMaterial.prototype, "_disableLighting", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], StandardMaterial.prototype, "disableLighting", void 0);
    __decorate$1([
        serialize("useObjectSpaceNormalMap")
    ], StandardMaterial.prototype, "_useObjectSpaceNormalMap", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useObjectSpaceNormalMap", void 0);
    __decorate$1([
        serialize("useParallax")
    ], StandardMaterial.prototype, "_useParallax", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useParallax", void 0);
    __decorate$1([
        serialize("useParallaxOcclusion")
    ], StandardMaterial.prototype, "_useParallaxOcclusion", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useParallaxOcclusion", void 0);
    __decorate$1([
        serialize()
    ], StandardMaterial.prototype, "parallaxScaleBias", void 0);
    __decorate$1([
        serialize("roughness")
    ], StandardMaterial.prototype, "_roughness", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "roughness", void 0);
    __decorate$1([
        serialize()
    ], StandardMaterial.prototype, "indexOfRefraction", void 0);
    __decorate$1([
        serialize()
    ], StandardMaterial.prototype, "invertRefractionY", void 0);
    __decorate$1([
        serialize()
    ], StandardMaterial.prototype, "alphaCutOff", void 0);
    __decorate$1([
        serialize("useLightmapAsShadowmap")
    ], StandardMaterial.prototype, "_useLightmapAsShadowmap", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useLightmapAsShadowmap", void 0);
    __decorate$1([
        serializeAsFresnelParameters("diffuseFresnelParameters")
    ], StandardMaterial.prototype, "_diffuseFresnelParameters", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsFresnelDirty")
    ], StandardMaterial.prototype, "diffuseFresnelParameters", void 0);
    __decorate$1([
        serializeAsFresnelParameters("opacityFresnelParameters")
    ], StandardMaterial.prototype, "_opacityFresnelParameters", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsFresnelAndMiscDirty")
    ], StandardMaterial.prototype, "opacityFresnelParameters", void 0);
    __decorate$1([
        serializeAsFresnelParameters("reflectionFresnelParameters")
    ], StandardMaterial.prototype, "_reflectionFresnelParameters", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsFresnelDirty")
    ], StandardMaterial.prototype, "reflectionFresnelParameters", void 0);
    __decorate$1([
        serializeAsFresnelParameters("refractionFresnelParameters")
    ], StandardMaterial.prototype, "_refractionFresnelParameters", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsFresnelDirty")
    ], StandardMaterial.prototype, "refractionFresnelParameters", void 0);
    __decorate$1([
        serializeAsFresnelParameters("emissiveFresnelParameters")
    ], StandardMaterial.prototype, "_emissiveFresnelParameters", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsFresnelDirty")
    ], StandardMaterial.prototype, "emissiveFresnelParameters", void 0);
    __decorate$1([
        serialize("useReflectionFresnelFromSpecular")
    ], StandardMaterial.prototype, "_useReflectionFresnelFromSpecular", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsFresnelDirty")
    ], StandardMaterial.prototype, "useReflectionFresnelFromSpecular", void 0);
    __decorate$1([
        serialize("useGlossinessFromSpecularMapAlpha")
    ], StandardMaterial.prototype, "_useGlossinessFromSpecularMapAlpha", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "useGlossinessFromSpecularMapAlpha", void 0);
    __decorate$1([
        serialize("maxSimultaneousLights")
    ], StandardMaterial.prototype, "_maxSimultaneousLights", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], StandardMaterial.prototype, "maxSimultaneousLights", void 0);
    __decorate$1([
        serialize("invertNormalMapX")
    ], StandardMaterial.prototype, "_invertNormalMapX", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "invertNormalMapX", void 0);
    __decorate$1([
        serialize("invertNormalMapY")
    ], StandardMaterial.prototype, "_invertNormalMapY", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "invertNormalMapY", void 0);
    __decorate$1([
        serialize("twoSidedLighting")
    ], StandardMaterial.prototype, "_twoSidedLighting", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], StandardMaterial.prototype, "twoSidedLighting", void 0);
    __decorate$1([
        serialize("applyDecalMapAfterDetailMap")
    ], StandardMaterial.prototype, "_applyDecalMapAfterDetailMap", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], StandardMaterial.prototype, "applyDecalMapAfterDetailMap", void 0);
    __decorate$1([
        serialize()
    ], StandardMaterial.prototype, "useLogarithmicDepth", null);
    RegisterClass("BABYLON.StandardMaterial", StandardMaterial);
    Scene.DefaultMaterialFactory = (scene) => {
        return new StandardMaterial("default material", scene);
    };

    // Do not edit.
    const name$$ = "postprocessVertexShader";
    const shader$$ = `attribute vec2 position;uniform vec2 scale;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=(position*madd+madd)*scale;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$$] = shader$$;

    /**
     * Wrapper around a render target (either single or multi textures)
     */
    class RenderTargetWrapper {
        /**
         * Gets the depth/stencil texture (if created by a createDepthStencilTexture() call)
         */
        get depthStencilTexture() {
            return this._depthStencilTexture;
        }
        /**
         * Indicates if the depth/stencil texture has a stencil aspect
         */
        get depthStencilTextureWithStencil() {
            return this._depthStencilTextureWithStencil;
        }
        /**
         * Defines if the render target wrapper is for a cube texture or if false a 2d texture
         */
        get isCube() {
            return this._isCube;
        }
        /**
         * Defines if the render target wrapper is for a single or multi target render wrapper
         */
        get isMulti() {
            return this._isMulti;
        }
        /**
         * Defines if the render target wrapper is for a single or an array of textures
         */
        get is2DArray() {
            return this.layers > 0;
        }
        /**
         * Gets the size of the render target wrapper (used for cubes, as width=height in this case)
         */
        get size() {
            return this.width;
        }
        /**
         * Gets the width of the render target wrapper
         */
        get width() {
            return this._size.width || this._size;
        }
        /**
         * Gets the height of the render target wrapper
         */
        get height() {
            return this._size.height || this._size;
        }
        /**
         * Gets the number of layers of the render target wrapper (only used if is2DArray is true and wrapper is not a multi render target)
         */
        get layers() {
            return this._size.layers || 0;
        }
        /**
         * Gets the render texture. If this is a multi render target, gets the first texture
         */
        get texture() {
            var _a, _b;
            return (_b = (_a = this._textures) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
        }
        /**
         * Gets the list of render textures. If we are not in a multi render target, the list will be null (use the texture getter instead)
         */
        get textures() {
            return this._textures;
        }
        /**
         * Gets the face indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
         */
        get faceIndices() {
            return this._faceIndices;
        }
        /**
         * Gets the layer indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
         */
        get layerIndices() {
            return this._layerIndices;
        }
        /**
         * Gets the sample count of the render target
         */
        get samples() {
            return this._samples;
        }
        /**
         * Sets the sample count of the render target
         * @param value sample count
         * @param initializeBuffers If set to true, the engine will make an initializing call to drawBuffers (only used when isMulti=true).
         * @param force true to force calling the update sample count engine function even if the current sample count is equal to value
         * @returns the sample count that has been set
         */
        setSamples(value, initializeBuffers = true, force = false) {
            if (this.samples === value && !force) {
                return value;
            }
            const result = this._isMulti
                ? this._engine.updateMultipleRenderTargetTextureSampleCount(this, value, initializeBuffers)
                : this._engine.updateRenderTargetTextureSampleCount(this, value);
            this._samples = value;
            return result;
        }
        /**
         * Initializes the render target wrapper
         * @param isMulti true if the wrapper is a multi render target
         * @param isCube true if the wrapper should render to a cube texture
         * @param size size of the render target (width/height/layers)
         * @param engine engine used to create the render target
         */
        constructor(isMulti, isCube, size, engine) {
            this._textures = null;
            this._faceIndices = null;
            this._layerIndices = null;
            /** @internal */
            this._samples = 1;
            /** @internal */
            this._attachments = null;
            /** @internal */
            this._generateStencilBuffer = false;
            /** @internal */
            this._generateDepthBuffer = false;
            /** @internal */
            this._depthStencilTextureWithStencil = false;
            this._isMulti = isMulti;
            this._isCube = isCube;
            this._size = size;
            this._engine = engine;
            this._depthStencilTexture = null;
        }
        /**
         * Sets the render target texture(s)
         * @param textures texture(s) to set
         */
        setTextures(textures) {
            if (Array.isArray(textures)) {
                this._textures = textures;
            }
            else if (textures) {
                this._textures = [textures];
            }
            else {
                this._textures = null;
            }
        }
        /**
         * Set a texture in the textures array
         * @param texture The texture to set
         * @param index The index in the textures array to set
         * @param disposePrevious If this function should dispose the previous texture
         */
        setTexture(texture, index = 0, disposePrevious = true) {
            if (!this._textures) {
                this._textures = [];
            }
            if (this._textures[index] && disposePrevious) {
                this._textures[index].dispose();
            }
            this._textures[index] = texture;
        }
        /**
         * Sets the layer and face indices of every render target texture bound to each color attachment
         * @param layers The layers of each texture to be set
         * @param faces The faces of each texture to be set
         */
        setLayerAndFaceIndices(layers, faces) {
            this._layerIndices = layers;
            this._faceIndices = faces;
        }
        /**
         * Sets the layer and face indices of a texture in the textures array that should be bound to each color attachment
         * @param index The index of the texture in the textures array to modify
         * @param layer The layer of the texture to be set
         * @param face The face of the texture to be set
         */
        setLayerAndFaceIndex(index = 0, layer, face) {
            if (!this._layerIndices) {
                this._layerIndices = [];
            }
            if (!this._faceIndices) {
                this._faceIndices = [];
            }
            if (layer !== undefined && layer >= 0) {
                this._layerIndices[index] = layer;
            }
            if (face !== undefined && face >= 0) {
                this._faceIndices[index] = face;
            }
        }
        /**
         * Creates the depth/stencil texture
         * @param comparisonFunction Comparison function to use for the texture
         * @param bilinearFiltering true if bilinear filtering should be used when sampling the texture
         * @param generateStencil true if the stencil aspect should also be created
         * @param samples sample count to use when creating the texture
         * @param format format of the depth texture
         * @param label defines the label to use for the texture (for debugging purpose only)
         * @returns the depth/stencil created texture
         */
        createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14, label) {
            var _a;
            (_a = this._depthStencilTexture) === null || _a === void 0 ? void 0 : _a.dispose();
            this._depthStencilTextureWithStencil = generateStencil;
            this._depthStencilTexture = this._engine.createDepthStencilTexture(this._size, {
                bilinearFiltering,
                comparisonFunction,
                generateStencil,
                isCube: this._isCube,
                samples,
                depthTextureFormat: format,
                label,
            }, this);
            return this._depthStencilTexture;
        }
        /**
         * Shares the depth buffer of this render target with another render target.
         * @internal
         * @param renderTarget Destination renderTarget
         */
        _shareDepth(renderTarget) {
            if (this._depthStencilTexture) {
                if (renderTarget._depthStencilTexture) {
                    renderTarget._depthStencilTexture.dispose();
                }
                renderTarget._depthStencilTexture = this._depthStencilTexture;
                this._depthStencilTexture.incrementReferences();
            }
        }
        /**
         * @internal
         */
        _swapAndDie(target) {
            if (this.texture) {
                this.texture._swapAndDie(target);
            }
            this._textures = null;
            this.dispose(true);
        }
        _cloneRenderTargetWrapper() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let rtw = null;
            if (this._isMulti) {
                const textureArray = this.textures;
                if (textureArray && textureArray.length > 0) {
                    let generateDepthTexture = false;
                    let textureCount = textureArray.length;
                    const lastTextureSource = textureArray[textureArray.length - 1]._source;
                    if (lastTextureSource === InternalTextureSource.Depth || lastTextureSource === InternalTextureSource.DepthStencil) {
                        generateDepthTexture = true;
                        textureCount--;
                    }
                    const samplingModes = [];
                    const types = [];
                    const formats = [];
                    const targetTypes = [];
                    const faceIndex = [];
                    const layerIndex = [];
                    const layerCounts = [];
                    const internalTexture2Index = {};
                    for (let i = 0; i < textureCount; ++i) {
                        const texture = textureArray[i];
                        samplingModes.push(texture.samplingMode);
                        types.push(texture.type);
                        formats.push(texture.format);
                        const index = internalTexture2Index[texture.uniqueId];
                        if (index !== undefined) {
                            targetTypes.push(-1);
                            layerCounts.push(0);
                        }
                        else {
                            internalTexture2Index[texture.uniqueId] = i;
                            if (texture.is2DArray) {
                                targetTypes.push(35866);
                                layerCounts.push(texture.depth);
                            }
                            else if (texture.isCube) {
                                targetTypes.push(34067);
                                layerCounts.push(0);
                            } /*else if (texture.isCubeArray) {
                                targetTypes.push(3735928559);
                                layerCounts.push(texture.depth);
                            }*/
                            else if (texture.is3D) {
                                targetTypes.push(32879);
                                layerCounts.push(texture.depth);
                            }
                            else {
                                targetTypes.push(3553);
                                layerCounts.push(0);
                            }
                        }
                        if (this._faceIndices) {
                            faceIndex.push((_a = this._faceIndices[i]) !== null && _a !== void 0 ? _a : 0);
                        }
                        if (this._layerIndices) {
                            layerIndex.push((_b = this._layerIndices[i]) !== null && _b !== void 0 ? _b : 0);
                        }
                    }
                    const optionsMRT = {
                        samplingModes,
                        generateMipMaps: textureArray[0].generateMipMaps,
                        generateDepthBuffer: this._generateDepthBuffer,
                        generateStencilBuffer: this._generateStencilBuffer,
                        generateDepthTexture,
                        types,
                        formats,
                        textureCount,
                        targetTypes,
                        faceIndex,
                        layerIndex,
                        layerCounts,
                    };
                    const size = {
                        width: this.width,
                        height: this.height,
                    };
                    rtw = this._engine.createMultipleRenderTarget(size, optionsMRT);
                    for (let i = 0; i < textureCount; ++i) {
                        if (targetTypes[i] !== -1) {
                            continue;
                        }
                        const index = internalTexture2Index[textureArray[i].uniqueId];
                        rtw.setTexture(rtw.textures[index], i);
                    }
                }
            }
            else {
                const options = {};
                options.generateDepthBuffer = this._generateDepthBuffer;
                options.generateMipMaps = (_d = (_c = this.texture) === null || _c === void 0 ? void 0 : _c.generateMipMaps) !== null && _d !== void 0 ? _d : false;
                options.generateStencilBuffer = this._generateStencilBuffer;
                options.samplingMode = (_e = this.texture) === null || _e === void 0 ? void 0 : _e.samplingMode;
                options.type = (_f = this.texture) === null || _f === void 0 ? void 0 : _f.type;
                options.format = (_g = this.texture) === null || _g === void 0 ? void 0 : _g.format;
                if (this.isCube) {
                    rtw = this._engine.createRenderTargetCubeTexture(this.width, options);
                }
                else {
                    const size = {
                        width: this.width,
                        height: this.height,
                        layers: this.is2DArray ? (_h = this.texture) === null || _h === void 0 ? void 0 : _h.depth : undefined,
                    };
                    rtw = this._engine.createRenderTargetTexture(size, options);
                }
                rtw.texture.isReady = true;
            }
            return rtw;
        }
        _swapRenderTargetWrapper(target) {
            if (this._textures && target._textures) {
                for (let i = 0; i < this._textures.length; ++i) {
                    this._textures[i]._swapAndDie(target._textures[i], false);
                    target._textures[i].isReady = true;
                }
            }
            if (this._depthStencilTexture && target._depthStencilTexture) {
                this._depthStencilTexture._swapAndDie(target._depthStencilTexture);
                target._depthStencilTexture.isReady = true;
            }
            this._textures = null;
            this._depthStencilTexture = null;
        }
        /** @internal */
        _rebuild() {
            const rtw = this._cloneRenderTargetWrapper();
            if (!rtw) {
                return;
            }
            if (this._depthStencilTexture) {
                const samplingMode = this._depthStencilTexture.samplingMode;
                const bilinear = samplingMode === 2 ||
                    samplingMode === 3 ||
                    samplingMode === 11;
                rtw.createDepthStencilTexture(this._depthStencilTexture._comparisonFunction, bilinear, this._depthStencilTextureWithStencil, this._depthStencilTexture.samples);
            }
            if (this.samples > 1) {
                rtw.setSamples(this.samples);
            }
            rtw._swapRenderTargetWrapper(this);
            rtw.dispose();
        }
        /**
         * Releases the internal render textures
         */
        releaseTextures() {
            var _a, _b;
            if (this._textures) {
                for (let i = 0; (_b = i < ((_a = this._textures) === null || _a === void 0 ? void 0 : _a.length)) !== null && _b !== void 0 ? _b : 0; ++i) {
                    this._textures[i].dispose();
                }
            }
            this._textures = null;
        }
        /**
         * Disposes the whole render target wrapper
         * @param disposeOnlyFramebuffers true if only the frame buffers should be released (used for the WebGL engine). If false, all the textures will also be released
         */
        dispose(disposeOnlyFramebuffers = false) {
            var _a;
            if (!disposeOnlyFramebuffers) {
                (_a = this._depthStencilTexture) === null || _a === void 0 ? void 0 : _a.dispose();
                this._depthStencilTexture = null;
                this.releaseTextures();
            }
            this._engine._releaseRenderTargetWrapper(this);
        }
    }

    /** @internal */
    class WebGLRenderTargetWrapper extends RenderTargetWrapper {
        constructor(isMulti, isCube, size, engine, context) {
            super(isMulti, isCube, size, engine);
            /**
             * @internal
             */
            this._framebuffer = null;
            /**
             * @internal
             */
            this._depthStencilBuffer = null;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            /**
             * @internal
             */
            this._MSAAFramebuffer = null;
            // Multiview
            /**
             * @internal
             */
            this._colorTextureArray = null;
            /**
             * @internal
             */
            this._depthStencilTextureArray = null;
            /**
             * @internal
             */
            this._disposeOnlyFramebuffers = false;
            this._context = context;
        }
        _cloneRenderTargetWrapper() {
            let rtw = null;
            if (this._colorTextureArray && this._depthStencilTextureArray) {
                rtw = this._engine.createMultiviewRenderTargetTexture(this.width, this.height);
                rtw.texture.isReady = true;
            }
            else {
                rtw = super._cloneRenderTargetWrapper();
            }
            return rtw;
        }
        _swapRenderTargetWrapper(target) {
            super._swapRenderTargetWrapper(target);
            target._framebuffer = this._framebuffer;
            target._depthStencilBuffer = this._depthStencilBuffer;
            target._MSAAFramebuffer = this._MSAAFramebuffer;
            target._colorTextureArray = this._colorTextureArray;
            target._depthStencilTextureArray = this._depthStencilTextureArray;
            this._framebuffer = this._depthStencilBuffer = this._MSAAFramebuffer = this._colorTextureArray = this._depthStencilTextureArray = null;
        }
        /**
         * Shares the depth buffer of this render target with another render target.
         * @internal
         * @param renderTarget Destination renderTarget
         */
        _shareDepth(renderTarget) {
            super._shareDepth(renderTarget);
            const gl = this._context;
            const depthbuffer = this._depthStencilBuffer;
            const framebuffer = renderTarget._MSAAFramebuffer || renderTarget._framebuffer;
            if (renderTarget._depthStencilBuffer) {
                gl.deleteRenderbuffer(renderTarget._depthStencilBuffer);
            }
            renderTarget._depthStencilBuffer = this._depthStencilBuffer;
            this._engine._bindUnboundFramebuffer(framebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthbuffer);
            this._engine._bindUnboundFramebuffer(null);
        }
        /**
         * Binds a texture to this render target on a specific attachment
         * @param texture The texture to bind to the framebuffer
         * @param attachmentIndex Index of the attachment
         * @param faceIndexOrLayer The face or layer of the texture to render to in case of cube texture or array texture
         * @param lodLevel defines the lod level to bind to the frame buffer
         */
        _bindTextureRenderTarget(texture, attachmentIndex = 0, faceIndexOrLayer, lodLevel = 0) {
            var _a, _b, _c, _d;
            if (!texture._hardwareTexture) {
                return;
            }
            const framebuffer = this._framebuffer;
            const currentFB = this._engine._currentFramebuffer;
            this._engine._bindUnboundFramebuffer(framebuffer);
            if (this._engine.webGLVersion > 1) {
                const gl = this._context;
                const attachment = gl["COLOR_ATTACHMENT" + attachmentIndex];
                if (texture.is2DArray || texture.is3D) {
                    faceIndexOrLayer = (_b = faceIndexOrLayer !== null && faceIndexOrLayer !== void 0 ? faceIndexOrLayer : (_a = this.layerIndices) === null || _a === void 0 ? void 0 : _a[attachmentIndex]) !== null && _b !== void 0 ? _b : 0;
                    gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, texture._hardwareTexture.underlyingResource, lodLevel, faceIndexOrLayer);
                }
                else if (texture.isCube) {
                    // if face index is not specified, try to query it from faceIndices
                    // default is face 0
                    faceIndexOrLayer = (_d = faceIndexOrLayer !== null && faceIndexOrLayer !== void 0 ? faceIndexOrLayer : (_c = this.faceIndices) === null || _c === void 0 ? void 0 : _c[attachmentIndex]) !== null && _d !== void 0 ? _d : 0;
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndexOrLayer, texture._hardwareTexture.underlyingResource, lodLevel);
                }
                else {
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, texture._hardwareTexture.underlyingResource, lodLevel);
                }
            }
            else {
                // Default behavior (WebGL)
                const gl = this._context;
                const attachment = gl["COLOR_ATTACHMENT" + attachmentIndex + "_WEBGL"];
                const target = faceIndexOrLayer !== undefined ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndexOrLayer : gl.TEXTURE_2D;
                gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, target, texture._hardwareTexture.underlyingResource, lodLevel);
            }
            this._engine._bindUnboundFramebuffer(currentFB);
        }
        /**
         * Set a texture in the textures array
         * @param texture the texture to set
         * @param index the index in the textures array to set
         * @param disposePrevious If this function should dispose the previous texture
         */
        setTexture(texture, index = 0, disposePrevious = true) {
            super.setTexture(texture, index, disposePrevious);
            this._bindTextureRenderTarget(texture, index);
        }
        /**
         * Sets the layer and face indices of every render target texture
         * @param layers The layer of the texture to be set (make negative to not modify)
         * @param faces The face of the texture to be set (make negative to not modify)
         */
        setLayerAndFaceIndices(layers, faces) {
            var _a, _b;
            super.setLayerAndFaceIndices(layers, faces);
            if (!this.textures || !this.layerIndices || !this.faceIndices) {
                return;
            }
            // the length of this._attachments is the right one as it does not count the depth texture, in case we generated it
            const textureCount = (_b = (_a = this._attachments) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : this.textures.length;
            for (let index = 0; index < textureCount; index++) {
                const texture = this.textures[index];
                if (!texture) {
                    // The target type was probably -1 at creation time and setTexture has not been called yet for this index
                    continue;
                }
                if (texture.is2DArray || texture.is3D) {
                    this._bindTextureRenderTarget(texture, index, this.layerIndices[index]);
                }
                else if (texture.isCube) {
                    this._bindTextureRenderTarget(texture, index, this.faceIndices[index]);
                }
                else {
                    this._bindTextureRenderTarget(texture, index);
                }
            }
        }
        /**
         * Set the face and layer indices of a texture in the textures array
         * @param index The index of the texture in the textures array to modify
         * @param layer The layer of the texture to be set
         * @param face The face of the texture to be set
         */
        setLayerAndFaceIndex(index = 0, layer, face) {
            super.setLayerAndFaceIndex(index, layer, face);
            if (!this.textures || !this.layerIndices || !this.faceIndices) {
                return;
            }
            const texture = this.textures[index];
            if (texture.is2DArray || texture.is3D) {
                this._bindTextureRenderTarget(this.textures[index], index, this.layerIndices[index]);
            }
            else if (texture.isCube) {
                this._bindTextureRenderTarget(this.textures[index], index, this.faceIndices[index]);
            }
        }
        dispose(disposeOnlyFramebuffers = this._disposeOnlyFramebuffers) {
            const gl = this._context;
            if (!disposeOnlyFramebuffers) {
                if (this._colorTextureArray) {
                    this._context.deleteTexture(this._colorTextureArray);
                    this._colorTextureArray = null;
                }
                if (this._depthStencilTextureArray) {
                    this._context.deleteTexture(this._depthStencilTextureArray);
                    this._depthStencilTextureArray = null;
                }
            }
            if (this._framebuffer) {
                gl.deleteFramebuffer(this._framebuffer);
                this._framebuffer = null;
            }
            if (this._depthStencilBuffer) {
                gl.deleteRenderbuffer(this._depthStencilBuffer);
                this._depthStencilBuffer = null;
            }
            if (this._MSAAFramebuffer) {
                gl.deleteFramebuffer(this._MSAAFramebuffer);
                this._MSAAFramebuffer = null;
            }
            super.dispose(disposeOnlyFramebuffers);
        }
    }

    ThinEngine.prototype._createHardwareRenderTargetWrapper = function (isMulti, isCube, size) {
        const rtWrapper = new WebGLRenderTargetWrapper(isMulti, isCube, size, this, this._gl);
        this._renderTargetWrapperCache.push(rtWrapper);
        return rtWrapper;
    };
    ThinEngine.prototype.createRenderTargetTexture = function (size, options) {
        var _a, _b;
        const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, size);
        let generateDepthBuffer = true;
        let generateStencilBuffer = false;
        let noColorAttachment = false;
        let colorAttachment = undefined;
        let samples = 1;
        if (options !== undefined && typeof options === "object") {
            generateDepthBuffer = (_a = options.generateDepthBuffer) !== null && _a !== void 0 ? _a : true;
            generateStencilBuffer = !!options.generateStencilBuffer;
            noColorAttachment = !!options.noColorAttachment;
            colorAttachment = options.colorAttachment;
            samples = (_b = options.samples) !== null && _b !== void 0 ? _b : 1;
        }
        const texture = colorAttachment || (noColorAttachment ? null : this._createInternalTexture(size, options, true, InternalTextureSource.RenderTarget));
        const width = size.width || size;
        const height = size.height || size;
        const currentFrameBuffer = this._currentFramebuffer;
        const gl = this._gl;
        // Create the framebuffer
        const framebuffer = gl.createFramebuffer();
        this._bindUnboundFramebuffer(framebuffer);
        rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(generateStencilBuffer, generateDepthBuffer, width, height);
        // No need to rebind on every frame
        if (texture && !texture.is2DArray) {
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture._hardwareTexture.underlyingResource, 0);
        }
        this._bindUnboundFramebuffer(currentFrameBuffer);
        rtWrapper._framebuffer = framebuffer;
        rtWrapper._generateDepthBuffer = generateDepthBuffer;
        rtWrapper._generateStencilBuffer = generateStencilBuffer;
        rtWrapper.setTextures(texture);
        this.updateRenderTargetTextureSampleCount(rtWrapper, samples);
        return rtWrapper;
    };
    ThinEngine.prototype.createDepthStencilTexture = function (size, options, rtWrapper) {
        if (options.isCube) {
            const width = size.width || size;
            return this._createDepthStencilCubeTexture(width, options, rtWrapper);
        }
        else {
            return this._createDepthStencilTexture(size, options, rtWrapper);
        }
    };
    ThinEngine.prototype._createDepthStencilTexture = function (size, options, rtWrapper) {
        const gl = this._gl;
        const layers = size.layers || 0;
        const target = layers !== 0 ? gl.TEXTURE_2D_ARRAY : gl.TEXTURE_2D;
        const internalTexture = new InternalTexture(this, InternalTextureSource.DepthStencil);
        if (!this._caps.depthTextureExtension) {
            Logger.Error("Depth texture is not supported by your browser or hardware.");
            return internalTexture;
        }
        const internalOptions = Object.assign({ bilinearFiltering: false, comparisonFunction: 0, generateStencil: false }, options);
        this._bindTextureDirectly(target, internalTexture, true);
        this._setupDepthStencilTexture(internalTexture, size, internalOptions.generateStencil, internalOptions.comparisonFunction === 0 ? false : internalOptions.bilinearFiltering, internalOptions.comparisonFunction, internalOptions.samples);
        if (internalOptions.depthTextureFormat !== undefined) {
            if (internalOptions.depthTextureFormat !== 15 &&
                internalOptions.depthTextureFormat !== 16 &&
                internalOptions.depthTextureFormat !== 17 &&
                internalOptions.depthTextureFormat !== 13 &&
                internalOptions.depthTextureFormat !== 14 &&
                internalOptions.depthTextureFormat !== 18) {
                Logger.Error("Depth texture format is not supported.");
                return internalTexture;
            }
            internalTexture.format = internalOptions.depthTextureFormat;
        }
        else {
            internalTexture.format = internalOptions.generateStencil ? 13 : 16;
        }
        const hasStencil = internalTexture.format === 17 ||
            internalTexture.format === 13 ||
            internalTexture.format === 18;
        rtWrapper._depthStencilTexture = internalTexture;
        rtWrapper._depthStencilTextureWithStencil = hasStencil;
        let type = gl.UNSIGNED_INT;
        if (internalTexture.format === 15) {
            type = gl.UNSIGNED_SHORT;
        }
        else if (internalTexture.format === 17 || internalTexture.format === 13) {
            type = gl.UNSIGNED_INT_24_8;
        }
        else if (internalTexture.format === 14) {
            type = gl.FLOAT;
        }
        else if (internalTexture.format === 18) {
            type = gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
        }
        const format = hasStencil ? gl.DEPTH_STENCIL : gl.DEPTH_COMPONENT;
        let internalFormat = format;
        if (this.webGLVersion > 1) {
            if (internalTexture.format === 15) {
                internalFormat = gl.DEPTH_COMPONENT16;
            }
            else if (internalTexture.format === 16) {
                internalFormat = gl.DEPTH_COMPONENT24;
            }
            else if (internalTexture.format === 17 || internalTexture.format === 13) {
                internalFormat = gl.DEPTH24_STENCIL8;
            }
            else if (internalTexture.format === 14) {
                internalFormat = gl.DEPTH_COMPONENT32F;
            }
            else if (internalTexture.format === 18) {
                internalFormat = gl.DEPTH32F_STENCIL8;
            }
        }
        if (internalTexture.is2DArray) {
            gl.texImage3D(target, 0, internalFormat, internalTexture.width, internalTexture.height, layers, 0, format, type, null);
        }
        else {
            gl.texImage2D(target, 0, internalFormat, internalTexture.width, internalTexture.height, 0, format, type, null);
        }
        this._bindTextureDirectly(target, null);
        this._internalTexturesCache.push(internalTexture);
        // Dispose previous depth/stencil render buffers and clear the corresponding attachment.
        // Next time this framebuffer is bound, the new depth/stencil texture will be attached.
        const glRtWrapper = rtWrapper;
        if (glRtWrapper._depthStencilBuffer) {
            const currentFrameBuffer = this._currentFramebuffer;
            this._bindUnboundFramebuffer(glRtWrapper._framebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, null);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, null);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.STENCIL_ATTACHMENT, gl.RENDERBUFFER, null);
            this._bindUnboundFramebuffer(currentFrameBuffer);
            gl.deleteRenderbuffer(glRtWrapper._depthStencilBuffer);
            glRtWrapper._depthStencilBuffer = null;
        }
        return internalTexture;
    };
    ThinEngine.prototype.updateRenderTargetTextureSampleCount = function (rtWrapper, samples) {
        if (this.webGLVersion < 2 || !rtWrapper || !rtWrapper.texture) {
            return 1;
        }
        if (rtWrapper.samples === samples) {
            return samples;
        }
        const gl = this._gl;
        samples = Math.min(samples, this.getCaps().maxMSAASamples);
        // Dispose previous render buffers
        if (rtWrapper._depthStencilBuffer) {
            gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
            rtWrapper._depthStencilBuffer = null;
        }
        if (rtWrapper._MSAAFramebuffer) {
            gl.deleteFramebuffer(rtWrapper._MSAAFramebuffer);
            rtWrapper._MSAAFramebuffer = null;
        }
        const hardwareTexture = rtWrapper.texture._hardwareTexture;
        hardwareTexture.releaseMSAARenderBuffers();
        if (samples > 1 && typeof gl.renderbufferStorageMultisample === "function") {
            const framebuffer = gl.createFramebuffer();
            if (!framebuffer) {
                throw new Error("Unable to create multi sampled framebuffer");
            }
            rtWrapper._MSAAFramebuffer = framebuffer;
            this._bindUnboundFramebuffer(rtWrapper._MSAAFramebuffer);
            const colorRenderbuffer = this._createRenderBuffer(rtWrapper.texture.width, rtWrapper.texture.height, samples, -1 /* not used */, this._getRGBAMultiSampleBufferFormat(rtWrapper.texture.type), gl.COLOR_ATTACHMENT0, false);
            if (!colorRenderbuffer) {
                throw new Error("Unable to create multi sampled framebuffer");
            }
            hardwareTexture.addMSAARenderBuffer(colorRenderbuffer);
        }
        else {
            this._bindUnboundFramebuffer(rtWrapper._framebuffer);
        }
        rtWrapper.texture.samples = samples;
        rtWrapper._samples = samples;
        rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.texture.width, rtWrapper.texture.height, samples);
        this._bindUnboundFramebuffer(null);
        return samples;
    };

    /**
     * PostProcess can be used to apply a shader to a texture after it has been rendered
     * See https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses
     */
    class PostProcess {
        /**
         * Registers a shader code processing with a post process name.
         * @param postProcessName name of the post process. Use null for the fallback shader code processing. This is the shader code processing that will be used in case no specific shader code processing has been associated to a post process name
         * @param customShaderCodeProcessing shader code processing to associate to the post process name
         * @returns
         */
        static RegisterShaderCodeProcessing(postProcessName, customShaderCodeProcessing) {
            if (!customShaderCodeProcessing) {
                delete PostProcess._CustomShaderCodeProcessing[postProcessName !== null && postProcessName !== void 0 ? postProcessName : ""];
                return;
            }
            PostProcess._CustomShaderCodeProcessing[postProcessName !== null && postProcessName !== void 0 ? postProcessName : ""] = customShaderCodeProcessing;
        }
        static _GetShaderCodeProcessing(postProcessName) {
            var _a;
            return (_a = PostProcess._CustomShaderCodeProcessing[postProcessName]) !== null && _a !== void 0 ? _a : PostProcess._CustomShaderCodeProcessing[""];
        }
        /**
         * Number of sample textures (default: 1)
         */
        get samples() {
            return this._samples;
        }
        set samples(n) {
            this._samples = Math.min(n, this._engine.getCaps().maxMSAASamples);
            this._textures.forEach((texture) => {
                texture.setSamples(this._samples);
            });
        }
        /**
         * Returns the fragment url or shader name used in the post process.
         * @returns the fragment url or name in the shader store.
         */
        getEffectName() {
            return this._fragmentUrl;
        }
        /**
         * A function that is added to the onActivateObservable
         */
        set onActivate(callback) {
            if (this._onActivateObserver) {
                this.onActivateObservable.remove(this._onActivateObserver);
            }
            if (callback) {
                this._onActivateObserver = this.onActivateObservable.add(callback);
            }
        }
        /**
         * A function that is added to the onSizeChangedObservable
         */
        set onSizeChanged(callback) {
            if (this._onSizeChangedObserver) {
                this.onSizeChangedObservable.remove(this._onSizeChangedObserver);
            }
            this._onSizeChangedObserver = this.onSizeChangedObservable.add(callback);
        }
        /**
         * A function that is added to the onApplyObservable
         */
        set onApply(callback) {
            if (this._onApplyObserver) {
                this.onApplyObservable.remove(this._onApplyObserver);
            }
            this._onApplyObserver = this.onApplyObservable.add(callback);
        }
        /**
         * A function that is added to the onBeforeRenderObservable
         */
        set onBeforeRender(callback) {
            if (this._onBeforeRenderObserver) {
                this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
            }
            this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
        }
        /**
         * A function that is added to the onAfterRenderObservable
         */
        set onAfterRender(callback) {
            if (this._onAfterRenderObserver) {
                this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
            }
            this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
        }
        /**
         * The input texture for this post process and the output texture of the previous post process. When added to a pipeline the previous post process will
         * render it's output into this texture and this texture will be used as textureSampler in the fragment shader of this post process.
         */
        get inputTexture() {
            return this._textures.data[this._currentRenderTextureInd];
        }
        set inputTexture(value) {
            this._forcedOutputTexture = value;
        }
        /**
         * Since inputTexture should always be defined, if we previously manually set `inputTexture`,
         * the only way to unset it is to use this function to restore its internal state
         */
        restoreDefaultInputTexture() {
            if (this._forcedOutputTexture) {
                this._forcedOutputTexture = null;
                this.markTextureDirty();
            }
        }
        /**
         * Gets the camera which post process is applied to.
         * @returns The camera the post process is applied to.
         */
        getCamera() {
            return this._camera;
        }
        /**
         * Gets the texel size of the postprocess.
         * See https://en.wikipedia.org/wiki/Texel_(graphics)
         */
        get texelSize() {
            if (this._shareOutputWithPostProcess) {
                return this._shareOutputWithPostProcess.texelSize;
            }
            if (this._forcedOutputTexture) {
                this._texelSize.copyFromFloats(1.0 / this._forcedOutputTexture.width, 1.0 / this._forcedOutputTexture.height);
            }
            return this._texelSize;
        }
        /**
         * Creates a new instance PostProcess
         * @param name The name of the PostProcess.
         * @param fragmentUrl The url of the fragment shader to be used.
         * @param parameters Array of the names of uniform non-sampler2D variables that will be passed to the shader.
         * @param samplers Array of the names of uniform sampler2D variables that will be passed to the shader.
         * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
         * @param camera The camera to apply the render pass to.
         * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
         * @param engine The engine which the post process will be applied. (default: current engine)
         * @param reusable If the post process can be reused on the same frame. (default: false)
         * @param defines String of defines that will be set when running the fragment shader. (default: null)
         * @param textureType Type of textures used when performing the post process. (default: 0)
         * @param vertexUrl The url of the vertex shader to be used. (default: "postprocess")
         * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
         * @param blockCompilation If the shader should not be compiled immediatly. (default: false)
         * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
         */
        constructor(name, fragmentUrl, parameters, samplers, options, camera, samplingMode = 1, engine, reusable, defines = null, textureType = 0, vertexUrl = "postprocess", indexParameters, blockCompilation = false, textureFormat = 5, shaderLanguage = ShaderLanguage.GLSL) {
            /** @internal */
            this._parentContainer = null;
            /**
             * Width of the texture to apply the post process on
             */
            this.width = -1;
            /**
             * Height of the texture to apply the post process on
             */
            this.height = -1;
            /**
             * Gets the node material used to create this postprocess (null if the postprocess was manually created)
             */
            this.nodeMaterialSource = null;
            /**
             * Internal, reference to the location where this postprocess was output to. (Typically the texture on the next postprocess in the chain)
             * @internal
             */
            this._outputTexture = null;
            /**
             * If the buffer needs to be cleared before applying the post process. (default: true)
             * Should be set to false if shader will overwrite all previous pixels.
             */
            this.autoClear = true;
            /**
             * If clearing the buffer should be forced in autoClear mode, even when alpha mode is enabled (default: false).
             * By default, the buffer will only be cleared if alpha mode is disabled (and autoClear is true).
             */
            this.forceAutoClearInAlphaMode = false;
            /**
             * Type of alpha mode to use when performing the post process (default: Engine.ALPHA_DISABLE)
             */
            this.alphaMode = 0;
            /**
             * Animations to be used for the post processing
             */
            this.animations = new Array();
            /**
             * Enable Pixel Perfect mode where texture is not scaled to be power of 2.
             * Can only be used on a single postprocess or on the last one of a chain. (default: false)
             */
            this.enablePixelPerfectMode = false;
            /**
             * Force the postprocess to be applied without taking in account viewport
             */
            this.forceFullscreenViewport = true;
            /**
             * Scale mode for the post process (default: Engine.SCALEMODE_FLOOR)
             *
             * | Value | Type                                | Description |
             * | ----- | ----------------------------------- | ----------- |
             * | 1     | SCALEMODE_FLOOR                     | [engine.scalemode_floor](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_floor) |
             * | 2     | SCALEMODE_NEAREST                   | [engine.scalemode_nearest](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_nearest) |
             * | 3     | SCALEMODE_CEILING                   | [engine.scalemode_ceiling](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_ceiling) |
             *
             */
            this.scaleMode = 1;
            /**
             * Force textures to be a power of two (default: false)
             */
            this.alwaysForcePOT = false;
            this._samples = 1;
            /**
             * Modify the scale of the post process to be the same as the viewport (default: false)
             */
            this.adaptScaleToCurrentViewport = false;
            this._reusable = false;
            this._renderId = 0;
            /**
             * if externalTextureSamplerBinding is true, the "apply" method won't bind the textureSampler texture, it is expected to be done by the "outside" (by the onApplyObservable observer most probably).
             * counter-productive in some cases because if the texture bound by "apply" is different from the currently texture bound, (the one set by the onApplyObservable observer, for eg) some
             * internal structures (materialContext) will be dirtified, which may impact performances
             */
            this.externalTextureSamplerBinding = false;
            /**
             * Smart array of input and output textures for the post process.
             * @internal
             */
            this._textures = new SmartArray(2);
            /**
             * Smart array of input and output textures for the post process.
             * @internal
             */
            this._textureCache = [];
            /**
             * The index in _textures that corresponds to the output texture.
             * @internal
             */
            this._currentRenderTextureInd = 0;
            this._scaleRatio = new Vector2(1, 1);
            this._texelSize = Vector2.Zero();
            // Events
            /**
             * An event triggered when the postprocess is activated.
             */
            this.onActivateObservable = new Observable$1();
            /**
             * An event triggered when the postprocess changes its size.
             */
            this.onSizeChangedObservable = new Observable$1();
            /**
             * An event triggered when the postprocess applies its effect.
             */
            this.onApplyObservable = new Observable$1();
            /**
             * An event triggered before rendering the postprocess
             */
            this.onBeforeRenderObservable = new Observable$1();
            /**
             * An event triggered after rendering the postprocess
             */
            this.onAfterRenderObservable = new Observable$1();
            this.name = name;
            if (camera != null) {
                this._camera = camera;
                this._scene = camera.getScene();
                camera.attachPostProcess(this);
                this._engine = this._scene.getEngine();
                this._scene.postProcesses.push(this);
                this.uniqueId = this._scene.getUniqueId();
            }
            else if (engine) {
                this._engine = engine;
                this._engine.postProcesses.push(this);
            }
            this._options = options;
            this.renderTargetSamplingMode = samplingMode ? samplingMode : 1;
            this._reusable = reusable || false;
            this._textureType = textureType;
            this._textureFormat = textureFormat;
            this._shaderLanguage = shaderLanguage;
            this._samplers = samplers || [];
            this._samplers.push("textureSampler");
            this._fragmentUrl = fragmentUrl;
            this._vertexUrl = vertexUrl;
            this._parameters = parameters || [];
            this._parameters.push("scale");
            this._indexParameters = indexParameters;
            this._drawWrapper = new DrawWrapper(this._engine);
            if (!blockCompilation) {
                this.updateEffect(defines);
            }
        }
        /**
         * Gets a string identifying the name of the class
         * @returns "PostProcess" string
         */
        getClassName() {
            return "PostProcess";
        }
        /**
         * Gets the engine which this post process belongs to.
         * @returns The engine the post process was enabled with.
         */
        getEngine() {
            return this._engine;
        }
        /**
         * The effect that is created when initializing the post process.
         * @returns The created effect corresponding the the postprocess.
         */
        getEffect() {
            return this._drawWrapper.effect;
        }
        /**
         * To avoid multiple redundant textures for multiple post process, the output the output texture for this post process can be shared with another.
         * @param postProcess The post process to share the output with.
         * @returns This post process.
         */
        shareOutputWith(postProcess) {
            this._disposeTextures();
            this._shareOutputWithPostProcess = postProcess;
            return this;
        }
        /**
         * Reverses the effect of calling shareOutputWith and returns the post process back to its original state.
         * This should be called if the post process that shares output with this post process is disabled/disposed.
         */
        useOwnOutput() {
            if (this._textures.length == 0) {
                this._textures = new SmartArray(2);
            }
            this._shareOutputWithPostProcess = null;
        }
        /**
         * Updates the effect with the current post process compile time values and recompiles the shader.
         * @param defines Define statements that should be added at the beginning of the shader. (default: null)
         * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
         * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
         * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
         * @param onCompiled Called when the shader has been compiled.
         * @param onError Called if there is an error when compiling a shader.
         * @param vertexUrl The url of the vertex shader to be used (default: the one given at construction time)
         * @param fragmentUrl The url of the fragment shader to be used (default: the one given at construction time)
         */
        updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError, vertexUrl, fragmentUrl) {
            var _a, _b;
            const customShaderCodeProcessing = PostProcess._GetShaderCodeProcessing(this.name);
            if (customShaderCodeProcessing === null || customShaderCodeProcessing === void 0 ? void 0 : customShaderCodeProcessing.defineCustomBindings) {
                const newUniforms = (_a = uniforms === null || uniforms === void 0 ? void 0 : uniforms.slice()) !== null && _a !== void 0 ? _a : [];
                newUniforms.push(...this._parameters);
                const newSamplers = (_b = samplers === null || samplers === void 0 ? void 0 : samplers.slice()) !== null && _b !== void 0 ? _b : [];
                newSamplers.push(...this._samplers);
                defines = customShaderCodeProcessing.defineCustomBindings(this.name, defines, newUniforms, newSamplers);
                uniforms = newUniforms;
                samplers = newSamplers;
            }
            this._postProcessDefines = defines;
            this._drawWrapper.effect = this._engine.createEffect({ vertex: vertexUrl !== null && vertexUrl !== void 0 ? vertexUrl : this._vertexUrl, fragment: fragmentUrl !== null && fragmentUrl !== void 0 ? fragmentUrl : this._fragmentUrl }, {
                attributes: ["position"],
                uniformsNames: uniforms || this._parameters,
                uniformBuffersNames: [],
                samplers: samplers || this._samplers,
                defines: defines !== null ? defines : "",
                fallbacks: null,
                onCompiled: onCompiled !== null && onCompiled !== void 0 ? onCompiled : null,
                onError: onError !== null && onError !== void 0 ? onError : null,
                indexParameters: indexParameters || this._indexParameters,
                processCodeAfterIncludes: (customShaderCodeProcessing === null || customShaderCodeProcessing === void 0 ? void 0 : customShaderCodeProcessing.processCodeAfterIncludes)
                    ? (shaderType, code) => customShaderCodeProcessing.processCodeAfterIncludes(this.name, shaderType, code)
                    : null,
                processFinalCode: (customShaderCodeProcessing === null || customShaderCodeProcessing === void 0 ? void 0 : customShaderCodeProcessing.processFinalCode)
                    ? (shaderType, code) => customShaderCodeProcessing.processFinalCode(this.name, shaderType, code)
                    : null,
                shaderLanguage: this._shaderLanguage,
            }, this._engine);
        }
        /**
         * The post process is reusable if it can be used multiple times within one frame.
         * @returns If the post process is reusable
         */
        isReusable() {
            return this._reusable;
        }
        /** invalidate frameBuffer to hint the postprocess to create a depth buffer */
        markTextureDirty() {
            this.width = -1;
        }
        _createRenderTargetTexture(textureSize, textureOptions, channel = 0) {
            for (let i = 0; i < this._textureCache.length; i++) {
                if (this._textureCache[i].texture.width === textureSize.width &&
                    this._textureCache[i].texture.height === textureSize.height &&
                    this._textureCache[i].postProcessChannel === channel &&
                    this._textureCache[i].texture._generateDepthBuffer === textureOptions.generateDepthBuffer &&
                    this._textureCache[i].texture.samples === textureOptions.samples) {
                    return this._textureCache[i].texture;
                }
            }
            const tex = this._engine.createRenderTargetTexture(textureSize, textureOptions);
            this._textureCache.push({ texture: tex, postProcessChannel: channel, lastUsedRenderId: -1 });
            return tex;
        }
        _flushTextureCache() {
            const currentRenderId = this._renderId;
            for (let i = this._textureCache.length - 1; i >= 0; i--) {
                if (currentRenderId - this._textureCache[i].lastUsedRenderId > 100) {
                    let currentlyUsed = false;
                    for (let j = 0; j < this._textures.length; j++) {
                        if (this._textures.data[j] === this._textureCache[i].texture) {
                            currentlyUsed = true;
                            break;
                        }
                    }
                    if (!currentlyUsed) {
                        this._textureCache[i].texture.dispose();
                        this._textureCache.splice(i, 1);
                    }
                }
            }
        }
        _resize(width, height, camera, needMipMaps, forceDepthStencil) {
            if (this._textures.length > 0) {
                this._textures.reset();
            }
            this.width = width;
            this.height = height;
            let firstPP = null;
            for (let i = 0; i < camera._postProcesses.length; i++) {
                if (camera._postProcesses[i] !== null) {
                    firstPP = camera._postProcesses[i];
                    break;
                }
            }
            const textureSize = { width: this.width, height: this.height };
            const textureOptions = {
                generateMipMaps: needMipMaps,
                generateDepthBuffer: forceDepthStencil || firstPP === this,
                generateStencilBuffer: (forceDepthStencil || firstPP === this) && this._engine.isStencilEnable,
                samplingMode: this.renderTargetSamplingMode,
                type: this._textureType,
                format: this._textureFormat,
                samples: this._samples,
                label: "PostProcessRTT-" + this.name,
            };
            this._textures.push(this._createRenderTargetTexture(textureSize, textureOptions, 0));
            if (this._reusable) {
                this._textures.push(this._createRenderTargetTexture(textureSize, textureOptions, 1));
            }
            this._texelSize.copyFromFloats(1.0 / this.width, 1.0 / this.height);
            this.onSizeChangedObservable.notifyObservers(this);
        }
        /**
         * Activates the post process by intializing the textures to be used when executed. Notifies onActivateObservable.
         * When this post process is used in a pipeline, this is call will bind the input texture of this post process to the output of the previous.
         * @param camera The camera that will be used in the post process. This camera will be used when calling onActivateObservable.
         * @param sourceTexture The source texture to be inspected to get the width and height if not specified in the post process constructor. (default: null)
         * @param forceDepthStencil If true, a depth and stencil buffer will be generated. (default: false)
         * @returns The render target wrapper that was bound to be written to.
         */
        activate(camera, sourceTexture = null, forceDepthStencil) {
            var _a, _b;
            camera = camera || this._camera;
            const scene = camera.getScene();
            const engine = scene.getEngine();
            const maxSize = engine.getCaps().maxTextureSize;
            let requiredWidth = ((sourceTexture ? sourceTexture.width : this._engine.getRenderWidth(true)) * this._options) | 0;
            const requiredHeight = ((sourceTexture ? sourceTexture.height : this._engine.getRenderHeight(true)) * this._options) | 0;
            // If rendering to a webvr camera's left or right eye only half the width should be used to avoid resize when rendered to screen
            const webVRCamera = camera.parent;
            if (webVRCamera && (webVRCamera.leftCamera == camera || webVRCamera.rightCamera == camera)) {
                requiredWidth /= 2;
            }
            let desiredWidth = this._options.width || requiredWidth;
            let desiredHeight = this._options.height || requiredHeight;
            const needMipMaps = this.renderTargetSamplingMode !== 7 &&
                this.renderTargetSamplingMode !== 1 &&
                this.renderTargetSamplingMode !== 2;
            if (!this._shareOutputWithPostProcess && !this._forcedOutputTexture) {
                if (this.adaptScaleToCurrentViewport) {
                    const currentViewport = engine.currentViewport;
                    if (currentViewport) {
                        desiredWidth *= currentViewport.width;
                        desiredHeight *= currentViewport.height;
                    }
                }
                if (needMipMaps || this.alwaysForcePOT) {
                    if (!this._options.width) {
                        desiredWidth = engine.needPOTTextures ? Engine.GetExponentOfTwo(desiredWidth, maxSize, this.scaleMode) : desiredWidth;
                    }
                    if (!this._options.height) {
                        desiredHeight = engine.needPOTTextures ? Engine.GetExponentOfTwo(desiredHeight, maxSize, this.scaleMode) : desiredHeight;
                    }
                }
                if (this.width !== desiredWidth || this.height !== desiredHeight) {
                    this._resize(desiredWidth, desiredHeight, camera, needMipMaps, forceDepthStencil);
                }
                this._textures.forEach((texture) => {
                    if (texture.samples !== this.samples) {
                        this._engine.updateRenderTargetTextureSampleCount(texture, this.samples);
                    }
                });
                this._flushTextureCache();
                this._renderId++;
            }
            let target;
            if (this._shareOutputWithPostProcess) {
                target = this._shareOutputWithPostProcess.inputTexture;
            }
            else if (this._forcedOutputTexture) {
                target = this._forcedOutputTexture;
                this.width = this._forcedOutputTexture.width;
                this.height = this._forcedOutputTexture.height;
            }
            else {
                target = this.inputTexture;
                let cache;
                for (let i = 0; i < this._textureCache.length; i++) {
                    if (this._textureCache[i].texture === target) {
                        cache = this._textureCache[i];
                        break;
                    }
                }
                if (cache) {
                    cache.lastUsedRenderId = this._renderId;
                }
            }
            // Bind the input of this post process to be used as the output of the previous post process.
            if (this.enablePixelPerfectMode) {
                this._scaleRatio.copyFromFloats(requiredWidth / desiredWidth, requiredHeight / desiredHeight);
                this._engine.bindFramebuffer(target, 0, requiredWidth, requiredHeight, this.forceFullscreenViewport);
            }
            else {
                this._scaleRatio.copyFromFloats(1, 1);
                this._engine.bindFramebuffer(target, 0, undefined, undefined, this.forceFullscreenViewport);
            }
            (_b = (_a = this._engine)._debugInsertMarker) === null || _b === void 0 ? void 0 : _b.call(_a, `post process ${this.name} input`);
            this.onActivateObservable.notifyObservers(camera);
            // Clear
            if (this.autoClear && (this.alphaMode === 0 || this.forceAutoClearInAlphaMode)) {
                this._engine.clear(this.clearColor ? this.clearColor : scene.clearColor, scene._allowPostProcessClearColor, true, true);
            }
            if (this._reusable) {
                this._currentRenderTextureInd = (this._currentRenderTextureInd + 1) % 2;
            }
            return target;
        }
        /**
         * If the post process is supported.
         */
        get isSupported() {
            return this._drawWrapper.effect.isSupported;
        }
        /**
         * The aspect ratio of the output texture.
         */
        get aspectRatio() {
            if (this._shareOutputWithPostProcess) {
                return this._shareOutputWithPostProcess.aspectRatio;
            }
            if (this._forcedOutputTexture) {
                return this._forcedOutputTexture.width / this._forcedOutputTexture.height;
            }
            return this.width / this.height;
        }
        /**
         * Get a value indicating if the post-process is ready to be used
         * @returns true if the post-process is ready (shader is compiled)
         */
        isReady() {
            var _a, _b;
            return (_b = (_a = this._drawWrapper.effect) === null || _a === void 0 ? void 0 : _a.isReady()) !== null && _b !== void 0 ? _b : false;
        }
        /**
         * Binds all textures and uniforms to the shader, this will be run on every pass.
         * @returns the effect corresponding to this post process. Null if not compiled or not ready.
         */
        apply() {
            var _a, _b, _c;
            // Check
            if (!((_a = this._drawWrapper.effect) === null || _a === void 0 ? void 0 : _a.isReady())) {
                return null;
            }
            // States
            this._engine.enableEffect(this._drawWrapper);
            this._engine.setState(false);
            this._engine.setDepthBuffer(false);
            this._engine.setDepthWrite(false);
            // Alpha
            this._engine.setAlphaMode(this.alphaMode);
            if (this.alphaConstants) {
                this.getEngine().setAlphaConstants(this.alphaConstants.r, this.alphaConstants.g, this.alphaConstants.b, this.alphaConstants.a);
            }
            // Bind the output texture of the preivous post process as the input to this post process.
            let source;
            if (this._shareOutputWithPostProcess) {
                source = this._shareOutputWithPostProcess.inputTexture;
            }
            else if (this._forcedOutputTexture) {
                source = this._forcedOutputTexture;
            }
            else {
                source = this.inputTexture;
            }
            if (!this.externalTextureSamplerBinding) {
                this._drawWrapper.effect._bindTexture("textureSampler", source === null || source === void 0 ? void 0 : source.texture);
            }
            // Parameters
            this._drawWrapper.effect.setVector2("scale", this._scaleRatio);
            this.onApplyObservable.notifyObservers(this._drawWrapper.effect);
            (_c = (_b = PostProcess._GetShaderCodeProcessing(this.name)) === null || _b === void 0 ? void 0 : _b.bindCustomBindings) === null || _c === void 0 ? void 0 : _c.call(_b, this.name, this._drawWrapper.effect);
            return this._drawWrapper.effect;
        }
        _disposeTextures() {
            if (this._shareOutputWithPostProcess || this._forcedOutputTexture) {
                this._disposeTextureCache();
                return;
            }
            this._disposeTextureCache();
            this._textures.dispose();
        }
        _disposeTextureCache() {
            for (let i = this._textureCache.length - 1; i >= 0; i--) {
                this._textureCache[i].texture.dispose();
            }
            this._textureCache.length = 0;
        }
        /**
         * Sets the required values to the prepass renderer.
         * @param prePassRenderer defines the prepass renderer to setup.
         * @returns true if the pre pass is needed.
         */
        setPrePassRenderer(prePassRenderer) {
            if (this._prePassEffectConfiguration) {
                this._prePassEffectConfiguration = prePassRenderer.addEffectConfiguration(this._prePassEffectConfiguration);
                this._prePassEffectConfiguration.enabled = true;
                return true;
            }
            return false;
        }
        /**
         * Disposes the post process.
         * @param camera The camera to dispose the post process on.
         */
        dispose(camera) {
            camera = camera || this._camera;
            this._disposeTextures();
            let index;
            if (this._scene) {
                index = this._scene.postProcesses.indexOf(this);
                if (index !== -1) {
                    this._scene.postProcesses.splice(index, 1);
                }
            }
            if (this._parentContainer) {
                const index = this._parentContainer.postProcesses.indexOf(this);
                if (index > -1) {
                    this._parentContainer.postProcesses.splice(index, 1);
                }
                this._parentContainer = null;
            }
            index = this._engine.postProcesses.indexOf(this);
            if (index !== -1) {
                this._engine.postProcesses.splice(index, 1);
            }
            if (!camera) {
                return;
            }
            camera.detachPostProcess(this);
            index = camera._postProcesses.indexOf(this);
            if (index === 0 && camera._postProcesses.length > 0) {
                const firstPostProcess = this._camera._getFirstPostProcess();
                if (firstPostProcess) {
                    firstPostProcess.markTextureDirty();
                }
            }
            this.onActivateObservable.clear();
            this.onAfterRenderObservable.clear();
            this.onApplyObservable.clear();
            this.onBeforeRenderObservable.clear();
            this.onSizeChangedObservable.clear();
        }
        /**
         * Serializes the post process to a JSON object
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this);
            const camera = this.getCamera() || (this._scene && this._scene.activeCamera);
            serializationObject.customType = "BABYLON." + this.getClassName();
            serializationObject.cameraId = camera ? camera.id : null;
            serializationObject.reusable = this._reusable;
            serializationObject.textureType = this._textureType;
            serializationObject.fragmentUrl = this._fragmentUrl;
            serializationObject.parameters = this._parameters;
            serializationObject.samplers = this._samplers;
            serializationObject.options = this._options;
            serializationObject.defines = this._postProcessDefines;
            serializationObject.textureFormat = this._textureFormat;
            serializationObject.vertexUrl = this._vertexUrl;
            serializationObject.indexParameters = this._indexParameters;
            return serializationObject;
        }
        /**
         * Clones this post process
         * @returns a new post process similar to this one
         */
        clone() {
            const serializationObject = this.serialize();
            serializationObject._engine = this._engine;
            serializationObject.cameraId = null;
            const result = PostProcess.Parse(serializationObject, this._scene, "");
            if (!result) {
                return null;
            }
            result.onActivateObservable = this.onActivateObservable.clone();
            result.onSizeChangedObservable = this.onSizeChangedObservable.clone();
            result.onApplyObservable = this.onApplyObservable.clone();
            result.onBeforeRenderObservable = this.onBeforeRenderObservable.clone();
            result.onAfterRenderObservable = this.onAfterRenderObservable.clone();
            result._prePassEffectConfiguration = this._prePassEffectConfiguration;
            return result;
        }
        /**
         * Creates a material from parsed material data
         * @param parsedPostProcess defines parsed post process data
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures
         * @returns a new post process
         */
        static Parse(parsedPostProcess, scene, rootUrl) {
            const postProcessType = GetClass(parsedPostProcess.customType);
            if (!postProcessType || !postProcessType._Parse) {
                return null;
            }
            const camera = scene ? scene.getCameraById(parsedPostProcess.cameraId) : null;
            return postProcessType._Parse(parsedPostProcess, camera, scene, rootUrl);
        }
        /**
         * @internal
         */
        static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
            return SerializationHelper.Parse(() => {
                return new PostProcess(parsedPostProcess.name, parsedPostProcess.fragmentUrl, parsedPostProcess.parameters, parsedPostProcess.samplers, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable, parsedPostProcess.defines, parsedPostProcess.textureType, parsedPostProcess.vertexUrl, parsedPostProcess.indexParameters, false, parsedPostProcess.textureFormat);
            }, parsedPostProcess, scene, rootUrl);
        }
    }
    PostProcess._CustomShaderCodeProcessing = {};
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "uniqueId", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "name", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "width", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "height", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "renderTargetSamplingMode", void 0);
    __decorate$1([
        serializeAsColor4()
    ], PostProcess.prototype, "clearColor", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "autoClear", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "forceAutoClearInAlphaMode", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "alphaMode", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "alphaConstants", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "enablePixelPerfectMode", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "forceFullscreenViewport", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "scaleMode", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "alwaysForcePOT", void 0);
    __decorate$1([
        serialize("samples")
    ], PostProcess.prototype, "_samples", void 0);
    __decorate$1([
        serialize()
    ], PostProcess.prototype, "adaptScaleToCurrentViewport", void 0);
    RegisterClass("BABYLON.PostProcess", PostProcess);

    // Do not edit.
    const name$10 = "rgbdDecodePixelShader";
    const shader$10 = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<helperFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=vec4(fromRGBD(texture2D(textureSampler,vUV)),1.0);}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$10] = shader$10;

    ThinEngine.prototype.createRenderTargetCubeTexture = function (size, options) {
        const rtWrapper = this._createHardwareRenderTargetWrapper(false, true, size);
        const fullOptions = Object.assign({ generateMipMaps: true, generateDepthBuffer: true, generateStencilBuffer: false, type: 0, samplingMode: 3, format: 5 }, options);
        fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && fullOptions.generateStencilBuffer;
        if (fullOptions.type === 1 && !this._caps.textureFloatLinearFiltering) {
            // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
            fullOptions.samplingMode = 1;
        }
        else if (fullOptions.type === 2 && !this._caps.textureHalfFloatLinearFiltering) {
            // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
            fullOptions.samplingMode = 1;
        }
        const gl = this._gl;
        const texture = new InternalTexture(this, InternalTextureSource.RenderTarget);
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        const filters = this._getSamplingParameters(fullOptions.samplingMode, fullOptions.generateMipMaps);
        if (fullOptions.type === 1 && !this._caps.textureFloat) {
            fullOptions.type = 0;
            Logger.Warn("Float textures are not supported. Cube render target forced to TEXTURETYPE_UNESIGNED_BYTE type");
        }
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, filters.min);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        for (let face = 0; face < 6; face++) {
            gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, this._getRGBABufferInternalSizedFormat(fullOptions.type, fullOptions.format), size, size, 0, this._getInternalFormat(fullOptions.format), this._getWebGLTextureType(fullOptions.type), null);
        }
        // Create the framebuffer
        const framebuffer = gl.createFramebuffer();
        this._bindUnboundFramebuffer(framebuffer);
        rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(fullOptions.generateStencilBuffer, fullOptions.generateDepthBuffer, size, size);
        // MipMaps
        if (fullOptions.generateMipMaps) {
            gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        }
        // Unbind
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
        this._bindUnboundFramebuffer(null);
        rtWrapper._framebuffer = framebuffer;
        rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
        rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer;
        texture.width = size;
        texture.height = size;
        texture.isReady = true;
        texture.isCube = true;
        texture.samples = 1;
        texture.generateMipMaps = fullOptions.generateMipMaps;
        texture.samplingMode = fullOptions.samplingMode;
        texture.type = fullOptions.type;
        texture.format = fullOptions.format;
        this._internalTexturesCache.push(texture);
        rtWrapper.setTextures(texture);
        return rtWrapper;
    };

    // Fullscreen quad buffers by default.
    const defaultOptions = {
        positions: [1, 1, -1, 1, -1, -1, 1, -1],
        indices: [0, 1, 2, 0, 2, 3],
    };
    /**
     * Helper class to render one or more effects.
     * You can access the previous rendering in your shader by declaring a sampler named textureSampler
     */
    class EffectRenderer {
        /**
         * Creates an effect renderer
         * @param engine the engine to use for rendering
         * @param options defines the options of the effect renderer
         */
        constructor(engine, options = defaultOptions) {
            var _a, _b;
            this._fullscreenViewport = new Viewport(0, 0, 1, 1);
            const positions = (_a = options.positions) !== null && _a !== void 0 ? _a : defaultOptions.positions;
            const indices = (_b = options.indices) !== null && _b !== void 0 ? _b : defaultOptions.indices;
            this.engine = engine;
            this._vertexBuffers = {
                [VertexBuffer.PositionKind]: new VertexBuffer(engine, positions, VertexBuffer.PositionKind, false, false, 2),
            };
            this._indexBuffer = engine.createIndexBuffer(indices);
            this._onContextRestoredObserver = engine.onContextRestoredObservable.add(() => {
                this._indexBuffer = engine.createIndexBuffer(indices);
                for (const key in this._vertexBuffers) {
                    const vertexBuffer = this._vertexBuffers[key];
                    vertexBuffer._rebuild();
                }
            });
        }
        /**
         * Sets the current viewport in normalized coordinates 0-1
         * @param viewport Defines the viewport to set (defaults to 0 0 1 1)
         */
        setViewport(viewport = this._fullscreenViewport) {
            this.engine.setViewport(viewport);
        }
        /**
         * Binds the embedded attributes buffer to the effect.
         * @param effect Defines the effect to bind the attributes for
         */
        bindBuffers(effect) {
            this.engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
        }
        /**
         * Sets the current effect wrapper to use during draw.
         * The effect needs to be ready before calling this api.
         * This also sets the default full screen position attribute.
         * @param effectWrapper Defines the effect to draw with
         */
        applyEffectWrapper(effectWrapper) {
            this.engine.setState(true);
            this.engine.depthCullingState.depthTest = false;
            this.engine.stencilState.stencilTest = false;
            this.engine.enableEffect(effectWrapper._drawWrapper);
            this.bindBuffers(effectWrapper.effect);
            effectWrapper.onApplyObservable.notifyObservers({});
        }
        /**
         * Saves engine states
         */
        saveStates() {
            this._savedStateDepthTest = this.engine.depthCullingState.depthTest;
            this._savedStateStencilTest = this.engine.stencilState.stencilTest;
        }
        /**
         * Restores engine states
         */
        restoreStates() {
            this.engine.depthCullingState.depthTest = this._savedStateDepthTest;
            this.engine.stencilState.stencilTest = this._savedStateStencilTest;
        }
        /**
         * Draws a full screen quad.
         */
        draw() {
            this.engine.drawElementsType(0, 0, 6);
        }
        _isRenderTargetTexture(texture) {
            return texture.renderTarget !== undefined;
        }
        /**
         * renders one or more effects to a specified texture
         * @param effectWrapper the effect to renderer
         * @param outputTexture texture to draw to, if null it will render to the screen.
         */
        render(effectWrapper, outputTexture = null) {
            // Ensure effect is ready
            if (!effectWrapper.effect.isReady()) {
                return;
            }
            this.saveStates();
            // Reset state
            this.setViewport();
            const out = outputTexture === null ? null : this._isRenderTargetTexture(outputTexture) ? outputTexture.renderTarget : outputTexture;
            if (out) {
                this.engine.bindFramebuffer(out);
            }
            this.applyEffectWrapper(effectWrapper);
            this.draw();
            if (out) {
                this.engine.unBindFramebuffer(out);
            }
            this.restoreStates();
        }
        /**
         * Disposes of the effect renderer
         */
        dispose() {
            const vertexBuffer = this._vertexBuffers[VertexBuffer.PositionKind];
            if (vertexBuffer) {
                vertexBuffer.dispose();
                delete this._vertexBuffers[VertexBuffer.PositionKind];
            }
            if (this._indexBuffer) {
                this.engine._releaseBuffer(this._indexBuffer);
            }
            if (this._onContextRestoredObserver) {
                this.engine.onContextRestoredObservable.remove(this._onContextRestoredObserver);
                this._onContextRestoredObserver = null;
            }
        }
    }
    /**
     * Wraps an effect to be used for rendering
     */
    class EffectWrapper {
        /**
         * The underlying effect
         */
        get effect() {
            return this._drawWrapper.effect;
        }
        set effect(effect) {
            this._drawWrapper.effect = effect;
        }
        /**
         * Creates an effect to be renderer
         * @param creationOptions options to create the effect
         */
        constructor(creationOptions) {
            /**
             * Event that is fired right before the effect is drawn (should be used to update uniforms)
             */
            this.onApplyObservable = new Observable$1();
            let effectCreationOptions;
            const uniformNames = creationOptions.uniformNames || [];
            if (creationOptions.vertexShader) {
                effectCreationOptions = {
                    fragmentSource: creationOptions.fragmentShader,
                    vertexSource: creationOptions.vertexShader,
                    spectorName: creationOptions.name || "effectWrapper",
                };
            }
            else {
                // Default scale to use in post process vertex shader.
                uniformNames.push("scale");
                effectCreationOptions = {
                    fragmentSource: creationOptions.fragmentShader,
                    vertex: "postprocess",
                    spectorName: creationOptions.name || "effectWrapper",
                };
                // Sets the default scale to identity for the post process vertex shader.
                this.onApplyObservable.add(() => {
                    this.effect.setFloat2("scale", 1, 1);
                });
            }
            const defines = creationOptions.defines ? creationOptions.defines.join("\n") : "";
            this._drawWrapper = new DrawWrapper(creationOptions.engine);
            if (creationOptions.useShaderStore) {
                effectCreationOptions.fragment = effectCreationOptions.fragmentSource;
                if (!effectCreationOptions.vertex) {
                    effectCreationOptions.vertex = effectCreationOptions.vertexSource;
                }
                delete effectCreationOptions.fragmentSource;
                delete effectCreationOptions.vertexSource;
                this.effect = creationOptions.engine.createEffect(effectCreationOptions, creationOptions.attributeNames || ["position"], uniformNames, creationOptions.samplerNames, defines, undefined, creationOptions.onCompiled, undefined, undefined, creationOptions.shaderLanguage);
            }
            else {
                this.effect = new Effect(effectCreationOptions, creationOptions.attributeNames || ["position"], uniformNames, creationOptions.samplerNames, creationOptions.engine, defines, undefined, creationOptions.onCompiled, undefined, undefined, undefined, creationOptions.shaderLanguage);
                this._onContextRestoredObserver = creationOptions.engine.onContextRestoredObservable.add(() => {
                    this.effect._pipelineContext = null; // because _prepareEffect will try to dispose this pipeline before recreating it and that would lead to webgl errors
                    this.effect._wasPreviouslyReady = false;
                    this.effect._prepareEffect();
                });
            }
        }
        /**
         * Disposes of the effect wrapper
         */
        dispose() {
            if (this._onContextRestoredObserver) {
                this.effect.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
                this._onContextRestoredObserver = null;
            }
            this.effect.dispose();
        }
    }

    // Do not edit.
    const name$11 = "passPixelShader";
    const shader$11 = `varying vec2 vUV;uniform sampler2D textureSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=texture2D(textureSampler,vUV);}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$11] = shader$11;
    /** @internal */
    const passPixelShader = { name: name$11, shader: shader$11 };

    /**
     * Class containing a set of static utilities functions to dump data from a canvas
     */
    class DumpTools {
        static _CreateDumpRenderer() {
            if (!DumpTools._DumpToolsEngine) {
                let canvas = new OffscreenCanvas(100, 100); // will be resized later
                let engine = null;
                const options = {
                    preserveDrawingBuffer: true,
                    depth: false,
                    stencil: false,
                    alpha: true,
                    premultipliedAlpha: false,
                    antialias: false,
                    failIfMajorPerformanceCaveat: false,
                };
                try {
                    engine = new ThinEngine(canvas, false, options);
                }
                catch (e) {
                    // The browser does not support WebGL context in OffscreenCanvas, fallback on a regular canvas
                    canvas = document.createElement("canvas");
                    engine = new ThinEngine(canvas, false, options);
                }
                engine.getCaps().parallelShaderCompile = undefined;
                const renderer = new EffectRenderer(engine);
                const wrapper = new EffectWrapper({
                    engine,
                    name: passPixelShader.name,
                    fragmentShader: passPixelShader.shader,
                    samplerNames: ["textureSampler"],
                });
                DumpTools._DumpToolsEngine = {
                    canvas,
                    engine,
                    renderer,
                    wrapper,
                };
            }
            return DumpTools._DumpToolsEngine;
        }
        /**
         * Dumps the current bound framebuffer
         * @param width defines the rendering width
         * @param height defines the rendering height
         * @param engine defines the hosting engine
         * @param successCallback defines the callback triggered once the data are available
         * @param mimeType defines the mime type of the result
         * @param fileName defines the filename to download. If present, the result will automatically be downloaded
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         * @returns a void promise
         */
        static async DumpFramebuffer(width, height, engine, successCallback, mimeType = "image/png", fileName, quality) {
            // Read the contents of the framebuffer
            const bufferView = await engine.readPixels(0, 0, width, height);
            const data = new Uint8Array(bufferView.buffer);
            DumpTools.DumpData(width, height, data, successCallback, mimeType, fileName, true, undefined, quality);
        }
        /**
         * Dumps an array buffer
         * @param width defines the rendering width
         * @param height defines the rendering height
         * @param data the data array
         * @param mimeType defines the mime type of the result
         * @param fileName defines the filename to download. If present, the result will automatically be downloaded
         * @param invertY true to invert the picture in the Y dimension
         * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         * @returns a promise that resolve to the final data
         */
        static DumpDataAsync(width, height, data, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
            return new Promise((resolve) => {
                DumpTools.DumpData(width, height, data, (result) => resolve(result), mimeType, fileName, invertY, toArrayBuffer, quality);
            });
        }
        /**
         * Dumps an array buffer
         * @param width defines the rendering width
         * @param height defines the rendering height
         * @param data the data array
         * @param successCallback defines the callback triggered once the data are available
         * @param mimeType defines the mime type of the result
         * @param fileName defines the filename to download. If present, the result will automatically be downloaded
         * @param invertY true to invert the picture in the Y dimension
         * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
         * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
         */
        static DumpData(width, height, data, successCallback, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
            const renderer = DumpTools._CreateDumpRenderer();
            renderer.engine.setSize(width, height, true);
            // Convert if data are float32
            if (data instanceof Float32Array) {
                const data2 = new Uint8Array(data.length);
                let n = data.length;
                while (n--) {
                    const v = data[n];
                    data2[n] = Math.round(Scalar.Clamp(v) * 255);
                }
                data = data2;
            }
            // Create the image
            const texture = renderer.engine.createRawTexture(data, width, height, 5, false, !invertY, 1);
            renderer.renderer.setViewport();
            renderer.renderer.applyEffectWrapper(renderer.wrapper);
            renderer.wrapper.effect._bindTexture("textureSampler", texture);
            renderer.renderer.draw();
            if (toArrayBuffer) {
                Tools.ToBlob(renderer.canvas, (blob) => {
                    const fileReader = new FileReader();
                    fileReader.onload = (event) => {
                        const arrayBuffer = event.target.result;
                        if (successCallback) {
                            successCallback(arrayBuffer);
                        }
                    };
                    fileReader.readAsArrayBuffer(blob);
                }, mimeType, quality);
            }
            else {
                Tools.EncodeScreenshotCanvasData(renderer.canvas, successCallback, mimeType, fileName, quality);
            }
            texture.dispose();
        }
        /**
         * Dispose the dump tools associated resources
         */
        static Dispose() {
            if (DumpTools._DumpToolsEngine) {
                DumpTools._DumpToolsEngine.wrapper.dispose();
                DumpTools._DumpToolsEngine.renderer.dispose();
                DumpTools._DumpToolsEngine.engine.dispose();
            }
            DumpTools._DumpToolsEngine = null;
        }
    }
    /**
     * This will be executed automatically for UMD and es5.
     * If esm dev wants the side effects to execute they will have to run it manually
     * Once we build native modules those need to be exported.
     * @internal
     */
    const initSideEffects$1 = () => {
        // References the dependencies.
        Tools.DumpData = DumpTools.DumpData;
        Tools.DumpDataAsync = DumpTools.DumpDataAsync;
        Tools.DumpFramebuffer = DumpTools.DumpFramebuffer;
    };
    initSideEffects$1();

    /**
     * This Helps creating a texture that will be created from a camera in your scene.
     * It is basically a dynamic texture that could be used to create special effects for instance.
     * Actually, It is the base of lot of effects in the framework like post process, shadows, effect layers and rendering pipelines...
     */
    class RenderTargetTexture extends Texture {
        /**
         * Use this list to define the list of mesh you want to render.
         */
        get renderList() {
            return this._renderList;
        }
        set renderList(value) {
            if (this._unObserveRenderList) {
                this._unObserveRenderList();
                this._unObserveRenderList = null;
            }
            if (value) {
                this._unObserveRenderList = _ObserveArray(value, this._renderListHasChanged);
            }
            this._renderList = value;
        }
        /**
         * Post-processes for this render target
         */
        get postProcesses() {
            return this._postProcesses;
        }
        get _prePassEnabled() {
            return !!this._prePassRenderTarget && this._prePassRenderTarget.enabled;
        }
        /**
         * Set a after unbind callback in the texture.
         * This has been kept for backward compatibility and use of onAfterUnbindObservable is recommended.
         */
        set onAfterUnbind(callback) {
            if (this._onAfterUnbindObserver) {
                this.onAfterUnbindObservable.remove(this._onAfterUnbindObserver);
            }
            this._onAfterUnbindObserver = this.onAfterUnbindObservable.add(callback);
        }
        /**
         * Set a before render callback in the texture.
         * This has been kept for backward compatibility and use of onBeforeRenderObservable is recommended.
         */
        set onBeforeRender(callback) {
            if (this._onBeforeRenderObserver) {
                this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
            }
            this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
        }
        /**
         * Set a after render callback in the texture.
         * This has been kept for backward compatibility and use of onAfterRenderObservable is recommended.
         */
        set onAfterRender(callback) {
            if (this._onAfterRenderObserver) {
                this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
            }
            this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
        }
        /**
         * Set a clear callback in the texture.
         * This has been kept for backward compatibility and use of onClearObservable is recommended.
         */
        set onClear(callback) {
            if (this._onClearObserver) {
                this.onClearObservable.remove(this._onClearObserver);
            }
            this._onClearObserver = this.onClearObservable.add(callback);
        }
        /**
         * Gets the render pass ids used by the render target texture. For a single render target the array length will be 1, for a cube texture it will be 6 and for
         * a 2D texture array it will return an array of ids the size of the 2D texture array
         */
        get renderPassIds() {
            return this._renderPassIds;
        }
        /**
         * Gets the current value of the refreshId counter
         */
        get currentRefreshId() {
            return this._currentRefreshId;
        }
        /**
         * Sets a specific material to be used to render a mesh/a list of meshes in this render target texture
         * @param mesh mesh or array of meshes
         * @param material material or array of materials to use for this render pass. If undefined is passed, no specific material will be used but the regular material instead (mesh.material). It's possible to provide an array of materials to use a different material for each rendering in the case of a cube texture (6 rendering) and a 2D texture array (as many rendering as the length of the array)
         */
        setMaterialForRendering(mesh, material) {
            let meshes;
            if (!Array.isArray(mesh)) {
                meshes = [mesh];
            }
            else {
                meshes = mesh;
            }
            for (let j = 0; j < meshes.length; ++j) {
                for (let i = 0; i < this._renderPassIds.length; ++i) {
                    meshes[j].setMaterialForRenderPass(this._renderPassIds[i], material !== undefined ? (Array.isArray(material) ? material[i] : material) : undefined);
                }
            }
        }
        /**
         * Define if the texture has multiple draw buffers or if false a single draw buffer.
         */
        get isMulti() {
            var _a, _b;
            return (_b = (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.isMulti) !== null && _b !== void 0 ? _b : false;
        }
        /**
         * Gets render target creation options that were used.
         */
        get renderTargetOptions() {
            return this._renderTargetOptions;
        }
        /**
         * Gets the render target wrapper associated with this render target
         */
        get renderTarget() {
            return this._renderTarget;
        }
        _onRatioRescale() {
            if (this._sizeRatio) {
                this.resize(this._initialSizeParameter);
            }
        }
        /**
         * Gets or sets the size of the bounding box associated with the texture (when in cube mode)
         * When defined, the cubemap will switch to local mode
         * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
         * @example https://www.babylonjs-playground.com/#RNASML
         */
        set boundingBoxSize(value) {
            if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) {
                return;
            }
            this._boundingBoxSize = value;
            const scene = this.getScene();
            if (scene) {
                scene.markAllMaterialsAsDirty(1);
            }
        }
        get boundingBoxSize() {
            return this._boundingBoxSize;
        }
        /**
         * In case the RTT has been created with a depth texture, get the associated
         * depth texture.
         * Otherwise, return null.
         */
        get depthStencilTexture() {
            var _a, _b;
            return (_b = (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a._depthStencilTexture) !== null && _b !== void 0 ? _b : null;
        }
        /** @internal */
        constructor(name, size, scene, generateMipMaps = false, doNotChangeAspectRatio = true, type = 0, isCube = false, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, generateDepthBuffer = true, generateStencilBuffer = false, isMulti = false, format = 5, delayAllocation = false, samples, creationFlags, noColorAttachment = false, useSRGBBuffer = false) {
            var _a, _b, _c, _d, _e, _f;
            let colorAttachment = undefined;
            if (typeof generateMipMaps === "object") {
                const options = generateMipMaps;
                generateMipMaps = !!options.generateMipMaps;
                doNotChangeAspectRatio = (_a = options.doNotChangeAspectRatio) !== null && _a !== void 0 ? _a : true;
                type = (_b = options.type) !== null && _b !== void 0 ? _b : 0;
                isCube = !!options.isCube;
                samplingMode = (_c = options.samplingMode) !== null && _c !== void 0 ? _c : Texture.TRILINEAR_SAMPLINGMODE;
                generateDepthBuffer = (_d = options.generateDepthBuffer) !== null && _d !== void 0 ? _d : true;
                generateStencilBuffer = !!options.generateStencilBuffer;
                isMulti = !!options.isMulti;
                format = (_e = options.format) !== null && _e !== void 0 ? _e : 5;
                delayAllocation = !!options.delayAllocation;
                samples = options.samples;
                creationFlags = options.creationFlags;
                noColorAttachment = !!options.noColorAttachment;
                useSRGBBuffer = !!options.useSRGBBuffer;
                colorAttachment = options.colorAttachment;
            }
            super(null, scene, !generateMipMaps, undefined, samplingMode, undefined, undefined, undefined, undefined, format);
            this._unObserveRenderList = null;
            this._renderListHasChanged = (_functionName, previousLength) => {
                var _a;
                const newLength = this._renderList ? this._renderList.length : 0;
                if ((previousLength === 0 && newLength > 0) || newLength === 0) {
                    (_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.meshes.forEach((mesh) => {
                        mesh._markSubMeshesAsLightDirty();
                    });
                }
            };
            /**
             * Define if particles should be rendered in your texture.
             */
            this.renderParticles = true;
            /**
             * Define if sprites should be rendered in your texture.
             */
            this.renderSprites = false;
            /**
             * Force checking the layerMask property even if a custom list of meshes is provided (ie. if renderList is not undefined)
             */
            this.forceLayerMaskCheck = false;
            /**
             * Define if the camera viewport should be respected while rendering the texture or if the render should be done to the entire texture.
             */
            this.ignoreCameraViewport = false;
            /**
             * An event triggered when the texture is unbind.
             */
            this.onBeforeBindObservable = new Observable$1();
            /**
             * An event triggered when the texture is unbind.
             */
            this.onAfterUnbindObservable = new Observable$1();
            /**
             * An event triggered before rendering the texture
             */
            this.onBeforeRenderObservable = new Observable$1();
            /**
             * An event triggered after rendering the texture
             */
            this.onAfterRenderObservable = new Observable$1();
            /**
             * An event triggered after the texture clear
             */
            this.onClearObservable = new Observable$1();
            /**
             * An event triggered when the texture is resized.
             */
            this.onResizeObservable = new Observable$1();
            /** @internal */
            this._cleared = false;
            /**
             * Skip the initial clear of the rtt at the beginning of the frame render loop
             */
            this.skipInitialClear = false;
            this._currentRefreshId = -1;
            this._refreshRate = 1;
            this._samples = 1;
            this._canRescale = true;
            this._renderTarget = null;
            /**
             * Gets or sets the center of the bounding box associated with the texture (when in cube mode)
             * It must define where the camera used to render the texture is set
             */
            this.boundingBoxPosition = Vector3.Zero();
            scene = this.getScene();
            if (!scene) {
                return;
            }
            const engine = this.getScene().getEngine();
            this._coordinatesMode = Texture.PROJECTION_MODE;
            this.renderList = new Array();
            this.name = name;
            this.isRenderTarget = true;
            this._initialSizeParameter = size;
            this._renderPassIds = [];
            this._isCubeData = isCube;
            this._processSizeParameter(size);
            this.renderPassId = this._renderPassIds[0];
            this._resizeObserver = engine.onResizeObservable.add(() => { });
            this._generateMipMaps = generateMipMaps ? true : false;
            this._doNotChangeAspectRatio = doNotChangeAspectRatio;
            // Rendering groups
            this._renderingManager = new RenderingManager(scene);
            this._renderingManager._useSceneAutoClearSetup = true;
            if (isMulti) {
                return;
            }
            this._renderTargetOptions = {
                generateMipMaps: generateMipMaps,
                type: type,
                format: (_f = this._format) !== null && _f !== void 0 ? _f : undefined,
                samplingMode: this.samplingMode,
                generateDepthBuffer: generateDepthBuffer,
                generateStencilBuffer: generateStencilBuffer,
                samples,
                creationFlags,
                noColorAttachment: noColorAttachment,
                useSRGBBuffer,
                colorAttachment: colorAttachment,
                label: this.name,
            };
            if (this.samplingMode === Texture.NEAREST_SAMPLINGMODE) {
                this.wrapU = Texture.CLAMP_ADDRESSMODE;
                this.wrapV = Texture.CLAMP_ADDRESSMODE;
            }
            if (!delayAllocation) {
                if (isCube) {
                    this._renderTarget = scene.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions);
                    this.coordinatesMode = Texture.INVCUBIC_MODE;
                    this._textureMatrix = Matrix.Identity();
                }
                else {
                    this._renderTarget = scene.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions);
                }
                this._texture = this._renderTarget.texture;
                if (samples !== undefined) {
                    this.samples = samples;
                }
            }
        }
        /**
         * Creates a depth stencil texture.
         * This is only available in WebGL 2 or with the depth texture extension available.
         * @param comparisonFunction Specifies the comparison function to set on the texture. If 0 or undefined, the texture is not in comparison mode (default: 0)
         * @param bilinearFiltering Specifies whether or not bilinear filtering is enable on the texture (default: true)
         * @param generateStencil Specifies whether or not a stencil should be allocated in the texture (default: false)
         * @param samples sample count of the depth/stencil texture (default: 1)
         * @param format format of the depth texture (default: 14)
         */
        createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14) {
            var _a;
            (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.createDepthStencilTexture(comparisonFunction, bilinearFiltering, generateStencil, samples, format);
        }
        _releaseRenderPassId() {
            if (this._scene) {
                const engine = this._scene.getEngine();
                for (let i = 0; i < this._renderPassIds.length; ++i) {
                    engine.releaseRenderPassId(this._renderPassIds[i]);
                }
            }
            this._renderPassIds = [];
        }
        _createRenderPassId() {
            this._releaseRenderPassId();
            const engine = this._scene.getEngine(); // scene can't be null in a RenderTargetTexture, see constructor
            const numPasses = this._isCubeData ? 6 : this.getRenderLayers() || 1;
            for (let i = 0; i < numPasses; ++i) {
                this._renderPassIds[i] = engine.createRenderPassId(`RenderTargetTexture - ${this.name}#${i}`);
            }
        }
        _processSizeParameter(size, createRenderPassIds = true) {
            if (size.ratio) {
                this._sizeRatio = size.ratio;
                const engine = this._getEngine();
                this._size = {
                    width: this._bestReflectionRenderTargetDimension(engine.getRenderWidth(), this._sizeRatio),
                    height: this._bestReflectionRenderTargetDimension(engine.getRenderHeight(), this._sizeRatio),
                };
            }
            else {
                this._size = size;
            }
            if (createRenderPassIds) {
                this._createRenderPassId();
            }
        }
        /**
         * Define the number of samples to use in case of MSAA.
         * It defaults to one meaning no MSAA has been enabled.
         */
        get samples() {
            var _a, _b;
            return (_b = (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.samples) !== null && _b !== void 0 ? _b : this._samples;
        }
        set samples(value) {
            if (this._renderTarget) {
                this._samples = this._renderTarget.setSamples(value);
            }
        }
        /**
         * Resets the refresh counter of the texture and start bak from scratch.
         * Could be useful to regenerate the texture if it is setup to render only once.
         */
        resetRefreshCounter() {
            this._currentRefreshId = -1;
        }
        /**
         * Define the refresh rate of the texture or the rendering frequency.
         * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
         */
        get refreshRate() {
            return this._refreshRate;
        }
        set refreshRate(value) {
            this._refreshRate = value;
            this.resetRefreshCounter();
        }
        /**
         * Adds a post process to the render target rendering passes.
         * @param postProcess define the post process to add
         */
        addPostProcess(postProcess) {
            if (!this._postProcessManager) {
                const scene = this.getScene();
                if (!scene) {
                    return;
                }
                this._postProcessManager = new PostProcessManager(scene);
                this._postProcesses = new Array();
            }
            this._postProcesses.push(postProcess);
            this._postProcesses[0].autoClear = false;
        }
        /**
         * Clear all the post processes attached to the render target
         * @param dispose define if the cleared post processes should also be disposed (false by default)
         */
        clearPostProcesses(dispose = false) {
            if (!this._postProcesses) {
                return;
            }
            if (dispose) {
                for (const postProcess of this._postProcesses) {
                    postProcess.dispose();
                }
            }
            this._postProcesses = [];
        }
        /**
         * Remove one of the post process from the list of attached post processes to the texture
         * @param postProcess define the post process to remove from the list
         */
        removePostProcess(postProcess) {
            if (!this._postProcesses) {
                return;
            }
            const index = this._postProcesses.indexOf(postProcess);
            if (index === -1) {
                return;
            }
            this._postProcesses.splice(index, 1);
            if (this._postProcesses.length > 0) {
                this._postProcesses[0].autoClear = false;
            }
        }
        /** @internal */
        _shouldRender() {
            if (this._currentRefreshId === -1) {
                // At least render once
                this._currentRefreshId = 1;
                return true;
            }
            if (this.refreshRate === this._currentRefreshId) {
                this._currentRefreshId = 1;
                return true;
            }
            this._currentRefreshId++;
            return false;
        }
        /**
         * Gets the actual render size of the texture.
         * @returns the width of the render size
         */
        getRenderSize() {
            return this.getRenderWidth();
        }
        /**
         * Gets the actual render width of the texture.
         * @returns the width of the render size
         */
        getRenderWidth() {
            if (this._size.width) {
                return this._size.width;
            }
            return this._size;
        }
        /**
         * Gets the actual render height of the texture.
         * @returns the height of the render size
         */
        getRenderHeight() {
            if (this._size.width) {
                return this._size.height;
            }
            return this._size;
        }
        /**
         * Gets the actual number of layers of the texture.
         * @returns the number of layers
         */
        getRenderLayers() {
            const layers = this._size.layers;
            if (layers) {
                return layers;
            }
            return 0;
        }
        /**
         * Don't allow this render target texture to rescale. Mainly used to prevent rescaling by the scene optimizer.
         */
        disableRescaling() {
            this._canRescale = false;
        }
        /**
         * Get if the texture can be rescaled or not.
         */
        get canRescale() {
            return this._canRescale;
        }
        /**
         * Resize the texture using a ratio.
         * @param ratio the ratio to apply to the texture size in order to compute the new target size
         */
        scale(ratio) {
            const newSize = Math.max(1, this.getRenderSize() * ratio);
            this.resize(newSize);
        }
        /**
         * Get the texture reflection matrix used to rotate/transform the reflection.
         * @returns the reflection matrix
         */
        getReflectionTextureMatrix() {
            if (this.isCube) {
                return this._textureMatrix;
            }
            return super.getReflectionTextureMatrix();
        }
        /**
         * Resize the texture to a new desired size.
         * Be careful as it will recreate all the data in the new texture.
         * @param size Define the new size. It can be:
         *   - a number for squared texture,
         *   - an object containing { width: number, height: number }
         *   - or an object containing a ratio { ratio: number }
         */
        resize(size) {
            var _a;
            const wasCube = this.isCube;
            (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.dispose();
            this._renderTarget = null;
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            this._processSizeParameter(size, false);
            if (wasCube) {
                this._renderTarget = scene.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions);
            }
            else {
                this._renderTarget = scene.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions);
            }
            this._texture = this._renderTarget.texture;
            if (this._renderTargetOptions.samples !== undefined) {
                this.samples = this._renderTargetOptions.samples;
            }
            if (this.onResizeObservable.hasObservers()) {
                this.onResizeObservable.notifyObservers(this);
            }
        }
        /**
         * Renders all the objects from the render list into the texture.
         * @param useCameraPostProcess Define if camera post processes should be used during the rendering
         * @param dumpForDebug Define if the rendering result should be dumped (copied) for debugging purpose
         */
        render(useCameraPostProcess = false, dumpForDebug = false) {
            this._render(useCameraPostProcess, dumpForDebug);
        }
        /**
         * This function will check if the render target texture can be rendered (textures are loaded, shaders are compiled)
         * @returns true if all required resources are ready
         */
        isReadyForRendering() {
            return this._render(false, false, true);
        }
        _render(useCameraPostProcess = false, dumpForDebug = false, checkReadiness = false) {
            var _a;
            const scene = this.getScene();
            if (!scene) {
                return checkReadiness;
            }
            const engine = scene.getEngine();
            if (this.useCameraPostProcesses !== undefined) {
                useCameraPostProcess = this.useCameraPostProcesses;
            }
            if (this._waitingRenderList) {
                this.renderList = [];
                for (let index = 0; index < this._waitingRenderList.length; index++) {
                    const id = this._waitingRenderList[index];
                    const mesh = scene.getMeshById(id);
                    if (mesh) {
                        this.renderList.push(mesh);
                    }
                }
                this._waitingRenderList = undefined;
            }
            // Is predicate defined?
            if (this.renderListPredicate) {
                if (this.renderList) {
                    this.renderList.length = 0; // Clear previous renderList
                }
                else {
                    this.renderList = [];
                }
                const scene = this.getScene();
                if (!scene) {
                    return checkReadiness;
                }
                const sceneMeshes = scene.meshes;
                for (let index = 0; index < sceneMeshes.length; index++) {
                    const mesh = sceneMeshes[index];
                    if (this.renderListPredicate(mesh)) {
                        this.renderList.push(mesh);
                    }
                }
            }
            const currentRenderPassId = engine.currentRenderPassId;
            this.onBeforeBindObservable.notifyObservers(this);
            // Set custom projection.
            // Needs to be before binding to prevent changing the aspect ratio.
            const camera = (_a = this.activeCamera) !== null && _a !== void 0 ? _a : scene.activeCamera;
            const sceneCamera = scene.activeCamera;
            if (camera) {
                if (camera !== scene.activeCamera) {
                    scene.setTransformMatrix(camera.getViewMatrix(), camera.getProjectionMatrix(true));
                    scene.activeCamera = camera;
                }
                engine.setViewport(camera.rigParent ? camera.rigParent.viewport : camera.viewport, this.getRenderWidth(), this.getRenderHeight());
            }
            this._defaultRenderListPrepared = false;
            let returnValue = checkReadiness;
            if (!checkReadiness) {
                if (this.is2DArray && !this.isMulti) {
                    for (let layer = 0; layer < this.getRenderLayers(); layer++) {
                        this._renderToTarget(0, useCameraPostProcess, dumpForDebug, layer, camera);
                        scene.incrementRenderId();
                        scene.resetCachedMaterial();
                    }
                }
                else if (this.isCube && !this.isMulti) {
                    for (let face = 0; face < 6; face++) {
                        this._renderToTarget(face, useCameraPostProcess, dumpForDebug, undefined, camera);
                        scene.incrementRenderId();
                        scene.resetCachedMaterial();
                    }
                }
                else {
                    this._renderToTarget(0, useCameraPostProcess, dumpForDebug, undefined, camera);
                }
            }
            else {
                if (!scene.getViewMatrix()) {
                    // We probably didn't execute scene.render() yet, so make sure we have a view/projection matrix setup for the scene
                    scene.updateTransformMatrix();
                }
                const numLayers = this.is2DArray ? this.getRenderLayers() : this.isCube ? 6 : 1;
                for (let layer = 0; layer < numLayers && returnValue; layer++) {
                    let currentRenderList = null;
                    const defaultRenderList = this.renderList ? this.renderList : scene.getActiveMeshes().data;
                    const defaultRenderListLength = this.renderList ? this.renderList.length : scene.getActiveMeshes().length;
                    engine.currentRenderPassId = this._renderPassIds[layer];
                    this.onBeforeRenderObservable.notifyObservers(layer);
                    if (this.getCustomRenderList) {
                        currentRenderList = this.getCustomRenderList(layer, defaultRenderList, defaultRenderListLength);
                    }
                    if (!currentRenderList) {
                        currentRenderList = defaultRenderList;
                    }
                    if (!this._doNotChangeAspectRatio) {
                        scene.updateTransformMatrix(true);
                    }
                    for (let i = 0; i < currentRenderList.length && returnValue; ++i) {
                        const mesh = currentRenderList[i];
                        if (!mesh.isEnabled() || mesh.isBlocked || !mesh.isVisible || !mesh.subMeshes) {
                            continue;
                        }
                        if (this.customIsReadyFunction) {
                            if (!this.customIsReadyFunction(mesh, this.refreshRate, checkReadiness)) {
                                returnValue = false;
                                continue;
                            }
                        }
                        else if (!mesh.isReady(true)) {
                            returnValue = false;
                            continue;
                        }
                    }
                    this.onAfterRenderObservable.notifyObservers(layer);
                    if (this.is2DArray || this.isCube) {
                        scene.incrementRenderId();
                        scene.resetCachedMaterial();
                    }
                }
            }
            this.onAfterUnbindObservable.notifyObservers(this);
            engine.currentRenderPassId = currentRenderPassId;
            if (sceneCamera) {
                scene.activeCamera = sceneCamera;
                // Do not avoid setting uniforms when multiple scenes are active as another camera may have overwrite these
                if (scene.getEngine().scenes.length > 1 || (this.activeCamera && this.activeCamera !== scene.activeCamera)) {
                    scene.setTransformMatrix(scene.activeCamera.getViewMatrix(), scene.activeCamera.getProjectionMatrix(true));
                }
                engine.setViewport(scene.activeCamera.viewport);
            }
            scene.resetCachedMaterial();
            return returnValue;
        }
        _bestReflectionRenderTargetDimension(renderDimension, scale) {
            const minimum = 128;
            const x = renderDimension * scale;
            const curved = Engine.NearestPOT(x + (minimum * minimum) / (minimum + x));
            // Ensure we don't exceed the render dimension (while staying POT)
            return Math.min(Engine.FloorPOT(renderDimension), curved);
        }
        _prepareRenderingManager(currentRenderList, currentRenderListLength, camera, checkLayerMask) {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            this._renderingManager.reset();
            const sceneRenderId = scene.getRenderId();
            for (let meshIndex = 0; meshIndex < currentRenderListLength; meshIndex++) {
                const mesh = currentRenderList[meshIndex];
                if (mesh && !mesh.isBlocked) {
                    if (this.customIsReadyFunction) {
                        if (!this.customIsReadyFunction(mesh, this.refreshRate, false)) {
                            this.resetRefreshCounter();
                            continue;
                        }
                    }
                    else if (!mesh.isReady(this.refreshRate === 0)) {
                        this.resetRefreshCounter();
                        continue;
                    }
                    if (!mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate && scene.activeCamera) {
                        mesh._internalAbstractMeshDataInfo._currentLOD = scene.customLODSelector
                            ? scene.customLODSelector(mesh, this.activeCamera || scene.activeCamera)
                            : mesh.getLOD(this.activeCamera || scene.activeCamera);
                        mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate = true;
                    }
                    if (!mesh._internalAbstractMeshDataInfo._currentLOD) {
                        continue;
                    }
                    let meshToRender = mesh._internalAbstractMeshDataInfo._currentLOD;
                    meshToRender._preActivateForIntermediateRendering(sceneRenderId);
                    let isMasked;
                    if (checkLayerMask && camera) {
                        isMasked = (mesh.layerMask & camera.layerMask) === 0;
                    }
                    else {
                        isMasked = false;
                    }
                    if (mesh.isEnabled() && mesh.isVisible && mesh.subMeshes && !isMasked) {
                        if (meshToRender !== mesh) {
                            meshToRender._activate(sceneRenderId, true);
                        }
                        if (mesh._activate(sceneRenderId, true) && mesh.subMeshes.length) {
                            if (!mesh.isAnInstance) {
                                meshToRender._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = false;
                            }
                            else {
                                if (mesh._internalAbstractMeshDataInfo._actAsRegularMesh) {
                                    meshToRender = mesh;
                                }
                            }
                            meshToRender._internalAbstractMeshDataInfo._isActiveIntermediate = true;
                            for (let subIndex = 0; subIndex < meshToRender.subMeshes.length; subIndex++) {
                                const subMesh = meshToRender.subMeshes[subIndex];
                                this._renderingManager.dispatch(subMesh, meshToRender);
                            }
                        }
                    }
                }
            }
            for (let particleIndex = 0; particleIndex < scene.particleSystems.length; particleIndex++) {
                const particleSystem = scene.particleSystems[particleIndex];
                const emitter = particleSystem.emitter;
                if (!particleSystem.isStarted() || !emitter || (emitter.position && !emitter.isEnabled())) {
                    continue;
                }
                this._renderingManager.dispatchParticles(particleSystem);
            }
        }
        /**
         * @internal
         * @param faceIndex face index to bind to if this is a cubetexture
         * @param layer defines the index of the texture to bind in the array
         */
        _bindFrameBuffer(faceIndex = 0, layer = 0) {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            const engine = scene.getEngine();
            if (this._renderTarget) {
                engine.bindFramebuffer(this._renderTarget, this.isCube ? faceIndex : undefined, undefined, undefined, this.ignoreCameraViewport, 0, layer);
            }
        }
        _unbindFrameBuffer(engine, faceIndex) {
            if (!this._renderTarget) {
                return;
            }
            engine.unBindFramebuffer(this._renderTarget, this.isCube, () => {
                this.onAfterRenderObservable.notifyObservers(faceIndex);
            });
        }
        /**
         * @internal
         */
        _prepareFrame(scene, faceIndex, layer, useCameraPostProcess) {
            if (this._postProcessManager) {
                if (!this._prePassEnabled) {
                    this._postProcessManager._prepareFrame(this._texture, this._postProcesses);
                }
            }
            else if (!useCameraPostProcess || !scene.postProcessManager._prepareFrame(this._texture)) {
                this._bindFrameBuffer(faceIndex, layer);
            }
        }
        _renderToTarget(faceIndex, useCameraPostProcess, dumpForDebug, layer = 0, camera = null) {
            var _a, _b, _c, _d, _e, _f;
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            const engine = scene.getEngine();
            (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, `render to face #${faceIndex} layer #${layer}`, 1);
            // Bind
            this._prepareFrame(scene, faceIndex, layer, useCameraPostProcess);
            if (this.is2DArray) {
                engine.currentRenderPassId = this._renderPassIds[layer];
                this.onBeforeRenderObservable.notifyObservers(layer);
            }
            else {
                engine.currentRenderPassId = this._renderPassIds[faceIndex];
                this.onBeforeRenderObservable.notifyObservers(faceIndex);
            }
            const fastPath = engine.snapshotRendering && engine.snapshotRenderingMode === 1;
            if (!fastPath) {
                // Get the list of meshes to render
                let currentRenderList = null;
                const defaultRenderList = this.renderList ? this.renderList : scene.getActiveMeshes().data;
                const defaultRenderListLength = this.renderList ? this.renderList.length : scene.getActiveMeshes().length;
                if (this.getCustomRenderList) {
                    currentRenderList = this.getCustomRenderList(this.is2DArray ? layer : faceIndex, defaultRenderList, defaultRenderListLength);
                }
                if (!currentRenderList) {
                    // No custom render list provided, we prepare the rendering for the default list, but check
                    // first if we did not already performed the preparation before so as to avoid re-doing it several times
                    if (!this._defaultRenderListPrepared) {
                        this._prepareRenderingManager(defaultRenderList, defaultRenderListLength, camera, !this.renderList || this.forceLayerMaskCheck);
                        this._defaultRenderListPrepared = true;
                    }
                    currentRenderList = defaultRenderList;
                }
                else {
                    // Prepare the rendering for the custom render list provided
                    this._prepareRenderingManager(currentRenderList, currentRenderList.length, camera, this.forceLayerMaskCheck);
                }
                // Before clear
                for (const step of scene._beforeRenderTargetClearStage) {
                    step.action(this, faceIndex, layer);
                }
                // Clear
                if (this.onClearObservable.hasObservers()) {
                    this.onClearObservable.notifyObservers(engine);
                }
                else {
                    if (!this.skipInitialClear) {
                        engine.clear(this.clearColor || scene.clearColor, true, true, true);
                    }
                }
                if (!this._doNotChangeAspectRatio) {
                    scene.updateTransformMatrix(true);
                }
                // Before Camera Draw
                for (const step of scene._beforeRenderTargetDrawStage) {
                    step.action(this, faceIndex, layer);
                }
                // Render
                this._renderingManager.render(this.customRenderFunction, currentRenderList, this.renderParticles, this.renderSprites);
                // After Camera Draw
                for (const step of scene._afterRenderTargetDrawStage) {
                    step.action(this, faceIndex, layer);
                }
                const saveGenerateMipMaps = (_c = (_b = this._texture) === null || _b === void 0 ? void 0 : _b.generateMipMaps) !== null && _c !== void 0 ? _c : false;
                if (this._texture) {
                    this._texture.generateMipMaps = false; // if left true, the mipmaps will be generated (if this._texture.generateMipMaps = true) when the first post process binds its own RTT: by doing so it will unbind the current RTT,
                    // which will trigger a mipmap generation. We don't want this because it's a wasted work, we will do an unbind of the current RTT at the end of the process (see unbindFrameBuffer) which will
                    // trigger the generation of the final mipmaps
                }
                if (this._postProcessManager) {
                    this._postProcessManager._finalizeFrame(false, (_d = this._renderTarget) !== null && _d !== void 0 ? _d : undefined, faceIndex, this._postProcesses, this.ignoreCameraViewport);
                }
                else if (useCameraPostProcess) {
                    scene.postProcessManager._finalizeFrame(false, (_e = this._renderTarget) !== null && _e !== void 0 ? _e : undefined, faceIndex);
                }
                for (const step of scene._afterRenderTargetPostProcessStage) {
                    step.action(this, faceIndex, layer);
                }
                if (this._texture) {
                    this._texture.generateMipMaps = saveGenerateMipMaps;
                }
                if (!this._doNotChangeAspectRatio) {
                    scene.updateTransformMatrix(true);
                }
                // Dump ?
                if (dumpForDebug) {
                    DumpTools.DumpFramebuffer(this.getRenderWidth(), this.getRenderHeight(), engine);
                }
            }
            else {
                // Clear
                if (this.onClearObservable.hasObservers()) {
                    this.onClearObservable.notifyObservers(engine);
                }
                else {
                    if (!this.skipInitialClear) {
                        engine.clear(this.clearColor || scene.clearColor, true, true, true);
                    }
                }
            }
            // Unbind
            this._unbindFrameBuffer(engine, faceIndex);
            if (this._texture && this.isCube && faceIndex === 5) {
                engine.generateMipMapsForCubemap(this._texture);
            }
            (_f = engine._debugPopGroup) === null || _f === void 0 ? void 0 : _f.call(engine, 1);
        }
        /**
         * Overrides the default sort function applied in the rendering group to prepare the meshes.
         * This allowed control for front to back rendering or reversely depending of the special needs.
         *
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
         * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
         * @param transparentSortCompareFn The transparent queue comparison function use to sort.
         */
        setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
            this._renderingManager.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
        }
        /**
         * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
         *
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
         */
        setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil) {
            this._renderingManager.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil);
            this._renderingManager._useSceneAutoClearSetup = false;
        }
        /**
         * Clones the texture.
         * @returns the cloned texture
         */
        clone() {
            const textureSize = this.getSize();
            const newTexture = new RenderTargetTexture(this.name, textureSize, this.getScene(), this._renderTargetOptions.generateMipMaps, this._doNotChangeAspectRatio, this._renderTargetOptions.type, this.isCube, this._renderTargetOptions.samplingMode, this._renderTargetOptions.generateDepthBuffer, this._renderTargetOptions.generateStencilBuffer, undefined, this._renderTargetOptions.format, undefined, this._renderTargetOptions.samples);
            // Base texture
            newTexture.hasAlpha = this.hasAlpha;
            newTexture.level = this.level;
            // RenderTarget Texture
            newTexture.coordinatesMode = this.coordinatesMode;
            if (this.renderList) {
                newTexture.renderList = this.renderList.slice(0);
            }
            return newTexture;
        }
        /**
         * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
         * @returns The JSON representation of the texture
         */
        serialize() {
            if (!this.name) {
                return null;
            }
            const serializationObject = super.serialize();
            serializationObject.renderTargetSize = this.getRenderSize();
            serializationObject.renderList = [];
            if (this.renderList) {
                for (let index = 0; index < this.renderList.length; index++) {
                    serializationObject.renderList.push(this.renderList[index].id);
                }
            }
            return serializationObject;
        }
        /**
         *  This will remove the attached framebuffer objects. The texture will not be able to be used as render target anymore
         */
        disposeFramebufferObjects() {
            var _a;
            (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.dispose(true);
        }
        /**
         * Release and destroy the underlying lower level texture aka internalTexture.
         */
        releaseInternalTexture() {
            var _a;
            (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.releaseTextures();
            this._texture = null;
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            var _a;
            this.onResizeObservable.clear();
            this.onClearObservable.clear();
            this.onAfterRenderObservable.clear();
            this.onAfterUnbindObservable.clear();
            this.onBeforeBindObservable.clear();
            this.onBeforeRenderObservable.clear();
            if (this._postProcessManager) {
                this._postProcessManager.dispose();
                this._postProcessManager = null;
            }
            if (this._prePassRenderTarget) {
                this._prePassRenderTarget.dispose();
            }
            this._releaseRenderPassId();
            this.clearPostProcesses(true);
            if (this._resizeObserver) {
                this.getScene().getEngine().onResizeObservable.remove(this._resizeObserver);
                this._resizeObserver = null;
            }
            this.renderList = null;
            // Remove from custom render targets
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            let index = scene.customRenderTargets.indexOf(this);
            if (index >= 0) {
                scene.customRenderTargets.splice(index, 1);
            }
            for (const camera of scene.cameras) {
                index = camera.customRenderTargets.indexOf(this);
                if (index >= 0) {
                    camera.customRenderTargets.splice(index, 1);
                }
            }
            (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.dispose();
            this._renderTarget = null;
            this._texture = null;
            super.dispose();
        }
        /** @internal */
        _rebuild() {
            if (this.refreshRate === RenderTargetTexture.REFRESHRATE_RENDER_ONCE) {
                this.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONCE;
            }
            if (this._postProcessManager) {
                this._postProcessManager._rebuild();
            }
        }
        /**
         * Clear the info related to rendering groups preventing retention point in material dispose.
         */
        freeRenderingGroups() {
            if (this._renderingManager) {
                this._renderingManager.freeRenderingGroups();
            }
        }
        /**
         * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
         * @returns the view count
         */
        getViewCount() {
            return 1;
        }
    }
    /**
     * The texture will only be rendered once which can be useful to improve performance if everything in your render is static for instance.
     */
    RenderTargetTexture.REFRESHRATE_RENDER_ONCE = 0;
    /**
     * The texture will only be rendered rendered every frame and is recommended for dynamic contents.
     */
    RenderTargetTexture.REFRESHRATE_RENDER_ONEVERYFRAME = 1;
    /**
     * The texture will be rendered every 2 frames which could be enough if your dynamic objects are not
     * the central point of your effect and can save a lot of performances.
     */
    RenderTargetTexture.REFRESHRATE_RENDER_ONEVERYTWOFRAMES = 2;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Texture._CreateRenderTargetTexture = (name, renderTargetSize, scene, generateMipMaps, creationFlags) => {
        return new RenderTargetTexture(name, renderTargetSize, scene, generateMipMaps);
    };

    // Do not edit.
    const name$12 = "passCubePixelShader";
    const shader$12 = `varying vec2 vUV;uniform samplerCube textureSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec2 uv=vUV*2.0-1.0;
#ifdef POSITIVEX
gl_FragColor=textureCube(textureSampler,vec3(1.001,uv.y,uv.x));
#endif
#ifdef NEGATIVEX
gl_FragColor=textureCube(textureSampler,vec3(-1.001,uv.y,uv.x));
#endif
#ifdef POSITIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,1.001,uv.x));
#endif
#ifdef NEGATIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,-1.001,uv.x));
#endif
#ifdef POSITIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,1.001));
#endif
#ifdef NEGATIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,-1.001));
#endif
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$12] = shader$12;

    /**
     * PassPostProcess which produces an output the same as it's input
     */
    class PassPostProcess extends PostProcess {
        /**
         * Gets a string identifying the name of the class
         * @returns "PassPostProcess" string
         */
        getClassName() {
            return "PassPostProcess";
        }
        /**
         * Creates the PassPostProcess
         * @param name The name of the effect.
         * @param options The required width/height ratio to downsize to before computing the render pass.
         * @param camera The camera to apply the render pass to.
         * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
         * @param engine The engine which the post process will be applied. (default: current engine)
         * @param reusable If the post process can be reused on the same frame. (default: false)
         * @param textureType The type of texture to be used when performing the post processing.
         * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
         */
        constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
            super(name, "pass", null, null, options, camera, samplingMode, engine, reusable, undefined, textureType, undefined, null, blockCompilation);
        }
        /**
         * @internal
         */
        static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
            return SerializationHelper.Parse(() => {
                return new PassPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable);
            }, parsedPostProcess, scene, rootUrl);
        }
    }
    RegisterClass("BABYLON.PassPostProcess", PassPostProcess);
    Engine._RescalePostProcessFactory = (engine) => {
        return new PassPostProcess("rescale", 1, null, 2, engine, false, 0);
    };

    /**
     * Uses the GPU to create a copy texture rescaled at a given size
     * @param texture Texture to copy from
     * @param width defines the desired width
     * @param height defines the desired height
     * @param useBilinearMode defines if bilinear mode has to be used
     * @returns the generated texture
     */
    function CreateResizedCopy(texture, width, height, useBilinearMode = true) {
        const scene = texture.getScene();
        const engine = scene.getEngine();
        const rtt = new RenderTargetTexture("resized" + texture.name, { width: width, height: height }, scene, !texture.noMipmap, true, texture._texture.type, false, texture.samplingMode, false);
        rtt.wrapU = texture.wrapU;
        rtt.wrapV = texture.wrapV;
        rtt.uOffset = texture.uOffset;
        rtt.vOffset = texture.vOffset;
        rtt.uScale = texture.uScale;
        rtt.vScale = texture.vScale;
        rtt.uAng = texture.uAng;
        rtt.vAng = texture.vAng;
        rtt.wAng = texture.wAng;
        rtt.coordinatesIndex = texture.coordinatesIndex;
        rtt.level = texture.level;
        rtt.anisotropicFilteringLevel = texture.anisotropicFilteringLevel;
        rtt._texture.isReady = false;
        texture.wrapU = Texture.CLAMP_ADDRESSMODE;
        texture.wrapV = Texture.CLAMP_ADDRESSMODE;
        const passPostProcess = new PassPostProcess("pass", 1, null, useBilinearMode ? Texture.BILINEAR_SAMPLINGMODE : Texture.NEAREST_SAMPLINGMODE, engine, false, 0);
        passPostProcess.externalTextureSamplerBinding = true;
        passPostProcess.getEffect().executeWhenCompiled(() => {
            passPostProcess.onApply = function (effect) {
                effect.setTexture("textureSampler", texture);
            };
            const internalTexture = rtt.renderTarget;
            if (internalTexture) {
                scene.postProcessManager.directRender([passPostProcess], internalTexture);
                engine.unBindFramebuffer(internalTexture);
                rtt.disposeFramebufferObjects();
                passPostProcess.dispose();
                rtt.getInternalTexture().isReady = true;
            }
        });
        return rtt;
    }
    /**
     * Apply a post process to a texture
     * @param postProcessName name of the fragment post process
     * @param internalTexture the texture to encode
     * @param scene the scene hosting the texture
     * @param type type of the output texture. If not provided, use the one from internalTexture
     * @param samplingMode sampling mode to use to sample the source texture. If not provided, use the one from internalTexture
     * @param format format of the output texture. If not provided, use the one from internalTexture
     * @returns a promise with the internalTexture having its texture replaced by the result of the processing
     */
    function ApplyPostProcess(postProcessName, internalTexture, scene, type, samplingMode, format, width, height) {
        // Gets everything ready.
        const engine = internalTexture.getEngine();
        internalTexture.isReady = false;
        samplingMode = samplingMode !== null && samplingMode !== void 0 ? samplingMode : internalTexture.samplingMode;
        type = type !== null && type !== void 0 ? type : internalTexture.type;
        format = format !== null && format !== void 0 ? format : internalTexture.format;
        width = width !== null && width !== void 0 ? width : internalTexture.width;
        height = height !== null && height !== void 0 ? height : internalTexture.height;
        if (type === -1) {
            type = 0;
        }
        return new Promise((resolve) => {
            // Create the post process
            const postProcess = new PostProcess("postprocess", postProcessName, null, null, 1, null, samplingMode, engine, false, undefined, type, undefined, null, false, format);
            postProcess.externalTextureSamplerBinding = true;
            // Hold the output of the decoding.
            const encodedTexture = engine.createRenderTargetTexture({ width: width, height: height }, {
                generateDepthBuffer: false,
                generateMipMaps: false,
                generateStencilBuffer: false,
                samplingMode,
                type,
                format,
            });
            postProcess.getEffect().executeWhenCompiled(() => {
                // PP Render Pass
                postProcess.onApply = (effect) => {
                    effect._bindTexture("textureSampler", internalTexture);
                    effect.setFloat2("scale", 1, 1);
                };
                scene.postProcessManager.directRender([postProcess], encodedTexture, true);
                // Cleanup
                engine.restoreDefaultFramebuffer();
                engine._releaseTexture(internalTexture);
                if (postProcess) {
                    postProcess.dispose();
                }
                // Internal Swap
                encodedTexture._swapAndDie(internalTexture);
                // Ready to get rolling again.
                internalTexture.type = type;
                internalTexture.format = 5;
                internalTexture.isReady = true;
                resolve(internalTexture);
            });
        });
    }
    // ref: http://stackoverflow.com/questions/32633585/how-do-you-convert-to-half-floats-in-javascript
    let floatView;
    let int32View;
    /**
     * Converts a number to half float
     * @param value number to convert
     * @returns converted number
     */
    function ToHalfFloat(value) {
        if (!floatView) {
            floatView = new Float32Array(1);
            int32View = new Int32Array(floatView.buffer);
        }
        floatView[0] = value;
        const x = int32View[0];
        let bits = (x >> 16) & 0x8000; /* Get the sign */
        let m = (x >> 12) & 0x07ff; /* Keep one extra bit for rounding */
        const e = (x >> 23) & 0xff; /* Using int is faster here */
        /* If zero, or denormal, or exponent underflows too much for a denormal
         * half, return signed zero. */
        if (e < 103) {
            return bits;
        }
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */
        if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
             * not Inf, so make sure we set one mantissa bit too. */
            bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */
        if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
             * to 1, which is OK. */
            bits |= (m >> (114 - e)) + ((m >> (113 - e)) & 1);
            return bits;
        }
        bits |= ((e - 112) << 10) | (m >> 1);
        bits += m & 1;
        return bits;
    }
    /**
     * Converts a half float to a number
     * @param value half float to convert
     * @returns converted half float
     */
    function FromHalfFloat(value) {
        const s = (value & 0x8000) >> 15;
        const e = (value & 0x7c00) >> 10;
        const f = value & 0x03ff;
        if (e === 0) {
            return (s ? -1 : 1) * Math.pow(2, -14) * (f / Math.pow(2, 10));
        }
        else if (e == 0x1f) {
            return f ? NaN : (s ? -1 : 1) * Infinity;
        }
        return (s ? -1 : 1) * Math.pow(2, e - 15) * (1 + f / Math.pow(2, 10));
    }
    /**
     * Class used to host texture specific utilities
     */
    const TextureTools = {
        /**
         * Uses the GPU to create a copy texture rescaled at a given size
         * @param texture Texture to copy from
         * @param width defines the desired width
         * @param height defines the desired height
         * @param useBilinearMode defines if bilinear mode has to be used
         * @returns the generated texture
         */
        CreateResizedCopy,
        /**
         * Apply a post process to a texture
         * @param postProcessName name of the fragment post process
         * @param internalTexture the texture to encode
         * @param scene the scene hosting the texture
         * @param type type of the output texture. If not provided, use the one from internalTexture
         * @param samplingMode sampling mode to use to sample the source texture. If not provided, use the one from internalTexture
         * @param format format of the output texture. If not provided, use the one from internalTexture
         * @returns a promise with the internalTexture having its texture replaced by the result of the processing
         */
        ApplyPostProcess,
        /**
         * Converts a number to half float
         * @param value number to convert
         * @returns converted number
         */
        ToHalfFloat,
        /**
         * Converts a half float to a number
         * @param value half float to convert
         * @returns converted half float
         */
        FromHalfFloat,
    };

    /**
     * Class used to host RGBD texture specific utilities
     */
    class RGBDTextureTools {
        /**
         * Expand the RGBD Texture from RGBD to Half Float if possible.
         * @param texture the texture to expand.
         */
        static ExpandRGBDTexture(texture) {
            const internalTexture = texture._texture;
            if (!internalTexture || !texture.isRGBD) {
                return;
            }
            // Gets everything ready.
            const engine = internalTexture.getEngine();
            const caps = engine.getCaps();
            const isReady = internalTexture.isReady;
            let expandTexture = false;
            // If half float available we can uncompress the texture
            if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) {
                expandTexture = true;
                internalTexture.type = 2;
            }
            // If full float available we can uncompress the texture
            else if (caps.textureFloatRender && caps.textureFloatLinearFiltering) {
                expandTexture = true;
                internalTexture.type = 1;
            }
            if (expandTexture) {
                // Do not use during decode.
                internalTexture.isReady = false;
                internalTexture._isRGBD = false;
                internalTexture.invertY = false;
            }
            const expandRGBDTexture = () => {
                // Expand the texture if possible
                if (expandTexture) {
                    // Simply run through the decode PP.
                    const rgbdPostProcess = new PostProcess("rgbdDecode", "rgbdDecode", null, null, 1, null, 3, engine, false, undefined, internalTexture.type, undefined, null, false);
                    rgbdPostProcess.externalTextureSamplerBinding = true;
                    // Hold the output of the decoding.
                    const expandedTexture = engine.createRenderTargetTexture(internalTexture.width, {
                        generateDepthBuffer: false,
                        generateMipMaps: false,
                        generateStencilBuffer: false,
                        samplingMode: internalTexture.samplingMode,
                        type: internalTexture.type,
                        format: 5,
                    });
                    rgbdPostProcess.getEffect().executeWhenCompiled(() => {
                        // PP Render Pass
                        rgbdPostProcess.onApply = (effect) => {
                            effect._bindTexture("textureSampler", internalTexture);
                            effect.setFloat2("scale", 1, 1);
                        };
                        texture.getScene().postProcessManager.directRender([rgbdPostProcess], expandedTexture, true);
                        // Cleanup
                        engine.restoreDefaultFramebuffer();
                        engine._releaseTexture(internalTexture);
                        if (rgbdPostProcess) {
                            rgbdPostProcess.dispose();
                        }
                        // Internal Swap
                        expandedTexture._swapAndDie(internalTexture);
                        // Ready to get rolling again.
                        internalTexture.isReady = true;
                    });
                }
            };
            if (isReady) {
                expandRGBDTexture();
            }
            else {
                texture.onLoadObservable.addOnce(expandRGBDTexture);
            }
        }
        /**
         * Encode the texture to RGBD if possible.
         * @param internalTexture the texture to encode
         * @param scene the scene hosting the texture
         * @param outputTextureType type of the texture in which the encoding is performed
         * @returns a promise with the internalTexture having its texture replaced by the result of the processing
         */
        static EncodeTextureToRGBD(internalTexture, scene, outputTextureType = 0) {
            return ApplyPostProcess("rgbdEncode", internalTexture, scene, outputTextureType, 1, 5);
        }
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _environmentBRDFBase64Texture = "data:image/png;base64,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";
    let _instanceNumber = 0;
    /**
     * Gets a default environment BRDF for MS-BRDF Height Correlated BRDF
     * @param scene defines the hosting scene
     * @returns the environment BRDF texture
     */
    const GetEnvironmentBRDFTexture = (scene) => {
        if (!scene.environmentBRDFTexture) {
            // Forces Delayed Texture Loading to prevent undefined error whilst setting RGBD values.
            const useDelayedTextureLoading = scene.useDelayedTextureLoading;
            scene.useDelayedTextureLoading = false;
            const previousState = scene._blockEntityCollection;
            scene._blockEntityCollection = false;
            const texture = Texture.CreateFromBase64String(_environmentBRDFBase64Texture, "EnvironmentBRDFTexture" + _instanceNumber++, scene, true, false, Texture.BILINEAR_SAMPLINGMODE);
            scene._blockEntityCollection = previousState;
            // BRDF Texture should not be cached here due to pre processing and redundant scene caches.
            const texturesCache = scene.getEngine().getLoadedTexturesCache();
            const index = texturesCache.indexOf(texture.getInternalTexture());
            if (index !== -1) {
                texturesCache.splice(index, 1);
            }
            texture.isRGBD = true;
            texture.wrapU = Texture.CLAMP_ADDRESSMODE;
            texture.wrapV = Texture.CLAMP_ADDRESSMODE;
            scene.environmentBRDFTexture = texture;
            scene.useDelayedTextureLoading = useDelayedTextureLoading;
            RGBDTextureTools.ExpandRGBDTexture(texture);
            const observer = scene.getEngine().onContextRestoredObservable.add(() => {
                texture.isRGBD = true;
                const checkReady = () => {
                    if (texture.isReady()) {
                        RGBDTextureTools.ExpandRGBDTexture(texture);
                    }
                    else {
                        Tools.SetImmediate(checkReady);
                    }
                };
                checkReady();
            });
            scene.onDisposeObservable.add(() => {
                scene.getEngine().onContextRestoredObservable.remove(observer);
            });
        }
        return scene.environmentBRDFTexture;
    };

    /**
     * @internal
     */
    class MaterialBRDFDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.BRDF_V_HEIGHT_CORRELATED = false;
            this.MS_BRDF_ENERGY_CONSERVATION = false;
            this.SPHERICAL_HARMONICS = false;
            this.SPECULAR_GLOSSINESS_ENERGY_CONSERVATION = false;
        }
    }
    /**
     * Plugin that implements the BRDF component of the PBR material
     */
    class PBRBRDFConfiguration extends MaterialPluginBase {
        /** @internal */
        _markAllSubMeshesAsMiscDirty() {
            this._internalMarkAllSubMeshesAsMiscDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "PBRBRDF", 90, new MaterialBRDFDefines(), addToPluginList);
            this._useEnergyConservation = PBRBRDFConfiguration.DEFAULT_USE_ENERGY_CONSERVATION;
            /**
             * Defines if the material uses energy conservation.
             */
            this.useEnergyConservation = PBRBRDFConfiguration.DEFAULT_USE_ENERGY_CONSERVATION;
            this._useSmithVisibilityHeightCorrelated = PBRBRDFConfiguration.DEFAULT_USE_SMITH_VISIBILITY_HEIGHT_CORRELATED;
            /**
             * LEGACY Mode set to false
             * Defines if the material uses height smith correlated visibility term.
             * If you intent to not use our default BRDF, you need to load a separate BRDF Texture for the PBR
             * You can either load https://assets.babylonjs.com/environments/uncorrelatedBRDF.png
             * or https://assets.babylonjs.com/environments/uncorrelatedBRDF.dds to have more precision
             * Not relying on height correlated will also disable energy conservation.
             */
            this.useSmithVisibilityHeightCorrelated = PBRBRDFConfiguration.DEFAULT_USE_SMITH_VISIBILITY_HEIGHT_CORRELATED;
            this._useSphericalHarmonics = PBRBRDFConfiguration.DEFAULT_USE_SPHERICAL_HARMONICS;
            /**
             * LEGACY Mode set to false
             * Defines if the material uses spherical harmonics vs spherical polynomials for the
             * diffuse part of the IBL.
             * The harmonics despite a tiny bigger cost has been proven to provide closer results
             * to the ground truth.
             */
            this.useSphericalHarmonics = PBRBRDFConfiguration.DEFAULT_USE_SPHERICAL_HARMONICS;
            this._useSpecularGlossinessInputEnergyConservation = PBRBRDFConfiguration.DEFAULT_USE_SPECULAR_GLOSSINESS_INPUT_ENERGY_CONSERVATION;
            /**
             * Defines if the material uses energy conservation, when the specular workflow is active.
             * If activated, the albedo color is multiplied with (1. - maxChannel(specular color)).
             * If deactivated, a material is only physically plausible, when (albedo color + specular color) < 1.
             * In the deactivated case, the material author has to ensure energy conservation, for a physically plausible rendering.
             */
            this.useSpecularGlossinessInputEnergyConservation = PBRBRDFConfiguration.DEFAULT_USE_SPECULAR_GLOSSINESS_INPUT_ENERGY_CONSERVATION;
            this._internalMarkAllSubMeshesAsMiscDirty = material._dirtyCallbacks[16];
            this._enable(true);
        }
        prepareDefines(defines) {
            defines.BRDF_V_HEIGHT_CORRELATED = this._useSmithVisibilityHeightCorrelated;
            defines.MS_BRDF_ENERGY_CONSERVATION = this._useEnergyConservation && this._useSmithVisibilityHeightCorrelated;
            defines.SPHERICAL_HARMONICS = this._useSphericalHarmonics;
            defines.SPECULAR_GLOSSINESS_ENERGY_CONSERVATION = this._useSpecularGlossinessInputEnergyConservation;
        }
        getClassName() {
            return "PBRBRDFConfiguration";
        }
    }
    /**
     * Default value used for the energy conservation.
     * This should only be changed to adapt to the type of texture in scene.environmentBRDFTexture.
     */
    PBRBRDFConfiguration.DEFAULT_USE_ENERGY_CONSERVATION = true;
    /**
     * Default value used for the Smith Visibility Height Correlated mode.
     * This should only be changed to adapt to the type of texture in scene.environmentBRDFTexture.
     */
    PBRBRDFConfiguration.DEFAULT_USE_SMITH_VISIBILITY_HEIGHT_CORRELATED = true;
    /**
     * Default value used for the IBL diffuse part.
     * This can help switching back to the polynomials mode globally which is a tiny bit
     * less GPU intensive at the drawback of a lower quality.
     */
    PBRBRDFConfiguration.DEFAULT_USE_SPHERICAL_HARMONICS = true;
    /**
     * Default value used for activating energy conservation for the specular workflow.
     * If activated, the albedo color is multiplied with (1. - maxChannel(specular color)).
     * If deactivated, a material is only physically plausible, when (albedo color + specular color) < 1.
     */
    PBRBRDFConfiguration.DEFAULT_USE_SPECULAR_GLOSSINESS_INPUT_ENERGY_CONSERVATION = true;
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRBRDFConfiguration.prototype, "useEnergyConservation", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRBRDFConfiguration.prototype, "useSmithVisibilityHeightCorrelated", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRBRDFConfiguration.prototype, "useSphericalHarmonics", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRBRDFConfiguration.prototype, "useSpecularGlossinessInputEnergyConservation", void 0);

    class FileFaceOrientation {
        constructor(name, worldAxisForNormal, worldAxisForFileX, worldAxisForFileY) {
            this.name = name;
            this.worldAxisForNormal = worldAxisForNormal;
            this.worldAxisForFileX = worldAxisForFileX;
            this.worldAxisForFileY = worldAxisForFileY;
        }
    }
    /**
     * Helper class dealing with the extraction of spherical polynomial dataArray
     * from a cube map.
     */
    class CubeMapToSphericalPolynomialTools {
        /**
         * Converts a texture to the according Spherical Polynomial data.
         * This extracts the first 3 orders only as they are the only one used in the lighting.
         *
         * @param texture The texture to extract the information from.
         * @returns The Spherical Polynomial data.
         */
        static ConvertCubeMapTextureToSphericalPolynomial(texture) {
            var _a;
            if (!texture.isCube) {
                // Only supports cube Textures currently.
                return null;
            }
            (_a = texture.getScene()) === null || _a === void 0 ? void 0 : _a.getEngine().flushFramebuffer();
            const size = texture.getSize().width;
            const rightPromise = texture.readPixels(0, undefined, undefined, false);
            const leftPromise = texture.readPixels(1, undefined, undefined, false);
            let upPromise;
            let downPromise;
            if (texture.isRenderTarget) {
                upPromise = texture.readPixels(3, undefined, undefined, false);
                downPromise = texture.readPixels(2, undefined, undefined, false);
            }
            else {
                upPromise = texture.readPixels(2, undefined, undefined, false);
                downPromise = texture.readPixels(3, undefined, undefined, false);
            }
            const frontPromise = texture.readPixels(4, undefined, undefined, false);
            const backPromise = texture.readPixels(5, undefined, undefined, false);
            const gammaSpace = texture.gammaSpace;
            // Always read as RGBA.
            const format = 5;
            let type = 0;
            if (texture.textureType == 1 || texture.textureType == 2) {
                type = 1;
            }
            return new Promise((resolve) => {
                Promise.all([leftPromise, rightPromise, upPromise, downPromise, frontPromise, backPromise]).then(([left, right, up, down, front, back]) => {
                    const cubeInfo = {
                        size,
                        right,
                        left,
                        up,
                        down,
                        front,
                        back,
                        format,
                        type,
                        gammaSpace,
                    };
                    resolve(this.ConvertCubeMapToSphericalPolynomial(cubeInfo));
                });
            });
        }
        /**
         * Compute the area on the unit sphere of the rectangle defined by (x,y) and the origin
         * See https://www.rorydriscoll.com/2012/01/15/cubemap-texel-solid-angle/
         * @param x
         * @param y
         */
        static _AreaElement(x, y) {
            return Math.atan2(x * y, Math.sqrt(x * x + y * y + 1));
        }
        /**
         * Converts a cubemap to the according Spherical Polynomial data.
         * This extracts the first 3 orders only as they are the only one used in the lighting.
         *
         * @param cubeInfo The Cube map to extract the information from.
         * @returns The Spherical Polynomial data.
         */
        static ConvertCubeMapToSphericalPolynomial(cubeInfo) {
            const sphericalHarmonics = new SphericalHarmonics();
            let totalSolidAngle = 0.0;
            // The (u,v) range is [-1,+1], so the distance between each texel is 2/Size.
            const du = 2.0 / cubeInfo.size;
            const dv = du;
            const halfTexel = 0.5 * du;
            // The (u,v) of the first texel is half a texel from the corner (-1,-1).
            const minUV = halfTexel - 1.0;
            for (let faceIndex = 0; faceIndex < 6; faceIndex++) {
                const fileFace = this._FileFaces[faceIndex];
                const dataArray = cubeInfo[fileFace.name];
                let v = minUV;
                // TODO: we could perform the summation directly into a SphericalPolynomial (SP), which is more efficient than SphericalHarmonic (SH).
                // This is possible because during the summation we do not need the SH-specific properties, e.g. orthogonality.
                // Because SP is still linear, so summation is fine in that basis.
                const stride = cubeInfo.format === 5 ? 4 : 3;
                for (let y = 0; y < cubeInfo.size; y++) {
                    let u = minUV;
                    for (let x = 0; x < cubeInfo.size; x++) {
                        // World direction (not normalised)
                        const worldDirection = fileFace.worldAxisForFileX.scale(u).add(fileFace.worldAxisForFileY.scale(v)).add(fileFace.worldAxisForNormal);
                        worldDirection.normalize();
                        const deltaSolidAngle = this._AreaElement(u - halfTexel, v - halfTexel) -
                            this._AreaElement(u - halfTexel, v + halfTexel) -
                            this._AreaElement(u + halfTexel, v - halfTexel) +
                            this._AreaElement(u + halfTexel, v + halfTexel);
                        let r = dataArray[y * cubeInfo.size * stride + x * stride + 0];
                        let g = dataArray[y * cubeInfo.size * stride + x * stride + 1];
                        let b = dataArray[y * cubeInfo.size * stride + x * stride + 2];
                        // Prevent NaN harmonics with extreme HDRI data.
                        if (isNaN(r)) {
                            r = 0;
                        }
                        if (isNaN(g)) {
                            g = 0;
                        }
                        if (isNaN(b)) {
                            b = 0;
                        }
                        // Handle Integer types.
                        if (cubeInfo.type === 0) {
                            r /= 255;
                            g /= 255;
                            b /= 255;
                        }
                        // Handle Gamma space textures.
                        if (cubeInfo.gammaSpace) {
                            r = Math.pow(Scalar.Clamp(r), ToLinearSpace);
                            g = Math.pow(Scalar.Clamp(g), ToLinearSpace);
                            b = Math.pow(Scalar.Clamp(b), ToLinearSpace);
                        }
                        // Prevent to explode in case of really high dynamic ranges.
                        // sh 3 would not be enough to accurately represent it.
                        const max = this.MAX_HDRI_VALUE;
                        if (this.PRESERVE_CLAMPED_COLORS) {
                            const currentMax = Math.max(r, g, b);
                            if (currentMax > max) {
                                const factor = max / currentMax;
                                r *= factor;
                                g *= factor;
                                b *= factor;
                            }
                        }
                        else {
                            r = Scalar.Clamp(r, 0, max);
                            g = Scalar.Clamp(g, 0, max);
                            b = Scalar.Clamp(b, 0, max);
                        }
                        const color = new Color3(r, g, b);
                        sphericalHarmonics.addLight(worldDirection, color, deltaSolidAngle);
                        totalSolidAngle += deltaSolidAngle;
                        u += du;
                    }
                    v += dv;
                }
            }
            // Solid angle for entire sphere is 4*pi
            const sphereSolidAngle = 4.0 * Math.PI;
            // Adjust the solid angle to allow for how many faces we processed.
            const facesProcessed = 6.0;
            const expectedSolidAngle = (sphereSolidAngle * facesProcessed) / 6.0;
            // Adjust the harmonics so that the accumulated solid angle matches the expected solid angle.
            // This is needed because the numerical integration over the cube uses a
            // small angle approximation of solid angle for each texel (see deltaSolidAngle),
            // and also to compensate for accumulative error due to float precision in the summation.
            const correctionFactor = expectedSolidAngle / totalSolidAngle;
            sphericalHarmonics.scaleInPlace(correctionFactor);
            sphericalHarmonics.convertIncidentRadianceToIrradiance();
            sphericalHarmonics.convertIrradianceToLambertianRadiance();
            return SphericalPolynomial.FromHarmonics(sphericalHarmonics);
        }
    }
    CubeMapToSphericalPolynomialTools._FileFaces = [
        new FileFaceOrientation("right", new Vector3(1, 0, 0), new Vector3(0, 0, -1), new Vector3(0, -1, 0)),
        new FileFaceOrientation("left", new Vector3(-1, 0, 0), new Vector3(0, 0, 1), new Vector3(0, -1, 0)),
        new FileFaceOrientation("up", new Vector3(0, 1, 0), new Vector3(1, 0, 0), new Vector3(0, 0, 1)),
        new FileFaceOrientation("down", new Vector3(0, -1, 0), new Vector3(1, 0, 0), new Vector3(0, 0, -1)),
        new FileFaceOrientation("front", new Vector3(0, 0, 1), new Vector3(1, 0, 0), new Vector3(0, -1, 0)),
        new FileFaceOrientation("back", new Vector3(0, 0, -1), new Vector3(-1, 0, 0), new Vector3(0, -1, 0)), // -Z bottom
    ];
    /** @internal */
    CubeMapToSphericalPolynomialTools.MAX_HDRI_VALUE = 4096;
    /** @internal */
    CubeMapToSphericalPolynomialTools.PRESERVE_CLAMPED_COLORS = false;

    BaseTexture.prototype.forceSphericalPolynomialsRecompute = function () {
        if (this._texture) {
            this._texture._sphericalPolynomial = null;
            this._texture._sphericalPolynomialPromise = null;
            this._texture._sphericalPolynomialComputed = false;
        }
    };
    Object.defineProperty(BaseTexture.prototype, "sphericalPolynomial", {
        get: function () {
            if (this._texture) {
                if (this._texture._sphericalPolynomial || this._texture._sphericalPolynomialComputed) {
                    return this._texture._sphericalPolynomial;
                }
                if (this._texture.isReady) {
                    if (!this._texture._sphericalPolynomialPromise) {
                        this._texture._sphericalPolynomialPromise = CubeMapToSphericalPolynomialTools.ConvertCubeMapTextureToSphericalPolynomial(this);
                        if (this._texture._sphericalPolynomialPromise === null) {
                            this._texture._sphericalPolynomialComputed = true;
                        }
                        else {
                            this._texture._sphericalPolynomialPromise.then((sphericalPolynomial) => {
                                this._texture._sphericalPolynomial = sphericalPolynomial;
                                this._texture._sphericalPolynomialComputed = true;
                            });
                        }
                    }
                    return null;
                }
            }
            return null;
        },
        set: function (value) {
            if (this._texture) {
                this._texture._sphericalPolynomial = value;
            }
        },
        enumerable: true,
        configurable: true,
    });

    // Do not edit.
    const name$13 = "pbrFragmentDeclaration";
    const shader$13 = `uniform vec4 vEyePosition;uniform vec3 vReflectionColor;uniform vec4 vAlbedoColor;uniform vec4 vLightingIntensity;uniform vec4 vReflectivityColor;uniform vec4 vMetallicReflectanceFactors;uniform vec3 vEmissiveColor;uniform float visibility;uniform vec3 vAmbientColor;
#ifdef ALBEDO
uniform vec2 vAlbedoInfos;
#endif
#ifdef AMBIENT
uniform vec4 vAmbientInfos;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#ifdef OPACITY
uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;
#endif
#ifdef REFLECTIVITY
uniform vec3 vReflectivityInfos;
#endif
#ifdef MICROSURFACEMAP
uniform vec2 vMicroSurfaceSamplerInfos;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(SS_REFRACTION) || defined(PREPASS)
uniform mat4 view;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;
#ifdef REALTIME_FILTERING
uniform vec2 vReflectionFilteringInfo;
#endif
uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;
#if defined(USE_LOCAL_REFLECTIONMAP_CUBIC) && defined(REFLECTIONMAP_CUBIC)
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize; 
#endif
#endif
#if defined(SS_REFRACTION) && defined(SS_USE_LOCAL_REFRACTIONMAP_CUBIC)
uniform vec3 vRefractionPosition;uniform vec3 vRefractionSize; 
#endif
#ifdef CLEARCOAT
uniform vec2 vClearCoatParams;uniform vec4 vClearCoatRefractionParams;
#if defined(CLEARCOAT_TEXTURE) || defined(CLEARCOAT_TEXTURE_ROUGHNESS)
uniform vec4 vClearCoatInfos;
#endif
#ifdef CLEARCOAT_TEXTURE
uniform mat4 clearCoatMatrix;
#endif
#ifdef CLEARCOAT_TEXTURE_ROUGHNESS
uniform mat4 clearCoatRoughnessMatrix;
#endif
#ifdef CLEARCOAT_BUMP
uniform vec2 vClearCoatBumpInfos;uniform vec2 vClearCoatTangentSpaceParams;uniform mat4 clearCoatBumpMatrix;
#endif
#ifdef CLEARCOAT_TINT
uniform vec4 vClearCoatTintParams;uniform float clearCoatColorAtDistance;
#ifdef CLEARCOAT_TINT_TEXTURE
uniform vec2 vClearCoatTintInfos;uniform mat4 clearCoatTintMatrix;
#endif
#endif
#endif
#ifdef IRIDESCENCE
uniform vec4 vIridescenceParams;
#if defined(IRIDESCENCE_TEXTURE) || defined(IRIDESCENCE_THICKNESS_TEXTURE)
uniform vec4 vIridescenceInfos;
#endif
#ifdef IRIDESCENCE_TEXTURE
uniform mat4 iridescenceMatrix;
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
uniform mat4 iridescenceThicknessMatrix;
#endif
#endif
#ifdef ANISOTROPIC
uniform vec3 vAnisotropy;
#ifdef ANISOTROPIC_TEXTURE
uniform vec2 vAnisotropyInfos;uniform mat4 anisotropyMatrix;
#endif
#endif
#ifdef SHEEN
uniform vec4 vSheenColor;
#ifdef SHEEN_ROUGHNESS
uniform float vSheenRoughness;
#endif
#if defined(SHEEN_TEXTURE) || defined(SHEEN_TEXTURE_ROUGHNESS)
uniform vec4 vSheenInfos;
#endif
#ifdef SHEEN_TEXTURE
uniform mat4 sheenMatrix;
#endif
#ifdef SHEEN_TEXTURE_ROUGHNESS
uniform mat4 sheenRoughnessMatrix;
#endif
#endif
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
uniform vec4 vRefractionMicrosurfaceInfos;uniform vec4 vRefractionInfos;uniform mat4 refractionMatrix;
#ifdef REALTIME_FILTERING
uniform vec2 vRefractionFilteringInfo;
#endif
#endif
#ifdef SS_THICKNESSANDMASK_TEXTURE
uniform vec2 vThicknessInfos;uniform mat4 thicknessMatrix;
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
uniform vec2 vRefractionIntensityInfos;uniform mat4 refractionIntensityMatrix;
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
uniform vec2 vTranslucencyIntensityInfos;uniform mat4 translucencyIntensityMatrix;
#endif
uniform vec2 vThicknessParam;uniform vec3 vDiffusionDistance;uniform vec4 vTintColor;uniform vec3 vSubSurfaceIntensity;
#endif
#ifdef PREPASS
#ifdef SS_SCATTERING
uniform float scatteringDiffusionProfile;
#endif
#endif
#if DEBUGMODE>0
uniform vec2 vDebugMode;
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;
#endif
#include<decalFragmentDeclaration>
#ifdef USESPHERICALFROMREFLECTIONMAP
#ifdef SPHERICAL_HARMONICS
uniform vec3 vSphericalL00;uniform vec3 vSphericalL1_1;uniform vec3 vSphericalL10;uniform vec3 vSphericalL11;uniform vec3 vSphericalL2_2;uniform vec3 vSphericalL2_1;uniform vec3 vSphericalL20;uniform vec3 vSphericalL21;uniform vec3 vSphericalL22;
#else
uniform vec3 vSphericalX;uniform vec3 vSphericalY;uniform vec3 vSphericalZ;uniform vec3 vSphericalXX_ZZ;uniform vec3 vSphericalYY_ZZ;uniform vec3 vSphericalZZ;uniform vec3 vSphericalXY;uniform vec3 vSphericalYZ;uniform vec3 vSphericalZX;
#endif
#endif
#define ADDITIONAL_FRAGMENT_DECLARATION
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$13] = shader$13;

    // Do not edit.
    const name$14 = "pbrUboDeclaration";
    const shader$14 = `layout(std140,column_major) uniform;uniform Material {vec2 vAlbedoInfos;vec4 vAmbientInfos;vec2 vOpacityInfos;vec2 vEmissiveInfos;vec2 vLightmapInfos;vec3 vReflectivityInfos;vec2 vMicroSurfaceSamplerInfos;vec2 vReflectionInfos;vec2 vReflectionFilteringInfo;vec3 vReflectionPosition;vec3 vReflectionSize;vec3 vBumpInfos;mat4 albedoMatrix;mat4 ambientMatrix;mat4 opacityMatrix;mat4 emissiveMatrix;mat4 lightmapMatrix;mat4 reflectivityMatrix;mat4 microSurfaceSamplerMatrix;mat4 bumpMatrix;vec2 vTangentSpaceParams;mat4 reflectionMatrix;vec3 vReflectionColor;vec4 vAlbedoColor;vec4 vLightingIntensity;vec3 vReflectionMicrosurfaceInfos;float pointSize;vec4 vReflectivityColor;vec3 vEmissiveColor;vec3 vAmbientColor;vec2 vDebugMode;vec4 vMetallicReflectanceFactors;vec2 vMetallicReflectanceInfos;mat4 metallicReflectanceMatrix;vec2 vReflectanceInfos;mat4 reflectanceMatrix;vec3 vSphericalL00;vec3 vSphericalL1_1;vec3 vSphericalL10;vec3 vSphericalL11;vec3 vSphericalL2_2;vec3 vSphericalL2_1;vec3 vSphericalL20;vec3 vSphericalL21;vec3 vSphericalL22;vec3 vSphericalX;vec3 vSphericalY;vec3 vSphericalZ;vec3 vSphericalXX_ZZ;vec3 vSphericalYY_ZZ;vec3 vSphericalZZ;vec3 vSphericalXY;vec3 vSphericalYZ;vec3 vSphericalZX;
#define ADDITIONAL_UBO_DECLARATION
};
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$14] = shader$14;

    // Do not edit.
    const name$15 = "pbrFragmentExtraDeclaration";
    const shader$15 = `varying vec3 vPositionW;
#if DEBUGMODE>0
varying vec4 vClipSpacePosition;
#endif
#include<mainUVVaryingDeclaration>[1..7]
#ifdef NORMAL
varying vec3 vNormalW;
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
varying vec3 vEnvironmentIrradiance;
#endif
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$15] = shader$15;

    // Do not edit.
    const name$16 = "samplerFragmentAlternateDeclaration";
    const shader$16 = `#ifdef _DEFINENAME_
#if _DEFINENAME_DIRECTUV==1
#define v_VARYINGNAME_UV vMainUV1
#elif _DEFINENAME_DIRECTUV==2
#define v_VARYINGNAME_UV vMainUV2
#elif _DEFINENAME_DIRECTUV==3
#define v_VARYINGNAME_UV vMainUV3
#elif _DEFINENAME_DIRECTUV==4
#define v_VARYINGNAME_UV vMainUV4
#elif _DEFINENAME_DIRECTUV==5
#define v_VARYINGNAME_UV vMainUV5
#elif _DEFINENAME_DIRECTUV==6
#define v_VARYINGNAME_UV vMainUV6
#else
varying vec2 v_VARYINGNAME_UV;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$16] = shader$16;

    // Do not edit.
    const name$17 = "pbrFragmentSamplersDeclaration";
    const shader$17 = `#include<samplerFragmentDeclaration>(_DEFINENAME_,ALBEDO,_VARYINGNAME_,Albedo,_SAMPLERNAME_,albedo)
#include<samplerFragmentDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_SAMPLERNAME_,ambient)
#include<samplerFragmentDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_SAMPLERNAME_,opacity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_SAMPLERNAME_,emissive)
#include<samplerFragmentDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_SAMPLERNAME_,lightmap)
#include<samplerFragmentDeclaration>(_DEFINENAME_,REFLECTIVITY,_VARYINGNAME_,Reflectivity,_SAMPLERNAME_,reflectivity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,MICROSURFACEMAP,_VARYINGNAME_,MicroSurfaceSampler,_SAMPLERNAME_,microSurface)
#include<samplerFragmentDeclaration>(_DEFINENAME_,METALLIC_REFLECTANCE,_VARYINGNAME_,MetallicReflectance,_SAMPLERNAME_,metallicReflectance)
#include<samplerFragmentDeclaration>(_DEFINENAME_,REFLECTANCE,_VARYINGNAME_,Reflectance,_SAMPLERNAME_,reflectance)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_SAMPLERNAME_,decal)
#ifdef CLEARCOAT
#include<samplerFragmentDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE,_VARYINGNAME_,ClearCoat,_SAMPLERNAME_,clearCoat)
#include<samplerFragmentAlternateDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE_ROUGHNESS,_VARYINGNAME_,ClearCoatRoughness)
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL)
uniform sampler2D clearCoatRoughnessSampler;
#endif
#include<samplerFragmentDeclaration>(_DEFINENAME_,CLEARCOAT_BUMP,_VARYINGNAME_,ClearCoatBump,_SAMPLERNAME_,clearCoatBump)
#include<samplerFragmentDeclaration>(_DEFINENAME_,CLEARCOAT_TINT_TEXTURE,_VARYINGNAME_,ClearCoatTint,_SAMPLERNAME_,clearCoatTint)
#endif
#ifdef IRIDESCENCE
#include<samplerFragmentDeclaration>(_DEFINENAME_,IRIDESCENCE_TEXTURE,_VARYINGNAME_,Iridescence,_SAMPLERNAME_,iridescence)
#include<samplerFragmentDeclaration>(_DEFINENAME_,IRIDESCENCE_THICKNESS_TEXTURE,_VARYINGNAME_,IridescenceThickness,_SAMPLERNAME_,iridescenceThickness)
#endif
#ifdef SHEEN
#include<samplerFragmentDeclaration>(_DEFINENAME_,SHEEN_TEXTURE,_VARYINGNAME_,Sheen,_SAMPLERNAME_,sheen)
#include<samplerFragmentAlternateDeclaration>(_DEFINENAME_,SHEEN_TEXTURE_ROUGHNESS,_VARYINGNAME_,SheenRoughness)
#if defined(SHEEN_ROUGHNESS) && defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL)
uniform sampler2D sheenRoughnessSampler;
#endif
#endif
#ifdef ANISOTROPIC
#include<samplerFragmentDeclaration>(_DEFINENAME_,ANISOTROPIC_TEXTURE,_VARYINGNAME_,Anisotropy,_SAMPLERNAME_,anisotropy)
#endif
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
#define sampleReflection(s,c) textureCube(s,c)
uniform samplerCube reflectionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleReflectionLod(s,c,l) textureCubeLodEXT(s,c,l)
#else
uniform samplerCube reflectionSamplerLow;uniform samplerCube reflectionSamplerHigh;
#endif
#ifdef USEIRRADIANCEMAP
uniform samplerCube irradianceSampler;
#endif
#else
#define sampleReflection(s,c) texture2D(s,c)
uniform sampler2D reflectionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleReflectionLod(s,c,l) texture2DLodEXT(s,c,l)
#else
uniform sampler2D reflectionSamplerLow;uniform sampler2D reflectionSamplerHigh;
#endif
#ifdef USEIRRADIANCEMAP
uniform sampler2D irradianceSampler;
#endif
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#endif
#ifdef ENVIRONMENTBRDF
uniform sampler2D environmentBrdfSampler;
#endif
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
#ifdef SS_REFRACTIONMAP_3D
#define sampleRefraction(s,c) textureCube(s,c)
uniform samplerCube refractionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleRefractionLod(s,c,l) textureCubeLodEXT(s,c,l)
#else
uniform samplerCube refractionSamplerLow;uniform samplerCube refractionSamplerHigh;
#endif
#else
#define sampleRefraction(s,c) texture2D(s,c)
uniform sampler2D refractionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleRefractionLod(s,c,l) texture2DLodEXT(s,c,l)
#else
uniform sampler2D refractionSamplerLow;uniform sampler2D refractionSamplerHigh;
#endif
#endif
#endif
#include<samplerFragmentDeclaration>(_DEFINENAME_,SS_THICKNESSANDMASK_TEXTURE,_VARYINGNAME_,Thickness,_SAMPLERNAME_,thickness)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SS_REFRACTIONINTENSITY_TEXTURE,_VARYINGNAME_,RefractionIntensity,_SAMPLERNAME_,refractionIntensity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SS_TRANSLUCENCYINTENSITY_TEXTURE,_VARYINGNAME_,TranslucencyIntensity,_SAMPLERNAME_,translucencyIntensity)
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$17] = shader$17;

    // Do not edit.
    const name$18 = "subSurfaceScatteringFunctions";
    const shader$18 = `bool testLightingForSSS(float diffusionProfile)
{return diffusionProfile<1.;}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$18] = shader$18;

    // Do not edit.
    const name$19 = "importanceSampling";
    const shader$19 = `vec3 hemisphereCosSample(vec2 u) {float phi=2.*PI*u.x;float cosTheta2=1.-u.y;float cosTheta=sqrt(cosTheta2);float sinTheta=sqrt(1.-cosTheta2);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}
vec3 hemisphereImportanceSampleDggx(vec2 u,float a) {float phi=2.*PI*u.x;float cosTheta2=(1.-u.y)/(1.+(a+1.)*((a-1.)*u.y));float cosTheta=sqrt(cosTheta2);float sinTheta=sqrt(1.-cosTheta2);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}
vec3 hemisphereImportanceSampleDCharlie(vec2 u,float a) { 
float phi=2.*PI*u.x;float sinTheta=pow(u.y,a/(2.*a+1.));float cosTheta=sqrt(1.-sinTheta*sinTheta);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$19] = shader$19;

    // Do not edit.
    const name$1a = "pbrHelperFunctions";
    const shader$1a = `#define RECIPROCAL_PI2 0.15915494
#define RECIPROCAL_PI 0.31830988618
#define MINIMUMVARIANCE 0.0005
float convertRoughnessToAverageSlope(float roughness)
{return square(roughness)+MINIMUMVARIANCE;}
float fresnelGrazingReflectance(float reflectance0) {float reflectance90=saturate(reflectance0*25.0);return reflectance90;}
vec2 getAARoughnessFactors(vec3 normalVector) {
#ifdef SPECULARAA
vec3 nDfdx=dFdx(normalVector.xyz);vec3 nDfdy=dFdy(normalVector.xyz);float slopeSquare=max(dot(nDfdx,nDfdx),dot(nDfdy,nDfdy));float geometricRoughnessFactor=pow(saturate(slopeSquare),0.333);float geometricAlphaGFactor=sqrt(slopeSquare);geometricAlphaGFactor*=0.75;return vec2(geometricRoughnessFactor,geometricAlphaGFactor);
#else
return vec2(0.);
#endif
}
#ifdef ANISOTROPIC
#ifdef ANISOTROPIC_LEGACY
vec2 getAnisotropicRoughness(float alphaG,float anisotropy) {float alphaT=max(alphaG*(1.0+anisotropy),MINIMUMVARIANCE);float alphaB=max(alphaG*(1.0-anisotropy),MINIMUMVARIANCE);return vec2(alphaT,alphaB);}
vec3 getAnisotropicBentNormals(const vec3 T,const vec3 B,const vec3 N,const vec3 V,float anisotropy,float roughness) {vec3 anisotropicFrameDirection=anisotropy>=0.0 ? B : T;vec3 anisotropicFrameTangent=cross(normalize(anisotropicFrameDirection),V);vec3 anisotropicFrameNormal=cross(anisotropicFrameTangent,anisotropicFrameDirection);vec3 anisotropicNormal=normalize(mix(N,anisotropicFrameNormal,abs(anisotropy)));return anisotropicNormal;}
#else
vec2 getAnisotropicRoughness(float alphaG,float anisotropy) {float alphaT=max(mix(alphaG,1.0,anisotropy*anisotropy),MINIMUMVARIANCE);float alphaB=max(alphaG,MINIMUMVARIANCE);return vec2(alphaT,alphaB);}
vec3 getAnisotropicBentNormals(const vec3 T,const vec3 B,const vec3 N,const vec3 V,float anisotropy,float roughness) {vec3 bentNormal=cross(B,V);bentNormal=normalize(cross(bentNormal,B));float a=square(square(1.0-anisotropy*(1.0-roughness)));bentNormal=normalize(mix(bentNormal,N,a));return bentNormal;}
#endif
#endif
#if defined(CLEARCOAT) || defined(SS_REFRACTION)
vec3 cocaLambert(vec3 alpha,float distance) {return exp(-alpha*distance);}
vec3 cocaLambert(float NdotVRefract,float NdotLRefract,vec3 alpha,float thickness) {return cocaLambert(alpha,(thickness*((NdotLRefract+NdotVRefract)/(NdotLRefract*NdotVRefract))));}
vec3 computeColorAtDistanceInMedia(vec3 color,float distance) {return -log(color)/distance;}
vec3 computeClearCoatAbsorption(float NdotVRefract,float NdotLRefract,vec3 clearCoatColor,float clearCoatThickness,float clearCoatIntensity) {vec3 clearCoatAbsorption=mix(vec3(1.0),
cocaLambert(NdotVRefract,NdotLRefract,clearCoatColor,clearCoatThickness),
clearCoatIntensity);return clearCoatAbsorption;}
#endif
#ifdef MICROSURFACEAUTOMATIC
float computeDefaultMicroSurface(float microSurface,vec3 reflectivityColor)
{const float kReflectivityNoAlphaWorkflow_SmoothnessMax=0.95;float reflectivityLuminance=getLuminance(reflectivityColor);float reflectivityLuma=sqrt(reflectivityLuminance);microSurface=reflectivityLuma*kReflectivityNoAlphaWorkflow_SmoothnessMax;return microSurface;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1a] = shader$1a;

    // Do not edit.
    const name$1b = "harmonicsFunctions";
    const shader$1b = `#ifdef USESPHERICALFROMREFLECTIONMAP
#ifdef SPHERICAL_HARMONICS
vec3 computeEnvironmentIrradiance(vec3 normal) {return vSphericalL00
+ vSphericalL1_1*(normal.y)
+ vSphericalL10*(normal.z)
+ vSphericalL11*(normal.x)
+ vSphericalL2_2*(normal.y*normal.x)
+ vSphericalL2_1*(normal.y*normal.z)
+ vSphericalL20*((3.0*normal.z*normal.z)-1.0)
+ vSphericalL21*(normal.z*normal.x)
+ vSphericalL22*(normal.x*normal.x-(normal.y*normal.y));}
#else
vec3 computeEnvironmentIrradiance(vec3 normal) {float Nx=normal.x;float Ny=normal.y;float Nz=normal.z;vec3 C1=vSphericalZZ.rgb;vec3 Cx=vSphericalX.rgb;vec3 Cy=vSphericalY.rgb;vec3 Cz=vSphericalZ.rgb;vec3 Cxx_zz=vSphericalXX_ZZ.rgb;vec3 Cyy_zz=vSphericalYY_ZZ.rgb;vec3 Cxy=vSphericalXY.rgb;vec3 Cyz=vSphericalYZ.rgb;vec3 Czx=vSphericalZX.rgb;vec3 a1=Cyy_zz*Ny+Cy;vec3 a2=Cyz*Nz+a1;vec3 b1=Czx*Nz+Cx;vec3 b2=Cxy*Ny+b1;vec3 b3=Cxx_zz*Nx+b2;vec3 t1=Cz *Nz+C1;vec3 t2=a2 *Ny+t1;vec3 t3=b3 *Nx+t2;return t3;}
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1b] = shader$1b;

    // Do not edit.
    const name$1c = "pbrDirectLightingSetupFunctions";
    const shader$1c = `struct preLightingInfo
{vec3 lightOffset;float lightDistanceSquared;float lightDistance;float attenuation;vec3 L;vec3 H;float NdotV;float NdotLUnclamped;float NdotL;float VdotH;float roughness;
#ifdef IRIDESCENCE
float iridescenceIntensity;
#endif
};preLightingInfo computePointAndSpotPreLightingInfo(vec4 lightData,vec3 V,vec3 N) {preLightingInfo result;result.lightOffset=lightData.xyz-vPositionW;result.lightDistanceSquared=dot(result.lightOffset,result.lightOffset);result.lightDistance=sqrt(result.lightDistanceSquared);result.L=normalize(result.lightOffset);result.H=normalize(V+result.L);result.VdotH=saturate(dot(V,result.H));result.NdotLUnclamped=dot(N,result.L);result.NdotL=saturateEps(result.NdotLUnclamped);return result;}
preLightingInfo computeDirectionalPreLightingInfo(vec4 lightData,vec3 V,vec3 N) {preLightingInfo result;result.lightDistance=length(-lightData.xyz);result.L=normalize(-lightData.xyz);result.H=normalize(V+result.L);result.VdotH=saturate(dot(V,result.H));result.NdotLUnclamped=dot(N,result.L);result.NdotL=saturateEps(result.NdotLUnclamped);return result;}
preLightingInfo computeHemisphericPreLightingInfo(vec4 lightData,vec3 V,vec3 N) {preLightingInfo result;result.NdotL=dot(N,lightData.xyz)*0.5+0.5;result.NdotL=saturateEps(result.NdotL);result.NdotLUnclamped=result.NdotL;
#ifdef SPECULARTERM
result.L=normalize(lightData.xyz);result.H=normalize(V+result.L);result.VdotH=saturate(dot(V,result.H));
#endif
return result;}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1c] = shader$1c;

    // Do not edit.
    const name$1d = "pbrDirectLightingFalloffFunctions";
    const shader$1d = `float computeDistanceLightFalloff_Standard(vec3 lightOffset,float range)
{return max(0.,1.0-length(lightOffset)/range);}
float computeDistanceLightFalloff_Physical(float lightDistanceSquared)
{return 1.0/maxEps(lightDistanceSquared);}
float computeDistanceLightFalloff_GLTF(float lightDistanceSquared,float inverseSquaredRange)
{float lightDistanceFalloff=1.0/maxEps(lightDistanceSquared);float factor=lightDistanceSquared*inverseSquaredRange;float attenuation=saturate(1.0-factor*factor);attenuation*=attenuation;lightDistanceFalloff*=attenuation;return lightDistanceFalloff;}
float computeDistanceLightFalloff(vec3 lightOffset,float lightDistanceSquared,float range,float inverseSquaredRange)
{
#ifdef USEPHYSICALLIGHTFALLOFF
return computeDistanceLightFalloff_Physical(lightDistanceSquared);
#elif defined(USEGLTFLIGHTFALLOFF)
return computeDistanceLightFalloff_GLTF(lightDistanceSquared,inverseSquaredRange);
#else
return computeDistanceLightFalloff_Standard(lightOffset,range);
#endif
}
float computeDirectionalLightFalloff_Standard(vec3 lightDirection,vec3 directionToLightCenterW,float cosHalfAngle,float exponent)
{float falloff=0.0;float cosAngle=maxEps(dot(-lightDirection,directionToLightCenterW));if (cosAngle>=cosHalfAngle)
{falloff=max(0.,pow(cosAngle,exponent));}
return falloff;}
float computeDirectionalLightFalloff_Physical(vec3 lightDirection,vec3 directionToLightCenterW,float cosHalfAngle)
{const float kMinusLog2ConeAngleIntensityRatio=6.64385618977; 
float concentrationKappa=kMinusLog2ConeAngleIntensityRatio/(1.0-cosHalfAngle);vec4 lightDirectionSpreadSG=vec4(-lightDirection*concentrationKappa,-concentrationKappa);float falloff=exp2(dot(vec4(directionToLightCenterW,1.0),lightDirectionSpreadSG));return falloff;}
float computeDirectionalLightFalloff_GLTF(vec3 lightDirection,vec3 directionToLightCenterW,float lightAngleScale,float lightAngleOffset)
{float cd=dot(-lightDirection,directionToLightCenterW);float falloff=saturate(cd*lightAngleScale+lightAngleOffset);falloff*=falloff;return falloff;}
float computeDirectionalLightFalloff(vec3 lightDirection,vec3 directionToLightCenterW,float cosHalfAngle,float exponent,float lightAngleScale,float lightAngleOffset)
{
#ifdef USEPHYSICALLIGHTFALLOFF
return computeDirectionalLightFalloff_Physical(lightDirection,directionToLightCenterW,cosHalfAngle);
#elif defined(USEGLTFLIGHTFALLOFF)
return computeDirectionalLightFalloff_GLTF(lightDirection,directionToLightCenterW,lightAngleScale,lightAngleOffset);
#else
return computeDirectionalLightFalloff_Standard(lightDirection,directionToLightCenterW,cosHalfAngle,exponent);
#endif
}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1d] = shader$1d;

    // Do not edit.
    const name$1e = "pbrBRDFFunctions";
    const shader$1e = `#define FRESNEL_MAXIMUM_ON_ROUGH 0.25
#ifdef MS_BRDF_ENERGY_CONSERVATION
vec3 getEnergyConservationFactor(const vec3 specularEnvironmentR0,const vec3 environmentBrdf) {return 1.0+specularEnvironmentR0*(1.0/environmentBrdf.y-1.0);}
#endif
#ifdef ENVIRONMENTBRDF
vec3 getBRDFLookup(float NdotV,float perceptualRoughness) {vec2 UV=vec2(NdotV,perceptualRoughness);vec4 brdfLookup=texture2D(environmentBrdfSampler,UV);
#ifdef ENVIRONMENTBRDF_RGBD
brdfLookup.rgb=fromRGBD(brdfLookup.rgba);
#endif
return brdfLookup.rgb;}
vec3 getReflectanceFromBRDFLookup(const vec3 specularEnvironmentR0,const vec3 specularEnvironmentR90,const vec3 environmentBrdf) {
#ifdef BRDF_V_HEIGHT_CORRELATED
vec3 reflectance=(specularEnvironmentR90-specularEnvironmentR0)*environmentBrdf.x+specularEnvironmentR0*environmentBrdf.y;
#else
vec3 reflectance=specularEnvironmentR0*environmentBrdf.x+specularEnvironmentR90*environmentBrdf.y;
#endif
return reflectance;}
vec3 getReflectanceFromBRDFLookup(const vec3 specularEnvironmentR0,const vec3 environmentBrdf) {
#ifdef BRDF_V_HEIGHT_CORRELATED
vec3 reflectance=mix(environmentBrdf.xxx,environmentBrdf.yyy,specularEnvironmentR0);
#else
vec3 reflectance=specularEnvironmentR0*environmentBrdf.x+environmentBrdf.y;
#endif
return reflectance;}
#endif
/* NOT USED
#if defined(SHEEN) && defined(SHEEN_SOFTER)
float getBRDFLookupCharlieSheen(float NdotV,float perceptualRoughness)
{float c=1.0-NdotV;float c3=c*c*c;return 0.65584461*c3+1.0/(4.16526551+exp(-7.97291361*perceptualRoughness+6.33516894));}
#endif
*/
#if !defined(ENVIRONMENTBRDF) || defined(REFLECTIONMAP_SKYBOX) || defined(ALPHAFRESNEL)
vec3 getReflectanceFromAnalyticalBRDFLookup_Jones(float VdotN,vec3 reflectance0,vec3 reflectance90,float smoothness)
{float weight=mix(FRESNEL_MAXIMUM_ON_ROUGH,1.0,smoothness);return reflectance0+weight*(reflectance90-reflectance0)*pow5(saturate(1.0-VdotN));}
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF)
/**
* The sheen BRDF not containing F can be easily stored in the blue channel of the BRDF texture.
* The blue channel contains DCharlie*VAshikhmin*NdotL as a lokkup table
*/
vec3 getSheenReflectanceFromBRDFLookup(const vec3 reflectance0,const vec3 environmentBrdf) {vec3 sheenEnvironmentReflectance=reflectance0*environmentBrdf.b;return sheenEnvironmentReflectance;}
#endif
vec3 fresnelSchlickGGX(float VdotH,vec3 reflectance0,vec3 reflectance90)
{return reflectance0+(reflectance90-reflectance0)*pow5(1.0-VdotH);}
float fresnelSchlickGGX(float VdotH,float reflectance0,float reflectance90)
{return reflectance0+(reflectance90-reflectance0)*pow5(1.0-VdotH);}
#ifdef CLEARCOAT
vec3 getR0RemappedForClearCoat(vec3 f0) {
#ifdef CLEARCOAT_DEFAULTIOR
#ifdef MOBILE
return saturate(f0*(f0*0.526868+0.529324)-0.0482256);
#else
return saturate(f0*(f0*(0.941892-0.263008*f0)+0.346479)-0.0285998);
#endif
#else
vec3 s=sqrt(f0);vec3 t=(vClearCoatRefractionParams.z+vClearCoatRefractionParams.w*s)/(vClearCoatRefractionParams.w+vClearCoatRefractionParams.z*s);return square(t);
#endif
}
#endif
#ifdef IRIDESCENCE
const mat3 XYZ_TO_REC709=mat3(
3.2404542,-0.9692660, 0.0556434,
-1.5371385, 1.8760108,-0.2040259,
-0.4985314, 0.0415560, 1.0572252
);vec3 getIORTfromAirToSurfaceR0(vec3 f0) {vec3 sqrtF0=sqrt(f0);return (1.+sqrtF0)/(1.-sqrtF0);}
vec3 getR0fromIORs(vec3 iorT,float iorI) {return square((iorT-vec3(iorI))/(iorT+vec3(iorI)));}
float getR0fromIORs(float iorT,float iorI) {return square((iorT-iorI)/(iorT+iorI));}
vec3 evalSensitivity(float opd,vec3 shift) {float phase=2.0*PI*opd*1.0e-9;const vec3 val=vec3(5.4856e-13,4.4201e-13,5.2481e-13);const vec3 pos=vec3(1.6810e+06,1.7953e+06,2.2084e+06);const vec3 var=vec3(4.3278e+09,9.3046e+09,6.6121e+09);vec3 xyz=val*sqrt(2.0*PI*var)*cos(pos*phase+shift)*exp(-square(phase)*var);xyz.x+=9.7470e-14*sqrt(2.0*PI*4.5282e+09)*cos(2.2399e+06*phase+shift[0])*exp(-4.5282e+09*square(phase));xyz/=1.0685e-7;vec3 srgb=XYZ_TO_REC709*xyz;return srgb;}
vec3 evalIridescence(float outsideIOR,float eta2,float cosTheta1,float thinFilmThickness,vec3 baseF0) {vec3 I=vec3(1.0);float iridescenceIOR=mix(outsideIOR,eta2,smoothstep(0.0,0.03,thinFilmThickness));float sinTheta2Sq=square(outsideIOR/iridescenceIOR)*(1.0-square(cosTheta1));float cosTheta2Sq=1.0-sinTheta2Sq;if (cosTheta2Sq<0.0) {return I;}
float cosTheta2=sqrt(cosTheta2Sq);float R0=getR0fromIORs(iridescenceIOR,outsideIOR);float R12=fresnelSchlickGGX(cosTheta1,R0,1.);float R21=R12;float T121=1.0-R12;float phi12=0.0;if (iridescenceIOR<outsideIOR) phi12=PI;float phi21=PI-phi12;vec3 baseIOR=getIORTfromAirToSurfaceR0(clamp(baseF0,0.0,0.9999)); 
vec3 R1=getR0fromIORs(baseIOR,iridescenceIOR);vec3 R23=fresnelSchlickGGX(cosTheta2,R1,vec3(1.));vec3 phi23=vec3(0.0);if (baseIOR[0]<iridescenceIOR) phi23[0]=PI;if (baseIOR[1]<iridescenceIOR) phi23[1]=PI;if (baseIOR[2]<iridescenceIOR) phi23[2]=PI;float opd=2.0*iridescenceIOR*thinFilmThickness*cosTheta2;vec3 phi=vec3(phi21)+phi23;vec3 R123=clamp(R12*R23,1e-5,0.9999);vec3 r123=sqrt(R123);vec3 Rs=square(T121)*R23/(vec3(1.0)-R123);vec3 C0=R12+Rs;I=C0;vec3 Cm=Rs-T121;for (int m=1; m<=2; ++m)
{Cm*=r123;vec3 Sm=2.0*evalSensitivity(float(m)*opd,float(m)*phi);I+=Cm*Sm;}
return max(I,vec3(0.0));}
#endif
float normalDistributionFunction_TrowbridgeReitzGGX(float NdotH,float alphaG)
{float a2=square(alphaG);float d=NdotH*NdotH*(a2-1.0)+1.0;return a2/(PI*d*d);}
#ifdef SHEEN
float normalDistributionFunction_CharlieSheen(float NdotH,float alphaG)
{float invR=1./alphaG;float cos2h=NdotH*NdotH;float sin2h=1.-cos2h;return (2.+invR)*pow(sin2h,invR*.5)/(2.*PI);}
#endif
#ifdef ANISOTROPIC
float normalDistributionFunction_BurleyGGX_Anisotropic(float NdotH,float TdotH,float BdotH,const vec2 alphaTB) {float a2=alphaTB.x*alphaTB.y;vec3 v=vec3(alphaTB.y*TdotH,alphaTB.x *BdotH,a2*NdotH);float v2=dot(v,v);float w2=a2/v2;return a2*w2*w2*RECIPROCAL_PI;}
#endif
#ifdef BRDF_V_HEIGHT_CORRELATED
float smithVisibility_GGXCorrelated(float NdotL,float NdotV,float alphaG) {
#ifdef MOBILE
float GGXV=NdotL*(NdotV*(1.0-alphaG)+alphaG);float GGXL=NdotV*(NdotL*(1.0-alphaG)+alphaG);return 0.5/(GGXV+GGXL);
#else
float a2=alphaG*alphaG;float GGXV=NdotL*sqrt(NdotV*(NdotV-a2*NdotV)+a2);float GGXL=NdotV*sqrt(NdotL*(NdotL-a2*NdotL)+a2);return 0.5/(GGXV+GGXL);
#endif
}
#else
float smithVisibilityG1_TrowbridgeReitzGGXFast(float dot,float alphaG)
{
#ifdef MOBILE
return 1.0/(dot+alphaG+(1.0-alphaG)*dot ));
#else
float alphaSquared=alphaG*alphaG;return 1.0/(dot+sqrt(alphaSquared+(1.0-alphaSquared)*dot*dot));
#endif
}
float smithVisibility_TrowbridgeReitzGGXFast(float NdotL,float NdotV,float alphaG)
{float visibility=smithVisibilityG1_TrowbridgeReitzGGXFast(NdotL,alphaG)*smithVisibilityG1_TrowbridgeReitzGGXFast(NdotV,alphaG);return visibility;}
#endif
#ifdef ANISOTROPIC
float smithVisibility_GGXCorrelated_Anisotropic(float NdotL,float NdotV,float TdotV,float BdotV,float TdotL,float BdotL,const vec2 alphaTB) {float lambdaV=NdotL*length(vec3(alphaTB.x*TdotV,alphaTB.y*BdotV,NdotV));float lambdaL=NdotV*length(vec3(alphaTB.x*TdotL,alphaTB.y*BdotL,NdotL));float v=0.5/(lambdaV+lambdaL);return v;}
#endif
#ifdef CLEARCOAT
float visibility_Kelemen(float VdotH) {return 0.25/(VdotH*VdotH); }
#endif
#ifdef SHEEN
float visibility_Ashikhmin(float NdotL,float NdotV)
{return 1./(4.*(NdotL+NdotV-NdotL*NdotV));}
/* NOT USED
#ifdef SHEEN_SOFTER
float l(float x,float alphaG)
{float oneMinusAlphaSq=(1.0-alphaG)*(1.0-alphaG);float a=mix(21.5473,25.3245,oneMinusAlphaSq);float b=mix(3.82987,3.32435,oneMinusAlphaSq);float c=mix(0.19823,0.16801,oneMinusAlphaSq);float d=mix(-1.97760,-1.27393,oneMinusAlphaSq);float e=mix(-4.32054,-4.85967,oneMinusAlphaSq);return a/(1.0+b*pow(x,c))+d*x+e;}
float lambdaSheen(float cosTheta,float alphaG)
{return abs(cosTheta)<0.5 ? exp(l(cosTheta,alphaG)) : exp(2.0*l(0.5,alphaG)-l(1.0-cosTheta,alphaG));}
float visibility_CharlieSheen(float NdotL,float NdotV,float alphaG)
{float G=1.0/(1.0+lambdaSheen(NdotV,alphaG)+lambdaSheen(NdotL,alphaG));return G/(4.0*NdotV*NdotL);}
#endif
*/
#endif
float diffuseBRDF_Burley(float NdotL,float NdotV,float VdotH,float roughness) {float diffuseFresnelNV=pow5(saturateEps(1.0-NdotL));float diffuseFresnelNL=pow5(saturateEps(1.0-NdotV));float diffuseFresnel90=0.5+2.0*VdotH*VdotH*roughness;float fresnel =
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNL) *
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNV);return fresnel/PI;}
#ifdef SS_TRANSLUCENCY
vec3 transmittanceBRDF_Burley(const vec3 tintColor,const vec3 diffusionDistance,float thickness) {vec3 S=1./maxEps(diffusionDistance);vec3 temp=exp((-0.333333333*thickness)*S);return tintColor.rgb*0.25*(temp*temp*temp+3.0*temp);}
float computeWrappedDiffuseNdotL(float NdotL,float w) {float t=1.0+w;float invt2=1.0/square(t);return saturate((NdotL+w)*invt2);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1e] = shader$1e;

    // Do not edit.
    const name$1f = "hdrFilteringFunctions";
    const shader$1f = `#ifdef NUM_SAMPLES
#if NUM_SAMPLES>0
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
float radicalInverse_VdC(uint bits) 
{bits=(bits<<16u) | (bits>>16u);bits=((bits & 0x55555555u)<<1u) | ((bits & 0xAAAAAAAAu)>>1u);bits=((bits & 0x33333333u)<<2u) | ((bits & 0xCCCCCCCCu)>>2u);bits=((bits & 0x0F0F0F0Fu)<<4u) | ((bits & 0xF0F0F0F0u)>>4u);bits=((bits & 0x00FF00FFu)<<8u) | ((bits & 0xFF00FF00u)>>8u);return float(bits)*2.3283064365386963e-10; }
vec2 hammersley(uint i,uint N)
{return vec2(float(i)/float(N),radicalInverse_VdC(i));}
#else
float vanDerCorpus(int n,int base)
{float invBase=1.0/float(base);float denom =1.0;float result =0.0;for(int i=0; i<32; ++i)
{if(n>0)
{denom =mod(float(n),2.0);result+=denom*invBase;invBase=invBase/2.0;n =int(float(n)/2.0);}}
return result;}
vec2 hammersley(int i,int N)
{return vec2(float(i)/float(N),vanDerCorpus(i,2));}
#endif
float log4(float x) {return log2(x)/2.;}
const float NUM_SAMPLES_FLOAT=float(NUM_SAMPLES);const float NUM_SAMPLES_FLOAT_INVERSED=1./NUM_SAMPLES_FLOAT;const float K=4.;
#define inline
vec3 irradiance(samplerCube inputTexture,vec3 inputN,vec2 filteringInfo)
{vec3 n=normalize(inputN);vec3 result=vec3(0.0);vec3 tangent=abs(n.z)<0.999 ? vec3(0.,0.,1.) : vec3(1.,0.,0.);tangent=normalize(cross(tangent,n));vec3 bitangent=cross(n,tangent);mat3 tbn=mat3(tangent,bitangent,n);float maxLevel=filteringInfo.y;float dim0=filteringInfo.x;float omegaP=(4.*PI)/(6.*dim0*dim0);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
for(uint i=0u; i<NUM_SAMPLES; ++i)
#else
for(int i=0; i<NUM_SAMPLES; ++i)
#endif
{vec2 Xi=hammersley(i,NUM_SAMPLES);vec3 Ls=hemisphereCosSample(Xi);Ls=normalize(Ls);vec3 Ns=vec3(0.,0.,1.);float NoL=dot(Ns,Ls);if (NoL>0.) {float pdf_inversed=PI/NoL;float omegaS=NUM_SAMPLES_FLOAT_INVERSED*pdf_inversed;float l=log4(omegaS)-log4(omegaP)+log4(K);float mipLevel=clamp(l,0.0,maxLevel);vec3 c=textureCubeLodEXT(inputTexture,tbn*Ls,mipLevel).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
result+=c;}}
result=result*NUM_SAMPLES_FLOAT_INVERSED;return result;}
#define inline
vec3 radiance(float alphaG,samplerCube inputTexture,vec3 inputN,vec2 filteringInfo)
{vec3 n=normalize(inputN);if (alphaG==0.) {vec3 c=textureCube(inputTexture,n).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
return c;} else {vec3 result=vec3(0.);vec3 tangent=abs(n.z)<0.999 ? vec3(0.,0.,1.) : vec3(1.,0.,0.);tangent=normalize(cross(tangent,n));vec3 bitangent=cross(n,tangent);mat3 tbn=mat3(tangent,bitangent,n);float maxLevel=filteringInfo.y;float dim0=filteringInfo.x;float omegaP=(4.*PI)/(6.*dim0*dim0);float weight=0.;
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
for(uint i=0u; i<NUM_SAMPLES; ++i)
#else
for(int i=0; i<NUM_SAMPLES; ++i)
#endif
{vec2 Xi=hammersley(i,NUM_SAMPLES);vec3 H=hemisphereImportanceSampleDggx(Xi,alphaG);float NoV=1.;float NoH=H.z;float NoH2=H.z*H.z;float NoL=2.*NoH2-1.;vec3 L=vec3(2.*NoH*H.x,2.*NoH*H.y,NoL);L=normalize(L);if (NoL>0.) {float pdf_inversed=4./normalDistributionFunction_TrowbridgeReitzGGX(NoH,alphaG);float omegaS=NUM_SAMPLES_FLOAT_INVERSED*pdf_inversed;float l=log4(omegaS)-log4(omegaP)+log4(K);float mipLevel=clamp(float(l),0.0,maxLevel);weight+=NoL;vec3 c=textureCubeLodEXT(inputTexture,tbn*L,mipLevel).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
result+=c*NoL;}}
result=result/weight;return result;}}
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1f] = shader$1f;

    // Do not edit.
    const name$1g = "pbrDirectLightingFunctions";
    const shader$1g = `#define CLEARCOATREFLECTANCE90 1.0
struct lightingInfo
{vec3 diffuse;
#ifdef SPECULARTERM
vec3 specular;
#endif
#ifdef CLEARCOAT
vec4 clearCoat;
#endif
#ifdef SHEEN
vec3 sheen;
#endif
};float adjustRoughnessFromLightProperties(float roughness,float lightRadius,float lightDistance) {
#if defined(USEPHYSICALLIGHTFALLOFF) || defined(USEGLTFLIGHTFALLOFF)
float lightRoughness=lightRadius/lightDistance;float totalRoughness=saturate(lightRoughness+roughness);return totalRoughness;
#else
return roughness;
#endif
}
vec3 computeHemisphericDiffuseLighting(preLightingInfo info,vec3 lightColor,vec3 groundColor) {return mix(groundColor,lightColor,info.NdotL);}
vec3 computeDiffuseLighting(preLightingInfo info,vec3 lightColor) {float diffuseTerm=diffuseBRDF_Burley(info.NdotL,info.NdotV,info.VdotH,info.roughness);return diffuseTerm*info.attenuation*info.NdotL*lightColor;}
#define inline
vec3 computeProjectionTextureDiffuseLighting(sampler2D projectionLightSampler,mat4 textureProjectionMatrix){vec4 strq=textureProjectionMatrix*vec4(vPositionW,1.0);strq/=strq.w;vec3 textureColor=texture2D(projectionLightSampler,strq.xy).rgb;return toLinearSpace(textureColor);}
#ifdef SS_TRANSLUCENCY
vec3 computeDiffuseAndTransmittedLighting(preLightingInfo info,vec3 lightColor,vec3 transmittance) {float NdotL=absEps(info.NdotLUnclamped);float wrapNdotL=computeWrappedDiffuseNdotL(NdotL,0.02);float trAdapt=step(0.,info.NdotLUnclamped);vec3 transmittanceNdotL=mix(transmittance*wrapNdotL,vec3(wrapNdotL),trAdapt);float diffuseTerm=diffuseBRDF_Burley(NdotL,info.NdotV,info.VdotH,info.roughness);return diffuseTerm*transmittanceNdotL*info.attenuation*lightColor;}
#endif
#ifdef SPECULARTERM
vec3 computeSpecularLighting(preLightingInfo info,vec3 N,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor,vec3 lightColor) {float NdotH=saturateEps(dot(N,info.H));float roughness=max(info.roughness,geometricRoughnessFactor);float alphaG=convertRoughnessToAverageSlope(roughness);vec3 fresnel=fresnelSchlickGGX(info.VdotH,reflectance0,reflectance90);
#ifdef IRIDESCENCE
fresnel=mix(fresnel,reflectance0,info.iridescenceIntensity);
#endif
float distribution=normalDistributionFunction_TrowbridgeReitzGGX(NdotH,alphaG);
#ifdef BRDF_V_HEIGHT_CORRELATED
float smithVisibility=smithVisibility_GGXCorrelated(info.NdotL,info.NdotV,alphaG);
#else
float smithVisibility=smithVisibility_TrowbridgeReitzGGXFast(info.NdotL,info.NdotV,alphaG);
#endif
vec3 specTerm=fresnel*distribution*smithVisibility;return specTerm*info.attenuation*info.NdotL*lightColor;}
#endif
#ifdef ANISOTROPIC
vec3 computeAnisotropicSpecularLighting(preLightingInfo info,vec3 V,vec3 N,vec3 T,vec3 B,float anisotropy,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor,vec3 lightColor) {float NdotH=saturateEps(dot(N,info.H));float TdotH=dot(T,info.H);float BdotH=dot(B,info.H);float TdotV=dot(T,V);float BdotV=dot(B,V);float TdotL=dot(T,info.L);float BdotL=dot(B,info.L);float alphaG=convertRoughnessToAverageSlope(info.roughness);vec2 alphaTB=getAnisotropicRoughness(alphaG,anisotropy);alphaTB=max(alphaTB,square(geometricRoughnessFactor));vec3 fresnel=fresnelSchlickGGX(info.VdotH,reflectance0,reflectance90);
#ifdef IRIDESCENCE
fresnel=mix(fresnel,reflectance0,info.iridescenceIntensity);
#endif
float distribution=normalDistributionFunction_BurleyGGX_Anisotropic(NdotH,TdotH,BdotH,alphaTB);float smithVisibility=smithVisibility_GGXCorrelated_Anisotropic(info.NdotL,info.NdotV,TdotV,BdotV,TdotL,BdotL,alphaTB);vec3 specTerm=fresnel*distribution*smithVisibility;return specTerm*info.attenuation*info.NdotL*lightColor;}
#endif
#ifdef CLEARCOAT
vec4 computeClearCoatLighting(preLightingInfo info,vec3 Ncc,float geometricRoughnessFactor,float clearCoatIntensity,vec3 lightColor) {float NccdotL=saturateEps(dot(Ncc,info.L));float NccdotH=saturateEps(dot(Ncc,info.H));float clearCoatRoughness=max(info.roughness,geometricRoughnessFactor);float alphaG=convertRoughnessToAverageSlope(clearCoatRoughness);float fresnel=fresnelSchlickGGX(info.VdotH,vClearCoatRefractionParams.x,CLEARCOATREFLECTANCE90);fresnel*=clearCoatIntensity;float distribution=normalDistributionFunction_TrowbridgeReitzGGX(NccdotH,alphaG);float kelemenVisibility=visibility_Kelemen(info.VdotH);float clearCoatTerm=fresnel*distribution*kelemenVisibility;return vec4(
clearCoatTerm*info.attenuation*NccdotL*lightColor,
1.0-fresnel
);}
vec3 computeClearCoatLightingAbsorption(float NdotVRefract,vec3 L,vec3 Ncc,vec3 clearCoatColor,float clearCoatThickness,float clearCoatIntensity) {vec3 LRefract=-refract(L,Ncc,vClearCoatRefractionParams.y);float NdotLRefract=saturateEps(dot(Ncc,LRefract));vec3 absorption=computeClearCoatAbsorption(NdotVRefract,NdotLRefract,clearCoatColor,clearCoatThickness,clearCoatIntensity);return absorption;}
#endif
#ifdef SHEEN
vec3 computeSheenLighting(preLightingInfo info,vec3 N,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor,vec3 lightColor) {float NdotH=saturateEps(dot(N,info.H));float roughness=max(info.roughness,geometricRoughnessFactor);float alphaG=convertRoughnessToAverageSlope(roughness);float fresnel=1.;float distribution=normalDistributionFunction_CharlieSheen(NdotH,alphaG);/*#ifdef SHEEN_SOFTER
float visibility=visibility_CharlieSheen(info.NdotL,info.NdotV,alphaG);
#else */
float visibility=visibility_Ashikhmin(info.NdotL,info.NdotV);/* #endif */
float sheenTerm=fresnel*distribution*visibility;return sheenTerm*info.attenuation*info.NdotL*lightColor;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1g] = shader$1g;

    // Do not edit.
    const name$1h = "pbrIBLFunctions";
    const shader$1h = `#if defined(REFLECTION) || defined(SS_REFRACTION)
float getLodFromAlphaG(float cubeMapDimensionPixels,float microsurfaceAverageSlope) {float microsurfaceAverageSlopeTexels=cubeMapDimensionPixels*microsurfaceAverageSlope;float lod=log2(microsurfaceAverageSlopeTexels);return lod;}
float getLinearLodFromRoughness(float cubeMapDimensionPixels,float roughness) {float lod=log2(cubeMapDimensionPixels)*roughness;return lod;}
#endif
#if defined(ENVIRONMENTBRDF) && defined(RADIANCEOCCLUSION)
float environmentRadianceOcclusion(float ambientOcclusion,float NdotVUnclamped) {float temp=NdotVUnclamped+ambientOcclusion;return saturate(square(temp)-1.0+ambientOcclusion);}
#endif
#if defined(ENVIRONMENTBRDF) && defined(HORIZONOCCLUSION)
float environmentHorizonOcclusion(vec3 view,vec3 normal,vec3 geometricNormal) {vec3 reflection=reflect(view,normal);float temp=saturate(1.0+1.1*dot(reflection,geometricNormal));return square(temp);}
#endif
#if defined(LODINREFLECTIONALPHA) || defined(SS_LODINREFRACTIONALPHA)
#define UNPACK_LOD(x) (1.0-x)*255.0
float getLodFromAlphaG(float cubeMapDimensionPixels,float alphaG,float NdotV) {float microsurfaceAverageSlope=alphaG;microsurfaceAverageSlope*=sqrt(abs(NdotV));return getLodFromAlphaG(cubeMapDimensionPixels,microsurfaceAverageSlope);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1h] = shader$1h;

    // Do not edit.
    const name$1i = "pbrBlockAlbedoOpacity";
    const shader$1i = `struct albedoOpacityOutParams
{vec3 surfaceAlbedo;float alpha;};
#define pbr_inline
void albedoOpacityBlock(
in vec4 vAlbedoColor,
#ifdef ALBEDO
in vec4 albedoTexture,
in vec2 albedoInfos,
#endif
#ifdef OPACITY
in vec4 opacityMap,
in vec2 vOpacityInfos,
#endif
#ifdef DETAIL
in vec4 detailColor,
in vec4 vDetailInfos,
#endif
#ifdef DECAL
in vec4 decalColor,
in vec4 vDecalInfos,
#endif
out albedoOpacityOutParams outParams
)
{vec3 surfaceAlbedo=vAlbedoColor.rgb;float alpha=vAlbedoColor.a;
#ifdef ALBEDO
#if defined(ALPHAFROMALBEDO) || defined(ALPHATEST)
alpha*=albedoTexture.a;
#endif
#ifdef GAMMAALBEDO
surfaceAlbedo*=toLinearSpace(albedoTexture.rgb);
#else
surfaceAlbedo*=albedoTexture.rgb;
#endif
surfaceAlbedo*=albedoInfos.y;
#endif
#ifndef DECAL_AFTER_DETAIL
#include<decalFragment>
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
surfaceAlbedo*=vColor.rgb;
#endif
#ifdef DETAIL
float detailAlbedo=2.0*mix(0.5,detailColor.r,vDetailInfos.y);surfaceAlbedo.rgb=surfaceAlbedo.rgb*detailAlbedo*detailAlbedo; 
#endif
#ifdef DECAL_AFTER_DETAIL
#include<decalFragment>
#endif
#define CUSTOM_FRAGMENT_UPDATE_ALBEDO
#ifdef OPACITY
#ifdef OPACITYRGB
alpha=getLuminance(opacityMap.rgb);
#else
alpha*=opacityMap.a;
#endif
alpha*=vOpacityInfos.y;
#endif
#if defined(VERTEXALPHA) || defined(INSTANCESCOLOR) && defined(INSTANCES)
alpha*=vColor.a;
#endif
#if !defined(SS_LINKREFRACTIONTOTRANSPARENCY) && !defined(ALPHAFRESNEL)
#ifdef ALPHATEST 
#if DEBUGMODE != 88
if (alpha<ALPHATESTVALUE)
discard;
#endif
#ifndef ALPHABLEND
alpha=1.0;
#endif
#endif
#endif
outParams.surfaceAlbedo=surfaceAlbedo;outParams.alpha=alpha;}
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1i] = shader$1i;

    // Do not edit.
    const name$1j = "pbrBlockReflectivity";
    const shader$1j = `struct reflectivityOutParams
{float microSurface;float roughness;vec3 surfaceReflectivityColor;
#ifdef METALLICWORKFLOW
vec3 surfaceAlbedo;
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
vec3 ambientOcclusionColor;
#endif
#if DEBUGMODE>0
#ifdef METALLICWORKFLOW
vec2 metallicRoughness;
#ifdef REFLECTIVITY
vec4 surfaceMetallicColorMap;
#endif
#ifndef FROSTBITE_REFLECTANCE
vec3 metallicF0;
#endif
#else
#ifdef REFLECTIVITY
vec4 surfaceReflectivityColorMap;
#endif
#endif
#endif
};
#define pbr_inline
void reflectivityBlock(
in vec4 vReflectivityColor,
#ifdef METALLICWORKFLOW
in vec3 surfaceAlbedo,
in vec4 metallicReflectanceFactors,
#endif
#ifdef REFLECTIVITY
in vec3 reflectivityInfos,
in vec4 surfaceMetallicOrReflectivityColorMap,
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
in vec3 ambientOcclusionColorIn,
#endif
#ifdef MICROSURFACEMAP
in vec4 microSurfaceTexel,
#endif
#ifdef DETAIL
in vec4 detailColor,
in vec4 vDetailInfos,
#endif
out reflectivityOutParams outParams
)
{float microSurface=vReflectivityColor.a;vec3 surfaceReflectivityColor=vReflectivityColor.rgb;
#ifdef METALLICWORKFLOW
vec2 metallicRoughness=surfaceReflectivityColor.rg;
#ifdef REFLECTIVITY
#if DEBUGMODE>0
outParams.surfaceMetallicColorMap=surfaceMetallicOrReflectivityColorMap;
#endif
#ifdef AOSTOREINMETALMAPRED
vec3 aoStoreInMetalMap=vec3(surfaceMetallicOrReflectivityColorMap.r,surfaceMetallicOrReflectivityColorMap.r,surfaceMetallicOrReflectivityColorMap.r);outParams.ambientOcclusionColor=mix(ambientOcclusionColorIn,aoStoreInMetalMap,reflectivityInfos.z);
#endif
#ifdef METALLNESSSTOREINMETALMAPBLUE
metallicRoughness.r*=surfaceMetallicOrReflectivityColorMap.b;
#else
metallicRoughness.r*=surfaceMetallicOrReflectivityColorMap.r;
#endif
#ifdef ROUGHNESSSTOREINMETALMAPALPHA
metallicRoughness.g*=surfaceMetallicOrReflectivityColorMap.a;
#else
#ifdef ROUGHNESSSTOREINMETALMAPGREEN
metallicRoughness.g*=surfaceMetallicOrReflectivityColorMap.g;
#endif
#endif
#endif
#ifdef DETAIL
float detailRoughness=mix(0.5,detailColor.b,vDetailInfos.w);float loLerp=mix(0.,metallicRoughness.g,detailRoughness*2.);float hiLerp=mix(metallicRoughness.g,1.,(detailRoughness-0.5)*2.);metallicRoughness.g=mix(loLerp,hiLerp,step(detailRoughness,0.5));
#endif
#ifdef MICROSURFACEMAP
metallicRoughness.g*=microSurfaceTexel.r;
#endif
#if DEBUGMODE>0
outParams.metallicRoughness=metallicRoughness;
#endif
#define CUSTOM_FRAGMENT_UPDATE_METALLICROUGHNESS
microSurface=1.0-metallicRoughness.g;vec3 baseColor=surfaceAlbedo;
#ifdef FROSTBITE_REFLECTANCE
outParams.surfaceAlbedo=baseColor.rgb*(1.0-metallicRoughness.r);surfaceReflectivityColor=mix(0.16*reflectance*reflectance,baseColor,metallicRoughness.r);
#else
vec3 metallicF0=metallicReflectanceFactors.rgb;
#if DEBUGMODE>0
outParams.metallicF0=metallicF0;
#endif
outParams.surfaceAlbedo=mix(baseColor.rgb*(1.0-metallicF0),vec3(0.,0.,0.),metallicRoughness.r);surfaceReflectivityColor=mix(metallicF0,baseColor,metallicRoughness.r);
#endif
#else
#ifdef REFLECTIVITY
surfaceReflectivityColor*=surfaceMetallicOrReflectivityColorMap.rgb;
#if DEBUGMODE>0
outParams.surfaceReflectivityColorMap=surfaceMetallicOrReflectivityColorMap;
#endif
#ifdef MICROSURFACEFROMREFLECTIVITYMAP
microSurface*=surfaceMetallicOrReflectivityColorMap.a;microSurface*=reflectivityInfos.z;
#else
#ifdef MICROSURFACEAUTOMATIC
microSurface*=computeDefaultMicroSurface(microSurface,surfaceReflectivityColor);
#endif
#ifdef MICROSURFACEMAP
microSurface*=microSurfaceTexel.r;
#endif
#define CUSTOM_FRAGMENT_UPDATE_MICROSURFACE
#endif
#endif
#endif
microSurface=saturate(microSurface);float roughness=1.-microSurface;outParams.microSurface=microSurface;outParams.roughness=roughness;outParams.surfaceReflectivityColor=surfaceReflectivityColor;}
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1j] = shader$1j;

    // Do not edit.
    const name$1k = "pbrBlockAmbientOcclusion";
    const shader$1k = `struct ambientOcclusionOutParams
{vec3 ambientOcclusionColor;
#if DEBUGMODE>0 && defined(AMBIENT)
vec3 ambientOcclusionColorMap;
#endif
};
#define pbr_inline
void ambientOcclusionBlock(
#ifdef AMBIENT
in vec3 ambientOcclusionColorMap_,
in vec4 vAmbientInfos,
#endif
out ambientOcclusionOutParams outParams
)
{vec3 ambientOcclusionColor=vec3(1.,1.,1.);
#ifdef AMBIENT
vec3 ambientOcclusionColorMap=ambientOcclusionColorMap_*vAmbientInfos.y;
#ifdef AMBIENTINGRAYSCALE
ambientOcclusionColorMap=vec3(ambientOcclusionColorMap.r,ambientOcclusionColorMap.r,ambientOcclusionColorMap.r);
#endif
ambientOcclusionColor=mix(ambientOcclusionColor,ambientOcclusionColorMap,vAmbientInfos.z);
#if DEBUGMODE>0
outParams.ambientOcclusionColorMap=ambientOcclusionColorMap;
#endif
#endif
outParams.ambientOcclusionColor=ambientOcclusionColor;}
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1k] = shader$1k;

    // Do not edit.
    const name$1l = "pbrBlockAlphaFresnel";
    const shader$1l = `#ifdef ALPHAFRESNEL
#if defined(ALPHATEST) || defined(ALPHABLEND)
struct alphaFresnelOutParams
{float alpha;};
#define pbr_inline
void alphaFresnelBlock(
in vec3 normalW,
in vec3 viewDirectionW,
in float alpha,
in float microSurface,
out alphaFresnelOutParams outParams
)
{float opacityPerceptual=alpha;
#ifdef LINEARALPHAFRESNEL
float opacity0=opacityPerceptual;
#else
float opacity0=opacityPerceptual*opacityPerceptual;
#endif
float opacity90=fresnelGrazingReflectance(opacity0);vec3 normalForward=faceforward(normalW,-viewDirectionW,normalW);outParams.alpha=getReflectanceFromAnalyticalBRDFLookup_Jones(saturate(dot(viewDirectionW,normalForward)),vec3(opacity0),vec3(opacity90),sqrt(microSurface)).x;
#ifdef ALPHATEST
if (outParams.alpha<ALPHATESTVALUE)
discard;
#ifndef ALPHABLEND
outParams.alpha=1.0;
#endif
#endif
}
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1l] = shader$1l;

    // Do not edit.
    const name$1m = "pbrBlockAnisotropic";
    const shader$1m = `#ifdef ANISOTROPIC
struct anisotropicOutParams
{float anisotropy;vec3 anisotropicTangent;vec3 anisotropicBitangent;vec3 anisotropicNormal;
#if DEBUGMODE>0 && defined(ANISOTROPIC_TEXTURE)
vec3 anisotropyMapData;
#endif
};
#define pbr_inline
void anisotropicBlock(
in vec3 vAnisotropy,
in float roughness,
#ifdef ANISOTROPIC_TEXTURE
in vec3 anisotropyMapData,
#endif
in mat3 TBN,
in vec3 normalW,
in vec3 viewDirectionW,
out anisotropicOutParams outParams
)
{float anisotropy=vAnisotropy.b;vec3 anisotropyDirection=vec3(vAnisotropy.xy,0.);
#ifdef ANISOTROPIC_TEXTURE
anisotropy*=anisotropyMapData.b;
#if DEBUGMODE>0
outParams.anisotropyMapData=anisotropyMapData;
#endif
anisotropyMapData.rg=anisotropyMapData.rg*2.0-1.0;
#ifdef ANISOTROPIC_LEGACY
anisotropyDirection.rg*=anisotropyMapData.rg;
#else
anisotropyDirection.xy=mat2(anisotropyDirection.x,anisotropyDirection.y,-anisotropyDirection.y,anisotropyDirection.x)*normalize(anisotropyMapData.rg);
#endif
#endif
mat3 anisoTBN=mat3(normalize(TBN[0]),normalize(TBN[1]),normalize(TBN[2]));vec3 anisotropicTangent=normalize(anisoTBN*anisotropyDirection);vec3 anisotropicBitangent=normalize(cross(anisoTBN[2],anisotropicTangent));outParams.anisotropy=anisotropy;outParams.anisotropicTangent=anisotropicTangent;outParams.anisotropicBitangent=anisotropicBitangent;outParams.anisotropicNormal=getAnisotropicBentNormals(anisotropicTangent,anisotropicBitangent,normalW,viewDirectionW,anisotropy,roughness);}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1m] = shader$1m;

    // Do not edit.
    const name$1n = "pbrBlockReflection";
    const shader$1n = `#ifdef REFLECTION
struct reflectionOutParams
{vec4 environmentRadiance;vec3 environmentIrradiance;
#ifdef REFLECTIONMAP_3D
vec3 reflectionCoords;
#else
vec2 reflectionCoords;
#endif
#ifdef SS_TRANSLUCENCY
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
vec3 irradianceVector;
#endif
#endif
#endif
};
#define pbr_inline
void createReflectionCoords(
in vec3 vPositionW,
in vec3 normalW,
#ifdef ANISOTROPIC
in anisotropicOutParams anisotropicOut,
#endif
#ifdef REFLECTIONMAP_3D
out vec3 reflectionCoords
#else
out vec2 reflectionCoords
#endif
)
{
#ifdef ANISOTROPIC
vec3 reflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),anisotropicOut.anisotropicNormal);
#else
vec3 reflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#endif
#ifdef REFLECTIONMAP_OPPOSITEZ
reflectionVector.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
reflectionCoords=reflectionVector;
#else
reflectionCoords=reflectionVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
reflectionCoords/=reflectionVector.z;
#endif
reflectionCoords.y=1.0-reflectionCoords.y;
#endif
}
#define pbr_inline
#define inline
void sampleReflectionTexture(
in float alphaG,
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
in float NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
in float roughness,
#endif
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
const vec3 reflectionCoords,
#else
in sampler2D reflectionSampler,
const vec2 reflectionCoords,
#endif
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
out vec4 environmentRadiance
)
{
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
float reflectionLOD=getLodFromAlphaG(vReflectionMicrosurfaceInfos.x,alphaG,NdotVUnclamped);
#elif defined(LINEARSPECULARREFLECTION)
float reflectionLOD=getLinearLodFromRoughness(vReflectionMicrosurfaceInfos.x,roughness);
#else
float reflectionLOD=getLodFromAlphaG(vReflectionMicrosurfaceInfos.x,alphaG);
#endif
#ifdef LODBASEDMICROSFURACE
reflectionLOD=reflectionLOD*vReflectionMicrosurfaceInfos.y+vReflectionMicrosurfaceInfos.z;
#ifdef LODINREFLECTIONALPHA
float automaticReflectionLOD=UNPACK_LOD(sampleReflection(reflectionSampler,reflectionCoords).a);float requestedReflectionLOD=max(automaticReflectionLOD,reflectionLOD);
#else
float requestedReflectionLOD=reflectionLOD;
#endif
#ifdef REALTIME_FILTERING
environmentRadiance=vec4(radiance(alphaG,reflectionSampler,reflectionCoords,vReflectionFilteringInfo),1.0);
#else
environmentRadiance=sampleReflectionLod(reflectionSampler,reflectionCoords,reflectionLOD);
#endif
#else
float lodReflectionNormalized=saturate(reflectionLOD/log2(vReflectionMicrosurfaceInfos.x));float lodReflectionNormalizedDoubled=lodReflectionNormalized*2.0;vec4 environmentMid=sampleReflection(reflectionSampler,reflectionCoords);if (lodReflectionNormalizedDoubled<1.0){environmentRadiance=mix(
sampleReflection(reflectionSamplerHigh,reflectionCoords),
environmentMid,
lodReflectionNormalizedDoubled
);} else {environmentRadiance=mix(
environmentMid,
sampleReflection(reflectionSamplerLow,reflectionCoords),
lodReflectionNormalizedDoubled-1.0
);}
#endif
#ifdef RGBDREFLECTION
environmentRadiance.rgb=fromRGBD(environmentRadiance);
#endif
#ifdef GAMMAREFLECTION
environmentRadiance.rgb=toLinearSpace(environmentRadiance.rgb);
#endif
environmentRadiance.rgb*=vReflectionInfos.x;environmentRadiance.rgb*=vReflectionColor.rgb;}
#define pbr_inline
#define inline
void reflectionBlock(
in vec3 vPositionW,
in vec3 normalW,
in float alphaG,
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
#ifdef ANISOTROPIC
in anisotropicOutParams anisotropicOut,
#endif
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
in float NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
in float roughness,
#endif
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
#else
in sampler2D reflectionSampler,
#endif
#if defined(NORMAL) && defined(USESPHERICALINVERTEX)
in vec3 vEnvironmentIrradiance,
#endif
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
in mat4 reflectionMatrix,
#endif
#endif
#ifdef USEIRRADIANCEMAP
#ifdef REFLECTIONMAP_3D
in samplerCube irradianceSampler,
#else
in sampler2D irradianceSampler,
#endif
#endif
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
out reflectionOutParams outParams
)
{vec4 environmentRadiance=vec4(0.,0.,0.,0.);
#ifdef REFLECTIONMAP_3D
vec3 reflectionCoords=vec3(0.);
#else
vec2 reflectionCoords=vec2(0.);
#endif
createReflectionCoords(
vPositionW,
normalW,
#ifdef ANISOTROPIC
anisotropicOut,
#endif
reflectionCoords
);sampleReflectionTexture(
alphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
roughness,
#endif
#ifdef REFLECTIONMAP_3D
reflectionSampler,
reflectionCoords,
#else
reflectionSampler,
reflectionCoords,
#endif
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
environmentRadiance
);vec3 environmentIrradiance=vec3(0.,0.,0.);
#ifdef USESPHERICALFROMREFLECTIONMAP
#if defined(NORMAL) && defined(USESPHERICALINVERTEX)
environmentIrradiance=vEnvironmentIrradiance;
#else
#ifdef ANISOTROPIC
vec3 irradianceVector=vec3(reflectionMatrix*vec4(anisotropicOut.anisotropicNormal,0)).xyz;
#else
vec3 irradianceVector=vec3(reflectionMatrix*vec4(normalW,0)).xyz;
#endif
#ifdef REFLECTIONMAP_OPPOSITEZ
irradianceVector.z*=-1.0;
#endif
#ifdef INVERTCUBICMAP
irradianceVector.y*=-1.0;
#endif
#if defined(REALTIME_FILTERING)
environmentIrradiance=irradiance(reflectionSampler,irradianceVector,vReflectionFilteringInfo);
#else
environmentIrradiance=computeEnvironmentIrradiance(irradianceVector);
#endif
#ifdef SS_TRANSLUCENCY
outParams.irradianceVector=irradianceVector;
#endif
#endif
#elif defined(USEIRRADIANCEMAP)
vec4 environmentIrradiance4=sampleReflection(irradianceSampler,reflectionCoords);environmentIrradiance=environmentIrradiance4.rgb;
#ifdef RGBDREFLECTION
environmentIrradiance.rgb=fromRGBD(environmentIrradiance4);
#endif
#ifdef GAMMAREFLECTION
environmentIrradiance.rgb=toLinearSpace(environmentIrradiance.rgb);
#endif
#endif
environmentIrradiance*=vReflectionColor.rgb;outParams.environmentRadiance=environmentRadiance;outParams.environmentIrradiance=environmentIrradiance;outParams.reflectionCoords=reflectionCoords;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1n] = shader$1n;

    // Do not edit.
    const name$1o = "pbrBlockSheen";
    const shader$1o = `#ifdef SHEEN
struct sheenOutParams
{float sheenIntensity;vec3 sheenColor;float sheenRoughness;
#ifdef SHEEN_LINKWITHALBEDO
vec3 surfaceAlbedo;
#endif
#if defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
float sheenAlbedoScaling;
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
vec3 finalSheenRadianceScaled;
#endif
#if DEBUGMODE>0
#ifdef SHEEN_TEXTURE
vec4 sheenMapData;
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
vec3 sheenEnvironmentReflectance;
#endif
#endif
};
#define pbr_inline
#define inline
void sheenBlock(
in vec4 vSheenColor,
#ifdef SHEEN_ROUGHNESS
in float vSheenRoughness,
#if defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE)
in vec4 sheenMapRoughnessData,
#endif
#endif
in float roughness,
#ifdef SHEEN_TEXTURE
in vec4 sheenMapData,
in float sheenMapLevel,
#endif
in float reflectance,
#ifdef SHEEN_LINKWITHALBEDO
in vec3 baseColor,
in vec3 surfaceAlbedo,
#endif
#ifdef ENVIRONMENTBRDF
in float NdotV,
in vec3 environmentBrdf,
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
in vec2 AARoughnessFactors,
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
in vec4 vLightingIntensity,
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
in vec3 reflectionCoords,
#else
in sampler2D reflectionSampler,
in vec2 reflectionCoords,
#endif
in float NdotVUnclamped,
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(RADIANCEOCCLUSION)
in float seo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
in float eho,
#endif
#endif
out sheenOutParams outParams
)
{float sheenIntensity=vSheenColor.a;
#ifdef SHEEN_TEXTURE
#if DEBUGMODE>0
outParams.sheenMapData=sheenMapData;
#endif
#endif
#ifdef SHEEN_LINKWITHALBEDO
float sheenFactor=pow5(1.0-sheenIntensity);vec3 sheenColor=baseColor.rgb*(1.0-sheenFactor);float sheenRoughness=sheenIntensity;outParams.surfaceAlbedo=surfaceAlbedo*sheenFactor;
#ifdef SHEEN_TEXTURE
sheenIntensity*=sheenMapData.a;
#endif
#else
vec3 sheenColor=vSheenColor.rgb;
#ifdef SHEEN_TEXTURE
#ifdef SHEEN_GAMMATEXTURE
sheenColor.rgb*=toLinearSpace(sheenMapData.rgb);
#else
sheenColor.rgb*=sheenMapData.rgb;
#endif
sheenColor.rgb*=sheenMapLevel;
#endif
#ifdef SHEEN_ROUGHNESS
float sheenRoughness=vSheenRoughness;
#ifdef SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE
#if defined(SHEEN_TEXTURE)
sheenRoughness*=sheenMapData.a;
#endif
#elif defined(SHEEN_TEXTURE_ROUGHNESS)
#ifdef SHEEN_TEXTURE_ROUGHNESS_IDENTICAL
sheenRoughness*=sheenMapData.a;
#else
sheenRoughness*=sheenMapRoughnessData.a;
#endif
#endif
#else
float sheenRoughness=roughness;
#ifdef SHEEN_TEXTURE
sheenIntensity*=sheenMapData.a;
#endif
#endif
#if !defined(SHEEN_ALBEDOSCALING)
sheenIntensity*=(1.-reflectance);
#endif
sheenColor*=sheenIntensity;
#endif
#ifdef ENVIRONMENTBRDF
/*#ifdef SHEEN_SOFTER
vec3 environmentSheenBrdf=vec3(0.,0.,getBRDFLookupCharlieSheen(NdotV,sheenRoughness));
#else*/
#ifdef SHEEN_ROUGHNESS
vec3 environmentSheenBrdf=getBRDFLookup(NdotV,sheenRoughness);
#else
vec3 environmentSheenBrdf=environmentBrdf;
#endif
/*#endif*/
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
float sheenAlphaG=convertRoughnessToAverageSlope(sheenRoughness);
#ifdef SPECULARAA
sheenAlphaG+=AARoughnessFactors.y;
#endif
vec4 environmentSheenRadiance=vec4(0.,0.,0.,0.);sampleReflectionTexture(
sheenAlphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
sheenRoughness,
#endif
reflectionSampler,
reflectionCoords,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
environmentSheenRadiance
);vec3 sheenEnvironmentReflectance=getSheenReflectanceFromBRDFLookup(sheenColor,environmentSheenBrdf);
#if !defined(REFLECTIONMAP_SKYBOX) && defined(RADIANCEOCCLUSION)
sheenEnvironmentReflectance*=seo;
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
sheenEnvironmentReflectance*=eho;
#endif
#if DEBUGMODE>0
outParams.sheenEnvironmentReflectance=sheenEnvironmentReflectance;
#endif
outParams.finalSheenRadianceScaled=
environmentSheenRadiance.rgb *
sheenEnvironmentReflectance *
vLightingIntensity.z;
#endif
#if defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
outParams.sheenAlbedoScaling=1.0-sheenIntensity*max(max(sheenColor.r,sheenColor.g),sheenColor.b)*environmentSheenBrdf.b;
#endif
outParams.sheenIntensity=sheenIntensity;outParams.sheenColor=sheenColor;outParams.sheenRoughness=sheenRoughness;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1o] = shader$1o;

    // Do not edit.
    const name$1p = "pbrBlockClearcoat";
    const shader$1p = `struct clearcoatOutParams
{vec3 specularEnvironmentR0;float conservationFactor;vec3 clearCoatNormalW;vec2 clearCoatAARoughnessFactors;float clearCoatIntensity;float clearCoatRoughness;
#ifdef REFLECTION
vec3 finalClearCoatRadianceScaled;
#endif
#ifdef CLEARCOAT_TINT
vec3 absorption;float clearCoatNdotVRefract;vec3 clearCoatColor;float clearCoatThickness;
#endif
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
vec3 energyConservationFactorClearCoat;
#endif
#if DEBUGMODE>0
#ifdef CLEARCOAT_BUMP
mat3 TBNClearCoat;
#endif
#ifdef CLEARCOAT_TEXTURE
vec2 clearCoatMapData;
#endif
#if defined(CLEARCOAT_TINT) && defined(CLEARCOAT_TINT_TEXTURE)
vec4 clearCoatTintMapData;
#endif
#ifdef REFLECTION
vec4 environmentClearCoatRadiance;vec3 clearCoatEnvironmentReflectance;
#endif
float clearCoatNdotV;
#endif
};
#ifdef CLEARCOAT
#define pbr_inline
#define inline
void clearcoatBlock(
in vec3 vPositionW,
in vec3 geometricNormalW,
in vec3 viewDirectionW,
in vec2 vClearCoatParams,
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
in vec4 clearCoatMapRoughnessData,
#endif
in vec3 specularEnvironmentR0,
#ifdef CLEARCOAT_TEXTURE
in vec2 clearCoatMapData,
#endif
#ifdef CLEARCOAT_TINT
in vec4 vClearCoatTintParams,
in float clearCoatColorAtDistance,
in vec4 vClearCoatRefractionParams,
#ifdef CLEARCOAT_TINT_TEXTURE
in vec4 clearCoatTintMapData,
#endif
#endif
#ifdef CLEARCOAT_BUMP
in vec2 vClearCoatBumpInfos,
in vec4 clearCoatBumpMapData,
in vec2 vClearCoatBumpUV,
#if defined(TANGENT) && defined(NORMAL)
in mat3 vTBN,
#else
in vec2 vClearCoatTangentSpaceParams,
#endif
#ifdef OBJECTSPACE_NORMALMAP
in mat4 normalMatrix,
#endif
#endif
#if defined(FORCENORMALFORWARD) && defined(NORMAL)
in vec3 faceNormal,
#endif
#ifdef REFLECTION
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
in vec4 vLightingIntensity,
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
#else
in sampler2D reflectionSampler,
#endif
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
#ifdef RADIANCEOCCLUSION
in float ambientMonochrome,
#endif
#endif
#if defined(CLEARCOAT_BUMP) || defined(TWOSIDEDLIGHTING)
in float frontFacingMultiplier,
#endif
out clearcoatOutParams outParams
)
{float clearCoatIntensity=vClearCoatParams.x;float clearCoatRoughness=vClearCoatParams.y;
#ifdef CLEARCOAT_TEXTURE
clearCoatIntensity*=clearCoatMapData.x;
#ifdef CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE
clearCoatRoughness*=clearCoatMapData.y;
#endif
#if DEBUGMODE>0
outParams.clearCoatMapData=clearCoatMapData;
#endif
#endif
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
#ifdef CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL
clearCoatRoughness*=clearCoatMapData.y;
#else
clearCoatRoughness*=clearCoatMapRoughnessData.y;
#endif
#endif
outParams.clearCoatIntensity=clearCoatIntensity;outParams.clearCoatRoughness=clearCoatRoughness;
#ifdef CLEARCOAT_TINT
vec3 clearCoatColor=vClearCoatTintParams.rgb;float clearCoatThickness=vClearCoatTintParams.a;
#ifdef CLEARCOAT_TINT_TEXTURE
#ifdef CLEARCOAT_TINT_GAMMATEXTURE
clearCoatColor*=toLinearSpace(clearCoatTintMapData.rgb);
#else
clearCoatColor*=clearCoatTintMapData.rgb;
#endif
clearCoatThickness*=clearCoatTintMapData.a;
#if DEBUGMODE>0
outParams.clearCoatTintMapData=clearCoatTintMapData;
#endif
#endif
outParams.clearCoatColor=computeColorAtDistanceInMedia(clearCoatColor,clearCoatColorAtDistance);outParams.clearCoatThickness=clearCoatThickness;
#endif
#ifdef CLEARCOAT_REMAP_F0
vec3 specularEnvironmentR0Updated=getR0RemappedForClearCoat(specularEnvironmentR0);
#else
vec3 specularEnvironmentR0Updated=specularEnvironmentR0;
#endif
outParams.specularEnvironmentR0=mix(specularEnvironmentR0,specularEnvironmentR0Updated,clearCoatIntensity);vec3 clearCoatNormalW=geometricNormalW;
#ifdef CLEARCOAT_BUMP
#ifdef NORMALXYSCALE
float clearCoatNormalScale=1.0;
#else
float clearCoatNormalScale=vClearCoatBumpInfos.y;
#endif
#if defined(TANGENT) && defined(NORMAL)
mat3 TBNClearCoat=vTBN;
#else
vec2 TBNClearCoatUV=vClearCoatBumpUV*frontFacingMultiplier;mat3 TBNClearCoat=cotangent_frame(clearCoatNormalW*clearCoatNormalScale,vPositionW,TBNClearCoatUV,vClearCoatTangentSpaceParams);
#endif
#if DEBUGMODE>0
outParams.TBNClearCoat=TBNClearCoat;
#endif
#ifdef OBJECTSPACE_NORMALMAP
clearCoatNormalW=normalize(clearCoatBumpMapData.xyz *2.0-1.0);clearCoatNormalW=normalize(mat3(normalMatrix)*clearCoatNormalW);
#else
clearCoatNormalW=perturbNormal(TBNClearCoat,clearCoatBumpMapData.xyz,vClearCoatBumpInfos.y);
#endif
#endif
#if defined(FORCENORMALFORWARD) && defined(NORMAL)
clearCoatNormalW*=sign(dot(clearCoatNormalW,faceNormal));
#endif
#if defined(TWOSIDEDLIGHTING) && defined(NORMAL)
clearCoatNormalW=clearCoatNormalW*frontFacingMultiplier;
#endif
outParams.clearCoatNormalW=clearCoatNormalW;outParams.clearCoatAARoughnessFactors=getAARoughnessFactors(clearCoatNormalW.xyz);float clearCoatNdotVUnclamped=dot(clearCoatNormalW,viewDirectionW);float clearCoatNdotV=absEps(clearCoatNdotVUnclamped);
#if DEBUGMODE>0
outParams.clearCoatNdotV=clearCoatNdotV;
#endif
#ifdef CLEARCOAT_TINT
vec3 clearCoatVRefract=refract(-viewDirectionW,clearCoatNormalW,vClearCoatRefractionParams.y);outParams.clearCoatNdotVRefract=absEps(dot(clearCoatNormalW,clearCoatVRefract));
#endif
#if defined(ENVIRONMENTBRDF) && (!defined(REFLECTIONMAP_SKYBOX) || defined(MS_BRDF_ENERGY_CONSERVATION))
vec3 environmentClearCoatBrdf=getBRDFLookup(clearCoatNdotV,clearCoatRoughness);
#endif
#if defined(REFLECTION)
float clearCoatAlphaG=convertRoughnessToAverageSlope(clearCoatRoughness);
#ifdef SPECULARAA
clearCoatAlphaG+=outParams.clearCoatAARoughnessFactors.y;
#endif
vec4 environmentClearCoatRadiance=vec4(0.,0.,0.,0.);vec3 clearCoatReflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),clearCoatNormalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
clearCoatReflectionVector.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
vec3 clearCoatReflectionCoords=clearCoatReflectionVector;
#else
vec2 clearCoatReflectionCoords=clearCoatReflectionVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
clearCoatReflectionCoords/=clearCoatReflectionVector.z;
#endif
clearCoatReflectionCoords.y=1.0-clearCoatReflectionCoords.y;
#endif
sampleReflectionTexture(
clearCoatAlphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
clearCoatNdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
clearCoatRoughness,
#endif
reflectionSampler,
clearCoatReflectionCoords,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
environmentClearCoatRadiance
);
#if DEBUGMODE>0
outParams.environmentClearCoatRadiance=environmentClearCoatRadiance;
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
vec3 clearCoatEnvironmentReflectance=getReflectanceFromBRDFLookup(vec3(vClearCoatRefractionParams.x),environmentClearCoatBrdf);
#ifdef HORIZONOCCLUSION
#ifdef BUMP
#ifdef REFLECTIONMAP_3D
float clearCoatEho=environmentHorizonOcclusion(-viewDirectionW,clearCoatNormalW,geometricNormalW);clearCoatEnvironmentReflectance*=clearCoatEho;
#endif
#endif
#endif
#else
vec3 clearCoatEnvironmentReflectance=getReflectanceFromAnalyticalBRDFLookup_Jones(clearCoatNdotV,vec3(1.),vec3(1.),sqrt(1.-clearCoatRoughness));
#endif
clearCoatEnvironmentReflectance*=clearCoatIntensity;
#if DEBUGMODE>0
outParams.clearCoatEnvironmentReflectance=clearCoatEnvironmentReflectance;
#endif
outParams.finalClearCoatRadianceScaled=
environmentClearCoatRadiance.rgb *
clearCoatEnvironmentReflectance *
vLightingIntensity.z;
#endif
#if defined(CLEARCOAT_TINT)
outParams.absorption=computeClearCoatAbsorption(outParams.clearCoatNdotVRefract,outParams.clearCoatNdotVRefract,outParams.clearCoatColor,clearCoatThickness,clearCoatIntensity);
#endif
float fresnelIBLClearCoat=fresnelSchlickGGX(clearCoatNdotV,vClearCoatRefractionParams.x,CLEARCOATREFLECTANCE90);fresnelIBLClearCoat*=clearCoatIntensity;outParams.conservationFactor=(1.-fresnelIBLClearCoat);
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
outParams.energyConservationFactorClearCoat=getEnergyConservationFactor(outParams.specularEnvironmentR0,environmentClearCoatBrdf);
#endif
}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1p] = shader$1p;

    // Do not edit.
    const name$1q = "pbrBlockIridescence";
    const shader$1q = `struct iridescenceOutParams
{float iridescenceIntensity;float iridescenceIOR;float iridescenceThickness;vec3 specularEnvironmentR0;};
#ifdef IRIDESCENCE
#define pbr_inline
#define inline
void iridescenceBlock(
in vec4 vIridescenceParams,
in float viewAngle,
in vec3 specularEnvironmentR0,
#ifdef IRIDESCENCE_TEXTURE
in vec2 iridescenceMapData,
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
in vec2 iridescenceThicknessMapData,
#endif
#ifdef CLEARCOAT
in float NdotVUnclamped,
#ifdef CLEARCOAT_TEXTURE
in vec2 clearCoatMapData,
#endif
#endif
out iridescenceOutParams outParams
)
{float iridescenceIntensity=vIridescenceParams.x;float iridescenceIOR=vIridescenceParams.y;float iridescenceThicknessMin=vIridescenceParams.z;float iridescenceThicknessMax=vIridescenceParams.w;float iridescenceThicknessWeight=1.;
#ifdef IRIDESCENCE_TEXTURE
iridescenceIntensity*=iridescenceMapData.x;
#ifdef IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE
iridescenceThicknessWeight=iridescenceMapData.g;
#endif
#endif
#if defined(IRIDESCENCE_THICKNESS_TEXTURE)
iridescenceThicknessWeight=iridescenceThicknessMapData.g;
#endif
float iridescenceThickness=mix(iridescenceThicknessMin,iridescenceThicknessMax,iridescenceThicknessWeight);float topIor=1.; 
#ifdef CLEARCOAT
float clearCoatIntensity=vClearCoatParams.x;
#ifdef CLEARCOAT_TEXTURE
clearCoatIntensity*=clearCoatMapData.x;
#endif
topIor=mix(1.0,vClearCoatRefractionParams.w-1.,clearCoatIntensity);viewAngle=sqrt(1.0+square(1.0/topIor)*(square(NdotVUnclamped)-1.0));
#endif
vec3 iridescenceFresnel=evalIridescence(topIor,iridescenceIOR,viewAngle,iridescenceThickness,specularEnvironmentR0);outParams.specularEnvironmentR0=mix(specularEnvironmentR0,iridescenceFresnel,iridescenceIntensity);outParams.iridescenceIntensity=iridescenceIntensity;outParams.iridescenceThickness=iridescenceThickness;outParams.iridescenceIOR=iridescenceIOR;}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1q] = shader$1q;

    // Do not edit.
    const name$1r = "pbrBlockSubSurface";
    const shader$1r = `struct subSurfaceOutParams
{vec3 specularEnvironmentReflectance;
#ifdef SS_REFRACTION
vec3 finalRefraction;vec3 surfaceAlbedo;
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
float alpha;
#endif
#ifdef REFLECTION
float refractionFactorForIrradiance;
#endif
#endif
#ifdef SS_TRANSLUCENCY
vec3 transmittance;float translucencyIntensity;
#ifdef REFLECTION
vec3 refractionIrradiance;
#endif
#endif
#if DEBUGMODE>0
#ifdef SS_THICKNESSANDMASK_TEXTURE
vec4 thicknessMap;
#endif
#ifdef SS_REFRACTION
vec4 environmentRefraction;vec3 refractionTransmittance;
#endif
#endif
};
#ifdef SUBSURFACE
#define pbr_inline
#define inline
void subSurfaceBlock(
in vec3 vSubSurfaceIntensity,
in vec2 vThicknessParam,
in vec4 vTintColor,
in vec3 normalW,
in vec3 specularEnvironmentReflectance,
#ifdef SS_THICKNESSANDMASK_TEXTURE
in vec4 thicknessMap,
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
in vec4 refractionIntensityMap,
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
in vec4 translucencyIntensityMap,
#endif
#ifdef REFLECTION
#ifdef SS_TRANSLUCENCY
in mat4 reflectionMatrix,
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
in vec3 irradianceVector_,
#endif
#if defined(REALTIME_FILTERING)
in samplerCube reflectionSampler,
in vec2 vReflectionFilteringInfo,
#endif
#endif
#ifdef USEIRRADIANCEMAP
#ifdef REFLECTIONMAP_3D
in samplerCube irradianceSampler,
#else
in sampler2D irradianceSampler,
#endif
#endif
#endif
#endif
#if defined(SS_REFRACTION) || defined(SS_TRANSLUCENCY)
in vec3 surfaceAlbedo,
#endif
#ifdef SS_REFRACTION
in vec3 vPositionW,
in vec3 viewDirectionW,
in mat4 view,
in vec4 vRefractionInfos,
in mat4 refractionMatrix,
in vec4 vRefractionMicrosurfaceInfos,
in vec4 vLightingIntensity,
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
in float alpha,
#endif
#ifdef SS_LODINREFRACTIONALPHA
in float NdotVUnclamped,
#endif
#ifdef SS_LINEARSPECULARREFRACTION
in float roughness,
#endif
in float alphaG,
#ifdef SS_REFRACTIONMAP_3D
in samplerCube refractionSampler,
#ifndef LODBASEDMICROSFURACE
in samplerCube refractionSamplerLow,
in samplerCube refractionSamplerHigh,
#endif
#else
in sampler2D refractionSampler,
#ifndef LODBASEDMICROSFURACE
in sampler2D refractionSamplerLow,
in sampler2D refractionSamplerHigh,
#endif
#endif
#ifdef ANISOTROPIC
in anisotropicOutParams anisotropicOut,
#endif
#ifdef REALTIME_FILTERING
in vec2 vRefractionFilteringInfo,
#endif
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
in vec3 refractionPosition,
in vec3 refractionSize,
#endif
#endif
#ifdef SS_TRANSLUCENCY
in vec3 vDiffusionDistance,
#endif
out subSurfaceOutParams outParams
)
{outParams.specularEnvironmentReflectance=specularEnvironmentReflectance;
#ifdef SS_REFRACTION
float refractionIntensity=vSubSurfaceIntensity.x;
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
refractionIntensity*=(1.0-alpha);outParams.alpha=1.0;
#endif
#endif
#ifdef SS_TRANSLUCENCY
float translucencyIntensity=vSubSurfaceIntensity.y;
#endif
#ifdef SS_THICKNESSANDMASK_TEXTURE
#if defined(SS_USE_GLTF_TEXTURES)
float thickness=thicknessMap.g*vThicknessParam.y+vThicknessParam.x;
#else
float thickness=thicknessMap.r*vThicknessParam.y+vThicknessParam.x;
#endif
#if DEBUGMODE>0
outParams.thicknessMap=thicknessMap;
#endif
#ifdef SS_MASK_FROM_THICKNESS_TEXTURE
#if defined(SS_REFRACTION) && defined(SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE)
#if defined(SS_USE_GLTF_TEXTURES)
refractionIntensity*=thicknessMap.r;
#else
refractionIntensity*=thicknessMap.g;
#endif
#endif
#if defined(SS_TRANSLUCENCY) && defined(SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE)
translucencyIntensity*=thicknessMap.b;
#endif
#endif
#else
float thickness=vThicknessParam.y;
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
#ifdef SS_USE_GLTF_TEXTURES
refractionIntensity*=refractionIntensityMap.r;
#else
refractionIntensity*=refractionIntensityMap.g;
#endif
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
translucencyIntensity*=translucencyIntensityMap.b;
#endif
#ifdef SS_TRANSLUCENCY
thickness=maxEps(thickness);vec3 transmittance=transmittanceBRDF_Burley(vTintColor.rgb,vDiffusionDistance,thickness);transmittance*=translucencyIntensity;outParams.transmittance=transmittance;outParams.translucencyIntensity=translucencyIntensity;
#endif
#ifdef SS_REFRACTION
vec4 environmentRefraction=vec4(0.,0.,0.,0.);
#ifdef ANISOTROPIC
vec3 refractionVector=refract(-viewDirectionW,anisotropicOut.anisotropicNormal,vRefractionInfos.y);
#else
vec3 refractionVector=refract(-viewDirectionW,normalW,vRefractionInfos.y);
#endif
#ifdef SS_REFRACTIONMAP_OPPOSITEZ
refractionVector.z*=-1.0;
#endif
#ifdef SS_REFRACTIONMAP_3D
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
refractionVector=parallaxCorrectNormal(vPositionW,refractionVector,refractionSize,refractionPosition);
#endif
refractionVector.y=refractionVector.y*vRefractionInfos.w;vec3 refractionCoords=refractionVector;refractionCoords=vec3(refractionMatrix*vec4(refractionCoords,0));
#else
#ifdef SS_USE_THICKNESS_AS_DEPTH
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*thickness,1.0)));
#else
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*vRefractionInfos.z,1.0)));
#endif
vec2 refractionCoords=vRefractionUVW.xy/vRefractionUVW.z;refractionCoords.y=1.0-refractionCoords.y;
#endif
#ifdef SS_HAS_THICKNESS
float ior=vRefractionInfos.y;
#else
float ior=vRefractionMicrosurfaceInfos.w;
#endif
#ifdef SS_LODINREFRACTIONALPHA
float refractionAlphaG=alphaG;refractionAlphaG=mix(alphaG,0.0,clamp(ior*3.0-2.0,0.0,1.0));float refractionLOD=getLodFromAlphaG(vRefractionMicrosurfaceInfos.x,refractionAlphaG,NdotVUnclamped);
#elif defined(SS_LINEARSPECULARREFRACTION)
float refractionRoughness=alphaG;refractionRoughness=mix(alphaG,0.0,clamp(ior*3.0-2.0,0.0,1.0));float refractionLOD=getLinearLodFromRoughness(vRefractionMicrosurfaceInfos.x,refractionRoughness);
#else
float refractionAlphaG=alphaG;refractionAlphaG=mix(alphaG,0.0,clamp(ior*3.0-2.0,0.0,1.0));float refractionLOD=getLodFromAlphaG(vRefractionMicrosurfaceInfos.x,refractionAlphaG);
#endif
#ifdef LODBASEDMICROSFURACE
refractionLOD=refractionLOD*vRefractionMicrosurfaceInfos.y+vRefractionMicrosurfaceInfos.z;
#ifdef SS_LODINREFRACTIONALPHA
float automaticRefractionLOD=UNPACK_LOD(sampleRefraction(refractionSampler,refractionCoords).a);float requestedRefractionLOD=max(automaticRefractionLOD,refractionLOD);
#else
float requestedRefractionLOD=refractionLOD;
#endif
#if defined(REALTIME_FILTERING) && defined(SS_REFRACTIONMAP_3D)
environmentRefraction=vec4(radiance(alphaG,refractionSampler,refractionCoords,vRefractionFilteringInfo),1.0);
#else
environmentRefraction=sampleRefractionLod(refractionSampler,refractionCoords,requestedRefractionLOD);
#endif
#else
float lodRefractionNormalized=saturate(refractionLOD/log2(vRefractionMicrosurfaceInfos.x));float lodRefractionNormalizedDoubled=lodRefractionNormalized*2.0;vec4 environmentRefractionMid=sampleRefraction(refractionSampler,refractionCoords);if (lodRefractionNormalizedDoubled<1.0){environmentRefraction=mix(
sampleRefraction(refractionSamplerHigh,refractionCoords),
environmentRefractionMid,
lodRefractionNormalizedDoubled
);} else {environmentRefraction=mix(
environmentRefractionMid,
sampleRefraction(refractionSamplerLow,refractionCoords),
lodRefractionNormalizedDoubled-1.0
);}
#endif
#ifdef SS_RGBDREFRACTION
environmentRefraction.rgb=fromRGBD(environmentRefraction);
#endif
#ifdef SS_GAMMAREFRACTION
environmentRefraction.rgb=toLinearSpace(environmentRefraction.rgb);
#endif
environmentRefraction.rgb*=vRefractionInfos.x;
#endif
#ifdef SS_REFRACTION
vec3 refractionTransmittance=vec3(refractionIntensity);
#ifdef SS_THICKNESSANDMASK_TEXTURE
vec3 volumeAlbedo=computeColorAtDistanceInMedia(vTintColor.rgb,vTintColor.w);refractionTransmittance*=cocaLambert(volumeAlbedo,thickness);
#elif defined(SS_LINKREFRACTIONTOTRANSPARENCY)
float maxChannel=max(max(surfaceAlbedo.r,surfaceAlbedo.g),surfaceAlbedo.b);vec3 volumeAlbedo=saturate(maxChannel*surfaceAlbedo);environmentRefraction.rgb*=volumeAlbedo;
#else
vec3 volumeAlbedo=computeColorAtDistanceInMedia(vTintColor.rgb,vTintColor.w);refractionTransmittance*=cocaLambert(volumeAlbedo,vThicknessParam.y);
#endif
#ifdef SS_ALBEDOFORREFRACTIONTINT
environmentRefraction.rgb*=surfaceAlbedo.rgb;
#endif
outParams.surfaceAlbedo=surfaceAlbedo*(1.-refractionIntensity);
#ifdef REFLECTION
outParams.refractionFactorForIrradiance=(1.-refractionIntensity);
#endif
#ifdef UNUSED_MULTIPLEBOUNCES
vec3 bounceSpecularEnvironmentReflectance=(2.0*specularEnvironmentReflectance)/(1.0+specularEnvironmentReflectance);outParams.specularEnvironmentReflectance=mix(bounceSpecularEnvironmentReflectance,specularEnvironmentReflectance,refractionIntensity);
#endif
refractionTransmittance*=1.0-outParams.specularEnvironmentReflectance;
#if DEBUGMODE>0
outParams.refractionTransmittance=refractionTransmittance;
#endif
outParams.finalRefraction=environmentRefraction.rgb*refractionTransmittance*vLightingIntensity.z;
#if DEBUGMODE>0
outParams.environmentRefraction=environmentRefraction;
#endif
#endif
#if defined(REFLECTION) && defined(SS_TRANSLUCENCY)
#if defined(NORMAL) && defined(USESPHERICALINVERTEX) || !defined(USESPHERICALFROMREFLECTIONMAP)
vec3 irradianceVector=vec3(reflectionMatrix*vec4(normalW,0)).xyz;
#ifdef REFLECTIONMAP_OPPOSITEZ
irradianceVector.z*=-1.0;
#endif
#ifdef INVERTCUBICMAP
irradianceVector.y*=-1.0;
#endif
#else
vec3 irradianceVector=irradianceVector_;
#endif
#if defined(USESPHERICALFROMREFLECTIONMAP)
#if defined(REALTIME_FILTERING)
vec3 refractionIrradiance=irradiance(reflectionSampler,-irradianceVector,vReflectionFilteringInfo);
#else
vec3 refractionIrradiance=computeEnvironmentIrradiance(-irradianceVector);
#endif
#elif defined(USEIRRADIANCEMAP)
#ifdef REFLECTIONMAP_3D
vec3 irradianceCoords=irradianceVector;
#else
vec2 irradianceCoords=irradianceVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
irradianceCoords/=irradianceVector.z;
#endif
irradianceCoords.y=1.0-irradianceCoords.y;
#endif
vec4 refractionIrradiance=sampleReflection(irradianceSampler,-irradianceCoords);
#ifdef RGBDREFLECTION
refractionIrradiance.rgb=fromRGBD(refractionIrradiance);
#endif
#ifdef GAMMAREFLECTION
refractionIrradiance.rgb=toLinearSpace(refractionIrradiance.rgb);
#endif
#else
vec4 refractionIrradiance=vec4(0.);
#endif
refractionIrradiance.rgb*=transmittance;
#ifdef SS_ALBEDOFORTRANSLUCENCYTINT
refractionIrradiance.rgb*=surfaceAlbedo.rgb;
#endif
outParams.refractionIrradiance=refractionIrradiance.rgb;
#endif
}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1r] = shader$1r;

    // Do not edit.
    const name$1s = "pbrBlockNormalGeometric";
    const shader$1s = `vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=normalize(cross(dFdx(vPositionW),dFdy(vPositionW)))*vEyePosition.w;
#endif
vec3 geometricNormalW=normalW;
#if defined(TWOSIDEDLIGHTING) && defined(NORMAL)
geometricNormalW=gl_FrontFacing ? geometricNormalW : -geometricNormalW;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1s] = shader$1s;

    // Do not edit.
    const name$1t = "pbrBlockNormalFinal";
    const shader$1t = `#if defined(FORCENORMALFORWARD) && defined(NORMAL)
vec3 faceNormal=normalize(cross(dFdx(vPositionW),dFdy(vPositionW)))*vEyePosition.w;
#if defined(TWOSIDEDLIGHTING)
faceNormal=gl_FrontFacing ? faceNormal : -faceNormal;
#endif
normalW*=sign(dot(normalW,faceNormal));
#endif
#if defined(TWOSIDEDLIGHTING) && defined(NORMAL)
normalW=gl_FrontFacing ? normalW : -normalW;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1t] = shader$1t;

    // Do not edit.
    const name$1u = "pbrBlockLightmapInit";
    const shader$1u = `#ifdef LIGHTMAP
vec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);
#ifdef RGBDLIGHTMAP
lightmapColor.rgb=fromRGBD(lightmapColor);
#endif
#ifdef GAMMALIGHTMAP
lightmapColor.rgb=toLinearSpace(lightmapColor.rgb);
#endif
lightmapColor.rgb*=vLightmapInfos.y;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1u] = shader$1u;

    // Do not edit.
    const name$1v = "pbrBlockGeometryInfo";
    const shader$1v = `float NdotVUnclamped=dot(normalW,viewDirectionW);float NdotV=absEps(NdotVUnclamped);float alphaG=convertRoughnessToAverageSlope(roughness);vec2 AARoughnessFactors=getAARoughnessFactors(normalW.xyz);
#ifdef SPECULARAA
alphaG+=AARoughnessFactors.y;
#endif
#if defined(ENVIRONMENTBRDF)
vec3 environmentBrdf=getBRDFLookup(NdotV,roughness);
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
#ifdef RADIANCEOCCLUSION
#ifdef AMBIENTINGRAYSCALE
float ambientMonochrome=aoOut.ambientOcclusionColor.r;
#else
float ambientMonochrome=getLuminance(aoOut.ambientOcclusionColor);
#endif
float seo=environmentRadianceOcclusion(ambientMonochrome,NdotVUnclamped);
#endif
#ifdef HORIZONOCCLUSION
#ifdef BUMP
#ifdef REFLECTIONMAP_3D
float eho=environmentHorizonOcclusion(-viewDirectionW,normalW,geometricNormalW);
#endif
#endif
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1v] = shader$1v;

    // Do not edit.
    const name$1w = "pbrBlockReflectance0";
    const shader$1w = `float reflectance=max(max(reflectivityOut.surfaceReflectivityColor.r,reflectivityOut.surfaceReflectivityColor.g),reflectivityOut.surfaceReflectivityColor.b);vec3 specularEnvironmentR0=reflectivityOut.surfaceReflectivityColor.rgb;
#ifdef METALLICWORKFLOW
vec3 specularEnvironmentR90=vec3(metallicReflectanceFactors.a);
#else 
vec3 specularEnvironmentR90=vec3(1.0,1.0,1.0);
#endif
#ifdef ALPHAFRESNEL
float reflectance90=fresnelGrazingReflectance(reflectance);specularEnvironmentR90=specularEnvironmentR90*reflectance90;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1w] = shader$1w;

    // Do not edit.
    const name$1x = "pbrBlockReflectance";
    const shader$1x = `#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
vec3 specularEnvironmentReflectance=getReflectanceFromBRDFLookup(clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,environmentBrdf);
#ifdef RADIANCEOCCLUSION
specularEnvironmentReflectance*=seo;
#endif
#ifdef HORIZONOCCLUSION
#ifdef BUMP
#ifdef REFLECTIONMAP_3D
specularEnvironmentReflectance*=eho;
#endif
#endif
#endif
#else
vec3 specularEnvironmentReflectance=getReflectanceFromAnalyticalBRDFLookup_Jones(NdotV,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,sqrt(microSurface));
#endif
#ifdef CLEARCOAT
specularEnvironmentReflectance*=clearcoatOut.conservationFactor;
#if defined(CLEARCOAT_TINT)
specularEnvironmentReflectance*=clearcoatOut.absorption;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1x] = shader$1x;

    // Do not edit.
    const name$1y = "pbrBlockDirectLighting";
    const shader$1y = `vec3 diffuseBase=vec3(0.,0.,0.);
#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);
#endif
#ifdef CLEARCOAT
vec3 clearCoatBase=vec3(0.,0.,0.);
#endif
#ifdef SHEEN
vec3 sheenBase=vec3(0.,0.,0.);
#endif
preLightingInfo preInfo;lightingInfo info;float shadow=1.; 
#if defined(CLEARCOAT) && defined(CLEARCOAT_TINT)
vec3 absorption=vec3(0.);
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1y] = shader$1y;

    // Do not edit.
    const name$1z = "pbrBlockFinalLitComponents";
    const shader$1z = `#if defined(ENVIRONMENTBRDF)
#ifdef MS_BRDF_ENERGY_CONSERVATION
vec3 energyConservationFactor=getEnergyConservationFactor(clearcoatOut.specularEnvironmentR0,environmentBrdf);
#endif
#endif
#ifndef METALLICWORKFLOW
#ifdef SPECULAR_GLOSSINESS_ENERGY_CONSERVATION
surfaceAlbedo.rgb=(1.-reflectance)*surfaceAlbedo.rgb;
#endif
#endif
#if defined(SHEEN) && defined(SHEEN_ALBEDOSCALING) && defined(ENVIRONMENTBRDF)
surfaceAlbedo.rgb=sheenOut.sheenAlbedoScaling*surfaceAlbedo.rgb;
#endif
#ifdef REFLECTION
vec3 finalIrradiance=reflectionOut.environmentIrradiance;
#if defined(CLEARCOAT)
finalIrradiance*=clearcoatOut.conservationFactor;
#if defined(CLEARCOAT_TINT)
finalIrradiance*=clearcoatOut.absorption;
#endif
#endif
#if defined(SS_REFRACTION)
finalIrradiance*=subSurfaceOut.refractionFactorForIrradiance;
#endif
#if defined(SS_TRANSLUCENCY)
finalIrradiance*=(1.0-subSurfaceOut.translucencyIntensity);finalIrradiance+=subSurfaceOut.refractionIrradiance;
#endif
finalIrradiance*=surfaceAlbedo.rgb;finalIrradiance*=vLightingIntensity.z;finalIrradiance*=aoOut.ambientOcclusionColor;
#endif
#ifdef SPECULARTERM
vec3 finalSpecular=specularBase;finalSpecular=max(finalSpecular,0.0);vec3 finalSpecularScaled=finalSpecular*vLightingIntensity.x*vLightingIntensity.w;
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
finalSpecularScaled*=energyConservationFactor;
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
finalSpecularScaled*=sheenOut.sheenAlbedoScaling;
#endif
#endif
#ifdef REFLECTION
vec3 finalRadiance=reflectionOut.environmentRadiance.rgb;finalRadiance*=subSurfaceOut.specularEnvironmentReflectance;vec3 finalRadianceScaled=finalRadiance*vLightingIntensity.z;
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
finalRadianceScaled*=energyConservationFactor;
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
finalRadianceScaled*=sheenOut.sheenAlbedoScaling;
#endif
#endif
#ifdef SHEEN
vec3 finalSheen=sheenBase*sheenOut.sheenColor;finalSheen=max(finalSheen,0.0);vec3 finalSheenScaled=finalSheen*vLightingIntensity.x*vLightingIntensity.w;
#if defined(CLEARCOAT) && defined(REFLECTION) && defined(ENVIRONMENTBRDF)
sheenOut.finalSheenRadianceScaled*=clearcoatOut.conservationFactor;
#if defined(CLEARCOAT_TINT)
sheenOut.finalSheenRadianceScaled*=clearcoatOut.absorption;
#endif
#endif
#endif
#ifdef CLEARCOAT
vec3 finalClearCoat=clearCoatBase;finalClearCoat=max(finalClearCoat,0.0);vec3 finalClearCoatScaled=finalClearCoat*vLightingIntensity.x*vLightingIntensity.w;
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
finalClearCoatScaled*=clearcoatOut.energyConservationFactorClearCoat;
#endif
#ifdef SS_REFRACTION
subSurfaceOut.finalRefraction*=clearcoatOut.conservationFactor;
#ifdef CLEARCOAT_TINT
subSurfaceOut.finalRefraction*=clearcoatOut.absorption;
#endif
#endif
#endif
#ifdef ALPHABLEND
float luminanceOverAlpha=0.0;
#if defined(REFLECTION) && defined(RADIANCEOVERALPHA)
luminanceOverAlpha+=getLuminance(finalRadianceScaled);
#if defined(CLEARCOAT)
luminanceOverAlpha+=getLuminance(clearcoatOut.finalClearCoatRadianceScaled);
#endif
#endif
#if defined(SPECULARTERM) && defined(SPECULAROVERALPHA)
luminanceOverAlpha+=getLuminance(finalSpecularScaled);
#endif
#if defined(CLEARCOAT) && defined(CLEARCOATOVERALPHA)
luminanceOverAlpha+=getLuminance(finalClearCoatScaled);
#endif
#if defined(RADIANCEOVERALPHA) || defined(SPECULAROVERALPHA) || defined(CLEARCOATOVERALPHA)
alpha=saturate(alpha+luminanceOverAlpha*luminanceOverAlpha);
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1z] = shader$1z;

    // Do not edit.
    const name$1A = "pbrBlockFinalUnlitComponents";
    const shader$1A = `vec3 finalDiffuse=diffuseBase;finalDiffuse*=surfaceAlbedo.rgb;finalDiffuse=max(finalDiffuse,0.0);finalDiffuse*=vLightingIntensity.x;vec3 finalAmbient=vAmbientColor;finalAmbient*=surfaceAlbedo.rgb;vec3 finalEmissive=vEmissiveColor;
#ifdef EMISSIVE
vec3 emissiveColorTex=texture2D(emissiveSampler,vEmissiveUV+uvOffset).rgb;
#ifdef GAMMAEMISSIVE
finalEmissive*=toLinearSpace(emissiveColorTex.rgb);
#else
finalEmissive*=emissiveColorTex.rgb;
#endif
finalEmissive*= vEmissiveInfos.y;
#endif
finalEmissive*=vLightingIntensity.y;
#ifdef AMBIENT
vec3 ambientOcclusionForDirectDiffuse=mix(vec3(1.),aoOut.ambientOcclusionColor,vAmbientInfos.w);
#else
vec3 ambientOcclusionForDirectDiffuse=aoOut.ambientOcclusionColor;
#endif
finalAmbient*=aoOut.ambientOcclusionColor;finalDiffuse*=ambientOcclusionForDirectDiffuse;
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1A] = shader$1A;

    // Do not edit.
    const name$1B = "pbrBlockFinalColorComposition";
    const shader$1B = `vec4 finalColor=vec4(
#ifndef UNLIT
#ifdef REFLECTION
finalIrradiance +
#endif
#ifdef SPECULARTERM
finalSpecularScaled +
#endif
#ifdef SHEEN
finalSheenScaled +
#endif
#ifdef CLEARCOAT
finalClearCoatScaled +
#endif
#ifdef REFLECTION
finalRadianceScaled +
#if defined(SHEEN) && defined(ENVIRONMENTBRDF)
sheenOut.finalSheenRadianceScaled +
#endif
#ifdef CLEARCOAT
clearcoatOut.finalClearCoatRadianceScaled +
#endif
#endif
#ifdef SS_REFRACTION
subSurfaceOut.finalRefraction +
#endif
#endif
finalAmbient +
finalDiffuse,
alpha);
#ifdef LIGHTMAP
#ifndef LIGHTMAPEXCLUDED
#ifdef USELIGHTMAPASSHADOWMAP
finalColor.rgb*=lightmapColor.rgb;
#else
finalColor.rgb+=lightmapColor.rgb;
#endif
#endif
#endif
finalColor.rgb+=finalEmissive;
#define CUSTOM_FRAGMENT_BEFORE_FOG
finalColor=max(finalColor,0.0);
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1B] = shader$1B;

    // Do not edit.
    const name$1C = "pbrBlockImageProcessing";
    const shader$1C = `#if defined(IMAGEPROCESSINGPOSTPROCESS) || defined(SS_SCATTERING)
#if !defined(SKIPFINALCOLORCLAMP)
finalColor.rgb=clamp(finalColor.rgb,0.,30.0);
#endif
#else
finalColor=applyImageProcessing(finalColor);
#endif
finalColor.a*=visibility;
#ifdef PREMULTIPLYALPHA
finalColor.rgb*=finalColor.a;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1C] = shader$1C;

    // Do not edit.
    const name$1D = "pbrDebug";
    const shader$1D = `#if DEBUGMODE>0
if (vClipSpacePosition.x/vClipSpacePosition.w>=vDebugMode.x) {
#if DEBUGMODE==1
gl_FragColor.rgb=vPositionW.rgb;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==2 && defined(NORMAL)
gl_FragColor.rgb=vNormalW.rgb;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==3 && defined(BUMP) || DEBUGMODE==3 && defined(PARALLAX) || DEBUGMODE==3 && defined(ANISOTROPIC)
gl_FragColor.rgb=TBN[0];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==4 && defined(BUMP) || DEBUGMODE==4 && defined(PARALLAX) || DEBUGMODE==4 && defined(ANISOTROPIC)
gl_FragColor.rgb=TBN[1];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==5
gl_FragColor.rgb=normalW;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==6 && defined(MAINUV1)
gl_FragColor.rgb=vec3(vMainUV1,0.0);
#elif DEBUGMODE==7 && defined(MAINUV2)
gl_FragColor.rgb=vec3(vMainUV2,0.0);
#elif DEBUGMODE==8 && defined(CLEARCOAT) && defined(CLEARCOAT_BUMP)
gl_FragColor.rgb=clearcoatOut.TBNClearCoat[0];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==9 && defined(CLEARCOAT) && defined(CLEARCOAT_BUMP)
gl_FragColor.rgb=clearcoatOut.TBNClearCoat[1];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==10 && defined(CLEARCOAT)
gl_FragColor.rgb=clearcoatOut.clearCoatNormalW;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==11 && defined(ANISOTROPIC)
gl_FragColor.rgb=anisotropicOut.anisotropicNormal;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==12 && defined(ANISOTROPIC)
gl_FragColor.rgb=anisotropicOut.anisotropicTangent;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==13 && defined(ANISOTROPIC)
gl_FragColor.rgb=anisotropicOut.anisotropicBitangent;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==20 && defined(ALBEDO)
gl_FragColor.rgb=albedoTexture.rgb;
#ifndef GAMMAALBEDO
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==21 && defined(AMBIENT)
gl_FragColor.rgb=aoOut.ambientOcclusionColorMap.rgb;
#elif DEBUGMODE==22 && defined(OPACITY)
gl_FragColor.rgb=opacityMap.rgb;
#elif DEBUGMODE==23 && defined(EMISSIVE)
gl_FragColor.rgb=emissiveColorTex.rgb;
#ifndef GAMMAEMISSIVE
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==24 && defined(LIGHTMAP)
gl_FragColor.rgb=lightmapColor.rgb;
#ifndef GAMMALIGHTMAP
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==25 && defined(REFLECTIVITY) && defined(METALLICWORKFLOW)
gl_FragColor.rgb=reflectivityOut.surfaceMetallicColorMap.rgb;
#elif DEBUGMODE==26 && defined(REFLECTIVITY) && !defined(METALLICWORKFLOW)
gl_FragColor.rgb=reflectivityOut.surfaceReflectivityColorMap.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==27 && defined(CLEARCOAT) && defined(CLEARCOAT_TEXTURE)
gl_FragColor.rgb=vec3(clearcoatOut.clearCoatMapData.rg,0.0);
#elif DEBUGMODE==28 && defined(CLEARCOAT) && defined(CLEARCOAT_TINT) && defined(CLEARCOAT_TINT_TEXTURE)
gl_FragColor.rgb=clearcoatOut.clearCoatTintMapData.rgb;
#elif DEBUGMODE==29 && defined(SHEEN) && defined(SHEEN_TEXTURE)
gl_FragColor.rgb=sheenOut.sheenMapData.rgb;
#elif DEBUGMODE==30 && defined(ANISOTROPIC) && defined(ANISOTROPIC_TEXTURE)
gl_FragColor.rgb=anisotropicOut.anisotropyMapData.rgb;
#elif DEBUGMODE==31 && defined(SUBSURFACE) && defined(SS_THICKNESSANDMASK_TEXTURE)
gl_FragColor.rgb=subSurfaceOut.thicknessMap.rgb;
#elif DEBUGMODE==32 && defined(BUMP)
gl_FragColor.rgb=texture2D(bumpSampler,vBumpUV).rgb;
#elif DEBUGMODE==40 && defined(SS_REFRACTION)
gl_FragColor.rgb=subSurfaceOut.environmentRefraction.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==41 && defined(REFLECTION)
gl_FragColor.rgb=reflectionOut.environmentRadiance.rgb;
#ifndef GAMMAREFLECTION
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==42 && defined(CLEARCOAT) && defined(REFLECTION)
gl_FragColor.rgb=clearcoatOut.environmentClearCoatRadiance.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==50
gl_FragColor.rgb=diffuseBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==51 && defined(SPECULARTERM)
gl_FragColor.rgb=specularBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==52 && defined(CLEARCOAT)
gl_FragColor.rgb=clearCoatBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==53 && defined(SHEEN)
gl_FragColor.rgb=sheenBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==54 && defined(REFLECTION)
gl_FragColor.rgb=reflectionOut.environmentIrradiance.rgb;
#ifndef GAMMAREFLECTION
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==60
gl_FragColor.rgb=surfaceAlbedo.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==61
gl_FragColor.rgb=clearcoatOut.specularEnvironmentR0;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==62 && defined(METALLICWORKFLOW)
gl_FragColor.rgb=vec3(reflectivityOut.metallicRoughness.r);
#elif DEBUGMODE==71 && defined(METALLICWORKFLOW)
gl_FragColor.rgb=reflectivityOut.metallicF0;
#elif DEBUGMODE==63
gl_FragColor.rgb=vec3(roughness);
#elif DEBUGMODE==64
gl_FragColor.rgb=vec3(alphaG);
#elif DEBUGMODE==65
gl_FragColor.rgb=vec3(NdotV);
#elif DEBUGMODE==66 && defined(CLEARCOAT) && defined(CLEARCOAT_TINT)
gl_FragColor.rgb=clearcoatOut.clearCoatColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==67 && defined(CLEARCOAT)
gl_FragColor.rgb=vec3(clearcoatOut.clearCoatRoughness);
#elif DEBUGMODE==68 && defined(CLEARCOAT)
gl_FragColor.rgb=vec3(clearcoatOut.clearCoatNdotV);
#elif DEBUGMODE==69 && defined(SUBSURFACE) && defined(SS_TRANSLUCENCY)
gl_FragColor.rgb=subSurfaceOut.transmittance;
#elif DEBUGMODE==70 && defined(SUBSURFACE) && defined(SS_REFRACTION)
gl_FragColor.rgb=subSurfaceOut.refractionTransmittance;
#elif DEBUGMODE==72
gl_FragColor.rgb=vec3(microSurface);
#elif DEBUGMODE==73
gl_FragColor.rgb=vAlbedoColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==74 && !defined(METALLICWORKFLOW)
gl_FragColor.rgb=vReflectivityColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==75
gl_FragColor.rgb=vEmissiveColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==80 && defined(RADIANCEOCCLUSION)
gl_FragColor.rgb=vec3(seo);
#elif DEBUGMODE==81 && defined(HORIZONOCCLUSION)
gl_FragColor.rgb=vec3(eho);
#elif DEBUGMODE==82 && defined(MS_BRDF_ENERGY_CONSERVATION)
gl_FragColor.rgb=vec3(energyConservationFactor);
#elif DEBUGMODE==83 && defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
gl_FragColor.rgb=specularEnvironmentReflectance;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==84 && defined(CLEARCOAT) && defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
gl_FragColor.rgb=clearcoatOut.clearCoatEnvironmentReflectance;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==85 && defined(SHEEN) && defined(REFLECTION)
gl_FragColor.rgb=sheenOut.sheenEnvironmentReflectance;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==86 && defined(ALPHABLEND)
gl_FragColor.rgb=vec3(luminanceOverAlpha);
#elif DEBUGMODE==87
gl_FragColor.rgb=vec3(alpha);
#elif DEBUGMODE==88 && defined(ALBEDO)
gl_FragColor.rgb=vec3(albedoTexture.a);
#else
float stripeWidth=30.;float stripePos=floor((gl_FragCoord.x+gl_FragCoord.y)/stripeWidth);float whichColor=mod(stripePos,2.);vec3 color1=vec3(.6,.2,.2);vec3 color2=vec3(.3,.1,.1);gl_FragColor.rgb=mix(color1,color2,whichColor);
#endif
gl_FragColor.rgb*=vDebugMode.y;
#ifdef DEBUGMODE_NORMALIZE
gl_FragColor.rgb=normalize(gl_FragColor.rgb)*0.5+0.5;
#endif
#ifdef DEBUGMODE_GAMMA
gl_FragColor.rgb=toGammaSpace(gl_FragColor.rgb);
#endif
gl_FragColor.a=1.0;
#ifdef PREPASS
gl_FragData[0]=toLinearSpace(gl_FragColor); 
gl_FragData[1]=vec4(0.,0.,0.,0.); 
#endif
}
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1D] = shader$1D;

    // Do not edit.
    const name$1E = "pbrPixelShader";
    const shader$1E = `#if defined(BUMP) || !defined(NORMAL) || defined(FORCENORMALFORWARD) || defined(SPECULARAA) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#extension GL_OES_standard_derivatives : enable
#endif
#ifdef LODBASEDMICROSFURACE
#extension GL_EXT_shader_texture_lod : enable
#endif
#define CUSTOM_FRAGMENT_BEGIN
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#include<prePassDeclaration>[SCENE_MRT_COUNT]
precision highp float;
#include<oitDeclaration>
#ifndef FROMLINEARSPACE
#define FROMLINEARSPACE
#endif
#include<__decl__pbrFragment>
#include<pbrFragmentExtraDeclaration>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<pbrFragmentSamplersDeclaration>
#include<imageProcessingDeclaration>
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#include<helperFunctions>
#include<subSurfaceScatteringFunctions>
#include<importanceSampling>
#include<pbrHelperFunctions>
#include<imageProcessingFunctions>
#include<shadowsFragmentFunctions>
#include<harmonicsFunctions>
#include<pbrDirectLightingSetupFunctions>
#include<pbrDirectLightingFalloffFunctions>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
#include<pbrDirectLightingFunctions>
#include<pbrIBLFunctions>
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#ifdef REFLECTION
#include<reflectionFunction>
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
#include<pbrBlockAlbedoOpacity>
#include<pbrBlockReflectivity>
#include<pbrBlockAmbientOcclusion>
#include<pbrBlockAlphaFresnel>
#include<pbrBlockAnisotropic>
#include<pbrBlockReflection>
#include<pbrBlockSheen>
#include<pbrBlockClearcoat>
#include<pbrBlockIridescence>
#include<pbrBlockSubSurface>
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#include<pbrBlockNormalGeometric>
#include<bumpFragment>
#include<pbrBlockNormalFinal>
albedoOpacityOutParams albedoOpacityOut;
#ifdef ALBEDO
vec4 albedoTexture=texture2D(albedoSampler,vAlbedoUV+uvOffset);
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vOpacityUV+uvOffset);
#endif
#ifdef DECAL
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#endif
albedoOpacityBlock(
vAlbedoColor,
#ifdef ALBEDO
albedoTexture,
vAlbedoInfos,
#endif
#ifdef OPACITY
opacityMap,
vOpacityInfos,
#endif
#ifdef DETAIL
detailColor,
vDetailInfos,
#endif
#ifdef DECAL
decalColor,
vDecalInfos,
#endif
albedoOpacityOut
);vec3 surfaceAlbedo=albedoOpacityOut.surfaceAlbedo;float alpha=albedoOpacityOut.alpha;
#define CUSTOM_FRAGMENT_UPDATE_ALPHA
#include<depthPrePass>
#define CUSTOM_FRAGMENT_BEFORE_LIGHTS
ambientOcclusionOutParams aoOut;
#ifdef AMBIENT
vec3 ambientOcclusionColorMap=texture2D(ambientSampler,vAmbientUV+uvOffset).rgb;
#endif
ambientOcclusionBlock(
#ifdef AMBIENT
ambientOcclusionColorMap,
vAmbientInfos,
#endif
aoOut
);
#include<pbrBlockLightmapInit>
#ifdef UNLIT
vec3 diffuseBase=vec3(1.,1.,1.);
#else
vec3 baseColor=surfaceAlbedo;reflectivityOutParams reflectivityOut;
#if defined(REFLECTIVITY)
vec4 surfaceMetallicOrReflectivityColorMap=texture2D(reflectivitySampler,vReflectivityUV+uvOffset);vec4 baseReflectivity=surfaceMetallicOrReflectivityColorMap;
#ifndef METALLICWORKFLOW
#ifdef REFLECTIVITY_GAMMA
surfaceMetallicOrReflectivityColorMap=toLinearSpace(surfaceMetallicOrReflectivityColorMap);
#endif
surfaceMetallicOrReflectivityColorMap.rgb*=vReflectivityInfos.y;
#endif
#endif
#if defined(MICROSURFACEMAP)
vec4 microSurfaceTexel=texture2D(microSurfaceSampler,vMicroSurfaceSamplerUV+uvOffset)*vMicroSurfaceSamplerInfos.y;
#endif
#ifdef METALLICWORKFLOW
vec4 metallicReflectanceFactors=vMetallicReflectanceFactors;
#ifdef REFLECTANCE
vec4 reflectanceFactorsMap=texture2D(reflectanceSampler,vReflectanceUV+uvOffset);
#ifdef REFLECTANCE_GAMMA
reflectanceFactorsMap=toLinearSpace(reflectanceFactorsMap);
#endif
metallicReflectanceFactors.rgb*=reflectanceFactorsMap.rgb;
#endif
#ifdef METALLIC_REFLECTANCE
vec4 metallicReflectanceFactorsMap=texture2D(metallicReflectanceSampler,vMetallicReflectanceUV+uvOffset);
#ifdef METALLIC_REFLECTANCE_GAMMA
metallicReflectanceFactorsMap=toLinearSpace(metallicReflectanceFactorsMap);
#endif
#ifndef METALLIC_REFLECTANCE_USE_ALPHA_ONLY
metallicReflectanceFactors.rgb*=metallicReflectanceFactorsMap.rgb;
#endif
metallicReflectanceFactors*=metallicReflectanceFactorsMap.a;
#endif
#endif
reflectivityBlock(
vReflectivityColor,
#ifdef METALLICWORKFLOW
surfaceAlbedo,
metallicReflectanceFactors,
#endif
#ifdef REFLECTIVITY
vReflectivityInfos,
surfaceMetallicOrReflectivityColorMap,
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
aoOut.ambientOcclusionColor,
#endif
#ifdef MICROSURFACEMAP
microSurfaceTexel,
#endif
#ifdef DETAIL
detailColor,
vDetailInfos,
#endif
reflectivityOut
);float microSurface=reflectivityOut.microSurface;float roughness=reflectivityOut.roughness;
#ifdef METALLICWORKFLOW
surfaceAlbedo=reflectivityOut.surfaceAlbedo;
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
aoOut.ambientOcclusionColor=reflectivityOut.ambientOcclusionColor;
#endif
#ifdef ALPHAFRESNEL
#if defined(ALPHATEST) || defined(ALPHABLEND)
alphaFresnelOutParams alphaFresnelOut;alphaFresnelBlock(
normalW,
viewDirectionW,
alpha,
microSurface,
alphaFresnelOut
);alpha=alphaFresnelOut.alpha;
#endif
#endif
#include<pbrBlockGeometryInfo>
#ifdef ANISOTROPIC
anisotropicOutParams anisotropicOut;
#ifdef ANISOTROPIC_TEXTURE
vec3 anisotropyMapData=texture2D(anisotropySampler,vAnisotropyUV+uvOffset).rgb*vAnisotropyInfos.y;
#endif
anisotropicBlock(
vAnisotropy,
roughness,
#ifdef ANISOTROPIC_TEXTURE
anisotropyMapData,
#endif
TBN,
normalW,
viewDirectionW,
anisotropicOut
);
#endif
#ifdef REFLECTION
reflectionOutParams reflectionOut;
#ifndef USE_CUSTOM_REFLECTION
reflectionBlock(
vPositionW,
normalW,
alphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#ifdef ANISOTROPIC
anisotropicOut,
#endif
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
roughness,
#endif
reflectionSampler,
#if defined(NORMAL) && defined(USESPHERICALINVERTEX)
vEnvironmentIrradiance,
#endif
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
reflectionMatrix,
#endif
#endif
#ifdef USEIRRADIANCEMAP
irradianceSampler,
#endif
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
reflectionOut
);
#else
#define CUSTOM_REFLECTION
#endif
#endif
#include<pbrBlockReflectance0>
#ifdef SHEEN
sheenOutParams sheenOut;
#ifdef SHEEN_TEXTURE
vec4 sheenMapData=texture2D(sheenSampler,vSheenUV+uvOffset);
#endif
#if defined(SHEEN_ROUGHNESS) && defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE)
vec4 sheenMapRoughnessData=texture2D(sheenRoughnessSampler,vSheenRoughnessUV+uvOffset)*vSheenInfos.w;
#endif
sheenBlock(
vSheenColor,
#ifdef SHEEN_ROUGHNESS
vSheenRoughness,
#if defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE)
sheenMapRoughnessData,
#endif
#endif
roughness,
#ifdef SHEEN_TEXTURE
sheenMapData,
vSheenInfos.y,
#endif
reflectance,
#ifdef SHEEN_LINKWITHALBEDO
baseColor,
surfaceAlbedo,
#endif
#ifdef ENVIRONMENTBRDF
NdotV,
environmentBrdf,
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
AARoughnessFactors,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
vLightingIntensity,
reflectionSampler,
reflectionOut.reflectionCoords,
NdotVUnclamped,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(RADIANCEOCCLUSION)
seo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
eho,
#endif
#endif
sheenOut
);
#ifdef SHEEN_LINKWITHALBEDO
surfaceAlbedo=sheenOut.surfaceAlbedo;
#endif
#endif
#ifdef CLEARCOAT
#ifdef CLEARCOAT_TEXTURE
vec2 clearCoatMapData=texture2D(clearCoatSampler,vClearCoatUV+uvOffset).rg*vClearCoatInfos.y;
#endif
#endif
#ifdef IRIDESCENCE
iridescenceOutParams iridescenceOut;
#ifdef IRIDESCENCE_TEXTURE
vec2 iridescenceMapData=texture2D(iridescenceSampler,vIridescenceUV+uvOffset).rg*vIridescenceInfos.y;
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
vec2 iridescenceThicknessMapData=texture2D(iridescenceThicknessSampler,vIridescenceThicknessUV+uvOffset).rg*vIridescenceInfos.w;
#endif
iridescenceBlock(
vIridescenceParams,
NdotV,
specularEnvironmentR0,
#ifdef IRIDESCENCE_TEXTURE
iridescenceMapData,
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
iridescenceThicknessMapData,
#endif
#ifdef CLEARCOAT
NdotVUnclamped,
#ifdef CLEARCOAT_TEXTURE
clearCoatMapData,
#endif
#endif
iridescenceOut
);float iridescenceIntensity=iridescenceOut.iridescenceIntensity;specularEnvironmentR0=iridescenceOut.specularEnvironmentR0;
#endif
clearcoatOutParams clearcoatOut;
#ifdef CLEARCOAT
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
vec4 clearCoatMapRoughnessData=texture2D(clearCoatRoughnessSampler,vClearCoatRoughnessUV+uvOffset)*vClearCoatInfos.w;
#endif
#if defined(CLEARCOAT_TINT) && defined(CLEARCOAT_TINT_TEXTURE)
vec4 clearCoatTintMapData=texture2D(clearCoatTintSampler,vClearCoatTintUV+uvOffset);
#endif
#ifdef CLEARCOAT_BUMP
vec4 clearCoatBumpMapData=texture2D(clearCoatBumpSampler,vClearCoatBumpUV+uvOffset);
#endif
clearcoatBlock(
vPositionW,
geometricNormalW,
viewDirectionW,
vClearCoatParams,
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
clearCoatMapRoughnessData,
#endif
specularEnvironmentR0,
#ifdef CLEARCOAT_TEXTURE
clearCoatMapData,
#endif
#ifdef CLEARCOAT_TINT
vClearCoatTintParams,
clearCoatColorAtDistance,
vClearCoatRefractionParams,
#ifdef CLEARCOAT_TINT_TEXTURE
clearCoatTintMapData,
#endif
#endif
#ifdef CLEARCOAT_BUMP
vClearCoatBumpInfos,
clearCoatBumpMapData,
vClearCoatBumpUV,
#if defined(TANGENT) && defined(NORMAL)
vTBN,
#else
vClearCoatTangentSpaceParams,
#endif
#ifdef OBJECTSPACE_NORMALMAP
normalMatrix,
#endif
#endif
#if defined(FORCENORMALFORWARD) && defined(NORMAL)
faceNormal,
#endif
#ifdef REFLECTION
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
vLightingIntensity,
reflectionSampler,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
#ifdef RADIANCEOCCLUSION
ambientMonochrome,
#endif
#endif
#if defined(CLEARCOAT_BUMP) || defined(TWOSIDEDLIGHTING)
(gl_FrontFacing ? 1. : -1.),
#endif
clearcoatOut
);
#else
clearcoatOut.specularEnvironmentR0=specularEnvironmentR0;
#endif
#include<pbrBlockReflectance>
subSurfaceOutParams subSurfaceOut;
#ifdef SUBSURFACE
#ifdef SS_THICKNESSANDMASK_TEXTURE
vec4 thicknessMap=texture2D(thicknessSampler,vThicknessUV+uvOffset);
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
vec4 refractionIntensityMap=texture2D(refractionIntensitySampler,vRefractionIntensityUV+uvOffset);
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
vec4 translucencyIntensityMap=texture2D(translucencyIntensitySampler,vTranslucencyIntensityUV+uvOffset);
#endif
subSurfaceBlock(
vSubSurfaceIntensity,
vThicknessParam,
vTintColor,
normalW,
specularEnvironmentReflectance,
#ifdef SS_THICKNESSANDMASK_TEXTURE
thicknessMap,
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
refractionIntensityMap,
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
translucencyIntensityMap,
#endif
#ifdef REFLECTION
#ifdef SS_TRANSLUCENCY
reflectionMatrix,
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
reflectionOut.irradianceVector,
#endif
#if defined(REALTIME_FILTERING)
reflectionSampler,
vReflectionFilteringInfo,
#endif
#endif
#ifdef USEIRRADIANCEMAP
irradianceSampler,
#endif
#endif
#endif
#if defined(SS_REFRACTION) || defined(SS_TRANSLUCENCY)
surfaceAlbedo,
#endif
#ifdef SS_REFRACTION
vPositionW,
viewDirectionW,
view,
vRefractionInfos,
refractionMatrix,
vRefractionMicrosurfaceInfos,
vLightingIntensity,
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
alpha,
#endif
#ifdef SS_LODINREFRACTIONALPHA
NdotVUnclamped,
#endif
#ifdef SS_LINEARSPECULARREFRACTION
roughness,
#endif
alphaG,
refractionSampler,
#ifndef LODBASEDMICROSFURACE
refractionSamplerLow,
refractionSamplerHigh,
#endif
#ifdef ANISOTROPIC
anisotropicOut,
#endif
#ifdef REALTIME_FILTERING
vRefractionFilteringInfo,
#endif
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
vRefractionPosition,
vRefractionSize,
#endif
#endif
#ifdef SS_TRANSLUCENCY
vDiffusionDistance,
#endif
subSurfaceOut
);
#ifdef SS_REFRACTION
surfaceAlbedo=subSurfaceOut.surfaceAlbedo;
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
alpha=subSurfaceOut.alpha;
#endif
#endif
#else
subSurfaceOut.specularEnvironmentReflectance=specularEnvironmentReflectance;
#endif
#include<pbrBlockDirectLighting>
#include<lightFragment>[0..maxSimultaneousLights]
#include<pbrBlockFinalLitComponents>
#endif 
#include<pbrBlockFinalUnlitComponents>
#define CUSTOM_FRAGMENT_BEFORE_FINALCOLORCOMPOSITION
#include<pbrBlockFinalColorComposition>
#include<logDepthFragment>
#include<fogFragment>(color,finalColor)
#include<pbrBlockImageProcessing>
#define CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR
#ifdef PREPASS
float writeGeometryInfo=finalColor.a>0.4 ? 1.0 : 0.0;
#ifdef PREPASS_POSITION
gl_FragData[PREPASS_POSITION_INDEX]=vec4(vPositionW,writeGeometryInfo);
#endif
#ifdef PREPASS_VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[PREPASS_VELOCITY_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_ALBEDO_SQRT
vec3 sqAlbedo=sqrt(surfaceAlbedo); 
#endif
#ifdef PREPASS_IRRADIANCE
vec3 irradiance=finalDiffuse;
#ifndef UNLIT
#ifdef REFLECTION
irradiance+=finalIrradiance;
#endif
#endif
#ifdef SS_SCATTERING
gl_FragData[0]=vec4(finalColor.rgb-irradiance,finalColor.a); 
irradiance/=sqAlbedo;
#else
gl_FragData[0]=finalColor; 
float scatteringDiffusionProfile=255.;
#endif
gl_FragData[PREPASS_IRRADIANCE_INDEX]=vec4(clamp(irradiance,vec3(0.),vec3(1.)),writeGeometryInfo*scatteringDiffusionProfile/255.); 
#else
gl_FragData[0]=vec4(finalColor.rgb,finalColor.a);
#endif
#ifdef PREPASS_DEPTH
gl_FragData[PREPASS_DEPTH_INDEX]=vec4(vViewPos.z,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_NORMAL
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalize((view*vec4(normalW,0.0)).rgb),writeGeometryInfo); 
#endif
#ifdef PREPASS_ALBEDO_SQRT
gl_FragData[PREPASS_ALBEDO_SQRT_INDEX]=vec4(sqAlbedo,writeGeometryInfo); 
#endif
#ifdef PREPASS_REFLECTIVITY
#ifndef UNLIT
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(specularEnvironmentR0,microSurface)*writeGeometryInfo;
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4( 0.0,0.0,0.0,1.0 )*writeGeometryInfo;
#endif
#endif
#endif
#if !defined(PREPASS) || defined(WEBGL2)
gl_FragColor=finalColor;
#endif
#include<oitFragment>
#if ORDER_INDEPENDENT_TRANSPARENCY
if (fragDepth==nearestDepth) {frontColor.rgb+=finalColor.rgb*finalColor.a*alphaMultiplier;frontColor.a=1.0-alphaMultiplier*(1.0-finalColor.a);} else {backColor+=finalColor;}
#endif
#include<pbrDebug>
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1E] = shader$1E;

    // Do not edit.
    const name$1F = "pbrVertexDeclaration";
    const shader$1F = `uniform mat4 view;uniform mat4 viewProjection;
#ifdef ALBEDO
uniform mat4 albedoMatrix;uniform vec2 vAlbedoInfos;
#endif
#ifdef AMBIENT
uniform mat4 ambientMatrix;uniform vec4 vAmbientInfos;
#endif
#ifdef OPACITY
uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;uniform mat4 emissiveMatrix;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;uniform mat4 lightmapMatrix;
#endif
#ifdef REFLECTIVITY 
uniform vec3 vReflectivityInfos;uniform mat4 reflectivityMatrix;
#endif
#ifdef METALLIC_REFLECTANCE
uniform vec2 vMetallicReflectanceInfos;uniform mat4 metallicReflectanceMatrix;
#endif
#ifdef REFLECTANCE
uniform vec2 vReflectanceInfos;uniform mat4 reflectanceMatrix;
#endif
#ifdef MICROSURFACEMAP
uniform vec2 vMicroSurfaceSamplerInfos;uniform mat4 microSurfaceSamplerMatrix;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform mat4 bumpMatrix;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;
#endif
#ifdef CLEARCOAT
#if defined(CLEARCOAT_TEXTURE) || defined(CLEARCOAT_TEXTURE_ROUGHNESS)
uniform vec4 vClearCoatInfos;
#endif
#ifdef CLEARCOAT_TEXTURE
uniform mat4 clearCoatMatrix;
#endif
#ifdef CLEARCOAT_TEXTURE_ROUGHNESS
uniform mat4 clearCoatRoughnessMatrix;
#endif
#ifdef CLEARCOAT_BUMP
uniform vec2 vClearCoatBumpInfos;uniform mat4 clearCoatBumpMatrix;
#endif
#ifdef CLEARCOAT_TINT_TEXTURE
uniform vec2 vClearCoatTintInfos;uniform mat4 clearCoatTintMatrix;
#endif
#endif
#ifdef IRIDESCENCE
#if defined(IRIDESCENCE_TEXTURE) || defined(IRIDESCENCE_THICKNESS_TEXTURE)
uniform vec4 vIridescenceInfos;
#endif
#ifdef IRIDESCENCE_TEXTURE
uniform mat4 iridescenceMatrix;
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
uniform mat4 iridescenceThicknessMatrix;
#endif
#endif
#ifdef ANISOTROPIC
#ifdef ANISOTROPIC_TEXTURE
uniform vec2 vAnisotropyInfos;uniform mat4 anisotropyMatrix;
#endif
#endif
#ifdef SHEEN
#if defined(SHEEN_TEXTURE) || defined(SHEEN_TEXTURE_ROUGHNESS)
uniform vec4 vSheenInfos;
#endif
#ifdef SHEEN_TEXTURE
uniform mat4 sheenMatrix;
#endif
#ifdef SHEEN_TEXTURE_ROUGHNESS
uniform mat4 sheenRoughnessMatrix;
#endif
#endif
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
uniform vec4 vRefractionInfos;uniform mat4 refractionMatrix;
#endif
#ifdef SS_THICKNESSANDMASK_TEXTURE
uniform vec2 vThicknessInfos;uniform mat4 thicknessMatrix;
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
uniform vec2 vRefractionIntensityInfos;uniform mat4 refractionIntensityMatrix;
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
uniform vec2 vTranslucencyIntensityInfos;uniform mat4 translucencyIntensityMatrix;
#endif
#endif
#ifdef NORMAL
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
#ifdef USESPHERICALFROMREFLECTIONMAP
#ifdef SPHERICAL_HARMONICS
uniform vec3 vSphericalL00;uniform vec3 vSphericalL1_1;uniform vec3 vSphericalL10;uniform vec3 vSphericalL11;uniform vec3 vSphericalL2_2;uniform vec3 vSphericalL2_1;uniform vec3 vSphericalL20;uniform vec3 vSphericalL21;uniform vec3 vSphericalL22;
#else
uniform vec3 vSphericalX;uniform vec3 vSphericalY;uniform vec3 vSphericalZ;uniform vec3 vSphericalXX_ZZ;uniform vec3 vSphericalYY_ZZ;uniform vec3 vSphericalZZ;uniform vec3 vSphericalXY;uniform vec3 vSphericalYZ;uniform vec3 vSphericalZX;
#endif
#endif
#endif
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;uniform mat4 detailMatrix;
#endif
#include<decalVertexDeclaration>
#define ADDITIONAL_VERTEX_DECLARATION
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1F] = shader$1F;

    // Do not edit.
    const name$1G = "pbrVertexShader";
    const shader$1G = `precision highp float;
#include<__decl__pbrVertex>
#define CUSTOM_VERTEX_BEGIN
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#ifdef TANGENT
attribute vec4 tangent;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#include<uvAttributeDeclaration>[2..7]
#include<mainUVVaryingDeclaration>[1..7]
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<helperFunctions>
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
#include<prePassVertexDeclaration>
#include<samplerVertexDeclaration>(_DEFINENAME_,ALBEDO,_VARYINGNAME_,Albedo)
#include<samplerVertexDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail)
#include<samplerVertexDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient)
#include<samplerVertexDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity)
#include<samplerVertexDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive)
#include<samplerVertexDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap)
#include<samplerVertexDeclaration>(_DEFINENAME_,REFLECTIVITY,_VARYINGNAME_,Reflectivity)
#include<samplerVertexDeclaration>(_DEFINENAME_,MICROSURFACEMAP,_VARYINGNAME_,MicroSurfaceSampler)
#include<samplerVertexDeclaration>(_DEFINENAME_,METALLIC_REFLECTANCE,_VARYINGNAME_,MetallicReflectance)
#include<samplerVertexDeclaration>(_DEFINENAME_,REFLECTANCE,_VARYINGNAME_,Reflectance)
#include<samplerVertexDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump)
#include<samplerVertexDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal)
#ifdef CLEARCOAT
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE,_VARYINGNAME_,ClearCoat)
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE_ROUGHNESS,_VARYINGNAME_,ClearCoatRoughness)
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_BUMP,_VARYINGNAME_,ClearCoatBump)
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_TINT_TEXTURE,_VARYINGNAME_,ClearCoatTint)
#endif
#ifdef IRIDESCENCE
#include<samplerVertexDeclaration>(_DEFINENAME_,IRIDESCENCE_TEXTURE,_VARYINGNAME_,Iridescence)
#include<samplerVertexDeclaration>(_DEFINENAME_,IRIDESCENCE_THICKNESS_TEXTURE,_VARYINGNAME_,IridescenceThickness)
#endif
#ifdef SHEEN
#include<samplerVertexDeclaration>(_DEFINENAME_,SHEEN_TEXTURE,_VARYINGNAME_,Sheen)
#include<samplerVertexDeclaration>(_DEFINENAME_,SHEEN_TEXTURE_ROUGHNESS,_VARYINGNAME_,SheenRoughness)
#endif
#ifdef ANISOTROPIC
#include<samplerVertexDeclaration>(_DEFINENAME_,ANISOTROPIC_TEXTURE,_VARYINGNAME_,Anisotropy)
#endif
#ifdef SUBSURFACE
#include<samplerVertexDeclaration>(_DEFINENAME_,SS_THICKNESSANDMASK_TEXTURE,_VARYINGNAME_,Thickness)
#include<samplerVertexDeclaration>(_DEFINENAME_,SS_REFRACTIONINTENSITY_TEXTURE,_VARYINGNAME_,RefractionIntensity)
#include<samplerVertexDeclaration>(_DEFINENAME_,SS_TRANSLUCENCYINTENSITY_TEXTURE,_VARYINGNAME_,TranslucencyIntensity)
#endif
varying vec3 vPositionW;
#if DEBUGMODE>0
varying vec4 vClipSpacePosition;
#endif
#ifdef NORMAL
varying vec3 vNormalW;
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
varying vec3 vEnvironmentIrradiance;
#include<harmonicsFunctions>
#endif
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<bumpVertexDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#ifdef TANGENT
vec4 tangentUpdated=tangent;
#endif
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=positionUpdated;
#endif
#define CUSTOM_VERTEX_UPDATE_POSITION
#define CUSTOM_VERTEX_UPDATE_NORMAL
#include<instancesVertex>
#if defined(PREPASS) && defined(PREPASS_VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);vPositionW=vec3(worldPos);
#include<prePassVertex>
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normalWorld[0],normalWorld[0]),dot(normalWorld[1],normalWorld[1]),dot(normalWorld[2],normalWorld[2]));vNormalW=normalize(normalWorld*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normalUpdated);
#endif
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
vec3 reflectionVector=vec3(reflectionMatrix*vec4(vNormalW,0)).xyz;
#ifdef REFLECTIONMAP_OPPOSITEZ
reflectionVector.z*=-1.0;
#endif
vEnvironmentIrradiance=computeEnvironmentIrradiance(reflectionVector);
#endif
#endif
#define CUSTOM_VERTEX_UPDATE_WORLDPOS
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#if DEBUGMODE>0
vClipSpacePosition=gl_Position;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(positionUpdated,0.0)));
#endif
#ifndef UV1
vec2 uvUpdated=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uvUpdated;
#endif
#include<uvVariableDeclaration>[2..7]
#include<samplerVertexImplementation>(_DEFINENAME_,ALBEDO,_VARYINGNAME_,Albedo,_MATRIXNAME_,albedo,_INFONAME_,AlbedoInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_MATRIXNAME_,detail,_INFONAME_,DetailInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_MATRIXNAME_,ambient,_INFONAME_,AmbientInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_MATRIXNAME_,opacity,_INFONAME_,OpacityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_MATRIXNAME_,emissive,_INFONAME_,EmissiveInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_MATRIXNAME_,lightmap,_INFONAME_,LightmapInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,REFLECTIVITY,_VARYINGNAME_,Reflectivity,_MATRIXNAME_,reflectivity,_INFONAME_,ReflectivityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,MICROSURFACEMAP,_VARYINGNAME_,MicroSurfaceSampler,_MATRIXNAME_,microSurfaceSampler,_INFONAME_,MicroSurfaceSamplerInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,METALLIC_REFLECTANCE,_VARYINGNAME_,MetallicReflectance,_MATRIXNAME_,metallicReflectance,_INFONAME_,MetallicReflectanceInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,REFLECTANCE,_VARYINGNAME_,Reflectance,_MATRIXNAME_,reflectance,_INFONAME_,ReflectanceInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_MATRIXNAME_,bump,_INFONAME_,BumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_MATRIXNAME_,decal,_INFONAME_,DecalInfos.x)
#ifdef CLEARCOAT
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_TEXTURE,_VARYINGNAME_,ClearCoat,_MATRIXNAME_,clearCoat,_INFONAME_,ClearCoatInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_TEXTURE_ROUGHNESS,_VARYINGNAME_,ClearCoatRoughness,_MATRIXNAME_,clearCoatRoughness,_INFONAME_,ClearCoatInfos.z)
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_BUMP,_VARYINGNAME_,ClearCoatBump,_MATRIXNAME_,clearCoatBump,_INFONAME_,ClearCoatBumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_TINT_TEXTURE,_VARYINGNAME_,ClearCoatTint,_MATRIXNAME_,clearCoatTint,_INFONAME_,ClearCoatTintInfos.x)
#endif
#ifdef IRIDESCENCE
#include<samplerVertexImplementation>(_DEFINENAME_,IRIDESCENCE_TEXTURE,_VARYINGNAME_,Iridescence,_MATRIXNAME_,iridescence,_INFONAME_,IridescenceInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,IRIDESCENCE_THICKNESS_TEXTURE,_VARYINGNAME_,IridescenceThickness,_MATRIXNAME_,iridescenceThickness,_INFONAME_,IridescenceInfos.z)
#endif
#ifdef SHEEN
#include<samplerVertexImplementation>(_DEFINENAME_,SHEEN_TEXTURE,_VARYINGNAME_,Sheen,_MATRIXNAME_,sheen,_INFONAME_,SheenInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,SHEEN_TEXTURE_ROUGHNESS,_VARYINGNAME_,SheenRoughness,_MATRIXNAME_,sheen,_INFONAME_,SheenInfos.z)
#endif
#ifdef ANISOTROPIC
#include<samplerVertexImplementation>(_DEFINENAME_,ANISOTROPIC_TEXTURE,_VARYINGNAME_,Anisotropy,_MATRIXNAME_,anisotropy,_INFONAME_,AnisotropyInfos.x)
#endif
#ifdef SUBSURFACE
#include<samplerVertexImplementation>(_DEFINENAME_,SS_THICKNESSANDMASK_TEXTURE,_VARYINGNAME_,Thickness,_MATRIXNAME_,thickness,_INFONAME_,ThicknessInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,SS_REFRACTIONINTENSITY_TEXTURE,_VARYINGNAME_,RefractionIntensity,_MATRIXNAME_,refractionIntensity,_INFONAME_,RefractionIntensityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,SS_TRANSLUCENCYINTENSITY_TEXTURE,_VARYINGNAME_,TranslucencyIntensity,_MATRIXNAME_,translucencyIntensity,_INFONAME_,TranslucencyIntensityInfos.x)
#endif
#include<bumpVertex>
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1G] = shader$1G;

    /**
     * @internal
     */
    class MaterialClearCoatDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.CLEARCOAT = false;
            this.CLEARCOAT_DEFAULTIOR = false;
            this.CLEARCOAT_TEXTURE = false;
            this.CLEARCOAT_TEXTURE_ROUGHNESS = false;
            this.CLEARCOAT_TEXTUREDIRECTUV = 0;
            this.CLEARCOAT_TEXTURE_ROUGHNESSDIRECTUV = 0;
            this.CLEARCOAT_BUMP = false;
            this.CLEARCOAT_BUMPDIRECTUV = 0;
            this.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
            this.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL = false;
            this.CLEARCOAT_REMAP_F0 = false;
            this.CLEARCOAT_TINT = false;
            this.CLEARCOAT_TINT_TEXTURE = false;
            this.CLEARCOAT_TINT_TEXTUREDIRECTUV = 0;
            this.CLEARCOAT_TINT_GAMMATEXTURE = false;
        }
    }
    /**
     * Plugin that implements the clear coat component of the PBR material
     */
    class PBRClearCoatConfiguration extends MaterialPluginBase {
        /** @internal */
        _markAllSubMeshesAsTexturesDirty() {
            this._enable(this._isEnabled);
            this._internalMarkAllSubMeshesAsTexturesDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "PBRClearCoat", 100, new MaterialClearCoatDefines(), addToPluginList);
            this._isEnabled = false;
            /**
             * Defines if the clear coat is enabled in the material.
             */
            this.isEnabled = false;
            /**
             * Defines the clear coat layer strength (between 0 and 1) it defaults to 1.
             */
            this.intensity = 1;
            /**
             * Defines the clear coat layer roughness.
             */
            this.roughness = 0;
            this._indexOfRefraction = PBRClearCoatConfiguration._DefaultIndexOfRefraction;
            /**
             * Defines the index of refraction of the clear coat.
             * This defaults to 1.5 corresponding to a 0.04 f0 or a 4% reflectance at normal incidence
             * The default fits with a polyurethane material.
             * Changing the default value is more performance intensive.
             */
            this.indexOfRefraction = PBRClearCoatConfiguration._DefaultIndexOfRefraction;
            this._texture = null;
            /**
             * Stores the clear coat values in a texture (red channel is intensity and green channel is roughness)
             * If useRoughnessFromMainTexture is false, the green channel of texture is not used and the green channel of textureRoughness is used instead
             * if textureRoughness is not empty, else no texture roughness is used
             */
            this.texture = null;
            this._useRoughnessFromMainTexture = true;
            /**
             * Indicates that the green channel of the texture property will be used for roughness (default: true)
             * If false, the green channel from textureRoughness is used for roughness
             */
            this.useRoughnessFromMainTexture = true;
            this._textureRoughness = null;
            /**
             * Stores the clear coat roughness in a texture (green channel)
             * Not used if useRoughnessFromMainTexture is true
             */
            this.textureRoughness = null;
            this._remapF0OnInterfaceChange = true;
            /**
             * Defines if the F0 value should be remapped to account for the interface change in the material.
             */
            this.remapF0OnInterfaceChange = true;
            this._bumpTexture = null;
            /**
             * Define the clear coat specific bump texture.
             */
            this.bumpTexture = null;
            this._isTintEnabled = false;
            /**
             * Defines if the clear coat tint is enabled in the material.
             */
            this.isTintEnabled = false;
            /**
             * Defines the clear coat tint of the material.
             * This is only use if tint is enabled
             */
            this.tintColor = Color3.White();
            /**
             * Defines the distance at which the tint color should be found in the
             * clear coat media.
             * This is only use if tint is enabled
             */
            this.tintColorAtDistance = 1;
            /**
             * Defines the clear coat layer thickness.
             * This is only use if tint is enabled
             */
            this.tintThickness = 1;
            this._tintTexture = null;
            /**
             * Stores the clear tint values in a texture.
             * rgb is tint
             * a is a thickness factor
             */
            this.tintTexture = null;
            this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        }
        isReadyForSubMesh(defines, scene, engine) {
            if (!this._isEnabled) {
                return true;
            }
            const disableBumpMap = this._material._disableBumpMap;
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && MaterialFlags.ClearCoatTextureEnabled) {
                        if (!this._texture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (this._textureRoughness && MaterialFlags.ClearCoatTextureEnabled) {
                        if (!this._textureRoughness.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (engine.getCaps().standardDerivatives && this._bumpTexture && MaterialFlags.ClearCoatBumpTextureEnabled && !disableBumpMap) {
                        // Bump texture cannot be not blocking.
                        if (!this._bumpTexture.isReady()) {
                            return false;
                        }
                    }
                    if (this._isTintEnabled && this._tintTexture && MaterialFlags.ClearCoatTintTextureEnabled) {
                        if (!this._tintTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        prepareDefinesBeforeAttributes(defines, scene) {
            var _a;
            if (this._isEnabled) {
                defines.CLEARCOAT = true;
                defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE = this._useRoughnessFromMainTexture;
                defines.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL =
                    this._texture !== null && this._texture._texture === ((_a = this._textureRoughness) === null || _a === void 0 ? void 0 : _a._texture) && this._texture.checkTransformsAreIdentical(this._textureRoughness);
                defines.CLEARCOAT_REMAP_F0 = this._remapF0OnInterfaceChange;
                if (defines._areTexturesDirty) {
                    if (scene.texturesEnabled) {
                        if (this._texture && MaterialFlags.ClearCoatTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._texture, defines, "CLEARCOAT_TEXTURE");
                        }
                        else {
                            defines.CLEARCOAT_TEXTURE = false;
                        }
                        if (this._textureRoughness && MaterialFlags.ClearCoatTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._textureRoughness, defines, "CLEARCOAT_TEXTURE_ROUGHNESS");
                        }
                        else {
                            defines.CLEARCOAT_TEXTURE_ROUGHNESS = false;
                        }
                        if (this._bumpTexture && MaterialFlags.ClearCoatBumpTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._bumpTexture, defines, "CLEARCOAT_BUMP");
                        }
                        else {
                            defines.CLEARCOAT_BUMP = false;
                        }
                        defines.CLEARCOAT_DEFAULTIOR = this._indexOfRefraction === PBRClearCoatConfiguration._DefaultIndexOfRefraction;
                        if (this._isTintEnabled) {
                            defines.CLEARCOAT_TINT = true;
                            if (this._tintTexture && MaterialFlags.ClearCoatTintTextureEnabled) {
                                MaterialHelper.PrepareDefinesForMergedUV(this._tintTexture, defines, "CLEARCOAT_TINT_TEXTURE");
                                defines.CLEARCOAT_TINT_GAMMATEXTURE = this._tintTexture.gammaSpace;
                            }
                            else {
                                defines.CLEARCOAT_TINT_TEXTURE = false;
                            }
                        }
                        else {
                            defines.CLEARCOAT_TINT = false;
                            defines.CLEARCOAT_TINT_TEXTURE = false;
                        }
                    }
                }
            }
            else {
                defines.CLEARCOAT = false;
                defines.CLEARCOAT_TEXTURE = false;
                defines.CLEARCOAT_TEXTURE_ROUGHNESS = false;
                defines.CLEARCOAT_BUMP = false;
                defines.CLEARCOAT_TINT = false;
                defines.CLEARCOAT_TINT_TEXTURE = false;
                defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
                defines.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL = false;
                defines.CLEARCOAT_DEFAULTIOR = false;
                defines.CLEARCOAT_TEXTUREDIRECTUV = 0;
                defines.CLEARCOAT_TEXTURE_ROUGHNESSDIRECTUV = 0;
                defines.CLEARCOAT_BUMPDIRECTUV = 0;
                defines.CLEARCOAT_REMAP_F0 = false;
                defines.CLEARCOAT_TINT_TEXTUREDIRECTUV = 0;
                defines.CLEARCOAT_TINT_GAMMATEXTURE = false;
            }
        }
        bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (!this._isEnabled) {
                return;
            }
            const defines = subMesh.materialDefines;
            const isFrozen = this._material.isFrozen;
            const disableBumpMap = this._material._disableBumpMap;
            const invertNormalMapX = this._material._invertNormalMapX;
            const invertNormalMapY = this._material._invertNormalMapY;
            const identicalTextures = defines.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL;
            if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
                if (identicalTextures && MaterialFlags.ClearCoatTextureEnabled) {
                    uniformBuffer.updateFloat4("vClearCoatInfos", this._texture.coordinatesIndex, this._texture.level, -1, -1);
                    MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "clearCoat");
                }
                else if ((this._texture || this._textureRoughness) && MaterialFlags.ClearCoatTextureEnabled) {
                    uniformBuffer.updateFloat4("vClearCoatInfos", (_b = (_a = this._texture) === null || _a === void 0 ? void 0 : _a.coordinatesIndex) !== null && _b !== void 0 ? _b : 0, (_d = (_c = this._texture) === null || _c === void 0 ? void 0 : _c.level) !== null && _d !== void 0 ? _d : 0, (_f = (_e = this._textureRoughness) === null || _e === void 0 ? void 0 : _e.coordinatesIndex) !== null && _f !== void 0 ? _f : 0, (_h = (_g = this._textureRoughness) === null || _g === void 0 ? void 0 : _g.level) !== null && _h !== void 0 ? _h : 0);
                    if (this._texture) {
                        MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "clearCoat");
                    }
                    if (this._textureRoughness && !identicalTextures && !defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE) {
                        MaterialHelper.BindTextureMatrix(this._textureRoughness, uniformBuffer, "clearCoatRoughness");
                    }
                }
                if (this._bumpTexture && engine.getCaps().standardDerivatives && MaterialFlags.ClearCoatTextureEnabled && !disableBumpMap) {
                    uniformBuffer.updateFloat2("vClearCoatBumpInfos", this._bumpTexture.coordinatesIndex, this._bumpTexture.level);
                    MaterialHelper.BindTextureMatrix(this._bumpTexture, uniformBuffer, "clearCoatBump");
                    if (scene._mirroredCameraPosition) {
                        uniformBuffer.updateFloat2("vClearCoatTangentSpaceParams", invertNormalMapX ? 1.0 : -1.0, invertNormalMapY ? 1.0 : -1.0);
                    }
                    else {
                        uniformBuffer.updateFloat2("vClearCoatTangentSpaceParams", invertNormalMapX ? -1.0 : 1.0, invertNormalMapY ? -1.0 : 1.0);
                    }
                }
                if (this._tintTexture && MaterialFlags.ClearCoatTintTextureEnabled) {
                    uniformBuffer.updateFloat2("vClearCoatTintInfos", this._tintTexture.coordinatesIndex, this._tintTexture.level);
                    MaterialHelper.BindTextureMatrix(this._tintTexture, uniformBuffer, "clearCoatTint");
                }
                // Clear Coat General params
                uniformBuffer.updateFloat2("vClearCoatParams", this.intensity, this.roughness);
                // Clear Coat Refraction params
                const a = 1 - this._indexOfRefraction;
                const b = 1 + this._indexOfRefraction;
                const f0 = Math.pow(-a / b, 2); // Schlicks approx: (ior1 - ior2) / (ior1 + ior2) where ior2 for air is close to vacuum = 1.
                const eta = 1 / this._indexOfRefraction;
                uniformBuffer.updateFloat4("vClearCoatRefractionParams", f0, eta, a, b);
                if (this._isTintEnabled) {
                    uniformBuffer.updateFloat4("vClearCoatTintParams", this.tintColor.r, this.tintColor.g, this.tintColor.b, Math.max(0.00001, this.tintThickness));
                    uniformBuffer.updateFloat("clearCoatColorAtDistance", Math.max(0.00001, this.tintColorAtDistance));
                }
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._texture && MaterialFlags.ClearCoatTextureEnabled) {
                    uniformBuffer.setTexture("clearCoatSampler", this._texture);
                }
                if (this._textureRoughness && !identicalTextures && !defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE && MaterialFlags.ClearCoatTextureEnabled) {
                    uniformBuffer.setTexture("clearCoatRoughnessSampler", this._textureRoughness);
                }
                if (this._bumpTexture && engine.getCaps().standardDerivatives && MaterialFlags.ClearCoatBumpTextureEnabled && !disableBumpMap) {
                    uniformBuffer.setTexture("clearCoatBumpSampler", this._bumpTexture);
                }
                if (this._isTintEnabled && this._tintTexture && MaterialFlags.ClearCoatTintTextureEnabled) {
                    uniformBuffer.setTexture("clearCoatTintSampler", this._tintTexture);
                }
            }
        }
        hasTexture(texture) {
            if (this._texture === texture) {
                return true;
            }
            if (this._textureRoughness === texture) {
                return true;
            }
            if (this._bumpTexture === texture) {
                return true;
            }
            if (this._tintTexture === texture) {
                return true;
            }
            return false;
        }
        getActiveTextures(activeTextures) {
            if (this._texture) {
                activeTextures.push(this._texture);
            }
            if (this._textureRoughness) {
                activeTextures.push(this._textureRoughness);
            }
            if (this._bumpTexture) {
                activeTextures.push(this._bumpTexture);
            }
            if (this._tintTexture) {
                activeTextures.push(this._tintTexture);
            }
        }
        getAnimatables(animatables) {
            if (this._texture && this._texture.animations && this._texture.animations.length > 0) {
                animatables.push(this._texture);
            }
            if (this._textureRoughness && this._textureRoughness.animations && this._textureRoughness.animations.length > 0) {
                animatables.push(this._textureRoughness);
            }
            if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) {
                animatables.push(this._bumpTexture);
            }
            if (this._tintTexture && this._tintTexture.animations && this._tintTexture.animations.length > 0) {
                animatables.push(this._tintTexture);
            }
        }
        dispose(forceDisposeTextures) {
            var _a, _b, _c, _d;
            if (forceDisposeTextures) {
                (_a = this._texture) === null || _a === void 0 ? void 0 : _a.dispose();
                (_b = this._textureRoughness) === null || _b === void 0 ? void 0 : _b.dispose();
                (_c = this._bumpTexture) === null || _c === void 0 ? void 0 : _c.dispose();
                (_d = this._tintTexture) === null || _d === void 0 ? void 0 : _d.dispose();
            }
        }
        getClassName() {
            return "PBRClearCoatConfiguration";
        }
        addFallbacks(defines, fallbacks, currentRank) {
            if (defines.CLEARCOAT_BUMP) {
                fallbacks.addFallback(currentRank++, "CLEARCOAT_BUMP");
            }
            if (defines.CLEARCOAT_TINT) {
                fallbacks.addFallback(currentRank++, "CLEARCOAT_TINT");
            }
            if (defines.CLEARCOAT) {
                fallbacks.addFallback(currentRank++, "CLEARCOAT");
            }
            return currentRank;
        }
        getSamplers(samplers) {
            samplers.push("clearCoatSampler", "clearCoatRoughnessSampler", "clearCoatBumpSampler", "clearCoatTintSampler");
        }
        getUniforms() {
            return {
                ubo: [
                    { name: "vClearCoatParams", size: 2, type: "vec2" },
                    { name: "vClearCoatRefractionParams", size: 4, type: "vec4" },
                    { name: "vClearCoatInfos", size: 4, type: "vec4" },
                    { name: "clearCoatMatrix", size: 16, type: "mat4" },
                    { name: "clearCoatRoughnessMatrix", size: 16, type: "mat4" },
                    { name: "vClearCoatBumpInfos", size: 2, type: "vec2" },
                    { name: "vClearCoatTangentSpaceParams", size: 2, type: "vec2" },
                    { name: "clearCoatBumpMatrix", size: 16, type: "mat4" },
                    { name: "vClearCoatTintParams", size: 4, type: "vec4" },
                    { name: "clearCoatColorAtDistance", size: 1, type: "float" },
                    { name: "vClearCoatTintInfos", size: 2, type: "vec2" },
                    { name: "clearCoatTintMatrix", size: 16, type: "mat4" },
                ],
            };
        }
    }
    /**
     * This defaults to 1.5 corresponding to a 0.04 f0 or a 4% reflectance at normal incidence
     * The default fits with a polyurethane material.
     * @internal
     */
    PBRClearCoatConfiguration._DefaultIndexOfRefraction = 1.5;
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "isEnabled", void 0);
    __decorate$1([
        serialize()
    ], PBRClearCoatConfiguration.prototype, "intensity", void 0);
    __decorate$1([
        serialize()
    ], PBRClearCoatConfiguration.prototype, "roughness", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "indexOfRefraction", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "texture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "useRoughnessFromMainTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "textureRoughness", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "remapF0OnInterfaceChange", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "bumpTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "isTintEnabled", void 0);
    __decorate$1([
        serializeAsColor3()
    ], PBRClearCoatConfiguration.prototype, "tintColor", void 0);
    __decorate$1([
        serialize()
    ], PBRClearCoatConfiguration.prototype, "tintColorAtDistance", void 0);
    __decorate$1([
        serialize()
    ], PBRClearCoatConfiguration.prototype, "tintThickness", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRClearCoatConfiguration.prototype, "tintTexture", void 0);

    /**
     * @internal
     */
    class MaterialIridescenceDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.IRIDESCENCE = false;
            this.IRIDESCENCE_TEXTURE = false;
            this.IRIDESCENCE_TEXTUREDIRECTUV = 0;
            this.IRIDESCENCE_THICKNESS_TEXTURE = false;
            this.IRIDESCENCE_THICKNESS_TEXTUREDIRECTUV = 0;
            this.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE = false;
        }
    }
    /**
     * Plugin that implements the iridescence (thin film) component of the PBR material
     */
    class PBRIridescenceConfiguration extends MaterialPluginBase {
        /** @internal */
        _markAllSubMeshesAsTexturesDirty() {
            this._enable(this._isEnabled);
            this._internalMarkAllSubMeshesAsTexturesDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "PBRIridescence", 110, new MaterialIridescenceDefines(), addToPluginList);
            this._isEnabled = false;
            /**
             * Defines if the iridescence is enabled in the material.
             */
            this.isEnabled = false;
            /**
             * Defines the iridescence layer strength (between 0 and 1) it defaults to 1.
             */
            this.intensity = 1;
            /**
             * Defines the minimum thickness of the thin-film layer given in nanometers (nm).
             */
            this.minimumThickness = PBRIridescenceConfiguration._DefaultMinimumThickness;
            /**
             * Defines the maximum thickness of the thin-film layer given in nanometers (nm). This will be the thickness used if not thickness texture has been set.
             */
            this.maximumThickness = PBRIridescenceConfiguration._DefaultMaximumThickness;
            /**
             * Defines the maximum thickness of the thin-film layer given in nanometers (nm).
             */
            this.indexOfRefraction = PBRIridescenceConfiguration._DefaultIndexOfRefraction;
            this._texture = null;
            /**
             * Stores the iridescence intensity in a texture (red channel)
             */
            this.texture = null;
            this._thicknessTexture = null;
            /**
             * Stores the iridescence thickness in a texture (green channel)
             */
            this.thicknessTexture = null;
            this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        }
        isReadyForSubMesh(defines, scene) {
            if (!this._isEnabled) {
                return true;
            }
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && MaterialFlags.IridescenceTextureEnabled) {
                        if (!this._texture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (this._thicknessTexture && MaterialFlags.IridescenceTextureEnabled) {
                        if (!this._thicknessTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        prepareDefinesBeforeAttributes(defines, scene) {
            var _a;
            if (this._isEnabled) {
                defines.IRIDESCENCE = true;
                defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE =
                    this._texture !== null && this._texture._texture === ((_a = this._thicknessTexture) === null || _a === void 0 ? void 0 : _a._texture) && this._texture.checkTransformsAreIdentical(this._thicknessTexture);
                if (defines._areTexturesDirty) {
                    if (scene.texturesEnabled) {
                        if (this._texture && MaterialFlags.IridescenceTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._texture, defines, "IRIDESCENCE_TEXTURE");
                        }
                        else {
                            defines.IRIDESCENCE_TEXTURE = false;
                        }
                        if (!defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE && this._thicknessTexture && MaterialFlags.IridescenceTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._thicknessTexture, defines, "IRIDESCENCE_THICKNESS_TEXTURE");
                        }
                        else {
                            defines.IRIDESCENCE_THICKNESS_TEXTURE = false;
                        }
                    }
                }
            }
            else {
                defines.IRIDESCENCE = false;
                defines.IRIDESCENCE_TEXTURE = false;
                defines.IRIDESCENCE_THICKNESS_TEXTURE = false;
                defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE = false;
                defines.IRIDESCENCE_TEXTUREDIRECTUV = 0;
                defines.IRIDESCENCE_THICKNESS_TEXTUREDIRECTUV = 0;
            }
        }
        bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (!this._isEnabled) {
                return;
            }
            const defines = subMesh.materialDefines;
            const isFrozen = this._material.isFrozen;
            const identicalTextures = defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE;
            if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
                if (identicalTextures && MaterialFlags.IridescenceTextureEnabled) {
                    uniformBuffer.updateFloat4("vIridescenceInfos", this._texture.coordinatesIndex, this._texture.level, -1, -1);
                    MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "iridescence");
                }
                else if ((this._texture || this._thicknessTexture) && MaterialFlags.IridescenceTextureEnabled) {
                    uniformBuffer.updateFloat4("vIridescenceInfos", (_b = (_a = this._texture) === null || _a === void 0 ? void 0 : _a.coordinatesIndex) !== null && _b !== void 0 ? _b : 0, (_d = (_c = this._texture) === null || _c === void 0 ? void 0 : _c.level) !== null && _d !== void 0 ? _d : 0, (_f = (_e = this._thicknessTexture) === null || _e === void 0 ? void 0 : _e.coordinatesIndex) !== null && _f !== void 0 ? _f : 0, (_h = (_g = this._thicknessTexture) === null || _g === void 0 ? void 0 : _g.level) !== null && _h !== void 0 ? _h : 0);
                    if (this._texture) {
                        MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "iridescence");
                    }
                    if (this._thicknessTexture && !identicalTextures && !defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE) {
                        MaterialHelper.BindTextureMatrix(this._thicknessTexture, uniformBuffer, "iridescenceThickness");
                    }
                }
                // Clear Coat General params
                uniformBuffer.updateFloat4("vIridescenceParams", this.intensity, this.indexOfRefraction, this.minimumThickness, this.maximumThickness);
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._texture && MaterialFlags.IridescenceTextureEnabled) {
                    uniformBuffer.setTexture("iridescenceSampler", this._texture);
                }
                if (this._thicknessTexture && !identicalTextures && !defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE && MaterialFlags.IridescenceTextureEnabled) {
                    uniformBuffer.setTexture("iridescenceThicknessSampler", this._thicknessTexture);
                }
            }
        }
        hasTexture(texture) {
            if (this._texture === texture) {
                return true;
            }
            if (this._thicknessTexture === texture) {
                return true;
            }
            return false;
        }
        getActiveTextures(activeTextures) {
            if (this._texture) {
                activeTextures.push(this._texture);
            }
            if (this._thicknessTexture) {
                activeTextures.push(this._thicknessTexture);
            }
        }
        getAnimatables(animatables) {
            if (this._texture && this._texture.animations && this._texture.animations.length > 0) {
                animatables.push(this._texture);
            }
            if (this._thicknessTexture && this._thicknessTexture.animations && this._thicknessTexture.animations.length > 0) {
                animatables.push(this._thicknessTexture);
            }
        }
        dispose(forceDisposeTextures) {
            var _a, _b;
            if (forceDisposeTextures) {
                (_a = this._texture) === null || _a === void 0 ? void 0 : _a.dispose();
                (_b = this._thicknessTexture) === null || _b === void 0 ? void 0 : _b.dispose();
            }
        }
        getClassName() {
            return "PBRIridescenceConfiguration";
        }
        addFallbacks(defines, fallbacks, currentRank) {
            if (defines.IRIDESCENCE) {
                fallbacks.addFallback(currentRank++, "IRIDESCENCE");
            }
            return currentRank;
        }
        getSamplers(samplers) {
            samplers.push("iridescenceSampler", "iridescenceThicknessSampler");
        }
        getUniforms() {
            return {
                ubo: [
                    { name: "vIridescenceParams", size: 4, type: "vec4" },
                    { name: "vIridescenceInfos", size: 4, type: "vec4" },
                    { name: "iridescenceMatrix", size: 16, type: "mat4" },
                    { name: "iridescenceThicknessMatrix", size: 16, type: "mat4" },
                ],
            };
        }
    }
    /**
     * The default minimum thickness of the thin-film layer given in nanometers (nm).
     * Defaults to 100 nm.
     * @internal
     */
    PBRIridescenceConfiguration._DefaultMinimumThickness = 100;
    /**
     * The default maximum thickness of the thin-film layer given in nanometers (nm).
     * Defaults to 400 nm.
     * @internal
     */
    PBRIridescenceConfiguration._DefaultMaximumThickness = 400;
    /**
     * The default index of refraction of the thin-film layer.
     * Defaults to 1.3
     * @internal
     */
    PBRIridescenceConfiguration._DefaultIndexOfRefraction = 1.3;
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRIridescenceConfiguration.prototype, "isEnabled", void 0);
    __decorate$1([
        serialize()
    ], PBRIridescenceConfiguration.prototype, "intensity", void 0);
    __decorate$1([
        serialize()
    ], PBRIridescenceConfiguration.prototype, "minimumThickness", void 0);
    __decorate$1([
        serialize()
    ], PBRIridescenceConfiguration.prototype, "maximumThickness", void 0);
    __decorate$1([
        serialize()
    ], PBRIridescenceConfiguration.prototype, "indexOfRefraction", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRIridescenceConfiguration.prototype, "texture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRIridescenceConfiguration.prototype, "thicknessTexture", void 0);

    /**
     * @internal
     */
    class MaterialAnisotropicDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.ANISOTROPIC = false;
            this.ANISOTROPIC_TEXTURE = false;
            this.ANISOTROPIC_TEXTUREDIRECTUV = 0;
            this.ANISOTROPIC_LEGACY = false;
            this.MAINUV1 = false;
        }
    }
    /**
     * Plugin that implements the anisotropic component of the PBR material
     */
    class PBRAnisotropicConfiguration extends MaterialPluginBase {
        /**
         * Sets the anisotropy direction as an angle.
         */
        set angle(value) {
            this.direction.x = Math.cos(value);
            this.direction.y = Math.sin(value);
        }
        /**
         * Gets the anisotropy angle value in radians.
         * @returns the anisotropy angle value in radians.
         */
        get angle() {
            return Math.atan2(this.direction.y, this.direction.x);
        }
        /** @internal */
        _markAllSubMeshesAsTexturesDirty() {
            this._enable(this._isEnabled);
            this._internalMarkAllSubMeshesAsTexturesDirty();
        }
        /** @internal */
        _markAllSubMeshesAsMiscDirty() {
            this._enable(this._isEnabled);
            this._internalMarkAllSubMeshesAsMiscDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "PBRAnisotropic", 110, new MaterialAnisotropicDefines(), addToPluginList);
            this._isEnabled = false;
            /**
             * Defines if the anisotropy is enabled in the material.
             */
            this.isEnabled = false;
            /**
             * Defines the anisotropy strength (between 0 and 1) it defaults to 1.
             */
            this.intensity = 1;
            /**
             * Defines if the effect is along the tangents, bitangents or in between.
             * By default, the effect is "stretching" the highlights along the tangents.
             */
            this.direction = new Vector2(1, 0);
            this._texture = null;
            /**
             * Stores the anisotropy values in a texture.
             * rg is direction (like normal from -1 to 1)
             * b is a intensity
             */
            this.texture = null;
            this._legacy = false;
            /**
             * Defines if the anisotropy is in legacy mode for backwards compatibility before 6.4.0.
             */
            this.legacy = false;
            this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
            this._internalMarkAllSubMeshesAsMiscDirty = material._dirtyCallbacks[16];
        }
        isReadyForSubMesh(defines, scene) {
            if (!this._isEnabled) {
                return true;
            }
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && MaterialFlags.AnisotropicTextureEnabled) {
                        if (!this._texture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        prepareDefinesBeforeAttributes(defines, scene, mesh) {
            if (this._isEnabled) {
                defines.ANISOTROPIC = this._isEnabled;
                if (this._isEnabled && !mesh.isVerticesDataPresent(VertexBuffer.TangentKind)) {
                    defines._needUVs = true;
                    defines.MAINUV1 = true;
                }
                if (defines._areTexturesDirty) {
                    if (scene.texturesEnabled) {
                        if (this._texture && MaterialFlags.AnisotropicTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._texture, defines, "ANISOTROPIC_TEXTURE");
                        }
                        else {
                            defines.ANISOTROPIC_TEXTURE = false;
                        }
                    }
                }
                if (defines._areMiscDirty) {
                    defines.ANISOTROPIC_LEGACY = this._legacy;
                }
            }
            else {
                defines.ANISOTROPIC = false;
                defines.ANISOTROPIC_TEXTURE = false;
                defines.ANISOTROPIC_TEXTUREDIRECTUV = 0;
                defines.ANISOTROPIC_LEGACY = false;
            }
        }
        bindForSubMesh(uniformBuffer, scene) {
            if (!this._isEnabled) {
                return;
            }
            const isFrozen = this._material.isFrozen;
            if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
                if (this._texture && MaterialFlags.AnisotropicTextureEnabled) {
                    uniformBuffer.updateFloat2("vAnisotropyInfos", this._texture.coordinatesIndex, this._texture.level);
                    MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "anisotropy");
                }
                // Anisotropy
                uniformBuffer.updateFloat3("vAnisotropy", this.direction.x, this.direction.y, this.intensity);
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._texture && MaterialFlags.AnisotropicTextureEnabled) {
                    uniformBuffer.setTexture("anisotropySampler", this._texture);
                }
            }
        }
        hasTexture(texture) {
            if (this._texture === texture) {
                return true;
            }
            return false;
        }
        getActiveTextures(activeTextures) {
            if (this._texture) {
                activeTextures.push(this._texture);
            }
        }
        getAnimatables(animatables) {
            if (this._texture && this._texture.animations && this._texture.animations.length > 0) {
                animatables.push(this._texture);
            }
        }
        dispose(forceDisposeTextures) {
            if (forceDisposeTextures) {
                if (this._texture) {
                    this._texture.dispose();
                }
            }
        }
        getClassName() {
            return "PBRAnisotropicConfiguration";
        }
        addFallbacks(defines, fallbacks, currentRank) {
            if (defines.ANISOTROPIC) {
                fallbacks.addFallback(currentRank++, "ANISOTROPIC");
            }
            return currentRank;
        }
        getSamplers(samplers) {
            samplers.push("anisotropySampler");
        }
        getUniforms() {
            return {
                ubo: [
                    { name: "vAnisotropy", size: 3, type: "vec3" },
                    { name: "vAnisotropyInfos", size: 2, type: "vec2" },
                    { name: "anisotropyMatrix", size: 16, type: "mat4" },
                ],
            };
        }
        /**
         * Parses a anisotropy Configuration from a serialized object.
         * @param source - Serialized object.
         * @param scene Defines the scene we are parsing for
         * @param rootUrl Defines the rootUrl to load from
         */
        parse(source, scene, rootUrl) {
            super.parse(source, scene, rootUrl);
            // Backward compatibility
            if (source.legacy === undefined) {
                this.legacy = true;
            }
        }
    }
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRAnisotropicConfiguration.prototype, "isEnabled", void 0);
    __decorate$1([
        serialize()
    ], PBRAnisotropicConfiguration.prototype, "intensity", void 0);
    __decorate$1([
        serializeAsVector2()
    ], PBRAnisotropicConfiguration.prototype, "direction", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRAnisotropicConfiguration.prototype, "texture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRAnisotropicConfiguration.prototype, "legacy", void 0);

    /**
     * @internal
     */
    class MaterialSheenDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.SHEEN = false;
            this.SHEEN_TEXTURE = false;
            this.SHEEN_GAMMATEXTURE = false;
            this.SHEEN_TEXTURE_ROUGHNESS = false;
            this.SHEEN_TEXTUREDIRECTUV = 0;
            this.SHEEN_TEXTURE_ROUGHNESSDIRECTUV = 0;
            this.SHEEN_LINKWITHALBEDO = false;
            this.SHEEN_ROUGHNESS = false;
            this.SHEEN_ALBEDOSCALING = false;
            this.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
            this.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL = false;
        }
    }
    /**
     * Plugin that implements the sheen component of the PBR material.
     */
    class PBRSheenConfiguration extends MaterialPluginBase {
        /** @internal */
        _markAllSubMeshesAsTexturesDirty() {
            this._enable(this._isEnabled);
            this._internalMarkAllSubMeshesAsTexturesDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "Sheen", 120, new MaterialSheenDefines(), addToPluginList);
            this._isEnabled = false;
            /**
             * Defines if the material uses sheen.
             */
            this.isEnabled = false;
            this._linkSheenWithAlbedo = false;
            /**
             * Defines if the sheen is linked to the sheen color.
             */
            this.linkSheenWithAlbedo = false;
            /**
             * Defines the sheen intensity.
             */
            this.intensity = 1;
            /**
             * Defines the sheen color.
             */
            this.color = Color3.White();
            this._texture = null;
            /**
             * Stores the sheen tint values in a texture.
             * rgb is tint
             * a is a intensity or roughness if the roughness property has been defined and useRoughnessFromTexture is true (in that case, textureRoughness won't be used)
             * If the roughness property has been defined and useRoughnessFromTexture is false then the alpha channel is not used to modulate roughness
             */
            this.texture = null;
            this._useRoughnessFromMainTexture = true;
            /**
             * Indicates that the alpha channel of the texture property will be used for roughness.
             * Has no effect if the roughness (and texture!) property is not defined
             */
            this.useRoughnessFromMainTexture = true;
            this._roughness = null;
            /**
             * Defines the sheen roughness.
             * It is not taken into account if linkSheenWithAlbedo is true.
             * To stay backward compatible, material roughness is used instead if sheen roughness = null
             */
            this.roughness = null;
            this._textureRoughness = null;
            /**
             * Stores the sheen roughness in a texture.
             * alpha channel is the roughness. This texture won't be used if the texture property is not empty and useRoughnessFromTexture is true
             */
            this.textureRoughness = null;
            this._albedoScaling = false;
            /**
             * If true, the sheen effect is layered above the base BRDF with the albedo-scaling technique.
             * It allows the strength of the sheen effect to not depend on the base color of the material,
             * making it easier to setup and tweak the effect
             */
            this.albedoScaling = false;
            this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        }
        isReadyForSubMesh(defines, scene) {
            if (!this._isEnabled) {
                return true;
            }
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && MaterialFlags.SheenTextureEnabled) {
                        if (!this._texture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (this._textureRoughness && MaterialFlags.SheenTextureEnabled) {
                        if (!this._textureRoughness.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        prepareDefinesBeforeAttributes(defines, scene) {
            var _a;
            if (this._isEnabled) {
                defines.SHEEN = true;
                defines.SHEEN_LINKWITHALBEDO = this._linkSheenWithAlbedo;
                defines.SHEEN_ROUGHNESS = this._roughness !== null;
                defines.SHEEN_ALBEDOSCALING = this._albedoScaling;
                defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE = this._useRoughnessFromMainTexture;
                defines.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL =
                    this._texture !== null && this._texture._texture === ((_a = this._textureRoughness) === null || _a === void 0 ? void 0 : _a._texture) && this._texture.checkTransformsAreIdentical(this._textureRoughness);
                if (defines._areTexturesDirty) {
                    if (scene.texturesEnabled) {
                        if (this._texture && MaterialFlags.SheenTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._texture, defines, "SHEEN_TEXTURE");
                            defines.SHEEN_GAMMATEXTURE = this._texture.gammaSpace;
                        }
                        else {
                            defines.SHEEN_TEXTURE = false;
                        }
                        if (this._textureRoughness && MaterialFlags.SheenTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._textureRoughness, defines, "SHEEN_TEXTURE_ROUGHNESS");
                        }
                        else {
                            defines.SHEEN_TEXTURE_ROUGHNESS = false;
                        }
                    }
                }
            }
            else {
                defines.SHEEN = false;
                defines.SHEEN_TEXTURE = false;
                defines.SHEEN_TEXTURE_ROUGHNESS = false;
                defines.SHEEN_LINKWITHALBEDO = false;
                defines.SHEEN_ROUGHNESS = false;
                defines.SHEEN_ALBEDOSCALING = false;
                defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
                defines.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL = false;
                defines.SHEEN_GAMMATEXTURE = false;
                defines.SHEEN_TEXTUREDIRECTUV = 0;
                defines.SHEEN_TEXTURE_ROUGHNESSDIRECTUV = 0;
            }
        }
        bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (!this._isEnabled) {
                return;
            }
            const defines = subMesh.materialDefines;
            const isFrozen = this._material.isFrozen;
            const identicalTextures = defines.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL;
            if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
                if (identicalTextures && MaterialFlags.SheenTextureEnabled) {
                    uniformBuffer.updateFloat4("vSheenInfos", this._texture.coordinatesIndex, this._texture.level, -1, -1);
                    MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "sheen");
                }
                else if ((this._texture || this._textureRoughness) && MaterialFlags.SheenTextureEnabled) {
                    uniformBuffer.updateFloat4("vSheenInfos", (_b = (_a = this._texture) === null || _a === void 0 ? void 0 : _a.coordinatesIndex) !== null && _b !== void 0 ? _b : 0, (_d = (_c = this._texture) === null || _c === void 0 ? void 0 : _c.level) !== null && _d !== void 0 ? _d : 0, (_f = (_e = this._textureRoughness) === null || _e === void 0 ? void 0 : _e.coordinatesIndex) !== null && _f !== void 0 ? _f : 0, (_h = (_g = this._textureRoughness) === null || _g === void 0 ? void 0 : _g.level) !== null && _h !== void 0 ? _h : 0);
                    if (this._texture) {
                        MaterialHelper.BindTextureMatrix(this._texture, uniformBuffer, "sheen");
                    }
                    if (this._textureRoughness && !identicalTextures && !defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE) {
                        MaterialHelper.BindTextureMatrix(this._textureRoughness, uniformBuffer, "sheenRoughness");
                    }
                }
                // Sheen
                uniformBuffer.updateFloat4("vSheenColor", this.color.r, this.color.g, this.color.b, this.intensity);
                if (this._roughness !== null) {
                    uniformBuffer.updateFloat("vSheenRoughness", this._roughness);
                }
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._texture && MaterialFlags.SheenTextureEnabled) {
                    uniformBuffer.setTexture("sheenSampler", this._texture);
                }
                if (this._textureRoughness && !identicalTextures && !defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE && MaterialFlags.SheenTextureEnabled) {
                    uniformBuffer.setTexture("sheenRoughnessSampler", this._textureRoughness);
                }
            }
        }
        hasTexture(texture) {
            if (this._texture === texture) {
                return true;
            }
            if (this._textureRoughness === texture) {
                return true;
            }
            return false;
        }
        getActiveTextures(activeTextures) {
            if (this._texture) {
                activeTextures.push(this._texture);
            }
            if (this._textureRoughness) {
                activeTextures.push(this._textureRoughness);
            }
        }
        getAnimatables(animatables) {
            if (this._texture && this._texture.animations && this._texture.animations.length > 0) {
                animatables.push(this._texture);
            }
            if (this._textureRoughness && this._textureRoughness.animations && this._textureRoughness.animations.length > 0) {
                animatables.push(this._textureRoughness);
            }
        }
        dispose(forceDisposeTextures) {
            var _a, _b;
            if (forceDisposeTextures) {
                (_a = this._texture) === null || _a === void 0 ? void 0 : _a.dispose();
                (_b = this._textureRoughness) === null || _b === void 0 ? void 0 : _b.dispose();
            }
        }
        getClassName() {
            return "PBRSheenConfiguration";
        }
        addFallbacks(defines, fallbacks, currentRank) {
            if (defines.SHEEN) {
                fallbacks.addFallback(currentRank++, "SHEEN");
            }
            return currentRank;
        }
        getSamplers(samplers) {
            samplers.push("sheenSampler", "sheenRoughnessSampler");
        }
        getUniforms() {
            return {
                ubo: [
                    { name: "vSheenColor", size: 4, type: "vec4" },
                    { name: "vSheenRoughness", size: 1, type: "float" },
                    { name: "vSheenInfos", size: 4, type: "vec4" },
                    { name: "sheenMatrix", size: 16, type: "mat4" },
                    { name: "sheenRoughnessMatrix", size: 16, type: "mat4" },
                ],
            };
        }
    }
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "isEnabled", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "linkSheenWithAlbedo", void 0);
    __decorate$1([
        serialize()
    ], PBRSheenConfiguration.prototype, "intensity", void 0);
    __decorate$1([
        serializeAsColor3()
    ], PBRSheenConfiguration.prototype, "color", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "texture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "useRoughnessFromMainTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "roughness", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "textureRoughness", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSheenConfiguration.prototype, "albedoScaling", void 0);

    /**
     * @internal
     */
    class MaterialSubSurfaceDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            this.SUBSURFACE = false;
            this.SS_REFRACTION = false;
            this.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = false;
            this.SS_TRANSLUCENCY = false;
            this.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = false;
            this.SS_SCATTERING = false;
            this.SS_THICKNESSANDMASK_TEXTURE = false;
            this.SS_THICKNESSANDMASK_TEXTUREDIRECTUV = 0;
            this.SS_HAS_THICKNESS = false;
            this.SS_REFRACTIONINTENSITY_TEXTURE = false;
            this.SS_REFRACTIONINTENSITY_TEXTUREDIRECTUV = 0;
            this.SS_TRANSLUCENCYINTENSITY_TEXTURE = false;
            this.SS_TRANSLUCENCYINTENSITY_TEXTUREDIRECTUV = 0;
            this.SS_REFRACTIONMAP_3D = false;
            this.SS_REFRACTIONMAP_OPPOSITEZ = false;
            this.SS_LODINREFRACTIONALPHA = false;
            this.SS_GAMMAREFRACTION = false;
            this.SS_RGBDREFRACTION = false;
            this.SS_LINEARSPECULARREFRACTION = false;
            this.SS_LINKREFRACTIONTOTRANSPARENCY = false;
            this.SS_ALBEDOFORREFRACTIONTINT = false;
            this.SS_ALBEDOFORTRANSLUCENCYTINT = false;
            this.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = false;
            this.SS_USE_THICKNESS_AS_DEPTH = false;
            this.SS_MASK_FROM_THICKNESS_TEXTURE = false;
            this.SS_USE_GLTF_TEXTURES = false;
        }
    }
    /**
     * Plugin that implements the sub surface component of the PBR material
     */
    class PBRSubSurfaceConfiguration extends MaterialPluginBase {
        /**
         * Diffusion profile for subsurface scattering.
         * Useful for better scattering in the skins or foliages.
         */
        get scatteringDiffusionProfile() {
            if (!this._scene.subSurfaceConfiguration) {
                return null;
            }
            return this._scene.subSurfaceConfiguration.ssDiffusionProfileColors[this._scatteringDiffusionProfileIndex];
        }
        set scatteringDiffusionProfile(c) {
            if (!this._scene.enableSubSurfaceForPrePass()) {
                // Not supported
                return;
            }
            // addDiffusionProfile automatically checks for doubles
            if (c) {
                this._scatteringDiffusionProfileIndex = this._scene.subSurfaceConfiguration.addDiffusionProfile(c);
            }
        }
        /**
         * Index of refraction of the material's volume.
         * https://en.wikipedia.org/wiki/List_of_refractive_indices
         *
         * This ONLY impacts refraction. If not provided or given a non-valid value,
         * the volume will use the same IOR as the surface.
         */
        get volumeIndexOfRefraction() {
            if (this._volumeIndexOfRefraction >= 1.0) {
                return this._volumeIndexOfRefraction;
            }
            return this._indexOfRefraction;
        }
        set volumeIndexOfRefraction(value) {
            if (value >= 1.0) {
                this._volumeIndexOfRefraction = value;
            }
            else {
                this._volumeIndexOfRefraction = -1.0;
            }
        }
        /** @internal */
        _markAllSubMeshesAsTexturesDirty() {
            this._enable(this._isRefractionEnabled || this._isTranslucencyEnabled || this._isScatteringEnabled);
            this._internalMarkAllSubMeshesAsTexturesDirty();
        }
        /** @internal */
        _markScenePrePassDirty() {
            this._internalMarkAllSubMeshesAsTexturesDirty();
            this._internalMarkScenePrePassDirty();
        }
        constructor(material, addToPluginList = true) {
            super(material, "PBRSubSurface", 130, new MaterialSubSurfaceDefines(), addToPluginList);
            this._isRefractionEnabled = false;
            /**
             * Defines if the refraction is enabled in the material.
             */
            this.isRefractionEnabled = false;
            this._isTranslucencyEnabled = false;
            /**
             * Defines if the translucency is enabled in the material.
             */
            this.isTranslucencyEnabled = false;
            this._isScatteringEnabled = false;
            /**
             * Defines if the sub surface scattering is enabled in the material.
             */
            this.isScatteringEnabled = false;
            this._scatteringDiffusionProfileIndex = 0;
            /**
             * Defines the refraction intensity of the material.
             * The refraction when enabled replaces the Diffuse part of the material.
             * The intensity helps transitioning between diffuse and refraction.
             */
            this.refractionIntensity = 1;
            /**
             * Defines the translucency intensity of the material.
             * When translucency has been enabled, this defines how much of the "translucency"
             * is added to the diffuse part of the material.
             */
            this.translucencyIntensity = 1;
            /**
             * When enabled, transparent surfaces will be tinted with the albedo colour (independent of thickness)
             */
            this.useAlbedoToTintRefraction = false;
            /**
             * When enabled, translucent surfaces will be tinted with the albedo colour (independent of thickness)
             */
            this.useAlbedoToTintTranslucency = false;
            this._thicknessTexture = null;
            /**
             * Stores the average thickness of a mesh in a texture (The texture is holding the values linearly).
             * The red (or green if useGltfStyleTextures=true) channel of the texture should contain the thickness remapped between 0 and 1.
             * 0 would mean minimumThickness
             * 1 would mean maximumThickness
             * The other channels might be use as a mask to vary the different effects intensity.
             */
            this.thicknessTexture = null;
            this._refractionTexture = null;
            /**
             * Defines the texture to use for refraction.
             */
            this.refractionTexture = null;
            /** @internal */
            this._indexOfRefraction = 1.5;
            /**
             * Index of refraction of the material base layer.
             * https://en.wikipedia.org/wiki/List_of_refractive_indices
             *
             * This does not only impact refraction but also the Base F0 of Dielectric Materials.
             *
             * From dielectric fresnel rules: F0 = square((iorT - iorI) / (iorT + iorI))
             */
            this.indexOfRefraction = 1.5;
            this._volumeIndexOfRefraction = -1.0;
            this._invertRefractionY = false;
            /**
             * Controls if refraction needs to be inverted on Y. This could be useful for procedural texture.
             */
            this.invertRefractionY = false;
            /** @internal */
            this._linkRefractionWithTransparency = false;
            /**
             * This parameters will make the material used its opacity to control how much it is refracting against not.
             * Materials half opaque for instance using refraction could benefit from this control.
             */
            this.linkRefractionWithTransparency = false;
            /**
             * Defines the minimum thickness stored in the thickness map.
             * If no thickness map is defined, this value will be used to simulate thickness.
             */
            this.minimumThickness = 0;
            /**
             * Defines the maximum thickness stored in the thickness map.
             */
            this.maximumThickness = 1;
            /**
             * Defines that the thickness should be used as a measure of the depth volume.
             */
            this.useThicknessAsDepth = false;
            /**
             * Defines the volume tint of the material.
             * This is used for both translucency and scattering.
             */
            this.tintColor = Color3.White();
            /**
             * Defines the distance at which the tint color should be found in the media.
             * This is used for refraction only.
             */
            this.tintColorAtDistance = 1;
            /**
             * Defines how far each channel transmit through the media.
             * It is defined as a color to simplify it selection.
             */
            this.diffusionDistance = Color3.White();
            this._useMaskFromThicknessTexture = false;
            /**
             * Stores the intensity of the different subsurface effects in the thickness texture.
             * Note that if refractionIntensityTexture and/or translucencyIntensityTexture is provided it takes precedence over thicknessTexture + useMaskFromThicknessTexture
             * * the green (red if useGltfStyleTextures = true) channel is the refraction intensity.
             * * the blue channel is the translucency intensity.
             */
            this.useMaskFromThicknessTexture = false;
            this._refractionIntensityTexture = null;
            /**
             * Stores the intensity of the refraction. If provided, it takes precedence over thicknessTexture + useMaskFromThicknessTexture
             * * the green (red if useGltfStyleTextures = true) channel is the refraction intensity.
             */
            this.refractionIntensityTexture = null;
            this._translucencyIntensityTexture = null;
            /**
             * Stores the intensity of the translucency. If provided, it takes precedence over thicknessTexture + useMaskFromThicknessTexture
             * * the blue channel is the translucency intensity.
             */
            this.translucencyIntensityTexture = null;
            this._useGltfStyleTextures = false;
            /**
             * Use channels layout used by glTF:
             * * thicknessTexture: the green (instead of red) channel is the thickness
             * * thicknessTexture/refractionIntensityTexture: the red (instead of green) channel is the refraction intensity
             * * thicknessTexture/translucencyIntensityTexture: no change, use the blue channel for the translucency intensity
             */
            this.useGltfStyleTextures = false;
            this._scene = material.getScene();
            this.registerForExtraEvents = true;
            this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
            this._internalMarkScenePrePassDirty = material._dirtyCallbacks[32];
        }
        isReadyForSubMesh(defines, scene) {
            if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) {
                return true;
            }
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._thicknessTexture && MaterialFlags.ThicknessTextureEnabled) {
                        if (!this._thicknessTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    const refractionTexture = this._getRefractionTexture(scene);
                    if (refractionTexture && MaterialFlags.RefractionTextureEnabled) {
                        if (!refractionTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        prepareDefinesBeforeAttributes(defines, scene) {
            if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) {
                defines.SUBSURFACE = false;
                defines.SS_TRANSLUCENCY = false;
                defines.SS_SCATTERING = false;
                defines.SS_REFRACTION = false;
                defines.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = false;
                defines.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = false;
                defines.SS_THICKNESSANDMASK_TEXTURE = false;
                defines.SS_THICKNESSANDMASK_TEXTUREDIRECTUV = 0;
                defines.SS_HAS_THICKNESS = false;
                defines.SS_REFRACTIONINTENSITY_TEXTURE = false;
                defines.SS_REFRACTIONINTENSITY_TEXTUREDIRECTUV = 0;
                defines.SS_TRANSLUCENCYINTENSITY_TEXTURE = false;
                defines.SS_TRANSLUCENCYINTENSITY_TEXTUREDIRECTUV = 0;
                defines.SS_REFRACTIONMAP_3D = false;
                defines.SS_REFRACTIONMAP_OPPOSITEZ = false;
                defines.SS_LODINREFRACTIONALPHA = false;
                defines.SS_GAMMAREFRACTION = false;
                defines.SS_RGBDREFRACTION = false;
                defines.SS_LINEARSPECULARREFRACTION = false;
                defines.SS_LINKREFRACTIONTOTRANSPARENCY = false;
                defines.SS_ALBEDOFORREFRACTIONTINT = false;
                defines.SS_ALBEDOFORTRANSLUCENCYTINT = false;
                defines.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = false;
                defines.SS_USE_THICKNESS_AS_DEPTH = false;
                defines.SS_MASK_FROM_THICKNESS_TEXTURE = false;
                defines.SS_USE_GLTF_TEXTURES = false;
                return;
            }
            if (defines._areTexturesDirty) {
                defines.SUBSURFACE = true;
                defines.SS_TRANSLUCENCY = this._isTranslucencyEnabled;
                defines.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = false;
                defines.SS_SCATTERING = this._isScatteringEnabled;
                defines.SS_THICKNESSANDMASK_TEXTURE = false;
                defines.SS_REFRACTIONINTENSITY_TEXTURE = false;
                defines.SS_TRANSLUCENCYINTENSITY_TEXTURE = false;
                defines.SS_HAS_THICKNESS = false;
                defines.SS_MASK_FROM_THICKNESS_TEXTURE = false;
                defines.SS_USE_GLTF_TEXTURES = false;
                defines.SS_REFRACTION = false;
                defines.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = false;
                defines.SS_REFRACTIONMAP_3D = false;
                defines.SS_GAMMAREFRACTION = false;
                defines.SS_RGBDREFRACTION = false;
                defines.SS_LINEARSPECULARREFRACTION = false;
                defines.SS_REFRACTIONMAP_OPPOSITEZ = false;
                defines.SS_LODINREFRACTIONALPHA = false;
                defines.SS_LINKREFRACTIONTOTRANSPARENCY = false;
                defines.SS_ALBEDOFORREFRACTIONTINT = false;
                defines.SS_ALBEDOFORTRANSLUCENCYTINT = false;
                defines.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = false;
                defines.SS_USE_THICKNESS_AS_DEPTH = false;
                const refractionIntensityTextureIsThicknessTexture = !!this._thicknessTexture &&
                    !!this._refractionIntensityTexture &&
                    this._refractionIntensityTexture.checkTransformsAreIdentical(this._thicknessTexture) &&
                    this._refractionIntensityTexture._texture === this._thicknessTexture._texture;
                const translucencyIntensityTextureIsThicknessTexture = !!this._thicknessTexture &&
                    !!this._translucencyIntensityTexture &&
                    this._translucencyIntensityTexture.checkTransformsAreIdentical(this._thicknessTexture) &&
                    this._translucencyIntensityTexture._texture === this._thicknessTexture._texture;
                // if true, it means the refraction/translucency textures are the same than the thickness texture so there's no need to pass them to the shader, only thicknessTexture
                const useOnlyThicknessTexture = (refractionIntensityTextureIsThicknessTexture || !this._refractionIntensityTexture) &&
                    (translucencyIntensityTextureIsThicknessTexture || !this._translucencyIntensityTexture);
                if (defines._areTexturesDirty) {
                    if (scene.texturesEnabled) {
                        if (this._thicknessTexture && MaterialFlags.ThicknessTextureEnabled) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._thicknessTexture, defines, "SS_THICKNESSANDMASK_TEXTURE");
                        }
                        if (this._refractionIntensityTexture && MaterialFlags.RefractionIntensityTextureEnabled && !useOnlyThicknessTexture) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._refractionIntensityTexture, defines, "SS_REFRACTIONINTENSITY_TEXTURE");
                        }
                        if (this._translucencyIntensityTexture && MaterialFlags.TranslucencyIntensityTextureEnabled && !useOnlyThicknessTexture) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._translucencyIntensityTexture, defines, "SS_TRANSLUCENCYINTENSITY_TEXTURE");
                        }
                    }
                }
                defines.SS_HAS_THICKNESS = this.maximumThickness - this.minimumThickness !== 0.0;
                defines.SS_MASK_FROM_THICKNESS_TEXTURE =
                    (this._useMaskFromThicknessTexture || !!this._refractionIntensityTexture || !!this._translucencyIntensityTexture) && useOnlyThicknessTexture;
                defines.SS_USE_GLTF_TEXTURES = this._useGltfStyleTextures;
                defines.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = (this._useMaskFromThicknessTexture || !!this._refractionIntensityTexture) && useOnlyThicknessTexture;
                defines.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = (this._useMaskFromThicknessTexture || !!this._translucencyIntensityTexture) && useOnlyThicknessTexture;
                if (this._isRefractionEnabled) {
                    if (scene.texturesEnabled) {
                        const refractionTexture = this._getRefractionTexture(scene);
                        if (refractionTexture && MaterialFlags.RefractionTextureEnabled) {
                            defines.SS_REFRACTION = true;
                            defines.SS_REFRACTIONMAP_3D = refractionTexture.isCube;
                            defines.SS_GAMMAREFRACTION = refractionTexture.gammaSpace;
                            defines.SS_RGBDREFRACTION = refractionTexture.isRGBD;
                            defines.SS_LINEARSPECULARREFRACTION = refractionTexture.linearSpecularLOD;
                            defines.SS_REFRACTIONMAP_OPPOSITEZ = this._scene.useRightHandedSystem && refractionTexture.isCube ? !refractionTexture.invertZ : refractionTexture.invertZ;
                            defines.SS_LODINREFRACTIONALPHA = refractionTexture.lodLevelInAlpha;
                            defines.SS_LINKREFRACTIONTOTRANSPARENCY = this._linkRefractionWithTransparency;
                            defines.SS_ALBEDOFORREFRACTIONTINT = this.useAlbedoToTintRefraction;
                            defines.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = refractionTexture.isCube && refractionTexture.boundingBoxSize;
                            defines.SS_USE_THICKNESS_AS_DEPTH = this.useThicknessAsDepth;
                        }
                    }
                }
                if (this._isTranslucencyEnabled) {
                    defines.SS_ALBEDOFORTRANSLUCENCYTINT = this.useAlbedoToTintTranslucency;
                }
            }
        }
        /**
         * Binds the material data (this function is called even if mustRebind() returns false)
         * @param uniformBuffer defines the Uniform buffer to fill in.
         * @param scene defines the scene the material belongs to.
         * @param engine defines the engine the material belongs to.
         * @param subMesh the submesh to bind data for
         */
        hardBindForSubMesh(uniformBuffer, scene, engine, subMesh) {
            if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) {
                return;
            }
            subMesh.getRenderingMesh().getWorldMatrix().decompose(TmpVectors.Vector3[0]);
            const thicknessScale = Math.max(Math.abs(TmpVectors.Vector3[0].x), Math.abs(TmpVectors.Vector3[0].y), Math.abs(TmpVectors.Vector3[0].z));
            uniformBuffer.updateFloat2("vThicknessParam", this.minimumThickness * thicknessScale, (this.maximumThickness - this.minimumThickness) * thicknessScale);
        }
        bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
            if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) {
                return;
            }
            const defines = subMesh.materialDefines;
            const isFrozen = this._material.isFrozen;
            const realTimeFiltering = this._material.realTimeFiltering;
            const lodBasedMicrosurface = defines.LODBASEDMICROSFURACE;
            const refractionTexture = this._getRefractionTexture(scene);
            if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
                if (this._thicknessTexture && MaterialFlags.ThicknessTextureEnabled) {
                    uniformBuffer.updateFloat2("vThicknessInfos", this._thicknessTexture.coordinatesIndex, this._thicknessTexture.level);
                    MaterialHelper.BindTextureMatrix(this._thicknessTexture, uniformBuffer, "thickness");
                }
                if (this._refractionIntensityTexture && MaterialFlags.RefractionIntensityTextureEnabled && defines.SS_REFRACTIONINTENSITY_TEXTURE) {
                    uniformBuffer.updateFloat2("vRefractionIntensityInfos", this._refractionIntensityTexture.coordinatesIndex, this._refractionIntensityTexture.level);
                    MaterialHelper.BindTextureMatrix(this._refractionIntensityTexture, uniformBuffer, "refractionIntensity");
                }
                if (this._translucencyIntensityTexture && MaterialFlags.TranslucencyIntensityTextureEnabled && defines.SS_TRANSLUCENCYINTENSITY_TEXTURE) {
                    uniformBuffer.updateFloat2("vTranslucencyIntensityInfos", this._translucencyIntensityTexture.coordinatesIndex, this._translucencyIntensityTexture.level);
                    MaterialHelper.BindTextureMatrix(this._translucencyIntensityTexture, uniformBuffer, "translucencyIntensity");
                }
                if (refractionTexture && MaterialFlags.RefractionTextureEnabled) {
                    uniformBuffer.updateMatrix("refractionMatrix", refractionTexture.getRefractionTextureMatrix());
                    let depth = 1.0;
                    if (!refractionTexture.isCube) {
                        if (refractionTexture.depth) {
                            depth = refractionTexture.depth;
                        }
                    }
                    const width = refractionTexture.getSize().width;
                    const refractionIor = this.volumeIndexOfRefraction;
                    uniformBuffer.updateFloat4("vRefractionInfos", refractionTexture.level, 1 / refractionIor, depth, this._invertRefractionY ? -1 : 1);
                    uniformBuffer.updateFloat4("vRefractionMicrosurfaceInfos", width, refractionTexture.lodGenerationScale, refractionTexture.lodGenerationOffset, 1.0 / this.indexOfRefraction);
                    if (realTimeFiltering) {
                        uniformBuffer.updateFloat2("vRefractionFilteringInfo", width, Scalar.Log2(width));
                    }
                    if (refractionTexture.boundingBoxSize) {
                        const cubeTexture = refractionTexture;
                        uniformBuffer.updateVector3("vRefractionPosition", cubeTexture.boundingBoxPosition);
                        uniformBuffer.updateVector3("vRefractionSize", cubeTexture.boundingBoxSize);
                    }
                }
                if (this._isScatteringEnabled) {
                    uniformBuffer.updateFloat("scatteringDiffusionProfile", this._scatteringDiffusionProfileIndex);
                }
                uniformBuffer.updateColor3("vDiffusionDistance", this.diffusionDistance);
                uniformBuffer.updateFloat4("vTintColor", this.tintColor.r, this.tintColor.g, this.tintColor.b, Math.max(0.00001, this.tintColorAtDistance));
                uniformBuffer.updateFloat3("vSubSurfaceIntensity", this.refractionIntensity, this.translucencyIntensity, 0);
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._thicknessTexture && MaterialFlags.ThicknessTextureEnabled) {
                    uniformBuffer.setTexture("thicknessSampler", this._thicknessTexture);
                }
                if (this._refractionIntensityTexture && MaterialFlags.RefractionIntensityTextureEnabled && defines.SS_REFRACTIONINTENSITY_TEXTURE) {
                    uniformBuffer.setTexture("refractionIntensitySampler", this._refractionIntensityTexture);
                }
                if (this._translucencyIntensityTexture && MaterialFlags.TranslucencyIntensityTextureEnabled && defines.SS_TRANSLUCENCYINTENSITY_TEXTURE) {
                    uniformBuffer.setTexture("translucencyIntensitySampler", this._translucencyIntensityTexture);
                }
                if (refractionTexture && MaterialFlags.RefractionTextureEnabled) {
                    if (lodBasedMicrosurface) {
                        uniformBuffer.setTexture("refractionSampler", refractionTexture);
                    }
                    else {
                        uniformBuffer.setTexture("refractionSampler", refractionTexture._lodTextureMid || refractionTexture);
                        uniformBuffer.setTexture("refractionSamplerLow", refractionTexture._lodTextureLow || refractionTexture);
                        uniformBuffer.setTexture("refractionSamplerHigh", refractionTexture._lodTextureHigh || refractionTexture);
                    }
                }
            }
        }
        /**
         * Returns the texture used for refraction or null if none is used.
         * @param scene defines the scene the material belongs to.
         * @returns - Refraction texture if present.  If no refraction texture and refraction
         * is linked with transparency, returns environment texture.  Otherwise, returns null.
         */
        _getRefractionTexture(scene) {
            if (this._refractionTexture) {
                return this._refractionTexture;
            }
            if (this._isRefractionEnabled) {
                return scene.environmentTexture;
            }
            return null;
        }
        /**
         * Returns true if alpha blending should be disabled.
         */
        get disableAlphaBlending() {
            return this._isRefractionEnabled && this._linkRefractionWithTransparency;
        }
        /**
         * Fills the list of render target textures.
         * @param renderTargets the list of render targets to update
         */
        fillRenderTargetTextures(renderTargets) {
            if (MaterialFlags.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) {
                renderTargets.push(this._refractionTexture);
            }
        }
        hasTexture(texture) {
            if (this._thicknessTexture === texture) {
                return true;
            }
            if (this._refractionTexture === texture) {
                return true;
            }
            return false;
        }
        hasRenderTargetTextures() {
            if (MaterialFlags.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) {
                return true;
            }
            return false;
        }
        getActiveTextures(activeTextures) {
            if (this._thicknessTexture) {
                activeTextures.push(this._thicknessTexture);
            }
            if (this._refractionTexture) {
                activeTextures.push(this._refractionTexture);
            }
        }
        getAnimatables(animatables) {
            if (this._thicknessTexture && this._thicknessTexture.animations && this._thicknessTexture.animations.length > 0) {
                animatables.push(this._thicknessTexture);
            }
            if (this._refractionTexture && this._refractionTexture.animations && this._refractionTexture.animations.length > 0) {
                animatables.push(this._refractionTexture);
            }
        }
        dispose(forceDisposeTextures) {
            if (forceDisposeTextures) {
                if (this._thicknessTexture) {
                    this._thicknessTexture.dispose();
                }
                if (this._refractionTexture) {
                    this._refractionTexture.dispose();
                }
            }
        }
        getClassName() {
            return "PBRSubSurfaceConfiguration";
        }
        addFallbacks(defines, fallbacks, currentRank) {
            if (defines.SS_SCATTERING) {
                fallbacks.addFallback(currentRank++, "SS_SCATTERING");
            }
            if (defines.SS_TRANSLUCENCY) {
                fallbacks.addFallback(currentRank++, "SS_TRANSLUCENCY");
            }
            return currentRank;
        }
        getSamplers(samplers) {
            samplers.push("thicknessSampler", "refractionIntensitySampler", "translucencyIntensitySampler", "refractionSampler", "refractionSamplerLow", "refractionSamplerHigh");
        }
        getUniforms() {
            return {
                ubo: [
                    { name: "vRefractionMicrosurfaceInfos", size: 4, type: "vec4" },
                    { name: "vRefractionFilteringInfo", size: 2, type: "vec2" },
                    { name: "vTranslucencyIntensityInfos", size: 2, type: "vec2" },
                    { name: "vRefractionInfos", size: 4, type: "vec4" },
                    { name: "refractionMatrix", size: 16, type: "mat4" },
                    { name: "vThicknessInfos", size: 2, type: "vec2" },
                    { name: "vRefractionIntensityInfos", size: 2, type: "vec2" },
                    { name: "thicknessMatrix", size: 16, type: "mat4" },
                    { name: "refractionIntensityMatrix", size: 16, type: "mat4" },
                    { name: "translucencyIntensityMatrix", size: 16, type: "mat4" },
                    { name: "vThicknessParam", size: 2, type: "vec2" },
                    { name: "vDiffusionDistance", size: 3, type: "vec3" },
                    { name: "vTintColor", size: 4, type: "vec4" },
                    { name: "vSubSurfaceIntensity", size: 3, type: "vec3" },
                    { name: "vRefractionPosition", size: 3, type: "vec3" },
                    { name: "vRefractionSize", size: 3, type: "vec3" },
                    { name: "scatteringDiffusionProfile", size: 1, type: "float" },
                ],
            };
        }
    }
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "isRefractionEnabled", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "isTranslucencyEnabled", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markScenePrePassDirty")
    ], PBRSubSurfaceConfiguration.prototype, "isScatteringEnabled", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "_scatteringDiffusionProfileIndex", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "refractionIntensity", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "translucencyIntensity", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "useAlbedoToTintRefraction", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "useAlbedoToTintTranslucency", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "thicknessTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "refractionTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "indexOfRefraction", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "_volumeIndexOfRefraction", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "volumeIndexOfRefraction", null);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "invertRefractionY", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "linkRefractionWithTransparency", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "minimumThickness", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "maximumThickness", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "useThicknessAsDepth", void 0);
    __decorate$1([
        serializeAsColor3()
    ], PBRSubSurfaceConfiguration.prototype, "tintColor", void 0);
    __decorate$1([
        serialize()
    ], PBRSubSurfaceConfiguration.prototype, "tintColorAtDistance", void 0);
    __decorate$1([
        serializeAsColor3()
    ], PBRSubSurfaceConfiguration.prototype, "diffusionDistance", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "useMaskFromThicknessTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "refractionIntensityTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "translucencyIntensityTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRSubSurfaceConfiguration.prototype, "useGltfStyleTextures", void 0);

    const onCreatedEffectParameters$1 = { effect: null, subMesh: null };
    /**
     * Manages the defines for the PBR Material.
     * @internal
     */
    class PBRMaterialDefines extends MaterialDefines {
        /**
         * Initializes the PBR Material defines.
         * @param externalProperties The external properties
         */
        constructor(externalProperties) {
            super(externalProperties);
            this.PBR = true;
            this.NUM_SAMPLES = "0";
            this.REALTIME_FILTERING = false;
            this.MAINUV1 = false;
            this.MAINUV2 = false;
            this.MAINUV3 = false;
            this.MAINUV4 = false;
            this.MAINUV5 = false;
            this.MAINUV6 = false;
            this.UV1 = false;
            this.UV2 = false;
            this.UV3 = false;
            this.UV4 = false;
            this.UV5 = false;
            this.UV6 = false;
            this.ALBEDO = false;
            this.GAMMAALBEDO = false;
            this.ALBEDODIRECTUV = 0;
            this.VERTEXCOLOR = false;
            this.BAKED_VERTEX_ANIMATION_TEXTURE = false;
            this.AMBIENT = false;
            this.AMBIENTDIRECTUV = 0;
            this.AMBIENTINGRAYSCALE = false;
            this.OPACITY = false;
            this.VERTEXALPHA = false;
            this.OPACITYDIRECTUV = 0;
            this.OPACITYRGB = false;
            this.ALPHATEST = false;
            this.DEPTHPREPASS = false;
            this.ALPHABLEND = false;
            this.ALPHAFROMALBEDO = false;
            this.ALPHATESTVALUE = "0.5";
            this.SPECULAROVERALPHA = false;
            this.RADIANCEOVERALPHA = false;
            this.ALPHAFRESNEL = false;
            this.LINEARALPHAFRESNEL = false;
            this.PREMULTIPLYALPHA = false;
            this.EMISSIVE = false;
            this.EMISSIVEDIRECTUV = 0;
            this.GAMMAEMISSIVE = false;
            this.REFLECTIVITY = false;
            this.REFLECTIVITY_GAMMA = false;
            this.REFLECTIVITYDIRECTUV = 0;
            this.SPECULARTERM = false;
            this.MICROSURFACEFROMREFLECTIVITYMAP = false;
            this.MICROSURFACEAUTOMATIC = false;
            this.LODBASEDMICROSFURACE = false;
            this.MICROSURFACEMAP = false;
            this.MICROSURFACEMAPDIRECTUV = 0;
            this.METALLICWORKFLOW = false;
            this.ROUGHNESSSTOREINMETALMAPALPHA = false;
            this.ROUGHNESSSTOREINMETALMAPGREEN = false;
            this.METALLNESSSTOREINMETALMAPBLUE = false;
            this.AOSTOREINMETALMAPRED = false;
            this.METALLIC_REFLECTANCE = false;
            this.METALLIC_REFLECTANCE_GAMMA = false;
            this.METALLIC_REFLECTANCEDIRECTUV = 0;
            this.METALLIC_REFLECTANCE_USE_ALPHA_ONLY = false;
            this.REFLECTANCE = false;
            this.REFLECTANCE_GAMMA = false;
            this.REFLECTANCEDIRECTUV = 0;
            this.ENVIRONMENTBRDF = false;
            this.ENVIRONMENTBRDF_RGBD = false;
            this.NORMAL = false;
            this.TANGENT = false;
            this.BUMP = false;
            this.BUMPDIRECTUV = 0;
            this.OBJECTSPACE_NORMALMAP = false;
            this.PARALLAX = false;
            this.PARALLAXOCCLUSION = false;
            this.NORMALXYSCALE = true;
            this.LIGHTMAP = false;
            this.LIGHTMAPDIRECTUV = 0;
            this.USELIGHTMAPASSHADOWMAP = false;
            this.GAMMALIGHTMAP = false;
            this.RGBDLIGHTMAP = false;
            this.REFLECTION = false;
            this.REFLECTIONMAP_3D = false;
            this.REFLECTIONMAP_SPHERICAL = false;
            this.REFLECTIONMAP_PLANAR = false;
            this.REFLECTIONMAP_CUBIC = false;
            this.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
            this.REFLECTIONMAP_PROJECTION = false;
            this.REFLECTIONMAP_SKYBOX = false;
            this.REFLECTIONMAP_EXPLICIT = false;
            this.REFLECTIONMAP_EQUIRECTANGULAR = false;
            this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
            this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
            this.INVERTCUBICMAP = false;
            this.USESPHERICALFROMREFLECTIONMAP = false;
            this.USEIRRADIANCEMAP = false;
            this.USESPHERICALINVERTEX = false;
            this.REFLECTIONMAP_OPPOSITEZ = false;
            this.LODINREFLECTIONALPHA = false;
            this.GAMMAREFLECTION = false;
            this.RGBDREFLECTION = false;
            this.LINEARSPECULARREFLECTION = false;
            this.RADIANCEOCCLUSION = false;
            this.HORIZONOCCLUSION = false;
            this.INSTANCES = false;
            this.THIN_INSTANCES = false;
            this.INSTANCESCOLOR = false;
            this.PREPASS = false;
            this.PREPASS_IRRADIANCE = false;
            this.PREPASS_IRRADIANCE_INDEX = -1;
            this.PREPASS_ALBEDO_SQRT = false;
            this.PREPASS_ALBEDO_SQRT_INDEX = -1;
            this.PREPASS_DEPTH = false;
            this.PREPASS_DEPTH_INDEX = -1;
            this.PREPASS_NORMAL = false;
            this.PREPASS_NORMAL_INDEX = -1;
            this.PREPASS_POSITION = false;
            this.PREPASS_POSITION_INDEX = -1;
            this.PREPASS_VELOCITY = false;
            this.PREPASS_VELOCITY_INDEX = -1;
            this.PREPASS_REFLECTIVITY = false;
            this.PREPASS_REFLECTIVITY_INDEX = -1;
            this.SCENE_MRT_COUNT = 0;
            this.NUM_BONE_INFLUENCERS = 0;
            this.BonesPerMesh = 0;
            this.BONETEXTURE = false;
            this.BONES_VELOCITY_ENABLED = false;
            this.NONUNIFORMSCALING = false;
            this.MORPHTARGETS = false;
            this.MORPHTARGETS_NORMAL = false;
            this.MORPHTARGETS_TANGENT = false;
            this.MORPHTARGETS_UV = false;
            this.NUM_MORPH_INFLUENCERS = 0;
            this.MORPHTARGETS_TEXTURE = false;
            this.IMAGEPROCESSING = false;
            this.VIGNETTE = false;
            this.VIGNETTEBLENDMODEMULTIPLY = false;
            this.VIGNETTEBLENDMODEOPAQUE = false;
            this.TONEMAPPING = false;
            this.TONEMAPPING_ACES = false;
            this.CONTRAST = false;
            this.COLORCURVES = false;
            this.COLORGRADING = false;
            this.COLORGRADING3D = false;
            this.SAMPLER3DGREENDEPTH = false;
            this.SAMPLER3DBGRMAP = false;
            this.DITHER = false;
            this.IMAGEPROCESSINGPOSTPROCESS = false;
            this.SKIPFINALCOLORCLAMP = false;
            this.EXPOSURE = false;
            this.MULTIVIEW = false;
            this.ORDER_INDEPENDENT_TRANSPARENCY = false;
            this.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = false;
            this.USEPHYSICALLIGHTFALLOFF = false;
            this.USEGLTFLIGHTFALLOFF = false;
            this.TWOSIDEDLIGHTING = false;
            this.SHADOWFLOAT = false;
            this.CLIPPLANE = false;
            this.CLIPPLANE2 = false;
            this.CLIPPLANE3 = false;
            this.CLIPPLANE4 = false;
            this.CLIPPLANE5 = false;
            this.CLIPPLANE6 = false;
            this.POINTSIZE = false;
            this.FOG = false;
            this.LOGARITHMICDEPTH = false;
            this.CAMERA_ORTHOGRAPHIC = false;
            this.CAMERA_PERSPECTIVE = false;
            this.FORCENORMALFORWARD = false;
            this.SPECULARAA = false;
            this.UNLIT = false;
            this.DECAL_AFTER_DETAIL = false;
            this.DEBUGMODE = 0;
            this.rebuild();
        }
        /**
         * Resets the PBR Material defines.
         */
        reset() {
            super.reset();
            this.ALPHATESTVALUE = "0.5";
            this.PBR = true;
            this.NORMALXYSCALE = true;
        }
    }
    /**
     * The Physically based material base class of BJS.
     *
     * This offers the main features of a standard PBR material.
     * For more information, please refer to the documentation :
     * https://doc.babylonjs.com/features/featuresDeepDive/materials/using/introToPBR
     */
    class PBRBaseMaterial extends PushMaterial {
        /**
         * Enables realtime filtering on the texture.
         */
        get realTimeFiltering() {
            return this._realTimeFiltering;
        }
        set realTimeFiltering(b) {
            this._realTimeFiltering = b;
            this.markAsDirty(1);
        }
        /**
         * Quality switch for realtime filtering
         */
        get realTimeFilteringQuality() {
            return this._realTimeFilteringQuality;
        }
        set realTimeFilteringQuality(n) {
            this._realTimeFilteringQuality = n;
            this.markAsDirty(1);
        }
        /**
         * Can this material render to several textures at once
         */
        get canRenderToMRT() {
            return true;
        }
        /**
         * Attaches a new image processing configuration to the PBR Material.
         * @param configuration
         */
        _attachImageProcessingConfiguration(configuration) {
            if (configuration === this._imageProcessingConfiguration) {
                return;
            }
            // Detaches observer.
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            // Pick the scene configuration if needed.
            if (!configuration) {
                this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
            }
            else {
                this._imageProcessingConfiguration = configuration;
            }
            // Attaches observer.
            if (this._imageProcessingConfiguration) {
                this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
                    this._markAllSubMeshesAsImageProcessingDirty();
                });
            }
        }
        /**
         * Instantiates a new PBRMaterial instance.
         *
         * @param name The material name
         * @param scene The scene the material will be use in.
         */
        constructor(name, scene) {
            super(name, scene);
            /**
             * Intensity of the direct lights e.g. the four lights available in your scene.
             * This impacts both the direct diffuse and specular highlights.
             * @internal
             */
            this._directIntensity = 1.0;
            /**
             * Intensity of the emissive part of the material.
             * This helps controlling the emissive effect without modifying the emissive color.
             * @internal
             */
            this._emissiveIntensity = 1.0;
            /**
             * Intensity of the environment e.g. how much the environment will light the object
             * either through harmonics for rough material or through the reflection for shiny ones.
             * @internal
             */
            this._environmentIntensity = 1.0;
            /**
             * This is a special control allowing the reduction of the specular highlights coming from the
             * four lights of the scene. Those highlights may not be needed in full environment lighting.
             * @internal
             */
            this._specularIntensity = 1.0;
            /**
             * This stores the direct, emissive, environment, and specular light intensities into a Vector4.
             */
            this._lightingInfos = new Vector4(this._directIntensity, this._emissiveIntensity, this._environmentIntensity, this._specularIntensity);
            /**
             * Debug Control allowing disabling the bump map on this material.
             * @internal
             */
            this._disableBumpMap = false;
            /**
             * AKA Diffuse Texture in standard nomenclature.
             * @internal
             */
            this._albedoTexture = null;
            /**
             * AKA Occlusion Texture in other nomenclature.
             * @internal
             */
            this._ambientTexture = null;
            /**
             * AKA Occlusion Texture Intensity in other nomenclature.
             * @internal
             */
            this._ambientTextureStrength = 1.0;
            /**
             * Defines how much the AO map is occluding the analytical lights (point spot...).
             * 1 means it completely occludes it
             * 0 mean it has no impact
             * @internal
             */
            this._ambientTextureImpactOnAnalyticalLights = PBRBaseMaterial.DEFAULT_AO_ON_ANALYTICAL_LIGHTS;
            /**
             * Stores the alpha values in a texture.
             * @internal
             */
            this._opacityTexture = null;
            /**
             * Stores the reflection values in a texture.
             * @internal
             */
            this._reflectionTexture = null;
            /**
             * Stores the emissive values in a texture.
             * @internal
             */
            this._emissiveTexture = null;
            /**
             * AKA Specular texture in other nomenclature.
             * @internal
             */
            this._reflectivityTexture = null;
            /**
             * Used to switch from specular/glossiness to metallic/roughness workflow.
             * @internal
             */
            this._metallicTexture = null;
            /**
             * Specifies the metallic scalar of the metallic/roughness workflow.
             * Can also be used to scale the metalness values of the metallic texture.
             * @internal
             */
            this._metallic = null;
            /**
             * Specifies the roughness scalar of the metallic/roughness workflow.
             * Can also be used to scale the roughness values of the metallic texture.
             * @internal
             */
            this._roughness = null;
            /**
             * In metallic workflow, specifies an F0 factor to help configuring the material F0.
             * By default the indexOfrefraction is used to compute F0;
             *
             * This is used as a factor against the default reflectance at normal incidence to tweak it.
             *
             * F0 = defaultF0 * metallicF0Factor * metallicReflectanceColor;
             * F90 = metallicReflectanceColor;
             * @internal
             */
            this._metallicF0Factor = 1;
            /**
             * In metallic workflow, specifies an F0 color.
             * By default the F90 is always 1;
             *
             * Please note that this factor is also used as a factor against the default reflectance at normal incidence.
             *
             * F0 = defaultF0_from_IOR * metallicF0Factor * metallicReflectanceColor
             * F90 = metallicF0Factor;
             * @internal
             */
            this._metallicReflectanceColor = Color3.White();
            /**
             * Specifies that only the A channel from _metallicReflectanceTexture should be used.
             * If false, both RGB and A channels will be used
             * @internal
             */
            this._useOnlyMetallicFromMetallicReflectanceTexture = false;
            /**
             * Defines to store metallicReflectanceColor in RGB and metallicF0Factor in A
             * This is multiply against the scalar values defined in the material.
             * @internal
             */
            this._metallicReflectanceTexture = null;
            /**
             * Defines to store reflectanceColor in RGB
             * This is multiplied against the scalar values defined in the material.
             * If both _reflectanceTexture and _metallicReflectanceTexture textures are provided and _useOnlyMetallicFromMetallicReflectanceTexture
             * is false, _metallicReflectanceTexture takes precedence and _reflectanceTexture is not used
             * @internal
             */
            this._reflectanceTexture = null;
            /**
             * Used to enable roughness/glossiness fetch from a separate channel depending on the current mode.
             * Gray Scale represents roughness in metallic mode and glossiness in specular mode.
             * @internal
             */
            this._microSurfaceTexture = null;
            /**
             * Stores surface normal data used to displace a mesh in a texture.
             * @internal
             */
            this._bumpTexture = null;
            /**
             * Stores the pre-calculated light information of a mesh in a texture.
             * @internal
             */
            this._lightmapTexture = null;
            /**
             * The color of a material in ambient lighting.
             * @internal
             */
            this._ambientColor = new Color3(0, 0, 0);
            /**
             * AKA Diffuse Color in other nomenclature.
             * @internal
             */
            this._albedoColor = new Color3(1, 1, 1);
            /**
             * AKA Specular Color in other nomenclature.
             * @internal
             */
            this._reflectivityColor = new Color3(1, 1, 1);
            /**
             * The color applied when light is reflected from a material.
             * @internal
             */
            this._reflectionColor = new Color3(1, 1, 1);
            /**
             * The color applied when light is emitted from a material.
             * @internal
             */
            this._emissiveColor = new Color3(0, 0, 0);
            /**
             * AKA Glossiness in other nomenclature.
             * @internal
             */
            this._microSurface = 0.9;
            /**
             * Specifies that the material will use the light map as a show map.
             * @internal
             */
            this._useLightmapAsShadowmap = false;
            /**
             * This parameters will enable/disable Horizon occlusion to prevent normal maps to look shiny when the normal
             * makes the reflect vector face the model (under horizon).
             * @internal
             */
            this._useHorizonOcclusion = true;
            /**
             * This parameters will enable/disable radiance occlusion by preventing the radiance to lit
             * too much the area relying on ambient texture to define their ambient occlusion.
             * @internal
             */
            this._useRadianceOcclusion = true;
            /**
             * Specifies that the alpha is coming form the albedo channel alpha channel for alpha blending.
             * @internal
             */
            this._useAlphaFromAlbedoTexture = false;
            /**
             * Specifies that the material will keeps the specular highlights over a transparent surface (only the most luminous ones).
             * A car glass is a good example of that. When sun reflects on it you can not see what is behind.
             * @internal
             */
            this._useSpecularOverAlpha = true;
            /**
             * Specifies if the reflectivity texture contains the glossiness information in its alpha channel.
             * @internal
             */
            this._useMicroSurfaceFromReflectivityMapAlpha = false;
            /**
             * Specifies if the metallic texture contains the roughness information in its alpha channel.
             * @internal
             */
            this._useRoughnessFromMetallicTextureAlpha = true;
            /**
             * Specifies if the metallic texture contains the roughness information in its green channel.
             * @internal
             */
            this._useRoughnessFromMetallicTextureGreen = false;
            /**
             * Specifies if the metallic texture contains the metallness information in its blue channel.
             * @internal
             */
            this._useMetallnessFromMetallicTextureBlue = false;
            /**
             * Specifies if the metallic texture contains the ambient occlusion information in its red channel.
             * @internal
             */
            this._useAmbientOcclusionFromMetallicTextureRed = false;
            /**
             * Specifies if the ambient texture contains the ambient occlusion information in its red channel only.
             * @internal
             */
            this._useAmbientInGrayScale = false;
            /**
             * In case the reflectivity map does not contain the microsurface information in its alpha channel,
             * The material will try to infer what glossiness each pixel should be.
             * @internal
             */
            this._useAutoMicroSurfaceFromReflectivityMap = false;
            /**
             * Defines the  falloff type used in this material.
             * It by default is Physical.
             * @internal
             */
            this._lightFalloff = PBRBaseMaterial.LIGHTFALLOFF_PHYSICAL;
            /**
             * Specifies that the material will keeps the reflection highlights over a transparent surface (only the most luminous ones).
             * A car glass is a good example of that. When the street lights reflects on it you can not see what is behind.
             * @internal
             */
            this._useRadianceOverAlpha = true;
            /**
             * Allows using an object space normal map (instead of tangent space).
             * @internal
             */
            this._useObjectSpaceNormalMap = false;
            /**
             * Allows using the bump map in parallax mode.
             * @internal
             */
            this._useParallax = false;
            /**
             * Allows using the bump map in parallax occlusion mode.
             * @internal
             */
            this._useParallaxOcclusion = false;
            /**
             * Controls the scale bias of the parallax mode.
             * @internal
             */
            this._parallaxScaleBias = 0.05;
            /**
             * If sets to true, disables all the lights affecting the material.
             * @internal
             */
            this._disableLighting = false;
            /**
             * Number of Simultaneous lights allowed on the material.
             * @internal
             */
            this._maxSimultaneousLights = 4;
            /**
             * If sets to true, x component of normal map value will be inverted (x = 1.0 - x).
             * @internal
             */
            this._invertNormalMapX = false;
            /**
             * If sets to true, y component of normal map value will be inverted (y = 1.0 - y).
             * @internal
             */
            this._invertNormalMapY = false;
            /**
             * If sets to true and backfaceCulling is false, normals will be flipped on the backside.
             * @internal
             */
            this._twoSidedLighting = false;
            /**
             * Defines the alpha limits in alpha test mode.
             * @internal
             */
            this._alphaCutOff = 0.4;
            /**
             * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
             * @internal
             */
            this._forceAlphaTest = false;
            /**
             * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
             * And/Or occlude the blended part. (alpha is converted to gamma to compute the fresnel)
             * @internal
             */
            this._useAlphaFresnel = false;
            /**
             * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
             * And/Or occlude the blended part. (alpha stays linear to compute the fresnel)
             * @internal
             */
            this._useLinearAlphaFresnel = false;
            /**
             * Specifies the environment BRDF texture used to compute the scale and offset roughness values
             * from cos theta and roughness:
             * http://blog.selfshadow.com/publications/s2013-shading-course/karis/s2013_pbs_epic_notes_v2.pdf
             * @internal
             */
            this._environmentBRDFTexture = null;
            /**
             * Force the shader to compute irradiance in the fragment shader in order to take bump in account.
             * @internal
             */
            this._forceIrradianceInFragment = false;
            this._realTimeFiltering = false;
            this._realTimeFilteringQuality = 8;
            /**
             * Force normal to face away from face.
             * @internal
             */
            this._forceNormalForward = false;
            /**
             * Enables specular anti aliasing in the PBR shader.
             * It will both interacts on the Geometry for analytical and IBL lighting.
             * It also prefilter the roughness map based on the bump values.
             * @internal
             */
            this._enableSpecularAntiAliasing = false;
            /**
             * Keep track of the image processing observer to allow dispose and replace.
             */
            this._imageProcessingObserver = null;
            /**
             * Stores the available render targets.
             */
            this._renderTargets = new SmartArray(16);
            /**
             * Sets the global ambient color for the material used in lighting calculations.
             */
            this._globalAmbientColor = new Color3(0, 0, 0);
            /**
             * Enables the use of logarithmic depth buffers, which is good for wide depth buffers.
             */
            this._useLogarithmicDepth = false;
            /**
             * If set to true, no lighting calculations will be applied.
             */
            this._unlit = false;
            /**
             * If sets to true, the decal map will be applied after the detail map. Else, it is applied before (default: false)
             */
            this._applyDecalMapAfterDetailMap = false;
            this._debugMode = 0;
            /**
             * @internal
             * This is reserved for the inspector.
             * Defines the material debug mode.
             * It helps seeing only some components of the material while troubleshooting.
             */
            this.debugMode = 0;
            /**
             * @internal
             * This is reserved for the inspector.
             * Specify from where on screen the debug mode should start.
             * The value goes from -1 (full screen) to 1 (not visible)
             * It helps with side by side comparison against the final render
             * This defaults to -1
             */
            this.debugLimit = -1;
            /**
             * @internal
             * This is reserved for the inspector.
             * As the default viewing range might not be enough (if the ambient is really small for instance)
             * You can use the factor to better multiply the final value.
             */
            this.debugFactor = 1;
            this._cacheHasRenderTargetTextures = false;
            this.brdf = new PBRBRDFConfiguration(this);
            this.clearCoat = new PBRClearCoatConfiguration(this);
            this.iridescence = new PBRIridescenceConfiguration(this);
            this.anisotropy = new PBRAnisotropicConfiguration(this);
            this.sheen = new PBRSheenConfiguration(this);
            this.subSurface = new PBRSubSurfaceConfiguration(this);
            this.detailMap = new DetailMapConfiguration(this);
            // Setup the default processing configuration to the scene.
            this._attachImageProcessingConfiguration(null);
            this.getRenderTargetTextures = () => {
                this._renderTargets.reset();
                if (MaterialFlags.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                    this._renderTargets.push(this._reflectionTexture);
                }
                this._eventInfo.renderTargets = this._renderTargets;
                this._callbackPluginEventFillRenderTargetTextures(this._eventInfo);
                return this._renderTargets;
            };
            this._environmentBRDFTexture = GetEnvironmentBRDFTexture(this.getScene());
            this.prePassConfiguration = new PrePassConfiguration();
        }
        /**
         * Gets a boolean indicating that current material needs to register RTT
         */
        get hasRenderTargetTextures() {
            if (MaterialFlags.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                return true;
            }
            return this._cacheHasRenderTargetTextures;
        }
        /**
         * Can this material render to prepass
         */
        get isPrePassCapable() {
            return !this.disableDepthWrite;
        }
        /**
         * Gets the name of the material class.
         */
        getClassName() {
            return "PBRBaseMaterial";
        }
        /**
         * Enabled the use of logarithmic depth buffers, which is good for wide depth buffers.
         */
        get useLogarithmicDepth() {
            return this._useLogarithmicDepth;
        }
        /**
         * Enabled the use of logarithmic depth buffers, which is good for wide depth buffers.
         */
        set useLogarithmicDepth(value) {
            this._useLogarithmicDepth = value && this.getScene().getEngine().getCaps().fragmentDepthSupported;
        }
        /**
         * Returns true if alpha blending should be disabled.
         */
        get _disableAlphaBlending() {
            var _a;
            return (this._transparencyMode === PBRBaseMaterial.PBRMATERIAL_OPAQUE ||
                this._transparencyMode === PBRBaseMaterial.PBRMATERIAL_ALPHATEST ||
                ((_a = this.subSurface) === null || _a === void 0 ? void 0 : _a.disableAlphaBlending));
        }
        /**
         * Specifies whether or not this material should be rendered in alpha blend mode.
         */
        needAlphaBlending() {
            if (this._disableAlphaBlending) {
                return false;
            }
            return this.alpha < 1.0 || this._opacityTexture != null || this._shouldUseAlphaFromAlbedoTexture();
        }
        /**
         * Specifies whether or not this material should be rendered in alpha test mode.
         */
        needAlphaTesting() {
            var _a;
            if (this._forceAlphaTest) {
                return true;
            }
            if ((_a = this.subSurface) === null || _a === void 0 ? void 0 : _a.disableAlphaBlending) {
                return false;
            }
            return this._hasAlphaChannel() && (this._transparencyMode == null || this._transparencyMode === PBRBaseMaterial.PBRMATERIAL_ALPHATEST);
        }
        /**
         * Specifies whether or not the alpha value of the albedo texture should be used for alpha blending.
         */
        _shouldUseAlphaFromAlbedoTexture() {
            return this._albedoTexture != null && this._albedoTexture.hasAlpha && this._useAlphaFromAlbedoTexture && this._transparencyMode !== PBRBaseMaterial.PBRMATERIAL_OPAQUE;
        }
        /**
         * Specifies whether or not there is a usable alpha channel for transparency.
         */
        _hasAlphaChannel() {
            return (this._albedoTexture != null && this._albedoTexture.hasAlpha) || this._opacityTexture != null;
        }
        /**
         * Gets the texture used for the alpha test.
         */
        getAlphaTestTexture() {
            return this._albedoTexture;
        }
        /**
         * Specifies that the submesh is ready to be used.
         * @param mesh - BJS mesh.
         * @param subMesh - A submesh of the BJS mesh.  Used to check if it is ready.
         * @param useInstances - Specifies that instances should be used.
         * @returns - boolean indicating that the submesh is ready or not.
         */
        isReadyForSubMesh(mesh, subMesh, useInstances) {
            var _a;
            if (!this._uniformBufferLayoutBuilt) {
                this.buildUniformLayout();
            }
            if (subMesh.effect && this.isFrozen) {
                if (subMesh.effect._wasPreviouslyReady && subMesh.effect._wasPreviouslyUsingInstances === useInstances) {
                    return true;
                }
            }
            if (!subMesh.materialDefines) {
                this._callbackPluginEventGeneric(MaterialPluginEvent.GetDefineNames, this._eventInfo);
                subMesh.materialDefines = new PBRMaterialDefines(this._eventInfo.defineNames);
            }
            const defines = subMesh.materialDefines;
            if (this._isReadyForSubMesh(subMesh)) {
                return true;
            }
            const scene = this.getScene();
            const engine = scene.getEngine();
            if (defines._areTexturesDirty) {
                this._eventInfo.hasRenderTargetTextures = false;
                this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
                this._cacheHasRenderTargetTextures = this._eventInfo.hasRenderTargetTextures;
                if (scene.texturesEnabled) {
                    if (this._albedoTexture && MaterialFlags.DiffuseTextureEnabled) {
                        if (!this._albedoTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (this._ambientTexture && MaterialFlags.AmbientTextureEnabled) {
                        if (!this._ambientTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (this._opacityTexture && MaterialFlags.OpacityTextureEnabled) {
                        if (!this._opacityTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    const reflectionTexture = this._getReflectionTexture();
                    if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                        if (!reflectionTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        if (reflectionTexture.irradianceTexture) {
                            if (!reflectionTexture.irradianceTexture.isReadyOrNotBlocking()) {
                                return false;
                            }
                        }
                        else {
                            // Not ready until spherical are ready too.
                            if (!reflectionTexture.sphericalPolynomial && ((_a = reflectionTexture.getInternalTexture()) === null || _a === void 0 ? void 0 : _a._sphericalPolynomialPromise)) {
                                return false;
                            }
                        }
                    }
                    if (this._lightmapTexture && MaterialFlags.LightmapTextureEnabled) {
                        if (!this._lightmapTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (this._emissiveTexture && MaterialFlags.EmissiveTextureEnabled) {
                        if (!this._emissiveTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                    }
                    if (MaterialFlags.SpecularTextureEnabled) {
                        if (this._metallicTexture) {
                            if (!this._metallicTexture.isReadyOrNotBlocking()) {
                                return false;
                            }
                        }
                        else if (this._reflectivityTexture) {
                            if (!this._reflectivityTexture.isReadyOrNotBlocking()) {
                                return false;
                            }
                        }
                        if (this._metallicReflectanceTexture) {
                            if (!this._metallicReflectanceTexture.isReadyOrNotBlocking()) {
                                return false;
                            }
                        }
                        if (this._reflectanceTexture) {
                            if (!this._reflectanceTexture.isReadyOrNotBlocking()) {
                                return false;
                            }
                        }
                        if (this._microSurfaceTexture) {
                            if (!this._microSurfaceTexture.isReadyOrNotBlocking()) {
                                return false;
                            }
                        }
                    }
                    if (engine.getCaps().standardDerivatives && this._bumpTexture && MaterialFlags.BumpTextureEnabled && !this._disableBumpMap) {
                        // Bump texture cannot be not blocking.
                        if (!this._bumpTexture.isReady()) {
                            return false;
                        }
                    }
                    if (this._environmentBRDFTexture && MaterialFlags.ReflectionTextureEnabled) {
                        // This is blocking.
                        if (!this._environmentBRDFTexture.isReady()) {
                            return false;
                        }
                    }
                }
            }
            this._eventInfo.isReadyForSubMesh = true;
            this._eventInfo.defines = defines;
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
            if (!this._eventInfo.isReadyForSubMesh) {
                return false;
            }
            if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
                if (!this._imageProcessingConfiguration.isReady()) {
                    return false;
                }
            }
            if (!engine.getCaps().standardDerivatives && !mesh.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                mesh.createNormals(true);
                Logger.Warn("PBRMaterial: Normals have been created for the mesh: " + mesh.name);
            }
            const previousEffect = subMesh.effect;
            const lightDisposed = defines._areLightsDisposed;
            let effect = this._prepareEffect(mesh, defines, this.onCompiled, this.onError, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
            let forceWasNotReadyPreviously = false;
            if (effect) {
                if (this._onEffectCreatedObservable) {
                    onCreatedEffectParameters$1.effect = effect;
                    onCreatedEffectParameters$1.subMesh = subMesh;
                    this._onEffectCreatedObservable.notifyObservers(onCreatedEffectParameters$1);
                }
                // Use previous effect while new one is compiling
                if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                    effect = previousEffect;
                    defines.markAsUnprocessed();
                    forceWasNotReadyPreviously = this.isFrozen;
                    if (lightDisposed) {
                        // re register in case it takes more than one frame.
                        defines._areLightsDisposed = true;
                        return false;
                    }
                }
                else {
                    scene.resetCachedMaterial();
                    subMesh.setEffect(effect, defines, this._materialContext);
                }
            }
            if (!subMesh.effect || !subMesh.effect.isReady()) {
                return false;
            }
            defines._renderId = scene.getRenderId();
            subMesh.effect._wasPreviouslyReady = forceWasNotReadyPreviously ? false : true;
            subMesh.effect._wasPreviouslyUsingInstances = !!useInstances;
            this._checkScenePerformancePriority();
            return true;
        }
        /**
         * Specifies if the material uses metallic roughness workflow.
         * @returns boolean specifying if the material uses metallic roughness workflow.
         */
        isMetallicWorkflow() {
            if (this._metallic != null || this._roughness != null || this._metallicTexture) {
                return true;
            }
            return false;
        }
        _prepareEffect(mesh, defines, onCompiled = null, onError = null, useInstances = null, useClipPlane = null, useThinInstances) {
            this._prepareDefines(mesh, defines, useInstances, useClipPlane, useThinInstances);
            if (!defines.isDirty) {
                return null;
            }
            defines.markAsProcessed();
            const scene = this.getScene();
            const engine = scene.getEngine();
            // Fallbacks
            const fallbacks = new EffectFallbacks();
            let fallbackRank = 0;
            if (defines.USESPHERICALINVERTEX) {
                fallbacks.addFallback(fallbackRank++, "USESPHERICALINVERTEX");
            }
            if (defines.FOG) {
                fallbacks.addFallback(fallbackRank, "FOG");
            }
            if (defines.SPECULARAA) {
                fallbacks.addFallback(fallbackRank, "SPECULARAA");
            }
            if (defines.POINTSIZE) {
                fallbacks.addFallback(fallbackRank, "POINTSIZE");
            }
            if (defines.LOGARITHMICDEPTH) {
                fallbacks.addFallback(fallbackRank, "LOGARITHMICDEPTH");
            }
            if (defines.PARALLAX) {
                fallbacks.addFallback(fallbackRank, "PARALLAX");
            }
            if (defines.PARALLAXOCCLUSION) {
                fallbacks.addFallback(fallbackRank++, "PARALLAXOCCLUSION");
            }
            if (defines.ENVIRONMENTBRDF) {
                fallbacks.addFallback(fallbackRank++, "ENVIRONMENTBRDF");
            }
            if (defines.TANGENT) {
                fallbacks.addFallback(fallbackRank++, "TANGENT");
            }
            if (defines.BUMP) {
                fallbacks.addFallback(fallbackRank++, "BUMP");
            }
            fallbackRank = MaterialHelper.HandleFallbacksForShadows(defines, fallbacks, this._maxSimultaneousLights, fallbackRank++);
            if (defines.SPECULARTERM) {
                fallbacks.addFallback(fallbackRank++, "SPECULARTERM");
            }
            if (defines.USESPHERICALFROMREFLECTIONMAP) {
                fallbacks.addFallback(fallbackRank++, "USESPHERICALFROMREFLECTIONMAP");
            }
            if (defines.USEIRRADIANCEMAP) {
                fallbacks.addFallback(fallbackRank++, "USEIRRADIANCEMAP");
            }
            if (defines.LIGHTMAP) {
                fallbacks.addFallback(fallbackRank++, "LIGHTMAP");
            }
            if (defines.NORMAL) {
                fallbacks.addFallback(fallbackRank++, "NORMAL");
            }
            if (defines.AMBIENT) {
                fallbacks.addFallback(fallbackRank++, "AMBIENT");
            }
            if (defines.EMISSIVE) {
                fallbacks.addFallback(fallbackRank++, "EMISSIVE");
            }
            if (defines.VERTEXCOLOR) {
                fallbacks.addFallback(fallbackRank++, "VERTEXCOLOR");
            }
            if (defines.MORPHTARGETS) {
                fallbacks.addFallback(fallbackRank++, "MORPHTARGETS");
            }
            if (defines.MULTIVIEW) {
                fallbacks.addFallback(0, "MULTIVIEW");
            }
            //Attributes
            const attribs = [VertexBuffer.PositionKind];
            if (defines.NORMAL) {
                attribs.push(VertexBuffer.NormalKind);
            }
            if (defines.TANGENT) {
                attribs.push(VertexBuffer.TangentKind);
            }
            for (let i = 1; i <= 6; ++i) {
                if (defines["UV" + i]) {
                    attribs.push(`uv${i === 1 ? "" : i}`);
                }
            }
            if (defines.VERTEXCOLOR) {
                attribs.push(VertexBuffer.ColorKind);
            }
            if (defines.INSTANCESCOLOR) {
                attribs.push(VertexBuffer.ColorInstanceKind);
            }
            MaterialHelper.PrepareAttributesForBones(attribs, mesh, defines, fallbacks);
            MaterialHelper.PrepareAttributesForInstances(attribs, defines);
            MaterialHelper.PrepareAttributesForMorphTargets(attribs, mesh, defines);
            MaterialHelper.PrepareAttributesForBakedVertexAnimation(attribs, mesh, defines);
            let shaderName = "pbr";
            const uniforms = [
                "world",
                "view",
                "viewProjection",
                "vEyePosition",
                "vLightsType",
                "vAmbientColor",
                "vAlbedoColor",
                "vReflectivityColor",
                "vMetallicReflectanceFactors",
                "vEmissiveColor",
                "visibility",
                "vReflectionColor",
                "vFogInfos",
                "vFogColor",
                "pointSize",
                "vAlbedoInfos",
                "vAmbientInfos",
                "vOpacityInfos",
                "vReflectionInfos",
                "vReflectionPosition",
                "vReflectionSize",
                "vEmissiveInfos",
                "vReflectivityInfos",
                "vReflectionFilteringInfo",
                "vMetallicReflectanceInfos",
                "vReflectanceInfos",
                "vMicroSurfaceSamplerInfos",
                "vBumpInfos",
                "vLightmapInfos",
                "mBones",
                "albedoMatrix",
                "ambientMatrix",
                "opacityMatrix",
                "reflectionMatrix",
                "emissiveMatrix",
                "reflectivityMatrix",
                "normalMatrix",
                "microSurfaceSamplerMatrix",
                "bumpMatrix",
                "lightmapMatrix",
                "metallicReflectanceMatrix",
                "reflectanceMatrix",
                "vLightingIntensity",
                "logarithmicDepthConstant",
                "vSphericalX",
                "vSphericalY",
                "vSphericalZ",
                "vSphericalXX_ZZ",
                "vSphericalYY_ZZ",
                "vSphericalZZ",
                "vSphericalXY",
                "vSphericalYZ",
                "vSphericalZX",
                "vSphericalL00",
                "vSphericalL1_1",
                "vSphericalL10",
                "vSphericalL11",
                "vSphericalL2_2",
                "vSphericalL2_1",
                "vSphericalL20",
                "vSphericalL21",
                "vSphericalL22",
                "vReflectionMicrosurfaceInfos",
                "vTangentSpaceParams",
                "boneTextureWidth",
                "vDebugMode",
                "morphTargetTextureInfo",
                "morphTargetTextureIndices",
            ];
            const samplers = [
                "albedoSampler",
                "reflectivitySampler",
                "ambientSampler",
                "emissiveSampler",
                "bumpSampler",
                "lightmapSampler",
                "opacitySampler",
                "reflectionSampler",
                "reflectionSamplerLow",
                "reflectionSamplerHigh",
                "irradianceSampler",
                "microSurfaceSampler",
                "environmentBrdfSampler",
                "boneSampler",
                "metallicReflectanceSampler",
                "reflectanceSampler",
                "morphTargets",
                "oitDepthSampler",
                "oitFrontColorSampler",
            ];
            const uniformBuffers = ["Material", "Scene", "Mesh"];
            const indexParameters = { maxSimultaneousLights: this._maxSimultaneousLights, maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS };
            this._eventInfo.fallbacks = fallbacks;
            this._eventInfo.fallbackRank = fallbackRank;
            this._eventInfo.defines = defines;
            this._eventInfo.uniforms = uniforms;
            this._eventInfo.attributes = attribs;
            this._eventInfo.samplers = samplers;
            this._eventInfo.uniformBuffersNames = uniformBuffers;
            this._eventInfo.customCode = undefined;
            this._eventInfo.mesh = mesh;
            this._eventInfo.indexParameters = indexParameters;
            this._callbackPluginEventGeneric(MaterialPluginEvent.PrepareEffect, this._eventInfo);
            PrePassConfiguration.AddUniforms(uniforms);
            PrePassConfiguration.AddSamplers(samplers);
            addClipPlaneUniforms(uniforms);
            if (ImageProcessingConfiguration) {
                ImageProcessingConfiguration.PrepareUniforms(uniforms, defines);
                ImageProcessingConfiguration.PrepareSamplers(samplers, defines);
            }
            MaterialHelper.PrepareUniformsAndSamplersList({
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: defines,
                maxSimultaneousLights: this._maxSimultaneousLights,
            });
            const csnrOptions = {};
            if (this.customShaderNameResolve) {
                shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs, csnrOptions);
            }
            const join = defines.toString();
            const effect = engine.createEffect(shaderName, {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                fallbacks: fallbacks,
                onCompiled: onCompiled,
                onError: onError,
                indexParameters,
                processFinalCode: csnrOptions.processFinalCode,
                processCodeAfterIncludes: this._eventInfo.customCode,
                multiTarget: defines.PREPASS,
            }, engine);
            this._eventInfo.customCode = undefined;
            return effect;
        }
        _prepareDefines(mesh, defines, useInstances = null, useClipPlane = null, useThinInstances = false) {
            var _a;
            const scene = this.getScene();
            const engine = scene.getEngine();
            // Lights
            MaterialHelper.PrepareDefinesForLights(scene, mesh, defines, true, this._maxSimultaneousLights, this._disableLighting);
            defines._needNormals = true;
            // Multiview
            MaterialHelper.PrepareDefinesForMultiview(scene, defines);
            // PrePass
            const oit = this.needAlphaBlendingForMesh(mesh) && this.getScene().useOrderIndependentTransparency;
            MaterialHelper.PrepareDefinesForPrePass(scene, defines, this.canRenderToMRT && !oit);
            // Order independant transparency
            MaterialHelper.PrepareDefinesForOIT(scene, defines, oit);
            // Textures
            defines.METALLICWORKFLOW = this.isMetallicWorkflow();
            if (defines._areTexturesDirty) {
                defines._needUVs = false;
                for (let i = 1; i <= 6; ++i) {
                    defines["MAINUV" + i] = false;
                }
                if (scene.texturesEnabled) {
                    defines.ALBEDODIRECTUV = 0;
                    defines.AMBIENTDIRECTUV = 0;
                    defines.OPACITYDIRECTUV = 0;
                    defines.EMISSIVEDIRECTUV = 0;
                    defines.REFLECTIVITYDIRECTUV = 0;
                    defines.MICROSURFACEMAPDIRECTUV = 0;
                    defines.METALLIC_REFLECTANCEDIRECTUV = 0;
                    defines.REFLECTANCEDIRECTUV = 0;
                    defines.BUMPDIRECTUV = 0;
                    defines.LIGHTMAPDIRECTUV = 0;
                    if (engine.getCaps().textureLOD) {
                        defines.LODBASEDMICROSFURACE = true;
                    }
                    if (this._albedoTexture && MaterialFlags.DiffuseTextureEnabled) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._albedoTexture, defines, "ALBEDO");
                        defines.GAMMAALBEDO = this._albedoTexture.gammaSpace;
                    }
                    else {
                        defines.ALBEDO = false;
                    }
                    if (this._ambientTexture && MaterialFlags.AmbientTextureEnabled) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._ambientTexture, defines, "AMBIENT");
                        defines.AMBIENTINGRAYSCALE = this._useAmbientInGrayScale;
                    }
                    else {
                        defines.AMBIENT = false;
                    }
                    if (this._opacityTexture && MaterialFlags.OpacityTextureEnabled) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._opacityTexture, defines, "OPACITY");
                        defines.OPACITYRGB = this._opacityTexture.getAlphaFromRGB;
                    }
                    else {
                        defines.OPACITY = false;
                    }
                    const reflectionTexture = this._getReflectionTexture();
                    if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                        defines.REFLECTION = true;
                        defines.GAMMAREFLECTION = reflectionTexture.gammaSpace;
                        defines.RGBDREFLECTION = reflectionTexture.isRGBD;
                        defines.LODINREFLECTIONALPHA = reflectionTexture.lodLevelInAlpha;
                        defines.LINEARSPECULARREFLECTION = reflectionTexture.linearSpecularLOD;
                        if (this.realTimeFiltering && this.realTimeFilteringQuality > 0) {
                            defines.NUM_SAMPLES = "" + this.realTimeFilteringQuality;
                            if (engine._features.needTypeSuffixInShaderConstants) {
                                defines.NUM_SAMPLES = defines.NUM_SAMPLES + "u";
                            }
                            defines.REALTIME_FILTERING = true;
                        }
                        else {
                            defines.REALTIME_FILTERING = false;
                        }
                        defines.INVERTCUBICMAP = reflectionTexture.coordinatesMode === Texture.INVCUBIC_MODE;
                        defines.REFLECTIONMAP_3D = reflectionTexture.isCube;
                        defines.REFLECTIONMAP_OPPOSITEZ = defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !reflectionTexture.invertZ : reflectionTexture.invertZ;
                        defines.REFLECTIONMAP_CUBIC = false;
                        defines.REFLECTIONMAP_EXPLICIT = false;
                        defines.REFLECTIONMAP_PLANAR = false;
                        defines.REFLECTIONMAP_PROJECTION = false;
                        defines.REFLECTIONMAP_SKYBOX = false;
                        defines.REFLECTIONMAP_SPHERICAL = false;
                        defines.REFLECTIONMAP_EQUIRECTANGULAR = false;
                        defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
                        defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
                        switch (reflectionTexture.coordinatesMode) {
                            case Texture.EXPLICIT_MODE:
                                defines.REFLECTIONMAP_EXPLICIT = true;
                                break;
                            case Texture.PLANAR_MODE:
                                defines.REFLECTIONMAP_PLANAR = true;
                                break;
                            case Texture.PROJECTION_MODE:
                                defines.REFLECTIONMAP_PROJECTION = true;
                                break;
                            case Texture.SKYBOX_MODE:
                                defines.REFLECTIONMAP_SKYBOX = true;
                                break;
                            case Texture.SPHERICAL_MODE:
                                defines.REFLECTIONMAP_SPHERICAL = true;
                                break;
                            case Texture.EQUIRECTANGULAR_MODE:
                                defines.REFLECTIONMAP_EQUIRECTANGULAR = true;
                                break;
                            case Texture.FIXED_EQUIRECTANGULAR_MODE:
                                defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = true;
                                break;
                            case Texture.FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                                defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = true;
                                break;
                            case Texture.CUBIC_MODE:
                            case Texture.INVCUBIC_MODE:
                            default:
                                defines.REFLECTIONMAP_CUBIC = true;
                                defines.USE_LOCAL_REFLECTIONMAP_CUBIC = reflectionTexture.boundingBoxSize ? true : false;
                                break;
                        }
                        if (reflectionTexture.coordinatesMode !== Texture.SKYBOX_MODE) {
                            if (reflectionTexture.irradianceTexture) {
                                defines.USEIRRADIANCEMAP = true;
                                defines.USESPHERICALFROMREFLECTIONMAP = false;
                            }
                            // Assume using spherical polynomial if the reflection texture is a cube map
                            else if (reflectionTexture.isCube) {
                                defines.USESPHERICALFROMREFLECTIONMAP = true;
                                defines.USEIRRADIANCEMAP = false;
                                if (this._forceIrradianceInFragment || this.realTimeFiltering || engine.getCaps().maxVaryingVectors <= 8) {
                                    defines.USESPHERICALINVERTEX = false;
                                }
                                else {
                                    defines.USESPHERICALINVERTEX = true;
                                }
                            }
                        }
                    }
                    else {
                        defines.REFLECTION = false;
                        defines.REFLECTIONMAP_3D = false;
                        defines.REFLECTIONMAP_SPHERICAL = false;
                        defines.REFLECTIONMAP_PLANAR = false;
                        defines.REFLECTIONMAP_CUBIC = false;
                        defines.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
                        defines.REFLECTIONMAP_PROJECTION = false;
                        defines.REFLECTIONMAP_SKYBOX = false;
                        defines.REFLECTIONMAP_EXPLICIT = false;
                        defines.REFLECTIONMAP_EQUIRECTANGULAR = false;
                        defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
                        defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
                        defines.INVERTCUBICMAP = false;
                        defines.USESPHERICALFROMREFLECTIONMAP = false;
                        defines.USEIRRADIANCEMAP = false;
                        defines.USESPHERICALINVERTEX = false;
                        defines.REFLECTIONMAP_OPPOSITEZ = false;
                        defines.LODINREFLECTIONALPHA = false;
                        defines.GAMMAREFLECTION = false;
                        defines.RGBDREFLECTION = false;
                        defines.LINEARSPECULARREFLECTION = false;
                    }
                    if (this._lightmapTexture && MaterialFlags.LightmapTextureEnabled) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._lightmapTexture, defines, "LIGHTMAP");
                        defines.USELIGHTMAPASSHADOWMAP = this._useLightmapAsShadowmap;
                        defines.GAMMALIGHTMAP = this._lightmapTexture.gammaSpace;
                        defines.RGBDLIGHTMAP = this._lightmapTexture.isRGBD;
                    }
                    else {
                        defines.LIGHTMAP = false;
                    }
                    if (this._emissiveTexture && MaterialFlags.EmissiveTextureEnabled) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._emissiveTexture, defines, "EMISSIVE");
                        defines.GAMMAEMISSIVE = this._emissiveTexture.gammaSpace;
                    }
                    else {
                        defines.EMISSIVE = false;
                    }
                    if (MaterialFlags.SpecularTextureEnabled) {
                        if (this._metallicTexture) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._metallicTexture, defines, "REFLECTIVITY");
                            defines.ROUGHNESSSTOREINMETALMAPALPHA = this._useRoughnessFromMetallicTextureAlpha;
                            defines.ROUGHNESSSTOREINMETALMAPGREEN = !this._useRoughnessFromMetallicTextureAlpha && this._useRoughnessFromMetallicTextureGreen;
                            defines.METALLNESSSTOREINMETALMAPBLUE = this._useMetallnessFromMetallicTextureBlue;
                            defines.AOSTOREINMETALMAPRED = this._useAmbientOcclusionFromMetallicTextureRed;
                            defines.REFLECTIVITY_GAMMA = false;
                        }
                        else if (this._reflectivityTexture) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._reflectivityTexture, defines, "REFLECTIVITY");
                            defines.MICROSURFACEFROMREFLECTIVITYMAP = this._useMicroSurfaceFromReflectivityMapAlpha;
                            defines.MICROSURFACEAUTOMATIC = this._useAutoMicroSurfaceFromReflectivityMap;
                            defines.REFLECTIVITY_GAMMA = this._reflectivityTexture.gammaSpace;
                        }
                        else {
                            defines.REFLECTIVITY = false;
                        }
                        if (this._metallicReflectanceTexture || this._reflectanceTexture) {
                            const identicalTextures = this._metallicReflectanceTexture !== null &&
                                this._metallicReflectanceTexture._texture === ((_a = this._reflectanceTexture) === null || _a === void 0 ? void 0 : _a._texture) &&
                                this._metallicReflectanceTexture.checkTransformsAreIdentical(this._reflectanceTexture);
                            defines.METALLIC_REFLECTANCE_USE_ALPHA_ONLY = this._useOnlyMetallicFromMetallicReflectanceTexture && !identicalTextures;
                            if (this._metallicReflectanceTexture) {
                                MaterialHelper.PrepareDefinesForMergedUV(this._metallicReflectanceTexture, defines, "METALLIC_REFLECTANCE");
                                defines.METALLIC_REFLECTANCE_GAMMA = this._metallicReflectanceTexture.gammaSpace;
                            }
                            else {
                                defines.METALLIC_REFLECTANCE = false;
                            }
                            if (this._reflectanceTexture &&
                                !identicalTextures &&
                                (!this._metallicReflectanceTexture || (this._metallicReflectanceTexture && this._useOnlyMetallicFromMetallicReflectanceTexture))) {
                                MaterialHelper.PrepareDefinesForMergedUV(this._reflectanceTexture, defines, "REFLECTANCE");
                                defines.REFLECTANCE_GAMMA = this._reflectanceTexture.gammaSpace;
                            }
                            else {
                                defines.REFLECTANCE = false;
                            }
                        }
                        else {
                            defines.METALLIC_REFLECTANCE = false;
                            defines.REFLECTANCE = false;
                        }
                        if (this._microSurfaceTexture) {
                            MaterialHelper.PrepareDefinesForMergedUV(this._microSurfaceTexture, defines, "MICROSURFACEMAP");
                        }
                        else {
                            defines.MICROSURFACEMAP = false;
                        }
                    }
                    else {
                        defines.REFLECTIVITY = false;
                        defines.MICROSURFACEMAP = false;
                    }
                    if (engine.getCaps().standardDerivatives && this._bumpTexture && MaterialFlags.BumpTextureEnabled && !this._disableBumpMap) {
                        MaterialHelper.PrepareDefinesForMergedUV(this._bumpTexture, defines, "BUMP");
                        if (this._useParallax && this._albedoTexture && MaterialFlags.DiffuseTextureEnabled) {
                            defines.PARALLAX = true;
                            defines.PARALLAXOCCLUSION = !!this._useParallaxOcclusion;
                        }
                        else {
                            defines.PARALLAX = false;
                        }
                        defines.OBJECTSPACE_NORMALMAP = this._useObjectSpaceNormalMap;
                    }
                    else {
                        defines.BUMP = false;
                        defines.PARALLAX = false;
                        defines.PARALLAXOCCLUSION = false;
                        defines.OBJECTSPACE_NORMALMAP = false;
                    }
                    if (this._environmentBRDFTexture && MaterialFlags.ReflectionTextureEnabled) {
                        defines.ENVIRONMENTBRDF = true;
                        defines.ENVIRONMENTBRDF_RGBD = this._environmentBRDFTexture.isRGBD;
                    }
                    else {
                        defines.ENVIRONMENTBRDF = false;
                        defines.ENVIRONMENTBRDF_RGBD = false;
                    }
                    if (this._shouldUseAlphaFromAlbedoTexture()) {
                        defines.ALPHAFROMALBEDO = true;
                    }
                    else {
                        defines.ALPHAFROMALBEDO = false;
                    }
                }
                defines.SPECULAROVERALPHA = this._useSpecularOverAlpha;
                if (this._lightFalloff === PBRBaseMaterial.LIGHTFALLOFF_STANDARD) {
                    defines.USEPHYSICALLIGHTFALLOFF = false;
                    defines.USEGLTFLIGHTFALLOFF = false;
                }
                else if (this._lightFalloff === PBRBaseMaterial.LIGHTFALLOFF_GLTF) {
                    defines.USEPHYSICALLIGHTFALLOFF = false;
                    defines.USEGLTFLIGHTFALLOFF = true;
                }
                else {
                    defines.USEPHYSICALLIGHTFALLOFF = true;
                    defines.USEGLTFLIGHTFALLOFF = false;
                }
                defines.RADIANCEOVERALPHA = this._useRadianceOverAlpha;
                if (!this.backFaceCulling && this._twoSidedLighting) {
                    defines.TWOSIDEDLIGHTING = true;
                }
                else {
                    defines.TWOSIDEDLIGHTING = false;
                }
                defines.SPECULARAA = engine.getCaps().standardDerivatives && this._enableSpecularAntiAliasing;
            }
            if (defines._areTexturesDirty || defines._areMiscDirty) {
                defines.ALPHATESTVALUE = `${this._alphaCutOff}${this._alphaCutOff % 1 === 0 ? "." : ""}`;
                defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
                defines.ALPHABLEND = this.needAlphaBlendingForMesh(mesh);
                defines.ALPHAFRESNEL = this._useAlphaFresnel || this._useLinearAlphaFresnel;
                defines.LINEARALPHAFRESNEL = this._useLinearAlphaFresnel;
            }
            if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
                this._imageProcessingConfiguration.prepareDefines(defines);
            }
            defines.FORCENORMALFORWARD = this._forceNormalForward;
            defines.RADIANCEOCCLUSION = this._useRadianceOcclusion;
            defines.HORIZONOCCLUSION = this._useHorizonOcclusion;
            // Misc.
            if (defines._areMiscDirty) {
                MaterialHelper.PrepareDefinesForMisc(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh) || this._forceAlphaTest, defines, this._applyDecalMapAfterDetailMap);
                defines.UNLIT = this._unlit || ((this.pointsCloud || this.wireframe) && !mesh.isVerticesDataPresent(VertexBuffer.NormalKind));
                defines.DEBUGMODE = this._debugMode;
            }
            // Values that need to be evaluated on every frame
            MaterialHelper.PrepareDefinesForFrameBoundValues(scene, engine, this, defines, useInstances ? true : false, useClipPlane, useThinInstances);
            // External config
            this._eventInfo.defines = defines;
            this._eventInfo.mesh = mesh;
            this._callbackPluginEventPrepareDefinesBeforeAttributes(this._eventInfo);
            // Attribs
            MaterialHelper.PrepareDefinesForAttributes(mesh, defines, true, true, true, this._transparencyMode !== PBRBaseMaterial.PBRMATERIAL_OPAQUE);
            // External config
            this._callbackPluginEventPrepareDefines(this._eventInfo);
        }
        /**
         * Force shader compilation
         * @param mesh
         * @param onCompiled
         * @param options
         */
        forceCompilation(mesh, onCompiled, options) {
            const localOptions = Object.assign({ clipPlane: false, useInstances: false }, options);
            if (!this._uniformBufferLayoutBuilt) {
                this.buildUniformLayout();
            }
            this._callbackPluginEventGeneric(MaterialPluginEvent.GetDefineNames, this._eventInfo);
            const defines = new PBRMaterialDefines(this._eventInfo.defineNames);
            const effect = this._prepareEffect(mesh, defines, undefined, undefined, localOptions.useInstances, localOptions.clipPlane, mesh.hasThinInstances);
            if (this._onEffectCreatedObservable) {
                onCreatedEffectParameters$1.effect = effect;
                onCreatedEffectParameters$1.subMesh = null;
                this._onEffectCreatedObservable.notifyObservers(onCreatedEffectParameters$1);
            }
            if (effect.isReady()) {
                if (onCompiled) {
                    onCompiled(this);
                }
            }
            else {
                effect.onCompileObservable.add(() => {
                    if (onCompiled) {
                        onCompiled(this);
                    }
                });
            }
        }
        /**
         * Initializes the uniform buffer layout for the shader.
         */
        buildUniformLayout() {
            // Order is important !
            const ubo = this._uniformBuffer;
            ubo.addUniform("vAlbedoInfos", 2);
            ubo.addUniform("vAmbientInfos", 4);
            ubo.addUniform("vOpacityInfos", 2);
            ubo.addUniform("vEmissiveInfos", 2);
            ubo.addUniform("vLightmapInfos", 2);
            ubo.addUniform("vReflectivityInfos", 3);
            ubo.addUniform("vMicroSurfaceSamplerInfos", 2);
            ubo.addUniform("vReflectionInfos", 2);
            ubo.addUniform("vReflectionFilteringInfo", 2);
            ubo.addUniform("vReflectionPosition", 3);
            ubo.addUniform("vReflectionSize", 3);
            ubo.addUniform("vBumpInfos", 3);
            ubo.addUniform("albedoMatrix", 16);
            ubo.addUniform("ambientMatrix", 16);
            ubo.addUniform("opacityMatrix", 16);
            ubo.addUniform("emissiveMatrix", 16);
            ubo.addUniform("lightmapMatrix", 16);
            ubo.addUniform("reflectivityMatrix", 16);
            ubo.addUniform("microSurfaceSamplerMatrix", 16);
            ubo.addUniform("bumpMatrix", 16);
            ubo.addUniform("vTangentSpaceParams", 2);
            ubo.addUniform("reflectionMatrix", 16);
            ubo.addUniform("vReflectionColor", 3);
            ubo.addUniform("vAlbedoColor", 4);
            ubo.addUniform("vLightingIntensity", 4);
            ubo.addUniform("vReflectionMicrosurfaceInfos", 3);
            ubo.addUniform("pointSize", 1);
            ubo.addUniform("vReflectivityColor", 4);
            ubo.addUniform("vEmissiveColor", 3);
            ubo.addUniform("vAmbientColor", 3);
            ubo.addUniform("vDebugMode", 2);
            ubo.addUniform("vMetallicReflectanceFactors", 4);
            ubo.addUniform("vMetallicReflectanceInfos", 2);
            ubo.addUniform("metallicReflectanceMatrix", 16);
            ubo.addUniform("vReflectanceInfos", 2);
            ubo.addUniform("reflectanceMatrix", 16);
            ubo.addUniform("vSphericalL00", 3);
            ubo.addUniform("vSphericalL1_1", 3);
            ubo.addUniform("vSphericalL10", 3);
            ubo.addUniform("vSphericalL11", 3);
            ubo.addUniform("vSphericalL2_2", 3);
            ubo.addUniform("vSphericalL2_1", 3);
            ubo.addUniform("vSphericalL20", 3);
            ubo.addUniform("vSphericalL21", 3);
            ubo.addUniform("vSphericalL22", 3);
            ubo.addUniform("vSphericalX", 3);
            ubo.addUniform("vSphericalY", 3);
            ubo.addUniform("vSphericalZ", 3);
            ubo.addUniform("vSphericalXX_ZZ", 3);
            ubo.addUniform("vSphericalYY_ZZ", 3);
            ubo.addUniform("vSphericalZZ", 3);
            ubo.addUniform("vSphericalXY", 3);
            ubo.addUniform("vSphericalYZ", 3);
            ubo.addUniform("vSphericalZX", 3);
            super.buildUniformLayout();
        }
        /**
         * Binds the submesh data.
         * @param world - The world matrix.
         * @param mesh - The BJS mesh.
         * @param subMesh - A submesh of the BJS mesh.
         */
        bindForSubMesh(world, mesh, subMesh) {
            var _a, _b, _c, _d;
            const scene = this.getScene();
            const defines = subMesh.materialDefines;
            if (!defines) {
                return;
            }
            const effect = subMesh.effect;
            if (!effect) {
                return;
            }
            this._activeEffect = effect;
            // Matrices Mesh.
            mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
            mesh.transferToEffect(world);
            const engine = scene.getEngine();
            // Binding unconditionally
            this._uniformBuffer.bindToEffect(effect, "Material");
            this.prePassConfiguration.bindForSubMesh(this._activeEffect, scene, mesh, world, this.isFrozen);
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventHardBindForSubMesh(this._eventInfo);
            // Normal Matrix
            if (defines.OBJECTSPACE_NORMALMAP) {
                world.toNormalMatrix(this._normalMatrix);
                this.bindOnlyNormalMatrix(this._normalMatrix);
            }
            const mustRebind = effect._forceRebindOnNextCall || this._mustRebind(scene, effect, mesh.visibility);
            // Bones
            MaterialHelper.BindBonesParameters(mesh, this._activeEffect, this.prePassConfiguration);
            let reflectionTexture = null;
            const ubo = this._uniformBuffer;
            if (mustRebind) {
                this.bindViewProjection(effect);
                reflectionTexture = this._getReflectionTexture();
                if (!ubo.useUbo || !this.isFrozen || !ubo.isSync || effect._forceRebindOnNextCall) {
                    // Texture uniforms
                    if (scene.texturesEnabled) {
                        if (this._albedoTexture && MaterialFlags.DiffuseTextureEnabled) {
                            ubo.updateFloat2("vAlbedoInfos", this._albedoTexture.coordinatesIndex, this._albedoTexture.level);
                            MaterialHelper.BindTextureMatrix(this._albedoTexture, ubo, "albedo");
                        }
                        if (this._ambientTexture && MaterialFlags.AmbientTextureEnabled) {
                            ubo.updateFloat4("vAmbientInfos", this._ambientTexture.coordinatesIndex, this._ambientTexture.level, this._ambientTextureStrength, this._ambientTextureImpactOnAnalyticalLights);
                            MaterialHelper.BindTextureMatrix(this._ambientTexture, ubo, "ambient");
                        }
                        if (this._opacityTexture && MaterialFlags.OpacityTextureEnabled) {
                            ubo.updateFloat2("vOpacityInfos", this._opacityTexture.coordinatesIndex, this._opacityTexture.level);
                            MaterialHelper.BindTextureMatrix(this._opacityTexture, ubo, "opacity");
                        }
                        if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                            ubo.updateMatrix("reflectionMatrix", reflectionTexture.getReflectionTextureMatrix());
                            ubo.updateFloat2("vReflectionInfos", reflectionTexture.level, 0);
                            if (reflectionTexture.boundingBoxSize) {
                                const cubeTexture = reflectionTexture;
                                ubo.updateVector3("vReflectionPosition", cubeTexture.boundingBoxPosition);
                                ubo.updateVector3("vReflectionSize", cubeTexture.boundingBoxSize);
                            }
                            if (this.realTimeFiltering) {
                                const width = reflectionTexture.getSize().width;
                                ubo.updateFloat2("vReflectionFilteringInfo", width, Scalar.Log2(width));
                            }
                            if (!defines.USEIRRADIANCEMAP) {
                                const polynomials = reflectionTexture.sphericalPolynomial;
                                if (defines.USESPHERICALFROMREFLECTIONMAP && polynomials) {
                                    if (defines.SPHERICAL_HARMONICS) {
                                        const preScaledHarmonics = polynomials.preScaledHarmonics;
                                        ubo.updateVector3("vSphericalL00", preScaledHarmonics.l00);
                                        ubo.updateVector3("vSphericalL1_1", preScaledHarmonics.l1_1);
                                        ubo.updateVector3("vSphericalL10", preScaledHarmonics.l10);
                                        ubo.updateVector3("vSphericalL11", preScaledHarmonics.l11);
                                        ubo.updateVector3("vSphericalL2_2", preScaledHarmonics.l2_2);
                                        ubo.updateVector3("vSphericalL2_1", preScaledHarmonics.l2_1);
                                        ubo.updateVector3("vSphericalL20", preScaledHarmonics.l20);
                                        ubo.updateVector3("vSphericalL21", preScaledHarmonics.l21);
                                        ubo.updateVector3("vSphericalL22", preScaledHarmonics.l22);
                                    }
                                    else {
                                        ubo.updateFloat3("vSphericalX", polynomials.x.x, polynomials.x.y, polynomials.x.z);
                                        ubo.updateFloat3("vSphericalY", polynomials.y.x, polynomials.y.y, polynomials.y.z);
                                        ubo.updateFloat3("vSphericalZ", polynomials.z.x, polynomials.z.y, polynomials.z.z);
                                        ubo.updateFloat3("vSphericalXX_ZZ", polynomials.xx.x - polynomials.zz.x, polynomials.xx.y - polynomials.zz.y, polynomials.xx.z - polynomials.zz.z);
                                        ubo.updateFloat3("vSphericalYY_ZZ", polynomials.yy.x - polynomials.zz.x, polynomials.yy.y - polynomials.zz.y, polynomials.yy.z - polynomials.zz.z);
                                        ubo.updateFloat3("vSphericalZZ", polynomials.zz.x, polynomials.zz.y, polynomials.zz.z);
                                        ubo.updateFloat3("vSphericalXY", polynomials.xy.x, polynomials.xy.y, polynomials.xy.z);
                                        ubo.updateFloat3("vSphericalYZ", polynomials.yz.x, polynomials.yz.y, polynomials.yz.z);
                                        ubo.updateFloat3("vSphericalZX", polynomials.zx.x, polynomials.zx.y, polynomials.zx.z);
                                    }
                                }
                            }
                            ubo.updateFloat3("vReflectionMicrosurfaceInfos", reflectionTexture.getSize().width, reflectionTexture.lodGenerationScale, reflectionTexture.lodGenerationOffset);
                        }
                        if (this._emissiveTexture && MaterialFlags.EmissiveTextureEnabled) {
                            ubo.updateFloat2("vEmissiveInfos", this._emissiveTexture.coordinatesIndex, this._emissiveTexture.level);
                            MaterialHelper.BindTextureMatrix(this._emissiveTexture, ubo, "emissive");
                        }
                        if (this._lightmapTexture && MaterialFlags.LightmapTextureEnabled) {
                            ubo.updateFloat2("vLightmapInfos", this._lightmapTexture.coordinatesIndex, this._lightmapTexture.level);
                            MaterialHelper.BindTextureMatrix(this._lightmapTexture, ubo, "lightmap");
                        }
                        if (MaterialFlags.SpecularTextureEnabled) {
                            if (this._metallicTexture) {
                                ubo.updateFloat3("vReflectivityInfos", this._metallicTexture.coordinatesIndex, this._metallicTexture.level, this._ambientTextureStrength);
                                MaterialHelper.BindTextureMatrix(this._metallicTexture, ubo, "reflectivity");
                            }
                            else if (this._reflectivityTexture) {
                                ubo.updateFloat3("vReflectivityInfos", this._reflectivityTexture.coordinatesIndex, this._reflectivityTexture.level, 1.0);
                                MaterialHelper.BindTextureMatrix(this._reflectivityTexture, ubo, "reflectivity");
                            }
                            if (this._metallicReflectanceTexture) {
                                ubo.updateFloat2("vMetallicReflectanceInfos", this._metallicReflectanceTexture.coordinatesIndex, this._metallicReflectanceTexture.level);
                                MaterialHelper.BindTextureMatrix(this._metallicReflectanceTexture, ubo, "metallicReflectance");
                            }
                            if (this._reflectanceTexture && defines.REFLECTANCE) {
                                ubo.updateFloat2("vReflectanceInfos", this._reflectanceTexture.coordinatesIndex, this._reflectanceTexture.level);
                                MaterialHelper.BindTextureMatrix(this._reflectanceTexture, ubo, "reflectance");
                            }
                            if (this._microSurfaceTexture) {
                                ubo.updateFloat2("vMicroSurfaceSamplerInfos", this._microSurfaceTexture.coordinatesIndex, this._microSurfaceTexture.level);
                                MaterialHelper.BindTextureMatrix(this._microSurfaceTexture, ubo, "microSurfaceSampler");
                            }
                        }
                        if (this._bumpTexture && engine.getCaps().standardDerivatives && MaterialFlags.BumpTextureEnabled && !this._disableBumpMap) {
                            ubo.updateFloat3("vBumpInfos", this._bumpTexture.coordinatesIndex, this._bumpTexture.level, this._parallaxScaleBias);
                            MaterialHelper.BindTextureMatrix(this._bumpTexture, ubo, "bump");
                            if (scene._mirroredCameraPosition) {
                                ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? 1.0 : -1.0, this._invertNormalMapY ? 1.0 : -1.0);
                            }
                            else {
                                ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? -1.0 : 1.0, this._invertNormalMapY ? -1.0 : 1.0);
                            }
                        }
                    }
                    // Point size
                    if (this.pointsCloud) {
                        ubo.updateFloat("pointSize", this.pointSize);
                    }
                    // Colors
                    if (defines.METALLICWORKFLOW) {
                        TmpColors.Color3[0].r = this._metallic === undefined || this._metallic === null ? 1 : this._metallic;
                        TmpColors.Color3[0].g = this._roughness === undefined || this._roughness === null ? 1 : this._roughness;
                        ubo.updateColor4("vReflectivityColor", TmpColors.Color3[0], 1);
                        const ior = (_b = (_a = this.subSurface) === null || _a === void 0 ? void 0 : _a._indexOfRefraction) !== null && _b !== void 0 ? _b : 1.5;
                        const outsideIOR = 1; // consider air as clear coat and other layers would remap in the shader.
                        // We are here deriving our default reflectance from a common value for none metallic surface.
                        // Based of the schlick fresnel approximation model
                        // for dielectrics.
                        const f0 = Math.pow((ior - outsideIOR) / (ior + outsideIOR), 2);
                        // Tweak the default F0 and F90 based on our given setup
                        this._metallicReflectanceColor.scaleToRef(f0 * this._metallicF0Factor, TmpColors.Color3[0]);
                        const metallicF90 = this._metallicF0Factor;
                        ubo.updateColor4("vMetallicReflectanceFactors", TmpColors.Color3[0], metallicF90);
                    }
                    else {
                        ubo.updateColor4("vReflectivityColor", this._reflectivityColor, this._microSurface);
                    }
                    ubo.updateColor3("vEmissiveColor", MaterialFlags.EmissiveTextureEnabled ? this._emissiveColor : Color3.BlackReadOnly);
                    ubo.updateColor3("vReflectionColor", this._reflectionColor);
                    if (!defines.SS_REFRACTION && ((_c = this.subSurface) === null || _c === void 0 ? void 0 : _c._linkRefractionWithTransparency)) {
                        ubo.updateColor4("vAlbedoColor", this._albedoColor, 1);
                    }
                    else {
                        ubo.updateColor4("vAlbedoColor", this._albedoColor, this.alpha);
                    }
                    // Misc
                    this._lightingInfos.x = this._directIntensity;
                    this._lightingInfos.y = this._emissiveIntensity;
                    this._lightingInfos.z = this._environmentIntensity * scene.environmentIntensity;
                    this._lightingInfos.w = this._specularIntensity;
                    ubo.updateVector4("vLightingIntensity", this._lightingInfos);
                    // Colors
                    scene.ambientColor.multiplyToRef(this._ambientColor, this._globalAmbientColor);
                    ubo.updateColor3("vAmbientColor", this._globalAmbientColor);
                    ubo.updateFloat2("vDebugMode", this.debugLimit, this.debugFactor);
                }
                // Textures
                if (scene.texturesEnabled) {
                    if (this._albedoTexture && MaterialFlags.DiffuseTextureEnabled) {
                        ubo.setTexture("albedoSampler", this._albedoTexture);
                    }
                    if (this._ambientTexture && MaterialFlags.AmbientTextureEnabled) {
                        ubo.setTexture("ambientSampler", this._ambientTexture);
                    }
                    if (this._opacityTexture && MaterialFlags.OpacityTextureEnabled) {
                        ubo.setTexture("opacitySampler", this._opacityTexture);
                    }
                    if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                        if (defines.LODBASEDMICROSFURACE) {
                            ubo.setTexture("reflectionSampler", reflectionTexture);
                        }
                        else {
                            ubo.setTexture("reflectionSampler", reflectionTexture._lodTextureMid || reflectionTexture);
                            ubo.setTexture("reflectionSamplerLow", reflectionTexture._lodTextureLow || reflectionTexture);
                            ubo.setTexture("reflectionSamplerHigh", reflectionTexture._lodTextureHigh || reflectionTexture);
                        }
                        if (defines.USEIRRADIANCEMAP) {
                            ubo.setTexture("irradianceSampler", reflectionTexture.irradianceTexture);
                        }
                    }
                    if (defines.ENVIRONMENTBRDF) {
                        ubo.setTexture("environmentBrdfSampler", this._environmentBRDFTexture);
                    }
                    if (this._emissiveTexture && MaterialFlags.EmissiveTextureEnabled) {
                        ubo.setTexture("emissiveSampler", this._emissiveTexture);
                    }
                    if (this._lightmapTexture && MaterialFlags.LightmapTextureEnabled) {
                        ubo.setTexture("lightmapSampler", this._lightmapTexture);
                    }
                    if (MaterialFlags.SpecularTextureEnabled) {
                        if (this._metallicTexture) {
                            ubo.setTexture("reflectivitySampler", this._metallicTexture);
                        }
                        else if (this._reflectivityTexture) {
                            ubo.setTexture("reflectivitySampler", this._reflectivityTexture);
                        }
                        if (this._metallicReflectanceTexture) {
                            ubo.setTexture("metallicReflectanceSampler", this._metallicReflectanceTexture);
                        }
                        if (this._reflectanceTexture && defines.REFLECTANCE) {
                            ubo.setTexture("reflectanceSampler", this._reflectanceTexture);
                        }
                        if (this._microSurfaceTexture) {
                            ubo.setTexture("microSurfaceSampler", this._microSurfaceTexture);
                        }
                    }
                    if (this._bumpTexture && engine.getCaps().standardDerivatives && MaterialFlags.BumpTextureEnabled && !this._disableBumpMap) {
                        ubo.setTexture("bumpSampler", this._bumpTexture);
                    }
                }
                // OIT with depth peeling
                if (this.getScene().useOrderIndependentTransparency && this.needAlphaBlendingForMesh(mesh)) {
                    this.getScene().depthPeelingRenderer.bind(effect);
                }
                this._eventInfo.subMesh = subMesh;
                this._callbackPluginEventBindForSubMesh(this._eventInfo);
                // Clip plane
                bindClipPlane(this._activeEffect, this, scene);
                this.bindEyePosition(effect);
            }
            else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) {
                this._needToBindSceneUbo = true;
            }
            if (mustRebind || !this.isFrozen) {
                // Lights
                if (scene.lightsEnabled && !this._disableLighting) {
                    MaterialHelper.BindLights(scene, mesh, this._activeEffect, defines, this._maxSimultaneousLights);
                }
                // View
                if ((scene.fogEnabled && mesh.applyFog && scene.fogMode !== Scene.FOGMODE_NONE) || reflectionTexture || mesh.receiveShadows || defines.PREPASS) {
                    this.bindView(effect);
                }
                // Fog
                MaterialHelper.BindFogParameters(scene, mesh, this._activeEffect, true);
                // Morph targets
                if (defines.NUM_MORPH_INFLUENCERS) {
                    MaterialHelper.BindMorphTargetParameters(mesh, this._activeEffect);
                }
                if (defines.BAKED_VERTEX_ANIMATION_TEXTURE) {
                    (_d = mesh.bakedVertexAnimationManager) === null || _d === void 0 ? void 0 : _d.bind(effect, defines.INSTANCES);
                }
                // image processing
                this._imageProcessingConfiguration.bind(this._activeEffect);
                // Log. depth
                MaterialHelper.BindLogDepth(defines, this._activeEffect, scene);
            }
            this._afterBind(mesh, this._activeEffect);
            ubo.update();
        }
        /**
         * Returns the animatable textures.
         * If material have animatable metallic texture, then reflectivity texture will not be returned, even if it has animations.
         * @returns - Array of animatable textures.
         */
        getAnimatables() {
            const results = super.getAnimatables();
            if (this._albedoTexture && this._albedoTexture.animations && this._albedoTexture.animations.length > 0) {
                results.push(this._albedoTexture);
            }
            if (this._ambientTexture && this._ambientTexture.animations && this._ambientTexture.animations.length > 0) {
                results.push(this._ambientTexture);
            }
            if (this._opacityTexture && this._opacityTexture.animations && this._opacityTexture.animations.length > 0) {
                results.push(this._opacityTexture);
            }
            if (this._reflectionTexture && this._reflectionTexture.animations && this._reflectionTexture.animations.length > 0) {
                results.push(this._reflectionTexture);
            }
            if (this._emissiveTexture && this._emissiveTexture.animations && this._emissiveTexture.animations.length > 0) {
                results.push(this._emissiveTexture);
            }
            if (this._metallicTexture && this._metallicTexture.animations && this._metallicTexture.animations.length > 0) {
                results.push(this._metallicTexture);
            }
            else if (this._reflectivityTexture && this._reflectivityTexture.animations && this._reflectivityTexture.animations.length > 0) {
                results.push(this._reflectivityTexture);
            }
            if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) {
                results.push(this._bumpTexture);
            }
            if (this._lightmapTexture && this._lightmapTexture.animations && this._lightmapTexture.animations.length > 0) {
                results.push(this._lightmapTexture);
            }
            if (this._metallicReflectanceTexture && this._metallicReflectanceTexture.animations && this._metallicReflectanceTexture.animations.length > 0) {
                results.push(this._metallicReflectanceTexture);
            }
            if (this._reflectanceTexture && this._reflectanceTexture.animations && this._reflectanceTexture.animations.length > 0) {
                results.push(this._reflectanceTexture);
            }
            if (this._microSurfaceTexture && this._microSurfaceTexture.animations && this._microSurfaceTexture.animations.length > 0) {
                results.push(this._microSurfaceTexture);
            }
            return results;
        }
        /**
         * Returns the texture used for reflections.
         * @returns - Reflection texture if present.  Otherwise, returns the environment texture.
         */
        _getReflectionTexture() {
            if (this._reflectionTexture) {
                return this._reflectionTexture;
            }
            return this.getScene().environmentTexture;
        }
        /**
         * Returns an array of the actively used textures.
         * @returns - Array of BaseTextures
         */
        getActiveTextures() {
            const activeTextures = super.getActiveTextures();
            if (this._albedoTexture) {
                activeTextures.push(this._albedoTexture);
            }
            if (this._ambientTexture) {
                activeTextures.push(this._ambientTexture);
            }
            if (this._opacityTexture) {
                activeTextures.push(this._opacityTexture);
            }
            if (this._reflectionTexture) {
                activeTextures.push(this._reflectionTexture);
            }
            if (this._emissiveTexture) {
                activeTextures.push(this._emissiveTexture);
            }
            if (this._reflectivityTexture) {
                activeTextures.push(this._reflectivityTexture);
            }
            if (this._metallicTexture) {
                activeTextures.push(this._metallicTexture);
            }
            if (this._metallicReflectanceTexture) {
                activeTextures.push(this._metallicReflectanceTexture);
            }
            if (this._reflectanceTexture) {
                activeTextures.push(this._reflectanceTexture);
            }
            if (this._microSurfaceTexture) {
                activeTextures.push(this._microSurfaceTexture);
            }
            if (this._bumpTexture) {
                activeTextures.push(this._bumpTexture);
            }
            if (this._lightmapTexture) {
                activeTextures.push(this._lightmapTexture);
            }
            return activeTextures;
        }
        /**
         * Checks to see if a texture is used in the material.
         * @param texture - Base texture to use.
         * @returns - Boolean specifying if a texture is used in the material.
         */
        hasTexture(texture) {
            if (super.hasTexture(texture)) {
                return true;
            }
            if (this._albedoTexture === texture) {
                return true;
            }
            if (this._ambientTexture === texture) {
                return true;
            }
            if (this._opacityTexture === texture) {
                return true;
            }
            if (this._reflectionTexture === texture) {
                return true;
            }
            if (this._emissiveTexture === texture) {
                return true;
            }
            if (this._reflectivityTexture === texture) {
                return true;
            }
            if (this._metallicTexture === texture) {
                return true;
            }
            if (this._metallicReflectanceTexture === texture) {
                return true;
            }
            if (this._reflectanceTexture === texture) {
                return true;
            }
            if (this._microSurfaceTexture === texture) {
                return true;
            }
            if (this._bumpTexture === texture) {
                return true;
            }
            if (this._lightmapTexture === texture) {
                return true;
            }
            return false;
        }
        /**
         * Sets the required values to the prepass renderer.
         * It can't be sets when subsurface scattering of this material is disabled.
         * When scene have ability to enable subsurface prepass effect, it will enable.
         */
        setPrePassRenderer() {
            var _a;
            if (!((_a = this.subSurface) === null || _a === void 0 ? void 0 : _a.isScatteringEnabled)) {
                return false;
            }
            const subSurfaceConfiguration = this.getScene().enableSubSurfaceForPrePass();
            if (subSurfaceConfiguration) {
                subSurfaceConfiguration.enabled = true;
            }
            return true;
        }
        /**
         * Disposes the resources of the material.
         * @param forceDisposeEffect - Forces the disposal of effects.
         * @param forceDisposeTextures - Forces the disposal of all textures.
         */
        dispose(forceDisposeEffect, forceDisposeTextures) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            if (forceDisposeTextures) {
                if (this._environmentBRDFTexture && this.getScene().environmentBRDFTexture !== this._environmentBRDFTexture) {
                    this._environmentBRDFTexture.dispose();
                }
                (_a = this._albedoTexture) === null || _a === void 0 ? void 0 : _a.dispose();
                (_b = this._ambientTexture) === null || _b === void 0 ? void 0 : _b.dispose();
                (_c = this._opacityTexture) === null || _c === void 0 ? void 0 : _c.dispose();
                (_d = this._reflectionTexture) === null || _d === void 0 ? void 0 : _d.dispose();
                (_e = this._emissiveTexture) === null || _e === void 0 ? void 0 : _e.dispose();
                (_f = this._metallicTexture) === null || _f === void 0 ? void 0 : _f.dispose();
                (_g = this._reflectivityTexture) === null || _g === void 0 ? void 0 : _g.dispose();
                (_h = this._bumpTexture) === null || _h === void 0 ? void 0 : _h.dispose();
                (_j = this._lightmapTexture) === null || _j === void 0 ? void 0 : _j.dispose();
                (_k = this._metallicReflectanceTexture) === null || _k === void 0 ? void 0 : _k.dispose();
                (_l = this._reflectanceTexture) === null || _l === void 0 ? void 0 : _l.dispose();
                (_m = this._microSurfaceTexture) === null || _m === void 0 ? void 0 : _m.dispose();
            }
            this._renderTargets.dispose();
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            super.dispose(forceDisposeEffect, forceDisposeTextures);
        }
    }
    /**
     * PBRMaterialTransparencyMode: No transparency mode, Alpha channel is not use.
     */
    PBRBaseMaterial.PBRMATERIAL_OPAQUE = Material.MATERIAL_OPAQUE;
    /**
     * PBRMaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
     */
    PBRBaseMaterial.PBRMATERIAL_ALPHATEST = Material.MATERIAL_ALPHATEST;
    /**
     * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
     */
    PBRBaseMaterial.PBRMATERIAL_ALPHABLEND = Material.MATERIAL_ALPHABLEND;
    /**
     * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
     * They are also discarded below the alpha cutoff threshold to improve performances.
     */
    PBRBaseMaterial.PBRMATERIAL_ALPHATESTANDBLEND = Material.MATERIAL_ALPHATESTANDBLEND;
    /**
     * Defines the default value of how much AO map is occluding the analytical lights
     * (point spot...).
     */
    PBRBaseMaterial.DEFAULT_AO_ON_ANALYTICAL_LIGHTS = 0;
    /**
     * PBRMaterialLightFalloff Physical: light is falling off following the inverse squared distance law.
     */
    PBRBaseMaterial.LIGHTFALLOFF_PHYSICAL = 0;
    /**
     * PBRMaterialLightFalloff gltf: light is falling off as described in the gltf moving to PBR document
     * to enhance interoperability with other engines.
     */
    PBRBaseMaterial.LIGHTFALLOFF_GLTF = 1;
    /**
     * PBRMaterialLightFalloff Standard: light is falling off like in the standard material
     * to enhance interoperability with other materials.
     */
    PBRBaseMaterial.LIGHTFALLOFF_STANDARD = 2;
    __decorate$1([
        serializeAsImageProcessingConfiguration()
    ], PBRBaseMaterial.prototype, "_imageProcessingConfiguration", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRBaseMaterial.prototype, "debugMode", void 0);
    __decorate$1([
        serialize()
    ], PBRBaseMaterial.prototype, "useLogarithmicDepth", null);

    /**
     * The Physically based material of BJS.
     *
     * This offers the main features of a standard PBR material.
     * For more information, please refer to the documentation :
     * https://doc.babylonjs.com/features/featuresDeepDive/materials/using/introToPBR
     */
    class PBRMaterial extends PBRBaseMaterial {
        /**
         * Stores the refracted light information in a texture.
         */
        get refractionTexture() {
            return this.subSurface.refractionTexture;
        }
        set refractionTexture(value) {
            this.subSurface.refractionTexture = value;
            if (value) {
                this.subSurface.isRefractionEnabled = true;
            }
            else if (!this.subSurface.linkRefractionWithTransparency) {
                this.subSurface.isRefractionEnabled = false;
            }
        }
        /**
         * Index of refraction of the material base layer.
         * https://en.wikipedia.org/wiki/List_of_refractive_indices
         *
         * This does not only impact refraction but also the Base F0 of Dielectric Materials.
         *
         * From dielectric fresnel rules: F0 = square((iorT - iorI) / (iorT + iorI))
         */
        get indexOfRefraction() {
            return this.subSurface.indexOfRefraction;
        }
        set indexOfRefraction(value) {
            this.subSurface.indexOfRefraction = value;
        }
        /**
         * Controls if refraction needs to be inverted on Y. This could be useful for procedural texture.
         */
        get invertRefractionY() {
            return this.subSurface.invertRefractionY;
        }
        set invertRefractionY(value) {
            this.subSurface.invertRefractionY = value;
        }
        /**
         * This parameters will make the material used its opacity to control how much it is refracting against not.
         * Materials half opaque for instance using refraction could benefit from this control.
         */
        get linkRefractionWithTransparency() {
            return this.subSurface.linkRefractionWithTransparency;
        }
        set linkRefractionWithTransparency(value) {
            this.subSurface.linkRefractionWithTransparency = value;
            if (value) {
                this.subSurface.isRefractionEnabled = true;
            }
        }
        /**
         * BJS is using an hardcoded light falloff based on a manually sets up range.
         * In PBR, one way to represents the falloff is to use the inverse squared root algorithm.
         * This parameter can help you switch back to the BJS mode in order to create scenes using both materials.
         */
        get usePhysicalLightFalloff() {
            return this._lightFalloff === PBRBaseMaterial.LIGHTFALLOFF_PHYSICAL;
        }
        /**
         * BJS is using an hardcoded light falloff based on a manually sets up range.
         * In PBR, one way to represents the falloff is to use the inverse squared root algorithm.
         * This parameter can help you switch back to the BJS mode in order to create scenes using both materials.
         */
        set usePhysicalLightFalloff(value) {
            if (value !== this.usePhysicalLightFalloff) {
                // Ensure the effect will be rebuilt.
                this._markAllSubMeshesAsTexturesDirty();
                if (value) {
                    this._lightFalloff = PBRBaseMaterial.LIGHTFALLOFF_PHYSICAL;
                }
                else {
                    this._lightFalloff = PBRBaseMaterial.LIGHTFALLOFF_STANDARD;
                }
            }
        }
        /**
         * In order to support the falloff compatibility with gltf, a special mode has been added
         * to reproduce the gltf light falloff.
         */
        get useGLTFLightFalloff() {
            return this._lightFalloff === PBRBaseMaterial.LIGHTFALLOFF_GLTF;
        }
        /**
         * In order to support the falloff compatibility with gltf, a special mode has been added
         * to reproduce the gltf light falloff.
         */
        set useGLTFLightFalloff(value) {
            if (value !== this.useGLTFLightFalloff) {
                // Ensure the effect will be rebuilt.
                this._markAllSubMeshesAsTexturesDirty();
                if (value) {
                    this._lightFalloff = PBRBaseMaterial.LIGHTFALLOFF_GLTF;
                }
                else {
                    this._lightFalloff = PBRBaseMaterial.LIGHTFALLOFF_STANDARD;
                }
            }
        }
        /**
         * Gets the image processing configuration used either in this material.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Sets the Default image processing configuration used either in the this material.
         *
         * If sets to null, the scene one is in use.
         */
        set imageProcessingConfiguration(value) {
            this._attachImageProcessingConfiguration(value);
            // Ensure the effect will be rebuilt.
            this._markAllSubMeshesAsTexturesDirty();
        }
        /**
         * Gets whether the color curves effect is enabled.
         */
        get cameraColorCurvesEnabled() {
            return this.imageProcessingConfiguration.colorCurvesEnabled;
        }
        /**
         * Sets whether the color curves effect is enabled.
         */
        set cameraColorCurvesEnabled(value) {
            this.imageProcessingConfiguration.colorCurvesEnabled = value;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        get cameraColorGradingEnabled() {
            return this.imageProcessingConfiguration.colorGradingEnabled;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        set cameraColorGradingEnabled(value) {
            this.imageProcessingConfiguration.colorGradingEnabled = value;
        }
        /**
         * Gets whether tonemapping is enabled or not.
         */
        get cameraToneMappingEnabled() {
            return this._imageProcessingConfiguration.toneMappingEnabled;
        }
        /**
         * Sets whether tonemapping is enabled or not
         */
        set cameraToneMappingEnabled(value) {
            this._imageProcessingConfiguration.toneMappingEnabled = value;
        }
        /**
         * The camera exposure used on this material.
         * This property is here and not in the camera to allow controlling exposure without full screen post process.
         * This corresponds to a photographic exposure.
         */
        get cameraExposure() {
            return this._imageProcessingConfiguration.exposure;
        }
        /**
         * The camera exposure used on this material.
         * This property is here and not in the camera to allow controlling exposure without full screen post process.
         * This corresponds to a photographic exposure.
         */
        set cameraExposure(value) {
            this._imageProcessingConfiguration.exposure = value;
        }
        /**
         * Gets The camera contrast used on this material.
         */
        get cameraContrast() {
            return this._imageProcessingConfiguration.contrast;
        }
        /**
         * Sets The camera contrast used on this material.
         */
        set cameraContrast(value) {
            this._imageProcessingConfiguration.contrast = value;
        }
        /**
         * Gets the Color Grading 2D Lookup Texture.
         */
        get cameraColorGradingTexture() {
            return this._imageProcessingConfiguration.colorGradingTexture;
        }
        /**
         * Sets the Color Grading 2D Lookup Texture.
         */
        set cameraColorGradingTexture(value) {
            this._imageProcessingConfiguration.colorGradingTexture = value;
        }
        /**
         * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
         * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
         * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
         * corresponding to low luminance, medium luminance, and high luminance areas respectively.
         */
        get cameraColorCurves() {
            return this._imageProcessingConfiguration.colorCurves;
        }
        /**
         * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
         * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
         * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
         * corresponding to low luminance, medium luminance, and high luminance areas respectively.
         */
        set cameraColorCurves(value) {
            this._imageProcessingConfiguration.colorCurves = value;
        }
        /**
         * Instantiates a new PBRMaterial instance.
         *
         * @param name The material name
         * @param scene The scene the material will be use in.
         */
        constructor(name, scene) {
            super(name, scene);
            /**
             * Intensity of the direct lights e.g. the four lights available in your scene.
             * This impacts both the direct diffuse and specular highlights.
             */
            this.directIntensity = 1.0;
            /**
             * Intensity of the emissive part of the material.
             * This helps controlling the emissive effect without modifying the emissive color.
             */
            this.emissiveIntensity = 1.0;
            /**
             * Intensity of the environment e.g. how much the environment will light the object
             * either through harmonics for rough material or through the reflection for shiny ones.
             */
            this.environmentIntensity = 1.0;
            /**
             * This is a special control allowing the reduction of the specular highlights coming from the
             * four lights of the scene. Those highlights may not be needed in full environment lighting.
             */
            this.specularIntensity = 1.0;
            /**
             * Debug Control allowing disabling the bump map on this material.
             */
            this.disableBumpMap = false;
            /**
             * AKA Occlusion Texture Intensity in other nomenclature.
             */
            this.ambientTextureStrength = 1.0;
            /**
             * Defines how much the AO map is occluding the analytical lights (point spot...).
             * 1 means it completely occludes it
             * 0 mean it has no impact
             */
            this.ambientTextureImpactOnAnalyticalLights = PBRMaterial.DEFAULT_AO_ON_ANALYTICAL_LIGHTS;
            /**
             * In metallic workflow, specifies an F0 factor to help configuring the material F0.
             * By default the indexOfrefraction is used to compute F0;
             *
             * This is used as a factor against the default reflectance at normal incidence to tweak it.
             *
             * F0 = defaultF0 * metallicF0Factor * metallicReflectanceColor;
             * F90 = metallicReflectanceColor;
             */
            this.metallicF0Factor = 1;
            /**
             * In metallic workflow, specifies an F0 color.
             * By default the F90 is always 1;
             *
             * Please note that this factor is also used as a factor against the default reflectance at normal incidence.
             *
             * F0 = defaultF0_from_IOR * metallicF0Factor * metallicReflectanceColor
             * F90 = metallicF0Factor;
             */
            this.metallicReflectanceColor = Color3.White();
            /**
             * Specifies that only the A channel from metallicReflectanceTexture should be used.
             * If false, both RGB and A channels will be used
             */
            this.useOnlyMetallicFromMetallicReflectanceTexture = false;
            /**
             * The color of a material in ambient lighting.
             */
            this.ambientColor = new Color3(0, 0, 0);
            /**
             * AKA Diffuse Color in other nomenclature.
             */
            this.albedoColor = new Color3(1, 1, 1);
            /**
             * AKA Specular Color in other nomenclature.
             */
            this.reflectivityColor = new Color3(1, 1, 1);
            /**
             * The color reflected from the material.
             */
            this.reflectionColor = new Color3(1.0, 1.0, 1.0);
            /**
             * The color emitted from the material.
             */
            this.emissiveColor = new Color3(0, 0, 0);
            /**
             * AKA Glossiness in other nomenclature.
             */
            this.microSurface = 1.0;
            /**
             * If true, the light map contains occlusion information instead of lighting info.
             */
            this.useLightmapAsShadowmap = false;
            /**
             * Specifies that the alpha is coming form the albedo channel alpha channel for alpha blending.
             */
            this.useAlphaFromAlbedoTexture = false;
            /**
             * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
             */
            this.forceAlphaTest = false;
            /**
             * Defines the alpha limits in alpha test mode.
             */
            this.alphaCutOff = 0.4;
            /**
             * Specifies that the material will keep the specular highlights over a transparent surface (only the most luminous ones).
             * A car glass is a good example of that. When sun reflects on it you can not see what is behind.
             */
            this.useSpecularOverAlpha = true;
            /**
             * Specifies if the reflectivity texture contains the glossiness information in its alpha channel.
             */
            this.useMicroSurfaceFromReflectivityMapAlpha = false;
            /**
             * Specifies if the metallic texture contains the roughness information in its alpha channel.
             */
            this.useRoughnessFromMetallicTextureAlpha = true;
            /**
             * Specifies if the metallic texture contains the roughness information in its green channel.
             */
            this.useRoughnessFromMetallicTextureGreen = false;
            /**
             * Specifies if the metallic texture contains the metallness information in its blue channel.
             */
            this.useMetallnessFromMetallicTextureBlue = false;
            /**
             * Specifies if the metallic texture contains the ambient occlusion information in its red channel.
             */
            this.useAmbientOcclusionFromMetallicTextureRed = false;
            /**
             * Specifies if the ambient texture contains the ambient occlusion information in its red channel only.
             */
            this.useAmbientInGrayScale = false;
            /**
             * In case the reflectivity map does not contain the microsurface information in its alpha channel,
             * The material will try to infer what glossiness each pixel should be.
             */
            this.useAutoMicroSurfaceFromReflectivityMap = false;
            /**
             * Specifies that the material will keeps the reflection highlights over a transparent surface (only the most luminous ones).
             * A car glass is a good example of that. When the street lights reflects on it you can not see what is behind.
             */
            this.useRadianceOverAlpha = true;
            /**
             * Allows using an object space normal map (instead of tangent space).
             */
            this.useObjectSpaceNormalMap = false;
            /**
             * Allows using the bump map in parallax mode.
             */
            this.useParallax = false;
            /**
             * Allows using the bump map in parallax occlusion mode.
             */
            this.useParallaxOcclusion = false;
            /**
             * Controls the scale bias of the parallax mode.
             */
            this.parallaxScaleBias = 0.05;
            /**
             * If sets to true, disables all the lights affecting the material.
             */
            this.disableLighting = false;
            /**
             * Force the shader to compute irradiance in the fragment shader in order to take bump in account.
             */
            this.forceIrradianceInFragment = false;
            /**
             * Number of Simultaneous lights allowed on the material.
             */
            this.maxSimultaneousLights = 4;
            /**
             * If sets to true, x component of normal map value will invert (x = 1.0 - x).
             */
            this.invertNormalMapX = false;
            /**
             * If sets to true, y component of normal map value will invert (y = 1.0 - y).
             */
            this.invertNormalMapY = false;
            /**
             * If sets to true and backfaceCulling is false, normals will be flipped on the backside.
             */
            this.twoSidedLighting = false;
            /**
             * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
             * And/Or occlude the blended part. (alpha is converted to gamma to compute the fresnel)
             */
            this.useAlphaFresnel = false;
            /**
             * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
             * And/Or occlude the blended part. (alpha stays linear to compute the fresnel)
             */
            this.useLinearAlphaFresnel = false;
            /**
             * Let user defines the brdf lookup texture used for IBL.
             * A default 8bit version is embedded but you could point at :
             * * Default texture: https://assets.babylonjs.com/environments/correlatedMSBRDF_RGBD.png
             * * Default 16bit pixel depth texture: https://assets.babylonjs.com/environments/correlatedMSBRDF.dds
             * * LEGACY Default None correlated https://assets.babylonjs.com/environments/uncorrelatedBRDF_RGBD.png
             * * LEGACY Default None correlated 16bit pixel depth https://assets.babylonjs.com/environments/uncorrelatedBRDF.dds
             */
            this.environmentBRDFTexture = null;
            /**
             * Force normal to face away from face.
             */
            this.forceNormalForward = false;
            /**
             * Enables specular anti aliasing in the PBR shader.
             * It will both interacts on the Geometry for analytical and IBL lighting.
             * It also prefilter the roughness map based on the bump values.
             */
            this.enableSpecularAntiAliasing = false;
            /**
             * This parameters will enable/disable Horizon occlusion to prevent normal maps to look shiny when the normal
             * makes the reflect vector face the model (under horizon).
             */
            this.useHorizonOcclusion = true;
            /**
             * This parameters will enable/disable radiance occlusion by preventing the radiance to lit
             * too much the area relying on ambient texture to define their ambient occlusion.
             */
            this.useRadianceOcclusion = true;
            /**
             * If set to true, no lighting calculations will be applied.
             */
            this.unlit = false;
            /**
             * If sets to true, the decal map will be applied after the detail map. Else, it is applied before (default: false)
             */
            this.applyDecalMapAfterDetailMap = false;
            this._environmentBRDFTexture = GetEnvironmentBRDFTexture(this.getScene());
        }
        /**
         * Returns the name of this material class.
         */
        getClassName() {
            return "PBRMaterial";
        }
        /**
         * Makes a duplicate of the current material.
         * @param name - name to use for the new material.
         * @param cloneTexturesOnlyOnce - if a texture is used in more than one channel (e.g diffuse and opacity), only clone it once and reuse it on the other channels. Default false.
         * @param rootUrl defines the root URL to use to load textures
         */
        clone(name, cloneTexturesOnlyOnce = true, rootUrl = "") {
            const clone = SerializationHelper.Clone(() => new PBRMaterial(name, this.getScene()), this, { cloneTexturesOnlyOnce });
            clone.id = name;
            clone.name = name;
            this.stencil.copyTo(clone.stencil);
            this._clonePlugins(clone, rootUrl);
            return clone;
        }
        /**
         * Serializes this PBR Material.
         * @returns - An object with the serialized material.
         */
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.customType = "BABYLON.PBRMaterial";
            return serializationObject;
        }
        // Statics
        /**
         * Parses a PBR Material from a serialized object.
         * @param source - Serialized object.
         * @param scene - BJS scene instance.
         * @param rootUrl - url for the scene object
         * @returns - PBRMaterial
         */
        static Parse(source, scene, rootUrl) {
            const material = SerializationHelper.Parse(() => new PBRMaterial(source.name, scene), source, scene, rootUrl);
            if (source.stencil) {
                material.stencil.parse(source.stencil, scene, rootUrl);
            }
            Material._parsePlugins(source, material, scene, rootUrl);
            // The code block below ensures backward compatibility with serialized materials before plugins are automatically serialized.
            if (source.clearCoat) {
                material.clearCoat.parse(source.clearCoat, scene, rootUrl);
            }
            if (source.anisotropy) {
                material.anisotropy.parse(source.anisotropy, scene, rootUrl);
            }
            if (source.brdf) {
                material.brdf.parse(source.brdf, scene, rootUrl);
            }
            if (source.sheen) {
                material.sheen.parse(source.sheen, scene, rootUrl);
            }
            if (source.subSurface) {
                material.subSurface.parse(source.subSurface, scene, rootUrl);
            }
            if (source.iridescence) {
                material.iridescence.parse(source.iridescence, scene, rootUrl);
            }
            return material;
        }
    }
    /**
     * PBRMaterialTransparencyMode: No transparency mode, Alpha channel is not use.
     */
    PBRMaterial.PBRMATERIAL_OPAQUE = PBRBaseMaterial.PBRMATERIAL_OPAQUE;
    /**
     * PBRMaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
     */
    PBRMaterial.PBRMATERIAL_ALPHATEST = PBRBaseMaterial.PBRMATERIAL_ALPHATEST;
    /**
     * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
     */
    PBRMaterial.PBRMATERIAL_ALPHABLEND = PBRBaseMaterial.PBRMATERIAL_ALPHABLEND;
    /**
     * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
     * They are also discarded below the alpha cutoff threshold to improve performances.
     */
    PBRMaterial.PBRMATERIAL_ALPHATESTANDBLEND = PBRBaseMaterial.PBRMATERIAL_ALPHATESTANDBLEND;
    /**
     * Defines the default value of how much AO map is occluding the analytical lights
     * (point spot...).
     */
    PBRMaterial.DEFAULT_AO_ON_ANALYTICAL_LIGHTS = PBRBaseMaterial.DEFAULT_AO_ON_ANALYTICAL_LIGHTS;
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "directIntensity", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "emissiveIntensity", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "environmentIntensity", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "specularIntensity", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "disableBumpMap", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "albedoTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "ambientTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "ambientTextureStrength", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "ambientTextureImpactOnAnalyticalLights", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], PBRMaterial.prototype, "opacityTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "reflectionTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "emissiveTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "reflectivityTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "metallicTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "metallic", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "roughness", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "metallicF0Factor", void 0);
    __decorate$1([
        serializeAsColor3(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "metallicReflectanceColor", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useOnlyMetallicFromMetallicReflectanceTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "metallicReflectanceTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "reflectanceTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "microSurfaceTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "bumpTexture", void 0);
    __decorate$1([
        serializeAsTexture(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty", null)
    ], PBRMaterial.prototype, "lightmapTexture", void 0);
    __decorate$1([
        serializeAsColor3("ambient"),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "ambientColor", void 0);
    __decorate$1([
        serializeAsColor3("albedo"),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "albedoColor", void 0);
    __decorate$1([
        serializeAsColor3("reflectivity"),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "reflectivityColor", void 0);
    __decorate$1([
        serializeAsColor3("reflection"),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "reflectionColor", void 0);
    __decorate$1([
        serializeAsColor3("emissive"),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "emissiveColor", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "microSurface", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useLightmapAsShadowmap", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], PBRMaterial.prototype, "useAlphaFromAlbedoTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], PBRMaterial.prototype, "forceAlphaTest", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")
    ], PBRMaterial.prototype, "alphaCutOff", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useSpecularOverAlpha", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useMicroSurfaceFromReflectivityMapAlpha", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useRoughnessFromMetallicTextureAlpha", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useRoughnessFromMetallicTextureGreen", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useMetallnessFromMetallicTextureBlue", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useAmbientOcclusionFromMetallicTextureRed", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useAmbientInGrayScale", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useAutoMicroSurfaceFromReflectivityMap", void 0);
    __decorate$1([
        serialize()
    ], PBRMaterial.prototype, "usePhysicalLightFalloff", null);
    __decorate$1([
        serialize()
    ], PBRMaterial.prototype, "useGLTFLightFalloff", null);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useRadianceOverAlpha", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useObjectSpaceNormalMap", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useParallax", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useParallaxOcclusion", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "parallaxScaleBias", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], PBRMaterial.prototype, "disableLighting", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "forceIrradianceInFragment", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], PBRMaterial.prototype, "maxSimultaneousLights", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "invertNormalMapX", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "invertNormalMapY", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "twoSidedLighting", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useAlphaFresnel", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useLinearAlphaFresnel", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "environmentBRDFTexture", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "forceNormalForward", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "enableSpecularAntiAliasing", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useHorizonOcclusion", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], PBRMaterial.prototype, "useRadianceOcclusion", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRMaterial.prototype, "unlit", void 0);
    __decorate$1([
        serialize(),
        expandToProperty("_markAllSubMeshesAsMiscDirty")
    ], PBRMaterial.prototype, "applyDecalMapAfterDetailMap", void 0);
    RegisterClass("BABYLON.PBRMaterial", PBRMaterial);

    /**
     * Base class of all the lights in Babylon. It groups all the generic information about lights.
     * Lights are used, as you would expect, to affect how meshes are seen, in terms of both illumination and colour.
     * All meshes allow light to pass through them unless shadow generation is activated. The default number of lights allowed is four but this can be increased.
     */
    class Light extends Node {
        /**
         * Defines how far from the source the light is impacting in scene units.
         * Note: Unused in PBR material as the distance light falloff is defined following the inverse squared falloff.
         */
        get range() {
            return this._range;
        }
        /**
         * Defines how far from the source the light is impacting in scene units.
         * Note: Unused in PBR material as the distance light falloff is defined following the inverse squared falloff.
         */
        set range(value) {
            this._range = value;
            this._inverseSquaredRange = 1.0 / (this.range * this.range);
        }
        /**
         * Gets the photometric scale used to interpret the intensity.
         * This is only relevant with PBR Materials where the light intensity can be defined in a physical way.
         */
        get intensityMode() {
            return this._intensityMode;
        }
        /**
         * Sets the photometric scale used to interpret the intensity.
         * This is only relevant with PBR Materials where the light intensity can be defined in a physical way.
         */
        set intensityMode(value) {
            this._intensityMode = value;
            this._computePhotometricScale();
        }
        /**
         * Gets the light radius used by PBR Materials to simulate soft area lights.
         */
        get radius() {
            return this._radius;
        }
        /**
         * sets the light radius used by PBR Materials to simulate soft area lights.
         */
        set radius(value) {
            this._radius = value;
            this._computePhotometricScale();
        }
        /**
         * Gets whether or not the shadows are enabled for this light. This can help turning off/on shadow without detaching
         * the current shadow generator.
         */
        get shadowEnabled() {
            return this._shadowEnabled;
        }
        /**
         * Sets whether or not the shadows are enabled for this light. This can help turning off/on shadow without detaching
         * the current shadow generator.
         */
        set shadowEnabled(value) {
            if (this._shadowEnabled === value) {
                return;
            }
            this._shadowEnabled = value;
            this._markMeshesAsLightDirty();
        }
        /**
         * Gets the only meshes impacted by this light.
         */
        get includedOnlyMeshes() {
            return this._includedOnlyMeshes;
        }
        /**
         * Sets the only meshes impacted by this light.
         */
        set includedOnlyMeshes(value) {
            this._includedOnlyMeshes = value;
            this._hookArrayForIncludedOnly(value);
        }
        /**
         * Gets the meshes not impacted by this light.
         */
        get excludedMeshes() {
            return this._excludedMeshes;
        }
        /**
         * Sets the meshes not impacted by this light.
         */
        set excludedMeshes(value) {
            this._excludedMeshes = value;
            this._hookArrayForExcluded(value);
        }
        /**
         * Gets the layer id use to find what meshes are not impacted by the light.
         * Inactive if 0
         */
        get excludeWithLayerMask() {
            return this._excludeWithLayerMask;
        }
        /**
         * Sets the layer id use to find what meshes are not impacted by the light.
         * Inactive if 0
         */
        set excludeWithLayerMask(value) {
            this._excludeWithLayerMask = value;
            this._resyncMeshes();
        }
        /**
         * Gets the layer id use to find what meshes are impacted by the light.
         * Inactive if 0
         */
        get includeOnlyWithLayerMask() {
            return this._includeOnlyWithLayerMask;
        }
        /**
         * Sets the layer id use to find what meshes are impacted by the light.
         * Inactive if 0
         */
        set includeOnlyWithLayerMask(value) {
            this._includeOnlyWithLayerMask = value;
            this._resyncMeshes();
        }
        /**
         * Gets the lightmap mode of this light (should be one of the constants defined by Light.LIGHTMAP_x)
         */
        get lightmapMode() {
            return this._lightmapMode;
        }
        /**
         * Sets the lightmap mode of this light (should be one of the constants defined by Light.LIGHTMAP_x)
         */
        set lightmapMode(value) {
            if (this._lightmapMode === value) {
                return;
            }
            this._lightmapMode = value;
            this._markMeshesAsLightDirty();
        }
        /**
         * Creates a Light object in the scene.
         * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         * @param name The friendly name of the light
         * @param scene The scene the light belongs too
         */
        constructor(name, scene) {
            super(name, scene);
            /**
             * Diffuse gives the basic color to an object.
             */
            this.diffuse = new Color3(1.0, 1.0, 1.0);
            /**
             * Specular produces a highlight color on an object.
             * Note: This is not affecting PBR materials.
             */
            this.specular = new Color3(1.0, 1.0, 1.0);
            /**
             * Defines the falloff type for this light. This lets overriding how punctual light are
             * falling off base on range or angle.
             * This can be set to any values in Light.FALLOFF_x.
             *
             * Note: This is only useful for PBR Materials at the moment. This could be extended if required to
             * other types of materials.
             */
            this.falloffType = Light.FALLOFF_DEFAULT;
            /**
             * Strength of the light.
             * Note: By default it is define in the framework own unit.
             * Note: In PBR materials the intensityMode can be use to chose what unit the intensity is defined in.
             */
            this.intensity = 1.0;
            this._range = Number.MAX_VALUE;
            this._inverseSquaredRange = 0;
            /**
             * Cached photometric scale default to 1.0 as the automatic intensity mode defaults to 1.0 for every type
             * of light.
             */
            this._photometricScale = 1.0;
            this._intensityMode = Light.INTENSITYMODE_AUTOMATIC;
            this._radius = 0.00001;
            /**
             * Defines the rendering priority of the lights. It can help in case of fallback or number of lights
             * exceeding the number allowed of the materials.
             */
            this.renderPriority = 0;
            this._shadowEnabled = true;
            this._excludeWithLayerMask = 0;
            this._includeOnlyWithLayerMask = 0;
            this._lightmapMode = 0;
            /**
             * Shadow generators associated to the light.
             * @internal Internal use only.
             */
            this._shadowGenerators = null;
            /**
             * @internal Internal use only.
             */
            this._excludedMeshesIds = new Array();
            /**
             * @internal Internal use only.
             */
            this._includedOnlyMeshesIds = new Array();
            /** @internal */
            this._isLight = true;
            this.getScene().addLight(this);
            this._uniformBuffer = new UniformBuffer(this.getScene().getEngine(), undefined, undefined, name);
            this._buildUniformLayout();
            this.includedOnlyMeshes = new Array();
            this.excludedMeshes = new Array();
            this._resyncMeshes();
        }
        /**
         * Sets the passed Effect "effect" with the Light textures.
         * @param effect The effect to update
         * @param lightIndex The index of the light in the effect to update
         * @returns The light
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        transferTexturesToEffect(effect, lightIndex) {
            // Do nothing by default.
            return this;
        }
        /**
         * Binds the lights information from the scene to the effect for the given mesh.
         * @param lightIndex Light index
         * @param scene The scene where the light belongs to
         * @param effect The effect we are binding the data to
         * @param useSpecular Defines if specular is supported
         * @param receiveShadows Defines if the effect (mesh) we bind the light for receives shadows
         */
        _bindLight(lightIndex, scene, effect, useSpecular, receiveShadows = true) {
            var _a;
            const iAsString = lightIndex.toString();
            let needUpdate = false;
            this._uniformBuffer.bindToEffect(effect, "Light" + iAsString);
            if (this._renderId !== scene.getRenderId() || this._lastUseSpecular !== useSpecular || !this._uniformBuffer.useUbo) {
                this._renderId = scene.getRenderId();
                this._lastUseSpecular = useSpecular;
                const scaledIntensity = this.getScaledIntensity();
                this.transferToEffect(effect, iAsString);
                this.diffuse.scaleToRef(scaledIntensity, TmpColors.Color3[0]);
                this._uniformBuffer.updateColor4("vLightDiffuse", TmpColors.Color3[0], this.range, iAsString);
                if (useSpecular) {
                    this.specular.scaleToRef(scaledIntensity, TmpColors.Color3[1]);
                    this._uniformBuffer.updateColor4("vLightSpecular", TmpColors.Color3[1], this.radius, iAsString);
                }
                needUpdate = true;
            }
            // Textures might still need to be rebound.
            this.transferTexturesToEffect(effect, iAsString);
            // Shadows
            if (scene.shadowsEnabled && this.shadowEnabled && receiveShadows) {
                const shadowGenerator = (_a = this.getShadowGenerator(scene.activeCamera)) !== null && _a !== void 0 ? _a : this.getShadowGenerator();
                if (shadowGenerator) {
                    shadowGenerator.bindShadowLight(iAsString, effect);
                    needUpdate = true;
                }
            }
            if (needUpdate) {
                this._uniformBuffer.update();
            }
            else {
                this._uniformBuffer.bindUniformBuffer();
            }
        }
        /**
         * Returns the string "Light".
         * @returns the class name
         */
        getClassName() {
            return "Light";
        }
        /**
         * Converts the light information to a readable string for debug purpose.
         * @param fullDetails Supports for multiple levels of logging within scene loading
         * @returns the human readable light info
         */
        toString(fullDetails) {
            let ret = "Name: " + this.name;
            ret += ", type: " + ["Point", "Directional", "Spot", "Hemispheric"][this.getTypeID()];
            if (this.animations) {
                for (let i = 0; i < this.animations.length; i++) {
                    ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
                }
            }
            return ret;
        }
        /** @internal */
        _syncParentEnabledState() {
            super._syncParentEnabledState();
            if (!this.isDisposed()) {
                this._resyncMeshes();
            }
        }
        /**
         * Set the enabled state of this node.
         * @param value - the new enabled state
         */
        setEnabled(value) {
            super.setEnabled(value);
            this._resyncMeshes();
        }
        /**
         * Returns the Light associated shadow generator if any.
         * @param camera Camera for which the shadow generator should be retrieved (default: null). If null, retrieves the default shadow generator
         * @returns the associated shadow generator.
         */
        getShadowGenerator(camera = null) {
            var _a;
            if (this._shadowGenerators === null) {
                return null;
            }
            return (_a = this._shadowGenerators.get(camera)) !== null && _a !== void 0 ? _a : null;
        }
        /**
         * Returns all the shadow generators associated to this light
         * @returns
         */
        getShadowGenerators() {
            return this._shadowGenerators;
        }
        /**
         * Returns a Vector3, the absolute light position in the World.
         * @returns the world space position of the light
         */
        getAbsolutePosition() {
            return Vector3.Zero();
        }
        /**
         * Specifies if the light will affect the passed mesh.
         * @param mesh The mesh to test against the light
         * @returns true the mesh is affected otherwise, false.
         */
        canAffectMesh(mesh) {
            if (!mesh) {
                return true;
            }
            if (this.includedOnlyMeshes && this.includedOnlyMeshes.length > 0 && this.includedOnlyMeshes.indexOf(mesh) === -1) {
                return false;
            }
            if (this.excludedMeshes && this.excludedMeshes.length > 0 && this.excludedMeshes.indexOf(mesh) !== -1) {
                return false;
            }
            if (this.includeOnlyWithLayerMask !== 0 && (this.includeOnlyWithLayerMask & mesh.layerMask) === 0) {
                return false;
            }
            if (this.excludeWithLayerMask !== 0 && this.excludeWithLayerMask & mesh.layerMask) {
                return false;
            }
            return true;
        }
        /**
         * Releases resources associated with this node.
         * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
         * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            if (this._shadowGenerators) {
                const iterator = this._shadowGenerators.values();
                for (let key = iterator.next(); key.done !== true; key = iterator.next()) {
                    const shadowGenerator = key.value;
                    shadowGenerator.dispose();
                }
                this._shadowGenerators = null;
            }
            // Animations
            this.getScene().stopAnimation(this);
            if (this._parentContainer) {
                const index = this._parentContainer.lights.indexOf(this);
                if (index > -1) {
                    this._parentContainer.lights.splice(index, 1);
                }
                this._parentContainer = null;
            }
            // Remove from meshes
            for (const mesh of this.getScene().meshes) {
                mesh._removeLightSource(this, true);
            }
            this._uniformBuffer.dispose();
            // Remove from scene
            this.getScene().removeLight(this);
            super.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        /**
         * Returns the light type ID (integer).
         * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
         */
        getTypeID() {
            return 0;
        }
        /**
         * Returns the intensity scaled by the Photometric Scale according to the light type and intensity mode.
         * @returns the scaled intensity in intensity mode unit
         */
        getScaledIntensity() {
            return this._photometricScale * this.intensity;
        }
        /**
         * Returns a new Light object, named "name", from the current one.
         * @param name The name of the cloned light
         * @param newParent The parent of this light, if it has one
         * @returns the new created light
         */
        clone(name, newParent = null) {
            const constructor = Light.GetConstructorFromName(this.getTypeID(), name, this.getScene());
            if (!constructor) {
                return null;
            }
            const clonedLight = SerializationHelper.Clone(constructor, this);
            if (name) {
                clonedLight.name = name;
            }
            if (newParent) {
                clonedLight.parent = newParent;
            }
            clonedLight.setEnabled(this.isEnabled());
            this.onClonedObservable.notifyObservers(clonedLight);
            return clonedLight;
        }
        /**
         * Serializes the current light into a Serialization object.
         * @returns the serialized object.
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this);
            serializationObject.uniqueId = this.uniqueId;
            // Type
            serializationObject.type = this.getTypeID();
            // Parent
            if (this.parent) {
                this.parent._serializeAsParent(serializationObject);
            }
            // Inclusion / exclusions
            if (this.excludedMeshes.length > 0) {
                serializationObject.excludedMeshesIds = [];
                this.excludedMeshes.forEach((mesh) => {
                    serializationObject.excludedMeshesIds.push(mesh.id);
                });
            }
            if (this.includedOnlyMeshes.length > 0) {
                serializationObject.includedOnlyMeshesIds = [];
                this.includedOnlyMeshes.forEach((mesh) => {
                    serializationObject.includedOnlyMeshesIds.push(mesh.id);
                });
            }
            // Animations
            SerializationHelper.AppendSerializedAnimations(this, serializationObject);
            serializationObject.ranges = this.serializeAnimationRanges();
            serializationObject.isEnabled = this.isEnabled();
            return serializationObject;
        }
        /**
         * Creates a new typed light from the passed type (integer) : point light = 0, directional light = 1, spot light = 2, hemispheric light = 3.
         * This new light is named "name" and added to the passed scene.
         * @param type Type according to the types available in Light.LIGHTTYPEID_x
         * @param name The friendly name of the light
         * @param scene The scene the new light will belong to
         * @returns the constructor function
         */
        static GetConstructorFromName(type, name, scene) {
            const constructorFunc = Node.Construct("Light_Type_" + type, name, scene);
            if (constructorFunc) {
                return constructorFunc;
            }
            // Default to no light for none present once.
            return null;
        }
        /**
         * Parses the passed "parsedLight" and returns a new instanced Light from this parsing.
         * @param parsedLight The JSON representation of the light
         * @param scene The scene to create the parsed light in
         * @returns the created light after parsing
         */
        static Parse(parsedLight, scene) {
            const constructor = Light.GetConstructorFromName(parsedLight.type, parsedLight.name, scene);
            if (!constructor) {
                return null;
            }
            const light = SerializationHelper.Parse(constructor, parsedLight, scene);
            // Inclusion / exclusions
            if (parsedLight.excludedMeshesIds) {
                light._excludedMeshesIds = parsedLight.excludedMeshesIds;
            }
            if (parsedLight.includedOnlyMeshesIds) {
                light._includedOnlyMeshesIds = parsedLight.includedOnlyMeshesIds;
            }
            // Parent
            if (parsedLight.parentId !== undefined) {
                light._waitingParentId = parsedLight.parentId;
            }
            if (parsedLight.parentInstanceIndex !== undefined) {
                light._waitingParentInstanceIndex = parsedLight.parentInstanceIndex;
            }
            // Falloff
            if (parsedLight.falloffType !== undefined) {
                light.falloffType = parsedLight.falloffType;
            }
            // Lightmaps
            if (parsedLight.lightmapMode !== undefined) {
                light.lightmapMode = parsedLight.lightmapMode;
            }
            // Animations
            if (parsedLight.animations) {
                for (let animationIndex = 0; animationIndex < parsedLight.animations.length; animationIndex++) {
                    const parsedAnimation = parsedLight.animations[animationIndex];
                    const internalClass = GetClass("BABYLON.Animation");
                    if (internalClass) {
                        light.animations.push(internalClass.Parse(parsedAnimation));
                    }
                }
                Node.ParseAnimationRanges(light, parsedLight, scene);
            }
            if (parsedLight.autoAnimate) {
                scene.beginAnimation(light, parsedLight.autoAnimateFrom, parsedLight.autoAnimateTo, parsedLight.autoAnimateLoop, parsedLight.autoAnimateSpeed || 1.0);
            }
            // Check if isEnabled is defined to be back compatible with prior serialized versions.
            if (parsedLight.isEnabled !== undefined) {
                light.setEnabled(parsedLight.isEnabled);
            }
            return light;
        }
        _hookArrayForExcluded(array) {
            const oldPush = array.push;
            array.push = (...items) => {
                const result = oldPush.apply(array, items);
                for (const item of items) {
                    item._resyncLightSource(this);
                }
                return result;
            };
            const oldSplice = array.splice;
            array.splice = (index, deleteCount) => {
                const deleted = oldSplice.apply(array, [index, deleteCount]);
                for (const item of deleted) {
                    item._resyncLightSource(this);
                }
                return deleted;
            };
            for (const item of array) {
                item._resyncLightSource(this);
            }
        }
        _hookArrayForIncludedOnly(array) {
            const oldPush = array.push;
            array.push = (...items) => {
                const result = oldPush.apply(array, items);
                this._resyncMeshes();
                return result;
            };
            const oldSplice = array.splice;
            array.splice = (index, deleteCount) => {
                const deleted = oldSplice.apply(array, [index, deleteCount]);
                this._resyncMeshes();
                return deleted;
            };
            this._resyncMeshes();
        }
        _resyncMeshes() {
            for (const mesh of this.getScene().meshes) {
                mesh._resyncLightSource(this);
            }
        }
        /**
         * Forces the meshes to update their light related information in their rendering used effects
         * @internal Internal Use Only
         */
        _markMeshesAsLightDirty() {
            for (const mesh of this.getScene().meshes) {
                if (mesh.lightSources.indexOf(this) !== -1) {
                    mesh._markSubMeshesAsLightDirty();
                }
            }
        }
        /**
         * Recomputes the cached photometric scale if needed.
         */
        _computePhotometricScale() {
            this._photometricScale = this._getPhotometricScale();
            this.getScene().resetCachedMaterial();
        }
        /**
         * Returns the Photometric Scale according to the light type and intensity mode.
         */
        _getPhotometricScale() {
            let photometricScale = 0.0;
            const lightTypeID = this.getTypeID();
            //get photometric mode
            let photometricMode = this.intensityMode;
            if (photometricMode === Light.INTENSITYMODE_AUTOMATIC) {
                if (lightTypeID === Light.LIGHTTYPEID_DIRECTIONALLIGHT) {
                    photometricMode = Light.INTENSITYMODE_ILLUMINANCE;
                }
                else {
                    photometricMode = Light.INTENSITYMODE_LUMINOUSINTENSITY;
                }
            }
            //compute photometric scale
            switch (lightTypeID) {
                case Light.LIGHTTYPEID_POINTLIGHT:
                case Light.LIGHTTYPEID_SPOTLIGHT:
                    switch (photometricMode) {
                        case Light.INTENSITYMODE_LUMINOUSPOWER:
                            photometricScale = 1.0 / (4.0 * Math.PI);
                            break;
                        case Light.INTENSITYMODE_LUMINOUSINTENSITY:
                            photometricScale = 1.0;
                            break;
                        case Light.INTENSITYMODE_LUMINANCE:
                            photometricScale = this.radius * this.radius;
                            break;
                    }
                    break;
                case Light.LIGHTTYPEID_DIRECTIONALLIGHT:
                    switch (photometricMode) {
                        case Light.INTENSITYMODE_ILLUMINANCE:
                            photometricScale = 1.0;
                            break;
                        case Light.INTENSITYMODE_LUMINANCE: {
                            // When radius (and therefore solid angle) is non-zero a directional lights brightness can be specified via central (peak) luminance.
                            // For a directional light the 'radius' defines the angular radius (in radians) rather than world-space radius (e.g. in metres).
                            let apexAngleRadians = this.radius;
                            // Impose a minimum light angular size to avoid the light becoming an infinitely small angular light source (i.e. a dirac delta function).
                            apexAngleRadians = Math.max(apexAngleRadians, 0.001);
                            const solidAngle = 2.0 * Math.PI * (1.0 - Math.cos(apexAngleRadians));
                            photometricScale = solidAngle;
                            break;
                        }
                    }
                    break;
                case Light.LIGHTTYPEID_HEMISPHERICLIGHT:
                    // No fall off in hemispheric light.
                    photometricScale = 1.0;
                    break;
            }
            return photometricScale;
        }
        /**
         * Reorder the light in the scene according to their defined priority.
         * @internal Internal Use Only
         */
        _reorderLightsInScene() {
            const scene = this.getScene();
            if (this._renderPriority != 0) {
                scene.requireLightSorting = true;
            }
            this.getScene().sortLightsByPriority();
        }
    }
    /**
     * Falloff Default: light is falling off following the material specification:
     * standard material is using standard falloff whereas pbr material can request special falloff per materials.
     */
    Light.FALLOFF_DEFAULT = LightConstants.FALLOFF_DEFAULT;
    /**
     * Falloff Physical: light is falling off following the inverse squared distance law.
     */
    Light.FALLOFF_PHYSICAL = LightConstants.FALLOFF_PHYSICAL;
    /**
     * Falloff gltf: light is falling off as described in the gltf moving to PBR document
     * to enhance interoperability with other engines.
     */
    Light.FALLOFF_GLTF = LightConstants.FALLOFF_GLTF;
    /**
     * Falloff Standard: light is falling off like in the standard material
     * to enhance interoperability with other materials.
     */
    Light.FALLOFF_STANDARD = LightConstants.FALLOFF_STANDARD;
    //lightmapMode Consts
    /**
     * If every light affecting the material is in this lightmapMode,
     * material.lightmapTexture adds or multiplies
     * (depends on material.useLightmapAsShadowmap)
     * after every other light calculations.
     */
    Light.LIGHTMAP_DEFAULT = LightConstants.LIGHTMAP_DEFAULT;
    /**
     * material.lightmapTexture as only diffuse lighting from this light
     * adds only specular lighting from this light
     * adds dynamic shadows
     */
    Light.LIGHTMAP_SPECULAR = LightConstants.LIGHTMAP_SPECULAR;
    /**
     * material.lightmapTexture as only lighting
     * no light calculation from this light
     * only adds dynamic shadows from this light
     */
    Light.LIGHTMAP_SHADOWSONLY = LightConstants.LIGHTMAP_SHADOWSONLY;
    // Intensity Mode Consts
    /**
     * Each light type uses the default quantity according to its type:
     *      point/spot lights use luminous intensity
     *      directional lights use illuminance
     */
    Light.INTENSITYMODE_AUTOMATIC = LightConstants.INTENSITYMODE_AUTOMATIC;
    /**
     * lumen (lm)
     */
    Light.INTENSITYMODE_LUMINOUSPOWER = LightConstants.INTENSITYMODE_LUMINOUSPOWER;
    /**
     * candela (lm/sr)
     */
    Light.INTENSITYMODE_LUMINOUSINTENSITY = LightConstants.INTENSITYMODE_LUMINOUSINTENSITY;
    /**
     * lux (lm/m^2)
     */
    Light.INTENSITYMODE_ILLUMINANCE = LightConstants.INTENSITYMODE_ILLUMINANCE;
    /**
     * nit (cd/m^2)
     */
    Light.INTENSITYMODE_LUMINANCE = LightConstants.INTENSITYMODE_LUMINANCE;
    // Light types ids const.
    /**
     * Light type const id of the point light.
     */
    Light.LIGHTTYPEID_POINTLIGHT = LightConstants.LIGHTTYPEID_POINTLIGHT;
    /**
     * Light type const id of the directional light.
     */
    Light.LIGHTTYPEID_DIRECTIONALLIGHT = LightConstants.LIGHTTYPEID_DIRECTIONALLIGHT;
    /**
     * Light type const id of the spot light.
     */
    Light.LIGHTTYPEID_SPOTLIGHT = LightConstants.LIGHTTYPEID_SPOTLIGHT;
    /**
     * Light type const id of the hemispheric light.
     */
    Light.LIGHTTYPEID_HEMISPHERICLIGHT = LightConstants.LIGHTTYPEID_HEMISPHERICLIGHT;
    __decorate$1([
        serializeAsColor3()
    ], Light.prototype, "diffuse", void 0);
    __decorate$1([
        serializeAsColor3()
    ], Light.prototype, "specular", void 0);
    __decorate$1([
        serialize()
    ], Light.prototype, "falloffType", void 0);
    __decorate$1([
        serialize()
    ], Light.prototype, "intensity", void 0);
    __decorate$1([
        serialize()
    ], Light.prototype, "range", null);
    __decorate$1([
        serialize()
    ], Light.prototype, "intensityMode", null);
    __decorate$1([
        serialize()
    ], Light.prototype, "radius", null);
    __decorate$1([
        serialize()
    ], Light.prototype, "_renderPriority", void 0);
    __decorate$1([
        expandToProperty("_reorderLightsInScene")
    ], Light.prototype, "renderPriority", void 0);
    __decorate$1([
        serialize("shadowEnabled")
    ], Light.prototype, "_shadowEnabled", void 0);
    __decorate$1([
        serialize("excludeWithLayerMask")
    ], Light.prototype, "_excludeWithLayerMask", void 0);
    __decorate$1([
        serialize("includeOnlyWithLayerMask")
    ], Light.prototype, "_includeOnlyWithLayerMask", void 0);
    __decorate$1([
        serialize("lightmapMode")
    ], Light.prototype, "_lightmapMode", void 0);

    Node.AddNodeConstructor("Light_Type_3", (name, scene) => {
        return () => new HemisphericLight(name, Vector3.Zero(), scene);
    });
    /**
     * The HemisphericLight simulates the ambient environment light,
     * so the passed direction is the light reflection direction, not the incoming direction.
     */
    class HemisphericLight extends Light {
        /**
         * Creates a HemisphericLight object in the scene according to the passed direction (Vector3).
         * The HemisphericLight simulates the ambient environment light, so the passed direction is the light reflection direction, not the incoming direction.
         * The HemisphericLight can't cast shadows.
         * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         * @param name The friendly name of the light
         * @param direction The direction of the light reflection
         * @param scene The scene the light belongs to
         */
        constructor(name, direction, scene) {
            super(name, scene);
            /**
             * The groundColor is the light in the opposite direction to the one specified during creation.
             * You can think of the diffuse and specular light as coming from the centre of the object in the given direction and the groundColor light in the opposite direction.
             */
            this.groundColor = new Color3(0.0, 0.0, 0.0);
            this.direction = direction || Vector3.Up();
        }
        _buildUniformLayout() {
            this._uniformBuffer.addUniform("vLightData", 4);
            this._uniformBuffer.addUniform("vLightDiffuse", 4);
            this._uniformBuffer.addUniform("vLightSpecular", 4);
            this._uniformBuffer.addUniform("vLightGround", 3);
            this._uniformBuffer.addUniform("shadowsInfo", 3);
            this._uniformBuffer.addUniform("depthValues", 2);
            this._uniformBuffer.create();
        }
        /**
         * Returns the string "HemisphericLight".
         * @returns The class name
         */
        getClassName() {
            return "HemisphericLight";
        }
        /**
         * Sets the HemisphericLight direction towards the passed target (Vector3).
         * Returns the updated direction.
         * @param target The target the direction should point to
         * @returns The computed direction
         */
        setDirectionToTarget(target) {
            this.direction = Vector3.Normalize(target.subtract(Vector3.Zero()));
            return this.direction;
        }
        /**
         * Returns the shadow generator associated to the light.
         * @returns Always null for hemispheric lights because it does not support shadows.
         */
        getShadowGenerator() {
            return null;
        }
        /**
         * Sets the passed Effect object with the HemisphericLight normalized direction and color and the passed name (string).
         * @param _effect The effect to update
         * @param lightIndex The index of the light in the effect to update
         * @returns The hemispheric light
         */
        transferToEffect(_effect, lightIndex) {
            const normalizeDirection = Vector3.Normalize(this.direction);
            this._uniformBuffer.updateFloat4("vLightData", normalizeDirection.x, normalizeDirection.y, normalizeDirection.z, 0.0, lightIndex);
            this._uniformBuffer.updateColor3("vLightGround", this.groundColor.scale(this.intensity), lightIndex);
            return this;
        }
        transferToNodeMaterialEffect(effect, lightDataUniformName) {
            const normalizeDirection = Vector3.Normalize(this.direction);
            effect.setFloat3(lightDataUniformName, normalizeDirection.x, normalizeDirection.y, normalizeDirection.z);
            return this;
        }
        /**
         * Computes the world matrix of the node
         * @returns the world matrix
         */
        computeWorldMatrix() {
            if (!this._worldMatrix) {
                this._worldMatrix = Matrix.Identity();
            }
            return this._worldMatrix;
        }
        /**
         * Returns the integer 3.
         * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
         */
        getTypeID() {
            return Light.LIGHTTYPEID_HEMISPHERICLIGHT;
        }
        /**
         * Prepares the list of defines specific to the light type.
         * @param defines the list of defines
         * @param lightIndex defines the index of the light for the effect
         */
        prepareLightSpecificDefines(defines, lightIndex) {
            defines["HEMILIGHT" + lightIndex] = true;
        }
    }
    __decorate$1([
        serializeAsColor3()
    ], HemisphericLight.prototype, "groundColor", void 0);
    __decorate$1([
        serializeAsVector3()
    ], HemisphericLight.prototype, "direction", void 0);

    // Do not edit.
    const name$1H = "kernelBlurVaryingDeclaration";
    const shader$1H = `varying vec2 sampleCoord{X};`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1H] = shader$1H;

    // Do not edit.
    const name$1I = "packingFunctions";
    const shader$1I = `vec4 pack(float depth)
{const vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const vec4 bit_mask=vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1I] = shader$1I;

    // Do not edit.
    const name$1J = "kernelBlurFragment";
    const shader$1J = `#ifdef DOF
factor=sampleCoC(sampleCoord{X}); 
computedWeight=KERNEL_WEIGHT{X}*factor;sumOfWeights+=computedWeight;
#else
computedWeight=KERNEL_WEIGHT{X};
#endif
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCoord{X}))*computedWeight;
#else
blend+=texture2D(textureSampler,sampleCoord{X})*computedWeight;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1J] = shader$1J;

    // Do not edit.
    const name$1K = "kernelBlurFragment2";
    const shader$1K = `#ifdef DOF
factor=sampleCoC(sampleCenter+delta*KERNEL_DEP_OFFSET{X});computedWeight=KERNEL_DEP_WEIGHT{X}*factor;sumOfWeights+=computedWeight;
#else
computedWeight=KERNEL_DEP_WEIGHT{X};
#endif
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter+delta*KERNEL_DEP_OFFSET{X}))*computedWeight;
#else
blend+=texture2D(textureSampler,sampleCenter+delta*KERNEL_DEP_OFFSET{X})*computedWeight;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1K] = shader$1K;

    // Do not edit.
    const name$1L = "kernelBlurPixelShader";
    const shader$1L = `uniform sampler2D textureSampler;uniform vec2 delta;varying vec2 sampleCenter;
#ifdef DOF
uniform sampler2D circleOfConfusionSampler;float sampleCoC(in vec2 offset) {float coc=texture2D(circleOfConfusionSampler,offset).r;return coc; }
#endif
#include<kernelBlurVaryingDeclaration>[0..varyingCount]
#ifdef PACKEDFLOAT
#include<packingFunctions>
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float computedWeight=0.0;
#ifdef PACKEDFLOAT
float blend=0.;
#else
vec4 blend=vec4(0.);
#endif
#ifdef DOF
float sumOfWeights=CENTER_WEIGHT; 
float factor=0.0;
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter))*CENTER_WEIGHT;
#else
blend+=texture2D(textureSampler,sampleCenter)*CENTER_WEIGHT;
#endif
#endif
#include<kernelBlurFragment>[0..varyingCount]
#include<kernelBlurFragment2>[0..depCount]
#ifdef PACKEDFLOAT
gl_FragColor=pack(blend);
#else
gl_FragColor=blend;
#endif
#ifdef DOF
gl_FragColor/=sumOfWeights;
#endif
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1L] = shader$1L;

    // Do not edit.
    const name$1M = "kernelBlurVertex";
    const shader$1M = `sampleCoord{X}=sampleCenter+delta*KERNEL_OFFSET{X};`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1M] = shader$1M;

    // Do not edit.
    const name$1N = "kernelBlurVertexShader";
    const shader$1N = `attribute vec2 position;uniform vec2 delta;varying vec2 sampleCenter;
#include<kernelBlurVaryingDeclaration>[0..varyingCount]
const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
sampleCenter=(position*madd+madd);
#include<kernelBlurVertex>[0..varyingCount]
gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1N] = shader$1N;

    /**
     * The Blur Post Process which blurs an image based on a kernel and direction.
     * Can be used twice in x and y directions to perform a gaussian blur in two passes.
     */
    class BlurPostProcess extends PostProcess {
        /**
         * Sets the length in pixels of the blur sample region
         */
        set kernel(v) {
            if (this._idealKernel === v) {
                return;
            }
            v = Math.max(v, 1);
            this._idealKernel = v;
            this._kernel = this._nearestBestKernel(v);
            if (!this._blockCompilation) {
                this._updateParameters();
            }
        }
        /**
         * Gets the length in pixels of the blur sample region
         */
        get kernel() {
            return this._idealKernel;
        }
        /**
         * Sets whether or not the blur needs to unpack/repack floats
         */
        set packedFloat(v) {
            if (this._packedFloat === v) {
                return;
            }
            this._packedFloat = v;
            if (!this._blockCompilation) {
                this._updateParameters();
            }
        }
        /**
         * Gets whether or not the blur is unpacking/repacking floats
         */
        get packedFloat() {
            return this._packedFloat;
        }
        /**
         * Gets a string identifying the name of the class
         * @returns "BlurPostProcess" string
         */
        getClassName() {
            return "BlurPostProcess";
        }
        /**
         * Creates a new instance BlurPostProcess
         * @param name The name of the effect.
         * @param direction The direction in which to blur the image.
         * @param kernel The size of the kernel to be used when computing the blur. eg. Size of 3 will blur the center pixel by 2 pixels surrounding it.
         * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
         * @param camera The camera to apply the render pass to.
         * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
         * @param engine The engine which the post process will be applied. (default: current engine)
         * @param reusable If the post process can be reused on the same frame. (default: false)
         * @param textureType Type of textures used when performing the post process. (default: 0)
         * @param defines
         * @param _blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
         * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
         */
        constructor(name, direction, kernel, options, camera, samplingMode = Texture.BILINEAR_SAMPLINGMODE, engine, reusable, textureType = 0, defines = "", _blockCompilation = false, textureFormat = 5) {
            super(name, "kernelBlur", ["delta", "direction"], ["circleOfConfusionSampler"], options, camera, samplingMode, engine, reusable, null, textureType, "kernelBlur", { varyingCount: 0, depCount: 0 }, true, textureFormat);
            this._blockCompilation = _blockCompilation;
            this._packedFloat = false;
            this._staticDefines = "";
            this._staticDefines = defines;
            this.direction = direction;
            this.onApplyObservable.add((effect) => {
                if (this._outputTexture) {
                    effect.setFloat2("delta", (1 / this._outputTexture.width) * this.direction.x, (1 / this._outputTexture.height) * this.direction.y);
                }
                else {
                    effect.setFloat2("delta", (1 / this.width) * this.direction.x, (1 / this.height) * this.direction.y);
                }
            });
            this.kernel = kernel;
        }
        /**
         * Updates the effect with the current post process compile time values and recompiles the shader.
         * @param defines Define statements that should be added at the beginning of the shader. (default: null)
         * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
         * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
         * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
         * @param onCompiled Called when the shader has been compiled.
         * @param onError Called if there is an error when compiling a shader.
         */
        updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError) {
            this._updateParameters(onCompiled, onError);
        }
        _updateParameters(onCompiled, onError) {
            // Generate sampling offsets and weights
            const N = this._kernel;
            const centerIndex = (N - 1) / 2;
            // Generate Gaussian sampling weights over kernel
            let offsets = [];
            let weights = [];
            let totalWeight = 0;
            for (let i = 0; i < N; i++) {
                const u = i / (N - 1);
                const w = this._gaussianWeight(u * 2.0 - 1);
                offsets[i] = i - centerIndex;
                weights[i] = w;
                totalWeight += w;
            }
            // Normalize weights
            for (let i = 0; i < weights.length; i++) {
                weights[i] /= totalWeight;
            }
            // Optimize: combine samples to take advantage of hardware linear sampling
            // Walk from left to center, combining pairs (symmetrically)
            const linearSamplingWeights = [];
            const linearSamplingOffsets = [];
            const linearSamplingMap = [];
            for (let i = 0; i <= centerIndex; i += 2) {
                const j = Math.min(i + 1, Math.floor(centerIndex));
                const singleCenterSample = i === j;
                if (singleCenterSample) {
                    linearSamplingMap.push({ o: offsets[i], w: weights[i] });
                }
                else {
                    const sharedCell = j === centerIndex;
                    const weightLinear = weights[i] + weights[j] * (sharedCell ? 0.5 : 1);
                    const offsetLinear = offsets[i] + 1 / (1 + weights[i] / weights[j]);
                    if (offsetLinear === 0) {
                        linearSamplingMap.push({ o: offsets[i], w: weights[i] });
                        linearSamplingMap.push({ o: offsets[i + 1], w: weights[i + 1] });
                    }
                    else {
                        linearSamplingMap.push({ o: offsetLinear, w: weightLinear });
                        linearSamplingMap.push({ o: -offsetLinear, w: weightLinear });
                    }
                }
            }
            for (let i = 0; i < linearSamplingMap.length; i++) {
                linearSamplingOffsets[i] = linearSamplingMap[i].o;
                linearSamplingWeights[i] = linearSamplingMap[i].w;
            }
            // Replace with optimized
            offsets = linearSamplingOffsets;
            weights = linearSamplingWeights;
            // Generate shaders
            const maxVaryingRows = this.getEngine().getCaps().maxVaryingVectors;
            const freeVaryingVec2 = Math.max(maxVaryingRows, 0) - 1; // Because of sampleCenter
            let varyingCount = Math.min(offsets.length, freeVaryingVec2);
            let defines = "";
            defines += this._staticDefines;
            // The DOF fragment should ignore the center pixel when looping as it is handled manually in the fragment shader.
            if (this._staticDefines.indexOf("DOF") != -1) {
                defines += `#define CENTER_WEIGHT ${this._glslFloat(weights[varyingCount - 1])}\n`;
                varyingCount--;
            }
            for (let i = 0; i < varyingCount; i++) {
                defines += `#define KERNEL_OFFSET${i} ${this._glslFloat(offsets[i])}\n`;
                defines += `#define KERNEL_WEIGHT${i} ${this._glslFloat(weights[i])}\n`;
            }
            let depCount = 0;
            for (let i = freeVaryingVec2; i < offsets.length; i++) {
                defines += `#define KERNEL_DEP_OFFSET${depCount} ${this._glslFloat(offsets[i])}\n`;
                defines += `#define KERNEL_DEP_WEIGHT${depCount} ${this._glslFloat(weights[i])}\n`;
                depCount++;
            }
            if (this.packedFloat) {
                defines += `#define PACKEDFLOAT 1`;
            }
            this._blockCompilation = false;
            super.updateEffect(defines, null, null, {
                varyingCount: varyingCount,
                depCount: depCount,
            }, onCompiled, onError);
        }
        /**
         * Best kernels are odd numbers that when divided by 2, their integer part is even, so 5, 9 or 13.
         * Other odd kernels optimize correctly but require proportionally more samples, even kernels are
         * possible but will produce minor visual artifacts. Since each new kernel requires a new shader we
         * want to minimize kernel changes, having gaps between physical kernels is helpful in that regard.
         * The gaps between physical kernels are compensated for in the weighting of the samples
         * @param idealKernel Ideal blur kernel.
         * @returns Nearest best kernel.
         */
        _nearestBestKernel(idealKernel) {
            const v = Math.round(idealKernel);
            for (const k of [v, v - 1, v + 1, v - 2, v + 2]) {
                if (k % 2 !== 0 && Math.floor(k / 2) % 2 === 0 && k > 0) {
                    return Math.max(k, 3);
                }
            }
            return Math.max(v, 3);
        }
        /**
         * Calculates the value of a Gaussian distribution with sigma 3 at a given point.
         * @param x The point on the Gaussian distribution to sample.
         * @returns the value of the Gaussian function at x.
         */
        _gaussianWeight(x) {
            //reference: Engines/ImageProcessingBlur.cpp #dcc760
            // We are evaluating the Gaussian (normal) distribution over a kernel parameter space of [-1,1],
            // so we truncate at three standard deviations by setting stddev (sigma) to 1/3.
            // The choice of 3-sigma truncation is common but arbitrary, and means that the signal is
            // truncated at around 1.3% of peak strength.
            //the distribution is scaled to account for the difference between the actual kernel size and the requested kernel size
            const sigma = 1 / 3;
            const denominator = Math.sqrt(2.0 * Math.PI) * sigma;
            const exponent = -((x * x) / (2.0 * sigma * sigma));
            const weight = (1.0 / denominator) * Math.exp(exponent);
            return weight;
        }
        /**
         * Generates a string that can be used as a floating point number in GLSL.
         * @param x Value to print.
         * @param decimalFigures Number of decimal places to print the number to (excluding trailing 0s).
         * @returns GLSL float string.
         */
        _glslFloat(x, decimalFigures = 8) {
            return x.toFixed(decimalFigures).replace(/0+$/, "");
        }
        /**
         * @internal
         */
        static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
            return SerializationHelper.Parse(() => {
                return new BlurPostProcess(parsedPostProcess.name, parsedPostProcess.direction, parsedPostProcess.kernel, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, undefined, false);
            }, parsedPostProcess, scene, rootUrl);
        }
    }
    __decorate$1([
        serialize("kernel")
    ], BlurPostProcess.prototype, "_kernel", void 0);
    __decorate$1([
        serialize("packedFloat")
    ], BlurPostProcess.prototype, "_packedFloat", void 0);
    __decorate$1([
        serializeAsVector2()
    ], BlurPostProcess.prototype, "direction", void 0);
    RegisterClass("BABYLON.BlurPostProcess", BlurPostProcess);

    /**
     * Mirror texture can be used to simulate the view from a mirror in a scene.
     * It will dynamically be rendered every frame to adapt to the camera point of view.
     * You can then easily use it as a reflectionTexture on a flat surface.
     * In case the surface is not a plane, please consider relying on reflection probes.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#mirrortexture
     */
    class MirrorTexture extends RenderTargetTexture {
        /**
         * Define the blur ratio used to blur the reflection if needed.
         */
        set blurRatio(value) {
            if (this._blurRatio === value) {
                return;
            }
            this._blurRatio = value;
            this._preparePostProcesses();
        }
        get blurRatio() {
            return this._blurRatio;
        }
        /**
         * Define the adaptive blur kernel used to blur the reflection if needed.
         * This will autocompute the closest best match for the `blurKernel`
         */
        set adaptiveBlurKernel(value) {
            this._adaptiveBlurKernel = value;
            this._autoComputeBlurKernel();
        }
        /**
         * Define the blur kernel used to blur the reflection if needed.
         * Please consider using `adaptiveBlurKernel` as it could find the closest best value for you.
         */
        set blurKernel(value) {
            this.blurKernelX = value;
            this.blurKernelY = value;
        }
        /**
         * Define the blur kernel on the X Axis used to blur the reflection if needed.
         * Please consider using `adaptiveBlurKernel` as it could find the closest best value for you.
         */
        set blurKernelX(value) {
            if (this._blurKernelX === value) {
                return;
            }
            this._blurKernelX = value;
            this._preparePostProcesses();
        }
        get blurKernelX() {
            return this._blurKernelX;
        }
        /**
         * Define the blur kernel on the Y Axis used to blur the reflection if needed.
         * Please consider using `adaptiveBlurKernel` as it could find the closest best value for you.
         */
        set blurKernelY(value) {
            if (this._blurKernelY === value) {
                return;
            }
            this._blurKernelY = value;
            this._preparePostProcesses();
        }
        get blurKernelY() {
            return this._blurKernelY;
        }
        _autoComputeBlurKernel() {
            const engine = this.getScene().getEngine();
            const dw = this.getRenderWidth() / engine.getRenderWidth();
            const dh = this.getRenderHeight() / engine.getRenderHeight();
            this.blurKernelX = this._adaptiveBlurKernel * dw;
            this.blurKernelY = this._adaptiveBlurKernel * dh;
        }
        _onRatioRescale() {
            if (this._sizeRatio) {
                this.resize(this._initialSizeParameter);
                if (!this._adaptiveBlurKernel) {
                    this._preparePostProcesses();
                }
            }
            if (this._adaptiveBlurKernel) {
                this._autoComputeBlurKernel();
            }
        }
        _updateGammaSpace() {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            this.gammaSpace = !scene.imageProcessingConfiguration.isEnabled || !scene.imageProcessingConfiguration.applyByPostProcess;
        }
        /**
         * Instantiates a Mirror Texture.
         * Mirror texture can be used to simulate the view from a mirror in a scene.
         * It will dynamically be rendered every frame to adapt to the camera point of view.
         * You can then easily use it as a reflectionTexture on a flat surface.
         * In case the surface is not a plane, please consider relying on reflection probes.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#mirrors
         * @param name
         * @param size
         * @param scene
         * @param generateMipMaps
         * @param type
         * @param samplingMode
         * @param generateDepthBuffer
         */
        constructor(name, size, scene, generateMipMaps, type = 0, samplingMode = Texture.BILINEAR_SAMPLINGMODE, generateDepthBuffer = true) {
            super(name, size, scene, generateMipMaps, true, type, false, samplingMode, generateDepthBuffer);
            /**
             * Define the reflection plane we want to use. The mirrorPlane is usually set to the constructed reflector.
             * It is possible to directly set the mirrorPlane by directly using a Plane(a, b, c, d) where a, b and c give the plane normal vector (a, b, c) and d is a scalar displacement from the mirrorPlane to the origin. However in all but the very simplest of situations it is more straight forward to set it to the reflector as stated in the doc.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#mirrors
             */
            this.mirrorPlane = new Plane(0, 1, 0, 1);
            this._transformMatrix = Matrix.Zero();
            this._mirrorMatrix = Matrix.Zero();
            this._adaptiveBlurKernel = 0;
            this._blurKernelX = 0;
            this._blurKernelY = 0;
            this._blurRatio = 1.0;
            scene = this.getScene();
            if (!scene) {
                return this;
            }
            this.ignoreCameraViewport = true;
            this._updateGammaSpace();
            this._imageProcessingConfigChangeObserver = scene.imageProcessingConfiguration.onUpdateParameters.add(() => {
                this._updateGammaSpace();
            });
            const engine = scene.getEngine();
            if (engine.supportsUniformBuffers) {
                this._sceneUBO = scene.createSceneUniformBuffer(`Scene for Mirror Texture (name "${name}")`);
            }
            this.onBeforeBindObservable.add(() => {
                var _a;
                (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, `mirror generation for ${name}`, 1);
            });
            this.onAfterUnbindObservable.add(() => {
                var _a;
                (_a = engine._debugPopGroup) === null || _a === void 0 ? void 0 : _a.call(engine, 1);
            });
            let saveClipPlane;
            this.onBeforeRenderObservable.add(() => {
                if (this._sceneUBO) {
                    this._currentSceneUBO = scene.getSceneUniformBuffer();
                    scene.setSceneUniformBuffer(this._sceneUBO);
                    scene.getSceneUniformBuffer().unbindEffect();
                }
                Matrix.ReflectionToRef(this.mirrorPlane, this._mirrorMatrix);
                this._mirrorMatrix.multiplyToRef(scene.getViewMatrix(), this._transformMatrix);
                scene.setTransformMatrix(this._transformMatrix, scene.getProjectionMatrix());
                saveClipPlane = scene.clipPlane;
                scene.clipPlane = this.mirrorPlane;
                scene._mirroredCameraPosition = Vector3.TransformCoordinates(scene.activeCamera.globalPosition, this._mirrorMatrix);
            });
            this.onAfterRenderObservable.add(() => {
                if (this._sceneUBO) {
                    scene.setSceneUniformBuffer(this._currentSceneUBO);
                }
                scene.updateTransformMatrix();
                scene._mirroredCameraPosition = null;
                scene.clipPlane = saveClipPlane;
            });
        }
        _preparePostProcesses() {
            this.clearPostProcesses(true);
            if (this._blurKernelX && this._blurKernelY) {
                const engine = this.getScene().getEngine();
                const textureType = engine.getCaps().textureFloatRender && engine.getCaps().textureFloatLinearFiltering ? 1 : 2;
                this._blurX = new BlurPostProcess("horizontal blur", new Vector2(1.0, 0), this._blurKernelX, this._blurRatio, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, textureType);
                this._blurX.autoClear = false;
                if (this._blurRatio === 1 && this.samples < 2 && this._texture) {
                    this._blurX.inputTexture = this._renderTarget;
                }
                else {
                    this._blurX.alwaysForcePOT = true;
                }
                this._blurY = new BlurPostProcess("vertical blur", new Vector2(0, 1.0), this._blurKernelY, this._blurRatio, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, textureType);
                this._blurY.autoClear = false;
                this._blurY.alwaysForcePOT = this._blurRatio !== 1;
                this.addPostProcess(this._blurX);
                this.addPostProcess(this._blurY);
            }
            else {
                if (this._blurY) {
                    this.removePostProcess(this._blurY);
                    this._blurY.dispose();
                    this._blurY = null;
                }
                if (this._blurX) {
                    this.removePostProcess(this._blurX);
                    this._blurX.dispose();
                    this._blurX = null;
                }
            }
        }
        /**
         * Clone the mirror texture.
         * @returns the cloned texture
         */
        clone() {
            const scene = this.getScene();
            if (!scene) {
                return this;
            }
            const textureSize = this.getSize();
            const newTexture = new MirrorTexture(this.name, textureSize.width, scene, this._renderTargetOptions.generateMipMaps, this._renderTargetOptions.type, this._renderTargetOptions.samplingMode, this._renderTargetOptions.generateDepthBuffer);
            // Base texture
            newTexture.hasAlpha = this.hasAlpha;
            newTexture.level = this.level;
            // Mirror Texture
            newTexture.mirrorPlane = this.mirrorPlane.clone();
            if (this.renderList) {
                newTexture.renderList = this.renderList.slice(0);
            }
            return newTexture;
        }
        /**
         * Serialize the texture to a JSON representation you could use in Parse later on
         * @returns the serialized JSON representation
         */
        serialize() {
            if (!this.name) {
                return null;
            }
            const serializationObject = super.serialize();
            serializationObject.mirrorPlane = this.mirrorPlane.asArray();
            return serializationObject;
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            var _a;
            super.dispose();
            const scene = this.getScene();
            if (scene) {
                scene.imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingConfigChangeObserver);
            }
            (_a = this._sceneUBO) === null || _a === void 0 ? void 0 : _a.dispose();
        }
    }
    Texture._CreateMirror = (name, renderTargetSize, scene, generateMipMaps) => {
        return new MirrorTexture(name, renderTargetSize, scene, generateMipMaps);
    };

    ThinEngine.prototype._createDepthStencilCubeTexture = function (size, options, rtWrapper) {
        const internalTexture = new InternalTexture(this, InternalTextureSource.DepthStencil);
        internalTexture.isCube = true;
        if (this.webGLVersion === 1) {
            Logger.Error("Depth cube texture is not supported by WebGL 1.");
            return internalTexture;
        }
        const internalOptions = Object.assign({ bilinearFiltering: false, comparisonFunction: 0, generateStencil: false }, options);
        const gl = this._gl;
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, internalTexture, true);
        this._setupDepthStencilTexture(internalTexture, size, internalOptions.generateStencil, internalOptions.bilinearFiltering, internalOptions.comparisonFunction);
        rtWrapper._depthStencilTexture = internalTexture;
        rtWrapper._depthStencilTextureWithStencil = internalOptions.generateStencil;
        // Create the depth/stencil buffer
        for (let face = 0; face < 6; face++) {
            if (internalOptions.generateStencil) {
                gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, gl.DEPTH24_STENCIL8, size, size, 0, gl.DEPTH_STENCIL, gl.UNSIGNED_INT_24_8, null);
            }
            else {
                gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, gl.DEPTH_COMPONENT24, size, size, 0, gl.DEPTH_COMPONENT, gl.UNSIGNED_INT, null);
            }
        }
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
        this._internalTexturesCache.push(internalTexture);
        return internalTexture;
    };
    ThinEngine.prototype._partialLoadFile = function (url, index, loadedFiles, onfinish, onErrorCallBack = null) {
        const onload = (data) => {
            loadedFiles[index] = data;
            loadedFiles._internalCount++;
            if (loadedFiles._internalCount === 6) {
                onfinish(loadedFiles);
            }
        };
        const onerror = (request, exception) => {
            if (onErrorCallBack && request) {
                onErrorCallBack(request.status + " " + request.statusText, exception);
            }
        };
        this._loadFile(url, onload, undefined, undefined, true, onerror);
    };
    ThinEngine.prototype._cascadeLoadFiles = function (scene, onfinish, files, onError = null) {
        const loadedFiles = [];
        loadedFiles._internalCount = 0;
        for (let index = 0; index < 6; index++) {
            this._partialLoadFile(files[index], index, loadedFiles, onfinish, onError);
        }
    };
    ThinEngine.prototype._cascadeLoadImgs = function (scene, texture, onfinish, files, onError = null, mimeType) {
        const loadedImages = [];
        loadedImages._internalCount = 0;
        for (let index = 0; index < 6; index++) {
            this._partialLoadImg(files[index], index, loadedImages, scene, texture, onfinish, onError, mimeType);
        }
    };
    ThinEngine.prototype._partialLoadImg = function (url, index, loadedImages, scene, texture, onfinish, onErrorCallBack = null, mimeType) {
        const tokenPendingData = RandomGUID();
        const onload = (img) => {
            loadedImages[index] = img;
            loadedImages._internalCount++;
            if (scene) {
                scene.removePendingData(tokenPendingData);
            }
            if (loadedImages._internalCount === 6 && onfinish) {
                onfinish(texture, loadedImages);
            }
        };
        const onerror = (message, exception) => {
            if (scene) {
                scene.removePendingData(tokenPendingData);
            }
            if (onErrorCallBack) {
                onErrorCallBack(message, exception);
            }
        };
        LoadImage(url, onload, onerror, scene ? scene.offlineProvider : null, mimeType);
        if (scene) {
            scene.addPendingData(tokenPendingData);
        }
    };
    ThinEngine.prototype._setCubeMapTextureParams = function (texture, loadMipmap, maxLevel) {
        const gl = this._gl;
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, loadMipmap ? gl.LINEAR_MIPMAP_LINEAR : gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        texture.samplingMode = loadMipmap ? 3 : 2;
        if (loadMipmap && this.getCaps().textureMaxLevel && maxLevel !== undefined && maxLevel > 0) {
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAX_LEVEL, maxLevel);
            texture._maxLodLevel = maxLevel;
        }
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    };
    ThinEngine.prototype.createCubeTextureBase = function (rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, beforeLoadCubeDataCallback = null, imageHandler = null, useSRGBBuffer = false) {
        const texture = fallback ? fallback : new InternalTexture(this, InternalTextureSource.Cube);
        texture.isCube = true;
        texture.url = rootUrl;
        texture.generateMipMaps = !noMipmap;
        texture._lodGenerationScale = lodScale;
        texture._lodGenerationOffset = lodOffset;
        texture._useSRGBBuffer = !!useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU || !!noMipmap);
        if (texture !== fallback) {
            texture.label = rootUrl.substring(0, 60); // default label, can be overriden by the caller
        }
        if (!this._doNotHandleContextLost) {
            texture._extension = forcedExtension;
            texture._files = files;
        }
        const originalRootUrl = rootUrl;
        if (this._transformTextureUrl && !fallback) {
            rootUrl = this._transformTextureUrl(rootUrl);
        }
        const rootUrlWithoutUriParams = rootUrl.split("?")[0];
        const lastDot = rootUrlWithoutUriParams.lastIndexOf(".");
        const extension = forcedExtension ? forcedExtension : lastDot > -1 ? rootUrlWithoutUriParams.substring(lastDot).toLowerCase() : "";
        let loader = null;
        for (const availableLoader of ThinEngine._TextureLoaders) {
            if (availableLoader.canLoad(extension)) {
                loader = availableLoader;
                break;
            }
        }
        const onInternalError = (request, exception) => {
            if (rootUrl === originalRootUrl) {
                if (onError && request) {
                    onError(request.status + " " + request.statusText, exception);
                }
            }
            else {
                // fall back to the original url if the transformed url fails to load
                Logger.Warn(`Failed to load ${rootUrl}, falling back to the ${originalRootUrl}`);
                this.createCubeTextureBase(originalRootUrl, scene, files, !!noMipmap, onLoad, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset, texture, beforeLoadCubeDataCallback, imageHandler, useSRGBBuffer);
            }
        };
        if (loader) {
            const onloaddata = (data) => {
                if (beforeLoadCubeDataCallback) {
                    beforeLoadCubeDataCallback(texture, data);
                }
                loader.loadCubeData(data, texture, createPolynomials, onLoad, onError);
            };
            if (files && files.length === 6) {
                if (loader.supportCascades) {
                    this._cascadeLoadFiles(scene, (images) => onloaddata(images.map((image) => new Uint8Array(image))), files, onError);
                }
                else {
                    if (onError) {
                        onError("Textures type does not support cascades.");
                    }
                    else {
                        Logger.Warn("Texture loader does not support cascades.");
                    }
                }
            }
            else {
                this._loadFile(rootUrl, (data) => onloaddata(new Uint8Array(data)), undefined, undefined, true, onInternalError);
            }
        }
        else {
            if (!files) {
                throw new Error("Cannot load cubemap because files were not defined");
            }
            this._cascadeLoadImgs(scene, texture, (texture, imgs) => {
                if (imageHandler) {
                    imageHandler(texture, imgs);
                }
            }, files, onError);
        }
        this._internalTexturesCache.push(texture);
        return texture;
    };
    ThinEngine.prototype.createCubeTexture = function (rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, loaderOptions, useSRGBBuffer = false) {
        const gl = this._gl;
        return this.createCubeTextureBase(rootUrl, scene, files, !!noMipmap, onLoad, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset, fallback, (texture) => this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true), (texture, imgs) => {
            const width = this.needPOTTextures ? ThinEngine.GetExponentOfTwo(imgs[0].width, this._caps.maxCubemapTextureSize) : imgs[0].width;
            const height = width;
            const faces = [
                gl.TEXTURE_CUBE_MAP_POSITIVE_X,
                gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
                gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
                gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
                gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
                gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
            ];
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
            this._unpackFlipY(false);
            const internalFormat = format ? this._getInternalFormat(format, texture._useSRGBBuffer) : texture._useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : gl.RGBA;
            let texelFormat = format ? this._getInternalFormat(format) : gl.RGBA;
            if (texture._useSRGBBuffer && this.webGLVersion === 1) {
                texelFormat = internalFormat;
            }
            for (let index = 0; index < faces.length; index++) {
                if (imgs[index].width !== width || imgs[index].height !== height) {
                    this._prepareWorkingCanvas();
                    if (!this._workingCanvas || !this._workingContext) {
                        Logger.Warn("Cannot create canvas to resize texture.");
                        return;
                    }
                    this._workingCanvas.width = width;
                    this._workingCanvas.height = height;
                    this._workingContext.drawImage(imgs[index], 0, 0, imgs[index].width, imgs[index].height, 0, 0, width, height);
                    gl.texImage2D(faces[index], 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, this._workingCanvas);
                }
                else {
                    gl.texImage2D(faces[index], 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, imgs[index]);
                }
            }
            if (!noMipmap) {
                gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
            }
            this._setCubeMapTextureParams(texture, !noMipmap);
            texture.width = width;
            texture.height = height;
            texture.isReady = true;
            if (format) {
                texture.format = format;
            }
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
            if (onLoad) {
                onLoad();
            }
        }, !!useSRGBBuffer);
    };

    /**
     * Class for creating a cube texture
     */
    class CubeTexture extends BaseTexture {
        /**
         * Gets or sets the size of the bounding box associated with the cube texture
         * When defined, the cubemap will switch to local mode
         * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
         * @example https://www.babylonjs-playground.com/#RNASML
         */
        set boundingBoxSize(value) {
            if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) {
                return;
            }
            this._boundingBoxSize = value;
            const scene = this.getScene();
            if (scene) {
                scene.markAllMaterialsAsDirty(1);
            }
        }
        /**
         * Returns the bounding box size
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#using-local-cubemap-mode
         */
        get boundingBoxSize() {
            return this._boundingBoxSize;
        }
        /**
         * Sets texture matrix rotation angle around Y axis in radians.
         */
        set rotationY(value) {
            this._rotationY = value;
            this.setReflectionTextureMatrix(Matrix.RotationY(this._rotationY));
        }
        /**
         * Gets texture matrix rotation angle around Y axis radians.
         */
        get rotationY() {
            return this._rotationY;
        }
        /**
         * Are mip maps generated for this texture or not.
         */
        get noMipmap() {
            return this._noMipmap;
        }
        /**
         * Gets the forced extension (if any)
         */
        get forcedExtension() {
            return this._forcedExtension;
        }
        /**
         * Creates a cube texture from an array of image urls
         * @param files defines an array of image urls
         * @param scene defines the hosting scene
         * @param noMipmap specifies if mip maps are not used
         * @returns a cube texture
         */
        static CreateFromImages(files, scene, noMipmap) {
            let rootUrlKey = "";
            files.forEach((url) => (rootUrlKey += url));
            return new CubeTexture(rootUrlKey, scene, null, noMipmap, files);
        }
        /**
         * Creates and return a texture created from prefilterd data by tools like IBL Baker or Lys.
         * @param url defines the url of the prefiltered texture
         * @param scene defines the scene the texture is attached to
         * @param forcedExtension defines the extension of the file if different from the url
         * @param createPolynomials defines whether or not to create polynomial harmonics from the texture data if necessary
         * @returns the prefiltered texture
         */
        static CreateFromPrefilteredData(url, scene, forcedExtension = null, createPolynomials = true) {
            const oldValue = scene.useDelayedTextureLoading;
            scene.useDelayedTextureLoading = false;
            const result = new CubeTexture(url, scene, null, false, null, null, null, undefined, true, forcedExtension, createPolynomials);
            scene.useDelayedTextureLoading = oldValue;
            return result;
        }
        /**
         * Creates a cube texture to use with reflection for instance. It can be based upon dds or six images as well
         * as prefiltered data.
         * @param rootUrl defines the url of the texture or the root name of the six images
         * @param sceneOrEngine defines the scene or engine the texture is attached to
         * @param extensions defines the suffixes add to the picture name in case six images are in use like _px.jpg...
         * @param noMipmap defines if mipmaps should be created or not
         * @param files defines the six files to load for the different faces in that order: px, py, pz, nx, ny, nz
         * @param onLoad defines a callback triggered at the end of the file load if no errors occurred
         * @param onError defines a callback triggered in case of error during load
         * @param format defines the internal format to use for the texture once loaded
         * @param prefiltered defines whether or not the texture is created from prefiltered data
         * @param forcedExtension defines the extensions to use (force a special type of file to load) in case it is different from the file name
         * @param createPolynomials defines whether or not to create polynomial harmonics from the texture data if necessary
         * @param lodScale defines the scale applied to environment texture. This manages the range of LOD level used for IBL according to the roughness
         * @param lodOffset defines the offset applied to environment texture. This manages first LOD level used for IBL according to the roughness
         * @param loaderOptions options to be passed to the loader
         * @param useSRGBBuffer Defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU) (default: false)
         * @returns the cube texture
         */
        constructor(rootUrl, sceneOrEngine, extensions = null, noMipmap = false, files = null, onLoad = null, onError = null, format = 5, prefiltered = false, forcedExtension = null, createPolynomials = false, lodScale = 0.8, lodOffset = 0, loaderOptions, useSRGBBuffer) {
            var _a;
            super(sceneOrEngine);
            this._lodScale = 0.8;
            this._lodOffset = 0;
            /**
             * Observable triggered once the texture has been loaded.
             */
            this.onLoadObservable = new Observable$1();
            /**
             * Gets or sets the center of the bounding box associated with the cube texture.
             * It must define where the camera used to render the texture was set
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#using-local-cubemap-mode
             */
            this.boundingBoxPosition = Vector3.Zero();
            this._rotationY = 0;
            /** @internal */
            this._files = null;
            this._forcedExtension = null;
            this._extensions = null;
            this._textureMatrixRefraction = new Matrix();
            this.name = rootUrl;
            this.url = rootUrl;
            this._noMipmap = noMipmap;
            this.hasAlpha = false;
            this._format = format;
            this.isCube = true;
            this._textureMatrix = Matrix.Identity();
            this._createPolynomials = createPolynomials;
            this.coordinatesMode = Texture.CUBIC_MODE;
            this._extensions = extensions;
            this._files = files;
            this._forcedExtension = forcedExtension;
            this._loaderOptions = loaderOptions;
            this._useSRGBBuffer = useSRGBBuffer;
            this._lodScale = lodScale;
            this._lodOffset = lodOffset;
            if (!rootUrl && !files) {
                return;
            }
            this.updateURL(rootUrl, forcedExtension, onLoad, prefiltered, onError, extensions, (_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.useDelayedTextureLoading, files);
        }
        /**
         * Get the current class name of the texture useful for serialization or dynamic coding.
         * @returns "CubeTexture"
         */
        getClassName() {
            return "CubeTexture";
        }
        /**
         * Update the url (and optional buffer) of this texture if url was null during construction.
         * @param url the url of the texture
         * @param forcedExtension defines the extension to use
         * @param onLoad callback called when the texture is loaded  (defaults to null)
         * @param prefiltered Defines whether the updated texture is prefiltered or not
         * @param onError callback called if there was an error during the loading process (defaults to null)
         * @param extensions defines the suffixes add to the picture name in case six images are in use like _px.jpg...
         * @param delayLoad defines if the texture should be loaded now (false by default)
         * @param files defines the six files to load for the different faces in that order: px, py, pz, nx, ny, nz
         */
        updateURL(url, forcedExtension, onLoad = null, prefiltered = false, onError = null, extensions = null, delayLoad = false, files = null) {
            if (!this.name || this.name.startsWith("data:")) {
                this.name = url;
            }
            this.url = url;
            if (forcedExtension) {
                this._forcedExtension = forcedExtension;
            }
            const lastDot = url.lastIndexOf(".");
            const extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
            const isDDS = extension.indexOf(".dds") === 0;
            const isEnv = extension.indexOf(".env") === 0;
            const isBasis = extension.indexOf(".basis") === 0;
            if (isEnv) {
                this.gammaSpace = false;
                this._prefiltered = false;
                this.anisotropicFilteringLevel = 1;
            }
            else {
                this._prefiltered = prefiltered;
                if (prefiltered) {
                    this.gammaSpace = false;
                    this.anisotropicFilteringLevel = 1;
                }
            }
            if (files) {
                this._files = files;
            }
            else {
                if (!isBasis && !isEnv && !isDDS && !extensions) {
                    extensions = ["_px.jpg", "_py.jpg", "_pz.jpg", "_nx.jpg", "_ny.jpg", "_nz.jpg"];
                }
                this._files = this._files || [];
                this._files.length = 0;
                if (extensions) {
                    for (let index = 0; index < extensions.length; index++) {
                        this._files.push(url + extensions[index]);
                    }
                    this._extensions = extensions;
                }
            }
            if (delayLoad) {
                this.delayLoadState = 4;
                this._delayedOnLoad = onLoad;
                this._delayedOnError = onError;
            }
            else {
                this._loadTexture(onLoad, onError);
            }
        }
        /**
         * Delays loading of the cube texture
         * @param forcedExtension defines the extension to use
         */
        delayLoad(forcedExtension) {
            if (this.delayLoadState !== 4) {
                return;
            }
            if (forcedExtension) {
                this._forcedExtension = forcedExtension;
            }
            this.delayLoadState = 1;
            this._loadTexture(this._delayedOnLoad, this._delayedOnError);
        }
        /**
         * Returns the reflection texture matrix
         * @returns the reflection texture matrix
         */
        getReflectionTextureMatrix() {
            return this._textureMatrix;
        }
        /**
         * Sets the reflection texture matrix
         * @param value Reflection texture matrix
         */
        setReflectionTextureMatrix(value) {
            var _a, _b;
            if (value.updateFlag === this._textureMatrix.updateFlag) {
                return;
            }
            if (value.isIdentity() !== this._textureMatrix.isIdentity()) {
                (_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.markAllMaterialsAsDirty(1, (mat) => mat.getActiveTextures().indexOf(this) !== -1);
            }
            this._textureMatrix = value;
            if (!((_b = this.getScene()) === null || _b === void 0 ? void 0 : _b.useRightHandedSystem)) {
                return;
            }
            const scale = TmpVectors.Vector3[0];
            const quat = TmpVectors.Quaternion[0];
            const trans = TmpVectors.Vector3[1];
            this._textureMatrix.decompose(scale, quat, trans);
            quat.z *= -1; // these two operations correspond to negating the x and y euler angles
            quat.w *= -1;
            Matrix.ComposeToRef(scale, quat, trans, this._textureMatrixRefraction);
        }
        /**
         * Gets a suitable rotate/transform matrix when the texture is used for refraction.
         * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
         * @returns The refraction matrix
         */
        getRefractionTextureMatrix() {
            var _a;
            return ((_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.useRightHandedSystem) ? this._textureMatrixRefraction : this._textureMatrix;
        }
        _loadTexture(onLoad = null, onError = null) {
            var _a;
            const scene = this.getScene();
            const oldTexture = this._texture;
            this._texture = this._getFromCache(this.url, this._noMipmap, undefined, undefined, this._useSRGBBuffer, this.isCube);
            const onLoadProcessing = () => {
                var _a;
                this.onLoadObservable.notifyObservers(this);
                if (oldTexture) {
                    oldTexture.dispose();
                    (_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.markAllMaterialsAsDirty(1);
                }
                if (onLoad) {
                    onLoad();
                }
            };
            const errorHandler = (message, exception) => {
                this._loadingError = true;
                this._errorObject = { message, exception };
                if (onError) {
                    onError(message, exception);
                }
                Texture.OnTextureLoadErrorObservable.notifyObservers(this);
            };
            if (!this._texture) {
                if (this._prefiltered) {
                    this._texture = this._getEngine().createPrefilteredCubeTexture(this.url, scene, this._lodScale, this._lodOffset, onLoad, errorHandler, this._format, this._forcedExtension, this._createPolynomials);
                }
                else {
                    this._texture = this._getEngine().createCubeTexture(this.url, scene, this._files, this._noMipmap, onLoad, errorHandler, this._format, this._forcedExtension, false, this._lodScale, this._lodOffset, null, this._loaderOptions, !!this._useSRGBBuffer);
                }
                (_a = this._texture) === null || _a === void 0 ? void 0 : _a.onLoadedObservable.add(() => this.onLoadObservable.notifyObservers(this));
            }
            else {
                if (this._texture.isReady) {
                    Tools.SetImmediate(() => onLoadProcessing());
                }
                else {
                    this._texture.onLoadedObservable.add(() => onLoadProcessing());
                }
            }
        }
        /**
         * Parses text to create a cube texture
         * @param parsedTexture define the serialized text to read from
         * @param scene defines the hosting scene
         * @param rootUrl defines the root url of the cube texture
         * @returns a cube texture
         */
        static Parse(parsedTexture, scene, rootUrl) {
            const texture = SerializationHelper.Parse(() => {
                var _a;
                let prefiltered = false;
                if (parsedTexture.prefiltered) {
                    prefiltered = parsedTexture.prefiltered;
                }
                return new CubeTexture(rootUrl + ((_a = parsedTexture.url) !== null && _a !== void 0 ? _a : parsedTexture.name), scene, parsedTexture.extensions, false, parsedTexture.files || null, null, null, undefined, prefiltered, parsedTexture.forcedExtension);
            }, parsedTexture, scene);
            // Local Cubemaps
            if (parsedTexture.boundingBoxPosition) {
                texture.boundingBoxPosition = Vector3.FromArray(parsedTexture.boundingBoxPosition);
            }
            if (parsedTexture.boundingBoxSize) {
                texture.boundingBoxSize = Vector3.FromArray(parsedTexture.boundingBoxSize);
            }
            // Animations
            if (parsedTexture.animations) {
                for (let animationIndex = 0; animationIndex < parsedTexture.animations.length; animationIndex++) {
                    const parsedAnimation = parsedTexture.animations[animationIndex];
                    const internalClass = GetClass("BABYLON.Animation");
                    if (internalClass) {
                        texture.animations.push(internalClass.Parse(parsedAnimation));
                    }
                }
            }
            return texture;
        }
        /**
         * Makes a clone, or deep copy, of the cube texture
         * @returns a new cube texture
         */
        clone() {
            let uniqueId = 0;
            const newCubeTexture = SerializationHelper.Clone(() => {
                const cubeTexture = new CubeTexture(this.url, this.getScene() || this._getEngine(), this._extensions, this._noMipmap, this._files);
                uniqueId = cubeTexture.uniqueId;
                return cubeTexture;
            }, this);
            newCubeTexture.uniqueId = uniqueId;
            return newCubeTexture;
        }
    }
    __decorate$1([
        serialize()
    ], CubeTexture.prototype, "url", void 0);
    __decorate$1([
        serializeAsVector3()
    ], CubeTexture.prototype, "boundingBoxPosition", void 0);
    __decorate$1([
        serializeAsVector3()
    ], CubeTexture.prototype, "boundingBoxSize", null);
    __decorate$1([
        serialize("rotationY")
    ], CubeTexture.prototype, "rotationY", null);
    __decorate$1([
        serialize("files")
    ], CubeTexture.prototype, "_files", void 0);
    __decorate$1([
        serialize("forcedExtension")
    ], CubeTexture.prototype, "_forcedExtension", void 0);
    __decorate$1([
        serialize("extensions")
    ], CubeTexture.prototype, "_extensions", void 0);
    __decorate$1([
        serializeAsMatrix("textureMatrix")
    ], CubeTexture.prototype, "_textureMatrix", void 0);
    __decorate$1([
        serializeAsMatrix("textureMatrixRefraction")
    ], CubeTexture.prototype, "_textureMatrixRefraction", void 0);
    Texture._CubeTextureParser = CubeTexture.Parse;
    // Some exporters relies on Tools.Instantiate
    RegisterClass("BABYLON.CubeTexture", CubeTexture);

    // Do not edit.
    const name$1O = "backgroundFragmentDeclaration";
    const shader$1O = `uniform vec4 vEyePosition;uniform vec4 vPrimaryColor;
#ifdef USEHIGHLIGHTANDSHADOWCOLORS
uniform vec4 vPrimaryColorShadow;
#endif
uniform float shadowLevel;uniform float alpha;
#ifdef DIFFUSE
uniform vec2 vDiffuseInfos;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;
#endif
#if defined(REFLECTIONFRESNEL) || defined(OPACITYFRESNEL)
uniform vec3 vBackgroundCenter;
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 vReflectionControl;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(REFRACTION)
uniform mat4 view;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1O] = shader$1O;

    // Do not edit.
    const name$1P = "backgroundUboDeclaration";
    const shader$1P = `layout(std140,column_major) uniform;uniform Material
{uniform vec4 vPrimaryColor;uniform vec4 vPrimaryColorShadow;uniform vec2 vDiffuseInfos;uniform vec2 vReflectionInfos;uniform mat4 diffuseMatrix;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;uniform float fFovMultiplier;uniform float pointSize;uniform float shadowLevel;uniform float alpha;
#if defined(REFLECTIONFRESNEL) || defined(OPACITYFRESNEL)
uniform vec3 vBackgroundCenter;
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 vReflectionControl;
#endif
};
#include<sceneUboDeclaration>
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1P] = shader$1P;

    // Do not edit.
    const name$1Q = "backgroundPixelShader";
    const shader$1Q = `#ifdef TEXTURELODSUPPORT
#extension GL_EXT_shader_texture_lod : enable
#endif
precision highp float;
#include<__decl__backgroundFragment>
#include<helperFunctions>
#define RECIPROCAL_PI2 0.15915494
varying vec3 vPositionW;
#ifdef MAINUV1
varying vec2 vMainUV1;
#endif 
#ifdef MAINUV2 
varying vec2 vMainUV2; 
#endif 
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#ifdef DIFFUSE
#if DIFFUSEDIRECTUV==1
#define vDiffuseUV vMainUV1
#elif DIFFUSEDIRECTUV==2
#define vDiffuseUV vMainUV2
#else
varying vec2 vDiffuseUV;
#endif
uniform sampler2D diffuseSampler;
#endif
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
#define sampleReflection(s,c) textureCube(s,c)
uniform samplerCube reflectionSampler;
#ifdef TEXTURELODSUPPORT
#define sampleReflectionLod(s,c,l) textureCubeLodEXT(s,c,l)
#else
uniform samplerCube reflectionSamplerLow;uniform samplerCube reflectionSamplerHigh;
#endif
#else
#define sampleReflection(s,c) texture2D(s,c)
uniform sampler2D reflectionSampler;
#ifdef TEXTURELODSUPPORT
#define sampleReflectionLod(s,c,l) texture2DLodEXT(s,c,l)
#else
uniform samplerCube reflectionSamplerLow;uniform samplerCube reflectionSamplerHigh;
#endif
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#include<reflectionFunction>
#endif
#ifndef FROMLINEARSPACE
#define FROMLINEARSPACE;
#endif
#ifndef SHADOWONLY
#define SHADOWONLY;
#endif
#include<imageProcessingDeclaration>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<imageProcessingFunctions>
#include<clipPlaneFragmentDeclaration>
#include<fogFragmentDeclaration>
#ifdef REFLECTIONFRESNEL
#define FRESNEL_MAXIMUM_ON_ROUGH 0.25
vec3 fresnelSchlickEnvironmentGGX(float VdotN,vec3 reflectance0,vec3 reflectance90,float smoothness)
{float weight=mix(FRESNEL_MAXIMUM_ON_ROUGH,1.0,smoothness);return reflectance0+weight*(reflectance90-reflectance0)*pow5(saturate(1.0-VdotN));}
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=vec3(0.0,1.0,0.0);
#endif
float shadow=1.;float globalShadow=0.;float shadowLightCount=0.;
#include<lightFragment>[0..maxSimultaneousLights]
#ifdef SHADOWINUSE
globalShadow/=shadowLightCount;
#else
globalShadow=1.0;
#endif
#ifndef BACKMAT_SHADOWONLY
vec4 reflectionColor=vec4(1.,1.,1.,1.);
#ifdef REFLECTION
vec3 reflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
reflectionVector.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
vec3 reflectionCoords=reflectionVector;
#else
vec2 reflectionCoords=reflectionVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
reflectionCoords/=reflectionVector.z;
#endif
reflectionCoords.y=1.0-reflectionCoords.y;
#endif
#ifdef REFLECTIONBLUR
float reflectionLOD=vReflectionInfos.y;
#ifdef TEXTURELODSUPPORT
reflectionLOD=reflectionLOD*log2(vReflectionMicrosurfaceInfos.x)*vReflectionMicrosurfaceInfos.y+vReflectionMicrosurfaceInfos.z;reflectionColor=sampleReflectionLod(reflectionSampler,reflectionCoords,reflectionLOD);
#else
float lodReflectionNormalized=saturate(reflectionLOD);float lodReflectionNormalizedDoubled=lodReflectionNormalized*2.0;vec4 reflectionSpecularMid=sampleReflection(reflectionSampler,reflectionCoords);if(lodReflectionNormalizedDoubled<1.0){reflectionColor=mix(
sampleReflection(reflectionSamplerHigh,reflectionCoords),
reflectionSpecularMid,
lodReflectionNormalizedDoubled
);} else {reflectionColor=mix(
reflectionSpecularMid,
sampleReflection(reflectionSamplerLow,reflectionCoords),
lodReflectionNormalizedDoubled-1.0
);}
#endif
#else
vec4 reflectionSample=sampleReflection(reflectionSampler,reflectionCoords);reflectionColor=reflectionSample;
#endif
#ifdef RGBDREFLECTION
reflectionColor.rgb=fromRGBD(reflectionColor);
#endif
#ifdef GAMMAREFLECTION
reflectionColor.rgb=toLinearSpace(reflectionColor.rgb);
#endif
#ifdef REFLECTIONBGR
reflectionColor.rgb=reflectionColor.bgr;
#endif
reflectionColor.rgb*=vReflectionInfos.x;
#endif
vec3 diffuseColor=vec3(1.,1.,1.);float finalAlpha=alpha;
#ifdef DIFFUSE
vec4 diffuseMap=texture2D(diffuseSampler,vDiffuseUV);
#ifdef GAMMADIFFUSE
diffuseMap.rgb=toLinearSpace(diffuseMap.rgb);
#endif
diffuseMap.rgb*=vDiffuseInfos.y;
#ifdef DIFFUSEHASALPHA
finalAlpha*=diffuseMap.a;
#endif
diffuseColor=diffuseMap.rgb;
#endif
#ifdef REFLECTIONFRESNEL
vec3 colorBase=diffuseColor;
#else
vec3 colorBase=reflectionColor.rgb*diffuseColor;
#endif
colorBase=max(colorBase,0.0);
#ifdef USERGBCOLOR
vec3 finalColor=colorBase;
#else
#ifdef USEHIGHLIGHTANDSHADOWCOLORS
vec3 mainColor=mix(vPrimaryColorShadow.rgb,vPrimaryColor.rgb,colorBase);
#else
vec3 mainColor=vPrimaryColor.rgb;
#endif
vec3 finalColor=colorBase*mainColor;
#endif
#ifdef REFLECTIONFRESNEL
vec3 reflectionAmount=vReflectionControl.xxx;vec3 reflectionReflectance0=vReflectionControl.yyy;vec3 reflectionReflectance90=vReflectionControl.zzz;float VdotN=dot(normalize(vEyePosition.xyz),normalW);vec3 planarReflectionFresnel=fresnelSchlickEnvironmentGGX(saturate(VdotN),reflectionReflectance0,reflectionReflectance90,1.0);reflectionAmount*=planarReflectionFresnel;
#ifdef REFLECTIONFALLOFF
float reflectionDistanceFalloff=1.0-saturate(length(vPositionW.xyz-vBackgroundCenter)*vReflectionControl.w);reflectionDistanceFalloff*=reflectionDistanceFalloff;reflectionAmount*=reflectionDistanceFalloff;
#endif
finalColor=mix(finalColor,reflectionColor.rgb,saturate(reflectionAmount));
#endif
#ifdef OPACITYFRESNEL
float viewAngleToFloor=dot(normalW,normalize(vEyePosition.xyz-vBackgroundCenter));const float startAngle=0.1;float fadeFactor=saturate(viewAngleToFloor/startAngle);finalAlpha*=fadeFactor*fadeFactor;
#endif
#ifdef SHADOWINUSE
finalColor=mix(finalColor*shadowLevel,finalColor,globalShadow);
#endif
vec4 color=vec4(finalColor,finalAlpha);
#else
vec4 color=vec4(vPrimaryColor.rgb,(1.0-clamp(globalShadow,0.,1.))*alpha);
#endif
#include<fogFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
#if !defined(SKIPFINALCOLORCLAMP)
color.rgb=clamp(color.rgb,0.,30.0);
#endif
#else
color=applyImageProcessing(color);
#endif
#ifdef PREMULTIPLYALPHA
color.rgb*=color.a;
#endif
#ifdef NOISE
color.rgb+=dither(vPositionW.xy,0.5);color=max(color,0.0);
#endif
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1Q] = shader$1Q;

    // Do not edit.
    const name$1R = "backgroundVertexDeclaration";
    const shader$1R = `uniform mat4 view;uniform mat4 viewProjection;uniform float shadowLevel;
#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;uniform float fFovMultiplier;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$1R] = shader$1R;

    // Do not edit.
    const name$1S = "backgroundVertexShader";
    const shader$1S = `precision highp float;
#include<__decl__backgroundVertex>
#include<helperFunctions>
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#ifdef MAINUV1
varying vec2 vMainUV1;
#endif
#ifdef MAINUV2
varying vec2 vMainUV2;
#endif
#if defined(DIFFUSE) && DIFFUSEDIRECTUV==0
varying vec2 vDiffuseUV;
#endif
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=position;
#endif
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*finalWorld*vec4(position,1.0);} else {gl_Position=viewProjectionR*finalWorld*vec4(position,1.0);}
#else
gl_Position=viewProjection*finalWorld*vec4(position,1.0);
#endif
vec4 worldPos=finalWorld*vec4(position,1.0);vPositionW=vec3(worldPos);
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normal);
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(position,0.0)));
#ifdef EQUIRECTANGULAR_RELFECTION_FOV
mat3 screenToWorld=inverseMat3(mat3(finalWorld*viewProjection));vec3 segment=mix(vDirectionW,screenToWorld*vec3(0.0,0.0,1.0),abs(fFovMultiplier-1.0));if (fFovMultiplier<=1.0) {vDirectionW=normalize(segment);} else {vDirectionW=normalize(vDirectionW+(vDirectionW-segment));}
#endif
#endif
#ifndef UV1
vec2 uv=vec2(0.,0.);
#endif
#ifndef UV2
vec2 uv2=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uv;
#endif
#ifdef MAINUV2
vMainUV2=uv2;
#endif
#if defined(DIFFUSE) && DIFFUSEDIRECTUV==0
if (vDiffuseInfos.x==0.)
{vDiffuseUV=vec2(diffuseMatrix*vec4(uv,1.0,0.0));}
else
{vDiffuseUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));}
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#ifdef VERTEXCOLOR
vColor=color;
#endif
#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
#define CUSTOM_VERTEX_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1S] = shader$1S;

    /**
     * Background material defines definition.
     * @internal Mainly internal Use
     */
    class BackgroundMaterialDefines extends MaterialDefines {
        /**
         * Constructor of the defines.
         */
        constructor() {
            super();
            /**
             * True if the diffuse texture is in use.
             */
            this.DIFFUSE = false;
            /**
             * The direct UV channel to use.
             */
            this.DIFFUSEDIRECTUV = 0;
            /**
             * True if the diffuse texture is in gamma space.
             */
            this.GAMMADIFFUSE = false;
            /**
             * True if the diffuse texture has opacity in the alpha channel.
             */
            this.DIFFUSEHASALPHA = false;
            /**
             * True if you want the material to fade to transparent at grazing angle.
             */
            this.OPACITYFRESNEL = false;
            /**
             * True if an extra blur needs to be added in the reflection.
             */
            this.REFLECTIONBLUR = false;
            /**
             * True if you want the material to fade to reflection at grazing angle.
             */
            this.REFLECTIONFRESNEL = false;
            /**
             * True if you want the material to falloff as far as you move away from the scene center.
             */
            this.REFLECTIONFALLOFF = false;
            /**
             * False if the current Webgl implementation does not support the texture lod extension.
             */
            this.TEXTURELODSUPPORT = false;
            /**
             * True to ensure the data are premultiplied.
             */
            this.PREMULTIPLYALPHA = false;
            /**
             * True if the texture contains cooked RGB values and not gray scaled multipliers.
             */
            this.USERGBCOLOR = false;
            /**
             * True if highlight and shadow levels have been specified. It can help ensuring the main perceived color
             * stays aligned with the desired configuration.
             */
            this.USEHIGHLIGHTANDSHADOWCOLORS = false;
            /**
             * True if only shadows must be rendered
             */
            this.BACKMAT_SHADOWONLY = false;
            /**
             * True to add noise in order to reduce the banding effect.
             */
            this.NOISE = false;
            /**
             * is the reflection texture in BGR color scheme?
             * Mainly used to solve a bug in ios10 video tag
             */
            this.REFLECTIONBGR = false;
            this.IMAGEPROCESSING = false;
            this.VIGNETTE = false;
            this.VIGNETTEBLENDMODEMULTIPLY = false;
            this.VIGNETTEBLENDMODEOPAQUE = false;
            this.TONEMAPPING = false;
            this.TONEMAPPING_ACES = false;
            this.CONTRAST = false;
            this.COLORCURVES = false;
            this.COLORGRADING = false;
            this.COLORGRADING3D = false;
            this.SAMPLER3DGREENDEPTH = false;
            this.SAMPLER3DBGRMAP = false;
            this.DITHER = false;
            this.IMAGEPROCESSINGPOSTPROCESS = false;
            this.SKIPFINALCOLORCLAMP = false;
            this.EXPOSURE = false;
            this.MULTIVIEW = false;
            // Reflection.
            this.REFLECTION = false;
            this.REFLECTIONMAP_3D = false;
            this.REFLECTIONMAP_SPHERICAL = false;
            this.REFLECTIONMAP_PLANAR = false;
            this.REFLECTIONMAP_CUBIC = false;
            this.REFLECTIONMAP_PROJECTION = false;
            this.REFLECTIONMAP_SKYBOX = false;
            this.REFLECTIONMAP_EXPLICIT = false;
            this.REFLECTIONMAP_EQUIRECTANGULAR = false;
            this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
            this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
            this.INVERTCUBICMAP = false;
            this.REFLECTIONMAP_OPPOSITEZ = false;
            this.LODINREFLECTIONALPHA = false;
            this.GAMMAREFLECTION = false;
            this.RGBDREFLECTION = false;
            this.EQUIRECTANGULAR_RELFECTION_FOV = false;
            // Default BJS.
            this.MAINUV1 = false;
            this.MAINUV2 = false;
            this.UV1 = false;
            this.UV2 = false;
            this.CLIPPLANE = false;
            this.CLIPPLANE2 = false;
            this.CLIPPLANE3 = false;
            this.CLIPPLANE4 = false;
            this.CLIPPLANE5 = false;
            this.CLIPPLANE6 = false;
            this.POINTSIZE = false;
            this.FOG = false;
            this.NORMAL = false;
            this.NUM_BONE_INFLUENCERS = 0;
            this.BonesPerMesh = 0;
            this.INSTANCES = false;
            this.SHADOWFLOAT = false;
            this.LOGARITHMICDEPTH = false;
            this.NONUNIFORMSCALING = false;
            this.ALPHATEST = false;
            this.rebuild();
        }
    }
    /**
     * Background material used to create an efficient environment around your scene.
     */
    class BackgroundMaterial extends PushMaterial {
        /**
         * Experimental Internal Use Only.
         *
         * Key light Color in "perceptual value" meaning the color you would like to see on screen.
         * This acts as a helper to set the primary color to a more "human friendly" value.
         * Conversion to linear space as well as exposure and tone mapping correction will be applied to keep the
         * output color as close as possible from the chosen value.
         * (This does not account for contrast color grading and color curves as they are considered post effect and not directly
         * part of lighting setup.)
         */
        get _perceptualColor() {
            return this.__perceptualColor;
        }
        set _perceptualColor(value) {
            this.__perceptualColor = value;
            this._computePrimaryColorFromPerceptualColor();
            this._markAllSubMeshesAsLightsDirty();
        }
        /**
         * Defines the level of the shadows (dark area of the reflection map) in order to help scaling the colors.
         * The color opposite to the primary color is used at the level chosen to define what the black area would look.
         */
        get primaryColorShadowLevel() {
            return this._primaryColorShadowLevel;
        }
        set primaryColorShadowLevel(value) {
            this._primaryColorShadowLevel = value;
            this._computePrimaryColors();
            this._markAllSubMeshesAsLightsDirty();
        }
        /**
         * Defines the level of the highlights (highlight area of the reflection map) in order to help scaling the colors.
         * The primary color is used at the level chosen to define what the white area would look.
         */
        get primaryColorHighlightLevel() {
            return this._primaryColorHighlightLevel;
        }
        set primaryColorHighlightLevel(value) {
            this._primaryColorHighlightLevel = value;
            this._computePrimaryColors();
            this._markAllSubMeshesAsLightsDirty();
        }
        /**
         * Sets the reflection reflectance fresnel values according to the default standard
         * empirically know to work well :-)
         */
        set reflectionStandardFresnelWeight(value) {
            let reflectionWeight = value;
            if (reflectionWeight < 0.5) {
                reflectionWeight = reflectionWeight * 2.0;
                this.reflectionReflectance0 = BackgroundMaterial.StandardReflectance0 * reflectionWeight;
                this.reflectionReflectance90 = BackgroundMaterial.StandardReflectance90 * reflectionWeight;
            }
            else {
                reflectionWeight = reflectionWeight * 2.0 - 1.0;
                this.reflectionReflectance0 = BackgroundMaterial.StandardReflectance0 + (1.0 - BackgroundMaterial.StandardReflectance0) * reflectionWeight;
                this.reflectionReflectance90 = BackgroundMaterial.StandardReflectance90 + (1.0 - BackgroundMaterial.StandardReflectance90) * reflectionWeight;
            }
        }
        /**
         * The current fov(field of view) multiplier, 0.0 - 2.0. Defaults to 1.0. Lower values "zoom in" and higher values "zoom out".
         * Best used when trying to implement visual zoom effects like fish-eye or binoculars while not adjusting camera fov.
         * Recommended to be keep at 1.0 except for special cases.
         */
        get fovMultiplier() {
            return this._fovMultiplier;
        }
        set fovMultiplier(value) {
            if (isNaN(value)) {
                value = 1.0;
            }
            this._fovMultiplier = Math.max(0.0, Math.min(2.0, value));
        }
        /**
         * Attaches a new image processing configuration to the PBR Material.
         * @param configuration (if null the scene configuration will be use)
         */
        _attachImageProcessingConfiguration(configuration) {
            if (configuration === this._imageProcessingConfiguration) {
                return;
            }
            // Detaches observer.
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            // Pick the scene configuration if needed.
            if (!configuration) {
                this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
            }
            else {
                this._imageProcessingConfiguration = configuration;
            }
            // Attaches observer.
            if (this._imageProcessingConfiguration) {
                this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
                    this._computePrimaryColorFromPerceptualColor();
                    this._markAllSubMeshesAsImageProcessingDirty();
                });
            }
        }
        /**
         * Gets the image processing configuration used either in this material.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Sets the Default image processing configuration used either in the this material.
         *
         * If sets to null, the scene one is in use.
         */
        set imageProcessingConfiguration(value) {
            this._attachImageProcessingConfiguration(value);
            // Ensure the effect will be rebuilt.
            this._markAllSubMeshesAsTexturesDirty();
        }
        /**
         * Gets whether the color curves effect is enabled.
         */
        get cameraColorCurvesEnabled() {
            return this.imageProcessingConfiguration.colorCurvesEnabled;
        }
        /**
         * Sets whether the color curves effect is enabled.
         */
        set cameraColorCurvesEnabled(value) {
            this.imageProcessingConfiguration.colorCurvesEnabled = value;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        get cameraColorGradingEnabled() {
            return this.imageProcessingConfiguration.colorGradingEnabled;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        set cameraColorGradingEnabled(value) {
            this.imageProcessingConfiguration.colorGradingEnabled = value;
        }
        /**
         * Gets whether tonemapping is enabled or not.
         */
        get cameraToneMappingEnabled() {
            return this._imageProcessingConfiguration.toneMappingEnabled;
        }
        /**
         * Sets whether tonemapping is enabled or not
         */
        set cameraToneMappingEnabled(value) {
            this._imageProcessingConfiguration.toneMappingEnabled = value;
        }
        /**
         * The camera exposure used on this material.
         * This property is here and not in the camera to allow controlling exposure without full screen post process.
         * This corresponds to a photographic exposure.
         */
        get cameraExposure() {
            return this._imageProcessingConfiguration.exposure;
        }
        /**
         * The camera exposure used on this material.
         * This property is here and not in the camera to allow controlling exposure without full screen post process.
         * This corresponds to a photographic exposure.
         */
        set cameraExposure(value) {
            this._imageProcessingConfiguration.exposure = value;
        }
        /**
         * Gets The camera contrast used on this material.
         */
        get cameraContrast() {
            return this._imageProcessingConfiguration.contrast;
        }
        /**
         * Sets The camera contrast used on this material.
         */
        set cameraContrast(value) {
            this._imageProcessingConfiguration.contrast = value;
        }
        /**
         * Gets the Color Grading 2D Lookup Texture.
         */
        get cameraColorGradingTexture() {
            return this._imageProcessingConfiguration.colorGradingTexture;
        }
        /**
         * Sets the Color Grading 2D Lookup Texture.
         */
        set cameraColorGradingTexture(value) {
            this.imageProcessingConfiguration.colorGradingTexture = value;
        }
        /**
         * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
         * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
         * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
         * corresponding to low luminance, medium luminance, and high luminance areas respectively.
         */
        get cameraColorCurves() {
            return this.imageProcessingConfiguration.colorCurves;
        }
        /**
         * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
         * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
         * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
         * corresponding to low luminance, medium luminance, and high luminance areas respectively.
         */
        set cameraColorCurves(value) {
            this.imageProcessingConfiguration.colorCurves = value;
        }
        /**
         * Instantiates a Background Material in the given scene
         * @param name The friendly name of the material
         * @param scene The scene to add the material to
         */
        constructor(name, scene) {
            super(name, scene);
            /**
             * Key light Color (multiply against the environment texture)
             */
            this.primaryColor = Color3.White();
            this._primaryColorShadowLevel = 0;
            this._primaryColorHighlightLevel = 0;
            /**
             * Reflection Texture used in the material.
             * Should be author in a specific way for the best result (refer to the documentation).
             */
            this.reflectionTexture = null;
            /**
             * Reflection Texture level of blur.
             *
             * Can be use to reuse an existing HDR Texture and target a specific LOD to prevent authoring the
             * texture twice.
             */
            this.reflectionBlur = 0;
            /**
             * Diffuse Texture used in the material.
             * Should be author in a specific way for the best result (refer to the documentation).
             */
            this.diffuseTexture = null;
            this._shadowLights = null;
            /**
             * Specify the list of lights casting shadow on the material.
             * All scene shadow lights will be included if null.
             */
            this.shadowLights = null;
            /**
             * Helps adjusting the shadow to a softer level if required.
             * 0 means black shadows and 1 means no shadows.
             */
            this.shadowLevel = 0;
            /**
             * In case of opacity Fresnel or reflection falloff, this is use as a scene center.
             * It is usually zero but might be interesting to modify according to your setup.
             */
            this.sceneCenter = Vector3.Zero();
            /**
             * This helps specifying that the material is falling off to the sky box at grazing angle.
             * This helps ensuring a nice transition when the camera goes under the ground.
             */
            this.opacityFresnel = true;
            /**
             * This helps specifying that the material is falling off from diffuse to the reflection texture at grazing angle.
             * This helps adding a mirror texture on the ground.
             */
            this.reflectionFresnel = false;
            /**
             * This helps specifying the falloff radius off the reflection texture from the sceneCenter.
             * This helps adding a nice falloff effect to the reflection if used as a mirror for instance.
             */
            this.reflectionFalloffDistance = 0.0;
            /**
             * This specifies the weight of the reflection against the background in case of reflection Fresnel.
             */
            this.reflectionAmount = 1.0;
            /**
             * This specifies the weight of the reflection at grazing angle.
             */
            this.reflectionReflectance0 = 0.05;
            /**
             * This specifies the weight of the reflection at a perpendicular point of view.
             */
            this.reflectionReflectance90 = 0.5;
            /**
             * Helps to directly use the maps channels instead of their level.
             */
            this.useRGBColor = true;
            /**
             * This helps reducing the banding effect that could occur on the background.
             */
            this.enableNoise = false;
            this._fovMultiplier = 1.0;
            /**
             * Enable the FOV adjustment feature controlled by fovMultiplier.
             */
            this.useEquirectangularFOV = false;
            this._maxSimultaneousLights = 4;
            /**
             * Number of Simultaneous lights allowed on the material.
             */
            this.maxSimultaneousLights = 4;
            this._shadowOnly = false;
            /**
             * Make the material only render shadows
             */
            this.shadowOnly = false;
            /**
             * Keep track of the image processing observer to allow dispose and replace.
             */
            this._imageProcessingObserver = null;
            /**
             * Due to a bug in iOS10, video tags (which are using the background material) are in BGR and not RGB.
             * Setting this flag to true (not done automatically!) will convert it back to RGB.
             */
            this.switchToBGR = false;
            // Temp values kept as cache in the material.
            this._renderTargets = new SmartArray(16);
            this._reflectionControls = Vector4.Zero();
            this._white = Color3.White();
            this._primaryShadowColor = Color3.Black();
            this._primaryHighlightColor = Color3.Black();
            // Setup the default processing configuration to the scene.
            this._attachImageProcessingConfiguration(null);
            this.getRenderTargetTextures = () => {
                this._renderTargets.reset();
                if (this._diffuseTexture && this._diffuseTexture.isRenderTarget) {
                    this._renderTargets.push(this._diffuseTexture);
                }
                if (this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                    this._renderTargets.push(this._reflectionTexture);
                }
                return this._renderTargets;
            };
        }
        /**
         * Gets a boolean indicating that current material needs to register RTT
         */
        get hasRenderTargetTextures() {
            if (this._diffuseTexture && this._diffuseTexture.isRenderTarget) {
                return true;
            }
            if (this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                return true;
            }
            return false;
        }
        /**
         * The entire material has been created in order to prevent overdraw.
         * @returns false
         */
        needAlphaTesting() {
            return true;
        }
        /**
         * The entire material has been created in order to prevent overdraw.
         * @returns true if blending is enable
         */
        needAlphaBlending() {
            return this.alpha < 1 || (this._diffuseTexture != null && this._diffuseTexture.hasAlpha) || this._shadowOnly;
        }
        /**
         * Checks whether the material is ready to be rendered for a given mesh.
         * @param mesh The mesh to render
         * @param subMesh The submesh to check against
         * @param useInstances Specify wether or not the material is used with instances
         * @returns true if all the dependencies are ready (Textures, Effects...)
         */
        isReadyForSubMesh(mesh, subMesh, useInstances = false) {
            if (subMesh.effect && this.isFrozen) {
                if (subMesh.effect._wasPreviouslyReady && subMesh.effect._wasPreviouslyUsingInstances === useInstances) {
                    return true;
                }
            }
            if (!subMesh.materialDefines) {
                subMesh.materialDefines = new BackgroundMaterialDefines();
            }
            const scene = this.getScene();
            const defines = subMesh.materialDefines;
            if (this._isReadyForSubMesh(subMesh)) {
                return true;
            }
            const engine = scene.getEngine();
            // Lights
            MaterialHelper.PrepareDefinesForLights(scene, mesh, defines, false, this._maxSimultaneousLights);
            defines._needNormals = true;
            // Multiview
            MaterialHelper.PrepareDefinesForMultiview(scene, defines);
            // Textures
            if (defines._areTexturesDirty) {
                defines._needUVs = false;
                if (scene.texturesEnabled) {
                    if (scene.getEngine().getCaps().textureLOD) {
                        defines.TEXTURELODSUPPORT = true;
                    }
                    if (this._diffuseTexture && MaterialFlags.DiffuseTextureEnabled) {
                        if (!this._diffuseTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        MaterialHelper.PrepareDefinesForMergedUV(this._diffuseTexture, defines, "DIFFUSE");
                        defines.DIFFUSEHASALPHA = this._diffuseTexture.hasAlpha;
                        defines.GAMMADIFFUSE = this._diffuseTexture.gammaSpace;
                        defines.OPACITYFRESNEL = this._opacityFresnel;
                    }
                    else {
                        defines.DIFFUSE = false;
                        defines.DIFFUSEDIRECTUV = 0;
                        defines.DIFFUSEHASALPHA = false;
                        defines.GAMMADIFFUSE = false;
                        defines.OPACITYFRESNEL = false;
                    }
                    const reflectionTexture = this._reflectionTexture;
                    if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                        if (!reflectionTexture.isReadyOrNotBlocking()) {
                            return false;
                        }
                        defines.REFLECTION = true;
                        defines.GAMMAREFLECTION = reflectionTexture.gammaSpace;
                        defines.RGBDREFLECTION = reflectionTexture.isRGBD;
                        defines.REFLECTIONBLUR = this._reflectionBlur > 0;
                        defines.LODINREFLECTIONALPHA = reflectionTexture.lodLevelInAlpha;
                        defines.EQUIRECTANGULAR_RELFECTION_FOV = this.useEquirectangularFOV;
                        defines.REFLECTIONBGR = this.switchToBGR;
                        if (reflectionTexture.coordinatesMode === Texture.INVCUBIC_MODE) {
                            defines.INVERTCUBICMAP = true;
                        }
                        defines.REFLECTIONMAP_3D = reflectionTexture.isCube;
                        defines.REFLECTIONMAP_OPPOSITEZ = defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !reflectionTexture.invertZ : reflectionTexture.invertZ;
                        switch (reflectionTexture.coordinatesMode) {
                            case Texture.EXPLICIT_MODE:
                                defines.REFLECTIONMAP_EXPLICIT = true;
                                break;
                            case Texture.PLANAR_MODE:
                                defines.REFLECTIONMAP_PLANAR = true;
                                break;
                            case Texture.PROJECTION_MODE:
                                defines.REFLECTIONMAP_PROJECTION = true;
                                break;
                            case Texture.SKYBOX_MODE:
                                defines.REFLECTIONMAP_SKYBOX = true;
                                break;
                            case Texture.SPHERICAL_MODE:
                                defines.REFLECTIONMAP_SPHERICAL = true;
                                break;
                            case Texture.EQUIRECTANGULAR_MODE:
                                defines.REFLECTIONMAP_EQUIRECTANGULAR = true;
                                break;
                            case Texture.FIXED_EQUIRECTANGULAR_MODE:
                                defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = true;
                                break;
                            case Texture.FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                                defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = true;
                                break;
                            case Texture.CUBIC_MODE:
                            case Texture.INVCUBIC_MODE:
                            default:
                                defines.REFLECTIONMAP_CUBIC = true;
                                break;
                        }
                        if (this.reflectionFresnel) {
                            defines.REFLECTIONFRESNEL = true;
                            defines.REFLECTIONFALLOFF = this.reflectionFalloffDistance > 0;
                            this._reflectionControls.x = this.reflectionAmount;
                            this._reflectionControls.y = this.reflectionReflectance0;
                            this._reflectionControls.z = this.reflectionReflectance90;
                            this._reflectionControls.w = 1 / this.reflectionFalloffDistance;
                        }
                        else {
                            defines.REFLECTIONFRESNEL = false;
                            defines.REFLECTIONFALLOFF = false;
                        }
                    }
                    else {
                        defines.REFLECTION = false;
                        defines.REFLECTIONFRESNEL = false;
                        defines.REFLECTIONFALLOFF = false;
                        defines.REFLECTIONBLUR = false;
                        defines.REFLECTIONMAP_3D = false;
                        defines.REFLECTIONMAP_SPHERICAL = false;
                        defines.REFLECTIONMAP_PLANAR = false;
                        defines.REFLECTIONMAP_CUBIC = false;
                        defines.REFLECTIONMAP_PROJECTION = false;
                        defines.REFLECTIONMAP_SKYBOX = false;
                        defines.REFLECTIONMAP_EXPLICIT = false;
                        defines.REFLECTIONMAP_EQUIRECTANGULAR = false;
                        defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
                        defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
                        defines.INVERTCUBICMAP = false;
                        defines.REFLECTIONMAP_OPPOSITEZ = false;
                        defines.LODINREFLECTIONALPHA = false;
                        defines.GAMMAREFLECTION = false;
                        defines.RGBDREFLECTION = false;
                    }
                }
                defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
                defines.USERGBCOLOR = this._useRGBColor;
                defines.NOISE = this._enableNoise;
            }
            if (defines._areLightsDirty) {
                defines.USEHIGHLIGHTANDSHADOWCOLORS = !this._useRGBColor && (this._primaryColorShadowLevel !== 0 || this._primaryColorHighlightLevel !== 0);
                defines.BACKMAT_SHADOWONLY = this._shadowOnly;
            }
            if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
                if (!this._imageProcessingConfiguration.isReady()) {
                    return false;
                }
                this._imageProcessingConfiguration.prepareDefines(defines);
            }
            // Misc.
            MaterialHelper.PrepareDefinesForMisc(mesh, scene, false, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh), defines);
            // Values that need to be evaluated on every frame
            MaterialHelper.PrepareDefinesForFrameBoundValues(scene, engine, this, defines, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
            // Attribs
            if (MaterialHelper.PrepareDefinesForAttributes(mesh, defines, false, true, false)) {
                if (mesh) {
                    if (!scene.getEngine().getCaps().standardDerivatives && !mesh.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                        mesh.createNormals(true);
                        Logger.Warn("BackgroundMaterial: Normals have been created for the mesh: " + mesh.name);
                    }
                }
            }
            // Get correct effect
            if (defines.isDirty) {
                defines.markAsProcessed();
                scene.resetCachedMaterial();
                // Fallbacks
                const fallbacks = new EffectFallbacks();
                if (defines.FOG) {
                    fallbacks.addFallback(0, "FOG");
                }
                if (defines.POINTSIZE) {
                    fallbacks.addFallback(1, "POINTSIZE");
                }
                if (defines.MULTIVIEW) {
                    fallbacks.addFallback(0, "MULTIVIEW");
                }
                MaterialHelper.HandleFallbacksForShadows(defines, fallbacks, this._maxSimultaneousLights);
                //Attributes
                const attribs = [VertexBuffer.PositionKind];
                if (defines.NORMAL) {
                    attribs.push(VertexBuffer.NormalKind);
                }
                if (defines.UV1) {
                    attribs.push(VertexBuffer.UVKind);
                }
                if (defines.UV2) {
                    attribs.push(VertexBuffer.UV2Kind);
                }
                MaterialHelper.PrepareAttributesForBones(attribs, mesh, defines, fallbacks);
                MaterialHelper.PrepareAttributesForInstances(attribs, defines);
                const uniforms = [
                    "world",
                    "view",
                    "viewProjection",
                    "vEyePosition",
                    "vLightsType",
                    "vFogInfos",
                    "vFogColor",
                    "pointSize",
                    "mBones",
                    "vPrimaryColor",
                    "vPrimaryColorShadow",
                    "vReflectionInfos",
                    "reflectionMatrix",
                    "vReflectionMicrosurfaceInfos",
                    "fFovMultiplier",
                    "shadowLevel",
                    "alpha",
                    "vBackgroundCenter",
                    "vReflectionControl",
                    "vDiffuseInfos",
                    "diffuseMatrix",
                ];
                addClipPlaneUniforms(uniforms);
                const samplers = ["diffuseSampler", "reflectionSampler", "reflectionSamplerLow", "reflectionSamplerHigh"];
                const uniformBuffers = ["Material", "Scene"];
                if (ImageProcessingConfiguration) {
                    ImageProcessingConfiguration.PrepareUniforms(uniforms, defines);
                    ImageProcessingConfiguration.PrepareSamplers(samplers, defines);
                }
                MaterialHelper.PrepareUniformsAndSamplersList({
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: defines,
                    maxSimultaneousLights: this._maxSimultaneousLights,
                });
                const join = defines.toString();
                const effect = scene.getEngine().createEffect("background", {
                    attributes: attribs,
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: join,
                    fallbacks: fallbacks,
                    onCompiled: this.onCompiled,
                    onError: this.onError,
                    indexParameters: { maxSimultaneousLights: this._maxSimultaneousLights },
                }, engine);
                subMesh.setEffect(effect, defines, this._materialContext);
                this.buildUniformLayout();
            }
            if (!subMesh.effect || !subMesh.effect.isReady()) {
                return false;
            }
            defines._renderId = scene.getRenderId();
            subMesh.effect._wasPreviouslyReady = true;
            subMesh.effect._wasPreviouslyUsingInstances = useInstances;
            this._checkScenePerformancePriority();
            return true;
        }
        /**
         * Compute the primary color according to the chosen perceptual color.
         */
        _computePrimaryColorFromPerceptualColor() {
            if (!this.__perceptualColor) {
                return;
            }
            this._primaryColor.copyFrom(this.__perceptualColor);
            // Revert gamma space.
            this._primaryColor.toLinearSpaceToRef(this._primaryColor, this.getScene().getEngine().useExactSrgbConversions);
            // Revert image processing configuration.
            if (this._imageProcessingConfiguration) {
                // Revert Exposure.
                this._primaryColor.scaleToRef(1 / this._imageProcessingConfiguration.exposure, this._primaryColor);
            }
            this._computePrimaryColors();
        }
        /**
         * Compute the highlights and shadow colors according to their chosen levels.
         */
        _computePrimaryColors() {
            if (this._primaryColorShadowLevel === 0 && this._primaryColorHighlightLevel === 0) {
                return;
            }
            // Find the highlight color based on the configuration.
            this._primaryColor.scaleToRef(this._primaryColorShadowLevel, this._primaryShadowColor);
            this._primaryColor.subtractToRef(this._primaryShadowColor, this._primaryShadowColor);
            // Find the shadow color based on the configuration.
            this._white.subtractToRef(this._primaryColor, this._primaryHighlightColor);
            this._primaryHighlightColor.scaleToRef(this._primaryColorHighlightLevel, this._primaryHighlightColor);
            this._primaryColor.addToRef(this._primaryHighlightColor, this._primaryHighlightColor);
        }
        /**
         * Build the uniform buffer used in the material.
         */
        buildUniformLayout() {
            // Order is important !
            this._uniformBuffer.addUniform("vPrimaryColor", 4);
            this._uniformBuffer.addUniform("vPrimaryColorShadow", 4);
            this._uniformBuffer.addUniform("vDiffuseInfos", 2);
            this._uniformBuffer.addUniform("vReflectionInfos", 2);
            this._uniformBuffer.addUniform("diffuseMatrix", 16);
            this._uniformBuffer.addUniform("reflectionMatrix", 16);
            this._uniformBuffer.addUniform("vReflectionMicrosurfaceInfos", 3);
            this._uniformBuffer.addUniform("fFovMultiplier", 1);
            this._uniformBuffer.addUniform("pointSize", 1);
            this._uniformBuffer.addUniform("shadowLevel", 1);
            this._uniformBuffer.addUniform("alpha", 1);
            this._uniformBuffer.addUniform("vBackgroundCenter", 3);
            this._uniformBuffer.addUniform("vReflectionControl", 4);
            this._uniformBuffer.create();
        }
        /**
         * Unbind the material.
         */
        unbind() {
            if (this._diffuseTexture && this._diffuseTexture.isRenderTarget) {
                this._uniformBuffer.setTexture("diffuseSampler", null);
            }
            if (this._reflectionTexture && this._reflectionTexture.isRenderTarget) {
                this._uniformBuffer.setTexture("reflectionSampler", null);
            }
            super.unbind();
        }
        /**
         * Bind only the world matrix to the material.
         * @param world The world matrix to bind.
         */
        bindOnlyWorldMatrix(world) {
            this._activeEffect.setMatrix("world", world);
        }
        /**
         * Bind the material for a dedicated submeh (every used meshes will be considered opaque).
         * @param world The world matrix to bind.
         * @param mesh
         * @param subMesh The submesh to bind for.
         */
        bindForSubMesh(world, mesh, subMesh) {
            const scene = this.getScene();
            const defines = subMesh.materialDefines;
            if (!defines) {
                return;
            }
            const effect = subMesh.effect;
            if (!effect) {
                return;
            }
            this._activeEffect = effect;
            // Matrices
            this.bindOnlyWorldMatrix(world);
            // Bones
            MaterialHelper.BindBonesParameters(mesh, this._activeEffect);
            const mustRebind = this._mustRebind(scene, effect, mesh.visibility);
            if (mustRebind) {
                this._uniformBuffer.bindToEffect(effect, "Material");
                this.bindViewProjection(effect);
                const reflectionTexture = this._reflectionTexture;
                if (!this._uniformBuffer.useUbo || !this.isFrozen || !this._uniformBuffer.isSync) {
                    // Texture uniforms
                    if (scene.texturesEnabled) {
                        if (this._diffuseTexture && MaterialFlags.DiffuseTextureEnabled) {
                            this._uniformBuffer.updateFloat2("vDiffuseInfos", this._diffuseTexture.coordinatesIndex, this._diffuseTexture.level);
                            MaterialHelper.BindTextureMatrix(this._diffuseTexture, this._uniformBuffer, "diffuse");
                        }
                        if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                            this._uniformBuffer.updateMatrix("reflectionMatrix", reflectionTexture.getReflectionTextureMatrix());
                            this._uniformBuffer.updateFloat2("vReflectionInfos", reflectionTexture.level, this._reflectionBlur);
                            this._uniformBuffer.updateFloat3("vReflectionMicrosurfaceInfos", reflectionTexture.getSize().width, reflectionTexture.lodGenerationScale, reflectionTexture.lodGenerationOffset);
                        }
                    }
                    if (this.shadowLevel > 0) {
                        this._uniformBuffer.updateFloat("shadowLevel", this.shadowLevel);
                    }
                    this._uniformBuffer.updateFloat("alpha", this.alpha);
                    // Point size
                    if (this.pointsCloud) {
                        this._uniformBuffer.updateFloat("pointSize", this.pointSize);
                    }
                    if (defines.USEHIGHLIGHTANDSHADOWCOLORS) {
                        this._uniformBuffer.updateColor4("vPrimaryColor", this._primaryHighlightColor, 1.0);
                        this._uniformBuffer.updateColor4("vPrimaryColorShadow", this._primaryShadowColor, 1.0);
                    }
                    else {
                        this._uniformBuffer.updateColor4("vPrimaryColor", this._primaryColor, 1.0);
                    }
                }
                this._uniformBuffer.updateFloat("fFovMultiplier", this._fovMultiplier);
                // Textures
                if (scene.texturesEnabled) {
                    if (this._diffuseTexture && MaterialFlags.DiffuseTextureEnabled) {
                        this._uniformBuffer.setTexture("diffuseSampler", this._diffuseTexture);
                    }
                    if (reflectionTexture && MaterialFlags.ReflectionTextureEnabled) {
                        if (defines.REFLECTIONBLUR && defines.TEXTURELODSUPPORT) {
                            this._uniformBuffer.setTexture("reflectionSampler", reflectionTexture);
                        }
                        else if (!defines.REFLECTIONBLUR) {
                            this._uniformBuffer.setTexture("reflectionSampler", reflectionTexture);
                        }
                        else {
                            this._uniformBuffer.setTexture("reflectionSampler", reflectionTexture._lodTextureMid || reflectionTexture);
                            this._uniformBuffer.setTexture("reflectionSamplerLow", reflectionTexture._lodTextureLow || reflectionTexture);
                            this._uniformBuffer.setTexture("reflectionSamplerHigh", reflectionTexture._lodTextureHigh || reflectionTexture);
                        }
                        if (defines.REFLECTIONFRESNEL) {
                            this._uniformBuffer.updateFloat3("vBackgroundCenter", this.sceneCenter.x, this.sceneCenter.y, this.sceneCenter.z);
                            this._uniformBuffer.updateFloat4("vReflectionControl", this._reflectionControls.x, this._reflectionControls.y, this._reflectionControls.z, this._reflectionControls.w);
                        }
                    }
                }
                // Clip plane
                bindClipPlane(this._activeEffect, this, scene);
                scene.bindEyePosition(effect);
            }
            else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) {
                this._uniformBuffer.bindToEffect(effect, "Material");
                this._needToBindSceneUbo = true;
            }
            if (mustRebind || !this.isFrozen) {
                if (scene.lightsEnabled) {
                    MaterialHelper.BindLights(scene, mesh, this._activeEffect, defines, this._maxSimultaneousLights);
                }
                // View
                this.bindView(effect);
                // Fog
                MaterialHelper.BindFogParameters(scene, mesh, this._activeEffect, true);
                // image processing
                if (this._imageProcessingConfiguration) {
                    this._imageProcessingConfiguration.bind(this._activeEffect);
                }
            }
            this._afterBind(mesh, this._activeEffect);
            this._uniformBuffer.update();
        }
        /**
         * Checks to see if a texture is used in the material.
         * @param texture - Base texture to use.
         * @returns - Boolean specifying if a texture is used in the material.
         */
        hasTexture(texture) {
            if (super.hasTexture(texture)) {
                return true;
            }
            if (this._reflectionTexture === texture) {
                return true;
            }
            if (this._diffuseTexture === texture) {
                return true;
            }
            return false;
        }
        /**
         * Dispose the material.
         * @param forceDisposeEffect Force disposal of the associated effect.
         * @param forceDisposeTextures Force disposal of the associated textures.
         */
        dispose(forceDisposeEffect = false, forceDisposeTextures = false) {
            if (forceDisposeTextures) {
                if (this.diffuseTexture) {
                    this.diffuseTexture.dispose();
                }
                if (this.reflectionTexture) {
                    this.reflectionTexture.dispose();
                }
            }
            this._renderTargets.dispose();
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            super.dispose(forceDisposeEffect);
        }
        /**
         * Clones the material.
         * @param name The cloned name.
         * @returns The cloned material.
         */
        clone(name) {
            return SerializationHelper.Clone(() => new BackgroundMaterial(name, this.getScene()), this);
        }
        /**
         * Serializes the current material to its JSON representation.
         * @returns The JSON representation.
         */
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.customType = "BABYLON.BackgroundMaterial";
            return serializationObject;
        }
        /**
         * Gets the class name of the material
         * @returns "BackgroundMaterial"
         */
        getClassName() {
            return "BackgroundMaterial";
        }
        /**
         * Parse a JSON input to create back a background material.
         * @param source The JSON data to parse
         * @param scene The scene to create the parsed material in
         * @param rootUrl The root url of the assets the material depends upon
         * @returns the instantiated BackgroundMaterial.
         */
        static Parse(source, scene, rootUrl) {
            return SerializationHelper.Parse(() => new BackgroundMaterial(source.name, scene), source, scene, rootUrl);
        }
    }
    /**
     * Standard reflectance value at parallel view angle.
     */
    BackgroundMaterial.StandardReflectance0 = 0.05;
    /**
     * Standard reflectance value at grazing angle.
     */
    BackgroundMaterial.StandardReflectance90 = 0.5;
    __decorate$1([
        serializeAsColor3()
    ], BackgroundMaterial.prototype, "_primaryColor", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], BackgroundMaterial.prototype, "primaryColor", void 0);
    __decorate$1([
        serializeAsColor3()
    ], BackgroundMaterial.prototype, "__perceptualColor", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_primaryColorShadowLevel", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_primaryColorHighlightLevel", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], BackgroundMaterial.prototype, "primaryColorHighlightLevel", null);
    __decorate$1([
        serializeAsTexture()
    ], BackgroundMaterial.prototype, "_reflectionTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionTexture", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_reflectionBlur", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionBlur", void 0);
    __decorate$1([
        serializeAsTexture()
    ], BackgroundMaterial.prototype, "_diffuseTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "diffuseTexture", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "shadowLights", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_shadowLevel", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "shadowLevel", void 0);
    __decorate$1([
        serializeAsVector3()
    ], BackgroundMaterial.prototype, "_sceneCenter", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "sceneCenter", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_opacityFresnel", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "opacityFresnel", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_reflectionFresnel", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionFresnel", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_reflectionFalloffDistance", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionFalloffDistance", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_reflectionAmount", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionAmount", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_reflectionReflectance0", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionReflectance0", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_reflectionReflectance90", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "reflectionReflectance90", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_useRGBColor", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "useRGBColor", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_enableNoise", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "enableNoise", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_maxSimultaneousLights", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsTexturesDirty")
    ], BackgroundMaterial.prototype, "maxSimultaneousLights", void 0);
    __decorate$1([
        serialize()
    ], BackgroundMaterial.prototype, "_shadowOnly", void 0);
    __decorate$1([
        expandToProperty("_markAllSubMeshesAsLightsDirty")
    ], BackgroundMaterial.prototype, "shadowOnly", void 0);
    __decorate$1([
        serializeAsImageProcessingConfiguration()
    ], BackgroundMaterial.prototype, "_imageProcessingConfiguration", void 0);
    RegisterClass("BABYLON.BackgroundMaterial", BackgroundMaterial);

    /**
     * Creates the VertexData for a Plane
     * @param options an object used to set the following optional parameters for the plane, required but can be empty
     * * size sets the width and height of the plane to the value of size, optional default 1
     * * width sets the width (x direction) of the plane, overwrites the width set by size, optional, default size
     * * height sets the height (y direction) of the plane, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the box
     */
    function CreatePlaneVertexData(options) {
        const indices = [];
        const positions = [];
        const normals = [];
        const uvs = [];
        const width = options.width || options.size || 1;
        const height = options.height || options.size || 1;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        // Vertices
        const halfWidth = width / 2.0;
        const halfHeight = height / 2.0;
        positions.push(-halfWidth, -halfHeight, 0);
        normals.push(0, 0, -1.0);
        uvs.push(0.0, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 : 0.0);
        positions.push(halfWidth, -halfHeight, 0);
        normals.push(0, 0, -1.0);
        uvs.push(1.0, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 : 0.0);
        positions.push(halfWidth, halfHeight, 0);
        normals.push(0, 0, -1.0);
        uvs.push(1.0, CompatibilityOptions.UseOpenGLOrientationForUV ? 0.0 : 1.0);
        positions.push(-halfWidth, halfHeight, 0);
        normals.push(0, 0, -1.0);
        uvs.push(0.0, CompatibilityOptions.UseOpenGLOrientationForUV ? 0.0 : 1.0);
        // Indices
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        // Sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a plane mesh
     * * The parameter `size` sets the size (float) of both sides of the plane at once (default 1)
     * * You can set some different plane dimensions by using the parameters `width` and `height` (both by default have the same value of `size`)
     * * The parameter `sourcePlane` is a Plane instance. It builds a mesh plane from a Math plane
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.updatable
     * @param options.sourcePlane
     * @param scene defines the hosting scene
     * @returns the plane mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#plane
     */
    function CreatePlane(name, options = {}, scene = null) {
        const plane = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        plane._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreatePlaneVertexData(options);
        vertexData.applyToMesh(plane, options.updatable);
        if (options.sourcePlane) {
            plane.translate(options.sourcePlane.normal, -options.sourcePlane.d);
            plane.setDirection(options.sourcePlane.normal.scale(-1));
        }
        return plane;
    }
    /**
     * Class containing static functions to help procedurally build meshes
     * @deprecated use the function directly from the module
     */
    const PlaneBuilder = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreatePlane,
    };
    VertexData.CreatePlane = CreatePlaneVertexData;
    Mesh.CreatePlane = (name, size, scene, updatable, sideOrientation) => {
        const options = {
            size,
            width: size,
            height: size,
            sideOrientation,
            updatable,
        };
        return CreatePlane(name, options, scene);
    };

    Mesh._GroundMeshParser = (parsedMesh, scene) => {
        return GroundMesh.Parse(parsedMesh, scene);
    };
    /**
     * Mesh representing the ground
     */
    class GroundMesh extends Mesh {
        constructor(name, scene) {
            super(name, scene);
            /** If octree should be generated */
            this.generateOctree = false;
        }
        /**
         * "GroundMesh"
         * @returns "GroundMesh"
         */
        getClassName() {
            return "GroundMesh";
        }
        /**
         * The minimum of x and y subdivisions
         */
        get subdivisions() {
            return Math.min(this._subdivisionsX, this._subdivisionsY);
        }
        /**
         * X subdivisions
         */
        get subdivisionsX() {
            return this._subdivisionsX;
        }
        /**
         * Y subdivisions
         */
        get subdivisionsY() {
            return this._subdivisionsY;
        }
        /**
         * This function will divide the mesh into submeshes and update an octree to help to select the right submeshes
         * for rendering, picking and collision computations. Please note that you must have a decent number of submeshes
         * to get performance improvements when using an octree.
         * @param chunksCount the number of submeshes the mesh will be divided into
         * @param octreeBlocksSize the maximum size of the octree blocks (Default: 32)
         */
        optimize(chunksCount, octreeBlocksSize = 32) {
            this._subdivisionsX = chunksCount;
            this._subdivisionsY = chunksCount;
            this.subdivide(chunksCount);
            // Call the octree system optimization if it is defined.
            const thisAsAny = this;
            if (thisAsAny.createOrUpdateSubmeshesOctree) {
                thisAsAny.createOrUpdateSubmeshesOctree(octreeBlocksSize);
            }
        }
        /**
         * Returns a height (y) value in the World system :
         * the ground altitude at the coordinates (x, z) expressed in the World system.
         * @param x x coordinate
         * @param z z coordinate
         * @returns the ground y position if (x, z) are outside the ground surface.
         */
        getHeightAtCoordinates(x, z) {
            const world = this.getWorldMatrix();
            const invMat = TmpVectors.Matrix[5];
            world.invertToRef(invMat);
            const tmpVect = TmpVectors.Vector3[8];
            Vector3.TransformCoordinatesFromFloatsToRef(x, 0.0, z, invMat, tmpVect); // transform x,z in the mesh local space
            x = tmpVect.x;
            z = tmpVect.z;
            if (x < this._minX || x >= this._maxX || z <= this._minZ || z > this._maxZ) {
                return this.position.y;
            }
            if (!this._heightQuads || this._heightQuads.length == 0) {
                this._initHeightQuads();
                this._computeHeightQuads();
            }
            const facet = this._getFacetAt(x, z);
            const y = -(facet.x * x + facet.z * z + facet.w) / facet.y;
            // return y in the World system
            Vector3.TransformCoordinatesFromFloatsToRef(0.0, y, 0.0, world, tmpVect);
            return tmpVect.y;
        }
        /**
         * Returns a normalized vector (Vector3) orthogonal to the ground
         * at the ground coordinates (x, z) expressed in the World system.
         * @param x x coordinate
         * @param z z coordinate
         * @returns Vector3(0.0, 1.0, 0.0) if (x, z) are outside the ground surface.
         */
        getNormalAtCoordinates(x, z) {
            const normal = new Vector3(0.0, 1.0, 0.0);
            this.getNormalAtCoordinatesToRef(x, z, normal);
            return normal;
        }
        /**
         * Updates the Vector3 passed a reference with a normalized vector orthogonal to the ground
         * at the ground coordinates (x, z) expressed in the World system.
         * Doesn't update the reference Vector3 if (x, z) are outside the ground surface.
         * @param x x coordinate
         * @param z z coordinate
         * @param ref vector to store the result
         * @returns the GroundMesh.
         */
        getNormalAtCoordinatesToRef(x, z, ref) {
            const world = this.getWorldMatrix();
            const tmpMat = TmpVectors.Matrix[5];
            world.invertToRef(tmpMat);
            const tmpVect = TmpVectors.Vector3[8];
            Vector3.TransformCoordinatesFromFloatsToRef(x, 0.0, z, tmpMat, tmpVect); // transform x,z in the mesh local space
            x = tmpVect.x;
            z = tmpVect.z;
            if (x < this._minX || x > this._maxX || z < this._minZ || z > this._maxZ) {
                return this;
            }
            if (!this._heightQuads || this._heightQuads.length == 0) {
                this._initHeightQuads();
                this._computeHeightQuads();
            }
            const facet = this._getFacetAt(x, z);
            Vector3.TransformNormalFromFloatsToRef(facet.x, facet.y, facet.z, world, ref);
            return this;
        }
        /**
         * Force the heights to be recomputed for getHeightAtCoordinates() or getNormalAtCoordinates()
         * if the ground has been updated.
         * This can be used in the render loop.
         * @returns the GroundMesh.
         */
        updateCoordinateHeights() {
            if (!this._heightQuads || this._heightQuads.length == 0) {
                this._initHeightQuads();
            }
            this._computeHeightQuads();
            return this;
        }
        // Returns the element "facet" from the heightQuads array relative to (x, z) local coordinates
        _getFacetAt(x, z) {
            // retrieve col and row from x, z coordinates in the ground local system
            const col = Math.floor(((x + this._maxX) * this._subdivisionsX) / this._width);
            const row = Math.floor((-(z + this._maxZ) * this._subdivisionsY) / this._height + this._subdivisionsY);
            const quad = this._heightQuads[row * this._subdivisionsX + col];
            let facet;
            if (z < quad.slope.x * x + quad.slope.y) {
                facet = quad.facet1;
            }
            else {
                facet = quad.facet2;
            }
            return facet;
        }
        //  Creates and populates the heightMap array with "facet" elements :
        // a quad is two triangular facets separated by a slope, so a "facet" element is 1 slope + 2 facets
        // slope : Vector2(c, h) = 2D diagonal line equation setting apart two triangular facets in a quad : z = cx + h
        // facet1 : Vector4(a, b, c, d) = first facet 3D plane equation : ax + by + cz + d = 0
        // facet2 :  Vector4(a, b, c, d) = second facet 3D plane equation : ax + by + cz + d = 0
        // Returns the GroundMesh.
        _initHeightQuads() {
            const subdivisionsX = this._subdivisionsX;
            const subdivisionsY = this._subdivisionsY;
            this._heightQuads = new Array();
            for (let row = 0; row < subdivisionsY; row++) {
                for (let col = 0; col < subdivisionsX; col++) {
                    const quad = { slope: Vector2.Zero(), facet1: new Vector4(0.0, 0.0, 0.0, 0.0), facet2: new Vector4(0.0, 0.0, 0.0, 0.0) };
                    this._heightQuads[row * subdivisionsX + col] = quad;
                }
            }
            return this;
        }
        // Compute each quad element values and update the the heightMap array :
        // slope : Vector2(c, h) = 2D diagonal line equation setting apart two triangular facets in a quad : z = cx + h
        // facet1 : Vector4(a, b, c, d) = first facet 3D plane equation : ax + by + cz + d = 0
        // facet2 :  Vector4(a, b, c, d) = second facet 3D plane equation : ax + by + cz + d = 0
        // Returns the GroundMesh.
        _computeHeightQuads() {
            const positions = this.getVerticesData(VertexBuffer.PositionKind);
            if (!positions) {
                return this;
            }
            const v1 = TmpVectors.Vector3[3];
            const v2 = TmpVectors.Vector3[2];
            const v3 = TmpVectors.Vector3[1];
            const v4 = TmpVectors.Vector3[0];
            const v1v2 = TmpVectors.Vector3[4];
            const v1v3 = TmpVectors.Vector3[5];
            const v1v4 = TmpVectors.Vector3[6];
            const norm1 = TmpVectors.Vector3[7];
            const norm2 = TmpVectors.Vector3[8];
            let i = 0;
            let j = 0;
            let k = 0;
            let cd = 0; // 2D slope coefficient : z = cd * x + h
            let h = 0;
            let d1 = 0; // facet plane equation : ax + by + cz + d = 0
            let d2 = 0;
            const subdivisionsX = this._subdivisionsX;
            const subdivisionsY = this._subdivisionsY;
            for (let row = 0; row < subdivisionsY; row++) {
                for (let col = 0; col < subdivisionsX; col++) {
                    i = col * 3;
                    j = row * (subdivisionsX + 1) * 3;
                    k = (row + 1) * (subdivisionsX + 1) * 3;
                    v1.x = positions[j + i];
                    v1.y = positions[j + i + 1];
                    v1.z = positions[j + i + 2];
                    v2.x = positions[j + i + 3];
                    v2.y = positions[j + i + 4];
                    v2.z = positions[j + i + 5];
                    v3.x = positions[k + i];
                    v3.y = positions[k + i + 1];
                    v3.z = positions[k + i + 2];
                    v4.x = positions[k + i + 3];
                    v4.y = positions[k + i + 4];
                    v4.z = positions[k + i + 5];
                    // 2D slope V1V4
                    cd = (v4.z - v1.z) / (v4.x - v1.x);
                    h = v1.z - cd * v1.x; // v1 belongs to the slope
                    // facet equations :
                    // we compute each facet normal vector
                    // the equation of the facet plane is : norm.x * x + norm.y * y + norm.z * z + d = 0
                    // we compute the value d by applying the equation to v1 which belongs to the plane
                    // then we store the facet equation in a Vector4
                    v2.subtractToRef(v1, v1v2);
                    v3.subtractToRef(v1, v1v3);
                    v4.subtractToRef(v1, v1v4);
                    Vector3.CrossToRef(v1v4, v1v3, norm1); // caution : CrossToRef uses the Tmp class
                    Vector3.CrossToRef(v1v2, v1v4, norm2);
                    norm1.normalize();
                    norm2.normalize();
                    d1 = -(norm1.x * v1.x + norm1.y * v1.y + norm1.z * v1.z);
                    d2 = -(norm2.x * v2.x + norm2.y * v2.y + norm2.z * v2.z);
                    const quad = this._heightQuads[row * subdivisionsX + col];
                    quad.slope.copyFromFloats(cd, h);
                    quad.facet1.copyFromFloats(norm1.x, norm1.y, norm1.z, d1);
                    quad.facet2.copyFromFloats(norm2.x, norm2.y, norm2.z, d2);
                }
            }
            return this;
        }
        /**
         * Serializes this ground mesh
         * @param serializationObject object to write serialization to
         */
        serialize(serializationObject) {
            super.serialize(serializationObject);
            serializationObject.subdivisionsX = this._subdivisionsX;
            serializationObject.subdivisionsY = this._subdivisionsY;
            serializationObject.minX = this._minX;
            serializationObject.maxX = this._maxX;
            serializationObject.minZ = this._minZ;
            serializationObject.maxZ = this._maxZ;
            serializationObject.width = this._width;
            serializationObject.height = this._height;
        }
        /**
         * Parses a serialized ground mesh
         * @param parsedMesh the serialized mesh
         * @param scene the scene to create the ground mesh in
         * @returns the created ground mesh
         */
        static Parse(parsedMesh, scene) {
            const result = new GroundMesh(parsedMesh.name, scene);
            result._subdivisionsX = parsedMesh.subdivisionsX || 1;
            result._subdivisionsY = parsedMesh.subdivisionsY || 1;
            result._minX = parsedMesh.minX;
            result._maxX = parsedMesh.maxX;
            result._minZ = parsedMesh.minZ;
            result._maxZ = parsedMesh.maxZ;
            result._width = parsedMesh.width;
            result._height = parsedMesh.height;
            return result;
        }
    }

    /**
     * Creates the VertexData for a Ground
     * @param options an object used to set the following optional parameters for the Ground, required but can be empty
     *  - width the width (x direction) of the ground, optional, default 1
     *  - height the height (z direction) of the ground, optional, default 1
     *  - subdivisions the number of subdivisions per side, optional, default 1
     * @param options.width
     * @param options.height
     * @param options.subdivisions
     * @param options.subdivisionsX
     * @param options.subdivisionsY
     * @returns the VertexData of the Ground
     */
    function CreateGroundVertexData(options) {
        const indices = [];
        const positions = [];
        const normals = [];
        const uvs = [];
        let row, col;
        const width = options.width || 1;
        const height = options.height || 1;
        const subdivisionsX = (options.subdivisionsX || options.subdivisions || 1) | 0;
        const subdivisionsY = (options.subdivisionsY || options.subdivisions || 1) | 0;
        for (row = 0; row <= subdivisionsY; row++) {
            for (col = 0; col <= subdivisionsX; col++) {
                const position = new Vector3((col * width) / subdivisionsX - width / 2.0, 0, ((subdivisionsY - row) * height) / subdivisionsY - height / 2.0);
                const normal = new Vector3(0, 1.0, 0);
                positions.push(position.x, position.y, position.z);
                normals.push(normal.x, normal.y, normal.z);
                uvs.push(col / subdivisionsX, CompatibilityOptions.UseOpenGLOrientationForUV ? row / subdivisionsY : 1.0 - row / subdivisionsY);
            }
        }
        for (row = 0; row < subdivisionsY; row++) {
            for (col = 0; col < subdivisionsX; col++) {
                indices.push(col + 1 + (row + 1) * (subdivisionsX + 1));
                indices.push(col + 1 + row * (subdivisionsX + 1));
                indices.push(col + row * (subdivisionsX + 1));
                indices.push(col + (row + 1) * (subdivisionsX + 1));
                indices.push(col + 1 + (row + 1) * (subdivisionsX + 1));
                indices.push(col + row * (subdivisionsX + 1));
            }
        }
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates the VertexData for a TiledGround by subdividing the ground into tiles
     * @param options an object used to set the following optional parameters for the Ground, required but can be empty
     * * xmin the ground minimum X coordinate, optional, default -1
     * * zmin the ground minimum Z coordinate, optional, default -1
     * * xmax the ground maximum X coordinate, optional, default 1
     * * zmax the ground maximum Z coordinate, optional, default 1
     * * subdivisions a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the ground width and height creating 'tiles', default {w: 6, h: 6}
     * * precision a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the tile width and height, default {w: 2, h: 2}
     * @param options.xmin
     * @param options.zmin
     * @param options.xmax
     * @param options.zmax
     * @param options.subdivisions
     * @param options.subdivisions.w
     * @param options.subdivisions.h
     * @param options.precision
     * @param options.precision.w
     * @param options.precision.h
     * @returns the VertexData of the TiledGround
     */
    function CreateTiledGroundVertexData(options) {
        const xmin = options.xmin !== undefined && options.xmin !== null ? options.xmin : -1.0;
        const zmin = options.zmin !== undefined && options.zmin !== null ? options.zmin : -1.0;
        const xmax = options.xmax !== undefined && options.xmax !== null ? options.xmax : 1.0;
        const zmax = options.zmax !== undefined && options.zmax !== null ? options.zmax : 1.0;
        const subdivisions = options.subdivisions || { w: 1, h: 1 };
        const precision = options.precision || { w: 1, h: 1 };
        const indices = new Array();
        const positions = new Array();
        const normals = new Array();
        const uvs = new Array();
        let row, col, tileRow, tileCol;
        subdivisions.h = subdivisions.h < 1 ? 1 : subdivisions.h;
        subdivisions.w = subdivisions.w < 1 ? 1 : subdivisions.w;
        precision.w = precision.w < 1 ? 1 : precision.w;
        precision.h = precision.h < 1 ? 1 : precision.h;
        const tileSize = {
            w: (xmax - xmin) / subdivisions.w,
            h: (zmax - zmin) / subdivisions.h,
        };
        function applyTile(xTileMin, zTileMin, xTileMax, zTileMax) {
            // Indices
            const base = positions.length / 3;
            const rowLength = precision.w + 1;
            for (row = 0; row < precision.h; row++) {
                for (col = 0; col < precision.w; col++) {
                    const square = [base + col + row * rowLength, base + (col + 1) + row * rowLength, base + (col + 1) + (row + 1) * rowLength, base + col + (row + 1) * rowLength];
                    indices.push(square[1]);
                    indices.push(square[2]);
                    indices.push(square[3]);
                    indices.push(square[0]);
                    indices.push(square[1]);
                    indices.push(square[3]);
                }
            }
            // Position, normals and uvs
            const position = Vector3.Zero();
            const normal = new Vector3(0, 1.0, 0);
            for (row = 0; row <= precision.h; row++) {
                position.z = (row * (zTileMax - zTileMin)) / precision.h + zTileMin;
                for (col = 0; col <= precision.w; col++) {
                    position.x = (col * (xTileMax - xTileMin)) / precision.w + xTileMin;
                    position.y = 0;
                    positions.push(position.x, position.y, position.z);
                    normals.push(normal.x, normal.y, normal.z);
                    uvs.push(col / precision.w, row / precision.h);
                }
            }
        }
        for (tileRow = 0; tileRow < subdivisions.h; tileRow++) {
            for (tileCol = 0; tileCol < subdivisions.w; tileCol++) {
                applyTile(xmin + tileCol * tileSize.w, zmin + tileRow * tileSize.h, xmin + (tileCol + 1) * tileSize.w, zmin + (tileRow + 1) * tileSize.h);
            }
        }
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates the VertexData of the Ground designed from a heightmap
     * @param options an object used to set the following parameters for the Ground, required and provided by CreateGroundFromHeightMap
     * * width the width (x direction) of the ground
     * * height the height (z direction) of the ground
     * * subdivisions the number of subdivisions per side
     * * minHeight the minimum altitude on the ground, optional, default 0
     * * maxHeight the maximum altitude on the ground, optional default 1
     * * colorFilter the filter to apply to the image pixel colors to compute the height, optional Color3, default (0.3, 0.59, 0.11)
     * * buffer the array holding the image color data
     * * bufferWidth the width of image
     * * bufferHeight the height of image
     * * alphaFilter Remove any data where the alpha channel is below this value, defaults 0 (all data visible)
     * @param options.width
     * @param options.height
     * @param options.subdivisions
     * @param options.minHeight
     * @param options.maxHeight
     * @param options.colorFilter
     * @param options.buffer
     * @param options.bufferWidth
     * @param options.bufferHeight
     * @param options.alphaFilter
     * @returns the VertexData of the Ground designed from a heightmap
     */
    function CreateGroundFromHeightMapVertexData(options) {
        const indices = [];
        const positions = [];
        const normals = [];
        const uvs = [];
        let row, col;
        const filter = options.colorFilter || new Color3(0.3, 0.59, 0.11);
        const alphaFilter = options.alphaFilter || 0.0;
        let invert = false;
        if (options.minHeight > options.maxHeight) {
            invert = true;
            const temp = options.maxHeight;
            options.maxHeight = options.minHeight;
            options.minHeight = temp;
        }
        // Vertices
        for (row = 0; row <= options.subdivisions; row++) {
            for (col = 0; col <= options.subdivisions; col++) {
                const position = new Vector3((col * options.width) / options.subdivisions - options.width / 2.0, 0, ((options.subdivisions - row) * options.height) / options.subdivisions - options.height / 2.0);
                // Compute height
                const heightMapX = (((position.x + options.width / 2) / options.width) * (options.bufferWidth - 1)) | 0;
                const heightMapY = ((1.0 - (position.z + options.height / 2) / options.height) * (options.bufferHeight - 1)) | 0;
                const pos = (heightMapX + heightMapY * options.bufferWidth) * 4;
                let r = options.buffer[pos] / 255.0;
                let g = options.buffer[pos + 1] / 255.0;
                let b = options.buffer[pos + 2] / 255.0;
                const a = options.buffer[pos + 3] / 255.0;
                if (invert) {
                    r = 1.0 - r;
                    g = 1.0 - g;
                    b = 1.0 - b;
                }
                const gradient = r * filter.r + g * filter.g + b * filter.b;
                // If our alpha channel is not within our filter then we will assign a 'special' height
                // Then when building the indices, we will ignore any vertex that is using the special height
                if (a >= alphaFilter) {
                    position.y = options.minHeight + (options.maxHeight - options.minHeight) * gradient;
                }
                else {
                    position.y = options.minHeight - Epsilon; // We can't have a height below minHeight, normally.
                }
                // Add  vertex
                positions.push(position.x, position.y, position.z);
                normals.push(0, 0, 0);
                uvs.push(col / options.subdivisions, 1.0 - row / options.subdivisions);
            }
        }
        // Indices
        for (row = 0; row < options.subdivisions; row++) {
            for (col = 0; col < options.subdivisions; col++) {
                // Calculate Indices
                const idx1 = col + 1 + (row + 1) * (options.subdivisions + 1);
                const idx2 = col + 1 + row * (options.subdivisions + 1);
                const idx3 = col + row * (options.subdivisions + 1);
                const idx4 = col + (row + 1) * (options.subdivisions + 1);
                // Check that all indices are visible (based on our special height)
                // Only display the vertex if all Indices are visible
                // Positions are stored x,y,z for each vertex, hence the * 3 and + 1 for height
                const isVisibleIdx1 = positions[idx1 * 3 + 1] >= options.minHeight;
                const isVisibleIdx2 = positions[idx2 * 3 + 1] >= options.minHeight;
                const isVisibleIdx3 = positions[idx3 * 3 + 1] >= options.minHeight;
                if (isVisibleIdx1 && isVisibleIdx2 && isVisibleIdx3) {
                    indices.push(idx1);
                    indices.push(idx2);
                    indices.push(idx3);
                }
                const isVisibleIdx4 = positions[idx4 * 3 + 1] >= options.minHeight;
                if (isVisibleIdx4 && isVisibleIdx1 && isVisibleIdx3) {
                    indices.push(idx4);
                    indices.push(idx1);
                    indices.push(idx3);
                }
            }
        }
        // Normals
        VertexData.ComputeNormals(positions, indices, normals);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a ground mesh
     * * The parameters `width` and `height` (floats, default 1) set the width and height sizes of the ground
     * * The parameter `subdivisions` (positive integer) sets the number of subdivisions per side
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.width
     * @param options.height
     * @param options.subdivisions
     * @param options.subdivisionsX
     * @param options.subdivisionsY
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the ground mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#ground
     */
    function CreateGround(name, options = {}, scene) {
        const ground = new GroundMesh(name, scene);
        ground._setReady(false);
        ground._subdivisionsX = options.subdivisionsX || options.subdivisions || 1;
        ground._subdivisionsY = options.subdivisionsY || options.subdivisions || 1;
        ground._width = options.width || 1;
        ground._height = options.height || 1;
        ground._maxX = ground._width / 2;
        ground._maxZ = ground._height / 2;
        ground._minX = -ground._maxX;
        ground._minZ = -ground._maxZ;
        const vertexData = CreateGroundVertexData(options);
        vertexData.applyToMesh(ground, options.updatable);
        ground._setReady(true);
        return ground;
    }
    /**
     * Creates a tiled ground mesh
     * * The parameters `xmin` and `xmax` (floats, default -1 and 1) set the ground minimum and maximum X coordinates
     * * The parameters `zmin` and `zmax` (floats, default -1 and 1) set the ground minimum and maximum Z coordinates
     * * The parameter `subdivisions` is a javascript object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
     * * The parameter `precision` is a javascript object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.xmin
     * @param options.zmin
     * @param options.xmax
     * @param options.zmax
     * @param options.subdivisions
     * @param options.subdivisions.w
     * @param options.subdivisions.h
     * @param options.precision
     * @param options.precision.w
     * @param options.precision.h
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the tiled ground mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#tiled-ground
     */
    function CreateTiledGround(name, options, scene = null) {
        const tiledGround = new Mesh(name, scene);
        const vertexData = CreateTiledGroundVertexData(options);
        vertexData.applyToMesh(tiledGround, options.updatable);
        return tiledGround;
    }
    /**
     * Creates a ground mesh from a height map
     * * The parameter `url` sets the URL of the height map image resource.
     * * The parameters `width` and `height` (positive floats, default 10) set the ground width and height sizes.
     * * The parameter `subdivisions` (positive integer, default 1) sets the number of subdivision per side.
     * * The parameter `minHeight` (float, default 0) is the minimum altitude on the ground.
     * * The parameter `maxHeight` (float, default 1) is the maximum altitude on the ground.
     * * The parameter `colorFilter` (optional Color3, default (0.3, 0.59, 0.11) ) is the filter to apply to the image pixel colors to compute the height.
     * * The parameter `onReady` is a javascript callback function that will be called  once the mesh is just built (the height map download can last some time).
     * * The parameter `alphaFilter` will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * @param name defines the name of the mesh
     * @param url defines the url to the height map
     * @param options defines the options used to create the mesh
     * @param options.width
     * @param options.height
     * @param options.subdivisions
     * @param options.minHeight
     * @param options.maxHeight
     * @param options.colorFilter
     * @param options.alphaFilter
     * @param options.updatable
     * @param options.onReady
     * @param scene defines the hosting scene
     * @returns the ground mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/height_map
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#ground-from-a-height-map
     */
    function CreateGroundFromHeightMap(name, url, options = {}, scene = null) {
        const width = options.width || 10.0;
        const height = options.height || 10.0;
        const subdivisions = options.subdivisions || 1 | 0;
        const minHeight = options.minHeight || 0.0;
        const maxHeight = options.maxHeight || 1.0;
        const filter = options.colorFilter || new Color3(0.3, 0.59, 0.11);
        const alphaFilter = options.alphaFilter || 0.0;
        const updatable = options.updatable;
        const onReady = options.onReady;
        scene = scene || EngineStore.LastCreatedScene;
        const ground = new GroundMesh(name, scene);
        ground._subdivisionsX = subdivisions;
        ground._subdivisionsY = subdivisions;
        ground._width = width;
        ground._height = height;
        ground._maxX = ground._width / 2.0;
        ground._maxZ = ground._height / 2.0;
        ground._minX = -ground._maxX;
        ground._minZ = -ground._maxZ;
        ground._setReady(false);
        const onload = (img) => {
            const bufferWidth = img.width;
            const bufferHeight = img.height;
            if (scene.isDisposed) {
                return;
            }
            const buffer = scene === null || scene === void 0 ? void 0 : scene.getEngine().resizeImageBitmap(img, bufferWidth, bufferHeight);
            const vertexData = CreateGroundFromHeightMapVertexData({
                width: width,
                height: height,
                subdivisions: subdivisions,
                minHeight: minHeight,
                maxHeight: maxHeight,
                colorFilter: filter,
                buffer: buffer,
                bufferWidth: bufferWidth,
                bufferHeight: bufferHeight,
                alphaFilter: alphaFilter,
            });
            vertexData.applyToMesh(ground, updatable);
            //execute ready callback, if set
            if (onReady) {
                onReady(ground);
            }
            ground._setReady(true);
        };
        Tools.LoadImage(url, onload, () => { }, scene.offlineProvider);
        return ground;
    }
    /**
     * Class containing static functions to help procedurally build meshes
     * @deprecated use the functions directly from the module
     */
    const GroundBuilder = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreateGround,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreateGroundFromHeightMap,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreateTiledGround,
    };
    VertexData.CreateGround = CreateGroundVertexData;
    VertexData.CreateTiledGround = CreateTiledGroundVertexData;
    VertexData.CreateGroundFromHeightMap = CreateGroundFromHeightMapVertexData;
    Mesh.CreateGround = (name, width, height, subdivisions, scene, updatable) => {
        const options = {
            width,
            height,
            subdivisions,
            updatable,
        };
        return CreateGround(name, options, scene);
    };
    Mesh.CreateTiledGround = (name, xmin, zmin, xmax, zmax, subdivisions, precision, scene, updatable) => {
        const options = {
            xmin,
            zmin,
            xmax,
            zmax,
            subdivisions,
            precision,
            updatable,
        };
        return CreateTiledGround(name, options, scene);
    };
    Mesh.CreateGroundFromHeightMap = (name, url, width, height, subdivisions, minHeight, maxHeight, scene, updatable, onReady, alphaFilter) => {
        const options = {
            width,
            height,
            subdivisions,
            minHeight,
            maxHeight,
            updatable,
            onReady,
            alphaFilter,
        };
        return CreateGroundFromHeightMap(name, url, options, scene);
    };

    /**
     * Creates the VertexData for a box
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * size sets the width, height and depth of the box to the value of size, optional default 1
     * * width sets the width (x direction) of the box, overwrites the width set by size, optional, default size
     * * height sets the height (y direction) of the box, overwrites the height set by size, optional, default size
     * * depth sets the depth (z direction) of the box, overwrites the depth set by size, optional, default size
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.depth
     * @param options.faceUV
     * @param options.faceColors
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.wrap
     * @param options.topBaseAt
     * @param options.bottomBaseAt
     * @returns the VertexData of the box
     */
    function CreateBoxVertexData(options) {
        const nbFaces = 6;
        let indices = [0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23];
        const normals = [
            0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0,
            1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,
        ];
        const uvs = [];
        let positions = [];
        const width = options.width || options.size || 1;
        const height = options.height || options.size || 1;
        const depth = options.depth || options.size || 1;
        const wrap = options.wrap || false;
        let topBaseAt = options.topBaseAt === void 0 ? 1 : options.topBaseAt;
        let bottomBaseAt = options.bottomBaseAt === void 0 ? 0 : options.bottomBaseAt;
        topBaseAt = (topBaseAt + 4) % 4; // places values as 0 to 3
        bottomBaseAt = (bottomBaseAt + 4) % 4; // places values as 0 to 3
        const topOrder = [2, 0, 3, 1];
        const bottomOrder = [2, 0, 1, 3];
        let topIndex = topOrder[topBaseAt];
        let bottomIndex = bottomOrder[bottomBaseAt];
        let basePositions = [
            1, -1, 1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, 1, -1, 1, -1, -1, 1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1,
            1, 1, -1, 1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, -1, -1, -1, -1, -1, 1,
        ];
        if (wrap) {
            indices = [2, 3, 0, 2, 0, 1, 4, 5, 6, 4, 6, 7, 9, 10, 11, 9, 11, 8, 12, 14, 15, 12, 13, 14];
            basePositions = [
                -1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, 1, 1, 1, 1, -1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1,
            ];
            let topFaceBase = [
                [1, 1, 1],
                [-1, 1, 1],
                [-1, 1, -1],
                [1, 1, -1],
            ];
            let bottomFaceBase = [
                [-1, -1, 1],
                [1, -1, 1],
                [1, -1, -1],
                [-1, -1, -1],
            ];
            const topFaceOrder = [17, 18, 19, 16];
            const bottomFaceOrder = [22, 23, 20, 21];
            while (topIndex > 0) {
                topFaceBase.unshift(topFaceBase.pop());
                topFaceOrder.unshift(topFaceOrder.pop());
                topIndex--;
            }
            while (bottomIndex > 0) {
                bottomFaceBase.unshift(bottomFaceBase.pop());
                bottomFaceOrder.unshift(bottomFaceOrder.pop());
                bottomIndex--;
            }
            topFaceBase = topFaceBase.flat();
            bottomFaceBase = bottomFaceBase.flat();
            basePositions = basePositions.concat(topFaceBase).concat(bottomFaceBase);
            indices.push(topFaceOrder[0], topFaceOrder[2], topFaceOrder[3], topFaceOrder[0], topFaceOrder[1], topFaceOrder[2]);
            indices.push(bottomFaceOrder[0], bottomFaceOrder[2], bottomFaceOrder[3], bottomFaceOrder[0], bottomFaceOrder[1], bottomFaceOrder[2]);
        }
        const scaleArray = [width / 2, height / 2, depth / 2];
        positions = basePositions.reduce((accumulator, currentValue, currentIndex) => accumulator.concat(currentValue * scaleArray[currentIndex % 3]), []);
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const faceUV = options.faceUV || new Array(6);
        const faceColors = options.faceColors;
        const colors = [];
        // default face colors and UV if undefined
        for (let f = 0; f < 6; f++) {
            if (faceUV[f] === undefined) {
                faceUV[f] = new Vector4(0, 0, 1, 1);
            }
            if (faceColors && faceColors[f] === undefined) {
                faceColors[f] = new Color4(1, 1, 1, 1);
            }
        }
        // Create each face in turn.
        for (let index = 0; index < nbFaces; index++) {
            uvs.push(faceUV[index].z, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - faceUV[index].w : faceUV[index].w);
            uvs.push(faceUV[index].x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - faceUV[index].w : faceUV[index].w);
            uvs.push(faceUV[index].x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - faceUV[index].y : faceUV[index].y);
            uvs.push(faceUV[index].z, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - faceUV[index].y : faceUV[index].y);
            if (faceColors) {
                for (let c = 0; c < 4; c++) {
                    colors.push(faceColors[index].r, faceColors[index].g, faceColors[index].b, faceColors[index].a);
                }
            }
        }
        // sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        if (faceColors) {
            const totalColors = sideOrientation === VertexData.DOUBLESIDE ? colors.concat(colors) : colors;
            vertexData.colors = totalColors;
        }
        return vertexData;
    }
    /**
     * Creates a box mesh
     * * The parameter `size` sets the size (float) of each box side (default 1)
     * * You can set some different box dimensions by using the parameters `width`, `height` and `depth` (all by default have the same value of `size`)
     * * You can set different colors and different images to each box side by using the parameters `faceColors` (an array of 6 Color3 elements) and `faceUV` (an array of 6 Vector4 elements)
     * * Please read this tutorial : https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#box
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.depth
     * @param options.faceUV
     * @param options.faceColors
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.wrap
     * @param options.topBaseAt
     * @param options.bottomBaseAt
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the box mesh
     */
    function CreateBox(name, options = {}, scene = null) {
        const box = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        box._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateBoxVertexData(options);
        vertexData.applyToMesh(box, options.updatable);
        return box;
    }
    /**
     * Class containing static functions to help procedurally build meshes
     * @deprecated please use CreateBox directly
     */
    const BoxBuilder = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreateBox,
    };
    // Side effects
    VertexData.CreateBox = CreateBoxVertexData;
    Mesh.CreateBox = (name, size, scene = null, updatable, sideOrientation) => {
        const options = {
            size,
            sideOrientation,
            updatable,
        };
        return CreateBox(name, options, scene);
    };

    /**
     * The EnvironmentHelper class can be used to add a fully featured non-expensive background to your scene.
     * It includes by default a skybox and a ground relying on the BackgroundMaterial.
     * It also helps with the default setup of your ImageProcessingConfiguration.
     */
    class EnvironmentHelper {
        /**
         * Creates the default options for the helper.
         * @param scene The scene the environment helper belongs to.
         */
        static _GetDefaultOptions(scene) {
            return {
                createGround: true,
                groundSize: 15,
                groundTexture: this._GroundTextureCDNUrl,
                groundColor: new Color3(0.2, 0.2, 0.3).toLinearSpace(scene.getEngine().useExactSrgbConversions).scale(3),
                groundOpacity: 0.9,
                enableGroundShadow: true,
                groundShadowLevel: 0.5,
                enableGroundMirror: false,
                groundMirrorSizeRatio: 0.3,
                groundMirrorBlurKernel: 64,
                groundMirrorAmount: 1,
                groundMirrorFresnelWeight: 1,
                groundMirrorFallOffDistance: 0,
                groundMirrorTextureType: 0,
                groundYBias: 0.00001,
                createSkybox: true,
                skyboxSize: 20,
                skyboxTexture: this._SkyboxTextureCDNUrl,
                skyboxColor: new Color3(0.2, 0.2, 0.3).toLinearSpace(scene.getEngine().useExactSrgbConversions).scale(3),
                backgroundYRotation: 0,
                sizeAuto: true,
                rootPosition: Vector3.Zero(),
                setupImageProcessing: true,
                environmentTexture: this._EnvironmentTextureCDNUrl,
                cameraExposure: 0.8,
                cameraContrast: 1.2,
                toneMappingEnabled: true,
            };
        }
        /**
         * Gets the root mesh created by the helper.
         */
        get rootMesh() {
            return this._rootMesh;
        }
        /**
         * Gets the skybox created by the helper.
         */
        get skybox() {
            return this._skybox;
        }
        /**
         * Gets the skybox texture created by the helper.
         */
        get skyboxTexture() {
            return this._skyboxTexture;
        }
        /**
         * Gets the skybox material created by the helper.
         */
        get skyboxMaterial() {
            return this._skyboxMaterial;
        }
        /**
         * Gets the ground mesh created by the helper.
         */
        get ground() {
            return this._ground;
        }
        /**
         * Gets the ground texture created by the helper.
         */
        get groundTexture() {
            return this._groundTexture;
        }
        /**
         * Gets the ground mirror created by the helper.
         */
        get groundMirror() {
            return this._groundMirror;
        }
        /**
         * Gets the ground mirror render list to helps pushing the meshes
         * you wish in the ground reflection.
         */
        get groundMirrorRenderList() {
            if (this._groundMirror) {
                return this._groundMirror.renderList;
            }
            return null;
        }
        /**
         * Gets the ground material created by the helper.
         */
        get groundMaterial() {
            return this._groundMaterial;
        }
        /**
         * constructor
         * @param options Defines the options we want to customize the helper
         * @param scene The scene to add the material to
         */
        constructor(options, scene) {
            this._errorHandler = (message, exception) => {
                this.onErrorObservable.notifyObservers({ message: message, exception: exception });
            };
            this._options = Object.assign(Object.assign({}, EnvironmentHelper._GetDefaultOptions(scene)), options);
            this._scene = scene;
            this.onErrorObservable = new Observable$1();
            this._setupBackground();
            this._setupImageProcessing();
        }
        /**
         * Updates the background according to the new options
         * @param options
         */
        updateOptions(options) {
            const newOptions = Object.assign(Object.assign({}, this._options), options);
            if (this._ground && !newOptions.createGround) {
                this._ground.dispose();
                this._ground = null;
            }
            if (this._groundMaterial && !newOptions.createGround) {
                this._groundMaterial.dispose();
                this._groundMaterial = null;
            }
            if (this._groundTexture) {
                if (this._options.groundTexture != newOptions.groundTexture) {
                    this._groundTexture.dispose();
                    this._groundTexture = null;
                }
            }
            if (this._skybox && !newOptions.createSkybox) {
                this._skybox.dispose();
                this._skybox = null;
            }
            if (this._skyboxMaterial && !newOptions.createSkybox) {
                this._skyboxMaterial.dispose();
                this._skyboxMaterial = null;
            }
            if (this._skyboxTexture) {
                if (this._options.skyboxTexture != newOptions.skyboxTexture) {
                    this._skyboxTexture.dispose();
                    this._skyboxTexture = null;
                }
            }
            if (this._groundMirror && !newOptions.enableGroundMirror) {
                this._groundMirror.dispose();
                this._groundMirror = null;
            }
            if (this._scene.environmentTexture) {
                if (this._options.environmentTexture != newOptions.environmentTexture) {
                    this._scene.environmentTexture.dispose();
                }
            }
            this._options = newOptions;
            this._setupBackground();
            this._setupImageProcessing();
        }
        /**
         * Sets the primary color of all the available elements.
         * @param color the main color to affect to the ground and the background
         */
        setMainColor(color) {
            if (this.groundMaterial) {
                this.groundMaterial.primaryColor = color;
            }
            if (this.skyboxMaterial) {
                this.skyboxMaterial.primaryColor = color;
            }
            if (this.groundMirror) {
                this.groundMirror.clearColor = new Color4(color.r, color.g, color.b, 1.0);
            }
        }
        /**
         * Setup the image processing according to the specified options.
         */
        _setupImageProcessing() {
            if (this._options.setupImageProcessing) {
                this._scene.imageProcessingConfiguration.contrast = this._options.cameraContrast;
                this._scene.imageProcessingConfiguration.exposure = this._options.cameraExposure;
                this._scene.imageProcessingConfiguration.toneMappingEnabled = this._options.toneMappingEnabled;
                this._setupEnvironmentTexture();
            }
        }
        /**
         * Setup the environment texture according to the specified options.
         */
        _setupEnvironmentTexture() {
            if (this._scene.environmentTexture) {
                return;
            }
            if (this._options.environmentTexture instanceof BaseTexture) {
                this._scene.environmentTexture = this._options.environmentTexture;
                return;
            }
            const environmentTexture = CubeTexture.CreateFromPrefilteredData(this._options.environmentTexture, this._scene);
            this._scene.environmentTexture = environmentTexture;
        }
        /**
         * Setup the background according to the specified options.
         */
        _setupBackground() {
            if (!this._rootMesh) {
                this._rootMesh = new Mesh("BackgroundHelper", this._scene);
            }
            this._rootMesh.rotation.y = this._options.backgroundYRotation;
            const sceneSize = this._getSceneSize();
            if (this._options.createGround) {
                this._setupGround(sceneSize);
                this._setupGroundMaterial();
                this._setupGroundDiffuseTexture();
                if (this._options.enableGroundMirror) {
                    this._setupGroundMirrorTexture(sceneSize);
                }
                this._setupMirrorInGroundMaterial();
            }
            if (this._options.createSkybox) {
                this._setupSkybox(sceneSize);
                this._setupSkyboxMaterial();
                this._setupSkyboxReflectionTexture();
            }
            this._rootMesh.position.x = sceneSize.rootPosition.x;
            this._rootMesh.position.z = sceneSize.rootPosition.z;
            this._rootMesh.position.y = sceneSize.rootPosition.y;
        }
        /**
         * Get the scene sizes according to the setup.
         */
        _getSceneSize() {
            let groundSize = this._options.groundSize;
            let skyboxSize = this._options.skyboxSize;
            let rootPosition = this._options.rootPosition;
            if (!this._scene.meshes || this._scene.meshes.length === 1) {
                // 1 only means the root of the helper.
                return { groundSize, skyboxSize, rootPosition };
            }
            const sceneExtends = this._scene.getWorldExtends((mesh) => {
                return mesh !== this._ground && mesh !== this._rootMesh && mesh !== this._skybox;
            });
            const sceneDiagonal = sceneExtends.max.subtract(sceneExtends.min);
            if (this._options.sizeAuto) {
                if (this._scene.activeCamera instanceof ArcRotateCamera && this._scene.activeCamera.upperRadiusLimit) {
                    groundSize = this._scene.activeCamera.upperRadiusLimit * 2;
                    skyboxSize = groundSize;
                }
                const sceneDiagonalLenght = sceneDiagonal.length();
                if (sceneDiagonalLenght > groundSize) {
                    groundSize = sceneDiagonalLenght * 2;
                    skyboxSize = groundSize;
                }
                // 10 % bigger.
                groundSize *= 1.1;
                skyboxSize *= 1.5;
                rootPosition = sceneExtends.min.add(sceneDiagonal.scale(0.5));
                rootPosition.y = sceneExtends.min.y - this._options.groundYBias;
            }
            return { groundSize, skyboxSize, rootPosition };
        }
        /**
         * Setup the ground according to the specified options.
         * @param sceneSize
         */
        _setupGround(sceneSize) {
            if (!this._ground || this._ground.isDisposed()) {
                this._ground = CreatePlane("BackgroundPlane", { size: sceneSize.groundSize }, this._scene);
                this._ground.rotation.x = Math.PI / 2; // Face up by default.
                this._ground.parent = this._rootMesh;
                this._ground.onDisposeObservable.add(() => {
                    this._ground = null;
                });
            }
            this._ground.receiveShadows = this._options.enableGroundShadow;
        }
        /**
         * Setup the ground material according to the specified options.
         */
        _setupGroundMaterial() {
            if (!this._groundMaterial) {
                this._groundMaterial = new BackgroundMaterial("BackgroundPlaneMaterial", this._scene);
            }
            this._groundMaterial.alpha = this._options.groundOpacity;
            this._groundMaterial.alphaMode = 8;
            this._groundMaterial.shadowLevel = this._options.groundShadowLevel;
            this._groundMaterial.primaryColor = this._options.groundColor;
            this._groundMaterial.useRGBColor = false;
            this._groundMaterial.enableNoise = true;
            if (this._ground) {
                this._ground.material = this._groundMaterial;
            }
        }
        /**
         * Setup the ground diffuse texture according to the specified options.
         */
        _setupGroundDiffuseTexture() {
            if (!this._groundMaterial) {
                return;
            }
            if (this._groundTexture) {
                return;
            }
            if (this._options.groundTexture instanceof BaseTexture) {
                this._groundMaterial.diffuseTexture = this._options.groundTexture;
                return;
            }
            this._groundTexture = new Texture(this._options.groundTexture, this._scene, undefined, undefined, undefined, undefined, this._errorHandler);
            this._groundTexture.gammaSpace = false;
            this._groundTexture.hasAlpha = true;
            this._groundMaterial.diffuseTexture = this._groundTexture;
        }
        /**
         * Setup the ground mirror texture according to the specified options.
         * @param sceneSize
         */
        _setupGroundMirrorTexture(sceneSize) {
            const wrapping = Texture.CLAMP_ADDRESSMODE;
            if (!this._groundMirror) {
                this._groundMirror = new MirrorTexture("BackgroundPlaneMirrorTexture", { ratio: this._options.groundMirrorSizeRatio }, this._scene, false, this._options.groundMirrorTextureType, Texture.BILINEAR_SAMPLINGMODE, true);
                this._groundMirror.mirrorPlane = new Plane(0, -1, 0, sceneSize.rootPosition.y);
                this._groundMirror.anisotropicFilteringLevel = 1;
                this._groundMirror.wrapU = wrapping;
                this._groundMirror.wrapV = wrapping;
                if (this._groundMirror.renderList) {
                    for (let i = 0; i < this._scene.meshes.length; i++) {
                        const mesh = this._scene.meshes[i];
                        if (mesh !== this._ground && mesh !== this._skybox && mesh !== this._rootMesh) {
                            this._groundMirror.renderList.push(mesh);
                        }
                    }
                }
            }
            const gammaGround = this._options.groundColor.toGammaSpace(this._scene.getEngine().useExactSrgbConversions);
            this._groundMirror.clearColor = new Color4(gammaGround.r, gammaGround.g, gammaGround.b, 1);
            this._groundMirror.adaptiveBlurKernel = this._options.groundMirrorBlurKernel;
        }
        /**
         * Setup the ground to receive the mirror texture.
         */
        _setupMirrorInGroundMaterial() {
            if (this._groundMaterial) {
                this._groundMaterial.reflectionTexture = this._groundMirror;
                this._groundMaterial.reflectionFresnel = true;
                this._groundMaterial.reflectionAmount = this._options.groundMirrorAmount;
                this._groundMaterial.reflectionStandardFresnelWeight = this._options.groundMirrorFresnelWeight;
                this._groundMaterial.reflectionFalloffDistance = this._options.groundMirrorFallOffDistance;
            }
        }
        /**
         * Setup the skybox according to the specified options.
         * @param sceneSize
         */
        _setupSkybox(sceneSize) {
            if (!this._skybox || this._skybox.isDisposed()) {
                this._skybox = CreateBox("BackgroundSkybox", { size: sceneSize.skyboxSize, sideOrientation: Mesh.BACKSIDE }, this._scene);
                this._skybox.onDisposeObservable.add(() => {
                    this._skybox = null;
                });
            }
            this._skybox.parent = this._rootMesh;
        }
        /**
         * Setup the skybox material according to the specified options.
         */
        _setupSkyboxMaterial() {
            if (!this._skybox) {
                return;
            }
            if (!this._skyboxMaterial) {
                this._skyboxMaterial = new BackgroundMaterial("BackgroundSkyboxMaterial", this._scene);
            }
            this._skyboxMaterial.useRGBColor = false;
            this._skyboxMaterial.primaryColor = this._options.skyboxColor;
            this._skyboxMaterial.enableNoise = true;
            this._skybox.material = this._skyboxMaterial;
        }
        /**
         * Setup the skybox reflection texture according to the specified options.
         */
        _setupSkyboxReflectionTexture() {
            if (!this._skyboxMaterial) {
                return;
            }
            if (this._skyboxTexture) {
                return;
            }
            if (this._options.skyboxTexture instanceof BaseTexture) {
                this._skyboxMaterial.reflectionTexture = this._options.skyboxTexture;
                return;
            }
            this._skyboxTexture = new CubeTexture(this._options.skyboxTexture, this._scene, undefined, undefined, undefined, undefined, this._errorHandler);
            this._skyboxTexture.coordinatesMode = Texture.SKYBOX_MODE;
            this._skyboxTexture.gammaSpace = false;
            this._skyboxMaterial.reflectionTexture = this._skyboxTexture;
        }
        /**
         * Dispose all the elements created by the Helper.
         */
        dispose() {
            if (this._groundMaterial) {
                this._groundMaterial.dispose(true, true);
            }
            if (this._skyboxMaterial) {
                this._skyboxMaterial.dispose(true, true);
            }
            this._rootMesh.dispose(false);
        }
    }
    /**
     * Default ground texture URL.
     */
    EnvironmentHelper._GroundTextureCDNUrl = "https://assets.babylonjs.com/environments/backgroundGround.png";
    /**
     * Default skybox texture URL.
     */
    EnvironmentHelper._SkyboxTextureCDNUrl = "https://assets.babylonjs.com/environments/backgroundSkybox.dds";
    /**
     * Default environment texture URL.
     */
    EnvironmentHelper._EnvironmentTextureCDNUrl = "https://assets.babylonjs.com/environments/environmentSpecular.env";

    /**
     * Manage the keyboard inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraKeyboardMoveInput {
        constructor() {
            /**
             * Gets or Set the list of keyboard keys used to control the forward move of the camera.
             */
            this.keysUp = [38];
            /**
             * Gets or Set the list of keyboard keys used to control the upward move of the camera.
             */
            this.keysUpward = [33];
            /**
             * Gets or Set the list of keyboard keys used to control the backward move of the camera.
             */
            this.keysDown = [40];
            /**
             * Gets or Set the list of keyboard keys used to control the downward move of the camera.
             */
            this.keysDownward = [34];
            /**
             * Gets or Set the list of keyboard keys used to control the left strafe move of the camera.
             */
            this.keysLeft = [37];
            /**
             * Gets or Set the list of keyboard keys used to control the right strafe move of the camera.
             */
            this.keysRight = [39];
            /**
             * Defines the pointer angular sensibility  along the X and Y axis or how fast is the camera rotating.
             */
            this.rotationSpeed = 0.5;
            /**
             * Gets or Set the list of keyboard keys used to control the left rotation move of the camera.
             */
            this.keysRotateLeft = [];
            /**
             * Gets or Set the list of keyboard keys used to control the right rotation move of the camera.
             */
            this.keysRotateRight = [];
            /**
             * Gets or Set the list of keyboard keys used to control the up rotation move of the camera.
             */
            this.keysRotateUp = [];
            /**
             * Gets or Set the list of keyboard keys used to control the down rotation move of the camera.
             */
            this.keysRotateDown = [];
            this._keys = new Array();
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            if (this._onCanvasBlurObserver) {
                return;
            }
            this._scene = this.camera.getScene();
            this._engine = this._scene.getEngine();
            this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(() => {
                this._keys.length = 0;
            });
            this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info) => {
                const evt = info.event;
                if (!evt.metaKey) {
                    if (info.type === KeyboardEventTypes.KEYDOWN) {
                        if (this.keysUp.indexOf(evt.keyCode) !== -1 ||
                            this.keysDown.indexOf(evt.keyCode) !== -1 ||
                            this.keysLeft.indexOf(evt.keyCode) !== -1 ||
                            this.keysRight.indexOf(evt.keyCode) !== -1 ||
                            this.keysUpward.indexOf(evt.keyCode) !== -1 ||
                            this.keysDownward.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateLeft.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateRight.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateUp.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateDown.indexOf(evt.keyCode) !== -1) {
                            const index = this._keys.indexOf(evt.keyCode);
                            if (index === -1) {
                                this._keys.push(evt.keyCode);
                            }
                            if (!noPreventDefault) {
                                evt.preventDefault();
                            }
                        }
                    }
                    else {
                        if (this.keysUp.indexOf(evt.keyCode) !== -1 ||
                            this.keysDown.indexOf(evt.keyCode) !== -1 ||
                            this.keysLeft.indexOf(evt.keyCode) !== -1 ||
                            this.keysRight.indexOf(evt.keyCode) !== -1 ||
                            this.keysUpward.indexOf(evt.keyCode) !== -1 ||
                            this.keysDownward.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateLeft.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateRight.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateUp.indexOf(evt.keyCode) !== -1 ||
                            this.keysRotateDown.indexOf(evt.keyCode) !== -1) {
                            const index = this._keys.indexOf(evt.keyCode);
                            if (index >= 0) {
                                this._keys.splice(index, 1);
                            }
                            if (!noPreventDefault) {
                                evt.preventDefault();
                            }
                        }
                    }
                }
            });
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._scene) {
                if (this._onKeyboardObserver) {
                    this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
                }
                if (this._onCanvasBlurObserver) {
                    this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
                }
                this._onKeyboardObserver = null;
                this._onCanvasBlurObserver = null;
            }
            this._keys.length = 0;
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            if (this._onKeyboardObserver) {
                const camera = this.camera;
                // Keyboard
                for (let index = 0; index < this._keys.length; index++) {
                    const keyCode = this._keys[index];
                    const speed = camera._computeLocalCameraSpeed();
                    if (this.keysLeft.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(-speed, 0, 0);
                    }
                    else if (this.keysUp.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, 0, speed);
                    }
                    else if (this.keysRight.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(speed, 0, 0);
                    }
                    else if (this.keysDown.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, 0, -speed);
                    }
                    else if (this.keysUpward.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, speed, 0);
                    }
                    else if (this.keysDownward.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, -speed, 0);
                    }
                    else if (this.keysRotateLeft.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, 0, 0);
                        camera.cameraRotation.y -= this._getLocalRotation();
                    }
                    else if (this.keysRotateRight.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, 0, 0);
                        camera.cameraRotation.y += this._getLocalRotation();
                    }
                    else if (this.keysRotateUp.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, 0, 0);
                        camera.cameraRotation.x -= this._getLocalRotation();
                    }
                    else if (this.keysRotateDown.indexOf(keyCode) !== -1) {
                        camera._localDirection.copyFromFloats(0, 0, 0);
                        camera.cameraRotation.x += this._getLocalRotation();
                    }
                    if (camera.getScene().useRightHandedSystem) {
                        camera._localDirection.z *= -1;
                    }
                    camera.getViewMatrix().invertToRef(camera._cameraTransformMatrix);
                    Vector3.TransformNormalToRef(camera._localDirection, camera._cameraTransformMatrix, camera._transformedDirection);
                    camera.cameraDirection.addInPlace(camera._transformedDirection);
                }
            }
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "FreeCameraKeyboardMoveInput";
        }
        /** @internal */
        _onLostFocus() {
            this._keys.length = 0;
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "keyboard";
        }
        _getLocalRotation() {
            let rotation = (this.rotationSpeed * this._engine.getDeltaTime()) / 1000;
            if (this.camera.getScene().useRightHandedSystem) {
                rotation *= -1;
            }
            if (this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0) {
                rotation *= -1;
            }
            return rotation;
        }
    }
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysUp", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysUpward", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysDown", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysDownward", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysLeft", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysRight", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "rotationSpeed", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysRotateLeft", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysRotateRight", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysRotateUp", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraKeyboardMoveInput.prototype, "keysRotateDown", void 0);
    CameraInputTypes["FreeCameraKeyboardMoveInput"] = FreeCameraKeyboardMoveInput;

    /**
     * Manage the mouse inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraMouseInput {
        /**
         * Manage the mouse inputs to control the movement of a free camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
         * @param touchEnabled Defines if touch is enabled or not
         */
        constructor(
        /**
         * Define if touch is enabled in the mouse input
         */
        touchEnabled = true) {
            this.touchEnabled = touchEnabled;
            /**
             * Defines the buttons associated with the input to handle camera move.
             */
            this.buttons = [0, 1, 2];
            /**
             * Defines the pointer angular sensibility  along the X and Y axis or how fast is the camera rotating.
             */
            this.angularSensibility = 2000.0;
            this._previousPosition = null;
            /**
             * Observable for when a pointer move event occurs containing the move offset
             */
            this.onPointerMovedObservable = new Observable$1();
            /**
             * @internal
             * If the camera should be rotated automatically based on pointer movement
             */
            this._allowCameraRotation = true;
            this._currentActiveButton = -1;
            this._activePointerId = -1;
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            const engine = this.camera.getEngine();
            const element = engine.getInputElement();
            if (!this._pointerInput) {
                this._pointerInput = (p) => {
                    const evt = p.event;
                    const isTouch = evt.pointerType === "touch";
                    if (engine.isInVRExclusivePointerMode) {
                        return;
                    }
                    if (!this.touchEnabled && isTouch) {
                        return;
                    }
                    if (p.type !== PointerEventTypes.POINTERMOVE && this.buttons.indexOf(evt.button) === -1) {
                        return;
                    }
                    const srcElement = evt.target;
                    if (p.type === PointerEventTypes.POINTERDOWN) {
                        // If the input is touch with more than one touch OR if the input is mouse and there is already an active button, return
                        if ((isTouch && this._activePointerId !== -1) || (!isTouch && this._currentActiveButton !== -1)) {
                            return;
                        }
                        this._activePointerId = evt.pointerId;
                        try {
                            srcElement === null || srcElement === void 0 ? void 0 : srcElement.setPointerCapture(evt.pointerId);
                        }
                        catch (e) {
                            //Nothing to do with the error. Execution will continue.
                        }
                        if (this._currentActiveButton === -1) {
                            this._currentActiveButton = evt.button;
                        }
                        this._previousPosition = {
                            x: evt.clientX,
                            y: evt.clientY,
                        };
                        if (!noPreventDefault) {
                            evt.preventDefault();
                            element && element.focus();
                        }
                        // This is required to move while pointer button is down
                        if (engine.isPointerLock && this._onMouseMove) {
                            this._onMouseMove(p.event);
                        }
                    }
                    else if (p.type === PointerEventTypes.POINTERUP) {
                        // If input is touch with a different touch id OR if input is mouse with a different button, return
                        if ((isTouch && this._activePointerId !== evt.pointerId) || (!isTouch && this._currentActiveButton !== evt.button)) {
                            return;
                        }
                        try {
                            srcElement === null || srcElement === void 0 ? void 0 : srcElement.releasePointerCapture(evt.pointerId);
                        }
                        catch (e) {
                            //Nothing to do with the error.
                        }
                        this._currentActiveButton = -1;
                        this._previousPosition = null;
                        if (!noPreventDefault) {
                            evt.preventDefault();
                        }
                        this._activePointerId = -1;
                    }
                    else if (p.type === PointerEventTypes.POINTERMOVE && (this._activePointerId === evt.pointerId || !isTouch)) {
                        if (engine.isPointerLock && this._onMouseMove) {
                            this._onMouseMove(p.event);
                        }
                        else if (this._previousPosition) {
                            let offsetX = evt.clientX - this._previousPosition.x;
                            const offsetY = evt.clientY - this._previousPosition.y;
                            if (this.camera.getScene().useRightHandedSystem) {
                                offsetX *= -1;
                            }
                            if (this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0) {
                                offsetX *= -1;
                            }
                            if (this._allowCameraRotation) {
                                this.camera.cameraRotation.y += offsetX / this.angularSensibility;
                                this.camera.cameraRotation.x += offsetY / this.angularSensibility;
                            }
                            this.onPointerMovedObservable.notifyObservers({ offsetX: offsetX, offsetY: offsetY });
                            this._previousPosition = {
                                x: evt.clientX,
                                y: evt.clientY,
                            };
                            if (!noPreventDefault) {
                                evt.preventDefault();
                            }
                        }
                    }
                };
            }
            this._onMouseMove = (evt) => {
                if (!engine.isPointerLock) {
                    return;
                }
                if (engine.isInVRExclusivePointerMode) {
                    return;
                }
                let offsetX = evt.movementX;
                if (this.camera.getScene().useRightHandedSystem) {
                    offsetX *= -1;
                }
                if (this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0) {
                    offsetX *= -1;
                }
                this.camera.cameraRotation.y += offsetX / this.angularSensibility;
                const offsetY = evt.movementY;
                this.camera.cameraRotation.x += offsetY / this.angularSensibility;
                this._previousPosition = null;
                if (!noPreventDefault) {
                    evt.preventDefault();
                }
            };
            this._observer = this.camera
                .getScene()
                ._inputManager._addCameraPointerObserver(this._pointerInput, PointerEventTypes.POINTERDOWN | PointerEventTypes.POINTERUP | PointerEventTypes.POINTERMOVE);
            if (element) {
                this._contextMenuBind = this.onContextMenu.bind(this);
                element.addEventListener("contextmenu", this._contextMenuBind, false); // TODO: We need to figure out how to handle this for Native
            }
        }
        /**
         * Called on JS contextmenu event.
         * Override this method to provide functionality.
         * @param evt
         */
        onContextMenu(evt) {
            evt.preventDefault();
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._observer) {
                this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
                if (this._contextMenuBind) {
                    const engine = this.camera.getEngine();
                    const element = engine.getInputElement();
                    element && element.removeEventListener("contextmenu", this._contextMenuBind);
                }
                if (this.onPointerMovedObservable) {
                    this.onPointerMovedObservable.clear();
                }
                this._observer = null;
                this._onMouseMove = null;
                this._previousPosition = null;
            }
            this._activePointerId = -1;
            this._currentActiveButton = -1;
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "FreeCameraMouseInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "mouse";
        }
    }
    __decorate$1([
        serialize()
    ], FreeCameraMouseInput.prototype, "buttons", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraMouseInput.prototype, "angularSensibility", void 0);
    CameraInputTypes["FreeCameraMouseInput"] = FreeCameraMouseInput;

    /**
     * Base class for mouse wheel input..
     * See FollowCameraMouseWheelInput in src/Cameras/Inputs/freeCameraMouseWheelInput.ts
     * for example usage.
     */
    class BaseCameraMouseWheelInput {
        constructor() {
            /**
             * How fast is the camera moves in relation to X axis mouseWheel events.
             * Use negative value to reverse direction.
             */
            this.wheelPrecisionX = 3.0;
            /**
             * How fast is the camera moves in relation to Y axis mouseWheel events.
             * Use negative value to reverse direction.
             */
            this.wheelPrecisionY = 3.0;
            /**
             * How fast is the camera moves in relation to Z axis mouseWheel events.
             * Use negative value to reverse direction.
             */
            this.wheelPrecisionZ = 3.0;
            /**
             * Observable for when a mouse wheel move event occurs.
             */
            this.onChangedObservable = new Observable$1();
            /**
             * Incremental value of multiple mouse wheel movements of the X axis.
             * Should be zero-ed when read.
             */
            this._wheelDeltaX = 0;
            /**
             * Incremental value of multiple mouse wheel movements of the Y axis.
             * Should be zero-ed when read.
             */
            this._wheelDeltaY = 0;
            /**
             * Incremental value of multiple mouse wheel movements of the Z axis.
             * Should be zero-ed when read.
             */
            this._wheelDeltaZ = 0;
            /**
             * Firefox uses a different scheme to report scroll distances to other
             * browsers. Rather than use complicated methods to calculate the exact
             * multiple we need to apply, let's just cheat and use a constant.
             * https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode
             * https://stackoverflow.com/questions/20110224/what-is-the-height-of-a-line-in-a-wheel-event-deltamode-dom-delta-line
             */
            this._ffMultiplier = 12;
            /**
             * Different event attributes for wheel data fall into a few set ranges.
             * Some relevant but dated date here:
             * https://stackoverflow.com/questions/5527601/normalizing-mousewheel-speed-across-browsers
             */
            this._normalize = 120;
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls
         *   should call preventdefault().
         *   (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            this._wheel = (pointer) => {
                // sanity check - this should be a PointerWheel event.
                if (pointer.type !== PointerEventTypes.POINTERWHEEL) {
                    return;
                }
                const event = pointer.event;
                const platformScale = event.deltaMode === EventConstants.DOM_DELTA_LINE ? this._ffMultiplier : 1; // If this happens to be set to DOM_DELTA_LINE, adjust accordingly
                this._wheelDeltaX += (this.wheelPrecisionX * platformScale * event.deltaX) / this._normalize;
                this._wheelDeltaY -= (this.wheelPrecisionY * platformScale * event.deltaY) / this._normalize;
                this._wheelDeltaZ += (this.wheelPrecisionZ * platformScale * event.deltaZ) / this._normalize;
                if (event.preventDefault) {
                    if (!noPreventDefault) {
                        event.preventDefault();
                    }
                }
            };
            this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, PointerEventTypes.POINTERWHEEL);
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._observer) {
                this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
                this._observer = null;
                this._wheel = null;
            }
            if (this.onChangedObservable) {
                this.onChangedObservable.clear();
            }
        }
        /**
         * Called for each rendered frame.
         */
        checkInputs() {
            this.onChangedObservable.notifyObservers({
                wheelDeltaX: this._wheelDeltaX,
                wheelDeltaY: this._wheelDeltaY,
                wheelDeltaZ: this._wheelDeltaZ,
            });
            // Clear deltas.
            this._wheelDeltaX = 0;
            this._wheelDeltaY = 0;
            this._wheelDeltaZ = 0;
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "BaseCameraMouseWheelInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "mousewheel";
        }
    }
    __decorate$1([
        serialize()
    ], BaseCameraMouseWheelInput.prototype, "wheelPrecisionX", void 0);
    __decorate$1([
        serialize()
    ], BaseCameraMouseWheelInput.prototype, "wheelPrecisionY", void 0);
    __decorate$1([
        serialize()
    ], BaseCameraMouseWheelInput.prototype, "wheelPrecisionZ", void 0);

    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _CameraProperty;
    (function (_CameraProperty) {
        _CameraProperty[_CameraProperty["MoveRelative"] = 0] = "MoveRelative";
        _CameraProperty[_CameraProperty["RotateRelative"] = 1] = "RotateRelative";
        _CameraProperty[_CameraProperty["MoveScene"] = 2] = "MoveScene";
    })(_CameraProperty || (_CameraProperty = {}));
    /**
     * Manage the mouse wheel inputs to control a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraMouseWheelInput extends BaseCameraMouseWheelInput {
        constructor() {
            super(...arguments);
            this._moveRelative = Vector3.Zero();
            this._rotateRelative = Vector3.Zero();
            this._moveScene = Vector3.Zero();
            /**
             * These are set to the desired default behaviour.
             */
            this._wheelXAction = _CameraProperty.MoveRelative;
            this._wheelXActionCoordinate = Coordinate.X;
            this._wheelYAction = _CameraProperty.MoveRelative;
            this._wheelYActionCoordinate = Coordinate.Z;
            this._wheelZAction = null;
            this._wheelZActionCoordinate = null;
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "FreeCameraMouseWheelInput";
        }
        /**
         * Set which movement axis (relative to camera's orientation) the mouse
         * wheel's X axis controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelXMoveRelative(axis) {
            if (axis === null && this._wheelXAction !== _CameraProperty.MoveRelative) {
                // Attempting to clear different _wheelXAction.
                return;
            }
            this._wheelXAction = _CameraProperty.MoveRelative;
            this._wheelXActionCoordinate = axis;
        }
        /**
         * Get the configured movement axis (relative to camera's orientation) the
         * mouse wheel's X axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelXMoveRelative() {
            if (this._wheelXAction !== _CameraProperty.MoveRelative) {
                return null;
            }
            return this._wheelXActionCoordinate;
        }
        /**
         * Set which movement axis (relative to camera's orientation) the mouse
         * wheel's Y axis controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelYMoveRelative(axis) {
            if (axis === null && this._wheelYAction !== _CameraProperty.MoveRelative) {
                // Attempting to clear different _wheelYAction.
                return;
            }
            this._wheelYAction = _CameraProperty.MoveRelative;
            this._wheelYActionCoordinate = axis;
        }
        /**
         * Get the configured movement axis (relative to camera's orientation) the
         * mouse wheel's Y axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelYMoveRelative() {
            if (this._wheelYAction !== _CameraProperty.MoveRelative) {
                return null;
            }
            return this._wheelYActionCoordinate;
        }
        /**
         * Set which movement axis (relative to camera's orientation) the mouse
         * wheel's Z axis controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelZMoveRelative(axis) {
            if (axis === null && this._wheelZAction !== _CameraProperty.MoveRelative) {
                // Attempting to clear different _wheelZAction.
                return;
            }
            this._wheelZAction = _CameraProperty.MoveRelative;
            this._wheelZActionCoordinate = axis;
        }
        /**
         * Get the configured movement axis (relative to camera's orientation) the
         * mouse wheel's Z axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelZMoveRelative() {
            if (this._wheelZAction !== _CameraProperty.MoveRelative) {
                return null;
            }
            return this._wheelZActionCoordinate;
        }
        /**
         * Set which rotation axis (relative to camera's orientation) the mouse
         * wheel's X axis controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelXRotateRelative(axis) {
            if (axis === null && this._wheelXAction !== _CameraProperty.RotateRelative) {
                // Attempting to clear different _wheelXAction.
                return;
            }
            this._wheelXAction = _CameraProperty.RotateRelative;
            this._wheelXActionCoordinate = axis;
        }
        /**
         * Get the configured rotation axis (relative to camera's orientation) the
         * mouse wheel's X axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelXRotateRelative() {
            if (this._wheelXAction !== _CameraProperty.RotateRelative) {
                return null;
            }
            return this._wheelXActionCoordinate;
        }
        /**
         * Set which rotation axis (relative to camera's orientation) the mouse
         * wheel's Y axis controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelYRotateRelative(axis) {
            if (axis === null && this._wheelYAction !== _CameraProperty.RotateRelative) {
                // Attempting to clear different _wheelYAction.
                return;
            }
            this._wheelYAction = _CameraProperty.RotateRelative;
            this._wheelYActionCoordinate = axis;
        }
        /**
         * Get the configured rotation axis (relative to camera's orientation) the
         * mouse wheel's Y axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelYRotateRelative() {
            if (this._wheelYAction !== _CameraProperty.RotateRelative) {
                return null;
            }
            return this._wheelYActionCoordinate;
        }
        /**
         * Set which rotation axis (relative to camera's orientation) the mouse
         * wheel's Z axis controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelZRotateRelative(axis) {
            if (axis === null && this._wheelZAction !== _CameraProperty.RotateRelative) {
                // Attempting to clear different _wheelZAction.
                return;
            }
            this._wheelZAction = _CameraProperty.RotateRelative;
            this._wheelZActionCoordinate = axis;
        }
        /**
         * Get the configured rotation axis (relative to camera's orientation) the
         * mouse wheel's Z axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelZRotateRelative() {
            if (this._wheelZAction !== _CameraProperty.RotateRelative) {
                return null;
            }
            return this._wheelZActionCoordinate;
        }
        /**
         * Set which movement axis (relative to the scene) the mouse wheel's X axis
         * controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelXMoveScene(axis) {
            if (axis === null && this._wheelXAction !== _CameraProperty.MoveScene) {
                // Attempting to clear different _wheelXAction.
                return;
            }
            this._wheelXAction = _CameraProperty.MoveScene;
            this._wheelXActionCoordinate = axis;
        }
        /**
         * Get the configured movement axis (relative to the scene) the mouse wheel's
         * X axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelXMoveScene() {
            if (this._wheelXAction !== _CameraProperty.MoveScene) {
                return null;
            }
            return this._wheelXActionCoordinate;
        }
        /**
         * Set which movement axis (relative to the scene) the mouse wheel's Y axis
         * controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelYMoveScene(axis) {
            if (axis === null && this._wheelYAction !== _CameraProperty.MoveScene) {
                // Attempting to clear different _wheelYAction.
                return;
            }
            this._wheelYAction = _CameraProperty.MoveScene;
            this._wheelYActionCoordinate = axis;
        }
        /**
         * Get the configured movement axis (relative to the scene) the mouse wheel's
         * Y axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelYMoveScene() {
            if (this._wheelYAction !== _CameraProperty.MoveScene) {
                return null;
            }
            return this._wheelYActionCoordinate;
        }
        /**
         * Set which movement axis (relative to the scene) the mouse wheel's Z axis
         * controls.
         * @param axis The axis to be moved. Set null to clear.
         */
        set wheelZMoveScene(axis) {
            if (axis === null && this._wheelZAction !== _CameraProperty.MoveScene) {
                // Attempting to clear different _wheelZAction.
                return;
            }
            this._wheelZAction = _CameraProperty.MoveScene;
            this._wheelZActionCoordinate = axis;
        }
        /**
         * Get the configured movement axis (relative to the scene) the mouse wheel's
         * Z axis controls.
         * @returns The configured axis or null if none.
         */
        get wheelZMoveScene() {
            if (this._wheelZAction !== _CameraProperty.MoveScene) {
                return null;
            }
            return this._wheelZActionCoordinate;
        }
        /**
         * Called for each rendered frame.
         */
        checkInputs() {
            if (this._wheelDeltaX === 0 && this._wheelDeltaY === 0 && this._wheelDeltaZ == 0) {
                return;
            }
            // Clear the camera properties that we might be updating.
            this._moveRelative.setAll(0);
            this._rotateRelative.setAll(0);
            this._moveScene.setAll(0);
            // Set the camera properties that are to be updated.
            this._updateCamera();
            if (this.camera.getScene().useRightHandedSystem) {
                // TODO: Does this need done for worldUpdate too?
                this._moveRelative.z *= -1;
            }
            // Convert updates relative to camera to world position update.
            const cameraTransformMatrix = Matrix.Zero();
            this.camera.getViewMatrix().invertToRef(cameraTransformMatrix);
            const transformedDirection = Vector3.Zero();
            Vector3.TransformNormalToRef(this._moveRelative, cameraTransformMatrix, transformedDirection);
            // Apply updates to camera position.
            this.camera.cameraRotation.x += this._rotateRelative.x / 200;
            this.camera.cameraRotation.y += this._rotateRelative.y / 200;
            this.camera.cameraDirection.addInPlace(transformedDirection);
            this.camera.cameraDirection.addInPlace(this._moveScene);
            // Call the base class implementation to handle observers and do cleanup.
            super.checkInputs();
        }
        /**
         * Update the camera according to any configured properties for the 3
         * mouse-wheel axis.
         */
        _updateCamera() {
            // Do the camera updates for each of the 3 touch-wheel axis.
            this._updateCameraProperty(this._wheelDeltaX, this._wheelXAction, this._wheelXActionCoordinate);
            this._updateCameraProperty(this._wheelDeltaY, this._wheelYAction, this._wheelYActionCoordinate);
            this._updateCameraProperty(this._wheelDeltaZ, this._wheelZAction, this._wheelZActionCoordinate);
        }
        /**
         * Update one property of the camera.
         * @param value
         * @param cameraProperty
         * @param coordinate
         */
        _updateCameraProperty(
        /* Mouse-wheel delta. */
        value, 
        /* Camera property to be changed. */
        cameraProperty, 
        /* Axis of Camera property to be changed. */
        coordinate) {
            if (value === 0) {
                // Mouse wheel has not moved.
                return;
            }
            if (cameraProperty === null || coordinate === null) {
                // Mouse wheel axis not configured.
                return;
            }
            let action = null;
            switch (cameraProperty) {
                case _CameraProperty.MoveRelative:
                    action = this._moveRelative;
                    break;
                case _CameraProperty.RotateRelative:
                    action = this._rotateRelative;
                    break;
                case _CameraProperty.MoveScene:
                    action = this._moveScene;
                    break;
            }
            switch (coordinate) {
                case Coordinate.X:
                    action.set(value, 0, 0);
                    break;
                case Coordinate.Y:
                    action.set(0, value, 0);
                    break;
                case Coordinate.Z:
                    action.set(0, 0, value);
                    break;
            }
        }
    }
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelXMoveRelative", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelYMoveRelative", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelZMoveRelative", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelXRotateRelative", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelYRotateRelative", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelZRotateRelative", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelXMoveScene", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelYMoveScene", null);
    __decorate$1([
        serialize()
    ], FreeCameraMouseWheelInput.prototype, "wheelZMoveScene", null);
    CameraInputTypes["FreeCameraMouseWheelInput"] = FreeCameraMouseWheelInput;

    /**
     * Manage the touch inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraTouchInput {
        /**
         * Manage the touch inputs to control the movement of a free camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
         * @param allowMouse Defines if mouse events can be treated as touch events
         */
        constructor(
        /**
         * Define if mouse events can be treated as touch events
         */
        allowMouse = false) {
            this.allowMouse = allowMouse;
            /**
             * Defines the touch sensibility for rotation.
             * The lower the faster.
             */
            this.touchAngularSensibility = 200000.0;
            /**
             * Defines the touch sensibility for move.
             * The lower the faster.
             */
            this.touchMoveSensibility = 250.0;
            /**
             * Swap touch actions so that one touch is used for rotation and multiple for movement
             */
            this.singleFingerRotate = false;
            this._offsetX = null;
            this._offsetY = null;
            this._pointerPressed = new Array();
            this._isSafari = Tools.IsSafari();
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(noPreventDefault) {
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            let previousPosition = null;
            if (this._pointerInput === undefined) {
                this._onLostFocus = () => {
                    this._offsetX = null;
                    this._offsetY = null;
                };
                this._pointerInput = (p) => {
                    const evt = p.event;
                    const isMouseEvent = evt.pointerType === "mouse" || (this._isSafari && typeof evt.pointerType === "undefined");
                    if (!this.allowMouse && isMouseEvent) {
                        return;
                    }
                    if (p.type === PointerEventTypes.POINTERDOWN) {
                        if (!noPreventDefault) {
                            evt.preventDefault();
                        }
                        this._pointerPressed.push(evt.pointerId);
                        if (this._pointerPressed.length !== 1) {
                            return;
                        }
                        previousPosition = {
                            x: evt.clientX,
                            y: evt.clientY,
                        };
                    }
                    else if (p.type === PointerEventTypes.POINTERUP) {
                        if (!noPreventDefault) {
                            evt.preventDefault();
                        }
                        const index = this._pointerPressed.indexOf(evt.pointerId);
                        if (index === -1) {
                            return;
                        }
                        this._pointerPressed.splice(index, 1);
                        if (index != 0) {
                            return;
                        }
                        previousPosition = null;
                        this._offsetX = null;
                        this._offsetY = null;
                    }
                    else if (p.type === PointerEventTypes.POINTERMOVE) {
                        if (!noPreventDefault) {
                            evt.preventDefault();
                        }
                        if (!previousPosition) {
                            return;
                        }
                        const index = this._pointerPressed.indexOf(evt.pointerId);
                        if (index != 0) {
                            return;
                        }
                        this._offsetX = evt.clientX - previousPosition.x;
                        this._offsetY = -(evt.clientY - previousPosition.y);
                    }
                };
            }
            this._observer = this.camera
                .getScene()
                ._inputManager._addCameraPointerObserver(this._pointerInput, PointerEventTypes.POINTERDOWN | PointerEventTypes.POINTERUP | PointerEventTypes.POINTERMOVE);
            if (this._onLostFocus) {
                const engine = this.camera.getEngine();
                const element = engine.getInputElement();
                element && element.addEventListener("blur", this._onLostFocus);
            }
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            if (this._pointerInput) {
                if (this._observer) {
                    this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
                    this._observer = null;
                }
                if (this._onLostFocus) {
                    const engine = this.camera.getEngine();
                    const element = engine.getInputElement();
                    element && element.removeEventListener("blur", this._onLostFocus);
                    this._onLostFocus = null;
                }
                this._pointerPressed.length = 0;
                this._offsetX = null;
                this._offsetY = null;
            }
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            if (this._offsetX === null || this._offsetY === null) {
                return;
            }
            if (this._offsetX === 0 && this._offsetY === 0) {
                return;
            }
            const camera = this.camera;
            camera.cameraRotation.y = this._offsetX / this.touchAngularSensibility;
            const rotateCamera = (this.singleFingerRotate && this._pointerPressed.length === 1) || (!this.singleFingerRotate && this._pointerPressed.length > 1);
            if (rotateCamera) {
                camera.cameraRotation.x = -this._offsetY / this.touchAngularSensibility;
            }
            else {
                const speed = camera._computeLocalCameraSpeed();
                const direction = new Vector3(0, 0, this.touchMoveSensibility !== 0 ? (speed * this._offsetY) / this.touchMoveSensibility : 0);
                Matrix.RotationYawPitchRollToRef(camera.rotation.y, camera.rotation.x, 0, camera._cameraRotationMatrix);
                camera.cameraDirection.addInPlace(Vector3.TransformCoordinates(direction, camera._cameraRotationMatrix));
            }
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "FreeCameraTouchInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "touch";
        }
    }
    __decorate$1([
        serialize()
    ], FreeCameraTouchInput.prototype, "touchAngularSensibility", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraTouchInput.prototype, "touchMoveSensibility", void 0);
    CameraInputTypes["FreeCameraTouchInput"] = FreeCameraTouchInput;

    /**
     * Default Inputs manager for the FreeCamera.
     * It groups all the default supported inputs for ease of use.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraInputsManager extends CameraInputsManager {
        /**
         * Instantiates a new FreeCameraInputsManager.
         * @param camera Defines the camera the inputs belong to
         */
        constructor(camera) {
            super(camera);
            /**
             * @internal
             */
            this._mouseInput = null;
            /**
             * @internal
             */
            this._mouseWheelInput = null;
        }
        /**
         * Add keyboard input support to the input manager.
         * @returns the current input manager
         */
        addKeyboard() {
            this.add(new FreeCameraKeyboardMoveInput());
            return this;
        }
        /**
         * Add mouse input support to the input manager.
         * @param touchEnabled if the FreeCameraMouseInput should support touch (default: true)
         * @returns the current input manager
         */
        addMouse(touchEnabled = true) {
            if (!this._mouseInput) {
                this._mouseInput = new FreeCameraMouseInput(touchEnabled);
                this.add(this._mouseInput);
            }
            return this;
        }
        /**
         * Removes the mouse input support from the manager
         * @returns the current input manager
         */
        removeMouse() {
            if (this._mouseInput) {
                this.remove(this._mouseInput);
            }
            return this;
        }
        /**
         * Add mouse wheel input support to the input manager.
         * @returns the current input manager
         */
        addMouseWheel() {
            if (!this._mouseWheelInput) {
                this._mouseWheelInput = new FreeCameraMouseWheelInput();
                this.add(this._mouseWheelInput);
            }
            return this;
        }
        /**
         * Removes the mouse wheel input support from the manager
         * @returns the current input manager
         */
        removeMouseWheel() {
            if (this._mouseWheelInput) {
                this.remove(this._mouseWheelInput);
            }
            return this;
        }
        /**
         * Add touch input support to the input manager.
         * @returns the current input manager
         */
        addTouch() {
            this.add(new FreeCameraTouchInput());
            return this;
        }
        /**
         * Remove all attached input methods from a camera
         */
        clear() {
            super.clear();
            this._mouseInput = null;
        }
    }

    /**
     * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
     * Please consider using the new UniversalCamera instead as it adds more functionality like the gamepad.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     */
    class FreeCamera extends TargetCamera {
        /**
         * Gets the input sensibility for a mouse input. (default is 2000.0)
         * Higher values reduce sensitivity.
         */
        get angularSensibility() {
            const mouse = this.inputs.attached["mouse"];
            if (mouse) {
                return mouse.angularSensibility;
            }
            return 0;
        }
        /**
         * Sets the input sensibility for a mouse input. (default is 2000.0)
         * Higher values reduce sensitivity.
         */
        set angularSensibility(value) {
            const mouse = this.inputs.attached["mouse"];
            if (mouse) {
                mouse.angularSensibility = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the forward move of the camera.
         */
        get keysUp() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysUp;
            }
            return [];
        }
        set keysUp(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysUp = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the upward move of the camera.
         */
        get keysUpward() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysUpward;
            }
            return [];
        }
        set keysUpward(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysUpward = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the backward move of the camera.
         */
        get keysDown() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysDown;
            }
            return [];
        }
        set keysDown(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysDown = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the downward move of the camera.
         */
        get keysDownward() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysDownward;
            }
            return [];
        }
        set keysDownward(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysDownward = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the left strafe move of the camera.
         */
        get keysLeft() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysLeft;
            }
            return [];
        }
        set keysLeft(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysLeft = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the right strafe move of the camera.
         */
        get keysRight() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysRight;
            }
            return [];
        }
        set keysRight(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysRight = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the left rotation move of the camera.
         */
        get keysRotateLeft() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysRotateLeft;
            }
            return [];
        }
        set keysRotateLeft(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysRotateLeft = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the right rotation move of the camera.
         */
        get keysRotateRight() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysRotateRight;
            }
            return [];
        }
        set keysRotateRight(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysRotateRight = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the up rotation move of the camera.
         */
        get keysRotateUp() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysRotateUp;
            }
            return [];
        }
        set keysRotateUp(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysRotateUp = value;
            }
        }
        /**
         * Gets or Set the list of keyboard keys used to control the down rotation move of the camera.
         */
        get keysRotateDown() {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                return keyboard.keysRotateDown;
            }
            return [];
        }
        set keysRotateDown(value) {
            const keyboard = this.inputs.attached["keyboard"];
            if (keyboard) {
                keyboard.keysRotateDown = value;
            }
        }
        /**
         * Instantiates a Free Camera.
         * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
         * Please consider using the new UniversalCamera instead as it adds more functionality like touch to this camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
         * @param name Define the name of the camera in the scene
         * @param position Define the start position of the camera in the scene
         * @param scene Define the scene the camera belongs to
         * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
         */
        constructor(name, position, scene, setActiveOnSceneIfNoneActive = true) {
            super(name, position, scene, setActiveOnSceneIfNoneActive);
            /**
             * Define the collision ellipsoid of the camera.
             * This is helpful to simulate a camera body like the player body around the camera
             * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#arcrotatecamera
             */
            this.ellipsoid = new Vector3(0.5, 1, 0.5);
            /**
             * Define an offset for the position of the ellipsoid around the camera.
             * This can be helpful to determine the center of the body near the gravity center of the body
             * instead of its head.
             */
            this.ellipsoidOffset = new Vector3(0, 0, 0);
            /**
             * Enable or disable collisions of the camera with the rest of the scene objects.
             */
            this.checkCollisions = false;
            /**
             * Enable or disable gravity on the camera.
             */
            this.applyGravity = false;
            this._needMoveForGravity = false;
            this._oldPosition = Vector3.Zero();
            this._diffPosition = Vector3.Zero();
            this._newPosition = Vector3.Zero();
            // Collisions
            this._collisionMask = -1;
            this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null) => {
                this._newPosition.copyFrom(newPosition);
                this._newPosition.subtractToRef(this._oldPosition, this._diffPosition);
                if (this._diffPosition.length() > Engine.CollisionsEpsilon) {
                    this.position.addToRef(this._diffPosition, this._deferredPositionUpdate);
                    if (!this._deferOnly) {
                        this.position.copyFrom(this._deferredPositionUpdate);
                    }
                    else {
                        this._deferredUpdated = true;
                    }
                    // call onCollide, if defined. Note that in case of deferred update, the actual position change might happen in the next frame.
                    if (this.onCollide && collidedMesh) {
                        this.onCollide(collidedMesh);
                    }
                }
            };
            this.inputs = new FreeCameraInputsManager(this);
            this.inputs.addKeyboard().addMouse();
        }
        /**
         * Attached controls to the current camera.
         * @param ignored defines an ignored parameter kept for backward compatibility.
         * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
         */
        attachControl(ignored, noPreventDefault) {
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            this.inputs.attachElement(noPreventDefault);
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            this.inputs.detachElement();
            this.cameraDirection = new Vector3(0, 0, 0);
            this.cameraRotation = new Vector2(0, 0);
        }
        /**
         * Define a collision mask to limit the list of object the camera can collide with
         */
        get collisionMask() {
            return this._collisionMask;
        }
        set collisionMask(mask) {
            this._collisionMask = !isNaN(mask) ? mask : -1;
        }
        /**
         * @internal
         */
        _collideWithWorld(displacement) {
            let globalPosition;
            if (this.parent) {
                globalPosition = Vector3.TransformCoordinates(this.position, this.parent.getWorldMatrix());
            }
            else {
                globalPosition = this.position;
            }
            globalPosition.subtractFromFloatsToRef(0, this.ellipsoid.y, 0, this._oldPosition);
            this._oldPosition.addInPlace(this.ellipsoidOffset);
            const coordinator = this.getScene().collisionCoordinator;
            if (!this._collider) {
                this._collider = coordinator.createCollider();
            }
            this._collider._radius = this.ellipsoid;
            this._collider.collisionMask = this._collisionMask;
            //no need for clone, as long as gravity is not on.
            let actualDisplacement = displacement;
            //add gravity to the direction to prevent the dual-collision checking
            if (this.applyGravity) {
                //this prevents mending with cameraDirection, a global variable of the free camera class.
                actualDisplacement = displacement.add(this.getScene().gravity);
            }
            coordinator.getNewPosition(this._oldPosition, actualDisplacement, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
        }
        /** @internal */
        _checkInputs() {
            if (!this._localDirection) {
                this._localDirection = Vector3.Zero();
                this._transformedDirection = Vector3.Zero();
            }
            this.inputs.checkInputs();
            super._checkInputs();
        }
        /**
         * Enable movement without a user input. This allows gravity to always be applied.
         */
        set needMoveForGravity(value) {
            this._needMoveForGravity = value;
        }
        /**
         * When true, gravity is applied whether there is user input or not.
         */
        get needMoveForGravity() {
            return this._needMoveForGravity;
        }
        /** @internal */
        _decideIfNeedsToMove() {
            return this._needMoveForGravity || Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
        }
        /** @internal */
        _updatePosition() {
            if (this.checkCollisions && this.getScene().collisionsEnabled) {
                this._collideWithWorld(this.cameraDirection);
            }
            else {
                super._updatePosition();
            }
        }
        /**
         * Destroy the camera and release the current resources hold by it.
         */
        dispose() {
            this.inputs.clear();
            super.dispose();
        }
        /**
         * Gets the current object class name.
         * @returns the class name
         */
        getClassName() {
            return "FreeCamera";
        }
    }
    __decorate$1([
        serializeAsVector3()
    ], FreeCamera.prototype, "ellipsoid", void 0);
    __decorate$1([
        serializeAsVector3()
    ], FreeCamera.prototype, "ellipsoidOffset", void 0);
    __decorate$1([
        serialize()
    ], FreeCamera.prototype, "checkCollisions", void 0);
    __decorate$1([
        serialize()
    ], FreeCamera.prototype, "applyGravity", void 0);

    /**
     * Add orientation input support to the input manager.
     * @param smoothFactor deviceOrientation smoothing. 0: no smoothing, 1: new data ignored, 0.9 recommended for smoothing
     * @returns the current input manager
     */
    FreeCameraInputsManager.prototype.addDeviceOrientation = function (smoothFactor) {
        if (!this._deviceOrientationInput) {
            this._deviceOrientationInput = new FreeCameraDeviceOrientationInput();
            if (smoothFactor) {
                this._deviceOrientationInput.smoothFactor = smoothFactor;
            }
            this.add(this._deviceOrientationInput);
        }
        return this;
    };
    /**
     * Takes information about the orientation of the device as reported by the deviceorientation event to orient the camera.
     * Screen rotation is taken into account.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraDeviceOrientationInput {
        /**
         * Can be used to detect if a device orientation sensor is available on a device
         * @param timeout amount of time in milliseconds to wait for a response from the sensor (default: infinite)
         * @returns a promise that will resolve on orientation change
         */
        static WaitForOrientationChangeAsync(timeout) {
            return new Promise((res, rej) => {
                let gotValue = false;
                const eventHandler = () => {
                    window.removeEventListener("deviceorientation", eventHandler);
                    gotValue = true;
                    res();
                };
                // If timeout is populated reject the promise
                if (timeout) {
                    setTimeout(() => {
                        if (!gotValue) {
                            window.removeEventListener("deviceorientation", eventHandler);
                            rej("WaitForOrientationChangeAsync timed out");
                        }
                    }, timeout);
                }
                if (typeof DeviceOrientationEvent !== "undefined" && typeof DeviceOrientationEvent.requestPermission === "function") {
                    DeviceOrientationEvent
                        .requestPermission()
                        .then((response) => {
                        if (response == "granted") {
                            window.addEventListener("deviceorientation", eventHandler);
                        }
                        else {
                            Tools.Warn("Permission not granted.");
                        }
                    })
                        .catch((error) => {
                        Tools.Error(error);
                    });
                }
                else {
                    window.addEventListener("deviceorientation", eventHandler);
                }
            });
        }
        /**
         * Instantiates a new input
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
         */
        constructor() {
            this._screenOrientationAngle = 0;
            this._screenQuaternion = new Quaternion();
            this._alpha = 0;
            this._beta = 0;
            this._gamma = 0;
            /** alpha+beta+gamma smoothing. 0: no smoothing, 1: new data ignored, 0.9 recommended for smoothing */
            this.smoothFactor = 0;
            /**
             * @internal
             */
            this._onDeviceOrientationChangedObservable = new Observable$1();
            this._orientationChanged = () => {
                this._screenOrientationAngle =
                    window.orientation !== undefined
                        ? +window.orientation
                        : window.screen.orientation && window.screen.orientation["angle"]
                            ? window.screen.orientation.angle
                            : 0;
                this._screenOrientationAngle = -Tools.ToRadians(this._screenOrientationAngle / 2);
                this._screenQuaternion.copyFromFloats(0, Math.sin(this._screenOrientationAngle), 0, Math.cos(this._screenOrientationAngle));
            };
            this._deviceOrientation = (evt) => {
                if (this.smoothFactor) {
                    this._alpha = evt.alpha !== null ? Tools.SmoothAngleChange(this._alpha, evt.alpha, this.smoothFactor) : 0;
                    this._beta = evt.beta !== null ? Tools.SmoothAngleChange(this._beta, evt.beta, this.smoothFactor) : 0;
                    this._gamma = evt.gamma !== null ? Tools.SmoothAngleChange(this._gamma, evt.gamma, this.smoothFactor) : 0;
                }
                else {
                    this._alpha = evt.alpha !== null ? evt.alpha : 0;
                    this._beta = evt.beta !== null ? evt.beta : 0;
                    this._gamma = evt.gamma !== null ? evt.gamma : 0;
                }
                if (evt.alpha !== null) {
                    this._onDeviceOrientationChangedObservable.notifyObservers();
                }
            };
            this._constantTranform = new Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));
            this._orientationChanged();
        }
        /**
         * Define the camera controlled by the input.
         */
        get camera() {
            return this._camera;
        }
        set camera(camera) {
            this._camera = camera;
            if (this._camera != null && !this._camera.rotationQuaternion) {
                this._camera.rotationQuaternion = new Quaternion();
            }
            if (this._camera) {
                this._camera.onDisposeObservable.add(() => {
                    this._onDeviceOrientationChangedObservable.clear();
                });
            }
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         */
        attachControl() {
            const hostWindow = this.camera.getScene().getEngine().getHostWindow();
            if (hostWindow) {
                const eventHandler = () => {
                    hostWindow.addEventListener("orientationchange", this._orientationChanged);
                    hostWindow.addEventListener("deviceorientation", this._deviceOrientation);
                    //In certain cases, the attach control is called AFTER orientation was changed,
                    //So this is needed.
                    this._orientationChanged();
                };
                if (typeof DeviceOrientationEvent !== "undefined" && typeof DeviceOrientationEvent.requestPermission === "function") {
                    DeviceOrientationEvent
                        .requestPermission()
                        .then((response) => {
                        if (response === "granted") {
                            eventHandler();
                        }
                        else {
                            Tools.Warn("Permission not granted.");
                        }
                    })
                        .catch((error) => {
                        Tools.Error(error);
                    });
                }
                else {
                    eventHandler();
                }
            }
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            window.removeEventListener("orientationchange", this._orientationChanged);
            window.removeEventListener("deviceorientation", this._deviceOrientation);
            this._alpha = 0;
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            //if no device orientation provided, don't update the rotation.
            //Only testing against alpha under the assumption thatnorientation will never be so exact when set.
            if (!this._alpha) {
                return;
            }
            Quaternion.RotationYawPitchRollToRef(Tools.ToRadians(this._alpha), Tools.ToRadians(this._beta), -Tools.ToRadians(this._gamma), this.camera.rotationQuaternion);
            this._camera.rotationQuaternion.multiplyInPlace(this._screenQuaternion);
            this._camera.rotationQuaternion.multiplyInPlace(this._constantTranform);
            //Mirror on XY Plane
            this._camera.rotationQuaternion.z *= -1;
            this._camera.rotationQuaternion.w *= -1;
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "FreeCameraDeviceOrientationInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "deviceOrientation";
        }
    }
    CameraInputTypes["FreeCameraDeviceOrientationInput"] = FreeCameraDeviceOrientationInput;

    Node.AddNodeConstructor("DeviceOrientationCamera", (name, scene) => {
        return () => new DeviceOrientationCamera(name, Vector3.Zero(), scene);
    });
    // We're mainly based on the logic defined into the FreeCamera code
    /**
     * This is a camera specifically designed to react to device orientation events such as a modern mobile device
     * being tilted forward or back and left or right.
     */
    class DeviceOrientationCamera extends FreeCamera {
        /**
         * Creates a new device orientation camera
         * @param name The name of the camera
         * @param position The start position camera
         * @param scene The scene the camera belongs to
         */
        constructor(name, position, scene) {
            super(name, position, scene);
            this._tmpDragQuaternion = new Quaternion();
            this._disablePointerInputWhenUsingDeviceOrientation = true;
            this._dragFactor = 0;
            this._quaternionCache = new Quaternion();
            this.inputs.addDeviceOrientation();
            // When the orientation sensor fires it's first event, disable mouse input
            if (this.inputs._deviceOrientationInput) {
                this.inputs._deviceOrientationInput._onDeviceOrientationChangedObservable.addOnce(() => {
                    if (this._disablePointerInputWhenUsingDeviceOrientation) {
                        if (this.inputs._mouseInput) {
                            this.inputs._mouseInput._allowCameraRotation = false;
                            this.inputs._mouseInput.onPointerMovedObservable.add((e) => {
                                if (this._dragFactor != 0) {
                                    if (!this._initialQuaternion) {
                                        this._initialQuaternion = new Quaternion();
                                    }
                                    // Rotate the initial space around the y axis to allow users to "turn around" via touch/mouse
                                    Quaternion.FromEulerAnglesToRef(0, e.offsetX * this._dragFactor, 0, this._tmpDragQuaternion);
                                    this._initialQuaternion.multiplyToRef(this._tmpDragQuaternion, this._initialQuaternion);
                                }
                            });
                        }
                    }
                });
            }
        }
        /**
         * Gets or sets a boolean indicating that pointer input must be disabled on first orientation sensor update (Default: true)
         */
        get disablePointerInputWhenUsingDeviceOrientation() {
            return this._disablePointerInputWhenUsingDeviceOrientation;
        }
        set disablePointerInputWhenUsingDeviceOrientation(value) {
            this._disablePointerInputWhenUsingDeviceOrientation = value;
        }
        /**
         * Enabled turning on the y axis when the orientation sensor is active
         * @param dragFactor the factor that controls the turn speed (default: 1/300)
         */
        enableHorizontalDragging(dragFactor = 1 / 300) {
            this._dragFactor = dragFactor;
        }
        /**
         * Gets the current instance class name ("DeviceOrientationCamera").
         * This helps avoiding instanceof at run time.
         * @returns the class name
         */
        getClassName() {
            return "DeviceOrientationCamera";
        }
        /**
         * @internal
         * Checks and applies the current values of the inputs to the camera. (Internal use only)
         */
        _checkInputs() {
            super._checkInputs();
            this._quaternionCache.copyFrom(this.rotationQuaternion);
            if (this._initialQuaternion) {
                this._initialQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
            }
        }
        /**
         * Reset the camera to its default orientation on the specified axis only.
         * @param axis The axis to reset
         */
        resetToCurrentRotation(axis = Axis.Y) {
            //can only work if this camera has a rotation quaternion already.
            if (!this.rotationQuaternion) {
                return;
            }
            if (!this._initialQuaternion) {
                this._initialQuaternion = new Quaternion();
            }
            this._initialQuaternion.copyFrom(this._quaternionCache || this.rotationQuaternion);
            ["x", "y", "z"].forEach((axisName) => {
                if (!axis[axisName]) {
                    this._initialQuaternion[axisName] = 0;
                }
                else {
                    this._initialQuaternion[axisName] *= -1;
                }
            });
            this._initialQuaternion.normalize();
            //force rotation update
            this._initialQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
        }
    }

    /**
     * This represents all the required metrics to create a VR camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#device-orientation-camera
     */
    class VRCameraMetrics {
        constructor() {
            /**
             * Define if the current vr camera should compensate the distortion of the lens or not.
             */
            this.compensateDistortion = true;
            /**
             * Defines if multiview should be enabled when rendering (Default: false)
             */
            this.multiviewEnabled = false;
        }
        /**
         * Gets the rendering aspect ratio based on the provided resolutions.
         */
        get aspectRatio() {
            return this.hResolution / (2 * this.vResolution);
        }
        /**
         * Gets the aspect ratio based on the FOV, scale factors, and real screen sizes.
         */
        get aspectRatioFov() {
            return 2 * Math.atan((this.postProcessScaleFactor * this.vScreenSize) / (2 * this.eyeToScreenDistance));
        }
        /**
         * @internal
         */
        get leftHMatrix() {
            const meters = this.hScreenSize / 4 - this.lensSeparationDistance / 2;
            const h = (4 * meters) / this.hScreenSize;
            return Matrix.Translation(h, 0, 0);
        }
        /**
         * @internal
         */
        get rightHMatrix() {
            const meters = this.hScreenSize / 4 - this.lensSeparationDistance / 2;
            const h = (4 * meters) / this.hScreenSize;
            return Matrix.Translation(-h, 0, 0);
        }
        /**
         * @internal
         */
        get leftPreViewMatrix() {
            return Matrix.Translation(0.5 * this.interpupillaryDistance, 0, 0);
        }
        /**
         * @internal
         */
        get rightPreViewMatrix() {
            return Matrix.Translation(-0.5 * this.interpupillaryDistance, 0, 0);
        }
        /**
         * Get the default VRMetrics based on the most generic setup.
         * @returns the default vr metrics
         */
        static GetDefault() {
            const result = new VRCameraMetrics();
            result.hResolution = 1280;
            result.vResolution = 800;
            result.hScreenSize = 0.149759993;
            result.vScreenSize = 0.0935999975;
            result.vScreenCenter = 0.0467999987;
            result.eyeToScreenDistance = 0.0410000011;
            result.lensSeparationDistance = 0.063500002;
            result.interpupillaryDistance = 0.064000003;
            result.distortionK = [1.0, 0.219999999, 0.239999995, 0.0];
            result.chromaAbCorrection = [0.995999992, -0.00400000019, 1.01400006, 0.0];
            result.postProcessScaleFactor = 1.714605507808412;
            result.lensCenterOffset = 0.151976421;
            return result;
        }
    }

    // Do not edit.
    const name$1T = "vrDistortionCorrectionPixelShader";
    const shader$1T = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 LensCenter;uniform vec2 Scale;uniform vec2 ScaleIn;uniform vec4 HmdWarpParam;vec2 HmdWarp(vec2 in01) {vec2 theta=(in01-LensCenter)*ScaleIn; 
float rSq=theta.x*theta.x+theta.y*theta.y;vec2 rvector=theta*(HmdWarpParam.x+HmdWarpParam.y*rSq+HmdWarpParam.z*rSq*rSq+HmdWarpParam.w*rSq*rSq*rSq);return LensCenter+Scale*rvector;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec2 tc=HmdWarp(vUV);if (tc.x <0.0 || tc.x>1.0 || tc.y<0.0 || tc.y>1.0)
gl_FragColor=vec4(0.0,0.0,0.0,0.0);else{gl_FragColor=texture2D(textureSampler,tc);}}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1T] = shader$1T;

    /**
     * VRDistortionCorrectionPostProcess used for mobile VR
     */
    class VRDistortionCorrectionPostProcess extends PostProcess {
        /**
         * Gets a string identifying the name of the class
         * @returns "VRDistortionCorrectionPostProcess" string
         */
        getClassName() {
            return "VRDistortionCorrectionPostProcess";
        }
        /**
         * Initializes the VRDistortionCorrectionPostProcess
         * @param name The name of the effect.
         * @param camera The camera to apply the render pass to.
         * @param isRightEye If this is for the right eye distortion
         * @param vrMetrics All the required metrics for the VR camera
         */
        constructor(name, camera, isRightEye, vrMetrics) {
            super(name, "vrDistortionCorrection", ["LensCenter", "Scale", "ScaleIn", "HmdWarpParam"], null, vrMetrics.postProcessScaleFactor, camera, Texture.BILINEAR_SAMPLINGMODE);
            this._isRightEye = isRightEye;
            this._distortionFactors = vrMetrics.distortionK;
            this._postProcessScaleFactor = vrMetrics.postProcessScaleFactor;
            this._lensCenterOffset = vrMetrics.lensCenterOffset;
            this.adaptScaleToCurrentViewport = true;
            this.onSizeChangedObservable.add(() => {
                this._scaleIn = new Vector2(2, 2 / this.aspectRatio);
                this._scaleFactor = new Vector2(0.5 * (1 / this._postProcessScaleFactor), 0.5 * (1 / this._postProcessScaleFactor) * this.aspectRatio);
                this._lensCenter = new Vector2(this._isRightEye ? 0.5 - this._lensCenterOffset * 0.5 : 0.5 + this._lensCenterOffset * 0.5, 0.5);
            });
            this.onApplyObservable.add((effect) => {
                effect.setFloat2("LensCenter", this._lensCenter.x, this._lensCenter.y);
                effect.setFloat2("Scale", this._scaleFactor.x, this._scaleFactor.y);
                effect.setFloat2("ScaleIn", this._scaleIn.x, this._scaleIn.y);
                effect.setFloat4("HmdWarpParam", this._distortionFactors[0], this._distortionFactors[1], this._distortionFactors[2], this._distortionFactors[3]);
            });
        }
    }

    // Do not edit.
    const name$1U = "vrMultiviewToSingleviewPixelShader";
    const shader$1U = `precision mediump sampler2DArray;varying vec2 vUV;uniform sampler2DArray multiviewSampler;uniform int imageIndex;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{gl_FragColor=texture2D(multiviewSampler,vec3(vUV,imageIndex));}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1U] = shader$1U;

    /**
     * Renders to multiple views with a single draw call
     * @see https://www.khronos.org/registry/webgl/extensions/OVR_multiview2/
     */
    class MultiviewRenderTarget extends RenderTargetTexture {
        set samples(value) {
            // We override this setter because multisampling is handled by framebufferTextureMultisampleMultiviewOVR
            this._samples = value;
        }
        get samples() {
            return this._samples;
        }
        /**
         * Creates a multiview render target
         * @param scene scene used with the render target
         * @param size the size of the render target (used for each view)
         */
        constructor(scene, size = 512) {
            super("multiview rtt", size, scene, false, true, 0, false, undefined, false, false, true, undefined, true);
            this._renderTarget = this.getScene().getEngine().createMultiviewRenderTargetTexture(this.getRenderWidth(), this.getRenderHeight());
            this._texture = this._renderTarget.texture;
            this._texture.isMultiview = true;
            this._texture.format = 5;
            this.samples = this._getEngine().getCaps().maxSamples || this.samples;
            this._texture.samples = this._samples;
        }
        /**
         * @internal
         */
        _bindFrameBuffer() {
            if (!this._renderTarget) {
                return;
            }
            this.getScene().getEngine().bindMultiviewFramebuffer(this._renderTarget);
        }
        /**
         * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
         * @returns the view count
         */
        getViewCount() {
            return 2;
        }
    }

    Engine.prototype.createMultiviewRenderTargetTexture = function (width, height, colorTexture, depthStencilTexture) {
        const gl = this._gl;
        if (!this.getCaps().multiview) {
            throw "Multiview is not supported";
        }
        const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, { width, height });
        rtWrapper._framebuffer = gl.createFramebuffer();
        const internalTexture = new InternalTexture(this, InternalTextureSource.Unknown, true);
        internalTexture.width = width;
        internalTexture.height = height;
        internalTexture.isMultiview = true;
        if (!colorTexture) {
            colorTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D_ARRAY, colorTexture);
            gl.texStorage3D(gl.TEXTURE_2D_ARRAY, 1, gl.RGBA8, width, height, 2);
        }
        rtWrapper._colorTextureArray = colorTexture;
        if (!depthStencilTexture) {
            depthStencilTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D_ARRAY, depthStencilTexture);
            gl.texStorage3D(gl.TEXTURE_2D_ARRAY, 1, gl.DEPTH24_STENCIL8, width, height, 2);
        }
        rtWrapper._depthStencilTextureArray = depthStencilTexture;
        internalTexture.isReady = true;
        rtWrapper.setTextures(internalTexture);
        rtWrapper._depthStencilTexture = internalTexture;
        return rtWrapper;
    };
    Engine.prototype.bindMultiviewFramebuffer = function (_multiviewTexture) {
        const multiviewTexture = _multiviewTexture;
        const gl = this._gl;
        const ext = this.getCaps().oculusMultiview || this.getCaps().multiview;
        this.bindFramebuffer(multiviewTexture, undefined, undefined, undefined, true);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, multiviewTexture._framebuffer);
        if (multiviewTexture._colorTextureArray && multiviewTexture._depthStencilTextureArray) {
            if (this.getCaps().oculusMultiview) {
                ext.framebufferTextureMultisampleMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, multiviewTexture._colorTextureArray, 0, multiviewTexture.samples, 0, 2);
                ext.framebufferTextureMultisampleMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, multiviewTexture._depthStencilTextureArray, 0, multiviewTexture.samples, 0, 2);
            }
            else {
                ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, multiviewTexture._colorTextureArray, 0, 0, 2);
                ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, multiviewTexture._depthStencilTextureArray, 0, 0, 2);
            }
        }
        else {
            throw "Invalid multiview frame buffer";
        }
    };
    Engine.prototype.bindSpaceWarpFramebuffer = function (_spaceWarpTexture) {
        const spaceWarpTexture = _spaceWarpTexture;
        const gl = this._gl;
        const ext = this.getCaps().oculusMultiview || this.getCaps().multiview;
        this.bindFramebuffer(spaceWarpTexture, undefined, undefined, undefined, true);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, spaceWarpTexture._framebuffer);
        if (spaceWarpTexture._colorTextureArray && spaceWarpTexture._depthStencilTextureArray) {
            ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, spaceWarpTexture._colorTextureArray, 0, 0, 2);
            ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.DEPTH_ATTACHMENT, spaceWarpTexture._depthStencilTextureArray, 0, 0, 2);
        }
        else {
            throw new Error("Invalid Space Warp framebuffer");
        }
    };
    Camera.prototype._useMultiviewToSingleView = false;
    Camera.prototype._multiviewTexture = null;
    Camera.prototype._resizeOrCreateMultiviewTexture = function (width, height) {
        if (!this._multiviewTexture) {
            this._multiviewTexture = new MultiviewRenderTarget(this.getScene(), { width: width, height: height });
        }
        else if (this._multiviewTexture.getRenderWidth() != width || this._multiviewTexture.getRenderHeight() != height) {
            this._multiviewTexture.dispose();
            this._multiviewTexture = new MultiviewRenderTarget(this.getScene(), { width: width, height: height });
        }
    };
    function createMultiviewUbo(engine, name) {
        const ubo = new UniformBuffer(engine, undefined, true, name);
        ubo.addUniform("viewProjection", 16);
        ubo.addUniform("viewProjectionR", 16);
        ubo.addUniform("view", 16);
        ubo.addUniform("projection", 16);
        ubo.addUniform("vEyePosition", 4);
        return ubo;
    }
    const currentCreateSceneUniformBuffer = Scene.prototype.createSceneUniformBuffer;
    Scene.prototype._transformMatrixR = Matrix.Zero();
    Scene.prototype._multiviewSceneUbo = null;
    Scene.prototype._createMultiviewUbo = function () {
        this._multiviewSceneUbo = createMultiviewUbo(this.getEngine(), "scene_multiview");
    };
    Scene.prototype.createSceneUniformBuffer = function (name) {
        if (this._multiviewSceneUbo) {
            return createMultiviewUbo(this.getEngine(), name);
        }
        return currentCreateSceneUniformBuffer.bind(this)(name);
    };
    Scene.prototype._updateMultiviewUbo = function (viewR, projectionR) {
        if (viewR && projectionR) {
            viewR.multiplyToRef(projectionR, this._transformMatrixR);
        }
        if (viewR && projectionR) {
            viewR.multiplyToRef(projectionR, TmpVectors.Matrix[0]);
            Frustum.GetRightPlaneToRef(TmpVectors.Matrix[0], this._frustumPlanes[3]); // Replace right plane by second camera right plane
        }
        if (this._multiviewSceneUbo) {
            this._multiviewSceneUbo.updateMatrix("viewProjection", this.getTransformMatrix());
            this._multiviewSceneUbo.updateMatrix("viewProjectionR", this._transformMatrixR);
            this._multiviewSceneUbo.updateMatrix("view", this._viewMatrix);
            this._multiviewSceneUbo.updateMatrix("projection", this._projectionMatrix);
        }
    };
    Scene.prototype._renderMultiviewToSingleView = function (camera) {
        // Multiview is only able to be displayed directly for API's such as webXR
        // This displays a multiview image by rendering to the multiview image and then
        // copying the result into the sub cameras instead of rendering them and proceeding as normal from there
        // Render to a multiview texture
        camera._resizeOrCreateMultiviewTexture(camera._rigPostProcess && camera._rigPostProcess && camera._rigPostProcess.width > 0 ? camera._rigPostProcess.width : this.getEngine().getRenderWidth(true), camera._rigPostProcess && camera._rigPostProcess && camera._rigPostProcess.height > 0 ? camera._rigPostProcess.height : this.getEngine().getRenderHeight(true));
        if (!this._multiviewSceneUbo) {
            this._createMultiviewUbo();
        }
        camera.outputRenderTarget = camera._multiviewTexture;
        this._renderForCamera(camera);
        camera.outputRenderTarget = null;
        // Consume the multiview texture through a shader for each eye
        for (let index = 0; index < camera._rigCameras.length; index++) {
            const engine = this.getEngine();
            this._activeCamera = camera._rigCameras[index];
            engine.setViewport(this._activeCamera.viewport);
            if (this.postProcessManager) {
                this.postProcessManager._prepareFrame();
                this.postProcessManager._finalizeFrame(this._activeCamera.isIntermediate);
            }
        }
    };

    /**
     * VRMultiviewToSingleview used to convert multiview texture arrays to standard textures for scenarios such as webVR
     * This will not be used for webXR as it supports displaying texture arrays directly
     */
    class VRMultiviewToSingleviewPostProcess extends PostProcess {
        /**
         * Gets a string identifying the name of the class
         * @returns "VRMultiviewToSingleviewPostProcess" string
         */
        getClassName() {
            return "VRMultiviewToSingleviewPostProcess";
        }
        /**
         * Initializes a VRMultiviewToSingleview
         * @param name name of the post process
         * @param camera camera to be applied to
         * @param scaleFactor scaling factor to the size of the output texture
         */
        constructor(name, camera, scaleFactor) {
            super(name, "vrMultiviewToSingleview", ["imageIndex"], ["multiviewSampler"], scaleFactor, camera, Texture.BILINEAR_SAMPLINGMODE);
            const cam = camera !== null && camera !== void 0 ? camera : this.getCamera();
            this.onSizeChangedObservable.add(() => { });
            this.onApplyObservable.add((effect) => {
                if (cam._scene.activeCamera && cam._scene.activeCamera.isLeftCamera) {
                    effect.setInt("imageIndex", 0);
                }
                else {
                    effect.setInt("imageIndex", 1);
                }
                effect.setTexture("multiviewSampler", cam._multiviewTexture);
            });
        }
    }

    /**
     * @internal
     */
    function setVRRigMode(camera, rigParams) {
        const metrics = rigParams.vrCameraMetrics || VRCameraMetrics.GetDefault();
        camera._rigCameras[0]._cameraRigParams.vrMetrics = metrics;
        camera._rigCameras[0].viewport = new Viewport(0, 0, 0.5, 1.0);
        camera._rigCameras[0]._cameraRigParams.vrWorkMatrix = new Matrix();
        camera._rigCameras[0]._cameraRigParams.vrHMatrix = metrics.leftHMatrix;
        camera._rigCameras[0]._cameraRigParams.vrPreViewMatrix = metrics.leftPreViewMatrix;
        camera._rigCameras[0].getProjectionMatrix = camera._rigCameras[0]._getVRProjectionMatrix;
        camera._rigCameras[1]._cameraRigParams.vrMetrics = metrics;
        camera._rigCameras[1].viewport = new Viewport(0.5, 0, 0.5, 1.0);
        camera._rigCameras[1]._cameraRigParams.vrWorkMatrix = new Matrix();
        camera._rigCameras[1]._cameraRigParams.vrHMatrix = metrics.rightHMatrix;
        camera._rigCameras[1]._cameraRigParams.vrPreViewMatrix = metrics.rightPreViewMatrix;
        camera._rigCameras[1].getProjectionMatrix = camera._rigCameras[1]._getVRProjectionMatrix;
        // For multiview on a webVR camera
        // First multiview will be rendered to camera._multiviewTexture
        // Then this postprocess will run on each eye to copy the right texture to each eye
        if (metrics.multiviewEnabled) {
            if (!camera.getScene().getEngine().getCaps().multiview) {
                Logger.Warn("Multiview is not supported, falling back to standard rendering");
                metrics.multiviewEnabled = false;
            }
            else {
                camera._useMultiviewToSingleView = true;
                camera._rigPostProcess = new VRMultiviewToSingleviewPostProcess("VRMultiviewToSingleview", camera, metrics.postProcessScaleFactor);
            }
        }
        if (metrics.compensateDistortion) {
            camera._rigCameras[0]._rigPostProcess = new VRDistortionCorrectionPostProcess("VR_Distort_Compensation_Left", camera._rigCameras[0], false, metrics);
            camera._rigCameras[1]._rigPostProcess = new VRDistortionCorrectionPostProcess("VR_Distort_Compensation_Right", camera._rigCameras[1], true, metrics);
        }
    }

    Node.AddNodeConstructor("VRDeviceOrientationFreeCamera", (name, scene) => {
        return () => new VRDeviceOrientationFreeCamera(name, Vector3.Zero(), scene);
    });
    /**
     * Camera used to simulate VR rendering (based on FreeCamera)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#vr-device-orientation-cameras
     */
    class VRDeviceOrientationFreeCamera extends DeviceOrientationCamera {
        /**
         * Creates a new VRDeviceOrientationFreeCamera
         * @param name defines camera name
         * @param position defines the start position of the camera
         * @param scene defines the scene the camera belongs to
         * @param compensateDistortion defines if the camera needs to compensate the lens distortion
         * @param vrCameraMetrics defines the vr metrics associated to the camera
         */
        constructor(name, position, scene, compensateDistortion = true, vrCameraMetrics = VRCameraMetrics.GetDefault()) {
            super(name, position, scene);
            this._setRigMode = setVRRigMode.bind(null, this);
            vrCameraMetrics.compensateDistortion = compensateDistortion;
            this.setCameraRigMode(Camera.RIG_MODE_VR, { vrCameraMetrics: vrCameraMetrics });
        }
        /**
         * Gets camera class name
         * @returns VRDeviceOrientationFreeCamera
         */
        getClassName() {
            return "VRDeviceOrientationFreeCamera";
        }
    }

    /**
     * Represents a gamepad
     */
    class Gamepad {
        /**
         * Specifies if the gamepad has been connected
         */
        get isConnected() {
            return this._isConnected;
        }
        /**
         * Initializes the gamepad
         * @param id The id of the gamepad
         * @param index The index of the gamepad
         * @param browserGamepad The browser gamepad
         * @param leftStickX The x component of the left joystick
         * @param leftStickY The y component of the left joystick
         * @param rightStickX The x component of the right joystick
         * @param rightStickY The y component of the right joystick
         */
        constructor(
        /**
         * The id of the gamepad
         */
        id, 
        /**
         * The index of the gamepad
         */
        index, 
        /**
         * The browser gamepad
         */
        browserGamepad, leftStickX = 0, leftStickY = 1, rightStickX = 2, rightStickY = 3) {
            this.id = id;
            this.index = index;
            this.browserGamepad = browserGamepad;
            this._leftStick = { x: 0, y: 0 };
            this._rightStick = { x: 0, y: 0 };
            /** @internal */
            this._isConnected = true;
            /**
             * Specifies whether the left control stick should be Y-inverted
             */
            this._invertLeftStickY = false;
            this.type = Gamepad.GAMEPAD;
            this._leftStickAxisX = leftStickX;
            this._leftStickAxisY = leftStickY;
            this._rightStickAxisX = rightStickX;
            this._rightStickAxisY = rightStickY;
            if (this.browserGamepad.axes.length >= 2) {
                this._leftStick = { x: this.browserGamepad.axes[this._leftStickAxisX], y: this.browserGamepad.axes[this._leftStickAxisY] };
            }
            if (this.browserGamepad.axes.length >= 4) {
                this._rightStick = { x: this.browserGamepad.axes[this._rightStickAxisX], y: this.browserGamepad.axes[this._rightStickAxisY] };
            }
        }
        /**
         * Callback triggered when the left joystick has changed
         * @param callback
         */
        onleftstickchanged(callback) {
            this._onleftstickchanged = callback;
        }
        /**
         * Callback triggered when the right joystick has changed
         * @param callback
         */
        onrightstickchanged(callback) {
            this._onrightstickchanged = callback;
        }
        /**
         * Gets the left joystick
         */
        get leftStick() {
            return this._leftStick;
        }
        /**
         * Sets the left joystick values
         */
        set leftStick(newValues) {
            if (this._onleftstickchanged && (this._leftStick.x !== newValues.x || this._leftStick.y !== newValues.y)) {
                this._onleftstickchanged(newValues);
            }
            this._leftStick = newValues;
        }
        /**
         * Gets the right joystick
         */
        get rightStick() {
            return this._rightStick;
        }
        /**
         * Sets the right joystick value
         */
        set rightStick(newValues) {
            if (this._onrightstickchanged && (this._rightStick.x !== newValues.x || this._rightStick.y !== newValues.y)) {
                this._onrightstickchanged(newValues);
            }
            this._rightStick = newValues;
        }
        /**
         * Updates the gamepad joystick positions
         */
        update() {
            if (this._leftStick) {
                this.leftStick = { x: this.browserGamepad.axes[this._leftStickAxisX], y: this.browserGamepad.axes[this._leftStickAxisY] };
                if (this._invertLeftStickY) {
                    this.leftStick.y *= -1;
                }
            }
            if (this._rightStick) {
                this.rightStick = { x: this.browserGamepad.axes[this._rightStickAxisX], y: this.browserGamepad.axes[this._rightStickAxisY] };
            }
        }
        /**
         * Disposes the gamepad
         */
        dispose() { }
    }
    /**
     * Represents a gamepad controller
     */
    Gamepad.GAMEPAD = 0;
    /**
     * Represents a generic controller
     */
    Gamepad.GENERIC = 1;
    /**
     * Represents an XBox controller
     */
    Gamepad.XBOX = 2;
    /**
     * Represents a pose-enabled controller
     */
    Gamepad.POSE_ENABLED = 3;
    /**
     * Represents an Dual Shock controller
     */
    Gamepad.DUALSHOCK = 4;
    /**
     * Represents a generic gamepad
     */
    class GenericPad extends Gamepad {
        /**
         * Callback triggered when a button has been pressed
         * @param callback Called when a button has been pressed
         */
        onbuttondown(callback) {
            this._onbuttondown = callback;
        }
        /**
         * Callback triggered when a button has been released
         * @param callback Called when a button has been released
         */
        onbuttonup(callback) {
            this._onbuttonup = callback;
        }
        /**
         * Initializes the generic gamepad
         * @param id The id of the generic gamepad
         * @param index The index of the generic gamepad
         * @param browserGamepad The browser gamepad
         */
        constructor(id, index, browserGamepad) {
            super(id, index, browserGamepad);
            /**
             * Observable triggered when a button has been pressed
             */
            this.onButtonDownObservable = new Observable$1();
            /**
             * Observable triggered when a button has been released
             */
            this.onButtonUpObservable = new Observable$1();
            this.type = Gamepad.GENERIC;
            this._buttons = new Array(browserGamepad.buttons.length);
        }
        _setButtonValue(newValue, currentValue, buttonIndex) {
            if (newValue !== currentValue) {
                if (newValue === 1) {
                    if (this._onbuttondown) {
                        this._onbuttondown(buttonIndex);
                    }
                    this.onButtonDownObservable.notifyObservers(buttonIndex);
                }
                if (newValue === 0) {
                    if (this._onbuttonup) {
                        this._onbuttonup(buttonIndex);
                    }
                    this.onButtonUpObservable.notifyObservers(buttonIndex);
                }
            }
            return newValue;
        }
        /**
         * Updates the generic gamepad
         */
        update() {
            super.update();
            for (let index = 0; index < this._buttons.length; index++) {
                this._buttons[index] = this._setButtonValue(this.browserGamepad.buttons[index].value, this._buttons[index], index);
            }
        }
        /**
         * Disposes the generic gamepad
         */
        dispose() {
            super.dispose();
            this.onButtonDownObservable.clear();
            this.onButtonUpObservable.clear();
        }
    }

    /**
     * Defines the types of pose enabled controllers that are supported
     */
    var PoseEnabledControllerType;
    (function (PoseEnabledControllerType) {
        /**
         * HTC Vive
         */
        PoseEnabledControllerType[PoseEnabledControllerType["VIVE"] = 0] = "VIVE";
        /**
         * Oculus Rift
         */
        PoseEnabledControllerType[PoseEnabledControllerType["OCULUS"] = 1] = "OCULUS";
        /**
         * Windows mixed reality
         */
        PoseEnabledControllerType[PoseEnabledControllerType["WINDOWS"] = 2] = "WINDOWS";
        /**
         * Samsung gear VR
         */
        PoseEnabledControllerType[PoseEnabledControllerType["GEAR_VR"] = 3] = "GEAR_VR";
        /**
         * Google Daydream
         */
        PoseEnabledControllerType[PoseEnabledControllerType["DAYDREAM"] = 4] = "DAYDREAM";
        /**
         * Generic
         */
        PoseEnabledControllerType[PoseEnabledControllerType["GENERIC"] = 5] = "GENERIC";
    })(PoseEnabledControllerType || (PoseEnabledControllerType = {}));
    /**
     * Defines the PoseEnabledControllerHelper object that is used initialize a gamepad as the controller type it is specified as (eg. windows mixed reality controller)
     */
    class PoseEnabledControllerHelper {
        /**
         * Initializes a gamepad as the controller type it is specified as (eg. windows mixed reality controller)
         * @param vrGamepad the gamepad to initialized
         * @returns a vr controller of the type the gamepad identified as
         */
        static InitiateController(vrGamepad) {
            for (const factory of this._ControllerFactories) {
                if (factory.canCreate(vrGamepad)) {
                    return factory.create(vrGamepad);
                }
            }
            if (this._DefaultControllerFactory) {
                return this._DefaultControllerFactory(vrGamepad);
            }
            throw "The type of gamepad you are trying to load needs to be imported first or is not supported.";
        }
    }
    /** @internal */
    PoseEnabledControllerHelper._ControllerFactories = [];
    /** @internal */
    PoseEnabledControllerHelper._DefaultControllerFactory = null;
    /**
     * Defines the PoseEnabledController object that contains state of a vr capable controller
     */
    class PoseEnabledController extends Gamepad {
        /**
         * @internal
         */
        _disableTrackPosition(fixedPosition) {
            if (this._trackPosition) {
                this._calculatedPosition.copyFrom(fixedPosition);
                this._trackPosition = false;
            }
        }
        /**
         * Creates a new PoseEnabledController from a gamepad
         * @param browserGamepad the gamepad that the PoseEnabledController should be created from
         */
        constructor(browserGamepad) {
            super(browserGamepad.id, browserGamepad.index, browserGamepad);
            /**
             * If the controller is used in a webXR session
             */
            this.isXR = false;
            // Represents device position and rotation in room space. Should only be used to help calculate babylon space values
            this._deviceRoomPosition = Vector3.Zero();
            this._deviceRoomRotationQuaternion = new Quaternion();
            /**
             * The device position in babylon space
             */
            this.devicePosition = Vector3.Zero();
            /**
             * The device rotation in babylon space
             */
            this.deviceRotationQuaternion = new Quaternion();
            /**
             * The scale factor of the device in babylon space
             */
            this.deviceScaleFactor = 1;
            // Used to convert 6dof controllers to 3dof
            this._trackPosition = true;
            this._maxRotationDistFromHeadset = Math.PI / 5;
            this._draggedRoomRotation = 0;
            this._leftHandSystemQuaternion = new Quaternion();
            /**
             * Internal, matrix used to convert room space to babylon space
             * @internal
             */
            this._deviceToWorld = Matrix.Identity();
            /**
             * Node to be used when casting a ray from the controller
             * @internal
             */
            this._pointingPoseNode = null;
            this._workingMatrix = Matrix.Identity();
            /**
             * @internal
             */
            this._meshAttachedObservable = new Observable$1();
            this.type = Gamepad.POSE_ENABLED;
            this.controllerType = PoseEnabledControllerType.GENERIC;
            this.position = Vector3.Zero();
            this.rotationQuaternion = new Quaternion();
            this._calculatedPosition = Vector3.Zero();
            this._calculatedRotation = new Quaternion();
            Quaternion.RotationYawPitchRollToRef(Math.PI, 0, 0, this._leftHandSystemQuaternion);
        }
        /**
         * Updates the state of the pose enabled controller and mesh based on the current position and rotation of the controller
         */
        update() {
            super.update();
            this._updatePoseAndMesh();
        }
        /**
         * Updates only the pose device and mesh without doing any button event checking
         */
        _updatePoseAndMesh() {
            if (this.isXR) {
                return;
            }
            const pose = this.browserGamepad.pose;
            this.updateFromDevice(pose);
            if (!this._trackPosition &&
                EngineStore.LastCreatedScene &&
                EngineStore.LastCreatedScene.activeCamera &&
                EngineStore.LastCreatedScene.activeCamera.devicePosition) {
                const camera = EngineStore.LastCreatedScene.activeCamera;
                camera._computeDevicePosition();
                this._deviceToWorld.setTranslation(camera.devicePosition);
                if (camera.deviceRotationQuaternion) {
                    camera._deviceRoomRotationQuaternion.toEulerAnglesToRef(TmpVectors.Vector3[0]);
                    // Find the radian distance away that the headset is from the controllers rotation
                    const distanceAway = Math.atan2(Math.sin(TmpVectors.Vector3[0].y - this._draggedRoomRotation), Math.cos(TmpVectors.Vector3[0].y - this._draggedRoomRotation));
                    if (Math.abs(distanceAway) > this._maxRotationDistFromHeadset) {
                        // Only rotate enouph to be within the _maxRotationDistFromHeadset
                        const rotationAmount = distanceAway - (distanceAway < 0 ? -this._maxRotationDistFromHeadset : this._maxRotationDistFromHeadset);
                        this._draggedRoomRotation += rotationAmount;
                        // Rotate controller around headset
                        const sin = Math.sin(-rotationAmount);
                        const cos = Math.cos(-rotationAmount);
                        this._calculatedPosition.x = this._calculatedPosition.x * cos - this._calculatedPosition.z * sin;
                        this._calculatedPosition.z = this._calculatedPosition.x * sin + this._calculatedPosition.z * cos;
                    }
                }
            }
            Vector3.TransformCoordinatesToRef(this._calculatedPosition, this._deviceToWorld, this.devicePosition);
            this._deviceToWorld.getRotationMatrixToRef(this._workingMatrix);
            Quaternion.FromRotationMatrixToRef(this._workingMatrix, this.deviceRotationQuaternion);
            this.deviceRotationQuaternion.multiplyInPlace(this._calculatedRotation);
            if (this._mesh) {
                this._mesh.position.copyFrom(this.devicePosition);
                if (this._mesh.rotationQuaternion) {
                    this._mesh.rotationQuaternion.copyFrom(this.deviceRotationQuaternion);
                }
            }
        }
        /**
         * Updates the state of the pose enbaled controller based on the raw pose data from the device
         * @param poseData raw pose fromthe device
         */
        updateFromDevice(poseData) {
            if (this.isXR) {
                return;
            }
            if (poseData) {
                this.rawPose = poseData;
                if (poseData.position) {
                    this._deviceRoomPosition.copyFromFloats(poseData.position[0], poseData.position[1], -poseData.position[2]);
                    if (this._mesh && this._mesh.getScene().useRightHandedSystem) {
                        this._deviceRoomPosition.z *= -1;
                    }
                    if (this._trackPosition) {
                        this._deviceRoomPosition.scaleToRef(this.deviceScaleFactor, this._calculatedPosition);
                    }
                    this._calculatedPosition.addInPlace(this.position);
                }
                const pose = this.rawPose;
                if (poseData.orientation && pose.orientation && pose.orientation.length === 4) {
                    this._deviceRoomRotationQuaternion.copyFromFloats(pose.orientation[0], pose.orientation[1], -pose.orientation[2], -pose.orientation[3]);
                    if (this._mesh) {
                        if (this._mesh.getScene().useRightHandedSystem) {
                            this._deviceRoomRotationQuaternion.z *= -1;
                            this._deviceRoomRotationQuaternion.w *= -1;
                        }
                        else {
                            this._deviceRoomRotationQuaternion.multiplyToRef(this._leftHandSystemQuaternion, this._deviceRoomRotationQuaternion);
                        }
                    }
                    // if the camera is set, rotate to the camera's rotation
                    this._deviceRoomRotationQuaternion.multiplyToRef(this.rotationQuaternion, this._calculatedRotation);
                }
            }
        }
        /**
         * Attaches a mesh to the controller
         * @param mesh the mesh to be attached
         */
        attachToMesh(mesh) {
            if (this._mesh) {
                this._mesh.parent = null;
            }
            this._mesh = mesh;
            if (this._poseControlledCamera) {
                this._mesh.parent = this._poseControlledCamera;
            }
            if (!this._mesh.rotationQuaternion) {
                this._mesh.rotationQuaternion = new Quaternion();
            }
            // Sync controller mesh and pointing pose node's state with controller, this is done to avoid a frame where position is 0,0,0 when attaching mesh
            if (!this.isXR) {
                this._updatePoseAndMesh();
                if (this._pointingPoseNode) {
                    const parents = [];
                    let obj = this._pointingPoseNode;
                    while (obj.parent) {
                        parents.push(obj.parent);
                        obj = obj.parent;
                    }
                    parents.reverse().forEach((p) => {
                        p.computeWorldMatrix(true);
                    });
                }
            }
            this._meshAttachedObservable.notifyObservers(mesh);
        }
        /**
         * Attaches the controllers mesh to a camera
         * @param camera the camera the mesh should be attached to
         */
        attachToPoseControlledCamera(camera) {
            this._poseControlledCamera = camera;
            if (this._mesh) {
                this._mesh.parent = this._poseControlledCamera;
            }
        }
        /**
         * Disposes of the controller
         */
        dispose() {
            if (this._mesh) {
                this._mesh.dispose();
            }
            this._mesh = null;
            super.dispose();
        }
        /**
         * The mesh that is attached to the controller
         */
        get mesh() {
            return this._mesh;
        }
        /**
         * Gets the ray of the controller in the direction the controller is pointing
         * @param length the length the resulting ray should be
         * @returns a ray in the direction the controller is pointing
         */
        getForwardRay(length = 100) {
            if (!this.mesh) {
                return new Ray(Vector3.Zero(), new Vector3(0, 0, 1), length);
            }
            const m = this._pointingPoseNode ? this._pointingPoseNode.getWorldMatrix() : this.mesh.getWorldMatrix();
            const origin = m.getTranslation();
            const forward = new Vector3(0, 0, -1);
            const forwardWorld = Vector3.TransformNormal(forward, m);
            const direction = Vector3.Normalize(forwardWorld);
            return new Ray(origin, direction, length);
        }
    }
    /**
     * Name of the child mesh that can be used to cast a ray from the controller
     */
    PoseEnabledController.POINTING_POSE = "POINTING_POSE";

    /**
     * @internal
     */
    function setWebVRRigMode(camera, rigParams) {
        if (rigParams.vrDisplay) {
            const leftEye = rigParams.vrDisplay.getEyeParameters("left");
            const rightEye = rigParams.vrDisplay.getEyeParameters("right");
            //Left eye
            camera._rigCameras[0].viewport = new Viewport(0, 0, 0.5, 1.0);
            camera._rigCameras[0].setCameraRigParameter("left", true);
            //leaving this for future reference
            camera._rigCameras[0].setCameraRigParameter("specs", rigParams.specs);
            camera._rigCameras[0].setCameraRigParameter("eyeParameters", leftEye);
            camera._rigCameras[0].setCameraRigParameter("frameData", rigParams.frameData);
            camera._rigCameras[0].setCameraRigParameter("parentCamera", rigParams.parentCamera);
            camera._rigCameras[0]._cameraRigParams.vrWorkMatrix = new Matrix();
            camera._rigCameras[0].getProjectionMatrix = camera._getWebVRProjectionMatrix;
            camera._rigCameras[0].parent = camera;
            camera._rigCameras[0]._getViewMatrix = camera._getWebVRViewMatrix;
            //Right eye
            camera._rigCameras[1].viewport = new Viewport(0.5, 0, 0.5, 1.0);
            camera._rigCameras[1].setCameraRigParameter("eyeParameters", rightEye);
            camera._rigCameras[1].setCameraRigParameter("specs", rigParams.specs);
            camera._rigCameras[1].setCameraRigParameter("frameData", rigParams.frameData);
            camera._rigCameras[1].setCameraRigParameter("parentCamera", rigParams.parentCamera);
            camera._rigCameras[1]._cameraRigParams.vrWorkMatrix = new Matrix();
            camera._rigCameras[1].getProjectionMatrix = camera._getWebVRProjectionMatrix;
            camera._rigCameras[1].parent = camera;
            camera._rigCameras[1]._getViewMatrix = camera._getWebVRViewMatrix;
        }
    }

    Object.defineProperty(Engine.prototype, "isInVRExclusivePointerMode", {
        get: function () {
            return this._vrExclusivePointerMode;
        },
        enumerable: true,
        configurable: true,
    });
    Engine.prototype._prepareVRComponent = function () {
        this._vrSupported = false;
        this._vrExclusivePointerMode = false;
        this.onVRDisplayChangedObservable = new Observable$1();
        this.onVRRequestPresentComplete = new Observable$1();
        this.onVRRequestPresentStart = new Observable$1();
    };
    Engine.prototype.isVRDevicePresent = function () {
        return !!this._vrDisplay;
    };
    Engine.prototype.getVRDevice = function () {
        return this._vrDisplay;
    };
    Engine.prototype.initWebVR = function () {
        this.initWebVRAsync();
        return this.onVRDisplayChangedObservable;
    };
    Engine.prototype.initWebVRAsync = function () {
        const notifyObservers = () => {
            const eventArgs = {
                vrDisplay: this._vrDisplay,
                vrSupported: this._vrSupported,
            };
            this.onVRDisplayChangedObservable.notifyObservers(eventArgs);
            this._webVRInitPromise = new Promise((res) => {
                res(eventArgs);
            });
        };
        if (!this._onVrDisplayConnect) {
            this._onVrDisplayConnect = (event) => {
                this._vrDisplay = event.display;
                notifyObservers();
            };
            this._onVrDisplayDisconnect = () => {
                this._vrDisplay.cancelAnimationFrame(this._frameHandler);
                this._vrDisplay = undefined;
                this._frameHandler = Engine.QueueNewFrame(this._boundRenderFunction);
                notifyObservers();
            };
            this._onVrDisplayPresentChange = () => {
                this._vrExclusivePointerMode = this._vrDisplay && this._vrDisplay.isPresenting;
            };
            const hostWindow = this.getHostWindow();
            if (hostWindow) {
                hostWindow.addEventListener("vrdisplayconnect", this._onVrDisplayConnect);
                hostWindow.addEventListener("vrdisplaydisconnect", this._onVrDisplayDisconnect);
                hostWindow.addEventListener("vrdisplaypresentchange", this._onVrDisplayPresentChange);
            }
        }
        this._webVRInitPromise = this._webVRInitPromise || this._getVRDisplaysAsync();
        this._webVRInitPromise.then(notifyObservers);
        return this._webVRInitPromise;
    };
    Engine.prototype._getVRDisplaysAsync = function () {
        return new Promise((res) => {
            if (navigator.getVRDisplays) {
                navigator.getVRDisplays().then((devices) => {
                    this._vrSupported = true;
                    // note that devices may actually be an empty array. This is fine;
                    // we expect this._vrDisplay to be undefined in this case.
                    this._vrDisplay = devices[0];
                    res({
                        vrDisplay: this._vrDisplay,
                        vrSupported: this._vrSupported,
                    });
                });
            }
            else {
                this._vrDisplay = undefined;
                this._vrSupported = false;
                res({
                    vrDisplay: this._vrDisplay,
                    vrSupported: this._vrSupported,
                });
            }
        });
    };
    Engine.prototype.enableVR = function (options) {
        if (this._vrDisplay && !this._vrDisplay.isPresenting) {
            const onResolved = () => {
                this.onVRRequestPresentComplete.notifyObservers(true);
                this._onVRFullScreenTriggered();
            };
            const onRejected = () => {
                this.onVRRequestPresentComplete.notifyObservers(false);
            };
            this.onVRRequestPresentStart.notifyObservers(this);
            const presentationAttributes = {
                highRefreshRate: this.vrPresentationAttributes ? this.vrPresentationAttributes.highRefreshRate : false,
                foveationLevel: this.vrPresentationAttributes ? this.vrPresentationAttributes.foveationLevel : 1,
                multiview: (this.getCaps().multiview || this.getCaps().oculusMultiview) && options.useMultiview,
            };
            this._vrDisplay
                .requestPresent([
                Object.assign({ source: this.getRenderingCanvas(), attributes: presentationAttributes }, presentationAttributes),
            ])
                .then(onResolved)
                .catch(onRejected);
        }
    };
    Engine.prototype._onVRFullScreenTriggered = function () {
        if (this._vrDisplay && this._vrDisplay.isPresenting) {
            //get the old size before we change
            this._oldSize = new Size(this.getRenderWidth(), this.getRenderHeight());
            this._oldHardwareScaleFactor = this.getHardwareScalingLevel();
            //get the width and height, change the render size
            const leftEye = this._vrDisplay.getEyeParameters("left");
            this.setHardwareScalingLevel(1);
            this.setSize(leftEye.renderWidth * 2, leftEye.renderHeight);
        }
        else {
            this.setHardwareScalingLevel(this._oldHardwareScaleFactor);
            this.setSize(this._oldSize.width, this._oldSize.height);
        }
    };
    Engine.prototype.disableVR = function () {
        if (this._vrDisplay && this._vrDisplay.isPresenting) {
            this._vrDisplay
                .exitPresent()
                .then(() => this._onVRFullScreenTriggered())
                .catch(() => this._onVRFullScreenTriggered());
        }
        if (IsWindowObjectExist()) {
            window.removeEventListener("vrdisplaypointerrestricted", this._onVRDisplayPointerRestricted);
            window.removeEventListener("vrdisplaypointerunrestricted", this._onVRDisplayPointerUnrestricted);
            if (this._onVrDisplayConnect) {
                window.removeEventListener("vrdisplayconnect", this._onVrDisplayConnect);
                if (this._onVrDisplayDisconnect) {
                    window.removeEventListener("vrdisplaydisconnect", this._onVrDisplayDisconnect);
                }
                if (this._onVrDisplayPresentChange) {
                    window.removeEventListener("vrdisplaypresentchange", this._onVrDisplayPresentChange);
                }
                this._onVrDisplayConnect = null;
                this._onVrDisplayDisconnect = null;
            }
        }
    };
    Engine.prototype._connectVREvents = function (canvas, document) {
        this._onVRDisplayPointerRestricted = () => {
            if (canvas) {
                canvas.requestPointerLock();
            }
        };
        this._onVRDisplayPointerUnrestricted = () => {
            // Edge fix - for some reason document is not present and this is window
            if (!document) {
                const hostWindow = this.getHostWindow();
                if (hostWindow.document && hostWindow.document.exitPointerLock) {
                    hostWindow.document.exitPointerLock();
                }
                return;
            }
            if (!document.exitPointerLock) {
                return;
            }
            document.exitPointerLock();
        };
        if (IsWindowObjectExist()) {
            const hostWindow = this.getHostWindow();
            hostWindow.addEventListener("vrdisplaypointerrestricted", this._onVRDisplayPointerRestricted, false);
            hostWindow.addEventListener("vrdisplaypointerunrestricted", this._onVRDisplayPointerUnrestricted, false);
        }
    };
    Engine.prototype._submitVRFrame = function () {
        // Submit frame to the vr device, if enabled
        if (this._vrDisplay && this._vrDisplay.isPresenting) {
            // TODO: We should only submit the frame if we read frameData successfully.
            try {
                this._vrDisplay.submitFrame();
            }
            catch (e) {
                Tools.Warn("webVR submitFrame has had an unexpected failure: " + e);
            }
        }
    };
    Engine.prototype.isVRPresenting = function () {
        return this._vrDisplay && this._vrDisplay.isPresenting;
    };
    Engine.prototype._requestVRFrame = function () {
        this._frameHandler = Engine.QueueNewFrame(this._boundRenderFunction, this._vrDisplay);
    };

    Node.AddNodeConstructor("WebVRFreeCamera", (name, scene) => {
        return () => new WebVRFreeCamera(name, Vector3.Zero(), scene);
    });
    Node.AddNodeConstructor("WebVRGamepadCamera", (name, scene) => {
        return () => new WebVRFreeCamera(name, Vector3.Zero(), scene);
    });
    /**
     * This represents a WebVR camera.
     * The WebVR camera is Babylon's simple interface to interaction with Windows Mixed Reality, HTC Vive and Oculus Rift.
     * @deprecated Use WebXR instead - https://doc.babylonjs.com/features/featuresDeepDive/webXR
     * @example https://doc.babylonjs.com/features/featuresDeepDive/cameras/webVRCamera
     */
    class WebVRFreeCamera extends FreeCamera {
        /**
         * Instantiates a WebVRFreeCamera.
         * @param name The name of the WebVRFreeCamera
         * @param position The starting anchor position for the camera
         * @param scene The scene the camera belongs to
         * @param _webVROptions a set of customizable options for the webVRCamera
         */
        constructor(name, position, scene, _webVROptions = {}) {
            super(name, position, scene);
            this._webVROptions = _webVROptions;
            /**
             * @internal
             * The vrDisplay tied to the camera. See https://developer.mozilla.org/en-US/docs/Web/API/VRDisplay
             */
            this._vrDevice = null;
            /**
             * The rawPose of the vrDevice.
             */
            this.rawPose = null;
            this._specsVersion = "1.1";
            this._attached = false;
            this._descendants = [];
            // Represents device position and rotation in room space. Should only be used to help calculate babylon space values
            this._deviceRoomPosition = Vector3.Zero();
            /** @internal */
            this._deviceRoomRotationQuaternion = Quaternion.Identity();
            this._standingMatrix = null;
            /**
             * Represents device position in babylon space.
             */
            this.devicePosition = Vector3.Zero();
            /**
             * Represents device rotation in babylon space.
             */
            this.deviceRotationQuaternion = Quaternion.Identity();
            /**
             * The scale of the device to be used when translating from device space to babylon space.
             */
            this.deviceScaleFactor = 1;
            this._deviceToWorld = Matrix.Identity();
            this._worldToDevice = Matrix.Identity();
            /**
             * References to the webVR controllers for the vrDevice.
             */
            this.controllers = [];
            /**
             * Emits an event when a controller is attached.
             */
            this.onControllersAttachedObservable = new Observable$1();
            /**
             * Emits an event when a controller's mesh has been loaded;
             */
            this.onControllerMeshLoadedObservable = new Observable$1();
            /**
             * Emits an event when the HMD's pose has been updated.
             */
            this.onPoseUpdatedFromDeviceObservable = new Observable$1();
            this._poseSet = false;
            /**
             * If the rig cameras be used as parent instead of this camera.
             */
            this.rigParenting = true;
            this._defaultHeight = undefined;
            this._setRigMode = setWebVRRigMode.bind(null, this);
            this._detachIfAttached = () => {
                const vrDisplay = this.getEngine().getVRDevice();
                if (vrDisplay && !vrDisplay.isPresenting) {
                    this.detachControl();
                }
            };
            this._workingVector = Vector3.Zero();
            this._oneVector = Vector3.One();
            this._workingMatrix = Matrix.Identity();
            this._tmpMatrix = new Matrix();
            this._cache.position = Vector3.Zero();
            if (_webVROptions.defaultHeight) {
                this._defaultHeight = _webVROptions.defaultHeight;
                this.position.y = this._defaultHeight;
            }
            this.minZ = 0.1;
            //legacy support - the compensation boolean was removed.
            if (arguments.length === 5) {
                // eslint-disable-next-line prefer-rest-params
                this._webVROptions = arguments[4];
            }
            // default webVR options
            if (this._webVROptions.trackPosition == undefined) {
                this._webVROptions.trackPosition = true;
            }
            if (this._webVROptions.controllerMeshes == undefined) {
                this._webVROptions.controllerMeshes = true;
            }
            if (this._webVROptions.defaultLightingOnControllers == undefined) {
                this._webVROptions.defaultLightingOnControllers = true;
            }
            this.rotationQuaternion = new Quaternion();
            if (this._webVROptions && this._webVROptions.positionScale) {
                this.deviceScaleFactor = this._webVROptions.positionScale;
            }
            //enable VR
            const engine = this.getEngine();
            this._onVREnabled = (success) => {
                if (success) {
                    this.initControllers();
                }
            };
            engine.onVRRequestPresentComplete.add(this._onVREnabled);
            engine.initWebVR().add((event) => {
                if (!event.vrDisplay || this._vrDevice === event.vrDisplay) {
                    return;
                }
                this._vrDevice = event.vrDisplay;
                //reset the rig parameters.
                this.setCameraRigMode(Camera.RIG_MODE_WEBVR, { parentCamera: this, vrDisplay: this._vrDevice, frameData: this._frameData, specs: this._specsVersion });
                if (this._attached) {
                    this.getEngine().enableVR(this._webVROptions);
                }
            });
            if (typeof VRFrameData !== "undefined") {
                this._frameData = new VRFrameData();
            }
            if (_webVROptions.useMultiview) {
                if (!this.getScene().getEngine().getCaps().multiview) {
                    Logger.Warn("Multiview is not supported, falling back to standard rendering");
                    this._useMultiviewToSingleView = false;
                }
                else {
                    this._useMultiviewToSingleView = true;
                    this._rigPostProcess = new VRMultiviewToSingleviewPostProcess("VRMultiviewToSingleview", this, 1.0);
                }
            }
            /**
             * The idea behind the following lines:
             * objects that have the camera as parent should actually have the rig cameras as a parent.
             * BUT, each of those cameras has a different view matrix, which means that if we set the parent to the first rig camera,
             * the second will not show it correctly.
             *
             * To solve this - each object that has the camera as parent will be added to a protected array.
             * When the rig camera renders, it will take this array and set all of those to be its children.
             * This way, the right camera will be used as a parent, and the mesh will be rendered correctly.
             * Amazing!
             */
            this.getScene().onBeforeCameraRenderObservable.add((camera) => {
                if (camera.parent === this && this.rigParenting) {
                    this._descendants = this.getDescendants(true, (n) => {
                        // don't take the cameras or the controllers!
                        const isController = this.controllers.some((controller) => {
                            return controller._mesh === n;
                        });
                        const isRigCamera = this._rigCameras.indexOf(n) !== -1;
                        return !isController && !isRigCamera;
                    });
                    this._descendants.forEach((node) => {
                        node.parent = camera;
                    });
                }
            });
            this.getScene().onAfterCameraRenderObservable.add((camera) => {
                if (camera.parent === this && this.rigParenting) {
                    this._descendants.forEach((node) => {
                        node.parent = this;
                    });
                }
            });
        }
        /**
         * Gets the device distance from the ground in meters.
         * @returns the distance in meters from the vrDevice to ground in device space. If standing matrix is not supported for the vrDevice 0 is returned.
         */
        deviceDistanceToRoomGround() {
            if (this._standingMatrix) {
                // Add standing matrix offset to get real offset from ground in room
                this._standingMatrix.getTranslationToRef(this._workingVector);
                return this._deviceRoomPosition.y + this._workingVector.y;
            }
            //If VRDisplay does not inform stage parameters and no default height is set we fallback to zero.
            return this._defaultHeight || 0;
        }
        /**
         * Enables the standing matrix when supported. This can be used to position the user's view the correct height from the ground.
         * @param callback will be called when the standing matrix is set. Callback parameter is if the standing matrix is supported.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        useStandingMatrix(callback = (bool) => { }) {
            // Use standing matrix if available
            this.getEngine()
                .initWebVRAsync()
                .then((result) => {
                if (!result.vrDisplay || !result.vrDisplay.stageParameters || !result.vrDisplay.stageParameters.sittingToStandingTransform || !this._webVROptions.trackPosition) {
                    callback(false);
                }
                else {
                    this._standingMatrix = new Matrix();
                    Matrix.FromFloat32ArrayToRefScaled(result.vrDisplay.stageParameters.sittingToStandingTransform, 0, 1, this._standingMatrix);
                    if (!this.getScene().useRightHandedSystem) {
                        if (this._standingMatrix) {
                            this._standingMatrix.toggleModelMatrixHandInPlace();
                        }
                    }
                    callback(true);
                }
            });
        }
        /**
         * Enables the standing matrix when supported. This can be used to position the user's view the correct height from the ground.
         * @returns A promise with a boolean set to if the standing matrix is supported.
         */
        useStandingMatrixAsync() {
            return new Promise((res) => {
                this.useStandingMatrix((supported) => {
                    res(supported);
                });
            });
        }
        /**
         * Disposes the camera
         */
        dispose() {
            this._detachIfAttached();
            this.getEngine().onVRRequestPresentComplete.removeCallback(this._onVREnabled);
            if (this._updateCacheWhenTrackingDisabledObserver) {
                this._scene.onBeforeRenderObservable.remove(this._updateCacheWhenTrackingDisabledObserver);
            }
            super.dispose();
        }
        /**
         * Gets a vrController by name.
         * @param name The name of the controller to retrieve
         * @returns the controller matching the name specified or null if not found
         */
        getControllerByName(name) {
            for (const gp of this.controllers) {
                if (gp.hand === name) {
                    return gp;
                }
            }
            return null;
        }
        /**
         * The controller corresponding to the users left hand.
         */
        get leftController() {
            if (!this._leftController) {
                this._leftController = this.getControllerByName("left");
            }
            return this._leftController;
        }
        /**
         * The controller corresponding to the users right hand.
         */
        get rightController() {
            if (!this._rightController) {
                this._rightController = this.getControllerByName("right");
            }
            return this._rightController;
        }
        /**
         * Casts a ray forward from the vrCamera's gaze.
         * @param length Length of the ray (default: 100)
         * @returns the ray corresponding to the gaze
         */
        getForwardRay(length = 100) {
            if (this.leftCamera) {
                // Use left eye to avoid computation to compute center on every call
                return super.getForwardRay(length, this.leftCamera.getWorldMatrix(), this.leftCamera.globalPosition); // Need the actual rendered camera
            }
            else {
                return super.getForwardRay(length);
            }
        }
        /**
         * @internal
         * Updates the camera based on device's frame data
         */
        _checkInputs() {
            if (this._vrDevice && this._vrDevice.isPresenting) {
                this._vrDevice.getFrameData(this._frameData);
                this.updateFromDevice(this._frameData.pose);
            }
            super._checkInputs();
        }
        /**
         * Updates the poseControlled values based on the input device pose.
         * @param poseData Pose coming from the device
         */
        updateFromDevice(poseData) {
            if (poseData && poseData.orientation && poseData.orientation.length === 4) {
                this.rawPose = poseData;
                this._deviceRoomRotationQuaternion.copyFromFloats(poseData.orientation[0], poseData.orientation[1], -poseData.orientation[2], -poseData.orientation[3]);
                if (this.getScene().useRightHandedSystem) {
                    this._deviceRoomRotationQuaternion.z *= -1;
                    this._deviceRoomRotationQuaternion.w *= -1;
                }
                if (this._webVROptions.trackPosition && this.rawPose.position) {
                    this._deviceRoomPosition.copyFromFloats(this.rawPose.position[0], this.rawPose.position[1], -this.rawPose.position[2]);
                    if (this.getScene().useRightHandedSystem) {
                        this._deviceRoomPosition.z *= -1;
                    }
                }
                this._poseSet = true;
            }
        }
        /**
         * WebVR's attach control will start broadcasting frames to the device.
         * Note that in certain browsers (chrome for example) this function must be called
         * within a user-interaction callback. Example:
         * <pre> scene.onPointerDown = function() { camera.attachControl(canvas); }</pre>
         *
         * @param noPreventDefault prevent the default html element operation when attaching the vrDevice
         */
        attachControl(noPreventDefault) {
            // eslint-disable-next-line prefer-rest-params
            noPreventDefault = Tools.BackCompatCameraNoPreventDefault(arguments);
            super.attachControl(noPreventDefault);
            this._attached = true;
            noPreventDefault = Camera.ForceAttachControlToAlwaysPreventDefault ? false : noPreventDefault;
            if (this._vrDevice) {
                this.getEngine().enableVR(this._webVROptions);
            }
            const hostWindow = this._scene.getEngine().getHostWindow();
            if (hostWindow) {
                hostWindow.addEventListener("vrdisplaypresentchange", this._detachIfAttached);
            }
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            this.getScene().gamepadManager.onGamepadConnectedObservable.remove(this._onGamepadConnectedObserver);
            this.getScene().gamepadManager.onGamepadDisconnectedObservable.remove(this._onGamepadDisconnectedObserver);
            super.detachControl();
            this._attached = false;
            this.getEngine().disableVR();
            window.removeEventListener("vrdisplaypresentchange", this._detachIfAttached);
        }
        /**
         * @returns the name of this class
         */
        getClassName() {
            return "WebVRFreeCamera";
        }
        /**
         * Calls resetPose on the vrDisplay
         * See: https://developer.mozilla.org/en-US/docs/Web/API/VRDisplay/resetPose
         */
        resetToCurrentRotation() {
            //uses the vrDisplay's "resetPose()".
            //pitch and roll won't be affected.
            this._vrDevice.resetPose();
        }
        /**
         * @internal
         * Updates the rig cameras (left and right eye)
         */
        _updateRigCameras() {
            const camLeft = this._rigCameras[0];
            const camRight = this._rigCameras[1];
            camLeft.rotationQuaternion.copyFrom(this._deviceRoomRotationQuaternion);
            camRight.rotationQuaternion.copyFrom(this._deviceRoomRotationQuaternion);
            camLeft.position.copyFrom(this._deviceRoomPosition);
            camRight.position.copyFrom(this._deviceRoomPosition);
        }
        // Remove translation from 6dof headset if trackposition is set to false
        _correctPositionIfNotTrackPosition(matrix, isViewMatrix = false) {
            if (this.rawPose && this.rawPose.position && !this._webVROptions.trackPosition) {
                Matrix.TranslationToRef(this.rawPose.position[0], this.rawPose.position[1], -this.rawPose.position[2], this._tmpMatrix);
                if (!isViewMatrix) {
                    this._tmpMatrix.invert();
                }
                this._tmpMatrix.multiplyToRef(matrix, matrix);
            }
        }
        /**
         * @internal
         * Updates the cached values of the camera
         * @param ignoreParentClass ignores updating the parent class's cache (default: false)
         */
        _updateCache(ignoreParentClass) {
            if (!this.rotationQuaternion.equals(this._cache.rotationQuaternion) || !this.position.equals(this._cache.position)) {
                // Update to ensure devicePosition is up to date with most recent _deviceRoomPosition
                if (!this._updateCacheCalled) {
                    // make sure it is only called once per loop. this.update() might cause an infinite loop.
                    this._updateCacheCalled = true;
                    this.update();
                }
                // Set working vector to the device position in room space rotated by the new rotation
                this.rotationQuaternion.toRotationMatrix(this._workingMatrix);
                Vector3.TransformCoordinatesToRef(this._deviceRoomPosition, this._workingMatrix, this._workingVector);
                // Subtract this vector from the current device position in world to get the translation for the device world matrix
                this.devicePosition.subtractToRef(this._workingVector, this._workingVector);
                Matrix.ComposeToRef(this._oneVector, this.rotationQuaternion, this._workingVector, this._deviceToWorld);
                // Add translation from anchor position
                this._deviceToWorld.getTranslationToRef(this._workingVector);
                this._workingVector.addInPlace(this.position);
                this._workingVector.subtractInPlace(this._cache.position);
                this._deviceToWorld.setTranslation(this._workingVector);
                // Set an inverted matrix to be used when updating the camera
                this._deviceToWorld.invertToRef(this._worldToDevice);
                // Update the gamepad to ensure the mesh is updated on the same frame as camera
                this.controllers.forEach((controller) => {
                    controller._deviceToWorld.copyFrom(this._deviceToWorld);
                    this._correctPositionIfNotTrackPosition(controller._deviceToWorld);
                    controller.update();
                });
            }
            if (!ignoreParentClass) {
                super._updateCache();
            }
            this._updateCacheCalled = false;
        }
        /**
         * @internal
         * Get current device position in babylon world
         */
        _computeDevicePosition() {
            Vector3.TransformCoordinatesToRef(this._deviceRoomPosition, this._deviceToWorld, this.devicePosition);
        }
        /**
         * Updates the current device position and rotation in the babylon world
         */
        update() {
            this._computeDevicePosition();
            // Get current device rotation in babylon world
            Matrix.FromQuaternionToRef(this._deviceRoomRotationQuaternion, this._workingMatrix);
            this._workingMatrix.multiplyToRef(this._deviceToWorld, this._workingMatrix);
            Quaternion.FromRotationMatrixToRef(this._workingMatrix, this.deviceRotationQuaternion);
            if (this._poseSet) {
                this.onPoseUpdatedFromDeviceObservable.notifyObservers(null);
            }
            super.update();
        }
        /**
         * @internal
         * Gets the view matrix of this camera (Always set to identity as left and right eye cameras contain the actual view matrix)
         * @returns an identity matrix
         */
        _getViewMatrix() {
            return Matrix.Identity();
        }
        /**
         * This function is called by the two RIG cameras.
         * 'this' is the left or right camera (and NOT (!!!) the WebVRFreeCamera instance)
         * @internal
         */
        _getWebVRViewMatrix() {
            // Update the parent camera prior to using a child camera to avoid desynchronization
            const parentCamera = this._cameraRigParams["parentCamera"];
            parentCamera._updateCache();
            //WebVR 1.1
            const viewArray = this._cameraRigParams["left"] ? this._cameraRigParams["frameData"].leftViewMatrix : this._cameraRigParams["frameData"].rightViewMatrix;
            Matrix.FromArrayToRef(viewArray, 0, this._webvrViewMatrix);
            if (!this.getScene().useRightHandedSystem) {
                this._webvrViewMatrix.toggleModelMatrixHandInPlace();
            }
            // update the camera rotation matrix
            this._webvrViewMatrix.getRotationMatrixToRef(this._cameraRotationMatrix);
            Vector3.TransformCoordinatesToRef(this._referencePoint, this._cameraRotationMatrix, this._transformedReferencePoint);
            // Computing target and final matrix
            this.position.addToRef(this._transformedReferencePoint, this._currentTarget);
            // should the view matrix be updated with scale and position offset?
            if (parentCamera.deviceScaleFactor !== 1) {
                this._webvrViewMatrix.invert();
                // scale the position, if set
                if (parentCamera.deviceScaleFactor) {
                    this._webvrViewMatrix.multiplyAtIndex(12, parentCamera.deviceScaleFactor);
                    this._webvrViewMatrix.multiplyAtIndex(13, parentCamera.deviceScaleFactor);
                    this._webvrViewMatrix.multiplyAtIndex(14, parentCamera.deviceScaleFactor);
                }
                this._webvrViewMatrix.invert();
            }
            // Remove translation from 6dof headset if trackposition is set to false
            parentCamera._correctPositionIfNotTrackPosition(this._webvrViewMatrix, true);
            parentCamera._worldToDevice.multiplyToRef(this._webvrViewMatrix, this._webvrViewMatrix);
            // Compute global position
            this._workingMatrix = this._workingMatrix || Matrix.Identity();
            this._webvrViewMatrix.invertToRef(this._workingMatrix);
            this._workingMatrix.multiplyToRef(parentCamera.getWorldMatrix(), this._workingMatrix);
            this._workingMatrix.getTranslationToRef(this._globalPosition);
            this._markSyncedWithParent();
            return this._webvrViewMatrix;
        }
        /** @internal */
        _getWebVRProjectionMatrix() {
            const parentCamera = this.parent;
            parentCamera._vrDevice.depthNear = parentCamera.minZ;
            parentCamera._vrDevice.depthFar = parentCamera.maxZ;
            const projectionArray = this._cameraRigParams["left"] ? this._cameraRigParams["frameData"].leftProjectionMatrix : this._cameraRigParams["frameData"].rightProjectionMatrix;
            Matrix.FromArrayToRef(projectionArray, 0, this._projectionMatrix);
            //babylon compatible matrix
            if (!this.getScene().useRightHandedSystem) {
                this._projectionMatrix.toggleProjectionMatrixHandInPlace();
            }
            return this._projectionMatrix;
        }
        /**
         * Initializes the controllers and their meshes
         */
        initControllers() {
            this.controllers.length = 0;
            const manager = this.getScene().gamepadManager;
            this._onGamepadDisconnectedObserver = manager.onGamepadDisconnectedObservable.add((gamepad) => {
                if (gamepad.type === Gamepad.POSE_ENABLED) {
                    const webVrController = gamepad;
                    if (webVrController.defaultModel) {
                        webVrController.defaultModel.setEnabled(false);
                    }
                    if (webVrController.hand === "right") {
                        this._rightController = null;
                    }
                    if (webVrController.hand === "left") {
                        this._leftController = null;
                    }
                    const controllerIndex = this.controllers.indexOf(webVrController);
                    if (controllerIndex !== -1) {
                        this.controllers.splice(controllerIndex, 1);
                    }
                }
            });
            this._onGamepadConnectedObserver = manager.onGamepadConnectedObservable.add((gamepad) => {
                if (gamepad.type === Gamepad.POSE_ENABLED) {
                    const webVrController = gamepad;
                    if (!this._webVROptions.trackPosition) {
                        webVrController._disableTrackPosition(new Vector3(webVrController.hand == "left" ? -0.15 : 0.15, -0.5, 0.25));
                        // Cache must be updated before rendering controllers to avoid them being one frame behind
                        if (!this._updateCacheWhenTrackingDisabledObserver) {
                            this._updateCacheWhenTrackingDisabledObserver = this._scene.onBeforeRenderObservable.add(() => {
                                this._updateCache();
                            });
                        }
                    }
                    webVrController.deviceScaleFactor = this.deviceScaleFactor;
                    webVrController._deviceToWorld.copyFrom(this._deviceToWorld);
                    this._correctPositionIfNotTrackPosition(webVrController._deviceToWorld);
                    if (this._webVROptions.controllerMeshes) {
                        if (webVrController.defaultModel) {
                            webVrController.defaultModel.setEnabled(true);
                        }
                        else {
                            // Load the meshes
                            webVrController.initControllerMesh(this.getScene(), (loadedMesh) => {
                                loadedMesh.scaling.scaleInPlace(this.deviceScaleFactor);
                                this.onControllerMeshLoadedObservable.notifyObservers(webVrController);
                                if (this._webVROptions.defaultLightingOnControllers) {
                                    if (!this._lightOnControllers) {
                                        this._lightOnControllers = new HemisphericLight("vrControllersLight", new Vector3(0, 1, 0), this.getScene());
                                    }
                                    const activateLightOnSubMeshes = function (mesh, light) {
                                        const children = mesh.getChildren();
                                        if (children && children.length !== 0) {
                                            children.forEach((mesh) => {
                                                light.includedOnlyMeshes.push(mesh);
                                                activateLightOnSubMeshes(mesh, light);
                                            });
                                        }
                                    };
                                    this._lightOnControllers.includedOnlyMeshes.push(loadedMesh);
                                    activateLightOnSubMeshes(loadedMesh, this._lightOnControllers);
                                }
                            });
                        }
                    }
                    webVrController.attachToPoseControlledCamera(this);
                    // since this is async - sanity check. Is the controller already stored?
                    if (this.controllers.indexOf(webVrController) === -1) {
                        //add to the controllers array
                        this.controllers.push(webVrController);
                        // Forced to add some control code for Vive as it doesn't always fill properly the "hand" property
                        // Sometimes, both controllers are set correctly (left and right), sometimes none, sometimes only one of them...
                        // So we're overriding setting left & right manually to be sure
                        let firstViveWandDetected = false;
                        for (let i = 0; i < this.controllers.length; i++) {
                            if (this.controllers[i].controllerType === PoseEnabledControllerType.VIVE) {
                                if (!firstViveWandDetected) {
                                    firstViveWandDetected = true;
                                    this.controllers[i].hand = "left";
                                }
                                else {
                                    this.controllers[i].hand = "right";
                                }
                            }
                        }
                        //did we find enough controllers? Great! let the developer know.
                        if (this.controllers.length >= 2) {
                            this.onControllersAttachedObservable.notifyObservers(this.controllers);
                        }
                    }
                }
            });
        }
    }

    /**
     * Defines the WebVRController object that represents controllers tracked in 3D space
     * @deprecated Use WebXR instead
     */
    class WebVRController extends PoseEnabledController {
        /**
         * Fired when a controller button's state has changed
         * @param callback the callback containing the button that was modified
         */
        onButtonStateChange(callback) {
            this._onButtonStateChange = callback;
        }
        /**
         * The default controller model for the controller
         */
        get defaultModel() {
            return this._defaultModel;
        }
        /**
         * Creates a new WebVRController from a gamepad
         * @param vrGamepad the gamepad that the WebVRController should be created from
         */
        constructor(vrGamepad) {
            super(vrGamepad);
            // Observables
            /**
             * Fired when the trigger state has changed
             */
            this.onTriggerStateChangedObservable = new Observable$1();
            /**
             * Fired when the main button state has changed
             */
            this.onMainButtonStateChangedObservable = new Observable$1();
            /**
             * Fired when the secondary button state has changed
             */
            this.onSecondaryButtonStateChangedObservable = new Observable$1();
            /**
             * Fired when the pad state has changed
             */
            this.onPadStateChangedObservable = new Observable$1();
            /**
             * Fired when controllers stick values have changed
             */
            this.onPadValuesChangedObservable = new Observable$1();
            /**
             * X and Y axis corresponding to the controllers joystick
             */
            this.pad = { x: 0, y: 0 };
            // avoid GC, store state in a tmp object
            this._changes = {
                pressChanged: false,
                touchChanged: false,
                valueChanged: false,
                changed: false,
            };
            this._buttons = new Array(vrGamepad.buttons.length);
            this.hand = vrGamepad.hand;
        }
        /**
         * Updates the state of the controller and mesh based on the current position and rotation of the controller
         */
        update() {
            super.update();
            for (let index = 0; index < this._buttons.length; index++) {
                this._setButtonValue(this.browserGamepad.buttons[index], this._buttons[index], index);
            }
            if (this.leftStick.x !== this.pad.x || this.leftStick.y !== this.pad.y) {
                this.pad.x = this.leftStick.x;
                this.pad.y = this.leftStick.y;
                this.onPadValuesChangedObservable.notifyObservers(this.pad);
            }
        }
        _setButtonValue(newState, currentState, buttonIndex) {
            if (!newState) {
                newState = {
                    pressed: false,
                    touched: false,
                    value: 0,
                };
            }
            if (!currentState) {
                this._buttons[buttonIndex] = {
                    pressed: newState.pressed,
                    touched: newState.touched,
                    value: newState.value,
                };
                return;
            }
            this._checkChanges(newState, currentState);
            if (this._changes.changed) {
                this._onButtonStateChange && this._onButtonStateChange(this.index, buttonIndex, newState);
                this._handleButtonChange(buttonIndex, newState, this._changes);
            }
            this._buttons[buttonIndex].pressed = newState.pressed;
            this._buttons[buttonIndex].touched = newState.touched;
            // oculus triggers are never 0, thou not touched.
            this._buttons[buttonIndex].value = newState.value < 0.00000001 ? 0 : newState.value;
        }
        _checkChanges(newState, currentState) {
            this._changes.pressChanged = newState.pressed !== currentState.pressed;
            this._changes.touchChanged = newState.touched !== currentState.touched;
            this._changes.valueChanged = newState.value !== currentState.value;
            this._changes.changed = this._changes.pressChanged || this._changes.touchChanged || this._changes.valueChanged;
            return this._changes;
        }
        /**
         * Disposes of th webVRController
         */
        dispose() {
            super.dispose();
            this._defaultModel = null;
            this.onTriggerStateChangedObservable.clear();
            this.onMainButtonStateChangedObservable.clear();
            this.onSecondaryButtonStateChangedObservable.clear();
            this.onPadStateChangedObservable.clear();
            this.onPadValuesChangedObservable.clear();
        }
    }

    /**
     * Defines supported buttons for XBox360 compatible gamepads
     */
    var Xbox360Button;
    (function (Xbox360Button) {
        /** A */
        Xbox360Button[Xbox360Button["A"] = 0] = "A";
        /** B */
        Xbox360Button[Xbox360Button["B"] = 1] = "B";
        /** X */
        Xbox360Button[Xbox360Button["X"] = 2] = "X";
        /** Y */
        Xbox360Button[Xbox360Button["Y"] = 3] = "Y";
        /** Left button */
        Xbox360Button[Xbox360Button["LB"] = 4] = "LB";
        /** Right button */
        Xbox360Button[Xbox360Button["RB"] = 5] = "RB";
        /** Back */
        Xbox360Button[Xbox360Button["Back"] = 8] = "Back";
        /** Start */
        Xbox360Button[Xbox360Button["Start"] = 9] = "Start";
        /** Left stick */
        Xbox360Button[Xbox360Button["LeftStick"] = 10] = "LeftStick";
        /** Right stick */
        Xbox360Button[Xbox360Button["RightStick"] = 11] = "RightStick";
    })(Xbox360Button || (Xbox360Button = {}));
    /** Defines values for XBox360 DPad  */
    var Xbox360Dpad;
    (function (Xbox360Dpad) {
        /** Up */
        Xbox360Dpad[Xbox360Dpad["Up"] = 12] = "Up";
        /** Down */
        Xbox360Dpad[Xbox360Dpad["Down"] = 13] = "Down";
        /** Left */
        Xbox360Dpad[Xbox360Dpad["Left"] = 14] = "Left";
        /** Right */
        Xbox360Dpad[Xbox360Dpad["Right"] = 15] = "Right";
    })(Xbox360Dpad || (Xbox360Dpad = {}));
    /**
     * Defines a XBox360 gamepad
     */
    class Xbox360Pad extends Gamepad {
        /**
         * Creates a new XBox360 gamepad object
         * @param id defines the id of this gamepad
         * @param index defines its index
         * @param gamepad defines the internal HTML gamepad object
         * @param xboxOne defines if it is a XBox One gamepad
         */
        constructor(id, index, gamepad, xboxOne = false) {
            super(id, index, gamepad, 0, 1, 2, 3);
            this._leftTrigger = 0;
            this._rightTrigger = 0;
            /** Observable raised when a button is pressed */
            this.onButtonDownObservable = new Observable$1();
            /** Observable raised when a button is released */
            this.onButtonUpObservable = new Observable$1();
            /** Observable raised when a pad is pressed */
            this.onPadDownObservable = new Observable$1();
            /** Observable raised when a pad is released */
            this.onPadUpObservable = new Observable$1();
            this._buttonA = 0;
            this._buttonB = 0;
            this._buttonX = 0;
            this._buttonY = 0;
            this._buttonBack = 0;
            this._buttonStart = 0;
            this._buttonLB = 0;
            this._buttonRB = 0;
            this._buttonLeftStick = 0;
            this._buttonRightStick = 0;
            this._dPadUp = 0;
            this._dPadDown = 0;
            this._dPadLeft = 0;
            this._dPadRight = 0;
            this._isXboxOnePad = false;
            this.type = Gamepad.XBOX;
            this._isXboxOnePad = xboxOne;
        }
        /**
         * Defines the callback to call when left trigger is pressed
         * @param callback defines the callback to use
         */
        onlefttriggerchanged(callback) {
            this._onlefttriggerchanged = callback;
        }
        /**
         * Defines the callback to call when right trigger is pressed
         * @param callback defines the callback to use
         */
        onrighttriggerchanged(callback) {
            this._onrighttriggerchanged = callback;
        }
        /**
         * Gets the left trigger value
         */
        get leftTrigger() {
            return this._leftTrigger;
        }
        /**
         * Sets the left trigger value
         */
        set leftTrigger(newValue) {
            if (this._onlefttriggerchanged && this._leftTrigger !== newValue) {
                this._onlefttriggerchanged(newValue);
            }
            this._leftTrigger = newValue;
        }
        /**
         * Gets the right trigger value
         */
        get rightTrigger() {
            return this._rightTrigger;
        }
        /**
         * Sets the right trigger value
         */
        set rightTrigger(newValue) {
            if (this._onrighttriggerchanged && this._rightTrigger !== newValue) {
                this._onrighttriggerchanged(newValue);
            }
            this._rightTrigger = newValue;
        }
        /**
         * Defines the callback to call when a button is pressed
         * @param callback defines the callback to use
         */
        onbuttondown(callback) {
            this._onbuttondown = callback;
        }
        /**
         * Defines the callback to call when a button is released
         * @param callback defines the callback to use
         */
        onbuttonup(callback) {
            this._onbuttonup = callback;
        }
        /**
         * Defines the callback to call when a pad is pressed
         * @param callback defines the callback to use
         */
        ondpaddown(callback) {
            this._ondpaddown = callback;
        }
        /**
         * Defines the callback to call when a pad is released
         * @param callback defines the callback to use
         */
        ondpadup(callback) {
            this._ondpadup = callback;
        }
        _setButtonValue(newValue, currentValue, buttonType) {
            if (newValue !== currentValue) {
                if (newValue === 1) {
                    if (this._onbuttondown) {
                        this._onbuttondown(buttonType);
                    }
                    this.onButtonDownObservable.notifyObservers(buttonType);
                }
                if (newValue === 0) {
                    if (this._onbuttonup) {
                        this._onbuttonup(buttonType);
                    }
                    this.onButtonUpObservable.notifyObservers(buttonType);
                }
            }
            return newValue;
        }
        _setDPadValue(newValue, currentValue, buttonType) {
            if (newValue !== currentValue) {
                if (newValue === 1) {
                    if (this._ondpaddown) {
                        this._ondpaddown(buttonType);
                    }
                    this.onPadDownObservable.notifyObservers(buttonType);
                }
                if (newValue === 0) {
                    if (this._ondpadup) {
                        this._ondpadup(buttonType);
                    }
                    this.onPadUpObservable.notifyObservers(buttonType);
                }
            }
            return newValue;
        }
        /**
         * Gets the value of the `A` button
         */
        get buttonA() {
            return this._buttonA;
        }
        /**
         * Sets the value of the `A` button
         */
        set buttonA(value) {
            this._buttonA = this._setButtonValue(value, this._buttonA, Xbox360Button.A);
        }
        /**
         * Gets the value of the `B` button
         */
        get buttonB() {
            return this._buttonB;
        }
        /**
         * Sets the value of the `B` button
         */
        set buttonB(value) {
            this._buttonB = this._setButtonValue(value, this._buttonB, Xbox360Button.B);
        }
        /**
         * Gets the value of the `X` button
         */
        get buttonX() {
            return this._buttonX;
        }
        /**
         * Sets the value of the `X` button
         */
        set buttonX(value) {
            this._buttonX = this._setButtonValue(value, this._buttonX, Xbox360Button.X);
        }
        /**
         * Gets the value of the `Y` button
         */
        get buttonY() {
            return this._buttonY;
        }
        /**
         * Sets the value of the `Y` button
         */
        set buttonY(value) {
            this._buttonY = this._setButtonValue(value, this._buttonY, Xbox360Button.Y);
        }
        /**
         * Gets the value of the `Start` button
         */
        get buttonStart() {
            return this._buttonStart;
        }
        /**
         * Sets the value of the `Start` button
         */
        set buttonStart(value) {
            this._buttonStart = this._setButtonValue(value, this._buttonStart, Xbox360Button.Start);
        }
        /**
         * Gets the value of the `Back` button
         */
        get buttonBack() {
            return this._buttonBack;
        }
        /**
         * Sets the value of the `Back` button
         */
        set buttonBack(value) {
            this._buttonBack = this._setButtonValue(value, this._buttonBack, Xbox360Button.Back);
        }
        /**
         * Gets the value of the `Left` button
         */
        get buttonLB() {
            return this._buttonLB;
        }
        /**
         * Sets the value of the `Left` button
         */
        set buttonLB(value) {
            this._buttonLB = this._setButtonValue(value, this._buttonLB, Xbox360Button.LB);
        }
        /**
         * Gets the value of the `Right` button
         */
        get buttonRB() {
            return this._buttonRB;
        }
        /**
         * Sets the value of the `Right` button
         */
        set buttonRB(value) {
            this._buttonRB = this._setButtonValue(value, this._buttonRB, Xbox360Button.RB);
        }
        /**
         * Gets the value of the Left joystick
         */
        get buttonLeftStick() {
            return this._buttonLeftStick;
        }
        /**
         * Sets the value of the Left joystick
         */
        set buttonLeftStick(value) {
            this._buttonLeftStick = this._setButtonValue(value, this._buttonLeftStick, Xbox360Button.LeftStick);
        }
        /**
         * Gets the value of the Right joystick
         */
        get buttonRightStick() {
            return this._buttonRightStick;
        }
        /**
         * Sets the value of the Right joystick
         */
        set buttonRightStick(value) {
            this._buttonRightStick = this._setButtonValue(value, this._buttonRightStick, Xbox360Button.RightStick);
        }
        /**
         * Gets the value of D-pad up
         */
        get dPadUp() {
            return this._dPadUp;
        }
        /**
         * Sets the value of D-pad up
         */
        set dPadUp(value) {
            this._dPadUp = this._setDPadValue(value, this._dPadUp, Xbox360Dpad.Up);
        }
        /**
         * Gets the value of D-pad down
         */
        get dPadDown() {
            return this._dPadDown;
        }
        /**
         * Sets the value of D-pad down
         */
        set dPadDown(value) {
            this._dPadDown = this._setDPadValue(value, this._dPadDown, Xbox360Dpad.Down);
        }
        /**
         * Gets the value of D-pad left
         */
        get dPadLeft() {
            return this._dPadLeft;
        }
        /**
         * Sets the value of D-pad left
         */
        set dPadLeft(value) {
            this._dPadLeft = this._setDPadValue(value, this._dPadLeft, Xbox360Dpad.Left);
        }
        /**
         * Gets the value of D-pad right
         */
        get dPadRight() {
            return this._dPadRight;
        }
        /**
         * Sets the value of D-pad right
         */
        set dPadRight(value) {
            this._dPadRight = this._setDPadValue(value, this._dPadRight, Xbox360Dpad.Right);
        }
        /**
         * Force the gamepad to synchronize with device values
         */
        update() {
            super.update();
            if (this._isXboxOnePad) {
                this.buttonA = this.browserGamepad.buttons[0].value;
                this.buttonB = this.browserGamepad.buttons[1].value;
                this.buttonX = this.browserGamepad.buttons[2].value;
                this.buttonY = this.browserGamepad.buttons[3].value;
                this.buttonLB = this.browserGamepad.buttons[4].value;
                this.buttonRB = this.browserGamepad.buttons[5].value;
                this.leftTrigger = this.browserGamepad.buttons[6].value;
                this.rightTrigger = this.browserGamepad.buttons[7].value;
                this.buttonBack = this.browserGamepad.buttons[8].value;
                this.buttonStart = this.browserGamepad.buttons[9].value;
                this.buttonLeftStick = this.browserGamepad.buttons[10].value;
                this.buttonRightStick = this.browserGamepad.buttons[11].value;
                this.dPadUp = this.browserGamepad.buttons[12].value;
                this.dPadDown = this.browserGamepad.buttons[13].value;
                this.dPadLeft = this.browserGamepad.buttons[14].value;
                this.dPadRight = this.browserGamepad.buttons[15].value;
            }
            else {
                this.buttonA = this.browserGamepad.buttons[0].value;
                this.buttonB = this.browserGamepad.buttons[1].value;
                this.buttonX = this.browserGamepad.buttons[2].value;
                this.buttonY = this.browserGamepad.buttons[3].value;
                this.buttonLB = this.browserGamepad.buttons[4].value;
                this.buttonRB = this.browserGamepad.buttons[5].value;
                this.leftTrigger = this.browserGamepad.buttons[6].value;
                this.rightTrigger = this.browserGamepad.buttons[7].value;
                this.buttonBack = this.browserGamepad.buttons[8].value;
                this.buttonStart = this.browserGamepad.buttons[9].value;
                this.buttonLeftStick = this.browserGamepad.buttons[10].value;
                this.buttonRightStick = this.browserGamepad.buttons[11].value;
                this.dPadUp = this.browserGamepad.buttons[12].value;
                this.dPadDown = this.browserGamepad.buttons[13].value;
                this.dPadLeft = this.browserGamepad.buttons[14].value;
                this.dPadRight = this.browserGamepad.buttons[15].value;
            }
        }
        /**
         * Disposes the gamepad
         */
        dispose() {
            super.dispose();
            this.onButtonDownObservable.clear();
            this.onButtonUpObservable.clear();
            this.onPadDownObservable.clear();
            this.onPadUpObservable.clear();
        }
    }

    ThinEngine.prototype.createDynamicTexture = function (width, height, generateMipMaps, samplingMode) {
        const texture = new InternalTexture(this, InternalTextureSource.Dynamic);
        texture.baseWidth = width;
        texture.baseHeight = height;
        if (generateMipMaps) {
            width = this.needPOTTextures ? ThinEngine.GetExponentOfTwo(width, this._caps.maxTextureSize) : width;
            height = this.needPOTTextures ? ThinEngine.GetExponentOfTwo(height, this._caps.maxTextureSize) : height;
        }
        //  this.resetTextureCache();
        texture.width = width;
        texture.height = height;
        texture.isReady = false;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        this.updateTextureSamplingMode(samplingMode, texture);
        this._internalTexturesCache.push(texture);
        return texture;
    };
    ThinEngine.prototype.updateDynamicTexture = function (texture, source, invertY, premulAlpha = false, format, forceBindTexture = false, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    allowGPUOptimization = false) {
        if (!texture) {
            return;
        }
        const gl = this._gl;
        const target = gl.TEXTURE_2D;
        const wasPreviouslyBound = this._bindTextureDirectly(target, texture, true, forceBindTexture);
        this._unpackFlipY(invertY === undefined ? texture.invertY : invertY);
        if (premulAlpha) {
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 1);
        }
        const textureType = this._getWebGLTextureType(texture.type);
        const glformat = this._getInternalFormat(format ? format : texture.format);
        const internalFormat = this._getRGBABufferInternalSizedFormat(texture.type, glformat);
        gl.texImage2D(target, 0, internalFormat, glformat, textureType, source);
        if (texture.generateMipMaps) {
            gl.generateMipmap(target);
        }
        if (!wasPreviouslyBound) {
            this._bindTextureDirectly(target, null);
        }
        if (premulAlpha) {
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
        }
        texture.isReady = true;
    };

    /**
     * A class extending Texture allowing drawing on a texture
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/dynamicTexture
     */
    class DynamicTexture extends Texture {
        /**
         * Creates a DynamicTexture
         * @param name defines the name of the texture
         * @param options provides 3 alternatives for width and height of texture, a canvas, object with width and height properties, number for both width and height
         * @param scene defines the scene where you want the texture
         * @param generateMipMaps defines the use of MinMaps or not (default is false)
         * @param samplingMode defines the sampling mode to use (default is Texture.TRILINEAR_SAMPLINGMODE)
         * @param format defines the texture format to use (default is Engine.TEXTUREFORMAT_RGBA)
         * @param invertY defines if the texture needs to be inverted on the y axis during loading
         */
        constructor(name, options, scene = null, generateMipMaps = false, samplingMode = 3, format = 5, invertY) {
            super(null, scene, !generateMipMaps, invertY, samplingMode, undefined, undefined, undefined, undefined, format);
            this.name = name;
            this.wrapU = Texture.CLAMP_ADDRESSMODE;
            this.wrapV = Texture.CLAMP_ADDRESSMODE;
            this._generateMipMaps = generateMipMaps;
            const engine = this._getEngine();
            if (!engine) {
                return;
            }
            if (options.getContext) {
                this._canvas = options;
                this._texture = engine.createDynamicTexture(options.width, options.height, generateMipMaps, samplingMode);
            }
            else {
                this._canvas = engine.createCanvas(1, 1);
                if (options.width || options.width === 0) {
                    this._texture = engine.createDynamicTexture(options.width, options.height, generateMipMaps, samplingMode);
                }
                else {
                    this._texture = engine.createDynamicTexture(options, options, generateMipMaps, samplingMode);
                }
            }
            const textureSize = this.getSize();
            if (this._canvas.width !== textureSize.width) {
                this._canvas.width = textureSize.width;
            }
            if (this._canvas.height !== textureSize.height) {
                this._canvas.height = textureSize.height;
            }
            this._context = this._canvas.getContext("2d");
        }
        /**
         * Get the current class name of the texture useful for serialization or dynamic coding.
         * @returns "DynamicTexture"
         */
        getClassName() {
            return "DynamicTexture";
        }
        /**
         * Gets the current state of canRescale
         */
        get canRescale() {
            return true;
        }
        _recreate(textureSize) {
            this._canvas.width = textureSize.width;
            this._canvas.height = textureSize.height;
            this.releaseInternalTexture();
            this._texture = this._getEngine().createDynamicTexture(textureSize.width, textureSize.height, this._generateMipMaps, this.samplingMode);
        }
        /**
         * Scales the texture
         * @param ratio the scale factor to apply to both width and height
         */
        scale(ratio) {
            const textureSize = this.getSize();
            textureSize.width *= ratio;
            textureSize.height *= ratio;
            this._recreate(textureSize);
        }
        /**
         * Resizes the texture
         * @param width the new width
         * @param height the new height
         */
        scaleTo(width, height) {
            const textureSize = this.getSize();
            textureSize.width = width;
            textureSize.height = height;
            this._recreate(textureSize);
        }
        /**
         * Gets the context of the canvas used by the texture
         * @returns the canvas context of the dynamic texture
         */
        getContext() {
            return this._context;
        }
        /**
         * Clears the texture
         */
        clear() {
            const size = this.getSize();
            this._context.fillRect(0, 0, size.width, size.height);
        }
        /**
         * Updates the texture
         * @param invertY defines the direction for the Y axis (default is true - y increases downwards)
         * @param premulAlpha defines if alpha is stored as premultiplied (default is false)
         * @param allowGPUOptimization true to allow some specific GPU optimizations (subject to engine feature "allowGPUOptimizationsForGUI" being true)
         */
        update(invertY, premulAlpha = false, allowGPUOptimization = false) {
            this._getEngine().updateDynamicTexture(this._texture, this._canvas, invertY === undefined ? true : invertY, premulAlpha, this._format || undefined, undefined, allowGPUOptimization);
        }
        /**
         * Draws text onto the texture
         * @param text defines the text to be drawn
         * @param x defines the placement of the text from the left
         * @param y defines the placement of the text from the top when invertY is true and from the bottom when false
         * @param font defines the font to be used with font-style, font-size, font-name
         * @param color defines the color used for the text
         * @param clearColor defines the color for the canvas, use null to not overwrite canvas
         * @param invertY defines the direction for the Y axis (default is true - y increases downwards)
         * @param update defines whether texture is immediately update (default is true)
         */
        drawText(text, x, y, font, color, clearColor, invertY, update = true) {
            const size = this.getSize();
            if (clearColor) {
                this._context.fillStyle = clearColor;
                this._context.fillRect(0, 0, size.width, size.height);
            }
            this._context.font = font;
            if (x === null || x === undefined) {
                const textSize = this._context.measureText(text);
                x = (size.width - textSize.width) / 2;
            }
            if (y === null || y === undefined) {
                const fontSize = parseInt(font.replace(/\D/g, ""));
                y = size.height / 2 + fontSize / 3.65;
            }
            this._context.fillStyle = color || "";
            this._context.fillText(text, x, y);
            if (update) {
                this.update(invertY);
            }
        }
        /**
         * Clones the texture
         * @returns the clone of the texture.
         */
        clone() {
            const scene = this.getScene();
            if (!scene) {
                return this;
            }
            const textureSize = this.getSize();
            const newTexture = new DynamicTexture(this.name, textureSize, scene, this._generateMipMaps);
            // Base texture
            newTexture.hasAlpha = this.hasAlpha;
            newTexture.level = this.level;
            // Dynamic Texture
            newTexture.wrapU = this.wrapU;
            newTexture.wrapV = this.wrapV;
            return newTexture;
        }
        /**
         * Serializes the dynamic texture.  The scene should be ready before the dynamic texture is serialized
         * @returns a serialized dynamic texture object
         */
        serialize() {
            const scene = this.getScene();
            if (scene && !scene.isReady()) {
                Logger.Warn("The scene must be ready before serializing the dynamic texture");
            }
            const serializationObject = super.serialize();
            if (DynamicTexture._IsCanvasElement(this._canvas)) {
                serializationObject.base64String = this._canvas.toDataURL();
            }
            serializationObject.invertY = this._invertY;
            serializationObject.samplingMode = this.samplingMode;
            return serializationObject;
        }
        static _IsCanvasElement(canvas) {
            return canvas.toDataURL !== undefined;
        }
        /** @internal */
        _rebuild() {
            this.update();
        }
    }

    // Do not edit.
    const name$1V = "imageProcessingPixelShader";
    const shader$1V = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<imageProcessingDeclaration>
#include<helperFunctions>
#include<imageProcessingFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 result=texture2D(textureSampler,vUV);
#ifdef IMAGEPROCESSING
#ifndef FROMLINEARSPACE
result.rgb=toLinearSpace(result.rgb);
#endif
result=applyImageProcessing(result);
#else
#ifdef FROMLINEARSPACE
result=applyImageProcessing(result);
#endif
#endif
gl_FragColor=result;}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1V] = shader$1V;

    /**
     * ImageProcessingPostProcess
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#imageprocessing
     */
    class ImageProcessingPostProcess extends PostProcess {
        /**
         * Gets the image processing configuration used either in this material.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Sets the Default image processing configuration used either in the this material.
         *
         * If sets to null, the scene one is in use.
         */
        set imageProcessingConfiguration(value) {
            // We are almost sure it is applied by post process as
            // We are in the post process :-)
            value.applyByPostProcess = true;
            this._attachImageProcessingConfiguration(value);
        }
        /**
         * Attaches a new image processing configuration to the PBR Material.
         * @param configuration
         * @param doNotBuild
         */
        _attachImageProcessingConfiguration(configuration, doNotBuild = false) {
            if (configuration === this._imageProcessingConfiguration) {
                return;
            }
            // Detaches observer.
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            // Pick the scene configuration if needed.
            if (!configuration) {
                let scene = null;
                const engine = this.getEngine();
                const camera = this.getCamera();
                if (camera) {
                    scene = camera.getScene();
                }
                else if (engine && engine.scenes) {
                    const scenes = engine.scenes;
                    scene = scenes[scenes.length - 1];
                }
                else {
                    scene = EngineStore.LastCreatedScene;
                }
                if (scene) {
                    this._imageProcessingConfiguration = scene.imageProcessingConfiguration;
                }
                else {
                    this._imageProcessingConfiguration = new ImageProcessingConfiguration();
                }
            }
            else {
                this._imageProcessingConfiguration = configuration;
            }
            // Attaches observer.
            if (this._imageProcessingConfiguration) {
                this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
                    this._updateParameters();
                });
            }
            // Ensure the effect will be rebuilt.
            if (!doNotBuild) {
                this._updateParameters();
            }
        }
        /**
         * If the post process is supported.
         */
        get isSupported() {
            const effect = this.getEffect();
            return !effect || effect.isSupported;
        }
        /**
         * Gets Color curves setup used in the effect if colorCurvesEnabled is set to true .
         */
        get colorCurves() {
            return this.imageProcessingConfiguration.colorCurves;
        }
        /**
         * Sets Color curves setup used in the effect if colorCurvesEnabled is set to true .
         */
        set colorCurves(value) {
            this.imageProcessingConfiguration.colorCurves = value;
        }
        /**
         * Gets whether the color curves effect is enabled.
         */
        get colorCurvesEnabled() {
            return this.imageProcessingConfiguration.colorCurvesEnabled;
        }
        /**
         * Sets whether the color curves effect is enabled.
         */
        set colorCurvesEnabled(value) {
            this.imageProcessingConfiguration.colorCurvesEnabled = value;
        }
        /**
         * Gets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
         */
        get colorGradingTexture() {
            return this.imageProcessingConfiguration.colorGradingTexture;
        }
        /**
         * Sets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
         */
        set colorGradingTexture(value) {
            this.imageProcessingConfiguration.colorGradingTexture = value;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        get colorGradingEnabled() {
            return this.imageProcessingConfiguration.colorGradingEnabled;
        }
        /**
         * Gets whether the color grading effect is enabled.
         */
        set colorGradingEnabled(value) {
            this.imageProcessingConfiguration.colorGradingEnabled = value;
        }
        /**
         * Gets exposure used in the effect.
         */
        get exposure() {
            return this.imageProcessingConfiguration.exposure;
        }
        /**
         * Sets exposure used in the effect.
         */
        set exposure(value) {
            this.imageProcessingConfiguration.exposure = value;
        }
        /**
         * Gets whether tonemapping is enabled or not.
         */
        get toneMappingEnabled() {
            return this._imageProcessingConfiguration.toneMappingEnabled;
        }
        /**
         * Sets whether tonemapping is enabled or not
         */
        set toneMappingEnabled(value) {
            this._imageProcessingConfiguration.toneMappingEnabled = value;
        }
        /**
         * Gets the type of tone mapping effect.
         */
        get toneMappingType() {
            return this._imageProcessingConfiguration.toneMappingType;
        }
        /**
         * Sets the type of tone mapping effect.
         */
        set toneMappingType(value) {
            this._imageProcessingConfiguration.toneMappingType = value;
        }
        /**
         * Gets contrast used in the effect.
         */
        get contrast() {
            return this.imageProcessingConfiguration.contrast;
        }
        /**
         * Sets contrast used in the effect.
         */
        set contrast(value) {
            this.imageProcessingConfiguration.contrast = value;
        }
        /**
         * Gets Vignette stretch size.
         */
        get vignetteStretch() {
            return this.imageProcessingConfiguration.vignetteStretch;
        }
        /**
         * Sets Vignette stretch size.
         */
        set vignetteStretch(value) {
            this.imageProcessingConfiguration.vignetteStretch = value;
        }
        /**
         * Gets Vignette center X Offset.
         * @deprecated use vignetteCenterX instead
         */
        get vignetteCentreX() {
            return this.imageProcessingConfiguration.vignetteCenterX;
        }
        /**
         * Sets Vignette center X Offset.
         * @deprecated use vignetteCenterX instead
         */
        set vignetteCentreX(value) {
            this.imageProcessingConfiguration.vignetteCenterX = value;
        }
        /**
         * Gets Vignette center Y Offset.
         * @deprecated use vignetteCenterY instead
         */
        get vignetteCentreY() {
            return this.imageProcessingConfiguration.vignetteCenterY;
        }
        /**
         * Sets Vignette center Y Offset.
         * @deprecated use vignetteCenterY instead
         */
        set vignetteCentreY(value) {
            this.imageProcessingConfiguration.vignetteCenterY = value;
        }
        /**
         * Vignette center Y Offset.
         */
        get vignetteCenterY() {
            return this.imageProcessingConfiguration.vignetteCenterY;
        }
        set vignetteCenterY(value) {
            this.imageProcessingConfiguration.vignetteCenterY = value;
        }
        /**
         * Vignette center X Offset.
         */
        get vignetteCenterX() {
            return this.imageProcessingConfiguration.vignetteCenterX;
        }
        set vignetteCenterX(value) {
            this.imageProcessingConfiguration.vignetteCenterX = value;
        }
        /**
         * Gets Vignette weight or intensity of the vignette effect.
         */
        get vignetteWeight() {
            return this.imageProcessingConfiguration.vignetteWeight;
        }
        /**
         * Sets Vignette weight or intensity of the vignette effect.
         */
        set vignetteWeight(value) {
            this.imageProcessingConfiguration.vignetteWeight = value;
        }
        /**
         * Gets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
         * if vignetteEnabled is set to true.
         */
        get vignetteColor() {
            return this.imageProcessingConfiguration.vignetteColor;
        }
        /**
         * Sets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
         * if vignetteEnabled is set to true.
         */
        set vignetteColor(value) {
            this.imageProcessingConfiguration.vignetteColor = value;
        }
        /**
         * Gets Camera field of view used by the Vignette effect.
         */
        get vignetteCameraFov() {
            return this.imageProcessingConfiguration.vignetteCameraFov;
        }
        /**
         * Sets Camera field of view used by the Vignette effect.
         */
        set vignetteCameraFov(value) {
            this.imageProcessingConfiguration.vignetteCameraFov = value;
        }
        /**
         * Gets the vignette blend mode allowing different kind of effect.
         */
        get vignetteBlendMode() {
            return this.imageProcessingConfiguration.vignetteBlendMode;
        }
        /**
         * Sets the vignette blend mode allowing different kind of effect.
         */
        set vignetteBlendMode(value) {
            this.imageProcessingConfiguration.vignetteBlendMode = value;
        }
        /**
         * Gets whether the vignette effect is enabled.
         */
        get vignetteEnabled() {
            return this.imageProcessingConfiguration.vignetteEnabled;
        }
        /**
         * Sets whether the vignette effect is enabled.
         */
        set vignetteEnabled(value) {
            this.imageProcessingConfiguration.vignetteEnabled = value;
        }
        /**
         * Gets intensity of the dithering effect.
         */
        get ditheringIntensity() {
            return this.imageProcessingConfiguration.ditheringIntensity;
        }
        /**
         * Sets intensity of the dithering effect.
         */
        set ditheringIntensity(value) {
            this.imageProcessingConfiguration.ditheringIntensity = value;
        }
        /**
         * Gets whether the dithering effect is enabled.
         */
        get ditheringEnabled() {
            return this.imageProcessingConfiguration.ditheringEnabled;
        }
        /**
         * Sets whether the dithering effect is enabled.
         */
        set ditheringEnabled(value) {
            this.imageProcessingConfiguration.ditheringEnabled = value;
        }
        /**
         * Gets whether the input of the processing is in Gamma or Linear Space.
         */
        get fromLinearSpace() {
            return this._fromLinearSpace;
        }
        /**
         * Sets whether the input of the processing is in Gamma or Linear Space.
         */
        set fromLinearSpace(value) {
            if (this._fromLinearSpace === value) {
                return;
            }
            this._fromLinearSpace = value;
            this._updateParameters();
        }
        constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, imageProcessingConfiguration) {
            super(name, "imageProcessing", [], [], options, camera, samplingMode, engine, reusable, null, textureType, "postprocess", null, true);
            this._fromLinearSpace = true;
            /**
             * Defines cache preventing GC.
             */
            this._defines = {
                IMAGEPROCESSING: false,
                VIGNETTE: false,
                VIGNETTEBLENDMODEMULTIPLY: false,
                VIGNETTEBLENDMODEOPAQUE: false,
                TONEMAPPING: false,
                TONEMAPPING_ACES: false,
                CONTRAST: false,
                COLORCURVES: false,
                COLORGRADING: false,
                COLORGRADING3D: false,
                FROMLINEARSPACE: false,
                SAMPLER3DGREENDEPTH: false,
                SAMPLER3DBGRMAP: false,
                DITHER: false,
                IMAGEPROCESSINGPOSTPROCESS: false,
                EXPOSURE: false,
                SKIPFINALCOLORCLAMP: false,
            };
            // Setup the configuration as forced by the constructor. This would then not force the
            // scene materials output in linear space and let untouched the default forward pass.
            if (imageProcessingConfiguration) {
                imageProcessingConfiguration.applyByPostProcess = true;
                this._attachImageProcessingConfiguration(imageProcessingConfiguration, true);
                // This will cause the shader to be compiled
                this._updateParameters();
            }
            // Setup the default processing configuration to the scene.
            else {
                this._attachImageProcessingConfiguration(null, true);
                this.imageProcessingConfiguration.applyByPostProcess = true;
            }
            this.onApply = (effect) => {
                this.imageProcessingConfiguration.bind(effect, this.aspectRatio);
            };
        }
        /**
         *  "ImageProcessingPostProcess"
         * @returns "ImageProcessingPostProcess"
         */
        getClassName() {
            return "ImageProcessingPostProcess";
        }
        /**
         * @internal
         */
        _updateParameters() {
            this._defines.FROMLINEARSPACE = this._fromLinearSpace;
            this.imageProcessingConfiguration.prepareDefines(this._defines, true);
            let defines = "";
            for (const define in this._defines) {
                if (this._defines[define]) {
                    defines += `#define ${define};\n`;
                }
            }
            const samplers = ["textureSampler"];
            const uniforms = ["scale"];
            if (ImageProcessingConfiguration) {
                ImageProcessingConfiguration.PrepareSamplers(samplers, this._defines);
                ImageProcessingConfiguration.PrepareUniforms(uniforms, this._defines);
            }
            this.updateEffect(defines, uniforms, samplers);
        }
        dispose(camera) {
            super.dispose(camera);
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            if (this._imageProcessingConfiguration) {
                this.imageProcessingConfiguration.applyByPostProcess = false;
            }
        }
    }
    __decorate$1([
        serialize()
    ], ImageProcessingPostProcess.prototype, "_fromLinearSpace", void 0);

    /**
     * Defines supported buttons for DualShock compatible gamepads
     */
    var DualShockButton;
    (function (DualShockButton) {
        /** Cross */
        DualShockButton[DualShockButton["Cross"] = 0] = "Cross";
        /** Circle */
        DualShockButton[DualShockButton["Circle"] = 1] = "Circle";
        /** Square */
        DualShockButton[DualShockButton["Square"] = 2] = "Square";
        /** Triangle */
        DualShockButton[DualShockButton["Triangle"] = 3] = "Triangle";
        /** L1 */
        DualShockButton[DualShockButton["L1"] = 4] = "L1";
        /** R1 */
        DualShockButton[DualShockButton["R1"] = 5] = "R1";
        /** Share */
        DualShockButton[DualShockButton["Share"] = 8] = "Share";
        /** Options */
        DualShockButton[DualShockButton["Options"] = 9] = "Options";
        /** Left stick */
        DualShockButton[DualShockButton["LeftStick"] = 10] = "LeftStick";
        /** Right stick */
        DualShockButton[DualShockButton["RightStick"] = 11] = "RightStick";
    })(DualShockButton || (DualShockButton = {}));
    /** Defines values for DualShock DPad  */
    var DualShockDpad;
    (function (DualShockDpad) {
        /** Up */
        DualShockDpad[DualShockDpad["Up"] = 12] = "Up";
        /** Down */
        DualShockDpad[DualShockDpad["Down"] = 13] = "Down";
        /** Left */
        DualShockDpad[DualShockDpad["Left"] = 14] = "Left";
        /** Right */
        DualShockDpad[DualShockDpad["Right"] = 15] = "Right";
    })(DualShockDpad || (DualShockDpad = {}));
    /**
     * Defines a DualShock gamepad
     */
    class DualShockPad extends Gamepad {
        /**
         * Creates a new DualShock gamepad object
         * @param id defines the id of this gamepad
         * @param index defines its index
         * @param gamepad defines the internal HTML gamepad object
         */
        constructor(id, index, gamepad) {
            super(id.replace("STANDARD GAMEPAD", "SONY PLAYSTATION DUALSHOCK"), index, gamepad, 0, 1, 2, 3);
            this._leftTrigger = 0;
            this._rightTrigger = 0;
            /** Observable raised when a button is pressed */
            this.onButtonDownObservable = new Observable$1();
            /** Observable raised when a button is released */
            this.onButtonUpObservable = new Observable$1();
            /** Observable raised when a pad is pressed */
            this.onPadDownObservable = new Observable$1();
            /** Observable raised when a pad is released */
            this.onPadUpObservable = new Observable$1();
            this._buttonCross = 0;
            this._buttonCircle = 0;
            this._buttonSquare = 0;
            this._buttonTriangle = 0;
            this._buttonShare = 0;
            this._buttonOptions = 0;
            this._buttonL1 = 0;
            this._buttonR1 = 0;
            this._buttonLeftStick = 0;
            this._buttonRightStick = 0;
            this._dPadUp = 0;
            this._dPadDown = 0;
            this._dPadLeft = 0;
            this._dPadRight = 0;
            this.type = Gamepad.DUALSHOCK;
        }
        /**
         * Defines the callback to call when left trigger is pressed
         * @param callback defines the callback to use
         */
        onlefttriggerchanged(callback) {
            this._onlefttriggerchanged = callback;
        }
        /**
         * Defines the callback to call when right trigger is pressed
         * @param callback defines the callback to use
         */
        onrighttriggerchanged(callback) {
            this._onrighttriggerchanged = callback;
        }
        /**
         * Gets the left trigger value
         */
        get leftTrigger() {
            return this._leftTrigger;
        }
        /**
         * Sets the left trigger value
         */
        set leftTrigger(newValue) {
            if (this._onlefttriggerchanged && this._leftTrigger !== newValue) {
                this._onlefttriggerchanged(newValue);
            }
            this._leftTrigger = newValue;
        }
        /**
         * Gets the right trigger value
         */
        get rightTrigger() {
            return this._rightTrigger;
        }
        /**
         * Sets the right trigger value
         */
        set rightTrigger(newValue) {
            if (this._onrighttriggerchanged && this._rightTrigger !== newValue) {
                this._onrighttriggerchanged(newValue);
            }
            this._rightTrigger = newValue;
        }
        /**
         * Defines the callback to call when a button is pressed
         * @param callback defines the callback to use
         */
        onbuttondown(callback) {
            this._onbuttondown = callback;
        }
        /**
         * Defines the callback to call when a button is released
         * @param callback defines the callback to use
         */
        onbuttonup(callback) {
            this._onbuttonup = callback;
        }
        /**
         * Defines the callback to call when a pad is pressed
         * @param callback defines the callback to use
         */
        ondpaddown(callback) {
            this._ondpaddown = callback;
        }
        /**
         * Defines the callback to call when a pad is released
         * @param callback defines the callback to use
         */
        ondpadup(callback) {
            this._ondpadup = callback;
        }
        _setButtonValue(newValue, currentValue, buttonType) {
            if (newValue !== currentValue) {
                if (newValue === 1) {
                    if (this._onbuttondown) {
                        this._onbuttondown(buttonType);
                    }
                    this.onButtonDownObservable.notifyObservers(buttonType);
                }
                if (newValue === 0) {
                    if (this._onbuttonup) {
                        this._onbuttonup(buttonType);
                    }
                    this.onButtonUpObservable.notifyObservers(buttonType);
                }
            }
            return newValue;
        }
        _setDPadValue(newValue, currentValue, buttonType) {
            if (newValue !== currentValue) {
                if (newValue === 1) {
                    if (this._ondpaddown) {
                        this._ondpaddown(buttonType);
                    }
                    this.onPadDownObservable.notifyObservers(buttonType);
                }
                if (newValue === 0) {
                    if (this._ondpadup) {
                        this._ondpadup(buttonType);
                    }
                    this.onPadUpObservable.notifyObservers(buttonType);
                }
            }
            return newValue;
        }
        /**
         * Gets the value of the `Cross` button
         */
        get buttonCross() {
            return this._buttonCross;
        }
        /**
         * Sets the value of the `Cross` button
         */
        set buttonCross(value) {
            this._buttonCross = this._setButtonValue(value, this._buttonCross, DualShockButton.Cross);
        }
        /**
         * Gets the value of the `Circle` button
         */
        get buttonCircle() {
            return this._buttonCircle;
        }
        /**
         * Sets the value of the `Circle` button
         */
        set buttonCircle(value) {
            this._buttonCircle = this._setButtonValue(value, this._buttonCircle, DualShockButton.Circle);
        }
        /**
         * Gets the value of the `Square` button
         */
        get buttonSquare() {
            return this._buttonSquare;
        }
        /**
         * Sets the value of the `Square` button
         */
        set buttonSquare(value) {
            this._buttonSquare = this._setButtonValue(value, this._buttonSquare, DualShockButton.Square);
        }
        /**
         * Gets the value of the `Triangle` button
         */
        get buttonTriangle() {
            return this._buttonTriangle;
        }
        /**
         * Sets the value of the `Triangle` button
         */
        set buttonTriangle(value) {
            this._buttonTriangle = this._setButtonValue(value, this._buttonTriangle, DualShockButton.Triangle);
        }
        /**
         * Gets the value of the `Options` button
         */
        get buttonOptions() {
            return this._buttonOptions;
        }
        /**
         * Sets the value of the `Options` button
         */
        set buttonOptions(value) {
            this._buttonOptions = this._setButtonValue(value, this._buttonOptions, DualShockButton.Options);
        }
        /**
         * Gets the value of the `Share` button
         */
        get buttonShare() {
            return this._buttonShare;
        }
        /**
         * Sets the value of the `Share` button
         */
        set buttonShare(value) {
            this._buttonShare = this._setButtonValue(value, this._buttonShare, DualShockButton.Share);
        }
        /**
         * Gets the value of the `L1` button
         */
        get buttonL1() {
            return this._buttonL1;
        }
        /**
         * Sets the value of the `L1` button
         */
        set buttonL1(value) {
            this._buttonL1 = this._setButtonValue(value, this._buttonL1, DualShockButton.L1);
        }
        /**
         * Gets the value of the `R1` button
         */
        get buttonR1() {
            return this._buttonR1;
        }
        /**
         * Sets the value of the `R1` button
         */
        set buttonR1(value) {
            this._buttonR1 = this._setButtonValue(value, this._buttonR1, DualShockButton.R1);
        }
        /**
         * Gets the value of the Left joystick
         */
        get buttonLeftStick() {
            return this._buttonLeftStick;
        }
        /**
         * Sets the value of the Left joystick
         */
        set buttonLeftStick(value) {
            this._buttonLeftStick = this._setButtonValue(value, this._buttonLeftStick, DualShockButton.LeftStick);
        }
        /**
         * Gets the value of the Right joystick
         */
        get buttonRightStick() {
            return this._buttonRightStick;
        }
        /**
         * Sets the value of the Right joystick
         */
        set buttonRightStick(value) {
            this._buttonRightStick = this._setButtonValue(value, this._buttonRightStick, DualShockButton.RightStick);
        }
        /**
         * Gets the value of D-pad up
         */
        get dPadUp() {
            return this._dPadUp;
        }
        /**
         * Sets the value of D-pad up
         */
        set dPadUp(value) {
            this._dPadUp = this._setDPadValue(value, this._dPadUp, DualShockDpad.Up);
        }
        /**
         * Gets the value of D-pad down
         */
        get dPadDown() {
            return this._dPadDown;
        }
        /**
         * Sets the value of D-pad down
         */
        set dPadDown(value) {
            this._dPadDown = this._setDPadValue(value, this._dPadDown, DualShockDpad.Down);
        }
        /**
         * Gets the value of D-pad left
         */
        get dPadLeft() {
            return this._dPadLeft;
        }
        /**
         * Sets the value of D-pad left
         */
        set dPadLeft(value) {
            this._dPadLeft = this._setDPadValue(value, this._dPadLeft, DualShockDpad.Left);
        }
        /**
         * Gets the value of D-pad right
         */
        get dPadRight() {
            return this._dPadRight;
        }
        /**
         * Sets the value of D-pad right
         */
        set dPadRight(value) {
            this._dPadRight = this._setDPadValue(value, this._dPadRight, DualShockDpad.Right);
        }
        /**
         * Force the gamepad to synchronize with device values
         */
        update() {
            super.update();
            this.buttonCross = this.browserGamepad.buttons[0].value;
            this.buttonCircle = this.browserGamepad.buttons[1].value;
            this.buttonSquare = this.browserGamepad.buttons[2].value;
            this.buttonTriangle = this.browserGamepad.buttons[3].value;
            this.buttonL1 = this.browserGamepad.buttons[4].value;
            this.buttonR1 = this.browserGamepad.buttons[5].value;
            this.leftTrigger = this.browserGamepad.buttons[6].value;
            this.rightTrigger = this.browserGamepad.buttons[7].value;
            this.buttonShare = this.browserGamepad.buttons[8].value;
            this.buttonOptions = this.browserGamepad.buttons[9].value;
            this.buttonLeftStick = this.browserGamepad.buttons[10].value;
            this.buttonRightStick = this.browserGamepad.buttons[11].value;
            this.dPadUp = this.browserGamepad.buttons[12].value;
            this.dPadDown = this.browserGamepad.buttons[13].value;
            this.dPadLeft = this.browserGamepad.buttons[14].value;
            this.dPadRight = this.browserGamepad.buttons[15].value;
        }
        /**
         * Disposes the gamepad
         */
        dispose() {
            super.dispose();
            this.onButtonDownObservable.clear();
            this.onButtonUpObservable.clear();
            this.onPadDownObservable.clear();
            this.onPadUpObservable.clear();
        }
    }

    /**
     * Manager for handling gamepads
     */
    class GamepadManager {
        /**
         * Initializes the gamepad manager
         * @param _scene BabylonJS scene
         */
        constructor(_scene) {
            this._scene = _scene;
            this._babylonGamepads = [];
            this._oneGamepadConnected = false;
            /** @internal */
            this._isMonitoring = false;
            /**
             * observable to be triggered when the gamepad controller has been disconnected
             */
            this.onGamepadDisconnectedObservable = new Observable$1();
            if (!IsWindowObjectExist()) {
                this._gamepadEventSupported = false;
            }
            else {
                this._gamepadEventSupported = "GamepadEvent" in window;
                this._gamepadSupport = navigator && navigator.getGamepads;
            }
            this.onGamepadConnectedObservable = new Observable$1((observer) => {
                // This will be used to raise the onGamepadConnected for all gamepads ALREADY connected
                for (const i in this._babylonGamepads) {
                    const gamepad = this._babylonGamepads[i];
                    if (gamepad && gamepad._isConnected) {
                        this.onGamepadConnectedObservable.notifyObserver(observer, gamepad);
                    }
                }
            });
            this._onGamepadConnectedEvent = (evt) => {
                const gamepad = evt.gamepad;
                if (gamepad.index in this._babylonGamepads) {
                    if (this._babylonGamepads[gamepad.index].isConnected) {
                        return;
                    }
                }
                let newGamepad;
                if (this._babylonGamepads[gamepad.index]) {
                    newGamepad = this._babylonGamepads[gamepad.index];
                    newGamepad.browserGamepad = gamepad;
                    newGamepad._isConnected = true;
                }
                else {
                    newGamepad = this._addNewGamepad(gamepad);
                }
                this.onGamepadConnectedObservable.notifyObservers(newGamepad);
                this._startMonitoringGamepads();
            };
            this._onGamepadDisconnectedEvent = (evt) => {
                const gamepad = evt.gamepad;
                // Remove the gamepad from the list of gamepads to monitor.
                for (const i in this._babylonGamepads) {
                    if (this._babylonGamepads[i].index === gamepad.index) {
                        const disconnectedGamepad = this._babylonGamepads[i];
                        disconnectedGamepad._isConnected = false;
                        this.onGamepadDisconnectedObservable.notifyObservers(disconnectedGamepad);
                        disconnectedGamepad.dispose && disconnectedGamepad.dispose();
                        break;
                    }
                }
            };
            if (this._gamepadSupport) {
                //first add already-connected gamepads
                this._updateGamepadObjects();
                if (this._babylonGamepads.length) {
                    this._startMonitoringGamepads();
                }
                // Checking if the gamepad connected event is supported (like in Firefox)
                if (this._gamepadEventSupported) {
                    const hostWindow = this._scene ? this._scene.getEngine().getHostWindow() : window;
                    if (hostWindow) {
                        hostWindow.addEventListener("gamepadconnected", this._onGamepadConnectedEvent, false);
                        hostWindow.addEventListener("gamepaddisconnected", this._onGamepadDisconnectedEvent, false);
                    }
                }
                else {
                    this._startMonitoringGamepads();
                }
            }
        }
        /**
         * The gamepads in the game pad manager
         */
        get gamepads() {
            return this._babylonGamepads;
        }
        /**
         * Get the gamepad controllers based on type
         * @param type The type of gamepad controller
         * @returns Nullable gamepad
         */
        getGamepadByType(type = Gamepad.XBOX) {
            for (const gamepad of this._babylonGamepads) {
                if (gamepad && gamepad.type === type) {
                    return gamepad;
                }
            }
            return null;
        }
        /**
         * Disposes the gamepad manager
         */
        dispose() {
            if (this._gamepadEventSupported) {
                if (this._onGamepadConnectedEvent) {
                    window.removeEventListener("gamepadconnected", this._onGamepadConnectedEvent);
                }
                if (this._onGamepadDisconnectedEvent) {
                    window.removeEventListener("gamepaddisconnected", this._onGamepadDisconnectedEvent);
                }
                this._onGamepadConnectedEvent = null;
                this._onGamepadDisconnectedEvent = null;
            }
            this._babylonGamepads.forEach((gamepad) => {
                gamepad.dispose();
            });
            this.onGamepadConnectedObservable.clear();
            this.onGamepadDisconnectedObservable.clear();
            this._oneGamepadConnected = false;
            this._stopMonitoringGamepads();
            this._babylonGamepads = [];
        }
        _addNewGamepad(gamepad) {
            if (!this._oneGamepadConnected) {
                this._oneGamepadConnected = true;
            }
            let newGamepad;
            const dualShock = gamepad.id.search("054c") !== -1 && gamepad.id.search("0ce6") === -1;
            const xboxOne = gamepad.id.search("Xbox One") !== -1;
            if (xboxOne ||
                gamepad.id.search("Xbox 360") !== -1 ||
                gamepad.id.search("xinput") !== -1 ||
                (gamepad.id.search("045e") !== -1 && gamepad.id.search("Surface Dock") === -1)) {
                // make sure the Surface Dock Extender is not detected as an xbox controller
                newGamepad = new Xbox360Pad(gamepad.id, gamepad.index, gamepad, xboxOne);
            }
            else if (dualShock) {
                newGamepad = new DualShockPad(gamepad.id, gamepad.index, gamepad);
            }
            // if pose is supported, use the (WebVR) pose enabled controller
            else if (gamepad.pose) {
                newGamepad = PoseEnabledControllerHelper.InitiateController(gamepad);
            }
            else {
                newGamepad = new GenericPad(gamepad.id, gamepad.index, gamepad);
            }
            this._babylonGamepads[newGamepad.index] = newGamepad;
            return newGamepad;
        }
        _startMonitoringGamepads() {
            if (!this._isMonitoring) {
                this._isMonitoring = true;
                //back-comp
                this._checkGamepadsStatus();
            }
        }
        _stopMonitoringGamepads() {
            this._isMonitoring = false;
        }
        /** @internal */
        _checkGamepadsStatus() {
            // Hack to be compatible Chrome
            this._updateGamepadObjects();
            for (const i in this._babylonGamepads) {
                const gamepad = this._babylonGamepads[i];
                if (!gamepad || !gamepad.isConnected) {
                    continue;
                }
                try {
                    gamepad.update();
                }
                catch (_a) {
                    if (this._loggedErrors.indexOf(gamepad.index) === -1) {
                        Tools.Warn(`Error updating gamepad ${gamepad.id}`);
                        this._loggedErrors.push(gamepad.index);
                    }
                }
            }
            if (this._isMonitoring) {
                Engine.QueueNewFrame(() => {
                    this._checkGamepadsStatus();
                });
            }
        }
        // This function is called only on Chrome, which does not properly support
        // connection/disconnection events and forces you to recopy again the gamepad object
        _updateGamepadObjects() {
            const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
            for (let i = 0; i < gamepads.length; i++) {
                const gamepad = gamepads[i];
                if (gamepad) {
                    if (!this._babylonGamepads[gamepad.index]) {
                        const newGamepad = this._addNewGamepad(gamepad);
                        this.onGamepadConnectedObservable.notifyObservers(newGamepad);
                    }
                    else {
                        // Forced to copy again this object for Chrome for unknown reason
                        this._babylonGamepads[i].browserGamepad = gamepad;
                        if (!this._babylonGamepads[i].isConnected) {
                            this._babylonGamepads[i]._isConnected = true;
                            this.onGamepadConnectedObservable.notifyObservers(this._babylonGamepads[i]);
                        }
                    }
                }
            }
        }
    }

    /**
     * Manage the gamepad inputs to control a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class FreeCameraGamepadInput {
        constructor() {
            /**
             * Defines the gamepad rotation sensibility.
             * This is the threshold from when rotation starts to be accounted for to prevent jittering.
             */
            this.gamepadAngularSensibility = 200;
            /**
             * Defines the gamepad move sensibility.
             * This is the threshold from when moving starts to be accounted for for to prevent jittering.
             */
            this.gamepadMoveSensibility = 40;
            /**
             * Defines the minimum value at which any analog stick input is ignored.
             * Note: This value should only be a value between 0 and 1.
             */
            this.deadzoneDelta = 0.1;
            this._yAxisScale = 1.0;
            this._cameraTransform = Matrix.Identity();
            this._deltaTransform = Vector3.Zero();
            this._vector3 = Vector3.Zero();
            this._vector2 = Vector2.Zero();
        }
        /**
         * Gets or sets a boolean indicating that Yaxis (for right stick) should be inverted
         */
        get invertYAxis() {
            return this._yAxisScale !== 1.0;
        }
        set invertYAxis(value) {
            this._yAxisScale = value ? -1.0 : 1.0;
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         */
        attachControl() {
            const manager = this.camera.getScene().gamepadManager;
            this._onGamepadConnectedObserver = manager.onGamepadConnectedObservable.add((gamepad) => {
                if (gamepad.type !== Gamepad.POSE_ENABLED) {
                    // prioritize XBOX gamepads.
                    if (!this.gamepad || gamepad.type === Gamepad.XBOX) {
                        this.gamepad = gamepad;
                    }
                }
            });
            this._onGamepadDisconnectedObserver = manager.onGamepadDisconnectedObservable.add((gamepad) => {
                if (this.gamepad === gamepad) {
                    this.gamepad = null;
                }
            });
            // check if there are already other controllers connected
            this.gamepad = manager.getGamepadByType(Gamepad.XBOX);
            // if no xbox controller was found, but there are gamepad controllers, take the first one
            if (!this.gamepad && manager.gamepads.length) {
                this.gamepad = manager.gamepads[0];
            }
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            this.camera.getScene().gamepadManager.onGamepadConnectedObservable.remove(this._onGamepadConnectedObserver);
            this.camera.getScene().gamepadManager.onGamepadDisconnectedObservable.remove(this._onGamepadDisconnectedObserver);
            this.gamepad = null;
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            if (this.gamepad && this.gamepad.leftStick) {
                const camera = this.camera;
                const lsValues = this.gamepad.leftStick;
                if (this.gamepadMoveSensibility !== 0) {
                    lsValues.x = Math.abs(lsValues.x) > this.deadzoneDelta ? lsValues.x / this.gamepadMoveSensibility : 0;
                    lsValues.y = Math.abs(lsValues.y) > this.deadzoneDelta ? lsValues.y / this.gamepadMoveSensibility : 0;
                }
                let rsValues = this.gamepad.rightStick;
                if (rsValues && this.gamepadAngularSensibility !== 0) {
                    rsValues.x = Math.abs(rsValues.x) > this.deadzoneDelta ? rsValues.x / this.gamepadAngularSensibility : 0;
                    rsValues.y = (Math.abs(rsValues.y) > this.deadzoneDelta ? rsValues.y / this.gamepadAngularSensibility : 0) * this._yAxisScale;
                }
                else {
                    rsValues = { x: 0, y: 0 };
                }
                if (!camera.rotationQuaternion) {
                    Matrix.RotationYawPitchRollToRef(camera.rotation.y, camera.rotation.x, 0, this._cameraTransform);
                }
                else {
                    camera.rotationQuaternion.toRotationMatrix(this._cameraTransform);
                }
                const speed = camera._computeLocalCameraSpeed() * 50.0;
                this._vector3.copyFromFloats(lsValues.x * speed, 0, -lsValues.y * speed);
                Vector3.TransformCoordinatesToRef(this._vector3, this._cameraTransform, this._deltaTransform);
                camera.cameraDirection.addInPlace(this._deltaTransform);
                this._vector2.copyFromFloats(rsValues.y, rsValues.x);
                camera.cameraRotation.addInPlace(this._vector2);
            }
        }
        /**
         * Gets the class name of the current input.
         * @returns the class name
         */
        getClassName() {
            return "FreeCameraGamepadInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "gamepad";
        }
    }
    __decorate$1([
        serialize()
    ], FreeCameraGamepadInput.prototype, "gamepadAngularSensibility", void 0);
    __decorate$1([
        serialize()
    ], FreeCameraGamepadInput.prototype, "gamepadMoveSensibility", void 0);
    CameraInputTypes["FreeCameraGamepadInput"] = FreeCameraGamepadInput;

    /**
     * Manage the gamepad inputs to control an arc rotate camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */
    class ArcRotateCameraGamepadInput {
        constructor() {
            /**
             * Defines the gamepad rotation sensibility.
             * This is the threshold from when rotation starts to be accounted for to prevent jittering.
             */
            this.gamepadRotationSensibility = 80;
            /**
             * Defines the gamepad move sensibility.
             * This is the threshold from when moving starts to be accounted for for to prevent jittering.
             */
            this.gamepadMoveSensibility = 40;
            this._yAxisScale = 1.0;
        }
        /**
         * Gets or sets a boolean indicating that Yaxis (for right stick) should be inverted
         */
        get invertYAxis() {
            return this._yAxisScale !== 1.0;
        }
        set invertYAxis(value) {
            this._yAxisScale = value ? -1.0 : 1.0;
        }
        /**
         * Attach the input controls to a specific dom element to get the input from.
         */
        attachControl() {
            const manager = this.camera.getScene().gamepadManager;
            this._onGamepadConnectedObserver = manager.onGamepadConnectedObservable.add((gamepad) => {
                if (gamepad.type !== Gamepad.POSE_ENABLED) {
                    // prioritize XBOX gamepads.
                    if (!this.gamepad || gamepad.type === Gamepad.XBOX) {
                        this.gamepad = gamepad;
                    }
                }
            });
            this._onGamepadDisconnectedObserver = manager.onGamepadDisconnectedObservable.add((gamepad) => {
                if (this.gamepad === gamepad) {
                    this.gamepad = null;
                }
            });
            this.gamepad = manager.getGamepadByType(Gamepad.XBOX);
        }
        /**
         * Detach the current controls from the specified dom element.
         */
        detachControl() {
            this.camera.getScene().gamepadManager.onGamepadConnectedObservable.remove(this._onGamepadConnectedObserver);
            this.camera.getScene().gamepadManager.onGamepadDisconnectedObservable.remove(this._onGamepadDisconnectedObserver);
            this.gamepad = null;
        }
        /**
         * Update the current camera state depending on the inputs that have been used this frame.
         * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
         */
        checkInputs() {
            if (this.gamepad) {
                const camera = this.camera;
                const rsValues = this.gamepad.rightStick;
                if (rsValues) {
                    if (rsValues.x != 0) {
                        const normalizedRX = rsValues.x / this.gamepadRotationSensibility;
                        if (normalizedRX != 0 && Math.abs(normalizedRX) > 0.005) {
                            camera.inertialAlphaOffset += normalizedRX;
                        }
                    }
                    if (rsValues.y != 0) {
                        const normalizedRY = (rsValues.y / this.gamepadRotationSensibility) * this._yAxisScale;
                        if (normalizedRY != 0 && Math.abs(normalizedRY) > 0.005) {
                            camera.inertialBetaOffset += normalizedRY;
                        }
                    }
                }
                const lsValues = this.gamepad.leftStick;
                if (lsValues && lsValues.y != 0) {
                    const normalizedLY = lsValues.y / this.gamepadMoveSensibility;
                    if (normalizedLY != 0 && Math.abs(normalizedLY) > 0.005) {
                        this.camera.inertialRadiusOffset -= normalizedLY;
                    }
                }
            }
        }
        /**
         * Gets the class name of the current intput.
         * @returns the class name
         */
        getClassName() {
            return "ArcRotateCameraGamepadInput";
        }
        /**
         * Get the friendly name associated with the input class.
         * @returns the input friendly name
         */
        getSimpleName() {
            return "gamepad";
        }
    }
    __decorate$1([
        serialize()
    ], ArcRotateCameraGamepadInput.prototype, "gamepadRotationSensibility", void 0);
    __decorate$1([
        serialize()
    ], ArcRotateCameraGamepadInput.prototype, "gamepadMoveSensibility", void 0);
    CameraInputTypes["ArcRotateCameraGamepadInput"] = ArcRotateCameraGamepadInput;

    Object.defineProperty(Scene.prototype, "gamepadManager", {
        get: function () {
            if (!this._gamepadManager) {
                this._gamepadManager = new GamepadManager(this);
                let component = this._getComponent(SceneComponentConstants.NAME_GAMEPAD);
                if (!component) {
                    component = new GamepadSystemSceneComponent(this);
                    this._addComponent(component);
                }
            }
            return this._gamepadManager;
        },
        enumerable: true,
        configurable: true,
    });
    /**
     * Adds a gamepad to the free camera inputs manager
     */
    FreeCameraInputsManager.prototype.addGamepad = function () {
        this.add(new FreeCameraGamepadInput());
        return this;
    };
    /**
     * Adds a gamepad to the arc rotate camera inputs manager
     */
    ArcRotateCameraInputsManager.prototype.addGamepad = function () {
        this.add(new ArcRotateCameraGamepadInput());
        return this;
    };
    /**
     * Defines the gamepad scene component responsible to manage gamepads in a given scene
     */
    class GamepadSystemSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpfull to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_GAMEPAD;
            this.scene = scene;
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._beforeCameraUpdateStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERAUPDATE_GAMEPAD, this, this._beforeCameraUpdate);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Nothing to do for gamepads
        }
        /**
         * Disposes the component and the associated resources
         */
        dispose() {
            const gamepadManager = this.scene._gamepadManager;
            if (gamepadManager) {
                gamepadManager.dispose();
                this.scene._gamepadManager = null;
            }
        }
        _beforeCameraUpdate() {
            const gamepadManager = this.scene._gamepadManager;
            if (gamepadManager && gamepadManager._isMonitoring) {
                gamepadManager._checkGamepadsStatus();
            }
        }
    }

    // Static values to help the garbage collector
    // Quaternion
    const _staticOffsetValueQuaternion = Object.freeze(new Quaternion(0, 0, 0, 0));
    // Vector3
    const _staticOffsetValueVector3 = Object.freeze(Vector3.Zero());
    // Vector2
    const _staticOffsetValueVector2 = Object.freeze(Vector2.Zero());
    // Size
    const _staticOffsetValueSize = Object.freeze(Size.Zero());
    // Color3
    const _staticOffsetValueColor3 = Object.freeze(Color3.Black());
    /**
     * Defines a runtime animation
     */
    class RuntimeAnimation {
        /**
         * Gets the current frame of the runtime animation
         */
        get currentFrame() {
            return this._currentFrame;
        }
        /**
         * Gets the weight of the runtime animation
         */
        get weight() {
            return this._weight;
        }
        /**
         * Gets the current value of the runtime animation
         */
        get currentValue() {
            return this._currentValue;
        }
        /**
         * Gets or sets the target path of the runtime animation
         */
        get targetPath() {
            return this._targetPath;
        }
        /**
         * Gets the actual target of the runtime animation
         */
        get target() {
            return this._currentActiveTarget;
        }
        /**
         * Gets the additive state of the runtime animation
         */
        get isAdditive() {
            return this._host && this._host.isAdditive;
        }
        /**
         * Create a new RuntimeAnimation object
         * @param target defines the target of the animation
         * @param animation defines the source animation object
         * @param scene defines the hosting scene
         * @param host defines the initiating Animatable
         */
        constructor(target, animation, scene, host) {
            this._events = new Array();
            /**
             * The current frame of the runtime animation
             */
            this._currentFrame = 0;
            /**
             * The original value of the runtime animation
             */
            this._originalValue = new Array();
            /**
             * The original blend value of the runtime animation
             */
            this._originalBlendValue = null;
            /**
             * The offsets cache of the runtime animation
             */
            this._offsetsCache = {};
            /**
             * The high limits cache of the runtime animation
             */
            this._highLimitsCache = {};
            /**
             * Specifies if the runtime animation has been stopped
             */
            this._stopped = false;
            /**
             * The blending factor of the runtime animation
             */
            this._blendingFactor = 0;
            /**
             * The current value of the runtime animation
             */
            this._currentValue = null;
            this._currentActiveTarget = null;
            this._directTarget = null;
            /**
             * The target path of the runtime animation
             */
            this._targetPath = "";
            /**
             * The weight of the runtime animation
             */
            this._weight = 1.0;
            /**
             * The absolute frame offset of the runtime animation
             */
            this._absoluteFrameOffset = 0;
            /**
             * The previous elapsed time (since start of animation) of the runtime animation
             */
            this._previousElapsedTime = 0;
            /**
             * The previous absolute frame of the runtime animation (meaning, without taking into account the from/to values, only the elapsed time and the fps)
             */
            this._previousAbsoluteFrame = 0;
            this._targetIsArray = false;
            this._animation = animation;
            this._target = target;
            this._scene = scene;
            this._host = host;
            this._activeTargets = [];
            animation._runtimeAnimations.push(this);
            // State
            this._animationState = {
                key: 0,
                repeatCount: 0,
                loopMode: this._getCorrectLoopMode(),
            };
            if (this._animation.dataType === Animation.ANIMATIONTYPE_MATRIX) {
                this._animationState.workValue = Matrix.Zero();
            }
            // Limits
            this._keys = this._animation.getKeys();
            this._minFrame = this._keys[0].frame;
            this._maxFrame = this._keys[this._keys.length - 1].frame;
            this._minValue = this._keys[0].value;
            this._maxValue = this._keys[this._keys.length - 1].value;
            // Add a start key at frame 0 if missing
            if (this._minFrame !== 0) {
                const newKey = { frame: 0, value: this._minValue };
                this._keys.splice(0, 0, newKey);
            }
            // Check data
            if (this._target instanceof Array) {
                let index = 0;
                for (const target of this._target) {
                    this._preparePath(target, index);
                    this._getOriginalValues(index);
                    index++;
                }
                this._targetIsArray = true;
            }
            else {
                this._preparePath(this._target);
                this._getOriginalValues();
                this._targetIsArray = false;
                this._directTarget = this._activeTargets[0];
            }
            // Cloning events locally
            const events = animation.getEvents();
            if (events && events.length > 0) {
                events.forEach((e) => {
                    this._events.push(e._clone());
                });
            }
            this._enableBlending = target && target.animationPropertiesOverride ? target.animationPropertiesOverride.enableBlending : this._animation.enableBlending;
        }
        _preparePath(target, targetIndex = 0) {
            const targetPropertyPath = this._animation.targetPropertyPath;
            if (targetPropertyPath.length > 1) {
                let property = target[targetPropertyPath[0]];
                for (let index = 1; index < targetPropertyPath.length - 1; index++) {
                    property = property[targetPropertyPath[index]];
                }
                this._targetPath = targetPropertyPath[targetPropertyPath.length - 1];
                this._activeTargets[targetIndex] = property;
            }
            else {
                this._targetPath = targetPropertyPath[0];
                this._activeTargets[targetIndex] = target;
            }
        }
        /**
         * Gets the animation from the runtime animation
         */
        get animation() {
            return this._animation;
        }
        /**
         * Resets the runtime animation to the beginning
         * @param restoreOriginal defines whether to restore the target property to the original value
         */
        reset(restoreOriginal = false) {
            if (restoreOriginal) {
                if (this._target instanceof Array) {
                    let index = 0;
                    for (const target of this._target) {
                        if (this._originalValue[index] !== undefined) {
                            this._setValue(target, this._activeTargets[index], this._originalValue[index], -1, index);
                        }
                        index++;
                    }
                }
                else {
                    if (this._originalValue[0] !== undefined) {
                        this._setValue(this._target, this._directTarget, this._originalValue[0], -1, 0);
                    }
                }
            }
            this._offsetsCache = {};
            this._highLimitsCache = {};
            this._currentFrame = 0;
            this._blendingFactor = 0;
            // Events
            for (let index = 0; index < this._events.length; index++) {
                this._events[index].isDone = false;
            }
        }
        /**
         * Specifies if the runtime animation is stopped
         * @returns Boolean specifying if the runtime animation is stopped
         */
        isStopped() {
            return this._stopped;
        }
        /**
         * Disposes of the runtime animation
         */
        dispose() {
            const index = this._animation.runtimeAnimations.indexOf(this);
            if (index > -1) {
                this._animation.runtimeAnimations.splice(index, 1);
            }
        }
        /**
         * Apply the interpolated value to the target
         * @param currentValue defines the value computed by the animation
         * @param weight defines the weight to apply to this value (Defaults to 1.0)
         */
        setValue(currentValue, weight) {
            if (this._targetIsArray) {
                for (let index = 0; index < this._target.length; index++) {
                    const target = this._target[index];
                    this._setValue(target, this._activeTargets[index], currentValue, weight, index);
                }
                return;
            }
            this._setValue(this._target, this._directTarget, currentValue, weight, 0);
        }
        _getOriginalValues(targetIndex = 0) {
            let originalValue;
            const target = this._activeTargets[targetIndex];
            if (target.getRestPose && this._targetPath === "_matrix") {
                // For bones
                originalValue = target.getRestPose();
            }
            else {
                originalValue = target[this._targetPath];
            }
            if (originalValue && originalValue.clone) {
                this._originalValue[targetIndex] = originalValue.clone();
            }
            else {
                this._originalValue[targetIndex] = originalValue;
            }
        }
        _setValue(target, destination, currentValue, weight, targetIndex) {
            // Set value
            this._currentActiveTarget = destination;
            this._weight = weight;
            if (this._enableBlending && this._blendingFactor <= 1.0) {
                if (!this._originalBlendValue) {
                    const originalValue = destination[this._targetPath];
                    if (originalValue.clone) {
                        this._originalBlendValue = originalValue.clone();
                    }
                    else {
                        this._originalBlendValue = originalValue;
                    }
                }
                if (this._originalBlendValue.m) {
                    // Matrix
                    if (Animation.AllowMatrixDecomposeForInterpolation) {
                        if (this._currentValue) {
                            Matrix.DecomposeLerpToRef(this._originalBlendValue, currentValue, this._blendingFactor, this._currentValue);
                        }
                        else {
                            this._currentValue = Matrix.DecomposeLerp(this._originalBlendValue, currentValue, this._blendingFactor);
                        }
                    }
                    else {
                        if (this._currentValue) {
                            Matrix.LerpToRef(this._originalBlendValue, currentValue, this._blendingFactor, this._currentValue);
                        }
                        else {
                            this._currentValue = Matrix.Lerp(this._originalBlendValue, currentValue, this._blendingFactor);
                        }
                    }
                }
                else {
                    this._currentValue = Animation._UniversalLerp(this._originalBlendValue, currentValue, this._blendingFactor);
                }
                const blendingSpeed = target && target.animationPropertiesOverride ? target.animationPropertiesOverride.blendingSpeed : this._animation.blendingSpeed;
                this._blendingFactor += blendingSpeed;
            }
            else {
                if (!this._currentValue) {
                    if (currentValue === null || currentValue === void 0 ? void 0 : currentValue.clone) {
                        this._currentValue = currentValue.clone();
                    }
                    else {
                        this._currentValue = currentValue;
                    }
                }
                else if (this._currentValue.copyFrom) {
                    this._currentValue.copyFrom(currentValue);
                }
                else {
                    this._currentValue = currentValue;
                }
            }
            if (weight !== -1.0) {
                this._scene._registerTargetForLateAnimationBinding(this, this._originalValue[targetIndex]);
            }
            else {
                destination[this._targetPath] = this._currentValue;
            }
            if (target.markAsDirty) {
                target.markAsDirty(this._animation.targetProperty);
            }
        }
        /**
         * Gets the loop pmode of the runtime animation
         * @returns Loop Mode
         */
        _getCorrectLoopMode() {
            if (this._target && this._target.animationPropertiesOverride) {
                return this._target.animationPropertiesOverride.loopMode;
            }
            return this._animation.loopMode;
        }
        /**
         * Move the current animation to a given frame
         * @param frame defines the frame to move to
         */
        goToFrame(frame) {
            const keys = this._animation.getKeys();
            if (frame < keys[0].frame) {
                frame = keys[0].frame;
            }
            else if (frame > keys[keys.length - 1].frame) {
                frame = keys[keys.length - 1].frame;
            }
            // Need to reset animation events
            const events = this._events;
            if (events.length) {
                for (let index = 0; index < events.length; index++) {
                    if (!events[index].onlyOnce) {
                        // reset events in the future
                        events[index].isDone = events[index].frame < frame;
                    }
                }
            }
            this._currentFrame = frame;
            const currentValue = this._animation._interpolate(frame, this._animationState);
            this.setValue(currentValue, -1);
        }
        /**
         * @internal Internal use only
         */
        _prepareForSpeedRatioChange(newSpeedRatio) {
            const newAbsoluteFrame = (this._previousElapsedTime * (this._animation.framePerSecond * newSpeedRatio)) / 1000.0;
            this._absoluteFrameOffset = this._previousAbsoluteFrame - newAbsoluteFrame;
        }
        /**
         * Execute the current animation
         * @param elapsedTimeSinceAnimationStart defines the elapsed time (in milliseconds) since the animation was started
         * @param from defines the lower frame of the animation range
         * @param to defines the upper frame of the animation range
         * @param loop defines if the current animation must loop
         * @param speedRatio defines the current speed ratio
         * @param weight defines the weight of the animation (default is -1 so no weight)
         * @returns a boolean indicating if the animation is running
         */
        animate(elapsedTimeSinceAnimationStart, from, to, loop, speedRatio, weight = -1.0) {
            const animation = this._animation;
            const targetPropertyPath = animation.targetPropertyPath;
            if (!targetPropertyPath || targetPropertyPath.length < 1) {
                this._stopped = true;
                return false;
            }
            let returnValue = true;
            // Check limits
            if (from < this._minFrame || from > this._maxFrame) {
                from = this._minFrame;
            }
            if (to < this._minFrame || to > this._maxFrame) {
                to = this._maxFrame;
            }
            const frameRange = to - from;
            let offsetValue;
            // Compute the frame according to the elapsed time and the fps of the animation ("from" and "to" are not factored in!)
            let absoluteFrame = (elapsedTimeSinceAnimationStart * (animation.framePerSecond * speedRatio)) / 1000.0 + this._absoluteFrameOffset;
            let highLimitValue = 0;
            // Apply the yoyo function if required
            if (loop && this._animationState.loopMode === Animation.ANIMATIONLOOPMODE_YOYO) {
                const position = (absoluteFrame - from) / frameRange;
                // Apply the yoyo curve
                const yoyoPosition = Math.abs(Math.sin(position * Math.PI));
                // Map the yoyo position back to the range
                absoluteFrame = yoyoPosition * frameRange + from;
            }
            this._previousElapsedTime = elapsedTimeSinceAnimationStart;
            this._previousAbsoluteFrame = absoluteFrame;
            if (!loop && to >= from && absoluteFrame >= frameRange) {
                // If we are out of range and not looping get back to caller
                returnValue = false;
                highLimitValue = animation._getKeyValue(this._maxValue);
            }
            else if (!loop && from >= to && absoluteFrame <= frameRange) {
                returnValue = false;
                highLimitValue = animation._getKeyValue(this._minValue);
            }
            else if (this._animationState.loopMode !== Animation.ANIMATIONLOOPMODE_CYCLE) {
                const keyOffset = to.toString() + from.toString();
                if (!this._offsetsCache[keyOffset]) {
                    this._animationState.repeatCount = 0;
                    this._animationState.loopMode = Animation.ANIMATIONLOOPMODE_CYCLE; // force a specific codepath in animation._interpolate()!
                    const fromValue = animation._interpolate(from, this._animationState);
                    const toValue = animation._interpolate(to, this._animationState);
                    this._animationState.loopMode = this._getCorrectLoopMode();
                    switch (animation.dataType) {
                        // Float
                        case Animation.ANIMATIONTYPE_FLOAT:
                            this._offsetsCache[keyOffset] = toValue - fromValue;
                            break;
                        // Quaternion
                        case Animation.ANIMATIONTYPE_QUATERNION:
                            this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                            break;
                        // Vector3
                        case Animation.ANIMATIONTYPE_VECTOR3:
                            this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                            break;
                        // Vector2
                        case Animation.ANIMATIONTYPE_VECTOR2:
                            this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                            break;
                        // Size
                        case Animation.ANIMATIONTYPE_SIZE:
                            this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                            break;
                        // Color3
                        case Animation.ANIMATIONTYPE_COLOR3:
                            this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                            break;
                    }
                    this._highLimitsCache[keyOffset] = toValue;
                }
                highLimitValue = this._highLimitsCache[keyOffset];
                offsetValue = this._offsetsCache[keyOffset];
            }
            if (offsetValue === undefined) {
                switch (animation.dataType) {
                    // Float
                    case Animation.ANIMATIONTYPE_FLOAT:
                        offsetValue = 0;
                        break;
                    // Quaternion
                    case Animation.ANIMATIONTYPE_QUATERNION:
                        offsetValue = _staticOffsetValueQuaternion;
                        break;
                    // Vector3
                    case Animation.ANIMATIONTYPE_VECTOR3:
                        offsetValue = _staticOffsetValueVector3;
                        break;
                    // Vector2
                    case Animation.ANIMATIONTYPE_VECTOR2:
                        offsetValue = _staticOffsetValueVector2;
                        break;
                    // Size
                    case Animation.ANIMATIONTYPE_SIZE:
                        offsetValue = _staticOffsetValueSize;
                        break;
                    // Color3
                    case Animation.ANIMATIONTYPE_COLOR3:
                        offsetValue = _staticOffsetValueColor3;
                }
            }
            // Compute value
            let currentFrame;
            if (this._host && this._host.syncRoot) {
                // If we must sync with an animatable, calculate the current frame based on the frame of the root animatable
                const syncRoot = this._host.syncRoot;
                const hostNormalizedFrame = (syncRoot.masterFrame - syncRoot.fromFrame) / (syncRoot.toFrame - syncRoot.fromFrame);
                currentFrame = from + frameRange * hostNormalizedFrame;
            }
            else {
                if ((absoluteFrame > 0 && from > to) || (absoluteFrame < 0 && from < to)) {
                    currentFrame = returnValue && frameRange !== 0 ? to + (absoluteFrame % frameRange) : from;
                }
                else {
                    currentFrame = returnValue && frameRange !== 0 ? from + (absoluteFrame % frameRange) : to;
                }
            }
            const events = this._events;
            // Reset event/state if looping
            if ((speedRatio > 0 && this.currentFrame > currentFrame) || (speedRatio < 0 && this.currentFrame < currentFrame)) {
                this._onLoop();
                // Need to reset animation events
                for (let index = 0; index < events.length; index++) {
                    if (!events[index].onlyOnce) {
                        // reset event, the animation is looping
                        events[index].isDone = false;
                    }
                }
                this._animationState.key = speedRatio > 0 ? 0 : animation.getKeys().length - 1;
            }
            this._currentFrame = currentFrame;
            this._animationState.repeatCount = frameRange === 0 ? 0 : (absoluteFrame / frameRange) >> 0;
            this._animationState.highLimitValue = highLimitValue;
            this._animationState.offsetValue = offsetValue;
            const currentValue = animation._interpolate(currentFrame, this._animationState);
            // Set value
            this.setValue(currentValue, weight);
            // Check events
            if (events.length) {
                for (let index = 0; index < events.length; index++) {
                    // Make sure current frame has passed event frame and that event frame is within the current range
                    // Also, handle both forward and reverse animations
                    if ((frameRange > 0 && currentFrame >= events[index].frame && events[index].frame >= from) ||
                        (frameRange < 0 && currentFrame <= events[index].frame && events[index].frame <= from)) {
                        const event = events[index];
                        if (!event.isDone) {
                            // If event should be done only once, remove it.
                            if (event.onlyOnce) {
                                events.splice(index, 1);
                                index--;
                            }
                            event.isDone = true;
                            event.action(currentFrame);
                        } // Don't do anything if the event has already been done.
                    }
                }
            }
            if (!returnValue) {
                this._stopped = true;
            }
            return returnValue;
        }
    }

    /**
     * Class used to store bone information
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
     */
    class Bone extends Node {
        /** @internal */
        get _matrix() {
            this._compose();
            return this._localMatrix;
        }
        /** @internal */
        set _matrix(value) {
            // skip if the matrices are the same
            if (value.updateFlag === this._localMatrix.updateFlag && !this._needToCompose) {
                return;
            }
            this._needToCompose = false; // in case there was a pending compose
            this._localMatrix.copyFrom(value);
            this._markAsDirtyAndDecompose();
        }
        /**
         * Create a new bone
         * @param name defines the bone name
         * @param skeleton defines the parent skeleton
         * @param parentBone defines the parent (can be null if the bone is the root)
         * @param localMatrix defines the local matrix (default: identity)
         * @param restMatrix defines the rest matrix (default: localMatrix)
         * @param bindMatrix defines the bind matrix (default: localMatrix)
         * @param index defines index of the bone in the hierarchy (default: null)
         */
        constructor(
        /**
         * defines the bone name
         */
        name, skeleton, parentBone = null, localMatrix = null, restMatrix = null, bindMatrix = null, index = null) {
            var _a;
            super(name, skeleton.getScene());
            this.name = name;
            /**
             * Gets the list of child bones
             */
            this.children = new Array();
            /** Gets the animations associated with this bone */
            this.animations = new Array();
            /**
             * @internal Internal only
             * Set this value to map this bone to a different index in the transform matrices
             * Set this value to -1 to exclude the bone from the transform matrices
             */
            this._index = null;
            this._scalingDeterminant = 1;
            this._needToDecompose = true;
            this._needToCompose = false;
            /** @internal */
            this._linkedTransformNode = null;
            /** @internal */
            this._waitingTransformNodeId = null;
            this._skeleton = skeleton;
            this._localMatrix = (_a = localMatrix === null || localMatrix === void 0 ? void 0 : localMatrix.clone()) !== null && _a !== void 0 ? _a : Matrix.Identity();
            this._restMatrix = restMatrix !== null && restMatrix !== void 0 ? restMatrix : this._localMatrix.clone();
            this._bindMatrix = bindMatrix !== null && bindMatrix !== void 0 ? bindMatrix : this._localMatrix.clone();
            this._index = index;
            this._absoluteMatrix = new Matrix();
            this._absoluteBindMatrix = new Matrix();
            this._absoluteInverseBindMatrix = new Matrix();
            this._finalMatrix = new Matrix();
            skeleton.bones.push(this);
            this.setParent(parentBone, false);
            this._updateAbsoluteBindMatrices();
        }
        /**
         * Gets the current object class name.
         * @returns the class name
         */
        getClassName() {
            return "Bone";
        }
        // Members
        /**
         * Gets the parent skeleton
         * @returns a skeleton
         */
        getSkeleton() {
            return this._skeleton;
        }
        get parent() {
            return this._parentNode;
        }
        /**
         * Gets parent bone
         * @returns a bone or null if the bone is the root of the bone hierarchy
         */
        getParent() {
            return this.parent;
        }
        /**
         * Returns an array containing the children of the bone
         * @returns an array containing the children of the bone (can be empty if the bone has no children)
         */
        getChildren() {
            return this.children;
        }
        /**
         * Gets the node index in matrix array generated for rendering
         * @returns the node index
         */
        getIndex() {
            return this._index === null ? this.getSkeleton().bones.indexOf(this) : this._index;
        }
        set parent(newParent) {
            this.setParent(newParent);
        }
        /**
         * Sets the parent bone
         * @param parent defines the parent (can be null if the bone is the root)
         * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be updated
         */
        setParent(parent, updateAbsoluteBindMatrices = true) {
            if (this.parent === parent) {
                return;
            }
            if (this.parent) {
                const index = this.parent.children.indexOf(this);
                if (index !== -1) {
                    this.parent.children.splice(index, 1);
                }
            }
            this._parentNode = parent;
            if (this.parent) {
                this.parent.children.push(this);
            }
            if (updateAbsoluteBindMatrices) {
                this._updateAbsoluteBindMatrices();
            }
            this.markAsDirty();
        }
        /**
         * Gets the local matrix
         * @returns the local matrix
         */
        getLocalMatrix() {
            this._compose();
            return this._localMatrix;
        }
        /**
         * Gets the bind matrix
         * @returns the bind matrix
         */
        getBindMatrix() {
            return this._bindMatrix;
        }
        /**
         * Gets the bind matrix.
         * @returns the bind matrix
         * @deprecated Please use getBindMatrix instead
         */
        getBaseMatrix() {
            return this.getBindMatrix();
        }
        /**
         * Gets the rest matrix
         * @returns the rest matrix
         */
        getRestMatrix() {
            return this._restMatrix;
        }
        /**
         * Gets the rest matrix
         * @returns the rest matrix
         * @deprecated Please use getRestMatrix instead
         */
        getRestPose() {
            return this.getRestMatrix();
        }
        /**
         * Sets the rest matrix
         * @param matrix the local-space rest matrix to set for this bone
         */
        setRestMatrix(matrix) {
            this._restMatrix.copyFrom(matrix);
        }
        /**
         * Sets the rest matrix
         * @param matrix the local-space rest to set for this bone
         * @deprecated Please use setRestMatrix instead
         */
        setRestPose(matrix) {
            this.setRestMatrix(matrix);
        }
        /**
         * Gets the bind matrix
         * @returns the bind matrix
         * @deprecated Please use getBindMatrix instead
         */
        getBindPose() {
            return this.getBindMatrix();
        }
        /**
         * Sets the bind matrix
         * This will trigger a recomputation of the absolute bind and absolute inverse bind matrices for this bone and its children
         * Note that the local matrix will also be set with the matrix passed in parameter!
         * @param matrix the local-space bind matrix to set for this bone
         */
        setBindMatrix(matrix) {
            this.updateMatrix(matrix);
        }
        /**
         * Sets the bind matrix
         * @param matrix the local-space bind to set for this bone
         * @deprecated Please use setBindMatrix instead
         */
        setBindPose(matrix) {
            this.setBindMatrix(matrix);
        }
        /**
         * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
         */
        getFinalMatrix() {
            return this._finalMatrix;
        }
        /**
         * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
         * @deprecated Please use getFinalMatrix instead
         */
        getWorldMatrix() {
            return this.getFinalMatrix();
        }
        /**
         * Sets the local matrix to the rest matrix
         */
        returnToRest() {
            var _a;
            if (this._linkedTransformNode) {
                const localScaling = TmpVectors.Vector3[0];
                const localRotation = TmpVectors.Quaternion[0];
                const localPosition = TmpVectors.Vector3[1];
                this.getRestMatrix().decompose(localScaling, localRotation, localPosition);
                this._linkedTransformNode.position.copyFrom(localPosition);
                this._linkedTransformNode.rotationQuaternion = (_a = this._linkedTransformNode.rotationQuaternion) !== null && _a !== void 0 ? _a : Quaternion.Identity();
                this._linkedTransformNode.rotationQuaternion.copyFrom(localRotation);
                this._linkedTransformNode.scaling.copyFrom(localScaling);
            }
            else {
                this._matrix = this._restMatrix;
            }
        }
        /**
         * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
         * @returns the inverse bind matrix, in world space
         */
        getAbsoluteInverseBindMatrix() {
            return this._absoluteInverseBindMatrix;
        }
        /**
         * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
         * @returns the inverse bind matrix, in world space
         * @deprecated Please use getAbsoluteInverseBindMatrix instead
         */
        getInvertedAbsoluteTransform() {
            return this.getAbsoluteInverseBindMatrix();
        }
        /**
         * Gets the bone matrix, in world space (relative to the skeleton root)
         * @returns the bone matrix, in world space
         */
        getAbsoluteMatrix() {
            return this._absoluteMatrix;
        }
        /**
         * Gets the bone matrix, in world space (relative to the skeleton root)
         * @returns the bone matrix, in world space
         * @deprecated Please use getAbsoluteMatrix instead
         */
        getAbsoluteTransform() {
            return this._absoluteMatrix;
        }
        /**
         * Links with the given transform node.
         * The local matrix of this bone is overwritten by the transform of the node every frame.
         * @param transformNode defines the transform node to link to
         */
        linkTransformNode(transformNode) {
            if (this._linkedTransformNode) {
                this._skeleton._numBonesWithLinkedTransformNode--;
            }
            this._linkedTransformNode = transformNode;
            if (this._linkedTransformNode) {
                this._skeleton._numBonesWithLinkedTransformNode++;
            }
        }
        // Properties (matches TransformNode properties)
        /**
         * Gets the node used to drive the bone's transformation
         * @returns a transform node or null
         */
        getTransformNode() {
            return this._linkedTransformNode;
        }
        /** Gets or sets current position (in local space) */
        get position() {
            this._decompose();
            return this._localPosition;
        }
        set position(newPosition) {
            this._decompose();
            this._localPosition.copyFrom(newPosition);
            this._markAsDirtyAndCompose();
        }
        /** Gets or sets current rotation (in local space) */
        get rotation() {
            return this.getRotation();
        }
        set rotation(newRotation) {
            this.setRotation(newRotation);
        }
        /** Gets or sets current rotation quaternion (in local space) */
        get rotationQuaternion() {
            this._decompose();
            return this._localRotation;
        }
        set rotationQuaternion(newRotation) {
            this.setRotationQuaternion(newRotation);
        }
        /** Gets or sets current scaling (in local space) */
        get scaling() {
            return this.getScale();
        }
        set scaling(newScaling) {
            this.setScale(newScaling);
        }
        /**
         * Gets the animation properties override
         */
        get animationPropertiesOverride() {
            return this._skeleton.animationPropertiesOverride;
        }
        // Methods
        _decompose() {
            if (!this._needToDecompose) {
                return;
            }
            this._needToDecompose = false;
            if (!this._localScaling) {
                this._localScaling = Vector3.Zero();
                this._localRotation = Quaternion.Zero();
                this._localPosition = Vector3.Zero();
            }
            this._localMatrix.decompose(this._localScaling, this._localRotation, this._localPosition);
        }
        _compose() {
            if (!this._needToCompose) {
                return;
            }
            if (!this._localScaling) {
                this._needToCompose = false;
                return;
            }
            this._needToCompose = false;
            Matrix.ComposeToRef(this._localScaling, this._localRotation, this._localPosition, this._localMatrix);
        }
        /**
         * Update the bind (and optionally the local) matrix
         * @param bindMatrix defines the new matrix to set to the bind/local matrix, in local space
         * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be recomputed (default: true)
         * @param updateLocalMatrix defines if the local matrix should also be updated with the matrix passed in parameter (default: true)
         */
        updateMatrix(bindMatrix, updateAbsoluteBindMatrices = true, updateLocalMatrix = true) {
            this._bindMatrix.copyFrom(bindMatrix);
            if (updateAbsoluteBindMatrices) {
                this._updateAbsoluteBindMatrices();
            }
            if (updateLocalMatrix) {
                this._matrix = bindMatrix;
            }
            else {
                this.markAsDirty();
            }
        }
        /**
         * @internal
         */
        _updateAbsoluteBindMatrices(bindMatrix, updateChildren = true) {
            if (!bindMatrix) {
                bindMatrix = this._bindMatrix;
            }
            if (this.parent) {
                bindMatrix.multiplyToRef(this.parent._absoluteBindMatrix, this._absoluteBindMatrix);
            }
            else {
                this._absoluteBindMatrix.copyFrom(bindMatrix);
            }
            this._absoluteBindMatrix.invertToRef(this._absoluteInverseBindMatrix);
            if (updateChildren) {
                for (let index = 0; index < this.children.length; index++) {
                    this.children[index]._updateAbsoluteBindMatrices();
                }
            }
            this._scalingDeterminant = this._absoluteBindMatrix.determinant() < 0 ? -1 : 1;
        }
        /**
         * Flag the bone as dirty (Forcing it to update everything)
         * @returns this bone
         */
        markAsDirty() {
            this._currentRenderId++;
            this._childUpdateId++;
            this._skeleton._markAsDirty();
            return this;
        }
        /** @internal */
        _markAsDirtyAndCompose() {
            this.markAsDirty();
            this._needToCompose = true;
        }
        _markAsDirtyAndDecompose() {
            this.markAsDirty();
            this._needToDecompose = true;
        }
        _updatePosition(vec, space = Space.LOCAL, tNode, translationMode = true) {
            const lm = this.getLocalMatrix();
            if (space == Space.LOCAL) {
                if (translationMode) {
                    lm.addAtIndex(12, vec.x);
                    lm.addAtIndex(13, vec.y);
                    lm.addAtIndex(14, vec.z);
                }
                else {
                    lm.setTranslationFromFloats(vec.x, vec.y, vec.z);
                }
            }
            else {
                let wm = null;
                //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
                if (tNode) {
                    wm = tNode.getWorldMatrix();
                }
                this._skeleton.computeAbsoluteMatrices();
                const tmat = Bone._TmpMats[0];
                const tvec = Bone._TmpVecs[0];
                if (this.parent) {
                    if (tNode && wm) {
                        tmat.copyFrom(this.parent.getAbsoluteMatrix());
                        tmat.multiplyToRef(wm, tmat);
                    }
                    else {
                        tmat.copyFrom(this.parent.getAbsoluteMatrix());
                    }
                }
                else {
                    Matrix.IdentityToRef(tmat);
                }
                if (translationMode) {
                    tmat.setTranslationFromFloats(0, 0, 0);
                }
                tmat.invert();
                Vector3.TransformCoordinatesToRef(vec, tmat, tvec);
                if (translationMode) {
                    lm.addAtIndex(12, tvec.x);
                    lm.addAtIndex(13, tvec.y);
                    lm.addAtIndex(14, tvec.z);
                }
                else {
                    lm.setTranslationFromFloats(tvec.x, tvec.y, tvec.z);
                }
            }
            this._markAsDirtyAndDecompose();
        }
        /**
         * Translate the bone in local or world space
         * @param vec The amount to translate the bone
         * @param space The space that the translation is in (default: Space.LOCAL)
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        translate(vec, space = Space.LOCAL, tNode) {
            this._updatePosition(vec, space, tNode, true);
        }
        /**
         * Set the position of the bone in local or world space
         * @param position The position to set the bone
         * @param space The space that the position is in (default: Space.LOCAL)
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setPosition(position, space = Space.LOCAL, tNode) {
            this._updatePosition(position, space, tNode, false);
        }
        /**
         * Set the absolute position of the bone (world space)
         * @param position The position to set the bone
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setAbsolutePosition(position, tNode) {
            this.setPosition(position, Space.WORLD, tNode);
        }
        /**
         * Scale the bone on the x, y and z axes (in local space)
         * @param x The amount to scale the bone on the x axis
         * @param y The amount to scale the bone on the y axis
         * @param z The amount to scale the bone on the z axis
         * @param scaleChildren sets this to true if children of the bone should be scaled as well (false by default)
         */
        scale(x, y, z, scaleChildren = false) {
            const locMat = this.getLocalMatrix();
            // Apply new scaling on top of current local matrix
            const scaleMat = Bone._TmpMats[0];
            Matrix.ScalingToRef(x, y, z, scaleMat);
            scaleMat.multiplyToRef(locMat, locMat);
            // Invert scaling matrix and apply the inverse to all children
            scaleMat.invert();
            for (const child of this.children) {
                const cm = child.getLocalMatrix();
                cm.multiplyToRef(scaleMat, cm);
                cm.multiplyAtIndex(12, x);
                cm.multiplyAtIndex(13, y);
                cm.multiplyAtIndex(14, z);
                child._markAsDirtyAndDecompose();
            }
            this._markAsDirtyAndDecompose();
            if (scaleChildren) {
                for (const child of this.children) {
                    child.scale(x, y, z, scaleChildren);
                }
            }
        }
        /**
         * Set the bone scaling in local space
         * @param scale defines the scaling vector
         */
        setScale(scale) {
            this._decompose();
            this._localScaling.copyFrom(scale);
            this._markAsDirtyAndCompose();
        }
        /**
         * Gets the current scaling in local space
         * @returns the current scaling vector
         */
        getScale() {
            this._decompose();
            return this._localScaling;
        }
        /**
         * Gets the current scaling in local space and stores it in a target vector
         * @param result defines the target vector
         */
        getScaleToRef(result) {
            this._decompose();
            result.copyFrom(this._localScaling);
        }
        /**
         * Set the yaw, pitch, and roll of the bone in local or world space
         * @param yaw The rotation of the bone on the y axis
         * @param pitch The rotation of the bone on the x axis
         * @param roll The rotation of the bone on the z axis
         * @param space The space that the axes of rotation are in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setYawPitchRoll(yaw, pitch, roll, space = Space.LOCAL, tNode) {
            if (space === Space.LOCAL) {
                const quat = Bone._TmpQuat;
                Quaternion.RotationYawPitchRollToRef(yaw, pitch, roll, quat);
                this.setRotationQuaternion(quat, space, tNode);
                return;
            }
            const rotMatInv = Bone._TmpMats[0];
            if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) {
                return;
            }
            const rotMat = Bone._TmpMats[1];
            Matrix.RotationYawPitchRollToRef(yaw, pitch, roll, rotMat);
            rotMatInv.multiplyToRef(rotMat, rotMat);
            this._rotateWithMatrix(rotMat, space, tNode);
        }
        /**
         * Add a rotation to the bone on an axis in local or world space
         * @param axis The axis to rotate the bone on
         * @param amount The amount to rotate the bone
         * @param space The space that the axis is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        rotate(axis, amount, space = Space.LOCAL, tNode) {
            const rmat = Bone._TmpMats[0];
            rmat.setTranslationFromFloats(0, 0, 0);
            Matrix.RotationAxisToRef(axis, amount, rmat);
            this._rotateWithMatrix(rmat, space, tNode);
        }
        /**
         * Set the rotation of the bone to a particular axis angle in local or world space
         * @param axis The axis to rotate the bone on
         * @param angle The angle that the bone should be rotated to
         * @param space The space that the axis is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setAxisAngle(axis, angle, space = Space.LOCAL, tNode) {
            if (space === Space.LOCAL) {
                const quat = Bone._TmpQuat;
                Quaternion.RotationAxisToRef(axis, angle, quat);
                this.setRotationQuaternion(quat, space, tNode);
                return;
            }
            const rotMatInv = Bone._TmpMats[0];
            if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) {
                return;
            }
            const rotMat = Bone._TmpMats[1];
            Matrix.RotationAxisToRef(axis, angle, rotMat);
            rotMatInv.multiplyToRef(rotMat, rotMat);
            this._rotateWithMatrix(rotMat, space, tNode);
        }
        /**
         * Set the euler rotation of the bone in local or world space
         * @param rotation The euler rotation that the bone should be set to
         * @param space The space that the rotation is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setRotation(rotation, space = Space.LOCAL, tNode) {
            this.setYawPitchRoll(rotation.y, rotation.x, rotation.z, space, tNode);
        }
        /**
         * Set the quaternion rotation of the bone in local or world space
         * @param quat The quaternion rotation that the bone should be set to
         * @param space The space that the rotation is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setRotationQuaternion(quat, space = Space.LOCAL, tNode) {
            if (space === Space.LOCAL) {
                this._decompose();
                this._localRotation.copyFrom(quat);
                this._markAsDirtyAndCompose();
                return;
            }
            const rotMatInv = Bone._TmpMats[0];
            if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) {
                return;
            }
            const rotMat = Bone._TmpMats[1];
            Matrix.FromQuaternionToRef(quat, rotMat);
            rotMatInv.multiplyToRef(rotMat, rotMat);
            this._rotateWithMatrix(rotMat, space, tNode);
        }
        /**
         * Set the rotation matrix of the bone in local or world space
         * @param rotMat The rotation matrix that the bone should be set to
         * @param space The space that the rotation is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         */
        setRotationMatrix(rotMat, space = Space.LOCAL, tNode) {
            if (space === Space.LOCAL) {
                const quat = Bone._TmpQuat;
                Quaternion.FromRotationMatrixToRef(rotMat, quat);
                this.setRotationQuaternion(quat, space, tNode);
                return;
            }
            const rotMatInv = Bone._TmpMats[0];
            if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) {
                return;
            }
            const rotMat2 = Bone._TmpMats[1];
            rotMat2.copyFrom(rotMat);
            rotMatInv.multiplyToRef(rotMat, rotMat2);
            this._rotateWithMatrix(rotMat2, space, tNode);
        }
        _rotateWithMatrix(rmat, space = Space.LOCAL, tNode) {
            const lmat = this.getLocalMatrix();
            const lx = lmat.m[12];
            const ly = lmat.m[13];
            const lz = lmat.m[14];
            const parent = this.getParent();
            const parentScale = Bone._TmpMats[3];
            const parentScaleInv = Bone._TmpMats[4];
            if (parent && space == Space.WORLD) {
                if (tNode) {
                    parentScale.copyFrom(tNode.getWorldMatrix());
                    parent.getAbsoluteMatrix().multiplyToRef(parentScale, parentScale);
                }
                else {
                    parentScale.copyFrom(parent.getAbsoluteMatrix());
                }
                parentScaleInv.copyFrom(parentScale);
                parentScaleInv.invert();
                lmat.multiplyToRef(parentScale, lmat);
                lmat.multiplyToRef(rmat, lmat);
                lmat.multiplyToRef(parentScaleInv, lmat);
            }
            else {
                if (space == Space.WORLD && tNode) {
                    parentScale.copyFrom(tNode.getWorldMatrix());
                    parentScaleInv.copyFrom(parentScale);
                    parentScaleInv.invert();
                    lmat.multiplyToRef(parentScale, lmat);
                    lmat.multiplyToRef(rmat, lmat);
                    lmat.multiplyToRef(parentScaleInv, lmat);
                }
                else {
                    lmat.multiplyToRef(rmat, lmat);
                }
            }
            lmat.setTranslationFromFloats(lx, ly, lz);
            this.computeAbsoluteMatrices();
            this._markAsDirtyAndDecompose();
        }
        _getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode) {
            const scaleMatrix = Bone._TmpMats[2];
            rotMatInv.copyFrom(this.getAbsoluteMatrix());
            if (tNode) {
                rotMatInv.multiplyToRef(tNode.getWorldMatrix(), rotMatInv);
                Matrix.ScalingToRef(tNode.scaling.x, tNode.scaling.y, tNode.scaling.z, scaleMatrix);
            }
            else {
                Matrix.IdentityToRef(scaleMatrix);
            }
            rotMatInv.invert();
            if (isNaN(rotMatInv.m[0])) {
                // Matrix failed to invert.
                // This can happen if scale is zero for example.
                return false;
            }
            scaleMatrix.multiplyAtIndex(0, this._scalingDeterminant);
            rotMatInv.multiplyToRef(scaleMatrix, rotMatInv);
            return true;
        }
        /**
         * Get the position of the bone in local or world space
         * @param space The space that the returned position is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The position of the bone
         */
        getPosition(space = Space.LOCAL, tNode = null) {
            const pos = Vector3.Zero();
            this.getPositionToRef(space, tNode, pos);
            return pos;
        }
        /**
         * Copy the position of the bone to a vector3 in local or world space
         * @param space The space that the returned position is in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The vector3 to copy the position to
         */
        getPositionToRef(space = Space.LOCAL, tNode, result) {
            if (space == Space.LOCAL) {
                const lm = this.getLocalMatrix();
                result.x = lm.m[12];
                result.y = lm.m[13];
                result.z = lm.m[14];
            }
            else {
                let wm = null;
                //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
                if (tNode) {
                    wm = tNode.getWorldMatrix();
                }
                this._skeleton.computeAbsoluteMatrices();
                let tmat = Bone._TmpMats[0];
                if (tNode && wm) {
                    tmat.copyFrom(this.getAbsoluteMatrix());
                    tmat.multiplyToRef(wm, tmat);
                }
                else {
                    tmat = this.getAbsoluteMatrix();
                }
                result.x = tmat.m[12];
                result.y = tmat.m[13];
                result.z = tmat.m[14];
            }
        }
        /**
         * Get the absolute position of the bone (world space)
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The absolute position of the bone
         */
        getAbsolutePosition(tNode = null) {
            const pos = Vector3.Zero();
            this.getPositionToRef(Space.WORLD, tNode, pos);
            return pos;
        }
        /**
         * Copy the absolute position of the bone (world space) to the result param
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The vector3 to copy the absolute position to
         */
        getAbsolutePositionToRef(tNode, result) {
            this.getPositionToRef(Space.WORLD, tNode, result);
        }
        /**
         * Compute the absolute matrices of this bone and its children
         */
        computeAbsoluteMatrices() {
            this._compose();
            if (this.parent) {
                this._localMatrix.multiplyToRef(this.parent._absoluteMatrix, this._absoluteMatrix);
            }
            else {
                this._absoluteMatrix.copyFrom(this._localMatrix);
                const poseMatrix = this._skeleton.getPoseMatrix();
                if (poseMatrix) {
                    this._absoluteMatrix.multiplyToRef(poseMatrix, this._absoluteMatrix);
                }
            }
            const children = this.children;
            const len = children.length;
            for (let i = 0; i < len; i++) {
                children[i].computeAbsoluteMatrices();
            }
        }
        /**
         * Compute the absolute matrices of this bone and its children
         * @deprecated Please use computeAbsoluteMatrices instead
         */
        computeAbsoluteTransforms() {
            this.computeAbsoluteMatrices();
        }
        /**
         * Get the world direction from an axis that is in the local space of the bone
         * @param localAxis The local direction that is used to compute the world direction
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The world direction
         */
        getDirection(localAxis, tNode = null) {
            const result = Vector3.Zero();
            this.getDirectionToRef(localAxis, tNode, result);
            return result;
        }
        /**
         * Copy the world direction to a vector3 from an axis that is in the local space of the bone
         * @param localAxis The local direction that is used to compute the world direction
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The vector3 that the world direction will be copied to
         */
        getDirectionToRef(localAxis, tNode = null, result) {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) {
                wm = tNode.getWorldMatrix();
            }
            this._skeleton.computeAbsoluteMatrices();
            const mat = Bone._TmpMats[0];
            mat.copyFrom(this.getAbsoluteMatrix());
            if (tNode && wm) {
                mat.multiplyToRef(wm, mat);
            }
            Vector3.TransformNormalToRef(localAxis, mat, result);
            result.normalize();
        }
        /**
         * Get the euler rotation of the bone in local or world space
         * @param space The space that the rotation should be in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The euler rotation
         */
        getRotation(space = Space.LOCAL, tNode = null) {
            const result = Vector3.Zero();
            this.getRotationToRef(space, tNode, result);
            return result;
        }
        /**
         * Copy the euler rotation of the bone to a vector3.  The rotation can be in either local or world space
         * @param space The space that the rotation should be in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The vector3 that the rotation should be copied to
         */
        getRotationToRef(space = Space.LOCAL, tNode = null, result) {
            const quat = Bone._TmpQuat;
            this.getRotationQuaternionToRef(space, tNode, quat);
            quat.toEulerAnglesToRef(result);
        }
        /**
         * Get the quaternion rotation of the bone in either local or world space
         * @param space The space that the rotation should be in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The quaternion rotation
         */
        getRotationQuaternion(space = Space.LOCAL, tNode = null) {
            const result = Quaternion.Identity();
            this.getRotationQuaternionToRef(space, tNode, result);
            return result;
        }
        /**
         * Copy the quaternion rotation of the bone to a quaternion.  The rotation can be in either local or world space
         * @param space The space that the rotation should be in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The quaternion that the rotation should be copied to
         */
        getRotationQuaternionToRef(space = Space.LOCAL, tNode = null, result) {
            if (space == Space.LOCAL) {
                this._decompose();
                result.copyFrom(this._localRotation);
            }
            else {
                const mat = Bone._TmpMats[0];
                const amat = this.getAbsoluteMatrix();
                if (tNode) {
                    amat.multiplyToRef(tNode.getWorldMatrix(), mat);
                }
                else {
                    mat.copyFrom(amat);
                }
                mat.multiplyAtIndex(0, this._scalingDeterminant);
                mat.multiplyAtIndex(1, this._scalingDeterminant);
                mat.multiplyAtIndex(2, this._scalingDeterminant);
                mat.decompose(undefined, result, undefined);
            }
        }
        /**
         * Get the rotation matrix of the bone in local or world space
         * @param space The space that the rotation should be in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The rotation matrix
         */
        getRotationMatrix(space = Space.LOCAL, tNode) {
            const result = Matrix.Identity();
            this.getRotationMatrixToRef(space, tNode, result);
            return result;
        }
        /**
         * Copy the rotation matrix of the bone to a matrix.  The rotation can be in either local or world space
         * @param space The space that the rotation should be in
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The quaternion that the rotation should be copied to
         */
        getRotationMatrixToRef(space = Space.LOCAL, tNode, result) {
            if (space == Space.LOCAL) {
                this.getLocalMatrix().getRotationMatrixToRef(result);
            }
            else {
                const mat = Bone._TmpMats[0];
                const amat = this.getAbsoluteMatrix();
                if (tNode) {
                    amat.multiplyToRef(tNode.getWorldMatrix(), mat);
                }
                else {
                    mat.copyFrom(amat);
                }
                mat.multiplyAtIndex(0, this._scalingDeterminant);
                mat.multiplyAtIndex(1, this._scalingDeterminant);
                mat.multiplyAtIndex(2, this._scalingDeterminant);
                mat.getRotationMatrixToRef(result);
            }
        }
        /**
         * Get the world position of a point that is in the local space of the bone
         * @param position The local position
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The world position
         */
        getAbsolutePositionFromLocal(position, tNode = null) {
            const result = Vector3.Zero();
            this.getAbsolutePositionFromLocalToRef(position, tNode, result);
            return result;
        }
        /**
         * Get the world position of a point that is in the local space of the bone and copy it to the result param
         * @param position The local position
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The vector3 that the world position should be copied to
         */
        getAbsolutePositionFromLocalToRef(position, tNode = null, result) {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) {
                wm = tNode.getWorldMatrix();
            }
            this._skeleton.computeAbsoluteMatrices();
            const tmat = Bone._TmpMats[0];
            tmat.copyFrom(this.getAbsoluteMatrix());
            if (tNode && wm) {
                tmat.multiplyToRef(wm, tmat);
            }
            Vector3.TransformCoordinatesToRef(position, tmat, result);
        }
        /**
         * Get the local position of a point that is in world space
         * @param position The world position
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @returns The local position
         */
        getLocalPositionFromAbsolute(position, tNode = null) {
            const result = Vector3.Zero();
            this.getLocalPositionFromAbsoluteToRef(position, tNode, result);
            return result;
        }
        /**
         * Get the local position of a point that is in world space and copy it to the result param
         * @param position The world position
         * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
         * @param result The vector3 that the local position should be copied to
         */
        getLocalPositionFromAbsoluteToRef(position, tNode = null, result) {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) {
                wm = tNode.getWorldMatrix();
            }
            this._skeleton.computeAbsoluteMatrices();
            const tmat = Bone._TmpMats[0];
            tmat.copyFrom(this.getAbsoluteMatrix());
            if (tNode && wm) {
                tmat.multiplyToRef(wm, tmat);
            }
            tmat.invert();
            Vector3.TransformCoordinatesToRef(position, tmat, result);
        }
        /**
         * Set the current local matrix as the restMatrix for this bone.
         */
        setCurrentPoseAsRest() {
            this.setRestMatrix(this.getLocalMatrix());
        }
    }
    Bone._TmpVecs = ArrayTools.BuildArray(2, Vector3.Zero);
    Bone._TmpQuat = Quaternion.Identity();
    Bone._TmpMats = ArrayTools.BuildArray(5, Matrix.Identity);

    /**
     * Class used to store an actual running animation
     */
    class Animatable {
        /**
         * Gets the root Animatable used to synchronize and normalize animations
         */
        get syncRoot() {
            return this._syncRoot;
        }
        /**
         * Gets the current frame of the first RuntimeAnimation
         * Used to synchronize Animatables
         */
        get masterFrame() {
            if (this._runtimeAnimations.length === 0) {
                return 0;
            }
            return this._runtimeAnimations[0].currentFrame;
        }
        /**
         * Gets or sets the animatable weight (-1.0 by default meaning not weighted)
         */
        get weight() {
            return this._weight;
        }
        set weight(value) {
            if (value === -1) {
                // -1 is ok and means no weight
                this._weight = -1;
                return;
            }
            // Else weight must be in [0, 1] range
            this._weight = Math.min(Math.max(value, 0), 1.0);
        }
        /**
         * Gets or sets the speed ratio to apply to the animatable (1.0 by default)
         */
        get speedRatio() {
            return this._speedRatio;
        }
        set speedRatio(value) {
            for (let index = 0; index < this._runtimeAnimations.length; index++) {
                const animation = this._runtimeAnimations[index];
                animation._prepareForSpeedRatioChange(value);
            }
            this._speedRatio = value;
            // Resync _manualJumpDelay in case goToFrame was called before speedRatio was set.
            if (this._goToFrame !== null) {
                this.goToFrame(this._goToFrame);
            }
        }
        /**
         * Creates a new Animatable
         * @param scene defines the hosting scene
         * @param target defines the target object
         * @param fromFrame defines the starting frame number (default is 0)
         * @param toFrame defines the ending frame number (default is 100)
         * @param loopAnimation defines if the animation must loop (default is false)
         * @param speedRatio defines the factor to apply to animation speed (default is 1)
         * @param onAnimationEnd defines a callback to call when animation ends if it is not looping
         * @param animations defines a group of animation to add to the new Animatable
         * @param onAnimationLoop defines a callback to call when animation loops
         * @param isAdditive defines whether the animation should be evaluated additively
         * @param playOrder defines the order in which this animatable should be processed in the list of active animatables (default: 0)
         */
        constructor(scene, 
        /** defines the target object */
        target, 
        /** defines the starting frame number (default is 0) */
        fromFrame = 0, 
        /** defines the ending frame number (default is 100) */
        toFrame = 100, 
        /** defines if the animation must loop (default is false)  */
        loopAnimation = false, speedRatio = 1.0, 
        /** defines a callback to call when animation ends if it is not looping */
        onAnimationEnd, animations, 
        /** defines a callback to call when animation loops */
        onAnimationLoop, 
        /** defines whether the animation should be evaluated additively */
        isAdditive = false, 
        /** defines the order in which this animatable should be processed in the list of active animatables (default: 0) */
        playOrder = 0) {
            this.target = target;
            this.fromFrame = fromFrame;
            this.toFrame = toFrame;
            this.loopAnimation = loopAnimation;
            this.onAnimationEnd = onAnimationEnd;
            this.onAnimationLoop = onAnimationLoop;
            this.isAdditive = isAdditive;
            this.playOrder = playOrder;
            this._localDelayOffset = null;
            this._pausedDelay = null;
            this._manualJumpDelay = null;
            /** @hidden */
            this._runtimeAnimations = new Array();
            this._paused = false;
            this._speedRatio = 1;
            this._weight = -1.0;
            this._syncRoot = null;
            this._frameToSyncFromJump = null;
            this._goToFrame = null;
            /**
             * Gets or sets a boolean indicating if the animatable must be disposed and removed at the end of the animation.
             * This will only apply for non looping animation (default is true)
             */
            this.disposeOnEnd = true;
            /**
             * Gets a boolean indicating if the animation has started
             */
            this.animationStarted = false;
            /**
             * Observer raised when the animation ends
             */
            this.onAnimationEndObservable = new Observable$1();
            /**
             * Observer raised when the animation loops
             */
            this.onAnimationLoopObservable = new Observable$1();
            this._scene = scene;
            if (animations) {
                this.appendAnimations(target, animations);
            }
            this._speedRatio = speedRatio;
            scene._activeAnimatables.push(this);
        }
        // Methods
        /**
         * Synchronize and normalize current Animatable with a source Animatable
         * This is useful when using animation weights and when animations are not of the same length
         * @param root defines the root Animatable to synchronize with (null to stop synchronizing)
         * @returns the current Animatable
         */
        syncWith(root) {
            this._syncRoot = root;
            if (root) {
                // Make sure this animatable will animate after the root
                const index = this._scene._activeAnimatables.indexOf(this);
                if (index > -1) {
                    this._scene._activeAnimatables.splice(index, 1);
                    this._scene._activeAnimatables.push(this);
                }
            }
            return this;
        }
        /**
         * Gets the list of runtime animations
         * @returns an array of RuntimeAnimation
         */
        getAnimations() {
            return this._runtimeAnimations;
        }
        /**
         * Adds more animations to the current animatable
         * @param target defines the target of the animations
         * @param animations defines the new animations to add
         */
        appendAnimations(target, animations) {
            for (let index = 0; index < animations.length; index++) {
                const animation = animations[index];
                const newRuntimeAnimation = new RuntimeAnimation(target, animation, this._scene, this);
                newRuntimeAnimation._onLoop = () => {
                    this.onAnimationLoopObservable.notifyObservers(this);
                    if (this.onAnimationLoop) {
                        this.onAnimationLoop();
                    }
                };
                this._runtimeAnimations.push(newRuntimeAnimation);
            }
        }
        /**
         * Gets the source animation for a specific property
         * @param property defines the property to look for
         * @returns null or the source animation for the given property
         */
        getAnimationByTargetProperty(property) {
            const runtimeAnimations = this._runtimeAnimations;
            for (let index = 0; index < runtimeAnimations.length; index++) {
                if (runtimeAnimations[index].animation.targetProperty === property) {
                    return runtimeAnimations[index].animation;
                }
            }
            return null;
        }
        /**
         * Gets the runtime animation for a specific property
         * @param property defines the property to look for
         * @returns null or the runtime animation for the given property
         */
        getRuntimeAnimationByTargetProperty(property) {
            const runtimeAnimations = this._runtimeAnimations;
            for (let index = 0; index < runtimeAnimations.length; index++) {
                if (runtimeAnimations[index].animation.targetProperty === property) {
                    return runtimeAnimations[index];
                }
            }
            return null;
        }
        /**
         * Resets the animatable to its original state
         */
        reset() {
            const runtimeAnimations = this._runtimeAnimations;
            for (let index = 0; index < runtimeAnimations.length; index++) {
                runtimeAnimations[index].reset(true);
            }
            this._localDelayOffset = null;
            this._pausedDelay = null;
        }
        /**
         * Allows the animatable to blend with current running animations
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
         * @param blendingSpeed defines the blending speed to use
         */
        enableBlending(blendingSpeed) {
            const runtimeAnimations = this._runtimeAnimations;
            for (let index = 0; index < runtimeAnimations.length; index++) {
                runtimeAnimations[index].animation.enableBlending = true;
                runtimeAnimations[index].animation.blendingSpeed = blendingSpeed;
            }
        }
        /**
         * Disable animation blending
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
         */
        disableBlending() {
            const runtimeAnimations = this._runtimeAnimations;
            for (let index = 0; index < runtimeAnimations.length; index++) {
                runtimeAnimations[index].animation.enableBlending = false;
            }
        }
        /**
         * Jump directly to a given frame
         * @param frame defines the frame to jump to
         */
        goToFrame(frame) {
            var _a;
            const runtimeAnimations = this._runtimeAnimations;
            if (runtimeAnimations[0]) {
                const fps = runtimeAnimations[0].animation.framePerSecond;
                this._frameToSyncFromJump = (_a = this._frameToSyncFromJump) !== null && _a !== void 0 ? _a : runtimeAnimations[0].currentFrame;
                const delay = this.speedRatio === 0 ? 0 : (((frame - this._frameToSyncFromJump) / fps) * 1000) / this.speedRatio;
                this._manualJumpDelay = -delay;
            }
            for (let index = 0; index < runtimeAnimations.length; index++) {
                runtimeAnimations[index].goToFrame(frame);
            }
            this._goToFrame = frame;
        }
        /**
         * Pause the animation
         */
        pause() {
            if (this._paused) {
                return;
            }
            this._paused = true;
        }
        /**
         * Restart the animation
         */
        restart() {
            this._paused = false;
        }
        _raiseOnAnimationEnd() {
            if (this.onAnimationEnd) {
                this.onAnimationEnd();
            }
            this.onAnimationEndObservable.notifyObservers(this);
        }
        /**
         * Stop and delete the current animation
         * @param animationName defines a string used to only stop some of the runtime animations instead of all
         * @param targetMask a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
         * @param useGlobalSplice if true, the animatables will be removed by the caller of this function (false by default)
         */
        stop(animationName, targetMask, useGlobalSplice = false) {
            if (animationName || targetMask) {
                const idx = this._scene._activeAnimatables.indexOf(this);
                if (idx > -1) {
                    const runtimeAnimations = this._runtimeAnimations;
                    for (let index = runtimeAnimations.length - 1; index >= 0; index--) {
                        const runtimeAnimation = runtimeAnimations[index];
                        if (animationName && runtimeAnimation.animation.name != animationName) {
                            continue;
                        }
                        if (targetMask && !targetMask(runtimeAnimation.target)) {
                            continue;
                        }
                        runtimeAnimation.dispose();
                        runtimeAnimations.splice(index, 1);
                    }
                    if (runtimeAnimations.length == 0) {
                        if (!useGlobalSplice) {
                            this._scene._activeAnimatables.splice(idx, 1);
                        }
                        this._raiseOnAnimationEnd();
                    }
                }
            }
            else {
                const index = this._scene._activeAnimatables.indexOf(this);
                if (index > -1) {
                    if (!useGlobalSplice) {
                        this._scene._activeAnimatables.splice(index, 1);
                    }
                    const runtimeAnimations = this._runtimeAnimations;
                    for (let index = 0; index < runtimeAnimations.length; index++) {
                        runtimeAnimations[index].dispose();
                    }
                    this._runtimeAnimations.length = 0;
                    this._raiseOnAnimationEnd();
                }
            }
        }
        /**
         * Wait asynchronously for the animation to end
         * @returns a promise which will be fulfilled when the animation ends
         */
        waitAsync() {
            return new Promise((resolve) => {
                this.onAnimationEndObservable.add(() => {
                    resolve(this);
                }, undefined, undefined, this, true);
            });
        }
        /**
         * @internal
         */
        _animate(delay) {
            if (this._paused) {
                this.animationStarted = false;
                if (this._pausedDelay === null) {
                    this._pausedDelay = delay;
                }
                return true;
            }
            if (this._localDelayOffset === null) {
                this._localDelayOffset = delay;
                this._pausedDelay = null;
            }
            else if (this._pausedDelay !== null) {
                this._localDelayOffset += delay - this._pausedDelay;
                this._pausedDelay = null;
            }
            if (this._manualJumpDelay !== null) {
                this._localDelayOffset += this._manualJumpDelay;
                this._manualJumpDelay = null;
                this._frameToSyncFromJump = null;
            }
            this._goToFrame = null;
            if (this._weight === 0) {
                // We consider that an animation with a weight === 0 is "actively" paused
                return true;
            }
            // Animating
            let running = false;
            const runtimeAnimations = this._runtimeAnimations;
            let index;
            for (index = 0; index < runtimeAnimations.length; index++) {
                const animation = runtimeAnimations[index];
                const isRunning = animation.animate(delay - this._localDelayOffset, this.fromFrame, this.toFrame, this.loopAnimation, this._speedRatio, this._weight);
                running = running || isRunning;
            }
            this.animationStarted = running;
            if (!running) {
                if (this.disposeOnEnd) {
                    // Remove from active animatables
                    index = this._scene._activeAnimatables.indexOf(this);
                    this._scene._activeAnimatables.splice(index, 1);
                    // Dispose all runtime animations
                    for (index = 0; index < runtimeAnimations.length; index++) {
                        runtimeAnimations[index].dispose();
                    }
                }
                this._raiseOnAnimationEnd();
                if (this.disposeOnEnd) {
                    this.onAnimationEnd = null;
                    this.onAnimationLoop = null;
                    this.onAnimationLoopObservable.clear();
                    this.onAnimationEndObservable.clear();
                }
            }
            return running;
        }
    }
    Scene.prototype._animate = function () {
        if (!this.animationsEnabled) {
            return;
        }
        // Getting time
        const now = PrecisionDate.Now;
        if (!this._animationTimeLast) {
            if (this._pendingData.length > 0) {
                return;
            }
            this._animationTimeLast = now;
        }
        this.deltaTime = this.useConstantAnimationDeltaTime ? 16.0 : (now - this._animationTimeLast) * this.animationTimeScale;
        this._animationTimeLast = now;
        const animatables = this._activeAnimatables;
        if (animatables.length === 0) {
            return;
        }
        this._animationTime += this.deltaTime;
        const animationTime = this._animationTime;
        for (let index = 0; index < animatables.length; index++) {
            const animatable = animatables[index];
            if (!animatable._animate(animationTime) && animatable.disposeOnEnd) {
                index--; // Array was updated
            }
        }
        // Late animation bindings
        this._processLateAnimationBindings();
    };
    Scene.prototype.sortActiveAnimatables = function () {
        this._activeAnimatables.sort((a, b) => {
            return a.playOrder - b.playOrder;
        });
    };
    Scene.prototype.beginWeightedAnimation = function (target, from, to, weight = 1.0, loop, speedRatio = 1.0, onAnimationEnd, animatable, targetMask, onAnimationLoop, isAdditive = false) {
        const returnedAnimatable = this.beginAnimation(target, from, to, loop, speedRatio, onAnimationEnd, animatable, false, targetMask, onAnimationLoop, isAdditive);
        returnedAnimatable.weight = weight;
        return returnedAnimatable;
    };
    Scene.prototype.beginAnimation = function (target, from, to, loop, speedRatio = 1.0, onAnimationEnd, animatable, stopCurrent = true, targetMask, onAnimationLoop, isAdditive = false) {
        if (from > to && speedRatio > 0) {
            speedRatio *= -1;
        }
        if (stopCurrent) {
            this.stopAnimation(target, undefined, targetMask);
        }
        if (!animatable) {
            animatable = new Animatable(this, target, from, to, loop, speedRatio, onAnimationEnd, undefined, onAnimationLoop, isAdditive);
        }
        const shouldRunTargetAnimations = targetMask ? targetMask(target) : true;
        // Local animations
        if (target.animations && shouldRunTargetAnimations) {
            animatable.appendAnimations(target, target.animations);
        }
        // Children animations
        if (target.getAnimatables) {
            const animatables = target.getAnimatables();
            for (let index = 0; index < animatables.length; index++) {
                this.beginAnimation(animatables[index], from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, onAnimationLoop);
            }
        }
        animatable.reset();
        return animatable;
    };
    Scene.prototype.beginHierarchyAnimation = function (target, directDescendantsOnly, from, to, loop, speedRatio = 1.0, onAnimationEnd, animatable, stopCurrent = true, targetMask, onAnimationLoop, isAdditive = false) {
        const children = target.getDescendants(directDescendantsOnly);
        const result = [];
        result.push(this.beginAnimation(target, from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, undefined, isAdditive));
        for (const child of children) {
            result.push(this.beginAnimation(child, from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, undefined, isAdditive));
        }
        return result;
    };
    Scene.prototype.beginDirectAnimation = function (target, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive = false) {
        if (speedRatio === undefined) {
            speedRatio = 1.0;
        }
        if (from > to && speedRatio > 0) {
            speedRatio *= -1;
        }
        else if (to > from && speedRatio < 0) {
            const temp = to;
            to = from;
            from = temp;
        }
        const animatable = new Animatable(this, target, from, to, loop, speedRatio, onAnimationEnd, animations, onAnimationLoop, isAdditive);
        return animatable;
    };
    Scene.prototype.beginDirectHierarchyAnimation = function (target, directDescendantsOnly, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive = false) {
        const children = target.getDescendants(directDescendantsOnly);
        const result = [];
        result.push(this.beginDirectAnimation(target, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive));
        for (const child of children) {
            result.push(this.beginDirectAnimation(child, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive));
        }
        return result;
    };
    Scene.prototype.getAnimatableByTarget = function (target) {
        for (let index = 0; index < this._activeAnimatables.length; index++) {
            if (this._activeAnimatables[index].target === target) {
                return this._activeAnimatables[index];
            }
        }
        return null;
    };
    Scene.prototype.getAllAnimatablesByTarget = function (target) {
        const result = [];
        for (let index = 0; index < this._activeAnimatables.length; index++) {
            if (this._activeAnimatables[index].target === target) {
                result.push(this._activeAnimatables[index]);
            }
        }
        return result;
    };
    /**
     * Will stop the animation of the given target
     * @param target - the target
     * @param animationName - the name of the animation to stop (all animations will be stopped if both this and targetMask are empty)
     * @param targetMask - a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
     */
    Scene.prototype.stopAnimation = function (target, animationName, targetMask) {
        const animatables = this.getAllAnimatablesByTarget(target);
        for (const animatable of animatables) {
            animatable.stop(animationName, targetMask);
        }
    };
    /**
     * Stops and removes all animations that have been applied to the scene
     */
    Scene.prototype.stopAllAnimations = function () {
        if (this._activeAnimatables) {
            for (let i = 0; i < this._activeAnimatables.length; i++) {
                this._activeAnimatables[i].stop(undefined, undefined, true);
            }
            this._activeAnimatables.length = 0;
        }
        for (const group of this.animationGroups) {
            group.stop();
        }
    };
    Scene.prototype._registerTargetForLateAnimationBinding = function (runtimeAnimation, originalValue) {
        const target = runtimeAnimation.target;
        this._registeredForLateAnimationBindings.pushNoDuplicate(target);
        if (!target._lateAnimationHolders) {
            target._lateAnimationHolders = {};
        }
        if (!target._lateAnimationHolders[runtimeAnimation.targetPath]) {
            target._lateAnimationHolders[runtimeAnimation.targetPath] = {
                totalWeight: 0,
                totalAdditiveWeight: 0,
                animations: [],
                additiveAnimations: [],
                originalValue: originalValue,
            };
        }
        if (runtimeAnimation.isAdditive) {
            target._lateAnimationHolders[runtimeAnimation.targetPath].additiveAnimations.push(runtimeAnimation);
            target._lateAnimationHolders[runtimeAnimation.targetPath].totalAdditiveWeight += runtimeAnimation.weight;
        }
        else {
            target._lateAnimationHolders[runtimeAnimation.targetPath].animations.push(runtimeAnimation);
            target._lateAnimationHolders[runtimeAnimation.targetPath].totalWeight += runtimeAnimation.weight;
        }
    };
    Scene.prototype._processLateAnimationBindingsForMatrices = function (holder) {
        if (holder.totalWeight === 0 && holder.totalAdditiveWeight === 0) {
            return holder.originalValue;
        }
        let normalizer = 1.0;
        const finalPosition = TmpVectors.Vector3[0];
        const finalScaling = TmpVectors.Vector3[1];
        const finalQuaternion = TmpVectors.Quaternion[0];
        let startIndex = 0;
        const originalAnimation = holder.animations[0];
        const originalValue = holder.originalValue;
        let scale = 1;
        let skipOverride = false;
        if (holder.totalWeight < 1.0) {
            // We need to mix the original value in
            scale = 1.0 - holder.totalWeight;
            originalValue.decompose(finalScaling, finalQuaternion, finalPosition);
        }
        else {
            startIndex = 1;
            // We need to normalize the weights
            normalizer = holder.totalWeight;
            scale = originalAnimation.weight / normalizer;
            if (scale == 1) {
                if (holder.totalAdditiveWeight) {
                    skipOverride = true;
                }
                else {
                    return originalAnimation.currentValue;
                }
            }
            originalAnimation.currentValue.decompose(finalScaling, finalQuaternion, finalPosition);
        }
        // Add up the override animations
        if (!skipOverride) {
            finalScaling.scaleInPlace(scale);
            finalPosition.scaleInPlace(scale);
            finalQuaternion.scaleInPlace(scale);
            for (let animIndex = startIndex; animIndex < holder.animations.length; animIndex++) {
                const runtimeAnimation = holder.animations[animIndex];
                if (runtimeAnimation.weight === 0) {
                    continue;
                }
                scale = runtimeAnimation.weight / normalizer;
                const currentPosition = TmpVectors.Vector3[2];
                const currentScaling = TmpVectors.Vector3[3];
                const currentQuaternion = TmpVectors.Quaternion[1];
                runtimeAnimation.currentValue.decompose(currentScaling, currentQuaternion, currentPosition);
                currentScaling.scaleAndAddToRef(scale, finalScaling);
                currentQuaternion.scaleAndAddToRef(Quaternion.Dot(finalQuaternion, currentQuaternion) > 0 ? scale : -scale, finalQuaternion);
                currentPosition.scaleAndAddToRef(scale, finalPosition);
            }
            finalQuaternion.normalize();
        }
        // Add up the additive animations
        for (let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++) {
            const runtimeAnimation = holder.additiveAnimations[animIndex];
            if (runtimeAnimation.weight === 0) {
                continue;
            }
            const currentPosition = TmpVectors.Vector3[2];
            const currentScaling = TmpVectors.Vector3[3];
            const currentQuaternion = TmpVectors.Quaternion[1];
            runtimeAnimation.currentValue.decompose(currentScaling, currentQuaternion, currentPosition);
            currentScaling.multiplyToRef(finalScaling, currentScaling);
            Vector3.LerpToRef(finalScaling, currentScaling, runtimeAnimation.weight, finalScaling);
            finalQuaternion.multiplyToRef(currentQuaternion, currentQuaternion);
            Quaternion.SlerpToRef(finalQuaternion, currentQuaternion, runtimeAnimation.weight, finalQuaternion);
            currentPosition.scaleAndAddToRef(runtimeAnimation.weight, finalPosition);
        }
        const workValue = originalAnimation ? originalAnimation._animationState.workValue : TmpVectors.Matrix[0].clone();
        Matrix.ComposeToRef(finalScaling, finalQuaternion, finalPosition, workValue);
        return workValue;
    };
    Scene.prototype._processLateAnimationBindingsForQuaternions = function (holder, refQuaternion) {
        if (holder.totalWeight === 0 && holder.totalAdditiveWeight === 0) {
            return refQuaternion;
        }
        const originalAnimation = holder.animations[0];
        const originalValue = holder.originalValue;
        let cumulativeQuaternion = refQuaternion;
        if (holder.totalWeight === 0 && holder.totalAdditiveWeight > 0) {
            cumulativeQuaternion.copyFrom(originalValue);
        }
        else if (holder.animations.length === 1) {
            Quaternion.SlerpToRef(originalValue, originalAnimation.currentValue, Math.min(1.0, holder.totalWeight), cumulativeQuaternion);
            if (holder.totalAdditiveWeight === 0) {
                return cumulativeQuaternion;
            }
        }
        else if (holder.animations.length > 1) {
            // Add up the override animations
            let normalizer = 1.0;
            let quaternions;
            let weights;
            if (holder.totalWeight < 1.0) {
                const scale = 1.0 - holder.totalWeight;
                quaternions = [];
                weights = [];
                quaternions.push(originalValue);
                weights.push(scale);
            }
            else {
                if (holder.animations.length === 2) {
                    // Slerp as soon as we can
                    Quaternion.SlerpToRef(holder.animations[0].currentValue, holder.animations[1].currentValue, holder.animations[1].weight / holder.totalWeight, refQuaternion);
                    if (holder.totalAdditiveWeight === 0) {
                        return refQuaternion;
                    }
                }
                quaternions = [];
                weights = [];
                normalizer = holder.totalWeight;
            }
            for (let animIndex = 0; animIndex < holder.animations.length; animIndex++) {
                const runtimeAnimation = holder.animations[animIndex];
                quaternions.push(runtimeAnimation.currentValue);
                weights.push(runtimeAnimation.weight / normalizer);
            }
            // https://gamedev.stackexchange.com/questions/62354/method-for-interpolation-between-3-quaternions
            let cumulativeAmount = 0;
            for (let index = 0; index < quaternions.length;) {
                if (!index) {
                    Quaternion.SlerpToRef(quaternions[index], quaternions[index + 1], weights[index + 1] / (weights[index] + weights[index + 1]), refQuaternion);
                    cumulativeQuaternion = refQuaternion;
                    cumulativeAmount = weights[index] + weights[index + 1];
                    index += 2;
                    continue;
                }
                cumulativeAmount += weights[index];
                Quaternion.SlerpToRef(cumulativeQuaternion, quaternions[index], weights[index] / cumulativeAmount, cumulativeQuaternion);
                index++;
            }
        }
        // Add up the additive animations
        for (let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++) {
            const runtimeAnimation = holder.additiveAnimations[animIndex];
            if (runtimeAnimation.weight === 0) {
                continue;
            }
            cumulativeQuaternion.multiplyToRef(runtimeAnimation.currentValue, TmpVectors.Quaternion[0]);
            Quaternion.SlerpToRef(cumulativeQuaternion, TmpVectors.Quaternion[0], runtimeAnimation.weight, cumulativeQuaternion);
        }
        return cumulativeQuaternion;
    };
    Scene.prototype._processLateAnimationBindings = function () {
        if (!this._registeredForLateAnimationBindings.length) {
            return;
        }
        for (let index = 0; index < this._registeredForLateAnimationBindings.length; index++) {
            const target = this._registeredForLateAnimationBindings.data[index];
            for (const path in target._lateAnimationHolders) {
                const holder = target._lateAnimationHolders[path];
                const originalAnimation = holder.animations[0];
                const originalValue = holder.originalValue;
                if (originalValue === undefined || originalValue === null) {
                    continue;
                }
                const matrixDecomposeMode = Animation.AllowMatrixDecomposeForInterpolation && originalValue.m; // ie. data is matrix
                let finalValue = target[path];
                if (matrixDecomposeMode) {
                    finalValue = this._processLateAnimationBindingsForMatrices(holder);
                }
                else {
                    const quaternionMode = originalValue.w !== undefined;
                    if (quaternionMode) {
                        finalValue = this._processLateAnimationBindingsForQuaternions(holder, finalValue || Quaternion.Identity());
                    }
                    else {
                        let startIndex = 0;
                        let normalizer = 1.0;
                        if (holder.totalWeight < 1.0) {
                            // We need to mix the original value in
                            if (originalAnimation && originalValue.scale) {
                                finalValue = originalValue.scale(1.0 - holder.totalWeight);
                            }
                            else if (originalAnimation) {
                                finalValue = originalValue * (1.0 - holder.totalWeight);
                            }
                            else if (originalValue.clone) {
                                finalValue = originalValue.clone();
                            }
                            else {
                                finalValue = originalValue;
                            }
                        }
                        else if (originalAnimation) {
                            // We need to normalize the weights
                            normalizer = holder.totalWeight;
                            const scale = originalAnimation.weight / normalizer;
                            if (scale !== 1) {
                                if (originalAnimation.currentValue.scale) {
                                    finalValue = originalAnimation.currentValue.scale(scale);
                                }
                                else {
                                    finalValue = originalAnimation.currentValue * scale;
                                }
                            }
                            else {
                                finalValue = originalAnimation.currentValue;
                            }
                            startIndex = 1;
                        }
                        // Add up the override animations
                        for (let animIndex = startIndex; animIndex < holder.animations.length; animIndex++) {
                            const runtimeAnimation = holder.animations[animIndex];
                            const scale = runtimeAnimation.weight / normalizer;
                            if (!scale) {
                                continue;
                            }
                            else if (runtimeAnimation.currentValue.scaleAndAddToRef) {
                                runtimeAnimation.currentValue.scaleAndAddToRef(scale, finalValue);
                            }
                            else {
                                finalValue += runtimeAnimation.currentValue * scale;
                            }
                        }
                        // Add up the additive animations
                        for (let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++) {
                            const runtimeAnimation = holder.additiveAnimations[animIndex];
                            const scale = runtimeAnimation.weight;
                            if (!scale) {
                                continue;
                            }
                            else if (runtimeAnimation.currentValue.scaleAndAddToRef) {
                                runtimeAnimation.currentValue.scaleAndAddToRef(scale, finalValue);
                            }
                            else {
                                finalValue += runtimeAnimation.currentValue * scale;
                            }
                        }
                    }
                }
                target[path] = finalValue;
            }
            target._lateAnimationHolders = {};
        }
        this._registeredForLateAnimationBindings.reset();
    };
    Bone.prototype.copyAnimationRange = function (source, rangeName, frameOffset, rescaleAsRequired = false, skelDimensionsRatio = null) {
        // all animation may be coming from a library skeleton, so may need to create animation
        if (this.animations.length === 0) {
            this.animations.push(new Animation(this.name, "_matrix", source.animations[0].framePerSecond, Animation.ANIMATIONTYPE_MATRIX, 0));
            this.animations[0].setKeys([]);
        }
        // get animation info / verify there is such a range from the source bone
        const sourceRange = source.animations[0].getRange(rangeName);
        if (!sourceRange) {
            return false;
        }
        const from = sourceRange.from;
        const to = sourceRange.to;
        const sourceKeys = source.animations[0].getKeys();
        // rescaling prep
        const sourceBoneLength = source.length;
        const sourceParent = source.getParent();
        const parent = this.getParent();
        const parentScalingReqd = rescaleAsRequired && sourceParent && sourceBoneLength && this.length && sourceBoneLength !== this.length;
        const parentRatio = parentScalingReqd && parent && sourceParent ? parent.length / sourceParent.length : 1;
        const dimensionsScalingReqd = rescaleAsRequired && !parent && skelDimensionsRatio && (skelDimensionsRatio.x !== 1 || skelDimensionsRatio.y !== 1 || skelDimensionsRatio.z !== 1);
        const destKeys = this.animations[0].getKeys();
        // loop vars declaration
        let orig;
        let origTranslation;
        let mat;
        for (let key = 0, nKeys = sourceKeys.length; key < nKeys; key++) {
            orig = sourceKeys[key];
            if (orig.frame >= from && orig.frame <= to) {
                if (rescaleAsRequired) {
                    mat = orig.value.clone();
                    // scale based on parent ratio, when bone has parent
                    if (parentScalingReqd) {
                        origTranslation = mat.getTranslation();
                        mat.setTranslation(origTranslation.scaleInPlace(parentRatio));
                        // scale based on skeleton dimension ratio when root bone, and value is passed
                    }
                    else if (dimensionsScalingReqd && skelDimensionsRatio) {
                        origTranslation = mat.getTranslation();
                        mat.setTranslation(origTranslation.multiplyInPlace(skelDimensionsRatio));
                        // use original when root bone, and no data for skelDimensionsRatio
                    }
                    else {
                        mat = orig.value;
                    }
                }
                else {
                    mat = orig.value;
                }
                destKeys.push({ frame: orig.frame + frameOffset, value: mat });
            }
        }
        this.animations[0].createRange(rangeName, from + frameOffset, to + frameOffset);
        return true;
    };

    /**
     * Wrapper over subclasses of XRLayer.
     * @internal
     */
    class WebXRLayerWrapper {
        /**
         * Check if fixed foveation is supported on this device
         */
        get isFixedFoveationSupported() {
            return this.layerType == "XRWebGLLayer" && typeof this.layer.fixedFoveation == "number";
        }
        /**
         * Get the fixed foveation currently set, as specified by the webxr specs
         * If this returns null, then fixed foveation is not supported
         */
        get fixedFoveation() {
            if (this.isFixedFoveationSupported) {
                return this.layer.fixedFoveation;
            }
            return null;
        }
        /**
         * Set the fixed foveation to the specified value, as specified by the webxr specs
         * This value will be normalized to be between 0 and 1, 1 being max foveation, 0 being no foveation
         */
        set fixedFoveation(value) {
            if (this.isFixedFoveationSupported) {
                const val = Math.max(0, Math.min(1, value || 0));
                this.layer.fixedFoveation = val;
            }
        }
        constructor(
        /** The width of the layer's framebuffer. */
        getWidth, 
        /** The height of the layer's framebuffer. */
        getHeight, 
        /** The XR layer that this WebXRLayerWrapper wraps. */
        layer, 
        /** The type of XR layer that is being wrapped. */
        layerType, 
        /** Create a render target provider for the wrapped layer. */
        createRenderTargetTextureProvider) {
            this.getWidth = getWidth;
            this.getHeight = getHeight;
            this.layer = layer;
            this.layerType = layerType;
            this.createRenderTargetTextureProvider = createRenderTargetTextureProvider;
        }
    }

    /**
     * Provides render target textures and other important rendering information for a given XRLayer.
     * @internal
     */
    class WebXRLayerRenderTargetTextureProvider {
        constructor(_scene, layerWrapper) {
            this._scene = _scene;
            this.layerWrapper = layerWrapper;
            this._renderTargetTextures = new Array();
            this._engine = _scene.getEngine();
        }
        _createInternalTexture(textureSize, texture) {
            const internalTexture = new InternalTexture(this._engine, InternalTextureSource.Unknown, true);
            internalTexture.width = textureSize.width;
            internalTexture.height = textureSize.height;
            internalTexture._hardwareTexture = new WebGLHardwareTexture(texture, this._engine._gl);
            internalTexture.isReady = true;
            return internalTexture;
        }
        _createRenderTargetTexture(width, height, framebuffer, colorTexture, depthStencilTexture, multiview) {
            if (!this._engine) {
                throw new Error("Engine is disposed");
            }
            const textureSize = { width, height };
            // Create render target texture from the internal texture
            const renderTargetTexture = multiview ? new MultiviewRenderTarget(this._scene, textureSize) : new RenderTargetTexture("XR renderTargetTexture", textureSize, this._scene);
            const renderTargetWrapper = renderTargetTexture.renderTarget;
            renderTargetWrapper._samples = renderTargetTexture.samples;
            // Set the framebuffer, make sure it works in all scenarios - emulator, no layers and layers
            if (framebuffer || !colorTexture) {
                renderTargetWrapper._framebuffer = framebuffer;
            }
            // Create internal texture
            if (colorTexture) {
                if (multiview) {
                    renderTargetWrapper._colorTextureArray = colorTexture;
                }
                else {
                    const internalTexture = this._createInternalTexture(textureSize, colorTexture);
                    renderTargetWrapper.setTexture(internalTexture, 0);
                    renderTargetTexture._texture = internalTexture;
                }
            }
            if (depthStencilTexture) {
                if (multiview) {
                    renderTargetWrapper._depthStencilTextureArray = depthStencilTexture;
                }
                else {
                    renderTargetWrapper._depthStencilTexture = this._createInternalTexture(textureSize, depthStencilTexture);
                }
            }
            renderTargetTexture.disableRescaling();
            // Firefox reality fails if skipInitialClear is set to true, so make sure only modern XR implementations set it.
            if (typeof XRWebGLBinding !== "undefined") {
                // WebXR pre-clears textures
                renderTargetTexture.skipInitialClear = true;
            }
            this._renderTargetTextures.push(renderTargetTexture);
            return renderTargetTexture;
        }
        _destroyRenderTargetTexture(renderTargetTexture) {
            this._renderTargetTextures.splice(this._renderTargetTextures.indexOf(renderTargetTexture), 1);
            renderTargetTexture.dispose();
        }
        getFramebufferDimensions() {
            return this._framebufferDimensions;
        }
        dispose() {
            this._renderTargetTextures.forEach((rtt) => rtt.dispose());
            this._renderTargetTextures.length = 0;
        }
    }

    /**
     * Wraps xr webgl layers.
     * @internal
     */
    class WebXRWebGLLayerWrapper extends WebXRLayerWrapper {
        /**
         * @param layer is the layer to be wrapped.
         * @returns a new WebXRLayerWrapper wrapping the provided XRWebGLLayer.
         */
        constructor(layer) {
            super(() => layer.framebufferWidth, () => layer.framebufferHeight, layer, "XRWebGLLayer", (sessionManager) => new WebXRWebGLLayerRenderTargetTextureProvider(sessionManager.scene, this));
            this.layer = layer;
        }
    }
    /**
     * Provides render target textures and other important rendering information for a given XRWebGLLayer.
     * @internal
     */
    class WebXRWebGLLayerRenderTargetTextureProvider extends WebXRLayerRenderTargetTextureProvider {
        constructor(scene, layerWrapper) {
            super(scene, layerWrapper);
            this.layerWrapper = layerWrapper;
            this._layer = layerWrapper.layer;
            this._framebufferDimensions = {
                framebufferWidth: this._layer.framebufferWidth,
                framebufferHeight: this._layer.framebufferHeight,
            };
        }
        trySetViewportForView(viewport, view) {
            const xrViewport = this._layer.getViewport(view);
            if (!xrViewport) {
                return false;
            }
            const framebufferWidth = this._framebufferDimensions.framebufferWidth;
            const framebufferHeight = this._framebufferDimensions.framebufferHeight;
            viewport.x = xrViewport.x / framebufferWidth;
            viewport.y = xrViewport.y / framebufferHeight;
            viewport.width = xrViewport.width / framebufferWidth;
            viewport.height = xrViewport.height / framebufferHeight;
            return true;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getRenderTargetTextureForEye(eye) {
            const layerWidth = this._layer.framebufferWidth;
            const layerHeight = this._layer.framebufferHeight;
            const framebuffer = this._layer.framebuffer;
            if (!this._rtt ||
                layerWidth !== this._framebufferDimensions.framebufferWidth ||
                layerHeight !== this._framebufferDimensions.framebufferHeight ||
                framebuffer !== this._framebuffer) {
                this._rtt = this._createRenderTargetTexture(layerWidth, layerHeight, framebuffer);
                this._framebufferDimensions.framebufferWidth = layerWidth;
                this._framebufferDimensions.framebufferHeight = layerHeight;
                this._framebuffer = framebuffer;
            }
            return this._rtt;
        }
        getRenderTargetTextureForView(view) {
            return this.getRenderTargetTextureForEye(view.eye);
        }
    }

    /**
     * Configuration object for WebXR output canvas
     */
    class WebXRManagedOutputCanvasOptions {
        /**
         * Get the default values of the configuration object
         * @param engine defines the engine to use (can be null)
         * @returns default values of this configuration object
         */
        static GetDefaults(engine) {
            const defaults = new WebXRManagedOutputCanvasOptions();
            defaults.canvasOptions = {
                antialias: true,
                depth: true,
                stencil: engine ? engine.isStencilEnable : true,
                alpha: true,
                framebufferScaleFactor: 1,
            };
            defaults.newCanvasCssStyle = "position:absolute; bottom:0px;right:0px;z-index:10;width:90%;height:100%;background-color: #000000;";
            return defaults;
        }
    }
    /**
     * Creates a canvas that is added/removed from the webpage when entering/exiting XR
     */
    class WebXRManagedOutputCanvas {
        /**
         * Initializes the canvas to be added/removed upon entering/exiting xr
         * @param _xrSessionManager The XR Session manager
         * @param _options optional configuration for this canvas output. defaults will be used if not provided
         */
        constructor(_xrSessionManager, _options = WebXRManagedOutputCanvasOptions.GetDefaults()) {
            this._options = _options;
            this._canvas = null;
            this._engine = null;
            /**
             * xr layer for the canvas
             */
            this.xrLayer = null;
            this._xrLayerWrapper = null;
            /**
             * Observers registered here will be triggered when the xr layer was initialized
             */
            this.onXRLayerInitObservable = new Observable$1();
            this._engine = _xrSessionManager.scene.getEngine();
            this._engine.onDisposeObservable.addOnce(() => {
                this._engine = null;
            });
            if (!_options.canvasElement) {
                const canvas = document.createElement("canvas");
                canvas.style.cssText = this._options.newCanvasCssStyle || "position:absolute; bottom:0px;right:0px;";
                this._setManagedOutputCanvas(canvas);
            }
            else {
                this._setManagedOutputCanvas(_options.canvasElement);
            }
            _xrSessionManager.onXRSessionInit.add(() => {
                this._addCanvas();
            });
            _xrSessionManager.onXRSessionEnded.add(() => {
                this._removeCanvas();
            });
        }
        /**
         * Disposes of the object
         */
        dispose() {
            this._removeCanvas();
            this._setManagedOutputCanvas(null);
        }
        /**
         * Initializes a XRWebGLLayer to be used as the session's baseLayer.
         * @param xrSession xr session
         * @returns a promise that will resolve once the XR Layer has been created
         */
        async initializeXRLayerAsync(xrSession) {
            const createLayer = () => {
                this.xrLayer = new XRWebGLLayer(xrSession, this.canvasContext, this._options.canvasOptions);
                this._xrLayerWrapper = new WebXRWebGLLayerWrapper(this.xrLayer);
                this.onXRLayerInitObservable.notifyObservers(this.xrLayer);
                return this.xrLayer;
            };
            // support canvases without makeXRCompatible
            if (!this.canvasContext.makeXRCompatible) {
                return Promise.resolve(createLayer());
            }
            return this.canvasContext
                .makeXRCompatible()
                .then(
            // catch any error and continue. When using the emulator is throws this error for no apparent reason.
            () => { }, () => {
                // log the error, continue nonetheless!
                Tools.Warn("Error executing makeXRCompatible. This does not mean that the session will work incorrectly.");
            })
                .then(() => {
                return createLayer();
            });
        }
        _addCanvas() {
            if (this._canvas && this._engine && this._canvas !== this._engine.getRenderingCanvas()) {
                document.body.appendChild(this._canvas);
            }
            if (this.xrLayer) {
                this._setCanvasSize(true);
            }
            else {
                this.onXRLayerInitObservable.addOnce(() => {
                    this._setCanvasSize(true);
                });
            }
        }
        _removeCanvas() {
            if (this._canvas && this._engine && document.body.contains(this._canvas) && this._canvas !== this._engine.getRenderingCanvas()) {
                document.body.removeChild(this._canvas);
            }
            this._setCanvasSize(false);
        }
        _setCanvasSize(init = true, xrLayer = this._xrLayerWrapper) {
            if (!this._canvas || !this._engine) {
                return;
            }
            if (init) {
                if (xrLayer) {
                    if (this._canvas !== this._engine.getRenderingCanvas()) {
                        this._canvas.style.width = xrLayer.getWidth() + "px";
                        this._canvas.style.height = xrLayer.getHeight() + "px";
                    }
                    else {
                        this._engine.setSize(xrLayer.getWidth(), xrLayer.getHeight());
                    }
                }
            }
            else {
                if (this._originalCanvasSize) {
                    if (this._canvas !== this._engine.getRenderingCanvas()) {
                        this._canvas.style.width = this._originalCanvasSize.width + "px";
                        this._canvas.style.height = this._originalCanvasSize.height + "px";
                    }
                    else {
                        this._engine.setSize(this._originalCanvasSize.width, this._originalCanvasSize.height);
                    }
                }
            }
        }
        _setManagedOutputCanvas(canvas) {
            this._removeCanvas();
            if (!canvas) {
                this._canvas = null;
                this.canvasContext = null;
            }
            else {
                this._originalCanvasSize = {
                    width: canvas.offsetWidth,
                    height: canvas.offsetHeight,
                };
                this._canvas = canvas;
                this.canvasContext = this._canvas.getContext("webgl2");
                if (!this.canvasContext) {
                    this.canvasContext = this._canvas.getContext("webgl");
                }
            }
        }
    }

    /**
     * Wraps XRWebGLLayer's created by Babylon Native.
     * @internal
     */
    class NativeXRLayerWrapper extends WebXRLayerWrapper {
        constructor(layer) {
            super(() => layer.framebufferWidth, () => layer.framebufferHeight, layer, "XRWebGLLayer", (sessionManager) => new NativeXRLayerRenderTargetTextureProvider(sessionManager, this));
            this.layer = layer;
        }
    }
    /**
     * Provides render target textures for layers created by Babylon Native.
     * @internal
     */
    class NativeXRLayerRenderTargetTextureProvider extends WebXRLayerRenderTargetTextureProvider {
        constructor(sessionManager, layerWrapper) {
            super(sessionManager.scene, layerWrapper);
            this.layerWrapper = layerWrapper;
            this._nativeRTTProvider = navigator.xr.getNativeRenderTargetProvider(sessionManager.session, this._createRenderTargetTexture.bind(this), this._destroyRenderTargetTexture.bind(this));
            this._nativeLayer = layerWrapper.layer;
        }
        trySetViewportForView(viewport) {
            viewport.x = 0;
            viewport.y = 0;
            viewport.width = 1;
            viewport.height = 1;
            return true;
        }
        getRenderTargetTextureForEye(eye) {
            // TODO (rgerd): Update the contract on the BabylonNative side to call this "getRenderTargetTextureForEye"
            return this._nativeRTTProvider.getRenderTargetForEye(eye);
        }
        getRenderTargetTextureForView(view) {
            return this._nativeRTTProvider.getRenderTargetForEye(view.eye);
        }
        getFramebufferDimensions() {
            return {
                framebufferWidth: this._nativeLayer.framebufferWidth,
                framebufferHeight: this._nativeLayer.framebufferHeight,
            };
        }
    }
    /**
     * Creates the xr layer that will be used as the xr session's base layer.
     * @internal
     */
    class NativeXRRenderTarget {
        constructor(_xrSessionManager) {
            this._nativeRenderTarget = navigator.xr.getWebXRRenderTarget(_xrSessionManager.scene.getEngine());
        }
        async initializeXRLayerAsync(xrSession) {
            await this._nativeRenderTarget.initializeXRLayerAsync(xrSession);
            this.xrLayer = this._nativeRenderTarget.xrLayer;
            return this.xrLayer;
        }
        dispose() {
            /* empty */
        }
    }

    /**
     * Manages an XRSession to work with Babylon's engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/webXR/webXRSessionManagers
     */
    class WebXRSessionManager {
        /**
         * Constructs a WebXRSessionManager, this must be initialized within a user action before usage
         * @param scene The scene which the session should be created for
         */
        constructor(
        /** The scene which the session should be created for */
        scene) {
            this.scene = scene;
            /** WebXR timestamp updated every frame */
            this.currentTimestamp = -1;
            /**
             * Used just in case of a failure to initialize an immersive session.
             * The viewer reference space is compensated using this height, creating a kind of "viewer-floor" reference space
             */
            this.defaultHeightCompensation = 1.7;
            /**
             * Fires every time a new xrFrame arrives which can be used to update the camera
             */
            this.onXRFrameObservable = new Observable$1();
            /**
             * Fires when the reference space changed
             */
            this.onXRReferenceSpaceChanged = new Observable$1();
            /**
             * Fires when the xr session is ended either by the device or manually done
             */
            this.onXRSessionEnded = new Observable$1();
            /**
             * Fires when the xr session is initialized: right after requestSession was called and returned with a successful result
             */
            this.onXRSessionInit = new Observable$1();
            /**
             * Are we currently in the XR loop?
             */
            this.inXRFrameLoop = false;
            /**
             * Are we in an XR session?
             */
            this.inXRSession = false;
            this._engine = scene.getEngine();
            this._onEngineDisposedObserver = this._engine.onDisposeObservable.addOnce(() => {
                this._engine = null;
            });
            scene.onDisposeObservable.addOnce(() => {
                this.dispose();
            });
        }
        /**
         * The current reference space used in this session. This reference space can constantly change!
         * It is mainly used to offset the camera's position.
         */
        get referenceSpace() {
            return this._referenceSpace;
        }
        /**
         * Set a new reference space and triggers the observable
         */
        set referenceSpace(newReferenceSpace) {
            this._referenceSpace = newReferenceSpace;
            this.onXRReferenceSpaceChanged.notifyObservers(this._referenceSpace);
        }
        /**
         * The mode for the managed XR session
         */
        get sessionMode() {
            return this._sessionMode;
        }
        /**
         * Disposes of the session manager
         * This should be called explicitly by the dev, if required.
         */
        dispose() {
            var _a;
            // disposing without leaving XR? Exit XR first
            if (this.inXRSession) {
                this.exitXRAsync();
            }
            this.onXRFrameObservable.clear();
            this.onXRSessionEnded.clear();
            this.onXRReferenceSpaceChanged.clear();
            this.onXRSessionInit.clear();
            (_a = this._engine) === null || _a === void 0 ? void 0 : _a.onDisposeObservable.remove(this._onEngineDisposedObserver);
            this._engine = null;
        }
        /**
         * Stops the xrSession and restores the render loop
         * @returns Promise which resolves after it exits XR
         */
        exitXRAsync() {
            if (this.session && this.inXRSession) {
                this.inXRSession = false;
                return this.session.end().catch(() => {
                    Logger.Warn("Could not end XR session.");
                });
            }
            return Promise.resolve();
        }
        /**
         * Attempts to set the framebuffer-size-normalized viewport to be rendered this frame for this view.
         * In the event of a failure, the supplied viewport is not updated.
         * @param viewport the viewport to which the view will be rendered
         * @param view the view for which to set the viewport
         * @returns whether the operation was successful
         */
        trySetViewportForView(viewport, view) {
            var _a;
            return ((_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.trySetViewportForView(viewport, view)) || false;
        }
        /**
         * Gets the correct render target texture to be rendered this frame for this eye
         * @param eye the eye for which to get the render target
         * @returns the render target for the specified eye or null if not available
         */
        getRenderTargetTextureForEye(eye) {
            var _a;
            return ((_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.getRenderTargetTextureForEye(eye)) || null;
        }
        /**
         * Gets the correct render target texture to be rendered this frame for this view
         * @param view the view for which to get the render target
         * @returns the render target for the specified view or null if not available
         */
        getRenderTargetTextureForView(view) {
            var _a;
            return ((_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.getRenderTargetTextureForView(view)) || null;
        }
        /**
         * Creates a WebXRRenderTarget object for the XR session
         * @param options optional options to provide when creating a new render target
         * @returns a WebXR render target to which the session can render
         */
        getWebXRRenderTarget(options) {
            const engine = this.scene.getEngine();
            if (this._xrNavigator.xr.native) {
                return new NativeXRRenderTarget(this);
            }
            else {
                options = options || WebXRManagedOutputCanvasOptions.GetDefaults(engine);
                options.canvasElement = options.canvasElement || engine.getRenderingCanvas() || undefined;
                return new WebXRManagedOutputCanvas(this, options);
            }
        }
        /**
         * Initializes the manager
         * After initialization enterXR can be called to start an XR session
         * @returns Promise which resolves after it is initialized
         */
        initializeAsync() {
            // Check if the browser supports webXR
            this._xrNavigator = navigator;
            if (!this._xrNavigator.xr) {
                return Promise.reject("WebXR not available");
            }
            return Promise.resolve();
        }
        /**
         * Initializes an xr session
         * @param xrSessionMode mode to initialize
         * @param xrSessionInit defines optional and required values to pass to the session builder
         * @returns a promise which will resolve once the session has been initialized
         */
        initializeSessionAsync(xrSessionMode = "immersive-vr", xrSessionInit = {}) {
            return this._xrNavigator.xr.requestSession(xrSessionMode, xrSessionInit).then((session) => {
                this.session = session;
                this._sessionMode = xrSessionMode;
                this.onXRSessionInit.notifyObservers(session);
                this.inXRSession = true;
                // handle when the session is ended (By calling session.end or device ends its own session eg. pressing home button on phone)
                this.session.addEventListener("end", () => {
                    var _a;
                    this.inXRSession = false;
                    // Notify frame observers
                    this.onXRSessionEnded.notifyObservers(null);
                    if (this._engine) {
                        // make sure dimensions object is restored
                        this._engine.framebufferDimensionsObject = null;
                        // Restore frame buffer to avoid clear on xr framebuffer after session end
                        this._engine.restoreDefaultFramebuffer();
                        // Need to restart render loop as after the session is ended the last request for new frame will never call callback
                        this._engine.customAnimationFrameRequester = null;
                        this._engine._renderLoop();
                    }
                    // Dispose render target textures.
                    // Only dispose on native because we can't destroy opaque textures on browser.
                    if (this.isNative) {
                        (_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.dispose();
                    }
                    this._baseLayerRTTProvider = null;
                    this._baseLayerWrapper = null;
                }, { once: true });
                return this.session;
            });
        }
        /**
         * Checks if a session would be supported for the creation options specified
         * @param sessionMode session mode to check if supported eg. immersive-vr
         * @returns A Promise that resolves to true if supported and false if not
         */
        isSessionSupportedAsync(sessionMode) {
            return WebXRSessionManager.IsSessionSupportedAsync(sessionMode);
        }
        /**
         * Resets the reference space to the one started the session
         */
        resetReferenceSpace() {
            this.referenceSpace = this.baseReferenceSpace;
        }
        /**
         * Starts rendering to the xr layer
         */
        runXRRenderLoop() {
            var _a;
            if (!this.inXRSession || !this._engine) {
                return;
            }
            // Tell the engine's render loop to be driven by the xr session's refresh rate and provide xr pose information
            this._engine.customAnimationFrameRequester = {
                requestAnimationFrame: this.session.requestAnimationFrame.bind(this.session),
                renderFunction: (timestamp, xrFrame) => {
                    var _a;
                    if (!this.inXRSession || !this._engine) {
                        return;
                    }
                    // Store the XR frame and timestamp in the session manager
                    this.currentFrame = xrFrame;
                    this.currentTimestamp = timestamp;
                    if (xrFrame) {
                        this.inXRFrameLoop = true;
                        this._engine.framebufferDimensionsObject = ((_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.getFramebufferDimensions()) || null;
                        this.onXRFrameObservable.notifyObservers(xrFrame);
                        this._engine._renderLoop();
                        this._engine.framebufferDimensionsObject = null;
                        this.inXRFrameLoop = false;
                    }
                },
            };
            this._engine.framebufferDimensionsObject = ((_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.getFramebufferDimensions()) || null;
            // Stop window's animation frame and trigger sessions animation frame
            if (typeof window !== "undefined" && window.cancelAnimationFrame) {
                window.cancelAnimationFrame(this._engine._frameHandler);
            }
            this._engine._renderLoop();
        }
        /**
         * Sets the reference space on the xr session
         * @param referenceSpaceType space to set
         * @returns a promise that will resolve once the reference space has been set
         */
        setReferenceSpaceTypeAsync(referenceSpaceType = "local-floor") {
            return this.session
                .requestReferenceSpace(referenceSpaceType)
                .then((referenceSpace) => {
                return referenceSpace;
            }, (rejectionReason) => {
                Logger.Error("XR.requestReferenceSpace failed for the following reason: ");
                Logger.Error(rejectionReason);
                Logger.Log('Defaulting to universally-supported "viewer" reference space type.');
                return this.session.requestReferenceSpace("viewer").then((referenceSpace) => {
                    const heightCompensation = new XRRigidTransform({ x: 0, y: -this.defaultHeightCompensation, z: 0 });
                    return referenceSpace.getOffsetReferenceSpace(heightCompensation);
                }, (rejectionReason) => {
                    Logger.Error(rejectionReason);
                    throw 'XR initialization failed: required "viewer" reference space type not supported.';
                });
            })
                .then((referenceSpace) => {
                // create viewer reference space before setting the first reference space
                return this.session.requestReferenceSpace("viewer").then((viewerReferenceSpace) => {
                    this.viewerReferenceSpace = viewerReferenceSpace;
                    return referenceSpace;
                });
            })
                .then((referenceSpace) => {
                // initialize the base and offset (currently the same)
                this.referenceSpace = this.baseReferenceSpace = referenceSpace;
                return this.referenceSpace;
            });
        }
        /**
         * Updates the render state of the session.
         * Note that this is deprecated in favor of WebXRSessionManager.updateRenderState().
         * @param state state to set
         * @returns a promise that resolves once the render state has been updated
         * @deprecated
         */
        updateRenderStateAsync(state) {
            return Promise.resolve(this.session.updateRenderState(state));
        }
        /**
         * @internal
         */
        _setBaseLayerWrapper(baseLayerWrapper) {
            var _a, _b;
            if (this.isNative) {
                (_a = this._baseLayerRTTProvider) === null || _a === void 0 ? void 0 : _a.dispose();
            }
            this._baseLayerWrapper = baseLayerWrapper;
            this._baseLayerRTTProvider = ((_b = this._baseLayerWrapper) === null || _b === void 0 ? void 0 : _b.createRenderTargetTextureProvider(this)) || null;
        }
        /**
         * @internal
         */
        _getBaseLayerWrapper() {
            return this._baseLayerWrapper;
        }
        /**
         * Updates the render state of the session
         * @param state state to set
         */
        updateRenderState(state) {
            if (state.baseLayer) {
                this._setBaseLayerWrapper(this.isNative ? new NativeXRLayerWrapper(state.baseLayer) : new WebXRWebGLLayerWrapper(state.baseLayer));
            }
            this.session.updateRenderState(state);
        }
        /**
         * Returns a promise that resolves with a boolean indicating if the provided session mode is supported by this browser
         * @param sessionMode defines the session to test
         * @returns a promise with boolean as final value
         */
        static IsSessionSupportedAsync(sessionMode) {
            if (!navigator.xr) {
                return Promise.resolve(false);
            }
            // When the specs are final, remove supportsSession!
            const functionToUse = navigator.xr.isSessionSupported || navigator.xr.supportsSession;
            if (!functionToUse) {
                return Promise.resolve(false);
            }
            else {
                return functionToUse
                    .call(navigator.xr, sessionMode)
                    .then((result) => {
                    const returnValue = typeof result === "undefined" ? true : result;
                    return Promise.resolve(returnValue);
                })
                    .catch((e) => {
                    Logger.Warn(e);
                    return Promise.resolve(false);
                });
            }
        }
        /**
         * Returns true if Babylon.js is using the BabylonNative backend, otherwise false
         */
        get isNative() {
            var _a;
            return (_a = this._xrNavigator.xr.native) !== null && _a !== void 0 ? _a : false;
        }
        /**
         * The current frame rate as reported by the device
         */
        get currentFrameRate() {
            var _a;
            return (_a = this.session) === null || _a === void 0 ? void 0 : _a.frameRate;
        }
        /**
         * A list of supported frame rates (only available in-session!
         */
        get supportedFrameRates() {
            var _a;
            return (_a = this.session) === null || _a === void 0 ? void 0 : _a.supportedFrameRates;
        }
        /**
         * Set the framerate of the session.
         * @param rate the new framerate. This value needs to be in the supportedFrameRates array
         * @returns a promise that resolves once the framerate has been set
         */
        updateTargetFrameRate(rate) {
            return this.session.updateTargetFrameRate(rate);
        }
        /**
         * Run a callback in the xr render loop
         * @param callback the callback to call when in XR Frame
         * @param ignoreIfNotInSession if no session is currently running, run it first thing on the next session
         */
        runInXRFrame(callback, ignoreIfNotInSession = true) {
            if (this.inXRFrameLoop) {
                callback();
            }
            else if (this.inXRSession || !ignoreIfNotInSession) {
                this.onXRFrameObservable.addOnce(callback);
            }
        }
        /**
         * Check if fixed foveation is supported on this device
         */
        get isFixedFoveationSupported() {
            var _a;
            return ((_a = this._baseLayerWrapper) === null || _a === void 0 ? void 0 : _a.isFixedFoveationSupported) || false;
        }
        /**
         * Get the fixed foveation currently set, as specified by the webxr specs
         * If this returns null, then fixed foveation is not supported
         */
        get fixedFoveation() {
            var _a;
            return ((_a = this._baseLayerWrapper) === null || _a === void 0 ? void 0 : _a.fixedFoveation) || null;
        }
        /**
         * Set the fixed foveation to the specified value, as specified by the webxr specs
         * This value will be normalized to be between 0 and 1, 1 being max foveation, 0 being no foveation
         */
        set fixedFoveation(value) {
            const val = Math.max(0, Math.min(1, value || 0));
            if (this._baseLayerWrapper) {
                this._baseLayerWrapper.fixedFoveation = val;
            }
        }
        /**
         * Get the features enabled on the current session
         * This is only available in-session!
         * @see https://www.w3.org/TR/webxr/#dom-xrsession-enabledfeatures
         */
        get enabledFeatures() {
            var _a, _b;
            return (_b = (_a = this.session) === null || _a === void 0 ? void 0 : _a.enabledFeatures) !== null && _b !== void 0 ? _b : null;
        }
    }

    /**
     * States of the webXR experience
     */
    var WebXRState;
    (function (WebXRState) {
        /**
         * Transitioning to being in XR mode
         */
        WebXRState[WebXRState["ENTERING_XR"] = 0] = "ENTERING_XR";
        /**
         * Transitioning to non XR mode
         */
        WebXRState[WebXRState["EXITING_XR"] = 1] = "EXITING_XR";
        /**
         * In XR mode and presenting
         */
        WebXRState[WebXRState["IN_XR"] = 2] = "IN_XR";
        /**
         * Not entered XR mode
         */
        WebXRState[WebXRState["NOT_IN_XR"] = 3] = "NOT_IN_XR";
    })(WebXRState || (WebXRState = {}));
    /**
     * The state of the XR camera's tracking
     */
    var WebXRTrackingState;
    (function (WebXRTrackingState) {
        /**
         * No transformation received, device is not being tracked
         */
        WebXRTrackingState[WebXRTrackingState["NOT_TRACKING"] = 0] = "NOT_TRACKING";
        /**
         * Tracking lost - using emulated position
         */
        WebXRTrackingState[WebXRTrackingState["TRACKING_LOST"] = 1] = "TRACKING_LOST";
        /**
         * Transformation tracking works normally
         */
        WebXRTrackingState[WebXRTrackingState["TRACKING"] = 2] = "TRACKING";
    })(WebXRTrackingState || (WebXRTrackingState = {}));

    /**
     * Creates the VertexData for a cylinder, cone or prism
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * height sets the height (y direction) of the cylinder, optional, default 2
     * * diameterTop sets the diameter of the top of the cone, overwrites diameter,  optional, default diameter
     * * diameterBottom sets the diameter of the bottom of the cone, overwrites diameter,  optional, default diameter
     * * diameter sets the diameter of the top and bottom of the cone, optional default 1
     * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
     * * subdivisions` the number of rings along the cylinder height, optional, default 1
     * * arc a number from 0 to 1, to create an unclosed cylinder based on the fraction of the circumference given by the arc value, optional, default 1
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * hasRings when true makes each subdivision independently treated as a face for faceUV and faceColors, optional, default false
     * * enclose when true closes an open cylinder by adding extra flat faces between the height axis and vertical edges, think cut cake
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.height
     * @param options.diameterTop
     * @param options.diameterBottom
     * @param options.diameter
     * @param options.tessellation
     * @param options.subdivisions
     * @param options.arc
     * @param options.faceColors
     * @param options.faceUV
     * @param options.hasRings
     * @param options.enclose
     * @param options.cap
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the cylinder, cone or prism
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function CreateCylinderVertexData(options) {
        const height = options.height || 2;
        let diameterTop = options.diameterTop === 0 ? 0 : options.diameterTop || options.diameter || 1;
        let diameterBottom = options.diameterBottom === 0 ? 0 : options.diameterBottom || options.diameter || 1;
        diameterTop = diameterTop || 0.00001; // Prevent broken normals
        diameterBottom = diameterBottom || 0.00001; // Prevent broken normals
        const tessellation = (options.tessellation || 24) | 0;
        const subdivisions = (options.subdivisions || 1) | 0;
        const hasRings = options.hasRings ? true : false;
        const enclose = options.enclose ? true : false;
        const cap = options.cap === 0 ? 0 : options.cap || Mesh.CAP_ALL;
        const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const faceUV = options.faceUV || new Array(3);
        const faceColors = options.faceColors;
        // default face colors and UV if undefined
        const quadNb = arc !== 1 && enclose ? 2 : 0;
        const ringNb = hasRings ? subdivisions : 1;
        const surfaceNb = 2 + (1 + quadNb) * ringNb;
        let f;
        for (f = 0; f < surfaceNb; f++) {
            if (faceColors && faceColors[f] === undefined) {
                faceColors[f] = new Color4(1, 1, 1, 1);
            }
        }
        for (f = 0; f < surfaceNb; f++) {
            if (faceUV && faceUV[f] === undefined) {
                faceUV[f] = new Vector4(0, 0, 1, 1);
            }
        }
        const indices = new Array();
        const positions = new Array();
        const normals = new Array();
        const uvs = new Array();
        const colors = new Array();
        const angleStep = (Math.PI * 2 * arc) / tessellation;
        let angle;
        let h;
        let radius;
        const tan = (diameterBottom - diameterTop) / 2 / height;
        const ringVertex = Vector3.Zero();
        const ringNormal = Vector3.Zero();
        const ringFirstVertex = Vector3.Zero();
        const ringFirstNormal = Vector3.Zero();
        const quadNormal = Vector3.Zero();
        const Y = Axis.Y;
        // positions, normals, uvs
        let i;
        let j;
        let r;
        let ringIdx = 1;
        let s = 1; // surface index
        let cs = 0;
        let v = 0;
        for (i = 0; i <= subdivisions; i++) {
            h = i / subdivisions;
            radius = (h * (diameterTop - diameterBottom) + diameterBottom) / 2;
            ringIdx = hasRings && i !== 0 && i !== subdivisions ? 2 : 1;
            for (r = 0; r < ringIdx; r++) {
                if (hasRings) {
                    s += r;
                }
                if (enclose) {
                    s += 2 * r;
                }
                for (j = 0; j <= tessellation; j++) {
                    angle = j * angleStep;
                    // position
                    ringVertex.x = Math.cos(-angle) * radius;
                    ringVertex.y = -height / 2 + h * height;
                    ringVertex.z = Math.sin(-angle) * radius;
                    // normal
                    if (diameterTop === 0 && i === subdivisions) {
                        // if no top cap, reuse former normals
                        ringNormal.x = normals[normals.length - (tessellation + 1) * 3];
                        ringNormal.y = normals[normals.length - (tessellation + 1) * 3 + 1];
                        ringNormal.z = normals[normals.length - (tessellation + 1) * 3 + 2];
                    }
                    else {
                        ringNormal.x = ringVertex.x;
                        ringNormal.z = ringVertex.z;
                        ringNormal.y = Math.sqrt(ringNormal.x * ringNormal.x + ringNormal.z * ringNormal.z) * tan;
                        ringNormal.normalize();
                    }
                    // keep first ring vertex values for enclose
                    if (j === 0) {
                        ringFirstVertex.copyFrom(ringVertex);
                        ringFirstNormal.copyFrom(ringNormal);
                    }
                    positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                    normals.push(ringNormal.x, ringNormal.y, ringNormal.z);
                    if (hasRings) {
                        v = cs !== s ? faceUV[s].y : faceUV[s].w;
                    }
                    else {
                        v = faceUV[s].y + (faceUV[s].w - faceUV[s].y) * h;
                    }
                    uvs.push(faceUV[s].x + ((faceUV[s].z - faceUV[s].x) * j) / tessellation, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                    if (faceColors) {
                        colors.push(faceColors[s].r, faceColors[s].g, faceColors[s].b, faceColors[s].a);
                    }
                }
                // if enclose, add four vertices and their dedicated normals
                if (arc !== 1 && enclose) {
                    positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                    positions.push(0, ringVertex.y, 0);
                    positions.push(0, ringVertex.y, 0);
                    positions.push(ringFirstVertex.x, ringFirstVertex.y, ringFirstVertex.z);
                    Vector3.CrossToRef(Y, ringNormal, quadNormal);
                    quadNormal.normalize();
                    normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                    Vector3.CrossToRef(ringFirstNormal, Y, quadNormal);
                    quadNormal.normalize();
                    normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                    if (hasRings) {
                        v = cs !== s ? faceUV[s + 1].y : faceUV[s + 1].w;
                    }
                    else {
                        v = faceUV[s + 1].y + (faceUV[s + 1].w - faceUV[s + 1].y) * h;
                    }
                    uvs.push(faceUV[s + 1].x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                    uvs.push(faceUV[s + 1].z, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                    if (hasRings) {
                        v = cs !== s ? faceUV[s + 2].y : faceUV[s + 2].w;
                    }
                    else {
                        v = faceUV[s + 2].y + (faceUV[s + 2].w - faceUV[s + 2].y) * h;
                    }
                    uvs.push(faceUV[s + 2].x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                    uvs.push(faceUV[s + 2].z, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                    if (faceColors) {
                        colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                        colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                        colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                        colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                    }
                }
                if (cs !== s) {
                    cs = s;
                }
            }
        }
        // indices
        const e = arc !== 1 && enclose ? tessellation + 4 : tessellation; // correction of number of iteration if enclose
        i = 0;
        for (s = 0; s < subdivisions; s++) {
            let i0 = 0;
            let i1 = 0;
            let i2 = 0;
            let i3 = 0;
            for (j = 0; j < tessellation; j++) {
                i0 = i * (e + 1) + j;
                i1 = (i + 1) * (e + 1) + j;
                i2 = i * (e + 1) + (j + 1);
                i3 = (i + 1) * (e + 1) + (j + 1);
                indices.push(i0, i1, i2);
                indices.push(i3, i2, i1);
            }
            if (arc !== 1 && enclose) {
                // if enclose, add two quads
                indices.push(i0 + 2, i1 + 2, i2 + 2);
                indices.push(i3 + 2, i2 + 2, i1 + 2);
                indices.push(i0 + 4, i1 + 4, i2 + 4);
                indices.push(i3 + 4, i2 + 4, i1 + 4);
            }
            i = hasRings ? i + 2 : i + 1;
        }
        // Caps
        const createCylinderCap = (isTop) => {
            const radius = isTop ? diameterTop / 2 : diameterBottom / 2;
            if (radius === 0) {
                return;
            }
            // Cap positions, normals & uvs
            let angle;
            let circleVector;
            let i;
            const u = isTop ? faceUV[surfaceNb - 1] : faceUV[0];
            let c = null;
            if (faceColors) {
                c = isTop ? faceColors[surfaceNb - 1] : faceColors[0];
            }
            // cap center
            const vbase = positions.length / 3;
            const offset = isTop ? height / 2 : -height / 2;
            const center = new Vector3(0, offset, 0);
            positions.push(center.x, center.y, center.z);
            normals.push(0, isTop ? 1 : -1, 0);
            const v = u.y + (u.w - u.y) * 0.5;
            uvs.push(u.x + (u.z - u.x) * 0.5, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
            if (c) {
                colors.push(c.r, c.g, c.b, c.a);
            }
            const textureScale = new Vector2(0.5, 0.5);
            for (i = 0; i <= tessellation; i++) {
                angle = (Math.PI * 2 * i * arc) / tessellation;
                const cos = Math.cos(-angle);
                const sin = Math.sin(-angle);
                circleVector = new Vector3(cos * radius, offset, sin * radius);
                const textureCoordinate = new Vector2(cos * textureScale.x + 0.5, sin * textureScale.y + 0.5);
                positions.push(circleVector.x, circleVector.y, circleVector.z);
                normals.push(0, isTop ? 1 : -1, 0);
                const v = u.y + (u.w - u.y) * textureCoordinate.y;
                uvs.push(u.x + (u.z - u.x) * textureCoordinate.x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                if (c) {
                    colors.push(c.r, c.g, c.b, c.a);
                }
            }
            // Cap indices
            for (i = 0; i < tessellation; i++) {
                if (!isTop) {
                    indices.push(vbase);
                    indices.push(vbase + (i + 1));
                    indices.push(vbase + (i + 2));
                }
                else {
                    indices.push(vbase);
                    indices.push(vbase + (i + 2));
                    indices.push(vbase + (i + 1));
                }
            }
        };
        // add caps to geometry based on cap parameter
        if (cap === Mesh.CAP_START || cap === Mesh.CAP_ALL) {
            createCylinderCap(false);
        }
        if (cap === Mesh.CAP_END || cap === Mesh.CAP_ALL) {
            createCylinderCap(true);
        }
        // Sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        if (faceColors) {
            vertexData.colors = colors;
        }
        return vertexData;
    }
    /**
     * Creates a cylinder or a cone mesh
     * * The parameter `height` sets the height size (float) of the cylinder/cone (float, default 2).
     * * The parameter `diameter` sets the diameter of the top and bottom cap at once (float, default 1).
     * * The parameters `diameterTop` and `diameterBottom` overwrite the parameter `diameter` and set respectively the top cap and bottom cap diameter (floats, default 1). The parameter "diameterBottom" can't be zero.
     * * The parameter `tessellation` sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance.
     * * The parameter `subdivisions` sets the number of rings along the cylinder height (positive integer, default 1).
     * * The parameter `hasRings` (boolean, default false) makes the subdivisions independent from each other, so they become different faces.
     * * The parameter `enclose`  (boolean, default false) adds two extra faces per subdivision to a sliced cylinder to close it around its height axis.
     * * The parameter `cap` sets the way the cylinder is capped. Possible values : BABYLON.Mesh.NO_CAP, BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL (default).
     * * The parameter `arc` (float, default 1) is the ratio (max 1) to apply to the circumference to slice the cylinder.
     * * You can set different colors and different images to each box side by using the parameters `faceColors` (an array of n Color3 elements) and `faceUV` (an array of n Vector4 elements).
     * * The value of n is the number of cylinder faces. If the cylinder has only 1 subdivisions, n equals : top face + cylinder surface + bottom face = 3
     * * Now, if the cylinder has 5 independent subdivisions (hasRings = true), n equals : top face + 5 stripe surfaces + bottom face = 2 + 5 = 7
     * * Finally, if the cylinder has 5 independent subdivisions and is enclose, n equals : top face + 5 x (stripe surface + 2 closing faces) + bottom face = 2 + 5 * 3 = 17
     * * Each array (color or UVs) is always ordered the same way : the first element is the bottom cap, the last element is the top cap. The other elements are each a ring surface.
     * * If `enclose` is false, a ring surface is one element.
     * * If `enclose` is true, a ring surface is 3 successive elements in the array : the tubular surface, then the two closing faces.
     * * Example how to set colors and textures on a sliced cylinder : https://www.html5gamedevs.com/topic/17945-creating-a-closed-slice-of-a-cylinder/#comment-106379
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.height
     * @param options.diameterTop
     * @param options.diameterBottom
     * @param options.diameter
     * @param options.tessellation
     * @param options.subdivisions
     * @param options.arc
     * @param options.faceColors
     * @param options.faceUV
     * @param options.updatable
     * @param options.hasRings
     * @param options.enclose
     * @param options.cap
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param scene defines the hosting scene
     * @returns the cylinder mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#cylinder-or-cone
     */
    function CreateCylinder(name, options = {}, scene) {
        const cylinder = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        cylinder._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateCylinderVertexData(options);
        vertexData.applyToMesh(cylinder, options.updatable);
        return cylinder;
    }
    /**
     * Class containing static functions to help procedurally build meshes
     * @deprecated Please use CreateCylinder directly
     */
    const CylinderBuilder = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreateCylinder,
    };
    VertexData.CreateCylinder = CreateCylinderVertexData;
    Mesh.CreateCylinder = (name, height, diameterTop, diameterBottom, tessellation, subdivisions, scene, updatable, sideOrientation) => {
        if (scene === undefined || !(scene instanceof Scene)) {
            if (scene !== undefined) {
                sideOrientation = updatable || Mesh.DEFAULTSIDE;
                updatable = scene;
            }
            scene = subdivisions;
            subdivisions = 1;
        }
        const options = {
            height,
            diameterTop,
            diameterBottom,
            tessellation,
            subdivisions,
            sideOrientation,
            updatable,
        };
        return CreateCylinder(name, options, scene);
    };

    /**
     * Creates the VertexData for a torus
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * diameter the diameter of the torus, optional default 1
     * * thickness the diameter of the tube forming the torus, optional default 0.5
     * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.diameter
     * @param options.thickness
     * @param options.tessellation
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the torus
     */
    function CreateTorusVertexData(options) {
        const indices = [];
        const positions = [];
        const normals = [];
        const uvs = [];
        const diameter = options.diameter || 1;
        const thickness = options.thickness || 0.5;
        const tessellation = (options.tessellation || 16) | 0;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const stride = tessellation + 1;
        for (let i = 0; i <= tessellation; i++) {
            const u = i / tessellation;
            const outerAngle = (i * Math.PI * 2.0) / tessellation - Math.PI / 2.0;
            const transform = Matrix.Translation(diameter / 2.0, 0, 0).multiply(Matrix.RotationY(outerAngle));
            for (let j = 0; j <= tessellation; j++) {
                const v = 1 - j / tessellation;
                const innerAngle = (j * Math.PI * 2.0) / tessellation + Math.PI;
                const dx = Math.cos(innerAngle);
                const dy = Math.sin(innerAngle);
                // Create a vertex.
                let normal = new Vector3(dx, dy, 0);
                let position = normal.scale(thickness / 2);
                const textureCoordinate = new Vector2(u, v);
                position = Vector3.TransformCoordinates(position, transform);
                normal = Vector3.TransformNormal(normal, transform);
                positions.push(position.x, position.y, position.z);
                normals.push(normal.x, normal.y, normal.z);
                uvs.push(textureCoordinate.x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - textureCoordinate.y : textureCoordinate.y);
                // And create indices for two triangles.
                const nextI = (i + 1) % stride;
                const nextJ = (j + 1) % stride;
                indices.push(i * stride + j);
                indices.push(i * stride + nextJ);
                indices.push(nextI * stride + j);
                indices.push(i * stride + nextJ);
                indices.push(nextI * stride + nextJ);
                indices.push(nextI * stride + j);
            }
        }
        // Sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a torus mesh
     * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
     * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
     * * The parameter `tessellation` sets the number of torus sides (positive integer, default 16)
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.diameter
     * @param options.thickness
     * @param options.tessellation
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param scene defines the hosting scene
     * @returns the torus mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#torus
     */
    function CreateTorus(name, options = {}, scene) {
        const torus = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        torus._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateTorusVertexData(options);
        vertexData.applyToMesh(torus, options.updatable);
        return torus;
    }
    VertexData.CreateTorus = CreateTorusVertexData;
    Mesh.CreateTorus = (name, diameter, thickness, tessellation, scene, updatable, sideOrientation) => {
        const options = {
            diameter,
            thickness,
            tessellation,
            sideOrientation,
            updatable,
        };
        return CreateTorus(name, options, scene);
    };

    class VRExperienceHelperGazer {
        constructor(scene, gazeTrackerToClone = null) {
            this.scene = scene;
            /** @internal */
            this._pointerDownOnMeshAsked = false;
            /** @internal */
            this._isActionableMesh = false;
            /** @internal */
            this._teleportationRequestInitiated = false;
            /** @internal */
            this._teleportationBackRequestInitiated = false;
            /** @internal */
            this._rotationRightAsked = false;
            /** @internal */
            this._rotationLeftAsked = false;
            /** @internal */
            this._dpadPressed = true;
            /** @internal */
            this._activePointer = false;
            this._id = VRExperienceHelperGazer._IdCounter++;
            // Gaze tracker
            if (!gazeTrackerToClone) {
                this._gazeTracker = CreateTorus("gazeTracker", {
                    diameter: 0.0035,
                    thickness: 0.0025,
                    tessellation: 20,
                    updatable: false,
                }, scene);
                this._gazeTracker.bakeCurrentTransformIntoVertices();
                this._gazeTracker.isPickable = false;
                this._gazeTracker.isVisible = false;
                const targetMat = new StandardMaterial("targetMat", scene);
                targetMat.specularColor = Color3.Black();
                targetMat.emissiveColor = new Color3(0.7, 0.7, 0.7);
                targetMat.backFaceCulling = false;
                this._gazeTracker.material = targetMat;
            }
            else {
                this._gazeTracker = gazeTrackerToClone.clone("gazeTracker");
            }
        }
        /**
         * @internal
         */
        _getForwardRay(length) {
            return new Ray(Vector3.Zero(), new Vector3(0, 0, length));
        }
        /** @internal */
        _selectionPointerDown() {
            this._pointerDownOnMeshAsked = true;
            if (this._currentHit) {
                this.scene.simulatePointerDown(this._currentHit, { pointerId: this._id });
            }
        }
        /** @internal */
        _selectionPointerUp() {
            if (this._currentHit) {
                this.scene.simulatePointerUp(this._currentHit, { pointerId: this._id });
            }
            this._pointerDownOnMeshAsked = false;
        }
        /** @internal */
        _activatePointer() {
            this._activePointer = true;
        }
        /** @internal */
        _deactivatePointer() {
            this._activePointer = false;
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _updatePointerDistance(distance = 100) { }
        dispose() {
            this._interactionsEnabled = false;
            this._teleportationEnabled = false;
            if (this._gazeTracker) {
                this._gazeTracker.dispose();
            }
        }
    }
    VRExperienceHelperGazer._IdCounter = 0;
    class VRExperienceHelperControllerGazer extends VRExperienceHelperGazer {
        constructor(webVRController, scene, gazeTrackerToClone) {
            super(scene, gazeTrackerToClone);
            this.webVRController = webVRController;
            // Laser pointer
            this._laserPointer = CreateCylinder("laserPointer", {
                updatable: false,
                height: 1,
                diameterTop: 0.004,
                diameterBottom: 0.0002,
                tessellation: 20,
                subdivisions: 1,
            }, scene);
            const laserPointerMaterial = new StandardMaterial("laserPointerMat", scene);
            laserPointerMaterial.emissiveColor = new Color3(0.7, 0.7, 0.7);
            laserPointerMaterial.alpha = 0.6;
            this._laserPointer.material = laserPointerMaterial;
            this._laserPointer.rotation.x = Math.PI / 2;
            this._laserPointer.position.z = -0.5;
            this._laserPointer.isVisible = false;
            this._laserPointer.isPickable = false;
            if (!webVRController.mesh) {
                // Create an empty mesh that is used prior to loading the high quality model
                const preloadMesh = new Mesh("preloadControllerMesh", scene);
                const preloadPointerPose = new Mesh(PoseEnabledController.POINTING_POSE, scene);
                preloadPointerPose.rotation.x = -0.7;
                preloadMesh.addChild(preloadPointerPose);
                webVRController.attachToMesh(preloadMesh);
            }
            this._setLaserPointerParent(webVRController.mesh);
            this._meshAttachedObserver = webVRController._meshAttachedObservable.add((mesh) => {
                this._setLaserPointerParent(mesh);
            });
        }
        _getForwardRay(length) {
            return this.webVRController.getForwardRay(length);
        }
        /** @internal */
        _activatePointer() {
            super._activatePointer();
            this._laserPointer.isVisible = true;
        }
        /** @internal */
        _deactivatePointer() {
            super._deactivatePointer();
            this._laserPointer.isVisible = false;
        }
        /**
         * @internal
         */
        _setLaserPointerColor(color) {
            this._laserPointer.material.emissiveColor = color;
        }
        /**
         * @internal
         */
        _setLaserPointerLightingDisabled(disabled) {
            this._laserPointer.material.disableLighting = disabled;
        }
        /**
         * @internal
         */
        _setLaserPointerParent(mesh) {
            const makeNotPick = (root) => {
                root.isPickable = false;
                root.getChildMeshes().forEach((c) => {
                    makeNotPick(c);
                });
            };
            makeNotPick(mesh);
            const meshChildren = mesh.getChildren(undefined, false);
            let laserParent = mesh;
            this.webVRController._pointingPoseNode = null;
            for (let i = 0; i < meshChildren.length; i++) {
                if (meshChildren[i].name && meshChildren[i].name.indexOf(PoseEnabledController.POINTING_POSE) >= 0) {
                    laserParent = meshChildren[i];
                    this.webVRController._pointingPoseNode = laserParent;
                    break;
                }
            }
            this._laserPointer.parent = laserParent;
        }
        _updatePointerDistance(distance = 100) {
            this._laserPointer.scaling.y = distance;
            this._laserPointer.position.z = -distance / 2;
        }
        dispose() {
            super.dispose();
            this._laserPointer.dispose();
            if (this._meshAttachedObserver) {
                this.webVRController._meshAttachedObservable.remove(this._meshAttachedObserver);
            }
        }
    }
    class VRExperienceHelperCameraGazer extends VRExperienceHelperGazer {
        constructor(_getCamera, scene) {
            super(scene);
            this._getCamera = _getCamera;
        }
        _getForwardRay(length) {
            const camera = this._getCamera();
            if (camera) {
                return camera.getForwardRay(length);
            }
            else {
                return new Ray(Vector3.Zero(), Vector3.Forward());
            }
        }
    }
    /**
     * Helps to quickly add VR support to an existing scene.
     * See https://doc.babylonjs.com/features/featuresDeepDive/cameras/webVRHelper
     * @deprecated
     */
    class VRExperienceHelper {
        /** Return this.onEnteringVRObservable
         * Note: This one is for backward compatibility. Please use onEnteringVRObservable directly
         */
        get onEnteringVR() {
            return this.onEnteringVRObservable;
        }
        /** Return this.onExitingVRObservable
         * Note: This one is for backward compatibility. Please use onExitingVRObservable directly
         */
        get onExitingVR() {
            return this.onExitingVRObservable;
        }
        /** Return this.onControllerMeshLoadedObservable
         * Note: This one is for backward compatibility. Please use onControllerMeshLoadedObservable directly
         */
        get onControllerMeshLoaded() {
            return this.onControllerMeshLoadedObservable;
        }
        /**
         * The mesh used to display where the user is going to teleport.
         */
        get teleportationTarget() {
            return this._teleportationTarget;
        }
        /**
         * Sets the mesh to be used to display where the user is going to teleport.
         */
        set teleportationTarget(value) {
            if (value) {
                value.name = "teleportationTarget";
                this._isDefaultTeleportationTarget = false;
                this._teleportationTarget = value;
            }
        }
        /**
         * The mesh used to display where the user is selecting, this mesh will be cloned and set as the gazeTracker for the left and right controller
         * when set bakeCurrentTransformIntoVertices will be called on the mesh.
         * See https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
         */
        get gazeTrackerMesh() {
            return this._cameraGazer._gazeTracker;
        }
        set gazeTrackerMesh(value) {
            if (value) {
                // Dispose of existing meshes
                if (this._cameraGazer._gazeTracker) {
                    this._cameraGazer._gazeTracker.dispose();
                }
                if (this._leftController && this._leftController._gazeTracker) {
                    this._leftController._gazeTracker.dispose();
                }
                if (this._rightController && this._rightController._gazeTracker) {
                    this._rightController._gazeTracker.dispose();
                }
                // Set and create gaze trackers on head and controllers
                this._cameraGazer._gazeTracker = value;
                this._cameraGazer._gazeTracker.bakeCurrentTransformIntoVertices();
                this._cameraGazer._gazeTracker.isPickable = false;
                this._cameraGazer._gazeTracker.isVisible = false;
                this._cameraGazer._gazeTracker.name = "gazeTracker";
                if (this._leftController) {
                    this._leftController._gazeTracker = this._cameraGazer._gazeTracker.clone("gazeTracker");
                }
                if (this._rightController) {
                    this._rightController._gazeTracker = this._cameraGazer._gazeTracker.clone("gazeTracker");
                }
            }
        }
        /**
         * The gaze tracking mesh corresponding to the left controller
         */
        get leftControllerGazeTrackerMesh() {
            if (this._leftController) {
                return this._leftController._gazeTracker;
            }
            return null;
        }
        /**
         * The gaze tracking mesh corresponding to the right controller
         */
        get rightControllerGazeTrackerMesh() {
            if (this._rightController) {
                return this._rightController._gazeTracker;
            }
            return null;
        }
        /**
         * If the ray of the gaze should be displayed.
         */
        get displayGaze() {
            return this._displayGaze;
        }
        /**
         * Sets if the ray of the gaze should be displayed.
         */
        set displayGaze(value) {
            this._displayGaze = value;
            if (!value) {
                this._cameraGazer._gazeTracker.isVisible = false;
                if (this._leftController) {
                    this._leftController._gazeTracker.isVisible = false;
                }
                if (this._rightController) {
                    this._rightController._gazeTracker.isVisible = false;
                }
            }
        }
        /**
         * If the ray of the LaserPointer should be displayed.
         */
        get displayLaserPointer() {
            return this._displayLaserPointer;
        }
        /**
         * Sets if the ray of the LaserPointer should be displayed.
         */
        set displayLaserPointer(value) {
            this._displayLaserPointer = value;
            if (!value) {
                if (this._rightController) {
                    this._rightController._deactivatePointer();
                    this._rightController._gazeTracker.isVisible = false;
                }
                if (this._leftController) {
                    this._leftController._deactivatePointer();
                    this._leftController._gazeTracker.isVisible = false;
                }
            }
            else {
                if (this._rightController) {
                    this._rightController._activatePointer();
                }
                if (this._leftController) {
                    this._leftController._activatePointer();
                }
            }
        }
        /**
         * The deviceOrientationCamera used as the camera when not in VR.
         */
        get deviceOrientationCamera() {
            return this._deviceOrientationCamera;
        }
        /**
         * Based on the current WebVR support, returns the current VR camera used.
         */
        get currentVRCamera() {
            if (this._webVRready) {
                return this._webVRCamera;
            }
            else {
                return this._scene.activeCamera;
            }
        }
        /**
         * The webVRCamera which is used when in VR.
         */
        get webVRCamera() {
            return this._webVRCamera;
        }
        /**
         * The deviceOrientationCamera that is used as a fallback when vr device is not connected.
         */
        get vrDeviceOrientationCamera() {
            return this._vrDeviceOrientationCamera;
        }
        /**
         * The html button that is used to trigger entering into VR.
         */
        get vrButton() {
            return this._btnVR;
        }
        get _teleportationRequestInitiated() {
            const result = this._cameraGazer._teleportationRequestInitiated ||
                (this._leftController !== null && this._leftController._teleportationRequestInitiated) ||
                (this._rightController !== null && this._rightController._teleportationRequestInitiated);
            return result;
        }
        /**
         * Instantiates a VRExperienceHelper.
         * Helps to quickly add VR support to an existing scene.
         * @param scene The scene the VRExperienceHelper belongs to.
         * @param webVROptions Options to modify the vr experience helper's behavior.
         */
        constructor(scene, 
        /** Options to modify the vr experience helper's behavior. */
        webVROptions = {}) {
            this.webVROptions = webVROptions;
            // Can the system support WebVR, even if a headset isn't plugged in?
            this._webVRsupported = false;
            // If WebVR is supported, is a headset plugged in and are we ready to present?
            this._webVRready = false;
            // Are we waiting for the requestPresent callback to complete?
            this._webVRrequesting = false;
            // Are we presenting to the headset right now? (this is the vrDevice state)
            this._webVRpresenting = false;
            // Are we presenting in the fullscreen fallback?
            this._fullscreenVRpresenting = false;
            /**
             * Gets or sets a boolean indicating that gaze can be enabled even if pointer lock is not engage (useful on iOS where fullscreen mode and pointer lock are not supported)
             */
            this.enableGazeEvenWhenNoPointerLock = false;
            /**
             * Gets or sets a boolean indicating that the VREXperienceHelper will exit VR if double tap is detected
             */
            this.exitVROnDoubleTap = true;
            /**
             * Observable raised right before entering VR.
             */
            this.onEnteringVRObservable = new Observable$1();
            /**
             * Observable raised when entering VR has completed.
             */
            this.onAfterEnteringVRObservable = new Observable$1();
            /**
             * Observable raised when exiting VR.
             */
            this.onExitingVRObservable = new Observable$1();
            /**
             * Observable raised when controller mesh is loaded.
             */
            this.onControllerMeshLoadedObservable = new Observable$1();
            this._useCustomVRButton = false;
            this._teleportationRequested = false;
            this._teleportActive = false;
            this._floorMeshesCollection = [];
            this._teleportationMode = VRExperienceHelper.TELEPORTATIONMODE_CONSTANTTIME;
            this._teleportationTime = 122;
            this._teleportationSpeed = 20;
            this._rotationAllowed = true;
            this._teleportBackwardsVector = new Vector3(0, -1, -1);
            this._isDefaultTeleportationTarget = true;
            this._teleportationFillColor = "#444444";
            this._teleportationBorderColor = "#FFFFFF";
            this._rotationAngle = 0;
            this._haloCenter = new Vector3(0, 0, 0);
            this._padSensibilityUp = 0.65;
            this._padSensibilityDown = 0.35;
            this._leftController = null;
            this._rightController = null;
            this._gazeColor = new Color3(0.7, 0.7, 0.7);
            this._laserColor = new Color3(0.7, 0.7, 0.7);
            this._pickedLaserColor = new Color3(0.2, 0.2, 1);
            this._pickedGazeColor = new Color3(0, 0, 1);
            /**
             * Observable raised when a new mesh is selected based on meshSelectionPredicate
             */
            this.onNewMeshSelected = new Observable$1();
            /**
             * Observable raised when a new mesh is selected based on meshSelectionPredicate.
             * This observable will provide the mesh and the controller used to select the mesh
             */
            this.onMeshSelectedWithController = new Observable$1();
            /**
             * Observable raised when a new mesh is picked based on meshSelectionPredicate
             */
            this.onNewMeshPicked = new Observable$1();
            /**
             * Observable raised before camera teleportation
             */
            this.onBeforeCameraTeleport = new Observable$1();
            /**
             *  Observable raised after camera teleportation
             */
            this.onAfterCameraTeleport = new Observable$1();
            /**
             * Observable raised when current selected mesh gets unselected
             */
            this.onSelectedMeshUnselected = new Observable$1();
            /**
             * Set teleportation enabled. If set to false camera teleportation will be disabled but camera rotation will be kept.
             */
            this.teleportationEnabled = true;
            this._teleportationInitialized = false;
            this._interactionsEnabled = false;
            this._interactionsRequested = false;
            this._displayGaze = true;
            this._displayLaserPointer = true;
            /**
             * If the gaze trackers scale should be updated to be constant size when pointing at near/far meshes
             */
            this.updateGazeTrackerScale = true;
            /**
             * If the gaze trackers color should be updated when selecting meshes
             */
            this.updateGazeTrackerColor = true;
            /**
             * If the controller laser color should be updated when selecting meshes
             */
            this.updateControllerLaserColor = true;
            /**
             * Defines whether or not Pointer lock should be requested when switching to
             * full screen.
             */
            this.requestPointerLockOnFullScreen = true;
            /**
             * Was the XR test done already. If this is true AND this.xr exists, xr is initialized.
             * If this is true and no this.xr, xr exists but is not supported, using WebVR.
             */
            this.xrTestDone = false;
            this._onResize = () => {
                this._moveButtonToBottomRight();
                if (this._fullscreenVRpresenting && this._webVRready) {
                    this.exitVR();
                }
            };
            this._onFullscreenChange = () => {
                this._fullscreenVRpresenting = !!document.fullscreenElement;
                if (!this._fullscreenVRpresenting && this._inputElement) {
                    this.exitVR();
                    if (!this._useCustomVRButton && this._btnVR) {
                        this._btnVR.style.top = this._inputElement.offsetTop + this._inputElement.offsetHeight - 70 + "px";
                        this._btnVR.style.left = this._inputElement.offsetLeft + this._inputElement.offsetWidth - 100 + "px";
                        // make sure the button is visible after setting its position
                        this._updateButtonVisibility();
                    }
                }
            };
            this._cachedAngularSensibility = { angularSensibilityX: null, angularSensibilityY: null, angularSensibility: null };
            this._beforeRender = () => {
                if (this._leftController && this._leftController._activePointer) {
                    this._castRayAndSelectObject(this._leftController);
                }
                if (this._rightController && this._rightController._activePointer) {
                    this._castRayAndSelectObject(this._rightController);
                }
                if (this._noControllerIsActive && (this._scene.getEngine().isPointerLock || this.enableGazeEvenWhenNoPointerLock)) {
                    this._castRayAndSelectObject(this._cameraGazer);
                }
                else {
                    this._cameraGazer._gazeTracker.isVisible = false;
                }
            };
            this._onNewGamepadConnected = (gamepad) => {
                if (gamepad.type !== Gamepad.POSE_ENABLED) {
                    if (gamepad.leftStick) {
                        gamepad.onleftstickchanged((stickValues) => {
                            if (this._teleportationInitialized && this.teleportationEnabled) {
                                // Listening to classic/xbox gamepad only if no VR controller is active
                                if ((!this._leftController && !this._rightController) ||
                                    (this._leftController && !this._leftController._activePointer && this._rightController && !this._rightController._activePointer)) {
                                    this._checkTeleportWithRay(stickValues, this._cameraGazer);
                                    this._checkTeleportBackwards(stickValues, this._cameraGazer);
                                }
                            }
                        });
                    }
                    if (gamepad.rightStick) {
                        gamepad.onrightstickchanged((stickValues) => {
                            if (this._teleportationInitialized) {
                                this._checkRotate(stickValues, this._cameraGazer);
                            }
                        });
                    }
                    if (gamepad.type === Gamepad.XBOX) {
                        gamepad.onbuttondown((buttonPressed) => {
                            if (this._interactionsEnabled && buttonPressed === Xbox360Button.A) {
                                this._cameraGazer._selectionPointerDown();
                            }
                        });
                        gamepad.onbuttonup((buttonPressed) => {
                            if (this._interactionsEnabled && buttonPressed === Xbox360Button.A) {
                                this._cameraGazer._selectionPointerUp();
                            }
                        });
                    }
                }
                else {
                    const webVRController = gamepad;
                    const controller = new VRExperienceHelperControllerGazer(webVRController, this._scene, this._cameraGazer._gazeTracker);
                    if (webVRController.hand === "right" || (this._leftController && this._leftController.webVRController != webVRController)) {
                        this._rightController = controller;
                    }
                    else {
                        this._leftController = controller;
                    }
                    this._tryEnableInteractionOnController(controller);
                }
            };
            // This only succeeds if the controller's mesh exists for the controller so this must be called whenever new controller is connected or when mesh is loaded
            this._tryEnableInteractionOnController = (controller) => {
                if (this._interactionsRequested && !controller._interactionsEnabled) {
                    this._enableInteractionOnController(controller);
                }
                if (this._teleportationRequested && !controller._teleportationEnabled) {
                    this._enableTeleportationOnController(controller);
                }
            };
            this._onNewGamepadDisconnected = (gamepad) => {
                if (gamepad instanceof WebVRController) {
                    if (gamepad.hand === "left" && this._leftController != null) {
                        this._leftController.dispose();
                        this._leftController = null;
                    }
                    if (gamepad.hand === "right" && this._rightController != null) {
                        this._rightController.dispose();
                        this._rightController = null;
                    }
                }
            };
            this._workingVector = Vector3.Zero();
            this._workingQuaternion = Quaternion.Identity();
            this._workingMatrix = Matrix.Identity();
            Logger.Warn("WebVR is deprecated. Please avoid using this experience helper and use the WebXR experience helper instead");
            this._scene = scene;
            this._inputElement = scene.getEngine().getInputElement();
            // check for VR support:
            const vrSupported = "getVRDisplays" in navigator;
            // no VR support? force XR but only when it is not set because web vr can work without the getVRDisplays
            if (!vrSupported && webVROptions.useXR === undefined) {
                webVROptions.useXR = true;
            }
            // Parse options
            if (webVROptions.createFallbackVRDeviceOrientationFreeCamera === undefined) {
                webVROptions.createFallbackVRDeviceOrientationFreeCamera = true;
            }
            if (webVROptions.createDeviceOrientationCamera === undefined) {
                webVROptions.createDeviceOrientationCamera = true;
            }
            if (webVROptions.laserToggle === undefined) {
                webVROptions.laserToggle = true;
            }
            if (webVROptions.defaultHeight === undefined) {
                webVROptions.defaultHeight = 1.7;
            }
            if (webVROptions.useCustomVRButton) {
                this._useCustomVRButton = true;
                if (webVROptions.customVRButton) {
                    this._btnVR = webVROptions.customVRButton;
                }
            }
            if (webVROptions.rayLength) {
                this._rayLength = webVROptions.rayLength;
            }
            this._defaultHeight = webVROptions.defaultHeight;
            if (webVROptions.positionScale) {
                this._rayLength *= webVROptions.positionScale;
                this._defaultHeight *= webVROptions.positionScale;
            }
            this._hasEnteredVR = false;
            // Set position
            if (this._scene.activeCamera) {
                this._position = this._scene.activeCamera.position.clone();
            }
            else {
                this._position = new Vector3(0, this._defaultHeight, 0);
            }
            // Set non-vr camera
            if (webVROptions.createDeviceOrientationCamera || !this._scene.activeCamera) {
                this._deviceOrientationCamera = new DeviceOrientationCamera("deviceOrientationVRHelper", this._position.clone(), scene);
                // Copy data from existing camera
                if (this._scene.activeCamera) {
                    this._deviceOrientationCamera.minZ = this._scene.activeCamera.minZ;
                    this._deviceOrientationCamera.maxZ = this._scene.activeCamera.maxZ;
                    // Set rotation from previous camera
                    if (this._scene.activeCamera instanceof TargetCamera && this._scene.activeCamera.rotation) {
                        const targetCamera = this._scene.activeCamera;
                        if (targetCamera.rotationQuaternion) {
                            this._deviceOrientationCamera.rotationQuaternion.copyFrom(targetCamera.rotationQuaternion);
                        }
                        else {
                            this._deviceOrientationCamera.rotationQuaternion.copyFrom(Quaternion.RotationYawPitchRoll(targetCamera.rotation.y, targetCamera.rotation.x, targetCamera.rotation.z));
                        }
                        this._deviceOrientationCamera.rotation = targetCamera.rotation.clone();
                    }
                }
                this._scene.activeCamera = this._deviceOrientationCamera;
                if (this._inputElement) {
                    this._scene.activeCamera.attachControl();
                }
            }
            else {
                this._existingCamera = this._scene.activeCamera;
            }
            if (this.webVROptions.useXR && navigator.xr) {
                // force-check XR session support
                WebXRSessionManager.IsSessionSupportedAsync("immersive-vr").then((supported) => {
                    if (supported) {
                        Logger.Log("Using WebXR. It is recommended to use the WebXRDefaultExperience directly");
                        // it is possible to use XR, let's do it!
                        scene
                            .createDefaultXRExperienceAsync({
                            floorMeshes: webVROptions.floorMeshes || [],
                        })
                            .then((xr) => {
                            this.xr = xr;
                            // connect observables
                            this.xrTestDone = true;
                            this._cameraGazer = new VRExperienceHelperCameraGazer(() => {
                                return this.xr.baseExperience.camera;
                            }, scene);
                            this.xr.baseExperience.onStateChangedObservable.add((state) => {
                                // support for entering / exiting
                                switch (state) {
                                    case WebXRState.ENTERING_XR:
                                        this.onEnteringVRObservable.notifyObservers(this);
                                        if (!this._interactionsEnabled) {
                                            this.xr.pointerSelection.detach();
                                        }
                                        this.xr.pointerSelection.displayLaserPointer = this._displayLaserPointer;
                                        break;
                                    case WebXRState.EXITING_XR:
                                        this.onExitingVRObservable.notifyObservers(this);
                                        // resize to update width and height when exiting vr exits fullscreen
                                        this._scene.getEngine().resize();
                                        break;
                                    case WebXRState.IN_XR:
                                        this._hasEnteredVR = true;
                                        break;
                                    case WebXRState.NOT_IN_XR:
                                        this._hasEnteredVR = false;
                                        break;
                                }
                            });
                        });
                    }
                    else {
                        // XR not supported (thou exists), continue WebVR init
                        this._completeVRInit(scene, webVROptions);
                    }
                });
            }
            else {
                // no XR, continue init synchronous
                this._completeVRInit(scene, webVROptions);
            }
        }
        _completeVRInit(scene, webVROptions) {
            this.xrTestDone = true;
            // Create VR cameras
            if (webVROptions.createFallbackVRDeviceOrientationFreeCamera) {
                if (webVROptions.useMultiview) {
                    if (!webVROptions.vrDeviceOrientationCameraMetrics) {
                        webVROptions.vrDeviceOrientationCameraMetrics = VRCameraMetrics.GetDefault();
                    }
                    webVROptions.vrDeviceOrientationCameraMetrics.multiviewEnabled = true;
                }
                this._vrDeviceOrientationCamera = new VRDeviceOrientationFreeCamera("VRDeviceOrientationVRHelper", this._position, this._scene, true, webVROptions.vrDeviceOrientationCameraMetrics);
                this._vrDeviceOrientationCamera.angularSensibility = Number.MAX_VALUE;
            }
            this._webVRCamera = new WebVRFreeCamera("WebVRHelper", this._position, this._scene, webVROptions);
            this._webVRCamera.useStandingMatrix();
            this._cameraGazer = new VRExperienceHelperCameraGazer(() => {
                return this.currentVRCamera;
            }, scene);
            // Create default button
            if (!this._useCustomVRButton) {
                this._btnVR = document.createElement("BUTTON");
                this._btnVR.className = "babylonVRicon";
                this._btnVR.id = "babylonVRiconbtn";
                this._btnVR.title = "Click to switch to VR";
                const url = !window.SVGSVGElement
                    ? "https://cdn.babylonjs.com/Assets/vrButton.png"
                    : "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%222048%22%20height%3D%221152%22%20viewBox%3D%220%200%202048%201152%22%20version%3D%221.1%22%3E%3Cpath%20transform%3D%22rotate%28180%201024%2C576.0000000000001%29%22%20d%3D%22m1109%2C896q17%2C0%2030%2C-12t13%2C-30t-12.5%2C-30.5t-30.5%2C-12.5l-170%2C0q-18%2C0%20-30.5%2C12.5t-12.5%2C30.5t13%2C30t30%2C12l170%2C0zm-85%2C256q59%2C0%20132.5%2C-1.5t154.5%2C-5.5t164.5%2C-11.5t163%2C-20t150%2C-30t124.5%2C-41.5q23%2C-11%2042%2C-24t38%2C-30q27%2C-25%2041%2C-61.5t14%2C-72.5l0%2C-257q0%2C-123%20-47%2C-232t-128%2C-190t-190%2C-128t-232%2C-47l-81%2C0q-37%2C0%20-68.5%2C14t-60.5%2C34.5t-55.5%2C45t-53%2C45t-53%2C34.5t-55.5%2C14t-55.5%2C-14t-53%2C-34.5t-53%2C-45t-55.5%2C-45t-60.5%2C-34.5t-68.5%2C-14l-81%2C0q-123%2C0%20-232%2C47t-190%2C128t-128%2C190t-47%2C232l0%2C257q0%2C68%2038%2C115t97%2C73q54%2C24%20124.5%2C41.5t150%2C30t163%2C20t164.5%2C11.5t154.5%2C5.5t132.5%2C1.5zm939%2C-298q0%2C39%20-24.5%2C67t-58.5%2C42q-54%2C23%20-122%2C39.5t-143.5%2C28t-155.5%2C19t-157%2C11t-148.5%2C5t-129.5%2C1.5q-59%2C0%20-130%2C-1.5t-148%2C-5t-157%2C-11t-155.5%2C-19t-143.5%2C-28t-122%2C-39.5q-34%2C-14%20-58.5%2C-42t-24.5%2C-67l0%2C-257q0%2C-106%2040.5%2C-199t110%2C-162.5t162.5%2C-109.5t199%2C-40l81%2C0q27%2C0%2052%2C14t50%2C34.5t51%2C44.5t55.5%2C44.5t63.5%2C34.5t74%2C14t74%2C-14t63.5%2C-34.5t55.5%2C-44.5t51%2C-44.5t50%2C-34.5t52%2C-14l14%2C0q37%2C0%2070%2C0.5t64.5%2C4.5t63.5%2C12t68%2C23q71%2C30%20128.5%2C78.5t98.5%2C110t63.5%2C133.5t22.5%2C149l0%2C257z%22%20fill%3D%22white%22%20/%3E%3C/svg%3E%0A";
                let css = ".babylonVRicon { position: absolute; right: 20px; height: 50px; width: 80px; background-color: rgba(51,51,51,0.7); background-image: url(" +
                    url +
                    "); background-size: 80%; background-repeat:no-repeat; background-position: center; border: none; outline: none; transition: transform 0.125s ease-out } .babylonVRicon:hover { transform: scale(1.05) } .babylonVRicon:active {background-color: rgba(51,51,51,1) } .babylonVRicon:focus {background-color: rgba(51,51,51,1) }";
                css += ".babylonVRicon.vrdisplaypresenting { display: none; }";
                // TODO: Add user feedback so that they know what state the VRDisplay is in (disconnected, connected, entering-VR)
                // css += ".babylonVRicon.vrdisplaysupported { }";
                // css += ".babylonVRicon.vrdisplayready { }";
                // css += ".babylonVRicon.vrdisplayrequesting { }";
                const style = document.createElement("style");
                style.appendChild(document.createTextNode(css));
                document.getElementsByTagName("head")[0].appendChild(style);
                this._moveButtonToBottomRight();
            }
            // VR button click event
            if (this._btnVR) {
                this._btnVR.addEventListener("click", () => {
                    if (!this.isInVRMode) {
                        this.enterVR();
                    }
                    else {
                        this._scene.getEngine().disableVR();
                    }
                });
            }
            // Window events
            const hostWindow = this._scene.getEngine().getHostWindow();
            if (!hostWindow) {
                return;
            }
            hostWindow.addEventListener("resize", this._onResize);
            document.addEventListener("fullscreenchange", this._onFullscreenChange, false);
            // Display vr button when headset is connected
            if (webVROptions.createFallbackVRDeviceOrientationFreeCamera) {
                this._displayVRButton();
            }
            else {
                this._scene.getEngine().onVRDisplayChangedObservable.add((e) => {
                    if (e.vrDisplay) {
                        this._displayVRButton();
                    }
                });
            }
            // Exiting VR mode using 'ESC' key on desktop
            this._onKeyDown = (event) => {
                if (event.keyCode === 27 && this.isInVRMode) {
                    this.exitVR();
                }
            };
            document.addEventListener("keydown", this._onKeyDown);
            // Exiting VR mode double tapping the touch screen
            this._scene.onPrePointerObservable.add(() => {
                if (this._hasEnteredVR && this.exitVROnDoubleTap) {
                    this.exitVR();
                    if (this._fullscreenVRpresenting) {
                        this._scene.getEngine().exitFullscreen();
                    }
                }
            }, PointerEventTypes.POINTERDOUBLETAP, false);
            // Listen for WebVR display changes
            this._onVRDisplayChangedBind = (eventArgs) => this._onVRDisplayChanged(eventArgs);
            this._onVrDisplayPresentChangeBind = () => this._onVrDisplayPresentChange();
            this._onVRRequestPresentStart = () => {
                this._webVRrequesting = true;
                this._updateButtonVisibility();
            };
            this._onVRRequestPresentComplete = () => {
                this._webVRrequesting = false;
                this._updateButtonVisibility();
            };
            scene.getEngine().onVRDisplayChangedObservable.add(this._onVRDisplayChangedBind);
            scene.getEngine().onVRRequestPresentStart.add(this._onVRRequestPresentStart);
            scene.getEngine().onVRRequestPresentComplete.add(this._onVRRequestPresentComplete);
            hostWindow.addEventListener("vrdisplaypresentchange", this._onVrDisplayPresentChangeBind);
            scene.onDisposeObservable.add(() => {
                this.dispose();
            });
            // Gamepad connection events
            this._webVRCamera.onControllerMeshLoadedObservable.add((webVRController) => this._onDefaultMeshLoaded(webVRController));
            this._scene.gamepadManager.onGamepadConnectedObservable.add(this._onNewGamepadConnected);
            this._scene.gamepadManager.onGamepadDisconnectedObservable.add(this._onNewGamepadDisconnected);
            this._updateButtonVisibility();
            //create easing functions
            this._circleEase = new CircleEase();
            this._circleEase.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
            this._teleportationEasing = this._circleEase;
            // Allow clicking in the vrDeviceOrientationCamera
            scene.onPointerObservable.add((e) => {
                if (this._interactionsEnabled) {
                    if (scene.activeCamera === this.vrDeviceOrientationCamera && e.event.pointerType === "mouse") {
                        if (e.type === PointerEventTypes.POINTERDOWN) {
                            this._cameraGazer._selectionPointerDown();
                        }
                        else if (e.type === PointerEventTypes.POINTERUP) {
                            this._cameraGazer._selectionPointerUp();
                        }
                    }
                }
            });
            if (this.webVROptions.floorMeshes) {
                this.enableTeleportation({ floorMeshes: this.webVROptions.floorMeshes });
            }
        }
        // Raised when one of the controller has loaded successfully its associated default mesh
        _onDefaultMeshLoaded(webVRController) {
            if (this._leftController && this._leftController.webVRController == webVRController) {
                if (webVRController.mesh) {
                    this._leftController._setLaserPointerParent(webVRController.mesh);
                }
            }
            if (this._rightController && this._rightController.webVRController == webVRController) {
                if (webVRController.mesh) {
                    this._rightController._setLaserPointerParent(webVRController.mesh);
                }
            }
            try {
                this.onControllerMeshLoadedObservable.notifyObservers(webVRController);
            }
            catch (err) {
                Logger.Warn("Error in your custom logic onControllerMeshLoaded: " + err);
            }
        }
        /**
         * Gets a value indicating if we are currently in VR mode.
         */
        get isInVRMode() {
            return (this.xr && this.webVROptions.useXR && this.xr.baseExperience.state === WebXRState.IN_XR) || this._webVRpresenting || this._fullscreenVRpresenting;
        }
        _onVrDisplayPresentChange() {
            const vrDisplay = this._scene.getEngine().getVRDevice();
            if (vrDisplay) {
                const wasPresenting = this._webVRpresenting;
                this._webVRpresenting = vrDisplay.isPresenting;
                if (wasPresenting && !this._webVRpresenting) {
                    this.exitVR();
                }
            }
            else {
                Logger.Warn("Detected VRDisplayPresentChange on an unknown VRDisplay. Did you can enterVR on the vrExperienceHelper?");
            }
            this._updateButtonVisibility();
        }
        _onVRDisplayChanged(eventArgs) {
            this._webVRsupported = eventArgs.vrSupported;
            this._webVRready = !!eventArgs.vrDisplay;
            this._webVRpresenting = eventArgs.vrDisplay && eventArgs.vrDisplay.isPresenting;
            this._updateButtonVisibility();
        }
        _moveButtonToBottomRight() {
            if (this._inputElement && !this._useCustomVRButton && this._btnVR) {
                const rect = this._inputElement.getBoundingClientRect();
                this._btnVR.style.top = rect.top + rect.height - 70 + "px";
                this._btnVR.style.left = rect.left + rect.width - 100 + "px";
            }
        }
        _displayVRButton() {
            if (!this._useCustomVRButton && !this._btnVRDisplayed && this._btnVR) {
                document.body.appendChild(this._btnVR);
                this._btnVRDisplayed = true;
            }
        }
        _updateButtonVisibility() {
            if (!this._btnVR || this._useCustomVRButton) {
                return;
            }
            this._btnVR.className = "babylonVRicon";
            if (this.isInVRMode) {
                this._btnVR.className += " vrdisplaypresenting";
            }
            else {
                if (this._webVRready) {
                    this._btnVR.className += " vrdisplayready";
                }
                if (this._webVRsupported) {
                    this._btnVR.className += " vrdisplaysupported";
                }
                if (this._webVRrequesting) {
                    this._btnVR.className += " vrdisplayrequesting";
                }
            }
        }
        /**
         * Attempt to enter VR. If a headset is connected and ready, will request present on that.
         * Otherwise, will use the fullscreen API.
         */
        enterVR() {
            if (this.xr) {
                this.xr.baseExperience.enterXRAsync("immersive-vr", "local-floor", this.xr.renderTarget);
                return;
            }
            if (this.onEnteringVRObservable) {
                try {
                    this.onEnteringVRObservable.notifyObservers(this);
                }
                catch (err) {
                    Logger.Warn("Error in your custom logic onEnteringVR: " + err);
                }
            }
            if (this._scene.activeCamera) {
                this._position = this._scene.activeCamera.position.clone();
                if (this.vrDeviceOrientationCamera) {
                    this.vrDeviceOrientationCamera.rotation = Quaternion.FromRotationMatrix(this._scene.activeCamera.getWorldMatrix().getRotationMatrix()).toEulerAngles();
                    this.vrDeviceOrientationCamera.angularSensibility = 2000;
                }
                if (this.webVRCamera) {
                    const currentYRotation = this.webVRCamera.deviceRotationQuaternion.toEulerAngles().y;
                    const desiredYRotation = Quaternion.FromRotationMatrix(this._scene.activeCamera.getWorldMatrix().getRotationMatrix()).toEulerAngles().y;
                    const delta = desiredYRotation - currentYRotation;
                    const currentGlobalRotation = this.webVRCamera.rotationQuaternion.toEulerAngles().y;
                    this.webVRCamera.rotationQuaternion = Quaternion.FromEulerAngles(0, currentGlobalRotation + delta, 0);
                }
                // make sure that we return to the last active camera
                this._existingCamera = this._scene.activeCamera;
                // Remove and cache angular sensability to avoid camera rotation when in VR
                if (this._existingCamera.angularSensibilityX) {
                    this._cachedAngularSensibility.angularSensibilityX = this._existingCamera.angularSensibilityX;
                    this._existingCamera.angularSensibilityX = Number.MAX_VALUE;
                }
                if (this._existingCamera.angularSensibilityY) {
                    this._cachedAngularSensibility.angularSensibilityY = this._existingCamera.angularSensibilityY;
                    this._existingCamera.angularSensibilityY = Number.MAX_VALUE;
                }
                if (this._existingCamera.angularSensibility) {
                    this._cachedAngularSensibility.angularSensibility = this._existingCamera.angularSensibility;
                    this._existingCamera.angularSensibility = Number.MAX_VALUE;
                }
            }
            if (this._webVRrequesting) {
                return;
            }
            // If WebVR is supported and a headset is connected
            if (this._webVRready) {
                if (!this._webVRpresenting) {
                    this._scene.getEngine().onVRRequestPresentComplete.addOnce((result) => {
                        this.onAfterEnteringVRObservable.notifyObservers({ success: result });
                    });
                    this._webVRCamera.position = this._position;
                    this._scene.activeCamera = this._webVRCamera;
                }
            }
            else if (this._vrDeviceOrientationCamera) {
                this._vrDeviceOrientationCamera.position = this._position;
                if (this._scene.activeCamera) {
                    this._vrDeviceOrientationCamera.minZ = this._scene.activeCamera.minZ;
                }
                this._scene.activeCamera = this._vrDeviceOrientationCamera;
                this._scene.getEngine().enterFullscreen(this.requestPointerLockOnFullScreen);
                this._updateButtonVisibility();
                this._vrDeviceOrientationCamera.onViewMatrixChangedObservable.addOnce(() => {
                    this.onAfterEnteringVRObservable.notifyObservers({ success: true });
                });
            }
            if (this._scene.activeCamera && this._inputElement) {
                this._scene.activeCamera.attachControl();
            }
            if (this._interactionsEnabled) {
                this._scene.registerBeforeRender(this._beforeRender);
            }
            if (this._displayLaserPointer) {
                [this._leftController, this._rightController].forEach((controller) => {
                    if (controller) {
                        controller._activatePointer();
                    }
                });
            }
            this._hasEnteredVR = true;
        }
        /**
         * Attempt to exit VR, or fullscreen.
         */
        exitVR() {
            if (this.xr) {
                this.xr.baseExperience.exitXRAsync();
                return;
            }
            if (this._hasEnteredVR) {
                if (this.onExitingVRObservable) {
                    try {
                        this.onExitingVRObservable.notifyObservers(this);
                    }
                    catch (err) {
                        Logger.Warn("Error in your custom logic onExitingVR: " + err);
                    }
                }
                if (this._webVRpresenting) {
                    this._scene.getEngine().disableVR();
                }
                if (this._scene.activeCamera) {
                    this._position = this._scene.activeCamera.position.clone();
                }
                if (this.vrDeviceOrientationCamera) {
                    this.vrDeviceOrientationCamera.angularSensibility = Number.MAX_VALUE;
                }
                if (this._deviceOrientationCamera) {
                    this._deviceOrientationCamera.position = this._position;
                    this._scene.activeCamera = this._deviceOrientationCamera;
                    // Restore angular sensibility
                    if (this._cachedAngularSensibility.angularSensibilityX) {
                        this._deviceOrientationCamera.angularSensibilityX = this._cachedAngularSensibility.angularSensibilityX;
                        this._cachedAngularSensibility.angularSensibilityX = null;
                    }
                    if (this._cachedAngularSensibility.angularSensibilityY) {
                        this._deviceOrientationCamera.angularSensibilityY = this._cachedAngularSensibility.angularSensibilityY;
                        this._cachedAngularSensibility.angularSensibilityY = null;
                    }
                    if (this._cachedAngularSensibility.angularSensibility) {
                        this._deviceOrientationCamera.angularSensibility = this._cachedAngularSensibility.angularSensibility;
                        this._cachedAngularSensibility.angularSensibility = null;
                    }
                }
                else if (this._existingCamera) {
                    this._existingCamera.position = this._position;
                    this._scene.activeCamera = this._existingCamera;
                    if (this._inputElement) {
                        this._scene.activeCamera.attachControl();
                    }
                    // Restore angular sensibility
                    if (this._cachedAngularSensibility.angularSensibilityX) {
                        this._existingCamera.angularSensibilityX = this._cachedAngularSensibility.angularSensibilityX;
                        this._cachedAngularSensibility.angularSensibilityX = null;
                    }
                    if (this._cachedAngularSensibility.angularSensibilityY) {
                        this._existingCamera.angularSensibilityY = this._cachedAngularSensibility.angularSensibilityY;
                        this._cachedAngularSensibility.angularSensibilityY = null;
                    }
                    if (this._cachedAngularSensibility.angularSensibility) {
                        this._existingCamera.angularSensibility = this._cachedAngularSensibility.angularSensibility;
                        this._cachedAngularSensibility.angularSensibility = null;
                    }
                }
                this._updateButtonVisibility();
                if (this._interactionsEnabled) {
                    this._scene.unregisterBeforeRender(this._beforeRender);
                    this._cameraGazer._gazeTracker.isVisible = false;
                    if (this._leftController) {
                        this._leftController._gazeTracker.isVisible = false;
                    }
                    if (this._rightController) {
                        this._rightController._gazeTracker.isVisible = false;
                    }
                }
                // resize to update width and height when exiting vr exits fullscreen
                this._scene.getEngine().resize();
                [this._leftController, this._rightController].forEach((controller) => {
                    if (controller) {
                        controller._deactivatePointer();
                    }
                });
                this._hasEnteredVR = false;
                // Update engine state to re enable non-vr camera input
                const engine = this._scene.getEngine();
                if (engine._onVrDisplayPresentChange) {
                    engine._onVrDisplayPresentChange();
                }
            }
        }
        /**
         * The position of the vr experience helper.
         */
        get position() {
            return this._position;
        }
        /**
         * Sets the position of the vr experience helper.
         */
        set position(value) {
            this._position = value;
            if (this._scene.activeCamera) {
                this._scene.activeCamera.position = value;
            }
        }
        /**
         * Enables controllers and user interactions such as selecting and object or clicking on an object.
         */
        enableInteractions() {
            if (!this._interactionsEnabled) {
                this._interactionsRequested = true;
                // in XR it is enabled by default, but just to make sure, re-attach
                if (this.xr) {
                    if (this.xr.baseExperience.state === WebXRState.IN_XR) {
                        this.xr.pointerSelection.attach();
                    }
                    return;
                }
                if (this._leftController) {
                    this._enableInteractionOnController(this._leftController);
                }
                if (this._rightController) {
                    this._enableInteractionOnController(this._rightController);
                }
                this.raySelectionPredicate = (mesh) => {
                    return mesh.isVisible && (mesh.isPickable || mesh.name === this._floorMeshName);
                };
                this.meshSelectionPredicate = () => {
                    return true;
                };
                this._raySelectionPredicate = (mesh) => {
                    if (this._isTeleportationFloor(mesh) ||
                        (mesh.name.indexOf("gazeTracker") === -1 && mesh.name.indexOf("teleportationTarget") === -1 && mesh.name.indexOf("torusTeleportation") === -1)) {
                        return this.raySelectionPredicate(mesh);
                    }
                    return false;
                };
                this._interactionsEnabled = true;
            }
        }
        get _noControllerIsActive() {
            return !(this._leftController && this._leftController._activePointer) && !(this._rightController && this._rightController._activePointer);
        }
        _isTeleportationFloor(mesh) {
            for (let i = 0; i < this._floorMeshesCollection.length; i++) {
                if (this._floorMeshesCollection[i].id === mesh.id) {
                    return true;
                }
            }
            if (this._floorMeshName && mesh.name === this._floorMeshName) {
                return true;
            }
            return false;
        }
        /**
         * Adds a floor mesh to be used for teleportation.
         * @param floorMesh the mesh to be used for teleportation.
         */
        addFloorMesh(floorMesh) {
            if (!this._floorMeshesCollection) {
                return;
            }
            if (this._floorMeshesCollection.indexOf(floorMesh) > -1) {
                return;
            }
            this._floorMeshesCollection.push(floorMesh);
        }
        /**
         * Removes a floor mesh from being used for teleportation.
         * @param floorMesh the mesh to be removed.
         */
        removeFloorMesh(floorMesh) {
            if (!this._floorMeshesCollection) {
                return;
            }
            const meshIndex = this._floorMeshesCollection.indexOf(floorMesh);
            if (meshIndex !== -1) {
                this._floorMeshesCollection.splice(meshIndex, 1);
            }
        }
        /**
         * Enables interactions and teleportation using the VR controllers and gaze.
         * @param vrTeleportationOptions options to modify teleportation behavior.
         */
        enableTeleportation(vrTeleportationOptions = {}) {
            if (!this._teleportationInitialized) {
                this._teleportationRequested = true;
                this.enableInteractions();
                if (this.webVROptions.useXR && (vrTeleportationOptions.floorMeshes || vrTeleportationOptions.floorMeshName)) {
                    const floorMeshes = vrTeleportationOptions.floorMeshes || [];
                    if (!floorMeshes.length) {
                        const floorMesh = this._scene.getMeshByName(vrTeleportationOptions.floorMeshName);
                        if (floorMesh) {
                            floorMeshes.push(floorMesh);
                        }
                    }
                    if (this.xr) {
                        floorMeshes.forEach((mesh) => {
                            this.xr.teleportation.addFloorMesh(mesh);
                        });
                        if (!this.xr.teleportation.attached) {
                            this.xr.teleportation.attach();
                        }
                        return;
                    }
                    else if (!this.xrTestDone) {
                        const waitForXr = () => {
                            if (this.xrTestDone) {
                                this._scene.unregisterBeforeRender(waitForXr);
                                if (this.xr) {
                                    if (!this.xr.teleportation.attached) {
                                        this.xr.teleportation.attach();
                                    }
                                }
                                else {
                                    this.enableTeleportation(vrTeleportationOptions);
                                }
                            }
                        };
                        this._scene.registerBeforeRender(waitForXr);
                        return;
                    }
                }
                if (vrTeleportationOptions.floorMeshName) {
                    this._floorMeshName = vrTeleportationOptions.floorMeshName;
                }
                if (vrTeleportationOptions.floorMeshes) {
                    this._floorMeshesCollection = vrTeleportationOptions.floorMeshes;
                }
                if (vrTeleportationOptions.teleportationMode) {
                    this._teleportationMode = vrTeleportationOptions.teleportationMode;
                }
                if (vrTeleportationOptions.teleportationTime && vrTeleportationOptions.teleportationTime > 0) {
                    this._teleportationTime = vrTeleportationOptions.teleportationTime;
                }
                if (vrTeleportationOptions.teleportationSpeed && vrTeleportationOptions.teleportationSpeed > 0) {
                    this._teleportationSpeed = vrTeleportationOptions.teleportationSpeed;
                }
                if (vrTeleportationOptions.easingFunction !== undefined) {
                    this._teleportationEasing = vrTeleportationOptions.easingFunction;
                }
                if (this._leftController != null) {
                    this._enableTeleportationOnController(this._leftController);
                }
                if (this._rightController != null) {
                    this._enableTeleportationOnController(this._rightController);
                }
                // Creates an image processing post process for the vignette not relying
                // on the main scene configuration for image processing to reduce setup and spaces
                // (gamma/linear) conflicts.
                const imageProcessingConfiguration = new ImageProcessingConfiguration();
                imageProcessingConfiguration.vignetteColor = new Color4(0, 0, 0, 0);
                imageProcessingConfiguration.vignetteEnabled = true;
                this._postProcessMove = new ImageProcessingPostProcess("postProcessMove", 1.0, this._webVRCamera, undefined, undefined, undefined, undefined, imageProcessingConfiguration);
                this._webVRCamera.detachPostProcess(this._postProcessMove);
                this._teleportationInitialized = true;
                if (this._isDefaultTeleportationTarget) {
                    this._createTeleportationCircles();
                    this._teleportationTarget.scaling.scaleInPlace(this._webVRCamera.deviceScaleFactor);
                }
            }
        }
        _enableInteractionOnController(controller) {
            const controllerMesh = controller.webVRController.mesh;
            if (controllerMesh) {
                controller._interactionsEnabled = true;
                if (this.isInVRMode && this._displayLaserPointer) {
                    controller._activatePointer();
                }
                if (this.webVROptions.laserToggle) {
                    controller.webVRController.onMainButtonStateChangedObservable.add((stateObject) => {
                        // Enabling / disabling laserPointer
                        if (this._displayLaserPointer && stateObject.value === 1) {
                            if (controller._activePointer) {
                                controller._deactivatePointer();
                            }
                            else {
                                controller._activatePointer();
                            }
                            if (this.displayGaze) {
                                controller._gazeTracker.isVisible = controller._activePointer;
                            }
                        }
                    });
                }
                controller.webVRController.onTriggerStateChangedObservable.add((stateObject) => {
                    let gazer = controller;
                    if (this._noControllerIsActive) {
                        gazer = this._cameraGazer;
                    }
                    if (!gazer._pointerDownOnMeshAsked) {
                        if (stateObject.value > this._padSensibilityUp) {
                            gazer._selectionPointerDown();
                        }
                    }
                    else if (stateObject.value < this._padSensibilityDown) {
                        gazer._selectionPointerUp();
                    }
                });
            }
        }
        _checkTeleportWithRay(stateObject, gazer) {
            // Dont teleport if another gaze already requested teleportation
            if (this._teleportationRequestInitiated && !gazer._teleportationRequestInitiated) {
                return;
            }
            if (!gazer._teleportationRequestInitiated) {
                if (stateObject.y < -this._padSensibilityUp && gazer._dpadPressed) {
                    gazer._activatePointer();
                    gazer._teleportationRequestInitiated = true;
                }
            }
            else {
                // Listening to the proper controller values changes to confirm teleportation
                if (Math.sqrt(stateObject.y * stateObject.y + stateObject.x * stateObject.x) < this._padSensibilityDown) {
                    if (this._teleportActive) {
                        this.teleportCamera(this._haloCenter);
                    }
                    gazer._teleportationRequestInitiated = false;
                }
            }
        }
        _checkRotate(stateObject, gazer) {
            // Only rotate when user is not currently selecting a teleportation location
            if (gazer._teleportationRequestInitiated) {
                return;
            }
            if (!gazer._rotationLeftAsked) {
                if (stateObject.x < -this._padSensibilityUp && gazer._dpadPressed) {
                    gazer._rotationLeftAsked = true;
                    if (this._rotationAllowed) {
                        this._rotateCamera(false);
                    }
                }
            }
            else {
                if (stateObject.x > -this._padSensibilityDown) {
                    gazer._rotationLeftAsked = false;
                }
            }
            if (!gazer._rotationRightAsked) {
                if (stateObject.x > this._padSensibilityUp && gazer._dpadPressed) {
                    gazer._rotationRightAsked = true;
                    if (this._rotationAllowed) {
                        this._rotateCamera(true);
                    }
                }
            }
            else {
                if (stateObject.x < this._padSensibilityDown) {
                    gazer._rotationRightAsked = false;
                }
            }
        }
        _checkTeleportBackwards(stateObject, gazer) {
            // Only teleport backwards when user is not currently selecting a teleportation location
            if (gazer._teleportationRequestInitiated) {
                return;
            }
            // Teleport backwards
            if (stateObject.y > this._padSensibilityUp && gazer._dpadPressed) {
                if (!gazer._teleportationBackRequestInitiated) {
                    if (!this.currentVRCamera) {
                        return;
                    }
                    // Get rotation and position of the current camera
                    let rotation = Quaternion.FromRotationMatrix(this.currentVRCamera.getWorldMatrix().getRotationMatrix());
                    let position = this.currentVRCamera.position;
                    // If the camera has device position, use that instead
                    if (this.currentVRCamera.devicePosition && this.currentVRCamera.deviceRotationQuaternion) {
                        rotation = this.currentVRCamera.deviceRotationQuaternion;
                        position = this.currentVRCamera.devicePosition;
                    }
                    // Get matrix with only the y rotation of the device rotation
                    rotation.toEulerAnglesToRef(this._workingVector);
                    this._workingVector.z = 0;
                    this._workingVector.x = 0;
                    Quaternion.RotationYawPitchRollToRef(this._workingVector.y, this._workingVector.x, this._workingVector.z, this._workingQuaternion);
                    this._workingQuaternion.toRotationMatrix(this._workingMatrix);
                    // Rotate backwards ray by device rotation to cast at the ground behind the user
                    Vector3.TransformCoordinatesToRef(this._teleportBackwardsVector, this._workingMatrix, this._workingVector);
                    // Teleport if ray hit the ground and is not to far away eg. backwards off a cliff
                    const ray = new Ray(position, this._workingVector);
                    const hit = this._scene.pickWithRay(ray, this._raySelectionPredicate);
                    if (hit && hit.pickedPoint && hit.pickedMesh && this._isTeleportationFloor(hit.pickedMesh) && hit.distance < 5) {
                        this.teleportCamera(hit.pickedPoint);
                    }
                    gazer._teleportationBackRequestInitiated = true;
                }
            }
            else {
                gazer._teleportationBackRequestInitiated = false;
            }
        }
        _enableTeleportationOnController(controller) {
            const controllerMesh = controller.webVRController.mesh;
            if (controllerMesh) {
                if (!controller._interactionsEnabled) {
                    this._enableInteractionOnController(controller);
                }
                controller._interactionsEnabled = true;
                controller._teleportationEnabled = true;
                if (controller.webVRController.controllerType === PoseEnabledControllerType.VIVE) {
                    controller._dpadPressed = false;
                    controller.webVRController.onPadStateChangedObservable.add((stateObject) => {
                        controller._dpadPressed = stateObject.pressed;
                        if (!controller._dpadPressed) {
                            controller._rotationLeftAsked = false;
                            controller._rotationRightAsked = false;
                            controller._teleportationBackRequestInitiated = false;
                        }
                    });
                }
                controller.webVRController.onPadValuesChangedObservable.add((stateObject) => {
                    if (this.teleportationEnabled) {
                        this._checkTeleportBackwards(stateObject, controller);
                        this._checkTeleportWithRay(stateObject, controller);
                    }
                    this._checkRotate(stateObject, controller);
                });
            }
        }
        _createTeleportationCircles() {
            this._teleportationTarget = CreateGround("teleportationTarget", { width: 2, height: 2, subdivisions: 2 }, this._scene);
            this._teleportationTarget.isPickable = false;
            const length = 512;
            const dynamicTexture = new DynamicTexture("DynamicTexture", length, this._scene, true);
            dynamicTexture.hasAlpha = true;
            const context = dynamicTexture.getContext();
            const centerX = length / 2;
            const centerY = length / 2;
            const radius = 200;
            context.beginPath();
            context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
            context.fillStyle = this._teleportationFillColor;
            context.fill();
            context.lineWidth = 10;
            context.strokeStyle = this._teleportationBorderColor;
            context.stroke();
            context.closePath();
            dynamicTexture.update();
            const teleportationCircleMaterial = new StandardMaterial("TextPlaneMaterial", this._scene);
            teleportationCircleMaterial.diffuseTexture = dynamicTexture;
            this._teleportationTarget.material = teleportationCircleMaterial;
            const torus = CreateTorus("torusTeleportation", {
                diameter: 0.75,
                thickness: 0.1,
                tessellation: 25,
                updatable: false,
            }, this._scene);
            torus.isPickable = false;
            torus.parent = this._teleportationTarget;
            const animationInnerCircle = new Animation("animationInnerCircle", "position.y", 30, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
            const keys = [];
            keys.push({
                frame: 0,
                value: 0,
            });
            keys.push({
                frame: 30,
                value: 0.4,
            });
            keys.push({
                frame: 60,
                value: 0,
            });
            animationInnerCircle.setKeys(keys);
            const easingFunction = new SineEase();
            easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
            animationInnerCircle.setEasingFunction(easingFunction);
            torus.animations = [];
            torus.animations.push(animationInnerCircle);
            this._scene.beginAnimation(torus, 0, 60, true);
            this._hideTeleportationTarget();
        }
        _displayTeleportationTarget() {
            this._teleportActive = true;
            if (this._teleportationInitialized) {
                this._teleportationTarget.isVisible = true;
                if (this._isDefaultTeleportationTarget) {
                    this._teleportationTarget.getChildren()[0].isVisible = true;
                }
            }
        }
        _hideTeleportationTarget() {
            this._teleportActive = false;
            if (this._teleportationInitialized) {
                this._teleportationTarget.isVisible = false;
                if (this._isDefaultTeleportationTarget) {
                    this._teleportationTarget.getChildren()[0].isVisible = false;
                }
            }
        }
        _rotateCamera(right) {
            if (!(this.currentVRCamera instanceof FreeCamera)) {
                return;
            }
            if (right) {
                this._rotationAngle++;
            }
            else {
                this._rotationAngle--;
            }
            this.currentVRCamera.animations = [];
            const target = Quaternion.FromRotationMatrix(Matrix.RotationY((Math.PI / 4) * this._rotationAngle));
            const animationRotation = new Animation("animationRotation", "rotationQuaternion", 90, Animation.ANIMATIONTYPE_QUATERNION, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const animationRotationKeys = [];
            animationRotationKeys.push({
                frame: 0,
                value: this.currentVRCamera.rotationQuaternion,
            });
            animationRotationKeys.push({
                frame: 6,
                value: target,
            });
            animationRotation.setKeys(animationRotationKeys);
            animationRotation.setEasingFunction(this._circleEase);
            this.currentVRCamera.animations.push(animationRotation);
            this._postProcessMove.animations = [];
            const animationPP = new Animation("animationPP", "vignetteWeight", 90, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const vignetteWeightKeys = [];
            vignetteWeightKeys.push({
                frame: 0,
                value: 0,
            });
            vignetteWeightKeys.push({
                frame: 3,
                value: 4,
            });
            vignetteWeightKeys.push({
                frame: 6,
                value: 0,
            });
            animationPP.setKeys(vignetteWeightKeys);
            animationPP.setEasingFunction(this._circleEase);
            this._postProcessMove.animations.push(animationPP);
            const animationPP2 = new Animation("animationPP2", "vignetteStretch", 90, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const vignetteStretchKeys = [];
            vignetteStretchKeys.push({
                frame: 0,
                value: 0,
            });
            vignetteStretchKeys.push({
                frame: 3,
                value: 10,
            });
            vignetteStretchKeys.push({
                frame: 6,
                value: 0,
            });
            animationPP2.setKeys(vignetteStretchKeys);
            animationPP2.setEasingFunction(this._circleEase);
            this._postProcessMove.animations.push(animationPP2);
            this._postProcessMove.imageProcessingConfiguration.vignetteWeight = 0;
            this._postProcessMove.imageProcessingConfiguration.vignetteStretch = 0;
            this._postProcessMove.samples = 4;
            this._webVRCamera.attachPostProcess(this._postProcessMove);
            this._scene.beginAnimation(this._postProcessMove, 0, 6, false, 1, () => {
                this._webVRCamera.detachPostProcess(this._postProcessMove);
            });
            this._scene.beginAnimation(this.currentVRCamera, 0, 6, false, 1);
        }
        _moveTeleportationSelectorTo(hit, gazer, ray) {
            if (hit.pickedPoint) {
                if (gazer._teleportationRequestInitiated) {
                    this._displayTeleportationTarget();
                    this._haloCenter.copyFrom(hit.pickedPoint);
                    this._teleportationTarget.position.copyFrom(hit.pickedPoint);
                }
                const pickNormal = this._convertNormalToDirectionOfRay(hit.getNormal(true, false), ray);
                if (pickNormal) {
                    const axis1 = Vector3.Cross(Axis.Y, pickNormal);
                    const axis2 = Vector3.Cross(pickNormal, axis1);
                    Vector3.RotationFromAxisToRef(axis2, pickNormal, axis1, this._teleportationTarget.rotation);
                }
                this._teleportationTarget.position.y += 0.1;
            }
        }
        /**
         * Teleports the users feet to the desired location
         * @param location The location where the user's feet should be placed
         */
        teleportCamera(location) {
            if (!(this.currentVRCamera instanceof FreeCamera)) {
                return;
            }
            // Teleport the hmd to where the user is looking by moving the anchor to where they are looking minus the
            // offset of the headset from the anchor.
            if (this.webVRCamera.leftCamera) {
                this._workingVector.copyFrom(this.webVRCamera.leftCamera.globalPosition);
                this._workingVector.subtractInPlace(this.webVRCamera.position);
                location.subtractToRef(this._workingVector, this._workingVector);
            }
            else {
                this._workingVector.copyFrom(location);
            }
            // Add height to account for user's height offset
            if (this.isInVRMode) {
                this._workingVector.y += this.webVRCamera.deviceDistanceToRoomGround() * this._webVRCamera.deviceScaleFactor;
            }
            else {
                this._workingVector.y += this._defaultHeight;
            }
            this.onBeforeCameraTeleport.notifyObservers(this._workingVector);
            // Animations FPS
            const FPS = 90;
            let speedRatio, lastFrame;
            if (this._teleportationMode == VRExperienceHelper.TELEPORTATIONMODE_CONSTANTSPEED) {
                lastFrame = FPS;
                const dist = Vector3.Distance(this.currentVRCamera.position, this._workingVector);
                speedRatio = this._teleportationSpeed / dist;
            }
            else {
                // teleportationMode is TELEPORTATIONMODE_CONSTANTTIME
                lastFrame = Math.round((this._teleportationTime * FPS) / 1000);
                speedRatio = 1;
            }
            // Create animation from the camera's position to the new location
            this.currentVRCamera.animations = [];
            const animationCameraTeleportation = new Animation("animationCameraTeleportation", "position", FPS, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const animationCameraTeleportationKeys = [
                {
                    frame: 0,
                    value: this.currentVRCamera.position,
                },
                {
                    frame: lastFrame,
                    value: this._workingVector,
                },
            ];
            animationCameraTeleportation.setKeys(animationCameraTeleportationKeys);
            animationCameraTeleportation.setEasingFunction(this._teleportationEasing);
            this.currentVRCamera.animations.push(animationCameraTeleportation);
            this._postProcessMove.animations = [];
            // Calculate the mid frame for vignette animations
            const midFrame = Math.round(lastFrame / 2);
            const animationPP = new Animation("animationPP", "vignetteWeight", FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const vignetteWeightKeys = [];
            vignetteWeightKeys.push({
                frame: 0,
                value: 0,
            });
            vignetteWeightKeys.push({
                frame: midFrame,
                value: 8,
            });
            vignetteWeightKeys.push({
                frame: lastFrame,
                value: 0,
            });
            animationPP.setKeys(vignetteWeightKeys);
            this._postProcessMove.animations.push(animationPP);
            const animationPP2 = new Animation("animationPP2", "vignetteStretch", FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const vignetteStretchKeys = [];
            vignetteStretchKeys.push({
                frame: 0,
                value: 0,
            });
            vignetteStretchKeys.push({
                frame: midFrame,
                value: 10,
            });
            vignetteStretchKeys.push({
                frame: lastFrame,
                value: 0,
            });
            animationPP2.setKeys(vignetteStretchKeys);
            this._postProcessMove.animations.push(animationPP2);
            this._postProcessMove.imageProcessingConfiguration.vignetteWeight = 0;
            this._postProcessMove.imageProcessingConfiguration.vignetteStretch = 0;
            this._webVRCamera.attachPostProcess(this._postProcessMove);
            this._scene.beginAnimation(this._postProcessMove, 0, lastFrame, false, speedRatio, () => {
                this._webVRCamera.detachPostProcess(this._postProcessMove);
            });
            this._scene.beginAnimation(this.currentVRCamera, 0, lastFrame, false, speedRatio, () => {
                this.onAfterCameraTeleport.notifyObservers(this._workingVector);
            });
            this._hideTeleportationTarget();
        }
        _convertNormalToDirectionOfRay(normal, ray) {
            if (normal) {
                const angle = Math.acos(Vector3.Dot(normal, ray.direction));
                if (angle < Math.PI / 2) {
                    normal.scaleInPlace(-1);
                }
            }
            return normal;
        }
        _castRayAndSelectObject(gazer) {
            if (!(this.currentVRCamera instanceof FreeCamera)) {
                return;
            }
            const ray = gazer._getForwardRay(this._rayLength);
            const hit = this._scene.pickWithRay(ray, this._raySelectionPredicate);
            if (hit) {
                this._scene.simulatePointerMove(hit, { pointerId: gazer._id });
            }
            gazer._currentHit = hit;
            // Moving the gazeTracker on the mesh face targetted
            if (hit && hit.pickedPoint) {
                if (this._displayGaze) {
                    let multiplier = 1;
                    gazer._gazeTracker.isVisible = true;
                    if (gazer._isActionableMesh) {
                        multiplier = 3;
                    }
                    if (this.updateGazeTrackerScale) {
                        gazer._gazeTracker.scaling.x = hit.distance * multiplier;
                        gazer._gazeTracker.scaling.y = hit.distance * multiplier;
                        gazer._gazeTracker.scaling.z = hit.distance * multiplier;
                    }
                    const pickNormal = this._convertNormalToDirectionOfRay(hit.getNormal(), ray);
                    // To avoid z-fighting
                    const deltaFighting = 0.002;
                    if (pickNormal) {
                        const axis1 = Vector3.Cross(Axis.Y, pickNormal);
                        const axis2 = Vector3.Cross(pickNormal, axis1);
                        Vector3.RotationFromAxisToRef(axis2, pickNormal, axis1, gazer._gazeTracker.rotation);
                    }
                    gazer._gazeTracker.position.copyFrom(hit.pickedPoint);
                    if (gazer._gazeTracker.position.x < 0) {
                        gazer._gazeTracker.position.x += deltaFighting;
                    }
                    else {
                        gazer._gazeTracker.position.x -= deltaFighting;
                    }
                    if (gazer._gazeTracker.position.y < 0) {
                        gazer._gazeTracker.position.y += deltaFighting;
                    }
                    else {
                        gazer._gazeTracker.position.y -= deltaFighting;
                    }
                    if (gazer._gazeTracker.position.z < 0) {
                        gazer._gazeTracker.position.z += deltaFighting;
                    }
                    else {
                        gazer._gazeTracker.position.z -= deltaFighting;
                    }
                }
                // Changing the size of the laser pointer based on the distance from the targetted point
                gazer._updatePointerDistance(hit.distance);
            }
            else {
                gazer._updatePointerDistance();
                gazer._gazeTracker.isVisible = false;
            }
            if (hit && hit.pickedMesh) {
                // The object selected is the floor, we're in a teleportation scenario
                if (this._teleportationInitialized && this._isTeleportationFloor(hit.pickedMesh) && hit.pickedPoint) {
                    // Moving the teleportation area to this targetted point
                    //Raise onSelectedMeshUnselected observable if ray collided floor mesh/meshes and a non floor mesh was previously selected
                    if (gazer._currentMeshSelected && !this._isTeleportationFloor(gazer._currentMeshSelected)) {
                        this._notifySelectedMeshUnselected(gazer._currentMeshSelected);
                    }
                    gazer._currentMeshSelected = null;
                    if (gazer._teleportationRequestInitiated) {
                        this._moveTeleportationSelectorTo(hit, gazer, ray);
                    }
                    return;
                }
                // If not, we're in a selection scenario
                //this._teleportationAllowed = false;
                if (hit.pickedMesh !== gazer._currentMeshSelected) {
                    if (this.meshSelectionPredicate(hit.pickedMesh)) {
                        this.onNewMeshPicked.notifyObservers(hit);
                        gazer._currentMeshSelected = hit.pickedMesh;
                        if (hit.pickedMesh.isPickable && hit.pickedMesh.actionManager) {
                            this.changeGazeColor(this._pickedGazeColor);
                            this.changeLaserColor(this._pickedLaserColor);
                            gazer._isActionableMesh = true;
                        }
                        else {
                            this.changeGazeColor(this._gazeColor);
                            this.changeLaserColor(this._laserColor);
                            gazer._isActionableMesh = false;
                        }
                        try {
                            this.onNewMeshSelected.notifyObservers(hit.pickedMesh);
                            const gazerAsControllerGazer = gazer;
                            if (gazerAsControllerGazer.webVRController) {
                                this.onMeshSelectedWithController.notifyObservers({ mesh: hit.pickedMesh, controller: gazerAsControllerGazer.webVRController });
                            }
                        }
                        catch (err) {
                            Logger.Warn("Error while raising onNewMeshSelected or onMeshSelectedWithController: " + err);
                        }
                    }
                    else {
                        this._notifySelectedMeshUnselected(gazer._currentMeshSelected);
                        gazer._currentMeshSelected = null;
                        this.changeGazeColor(this._gazeColor);
                        this.changeLaserColor(this._laserColor);
                    }
                }
            }
            else {
                this._notifySelectedMeshUnselected(gazer._currentMeshSelected);
                gazer._currentMeshSelected = null;
                //this._teleportationAllowed = false;
                this.changeGazeColor(this._gazeColor);
                this.changeLaserColor(this._laserColor);
            }
        }
        _notifySelectedMeshUnselected(mesh) {
            if (mesh) {
                this.onSelectedMeshUnselected.notifyObservers(mesh);
            }
        }
        /**
         * Permanently set new colors for the laser pointer
         * @param color the new laser color
         * @param pickedColor the new laser color when picked mesh detected
         */
        setLaserColor(color, pickedColor = this._pickedLaserColor) {
            this._laserColor = color;
            this._pickedLaserColor = pickedColor;
        }
        /**
         * Set lighting enabled / disabled on the laser pointer of both controllers
         * @param enabled should the lighting be enabled on the laser pointer
         */
        setLaserLightingState(enabled = true) {
            if (this._leftController) {
                this._leftController._setLaserPointerLightingDisabled(!enabled);
            }
            if (this._rightController) {
                this._rightController._setLaserPointerLightingDisabled(!enabled);
            }
        }
        /**
         * Permanently set new colors for the gaze pointer
         * @param color the new gaze color
         * @param pickedColor the new gaze color when picked mesh detected
         */
        setGazeColor(color, pickedColor = this._pickedGazeColor) {
            this._gazeColor = color;
            this._pickedGazeColor = pickedColor;
        }
        /**
         * Sets the color of the laser ray from the vr controllers.
         * @param color new color for the ray.
         */
        changeLaserColor(color) {
            if (!this.updateControllerLaserColor) {
                return;
            }
            if (this._leftController) {
                this._leftController._setLaserPointerColor(color);
            }
            if (this._rightController) {
                this._rightController._setLaserPointerColor(color);
            }
        }
        /**
         * Sets the color of the ray from the vr headsets gaze.
         * @param color new color for the ray.
         */
        changeGazeColor(color) {
            if (!this.updateGazeTrackerColor) {
                return;
            }
            if (!this._cameraGazer._gazeTracker.material) {
                return;
            }
            this._cameraGazer._gazeTracker.material.emissiveColor = color;
            if (this._leftController) {
                this._leftController._gazeTracker.material.emissiveColor = color;
            }
            if (this._rightController) {
                this._rightController._gazeTracker.material.emissiveColor = color;
            }
        }
        /**
         * Exits VR and disposes of the vr experience helper
         */
        dispose() {
            if (this.isInVRMode) {
                this.exitVR();
            }
            if (this._postProcessMove) {
                this._postProcessMove.dispose();
            }
            if (this._webVRCamera) {
                this._webVRCamera.dispose();
            }
            if (this._vrDeviceOrientationCamera) {
                this._vrDeviceOrientationCamera.dispose();
            }
            if (!this._useCustomVRButton && this._btnVR && this._btnVR.parentNode) {
                document.body.removeChild(this._btnVR);
            }
            if (this._deviceOrientationCamera && this._scene.activeCamera != this._deviceOrientationCamera) {
                this._deviceOrientationCamera.dispose();
            }
            if (this._cameraGazer) {
                this._cameraGazer.dispose();
            }
            if (this._leftController) {
                this._leftController.dispose();
            }
            if (this._rightController) {
                this._rightController.dispose();
            }
            if (this._teleportationTarget) {
                this._teleportationTarget.dispose();
            }
            if (this.xr) {
                this.xr.dispose();
            }
            this._floorMeshesCollection.length = 0;
            document.removeEventListener("keydown", this._onKeyDown);
            window.removeEventListener("vrdisplaypresentchange", this._onVrDisplayPresentChangeBind);
            window.removeEventListener("resize", this._onResize);
            document.removeEventListener("fullscreenchange", this._onFullscreenChange);
            this._scene.getEngine().onVRDisplayChangedObservable.removeCallback(this._onVRDisplayChangedBind);
            this._scene.getEngine().onVRRequestPresentStart.removeCallback(this._onVRRequestPresentStart);
            this._scene.getEngine().onVRRequestPresentComplete.removeCallback(this._onVRRequestPresentComplete);
            this._scene.gamepadManager.onGamepadConnectedObservable.removeCallback(this._onNewGamepadConnected);
            this._scene.gamepadManager.onGamepadDisconnectedObservable.removeCallback(this._onNewGamepadDisconnected);
            this._scene.unregisterBeforeRender(this._beforeRender);
        }
        /**
         * Gets the name of the VRExperienceHelper class
         * @returns "VRExperienceHelper"
         */
        getClassName() {
            return "VRExperienceHelper";
        }
    }
    /**
     * Time Constant Teleportation Mode
     */
    VRExperienceHelper.TELEPORTATIONMODE_CONSTANTTIME = 0;
    /**
     * Speed Constant Teleportation Mode
     */
    VRExperienceHelper.TELEPORTATIONMODE_CONSTANTSPEED = 1;

    /* eslint-disable @typescript-eslint/naming-convention */
    // Based on demo done by Brandon Jones - http://media.tojicode.com/webgl-samples/dds.html
    // All values and structures referenced from:
    // http://msdn.microsoft.com/en-us/library/bb943991.aspx/
    const DDS_MAGIC = 0x20534444;
    const //DDSD_CAPS = 0x1,
    //DDSD_HEIGHT = 0x2,
    //DDSD_WIDTH = 0x4,
    //DDSD_PITCH = 0x8,
    //DDSD_PIXELFORMAT = 0x1000,
    DDSD_MIPMAPCOUNT = 0x20000;
    //DDSD_LINEARSIZE = 0x80000,
    //DDSD_DEPTH = 0x800000;
    // var DDSCAPS_COMPLEX = 0x8,
    //     DDSCAPS_MIPMAP = 0x400000,
    //     DDSCAPS_TEXTURE = 0x1000;
    const DDSCAPS2_CUBEMAP = 0x200;
    // DDSCAPS2_CUBEMAP_POSITIVEX = 0x400,
    // DDSCAPS2_CUBEMAP_NEGATIVEX = 0x800,
    // DDSCAPS2_CUBEMAP_POSITIVEY = 0x1000,
    // DDSCAPS2_CUBEMAP_NEGATIVEY = 0x2000,
    // DDSCAPS2_CUBEMAP_POSITIVEZ = 0x4000,
    // DDSCAPS2_CUBEMAP_NEGATIVEZ = 0x8000,
    // DDSCAPS2_VOLUME = 0x200000;
    const //DDPF_ALPHAPIXELS = 0x1,
    //DDPF_ALPHA = 0x2,
    DDPF_FOURCC = 0x4, DDPF_RGB = 0x40, 
    //DDPF_YUV = 0x200,
    DDPF_LUMINANCE = 0x20000;
    function FourCCToInt32(value) {
        return value.charCodeAt(0) + (value.charCodeAt(1) << 8) + (value.charCodeAt(2) << 16) + (value.charCodeAt(3) << 24);
    }
    function Int32ToFourCC(value) {
        return String.fromCharCode(value & 0xff, (value >> 8) & 0xff, (value >> 16) & 0xff, (value >> 24) & 0xff);
    }
    const FOURCC_DXT1 = FourCCToInt32("DXT1");
    const FOURCC_DXT3 = FourCCToInt32("DXT3");
    const FOURCC_DXT5 = FourCCToInt32("DXT5");
    const FOURCC_DX10 = FourCCToInt32("DX10");
    const FOURCC_D3DFMT_R16G16B16A16F = 113;
    const FOURCC_D3DFMT_R32G32B32A32F = 116;
    const DXGI_FORMAT_R32G32B32A32_FLOAT = 2;
    const DXGI_FORMAT_R16G16B16A16_FLOAT = 10;
    const DXGI_FORMAT_B8G8R8X8_UNORM = 88;
    const headerLengthInt = 31; // The header length in 32 bit ints
    // Offsets into the header array
    const off_magic = 0;
    const off_size = 1;
    const off_flags = 2;
    const off_height = 3;
    const off_width = 4;
    const off_mipmapCount = 7;
    const off_pfFlags = 20;
    const off_pfFourCC = 21;
    const off_RGBbpp = 22;
    const off_RMask = 23;
    const off_GMask = 24;
    const off_BMask = 25;
    const off_AMask = 26;
    // var off_caps1 = 27;
    const off_caps2 = 28;
    // var off_caps3 = 29;
    // var off_caps4 = 30;
    const off_dxgiFormat = 32;
    /**
     * Class used to provide DDS decompression tools
     */
    class DDSTools {
        /**
         * Gets DDS information from an array buffer
         * @param data defines the array buffer view to read data from
         * @returns the DDS information
         */
        static GetDDSInfo(data) {
            const header = new Int32Array(data.buffer, data.byteOffset, headerLengthInt);
            const extendedHeader = new Int32Array(data.buffer, data.byteOffset, headerLengthInt + 4);
            let mipmapCount = 1;
            if (header[off_flags] & DDSD_MIPMAPCOUNT) {
                mipmapCount = Math.max(1, header[off_mipmapCount]);
            }
            const fourCC = header[off_pfFourCC];
            const dxgiFormat = fourCC === FOURCC_DX10 ? extendedHeader[off_dxgiFormat] : 0;
            let textureType = 0;
            switch (fourCC) {
                case FOURCC_D3DFMT_R16G16B16A16F:
                    textureType = 2;
                    break;
                case FOURCC_D3DFMT_R32G32B32A32F:
                    textureType = 1;
                    break;
                case FOURCC_DX10:
                    if (dxgiFormat === DXGI_FORMAT_R16G16B16A16_FLOAT) {
                        textureType = 2;
                        break;
                    }
                    if (dxgiFormat === DXGI_FORMAT_R32G32B32A32_FLOAT) {
                        textureType = 1;
                        break;
                    }
            }
            return {
                width: header[off_width],
                height: header[off_height],
                mipmapCount: mipmapCount,
                isFourCC: (header[off_pfFlags] & DDPF_FOURCC) === DDPF_FOURCC,
                isRGB: (header[off_pfFlags] & DDPF_RGB) === DDPF_RGB,
                isLuminance: (header[off_pfFlags] & DDPF_LUMINANCE) === DDPF_LUMINANCE,
                isCube: (header[off_caps2] & DDSCAPS2_CUBEMAP) === DDSCAPS2_CUBEMAP,
                isCompressed: fourCC === FOURCC_DXT1 || fourCC === FOURCC_DXT3 || fourCC === FOURCC_DXT5,
                dxgiFormat: dxgiFormat,
                textureType: textureType,
            };
        }
        static _GetHalfFloatAsFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
            const destArray = new Float32Array(dataLength);
            const srcData = new Uint16Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const srcPos = (x + y * width) * 4;
                    destArray[index] = FromHalfFloat(srcData[srcPos]);
                    destArray[index + 1] = FromHalfFloat(srcData[srcPos + 1]);
                    destArray[index + 2] = FromHalfFloat(srcData[srcPos + 2]);
                    if (DDSTools.StoreLODInAlphaChannel) {
                        destArray[index + 3] = lod;
                    }
                    else {
                        destArray[index + 3] = FromHalfFloat(srcData[srcPos + 3]);
                    }
                    index += 4;
                }
            }
            return destArray;
        }
        static _GetHalfFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
            if (DDSTools.StoreLODInAlphaChannel) {
                const destArray = new Uint16Array(dataLength);
                const srcData = new Uint16Array(arrayBuffer, dataOffset);
                let index = 0;
                for (let y = 0; y < height; y++) {
                    for (let x = 0; x < width; x++) {
                        const srcPos = (x + y * width) * 4;
                        destArray[index] = srcData[srcPos];
                        destArray[index + 1] = srcData[srcPos + 1];
                        destArray[index + 2] = srcData[srcPos + 2];
                        destArray[index + 3] = ToHalfFloat(lod);
                        index += 4;
                    }
                }
                return destArray;
            }
            return new Uint16Array(arrayBuffer, dataOffset, dataLength);
        }
        static _GetFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
            if (DDSTools.StoreLODInAlphaChannel) {
                const destArray = new Float32Array(dataLength);
                const srcData = new Float32Array(arrayBuffer, dataOffset);
                let index = 0;
                for (let y = 0; y < height; y++) {
                    for (let x = 0; x < width; x++) {
                        const srcPos = (x + y * width) * 4;
                        destArray[index] = srcData[srcPos];
                        destArray[index + 1] = srcData[srcPos + 1];
                        destArray[index + 2] = srcData[srcPos + 2];
                        destArray[index + 3] = lod;
                        index += 4;
                    }
                }
                return destArray;
            }
            return new Float32Array(arrayBuffer, dataOffset, dataLength);
        }
        static _GetFloatAsHalfFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
            const destArray = new Uint16Array(dataLength);
            const srcData = new Float32Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    destArray[index] = ToHalfFloat(srcData[index]);
                    destArray[index + 1] = ToHalfFloat(srcData[index + 1]);
                    destArray[index + 2] = ToHalfFloat(srcData[index + 2]);
                    if (DDSTools.StoreLODInAlphaChannel) {
                        destArray[index + 3] = ToHalfFloat(lod);
                    }
                    else {
                        destArray[index + 3] = ToHalfFloat(srcData[index + 3]);
                    }
                    index += 4;
                }
            }
            return destArray;
        }
        static _GetFloatAsUIntRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
            const destArray = new Uint8Array(dataLength);
            const srcData = new Float32Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const srcPos = (x + y * width) * 4;
                    destArray[index] = Scalar.Clamp(srcData[srcPos]) * 255;
                    destArray[index + 1] = Scalar.Clamp(srcData[srcPos + 1]) * 255;
                    destArray[index + 2] = Scalar.Clamp(srcData[srcPos + 2]) * 255;
                    if (DDSTools.StoreLODInAlphaChannel) {
                        destArray[index + 3] = lod;
                    }
                    else {
                        destArray[index + 3] = Scalar.Clamp(srcData[srcPos + 3]) * 255;
                    }
                    index += 4;
                }
            }
            return destArray;
        }
        static _GetHalfFloatAsUIntRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
            const destArray = new Uint8Array(dataLength);
            const srcData = new Uint16Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const srcPos = (x + y * width) * 4;
                    destArray[index] = Scalar.Clamp(FromHalfFloat(srcData[srcPos])) * 255;
                    destArray[index + 1] = Scalar.Clamp(FromHalfFloat(srcData[srcPos + 1])) * 255;
                    destArray[index + 2] = Scalar.Clamp(FromHalfFloat(srcData[srcPos + 2])) * 255;
                    if (DDSTools.StoreLODInAlphaChannel) {
                        destArray[index + 3] = lod;
                    }
                    else {
                        destArray[index + 3] = Scalar.Clamp(FromHalfFloat(srcData[srcPos + 3])) * 255;
                    }
                    index += 4;
                }
            }
            return destArray;
        }
        static _GetRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, rOffset, gOffset, bOffset, aOffset) {
            const byteArray = new Uint8Array(dataLength);
            const srcData = new Uint8Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const srcPos = (x + y * width) * 4;
                    byteArray[index] = srcData[srcPos + rOffset];
                    byteArray[index + 1] = srcData[srcPos + gOffset];
                    byteArray[index + 2] = srcData[srcPos + bOffset];
                    byteArray[index + 3] = srcData[srcPos + aOffset];
                    index += 4;
                }
            }
            return byteArray;
        }
        static _ExtractLongWordOrder(value) {
            if (value === 0 || value === 255 || value === -16777216) {
                return 0;
            }
            return 1 + DDSTools._ExtractLongWordOrder(value >> 8);
        }
        static _GetRGBArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, rOffset, gOffset, bOffset) {
            const byteArray = new Uint8Array(dataLength);
            const srcData = new Uint8Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const srcPos = (x + y * width) * 3;
                    byteArray[index] = srcData[srcPos + rOffset];
                    byteArray[index + 1] = srcData[srcPos + gOffset];
                    byteArray[index + 2] = srcData[srcPos + bOffset];
                    index += 3;
                }
            }
            return byteArray;
        }
        static _GetLuminanceArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer) {
            const byteArray = new Uint8Array(dataLength);
            const srcData = new Uint8Array(arrayBuffer, dataOffset);
            let index = 0;
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const srcPos = x + y * width;
                    byteArray[index] = srcData[srcPos];
                    index++;
                }
            }
            return byteArray;
        }
        /**
         * Uploads DDS Levels to a Babylon Texture
         * @internal
         */
        static UploadDDSLevels(engine, texture, data, info, loadMipmaps, faces, lodIndex = -1, currentFace, destTypeMustBeFilterable = true) {
            let sphericalPolynomialFaces = null;
            if (info.sphericalPolynomial) {
                sphericalPolynomialFaces = new Array();
            }
            const ext = !!engine.getCaps().s3tc;
            // TODO WEBGPU Once generateMipMaps is split into generateMipMaps + hasMipMaps in InternalTexture this line can be removed
            texture.generateMipMaps = loadMipmaps;
            const header = new Int32Array(data.buffer, data.byteOffset, headerLengthInt);
            let fourCC, width, height, dataLength = 0, dataOffset;
            let byteArray, mipmapCount, mip;
            let internalCompressedFormat = 0;
            let blockBytes = 1;
            if (header[off_magic] !== DDS_MAGIC) {
                Logger.Error("Invalid magic number in DDS header");
                return;
            }
            if (!info.isFourCC && !info.isRGB && !info.isLuminance) {
                Logger.Error("Unsupported format, must contain a FourCC, RGB or LUMINANCE code");
                return;
            }
            if (info.isCompressed && !ext) {
                Logger.Error("Compressed textures are not supported on this platform.");
                return;
            }
            let bpp = header[off_RGBbpp];
            dataOffset = header[off_size] + 4;
            let computeFormats = false;
            if (info.isFourCC) {
                fourCC = header[off_pfFourCC];
                switch (fourCC) {
                    case FOURCC_DXT1:
                        blockBytes = 8;
                        internalCompressedFormat = 33777;
                        break;
                    case FOURCC_DXT3:
                        blockBytes = 16;
                        internalCompressedFormat = 33778;
                        break;
                    case FOURCC_DXT5:
                        blockBytes = 16;
                        internalCompressedFormat = 33779;
                        break;
                    case FOURCC_D3DFMT_R16G16B16A16F:
                        computeFormats = true;
                        bpp = 64;
                        break;
                    case FOURCC_D3DFMT_R32G32B32A32F:
                        computeFormats = true;
                        bpp = 128;
                        break;
                    case FOURCC_DX10: {
                        // There is an additionnal header so dataOffset need to be changed
                        dataOffset += 5 * 4; // 5 uints
                        let supported = false;
                        switch (info.dxgiFormat) {
                            case DXGI_FORMAT_R16G16B16A16_FLOAT:
                                computeFormats = true;
                                bpp = 64;
                                supported = true;
                                break;
                            case DXGI_FORMAT_R32G32B32A32_FLOAT:
                                computeFormats = true;
                                bpp = 128;
                                supported = true;
                                break;
                            case DXGI_FORMAT_B8G8R8X8_UNORM:
                                info.isRGB = true;
                                info.isFourCC = false;
                                bpp = 32;
                                supported = true;
                                break;
                        }
                        if (supported) {
                            break;
                        }
                    }
                    // eslint-disable-next-line no-fallthrough
                    default:
                        console.error("Unsupported FourCC code:", Int32ToFourCC(fourCC));
                        return;
                }
            }
            const rOffset = DDSTools._ExtractLongWordOrder(header[off_RMask]);
            const gOffset = DDSTools._ExtractLongWordOrder(header[off_GMask]);
            const bOffset = DDSTools._ExtractLongWordOrder(header[off_BMask]);
            const aOffset = DDSTools._ExtractLongWordOrder(header[off_AMask]);
            if (computeFormats) {
                internalCompressedFormat = engine._getRGBABufferInternalSizedFormat(info.textureType);
            }
            mipmapCount = 1;
            if (header[off_flags] & DDSD_MIPMAPCOUNT && loadMipmaps !== false) {
                mipmapCount = Math.max(1, header[off_mipmapCount]);
            }
            const startFace = currentFace || 0;
            const caps = engine.getCaps();
            for (let face = startFace; face < faces; face++) {
                width = header[off_width];
                height = header[off_height];
                for (mip = 0; mip < mipmapCount; ++mip) {
                    if (lodIndex === -1 || lodIndex === mip) {
                        // In case of fixed LOD, if the lod has just been uploaded, early exit.
                        const i = lodIndex === -1 ? mip : 0;
                        if (!info.isCompressed && info.isFourCC) {
                            texture.format = 5;
                            dataLength = width * height * 4;
                            let floatArray = null;
                            if (engine._badOS || engine._badDesktopOS || (!caps.textureHalfFloat && !caps.textureFloat)) {
                                // Required because iOS has many issues with float and half float generation
                                if (bpp === 128) {
                                    floatArray = DDSTools._GetFloatAsUIntRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i);
                                    if (sphericalPolynomialFaces && i == 0) {
                                        sphericalPolynomialFaces.push(DDSTools._GetFloatRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i));
                                    }
                                }
                                else if (bpp === 64) {
                                    floatArray = DDSTools._GetHalfFloatAsUIntRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i);
                                    if (sphericalPolynomialFaces && i == 0) {
                                        sphericalPolynomialFaces.push(DDSTools._GetHalfFloatAsFloatRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i));
                                    }
                                }
                                texture.type = 0;
                            }
                            else {
                                const floatAvailable = caps.textureFloat && ((destTypeMustBeFilterable && caps.textureFloatLinearFiltering) || !destTypeMustBeFilterable);
                                const halfFloatAvailable = caps.textureHalfFloat && ((destTypeMustBeFilterable && caps.textureHalfFloatLinearFiltering) || !destTypeMustBeFilterable);
                                const destType = (bpp === 128 || (bpp === 64 && !halfFloatAvailable)) && floatAvailable
                                    ? 1
                                    : (bpp === 64 || (bpp === 128 && !floatAvailable)) && halfFloatAvailable
                                        ? 2
                                        : 0;
                                let dataGetter;
                                let dataGetterPolynomial = null;
                                switch (bpp) {
                                    case 128: {
                                        switch (destType) {
                                            case 1:
                                                dataGetter = DDSTools._GetFloatRGBAArrayBuffer;
                                                dataGetterPolynomial = null;
                                                break;
                                            case 2:
                                                dataGetter = DDSTools._GetFloatAsHalfFloatRGBAArrayBuffer;
                                                dataGetterPolynomial = DDSTools._GetFloatRGBAArrayBuffer;
                                                break;
                                            case 0:
                                                dataGetter = DDSTools._GetFloatAsUIntRGBAArrayBuffer;
                                                dataGetterPolynomial = DDSTools._GetFloatRGBAArrayBuffer;
                                                break;
                                        }
                                        break;
                                    }
                                    default: {
                                        // 64 bpp
                                        switch (destType) {
                                            case 1:
                                                dataGetter = DDSTools._GetHalfFloatAsFloatRGBAArrayBuffer;
                                                dataGetterPolynomial = null;
                                                break;
                                            case 2:
                                                dataGetter = DDSTools._GetHalfFloatRGBAArrayBuffer;
                                                dataGetterPolynomial = DDSTools._GetHalfFloatAsFloatRGBAArrayBuffer;
                                                break;
                                            case 0:
                                                dataGetter = DDSTools._GetHalfFloatAsUIntRGBAArrayBuffer;
                                                dataGetterPolynomial = DDSTools._GetHalfFloatAsFloatRGBAArrayBuffer;
                                                break;
                                        }
                                        break;
                                    }
                                }
                                texture.type = destType;
                                floatArray = dataGetter(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i);
                                if (sphericalPolynomialFaces && i == 0) {
                                    sphericalPolynomialFaces.push(dataGetterPolynomial ? dataGetterPolynomial(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i) : floatArray);
                                }
                            }
                            if (floatArray) {
                                engine._uploadDataToTextureDirectly(texture, floatArray, face, i);
                            }
                        }
                        else if (info.isRGB) {
                            texture.type = 0;
                            if (bpp === 24) {
                                texture.format = 4;
                                dataLength = width * height * 3;
                                byteArray = DDSTools._GetRGBArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, rOffset, gOffset, bOffset);
                                engine._uploadDataToTextureDirectly(texture, byteArray, face, i);
                            }
                            else {
                                // 32
                                texture.format = 5;
                                dataLength = width * height * 4;
                                byteArray = DDSTools._GetRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, rOffset, gOffset, bOffset, aOffset);
                                engine._uploadDataToTextureDirectly(texture, byteArray, face, i);
                            }
                        }
                        else if (info.isLuminance) {
                            const unpackAlignment = engine._getUnpackAlignement();
                            const unpaddedRowSize = width;
                            const paddedRowSize = Math.floor((width + unpackAlignment - 1) / unpackAlignment) * unpackAlignment;
                            dataLength = paddedRowSize * (height - 1) + unpaddedRowSize;
                            byteArray = DDSTools._GetLuminanceArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer);
                            texture.format = 1;
                            texture.type = 0;
                            engine._uploadDataToTextureDirectly(texture, byteArray, face, i);
                        }
                        else {
                            dataLength = (((Math.max(4, width) / 4) * Math.max(4, height)) / 4) * blockBytes;
                            byteArray = new Uint8Array(data.buffer, data.byteOffset + dataOffset, dataLength);
                            texture.type = 0;
                            engine._uploadCompressedDataToTextureDirectly(texture, internalCompressedFormat, width, height, byteArray, face, i);
                        }
                    }
                    dataOffset += bpp ? width * height * (bpp / 8) : dataLength;
                    width *= 0.5;
                    height *= 0.5;
                    width = Math.max(1.0, width);
                    height = Math.max(1.0, height);
                }
                if (currentFace !== undefined) {
                    // Loading a single face
                    break;
                }
            }
            if (sphericalPolynomialFaces && sphericalPolynomialFaces.length > 0) {
                info.sphericalPolynomial = CubeMapToSphericalPolynomialTools.ConvertCubeMapToSphericalPolynomial({
                    size: header[off_width],
                    right: sphericalPolynomialFaces[0],
                    left: sphericalPolynomialFaces[1],
                    up: sphericalPolynomialFaces[2],
                    down: sphericalPolynomialFaces[3],
                    front: sphericalPolynomialFaces[4],
                    back: sphericalPolynomialFaces[5],
                    format: 5,
                    type: 1,
                    gammaSpace: false,
                });
            }
            else {
                info.sphericalPolynomial = undefined;
            }
        }
    }
    /**
     * Gets or sets a boolean indicating that LOD info is stored in alpha channel (false by default)
     */
    DDSTools.StoreLODInAlphaChannel = false;
    /**
     * Create a cube texture from prefiltered data (ie. the mipmaps contain ready to use data for PBR reflection)
     * @param rootUrl defines the url where the file to load is located
     * @param scene defines the current scene
     * @param lodScale defines scale to apply to the mip map selection
     * @param lodOffset defines offset to apply to the mip map selection
     * @param onLoad defines an optional callback raised when the texture is loaded
     * @param onError defines an optional callback raised if there is an issue to load the texture
     * @param format defines the format of the data
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param createPolynomials defines wheter or not to create polynomails harmonics for the texture
     * @returns the cube texture as an InternalTexture
     */
    ThinEngine.prototype.createPrefilteredCubeTexture = function (rootUrl, scene, lodScale, lodOffset, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = true) {
        const callback = (loadData) => {
            if (!loadData) {
                if (onLoad) {
                    onLoad(null);
                }
                return;
            }
            const texture = loadData.texture;
            if (!createPolynomials) {
                texture._sphericalPolynomial = new SphericalPolynomial();
            }
            else if (loadData.info.sphericalPolynomial) {
                texture._sphericalPolynomial = loadData.info.sphericalPolynomial;
            }
            texture._source = InternalTextureSource.CubePrefiltered;
            if (this.getCaps().textureLOD) {
                // Do not add extra process if texture lod is supported.
                if (onLoad) {
                    onLoad(texture);
                }
                return;
            }
            const mipSlices = 3;
            const gl = this._gl;
            const width = loadData.width;
            if (!width) {
                return;
            }
            const textures = [];
            for (let i = 0; i < mipSlices; i++) {
                //compute LOD from even spacing in smoothness (matching shader calculation)
                const smoothness = i / (mipSlices - 1);
                const roughness = 1 - smoothness;
                const minLODIndex = lodOffset; // roughness = 0
                const maxLODIndex = Scalar.Log2(width) * lodScale + lodOffset; // roughness = 1
                const lodIndex = minLODIndex + (maxLODIndex - minLODIndex) * roughness;
                const mipmapIndex = Math.round(Math.min(Math.max(lodIndex, 0), maxLODIndex));
                const glTextureFromLod = new InternalTexture(this, InternalTextureSource.Temp);
                glTextureFromLod.type = texture.type;
                glTextureFromLod.format = texture.format;
                glTextureFromLod.width = Math.pow(2, Math.max(Scalar.Log2(width) - mipmapIndex, 0));
                glTextureFromLod.height = glTextureFromLod.width;
                glTextureFromLod.isCube = true;
                glTextureFromLod._cachedWrapU = 0;
                glTextureFromLod._cachedWrapV = 0;
                this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, glTextureFromLod, true);
                glTextureFromLod.samplingMode = 2;
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                if (loadData.isDDS) {
                    const info = loadData.info;
                    const data = loadData.data;
                    this._unpackFlipY(info.isCompressed);
                    DDSTools.UploadDDSLevels(this, glTextureFromLod, data, info, true, 6, mipmapIndex);
                }
                else {
                    Logger.Warn("DDS is the only prefiltered cube map supported so far.");
                }
                this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
                // Wrap in a base texture for easy binding.
                const lodTexture = new BaseTexture(scene);
                lodTexture._isCube = true;
                lodTexture._texture = glTextureFromLod;
                glTextureFromLod.isReady = true;
                textures.push(lodTexture);
            }
            texture._lodTextureHigh = textures[2];
            texture._lodTextureMid = textures[1];
            texture._lodTextureLow = textures[0];
            if (onLoad) {
                onLoad(texture);
            }
        };
        return this.createCubeTexture(rootUrl, scene, null, false, callback, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset);
    };

    /**
     * Implementation of the DDS Texture Loader.
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _DDSTextureLoader {
        constructor() {
            /**
             * Defines whether the loader supports cascade loading the different faces.
             */
            this.supportCascades = true;
        }
        /**
         * This returns if the loader support the current file information.
         * @param extension defines the file extension of the file being loaded
         * @returns true if the loader can load the specified file
         */
        canLoad(extension) {
            return extension.endsWith(".dds");
        }
        /**
         * Uploads the cube texture data to the WebGL texture. It has already been bound.
         * @param imgs contains the cube maps
         * @param texture defines the BabylonJS internal texture
         * @param createPolynomials will be true if polynomials have been requested
         * @param onLoad defines the callback to trigger once the texture is ready
         */
        loadCubeData(imgs, texture, createPolynomials, onLoad) {
            const engine = texture.getEngine();
            let info;
            let loadMipmap = false;
            let maxLevel = 1000;
            if (Array.isArray(imgs)) {
                for (let index = 0; index < imgs.length; index++) {
                    const data = imgs[index];
                    info = DDSTools.GetDDSInfo(data);
                    texture.width = info.width;
                    texture.height = info.height;
                    loadMipmap = (info.isRGB || info.isLuminance || info.mipmapCount > 1) && texture.generateMipMaps;
                    engine._unpackFlipY(info.isCompressed);
                    DDSTools.UploadDDSLevels(engine, texture, data, info, loadMipmap, 6, -1, index);
                    if (!info.isFourCC && info.mipmapCount === 1) {
                        engine.generateMipMapsForCubemap(texture);
                    }
                    else {
                        maxLevel = info.mipmapCount - 1;
                    }
                }
            }
            else {
                const data = imgs;
                info = DDSTools.GetDDSInfo(data);
                texture.width = info.width;
                texture.height = info.height;
                if (createPolynomials) {
                    info.sphericalPolynomial = new SphericalPolynomial();
                }
                loadMipmap = (info.isRGB || info.isLuminance || info.mipmapCount > 1) && texture.generateMipMaps;
                engine._unpackFlipY(info.isCompressed);
                DDSTools.UploadDDSLevels(engine, texture, data, info, loadMipmap, 6);
                if (!info.isFourCC && info.mipmapCount === 1) {
                    // Do not unbind as we still need to set the parameters.
                    engine.generateMipMapsForCubemap(texture, false);
                }
                else {
                    maxLevel = info.mipmapCount - 1;
                }
            }
            engine._setCubeMapTextureParams(texture, loadMipmap, maxLevel);
            texture.isReady = true;
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
            if (onLoad) {
                onLoad({ isDDS: true, width: texture.width, info, data: imgs, texture });
            }
        }
        /**
         * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param callback defines the method to call once ready to upload
         */
        loadData(data, texture, callback) {
            const info = DDSTools.GetDDSInfo(data);
            const loadMipmap = (info.isRGB || info.isLuminance || info.mipmapCount > 1) && texture.generateMipMaps && info.width >> (info.mipmapCount - 1) === 1;
            callback(info.width, info.height, loadMipmap, info.isFourCC, () => {
                DDSTools.UploadDDSLevels(texture.getEngine(), texture, data, info, loadMipmap, 1);
            });
        }
    }
    // Register the loader.
    Engine._TextureLoaders.push(new _DDSTextureLoader());

    // Do not edit.
    const name$1W = "rgbdEncodePixelShader";
    const shader$1W = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<helperFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=toRGBD(texture2D(textureSampler,vUV).rgb);}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1W] = shader$1W;

    const DefaultEnvironmentTextureImageType = "image/png";
    const CurrentVersion = 2;
    /**
     * Magic number identifying the env file.
     */
    const MagicBytes = [0x86, 0x16, 0x87, 0x96, 0xf6, 0xd6, 0x96, 0x36];
    /**
     * Gets the environment info from an env file.
     * @param data The array buffer containing the .env bytes.
     * @returns the environment file info (the json header) if successfully parsed, normalized to the latest supported version.
     */
    function GetEnvInfo(data) {
        const dataView = new DataView(data.buffer, data.byteOffset, data.byteLength);
        let pos = 0;
        for (let i = 0; i < MagicBytes.length; i++) {
            if (dataView.getUint8(pos++) !== MagicBytes[i]) {
                Logger.Error("Not a babylon environment map");
                return null;
            }
        }
        // Read json manifest - collect characters up to null terminator
        let manifestString = "";
        let charCode = 0x00;
        while ((charCode = dataView.getUint8(pos++))) {
            manifestString += String.fromCharCode(charCode);
        }
        let manifest = JSON.parse(manifestString);
        manifest = normalizeEnvInfo(manifest);
        if (manifest.specular) {
            // Extend the header with the position of the payload.
            manifest.specular.specularDataPosition = pos;
            // Fallback to 0.8 exactly if lodGenerationScale is not defined for backward compatibility.
            manifest.specular.lodGenerationScale = manifest.specular.lodGenerationScale || 0.8;
        }
        return manifest;
    }
    /**
     * Normalizes any supported version of the environment file info to the latest version
     * @param info environment file info on any supported version
     * @returns environment file info in the latest supported version
     * @private
     */
    function normalizeEnvInfo(info) {
        if (info.version > CurrentVersion) {
            throw new Error(`Unsupported babylon environment map version "${info.version}". Latest supported version is "${CurrentVersion}".`);
        }
        if (info.version === 2) {
            return info;
        }
        // Migrate a v1 info to v2
        info = Object.assign(Object.assign({}, info), { version: 2, imageType: DefaultEnvironmentTextureImageType });
        return info;
    }
    /**
     * Creates an environment texture from a loaded cube texture.
     * @param texture defines the cube texture to convert in env file
     * @param options options for the conversion process
     * @param options.imageType the mime type for the encoded images, with support for "image/png" (default) and "image/webp"
     * @param options.imageQuality the image quality of encoded WebP images.
     * @returns a promise containing the environment data if successful.
     */
    async function CreateEnvTextureAsync(texture, options = {}) {
        var _a, _b;
        const internalTexture = texture.getInternalTexture();
        if (!internalTexture) {
            return Promise.reject("The cube texture is invalid.");
        }
        const imageType = (_a = options.imageType) !== null && _a !== void 0 ? _a : DefaultEnvironmentTextureImageType;
        const engine = internalTexture.getEngine();
        if (texture.textureType !== 2 &&
            texture.textureType !== 1 &&
            texture.textureType !== 0 &&
            texture.textureType !== 0 &&
            texture.textureType !== 7 &&
            texture.textureType !== -1) {
            return Promise.reject("The cube texture should allow HDR (Full Float or Half Float).");
        }
        let textureType = 1;
        if (!engine.getCaps().textureFloatRender) {
            textureType = 2;
            if (!engine.getCaps().textureHalfFloatRender) {
                return Promise.reject("Env texture can only be created when the browser supports half float or full float rendering.");
            }
        }
        // sphericalPolynomial is lazy loaded so simply accessing it should trigger the computation.
        texture.sphericalPolynomial;
        // Lets keep track of the polynomial promise so we can wait for it to be ready before generating the pixels.
        const sphericalPolynomialPromise = (_b = texture.getInternalTexture()) === null || _b === void 0 ? void 0 : _b._sphericalPolynomialPromise;
        const cubeWidth = internalTexture.width;
        const hostingScene = new Scene(engine);
        const specularTextures = {};
        // As we are going to readPixels the faces of the cube, make sure the drawing/update commands for the cube texture are fully sent to the GPU in case it is drawn for the first time in this very frame!
        engine.flushFramebuffer();
        // Read and collect all mipmaps data from the cube.
        const mipmapsCount = Scalar.ILog2(internalTexture.width);
        for (let i = 0; i <= mipmapsCount; i++) {
            const faceWidth = Math.pow(2, mipmapsCount - i);
            // All faces of the cube.
            for (let face = 0; face < 6; face++) {
                let faceData = await texture.readPixels(face, i, undefined, false);
                if (faceData && faceData.byteLength === faceData.length) {
                    const faceDataFloat = new Float32Array(faceData.byteLength * 4);
                    for (let i = 0; i < faceData.byteLength; i++) {
                        faceDataFloat[i] = faceData[i] / 255;
                        // Gamma to linear
                        faceDataFloat[i] = Math.pow(faceDataFloat[i], 2.2);
                    }
                    faceData = faceDataFloat;
                }
                else if (faceData && texture.gammaSpace) {
                    const floatData = faceData;
                    for (let i = 0; i < floatData.length; i++) {
                        // Gamma to linear
                        floatData[i] = Math.pow(floatData[i], 2.2);
                    }
                }
                const tempTexture = engine.createRawTexture(faceData, faceWidth, faceWidth, 5, false, true, 1, null, textureType);
                await RGBDTextureTools.EncodeTextureToRGBD(tempTexture, hostingScene, textureType);
                const rgbdEncodedData = await engine._readTexturePixels(tempTexture, faceWidth, faceWidth);
                const imageEncodedData = await DumpTools.DumpDataAsync(faceWidth, faceWidth, rgbdEncodedData, imageType, undefined, false, true, options.imageQuality);
                specularTextures[i * 6 + face] = imageEncodedData;
                tempTexture.dispose();
            }
        }
        // We can delete the hosting scene keeping track of all the creation objects
        hostingScene.dispose();
        // Ensure completion of the polynomial creation promise.
        if (sphericalPolynomialPromise) {
            await sphericalPolynomialPromise;
        }
        // Creates the json header for the env texture
        const info = {
            version: CurrentVersion,
            width: cubeWidth,
            imageType,
            irradiance: _CreateEnvTextureIrradiance(texture),
            specular: {
                mipmaps: [],
                lodGenerationScale: texture.lodGenerationScale,
            },
        };
        // Sets the specular image data information
        let position = 0;
        for (let i = 0; i <= mipmapsCount; i++) {
            for (let face = 0; face < 6; face++) {
                const byteLength = specularTextures[i * 6 + face].byteLength;
                info.specular.mipmaps.push({
                    length: byteLength,
                    position: position,
                });
                position += byteLength;
            }
        }
        // Encode the JSON as an array buffer
        const infoString = JSON.stringify(info);
        const infoBuffer = new ArrayBuffer(infoString.length + 1);
        const infoView = new Uint8Array(infoBuffer); // Limited to ascii subset matching unicode.
        for (let i = 0, strLen = infoString.length; i < strLen; i++) {
            infoView[i] = infoString.charCodeAt(i);
        }
        // Ends up with a null terminator for easier parsing
        infoView[infoString.length] = 0x00;
        // Computes the final required size and creates the storage
        const totalSize = MagicBytes.length + position + infoBuffer.byteLength;
        const finalBuffer = new ArrayBuffer(totalSize);
        const finalBufferView = new Uint8Array(finalBuffer);
        const dataView = new DataView(finalBuffer);
        // Copy the magic bytes identifying the file in
        let pos = 0;
        for (let i = 0; i < MagicBytes.length; i++) {
            dataView.setUint8(pos++, MagicBytes[i]);
        }
        // Add the json info
        finalBufferView.set(new Uint8Array(infoBuffer), pos);
        pos += infoBuffer.byteLength;
        // Finally inserts the texture data
        for (let i = 0; i <= mipmapsCount; i++) {
            for (let face = 0; face < 6; face++) {
                const dataBuffer = specularTextures[i * 6 + face];
                finalBufferView.set(new Uint8Array(dataBuffer), pos);
                pos += dataBuffer.byteLength;
            }
        }
        // Voila
        return finalBuffer;
    }
    /**
     * Creates a JSON representation of the spherical data.
     * @param texture defines the texture containing the polynomials
     * @returns the JSON representation of the spherical info
     */
    function _CreateEnvTextureIrradiance(texture) {
        const polynmials = texture.sphericalPolynomial;
        if (polynmials == null) {
            return null;
        }
        return {
            x: [polynmials.x.x, polynmials.x.y, polynmials.x.z],
            y: [polynmials.y.x, polynmials.y.y, polynmials.y.z],
            z: [polynmials.z.x, polynmials.z.y, polynmials.z.z],
            xx: [polynmials.xx.x, polynmials.xx.y, polynmials.xx.z],
            yy: [polynmials.yy.x, polynmials.yy.y, polynmials.yy.z],
            zz: [polynmials.zz.x, polynmials.zz.y, polynmials.zz.z],
            yz: [polynmials.yz.x, polynmials.yz.y, polynmials.yz.z],
            zx: [polynmials.zx.x, polynmials.zx.y, polynmials.zx.z],
            xy: [polynmials.xy.x, polynmials.xy.y, polynmials.xy.z],
        };
    }
    /**
     * Creates the ArrayBufferViews used for initializing environment texture image data.
     * @param data the image data
     * @param info parameters that determine what views will be created for accessing the underlying buffer
     * @returns the views described by info providing access to the underlying buffer
     */
    function CreateImageDataArrayBufferViews(data, info) {
        info = normalizeEnvInfo(info);
        const specularInfo = info.specular;
        // Double checks the enclosed info
        let mipmapsCount = Scalar.Log2(info.width);
        mipmapsCount = Math.round(mipmapsCount) + 1;
        if (specularInfo.mipmaps.length !== 6 * mipmapsCount) {
            throw new Error(`Unsupported specular mipmaps number "${specularInfo.mipmaps.length}"`);
        }
        const imageData = new Array(mipmapsCount);
        for (let i = 0; i < mipmapsCount; i++) {
            imageData[i] = new Array(6);
            for (let face = 0; face < 6; face++) {
                const imageInfo = specularInfo.mipmaps[i * 6 + face];
                imageData[i][face] = new Uint8Array(data.buffer, data.byteOffset + specularInfo.specularDataPosition + imageInfo.position, imageInfo.length);
            }
        }
        return imageData;
    }
    /**
     * Uploads the texture info contained in the env file to the GPU.
     * @param texture defines the internal texture to upload to
     * @param data defines the data to load
     * @param info defines the texture info retrieved through the GetEnvInfo method
     * @returns a promise
     */
    function UploadEnvLevelsAsync(texture, data, info) {
        info = normalizeEnvInfo(info);
        const specularInfo = info.specular;
        if (!specularInfo) {
            // Nothing else parsed so far
            return Promise.resolve();
        }
        texture._lodGenerationScale = specularInfo.lodGenerationScale;
        const imageData = CreateImageDataArrayBufferViews(data, info);
        return UploadLevelsAsync(texture, imageData, info.imageType);
    }
    function _OnImageReadyAsync(image, engine, expandTexture, rgbdPostProcess, url, face, i, generateNonLODTextures, lodTextures, cubeRtt, texture) {
        return new Promise((resolve, reject) => {
            if (expandTexture) {
                const tempTexture = engine.createTexture(null, true, true, null, 1, null, (message) => {
                    reject(message);
                }, image);
                rgbdPostProcess.getEffect().executeWhenCompiled(() => {
                    // Uncompress the data to a RTT
                    rgbdPostProcess.externalTextureSamplerBinding = true;
                    rgbdPostProcess.onApply = (effect) => {
                        effect._bindTexture("textureSampler", tempTexture);
                        effect.setFloat2("scale", 1, engine._features.needsInvertingBitmap && image instanceof ImageBitmap ? -1 : 1);
                    };
                    if (!engine.scenes.length) {
                        return;
                    }
                    engine.scenes[0].postProcessManager.directRender([rgbdPostProcess], cubeRtt, true, face, i);
                    // Cleanup
                    engine.restoreDefaultFramebuffer();
                    tempTexture.dispose();
                    URL.revokeObjectURL(url);
                    resolve();
                });
            }
            else {
                engine._uploadImageToTexture(texture, image, face, i);
                // Upload the face to the non lod texture support
                if (generateNonLODTextures) {
                    const lodTexture = lodTextures[i];
                    if (lodTexture) {
                        engine._uploadImageToTexture(lodTexture._texture, image, face, 0);
                    }
                }
                resolve();
            }
        });
    }
    /**
     * Uploads the levels of image data to the GPU.
     * @param texture defines the internal texture to upload to
     * @param imageData defines the array buffer views of image data [mipmap][face]
     * @param imageType the mime type of the image data
     * @returns a promise
     */
    function UploadLevelsAsync(texture, imageData, imageType = DefaultEnvironmentTextureImageType) {
        if (!Tools.IsExponentOfTwo(texture.width)) {
            throw new Error("Texture size must be a power of two");
        }
        const mipmapsCount = Scalar.ILog2(texture.width) + 1;
        // Gets everything ready.
        const engine = texture.getEngine();
        let expandTexture = false;
        let generateNonLODTextures = false;
        let rgbdPostProcess = null;
        let cubeRtt = null;
        let lodTextures = null;
        const caps = engine.getCaps();
        texture.format = 5;
        texture.type = 0;
        texture.generateMipMaps = true;
        texture._cachedAnisotropicFilteringLevel = null;
        engine.updateTextureSamplingMode(3, texture);
        // Add extra process if texture lod is not supported
        if (!caps.textureLOD) {
            expandTexture = false;
            generateNonLODTextures = true;
            lodTextures = {};
        }
        // in webgl 1 there are no ways to either render or copy lod level information for float textures.
        else if (!engine._features.supportRenderAndCopyToLodForFloatTextures) {
            expandTexture = false;
        }
        // If half float available we can uncompress the texture
        else if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) {
            expandTexture = true;
            texture.type = 2;
        }
        // If full float available we can uncompress the texture
        else if (caps.textureFloatRender && caps.textureFloatLinearFiltering) {
            expandTexture = true;
            texture.type = 1;
        }
        // Expand the texture if possible
        if (expandTexture) {
            // Simply run through the decode PP
            rgbdPostProcess = new PostProcess("rgbdDecode", "rgbdDecode", null, null, 1, null, 3, engine, false, undefined, texture.type, undefined, null, false);
            texture._isRGBD = false;
            texture.invertY = false;
            cubeRtt = engine.createRenderTargetCubeTexture(texture.width, {
                generateDepthBuffer: false,
                generateMipMaps: true,
                generateStencilBuffer: false,
                samplingMode: 3,
                type: texture.type,
                format: 5,
            });
        }
        else {
            texture._isRGBD = true;
            texture.invertY = true;
            // In case of missing support, applies the same patch than DDS files.
            if (generateNonLODTextures) {
                const mipSlices = 3;
                const scale = texture._lodGenerationScale;
                const offset = texture._lodGenerationOffset;
                for (let i = 0; i < mipSlices; i++) {
                    //compute LOD from even spacing in smoothness (matching shader calculation)
                    const smoothness = i / (mipSlices - 1);
                    const roughness = 1 - smoothness;
                    const minLODIndex = offset; // roughness = 0
                    const maxLODIndex = (mipmapsCount - 1) * scale + offset; // roughness = 1 (mipmaps start from 0)
                    const lodIndex = minLODIndex + (maxLODIndex - minLODIndex) * roughness;
                    const mipmapIndex = Math.round(Math.min(Math.max(lodIndex, 0), maxLODIndex));
                    const glTextureFromLod = new InternalTexture(engine, InternalTextureSource.Temp);
                    glTextureFromLod.isCube = true;
                    glTextureFromLod.invertY = true;
                    glTextureFromLod.generateMipMaps = false;
                    engine.updateTextureSamplingMode(2, glTextureFromLod);
                    // Wrap in a base texture for easy binding.
                    const lodTexture = new BaseTexture(null);
                    lodTexture._isCube = true;
                    lodTexture._texture = glTextureFromLod;
                    lodTextures[mipmapIndex] = lodTexture;
                    switch (i) {
                        case 0:
                            texture._lodTextureLow = lodTexture;
                            break;
                        case 1:
                            texture._lodTextureMid = lodTexture;
                            break;
                        case 2:
                            texture._lodTextureHigh = lodTexture;
                            break;
                    }
                }
            }
        }
        const promises = [];
        // All mipmaps up to provided number of images
        for (let i = 0; i < imageData.length; i++) {
            // All faces
            for (let face = 0; face < 6; face++) {
                // Constructs an image element from image data
                const bytes = imageData[i][face];
                const blob = new Blob([bytes], { type: imageType });
                const url = URL.createObjectURL(blob);
                let promise;
                if (typeof Image === "undefined" || engine._features.forceBitmapOverHTMLImageElement) {
                    promise = engine.createImageBitmap(blob, { premultiplyAlpha: "none" }).then((img) => {
                        return _OnImageReadyAsync(img, engine, expandTexture, rgbdPostProcess, url, face, i, generateNonLODTextures, lodTextures, cubeRtt, texture);
                    });
                }
                else {
                    const image = new Image();
                    image.src = url;
                    // Enqueue promise to upload to the texture.
                    promise = new Promise((resolve, reject) => {
                        image.onload = () => {
                            _OnImageReadyAsync(image, engine, expandTexture, rgbdPostProcess, url, face, i, generateNonLODTextures, lodTextures, cubeRtt, texture)
                                .then(() => resolve())
                                .catch((reason) => {
                                reject(reason);
                            });
                        };
                        image.onerror = (error) => {
                            reject(error);
                        };
                    });
                }
                promises.push(promise);
            }
        }
        // Fill remaining mipmaps with black textures.
        if (imageData.length < mipmapsCount) {
            let data;
            const size = Math.pow(2, mipmapsCount - 1 - imageData.length);
            const dataLength = size * size * 4;
            switch (texture.type) {
                case 0: {
                    data = new Uint8Array(dataLength);
                    break;
                }
                case 2: {
                    data = new Uint16Array(dataLength);
                    break;
                }
                case 1: {
                    data = new Float32Array(dataLength);
                    break;
                }
            }
            for (let i = imageData.length; i < mipmapsCount; i++) {
                for (let face = 0; face < 6; face++) {
                    engine._uploadArrayBufferViewToTexture(texture, data, face, i);
                }
            }
        }
        // Once all done, finishes the cleanup and return
        return Promise.all(promises).then(() => {
            // Release temp RTT.
            if (cubeRtt) {
                engine._releaseTexture(texture);
                cubeRtt._swapAndDie(texture);
            }
            // Release temp Post Process.
            if (rgbdPostProcess) {
                rgbdPostProcess.dispose();
            }
            // Flag internal texture as ready in case they are in use.
            if (generateNonLODTextures) {
                if (texture._lodTextureHigh && texture._lodTextureHigh._texture) {
                    texture._lodTextureHigh._texture.isReady = true;
                }
                if (texture._lodTextureMid && texture._lodTextureMid._texture) {
                    texture._lodTextureMid._texture.isReady = true;
                }
                if (texture._lodTextureLow && texture._lodTextureLow._texture) {
                    texture._lodTextureLow._texture.isReady = true;
                }
            }
        });
    }
    /**
     * Uploads spherical polynomials information to the texture.
     * @param texture defines the texture we are trying to upload the information to
     * @param info defines the environment texture info retrieved through the GetEnvInfo method
     */
    function UploadEnvSpherical(texture, info) {
        info = normalizeEnvInfo(info);
        const irradianceInfo = info.irradiance;
        if (!irradianceInfo) {
            return;
        }
        const sp = new SphericalPolynomial();
        Vector3.FromArrayToRef(irradianceInfo.x, 0, sp.x);
        Vector3.FromArrayToRef(irradianceInfo.y, 0, sp.y);
        Vector3.FromArrayToRef(irradianceInfo.z, 0, sp.z);
        Vector3.FromArrayToRef(irradianceInfo.xx, 0, sp.xx);
        Vector3.FromArrayToRef(irradianceInfo.yy, 0, sp.yy);
        Vector3.FromArrayToRef(irradianceInfo.zz, 0, sp.zz);
        Vector3.FromArrayToRef(irradianceInfo.yz, 0, sp.yz);
        Vector3.FromArrayToRef(irradianceInfo.zx, 0, sp.zx);
        Vector3.FromArrayToRef(irradianceInfo.xy, 0, sp.xy);
        texture._sphericalPolynomial = sp;
    }
    /**
     * Sets of helpers addressing the serialization and deserialization of environment texture
     * stored in a BabylonJS env file.
     * Those files are usually stored as .env files.
     */
    const EnvironmentTextureTools = {
        /**
         * Gets the environment info from an env file.
         * @param data The array buffer containing the .env bytes.
         * @returns the environment file info (the json header) if successfully parsed, normalized to the latest supported version.
         */
        GetEnvInfo,
        /**
         * Creates an environment texture from a loaded cube texture.
         * @param texture defines the cube texture to convert in env file
         * @param options options for the conversion process
         * @param options.imageType the mime type for the encoded images, with support for "image/png" (default) and "image/webp"
         * @param options.imageQuality the image quality of encoded WebP images.
         * @returns a promise containing the environment data if successful.
         */
        CreateEnvTextureAsync,
        /**
         * Creates the ArrayBufferViews used for initializing environment texture image data.
         * @param data the image data
         * @param info parameters that determine what views will be created for accessing the underlying buffer
         * @returns the views described by info providing access to the underlying buffer
         */
        CreateImageDataArrayBufferViews,
        /**
         * Uploads the texture info contained in the env file to the GPU.
         * @param texture defines the internal texture to upload to
         * @param data defines the data to load
         * @param info defines the texture info retrieved through the GetEnvInfo method
         * @returns a promise
         */
        UploadEnvLevelsAsync,
        /**
         * Uploads the levels of image data to the GPU.
         * @param texture defines the internal texture to upload to
         * @param imageData defines the array buffer views of image data [mipmap][face]
         * @param imageType the mime type of the image data
         * @returns a promise
         */
        UploadLevelsAsync,
        /**
         * Uploads spherical polynomials information to the texture.
         * @param texture defines the texture we are trying to upload the information to
         * @param info defines the environment texture info retrieved through the GetEnvInfo method
         */
        UploadEnvSpherical,
    };

    /**
     * Implementation of the ENV Texture Loader.
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _ENVTextureLoader {
        constructor() {
            /**
             * Defines whether the loader supports cascade loading the different faces.
             */
            this.supportCascades = false;
        }
        /**
         * This returns if the loader support the current file information.
         * @param extension defines the file extension of the file being loaded
         * @returns true if the loader can load the specified file
         */
        canLoad(extension) {
            return extension.endsWith(".env");
        }
        /**
         * Uploads the cube texture data to the WebGL texture. It has already been bound.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param createPolynomials will be true if polynomials have been requested
         * @param onLoad defines the callback to trigger once the texture is ready
         * @param onError defines the callback to trigger in case of error
         */
        loadCubeData(data, texture, createPolynomials, onLoad, onError) {
            if (Array.isArray(data)) {
                return;
            }
            const info = GetEnvInfo(data);
            if (info) {
                texture.width = info.width;
                texture.height = info.width;
                try {
                    UploadEnvSpherical(texture, info);
                    UploadEnvLevelsAsync(texture, data, info).then(() => {
                        texture.isReady = true;
                        texture.onLoadedObservable.notifyObservers(texture);
                        texture.onLoadedObservable.clear();
                        if (onLoad) {
                            onLoad();
                        }
                    }, (reason) => {
                        onError === null || onError === void 0 ? void 0 : onError("Can not upload environment levels", reason);
                    });
                }
                catch (e) {
                    onError === null || onError === void 0 ? void 0 : onError("Can not upload environment file", e);
                }
            }
            else if (onError) {
                onError("Can not parse the environment file", null);
            }
        }
        /**
         * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
         */
        loadData() {
            throw ".env not supported in 2d.";
        }
    }
    // Register the loader.
    Engine._TextureLoaders.push(new _ENVTextureLoader());

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * for description see https://www.khronos.org/opengles/sdk/tools/KTX/
     * for file layout see https://www.khronos.org/opengles/sdk/tools/KTX/file_format_spec/
     */
    class KhronosTextureContainer {
        /**
         * Creates a new KhronosTextureContainer
         * @param data contents of the KTX container file
         * @param facesExpected should be either 1 or 6, based whether a cube texture or or
         */
        constructor(
        /** contents of the KTX container file */
        data, facesExpected) {
            this.data = data;
            /**
             * If the container has been made invalid (eg. constructor failed to correctly load array buffer)
             */
            this.isInvalid = false;
            if (!KhronosTextureContainer.IsValid(data)) {
                this.isInvalid = true;
                Logger.Error("texture missing KTX identifier");
                return;
            }
            // load the reset of the header in native 32 bit uint
            const dataSize = Uint32Array.BYTES_PER_ELEMENT;
            const headerDataView = new DataView(this.data.buffer, this.data.byteOffset + 12, 13 * dataSize);
            const endianness = headerDataView.getUint32(0, true);
            const littleEndian = endianness === 0x04030201;
            this.glType = headerDataView.getUint32(1 * dataSize, littleEndian); // must be 0 for compressed textures
            this.glTypeSize = headerDataView.getUint32(2 * dataSize, littleEndian); // must be 1 for compressed textures
            this.glFormat = headerDataView.getUint32(3 * dataSize, littleEndian); // must be 0 for compressed textures
            this.glInternalFormat = headerDataView.getUint32(4 * dataSize, littleEndian); // the value of arg passed to gl.compressedTexImage2D(,,x,,,,)
            this.glBaseInternalFormat = headerDataView.getUint32(5 * dataSize, littleEndian); // specify GL_RGB, GL_RGBA, GL_ALPHA, etc (un-compressed only)
            this.pixelWidth = headerDataView.getUint32(6 * dataSize, littleEndian); // level 0 value of arg passed to gl.compressedTexImage2D(,,,x,,,)
            this.pixelHeight = headerDataView.getUint32(7 * dataSize, littleEndian); // level 0 value of arg passed to gl.compressedTexImage2D(,,,,x,,)
            this.pixelDepth = headerDataView.getUint32(8 * dataSize, littleEndian); // level 0 value of arg passed to gl.compressedTexImage3D(,,,,,x,,)
            this.numberOfArrayElements = headerDataView.getUint32(9 * dataSize, littleEndian); // used for texture arrays
            this.numberOfFaces = headerDataView.getUint32(10 * dataSize, littleEndian); // used for cubemap textures, should either be 1 or 6
            this.numberOfMipmapLevels = headerDataView.getUint32(11 * dataSize, littleEndian); // number of levels; disregard possibility of 0 for compressed textures
            this.bytesOfKeyValueData = headerDataView.getUint32(12 * dataSize, littleEndian); // the amount of space after the header for meta-data
            // Make sure we have a compressed type.  Not only reduces work, but probably better to let dev know they are not compressing.
            if (this.glType !== 0) {
                Logger.Error("only compressed formats currently supported");
                this.isInvalid = true;
                return;
            }
            else {
                // value of zero is an indication to generate mipmaps @ runtime.  Not usually allowed for compressed, so disregard.
                this.numberOfMipmapLevels = Math.max(1, this.numberOfMipmapLevels);
            }
            if (this.pixelHeight === 0 || this.pixelDepth !== 0) {
                Logger.Error("only 2D textures currently supported");
                this.isInvalid = true;
                return;
            }
            if (this.numberOfArrayElements !== 0) {
                Logger.Error("texture arrays not currently supported");
                this.isInvalid = true;
                return;
            }
            if (this.numberOfFaces !== facesExpected) {
                Logger.Error("number of faces expected" + facesExpected + ", but found " + this.numberOfFaces);
                this.isInvalid = true;
                return;
            }
            // we now have a completely validated file, so could use existence of loadType as success
            // would need to make this more elaborate & adjust checks above to support more than one load type
            this.loadType = KhronosTextureContainer.COMPRESSED_2D;
        }
        /**
         * Uploads KTX content to a Babylon Texture.
         * It is assumed that the texture has already been created & is currently bound
         * @internal
         */
        uploadLevels(texture, loadMipmaps) {
            switch (this.loadType) {
                case KhronosTextureContainer.COMPRESSED_2D:
                    this._upload2DCompressedLevels(texture, loadMipmaps);
                    break;
            }
        }
        _upload2DCompressedLevels(texture, loadMipmaps) {
            // initialize width & height for level 1
            let dataOffset = KhronosTextureContainer.HEADER_LEN + this.bytesOfKeyValueData;
            let width = this.pixelWidth;
            let height = this.pixelHeight;
            const mipmapCount = loadMipmaps ? this.numberOfMipmapLevels : 1;
            for (let level = 0; level < mipmapCount; level++) {
                const imageSize = new Int32Array(this.data.buffer, this.data.byteOffset + dataOffset, 1)[0]; // size per face, since not supporting array cubemaps
                dataOffset += 4; //image data starts from next multiple of 4 offset. Each face refers to same imagesize field above.
                for (let face = 0; face < this.numberOfFaces; face++) {
                    const byteArray = new Uint8Array(this.data.buffer, this.data.byteOffset + dataOffset, imageSize);
                    const engine = texture.getEngine();
                    engine._uploadCompressedDataToTextureDirectly(texture, texture.format, width, height, byteArray, face, level);
                    dataOffset += imageSize; // add size of the image for the next face/mipmap
                    dataOffset += 3 - ((imageSize + 3) % 4); // add padding for odd sized image
                }
                width = Math.max(1.0, width * 0.5);
                height = Math.max(1.0, height * 0.5);
            }
        }
        /**
         * Checks if the given data starts with a KTX file identifier.
         * @param data the data to check
         * @returns true if the data is a KTX file or false otherwise
         */
        static IsValid(data) {
            if (data.byteLength >= 12) {
                // '«', 'K', 'T', 'X', ' ', '1', '1', '»', '\r', '\n', '\x1A', '\n'
                const identifier = new Uint8Array(data.buffer, data.byteOffset, 12);
                if (identifier[0] === 0xab &&
                    identifier[1] === 0x4b &&
                    identifier[2] === 0x54 &&
                    identifier[3] === 0x58 &&
                    identifier[4] === 0x20 &&
                    identifier[5] === 0x31 &&
                    identifier[6] === 0x31 &&
                    identifier[7] === 0xbb &&
                    identifier[8] === 0x0d &&
                    identifier[9] === 0x0a &&
                    identifier[10] === 0x1a &&
                    identifier[11] === 0x0a) {
                    return true;
                }
            }
            return false;
        }
    }
    KhronosTextureContainer.HEADER_LEN = 12 + 13 * 4; // identifier + header elements (not including key value meta-data pairs)
    // load types
    KhronosTextureContainer.COMPRESSED_2D = 0; // uses a gl.compressedTexImage2D()
    KhronosTextureContainer.COMPRESSED_3D = 1; // uses a gl.compressedTexImage3D()
    KhronosTextureContainer.TEX_2D = 2; // uses a gl.texImage2D()
    KhronosTextureContainer.TEX_3D = 3; // uses a gl.texImage3D()

    /**
     * Helper class to push actions to a pool of workers.
     */
    class WorkerPool {
        /**
         * Constructor
         * @param workers Array of workers to use for actions
         */
        constructor(workers) {
            this._pendingActions = new Array();
            this._workerInfos = workers.map((worker) => ({
                workerPromise: Promise.resolve(worker),
                idle: true,
            }));
        }
        /**
         * Terminates all workers and clears any pending actions.
         */
        dispose() {
            for (const workerInfo of this._workerInfos) {
                workerInfo.workerPromise.then((worker) => {
                    worker.terminate();
                });
            }
            this._workerInfos.length = 0;
            this._pendingActions.length = 0;
        }
        /**
         * Pushes an action to the worker pool. If all the workers are active, the action will be
         * pended until a worker has completed its action.
         * @param action The action to perform. Call onComplete when the action is complete.
         */
        push(action) {
            if (!this._executeOnIdleWorker(action)) {
                this._pendingActions.push(action);
            }
        }
        _executeOnIdleWorker(action) {
            for (const workerInfo of this._workerInfos) {
                if (workerInfo.idle) {
                    this._execute(workerInfo, action);
                    return true;
                }
            }
            return false;
        }
        _execute(workerInfo, action) {
            workerInfo.idle = false;
            workerInfo.workerPromise.then((worker) => {
                action(worker, () => {
                    const nextAction = this._pendingActions.shift();
                    if (nextAction) {
                        this._execute(workerInfo, nextAction);
                    }
                    else {
                        workerInfo.idle = true;
                    }
                });
            });
        }
    }
    /**
     * Similar to the WorkerPool class except it creates and destroys workers automatically with a maximum of `maxWorkers` workers.
     * Workers are terminated when it is idle for at least `idleTimeElapsedBeforeRelease` milliseconds.
     */
    class AutoReleaseWorkerPool extends WorkerPool {
        constructor(maxWorkers, createWorkerAsync, options = AutoReleaseWorkerPool.DefaultOptions) {
            super([]);
            this._maxWorkers = maxWorkers;
            this._createWorkerAsync = createWorkerAsync;
            this._options = options;
        }
        push(action) {
            if (!this._executeOnIdleWorker(action)) {
                if (this._workerInfos.length < this._maxWorkers) {
                    const workerInfo = {
                        workerPromise: this._createWorkerAsync(),
                        idle: false,
                    };
                    this._workerInfos.push(workerInfo);
                    this._execute(workerInfo, action);
                }
                else {
                    this._pendingActions.push(action);
                }
            }
        }
        _execute(workerInfo, action) {
            // Reset the idle timeout.
            if (workerInfo.timeoutId) {
                clearTimeout(workerInfo.timeoutId);
                delete workerInfo.timeoutId;
            }
            super._execute(workerInfo, (worker, onComplete) => {
                action(worker, () => {
                    onComplete();
                    if (workerInfo.idle) {
                        // Schedule the worker to be terminated after the elapsed time.
                        workerInfo.timeoutId = setTimeout(() => {
                            workerInfo.workerPromise.then((worker) => {
                                worker.terminate();
                            });
                            const indexOf = this._workerInfos.indexOf(workerInfo);
                            if (indexOf !== -1) {
                                this._workerInfos.splice(indexOf, 1);
                            }
                        }, this._options.idleTimeElapsedBeforeRelease);
                    }
                });
            });
        }
    }
    /**
     * Default options for the constructor.
     * Override to change the defaults.
     */
    AutoReleaseWorkerPool.DefaultOptions = {
        idleTimeElapsedBeforeRelease: 1000,
    };

    var SourceTextureFormat;
    (function (SourceTextureFormat) {
        SourceTextureFormat[SourceTextureFormat["ETC1S"] = 0] = "ETC1S";
        SourceTextureFormat[SourceTextureFormat["UASTC4x4"] = 1] = "UASTC4x4";
    })(SourceTextureFormat || (SourceTextureFormat = {}));
    var TranscodeTarget;
    (function (TranscodeTarget) {
        TranscodeTarget[TranscodeTarget["ASTC_4X4_RGBA"] = 0] = "ASTC_4X4_RGBA";
        TranscodeTarget[TranscodeTarget["BC7_RGBA"] = 1] = "BC7_RGBA";
        TranscodeTarget[TranscodeTarget["BC3_RGBA"] = 2] = "BC3_RGBA";
        TranscodeTarget[TranscodeTarget["BC1_RGB"] = 3] = "BC1_RGB";
        TranscodeTarget[TranscodeTarget["PVRTC1_4_RGBA"] = 4] = "PVRTC1_4_RGBA";
        TranscodeTarget[TranscodeTarget["PVRTC1_4_RGB"] = 5] = "PVRTC1_4_RGB";
        TranscodeTarget[TranscodeTarget["ETC2_RGBA"] = 6] = "ETC2_RGBA";
        TranscodeTarget[TranscodeTarget["ETC1_RGB"] = 7] = "ETC1_RGB";
        TranscodeTarget[TranscodeTarget["RGBA32"] = 8] = "RGBA32";
        TranscodeTarget[TranscodeTarget["R8"] = 9] = "R8";
        TranscodeTarget[TranscodeTarget["RG8"] = 10] = "RG8";
    })(TranscodeTarget || (TranscodeTarget = {}));
    var EngineFormat;
    (function (EngineFormat) {
        EngineFormat[EngineFormat["COMPRESSED_RGBA_BPTC_UNORM_EXT"] = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT";
        EngineFormat[EngineFormat["COMPRESSED_RGBA_ASTC_4X4_KHR"] = 37808] = "COMPRESSED_RGBA_ASTC_4X4_KHR";
        EngineFormat[EngineFormat["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
        EngineFormat[EngineFormat["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
        EngineFormat[EngineFormat["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
        EngineFormat[EngineFormat["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
        EngineFormat[EngineFormat["COMPRESSED_RGBA8_ETC2_EAC"] = 37496] = "COMPRESSED_RGBA8_ETC2_EAC";
        EngineFormat[EngineFormat["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
        EngineFormat[EngineFormat["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
        EngineFormat[EngineFormat["RGBA8Format"] = 32856] = "RGBA8Format";
        EngineFormat[EngineFormat["R8Format"] = 33321] = "R8Format";
        EngineFormat[EngineFormat["RG8Format"] = 33323] = "RG8Format";
    })(EngineFormat || (EngineFormat = {}));

    function getAbsoluteUrlOrNull(url) {
        return url ? Tools.GetAbsoluteUrl(url) : null;
    }
    function applyConfig(urls) {
        if (urls.wasmUASTCToASTC !== null) {
            KTX2DECODER.LiteTranscoder_UASTC_ASTC.WasmModuleURL = urls.wasmUASTCToASTC;
        }
        if (urls.wasmUASTCToBC7 !== null) {
            KTX2DECODER.LiteTranscoder_UASTC_BC7.WasmModuleURL = urls.wasmUASTCToBC7;
        }
        if (urls.wasmUASTCToRGBA_UNORM !== null) {
            KTX2DECODER.LiteTranscoder_UASTC_RGBA_UNORM.WasmModuleURL = urls.wasmUASTCToRGBA_UNORM;
        }
        if (urls.wasmUASTCToRGBA_SRGB !== null) {
            KTX2DECODER.LiteTranscoder_UASTC_RGBA_SRGB.WasmModuleURL = urls.wasmUASTCToRGBA_SRGB;
        }
        if (urls.wasmUASTCToR8_UNORM !== null) {
            KTX2DECODER.LiteTranscoder_UASTC_R8_UNORM.WasmModuleURL = urls.wasmUASTCToR8_UNORM;
        }
        if (urls.wasmUASTCToRG8_UNORM !== null) {
            KTX2DECODER.LiteTranscoder_UASTC_RG8_UNORM.WasmModuleURL = urls.wasmUASTCToRG8_UNORM;
        }
        if (urls.jsMSCTranscoder !== null) {
            KTX2DECODER.MSCTranscoder.JSModuleURL = urls.jsMSCTranscoder;
        }
        if (urls.wasmMSCTranscoder !== null) {
            KTX2DECODER.MSCTranscoder.WasmModuleURL = urls.wasmMSCTranscoder;
        }
        if (urls.wasmZSTDDecoder !== null) {
            KTX2DECODER.ZSTDDecoder.WasmModuleURL = urls.wasmZSTDDecoder;
        }
    }
    /**
     * Class that defines the default KTX2 decoder options.
     *
     * This class is useful for providing options to the KTX2 decoder to control how the source data is transcoded.
     */
    class DefaultKTX2DecoderOptions {
        constructor() {
            this._isDirty = true;
            this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC = true;
            this._ktx2DecoderOptions = {};
        }
        /**
         * Gets the dirty flag
         */
        get isDirty() {
            return this._isDirty;
        }
        /**
         * force a (uncompressed) RGBA transcoded format if transcoding a UASTC source format and ASTC + BC7 are not available as a compressed transcoded format
         */
        get useRGBAIfASTCBC7NotAvailableWhenUASTC() {
            return this._useRGBAIfASTCBC7NotAvailableWhenUASTC;
        }
        set useRGBAIfASTCBC7NotAvailableWhenUASTC(value) {
            if (this._useRGBAIfASTCBC7NotAvailableWhenUASTC === value) {
                return;
            }
            this._useRGBAIfASTCBC7NotAvailableWhenUASTC = value;
            this._isDirty = true;
        }
        /**
         * force a (uncompressed) RGBA transcoded format if transcoding a UASTC source format and only BC1 or BC3 are available as a compressed transcoded format.
         * This property is true by default to favor speed over memory, because currently transcoding from UASTC to BC1/3 is slow because the transcoder transcodes
         * to uncompressed and then recompresses the texture
         */
        get useRGBAIfOnlyBC1BC3AvailableWhenUASTC() {
            return this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC;
        }
        set useRGBAIfOnlyBC1BC3AvailableWhenUASTC(value) {
            if (this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC === value) {
                return;
            }
            this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC = value;
            this._isDirty = true;
        }
        /**
         * force to always use (uncompressed) RGBA for transcoded format
         */
        get forceRGBA() {
            return this._forceRGBA;
        }
        set forceRGBA(value) {
            if (this._forceRGBA === value) {
                return;
            }
            this._forceRGBA = value;
            this._isDirty = true;
        }
        /**
         * force to always use (uncompressed) R8 for transcoded format
         */
        get forceR8() {
            return this._forceR8;
        }
        set forceR8(value) {
            if (this._forceR8 === value) {
                return;
            }
            this._forceR8 = value;
            this._isDirty = true;
        }
        /**
         * force to always use (uncompressed) RG8 for transcoded format
         */
        get forceRG8() {
            return this._forceRG8;
        }
        set forceRG8(value) {
            if (this._forceRG8 === value) {
                return;
            }
            this._forceRG8 = value;
            this._isDirty = true;
        }
        /**
         * list of transcoders to bypass when looking for a suitable transcoder. The available transcoders are:
         *      UniversalTranscoder_UASTC_ASTC
         *      UniversalTranscoder_UASTC_BC7
         *      UniversalTranscoder_UASTC_RGBA_UNORM
         *      UniversalTranscoder_UASTC_RGBA_SRGB
         *      UniversalTranscoder_UASTC_R8_UNORM
         *      UniversalTranscoder_UASTC_RG8_UNORM
         *      MSCTranscoder
         */
        get bypassTranscoders() {
            return this._bypassTranscoders;
        }
        set bypassTranscoders(value) {
            if (this._bypassTranscoders === value) {
                return;
            }
            this._bypassTranscoders = value;
            this._isDirty = true;
        }
        /** @internal */
        _getKTX2DecoderOptions() {
            if (!this._isDirty) {
                return this._ktx2DecoderOptions;
            }
            this._isDirty = false;
            const options = {
                useRGBAIfASTCBC7NotAvailableWhenUASTC: this._useRGBAIfASTCBC7NotAvailableWhenUASTC,
                forceRGBA: this._forceRGBA,
                forceR8: this._forceR8,
                forceRG8: this._forceRG8,
                bypassTranscoders: this._bypassTranscoders,
            };
            if (this.useRGBAIfOnlyBC1BC3AvailableWhenUASTC) {
                options.transcodeFormatDecisionTree = {
                    UASTC: {
                        transcodeFormat: [TranscodeTarget.BC1_RGB, TranscodeTarget.BC3_RGBA],
                        yes: {
                            transcodeFormat: TranscodeTarget.RGBA32,
                            engineFormat: EngineFormat.RGBA8Format,
                            roundToMultiple4: false,
                        },
                    },
                };
            }
            this._ktx2DecoderOptions = options;
            return options;
        }
    }
    /**
     * Class for loading KTX2 files
     */
    class KhronosTextureContainer2 {
        static GetDefaultNumWorkers() {
            if (typeof navigator !== "object" || !navigator.hardwareConcurrency) {
                return 1;
            }
            // Use 50% of the available logical processors but capped at 4.
            return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 4);
        }
        static _Initialize(numWorkers) {
            if (KhronosTextureContainer2._WorkerPoolPromise || KhronosTextureContainer2._DecoderModulePromise) {
                return;
            }
            const urls = {
                jsDecoderModule: Tools.GetAbsoluteUrl(this.URLConfig.jsDecoderModule),
                wasmUASTCToASTC: getAbsoluteUrlOrNull(this.URLConfig.wasmUASTCToASTC),
                wasmUASTCToBC7: getAbsoluteUrlOrNull(this.URLConfig.wasmUASTCToBC7),
                wasmUASTCToRGBA_UNORM: getAbsoluteUrlOrNull(this.URLConfig.wasmUASTCToRGBA_UNORM),
                wasmUASTCToRGBA_SRGB: getAbsoluteUrlOrNull(this.URLConfig.wasmUASTCToRGBA_SRGB),
                wasmUASTCToR8_UNORM: getAbsoluteUrlOrNull(this.URLConfig.wasmUASTCToR8_UNORM),
                wasmUASTCToRG8_UNORM: getAbsoluteUrlOrNull(this.URLConfig.wasmUASTCToRG8_UNORM),
                jsMSCTranscoder: getAbsoluteUrlOrNull(this.URLConfig.jsMSCTranscoder),
                wasmMSCTranscoder: getAbsoluteUrlOrNull(this.URLConfig.wasmMSCTranscoder),
                wasmZSTDDecoder: getAbsoluteUrlOrNull(this.URLConfig.wasmZSTDDecoder),
            };
            if (numWorkers && typeof Worker === "function" && typeof URL !== "undefined") {
                KhronosTextureContainer2._WorkerPoolPromise = new Promise((resolve) => {
                    const workerContent = `${applyConfig}(${workerFunc})()`;
                    const workerBlobUrl = URL.createObjectURL(new Blob([workerContent], { type: "application/javascript" }));
                    resolve(new AutoReleaseWorkerPool(numWorkers, () => new Promise((resolve, reject) => {
                        const worker = new Worker(workerBlobUrl);
                        const onError = (error) => {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            reject(error);
                        };
                        const onMessage = (message) => {
                            if (message.data.action === "init") {
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                resolve(worker);
                            }
                        };
                        worker.addEventListener("error", onError);
                        worker.addEventListener("message", onMessage);
                        worker.postMessage({
                            action: "init",
                            urls: urls,
                        });
                    })));
                });
            }
            else if (typeof KTX2DECODER === "undefined") {
                KhronosTextureContainer2._DecoderModulePromise = Tools.LoadScriptAsync(urls.jsDecoderModule).then(() => {
                    KTX2DECODER.MSCTranscoder.UseFromWorkerThread = false;
                    KTX2DECODER.WASMMemoryManager.LoadBinariesFromCurrentThread = true;
                    applyConfig(urls);
                    return new KTX2DECODER.KTX2Decoder();
                });
            }
            else {
                KTX2DECODER.MSCTranscoder.UseFromWorkerThread = false;
                KTX2DECODER.WASMMemoryManager.LoadBinariesFromCurrentThread = true;
                KhronosTextureContainer2._DecoderModulePromise = Promise.resolve(new KTX2DECODER.KTX2Decoder());
            }
        }
        /**
         * Constructor
         * @param engine The engine to use
         * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
         */
        constructor(engine, numWorkers = KhronosTextureContainer2.DefaultNumWorkers) {
            this._engine = engine;
            KhronosTextureContainer2._Initialize(numWorkers);
        }
        /**
         * @internal
         */
        uploadAsync(data, internalTexture, options) {
            const caps = this._engine.getCaps();
            const compressedTexturesCaps = {
                astc: !!caps.astc,
                bptc: !!caps.bptc,
                s3tc: !!caps.s3tc,
                pvrtc: !!caps.pvrtc,
                etc2: !!caps.etc2,
                etc1: !!caps.etc1,
            };
            if (KhronosTextureContainer2._WorkerPoolPromise) {
                return KhronosTextureContainer2._WorkerPoolPromise.then((workerPool) => {
                    return new Promise((resolve, reject) => {
                        workerPool.push((worker, onComplete) => {
                            const onError = (error) => {
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                reject(error);
                                onComplete();
                            };
                            const onMessage = (message) => {
                                if (message.data.action === "decoded") {
                                    worker.removeEventListener("error", onError);
                                    worker.removeEventListener("message", onMessage);
                                    if (!message.data.success) {
                                        reject({ message: message.data.msg });
                                    }
                                    else {
                                        try {
                                            this._createTexture(message.data.decodedData, internalTexture, options);
                                            resolve();
                                        }
                                        catch (err) {
                                            reject({ message: err });
                                        }
                                    }
                                    onComplete();
                                }
                            };
                            worker.addEventListener("error", onError);
                            worker.addEventListener("message", onMessage);
                            worker.postMessage({ action: "setDefaultDecoderOptions", options: KhronosTextureContainer2.DefaultDecoderOptions._getKTX2DecoderOptions() });
                            const dataCopy = new Uint8Array(data.byteLength);
                            dataCopy.set(new Uint8Array(data.buffer, data.byteOffset, data.byteLength));
                            worker.postMessage({ action: "decode", data: dataCopy, caps: compressedTexturesCaps, options }, [dataCopy.buffer]);
                        });
                    });
                });
            }
            else if (KhronosTextureContainer2._DecoderModulePromise) {
                return KhronosTextureContainer2._DecoderModulePromise.then((decoder) => {
                    if (KhronosTextureContainer2.DefaultDecoderOptions.isDirty) {
                        KTX2DECODER.KTX2Decoder.DefaultDecoderOptions = KhronosTextureContainer2.DefaultDecoderOptions._getKTX2DecoderOptions();
                    }
                    return new Promise((resolve, reject) => {
                        decoder
                            .decode(data, caps)
                            .then((data) => {
                            this._createTexture(data, internalTexture);
                            resolve();
                        })
                            .catch((reason) => {
                            reject({ message: reason });
                        });
                    });
                });
            }
            throw new Error("KTX2 decoder module is not available");
        }
        _createTexture(data, internalTexture, options) {
            const oglTexture2D = 3553; // gl.TEXTURE_2D
            this._engine._bindTextureDirectly(oglTexture2D, internalTexture);
            if (options) {
                // return back some information about the decoded data
                options.transcodedFormat = data.transcodedFormat;
                options.isInGammaSpace = data.isInGammaSpace;
                options.hasAlpha = data.hasAlpha;
                options.transcoderName = data.transcoderName;
            }
            let isUncompressedFormat = true;
            switch (data.transcodedFormat) {
                case 0x8058 /* RGBA8 */:
                    internalTexture.type = 0;
                    internalTexture.format = 5;
                    break;
                case 0x8229 /* R8 */:
                    internalTexture.type = 0;
                    internalTexture.format = 6;
                    break;
                case 0x822b /* RG8 */:
                    internalTexture.type = 0;
                    internalTexture.format = 7;
                    break;
                default:
                    internalTexture.format = data.transcodedFormat;
                    isUncompressedFormat = false;
                    break;
            }
            internalTexture._gammaSpace = data.isInGammaSpace;
            internalTexture.generateMipMaps = data.mipmaps.length > 1;
            if (data.errors) {
                throw new Error("KTX2 container - could not transcode the data. " + data.errors);
            }
            for (let t = 0; t < data.mipmaps.length; ++t) {
                const mipmap = data.mipmaps[t];
                if (!mipmap || !mipmap.data) {
                    throw new Error("KTX2 container - could not transcode one of the image");
                }
                if (isUncompressedFormat) {
                    // uncompressed RGBA / R8 / RG8
                    internalTexture.width = mipmap.width; // need to set width/height so that the call to _uploadDataToTextureDirectly uses the right dimensions
                    internalTexture.height = mipmap.height;
                    this._engine._uploadDataToTextureDirectly(internalTexture, mipmap.data, 0, t, undefined, true);
                }
                else {
                    this._engine._uploadCompressedDataToTextureDirectly(internalTexture, data.transcodedFormat, mipmap.width, mipmap.height, mipmap.data, 0, t);
                }
            }
            internalTexture._extension = ".ktx2";
            internalTexture.width = data.mipmaps[0].width;
            internalTexture.height = data.mipmaps[0].height;
            internalTexture.isReady = true;
            this._engine._bindTextureDirectly(oglTexture2D, null);
        }
        /**
         * Checks if the given data starts with a KTX2 file identifier.
         * @param data the data to check
         * @returns true if the data is a KTX2 file or false otherwise
         */
        static IsValid(data) {
            if (data.byteLength >= 12) {
                // '«', 'K', 'T', 'X', ' ', '2', '0', '»', '\r', '\n', '\x1A', '\n'
                const identifier = new Uint8Array(data.buffer, data.byteOffset, 12);
                if (identifier[0] === 0xab &&
                    identifier[1] === 0x4b &&
                    identifier[2] === 0x54 &&
                    identifier[3] === 0x58 &&
                    identifier[4] === 0x20 &&
                    identifier[5] === 0x32 &&
                    identifier[6] === 0x30 &&
                    identifier[7] === 0xbb &&
                    identifier[8] === 0x0d &&
                    identifier[9] === 0x0a &&
                    identifier[10] === 0x1a &&
                    identifier[11] === 0x0a) {
                    return true;
                }
            }
            return false;
        }
    }
    /**
     * URLs to use when loading the KTX2 decoder module as well as its dependencies
     * If a url is null, the default url is used (pointing to https://preview.babylonjs.com)
     * Note that jsDecoderModule can't be null and that the other dependencies will only be loaded if necessary
     * Urls you can change:
     *     URLConfig.jsDecoderModule
     *     URLConfig.wasmUASTCToASTC
     *     URLConfig.wasmUASTCToBC7
     *     URLConfig.wasmUASTCToRGBA_UNORM
     *     URLConfig.wasmUASTCToRGBA_SRGB
     *     URLConfig.wasmUASTCToR8_UNORM
     *     URLConfig.wasmUASTCToRG8_UNORM
     *     URLConfig.jsMSCTranscoder
     *     URLConfig.wasmMSCTranscoder
     *     URLConfig.wasmZSTDDecoder
     * You can see their default values in this PG: https://playground.babylonjs.com/#EIJH8L#29
     */
    KhronosTextureContainer2.URLConfig = {
        jsDecoderModule: "https://preview.babylonjs.com/babylon.ktx2Decoder.js",
        wasmUASTCToASTC: null,
        wasmUASTCToBC7: null,
        wasmUASTCToRGBA_UNORM: null,
        wasmUASTCToRGBA_SRGB: null,
        wasmUASTCToR8_UNORM: null,
        wasmUASTCToRG8_UNORM: null,
        jsMSCTranscoder: null,
        wasmMSCTranscoder: null,
        wasmZSTDDecoder: null,
    };
    /**
     * Default number of workers used to handle data decoding
     */
    KhronosTextureContainer2.DefaultNumWorkers = KhronosTextureContainer2.GetDefaultNumWorkers();
    /**
     * Default configuration for the KTX2 decoder.
     * The options defined in this way have priority over those passed when creating a KTX2 texture with new Texture(...).
     */
    KhronosTextureContainer2.DefaultDecoderOptions = new DefaultKTX2DecoderOptions();
    function workerFunc() {
        let ktx2Decoder;
        onmessage = (event) => {
            if (!event.data) {
                return;
            }
            switch (event.data.action) {
                case "init": {
                    const urls = event.data.urls;
                    importScripts(urls.jsDecoderModule);
                    applyConfig(urls);
                    ktx2Decoder = new KTX2DECODER.KTX2Decoder();
                    postMessage({ action: "init" });
                    break;
                }
                case "setDefaultDecoderOptions": {
                    KTX2DECODER.KTX2Decoder.DefaultDecoderOptions = event.data.options;
                    break;
                }
                case "decode":
                    ktx2Decoder
                        .decode(event.data.data, event.data.caps, event.data.options)
                        .then((data) => {
                        const buffers = [];
                        for (let mip = 0; mip < data.mipmaps.length; ++mip) {
                            const mipmap = data.mipmaps[mip];
                            if (mipmap && mipmap.data) {
                                buffers.push(mipmap.data.buffer);
                            }
                        }
                        postMessage({ action: "decoded", success: true, decodedData: data }, buffers);
                    })
                        .catch((reason) => {
                        postMessage({ action: "decoded", success: false, msg: reason });
                    });
                    break;
            }
        };
    }

    function mapSRGBToLinear(format) {
        switch (format) {
            case 35916:
                return 33776;
            case 35918:
                return 33778;
            case 35919:
                return 33779;
            case 37493:
                return 37492;
            case 37497:
                return 37496;
            case 37495:
                return 37494;
            case 37840:
                return 37808;
            case 36493:
                return 36492;
        }
        return null;
    }
    /**
     * Implementation of the KTX Texture Loader.
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _KTXTextureLoader {
        constructor() {
            /**
             * Defines whether the loader supports cascade loading the different faces.
             */
            this.supportCascades = false;
        }
        /**
         * This returns if the loader support the current file information.
         * @param extension defines the file extension of the file being loaded
         * @param mimeType defines the optional mime type of the file being loaded
         * @returns true if the loader can load the specified file
         */
        canLoad(extension, mimeType) {
            // The ".ktx2" file extension is still up for debate: https://github.com/KhronosGroup/KTX-Specification/issues/18
            return extension.endsWith(".ktx") || extension.endsWith(".ktx2") || mimeType === "image/ktx" || mimeType === "image/ktx2";
        }
        /**
         * Uploads the cube texture data to the WebGL texture. It has already been bound.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param createPolynomials will be true if polynomials have been requested
         * @param onLoad defines the callback to trigger once the texture is ready
         */
        loadCubeData(data, texture, createPolynomials, onLoad) {
            if (Array.isArray(data)) {
                return;
            }
            // Need to invert vScale as invertY via UNPACK_FLIP_Y_WEBGL is not supported by compressed texture
            texture._invertVScale = !texture.invertY;
            const engine = texture.getEngine();
            const ktx = new KhronosTextureContainer(data, 6);
            const loadMipmap = ktx.numberOfMipmapLevels > 1 && texture.generateMipMaps;
            engine._unpackFlipY(true);
            ktx.uploadLevels(texture, texture.generateMipMaps);
            texture.width = ktx.pixelWidth;
            texture.height = ktx.pixelHeight;
            engine._setCubeMapTextureParams(texture, loadMipmap, ktx.numberOfMipmapLevels - 1);
            texture.isReady = true;
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
            if (onLoad) {
                onLoad();
            }
        }
        /**
         * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param callback defines the method to call once ready to upload
         * @param options
         */
        loadData(data, texture, callback, options) {
            if (KhronosTextureContainer.IsValid(data)) {
                // Need to invert vScale as invertY via UNPACK_FLIP_Y_WEBGL is not supported by compressed texture
                texture._invertVScale = !texture.invertY;
                const ktx = new KhronosTextureContainer(data, 1);
                const mappedFormat = mapSRGBToLinear(ktx.glInternalFormat);
                if (mappedFormat) {
                    texture.format = mappedFormat;
                    texture._useSRGBBuffer = texture.getEngine()._getUseSRGBBuffer(true, texture.generateMipMaps);
                    texture._gammaSpace = true;
                }
                else {
                    texture.format = ktx.glInternalFormat;
                }
                callback(ktx.pixelWidth, ktx.pixelHeight, texture.generateMipMaps, true, () => {
                    ktx.uploadLevels(texture, texture.generateMipMaps);
                }, ktx.isInvalid);
            }
            else if (KhronosTextureContainer2.IsValid(data)) {
                const ktx2 = new KhronosTextureContainer2(texture.getEngine());
                ktx2.uploadAsync(data, texture, options).then(() => {
                    callback(texture.width, texture.height, texture.generateMipMaps, true, () => { }, false);
                }, (error) => {
                    Logger.Warn(`Failed to load KTX2 texture data: ${error.message}`);
                    callback(0, 0, false, false, () => { }, true);
                });
            }
            else {
                Logger.Error("texture missing KTX identifier");
                callback(0, 0, false, false, () => { }, true);
            }
        }
    }
    // Register the loader.
    Engine._TextureLoaders.unshift(new _KTXTextureLoader());

    /**
     * WebXR Camera which holds the views for the xrSession
     * @see https://doc.babylonjs.com/features/featuresDeepDive/webXR/webXRCamera
     */
    class WebXRCamera extends FreeCamera {
        /**
         * Creates a new webXRCamera, this should only be set at the camera after it has been updated by the xrSessionManager
         * @param name the name of the camera
         * @param scene the scene to add the camera to
         * @param _xrSessionManager a constructed xr session manager
         */
        constructor(name, scene, _xrSessionManager) {
            super(name, Vector3.Zero(), scene);
            this._xrSessionManager = _xrSessionManager;
            this._firstFrame = false;
            this._referenceQuaternion = Quaternion.Identity();
            this._referencedPosition = new Vector3();
            this._trackingState = WebXRTrackingState.NOT_TRACKING;
            /**
             * Observable raised before camera teleportation
             */
            this.onBeforeCameraTeleport = new Observable$1();
            /**
             *  Observable raised after camera teleportation
             */
            this.onAfterCameraTeleport = new Observable$1();
            /**
             * Notifies when the camera's tracking state has changed.
             * Notice - will also be triggered when tracking has started (at the beginning of the session)
             */
            this.onTrackingStateChanged = new Observable$1();
            /**
             * Should position compensation execute on first frame.
             * This is used when copying the position from a native (non XR) camera
             */
            this.compensateOnFirstFrame = true;
            this._rotate180 = new Quaternion(0, 1, 0, 0);
            // Initial camera configuration
            this.minZ = 0.1;
            this.rotationQuaternion = new Quaternion();
            this.cameraRigMode = Camera.RIG_MODE_CUSTOM;
            this.updateUpVectorFromRotation = true;
            this._updateNumberOfRigCameras(1);
            // freeze projection matrix, which will be copied later
            this.freezeProjectionMatrix();
            this._deferOnly = true;
            this._xrSessionManager.onXRSessionInit.add(() => {
                this._referencedPosition.copyFromFloats(0, 0, 0);
                this._referenceQuaternion.copyFromFloats(0, 0, 0, 1);
                // first frame - camera's y position should be 0 for the correct offset
                this._firstFrame = this.compensateOnFirstFrame;
            });
            // Check transformation changes on each frame. Callback is added to be first so that the transformation will be
            // applied to the rest of the elements using the referenceSpace object
            this._xrSessionManager.onXRFrameObservable.add(() => {
                if (this._firstFrame) {
                    this._updateFromXRSession();
                }
                if (this._deferredUpdated) {
                    this.position.copyFrom(this._deferredPositionUpdate);
                    this.rotationQuaternion.copyFrom(this._deferredRotationQuaternionUpdate);
                }
                this._updateReferenceSpace();
                this._updateFromXRSession();
            }, undefined, true);
        }
        /**
         * Get the current XR tracking state of the camera
         */
        get trackingState() {
            return this._trackingState;
        }
        _setTrackingState(newState) {
            if (this._trackingState !== newState) {
                this._trackingState = newState;
                this.onTrackingStateChanged.notifyObservers(newState);
            }
        }
        /**
         * Return the user's height, unrelated to the current ground.
         * This will be the y position of this camera, when ground level is 0.
         */
        get realWorldHeight() {
            const basePose = this._xrSessionManager.currentFrame && this._xrSessionManager.currentFrame.getViewerPose(this._xrSessionManager.baseReferenceSpace);
            if (basePose && basePose.transform) {
                return basePose.transform.position.y;
            }
            else {
                return 0;
            }
        }
        /** @internal */
        _updateForDualEyeDebugging( /*pupilDistance = 0.01*/) {
            // Create initial camera rigs
            this._updateNumberOfRigCameras(2);
            this.rigCameras[0].viewport = new Viewport(0, 0, 0.5, 1.0);
            // this.rigCameras[0].position.x = -pupilDistance / 2;
            this.rigCameras[0].outputRenderTarget = null;
            this.rigCameras[1].viewport = new Viewport(0.5, 0, 0.5, 1.0);
            // this.rigCameras[1].position.x = pupilDistance / 2;
            this.rigCameras[1].outputRenderTarget = null;
        }
        /**
         * Sets this camera's transformation based on a non-vr camera
         * @param otherCamera the non-vr camera to copy the transformation from
         * @param resetToBaseReferenceSpace should XR reset to the base reference space
         */
        setTransformationFromNonVRCamera(otherCamera = this.getScene().activeCamera, resetToBaseReferenceSpace = true) {
            if (!otherCamera || otherCamera === this) {
                return;
            }
            const mat = otherCamera.computeWorldMatrix();
            mat.decompose(undefined, this.rotationQuaternion, this.position);
            // set the ground level
            this.position.y = 0;
            Quaternion.FromEulerAnglesToRef(0, this.rotationQuaternion.toEulerAngles().y, 0, this.rotationQuaternion);
            this._firstFrame = true;
            if (resetToBaseReferenceSpace) {
                this._xrSessionManager.resetReferenceSpace();
            }
        }
        /**
         * Gets the current instance class name ("WebXRCamera").
         * @returns the class name
         */
        getClassName() {
            return "WebXRCamera";
        }
        /**
         * Set the target for the camera to look at.
         * Note that this only rotates around the Y axis, as opposed to the default behavior of other cameras
         * @param target the target to set the camera to look at
         */
        setTarget(target) {
            // only rotate around the y axis!
            const tmpVector = TmpVectors.Vector3[1];
            target.subtractToRef(this.position, tmpVector);
            tmpVector.y = 0;
            tmpVector.normalize();
            const yRotation = Math.atan2(tmpVector.x, tmpVector.z);
            this.rotationQuaternion.toEulerAnglesToRef(tmpVector);
            Quaternion.FromEulerAnglesToRef(tmpVector.x, yRotation, tmpVector.z, this.rotationQuaternion);
        }
        dispose() {
            super.dispose();
            this._lastXRViewerPose = undefined;
        }
        _updateFromXRSession() {
            const pose = this._xrSessionManager.currentFrame && this._xrSessionManager.currentFrame.getViewerPose(this._xrSessionManager.referenceSpace);
            this._lastXRViewerPose = pose || undefined;
            if (!pose) {
                this._setTrackingState(WebXRTrackingState.NOT_TRACKING);
                return;
            }
            // Set the tracking state. if it didn't change it is a no-op
            const trackingState = pose.emulatedPosition ? WebXRTrackingState.TRACKING_LOST : WebXRTrackingState.TRACKING;
            this._setTrackingState(trackingState);
            // check min/max Z and update if not the same as in cache
            if (this.minZ !== this._cache.minZ || this.maxZ !== this._cache.maxZ) {
                const xrRenderState = {
                    // if maxZ is 0 it should be "Infinity", but it doesn't work with the WebXR API. Setting to a large number.
                    depthFar: this.maxZ || 10000,
                    depthNear: this.minZ,
                };
                this._xrSessionManager.updateRenderState(xrRenderState);
                this._cache.minZ = this.minZ;
                this._cache.maxZ = this.maxZ;
            }
            if (pose.transform) {
                const orientation = pose.transform.orientation;
                if (pose.transform.orientation.x === undefined) {
                    // Babylon native polyfill can return an undefined orientation value
                    // When not initialized
                    return;
                }
                const pos = pose.transform.position;
                this._referencedPosition.set(pos.x, pos.y, pos.z);
                this._referenceQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
                if (!this._scene.useRightHandedSystem) {
                    this._referencedPosition.z *= -1;
                    this._referenceQuaternion.z *= -1;
                    this._referenceQuaternion.w *= -1;
                }
                if (this._firstFrame) {
                    this._firstFrame = false;
                    // we have the XR reference, now use this to find the offset to get the camera to be
                    // in the right position
                    // set the height to correlate to the current height
                    this.position.y += this._referencedPosition.y;
                    // avoid using the head rotation on the first frame.
                    this._referenceQuaternion.copyFromFloats(0, 0, 0, 1);
                }
                else {
                    // update position and rotation as reference
                    this.rotationQuaternion.copyFrom(this._referenceQuaternion);
                    this.position.copyFrom(this._referencedPosition);
                }
            }
            // Update camera rigs
            if (this.rigCameras.length !== pose.views.length) {
                this._updateNumberOfRigCameras(pose.views.length);
            }
            pose.views.forEach((view, i) => {
                var _a;
                const currentRig = this.rigCameras[i];
                // update right and left, where applicable
                if (!currentRig.isLeftCamera && !currentRig.isRightCamera) {
                    if (view.eye === "right") {
                        currentRig._isRightCamera = true;
                    }
                    else if (view.eye === "left") {
                        currentRig._isLeftCamera = true;
                    }
                }
                // Update view/projection matrix
                const pos = view.transform.position;
                const orientation = view.transform.orientation;
                currentRig.parent = this.parent;
                currentRig.position.set(pos.x, pos.y, pos.z);
                currentRig.rotationQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
                if (!this._scene.useRightHandedSystem) {
                    currentRig.position.z *= -1;
                    currentRig.rotationQuaternion.z *= -1;
                    currentRig.rotationQuaternion.w *= -1;
                }
                else {
                    currentRig.rotationQuaternion.multiplyInPlace(this._rotate180);
                }
                Matrix.FromFloat32ArrayToRefScaled(view.projectionMatrix, 0, 1, currentRig._projectionMatrix);
                if (!this._scene.useRightHandedSystem) {
                    currentRig._projectionMatrix.toggleProjectionMatrixHandInPlace();
                }
                // first camera?
                if (i === 0) {
                    this._projectionMatrix.copyFrom(currentRig._projectionMatrix);
                }
                const renderTargetTexture = this._xrSessionManager.getRenderTargetTextureForView(view);
                this._renderingMultiview = ((_a = renderTargetTexture === null || renderTargetTexture === void 0 ? void 0 : renderTargetTexture._texture) === null || _a === void 0 ? void 0 : _a.isMultiview) || false;
                if (this._renderingMultiview) {
                    // For multiview, the render target texture is the same per-view (just the slice index is different),
                    // so we only need to set the output render target once for the rig parent.
                    if (i == 0) {
                        this._xrSessionManager.trySetViewportForView(this.viewport, view);
                        this.outputRenderTarget = renderTargetTexture;
                    }
                }
                else {
                    // Update viewport
                    this._xrSessionManager.trySetViewportForView(currentRig.viewport, view);
                    // Set cameras to render to the session's render target
                    currentRig.outputRenderTarget = renderTargetTexture || this._xrSessionManager.getRenderTargetTextureForView(view);
                }
                // Replicate parent rig camera behavior
                currentRig.layerMask = this.layerMask;
            });
        }
        _updateNumberOfRigCameras(viewCount = 1) {
            while (this.rigCameras.length < viewCount) {
                const newCamera = new TargetCamera("XR-RigCamera: " + this.rigCameras.length, Vector3.Zero(), this.getScene());
                newCamera.minZ = 0.1;
                newCamera.rotationQuaternion = new Quaternion();
                newCamera.updateUpVectorFromRotation = true;
                newCamera.isRigCamera = true;
                newCamera.rigParent = this;
                // do not compute projection matrix, provided by XR
                newCamera.freezeProjectionMatrix();
                this.rigCameras.push(newCamera);
            }
            while (this.rigCameras.length > viewCount) {
                const removedCamera = this.rigCameras.pop();
                if (removedCamera) {
                    removedCamera.dispose();
                }
            }
        }
        _updateReferenceSpace() {
            // were position & rotation updated OUTSIDE of the xr update loop
            if (!this.position.equals(this._referencedPosition) || !this.rotationQuaternion.equals(this._referenceQuaternion)) {
                const referencedMat = TmpVectors.Matrix[0];
                const poseMat = TmpVectors.Matrix[1];
                const transformMat = TmpVectors.Matrix[2];
                Matrix.ComposeToRef(WebXRCamera._ScaleReadOnly, this._referenceQuaternion, this._referencedPosition, referencedMat);
                Matrix.ComposeToRef(WebXRCamera._ScaleReadOnly, this.rotationQuaternion, this.position, poseMat);
                referencedMat.invert().multiplyToRef(poseMat, transformMat);
                transformMat.invert();
                if (!this._scene.useRightHandedSystem) {
                    transformMat.toggleModelMatrixHandInPlace();
                }
                transformMat.decompose(undefined, this._referenceQuaternion, this._referencedPosition);
                const transform = new XRRigidTransform({
                    x: this._referencedPosition.x,
                    y: this._referencedPosition.y,
                    z: this._referencedPosition.z,
                }, {
                    x: this._referenceQuaternion.x,
                    y: this._referenceQuaternion.y,
                    z: this._referenceQuaternion.z,
                    w: this._referenceQuaternion.w,
                });
                this._xrSessionManager.referenceSpace = this._xrSessionManager.referenceSpace.getOffsetReferenceSpace(transform);
            }
        }
    }
    WebXRCamera._ScaleReadOnly = Vector3.One();

    /**
     * A list of the currently available features without referencing them
     */
    class WebXRFeatureName {
    }
    /**
     * The name of the anchor system feature
     */
    WebXRFeatureName.ANCHOR_SYSTEM = "xr-anchor-system";
    /**
     * The name of the background remover feature
     */
    WebXRFeatureName.BACKGROUND_REMOVER = "xr-background-remover";
    /**
     * The name of the hit test feature
     */
    WebXRFeatureName.HIT_TEST = "xr-hit-test";
    /**
     * The name of the mesh detection feature
     */
    WebXRFeatureName.MESH_DETECTION = "xr-mesh-detection";
    /**
     * physics impostors for xr controllers feature
     */
    WebXRFeatureName.PHYSICS_CONTROLLERS = "xr-physics-controller";
    /**
     * The name of the plane detection feature
     */
    WebXRFeatureName.PLANE_DETECTION = "xr-plane-detection";
    /**
     * The name of the pointer selection feature
     */
    WebXRFeatureName.POINTER_SELECTION = "xr-controller-pointer-selection";
    /**
     * The name of the teleportation feature
     */
    WebXRFeatureName.TELEPORTATION = "xr-controller-teleportation";
    /**
     * The name of the feature points feature.
     */
    WebXRFeatureName.FEATURE_POINTS = "xr-feature-points";
    /**
     * The name of the hand tracking feature.
     */
    WebXRFeatureName.HAND_TRACKING = "xr-hand-tracking";
    /**
     * The name of the image tracking feature
     */
    WebXRFeatureName.IMAGE_TRACKING = "xr-image-tracking";
    /**
     * The name of the near interaction feature
     */
    WebXRFeatureName.NEAR_INTERACTION = "xr-near-interaction";
    /**
     * The name of the DOM overlay feature
     */
    WebXRFeatureName.DOM_OVERLAY = "xr-dom-overlay";
    /**
     * The name of the movement feature
     */
    WebXRFeatureName.MOVEMENT = "xr-controller-movement";
    /**
     * The name of the light estimation feature
     */
    WebXRFeatureName.LIGHT_ESTIMATION = "xr-light-estimation";
    /**
     * The name of the eye tracking feature
     */
    WebXRFeatureName.EYE_TRACKING = "xr-eye-tracking";
    /**
     * The name of the walking locomotion feature
     */
    WebXRFeatureName.WALKING_LOCOMOTION = "xr-walking-locomotion";
    /**
     * The name of the composition layers feature
     */
    WebXRFeatureName.LAYERS = "xr-layers";
    /**
     * The name of the depth sensing feature
     */
    WebXRFeatureName.DEPTH_SENSING = "xr-depth-sensing";
    /**
     * The name of the WebXR Space Warp feature
     */
    WebXRFeatureName.SPACE_WARP = "xr-space-warp";
    /**
     * The WebXR features manager is responsible of enabling or disabling features required for the current XR session.
     * It is mainly used in AR sessions.
     *
     * A feature can have a version that is defined by Babylon (and does not correspond with the webxr version).
     */
    class WebXRFeaturesManager {
        /**
         * constructs a new features manages.
         *
         * @param _xrSessionManager an instance of WebXRSessionManager
         */
        constructor(_xrSessionManager) {
            this._xrSessionManager = _xrSessionManager;
            this._features = {};
            // when session starts / initialized - attach
            this._xrSessionManager.onXRSessionInit.add(() => {
                this.getEnabledFeatures().forEach((featureName) => {
                    const feature = this._features[featureName];
                    if (feature.enabled && !feature.featureImplementation.attached && !feature.featureImplementation.disableAutoAttach) {
                        this.attachFeature(featureName);
                    }
                });
            });
            // when session ends - detach
            this._xrSessionManager.onXRSessionEnded.add(() => {
                this.getEnabledFeatures().forEach((featureName) => {
                    const feature = this._features[featureName];
                    if (feature.enabled && feature.featureImplementation.attached) {
                        // detach, but don't disable!
                        this.detachFeature(featureName);
                    }
                });
            });
        }
        /**
         * Used to register a module. After calling this function a developer can use this feature in the scene.
         * Mainly used internally.
         *
         * @param featureName the name of the feature to register
         * @param constructorFunction the function used to construct the module
         * @param version the (babylon) version of the module
         * @param stable is that a stable version of this module
         */
        static AddWebXRFeature(featureName, constructorFunction, version = 1, stable = false) {
            this._AvailableFeatures[featureName] = this._AvailableFeatures[featureName] || { latest: version };
            if (version > this._AvailableFeatures[featureName].latest) {
                this._AvailableFeatures[featureName].latest = version;
            }
            if (stable) {
                this._AvailableFeatures[featureName].stable = version;
            }
            this._AvailableFeatures[featureName][version] = constructorFunction;
        }
        /**
         * Returns a constructor of a specific feature.
         *
         * @param featureName the name of the feature to construct
         * @param version the version of the feature to load
         * @param xrSessionManager the xrSessionManager. Used to construct the module
         * @param options optional options provided to the module.
         * @returns a function that, when called, will return a new instance of this feature
         */
        static ConstructFeature(featureName, version = 1, xrSessionManager, options) {
            const constructorFunction = this._AvailableFeatures[featureName][version];
            if (!constructorFunction) {
                // throw an error? return nothing?
                throw new Error("feature not found");
            }
            return constructorFunction(xrSessionManager, options);
        }
        /**
         * Can be used to return the list of features currently registered
         *
         * @returns an Array of available features
         */
        static GetAvailableFeatures() {
            return Object.keys(this._AvailableFeatures);
        }
        /**
         * Gets the versions available for a specific feature
         * @param featureName the name of the feature
         * @returns an array with the available versions
         */
        static GetAvailableVersions(featureName) {
            return Object.keys(this._AvailableFeatures[featureName]);
        }
        /**
         * Return the latest unstable version of this feature
         * @param featureName the name of the feature to search
         * @returns the version number. if not found will return -1
         */
        static GetLatestVersionOfFeature(featureName) {
            return (this._AvailableFeatures[featureName] && this._AvailableFeatures[featureName].latest) || -1;
        }
        /**
         * Return the latest stable version of this feature
         * @param featureName the name of the feature to search
         * @returns the version number. if not found will return -1
         */
        static GetStableVersionOfFeature(featureName) {
            return (this._AvailableFeatures[featureName] && this._AvailableFeatures[featureName].stable) || -1;
        }
        /**
         * Attach a feature to the current session. Mainly used when session started to start the feature effect.
         * Can be used during a session to start a feature
         * @param featureName the name of feature to attach
         */
        attachFeature(featureName) {
            const feature = this._features[featureName];
            if (feature && feature.enabled && !feature.featureImplementation.attached) {
                feature.featureImplementation.attach();
            }
        }
        /**
         * Can be used inside a session or when the session ends to detach a specific feature
         * @param featureName the name of the feature to detach
         */
        detachFeature(featureName) {
            const feature = this._features[featureName];
            if (feature && feature.featureImplementation.attached) {
                feature.featureImplementation.detach();
            }
        }
        /**
         * Used to disable an already-enabled feature
         * The feature will be disposed and will be recreated once enabled.
         * @param featureName the feature to disable
         * @returns true if disable was successful
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        disableFeature(featureName) {
            const name = typeof featureName === "string" ? featureName : featureName.Name;
            const feature = this._features[name];
            if (feature && feature.enabled) {
                feature.enabled = false;
                this.detachFeature(name);
                feature.featureImplementation.dispose();
                delete this._features[name];
                return true;
            }
            return false;
        }
        /**
         * dispose this features manager
         */
        dispose() {
            this.getEnabledFeatures().forEach((feature) => {
                this.disableFeature(feature);
            });
        }
        /**
         * Enable a feature using its name and a version. This will enable it in the scene, and will be responsible to attach it when the session starts.
         * If used twice, the old version will be disposed and a new one will be constructed. This way you can re-enable with different configuration.
         *
         * @param featureName the name of the feature to load or the class of the feature
         * @param version optional version to load. if not provided the latest version will be enabled
         * @param moduleOptions options provided to the module. Ses the module documentation / constructor
         * @param attachIfPossible if set to true (default) the feature will be automatically attached, if it is currently possible
         * @param required is this feature required to the app. If set to true the session init will fail if the feature is not available.
         * @returns a new constructed feature or throws an error if feature not found or conflicts with another enabled feature.
         */
        enableFeature(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        featureName, version = "latest", moduleOptions = {}, attachIfPossible = true, required = true) {
            const name = typeof featureName === "string" ? featureName : featureName.Name;
            let versionToLoad = 0;
            if (typeof version === "string") {
                if (!version) {
                    throw new Error(`Error in provided version - ${name} (${version})`);
                }
                if (version === "stable") {
                    versionToLoad = WebXRFeaturesManager.GetStableVersionOfFeature(name);
                }
                else if (version === "latest") {
                    versionToLoad = WebXRFeaturesManager.GetLatestVersionOfFeature(name);
                }
                else {
                    // try loading the number the string represents
                    versionToLoad = +version;
                }
                if (versionToLoad === -1 || isNaN(versionToLoad)) {
                    throw new Error(`feature not found - ${name} (${version})`);
                }
            }
            else {
                versionToLoad = version;
            }
            // check if there is a feature conflict
            const conflictingFeature = WebXRFeaturesManager._ConflictingFeatures[name];
            if (conflictingFeature !== undefined && this.getEnabledFeatures().indexOf(conflictingFeature) !== -1) {
                throw new Error(`Feature ${name} cannot be enabled while ${conflictingFeature} is enabled.`);
            }
            // check if already initialized
            const feature = this._features[name];
            const constructFunction = WebXRFeaturesManager.ConstructFeature(name, versionToLoad, this._xrSessionManager, moduleOptions);
            if (!constructFunction) {
                // report error?
                throw new Error(`feature not found - ${name}`);
            }
            /* If the feature is already enabled, detach and dispose it, and create a new one */
            if (feature) {
                this.disableFeature(name);
            }
            const constructed = constructFunction();
            if (constructed.dependsOn) {
                const dependentsFound = constructed.dependsOn.every((featureName) => !!this._features[featureName]);
                if (!dependentsFound) {
                    throw new Error(`Dependant features missing. Make sure the following features are enabled - ${constructed.dependsOn.join(", ")}`);
                }
            }
            if (constructed.isCompatible()) {
                this._features[name] = {
                    featureImplementation: constructed,
                    enabled: true,
                    version: versionToLoad,
                    required,
                };
                if (attachIfPossible) {
                    // if session started already, request and enable
                    if (this._xrSessionManager.session && !this._features[name].featureImplementation.attached) {
                        // enable feature
                        this.attachFeature(name);
                    }
                }
                else {
                    // disable auto-attach when session starts
                    this._features[name].featureImplementation.disableAutoAttach = true;
                }
                return this._features[name].featureImplementation;
            }
            else {
                if (required) {
                    throw new Error("required feature not compatible");
                }
                else {
                    Tools.Warn(`Feature ${name} not compatible with the current environment/browser and was not enabled.`);
                    return constructed;
                }
            }
        }
        /**
         * get the implementation of an enabled feature.
         * @param featureName the name of the feature to load
         * @returns the feature class, if found
         */
        getEnabledFeature(featureName) {
            return this._features[featureName] && this._features[featureName].featureImplementation;
        }
        /**
         * Get the list of enabled features
         * @returns an array of enabled features
         */
        getEnabledFeatures() {
            return Object.keys(this._features);
        }
        /**
         * This function will extend the session creation configuration object with enabled features.
         * If, for example, the anchors feature is enabled, it will be automatically added to the optional or required features list,
         * according to the defined "required" variable, provided during enableFeature call
         * @param xrSessionInit the xr Session init object to extend
         *
         * @returns an extended XRSessionInit object
         */
        async _extendXRSessionInitObject(xrSessionInit) {
            const enabledFeatures = this.getEnabledFeatures();
            for (const featureName of enabledFeatures) {
                const feature = this._features[featureName];
                const nativeName = feature.featureImplementation.xrNativeFeatureName;
                if (nativeName) {
                    if (feature.required) {
                        xrSessionInit.requiredFeatures = xrSessionInit.requiredFeatures || [];
                        if (xrSessionInit.requiredFeatures.indexOf(nativeName) === -1) {
                            xrSessionInit.requiredFeatures.push(nativeName);
                        }
                    }
                    else {
                        xrSessionInit.optionalFeatures = xrSessionInit.optionalFeatures || [];
                        if (xrSessionInit.optionalFeatures.indexOf(nativeName) === -1) {
                            xrSessionInit.optionalFeatures.push(nativeName);
                        }
                    }
                }
                if (feature.featureImplementation.getXRSessionInitExtension) {
                    const extended = await feature.featureImplementation.getXRSessionInitExtension();
                    xrSessionInit = Object.assign(Object.assign({}, xrSessionInit), extended);
                }
            }
            return xrSessionInit;
        }
    }
    WebXRFeaturesManager._AvailableFeatures = {};
    /**
     * The key is the feature to check and the value is the feature that conflicts.
     */
    WebXRFeaturesManager._ConflictingFeatures = {
        [WebXRFeatureName.TELEPORTATION]: WebXRFeatureName.MOVEMENT,
        [WebXRFeatureName.MOVEMENT]: WebXRFeatureName.TELEPORTATION,
    };

    Node.AddNodeConstructor("TouchCamera", (name, scene) => {
        return () => new TouchCamera(name, Vector3.Zero(), scene);
    });
    /**
     * This represents a FPS type of camera controlled by touch.
     * This is like a universal camera minus the Gamepad controls.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     */
    class TouchCamera extends FreeCamera {
        /**
         * Defines the touch sensibility for rotation.
         * The higher the faster.
         */
        get touchAngularSensibility() {
            const touch = this.inputs.attached["touch"];
            if (touch) {
                return touch.touchAngularSensibility;
            }
            return 0;
        }
        set touchAngularSensibility(value) {
            const touch = this.inputs.attached["touch"];
            if (touch) {
                touch.touchAngularSensibility = value;
            }
        }
        /**
         * Defines the touch sensibility for move.
         * The higher the faster.
         */
        get touchMoveSensibility() {
            const touch = this.inputs.attached["touch"];
            if (touch) {
                return touch.touchMoveSensibility;
            }
            return 0;
        }
        set touchMoveSensibility(value) {
            const touch = this.inputs.attached["touch"];
            if (touch) {
                touch.touchMoveSensibility = value;
            }
        }
        /**
         * Instantiates a new touch camera.
         * This represents a FPS type of camera controlled by touch.
         * This is like a universal camera minus the Gamepad controls.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
         * @param name Define the name of the camera in the scene
         * @param position Define the start position of the camera in the scene
         * @param scene Define the scene the camera belongs to
         */
        constructor(name, position, scene) {
            super(name, position, scene);
            this.inputs.addTouch();
            this._setupInputs();
        }
        /**
         * Gets the current object class name.
         * @returns the class name
         */
        getClassName() {
            return "TouchCamera";
        }
        /** @internal */
        _setupInputs() {
            const touch = this.inputs.attached["touch"];
            const mouse = this.inputs.attached["mouse"];
            if (mouse) {
                mouse.touchEnabled = false;
            }
            else {
                touch.allowMouse = true;
            }
        }
    }

    Node.AddNodeConstructor("FreeCamera", (name, scene) => {
        // Forcing to use the Universal camera
        return () => new UniversalCamera(name, Vector3.Zero(), scene);
    });
    /**
     * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
     * which still works and will still be found in many Playgrounds.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     */
    class UniversalCamera extends TouchCamera {
        /**
         * Defines the gamepad rotation sensibility.
         * This is the threshold from when rotation starts to be accounted for to prevent jittering.
         */
        get gamepadAngularSensibility() {
            const gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                return gamepad.gamepadAngularSensibility;
            }
            return 0;
        }
        set gamepadAngularSensibility(value) {
            const gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                gamepad.gamepadAngularSensibility = value;
            }
        }
        /**
         * Defines the gamepad move sensibility.
         * This is the threshold from when moving starts to be accounted for to prevent jittering.
         */
        get gamepadMoveSensibility() {
            const gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                return gamepad.gamepadMoveSensibility;
            }
            return 0;
        }
        set gamepadMoveSensibility(value) {
            const gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                gamepad.gamepadMoveSensibility = value;
            }
        }
        /**
         * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
         * which still works and will still be found in many Playgrounds.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
         * @param name Define the name of the camera in the scene
         * @param position Define the start position of the camera in the scene
         * @param scene Define the scene the camera belongs to
         */
        constructor(name, position, scene) {
            super(name, position, scene);
            this.inputs.addGamepad();
        }
        /**
         * Gets the current object class name.
         * @returns the class name
         */
        getClassName() {
            return "UniversalCamera";
        }
    }
    Camera._CreateDefaultParsedCamera = (name, scene) => {
        return new UniversalCamera(name, Vector3.Zero(), scene);
    };

    /**
     * Base set of functionality needed to create an XR experience (WebXRSessionManager, Camera, StateManagement, etc.)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/webXR/webXRExperienceHelpers
     */
    class WebXRExperienceHelper {
        /**
         * Creates a WebXRExperienceHelper
         * @param _scene The scene the helper should be created in
         */
        constructor(_scene) {
            this._scene = _scene;
            this._nonVRCamera = null;
            this._attachedToElement = false;
            this._spectatorCamera = null;
            this._originalSceneAutoClear = true;
            this._supported = false;
            this._spectatorMode = false;
            this._lastTimestamp = 0;
            /**
             * Observers registered here will be triggered after the camera's initial transformation is set
             * This can be used to set a different ground level or an extra rotation.
             *
             * Note that ground level is considered to be at 0. The height defined by the XR camera will be added
             * to the position set after this observable is done executing.
             */
            this.onInitialXRPoseSetObservable = new Observable$1();
            /**
             * Fires when the state of the experience helper has changed
             */
            this.onStateChangedObservable = new Observable$1();
            /**
             * The current state of the XR experience (eg. transitioning, in XR or not in XR)
             */
            this.state = WebXRState.NOT_IN_XR;
            this.sessionManager = new WebXRSessionManager(_scene);
            this.camera = new WebXRCamera("webxr", _scene, this.sessionManager);
            this.featuresManager = new WebXRFeaturesManager(this.sessionManager);
            _scene.onDisposeObservable.addOnce(() => {
                this.dispose();
            });
        }
        /**
         * Creates the experience helper
         * @param scene the scene to attach the experience helper to
         * @returns a promise for the experience helper
         */
        static CreateAsync(scene) {
            const helper = new WebXRExperienceHelper(scene);
            return helper.sessionManager
                .initializeAsync()
                .then(() => {
                helper._supported = true;
                return helper;
            })
                .catch((e) => {
                helper._setState(WebXRState.NOT_IN_XR);
                helper.dispose();
                throw e;
            });
        }
        /**
         * Disposes of the experience helper
         */
        dispose() {
            var _a;
            this.exitXRAsync();
            this.camera.dispose();
            this.onStateChangedObservable.clear();
            this.onInitialXRPoseSetObservable.clear();
            this.sessionManager.dispose();
            (_a = this._spectatorCamera) === null || _a === void 0 ? void 0 : _a.dispose();
            if (this._nonVRCamera) {
                this._scene.activeCamera = this._nonVRCamera;
            }
        }
        /**
         * Enters XR mode (This must be done within a user interaction in most browsers eg. button click)
         * @param sessionMode options for the XR session
         * @param referenceSpaceType frame of reference of the XR session
         * @param renderTarget the output canvas that will be used to enter XR mode
         * @param sessionCreationOptions optional XRSessionInit object to init the session with
         * @returns promise that resolves after xr mode has entered
         */
        async enterXRAsync(sessionMode, referenceSpaceType, renderTarget = this.sessionManager.getWebXRRenderTarget(), sessionCreationOptions = {}) {
            var _a, _b, _c;
            if (!this._supported) {
                throw "WebXR not supported in this browser or environment";
            }
            this._setState(WebXRState.ENTERING_XR);
            if (referenceSpaceType !== "viewer" && referenceSpaceType !== "local") {
                sessionCreationOptions.optionalFeatures = sessionCreationOptions.optionalFeatures || [];
                sessionCreationOptions.optionalFeatures.push(referenceSpaceType);
            }
            sessionCreationOptions = await this.featuresManager._extendXRSessionInitObject(sessionCreationOptions);
            // we currently recommend "unbounded" space in AR (#7959)
            if (sessionMode === "immersive-ar" && referenceSpaceType !== "unbounded") {
                Logger.Warn("We recommend using 'unbounded' reference space type when using 'immersive-ar' session mode");
            }
            // make sure that the session mode is supported
            try {
                await this.sessionManager.initializeSessionAsync(sessionMode, sessionCreationOptions);
                await this.sessionManager.setReferenceSpaceTypeAsync(referenceSpaceType);
                const baseLayer = await renderTarget.initializeXRLayerAsync(this.sessionManager.session);
                const xrRenderState = {
                    // if maxZ is 0 it should be "Infinity", but it doesn't work with the WebXR API. Setting to a large number.
                    depthFar: this.camera.maxZ || 10000,
                    depthNear: this.camera.minZ,
                };
                // The layers feature will have already initialized the xr session's layers on session init.
                if (!this.featuresManager.getEnabledFeature(WebXRFeatureName.LAYERS)) {
                    xrRenderState.baseLayer = baseLayer;
                }
                this.sessionManager.updateRenderState(xrRenderState);
                // run the render loop
                this.sessionManager.runXRRenderLoop();
                // Cache pre xr scene settings
                this._originalSceneAutoClear = this._scene.autoClear;
                this._nonVRCamera = this._scene.activeCamera;
                this._attachedToElement = !!((_b = (_a = this._nonVRCamera) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b.attachedToElement);
                (_c = this._nonVRCamera) === null || _c === void 0 ? void 0 : _c.detachControl();
                this._scene.activeCamera = this.camera;
                // do not compensate when AR session is used
                if (sessionMode !== "immersive-ar") {
                    this._nonXRToXRCamera();
                }
                else {
                    // Kept here, TODO - check if needed
                    this._scene.autoClear = false;
                    this.camera.compensateOnFirstFrame = false;
                    // reset the camera's position to the origin
                    this.camera.position.set(0, 0, 0);
                    this.camera.rotationQuaternion.set(0, 0, 0, 1);
                    this.onInitialXRPoseSetObservable.notifyObservers(this.camera);
                }
                this.sessionManager.onXRSessionEnded.addOnce(() => {
                    // when using the back button and not the exit button (default on mobile), the session is ending but the EXITING state was not set
                    if (this.state !== WebXRState.EXITING_XR) {
                        this._setState(WebXRState.EXITING_XR);
                    }
                    // Reset camera rigs output render target to ensure sessions render target is not drawn after it ends
                    this.camera.rigCameras.forEach((c) => {
                        c.outputRenderTarget = null;
                    });
                    // Restore scene settings
                    this._scene.autoClear = this._originalSceneAutoClear;
                    this._scene.activeCamera = this._nonVRCamera;
                    if (this._attachedToElement && this._nonVRCamera) {
                        this._nonVRCamera.attachControl(!!this._nonVRCamera.inputs.noPreventDefault);
                    }
                    if (sessionMode !== "immersive-ar" && this.camera.compensateOnFirstFrame) {
                        if (this._nonVRCamera.setPosition) {
                            this._nonVRCamera.setPosition(this.camera.position);
                        }
                        else {
                            this._nonVRCamera.position.copyFrom(this.camera.position);
                        }
                    }
                    this._setState(WebXRState.NOT_IN_XR);
                });
                // Wait until the first frame arrives before setting state to in xr
                this.sessionManager.onXRFrameObservable.addOnce(() => {
                    this._setState(WebXRState.IN_XR);
                });
                return this.sessionManager;
            }
            catch (e) {
                console.log(e);
                console.log(e.message);
                this._setState(WebXRState.NOT_IN_XR);
                throw e;
            }
        }
        /**
         * Exits XR mode and returns the scene to its original state
         * @returns promise that resolves after xr mode has exited
         */
        exitXRAsync() {
            // only exit if state is IN_XR
            if (this.state !== WebXRState.IN_XR) {
                return Promise.resolve();
            }
            this._setState(WebXRState.EXITING_XR);
            return this.sessionManager.exitXRAsync();
        }
        /**
         * Enable spectator mode for desktop VR experiences.
         * When spectator mode is enabled a camera will be attached to the desktop canvas and will
         * display the first rig camera's view on the desktop canvas.
         * Please note that this will degrade performance, as it requires another camera render.
         * It is also not recommended to enable this in devices like the quest, as it brings no benefit there.
         * @param options giving WebXRSpectatorModeOption for specutator camera to setup when the spectator mode is enabled.
         */
        enableSpectatorMode(options) {
            if (!this._spectatorMode) {
                this._spectatorMode = true;
                this._switchSpectatorMode(options);
            }
        }
        /**
         * Disable spectator mode for desktop VR experiences.
         */
        disableSpecatatorMode() {
            if (this._spectatorMode) {
                this._spectatorMode = false;
                this._switchSpectatorMode();
            }
        }
        _switchSpectatorMode(options) {
            const fps = (options === null || options === void 0 ? void 0 : options.fps) ? options.fps : 1000.0;
            const refreshRate = (1.0 / fps) * 1000.0;
            const cameraIndex = (options === null || options === void 0 ? void 0 : options.preferredCameraIndex) ? options === null || options === void 0 ? void 0 : options.preferredCameraIndex : 0;
            const updateSpectatorCamera = () => {
                if (this._spectatorCamera) {
                    const delta = this.sessionManager.currentTimestamp - this._lastTimestamp;
                    if (delta >= refreshRate) {
                        this._lastTimestamp = this.sessionManager.currentTimestamp;
                        this._spectatorCamera.position.copyFrom(this.camera.rigCameras[cameraIndex].globalPosition);
                        this._spectatorCamera.rotationQuaternion.copyFrom(this.camera.rigCameras[cameraIndex].absoluteRotation);
                    }
                }
            };
            if (this._spectatorMode) {
                if (cameraIndex >= this.camera.rigCameras.length) {
                    throw new Error("the preferred camera index is beyond the length of rig camera array.");
                }
                const onStateChanged = () => {
                    if (this.state === WebXRState.IN_XR) {
                        this._spectatorCamera = new UniversalCamera("webxr-spectator", Vector3.Zero(), this._scene);
                        this._spectatorCamera.rotationQuaternion = new Quaternion();
                        this._scene.activeCameras = [this.camera, this._spectatorCamera];
                        this.sessionManager.onXRFrameObservable.add(updateSpectatorCamera);
                        this._scene.onAfterRenderCameraObservable.add((camera) => {
                            if (camera === this.camera) {
                                // reset the dimensions object for correct resizing
                                this._scene.getEngine().framebufferDimensionsObject = null;
                            }
                        });
                    }
                    else if (this.state === WebXRState.EXITING_XR) {
                        this.sessionManager.onXRFrameObservable.removeCallback(updateSpectatorCamera);
                        this._scene.activeCameras = null;
                    }
                };
                this.onStateChangedObservable.add(onStateChanged);
                onStateChanged();
            }
            else {
                this.sessionManager.onXRFrameObservable.removeCallback(updateSpectatorCamera);
                this._scene.activeCameras = [this.camera];
            }
        }
        _nonXRToXRCamera() {
            this.camera.setTransformationFromNonVRCamera(this._nonVRCamera);
            this.onInitialXRPoseSetObservable.notifyObservers(this.camera);
        }
        _setState(val) {
            if (this.state === val) {
                return;
            }
            this.state = val;
            this.onStateChangedObservable.notifyObservers(this.state);
        }
    }

    /**
     * This class represents a single component (for example button or thumbstick) of a motion controller
     */
    class WebXRControllerComponent {
        /**
         * Creates a new component for a motion controller.
         * It is created by the motion controller itself
         *
         * @param id the id of this component
         * @param type the type of the component
         * @param _buttonIndex index in the buttons array of the gamepad
         * @param _axesIndices indices of the values in the axes array of the gamepad
         */
        constructor(
        /**
         * the id of this component
         */
        id, 
        /**
         * the type of the component
         */
        type, _buttonIndex = -1, _axesIndices = []) {
            this.id = id;
            this.type = type;
            this._buttonIndex = _buttonIndex;
            this._axesIndices = _axesIndices;
            this._axes = {
                x: 0,
                y: 0,
            };
            this._changes = {};
            this._currentValue = 0;
            this._hasChanges = false;
            this._pressed = false;
            this._touched = false;
            /**
             * If axes are available for this component (like a touchpad or thumbstick) the observers will be notified when
             * the axes data changes
             */
            this.onAxisValueChangedObservable = new Observable$1();
            /**
             * Observers registered here will be triggered when the state of a button changes
             * State change is either pressed / touched / value
             */
            this.onButtonStateChangedObservable = new Observable$1();
        }
        /**
         * The current axes data. If this component has no axes it will still return an object { x: 0, y: 0 }
         */
        get axes() {
            return this._axes;
        }
        /**
         * Get the changes. Elements will be populated only if they changed with their previous and current value
         */
        get changes() {
            return this._changes;
        }
        /**
         * Return whether or not the component changed the last frame
         */
        get hasChanges() {
            return this._hasChanges;
        }
        /**
         * is the button currently pressed
         */
        get pressed() {
            return this._pressed;
        }
        /**
         * is the button currently touched
         */
        get touched() {
            return this._touched;
        }
        /**
         * Get the current value of this component
         */
        get value() {
            return this._currentValue;
        }
        /**
         * Dispose this component
         */
        dispose() {
            this.onAxisValueChangedObservable.clear();
            this.onButtonStateChangedObservable.clear();
        }
        /**
         * Are there axes correlating to this component
         * @returns true is axes data is available
         */
        isAxes() {
            return this._axesIndices.length !== 0;
        }
        /**
         * Is this component a button (hence - pressable)
         * @returns true if can be pressed
         */
        isButton() {
            return this._buttonIndex !== -1;
        }
        /**
         * update this component using the gamepad object it is in. Called on every frame
         * @param nativeController the native gamepad controller object
         */
        update(nativeController) {
            let buttonUpdated = false;
            let axesUpdate = false;
            this._hasChanges = false;
            this._changes = {};
            if (this.isButton()) {
                const button = nativeController.buttons[this._buttonIndex];
                // defensive, in case a profile was forced
                if (!button) {
                    return;
                }
                if (this._currentValue !== button.value) {
                    this.changes.value = {
                        current: button.value,
                        previous: this._currentValue,
                    };
                    buttonUpdated = true;
                    this._currentValue = button.value;
                }
                if (this._touched !== button.touched) {
                    this.changes.touched = {
                        current: button.touched,
                        previous: this._touched,
                    };
                    buttonUpdated = true;
                    this._touched = button.touched;
                }
                if (this._pressed !== button.pressed) {
                    this.changes.pressed = {
                        current: button.pressed,
                        previous: this._pressed,
                    };
                    buttonUpdated = true;
                    this._pressed = button.pressed;
                }
            }
            if (this.isAxes()) {
                if (this._axes.x !== nativeController.axes[this._axesIndices[0]]) {
                    this.changes.axes = {
                        current: {
                            x: nativeController.axes[this._axesIndices[0]],
                            y: this._axes.y,
                        },
                        previous: {
                            x: this._axes.x,
                            y: this._axes.y,
                        },
                    };
                    this._axes.x = nativeController.axes[this._axesIndices[0]];
                    axesUpdate = true;
                }
                if (this._axes.y !== nativeController.axes[this._axesIndices[1]]) {
                    if (this.changes.axes) {
                        this.changes.axes.current.y = nativeController.axes[this._axesIndices[1]];
                    }
                    else {
                        this.changes.axes = {
                            current: {
                                x: this._axes.x,
                                y: nativeController.axes[this._axesIndices[1]],
                            },
                            previous: {
                                x: this._axes.x,
                                y: this._axes.y,
                            },
                        };
                    }
                    this._axes.y = nativeController.axes[this._axesIndices[1]];
                    axesUpdate = true;
                }
            }
            if (buttonUpdated) {
                this._hasChanges = true;
                this.onButtonStateChangedObservable.notifyObservers(this);
            }
            if (axesUpdate) {
                this._hasChanges = true;
                this.onAxisValueChangedObservable.notifyObservers(this._axes);
            }
        }
    }
    /**
     * button component type
     */
    WebXRControllerComponent.BUTTON_TYPE = "button";
    /**
     * squeeze component type
     */
    WebXRControllerComponent.SQUEEZE_TYPE = "squeeze";
    /**
     * Thumbstick component type
     */
    WebXRControllerComponent.THUMBSTICK_TYPE = "thumbstick";
    /**
     * Touchpad component type
     */
    WebXRControllerComponent.TOUCHPAD_TYPE = "touchpad";
    /**
     * trigger component type
     */
    WebXRControllerComponent.TRIGGER_TYPE = "trigger";

    /**
     * Mode that determines how to handle old animation groups before loading new ones.
     */
    var SceneLoaderAnimationGroupLoadingMode;
    (function (SceneLoaderAnimationGroupLoadingMode) {
        /**
         * Reset all old animations to initial state then dispose them.
         */
        SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["Clean"] = 0] = "Clean";
        /**
         * Stop all old animations.
         */
        SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["Stop"] = 1] = "Stop";
        /**
         * Restart old animations from first frame.
         */
        SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["Sync"] = 2] = "Sync";
        /**
         * Old animations remains untouched.
         */
        SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["NoSync"] = 3] = "NoSync";
    })(SceneLoaderAnimationGroupLoadingMode || (SceneLoaderAnimationGroupLoadingMode = {}));
    /**
     * Class used to load scene from various file formats using registered plugins
     * @see https://doc.babylonjs.com/features/featuresDeepDive/importers/loadingFileTypes
     */
    class SceneLoader {
        /**
         * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
         */
        static get ForceFullSceneLoadingForIncremental() {
            return SceneLoaderFlags.ForceFullSceneLoadingForIncremental;
        }
        static set ForceFullSceneLoadingForIncremental(value) {
            SceneLoaderFlags.ForceFullSceneLoadingForIncremental = value;
        }
        /**
         * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
         */
        static get ShowLoadingScreen() {
            return SceneLoaderFlags.ShowLoadingScreen;
        }
        static set ShowLoadingScreen(value) {
            SceneLoaderFlags.ShowLoadingScreen = value;
        }
        /**
         * Defines the current logging level (while loading the scene)
         * @ignorenaming
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static get loggingLevel() {
            return SceneLoaderFlags.loggingLevel;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static set loggingLevel(value) {
            SceneLoaderFlags.loggingLevel = value;
        }
        /**
         * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
         */
        static get CleanBoneMatrixWeights() {
            return SceneLoaderFlags.CleanBoneMatrixWeights;
        }
        static set CleanBoneMatrixWeights(value) {
            SceneLoaderFlags.CleanBoneMatrixWeights = value;
        }
        /**
         * Gets the default plugin (used to load Babylon files)
         * @returns the .babylon plugin
         */
        static GetDefaultPlugin() {
            return SceneLoader._RegisteredPlugins[".babylon"];
        }
        static _GetPluginForExtension(extension) {
            const registeredPlugin = SceneLoader._RegisteredPlugins[extension];
            if (registeredPlugin) {
                return registeredPlugin;
            }
            Logger.Warn("Unable to find a plugin to load " +
                extension +
                " files. Trying to use .babylon default plugin. To load from a specific filetype (eg. gltf) see: https://doc.babylonjs.com/features/featuresDeepDive/importers/loadingFileTypes");
            return SceneLoader.GetDefaultPlugin();
        }
        static _GetPluginForDirectLoad(data) {
            for (const extension in SceneLoader._RegisteredPlugins) {
                const plugin = SceneLoader._RegisteredPlugins[extension].plugin;
                if (plugin.canDirectLoad && plugin.canDirectLoad(data)) {
                    return SceneLoader._RegisteredPlugins[extension];
                }
            }
            return SceneLoader.GetDefaultPlugin();
        }
        static _GetPluginForFilename(sceneFilename) {
            const queryStringPosition = sceneFilename.indexOf("?");
            if (queryStringPosition !== -1) {
                sceneFilename = sceneFilename.substring(0, queryStringPosition);
            }
            const dotPosition = sceneFilename.lastIndexOf(".");
            const extension = sceneFilename.substring(dotPosition, sceneFilename.length).toLowerCase();
            return SceneLoader._GetPluginForExtension(extension);
        }
        static _GetDirectLoad(sceneFilename) {
            if (sceneFilename.substr(0, 5) === "data:") {
                return sceneFilename.substr(5);
            }
            return null;
        }
        static _FormatErrorMessage(fileInfo, message, exception) {
            const fromLoad = fileInfo.rawData ? "binary data" : fileInfo.url;
            let errorMessage = "Unable to load from " + fromLoad;
            if (message) {
                errorMessage += `: ${message}`;
            }
            else if (exception) {
                errorMessage += `: ${exception}`;
            }
            return errorMessage;
        }
        static _LoadData(fileInfo, scene, onSuccess, onProgress, onError, onDispose, pluginExtension, name) {
            const directLoad = SceneLoader._GetDirectLoad(fileInfo.url);
            if (fileInfo.rawData && !pluginExtension) {
                throw "When using ArrayBufferView to load data the file extension must be provided.";
            }
            const registeredPlugin = pluginExtension
                ? SceneLoader._GetPluginForExtension(pluginExtension)
                : directLoad
                    ? SceneLoader._GetPluginForDirectLoad(fileInfo.url)
                    : SceneLoader._GetPluginForFilename(fileInfo.url);
            if (fileInfo.rawData && !registeredPlugin.isBinary) {
                throw "Loading from ArrayBufferView can not be used with plugins that don't support binary loading.";
            }
            let plugin;
            if (registeredPlugin.plugin.createPlugin !== undefined) {
                plugin = registeredPlugin.plugin.createPlugin();
            }
            else {
                plugin = registeredPlugin.plugin;
            }
            if (!plugin) {
                throw "The loader plugin corresponding to the file type you are trying to load has not been found. If using es6, please import the plugin you wish to use before.";
            }
            SceneLoader.OnPluginActivatedObservable.notifyObservers(plugin);
            // Check if we have a direct load url. If the plugin is registered to handle
            // it or it's not a base64 data url, then pass it through the direct load path.
            if (directLoad && ((plugin.canDirectLoad && plugin.canDirectLoad(fileInfo.url)) || !IsBase64DataUrl(fileInfo.url))) {
                if (plugin.directLoad) {
                    const result = plugin.directLoad(scene, directLoad);
                    if (result.then) {
                        result
                            .then((data) => {
                            onSuccess(plugin, data);
                        })
                            .catch((error) => {
                            onError("Error in directLoad of _loadData: " + error, error);
                        });
                    }
                    else {
                        onSuccess(plugin, result);
                    }
                }
                else {
                    onSuccess(plugin, directLoad);
                }
                return plugin;
            }
            const useArrayBuffer = registeredPlugin.isBinary;
            const dataCallback = (data, responseURL) => {
                if (scene.isDisposed) {
                    onError("Scene has been disposed");
                    return;
                }
                onSuccess(plugin, data, responseURL);
            };
            let request = null;
            let pluginDisposed = false;
            const onDisposeObservable = plugin.onDisposeObservable;
            if (onDisposeObservable) {
                onDisposeObservable.add(() => {
                    pluginDisposed = true;
                    if (request) {
                        request.abort();
                        request = null;
                    }
                    onDispose();
                });
            }
            const manifestChecked = () => {
                if (pluginDisposed) {
                    return;
                }
                const errorCallback = (request, exception) => {
                    onError(request === null || request === void 0 ? void 0 : request.statusText, exception);
                };
                if (!plugin.loadFile && fileInfo.rawData) {
                    throw "Plugin does not support loading ArrayBufferView.";
                }
                request = plugin.loadFile
                    ? plugin.loadFile(scene, fileInfo.rawData || fileInfo.file || fileInfo.url, fileInfo.rootUrl, dataCallback, onProgress, useArrayBuffer, errorCallback, name)
                    : scene._loadFile(fileInfo.file || fileInfo.url, dataCallback, onProgress, true, useArrayBuffer, errorCallback);
            };
            const engine = scene.getEngine();
            let canUseOfflineSupport = engine.enableOfflineSupport;
            if (canUseOfflineSupport) {
                // Also check for exceptions
                let exceptionFound = false;
                for (const regex of scene.disableOfflineSupportExceptionRules) {
                    if (regex.test(fileInfo.url)) {
                        exceptionFound = true;
                        break;
                    }
                }
                canUseOfflineSupport = !exceptionFound;
            }
            if (canUseOfflineSupport && Engine.OfflineProviderFactory) {
                // Checking if a manifest file has been set for this scene and if offline mode has been requested
                scene.offlineProvider = Engine.OfflineProviderFactory(fileInfo.url, manifestChecked, engine.disableManifestCheck);
            }
            else {
                manifestChecked();
            }
            return plugin;
        }
        static _GetFileInfo(rootUrl, sceneFilename) {
            let url;
            let name;
            let file = null;
            let rawData = null;
            if (!sceneFilename) {
                url = rootUrl;
                name = Tools.GetFilename(rootUrl);
                rootUrl = Tools.GetFolderPath(rootUrl);
            }
            else if (sceneFilename.name) {
                const sceneFile = sceneFilename;
                url = `file:${sceneFile.name}`;
                name = sceneFile.name;
                file = sceneFile;
            }
            else if (ArrayBuffer.isView(sceneFilename)) {
                url = "";
                name = "arrayBuffer";
                rawData = sceneFilename;
            }
            else if (typeof sceneFilename === "string" && sceneFilename.startsWith("data:")) {
                url = sceneFilename;
                name = "";
            }
            else {
                const filename = sceneFilename;
                if (filename.substr(0, 1) === "/") {
                    Tools.Error("Wrong sceneFilename parameter");
                    return null;
                }
                url = rootUrl + filename;
                name = filename;
            }
            return {
                url: url,
                rootUrl: rootUrl,
                name: name,
                file: file,
                rawData,
            };
        }
        // Public functions
        /**
         * Gets a plugin that can load the given extension
         * @param extension defines the extension to load
         * @returns a plugin or null if none works
         */
        static GetPluginForExtension(extension) {
            return SceneLoader._GetPluginForExtension(extension).plugin;
        }
        /**
         * Gets a boolean indicating that the given extension can be loaded
         * @param extension defines the extension to load
         * @returns true if the extension is supported
         */
        static IsPluginForExtensionAvailable(extension) {
            return !!SceneLoader._RegisteredPlugins[extension];
        }
        /**
         * Adds a new plugin to the list of registered plugins
         * @param plugin defines the plugin to add
         */
        static RegisterPlugin(plugin) {
            if (typeof plugin.extensions === "string") {
                const extension = plugin.extensions;
                SceneLoader._RegisteredPlugins[extension.toLowerCase()] = {
                    plugin: plugin,
                    isBinary: false,
                };
            }
            else {
                const extensions = plugin.extensions;
                Object.keys(extensions).forEach((extension) => {
                    SceneLoader._RegisteredPlugins[extension.toLowerCase()] = {
                        plugin: plugin,
                        isBinary: extensions[extension].isBinary,
                    };
                });
            }
        }
        /**
         * Import meshes into a scene
         * @param meshNames an array of mesh names, a single mesh name, or empty string for all meshes that filter what meshes are imported
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene the instance of BABYLON.Scene to append to
         * @param onSuccess a callback with a list of imported meshes, particleSystems, skeletons, and animationGroups when import succeeds
         * @param onProgress a callback with a progress event for each file being loaded
         * @param onError a callback with the scene, a message, and possibly an exception when import fails
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded plugin
         */
        static ImportMesh(meshNames, rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
            if (!scene) {
                Logger.Error("No scene available to import mesh to");
                return null;
            }
            const fileInfo = SceneLoader._GetFileInfo(rootUrl, sceneFilename);
            if (!fileInfo) {
                return null;
            }
            const loadingToken = {};
            scene.addPendingData(loadingToken);
            const disposeHandler = () => {
                scene.removePendingData(loadingToken);
            };
            const errorHandler = (message, exception) => {
                const errorMessage = SceneLoader._FormatErrorMessage(fileInfo, message, exception);
                if (onError) {
                    onError(scene, errorMessage, new RuntimeError(errorMessage, ErrorCodes.SceneLoaderError, exception));
                }
                else {
                    Logger.Error(errorMessage);
                    // should the exception be thrown?
                }
                disposeHandler();
            };
            const progressHandler = onProgress
                ? (event) => {
                    try {
                        onProgress(event);
                    }
                    catch (e) {
                        errorHandler("Error in onProgress callback: " + e, e);
                    }
                }
                : undefined;
            const successHandler = (meshes, particleSystems, skeletons, animationGroups, transformNodes, geometries, lights) => {
                scene.importedMeshesFiles.push(fileInfo.url);
                if (onSuccess) {
                    try {
                        onSuccess(meshes, particleSystems, skeletons, animationGroups, transformNodes, geometries, lights);
                    }
                    catch (e) {
                        errorHandler("Error in onSuccess callback: " + e, e);
                    }
                }
                scene.removePendingData(loadingToken);
            };
            return SceneLoader._LoadData(fileInfo, scene, (plugin, data, responseURL) => {
                if (plugin.rewriteRootURL) {
                    fileInfo.rootUrl = plugin.rewriteRootURL(fileInfo.rootUrl, responseURL);
                }
                if (plugin.importMesh) {
                    const syncedPlugin = plugin;
                    const meshes = new Array();
                    const particleSystems = new Array();
                    const skeletons = new Array();
                    if (!syncedPlugin.importMesh(meshNames, scene, data, fileInfo.rootUrl, meshes, particleSystems, skeletons, errorHandler)) {
                        return;
                    }
                    scene.loadingPluginName = plugin.name;
                    successHandler(meshes, particleSystems, skeletons, [], [], [], []);
                }
                else {
                    const asyncedPlugin = plugin;
                    asyncedPlugin
                        .importMeshAsync(meshNames, scene, data, fileInfo.rootUrl, progressHandler, fileInfo.name)
                        .then((result) => {
                        scene.loadingPluginName = plugin.name;
                        successHandler(result.meshes, result.particleSystems, result.skeletons, result.animationGroups, result.transformNodes, result.geometries, result.lights);
                    })
                        .catch((error) => {
                        errorHandler(error.message, error);
                    });
                }
            }, progressHandler, errorHandler, disposeHandler, pluginExtension, name);
        }
        /**
         * Import meshes into a scene
         * @param meshNames an array of mesh names, a single mesh name, or empty string for all meshes that filter what meshes are imported
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene the instance of BABYLON.Scene to append to
         * @param onProgress a callback with a progress event for each file being loaded
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded list of imported meshes, particle systems, skeletons, and animation groups
         */
        static ImportMeshAsync(meshNames, rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, onProgress = null, pluginExtension = null, name = "") {
            return new Promise((resolve, reject) => {
                SceneLoader.ImportMesh(meshNames, rootUrl, sceneFilename, scene, (meshes, particleSystems, skeletons, animationGroups, transformNodes, geometries, lights) => {
                    resolve({
                        meshes: meshes,
                        particleSystems: particleSystems,
                        skeletons: skeletons,
                        animationGroups: animationGroups,
                        transformNodes: transformNodes,
                        geometries: geometries,
                        lights: lights,
                    });
                }, onProgress, (scene, message, exception) => {
                    reject(exception || new Error(message));
                }, pluginExtension, name);
            });
        }
        /**
         * Load a scene
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param engine is the instance of BABYLON.Engine to use to create the scene
         * @param onSuccess a callback with the scene when import succeeds
         * @param onProgress a callback with a progress event for each file being loaded
         * @param onError a callback with the scene, a message, and possibly an exception when import fails
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded plugin
         */
        static Load(rootUrl, sceneFilename = "", engine = EngineStore.LastCreatedEngine, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
            if (!engine) {
                Tools.Error("No engine available");
                return null;
            }
            return SceneLoader.Append(rootUrl, sceneFilename, new Scene(engine), onSuccess, onProgress, onError, pluginExtension, name);
        }
        /**
         * Load a scene
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param engine is the instance of BABYLON.Engine to use to create the scene
         * @param onProgress a callback with a progress event for each file being loaded
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded scene
         */
        static LoadAsync(rootUrl, sceneFilename = "", engine = EngineStore.LastCreatedEngine, onProgress = null, pluginExtension = null, name = "") {
            return new Promise((resolve, reject) => {
                SceneLoader.Load(rootUrl, sceneFilename, engine, (scene) => {
                    resolve(scene);
                }, onProgress, (scene, message, exception) => {
                    reject(exception || new Error(message));
                }, pluginExtension, name);
            });
        }
        /**
         * Append a scene
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene is the instance of BABYLON.Scene to append to
         * @param onSuccess a callback with the scene when import succeeds
         * @param onProgress a callback with a progress event for each file being loaded
         * @param onError a callback with the scene, a message, and possibly an exception when import fails
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded plugin
         */
        static Append(rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
            if (!scene) {
                Logger.Error("No scene available to append to");
                return null;
            }
            const fileInfo = SceneLoader._GetFileInfo(rootUrl, sceneFilename);
            if (!fileInfo) {
                return null;
            }
            const loadingToken = {};
            scene.addPendingData(loadingToken);
            const disposeHandler = () => {
                scene.removePendingData(loadingToken);
            };
            if (SceneLoader.ShowLoadingScreen && !this._ShowingLoadingScreen) {
                this._ShowingLoadingScreen = true;
                scene.getEngine().displayLoadingUI();
                scene.executeWhenReady(() => {
                    scene.getEngine().hideLoadingUI();
                    this._ShowingLoadingScreen = false;
                });
            }
            const errorHandler = (message, exception) => {
                const errorMessage = SceneLoader._FormatErrorMessage(fileInfo, message, exception);
                if (onError) {
                    onError(scene, errorMessage, new RuntimeError(errorMessage, ErrorCodes.SceneLoaderError, exception));
                }
                else {
                    Logger.Error(errorMessage);
                    // should the exception be thrown?
                }
                disposeHandler();
            };
            const progressHandler = onProgress
                ? (event) => {
                    try {
                        onProgress(event);
                    }
                    catch (e) {
                        errorHandler("Error in onProgress callback", e);
                    }
                }
                : undefined;
            const successHandler = () => {
                if (onSuccess) {
                    try {
                        onSuccess(scene);
                    }
                    catch (e) {
                        errorHandler("Error in onSuccess callback", e);
                    }
                }
                scene.removePendingData(loadingToken);
            };
            return SceneLoader._LoadData(fileInfo, scene, (plugin, data) => {
                if (plugin.load) {
                    const syncedPlugin = plugin;
                    if (!syncedPlugin.load(scene, data, fileInfo.rootUrl, errorHandler)) {
                        return;
                    }
                    scene.loadingPluginName = plugin.name;
                    successHandler();
                }
                else {
                    const asyncedPlugin = plugin;
                    asyncedPlugin
                        .loadAsync(scene, data, fileInfo.rootUrl, progressHandler, fileInfo.name)
                        .then(() => {
                        scene.loadingPluginName = plugin.name;
                        successHandler();
                    })
                        .catch((error) => {
                        errorHandler(error.message, error);
                    });
                }
            }, progressHandler, errorHandler, disposeHandler, pluginExtension, name);
        }
        /**
         * Append a scene
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene is the instance of BABYLON.Scene to append to
         * @param onProgress a callback with a progress event for each file being loaded
         * @param pluginExtension the extension used to determine the plugin
         * @returns The given scene
         */
        static AppendAsync(rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, onProgress = null, pluginExtension = null, name = "") {
            return new Promise((resolve, reject) => {
                SceneLoader.Append(rootUrl, sceneFilename, scene, (scene) => {
                    resolve(scene);
                }, onProgress, (scene, message, exception) => {
                    reject(exception || new Error(message));
                }, pluginExtension, name);
            });
        }
        /**
         * Load a scene into an asset container
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
         * @param onSuccess a callback with the scene when import succeeds
         * @param onProgress a callback with a progress event for each file being loaded
         * @param onError a callback with the scene, a message, and possibly an exception when import fails
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded plugin
         */
        static LoadAssetContainer(rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
            if (!scene) {
                Logger.Error("No scene available to load asset container to");
                return null;
            }
            const fileInfo = SceneLoader._GetFileInfo(rootUrl, sceneFilename);
            if (!fileInfo) {
                return null;
            }
            const loadingToken = {};
            scene.addPendingData(loadingToken);
            const disposeHandler = () => {
                scene.removePendingData(loadingToken);
            };
            const errorHandler = (message, exception) => {
                const errorMessage = SceneLoader._FormatErrorMessage(fileInfo, message, exception);
                if (onError) {
                    onError(scene, errorMessage, new RuntimeError(errorMessage, ErrorCodes.SceneLoaderError, exception));
                }
                else {
                    Logger.Error(errorMessage);
                    // should the exception be thrown?
                }
                disposeHandler();
            };
            const progressHandler = onProgress
                ? (event) => {
                    try {
                        onProgress(event);
                    }
                    catch (e) {
                        errorHandler("Error in onProgress callback", e);
                    }
                }
                : undefined;
            const successHandler = (assets) => {
                if (onSuccess) {
                    try {
                        onSuccess(assets);
                    }
                    catch (e) {
                        errorHandler("Error in onSuccess callback", e);
                    }
                }
                scene.removePendingData(loadingToken);
            };
            return SceneLoader._LoadData(fileInfo, scene, (plugin, data) => {
                if (plugin.loadAssetContainer) {
                    const syncedPlugin = plugin;
                    const assetContainer = syncedPlugin.loadAssetContainer(scene, data, fileInfo.rootUrl, errorHandler);
                    if (!assetContainer) {
                        return;
                    }
                    assetContainer.populateRootNodes();
                    scene.loadingPluginName = plugin.name;
                    successHandler(assetContainer);
                }
                else if (plugin.loadAssetContainerAsync) {
                    const asyncedPlugin = plugin;
                    asyncedPlugin
                        .loadAssetContainerAsync(scene, data, fileInfo.rootUrl, progressHandler, fileInfo.name)
                        .then((assetContainer) => {
                        assetContainer.populateRootNodes();
                        scene.loadingPluginName = plugin.name;
                        successHandler(assetContainer);
                    })
                        .catch((error) => {
                        errorHandler(error.message, error);
                    });
                }
                else {
                    errorHandler("LoadAssetContainer is not supported by this plugin. Plugin did not provide a loadAssetContainer or loadAssetContainerAsync method.");
                }
            }, progressHandler, errorHandler, disposeHandler, pluginExtension, name);
        }
        /**
         * Load a scene into an asset container
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene (default: empty string)
         * @param scene is the instance of Scene to append to
         * @param onProgress a callback with a progress event for each file being loaded
         * @param pluginExtension the extension used to determine the plugin
         * @returns The loaded asset container
         */
        static LoadAssetContainerAsync(rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, onProgress = null, pluginExtension = null) {
            return new Promise((resolve, reject) => {
                SceneLoader.LoadAssetContainer(rootUrl, sceneFilename, scene, (assetContainer) => {
                    resolve(assetContainer);
                }, onProgress, (scene, message, exception) => {
                    reject(exception || new Error(message));
                }, pluginExtension);
            });
        }
        /**
         * Import animations from a file into a scene
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
         * @param overwriteAnimations when true, animations are cleaned before importing new ones. Animations are appended otherwise
         * @param animationGroupLoadingMode defines how to handle old animations groups before importing new ones
         * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
         * @param onSuccess a callback with the scene when import succeeds
         * @param onProgress a callback with a progress event for each file being loaded
         * @param onError a callback with the scene, a message, and possibly an exception when import fails
         * @param pluginExtension the extension used to determine the plugin
         */
        static ImportAnimations(rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, overwriteAnimations = true, animationGroupLoadingMode = SceneLoaderAnimationGroupLoadingMode.Clean, targetConverter = null, onSuccess = null, onProgress = null, onError = null, pluginExtension = null) {
            if (!scene) {
                Logger.Error("No scene available to load animations to");
                return;
            }
            if (overwriteAnimations) {
                // Reset, stop and dispose all animations before loading new ones
                for (const animatable of scene.animatables) {
                    animatable.reset();
                }
                scene.stopAllAnimations();
                scene.animationGroups.slice().forEach((animationGroup) => {
                    animationGroup.dispose();
                });
                const nodes = scene.getNodes();
                nodes.forEach((node) => {
                    if (node.animations) {
                        node.animations = [];
                    }
                });
            }
            else {
                switch (animationGroupLoadingMode) {
                    case SceneLoaderAnimationGroupLoadingMode.Clean:
                        scene.animationGroups.slice().forEach((animationGroup) => {
                            animationGroup.dispose();
                        });
                        break;
                    case SceneLoaderAnimationGroupLoadingMode.Stop:
                        scene.animationGroups.forEach((animationGroup) => {
                            animationGroup.stop();
                        });
                        break;
                    case SceneLoaderAnimationGroupLoadingMode.Sync:
                        scene.animationGroups.forEach((animationGroup) => {
                            animationGroup.reset();
                            animationGroup.restart();
                        });
                        break;
                    case SceneLoaderAnimationGroupLoadingMode.NoSync:
                        // nothing to do
                        break;
                    default:
                        Logger.Error("Unknown animation group loading mode value '" + animationGroupLoadingMode + "'");
                        return;
                }
            }
            const startingIndexForNewAnimatables = scene.animatables.length;
            const onAssetContainerLoaded = (container) => {
                container.mergeAnimationsTo(scene, scene.animatables.slice(startingIndexForNewAnimatables), targetConverter);
                container.dispose();
                scene.onAnimationFileImportedObservable.notifyObservers(scene);
                if (onSuccess) {
                    onSuccess(scene);
                }
            };
            this.LoadAssetContainer(rootUrl, sceneFilename, scene, onAssetContainerLoaded, onProgress, onError, pluginExtension);
        }
        /**
         * Import animations from a file into a scene
         * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
         * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
         * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
         * @param overwriteAnimations when true, animations are cleaned before importing new ones. Animations are appended otherwise
         * @param animationGroupLoadingMode defines how to handle old animations groups before importing new ones
         * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
         * @param onSuccess a callback with the scene when import succeeds
         * @param onProgress a callback with a progress event for each file being loaded
         * @param onError a callback with the scene, a message, and possibly an exception when import fails
         * @param pluginExtension the extension used to determine the plugin
         * @returns the updated scene with imported animations
         */
        static ImportAnimationsAsync(rootUrl, sceneFilename = "", scene = EngineStore.LastCreatedScene, overwriteAnimations = true, animationGroupLoadingMode = SceneLoaderAnimationGroupLoadingMode.Clean, targetConverter = null, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onSuccess = null, onProgress = null, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onError = null, pluginExtension = null) {
            return new Promise((resolve, reject) => {
                SceneLoader.ImportAnimations(rootUrl, sceneFilename, scene, overwriteAnimations, animationGroupLoadingMode, targetConverter, (_scene) => {
                    resolve(_scene);
                }, onProgress, (_scene, message, exception) => {
                    reject(exception || new Error(message));
                }, pluginExtension);
            });
        }
    }
    /**
     * No logging while loading
     */
    SceneLoader.NO_LOGGING = 0;
    /**
     * Minimal logging while loading
     */
    SceneLoader.MINIMAL_LOGGING = 1;
    /**
     * Summary logging while loading
     */
    SceneLoader.SUMMARY_LOGGING = 2;
    /**
     * Detailed logging while loading
     */
    SceneLoader.DETAILED_LOGGING = 3;
    // Members
    /**
     * Event raised when a plugin is used to load a scene
     */
    SceneLoader.OnPluginActivatedObservable = new Observable$1();
    SceneLoader._RegisteredPlugins = {};
    SceneLoader._ShowingLoadingScreen = false;

    /**
     * An Abstract Motion controller
     * This class receives an xrInput and a profile layout and uses those to initialize the components
     * Each component has an observable to check for changes in value and state
     */
    class WebXRAbstractMotionController {
        /**
         * constructs a new abstract motion controller
         * @param scene the scene to which the model of the controller will be added
         * @param layout The profile layout to load
         * @param gamepadObject The gamepad object correlating to this controller
         * @param handedness handedness (left/right/none) of this controller
         * @param _doNotLoadControllerMesh set this flag to ignore the mesh loading
         * @param _controllerCache a cache holding controller models already loaded in this session
         */
        constructor(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        scene, 
        // eslint-disable-next-line @typescript-eslint/naming-convention
        layout, 
        /**
         * The gamepad object correlating to this controller
         */
        gamepadObject, 
        /**
         * handedness (left/right/none) of this controller
         */
        handedness, 
        /**
         * @internal
         */
        _doNotLoadControllerMesh = false, _controllerCache) {
            this.scene = scene;
            this.layout = layout;
            this.gamepadObject = gamepadObject;
            this.handedness = handedness;
            this._doNotLoadControllerMesh = _doNotLoadControllerMesh;
            this._controllerCache = _controllerCache;
            this._initComponent = (id) => {
                if (!id) {
                    return;
                }
                const componentDef = this.layout.components[id];
                const type = componentDef.type;
                const buttonIndex = componentDef.gamepadIndices.button;
                // search for axes
                const axes = [];
                if (componentDef.gamepadIndices.xAxis !== undefined && componentDef.gamepadIndices.yAxis !== undefined) {
                    axes.push(componentDef.gamepadIndices.xAxis, componentDef.gamepadIndices.yAxis);
                }
                this.components[id] = new WebXRControllerComponent(id, type, buttonIndex, axes);
            };
            this._modelReady = false;
            /**
             * A map of components (WebXRControllerComponent) in this motion controller
             * Components have a ComponentType and can also have both button and axis definitions
             */
            this.components = {};
            /**
             * Disable the model's animation. Can be set at any time.
             */
            this.disableAnimation = false;
            /**
             * Observers registered here will be triggered when the model of this controller is done loading
             */
            this.onModelLoadedObservable = new Observable$1();
            // initialize the components
            if (layout.components) {
                Object.keys(layout.components).forEach(this._initComponent);
            }
            // Model is loaded in WebXRInput
        }
        /**
         * Dispose this controller, the model mesh and all its components
         */
        dispose() {
            this.getComponentIds().forEach((id) => this.getComponent(id).dispose());
            if (this.rootMesh) {
                this.rootMesh.getChildren(undefined, true).forEach((node) => {
                    node.setEnabled(false);
                });
                this.rootMesh.dispose(!!this._controllerCache, !this._controllerCache);
            }
        }
        /**
         * Returns all components of specific type
         * @param type the type to search for
         * @returns an array of components with this type
         */
        getAllComponentsOfType(type) {
            return this.getComponentIds()
                .map((id) => this.components[id])
                .filter((component) => component.type === type);
        }
        /**
         * get a component based an its component id as defined in layout.components
         * @param id the id of the component
         * @returns the component correlates to the id or undefined if not found
         */
        getComponent(id) {
            return this.components[id];
        }
        /**
         * Get the list of components available in this motion controller
         * @returns an array of strings correlating to available components
         */
        getComponentIds() {
            return Object.keys(this.components);
        }
        /**
         * Get the first component of specific type
         * @param type type of component to find
         * @returns a controller component or null if not found
         */
        getComponentOfType(type) {
            return this.getAllComponentsOfType(type)[0] || null;
        }
        /**
         * Get the main (Select) component of this controller as defined in the layout
         * @returns the main component of this controller
         */
        getMainComponent() {
            return this.getComponent(this.layout.selectComponentId);
        }
        /**
         * Loads the model correlating to this controller
         * When the mesh is loaded, the onModelLoadedObservable will be triggered
         * @returns A promise fulfilled with the result of the model loading
         */
        async loadModel() {
            const useGeneric = !this._getModelLoadingConstraints();
            let loadingParams = this._getGenericFilenameAndPath();
            // Checking if GLB loader is present
            if (useGeneric) {
                Logger.Warn("Falling back to generic models");
            }
            else {
                loadingParams = this._getFilenameAndPath();
            }
            return new Promise((resolve, reject) => {
                const meshesLoaded = (meshes) => {
                    if (useGeneric) {
                        this._getGenericParentMesh(meshes);
                    }
                    else {
                        this._setRootMesh(meshes);
                    }
                    this._processLoadedModel(meshes);
                    this._modelReady = true;
                    this.onModelLoadedObservable.notifyObservers(this);
                    resolve(true);
                };
                if (this._controllerCache) {
                    // look for it in the cache
                    const found = this._controllerCache.filter((c) => {
                        return c.filename === loadingParams.filename && c.path === loadingParams.path;
                    });
                    if (found[0]) {
                        found[0].meshes.forEach((mesh) => mesh.setEnabled(true));
                        meshesLoaded(found[0].meshes);
                        return;
                        // found, don't continue to load
                    }
                }
                SceneLoader.ImportMesh("", loadingParams.path, loadingParams.filename, this.scene, (meshes) => {
                    if (this._controllerCache) {
                        this._controllerCache.push(Object.assign(Object.assign({}, loadingParams), { meshes }));
                    }
                    meshesLoaded(meshes);
                }, null, (_scene, message) => {
                    Logger.Log(message);
                    Logger.Warn(`Failed to retrieve controller model of type ${this.profileId} from the remote server: ${loadingParams.path}${loadingParams.filename}`);
                    reject(message);
                });
            });
        }
        /**
         * Update this model using the current XRFrame
         * @param xrFrame the current xr frame to use and update the model
         */
        updateFromXRFrame(xrFrame) {
            this.getComponentIds().forEach((id) => this.getComponent(id).update(this.gamepadObject));
            this.updateModel(xrFrame);
        }
        /**
         * Backwards compatibility due to a deeply-integrated typo
         */
        get handness() {
            return this.handedness;
        }
        /**
         * Pulse (vibrate) this controller
         * If the controller does not support pulses, this function will fail silently and return Promise<false> directly after called
         * Consecutive calls to this function will cancel the last pulse call
         *
         * @param value the strength of the pulse in 0.0...1.0 range
         * @param duration Duration of the pulse in milliseconds
         * @param hapticActuatorIndex optional index of actuator (will usually be 0)
         * @returns a promise that will send true when the pulse has ended and false if the device doesn't support pulse or an error accrued
         */
        pulse(value, duration, hapticActuatorIndex = 0) {
            if (this.gamepadObject.hapticActuators && this.gamepadObject.hapticActuators[hapticActuatorIndex]) {
                return this.gamepadObject.hapticActuators[hapticActuatorIndex].pulse(value, duration);
            }
            else {
                return Promise.resolve(false);
            }
        }
        // Look through all children recursively. This will return null if no mesh exists with the given name.
        _getChildByName(node, name) {
            return node.getChildren((n) => n.name === name, false)[0];
        }
        // Look through only immediate children. This will return null if no mesh exists with the given name.
        _getImmediateChildByName(node, name) {
            return node.getChildren((n) => n.name == name, true)[0];
        }
        /**
         * Moves the axis on the controller mesh based on its current state
         * @param axisMap
         * @param axisValue the value of the axis which determines the meshes new position
         * @internal
         */
        _lerpTransform(axisMap, axisValue, fixValueCoordinates) {
            if (!axisMap.minMesh || !axisMap.maxMesh || !axisMap.valueMesh) {
                return;
            }
            if (!axisMap.minMesh.rotationQuaternion || !axisMap.maxMesh.rotationQuaternion || !axisMap.valueMesh.rotationQuaternion) {
                return;
            }
            // Convert from gamepad value range (-1 to +1) to lerp range (0 to 1)
            const lerpValue = fixValueCoordinates ? axisValue * 0.5 + 0.5 : axisValue;
            Quaternion.SlerpToRef(axisMap.minMesh.rotationQuaternion, axisMap.maxMesh.rotationQuaternion, lerpValue, axisMap.valueMesh.rotationQuaternion);
            Vector3.LerpToRef(axisMap.minMesh.position, axisMap.maxMesh.position, lerpValue, axisMap.valueMesh.position);
        }
        /**
         * Update the model itself with the current frame data
         * @param xrFrame the frame to use for updating the model mesh
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        updateModel(xrFrame) {
            if (!this._modelReady) {
                return;
            }
            this._updateModel(xrFrame);
        }
        _getGenericFilenameAndPath() {
            return {
                filename: "generic.babylon",
                path: "https://controllers.babylonjs.com/generic/",
            };
        }
        _getGenericParentMesh(meshes) {
            this.rootMesh = new Mesh(this.profileId + " " + this.handedness, this.scene);
            meshes.forEach((mesh) => {
                if (!mesh.parent) {
                    mesh.isPickable = false;
                    mesh.setParent(this.rootMesh);
                }
            });
            this.rootMesh.rotationQuaternion = Quaternion.FromEulerAngles(0, Math.PI, 0);
        }
    }

    /**
     * A generic trigger-only motion controller for WebXR
     */
    class WebXRGenericTriggerMotionController extends WebXRAbstractMotionController {
        constructor(scene, gamepadObject, handedness) {
            super(scene, GenericTriggerLayout[handedness], gamepadObject, handedness);
            this.profileId = WebXRGenericTriggerMotionController.ProfileId;
        }
        _getFilenameAndPath() {
            return {
                filename: "generic.babylon",
                path: "https://controllers.babylonjs.com/generic/",
            };
        }
        _getModelLoadingConstraints() {
            return true;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _processLoadedModel(meshes) {
            // nothing to do
        }
        _setRootMesh(meshes) {
            this.rootMesh = new Mesh(this.profileId + " " + this.handedness, this.scene);
            meshes.forEach((mesh) => {
                mesh.isPickable = false;
                if (!mesh.parent) {
                    mesh.setParent(this.rootMesh);
                }
            });
            this.rootMesh.rotationQuaternion = Quaternion.FromEulerAngles(0, Math.PI, 0);
        }
        _updateModel() {
            // no-op
        }
    }
    /**
     * Static version of the profile id of this controller
     */
    WebXRGenericTriggerMotionController.ProfileId = "generic-trigger";
    // https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/generic/generic-trigger-touchpad-thumbstick.json
    const GenericTriggerLayout = {
        left: {
            selectComponentId: "xr-standard-trigger",
            components: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "xr-standard-trigger": {
                    type: "trigger",
                    gamepadIndices: {
                        button: 0,
                    },
                    rootNodeName: "xr_standard_trigger",
                    visualResponses: {},
                },
            },
            gamepadMapping: "xr-standard",
            rootNodeName: "generic-trigger-left",
            assetPath: "left.glb",
        },
        right: {
            selectComponentId: "xr-standard-trigger",
            components: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "xr-standard-trigger": {
                    type: "trigger",
                    gamepadIndices: {
                        button: 0,
                    },
                    rootNodeName: "xr_standard_trigger",
                    visualResponses: {},
                },
            },
            gamepadMapping: "xr-standard",
            rootNodeName: "generic-trigger-right",
            assetPath: "right.glb",
        },
        none: {
            selectComponentId: "xr-standard-trigger",
            components: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "xr-standard-trigger": {
                    type: "trigger",
                    gamepadIndices: {
                        button: 0,
                    },
                    rootNodeName: "xr_standard_trigger",
                    visualResponses: {},
                },
            },
            gamepadMapping: "xr-standard",
            rootNodeName: "generic-trigger-none",
            assetPath: "none.glb",
        },
    };

    /**
     * Creates the VertexData for an ellipsoid, defaults to a sphere
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * segments sets the number of horizontal strips optional, default 32
     * * diameter sets the axes dimensions, diameterX, diameterY and diameterZ to the value of diameter, optional default 1
     * * diameterX sets the diameterX (x direction) of the ellipsoid, overwrites the diameterX set by diameter, optional, default diameter
     * * diameterY sets the diameterY (y direction) of the ellipsoid, overwrites the diameterY set by diameter, optional, default diameter
     * * diameterZ sets the diameterZ (z direction) of the ellipsoid, overwrites the diameterZ set by diameter, optional, default diameter
     * * arc a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the circumference (latitude) given by the arc value, optional, default 1
     * * slice a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the height (latitude) given by the arc value, optional, default 1
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.segments
     * @param options.diameter
     * @param options.diameterX
     * @param options.diameterY
     * @param options.diameterZ
     * @param options.arc
     * @param options.slice
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.dedupTopBottomIndices
     * @returns the VertexData of the ellipsoid
     */
    function CreateSphereVertexData(options) {
        const segments = (options.segments || 32) | 0;
        const diameterX = options.diameterX || options.diameter || 1;
        const diameterY = options.diameterY || options.diameter || 1;
        const diameterZ = options.diameterZ || options.diameter || 1;
        const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
        const slice = options.slice && options.slice <= 0 ? 1.0 : options.slice || 1.0;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const dedupTopBottomIndices = !!options.dedupTopBottomIndices;
        const radius = new Vector3(diameterX / 2, diameterY / 2, diameterZ / 2);
        const totalZRotationSteps = 2 + segments;
        const totalYRotationSteps = 2 * totalZRotationSteps;
        const indices = [];
        const positions = [];
        const normals = [];
        const uvs = [];
        for (let zRotationStep = 0; zRotationStep <= totalZRotationSteps; zRotationStep++) {
            const normalizedZ = zRotationStep / totalZRotationSteps;
            const angleZ = normalizedZ * Math.PI * slice;
            for (let yRotationStep = 0; yRotationStep <= totalYRotationSteps; yRotationStep++) {
                const normalizedY = yRotationStep / totalYRotationSteps;
                const angleY = normalizedY * Math.PI * 2 * arc;
                const rotationZ = Matrix.RotationZ(-angleZ);
                const rotationY = Matrix.RotationY(angleY);
                const afterRotZ = Vector3.TransformCoordinates(Vector3.Up(), rotationZ);
                const complete = Vector3.TransformCoordinates(afterRotZ, rotationY);
                const vertex = complete.multiply(radius);
                const normal = complete.divide(radius).normalize();
                positions.push(vertex.x, vertex.y, vertex.z);
                normals.push(normal.x, normal.y, normal.z);
                uvs.push(normalizedY, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - normalizedZ : normalizedZ);
            }
            if (zRotationStep > 0) {
                const verticesCount = positions.length / 3;
                for (let firstIndex = verticesCount - 2 * (totalYRotationSteps + 1); firstIndex + totalYRotationSteps + 2 < verticesCount; firstIndex++) {
                    if (dedupTopBottomIndices) {
                        if (zRotationStep > 1) {
                            indices.push(firstIndex);
                            indices.push(firstIndex + 1);
                            indices.push(firstIndex + totalYRotationSteps + 1);
                        }
                        if (zRotationStep < totalZRotationSteps || slice < 1.0) {
                            indices.push(firstIndex + totalYRotationSteps + 1);
                            indices.push(firstIndex + 1);
                            indices.push(firstIndex + totalYRotationSteps + 2);
                        }
                    }
                    else {
                        indices.push(firstIndex);
                        indices.push(firstIndex + 1);
                        indices.push(firstIndex + totalYRotationSteps + 1);
                        indices.push(firstIndex + totalYRotationSteps + 1);
                        indices.push(firstIndex + 1);
                        indices.push(firstIndex + totalYRotationSteps + 2);
                    }
                }
            }
        }
        // Sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a sphere mesh
     * * The parameter `diameter` sets the diameter size (float) of the sphere (default 1)
     * * You can set some different sphere dimensions, for instance to build an ellipsoid, by using the parameters `diameterX`, `diameterY` and `diameterZ` (all by default have the same value of `diameter`)
     * * The parameter `segments` sets the sphere number of horizontal stripes (positive integer, default 32)
     * * You can create an unclosed sphere with the parameter `arc` (positive float, default 1), valued between 0 and 1, what is the ratio of the circumference (latitude) : 2 x PI x ratio
     * * You can create an unclosed sphere on its height with the parameter `slice` (positive float, default1), valued between 0 and 1, what is the height ratio (longitude)
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.segments
     * @param options.diameter
     * @param options.diameterX
     * @param options.diameterY
     * @param options.diameterZ
     * @param options.arc
     * @param options.slice
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the sphere mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#sphere
     */
    function CreateSphere(name, options = {}, scene = null) {
        const sphere = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        sphere._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateSphereVertexData(options);
        vertexData.applyToMesh(sphere, options.updatable);
        return sphere;
    }
    /**
     * Class containing static functions to help procedurally build meshes
     * @deprecated use CreateSphere directly
     */
    const SphereBuilder = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreateSphere,
    };
    VertexData.CreateSphere = CreateSphereVertexData;
    Mesh.CreateSphere = (name, segments, diameter, scene, updatable, sideOrientation) => {
        const options = {
            segments: segments,
            diameterX: diameter,
            diameterY: diameter,
            diameterZ: diameter,
            sideOrientation: sideOrientation,
            updatable: updatable,
        };
        return CreateSphere(name, options, scene);
    };

    /**
     * A profiled motion controller has its profile loaded from an online repository.
     * The class is responsible of loading the model, mapping the keys and enabling model-animations
     */
    class WebXRProfiledMotionController extends WebXRAbstractMotionController {
        constructor(scene, xrInput, _profile, _repositoryUrl, 
        // eslint-disable-next-line @typescript-eslint/naming-convention
        controllerCache) {
            super(scene, _profile.layouts[xrInput.handedness || "none"], xrInput.gamepad, xrInput.handedness, undefined, controllerCache);
            this._repositoryUrl = _repositoryUrl;
            this.controllerCache = controllerCache;
            this._buttonMeshMapping = {};
            this._touchDots = {};
            this.profileId = _profile.profileId;
        }
        dispose() {
            super.dispose();
            if (!this.controllerCache) {
                Object.keys(this._touchDots).forEach((visResKey) => {
                    this._touchDots[visResKey].dispose();
                });
            }
        }
        _getFilenameAndPath() {
            return {
                filename: this.layout.assetPath,
                path: `${this._repositoryUrl}/profiles/${this.profileId}/`,
            };
        }
        _getModelLoadingConstraints() {
            const glbLoaded = SceneLoader.IsPluginForExtensionAvailable(".glb");
            if (!glbLoaded) {
                Logger.Warn("glTF / glb loader was not registered, using generic controller instead");
            }
            return glbLoaded;
        }
        _processLoadedModel(_meshes) {
            this.getComponentIds().forEach((type) => {
                const componentInLayout = this.layout.components[type];
                this._buttonMeshMapping[type] = {
                    mainMesh: this._getChildByName(this.rootMesh, componentInLayout.rootNodeName),
                    states: {},
                };
                Object.keys(componentInLayout.visualResponses).forEach((visualResponseKey) => {
                    const visResponse = componentInLayout.visualResponses[visualResponseKey];
                    if (visResponse.valueNodeProperty === "transform") {
                        this._buttonMeshMapping[type].states[visualResponseKey] = {
                            valueMesh: this._getChildByName(this.rootMesh, visResponse.valueNodeName),
                            minMesh: this._getChildByName(this.rootMesh, visResponse.minNodeName),
                            maxMesh: this._getChildByName(this.rootMesh, visResponse.maxNodeName),
                        };
                    }
                    else {
                        // visibility, usually for touchpads
                        const nameOfMesh = componentInLayout.type === WebXRControllerComponent.TOUCHPAD_TYPE && componentInLayout.touchPointNodeName
                            ? componentInLayout.touchPointNodeName
                            : visResponse.valueNodeName;
                        this._buttonMeshMapping[type].states[visualResponseKey] = {
                            valueMesh: this._getChildByName(this.rootMesh, nameOfMesh),
                        };
                        if (componentInLayout.type === WebXRControllerComponent.TOUCHPAD_TYPE && !this._touchDots[visualResponseKey]) {
                            const dot = CreateSphere(visualResponseKey + "dot", {
                                diameter: 0.0015,
                                segments: 8,
                            }, this.scene);
                            dot.material = new StandardMaterial(visualResponseKey + "mat", this.scene);
                            dot.material.diffuseColor = Color3.Red();
                            dot.parent = this._buttonMeshMapping[type].states[visualResponseKey].valueMesh || null;
                            dot.isVisible = false;
                            this._touchDots[visualResponseKey] = dot;
                        }
                    }
                });
            });
        }
        _setRootMesh(meshes) {
            this.rootMesh = new Mesh(this.profileId + "-" + this.handedness, this.scene);
            this.rootMesh.isPickable = false;
            let rootMesh;
            // Find the root node in the loaded glTF scene, and attach it as a child of 'parentMesh'
            for (let i = 0; i < meshes.length; i++) {
                const mesh = meshes[i];
                mesh.isPickable = false;
                if (!mesh.parent) {
                    // Handle root node, attach to the new parentMesh
                    rootMesh = mesh;
                }
            }
            if (rootMesh) {
                rootMesh.setParent(this.rootMesh);
            }
            if (!this.scene.useRightHandedSystem) {
                this.rootMesh.rotate(Axis.Y, Math.PI, Space.WORLD);
            }
        }
        _updateModel(_xrFrame) {
            if (this.disableAnimation) {
                return;
            }
            this.getComponentIds().forEach((id) => {
                const component = this.getComponent(id);
                if (!component.hasChanges) {
                    return;
                }
                const meshes = this._buttonMeshMapping[id];
                const componentInLayout = this.layout.components[id];
                Object.keys(componentInLayout.visualResponses).forEach((visualResponseKey) => {
                    const visResponse = componentInLayout.visualResponses[visualResponseKey];
                    let value = component.value;
                    if (visResponse.componentProperty === "xAxis") {
                        value = component.axes.x;
                    }
                    else if (visResponse.componentProperty === "yAxis") {
                        value = component.axes.y;
                    }
                    if (visResponse.valueNodeProperty === "transform") {
                        this._lerpTransform(meshes.states[visualResponseKey], value, visResponse.componentProperty !== "button");
                    }
                    else {
                        // visibility
                        const valueMesh = meshes.states[visualResponseKey].valueMesh;
                        if (valueMesh) {
                            valueMesh.isVisible = component.touched || component.pressed;
                        }
                        if (this._touchDots[visualResponseKey]) {
                            this._touchDots[visualResponseKey].isVisible = component.touched || component.pressed;
                        }
                    }
                });
            });
        }
    }

    /**
     * The MotionController Manager manages all registered motion controllers and loads the right one when needed.
     *
     * When this repository is complete: https://github.com/immersive-web/webxr-input-profiles/tree/master/packages/assets
     * it should be replaced with auto-loaded controllers.
     *
     * When using a model try to stay as generic as possible. Eventually there will be no need in any of the controller classes
     */
    const controllerCache = [];
    /**
     * Motion controller manager is managing the different webxr profiles and makes sure the right
     * controller is being loaded.
     */
    class WebXRMotionControllerManager {
        /**
         * Clear the cache used for profile loading and reload when requested again
         */
        static ClearProfilesCache() {
            this._ProfilesList = null;
            this._ProfileLoadingPromises = {};
        }
        /**
         * Register the default fallbacks.
         * This function is called automatically when this file is imported.
         */
        static DefaultFallbacks() {
            this.RegisterFallbacksForProfileId("google-daydream", ["generic-touchpad"]);
            this.RegisterFallbacksForProfileId("htc-vive-focus", ["generic-trigger-touchpad"]);
            this.RegisterFallbacksForProfileId("htc-vive", ["generic-trigger-squeeze-touchpad"]);
            this.RegisterFallbacksForProfileId("magicleap-one", ["generic-trigger-squeeze-touchpad"]);
            this.RegisterFallbacksForProfileId("windows-mixed-reality", ["generic-trigger-squeeze-touchpad-thumbstick"]);
            this.RegisterFallbacksForProfileId("microsoft-mixed-reality", ["windows-mixed-reality", "generic-trigger-squeeze-touchpad-thumbstick"]);
            this.RegisterFallbacksForProfileId("oculus-go", ["generic-trigger-touchpad"]);
            this.RegisterFallbacksForProfileId("oculus-touch-v2", ["oculus-touch", "generic-trigger-squeeze-thumbstick"]);
            this.RegisterFallbacksForProfileId("oculus-touch", ["generic-trigger-squeeze-thumbstick"]);
            this.RegisterFallbacksForProfileId("samsung-gearvr", ["windows-mixed-reality", "generic-trigger-squeeze-touchpad-thumbstick"]);
            this.RegisterFallbacksForProfileId("samsung-odyssey", ["generic-touchpad"]);
            this.RegisterFallbacksForProfileId("valve-index", ["generic-trigger-squeeze-touchpad-thumbstick"]);
            this.RegisterFallbacksForProfileId("generic-hand-select", ["generic-trigger"]);
        }
        /**
         * Find a fallback profile if the profile was not found. There are a few predefined generic profiles.
         * @param profileId the profile to which a fallback needs to be found
         * @returns an array with corresponding fallback profiles
         */
        static FindFallbackWithProfileId(profileId) {
            const returnArray = this._Fallbacks[profileId] || [];
            returnArray.unshift(profileId);
            return returnArray;
        }
        /**
         * When acquiring a new xrInput object (usually by the WebXRInput class), match it with the correct profile.
         * The order of search:
         *
         * 1) Iterate the profiles array of the xr input and try finding a corresponding motion controller
         * 2) (If not found) search in the gamepad id and try using it (legacy versions only)
         * 3) search for registered fallbacks (should be redundant, nonetheless it makes sense to check)
         * 4) return the generic trigger controller if none were found
         *
         * @param xrInput the xrInput to which a new controller is initialized
         * @param scene the scene to which the model will be added
         * @param forceProfile force a certain profile for this controller
         * @returns A promise that fulfils with the motion controller class for this profile id or the generic standard class if none was found
         */
        static GetMotionControllerWithXRInput(xrInput, scene, forceProfile) {
            const profileArray = [];
            if (forceProfile) {
                profileArray.push(forceProfile);
            }
            profileArray.push(...(xrInput.profiles || []));
            // emulator support
            if (profileArray.length && !profileArray[0]) {
                // remove the first "undefined" that the emulator is adding
                profileArray.pop();
            }
            // legacy support - try using the gamepad id
            if (xrInput.gamepad && xrInput.gamepad.id) {
                switch (xrInput.gamepad.id) {
                    case xrInput.gamepad.id.match(/oculus touch/gi) ? xrInput.gamepad.id : undefined:
                        // oculus in gamepad id
                        profileArray.push("oculus-touch-v2");
                        break;
                }
            }
            // make sure microsoft/windows mixed reality works correctly
            const windowsMRIdx = profileArray.indexOf("windows-mixed-reality");
            if (windowsMRIdx !== -1) {
                profileArray.splice(windowsMRIdx, 0, "microsoft-mixed-reality");
            }
            if (!profileArray.length) {
                profileArray.push("generic-trigger");
            }
            if (this.UseOnlineRepository) {
                const firstFunction = this.PrioritizeOnlineRepository ? this._LoadProfileFromRepository : this._LoadProfilesFromAvailableControllers;
                const secondFunction = this.PrioritizeOnlineRepository ? this._LoadProfilesFromAvailableControllers : this._LoadProfileFromRepository;
                return firstFunction.call(this, profileArray, xrInput, scene).catch(() => {
                    return secondFunction.call(this, profileArray, xrInput, scene);
                });
            }
            else {
                // use only available functions
                return this._LoadProfilesFromAvailableControllers(profileArray, xrInput, scene);
            }
        }
        /**
         * Register a new controller based on its profile. This function will be called by the controller classes themselves.
         *
         * If you are missing a profile, make sure it is imported in your source, otherwise it will not register.
         *
         * @param type the profile type to register
         * @param constructFunction the function to be called when loading this profile
         */
        static RegisterController(type, constructFunction) {
            this._AvailableControllers[type] = constructFunction;
        }
        /**
         * Register a fallback to a specific profile.
         * @param profileId the profileId that will receive the fallbacks
         * @param fallbacks A list of fallback profiles
         */
        static RegisterFallbacksForProfileId(profileId, fallbacks) {
            if (this._Fallbacks[profileId]) {
                this._Fallbacks[profileId].push(...fallbacks);
            }
            else {
                this._Fallbacks[profileId] = fallbacks;
            }
        }
        /**
         * Will update the list of profiles available in the repository
         * @returns a promise that resolves to a map of profiles available online
         */
        static UpdateProfilesList() {
            this._ProfilesList = Tools.LoadFileAsync(this.BaseRepositoryUrl + "/profiles/profilesList.json", false).then((data) => {
                return JSON.parse(data.toString());
            });
            return this._ProfilesList;
        }
        /**
         * Clear the controller's cache (usually happens at the end of a session)
         */
        static ClearControllerCache() {
            controllerCache.forEach((cacheItem) => {
                cacheItem.meshes.forEach((mesh) => {
                    mesh.dispose(false, true);
                });
            });
            controllerCache.length = 0;
        }
        static _LoadProfileFromRepository(profileArray, xrInput, scene) {
            return Promise.resolve()
                .then(() => {
                if (!this._ProfilesList) {
                    return this.UpdateProfilesList();
                }
                else {
                    return this._ProfilesList;
                }
            })
                .then((profilesList) => {
                // load the right profile
                for (let i = 0; i < profileArray.length; ++i) {
                    // defensive
                    if (!profileArray[i]) {
                        continue;
                    }
                    if (profilesList[profileArray[i]]) {
                        return profileArray[i];
                    }
                }
                throw new Error(`neither controller ${profileArray[0]} nor all fallbacks were found in the repository,`);
            })
                .then((profileToLoad) => {
                // load the profile
                if (!this._ProfileLoadingPromises[profileToLoad]) {
                    this._ProfileLoadingPromises[profileToLoad] = Tools.LoadFileAsync(`${this.BaseRepositoryUrl}/profiles/${profileToLoad}/profile.json`, false).then((data) => JSON.parse(data));
                }
                return this._ProfileLoadingPromises[profileToLoad];
            })
                .then((profile) => {
                return new WebXRProfiledMotionController(scene, xrInput, profile, this.BaseRepositoryUrl, this.DisableControllerCache ? undefined : controllerCache);
            });
        }
        static _LoadProfilesFromAvailableControllers(profileArray, xrInput, scene) {
            // check fallbacks
            for (let i = 0; i < profileArray.length; ++i) {
                // defensive
                if (!profileArray[i]) {
                    continue;
                }
                const fallbacks = this.FindFallbackWithProfileId(profileArray[i]);
                for (let j = 0; j < fallbacks.length; ++j) {
                    const constructionFunction = this._AvailableControllers[fallbacks[j]];
                    if (constructionFunction) {
                        return Promise.resolve(constructionFunction(xrInput, scene));
                    }
                }
            }
            throw new Error(`no controller requested was found in the available controllers list`);
        }
    }
    WebXRMotionControllerManager._AvailableControllers = {};
    WebXRMotionControllerManager._Fallbacks = {};
    // cache for loading
    WebXRMotionControllerManager._ProfileLoadingPromises = {};
    /**
     * The base URL of the online controller repository. Can be changed at any time.
     */
    WebXRMotionControllerManager.BaseRepositoryUrl = "https://immersive-web.github.io/webxr-input-profiles/packages/viewer/dist";
    /**
     * Which repository gets priority - local or online
     */
    WebXRMotionControllerManager.PrioritizeOnlineRepository = true;
    /**
     * Use the online repository, or use only locally-defined controllers
     */
    WebXRMotionControllerManager.UseOnlineRepository = true;
    /**
     * Disable the controller cache and load the models each time a new WebXRProfileMotionController is loaded.
     * Defaults to true.
     */
    WebXRMotionControllerManager.DisableControllerCache = true;
    // register the generic profile(s) here so we will at least have them
    WebXRMotionControllerManager.RegisterController(WebXRGenericTriggerMotionController.ProfileId, (xrInput, scene) => {
        return new WebXRGenericTriggerMotionController(scene, xrInput.gamepad, xrInput.handedness);
    });
    // register fallbacks
    WebXRMotionControllerManager.DefaultFallbacks();

    let idCount = 0;
    /**
     * Represents an XR controller
     */
    class WebXRInputSource {
        /**
         * Creates the input source object
         * @see https://doc.babylonjs.com/features/featuresDeepDive/webXR/webXRInputControllerSupport
         * @param _scene the scene which the controller should be associated to
         * @param inputSource the underlying input source for the controller
         * @param _options options for this controller creation
         */
        constructor(_scene, 
        /** The underlying input source for the controller  */
        inputSource, _options = {}) {
            this._scene = _scene;
            this.inputSource = inputSource;
            this._options = _options;
            this._tmpVector = new Vector3();
            this._disposed = false;
            /**
             * Event that fires when the controller is removed/disposed.
             * The object provided as event data is this controller, after associated assets were disposed.
             * uniqueId is still available.
             */
            this.onDisposeObservable = new Observable$1();
            /**
             * Will be triggered when the mesh associated with the motion controller is done loading.
             * It is also possible that this will never trigger (!) if no mesh was loaded, or if the developer decides to load a different mesh
             * A shortened version of controller -> motion controller -> on mesh loaded.
             */
            this.onMeshLoadedObservable = new Observable$1();
            /**
             * Observers registered here will trigger when a motion controller profile was assigned to this xr controller
             */
            this.onMotionControllerInitObservable = new Observable$1();
            this._uniqueId = `controller-${idCount++}-${inputSource.targetRayMode}-${inputSource.handedness}`;
            this.pointer = new AbstractMesh(`${this._uniqueId}-pointer`, _scene);
            this.pointer.rotationQuaternion = new Quaternion();
            if (this.inputSource.gripSpace) {
                this.grip = new AbstractMesh(`${this._uniqueId}-grip`, this._scene);
                this.grip.rotationQuaternion = new Quaternion();
            }
            this._tmpVector.set(0, 0, this._scene.useRightHandedSystem ? -1.0 : 1.0);
            // for now only load motion controllers if gamepad object available
            if (this.inputSource.gamepad && this.inputSource.targetRayMode === "tracked-pointer") {
                WebXRMotionControllerManager.GetMotionControllerWithXRInput(inputSource, _scene, this._options.forceControllerProfile).then((motionController) => {
                    this.motionController = motionController;
                    this.onMotionControllerInitObservable.notifyObservers(motionController);
                    // should the model be loaded?
                    if (!this._options.doNotLoadControllerMesh && !this.motionController._doNotLoadControllerMesh) {
                        this.motionController.loadModel().then((success) => {
                            var _a;
                            if (success && this.motionController && this.motionController.rootMesh) {
                                if (this._options.renderingGroupId) {
                                    // anything other than 0?
                                    this.motionController.rootMesh.renderingGroupId = this._options.renderingGroupId;
                                    this.motionController.rootMesh.getChildMeshes(false).forEach((mesh) => (mesh.renderingGroupId = this._options.renderingGroupId));
                                }
                                this.onMeshLoadedObservable.notifyObservers(this.motionController.rootMesh);
                                this.motionController.rootMesh.parent = this.grip || this.pointer;
                                this.motionController.disableAnimation = !!this._options.disableMotionControllerAnimation;
                            }
                            // make sure to dispose is the controller is already disposed
                            if (this._disposed) {
                                (_a = this.motionController) === null || _a === void 0 ? void 0 : _a.dispose();
                            }
                        });
                    }
                }, () => {
                    Tools.Warn(`Could not find a matching motion controller for the registered input source`);
                });
            }
        }
        /**
         * Get this controllers unique id
         */
        get uniqueId() {
            return this._uniqueId;
        }
        /**
         * Disposes of the object
         */
        dispose() {
            if (this.grip) {
                this.grip.dispose(true);
            }
            if (this.motionController) {
                this.motionController.dispose();
            }
            this.pointer.dispose(true);
            this.onMotionControllerInitObservable.clear();
            this.onMeshLoadedObservable.clear();
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
            this._disposed = true;
        }
        /**
         * Gets a world space ray coming from the pointer or grip
         * @param result the resulting ray
         * @param gripIfAvailable use the grip mesh instead of the pointer, if available
         */
        getWorldPointerRayToRef(result, gripIfAvailable = false) {
            const object = gripIfAvailable && this.grip ? this.grip : this.pointer;
            Vector3.TransformNormalToRef(this._tmpVector, object.getWorldMatrix(), result.direction);
            result.direction.normalize();
            result.origin.copyFrom(object.absolutePosition);
            result.length = 1000;
        }
        /**
         * Updates the controller pose based on the given XRFrame
         * @param xrFrame xr frame to update the pose with
         * @param referenceSpace reference space to use
         * @param xrCamera the xr camera, used for parenting
         */
        updateFromXRFrame(xrFrame, referenceSpace, xrCamera) {
            const pose = xrFrame.getPose(this.inputSource.targetRaySpace, referenceSpace);
            this._lastXRPose = pose;
            // Update the pointer mesh
            if (pose) {
                const pos = pose.transform.position;
                this.pointer.position.set(pos.x, pos.y, pos.z);
                const orientation = pose.transform.orientation;
                this.pointer.rotationQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
                if (!this._scene.useRightHandedSystem) {
                    this.pointer.position.z *= -1;
                    this.pointer.rotationQuaternion.z *= -1;
                    this.pointer.rotationQuaternion.w *= -1;
                }
                this.pointer.parent = xrCamera.parent;
            }
            // Update the grip mesh if it exists
            if (this.inputSource.gripSpace && this.grip) {
                const pose = xrFrame.getPose(this.inputSource.gripSpace, referenceSpace);
                if (pose) {
                    const pos = pose.transform.position;
                    const orientation = pose.transform.orientation;
                    this.grip.position.set(pos.x, pos.y, pos.z);
                    this.grip.rotationQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
                    if (!this._scene.useRightHandedSystem) {
                        this.grip.position.z *= -1;
                        this.grip.rotationQuaternion.z *= -1;
                        this.grip.rotationQuaternion.w *= -1;
                    }
                }
                this.grip.parent = xrCamera.parent;
            }
            if (this.motionController) {
                // either update buttons only or also position, if in gamepad mode
                this.motionController.updateFromXRFrame(xrFrame);
            }
        }
    }

    /**
     * XR input used to track XR inputs such as controllers/rays
     */
    class WebXRInput {
        /**
         * Initializes the WebXRInput
         * @param xrSessionManager the xr session manager for this session
         * @param xrCamera the WebXR camera for this session. Mainly used for teleportation
         * @param _options = initialization options for this xr input
         */
        constructor(
        /**
         * the xr session manager for this session
         */
        xrSessionManager, 
        /**
         * the WebXR camera for this session. Mainly used for teleportation
         */
        xrCamera, _options = {}) {
            this.xrSessionManager = xrSessionManager;
            this.xrCamera = xrCamera;
            this._options = _options;
            /**
             * XR controllers being tracked
             */
            this.controllers = [];
            /**
             * Event when a controller has been connected/added
             */
            this.onControllerAddedObservable = new Observable$1();
            /**
             * Event when a controller has been removed/disconnected
             */
            this.onControllerRemovedObservable = new Observable$1();
            this._onInputSourcesChange = (event) => {
                this._addAndRemoveControllers(event.added, event.removed);
            };
            // Remove controllers when exiting XR
            this._sessionEndedObserver = this.xrSessionManager.onXRSessionEnded.add(() => {
                this._addAndRemoveControllers([], this.controllers.map((c) => {
                    return c.inputSource;
                }));
            });
            this._sessionInitObserver = this.xrSessionManager.onXRSessionInit.add((session) => {
                session.addEventListener("inputsourceschange", this._onInputSourcesChange);
            });
            this._frameObserver = this.xrSessionManager.onXRFrameObservable.add((frame) => {
                // Update controller pose info
                this.controllers.forEach((controller) => {
                    controller.updateFromXRFrame(frame, this.xrSessionManager.referenceSpace, this.xrCamera);
                });
            });
            if (this._options.customControllersRepositoryURL) {
                WebXRMotionControllerManager.BaseRepositoryUrl = this._options.customControllersRepositoryURL;
            }
            WebXRMotionControllerManager.UseOnlineRepository = !this._options.disableOnlineControllerRepository;
            if (WebXRMotionControllerManager.UseOnlineRepository) {
                // pre-load the profiles list to load the controllers quicker afterwards
                try {
                    WebXRMotionControllerManager.UpdateProfilesList().catch(() => {
                        WebXRMotionControllerManager.UseOnlineRepository = false;
                    });
                }
                catch (e) {
                    WebXRMotionControllerManager.UseOnlineRepository = false;
                }
            }
        }
        _addAndRemoveControllers(addInputs, removeInputs) {
            // Add controllers if they don't already exist
            const sources = this.controllers.map((c) => {
                return c.inputSource;
            });
            for (const input of addInputs) {
                if (sources.indexOf(input) === -1) {
                    const controller = new WebXRInputSource(this.xrSessionManager.scene, input, Object.assign(Object.assign({}, (this._options.controllerOptions || {})), { forceControllerProfile: this._options.forceInputProfile, doNotLoadControllerMesh: this._options.doNotLoadControllerMeshes, disableMotionControllerAnimation: this._options.disableControllerAnimation }));
                    this.controllers.push(controller);
                    this.onControllerAddedObservable.notifyObservers(controller);
                }
            }
            // Remove and dispose of controllers to be disposed
            const keepControllers = [];
            const removedControllers = [];
            this.controllers.forEach((c) => {
                if (removeInputs.indexOf(c.inputSource) === -1) {
                    keepControllers.push(c);
                }
                else {
                    removedControllers.push(c);
                }
            });
            this.controllers = keepControllers;
            removedControllers.forEach((c) => {
                this.onControllerRemovedObservable.notifyObservers(c);
                c.dispose();
            });
        }
        /**
         * Disposes of the object
         */
        dispose() {
            this.controllers.forEach((c) => {
                c.dispose();
            });
            this.xrSessionManager.onXRFrameObservable.remove(this._frameObserver);
            this.xrSessionManager.onXRSessionInit.remove(this._sessionInitObserver);
            this.xrSessionManager.onXRSessionEnded.remove(this._sessionEndedObserver);
            this.onControllerAddedObservable.clear();
            this.onControllerRemovedObservable.clear();
            // clear the controller cache
            WebXRMotionControllerManager.ClearControllerCache();
        }
    }

    /**
     * This is the base class for all WebXR features.
     * Since most features require almost the same resources and callbacks, this class can be used to simplify the development
     * Note that since the features manager is using the `IWebXRFeature` you are in no way obligated to use this class
     */
    class WebXRAbstractFeature {
        /**
         * Construct a new (abstract) WebXR feature
         * @param _xrSessionManager the xr session manager for this feature
         */
        constructor(_xrSessionManager) {
            this._xrSessionManager = _xrSessionManager;
            this._attached = false;
            this._removeOnDetach = [];
            /**
             * Is this feature disposed?
             */
            this.isDisposed = false;
            /**
             * Should auto-attach be disabled?
             */
            this.disableAutoAttach = false;
            /**
             * The name of the native xr feature name (like anchor, hit-test, or hand-tracking)
             */
            this.xrNativeFeatureName = "";
        }
        /**
         * Is this feature attached
         */
        get attached() {
            return this._attached;
        }
        /**
         * attach this feature
         *
         * @param force should attachment be forced (even when already attached)
         * @returns true if successful, false is failed or already attached
         */
        attach(force) {
            // do not attach a disposed feature
            if (this.isDisposed) {
                return false;
            }
            if (!force) {
                if (this.attached) {
                    return false;
                }
            }
            else {
                if (this.attached) {
                    // detach first, to be sure
                    this.detach();
                }
            }
            this._attached = true;
            this._addNewAttachObserver(this._xrSessionManager.onXRFrameObservable, (frame) => this._onXRFrame(frame));
            return true;
        }
        /**
         * detach this feature.
         *
         * @returns true if successful, false if failed or already detached
         */
        detach() {
            if (!this._attached) {
                this.disableAutoAttach = true;
                return false;
            }
            this._attached = false;
            this._removeOnDetach.forEach((toRemove) => {
                toRemove.observable.remove(toRemove.observer);
            });
            return true;
        }
        /**
         * Dispose this feature and all of the resources attached
         */
        dispose() {
            this.detach();
            this.isDisposed = true;
        }
        /**
         * This function will be executed during before enabling the feature and can be used to not-allow enabling it.
         * Note that at this point the session has NOT started, so this is purely checking if the browser supports it
         *
         * @returns whether or not the feature is compatible in this environment
         */
        isCompatible() {
            return true;
        }
        /**
         * This is used to register callbacks that will automatically be removed when detach is called.
         * @param observable the observable to which the observer will be attached
         * @param callback the callback to register
         */
        _addNewAttachObserver(observable, callback) {
            this._removeOnDetach.push({
                observable,
                observer: observable.add(callback),
            });
        }
    }

    /**
     * Renders a layer on top of an existing scene
     */
    class UtilityLayerRenderer {
        /**
         * Gets the camera that is used to render the utility layer (when not set, this will be the last active camera)
         * @param getRigParentIfPossible if the current active camera is a rig camera, should its parent camera be returned
         * @returns the camera that is used when rendering the utility layer
         */
        getRenderCamera(getRigParentIfPossible) {
            if (this._renderCamera) {
                return this._renderCamera;
            }
            else {
                let activeCam;
                if (this.originalScene.activeCameras && this.originalScene.activeCameras.length > 1) {
                    activeCam = this.originalScene.activeCameras[this.originalScene.activeCameras.length - 1];
                }
                else {
                    activeCam = this.originalScene.activeCamera;
                }
                if (getRigParentIfPossible && activeCam && activeCam.isRigCamera) {
                    return activeCam.rigParent;
                }
                return activeCam;
            }
        }
        /**
         * Sets the camera that should be used when rendering the utility layer (If set to null the last active camera will be used)
         * @param cam the camera that should be used when rendering the utility layer
         */
        setRenderCamera(cam) {
            this._renderCamera = cam;
        }
        /**
         * @internal
         * Light which used by gizmos to get light shading
         */
        _getSharedGizmoLight() {
            if (!this._sharedGizmoLight) {
                this._sharedGizmoLight = new HemisphericLight("shared gizmo light", new Vector3(0, 1, 0), this.utilityLayerScene);
                this._sharedGizmoLight.intensity = 2;
                this._sharedGizmoLight.groundColor = Color3.Gray();
            }
            return this._sharedGizmoLight;
        }
        /**
         * A shared utility layer that can be used to overlay objects into a scene (Depth map of the previous scene is cleared before drawing on top of it)
         */
        static get DefaultUtilityLayer() {
            if (UtilityLayerRenderer._DefaultUtilityLayer == null) {
                return UtilityLayerRenderer._CreateDefaultUtilityLayerFromScene(EngineStore.LastCreatedScene);
            }
            return UtilityLayerRenderer._DefaultUtilityLayer;
        }
        /**
         * Creates an utility layer, and set it as a default utility layer
         * @param scene associated scene
         * @internal
         */
        static _CreateDefaultUtilityLayerFromScene(scene) {
            UtilityLayerRenderer._DefaultUtilityLayer = new UtilityLayerRenderer(scene);
            UtilityLayerRenderer._DefaultUtilityLayer.originalScene.onDisposeObservable.addOnce(() => {
                UtilityLayerRenderer._DefaultUtilityLayer = null;
            });
            return UtilityLayerRenderer._DefaultUtilityLayer;
        }
        /**
         * A shared utility layer that can be used to embed objects into a scene (Depth map of the previous scene is not cleared before drawing on top of it)
         */
        static get DefaultKeepDepthUtilityLayer() {
            if (UtilityLayerRenderer._DefaultKeepDepthUtilityLayer == null) {
                UtilityLayerRenderer._DefaultKeepDepthUtilityLayer = new UtilityLayerRenderer(EngineStore.LastCreatedScene);
                UtilityLayerRenderer._DefaultKeepDepthUtilityLayer.utilityLayerScene.autoClearDepthAndStencil = false;
                UtilityLayerRenderer._DefaultKeepDepthUtilityLayer.originalScene.onDisposeObservable.addOnce(() => {
                    UtilityLayerRenderer._DefaultKeepDepthUtilityLayer = null;
                });
            }
            return UtilityLayerRenderer._DefaultKeepDepthUtilityLayer;
        }
        /**
         * Instantiates a UtilityLayerRenderer
         * @param originalScene the original scene that will be rendered on top of
         * @param handleEvents boolean indicating if the utility layer should handle events
         */
        constructor(
        /** the original scene that will be rendered on top of */
        originalScene, handleEvents = true) {
            this.originalScene = originalScene;
            this._pointerCaptures = {};
            this._lastPointerEvents = {};
            this._sharedGizmoLight = null;
            this._renderCamera = null;
            /**
             * If the picking should be done on the utility layer prior to the actual scene (Default: true)
             */
            this.pickUtilitySceneFirst = true;
            /**
             *  If the utility layer should automatically be rendered on top of existing scene
             */
            this.shouldRender = true;
            /**
             * If set to true, only pointer down onPointerObservable events will be blocked when picking is occluded by original scene
             */
            this.onlyCheckPointerDownEvents = true;
            /**
             * If set to false, only pointerUp, pointerDown and pointerMove will be sent to the utilityLayerScene (false by default)
             */
            this.processAllEvents = false;
            /**
             * Set to false to disable picking
             */
            this.pickingEnabled = true;
            /**
             * Observable raised when the pointer moves from the utility layer scene to the main scene
             */
            this.onPointerOutObservable = new Observable$1();
            // Create scene which will be rendered in the foreground and remove it from being referenced by engine to avoid interfering with existing app
            this.utilityLayerScene = new Scene(originalScene.getEngine(), { virtual: true });
            this.utilityLayerScene.useRightHandedSystem = originalScene.useRightHandedSystem;
            this.utilityLayerScene._allowPostProcessClearColor = false;
            // Deactivate post processes
            this.utilityLayerScene.postProcessesEnabled = false;
            // Detach controls on utility scene, events will be fired by logic below to handle picking priority
            this.utilityLayerScene.detachControl();
            if (handleEvents) {
                this._originalPointerObserver = originalScene.onPrePointerObservable.add((prePointerInfo) => {
                    if (!this.utilityLayerScene.activeCamera) {
                        return;
                    }
                    if (!this.pickingEnabled) {
                        return;
                    }
                    if (!this.processAllEvents) {
                        if (prePointerInfo.type !== PointerEventTypes.POINTERMOVE &&
                            prePointerInfo.type !== PointerEventTypes.POINTERUP &&
                            prePointerInfo.type !== PointerEventTypes.POINTERDOWN &&
                            prePointerInfo.type !== PointerEventTypes.POINTERDOUBLETAP) {
                            return;
                        }
                    }
                    this.utilityLayerScene.pointerX = originalScene.pointerX;
                    this.utilityLayerScene.pointerY = originalScene.pointerY;
                    const pointerEvent = prePointerInfo.event;
                    if (originalScene.isPointerCaptured(pointerEvent.pointerId)) {
                        this._pointerCaptures[pointerEvent.pointerId] = false;
                        return;
                    }
                    const getNearPickDataForScene = (scene) => {
                        let scenePick = null;
                        if (prePointerInfo.nearInteractionPickingInfo) {
                            if (prePointerInfo.nearInteractionPickingInfo.pickedMesh.getScene() == scene) {
                                scenePick = prePointerInfo.nearInteractionPickingInfo;
                            }
                            else {
                                scenePick = new PickingInfo();
                            }
                        }
                        else if (scene !== this.utilityLayerScene && prePointerInfo.originalPickingInfo) {
                            scenePick = prePointerInfo.originalPickingInfo;
                        }
                        else {
                            let previousActiveCamera = null;
                            // If a camera is set for rendering with this layer
                            // it will also be used for the ray computation
                            // To preserve back compat and because scene.pick always use activeCamera
                            // it's substituted temporarily and a new scenePick is forced.
                            // otherwise, the ray with previously active camera is always used.
                            // It's set back to previous activeCamera after operation.
                            if (this._renderCamera) {
                                previousActiveCamera = scene._activeCamera;
                                scene._activeCamera = this._renderCamera;
                                prePointerInfo.ray = null;
                            }
                            scenePick = prePointerInfo.ray ? scene.pickWithRay(prePointerInfo.ray) : scene.pick(originalScene.pointerX, originalScene.pointerY);
                            if (previousActiveCamera) {
                                scene._activeCamera = previousActiveCamera;
                            }
                        }
                        return scenePick;
                    };
                    const utilityScenePick = getNearPickDataForScene(this.utilityLayerScene);
                    if (!prePointerInfo.ray && utilityScenePick) {
                        prePointerInfo.ray = utilityScenePick.ray;
                    }
                    // always fire the prepointer observable
                    this.utilityLayerScene.onPrePointerObservable.notifyObservers(prePointerInfo);
                    // allow every non pointer down event to flow to the utility layer
                    if (this.onlyCheckPointerDownEvents && prePointerInfo.type != PointerEventTypes.POINTERDOWN) {
                        if (!prePointerInfo.skipOnPointerObservable) {
                            this.utilityLayerScene.onPointerObservable.notifyObservers(new PointerInfo(prePointerInfo.type, prePointerInfo.event, utilityScenePick), prePointerInfo.type);
                        }
                        if (prePointerInfo.type === PointerEventTypes.POINTERUP && this._pointerCaptures[pointerEvent.pointerId]) {
                            this._pointerCaptures[pointerEvent.pointerId] = false;
                        }
                        return;
                    }
                    if (this.utilityLayerScene.autoClearDepthAndStencil || this.pickUtilitySceneFirst) {
                        // If this layer is an overlay, check if this layer was hit and if so, skip pointer events for the main scene
                        if (utilityScenePick && utilityScenePick.hit) {
                            if (!prePointerInfo.skipOnPointerObservable) {
                                this.utilityLayerScene.onPointerObservable.notifyObservers(new PointerInfo(prePointerInfo.type, prePointerInfo.event, utilityScenePick), prePointerInfo.type);
                            }
                            prePointerInfo.skipOnPointerObservable = true;
                        }
                    }
                    else {
                        const originalScenePick = getNearPickDataForScene(originalScene);
                        const pointerEvent = prePointerInfo.event;
                        // If the layer can be occluded by the original scene, only fire pointer events to the first layer that hit they ray
                        if (originalScenePick && utilityScenePick) {
                            // No pick in utility scene
                            if (utilityScenePick.distance === 0 && originalScenePick.pickedMesh) {
                                if (this.mainSceneTrackerPredicate && this.mainSceneTrackerPredicate(originalScenePick.pickedMesh)) {
                                    // We touched an utility mesh present in the main scene
                                    this._notifyObservers(prePointerInfo, originalScenePick, pointerEvent);
                                    prePointerInfo.skipOnPointerObservable = true;
                                }
                                else if (prePointerInfo.type === PointerEventTypes.POINTERDOWN) {
                                    this._pointerCaptures[pointerEvent.pointerId] = true;
                                }
                                else if (prePointerInfo.type === PointerEventTypes.POINTERMOVE || prePointerInfo.type === PointerEventTypes.POINTERUP) {
                                    if (this._lastPointerEvents[pointerEvent.pointerId]) {
                                        // We need to send a last pointerup to the utilityLayerScene to make sure animations can complete
                                        this.onPointerOutObservable.notifyObservers(pointerEvent.pointerId);
                                        delete this._lastPointerEvents[pointerEvent.pointerId];
                                    }
                                    this._notifyObservers(prePointerInfo, originalScenePick, pointerEvent);
                                }
                            }
                            else if (!this._pointerCaptures[pointerEvent.pointerId] && (utilityScenePick.distance < originalScenePick.distance || originalScenePick.distance === 0)) {
                                // We pick something in utility scene or the pick in utility is closer than the one in main scene
                                this._notifyObservers(prePointerInfo, utilityScenePick, pointerEvent);
                                // If a previous utility layer set this, do not unset this
                                if (!prePointerInfo.skipOnPointerObservable) {
                                    prePointerInfo.skipOnPointerObservable = utilityScenePick.distance > 0;
                                }
                            }
                            else if (!this._pointerCaptures[pointerEvent.pointerId] && utilityScenePick.distance >= originalScenePick.distance) {
                                // We have a pick in both scenes but main is closer than utility
                                // We touched an utility mesh present in the main scene
                                if (this.mainSceneTrackerPredicate && this.mainSceneTrackerPredicate(originalScenePick.pickedMesh)) {
                                    this._notifyObservers(prePointerInfo, originalScenePick, pointerEvent);
                                    prePointerInfo.skipOnPointerObservable = true;
                                }
                                else {
                                    if (prePointerInfo.type === PointerEventTypes.POINTERMOVE || prePointerInfo.type === PointerEventTypes.POINTERUP) {
                                        if (this._lastPointerEvents[pointerEvent.pointerId]) {
                                            // We need to send a last pointerup to the utilityLayerScene to make sure animations can complete
                                            this.onPointerOutObservable.notifyObservers(pointerEvent.pointerId);
                                            delete this._lastPointerEvents[pointerEvent.pointerId];
                                        }
                                    }
                                    this._notifyObservers(prePointerInfo, utilityScenePick, pointerEvent);
                                }
                            }
                            if (prePointerInfo.type === PointerEventTypes.POINTERUP && this._pointerCaptures[pointerEvent.pointerId]) {
                                this._pointerCaptures[pointerEvent.pointerId] = false;
                            }
                        }
                    }
                });
                // As a newly added utility layer will be rendered over the screen last, it's pointer events should be processed first
                if (this._originalPointerObserver) {
                    originalScene.onPrePointerObservable.makeObserverTopPriority(this._originalPointerObserver);
                }
            }
            // Render directly on top of existing scene without clearing
            this.utilityLayerScene.autoClear = false;
            this._afterRenderObserver = this.originalScene.onAfterRenderCameraObservable.add((camera) => {
                // Only render when the render camera finishes rendering
                if (this.shouldRender && camera == this.getRenderCamera()) {
                    this.render();
                }
            });
            this._sceneDisposeObserver = this.originalScene.onDisposeObservable.add(() => {
                this.dispose();
            });
            this._updateCamera();
        }
        _notifyObservers(prePointerInfo, pickInfo, pointerEvent) {
            if (!prePointerInfo.skipOnPointerObservable) {
                this.utilityLayerScene.onPointerObservable.notifyObservers(new PointerInfo(prePointerInfo.type, prePointerInfo.event, pickInfo), prePointerInfo.type);
                this._lastPointerEvents[pointerEvent.pointerId] = true;
            }
        }
        /**
         * Renders the utility layers scene on top of the original scene
         */
        render() {
            this._updateCamera();
            if (this.utilityLayerScene.activeCamera) {
                // Set the camera's scene to utility layers scene
                const oldScene = this.utilityLayerScene.activeCamera.getScene();
                const camera = this.utilityLayerScene.activeCamera;
                camera._scene = this.utilityLayerScene;
                if (camera.leftCamera) {
                    camera.leftCamera._scene = this.utilityLayerScene;
                }
                if (camera.rightCamera) {
                    camera.rightCamera._scene = this.utilityLayerScene;
                }
                this.utilityLayerScene.render(false);
                // Reset camera's scene back to original
                camera._scene = oldScene;
                if (camera.leftCamera) {
                    camera.leftCamera._scene = oldScene;
                }
                if (camera.rightCamera) {
                    camera.rightCamera._scene = oldScene;
                }
            }
        }
        /**
         * Disposes of the renderer
         */
        dispose() {
            this.onPointerOutObservable.clear();
            if (this._afterRenderObserver) {
                this.originalScene.onAfterCameraRenderObservable.remove(this._afterRenderObserver);
            }
            if (this._sceneDisposeObserver) {
                this.originalScene.onDisposeObservable.remove(this._sceneDisposeObserver);
            }
            if (this._originalPointerObserver) {
                this.originalScene.onPrePointerObservable.remove(this._originalPointerObserver);
            }
            this.utilityLayerScene.dispose();
        }
        _updateCamera() {
            this.utilityLayerScene.cameraToUseForPointers = this.getRenderCamera();
            this.utilityLayerScene.activeCamera = this.getRenderCamera();
        }
    }
    /** @internal */
    UtilityLayerRenderer._DefaultUtilityLayer = null;
    /** @internal */
    UtilityLayerRenderer._DefaultKeepDepthUtilityLayer = null;

    /**
     * A module that will enable pointer selection for motion controllers of XR Input Sources
     */
    class WebXRControllerPointerSelection extends WebXRAbstractFeature {
        /**
         * constructs a new background remover module
         * @param _xrSessionManager the session manager for this module
         * @param _options read-only options to be used in this module
         */
        constructor(_xrSessionManager, _options) {
            super(_xrSessionManager);
            this._options = _options;
            this._attachController = (xrController) => {
                if (this._controllers[xrController.uniqueId]) {
                    // already attached
                    return;
                }
                const { laserPointer, selectionMesh } = this._generateNewMeshPair(xrController.pointer);
                // get two new meshes
                this._controllers[xrController.uniqueId] = {
                    xrController,
                    laserPointer,
                    selectionMesh,
                    meshUnderPointer: null,
                    pick: null,
                    tmpRay: new Ray(new Vector3(), new Vector3()),
                    disabledByNearInteraction: false,
                    id: WebXRControllerPointerSelection._IdCounter++,
                };
                if (this._attachedController) {
                    if (!this._options.enablePointerSelectionOnAllControllers &&
                        this._options.preferredHandedness &&
                        xrController.inputSource.handedness === this._options.preferredHandedness) {
                        this._attachedController = xrController.uniqueId;
                    }
                }
                else {
                    if (!this._options.enablePointerSelectionOnAllControllers) {
                        this._attachedController = xrController.uniqueId;
                    }
                }
                switch (xrController.inputSource.targetRayMode) {
                    case "tracked-pointer":
                        return this._attachTrackedPointerRayMode(xrController);
                    case "gaze":
                        return this._attachGazeMode(xrController);
                    case "screen":
                        return this._attachScreenRayMode(xrController);
                }
            };
            this._controllers = {};
            this._tmpVectorForPickCompare = new Vector3();
            /**
             * Disable lighting on the laser pointer (so it will always be visible)
             */
            this.disablePointerLighting = true;
            /**
             * Disable lighting on the selection mesh (so it will always be visible)
             */
            this.disableSelectionMeshLighting = true;
            /**
             * Should the laser pointer be displayed
             */
            this.displayLaserPointer = true;
            /**
             * Should the selection mesh be displayed (The ring at the end of the laser pointer)
             */
            this.displaySelectionMesh = true;
            /**
             * This color will be set to the laser pointer when selection is triggered
             */
            this.laserPointerPickedColor = new Color3(0.9, 0.9, 0.9);
            /**
             * Default color of the laser pointer
             */
            this.laserPointerDefaultColor = new Color3(0.7, 0.7, 0.7);
            /**
             * default color of the selection ring
             */
            this.selectionMeshDefaultColor = new Color3(0.8, 0.8, 0.8);
            /**
             * This color will be applied to the selection ring when selection is triggered
             */
            this.selectionMeshPickedColor = new Color3(0.3, 0.3, 1.0);
            this._identityMatrix = Matrix.Identity();
            this._screenCoordinatesRef = Vector3.Zero();
            this._viewportRef = new Viewport(0, 0, 0, 0);
            this._scene = this._xrSessionManager.scene;
        }
        /**
         * attach this feature
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        attach() {
            if (!super.attach()) {
                return false;
            }
            this._options.xrInput.controllers.forEach(this._attachController);
            this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController);
            this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller) => {
                // REMOVE the controller
                this._detachController(controller.uniqueId);
            });
            this._scene.constantlyUpdateMeshUnderPointer = true;
            if (this._options.gazeCamera) {
                const webXRCamera = this._options.gazeCamera;
                const { laserPointer, selectionMesh } = this._generateNewMeshPair(webXRCamera);
                this._controllers["camera"] = {
                    webXRCamera,
                    laserPointer,
                    selectionMesh,
                    meshUnderPointer: null,
                    pick: null,
                    tmpRay: new Ray(new Vector3(), new Vector3()),
                    disabledByNearInteraction: false,
                    id: WebXRControllerPointerSelection._IdCounter++,
                };
                this._attachGazeMode();
            }
            return true;
        }
        /**
         * detach this feature.
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        detach() {
            if (!super.detach()) {
                return false;
            }
            Object.keys(this._controllers).forEach((controllerId) => {
                this._detachController(controllerId);
            });
            return true;
        }
        /**
         * Will get the mesh under a specific pointer.
         * `scene.meshUnderPointer` will only return one mesh - either left or right.
         * @param controllerId the controllerId to check
         * @returns The mesh under pointer or null if no mesh is under the pointer
         */
        getMeshUnderPointer(controllerId) {
            if (this._controllers[controllerId]) {
                return this._controllers[controllerId].meshUnderPointer;
            }
            else {
                return null;
            }
        }
        /**
         * Get the xr controller that correlates to the pointer id in the pointer event
         *
         * @param id the pointer id to search for
         * @returns the controller that correlates to this id or null if not found
         */
        getXRControllerByPointerId(id) {
            const keys = Object.keys(this._controllers);
            for (let i = 0; i < keys.length; ++i) {
                if (this._controllers[keys[i]].id === id) {
                    return this._controllers[keys[i]].xrController || null;
                }
            }
            return null;
        }
        /**
         * @internal
         */
        _getPointerSelectionDisabledByPointerId(id) {
            const keys = Object.keys(this._controllers);
            for (let i = 0; i < keys.length; ++i) {
                if (this._controllers[keys[i]].id === id) {
                    return this._controllers[keys[i]].disabledByNearInteraction;
                }
            }
            return true;
        }
        /**
         * @internal
         */
        _setPointerSelectionDisabledByPointerId(id, state) {
            const keys = Object.keys(this._controllers);
            for (let i = 0; i < keys.length; ++i) {
                if (this._controllers[keys[i]].id === id) {
                    this._controllers[keys[i]].disabledByNearInteraction = state;
                    return;
                }
            }
        }
        _onXRFrame(_xrFrame) {
            Object.keys(this._controllers).forEach((id) => {
                // only do this for the selected pointer
                const controllerData = this._controllers[id];
                if ((!this._options.enablePointerSelectionOnAllControllers && id !== this._attachedController) || controllerData.disabledByNearInteraction) {
                    controllerData.selectionMesh.isVisible = false;
                    controllerData.laserPointer.isVisible = false;
                    controllerData.pick = null;
                    return;
                }
                controllerData.laserPointer.isVisible = this.displayLaserPointer;
                let controllerGlobalPosition;
                // Every frame check collisions/input
                if (controllerData.xrController) {
                    controllerGlobalPosition = controllerData.xrController.pointer.position;
                    controllerData.xrController.getWorldPointerRayToRef(controllerData.tmpRay);
                }
                else if (controllerData.webXRCamera) {
                    controllerGlobalPosition = controllerData.webXRCamera.position;
                    controllerData.webXRCamera.getForwardRayToRef(controllerData.tmpRay);
                }
                else {
                    return;
                }
                if (this._options.maxPointerDistance) {
                    controllerData.tmpRay.length = this._options.maxPointerDistance;
                }
                // update pointerX and pointerY of the scene. Only if the flag is set to true!
                if (!this._options.disableScenePointerVectorUpdate && controllerGlobalPosition) {
                    const scene = this._xrSessionManager.scene;
                    const camera = this._options.xrInput.xrCamera;
                    if (camera) {
                        camera.viewport.toGlobalToRef(scene.getEngine().getRenderWidth(), scene.getEngine().getRenderHeight(), this._viewportRef);
                        Vector3.ProjectToRef(controllerGlobalPosition, this._identityMatrix, scene.getTransformMatrix(), this._viewportRef, this._screenCoordinatesRef);
                        // stay safe
                        if (typeof this._screenCoordinatesRef.x === "number" &&
                            typeof this._screenCoordinatesRef.y === "number" &&
                            !isNaN(this._screenCoordinatesRef.x) &&
                            !isNaN(this._screenCoordinatesRef.y)) {
                            scene.pointerX = this._screenCoordinatesRef.x;
                            scene.pointerY = this._screenCoordinatesRef.y;
                            controllerData.screenCoordinates = {
                                x: this._screenCoordinatesRef.x,
                                y: this._screenCoordinatesRef.y,
                            };
                        }
                    }
                }
                let utilityScenePick = null;
                if (this._utilityLayerScene) {
                    utilityScenePick = this._utilityLayerScene.pickWithRay(controllerData.tmpRay, this._utilityLayerScene.pointerMovePredicate || this.raySelectionPredicate);
                }
                const originalScenePick = this._scene.pickWithRay(controllerData.tmpRay, this._scene.pointerMovePredicate || this.raySelectionPredicate);
                if (!utilityScenePick || !utilityScenePick.hit) {
                    // No hit in utility scene
                    controllerData.pick = originalScenePick;
                }
                else if (!originalScenePick || !originalScenePick.hit) {
                    // No hit in original scene
                    controllerData.pick = utilityScenePick;
                }
                else if (utilityScenePick.distance < originalScenePick.distance) {
                    // Hit is closer in utility scene
                    controllerData.pick = utilityScenePick;
                }
                else {
                    // Hit is closer in original scene
                    controllerData.pick = originalScenePick;
                }
                if (controllerData.pick && controllerData.xrController) {
                    controllerData.pick.aimTransform = controllerData.xrController.pointer;
                    controllerData.pick.gripTransform = controllerData.xrController.grip || null;
                }
                const pick = controllerData.pick;
                if (pick && pick.pickedPoint && pick.hit) {
                    // Update laser state
                    this._updatePointerDistance(controllerData.laserPointer, pick.distance);
                    // Update cursor state
                    controllerData.selectionMesh.position.copyFrom(pick.pickedPoint);
                    controllerData.selectionMesh.scaling.x = Math.sqrt(pick.distance);
                    controllerData.selectionMesh.scaling.y = Math.sqrt(pick.distance);
                    controllerData.selectionMesh.scaling.z = Math.sqrt(pick.distance);
                    // To avoid z-fighting
                    const pickNormal = this._convertNormalToDirectionOfRay(pick.getNormal(true), controllerData.tmpRay);
                    const deltaFighting = 0.001;
                    controllerData.selectionMesh.position.copyFrom(pick.pickedPoint);
                    if (pickNormal) {
                        const axis1 = Vector3.Cross(Axis.Y, pickNormal);
                        const axis2 = Vector3.Cross(pickNormal, axis1);
                        Vector3.RotationFromAxisToRef(axis2, pickNormal, axis1, controllerData.selectionMesh.rotation);
                        controllerData.selectionMesh.position.addInPlace(pickNormal.scale(deltaFighting));
                    }
                    controllerData.selectionMesh.isVisible =  this.displaySelectionMesh;
                    controllerData.meshUnderPointer = pick.pickedMesh;
                }
                else {
                    controllerData.selectionMesh.isVisible = false;
                    this._updatePointerDistance(controllerData.laserPointer, 1);
                    controllerData.meshUnderPointer = null;
                }
            });
        }
        get _utilityLayerScene() {
            return this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene;
        }
        _attachGazeMode(xrController) {
            const controllerData = this._controllers[(xrController && xrController.uniqueId) || "camera"];
            // attached when touched, detaches when raised
            const timeToSelect = this._options.timeToSelect || 3000;
            const sceneToRenderTo = this._options.useUtilityLayer ? this._utilityLayerScene : this._scene;
            let oldPick = new PickingInfo();
            const discMesh = CreateTorus("selection", {
                diameter: 0.0035 * 15,
                thickness: 0.0025 * 6,
                tessellation: 20,
            }, sceneToRenderTo);
            discMesh.isVisible = false;
            discMesh.isPickable = false;
            discMesh.parent = controllerData.selectionMesh;
            let timer = 0;
            let downTriggered = false;
            const pointerEventInit = {
                pointerId: controllerData.id,
                pointerType: "xr",
            };
            controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(() => {
                if (!controllerData.pick) {
                    return;
                }
                this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                controllerData.laserPointer.material.alpha = 0;
                discMesh.isVisible = false;
                if (controllerData.pick.hit) {
                    if (!this._pickingMoved(oldPick, controllerData.pick)) {
                        if (timer > timeToSelect / 10) {
                            discMesh.isVisible = true;
                        }
                        timer += this._scene.getEngine().getDeltaTime();
                        if (timer >= timeToSelect) {
                            this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                            // this pointerdown event is not setting the controllerData.pointerDownTriggered to avoid a pointerUp event when this feature is detached
                            downTriggered = true;
                            // pointer up right after down, if disable on touch out
                            if (this._options.disablePointerUpOnTouchOut) {
                                this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                            }
                            discMesh.isVisible = false;
                        }
                        else {
                            const scaleFactor = 1 - timer / timeToSelect;
                            discMesh.scaling.set(scaleFactor, scaleFactor, scaleFactor);
                        }
                    }
                    else {
                        if (downTriggered) {
                            if (!this._options.disablePointerUpOnTouchOut) {
                                this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                            }
                        }
                        downTriggered = false;
                        timer = 0;
                    }
                }
                else {
                    downTriggered = false;
                    timer = 0;
                }
                this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
                oldPick = controllerData.pick;
            });
            if (this._options.renderingGroupId !== undefined) {
                discMesh.renderingGroupId = this._options.renderingGroupId;
            }
            if (xrController) {
                xrController.onDisposeObservable.addOnce(() => {
                    if (controllerData.pick && !this._options.disablePointerUpOnTouchOut && downTriggered) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        controllerData.finalPointerUpTriggered = true;
                    }
                    discMesh.dispose();
                });
            }
        }
        _attachScreenRayMode(xrController) {
            const controllerData = this._controllers[xrController.uniqueId];
            let downTriggered = false;
            const pointerEventInit = {
                pointerId: controllerData.id,
                pointerType: "xr",
            };
            controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(() => {
                this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                if (!controllerData.pick || (this._options.disablePointerUpOnTouchOut && downTriggered)) {
                    return;
                }
                if (!downTriggered) {
                    this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                    controllerData.pointerDownTriggered = true;
                    downTriggered = true;
                    if (this._options.disablePointerUpOnTouchOut) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                    }
                }
                else {
                    this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
                }
            });
            xrController.onDisposeObservable.addOnce(() => {
                this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                this._xrSessionManager.runInXRFrame(() => {
                    if (controllerData.pick && !controllerData.finalPointerUpTriggered && downTriggered && !this._options.disablePointerUpOnTouchOut) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        controllerData.finalPointerUpTriggered = true;
                    }
                });
            });
        }
        _attachTrackedPointerRayMode(xrController) {
            const controllerData = this._controllers[xrController.uniqueId];
            if (this._options.forceGazeMode) {
                return this._attachGazeMode(xrController);
            }
            const pointerEventInit = {
                pointerId: controllerData.id,
                pointerType: "xr",
            };
            controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(() => {
                controllerData.laserPointer.material.disableLighting = this.disablePointerLighting;
                controllerData.selectionMesh.material.disableLighting = this.disableSelectionMeshLighting;
                if (controllerData.pick) {
                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                    this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
                }
            });
            if (xrController.inputSource.gamepad) {
                const init = (motionController) => {
                    if (this._options.overrideButtonId) {
                        controllerData.selectionComponent = motionController.getComponent(this._options.overrideButtonId);
                    }
                    if (!controllerData.selectionComponent) {
                        controllerData.selectionComponent = motionController.getMainComponent();
                    }
                    controllerData.onButtonChangedObserver = controllerData.selectionComponent.onButtonStateChangedObservable.add((component) => {
                        if (component.changes.pressed) {
                            const pressed = component.changes.pressed.current;
                            if (controllerData.pick) {
                                if (this._options.enablePointerSelectionOnAllControllers || xrController.uniqueId === this._attachedController) {
                                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                                    if (pressed) {
                                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                                        controllerData.pointerDownTriggered = true;
                                        controllerData.selectionMesh.material.emissiveColor = this.selectionMeshPickedColor;
                                        controllerData.laserPointer.material.emissiveColor = this.laserPointerPickedColor;
                                    }
                                    else {
                                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                                        controllerData.selectionMesh.material.emissiveColor = this.selectionMeshDefaultColor;
                                        controllerData.laserPointer.material.emissiveColor = this.laserPointerDefaultColor;
                                    }
                                }
                            }
                            else {
                                if (pressed && !this._options.enablePointerSelectionOnAllControllers && !this._options.disableSwitchOnClick) {
                                    this._attachedController = xrController.uniqueId;
                                }
                            }
                        }
                    });
                };
                if (xrController.motionController) {
                    init(xrController.motionController);
                }
                else {
                    xrController.onMotionControllerInitObservable.add(init);
                }
            }
            else {
                // use the select and squeeze events
                const selectStartListener = (event) => {
                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                    if (controllerData.xrController && event.inputSource === controllerData.xrController.inputSource && controllerData.pick) {
                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                        controllerData.pointerDownTriggered = true;
                        controllerData.selectionMesh.material.emissiveColor = this.selectionMeshPickedColor;
                        controllerData.laserPointer.material.emissiveColor = this.laserPointerPickedColor;
                    }
                };
                const selectEndListener = (event) => {
                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                    if (controllerData.xrController && event.inputSource === controllerData.xrController.inputSource && controllerData.pick) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        controllerData.selectionMesh.material.emissiveColor = this.selectionMeshDefaultColor;
                        controllerData.laserPointer.material.emissiveColor = this.laserPointerDefaultColor;
                    }
                };
                controllerData.eventListeners = {
                    selectend: selectEndListener,
                    selectstart: selectStartListener,
                };
                this._xrSessionManager.session.addEventListener("selectstart", selectStartListener);
                this._xrSessionManager.session.addEventListener("selectend", selectEndListener);
            }
        }
        _convertNormalToDirectionOfRay(normal, ray) {
            if (normal) {
                const angle = Math.acos(Vector3.Dot(normal, ray.direction));
                if (angle < Math.PI / 2) {
                    normal.scaleInPlace(-1);
                }
            }
            return normal;
        }
        _detachController(xrControllerUniqueId) {
            const controllerData = this._controllers[xrControllerUniqueId];
            if (!controllerData) {
                return;
            }
            if (controllerData.selectionComponent) {
                if (controllerData.onButtonChangedObserver) {
                    controllerData.selectionComponent.onButtonStateChangedObservable.remove(controllerData.onButtonChangedObserver);
                }
            }
            if (controllerData.onFrameObserver) {
                this._xrSessionManager.onXRFrameObservable.remove(controllerData.onFrameObserver);
            }
            if (controllerData.eventListeners) {
                Object.keys(controllerData.eventListeners).forEach((eventName) => {
                    const func = controllerData.eventListeners && controllerData.eventListeners[eventName];
                    if (func) {
                        // For future reference - this is an issue in the WebXR typings.
                        this._xrSessionManager.session.removeEventListener(eventName, func);
                    }
                });
            }
            if (!controllerData.finalPointerUpTriggered && controllerData.pointerDownTriggered) {
                // Stay safe and fire a pointerup, in case it wasn't already triggered
                const pointerEventInit = {
                    pointerId: controllerData.id,
                    pointerType: "xr",
                };
                this._xrSessionManager.runInXRFrame(() => {
                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                    this._scene.simulatePointerUp(controllerData.pick || new PickingInfo(), pointerEventInit);
                    controllerData.finalPointerUpTriggered = true;
                });
            }
            this._xrSessionManager.scene.onBeforeRenderObservable.addOnce(() => {
                try {
                    controllerData.selectionMesh.dispose();
                    controllerData.laserPointer.dispose();
                    // remove from the map
                    delete this._controllers[xrControllerUniqueId];
                    if (this._attachedController === xrControllerUniqueId) {
                        // check for other controllers
                        const keys = Object.keys(this._controllers);
                        if (keys.length) {
                            this._attachedController = keys[0];
                        }
                        else {
                            this._attachedController = "";
                        }
                    }
                }
                catch (e) {
                    Tools.Warn("controller already detached.");
                }
            });
        }
        _generateNewMeshPair(meshParent) {
            const sceneToRenderTo = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene : this._scene;
            const laserPointer = this._options.customLasterPointerMeshGenerator
                ? this._options.customLasterPointerMeshGenerator()
                : CreateCylinder("laserPointer", {
                    height: 1,
                    diameterTop: 0.0002,
                    diameterBottom: 0.004,
                    tessellation: 20,
                    subdivisions: 1,
                }, sceneToRenderTo);
            laserPointer.parent = meshParent;
            const laserPointerMaterial = new StandardMaterial("laserPointerMat", sceneToRenderTo);
            laserPointerMaterial.emissiveColor = this.laserPointerDefaultColor;
            laserPointerMaterial.alpha = 0.7;
            laserPointer.material = laserPointerMaterial;
            laserPointer.rotation.x = Math.PI / 2;
            this._updatePointerDistance(laserPointer, 1);
            laserPointer.isPickable = false;
            laserPointer.isVisible = false;
            // Create a gaze tracker for the  XR controller
            const selectionMesh = this._options.customSelectionMeshGenerator
                ? this._options.customSelectionMeshGenerator()
                : CreateTorus("gazeTracker", {
                    diameter: 0.0035 * 3,
                    thickness: 0.0025 * 3,
                    tessellation: 20,
                }, sceneToRenderTo);
            selectionMesh.bakeCurrentTransformIntoVertices();
            selectionMesh.isPickable = false;
            selectionMesh.isVisible = false;
            const targetMat = new StandardMaterial("targetMat", sceneToRenderTo);
            targetMat.specularColor = Color3.Black();
            targetMat.emissiveColor = this.selectionMeshDefaultColor;
            targetMat.backFaceCulling = false;
            selectionMesh.material = targetMat;
            if (this._options.renderingGroupId !== undefined) {
                laserPointer.renderingGroupId = this._options.renderingGroupId;
                selectionMesh.renderingGroupId = this._options.renderingGroupId;
            }
            return {
                laserPointer,
                selectionMesh,
            };
        }
        _pickingMoved(oldPick, newPick) {
            var _a;
            if (!oldPick.hit || !newPick.hit) {
                return true;
            }
            if (!oldPick.pickedMesh || !oldPick.pickedPoint || !newPick.pickedMesh || !newPick.pickedPoint) {
                return true;
            }
            if (oldPick.pickedMesh !== newPick.pickedMesh) {
                return true;
            }
            (_a = oldPick.pickedPoint) === null || _a === void 0 ? void 0 : _a.subtractToRef(newPick.pickedPoint, this._tmpVectorForPickCompare);
            this._tmpVectorForPickCompare.set(Math.abs(this._tmpVectorForPickCompare.x), Math.abs(this._tmpVectorForPickCompare.y), Math.abs(this._tmpVectorForPickCompare.z));
            const delta = (this._options.gazeModePointerMovedFactor || 1) * 0.01 * newPick.distance;
            const length = this._tmpVectorForPickCompare.length();
            if (length > delta) {
                return true;
            }
            return false;
        }
        _updatePointerDistance(_laserPointer, distance = 100) {
            _laserPointer.scaling.y = distance;
            // a bit of distance from the controller
            if (this._scene.useRightHandedSystem) {
                distance *= -1;
            }
            _laserPointer.position.z = distance / 2 + 0.05;
        }
        _augmentPointerInit(pointerEventInit, id, screenCoordinates) {
            pointerEventInit.pointerId = id;
            pointerEventInit.pointerType = "xr";
            if (screenCoordinates) {
                pointerEventInit.screenX = screenCoordinates.x;
                pointerEventInit.screenY = screenCoordinates.y;
            }
        }
        /** @internal */
        get lasterPointerDefaultColor() {
            // here due to a typo
            return this.laserPointerDefaultColor;
        }
    }
    WebXRControllerPointerSelection._IdCounter = 200;
    /**
     * The module's name
     */
    WebXRControllerPointerSelection.Name = WebXRFeatureName.POINTER_SELECTION;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the WebXR specs version
     */
    WebXRControllerPointerSelection.Version = 1;
    //register the plugin
    WebXRFeaturesManager.AddWebXRFeature(WebXRControllerPointerSelection.Name, (xrSessionManager, options) => {
        return () => new WebXRControllerPointerSelection(xrSessionManager, options);
    }, WebXRControllerPointerSelection.Version, true);

    /**
     * Defines the kind of connection point for node based material
     */
    var NodeMaterialBlockConnectionPointTypes;
    (function (NodeMaterialBlockConnectionPointTypes) {
        /** Float */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Float"] = 1] = "Float";
        /** Int */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Int"] = 2] = "Int";
        /** Vector2 */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Vector2"] = 4] = "Vector2";
        /** Vector3 */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Vector3"] = 8] = "Vector3";
        /** Vector4 */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Vector4"] = 16] = "Vector4";
        /** Color3 */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Color3"] = 32] = "Color3";
        /** Color4 */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Color4"] = 64] = "Color4";
        /** Matrix */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Matrix"] = 128] = "Matrix";
        /** Custom object */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Object"] = 256] = "Object";
        /** Detect type based on connection */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["AutoDetect"] = 1024] = "AutoDetect";
        /** Output type that will be defined by input type */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["BasedOnInput"] = 2048] = "BasedOnInput";
        /** Bitmask of all types */
        NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["All"] = 4095] = "All";
    })(NodeMaterialBlockConnectionPointTypes || (NodeMaterialBlockConnectionPointTypes = {}));

    /**
     * Enum used to define the target of a block
     */
    var NodeMaterialBlockTargets;
    (function (NodeMaterialBlockTargets) {
        /** Vertex shader */
        NodeMaterialBlockTargets[NodeMaterialBlockTargets["Vertex"] = 1] = "Vertex";
        /** Fragment shader */
        NodeMaterialBlockTargets[NodeMaterialBlockTargets["Fragment"] = 2] = "Fragment";
        /** Neutral */
        NodeMaterialBlockTargets[NodeMaterialBlockTargets["Neutral"] = 4] = "Neutral";
        /** Vertex and Fragment */
        NodeMaterialBlockTargets[NodeMaterialBlockTargets["VertexAndFragment"] = 3] = "VertexAndFragment";
    })(NodeMaterialBlockTargets || (NodeMaterialBlockTargets = {}));

    /**
     * Class used to store node based material build state
     */
    class NodeMaterialBuildState {
        constructor() {
            /** Gets or sets a boolean indicating if the current state can emit uniform buffers */
            this.supportUniformBuffers = false;
            /**
             * Gets the list of emitted attributes
             */
            this.attributes = new Array();
            /**
             * Gets the list of emitted uniforms
             */
            this.uniforms = new Array();
            /**
             * Gets the list of emitted constants
             */
            this.constants = new Array();
            /**
             * Gets the list of emitted samplers
             */
            this.samplers = new Array();
            /**
             * Gets the list of emitted functions
             */
            this.functions = {};
            /**
             * Gets the list of emitted extensions
             */
            this.extensions = {};
            /**
             * Gets the list of emitted counters
             */
            this.counters = {};
            /** @internal */
            this._attributeDeclaration = "";
            /** @internal */
            this._uniformDeclaration = "";
            /** @internal */
            this._constantDeclaration = "";
            /** @internal */
            this._samplerDeclaration = "";
            /** @internal */
            this._varyingTransfer = "";
            /** @internal */
            this._injectAtEnd = "";
            this._repeatableContentAnchorIndex = 0;
            /** @internal */
            this._builtCompilationString = "";
            /**
             * Gets the emitted compilation strings
             */
            this.compilationString = "";
        }
        /**
         * Finalize the compilation strings
         * @param state defines the current compilation state
         */
        finalize(state) {
            const emitComments = state.sharedData.emitComments;
            const isFragmentMode = this.target === NodeMaterialBlockTargets.Fragment;
            this.compilationString = `\n${emitComments ? "//Entry point\n" : ""}void main(void) {\n${this.compilationString}`;
            if (this._constantDeclaration) {
                this.compilationString = `\n${emitComments ? "//Constants\n" : ""}${this._constantDeclaration}\n${this.compilationString}`;
            }
            let functionCode = "";
            for (const functionName in this.functions) {
                functionCode += this.functions[functionName] + `\n`;
            }
            this.compilationString = `\n${functionCode}\n${this.compilationString}`;
            if (!isFragmentMode && this._varyingTransfer) {
                this.compilationString = `${this.compilationString}\n${this._varyingTransfer}`;
            }
            if (this._injectAtEnd) {
                this.compilationString = `${this.compilationString}\n${this._injectAtEnd}`;
            }
            this.compilationString = `${this.compilationString}\n}`;
            if (this.sharedData.varyingDeclaration) {
                this.compilationString = `\n${emitComments ? "//Varyings\n" : ""}${this.sharedData.varyingDeclaration}\n${this.compilationString}`;
            }
            if (this._samplerDeclaration) {
                this.compilationString = `\n${emitComments ? "//Samplers\n" : ""}${this._samplerDeclaration}\n${this.compilationString}`;
            }
            if (this._uniformDeclaration) {
                this.compilationString = `\n${emitComments ? "//Uniforms\n" : ""}${this._uniformDeclaration}\n${this.compilationString}`;
            }
            if (this._attributeDeclaration && !isFragmentMode) {
                this.compilationString = `\n${emitComments ? "//Attributes\n" : ""}${this._attributeDeclaration}\n${this.compilationString}`;
            }
            this.compilationString = "precision highp float;\n" + this.compilationString;
            this.compilationString = "#if defined(WEBGL2) || defines(WEBGPU)\nprecision highp sampler2DArray;\n#endif\n" + this.compilationString;
            for (const extensionName in this.extensions) {
                const extension = this.extensions[extensionName];
                this.compilationString = `\n${extension}\n${this.compilationString}`;
            }
            this._builtCompilationString = this.compilationString;
        }
        /** @internal */
        get _repeatableContentAnchor() {
            return `###___ANCHOR${this._repeatableContentAnchorIndex++}___###`;
        }
        /**
         * @internal
         */
        _getFreeVariableName(prefix) {
            prefix = prefix.replace(/[^a-zA-Z_]+/g, "");
            if (this.sharedData.variableNames[prefix] === undefined) {
                this.sharedData.variableNames[prefix] = 0;
                // Check reserved words
                if (prefix === "output" || prefix === "texture") {
                    return prefix + this.sharedData.variableNames[prefix];
                }
                return prefix;
            }
            else {
                this.sharedData.variableNames[prefix]++;
            }
            return prefix + this.sharedData.variableNames[prefix];
        }
        /**
         * @internal
         */
        _getFreeDefineName(prefix) {
            if (this.sharedData.defineNames[prefix] === undefined) {
                this.sharedData.defineNames[prefix] = 0;
            }
            else {
                this.sharedData.defineNames[prefix]++;
            }
            return prefix + this.sharedData.defineNames[prefix];
        }
        /**
         * @internal
         */
        _excludeVariableName(name) {
            this.sharedData.variableNames[name] = 0;
        }
        /**
         * @internal
         */
        _emit2DSampler(name) {
            if (this.samplers.indexOf(name) < 0) {
                this._samplerDeclaration += `uniform sampler2D ${name};\n`;
                this.samplers.push(name);
            }
        }
        /**
         * @internal
         */
        _emit2DArraySampler(name) {
            if (this.samplers.indexOf(name) < 0) {
                this._samplerDeclaration += `uniform sampler2DArray ${name};\n`;
                this.samplers.push(name);
            }
        }
        /**
         * @internal
         */
        _getGLType(type) {
            switch (type) {
                case NodeMaterialBlockConnectionPointTypes.Float:
                    return "float";
                case NodeMaterialBlockConnectionPointTypes.Int:
                    return "int";
                case NodeMaterialBlockConnectionPointTypes.Vector2:
                    return "vec2";
                case NodeMaterialBlockConnectionPointTypes.Color3:
                case NodeMaterialBlockConnectionPointTypes.Vector3:
                    return "vec3";
                case NodeMaterialBlockConnectionPointTypes.Color4:
                case NodeMaterialBlockConnectionPointTypes.Vector4:
                    return "vec4";
                case NodeMaterialBlockConnectionPointTypes.Matrix:
                    return "mat4";
            }
            return "";
        }
        /**
         * @internal
         */
        _emitExtension(name, extension, define = "") {
            if (this.extensions[name]) {
                return;
            }
            if (define) {
                extension = `#if ${define}\n${extension}\n#endif`;
            }
            this.extensions[name] = extension;
        }
        /**
         * @internal
         */
        _emitFunction(name, code, comments) {
            if (this.functions[name]) {
                return;
            }
            if (this.sharedData.emitComments) {
                code = comments + `\n` + code;
            }
            this.functions[name] = code;
        }
        /**
         * @internal
         */
        _emitCodeFromInclude(includeName, comments, options) {
            if (options && options.repeatKey) {
                return `#include<${includeName}>${options.substitutionVars ? "(" + options.substitutionVars + ")" : ""}[0..${options.repeatKey}]\n`;
            }
            let code = Effect.IncludesShadersStore[includeName] + "\n";
            if (this.sharedData.emitComments) {
                code = comments + `\n` + code;
            }
            if (!options) {
                return code;
            }
            if (options.replaceStrings) {
                for (let index = 0; index < options.replaceStrings.length; index++) {
                    const replaceString = options.replaceStrings[index];
                    code = code.replace(replaceString.search, replaceString.replace);
                }
            }
            return code;
        }
        /**
         * @internal
         */
        _emitFunctionFromInclude(includeName, comments, options, storeKey = "") {
            const key = includeName + storeKey;
            if (this.functions[key]) {
                return;
            }
            if (!options || (!options.removeAttributes && !options.removeUniforms && !options.removeVaryings && !options.removeIfDef && !options.replaceStrings)) {
                if (options && options.repeatKey) {
                    this.functions[key] = `#include<${includeName}>${options.substitutionVars ? "(" + options.substitutionVars + ")" : ""}[0..${options.repeatKey}]\n`;
                }
                else {
                    this.functions[key] = `#include<${includeName}>${(options === null || options === void 0 ? void 0 : options.substitutionVars) ? "(" + (options === null || options === void 0 ? void 0 : options.substitutionVars) + ")" : ""}\n`;
                }
                if (this.sharedData.emitComments) {
                    this.functions[key] = comments + `\n` + this.functions[key];
                }
                return;
            }
            this.functions[key] = Effect.IncludesShadersStore[includeName];
            if (this.sharedData.emitComments) {
                this.functions[key] = comments + `\n` + this.functions[key];
            }
            if (options.removeIfDef) {
                this.functions[key] = this.functions[key].replace(/^\s*?#ifdef.+$/gm, "");
                this.functions[key] = this.functions[key].replace(/^\s*?#endif.*$/gm, "");
                this.functions[key] = this.functions[key].replace(/^\s*?#else.*$/gm, "");
                this.functions[key] = this.functions[key].replace(/^\s*?#elif.*$/gm, "");
            }
            if (options.removeAttributes) {
                this.functions[key] = this.functions[key].replace(/\s*?attribute .+?;/g, "\n");
            }
            if (options.removeUniforms) {
                this.functions[key] = this.functions[key].replace(/\s*?uniform .*?;/g, "\n");
            }
            if (options.removeVaryings) {
                this.functions[key] = this.functions[key].replace(/\s*?(varying|in) .+?;/g, "\n");
            }
            if (options.replaceStrings) {
                for (let index = 0; index < options.replaceStrings.length; index++) {
                    const replaceString = options.replaceStrings[index];
                    this.functions[key] = this.functions[key].replace(replaceString.search, replaceString.replace);
                }
            }
        }
        /**
         * @internal
         */
        _registerTempVariable(name) {
            if (this.sharedData.temps.indexOf(name) !== -1) {
                return false;
            }
            this.sharedData.temps.push(name);
            return true;
        }
        /**
         * @internal
         */
        _emitVaryingFromString(name, type, define = "", notDefine = false) {
            if (this.sharedData.varyings.indexOf(name) !== -1) {
                return false;
            }
            this.sharedData.varyings.push(name);
            if (define) {
                if (define.startsWith("defined(")) {
                    this.sharedData.varyingDeclaration += `#if ${define}\n`;
                }
                else {
                    this.sharedData.varyingDeclaration += `${notDefine ? "#ifndef" : "#ifdef"} ${define}\n`;
                }
            }
            this.sharedData.varyingDeclaration += `varying ${type} ${name};\n`;
            if (define) {
                this.sharedData.varyingDeclaration += `#endif\n`;
            }
            return true;
        }
        /**
         * @internal
         */
        _emitUniformFromString(name, type, define = "", notDefine = false) {
            if (this.uniforms.indexOf(name) !== -1) {
                return;
            }
            this.uniforms.push(name);
            if (define) {
                if (define.startsWith("defined(")) {
                    this._uniformDeclaration += `#if ${define}\n`;
                }
                else {
                    this._uniformDeclaration += `${notDefine ? "#ifndef" : "#ifdef"} ${define}\n`;
                }
            }
            this._uniformDeclaration += `uniform ${type} ${name};\n`;
            if (define) {
                this._uniformDeclaration += `#endif\n`;
            }
        }
        /**
         * @internal
         */
        _emitFloat(value) {
            if (value.toString() === value.toFixed(0)) {
                return `${value}.0`;
            }
            return value.toString();
        }
    }

    /**
     * Class used to store shared data between 2 NodeMaterialBuildState
     */
    class NodeMaterialBuildStateSharedData {
        /** Creates a new shared data */
        constructor() {
            /**
             * Gets the list of emitted varyings
             */
            this.temps = new Array();
            /**
             * Gets the list of emitted varyings
             */
            this.varyings = new Array();
            /**
             * Gets the varying declaration string
             */
            this.varyingDeclaration = "";
            /**
             * Input blocks
             */
            this.inputBlocks = new Array();
            /**
             * Input blocks
             */
            this.textureBlocks = new Array();
            /**
             * Bindable blocks (Blocks that need to set data to the effect)
             */
            this.bindableBlocks = new Array();
            /**
             * Bindable blocks (Blocks that need to set data to the effect) that will always be called (by bindForSubMesh), contrary to bindableBlocks that won't be called if _mustRebind() returns false
             */
            this.forcedBindableBlocks = new Array();
            /**
             * List of blocks that can provide a compilation fallback
             */
            this.blocksWithFallbacks = new Array();
            /**
             * List of blocks that can provide a define update
             */
            this.blocksWithDefines = new Array();
            /**
             * List of blocks that can provide a repeatable content
             */
            this.repeatableContentBlocks = new Array();
            /**
             * List of blocks that can provide a dynamic list of uniforms
             */
            this.dynamicUniformBlocks = new Array();
            /**
             * List of blocks that can block the isReady function for the material
             */
            this.blockingBlocks = new Array();
            /**
             * Gets the list of animated inputs
             */
            this.animatedInputs = new Array();
            /** List of emitted variables */
            this.variableNames = {};
            /** List of emitted defines */
            this.defineNames = {};
            /**
             * Gets the compilation hints emitted at compilation time
             */
            this.hints = {
                needWorldViewMatrix: false,
                needWorldViewProjectionMatrix: false,
                needAlphaBlending: false,
                needAlphaTesting: false,
            };
            /**
             * List of compilation checks
             */
            this.checks = {
                emitVertex: false,
                emitFragment: false,
                notConnectedNonOptionalInputs: new Array(),
            };
            /**
             * Is vertex program allowed to be empty?
             */
            this.allowEmptyVertexProgram = false;
            // Exclude usual attributes from free variable names
            this.variableNames["position"] = 0;
            this.variableNames["normal"] = 0;
            this.variableNames["tangent"] = 0;
            this.variableNames["uv"] = 0;
            this.variableNames["uv2"] = 0;
            this.variableNames["uv3"] = 0;
            this.variableNames["uv4"] = 0;
            this.variableNames["uv5"] = 0;
            this.variableNames["uv6"] = 0;
            this.variableNames["color"] = 0;
            this.variableNames["matricesIndices"] = 0;
            this.variableNames["matricesWeights"] = 0;
            this.variableNames["matricesIndicesExtra"] = 0;
            this.variableNames["matricesWeightsExtra"] = 0;
            this.variableNames["diffuseBase"] = 0;
            this.variableNames["specularBase"] = 0;
            this.variableNames["worldPos"] = 0;
            this.variableNames["shadow"] = 0;
            this.variableNames["view"] = 0;
            // Exclude known varyings
            this.variableNames["vTBN"] = 0;
            // Exclude defines
            this.defineNames["MAINUV0"] = 0;
            this.defineNames["MAINUV1"] = 0;
            this.defineNames["MAINUV2"] = 0;
            this.defineNames["MAINUV3"] = 0;
            this.defineNames["MAINUV4"] = 0;
            this.defineNames["MAINUV5"] = 0;
            this.defineNames["MAINUV6"] = 0;
            this.defineNames["MAINUV7"] = 0;
        }
        /**
         * Emits console errors and exceptions if there is a failing check
         */
        emitErrors() {
            let errorMessage = "";
            if (!this.checks.emitVertex && !this.allowEmptyVertexProgram) {
                errorMessage += "NodeMaterial does not have a vertex output. You need to at least add a block that generates a glPosition value.\n";
            }
            if (!this.checks.emitFragment) {
                errorMessage += "NodeMaterial does not have a fragment output. You need to at least add a block that generates a glFragColor value.\n";
            }
            for (const notConnectedInput of this.checks.notConnectedNonOptionalInputs) {
                errorMessage += `input ${notConnectedInput.name} from block ${notConnectedInput.ownerBlock.name}[${notConnectedInput.ownerBlock.getClassName()}] is not connected and is not optional.\n`;
            }
            if (errorMessage) {
                throw "Build of NodeMaterial failed:\n" + errorMessage;
            }
        }
    }

    /**
     * Enum used to define the compatibility state between two connection points
     */
    var NodeMaterialConnectionPointCompatibilityStates;
    (function (NodeMaterialConnectionPointCompatibilityStates) {
        /** Points are compatibles */
        NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["Compatible"] = 0] = "Compatible";
        /** Points are incompatible because of their types */
        NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["TypeIncompatible"] = 1] = "TypeIncompatible";
        /** Points are incompatible because of their targets (vertex vs fragment) */
        NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["TargetIncompatible"] = 2] = "TargetIncompatible";
        /** Points are incompatible because they are in the same hierarchy **/
        NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["HierarchyIssue"] = 3] = "HierarchyIssue";
    })(NodeMaterialConnectionPointCompatibilityStates || (NodeMaterialConnectionPointCompatibilityStates = {}));
    /**
     * Defines the direction of a connection point
     */
    var NodeMaterialConnectionPointDirection;
    (function (NodeMaterialConnectionPointDirection) {
        /** Input */
        NodeMaterialConnectionPointDirection[NodeMaterialConnectionPointDirection["Input"] = 0] = "Input";
        /** Output */
        NodeMaterialConnectionPointDirection[NodeMaterialConnectionPointDirection["Output"] = 1] = "Output";
    })(NodeMaterialConnectionPointDirection || (NodeMaterialConnectionPointDirection = {}));
    /**
     * Defines a connection point for a block
     */
    class NodeMaterialConnectionPoint {
        /**
         * Checks if two types are equivalent
         * @param type1 type 1 to check
         * @param type2 type 2 to check
         * @returns true if both types are equivalent, else false
         */
        static AreEquivalentTypes(type1, type2) {
            switch (type1) {
                case NodeMaterialBlockConnectionPointTypes.Vector3: {
                    if (type2 === NodeMaterialBlockConnectionPointTypes.Color3) {
                        return true;
                    }
                    break;
                }
                case NodeMaterialBlockConnectionPointTypes.Vector4: {
                    if (type2 === NodeMaterialBlockConnectionPointTypes.Color4) {
                        return true;
                    }
                    break;
                }
                case NodeMaterialBlockConnectionPointTypes.Color3: {
                    if (type2 === NodeMaterialBlockConnectionPointTypes.Vector3) {
                        return true;
                    }
                    break;
                }
                case NodeMaterialBlockConnectionPointTypes.Color4: {
                    if (type2 === NodeMaterialBlockConnectionPointTypes.Vector4) {
                        return true;
                    }
                    break;
                }
            }
            return false;
        }
        /** Gets the direction of the point */
        get direction() {
            return this._direction;
        }
        /**
         * Gets or sets the associated variable name in the shader
         */
        get associatedVariableName() {
            if (this._ownerBlock.isInput) {
                return this._ownerBlock.associatedVariableName;
            }
            if ((!this._enforceAssociatedVariableName || !this._associatedVariableName) && this._connectedPoint) {
                return this._connectedPoint.associatedVariableName;
            }
            return this._associatedVariableName;
        }
        set associatedVariableName(value) {
            this._associatedVariableName = value;
        }
        /** Get the inner type (ie AutoDetect for instance instead of the inferred one) */
        get innerType() {
            if (this._linkedConnectionSource && this._linkedConnectionSource.isConnected) {
                return this.type;
            }
            return this._type;
        }
        /**
         * Gets or sets the connection point type (default is float)
         */
        get type() {
            if (this._type === NodeMaterialBlockConnectionPointTypes.AutoDetect) {
                if (this._ownerBlock.isInput) {
                    return this._ownerBlock.type;
                }
                if (this._connectedPoint) {
                    return this._connectedPoint.type;
                }
                if (this._linkedConnectionSource && this._linkedConnectionSource.isConnected) {
                    return this._linkedConnectionSource.type;
                }
            }
            if (this._type === NodeMaterialBlockConnectionPointTypes.BasedOnInput) {
                if (this._typeConnectionSource) {
                    if (!this._typeConnectionSource.isConnected && this._defaultConnectionPointType) {
                        return this._defaultConnectionPointType;
                    }
                    return this._typeConnectionSource.type;
                }
                else if (this._defaultConnectionPointType) {
                    return this._defaultConnectionPointType;
                }
            }
            return this._type;
        }
        set type(value) {
            this._type = value;
        }
        /** Gets or sets the target of that connection point */
        get target() {
            if (!this._prioritizeVertex || !this._ownerBlock) {
                return this._target;
            }
            if (this._target !== NodeMaterialBlockTargets.VertexAndFragment) {
                return this._target;
            }
            if (this._ownerBlock.target === NodeMaterialBlockTargets.Fragment) {
                return NodeMaterialBlockTargets.Fragment;
            }
            return NodeMaterialBlockTargets.Vertex;
        }
        set target(value) {
            this._target = value;
        }
        /**
         * Gets a boolean indicating that the current point is connected to another NodeMaterialBlock
         */
        get isConnected() {
            return this.connectedPoint !== null || this.hasEndpoints;
        }
        /**
         * Gets a boolean indicating that the current point is connected to an input block
         */
        get isConnectedToInputBlock() {
            return this.connectedPoint !== null && this.connectedPoint.ownerBlock.isInput;
        }
        /**
         * Gets a the connected input block (if any)
         */
        get connectInputBlock() {
            if (!this.isConnectedToInputBlock) {
                return null;
            }
            return this.connectedPoint.ownerBlock;
        }
        /** Get the other side of the connection (if any) */
        get connectedPoint() {
            return this._connectedPoint;
        }
        /** Get the block that owns this connection point */
        get ownerBlock() {
            return this._ownerBlock;
        }
        /** Get the block connected on the other side of this connection (if any) */
        get sourceBlock() {
            if (!this._connectedPoint) {
                return null;
            }
            return this._connectedPoint.ownerBlock;
        }
        /** Get the block connected on the endpoints of this connection (if any) */
        get connectedBlocks() {
            if (this._endpoints.length === 0) {
                return [];
            }
            return this._endpoints.map((e) => e.ownerBlock);
        }
        /** Gets the list of connected endpoints */
        get endpoints() {
            return this._endpoints;
        }
        /** Gets a boolean indicating if that output point is connected to at least one input */
        get hasEndpoints() {
            return this._endpoints && this._endpoints.length > 0;
        }
        /** Gets a boolean indicating that this connection has a path to the vertex output*/
        get isDirectlyConnectedToVertexOutput() {
            if (!this.hasEndpoints) {
                return false;
            }
            for (const endpoint of this._endpoints) {
                if (endpoint.ownerBlock.target === NodeMaterialBlockTargets.Vertex) {
                    return true;
                }
                if (endpoint.ownerBlock.target === NodeMaterialBlockTargets.Neutral || endpoint.ownerBlock.target === NodeMaterialBlockTargets.VertexAndFragment) {
                    if (endpoint.ownerBlock.outputs.some((o) => o.isDirectlyConnectedToVertexOutput)) {
                        return true;
                    }
                }
            }
            return false;
        }
        /** Gets a boolean indicating that this connection will be used in the vertex shader */
        get isConnectedInVertexShader() {
            if (this.target === NodeMaterialBlockTargets.Vertex) {
                return true;
            }
            if (!this.hasEndpoints) {
                return false;
            }
            for (const endpoint of this._endpoints) {
                if (endpoint.ownerBlock.target === NodeMaterialBlockTargets.Vertex) {
                    return true;
                }
                if (endpoint.target === NodeMaterialBlockTargets.Vertex) {
                    return true;
                }
                if (endpoint.ownerBlock.target === NodeMaterialBlockTargets.Neutral || endpoint.ownerBlock.target === NodeMaterialBlockTargets.VertexAndFragment) {
                    if (endpoint.ownerBlock.outputs.some((o) => o.isConnectedInVertexShader)) {
                        return true;
                    }
                }
            }
            return false;
        }
        /** Gets a boolean indicating that this connection will be used in the fragment shader */
        get isConnectedInFragmentShader() {
            if (this.target === NodeMaterialBlockTargets.Fragment) {
                return true;
            }
            if (!this.hasEndpoints) {
                return false;
            }
            for (const endpoint of this._endpoints) {
                if (endpoint.ownerBlock.target === NodeMaterialBlockTargets.Fragment) {
                    return true;
                }
                if (endpoint.ownerBlock.target === NodeMaterialBlockTargets.Neutral || endpoint.ownerBlock.target === NodeMaterialBlockTargets.VertexAndFragment) {
                    if (endpoint.ownerBlock.isConnectedInFragmentShader()) {
                        return true;
                    }
                }
            }
            return false;
        }
        /**
         * Creates a block suitable to be used as an input for this input point.
         * If null is returned, a block based on the point type will be created.
         * @returns The returned string parameter is the name of the output point of NodeMaterialBlock (first parameter of the returned array) that can be connected to the input
         */
        createCustomInputBlock() {
            return null;
        }
        /**
         * Creates a new connection point
         * @param name defines the connection point name
         * @param ownerBlock defines the block hosting this connection point
         * @param direction defines the direction of the connection point
         */
        constructor(name, ownerBlock, direction) {
            /** @internal */
            this._connectedPoint = null;
            this._endpoints = new Array();
            /** @internal */
            this._typeConnectionSource = null;
            /** @internal */
            this._defaultConnectionPointType = null;
            /** @internal */
            this._linkedConnectionSource = null;
            /** @internal */
            this._acceptedConnectionPointType = null;
            this._type = NodeMaterialBlockConnectionPointTypes.Float;
            /** @internal */
            this._enforceAssociatedVariableName = false;
            /** Indicates that this connection point needs dual validation before being connected to another point */
            this.needDualDirectionValidation = false;
            /**
             * Gets or sets the additional types supported by this connection point
             */
            this.acceptedConnectionPointTypes = new Array();
            /**
             * Gets or sets the additional types excluded by this connection point
             */
            this.excludedConnectionPointTypes = new Array();
            /**
             * Observable triggered when this point is connected
             */
            this.onConnectionObservable = new Observable$1();
            /**
             * Gets or sets a boolean indicating that this connection point is exposed on a frame
             */
            this.isExposedOnFrame = false;
            /**
             * Gets or sets number indicating the position that the port is exposed to on a frame
             */
            this.exposedPortPosition = -1;
            /** @internal */
            this._prioritizeVertex = false;
            this._target = NodeMaterialBlockTargets.VertexAndFragment;
            this._ownerBlock = ownerBlock;
            this.name = name;
            this._direction = direction;
        }
        /**
         * Gets the current class name e.g. "NodeMaterialConnectionPoint"
         * @returns the class name
         */
        getClassName() {
            return "NodeMaterialConnectionPoint";
        }
        /**
         * Gets a boolean indicating if the current point can be connected to another point
         * @param connectionPoint defines the other connection point
         * @returns a boolean
         */
        canConnectTo(connectionPoint) {
            return this.checkCompatibilityState(connectionPoint) === NodeMaterialConnectionPointCompatibilityStates.Compatible;
        }
        /**
         * Gets a number indicating if the current point can be connected to another point
         * @param connectionPoint defines the other connection point
         * @returns a number defining the compatibility state
         */
        checkCompatibilityState(connectionPoint) {
            const ownerBlock = this._ownerBlock;
            const otherBlock = connectionPoint.ownerBlock;
            if (ownerBlock.target === NodeMaterialBlockTargets.Fragment) {
                // Let's check we are not going reverse
                if (otherBlock.target === NodeMaterialBlockTargets.Vertex) {
                    return NodeMaterialConnectionPointCompatibilityStates.TargetIncompatible;
                }
                for (const output of otherBlock.outputs) {
                    if (output.ownerBlock.target != NodeMaterialBlockTargets.Neutral && output.isConnectedInVertexShader) {
                        return NodeMaterialConnectionPointCompatibilityStates.TargetIncompatible;
                    }
                }
            }
            if (this.type !== connectionPoint.type && connectionPoint.innerType !== NodeMaterialBlockConnectionPointTypes.AutoDetect) {
                // Equivalents
                if (NodeMaterialConnectionPoint.AreEquivalentTypes(this.type, connectionPoint.type)) {
                    return NodeMaterialConnectionPointCompatibilityStates.Compatible;
                }
                // Accepted types
                if ((connectionPoint.acceptedConnectionPointTypes && connectionPoint.acceptedConnectionPointTypes.indexOf(this.type) !== -1) ||
                    (connectionPoint._acceptedConnectionPointType && NodeMaterialConnectionPoint.AreEquivalentTypes(connectionPoint._acceptedConnectionPointType.type, this.type))) {
                    return NodeMaterialConnectionPointCompatibilityStates.Compatible;
                }
                else {
                    return NodeMaterialConnectionPointCompatibilityStates.TypeIncompatible;
                }
            }
            // Excluded
            if (connectionPoint.excludedConnectionPointTypes && connectionPoint.excludedConnectionPointTypes.indexOf(this.type) !== -1) {
                return NodeMaterialConnectionPointCompatibilityStates.TypeIncompatible;
            }
            // Check hierarchy
            let targetBlock = otherBlock;
            let sourceBlock = ownerBlock;
            if (this.direction === NodeMaterialConnectionPointDirection.Input) {
                targetBlock = ownerBlock;
                sourceBlock = otherBlock;
            }
            if (targetBlock.isAnAncestorOf(sourceBlock)) {
                return NodeMaterialConnectionPointCompatibilityStates.HierarchyIssue;
            }
            return NodeMaterialConnectionPointCompatibilityStates.Compatible;
        }
        /**
         * Connect this point to another connection point
         * @param connectionPoint defines the other connection point
         * @param ignoreConstraints defines if the system will ignore connection type constraints (default is false)
         * @returns the current connection point
         */
        connectTo(connectionPoint, ignoreConstraints = false) {
            if (!ignoreConstraints && !this.canConnectTo(connectionPoint)) {
                throw "Cannot connect these two connectors.";
            }
            this._endpoints.push(connectionPoint);
            connectionPoint._connectedPoint = this;
            this._enforceAssociatedVariableName = false;
            this.onConnectionObservable.notifyObservers(connectionPoint);
            connectionPoint.onConnectionObservable.notifyObservers(this);
            return this;
        }
        /**
         * Disconnect this point from one of his endpoint
         * @param endpoint defines the other connection point
         * @returns the current connection point
         */
        disconnectFrom(endpoint) {
            const index = this._endpoints.indexOf(endpoint);
            if (index === -1) {
                return this;
            }
            this._endpoints.splice(index, 1);
            endpoint._connectedPoint = null;
            this._enforceAssociatedVariableName = false;
            endpoint._enforceAssociatedVariableName = false;
            return this;
        }
        /**
         * Fill the list of excluded connection point types with all types other than those passed in the parameter
         * @param mask Types (ORed values of NodeMaterialBlockConnectionPointTypes) that are allowed, and thus will not be pushed to the excluded list
         */
        addExcludedConnectionPointFromAllowedTypes(mask) {
            let bitmask = 1;
            while (bitmask < NodeMaterialBlockConnectionPointTypes.All) {
                if (!(mask & bitmask)) {
                    this.excludedConnectionPointTypes.push(bitmask);
                }
                bitmask = bitmask << 1;
            }
        }
        /**
         * Serializes this point in a JSON representation
         * @param isInput defines if the connection point is an input (default is true)
         * @returns the serialized point object
         */
        serialize(isInput = true) {
            const serializationObject = {};
            serializationObject.name = this.name;
            serializationObject.displayName = this.displayName;
            if (isInput && this.connectedPoint) {
                serializationObject.inputName = this.name;
                serializationObject.targetBlockId = this.connectedPoint.ownerBlock.uniqueId;
                serializationObject.targetConnectionName = this.connectedPoint.name;
                serializationObject.isExposedOnFrame = true;
                serializationObject.exposedPortPosition = this.exposedPortPosition;
            }
            if (this.isExposedOnFrame || this.exposedPortPosition >= 0) {
                serializationObject.isExposedOnFrame = true;
                serializationObject.exposedPortPosition = this.exposedPortPosition;
            }
            return serializationObject;
        }
        /**
         * Release resources
         */
        dispose() {
            this.onConnectionObservable.clear();
        }
    }

    /**
     * Defines a block that can be used inside a node based material
     */
    class NodeMaterialBlock {
        /**
         * Gets the name of the block
         */
        get name() {
            return this._name;
        }
        /**
         * Sets the name of the block. Will check if the name is valid.
         */
        set name(newName) {
            if (!this.validateBlockName(newName)) {
                return;
            }
            this._name = newName;
        }
        /**
         * Gets a boolean indicating that this block can only be used once per NodeMaterial
         */
        get isUnique() {
            return this._isUnique;
        }
        /**
         * Gets a boolean indicating that this block is an end block (e.g. it is generating a system value)
         */
        get isFinalMerger() {
            return this._isFinalMerger;
        }
        /**
         * Gets a boolean indicating that this block is an input (e.g. it sends data to the shader)
         */
        get isInput() {
            return this._isInput;
        }
        /**
         * Gets a boolean indicating if this block is a teleport out
         */
        get isTeleportOut() {
            return this._isTeleportOut;
        }
        /**
         * Gets a boolean indicating if this block is a teleport in
         */
        get isTeleportIn() {
            return this._isTeleportIn;
        }
        /**
         * Gets or sets the build Id
         */
        get buildId() {
            return this._buildId;
        }
        set buildId(value) {
            this._buildId = value;
        }
        /**
         * Gets or sets the target of the block
         */
        get target() {
            return this._target;
        }
        set target(value) {
            if ((this._target & value) !== 0) {
                return;
            }
            this._target = value;
        }
        /**
         * Gets the list of input points
         */
        get inputs() {
            return this._inputs;
        }
        /** Gets the list of output points */
        get outputs() {
            return this._outputs;
        }
        /**
         * Find an input by its name
         * @param name defines the name of the input to look for
         * @returns the input or null if not found
         */
        getInputByName(name) {
            const filter = this._inputs.filter((e) => e.name === name);
            if (filter.length) {
                return filter[0];
            }
            return null;
        }
        /**
         * Find an output by its name
         * @param name defines the name of the output to look for
         * @returns the output or null if not found
         */
        getOutputByName(name) {
            const filter = this._outputs.filter((e) => e.name === name);
            if (filter.length) {
                return filter[0];
            }
            return null;
        }
        /**
         * Creates a new NodeMaterialBlock
         * @param name defines the block name
         * @param target defines the target of that block (Vertex by default)
         * @param isFinalMerger defines a boolean indicating that this block is an end block (e.g. it is generating a system value). Default is false
         */
        constructor(name, target = NodeMaterialBlockTargets.Vertex, isFinalMerger = false) {
            this._isFinalMerger = false;
            this._isInput = false;
            this._isTeleportOut = false;
            this._isTeleportIn = false;
            this._name = "";
            this._isUnique = false;
            /** Gets or sets a boolean indicating that only one input can be connected at a time */
            this.inputsAreExclusive = false;
            /** @internal */
            this._codeVariableName = "";
            /** @internal */
            this._inputs = new Array();
            /** @internal */
            this._outputs = new Array();
            /**
             * Gets or sets the comments associated with this block
             */
            this.comments = "";
            /** Gets or sets a boolean indicating that this input can be edited in the Inspector (false by default) */
            this.visibleInInspector = false;
            /** Gets or sets a boolean indicating that this input can be edited from a collapsed frame */
            this.visibleOnFrame = false;
            this._target = target;
            this._originalTargetIsNeutral = target === NodeMaterialBlockTargets.Neutral;
            this._isFinalMerger = isFinalMerger;
            this._isInput = this.getClassName() === "InputBlock";
            this._isTeleportOut = this.getClassName() === "NodeMaterialTeleportOutBlock";
            this._isTeleportIn = this.getClassName() === "NodeMaterialTeleportInBlock";
            this._name = name;
            this.uniqueId = UniqueIdGenerator.UniqueId;
        }
        /** @internal */
        _setInitialTarget(target) {
            this._target = target;
            this._originalTargetIsNeutral = target === NodeMaterialBlockTargets.Neutral;
        }
        /**
         * Initialize the block and prepare the context for build
         * @param state defines the state that will be used for the build
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        initialize(state) {
            // Do nothing
        }
        /**
         * Bind data to effect. Will only be called for blocks with isBindable === true
         * @param effect defines the effect to bind data to
         * @param nodeMaterial defines the hosting NodeMaterial
         * @param mesh defines the mesh that will be rendered
         * @param subMesh defines the submesh that will be rendered
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bind(effect, nodeMaterial, mesh, subMesh) {
            // Do nothing
        }
        _declareOutput(output, state) {
            return `${state._getGLType(output.type)} ${output.associatedVariableName}`;
        }
        _writeVariable(currentPoint) {
            const connectionPoint = currentPoint.connectedPoint;
            if (connectionPoint) {
                return `${currentPoint.associatedVariableName}`;
            }
            return `0.`;
        }
        _writeFloat(value) {
            let stringVersion = value.toString();
            if (stringVersion.indexOf(".") === -1) {
                stringVersion += ".0";
            }
            return `${stringVersion}`;
        }
        /**
         * Gets the current class name e.g. "NodeMaterialBlock"
         * @returns the class name
         */
        getClassName() {
            return "NodeMaterialBlock";
        }
        /** Gets a boolean indicating that this connection will be used in the fragment shader */
        isConnectedInFragmentShader() {
            return this.outputs.some((o) => o.isConnectedInFragmentShader);
        }
        /**
         * Register a new input. Must be called inside a block constructor
         * @param name defines the connection point name
         * @param type defines the connection point type
         * @param isOptional defines a boolean indicating that this input can be omitted
         * @param target defines the target to use to limit the connection point (will be VertexAndFragment by default)
         * @param point an already created connection point. If not provided, create a new one
         * @returns the current block
         */
        registerInput(name, type, isOptional = false, target, point) {
            point = point !== null && point !== void 0 ? point : new NodeMaterialConnectionPoint(name, this, NodeMaterialConnectionPointDirection.Input);
            point.type = type;
            point.isOptional = isOptional;
            if (target) {
                point.target = target;
            }
            this._inputs.push(point);
            return this;
        }
        /**
         * Register a new output. Must be called inside a block constructor
         * @param name defines the connection point name
         * @param type defines the connection point type
         * @param target defines the target to use to limit the connection point (will be VertexAndFragment by default)
         * @param point an already created connection point. If not provided, create a new one
         * @returns the current block
         */
        registerOutput(name, type, target, point) {
            point = point !== null && point !== void 0 ? point : new NodeMaterialConnectionPoint(name, this, NodeMaterialConnectionPointDirection.Output);
            point.type = type;
            if (target) {
                point.target = target;
            }
            this._outputs.push(point);
            return this;
        }
        /**
         * Will return the first available input e.g. the first one which is not an uniform or an attribute
         * @param forOutput defines an optional connection point to check compatibility with
         * @returns the first available input or null
         */
        getFirstAvailableInput(forOutput = null) {
            for (const input of this._inputs) {
                if (!input.connectedPoint) {
                    if (!forOutput || forOutput.type === input.type || input.type === NodeMaterialBlockConnectionPointTypes.AutoDetect) {
                        return input;
                    }
                }
            }
            return null;
        }
        /**
         * Will return the first available output e.g. the first one which is not yet connected and not a varying
         * @param forBlock defines an optional block to check compatibility with
         * @returns the first available input or null
         */
        getFirstAvailableOutput(forBlock = null) {
            for (const output of this._outputs) {
                if (!forBlock || !forBlock.target || forBlock.target === NodeMaterialBlockTargets.Neutral || (forBlock.target & output.target) !== 0) {
                    return output;
                }
            }
            return null;
        }
        /**
         * Gets the sibling of the given output
         * @param current defines the current output
         * @returns the next output in the list or null
         */
        getSiblingOutput(current) {
            const index = this._outputs.indexOf(current);
            if (index === -1 || index >= this._outputs.length) {
                return null;
            }
            return this._outputs[index + 1];
        }
        /**
         * Checks if the current block is an ancestor of a given block
         * @param block defines the potential descendant block to check
         * @returns true if block is a descendant
         */
        isAnAncestorOf(block) {
            for (const output of this._outputs) {
                if (!output.hasEndpoints) {
                    continue;
                }
                for (const endpoint of output.endpoints) {
                    if (endpoint.ownerBlock === block) {
                        return true;
                    }
                    if (endpoint.ownerBlock.isAnAncestorOf(block)) {
                        return true;
                    }
                }
            }
            return false;
        }
        /**
         * Connect current block with another block
         * @param other defines the block to connect with
         * @param options define the various options to help pick the right connections
         * @param options.input
         * @param options.output
         * @param options.outputSwizzle
         * @returns the current block
         */
        connectTo(other, options) {
            if (this._outputs.length === 0) {
                return;
            }
            let output = options && options.output ? this.getOutputByName(options.output) : this.getFirstAvailableOutput(other);
            let notFound = true;
            while (notFound) {
                const input = options && options.input ? other.getInputByName(options.input) : other.getFirstAvailableInput(output);
                if (output && input && output.canConnectTo(input)) {
                    output.connectTo(input);
                    notFound = false;
                }
                else if (!output) {
                    throw "Unable to find a compatible match";
                }
                else {
                    output = this.getSiblingOutput(output);
                }
            }
            return this;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _buildBlock(state) {
            // Empty. Must be defined by child nodes
        }
        /**
         * Add uniforms, samplers and uniform buffers at compilation time
         * @param state defines the state to update
         * @param nodeMaterial defines the node material requesting the update
         * @param defines defines the material defines to update
         * @param uniformBuffers defines the list of uniform buffer names
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateUniformsAndSamples(state, nodeMaterial, defines, uniformBuffers) {
            // Do nothing
        }
        /**
         * Add potential fallbacks if shader compilation fails
         * @param mesh defines the mesh to be rendered
         * @param fallbacks defines the current prioritized list of fallbacks
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        provideFallbacks(mesh, fallbacks) {
            // Do nothing
        }
        /**
         * Initialize defines for shader compilation
         * @param mesh defines the mesh to be rendered
         * @param nodeMaterial defines the node material requesting the update
         * @param defines defines the material defines to update
         * @param useInstances specifies that instances should be used
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        initializeDefines(mesh, nodeMaterial, defines, useInstances = false) { }
        /**
         * Update defines for shader compilation
         * @param mesh defines the mesh to be rendered
         * @param nodeMaterial defines the node material requesting the update
         * @param defines defines the material defines to update
         * @param useInstances specifies that instances should be used
         * @param subMesh defines which submesh to render
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        prepareDefines(mesh, nodeMaterial, defines, useInstances = false, subMesh) {
            // Do nothing
        }
        /**
         * Lets the block try to connect some inputs automatically
         * @param material defines the hosting NodeMaterial
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        autoConfigure(material) {
            // Do nothing
        }
        /**
         * Function called when a block is declared as repeatable content generator
         * @param vertexShaderState defines the current compilation state for the vertex shader
         * @param fragmentShaderState defines the current compilation state for the fragment shader
         * @param mesh defines the mesh to be rendered
         * @param defines defines the material defines to update
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        replaceRepeatableContent(vertexShaderState, fragmentShaderState, mesh, defines) {
            // Do nothing
        }
        /** Gets a boolean indicating that the code of this block will be promoted to vertex shader even if connected to fragment output */
        get willBeGeneratedIntoVertexShaderFromFragmentShader() {
            if (this.isInput || this.isFinalMerger) {
                return false;
            }
            if (this._outputs.some((o) => o.isDirectlyConnectedToVertexOutput)) {
                return false;
            }
            if (this.target === NodeMaterialBlockTargets.Vertex) {
                return false;
            }
            if (this.target === NodeMaterialBlockTargets.VertexAndFragment || this.target === NodeMaterialBlockTargets.Neutral) {
                if (this._outputs.some((o) => o.isConnectedInVertexShader)) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Checks if the block is ready
         * @param mesh defines the mesh to be rendered
         * @param nodeMaterial defines the node material requesting the update
         * @param defines defines the material defines to update
         * @param useInstances specifies that instances should be used
         * @returns true if the block is ready
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isReady(mesh, nodeMaterial, defines, useInstances = false) {
            return true;
        }
        _linkConnectionTypes(inputIndex0, inputIndex1, looseCoupling = false) {
            if (looseCoupling) {
                this._inputs[inputIndex1]._acceptedConnectionPointType = this._inputs[inputIndex0];
            }
            else {
                this._inputs[inputIndex0]._linkedConnectionSource = this._inputs[inputIndex1];
            }
            this._inputs[inputIndex1]._linkedConnectionSource = this._inputs[inputIndex0];
        }
        _processBuild(block, state, input, activeBlocks) {
            block.build(state, activeBlocks);
            const localBlockIsFragment = state._vertexState != null;
            const otherBlockWasGeneratedInVertexShader = block._buildTarget === NodeMaterialBlockTargets.Vertex && block.target !== NodeMaterialBlockTargets.VertexAndFragment;
            if (localBlockIsFragment &&
                ((block.target & block._buildTarget) === 0 ||
                    (block.target & input.target) === 0 ||
                    (this.target !== NodeMaterialBlockTargets.VertexAndFragment && otherBlockWasGeneratedInVertexShader))) {
                // context switch! We need a varying
                if ((!block.isInput && state.target !== block._buildTarget) || // block was already emitted by vertex shader
                    (block.isInput && block.isAttribute && !block._noContextSwitch) // block is an attribute
                ) {
                    const connectedPoint = input.connectedPoint;
                    if (state._vertexState._emitVaryingFromString("v_" + connectedPoint.associatedVariableName, state._getGLType(connectedPoint.type))) {
                        state._vertexState.compilationString += `${"v_" + connectedPoint.associatedVariableName} = ${connectedPoint.associatedVariableName};\n`;
                    }
                    input.associatedVariableName = "v_" + connectedPoint.associatedVariableName;
                    input._enforceAssociatedVariableName = true;
                }
            }
        }
        /**
         * Validates the new name for the block node.
         * @param newName the new name to be given to the node.
         * @returns false if the name is a reserve word, else true.
         */
        validateBlockName(newName) {
            const reservedNames = [
                "position",
                "normal",
                "tangent",
                "particle_positionw",
                "uv",
                "uv2",
                "uv3",
                "uv4",
                "uv5",
                "uv6",
                "position2d",
                "particle_uv",
                "matricesIndices",
                "matricesWeights",
                "world0",
                "world1",
                "world2",
                "world3",
                "particle_color",
                "particle_texturemask",
            ];
            for (const reservedName of reservedNames) {
                if (newName === reservedName) {
                    return false;
                }
            }
            return true;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _customBuildStep(state, activeBlocks) {
            // Must be implemented by children
        }
        /**
         * Compile the current node and generate the shader code
         * @param state defines the current compilation state (uniforms, samplers, current string)
         * @param activeBlocks defines the list of active blocks (i.e. blocks to compile)
         * @returns true if already built
         */
        build(state, activeBlocks) {
            if (this._buildId === state.sharedData.buildId) {
                return true;
            }
            if (!this.isInput) {
                /** Prepare outputs */
                for (const output of this._outputs) {
                    if (!output.associatedVariableName) {
                        output.associatedVariableName = state._getFreeVariableName(output.name);
                    }
                }
            }
            // Check if "parent" blocks are compiled
            for (const input of this._inputs) {
                if (!input.connectedPoint) {
                    if (!input.isOptional) {
                        // Emit a warning
                        state.sharedData.checks.notConnectedNonOptionalInputs.push(input);
                    }
                    continue;
                }
                if (this.target !== NodeMaterialBlockTargets.Neutral) {
                    if ((input.target & this.target) === 0) {
                        continue;
                    }
                    if ((input.target & state.target) === 0) {
                        continue;
                    }
                }
                const block = input.connectedPoint.ownerBlock;
                if (block && block !== this) {
                    this._processBuild(block, state, input, activeBlocks);
                }
            }
            this._customBuildStep(state, activeBlocks);
            if (this._buildId === state.sharedData.buildId) {
                return true; // Need to check again as inputs can be connected multiple time to this endpoint
            }
            // Logs
            if (state.sharedData.verbose) {
                console.log(`${state.target === NodeMaterialBlockTargets.Vertex ? "Vertex shader" : "Fragment shader"}: Building ${this.name} [${this.getClassName()}]`);
            }
            // Checks final outputs
            if (this.isFinalMerger) {
                switch (state.target) {
                    case NodeMaterialBlockTargets.Vertex:
                        state.sharedData.checks.emitVertex = true;
                        break;
                    case NodeMaterialBlockTargets.Fragment:
                        state.sharedData.checks.emitFragment = true;
                        break;
                }
            }
            if (!this.isInput && state.sharedData.emitComments) {
                state.compilationString += `\n//${this.name}\n`;
            }
            this._buildBlock(state);
            this._buildId = state.sharedData.buildId;
            this._buildTarget = state.target;
            // Compile connected blocks
            for (const output of this._outputs) {
                if ((output.target & state.target) === 0) {
                    continue;
                }
                for (const endpoint of output.endpoints) {
                    const block = endpoint.ownerBlock;
                    if (block && (block.target & state.target) !== 0 && activeBlocks.indexOf(block) !== -1) {
                        this._processBuild(block, state, endpoint, activeBlocks);
                    }
                }
            }
            return false;
        }
        _inputRename(name) {
            return name;
        }
        _outputRename(name) {
            return name;
        }
        _dumpPropertiesCode() {
            const variableName = this._codeVariableName;
            return `${variableName}.visibleInInspector = ${this.visibleInInspector};\n${variableName}.visibleOnFrame = ${this.visibleOnFrame};\n${variableName}.target = ${this.target};\n`;
        }
        /**
         * @internal
         */
        _dumpCode(uniqueNames, alreadyDumped) {
            alreadyDumped.push(this);
            // Get unique name
            const nameAsVariableName = this.name.replace(/[^A-Za-z_]+/g, "");
            this._codeVariableName = nameAsVariableName || `${this.getClassName()}_${this.uniqueId}`;
            if (uniqueNames.indexOf(this._codeVariableName) !== -1) {
                let index = 0;
                do {
                    index++;
                    this._codeVariableName = nameAsVariableName + index;
                } while (uniqueNames.indexOf(this._codeVariableName) !== -1);
            }
            uniqueNames.push(this._codeVariableName);
            // Declaration
            let codeString = `\n// ${this.getClassName()}\n`;
            if (this.comments) {
                codeString += `// ${this.comments}\n`;
            }
            codeString += `var ${this._codeVariableName} = new BABYLON.${this.getClassName()}("${this.name}");\n`;
            // Properties
            codeString += this._dumpPropertiesCode();
            // Inputs
            for (const input of this.inputs) {
                if (!input.isConnected) {
                    continue;
                }
                const connectedOutput = input.connectedPoint;
                const connectedBlock = connectedOutput.ownerBlock;
                if (alreadyDumped.indexOf(connectedBlock) === -1) {
                    codeString += connectedBlock._dumpCode(uniqueNames, alreadyDumped);
                }
            }
            // Outputs
            for (const output of this.outputs) {
                if (!output.hasEndpoints) {
                    continue;
                }
                for (const endpoint of output.endpoints) {
                    const connectedBlock = endpoint.ownerBlock;
                    if (connectedBlock && alreadyDumped.indexOf(connectedBlock) === -1) {
                        codeString += connectedBlock._dumpCode(uniqueNames, alreadyDumped);
                    }
                }
            }
            return codeString;
        }
        /**
         * @internal
         */
        _dumpCodeForOutputConnections(alreadyDumped) {
            let codeString = "";
            if (alreadyDumped.indexOf(this) !== -1) {
                return codeString;
            }
            alreadyDumped.push(this);
            for (const input of this.inputs) {
                if (!input.isConnected) {
                    continue;
                }
                const connectedOutput = input.connectedPoint;
                const connectedBlock = connectedOutput.ownerBlock;
                codeString += connectedBlock._dumpCodeForOutputConnections(alreadyDumped);
                codeString += `${connectedBlock._codeVariableName}.${connectedBlock._outputRename(connectedOutput.name)}.connectTo(${this._codeVariableName}.${this._inputRename(input.name)});\n`;
            }
            return codeString;
        }
        /**
         * Clone the current block to a new identical block
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @returns a copy of the current block
         */
        clone(scene, rootUrl = "") {
            const serializationObject = this.serialize();
            const blockType = GetClass(serializationObject.customType);
            if (blockType) {
                const block = new blockType();
                block._deserialize(serializationObject, scene, rootUrl);
                return block;
            }
            return null;
        }
        /**
         * Serializes this block in a JSON representation
         * @returns the serialized block object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.customType = "BABYLON." + this.getClassName();
            serializationObject.id = this.uniqueId;
            serializationObject.name = this.name;
            serializationObject.comments = this.comments;
            serializationObject.visibleInInspector = this.visibleInInspector;
            serializationObject.visibleOnFrame = this.visibleOnFrame;
            serializationObject.target = this.target;
            serializationObject.inputs = [];
            serializationObject.outputs = [];
            for (const input of this.inputs) {
                serializationObject.inputs.push(input.serialize());
            }
            for (const output of this.outputs) {
                serializationObject.outputs.push(output.serialize(false));
            }
            return serializationObject;
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _deserialize(serializationObject, scene, rootUrl) {
            var _a;
            this.name = serializationObject.name;
            this.comments = serializationObject.comments;
            this.visibleInInspector = !!serializationObject.visibleInInspector;
            this.visibleOnFrame = !!serializationObject.visibleOnFrame;
            this._target = (_a = serializationObject.target) !== null && _a !== void 0 ? _a : this.target;
            this._deserializePortDisplayNamesAndExposedOnFrame(serializationObject);
        }
        _deserializePortDisplayNamesAndExposedOnFrame(serializationObject) {
            const serializedInputs = serializationObject.inputs;
            const serializedOutputs = serializationObject.outputs;
            if (serializedInputs) {
                serializedInputs.forEach((port, i) => {
                    if (port.displayName) {
                        this.inputs[i].displayName = port.displayName;
                    }
                    if (port.isExposedOnFrame) {
                        this.inputs[i].isExposedOnFrame = port.isExposedOnFrame;
                        this.inputs[i].exposedPortPosition = port.exposedPortPosition;
                    }
                });
            }
            if (serializedOutputs) {
                serializedOutputs.forEach((port, i) => {
                    if (port.displayName) {
                        this.outputs[i].displayName = port.displayName;
                    }
                    if (port.isExposedOnFrame) {
                        this.outputs[i].isExposedOnFrame = port.isExposedOnFrame;
                        this.outputs[i].exposedPortPosition = port.exposedPortPosition;
                    }
                });
            }
        }
        /**
         * Release resources
         */
        dispose() {
            for (const input of this.inputs) {
                input.dispose();
            }
            for (const output of this.outputs) {
                output.dispose();
            }
        }
    }

    /**
     * Block used to transform a vector (2, 3 or 4) with a matrix. It will generate a Vector4
     */
    class TransformBlock extends NodeMaterialBlock {
        /**
         * Creates a new TransformBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Neutral);
            /**
             * Defines the value to use to complement W value to transform it to a Vector4
             */
            this.complementW = 1;
            /**
             * Defines the value to use to complement z value to transform it to a Vector4
             */
            this.complementZ = 0;
            this.target = NodeMaterialBlockTargets.Vertex;
            this.registerInput("vector", NodeMaterialBlockConnectionPointTypes.AutoDetect);
            this.registerInput("transform", NodeMaterialBlockConnectionPointTypes.Matrix);
            this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.Vector4);
            this.registerOutput("xyz", NodeMaterialBlockConnectionPointTypes.Vector3);
            this._inputs[0].onConnectionObservable.add((other) => {
                if (other.ownerBlock.isInput) {
                    const otherAsInput = other.ownerBlock;
                    if (otherAsInput.name === "normal" || otherAsInput.name === "tangent") {
                        this.complementW = 0;
                    }
                }
            });
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "TransformBlock";
        }
        /**
         * Gets the vector input
         */
        get vector() {
            return this._inputs[0];
        }
        /**
         * Gets the output component
         */
        get output() {
            return this._outputs[0];
        }
        /**
         * Gets the xyz output component
         */
        get xyz() {
            return this._outputs[1];
        }
        /**
         * Gets the matrix transform input
         */
        get transform() {
            return this._inputs[1];
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const vector = this.vector;
            const transform = this.transform;
            if (vector.connectedPoint) {
                // None uniform scaling case.
                if (this.complementW === 0) {
                    const comments = `//${this.name}`;
                    state._emitFunctionFromInclude("helperFunctions", comments);
                    state.sharedData.blocksWithDefines.push(this);
                    const transformName = state._getFreeVariableName(`${transform.associatedVariableName}_NUS`);
                    state.compilationString += `mat3 ${transformName} = mat3(${transform.associatedVariableName});\n`;
                    state.compilationString += `#ifdef NONUNIFORMSCALING\n`;
                    state.compilationString += `${transformName} = transposeMat3(inverseMat3(${transformName}));\n`;
                    state.compilationString += `#endif\n`;
                    switch (vector.connectedPoint.type) {
                        case NodeMaterialBlockConnectionPointTypes.Vector2:
                            state.compilationString +=
                                this._declareOutput(this.output, state) +
                                    ` = vec4(${transformName} * vec3(${vector.associatedVariableName}, ${this._writeFloat(this.complementZ)}), ${this._writeFloat(this.complementW)});\n`;
                            break;
                        case NodeMaterialBlockConnectionPointTypes.Vector3:
                        case NodeMaterialBlockConnectionPointTypes.Color3:
                            state.compilationString +=
                                this._declareOutput(this.output, state) + ` = vec4(${transformName} * ${vector.associatedVariableName}, ${this._writeFloat(this.complementW)});\n`;
                            break;
                        default:
                            state.compilationString +=
                                this._declareOutput(this.output, state) + ` = vec4(${transformName} * ${vector.associatedVariableName}.xyz, ${this._writeFloat(this.complementW)});\n`;
                            break;
                    }
                }
                else {
                    const transformName = transform.associatedVariableName;
                    switch (vector.connectedPoint.type) {
                        case NodeMaterialBlockConnectionPointTypes.Vector2:
                            state.compilationString +=
                                this._declareOutput(this.output, state) +
                                    ` = ${transformName} * vec4(${vector.associatedVariableName}, ${this._writeFloat(this.complementZ)}, ${this._writeFloat(this.complementW)});\n`;
                            break;
                        case NodeMaterialBlockConnectionPointTypes.Vector3:
                        case NodeMaterialBlockConnectionPointTypes.Color3:
                            state.compilationString +=
                                this._declareOutput(this.output, state) + ` = ${transformName} * vec4(${vector.associatedVariableName}, ${this._writeFloat(this.complementW)});\n`;
                            break;
                        default:
                            state.compilationString += this._declareOutput(this.output, state) + ` = ${transformName} * ${vector.associatedVariableName};\n`;
                            break;
                    }
                }
                if (this.xyz.hasEndpoints) {
                    state.compilationString += this._declareOutput(this.xyz, state) + ` = ${this.output.associatedVariableName}.xyz;\n`;
                }
            }
            return this;
        }
        /**
         * Update defines for shader compilation
         * @param mesh defines the mesh to be rendered
         * @param nodeMaterial defines the node material requesting the update
         * @param defines defines the material defines to update
         */
        prepareDefines(mesh, nodeMaterial, defines) {
            // Do nothing
            if (mesh.nonUniformScaling) {
                defines.setValue("NONUNIFORMSCALING", true);
            }
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.complementZ = this.complementZ;
            serializationObject.complementW = this.complementW;
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            super._deserialize(serializationObject, scene, rootUrl);
            this.complementZ = serializationObject.complementZ !== undefined ? serializationObject.complementZ : 0.0;
            this.complementW = serializationObject.complementW !== undefined ? serializationObject.complementW : 1.0;
        }
        _dumpPropertiesCode() {
            let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.complementZ = ${this.complementZ};\n`;
            codeString += `${this._codeVariableName}.complementW = ${this.complementW};\n`;
            return codeString;
        }
    }
    RegisterClass("BABYLON.TransformBlock", TransformBlock);

    /**
     * Block used to output the vertex position
     */
    class VertexOutputBlock extends NodeMaterialBlock {
        /**
         * Creates a new VertexOutputBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Vertex, true);
            this.registerInput("vector", NodeMaterialBlockConnectionPointTypes.Vector4);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "VertexOutputBlock";
        }
        /**
         * Gets the vector input component
         */
        get vector() {
            return this._inputs[0];
        }
        _isLogarithmicDepthEnabled(nodeList) {
            for (const node of nodeList) {
                if (node.useLogarithmicDepth) {
                    return true;
                }
            }
            return false;
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const input = this.vector;
            state.compilationString += `gl_Position = ${input.associatedVariableName};\n`;
            if (this._isLogarithmicDepthEnabled(state.sharedData.fragmentOutputNodes)) {
                state._emitUniformFromString("logarithmicDepthConstant", "float");
                state._emitVaryingFromString("vFragmentDepth", "float");
                state.compilationString += `vFragmentDepth = 1.0 + gl_Position.w;\n`;
                state.compilationString += `gl_Position.z = log2(max(0.000001, vFragmentDepth)) * logarithmicDepthConstant;\n`;
            }
            return this;
        }
    }
    RegisterClass("BABYLON.VertexOutputBlock", VertexOutputBlock);

    /**
     * Enum defining the type of properties that can be edited in the property pages in the node editor
     */
    var PropertyTypeForEdition;
    (function (PropertyTypeForEdition) {
        /** property is a boolean */
        PropertyTypeForEdition[PropertyTypeForEdition["Boolean"] = 0] = "Boolean";
        /** property is a float */
        PropertyTypeForEdition[PropertyTypeForEdition["Float"] = 1] = "Float";
        /** property is a int */
        PropertyTypeForEdition[PropertyTypeForEdition["Int"] = 2] = "Int";
        /** property is a Vector2 */
        PropertyTypeForEdition[PropertyTypeForEdition["Vector2"] = 3] = "Vector2";
        /** property is a list of values */
        PropertyTypeForEdition[PropertyTypeForEdition["List"] = 4] = "List";
    })(PropertyTypeForEdition || (PropertyTypeForEdition = {}));
    /**
     * Decorator that flags a property in a node block as being editable
     * @param displayName
     * @param propertyType
     * @param groupName
     * @param options
     */
    function editableInPropertyPage(displayName, propertyType = PropertyTypeForEdition.Boolean, groupName = "PROPERTIES", options) {
        return (target, propertyKey) => {
            let propStore = target._propStore;
            if (!propStore) {
                propStore = [];
                target._propStore = propStore;
            }
            propStore.push({
                propertyName: propertyKey,
                displayName: displayName,
                type: propertyType,
                groupName: groupName,
                options: options !== null && options !== void 0 ? options : {},
            });
        };
    }

    /**
     * Block used to output the final color
     */
    class FragmentOutputBlock extends NodeMaterialBlock {
        /**
         * Create a new FragmentOutputBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Fragment, true);
            /** Gets or sets a boolean indicating if content needs to be converted to gamma space */
            this.convertToGammaSpace = false;
            /** Gets or sets a boolean indicating if content needs to be converted to linear space */
            this.convertToLinearSpace = false;
            /** Gets or sets a boolean indicating if logarithmic depth should be used */
            this.useLogarithmicDepth = false;
            this.registerInput("rgba", NodeMaterialBlockConnectionPointTypes.Color4, true);
            this.registerInput("rgb", NodeMaterialBlockConnectionPointTypes.AutoDetect, true);
            this.registerInput("a", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.rgb.addExcludedConnectionPointFromAllowedTypes(NodeMaterialBlockConnectionPointTypes.Color3 | NodeMaterialBlockConnectionPointTypes.Vector3 | NodeMaterialBlockConnectionPointTypes.Float);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "FragmentOutputBlock";
        }
        /**
         * Initialize the block and prepare the context for build
         * @param state defines the state that will be used for the build
         */
        initialize(state) {
            state._excludeVariableName("logarithmicDepthConstant");
            state._excludeVariableName("vFragmentDepth");
        }
        /**
         * Gets the rgba input component
         */
        get rgba() {
            return this._inputs[0];
        }
        /**
         * Gets the rgb input component
         */
        get rgb() {
            return this._inputs[1];
        }
        /**
         * Gets the a input component
         */
        get a() {
            return this._inputs[2];
        }
        prepareDefines(mesh, nodeMaterial, defines) {
            defines.setValue(this._linearDefineName, this.convertToLinearSpace, true);
            defines.setValue(this._gammaDefineName, this.convertToGammaSpace, true);
        }
        bind(effect, nodeMaterial, mesh) {
            if (this.useLogarithmicDepth && mesh) {
                MaterialHelper.BindLogDepth(undefined, effect, mesh.getScene());
            }
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const rgba = this.rgba;
            const rgb = this.rgb;
            const a = this.a;
            state.sharedData.hints.needAlphaBlending = rgba.isConnected || a.isConnected;
            state.sharedData.blocksWithDefines.push(this);
            if (this.useLogarithmicDepth) {
                state._emitUniformFromString("logarithmicDepthConstant", "float");
                state._emitVaryingFromString("vFragmentDepth", "float");
                state.sharedData.bindableBlocks.push(this);
            }
            this._linearDefineName = state._getFreeDefineName("CONVERTTOLINEAR");
            this._gammaDefineName = state._getFreeDefineName("CONVERTTOGAMMA");
            const comments = `//${this.name}`;
            state._emitFunctionFromInclude("helperFunctions", comments);
            if (rgba.connectedPoint) {
                if (a.isConnected) {
                    state.compilationString += `gl_FragColor = vec4(${rgba.associatedVariableName}.rgb, ${a.associatedVariableName});\n`;
                }
                else {
                    state.compilationString += `gl_FragColor = ${rgba.associatedVariableName};\n`;
                }
            }
            else if (rgb.connectedPoint) {
                let aValue = "1.0";
                if (a.connectedPoint) {
                    aValue = a.associatedVariableName;
                }
                if (rgb.connectedPoint.type === NodeMaterialBlockConnectionPointTypes.Float) {
                    state.compilationString += `gl_FragColor = vec4(${rgb.associatedVariableName}, ${rgb.associatedVariableName}, ${rgb.associatedVariableName}, ${aValue});\n`;
                }
                else {
                    state.compilationString += `gl_FragColor = vec4(${rgb.associatedVariableName}, ${aValue});\n`;
                }
            }
            else {
                state.sharedData.checks.notConnectedNonOptionalInputs.push(rgba);
            }
            state.compilationString += `#ifdef ${this._linearDefineName}\n`;
            state.compilationString += `gl_FragColor = toLinearSpace(gl_FragColor);\n`;
            state.compilationString += `#endif\n`;
            state.compilationString += `#ifdef ${this._gammaDefineName}\n`;
            state.compilationString += `gl_FragColor = toGammaSpace(gl_FragColor);\n`;
            state.compilationString += `#endif\n`;
            if (this.useLogarithmicDepth) {
                state.compilationString += `gl_FragDepthEXT = log2(vFragmentDepth) * logarithmicDepthConstant * 0.5;\n`;
            }
            return this;
        }
        _dumpPropertiesCode() {
            let codeString = super._dumpPropertiesCode();
            codeString += `${this._codeVariableName}.convertToGammaSpace = ${this.convertToGammaSpace};\n`;
            codeString += `${this._codeVariableName}.convertToLinearSpace = ${this.convertToLinearSpace};\n`;
            codeString += `${this._codeVariableName}.useLogarithmicDepth = ${this.useLogarithmicDepth};\n`;
            return codeString;
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.convertToGammaSpace = this.convertToGammaSpace;
            serializationObject.convertToLinearSpace = this.convertToLinearSpace;
            serializationObject.useLogarithmicDepth = this.useLogarithmicDepth;
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            var _a;
            super._deserialize(serializationObject, scene, rootUrl);
            this.convertToGammaSpace = serializationObject.convertToGammaSpace;
            this.convertToLinearSpace = serializationObject.convertToLinearSpace;
            this.useLogarithmicDepth = (_a = serializationObject.useLogarithmicDepth) !== null && _a !== void 0 ? _a : false;
        }
    }
    __decorate$1([
        editableInPropertyPage("Convert to gamma space", PropertyTypeForEdition.Boolean, "PROPERTIES", { notifiers: { update: true } })
    ], FragmentOutputBlock.prototype, "convertToGammaSpace", void 0);
    __decorate$1([
        editableInPropertyPage("Convert to linear space", PropertyTypeForEdition.Boolean, "PROPERTIES", { notifiers: { update: true } })
    ], FragmentOutputBlock.prototype, "convertToLinearSpace", void 0);
    __decorate$1([
        editableInPropertyPage("Use logarithmic depth", PropertyTypeForEdition.Boolean, "PROPERTIES")
    ], FragmentOutputBlock.prototype, "useLogarithmicDepth", void 0);
    RegisterClass("BABYLON.FragmentOutputBlock", FragmentOutputBlock);

    /**
     * Enum defining the mode of a NodeMaterialBlockConnectionPoint
     */
    var NodeMaterialBlockConnectionPointMode;
    (function (NodeMaterialBlockConnectionPointMode) {
        /** Value is an uniform */
        NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Uniform"] = 0] = "Uniform";
        /** Value is a mesh attribute */
        NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Attribute"] = 1] = "Attribute";
        /** Value is a varying between vertex and fragment shaders */
        NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Varying"] = 2] = "Varying";
        /** Mode is undefined */
        NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Undefined"] = 3] = "Undefined";
    })(NodeMaterialBlockConnectionPointMode || (NodeMaterialBlockConnectionPointMode = {}));

    /**
     * Enum used to define system values e.g. values automatically provided by the system
     */
    var NodeMaterialSystemValues;
    (function (NodeMaterialSystemValues) {
        /** World */
        NodeMaterialSystemValues[NodeMaterialSystemValues["World"] = 1] = "World";
        /** View */
        NodeMaterialSystemValues[NodeMaterialSystemValues["View"] = 2] = "View";
        /** Projection */
        NodeMaterialSystemValues[NodeMaterialSystemValues["Projection"] = 3] = "Projection";
        /** ViewProjection */
        NodeMaterialSystemValues[NodeMaterialSystemValues["ViewProjection"] = 4] = "ViewProjection";
        /** WorldView */
        NodeMaterialSystemValues[NodeMaterialSystemValues["WorldView"] = 5] = "WorldView";
        /** WorldViewProjection */
        NodeMaterialSystemValues[NodeMaterialSystemValues["WorldViewProjection"] = 6] = "WorldViewProjection";
        /** CameraPosition */
        NodeMaterialSystemValues[NodeMaterialSystemValues["CameraPosition"] = 7] = "CameraPosition";
        /** Fog Color */
        NodeMaterialSystemValues[NodeMaterialSystemValues["FogColor"] = 8] = "FogColor";
        /** Delta time */
        NodeMaterialSystemValues[NodeMaterialSystemValues["DeltaTime"] = 9] = "DeltaTime";
        /** Camera parameters */
        NodeMaterialSystemValues[NodeMaterialSystemValues["CameraParameters"] = 10] = "CameraParameters";
        /** Material alpha */
        NodeMaterialSystemValues[NodeMaterialSystemValues["MaterialAlpha"] = 11] = "MaterialAlpha";
    })(NodeMaterialSystemValues || (NodeMaterialSystemValues = {}));

    /**
     * Enum defining the type of animations supported by InputBlock
     */
    var AnimatedInputBlockTypes;
    (function (AnimatedInputBlockTypes) {
        /** No animation */
        AnimatedInputBlockTypes[AnimatedInputBlockTypes["None"] = 0] = "None";
        /** Time based animation (is incremented by 0.6 each second). Will only work for floats */
        AnimatedInputBlockTypes[AnimatedInputBlockTypes["Time"] = 1] = "Time";
        /** Time elapsed (in seconds) since the engine was initialized. Will only work for floats */
        AnimatedInputBlockTypes[AnimatedInputBlockTypes["RealTime"] = 2] = "RealTime";
    })(AnimatedInputBlockTypes || (AnimatedInputBlockTypes = {}));

    /* eslint-disable @typescript-eslint/naming-convention */
    const remapAttributeName = {
        position2d: "position",
        particle_uv: "vUV",
        particle_color: "vColor",
        particle_texturemask: "textureMask",
        particle_positionw: "vPositionW",
    };
    const attributeInFragmentOnly = {
        particle_uv: true,
        particle_color: true,
        particle_texturemask: true,
        particle_positionw: true,
    };
    const attributeAsUniform = {
        particle_texturemask: true,
    };
    /**
     * Block used to expose an input value
     */
    class InputBlock extends NodeMaterialBlock {
        /**
         * Gets or sets the connection point type (default is float)
         */
        get type() {
            if (this._type === NodeMaterialBlockConnectionPointTypes.AutoDetect) {
                if (this.isUniform && this.value != null) {
                    if (!isNaN(this.value)) {
                        this._type = NodeMaterialBlockConnectionPointTypes.Float;
                        return this._type;
                    }
                    switch (this.value.getClassName()) {
                        case "Vector2":
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector2;
                            return this._type;
                        case "Vector3":
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector3;
                            return this._type;
                        case "Vector4":
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector4;
                            return this._type;
                        case "Color3":
                            this._type = NodeMaterialBlockConnectionPointTypes.Color3;
                            return this._type;
                        case "Color4":
                            this._type = NodeMaterialBlockConnectionPointTypes.Color4;
                            return this._type;
                        case "Matrix":
                            this._type = NodeMaterialBlockConnectionPointTypes.Matrix;
                            return this._type;
                    }
                }
                if (this.isAttribute) {
                    switch (this.name) {
                        case "position":
                        case "normal":
                        case "particle_positionw":
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector3;
                            return this._type;
                        case "uv":
                        case "uv2":
                        case "uv3":
                        case "uv4":
                        case "uv5":
                        case "uv6":
                        case "position2d":
                        case "particle_uv":
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector2;
                            return this._type;
                        case "matricesIndices":
                        case "matricesWeights":
                        case "matricesIndicesExtra":
                        case "matricesWeightsExtra":
                        case "world0":
                        case "world1":
                        case "world2":
                        case "world3":
                        case "tangent":
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector4;
                            return this._type;
                        case "color":
                        case "instanceColor":
                        case "particle_color":
                        case "particle_texturemask":
                            this._type = NodeMaterialBlockConnectionPointTypes.Color4;
                            return this._type;
                    }
                }
                if (this.isSystemValue) {
                    switch (this._systemValue) {
                        case NodeMaterialSystemValues.World:
                        case NodeMaterialSystemValues.WorldView:
                        case NodeMaterialSystemValues.WorldViewProjection:
                        case NodeMaterialSystemValues.View:
                        case NodeMaterialSystemValues.ViewProjection:
                        case NodeMaterialSystemValues.Projection:
                            this._type = NodeMaterialBlockConnectionPointTypes.Matrix;
                            return this._type;
                        case NodeMaterialSystemValues.CameraPosition:
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector3;
                            return this._type;
                        case NodeMaterialSystemValues.FogColor:
                            this._type = NodeMaterialBlockConnectionPointTypes.Color3;
                            return this._type;
                        case NodeMaterialSystemValues.DeltaTime:
                        case NodeMaterialSystemValues.MaterialAlpha:
                            this._type = NodeMaterialBlockConnectionPointTypes.Float;
                            return this._type;
                        case NodeMaterialSystemValues.CameraParameters:
                            this._type = NodeMaterialBlockConnectionPointTypes.Vector4;
                            return this._type;
                    }
                }
            }
            return this._type;
        }
        /**
         * Creates a new InputBlock
         * @param name defines the block name
         * @param target defines the target of that block (Vertex by default)
         * @param type defines the type of the input (can be set to NodeMaterialBlockConnectionPointTypes.AutoDetect)
         */
        constructor(name, target = NodeMaterialBlockTargets.Vertex, type = NodeMaterialBlockConnectionPointTypes.AutoDetect) {
            super(name, target, false);
            this._mode = NodeMaterialBlockConnectionPointMode.Undefined;
            this._animationType = AnimatedInputBlockTypes.None;
            /** Gets or set a value used to limit the range of float values */
            this.min = 0;
            /** Gets or set a value used to limit the range of float values */
            this.max = 0;
            /** Gets or set a value indicating that this input can only get 0 and 1 values */
            this.isBoolean = false;
            /** Gets or sets a value used by the Node Material editor to determine how to configure the current value if it is a matrix */
            this.matrixMode = 0;
            /** @internal */
            this._systemValue = null;
            /** Gets or sets a boolean indicating that the value of this input will not change after a build */
            this.isConstant = false;
            /** Gets or sets the group to use to display this block in the Inspector */
            this.groupInInspector = "";
            /** Gets an observable raised when the value is changed */
            this.onValueChangedObservable = new Observable$1();
            /** Gets or sets a boolean indicating if content needs to be converted to gamma space (for color3/4 only) */
            this.convertToGammaSpace = false;
            /** Gets or sets a boolean indicating if content needs to be converted to linear space (for color3/4 only) */
            this.convertToLinearSpace = false;
            this._type = type;
            this.setDefaultValue();
            this.registerOutput("output", type);
        }
        /**
         * Validates if a name is a reserve word.
         * @param newName the new name to be given to the node.
         * @returns false if the name is a reserve word, else true.
         */
        validateBlockName(newName) {
            if (!this.isAttribute) {
                return super.validateBlockName(newName);
            }
            return true;
        }
        /**
         * Gets the output component
         */
        get output() {
            return this._outputs[0];
        }
        /**
         * Set the source of this connection point to a vertex attribute
         * @param attributeName defines the attribute name (position, uv, normal, etc...). If not specified it will take the connection point name
         * @returns the current connection point
         */
        setAsAttribute(attributeName) {
            this._mode = NodeMaterialBlockConnectionPointMode.Attribute;
            if (attributeName) {
                this.name = attributeName;
            }
            return this;
        }
        /**
         * Set the source of this connection point to a system value
         * @param value define the system value to use (world, view, etc...) or null to switch to manual value
         * @returns the current connection point
         */
        setAsSystemValue(value) {
            this.systemValue = value;
            return this;
        }
        /**
         * Gets or sets the value of that point.
         * Please note that this value will be ignored if valueCallback is defined
         */
        get value() {
            return this._storedValue;
        }
        set value(value) {
            if (this.type === NodeMaterialBlockConnectionPointTypes.Float) {
                if (this.isBoolean) {
                    value = value ? 1 : 0;
                }
                else if (this.min !== this.max) {
                    value = Math.max(this.min, value);
                    value = Math.min(this.max, value);
                }
            }
            this._storedValue = value;
            this._mode = NodeMaterialBlockConnectionPointMode.Uniform;
            this.onValueChangedObservable.notifyObservers(this);
        }
        /**
         * Gets or sets a callback used to get the value of that point.
         * Please note that setting this value will force the connection point to ignore the value property
         */
        get valueCallback() {
            return this._valueCallback;
        }
        set valueCallback(value) {
            this._valueCallback = value;
            this._mode = NodeMaterialBlockConnectionPointMode.Uniform;
        }
        /**
         * Gets or sets the associated variable name in the shader
         */
        get associatedVariableName() {
            return this._associatedVariableName;
        }
        set associatedVariableName(value) {
            this._associatedVariableName = value;
        }
        /** Gets or sets the type of animation applied to the input */
        get animationType() {
            return this._animationType;
        }
        set animationType(value) {
            this._animationType = value;
        }
        /**
         * Gets a boolean indicating that this connection point not defined yet
         */
        get isUndefined() {
            return this._mode === NodeMaterialBlockConnectionPointMode.Undefined;
        }
        /**
         * Gets or sets a boolean indicating that this connection point is coming from an uniform.
         * In this case the connection point name must be the name of the uniform to use.
         * Can only be set on inputs
         */
        get isUniform() {
            return this._mode === NodeMaterialBlockConnectionPointMode.Uniform;
        }
        set isUniform(value) {
            this._mode = value ? NodeMaterialBlockConnectionPointMode.Uniform : NodeMaterialBlockConnectionPointMode.Undefined;
            this.associatedVariableName = "";
        }
        /**
         * Gets or sets a boolean indicating that this connection point is coming from an attribute.
         * In this case the connection point name must be the name of the attribute to use
         * Can only be set on inputs
         */
        get isAttribute() {
            return this._mode === NodeMaterialBlockConnectionPointMode.Attribute;
        }
        set isAttribute(value) {
            this._mode = value ? NodeMaterialBlockConnectionPointMode.Attribute : NodeMaterialBlockConnectionPointMode.Undefined;
            this.associatedVariableName = "";
        }
        /**
         * Gets or sets a boolean indicating that this connection point is generating a varying variable.
         * Can only be set on exit points
         */
        get isVarying() {
            return this._mode === NodeMaterialBlockConnectionPointMode.Varying;
        }
        set isVarying(value) {
            this._mode = value ? NodeMaterialBlockConnectionPointMode.Varying : NodeMaterialBlockConnectionPointMode.Undefined;
            this.associatedVariableName = "";
        }
        /**
         * Gets a boolean indicating that the current connection point is a system value
         */
        get isSystemValue() {
            return this._systemValue != null;
        }
        /**
         * Gets or sets the current well known value or null if not defined as a system value
         */
        get systemValue() {
            return this._systemValue;
        }
        set systemValue(value) {
            this._mode = NodeMaterialBlockConnectionPointMode.Uniform;
            this.associatedVariableName = "";
            this._systemValue = value;
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "InputBlock";
        }
        /**
         * Animate the input if animationType !== None
         * @param scene defines the rendering scene
         */
        animate(scene) {
            switch (this._animationType) {
                case AnimatedInputBlockTypes.Time: {
                    if (this.type === NodeMaterialBlockConnectionPointTypes.Float) {
                        this.value += scene.getAnimationRatio() * 0.01;
                    }
                    break;
                }
                case AnimatedInputBlockTypes.RealTime: {
                    if (this.type === NodeMaterialBlockConnectionPointTypes.Float) {
                        this.value = (PrecisionDate.Now - scene.getEngine().startTime) / 1000;
                    }
                    break;
                }
            }
        }
        _emitDefine(define) {
            if (define[0] === "!") {
                return `#ifndef ${define.substring(1)}\n`;
            }
            return `#ifdef ${define}\n`;
        }
        initialize() {
            this.associatedVariableName = "";
        }
        /**
         * Set the input block to its default value (based on its type)
         */
        setDefaultValue() {
            switch (this.type) {
                case NodeMaterialBlockConnectionPointTypes.Float:
                    this.value = 0;
                    break;
                case NodeMaterialBlockConnectionPointTypes.Vector2:
                    this.value = Vector2.Zero();
                    break;
                case NodeMaterialBlockConnectionPointTypes.Vector3:
                    this.value = Vector3.Zero();
                    break;
                case NodeMaterialBlockConnectionPointTypes.Vector4:
                    this.value = Vector4.Zero();
                    break;
                case NodeMaterialBlockConnectionPointTypes.Color3:
                    this.value = Color3.White();
                    break;
                case NodeMaterialBlockConnectionPointTypes.Color4:
                    this.value = new Color4(1, 1, 1, 1);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Matrix:
                    this.value = Matrix.Identity();
                    break;
            }
        }
        _emitConstant(state) {
            switch (this.type) {
                case NodeMaterialBlockConnectionPointTypes.Float:
                    return `${state._emitFloat(this.value)}`;
                case NodeMaterialBlockConnectionPointTypes.Vector2:
                    return `vec2(${this.value.x}, ${this.value.y})`;
                case NodeMaterialBlockConnectionPointTypes.Vector3:
                    return `vec3(${this.value.x}, ${this.value.y}, ${this.value.z})`;
                case NodeMaterialBlockConnectionPointTypes.Vector4:
                    return `vec4(${this.value.x}, ${this.value.y}, ${this.value.z}, ${this.value.w})`;
                case NodeMaterialBlockConnectionPointTypes.Color3:
                    TmpColors.Color3[0].set(this.value.r, this.value.g, this.value.b);
                    if (this.convertToGammaSpace) {
                        TmpColors.Color3[0].toGammaSpaceToRef(TmpColors.Color3[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                    }
                    if (this.convertToLinearSpace) {
                        TmpColors.Color3[0].toLinearSpaceToRef(TmpColors.Color3[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                    }
                    return `vec3(${TmpColors.Color3[0].r}, ${TmpColors.Color3[0].g}, ${TmpColors.Color3[0].b})`;
                case NodeMaterialBlockConnectionPointTypes.Color4:
                    TmpColors.Color4[0].set(this.value.r, this.value.g, this.value.b, this.value.a);
                    if (this.convertToGammaSpace) {
                        TmpColors.Color4[0].toGammaSpaceToRef(TmpColors.Color4[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                    }
                    if (this.convertToLinearSpace) {
                        TmpColors.Color4[0].toLinearSpaceToRef(TmpColors.Color4[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                    }
                    return `vec4(${TmpColors.Color4[0].r}, ${TmpColors.Color4[0].g}, ${TmpColors.Color4[0].b}, ${TmpColors.Color4[0].a})`;
            }
            return "";
        }
        /** @internal */
        get _noContextSwitch() {
            return attributeInFragmentOnly[this.name];
        }
        _emit(state, define) {
            var _a;
            // Uniforms
            if (this.isUniform) {
                if (!this.associatedVariableName) {
                    this.associatedVariableName = state._getFreeVariableName("u_" + this.name);
                }
                if (this.isConstant) {
                    if (state.constants.indexOf(this.associatedVariableName) !== -1) {
                        return;
                    }
                    state.constants.push(this.associatedVariableName);
                    state._constantDeclaration += this._declareOutput(this.output, state) + ` = ${this._emitConstant(state)};\n`;
                    return;
                }
                if (state.uniforms.indexOf(this.associatedVariableName) !== -1) {
                    return;
                }
                state.uniforms.push(this.associatedVariableName);
                if (define) {
                    state._uniformDeclaration += this._emitDefine(define);
                }
                state._uniformDeclaration += `uniform ${state._getGLType(this.type)} ${this.associatedVariableName};\n`;
                if (define) {
                    state._uniformDeclaration += `#endif\n`;
                }
                // well known
                const hints = state.sharedData.hints;
                if (this._systemValue !== null && this._systemValue !== undefined) {
                    switch (this._systemValue) {
                        case NodeMaterialSystemValues.WorldView:
                            hints.needWorldViewMatrix = true;
                            break;
                        case NodeMaterialSystemValues.WorldViewProjection:
                            hints.needWorldViewProjectionMatrix = true;
                            break;
                    }
                }
                else {
                    if (this._animationType !== AnimatedInputBlockTypes.None) {
                        state.sharedData.animatedInputs.push(this);
                    }
                }
                return;
            }
            // Attribute
            if (this.isAttribute) {
                this.associatedVariableName = (_a = remapAttributeName[this.name]) !== null && _a !== void 0 ? _a : this.name;
                if (this.target === NodeMaterialBlockTargets.Vertex && state._vertexState) {
                    // Attribute for fragment need to be carried over by varyings
                    if (attributeInFragmentOnly[this.name]) {
                        if (attributeAsUniform[this.name]) {
                            state._emitUniformFromString(this.associatedVariableName, state._getGLType(this.type), define);
                        }
                        else {
                            state._emitVaryingFromString(this.associatedVariableName, state._getGLType(this.type), define);
                        }
                    }
                    else {
                        this._emit(state._vertexState, define);
                    }
                    return;
                }
                if (state.attributes.indexOf(this.associatedVariableName) !== -1) {
                    return;
                }
                state.attributes.push(this.associatedVariableName);
                if (attributeInFragmentOnly[this.name]) {
                    if (attributeAsUniform[this.name]) {
                        state._emitUniformFromString(this.associatedVariableName, state._getGLType(this.type), define);
                    }
                    else {
                        state._emitVaryingFromString(this.associatedVariableName, state._getGLType(this.type), define);
                    }
                }
                else {
                    if (define) {
                        state._attributeDeclaration += this._emitDefine(define);
                    }
                    state._attributeDeclaration += `attribute ${state._getGLType(this.type)} ${this.associatedVariableName};\n`;
                    if (define) {
                        state._attributeDeclaration += `#endif\n`;
                    }
                }
            }
        }
        /**
         * @internal
         */
        _transmitWorld(effect, world, worldView, worldViewProjection) {
            if (!this._systemValue) {
                return;
            }
            const variableName = this.associatedVariableName;
            switch (this._systemValue) {
                case NodeMaterialSystemValues.World:
                    effect.setMatrix(variableName, world);
                    break;
                case NodeMaterialSystemValues.WorldView:
                    effect.setMatrix(variableName, worldView);
                    break;
                case NodeMaterialSystemValues.WorldViewProjection:
                    effect.setMatrix(variableName, worldViewProjection);
                    break;
            }
        }
        /**
         * @internal
         */
        _transmit(effect, scene, material) {
            if (this.isAttribute) {
                return;
            }
            const variableName = this.associatedVariableName;
            if (this._systemValue) {
                switch (this._systemValue) {
                    case NodeMaterialSystemValues.World:
                    case NodeMaterialSystemValues.WorldView:
                    case NodeMaterialSystemValues.WorldViewProjection:
                        return;
                    case NodeMaterialSystemValues.View:
                        effect.setMatrix(variableName, scene.getViewMatrix());
                        break;
                    case NodeMaterialSystemValues.Projection:
                        effect.setMatrix(variableName, scene.getProjectionMatrix());
                        break;
                    case NodeMaterialSystemValues.ViewProjection:
                        effect.setMatrix(variableName, scene.getTransformMatrix());
                        break;
                    case NodeMaterialSystemValues.CameraPosition:
                        scene.bindEyePosition(effect, variableName, true);
                        break;
                    case NodeMaterialSystemValues.FogColor:
                        effect.setColor3(variableName, scene.fogColor);
                        break;
                    case NodeMaterialSystemValues.DeltaTime:
                        effect.setFloat(variableName, scene.deltaTime / 1000.0);
                        break;
                    case NodeMaterialSystemValues.CameraParameters:
                        if (scene.activeCamera) {
                            effect.setFloat4(variableName, scene.getEngine().hasOriginBottomLeft ? -1 : 1, scene.activeCamera.minZ, scene.activeCamera.maxZ, 1 / scene.activeCamera.maxZ);
                        }
                        break;
                    case NodeMaterialSystemValues.MaterialAlpha:
                        effect.setFloat(variableName, material.alpha);
                        break;
                }
                return;
            }
            const value = this._valueCallback ? this._valueCallback() : this._storedValue;
            if (value === null) {
                return;
            }
            switch (this.type) {
                case NodeMaterialBlockConnectionPointTypes.Float:
                    effect.setFloat(variableName, value);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Int:
                    effect.setInt(variableName, value);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Color3:
                    TmpColors.Color3[0].set(this.value.r, this.value.g, this.value.b);
                    if (this.convertToGammaSpace) {
                        TmpColors.Color3[0].toGammaSpaceToRef(TmpColors.Color3[0], scene.getEngine().useExactSrgbConversions);
                    }
                    if (this.convertToLinearSpace) {
                        TmpColors.Color3[0].toLinearSpaceToRef(TmpColors.Color3[0], scene.getEngine().useExactSrgbConversions);
                    }
                    effect.setColor3(variableName, TmpColors.Color3[0]);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Color4:
                    TmpColors.Color4[0].set(this.value.r, this.value.g, this.value.b, this.value.a);
                    if (this.convertToGammaSpace) {
                        TmpColors.Color4[0].toGammaSpaceToRef(TmpColors.Color4[0], scene.getEngine().useExactSrgbConversions);
                    }
                    if (this.convertToLinearSpace) {
                        TmpColors.Color4[0].toLinearSpaceToRef(TmpColors.Color4[0], scene.getEngine().useExactSrgbConversions);
                    }
                    effect.setDirectColor4(variableName, TmpColors.Color4[0]);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Vector2:
                    effect.setVector2(variableName, value);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Vector3:
                    effect.setVector3(variableName, value);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Vector4:
                    effect.setVector4(variableName, value);
                    break;
                case NodeMaterialBlockConnectionPointTypes.Matrix:
                    effect.setMatrix(variableName, value);
                    break;
            }
        }
        _buildBlock(state) {
            super._buildBlock(state);
            if (this.isUniform || this.isSystemValue) {
                state.sharedData.inputBlocks.push(this);
            }
            this._emit(state);
        }
        _dumpPropertiesCode() {
            const variableName = this._codeVariableName;
            if (this.isAttribute) {
                return super._dumpPropertiesCode() + `${variableName}.setAsAttribute("${this.name}");\n`;
            }
            if (this.isSystemValue) {
                return super._dumpPropertiesCode() + `${variableName}.setAsSystemValue(BABYLON.NodeMaterialSystemValues.${NodeMaterialSystemValues[this._systemValue]});\n`;
            }
            if (this.isUniform) {
                const codes = [];
                let valueString = "";
                switch (this.type) {
                    case NodeMaterialBlockConnectionPointTypes.Float:
                        valueString = `${this.value}`;
                        break;
                    case NodeMaterialBlockConnectionPointTypes.Vector2:
                        valueString = `new BABYLON.Vector2(${this.value.x}, ${this.value.y})`;
                        break;
                    case NodeMaterialBlockConnectionPointTypes.Vector3:
                        valueString = `new BABYLON.Vector3(${this.value.x}, ${this.value.y}, ${this.value.z})`;
                        break;
                    case NodeMaterialBlockConnectionPointTypes.Vector4:
                        valueString = `new BABYLON.Vector4(${this.value.x}, ${this.value.y}, ${this.value.z}, ${this.value.w})`;
                        break;
                    case NodeMaterialBlockConnectionPointTypes.Color3:
                        valueString = `new BABYLON.Color3(${this.value.r}, ${this.value.g}, ${this.value.b})`;
                        if (this.convertToGammaSpace) {
                            valueString += ".toGammaSpace()";
                        }
                        if (this.convertToLinearSpace) {
                            valueString += ".toLinearSpace()";
                        }
                        break;
                    case NodeMaterialBlockConnectionPointTypes.Color4:
                        valueString = `new BABYLON.Color4(${this.value.r}, ${this.value.g}, ${this.value.b}, ${this.value.a})`;
                        if (this.convertToGammaSpace) {
                            valueString += ".toGammaSpace()";
                        }
                        if (this.convertToLinearSpace) {
                            valueString += ".toLinearSpace()";
                        }
                        break;
                    case NodeMaterialBlockConnectionPointTypes.Matrix:
                        valueString = `BABYLON.Matrix.FromArray([${this.value.m}])`;
                        break;
                }
                // Common Property "Value"
                codes.push(`${variableName}.value = ${valueString}`);
                // Float-Value-Specific Properties
                if (this.type === NodeMaterialBlockConnectionPointTypes.Float) {
                    codes.push(`${variableName}.min = ${this.min}`, `${variableName}.max = ${this.max}`, `${variableName}.isBoolean = ${this.isBoolean}`, `${variableName}.matrixMode = ${this.matrixMode}`, `${variableName}.animationType = BABYLON.AnimatedInputBlockTypes.${AnimatedInputBlockTypes[this.animationType]}`);
                }
                // Common Property "Type"
                codes.push(`${variableName}.isConstant = ${this.isConstant}`);
                codes.push("");
                return super._dumpPropertiesCode() + codes.join(";\n");
            }
            return super._dumpPropertiesCode();
        }
        dispose() {
            this.onValueChangedObservable.clear();
            super.dispose();
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.type = this.type;
            serializationObject.mode = this._mode;
            serializationObject.systemValue = this._systemValue;
            serializationObject.animationType = this._animationType;
            serializationObject.min = this.min;
            serializationObject.max = this.max;
            serializationObject.isBoolean = this.isBoolean;
            serializationObject.matrixMode = this.matrixMode;
            serializationObject.isConstant = this.isConstant;
            serializationObject.groupInInspector = this.groupInInspector;
            serializationObject.convertToGammaSpace = this.convertToGammaSpace;
            serializationObject.convertToLinearSpace = this.convertToLinearSpace;
            if (this._storedValue != null && this._mode === NodeMaterialBlockConnectionPointMode.Uniform) {
                if (this._storedValue.asArray) {
                    serializationObject.valueType = "BABYLON." + this._storedValue.getClassName();
                    serializationObject.value = this._storedValue.asArray();
                }
                else {
                    serializationObject.valueType = "number";
                    serializationObject.value = this._storedValue;
                }
            }
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            this._mode = serializationObject.mode;
            super._deserialize(serializationObject, scene, rootUrl);
            this._type = serializationObject.type;
            this._systemValue = serializationObject.systemValue || serializationObject.wellKnownValue;
            this._animationType = serializationObject.animationType;
            this.min = serializationObject.min || 0;
            this.max = serializationObject.max || 0;
            this.isBoolean = !!serializationObject.isBoolean;
            this.matrixMode = serializationObject.matrixMode || 0;
            this.isConstant = !!serializationObject.isConstant;
            this.groupInInspector = serializationObject.groupInInspector || "";
            this.convertToGammaSpace = !!serializationObject.convertToGammaSpace;
            this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
            // Tangents back compat
            if (serializationObject.name === "tangent" &&
                serializationObject.mode === NodeMaterialBlockConnectionPointMode.Attribute &&
                serializationObject.type === NodeMaterialBlockConnectionPointTypes.Vector3) {
                this._type = NodeMaterialBlockConnectionPointTypes.Vector4;
            }
            if (!serializationObject.valueType) {
                return;
            }
            if (serializationObject.valueType === "number") {
                this._storedValue = serializationObject.value;
            }
            else {
                const valueType = GetClass(serializationObject.valueType);
                if (valueType) {
                    this._storedValue = valueType.FromArray(serializationObject.value);
                }
            }
        }
    }
    RegisterClass("BABYLON.InputBlock", InputBlock);

    /**
     * Base block used as input for post process
     */
    class CurrentScreenBlock extends NodeMaterialBlock {
        /**
         * Create a new CurrentScreenBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.VertexAndFragment);
            this._samplerName = "textureSampler";
            /**
             * Gets or sets a boolean indicating if content needs to be converted to gamma space
             */
            this.convertToGammaSpace = false;
            /**
             * Gets or sets a boolean indicating if content needs to be converted to linear space
             */
            this.convertToLinearSpace = false;
            this._isUnique = false;
            this.registerInput("uv", NodeMaterialBlockConnectionPointTypes.AutoDetect, false, NodeMaterialBlockTargets.VertexAndFragment);
            this.registerOutput("rgba", NodeMaterialBlockConnectionPointTypes.Color4, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("rgb", NodeMaterialBlockConnectionPointTypes.Color3, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("r", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("g", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("b", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("a", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this._inputs[0].addExcludedConnectionPointFromAllowedTypes(NodeMaterialBlockConnectionPointTypes.Vector2 | NodeMaterialBlockConnectionPointTypes.Vector3 | NodeMaterialBlockConnectionPointTypes.Vector4);
            this._inputs[0]._prioritizeVertex = false;
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "CurrentScreenBlock";
        }
        /**
         * Gets the uv input component
         */
        get uv() {
            return this._inputs[0];
        }
        /**
         * Gets the rgba output component
         */
        get rgba() {
            return this._outputs[0];
        }
        /**
         * Gets the rgb output component
         */
        get rgb() {
            return this._outputs[1];
        }
        /**
         * Gets the r output component
         */
        get r() {
            return this._outputs[2];
        }
        /**
         * Gets the g output component
         */
        get g() {
            return this._outputs[3];
        }
        /**
         * Gets the b output component
         */
        get b() {
            return this._outputs[4];
        }
        /**
         * Gets the a output component
         */
        get a() {
            return this._outputs[5];
        }
        /**
         * Initialize the block and prepare the context for build
         * @param state defines the state that will be used for the build
         */
        initialize(state) {
            state._excludeVariableName("textureSampler");
        }
        get target() {
            if (!this.uv.isConnected) {
                return NodeMaterialBlockTargets.VertexAndFragment;
            }
            if (this.uv.sourceBlock.isInput) {
                return NodeMaterialBlockTargets.VertexAndFragment;
            }
            return NodeMaterialBlockTargets.Fragment;
        }
        prepareDefines(mesh, nodeMaterial, defines) {
            defines.setValue(this._linearDefineName, this.convertToGammaSpace, true);
            defines.setValue(this._gammaDefineName, this.convertToLinearSpace, true);
        }
        isReady() {
            if (this.texture && !this.texture.isReadyOrNotBlocking()) {
                return false;
            }
            return true;
        }
        _injectVertexCode(state) {
            const uvInput = this.uv;
            if (uvInput.connectedPoint.ownerBlock.isInput) {
                const uvInputOwnerBlock = uvInput.connectedPoint.ownerBlock;
                if (!uvInputOwnerBlock.isAttribute) {
                    state._emitUniformFromString(uvInput.associatedVariableName, "vec2");
                }
            }
            this._mainUVName = "vMain" + uvInput.associatedVariableName;
            state._emitVaryingFromString(this._mainUVName, "vec2");
            state.compilationString += `${this._mainUVName} = ${uvInput.associatedVariableName}.xy;\n`;
            if (!this._outputs.some((o) => o.isConnectedInVertexShader)) {
                return;
            }
            this._writeTextureRead(state, true);
            for (const output of this._outputs) {
                if (output.hasEndpoints) {
                    this._writeOutput(state, output, output.name, true);
                }
            }
        }
        _writeTextureRead(state, vertexMode = false) {
            const uvInput = this.uv;
            if (vertexMode) {
                if (state.target === NodeMaterialBlockTargets.Fragment) {
                    return;
                }
                state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${uvInput.associatedVariableName});\n`;
                return;
            }
            if (this.uv.ownerBlock.target === NodeMaterialBlockTargets.Fragment) {
                state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${uvInput.associatedVariableName});\n`;
                return;
            }
            state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${this._mainUVName});\n`;
        }
        _writeOutput(state, output, swizzle, vertexMode = false) {
            if (vertexMode) {
                if (state.target === NodeMaterialBlockTargets.Fragment) {
                    return;
                }
                state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
                return;
            }
            if (this.uv.ownerBlock.target === NodeMaterialBlockTargets.Fragment) {
                state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
                return;
            }
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            state.compilationString += `#ifdef ${this._linearDefineName}\n`;
            state.compilationString += `${output.associatedVariableName} = toGammaSpace(${output.associatedVariableName});\n`;
            state.compilationString += `#endif\n`;
            state.compilationString += `#ifdef ${this._gammaDefineName}\n`;
            state.compilationString += `${output.associatedVariableName} = toLinearSpace(${output.associatedVariableName});\n`;
            state.compilationString += `#endif\n`;
        }
        _buildBlock(state) {
            super._buildBlock(state);
            this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
            if (state.sharedData.blockingBlocks.indexOf(this) < 0) {
                state.sharedData.blockingBlocks.push(this);
            }
            if (state.sharedData.textureBlocks.indexOf(this) < 0) {
                state.sharedData.textureBlocks.push(this);
            }
            if (state.sharedData.blocksWithDefines.indexOf(this) < 0) {
                state.sharedData.blocksWithDefines.push(this);
            }
            if (state.target !== NodeMaterialBlockTargets.Fragment) {
                // Vertex
                state._emit2DSampler(this._samplerName);
                this._injectVertexCode(state);
                return;
            }
            // Fragment
            if (!this._outputs.some((o) => o.isConnectedInFragmentShader)) {
                return;
            }
            state._emit2DSampler(this._samplerName);
            this._linearDefineName = state._getFreeDefineName("ISLINEAR");
            this._gammaDefineName = state._getFreeDefineName("ISGAMMA");
            const comments = `//${this.name}`;
            state._emitFunctionFromInclude("helperFunctions", comments);
            this._writeTextureRead(state);
            for (const output of this._outputs) {
                if (output.hasEndpoints) {
                    this._writeOutput(state, output, output.name);
                }
            }
            return this;
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.convertToGammaSpace = this.convertToGammaSpace;
            serializationObject.convertToLinearSpace = this.convertToLinearSpace;
            if (this.texture && !this.texture.isRenderTarget) {
                serializationObject.texture = this.texture.serialize();
            }
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            super._deserialize(serializationObject, scene, rootUrl);
            this.convertToGammaSpace = serializationObject.convertToGammaSpace;
            this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
            if (serializationObject.texture) {
                rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
                this.texture = Texture.Parse(serializationObject.texture, scene, rootUrl);
            }
        }
    }
    RegisterClass("BABYLON.CurrentScreenBlock", CurrentScreenBlock);

    /**
     * Base block used for the particle texture
     */
    class ParticleTextureBlock extends NodeMaterialBlock {
        /**
         * Create a new ParticleTextureBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Fragment);
            this._samplerName = "diffuseSampler";
            /**
             * Gets or sets a boolean indicating if content needs to be converted to gamma space
             */
            this.convertToGammaSpace = false;
            /**
             * Gets or sets a boolean indicating if content needs to be converted to linear space
             */
            this.convertToLinearSpace = false;
            this._isUnique = false;
            this.registerInput("uv", NodeMaterialBlockConnectionPointTypes.AutoDetect, false, NodeMaterialBlockTargets.VertexAndFragment);
            this.registerOutput("rgba", NodeMaterialBlockConnectionPointTypes.Color4, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("rgb", NodeMaterialBlockConnectionPointTypes.Color3, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("r", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("g", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("b", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this.registerOutput("a", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Neutral);
            this._inputs[0].addExcludedConnectionPointFromAllowedTypes(NodeMaterialBlockConnectionPointTypes.Vector2 | NodeMaterialBlockConnectionPointTypes.Vector3 | NodeMaterialBlockConnectionPointTypes.Vector4);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "ParticleTextureBlock";
        }
        /**
         * Gets the uv input component
         */
        get uv() {
            return this._inputs[0];
        }
        /**
         * Gets the rgba output component
         */
        get rgba() {
            return this._outputs[0];
        }
        /**
         * Gets the rgb output component
         */
        get rgb() {
            return this._outputs[1];
        }
        /**
         * Gets the r output component
         */
        get r() {
            return this._outputs[2];
        }
        /**
         * Gets the g output component
         */
        get g() {
            return this._outputs[3];
        }
        /**
         * Gets the b output component
         */
        get b() {
            return this._outputs[4];
        }
        /**
         * Gets the a output component
         */
        get a() {
            return this._outputs[5];
        }
        /**
         * Initialize the block and prepare the context for build
         * @param state defines the state that will be used for the build
         */
        initialize(state) {
            state._excludeVariableName("diffuseSampler");
        }
        autoConfigure(material) {
            if (!this.uv.isConnected) {
                let uvInput = material.getInputBlockByPredicate((b) => b.isAttribute && b.name === "particle_uv");
                if (!uvInput) {
                    uvInput = new InputBlock("uv");
                    uvInput.setAsAttribute("particle_uv");
                }
                uvInput.output.connectTo(this.uv);
            }
        }
        prepareDefines(mesh, nodeMaterial, defines) {
            defines.setValue(this._linearDefineName, this.convertToGammaSpace, true);
            defines.setValue(this._gammaDefineName, this.convertToLinearSpace, true);
        }
        isReady() {
            if (this.texture && !this.texture.isReadyOrNotBlocking()) {
                return false;
            }
            return true;
        }
        _writeOutput(state, output, swizzle) {
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            state.compilationString += `#ifdef ${this._linearDefineName}\n`;
            state.compilationString += `${output.associatedVariableName} = toGammaSpace(${output.associatedVariableName});\n`;
            state.compilationString += `#endif\n`;
            state.compilationString += `#ifdef ${this._gammaDefineName}\n`;
            state.compilationString += `${output.associatedVariableName} = toLinearSpace(${output.associatedVariableName});\n`;
            state.compilationString += `#endif\n`;
        }
        _buildBlock(state) {
            super._buildBlock(state);
            if (state.target === NodeMaterialBlockTargets.Vertex) {
                return;
            }
            this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
            state._emit2DSampler(this._samplerName);
            state.sharedData.blockingBlocks.push(this);
            state.sharedData.textureBlocks.push(this);
            state.sharedData.blocksWithDefines.push(this);
            this._linearDefineName = state._getFreeDefineName("ISLINEAR");
            this._gammaDefineName = state._getFreeDefineName("ISGAMMA");
            const comments = `//${this.name}`;
            state._emitFunctionFromInclude("helperFunctions", comments);
            state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${this.uv.associatedVariableName});\n`;
            for (const output of this._outputs) {
                if (output.hasEndpoints) {
                    this._writeOutput(state, output, output.name);
                }
            }
            return this;
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.convertToGammaSpace = this.convertToGammaSpace;
            serializationObject.convertToLinearSpace = this.convertToLinearSpace;
            if (this.texture && !this.texture.isRenderTarget) {
                serializationObject.texture = this.texture.serialize();
            }
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            super._deserialize(serializationObject, scene, rootUrl);
            this.convertToGammaSpace = serializationObject.convertToGammaSpace;
            this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
            if (serializationObject.texture) {
                rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
                this.texture = Texture.Parse(serializationObject.texture, scene, rootUrl);
            }
        }
    }
    RegisterClass("BABYLON.ParticleTextureBlock", ParticleTextureBlock);

    /**
     * Block used for the particle ramp gradient section
     */
    class ParticleRampGradientBlock extends NodeMaterialBlock {
        /**
         * Create a new ParticleRampGradientBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Fragment);
            this._isUnique = true;
            this.registerInput("color", NodeMaterialBlockConnectionPointTypes.Color4, false, NodeMaterialBlockTargets.Fragment);
            this.registerOutput("rampColor", NodeMaterialBlockConnectionPointTypes.Color4, NodeMaterialBlockTargets.Fragment);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "ParticleRampGradientBlock";
        }
        /**
         * Gets the color input component
         */
        get color() {
            return this._inputs[0];
        }
        /**
         * Gets the rampColor output component
         */
        get rampColor() {
            return this._outputs[0];
        }
        /**
         * Initialize the block and prepare the context for build
         * @param state defines the state that will be used for the build
         */
        initialize(state) {
            state._excludeVariableName("remapRanges");
            state._excludeVariableName("rampSampler");
            state._excludeVariableName("baseColor");
            state._excludeVariableName("alpha");
            state._excludeVariableName("remappedColorIndex");
            state._excludeVariableName("rampColor");
            state._excludeVariableName("finalAlpha");
        }
        _buildBlock(state) {
            super._buildBlock(state);
            if (state.target === NodeMaterialBlockTargets.Vertex) {
                return;
            }
            state._emit2DSampler("rampSampler");
            state._emitVaryingFromString("remapRanges", "vec4", "RAMPGRADIENT");
            state.compilationString += `
            #ifdef RAMPGRADIENT
                vec4 baseColor = ${this.color.associatedVariableName};
                float alpha = ${this.color.associatedVariableName}.a;

                float remappedColorIndex = clamp((alpha - remapRanges.x) / remapRanges.y, 0.0, 1.0);

                vec4 rampColor = texture2D(rampSampler, vec2(1.0 - remappedColorIndex, 0.));
                baseColor.rgb *= rampColor.rgb;

                // Remapped alpha
                float finalAlpha = baseColor.a;
                baseColor.a = clamp((alpha * rampColor.a - remapRanges.z) / remapRanges.w, 0.0, 1.0);

                ${this._declareOutput(this.rampColor, state)} = baseColor;
            #else
                ${this._declareOutput(this.rampColor, state)} = ${this.color.associatedVariableName};
            #endif
        `;
            return this;
        }
    }
    RegisterClass("BABYLON.ParticleRampGradientBlock", ParticleRampGradientBlock);

    /**
     * Block used for the particle blend multiply section
     */
    class ParticleBlendMultiplyBlock extends NodeMaterialBlock {
        /**
         * Create a new ParticleBlendMultiplyBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Fragment);
            this._isUnique = true;
            this.registerInput("color", NodeMaterialBlockConnectionPointTypes.Color4, false, NodeMaterialBlockTargets.Fragment);
            this.registerInput("alphaTexture", NodeMaterialBlockConnectionPointTypes.Float, false, NodeMaterialBlockTargets.Fragment);
            this.registerInput("alphaColor", NodeMaterialBlockConnectionPointTypes.Float, false, NodeMaterialBlockTargets.Fragment);
            this.registerOutput("blendColor", NodeMaterialBlockConnectionPointTypes.Color4, NodeMaterialBlockTargets.Fragment);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "ParticleBlendMultiplyBlock";
        }
        /**
         * Gets the color input component
         */
        get color() {
            return this._inputs[0];
        }
        /**
         * Gets the alphaTexture input component
         */
        get alphaTexture() {
            return this._inputs[1];
        }
        /**
         * Gets the alphaColor input component
         */
        get alphaColor() {
            return this._inputs[2];
        }
        /**
         * Gets the blendColor output component
         */
        get blendColor() {
            return this._outputs[0];
        }
        /**
         * Initialize the block and prepare the context for build
         * @param state defines the state that will be used for the build
         */
        initialize(state) {
            state._excludeVariableName("sourceAlpha");
        }
        _buildBlock(state) {
            super._buildBlock(state);
            if (state.target === NodeMaterialBlockTargets.Vertex) {
                return;
            }
            state.compilationString += `
            #ifdef BLENDMULTIPLYMODE
                ${this._declareOutput(this.blendColor, state)};
                float sourceAlpha = ${this.alphaColor.associatedVariableName} * ${this.alphaTexture.associatedVariableName};
                ${this.blendColor.associatedVariableName}.rgb = ${this.color.associatedVariableName}.rgb * sourceAlpha + vec3(1.0) * (1.0 - sourceAlpha);
                ${this.blendColor.associatedVariableName}.a = ${this.color.associatedVariableName}.a;
            #else
                ${this._declareOutput(this.blendColor, state)} = ${this.color.associatedVariableName};
            #endif
        `;
            return this;
        }
    }
    RegisterClass("BABYLON.ParticleBlendMultiplyBlock", ParticleBlendMultiplyBlock);

    /**
     * Block used to create a Vector2/3/4 out of individual inputs (one for each component)
     */
    class VectorMergerBlock extends NodeMaterialBlock {
        /**
         * Create a new VectorMergerBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Neutral);
            /**
             * Gets or sets the swizzle for x (meaning which component to affect to the output.x)
             */
            this.xSwizzle = "x";
            /**
             * Gets or sets the swizzle for y (meaning which component to affect to the output.y)
             */
            this.ySwizzle = "y";
            /**
             * Gets or sets the swizzle for z (meaning which component to affect to the output.z)
             */
            this.zSwizzle = "z";
            /**
             * Gets or sets the swizzle for w (meaning which component to affect to the output.w)
             */
            this.wSwizzle = "w";
            this.registerInput("xyzw ", NodeMaterialBlockConnectionPointTypes.Vector4, true);
            this.registerInput("xyz ", NodeMaterialBlockConnectionPointTypes.Vector3, true);
            this.registerInput("xy ", NodeMaterialBlockConnectionPointTypes.Vector2, true);
            this.registerInput("zw ", NodeMaterialBlockConnectionPointTypes.Vector2, true);
            this.registerInput("x", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerInput("y", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerInput("z", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerInput("w", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerOutput("xyzw", NodeMaterialBlockConnectionPointTypes.Vector4);
            this.registerOutput("xyz", NodeMaterialBlockConnectionPointTypes.Vector3);
            this.registerOutput("xy", NodeMaterialBlockConnectionPointTypes.Vector2);
            this.registerOutput("zw", NodeMaterialBlockConnectionPointTypes.Vector2);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "VectorMergerBlock";
        }
        /**
         * Gets the xyzw component (input)
         */
        get xyzwIn() {
            return this._inputs[0];
        }
        /**
         * Gets the xyz component (input)
         */
        get xyzIn() {
            return this._inputs[1];
        }
        /**
         * Gets the xy component (input)
         */
        get xyIn() {
            return this._inputs[2];
        }
        /**
         * Gets the zw component (input)
         */
        get zwIn() {
            return this._inputs[3];
        }
        /**
         * Gets the x component (input)
         */
        get x() {
            return this._inputs[4];
        }
        /**
         * Gets the y component (input)
         */
        get y() {
            return this._inputs[5];
        }
        /**
         * Gets the z component (input)
         */
        get z() {
            return this._inputs[6];
        }
        /**
         * Gets the w component (input)
         */
        get w() {
            return this._inputs[7];
        }
        /**
         * Gets the xyzw component (output)
         */
        get xyzw() {
            return this._outputs[0];
        }
        /**
         * Gets the xyz component (output)
         */
        get xyzOut() {
            return this._outputs[1];
        }
        /**
         * Gets the xy component (output)
         */
        get xyOut() {
            return this._outputs[2];
        }
        /**
         * Gets the zw component (output)
         */
        get zwOut() {
            return this._outputs[3];
        }
        /**
         * Gets the xy component (output)
         * @deprecated Please use xyOut instead.
         */
        get xy() {
            return this.xyOut;
        }
        /**
         * Gets the xyz component (output)
         * @deprecated Please use xyzOut instead.
         */
        get xyz() {
            return this.xyzOut;
        }
        _inputRename(name) {
            if (name === "xyzw ") {
                return "xyzwIn";
            }
            if (name === "xyz ") {
                return "xyzIn";
            }
            if (name === "xy ") {
                return "xyIn";
            }
            if (name === "zw ") {
                return "zwIn";
            }
            return name;
        }
        _buildSwizzle(len) {
            const swizzle = this.xSwizzle + this.ySwizzle + this.zSwizzle + this.wSwizzle;
            return "." + swizzle.substr(0, len);
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const xInput = this.x;
            const yInput = this.y;
            const zInput = this.z;
            const wInput = this.w;
            const xyInput = this.xyIn;
            const zwInput = this.zwIn;
            const xyzInput = this.xyzIn;
            const xyzwInput = this.xyzwIn;
            const v4Output = this._outputs[0];
            const v3Output = this._outputs[1];
            const v2Output = this._outputs[2];
            const v2CompOutput = this._outputs[3];
            if (xyzwInput.isConnected) {
                if (v4Output.hasEndpoints) {
                    state.compilationString += this._declareOutput(v4Output, state) + ` = ${xyzwInput.associatedVariableName}${this._buildSwizzle(4)};\n`;
                }
                if (v3Output.hasEndpoints) {
                    state.compilationString += this._declareOutput(v3Output, state) + ` = ${xyzwInput.associatedVariableName}${this._buildSwizzle(3)};\n`;
                }
                if (v2Output.hasEndpoints) {
                    state.compilationString += this._declareOutput(v2Output, state) + ` = ${xyzwInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                }
            }
            else if (xyzInput.isConnected) {
                if (v4Output.hasEndpoints) {
                    state.compilationString +=
                        this._declareOutput(v4Output, state) +
                            ` = vec4(${xyzInput.associatedVariableName}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(4)};\n`;
                }
                if (v3Output.hasEndpoints) {
                    state.compilationString += this._declareOutput(v3Output, state) + ` = ${xyzInput.associatedVariableName}${this._buildSwizzle(3)};\n`;
                }
                if (v2Output.hasEndpoints) {
                    state.compilationString += this._declareOutput(v2Output, state) + ` = ${xyzInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                }
            }
            else if (xyInput.isConnected) {
                if (v4Output.hasEndpoints) {
                    if (zwInput.isConnected) {
                        state.compilationString +=
                            this._declareOutput(v4Output, state) + ` = vec4(${xyInput.associatedVariableName}, ${zwInput.associatedVariableName})${this._buildSwizzle(4)};\n`;
                    }
                    else {
                        state.compilationString +=
                            this._declareOutput(v4Output, state) +
                                ` = vec4(${xyInput.associatedVariableName}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(4)};\n`;
                    }
                }
                if (v3Output.hasEndpoints) {
                    state.compilationString +=
                        this._declareOutput(v3Output, state) +
                            ` = vec3(${xyInput.associatedVariableName}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"})${this._buildSwizzle(3)};\n`;
                }
                if (v2Output.hasEndpoints) {
                    state.compilationString += this._declareOutput(v2Output, state) + ` = ${xyInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                }
                if (v2CompOutput.hasEndpoints) {
                    if (zwInput.isConnected) {
                        state.compilationString += this._declareOutput(v2CompOutput, state) + ` = ${zwInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                    }
                    else {
                        state.compilationString +=
                            this._declareOutput(v2CompOutput, state) +
                                ` = vec2(${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(2)};\n`;
                    }
                }
            }
            else {
                if (v4Output.hasEndpoints) {
                    if (zwInput.isConnected) {
                        state.compilationString +=
                            this._declareOutput(v4Output, state) +
                                ` = vec4(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"}, ${zwInput.associatedVariableName})${this._buildSwizzle(4)};\n`;
                    }
                    else {
                        state.compilationString +=
                            this._declareOutput(v4Output, state) +
                                ` = vec4(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(4)};\n`;
                    }
                }
                if (v3Output.hasEndpoints) {
                    state.compilationString +=
                        this._declareOutput(v3Output, state) +
                            ` = vec3(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"})${this._buildSwizzle(3)};\n`;
                }
                if (v2Output.hasEndpoints) {
                    state.compilationString +=
                        this._declareOutput(v2Output, state) +
                            ` = vec2(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"})${this._buildSwizzle(2)};\n`;
                }
                if (v2CompOutput.hasEndpoints) {
                    if (zwInput.isConnected) {
                        state.compilationString += this._declareOutput(v2CompOutput, state) + ` = ${zwInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                    }
                    else {
                        state.compilationString +=
                            this._declareOutput(v2CompOutput, state) +
                                ` = vec2(${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(2)};\n`;
                    }
                }
            }
            return this;
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.xSwizzle = this.xSwizzle;
            serializationObject.ySwizzle = this.ySwizzle;
            serializationObject.zSwizzle = this.zSwizzle;
            serializationObject.wSwizzle = this.wSwizzle;
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            var _a, _b, _c, _d;
            super._deserialize(serializationObject, scene, rootUrl);
            this.xSwizzle = (_a = serializationObject.xSwizzle) !== null && _a !== void 0 ? _a : "x";
            this.ySwizzle = (_b = serializationObject.ySwizzle) !== null && _b !== void 0 ? _b : "y";
            this.zSwizzle = (_c = serializationObject.zSwizzle) !== null && _c !== void 0 ? _c : "z";
            this.wSwizzle = (_d = serializationObject.wSwizzle) !== null && _d !== void 0 ? _d : "w";
        }
        _dumpPropertiesCode() {
            let codeString = super._dumpPropertiesCode();
            codeString += `${this._codeVariableName}.xSwizzle = "${this.xSwizzle}";\n`;
            codeString += `${this._codeVariableName}.ySwizzle = "${this.ySwizzle}";\n`;
            codeString += `${this._codeVariableName}.zSwizzle = "${this.zSwizzle}";\n`;
            codeString += `${this._codeVariableName}.wSwizzle = "${this.wSwizzle}";\n`;
            return codeString;
        }
    }
    RegisterClass("BABYLON.VectorMergerBlock", VectorMergerBlock);

    /**
     * Block used to remap a float from a range to a new one
     */
    class RemapBlock extends NodeMaterialBlock {
        /**
         * Creates a new RemapBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Neutral);
            /**
             * Gets or sets the source range
             */
            this.sourceRange = new Vector2(-1, 1);
            /**
             * Gets or sets the target range
             */
            this.targetRange = new Vector2(0, 1);
            this.registerInput("input", NodeMaterialBlockConnectionPointTypes.AutoDetect);
            this.registerInput("sourceMin", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerInput("sourceMax", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerInput("targetMin", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerInput("targetMax", NodeMaterialBlockConnectionPointTypes.Float, true);
            this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
            this._outputs[0]._typeConnectionSource = this._inputs[0];
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "RemapBlock";
        }
        /**
         * Gets the input component
         */
        get input() {
            return this._inputs[0];
        }
        /**
         * Gets the source min input component
         */
        get sourceMin() {
            return this._inputs[1];
        }
        /**
         * Gets the source max input component
         */
        get sourceMax() {
            return this._inputs[2];
        }
        /**
         * Gets the target min input component
         */
        get targetMin() {
            return this._inputs[3];
        }
        /**
         * Gets the target max input component
         */
        get targetMax() {
            return this._inputs[4];
        }
        /**
         * Gets the output component
         */
        get output() {
            return this._outputs[0];
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const output = this._outputs[0];
            const sourceMin = this.sourceMin.isConnected ? this.sourceMin.associatedVariableName : this._writeFloat(this.sourceRange.x);
            const sourceMax = this.sourceMax.isConnected ? this.sourceMax.associatedVariableName : this._writeFloat(this.sourceRange.y);
            const targetMin = this.targetMin.isConnected ? this.targetMin.associatedVariableName : this._writeFloat(this.targetRange.x);
            const targetMax = this.targetMax.isConnected ? this.targetMax.associatedVariableName : this._writeFloat(this.targetRange.y);
            state.compilationString +=
                this._declareOutput(output, state) +
                    ` = ${targetMin} + (${this._inputs[0].associatedVariableName} - ${sourceMin}) * (${targetMax} - ${targetMin}) / (${sourceMax} - ${sourceMin});\n`;
            return this;
        }
        _dumpPropertiesCode() {
            let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.sourceRange = new BABYLON.Vector2(${this.sourceRange.x}, ${this.sourceRange.y});\n`;
            codeString += `${this._codeVariableName}.targetRange = new BABYLON.Vector2(${this.targetRange.x}, ${this.targetRange.y});\n`;
            return codeString;
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.sourceRange = this.sourceRange.asArray();
            serializationObject.targetRange = this.targetRange.asArray();
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            super._deserialize(serializationObject, scene, rootUrl);
            this.sourceRange = Vector2.FromArray(serializationObject.sourceRange);
            this.targetRange = Vector2.FromArray(serializationObject.targetRange);
        }
    }
    __decorate$1([
        editableInPropertyPage("From", PropertyTypeForEdition.Vector2)
    ], RemapBlock.prototype, "sourceRange", void 0);
    __decorate$1([
        editableInPropertyPage("To", PropertyTypeForEdition.Vector2)
    ], RemapBlock.prototype, "targetRange", void 0);
    RegisterClass("BABYLON.RemapBlock", RemapBlock);

    /**
     * Block used to multiply 2 values
     */
    class MultiplyBlock extends NodeMaterialBlock {
        /**
         * Creates a new MultiplyBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Neutral);
            this.registerInput("left", NodeMaterialBlockConnectionPointTypes.AutoDetect);
            this.registerInput("right", NodeMaterialBlockConnectionPointTypes.AutoDetect);
            this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
            this._outputs[0]._typeConnectionSource = this._inputs[0];
            this._linkConnectionTypes(0, 1);
            this._inputs[0].acceptedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Float);
            this._inputs[1].acceptedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Float);
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "MultiplyBlock";
        }
        /**
         * Gets the left operand input component
         */
        get left() {
            return this._inputs[0];
        }
        /**
         * Gets the right operand input component
         */
        get right() {
            return this._inputs[1];
        }
        /**
         * Gets the output component
         */
        get output() {
            return this._outputs[0];
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const output = this._outputs[0];
            state.compilationString += this._declareOutput(output, state) + ` = ${this.left.associatedVariableName} * ${this.right.associatedVariableName};\n`;
            return this;
        }
    }
    RegisterClass("BABYLON.MultiplyBlock", MultiplyBlock);

    /**
     * Enum used to define the material modes
     */
    var NodeMaterialModes;
    (function (NodeMaterialModes) {
        /** Regular material */
        NodeMaterialModes[NodeMaterialModes["Material"] = 0] = "Material";
        /** For post process */
        NodeMaterialModes[NodeMaterialModes["PostProcess"] = 1] = "PostProcess";
        /** For particle system */
        NodeMaterialModes[NodeMaterialModes["Particle"] = 2] = "Particle";
        /** For procedural texture */
        NodeMaterialModes[NodeMaterialModes["ProceduralTexture"] = 3] = "ProceduralTexture";
    })(NodeMaterialModes || (NodeMaterialModes = {}));

    /**
     * Particle emitter emitting particles from the inside of a box.
     * It emits the particles randomly between 2 given directions.
     */
    class BoxParticleEmitter {
        /**
         * Creates a new instance BoxParticleEmitter
         */
        constructor() {
            /**
             * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
             */
            this.direction1 = new Vector3(0, 1.0, 0);
            /**
             * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
             */
            this.direction2 = new Vector3(0, 1.0, 0);
            /**
             * Minimum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
             */
            this.minEmitBox = new Vector3(-0.5, -0.5, -0.5);
            /**
             * Maximum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
             */
            this.maxEmitBox = new Vector3(0.5, 0.5, 0.5);
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
            const randX = Scalar.RandomRange(this.direction1.x, this.direction2.x);
            const randY = Scalar.RandomRange(this.direction1.y, this.direction2.y);
            const randZ = Scalar.RandomRange(this.direction1.z, this.direction2.z);
            if (isLocal) {
                directionToUpdate.x = randX;
                directionToUpdate.y = randY;
                directionToUpdate.z = randZ;
                return;
            }
            Vector3.TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            const randX = Scalar.RandomRange(this.minEmitBox.x, this.maxEmitBox.x);
            const randY = Scalar.RandomRange(this.minEmitBox.y, this.maxEmitBox.y);
            const randZ = Scalar.RandomRange(this.minEmitBox.z, this.maxEmitBox.z);
            if (isLocal) {
                positionToUpdate.x = randX;
                positionToUpdate.y = randY;
                positionToUpdate.z = randZ;
                return;
            }
            Vector3.TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new BoxParticleEmitter();
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setVector3("direction1", this.direction1);
            uboOrEffect.setVector3("direction2", this.direction2);
            uboOrEffect.setVector3("minEmitBox", this.minEmitBox);
            uboOrEffect.setVector3("maxEmitBox", this.maxEmitBox);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("direction1", 3);
            ubo.addUniform("direction2", 3);
            ubo.addUniform("minEmitBox", 3);
            ubo.addUniform("maxEmitBox", 3);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define BOXEMITTER";
        }
        /**
         * Returns the string "BoxParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "BoxParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.direction1 = this.direction1.asArray();
            serializationObject.direction2 = this.direction2.asArray();
            serializationObject.minEmitBox = this.minEmitBox.asArray();
            serializationObject.maxEmitBox = this.maxEmitBox.asArray();
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            Vector3.FromArrayToRef(serializationObject.direction1, 0, this.direction1);
            Vector3.FromArrayToRef(serializationObject.direction2, 0, this.direction2);
            Vector3.FromArrayToRef(serializationObject.minEmitBox, 0, this.minEmitBox);
            Vector3.FromArrayToRef(serializationObject.maxEmitBox, 0, this.maxEmitBox);
        }
    }

    /**
     * Particle emitter emitting particles from the inside of a cone.
     * It emits the particles alongside the cone volume from the base to the particle.
     * The emission direction might be randomized.
     */
    class ConeParticleEmitter {
        /**
         * Gets or sets the radius of the emission cone
         */
        get radius() {
            return this._radius;
        }
        set radius(value) {
            this._radius = value;
            this._buildHeight();
        }
        /**
         * Gets or sets the angle of the emission cone
         */
        get angle() {
            return this._angle;
        }
        set angle(value) {
            this._angle = value;
            this._buildHeight();
        }
        _buildHeight() {
            if (this._angle !== 0) {
                this._height = this._radius / Math.tan(this._angle / 2);
            }
            else {
                this._height = 1;
            }
        }
        /**
         * Creates a new instance ConeParticleEmitter
         * @param radius the radius of the emission cone (1 by default)
         * @param angle the cone base angle (PI by default)
         * @param directionRandomizer defines how much to randomize the particle direction [0-1] (default is 0)
         */
        constructor(radius = 1, angle = Math.PI, 
        /** defines how much to randomize the particle direction [0-1] (default is 0) */
        directionRandomizer = 0) {
            this.directionRandomizer = directionRandomizer;
            /**
             * Gets or sets a value indicating where on the radius the start position should be picked (1 = everywhere, 0 = only surface)
             */
            this.radiusRange = 1;
            /**
             * Gets or sets a value indicating where on the height the start position should be picked (1 = everywhere, 0 = only surface)
             */
            this.heightRange = 1;
            /**
             * Gets or sets a value indicating if all the particles should be emitted from the spawn point only (the base of the cone)
             */
            this.emitFromSpawnPointOnly = false;
            this.angle = angle;
            this.radius = radius;
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
            if (isLocal) {
                TmpVectors.Vector3[0].copyFrom(particle._localPosition).normalize();
            }
            else {
                particle.position.subtractToRef(worldMatrix.getTranslation(), TmpVectors.Vector3[0]).normalize();
            }
            const randX = Scalar.RandomRange(0, this.directionRandomizer);
            const randY = Scalar.RandomRange(0, this.directionRandomizer);
            const randZ = Scalar.RandomRange(0, this.directionRandomizer);
            directionToUpdate.x = TmpVectors.Vector3[0].x + randX;
            directionToUpdate.y = TmpVectors.Vector3[0].y + randY;
            directionToUpdate.z = TmpVectors.Vector3[0].z + randZ;
            directionToUpdate.normalize();
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            const s = Scalar.RandomRange(0, Math.PI * 2);
            let h;
            if (!this.emitFromSpawnPointOnly) {
                h = Scalar.RandomRange(0, this.heightRange);
                // Better distribution in a cone at normal angles.
                h = 1 - h * h;
            }
            else {
                h = 0.0001;
            }
            let radius = this._radius - Scalar.RandomRange(0, this._radius * this.radiusRange);
            radius = radius * h;
            const randX = radius * Math.sin(s);
            const randZ = radius * Math.cos(s);
            const randY = h * this._height;
            if (isLocal) {
                positionToUpdate.x = randX;
                positionToUpdate.y = randY;
                positionToUpdate.z = randZ;
                return;
            }
            Vector3.TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new ConeParticleEmitter(this._radius, this._angle, this.directionRandomizer);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setFloat2("radius", this._radius, this.radiusRange);
            uboOrEffect.setFloat("coneAngle", this._angle);
            uboOrEffect.setFloat2("height", this._height, this.heightRange);
            uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("radius", 2);
            ubo.addUniform("coneAngle", 1);
            ubo.addUniform("height", 2);
            ubo.addUniform("directionRandomizer", 1);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            let defines = "#define CONEEMITTER";
            if (this.emitFromSpawnPointOnly) {
                defines += "\n#define CONEEMITTERSPAWNPOINT";
            }
            return defines;
        }
        /**
         * Returns the string "ConeParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "ConeParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.radius = this._radius;
            serializationObject.angle = this._angle;
            serializationObject.directionRandomizer = this.directionRandomizer;
            serializationObject.radiusRange = this.radiusRange;
            serializationObject.heightRange = this.heightRange;
            serializationObject.emitFromSpawnPointOnly = this.emitFromSpawnPointOnly;
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            this.radius = serializationObject.radius;
            this.angle = serializationObject.angle;
            this.directionRandomizer = serializationObject.directionRandomizer;
            this.radiusRange = serializationObject.radiusRange !== undefined ? serializationObject.radiusRange : 1;
            this.heightRange = serializationObject.radiusRange !== undefined ? serializationObject.heightRange : 1;
            this.emitFromSpawnPointOnly = serializationObject.emitFromSpawnPointOnly !== undefined ? serializationObject.emitFromSpawnPointOnly : false;
        }
    }

    /**
     * Particle emitter emitting particles from the inside of a cylinder.
     * It emits the particles alongside the cylinder radius. The emission direction might be randomized.
     */
    class CylinderParticleEmitter {
        /**
         * Creates a new instance CylinderParticleEmitter
         * @param radius the radius of the emission cylinder (1 by default)
         * @param height the height of the emission cylinder (1 by default)
         * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
         * @param directionRandomizer defines how much to randomize the particle direction [0-1]
         */
        constructor(
        /**
         * The radius of the emission cylinder.
         */
        radius = 1, 
        /**
         * The height of the emission cylinder.
         */
        height = 1, 
        /**
         * The range of emission [0-1] 0 Surface only, 1 Entire Radius.
         */
        radiusRange = 1, 
        /**
         * How much to randomize the particle direction [0-1].
         */
        directionRandomizer = 0) {
            this.radius = radius;
            this.height = height;
            this.radiusRange = radiusRange;
            this.directionRandomizer = directionRandomizer;
            this._tempVector = Vector3.Zero();
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         * @param inverseWorldMatrix defines the inverted world matrix to use if isLocal is false
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal, inverseWorldMatrix) {
            particle.position.subtractToRef(worldMatrix.getTranslation(), this._tempVector);
            this._tempVector.normalize();
            Vector3.TransformNormalToRef(this._tempVector, inverseWorldMatrix, this._tempVector);
            const randY = Scalar.RandomRange(-this.directionRandomizer / 2, this.directionRandomizer / 2);
            let angle = Math.atan2(this._tempVector.x, this._tempVector.z);
            angle += Scalar.RandomRange(-Math.PI / 2, Math.PI / 2) * this.directionRandomizer;
            this._tempVector.y = randY; // set direction y to rand y to mirror normal of cylinder surface
            this._tempVector.x = Math.sin(angle);
            this._tempVector.z = Math.cos(angle);
            this._tempVector.normalize();
            if (isLocal) {
                directionToUpdate.copyFrom(this._tempVector);
                return;
            }
            Vector3.TransformNormalFromFloatsToRef(this._tempVector.x, this._tempVector.y, this._tempVector.z, worldMatrix, directionToUpdate);
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            const yPos = Scalar.RandomRange(-this.height / 2, this.height / 2);
            const angle = Scalar.RandomRange(0, 2 * Math.PI);
            // Pick a properly distributed point within the circle https://programming.guide/random-point-within-circle.html
            const radiusDistribution = Scalar.RandomRange((1 - this.radiusRange) * (1 - this.radiusRange), 1);
            const positionRadius = Math.sqrt(radiusDistribution) * this.radius;
            const xPos = positionRadius * Math.cos(angle);
            const zPos = positionRadius * Math.sin(angle);
            if (isLocal) {
                positionToUpdate.copyFromFloats(xPos, yPos, zPos);
                return;
            }
            Vector3.TransformCoordinatesFromFloatsToRef(xPos, yPos, zPos, worldMatrix, positionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new CylinderParticleEmitter(this.radius, this.directionRandomizer);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setFloat("radius", this.radius);
            uboOrEffect.setFloat("height", this.height);
            uboOrEffect.setFloat("radiusRange", this.radiusRange);
            uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("radius", 1);
            ubo.addUniform("height", 1);
            ubo.addUniform("radiusRange", 1);
            ubo.addUniform("directionRandomizer", 1);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define CYLINDEREMITTER";
        }
        /**
         * Returns the string "CylinderParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "CylinderParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.radius = this.radius;
            serializationObject.height = this.height;
            serializationObject.radiusRange = this.radiusRange;
            serializationObject.directionRandomizer = this.directionRandomizer;
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            this.radius = serializationObject.radius;
            this.height = serializationObject.height;
            this.radiusRange = serializationObject.radiusRange;
            this.directionRandomizer = serializationObject.directionRandomizer;
        }
    }
    /**
     * Particle emitter emitting particles from the inside of a cylinder.
     * It emits the particles randomly between two vectors.
     */
    class CylinderDirectedParticleEmitter extends CylinderParticleEmitter {
        /**
         * Creates a new instance CylinderDirectedParticleEmitter
         * @param radius the radius of the emission cylinder (1 by default)
         * @param height the height of the emission cylinder (1 by default)
         * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
         * @param direction1 the min limit of the emission direction (up vector by default)
         * @param direction2 the max limit of the emission direction (up vector by default)
         */
        constructor(radius = 1, height = 1, radiusRange = 1, 
        /**
         * The min limit of the emission direction.
         */
        direction1 = new Vector3(0, 1, 0), 
        /**
         * The max limit of the emission direction.
         */
        direction2 = new Vector3(0, 1, 0)) {
            super(radius, height, radiusRange);
            this.direction1 = direction1;
            this.direction2 = direction2;
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         */
        startDirectionFunction(worldMatrix, directionToUpdate) {
            const randX = Scalar.RandomRange(this.direction1.x, this.direction2.x);
            const randY = Scalar.RandomRange(this.direction1.y, this.direction2.y);
            const randZ = Scalar.RandomRange(this.direction1.z, this.direction2.z);
            Vector3.TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new CylinderDirectedParticleEmitter(this.radius, this.height, this.radiusRange, this.direction1, this.direction2);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setFloat("radius", this.radius);
            uboOrEffect.setFloat("height", this.height);
            uboOrEffect.setFloat("radiusRange", this.radiusRange);
            uboOrEffect.setVector3("direction1", this.direction1);
            uboOrEffect.setVector3("direction2", this.direction2);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("radius", 1);
            ubo.addUniform("height", 1);
            ubo.addUniform("radiusRange", 1);
            ubo.addUniform("direction1", 3);
            ubo.addUniform("direction2", 3);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define CYLINDEREMITTER\n#define DIRECTEDCYLINDEREMITTER";
        }
        /**
         * Returns the string "CylinderDirectedParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "CylinderDirectedParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.direction1 = this.direction1.asArray();
            serializationObject.direction2 = this.direction2.asArray();
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            super.parse(serializationObject);
            this.direction1.copyFrom(serializationObject.direction1);
            this.direction2.copyFrom(serializationObject.direction2);
        }
    }

    /**
     * Particle emitter emitting particles from the inside of a hemisphere.
     * It emits the particles alongside the hemisphere radius. The emission direction might be randomized.
     */
    class HemisphericParticleEmitter {
        /**
         * Creates a new instance HemisphericParticleEmitter
         * @param radius the radius of the emission hemisphere (1 by default)
         * @param radiusRange the range of the emission hemisphere [0-1] 0 Surface only, 1 Entire Radius (1 by default)
         * @param directionRandomizer defines how much to randomize the particle direction [0-1]
         */
        constructor(
        /**
         * The radius of the emission hemisphere.
         */
        radius = 1, 
        /**
         * The range of emission [0-1] 0 Surface only, 1 Entire Radius.
         */
        radiusRange = 1, 
        /**
         * How much to randomize the particle direction [0-1].
         */
        directionRandomizer = 0) {
            this.radius = radius;
            this.radiusRange = radiusRange;
            this.directionRandomizer = directionRandomizer;
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
            const direction = particle.position.subtract(worldMatrix.getTranslation()).normalize();
            const randX = Scalar.RandomRange(0, this.directionRandomizer);
            const randY = Scalar.RandomRange(0, this.directionRandomizer);
            const randZ = Scalar.RandomRange(0, this.directionRandomizer);
            direction.x += randX;
            direction.y += randY;
            direction.z += randZ;
            direction.normalize();
            if (isLocal) {
                directionToUpdate.copyFrom(direction);
                return;
            }
            Vector3.TransformNormalFromFloatsToRef(direction.x, direction.y, direction.z, worldMatrix, directionToUpdate);
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            const randRadius = this.radius - Scalar.RandomRange(0, this.radius * this.radiusRange);
            const v = Scalar.RandomRange(0, 1.0);
            const phi = Scalar.RandomRange(0, 2 * Math.PI);
            const theta = Math.acos(2 * v - 1);
            const randX = randRadius * Math.cos(phi) * Math.sin(theta);
            const randY = randRadius * Math.cos(theta);
            const randZ = randRadius * Math.sin(phi) * Math.sin(theta);
            if (isLocal) {
                positionToUpdate.copyFromFloats(randX, Math.abs(randY), randZ);
                return;
            }
            Vector3.TransformCoordinatesFromFloatsToRef(randX, Math.abs(randY), randZ, worldMatrix, positionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new HemisphericParticleEmitter(this.radius, this.directionRandomizer);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setFloat("radius", this.radius);
            uboOrEffect.setFloat("radiusRange", this.radiusRange);
            uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("radius", 1);
            ubo.addUniform("radiusRange", 1);
            ubo.addUniform("directionRandomizer", 1);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define HEMISPHERICEMITTER";
        }
        /**
         * Returns the string "HemisphericParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "HemisphericParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.radius = this.radius;
            serializationObject.radiusRange = this.radiusRange;
            serializationObject.directionRandomizer = this.directionRandomizer;
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            this.radius = serializationObject.radius;
            this.radiusRange = serializationObject.radiusRange;
            this.directionRandomizer = serializationObject.directionRandomizer;
        }
    }

    /**
     * Particle emitter emitting particles from a point.
     * It emits the particles randomly between 2 given directions.
     */
    class PointParticleEmitter {
        /**
         * Creates a new instance PointParticleEmitter
         */
        constructor() {
            /**
             * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
             */
            this.direction1 = new Vector3(0, 1.0, 0);
            /**
             * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
             */
            this.direction2 = new Vector3(0, 1.0, 0);
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
            const randX = Scalar.RandomRange(this.direction1.x, this.direction2.x);
            const randY = Scalar.RandomRange(this.direction1.y, this.direction2.y);
            const randZ = Scalar.RandomRange(this.direction1.z, this.direction2.z);
            if (isLocal) {
                directionToUpdate.copyFromFloats(randX, randY, randZ);
                return;
            }
            Vector3.TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            if (isLocal) {
                positionToUpdate.copyFromFloats(0, 0, 0);
                return;
            }
            Vector3.TransformCoordinatesFromFloatsToRef(0, 0, 0, worldMatrix, positionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new PointParticleEmitter();
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setVector3("direction1", this.direction1);
            uboOrEffect.setVector3("direction2", this.direction2);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("direction1", 3);
            ubo.addUniform("direction2", 3);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define POINTEMITTER";
        }
        /**
         * Returns the string "PointParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "PointParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.direction1 = this.direction1.asArray();
            serializationObject.direction2 = this.direction2.asArray();
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            Vector3.FromArrayToRef(serializationObject.direction1, 0, this.direction1);
            Vector3.FromArrayToRef(serializationObject.direction2, 0, this.direction2);
        }
    }

    /**
     * Particle emitter emitting particles from the inside of a sphere.
     * It emits the particles alongside the sphere radius. The emission direction might be randomized.
     */
    class SphereParticleEmitter {
        /**
         * Creates a new instance SphereParticleEmitter
         * @param radius the radius of the emission sphere (1 by default)
         * @param radiusRange the range of the emission sphere [0-1] 0 Surface only, 1 Entire Radius (1 by default)
         * @param directionRandomizer defines how much to randomize the particle direction [0-1]
         */
        constructor(
        /**
         * The radius of the emission sphere.
         */
        radius = 1, 
        /**
         * The range of emission [0-1] 0 Surface only, 1 Entire Radius.
         */
        radiusRange = 1, 
        /**
         * How much to randomize the particle direction [0-1].
         */
        directionRandomizer = 0) {
            this.radius = radius;
            this.radiusRange = radiusRange;
            this.directionRandomizer = directionRandomizer;
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
            const direction = particle.position.subtract(worldMatrix.getTranslation()).normalize();
            const randX = Scalar.RandomRange(0, this.directionRandomizer);
            const randY = Scalar.RandomRange(0, this.directionRandomizer);
            const randZ = Scalar.RandomRange(0, this.directionRandomizer);
            direction.x += randX;
            direction.y += randY;
            direction.z += randZ;
            direction.normalize();
            if (isLocal) {
                directionToUpdate.copyFrom(direction);
                return;
            }
            Vector3.TransformNormalFromFloatsToRef(direction.x, direction.y, direction.z, worldMatrix, directionToUpdate);
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            const randRadius = this.radius - Scalar.RandomRange(0, this.radius * this.radiusRange);
            const v = Scalar.RandomRange(0, 1.0);
            const phi = Scalar.RandomRange(0, 2 * Math.PI);
            const theta = Math.acos(2 * v - 1);
            const randX = randRadius * Math.cos(phi) * Math.sin(theta);
            const randY = randRadius * Math.cos(theta);
            const randZ = randRadius * Math.sin(phi) * Math.sin(theta);
            if (isLocal) {
                positionToUpdate.copyFromFloats(randX, randY, randZ);
                return;
            }
            Vector3.TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new SphereParticleEmitter(this.radius, this.directionRandomizer);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setFloat("radius", this.radius);
            uboOrEffect.setFloat("radiusRange", this.radiusRange);
            uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("radius", 1);
            ubo.addUniform("radiusRange", 1);
            ubo.addUniform("directionRandomizer", 1);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define SPHEREEMITTER";
        }
        /**
         * Returns the string "SphereParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "SphereParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.radius = this.radius;
            serializationObject.radiusRange = this.radiusRange;
            serializationObject.directionRandomizer = this.directionRandomizer;
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            this.radius = serializationObject.radius;
            this.radiusRange = serializationObject.radiusRange;
            this.directionRandomizer = serializationObject.directionRandomizer;
        }
    }
    /**
     * Particle emitter emitting particles from the inside of a sphere.
     * It emits the particles randomly between two vectors.
     */
    class SphereDirectedParticleEmitter extends SphereParticleEmitter {
        /**
         * Creates a new instance SphereDirectedParticleEmitter
         * @param radius the radius of the emission sphere (1 by default)
         * @param direction1 the min limit of the emission direction (up vector by default)
         * @param direction2 the max limit of the emission direction (up vector by default)
         */
        constructor(radius = 1, 
        /**
         * The min limit of the emission direction.
         */
        direction1 = new Vector3(0, 1, 0), 
        /**
         * The max limit of the emission direction.
         */
        direction2 = new Vector3(0, 1, 0)) {
            super(radius);
            this.direction1 = direction1;
            this.direction2 = direction2;
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         */
        startDirectionFunction(worldMatrix, directionToUpdate) {
            const randX = Scalar.RandomRange(this.direction1.x, this.direction2.x);
            const randY = Scalar.RandomRange(this.direction1.y, this.direction2.y);
            const randZ = Scalar.RandomRange(this.direction1.z, this.direction2.z);
            Vector3.TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new SphereDirectedParticleEmitter(this.radius, this.direction1, this.direction2);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setFloat("radius", this.radius);
            uboOrEffect.setFloat("radiusRange", this.radiusRange);
            uboOrEffect.setVector3("direction1", this.direction1);
            uboOrEffect.setVector3("direction2", this.direction2);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("radius", 1);
            ubo.addUniform("radiusRange", 1);
            ubo.addUniform("direction1", 3);
            ubo.addUniform("direction2", 3);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "#define SPHEREEMITTER\n#define DIRECTEDSPHEREEMITTER";
        }
        /**
         * Returns the string "SphereDirectedParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "SphereDirectedParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.direction1 = this.direction1.asArray();
            serializationObject.direction2 = this.direction2.asArray();
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         */
        parse(serializationObject) {
            super.parse(serializationObject);
            this.direction1.copyFrom(serializationObject.direction1);
            this.direction2.copyFrom(serializationObject.direction2);
        }
    }

    /**
     * Particle emitter emitting particles from the inside of a box.
     * It emits the particles randomly between 2 given directions.
     */
    class MeshParticleEmitter {
        /** Defines the mesh to use as source */
        get mesh() {
            return this._mesh;
        }
        set mesh(value) {
            if (this._mesh === value) {
                return;
            }
            this._mesh = value;
            if (value) {
                this._indices = value.getIndices();
                this._positions = value.getVerticesData(VertexBuffer.PositionKind);
                this._normals = value.getVerticesData(VertexBuffer.NormalKind);
            }
            else {
                this._indices = null;
                this._positions = null;
                this._normals = null;
            }
        }
        /**
         * Creates a new instance MeshParticleEmitter
         * @param mesh defines the mesh to use as source
         */
        constructor(mesh = null) {
            this._indices = null;
            this._positions = null;
            this._normals = null;
            this._storedNormal = Vector3.Zero();
            this._mesh = null;
            /**
             * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
             */
            this.direction1 = new Vector3(0, 1.0, 0);
            /**
             * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
             */
            this.direction2 = new Vector3(0, 1.0, 0);
            /**
             * Gets or sets a boolean indicating that particle directions must be built from mesh face normals
             */
            this.useMeshNormalsForDirection = true;
            this.mesh = mesh;
        }
        /**
         * Called by the particle System when the direction is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param directionToUpdate is the direction vector to update with the result
         * @param particle is the particle we are computed the direction for
         * @param isLocal defines if the direction should be set in local space
         */
        startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
            if (this.useMeshNormalsForDirection && this._normals) {
                Vector3.TransformNormalToRef(this._storedNormal, worldMatrix, directionToUpdate);
                return;
            }
            const randX = Scalar.RandomRange(this.direction1.x, this.direction2.x);
            const randY = Scalar.RandomRange(this.direction1.y, this.direction2.y);
            const randZ = Scalar.RandomRange(this.direction1.z, this.direction2.z);
            if (isLocal) {
                directionToUpdate.copyFromFloats(randX, randY, randZ);
                return;
            }
            Vector3.TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
        }
        /**
         * Called by the particle System when the position is computed for the created particle.
         * @param worldMatrix is the world matrix of the particle system
         * @param positionToUpdate is the position vector to update with the result
         * @param particle is the particle we are computed the position for
         * @param isLocal defines if the position should be set in local space
         */
        startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
            if (!this._indices || !this._positions) {
                return;
            }
            const randomFaceIndex = (3 * Math.random() * (this._indices.length / 3)) | 0;
            const bu = Math.random();
            const bv = Math.random() * (1.0 - bu);
            const bw = 1.0 - bu - bv;
            const faceIndexA = this._indices[randomFaceIndex];
            const faceIndexB = this._indices[randomFaceIndex + 1];
            const faceIndexC = this._indices[randomFaceIndex + 2];
            const vertexA = TmpVectors.Vector3[0];
            const vertexB = TmpVectors.Vector3[1];
            const vertexC = TmpVectors.Vector3[2];
            const randomVertex = TmpVectors.Vector3[3];
            Vector3.FromArrayToRef(this._positions, faceIndexA * 3, vertexA);
            Vector3.FromArrayToRef(this._positions, faceIndexB * 3, vertexB);
            Vector3.FromArrayToRef(this._positions, faceIndexC * 3, vertexC);
            randomVertex.x = bu * vertexA.x + bv * vertexB.x + bw * vertexC.x;
            randomVertex.y = bu * vertexA.y + bv * vertexB.y + bw * vertexC.y;
            randomVertex.z = bu * vertexA.z + bv * vertexB.z + bw * vertexC.z;
            if (isLocal) {
                positionToUpdate.copyFromFloats(randomVertex.x, randomVertex.y, randomVertex.z);
            }
            else {
                Vector3.TransformCoordinatesFromFloatsToRef(randomVertex.x, randomVertex.y, randomVertex.z, worldMatrix, positionToUpdate);
            }
            if (this.useMeshNormalsForDirection && this._normals) {
                Vector3.FromArrayToRef(this._normals, faceIndexA * 3, vertexA);
                Vector3.FromArrayToRef(this._normals, faceIndexB * 3, vertexB);
                Vector3.FromArrayToRef(this._normals, faceIndexC * 3, vertexC);
                this._storedNormal.x = bu * vertexA.x + bv * vertexB.x + bw * vertexC.x;
                this._storedNormal.y = bu * vertexA.y + bv * vertexB.y + bw * vertexC.y;
                this._storedNormal.z = bu * vertexA.z + bv * vertexB.z + bw * vertexC.z;
            }
        }
        /**
         * Clones the current emitter and returns a copy of it
         * @returns the new emitter
         */
        clone() {
            const newOne = new MeshParticleEmitter(this.mesh);
            DeepCopier.DeepCopy(this, newOne);
            return newOne;
        }
        /**
         * Called by the GPUParticleSystem to setup the update shader
         * @param uboOrEffect defines the update shader
         */
        applyToShader(uboOrEffect) {
            uboOrEffect.setVector3("direction1", this.direction1);
            uboOrEffect.setVector3("direction2", this.direction2);
        }
        /**
         * Creates the structure of the ubo for this particle emitter
         * @param ubo ubo to create the structure for
         */
        buildUniformLayout(ubo) {
            ubo.addUniform("direction1", 3);
            ubo.addUniform("direction2", 3);
        }
        /**
         * Returns a string to use to update the GPU particles update shader
         * @returns a string containing the defines string
         */
        getEffectDefines() {
            return "";
        }
        /**
         * Returns the string "BoxParticleEmitter"
         * @returns a string containing the class name
         */
        getClassName() {
            return "MeshParticleEmitter";
        }
        /**
         * Serializes the particle system to a JSON object.
         * @returns the JSON object
         */
        serialize() {
            var _a;
            const serializationObject = {};
            serializationObject.type = this.getClassName();
            serializationObject.direction1 = this.direction1.asArray();
            serializationObject.direction2 = this.direction2.asArray();
            serializationObject.meshId = (_a = this.mesh) === null || _a === void 0 ? void 0 : _a.id;
            serializationObject.useMeshNormalsForDirection = this.useMeshNormalsForDirection;
            return serializationObject;
        }
        /**
         * Parse properties from a JSON object
         * @param serializationObject defines the JSON object
         * @param scene defines the hosting scene
         */
        parse(serializationObject, scene) {
            Vector3.FromArrayToRef(serializationObject.direction1, 0, this.direction1);
            Vector3.FromArrayToRef(serializationObject.direction2, 0, this.direction2);
            if (serializationObject.meshId && scene) {
                this.mesh = scene.getLastMeshById(serializationObject.meshId);
            }
            this.useMeshNormalsForDirection = serializationObject.useMeshNormalsForDirection;
        }
    }

    /**
     * This represents the base class for particle system in Babylon.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * Particles can take different shapes while emitted like box, sphere, cone or you can write your custom function.
     * @example https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro
     */
    class BaseParticleSystem {
        /**
         * Gets or sets a texture used to add random noise to particle positions
         */
        get noiseTexture() {
            return this._noiseTexture;
        }
        set noiseTexture(value) {
            if (this._noiseTexture === value) {
                return;
            }
            this._noiseTexture = value;
            this._reset();
        }
        /**
         * Gets or sets whether an animation sprite sheet is enabled or not on the particle system
         */
        get isAnimationSheetEnabled() {
            return this._isAnimationSheetEnabled;
        }
        set isAnimationSheetEnabled(value) {
            if (this._isAnimationSheetEnabled == value) {
                return;
            }
            this._isAnimationSheetEnabled = value;
            this._reset();
        }
        /**
         * Gets or sets a boolean enabling the use of logarithmic depth buffers, which is good for wide depth buffers.
         */
        get useLogarithmicDepth() {
            return this._useLogarithmicDepth;
        }
        set useLogarithmicDepth(value) {
            this._useLogarithmicDepth = value && this.getScene().getEngine().getCaps().fragmentDepthSupported;
        }
        /**
         * Get hosting scene
         * @returns the scene
         */
        getScene() {
            return this._scene;
        }
        _hasTargetStopDurationDependantGradient() {
            return ((this._startSizeGradients && this._startSizeGradients.length > 0) ||
                (this._emitRateGradients && this._emitRateGradients.length > 0) ||
                (this._lifeTimeGradients && this._lifeTimeGradients.length > 0));
        }
        /**
         * Gets the current list of drag gradients.
         * You must use addDragGradient and removeDragGradient to update this list
         * @returns the list of drag gradients
         */
        getDragGradients() {
            return this._dragGradients;
        }
        /**
         * Gets the current list of limit velocity gradients.
         * You must use addLimitVelocityGradient and removeLimitVelocityGradient to update this list
         * @returns the list of limit velocity gradients
         */
        getLimitVelocityGradients() {
            return this._limitVelocityGradients;
        }
        /**
         * Gets the current list of color gradients.
         * You must use addColorGradient and removeColorGradient to update this list
         * @returns the list of color gradients
         */
        getColorGradients() {
            return this._colorGradients;
        }
        /**
         * Gets the current list of size gradients.
         * You must use addSizeGradient and removeSizeGradient to update this list
         * @returns the list of size gradients
         */
        getSizeGradients() {
            return this._sizeGradients;
        }
        /**
         * Gets the current list of color remap gradients.
         * You must use addColorRemapGradient and removeColorRemapGradient to update this list
         * @returns the list of color remap gradients
         */
        getColorRemapGradients() {
            return this._colorRemapGradients;
        }
        /**
         * Gets the current list of alpha remap gradients.
         * You must use addAlphaRemapGradient and removeAlphaRemapGradient to update this list
         * @returns the list of alpha remap gradients
         */
        getAlphaRemapGradients() {
            return this._alphaRemapGradients;
        }
        /**
         * Gets the current list of life time gradients.
         * You must use addLifeTimeGradient and removeLifeTimeGradient to update this list
         * @returns the list of life time gradients
         */
        getLifeTimeGradients() {
            return this._lifeTimeGradients;
        }
        /**
         * Gets the current list of angular speed gradients.
         * You must use addAngularSpeedGradient and removeAngularSpeedGradient to update this list
         * @returns the list of angular speed gradients
         */
        getAngularSpeedGradients() {
            return this._angularSpeedGradients;
        }
        /**
         * Gets the current list of velocity gradients.
         * You must use addVelocityGradient and removeVelocityGradient to update this list
         * @returns the list of velocity gradients
         */
        getVelocityGradients() {
            return this._velocityGradients;
        }
        /**
         * Gets the current list of start size gradients.
         * You must use addStartSizeGradient and removeStartSizeGradient to update this list
         * @returns the list of start size gradients
         */
        getStartSizeGradients() {
            return this._startSizeGradients;
        }
        /**
         * Gets the current list of emit rate gradients.
         * You must use addEmitRateGradient and removeEmitRateGradient to update this list
         * @returns the list of emit rate gradients
         */
        getEmitRateGradients() {
            return this._emitRateGradients;
        }
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         * This only works when particleEmitterTyps is a BoxParticleEmitter
         */
        get direction1() {
            if (this.particleEmitterType.direction1) {
                return this.particleEmitterType.direction1;
            }
            return Vector3.Zero();
        }
        set direction1(value) {
            if (this.particleEmitterType.direction1) {
                this.particleEmitterType.direction1 = value;
            }
        }
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         * This only works when particleEmitterTyps is a BoxParticleEmitter
         */
        get direction2() {
            if (this.particleEmitterType.direction2) {
                return this.particleEmitterType.direction2;
            }
            return Vector3.Zero();
        }
        set direction2(value) {
            if (this.particleEmitterType.direction2) {
                this.particleEmitterType.direction2 = value;
            }
        }
        /**
         * Minimum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
         * This only works when particleEmitterTyps is a BoxParticleEmitter
         */
        get minEmitBox() {
            if (this.particleEmitterType.minEmitBox) {
                return this.particleEmitterType.minEmitBox;
            }
            return Vector3.Zero();
        }
        set minEmitBox(value) {
            if (this.particleEmitterType.minEmitBox) {
                this.particleEmitterType.minEmitBox = value;
            }
        }
        /**
         * Maximum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
         * This only works when particleEmitterTyps is a BoxParticleEmitter
         */
        get maxEmitBox() {
            if (this.particleEmitterType.maxEmitBox) {
                return this.particleEmitterType.maxEmitBox;
            }
            return Vector3.Zero();
        }
        set maxEmitBox(value) {
            if (this.particleEmitterType.maxEmitBox) {
                this.particleEmitterType.maxEmitBox = value;
            }
        }
        /**
         * Gets or sets the billboard mode to use when isBillboardBased = true.
         * Value can be: ParticleSystem.BILLBOARDMODE_ALL, ParticleSystem.BILLBOARDMODE_Y, ParticleSystem.BILLBOARDMODE_STRETCHED
         */
        get billboardMode() {
            return this._billboardMode;
        }
        set billboardMode(value) {
            if (this._billboardMode === value) {
                return;
            }
            this._billboardMode = value;
            this._reset();
        }
        /**
         * Gets or sets a boolean indicating if the particles must be rendered as billboard or aligned with the direction
         */
        get isBillboardBased() {
            return this._isBillboardBased;
        }
        set isBillboardBased(value) {
            if (this._isBillboardBased === value) {
                return;
            }
            this._isBillboardBased = value;
            this._reset();
        }
        /**
         * Gets the image processing configuration used either in this material.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Sets the Default image processing configuration used either in the this material.
         *
         * If sets to null, the scene one is in use.
         */
        set imageProcessingConfiguration(value) {
            this._attachImageProcessingConfiguration(value);
        }
        /**
         * Attaches a new image processing configuration to the Standard Material.
         * @param configuration
         */
        _attachImageProcessingConfiguration(configuration) {
            if (configuration === this._imageProcessingConfiguration) {
                return;
            }
            // Pick the scene configuration if needed.
            if (!configuration && this._scene) {
                this._imageProcessingConfiguration = this._scene.imageProcessingConfiguration;
            }
            else {
                this._imageProcessingConfiguration = configuration;
            }
        }
        /** @internal */
        _reset() { }
        /**
         * @internal
         */
        _removeGradientAndTexture(gradient, gradients, texture) {
            if (!gradients) {
                return this;
            }
            let index = 0;
            for (const valueGradient of gradients) {
                if (valueGradient.gradient === gradient) {
                    gradients.splice(index, 1);
                    break;
                }
                index++;
            }
            if (texture) {
                texture.dispose();
            }
            return this;
        }
        /**
         * Instantiates a particle system.
         * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
         * @param name The name of the particle system
         */
        constructor(name) {
            /**
             * List of animations used by the particle system.
             */
            this.animations = [];
            /**
             * The rendering group used by the Particle system to chose when to render.
             */
            this.renderingGroupId = 0;
            /**
             * The emitter represents the Mesh or position we are attaching the particle system to.
             */
            this.emitter = Vector3.Zero();
            /**
             * The maximum number of particles to emit per frame
             */
            this.emitRate = 10;
            /**
             * If you want to launch only a few particles at once, that can be done, as well.
             */
            this.manualEmitCount = -1;
            /**
             * The overall motion speed (0.01 is default update speed, faster updates = faster animation)
             */
            this.updateSpeed = 0.01;
            /**
             * The amount of time the particle system is running (depends of the overall update speed).
             */
            this.targetStopDuration = 0;
            /**
             * Specifies whether the particle system will be disposed once it reaches the end of the animation.
             */
            this.disposeOnStop = false;
            /**
             * Minimum power of emitting particles.
             */
            this.minEmitPower = 1;
            /**
             * Maximum power of emitting particles.
             */
            this.maxEmitPower = 1;
            /**
             * Minimum life time of emitting particles.
             */
            this.minLifeTime = 1;
            /**
             * Maximum life time of emitting particles.
             */
            this.maxLifeTime = 1;
            /**
             * Minimum Size of emitting particles.
             */
            this.minSize = 1;
            /**
             * Maximum Size of emitting particles.
             */
            this.maxSize = 1;
            /**
             * Minimum scale of emitting particles on X axis.
             */
            this.minScaleX = 1;
            /**
             * Maximum scale of emitting particles on X axis.
             */
            this.maxScaleX = 1;
            /**
             * Minimum scale of emitting particles on Y axis.
             */
            this.minScaleY = 1;
            /**
             * Maximum scale of emitting particles on Y axis.
             */
            this.maxScaleY = 1;
            /**
             * Gets or sets the minimal initial rotation in radians.
             */
            this.minInitialRotation = 0;
            /**
             * Gets or sets the maximal initial rotation in radians.
             */
            this.maxInitialRotation = 0;
            /**
             * Minimum angular speed of emitting particles (Z-axis rotation for each particle).
             */
            this.minAngularSpeed = 0;
            /**
             * Maximum angular speed of emitting particles (Z-axis rotation for each particle).
             */
            this.maxAngularSpeed = 0;
            /**
             * The layer mask we are rendering the particles through.
             */
            this.layerMask = 0x0fffffff;
            /**
             * This can help using your own shader to render the particle system.
             * The according effect will be created
             */
            this.customShader = null;
            /**
             * By default particle system starts as soon as they are created. This prevents the
             * automatic start to happen and let you decide when to start emitting particles.
             */
            this.preventAutoStart = false;
            /** @internal */
            this._wasDispatched = false;
            this._rootUrl = "";
            /** Gets or sets the strength to apply to the noise value (default is (10, 10, 10)) */
            this.noiseStrength = new Vector3(10, 10, 10);
            /**
             * Callback triggered when the particle animation is ending.
             */
            this.onAnimationEnd = null;
            /**
             * Blend mode use to render the particle, it can be either ParticleSystem.BLENDMODE_ONEONE or ParticleSystem.BLENDMODE_STANDARD.
             */
            this.blendMode = BaseParticleSystem.BLENDMODE_ONEONE;
            /**
             * Forces the particle to write their depth information to the depth buffer. This can help preventing other draw calls
             * to override the particles.
             */
            this.forceDepthWrite = false;
            /** Gets or sets a value indicating how many cycles (or frames) must be executed before first rendering (this value has to be set before starting the system). Default is 0 */
            this.preWarmCycles = 0;
            /** Gets or sets a value indicating the time step multiplier to use in pre-warm mode (default is 1) */
            this.preWarmStepOffset = 1;
            /**
             * If using a spritesheet (isAnimationSheetEnabled) defines the speed of the sprite loop (default is 1 meaning the animation will play once during the entire particle lifetime)
             */
            this.spriteCellChangeSpeed = 1;
            /**
             * If using a spritesheet (isAnimationSheetEnabled) defines the first sprite cell to display
             */
            this.startSpriteCellID = 0;
            /**
             * If using a spritesheet (isAnimationSheetEnabled) defines the last sprite cell to display
             */
            this.endSpriteCellID = 0;
            /**
             * If using a spritesheet (isAnimationSheetEnabled), defines the sprite cell width to use
             */
            this.spriteCellWidth = 0;
            /**
             * If using a spritesheet (isAnimationSheetEnabled), defines the sprite cell height to use
             */
            this.spriteCellHeight = 0;
            /**
             * If using a spritesheet (isAnimationSheetEnabled), defines wether the sprite animation is looping
             */
            this.spriteCellLoop = true;
            /**
             * This allows the system to random pick the start cell ID between startSpriteCellID and endSpriteCellID
             */
            this.spriteRandomStartCell = false;
            /** Gets or sets a Vector2 used to move the pivot (by default (0,0)) */
            this.translationPivot = new Vector2(0, 0);
            /**
             * Gets or sets a boolean indicating that hosted animations (in the system.animations array) must be started when system.start() is called
             */
            this.beginAnimationOnStart = false;
            /**
             * Gets or sets the frame to start the animation from when beginAnimationOnStart is true
             */
            this.beginAnimationFrom = 0;
            /**
             * Gets or sets the frame to end the animation on when beginAnimationOnStart is true
             */
            this.beginAnimationTo = 60;
            /**
             * Gets or sets a boolean indicating if animations must loop when beginAnimationOnStart is true
             */
            this.beginAnimationLoop = false;
            /**
             * Gets or sets a world offset applied to all particles
             */
            this.worldOffset = new Vector3(0, 0, 0);
            this._useLogarithmicDepth = false;
            /**
             * You can use gravity if you want to give an orientation to your particles.
             */
            this.gravity = Vector3.Zero();
            this._colorGradients = null;
            this._sizeGradients = null;
            this._lifeTimeGradients = null;
            this._angularSpeedGradients = null;
            this._velocityGradients = null;
            this._limitVelocityGradients = null;
            this._dragGradients = null;
            this._emitRateGradients = null;
            this._startSizeGradients = null;
            this._rampGradients = null;
            this._colorRemapGradients = null;
            this._alphaRemapGradients = null;
            /**
             * Defines the delay in milliseconds before starting the system (0 by default)
             */
            this.startDelay = 0;
            /** Gets or sets a value indicating the damping to apply if the limit velocity factor is reached */
            this.limitVelocityDamping = 0.4;
            /**
             * Random color of each particle after it has been emitted, between color1 and color2 vectors
             */
            this.color1 = new Color4(1.0, 1.0, 1.0, 1.0);
            /**
             * Random color of each particle after it has been emitted, between color1 and color2 vectors
             */
            this.color2 = new Color4(1.0, 1.0, 1.0, 1.0);
            /**
             * Color the particle will have at the end of its lifetime
             */
            this.colorDead = new Color4(0, 0, 0, 1.0);
            /**
             * An optional mask to filter some colors out of the texture, or filter a part of the alpha channel
             */
            this.textureMask = new Color4(1.0, 1.0, 1.0, 1.0);
            /** @internal */
            this._isSubEmitter = false;
            /** @internal */
            this._billboardMode = 7;
            /** @internal */
            this._isBillboardBased = true;
            /**
             * Local cache of defines for image processing.
             */
            this._imageProcessingConfigurationDefines = new ImageProcessingConfigurationDefines();
            this.id = name;
            this.name = name;
        }
        /**
         * Creates a Point Emitter for the particle system (emits directly from the emitter position)
         * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
         * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
         * @returns the emitter
         */
        createPointEmitter(direction1, direction2) {
            const particleEmitter = new PointParticleEmitter();
            particleEmitter.direction1 = direction1;
            particleEmitter.direction2 = direction2;
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Hemisphere Emitter for the particle system (emits along the hemisphere radius)
         * @param radius The radius of the hemisphere to emit from
         * @param radiusRange The range of the hemisphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
         * @returns the emitter
         */
        createHemisphericEmitter(radius = 1, radiusRange = 1) {
            const particleEmitter = new HemisphericParticleEmitter(radius, radiusRange);
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Sphere Emitter for the particle system (emits along the sphere radius)
         * @param radius The radius of the sphere to emit from
         * @param radiusRange The range of the sphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
         * @returns the emitter
         */
        createSphereEmitter(radius = 1, radiusRange = 1) {
            const particleEmitter = new SphereParticleEmitter(radius, radiusRange);
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Directed Sphere Emitter for the particle system (emits between direction1 and direction2)
         * @param radius The radius of the sphere to emit from
         * @param direction1 Particles are emitted between the direction1 and direction2 from within the sphere
         * @param direction2 Particles are emitted between the direction1 and direction2 from within the sphere
         * @returns the emitter
         */
        createDirectedSphereEmitter(radius = 1, direction1 = new Vector3(0, 1.0, 0), direction2 = new Vector3(0, 1.0, 0)) {
            const particleEmitter = new SphereDirectedParticleEmitter(radius, direction1, direction2);
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Cylinder Emitter for the particle system (emits from the cylinder to the particle position)
         * @param radius The radius of the emission cylinder
         * @param height The height of the emission cylinder
         * @param radiusRange The range of emission [0-1] 0 Surface only, 1 Entire Radius
         * @param directionRandomizer How much to randomize the particle direction [0-1]
         * @returns the emitter
         */
        createCylinderEmitter(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
            const particleEmitter = new CylinderParticleEmitter(radius, height, radiusRange, directionRandomizer);
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Directed Cylinder Emitter for the particle system (emits between direction1 and direction2)
         * @param radius The radius of the cylinder to emit from
         * @param height The height of the emission cylinder
         * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
         * @param direction1 Particles are emitted between the direction1 and direction2 from within the cylinder
         * @param direction2 Particles are emitted between the direction1 and direction2 from within the cylinder
         * @returns the emitter
         */
        createDirectedCylinderEmitter(radius = 1, height = 1, radiusRange = 1, direction1 = new Vector3(0, 1.0, 0), direction2 = new Vector3(0, 1.0, 0)) {
            const particleEmitter = new CylinderDirectedParticleEmitter(radius, height, radiusRange, direction1, direction2);
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Cone Emitter for the particle system (emits from the cone to the particle position)
         * @param radius The radius of the cone to emit from
         * @param angle The base angle of the cone
         * @returns the emitter
         */
        createConeEmitter(radius = 1, angle = Math.PI / 4) {
            const particleEmitter = new ConeParticleEmitter(radius, angle);
            this.particleEmitterType = particleEmitter;
            return particleEmitter;
        }
        /**
         * Creates a Box Emitter for the particle system. (emits between direction1 and direction2 from withing the box defined by minEmitBox and maxEmitBox)
         * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
         * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
         * @param minEmitBox Particles are emitted from the box between minEmitBox and maxEmitBox
         * @param maxEmitBox  Particles are emitted from the box between minEmitBox and maxEmitBox
         * @returns the emitter
         */
        createBoxEmitter(direction1, direction2, minEmitBox, maxEmitBox) {
            const particleEmitter = new BoxParticleEmitter();
            this.particleEmitterType = particleEmitter;
            this.direction1 = direction1;
            this.direction2 = direction2;
            this.minEmitBox = minEmitBox;
            this.maxEmitBox = maxEmitBox;
            return particleEmitter;
        }
    }
    /**
     * Source color is added to the destination color without alpha affecting the result
     */
    BaseParticleSystem.BLENDMODE_ONEONE = 0;
    /**
     * Blend current color and particle color using particle’s alpha
     */
    BaseParticleSystem.BLENDMODE_STANDARD = 1;
    /**
     * Add current color and particle color multiplied by particle’s alpha
     */
    BaseParticleSystem.BLENDMODE_ADD = 2;
    /**
     * Multiply current color with particle color
     */
    BaseParticleSystem.BLENDMODE_MULTIPLY = 3;
    /**
     * Multiply current color with particle color then add current color and particle color multiplied by particle’s alpha
     */
    BaseParticleSystem.BLENDMODE_MULTIPLYADD = 4;

    /**
     * Block used to expand a Color3/4 into 4 outputs (one for each component)
     */
    class ColorSplitterBlock extends NodeMaterialBlock {
        /**
         * Create a new ColorSplitterBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Neutral);
            this.registerInput("rgba", NodeMaterialBlockConnectionPointTypes.Color4, true);
            this.registerInput("rgb ", NodeMaterialBlockConnectionPointTypes.Color3, true);
            this.registerOutput("rgb", NodeMaterialBlockConnectionPointTypes.Color3);
            this.registerOutput("r", NodeMaterialBlockConnectionPointTypes.Float);
            this.registerOutput("g", NodeMaterialBlockConnectionPointTypes.Float);
            this.registerOutput("b", NodeMaterialBlockConnectionPointTypes.Float);
            this.registerOutput("a", NodeMaterialBlockConnectionPointTypes.Float);
            this.inputsAreExclusive = true;
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "ColorSplitterBlock";
        }
        /**
         * Gets the rgba component (input)
         */
        get rgba() {
            return this._inputs[0];
        }
        /**
         * Gets the rgb component (input)
         */
        get rgbIn() {
            return this._inputs[1];
        }
        /**
         * Gets the rgb component (output)
         */
        get rgbOut() {
            return this._outputs[0];
        }
        /**
         * Gets the r component (output)
         */
        get r() {
            return this._outputs[1];
        }
        /**
         * Gets the g component (output)
         */
        get g() {
            return this._outputs[2];
        }
        /**
         * Gets the b component (output)
         */
        get b() {
            return this._outputs[3];
        }
        /**
         * Gets the a component (output)
         */
        get a() {
            return this._outputs[4];
        }
        _inputRename(name) {
            if (name === "rgb ") {
                return "rgbIn";
            }
            return name;
        }
        _outputRename(name) {
            if (name === "rgb") {
                return "rgbOut";
            }
            return name;
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const input = this.rgba.isConnected ? this.rgba : this.rgbIn;
            if (!input.isConnected) {
                return;
            }
            const rgbOutput = this._outputs[0];
            const rOutput = this._outputs[1];
            const gOutput = this._outputs[2];
            const bOutput = this._outputs[3];
            const aOutput = this._outputs[4];
            if (rgbOutput.hasEndpoints) {
                state.compilationString += this._declareOutput(rgbOutput, state) + ` = ${input.associatedVariableName}.rgb;\n`;
            }
            if (rOutput.hasEndpoints) {
                state.compilationString += this._declareOutput(rOutput, state) + ` = ${input.associatedVariableName}.r;\n`;
            }
            if (gOutput.hasEndpoints) {
                state.compilationString += this._declareOutput(gOutput, state) + ` = ${input.associatedVariableName}.g;\n`;
            }
            if (bOutput.hasEndpoints) {
                state.compilationString += this._declareOutput(bOutput, state) + ` = ${input.associatedVariableName}.b;\n`;
            }
            if (aOutput.hasEndpoints) {
                state.compilationString += this._declareOutput(aOutput, state) + ` = ${input.associatedVariableName}.a;\n`;
            }
            return this;
        }
    }
    RegisterClass("BABYLON.ColorSplitterBlock", ColorSplitterBlock);

    /**
     * Defines the Procedural Texture scene component responsible to manage any Procedural Texture
     * in a given scene.
     */
    class ProceduralTextureSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_PROCEDURALTEXTURE;
            this.scene = scene;
            this.scene.proceduralTextures = new Array();
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._beforeClearStage.registerStep(SceneComponentConstants.STEP_BEFORECLEAR_PROCEDURALTEXTURE, this, this._beforeClear);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Nothing to do here.
        }
        /**
         * Disposes the component and the associated resources.
         */
        dispose() {
            // Nothing to do here.
        }
        _beforeClear() {
            if (this.scene.proceduralTexturesEnabled) {
                Tools.StartPerformanceCounter("Procedural textures", this.scene.proceduralTextures.length > 0);
                for (let proceduralIndex = 0; proceduralIndex < this.scene.proceduralTextures.length; proceduralIndex++) {
                    const proceduralTexture = this.scene.proceduralTextures[proceduralIndex];
                    if (proceduralTexture._shouldRender()) {
                        proceduralTexture.render();
                    }
                }
                Tools.EndPerformanceCounter("Procedural textures", this.scene.proceduralTextures.length > 0);
            }
        }
    }

    // Do not edit.
    const name$1X = "proceduralVertexShader";
    const shader$1X = `attribute vec2 position;varying vec2 vPosition;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vPosition=position;vUV=position*madd+madd;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1X] = shader$1X;

    /**
     * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes calmpler' images.
     * This is the base class of any Procedural texture and contains most of the shareable code.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/proceduralTextures
     */
    class ProceduralTexture extends Texture {
        /**
         * Instantiates a new procedural texture.
         * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes called 'refMaps' or 'sampler' images.
         * This is the base class of any Procedural texture and contains most of the shareable code.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/proceduralTextures
         * @param name  Define the name of the texture
         * @param size Define the size of the texture to create
         * @param fragment Define the fragment shader to use to generate the texture or null if it is defined later
         * @param scene Define the scene the texture belongs to
         * @param fallbackTexture Define a fallback texture in case there were issues to create the custom texture
         * @param generateMipMaps Define if the texture should creates mip maps or not
         * @param isCube Define if the texture is a cube texture or not (this will render each faces of the cube)
         * @param textureType The FBO internal texture type
         */
        constructor(name, size, fragment, scene, fallbackTexture = null, generateMipMaps = true, isCube = false, textureType = 0) {
            super(null, scene, !generateMipMaps);
            /**
             * Define if the texture is enabled or not (disabled texture will not render)
             */
            this.isEnabled = true;
            /**
             * Define if the texture must be cleared before rendering (default is true)
             */
            this.autoClear = true;
            /**
             * Event raised when the texture is generated
             */
            this.onGeneratedObservable = new Observable$1();
            /**
             * Event raised before the texture is generated
             */
            this.onBeforeGenerationObservable = new Observable$1();
            /**
             * Gets or sets the node material used to create this texture (null if the texture was manually created)
             */
            this.nodeMaterialSource = null;
            /** @internal */
            this._textures = {};
            this._currentRefreshId = -1;
            this._frameId = -1;
            this._refreshRate = 1;
            this._vertexBuffers = {};
            this._uniforms = new Array();
            this._samplers = new Array();
            this._floats = {};
            this._ints = {};
            this._floatsArrays = {};
            this._colors3 = {};
            this._colors4 = {};
            this._vectors2 = {};
            this._vectors3 = {};
            this._matrices = {};
            this._fallbackTextureUsed = false;
            this._cachedDefines = null;
            this._contentUpdateId = -1;
            this._rtWrapper = null;
            scene = this.getScene() || EngineStore.LastCreatedScene;
            let component = scene._getComponent(SceneComponentConstants.NAME_PROCEDURALTEXTURE);
            if (!component) {
                component = new ProceduralTextureSceneComponent(scene);
                scene._addComponent(component);
            }
            scene.proceduralTextures.push(this);
            this._fullEngine = scene.getEngine();
            this.name = name;
            this.isRenderTarget = true;
            this._size = size;
            this._textureType = textureType;
            this._generateMipMaps = generateMipMaps;
            this._drawWrapper = new DrawWrapper(this._fullEngine);
            this.setFragment(fragment);
            this._fallbackTexture = fallbackTexture;
            const rtWrapper = this._createRtWrapper(isCube, size, generateMipMaps, textureType);
            this._texture = rtWrapper.texture;
            // VBO
            const vertices = [];
            vertices.push(1, 1);
            vertices.push(-1, 1);
            vertices.push(-1, -1);
            vertices.push(1, -1);
            this._vertexBuffers[VertexBuffer.PositionKind] = new VertexBuffer(this._fullEngine, vertices, VertexBuffer.PositionKind, false, false, 2);
            this._createIndexBuffer();
        }
        _createRtWrapper(isCube, size, generateMipMaps, textureType) {
            if (isCube) {
                this._rtWrapper = this._fullEngine.createRenderTargetCubeTexture(size, {
                    generateMipMaps: generateMipMaps,
                    generateDepthBuffer: false,
                    generateStencilBuffer: false,
                    type: textureType,
                });
                this.setFloat("face", 0);
            }
            else {
                this._rtWrapper = this._fullEngine.createRenderTargetTexture(size, {
                    generateMipMaps: generateMipMaps,
                    generateDepthBuffer: false,
                    generateStencilBuffer: false,
                    type: textureType,
                });
            }
            return this._rtWrapper;
        }
        /**
         * The effect that is created when initializing the post process.
         * @returns The created effect corresponding the the postprocess.
         */
        getEffect() {
            return this._drawWrapper.effect;
        }
        /**
         * @internal*
         */
        _setEffect(effect) {
            this._drawWrapper.effect = effect;
        }
        /**
         * Gets texture content (Use this function wisely as reading from a texture can be slow)
         * @returns an ArrayBufferView promise (Uint8Array or Float32Array)
         */
        getContent() {
            if (this._contentData && this._frameId === this._contentUpdateId) {
                return this._contentData;
            }
            if (this._contentData) {
                this._contentData.then((buffer) => {
                    this._contentData = this.readPixels(0, 0, buffer);
                    this._contentUpdateId = this._frameId;
                });
            }
            else {
                this._contentData = this.readPixels(0, 0);
                this._contentUpdateId = this._frameId;
            }
            return this._contentData;
        }
        _createIndexBuffer() {
            const engine = this._fullEngine;
            // Indices
            const indices = [];
            indices.push(0);
            indices.push(1);
            indices.push(2);
            indices.push(0);
            indices.push(2);
            indices.push(3);
            this._indexBuffer = engine.createIndexBuffer(indices);
        }
        /** @internal */
        _rebuild() {
            const vb = this._vertexBuffers[VertexBuffer.PositionKind];
            if (vb) {
                vb._rebuild();
            }
            this._createIndexBuffer();
            if (this.refreshRate === RenderTargetTexture.REFRESHRATE_RENDER_ONCE) {
                this.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONCE;
            }
        }
        /**
         * Resets the texture in order to recreate its associated resources.
         * This can be called in case of context loss
         */
        reset() {
            var _a;
            (_a = this._drawWrapper.effect) === null || _a === void 0 ? void 0 : _a.dispose();
        }
        _getDefines() {
            return "";
        }
        /**
         * Is the texture ready to be used ? (rendered at least once)
         * @returns true if ready, otherwise, false.
         */
        isReady() {
            const engine = this._fullEngine;
            let shaders;
            if (this.nodeMaterialSource) {
                return this._drawWrapper.effect.isReady();
            }
            if (!this._fragment) {
                return false;
            }
            if (this._fallbackTextureUsed) {
                return true;
            }
            if (!this._texture) {
                return false;
            }
            const defines = this._getDefines();
            if (this._drawWrapper.effect && defines === this._cachedDefines && this._drawWrapper.effect.isReady()) {
                return true;
            }
            if (this._fragment.fragmentElement !== undefined) {
                shaders = { vertex: "procedural", fragmentElement: this._fragment.fragmentElement };
            }
            else {
                shaders = { vertex: "procedural", fragment: this._fragment };
            }
            if (this._cachedDefines !== defines) {
                this._cachedDefines = defines;
                this._drawWrapper.effect = engine.createEffect(shaders, [VertexBuffer.PositionKind], this._uniforms, this._samplers, defines, undefined, undefined, () => {
                    var _a;
                    (_a = this._rtWrapper) === null || _a === void 0 ? void 0 : _a.dispose();
                    this._rtWrapper = this._texture = null;
                    if (this._fallbackTexture) {
                        this._texture = this._fallbackTexture._texture;
                        if (this._texture) {
                            this._texture.incrementReferences();
                        }
                    }
                    this._fallbackTextureUsed = true;
                });
            }
            return this._drawWrapper.effect.isReady();
        }
        /**
         * Resets the refresh counter of the texture and start bak from scratch.
         * Could be useful to regenerate the texture if it is setup to render only once.
         */
        resetRefreshCounter() {
            this._currentRefreshId = -1;
        }
        /**
         * Set the fragment shader to use in order to render the texture.
         * @param fragment This can be set to a path (into the shader store) or to a json object containing a fragmentElement property.
         */
        setFragment(fragment) {
            this._fragment = fragment;
        }
        /**
         * Define the refresh rate of the texture or the rendering frequency.
         * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
         */
        get refreshRate() {
            return this._refreshRate;
        }
        set refreshRate(value) {
            this._refreshRate = value;
            this.resetRefreshCounter();
        }
        /** @internal */
        _shouldRender() {
            if (!this.isEnabled || !this.isReady() || !this._texture) {
                if (this._texture) {
                    this._texture.isReady = false;
                }
                return false;
            }
            if (this._fallbackTextureUsed) {
                return false;
            }
            if (this._currentRefreshId === -1) {
                // At least render once
                this._currentRefreshId = 1;
                this._frameId++;
                return true;
            }
            if (this.refreshRate === this._currentRefreshId) {
                this._currentRefreshId = 1;
                this._frameId++;
                return true;
            }
            this._currentRefreshId++;
            return false;
        }
        /**
         * Get the size the texture is rendering at.
         * @returns the size (on cube texture it is always squared)
         */
        getRenderSize() {
            return this._size;
        }
        /**
         * Resize the texture to new value.
         * @param size Define the new size the texture should have
         * @param generateMipMaps Define whether the new texture should create mip maps
         */
        resize(size, generateMipMaps) {
            if (this._fallbackTextureUsed || !this._rtWrapper || !this._texture) {
                return;
            }
            const isCube = this._texture.isCube;
            this._rtWrapper.dispose();
            const rtWrapper = this._createRtWrapper(isCube, size, generateMipMaps, this._textureType);
            this._texture = rtWrapper.texture;
            // Update properties
            this._size = size;
            this._generateMipMaps = generateMipMaps;
        }
        _checkUniform(uniformName) {
            if (this._uniforms.indexOf(uniformName) === -1) {
                this._uniforms.push(uniformName);
            }
        }
        /**
         * Set a texture in the shader program used to render.
         * @param name Define the name of the uniform samplers as defined in the shader
         * @param texture Define the texture to bind to this sampler
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setTexture(name, texture) {
            if (this._samplers.indexOf(name) === -1) {
                this._samplers.push(name);
            }
            this._textures[name] = texture;
            return this;
        }
        /**
         * Set a float in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setFloat(name, value) {
            this._checkUniform(name);
            this._floats[name] = value;
            return this;
        }
        /**
         * Set a int in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setInt(name, value) {
            this._checkUniform(name);
            this._ints[name] = value;
            return this;
        }
        /**
         * Set an array of floats in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setFloats(name, value) {
            this._checkUniform(name);
            this._floatsArrays[name] = value;
            return this;
        }
        /**
         * Set a vec3 in the shader from a Color3.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setColor3(name, value) {
            this._checkUniform(name);
            this._colors3[name] = value;
            return this;
        }
        /**
         * Set a vec4 in the shader from a Color4.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setColor4(name, value) {
            this._checkUniform(name);
            this._colors4[name] = value;
            return this;
        }
        /**
         * Set a vec2 in the shader from a Vector2.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setVector2(name, value) {
            this._checkUniform(name);
            this._vectors2[name] = value;
            return this;
        }
        /**
         * Set a vec3 in the shader from a Vector3.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setVector3(name, value) {
            this._checkUniform(name);
            this._vectors3[name] = value;
            return this;
        }
        /**
         * Set a mat4 in the shader from a MAtrix.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the texture itself allowing "fluent" like uniform updates
         */
        setMatrix(name, value) {
            this._checkUniform(name);
            this._matrices[name] = value;
            return this;
        }
        /**
         * Render the texture to its associated render target.
         * @param useCameraPostProcess Define if camera post process should be applied to the texture
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render(useCameraPostProcess) {
            var _a, _b;
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            const engine = this._fullEngine;
            // Render
            engine.enableEffect(this._drawWrapper);
            this.onBeforeGenerationObservable.notifyObservers(this);
            engine.setState(false);
            if (!this.nodeMaterialSource) {
                // Texture
                for (const name in this._textures) {
                    this._drawWrapper.effect.setTexture(name, this._textures[name]);
                }
                // Float
                for (const name in this._ints) {
                    this._drawWrapper.effect.setInt(name, this._ints[name]);
                }
                // Float
                for (const name in this._floats) {
                    this._drawWrapper.effect.setFloat(name, this._floats[name]);
                }
                // Floats
                for (const name in this._floatsArrays) {
                    this._drawWrapper.effect.setArray(name, this._floatsArrays[name]);
                }
                // Color3
                for (const name in this._colors3) {
                    this._drawWrapper.effect.setColor3(name, this._colors3[name]);
                }
                // Color4
                for (const name in this._colors4) {
                    const color = this._colors4[name];
                    this._drawWrapper.effect.setFloat4(name, color.r, color.g, color.b, color.a);
                }
                // Vector2
                for (const name in this._vectors2) {
                    this._drawWrapper.effect.setVector2(name, this._vectors2[name]);
                }
                // Vector3
                for (const name in this._vectors3) {
                    this._drawWrapper.effect.setVector3(name, this._vectors3[name]);
                }
                // Matrix
                for (const name in this._matrices) {
                    this._drawWrapper.effect.setMatrix(name, this._matrices[name]);
                }
            }
            if (!this._texture || !this._rtWrapper) {
                return;
            }
            (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, `procedural texture generation for ${this.name}`, 1);
            const viewPort = engine.currentViewport;
            if (this.isCube) {
                for (let face = 0; face < 6; face++) {
                    engine.bindFramebuffer(this._rtWrapper, face, undefined, undefined, true);
                    // VBOs
                    engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._drawWrapper.effect);
                    this._drawWrapper.effect.setFloat("face", face);
                    // Clear
                    if (this.autoClear) {
                        engine.clear(scene.clearColor, true, false, false);
                    }
                    // Draw order
                    engine.drawElementsType(Material.TriangleFillMode, 0, 6);
                }
            }
            else {
                engine.bindFramebuffer(this._rtWrapper, 0, undefined, undefined, true);
                // VBOs
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._drawWrapper.effect);
                // Clear
                if (this.autoClear) {
                    engine.clear(scene.clearColor, true, false, false);
                }
                // Draw order
                engine.drawElementsType(Material.TriangleFillMode, 0, 6);
            }
            // Unbind and restore viewport
            engine.unBindFramebuffer(this._rtWrapper, this.isCube);
            if (viewPort) {
                engine.setViewport(viewPort);
            }
            // Mipmaps
            if (this.isCube) {
                engine.generateMipMapsForCubemap(this._texture);
            }
            (_b = engine._debugPopGroup) === null || _b === void 0 ? void 0 : _b.call(engine, 1);
            if (this.onGenerated) {
                this.onGenerated();
            }
            this.onGeneratedObservable.notifyObservers(this);
        }
        /**
         * Clone the texture.
         * @returns the cloned texture
         */
        clone() {
            const textureSize = this.getSize();
            const newTexture = new ProceduralTexture(this.name, textureSize.width, this._fragment, this.getScene(), this._fallbackTexture, this._generateMipMaps);
            // Base texture
            newTexture.hasAlpha = this.hasAlpha;
            newTexture.level = this.level;
            // RenderTarget Texture
            newTexture.coordinatesMode = this.coordinatesMode;
            return newTexture;
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            const index = scene.proceduralTextures.indexOf(this);
            if (index >= 0) {
                scene.proceduralTextures.splice(index, 1);
            }
            const vertexBuffer = this._vertexBuffers[VertexBuffer.PositionKind];
            if (vertexBuffer) {
                vertexBuffer.dispose();
                this._vertexBuffers[VertexBuffer.PositionKind] = null;
            }
            if (this._indexBuffer && this._fullEngine._releaseBuffer(this._indexBuffer)) {
                this._indexBuffer = null;
            }
            this.onGeneratedObservable.clear();
            this.onBeforeGenerationObservable.clear();
            super.dispose();
        }
    }
    __decorate$1([
        serialize()
    ], ProceduralTexture.prototype, "isEnabled", void 0);
    __decorate$1([
        serialize()
    ], ProceduralTexture.prototype, "autoClear", void 0);
    __decorate$1([
        serialize()
    ], ProceduralTexture.prototype, "_generateMipMaps", void 0);
    __decorate$1([
        serialize()
    ], ProceduralTexture.prototype, "_size", void 0);
    __decorate$1([
        serialize()
    ], ProceduralTexture.prototype, "refreshRate", null);
    RegisterClass("BABYLON.ProceduralTexture", ProceduralTexture);

    /**
     * Operations supported by the Trigonometry block
     */
    var TrigonometryBlockOperations;
    (function (TrigonometryBlockOperations) {
        /** Cos */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Cos"] = 0] = "Cos";
        /** Sin */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Sin"] = 1] = "Sin";
        /** Abs */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Abs"] = 2] = "Abs";
        /** Exp */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Exp"] = 3] = "Exp";
        /** Exp2 */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Exp2"] = 4] = "Exp2";
        /** Round */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Round"] = 5] = "Round";
        /** Floor */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Floor"] = 6] = "Floor";
        /** Ceiling */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Ceiling"] = 7] = "Ceiling";
        /** Square root */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Sqrt"] = 8] = "Sqrt";
        /** Log */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Log"] = 9] = "Log";
        /** Tangent */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Tan"] = 10] = "Tan";
        /** Arc tangent */
        TrigonometryBlockOperations[TrigonometryBlockOperations["ArcTan"] = 11] = "ArcTan";
        /** Arc cosinus */
        TrigonometryBlockOperations[TrigonometryBlockOperations["ArcCos"] = 12] = "ArcCos";
        /** Arc sinus */
        TrigonometryBlockOperations[TrigonometryBlockOperations["ArcSin"] = 13] = "ArcSin";
        /** Fraction */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Fract"] = 14] = "Fract";
        /** Sign */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Sign"] = 15] = "Sign";
        /** To radians (from degrees) */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Radians"] = 16] = "Radians";
        /** To degrees (from radians) */
        TrigonometryBlockOperations[TrigonometryBlockOperations["Degrees"] = 17] = "Degrees";
    })(TrigonometryBlockOperations || (TrigonometryBlockOperations = {}));
    /**
     * Block used to apply trigonometry operation to floats
     */
    class TrigonometryBlock extends NodeMaterialBlock {
        /**
         * Creates a new TrigonometryBlock
         * @param name defines the block name
         */
        constructor(name) {
            super(name, NodeMaterialBlockTargets.Neutral);
            /**
             * Gets or sets the operation applied by the block
             */
            this.operation = TrigonometryBlockOperations.Cos;
            this.registerInput("input", NodeMaterialBlockConnectionPointTypes.AutoDetect);
            this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
            this._outputs[0]._typeConnectionSource = this._inputs[0];
        }
        /**
         * Gets the current class name
         * @returns the class name
         */
        getClassName() {
            return "TrigonometryBlock";
        }
        /**
         * Gets the input component
         */
        get input() {
            return this._inputs[0];
        }
        /**
         * Gets the output component
         */
        get output() {
            return this._outputs[0];
        }
        _buildBlock(state) {
            super._buildBlock(state);
            const output = this._outputs[0];
            let operation = "";
            switch (this.operation) {
                case TrigonometryBlockOperations.Cos: {
                    operation = "cos";
                    break;
                }
                case TrigonometryBlockOperations.Sin: {
                    operation = "sin";
                    break;
                }
                case TrigonometryBlockOperations.Abs: {
                    operation = "abs";
                    break;
                }
                case TrigonometryBlockOperations.Exp: {
                    operation = "exp";
                    break;
                }
                case TrigonometryBlockOperations.Exp2: {
                    operation = "exp2";
                    break;
                }
                case TrigonometryBlockOperations.Round: {
                    operation = "round";
                    break;
                }
                case TrigonometryBlockOperations.Floor: {
                    operation = "floor";
                    break;
                }
                case TrigonometryBlockOperations.Ceiling: {
                    operation = "ceil";
                    break;
                }
                case TrigonometryBlockOperations.Sqrt: {
                    operation = "sqrt";
                    break;
                }
                case TrigonometryBlockOperations.Log: {
                    operation = "log";
                    break;
                }
                case TrigonometryBlockOperations.Tan: {
                    operation = "tan";
                    break;
                }
                case TrigonometryBlockOperations.ArcTan: {
                    operation = "atan";
                    break;
                }
                case TrigonometryBlockOperations.ArcCos: {
                    operation = "acos";
                    break;
                }
                case TrigonometryBlockOperations.ArcSin: {
                    operation = "asin";
                    break;
                }
                case TrigonometryBlockOperations.Fract: {
                    operation = "fract";
                    break;
                }
                case TrigonometryBlockOperations.Sign: {
                    operation = "sign";
                    break;
                }
                case TrigonometryBlockOperations.Radians: {
                    operation = "radians";
                    break;
                }
                case TrigonometryBlockOperations.Degrees: {
                    operation = "degrees";
                    break;
                }
            }
            state.compilationString += this._declareOutput(output, state) + ` = ${operation}(${this.input.associatedVariableName});\n`;
            return this;
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.operation = this.operation;
            return serializationObject;
        }
        _deserialize(serializationObject, scene, rootUrl) {
            super._deserialize(serializationObject, scene, rootUrl);
            this.operation = serializationObject.operation;
        }
        _dumpPropertiesCode() {
            const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.operation = BABYLON.TrigonometryBlockOperations.${TrigonometryBlockOperations[this.operation]};\n`;
            return codeString;
        }
    }
    RegisterClass("BABYLON.TrigonometryBlock", TrigonometryBlock);

    const onCreatedEffectParameters$2 = { effect: null, subMesh: null };
    /** @internal */
    class NodeMaterialDefines extends MaterialDefines {
        constructor() {
            super();
            this.NORMAL = false;
            this.TANGENT = false;
            this.VERTEXCOLOR_NME = false;
            this.UV1 = false;
            this.UV2 = false;
            this.UV3 = false;
            this.UV4 = false;
            this.UV5 = false;
            this.UV6 = false;
            /** BONES */
            this.NUM_BONE_INFLUENCERS = 0;
            this.BonesPerMesh = 0;
            this.BONETEXTURE = false;
            /** MORPH TARGETS */
            this.MORPHTARGETS = false;
            this.MORPHTARGETS_NORMAL = false;
            this.MORPHTARGETS_TANGENT = false;
            this.MORPHTARGETS_UV = false;
            this.NUM_MORPH_INFLUENCERS = 0;
            this.MORPHTARGETS_TEXTURE = false;
            /** IMAGE PROCESSING */
            this.IMAGEPROCESSING = false;
            this.VIGNETTE = false;
            this.VIGNETTEBLENDMODEMULTIPLY = false;
            this.VIGNETTEBLENDMODEOPAQUE = false;
            this.TONEMAPPING = false;
            this.TONEMAPPING_ACES = false;
            this.CONTRAST = false;
            this.EXPOSURE = false;
            this.COLORCURVES = false;
            this.COLORGRADING = false;
            this.COLORGRADING3D = false;
            this.SAMPLER3DGREENDEPTH = false;
            this.SAMPLER3DBGRMAP = false;
            this.DITHER = false;
            this.IMAGEPROCESSINGPOSTPROCESS = false;
            this.SKIPFINALCOLORCLAMP = false;
            /** MISC. */
            this.BUMPDIRECTUV = 0;
            this.CAMERA_ORTHOGRAPHIC = false;
            this.CAMERA_PERSPECTIVE = false;
            this.rebuild();
        }
        setValue(name, value, markAsUnprocessedIfDirty = false) {
            if (this[name] === undefined) {
                this._keys.push(name);
            }
            if (markAsUnprocessedIfDirty && this[name] !== value) {
                this.markAsUnprocessed();
            }
            this[name] = value;
        }
    }
    /**
     * Class used to create a node based material built by assembling shader blocks
     */
    class NodeMaterial extends PushMaterial {
        /**
         * Checks if a block is a texture block
         * @param block The block to check
         * @returns True if the block is a texture block
         */
        static _BlockIsTextureBlock(block) {
            return (block.getClassName() === "TextureBlock" ||
                block.getClassName() === "ReflectionTextureBaseBlock" ||
                block.getClassName() === "RefractionBlock" ||
                block.getClassName() === "CurrentScreenBlock" ||
                block.getClassName() === "ParticleTextureBlock" ||
                block.getClassName() === "ImageSourceBlock" ||
                block.getClassName() === "TriPlanarBlock" ||
                block.getClassName() === "BiPlanarBlock");
        }
        /** Get the inspector from bundle or global */
        _getGlobalNodeMaterialEditor() {
            // UMD Global name detection from Webpack Bundle UMD Name.
            if (typeof NODEEDITOR !== "undefined") {
                return NODEEDITOR;
            }
            // In case of module let's check the global emitted from the editor entry point.
            if (typeof BABYLON !== "undefined" && typeof BABYLON.NodeEditor !== "undefined") {
                return BABYLON;
            }
            return undefined;
        }
        /** Gets or sets options to control the node material overall behavior */
        get options() {
            return this._options;
        }
        set options(options) {
            this._options = options;
        }
        /**
         * Gets the image processing configuration used either in this material.
         */
        get imageProcessingConfiguration() {
            return this._imageProcessingConfiguration;
        }
        /**
         * Sets the Default image processing configuration used either in the this material.
         *
         * If sets to null, the scene one is in use.
         */
        set imageProcessingConfiguration(value) {
            this._attachImageProcessingConfiguration(value);
            // Ensure the effect will be rebuilt.
            this._markAllSubMeshesAsTexturesDirty();
        }
        /**
         * Gets or sets the mode property
         */
        get mode() {
            return this._mode;
        }
        set mode(value) {
            this._mode = value;
        }
        /** Gets or sets the unique identifier used to identified the effect associated with the material */
        get buildId() {
            return this._buildId;
        }
        set buildId(value) {
            this._buildId = value;
        }
        /**
         * Create a new node based material
         * @param name defines the material name
         * @param scene defines the hosting scene
         * @param options defines creation option
         */
        constructor(name, scene, options = {}) {
            super(name, scene || EngineStore.LastCreatedScene);
            this._buildId = NodeMaterial._BuildIdGenerator++;
            this._buildWasSuccessful = false;
            this._cachedWorldViewMatrix = new Matrix();
            this._cachedWorldViewProjectionMatrix = new Matrix();
            this._optimizers = new Array();
            this._animationFrame = -1;
            this.BJSNODEMATERIALEDITOR = this._getGlobalNodeMaterialEditor();
            /**
             * Gets or sets data used by visual editor
             * @see https://nme.babylonjs.com
             */
            this.editorData = null;
            /**
             * Gets or sets a boolean indicating that alpha value must be ignored (This will turn alpha blending off even if an alpha value is produced by the material)
             */
            this.ignoreAlpha = false;
            /**
             * Defines the maximum number of lights that can be used in the material
             */
            this.maxSimultaneousLights = 4;
            /**
             * Observable raised when the material is built
             */
            this.onBuildObservable = new Observable$1();
            /**
             * Gets or sets the root nodes of the material vertex shader
             */
            this._vertexOutputNodes = new Array();
            /**
             * Gets or sets the root nodes of the material fragment (pixel) shader
             */
            this._fragmentOutputNodes = new Array();
            /**
             * Gets an array of blocks that needs to be serialized even if they are not yet connected
             */
            this.attachedBlocks = new Array();
            /**
             * Specifies the mode of the node material
             * @internal
             */
            this._mode = NodeMaterialModes.Material;
            /**
             * Gets or sets a boolean indicating that alpha blending must be enabled no matter what alpha value or alpha channel of the FragmentBlock are
             */
            this.forceAlphaBlending = false;
            this._options = Object.assign({ emitComments: false }, options);
            // Setup the default processing configuration to the scene.
            this._attachImageProcessingConfiguration(null);
        }
        /**
         * Gets the current class name of the material e.g. "NodeMaterial"
         * @returns the class name
         */
        getClassName() {
            return "NodeMaterial";
        }
        /**
         * Attaches a new image processing configuration to the Standard Material.
         * @param configuration
         */
        _attachImageProcessingConfiguration(configuration) {
            if (configuration === this._imageProcessingConfiguration) {
                return;
            }
            // Detaches observer.
            if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            }
            // Pick the scene configuration if needed.
            if (!configuration) {
                this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
            }
            else {
                this._imageProcessingConfiguration = configuration;
            }
            // Attaches observer.
            if (this._imageProcessingConfiguration) {
                this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
                    this._markAllSubMeshesAsImageProcessingDirty();
                });
            }
        }
        /**
         * Get a block by its name
         * @param name defines the name of the block to retrieve
         * @returns the required block or null if not found
         */
        getBlockByName(name) {
            let result = null;
            for (const block of this.attachedBlocks) {
                if (block.name === name) {
                    if (!result) {
                        result = block;
                    }
                    else {
                        Tools.Warn("More than one block was found with the name `" + name + "`");
                        return result;
                    }
                }
            }
            return result;
        }
        /**
         * Get a block by its name
         * @param predicate defines the predicate used to find the good candidate
         * @returns the required block or null if not found
         */
        getBlockByPredicate(predicate) {
            for (const block of this.attachedBlocks) {
                if (predicate(block)) {
                    return block;
                }
            }
            return null;
        }
        /**
         * Get an input block by its name
         * @param predicate defines the predicate used to find the good candidate
         * @returns the required input block or null if not found
         */
        getInputBlockByPredicate(predicate) {
            for (const block of this.attachedBlocks) {
                if (block.isInput && predicate(block)) {
                    return block;
                }
            }
            return null;
        }
        /**
         * Gets the list of input blocks attached to this material
         * @returns an array of InputBlocks
         */
        getInputBlocks() {
            const blocks = [];
            for (const block of this.attachedBlocks) {
                if (block.isInput) {
                    blocks.push(block);
                }
            }
            return blocks;
        }
        /**
         * Adds a new optimizer to the list of optimizers
         * @param optimizer defines the optimizers to add
         * @returns the current material
         */
        registerOptimizer(optimizer) {
            const index = this._optimizers.indexOf(optimizer);
            if (index > -1) {
                return;
            }
            this._optimizers.push(optimizer);
            return this;
        }
        /**
         * Remove an optimizer from the list of optimizers
         * @param optimizer defines the optimizers to remove
         * @returns the current material
         */
        unregisterOptimizer(optimizer) {
            const index = this._optimizers.indexOf(optimizer);
            if (index === -1) {
                return;
            }
            this._optimizers.splice(index, 1);
            return this;
        }
        /**
         * Add a new block to the list of output nodes
         * @param node defines the node to add
         * @returns the current material
         */
        addOutputNode(node) {
            if (node.target === null) {
                throw "This node is not meant to be an output node. You may want to explicitly set its target value.";
            }
            if ((node.target & NodeMaterialBlockTargets.Vertex) !== 0) {
                this._addVertexOutputNode(node);
            }
            if ((node.target & NodeMaterialBlockTargets.Fragment) !== 0) {
                this._addFragmentOutputNode(node);
            }
            return this;
        }
        /**
         * Remove a block from the list of root nodes
         * @param node defines the node to remove
         * @returns the current material
         */
        removeOutputNode(node) {
            if (node.target === null) {
                return this;
            }
            if ((node.target & NodeMaterialBlockTargets.Vertex) !== 0) {
                this._removeVertexOutputNode(node);
            }
            if ((node.target & NodeMaterialBlockTargets.Fragment) !== 0) {
                this._removeFragmentOutputNode(node);
            }
            return this;
        }
        _addVertexOutputNode(node) {
            if (this._vertexOutputNodes.indexOf(node) !== -1) {
                return;
            }
            node.target = NodeMaterialBlockTargets.Vertex;
            this._vertexOutputNodes.push(node);
            return this;
        }
        _removeVertexOutputNode(node) {
            const index = this._vertexOutputNodes.indexOf(node);
            if (index === -1) {
                return;
            }
            this._vertexOutputNodes.splice(index, 1);
            return this;
        }
        _addFragmentOutputNode(node) {
            if (this._fragmentOutputNodes.indexOf(node) !== -1) {
                return;
            }
            node.target = NodeMaterialBlockTargets.Fragment;
            this._fragmentOutputNodes.push(node);
            return this;
        }
        _removeFragmentOutputNode(node) {
            const index = this._fragmentOutputNodes.indexOf(node);
            if (index === -1) {
                return;
            }
            this._fragmentOutputNodes.splice(index, 1);
            return this;
        }
        /**
         * Specifies if the material will require alpha blending
         * @returns a boolean specifying if alpha blending is needed
         */
        needAlphaBlending() {
            if (this.ignoreAlpha) {
                return false;
            }
            return this.forceAlphaBlending || this.alpha < 1.0 || (this._sharedData && this._sharedData.hints.needAlphaBlending);
        }
        /**
         * Specifies if this material should be rendered in alpha test mode
         * @returns a boolean specifying if an alpha test is needed.
         */
        needAlphaTesting() {
            return this._sharedData && this._sharedData.hints.needAlphaTesting;
        }
        _processInitializeOnLink(block, state, nodesToProcessForOtherBuildState, autoConfigure = true) {
            if (block.target === NodeMaterialBlockTargets.VertexAndFragment) {
                nodesToProcessForOtherBuildState.push(block);
            }
            else if (state.target === NodeMaterialBlockTargets.Fragment && block.target === NodeMaterialBlockTargets.Vertex && block._preparationId !== this._buildId) {
                nodesToProcessForOtherBuildState.push(block);
            }
            this._initializeBlock(block, state, nodesToProcessForOtherBuildState, autoConfigure);
        }
        _initializeBlock(node, state, nodesToProcessForOtherBuildState, autoConfigure = true) {
            node.initialize(state);
            if (autoConfigure) {
                node.autoConfigure(this);
            }
            node._preparationId = this._buildId;
            if (this.attachedBlocks.indexOf(node) === -1) {
                if (node.isUnique) {
                    const className = node.getClassName();
                    for (const other of this.attachedBlocks) {
                        if (other.getClassName() === className) {
                            throw `Cannot have multiple blocks of type ${className} in the same NodeMaterial`;
                        }
                    }
                }
                this.attachedBlocks.push(node);
            }
            for (const input of node.inputs) {
                input.associatedVariableName = "";
                const connectedPoint = input.connectedPoint;
                if (connectedPoint) {
                    const block = connectedPoint.ownerBlock;
                    if (block !== node) {
                        this._processInitializeOnLink(block, state, nodesToProcessForOtherBuildState, autoConfigure);
                    }
                }
            }
            // Teleportation
            if (node.isTeleportOut) {
                const teleport = node;
                if (teleport.entryPoint) {
                    this._processInitializeOnLink(teleport.entryPoint, state, nodesToProcessForOtherBuildState, autoConfigure);
                }
            }
            for (const output of node.outputs) {
                output.associatedVariableName = "";
            }
        }
        _resetDualBlocks(node, id) {
            if (node.target === NodeMaterialBlockTargets.VertexAndFragment) {
                node.buildId = id;
            }
            for (const inputs of node.inputs) {
                const connectedPoint = inputs.connectedPoint;
                if (connectedPoint) {
                    const block = connectedPoint.ownerBlock;
                    if (block !== node) {
                        this._resetDualBlocks(block, id);
                    }
                }
            }
            // If this is a teleport out, we need to reset the connected block
            if (node.isTeleportOut) {
                const teleportOut = node;
                if (teleportOut.entryPoint) {
                    this._resetDualBlocks(teleportOut.entryPoint, id);
                }
            }
        }
        /**
         * Remove a block from the current node material
         * @param block defines the block to remove
         */
        removeBlock(block) {
            const attachedBlockIndex = this.attachedBlocks.indexOf(block);
            if (attachedBlockIndex > -1) {
                this.attachedBlocks.splice(attachedBlockIndex, 1);
            }
            if (block.isFinalMerger) {
                this.removeOutputNode(block);
            }
        }
        /**
         * Build the material and generates the inner effect
         * @param verbose defines if the build should log activity
         * @param updateBuildId defines if the internal build Id should be updated (default is true)
         * @param autoConfigure defines if the autoConfigure method should be called when initializing blocks (default is true)
         */
        build(verbose = false, updateBuildId = true, autoConfigure = true) {
            this._buildWasSuccessful = false;
            const engine = this.getScene().getEngine();
            const allowEmptyVertexProgram = this._mode === NodeMaterialModes.Particle;
            if (this._vertexOutputNodes.length === 0 && !allowEmptyVertexProgram) {
                throw "You must define at least one vertexOutputNode";
            }
            if (this._fragmentOutputNodes.length === 0) {
                throw "You must define at least one fragmentOutputNode";
            }
            // Compilation state
            this._vertexCompilationState = new NodeMaterialBuildState();
            this._vertexCompilationState.supportUniformBuffers = engine.supportsUniformBuffers;
            this._vertexCompilationState.target = NodeMaterialBlockTargets.Vertex;
            this._fragmentCompilationState = new NodeMaterialBuildState();
            this._fragmentCompilationState.supportUniformBuffers = engine.supportsUniformBuffers;
            this._fragmentCompilationState.target = NodeMaterialBlockTargets.Fragment;
            // Shared data
            this._sharedData = new NodeMaterialBuildStateSharedData();
            this._sharedData.fragmentOutputNodes = this._fragmentOutputNodes;
            this._vertexCompilationState.sharedData = this._sharedData;
            this._fragmentCompilationState.sharedData = this._sharedData;
            this._sharedData.buildId = this._buildId;
            this._sharedData.emitComments = this._options.emitComments;
            this._sharedData.verbose = verbose;
            this._sharedData.scene = this.getScene();
            this._sharedData.allowEmptyVertexProgram = allowEmptyVertexProgram;
            // Initialize blocks
            const vertexNodes = [];
            const fragmentNodes = [];
            for (const vertexOutputNode of this._vertexOutputNodes) {
                vertexNodes.push(vertexOutputNode);
                this._initializeBlock(vertexOutputNode, this._vertexCompilationState, fragmentNodes, autoConfigure);
            }
            for (const fragmentOutputNode of this._fragmentOutputNodes) {
                fragmentNodes.push(fragmentOutputNode);
                this._initializeBlock(fragmentOutputNode, this._fragmentCompilationState, vertexNodes, autoConfigure);
            }
            // Optimize
            this.optimize();
            // Vertex
            for (const vertexOutputNode of vertexNodes) {
                vertexOutputNode.build(this._vertexCompilationState, vertexNodes);
            }
            // Fragment
            this._fragmentCompilationState.uniforms = this._vertexCompilationState.uniforms.slice(0);
            this._fragmentCompilationState._uniformDeclaration = this._vertexCompilationState._uniformDeclaration;
            this._fragmentCompilationState._constantDeclaration = this._vertexCompilationState._constantDeclaration;
            this._fragmentCompilationState._vertexState = this._vertexCompilationState;
            for (const fragmentOutputNode of fragmentNodes) {
                this._resetDualBlocks(fragmentOutputNode, this._buildId - 1);
            }
            for (const fragmentOutputNode of fragmentNodes) {
                fragmentOutputNode.build(this._fragmentCompilationState, fragmentNodes);
            }
            // Finalize
            this._vertexCompilationState.finalize(this._vertexCompilationState);
            this._fragmentCompilationState.finalize(this._fragmentCompilationState);
            if (updateBuildId) {
                this._buildId = NodeMaterial._BuildIdGenerator++;
            }
            // Errors
            this._sharedData.emitErrors();
            if (verbose) {
                console.log("Vertex shader:");
                console.log(this._vertexCompilationState.compilationString);
                console.log("Fragment shader:");
                console.log(this._fragmentCompilationState.compilationString);
            }
            this._buildWasSuccessful = true;
            this.onBuildObservable.notifyObservers(this);
            // Wipe defines
            const meshes = this.getScene().meshes;
            for (const mesh of meshes) {
                if (!mesh.subMeshes) {
                    continue;
                }
                for (const subMesh of mesh.subMeshes) {
                    if (subMesh.getMaterial() !== this) {
                        continue;
                    }
                    if (!subMesh.materialDefines) {
                        continue;
                    }
                    const defines = subMesh.materialDefines;
                    defines.markAllAsDirty();
                    defines.reset();
                }
            }
        }
        /**
         * Runs an otpimization phase to try to improve the shader code
         */
        optimize() {
            for (const optimizer of this._optimizers) {
                optimizer.optimize(this._vertexOutputNodes, this._fragmentOutputNodes);
            }
        }
        _prepareDefinesForAttributes(mesh, defines) {
            const oldNormal = defines["NORMAL"];
            const oldTangent = defines["TANGENT"];
            const oldColor = defines["VERTEXCOLOR_NME"];
            defines["NORMAL"] = mesh.isVerticesDataPresent(VertexBuffer.NormalKind);
            defines["TANGENT"] = mesh.isVerticesDataPresent(VertexBuffer.TangentKind);
            const hasVertexColors = mesh.useVertexColors && mesh.isVerticesDataPresent(VertexBuffer.ColorKind);
            defines["VERTEXCOLOR_NME"] = hasVertexColors;
            let uvChanged = false;
            for (let i = 1; i <= 6; ++i) {
                const oldUV = defines["UV" + i];
                defines["UV" + i] = mesh.isVerticesDataPresent(`uv${i === 1 ? "" : i}`);
                uvChanged = uvChanged || defines["UV" + i] !== oldUV;
            }
            if (oldNormal !== defines["NORMAL"] || oldTangent !== defines["TANGENT"] || oldColor !== defines["VERTEXCOLOR_NME"] || uvChanged) {
                defines.markAsAttributesDirty();
            }
        }
        /**
         * Create a post process from the material
         * @param camera The camera to apply the render pass to.
         * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
         * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
         * @param engine The engine which the post process will be applied. (default: current engine)
         * @param reusable If the post process can be reused on the same frame. (default: false)
         * @param textureType Type of textures used when performing the post process. (default: 0)
         * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
         * @returns the post process created
         */
        createPostProcess(camera, options = 1, samplingMode = 1, engine, reusable, textureType = 0, textureFormat = 5) {
            if (this.mode !== NodeMaterialModes.PostProcess) {
                console.log("Incompatible material mode");
                return null;
            }
            return this._createEffectForPostProcess(null, camera, options, samplingMode, engine, reusable, textureType, textureFormat);
        }
        /**
         * Create the post process effect from the material
         * @param postProcess The post process to create the effect for
         */
        createEffectForPostProcess(postProcess) {
            this._createEffectForPostProcess(postProcess);
        }
        _createEffectForPostProcess(postProcess, camera, options = 1, samplingMode = 1, engine, reusable, textureType = 0, textureFormat = 5) {
            let tempName = this.name + this._buildId;
            const defines = new NodeMaterialDefines();
            const dummyMesh = new AbstractMesh(tempName + "PostProcess", this.getScene());
            let buildId = this._buildId;
            this._processDefines(dummyMesh, defines);
            Effect.RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
            if (!postProcess) {
                postProcess = new PostProcess(this.name + "PostProcess", tempName, this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, options, camera, samplingMode, engine, reusable, defines.toString(), textureType, tempName, { maxSimultaneousLights: this.maxSimultaneousLights }, false, textureFormat);
            }
            else {
                postProcess.updateEffect(defines.toString(), this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, { maxSimultaneousLights: this.maxSimultaneousLights }, undefined, undefined, tempName, tempName);
            }
            postProcess.nodeMaterialSource = this;
            postProcess.onApplyObservable.add((effect) => {
                if (buildId !== this._buildId) {
                    delete Effect.ShadersStore[tempName + "VertexShader"];
                    delete Effect.ShadersStore[tempName + "PixelShader"];
                    tempName = this.name + this._buildId;
                    defines.markAllAsDirty();
                    buildId = this._buildId;
                }
                const result = this._processDefines(dummyMesh, defines);
                if (result) {
                    Effect.RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
                    TimingTools.SetImmediate(() => postProcess.updateEffect(defines.toString(), this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, { maxSimultaneousLights: this.maxSimultaneousLights }, undefined, undefined, tempName, tempName));
                }
                this._checkInternals(effect);
            });
            return postProcess;
        }
        /**
         * Create a new procedural texture based on this node material
         * @param size defines the size of the texture
         * @param scene defines the hosting scene
         * @returns the new procedural texture attached to this node material
         */
        createProceduralTexture(size, scene) {
            if (this.mode !== NodeMaterialModes.ProceduralTexture) {
                console.log("Incompatible material mode");
                return null;
            }
            let tempName = this.name + this._buildId;
            const proceduralTexture = new ProceduralTexture(tempName, size, null, scene);
            const dummyMesh = new AbstractMesh(tempName + "Procedural", this.getScene());
            dummyMesh.reservedDataStore = {
                hidden: true,
            };
            const defines = new NodeMaterialDefines();
            const result = this._processDefines(dummyMesh, defines);
            Effect.RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
            let effect = this.getScene().getEngine().createEffect({
                vertexElement: tempName,
                fragmentElement: tempName,
            }, [VertexBuffer.PositionKind], this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString(), result === null || result === void 0 ? void 0 : result.fallbacks, undefined);
            proceduralTexture.nodeMaterialSource = this;
            proceduralTexture._setEffect(effect);
            let buildId = this._buildId;
            proceduralTexture.onBeforeGenerationObservable.add(() => {
                if (buildId !== this._buildId) {
                    delete Effect.ShadersStore[tempName + "VertexShader"];
                    delete Effect.ShadersStore[tempName + "PixelShader"];
                    tempName = this.name + this._buildId;
                    defines.markAllAsDirty();
                    buildId = this._buildId;
                }
                const result = this._processDefines(dummyMesh, defines);
                if (result) {
                    Effect.RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
                    TimingTools.SetImmediate(() => {
                        effect = this.getScene().getEngine().createEffect({
                            vertexElement: tempName,
                            fragmentElement: tempName,
                        }, [VertexBuffer.PositionKind], this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString(), result === null || result === void 0 ? void 0 : result.fallbacks, undefined);
                        proceduralTexture._setEffect(effect);
                    });
                }
                this._checkInternals(effect);
            });
            return proceduralTexture;
        }
        _createEffectForParticles(particleSystem, blendMode, onCompiled, onError, effect, defines, dummyMesh, particleSystemDefinesJoined = "") {
            let tempName = this.name + this._buildId + "_" + blendMode;
            if (!defines) {
                defines = new NodeMaterialDefines();
            }
            if (!dummyMesh) {
                dummyMesh = this.getScene().getMeshByName(this.name + "Particle");
                if (!dummyMesh) {
                    dummyMesh = new AbstractMesh(this.name + "Particle", this.getScene());
                    dummyMesh.reservedDataStore = {
                        hidden: true,
                    };
                }
            }
            let buildId = this._buildId;
            const particleSystemDefines = [];
            let join = particleSystemDefinesJoined;
            if (!effect) {
                const result = this._processDefines(dummyMesh, defines);
                Effect.RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString);
                particleSystem.fillDefines(particleSystemDefines, blendMode);
                join = particleSystemDefines.join("\n");
                effect = this.getScene()
                    .getEngine()
                    .createEffectForParticles(tempName, this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString() + "\n" + join, result === null || result === void 0 ? void 0 : result.fallbacks, onCompiled, onError, particleSystem);
                particleSystem.setCustomEffect(effect, blendMode);
            }
            effect.onBindObservable.add((effect) => {
                if (buildId !== this._buildId) {
                    delete Effect.ShadersStore[tempName + "PixelShader"];
                    tempName = this.name + this._buildId + "_" + blendMode;
                    defines.markAllAsDirty();
                    buildId = this._buildId;
                }
                particleSystemDefines.length = 0;
                particleSystem.fillDefines(particleSystemDefines, blendMode);
                const particleSystemDefinesJoinedCurrent = particleSystemDefines.join("\n");
                if (particleSystemDefinesJoinedCurrent !== join) {
                    defines.markAllAsDirty();
                    join = particleSystemDefinesJoinedCurrent;
                }
                const result = this._processDefines(dummyMesh, defines);
                if (result) {
                    Effect.RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString);
                    effect = this.getScene()
                        .getEngine()
                        .createEffectForParticles(tempName, this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString() + "\n" + join, result === null || result === void 0 ? void 0 : result.fallbacks, onCompiled, onError, particleSystem);
                    particleSystem.setCustomEffect(effect, blendMode);
                    this._createEffectForParticles(particleSystem, blendMode, onCompiled, onError, effect, defines, dummyMesh, particleSystemDefinesJoined); // add the effect.onBindObservable observer
                    return;
                }
                this._checkInternals(effect);
            });
        }
        _checkInternals(effect) {
            // Animated blocks
            if (this._sharedData.animatedInputs) {
                const scene = this.getScene();
                const frameId = scene.getFrameId();
                if (this._animationFrame !== frameId) {
                    for (const input of this._sharedData.animatedInputs) {
                        input.animate(scene);
                    }
                    this._animationFrame = frameId;
                }
            }
            // Bindable blocks
            for (const block of this._sharedData.bindableBlocks) {
                block.bind(effect, this);
            }
            // Connection points
            for (const inputBlock of this._sharedData.inputBlocks) {
                inputBlock._transmit(effect, this.getScene(), this);
            }
        }
        /**
         * Create the effect to be used as the custom effect for a particle system
         * @param particleSystem Particle system to create the effect for
         * @param onCompiled defines a function to call when the effect creation is successful
         * @param onError defines a function to call when the effect creation has failed
         */
        createEffectForParticles(particleSystem, onCompiled, onError) {
            if (this.mode !== NodeMaterialModes.Particle) {
                console.log("Incompatible material mode");
                return;
            }
            this._createEffectForParticles(particleSystem, BaseParticleSystem.BLENDMODE_ONEONE, onCompiled, onError);
            this._createEffectForParticles(particleSystem, BaseParticleSystem.BLENDMODE_MULTIPLY, onCompiled, onError);
        }
        /**
         * Use this material as the shadow depth wrapper of a target material
         * @param targetMaterial defines the target material
         */
        createAsShadowDepthWrapper(targetMaterial) {
            if (this.mode !== NodeMaterialModes.Material) {
                console.log("Incompatible material mode");
                return;
            }
            targetMaterial.shadowDepthWrapper = new BABYLON.ShadowDepthWrapper(this, this.getScene());
        }
        _processDefines(mesh, defines, useInstances = false, subMesh) {
            let result = null;
            // Global defines
            const scene = this.getScene();
            if (MaterialHelper.PrepareDefinesForCamera(scene, defines)) {
                defines.markAsMiscDirty();
            }
            // Shared defines
            this._sharedData.blocksWithDefines.forEach((b) => {
                b.initializeDefines(mesh, this, defines, useInstances);
            });
            this._sharedData.blocksWithDefines.forEach((b) => {
                b.prepareDefines(mesh, this, defines, useInstances, subMesh);
            });
            // Need to recompile?
            if (defines.isDirty) {
                const lightDisposed = defines._areLightsDisposed;
                defines.markAsProcessed();
                // Repeatable content generators
                this._vertexCompilationState.compilationString = this._vertexCompilationState._builtCompilationString;
                this._fragmentCompilationState.compilationString = this._fragmentCompilationState._builtCompilationString;
                this._sharedData.repeatableContentBlocks.forEach((b) => {
                    b.replaceRepeatableContent(this._vertexCompilationState, this._fragmentCompilationState, mesh, defines);
                });
                // Uniforms
                const uniformBuffers = [];
                this._sharedData.dynamicUniformBlocks.forEach((b) => {
                    b.updateUniformsAndSamples(this._vertexCompilationState, this, defines, uniformBuffers);
                });
                const mergedUniforms = this._vertexCompilationState.uniforms;
                this._fragmentCompilationState.uniforms.forEach((u) => {
                    const index = mergedUniforms.indexOf(u);
                    if (index === -1) {
                        mergedUniforms.push(u);
                    }
                });
                // Samplers
                const mergedSamplers = this._vertexCompilationState.samplers;
                this._fragmentCompilationState.samplers.forEach((s) => {
                    const index = mergedSamplers.indexOf(s);
                    if (index === -1) {
                        mergedSamplers.push(s);
                    }
                });
                const fallbacks = new EffectFallbacks();
                this._sharedData.blocksWithFallbacks.forEach((b) => {
                    b.provideFallbacks(mesh, fallbacks);
                });
                result = {
                    lightDisposed,
                    uniformBuffers,
                    mergedUniforms,
                    mergedSamplers,
                    fallbacks,
                };
            }
            return result;
        }
        /**
         * Get if the submesh is ready to be used and all its information available.
         * Child classes can use it to update shaders
         * @param mesh defines the mesh to check
         * @param subMesh defines which submesh to check
         * @param useInstances specifies that instances should be used
         * @returns a boolean indicating that the submesh is ready or not
         */
        isReadyForSubMesh(mesh, subMesh, useInstances = false) {
            if (!this._buildWasSuccessful) {
                return false;
            }
            const scene = this.getScene();
            if (this._sharedData.animatedInputs) {
                const frameId = scene.getFrameId();
                if (this._animationFrame !== frameId) {
                    for (const input of this._sharedData.animatedInputs) {
                        input.animate(scene);
                    }
                    this._animationFrame = frameId;
                }
            }
            if (subMesh.effect && this.isFrozen) {
                if (subMesh.effect._wasPreviouslyReady && subMesh.effect._wasPreviouslyUsingInstances === useInstances) {
                    return true;
                }
            }
            if (!subMesh.materialDefines) {
                subMesh.materialDefines = new NodeMaterialDefines();
            }
            const defines = subMesh.materialDefines;
            if (this._isReadyForSubMesh(subMesh)) {
                return true;
            }
            const engine = scene.getEngine();
            this._prepareDefinesForAttributes(mesh, defines);
            // Check if blocks are ready
            if (this._sharedData.blockingBlocks.some((b) => !b.isReady(mesh, this, defines, useInstances))) {
                return false;
            }
            const result = this._processDefines(mesh, defines, useInstances, subMesh);
            if (result) {
                const previousEffect = subMesh.effect;
                // Compilation
                const join = defines.toString();
                let effect = engine.createEffect({
                    vertex: "nodeMaterial" + this._buildId,
                    fragment: "nodeMaterial" + this._buildId,
                    vertexSource: this._vertexCompilationState.compilationString,
                    fragmentSource: this._fragmentCompilationState.compilationString,
                }, {
                    attributes: this._vertexCompilationState.attributes,
                    uniformsNames: result.mergedUniforms,
                    uniformBuffersNames: result.uniformBuffers,
                    samplers: result.mergedSamplers,
                    defines: join,
                    fallbacks: result.fallbacks,
                    onCompiled: this.onCompiled,
                    onError: this.onError,
                    indexParameters: { maxSimultaneousLights: this.maxSimultaneousLights, maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS },
                }, engine);
                if (effect) {
                    if (this._onEffectCreatedObservable) {
                        onCreatedEffectParameters$2.effect = effect;
                        onCreatedEffectParameters$2.subMesh = subMesh;
                        this._onEffectCreatedObservable.notifyObservers(onCreatedEffectParameters$2);
                    }
                    // Use previous effect while new one is compiling
                    if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                        effect = previousEffect;
                        defines.markAsUnprocessed();
                        if (result.lightDisposed) {
                            // re register in case it takes more than one frame.
                            defines._areLightsDisposed = true;
                            return false;
                        }
                    }
                    else {
                        scene.resetCachedMaterial();
                        subMesh.setEffect(effect, defines, this._materialContext);
                    }
                }
            }
            if (!subMesh.effect || !subMesh.effect.isReady()) {
                return false;
            }
            defines._renderId = scene.getRenderId();
            subMesh.effect._wasPreviouslyReady = true;
            subMesh.effect._wasPreviouslyUsingInstances = useInstances;
            this._checkScenePerformancePriority();
            return true;
        }
        /**
         * Get a string representing the shaders built by the current node graph
         */
        get compiledShaders() {
            return `// Vertex shader\n${this._vertexCompilationState.compilationString}\n\n// Fragment shader\n${this._fragmentCompilationState.compilationString}`;
        }
        /**
         * Binds the world matrix to the material
         * @param world defines the world transformation matrix
         */
        bindOnlyWorldMatrix(world) {
            const scene = this.getScene();
            if (!this._activeEffect) {
                return;
            }
            const hints = this._sharedData.hints;
            if (hints.needWorldViewMatrix) {
                world.multiplyToRef(scene.getViewMatrix(), this._cachedWorldViewMatrix);
            }
            if (hints.needWorldViewProjectionMatrix) {
                world.multiplyToRef(scene.getTransformMatrix(), this._cachedWorldViewProjectionMatrix);
            }
            // Connection points
            for (const inputBlock of this._sharedData.inputBlocks) {
                inputBlock._transmitWorld(this._activeEffect, world, this._cachedWorldViewMatrix, this._cachedWorldViewProjectionMatrix);
            }
        }
        /**
         * Binds the submesh to this material by preparing the effect and shader to draw
         * @param world defines the world transformation matrix
         * @param mesh defines the mesh containing the submesh
         * @param subMesh defines the submesh to bind the material to
         */
        bindForSubMesh(world, mesh, subMesh) {
            const scene = this.getScene();
            const effect = subMesh.effect;
            if (!effect) {
                return;
            }
            this._activeEffect = effect;
            // Matrices
            this.bindOnlyWorldMatrix(world);
            const mustRebind = this._mustRebind(scene, effect, mesh.visibility);
            const sharedData = this._sharedData;
            if (mustRebind) {
                // Bindable blocks
                for (const block of sharedData.bindableBlocks) {
                    block.bind(effect, this, mesh, subMesh);
                }
                for (const block of sharedData.forcedBindableBlocks) {
                    block.bind(effect, this, mesh, subMesh);
                }
                // Connection points
                for (const inputBlock of sharedData.inputBlocks) {
                    inputBlock._transmit(effect, scene, this);
                }
            }
            else if (!this.isFrozen) {
                for (const block of sharedData.forcedBindableBlocks) {
                    block.bind(effect, this, mesh, subMesh);
                }
            }
            this._afterBind(mesh, this._activeEffect);
        }
        /**
         * Gets the active textures from the material
         * @returns an array of textures
         */
        getActiveTextures() {
            const activeTextures = super.getActiveTextures();
            if (this._sharedData) {
                activeTextures.push(...this._sharedData.textureBlocks.filter((tb) => tb.texture).map((tb) => tb.texture));
            }
            return activeTextures;
        }
        /**
         * Gets the list of texture blocks
         * Note that this method will only return blocks that are reachable from the final block(s) and only after the material has been built!
         * @returns an array of texture blocks
         */
        getTextureBlocks() {
            if (!this._sharedData) {
                return [];
            }
            return this._sharedData.textureBlocks;
        }
        /**
         * Gets the list of all texture blocks
         * Note that this method will scan all attachedBlocks and return blocks that are texture blocks
         * @returns
         */
        getAllTextureBlocks() {
            const textureBlocks = [];
            for (const block of this.attachedBlocks) {
                if (NodeMaterial._BlockIsTextureBlock(block)) {
                    textureBlocks.push(block);
                }
            }
            return textureBlocks;
        }
        /**
         * Specifies if the material uses a texture
         * @param texture defines the texture to check against the material
         * @returns a boolean specifying if the material uses the texture
         */
        hasTexture(texture) {
            if (super.hasTexture(texture)) {
                return true;
            }
            if (!this._sharedData) {
                return false;
            }
            for (const t of this._sharedData.textureBlocks) {
                if (t.texture === texture) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Disposes the material
         * @param forceDisposeEffect specifies if effects should be forcefully disposed
         * @param forceDisposeTextures specifies if textures should be forcefully disposed
         * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
         */
        dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
            if (forceDisposeTextures) {
                for (const texture of this.getTextureBlocks()
                    .filter((tb) => tb.texture)
                    .map((tb) => tb.texture)) {
                    texture.dispose();
                }
            }
            for (const block of this.attachedBlocks) {
                block.dispose();
            }
            this.attachedBlocks.length = 0;
            this._sharedData = null;
            this._vertexCompilationState = null;
            this._fragmentCompilationState = null;
            this.onBuildObservable.clear();
            if (this._imageProcessingObserver) {
                this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
                this._imageProcessingObserver = null;
            }
            super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
        }
        /** Creates the node editor window. */
        _createNodeEditor(additionalConfig) {
            const nodeEditorConfig = Object.assign({ nodeMaterial: this }, additionalConfig);
            this.BJSNODEMATERIALEDITOR.NodeEditor.Show(nodeEditorConfig);
        }
        /**
         * Launch the node material editor
         * @param config Define the configuration of the editor
         * @returns a promise fulfilled when the node editor is visible
         */
        edit(config) {
            return new Promise((resolve) => {
                this.BJSNODEMATERIALEDITOR = this.BJSNODEMATERIALEDITOR || this._getGlobalNodeMaterialEditor();
                if (typeof this.BJSNODEMATERIALEDITOR == "undefined") {
                    const editorUrl = config && config.editorURL ? config.editorURL : NodeMaterial.EditorURL;
                    // Load editor and add it to the DOM
                    Tools.LoadScript(editorUrl, () => {
                        this.BJSNODEMATERIALEDITOR = this.BJSNODEMATERIALEDITOR || this._getGlobalNodeMaterialEditor();
                        this._createNodeEditor(config === null || config === void 0 ? void 0 : config.nodeEditorConfig);
                        resolve();
                    });
                }
                else {
                    // Otherwise creates the editor
                    this._createNodeEditor(config === null || config === void 0 ? void 0 : config.nodeEditorConfig);
                    resolve();
                }
            });
        }
        /**
         * Clear the current material
         */
        clear() {
            this._vertexOutputNodes.length = 0;
            this._fragmentOutputNodes.length = 0;
            this.attachedBlocks.length = 0;
        }
        /**
         * Clear the current material and set it to a default state
         */
        setToDefault() {
            this.clear();
            this.editorData = null;
            const positionInput = new InputBlock("Position");
            positionInput.setAsAttribute("position");
            const worldInput = new InputBlock("World");
            worldInput.setAsSystemValue(NodeMaterialSystemValues.World);
            const worldPos = new TransformBlock("WorldPos");
            positionInput.connectTo(worldPos);
            worldInput.connectTo(worldPos);
            const viewProjectionInput = new InputBlock("ViewProjection");
            viewProjectionInput.setAsSystemValue(NodeMaterialSystemValues.ViewProjection);
            const worldPosdMultipliedByViewProjection = new TransformBlock("WorldPos * ViewProjectionTransform");
            worldPos.connectTo(worldPosdMultipliedByViewProjection);
            viewProjectionInput.connectTo(worldPosdMultipliedByViewProjection);
            const vertexOutput = new VertexOutputBlock("VertexOutput");
            worldPosdMultipliedByViewProjection.connectTo(vertexOutput);
            // Pixel
            const pixelColor = new InputBlock("color");
            pixelColor.value = new Color4(0.8, 0.8, 0.8, 1);
            const fragmentOutput = new FragmentOutputBlock("FragmentOutput");
            pixelColor.connectTo(fragmentOutput);
            // Add to nodes
            this.addOutputNode(vertexOutput);
            this.addOutputNode(fragmentOutput);
            this._mode = NodeMaterialModes.Material;
        }
        /**
         * Clear the current material and set it to a default state for post process
         */
        setToDefaultPostProcess() {
            this.clear();
            this.editorData = null;
            const position = new InputBlock("Position");
            position.setAsAttribute("position2d");
            const const1 = new InputBlock("Constant1");
            const1.isConstant = true;
            const1.value = 1;
            const vmerger = new VectorMergerBlock("Position3D");
            position.connectTo(vmerger);
            const1.connectTo(vmerger, { input: "w" });
            const vertexOutput = new VertexOutputBlock("VertexOutput");
            vmerger.connectTo(vertexOutput);
            // Pixel
            const scale = new InputBlock("Scale");
            scale.visibleInInspector = true;
            scale.value = new Vector2(1, 1);
            const uv0 = new RemapBlock("uv0");
            position.connectTo(uv0);
            const uv = new MultiplyBlock("UV scale");
            uv0.connectTo(uv);
            scale.connectTo(uv);
            const currentScreen = new CurrentScreenBlock("CurrentScreen");
            uv.connectTo(currentScreen);
            currentScreen.texture = new Texture("https://assets.babylonjs.com/nme/currentScreenPostProcess.png", this.getScene());
            const fragmentOutput = new FragmentOutputBlock("FragmentOutput");
            currentScreen.connectTo(fragmentOutput, { output: "rgba" });
            // Add to nodes
            this.addOutputNode(vertexOutput);
            this.addOutputNode(fragmentOutput);
            this._mode = NodeMaterialModes.PostProcess;
        }
        /**
         * Clear the current material and set it to a default state for procedural texture
         */
        setToDefaultProceduralTexture() {
            this.clear();
            this.editorData = null;
            const position = new InputBlock("Position");
            position.setAsAttribute("position2d");
            const const1 = new InputBlock("Constant1");
            const1.isConstant = true;
            const1.value = 1;
            const vmerger = new VectorMergerBlock("Position3D");
            position.connectTo(vmerger);
            const1.connectTo(vmerger, { input: "w" });
            const vertexOutput = new VertexOutputBlock("VertexOutput");
            vmerger.connectTo(vertexOutput);
            // Pixel
            const time = new InputBlock("Time");
            time.value = 0;
            time.min = 0;
            time.max = 0;
            time.isBoolean = false;
            time.matrixMode = 0;
            time.animationType = AnimatedInputBlockTypes.Time;
            time.isConstant = false;
            const color = new InputBlock("Color3");
            color.value = new Color3(1, 1, 1);
            color.isConstant = false;
            const fragmentOutput = new FragmentOutputBlock("FragmentOutput");
            const vectorMerger = new VectorMergerBlock("VectorMerger");
            vectorMerger.visibleInInspector = false;
            const cos = new TrigonometryBlock("Cos");
            cos.operation = TrigonometryBlockOperations.Cos;
            position.connectTo(vectorMerger);
            time.output.connectTo(cos.input);
            cos.output.connectTo(vectorMerger.z);
            vectorMerger.xyzOut.connectTo(fragmentOutput.rgb);
            // Add to nodes
            this.addOutputNode(vertexOutput);
            this.addOutputNode(fragmentOutput);
            this._mode = NodeMaterialModes.ProceduralTexture;
        }
        /**
         * Clear the current material and set it to a default state for particle
         */
        setToDefaultParticle() {
            this.clear();
            this.editorData = null;
            // Pixel
            const uv = new InputBlock("uv");
            uv.setAsAttribute("particle_uv");
            const texture = new ParticleTextureBlock("ParticleTexture");
            uv.connectTo(texture);
            const color = new InputBlock("Color");
            color.setAsAttribute("particle_color");
            const multiply = new MultiplyBlock("Texture * Color");
            texture.connectTo(multiply);
            color.connectTo(multiply);
            const rampGradient = new ParticleRampGradientBlock("ParticleRampGradient");
            multiply.connectTo(rampGradient);
            const cSplitter = new ColorSplitterBlock("ColorSplitter");
            color.connectTo(cSplitter);
            const blendMultiply = new ParticleBlendMultiplyBlock("ParticleBlendMultiply");
            rampGradient.connectTo(blendMultiply);
            texture.connectTo(blendMultiply, { output: "a" });
            cSplitter.connectTo(blendMultiply, { output: "a" });
            const fragmentOutput = new FragmentOutputBlock("FragmentOutput");
            blendMultiply.connectTo(fragmentOutput);
            // Add to nodes
            this.addOutputNode(fragmentOutput);
            this._mode = NodeMaterialModes.Particle;
        }
        /**
         * Loads the current Node Material from a url pointing to a file save by the Node Material Editor
         * @deprecated Please use NodeMaterial.ParseFromFileAsync instead
         * @param url defines the url to load from
         * @param rootUrl defines the root URL for nested url in the node material
         * @returns a promise that will fulfil when the material is fully loaded
         */
        async loadAsync(url, rootUrl = "") {
            return NodeMaterial.ParseFromFileAsync("", url, this.getScene(), rootUrl, true, this);
        }
        _gatherBlocks(rootNode, list) {
            if (list.indexOf(rootNode) !== -1) {
                return;
            }
            list.push(rootNode);
            for (const input of rootNode.inputs) {
                const connectedPoint = input.connectedPoint;
                if (connectedPoint) {
                    const block = connectedPoint.ownerBlock;
                    if (block !== rootNode) {
                        this._gatherBlocks(block, list);
                    }
                }
            }
            // Teleportation
            if (rootNode.isTeleportOut) {
                const block = rootNode;
                if (block.entryPoint) {
                    this._gatherBlocks(block.entryPoint, list);
                }
            }
        }
        /**
         * Generate a string containing the code declaration required to create an equivalent of this material
         * @returns a string
         */
        generateCode() {
            let alreadyDumped = [];
            const vertexBlocks = [];
            const uniqueNames = ["const", "var", "let"];
            // Gets active blocks
            for (const outputNode of this._vertexOutputNodes) {
                this._gatherBlocks(outputNode, vertexBlocks);
            }
            const fragmentBlocks = [];
            for (const outputNode of this._fragmentOutputNodes) {
                this._gatherBlocks(outputNode, fragmentBlocks);
            }
            // Generate vertex shader
            let codeString = `var nodeMaterial = new BABYLON.NodeMaterial("${this.name || "node material"}");\n`;
            codeString += `nodeMaterial.mode = BABYLON.NodeMaterialModes.${NodeMaterialModes[this.mode]};\n`;
            for (const node of vertexBlocks) {
                if (node.isInput && alreadyDumped.indexOf(node) === -1) {
                    codeString += node._dumpCode(uniqueNames, alreadyDumped);
                }
            }
            // Generate fragment shader
            for (const node of fragmentBlocks) {
                if (node.isInput && alreadyDumped.indexOf(node) === -1) {
                    codeString += node._dumpCode(uniqueNames, alreadyDumped);
                }
            }
            // Connections
            alreadyDumped = [];
            codeString += "\n// Connections\n";
            for (const node of this._vertexOutputNodes) {
                codeString += node._dumpCodeForOutputConnections(alreadyDumped);
            }
            for (const node of this._fragmentOutputNodes) {
                codeString += node._dumpCodeForOutputConnections(alreadyDumped);
            }
            // Output nodes
            codeString += "\n// Output nodes\n";
            for (const node of this._vertexOutputNodes) {
                codeString += `nodeMaterial.addOutputNode(${node._codeVariableName});\n`;
            }
            for (const node of this._fragmentOutputNodes) {
                codeString += `nodeMaterial.addOutputNode(${node._codeVariableName});\n`;
            }
            codeString += `nodeMaterial.build();\n`;
            return codeString;
        }
        /**
         * Serializes this material in a JSON representation
         * @param selectedBlocks
         * @returns the serialized material object
         */
        serialize(selectedBlocks) {
            const serializationObject = selectedBlocks ? {} : SerializationHelper.Serialize(this);
            serializationObject.editorData = JSON.parse(JSON.stringify(this.editorData)); // Copy
            let blocks = [];
            if (selectedBlocks) {
                blocks = selectedBlocks;
            }
            else {
                serializationObject.customType = "BABYLON.NodeMaterial";
                serializationObject.outputNodes = [];
                // Outputs
                for (const outputNode of this._vertexOutputNodes) {
                    this._gatherBlocks(outputNode, blocks);
                    serializationObject.outputNodes.push(outputNode.uniqueId);
                }
                for (const outputNode of this._fragmentOutputNodes) {
                    this._gatherBlocks(outputNode, blocks);
                    if (serializationObject.outputNodes.indexOf(outputNode.uniqueId) === -1) {
                        serializationObject.outputNodes.push(outputNode.uniqueId);
                    }
                }
            }
            // Blocks
            serializationObject.blocks = [];
            for (const block of blocks) {
                serializationObject.blocks.push(block.serialize());
            }
            if (!selectedBlocks) {
                for (const block of this.attachedBlocks) {
                    if (blocks.indexOf(block) !== -1) {
                        continue;
                    }
                    serializationObject.blocks.push(block.serialize());
                }
            }
            return serializationObject;
        }
        _restoreConnections(block, source, map) {
            for (const outputPoint of block.outputs) {
                for (const candidate of source.blocks) {
                    const target = map[candidate.id];
                    if (!target) {
                        continue;
                    }
                    for (const input of candidate.inputs) {
                        if (map[input.targetBlockId] === block && input.targetConnectionName === outputPoint.name) {
                            const inputPoint = target.getInputByName(input.inputName);
                            if (!inputPoint || inputPoint.isConnected) {
                                continue;
                            }
                            outputPoint.connectTo(inputPoint, true);
                            this._restoreConnections(target, source, map);
                            continue;
                        }
                    }
                }
            }
        }
        /**
         * Clear the current graph and load a new one from a serialization object
         * @param source defines the JSON representation of the material
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @param merge defines whether or not the source must be merged or replace the current content
         */
        parseSerializedObject(source, rootUrl = "", merge = false) {
            var _a;
            if (!merge) {
                this.clear();
            }
            const map = {};
            // Create blocks
            for (const parsedBlock of source.blocks) {
                const blockType = GetClass(parsedBlock.customType);
                if (blockType) {
                    const block = new blockType();
                    block._deserialize(parsedBlock, this.getScene(), rootUrl);
                    map[parsedBlock.id] = block;
                    this.attachedBlocks.push(block);
                }
            }
            // Reconnect teleportation
            for (const block of this.attachedBlocks) {
                if (block.isTeleportOut) {
                    const teleportOut = block;
                    const id = teleportOut._tempEntryPointUniqueId;
                    if (id) {
                        const source = map[id];
                        source.attachToEndpoint(teleportOut);
                    }
                }
            }
            // Connections - Starts with input blocks only (except if in "merge" mode where we scan all blocks)
            for (let blockIndex = 0; blockIndex < source.blocks.length; blockIndex++) {
                const parsedBlock = source.blocks[blockIndex];
                const block = map[parsedBlock.id];
                if (!block) {
                    continue;
                }
                if (block.inputs.length && !merge) {
                    continue;
                }
                this._restoreConnections(block, source, map);
            }
            // Outputs
            if (source.outputNodes) {
                for (const outputNodeId of source.outputNodes) {
                    this.addOutputNode(map[outputNodeId]);
                }
            }
            // UI related info
            if (source.locations || (source.editorData && source.editorData.locations)) {
                const locations = source.locations || source.editorData.locations;
                for (const location of locations) {
                    if (map[location.blockId]) {
                        location.blockId = map[location.blockId].uniqueId;
                    }
                }
                if (merge && this.editorData && this.editorData.locations) {
                    locations.concat(this.editorData.locations);
                }
                if (source.locations) {
                    this.editorData = {
                        locations: locations,
                    };
                }
                else {
                    this.editorData = source.editorData;
                    this.editorData.locations = locations;
                }
                const blockMap = [];
                for (const key in map) {
                    blockMap[key] = map[key].uniqueId;
                }
                this.editorData.map = blockMap;
            }
            this.comment = source.comment;
            if (source.forceAlphaBlending !== undefined) {
                this.forceAlphaBlending = source.forceAlphaBlending;
            }
            if (!merge) {
                this._mode = (_a = source.mode) !== null && _a !== void 0 ? _a : NodeMaterialModes.Material;
            }
        }
        /**
         * Clear the current graph and load a new one from a serialization object
         * @param source defines the JSON representation of the material
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @param merge defines whether or not the source must be merged or replace the current content
         * @deprecated Please use the parseSerializedObject method instead
         */
        loadFromSerialization(source, rootUrl = "", merge = false) {
            this.parseSerializedObject(source, rootUrl, merge);
        }
        /**
         * Makes a duplicate of the current material.
         * @param name defines the name to use for the new material
         * @param shareEffect defines if the clone material should share the same effect (default is false)
         */
        clone(name, shareEffect = false) {
            const serializationObject = this.serialize();
            const clone = SerializationHelper.Clone(() => new NodeMaterial(name, this.getScene(), this.options), this);
            clone.id = name;
            clone.name = name;
            clone.parseSerializedObject(serializationObject);
            clone._buildId = this._buildId;
            clone.build(false, !shareEffect);
            return clone;
        }
        /**
         * Creates a node material from parsed material data
         * @param source defines the JSON representation of the material
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @returns a new node material
         */
        static Parse(source, scene, rootUrl = "") {
            const nodeMaterial = SerializationHelper.Parse(() => new NodeMaterial(source.name, scene), source, scene, rootUrl);
            nodeMaterial.parseSerializedObject(source, rootUrl);
            nodeMaterial.build();
            return nodeMaterial;
        }
        /**
         * Creates a node material from a snippet saved in a remote file
         * @param name defines the name of the material to create
         * @param url defines the url to load from
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL for nested url in the node material
         * @param skipBuild defines whether to build the node material
         * @param targetMaterial defines a material to use instead of creating a new one
         * @returns a promise that will resolve to the new node material
         */
        static async ParseFromFileAsync(name, url, scene, rootUrl = "", skipBuild = false, targetMaterial) {
            const material = targetMaterial !== null && targetMaterial !== void 0 ? targetMaterial : new NodeMaterial(name, scene);
            const data = await scene._loadFileAsync(url);
            const serializationObject = JSON.parse(data);
            material.parseSerializedObject(serializationObject, rootUrl);
            if (!skipBuild) {
                material.build();
            }
            return material;
        }
        /**
         * Creates a node material from a snippet saved by the node material editor
         * @param snippetId defines the snippet to load
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @param nodeMaterial defines a node material to update (instead of creating a new one)
         * @param skipBuild defines whether to build the node material
         * @returns a promise that will resolve to the new node material
         */
        static ParseFromSnippetAsync(snippetId, scene = EngineStore.LastCreatedScene, rootUrl = "", nodeMaterial, skipBuild = false) {
            if (snippetId === "_BLANK") {
                return Promise.resolve(NodeMaterial.CreateDefault("blank", scene));
            }
            return new Promise((resolve, reject) => {
                const request = new WebRequest();
                request.addEventListener("readystatechange", () => {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                            const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                            const serializationObject = JSON.parse(snippet.nodeMaterial);
                            if (!nodeMaterial) {
                                nodeMaterial = SerializationHelper.Parse(() => new NodeMaterial(snippetId, scene), serializationObject, scene, rootUrl);
                                nodeMaterial.uniqueId = scene.getUniqueId();
                            }
                            nodeMaterial.parseSerializedObject(serializationObject);
                            nodeMaterial.snippetId = snippetId;
                            try {
                                if (!skipBuild) {
                                    nodeMaterial.build();
                                }
                                resolve(nodeMaterial);
                            }
                            catch (err) {
                                reject(err);
                            }
                        }
                        else {
                            reject("Unable to load the snippet " + snippetId);
                        }
                    }
                });
                request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
                request.send();
            });
        }
        /**
         * Creates a new node material set to default basic configuration
         * @param name defines the name of the material
         * @param scene defines the hosting scene
         * @returns a new NodeMaterial
         */
        static CreateDefault(name, scene) {
            const newMaterial = new NodeMaterial(name, scene);
            newMaterial.setToDefault();
            newMaterial.build();
            return newMaterial;
        }
    }
    NodeMaterial._BuildIdGenerator = 0;
    /** Define the Url to load node editor script */
    NodeMaterial.EditorURL = `https://unpkg.com/babylonjs-node-editor@${Engine.Version}/babylon.nodeEditor.js`;
    /** Define the Url to load snippets */
    NodeMaterial.SnippetUrl = `https://snippet.babylonjs.com`;
    /** Gets or sets a boolean indicating that node materials should not deserialize textures from json / snippet content */
    NodeMaterial.IgnoreTexturesAtLoadTime = false;
    __decorate$1([
        serialize()
    ], NodeMaterial.prototype, "ignoreAlpha", void 0);
    __decorate$1([
        serialize()
    ], NodeMaterial.prototype, "maxSimultaneousLights", void 0);
    __decorate$1([
        serialize("mode")
    ], NodeMaterial.prototype, "_mode", void 0);
    __decorate$1([
        serialize("comment")
    ], NodeMaterial.prototype, "comment", void 0);
    __decorate$1([
        serialize()
    ], NodeMaterial.prototype, "forceAlphaBlending", void 0);
    RegisterClass("BABYLON.NodeMaterial", NodeMaterial);

    /**
     * @internal
     */
    SubMesh.prototype._projectOnTrianglesToRef = function (vector, positions, indices, step, checkStopper, ref) {
        // Triangles test
        const proj = TmpVectors.Vector3[0];
        const tmp = TmpVectors.Vector3[1];
        let distance = +Infinity;
        for (let index = this.indexStart; index < this.indexStart + this.indexCount - (3 - step); index += step) {
            const indexA = indices[index];
            const indexB = indices[index + 1];
            const indexC = indices[index + 2];
            if (checkStopper && indexC === 0xffffffff) {
                index += 2;
                continue;
            }
            const p0 = positions[indexA];
            const p1 = positions[indexB];
            const p2 = positions[indexC];
            // stay defensive and don't check against undefined positions.
            if (!p0 || !p1 || !p2) {
                continue;
            }
            const tmpDist = Vector3.ProjectOnTriangleToRef(vector, p0, p1, p2, tmp);
            if (tmpDist < distance) {
                proj.copyFrom(tmp);
                distance = tmpDist;
            }
        }
        ref.copyFrom(proj);
        return distance;
    };
    /**
     * @internal
     */
    SubMesh.prototype._projectOnUnIndexedTrianglesToRef = function (vector, positions, indices, ref) {
        // Triangles test
        const proj = TmpVectors.Vector3[0];
        const tmp = TmpVectors.Vector3[1];
        let distance = +Infinity;
        for (let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 3) {
            const p0 = positions[index];
            const p1 = positions[index + 1];
            const p2 = positions[index + 2];
            const tmpDist = Vector3.ProjectOnTriangleToRef(vector, p0, p1, p2, tmp);
            if (tmpDist < distance) {
                proj.copyFrom(tmp);
                distance = tmpDist;
            }
        }
        ref.copyFrom(proj);
        return distance;
    };
    SubMesh.prototype.projectToRef = function (vector, positions, indices, ref) {
        const material = this.getMaterial();
        if (!material) {
            return -1;
        }
        let step = 3;
        let checkStopper = false;
        switch (material.fillMode) {
            case 3:
            case 5:
            case 6:
            case 8:
                return -1;
            case 7:
                step = 1;
                checkStopper = true;
                break;
        }
        // LineMesh first as it's also a Mesh...
        if (material.fillMode === 4) {
            return -1;
        }
        else {
            // Check if mesh is unindexed
            if (!indices.length && this._mesh._unIndexed) {
                return this._projectOnUnIndexedTrianglesToRef(vector, positions, indices, ref);
            }
            return this._projectOnTrianglesToRef(vector, positions, indices, step, checkStopper, ref);
        }
    };

    // Tracks the interaction animation state when using a motion controller with a near interaction orb
    var ControllerOrbAnimationState;
    (function (ControllerOrbAnimationState) {
        /**
         * Orb is invisible
         */
        ControllerOrbAnimationState[ControllerOrbAnimationState["DEHYDRATED"] = 0] = "DEHYDRATED";
        /**
         * Orb is visible and inside the hover range
         */
        ControllerOrbAnimationState[ControllerOrbAnimationState["HOVER"] = 1] = "HOVER";
        /**
         * Orb is visible and touching a near interaction target
         */
        ControllerOrbAnimationState[ControllerOrbAnimationState["TOUCH"] = 2] = "TOUCH";
    })(ControllerOrbAnimationState || (ControllerOrbAnimationState = {}));
    /**
     * Where should the near interaction mesh be attached to when using a motion controller for near interaction
     */
    var WebXRNearControllerMode;
    (function (WebXRNearControllerMode) {
        /**
         * Motion controllers will not support near interaction
         */
        WebXRNearControllerMode[WebXRNearControllerMode["DISABLED"] = 0] = "DISABLED";
        /**
         * The interaction point for motion controllers will be inside of them
         */
        WebXRNearControllerMode[WebXRNearControllerMode["CENTERED_ON_CONTROLLER"] = 1] = "CENTERED_ON_CONTROLLER";
        /**
         * The interaction point for motion controllers will be in front of the controller
         */
        WebXRNearControllerMode[WebXRNearControllerMode["CENTERED_IN_FRONT"] = 2] = "CENTERED_IN_FRONT";
    })(WebXRNearControllerMode || (WebXRNearControllerMode = {}));
    /**
     * A module that will enable near interaction near interaction for hands and motion controllers of XR Input Sources
     */
    class WebXRNearInteraction extends WebXRAbstractFeature {
        /**
         * constructs a new background remover module
         * @param _xrSessionManager the session manager for this module
         * @param _options read-only options to be used in this module
         */
        constructor(_xrSessionManager, _options) {
            super(_xrSessionManager);
            this._options = _options;
            this._tmpRay = new Ray(new Vector3(), new Vector3());
            this._attachController = (xrController) => {
                if (this._controllers[xrController.uniqueId]) {
                    // already attached
                    return;
                }
                // get two new meshes
                const { touchCollisionMesh, touchCollisionMeshFunction, hydrateCollisionMeshFunction } = this._generateNewTouchPointMesh();
                const selectionMesh = this._generateVisualCue();
                this._controllers[xrController.uniqueId] = {
                    xrController,
                    meshUnderPointer: null,
                    nearInteractionTargetMesh: null,
                    pick: null,
                    stalePick: null,
                    touchCollisionMesh,
                    touchCollisionMeshFunction: touchCollisionMeshFunction,
                    hydrateCollisionMeshFunction: hydrateCollisionMeshFunction,
                    currentAnimationState: ControllerOrbAnimationState.DEHYDRATED,
                    grabRay: new Ray(new Vector3(), new Vector3()),
                    hoverInteraction: false,
                    nearInteraction: false,
                    grabInteraction: false,
                    id: WebXRNearInteraction._IdCounter++,
                    pickedPointVisualCue: selectionMesh,
                };
                if (this._attachedController) {
                    if (!this._options.enableNearInteractionOnAllControllers &&
                        this._options.preferredHandedness &&
                        xrController.inputSource.handedness === this._options.preferredHandedness) {
                        this._attachedController = xrController.uniqueId;
                    }
                }
                else {
                    if (!this._options.enableNearInteractionOnAllControllers) {
                        this._attachedController = xrController.uniqueId;
                    }
                }
                switch (xrController.inputSource.targetRayMode) {
                    case "tracked-pointer":
                        return this._attachNearInteractionMode(xrController);
                    case "gaze":
                        return null;
                    case "screen":
                        return null;
                }
            };
            this._controllers = {};
            this._farInteractionFeature = null;
            /**
             * default color of the selection ring
             */
            this.selectionMeshDefaultColor = new Color3(0.8, 0.8, 0.8);
            /**
             * This color will be applied to the selection ring when selection is triggered
             */
            this.selectionMeshPickedColor = new Color3(0.3, 0.3, 1.0);
            this._hoverRadius = 0.1;
            this._pickRadius = 0.02;
            this._controllerPickRadius = 0.03; // The radius is slightly larger here to make it easier to manipulate since it's not tied to the hand position
            this._nearGrabLengthScale = 5;
            this._scene = this._xrSessionManager.scene;
            if (this._options.nearInteractionControllerMode === undefined) {
                this._options.nearInteractionControllerMode = WebXRNearControllerMode.CENTERED_IN_FRONT;
            }
            if (this._options.farInteractionFeature) {
                this._farInteractionFeature = this._options.farInteractionFeature;
            }
        }
        /**
         * Attach this feature
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        attach() {
            if (!super.attach()) {
                return false;
            }
            this._options.xrInput.controllers.forEach(this._attachController);
            this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController);
            this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller) => {
                // REMOVE the controller
                this._detachController(controller.uniqueId);
            });
            this._scene.constantlyUpdateMeshUnderPointer = true;
            return true;
        }
        /**
         * Detach this feature.
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        detach() {
            if (!super.detach()) {
                return false;
            }
            Object.keys(this._controllers).forEach((controllerId) => {
                this._detachController(controllerId);
            });
            return true;
        }
        /**
         * Will get the mesh under a specific pointer.
         * `scene.meshUnderPointer` will only return one mesh - either left or right.
         * @param controllerId the controllerId to check
         * @returns The mesh under pointer or null if no mesh is under the pointer
         */
        getMeshUnderPointer(controllerId) {
            if (this._controllers[controllerId]) {
                return this._controllers[controllerId].meshUnderPointer;
            }
            else {
                return null;
            }
        }
        /**
         * Get the xr controller that correlates to the pointer id in the pointer event
         *
         * @param id the pointer id to search for
         * @returns the controller that correlates to this id or null if not found
         */
        getXRControllerByPointerId(id) {
            const keys = Object.keys(this._controllers);
            for (let i = 0; i < keys.length; ++i) {
                if (this._controllers[keys[i]].id === id) {
                    return this._controllers[keys[i]].xrController || null;
                }
            }
            return null;
        }
        /**
         * This function sets webXRControllerPointerSelection feature that will be disabled when
         * the hover range is reached for a mesh and will be reattached when not in hover range.
         * This is used to remove the selection rays when moving.
         * @param farInteractionFeature the feature to disable when finger is in hover range for a mesh
         */
        setFarInteractionFeature(farInteractionFeature) {
            this._farInteractionFeature = farInteractionFeature;
        }
        /**
         * Filter used for near interaction pick and hover
         * @param mesh
         */
        _nearPickPredicate(mesh) {
            return mesh.isEnabled() && mesh.isVisible && mesh.isPickable && mesh.isNearPickable;
        }
        /**
         * Filter used for near interaction grab
         * @param mesh
         */
        _nearGrabPredicate(mesh) {
            return mesh.isEnabled() && mesh.isVisible && mesh.isPickable && mesh.isNearGrabbable;
        }
        /**
         * Filter used for any near interaction
         * @param mesh
         */
        _nearInteractionPredicate(mesh) {
            return mesh.isEnabled() && mesh.isVisible && mesh.isPickable && (mesh.isNearPickable || mesh.isNearGrabbable);
        }
        _controllerAvailablePredicate(mesh, controllerId) {
            let parent = mesh;
            while (parent) {
                if (parent.reservedDataStore && parent.reservedDataStore.nearInteraction && parent.reservedDataStore.nearInteraction.excludedControllerId === controllerId) {
                    return false;
                }
                parent = parent.parent;
            }
            return true;
        }
        _handleTransitionAnimation(controllerData, newState) {
            var _a;
            if (controllerData.currentAnimationState === newState ||
                this._options.nearInteractionControllerMode !== WebXRNearControllerMode.CENTERED_IN_FRONT ||
                !!((_a = controllerData.xrController) === null || _a === void 0 ? void 0 : _a.inputSource.hand)) {
                return;
            }
            // Don't always break to allow for animation fallthrough on rare cases of multi-transitions
            if (newState > controllerData.currentAnimationState) {
                switch (controllerData.currentAnimationState) {
                    case ControllerOrbAnimationState.DEHYDRATED: {
                        controllerData.hydrateCollisionMeshFunction(true);
                        if (newState === ControllerOrbAnimationState.HOVER) {
                            break;
                        }
                    }
                    // eslint-disable-next-line no-fallthrough
                    case ControllerOrbAnimationState.HOVER: {
                        controllerData.touchCollisionMeshFunction(true);
                        if (newState === ControllerOrbAnimationState.TOUCH) {
                            break;
                        }
                    }
                }
            }
            else {
                switch (controllerData.currentAnimationState) {
                    case ControllerOrbAnimationState.TOUCH: {
                        controllerData.touchCollisionMeshFunction(false);
                        if (newState === ControllerOrbAnimationState.HOVER) {
                            break;
                        }
                    }
                    // eslint-disable-next-line no-fallthrough
                    case ControllerOrbAnimationState.HOVER: {
                        controllerData.hydrateCollisionMeshFunction(false);
                        if (newState === ControllerOrbAnimationState.DEHYDRATED) {
                            break;
                        }
                    }
                }
            }
            controllerData.currentAnimationState = newState;
        }
        _processTouchPoint(id, position, orientation) {
            var _a;
            const controllerData = this._controllers[id];
            // Position and orientation could be temporary values, se we take care of them before calling any functions that use temporary vectors/quaternions
            controllerData.grabRay.origin.copyFrom(position);
            orientation.toEulerAnglesToRef(TmpVectors.Vector3[0]);
            controllerData.grabRay.direction.copyFrom(TmpVectors.Vector3[0]);
            if (this._options.nearInteractionControllerMode === WebXRNearControllerMode.CENTERED_IN_FRONT && !((_a = controllerData.xrController) === null || _a === void 0 ? void 0 : _a.inputSource.hand)) {
                // offset the touch point in the direction the transform is facing
                controllerData.xrController.getWorldPointerRayToRef(this._tmpRay);
                controllerData.grabRay.origin.addInPlace(this._tmpRay.direction.scale(0.05));
            }
            controllerData.grabRay.length = this._nearGrabLengthScale * this._hoverRadius;
            controllerData.touchCollisionMesh.position.copyFrom(controllerData.grabRay.origin);
        }
        _onXRFrame(_xrFrame) {
            Object.keys(this._controllers).forEach((id) => {
                var _a;
                // only do this for the selected pointer
                const controllerData = this._controllers[id];
                const handData = (_a = controllerData.xrController) === null || _a === void 0 ? void 0 : _a.inputSource.hand;
                // If near interaction is not enabled/available for this controller, return early
                if ((!this._options.enableNearInteractionOnAllControllers && id !== this._attachedController) ||
                    !controllerData.xrController ||
                    (!handData && (!this._options.nearInteractionControllerMode || !controllerData.xrController.inputSource.gamepad))) {
                    controllerData.pick = null;
                    return;
                }
                controllerData.hoverInteraction = false;
                controllerData.nearInteraction = false;
                // Every frame check collisions/input
                if (controllerData.xrController) {
                    if (handData) {
                        const xrIndexTip = handData.get("index-finger-tip");
                        if (xrIndexTip) {
                            const indexTipPose = _xrFrame.getJointPose(xrIndexTip, this._xrSessionManager.referenceSpace);
                            if (indexTipPose && indexTipPose.transform) {
                                const axisRHSMultiplier = this._scene.useRightHandedSystem ? 1 : -1;
                                TmpVectors.Vector3[0].set(indexTipPose.transform.position.x, indexTipPose.transform.position.y, indexTipPose.transform.position.z * axisRHSMultiplier);
                                TmpVectors.Quaternion[0].set(indexTipPose.transform.orientation.x, indexTipPose.transform.orientation.y, indexTipPose.transform.orientation.z * axisRHSMultiplier, indexTipPose.transform.orientation.w * axisRHSMultiplier);
                                this._processTouchPoint(id, TmpVectors.Vector3[0], TmpVectors.Quaternion[0]);
                            }
                        }
                    }
                    else if (controllerData.xrController.inputSource.gamepad && this._options.nearInteractionControllerMode !== WebXRNearControllerMode.DISABLED) {
                        let controllerPose = controllerData.xrController.pointer;
                        if (controllerData.xrController.grip && this._options.nearInteractionControllerMode === WebXRNearControllerMode.CENTERED_ON_CONTROLLER) {
                            controllerPose = controllerData.xrController.grip;
                        }
                        this._processTouchPoint(id, controllerPose.position, controllerPose.rotationQuaternion);
                    }
                }
                else {
                    return;
                }
                const accuratePickInfo = (originalScenePick, utilityScenePick) => {
                    let pick = null;
                    if (!utilityScenePick || !utilityScenePick.hit) {
                        // No hit in utility scene
                        pick = originalScenePick;
                    }
                    else if (!originalScenePick || !originalScenePick.hit) {
                        // No hit in original scene
                        pick = utilityScenePick;
                    }
                    else if (utilityScenePick.distance < originalScenePick.distance) {
                        // Hit is closer in utility scene
                        pick = utilityScenePick;
                    }
                    else {
                        // Hit is closer in original scene
                        pick = originalScenePick;
                    }
                    return pick;
                };
                const populateNearInteractionInfo = (nearInteractionInfo) => {
                    let result = new PickingInfo();
                    let nearInteractionAtOrigin = false;
                    const nearInteraction = nearInteractionInfo && nearInteractionInfo.pickedPoint && nearInteractionInfo.hit;
                    if (nearInteractionInfo === null || nearInteractionInfo === void 0 ? void 0 : nearInteractionInfo.pickedPoint) {
                        nearInteractionAtOrigin = nearInteractionInfo.pickedPoint.x === 0 && nearInteractionInfo.pickedPoint.y === 0 && nearInteractionInfo.pickedPoint.z === 0;
                    }
                    if (nearInteraction && !nearInteractionAtOrigin) {
                        result = nearInteractionInfo;
                    }
                    return result;
                };
                // Don't perform touch logic while grabbing, to prevent triggering touch interactions while in the middle of a grab interaction
                // Dont update cursor logic either - the cursor should already be visible for the grab to be in range,
                // and in order to maintain its position on the target mesh it is parented for the duration of the grab.
                if (!controllerData.grabInteraction) {
                    let pick = null;
                    // near interaction hover
                    let utilitySceneHoverPick = null;
                    if (this._options.useUtilityLayer && this._utilityLayerScene) {
                        utilitySceneHoverPick = this._pickWithSphere(controllerData, this._hoverRadius, this._utilityLayerScene, (mesh) => this._nearInteractionPredicate(mesh));
                    }
                    const originalSceneHoverPick = this._pickWithSphere(controllerData, this._hoverRadius, this._scene, (mesh) => this._nearInteractionPredicate(mesh));
                    const hoverPickInfo = accuratePickInfo(originalSceneHoverPick, utilitySceneHoverPick);
                    if (hoverPickInfo && hoverPickInfo.hit) {
                        pick = populateNearInteractionInfo(hoverPickInfo);
                        if (pick.hit) {
                            controllerData.hoverInteraction = true;
                        }
                    }
                    // near interaction pick
                    if (controllerData.hoverInteraction) {
                        let utilitySceneNearPick = null;
                        const radius = handData ? this._pickRadius : this._controllerPickRadius;
                        if (this._options.useUtilityLayer && this._utilityLayerScene) {
                            utilitySceneNearPick = this._pickWithSphere(controllerData, radius, this._utilityLayerScene, (mesh) => this._nearPickPredicate(mesh));
                        }
                        const originalSceneNearPick = this._pickWithSphere(controllerData, radius, this._scene, (mesh) => this._nearPickPredicate(mesh));
                        const pickInfo = accuratePickInfo(originalSceneNearPick, utilitySceneNearPick);
                        const nearPick = populateNearInteractionInfo(pickInfo);
                        if (nearPick.hit) {
                            // Near pick takes precedence over hover interaction
                            pick = nearPick;
                            controllerData.nearInteraction = true;
                        }
                    }
                    controllerData.stalePick = controllerData.pick;
                    controllerData.pick = pick;
                    // Update mesh under pointer
                    if (controllerData.pick && controllerData.pick.pickedPoint && controllerData.pick.hit) {
                        controllerData.meshUnderPointer = controllerData.pick.pickedMesh;
                        controllerData.pickedPointVisualCue.position.copyFrom(controllerData.pick.pickedPoint);
                        controllerData.pickedPointVisualCue.isVisible = true;
                        if (this._farInteractionFeature && this._farInteractionFeature.attached) {
                            this._farInteractionFeature._setPointerSelectionDisabledByPointerId(controllerData.id, true);
                        }
                    }
                    else {
                        controllerData.meshUnderPointer = null;
                        controllerData.pickedPointVisualCue.isVisible = false;
                        if (this._farInteractionFeature && this._farInteractionFeature.attached) {
                            this._farInteractionFeature._setPointerSelectionDisabledByPointerId(controllerData.id, false);
                        }
                    }
                }
                // Update the interaction animation. Only updates if the visible touch mesh is active
                let state = ControllerOrbAnimationState.DEHYDRATED;
                if (controllerData.grabInteraction || controllerData.nearInteraction) {
                    state = ControllerOrbAnimationState.TOUCH;
                }
                else if (controllerData.hoverInteraction) {
                    state = ControllerOrbAnimationState.HOVER;
                }
                this._handleTransitionAnimation(controllerData, state);
            });
        }
        get _utilityLayerScene() {
            return this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene;
        }
        _generateVisualCue() {
            const sceneToRenderTo = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene : this._scene;
            const selectionMesh = CreateSphere("nearInteraction", {
                diameter: 0.0035 * 3,
            }, sceneToRenderTo);
            selectionMesh.bakeCurrentTransformIntoVertices();
            selectionMesh.isPickable = false;
            selectionMesh.isVisible = false;
            selectionMesh.rotationQuaternion = Quaternion.Identity();
            const targetMat = new StandardMaterial("targetMat", sceneToRenderTo);
            targetMat.specularColor = Color3.Black();
            targetMat.emissiveColor = this.selectionMeshDefaultColor;
            targetMat.backFaceCulling = false;
            selectionMesh.material = targetMat;
            return selectionMesh;
        }
        _isControllerReadyForNearInteraction(id) {
            if (this._farInteractionFeature) {
                return this._farInteractionFeature._getPointerSelectionDisabledByPointerId(id);
            }
            return true;
        }
        _attachNearInteractionMode(xrController) {
            const controllerData = this._controllers[xrController.uniqueId];
            const pointerEventInit = {
                pointerId: controllerData.id,
                pointerType: "xr-near",
            };
            controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(() => {
                if ((!this._options.enableNearInteractionOnAllControllers && xrController.uniqueId !== this._attachedController) ||
                    !controllerData.xrController ||
                    (!controllerData.xrController.inputSource.hand && (!this._options.nearInteractionControllerMode || !controllerData.xrController.inputSource.gamepad))) {
                    return;
                }
                if (controllerData.pick) {
                    controllerData.pick.ray = controllerData.grabRay;
                }
                if (controllerData.pick && this._isControllerReadyForNearInteraction(controllerData.id)) {
                    this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
                }
                // Near pick pointer event
                if (controllerData.nearInteraction && controllerData.pick && controllerData.pick.hit) {
                    if (!controllerData.nearInteractionTargetMesh) {
                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                        controllerData.nearInteractionTargetMesh = controllerData.meshUnderPointer;
                    }
                }
                else if (controllerData.nearInteractionTargetMesh && controllerData.stalePick) {
                    this._scene.simulatePointerUp(controllerData.stalePick, pointerEventInit);
                    controllerData.nearInteractionTargetMesh = null;
                }
            });
            const grabCheck = (pressed) => {
                if (this._options.enableNearInteractionOnAllControllers ||
                    (xrController.uniqueId === this._attachedController && this._isControllerReadyForNearInteraction(controllerData.id))) {
                    if (controllerData.pick) {
                        controllerData.pick.ray = controllerData.grabRay;
                    }
                    if (pressed && controllerData.pick && controllerData.meshUnderPointer && this._nearGrabPredicate(controllerData.meshUnderPointer)) {
                        controllerData.grabInteraction = true;
                        controllerData.pickedPointVisualCue.isVisible = false;
                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                    }
                    else if (!pressed && controllerData.pick && controllerData.grabInteraction) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        controllerData.grabInteraction = false;
                        controllerData.pickedPointVisualCue.isVisible = true;
                    }
                }
                else {
                    if (pressed && !this._options.enableNearInteractionOnAllControllers && !this._options.disableSwitchOnClick) {
                        this._attachedController = xrController.uniqueId;
                    }
                }
            };
            if (xrController.inputSource.gamepad) {
                const init = (motionController) => {
                    controllerData.squeezeComponent = motionController.getComponent("grasp");
                    if (controllerData.squeezeComponent) {
                        controllerData.onSqueezeButtonChangedObserver = controllerData.squeezeComponent.onButtonStateChangedObservable.add((component) => {
                            if (component.changes.pressed) {
                                const pressed = component.changes.pressed.current;
                                grabCheck(pressed);
                            }
                        });
                    }
                    else {
                        controllerData.selectionComponent = motionController.getMainComponent();
                        controllerData.onButtonChangedObserver = controllerData.selectionComponent.onButtonStateChangedObservable.add((component) => {
                            if (component.changes.pressed) {
                                const pressed = component.changes.pressed.current;
                                grabCheck(pressed);
                            }
                        });
                    }
                };
                if (xrController.motionController) {
                    init(xrController.motionController);
                }
                else {
                    xrController.onMotionControllerInitObservable.add(init);
                }
            }
            else {
                // use the select and squeeze events
                const selectStartListener = (event) => {
                    if (controllerData.xrController &&
                        event.inputSource === controllerData.xrController.inputSource &&
                        controllerData.pick &&
                        this._isControllerReadyForNearInteraction(controllerData.id) &&
                        controllerData.meshUnderPointer &&
                        this._nearGrabPredicate(controllerData.meshUnderPointer)) {
                        controllerData.grabInteraction = true;
                        controllerData.pickedPointVisualCue.isVisible = false;
                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                    }
                };
                const selectEndListener = (event) => {
                    if (controllerData.xrController &&
                        event.inputSource === controllerData.xrController.inputSource &&
                        controllerData.pick &&
                        this._isControllerReadyForNearInteraction(controllerData.id)) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        controllerData.grabInteraction = false;
                        controllerData.pickedPointVisualCue.isVisible = true;
                    }
                };
                controllerData.eventListeners = {
                    selectend: selectEndListener,
                    selectstart: selectStartListener,
                };
                this._xrSessionManager.session.addEventListener("selectstart", selectStartListener);
                this._xrSessionManager.session.addEventListener("selectend", selectEndListener);
            }
        }
        _detachController(xrControllerUniqueId) {
            const controllerData = this._controllers[xrControllerUniqueId];
            if (!controllerData) {
                return;
            }
            if (controllerData.squeezeComponent) {
                if (controllerData.onSqueezeButtonChangedObserver) {
                    controllerData.squeezeComponent.onButtonStateChangedObservable.remove(controllerData.onSqueezeButtonChangedObserver);
                }
            }
            if (controllerData.selectionComponent) {
                if (controllerData.onButtonChangedObserver) {
                    controllerData.selectionComponent.onButtonStateChangedObservable.remove(controllerData.onButtonChangedObserver);
                }
            }
            if (controllerData.onFrameObserver) {
                this._xrSessionManager.onXRFrameObservable.remove(controllerData.onFrameObserver);
            }
            if (controllerData.eventListeners) {
                Object.keys(controllerData.eventListeners).forEach((eventName) => {
                    const func = controllerData.eventListeners && controllerData.eventListeners[eventName];
                    if (func) {
                        this._xrSessionManager.session.removeEventListener(eventName, func);
                    }
                });
            }
            controllerData.touchCollisionMesh.dispose();
            controllerData.pickedPointVisualCue.dispose();
            this._xrSessionManager.runInXRFrame(() => {
                // Fire a pointerup
                const pointerEventInit = {
                    pointerId: controllerData.id,
                    pointerType: "xr-near",
                };
                this._scene.simulatePointerUp(new PickingInfo(), pointerEventInit);
            });
            // remove from the map
            delete this._controllers[xrControllerUniqueId];
            if (this._attachedController === xrControllerUniqueId) {
                // check for other controllers
                const keys = Object.keys(this._controllers);
                if (keys.length) {
                    this._attachedController = keys[0];
                }
                else {
                    this._attachedController = "";
                }
            }
        }
        _generateNewTouchPointMesh() {
            // populate information for near hover, pick and pinch
            const meshCreationScene = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene : this._scene;
            const touchCollisionMesh = CreateSphere("PickSphere", { diameter: 1 }, meshCreationScene);
            touchCollisionMesh.isVisible = false;
            // Generate the material for the touch mesh visuals
            if (this._options.motionControllerOrbMaterial) {
                touchCollisionMesh.material = this._options.motionControllerOrbMaterial;
            }
            else {
                NodeMaterial.ParseFromSnippetAsync("8RUNKL#3", meshCreationScene).then((nodeMaterial) => {
                    touchCollisionMesh.material = nodeMaterial;
                });
            }
            const easingFunction = new QuadraticEase();
            easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
            // Adjust the visual size based off of the size of the touch collision orb.
            // Having the size perfectly match for hover gives a more accurate tell for when the user will start interacting with the target
            // Sizes for other states are somewhat arbitrary, as they are based on what feels nice during an interaction
            const hoverSizeVec = new Vector3(this._controllerPickRadius, this._controllerPickRadius, this._controllerPickRadius);
            const touchSize = this._controllerPickRadius * (4 / 3);
            const touchSizeVec = new Vector3(touchSize, touchSize, touchSize);
            const hydrateTransitionSize = this._controllerPickRadius * (7 / 6);
            const hydrateTransitionSizeVec = new Vector3(hydrateTransitionSize, hydrateTransitionSize, hydrateTransitionSize);
            const touchHoverTransitionSize = this._controllerPickRadius * (4 / 5);
            const touchHoverTransitionSizeVec = new Vector3(touchHoverTransitionSize, touchHoverTransitionSize, touchHoverTransitionSize);
            const hoverTouchTransitionSize = this._controllerPickRadius * (3 / 2);
            const hoverTouchTransitionSizeVec = new Vector3(hoverTouchTransitionSize, hoverTouchTransitionSize, hoverTouchTransitionSize);
            const touchKeys = [
                { frame: 0, value: hoverSizeVec },
                { frame: 10, value: hoverTouchTransitionSizeVec },
                { frame: 18, value: touchSizeVec },
            ];
            const releaseKeys = [
                { frame: 0, value: touchSizeVec },
                { frame: 10, value: touchHoverTransitionSizeVec },
                { frame: 18, value: hoverSizeVec },
            ];
            const hydrateKeys = [
                { frame: 0, value: Vector3.ZeroReadOnly },
                { frame: 12, value: hydrateTransitionSizeVec },
                { frame: 15, value: hoverSizeVec },
            ];
            const dehydrateKeys = [
                { frame: 0, value: hoverSizeVec },
                { frame: 10, value: Vector3.ZeroReadOnly },
                { frame: 15, value: Vector3.ZeroReadOnly },
            ];
            const touchAction = new Animation("touch", "scaling", 60, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const releaseAction = new Animation("release", "scaling", 60, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const hydrateAction = new Animation("hydrate", "scaling", 60, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
            const dehydrateAction = new Animation("dehydrate", "scaling", 60, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
            touchAction.setEasingFunction(easingFunction);
            releaseAction.setEasingFunction(easingFunction);
            hydrateAction.setEasingFunction(easingFunction);
            dehydrateAction.setEasingFunction(easingFunction);
            touchAction.setKeys(touchKeys);
            releaseAction.setKeys(releaseKeys);
            hydrateAction.setKeys(hydrateKeys);
            dehydrateAction.setKeys(dehydrateKeys);
            const touchCollisionMeshFunction = (isTouch) => {
                const action = isTouch ? touchAction : releaseAction;
                meshCreationScene.beginDirectAnimation(touchCollisionMesh, [action], 0, 18, false, 1);
            };
            const hydrateCollisionMeshFunction = (isHydration) => {
                const action = isHydration ? hydrateAction : dehydrateAction;
                if (isHydration) {
                    touchCollisionMesh.isVisible = true;
                }
                meshCreationScene.beginDirectAnimation(touchCollisionMesh, [action], 0, 15, false, 1, () => {
                    if (!isHydration) {
                        touchCollisionMesh.isVisible = false;
                    }
                });
            };
            return { touchCollisionMesh, touchCollisionMeshFunction, hydrateCollisionMeshFunction };
        }
        _pickWithSphere(controllerData, radius, sceneToUse, predicate) {
            const pickingInfo = new PickingInfo();
            pickingInfo.distance = +Infinity;
            if (controllerData.touchCollisionMesh && controllerData.xrController) {
                const position = controllerData.touchCollisionMesh.position;
                const sphere = BoundingSphere.CreateFromCenterAndRadius(position, radius);
                for (let meshIndex = 0; meshIndex < sceneToUse.meshes.length; meshIndex++) {
                    const mesh = sceneToUse.meshes[meshIndex];
                    if (!predicate(mesh) || !this._controllerAvailablePredicate(mesh, controllerData.xrController.uniqueId)) {
                        continue;
                    }
                    const result = WebXRNearInteraction.PickMeshWithSphere(mesh, sphere);
                    if (result && result.hit && result.distance < pickingInfo.distance) {
                        pickingInfo.hit = result.hit;
                        pickingInfo.pickedMesh = mesh;
                        pickingInfo.pickedPoint = result.pickedPoint;
                        pickingInfo.aimTransform = controllerData.xrController.pointer;
                        pickingInfo.gripTransform = controllerData.xrController.grip || null;
                        pickingInfo.originMesh = controllerData.touchCollisionMesh;
                        pickingInfo.distance = result.distance;
                    }
                }
            }
            return pickingInfo;
        }
        /**
         * Picks a mesh with a sphere
         * @param mesh the mesh to pick
         * @param sphere picking sphere in world coordinates
         * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
         * @returns the picking info
         */
        static PickMeshWithSphere(mesh, sphere, skipBoundingInfo = false) {
            const subMeshes = mesh.subMeshes;
            const pi = new PickingInfo();
            const boundingInfo = mesh.getBoundingInfo();
            if (!mesh._generatePointsArray()) {
                return pi;
            }
            if (!mesh.subMeshes || !boundingInfo) {
                return pi;
            }
            if (!skipBoundingInfo && !BoundingSphere.Intersects(boundingInfo.boundingSphere, sphere)) {
                return pi;
            }
            const result = TmpVectors.Vector3[0];
            const tmpVec = TmpVectors.Vector3[1];
            let distance = +Infinity;
            let tmp, tmpDistanceSphereToCenter, tmpDistanceSurfaceToCenter;
            const center = TmpVectors.Vector3[2];
            const worldToMesh = TmpVectors.Matrix[0];
            worldToMesh.copyFrom(mesh.getWorldMatrix());
            worldToMesh.invert();
            Vector3.TransformCoordinatesToRef(sphere.center, worldToMesh, center);
            for (let index = 0; index < subMeshes.length; index++) {
                const subMesh = subMeshes[index];
                subMesh.projectToRef(center, mesh._positions, mesh.getIndices(), tmpVec);
                Vector3.TransformCoordinatesToRef(tmpVec, mesh.getWorldMatrix(), tmpVec);
                tmp = Vector3.Distance(tmpVec, sphere.center);
                // Check for finger inside of mesh
                tmpDistanceSurfaceToCenter = Vector3.Distance(tmpVec, mesh.getAbsolutePosition());
                tmpDistanceSphereToCenter = Vector3.Distance(sphere.center, mesh.getAbsolutePosition());
                if (tmpDistanceSphereToCenter !== -1 && tmpDistanceSurfaceToCenter !== -1 && tmpDistanceSurfaceToCenter > tmpDistanceSphereToCenter) {
                    tmp = 0;
                    tmpVec.copyFrom(sphere.center);
                }
                if (tmp !== -1 && tmp < distance) {
                    distance = tmp;
                    result.copyFrom(tmpVec);
                }
            }
            if (distance < sphere.radius) {
                pi.hit = true;
                pi.distance = distance;
                pi.pickedMesh = mesh;
                pi.pickedPoint = result.clone();
            }
            return pi;
        }
    }
    WebXRNearInteraction._IdCounter = 200;
    /**
     * The module's name
     */
    WebXRNearInteraction.Name = WebXRFeatureName.NEAR_INTERACTION;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the WebXR specs version
     */
    WebXRNearInteraction.Version = 1;
    //Register the plugin
    WebXRFeaturesManager.AddWebXRFeature(WebXRNearInteraction.Name, (xrSessionManager, options) => {
        return () => new WebXRNearInteraction(xrSessionManager, options);
    }, WebXRNearInteraction.Version, true);

    /**
     * Button which can be used to enter a different mode of XR
     */
    class WebXREnterExitUIButton {
        /**
         * Creates a WebXREnterExitUIButton
         * @param element button element
         * @param sessionMode XR initialization session mode
         * @param referenceSpaceType the type of reference space to be used
         */
        constructor(
        /** button element */
        element, 
        /** XR initialization options for the button */
        sessionMode, 
        /** Reference space type */
        referenceSpaceType) {
            this.element = element;
            this.sessionMode = sessionMode;
            this.referenceSpaceType = referenceSpaceType;
        }
        /**
         * Extendable function which can be used to update the button's visuals when the state changes
         * @param activeButton the current active button in the UI
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        update(activeButton) { }
    }
    /**
     * UI to allow the user to enter/exit XR mode
     */
    class WebXREnterExitUI {
        /**
         * Construct a new EnterExit UI class
         *
         * @param _scene babylon scene object to use
         * @param options (read-only) version of the options passed to this UI
         */
        constructor(_scene, 
        /** version of the options passed to this UI */
        options) {
            this._scene = _scene;
            this.options = options;
            this._activeButton = null;
            this._buttons = [];
            /**
             * Fired every time the active button is changed.
             *
             * When xr is entered via a button that launches xr that button will be the callback parameter
             *
             * When exiting xr the callback parameter will be null)
             */
            this.activeButtonChangedObservable = new Observable$1();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this._onSessionGranted = (evt) => {
                // This section is for future reference.
                // As per specs, evt.session.mode should have the supported session mode, but no browser supports it for now.
                // // check if the session granted is the same as the one requested
                // const grantedMode = (evt.session as any).mode;
                // if (grantedMode) {
                //     this._buttons.some((btn, idx) => {
                //         if (btn.sessionMode === grantedMode) {
                //             this._enterXRWithButtonIndex(idx);
                //             return true;
                //         }
                //         return false;
                //     });
                // } else
                if (this._helper) {
                    this._enterXRWithButtonIndex(0);
                }
            };
            this.overlay = document.createElement("div");
            this.overlay.classList.add("xr-button-overlay");
            // prepare for session granted event
            if (!options.ignoreSessionGrantedEvent && navigator.xr) {
                navigator.xr.addEventListener("sessiongranted", this._onSessionGranted);
            }
            // if served over HTTP, warn people.
            // Hopefully the browsers will catch up
            if (typeof window !== "undefined") {
                if (window.location && window.location.protocol === "http:" && window.location.hostname !== "localhost") {
                    Tools.Warn("WebXR can only be served over HTTPS");
                    throw new Error("WebXR can only be served over HTTPS");
                }
            }
            if (options.customButtons) {
                this._buttons = options.customButtons;
            }
            else {
                this.overlay.style.cssText = "z-index:11;position: absolute; right: 20px;bottom: 50px;";
                const sessionMode = options.sessionMode || "immersive-vr";
                const referenceSpaceType = options.referenceSpaceType || "local-floor";
                const url = typeof SVGSVGElement === "undefined"
                    ? "https://cdn.babylonjs.com/Assets/vrButton.png"
                    : "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%222048%22%20height%3D%221152%22%20viewBox%3D%220%200%202048%201152%22%20version%3D%221.1%22%3E%3Cpath%20transform%3D%22rotate%28180%201024%2C576.0000000000001%29%22%20d%3D%22m1109%2C896q17%2C0%2030%2C-12t13%2C-30t-12.5%2C-30.5t-30.5%2C-12.5l-170%2C0q-18%2C0%20-30.5%2C12.5t-12.5%2C30.5t13%2C30t30%2C12l170%2C0zm-85%2C256q59%2C0%20132.5%2C-1.5t154.5%2C-5.5t164.5%2C-11.5t163%2C-20t150%2C-30t124.5%2C-41.5q23%2C-11%2042%2C-24t38%2C-30q27%2C-25%2041%2C-61.5t14%2C-72.5l0%2C-257q0%2C-123%20-47%2C-232t-128%2C-190t-190%2C-128t-232%2C-47l-81%2C0q-37%2C0%20-68.5%2C14t-60.5%2C34.5t-55.5%2C45t-53%2C45t-53%2C34.5t-55.5%2C14t-55.5%2C-14t-53%2C-34.5t-53%2C-45t-55.5%2C-45t-60.5%2C-34.5t-68.5%2C-14l-81%2C0q-123%2C0%20-232%2C47t-190%2C128t-128%2C190t-47%2C232l0%2C257q0%2C68%2038%2C115t97%2C73q54%2C24%20124.5%2C41.5t150%2C30t163%2C20t164.5%2C11.5t154.5%2C5.5t132.5%2C1.5zm939%2C-298q0%2C39%20-24.5%2C67t-58.5%2C42q-54%2C23%20-122%2C39.5t-143.5%2C28t-155.5%2C19t-157%2C11t-148.5%2C5t-129.5%2C1.5q-59%2C0%20-130%2C-1.5t-148%2C-5t-157%2C-11t-155.5%2C-19t-143.5%2C-28t-122%2C-39.5q-34%2C-14%20-58.5%2C-42t-24.5%2C-67l0%2C-257q0%2C-106%2040.5%2C-199t110%2C-162.5t162.5%2C-109.5t199%2C-40l81%2C0q27%2C0%2052%2C14t50%2C34.5t51%2C44.5t55.5%2C44.5t63.5%2C34.5t74%2C14t74%2C-14t63.5%2C-34.5t55.5%2C-44.5t51%2C-44.5t50%2C-34.5t52%2C-14l14%2C0q37%2C0%2070%2C0.5t64.5%2C4.5t63.5%2C12t68%2C23q71%2C30%20128.5%2C78.5t98.5%2C110t63.5%2C133.5t22.5%2C149l0%2C257z%22%20fill%3D%22white%22%20/%3E%3C/svg%3E%0A";
                let css = ".babylonVRicon { color: #868686; border-color: #868686; border-style: solid; margin-left: 10px; height: 50px; width: 80px; background-color: rgba(51,51,51,0.7); background-image: url(" +
                    url +
                    "); background-size: 80%; background-repeat:no-repeat; background-position: center; border: none; outline: none; transition: transform 0.125s ease-out } .babylonVRicon:hover { transform: scale(1.05) } .babylonVRicon:active {background-color: rgba(51,51,51,1) } .babylonVRicon:focus {background-color: rgba(51,51,51,1) }";
                css += '.babylonVRicon.vrdisplaypresenting { background-image: none;} .vrdisplaypresenting::after { content: "EXIT"} .xr-error::after { content: "ERROR"}';
                const style = document.createElement("style");
                style.appendChild(document.createTextNode(css));
                document.getElementsByTagName("head")[0].appendChild(style);
                const hmdBtn = document.createElement("button");
                hmdBtn.className = "babylonVRicon";
                hmdBtn.title = `${sessionMode} - ${referenceSpaceType}`;
                this._buttons.push(new WebXREnterExitUIButton(hmdBtn, sessionMode, referenceSpaceType));
                this._buttons[this._buttons.length - 1].update = function (activeButton) {
                    this.element.style.display = activeButton === null || activeButton === this ? "" : "none";
                    hmdBtn.className = "babylonVRicon" + (activeButton === this ? " vrdisplaypresenting" : "");
                };
                this._updateButtons(null);
            }
            const renderCanvas = _scene.getEngine().getInputElement();
            if (renderCanvas && renderCanvas.parentNode) {
                renderCanvas.parentNode.appendChild(this.overlay);
                _scene.onDisposeObservable.addOnce(() => {
                    this.dispose();
                });
            }
        }
        /**
         * Set the helper to be used with this UI component.
         * The UI is bound to an experience helper. If not provided the UI can still be used but the events should be registered by the developer.
         *
         * @param helper the experience helper to attach
         * @param renderTarget an optional render target (in case it is created outside of the helper scope)
         * @returns a promise that resolves when the ui is ready
         */
        async setHelperAsync(helper, renderTarget) {
            this._helper = helper;
            this._renderTarget = renderTarget;
            const supportedPromises = this._buttons.map((btn) => {
                return helper.sessionManager.isSessionSupportedAsync(btn.sessionMode);
            });
            helper.onStateChangedObservable.add((state) => {
                if (state == WebXRState.NOT_IN_XR) {
                    this._updateButtons(null);
                }
            });
            const results = await Promise.all(supportedPromises);
            results.forEach((supported, i) => {
                if (supported) {
                    this.overlay.appendChild(this._buttons[i].element);
                    this._buttons[i].element.onclick = this._enterXRWithButtonIndex.bind(this, i);
                }
                else {
                    Tools.Warn(`Session mode "${this._buttons[i].sessionMode}" not supported in browser`);
                }
            });
        }
        /**
         * Creates UI to allow the user to enter/exit XR mode
         * @param scene the scene to add the ui to
         * @param helper the xr experience helper to enter/exit xr with
         * @param options options to configure the UI
         * @returns the created ui
         */
        static async CreateAsync(scene, helper, options) {
            const ui = new WebXREnterExitUI(scene, options);
            await ui.setHelperAsync(helper, options.renderTarget || undefined);
            return ui;
        }
        async _enterXRWithButtonIndex(idx = 0) {
            if (this._helper.state == WebXRState.IN_XR) {
                await this._helper.exitXRAsync();
                this._updateButtons(null);
            }
            else if (this._helper.state == WebXRState.NOT_IN_XR) {
                try {
                    await this._helper.enterXRAsync(this._buttons[idx].sessionMode, this._buttons[idx].referenceSpaceType, this._renderTarget, {
                        optionalFeatures: this.options.optionalFeatures,
                        requiredFeatures: this.options.requiredFeatures,
                    });
                    this._updateButtons(this._buttons[idx]);
                }
                catch (e) {
                    // make sure button is visible
                    this._updateButtons(null);
                    const element = this._buttons[idx].element;
                    const prevTitle = element.title;
                    element.title = "Error entering XR session : " + prevTitle;
                    element.classList.add("xr-error");
                    if (this.options.onError) {
                        this.options.onError(e);
                    }
                }
            }
        }
        /**
         * Disposes of the XR UI component
         */
        dispose() {
            const renderCanvas = this._scene.getEngine().getInputElement();
            if (renderCanvas && renderCanvas.parentNode && renderCanvas.parentNode.contains(this.overlay)) {
                renderCanvas.parentNode.removeChild(this.overlay);
            }
            this.activeButtonChangedObservable.clear();
            navigator.xr.removeEventListener("sessiongranted", this._onSessionGranted);
        }
        _updateButtons(activeButton) {
            this._activeButton = activeButton;
            this._buttons.forEach((b) => {
                b.update(this._activeButton);
            });
            this.activeButtonChangedObservable.notifyObservers(this._activeButton);
        }
    }

    Mesh._instancedMeshFactory = (name, mesh) => {
        const instance = new InstancedMesh(name, mesh);
        if (mesh.instancedBuffers) {
            instance.instancedBuffers = {};
            for (const key in mesh.instancedBuffers) {
                instance.instancedBuffers[key] = mesh.instancedBuffers[key];
            }
        }
        return instance;
    };
    /**
     * Creates an instance based on a source mesh.
     */
    class InstancedMesh extends AbstractMesh {
        /**
         * Creates a new InstancedMesh object from the mesh source.
         * @param name defines the name of the instance
         * @param source the mesh to create the instance from
         */
        constructor(name, source) {
            super(name, source.getScene());
            /** @internal */
            this._indexInSourceMeshInstanceArray = -1;
            /** @internal */
            this._distanceToCamera = 0;
            source.addInstance(this);
            this._sourceMesh = source;
            this._unIndexed = source._unIndexed;
            this.position.copyFrom(source.position);
            this.rotation.copyFrom(source.rotation);
            this.scaling.copyFrom(source.scaling);
            if (source.rotationQuaternion) {
                this.rotationQuaternion = source.rotationQuaternion.clone();
            }
            this.animations = source.animations.slice();
            for (const range of source.getAnimationRanges()) {
                if (range != null) {
                    this.createAnimationRange(range.name, range.from, range.to);
                }
            }
            this.infiniteDistance = source.infiniteDistance;
            this.setPivotMatrix(source.getPivotMatrix());
            this.refreshBoundingInfo(true, true);
            this._syncSubMeshes();
        }
        /**
         * Returns the string "InstancedMesh".
         */
        getClassName() {
            return "InstancedMesh";
        }
        /** Gets the list of lights affecting that mesh */
        get lightSources() {
            return this._sourceMesh._lightSources;
        }
        _resyncLightSources() {
            // Do nothing as all the work will be done by source mesh
        }
        _resyncLightSource() {
            // Do nothing as all the work will be done by source mesh
        }
        _removeLightSource() {
            // Do nothing as all the work will be done by source mesh
        }
        // Methods
        /**
         * If the source mesh receives shadows
         */
        get receiveShadows() {
            return this._sourceMesh.receiveShadows;
        }
        set receiveShadows(_value) {
            var _a;
            if (((_a = this._sourceMesh) === null || _a === void 0 ? void 0 : _a.receiveShadows) !== _value) {
                Tools.Warn("Setting receiveShadows on an instanced mesh has no effect");
            }
        }
        /**
         * The material of the source mesh
         */
        get material() {
            return this._sourceMesh.material;
        }
        set material(_value) {
            var _a;
            if (((_a = this._sourceMesh) === null || _a === void 0 ? void 0 : _a.material) !== _value) {
                Tools.Warn("Setting material on an instanced mesh has no effect");
            }
        }
        /**
         * Visibility of the source mesh
         */
        get visibility() {
            return this._sourceMesh.visibility;
        }
        set visibility(_value) {
            var _a;
            if (((_a = this._sourceMesh) === null || _a === void 0 ? void 0 : _a.visibility) !== _value) {
                Tools.Warn("Setting visibility on an instanced mesh has no effect");
            }
        }
        /**
         * Skeleton of the source mesh
         */
        get skeleton() {
            return this._sourceMesh.skeleton;
        }
        set skeleton(_value) {
            var _a;
            if (((_a = this._sourceMesh) === null || _a === void 0 ? void 0 : _a.skeleton) !== _value) {
                Tools.Warn("Setting skeleton on an instanced mesh has no effect");
            }
        }
        /**
         * Rendering ground id of the source mesh
         */
        get renderingGroupId() {
            return this._sourceMesh.renderingGroupId;
        }
        set renderingGroupId(value) {
            if (!this._sourceMesh || value === this._sourceMesh.renderingGroupId) {
                return;
            }
            //no-op with warning
            Logger.Warn("Note - setting renderingGroupId of an instanced mesh has no effect on the scene");
        }
        /**
         * Returns the total number of vertices (integer).
         */
        getTotalVertices() {
            return this._sourceMesh ? this._sourceMesh.getTotalVertices() : 0;
        }
        /**
         * Returns a positive integer : the total number of indices in this mesh geometry.
         * @returns the number of indices or zero if the mesh has no geometry.
         */
        getTotalIndices() {
            return this._sourceMesh.getTotalIndices();
        }
        /**
         * The source mesh of the instance
         */
        get sourceMesh() {
            return this._sourceMesh;
        }
        /**
         * Creates a new InstancedMesh object from the mesh model.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
         * @param name defines the name of the new instance
         * @returns a new InstancedMesh
         */
        createInstance(name) {
            return this._sourceMesh.createInstance(name);
        }
        /**
         * Is this node ready to be used/rendered
         * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
         * @returns {boolean} is it ready
         */
        isReady(completeCheck = false) {
            return this._sourceMesh.isReady(completeCheck, true);
        }
        /**
         * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
         * @param kind kind of verticies to retrieve (eg. positions, normals, uvs, etc.)
         * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
         * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
         * @returns a float array or a Float32Array of the requested kind of data : positions, normals, uvs, etc.
         */
        getVerticesData(kind, copyWhenShared, forceCopy) {
            return this._sourceMesh.getVerticesData(kind, copyWhenShared, forceCopy);
        }
        /**
         * Sets the vertex data of the mesh geometry for the requested `kind`.
         * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
         * The `data` are either a numeric array either a Float32Array.
         * The parameter `updatable` is passed as is to the underlying Geometry object constructor (if initially none) or updater.
         * The parameter `stride` is an optional positive integer, it is usually automatically deducted from the `kind` (3 for positions or normals, 2 for UV, etc).
         * Note that a new underlying VertexBuffer object is created each call.
         * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
         *
         * Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         *
         * Returns the Mesh.
         * @param kind
         * @param data
         * @param updatable
         * @param stride
         */
        setVerticesData(kind, data, updatable, stride) {
            if (this.sourceMesh) {
                this.sourceMesh.setVerticesData(kind, data, updatable, stride);
            }
            return this.sourceMesh;
        }
        /**
         * Updates the existing vertex data of the mesh geometry for the requested `kind`.
         * If the mesh has no geometry, it is simply returned as it is.
         * The `data` are either a numeric array either a Float32Array.
         * No new underlying VertexBuffer object is created.
         * If the `kind` is the `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
         * If the parameter `makeItUnique` is true, a new global geometry is created from this positions and is set to the mesh.
         *
         * Possible `kind` values :
         * - VertexBuffer.PositionKind
         * - VertexBuffer.UVKind
         * - VertexBuffer.UV2Kind
         * - VertexBuffer.UV3Kind
         * - VertexBuffer.UV4Kind
         * - VertexBuffer.UV5Kind
         * - VertexBuffer.UV6Kind
         * - VertexBuffer.ColorKind
         * - VertexBuffer.MatricesIndicesKind
         * - VertexBuffer.MatricesIndicesExtraKind
         * - VertexBuffer.MatricesWeightsKind
         * - VertexBuffer.MatricesWeightsExtraKind
         *
         * Returns the Mesh.
         * @param kind
         * @param data
         * @param updateExtends
         * @param makeItUnique
         */
        updateVerticesData(kind, data, updateExtends, makeItUnique) {
            if (this.sourceMesh) {
                this.sourceMesh.updateVerticesData(kind, data, updateExtends, makeItUnique);
            }
            return this.sourceMesh;
        }
        /**
         * Sets the mesh indices.
         * Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array).
         * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
         * This method creates a new index buffer each call.
         * Returns the Mesh.
         * @param indices
         * @param totalVertices
         */
        setIndices(indices, totalVertices = null) {
            if (this.sourceMesh) {
                this.sourceMesh.setIndices(indices, totalVertices);
            }
            return this.sourceMesh;
        }
        /**
         * Boolean : True if the mesh owns the requested kind of data.
         * @param kind
         */
        isVerticesDataPresent(kind) {
            return this._sourceMesh.isVerticesDataPresent(kind);
        }
        /**
         * Returns an array of indices (IndicesArray).
         */
        getIndices() {
            return this._sourceMesh.getIndices();
        }
        get _positions() {
            return this._sourceMesh._positions;
        }
        /**
         * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
         * This means the mesh underlying bounding box and sphere are recomputed.
         * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
         * @param applyMorph  defines whether to apply the morph target before computing the bounding info
         * @returns the current mesh
         */
        refreshBoundingInfo(applySkeleton = false, applyMorph = false) {
            if (this.hasBoundingInfo && this.getBoundingInfo().isLocked) {
                return this;
            }
            const bias = this._sourceMesh.geometry ? this._sourceMesh.geometry.boundingBias : null;
            this._refreshBoundingInfo(this._sourceMesh._getPositionData(applySkeleton, applyMorph), bias);
            return this;
        }
        /** @internal */
        _preActivate() {
            if (this._currentLOD) {
                this._currentLOD._preActivate();
            }
            return this;
        }
        /**
         * @internal
         */
        _activate(renderId, intermediateRendering) {
            super._activate(renderId, intermediateRendering);
            if (!this._sourceMesh.subMeshes) {
                Logger.Warn("Instances should only be created for meshes with geometry.");
            }
            if (this._currentLOD) {
                const differentSign = this._currentLOD._getWorldMatrixDeterminant() >= 0 !== this._getWorldMatrixDeterminant() >= 0;
                if (differentSign) {
                    this._internalAbstractMeshDataInfo._actAsRegularMesh = true;
                    return true;
                }
                this._internalAbstractMeshDataInfo._actAsRegularMesh = false;
                this._currentLOD._registerInstanceForRenderId(this, renderId);
                if (intermediateRendering) {
                    if (!this._currentLOD._internalAbstractMeshDataInfo._isActiveIntermediate) {
                        this._currentLOD._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = true;
                        return true;
                    }
                }
                else {
                    if (!this._currentLOD._internalAbstractMeshDataInfo._isActive) {
                        this._currentLOD._internalAbstractMeshDataInfo._onlyForInstances = true;
                        return true;
                    }
                }
            }
            return false;
        }
        /** @internal */
        _postActivate() {
            if (this._sourceMesh.edgesShareWithInstances && this._sourceMesh._edgesRenderer && this._sourceMesh._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup) {
                // we are using the edge renderer of the source mesh
                this._sourceMesh._renderingGroup._edgesRenderers.pushNoDuplicate(this._sourceMesh._edgesRenderer);
                this._sourceMesh._edgesRenderer.customInstances.push(this.getWorldMatrix());
            }
            else if (this._edgesRenderer && this._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup) {
                // we are using the edge renderer defined for this instance
                this._sourceMesh._renderingGroup._edgesRenderers.push(this._edgesRenderer);
            }
        }
        getWorldMatrix() {
            if (this._currentLOD && this._currentLOD.billboardMode !== TransformNode.BILLBOARDMODE_NONE && this._currentLOD._masterMesh !== this) {
                if (!this._billboardWorldMatrix) {
                    this._billboardWorldMatrix = new Matrix();
                }
                const tempMaster = this._currentLOD._masterMesh;
                this._currentLOD._masterMesh = this;
                TmpVectors.Vector3[7].copyFrom(this._currentLOD.position);
                this._currentLOD.position.set(0, 0, 0);
                this._billboardWorldMatrix.copyFrom(this._currentLOD.computeWorldMatrix(true));
                this._currentLOD.position.copyFrom(TmpVectors.Vector3[7]);
                this._currentLOD._masterMesh = tempMaster;
                return this._billboardWorldMatrix;
            }
            return super.getWorldMatrix();
        }
        get isAnInstance() {
            return true;
        }
        /**
         * Returns the current associated LOD AbstractMesh.
         * @param camera
         */
        getLOD(camera) {
            if (!camera) {
                return this;
            }
            const sourceMeshLODLevels = this.sourceMesh.getLODLevels();
            if (!sourceMeshLODLevels || sourceMeshLODLevels.length === 0) {
                this._currentLOD = this.sourceMesh;
            }
            else {
                const boundingInfo = this.getBoundingInfo();
                this._currentLOD = this.sourceMesh.getLOD(camera, boundingInfo.boundingSphere);
            }
            return this._currentLOD;
        }
        /**
         * @internal
         */
        _preActivateForIntermediateRendering(renderId) {
            return this.sourceMesh._preActivateForIntermediateRendering(renderId);
        }
        /** @internal */
        _syncSubMeshes() {
            this.releaseSubMeshes();
            if (this._sourceMesh.subMeshes) {
                for (let index = 0; index < this._sourceMesh.subMeshes.length; index++) {
                    this._sourceMesh.subMeshes[index].clone(this, this._sourceMesh);
                }
            }
            return this;
        }
        /** @internal */
        _generatePointsArray() {
            return this._sourceMesh._generatePointsArray();
        }
        /** @internal */
        _updateBoundingInfo() {
            if (this.hasBoundingInfo) {
                this.getBoundingInfo().update(this.worldMatrixFromCache);
            }
            else {
                this.buildBoundingInfo(this.absolutePosition, this.absolutePosition, this.worldMatrixFromCache);
            }
            this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
            return this;
        }
        /**
         * Creates a new InstancedMesh from the current mesh.
         *
         * Returns the clone.
         * @param name the cloned mesh name
         * @param newParent the optional Node to parent the clone to.
         * @param doNotCloneChildren if `true` the model children aren't cloned.
         * @param newSourceMesh if set this mesh will be used as the source mesh instead of ths instance's one
         * @returns the clone
         */
        clone(name, newParent = null, doNotCloneChildren, newSourceMesh) {
            const result = (newSourceMesh || this._sourceMesh).createInstance(name);
            // Deep copy
            DeepCopier.DeepCopy(this, result, [
                "name",
                "subMeshes",
                "uniqueId",
                "parent",
                "lightSources",
                "receiveShadows",
                "material",
                "visibility",
                "skeleton",
                "sourceMesh",
                "isAnInstance",
                "facetNb",
                "isFacetDataEnabled",
                "isBlocked",
                "useBones",
                "hasInstances",
                "collider",
                "edgesRenderer",
                "forward",
                "up",
                "right",
                "absolutePosition",
                "absoluteScaling",
                "absoluteRotationQuaternion",
                "isWorldMatrixFrozen",
                "nonUniformScaling",
                "behaviors",
                "worldMatrixFromCache",
                "hasThinInstances",
                "hasBoundingInfo",
            ], []);
            // Bounding info
            this.refreshBoundingInfo();
            // Parent
            if (newParent) {
                result.parent = newParent;
            }
            if (!doNotCloneChildren) {
                // Children
                for (let index = 0; index < this.getScene().meshes.length; index++) {
                    const mesh = this.getScene().meshes[index];
                    if (mesh.parent === this) {
                        mesh.clone(mesh.name, result);
                    }
                }
            }
            result.computeWorldMatrix(true);
            this.onClonedObservable.notifyObservers(result);
            return result;
        }
        /**
         * Disposes the InstancedMesh.
         * Returns nothing.
         * @param doNotRecurse
         * @param disposeMaterialAndTextures
         */
        dispose(doNotRecurse, disposeMaterialAndTextures = false) {
            // Remove from mesh
            this._sourceMesh.removeInstance(this);
            super.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        /**
         * @internal
         */
        _serializeAsParent(serializationObject) {
            super._serializeAsParent(serializationObject);
            serializationObject.parentId = this._sourceMesh.uniqueId;
            serializationObject.parentInstanceIndex = this._indexInSourceMeshInstanceArray;
        }
        /**
         * Instantiate (when possible) or clone that node with its hierarchy
         * @param newParent defines the new parent to use for the instance (or clone)
         * @param options defines options to configure how copy is done
         * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
         * @param options.newSourcedMesh newSourcedMesh the new source mesh for the instance (or clone)
         * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
         * @returns an instance (or a clone) of the current node with its hierarchy
         */
        instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
            const clone = this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true, options && options.newSourcedMesh);
            if (clone) {
                if (onNewNodeCreated) {
                    onNewNodeCreated(this, clone);
                }
            }
            for (const child of this.getChildTransformNodes(true)) {
                child.instantiateHierarchy(clone, options, onNewNodeCreated);
            }
            return clone;
        }
    }
    Mesh.prototype.registerInstancedBuffer = function (kind, stride) {
        var _a, _b;
        // Remove existing one
        (_b = (_a = this._userInstancedBuffersStorage) === null || _a === void 0 ? void 0 : _a.vertexBuffers[kind]) === null || _b === void 0 ? void 0 : _b.dispose();
        // Creates the instancedBuffer field if not present
        if (!this.instancedBuffers) {
            this.instancedBuffers = {};
            for (const instance of this.instances) {
                instance.instancedBuffers = {};
            }
            if (!this._userInstancedBuffersStorage) {
                this._userInstancedBuffersStorage = {
                    data: {},
                    vertexBuffers: {},
                    strides: {},
                    sizes: {},
                    vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : undefined,
                };
            }
        }
        // Creates an empty property for this kind
        this.instancedBuffers[kind] = null;
        this._userInstancedBuffersStorage.strides[kind] = stride;
        this._userInstancedBuffersStorage.sizes[kind] = stride * 32; // Initial size
        this._userInstancedBuffersStorage.data[kind] = new Float32Array(this._userInstancedBuffersStorage.sizes[kind]);
        this._userInstancedBuffersStorage.vertexBuffers[kind] = new VertexBuffer(this.getEngine(), this._userInstancedBuffersStorage.data[kind], kind, true, false, stride, true);
        for (const instance of this.instances) {
            instance.instancedBuffers[kind] = null;
        }
        this._invalidateInstanceVertexArrayObject();
        this._markSubMeshesAsAttributesDirty();
    };
    Mesh.prototype._processInstancedBuffers = function (visibleInstances, renderSelf) {
        const instanceCount = visibleInstances ? visibleInstances.length : 0;
        for (const kind in this.instancedBuffers) {
            let size = this._userInstancedBuffersStorage.sizes[kind];
            const stride = this._userInstancedBuffersStorage.strides[kind];
            // Resize if required
            const expectedSize = (instanceCount + 1) * stride;
            while (size < expectedSize) {
                size *= 2;
            }
            if (this._userInstancedBuffersStorage.data[kind].length != size) {
                this._userInstancedBuffersStorage.data[kind] = new Float32Array(size);
                this._userInstancedBuffersStorage.sizes[kind] = size;
                if (this._userInstancedBuffersStorage.vertexBuffers[kind]) {
                    this._userInstancedBuffersStorage.vertexBuffers[kind].dispose();
                    this._userInstancedBuffersStorage.vertexBuffers[kind] = null;
                }
            }
            const data = this._userInstancedBuffersStorage.data[kind];
            // Update data buffer
            let offset = 0;
            if (renderSelf) {
                const value = this.instancedBuffers[kind];
                if (value.toArray) {
                    value.toArray(data, offset);
                }
                else if (value.copyToArray) {
                    value.copyToArray(data, offset);
                }
                else {
                    data[offset] = value;
                }
                offset += stride;
            }
            for (let instanceIndex = 0; instanceIndex < instanceCount; instanceIndex++) {
                const instance = visibleInstances[instanceIndex];
                const value = instance.instancedBuffers[kind];
                if (value.toArray) {
                    value.toArray(data, offset);
                }
                else if (value.copyToArray) {
                    value.copyToArray(data, offset);
                }
                else {
                    data[offset] = value;
                }
                offset += stride;
            }
            // Update vertex buffer
            if (!this._userInstancedBuffersStorage.vertexBuffers[kind]) {
                this._userInstancedBuffersStorage.vertexBuffers[kind] = new VertexBuffer(this.getEngine(), this._userInstancedBuffersStorage.data[kind], kind, true, false, stride, true);
                this._invalidateInstanceVertexArrayObject();
            }
            else {
                this._userInstancedBuffersStorage.vertexBuffers[kind].updateDirectly(data, 0);
            }
        }
    };
    Mesh.prototype._invalidateInstanceVertexArrayObject = function () {
        if (!this._userInstancedBuffersStorage || this._userInstancedBuffersStorage.vertexArrayObjects === undefined) {
            return;
        }
        for (const kind in this._userInstancedBuffersStorage.vertexArrayObjects) {
            this.getEngine().releaseVertexArrayObject(this._userInstancedBuffersStorage.vertexArrayObjects[kind]);
        }
        this._userInstancedBuffersStorage.vertexArrayObjects = {};
    };
    Mesh.prototype._disposeInstanceSpecificData = function () {
        if (this._instanceDataStorage.instancesBuffer) {
            this._instanceDataStorage.instancesBuffer.dispose();
            this._instanceDataStorage.instancesBuffer = null;
        }
        while (this.instances.length) {
            this.instances[0].dispose();
        }
        for (const kind in this.instancedBuffers) {
            if (this._userInstancedBuffersStorage.vertexBuffers[kind]) {
                this._userInstancedBuffersStorage.vertexBuffers[kind].dispose();
            }
        }
        this._invalidateInstanceVertexArrayObject();
        this.instancedBuffers = {};
    };

    const onCreatedEffectParameters$3 = { effect: null, subMesh: null };
    /**
     * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
     *
     * This returned material effects how the mesh will look based on the code in the shaders.
     *
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/shaders/shaderMaterial
     */
    class ShaderMaterial extends PushMaterial {
        /**
         * Instantiate a new shader material.
         * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
         * This returned material effects how the mesh will look based on the code in the shaders.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/shaders/shaderMaterial
         * @param name Define the name of the material in the scene
         * @param scene Define the scene the material belongs to
         * @param shaderPath Defines  the route to the shader code in one of three ways:
         *  * object: \{ vertex: "custom", fragment: "custom" \}, used with Effect.ShadersStore["customVertexShader"] and Effect.ShadersStore["customFragmentShader"]
         *  * object: \{ vertexElement: "vertexShaderCode", fragmentElement: "fragmentShaderCode" \}, used with shader code in script tags
         *  * object: \{ vertexSource: "vertex shader code string", fragmentSource: "fragment shader code string" \} using with strings containing the shaders code
         *  * string: "./COMMON_NAME", used with external files COMMON_NAME.vertex.fx and COMMON_NAME.fragment.fx in index.html folder.
         * @param options Define the options used to create the shader
         * @param storeEffectOnSubMeshes true to store effect on submeshes, false to store the effect directly in the material class.
         */
        constructor(name, scene, shaderPath, options = {}, storeEffectOnSubMeshes = true) {
            super(name, scene, storeEffectOnSubMeshes);
            this._textures = {};
            this._textureArrays = {};
            this._externalTextures = {};
            this._floats = {};
            this._ints = {};
            this._uints = {};
            this._floatsArrays = {};
            this._colors3 = {};
            this._colors3Arrays = {};
            this._colors4 = {};
            this._colors4Arrays = {};
            this._vectors2 = {};
            this._vectors3 = {};
            this._vectors4 = {};
            this._quaternions = {};
            this._quaternionsArrays = {};
            this._matrices = {};
            this._matrixArrays = {};
            this._matrices3x3 = {};
            this._matrices2x2 = {};
            this._vectors2Arrays = {};
            this._vectors3Arrays = {};
            this._vectors4Arrays = {};
            this._uniformBuffers = {};
            this._textureSamplers = {};
            this._storageBuffers = {};
            this._cachedWorldViewMatrix = new Matrix();
            this._cachedWorldViewProjectionMatrix = new Matrix();
            this._multiview = false;
            /**
             * @internal
             */
            this._materialHelperNeedsPreviousMatrices = false;
            this._shaderPath = shaderPath;
            this._options = Object.assign({ needAlphaBlending: false, needAlphaTesting: false, attributes: ["position", "normal", "uv"], uniforms: ["worldViewProjection"], uniformBuffers: [], samplers: [], externalTextures: [], samplerObjects: [], storageBuffers: [], defines: [], useClipPlane: false }, options);
        }
        /**
         * Gets the shader path used to define the shader code
         * It can be modified to trigger a new compilation
         */
        get shaderPath() {
            return this._shaderPath;
        }
        /**
         * Sets the shader path used to define the shader code
         * It can be modified to trigger a new compilation
         */
        set shaderPath(shaderPath) {
            this._shaderPath = shaderPath;
        }
        /**
         * Gets the options used to compile the shader.
         * They can be modified to trigger a new compilation
         */
        get options() {
            return this._options;
        }
        /**
         * is multiview set to true?
         */
        get isMultiview() {
            return this._multiview;
        }
        /**
         * Gets the current class name of the material e.g. "ShaderMaterial"
         * Mainly use in serialization.
         * @returns the class name
         */
        getClassName() {
            return "ShaderMaterial";
        }
        /**
         * Specifies if the material will require alpha blending
         * @returns a boolean specifying if alpha blending is needed
         */
        needAlphaBlending() {
            return this.alpha < 1.0 || this._options.needAlphaBlending;
        }
        /**
         * Specifies if this material should be rendered in alpha test mode
         * @returns a boolean specifying if an alpha test is needed.
         */
        needAlphaTesting() {
            return this._options.needAlphaTesting;
        }
        _checkUniform(uniformName) {
            if (this._options.uniforms.indexOf(uniformName) === -1) {
                this._options.uniforms.push(uniformName);
            }
        }
        /**
         * Set a texture in the shader.
         * @param name Define the name of the uniform samplers as defined in the shader
         * @param texture Define the texture to bind to this sampler
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setTexture(name, texture) {
            if (this._options.samplers.indexOf(name) === -1) {
                this._options.samplers.push(name);
            }
            this._textures[name] = texture;
            return this;
        }
        /**
         * Set a texture array in the shader.
         * @param name Define the name of the uniform sampler array as defined in the shader
         * @param textures Define the list of textures to bind to this sampler
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setTextureArray(name, textures) {
            if (this._options.samplers.indexOf(name) === -1) {
                this._options.samplers.push(name);
            }
            this._checkUniform(name);
            this._textureArrays[name] = textures;
            return this;
        }
        /**
         * Set an internal texture in the shader.
         * @param name Define the name of the uniform samplers as defined in the shader
         * @param texture Define the texture to bind to this sampler
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setExternalTexture(name, texture) {
            if (this._options.externalTextures.indexOf(name) === -1) {
                this._options.externalTextures.push(name);
            }
            this._externalTextures[name] = texture;
            return this;
        }
        /**
         * Set a float in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setFloat(name, value) {
            this._checkUniform(name);
            this._floats[name] = value;
            return this;
        }
        /**
         * Set a int in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setInt(name, value) {
            this._checkUniform(name);
            this._ints[name] = value;
            return this;
        }
        /**
         * Set a unsigned int in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setUInt(name, value) {
            this._checkUniform(name);
            this._uints[name] = value;
            return this;
        }
        /**
         * Set an array of floats in the shader.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setFloats(name, value) {
            this._checkUniform(name);
            this._floatsArrays[name] = value;
            return this;
        }
        /**
         * Set a vec3 in the shader from a Color3.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setColor3(name, value) {
            this._checkUniform(name);
            this._colors3[name] = value;
            return this;
        }
        /**
         * Set a vec3 array in the shader from a Color3 array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setColor3Array(name, value) {
            this._checkUniform(name);
            this._colors3Arrays[name] = value.reduce((arr, color) => {
                color.toArray(arr, arr.length);
                return arr;
            }, []);
            return this;
        }
        /**
         * Set a vec4 in the shader from a Color4.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setColor4(name, value) {
            this._checkUniform(name);
            this._colors4[name] = value;
            return this;
        }
        /**
         * Set a vec4 array in the shader from a Color4 array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setColor4Array(name, value) {
            this._checkUniform(name);
            this._colors4Arrays[name] = value.reduce((arr, color) => {
                color.toArray(arr, arr.length);
                return arr;
            }, []);
            return this;
        }
        /**
         * Set a vec2 in the shader from a Vector2.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setVector2(name, value) {
            this._checkUniform(name);
            this._vectors2[name] = value;
            return this;
        }
        /**
         * Set a vec3 in the shader from a Vector3.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setVector3(name, value) {
            this._checkUniform(name);
            this._vectors3[name] = value;
            return this;
        }
        /**
         * Set a vec4 in the shader from a Vector4.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setVector4(name, value) {
            this._checkUniform(name);
            this._vectors4[name] = value;
            return this;
        }
        /**
         * Set a vec4 in the shader from a Quaternion.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setQuaternion(name, value) {
            this._checkUniform(name);
            this._quaternions[name] = value;
            return this;
        }
        /**
         * Set a vec4 array in the shader from a Quaternion array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setQuaternionArray(name, value) {
            this._checkUniform(name);
            this._quaternionsArrays[name] = value.reduce((arr, quaternion) => {
                quaternion.toArray(arr, arr.length);
                return arr;
            }, []);
            return this;
        }
        /**
         * Set a mat4 in the shader from a Matrix.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setMatrix(name, value) {
            this._checkUniform(name);
            this._matrices[name] = value;
            return this;
        }
        /**
         * Set a float32Array in the shader from a matrix array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setMatrices(name, value) {
            this._checkUniform(name);
            const float32Array = new Float32Array(value.length * 16);
            for (let index = 0; index < value.length; index++) {
                const matrix = value[index];
                matrix.copyToArray(float32Array, index * 16);
            }
            this._matrixArrays[name] = float32Array;
            return this;
        }
        /**
         * Set a mat3 in the shader from a Float32Array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setMatrix3x3(name, value) {
            this._checkUniform(name);
            this._matrices3x3[name] = value;
            return this;
        }
        /**
         * Set a mat2 in the shader from a Float32Array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setMatrix2x2(name, value) {
            this._checkUniform(name);
            this._matrices2x2[name] = value;
            return this;
        }
        /**
         * Set a vec2 array in the shader from a number array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setArray2(name, value) {
            this._checkUniform(name);
            this._vectors2Arrays[name] = value;
            return this;
        }
        /**
         * Set a vec3 array in the shader from a number array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setArray3(name, value) {
            this._checkUniform(name);
            this._vectors3Arrays[name] = value;
            return this;
        }
        /**
         * Set a vec4 array in the shader from a number array.
         * @param name Define the name of the uniform as defined in the shader
         * @param value Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setArray4(name, value) {
            this._checkUniform(name);
            this._vectors4Arrays[name] = value;
            return this;
        }
        /**
         * Set a uniform buffer in the shader
         * @param name Define the name of the uniform as defined in the shader
         * @param buffer Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setUniformBuffer(name, buffer) {
            if (this._options.uniformBuffers.indexOf(name) === -1) {
                this._options.uniformBuffers.push(name);
            }
            this._uniformBuffers[name] = buffer;
            return this;
        }
        /**
         * Set a texture sampler in the shader
         * @param name Define the name of the uniform as defined in the shader
         * @param sampler Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setTextureSampler(name, sampler) {
            if (this._options.samplerObjects.indexOf(name) === -1) {
                this._options.samplerObjects.push(name);
            }
            this._textureSamplers[name] = sampler;
            return this;
        }
        /**
         * Set a storage buffer in the shader
         * @param name Define the name of the storage buffer as defined in the shader
         * @param buffer Define the value to give to the uniform
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setStorageBuffer(name, buffer) {
            if (this._options.storageBuffers.indexOf(name) === -1) {
                this._options.storageBuffers.push(name);
            }
            this._storageBuffers[name] = buffer;
            return this;
        }
        /**
         * Adds, removes, or replaces the specified shader define and value.
         * * setDefine("MY_DEFINE", true); // enables a boolean define
         * * setDefine("MY_DEFINE", "0.5"); // adds "#define MY_DEFINE 0.5" to the shader (or sets and replaces the value of any existing define with that name)
         * * setDefine("MY_DEFINE", false); // disables and removes the define
         * Note if the active defines do change, the shader will be recompiled and this can be expensive.
         * @param define the define name e.g., "OUTPUT_TO_SRGB" or "#define OUTPUT_TO_SRGB". If the define was passed into the constructor already, the version used should match that, and in either case, it should not include any appended value.
         * @param value either the value of the define (e.g. a numerical value) or for booleans, true if the define should be enabled or false if it should be disabled
         * @returns the material itself allowing "fluent" like uniform updates
         */
        setDefine(define, value) {
            // First remove any existing define with this name.
            const defineName = define.trimEnd() + " ";
            const existingDefineIdx = this.options.defines.findIndex((x) => x === define || x.startsWith(defineName));
            if (existingDefineIdx >= 0) {
                this.options.defines.splice(existingDefineIdx, 1);
            }
            // Then add the new define value. (If it's a boolean value and false, don't add it.)
            if (typeof value !== "boolean" || value) {
                this.options.defines.push(defineName + value);
            }
            return this;
        }
        /**
         * Specifies that the submesh is ready to be used
         * @param mesh defines the mesh to check
         * @param subMesh defines which submesh to check
         * @param useInstances specifies that instances should be used
         * @returns a boolean indicating that the submesh is ready or not
         */
        isReadyForSubMesh(mesh, subMesh, useInstances) {
            return this.isReady(mesh, useInstances, subMesh);
        }
        /**
         * Checks if the material is ready to render the requested mesh
         * @param mesh Define the mesh to render
         * @param useInstances Define whether or not the material is used with instances
         * @param subMesh defines which submesh to render
         * @returns true if ready, otherwise false
         */
        isReady(mesh, useInstances, subMesh) {
            var _a, _b, _c, _d;
            const storeEffectOnSubMeshes = subMesh && this._storeEffectOnSubMeshes;
            if (this.isFrozen) {
                if (storeEffectOnSubMeshes) {
                    if (subMesh.effect && subMesh.effect._wasPreviouslyReady) {
                        return true;
                    }
                }
                else {
                    const effect = this._drawWrapper.effect;
                    if (effect && effect._wasPreviouslyReady && effect._wasPreviouslyUsingInstances === useInstances) {
                        return true;
                    }
                }
            }
            const scene = this.getScene();
            const engine = scene.getEngine();
            // Instances
            const defines = [];
            const attribs = [];
            const fallbacks = new EffectFallbacks();
            let shaderName = this._shaderPath, uniforms = this._options.uniforms, uniformBuffers = this._options.uniformBuffers, samplers = this._options.samplers;
            // global multiview
            if (engine.getCaps().multiview && scene.activeCamera && scene.activeCamera.outputRenderTarget && scene.activeCamera.outputRenderTarget.getViewCount() > 1) {
                this._multiview = true;
                defines.push("#define MULTIVIEW");
                if (this._options.uniforms.indexOf("viewProjection") !== -1 && this._options.uniforms.indexOf("viewProjectionR") === -1) {
                    this._options.uniforms.push("viewProjectionR");
                }
            }
            for (let index = 0; index < this._options.defines.length; index++) {
                const defineToAdd = this._options.defines[index].indexOf("#define") === 0 ? this._options.defines[index] : `#define ${this._options.defines[index]}`;
                defines.push(defineToAdd);
            }
            for (let index = 0; index < this._options.attributes.length; index++) {
                attribs.push(this._options.attributes[index]);
            }
            if (mesh && mesh.isVerticesDataPresent(VertexBuffer.ColorKind)) {
                attribs.push(VertexBuffer.ColorKind);
                defines.push("#define VERTEXCOLOR");
            }
            if (useInstances) {
                defines.push("#define INSTANCES");
                MaterialHelper.PushAttributesForInstances(attribs, this._materialHelperNeedsPreviousMatrices);
                if (mesh === null || mesh === void 0 ? void 0 : mesh.hasThinInstances) {
                    defines.push("#define THIN_INSTANCES");
                    if (mesh && mesh.isVerticesDataPresent(VertexBuffer.ColorInstanceKind)) {
                        attribs.push(VertexBuffer.ColorInstanceKind);
                        defines.push("#define INSTANCESCOLOR");
                    }
                }
            }
            // Bones
            if (mesh && mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
                attribs.push(VertexBuffer.MatricesIndicesKind);
                attribs.push(VertexBuffer.MatricesWeightsKind);
                if (mesh.numBoneInfluencers > 4) {
                    attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                    attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                }
                const skeleton = mesh.skeleton;
                defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                fallbacks.addCPUSkinningFallback(0, mesh);
                if (skeleton.isUsingTextureForMatrices) {
                    defines.push("#define BONETEXTURE");
                    if (this._options.uniforms.indexOf("boneTextureWidth") === -1) {
                        this._options.uniforms.push("boneTextureWidth");
                    }
                    if (this._options.samplers.indexOf("boneSampler") === -1) {
                        this._options.samplers.push("boneSampler");
                    }
                }
                else {
                    defines.push("#define BonesPerMesh " + (skeleton.bones.length + 1));
                    if (this._options.uniforms.indexOf("mBones") === -1) {
                        this._options.uniforms.push("mBones");
                    }
                }
            }
            else {
                defines.push("#define NUM_BONE_INFLUENCERS 0");
            }
            // Morph
            let numInfluencers = 0;
            const manager = mesh ? mesh.morphTargetManager : null;
            if (manager) {
                const uv = manager.supportsUVs && defines.indexOf("#define UV1") !== -1;
                const tangent = manager.supportsTangents && defines.indexOf("#define TANGENT") !== -1;
                const normal = manager.supportsNormals && defines.indexOf("#define NORMAL") !== -1;
                numInfluencers = manager.numInfluencers;
                if (uv) {
                    defines.push("#define MORPHTARGETS_UV");
                }
                if (tangent) {
                    defines.push("#define MORPHTARGETS_TANGENT");
                }
                if (normal) {
                    defines.push("#define MORPHTARGETS_NORMAL");
                }
                if (numInfluencers > 0) {
                    defines.push("#define MORPHTARGETS");
                }
                if (manager.isUsingTextureForTargets) {
                    defines.push("#define MORPHTARGETS_TEXTURE");
                    if (this._options.uniforms.indexOf("morphTargetTextureIndices") === -1) {
                        this._options.uniforms.push("morphTargetTextureIndices");
                    }
                    if (this._options.samplers.indexOf("morphTargets") === -1) {
                        this._options.samplers.push("morphTargets");
                    }
                }
                defines.push("#define NUM_MORPH_INFLUENCERS " + numInfluencers);
                for (let index = 0; index < numInfluencers; index++) {
                    attribs.push(VertexBuffer.PositionKind + index);
                    if (normal) {
                        attribs.push(VertexBuffer.NormalKind + index);
                    }
                    if (tangent) {
                        attribs.push(VertexBuffer.TangentKind + index);
                    }
                    if (uv) {
                        attribs.push(VertexBuffer.UVKind + "_" + index);
                    }
                }
                if (numInfluencers > 0) {
                    uniforms = uniforms.slice();
                    uniforms.push("morphTargetInfluences");
                    uniforms.push("morphTargetTextureInfo");
                    uniforms.push("morphTargetTextureIndices");
                }
            }
            else {
                defines.push("#define NUM_MORPH_INFLUENCERS 0");
            }
            // Baked Vertex Animation
            if (mesh) {
                const bvaManager = mesh.bakedVertexAnimationManager;
                if (bvaManager && bvaManager.isEnabled) {
                    defines.push("#define BAKED_VERTEX_ANIMATION_TEXTURE");
                    if (this._options.uniforms.indexOf("bakedVertexAnimationSettings") === -1) {
                        this._options.uniforms.push("bakedVertexAnimationSettings");
                    }
                    if (this._options.uniforms.indexOf("bakedVertexAnimationTextureSizeInverted") === -1) {
                        this._options.uniforms.push("bakedVertexAnimationTextureSizeInverted");
                    }
                    if (this._options.uniforms.indexOf("bakedVertexAnimationTime") === -1) {
                        this._options.uniforms.push("bakedVertexAnimationTime");
                    }
                    if (this._options.samplers.indexOf("bakedVertexAnimationTexture") === -1) {
                        this._options.samplers.push("bakedVertexAnimationTexture");
                    }
                }
                MaterialHelper.PrepareAttributesForBakedVertexAnimation(attribs, mesh, defines);
            }
            // Textures
            for (const name in this._textures) {
                if (!this._textures[name].isReady()) {
                    return false;
                }
            }
            // Alpha test
            if (mesh && this._shouldTurnAlphaTestOn(mesh)) {
                defines.push("#define ALPHATEST");
            }
            // Clip planes
            if (this._options.useClipPlane !== false) {
                addClipPlaneUniforms(uniforms);
                prepareStringDefinesForClipPlanes(this, scene, defines);
            }
            if (this.customShaderNameResolve) {
                uniforms = uniforms.slice();
                uniformBuffers = uniformBuffers.slice();
                samplers = samplers.slice();
                shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs);
            }
            const drawWrapper = storeEffectOnSubMeshes ? subMesh._getDrawWrapper() : this._drawWrapper;
            const previousEffect = (_a = drawWrapper === null || drawWrapper === void 0 ? void 0 : drawWrapper.effect) !== null && _a !== void 0 ? _a : null;
            const previousDefines = (_b = drawWrapper === null || drawWrapper === void 0 ? void 0 : drawWrapper.defines) !== null && _b !== void 0 ? _b : null;
            const join = defines.join("\n");
            let effect = previousEffect;
            if (previousDefines !== join) {
                effect = engine.createEffect(shaderName, {
                    attributes: attribs,
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: join,
                    fallbacks: fallbacks,
                    onCompiled: this.onCompiled,
                    onError: this.onError,
                    indexParameters: { maxSimultaneousMorphTargets: numInfluencers },
                    shaderLanguage: this._options.shaderLanguage,
                }, engine);
                if (storeEffectOnSubMeshes) {
                    subMesh.setEffect(effect, join, this._materialContext);
                }
                else if (drawWrapper) {
                    drawWrapper.setEffect(effect, join);
                }
                if (this._onEffectCreatedObservable) {
                    onCreatedEffectParameters$3.effect = effect;
                    onCreatedEffectParameters$3.subMesh = (_c = subMesh !== null && subMesh !== void 0 ? subMesh : mesh === null || mesh === void 0 ? void 0 : mesh.subMeshes[0]) !== null && _c !== void 0 ? _c : null;
                    this._onEffectCreatedObservable.notifyObservers(onCreatedEffectParameters$3);
                }
            }
            effect._wasPreviouslyUsingInstances = !!useInstances;
            if ((_d = !(effect === null || effect === void 0 ? void 0 : effect.isReady())) !== null && _d !== void 0 ? _d : true) {
                return false;
            }
            if (previousEffect !== effect) {
                scene.resetCachedMaterial();
            }
            effect._wasPreviouslyReady = true;
            return true;
        }
        /**
         * Binds the world matrix to the material
         * @param world defines the world transformation matrix
         * @param effectOverride - If provided, use this effect instead of internal effect
         */
        bindOnlyWorldMatrix(world, effectOverride) {
            const scene = this.getScene();
            const effect = effectOverride !== null && effectOverride !== void 0 ? effectOverride : this.getEffect();
            if (!effect) {
                return;
            }
            if (this._options.uniforms.indexOf("world") !== -1) {
                effect.setMatrix("world", world);
            }
            if (this._options.uniforms.indexOf("worldView") !== -1) {
                world.multiplyToRef(scene.getViewMatrix(), this._cachedWorldViewMatrix);
                effect.setMatrix("worldView", this._cachedWorldViewMatrix);
            }
            if (this._options.uniforms.indexOf("worldViewProjection") !== -1) {
                world.multiplyToRef(scene.getTransformMatrix(), this._cachedWorldViewProjectionMatrix);
                effect.setMatrix("worldViewProjection", this._cachedWorldViewProjectionMatrix);
            }
        }
        /**
         * Binds the submesh to this material by preparing the effect and shader to draw
         * @param world defines the world transformation matrix
         * @param mesh defines the mesh containing the submesh
         * @param subMesh defines the submesh to bind the material to
         */
        bindForSubMesh(world, mesh, subMesh) {
            var _a;
            this.bind(world, mesh, (_a = subMesh._drawWrapperOverride) === null || _a === void 0 ? void 0 : _a.effect, subMesh);
        }
        /**
         * Binds the material to the mesh
         * @param world defines the world transformation matrix
         * @param mesh defines the mesh to bind the material to
         * @param effectOverride - If provided, use this effect instead of internal effect
         * @param subMesh defines the submesh to bind the material to
         */
        bind(world, mesh, effectOverride, subMesh) {
            var _a;
            // Std values
            const storeEffectOnSubMeshes = subMesh && this._storeEffectOnSubMeshes;
            const effect = effectOverride !== null && effectOverride !== void 0 ? effectOverride : (storeEffectOnSubMeshes ? subMesh.effect : this.getEffect());
            if (!effect) {
                return;
            }
            this._activeEffect = effect;
            this.bindOnlyWorldMatrix(world, effectOverride);
            const uniformBuffers = this._options.uniformBuffers;
            let useSceneUBO = false;
            if (effect && uniformBuffers && uniformBuffers.length > 0 && this.getScene().getEngine().supportsUniformBuffers) {
                for (let i = 0; i < uniformBuffers.length; ++i) {
                    const bufferName = uniformBuffers[i];
                    switch (bufferName) {
                        case "Mesh":
                            if (mesh) {
                                mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                                mesh.transferToEffect(world);
                            }
                            break;
                        case "Scene":
                            MaterialHelper.BindSceneUniformBuffer(effect, this.getScene().getSceneUniformBuffer());
                            this.getScene().finalizeSceneUbo();
                            useSceneUBO = true;
                            break;
                    }
                }
            }
            const mustRebind = mesh && storeEffectOnSubMeshes ? this._mustRebind(this.getScene(), effect, mesh.visibility) : this.getScene().getCachedMaterial() !== this;
            if (effect && mustRebind) {
                if (!useSceneUBO && this._options.uniforms.indexOf("view") !== -1) {
                    effect.setMatrix("view", this.getScene().getViewMatrix());
                }
                if (!useSceneUBO && this._options.uniforms.indexOf("projection") !== -1) {
                    effect.setMatrix("projection", this.getScene().getProjectionMatrix());
                }
                if (!useSceneUBO && this._options.uniforms.indexOf("viewProjection") !== -1) {
                    effect.setMatrix("viewProjection", this.getScene().getTransformMatrix());
                    if (this._multiview) {
                        effect.setMatrix("viewProjectionR", this.getScene()._transformMatrixR);
                    }
                }
                if (this.getScene().activeCamera && this._options.uniforms.indexOf("cameraPosition") !== -1) {
                    effect.setVector3("cameraPosition", this.getScene().activeCamera.globalPosition);
                }
                // Bones
                MaterialHelper.BindBonesParameters(mesh, effect);
                // Clip plane
                bindClipPlane(effect, this, this.getScene());
                let name;
                // Texture
                for (name in this._textures) {
                    effect.setTexture(name, this._textures[name]);
                }
                // Texture arrays
                for (name in this._textureArrays) {
                    effect.setTextureArray(name, this._textureArrays[name]);
                }
                // External texture
                for (name in this._externalTextures) {
                    effect.setExternalTexture(name, this._externalTextures[name]);
                }
                // Int
                for (name in this._ints) {
                    effect.setInt(name, this._ints[name]);
                }
                // UInt
                for (name in this._uints) {
                    effect.setUInt(name, this._uints[name]);
                }
                // Float
                for (name in this._floats) {
                    effect.setFloat(name, this._floats[name]);
                }
                // Floats
                for (name in this._floatsArrays) {
                    effect.setArray(name, this._floatsArrays[name]);
                }
                // Color3
                for (name in this._colors3) {
                    effect.setColor3(name, this._colors3[name]);
                }
                // Color3Array
                for (name in this._colors3Arrays) {
                    effect.setArray3(name, this._colors3Arrays[name]);
                }
                // Color4
                for (name in this._colors4) {
                    const color = this._colors4[name];
                    effect.setFloat4(name, color.r, color.g, color.b, color.a);
                }
                // Color4Array
                for (name in this._colors4Arrays) {
                    effect.setArray4(name, this._colors4Arrays[name]);
                }
                // Vector2
                for (name in this._vectors2) {
                    effect.setVector2(name, this._vectors2[name]);
                }
                // Vector3
                for (name in this._vectors3) {
                    effect.setVector3(name, this._vectors3[name]);
                }
                // Vector4
                for (name in this._vectors4) {
                    effect.setVector4(name, this._vectors4[name]);
                }
                // Quaternion
                for (name in this._quaternions) {
                    effect.setQuaternion(name, this._quaternions[name]);
                }
                // Matrix
                for (name in this._matrices) {
                    effect.setMatrix(name, this._matrices[name]);
                }
                // MatrixArray
                for (name in this._matrixArrays) {
                    effect.setMatrices(name, this._matrixArrays[name]);
                }
                // Matrix 3x3
                for (name in this._matrices3x3) {
                    effect.setMatrix3x3(name, this._matrices3x3[name]);
                }
                // Matrix 2x2
                for (name in this._matrices2x2) {
                    effect.setMatrix2x2(name, this._matrices2x2[name]);
                }
                // Vector2Array
                for (name in this._vectors2Arrays) {
                    effect.setArray2(name, this._vectors2Arrays[name]);
                }
                // Vector3Array
                for (name in this._vectors3Arrays) {
                    effect.setArray3(name, this._vectors3Arrays[name]);
                }
                // Vector4Array
                for (name in this._vectors4Arrays) {
                    effect.setArray4(name, this._vectors4Arrays[name]);
                }
                // QuaternionArray
                for (name in this._quaternionsArrays) {
                    effect.setArray4(name, this._quaternionsArrays[name]);
                }
                // Uniform buffers
                for (name in this._uniformBuffers) {
                    const buffer = this._uniformBuffers[name].getBuffer();
                    if (buffer) {
                        effect.bindUniformBuffer(buffer, name);
                    }
                }
                // Samplers
                for (name in this._textureSamplers) {
                    effect.setTextureSampler(name, this._textureSamplers[name]);
                }
                // Storage buffers
                for (name in this._storageBuffers) {
                    effect.setStorageBuffer(name, this._storageBuffers[name]);
                }
            }
            if (effect && mesh && (mustRebind || !this.isFrozen)) {
                // Morph targets
                const manager = mesh.morphTargetManager;
                if (manager && manager.numInfluencers > 0) {
                    MaterialHelper.BindMorphTargetParameters(mesh, effect);
                }
                const bvaManager = mesh.bakedVertexAnimationManager;
                if (bvaManager && bvaManager.isEnabled) {
                    (_a = mesh.bakedVertexAnimationManager) === null || _a === void 0 ? void 0 : _a.bind(effect, !!effect._wasPreviouslyUsingInstances);
                }
            }
            this._afterBind(mesh, effect);
        }
        /**
         * Gets the active textures from the material
         * @returns an array of textures
         */
        getActiveTextures() {
            const activeTextures = super.getActiveTextures();
            for (const name in this._textures) {
                activeTextures.push(this._textures[name]);
            }
            for (const name in this._textureArrays) {
                const array = this._textureArrays[name];
                for (let index = 0; index < array.length; index++) {
                    activeTextures.push(array[index]);
                }
            }
            return activeTextures;
        }
        /**
         * Specifies if the material uses a texture
         * @param texture defines the texture to check against the material
         * @returns a boolean specifying if the material uses the texture
         */
        hasTexture(texture) {
            if (super.hasTexture(texture)) {
                return true;
            }
            for (const name in this._textures) {
                if (this._textures[name] === texture) {
                    return true;
                }
            }
            for (const name in this._textureArrays) {
                const array = this._textureArrays[name];
                for (let index = 0; index < array.length; index++) {
                    if (array[index] === texture) {
                        return true;
                    }
                }
            }
            return false;
        }
        /**
         * Makes a duplicate of the material, and gives it a new name
         * @param name defines the new name for the duplicated material
         * @returns the cloned material
         */
        clone(name) {
            const result = SerializationHelper.Clone(() => new ShaderMaterial(name, this.getScene(), this._shaderPath, this._options, this._storeEffectOnSubMeshes), this);
            result.name = name;
            result.id = name;
            // Shader code path
            if (typeof result._shaderPath === "object") {
                result._shaderPath = Object.assign({}, result._shaderPath);
            }
            // Options
            this._options = Object.assign({}, this._options);
            Object.keys(this._options).forEach((propName) => {
                const propValue = this._options[propName];
                if (Array.isArray(propValue)) {
                    this._options[propName] = propValue.slice(0);
                }
            });
            // Stencil
            this.stencil.copyTo(result.stencil);
            // Texture
            for (const key in this._textures) {
                result.setTexture(key, this._textures[key]);
            }
            // TextureArray
            for (const key in this._textureArrays) {
                result.setTextureArray(key, this._textureArrays[key]);
            }
            // External texture
            for (const key in this._externalTextures) {
                result.setExternalTexture(key, this._externalTextures[key]);
            }
            // Int
            for (const key in this._ints) {
                result.setInt(key, this._ints[key]);
            }
            // UInt
            for (const key in this._uints) {
                result.setUInt(key, this._uints[key]);
            }
            // Float
            for (const key in this._floats) {
                result.setFloat(key, this._floats[key]);
            }
            // Floats
            for (const key in this._floatsArrays) {
                result.setFloats(key, this._floatsArrays[key]);
            }
            // Color3
            for (const key in this._colors3) {
                result.setColor3(key, this._colors3[key]);
            }
            // Color3Array
            for (const key in this._colors3Arrays) {
                result._colors3Arrays[key] = this._colors3Arrays[key];
            }
            // Color4
            for (const key in this._colors4) {
                result.setColor4(key, this._colors4[key]);
            }
            // Color4Array
            for (const key in this._colors4Arrays) {
                result._colors4Arrays[key] = this._colors4Arrays[key];
            }
            // Vector2
            for (const key in this._vectors2) {
                result.setVector2(key, this._vectors2[key]);
            }
            // Vector3
            for (const key in this._vectors3) {
                result.setVector3(key, this._vectors3[key]);
            }
            // Vector4
            for (const key in this._vectors4) {
                result.setVector4(key, this._vectors4[key]);
            }
            // Quaternion
            for (const key in this._quaternions) {
                result.setQuaternion(key, this._quaternions[key]);
            }
            // QuaternionArray
            for (const key in this._quaternionsArrays) {
                result._quaternionsArrays[key] = this._quaternionsArrays[key];
            }
            // Matrix
            for (const key in this._matrices) {
                result.setMatrix(key, this._matrices[key]);
            }
            // MatrixArray
            for (const key in this._matrixArrays) {
                result._matrixArrays[key] = this._matrixArrays[key].slice();
            }
            // Matrix 3x3
            for (const key in this._matrices3x3) {
                result.setMatrix3x3(key, this._matrices3x3[key]);
            }
            // Matrix 2x2
            for (const key in this._matrices2x2) {
                result.setMatrix2x2(key, this._matrices2x2[key]);
            }
            // Vector2Array
            for (const key in this._vectors2Arrays) {
                result.setArray2(key, this._vectors2Arrays[key]);
            }
            // Vector3Array
            for (const key in this._vectors3Arrays) {
                result.setArray3(key, this._vectors3Arrays[key]);
            }
            // Vector4Array
            for (const key in this._vectors4Arrays) {
                result.setArray4(key, this._vectors4Arrays[key]);
            }
            // Uniform buffers
            for (const key in this._uniformBuffers) {
                result.setUniformBuffer(key, this._uniformBuffers[key]);
            }
            // Samplers
            for (const key in this._textureSamplers) {
                result.setTextureSampler(key, this._textureSamplers[key]);
            }
            // Storag buffers
            for (const key in this._storageBuffers) {
                result.setStorageBuffer(key, this._storageBuffers[key]);
            }
            return result;
        }
        /**
         * Disposes the material
         * @param forceDisposeEffect specifies if effects should be forcefully disposed
         * @param forceDisposeTextures specifies if textures should be forcefully disposed
         * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
         */
        dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
            if (forceDisposeTextures) {
                let name;
                for (name in this._textures) {
                    this._textures[name].dispose();
                }
                for (name in this._textureArrays) {
                    const array = this._textureArrays[name];
                    for (let index = 0; index < array.length; index++) {
                        array[index].dispose();
                    }
                }
            }
            this._textures = {};
            super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
        }
        /**
         * Serializes this material in a JSON representation
         * @returns the serialized material object
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this);
            serializationObject.customType = "BABYLON.ShaderMaterial";
            serializationObject.uniqueId = this.uniqueId;
            serializationObject.options = this._options;
            serializationObject.shaderPath = this._shaderPath;
            serializationObject.storeEffectOnSubMeshes = this._storeEffectOnSubMeshes;
            let name;
            // Stencil
            serializationObject.stencil = this.stencil.serialize();
            // Texture
            serializationObject.textures = {};
            for (name in this._textures) {
                serializationObject.textures[name] = this._textures[name].serialize();
            }
            // Texture arrays
            serializationObject.textureArrays = {};
            for (name in this._textureArrays) {
                serializationObject.textureArrays[name] = [];
                const array = this._textureArrays[name];
                for (let index = 0; index < array.length; index++) {
                    serializationObject.textureArrays[name].push(array[index].serialize());
                }
            }
            // Int
            serializationObject.ints = {};
            for (name in this._ints) {
                serializationObject.ints[name] = this._ints[name];
            }
            // UInt
            serializationObject.uints = {};
            for (name in this._uints) {
                serializationObject.uints[name] = this._uints[name];
            }
            // Float
            serializationObject.floats = {};
            for (name in this._floats) {
                serializationObject.floats[name] = this._floats[name];
            }
            // Floats
            serializationObject.FloatArrays = {};
            for (name in this._floatsArrays) {
                serializationObject.FloatArrays[name] = this._floatsArrays[name];
            }
            // Color3
            serializationObject.colors3 = {};
            for (name in this._colors3) {
                serializationObject.colors3[name] = this._colors3[name].asArray();
            }
            // Color3 array
            serializationObject.colors3Arrays = {};
            for (name in this._colors3Arrays) {
                serializationObject.colors3Arrays[name] = this._colors3Arrays[name];
            }
            // Color4
            serializationObject.colors4 = {};
            for (name in this._colors4) {
                serializationObject.colors4[name] = this._colors4[name].asArray();
            }
            // Color4 array
            serializationObject.colors4Arrays = {};
            for (name in this._colors4Arrays) {
                serializationObject.colors4Arrays[name] = this._colors4Arrays[name];
            }
            // Vector2
            serializationObject.vectors2 = {};
            for (name in this._vectors2) {
                serializationObject.vectors2[name] = this._vectors2[name].asArray();
            }
            // Vector3
            serializationObject.vectors3 = {};
            for (name in this._vectors3) {
                serializationObject.vectors3[name] = this._vectors3[name].asArray();
            }
            // Vector4
            serializationObject.vectors4 = {};
            for (name in this._vectors4) {
                serializationObject.vectors4[name] = this._vectors4[name].asArray();
            }
            // Quaternion
            serializationObject.quaternions = {};
            for (name in this._quaternions) {
                serializationObject.quaternions[name] = this._quaternions[name].asArray();
            }
            // Matrix
            serializationObject.matrices = {};
            for (name in this._matrices) {
                serializationObject.matrices[name] = this._matrices[name].asArray();
            }
            // MatrixArray
            serializationObject.matrixArray = {};
            for (name in this._matrixArrays) {
                serializationObject.matrixArray[name] = this._matrixArrays[name];
            }
            // Matrix 3x3
            serializationObject.matrices3x3 = {};
            for (name in this._matrices3x3) {
                serializationObject.matrices3x3[name] = this._matrices3x3[name];
            }
            // Matrix 2x2
            serializationObject.matrices2x2 = {};
            for (name in this._matrices2x2) {
                serializationObject.matrices2x2[name] = this._matrices2x2[name];
            }
            // Vector2Array
            serializationObject.vectors2Arrays = {};
            for (name in this._vectors2Arrays) {
                serializationObject.vectors2Arrays[name] = this._vectors2Arrays[name];
            }
            // Vector3Array
            serializationObject.vectors3Arrays = {};
            for (name in this._vectors3Arrays) {
                serializationObject.vectors3Arrays[name] = this._vectors3Arrays[name];
            }
            // Vector4Array
            serializationObject.vectors4Arrays = {};
            for (name in this._vectors4Arrays) {
                serializationObject.vectors4Arrays[name] = this._vectors4Arrays[name];
            }
            // QuaternionArray
            serializationObject.quaternionsArrays = {};
            for (name in this._quaternionsArrays) {
                serializationObject.quaternionsArrays[name] = this._quaternionsArrays[name];
            }
            return serializationObject;
        }
        /**
         * Creates a shader material from parsed shader material data
         * @param source defines the JSON representation of the material
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @returns a new material
         */
        static Parse(source, scene, rootUrl) {
            const material = SerializationHelper.Parse(() => new ShaderMaterial(source.name, scene, source.shaderPath, source.options, source.storeEffectOnSubMeshes), source, scene, rootUrl);
            let name;
            // Stencil
            if (source.stencil) {
                material.stencil.parse(source.stencil, scene, rootUrl);
            }
            // Texture
            for (name in source.textures) {
                material.setTexture(name, Texture.Parse(source.textures[name], scene, rootUrl));
            }
            // Texture arrays
            for (name in source.textureArrays) {
                const array = source.textureArrays[name];
                const textureArray = new Array();
                for (let index = 0; index < array.length; index++) {
                    textureArray.push(Texture.Parse(array[index], scene, rootUrl));
                }
                material.setTextureArray(name, textureArray);
            }
            // Int
            for (name in source.ints) {
                material.setInt(name, source.ints[name]);
            }
            // UInt
            for (name in source.uints) {
                material.setUInt(name, source.uints[name]);
            }
            // Float
            for (name in source.floats) {
                material.setFloat(name, source.floats[name]);
            }
            // Floats
            for (name in source.floatsArrays) {
                material.setFloats(name, source.floatsArrays[name]);
            }
            // Color3
            for (name in source.colors3) {
                material.setColor3(name, Color3.FromArray(source.colors3[name]));
            }
            // Color3 arrays
            for (name in source.colors3Arrays) {
                const colors = source.colors3Arrays[name]
                    .reduce((arr, num, i) => {
                    if (i % 3 === 0) {
                        arr.push([num]);
                    }
                    else {
                        arr[arr.length - 1].push(num);
                    }
                    return arr;
                }, [])
                    .map((color) => Color3.FromArray(color));
                material.setColor3Array(name, colors);
            }
            // Color4
            for (name in source.colors4) {
                material.setColor4(name, Color4.FromArray(source.colors4[name]));
            }
            // Color4 arrays
            for (name in source.colors4Arrays) {
                const colors = source.colors4Arrays[name]
                    .reduce((arr, num, i) => {
                    if (i % 4 === 0) {
                        arr.push([num]);
                    }
                    else {
                        arr[arr.length - 1].push(num);
                    }
                    return arr;
                }, [])
                    .map((color) => Color4.FromArray(color));
                material.setColor4Array(name, colors);
            }
            // Vector2
            for (name in source.vectors2) {
                material.setVector2(name, Vector2.FromArray(source.vectors2[name]));
            }
            // Vector3
            for (name in source.vectors3) {
                material.setVector3(name, Vector3.FromArray(source.vectors3[name]));
            }
            // Vector4
            for (name in source.vectors4) {
                material.setVector4(name, Vector4.FromArray(source.vectors4[name]));
            }
            // Quaternion
            for (name in source.quaternions) {
                material.setQuaternion(name, Quaternion.FromArray(source.quaternions[name]));
            }
            // Matrix
            for (name in source.matrices) {
                material.setMatrix(name, Matrix.FromArray(source.matrices[name]));
            }
            // MatrixArray
            for (name in source.matrixArray) {
                material._matrixArrays[name] = new Float32Array(source.matrixArray[name]);
            }
            // Matrix 3x3
            for (name in source.matrices3x3) {
                material.setMatrix3x3(name, source.matrices3x3[name]);
            }
            // Matrix 2x2
            for (name in source.matrices2x2) {
                material.setMatrix2x2(name, source.matrices2x2[name]);
            }
            // Vector2Array
            for (name in source.vectors2Arrays) {
                material.setArray2(name, source.vectors2Arrays[name]);
            }
            // Vector3Array
            for (name in source.vectors3Arrays) {
                material.setArray3(name, source.vectors3Arrays[name]);
            }
            // Vector4Array
            for (name in source.vectors4Arrays) {
                material.setArray4(name, source.vectors4Arrays[name]);
            }
            // QuaternionArray
            for (name in source.quaternionsArrays) {
                material.setArray4(name, source.quaternionsArrays[name]);
            }
            return material;
        }
        /**
         * Creates a new ShaderMaterial from a snippet saved in a remote file
         * @param name defines the name of the ShaderMaterial to create (can be null or empty to use the one from the json data)
         * @param url defines the url to load from
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @returns a promise that will resolve to the new ShaderMaterial
         */
        static ParseFromFileAsync(name, url, scene, rootUrl = "") {
            return new Promise((resolve, reject) => {
                const request = new WebRequest();
                request.addEventListener("readystatechange", () => {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                            const serializationObject = JSON.parse(request.responseText);
                            const output = this.Parse(serializationObject, scene || EngineStore.LastCreatedScene, rootUrl);
                            if (name) {
                                output.name = name;
                            }
                            resolve(output);
                        }
                        else {
                            reject("Unable to load the ShaderMaterial");
                        }
                    }
                });
                request.open("GET", url);
                request.send();
            });
        }
        /**
         * Creates a ShaderMaterial from a snippet saved by the Inspector
         * @param snippetId defines the snippet to load
         * @param scene defines the hosting scene
         * @param rootUrl defines the root URL to use to load textures and relative dependencies
         * @returns a promise that will resolve to the new ShaderMaterial
         */
        static ParseFromSnippetAsync(snippetId, scene, rootUrl = "") {
            return new Promise((resolve, reject) => {
                const request = new WebRequest();
                request.addEventListener("readystatechange", () => {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                            const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                            const serializationObject = JSON.parse(snippet.shaderMaterial);
                            const output = this.Parse(serializationObject, scene || EngineStore.LastCreatedScene, rootUrl);
                            output.snippetId = snippetId;
                            resolve(output);
                        }
                        else {
                            reject("Unable to load the snippet " + snippetId);
                        }
                    }
                });
                request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
                request.send();
            });
        }
    }
    /** Define the Url to load snippets */
    ShaderMaterial.SnippetUrl = `https://snippet.babylonjs.com`;
    /**
     * Creates a ShaderMaterial from a snippet saved by the Inspector
     * @deprecated Please use ParseFromSnippetAsync instead
     * @param snippetId defines the snippet to load
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new ShaderMaterial
     */
    ShaderMaterial.CreateFromSnippetAsync = ShaderMaterial.ParseFromSnippetAsync;
    RegisterClass("BABYLON.ShaderMaterial", ShaderMaterial);

    // Do not edit.
    const name$1Y = "colorPixelShader";
    const shader$1Y = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
#define VERTEXCOLOR
varying vec4 vColor;
#else
uniform vec4 color;
#endif
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
gl_FragColor=vColor;
#else
gl_FragColor=color;
#endif
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1Y] = shader$1Y;

    // Do not edit.
    const name$1Z = "colorVertexShader";
    const shader$1Z = `attribute vec3 position;
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<clipPlaneVertexDeclaration>
#include<instancesDeclaration>
uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#include<clipPlaneVertex>
#include<vertexColorMixing>
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1Z] = shader$1Z;

    Mesh._LinesMeshParser = (parsedMesh, scene) => {
        return LinesMesh.Parse(parsedMesh, scene);
    };
    /**
     * Line mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     */
    class LinesMesh extends Mesh {
        _isShaderMaterial(shader) {
            return shader.getClassName() === "ShaderMaterial";
        }
        /**
         * Creates a new LinesMesh
         * @param name defines the name
         * @param scene defines the hosting scene
         * @param parent defines the parent mesh if any
         * @param source defines the optional source LinesMesh used to clone data from
         * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
         * When false, achieved by calling a clone(), also passing False.
         * This will make creation of children, recursive.
         * @param useVertexColor defines if this LinesMesh supports vertex color
         * @param useVertexAlpha defines if this LinesMesh supports vertex alpha
         * @param material material to use to draw the line. If not provided, will create a new one
         */
        constructor(name, scene = null, parent = null, source = null, doNotCloneChildren, 
        /**
         * If vertex color should be applied to the mesh
         */
        useVertexColor, 
        /**
         * If vertex alpha should be applied to the mesh
         */
        useVertexAlpha, material) {
            super(name, scene, parent, source, doNotCloneChildren);
            this.useVertexColor = useVertexColor;
            this.useVertexAlpha = useVertexAlpha;
            /**
             * Color of the line (Default: White)
             */
            this.color = new Color3(1, 1, 1);
            /**
             * Alpha of the line (Default: 1)
             */
            this.alpha = 1;
            if (source) {
                this.color = source.color.clone();
                this.alpha = source.alpha;
                this.useVertexColor = source.useVertexColor;
                this.useVertexAlpha = source.useVertexAlpha;
            }
            this.intersectionThreshold = 0.1;
            const defines = [];
            const options = {
                attributes: [VertexBuffer.PositionKind],
                uniforms: ["world", "viewProjection"],
                needAlphaBlending: true,
                defines: defines,
                useClipPlane: null,
            };
            if (useVertexAlpha === false) {
                options.needAlphaBlending = false;
            }
            else {
                options.defines.push("#define VERTEXALPHA");
            }
            if (!useVertexColor) {
                options.uniforms.push("color");
                this._color4 = new Color4();
            }
            else {
                options.defines.push("#define VERTEXCOLOR");
                options.attributes.push(VertexBuffer.ColorKind);
            }
            if (material) {
                this.material = material;
            }
            else {
                this.material = new ShaderMaterial("colorShader", this.getScene(), "color", options, false);
                this.material.doNotSerialize = true;
            }
        }
        isReady() {
            if (!this._lineMaterial.isReady(this, !!this._userInstancedBuffersStorage)) {
                return false;
            }
            return super.isReady();
        }
        /**
         * Returns the string "LineMesh"
         */
        getClassName() {
            return "LinesMesh";
        }
        /**
         * @internal
         */
        get material() {
            return this._lineMaterial;
        }
        /**
         * @internal
         */
        set material(value) {
            this._lineMaterial = value;
            this._lineMaterial.fillMode = Material.LineListDrawMode;
        }
        /**
         * @internal
         */
        get checkCollisions() {
            return false;
        }
        set checkCollisions(value) {
            // Just ignore it
        }
        /**
         * @internal
         */
        _bind(_subMesh, colorEffect) {
            if (!this._geometry) {
                return this;
            }
            // VBOs
            const indexToBind = this.isUnIndexed ? null : this._geometry.getIndexBuffer();
            if (!this._userInstancedBuffersStorage) {
                this._geometry._bind(colorEffect, indexToBind);
            }
            else {
                this._geometry._bind(colorEffect, indexToBind, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects);
            }
            // Color
            if (!this.useVertexColor && this._isShaderMaterial(this._lineMaterial)) {
                const { r, g, b } = this.color;
                this._color4.set(r, g, b, this.alpha);
                this._lineMaterial.setColor4("color", this._color4);
            }
            return this;
        }
        /**
         * @internal
         */
        _draw(subMesh, fillMode, instancesCount) {
            if (!this._geometry || !this._geometry.getVertexBuffers() || (!this._unIndexed && !this._geometry.getIndexBuffer())) {
                return this;
            }
            const engine = this.getScene().getEngine();
            // Draw order
            if (this._unIndexed) {
                engine.drawArraysType(Material.LineListDrawMode, subMesh.verticesStart, subMesh.verticesCount, instancesCount);
            }
            else {
                engine.drawElementsType(Material.LineListDrawMode, subMesh.indexStart, subMesh.indexCount, instancesCount);
            }
            return this;
        }
        /**
         * Disposes of the line mesh
         * @param doNotRecurse If children should be disposed
         * @param disposeMaterialAndTextures This parameter is not used by the LineMesh class
         * @param doNotDisposeMaterial If the material should not be disposed (default: false, meaning the material is disposed)
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        dispose(doNotRecurse, disposeMaterialAndTextures = false, doNotDisposeMaterial) {
            if (!doNotDisposeMaterial) {
                this._lineMaterial.dispose(false, false, true);
            }
            super.dispose(doNotRecurse);
        }
        /**
         * Returns a new LineMesh object cloned from the current one.
         * @param name
         * @param newParent
         * @param doNotCloneChildren
         */
        clone(name, newParent = null, doNotCloneChildren) {
            return new LinesMesh(name, this.getScene(), newParent, this, doNotCloneChildren);
        }
        /**
         * Creates a new InstancedLinesMesh object from the mesh model.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
         * @param name defines the name of the new instance
         * @returns a new InstancedLinesMesh
         */
        createInstance(name) {
            const instance = new InstancedLinesMesh(name, this);
            if (this.instancedBuffers) {
                instance.instancedBuffers = {};
                for (const key in this.instancedBuffers) {
                    instance.instancedBuffers[key] = this.instancedBuffers[key];
                }
            }
            return instance;
        }
        /**
         * Serializes this ground mesh
         * @param serializationObject object to write serialization to
         */
        serialize(serializationObject) {
            super.serialize(serializationObject);
            serializationObject.color = this.color.asArray();
            serializationObject.alpha = this.alpha;
        }
        /**
         * Parses a serialized ground mesh
         * @param parsedMesh the serialized mesh
         * @param scene the scene to create the ground mesh in
         * @returns the created ground mesh
         */
        static Parse(parsedMesh, scene) {
            const result = new LinesMesh(parsedMesh.name, scene);
            result.color = Color3.FromArray(parsedMesh.color);
            result.alpha = parsedMesh.alpha;
            return result;
        }
    }
    /**
     * Creates an instance based on a source LinesMesh
     */
    class InstancedLinesMesh extends InstancedMesh {
        constructor(name, source) {
            super(name, source);
            this.intersectionThreshold = source.intersectionThreshold;
        }
        /**
         * Returns the string "InstancedLinesMesh".
         */
        getClassName() {
            return "InstancedLinesMesh";
        }
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * Creates the VertexData of the LineSystem
     * @param options an object used to set the following optional parameters for the LineSystem, required but can be empty
     *  - lines an array of lines, each line being an array of successive Vector3
     *  - colors an array of line colors, each of the line colors being an array of successive Color4, one per line point
     * @param options.lines
     * @param options.colors
     * @returns the VertexData of the LineSystem
     */
    function CreateLineSystemVertexData(options) {
        const indices = [];
        const positions = [];
        const lines = options.lines;
        const colors = options.colors;
        const vertexColors = [];
        let idx = 0;
        for (let l = 0; l < lines.length; l++) {
            const points = lines[l];
            for (let index = 0; index < points.length; index++) {
                positions.push(points[index].x, points[index].y, points[index].z);
                if (colors) {
                    const color = colors[l];
                    vertexColors.push(color[index].r, color[index].g, color[index].b, color[index].a);
                }
                if (index > 0) {
                    indices.push(idx - 1);
                    indices.push(idx);
                }
                idx++;
            }
        }
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        if (colors) {
            vertexData.colors = vertexColors;
        }
        return vertexData;
    }
    /**
     * Create the VertexData for a DashedLines
     * @param options an object used to set the following optional parameters for the DashedLines, required but can be empty
     *  - points an array successive Vector3
     *  - dashSize the size of the dashes relative to the dash number, optional, default 3
     *  - gapSize the size of the gap between two successive dashes relative to the dash number, optional, default 1
     *  - dashNb the intended total number of dashes, optional, default 200
     * @param options.points
     * @param options.dashSize
     * @param options.gapSize
     * @param options.dashNb
     * @returns the VertexData for the DashedLines
     */
    function CreateDashedLinesVertexData(options) {
        const dashSize = options.dashSize || 3;
        const gapSize = options.gapSize || 1;
        const dashNb = options.dashNb || 200;
        const points = options.points;
        const positions = new Array();
        const indices = new Array();
        const curvect = Vector3.Zero();
        let lg = 0;
        let nb = 0;
        let shft = 0;
        let dashshft = 0;
        let curshft = 0;
        let idx = 0;
        let i = 0;
        for (i = 0; i < points.length - 1; i++) {
            points[i + 1].subtractToRef(points[i], curvect);
            lg += curvect.length();
        }
        shft = lg / dashNb;
        dashshft = (dashSize * shft) / (dashSize + gapSize);
        for (i = 0; i < points.length - 1; i++) {
            points[i + 1].subtractToRef(points[i], curvect);
            nb = Math.floor(curvect.length() / shft);
            curvect.normalize();
            for (let j = 0; j < nb; j++) {
                curshft = shft * j;
                positions.push(points[i].x + curshft * curvect.x, points[i].y + curshft * curvect.y, points[i].z + curshft * curvect.z);
                positions.push(points[i].x + (curshft + dashshft) * curvect.x, points[i].y + (curshft + dashshft) * curvect.y, points[i].z + (curshft + dashshft) * curvect.z);
                indices.push(idx, idx + 1);
                idx += 2;
            }
        }
        // Result
        const vertexData = new VertexData();
        vertexData.positions = positions;
        vertexData.indices = indices;
        return vertexData;
    }
    /**
     * Creates a line system mesh. A line system is a pool of many lines gathered in a single mesh
     * * A line system mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of lines as an input parameter
     * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineSystem to this static function
     * * The parameter `lines` is an array of lines, each line being an array of successive Vector3
     * * The optional parameter `instance` is an instance of an existing LineSystem object to be updated with the passed `lines` parameter
     * * The optional parameter `colors` is an array of line colors, each line colors being an array of successive Color4, one per line point
     * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need the alpha blending (faster)
     * * The optional parameter `material` is the material to use to draw the lines if provided. If not, a default material will be created
     * * Updating a simple Line mesh, you just need to update every line in the `lines` array : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#lines-and-dashedlines
     * * When updating an instance, remember that only line point positions can change, not the number of points, neither the number of lines
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#line-system
     * @param name defines the name of the new line system
     * @param options defines the options used to create the line system
     * @param options.lines
     * @param options.updatable
     * @param options.instance
     * @param options.colors
     * @param options.useVertexAlpha
     * @param options.material
     * @param scene defines the hosting scene
     * @returns a new line system mesh
     */
    function CreateLineSystem(name, options, scene = null) {
        const instance = options.instance;
        const lines = options.lines;
        const colors = options.colors;
        if (instance) {
            // lines update
            const positions = instance.getVerticesData(VertexBuffer.PositionKind);
            let vertexColor;
            let lineColors;
            if (colors) {
                vertexColor = instance.getVerticesData(VertexBuffer.ColorKind);
            }
            let i = 0;
            let c = 0;
            for (let l = 0; l < lines.length; l++) {
                const points = lines[l];
                for (let p = 0; p < points.length; p++) {
                    positions[i] = points[p].x;
                    positions[i + 1] = points[p].y;
                    positions[i + 2] = points[p].z;
                    if (colors && vertexColor) {
                        lineColors = colors[l];
                        vertexColor[c] = lineColors[p].r;
                        vertexColor[c + 1] = lineColors[p].g;
                        vertexColor[c + 2] = lineColors[p].b;
                        vertexColor[c + 3] = lineColors[p].a;
                        c += 4;
                    }
                    i += 3;
                }
            }
            instance.updateVerticesData(VertexBuffer.PositionKind, positions, false, false);
            if (colors && vertexColor) {
                instance.updateVerticesData(VertexBuffer.ColorKind, vertexColor, false, false);
            }
            return instance;
        }
        // line system creation
        const useVertexColor = colors ? true : false;
        const lineSystem = new LinesMesh(name, scene, null, undefined, undefined, useVertexColor, options.useVertexAlpha, options.material);
        const vertexData = CreateLineSystemVertexData(options);
        vertexData.applyToMesh(lineSystem, options.updatable);
        return lineSystem;
    }
    /**
     * Creates a line mesh
     * A line mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of points as an input parameter
     * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineMesh to this static function
     * * The parameter `points` is an array successive Vector3
     * * The optional parameter `instance` is an instance of an existing LineMesh object to be updated with the passed `points` parameter : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#lines-and-dashedlines
     * * The optional parameter `colors` is an array of successive Color4, one per line point
     * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need alpha blending (faster)
     * * The optional parameter `material` is the material to use to draw the lines if provided. If not, a default material will be created
     * * When updating an instance, remember that only point positions can change, not the number of points
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#lines
     * @param name defines the name of the new line system
     * @param options defines the options used to create the line system
     * @param options.points
     * @param options.updatable
     * @param options.instance
     * @param options.colors
     * @param options.useVertexAlpha
     * @param options.material
     * @param scene defines the hosting scene
     * @returns a new line mesh
     */
    function CreateLines(name, options, scene = null) {
        const colors = options.colors ? [options.colors] : null;
        const lines = CreateLineSystem(name, { lines: [options.points], updatable: options.updatable, instance: options.instance, colors: colors, useVertexAlpha: options.useVertexAlpha, material: options.material }, scene);
        return lines;
    }
    /**
     * Creates a dashed line mesh
     * * A dashed line mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of points as an input parameter
     * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineMesh to this static function
     * * The parameter `points` is an array successive Vector3
     * * The parameter `dashNb` is the intended total number of dashes (positive integer, default 200)
     * * The parameter `dashSize` is the size of the dashes relatively the dash number (positive float, default 3)
     * * The parameter `gapSize` is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
     * * The optional parameter `instance` is an instance of an existing LineMesh object to be updated with the passed `points` parameter : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#lines-and-dashedlines
     * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need the alpha blending (faster)
     * * The optional parameter `material` is the material to use to draw the lines if provided. If not, a default material will be created
     * * When updating an instance, remember that only point positions can change, not the number of points
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.points
     * @param options.dashSize
     * @param options.gapSize
     * @param options.dashNb
     * @param options.updatable
     * @param options.instance
     * @param options.useVertexAlpha
     * @param options.material
     * @param scene defines the hosting scene
     * @returns the dashed line mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#dashed-lines
     */
    function CreateDashedLines(name, options, scene = null) {
        const points = options.points;
        const instance = options.instance;
        const gapSize = options.gapSize || 1;
        const dashSize = options.dashSize || 3;
        if (instance) {
            //  dashed lines update
            const positionFunction = (positions) => {
                const curvect = Vector3.Zero();
                const nbSeg = positions.length / 6;
                let lg = 0;
                let nb = 0;
                let shft = 0;
                let dashshft = 0;
                let curshft = 0;
                let p = 0;
                let i = 0;
                let j = 0;
                for (i = 0; i < points.length - 1; i++) {
                    points[i + 1].subtractToRef(points[i], curvect);
                    lg += curvect.length();
                }
                shft = lg / nbSeg;
                const dashSize = instance._creationDataStorage.dashSize;
                const gapSize = instance._creationDataStorage.gapSize;
                dashshft = (dashSize * shft) / (dashSize + gapSize);
                for (i = 0; i < points.length - 1; i++) {
                    points[i + 1].subtractToRef(points[i], curvect);
                    nb = Math.floor(curvect.length() / shft);
                    curvect.normalize();
                    j = 0;
                    while (j < nb && p < positions.length) {
                        curshft = shft * j;
                        positions[p] = points[i].x + curshft * curvect.x;
                        positions[p + 1] = points[i].y + curshft * curvect.y;
                        positions[p + 2] = points[i].z + curshft * curvect.z;
                        positions[p + 3] = points[i].x + (curshft + dashshft) * curvect.x;
                        positions[p + 4] = points[i].y + (curshft + dashshft) * curvect.y;
                        positions[p + 5] = points[i].z + (curshft + dashshft) * curvect.z;
                        p += 6;
                        j++;
                    }
                }
                while (p < positions.length) {
                    positions[p] = points[i].x;
                    positions[p + 1] = points[i].y;
                    positions[p + 2] = points[i].z;
                    p += 3;
                }
            };
            if (options.dashNb || options.dashSize || options.gapSize || options.useVertexAlpha || options.material) {
                Logger.Warn("You have used an option other than points with the instance option. Please be aware that these other options will be ignored.");
            }
            instance.updateMeshPositions(positionFunction, false);
            return instance;
        }
        // dashed lines creation
        const dashedLines = new LinesMesh(name, scene, null, undefined, undefined, undefined, options.useVertexAlpha, options.material);
        const vertexData = CreateDashedLinesVertexData(options);
        vertexData.applyToMesh(dashedLines, options.updatable);
        dashedLines._creationDataStorage = new _CreationDataStorage();
        dashedLines._creationDataStorage.dashSize = dashSize;
        dashedLines._creationDataStorage.gapSize = gapSize;
        return dashedLines;
    }
    VertexData.CreateLineSystem = CreateLineSystemVertexData;
    VertexData.CreateDashedLines = CreateDashedLinesVertexData;
    Mesh.CreateLines = (name, points, scene = null, updatable = false, instance = null) => {
        const options = {
            points,
            updatable,
            instance,
        };
        return CreateLines(name, options, scene);
    };
    Mesh.CreateDashedLines = (name, points, dashSize, gapSize, dashNb, scene = null, updatable, instance) => {
        const options = {
            points,
            dashSize,
            gapSize,
            dashNb,
            updatable,
            instance,
        };
        return CreateDashedLines(name, options, scene);
    };

    /**
     * The current state of the timer
     */
    var TimerState;
    (function (TimerState) {
        /**
         * Timer initialized, not yet started
         */
        TimerState[TimerState["INIT"] = 0] = "INIT";
        /**
         * Timer started and counting
         */
        TimerState[TimerState["STARTED"] = 1] = "STARTED";
        /**
         * Timer ended (whether aborted or time reached)
         */
        TimerState[TimerState["ENDED"] = 2] = "ENDED";
    })(TimerState || (TimerState = {}));
    /**
     * A simple version of the timer. Will take options and start the timer immediately after calling it
     *
     * @param options options with which to initialize this timer
     */
    function setAndStartTimer(options) {
        var _a;
        let timer = 0;
        const startTime = Date.now();
        options.observableParameters = (_a = options.observableParameters) !== null && _a !== void 0 ? _a : {};
        const observer = options.contextObservable.add((payload) => {
            const now = Date.now();
            timer = now - startTime;
            const data = {
                startTime,
                currentTime: now,
                deltaTime: timer,
                completeRate: timer / options.timeout,
                payload,
            };
            options.onTick && options.onTick(data);
            if (options.breakCondition && options.breakCondition()) {
                options.contextObservable.remove(observer);
                options.onAborted && options.onAborted(data);
            }
            if (timer >= options.timeout) {
                options.contextObservable.remove(observer);
                options.onEnded && options.onEnded(data);
            }
        }, options.observableParameters.mask, options.observableParameters.insertFirst, options.observableParameters.scope);
        return observer;
    }

    /**
     * This is a teleportation feature to be used with WebXR-enabled motion controllers.
     * When enabled and attached, the feature will allow a user to move around and rotate in the scene using
     * the input of the attached controllers.
     */
    class WebXRMotionControllerTeleportation extends WebXRAbstractFeature {
        /**
         * Is rotation enabled when moving forward?
         * Disabling this feature will prevent the user from deciding the direction when teleporting
         */
        get rotationEnabled() {
            return this._rotationEnabled;
        }
        /**
         * Sets whether rotation is enabled or not
         * @param enabled is rotation enabled when teleportation is shown
         */
        set rotationEnabled(enabled) {
            this._rotationEnabled = enabled;
            if (this._options.teleportationTargetMesh) {
                const children = this._options.teleportationTargetMesh.getChildMeshes(false, (node) => node.name === "rotationCone");
                if (children[0]) {
                    children[0].setEnabled(enabled);
                }
            }
        }
        /**
         * Exposes the currently set teleportation target mesh.
         */
        get teleportationTargetMesh() {
            return this._options.teleportationTargetMesh || null;
        }
        /**
         * constructs a new teleportation system
         * @param _xrSessionManager an instance of WebXRSessionManager
         * @param _options configuration object for this feature
         */
        constructor(_xrSessionManager, _options) {
            super(_xrSessionManager);
            this._options = _options;
            this._controllers = {};
            this._snappedToPoint = false;
            this._cachedColor4White = new Color4(1, 1, 1, 1);
            this._tmpRay = new Ray(new Vector3(), new Vector3());
            this._tmpVector = new Vector3();
            this._tmpQuaternion = new Quaternion();
            /**
             * Skip the next teleportation. This can be controlled by the user to prevent the user from teleportation
             * to sections that are not yet "unlocked", but should still show the teleportation mesh.
             */
            this.skipNextTeleportation = false;
            /**
             * Is movement backwards enabled
             */
            this.backwardsMovementEnabled = true;
            /**
             * Distance to travel when moving backwards
             */
            this.backwardsTeleportationDistance = 0.7;
            /**
             * The distance from the user to the inspection point in the direction of the controller
             * A higher number will allow the user to move further
             * defaults to 5 (meters, in xr units)
             */
            this.parabolicCheckRadius = 5;
            /**
             * Should the module support parabolic ray on top of direct ray
             * If enabled, the user will be able to point "at the sky" and move according to predefined radius distance
             * Very helpful when moving between floors / different heights
             */
            this.parabolicRayEnabled = true;
            /**
             * The second type of ray - straight line.
             * Should it be enabled or should the parabolic line be the only one.
             */
            this.straightRayEnabled = true;
            /**
             * How much rotation should be applied when rotating right and left
             */
            this.rotationAngle = Math.PI / 8;
            /**
             * This observable will notify when the target mesh position was updated.
             * The picking info it provides contains the point to which the target mesh will move ()
             */
            this.onTargetMeshPositionUpdatedObservable = new Observable$1();
            /**
             * Is teleportation enabled. Can be used to allow rotation only.
             */
            this.teleportationEnabled = true;
            this._rotationEnabled = true;
            this._attachController = (xrController) => {
                if (this._controllers[xrController.uniqueId] || (this._options.forceHandedness && xrController.inputSource.handedness !== this._options.forceHandedness)) {
                    // already attached
                    return;
                }
                this._controllers[xrController.uniqueId] = {
                    xrController,
                    teleportationState: {
                        forward: false,
                        backwards: false,
                        rotating: false,
                        currentRotation: 0,
                        baseRotation: 0,
                        blocked: false,
                    },
                };
                const controllerData = this._controllers[xrController.uniqueId];
                // motion controller only available to gamepad-enabled input sources.
                if (controllerData.xrController.inputSource.targetRayMode === "tracked-pointer" && controllerData.xrController.inputSource.gamepad) {
                    // motion controller support
                    const initMotionController = () => {
                        if (xrController.motionController) {
                            const movementController = xrController.motionController.getComponentOfType(WebXRControllerComponent.THUMBSTICK_TYPE) ||
                                xrController.motionController.getComponentOfType(WebXRControllerComponent.TOUCHPAD_TYPE);
                            if (!movementController || this._options.useMainComponentOnly) {
                                // use trigger to move on long press
                                const mainComponent = xrController.motionController.getMainComponent();
                                if (!mainComponent) {
                                    return;
                                }
                                controllerData.teleportationComponent = mainComponent;
                                controllerData.onButtonChangedObserver = mainComponent.onButtonStateChangedObservable.add(() => {
                                    if (!this.teleportationEnabled) {
                                        return;
                                    }
                                    // did "pressed" changed?
                                    if (mainComponent.changes.pressed) {
                                        if (mainComponent.changes.pressed.current) {
                                            // simulate "forward" thumbstick push
                                            controllerData.teleportationState.forward = true;
                                            this._currentTeleportationControllerId = controllerData.xrController.uniqueId;
                                            controllerData.teleportationState.baseRotation = this._options.xrInput.xrCamera.rotationQuaternion.toEulerAngles().y;
                                            controllerData.teleportationState.currentRotation = 0;
                                            const timeToSelect = this._options.timeToTeleport || 3000;
                                            setAndStartTimer({
                                                timeout: timeToSelect,
                                                contextObservable: this._xrSessionManager.onXRFrameObservable,
                                                breakCondition: () => !mainComponent.pressed,
                                                onEnded: () => {
                                                    if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId && controllerData.teleportationState.forward) {
                                                        this._teleportForward(xrController.uniqueId);
                                                    }
                                                },
                                            });
                                        }
                                        else {
                                            controllerData.teleportationState.forward = false;
                                            this._currentTeleportationControllerId = "";
                                        }
                                    }
                                });
                            }
                            else {
                                controllerData.teleportationComponent = movementController;
                                // use thumbstick (or touchpad if thumbstick not available)
                                controllerData.onAxisChangedObserver = movementController.onAxisValueChangedObservable.add((axesData) => {
                                    if (axesData.y <= 0.7 && controllerData.teleportationState.backwards) {
                                        controllerData.teleportationState.backwards = false;
                                    }
                                    if (axesData.y > 0.7 && !controllerData.teleportationState.forward && this.backwardsMovementEnabled && !this.snapPointsOnly) {
                                        // teleport backwards
                                        // General gist: Go Back N units, cast a ray towards the floor. If collided, move.
                                        if (!controllerData.teleportationState.backwards) {
                                            controllerData.teleportationState.backwards = true;
                                            // teleport backwards ONCE
                                            this._tmpQuaternion.copyFrom(this._options.xrInput.xrCamera.rotationQuaternion);
                                            this._tmpQuaternion.toEulerAnglesToRef(this._tmpVector);
                                            // get only the y rotation
                                            this._tmpVector.x = 0;
                                            this._tmpVector.z = 0;
                                            // get the quaternion
                                            Quaternion.FromEulerVectorToRef(this._tmpVector, this._tmpQuaternion);
                                            this._tmpVector.set(0, 0, this.backwardsTeleportationDistance * (this._xrSessionManager.scene.useRightHandedSystem ? 1.0 : -1.0));
                                            this._tmpVector.rotateByQuaternionToRef(this._tmpQuaternion, this._tmpVector);
                                            this._tmpVector.addInPlace(this._options.xrInput.xrCamera.position);
                                            this._tmpRay.origin.copyFrom(this._tmpVector);
                                            // This will prevent the user from "falling" to a lower platform!
                                            // TODO - should this be a flag? 'allow falling to lower platforms'?
                                            this._tmpRay.length = this._options.xrInput.xrCamera.realWorldHeight + 0.1;
                                            // Right handed system had here "1" instead of -1. This is unneeded.
                                            this._tmpRay.direction.set(0, -1, 0);
                                            const pick = this._xrSessionManager.scene.pickWithRay(this._tmpRay, (o) => {
                                                return this._floorMeshes.indexOf(o) !== -1;
                                            });
                                            // pick must exist, but stay safe
                                            if (pick && pick.pickedPoint) {
                                                // Teleport the users feet to where they targeted. Ignore the Y axis.
                                                // If the "falling to lower platforms" feature is implemented the Y axis should be set here as well
                                                this._options.xrInput.xrCamera.position.x = pick.pickedPoint.x;
                                                this._options.xrInput.xrCamera.position.z = pick.pickedPoint.z;
                                            }
                                        }
                                    }
                                    if (axesData.y < -0.7 && !this._currentTeleportationControllerId && !controllerData.teleportationState.rotating && this.teleportationEnabled) {
                                        controllerData.teleportationState.forward = true;
                                        this._currentTeleportationControllerId = controllerData.xrController.uniqueId;
                                        controllerData.teleportationState.baseRotation = this._options.xrInput.xrCamera.rotationQuaternion.toEulerAngles().y;
                                    }
                                    if (axesData.x) {
                                        if (!controllerData.teleportationState.forward) {
                                            if (!controllerData.teleportationState.rotating && Math.abs(axesData.x) > 0.7) {
                                                // rotate in the right direction positive is right
                                                controllerData.teleportationState.rotating = true;
                                                const rotation = this.rotationAngle * (axesData.x > 0 ? 1 : -1) * (this._xrSessionManager.scene.useRightHandedSystem ? -1 : 1);
                                                Quaternion.FromEulerAngles(0, rotation, 0).multiplyToRef(this._options.xrInput.xrCamera.rotationQuaternion, this._options.xrInput.xrCamera.rotationQuaternion);
                                            }
                                        }
                                        else {
                                            if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId) {
                                                // set the rotation of the forward movement
                                                if (this.rotationEnabled) {
                                                    setTimeout(() => {
                                                        controllerData.teleportationState.currentRotation = Math.atan2(axesData.x, axesData.y * (this._xrSessionManager.scene.useRightHandedSystem ? 1 : -1));
                                                    });
                                                }
                                                else {
                                                    controllerData.teleportationState.currentRotation = 0;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        controllerData.teleportationState.rotating = false;
                                    }
                                    if (axesData.x === 0 && axesData.y === 0) {
                                        if (controllerData.teleportationState.blocked) {
                                            controllerData.teleportationState.blocked = false;
                                            this._setTargetMeshVisibility(false);
                                        }
                                        if (controllerData.teleportationState.forward) {
                                            this._teleportForward(xrController.uniqueId);
                                        }
                                    }
                                });
                            }
                        }
                    };
                    if (xrController.motionController) {
                        initMotionController();
                    }
                    else {
                        xrController.onMotionControllerInitObservable.addOnce(() => {
                            initMotionController();
                        });
                    }
                }
                else {
                    this._xrSessionManager.scene.onPointerObservable.add((pointerInfo) => {
                        if (pointerInfo.type === PointerEventTypes.POINTERDOWN) {
                            controllerData.teleportationState.forward = true;
                            this._currentTeleportationControllerId = controllerData.xrController.uniqueId;
                            controllerData.teleportationState.baseRotation = this._options.xrInput.xrCamera.rotationQuaternion.toEulerAngles().y;
                            controllerData.teleportationState.currentRotation = 0;
                            const timeToSelect = this._options.timeToTeleport || 3000;
                            setAndStartTimer({
                                timeout: timeToSelect,
                                contextObservable: this._xrSessionManager.onXRFrameObservable,
                                onEnded: () => {
                                    if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId && controllerData.teleportationState.forward) {
                                        this._teleportForward(xrController.uniqueId);
                                    }
                                },
                            });
                        }
                        else if (pointerInfo.type === PointerEventTypes.POINTERUP) {
                            controllerData.teleportationState.forward = false;
                            this._currentTeleportationControllerId = "";
                        }
                    });
                }
            };
            // create default mesh if not provided
            if (!this._options.teleportationTargetMesh) {
                this._createDefaultTargetMesh();
            }
            this._floorMeshes = this._options.floorMeshes || [];
            this._snapToPositions = this._options.snapPositions || [];
            this._blockedRayColor = this._options.blockedRayColor || new Color4(1, 0, 0, 0.75);
            this._setTargetMeshVisibility(false);
        }
        /**
         * Get the snapPointsOnly flag
         */
        get snapPointsOnly() {
            return !!this._options.snapPointsOnly;
        }
        /**
         * Sets the snapPointsOnly flag
         * @param snapToPoints should teleportation be exclusively to snap points
         */
        set snapPointsOnly(snapToPoints) {
            this._options.snapPointsOnly = snapToPoints;
        }
        /**
         * Add a new mesh to the floor meshes array
         * @param mesh the mesh to use as floor mesh
         */
        addFloorMesh(mesh) {
            this._floorMeshes.push(mesh);
        }
        /**
         * Add a mesh to the list of meshes blocking the teleportation ray
         * @param mesh The mesh to add to the teleportation-blocking meshes
         */
        addBlockerMesh(mesh) {
            this._options.pickBlockerMeshes = this._options.pickBlockerMeshes || [];
            this._options.pickBlockerMeshes.push(mesh);
        }
        /**
         * Add a new snap-to point to fix teleportation to this position
         * @param newSnapPoint The new Snap-To point
         */
        addSnapPoint(newSnapPoint) {
            this._snapToPositions.push(newSnapPoint);
        }
        attach() {
            if (!super.attach()) {
                return false;
            }
            // Safety reset
            this._currentTeleportationControllerId = "";
            this._options.xrInput.controllers.forEach(this._attachController);
            this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController);
            this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller) => {
                // REMOVE the controller
                this._detachController(controller.uniqueId);
            });
            return true;
        }
        detach() {
            if (!super.detach()) {
                return false;
            }
            Object.keys(this._controllers).forEach((controllerId) => {
                this._detachController(controllerId);
            });
            this._setTargetMeshVisibility(false);
            this._currentTeleportationControllerId = "";
            this._controllers = {};
            return true;
        }
        dispose() {
            super.dispose();
            this._options.teleportationTargetMesh && this._options.teleportationTargetMesh.dispose(false, true);
        }
        /**
         * Remove a mesh from the floor meshes array
         * @param mesh the mesh to remove
         */
        removeFloorMesh(mesh) {
            const index = this._floorMeshes.indexOf(mesh);
            if (index !== -1) {
                this._floorMeshes.splice(index, 1);
            }
        }
        /**
         * Remove a mesh from the blocker meshes array
         * @param mesh the mesh to remove
         */
        removeBlockerMesh(mesh) {
            this._options.pickBlockerMeshes = this._options.pickBlockerMeshes || [];
            const index = this._options.pickBlockerMeshes.indexOf(mesh);
            if (index !== -1) {
                this._options.pickBlockerMeshes.splice(index, 1);
            }
        }
        /**
         * Remove a mesh from the floor meshes array using its name
         * @param name the mesh name to remove
         */
        removeFloorMeshByName(name) {
            const mesh = this._xrSessionManager.scene.getMeshByName(name);
            if (mesh) {
                this.removeFloorMesh(mesh);
            }
        }
        /**
         * This function will iterate through the array, searching for this point or equal to it. It will then remove it from the snap-to array
         * @param snapPointToRemove the point (or a clone of it) to be removed from the array
         * @returns was the point found and removed or not
         */
        removeSnapPoint(snapPointToRemove) {
            // check if the object is in the array
            let index = this._snapToPositions.indexOf(snapPointToRemove);
            // if not found as an object, compare to the points
            if (index === -1) {
                for (let i = 0; i < this._snapToPositions.length; ++i) {
                    // equals? index is i, break the loop
                    if (this._snapToPositions[i].equals(snapPointToRemove)) {
                        index = i;
                        break;
                    }
                }
            }
            // index is not -1? remove the object
            if (index !== -1) {
                this._snapToPositions.splice(index, 1);
                return true;
            }
            return false;
        }
        /**
         * This function sets a selection feature that will be disabled when
         * the forward ray is shown and will be reattached when hidden.
         * This is used to remove the selection rays when moving.
         * @param selectionFeature the feature to disable when forward movement is enabled
         */
        setSelectionFeature(selectionFeature) {
            this._selectionFeature = selectionFeature;
        }
        _onXRFrame(_xrFrame) {
            const frame = this._xrSessionManager.currentFrame;
            const scene = this._xrSessionManager.scene;
            if (!this.attach || !frame) {
                return;
            }
            // render target if needed
            const targetMesh = this._options.teleportationTargetMesh;
            if (this._currentTeleportationControllerId) {
                if (!targetMesh) {
                    return;
                }
                targetMesh.rotationQuaternion = targetMesh.rotationQuaternion || new Quaternion();
                const controllerData = this._controllers[this._currentTeleportationControllerId];
                if (controllerData && controllerData.teleportationState.forward) {
                    // set the rotation
                    Quaternion.RotationYawPitchRollToRef(controllerData.teleportationState.currentRotation + controllerData.teleportationState.baseRotation, 0, 0, targetMesh.rotationQuaternion);
                    // set the ray and position
                    let hitPossible = false;
                    controllerData.xrController.getWorldPointerRayToRef(this._tmpRay);
                    if (this.straightRayEnabled) {
                        // first check if direct ray possible
                        // pick grounds that are LOWER only. upper will use parabolic path
                        const pick = scene.pickWithRay(this._tmpRay, (o) => {
                            // check for mesh-blockers
                            if (this._options.pickBlockerMeshes && this._options.pickBlockerMeshes.indexOf(o) !== -1) {
                                return true;
                            }
                            const index = this._floorMeshes.indexOf(o);
                            if (index === -1) {
                                return false;
                            }
                            return this._floorMeshes[index].absolutePosition.y < this._options.xrInput.xrCamera.globalPosition.y;
                        });
                        if (pick && pick.pickedMesh && this._options.pickBlockerMeshes && this._options.pickBlockerMeshes.indexOf(pick.pickedMesh) !== -1) {
                            controllerData.teleportationState.blocked = true;
                            this._setTargetMeshVisibility(false);
                            this._showParabolicPath(pick);
                            return;
                        }
                        else if (pick && pick.pickedPoint) {
                            controllerData.teleportationState.blocked = false;
                            hitPossible = true;
                            this._setTargetMeshPosition(pick);
                            this._setTargetMeshVisibility(true);
                            this._showParabolicPath(pick);
                        }
                    }
                    // straight ray is still the main ray, but disabling the straight line will force parabolic line.
                    if (this.parabolicRayEnabled && !hitPossible) {
                        // radius compensation according to pointer rotation around X
                        const xRotation = controllerData.xrController.pointer.rotationQuaternion.toEulerAngles().x;
                        const compensation = 1 + (Math.PI / 2 - Math.abs(xRotation));
                        // check parabolic ray
                        const radius = this.parabolicCheckRadius * compensation;
                        this._tmpRay.origin.addToRef(this._tmpRay.direction.scale(radius * 2), this._tmpVector);
                        this._tmpVector.y = this._tmpRay.origin.y;
                        this._tmpRay.origin.addInPlace(this._tmpRay.direction.scale(radius));
                        this._tmpVector.subtractToRef(this._tmpRay.origin, this._tmpRay.direction);
                        this._tmpRay.direction.normalize();
                        const pick = scene.pickWithRay(this._tmpRay, (o) => {
                            // check for mesh-blockers
                            if (this._options.pickBlockerMeshes && this._options.pickBlockerMeshes.indexOf(o) !== -1) {
                                return true;
                            }
                            return this._floorMeshes.indexOf(o) !== -1;
                        });
                        if (pick && pick.pickedMesh && this._options.pickBlockerMeshes && this._options.pickBlockerMeshes.indexOf(pick.pickedMesh) !== -1) {
                            controllerData.teleportationState.blocked = true;
                            this._setTargetMeshVisibility(false);
                            this._showParabolicPath(pick);
                            return;
                        }
                        else if (pick && pick.pickedPoint) {
                            controllerData.teleportationState.blocked = false;
                            hitPossible = true;
                            this._setTargetMeshPosition(pick);
                            this._setTargetMeshVisibility(true);
                            this._showParabolicPath(pick);
                        }
                    }
                    // if needed, set visible:
                    this._setTargetMeshVisibility(hitPossible);
                }
                else {
                    this._setTargetMeshVisibility(false);
                }
            }
            else {
                this._disposeBezierCurve();
                this._setTargetMeshVisibility(false);
            }
        }
        _createDefaultTargetMesh() {
            // set defaults
            this._options.defaultTargetMeshOptions = this._options.defaultTargetMeshOptions || {};
            const sceneToRenderTo = this._options.useUtilityLayer
                ? this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene
                : this._xrSessionManager.scene;
            const teleportationTarget = CreateGround("teleportationTarget", { width: 2, height: 2, subdivisions: 2 }, sceneToRenderTo);
            teleportationTarget.isPickable = false;
            if (this._options.defaultTargetMeshOptions.teleportationCircleMaterial) {
                teleportationTarget.material = this._options.defaultTargetMeshOptions.teleportationCircleMaterial;
            }
            else {
                const length = 512;
                const dynamicTexture = new DynamicTexture("teleportationPlaneDynamicTexture", length, sceneToRenderTo, true);
                dynamicTexture.hasAlpha = true;
                const context = dynamicTexture.getContext();
                const centerX = length / 2;
                const centerY = length / 2;
                const radius = 200;
                context.beginPath();
                context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
                context.fillStyle = this._options.defaultTargetMeshOptions.teleportationFillColor || "#444444";
                context.fill();
                context.lineWidth = 10;
                context.strokeStyle = this._options.defaultTargetMeshOptions.teleportationBorderColor || "#FFFFFF";
                context.stroke();
                context.closePath();
                dynamicTexture.update();
                const teleportationCircleMaterial = new StandardMaterial("teleportationPlaneMaterial", sceneToRenderTo);
                teleportationCircleMaterial.diffuseTexture = dynamicTexture;
                teleportationTarget.material = teleportationCircleMaterial;
            }
            const torus = CreateTorus("torusTeleportation", {
                diameter: 0.75,
                thickness: 0.1,
                tessellation: 20,
            }, sceneToRenderTo);
            torus.isPickable = false;
            torus.parent = teleportationTarget;
            if (!this._options.defaultTargetMeshOptions.disableAnimation) {
                const animationInnerCircle = new Animation("animationInnerCircle", "position.y", 30, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
                const keys = [];
                keys.push({
                    frame: 0,
                    value: 0,
                });
                keys.push({
                    frame: 30,
                    value: 0.4,
                });
                keys.push({
                    frame: 60,
                    value: 0,
                });
                animationInnerCircle.setKeys(keys);
                const easingFunction = new SineEase();
                easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
                animationInnerCircle.setEasingFunction(easingFunction);
                torus.animations = [];
                torus.animations.push(animationInnerCircle);
                sceneToRenderTo.beginAnimation(torus, 0, 60, true);
            }
            const cone = CreateCylinder("rotationCone", { diameterTop: 0, tessellation: 4 }, sceneToRenderTo);
            cone.isPickable = false;
            cone.scaling.set(0.5, 0.12, 0.2);
            cone.rotate(Axis.X, Math.PI / 2);
            cone.position.z = 0.6;
            cone.parent = torus;
            if (this._options.defaultTargetMeshOptions.torusArrowMaterial) {
                torus.material = this._options.defaultTargetMeshOptions.torusArrowMaterial;
                cone.material = this._options.defaultTargetMeshOptions.torusArrowMaterial;
            }
            else {
                const torusConeMaterial = new StandardMaterial("torusConsMat", sceneToRenderTo);
                torusConeMaterial.disableLighting = !!this._options.defaultTargetMeshOptions.disableLighting;
                if (torusConeMaterial.disableLighting) {
                    torusConeMaterial.emissiveColor = new Color3(0.3, 0.3, 1.0);
                }
                else {
                    torusConeMaterial.diffuseColor = new Color3(0.3, 0.3, 1.0);
                }
                torusConeMaterial.alpha = 0.9;
                torus.material = torusConeMaterial;
                cone.material = torusConeMaterial;
                this._teleportationRingMaterial = torusConeMaterial;
            }
            if (this._options.renderingGroupId !== undefined) {
                teleportationTarget.renderingGroupId = this._options.renderingGroupId;
                torus.renderingGroupId = this._options.renderingGroupId;
                cone.renderingGroupId = this._options.renderingGroupId;
            }
            this._options.teleportationTargetMesh = teleportationTarget;
            // hide the teleportation target mesh right after creating it.
            this._setTargetMeshVisibility(false);
        }
        _detachController(xrControllerUniqueId) {
            const controllerData = this._controllers[xrControllerUniqueId];
            if (!controllerData) {
                return;
            }
            if (controllerData.teleportationComponent) {
                if (controllerData.onAxisChangedObserver) {
                    controllerData.teleportationComponent.onAxisValueChangedObservable.remove(controllerData.onAxisChangedObserver);
                }
                if (controllerData.onButtonChangedObserver) {
                    controllerData.teleportationComponent.onButtonStateChangedObservable.remove(controllerData.onButtonChangedObserver);
                }
            }
            // remove from the map
            delete this._controllers[xrControllerUniqueId];
        }
        _findClosestSnapPointWithRadius(realPosition, radius = this._options.snapToPositionRadius || 0.8) {
            let closestPoint = null;
            let closestDistance = Number.MAX_VALUE;
            if (this._snapToPositions.length) {
                const radiusSquared = radius * radius;
                this._snapToPositions.forEach((position) => {
                    const dist = Vector3.DistanceSquared(position, realPosition);
                    if (dist <= radiusSquared && dist < closestDistance) {
                        closestDistance = dist;
                        closestPoint = position;
                    }
                });
            }
            return closestPoint;
        }
        _setTargetMeshPosition(pickInfo) {
            const newPosition = pickInfo.pickedPoint;
            if (!this._options.teleportationTargetMesh || !newPosition) {
                return;
            }
            const snapPosition = this._findClosestSnapPointWithRadius(newPosition);
            this._snappedToPoint = !!snapPosition;
            if (this.snapPointsOnly && !this._snappedToPoint && this._teleportationRingMaterial) {
                this._teleportationRingMaterial.diffuseColor.set(1.0, 0.3, 0.3);
            }
            else if (this.snapPointsOnly && this._snappedToPoint && this._teleportationRingMaterial) {
                this._teleportationRingMaterial.diffuseColor.set(0.3, 0.3, 1.0);
            }
            this._options.teleportationTargetMesh.position.copyFrom(snapPosition || newPosition);
            this._options.teleportationTargetMesh.position.y += 0.01;
            this.onTargetMeshPositionUpdatedObservable.notifyObservers(pickInfo);
        }
        _setTargetMeshVisibility(visible, force) {
            if (!this._options.teleportationTargetMesh) {
                return;
            }
            if (this._options.teleportationTargetMesh.isVisible === visible && !force) {
                return;
            }
            this._options.teleportationTargetMesh.isVisible = visible;
            this._options.teleportationTargetMesh.getChildren(undefined, false).forEach((m) => {
                m.isVisible = visible;
            });
            if (!visible) {
                if (this._quadraticBezierCurve) {
                    this._quadraticBezierCurve.dispose();
                    this._quadraticBezierCurve = null;
                }
                if (this._selectionFeature) {
                    this._selectionFeature.attach();
                }
            }
            else {
                if (this._selectionFeature) {
                    this._selectionFeature.detach();
                }
            }
        }
        _disposeBezierCurve() {
            if (this._quadraticBezierCurve) {
                this._quadraticBezierCurve.dispose();
                this._quadraticBezierCurve = null;
            }
        }
        _showParabolicPath(pickInfo) {
            if (!pickInfo.pickedPoint || !this._currentTeleportationControllerId) {
                return;
            }
            const sceneToRenderTo = this._options.useUtilityLayer
                ? this._options.customUtilityLayerScene || UtilityLayerRenderer.DefaultUtilityLayer.utilityLayerScene
                : this._xrSessionManager.scene;
            const controllerData = this._controllers[this._currentTeleportationControllerId];
            const quadraticBezierVectors = Curve3.CreateQuadraticBezier(controllerData.xrController.pointer.absolutePosition, pickInfo.ray.origin, pickInfo.pickedPoint, 25);
            const color = controllerData.teleportationState.blocked ? this._blockedRayColor : undefined;
            const colorsArray = new Array(26).fill(color || this._cachedColor4White);
            if (!this._options.generateRayPathMesh) {
                this._quadraticBezierCurve = CreateLines("teleportation path line", { points: quadraticBezierVectors.getPoints(), instance: this._quadraticBezierCurve, updatable: true, colors: colorsArray }, sceneToRenderTo);
            }
            else {
                this._quadraticBezierCurve = this._options.generateRayPathMesh(quadraticBezierVectors.getPoints(), pickInfo);
            }
            this._quadraticBezierCurve.isPickable = false;
            if (this._options.renderingGroupId !== undefined) {
                this._quadraticBezierCurve.renderingGroupId = this._options.renderingGroupId;
            }
        }
        _teleportForward(controllerId) {
            const controllerData = this._controllers[controllerId];
            if (!controllerData || !controllerData.teleportationState.forward || !this.teleportationEnabled) {
                return;
            }
            controllerData.teleportationState.forward = false;
            this._currentTeleportationControllerId = "";
            if (this.snapPointsOnly && !this._snappedToPoint) {
                return;
            }
            if (this.skipNextTeleportation) {
                this.skipNextTeleportation = false;
                return;
            }
            // do the movement forward here
            if (this._options.teleportationTargetMesh && this._options.teleportationTargetMesh.isVisible) {
                const height = this._options.xrInput.xrCamera.realWorldHeight;
                this._options.xrInput.xrCamera.onBeforeCameraTeleport.notifyObservers(this._options.xrInput.xrCamera.position);
                this._options.xrInput.xrCamera.position.copyFrom(this._options.teleportationTargetMesh.position);
                this._options.xrInput.xrCamera.position.y += height;
                Quaternion.FromEulerAngles(0, controllerData.teleportationState.currentRotation - (this._xrSessionManager.scene.useRightHandedSystem ? Math.PI : 0), 0).multiplyToRef(this._options.xrInput.xrCamera.rotationQuaternion, this._options.xrInput.xrCamera.rotationQuaternion);
                this._options.xrInput.xrCamera.onAfterCameraTeleport.notifyObservers(this._options.xrInput.xrCamera.position);
            }
        }
    }
    /**
     * The module's name
     */
    WebXRMotionControllerTeleportation.Name = WebXRFeatureName.TELEPORTATION;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the webxr specs version
     */
    WebXRMotionControllerTeleportation.Version = 1;
    WebXRFeaturesManager.AddWebXRFeature(WebXRMotionControllerTeleportation.Name, (xrSessionManager, options) => {
        return () => new WebXRMotionControllerTeleportation(xrSessionManager, options);
    }, WebXRMotionControllerTeleportation.Version, true);

    /**
     * Default experience which provides a similar setup to the previous webVRExperience
     */
    class WebXRDefaultExperience {
        constructor() { }
        /**
         * Creates the default xr experience
         * @param scene scene
         * @param options options for basic configuration
         * @returns resulting WebXRDefaultExperience
         */
        static CreateAsync(scene, options = {}) {
            const result = new WebXRDefaultExperience();
            scene.onDisposeObservable.addOnce(() => {
                result.dispose();
            });
            // init the UI right after construction
            if (!options.disableDefaultUI) {
                const uiOptions = Object.assign({ renderTarget: result.renderTarget }, (options.uiOptions || {}));
                if (options.optionalFeatures) {
                    if (typeof options.optionalFeatures === "boolean") {
                        uiOptions.optionalFeatures = ["hit-test", "anchors", "plane-detection", "hand-tracking"];
                    }
                    else {
                        uiOptions.optionalFeatures = options.optionalFeatures;
                    }
                }
                result.enterExitUI = new WebXREnterExitUI(scene, uiOptions);
            }
            // Create base experience
            return WebXRExperienceHelper.CreateAsync(scene)
                .then((xrHelper) => {
                result.baseExperience = xrHelper;
                if (options.ignoreNativeCameraTransformation) {
                    result.baseExperience.camera.compensateOnFirstFrame = false;
                }
                // Add controller support
                result.input = new WebXRInput(xrHelper.sessionManager, xrHelper.camera, Object.assign({ controllerOptions: {
                        renderingGroupId: options.renderingGroupId,
                    } }, (options.inputOptions || {})));
                if (!options.disablePointerSelection) {
                    // Add default pointer selection
                    const pointerSelectionOptions = Object.assign(Object.assign({}, options.pointerSelectionOptions), { xrInput: result.input, renderingGroupId: options.renderingGroupId });
                    result.pointerSelection = (result.baseExperience.featuresManager.enableFeature(WebXRControllerPointerSelection.Name, options.useStablePlugins ? "stable" : "latest", pointerSelectionOptions));
                    if (!options.disableTeleportation) {
                        // Add default teleportation, including rotation
                        result.teleportation = result.baseExperience.featuresManager.enableFeature(WebXRMotionControllerTeleportation.Name, options.useStablePlugins ? "stable" : "latest", Object.assign({ floorMeshes: options.floorMeshes, xrInput: result.input, renderingGroupId: options.renderingGroupId }, options.teleportationOptions));
                        result.teleportation.setSelectionFeature(result.pointerSelection);
                    }
                }
                if (!options.disableNearInteraction) {
                    // Add default pointer selection
                    result.nearInteraction = result.baseExperience.featuresManager.enableFeature(WebXRNearInteraction.Name, options.useStablePlugins ? "stable" : "latest", Object.assign({ xrInput: result.input, farInteractionFeature: result.pointerSelection, renderingGroupId: options.renderingGroupId, useUtilityLayer: true, enableNearInteractionOnAllControllers: true }, options.nearInteractionOptions));
                }
                // Create the WebXR output target
                result.renderTarget = result.baseExperience.sessionManager.getWebXRRenderTarget(options.outputCanvasOptions);
                if (!options.disableDefaultUI) {
                    // Create ui for entering/exiting xr
                    return result.enterExitUI.setHelperAsync(result.baseExperience, result.renderTarget);
                }
                else {
                    return;
                }
            })
                .then(() => {
                return result;
            })
                .catch((error) => {
                Logger.Error("Error initializing XR");
                Logger.Error(error);
                return result;
            });
        }
        /**
         * Disposes of the experience helper
         */
        dispose() {
            if (this.baseExperience) {
                this.baseExperience.dispose();
            }
            if (this.input) {
                this.input.dispose();
            }
            if (this.enterExitUI) {
                this.enterExitUI.dispose();
            }
            if (this.renderTarget) {
                this.renderTarget.dispose();
            }
        }
    }

    Scene.prototype.createDefaultLight = function (replace = false) {
        // Dispose existing light in replace mode.
        if (replace) {
            if (this.lights) {
                for (let i = 0; i < this.lights.length; i++) {
                    this.lights[i].dispose();
                }
            }
        }
        // Light
        if (this.lights.length === 0) {
            new HemisphericLight("default light", Vector3.Up(), this);
        }
    };
    Scene.prototype.createDefaultCamera = function (createArcRotateCamera = false, replace = false, attachCameraControls = false) {
        // Dispose existing camera in replace mode.
        if (replace) {
            if (this.activeCamera) {
                this.activeCamera.dispose();
                this.activeCamera = null;
            }
        }
        // Camera
        if (!this.activeCamera) {
            const worldExtends = this.getWorldExtends((mesh) => mesh.isVisible && mesh.isEnabled());
            const worldSize = worldExtends.max.subtract(worldExtends.min);
            const worldCenter = worldExtends.min.add(worldSize.scale(0.5));
            let camera;
            let radius = worldSize.length() * 1.5;
            // empty scene scenario!
            if (!isFinite(radius)) {
                radius = 1;
                worldCenter.copyFromFloats(0, 0, 0);
            }
            if (createArcRotateCamera) {
                const arcRotateCamera = new ArcRotateCamera("default camera", -(Math.PI / 2), Math.PI / 2, radius, worldCenter, this);
                arcRotateCamera.lowerRadiusLimit = radius * 0.01;
                arcRotateCamera.wheelPrecision = 100 / radius;
                camera = arcRotateCamera;
            }
            else {
                const freeCamera = new FreeCamera("default camera", new Vector3(worldCenter.x, worldCenter.y, -radius), this);
                freeCamera.setTarget(worldCenter);
                camera = freeCamera;
            }
            camera.minZ = radius * 0.01;
            camera.maxZ = radius * 1000;
            camera.speed = radius * 0.2;
            this.activeCamera = camera;
            if (attachCameraControls) {
                camera.attachControl();
            }
        }
    };
    Scene.prototype.createDefaultCameraOrLight = function (createArcRotateCamera = false, replace = false, attachCameraControls = false) {
        this.createDefaultLight(replace);
        this.createDefaultCamera(createArcRotateCamera, replace, attachCameraControls);
    };
    Scene.prototype.createDefaultSkybox = function (environmentTexture, pbr = false, scale = 1000, blur = 0, setGlobalEnvTexture = true) {
        if (!environmentTexture) {
            Logger.Warn("Can not create default skybox without environment texture.");
            return null;
        }
        if (setGlobalEnvTexture) {
            if (environmentTexture) {
                this.environmentTexture = environmentTexture;
            }
        }
        // Skybox
        const hdrSkybox = CreateBox("hdrSkyBox", { size: scale }, this);
        if (pbr) {
            const hdrSkyboxMaterial = new PBRMaterial("skyBox", this);
            hdrSkyboxMaterial.backFaceCulling = false;
            hdrSkyboxMaterial.reflectionTexture = environmentTexture.clone();
            if (hdrSkyboxMaterial.reflectionTexture) {
                hdrSkyboxMaterial.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
            }
            hdrSkyboxMaterial.microSurface = 1.0 - blur;
            hdrSkyboxMaterial.disableLighting = true;
            hdrSkyboxMaterial.twoSidedLighting = true;
            hdrSkybox.material = hdrSkyboxMaterial;
        }
        else {
            const skyboxMaterial = new StandardMaterial("skyBox", this);
            skyboxMaterial.backFaceCulling = false;
            skyboxMaterial.reflectionTexture = environmentTexture.clone();
            if (skyboxMaterial.reflectionTexture) {
                skyboxMaterial.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
            }
            skyboxMaterial.disableLighting = true;
            hdrSkybox.material = skyboxMaterial;
        }
        hdrSkybox.isPickable = false;
        hdrSkybox.infiniteDistance = true;
        hdrSkybox.ignoreCameraMaxZ = true;
        return hdrSkybox;
    };
    Scene.prototype.createDefaultEnvironment = function (options) {
        if (EnvironmentHelper) {
            return new EnvironmentHelper(options, this);
        }
        return null;
    };
    Scene.prototype.createDefaultVRExperience = function (webVROptions = {}) {
        return new VRExperienceHelper(this, webVROptions);
    };
    Scene.prototype.createDefaultXRExperienceAsync = function (options = {}) {
        return WebXRDefaultExperience.CreateAsync(this, options).then((helper) => {
            return helper;
        });
    };

    // Do not edit.
    const name$1_ = "glowMapGenerationPixelShader";
    const shader$1_ = `#if defined(DIFFUSE_ISLINEAR) || defined(EMISSIVE_ISLINEAR)
#include<helperFunctions>
#endif
#ifdef DIFFUSE
varying vec2 vUVDiffuse;uniform sampler2D diffuseSampler;
#endif
#ifdef OPACITY
varying vec2 vUVOpacity;uniform sampler2D opacitySampler;uniform float opacityIntensity;
#endif
#ifdef EMISSIVE
varying vec2 vUVEmissive;uniform sampler2D emissiveSampler;
#endif
#ifdef VERTEXALPHA
varying vec4 vColor;
#endif
uniform vec4 glowColor;uniform float glowIntensity;
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#include<clipPlaneFragment>
vec4 finalColor=glowColor;
#ifdef DIFFUSE
vec4 albedoTexture=texture2D(diffuseSampler,vUVDiffuse);
#ifdef DIFFUSE_ISLINEAR
albedoTexture=toGammaSpace(albedoTexture);
#endif
#ifdef GLOW
finalColor.a*=albedoTexture.a;
#endif
#ifdef HIGHLIGHT
finalColor.a=albedoTexture.a;
#endif
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vUVOpacity);
#ifdef OPACITYRGB
finalColor.a*=getLuminance(opacityMap.rgb);
#else
finalColor.a*=opacityMap.a;
#endif
finalColor.a*=opacityIntensity;
#endif
#ifdef VERTEXALPHA
finalColor.a*=vColor.a;
#endif
#ifdef ALPHATEST
if (finalColor.a<ALPHATESTVALUE)
discard;
#endif
#ifdef EMISSIVE
vec4 emissive=texture2D(emissiveSampler,vUVEmissive);
#ifdef EMISSIVE_ISLINEAR
emissive=toGammaSpace(emissive);
#endif
gl_FragColor=emissive*finalColor*glowIntensity;
#else
gl_FragColor=finalColor*glowIntensity;
#endif
#ifdef HIGHLIGHT
gl_FragColor.a=glowColor.a;
#endif
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1_] = shader$1_;

    // Do not edit.
    const name$1$ = "glowMapGenerationVertexShader";
    const shader$1$ = `attribute vec3 position;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
#include<instancesDeclaration>
uniform mat4 viewProjection;varying vec4 vPosition;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#ifdef DIFFUSE
varying vec2 vUVDiffuse;uniform mat4 diffuseMatrix;
#endif
#ifdef OPACITY
varying vec2 vUVOpacity;uniform mat4 opacityMatrix;
#endif
#ifdef EMISSIVE
varying vec2 vUVEmissive;uniform mat4 emissiveMatrix;
#endif
#ifdef VERTEXALPHA
attribute vec4 color;varying vec4 vColor;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef CUBEMAP
vPosition=worldPos;gl_Position=viewProjection*finalWorld*vec4(position,1.0);
#else
vPosition=viewProjection*worldPos;gl_Position=vPosition;
#endif
#ifdef DIFFUSE
#ifdef DIFFUSEUV1
vUVDiffuse=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef DIFFUSEUV2
vUVDiffuse=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#ifdef OPACITY
#ifdef OPACITYUV1
vUVOpacity=vec2(opacityMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef OPACITYUV2
vUVOpacity=vec2(opacityMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#ifdef EMISSIVE
#ifdef EMISSIVEUV1
vUVEmissive=vec2(emissiveMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef EMISSIVEUV2
vUVEmissive=vec2(emissiveMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#ifdef VERTEXALPHA
vColor=color;
#endif
#include<clipPlaneVertex>
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$1$] = shader$1$;

    /**
     * The effect layer Helps adding post process effect blended with the main pass.
     *
     * This can be for instance use to generate glow or highlight effects on the scene.
     *
     * The effect layer class can not be used directly and is intented to inherited from to be
     * customized per effects.
     */
    class EffectLayer {
        /**
         * Gets the camera attached to the layer.
         */
        get camera() {
            return this._effectLayerOptions.camera;
        }
        /**
         * Gets the rendering group id the layer should render in.
         */
        get renderingGroupId() {
            return this._effectLayerOptions.renderingGroupId;
        }
        set renderingGroupId(renderingGroupId) {
            this._effectLayerOptions.renderingGroupId = renderingGroupId;
        }
        /**
         * Gets the main texture where the effect is rendered
         */
        get mainTexture() {
            return this._mainTexture;
        }
        /**
         * Sets a specific material to be used to render a mesh/a list of meshes in the layer
         * @param mesh mesh or array of meshes
         * @param material material to use by the layer when rendering the mesh(es). If undefined is passed, the specific material created by the layer will be used.
         */
        setMaterialForRendering(mesh, material) {
            this._mainTexture.setMaterialForRendering(mesh, material);
            if (Array.isArray(mesh)) {
                for (let i = 0; i < mesh.length; ++i) {
                    const currentMesh = mesh[i];
                    if (!material) {
                        delete this._materialForRendering[currentMesh.uniqueId];
                    }
                    else {
                        this._materialForRendering[currentMesh.uniqueId] = [currentMesh, material];
                    }
                }
            }
            else {
                if (!material) {
                    delete this._materialForRendering[mesh.uniqueId];
                }
                else {
                    this._materialForRendering[mesh.uniqueId] = [mesh, material];
                }
            }
        }
        /**
         * Gets the intensity of the effect for a specific mesh.
         * @param mesh The mesh to get the effect intensity for
         * @returns The intensity of the effect for the mesh
         */
        getEffectIntensity(mesh) {
            var _a;
            return (_a = this._effectIntensity[mesh.uniqueId]) !== null && _a !== void 0 ? _a : 1;
        }
        /**
         * Sets the intensity of the effect for a specific mesh.
         * @param mesh The mesh to set the effect intensity for
         * @param intensity The intensity of the effect for the mesh
         */
        setEffectIntensity(mesh, intensity) {
            this._effectIntensity[mesh.uniqueId] = intensity;
        }
        /**
         * Instantiates a new effect Layer and references it in the scene.
         * @param name The name of the layer
         * @param scene The scene to use the layer in
         */
        constructor(
        /** The Friendly of the effect in the scene */
        name, scene) {
            this._vertexBuffers = {};
            this._maxSize = 0;
            this._mainTextureDesiredSize = { width: 0, height: 0 };
            this._shouldRender = true;
            this._postProcesses = [];
            this._textures = [];
            this._emissiveTextureAndColor = { texture: null, color: new Color4() };
            this._effectIntensity = {};
            /**
             * The clear color of the texture used to generate the glow map.
             */
            this.neutralColor = new Color4();
            /**
             * Specifies whether the highlight layer is enabled or not.
             */
            this.isEnabled = true;
            /**
             * Specifies if the bounding boxes should be rendered normally or if they should undergo the effect of the layer
             */
            this.disableBoundingBoxesFromEffectLayer = false;
            /**
             * An event triggered when the effect layer has been disposed.
             */
            this.onDisposeObservable = new Observable$1();
            /**
             * An event triggered when the effect layer is about rendering the main texture with the glowy parts.
             */
            this.onBeforeRenderMainTextureObservable = new Observable$1();
            /**
             * An event triggered when the generated texture is being merged in the scene.
             */
            this.onBeforeComposeObservable = new Observable$1();
            /**
             * An event triggered when the mesh is rendered into the effect render target.
             */
            this.onBeforeRenderMeshToEffect = new Observable$1();
            /**
             * An event triggered after the mesh has been rendered into the effect render target.
             */
            this.onAfterRenderMeshToEffect = new Observable$1();
            /**
             * An event triggered when the generated texture has been merged in the scene.
             */
            this.onAfterComposeObservable = new Observable$1();
            /**
             * An event triggered when the effect layer changes its size.
             */
            this.onSizeChangedObservable = new Observable$1();
            this._materialForRendering = {};
            this.name = name;
            this._scene = scene || EngineStore.LastCreatedScene;
            EffectLayer._SceneComponentInitialization(this._scene);
            this._engine = this._scene.getEngine();
            this._maxSize = this._engine.getCaps().maxTextureSize;
            this._scene.effectLayers.push(this);
            this._mergeDrawWrapper = [];
            // Generate Buffers
            this._generateIndexBuffer();
            this._generateVertexBuffer();
        }
        /**
         * Number of times _internalRender will be called. Some effect layers need to render the mesh several times, so they should override this method with the number of times the mesh should be rendered
         * @returns Number of times a mesh must be rendered in the layer
         */
        _numInternalDraws() {
            return 1;
        }
        /**
         * Initializes the effect layer with the required options.
         * @param options Sets of none mandatory options to use with the layer (see IEffectLayerOptions for more information)
         */
        _init(options) {
            // Adapt options
            this._effectLayerOptions = Object.assign({ mainTextureRatio: 0.5, alphaBlendingMode: 2, camera: null, renderingGroupId: -1, mainTextureType: 0, generateStencilBuffer: false }, options);
            this._setMainTextureSize();
            this._createMainTexture();
            this._createTextureAndPostProcesses();
        }
        /**
         * Generates the index buffer of the full screen quad blending to the main canvas.
         */
        _generateIndexBuffer() {
            // Indices
            const indices = [];
            indices.push(0);
            indices.push(1);
            indices.push(2);
            indices.push(0);
            indices.push(2);
            indices.push(3);
            this._indexBuffer = this._engine.createIndexBuffer(indices);
        }
        /**
         * Generates the vertex buffer of the full screen quad blending to the main canvas.
         */
        _generateVertexBuffer() {
            // VBO
            const vertices = [];
            vertices.push(1, 1);
            vertices.push(-1, 1);
            vertices.push(-1, -1);
            vertices.push(1, -1);
            const vertexBuffer = new VertexBuffer(this._engine, vertices, VertexBuffer.PositionKind, false, false, 2);
            this._vertexBuffers[VertexBuffer.PositionKind] = vertexBuffer;
        }
        /**
         * Sets the main texture desired size which is the closest power of two
         * of the engine canvas size.
         */
        _setMainTextureSize() {
            if (this._effectLayerOptions.mainTextureFixedSize) {
                this._mainTextureDesiredSize.width = this._effectLayerOptions.mainTextureFixedSize;
                this._mainTextureDesiredSize.height = this._effectLayerOptions.mainTextureFixedSize;
            }
            else {
                this._mainTextureDesiredSize.width = this._engine.getRenderWidth() * this._effectLayerOptions.mainTextureRatio;
                this._mainTextureDesiredSize.height = this._engine.getRenderHeight() * this._effectLayerOptions.mainTextureRatio;
                this._mainTextureDesiredSize.width = this._engine.needPOTTextures
                    ? Engine.GetExponentOfTwo(this._mainTextureDesiredSize.width, this._maxSize)
                    : this._mainTextureDesiredSize.width;
                this._mainTextureDesiredSize.height = this._engine.needPOTTextures
                    ? Engine.GetExponentOfTwo(this._mainTextureDesiredSize.height, this._maxSize)
                    : this._mainTextureDesiredSize.height;
            }
            this._mainTextureDesiredSize.width = Math.floor(this._mainTextureDesiredSize.width);
            this._mainTextureDesiredSize.height = Math.floor(this._mainTextureDesiredSize.height);
        }
        /**
         * Creates the main texture for the effect layer.
         */
        _createMainTexture() {
            this._mainTexture = new RenderTargetTexture("EffectLayerMainRTT", {
                width: this._mainTextureDesiredSize.width,
                height: this._mainTextureDesiredSize.height,
            }, this._scene, false, true, this._effectLayerOptions.mainTextureType, false, Texture.TRILINEAR_SAMPLINGMODE, true, this._effectLayerOptions.generateStencilBuffer);
            this._mainTexture.activeCamera = this._effectLayerOptions.camera;
            this._mainTexture.wrapU = Texture.CLAMP_ADDRESSMODE;
            this._mainTexture.wrapV = Texture.CLAMP_ADDRESSMODE;
            this._mainTexture.anisotropicFilteringLevel = 1;
            this._mainTexture.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
            this._mainTexture.renderParticles = false;
            this._mainTexture.renderList = null;
            this._mainTexture.ignoreCameraViewport = true;
            for (const id in this._materialForRendering) {
                const [mesh, material] = this._materialForRendering[id];
                this._mainTexture.setMaterialForRendering(mesh, material);
            }
            this._mainTexture.customIsReadyFunction = (mesh, refreshRate, preWarm) => {
                if ((preWarm || refreshRate === 0) && mesh.subMeshes) {
                    for (let i = 0; i < mesh.subMeshes.length; ++i) {
                        const subMesh = mesh.subMeshes[i];
                        const material = subMesh.getMaterial();
                        const renderingMesh = subMesh.getRenderingMesh();
                        if (!material) {
                            continue;
                        }
                        const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                        const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances;
                        this._setEmissiveTextureAndColor(renderingMesh, subMesh, material);
                        if (!this._isReady(subMesh, hardwareInstancedRendering, this._emissiveTextureAndColor.texture)) {
                            return false;
                        }
                    }
                }
                return true;
            };
            // Custom render function
            this._mainTexture.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes) => {
                this.onBeforeRenderMainTextureObservable.notifyObservers(this);
                let index;
                const engine = this._scene.getEngine();
                if (depthOnlySubMeshes.length) {
                    engine.setColorWrite(false);
                    for (index = 0; index < depthOnlySubMeshes.length; index++) {
                        this._renderSubMesh(depthOnlySubMeshes.data[index]);
                    }
                    engine.setColorWrite(true);
                }
                for (index = 0; index < opaqueSubMeshes.length; index++) {
                    this._renderSubMesh(opaqueSubMeshes.data[index]);
                }
                for (index = 0; index < alphaTestSubMeshes.length; index++) {
                    this._renderSubMesh(alphaTestSubMeshes.data[index]);
                }
                const previousAlphaMode = engine.getAlphaMode();
                for (index = 0; index < transparentSubMeshes.length; index++) {
                    this._renderSubMesh(transparentSubMeshes.data[index], true);
                }
                engine.setAlphaMode(previousAlphaMode);
            };
            this._mainTexture.onClearObservable.add((engine) => {
                engine.clear(this.neutralColor, true, true, true);
            });
            // Prevent package size in es6 (getBoundingBoxRenderer might not be present)
            if (this._scene.getBoundingBoxRenderer) {
                const boundingBoxRendererEnabled = this._scene.getBoundingBoxRenderer().enabled;
                this._mainTexture.onBeforeBindObservable.add(() => {
                    this._scene.getBoundingBoxRenderer().enabled = !this.disableBoundingBoxesFromEffectLayer && boundingBoxRendererEnabled;
                });
                this._mainTexture.onAfterUnbindObservable.add(() => {
                    this._scene.getBoundingBoxRenderer().enabled = boundingBoxRendererEnabled;
                });
            }
        }
        /**
         * Adds specific effects defines.
         * @param defines The defines to add specifics to.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _addCustomEffectDefines(defines) {
            // Nothing to add by default.
        }
        /**
         * Checks for the readiness of the element composing the layer.
         * @param subMesh the mesh to check for
         * @param useInstances specify whether or not to use instances to render the mesh
         * @param emissiveTexture the associated emissive texture used to generate the glow
         * @returns true if ready otherwise, false
         */
        _isReady(subMesh, useInstances, emissiveTexture) {
            var _a;
            const engine = this._scene.getEngine();
            const mesh = subMesh.getMesh();
            const renderingMaterial = (_a = mesh._internalAbstractMeshDataInfo._materialForRenderPass) === null || _a === void 0 ? void 0 : _a[engine.currentRenderPassId];
            if (renderingMaterial) {
                return renderingMaterial.isReadyForSubMesh(mesh, subMesh, useInstances);
            }
            const material = subMesh.getMaterial();
            if (!material) {
                return false;
            }
            if (this._useMeshMaterial(subMesh.getRenderingMesh())) {
                return material.isReadyForSubMesh(subMesh.getMesh(), subMesh, useInstances);
            }
            const defines = [];
            const attribs = [VertexBuffer.PositionKind];
            let uv1 = false;
            let uv2 = false;
            // Diffuse
            if (material) {
                const needAlphaTest = material.needAlphaTesting();
                const diffuseTexture = material.getAlphaTestTexture();
                const needAlphaBlendFromDiffuse = diffuseTexture && diffuseTexture.hasAlpha && (material.useAlphaFromDiffuseTexture || material._useAlphaFromAlbedoTexture);
                if (diffuseTexture && (needAlphaTest || needAlphaBlendFromDiffuse)) {
                    defines.push("#define DIFFUSE");
                    if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind) && diffuseTexture.coordinatesIndex === 1) {
                        defines.push("#define DIFFUSEUV2");
                        uv2 = true;
                    }
                    else if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                        defines.push("#define DIFFUSEUV1");
                        uv1 = true;
                    }
                    if (needAlphaTest) {
                        defines.push("#define ALPHATEST");
                        defines.push("#define ALPHATESTVALUE 0.4");
                    }
                    if (!diffuseTexture.gammaSpace) {
                        defines.push("#define DIFFUSE_ISLINEAR");
                    }
                }
                const opacityTexture = material.opacityTexture;
                if (opacityTexture) {
                    defines.push("#define OPACITY");
                    if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind) && opacityTexture.coordinatesIndex === 1) {
                        defines.push("#define OPACITYUV2");
                        uv2 = true;
                    }
                    else if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                        defines.push("#define OPACITYUV1");
                        uv1 = true;
                    }
                }
            }
            // Emissive
            if (emissiveTexture) {
                defines.push("#define EMISSIVE");
                if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind) && emissiveTexture.coordinatesIndex === 1) {
                    defines.push("#define EMISSIVEUV2");
                    uv2 = true;
                }
                else if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                    defines.push("#define EMISSIVEUV1");
                    uv1 = true;
                }
                if (!emissiveTexture.gammaSpace) {
                    defines.push("#define EMISSIVE_ISLINEAR");
                }
            }
            // Vertex
            if (mesh.useVertexColors && mesh.isVerticesDataPresent(VertexBuffer.ColorKind) && mesh.hasVertexAlpha && material.transparencyMode !== Material.MATERIAL_OPAQUE) {
                attribs.push(VertexBuffer.ColorKind);
                defines.push("#define VERTEXALPHA");
            }
            if (uv1) {
                attribs.push(VertexBuffer.UVKind);
                defines.push("#define UV1");
            }
            if (uv2) {
                attribs.push(VertexBuffer.UV2Kind);
                defines.push("#define UV2");
            }
            // Bones
            const fallbacks = new EffectFallbacks();
            if (mesh.useBones && mesh.computeBonesUsingShaders) {
                attribs.push(VertexBuffer.MatricesIndicesKind);
                attribs.push(VertexBuffer.MatricesWeightsKind);
                if (mesh.numBoneInfluencers > 4) {
                    attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                    attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                }
                defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                const skeleton = mesh.skeleton;
                if (skeleton && skeleton.isUsingTextureForMatrices) {
                    defines.push("#define BONETEXTURE");
                }
                else {
                    defines.push("#define BonesPerMesh " + (skeleton ? skeleton.bones.length + 1 : 0));
                }
                if (mesh.numBoneInfluencers > 0) {
                    fallbacks.addCPUSkinningFallback(0, mesh);
                }
            }
            else {
                defines.push("#define NUM_BONE_INFLUENCERS 0");
            }
            // Morph targets
            const manager = mesh.morphTargetManager;
            let morphInfluencers = 0;
            if (manager) {
                if (manager.numInfluencers > 0) {
                    defines.push("#define MORPHTARGETS");
                    morphInfluencers = manager.numInfluencers;
                    defines.push("#define NUM_MORPH_INFLUENCERS " + morphInfluencers);
                    if (manager.isUsingTextureForTargets) {
                        defines.push("#define MORPHTARGETS_TEXTURE");
                    }
                    MaterialHelper.PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, morphInfluencers);
                }
            }
            // Instances
            if (useInstances) {
                defines.push("#define INSTANCES");
                MaterialHelper.PushAttributesForInstances(attribs);
                if (subMesh.getRenderingMesh().hasThinInstances) {
                    defines.push("#define THIN_INSTANCES");
                }
            }
            // ClipPlanes
            prepareStringDefinesForClipPlanes(material, this._scene, defines);
            this._addCustomEffectDefines(defines);
            // Get correct effect
            const drawWrapper = subMesh._getDrawWrapper(undefined, true);
            const cachedDefines = drawWrapper.defines;
            const join = defines.join("\n");
            if (cachedDefines !== join) {
                const uniforms = [
                    "world",
                    "mBones",
                    "viewProjection",
                    "glowColor",
                    "morphTargetInfluences",
                    "boneTextureWidth",
                    "diffuseMatrix",
                    "emissiveMatrix",
                    "opacityMatrix",
                    "opacityIntensity",
                    "morphTargetTextureInfo",
                    "morphTargetTextureIndices",
                    "glowIntensity",
                ];
                addClipPlaneUniforms(uniforms);
                drawWrapper.setEffect(this._engine.createEffect("glowMapGeneration", attribs, uniforms, ["diffuseSampler", "emissiveSampler", "opacitySampler", "boneSampler", "morphTargets"], join, fallbacks, undefined, undefined, { maxSimultaneousMorphTargets: morphInfluencers }), join);
            }
            return drawWrapper.effect.isReady();
        }
        /**
         * Renders the glowing part of the scene by blending the blurred glowing meshes on top of the rendered scene.
         */
        render() {
            for (let i = 0; i < this._postProcesses.length; i++) {
                if (!this._postProcesses[i].isReady()) {
                    return;
                }
            }
            const engine = this._scene.getEngine();
            const numDraws = this._numInternalDraws();
            // Check
            let isReady = true;
            for (let i = 0; i < numDraws; ++i) {
                let currentEffect = this._mergeDrawWrapper[i];
                if (!currentEffect) {
                    currentEffect = this._mergeDrawWrapper[i] = new DrawWrapper(this._engine);
                    currentEffect.setEffect(this._createMergeEffect());
                }
                isReady = isReady && currentEffect.effect.isReady();
            }
            if (!isReady) {
                return;
            }
            this.onBeforeComposeObservable.notifyObservers(this);
            const previousAlphaMode = engine.getAlphaMode();
            for (let i = 0; i < numDraws; ++i) {
                const currentEffect = this._mergeDrawWrapper[i];
                // Render
                engine.enableEffect(currentEffect);
                engine.setState(false);
                // VBOs
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, currentEffect.effect);
                // Go Blend.
                engine.setAlphaMode(this._effectLayerOptions.alphaBlendingMode);
                // Blends the map on the main canvas.
                this._internalRender(currentEffect.effect, i);
            }
            // Restore Alpha
            engine.setAlphaMode(previousAlphaMode);
            this.onAfterComposeObservable.notifyObservers(this);
            // Handle size changes.
            const size = this._mainTexture.getSize();
            this._setMainTextureSize();
            if ((size.width !== this._mainTextureDesiredSize.width || size.height !== this._mainTextureDesiredSize.height) &&
                this._mainTextureDesiredSize.width !== 0 &&
                this._mainTextureDesiredSize.height !== 0) {
                // Recreate RTT and post processes on size change.
                this.onSizeChangedObservable.notifyObservers(this);
                this._disposeTextureAndPostProcesses();
                this._createMainTexture();
                this._createTextureAndPostProcesses();
            }
        }
        /**
         * Determine if a given mesh will be used in the current effect.
         * @param mesh mesh to test
         * @returns true if the mesh will be used
         */
        hasMesh(mesh) {
            if (this.renderingGroupId === -1 || mesh.renderingGroupId === this.renderingGroupId) {
                return true;
            }
            return false;
        }
        /**
         * Returns true if the layer contains information to display, otherwise false.
         * @returns true if the glow layer should be rendered
         */
        shouldRender() {
            return this.isEnabled && this._shouldRender;
        }
        /**
         * Returns true if the mesh should render, otherwise false.
         * @param mesh The mesh to render
         * @returns true if it should render otherwise false
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _shouldRenderMesh(mesh) {
            return true;
        }
        /**
         * Returns true if the mesh can be rendered, otherwise false.
         * @param mesh The mesh to render
         * @param material The material used on the mesh
         * @returns true if it can be rendered otherwise false
         */
        _canRenderMesh(mesh, material) {
            return !material.needAlphaBlendingForMesh(mesh);
        }
        /**
         * Returns true if the mesh should render, otherwise false.
         * @returns true if it should render otherwise false
         */
        _shouldRenderEmissiveTextureForMesh() {
            return true;
        }
        /**
         * Renders the submesh passed in parameter to the generation map.
         * @param subMesh
         * @param enableAlphaMode
         */
        _renderSubMesh(subMesh, enableAlphaMode = false) {
            var _a, _b;
            if (!this.shouldRender()) {
                return;
            }
            const material = subMesh.getMaterial();
            const ownerMesh = subMesh.getMesh();
            const replacementMesh = subMesh.getReplacementMesh();
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = subMesh.getEffectiveMesh();
            const scene = this._scene;
            const engine = scene.getEngine();
            effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            if (!material) {
                return;
            }
            // Do not block in blend mode.
            if (!this._canRenderMesh(renderingMesh, material)) {
                return;
            }
            // Culling
            let sideOrientation = (_a = renderingMesh.overrideMaterialSideOrientation) !== null && _a !== void 0 ? _a : material.sideOrientation;
            const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
            if (mainDeterminant < 0) {
                sideOrientation = sideOrientation === Material.ClockWiseSideOrientation ? Material.CounterClockWiseSideOrientation : Material.ClockWiseSideOrientation;
            }
            const reverse = sideOrientation === Material.ClockWiseSideOrientation;
            engine.setState(material.backFaceCulling, material.zOffset, undefined, reverse, material.cullBackFaces, undefined, material.zOffsetUnits);
            // Managing instances
            const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!replacementMesh);
            if (batch.mustReturn) {
                return;
            }
            // Early Exit per mesh
            if (!this._shouldRenderMesh(renderingMesh)) {
                return;
            }
            const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances;
            this._setEmissiveTextureAndColor(renderingMesh, subMesh, material);
            this.onBeforeRenderMeshToEffect.notifyObservers(ownerMesh);
            if (this._useMeshMaterial(renderingMesh)) {
                renderingMesh.render(subMesh, enableAlphaMode, replacementMesh || undefined);
            }
            else if (this._isReady(subMesh, hardwareInstancedRendering, this._emissiveTextureAndColor.texture)) {
                const renderingMaterial = (_b = effectiveMesh._internalAbstractMeshDataInfo._materialForRenderPass) === null || _b === void 0 ? void 0 : _b[engine.currentRenderPassId];
                let drawWrapper = subMesh._getDrawWrapper();
                if (!drawWrapper && renderingMaterial) {
                    drawWrapper = renderingMaterial._getDrawWrapper();
                }
                if (!drawWrapper) {
                    return;
                }
                const effect = drawWrapper.effect;
                engine.enableEffect(drawWrapper);
                if (!hardwareInstancedRendering) {
                    renderingMesh._bind(subMesh, effect, material.fillMode);
                }
                if (!renderingMaterial) {
                    effect.setMatrix("viewProjection", scene.getTransformMatrix());
                    effect.setMatrix("world", effectiveMesh.getWorldMatrix());
                    effect.setFloat4("glowColor", this._emissiveTextureAndColor.color.r, this._emissiveTextureAndColor.color.g, this._emissiveTextureAndColor.color.b, this._emissiveTextureAndColor.color.a);
                }
                else {
                    renderingMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), effectiveMesh, subMesh);
                }
                if (!renderingMaterial) {
                    const needAlphaTest = material.needAlphaTesting();
                    const diffuseTexture = material.getAlphaTestTexture();
                    const needAlphaBlendFromDiffuse = diffuseTexture && diffuseTexture.hasAlpha && (material.useAlphaFromDiffuseTexture || material._useAlphaFromAlbedoTexture);
                    if (diffuseTexture && (needAlphaTest || needAlphaBlendFromDiffuse)) {
                        effect.setTexture("diffuseSampler", diffuseTexture);
                        const textureMatrix = diffuseTexture.getTextureMatrix();
                        if (textureMatrix) {
                            effect.setMatrix("diffuseMatrix", textureMatrix);
                        }
                    }
                    const opacityTexture = material.opacityTexture;
                    if (opacityTexture) {
                        effect.setTexture("opacitySampler", opacityTexture);
                        effect.setFloat("opacityIntensity", opacityTexture.level);
                        const textureMatrix = opacityTexture.getTextureMatrix();
                        if (textureMatrix) {
                            effect.setMatrix("opacityMatrix", textureMatrix);
                        }
                    }
                    // Glow emissive only
                    if (this._emissiveTextureAndColor.texture) {
                        effect.setTexture("emissiveSampler", this._emissiveTextureAndColor.texture);
                        effect.setMatrix("emissiveMatrix", this._emissiveTextureAndColor.texture.getTextureMatrix());
                    }
                    // Bones
                    if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                        const skeleton = renderingMesh.skeleton;
                        if (skeleton.isUsingTextureForMatrices) {
                            const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                            if (!boneTexture) {
                                return;
                            }
                            effect.setTexture("boneSampler", boneTexture);
                            effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                        }
                        else {
                            effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
                        }
                    }
                    // Morph targets
                    MaterialHelper.BindMorphTargetParameters(renderingMesh, effect);
                    if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) {
                        renderingMesh.morphTargetManager._bind(effect);
                    }
                    // Alpha mode
                    if (enableAlphaMode) {
                        engine.setAlphaMode(material.alphaMode);
                    }
                    // Intensity of effect
                    effect.setFloat("glowIntensity", this.getEffectIntensity(renderingMesh));
                    // Clip planes
                    bindClipPlane(effect, material, scene);
                }
                // Draw
                renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world) => effect.setMatrix("world", world));
            }
            else {
                // Need to reset refresh rate of the main map
                this._mainTexture.resetRefreshCounter();
            }
            this.onAfterRenderMeshToEffect.notifyObservers(ownerMesh);
        }
        /**
         * Defines whether the current material of the mesh should be use to render the effect.
         * @param mesh defines the current mesh to render
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _useMeshMaterial(mesh) {
            return false;
        }
        /**
         * Rebuild the required buffers.
         * @internal Internal use only.
         */
        _rebuild() {
            const vb = this._vertexBuffers[VertexBuffer.PositionKind];
            if (vb) {
                vb._rebuild();
            }
            this._generateIndexBuffer();
        }
        /**
         * Dispose only the render target textures and post process.
         */
        _disposeTextureAndPostProcesses() {
            this._mainTexture.dispose();
            for (let i = 0; i < this._postProcesses.length; i++) {
                if (this._postProcesses[i]) {
                    this._postProcesses[i].dispose();
                }
            }
            this._postProcesses = [];
            for (let i = 0; i < this._textures.length; i++) {
                if (this._textures[i]) {
                    this._textures[i].dispose();
                }
            }
            this._textures = [];
        }
        /**
         * Dispose the highlight layer and free resources.
         */
        dispose() {
            const vertexBuffer = this._vertexBuffers[VertexBuffer.PositionKind];
            if (vertexBuffer) {
                vertexBuffer.dispose();
                this._vertexBuffers[VertexBuffer.PositionKind] = null;
            }
            if (this._indexBuffer) {
                this._scene.getEngine()._releaseBuffer(this._indexBuffer);
                this._indexBuffer = null;
            }
            for (const drawWrapper of this._mergeDrawWrapper) {
                drawWrapper.dispose();
            }
            this._mergeDrawWrapper = [];
            // Clean textures and post processes
            this._disposeTextureAndPostProcesses();
            // Remove from scene
            const index = this._scene.effectLayers.indexOf(this, 0);
            if (index > -1) {
                this._scene.effectLayers.splice(index, 1);
            }
            // Callback
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
            this.onBeforeRenderMainTextureObservable.clear();
            this.onBeforeComposeObservable.clear();
            this.onBeforeRenderMeshToEffect.clear();
            this.onAfterRenderMeshToEffect.clear();
            this.onAfterComposeObservable.clear();
            this.onSizeChangedObservable.clear();
        }
        /**
         * Gets the class name of the effect layer
         * @returns the string with the class name of the effect layer
         */
        getClassName() {
            return "EffectLayer";
        }
        /**
         * Creates an effect layer from parsed effect layer data
         * @param parsedEffectLayer defines effect layer data
         * @param scene defines the current scene
         * @param rootUrl defines the root URL containing the effect layer information
         * @returns a parsed effect Layer
         */
        static Parse(parsedEffectLayer, scene, rootUrl) {
            const effectLayerType = Tools.Instantiate(parsedEffectLayer.customType);
            return effectLayerType.Parse(parsedEffectLayer, scene, rootUrl);
        }
    }
    /**
     * @internal
     */
    EffectLayer._SceneComponentInitialization = (_) => {
        throw _WarnImport("EffectLayerSceneComponent");
    };
    __decorate$1([
        serialize()
    ], EffectLayer.prototype, "name", void 0);
    __decorate$1([
        serializeAsColor4()
    ], EffectLayer.prototype, "neutralColor", void 0);
    __decorate$1([
        serialize()
    ], EffectLayer.prototype, "isEnabled", void 0);
    __decorate$1([
        serializeAsCameraReference()
    ], EffectLayer.prototype, "camera", null);
    __decorate$1([
        serialize()
    ], EffectLayer.prototype, "renderingGroupId", null);
    __decorate$1([
        serialize()
    ], EffectLayer.prototype, "disableBoundingBoxesFromEffectLayer", void 0);

    // Adds the parser to the scene parsers.
    AbstractScene.AddParser(SceneComponentConstants.NAME_EFFECTLAYER, (parsedData, scene, container, rootUrl) => {
        if (parsedData.effectLayers) {
            if (!container.effectLayers) {
                container.effectLayers = new Array();
            }
            for (let index = 0; index < parsedData.effectLayers.length; index++) {
                const effectLayer = EffectLayer.Parse(parsedData.effectLayers[index], scene, rootUrl);
                container.effectLayers.push(effectLayer);
            }
        }
    });
    AbstractScene.prototype.removeEffectLayer = function (toRemove) {
        const index = this.effectLayers.indexOf(toRemove);
        if (index !== -1) {
            this.effectLayers.splice(index, 1);
        }
        return index;
    };
    AbstractScene.prototype.addEffectLayer = function (newEffectLayer) {
        this.effectLayers.push(newEffectLayer);
    };
    /**
     * Defines the layer scene component responsible to manage any effect layers
     * in a given scene.
     */
    class EffectLayerSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_EFFECTLAYER;
            this._renderEffects = false;
            this._needStencil = false;
            this._previousStencilState = false;
            this.scene = scene || EngineStore.LastCreatedScene;
            if (!this.scene) {
                return;
            }
            this._engine = this.scene.getEngine();
            this.scene.effectLayers = new Array();
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._isReadyForMeshStage.registerStep(SceneComponentConstants.STEP_ISREADYFORMESH_EFFECTLAYER, this, this._isReadyForMesh);
            this.scene._cameraDrawRenderTargetStage.registerStep(SceneComponentConstants.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER, this, this._renderMainTexture);
            this.scene._beforeCameraDrawStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERADRAW_EFFECTLAYER, this, this._setStencil);
            this.scene._afterRenderingGroupDrawStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW, this, this._drawRenderingGroup);
            this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER, this, this._setStencilBack);
            this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW, this, this._drawCamera);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            const layers = this.scene.effectLayers;
            for (const effectLayer of layers) {
                effectLayer._rebuild();
            }
        }
        /**
         * Serializes the component data to the specified json object
         * @param serializationObject The object to serialize to
         */
        serialize(serializationObject) {
            // Effect layers
            serializationObject.effectLayers = [];
            const layers = this.scene.effectLayers;
            for (const effectLayer of layers) {
                if (effectLayer.serialize) {
                    serializationObject.effectLayers.push(effectLayer.serialize());
                }
            }
        }
        /**
         * Adds all the elements from the container to the scene
         * @param container the container holding the elements
         */
        addFromContainer(container) {
            if (!container.effectLayers) {
                return;
            }
            container.effectLayers.forEach((o) => {
                this.scene.addEffectLayer(o);
            });
        }
        /**
         * Removes all the elements in the container from the scene
         * @param container contains the elements to remove
         * @param dispose if the removed element should be disposed (default: false)
         */
        removeFromContainer(container, dispose) {
            if (!container.effectLayers) {
                return;
            }
            container.effectLayers.forEach((o) => {
                this.scene.removeEffectLayer(o);
                if (dispose) {
                    o.dispose();
                }
            });
        }
        /**
         * Disposes the component and the associated resources.
         */
        dispose() {
            const layers = this.scene.effectLayers;
            while (layers.length) {
                layers[0].dispose();
            }
        }
        _isReadyForMesh(mesh, hardwareInstancedRendering) {
            const currentRenderPassId = this._engine.currentRenderPassId;
            const layers = this.scene.effectLayers;
            for (const layer of layers) {
                if (!layer.hasMesh(mesh)) {
                    continue;
                }
                const renderTarget = layer._mainTexture;
                this._engine.currentRenderPassId = renderTarget.renderPassId;
                for (const subMesh of mesh.subMeshes) {
                    if (!layer.isReady(subMesh, hardwareInstancedRendering)) {
                        this._engine.currentRenderPassId = currentRenderPassId;
                        return false;
                    }
                }
            }
            this._engine.currentRenderPassId = currentRenderPassId;
            return true;
        }
        _renderMainTexture(camera) {
            this._renderEffects = false;
            this._needStencil = false;
            let needRebind = false;
            const layers = this.scene.effectLayers;
            if (layers && layers.length > 0) {
                this._previousStencilState = this._engine.getStencilBuffer();
                for (const effectLayer of layers) {
                    if (effectLayer.shouldRender() &&
                        (!effectLayer.camera ||
                            (effectLayer.camera.cameraRigMode === Camera.RIG_MODE_NONE && camera === effectLayer.camera) ||
                            (effectLayer.camera.cameraRigMode !== Camera.RIG_MODE_NONE && effectLayer.camera._rigCameras.indexOf(camera) > -1))) {
                        this._renderEffects = true;
                        this._needStencil = this._needStencil || effectLayer.needStencil();
                        const renderTarget = effectLayer._mainTexture;
                        if (renderTarget._shouldRender()) {
                            this.scene.incrementRenderId();
                            renderTarget.render(false, false);
                            needRebind = true;
                        }
                    }
                }
                this.scene.incrementRenderId();
            }
            return needRebind;
        }
        _setStencil() {
            // Activate effect Layer stencil
            if (this._needStencil) {
                this._engine.setStencilBuffer(true);
            }
        }
        _setStencilBack() {
            // Restore effect Layer stencil
            if (this._needStencil) {
                this._engine.setStencilBuffer(this._previousStencilState);
            }
        }
        _draw(renderingGroupId) {
            if (this._renderEffects) {
                this._engine.setDepthBuffer(false);
                const layers = this.scene.effectLayers;
                for (let i = 0; i < layers.length; i++) {
                    const effectLayer = layers[i];
                    if (effectLayer.renderingGroupId === renderingGroupId) {
                        if (effectLayer.shouldRender()) {
                            effectLayer.render();
                        }
                    }
                }
                this._engine.setDepthBuffer(true);
            }
        }
        _drawCamera() {
            if (this._renderEffects) {
                this._draw(-1);
            }
        }
        _drawRenderingGroup(index) {
            if (!this.scene._isInIntermediateRendering() && this._renderEffects) {
                this._draw(index);
            }
        }
    }
    EffectLayer._SceneComponentInitialization = (scene) => {
        let component = scene._getComponent(SceneComponentConstants.NAME_EFFECTLAYER);
        if (!component) {
            component = new EffectLayerSceneComponent(scene);
            scene._addComponent(component);
        }
    };

    /**
     * Base implementation IShadowLight
     * It groups all the common behaviour in order to reduce duplication and better follow the DRY pattern.
     */
    class ShadowLight extends Light {
        constructor() {
            super(...arguments);
            this._needProjectionMatrixCompute = true;
        }
        _setPosition(value) {
            this._position = value;
        }
        /**
         * Sets the position the shadow will be casted from. Also use as the light position for both
         * point and spot lights.
         */
        get position() {
            return this._position;
        }
        /**
         * Sets the position the shadow will be casted from. Also use as the light position for both
         * point and spot lights.
         */
        set position(value) {
            this._setPosition(value);
        }
        _setDirection(value) {
            this._direction = value;
        }
        /**
         * In 2d mode (needCube being false), gets the direction used to cast the shadow.
         * Also use as the light direction on spot and directional lights.
         */
        get direction() {
            return this._direction;
        }
        /**
         * In 2d mode (needCube being false), sets the direction used to cast the shadow.
         * Also use as the light direction on spot and directional lights.
         */
        set direction(value) {
            this._setDirection(value);
        }
        /**
         * Gets the shadow projection clipping minimum z value.
         */
        get shadowMinZ() {
            return this._shadowMinZ;
        }
        /**
         * Sets the shadow projection clipping minimum z value.
         */
        set shadowMinZ(value) {
            this._shadowMinZ = value;
            this.forceProjectionMatrixCompute();
        }
        /**
         * Sets the shadow projection clipping maximum z value.
         */
        get shadowMaxZ() {
            return this._shadowMaxZ;
        }
        /**
         * Gets the shadow projection clipping maximum z value.
         */
        set shadowMaxZ(value) {
            this._shadowMaxZ = value;
            this.forceProjectionMatrixCompute();
        }
        /**
         * Computes the transformed information (transformedPosition and transformedDirection in World space) of the current light
         * @returns true if the information has been computed, false if it does not need to (no parenting)
         */
        computeTransformedInformation() {
            if (this.parent && this.parent.getWorldMatrix) {
                if (!this.transformedPosition) {
                    this.transformedPosition = Vector3.Zero();
                }
                Vector3.TransformCoordinatesToRef(this.position, this.parent.getWorldMatrix(), this.transformedPosition);
                // In case the direction is present.
                if (this.direction) {
                    if (!this.transformedDirection) {
                        this.transformedDirection = Vector3.Zero();
                    }
                    Vector3.TransformNormalToRef(this.direction, this.parent.getWorldMatrix(), this.transformedDirection);
                }
                return true;
            }
            return false;
        }
        /**
         * Return the depth scale used for the shadow map.
         * @returns the depth scale.
         */
        getDepthScale() {
            return 50.0;
        }
        /**
         * Get the direction to use to render the shadow map. In case of cube texture, the face index can be passed.
         * @param faceIndex The index of the face we are computed the direction to generate shadow
         * @returns The set direction in 2d mode otherwise the direction to the cubemap face if needCube() is true
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getShadowDirection(faceIndex) {
            return this.transformedDirection ? this.transformedDirection : this.direction;
        }
        /**
         * Returns the ShadowLight absolute position in the World.
         * @returns the position vector in world space
         */
        getAbsolutePosition() {
            return this.transformedPosition ? this.transformedPosition : this.position;
        }
        /**
         * Sets the ShadowLight direction toward the passed target.
         * @param target The point to target in local space
         * @returns the updated ShadowLight direction
         */
        setDirectionToTarget(target) {
            this.direction = Vector3.Normalize(target.subtract(this.position));
            return this.direction;
        }
        /**
         * Returns the light rotation in euler definition.
         * @returns the x y z rotation in local space.
         */
        getRotation() {
            this.direction.normalize();
            const xaxis = Vector3.Cross(this.direction, Axis.Y);
            const yaxis = Vector3.Cross(xaxis, this.direction);
            return Vector3.RotationFromAxis(xaxis, yaxis, this.direction);
        }
        /**
         * Returns whether or not the shadow generation require a cube texture or a 2d texture.
         * @returns true if a cube texture needs to be use
         */
        needCube() {
            return false;
        }
        /**
         * Detects if the projection matrix requires to be recomputed this frame.
         * @returns true if it requires to be recomputed otherwise, false.
         */
        needProjectionMatrixCompute() {
            return this._needProjectionMatrixCompute;
        }
        /**
         * Forces the shadow generator to recompute the projection matrix even if position and direction did not changed.
         */
        forceProjectionMatrixCompute() {
            this._needProjectionMatrixCompute = true;
        }
        /** @internal */
        _initCache() {
            super._initCache();
            this._cache.position = Vector3.Zero();
        }
        /** @internal */
        _isSynchronized() {
            if (!this._cache.position.equals(this.position)) {
                return false;
            }
            return true;
        }
        /**
         * Computes the world matrix of the node
         * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
         * @returns the world matrix
         */
        computeWorldMatrix(force) {
            if (!force && this.isSynchronized()) {
                this._currentRenderId = this.getScene().getRenderId();
                return this._worldMatrix;
            }
            this._updateCache();
            this._cache.position.copyFrom(this.position);
            if (!this._worldMatrix) {
                this._worldMatrix = Matrix.Identity();
            }
            Matrix.TranslationToRef(this.position.x, this.position.y, this.position.z, this._worldMatrix);
            if (this.parent && this.parent.getWorldMatrix) {
                this._worldMatrix.multiplyToRef(this.parent.getWorldMatrix(), this._worldMatrix);
                this._markSyncedWithParent();
            }
            // Cache the determinant
            this._worldMatrixDeterminantIsDirty = true;
            return this._worldMatrix;
        }
        /**
         * Gets the minZ used for shadow according to both the scene and the light.
         * @param activeCamera The camera we are returning the min for
         * @returns the depth min z
         */
        getDepthMinZ(activeCamera) {
            return this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
        }
        /**
         * Gets the maxZ used for shadow according to both the scene and the light.
         * @param activeCamera The camera we are returning the max for
         * @returns the depth max z
         */
        getDepthMaxZ(activeCamera) {
            return this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
        }
        /**
         * Sets the shadow projection matrix in parameter to the generated projection matrix.
         * @param matrix The matrix to updated with the projection information
         * @param viewMatrix The transform matrix of the light
         * @param renderList The list of mesh to render in the map
         * @returns The current light
         */
        setShadowProjectionMatrix(matrix, viewMatrix, renderList) {
            if (this.customProjectionMatrixBuilder) {
                this.customProjectionMatrixBuilder(viewMatrix, renderList, matrix);
            }
            else {
                this._setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList);
            }
            return this;
        }
        /** @internal */
        _syncParentEnabledState() {
            super._syncParentEnabledState();
            if (!this.parent || !this.parent.getWorldMatrix) {
                this.transformedPosition = null;
                this.transformedDirection = null;
            }
        }
    }
    __decorate$1([
        serializeAsVector3()
    ], ShadowLight.prototype, "position", null);
    __decorate$1([
        serializeAsVector3()
    ], ShadowLight.prototype, "direction", null);
    __decorate$1([
        serialize()
    ], ShadowLight.prototype, "shadowMinZ", null);
    __decorate$1([
        serialize()
    ], ShadowLight.prototype, "shadowMaxZ", null);

    // Do not edit.
    const name$20 = "bayerDitherFunctions";
    const shader$20 = `float bayerDither2(vec2 _P) {return mod(2.0*_P.y+_P.x+1.0,4.0);}
float bayerDither4(vec2 _P) {vec2 P1=mod(_P,2.0); 
vec2 P2=floor(0.5*mod(_P,4.0)); 
return 4.0*bayerDither2(P1)+bayerDither2(P2);}
float bayerDither8(vec2 _P) {vec2 P1=mod(_P,2.0); 
vec2 P2=floor(0.5 *mod(_P,4.0)); 
vec2 P4=floor(0.25*mod(_P,8.0)); 
return 4.0*(4.0*bayerDither2(P1)+bayerDither2(P2))+bayerDither2(P4);}
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$20] = shader$20;

    // Do not edit.
    const name$21 = "shadowMapFragmentExtraDeclaration";
    const shader$21 = `#if SM_FLOAT==0
#include<packingFunctions>
#endif
#if SM_SOFTTRANSPARENTSHADOW==1
#include<bayerDitherFunctions>
uniform float softTransparentShadowSM;
#endif
varying float vDepthMetricSM;
#if SM_USEDISTANCE==1
uniform vec3 lightDataSM;varying vec3 vPositionWSM;
#endif
uniform vec3 biasAndScaleSM;uniform vec2 depthValuesSM;
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
varying float zSM;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$21] = shader$21;

    // Do not edit.
    const name$22 = "shadowMapFragment";
    const shader$22 = `float depthSM=vDepthMetricSM;
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
#if SM_USEDISTANCE==1
depthSM=(length(vPositionWSM-lightDataSM)+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#else
#ifdef USE_REVERSE_DEPTHBUFFER
depthSM=(-zSM+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#else
depthSM=(zSM+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#endif
#endif
#ifdef USE_REVERSE_DEPTHBUFFER
gl_FragDepth=clamp(1.0-depthSM,0.0,1.0);
#else
gl_FragDepth=clamp(depthSM,0.0,1.0); 
#endif
#elif SM_USEDISTANCE==1
depthSM=(length(vPositionWSM-lightDataSM)+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#endif
#if SM_ESM==1
depthSM=clamp(exp(-min(87.,biasAndScaleSM.z*depthSM)),0.,1.);
#endif
#if SM_FLOAT==1
gl_FragColor=vec4(depthSM,1.0,1.0,1.0);
#else
gl_FragColor=pack(depthSM);
#endif
return;`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$22] = shader$22;

    // Do not edit.
    const name$23 = "shadowMapPixelShader";
    const shader$23 = `#include<shadowMapFragmentExtraDeclaration>
#ifdef ALPHATEXTURE
varying vec2 vUV;uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#include<clipPlaneFragment>
#ifdef ALPHATEXTURE
float alphaFromAlphaTexture=texture2D(diffuseSampler,vUV).a;
#ifdef ALPHATESTVALUE
if (alphaFromAlphaTexture<ALPHATESTVALUE)
discard;
#endif
#endif
#if SM_SOFTTRANSPARENTSHADOW==1
#ifdef ALPHATEXTURE
if ((bayerDither8(floor(mod(gl_FragCoord.xy,8.0))))/64.0>=softTransparentShadowSM*alphaFromAlphaTexture) discard;
#else
if ((bayerDither8(floor(mod(gl_FragCoord.xy,8.0))))/64.0>=softTransparentShadowSM) discard;
#endif
#endif
#include<shadowMapFragment>
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$23] = shader$23;

    // Do not edit.
    const name$24 = "sceneVertexDeclaration";
    const shader$24 = `uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
uniform mat4 view;uniform mat4 projection;uniform vec4 vEyePosition;
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$24] = shader$24;

    // Do not edit.
    const name$25 = "meshVertexDeclaration";
    const shader$25 = `uniform mat4 world;uniform float visibility;
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$25] = shader$25;

    // Do not edit.
    const name$26 = "shadowMapVertexDeclaration";
    const shader$26 = `#include<sceneVertexDeclaration>
#include<meshVertexDeclaration>
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$26] = shader$26;

    // Do not edit.
    const name$27 = "shadowMapUboDeclaration";
    const shader$27 = `layout(std140,column_major) uniform;
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$27] = shader$27;

    // Do not edit.
    const name$28 = "shadowMapVertexExtraDeclaration";
    const shader$28 = `#if SM_NORMALBIAS==1
uniform vec3 lightDataSM;
#endif
uniform vec3 biasAndScaleSM;uniform vec2 depthValuesSM;varying float vDepthMetricSM;
#if SM_USEDISTANCE==1
varying vec3 vPositionWSM;
#endif
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
varying float zSM;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$28] = shader$28;

    // Do not edit.
    const name$29 = "shadowMapVertexNormalBias";
    const shader$29 = `#if SM_NORMALBIAS==1
#if SM_DIRECTIONINLIGHTDATA==1
vec3 worldLightDirSM=normalize(-lightDataSM.xyz);
#else
vec3 directionToLightSM=lightDataSM.xyz-worldPos.xyz;vec3 worldLightDirSM=normalize(directionToLightSM);
#endif
float ndlSM=dot(vNormalW,worldLightDirSM);float sinNLSM=sqrt(1.0-ndlSM*ndlSM);float normalBiasSM=biasAndScaleSM.y*sinNLSM;worldPos.xyz-=vNormalW*normalBiasSM;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$29] = shader$29;

    // Do not edit.
    const name$2a = "shadowMapVertexMetric";
    const shader$2a = `#if SM_USEDISTANCE==1
vPositionWSM=worldPos.xyz;
#endif
#if SM_DEPTHTEXTURE==1
#ifdef IS_NDC_HALF_ZRANGE
#define BIASFACTOR 0.5
#else
#define BIASFACTOR 1.0
#endif
#ifdef USE_REVERSE_DEPTHBUFFER
gl_Position.z-=biasAndScaleSM.x*gl_Position.w*BIASFACTOR;
#else
gl_Position.z+=biasAndScaleSM.x*gl_Position.w*BIASFACTOR;
#endif
#endif
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
zSM=gl_Position.z;gl_Position.z=0.0;
#elif SM_USEDISTANCE==0
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetricSM=(-gl_Position.z+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#else
vDepthMetricSM=(gl_Position.z+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#endif
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2a] = shader$2a;

    // Do not edit.
    const name$2b = "shadowMapVertexShader";
    const shader$2b = `attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef INSTANCES
attribute vec4 world0;attribute vec4 world1;attribute vec4 world2;attribute vec4 world3;
#endif
#include<helperFunctions>
#include<__decl__shadowMapVertex>
#ifdef ALPHATEXTURE
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#include<shadowMapVertexExtraDeclaration>
#include<clipPlaneVertexDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef NORMAL
mat3 normWorldSM=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vec3 vNormalW=normalUpdated/vec3(dot(normWorldSM[0],normWorldSM[0]),dot(normWorldSM[1],normWorldSM[1]),dot(normWorldSM[2],normWorldSM[2]));vNormalW=normalize(normWorldSM*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normWorldSM=transposeMat3(inverseMat3(normWorldSM));
#endif
vec3 vNormalW=normalize(normWorldSM*normalUpdated);
#endif
#endif
#include<shadowMapVertexNormalBias>
gl_Position=viewProjection*worldPos;
#include<shadowMapVertexMetric>
#ifdef ALPHATEXTURE
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#include<clipPlaneVertex>
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2b] = shader$2b;

    // Do not edit.
    const name$2c = "depthBoxBlurPixelShader";
    const shader$2c = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 screenSize;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 colorDepth=vec4(0.0);for (int x=-OFFSET; x<=OFFSET; x++)
for (int y=-OFFSET; y<=OFFSET; y++)
colorDepth+=texture2D(textureSampler,vUV+vec2(x,y)/screenSize);gl_FragColor=(colorDepth/float((OFFSET*2+1)*(OFFSET*2+1)));}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2c] = shader$2c;

    // Do not edit.
    const name$2d = "shadowMapFragmentSoftTransparentShadow";
    const shader$2d = `#if SM_SOFTTRANSPARENTSHADOW==1
if ((bayerDither8(floor(mod(gl_FragCoord.xy,8.0))))/64.0>=softTransparentShadowSM*alpha) discard;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2d] = shader$2d;

    /**
     * Default implementation IShadowGenerator.
     * This is the main object responsible of generating shadows in the framework.
     * Documentation: https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
     */
    class ShadowGenerator {
        /**
         * Gets the bias: offset applied on the depth preventing acnea (in light direction).
         */
        get bias() {
            return this._bias;
        }
        /**
         * Sets the bias: offset applied on the depth preventing acnea (in light direction).
         */
        set bias(bias) {
            this._bias = bias;
        }
        /**
         * Gets the normalBias: offset applied on the depth preventing acnea (along side the normal direction and proportional to the light/normal angle).
         */
        get normalBias() {
            return this._normalBias;
        }
        /**
         * Sets the normalBias: offset applied on the depth preventing acnea (along side the normal direction and proportional to the light/normal angle).
         */
        set normalBias(normalBias) {
            this._normalBias = normalBias;
        }
        /**
         * Gets the blur box offset: offset applied during the blur pass.
         * Only useful if useKernelBlur = false
         */
        get blurBoxOffset() {
            return this._blurBoxOffset;
        }
        /**
         * Sets the blur box offset: offset applied during the blur pass.
         * Only useful if useKernelBlur = false
         */
        set blurBoxOffset(value) {
            if (this._blurBoxOffset === value) {
                return;
            }
            this._blurBoxOffset = value;
            this._disposeBlurPostProcesses();
        }
        /**
         * Gets the blur scale: scale of the blurred texture compared to the main shadow map.
         * 2 means half of the size.
         */
        get blurScale() {
            return this._blurScale;
        }
        /**
         * Sets the blur scale: scale of the blurred texture compared to the main shadow map.
         * 2 means half of the size.
         */
        set blurScale(value) {
            if (this._blurScale === value) {
                return;
            }
            this._blurScale = value;
            this._disposeBlurPostProcesses();
        }
        /**
         * Gets the blur kernel: kernel size of the blur pass.
         * Only useful if useKernelBlur = true
         */
        get blurKernel() {
            return this._blurKernel;
        }
        /**
         * Sets the blur kernel: kernel size of the blur pass.
         * Only useful if useKernelBlur = true
         */
        set blurKernel(value) {
            if (this._blurKernel === value) {
                return;
            }
            this._blurKernel = value;
            this._disposeBlurPostProcesses();
        }
        /**
         * Gets whether the blur pass is a kernel blur (if true) or box blur.
         * Only useful in filtered mode (useBlurExponentialShadowMap...)
         */
        get useKernelBlur() {
            return this._useKernelBlur;
        }
        /**
         * Sets whether the blur pass is a kernel blur (if true) or box blur.
         * Only useful in filtered mode (useBlurExponentialShadowMap...)
         */
        set useKernelBlur(value) {
            if (this._useKernelBlur === value) {
                return;
            }
            this._useKernelBlur = value;
            this._disposeBlurPostProcesses();
        }
        /**
         * Gets the depth scale used in ESM mode.
         */
        get depthScale() {
            return this._depthScale !== undefined ? this._depthScale : this._light.getDepthScale();
        }
        /**
         * Sets the depth scale used in ESM mode.
         * This can override the scale stored on the light.
         */
        set depthScale(value) {
            this._depthScale = value;
        }
        _validateFilter(filter) {
            return filter;
        }
        /**
         * Gets the current mode of the shadow generator (normal, PCF, ESM...).
         * The returned value is a number equal to one of the available mode defined in ShadowMap.FILTER_x like _FILTER_NONE
         */
        get filter() {
            return this._filter;
        }
        /**
         * Sets the current mode of the shadow generator (normal, PCF, ESM...).
         * The returned value is a number equal to one of the available mode defined in ShadowMap.FILTER_x like _FILTER_NONE
         */
        set filter(value) {
            value = this._validateFilter(value);
            // Blurring the cubemap is going to be too expensive. Reverting to unblurred version
            if (this._light.needCube()) {
                if (value === ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP) {
                    this.useExponentialShadowMap = true;
                    return;
                }
                else if (value === ShadowGenerator.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP) {
                    this.useCloseExponentialShadowMap = true;
                    return;
                }
                // PCF on cubemap would also be expensive
                else if (value === ShadowGenerator.FILTER_PCF || value === ShadowGenerator.FILTER_PCSS) {
                    this.usePoissonSampling = true;
                    return;
                }
            }
            // Weblg1 fallback for PCF.
            if (value === ShadowGenerator.FILTER_PCF || value === ShadowGenerator.FILTER_PCSS) {
                if (!this._scene.getEngine()._features.supportShadowSamplers) {
                    this.usePoissonSampling = true;
                    return;
                }
            }
            if (this._filter === value) {
                return;
            }
            this._filter = value;
            this._disposeBlurPostProcesses();
            this._applyFilterValues();
            this._light._markMeshesAsLightDirty();
        }
        /**
         * Gets if the current filter is set to Poisson Sampling.
         */
        get usePoissonSampling() {
            return this.filter === ShadowGenerator.FILTER_POISSONSAMPLING;
        }
        /**
         * Sets the current filter to Poisson Sampling.
         */
        set usePoissonSampling(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_POISSONSAMPLING);
            if (!value && this.filter !== ShadowGenerator.FILTER_POISSONSAMPLING) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets if the current filter is set to ESM.
         */
        get useExponentialShadowMap() {
            return this.filter === ShadowGenerator.FILTER_EXPONENTIALSHADOWMAP;
        }
        /**
         * Sets the current filter is to ESM.
         */
        set useExponentialShadowMap(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_EXPONENTIALSHADOWMAP);
            if (!value && this.filter !== ShadowGenerator.FILTER_EXPONENTIALSHADOWMAP) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets if the current filter is set to filtered ESM.
         */
        get useBlurExponentialShadowMap() {
            return this.filter === ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP;
        }
        /**
         * Gets if the current filter is set to filtered  ESM.
         */
        set useBlurExponentialShadowMap(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP);
            if (!value && this.filter !== ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets if the current filter is set to "close ESM" (using the inverse of the
         * exponential to prevent steep falloff artifacts).
         */
        get useCloseExponentialShadowMap() {
            return this.filter === ShadowGenerator.FILTER_CLOSEEXPONENTIALSHADOWMAP;
        }
        /**
         * Sets the current filter to "close ESM" (using the inverse of the
         * exponential to prevent steep falloff artifacts).
         */
        set useCloseExponentialShadowMap(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_CLOSEEXPONENTIALSHADOWMAP);
            if (!value && this.filter !== ShadowGenerator.FILTER_CLOSEEXPONENTIALSHADOWMAP) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets if the current filter is set to filtered "close ESM" (using the inverse of the
         * exponential to prevent steep falloff artifacts).
         */
        get useBlurCloseExponentialShadowMap() {
            return this.filter === ShadowGenerator.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP;
        }
        /**
         * Sets the current filter to filtered "close ESM" (using the inverse of the
         * exponential to prevent steep falloff artifacts).
         */
        set useBlurCloseExponentialShadowMap(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP);
            if (!value && this.filter !== ShadowGenerator.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets if the current filter is set to "PCF" (percentage closer filtering).
         */
        get usePercentageCloserFiltering() {
            return this.filter === ShadowGenerator.FILTER_PCF;
        }
        /**
         * Sets the current filter to "PCF" (percentage closer filtering).
         */
        set usePercentageCloserFiltering(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_PCF);
            if (!value && this.filter !== ShadowGenerator.FILTER_PCF) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets the PCF or PCSS Quality.
         * Only valid if usePercentageCloserFiltering or usePercentageCloserFiltering is true.
         */
        get filteringQuality() {
            return this._filteringQuality;
        }
        /**
         * Sets the PCF or PCSS Quality.
         * Only valid if usePercentageCloserFiltering or usePercentageCloserFiltering is true.
         */
        set filteringQuality(filteringQuality) {
            if (this._filteringQuality === filteringQuality) {
                return;
            }
            this._filteringQuality = filteringQuality;
            this._disposeBlurPostProcesses();
            this._applyFilterValues();
            this._light._markMeshesAsLightDirty();
        }
        /**
         * Gets if the current filter is set to "PCSS" (contact hardening).
         */
        get useContactHardeningShadow() {
            return this.filter === ShadowGenerator.FILTER_PCSS;
        }
        /**
         * Sets the current filter to "PCSS" (contact hardening).
         */
        set useContactHardeningShadow(value) {
            const filter = this._validateFilter(ShadowGenerator.FILTER_PCSS);
            if (!value && this.filter !== ShadowGenerator.FILTER_PCSS) {
                return;
            }
            this.filter = value ? filter : ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets the Light Size (in shadow map uv unit) used in PCSS to determine the blocker search area and the penumbra size.
         * Using a ratio helps keeping shape stability independently of the map size.
         *
         * It does not account for the light projection as it was having too much
         * instability during the light setup or during light position changes.
         *
         * Only valid if useContactHardeningShadow is true.
         */
        get contactHardeningLightSizeUVRatio() {
            return this._contactHardeningLightSizeUVRatio;
        }
        /**
         * Sets the Light Size (in shadow map uv unit) used in PCSS to determine the blocker search area and the penumbra size.
         * Using a ratio helps keeping shape stability independently of the map size.
         *
         * It does not account for the light projection as it was having too much
         * instability during the light setup or during light position changes.
         *
         * Only valid if useContactHardeningShadow is true.
         */
        set contactHardeningLightSizeUVRatio(contactHardeningLightSizeUVRatio) {
            this._contactHardeningLightSizeUVRatio = contactHardeningLightSizeUVRatio;
        }
        /** Gets or sets the actual darkness of a shadow */
        get darkness() {
            return this._darkness;
        }
        set darkness(value) {
            this.setDarkness(value);
        }
        /**
         * Returns the darkness value (float). This can only decrease the actual darkness of a shadow.
         * 0 means strongest and 1 would means no shadow.
         * @returns the darkness.
         */
        getDarkness() {
            return this._darkness;
        }
        /**
         * Sets the darkness value (float). This can only decrease the actual darkness of a shadow.
         * @param darkness The darkness value 0 means strongest and 1 would means no shadow.
         * @returns the shadow generator allowing fluent coding.
         */
        setDarkness(darkness) {
            if (darkness >= 1.0) {
                this._darkness = 1.0;
            }
            else if (darkness <= 0.0) {
                this._darkness = 0.0;
            }
            else {
                this._darkness = darkness;
            }
            return this;
        }
        /** Gets or sets the ability to have transparent shadow  */
        get transparencyShadow() {
            return this._transparencyShadow;
        }
        set transparencyShadow(value) {
            this.setTransparencyShadow(value);
        }
        /**
         * Sets the ability to have transparent shadow (boolean).
         * @param transparent True if transparent else False
         * @returns the shadow generator allowing fluent coding
         */
        setTransparencyShadow(transparent) {
            this._transparencyShadow = transparent;
            return this;
        }
        /**
         * Gets the main RTT containing the shadow map (usually storing depth from the light point of view).
         * @returns The render target texture if present otherwise, null
         */
        getShadowMap() {
            return this._shadowMap;
        }
        /**
         * Gets the RTT used during rendering (can be a blurred version of the shadow map or the shadow map itself).
         * @returns The render target texture if the shadow map is present otherwise, null
         */
        getShadowMapForRendering() {
            if (this._shadowMap2) {
                return this._shadowMap2;
            }
            return this._shadowMap;
        }
        /**
         * Gets the class name of that object
         * @returns "ShadowGenerator"
         */
        getClassName() {
            return ShadowGenerator.CLASSNAME;
        }
        /**
         * Helper function to add a mesh and its descendants to the list of shadow casters.
         * @param mesh Mesh to add
         * @param includeDescendants boolean indicating if the descendants should be added. Default to true
         * @returns the Shadow Generator itself
         */
        addShadowCaster(mesh, includeDescendants = true) {
            if (!this._shadowMap) {
                return this;
            }
            if (!this._shadowMap.renderList) {
                this._shadowMap.renderList = [];
            }
            if (this._shadowMap.renderList.indexOf(mesh) === -1) {
                this._shadowMap.renderList.push(mesh);
            }
            if (includeDescendants) {
                for (const childMesh of mesh.getChildMeshes()) {
                    if (this._shadowMap.renderList.indexOf(childMesh) === -1) {
                        this._shadowMap.renderList.push(childMesh);
                    }
                }
            }
            return this;
        }
        /**
         * Helper function to remove a mesh and its descendants from the list of shadow casters
         * @param mesh Mesh to remove
         * @param includeDescendants boolean indicating if the descendants should be removed. Default to true
         * @returns the Shadow Generator itself
         */
        removeShadowCaster(mesh, includeDescendants = true) {
            if (!this._shadowMap || !this._shadowMap.renderList) {
                return this;
            }
            const index = this._shadowMap.renderList.indexOf(mesh);
            if (index !== -1) {
                this._shadowMap.renderList.splice(index, 1);
            }
            if (includeDescendants) {
                for (const child of mesh.getChildren()) {
                    this.removeShadowCaster(child);
                }
            }
            return this;
        }
        /**
         * Returns the associated light object.
         * @returns the light generating the shadow
         */
        getLight() {
            return this._light;
        }
        _getCamera() {
            var _a;
            return (_a = this._camera) !== null && _a !== void 0 ? _a : this._scene.activeCamera;
        }
        /**
         * Gets or sets the size of the texture what stores the shadows
         */
        get mapSize() {
            return this._mapSize;
        }
        set mapSize(size) {
            this._mapSize = size;
            this._light._markMeshesAsLightDirty();
            this.recreateShadowMap();
        }
        /**
         * Creates a ShadowGenerator object.
         * A ShadowGenerator is the required tool to use the shadows.
         * Each light casting shadows needs to use its own ShadowGenerator.
         * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
         * @param mapSize The size of the texture what stores the shadows. Example : 1024.
         * @param light The light object generating the shadows.
         * @param usefullFloatFirst By default the generator will try to use half float textures but if you need precision (for self shadowing for instance), you can use this option to enforce full float texture.
         * @param camera Camera associated with this shadow generator (default: null). If null, takes the scene active camera at the time we need to access it
         * @param useRedTextureType Forces the generator to use a Red instead of a RGBA type for the shadow map texture format (default: false)
         */
        constructor(mapSize, light, usefullFloatFirst, camera, useRedTextureType) {
            /**
             * Observable triggered before the shadow is rendered. Can be used to update internal effect state
             */
            this.onBeforeShadowMapRenderObservable = new Observable$1();
            /**
             * Observable triggered after the shadow is rendered. Can be used to restore internal effect state
             */
            this.onAfterShadowMapRenderObservable = new Observable$1();
            /**
             * Observable triggered before a mesh is rendered in the shadow map.
             * Can be used to update internal effect state (that you can get from the onBeforeShadowMapRenderObservable)
             */
            this.onBeforeShadowMapRenderMeshObservable = new Observable$1();
            /**
             * Observable triggered after a mesh is rendered in the shadow map.
             * Can be used to update internal effect state (that you can get from the onAfterShadowMapRenderObservable)
             */
            this.onAfterShadowMapRenderMeshObservable = new Observable$1();
            this._bias = 0.00005;
            this._normalBias = 0;
            this._blurBoxOffset = 1;
            this._blurScale = 2;
            this._blurKernel = 1;
            this._useKernelBlur = false;
            this._filter = ShadowGenerator.FILTER_NONE;
            this._filteringQuality = ShadowGenerator.QUALITY_HIGH;
            this._contactHardeningLightSizeUVRatio = 0.1;
            this._darkness = 0;
            this._transparencyShadow = false;
            /**
             * Enables or disables shadows with varying strength based on the transparency
             * When it is enabled, the strength of the shadow is taken equal to mesh.visibility
             * If you enabled an alpha texture on your material, the alpha value red from the texture is also combined to compute the strength:
             *          mesh.visibility * alphaTexture.a
             * The texture used is the diffuse by default, but it can be set to the opacity by setting useOpacityTextureForTransparentShadow
             * Note that by definition transparencyShadow must be set to true for enableSoftTransparentShadow to work!
             */
            this.enableSoftTransparentShadow = false;
            /**
             * If this is true, use the opacity texture's alpha channel for transparent shadows instead of the diffuse one
             */
            this.useOpacityTextureForTransparentShadow = false;
            /**
             * Controls the extent to which the shadows fade out at the edge of the frustum
             */
            this.frustumEdgeFalloff = 0;
            /**
             * If true the shadow map is generated by rendering the back face of the mesh instead of the front face.
             * This can help with self-shadowing as the geometry making up the back of objects is slightly offset.
             * It might on the other hand introduce peter panning.
             */
            this.forceBackFacesOnly = false;
            this._lightDirection = Vector3.Zero();
            this._viewMatrix = Matrix.Zero();
            this._projectionMatrix = Matrix.Zero();
            this._transformMatrix = Matrix.Zero();
            this._cachedPosition = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cachedDirection = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._currentFaceIndex = 0;
            this._currentFaceIndexCache = 0;
            this._defaultTextureMatrix = Matrix.Identity();
            this._mapSize = mapSize;
            this._light = light;
            this._scene = light.getScene();
            this._camera = camera !== null && camera !== void 0 ? camera : null;
            this._useRedTextureType = !!useRedTextureType;
            let shadowGenerators = light._shadowGenerators;
            if (!shadowGenerators) {
                shadowGenerators = light._shadowGenerators = new Map();
            }
            shadowGenerators.set(this._camera, this);
            this.id = light.id;
            this._useUBO = this._scene.getEngine().supportsUniformBuffers;
            if (this._useUBO) {
                this._sceneUBOs = [];
                this._sceneUBOs.push(this._scene.createSceneUniformBuffer(`Scene for Shadow Generator (light "${this._light.name}")`));
            }
            ShadowGenerator._SceneComponentInitialization(this._scene);
            // Texture type fallback from float to int if not supported.
            const caps = this._scene.getEngine().getCaps();
            if (!usefullFloatFirst) {
                if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) {
                    this._textureType = 2;
                }
                else if (caps.textureFloatRender && caps.textureFloatLinearFiltering) {
                    this._textureType = 1;
                }
                else {
                    this._textureType = 0;
                }
            }
            else {
                if (caps.textureFloatRender && caps.textureFloatLinearFiltering) {
                    this._textureType = 1;
                }
                else if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) {
                    this._textureType = 2;
                }
                else {
                    this._textureType = 0;
                }
            }
            this._initializeGenerator();
            this._applyFilterValues();
        }
        _initializeGenerator() {
            this._light._markMeshesAsLightDirty();
            this._initializeShadowMap();
        }
        _createTargetRenderTexture() {
            const engine = this._scene.getEngine();
            if (engine._features.supportDepthStencilTexture) {
                this._shadowMap = new RenderTargetTexture(this._light.name + "_shadowMap", this._mapSize, this._scene, false, true, this._textureType, this._light.needCube(), undefined, false, false, undefined, this._useRedTextureType ? 6 : 5);
                this._shadowMap.createDepthStencilTexture(engine.useReverseDepthBuffer ? 516 : 513, true);
            }
            else {
                this._shadowMap = new RenderTargetTexture(this._light.name + "_shadowMap", this._mapSize, this._scene, false, true, this._textureType, this._light.needCube());
            }
            this._shadowMap.noPrePassRenderer = true;
        }
        _initializeShadowMap() {
            this._createTargetRenderTexture();
            if (this._shadowMap === null) {
                return;
            }
            this._shadowMap.wrapU = Texture.CLAMP_ADDRESSMODE;
            this._shadowMap.wrapV = Texture.CLAMP_ADDRESSMODE;
            this._shadowMap.anisotropicFilteringLevel = 1;
            this._shadowMap.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
            this._shadowMap.renderParticles = false;
            this._shadowMap.ignoreCameraViewport = true;
            if (this._storedUniqueId) {
                this._shadowMap.uniqueId = this._storedUniqueId;
            }
            // Custom render function.
            this._shadowMap.customRenderFunction = this._renderForShadowMap.bind(this);
            // Force the mesh is ready function to true as we are double checking it
            // in the custom render function. Also it prevents side effects and useless
            // shader variations in DEPTHPREPASS mode.
            this._shadowMap.customIsReadyFunction = () => {
                return true;
            };
            const engine = this._scene.getEngine();
            this._shadowMap.onBeforeBindObservable.add(() => {
                var _a;
                this._currentSceneUBO = this._scene.getSceneUniformBuffer();
                (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, `shadow map generation for pass id ${engine.currentRenderPassId}`, 1);
            });
            // Record Face Index before render.
            this._shadowMap.onBeforeRenderObservable.add((faceIndex) => {
                if (this._sceneUBOs) {
                    this._scene.setSceneUniformBuffer(this._sceneUBOs[0]);
                }
                this._currentFaceIndex = faceIndex;
                if (this._filter === ShadowGenerator.FILTER_PCF) {
                    engine.setColorWrite(false);
                }
                this.getTransformMatrix(); // generate the view/projection matrix
                this._scene.setTransformMatrix(this._viewMatrix, this._projectionMatrix);
                if (this._useUBO) {
                    this._scene.getSceneUniformBuffer().unbindEffect();
                    this._scene.finalizeSceneUbo();
                }
            });
            // Blur if required after render.
            this._shadowMap.onAfterUnbindObservable.add(() => {
                var _a, _b;
                if (this._sceneUBOs) {
                    this._scene.setSceneUniformBuffer(this._currentSceneUBO);
                }
                this._scene.updateTransformMatrix(); // restore the view/projection matrices of the active camera
                if (this._filter === ShadowGenerator.FILTER_PCF) {
                    engine.setColorWrite(true);
                }
                if (!this.useBlurExponentialShadowMap && !this.useBlurCloseExponentialShadowMap) {
                    (_a = engine._debugPopGroup) === null || _a === void 0 ? void 0 : _a.call(engine, 1);
                    return;
                }
                const shadowMap = this.getShadowMapForRendering();
                if (shadowMap) {
                    this._scene.postProcessManager.directRender(this._blurPostProcesses, shadowMap.renderTarget, true);
                    engine.unBindFramebuffer(shadowMap.renderTarget, true);
                    (_b = engine._debugPopGroup) === null || _b === void 0 ? void 0 : _b.call(engine, 1);
                }
            });
            // Clear according to the chosen filter.
            const clearZero = new Color4(0, 0, 0, 0);
            const clearOne = new Color4(1.0, 1.0, 1.0, 1.0);
            this._shadowMap.onClearObservable.add((engine) => {
                if (this._filter === ShadowGenerator.FILTER_PCF) {
                    engine.clear(clearOne, false, true, false);
                }
                else if (this.useExponentialShadowMap || this.useBlurExponentialShadowMap) {
                    engine.clear(clearZero, true, true, false);
                }
                else {
                    engine.clear(clearOne, true, true, false);
                }
            });
            // Recreate on resize.
            this._shadowMap.onResizeObservable.add((rtt) => {
                this._storedUniqueId = this._shadowMap.uniqueId;
                this._mapSize = rtt.getRenderSize();
                this._light._markMeshesAsLightDirty();
                this.recreateShadowMap();
            });
            // Ensures rendering groupids do not erase the depth buffer
            // or we would lose the shadows information.
            for (let i = RenderingManager.MIN_RENDERINGGROUPS; i < RenderingManager.MAX_RENDERINGGROUPS; i++) {
                this._shadowMap.setRenderingAutoClearDepthStencil(i, false);
            }
        }
        _initializeBlurRTTAndPostProcesses() {
            const engine = this._scene.getEngine();
            const targetSize = this._mapSize / this.blurScale;
            if (!this.useKernelBlur || this.blurScale !== 1.0) {
                this._shadowMap2 = new RenderTargetTexture(this._light.name + "_shadowMap2", targetSize, this._scene, false, true, this._textureType, undefined, undefined, false);
                this._shadowMap2.wrapU = Texture.CLAMP_ADDRESSMODE;
                this._shadowMap2.wrapV = Texture.CLAMP_ADDRESSMODE;
                this._shadowMap2.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
            }
            if (this.useKernelBlur) {
                this._kernelBlurXPostprocess = new BlurPostProcess(this._light.name + "KernelBlurX", new Vector2(1, 0), this.blurKernel, 1.0, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._textureType);
                this._kernelBlurXPostprocess.width = targetSize;
                this._kernelBlurXPostprocess.height = targetSize;
                this._kernelBlurXPostprocess.externalTextureSamplerBinding = true;
                this._kernelBlurXPostprocess.onApplyObservable.add((effect) => {
                    effect.setTexture("textureSampler", this._shadowMap);
                });
                this._kernelBlurYPostprocess = new BlurPostProcess(this._light.name + "KernelBlurY", new Vector2(0, 1), this.blurKernel, 1.0, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._textureType);
                this._kernelBlurXPostprocess.autoClear = false;
                this._kernelBlurYPostprocess.autoClear = false;
                if (this._textureType === 0) {
                    this._kernelBlurXPostprocess.packedFloat = true;
                    this._kernelBlurYPostprocess.packedFloat = true;
                }
                this._blurPostProcesses = [this._kernelBlurXPostprocess, this._kernelBlurYPostprocess];
            }
            else {
                this._boxBlurPostprocess = new PostProcess(this._light.name + "DepthBoxBlur", "depthBoxBlur", ["screenSize", "boxOffset"], [], 1.0, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, "#define OFFSET " + this._blurBoxOffset, this._textureType);
                this._boxBlurPostprocess.externalTextureSamplerBinding = true;
                this._boxBlurPostprocess.onApplyObservable.add((effect) => {
                    effect.setFloat2("screenSize", targetSize, targetSize);
                    effect.setTexture("textureSampler", this._shadowMap);
                });
                this._boxBlurPostprocess.autoClear = false;
                this._blurPostProcesses = [this._boxBlurPostprocess];
            }
        }
        _renderForShadowMap(opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes) {
            let index;
            if (depthOnlySubMeshes.length) {
                for (index = 0; index < depthOnlySubMeshes.length; index++) {
                    this._renderSubMeshForShadowMap(depthOnlySubMeshes.data[index]);
                }
            }
            for (index = 0; index < opaqueSubMeshes.length; index++) {
                this._renderSubMeshForShadowMap(opaqueSubMeshes.data[index]);
            }
            for (index = 0; index < alphaTestSubMeshes.length; index++) {
                this._renderSubMeshForShadowMap(alphaTestSubMeshes.data[index]);
            }
            if (this._transparencyShadow) {
                for (index = 0; index < transparentSubMeshes.length; index++) {
                    this._renderSubMeshForShadowMap(transparentSubMeshes.data[index], true);
                }
            }
            else {
                for (index = 0; index < transparentSubMeshes.length; index++) {
                    transparentSubMeshes.data[index].getEffectiveMesh()._internalAbstractMeshDataInfo._isActiveIntermediate = false;
                }
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _bindCustomEffectForRenderSubMeshForShadowMap(subMesh, effect, mesh) {
            effect.setMatrix("viewProjection", this.getTransformMatrix());
        }
        _renderSubMeshForShadowMap(subMesh, isTransparent = false) {
            var _a, _b;
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = subMesh.getEffectiveMesh();
            const scene = this._scene;
            const engine = scene.getEngine();
            const material = subMesh.getMaterial();
            effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            if (!material || subMesh.verticesCount === 0 || subMesh._renderId === scene.getRenderId()) {
                return;
            }
            // Culling
            const detNeg = effectiveMesh._getWorldMatrixDeterminant() < 0;
            let sideOrientation = (_a = renderingMesh.overrideMaterialSideOrientation) !== null && _a !== void 0 ? _a : material.sideOrientation;
            if (detNeg) {
                sideOrientation =
                    sideOrientation === 0 ? 1 : 0;
            }
            const reverseSideOrientation = sideOrientation === 0;
            engine.setState(material.backFaceCulling, undefined, undefined, reverseSideOrientation, material.cullBackFaces);
            // Managing instances
            const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
            if (batch.mustReturn) {
                return;
            }
            const hardwareInstancedRendering = engine.getCaps().instancedArrays &&
                ((batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined) || renderingMesh.hasThinInstances);
            if (this.customAllowRendering && !this.customAllowRendering(subMesh)) {
                return;
            }
            if (this.isReady(subMesh, hardwareInstancedRendering, isTransparent)) {
                subMesh._renderId = scene.getRenderId();
                const shadowDepthWrapper = material.shadowDepthWrapper;
                const drawWrapper = (_b = shadowDepthWrapper === null || shadowDepthWrapper === void 0 ? void 0 : shadowDepthWrapper.getEffect(subMesh, this, engine.currentRenderPassId)) !== null && _b !== void 0 ? _b : subMesh._getDrawWrapper();
                const effect = DrawWrapper.GetEffect(drawWrapper);
                engine.enableEffect(drawWrapper);
                if (!hardwareInstancedRendering) {
                    renderingMesh._bind(subMesh, effect, material.fillMode);
                }
                this.getTransformMatrix(); // make sure _cachedDirection et _cachedPosition are up to date
                effect.setFloat3("biasAndScaleSM", this.bias, this.normalBias, this.depthScale);
                if (this.getLight().getTypeID() === Light.LIGHTTYPEID_DIRECTIONALLIGHT) {
                    effect.setVector3("lightDataSM", this._cachedDirection);
                }
                else {
                    effect.setVector3("lightDataSM", this._cachedPosition);
                }
                const camera = this._getCamera();
                if (camera) {
                    effect.setFloat2("depthValuesSM", this.getLight().getDepthMinZ(camera), this.getLight().getDepthMinZ(camera) + this.getLight().getDepthMaxZ(camera));
                }
                if (isTransparent && this.enableSoftTransparentShadow) {
                    effect.setFloat("softTransparentShadowSM", effectiveMesh.visibility * material.alpha);
                }
                if (shadowDepthWrapper) {
                    subMesh._setMainDrawWrapperOverride(drawWrapper);
                    if (shadowDepthWrapper.standalone) {
                        shadowDepthWrapper.baseMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), renderingMesh, subMesh);
                    }
                    else {
                        material.bindForSubMesh(effectiveMesh.getWorldMatrix(), renderingMesh, subMesh);
                    }
                    subMesh._setMainDrawWrapperOverride(null);
                }
                else {
                    // Alpha test
                    if (this._opacityTexture) {
                        effect.setTexture("diffuseSampler", this._opacityTexture);
                        effect.setMatrix("diffuseMatrix", this._opacityTexture.getTextureMatrix() || this._defaultTextureMatrix);
                    }
                    // Bones
                    if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                        const skeleton = renderingMesh.skeleton;
                        if (skeleton.isUsingTextureForMatrices) {
                            const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                            if (!boneTexture) {
                                return;
                            }
                            effect.setTexture("boneSampler", boneTexture);
                            effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                        }
                        else {
                            effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
                        }
                    }
                    // Morph targets
                    MaterialHelper.BindMorphTargetParameters(renderingMesh, effect);
                    if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) {
                        renderingMesh.morphTargetManager._bind(effect);
                    }
                    // Clip planes
                    bindClipPlane(effect, material, scene);
                }
                if (!this._useUBO && !shadowDepthWrapper) {
                    this._bindCustomEffectForRenderSubMeshForShadowMap(subMesh, effect, effectiveMesh);
                }
                MaterialHelper.BindSceneUniformBuffer(effect, this._scene.getSceneUniformBuffer());
                this._scene.getSceneUniformBuffer().bindUniformBuffer();
                const world = effectiveMesh.getWorldMatrix();
                // In the non hardware instanced mode, the Mesh ubo update is done by the callback passed to renderingMesh._processRendering (see below)
                if (hardwareInstancedRendering) {
                    effectiveMesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                    effectiveMesh.transferToEffect(world);
                }
                if (this.forceBackFacesOnly) {
                    engine.setState(true, 0, false, true, material.cullBackFaces);
                }
                // Observables
                this.onBeforeShadowMapRenderMeshObservable.notifyObservers(renderingMesh);
                this.onBeforeShadowMapRenderObservable.notifyObservers(effect);
                // Draw
                renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, worldOverride) => {
                    if (effectiveMesh !== renderingMesh && !isInstance) {
                        renderingMesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                        renderingMesh.transferToEffect(worldOverride);
                    }
                    else {
                        effectiveMesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                        effectiveMesh.transferToEffect(isInstance ? worldOverride : world);
                    }
                });
                if (this.forceBackFacesOnly) {
                    engine.setState(true, 0, false, false, material.cullBackFaces);
                }
                // Observables
                this.onAfterShadowMapRenderObservable.notifyObservers(effect);
                this.onAfterShadowMapRenderMeshObservable.notifyObservers(renderingMesh);
            }
            else {
                // Need to reset refresh rate of the shadowMap
                if (this._shadowMap) {
                    this._shadowMap.resetRefreshCounter();
                }
            }
        }
        _applyFilterValues() {
            if (!this._shadowMap) {
                return;
            }
            if (this.filter === ShadowGenerator.FILTER_NONE || this.filter === ShadowGenerator.FILTER_PCSS) {
                this._shadowMap.updateSamplingMode(Texture.NEAREST_SAMPLINGMODE);
            }
            else {
                this._shadowMap.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
            }
        }
        /**
         * Forces all the attached effect to compile to enable rendering only once ready vs. lazily compiling effects.
         * @param onCompiled Callback triggered at the and of the effects compilation
         * @param options Sets of optional options forcing the compilation with different modes
         */
        forceCompilation(onCompiled, options) {
            const localOptions = Object.assign({ useInstances: false }, options);
            const shadowMap = this.getShadowMap();
            if (!shadowMap) {
                if (onCompiled) {
                    onCompiled(this);
                }
                return;
            }
            const renderList = shadowMap.renderList;
            if (!renderList) {
                if (onCompiled) {
                    onCompiled(this);
                }
                return;
            }
            const subMeshes = new Array();
            for (const mesh of renderList) {
                subMeshes.push(...mesh.subMeshes);
            }
            if (subMeshes.length === 0) {
                if (onCompiled) {
                    onCompiled(this);
                }
                return;
            }
            let currentIndex = 0;
            const checkReady = () => {
                var _a, _b;
                if (!this._scene || !this._scene.getEngine()) {
                    return;
                }
                while (this.isReady(subMeshes[currentIndex], localOptions.useInstances, (_b = (_a = subMeshes[currentIndex].getMaterial()) === null || _a === void 0 ? void 0 : _a.needAlphaBlendingForMesh(subMeshes[currentIndex].getMesh())) !== null && _b !== void 0 ? _b : false)) {
                    currentIndex++;
                    if (currentIndex >= subMeshes.length) {
                        if (onCompiled) {
                            onCompiled(this);
                        }
                        return;
                    }
                }
                setTimeout(checkReady, 16);
            };
            checkReady();
        }
        /**
         * Forces all the attached effect to compile to enable rendering only once ready vs. lazily compiling effects.
         * @param options Sets of optional options forcing the compilation with different modes
         * @returns A promise that resolves when the compilation completes
         */
        forceCompilationAsync(options) {
            return new Promise((resolve) => {
                this.forceCompilation(() => {
                    resolve();
                }, options);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _isReadyCustomDefines(defines, subMesh, useInstances) { }
        _prepareShadowDefines(subMesh, useInstances, defines, isTransparent) {
            defines.push("#define SM_LIGHTTYPE_" + this._light.getClassName().toUpperCase());
            defines.push("#define SM_FLOAT " + (this._textureType !== 0 ? "1" : "0"));
            defines.push("#define SM_ESM " + (this.useExponentialShadowMap || this.useBlurExponentialShadowMap ? "1" : "0"));
            defines.push("#define SM_DEPTHTEXTURE " + (this.usePercentageCloserFiltering || this.useContactHardeningShadow ? "1" : "0"));
            const mesh = subMesh.getMesh();
            // Normal bias.
            defines.push("#define SM_NORMALBIAS " + (this.normalBias && mesh.isVerticesDataPresent(VertexBuffer.NormalKind) ? "1" : "0"));
            defines.push("#define SM_DIRECTIONINLIGHTDATA " + (this.getLight().getTypeID() === Light.LIGHTTYPEID_DIRECTIONALLIGHT ? "1" : "0"));
            // Point light
            defines.push("#define SM_USEDISTANCE " + (this._light.needCube() ? "1" : "0"));
            // Soft transparent shadows
            defines.push("#define SM_SOFTTRANSPARENTSHADOW " + (this.enableSoftTransparentShadow && isTransparent ? "1" : "0"));
            this._isReadyCustomDefines(defines, subMesh, useInstances);
            return defines;
        }
        /**
         * Determine whether the shadow generator is ready or not (mainly all effects and related post processes needs to be ready).
         * @param subMesh The submesh we want to render in the shadow map
         * @param useInstances Defines whether will draw in the map using instances
         * @param isTransparent Indicates that isReady is called for a transparent subMesh
         * @returns true if ready otherwise, false
         */
        isReady(subMesh, useInstances, isTransparent) {
            var _a;
            const material = subMesh.getMaterial(), shadowDepthWrapper = material === null || material === void 0 ? void 0 : material.shadowDepthWrapper;
            this._opacityTexture = null;
            if (!material) {
                return false;
            }
            const defines = [];
            this._prepareShadowDefines(subMesh, useInstances, defines, isTransparent);
            if (shadowDepthWrapper) {
                if (!shadowDepthWrapper.isReadyForSubMesh(subMesh, defines, this, useInstances, this._scene.getEngine().currentRenderPassId)) {
                    return false;
                }
            }
            else {
                const subMeshEffect = subMesh._getDrawWrapper(undefined, true);
                let effect = subMeshEffect.effect;
                let cachedDefines = subMeshEffect.defines;
                const attribs = [VertexBuffer.PositionKind];
                const mesh = subMesh.getMesh();
                // Normal bias.
                if (this.normalBias && mesh.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                    attribs.push(VertexBuffer.NormalKind);
                    defines.push("#define NORMAL");
                    if (mesh.nonUniformScaling) {
                        defines.push("#define NONUNIFORMSCALING");
                    }
                }
                // Alpha test
                const needAlphaTesting = material.needAlphaTesting();
                if (needAlphaTesting || material.needAlphaBlending()) {
                    if (this.useOpacityTextureForTransparentShadow) {
                        this._opacityTexture = material.opacityTexture;
                    }
                    else {
                        this._opacityTexture = material.getAlphaTestTexture();
                    }
                    if (this._opacityTexture) {
                        if (!this._opacityTexture.isReady()) {
                            return false;
                        }
                        const alphaCutOff = (_a = material.alphaCutOff) !== null && _a !== void 0 ? _a : ShadowGenerator.DEFAULT_ALPHA_CUTOFF;
                        defines.push("#define ALPHATEXTURE");
                        if (needAlphaTesting) {
                            defines.push(`#define ALPHATESTVALUE ${alphaCutOff}${alphaCutOff % 1 === 0 ? "." : ""}`);
                        }
                        if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                            attribs.push(VertexBuffer.UVKind);
                            defines.push("#define UV1");
                        }
                        if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind)) {
                            if (this._opacityTexture.coordinatesIndex === 1) {
                                attribs.push(VertexBuffer.UV2Kind);
                                defines.push("#define UV2");
                            }
                        }
                    }
                }
                // Bones
                const fallbacks = new EffectFallbacks();
                if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
                    attribs.push(VertexBuffer.MatricesIndicesKind);
                    attribs.push(VertexBuffer.MatricesWeightsKind);
                    if (mesh.numBoneInfluencers > 4) {
                        attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                        attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                    }
                    const skeleton = mesh.skeleton;
                    defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                    if (mesh.numBoneInfluencers > 0) {
                        fallbacks.addCPUSkinningFallback(0, mesh);
                    }
                    if (skeleton.isUsingTextureForMatrices) {
                        defines.push("#define BONETEXTURE");
                    }
                    else {
                        defines.push("#define BonesPerMesh " + (skeleton.bones.length + 1));
                    }
                }
                else {
                    defines.push("#define NUM_BONE_INFLUENCERS 0");
                }
                // Morph targets
                const manager = mesh.morphTargetManager;
                let morphInfluencers = 0;
                if (manager) {
                    if (manager.numInfluencers > 0) {
                        defines.push("#define MORPHTARGETS");
                        morphInfluencers = manager.numInfluencers;
                        defines.push("#define NUM_MORPH_INFLUENCERS " + morphInfluencers);
                        if (manager.isUsingTextureForTargets) {
                            defines.push("#define MORPHTARGETS_TEXTURE");
                        }
                        MaterialHelper.PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, morphInfluencers);
                    }
                }
                // ClipPlanes
                prepareStringDefinesForClipPlanes(material, this._scene, defines);
                // Instances
                if (useInstances) {
                    defines.push("#define INSTANCES");
                    MaterialHelper.PushAttributesForInstances(attribs);
                    if (subMesh.getRenderingMesh().hasThinInstances) {
                        defines.push("#define THIN_INSTANCES");
                    }
                }
                if (this.customShaderOptions) {
                    if (this.customShaderOptions.defines) {
                        for (const define of this.customShaderOptions.defines) {
                            if (defines.indexOf(define) === -1) {
                                defines.push(define);
                            }
                        }
                    }
                }
                // Get correct effect
                const join = defines.join("\n");
                if (cachedDefines !== join) {
                    cachedDefines = join;
                    let shaderName = "shadowMap";
                    const uniforms = [
                        "world",
                        "mBones",
                        "viewProjection",
                        "diffuseMatrix",
                        "lightDataSM",
                        "depthValuesSM",
                        "biasAndScaleSM",
                        "morphTargetInfluences",
                        "boneTextureWidth",
                        "softTransparentShadowSM",
                        "morphTargetTextureInfo",
                        "morphTargetTextureIndices",
                    ];
                    const samplers = ["diffuseSampler", "boneSampler", "morphTargets"];
                    const uniformBuffers = ["Scene", "Mesh"];
                    addClipPlaneUniforms(uniforms);
                    // Custom shader?
                    if (this.customShaderOptions) {
                        shaderName = this.customShaderOptions.shaderName;
                        if (this.customShaderOptions.attributes) {
                            for (const attrib of this.customShaderOptions.attributes) {
                                if (attribs.indexOf(attrib) === -1) {
                                    attribs.push(attrib);
                                }
                            }
                        }
                        if (this.customShaderOptions.uniforms) {
                            for (const uniform of this.customShaderOptions.uniforms) {
                                if (uniforms.indexOf(uniform) === -1) {
                                    uniforms.push(uniform);
                                }
                            }
                        }
                        if (this.customShaderOptions.samplers) {
                            for (const sampler of this.customShaderOptions.samplers) {
                                if (samplers.indexOf(sampler) === -1) {
                                    samplers.push(sampler);
                                }
                            }
                        }
                    }
                    const engine = this._scene.getEngine();
                    effect = engine.createEffect(shaderName, {
                        attributes: attribs,
                        uniformsNames: uniforms,
                        uniformBuffersNames: uniformBuffers,
                        samplers: samplers,
                        defines: join,
                        fallbacks: fallbacks,
                        onCompiled: null,
                        onError: null,
                        indexParameters: { maxSimultaneousMorphTargets: morphInfluencers },
                    }, engine);
                    subMeshEffect.setEffect(effect, cachedDefines);
                }
                if (!effect.isReady()) {
                    return false;
                }
            }
            if (this.useBlurExponentialShadowMap || this.useBlurCloseExponentialShadowMap) {
                if (!this._blurPostProcesses || !this._blurPostProcesses.length) {
                    this._initializeBlurRTTAndPostProcesses();
                }
            }
            if (this._kernelBlurXPostprocess && !this._kernelBlurXPostprocess.isReady()) {
                return false;
            }
            if (this._kernelBlurYPostprocess && !this._kernelBlurYPostprocess.isReady()) {
                return false;
            }
            if (this._boxBlurPostprocess && !this._boxBlurPostprocess.isReady()) {
                return false;
            }
            return true;
        }
        /**
         * Prepare all the defines in a material relying on a shadow map at the specified light index.
         * @param defines Defines of the material we want to update
         * @param lightIndex Index of the light in the enabled light list of the material
         */
        prepareDefines(defines, lightIndex) {
            const scene = this._scene;
            const light = this._light;
            if (!scene.shadowsEnabled || !light.shadowEnabled) {
                return;
            }
            defines["SHADOW" + lightIndex] = true;
            if (this.useContactHardeningShadow) {
                defines["SHADOWPCSS" + lightIndex] = true;
                if (this._filteringQuality === ShadowGenerator.QUALITY_LOW) {
                    defines["SHADOWLOWQUALITY" + lightIndex] = true;
                }
                else if (this._filteringQuality === ShadowGenerator.QUALITY_MEDIUM) {
                    defines["SHADOWMEDIUMQUALITY" + lightIndex] = true;
                }
                // else default to high.
            }
            else if (this.usePercentageCloserFiltering) {
                defines["SHADOWPCF" + lightIndex] = true;
                if (this._filteringQuality === ShadowGenerator.QUALITY_LOW) {
                    defines["SHADOWLOWQUALITY" + lightIndex] = true;
                }
                else if (this._filteringQuality === ShadowGenerator.QUALITY_MEDIUM) {
                    defines["SHADOWMEDIUMQUALITY" + lightIndex] = true;
                }
                // else default to high.
            }
            else if (this.usePoissonSampling) {
                defines["SHADOWPOISSON" + lightIndex] = true;
            }
            else if (this.useExponentialShadowMap || this.useBlurExponentialShadowMap) {
                defines["SHADOWESM" + lightIndex] = true;
            }
            else if (this.useCloseExponentialShadowMap || this.useBlurCloseExponentialShadowMap) {
                defines["SHADOWCLOSEESM" + lightIndex] = true;
            }
            if (light.needCube()) {
                defines["SHADOWCUBE" + lightIndex] = true;
            }
        }
        /**
         * Binds the shadow related information inside of an effect (information like near, far, darkness...
         * defined in the generator but impacting the effect).
         * @param lightIndex Index of the light in the enabled light list of the material owning the effect
         * @param effect The effect we are binding the information for
         */
        bindShadowLight(lightIndex, effect) {
            const light = this._light;
            const scene = this._scene;
            if (!scene.shadowsEnabled || !light.shadowEnabled) {
                return;
            }
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            const shadowMap = this.getShadowMap();
            if (!shadowMap) {
                return;
            }
            if (!light.needCube()) {
                effect.setMatrix("lightMatrix" + lightIndex, this.getTransformMatrix());
            }
            // Only PCF uses depth stencil texture.
            if (this._filter === ShadowGenerator.FILTER_PCF) {
                effect.setDepthStencilTexture("shadowSampler" + lightIndex, this.getShadowMapForRendering());
                light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), shadowMap.getSize().width, 1 / shadowMap.getSize().width, this.frustumEdgeFalloff, lightIndex);
            }
            else if (this._filter === ShadowGenerator.FILTER_PCSS) {
                effect.setDepthStencilTexture("shadowSampler" + lightIndex, this.getShadowMapForRendering());
                effect.setTexture("depthSampler" + lightIndex, this.getShadowMapForRendering());
                light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), 1 / shadowMap.getSize().width, this._contactHardeningLightSizeUVRatio * shadowMap.getSize().width, this.frustumEdgeFalloff, lightIndex);
            }
            else {
                effect.setTexture("shadowSampler" + lightIndex, this.getShadowMapForRendering());
                light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), this.blurScale / shadowMap.getSize().width, this.depthScale, this.frustumEdgeFalloff, lightIndex);
            }
            light._uniformBuffer.updateFloat2("depthValues", this.getLight().getDepthMinZ(camera), this.getLight().getDepthMinZ(camera) + this.getLight().getDepthMaxZ(camera), lightIndex);
        }
        /**
         * Gets the transformation matrix used to project the meshes into the map from the light point of view.
         * (eq to shadow projection matrix * light transform matrix)
         * @returns The transform matrix used to create the shadow map
         */
        getTransformMatrix() {
            const scene = this._scene;
            if (this._currentRenderId === scene.getRenderId() && this._currentFaceIndexCache === this._currentFaceIndex) {
                return this._transformMatrix;
            }
            this._currentRenderId = scene.getRenderId();
            this._currentFaceIndexCache = this._currentFaceIndex;
            let lightPosition = this._light.position;
            if (this._light.computeTransformedInformation()) {
                lightPosition = this._light.transformedPosition;
            }
            Vector3.NormalizeToRef(this._light.getShadowDirection(this._currentFaceIndex), this._lightDirection);
            if (Math.abs(Vector3.Dot(this._lightDirection, Vector3.Up())) === 1.0) {
                this._lightDirection.z = 0.0000000000001; // Required to avoid perfectly perpendicular light
            }
            if (this._light.needProjectionMatrixCompute() ||
                !this._cachedPosition ||
                !this._cachedDirection ||
                !lightPosition.equals(this._cachedPosition) ||
                !this._lightDirection.equals(this._cachedDirection)) {
                this._cachedPosition.copyFrom(lightPosition);
                this._cachedDirection.copyFrom(this._lightDirection);
                Matrix.LookAtLHToRef(lightPosition, lightPosition.add(this._lightDirection), Vector3.Up(), this._viewMatrix);
                const shadowMap = this.getShadowMap();
                if (shadowMap) {
                    const renderList = shadowMap.renderList;
                    if (renderList) {
                        this._light.setShadowProjectionMatrix(this._projectionMatrix, this._viewMatrix, renderList);
                    }
                }
                this._viewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
            }
            return this._transformMatrix;
        }
        /**
         * Recreates the shadow map dependencies like RTT and post processes. This can be used during the switch between
         * Cube and 2D textures for instance.
         */
        recreateShadowMap() {
            const shadowMap = this._shadowMap;
            if (!shadowMap) {
                return;
            }
            // Track render list.
            const renderList = shadowMap.renderList;
            // Clean up existing data.
            this._disposeRTTandPostProcesses();
            // Reinitializes.
            this._initializeGenerator();
            // Reaffect the filter to ensure a correct fallback if necessary.
            this.filter = this._filter;
            // Reaffect the filter.
            this._applyFilterValues();
            // Reaffect Render List.
            if (renderList) {
                // Note: don't do this._shadowMap!.renderList = renderList;
                // The renderList hooked array is accessing the old RenderTargetTexture (see RenderTargetTexture._hookArray), which is disposed at this point (by the call to _disposeRTTandPostProcesses)
                if (!this._shadowMap.renderList) {
                    this._shadowMap.renderList = [];
                }
                for (const mesh of renderList) {
                    this._shadowMap.renderList.push(mesh);
                }
            }
            else {
                this._shadowMap.renderList = null;
            }
        }
        _disposeBlurPostProcesses() {
            if (this._shadowMap2) {
                this._shadowMap2.dispose();
                this._shadowMap2 = null;
            }
            if (this._boxBlurPostprocess) {
                this._boxBlurPostprocess.dispose();
                this._boxBlurPostprocess = null;
            }
            if (this._kernelBlurXPostprocess) {
                this._kernelBlurXPostprocess.dispose();
                this._kernelBlurXPostprocess = null;
            }
            if (this._kernelBlurYPostprocess) {
                this._kernelBlurYPostprocess.dispose();
                this._kernelBlurYPostprocess = null;
            }
            this._blurPostProcesses = [];
        }
        _disposeRTTandPostProcesses() {
            if (this._shadowMap) {
                this._shadowMap.dispose();
                this._shadowMap = null;
            }
            this._disposeBlurPostProcesses();
        }
        _disposeSceneUBOs() {
            if (this._sceneUBOs) {
                for (const ubo of this._sceneUBOs) {
                    ubo.dispose();
                }
                this._sceneUBOs = [];
            }
        }
        /**
         * Disposes the ShadowGenerator.
         * Returns nothing.
         */
        dispose() {
            this._disposeRTTandPostProcesses();
            this._disposeSceneUBOs();
            if (this._light) {
                if (this._light._shadowGenerators) {
                    const iterator = this._light._shadowGenerators.entries();
                    for (let entry = iterator.next(); entry.done !== true; entry = iterator.next()) {
                        const [camera, shadowGenerator] = entry.value;
                        if (shadowGenerator === this) {
                            this._light._shadowGenerators.delete(camera);
                        }
                    }
                    if (this._light._shadowGenerators.size === 0) {
                        this._light._shadowGenerators = null;
                    }
                }
                this._light._markMeshesAsLightDirty();
            }
            this.onBeforeShadowMapRenderMeshObservable.clear();
            this.onBeforeShadowMapRenderObservable.clear();
            this.onAfterShadowMapRenderMeshObservable.clear();
            this.onAfterShadowMapRenderObservable.clear();
        }
        /**
         * Serializes the shadow generator setup to a json object.
         * @returns The serialized JSON object
         */
        serialize() {
            var _a;
            const serializationObject = {};
            const shadowMap = this.getShadowMap();
            if (!shadowMap) {
                return serializationObject;
            }
            serializationObject.className = this.getClassName();
            serializationObject.lightId = this._light.id;
            serializationObject.cameraId = (_a = this._camera) === null || _a === void 0 ? void 0 : _a.id;
            serializationObject.id = this.id;
            serializationObject.mapSize = shadowMap.getRenderSize();
            serializationObject.forceBackFacesOnly = this.forceBackFacesOnly;
            serializationObject.darkness = this.getDarkness();
            serializationObject.transparencyShadow = this._transparencyShadow;
            serializationObject.frustumEdgeFalloff = this.frustumEdgeFalloff;
            serializationObject.bias = this.bias;
            serializationObject.normalBias = this.normalBias;
            serializationObject.usePercentageCloserFiltering = this.usePercentageCloserFiltering;
            serializationObject.useContactHardeningShadow = this.useContactHardeningShadow;
            serializationObject.contactHardeningLightSizeUVRatio = this.contactHardeningLightSizeUVRatio;
            serializationObject.filteringQuality = this.filteringQuality;
            serializationObject.useExponentialShadowMap = this.useExponentialShadowMap;
            serializationObject.useBlurExponentialShadowMap = this.useBlurExponentialShadowMap;
            serializationObject.useCloseExponentialShadowMap = this.useBlurExponentialShadowMap;
            serializationObject.useBlurCloseExponentialShadowMap = this.useBlurExponentialShadowMap;
            serializationObject.usePoissonSampling = this.usePoissonSampling;
            serializationObject.depthScale = this.depthScale;
            serializationObject.blurBoxOffset = this.blurBoxOffset;
            serializationObject.blurKernel = this.blurKernel;
            serializationObject.blurScale = this.blurScale;
            serializationObject.useKernelBlur = this.useKernelBlur;
            serializationObject.renderList = [];
            if (shadowMap.renderList) {
                for (let meshIndex = 0; meshIndex < shadowMap.renderList.length; meshIndex++) {
                    const mesh = shadowMap.renderList[meshIndex];
                    serializationObject.renderList.push(mesh.id);
                }
            }
            return serializationObject;
        }
        /**
         * Parses a serialized ShadowGenerator and returns a new ShadowGenerator.
         * @param parsedShadowGenerator The JSON object to parse
         * @param scene The scene to create the shadow map for
         * @param constr A function that builds a shadow generator or undefined to create an instance of the default shadow generator
         * @returns The parsed shadow generator
         */
        static Parse(parsedShadowGenerator, scene, constr) {
            const light = scene.getLightById(parsedShadowGenerator.lightId);
            const camera = parsedShadowGenerator.cameraId !== undefined ? scene.getCameraById(parsedShadowGenerator.cameraId) : null;
            const shadowGenerator = constr ? constr(parsedShadowGenerator.mapSize, light, camera) : new ShadowGenerator(parsedShadowGenerator.mapSize, light, undefined, camera);
            const shadowMap = shadowGenerator.getShadowMap();
            for (let meshIndex = 0; meshIndex < parsedShadowGenerator.renderList.length; meshIndex++) {
                const meshes = scene.getMeshesById(parsedShadowGenerator.renderList[meshIndex]);
                meshes.forEach(function (mesh) {
                    if (!shadowMap) {
                        return;
                    }
                    if (!shadowMap.renderList) {
                        shadowMap.renderList = [];
                    }
                    shadowMap.renderList.push(mesh);
                });
            }
            if (parsedShadowGenerator.id !== undefined) {
                shadowGenerator.id = parsedShadowGenerator.id;
            }
            shadowGenerator.forceBackFacesOnly = !!parsedShadowGenerator.forceBackFacesOnly;
            if (parsedShadowGenerator.darkness !== undefined) {
                shadowGenerator.setDarkness(parsedShadowGenerator.darkness);
            }
            if (parsedShadowGenerator.transparencyShadow) {
                shadowGenerator.setTransparencyShadow(true);
            }
            if (parsedShadowGenerator.frustumEdgeFalloff !== undefined) {
                shadowGenerator.frustumEdgeFalloff = parsedShadowGenerator.frustumEdgeFalloff;
            }
            if (parsedShadowGenerator.bias !== undefined) {
                shadowGenerator.bias = parsedShadowGenerator.bias;
            }
            if (parsedShadowGenerator.normalBias !== undefined) {
                shadowGenerator.normalBias = parsedShadowGenerator.normalBias;
            }
            if (parsedShadowGenerator.usePercentageCloserFiltering) {
                shadowGenerator.usePercentageCloserFiltering = true;
            }
            else if (parsedShadowGenerator.useContactHardeningShadow) {
                shadowGenerator.useContactHardeningShadow = true;
            }
            else if (parsedShadowGenerator.usePoissonSampling) {
                shadowGenerator.usePoissonSampling = true;
            }
            else if (parsedShadowGenerator.useExponentialShadowMap) {
                shadowGenerator.useExponentialShadowMap = true;
            }
            else if (parsedShadowGenerator.useBlurExponentialShadowMap) {
                shadowGenerator.useBlurExponentialShadowMap = true;
            }
            else if (parsedShadowGenerator.useCloseExponentialShadowMap) {
                shadowGenerator.useCloseExponentialShadowMap = true;
            }
            else if (parsedShadowGenerator.useBlurCloseExponentialShadowMap) {
                shadowGenerator.useBlurCloseExponentialShadowMap = true;
            }
            // Backward compat
            else if (parsedShadowGenerator.useVarianceShadowMap) {
                shadowGenerator.useExponentialShadowMap = true;
            }
            else if (parsedShadowGenerator.useBlurVarianceShadowMap) {
                shadowGenerator.useBlurExponentialShadowMap = true;
            }
            if (parsedShadowGenerator.contactHardeningLightSizeUVRatio !== undefined) {
                shadowGenerator.contactHardeningLightSizeUVRatio = parsedShadowGenerator.contactHardeningLightSizeUVRatio;
            }
            if (parsedShadowGenerator.filteringQuality !== undefined) {
                shadowGenerator.filteringQuality = parsedShadowGenerator.filteringQuality;
            }
            if (parsedShadowGenerator.depthScale) {
                shadowGenerator.depthScale = parsedShadowGenerator.depthScale;
            }
            if (parsedShadowGenerator.blurScale) {
                shadowGenerator.blurScale = parsedShadowGenerator.blurScale;
            }
            if (parsedShadowGenerator.blurBoxOffset) {
                shadowGenerator.blurBoxOffset = parsedShadowGenerator.blurBoxOffset;
            }
            if (parsedShadowGenerator.useKernelBlur) {
                shadowGenerator.useKernelBlur = parsedShadowGenerator.useKernelBlur;
            }
            if (parsedShadowGenerator.blurKernel) {
                shadowGenerator.blurKernel = parsedShadowGenerator.blurKernel;
            }
            return shadowGenerator;
        }
    }
    /**
     * Name of the shadow generator class
     */
    ShadowGenerator.CLASSNAME = "ShadowGenerator";
    /**
     * Shadow generator mode None: no filtering applied.
     */
    ShadowGenerator.FILTER_NONE = 0;
    /**
     * Shadow generator mode ESM: Exponential Shadow Mapping.
     * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
     */
    ShadowGenerator.FILTER_EXPONENTIALSHADOWMAP = 1;
    /**
     * Shadow generator mode Poisson Sampling: Percentage Closer Filtering.
     * (Multiple Tap around evenly distributed around the pixel are used to evaluate the shadow strength)
     */
    ShadowGenerator.FILTER_POISSONSAMPLING = 2;
    /**
     * Shadow generator mode ESM: Blurred Exponential Shadow Mapping.
     * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
     */
    ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP = 3;
    /**
     * Shadow generator mode ESM: Exponential Shadow Mapping using the inverse of the exponential preventing
     * edge artifacts on steep falloff.
     * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
     */
    ShadowGenerator.FILTER_CLOSEEXPONENTIALSHADOWMAP = 4;
    /**
     * Shadow generator mode ESM: Blurred Exponential Shadow Mapping using the inverse of the exponential preventing
     * edge artifacts on steep falloff.
     * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
     */
    ShadowGenerator.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP = 5;
    /**
     * Shadow generator mode PCF: Percentage Closer Filtering
     * benefits from Webgl 2 shadow samplers. Fallback to Poisson Sampling in Webgl 1
     * (https://developer.nvidia.com/gpugems/GPUGems/gpugems_ch11.html)
     */
    ShadowGenerator.FILTER_PCF = 6;
    /**
     * Shadow generator mode PCSS: Percentage Closering Soft Shadow.
     * benefits from Webgl 2 shadow samplers. Fallback to Poisson Sampling in Webgl 1
     * Contact Hardening
     */
    ShadowGenerator.FILTER_PCSS = 7;
    /**
     * Reserved for PCF and PCSS
     * Highest Quality.
     *
     * Execute PCF on a 5*5 kernel improving a lot the shadow aliasing artifacts.
     *
     * Execute PCSS with 32 taps blocker search and 64 taps PCF.
     */
    ShadowGenerator.QUALITY_HIGH = 0;
    /**
     * Reserved for PCF and PCSS
     * Good tradeoff for quality/perf cross devices
     *
     * Execute PCF on a 3*3 kernel.
     *
     * Execute PCSS with 16 taps blocker search and 32 taps PCF.
     */
    ShadowGenerator.QUALITY_MEDIUM = 1;
    /**
     * Reserved for PCF and PCSS
     * The lowest quality but the fastest.
     *
     * Execute PCF on a 1*1 kernel.
     *
     * Execute PCSS with 16 taps blocker search and 16 taps PCF.
     */
    ShadowGenerator.QUALITY_LOW = 2;
    /**
     * Defines the default alpha cutoff value used for transparent alpha tested materials.
     */
    ShadowGenerator.DEFAULT_ALPHA_CUTOFF = 0.5;
    /**
     * @internal
     */
    ShadowGenerator._SceneComponentInitialization = (_) => {
        throw _WarnImport("ShadowGeneratorSceneComponent");
    };

    // Do not edit.
    const name$2e = "depthPixelShader";
    const shader$2e = `#ifdef ALPHATEST
varying vec2 vUV;uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
varying float vDepthMetric;
#ifdef PACKED
#include<packingFunctions>
#endif
#ifdef STORE_CAMERASPACE_Z
varying vec4 vViewPos;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
#ifdef STORE_CAMERASPACE_Z
#ifdef PACKED
gl_FragColor=pack(vViewPos.z);
#else
gl_FragColor=vec4(vViewPos.z,0.0,0.0,1.0);
#endif
#else
#ifdef NONLINEARDEPTH
#ifdef PACKED
gl_FragColor=pack(gl_FragCoord.z);
#else
gl_FragColor=vec4(gl_FragCoord.z,0.0,0.0,0.0);
#endif
#else
#ifdef PACKED
gl_FragColor=pack(vDepthMetric);
#else
gl_FragColor=vec4(vDepthMetric,0.0,0.0,1.0);
#endif
#endif
#endif
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2e] = shader$2e;

    // Do not edit.
    const name$2f = "depthVertexShader";
    const shader$2f = `attribute vec3 position;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
#include<instancesDeclaration>
uniform mat4 viewProjection;uniform vec2 depthValues;
#if defined(ALPHATEST) || defined(NEED_UV)
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#ifdef STORE_CAMERASPACE_Z
uniform mat4 view;varying vec4 vViewPos;
#endif
varying float vDepthMetric;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#include<clipPlaneVertex>
gl_Position=viewProjection*worldPos;
#ifdef STORE_CAMERASPACE_Z
vViewPos=view*worldPos;
#else
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric=((-gl_Position.z+depthValues.x)/(depthValues.y));
#else
vDepthMetric=((gl_Position.z+depthValues.x)/(depthValues.y));
#endif
#endif
#if defined(ALPHATEST) || defined(BASIC_RENDER)
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2f] = shader$2f;

    /**
     * This represents a depth renderer in Babylon.
     * A depth renderer will render to it's depth map every frame which can be displayed or used in post processing
     */
    class DepthRenderer {
        /**
         * Sets a specific material to be used to render a mesh/a list of meshes by the depth renderer
         * @param mesh mesh or array of meshes
         * @param material material to use by the depth render when rendering the mesh(es). If undefined is passed, the specific material created by the depth renderer will be used.
         */
        setMaterialForRendering(mesh, material) {
            this._depthMap.setMaterialForRendering(mesh, material);
        }
        /**
         * Instantiates a depth renderer
         * @param scene The scene the renderer belongs to
         * @param type The texture type of the depth map (default: Engine.TEXTURETYPE_FLOAT)
         * @param camera The camera to be used to render the depth map (default: scene's active camera)
         * @param storeNonLinearDepth Defines whether the depth is stored linearly like in Babylon Shadows or directly like glFragCoord.z
         * @param samplingMode The sampling mode to be used with the render target (Linear, Nearest...) (default: TRILINEAR_SAMPLINGMODE)
         * @param storeCameraSpaceZ Defines whether the depth stored is the Z coordinate in camera space. If true, storeNonLinearDepth has no effect. (Default: false)
         * @param name Name of the render target (default: DepthRenderer)
         */
        constructor(scene, type = 1, camera = null, storeNonLinearDepth = false, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, storeCameraSpaceZ = false, name) {
            /** Enable or disable the depth renderer. When disabled, the depth texture is not updated */
            this.enabled = true;
            /** Force writing the transparent objects into the depth map */
            this.forceDepthWriteTransparentMeshes = false;
            /**
             * Specifies that the depth renderer will only be used within
             * the camera it is created for.
             * This can help forcing its rendering during the camera processing.
             */
            this.useOnlyInActiveCamera = false;
            /** If true, reverse the culling of materials before writing to the depth texture.
             * So, basically, when "true", back facing instead of front facing faces are rasterized into the texture
             */
            this.reverseCulling = false;
            this._scene = scene;
            this._storeNonLinearDepth = storeNonLinearDepth;
            this._storeCameraSpaceZ = storeCameraSpaceZ;
            this.isPacked = type === 0;
            if (this.isPacked) {
                this.clearColor = new Color4(1.0, 1.0, 1.0, 1.0);
            }
            else {
                this.clearColor = new Color4(storeCameraSpaceZ ? 1e8 : 1.0, 0.0, 0.0, 1.0);
            }
            DepthRenderer._SceneComponentInitialization(this._scene);
            const engine = scene.getEngine();
            this._camera = camera;
            if (samplingMode !== Texture.NEAREST_SAMPLINGMODE) {
                if (type === 1 && !engine._caps.textureFloatLinearFiltering) {
                    samplingMode = Texture.NEAREST_SAMPLINGMODE;
                }
                if (type === 2 && !engine._caps.textureHalfFloatLinearFiltering) {
                    samplingMode = Texture.NEAREST_SAMPLINGMODE;
                }
            }
            // Render target
            const format = this.isPacked || !engine._features.supportExtendedTextureFormats ? 5 : 6;
            this._depthMap = new RenderTargetTexture(name !== null && name !== void 0 ? name : "DepthRenderer", { width: engine.getRenderWidth(), height: engine.getRenderHeight() }, this._scene, false, true, type, false, samplingMode, undefined, undefined, undefined, format);
            this._depthMap.wrapU = Texture.CLAMP_ADDRESSMODE;
            this._depthMap.wrapV = Texture.CLAMP_ADDRESSMODE;
            this._depthMap.refreshRate = 1;
            this._depthMap.renderParticles = false;
            this._depthMap.renderList = null;
            this._depthMap.noPrePassRenderer = true;
            // Camera to get depth map from to support multiple concurrent cameras
            this._depthMap.activeCamera = this._camera;
            this._depthMap.ignoreCameraViewport = true;
            this._depthMap.useCameraPostProcesses = false;
            // set default depth value to 1.0 (far away)
            this._depthMap.onClearObservable.add((engine) => {
                engine.clear(this.clearColor, true, true, true);
            });
            this._depthMap.onBeforeBindObservable.add(() => {
                var _a;
                (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, "depth renderer", 1);
            });
            this._depthMap.onAfterUnbindObservable.add(() => {
                var _a;
                (_a = engine._debugPopGroup) === null || _a === void 0 ? void 0 : _a.call(engine, 1);
            });
            this._depthMap.customIsReadyFunction = (mesh, refreshRate, preWarm) => {
                if ((preWarm || refreshRate === 0) && mesh.subMeshes) {
                    for (let i = 0; i < mesh.subMeshes.length; ++i) {
                        const subMesh = mesh.subMeshes[i];
                        const renderingMesh = subMesh.getRenderingMesh();
                        const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                        const hardwareInstancedRendering = engine.getCaps().instancedArrays &&
                            ((batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined) || renderingMesh.hasThinInstances);
                        if (!this.isReady(subMesh, hardwareInstancedRendering)) {
                            return false;
                        }
                    }
                }
                return true;
            };
            // Custom render function
            const renderSubMesh = (subMesh) => {
                var _a, _b;
                const renderingMesh = subMesh.getRenderingMesh();
                const effectiveMesh = subMesh.getEffectiveMesh();
                const scene = this._scene;
                const engine = scene.getEngine();
                const material = subMesh.getMaterial();
                effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
                if (!material || effectiveMesh.infiniteDistance || material.disableDepthWrite || subMesh.verticesCount === 0 || subMesh._renderId === scene.getRenderId()) {
                    return;
                }
                // Culling
                const detNeg = effectiveMesh._getWorldMatrixDeterminant() < 0;
                let sideOrientation = (_a = renderingMesh.overrideMaterialSideOrientation) !== null && _a !== void 0 ? _a : material.sideOrientation;
                if (detNeg) {
                    sideOrientation =
                        sideOrientation === 0
                            ? 1
                            : 0;
                }
                const reverseSideOrientation = sideOrientation === 0;
                engine.setState(material.backFaceCulling, 0, false, reverseSideOrientation, this.reverseCulling ? !material.cullBackFaces : material.cullBackFaces);
                // Managing instances
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                if (batch.mustReturn) {
                    return;
                }
                const hardwareInstancedRendering = engine.getCaps().instancedArrays &&
                    ((batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined) || renderingMesh.hasThinInstances);
                const camera = this._camera || scene.activeCamera;
                if (this.isReady(subMesh, hardwareInstancedRendering) && camera) {
                    subMesh._renderId = scene.getRenderId();
                    const renderingMaterial = (_b = effectiveMesh._internalAbstractMeshDataInfo._materialForRenderPass) === null || _b === void 0 ? void 0 : _b[engine.currentRenderPassId];
                    let drawWrapper = subMesh._getDrawWrapper();
                    if (!drawWrapper && renderingMaterial) {
                        drawWrapper = renderingMaterial._getDrawWrapper();
                    }
                    const cameraIsOrtho = camera.mode === Camera.ORTHOGRAPHIC_CAMERA;
                    if (!drawWrapper) {
                        return;
                    }
                    const effect = drawWrapper.effect;
                    engine.enableEffect(drawWrapper);
                    if (!hardwareInstancedRendering) {
                        renderingMesh._bind(subMesh, effect, material.fillMode);
                    }
                    if (!renderingMaterial) {
                        effect.setMatrix("viewProjection", scene.getTransformMatrix());
                        effect.setMatrix("world", effectiveMesh.getWorldMatrix());
                        if (this._storeCameraSpaceZ) {
                            effect.setMatrix("view", scene.getViewMatrix());
                        }
                    }
                    else {
                        renderingMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), effectiveMesh, subMesh);
                    }
                    let minZ, maxZ;
                    if (cameraIsOrtho) {
                        minZ = !engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
                        maxZ = engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
                    }
                    else {
                        minZ = engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? camera.minZ : engine.isNDCHalfZRange ? 0 : camera.minZ;
                        maxZ = engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : camera.maxZ;
                    }
                    effect.setFloat2("depthValues", minZ, minZ + maxZ);
                    if (!renderingMaterial) {
                        // Alpha test
                        if (material.needAlphaTesting()) {
                            const alphaTexture = material.getAlphaTestTexture();
                            if (alphaTexture) {
                                effect.setTexture("diffuseSampler", alphaTexture);
                                effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                            }
                        }
                        // Bones
                        if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                            const skeleton = renderingMesh.skeleton;
                            if (skeleton.isUsingTextureForMatrices) {
                                const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                                if (!boneTexture) {
                                    return;
                                }
                                effect.setTexture("boneSampler", boneTexture);
                                effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                            }
                            else {
                                effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
                            }
                        }
                        // Clip planes
                        bindClipPlane(effect, material, scene);
                        // Morph targets
                        MaterialHelper.BindMorphTargetParameters(renderingMesh, effect);
                        if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) {
                            renderingMesh.morphTargetManager._bind(effect);
                        }
                    }
                    // Draw
                    renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world) => effect.setMatrix("world", world));
                }
            };
            this._depthMap.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes) => {
                let index;
                if (depthOnlySubMeshes.length) {
                    for (index = 0; index < depthOnlySubMeshes.length; index++) {
                        renderSubMesh(depthOnlySubMeshes.data[index]);
                    }
                }
                for (index = 0; index < opaqueSubMeshes.length; index++) {
                    renderSubMesh(opaqueSubMeshes.data[index]);
                }
                for (index = 0; index < alphaTestSubMeshes.length; index++) {
                    renderSubMesh(alphaTestSubMeshes.data[index]);
                }
                if (this.forceDepthWriteTransparentMeshes) {
                    for (index = 0; index < transparentSubMeshes.length; index++) {
                        renderSubMesh(transparentSubMeshes.data[index]);
                    }
                }
                else {
                    for (index = 0; index < transparentSubMeshes.length; index++) {
                        transparentSubMeshes.data[index].getEffectiveMesh()._internalAbstractMeshDataInfo._isActiveIntermediate = false;
                    }
                }
            };
        }
        /**
         * Creates the depth rendering effect and checks if the effect is ready.
         * @param subMesh The submesh to be used to render the depth map of
         * @param useInstances If multiple world instances should be used
         * @returns if the depth renderer is ready to render the depth map
         */
        isReady(subMesh, useInstances) {
            var _a;
            const engine = this._scene.getEngine();
            const mesh = subMesh.getMesh();
            const scene = mesh.getScene();
            const renderingMaterial = (_a = mesh._internalAbstractMeshDataInfo._materialForRenderPass) === null || _a === void 0 ? void 0 : _a[engine.currentRenderPassId];
            if (renderingMaterial) {
                return renderingMaterial.isReadyForSubMesh(mesh, subMesh, useInstances);
            }
            const material = subMesh.getMaterial();
            if (!material || material.disableDepthWrite) {
                return false;
            }
            const defines = [];
            const attribs = [VertexBuffer.PositionKind];
            // Alpha test
            if (material && material.needAlphaTesting() && material.getAlphaTestTexture()) {
                defines.push("#define ALPHATEST");
                if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                    attribs.push(VertexBuffer.UVKind);
                    defines.push("#define UV1");
                }
                if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind)) {
                    attribs.push(VertexBuffer.UV2Kind);
                    defines.push("#define UV2");
                }
            }
            // Bones
            if (mesh.useBones && mesh.computeBonesUsingShaders) {
                attribs.push(VertexBuffer.MatricesIndicesKind);
                attribs.push(VertexBuffer.MatricesWeightsKind);
                if (mesh.numBoneInfluencers > 4) {
                    attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                    attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                }
                defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                defines.push("#define BonesPerMesh " + (mesh.skeleton ? mesh.skeleton.bones.length + 1 : 0));
                const skeleton = subMesh.getRenderingMesh().skeleton;
                if (skeleton === null || skeleton === void 0 ? void 0 : skeleton.isUsingTextureForMatrices) {
                    defines.push("#define BONETEXTURE");
                }
            }
            else {
                defines.push("#define NUM_BONE_INFLUENCERS 0");
            }
            // Morph targets
            const morphTargetManager = mesh.morphTargetManager;
            let numMorphInfluencers = 0;
            if (morphTargetManager) {
                if (morphTargetManager.numInfluencers > 0) {
                    numMorphInfluencers = morphTargetManager.numInfluencers;
                    defines.push("#define MORPHTARGETS");
                    defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
                    if (morphTargetManager.isUsingTextureForTargets) {
                        defines.push("#define MORPHTARGETS_TEXTURE");
                    }
                    MaterialHelper.PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, numMorphInfluencers);
                }
            }
            // Instances
            if (useInstances) {
                defines.push("#define INSTANCES");
                MaterialHelper.PushAttributesForInstances(attribs);
                if (subMesh.getRenderingMesh().hasThinInstances) {
                    defines.push("#define THIN_INSTANCES");
                }
            }
            // None linear depth
            if (this._storeNonLinearDepth) {
                defines.push("#define NONLINEARDEPTH");
            }
            // Store camera space Z coordinate instead of NDC Z
            if (this._storeCameraSpaceZ) {
                defines.push("#define STORE_CAMERASPACE_Z");
            }
            // Float Mode
            if (this.isPacked) {
                defines.push("#define PACKED");
            }
            // Clip planes
            prepareStringDefinesForClipPlanes(material, scene, defines);
            // Get correct effect
            const drawWrapper = subMesh._getDrawWrapper(undefined, true);
            const cachedDefines = drawWrapper.defines;
            const join = defines.join("\n");
            if (cachedDefines !== join) {
                const uniforms = [
                    "world",
                    "mBones",
                    "boneTextureWidth",
                    "viewProjection",
                    "view",
                    "diffuseMatrix",
                    "depthValues",
                    "morphTargetInfluences",
                    "morphTargetTextureInfo",
                    "morphTargetTextureIndices",
                ];
                addClipPlaneUniforms(uniforms);
                drawWrapper.setEffect(engine.createEffect("depth", attribs, uniforms, ["diffuseSampler", "morphTargets", "boneSampler"], join, undefined, undefined, undefined, {
                    maxSimultaneousMorphTargets: numMorphInfluencers,
                }), join);
            }
            return drawWrapper.effect.isReady();
        }
        /**
         * Gets the texture which the depth map will be written to.
         * @returns The depth map texture
         */
        getDepthMap() {
            return this._depthMap;
        }
        /**
         * Disposes of the depth renderer.
         */
        dispose() {
            const keysToDelete = [];
            for (const key in this._scene._depthRenderer) {
                const depthRenderer = this._scene._depthRenderer[key];
                if (depthRenderer === this) {
                    keysToDelete.push(key);
                }
            }
            if (keysToDelete.length > 0) {
                this._depthMap.dispose();
                for (const key of keysToDelete) {
                    delete this._scene._depthRenderer[key];
                }
            }
        }
    }
    /**
     * @internal
     */
    DepthRenderer._SceneComponentInitialization = (_) => {
        throw _WarnImport("DepthRendererSceneComponent");
    };

    // Do not edit.
    const name$2g = "minmaxReduxPixelShader";
    const shader$2g = `varying vec2 vUV;uniform sampler2D textureSampler;
#if defined(INITIAL)
uniform sampler2D sourceTexture;uniform vec2 texSize;void main(void)
{ivec2 coord=ivec2(vUV*(texSize-1.0));float f1=texelFetch(sourceTexture,coord,0).r;float f2=texelFetch(sourceTexture,coord+ivec2(1,0),0).r;float f3=texelFetch(sourceTexture,coord+ivec2(1,1),0).r;float f4=texelFetch(sourceTexture,coord+ivec2(0,1),0).r;float minz=min(min(min(f1,f2),f3),f4);
#ifdef DEPTH_REDUX
float maxz=max(max(max(sign(1.0-f1)*f1,sign(1.0-f2)*f2),sign(1.0-f3)*f3),sign(1.0-f4)*f4);
#else
float maxz=max(max(max(f1,f2),f3),f4);
#endif
glFragColor=vec4(minz,maxz,0.,0.);}
#elif defined(MAIN)
uniform vec2 texSize;void main(void)
{ivec2 coord=ivec2(vUV*(texSize-1.0));vec2 f1=texelFetch(textureSampler,coord,0).rg;vec2 f2=texelFetch(textureSampler,coord+ivec2(1,0),0).rg;vec2 f3=texelFetch(textureSampler,coord+ivec2(1,1),0).rg;vec2 f4=texelFetch(textureSampler,coord+ivec2(0,1),0).rg;float minz=min(min(min(f1.x,f2.x),f3.x),f4.x);float maxz=max(max(max(f1.y,f2.y),f3.y),f4.y);glFragColor=vec4(minz,maxz,0.,0.);}
#elif defined(ONEBEFORELAST)
uniform ivec2 texSize;void main(void)
{ivec2 coord=ivec2(vUV*vec2(texSize-1));vec2 f1=texelFetch(textureSampler,coord % texSize,0).rg;vec2 f2=texelFetch(textureSampler,(coord+ivec2(1,0)) % texSize,0).rg;vec2 f3=texelFetch(textureSampler,(coord+ivec2(1,1)) % texSize,0).rg;vec2 f4=texelFetch(textureSampler,(coord+ivec2(0,1)) % texSize,0).rg;float minz=min(f1.x,f2.x);float maxz=max(f1.y,f2.y);glFragColor=vec4(minz,maxz,0.,0.);}
#elif defined(LAST)
void main(void)
{glFragColor=vec4(0.);if (true) { 
discard;}}
#endif
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2g] = shader$2g;

    /**
     * This class computes a min/max reduction from a texture: it means it computes the minimum
     * and maximum values from all values of the texture.
     * It is performed on the GPU for better performances, thanks to a succession of post processes.
     * The source values are read from the red channel of the texture.
     */
    class MinMaxReducer {
        /**
         * Creates a min/max reducer
         * @param camera The camera to use for the post processes
         */
        constructor(camera) {
            /**
             * Observable triggered when the computation has been performed
             */
            this.onAfterReductionPerformed = new Observable$1();
            this._forceFullscreenViewport = true;
            this._activated = false;
            this._camera = camera;
            this._postProcessManager = new PostProcessManager(camera.getScene());
            this._onContextRestoredObserver = camera.getEngine().onContextRestoredObservable.add(() => {
                this._postProcessManager._rebuild();
            });
        }
        /**
         * Gets the texture used to read the values from.
         */
        get sourceTexture() {
            return this._sourceTexture;
        }
        /**
         * Sets the source texture to read the values from.
         * One must indicate if the texture is a depth texture or not through the depthRedux parameter
         * because in such textures '1' value must not be taken into account to compute the maximum
         * as this value is used to clear the texture.
         * Note that the computation is not activated by calling this function, you must call activate() for that!
         * @param sourceTexture The texture to read the values from. The values should be in the red channel.
         * @param depthRedux Indicates if the texture is a depth texture or not
         * @param type The type of the textures created for the reduction (defaults to TEXTURETYPE_HALF_FLOAT)
         * @param forceFullscreenViewport Forces the post processes used for the reduction to be applied without taking into account viewport (defaults to true)
         */
        setSourceTexture(sourceTexture, depthRedux, type = 2, forceFullscreenViewport = true) {
            if (sourceTexture === this._sourceTexture) {
                return;
            }
            this.dispose(false);
            this._sourceTexture = sourceTexture;
            this._reductionSteps = [];
            this._forceFullscreenViewport = forceFullscreenViewport;
            const scene = this._camera.getScene();
            // create the first step
            const reductionInitial = new PostProcess("Initial reduction phase", "minmaxRedux", // shader
            ["texSize"], ["sourceTexture"], // textures
            1.0, // options
            null, // camera
            1, // sampling
            scene.getEngine(), // engine
            false, // reusable
            "#define INITIAL" + (depthRedux ? "\n#define DEPTH_REDUX" : ""), // defines
            type, undefined, undefined, undefined, 7);
            reductionInitial.autoClear = false;
            reductionInitial.forceFullscreenViewport = forceFullscreenViewport;
            let w = this._sourceTexture.getRenderWidth(), h = this._sourceTexture.getRenderHeight();
            reductionInitial.onApply = ((w, h) => {
                return (effect) => {
                    effect.setTexture("sourceTexture", this._sourceTexture);
                    effect.setFloat2("texSize", w, h);
                };
            })(w, h);
            this._reductionSteps.push(reductionInitial);
            let index = 1;
            // create the additional steps
            while (w > 1 || h > 1) {
                w = Math.max(Math.round(w / 2), 1);
                h = Math.max(Math.round(h / 2), 1);
                const reduction = new PostProcess("Reduction phase " + index, "minmaxRedux", // shader
                ["texSize"], null, { width: w, height: h }, // options
                null, // camera
                1, // sampling
                scene.getEngine(), // engine
                false, // reusable
                "#define " + (w == 1 && h == 1 ? "LAST" : w == 1 || h == 1 ? "ONEBEFORELAST" : "MAIN"), // defines
                type, undefined, undefined, undefined, 7);
                reduction.autoClear = false;
                reduction.forceFullscreenViewport = forceFullscreenViewport;
                reduction.onApply = ((w, h) => {
                    return (effect) => {
                        if (w == 1 || h == 1) {
                            effect.setInt2("texSize", w, h);
                        }
                        else {
                            effect.setFloat2("texSize", w, h);
                        }
                    };
                })(w, h);
                this._reductionSteps.push(reduction);
                index++;
                if (w == 1 && h == 1) {
                    const func = (w, h, reduction) => {
                        const buffer = new Float32Array(4 * w * h), minmax = { min: 0, max: 0 };
                        return () => {
                            scene.getEngine()._readTexturePixels(reduction.inputTexture.texture, w, h, -1, 0, buffer, false);
                            minmax.min = buffer[0];
                            minmax.max = buffer[1];
                            this.onAfterReductionPerformed.notifyObservers(minmax);
                        };
                    };
                    reduction.onAfterRenderObservable.add(func(w, h, reduction));
                }
            }
        }
        /**
         * Defines the refresh rate of the computation.
         * Use 0 to compute just once, 1 to compute on every frame, 2 to compute every two frames and so on...
         */
        get refreshRate() {
            return this._sourceTexture ? this._sourceTexture.refreshRate : -1;
        }
        set refreshRate(value) {
            if (this._sourceTexture) {
                this._sourceTexture.refreshRate = value;
            }
        }
        /**
         * Gets the activation status of the reducer
         */
        get activated() {
            return this._activated;
        }
        /**
         * Activates the reduction computation.
         * When activated, the observers registered in onAfterReductionPerformed are
         * called after the computation is performed
         */
        activate() {
            if (this._onAfterUnbindObserver || !this._sourceTexture) {
                return;
            }
            this._onAfterUnbindObserver = this._sourceTexture.onAfterUnbindObservable.add(() => {
                var _a, _b;
                const engine = this._camera.getScene().getEngine();
                (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, `min max reduction`, 1);
                this._reductionSteps[0].activate(this._camera);
                this._postProcessManager.directRender(this._reductionSteps, this._reductionSteps[0].inputTexture, this._forceFullscreenViewport);
                engine.unBindFramebuffer(this._reductionSteps[0].inputTexture, false);
                (_b = engine._debugPopGroup) === null || _b === void 0 ? void 0 : _b.call(engine, 1);
            });
            this._activated = true;
        }
        /**
         * Deactivates the reduction computation.
         */
        deactivate() {
            if (!this._onAfterUnbindObserver || !this._sourceTexture) {
                return;
            }
            this._sourceTexture.onAfterUnbindObservable.remove(this._onAfterUnbindObserver);
            this._onAfterUnbindObserver = null;
            this._activated = false;
        }
        /**
         * Disposes the min/max reducer
         * @param disposeAll true to dispose all the resources. You should always call this function with true as the parameter (or without any parameter as it is the default one). This flag is meant to be used internally.
         */
        dispose(disposeAll = true) {
            if (disposeAll) {
                this.onAfterReductionPerformed.clear();
                if (this._onContextRestoredObserver) {
                    this._camera.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
                    this._onContextRestoredObserver = null;
                }
            }
            this.deactivate();
            if (this._reductionSteps) {
                for (let i = 0; i < this._reductionSteps.length; ++i) {
                    this._reductionSteps[i].dispose();
                }
                this._reductionSteps = null;
            }
            if (this._postProcessManager && disposeAll) {
                this._postProcessManager.dispose();
            }
            this._sourceTexture = null;
        }
    }

    /**
     * This class is a small wrapper around the MinMaxReducer class to compute the min/max values of a depth texture
     */
    class DepthReducer extends MinMaxReducer {
        /**
         * Gets the depth renderer used for the computation.
         * Note that the result is null if you provide your own renderer when calling setDepthRenderer.
         */
        get depthRenderer() {
            return this._depthRenderer;
        }
        /**
         * Creates a depth reducer
         * @param camera The camera used to render the depth texture
         */
        constructor(camera) {
            super(camera);
        }
        /**
         * Sets the depth renderer to use to generate the depth map
         * @param depthRenderer The depth renderer to use. If not provided, a new one will be created automatically
         * @param type The texture type of the depth map (default: TEXTURETYPE_HALF_FLOAT)
         * @param forceFullscreenViewport Forces the post processes used for the reduction to be applied without taking into account viewport (defaults to true)
         */
        setDepthRenderer(depthRenderer = null, type = 2, forceFullscreenViewport = true) {
            const scene = this._camera.getScene();
            if (this._depthRenderer) {
                delete scene._depthRenderer[this._depthRendererId];
                this._depthRenderer.dispose();
                this._depthRenderer = null;
            }
            if (depthRenderer === null) {
                if (!scene._depthRenderer) {
                    scene._depthRenderer = {};
                }
                depthRenderer = this._depthRenderer = new DepthRenderer(scene, type, this._camera, false, 1);
                depthRenderer.enabled = false;
                this._depthRendererId = "minmax" + this._camera.id;
                scene._depthRenderer[this._depthRendererId] = depthRenderer;
            }
            super.setSourceTexture(depthRenderer.getDepthMap(), true, type, forceFullscreenViewport);
        }
        /**
         * @internal
         */
        setSourceTexture(sourceTexture, depthRedux, type = 2, forceFullscreenViewport = true) {
            super.setSourceTexture(sourceTexture, depthRedux, type, forceFullscreenViewport);
        }
        /**
         * Activates the reduction computation.
         * When activated, the observers registered in onAfterReductionPerformed are
         * called after the computation is performed
         */
        activate() {
            if (this._depthRenderer) {
                this._depthRenderer.enabled = true;
            }
            super.activate();
        }
        /**
         * Deactivates the reduction computation.
         */
        deactivate() {
            super.deactivate();
            if (this._depthRenderer) {
                this._depthRenderer.enabled = false;
            }
        }
        /**
         * Disposes the depth reducer
         * @param disposeAll true to dispose all the resources. You should always call this function with true as the parameter (or without any parameter as it is the default one). This flag is meant to be used internally.
         */
        dispose(disposeAll = true) {
            super.dispose(disposeAll);
            if (this._depthRenderer && disposeAll) {
                const scene = this._depthRenderer.getDepthMap().getScene();
                if (scene) {
                    delete scene._depthRenderer[this._depthRendererId];
                }
                this._depthRenderer.dispose();
                this._depthRenderer = null;
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const UpDir = Vector3.Up();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const ZeroVec = Vector3.Zero();
    const tmpv1 = new Vector3(), tmpv2 = new Vector3(), tmpMatrix = new Matrix();
    /**
     * A CSM implementation allowing casting shadows on large scenes.
     * Documentation : https://doc.babylonjs.com/babylon101/cascadedShadows
     * Based on: https://github.com/TheRealMJP/Shadows and https://johanmedestrom.wordpress.com/2016/03/18/opengl-cascaded-shadow-maps/
     */
    class CascadedShadowGenerator extends ShadowGenerator {
        _validateFilter(filter) {
            if (filter === ShadowGenerator.FILTER_NONE || filter === ShadowGenerator.FILTER_PCF || filter === ShadowGenerator.FILTER_PCSS) {
                return filter;
            }
            console.error('Unsupported filter "' + filter + '"!');
            return ShadowGenerator.FILTER_NONE;
        }
        /**
         * Gets or set the number of cascades used by the CSM.
         */
        get numCascades() {
            return this._numCascades;
        }
        set numCascades(value) {
            value = Math.min(Math.max(value, CascadedShadowGenerator.MIN_CASCADES_COUNT), CascadedShadowGenerator.MAX_CASCADES_COUNT);
            if (value === this._numCascades) {
                return;
            }
            this._numCascades = value;
            this.recreateShadowMap();
            this._recreateSceneUBOs();
        }
        /**
         * Enables or disables the shadow casters bounding info computation.
         * If your shadow casters don't move, you can disable this feature.
         * If it is enabled, the bounding box computation is done every frame.
         */
        get freezeShadowCastersBoundingInfo() {
            return this._freezeShadowCastersBoundingInfo;
        }
        set freezeShadowCastersBoundingInfo(freeze) {
            if (this._freezeShadowCastersBoundingInfoObservable && freeze) {
                this._scene.onBeforeRenderObservable.remove(this._freezeShadowCastersBoundingInfoObservable);
                this._freezeShadowCastersBoundingInfoObservable = null;
            }
            if (!this._freezeShadowCastersBoundingInfoObservable && !freeze) {
                this._freezeShadowCastersBoundingInfoObservable = this._scene.onBeforeRenderObservable.add(this._computeShadowCastersBoundingInfo.bind(this));
            }
            this._freezeShadowCastersBoundingInfo = freeze;
            if (freeze) {
                this._computeShadowCastersBoundingInfo();
            }
        }
        _computeShadowCastersBoundingInfo() {
            this._scbiMin.copyFromFloats(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._scbiMax.copyFromFloats(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
            if (this._shadowMap && this._shadowMap.renderList) {
                const renderList = this._shadowMap.renderList;
                for (let meshIndex = 0; meshIndex < renderList.length; meshIndex++) {
                    const mesh = renderList[meshIndex];
                    if (!mesh) {
                        continue;
                    }
                    const boundingInfo = mesh.getBoundingInfo(), boundingBox = boundingInfo.boundingBox;
                    this._scbiMin.minimizeInPlace(boundingBox.minimumWorld);
                    this._scbiMax.maximizeInPlace(boundingBox.maximumWorld);
                }
                const meshes = this._scene.meshes;
                for (let meshIndex = 0; meshIndex < meshes.length; meshIndex++) {
                    const mesh = meshes[meshIndex];
                    if (!mesh || !mesh.isVisible || !mesh.isEnabled || !mesh.receiveShadows) {
                        continue;
                    }
                    const boundingInfo = mesh.getBoundingInfo(), boundingBox = boundingInfo.boundingBox;
                    this._scbiMin.minimizeInPlace(boundingBox.minimumWorld);
                    this._scbiMax.maximizeInPlace(boundingBox.maximumWorld);
                }
            }
            this._shadowCastersBoundingInfo.reConstruct(this._scbiMin, this._scbiMax);
        }
        /**
         * Gets or sets the shadow casters bounding info.
         * If you provide your own shadow casters bounding info, first enable freezeShadowCastersBoundingInfo
         * so that the system won't overwrite the bounds you provide
         */
        get shadowCastersBoundingInfo() {
            return this._shadowCastersBoundingInfo;
        }
        set shadowCastersBoundingInfo(boundingInfo) {
            this._shadowCastersBoundingInfo = boundingInfo;
        }
        /**
         * Sets the minimal and maximal distances to use when computing the cascade breaks.
         *
         * The values of min / max are typically the depth zmin and zmax values of your scene, for a given frame.
         * If you don't know these values, simply leave them to their defaults and don't call this function.
         * @param min minimal distance for the breaks (default to 0.)
         * @param max maximal distance for the breaks (default to 1.)
         */
        setMinMaxDistance(min, max) {
            if (this._minDistance === min && this._maxDistance === max) {
                return;
            }
            if (min > max) {
                min = 0;
                max = 1;
            }
            if (min < 0) {
                min = 0;
            }
            if (max > 1) {
                max = 1;
            }
            this._minDistance = min;
            this._maxDistance = max;
            this._breaksAreDirty = true;
        }
        /** Gets the minimal distance used in the cascade break computation */
        get minDistance() {
            return this._minDistance;
        }
        /** Gets the maximal distance used in the cascade break computation */
        get maxDistance() {
            return this._maxDistance;
        }
        /**
         * Gets the class name of that object
         * @returns "CascadedShadowGenerator"
         */
        getClassName() {
            return CascadedShadowGenerator.CLASSNAME;
        }
        /**
         * Gets a cascade minimum extents
         * @param cascadeIndex index of the cascade
         * @returns the minimum cascade extents
         */
        getCascadeMinExtents(cascadeIndex) {
            return cascadeIndex >= 0 && cascadeIndex < this._numCascades ? this._cascadeMinExtents[cascadeIndex] : null;
        }
        /**
         * Gets a cascade maximum extents
         * @param cascadeIndex index of the cascade
         * @returns the maximum cascade extents
         */
        getCascadeMaxExtents(cascadeIndex) {
            return cascadeIndex >= 0 && cascadeIndex < this._numCascades ? this._cascadeMaxExtents[cascadeIndex] : null;
        }
        /**
         * Gets the shadow max z distance. It's the limit beyond which shadows are not displayed.
         * It defaults to camera.maxZ
         */
        get shadowMaxZ() {
            if (!this._getCamera()) {
                return 0;
            }
            return this._shadowMaxZ;
        }
        /**
         * Sets the shadow max z distance.
         */
        set shadowMaxZ(value) {
            const camera = this._getCamera();
            if (!camera) {
                this._shadowMaxZ = value;
                return;
            }
            if (this._shadowMaxZ === value || value < camera.minZ || value > camera.maxZ) {
                return;
            }
            this._shadowMaxZ = value;
            this._light._markMeshesAsLightDirty();
            this._breaksAreDirty = true;
        }
        /**
         * Gets or sets the debug flag.
         * When enabled, the cascades are materialized by different colors on the screen.
         */
        get debug() {
            return this._debug;
        }
        set debug(dbg) {
            this._debug = dbg;
            this._light._markMeshesAsLightDirty();
        }
        /**
         * Gets or sets the depth clamping value.
         *
         * When enabled, it improves the shadow quality because the near z plane of the light frustum don't need to be adjusted
         * to account for the shadow casters far away.
         *
         * Note that this property is incompatible with PCSS filtering, so it won't be used in that case.
         */
        get depthClamp() {
            return this._depthClamp;
        }
        set depthClamp(value) {
            this._depthClamp = value;
        }
        /**
         * Gets or sets the percentage of blending between two cascades (value between 0. and 1.).
         * It defaults to 0.1 (10% blending).
         */
        get cascadeBlendPercentage() {
            return this._cascadeBlendPercentage;
        }
        set cascadeBlendPercentage(value) {
            this._cascadeBlendPercentage = value;
            this._light._markMeshesAsLightDirty();
        }
        /**
         * Gets or set the lambda parameter.
         * This parameter is used to split the camera frustum and create the cascades.
         * It's a value between 0. and 1.: If 0, the split is a uniform split of the frustum, if 1 it is a logarithmic split.
         * For all values in-between, it's a linear combination of the uniform and logarithm split algorithm.
         */
        get lambda() {
            return this._lambda;
        }
        set lambda(value) {
            const lambda = Math.min(Math.max(value, 0), 1);
            if (this._lambda == lambda) {
                return;
            }
            this._lambda = lambda;
            this._breaksAreDirty = true;
        }
        /**
         * Gets the view matrix corresponding to a given cascade
         * @param cascadeNum cascade to retrieve the view matrix from
         * @returns the cascade view matrix
         */
        getCascadeViewMatrix(cascadeNum) {
            return cascadeNum >= 0 && cascadeNum < this._numCascades ? this._viewMatrices[cascadeNum] : null;
        }
        /**
         * Gets the projection matrix corresponding to a given cascade
         * @param cascadeNum cascade to retrieve the projection matrix from
         * @returns the cascade projection matrix
         */
        getCascadeProjectionMatrix(cascadeNum) {
            return cascadeNum >= 0 && cascadeNum < this._numCascades ? this._projectionMatrices[cascadeNum] : null;
        }
        /**
         * Gets the transformation matrix corresponding to a given cascade
         * @param cascadeNum cascade to retrieve the transformation matrix from
         * @returns the cascade transformation matrix
         */
        getCascadeTransformMatrix(cascadeNum) {
            return cascadeNum >= 0 && cascadeNum < this._numCascades ? this._transformMatrices[cascadeNum] : null;
        }
        /**
         * Sets the depth renderer to use when autoCalcDepthBounds is enabled.
         *
         * Note that if no depth renderer is set, a new one will be automatically created internally when necessary.
         *
         * You should call this function if you already have a depth renderer enabled in your scene, to avoid
         * doing multiple depth rendering each frame. If you provide your own depth renderer, make sure it stores linear depth!
         * @param depthRenderer The depth renderer to use when autoCalcDepthBounds is enabled. If you pass null or don't call this function at all, a depth renderer will be automatically created
         */
        setDepthRenderer(depthRenderer) {
            this._depthRenderer = depthRenderer;
            if (this._depthReducer) {
                this._depthReducer.setDepthRenderer(this._depthRenderer);
            }
        }
        /**
         * Gets or sets the autoCalcDepthBounds property.
         *
         * When enabled, a depth rendering pass is first performed (with an internally created depth renderer or with the one
         * you provide by calling setDepthRenderer). Then, a min/max reducing is applied on the depth map to compute the
         * minimal and maximal depth of the map and those values are used as inputs for the setMinMaxDistance() function.
         * It can greatly enhance the shadow quality, at the expense of more GPU works.
         * When using this option, you should increase the value of the lambda parameter, and even set it to 1 for best results.
         */
        get autoCalcDepthBounds() {
            return this._autoCalcDepthBounds;
        }
        set autoCalcDepthBounds(value) {
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            this._autoCalcDepthBounds = value;
            if (!value) {
                if (this._depthReducer) {
                    this._depthReducer.deactivate();
                }
                this.setMinMaxDistance(0, 1);
                return;
            }
            if (!this._depthReducer) {
                this._depthReducer = new DepthReducer(camera);
                this._depthReducer.onAfterReductionPerformed.add((minmax) => {
                    let min = minmax.min, max = minmax.max;
                    if (min >= max) {
                        min = 0;
                        max = 1;
                    }
                    if (min != this._minDistance || max != this._maxDistance) {
                        this.setMinMaxDistance(min, max);
                    }
                });
                this._depthReducer.setDepthRenderer(this._depthRenderer);
            }
            this._depthReducer.activate();
        }
        /**
         * Defines the refresh rate of the min/max computation used when autoCalcDepthBounds is set to true
         * Use 0 to compute just once, 1 to compute on every frame, 2 to compute every two frames and so on...
         * Note that if you provided your own depth renderer through a call to setDepthRenderer, you are responsible
         * for setting the refresh rate on the renderer yourself!
         */
        get autoCalcDepthBoundsRefreshRate() {
            var _a, _b, _c;
            return (_c = (_b = (_a = this._depthReducer) === null || _a === void 0 ? void 0 : _a.depthRenderer) === null || _b === void 0 ? void 0 : _b.getDepthMap().refreshRate) !== null && _c !== void 0 ? _c : -1;
        }
        set autoCalcDepthBoundsRefreshRate(value) {
            var _a;
            if ((_a = this._depthReducer) === null || _a === void 0 ? void 0 : _a.depthRenderer) {
                this._depthReducer.depthRenderer.getDepthMap().refreshRate = value;
            }
        }
        /**
         * Create the cascade breaks according to the lambda, shadowMaxZ and min/max distance properties, as well as the camera near and far planes.
         * This function is automatically called when updating lambda, shadowMaxZ and min/max distances, however you should call it yourself if
         * you change the camera near/far planes!
         */
        splitFrustum() {
            this._breaksAreDirty = true;
        }
        _splitFrustum() {
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            const near = camera.minZ, far = camera.maxZ || this._shadowMaxZ, // account for infinite far plane (ie. maxZ = 0)
            cameraRange = far - near, minDistance = this._minDistance, maxDistance = this._shadowMaxZ < far && this._shadowMaxZ >= near ? Math.min((this._shadowMaxZ - near) / (far - near), this._maxDistance) : this._maxDistance;
            const minZ = near + minDistance * cameraRange, maxZ = near + maxDistance * cameraRange;
            const range = maxZ - minZ, ratio = maxZ / minZ;
            for (let cascadeIndex = 0; cascadeIndex < this._cascades.length; ++cascadeIndex) {
                const p = (cascadeIndex + 1) / this._numCascades, log = minZ * ratio ** p, uniform = minZ + range * p;
                const d = this._lambda * (log - uniform) + uniform;
                this._cascades[cascadeIndex].prevBreakDistance = cascadeIndex === 0 ? minDistance : this._cascades[cascadeIndex - 1].breakDistance;
                this._cascades[cascadeIndex].breakDistance = (d - near) / cameraRange;
                this._viewSpaceFrustumsZ[cascadeIndex] = d;
                this._frustumLengths[cascadeIndex] = (this._cascades[cascadeIndex].breakDistance - this._cascades[cascadeIndex].prevBreakDistance) * cameraRange;
            }
            this._breaksAreDirty = false;
        }
        _computeMatrices() {
            const scene = this._scene;
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            Vector3.NormalizeToRef(this._light.getShadowDirection(0), this._lightDirection);
            if (Math.abs(Vector3.Dot(this._lightDirection, Vector3.Up())) === 1.0) {
                this._lightDirection.z = 0.0000000000001; // Required to avoid perfectly perpendicular light
            }
            this._cachedDirection.copyFrom(this._lightDirection);
            const useReverseDepthBuffer = scene.getEngine().useReverseDepthBuffer;
            for (let cascadeIndex = 0; cascadeIndex < this._numCascades; ++cascadeIndex) {
                this._computeFrustumInWorldSpace(cascadeIndex);
                this._computeCascadeFrustum(cascadeIndex);
                this._cascadeMaxExtents[cascadeIndex].subtractToRef(this._cascadeMinExtents[cascadeIndex], tmpv1); // tmpv1 = cascadeExtents
                // Get position of the shadow camera
                this._frustumCenter[cascadeIndex].addToRef(this._lightDirection.scale(this._cascadeMinExtents[cascadeIndex].z), this._shadowCameraPos[cascadeIndex]);
                // Come up with a new orthographic camera for the shadow caster
                Matrix.LookAtLHToRef(this._shadowCameraPos[cascadeIndex], this._frustumCenter[cascadeIndex], UpDir, this._viewMatrices[cascadeIndex]);
                let minZ = 0, maxZ = tmpv1.z;
                // Try to tighten minZ and maxZ based on the bounding box of the shadow casters
                const boundingInfo = this._shadowCastersBoundingInfo;
                boundingInfo.update(this._viewMatrices[cascadeIndex]);
                maxZ = Math.min(maxZ, boundingInfo.boundingBox.maximumWorld.z);
                if (!this._depthClamp || this.filter === ShadowGenerator.FILTER_PCSS) {
                    // If we don't use depth clamping, we must set minZ so that all shadow casters are in the light frustum
                    minZ = Math.min(minZ, boundingInfo.boundingBox.minimumWorld.z);
                }
                else {
                    // If using depth clamping, we can adjust minZ to reduce the [minZ, maxZ] range (and get some additional precision in the shadow map)
                    minZ = Math.max(minZ, boundingInfo.boundingBox.minimumWorld.z);
                }
                Matrix.OrthoOffCenterLHToRef(this._cascadeMinExtents[cascadeIndex].x, this._cascadeMaxExtents[cascadeIndex].x, this._cascadeMinExtents[cascadeIndex].y, this._cascadeMaxExtents[cascadeIndex].y, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, this._projectionMatrices[cascadeIndex], scene.getEngine().isNDCHalfZRange);
                this._cascadeMinExtents[cascadeIndex].z = minZ;
                this._cascadeMaxExtents[cascadeIndex].z = maxZ;
                this._viewMatrices[cascadeIndex].multiplyToRef(this._projectionMatrices[cascadeIndex], this._transformMatrices[cascadeIndex]);
                // Create the rounding matrix, by projecting the world-space origin and determining
                // the fractional offset in texel space
                Vector3.TransformCoordinatesToRef(ZeroVec, this._transformMatrices[cascadeIndex], tmpv1); // tmpv1 = shadowOrigin
                tmpv1.scaleInPlace(this._mapSize / 2);
                tmpv2.copyFromFloats(Math.round(tmpv1.x), Math.round(tmpv1.y), Math.round(tmpv1.z)); // tmpv2 = roundedOrigin
                tmpv2.subtractInPlace(tmpv1).scaleInPlace(2 / this._mapSize); // tmpv2 = roundOffset
                Matrix.TranslationToRef(tmpv2.x, tmpv2.y, 0.0, tmpMatrix);
                this._projectionMatrices[cascadeIndex].multiplyToRef(tmpMatrix, this._projectionMatrices[cascadeIndex]);
                this._viewMatrices[cascadeIndex].multiplyToRef(this._projectionMatrices[cascadeIndex], this._transformMatrices[cascadeIndex]);
                this._transformMatrices[cascadeIndex].copyToArray(this._transformMatricesAsArray, cascadeIndex * 16);
            }
        }
        // Get the 8 points of the view frustum in world space
        _computeFrustumInWorldSpace(cascadeIndex) {
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            const prevSplitDist = this._cascades[cascadeIndex].prevBreakDistance, splitDist = this._cascades[cascadeIndex].breakDistance;
            const isNDCHalfZRange = this._scene.getEngine().isNDCHalfZRange;
            camera.getViewMatrix(); // make sure the transformation matrix we get when calling 'getTransformationMatrix()' is calculated with an up to date view matrix
            const cameraInfiniteFarPlane = camera.maxZ === 0;
            const saveCameraMaxZ = camera.maxZ;
            if (cameraInfiniteFarPlane) {
                camera.maxZ = this._shadowMaxZ;
                camera.getProjectionMatrix(true);
            }
            const invViewProj = Matrix.Invert(camera.getTransformationMatrix());
            if (cameraInfiniteFarPlane) {
                camera.maxZ = saveCameraMaxZ;
                camera.getProjectionMatrix(true);
            }
            const cornerIndexOffset = this._scene.getEngine().useReverseDepthBuffer ? 4 : 0;
            for (let cornerIndex = 0; cornerIndex < CascadedShadowGenerator._FrustumCornersNDCSpace.length; ++cornerIndex) {
                tmpv1.copyFrom(CascadedShadowGenerator._FrustumCornersNDCSpace[(cornerIndex + cornerIndexOffset) % CascadedShadowGenerator._FrustumCornersNDCSpace.length]);
                if (isNDCHalfZRange && tmpv1.z === -1) {
                    tmpv1.z = 0;
                }
                Vector3.TransformCoordinatesToRef(tmpv1, invViewProj, this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
            }
            // Get the corners of the current cascade slice of the view frustum
            for (let cornerIndex = 0; cornerIndex < CascadedShadowGenerator._FrustumCornersNDCSpace.length / 2; ++cornerIndex) {
                tmpv1.copyFrom(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex + 4]).subtractInPlace(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
                tmpv2.copyFrom(tmpv1).scaleInPlace(prevSplitDist); // near corner ray
                tmpv1.scaleInPlace(splitDist); // far corner ray
                tmpv1.addInPlace(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
                this._frustumCornersWorldSpace[cascadeIndex][cornerIndex + 4].copyFrom(tmpv1);
                this._frustumCornersWorldSpace[cascadeIndex][cornerIndex].addInPlace(tmpv2);
            }
        }
        _computeCascadeFrustum(cascadeIndex) {
            this._cascadeMinExtents[cascadeIndex].copyFromFloats(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            this._cascadeMaxExtents[cascadeIndex].copyFromFloats(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
            this._frustumCenter[cascadeIndex].copyFromFloats(0, 0, 0);
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            // Calculate the centroid of the view frustum slice
            for (let cornerIndex = 0; cornerIndex < this._frustumCornersWorldSpace[cascadeIndex].length; ++cornerIndex) {
                this._frustumCenter[cascadeIndex].addInPlace(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
            }
            this._frustumCenter[cascadeIndex].scaleInPlace(1 / this._frustumCornersWorldSpace[cascadeIndex].length);
            if (this.stabilizeCascades) {
                // Calculate the radius of a bounding sphere surrounding the frustum corners
                let sphereRadius = 0;
                for (let cornerIndex = 0; cornerIndex < this._frustumCornersWorldSpace[cascadeIndex].length; ++cornerIndex) {
                    const dist = this._frustumCornersWorldSpace[cascadeIndex][cornerIndex].subtractToRef(this._frustumCenter[cascadeIndex], tmpv1).length();
                    sphereRadius = Math.max(sphereRadius, dist);
                }
                sphereRadius = Math.ceil(sphereRadius * 16) / 16;
                this._cascadeMaxExtents[cascadeIndex].copyFromFloats(sphereRadius, sphereRadius, sphereRadius);
                this._cascadeMinExtents[cascadeIndex].copyFromFloats(-sphereRadius, -sphereRadius, -sphereRadius);
            }
            else {
                // Create a temporary view matrix for the light
                const lightCameraPos = this._frustumCenter[cascadeIndex];
                this._frustumCenter[cascadeIndex].addToRef(this._lightDirection, tmpv1); // tmpv1 = look at
                Matrix.LookAtLHToRef(lightCameraPos, tmpv1, UpDir, tmpMatrix); // matrix = lightView
                // Calculate an AABB around the frustum corners
                for (let cornerIndex = 0; cornerIndex < this._frustumCornersWorldSpace[cascadeIndex].length; ++cornerIndex) {
                    Vector3.TransformCoordinatesToRef(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex], tmpMatrix, tmpv1);
                    this._cascadeMinExtents[cascadeIndex].minimizeInPlace(tmpv1);
                    this._cascadeMaxExtents[cascadeIndex].maximizeInPlace(tmpv1);
                }
            }
        }
        _recreateSceneUBOs() {
            this._disposeSceneUBOs();
            if (this._sceneUBOs) {
                for (let i = 0; i < this._numCascades; ++i) {
                    this._sceneUBOs.push(this._scene.createSceneUniformBuffer(`Scene for CSM Shadow Generator (light "${this._light.name}" cascade #${i})`));
                }
            }
        }
        /**
         *  Support test.
         */
        static get IsSupported() {
            const engine = EngineStore.LastCreatedEngine;
            if (!engine) {
                return false;
            }
            return engine._features.supportCSM;
        }
        /**
         * Creates a Cascaded Shadow Generator object.
         * A ShadowGenerator is the required tool to use the shadows.
         * Each directional light casting shadows needs to use its own ShadowGenerator.
         * Documentation : https://doc.babylonjs.com/babylon101/cascadedShadows
         * @param mapSize The size of the texture what stores the shadows. Example : 1024.
         * @param light The directional light object generating the shadows.
         * @param usefulFloatFirst By default the generator will try to use half float textures but if you need precision (for self shadowing for instance), you can use this option to enforce full float texture.
         * @param camera Camera associated with this shadow generator (default: null). If null, takes the scene active camera at the time we need to access it
         * @param useRedTextureType Forces the generator to use a Red instead of a RGBA type for the shadow map texture format (default: true)
         */
        constructor(mapSize, light, usefulFloatFirst, camera, useRedTextureType = true) {
            if (!CascadedShadowGenerator.IsSupported) {
                Logger.Error("CascadedShadowMap is not supported by the current engine.");
                return;
            }
            super(mapSize, light, usefulFloatFirst, camera, useRedTextureType);
            this.usePercentageCloserFiltering = true;
        }
        _initializeGenerator() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            this.penumbraDarkness = (_a = this.penumbraDarkness) !== null && _a !== void 0 ? _a : 1.0;
            this._numCascades = (_b = this._numCascades) !== null && _b !== void 0 ? _b : CascadedShadowGenerator.DEFAULT_CASCADES_COUNT;
            this.stabilizeCascades = (_c = this.stabilizeCascades) !== null && _c !== void 0 ? _c : false;
            this._freezeShadowCastersBoundingInfoObservable = (_d = this._freezeShadowCastersBoundingInfoObservable) !== null && _d !== void 0 ? _d : null;
            this.freezeShadowCastersBoundingInfo = (_e = this.freezeShadowCastersBoundingInfo) !== null && _e !== void 0 ? _e : false;
            this._scbiMin = (_f = this._scbiMin) !== null && _f !== void 0 ? _f : new Vector3(0, 0, 0);
            this._scbiMax = (_g = this._scbiMax) !== null && _g !== void 0 ? _g : new Vector3(0, 0, 0);
            this._shadowCastersBoundingInfo = (_h = this._shadowCastersBoundingInfo) !== null && _h !== void 0 ? _h : new BoundingInfo(new Vector3(0, 0, 0), new Vector3(0, 0, 0));
            this._breaksAreDirty = (_j = this._breaksAreDirty) !== null && _j !== void 0 ? _j : true;
            this._minDistance = (_k = this._minDistance) !== null && _k !== void 0 ? _k : 0;
            this._maxDistance = (_l = this._maxDistance) !== null && _l !== void 0 ? _l : 1;
            this._currentLayer = (_m = this._currentLayer) !== null && _m !== void 0 ? _m : 0;
            this._shadowMaxZ = (_q = (_o = this._shadowMaxZ) !== null && _o !== void 0 ? _o : (_p = this._getCamera()) === null || _p === void 0 ? void 0 : _p.maxZ) !== null && _q !== void 0 ? _q : 10000;
            this._debug = (_r = this._debug) !== null && _r !== void 0 ? _r : false;
            this._depthClamp = (_s = this._depthClamp) !== null && _s !== void 0 ? _s : true;
            this._cascadeBlendPercentage = (_t = this._cascadeBlendPercentage) !== null && _t !== void 0 ? _t : 0.1;
            this._lambda = (_u = this._lambda) !== null && _u !== void 0 ? _u : 0.5;
            this._autoCalcDepthBounds = (_v = this._autoCalcDepthBounds) !== null && _v !== void 0 ? _v : false;
            this._recreateSceneUBOs();
            super._initializeGenerator();
        }
        _createTargetRenderTexture() {
            const engine = this._scene.getEngine();
            const size = { width: this._mapSize, height: this._mapSize, layers: this.numCascades };
            this._shadowMap = new RenderTargetTexture(this._light.name + "_CSMShadowMap", size, this._scene, false, true, this._textureType, false, undefined, false, false, undefined, this._useRedTextureType ? 6 : 5);
            this._shadowMap.createDepthStencilTexture(engine.useReverseDepthBuffer ? 516 : 513, true);
            this._shadowMap.noPrePassRenderer = true;
        }
        _initializeShadowMap() {
            super._initializeShadowMap();
            if (this._shadowMap === null) {
                return;
            }
            this._transformMatricesAsArray = new Float32Array(this._numCascades * 16);
            this._viewSpaceFrustumsZ = new Array(this._numCascades);
            this._frustumLengths = new Array(this._numCascades);
            this._lightSizeUVCorrection = new Array(this._numCascades * 2);
            this._depthCorrection = new Array(this._numCascades);
            this._cascades = [];
            this._viewMatrices = [];
            this._projectionMatrices = [];
            this._transformMatrices = [];
            this._cascadeMinExtents = [];
            this._cascadeMaxExtents = [];
            this._frustumCenter = [];
            this._shadowCameraPos = [];
            this._frustumCornersWorldSpace = [];
            for (let cascadeIndex = 0; cascadeIndex < this._numCascades; ++cascadeIndex) {
                this._cascades[cascadeIndex] = {
                    prevBreakDistance: 0,
                    breakDistance: 0,
                };
                this._viewMatrices[cascadeIndex] = Matrix.Zero();
                this._projectionMatrices[cascadeIndex] = Matrix.Zero();
                this._transformMatrices[cascadeIndex] = Matrix.Zero();
                this._cascadeMinExtents[cascadeIndex] = new Vector3();
                this._cascadeMaxExtents[cascadeIndex] = new Vector3();
                this._frustumCenter[cascadeIndex] = new Vector3();
                this._shadowCameraPos[cascadeIndex] = new Vector3();
                this._frustumCornersWorldSpace[cascadeIndex] = new Array(CascadedShadowGenerator._FrustumCornersNDCSpace.length);
                for (let i = 0; i < CascadedShadowGenerator._FrustumCornersNDCSpace.length; ++i) {
                    this._frustumCornersWorldSpace[cascadeIndex][i] = new Vector3();
                }
            }
            const engine = this._scene.getEngine();
            this._shadowMap.onBeforeBindObservable.clear();
            this._shadowMap.onBeforeRenderObservable.clear();
            this._shadowMap.onBeforeRenderObservable.add((layer) => {
                if (this._sceneUBOs) {
                    this._scene.setSceneUniformBuffer(this._sceneUBOs[layer]);
                }
                this._currentLayer = layer;
                if (this._filter === ShadowGenerator.FILTER_PCF) {
                    engine.setColorWrite(false);
                }
                this._scene.setTransformMatrix(this.getCascadeViewMatrix(layer), this.getCascadeProjectionMatrix(layer));
                if (this._useUBO) {
                    this._scene.getSceneUniformBuffer().unbindEffect();
                    this._scene.finalizeSceneUbo();
                }
            });
            this._shadowMap.onBeforeBindObservable.add(() => {
                var _a;
                this._currentSceneUBO = this._scene.getSceneUniformBuffer();
                (_a = engine._debugPushGroup) === null || _a === void 0 ? void 0 : _a.call(engine, `cascaded shadow map generation for pass id ${engine.currentRenderPassId}`, 1);
                if (this._breaksAreDirty) {
                    this._splitFrustum();
                }
                this._computeMatrices();
            });
            this._splitFrustum();
        }
        _bindCustomEffectForRenderSubMeshForShadowMap(subMesh, effect) {
            effect.setMatrix("viewProjection", this.getCascadeTransformMatrix(this._currentLayer));
        }
        _isReadyCustomDefines(defines) {
            defines.push("#define SM_DEPTHCLAMP " + (this._depthClamp && this._filter !== ShadowGenerator.FILTER_PCSS ? "1" : "0"));
        }
        /**
         * Prepare all the defines in a material relying on a shadow map at the specified light index.
         * @param defines Defines of the material we want to update
         * @param lightIndex Index of the light in the enabled light list of the material
         */
        prepareDefines(defines, lightIndex) {
            super.prepareDefines(defines, lightIndex);
            const scene = this._scene;
            const light = this._light;
            if (!scene.shadowsEnabled || !light.shadowEnabled) {
                return;
            }
            defines["SHADOWCSM" + lightIndex] = true;
            defines["SHADOWCSMDEBUG" + lightIndex] = this.debug;
            defines["SHADOWCSMNUM_CASCADES" + lightIndex] = this.numCascades;
            defines["SHADOWCSM_RIGHTHANDED" + lightIndex] = scene.useRightHandedSystem;
            const camera = this._getCamera();
            if (camera && this._shadowMaxZ <= (camera.maxZ || this._shadowMaxZ)) {
                defines["SHADOWCSMUSESHADOWMAXZ" + lightIndex] = true;
            }
            if (this.cascadeBlendPercentage === 0) {
                defines["SHADOWCSMNOBLEND" + lightIndex] = true;
            }
        }
        /**
         * Binds the shadow related information inside of an effect (information like near, far, darkness...
         * defined in the generator but impacting the effect).
         * @param lightIndex Index of the light in the enabled light list of the material owning the effect
         * @param effect The effect we are binfing the information for
         */
        bindShadowLight(lightIndex, effect) {
            const light = this._light;
            const scene = this._scene;
            if (!scene.shadowsEnabled || !light.shadowEnabled) {
                return;
            }
            const camera = this._getCamera();
            if (!camera) {
                return;
            }
            const shadowMap = this.getShadowMap();
            if (!shadowMap) {
                return;
            }
            const width = shadowMap.getSize().width;
            effect.setMatrices("lightMatrix" + lightIndex, this._transformMatricesAsArray);
            effect.setArray("viewFrustumZ" + lightIndex, this._viewSpaceFrustumsZ);
            effect.setFloat("cascadeBlendFactor" + lightIndex, this.cascadeBlendPercentage === 0 ? 10000 : 1 / this.cascadeBlendPercentage);
            effect.setArray("frustumLengths" + lightIndex, this._frustumLengths);
            // Only PCF uses depth stencil texture.
            if (this._filter === ShadowGenerator.FILTER_PCF) {
                effect.setDepthStencilTexture("shadowSampler" + lightIndex, shadowMap);
                light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), width, 1 / width, this.frustumEdgeFalloff, lightIndex);
            }
            else if (this._filter === ShadowGenerator.FILTER_PCSS) {
                for (let cascadeIndex = 0; cascadeIndex < this._numCascades; ++cascadeIndex) {
                    this._lightSizeUVCorrection[cascadeIndex * 2 + 0] =
                        cascadeIndex === 0
                            ? 1
                            : (this._cascadeMaxExtents[0].x - this._cascadeMinExtents[0].x) / (this._cascadeMaxExtents[cascadeIndex].x - this._cascadeMinExtents[cascadeIndex].x); // x correction
                    this._lightSizeUVCorrection[cascadeIndex * 2 + 1] =
                        cascadeIndex === 0
                            ? 1
                            : (this._cascadeMaxExtents[0].y - this._cascadeMinExtents[0].y) / (this._cascadeMaxExtents[cascadeIndex].y - this._cascadeMinExtents[cascadeIndex].y); // y correction
                    this._depthCorrection[cascadeIndex] =
                        cascadeIndex === 0
                            ? 1
                            : (this._cascadeMaxExtents[cascadeIndex].z - this._cascadeMinExtents[cascadeIndex].z) / (this._cascadeMaxExtents[0].z - this._cascadeMinExtents[0].z);
                }
                effect.setDepthStencilTexture("shadowSampler" + lightIndex, shadowMap);
                effect.setTexture("depthSampler" + lightIndex, shadowMap);
                effect.setArray2("lightSizeUVCorrection" + lightIndex, this._lightSizeUVCorrection);
                effect.setArray("depthCorrection" + lightIndex, this._depthCorrection);
                effect.setFloat("penumbraDarkness" + lightIndex, this.penumbraDarkness);
                light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), 1 / width, this._contactHardeningLightSizeUVRatio * width, this.frustumEdgeFalloff, lightIndex);
            }
            else {
                effect.setTexture("shadowSampler" + lightIndex, shadowMap);
                light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), width, 1 / width, this.frustumEdgeFalloff, lightIndex);
            }
            light._uniformBuffer.updateFloat2("depthValues", this.getLight().getDepthMinZ(camera), this.getLight().getDepthMinZ(camera) + this.getLight().getDepthMaxZ(camera), lightIndex);
        }
        /**
         * Gets the transformation matrix of the first cascade used to project the meshes into the map from the light point of view.
         * (eq to view projection * shadow projection matrices)
         * @returns The transform matrix used to create the shadow map
         */
        getTransformMatrix() {
            return this.getCascadeTransformMatrix(0);
        }
        /**
         * Disposes the ShadowGenerator.
         * Returns nothing.
         */
        dispose() {
            super.dispose();
            if (this._freezeShadowCastersBoundingInfoObservable) {
                this._scene.onBeforeRenderObservable.remove(this._freezeShadowCastersBoundingInfoObservable);
                this._freezeShadowCastersBoundingInfoObservable = null;
            }
            if (this._depthReducer) {
                this._depthReducer.dispose();
                this._depthReducer = null;
            }
        }
        /**
         * Serializes the shadow generator setup to a json object.
         * @returns The serialized JSON object
         */
        serialize() {
            const serializationObject = super.serialize();
            const shadowMap = this.getShadowMap();
            if (!shadowMap) {
                return serializationObject;
            }
            serializationObject.numCascades = this._numCascades;
            serializationObject.debug = this._debug;
            serializationObject.stabilizeCascades = this.stabilizeCascades;
            serializationObject.lambda = this._lambda;
            serializationObject.cascadeBlendPercentage = this.cascadeBlendPercentage;
            serializationObject.depthClamp = this._depthClamp;
            serializationObject.autoCalcDepthBounds = this.autoCalcDepthBounds;
            serializationObject.shadowMaxZ = this._shadowMaxZ;
            serializationObject.penumbraDarkness = this.penumbraDarkness;
            serializationObject.freezeShadowCastersBoundingInfo = this._freezeShadowCastersBoundingInfo;
            serializationObject.minDistance = this.minDistance;
            serializationObject.maxDistance = this.maxDistance;
            serializationObject.renderList = [];
            if (shadowMap.renderList) {
                for (let meshIndex = 0; meshIndex < shadowMap.renderList.length; meshIndex++) {
                    const mesh = shadowMap.renderList[meshIndex];
                    serializationObject.renderList.push(mesh.id);
                }
            }
            return serializationObject;
        }
        /**
         * Parses a serialized ShadowGenerator and returns a new ShadowGenerator.
         * @param parsedShadowGenerator The JSON object to parse
         * @param scene The scene to create the shadow map for
         * @returns The parsed shadow generator
         */
        static Parse(parsedShadowGenerator, scene) {
            const shadowGenerator = ShadowGenerator.Parse(parsedShadowGenerator, scene, (mapSize, light, camera) => new CascadedShadowGenerator(mapSize, light, undefined, camera));
            if (parsedShadowGenerator.numCascades !== undefined) {
                shadowGenerator.numCascades = parsedShadowGenerator.numCascades;
            }
            if (parsedShadowGenerator.debug !== undefined) {
                shadowGenerator.debug = parsedShadowGenerator.debug;
            }
            if (parsedShadowGenerator.stabilizeCascades !== undefined) {
                shadowGenerator.stabilizeCascades = parsedShadowGenerator.stabilizeCascades;
            }
            if (parsedShadowGenerator.lambda !== undefined) {
                shadowGenerator.lambda = parsedShadowGenerator.lambda;
            }
            if (parsedShadowGenerator.cascadeBlendPercentage !== undefined) {
                shadowGenerator.cascadeBlendPercentage = parsedShadowGenerator.cascadeBlendPercentage;
            }
            if (parsedShadowGenerator.depthClamp !== undefined) {
                shadowGenerator.depthClamp = parsedShadowGenerator.depthClamp;
            }
            if (parsedShadowGenerator.autoCalcDepthBounds !== undefined) {
                shadowGenerator.autoCalcDepthBounds = parsedShadowGenerator.autoCalcDepthBounds;
            }
            if (parsedShadowGenerator.shadowMaxZ !== undefined) {
                shadowGenerator.shadowMaxZ = parsedShadowGenerator.shadowMaxZ;
            }
            if (parsedShadowGenerator.penumbraDarkness !== undefined) {
                shadowGenerator.penumbraDarkness = parsedShadowGenerator.penumbraDarkness;
            }
            if (parsedShadowGenerator.freezeShadowCastersBoundingInfo !== undefined) {
                shadowGenerator.freezeShadowCastersBoundingInfo = parsedShadowGenerator.freezeShadowCastersBoundingInfo;
            }
            if (parsedShadowGenerator.minDistance !== undefined && parsedShadowGenerator.maxDistance !== undefined) {
                shadowGenerator.setMinMaxDistance(parsedShadowGenerator.minDistance, parsedShadowGenerator.maxDistance);
            }
            return shadowGenerator;
        }
    }
    CascadedShadowGenerator._FrustumCornersNDCSpace = [
        new Vector3(-1.0, +1.0, -1.0),
        new Vector3(+1.0, +1.0, -1.0),
        new Vector3(+1.0, -1.0, -1.0),
        new Vector3(-1.0, -1.0, -1.0),
        new Vector3(-1.0, +1.0, +1.0),
        new Vector3(+1.0, +1.0, +1.0),
        new Vector3(+1.0, -1.0, +1.0),
        new Vector3(-1.0, -1.0, +1.0),
    ];
    /**
     * Name of the CSM class
     */
    CascadedShadowGenerator.CLASSNAME = "CascadedShadowGenerator";
    /**
     * Defines the default number of cascades used by the CSM.
     */
    CascadedShadowGenerator.DEFAULT_CASCADES_COUNT = 4;
    /**
     * Defines the minimum number of cascades used by the CSM.
     */
    CascadedShadowGenerator.MIN_CASCADES_COUNT = 2;
    /**
     * Defines the maximum number of cascades used by the CSM.
     */
    CascadedShadowGenerator.MAX_CASCADES_COUNT = 4;
    /**
     * @internal
     */
    CascadedShadowGenerator._SceneComponentInitialization = (_) => {
        throw _WarnImport("ShadowGeneratorSceneComponent");
    };

    // Adds the parser to the scene parsers.
    AbstractScene.AddParser(SceneComponentConstants.NAME_SHADOWGENERATOR, (parsedData, scene) => {
        // Shadows
        if (parsedData.shadowGenerators !== undefined && parsedData.shadowGenerators !== null) {
            for (let index = 0, cache = parsedData.shadowGenerators.length; index < cache; index++) {
                const parsedShadowGenerator = parsedData.shadowGenerators[index];
                if (parsedShadowGenerator.className === CascadedShadowGenerator.CLASSNAME) {
                    CascadedShadowGenerator.Parse(parsedShadowGenerator, scene);
                }
                else {
                    ShadowGenerator.Parse(parsedShadowGenerator, scene);
                }
                // SG would be available on their associated lights
            }
        }
    });
    /**
     * Defines the shadow generator component responsible to manage any shadow generators
     * in a given scene.
     */
    class ShadowGeneratorSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_SHADOWGENERATOR;
            this.scene = scene;
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_SHADOWGENERATOR, this, this._gatherRenderTargets);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Nothing To Do Here.
        }
        /**
         * Serializes the component data to the specified json object
         * @param serializationObject The object to serialize to
         */
        serialize(serializationObject) {
            // Shadows
            serializationObject.shadowGenerators = [];
            const lights = this.scene.lights;
            for (const light of lights) {
                const shadowGenerators = light.getShadowGenerators();
                if (shadowGenerators) {
                    const iterator = shadowGenerators.values();
                    for (let key = iterator.next(); key.done !== true; key = iterator.next()) {
                        const shadowGenerator = key.value;
                        serializationObject.shadowGenerators.push(shadowGenerator.serialize());
                    }
                }
            }
        }
        /**
         * Adds all the elements from the container to the scene
         * @param container the container holding the elements
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        addFromContainer(container) {
            // Nothing To Do Here. (directly attached to a light)
        }
        /**
         * Removes all the elements in the container from the scene
         * @param container contains the elements to remove
         * @param dispose if the removed element should be disposed (default: false)
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        removeFromContainer(container, dispose) {
            // Nothing To Do Here. (directly attached to a light)
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        dispose() {
            // Nothing To Do Here.
        }
        _gatherRenderTargets(renderTargets) {
            // Shadows
            const scene = this.scene;
            if (this.scene.shadowsEnabled) {
                for (let lightIndex = 0; lightIndex < scene.lights.length; lightIndex++) {
                    const light = scene.lights[lightIndex];
                    const shadowGenerators = light.getShadowGenerators();
                    if (light.isEnabled() && light.shadowEnabled && shadowGenerators) {
                        const iterator = shadowGenerators.values();
                        for (let key = iterator.next(); key.done !== true; key = iterator.next()) {
                            const shadowGenerator = key.value;
                            const shadowMap = shadowGenerator.getShadowMap();
                            if (scene.textures.indexOf(shadowMap) !== -1) {
                                renderTargets.push(shadowMap);
                            }
                        }
                    }
                }
            }
        }
    }
    ShadowGenerator._SceneComponentInitialization = (scene) => {
        let component = scene._getComponent(SceneComponentConstants.NAME_SHADOWGENERATOR);
        if (!component) {
            component = new ShadowGeneratorSceneComponent(scene);
            scene._addComponent(component);
        }
    };

    Node.AddNodeConstructor("Light_Type_1", (name, scene) => {
        return () => new DirectionalLight(name, Vector3.Zero(), scene);
    });
    /**
     * A directional light is defined by a direction (what a surprise!).
     * The light is emitted from everywhere in the specified direction, and has an infinite range.
     * An example of a directional light is when a distance planet is lit by the apparently parallel lines of light from its sun. Light in a downward direction will light the top of an object.
     * Documentation: https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     */
    class DirectionalLight extends ShadowLight {
        /**
         * Fix frustum size for the shadow generation. This is disabled if the value is 0.
         */
        get shadowFrustumSize() {
            return this._shadowFrustumSize;
        }
        /**
         * Specifies a fix frustum size for the shadow generation.
         */
        set shadowFrustumSize(value) {
            this._shadowFrustumSize = value;
            this.forceProjectionMatrixCompute();
        }
        /**
         * Gets the shadow projection scale against the optimal computed one.
         * 0.1 by default which means that the projection window is increase by 10% from the optimal size.
         * This does not impact in fixed frustum size (shadowFrustumSize being set)
         */
        get shadowOrthoScale() {
            return this._shadowOrthoScale;
        }
        /**
         * Sets the shadow projection scale against the optimal computed one.
         * 0.1 by default which means that the projection window is increase by 10% from the optimal size.
         * This does not impact in fixed frustum size (shadowFrustumSize being set)
         */
        set shadowOrthoScale(value) {
            this._shadowOrthoScale = value;
            this.forceProjectionMatrixCompute();
        }
        /**
         * Gets or sets the orthoLeft property used to build the light frustum
         */
        get orthoLeft() {
            return this._orthoLeft;
        }
        set orthoLeft(left) {
            this._orthoLeft = left;
        }
        /**
         * Gets or sets the orthoRight property used to build the light frustum
         */
        get orthoRight() {
            return this._orthoRight;
        }
        set orthoRight(right) {
            this._orthoRight = right;
        }
        /**
         * Gets or sets the orthoTop property used to build the light frustum
         */
        get orthoTop() {
            return this._orthoTop;
        }
        set orthoTop(top) {
            this._orthoTop = top;
        }
        /**
         * Gets or sets the orthoBottom property used to build the light frustum
         */
        get orthoBottom() {
            return this._orthoBottom;
        }
        set orthoBottom(bottom) {
            this._orthoBottom = bottom;
        }
        /**
         * Creates a DirectionalLight object in the scene, oriented towards the passed direction (Vector3).
         * The directional light is emitted from everywhere in the given direction.
         * It can cast shadows.
         * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         * @param name The friendly name of the light
         * @param direction The direction of the light
         * @param scene The scene the light belongs to
         */
        constructor(name, direction, scene) {
            super(name, scene);
            this._shadowFrustumSize = 0;
            this._shadowOrthoScale = 0.1;
            /**
             * Automatically compute the projection matrix to best fit (including all the casters)
             * on each frame.
             */
            this.autoUpdateExtends = true;
            /**
             * Automatically compute the shadowMinZ and shadowMaxZ for the projection matrix to best fit (including all the casters)
             * on each frame. autoUpdateExtends must be set to true for this to work
             */
            this.autoCalcShadowZBounds = false;
            // Cache
            this._orthoLeft = Number.MAX_VALUE;
            this._orthoRight = Number.MIN_VALUE;
            this._orthoTop = Number.MIN_VALUE;
            this._orthoBottom = Number.MAX_VALUE;
            this.position = direction.scale(-1.0);
            this.direction = direction;
        }
        /**
         * Returns the string "DirectionalLight".
         * @returns The class name
         */
        getClassName() {
            return "DirectionalLight";
        }
        /**
         * Returns the integer 1.
         * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
         */
        getTypeID() {
            return Light.LIGHTTYPEID_DIRECTIONALLIGHT;
        }
        /**
         * Sets the passed matrix "matrix" as projection matrix for the shadows cast by the light according to the passed view matrix.
         * Returns the DirectionalLight Shadow projection matrix.
         * @param matrix
         * @param viewMatrix
         * @param renderList
         */
        _setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList) {
            if (this.shadowFrustumSize > 0) {
                this._setDefaultFixedFrustumShadowProjectionMatrix(matrix);
            }
            else {
                this._setDefaultAutoExtendShadowProjectionMatrix(matrix, viewMatrix, renderList);
            }
        }
        /**
         * Sets the passed matrix "matrix" as fixed frustum projection matrix for the shadows cast by the light according to the passed view matrix.
         * Returns the DirectionalLight Shadow projection matrix.
         * @param matrix
         */
        _setDefaultFixedFrustumShadowProjectionMatrix(matrix) {
            const activeCamera = this.getScene().activeCamera;
            if (!activeCamera) {
                return;
            }
            Matrix.OrthoLHToRef(this.shadowFrustumSize, this.shadowFrustumSize, this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ, this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ, matrix, this.getScene().getEngine().isNDCHalfZRange);
        }
        /**
         * Sets the passed matrix "matrix" as auto extend projection matrix for the shadows cast by the light according to the passed view matrix.
         * Returns the DirectionalLight Shadow projection matrix.
         * @param matrix
         * @param viewMatrix
         * @param renderList
         */
        _setDefaultAutoExtendShadowProjectionMatrix(matrix, viewMatrix, renderList) {
            const activeCamera = this.getScene().activeCamera;
            if (!activeCamera) {
                return;
            }
            // Check extends
            if (this.autoUpdateExtends || this._orthoLeft === Number.MAX_VALUE) {
                const tempVector3 = Vector3.Zero();
                this._orthoLeft = Number.MAX_VALUE;
                this._orthoRight = Number.MIN_VALUE;
                this._orthoTop = Number.MIN_VALUE;
                this._orthoBottom = Number.MAX_VALUE;
                let shadowMinZ = Number.MAX_VALUE;
                let shadowMaxZ = Number.MIN_VALUE;
                for (let meshIndex = 0; meshIndex < renderList.length; meshIndex++) {
                    const mesh = renderList[meshIndex];
                    if (!mesh) {
                        continue;
                    }
                    const boundingInfo = mesh.getBoundingInfo();
                    const boundingBox = boundingInfo.boundingBox;
                    for (let index = 0; index < boundingBox.vectorsWorld.length; index++) {
                        Vector3.TransformCoordinatesToRef(boundingBox.vectorsWorld[index], viewMatrix, tempVector3);
                        if (tempVector3.x < this._orthoLeft) {
                            this._orthoLeft = tempVector3.x;
                        }
                        if (tempVector3.y < this._orthoBottom) {
                            this._orthoBottom = tempVector3.y;
                        }
                        if (tempVector3.x > this._orthoRight) {
                            this._orthoRight = tempVector3.x;
                        }
                        if (tempVector3.y > this._orthoTop) {
                            this._orthoTop = tempVector3.y;
                        }
                        if (this.autoCalcShadowZBounds) {
                            if (tempVector3.z < shadowMinZ) {
                                shadowMinZ = tempVector3.z;
                            }
                            if (tempVector3.z > shadowMaxZ) {
                                shadowMaxZ = tempVector3.z;
                            }
                        }
                    }
                }
                if (this.autoCalcShadowZBounds) {
                    this._shadowMinZ = shadowMinZ;
                    this._shadowMaxZ = shadowMaxZ;
                }
            }
            const xOffset = this._orthoRight - this._orthoLeft;
            const yOffset = this._orthoTop - this._orthoBottom;
            const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
            const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
            const useReverseDepthBuffer = this.getScene().getEngine().useReverseDepthBuffer;
            Matrix.OrthoOffCenterLHToRef(this._orthoLeft - xOffset * this.shadowOrthoScale, this._orthoRight + xOffset * this.shadowOrthoScale, this._orthoBottom - yOffset * this.shadowOrthoScale, this._orthoTop + yOffset * this.shadowOrthoScale, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, matrix, this.getScene().getEngine().isNDCHalfZRange);
        }
        _buildUniformLayout() {
            this._uniformBuffer.addUniform("vLightData", 4);
            this._uniformBuffer.addUniform("vLightDiffuse", 4);
            this._uniformBuffer.addUniform("vLightSpecular", 4);
            this._uniformBuffer.addUniform("shadowsInfo", 3);
            this._uniformBuffer.addUniform("depthValues", 2);
            this._uniformBuffer.create();
        }
        /**
         * Sets the passed Effect object with the DirectionalLight transformed position (or position if not parented) and the passed name.
         * @param effect The effect to update
         * @param lightIndex The index of the light in the effect to update
         * @returns The directional light
         */
        transferToEffect(effect, lightIndex) {
            if (this.computeTransformedInformation()) {
                this._uniformBuffer.updateFloat4("vLightData", this.transformedDirection.x, this.transformedDirection.y, this.transformedDirection.z, 1, lightIndex);
                return this;
            }
            this._uniformBuffer.updateFloat4("vLightData", this.direction.x, this.direction.y, this.direction.z, 1, lightIndex);
            return this;
        }
        transferToNodeMaterialEffect(effect, lightDataUniformName) {
            if (this.computeTransformedInformation()) {
                effect.setFloat3(lightDataUniformName, this.transformedDirection.x, this.transformedDirection.y, this.transformedDirection.z);
                return this;
            }
            effect.setFloat3(lightDataUniformName, this.direction.x, this.direction.y, this.direction.z);
            return this;
        }
        /**
         * Gets the minZ used for shadow according to both the scene and the light.
         *
         * Values are fixed on directional lights as it relies on an ortho projection hence the need to convert being
         * -1 and 1 to 0 and 1 doing (depth + min) / (min + max) -> (depth + 1) / (1 + 1) -> (depth * 0.5) + 0.5.
         * (when not using reverse depth buffer / NDC half Z range)
         * @param activeCamera The camera we are returning the min for
         * @returns the depth min z
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getDepthMinZ(activeCamera) {
            const engine = this._scene.getEngine();
            return !engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
        }
        /**
         * Gets the maxZ used for shadow according to both the scene and the light.
         *
         * Values are fixed on directional lights as it relies on an ortho projection hence the need to convert being
         * -1 and 1 to 0 and 1 doing (depth + min) / (min + max) -> (depth + 1) / (1 + 1) -> (depth * 0.5) + 0.5.
         * (when not using reverse depth buffer / NDC half Z range)
         * @param activeCamera The camera we are returning the max for
         * @returns the depth max z
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getDepthMaxZ(activeCamera) {
            const engine = this._scene.getEngine();
            return engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
        }
        /**
         * Prepares the list of defines specific to the light type.
         * @param defines the list of defines
         * @param lightIndex defines the index of the light for the effect
         */
        prepareLightSpecificDefines(defines, lightIndex) {
            defines["DIRLIGHT" + lightIndex] = true;
        }
    }
    __decorate$1([
        serialize()
    ], DirectionalLight.prototype, "shadowFrustumSize", null);
    __decorate$1([
        serialize()
    ], DirectionalLight.prototype, "shadowOrthoScale", null);
    __decorate$1([
        serialize()
    ], DirectionalLight.prototype, "autoUpdateExtends", void 0);
    __decorate$1([
        serialize()
    ], DirectionalLight.prototype, "autoCalcShadowZBounds", void 0);
    __decorate$1([
        serialize("orthoLeft")
    ], DirectionalLight.prototype, "_orthoLeft", void 0);
    __decorate$1([
        serialize("orthoRight")
    ], DirectionalLight.prototype, "_orthoRight", void 0);
    __decorate$1([
        serialize("orthoTop")
    ], DirectionalLight.prototype, "_orthoTop", void 0);
    __decorate$1([
        serialize("orthoBottom")
    ], DirectionalLight.prototype, "_orthoBottom", void 0);

    Node.AddNodeConstructor("Light_Type_0", (name, scene) => {
        return () => new PointLight(name, Vector3.Zero(), scene);
    });
    /**
     * A point light is a light defined by an unique point in world space.
     * The light is emitted in every direction from this point.
     * A good example of a point light is a standard light bulb.
     * Documentation: https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     */
    class PointLight extends ShadowLight {
        /**
         * Getter: In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
         * This specifies what angle the shadow will use to be created.
         *
         * It default to 90 degrees to work nicely with the cube texture generation for point lights shadow maps.
         */
        get shadowAngle() {
            return this._shadowAngle;
        }
        /**
         * Setter: In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
         * This specifies what angle the shadow will use to be created.
         *
         * It default to 90 degrees to work nicely with the cube texture generation for point lights shadow maps.
         */
        set shadowAngle(value) {
            this._shadowAngle = value;
            this.forceProjectionMatrixCompute();
        }
        /**
         * Gets the direction if it has been set.
         * In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
         */
        get direction() {
            return this._direction;
        }
        /**
         * In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
         */
        set direction(value) {
            const previousNeedCube = this.needCube();
            this._direction = value;
            if (this.needCube() !== previousNeedCube && this._shadowGenerators) {
                const iterator = this._shadowGenerators.values();
                for (let key = iterator.next(); key.done !== true; key = iterator.next()) {
                    const shadowGenerator = key.value;
                    shadowGenerator.recreateShadowMap();
                }
            }
        }
        /**
         * Creates a PointLight object from the passed name and position (Vector3) and adds it in the scene.
         * A PointLight emits the light in every direction.
         * It can cast shadows.
         * If the scene camera is already defined and you want to set your PointLight at the camera position, just set it :
         * ```javascript
         * var pointLight = new PointLight("pl", camera.position, scene);
         * ```
         * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         * @param name The light friendly name
         * @param position The position of the point light in the scene
         * @param scene The scene the lights belongs to
         */
        constructor(name, position, scene) {
            super(name, scene);
            this._shadowAngle = Math.PI / 2;
            this.position = position;
        }
        /**
         * Returns the string "PointLight"
         * @returns the class name
         */
        getClassName() {
            return "PointLight";
        }
        /**
         * Returns the integer 0.
         * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
         */
        getTypeID() {
            return Light.LIGHTTYPEID_POINTLIGHT;
        }
        /**
         * Specifies whether or not the shadowmap should be a cube texture.
         * @returns true if the shadowmap needs to be a cube texture.
         */
        needCube() {
            return !this.direction;
        }
        /**
         * Returns a new Vector3 aligned with the PointLight cube system according to the passed cube face index (integer).
         * @param faceIndex The index of the face we are computed the direction to generate shadow
         * @returns The set direction in 2d mode otherwise the direction to the cubemap face if needCube() is true
         */
        getShadowDirection(faceIndex) {
            if (this.direction) {
                return super.getShadowDirection(faceIndex);
            }
            else {
                switch (faceIndex) {
                    case 0:
                        return new Vector3(1.0, 0.0, 0.0);
                    case 1:
                        return new Vector3(-1.0, 0.0, 0.0);
                    case 2:
                        return new Vector3(0.0, -1.0, 0.0);
                    case 3:
                        return new Vector3(0.0, 1.0, 0.0);
                    case 4:
                        return new Vector3(0.0, 0.0, 1.0);
                    case 5:
                        return new Vector3(0.0, 0.0, -1.0);
                }
            }
            return Vector3.Zero();
        }
        /**
         * Sets the passed matrix "matrix" as a left-handed perspective projection matrix with the following settings :
         * - fov = PI / 2
         * - aspect ratio : 1.0
         * - z-near and far equal to the active camera minZ and maxZ.
         * Returns the PointLight.
         * @param matrix
         * @param viewMatrix
         * @param renderList
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList) {
            const activeCamera = this.getScene().activeCamera;
            if (!activeCamera) {
                return;
            }
            const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
            const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
            const useReverseDepthBuffer = this.getScene().getEngine().useReverseDepthBuffer;
            Matrix.PerspectiveFovLHToRef(this.shadowAngle, 1.0, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, matrix, true, this._scene.getEngine().isNDCHalfZRange, undefined, useReverseDepthBuffer);
        }
        _buildUniformLayout() {
            this._uniformBuffer.addUniform("vLightData", 4);
            this._uniformBuffer.addUniform("vLightDiffuse", 4);
            this._uniformBuffer.addUniform("vLightSpecular", 4);
            this._uniformBuffer.addUniform("vLightFalloff", 4);
            this._uniformBuffer.addUniform("shadowsInfo", 3);
            this._uniformBuffer.addUniform("depthValues", 2);
            this._uniformBuffer.create();
        }
        /**
         * Sets the passed Effect "effect" with the PointLight transformed position (or position, if none) and passed name (string).
         * @param effect The effect to update
         * @param lightIndex The index of the light in the effect to update
         * @returns The point light
         */
        transferToEffect(effect, lightIndex) {
            if (this.computeTransformedInformation()) {
                this._uniformBuffer.updateFloat4("vLightData", this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z, 0.0, lightIndex);
            }
            else {
                this._uniformBuffer.updateFloat4("vLightData", this.position.x, this.position.y, this.position.z, 0, lightIndex);
            }
            this._uniformBuffer.updateFloat4("vLightFalloff", this.range, this._inverseSquaredRange, 0, 0, lightIndex);
            return this;
        }
        transferToNodeMaterialEffect(effect, lightDataUniformName) {
            if (this.computeTransformedInformation()) {
                effect.setFloat3(lightDataUniformName, this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z);
            }
            else {
                effect.setFloat3(lightDataUniformName, this.position.x, this.position.y, this.position.z);
            }
            return this;
        }
        /**
         * Prepares the list of defines specific to the light type.
         * @param defines the list of defines
         * @param lightIndex defines the index of the light for the effect
         */
        prepareLightSpecificDefines(defines, lightIndex) {
            defines["POINTLIGHT" + lightIndex] = true;
        }
    }
    __decorate$1([
        serialize()
    ], PointLight.prototype, "shadowAngle", null);

    Node.AddNodeConstructor("Light_Type_2", (name, scene) => {
        return () => new SpotLight(name, Vector3.Zero(), Vector3.Zero(), 0, 0, scene);
    });
    /**
     * A spot light is defined by a position, a direction, an angle, and an exponent.
     * These values define a cone of light starting from the position, emitting toward the direction.
     * The angle, in radians, defines the size (field of illumination) of the spotlight's conical beam,
     * and the exponent defines the speed of the decay of the light with distance (reach).
     * Documentation: https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     */
    class SpotLight extends ShadowLight {
        /**
         * Gets the cone angle of the spot light in Radians.
         */
        get angle() {
            return this._angle;
        }
        /**
         * Sets the cone angle of the spot light in Radians.
         */
        set angle(value) {
            this._angle = value;
            this._cosHalfAngle = Math.cos(value * 0.5);
            this._projectionTextureProjectionLightDirty = true;
            this.forceProjectionMatrixCompute();
            this._computeAngleValues();
        }
        /**
         * Only used in gltf falloff mode, this defines the angle where
         * the directional falloff will start before cutting at angle which could be seen
         * as outer angle.
         */
        get innerAngle() {
            return this._innerAngle;
        }
        /**
         * Only used in gltf falloff mode, this defines the angle where
         * the directional falloff will start before cutting at angle which could be seen
         * as outer angle.
         */
        set innerAngle(value) {
            this._innerAngle = value;
            this._computeAngleValues();
        }
        /**
         * Allows scaling the angle of the light for shadow generation only.
         */
        get shadowAngleScale() {
            return this._shadowAngleScale;
        }
        /**
         * Allows scaling the angle of the light for shadow generation only.
         */
        set shadowAngleScale(value) {
            this._shadowAngleScale = value;
            this.forceProjectionMatrixCompute();
        }
        /**
         * Allows reading the projection texture
         */
        get projectionTextureMatrix() {
            return this._projectionTextureMatrix;
        }
        /**
         * Gets the near clip of the Spotlight for texture projection.
         */
        get projectionTextureLightNear() {
            return this._projectionTextureLightNear;
        }
        /**
         * Sets the near clip of the Spotlight for texture projection.
         */
        set projectionTextureLightNear(value) {
            this._projectionTextureLightNear = value;
            this._projectionTextureProjectionLightDirty = true;
        }
        /**
         * Gets the far clip of the Spotlight for texture projection.
         */
        get projectionTextureLightFar() {
            return this._projectionTextureLightFar;
        }
        /**
         * Sets the far clip of the Spotlight for texture projection.
         */
        set projectionTextureLightFar(value) {
            this._projectionTextureLightFar = value;
            this._projectionTextureProjectionLightDirty = true;
        }
        /**
         * Gets the Up vector of the Spotlight for texture projection.
         */
        get projectionTextureUpDirection() {
            return this._projectionTextureUpDirection;
        }
        /**
         * Sets the Up vector of the Spotlight for texture projection.
         */
        set projectionTextureUpDirection(value) {
            this._projectionTextureUpDirection = value;
            this._projectionTextureProjectionLightDirty = true;
        }
        /**
         * Gets the projection texture of the light.
         */
        get projectionTexture() {
            return this._projectionTexture;
        }
        /**
         * Sets the projection texture of the light.
         */
        set projectionTexture(value) {
            if (this._projectionTexture === value) {
                return;
            }
            this._projectionTexture = value;
            this._projectionTextureDirty = true;
            if (this._projectionTexture && !this._projectionTexture.isReady()) {
                if (SpotLight._IsProceduralTexture(this._projectionTexture)) {
                    this._projectionTexture.getEffect().executeWhenCompiled(() => {
                        this._markMeshesAsLightDirty();
                    });
                }
                else if (SpotLight._IsTexture(this._projectionTexture)) {
                    this._projectionTexture.onLoadObservable.addOnce(() => {
                        this._markMeshesAsLightDirty();
                    });
                }
            }
        }
        static _IsProceduralTexture(texture) {
            return texture.onGeneratedObservable !== undefined;
        }
        static _IsTexture(texture) {
            return texture.onLoadObservable !== undefined;
        }
        /**
         * Gets or sets the light projection matrix as used by the projection texture
         */
        get projectionTextureProjectionLightMatrix() {
            return this._projectionTextureProjectionLightMatrix;
        }
        set projectionTextureProjectionLightMatrix(projection) {
            this._projectionTextureProjectionLightMatrix = projection;
            this._projectionTextureProjectionLightDirty = false;
            this._projectionTextureDirty = true;
        }
        /**
         * Creates a SpotLight object in the scene. A spot light is a simply light oriented cone.
         * It can cast shadows.
         * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         * @param name The light friendly name
         * @param position The position of the spot light in the scene
         * @param direction The direction of the light in the scene
         * @param angle The cone angle of the light in Radians
         * @param exponent The light decay speed with the distance from the emission spot
         * @param scene The scene the lights belongs to
         */
        constructor(name, position, direction, angle, exponent, scene) {
            super(name, scene);
            this._innerAngle = 0;
            this._projectionTextureMatrix = Matrix.Zero();
            this._projectionTextureLightNear = 1e-6;
            this._projectionTextureLightFar = 1000.0;
            this._projectionTextureUpDirection = Vector3.Up();
            this._projectionTextureViewLightDirty = true;
            this._projectionTextureProjectionLightDirty = true;
            this._projectionTextureDirty = true;
            this._projectionTextureViewTargetVector = Vector3.Zero();
            this._projectionTextureViewLightMatrix = Matrix.Zero();
            this._projectionTextureProjectionLightMatrix = Matrix.Zero();
            this._projectionTextureScalingMatrix = Matrix.FromValues(0.5, 0.0, 0.0, 0.0, 0.0, 0.5, 0.0, 0.0, 0.0, 0.0, 0.5, 0.0, 0.5, 0.5, 0.5, 1.0);
            this.position = position;
            this.direction = direction;
            this.angle = angle;
            this.exponent = exponent;
        }
        /**
         * Returns the string "SpotLight".
         * @returns the class name
         */
        getClassName() {
            return "SpotLight";
        }
        /**
         * Returns the integer 2.
         * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
         */
        getTypeID() {
            return Light.LIGHTTYPEID_SPOTLIGHT;
        }
        /**
         * Overrides the direction setter to recompute the projection texture view light Matrix.
         * @param value
         */
        _setDirection(value) {
            super._setDirection(value);
            this._projectionTextureViewLightDirty = true;
        }
        /**
         * Overrides the position setter to recompute the projection texture view light Matrix.
         * @param value
         */
        _setPosition(value) {
            super._setPosition(value);
            this._projectionTextureViewLightDirty = true;
        }
        /**
         * Sets the passed matrix "matrix" as perspective projection matrix for the shadows and the passed view matrix with the fov equal to the SpotLight angle and and aspect ratio of 1.0.
         * Returns the SpotLight.
         * @param matrix
         * @param viewMatrix
         * @param renderList
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList) {
            const activeCamera = this.getScene().activeCamera;
            if (!activeCamera) {
                return;
            }
            this._shadowAngleScale = this._shadowAngleScale || 1;
            const angle = this._shadowAngleScale * this._angle;
            const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
            const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
            const useReverseDepthBuffer = this.getScene().getEngine().useReverseDepthBuffer;
            Matrix.PerspectiveFovLHToRef(angle, 1.0, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, matrix, true, this._scene.getEngine().isNDCHalfZRange, undefined, useReverseDepthBuffer);
        }
        _computeProjectionTextureViewLightMatrix() {
            this._projectionTextureViewLightDirty = false;
            this._projectionTextureDirty = true;
            this.getAbsolutePosition().addToRef(this.direction, this._projectionTextureViewTargetVector);
            Matrix.LookAtLHToRef(this.getAbsolutePosition(), this._projectionTextureViewTargetVector, this._projectionTextureUpDirection, this._projectionTextureViewLightMatrix);
        }
        _computeProjectionTextureProjectionLightMatrix() {
            this._projectionTextureProjectionLightDirty = false;
            this._projectionTextureDirty = true;
            const lightFar = this.projectionTextureLightFar;
            const lightNear = this.projectionTextureLightNear;
            const P = lightFar / (lightFar - lightNear);
            const Q = -P * lightNear;
            const S = 1.0 / Math.tan(this._angle / 2.0);
            const A = 1.0;
            Matrix.FromValuesToRef(S / A, 0.0, 0.0, 0.0, 0.0, S, 0.0, 0.0, 0.0, 0.0, P, 1.0, 0.0, 0.0, Q, 0.0, this._projectionTextureProjectionLightMatrix);
        }
        /**
         * Main function for light texture projection matrix computing.
         */
        _computeProjectionTextureMatrix() {
            this._projectionTextureDirty = false;
            this._projectionTextureViewLightMatrix.multiplyToRef(this._projectionTextureProjectionLightMatrix, this._projectionTextureMatrix);
            if (this._projectionTexture instanceof Texture) {
                const u = this._projectionTexture.uScale / 2.0;
                const v = this._projectionTexture.vScale / 2.0;
                Matrix.FromValuesToRef(u, 0.0, 0.0, 0.0, 0.0, v, 0.0, 0.0, 0.0, 0.0, 0.5, 0.0, 0.5, 0.5, 0.5, 1.0, this._projectionTextureScalingMatrix);
            }
            this._projectionTextureMatrix.multiplyToRef(this._projectionTextureScalingMatrix, this._projectionTextureMatrix);
        }
        _buildUniformLayout() {
            this._uniformBuffer.addUniform("vLightData", 4);
            this._uniformBuffer.addUniform("vLightDiffuse", 4);
            this._uniformBuffer.addUniform("vLightSpecular", 4);
            this._uniformBuffer.addUniform("vLightDirection", 3);
            this._uniformBuffer.addUniform("vLightFalloff", 4);
            this._uniformBuffer.addUniform("shadowsInfo", 3);
            this._uniformBuffer.addUniform("depthValues", 2);
            this._uniformBuffer.create();
        }
        _computeAngleValues() {
            this._lightAngleScale = 1.0 / Math.max(0.001, Math.cos(this._innerAngle * 0.5) - this._cosHalfAngle);
            this._lightAngleOffset = -this._cosHalfAngle * this._lightAngleScale;
        }
        /**
         * Sets the passed Effect "effect" with the Light textures.
         * @param effect The effect to update
         * @param lightIndex The index of the light in the effect to update
         * @returns The light
         */
        transferTexturesToEffect(effect, lightIndex) {
            if (this.projectionTexture && this.projectionTexture.isReady()) {
                if (this._projectionTextureViewLightDirty) {
                    this._computeProjectionTextureViewLightMatrix();
                }
                if (this._projectionTextureProjectionLightDirty) {
                    this._computeProjectionTextureProjectionLightMatrix();
                }
                if (this._projectionTextureDirty) {
                    this._computeProjectionTextureMatrix();
                }
                effect.setMatrix("textureProjectionMatrix" + lightIndex, this._projectionTextureMatrix);
                effect.setTexture("projectionLightSampler" + lightIndex, this.projectionTexture);
            }
            return this;
        }
        /**
         * Sets the passed Effect object with the SpotLight transformed position (or position if not parented) and normalized direction.
         * @param effect The effect to update
         * @param lightIndex The index of the light in the effect to update
         * @returns The spot light
         */
        transferToEffect(effect, lightIndex) {
            let normalizeDirection;
            if (this.computeTransformedInformation()) {
                this._uniformBuffer.updateFloat4("vLightData", this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z, this.exponent, lightIndex);
                normalizeDirection = Vector3.Normalize(this.transformedDirection);
            }
            else {
                this._uniformBuffer.updateFloat4("vLightData", this.position.x, this.position.y, this.position.z, this.exponent, lightIndex);
                normalizeDirection = Vector3.Normalize(this.direction);
            }
            this._uniformBuffer.updateFloat4("vLightDirection", normalizeDirection.x, normalizeDirection.y, normalizeDirection.z, this._cosHalfAngle, lightIndex);
            this._uniformBuffer.updateFloat4("vLightFalloff", this.range, this._inverseSquaredRange, this._lightAngleScale, this._lightAngleOffset, lightIndex);
            return this;
        }
        transferToNodeMaterialEffect(effect, lightDataUniformName) {
            let normalizeDirection;
            if (this.computeTransformedInformation()) {
                normalizeDirection = Vector3.Normalize(this.transformedDirection);
            }
            else {
                normalizeDirection = Vector3.Normalize(this.direction);
            }
            if (this.getScene().useRightHandedSystem) {
                effect.setFloat3(lightDataUniformName, -normalizeDirection.x, -normalizeDirection.y, -normalizeDirection.z);
            }
            else {
                effect.setFloat3(lightDataUniformName, normalizeDirection.x, normalizeDirection.y, normalizeDirection.z);
            }
            return this;
        }
        /**
         * Disposes the light and the associated resources.
         */
        dispose() {
            super.dispose();
            if (this._projectionTexture) {
                this._projectionTexture.dispose();
            }
        }
        /**
         * Gets the minZ used for shadow according to both the scene and the light.
         * @param activeCamera The camera we are returning the min for
         * @returns the depth min z
         */
        getDepthMinZ(activeCamera) {
            const engine = this._scene.getEngine();
            const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
            return engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? minZ : this._scene.getEngine().isNDCHalfZRange ? 0 : minZ;
        }
        /**
         * Gets the maxZ used for shadow according to both the scene and the light.
         * @param activeCamera The camera we are returning the max for
         * @returns the depth max z
         */
        getDepthMaxZ(activeCamera) {
            const engine = this._scene.getEngine();
            const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
            return engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : maxZ;
        }
        /**
         * Prepares the list of defines specific to the light type.
         * @param defines the list of defines
         * @param lightIndex defines the index of the light for the effect
         */
        prepareLightSpecificDefines(defines, lightIndex) {
            defines["SPOTLIGHT" + lightIndex] = true;
            defines["PROJECTEDLIGHTTEXTURE" + lightIndex] = this.projectionTexture && this.projectionTexture.isReady() ? true : false;
        }
    }
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "angle", null);
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "innerAngle", null);
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "shadowAngleScale", null);
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "exponent", void 0);
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "projectionTextureLightNear", null);
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "projectionTextureLightFar", null);
    __decorate$1([
        serialize()
    ], SpotLight.prototype, "projectionTextureUpDirection", null);
    __decorate$1([
        serializeAsTexture("projectedLightTexture")
    ], SpotLight.prototype, "_projectionTexture", void 0);

    /**
     * Defines the root class used to create scene optimization to use with SceneOptimizer
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            return true;
        }
        /**
         * Creates the SceneOptimization object
         * @param priority defines the priority of this optimization (0 by default which means first in the list)
         */
        constructor(
        /**
         * Defines the priority of this optimization (0 by default which means first in the list)
         */
        priority = 0) {
            this.priority = priority;
        }
    }
    /**
     * Defines an optimization used to reduce the size of render target textures
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class TextureOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Reducing render target texture size to " + this.maximumSize;
        }
        /**
         * Creates the TextureOptimization object
         * @param priority defines the priority of this optimization (0 by default which means first in the list)
         * @param maximumSize defines the maximum sized allowed for textures (1024 is the default value). If a texture is bigger, it will be scaled down using a factor defined by the step parameter
         * @param step defines the factor (0.5 by default) used to scale down textures bigger than maximum sized allowed.
         */
        constructor(
        /**
         * Defines the priority of this optimization (0 by default which means first in the list)
         */
        priority = 0, 
        /**
         * Defines the maximum sized allowed for textures (1024 is the default value). If a texture is bigger, it will be scaled down using a factor defined by the step parameter
         */
        maximumSize = 1024, 
        /**
         * Defines the factor (0.5 by default) used to scale down textures bigger than maximum sized allowed.
         */
        step = 0.5) {
            super(priority);
            this.priority = priority;
            this.maximumSize = maximumSize;
            this.step = step;
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            let allDone = true;
            for (let index = 0; index < scene.textures.length; index++) {
                const texture = scene.textures[index];
                if (!texture.canRescale || texture.getContext) {
                    continue;
                }
                const currentSize = texture.getSize();
                const maxDimension = Math.max(currentSize.width, currentSize.height);
                if (maxDimension > this.maximumSize) {
                    texture.scale(this.step);
                    allDone = false;
                }
            }
            return allDone;
        }
    }
    /**
     * Defines an optimization used to increase or decrease the rendering resolution
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class HardwareScalingOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Setting hardware scaling level to " + this._currentScale;
        }
        /**
         * Creates the HardwareScalingOptimization object
         * @param priority defines the priority of this optimization (0 by default which means first in the list)
         * @param maximumScale defines the maximum scale to use (2 by default)
         * @param step defines the step to use between two passes (0.5 by default)
         */
        constructor(
        /**
         * Defines the priority of this optimization (0 by default which means first in the list)
         */
        priority = 0, 
        /**
         * Defines the maximum scale to use (2 by default)
         */
        maximumScale = 2, 
        /**
         * Defines the step to use between two passes (0.5 by default)
         */
        step = 0.25) {
            super(priority);
            this.priority = priority;
            this.maximumScale = maximumScale;
            this.step = step;
            this._currentScale = -1;
            this._directionOffset = 1;
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            if (this._currentScale === -1) {
                this._currentScale = scene.getEngine().getHardwareScalingLevel();
                if (this._currentScale > this.maximumScale) {
                    this._directionOffset = -1;
                }
            }
            this._currentScale += this._directionOffset * this.step;
            scene.getEngine().setHardwareScalingLevel(this._currentScale);
            return this._directionOffset === 1 ? this._currentScale >= this.maximumScale : this._currentScale <= this.maximumScale;
        }
    }
    /**
     * Defines an optimization used to remove shadows
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class ShadowsOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Turning shadows on/off";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            scene.shadowsEnabled = optimizer.isInImprovementMode;
            return true;
        }
    }
    /**
     * Defines an optimization used to turn post-processes off
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class PostProcessesOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Turning post-processes on/off";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            scene.postProcessesEnabled = optimizer.isInImprovementMode;
            return true;
        }
    }
    /**
     * Defines an optimization used to turn lens flares off
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class LensFlaresOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Turning lens flares on/off";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            scene.lensFlaresEnabled = optimizer.isInImprovementMode;
            return true;
        }
    }
    /**
     * Defines an optimization based on user defined callback.
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class CustomOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            if (this.onGetDescription) {
                return this.onGetDescription();
            }
            return "Running user defined callback";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            if (this.onApply) {
                return this.onApply(scene, optimizer);
            }
            return true;
        }
    }
    /**
     * Defines an optimization used to turn particles off
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class ParticlesOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Turning particles on/off";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            scene.particlesEnabled = optimizer.isInImprovementMode;
            return true;
        }
    }
    /**
     * Defines an optimization used to turn render targets off
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class RenderTargetsOptimization extends SceneOptimization {
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Turning render targets off";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer) {
            scene.renderTargetsEnabled = optimizer.isInImprovementMode;
            return true;
        }
    }
    /**
     * Defines an optimization used to merge meshes with compatible materials
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class MergeMeshesOptimization extends SceneOptimization {
        constructor() {
            super(...arguments);
            this._canBeMerged = (abstractMesh) => {
                if (!(abstractMesh instanceof Mesh)) {
                    return false;
                }
                const mesh = abstractMesh;
                if (mesh.isDisposed()) {
                    return false;
                }
                if (!mesh.isVisible || !mesh.isEnabled()) {
                    return false;
                }
                if (mesh.instances.length > 0) {
                    return false;
                }
                if (mesh.skeleton || mesh.hasLODLevels) {
                    return false;
                }
                if (mesh.getTotalVertices() === 0) {
                    return false;
                }
                return true;
            };
        }
        /**
         * Gets or sets a boolean which defines if optimization octree has to be updated
         */
        static get UpdateSelectionTree() {
            return MergeMeshesOptimization._UpdateSelectionTree;
        }
        /**
         * Gets or sets a boolean which defines if optimization octree has to be updated
         */
        static set UpdateSelectionTree(value) {
            MergeMeshesOptimization._UpdateSelectionTree = value;
        }
        /**
         * Gets a string describing the action executed by the current optimization
         * @returns description string
         */
        getDescription() {
            return "Merging similar meshes together";
        }
        /**
         * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
         * @param scene defines the current scene where to apply this optimization
         * @param optimizer defines the current optimizer
         * @param updateSelectionTree defines that the selection octree has to be updated (false by default)
         * @returns true if everything that can be done was applied
         */
        apply(scene, optimizer, updateSelectionTree) {
            const globalPool = scene.meshes.slice(0);
            let globalLength = globalPool.length;
            for (let index = 0; index < globalLength; index++) {
                const currentPool = new Array();
                const current = globalPool[index];
                // Checks
                if (!this._canBeMerged(current)) {
                    continue;
                }
                currentPool.push(current);
                // Find compatible meshes
                for (let subIndex = index + 1; subIndex < globalLength; subIndex++) {
                    const otherMesh = globalPool[subIndex];
                    if (!this._canBeMerged(otherMesh)) {
                        continue;
                    }
                    if (otherMesh.material !== current.material) {
                        continue;
                    }
                    if (otherMesh.checkCollisions !== current.checkCollisions) {
                        continue;
                    }
                    currentPool.push(otherMesh);
                    globalLength--;
                    globalPool.splice(subIndex, 1);
                    subIndex--;
                }
                if (currentPool.length < 2) {
                    continue;
                }
                // Merge meshes
                Mesh.MergeMeshes(currentPool, undefined, true);
            }
            // Call the octree system optimization if it is defined.
            const sceneAsAny = scene;
            if (sceneAsAny.createOrUpdateSelectionOctree) {
                if (updateSelectionTree != undefined) {
                    if (updateSelectionTree) {
                        sceneAsAny.createOrUpdateSelectionOctree();
                    }
                }
                else if (MergeMeshesOptimization.UpdateSelectionTree) {
                    sceneAsAny.createOrUpdateSelectionOctree();
                }
            }
            return true;
        }
    }
    MergeMeshesOptimization._UpdateSelectionTree = false;
    /**
     * Defines a list of options used by SceneOptimizer
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class SceneOptimizerOptions {
        /**
         * Creates a new list of options used by SceneOptimizer
         * @param targetFrameRate defines the target frame rate to reach (60 by default)
         * @param trackerDuration defines the interval between two checks (2000ms by default)
         */
        constructor(
        /**
         * Defines the target frame rate to reach (60 by default)
         */
        targetFrameRate = 60, 
        /**
         * Defines the interval between two checks (2000ms by default)
         */
        trackerDuration = 2000) {
            this.targetFrameRate = targetFrameRate;
            this.trackerDuration = trackerDuration;
            /**
             * Gets the list of optimizations to apply
             */
            this.optimizations = new Array();
        }
        /**
         * Add a new optimization
         * @param optimization defines the SceneOptimization to add to the list of active optimizations
         * @returns the current SceneOptimizerOptions
         */
        addOptimization(optimization) {
            this.optimizations.push(optimization);
            return this;
        }
        /**
         * Add a new custom optimization
         * @param onApply defines the callback called to apply the custom optimization (true if everything that can be done was applied)
         * @param onGetDescription defines the callback called to get the description attached with the optimization.
         * @param priority defines the priority of this optimization (0 by default which means first in the list)
         * @returns the current SceneOptimizerOptions
         */
        addCustomOptimization(onApply, onGetDescription, priority = 0) {
            const optimization = new CustomOptimization(priority);
            optimization.onApply = onApply;
            optimization.onGetDescription = onGetDescription;
            this.optimizations.push(optimization);
            return this;
        }
        /**
         * Creates a list of pre-defined optimizations aimed to reduce the visual impact on the scene
         * @param targetFrameRate defines the target frame rate (60 by default)
         * @returns a SceneOptimizerOptions object
         */
        static LowDegradationAllowed(targetFrameRate) {
            const result = new SceneOptimizerOptions(targetFrameRate);
            let priority = 0;
            result.addOptimization(new MergeMeshesOptimization(priority));
            result.addOptimization(new ShadowsOptimization(priority));
            result.addOptimization(new LensFlaresOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new PostProcessesOptimization(priority));
            result.addOptimization(new ParticlesOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new TextureOptimization(priority, 1024));
            return result;
        }
        /**
         * Creates a list of pre-defined optimizations aimed to have a moderate impact on the scene visual
         * @param targetFrameRate defines the target frame rate (60 by default)
         * @returns a SceneOptimizerOptions object
         */
        static ModerateDegradationAllowed(targetFrameRate) {
            const result = new SceneOptimizerOptions(targetFrameRate);
            let priority = 0;
            result.addOptimization(new MergeMeshesOptimization(priority));
            result.addOptimization(new ShadowsOptimization(priority));
            result.addOptimization(new LensFlaresOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new PostProcessesOptimization(priority));
            result.addOptimization(new ParticlesOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new TextureOptimization(priority, 512));
            // Next priority
            priority++;
            result.addOptimization(new RenderTargetsOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new HardwareScalingOptimization(priority, 2));
            return result;
        }
        /**
         * Creates a list of pre-defined optimizations aimed to have a big impact on the scene visual
         * @param targetFrameRate defines the target frame rate (60 by default)
         * @returns a SceneOptimizerOptions object
         */
        static HighDegradationAllowed(targetFrameRate) {
            const result = new SceneOptimizerOptions(targetFrameRate);
            let priority = 0;
            result.addOptimization(new MergeMeshesOptimization(priority));
            result.addOptimization(new ShadowsOptimization(priority));
            result.addOptimization(new LensFlaresOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new PostProcessesOptimization(priority));
            result.addOptimization(new ParticlesOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new TextureOptimization(priority, 256));
            // Next priority
            priority++;
            result.addOptimization(new RenderTargetsOptimization(priority));
            // Next priority
            priority++;
            result.addOptimization(new HardwareScalingOptimization(priority, 4));
            return result;
        }
    }
    /**
     * Class used to run optimizations in order to reach a target frame rate
     * @description More details at https://doc.babylonjs.com/features/featuresDeepDive/scene/sceneOptimizer
     */
    class SceneOptimizer {
        /**
         * Gets or sets a boolean indicating if the optimizer is in improvement mode
         */
        get isInImprovementMode() {
            return this._improvementMode;
        }
        set isInImprovementMode(value) {
            this._improvementMode = value;
        }
        /**
         * Gets the current priority level (0 at start)
         */
        get currentPriorityLevel() {
            return this._currentPriorityLevel;
        }
        /**
         * Gets the current frame rate checked by the SceneOptimizer
         */
        get currentFrameRate() {
            return this._currentFrameRate;
        }
        /**
         * Gets or sets the current target frame rate (60 by default)
         */
        get targetFrameRate() {
            return this._targetFrameRate;
        }
        /**
         * Gets or sets the current target frame rate (60 by default)
         */
        set targetFrameRate(value) {
            this._targetFrameRate = value;
        }
        /**
         * Gets or sets the current interval between two checks (every 2000ms by default)
         */
        get trackerDuration() {
            return this._trackerDuration;
        }
        /**
         * Gets or sets the current interval between two checks (every 2000ms by default)
         */
        set trackerDuration(value) {
            this._trackerDuration = value;
        }
        /**
         * Gets the list of active optimizations
         */
        get optimizations() {
            return this._options.optimizations;
        }
        /**
         * Creates a new SceneOptimizer
         * @param scene defines the scene to work on
         * @param options defines the options to use with the SceneOptimizer
         * @param autoGeneratePriorities defines if priorities must be generated and not read from SceneOptimization property (true by default)
         * @param improvementMode defines if the scene optimizer must run the maximum optimization while staying over a target frame instead of trying to reach the target framerate (false by default)
         */
        constructor(scene, options, autoGeneratePriorities = true, improvementMode = false) {
            this._isRunning = false;
            this._currentPriorityLevel = 0;
            this._targetFrameRate = 60;
            this._trackerDuration = 2000;
            this._currentFrameRate = 0;
            this._improvementMode = false;
            /**
             * Defines an observable called when the optimizer reaches the target frame rate
             */
            this.onSuccessObservable = new Observable$1();
            /**
             * Defines an observable called when the optimizer enables an optimization
             */
            this.onNewOptimizationAppliedObservable = new Observable$1();
            /**
             * Defines an observable called when the optimizer is not able to reach the target frame rate
             */
            this.onFailureObservable = new Observable$1();
            if (!options) {
                this._options = new SceneOptimizerOptions();
            }
            else {
                this._options = options;
            }
            if (this._options.targetFrameRate) {
                this._targetFrameRate = this._options.targetFrameRate;
            }
            if (this._options.trackerDuration) {
                this._trackerDuration = this._options.trackerDuration;
            }
            if (autoGeneratePriorities) {
                let priority = 0;
                for (const optim of this._options.optimizations) {
                    optim.priority = priority++;
                }
            }
            this._improvementMode = improvementMode;
            this._scene = scene || EngineStore.LastCreatedScene;
            this._sceneDisposeObserver = this._scene.onDisposeObservable.add(() => {
                this._sceneDisposeObserver = null;
                this.dispose();
            });
        }
        /**
         * Stops the current optimizer
         */
        stop() {
            this._isRunning = false;
        }
        /**
         * Reset the optimizer to initial step (current priority level = 0)
         */
        reset() {
            this._currentPriorityLevel = 0;
        }
        /**
         * Start the optimizer. By default it will try to reach a specific framerate
         * but if the optimizer is set with improvementMode === true then it will run all optimization while frame rate is above the target frame rate
         */
        start() {
            if (this._isRunning) {
                return;
            }
            this._isRunning = true;
            // Let's wait for the scene to be ready before running our check
            this._scene.executeWhenReady(() => {
                setTimeout(() => {
                    this._checkCurrentState();
                }, this._trackerDuration);
            });
        }
        _checkCurrentState() {
            if (!this._isRunning) {
                return;
            }
            const scene = this._scene;
            const options = this._options;
            this._currentFrameRate = Math.round(scene.getEngine().getFps());
            if ((this._improvementMode && this._currentFrameRate <= this._targetFrameRate) || (!this._improvementMode && this._currentFrameRate >= this._targetFrameRate)) {
                this._isRunning = false;
                this.onSuccessObservable.notifyObservers(this);
                return;
            }
            // Apply current level of optimizations
            let allDone = true;
            let noOptimizationApplied = true;
            for (let index = 0; index < options.optimizations.length; index++) {
                const optimization = options.optimizations[index];
                if (optimization.priority === this._currentPriorityLevel) {
                    noOptimizationApplied = false;
                    allDone = allDone && optimization.apply(scene, this);
                    this.onNewOptimizationAppliedObservable.notifyObservers(optimization);
                }
            }
            // If no optimization was applied, this is a failure :(
            if (noOptimizationApplied) {
                this._isRunning = false;
                this.onFailureObservable.notifyObservers(this);
                return;
            }
            // If all optimizations were done, move to next level
            if (allDone) {
                this._currentPriorityLevel++;
            }
            // Let's the system running for a specific amount of time before checking FPS
            scene.executeWhenReady(() => {
                setTimeout(() => {
                    this._checkCurrentState();
                }, this._trackerDuration);
            });
        }
        /**
         * Release all resources
         */
        dispose() {
            this.stop();
            this.onSuccessObservable.clear();
            this.onFailureObservable.clear();
            this.onNewOptimizationAppliedObservable.clear();
            if (this._sceneDisposeObserver) {
                this._scene.onDisposeObservable.remove(this._sceneDisposeObserver);
            }
        }
        /**
         * Helper function to create a SceneOptimizer with one single line of code
         * @param scene defines the scene to work on
         * @param options defines the options to use with the SceneOptimizer
         * @param onSuccess defines a callback to call on success
         * @param onFailure defines a callback to call on failure
         * @returns the new SceneOptimizer object
         */
        static OptimizeAsync(scene, options, onSuccess, onFailure) {
            const optimizer = new SceneOptimizer(scene, options || SceneOptimizerOptions.ModerateDegradationAllowed(), false);
            if (onSuccess) {
                optimizer.onSuccessObservable.add(() => {
                    onSuccess();
                });
            }
            if (onFailure) {
                optimizer.onFailureObservable.add(() => {
                    onFailure();
                });
            }
            optimizer.start();
            return optimizer;
        }
    }

    let serializedGeometries = [];
    const SerializeGeometry = (geometry, serializationGeometries) => {
        if (geometry.doNotSerialize) {
            return;
        }
        serializationGeometries.vertexData.push(geometry.serializeVerticeData());
        serializedGeometries[geometry.id] = true;
    };
    const SerializeMesh = (mesh, serializationScene) => {
        const serializationObject = {};
        // Geometry
        const geometry = mesh._geometry;
        if (geometry) {
            if (!mesh.getScene().getGeometryById(geometry.id)) {
                // Geometry was in the memory but not added to the scene, nevertheless it's better to serialize to be able to reload the mesh with its geometry
                SerializeGeometry(geometry, serializationScene.geometries);
            }
        }
        // Custom
        if (mesh.serialize) {
            mesh.serialize(serializationObject);
        }
        return serializationObject;
    };
    const FinalizeSingleNode = (node, serializationObject) => {
        if (node._isMesh) {
            const mesh = node;
            //only works if the mesh is already loaded
            if (mesh.delayLoadState === 1 || mesh.delayLoadState === 0) {
                const serializeMaterial = (material) => {
                    serializationObject.materials = serializationObject.materials || [];
                    if (mesh.material && !serializationObject.materials.some((mat) => mat.id === mesh.material.id)) {
                        serializationObject.materials.push(material.serialize());
                    }
                };
                //serialize material
                if (mesh.material && !mesh.material.doNotSerialize) {
                    if (mesh.material instanceof MultiMaterial) {
                        serializationObject.multiMaterials = serializationObject.multiMaterials || [];
                        if (!serializationObject.multiMaterials.some((mat) => mat.id === mesh.material.id)) {
                            serializationObject.multiMaterials.push(mesh.material.serialize());
                            for (const submaterial of mesh.material.subMaterials) {
                                if (submaterial) {
                                    serializeMaterial(submaterial);
                                }
                            }
                        }
                    }
                    else {
                        serializeMaterial(mesh.material);
                    }
                }
                else if (!mesh.material) {
                    serializeMaterial(mesh.getScene().defaultMaterial);
                }
                //serialize geometry
                const geometry = mesh._geometry;
                if (geometry) {
                    if (!serializationObject.geometries) {
                        serializationObject.geometries = {};
                        serializationObject.geometries.boxes = [];
                        serializationObject.geometries.spheres = [];
                        serializationObject.geometries.cylinders = [];
                        serializationObject.geometries.toruses = [];
                        serializationObject.geometries.grounds = [];
                        serializationObject.geometries.planes = [];
                        serializationObject.geometries.torusKnots = [];
                        serializationObject.geometries.vertexData = [];
                    }
                    SerializeGeometry(geometry, serializationObject.geometries);
                }
                // Skeletons
                if (mesh.skeleton && !mesh.skeleton.doNotSerialize) {
                    serializationObject.skeletons = serializationObject.skeletons || [];
                    serializationObject.skeletons.push(mesh.skeleton.serialize());
                }
                //serialize the actual mesh
                serializationObject.meshes = serializationObject.meshes || [];
                serializationObject.meshes.push(SerializeMesh(mesh, serializationObject));
            }
        }
        else if (node.getClassName() === "TransformNode") {
            const transformNode = node;
            serializationObject.transformNodes.push(transformNode.serialize());
        }
        else if (node.getClassName().indexOf("Camera") !== -1) {
            const camera = node;
            serializationObject.cameras.push(camera.serialize());
        }
        else if (node.getClassName().indexOf("Light") !== -1) {
            const light = node;
            serializationObject.lights.push(light.serialize());
        }
    };
    /**
     * Class used to serialize a scene into a string
     */
    class SceneSerializer {
        /**
         * Clear cache used by a previous serialization
         */
        static ClearCache() {
            serializedGeometries = [];
        }
        /**
         * Serialize a scene into a JSON compatible object
         * Note that if the current engine does not support synchronous texture reading (like WebGPU), you should use SerializeAsync instead
         * as else you may not retrieve the proper base64 encoded texture data (when using the Texture.ForceSerializeBuffers flag)
         * @param scene defines the scene to serialize
         * @returns a JSON compatible object
         */
        static Serialize(scene) {
            return SceneSerializer._Serialize(scene);
        }
        static _Serialize(scene, checkSyncReadSupported = true) {
            const serializationObject = {};
            if (checkSyncReadSupported && !scene.getEngine()._features.supportSyncTextureRead && Texture.ForceSerializeBuffers) {
                console.warn("The serialization object may not contain the proper base64 encoded texture data! You should use the SerializeAsync method instead.");
            }
            SceneSerializer.ClearCache();
            // Scene
            serializationObject.useDelayedTextureLoading = scene.useDelayedTextureLoading;
            serializationObject.autoClear = scene.autoClear;
            serializationObject.clearColor = scene.clearColor.asArray();
            serializationObject.ambientColor = scene.ambientColor.asArray();
            serializationObject.gravity = scene.gravity.asArray();
            serializationObject.collisionsEnabled = scene.collisionsEnabled;
            serializationObject.useRightHandedSystem = scene.useRightHandedSystem;
            // Fog
            if (scene.fogMode && scene.fogMode !== 0) {
                serializationObject.fogMode = scene.fogMode;
                serializationObject.fogColor = scene.fogColor.asArray();
                serializationObject.fogStart = scene.fogStart;
                serializationObject.fogEnd = scene.fogEnd;
                serializationObject.fogDensity = scene.fogDensity;
            }
            //Physics
            if (scene.isPhysicsEnabled && scene.isPhysicsEnabled()) {
                const physicEngine = scene.getPhysicsEngine();
                if (physicEngine) {
                    serializationObject.physicsEnabled = true;
                    serializationObject.physicsGravity = physicEngine.gravity.asArray();
                    serializationObject.physicsEngine = physicEngine.getPhysicsPluginName();
                }
            }
            // Metadata
            if (scene.metadata) {
                serializationObject.metadata = scene.metadata;
            }
            // Morph targets
            serializationObject.morphTargetManagers = [];
            for (const abstractMesh of scene.meshes) {
                const manager = abstractMesh.morphTargetManager;
                if (manager) {
                    serializationObject.morphTargetManagers.push(manager.serialize());
                }
            }
            // Lights
            serializationObject.lights = [];
            let index;
            let light;
            for (index = 0; index < scene.lights.length; index++) {
                light = scene.lights[index];
                if (!light.doNotSerialize) {
                    serializationObject.lights.push(light.serialize());
                }
            }
            // Cameras
            serializationObject.cameras = [];
            for (index = 0; index < scene.cameras.length; index++) {
                const camera = scene.cameras[index];
                if (!camera.doNotSerialize) {
                    serializationObject.cameras.push(camera.serialize());
                }
            }
            if (scene.activeCamera) {
                serializationObject.activeCameraID = scene.activeCamera.id;
            }
            // Animations
            SerializationHelper.AppendSerializedAnimations(scene, serializationObject);
            // Animation Groups
            if (scene.animationGroups && scene.animationGroups.length > 0) {
                serializationObject.animationGroups = [];
                for (let animationGroupIndex = 0; animationGroupIndex < scene.animationGroups.length; animationGroupIndex++) {
                    const animationGroup = scene.animationGroups[animationGroupIndex];
                    serializationObject.animationGroups.push(animationGroup.serialize());
                }
            }
            // Reflection probes
            if (scene.reflectionProbes && scene.reflectionProbes.length > 0) {
                serializationObject.reflectionProbes = [];
                for (index = 0; index < scene.reflectionProbes.length; index++) {
                    const reflectionProbe = scene.reflectionProbes[index];
                    serializationObject.reflectionProbes.push(reflectionProbe.serialize());
                }
            }
            // Materials
            serializationObject.materials = [];
            serializationObject.multiMaterials = [];
            let material;
            for (index = 0; index < scene.materials.length; index++) {
                material = scene.materials[index];
                if (!material.doNotSerialize) {
                    serializationObject.materials.push(material.serialize());
                }
            }
            // MultiMaterials
            serializationObject.multiMaterials = [];
            for (index = 0; index < scene.multiMaterials.length; index++) {
                const multiMaterial = scene.multiMaterials[index];
                serializationObject.multiMaterials.push(multiMaterial.serialize());
            }
            // Environment texture
            if (scene.environmentTexture) {
                if (scene.environmentTexture._files) {
                    serializationObject.environmentTexture = scene.environmentTexture.serialize();
                }
                else {
                    serializationObject.environmentTexture = scene.environmentTexture.name;
                    serializationObject.environmentTextureRotationY = scene.environmentTexture.rotationY;
                }
            }
            // Environment Intensity
            serializationObject.environmentIntensity = scene.environmentIntensity;
            // Skeletons
            serializationObject.skeletons = [];
            for (index = 0; index < scene.skeletons.length; index++) {
                const skeleton = scene.skeletons[index];
                if (!skeleton.doNotSerialize) {
                    serializationObject.skeletons.push(skeleton.serialize());
                }
            }
            // Transform nodes
            serializationObject.transformNodes = [];
            for (index = 0; index < scene.transformNodes.length; index++) {
                if (!scene.transformNodes[index].doNotSerialize) {
                    serializationObject.transformNodes.push(scene.transformNodes[index].serialize());
                }
            }
            // Geometries
            serializationObject.geometries = {};
            serializationObject.geometries.boxes = [];
            serializationObject.geometries.spheres = [];
            serializationObject.geometries.cylinders = [];
            serializationObject.geometries.toruses = [];
            serializationObject.geometries.grounds = [];
            serializationObject.geometries.planes = [];
            serializationObject.geometries.torusKnots = [];
            serializationObject.geometries.vertexData = [];
            serializedGeometries = [];
            const geometries = scene.getGeometries();
            for (index = 0; index < geometries.length; index++) {
                const geometry = geometries[index];
                if (geometry.isReady()) {
                    SerializeGeometry(geometry, serializationObject.geometries);
                }
            }
            // Meshes
            serializationObject.meshes = [];
            for (index = 0; index < scene.meshes.length; index++) {
                const abstractMesh = scene.meshes[index];
                if (abstractMesh instanceof Mesh) {
                    const mesh = abstractMesh;
                    if (!mesh.doNotSerialize) {
                        if (mesh.delayLoadState === 1 || mesh.delayLoadState === 0) {
                            serializationObject.meshes.push(SerializeMesh(mesh, serializationObject));
                        }
                    }
                }
            }
            // Particles Systems
            serializationObject.particleSystems = [];
            for (index = 0; index < scene.particleSystems.length; index++) {
                serializationObject.particleSystems.push(scene.particleSystems[index].serialize(false));
            }
            // Post processes
            serializationObject.postProcesses = [];
            for (index = 0; index < scene.postProcesses.length; index++) {
                serializationObject.postProcesses.push(scene.postProcesses[index].serialize());
            }
            // Action Manager
            if (scene.actionManager) {
                serializationObject.actions = scene.actionManager.serialize("scene");
            }
            // Components
            for (const component of scene._serializableComponents) {
                component.serialize(serializationObject);
            }
            return serializationObject;
        }
        /**
         * Serialize a scene into a JSON compatible object
         * @param scene defines the scene to serialize
         * @returns a JSON promise compatible object
         */
        static SerializeAsync(scene) {
            const serializationObject = SceneSerializer._Serialize(scene, false);
            const promises = [];
            this._CollectPromises(serializationObject, promises);
            return Promise.all(promises).then(() => serializationObject);
        }
        static _CollectPromises(obj, promises) {
            if (Array.isArray(obj)) {
                for (let i = 0; i < obj.length; ++i) {
                    const o = obj[i];
                    if (o instanceof Promise) {
                        promises.push(o.then((res) => (obj[i] = res)));
                    }
                    else if (o instanceof Object || Array.isArray(o)) {
                        this._CollectPromises(o, promises);
                    }
                }
            }
            else if (obj instanceof Object) {
                for (const name in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, name)) {
                        const o = obj[name];
                        if (o instanceof Promise) {
                            promises.push(o.then((res) => (obj[name] = res)));
                        }
                        else if (o instanceof Object || Array.isArray(o)) {
                            this._CollectPromises(o, promises);
                        }
                    }
                }
            }
        }
        /**
         * Serialize a mesh into a JSON compatible object
         * @param toSerialize defines the mesh to serialize
         * @param withParents defines if parents must be serialized as well
         * @param withChildren defines if children must be serialized as well
         * @returns a JSON compatible object
         */
        static SerializeMesh(toSerialize /* Mesh || Mesh[] */, withParents = false, withChildren = false) {
            const serializationObject = {};
            serializationObject.meshes = [];
            serializationObject.transformNodes = [];
            serializationObject.cameras = [];
            serializationObject.lights = [];
            SceneSerializer.ClearCache();
            toSerialize = toSerialize instanceof Array ? toSerialize : [toSerialize];
            if (withParents || withChildren) {
                //deliberate for loop! not for each, appended should be processed as well.
                for (let i = 0; i < toSerialize.length; ++i) {
                    if (withChildren) {
                        toSerialize[i].getDescendants().forEach((node) => {
                            if (toSerialize.indexOf(node) < 0 && !node.doNotSerialize) {
                                toSerialize.push(node);
                            }
                        });
                    }
                    //make sure the array doesn't contain the object already
                    if (withParents && toSerialize[i].parent && toSerialize.indexOf(toSerialize[i].parent) < 0 && !toSerialize[i].parent.doNotSerialize) {
                        toSerialize.push(toSerialize[i].parent);
                    }
                }
            }
            toSerialize.forEach((mesh) => {
                FinalizeSingleNode(mesh, serializationObject);
            });
            return serializationObject;
        }
    }

    Scene.prototype.enableDepthRenderer = function (camera, storeNonLinearDepth = false, force32bitsFloat = false, samplingMode = 3, storeCameraSpaceZ = false) {
        camera = camera || this.activeCamera;
        if (!camera) {
            throw "No camera available to enable depth renderer";
        }
        if (!this._depthRenderer) {
            this._depthRenderer = {};
        }
        if (!this._depthRenderer[camera.id]) {
            const supportFullfloat = !!this.getEngine().getCaps().textureFloatRender;
            let textureType = 0;
            if (this.getEngine().getCaps().textureHalfFloatRender && (!force32bitsFloat || !supportFullfloat)) {
                textureType = 2;
            }
            else if (supportFullfloat) {
                textureType = 1;
            }
            else {
                textureType = 0;
            }
            this._depthRenderer[camera.id] = new DepthRenderer(this, textureType, camera, storeNonLinearDepth, samplingMode, storeCameraSpaceZ);
        }
        return this._depthRenderer[camera.id];
    };
    Scene.prototype.disableDepthRenderer = function (camera) {
        camera = camera || this.activeCamera;
        if (!camera || !this._depthRenderer || !this._depthRenderer[camera.id]) {
            return;
        }
        this._depthRenderer[camera.id].dispose();
    };
    /**
     * Defines the Depth Renderer scene component responsible to manage a depth buffer useful
     * in several rendering techniques.
     */
    class DepthRendererSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_DEPTHRENDERER;
            this.scene = scene;
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_DEPTHRENDERER, this, this._gatherRenderTargets);
            this.scene._gatherActiveCameraRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERACTIVECAMERARENDERTARGETS_DEPTHRENDERER, this, this._gatherActiveCameraRenderTargets);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Nothing to do for this component
        }
        /**
         * Disposes the component and the associated resources
         */
        dispose() {
            for (const key in this.scene._depthRenderer) {
                this.scene._depthRenderer[key].dispose();
            }
        }
        _gatherRenderTargets(renderTargets) {
            if (this.scene._depthRenderer) {
                for (const key in this.scene._depthRenderer) {
                    const depthRenderer = this.scene._depthRenderer[key];
                    if (depthRenderer.enabled && !depthRenderer.useOnlyInActiveCamera) {
                        renderTargets.push(depthRenderer.getDepthMap());
                    }
                }
            }
        }
        _gatherActiveCameraRenderTargets(renderTargets) {
            if (this.scene._depthRenderer) {
                for (const key in this.scene._depthRenderer) {
                    const depthRenderer = this.scene._depthRenderer[key];
                    if (depthRenderer.enabled && depthRenderer.useOnlyInActiveCamera && this.scene.activeCamera.id === key) {
                        renderTargets.push(depthRenderer.getDepthMap());
                    }
                }
            }
        }
    }
    DepthRenderer._SceneComponentInitialization = (scene) => {
        // Register the G Buffer component to the scene.
        let component = scene._getComponent(SceneComponentConstants.NAME_DEPTHRENDERER);
        if (!component) {
            component = new DepthRendererSceneComponent(scene);
            scene._addComponent(component);
        }
    };

    // Do not edit.
    const name$2h = "linePixelShader";
    const shader$2h = `#include<clipPlaneFragmentDeclaration>
uniform vec4 color;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2h] = shader$2h;

    // Do not edit.
    const name$2i = "lineVertexShader";
    const shader$2i = `#include<instancesDeclaration>
#include<clipPlaneVertexDeclaration>
attribute vec3 position;attribute vec4 normal;uniform mat4 viewProjection;uniform float width;uniform float aspectRatio;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
mat4 worldViewProjection=viewProjection*finalWorld;vec4 viewPosition=worldViewProjection*vec4(position,1.0);vec4 viewPositionNext=worldViewProjection*vec4(normal.xyz,1.0);vec2 currentScreen=viewPosition.xy/viewPosition.w;vec2 nextScreen=viewPositionNext.xy/viewPositionNext.w;currentScreen.x*=aspectRatio;nextScreen.x*=aspectRatio;vec2 dir=normalize(nextScreen-currentScreen);vec2 normalDir=vec2(-dir.y,dir.x);normalDir*=width/2.0;normalDir.x/=aspectRatio;vec4 offset=vec4(normalDir*normal.w,0.0,0.0);gl_Position=viewPosition+offset;
#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
vec4 worldPos=finalWorld*vec4(position,1.0);
#include<clipPlaneVertex>
#endif
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2i] = shader$2i;

    AbstractMesh.prototype.disableEdgesRendering = function () {
        if (this._edgesRenderer) {
            this._edgesRenderer.dispose();
            this._edgesRenderer = null;
        }
        return this;
    };
    AbstractMesh.prototype.enableEdgesRendering = function (epsilon = 0.95, checkVerticesInsteadOfIndices = false, options) {
        this.disableEdgesRendering();
        this._edgesRenderer = new EdgesRenderer(this, epsilon, checkVerticesInsteadOfIndices, true, options);
        return this;
    };
    Object.defineProperty(AbstractMesh.prototype, "edgesRenderer", {
        get: function () {
            return this._edgesRenderer;
        },
        enumerable: true,
        configurable: true,
    });
    LinesMesh.prototype.enableEdgesRendering = function (epsilon = 0.95, checkVerticesInsteadOfIndices = false) {
        this.disableEdgesRendering();
        this._edgesRenderer = new LineEdgesRenderer(this, epsilon, checkVerticesInsteadOfIndices);
        return this;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    InstancedLinesMesh.prototype.enableEdgesRendering = function (epsilon = 0.95, checkVerticesInsteadOfIndices = false) {
        LinesMesh.prototype.enableEdgesRendering.apply(this, arguments);
        return this;
    };
    /**
     * FaceAdjacencies Helper class to generate edges
     */
    class FaceAdjacencies {
        constructor() {
            this.edges = new Array();
            this.edgesConnectedCount = 0;
        }
    }
    /**
     * This class is used to generate edges of the mesh that could then easily be rendered in a scene.
     */
    class EdgesRenderer {
        /** Gets the vertices generated by the edge renderer */
        get linesPositions() {
            return this._linesPositions;
        }
        /** Gets the normals generated by the edge renderer */
        get linesNormals() {
            return this._linesNormals;
        }
        /** Gets the indices generated by the edge renderer */
        get linesIndices() {
            return this._linesIndices;
        }
        /**
         * Gets or sets the shader used to draw the lines
         */
        get lineShader() {
            return this._lineShader;
        }
        set lineShader(shader) {
            this._lineShader = shader;
        }
        static _GetShader(scene) {
            if (!scene._edgeRenderLineShader) {
                const shader = new ShaderMaterial("lineShader", scene, "line", {
                    attributes: ["position", "normal"],
                    uniforms: ["world", "viewProjection", "color", "width", "aspectRatio"],
                }, false);
                shader.disableDepthWrite = true;
                shader.backFaceCulling = false;
                shader.checkReadyOnEveryCall = scene.getEngine().isWebGPU;
                scene._edgeRenderLineShader = shader;
            }
            return scene._edgeRenderLineShader;
        }
        /**
         * Creates an instance of the EdgesRenderer. It is primarily use to display edges of a mesh.
         * Beware when you use this class with complex objects as the adjacencies computation can be really long
         * @param  source Mesh used to create edges
         * @param  epsilon sum of angles in adjacency to check for edge
         * @param  checkVerticesInsteadOfIndices bases the edges detection on vertices vs indices. Note that this parameter is not used if options.useAlternateEdgeFinder = true
         * @param  generateEdgesLines - should generate Lines or only prepare resources.
         * @param  options The options to apply when generating the edges
         */
        constructor(source, epsilon = 0.95, checkVerticesInsteadOfIndices = false, generateEdgesLines = true, options) {
            var _a;
            /**
             * Define the size of the edges with an orthographic camera
             */
            this.edgesWidthScalerForOrthographic = 1000.0;
            /**
             * Define the size of the edges with a perspective camera
             */
            this.edgesWidthScalerForPerspective = 50.0;
            this._linesPositions = new Array();
            this._linesNormals = new Array();
            this._linesIndices = new Array();
            this._buffers = {};
            this._buffersForInstances = {};
            this._checkVerticesInsteadOfIndices = false;
            /** Gets or sets a boolean indicating if the edgesRenderer is active */
            this.isEnabled = true;
            /**
             * List of instances to render in case the source mesh has instances
             */
            this.customInstances = new SmartArray(32);
            this._source = source;
            this._checkVerticesInsteadOfIndices = checkVerticesInsteadOfIndices;
            this._options = options !== null && options !== void 0 ? options : null;
            this._epsilon = epsilon;
            if (this._source.getScene().getEngine().isWebGPU) {
                this._drawWrapper = new DrawWrapper(source.getEngine());
            }
            this._prepareRessources();
            if (generateEdgesLines) {
                if ((_a = options === null || options === void 0 ? void 0 : options.useAlternateEdgeFinder) !== null && _a !== void 0 ? _a : true) {
                    this._generateEdgesLinesAlternate();
                }
                else {
                    this._generateEdgesLines();
                }
            }
            this._meshRebuildObserver = this._source.onRebuildObservable.add(() => {
                this._rebuild();
            });
            this._meshDisposeObserver = this._source.onDisposeObservable.add(() => {
                this.dispose();
            });
        }
        _prepareRessources() {
            if (this._lineShader) {
                return;
            }
            this._lineShader = EdgesRenderer._GetShader(this._source.getScene());
        }
        /** @internal */
        _rebuild() {
            let buffer = this._buffers[VertexBuffer.PositionKind];
            if (buffer) {
                buffer._rebuild();
            }
            buffer = this._buffers[VertexBuffer.NormalKind];
            if (buffer) {
                buffer._rebuild();
            }
            const scene = this._source.getScene();
            const engine = scene.getEngine();
            this._ib = engine.createIndexBuffer(this._linesIndices);
        }
        /**
         * Releases the required resources for the edges renderer
         */
        dispose() {
            var _a;
            this._source.onRebuildObservable.remove(this._meshRebuildObserver);
            this._source.onDisposeObservable.remove(this._meshDisposeObserver);
            let buffer = this._buffers[VertexBuffer.PositionKind];
            if (buffer) {
                buffer.dispose();
                this._buffers[VertexBuffer.PositionKind] = null;
            }
            buffer = this._buffers[VertexBuffer.NormalKind];
            if (buffer) {
                buffer.dispose();
                this._buffers[VertexBuffer.NormalKind] = null;
            }
            if (this._ib) {
                this._source.getScene().getEngine()._releaseBuffer(this._ib);
            }
            this._lineShader.dispose();
            (_a = this._drawWrapper) === null || _a === void 0 ? void 0 : _a.dispose();
        }
        _processEdgeForAdjacencies(pa, pb, p0, p1, p2) {
            if ((pa === p0 && pb === p1) || (pa === p1 && pb === p0)) {
                return 0;
            }
            if ((pa === p1 && pb === p2) || (pa === p2 && pb === p1)) {
                return 1;
            }
            if ((pa === p2 && pb === p0) || (pa === p0 && pb === p2)) {
                return 2;
            }
            return -1;
        }
        _processEdgeForAdjacenciesWithVertices(pa, pb, p0, p1, p2) {
            const eps = 1e-10;
            if ((pa.equalsWithEpsilon(p0, eps) && pb.equalsWithEpsilon(p1, eps)) || (pa.equalsWithEpsilon(p1, eps) && pb.equalsWithEpsilon(p0, eps))) {
                return 0;
            }
            if ((pa.equalsWithEpsilon(p1, eps) && pb.equalsWithEpsilon(p2, eps)) || (pa.equalsWithEpsilon(p2, eps) && pb.equalsWithEpsilon(p1, eps))) {
                return 1;
            }
            if ((pa.equalsWithEpsilon(p2, eps) && pb.equalsWithEpsilon(p0, eps)) || (pa.equalsWithEpsilon(p0, eps) && pb.equalsWithEpsilon(p2, eps))) {
                return 2;
            }
            return -1;
        }
        /**
         * Checks if the pair of p0 and p1 is en edge
         * @param faceIndex
         * @param edge
         * @param faceNormals
         * @param  p0
         * @param  p1
         * @private
         */
        _checkEdge(faceIndex, edge, faceNormals, p0, p1) {
            let needToCreateLine;
            if (edge === undefined) {
                needToCreateLine = true;
            }
            else {
                const dotProduct = Vector3.Dot(faceNormals[faceIndex], faceNormals[edge]);
                needToCreateLine = dotProduct < this._epsilon;
            }
            if (needToCreateLine) {
                this.createLine(p0, p1, this._linesPositions.length / 3);
            }
        }
        /**
         * push line into the position, normal and index buffer
         * @param p0
         * @param p1
         * @param offset
         * @protected
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        createLine(p0, p1, offset) {
            // Positions
            this._linesPositions.push(p0.x, p0.y, p0.z, p0.x, p0.y, p0.z, p1.x, p1.y, p1.z, p1.x, p1.y, p1.z);
            // Normals
            this._linesNormals.push(p1.x, p1.y, p1.z, -1, p1.x, p1.y, p1.z, 1, p0.x, p0.y, p0.z, -1, p0.x, p0.y, p0.z, 1);
            // Indices
            this._linesIndices.push(offset, offset + 1, offset + 2, offset, offset + 2, offset + 3);
        }
        /**
         * See https://playground.babylonjs.com/#R3JR6V#1 for a visual display of the algorithm
         * @param edgePoints
         * @param indexTriangle
         * @param indices
         * @param remapVertexIndices
         */
        _tessellateTriangle(edgePoints, indexTriangle, indices, remapVertexIndices) {
            const makePointList = (edgePoints, pointIndices, firstIndex) => {
                if (firstIndex >= 0) {
                    pointIndices.push(firstIndex);
                }
                for (let i = 0; i < edgePoints.length; ++i) {
                    pointIndices.push(edgePoints[i][0]);
                }
            };
            let startEdge = 0;
            if (edgePoints[1].length >= edgePoints[0].length && edgePoints[1].length >= edgePoints[2].length) {
                startEdge = 1;
            }
            else if (edgePoints[2].length >= edgePoints[0].length && edgePoints[2].length >= edgePoints[1].length) {
                startEdge = 2;
            }
            for (let e = 0; e < 3; ++e) {
                if (e === startEdge) {
                    edgePoints[e].sort((a, b) => (a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0));
                }
                else {
                    edgePoints[e].sort((a, b) => (a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0));
                }
            }
            const mainPointIndices = [], otherPointIndices = [];
            makePointList(edgePoints[startEdge], mainPointIndices, -1);
            const numMainPoints = mainPointIndices.length;
            for (let i = startEdge + 2; i >= startEdge + 1; --i) {
                makePointList(edgePoints[i % 3], otherPointIndices, i !== startEdge + 2 ? remapVertexIndices[indices[indexTriangle + ((i + 1) % 3)]] : -1);
            }
            const numOtherPoints = otherPointIndices.length;
            const idxMain = 0;
            const idxOther = 0;
            indices.push(remapVertexIndices[indices[indexTriangle + startEdge]], mainPointIndices[0], otherPointIndices[0]);
            indices.push(remapVertexIndices[indices[indexTriangle + ((startEdge + 1) % 3)]], otherPointIndices[numOtherPoints - 1], mainPointIndices[numMainPoints - 1]);
            const bucketIsMain = numMainPoints <= numOtherPoints;
            const bucketStep = bucketIsMain ? numMainPoints : numOtherPoints;
            const bucketLimit = bucketIsMain ? numOtherPoints : numMainPoints;
            const bucketIdxLimit = bucketIsMain ? numMainPoints - 1 : numOtherPoints - 1;
            const winding = bucketIsMain ? 0 : 1;
            let numTris = numMainPoints + numOtherPoints - 2;
            let bucketIdx = bucketIsMain ? idxMain : idxOther;
            let nbucketIdx = bucketIsMain ? idxOther : idxMain;
            const bucketPoints = bucketIsMain ? mainPointIndices : otherPointIndices;
            const nbucketPoints = bucketIsMain ? otherPointIndices : mainPointIndices;
            let bucket = 0;
            while (numTris-- > 0) {
                if (winding) {
                    indices.push(bucketPoints[bucketIdx], nbucketPoints[nbucketIdx]);
                }
                else {
                    indices.push(nbucketPoints[nbucketIdx], bucketPoints[bucketIdx]);
                }
                bucket += bucketStep;
                let lastIdx;
                if (bucket >= bucketLimit && bucketIdx < bucketIdxLimit) {
                    lastIdx = bucketPoints[++bucketIdx];
                    bucket -= bucketLimit;
                }
                else {
                    lastIdx = nbucketPoints[++nbucketIdx];
                }
                indices.push(lastIdx);
            }
            indices[indexTriangle + 0] = indices[indices.length - 3];
            indices[indexTriangle + 1] = indices[indices.length - 2];
            indices[indexTriangle + 2] = indices[indices.length - 1];
            indices.length = indices.length - 3;
        }
        _generateEdgesLinesAlternate() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const positions = this._source.getVerticesData(VertexBuffer.PositionKind);
            let indices = this._source.getIndices();
            if (!indices || !positions) {
                return;
            }
            if (!Array.isArray(indices)) {
                indices = Array.from(indices);
            }
            /**
             * Find all vertices that are at the same location (with an epsilon) and remapp them on the same vertex
             */
            const useFastVertexMerger = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.useFastVertexMerger) !== null && _b !== void 0 ? _b : true;
            const epsVertexMerge = useFastVertexMerger ? Math.round(-Math.log((_d = (_c = this._options) === null || _c === void 0 ? void 0 : _c.epsilonVertexMerge) !== null && _d !== void 0 ? _d : 1e-6) / Math.log(10)) : (_f = (_e = this._options) === null || _e === void 0 ? void 0 : _e.epsilonVertexMerge) !== null && _f !== void 0 ? _f : 1e-6;
            const remapVertexIndices = [];
            const uniquePositions = []; // list of unique index of vertices - needed for tessellation
            if (useFastVertexMerger) {
                const mapVertices = {};
                for (let v1 = 0; v1 < positions.length; v1 += 3) {
                    const x1 = positions[v1 + 0], y1 = positions[v1 + 1], z1 = positions[v1 + 2];
                    const key = x1.toFixed(epsVertexMerge) + "|" + y1.toFixed(epsVertexMerge) + "|" + z1.toFixed(epsVertexMerge);
                    if (mapVertices[key] !== undefined) {
                        remapVertexIndices.push(mapVertices[key]);
                    }
                    else {
                        const idx = v1 / 3;
                        mapVertices[key] = idx;
                        remapVertexIndices.push(idx);
                        uniquePositions.push(idx);
                    }
                }
            }
            else {
                for (let v1 = 0; v1 < positions.length; v1 += 3) {
                    const x1 = positions[v1 + 0], y1 = positions[v1 + 1], z1 = positions[v1 + 2];
                    let found = false;
                    for (let v2 = 0; v2 < v1 && !found; v2 += 3) {
                        const x2 = positions[v2 + 0], y2 = positions[v2 + 1], z2 = positions[v2 + 2];
                        if (Math.abs(x1 - x2) < epsVertexMerge && Math.abs(y1 - y2) < epsVertexMerge && Math.abs(z1 - z2) < epsVertexMerge) {
                            remapVertexIndices.push(v2 / 3);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        remapVertexIndices.push(v1 / 3);
                        uniquePositions.push(v1 / 3);
                    }
                }
            }
            if ((_g = this._options) === null || _g === void 0 ? void 0 : _g.applyTessellation) {
                /**
                 * Tessellate triangles if necessary:
                 *
                 *               A
                 *               +
                 *               |\
                 *               | \
                 *               |  \
                 *             E +   \
                 *              /|    \
                 *             / |     \
                 *            /  |      \
                 *           +---+-------+ B
                 *           D   C
                 *
                 * For the edges to be rendered correctly, the ABC triangle has to be split into ABE and BCE, else AC is considered to be an edge, whereas only AE should be.
                 *
                 * The tessellation process looks for the vertices like E that are in-between two other vertices making of an edge and create new triangles as necessary
                 */
                // First step: collect the triangles to tessellate
                const epsVertexAligned = (_j = (_h = this._options) === null || _h === void 0 ? void 0 : _h.epsilonVertexAligned) !== null && _j !== void 0 ? _j : 1e-6;
                const mustTesselate = []; // liste of triangles that must be tessellated
                for (let index = 0; index < indices.length; index += 3) {
                    // loop over all triangles
                    let triangleToTessellate;
                    for (let i = 0; i < 3; ++i) {
                        // loop over the 3 edges of the triangle
                        const p0Index = remapVertexIndices[indices[index + i]];
                        const p1Index = remapVertexIndices[indices[index + ((i + 1) % 3)]];
                        const p2Index = remapVertexIndices[indices[index + ((i + 2) % 3)]];
                        if (p0Index === p1Index) {
                            continue;
                        } // degenerated triangle - don't process
                        const p0x = positions[p0Index * 3 + 0], p0y = positions[p0Index * 3 + 1], p0z = positions[p0Index * 3 + 2];
                        const p1x = positions[p1Index * 3 + 0], p1y = positions[p1Index * 3 + 1], p1z = positions[p1Index * 3 + 2];
                        const p0p1 = Math.sqrt((p1x - p0x) * (p1x - p0x) + (p1y - p0y) * (p1y - p0y) + (p1z - p0z) * (p1z - p0z));
                        for (let v = 0; v < uniquePositions.length - 1; v++) {
                            // loop over all (unique) vertices and look for the ones that would be in-between p0 and p1
                            const vIndex = uniquePositions[v];
                            if (vIndex === p0Index || vIndex === p1Index || vIndex === p2Index) {
                                continue;
                            } // don't handle the vertex if it is a vertex of the current triangle
                            const x = positions[vIndex * 3 + 0], y = positions[vIndex * 3 + 1], z = positions[vIndex * 3 + 2];
                            const p0p = Math.sqrt((x - p0x) * (x - p0x) + (y - p0y) * (y - p0y) + (z - p0z) * (z - p0z));
                            const pp1 = Math.sqrt((x - p1x) * (x - p1x) + (y - p1y) * (y - p1y) + (z - p1z) * (z - p1z));
                            if (Math.abs(p0p + pp1 - p0p1) < epsVertexAligned) {
                                // vertices are aligned and p in-between p0 and p1 if distance(p0, p) + distance (p, p1) ~ distance(p0, p1)
                                if (!triangleToTessellate) {
                                    triangleToTessellate = {
                                        index: index,
                                        edgesPoints: [[], [], []],
                                    };
                                    mustTesselate.push(triangleToTessellate);
                                }
                                triangleToTessellate.edgesPoints[i].push([vIndex, p0p]);
                            }
                        }
                    }
                }
                // Second step: tesselate the triangles
                for (let t = 0; t < mustTesselate.length; ++t) {
                    const triangle = mustTesselate[t];
                    this._tessellateTriangle(triangle.edgesPoints, triangle.index, indices, remapVertexIndices);
                }
                mustTesselate.length = 0;
            }
            /**
             * Collect the edges to render
             */
            const edges = {};
            for (let index = 0; index < indices.length; index += 3) {
                let faceNormal;
                for (let i = 0; i < 3; ++i) {
                    let p0Index = remapVertexIndices[indices[index + i]];
                    let p1Index = remapVertexIndices[indices[index + ((i + 1) % 3)]];
                    const p2Index = remapVertexIndices[indices[index + ((i + 2) % 3)]];
                    if (p0Index === p1Index || ((p0Index === p2Index || p1Index === p2Index) && ((_k = this._options) === null || _k === void 0 ? void 0 : _k.removeDegeneratedTriangles))) {
                        continue;
                    }
                    TmpVectors.Vector3[0].copyFromFloats(positions[p0Index * 3 + 0], positions[p0Index * 3 + 1], positions[p0Index * 3 + 2]);
                    TmpVectors.Vector3[1].copyFromFloats(positions[p1Index * 3 + 0], positions[p1Index * 3 + 1], positions[p1Index * 3 + 2]);
                    TmpVectors.Vector3[2].copyFromFloats(positions[p2Index * 3 + 0], positions[p2Index * 3 + 1], positions[p2Index * 3 + 2]);
                    if (!faceNormal) {
                        TmpVectors.Vector3[1].subtractToRef(TmpVectors.Vector3[0], TmpVectors.Vector3[3]);
                        TmpVectors.Vector3[2].subtractToRef(TmpVectors.Vector3[1], TmpVectors.Vector3[4]);
                        faceNormal = Vector3.Cross(TmpVectors.Vector3[3], TmpVectors.Vector3[4]);
                        faceNormal.normalize();
                    }
                    if (p0Index > p1Index) {
                        const tmp = p0Index;
                        p0Index = p1Index;
                        p1Index = tmp;
                    }
                    const key = p0Index + "_" + p1Index;
                    const ei = edges[key];
                    if (ei) {
                        if (!ei.done) {
                            const dotProduct = Vector3.Dot(faceNormal, ei.normal);
                            if (dotProduct < this._epsilon) {
                                this.createLine(TmpVectors.Vector3[0], TmpVectors.Vector3[1], this._linesPositions.length / 3);
                            }
                            ei.done = true;
                        }
                    }
                    else {
                        edges[key] = { normal: faceNormal, done: false, index: index, i: i };
                    }
                }
            }
            for (const key in edges) {
                const ei = edges[key];
                if (!ei.done) {
                    // Orphaned edge - we must display it
                    const p0Index = remapVertexIndices[indices[ei.index + ei.i]];
                    const p1Index = remapVertexIndices[indices[ei.index + ((ei.i + 1) % 3)]];
                    TmpVectors.Vector3[0].copyFromFloats(positions[p0Index * 3 + 0], positions[p0Index * 3 + 1], positions[p0Index * 3 + 2]);
                    TmpVectors.Vector3[1].copyFromFloats(positions[p1Index * 3 + 0], positions[p1Index * 3 + 1], positions[p1Index * 3 + 2]);
                    this.createLine(TmpVectors.Vector3[0], TmpVectors.Vector3[1], this._linesPositions.length / 3);
                }
            }
            /**
             * Merge into a single mesh
             */
            const engine = this._source.getScene().getEngine();
            this._buffers[VertexBuffer.PositionKind] = new VertexBuffer(engine, this._linesPositions, VertexBuffer.PositionKind, false);
            this._buffers[VertexBuffer.NormalKind] = new VertexBuffer(engine, this._linesNormals, VertexBuffer.NormalKind, false, false, 4);
            this._buffersForInstances[VertexBuffer.PositionKind] = this._buffers[VertexBuffer.PositionKind];
            this._buffersForInstances[VertexBuffer.NormalKind] = this._buffers[VertexBuffer.NormalKind];
            this._ib = engine.createIndexBuffer(this._linesIndices);
            this._indicesCount = this._linesIndices.length;
        }
        /**
         * Generates lines edges from adjacencjes
         * @private
         */
        _generateEdgesLines() {
            const positions = this._source.getVerticesData(VertexBuffer.PositionKind);
            const indices = this._source.getIndices();
            if (!indices || !positions) {
                return;
            }
            // First let's find adjacencies
            const adjacencies = new Array();
            const faceNormals = new Array();
            let index;
            let faceAdjacencies;
            // Prepare faces
            for (index = 0; index < indices.length; index += 3) {
                faceAdjacencies = new FaceAdjacencies();
                const p0Index = indices[index];
                const p1Index = indices[index + 1];
                const p2Index = indices[index + 2];
                faceAdjacencies.p0 = new Vector3(positions[p0Index * 3], positions[p0Index * 3 + 1], positions[p0Index * 3 + 2]);
                faceAdjacencies.p1 = new Vector3(positions[p1Index * 3], positions[p1Index * 3 + 1], positions[p1Index * 3 + 2]);
                faceAdjacencies.p2 = new Vector3(positions[p2Index * 3], positions[p2Index * 3 + 1], positions[p2Index * 3 + 2]);
                const faceNormal = Vector3.Cross(faceAdjacencies.p1.subtract(faceAdjacencies.p0), faceAdjacencies.p2.subtract(faceAdjacencies.p1));
                faceNormal.normalize();
                faceNormals.push(faceNormal);
                adjacencies.push(faceAdjacencies);
            }
            // Scan
            for (index = 0; index < adjacencies.length; index++) {
                faceAdjacencies = adjacencies[index];
                for (let otherIndex = index + 1; otherIndex < adjacencies.length; otherIndex++) {
                    const otherFaceAdjacencies = adjacencies[otherIndex];
                    if (faceAdjacencies.edgesConnectedCount === 3) {
                        // Full
                        break;
                    }
                    if (otherFaceAdjacencies.edgesConnectedCount === 3) {
                        // Full
                        continue;
                    }
                    const otherP0 = indices[otherIndex * 3];
                    const otherP1 = indices[otherIndex * 3 + 1];
                    const otherP2 = indices[otherIndex * 3 + 2];
                    for (let edgeIndex = 0; edgeIndex < 3; edgeIndex++) {
                        let otherEdgeIndex = 0;
                        if (faceAdjacencies.edges[edgeIndex] !== undefined) {
                            continue;
                        }
                        switch (edgeIndex) {
                            case 0:
                                if (this._checkVerticesInsteadOfIndices) {
                                    otherEdgeIndex = this._processEdgeForAdjacenciesWithVertices(faceAdjacencies.p0, faceAdjacencies.p1, otherFaceAdjacencies.p0, otherFaceAdjacencies.p1, otherFaceAdjacencies.p2);
                                }
                                else {
                                    otherEdgeIndex = this._processEdgeForAdjacencies(indices[index * 3], indices[index * 3 + 1], otherP0, otherP1, otherP2);
                                }
                                break;
                            case 1:
                                if (this._checkVerticesInsteadOfIndices) {
                                    otherEdgeIndex = this._processEdgeForAdjacenciesWithVertices(faceAdjacencies.p1, faceAdjacencies.p2, otherFaceAdjacencies.p0, otherFaceAdjacencies.p1, otherFaceAdjacencies.p2);
                                }
                                else {
                                    otherEdgeIndex = this._processEdgeForAdjacencies(indices[index * 3 + 1], indices[index * 3 + 2], otherP0, otherP1, otherP2);
                                }
                                break;
                            case 2:
                                if (this._checkVerticesInsteadOfIndices) {
                                    otherEdgeIndex = this._processEdgeForAdjacenciesWithVertices(faceAdjacencies.p2, faceAdjacencies.p0, otherFaceAdjacencies.p0, otherFaceAdjacencies.p1, otherFaceAdjacencies.p2);
                                }
                                else {
                                    otherEdgeIndex = this._processEdgeForAdjacencies(indices[index * 3 + 2], indices[index * 3], otherP0, otherP1, otherP2);
                                }
                                break;
                        }
                        if (otherEdgeIndex === -1) {
                            continue;
                        }
                        faceAdjacencies.edges[edgeIndex] = otherIndex;
                        otherFaceAdjacencies.edges[otherEdgeIndex] = index;
                        faceAdjacencies.edgesConnectedCount++;
                        otherFaceAdjacencies.edgesConnectedCount++;
                        if (faceAdjacencies.edgesConnectedCount === 3) {
                            break;
                        }
                    }
                }
            }
            // Create lines
            for (index = 0; index < adjacencies.length; index++) {
                // We need a line when a face has no adjacency on a specific edge or if all the adjacencies has an angle greater than epsilon
                const current = adjacencies[index];
                this._checkEdge(index, current.edges[0], faceNormals, current.p0, current.p1);
                this._checkEdge(index, current.edges[1], faceNormals, current.p1, current.p2);
                this._checkEdge(index, current.edges[2], faceNormals, current.p2, current.p0);
            }
            // Merge into a single mesh
            const engine = this._source.getScene().getEngine();
            this._buffers[VertexBuffer.PositionKind] = new VertexBuffer(engine, this._linesPositions, VertexBuffer.PositionKind, false);
            this._buffers[VertexBuffer.NormalKind] = new VertexBuffer(engine, this._linesNormals, VertexBuffer.NormalKind, false, false, 4);
            this._buffersForInstances[VertexBuffer.PositionKind] = this._buffers[VertexBuffer.PositionKind];
            this._buffersForInstances[VertexBuffer.NormalKind] = this._buffers[VertexBuffer.NormalKind];
            this._ib = engine.createIndexBuffer(this._linesIndices);
            this._indicesCount = this._linesIndices.length;
        }
        /**
         * Checks whether or not the edges renderer is ready to render.
         * @returns true if ready, otherwise false.
         */
        isReady() {
            return this._lineShader.isReady(this._source, (this._source.hasInstances && this.customInstances.length > 0) || this._source.hasThinInstances);
        }
        /**
         * Renders the edges of the attached mesh,
         */
        render() {
            const scene = this._source.getScene();
            const currentDrawWrapper = this._lineShader._getDrawWrapper();
            if (this._drawWrapper) {
                this._lineShader._setDrawWrapper(this._drawWrapper);
            }
            if (!this.isReady() || !scene.activeCamera) {
                this._lineShader._setDrawWrapper(currentDrawWrapper);
                return;
            }
            const hasInstances = this._source.hasInstances && this.customInstances.length > 0;
            const useBuffersWithInstances = hasInstances || this._source.hasThinInstances;
            let instanceCount = 0;
            if (useBuffersWithInstances) {
                this._buffersForInstances["world0"] = this._source.getVertexBuffer("world0");
                this._buffersForInstances["world1"] = this._source.getVertexBuffer("world1");
                this._buffersForInstances["world2"] = this._source.getVertexBuffer("world2");
                this._buffersForInstances["world3"] = this._source.getVertexBuffer("world3");
                if (hasInstances) {
                    const instanceStorage = this._source._instanceDataStorage;
                    instanceCount = this.customInstances.length;
                    if (!instanceStorage.instancesData) {
                        if (!this._source.getScene()._activeMeshesFrozen) {
                            this.customInstances.reset();
                        }
                        return;
                    }
                    if (!instanceStorage.isFrozen) {
                        let offset = 0;
                        for (let i = 0; i < instanceCount; ++i) {
                            this.customInstances.data[i].copyToArray(instanceStorage.instancesData, offset);
                            offset += 16;
                        }
                        instanceStorage.instancesBuffer.updateDirectly(instanceStorage.instancesData, 0, instanceCount);
                    }
                }
                else {
                    instanceCount = this._source.thinInstanceCount;
                }
            }
            const engine = scene.getEngine();
            this._lineShader._preBind();
            if (this._source.edgesColor.a !== 1) {
                engine.setAlphaMode(2);
            }
            else {
                engine.setAlphaMode(0);
            }
            // VBOs
            engine.bindBuffers(useBuffersWithInstances ? this._buffersForInstances : this._buffers, this._ib, this._lineShader.getEffect());
            scene.resetCachedMaterial();
            this._lineShader.setColor4("color", this._source.edgesColor);
            if (scene.activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                this._lineShader.setFloat("width", this._source.edgesWidth / this.edgesWidthScalerForOrthographic);
            }
            else {
                this._lineShader.setFloat("width", this._source.edgesWidth / this.edgesWidthScalerForPerspective);
            }
            this._lineShader.setFloat("aspectRatio", engine.getAspectRatio(scene.activeCamera));
            this._lineShader.bind(this._source.getWorldMatrix());
            // Draw order
            engine.drawElementsType(Material.TriangleFillMode, 0, this._indicesCount, instanceCount);
            this._lineShader.unbind();
            if (useBuffersWithInstances) {
                engine.unbindInstanceAttributes();
            }
            if (!this._source.getScene()._activeMeshesFrozen) {
                this.customInstances.reset();
            }
            this._lineShader._setDrawWrapper(currentDrawWrapper);
        }
    }
    /**
     * LineEdgesRenderer for LineMeshes to remove unnecessary triangulation
     */
    class LineEdgesRenderer extends EdgesRenderer {
        /**
         * This constructor turns off auto generating edges line in Edges Renderer to make it here.
         * @param  source LineMesh used to generate edges
         * @param  epsilon not important (specified angle for edge detection)
         * @param  checkVerticesInsteadOfIndices not important for LineMesh
         */
        constructor(source, epsilon = 0.95, checkVerticesInsteadOfIndices = false) {
            super(source, epsilon, checkVerticesInsteadOfIndices, false);
            this._generateEdgesLines();
        }
        /**
         * Generate edges for each line in LinesMesh. Every Line should be rendered as edge.
         */
        _generateEdgesLines() {
            const positions = this._source.getVerticesData(VertexBuffer.PositionKind);
            const indices = this._source.getIndices();
            if (!indices || !positions) {
                return;
            }
            const p0 = TmpVectors.Vector3[0];
            const p1 = TmpVectors.Vector3[1];
            const len = indices.length - 1;
            for (let i = 0, offset = 0; i < len; i += 2, offset += 4) {
                Vector3.FromArrayToRef(positions, 3 * indices[i], p0);
                Vector3.FromArrayToRef(positions, 3 * indices[i + 1], p1);
                this.createLine(p0, p1, offset);
            }
            // Merge into a single mesh
            const engine = this._source.getScene().getEngine();
            this._buffers[VertexBuffer.PositionKind] = new VertexBuffer(engine, this._linesPositions, VertexBuffer.PositionKind, false);
            this._buffers[VertexBuffer.NormalKind] = new VertexBuffer(engine, this._linesNormals, VertexBuffer.NormalKind, false, false, 4);
            this._ib = engine.createIndexBuffer(this._linesIndices);
            this._indicesCount = this._linesIndices.length;
        }
    }

    ThinEngine.prototype.restoreSingleAttachment = function () {
        const gl = this._gl;
        this.bindAttachments([gl.BACK]);
    };
    ThinEngine.prototype.restoreSingleAttachmentForRenderTarget = function () {
        const gl = this._gl;
        this.bindAttachments([gl.COLOR_ATTACHMENT0]);
    };
    ThinEngine.prototype.buildTextureLayout = function (textureStatus) {
        const gl = this._gl;
        const result = [];
        for (let i = 0; i < textureStatus.length; i++) {
            if (textureStatus[i]) {
                result.push(gl["COLOR_ATTACHMENT" + i]);
            }
            else {
                result.push(gl.NONE);
            }
        }
        return result;
    };
    ThinEngine.prototype.bindAttachments = function (attachments) {
        const gl = this._gl;
        gl.drawBuffers(attachments);
    };
    ThinEngine.prototype.unBindMultiColorAttachmentFramebuffer = function (rtWrapper, disableGenerateMipMaps = false, onBeforeUnbind) {
        this._currentRenderTarget = null;
        // If MSAA, we need to bitblt back to main texture
        const gl = this._gl;
        const attachments = rtWrapper._attachments;
        const count = attachments.length;
        if (rtWrapper._MSAAFramebuffer) {
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, rtWrapper._MSAAFramebuffer);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, rtWrapper._framebuffer);
            for (let i = 0; i < count; i++) {
                const texture = rtWrapper.textures[i];
                for (let j = 0; j < count; j++) {
                    attachments[j] = gl.NONE;
                }
                attachments[i] = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
                gl.readBuffer(attachments[i]);
                gl.drawBuffers(attachments);
                gl.blitFramebuffer(0, 0, texture.width, texture.height, 0, 0, texture.width, texture.height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
            }
            for (let i = 0; i < count; i++) {
                attachments[i] = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
            }
            gl.drawBuffers(attachments);
        }
        for (let i = 0; i < count; i++) {
            const texture = rtWrapper.textures[i];
            if ((texture === null || texture === void 0 ? void 0 : texture.generateMipMaps) && !disableGenerateMipMaps && !texture.isCube) {
                this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
                gl.generateMipmap(gl.TEXTURE_2D);
                this._bindTextureDirectly(gl.TEXTURE_2D, null);
            }
        }
        if (onBeforeUnbind) {
            if (rtWrapper._MSAAFramebuffer) {
                // Bind the correct framebuffer
                this._bindUnboundFramebuffer(rtWrapper._framebuffer);
            }
            onBeforeUnbind();
        }
        this._bindUnboundFramebuffer(null);
    };
    ThinEngine.prototype.createMultipleRenderTarget = function (size, options, initializeBuffers = true) {
        var _a;
        let generateMipMaps = false;
        let generateDepthBuffer = true;
        let generateStencilBuffer = false;
        let generateDepthTexture = false;
        let depthTextureFormat = 15;
        let textureCount = 1;
        const defaultType = 0;
        const defaultSamplingMode = 3;
        const defaultUseSRGBBuffer = false;
        const defaultFormat = 5;
        const defaultTarget = 3553;
        let types = new Array();
        let samplingModes = new Array();
        let useSRGBBuffers = new Array();
        let formats = new Array();
        let targets = new Array();
        let faceIndex = new Array();
        let layerIndex = new Array();
        let layers = new Array();
        const rtWrapper = this._createHardwareRenderTargetWrapper(true, false, size);
        if (options !== undefined) {
            generateMipMaps = options.generateMipMaps === undefined ? false : options.generateMipMaps;
            generateDepthBuffer = options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
            generateStencilBuffer = options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
            generateDepthTexture = options.generateDepthTexture === undefined ? false : options.generateDepthTexture;
            textureCount = options.textureCount || 1;
            if (options.types) {
                types = options.types;
            }
            if (options.samplingModes) {
                samplingModes = options.samplingModes;
            }
            if (options.useSRGBBuffers) {
                useSRGBBuffers = options.useSRGBBuffers;
            }
            if (options.formats) {
                formats = options.formats;
            }
            if (options.targetTypes) {
                targets = options.targetTypes;
            }
            if (options.faceIndex) {
                faceIndex = options.faceIndex;
            }
            if (options.layerIndex) {
                layerIndex = options.layerIndex;
            }
            if (options.layerCounts) {
                layers = options.layerCounts;
            }
            if (this.webGLVersion > 1 &&
                (options.depthTextureFormat === 13 ||
                    options.depthTextureFormat === 17 ||
                    options.depthTextureFormat === 16 ||
                    options.depthTextureFormat === 14 ||
                    options.depthTextureFormat === 18)) {
                depthTextureFormat = options.depthTextureFormat;
            }
        }
        const gl = this._gl;
        // Create the framebuffer
        const framebuffer = gl.createFramebuffer();
        this._bindUnboundFramebuffer(framebuffer);
        const width = size.width || size;
        const height = size.height || size;
        const textures = [];
        const attachments = [];
        const useStencilTexture = this.webGLVersion > 1 &&
            generateDepthTexture &&
            (options.depthTextureFormat === 13 ||
                options.depthTextureFormat === 17 ||
                options.depthTextureFormat === 18);
        const depthStencilBuffer = this._setupFramebufferDepthAttachments(!useStencilTexture && generateStencilBuffer, !generateDepthTexture && generateDepthBuffer, width, height);
        rtWrapper._framebuffer = framebuffer;
        rtWrapper._depthStencilBuffer = depthStencilBuffer;
        rtWrapper._generateDepthBuffer = !generateDepthTexture && generateDepthBuffer;
        rtWrapper._generateStencilBuffer = !useStencilTexture && generateStencilBuffer;
        rtWrapper._attachments = attachments;
        for (let i = 0; i < textureCount; i++) {
            let samplingMode = samplingModes[i] || defaultSamplingMode;
            let type = types[i] || defaultType;
            let useSRGBBuffer = useSRGBBuffers[i] || defaultUseSRGBBuffer;
            const format = formats[i] || defaultFormat;
            const target = targets[i] || defaultTarget;
            const layerCount = (_a = layers[i]) !== null && _a !== void 0 ? _a : 1;
            if (type === 1 && !this._caps.textureFloatLinearFiltering) {
                // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
                samplingMode = 1;
            }
            else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) {
                // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
                samplingMode = 1;
            }
            const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
            if (type === 1 && !this._caps.textureFloat) {
                type = 0;
                Logger.Warn("Float textures are not supported. Render target forced to TEXTURETYPE_UNSIGNED_BYTE type");
            }
            useSRGBBuffer = useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU);
            const isWebGL2 = this.webGLVersion > 1;
            const attachment = gl[isWebGL2 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
            attachments.push(attachment);
            if (target === -1) {
                continue;
            }
            const texture = new InternalTexture(this, InternalTextureSource.MultiRenderTarget);
            textures[i] = texture;
            gl.activeTexture(gl["TEXTURE" + i]);
            gl.bindTexture(target, texture._hardwareTexture.underlyingResource);
            gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filters.mag);
            gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filters.min);
            gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            const internalSizedFormat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
            const internalFormat = this._getInternalFormat(format);
            const webGLTextureType = this._getWebGLTextureType(type);
            if (isWebGL2 && (target === 35866 || target === 32879)) {
                if (target === 35866) {
                    texture.is2DArray = true;
                }
                else {
                    texture.is3D = true;
                }
                texture.baseDepth = texture.depth = layerCount;
                gl.texImage3D(target, 0, internalSizedFormat, width, height, layerCount, 0, internalFormat, webGLTextureType, null);
            }
            else if (target === 34067) {
                // We have to generate all faces to complete the framebuffer
                for (let i = 0; i < 6; i++) {
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, internalSizedFormat, width, height, 0, internalFormat, webGLTextureType, null);
                }
                texture.isCube = true;
            }
            else {
                gl.texImage2D(gl.TEXTURE_2D, 0, internalSizedFormat, width, height, 0, internalFormat, webGLTextureType, null);
            }
            if (generateMipMaps) {
                gl.generateMipmap(target);
            }
            // Unbind
            this._bindTextureDirectly(target, null);
            texture.baseWidth = width;
            texture.baseHeight = height;
            texture.width = width;
            texture.height = height;
            texture.isReady = true;
            texture.samples = 1;
            texture.generateMipMaps = generateMipMaps;
            texture.samplingMode = samplingMode;
            texture.type = type;
            texture._useSRGBBuffer = useSRGBBuffer;
            texture.format = format;
            this._internalTexturesCache.push(texture);
        }
        if (generateDepthTexture && this._caps.depthTextureExtension) {
            // Depth texture
            const depthTexture = new InternalTexture(this, InternalTextureSource.Depth);
            let depthTextureType = 5;
            let glDepthTextureInternalFormat = gl.DEPTH_COMPONENT16;
            let glDepthTextureFormat = gl.DEPTH_COMPONENT;
            let glDepthTextureType = gl.UNSIGNED_SHORT;
            let glDepthTextureAttachment = gl.DEPTH_ATTACHMENT;
            if (this.webGLVersion < 2) {
                glDepthTextureInternalFormat = gl.DEPTH_COMPONENT;
            }
            else {
                if (depthTextureFormat === 14) {
                    depthTextureType = 1;
                    glDepthTextureType = gl.FLOAT;
                    glDepthTextureInternalFormat = gl.DEPTH_COMPONENT32F;
                }
                else if (depthTextureFormat === 18) {
                    depthTextureType = 0;
                    glDepthTextureType = gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
                    glDepthTextureInternalFormat = gl.DEPTH32F_STENCIL8;
                    glDepthTextureFormat = gl.DEPTH_STENCIL;
                    glDepthTextureAttachment = gl.DEPTH_STENCIL_ATTACHMENT;
                }
                else if (depthTextureFormat === 16) {
                    depthTextureType = 0;
                    glDepthTextureType = gl.UNSIGNED_INT;
                    glDepthTextureInternalFormat = gl.DEPTH_COMPONENT24;
                    glDepthTextureAttachment = gl.DEPTH_ATTACHMENT;
                }
                else if (depthTextureFormat === 13 || depthTextureFormat === 17) {
                    depthTextureType = 12;
                    glDepthTextureType = gl.UNSIGNED_INT_24_8;
                    glDepthTextureInternalFormat = gl.DEPTH24_STENCIL8;
                    glDepthTextureFormat = gl.DEPTH_STENCIL;
                    glDepthTextureAttachment = gl.DEPTH_STENCIL_ATTACHMENT;
                }
            }
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, depthTexture._hardwareTexture.underlyingResource);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texImage2D(gl.TEXTURE_2D, 0, glDepthTextureInternalFormat, width, height, 0, glDepthTextureFormat, glDepthTextureType, null);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, glDepthTextureAttachment, gl.TEXTURE_2D, depthTexture._hardwareTexture.underlyingResource, 0);
            depthTexture.baseWidth = width;
            depthTexture.baseHeight = height;
            depthTexture.width = width;
            depthTexture.height = height;
            depthTexture.isReady = true;
            depthTexture.samples = 1;
            depthTexture.generateMipMaps = generateMipMaps;
            depthTexture.samplingMode = 1;
            depthTexture.format = depthTextureFormat;
            depthTexture.type = depthTextureType;
            textures[textureCount] = depthTexture;
            this._internalTexturesCache.push(depthTexture);
        }
        rtWrapper.setTextures(textures);
        if (initializeBuffers) {
            gl.drawBuffers(attachments);
        }
        this._bindUnboundFramebuffer(null);
        rtWrapper.setLayerAndFaceIndices(layerIndex, faceIndex);
        this.resetTextureCache();
        return rtWrapper;
    };
    ThinEngine.prototype.updateMultipleRenderTargetTextureSampleCount = function (rtWrapper, samples, initializeBuffers = true) {
        if (this.webGLVersion < 2 || !rtWrapper || !rtWrapper.texture) {
            return 1;
        }
        if (rtWrapper.samples === samples) {
            return samples;
        }
        const count = rtWrapper._attachments.length;
        if (count === 0) {
            return 1;
        }
        const gl = this._gl;
        samples = Math.min(samples, this.getCaps().maxMSAASamples);
        // Dispose previous render buffers
        const useDepthStencil = !!rtWrapper._depthStencilBuffer;
        if (useDepthStencil) {
            gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
            rtWrapper._depthStencilBuffer = null;
        }
        if (rtWrapper._MSAAFramebuffer) {
            gl.deleteFramebuffer(rtWrapper._MSAAFramebuffer);
            rtWrapper._MSAAFramebuffer = null;
        }
        if (samples > 1 && typeof gl.renderbufferStorageMultisample === "function") {
            const framebuffer = gl.createFramebuffer();
            if (!framebuffer) {
                throw new Error("Unable to create multi sampled framebuffer");
            }
            rtWrapper._MSAAFramebuffer = framebuffer;
            this._bindUnboundFramebuffer(framebuffer);
            const attachments = [];
            for (let i = 0; i < count; i++) {
                const texture = rtWrapper.textures[i];
                const hardwareTexture = texture._hardwareTexture;
                hardwareTexture.releaseMSAARenderBuffers();
            }
            for (let i = 0; i < count; i++) {
                const texture = rtWrapper.textures[i];
                const hardwareTexture = texture._hardwareTexture;
                const attachment = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
                const colorRenderbuffer = this._createRenderBuffer(texture.width, texture.height, samples, -1 /* not used */, this._getRGBAMultiSampleBufferFormat(texture.type, texture.format), attachment);
                if (!colorRenderbuffer) {
                    throw new Error("Unable to create multi sampled framebuffer");
                }
                hardwareTexture.addMSAARenderBuffer(colorRenderbuffer);
                texture.samples = samples;
                attachments.push(attachment);
            }
            if (initializeBuffers) {
                gl.drawBuffers(attachments);
            }
        }
        else {
            this._bindUnboundFramebuffer(rtWrapper._framebuffer);
        }
        if (useDepthStencil) {
            rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.texture.width, rtWrapper.texture.height, samples);
        }
        this._bindUnboundFramebuffer(null);
        return samples;
    };

    /**
     * A multi render target, like a render target provides the ability to render to a texture.
     * Unlike the render target, it can render to several draw buffers in one draw.
     * This is specially interesting in deferred rendering or for any effects requiring more than
     * just one color from a single pass.
     */
    class MultiRenderTarget extends RenderTargetTexture {
        /**
         * Get if draw buffers are currently supported by the used hardware and browser.
         */
        get isSupported() {
            var _a, _b;
            return (_b = (_a = this._engine) === null || _a === void 0 ? void 0 : _a.getCaps().drawBuffersExtension) !== null && _b !== void 0 ? _b : false;
        }
        /**
         * Get the list of textures generated by the multi render target.
         */
        get textures() {
            return this._textures;
        }
        /**
         * Gets the number of textures in this MRT. This number can be different from `_textures.length` in case a depth texture is generated.
         */
        get count() {
            return this._count;
        }
        /**
         * Get the depth texture generated by the multi render target if options.generateDepthTexture has been set
         */
        get depthTexture() {
            return this._textures[this._textures.length - 1];
        }
        /**
         * Set the wrapping mode on U of all the textures we are rendering to.
         * Can be any of the Texture. (CLAMP_ADDRESSMODE, MIRROR_ADDRESSMODE or WRAP_ADDRESSMODE)
         */
        set wrapU(wrap) {
            if (this._textures) {
                for (let i = 0; i < this._textures.length; i++) {
                    this._textures[i].wrapU = wrap;
                }
            }
        }
        /**
         * Set the wrapping mode on V of all the textures we are rendering to.
         * Can be any of the Texture. (CLAMP_ADDRESSMODE, MIRROR_ADDRESSMODE or WRAP_ADDRESSMODE)
         */
        set wrapV(wrap) {
            if (this._textures) {
                for (let i = 0; i < this._textures.length; i++) {
                    this._textures[i].wrapV = wrap;
                }
            }
        }
        /**
         * Instantiate a new multi render target texture.
         * A multi render target, like a render target provides the ability to render to a texture.
         * Unlike the render target, it can render to several draw buffers in one draw.
         * This is specially interesting in deferred rendering or for any effects requiring more than
         * just one color from a single pass.
         * @param name Define the name of the texture
         * @param size Define the size of the buffers to render to
         * @param count Define the number of target we are rendering into
         * @param scene Define the scene the texture belongs to
         * @param options Define the options used to create the multi render target
         * @param textureNames Define the names to set to the textures (if count > 0 - optional)
         */
        constructor(name, size, count, scene, options, textureNames) {
            const generateMipMaps = options && options.generateMipMaps ? options.generateMipMaps : false;
            const generateDepthTexture = options && options.generateDepthTexture ? options.generateDepthTexture : false;
            const depthTextureFormat = options && options.depthTextureFormat ? options.depthTextureFormat : 15;
            const doNotChangeAspectRatio = !options || options.doNotChangeAspectRatio === undefined ? true : options.doNotChangeAspectRatio;
            const drawOnlyOnFirstAttachmentByDefault = options && options.drawOnlyOnFirstAttachmentByDefault ? options.drawOnlyOnFirstAttachmentByDefault : false;
            super(name, size, scene, generateMipMaps, doNotChangeAspectRatio, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true);
            if (!this.isSupported) {
                this.dispose();
                return;
            }
            this._textureNames = textureNames;
            const types = [];
            const samplingModes = [];
            const useSRGBBuffers = [];
            const formats = [];
            const targetTypes = [];
            const faceIndex = [];
            const layerIndex = [];
            const layerCounts = [];
            this._initTypes(count, types, samplingModes, useSRGBBuffers, formats, targetTypes, faceIndex, layerIndex, layerCounts, options);
            const generateDepthBuffer = !options || options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
            const generateStencilBuffer = !options || options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
            this._multiRenderTargetOptions = {
                samplingModes: samplingModes,
                generateMipMaps: generateMipMaps,
                generateDepthBuffer: generateDepthBuffer,
                generateStencilBuffer: generateStencilBuffer,
                generateDepthTexture: generateDepthTexture,
                depthTextureFormat: depthTextureFormat,
                types: types,
                textureCount: count,
                useSRGBBuffers: useSRGBBuffers,
                formats: formats,
                targetTypes: targetTypes,
                faceIndex: faceIndex,
                layerIndex: layerIndex,
                layerCounts: layerCounts,
            };
            this._count = count;
            this._drawOnlyOnFirstAttachmentByDefault = drawOnlyOnFirstAttachmentByDefault;
            if (count > 0) {
                this._createInternalTextures();
                this._createTextures(textureNames);
            }
        }
        _initTypes(count, types, samplingModes, useSRGBBuffers, formats, targets, faceIndex, layerIndex, layerCounts, options) {
            for (let i = 0; i < count; i++) {
                if (options && options.types && options.types[i] !== undefined) {
                    types.push(options.types[i]);
                }
                else {
                    types.push(options && options.defaultType ? options.defaultType : 0);
                }
                if (options && options.samplingModes && options.samplingModes[i] !== undefined) {
                    samplingModes.push(options.samplingModes[i]);
                }
                else {
                    samplingModes.push(Texture.BILINEAR_SAMPLINGMODE);
                }
                if (options && options.useSRGBBuffers && options.useSRGBBuffers[i] !== undefined) {
                    useSRGBBuffers.push(options.useSRGBBuffers[i]);
                }
                else {
                    useSRGBBuffers.push(false);
                }
                if (options && options.formats && options.formats[i] !== undefined) {
                    formats.push(options.formats[i]);
                }
                else {
                    formats.push(5);
                }
                if (options && options.targetTypes && options.targetTypes[i] !== undefined) {
                    targets.push(options.targetTypes[i]);
                }
                else {
                    targets.push(3553);
                }
                if (options && options.faceIndex && options.faceIndex[i] !== undefined) {
                    faceIndex.push(options.faceIndex[i]);
                }
                else {
                    faceIndex.push(0);
                }
                if (options && options.layerIndex && options.layerIndex[i] !== undefined) {
                    layerIndex.push(options.layerIndex[i]);
                }
                else {
                    layerIndex.push(0);
                }
                if (options && options.layerCounts && options.layerCounts[i] !== undefined) {
                    layerCounts.push(options.layerCounts[i]);
                }
                else {
                    layerCounts.push(1);
                }
            }
        }
        _createInternaTextureIndexMapping() {
            const mapMainInternalTexture2Index = {};
            const mapInternalTexture2MainIndex = [];
            if (!this._renderTarget) {
                return mapInternalTexture2MainIndex;
            }
            const internalTextures = this._renderTarget.textures;
            for (let i = 0; i < internalTextures.length; i++) {
                const texture = internalTextures[i];
                if (!texture) {
                    continue;
                }
                const mainIndex = mapMainInternalTexture2Index[texture.uniqueId];
                if (mainIndex !== undefined) {
                    mapInternalTexture2MainIndex[i] = mainIndex;
                }
                else {
                    mapMainInternalTexture2Index[texture.uniqueId] = i;
                }
            }
            return mapInternalTexture2MainIndex;
        }
        /**
         * @internal
         */
        _rebuild(forceFullRebuild = false, textureNames) {
            if (this._count < 1) {
                return;
            }
            const mapInternalTexture2MainIndex = this._createInternaTextureIndexMapping();
            this.releaseInternalTextures();
            this._createInternalTextures();
            if (forceFullRebuild) {
                this._releaseTextures();
                this._createTextures(textureNames);
            }
            const internalTextures = this._renderTarget.textures;
            for (let i = 0; i < internalTextures.length; i++) {
                const texture = this._textures[i];
                if (mapInternalTexture2MainIndex[i] !== undefined) {
                    this._renderTarget.setTexture(internalTextures[mapInternalTexture2MainIndex[i]], i);
                }
                texture._texture = internalTextures[i];
                if (texture._texture) {
                    texture._noMipmap = !texture._texture.useMipMaps;
                    texture._useSRGBBuffer = texture._texture._useSRGBBuffer;
                }
            }
            if (this.samples !== 1) {
                this._renderTarget.setSamples(this.samples, !this._drawOnlyOnFirstAttachmentByDefault, true);
            }
        }
        _createInternalTextures() {
            this._renderTarget = this._getEngine().createMultipleRenderTarget(this._size, this._multiRenderTargetOptions, !this._drawOnlyOnFirstAttachmentByDefault);
            this._texture = this._renderTarget.texture;
        }
        _releaseTextures() {
            if (this._textures) {
                for (let i = 0; i < this._textures.length; i++) {
                    this._textures[i]._texture = null; // internal textures are released by a call to releaseInternalTextures()
                    this._textures[i].dispose();
                }
            }
        }
        _createTextures(textureNames) {
            const internalTextures = this._renderTarget.textures;
            this._textures = [];
            for (let i = 0; i < internalTextures.length; i++) {
                const texture = new Texture(null, this.getScene());
                if (textureNames === null || textureNames === void 0 ? void 0 : textureNames[i]) {
                    texture.name = textureNames[i];
                }
                texture._texture = internalTextures[i];
                if (texture._texture) {
                    texture._noMipmap = !texture._texture.useMipMaps;
                    texture._useSRGBBuffer = texture._texture._useSRGBBuffer;
                }
                this._textures.push(texture);
            }
        }
        /**
         * Replaces an internal texture within the MRT. Useful to share textures between MultiRenderTarget.
         * @param texture The new texture to set in the MRT
         * @param index The index of the texture to replace
         * @param disposePrevious Set to true if the previous internal texture should be disposed
         */
        setInternalTexture(texture, index, disposePrevious = true) {
            var _a, _b;
            if (!this.renderTarget) {
                return;
            }
            if (index === 0) {
                this._texture = texture;
            }
            this.renderTarget.setTexture(texture, index, disposePrevious);
            if (!this.textures[index]) {
                this.textures[index] = new Texture(null, this.getScene());
                this.textures[index].name = (_b = (_a = this._textureNames) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : this.textures[index].name;
            }
            this.textures[index]._texture = texture;
            this.textures[index]._noMipmap = !texture.useMipMaps;
            this.textures[index]._useSRGBBuffer = texture._useSRGBBuffer;
            this._count = this.renderTarget.textures ? this.renderTarget.textures.length : 0;
            if (this._multiRenderTargetOptions.types) {
                this._multiRenderTargetOptions.types[index] = texture.type;
            }
            if (this._multiRenderTargetOptions.samplingModes) {
                this._multiRenderTargetOptions.samplingModes[index] = texture.samplingMode;
            }
            if (this._multiRenderTargetOptions.useSRGBBuffers) {
                this._multiRenderTargetOptions.useSRGBBuffers[index] = texture._useSRGBBuffer;
            }
            if (this._multiRenderTargetOptions.targetTypes && this._multiRenderTargetOptions.targetTypes[index] !== -1) {
                let target = 0;
                if (texture.is2DArray) {
                    target = 35866;
                }
                else if (texture.isCube) {
                    target = 34067;
                } /*else if (texture.isCubeArray) {
                    target = 3735928559;
                }*/
                else if (texture.is3D) {
                    target = 32879;
                }
                else {
                    target = 3553;
                }
                this._multiRenderTargetOptions.targetTypes[index] = target;
            }
        }
        /**
         * Changes an attached texture's face index or layer.
         * @param index The index of the texture to modify the attachment of
         * @param layerIndex The layer index of the texture to be attached to the framebuffer
         * @param faceIndex The face index of the texture to be attached to the framebuffer
         */
        setLayerAndFaceIndex(index, layerIndex = -1, faceIndex = -1) {
            if (!this.textures[index] || !this.renderTarget) {
                return;
            }
            if (this._multiRenderTargetOptions.layerIndex) {
                this._multiRenderTargetOptions.layerIndex[index] = layerIndex;
            }
            if (this._multiRenderTargetOptions.faceIndex) {
                this._multiRenderTargetOptions.faceIndex[index] = faceIndex;
            }
            this.renderTarget.setLayerAndFaceIndex(index, layerIndex, faceIndex);
        }
        /**
         * Changes every attached texture's face index or layer.
         * @param layerIndices The layer indices of the texture to be attached to the framebuffer
         * @param faceIndices The face indices of the texture to be attached to the framebuffer
         */
        setLayerAndFaceIndices(layerIndices, faceIndices) {
            if (!this.renderTarget) {
                return;
            }
            this._multiRenderTargetOptions.layerIndex = layerIndices;
            this._multiRenderTargetOptions.faceIndex = faceIndices;
            this.renderTarget.setLayerAndFaceIndices(layerIndices, faceIndices);
        }
        /**
         * Define the number of samples used if MSAA is enabled.
         */
        get samples() {
            return this._samples;
        }
        set samples(value) {
            if (this._renderTarget) {
                this._samples = this._renderTarget.setSamples(value);
            }
            else {
                // In case samples are set with 0 textures created, we must save the desired samples value
                this._samples = value;
            }
        }
        /**
         * Resize all the textures in the multi render target.
         * Be careful as it will recreate all the data in the new texture.
         * @param size Define the new size
         */
        resize(size) {
            this._processSizeParameter(size, false);
            this._rebuild(undefined, this._textureNames);
        }
        /**
         * Changes the number of render targets in this MRT
         * Be careful as it will recreate all the data in the new texture.
         * @param count new texture count
         * @param options Specifies texture types and sampling modes for new textures
         * @param textureNames Specifies the names of the textures (optional)
         */
        updateCount(count, options, textureNames) {
            this._multiRenderTargetOptions.textureCount = count;
            this._count = count;
            const types = [];
            const samplingModes = [];
            const useSRGBBuffers = [];
            const formats = [];
            const targetTypes = [];
            const faceIndex = [];
            const layerIndex = [];
            const layerCounts = [];
            this._textureNames = textureNames;
            this._initTypes(count, types, samplingModes, useSRGBBuffers, formats, targetTypes, faceIndex, layerIndex, layerCounts, options);
            this._multiRenderTargetOptions.types = types;
            this._multiRenderTargetOptions.samplingModes = samplingModes;
            this._multiRenderTargetOptions.useSRGBBuffers = useSRGBBuffers;
            this._multiRenderTargetOptions.formats = formats;
            this._multiRenderTargetOptions.targetTypes = targetTypes;
            this._multiRenderTargetOptions.faceIndex = faceIndex;
            this._multiRenderTargetOptions.layerIndex = layerIndex;
            this._multiRenderTargetOptions.layerCounts = layerCounts;
            this._rebuild(true, textureNames);
        }
        _unbindFrameBuffer(engine, faceIndex) {
            if (this._renderTarget) {
                engine.unBindMultiColorAttachmentFramebuffer(this._renderTarget, this.isCube, () => {
                    this.onAfterRenderObservable.notifyObservers(faceIndex);
                });
            }
        }
        /**
         * Dispose the render targets and their associated resources
         * @param doNotDisposeInternalTextures
         */
        dispose(doNotDisposeInternalTextures = false) {
            this._releaseTextures();
            if (!doNotDisposeInternalTextures) {
                this.releaseInternalTextures();
            }
            else {
                // Prevent internal texture dispose in super.dispose
                this._texture = null;
            }
            super.dispose();
        }
        /**
         * Release all the underlying texture used as draw buffers.
         */
        releaseInternalTextures() {
            var _a, _b;
            const internalTextures = (_a = this._renderTarget) === null || _a === void 0 ? void 0 : _a.textures;
            if (!internalTextures) {
                return;
            }
            for (let i = internalTextures.length - 1; i >= 0; i--) {
                this._textures[i]._texture = null;
            }
            (_b = this._renderTarget) === null || _b === void 0 ? void 0 : _b.dispose();
            this._renderTarget = null;
        }
    }

    // Do not edit.
    const name$2j = "mrtFragmentDeclaration";
    const shader$2j = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
layout(location=0) out vec4 glFragData[{X}];
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2j] = shader$2j;

    // Do not edit.
    const name$2k = "geometryPixelShader";
    const shader$2k = `#extension GL_EXT_draw_buffers : require
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
precision highp float;
#ifdef BUMP
varying mat4 vWorldView;varying vec3 vNormalW;
#else
varying vec3 vNormalV;
#endif
varying vec4 vViewPos;
#if defined(POSITION) || defined(BUMP)
varying vec3 vPositionW;
#endif
#ifdef VELOCITY
varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#ifdef NEED_UV
varying vec2 vUV;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#if defined(REFLECTIVITY)
#if defined(ORMTEXTURE) || defined(SPECULARGLOSSINESSTEXTURE) || defined(REFLECTIVITYTEXTURE)
uniform sampler2D reflectivitySampler;varying vec2 vReflectivityUV;
#endif
#ifdef ALBEDOTEXTURE
varying vec2 vAlbedoUV;uniform sampler2D albedoSampler;
#endif
#ifdef REFLECTIVITYCOLOR
uniform vec3 reflectivityColor;
#endif
#ifdef ALBEDOCOLOR
uniform vec3 albedoColor;
#endif
#ifdef METALLIC
uniform float metallic;
#endif
#if defined(ROUGHNESS) || defined(GLOSSINESS)
uniform float glossiness;
#endif
#endif
#if defined(ALPHATEST) && defined(NEED_UV)
uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#include<mrtFragmentDeclaration>[RENDER_TARGET_COUNT]
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<helperFunctions>
void main() {
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
vec3 normalOutput;
#ifdef BUMP
vec3 normalW=normalize(vNormalW);
#include<bumpFragment>
normalOutput=normalize(vec3(vWorldView*vec4(normalW,0.0)));
#else
normalOutput=normalize(vNormalV);
#endif
#ifdef PREPASS
#ifdef PREPASS_DEPTH
gl_FragData[DEPTH_INDEX]=vec4(vViewPos.z/vViewPos.w,0.0,0.0,1.0);
#endif
#ifdef PREPASS_NORMAL
gl_FragData[NORMAL_INDEX]=vec4(normalOutput,1.0);
#endif
#else
gl_FragData[0]=vec4(vViewPos.z/vViewPos.w,0.0,0.0,1.0);gl_FragData[1]=vec4(normalOutput,1.0);
#endif
#ifdef POSITION
gl_FragData[POSITION_INDEX]=vec4(vPositionW,1.0);
#endif
#ifdef VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[VELOCITY_INDEX]=vec4(velocity,0.0,1.0);
#endif
#ifdef REFLECTIVITY
vec4 reflectivity=vec4(0.0,0.0,0.0,1.0);
#ifdef METALLICWORKFLOW
float metal=1.0;float roughness=1.0;
#ifdef ORMTEXTURE
metal*=texture2D(reflectivitySampler,vReflectivityUV).b;roughness*=texture2D(reflectivitySampler,vReflectivityUV).g;
#endif
#ifdef METALLIC
metal*=metallic;
#endif
#ifdef ROUGHNESS
roughness*=(1.0-glossiness); 
#endif
reflectivity.a-=roughness;vec3 color=vec3(1.0);
#ifdef ALBEDOTEXTURE
color=texture2D(albedoSampler,vAlbedoUV).rgb;
#ifdef GAMMAALBEDO
color=toLinearSpace(color);
#endif
#endif
#ifdef ALBEDOCOLOR
color*=albedoColor.xyz;
#endif
reflectivity.rgb=mix(vec3(0.04),color,metal);
#else
#if defined(SPECULARGLOSSINESSTEXTURE) || defined(REFLECTIVITYTEXTURE)
reflectivity=texture2D(reflectivitySampler,vReflectivityUV);
#ifdef GAMMAREFLECTIVITYTEXTURE
reflectivity.rgb=toLinearSpace(reflectivity.rgb);
#endif
#else 
#ifdef REFLECTIVITYCOLOR
reflectivity.rgb=toLinearSpace(reflectivityColor.xyz);reflectivity.a=1.0;
#endif
#endif
#ifdef GLOSSINESSS
reflectivity.a*=glossiness; 
#endif
#endif
gl_FragData[REFLECTIVITY_INDEX]=reflectivity;
#endif
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2k] = shader$2k;

    // Do not edit.
    const name$2l = "geometryVertexDeclaration";
    const shader$2l = `uniform mat4 viewProjection;uniform mat4 view;`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2l] = shader$2l;

    // Do not edit.
    const name$2m = "geometryUboDeclaration";
    const shader$2m = `#include<sceneUboDeclaration>
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2m] = shader$2m;

    // Do not edit.
    const name$2n = "geometryVertexShader";
    const shader$2n = `precision highp float;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<instancesDeclaration>
#include<__decl__geometryVertex>
#include<clipPlaneVertexDeclaration>
attribute vec3 position;attribute vec3 normal;
#ifdef NEED_UV
varying vec2 vUV;
#ifdef ALPHATEST
uniform mat4 diffuseMatrix;
#endif
#ifdef BUMP
uniform mat4 bumpMatrix;varying vec2 vBumpUV;
#endif
#ifdef REFLECTIVITY
uniform mat4 reflectivityMatrix;uniform mat4 albedoMatrix;varying vec2 vReflectivityUV;varying vec2 vAlbedoUV;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#ifdef BUMP
varying mat4 vWorldView;
#endif
#ifdef BUMP
varying vec3 vNormalW;
#else
varying vec3 vNormalV;
#endif
varying vec4 vViewPos;
#if defined(POSITION) || defined(BUMP)
varying vec3 vPositionW;
#endif
#ifdef VELOCITY
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;vec3 normalUpdated=normal;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#if defined(VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=vec4(finalWorld*vec4(positionUpdated,1.0));
#ifdef BUMP
vWorldView=view*finalWorld;vNormalW=normalUpdated;
#else
vNormalV=normalize(vec3((view*finalWorld)*vec4(normalUpdated,0.0)));
#endif
vViewPos=view*worldPos;
#if defined(VELOCITY) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
#if defined(POSITION) || defined(BUMP)
vPositionW=worldPos.xyz/worldPos.w;
#endif
gl_Position=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#include<clipPlaneVertex>
#ifdef NEED_UV
#ifdef UV1
#if defined(ALPHATEST) && defined(ALPHATEST_UV1)
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#else
vUV=uv;
#endif
#ifdef BUMP_UV1
vBumpUV=vec2(bumpMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef REFLECTIVITY_UV1
vReflectivityUV=vec2(reflectivityMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef ALBEDO_UV1
vAlbedoUV=vec2(albedoMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#endif
#ifdef UV2
#if defined(ALPHATEST) && defined(ALPHATEST_UV2)
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#else
vUV=uv2;
#endif
#ifdef BUMP_UV2
vBumpUV=vec2(bumpMatrix*vec4(uv2,1.0,0.0));
#endif
#ifdef REFLECTIVITY_UV2
vReflectivityUV=vec2(reflectivityMatrix*vec4(uv2,1.0,0.0));
#endif
#ifdef ALBEDO_UV2
vAlbedoUV=vec2(albedoMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#endif
#include<bumpVertex>
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2n] = shader$2n;

    /** list the uniforms used by the geometry renderer */
    const uniforms = [
        "world",
        "mBones",
        "viewProjection",
        "diffuseMatrix",
        "view",
        "previousWorld",
        "previousViewProjection",
        "mPreviousBones",
        "bumpMatrix",
        "reflectivityMatrix",
        "albedoMatrix",
        "reflectivityColor",
        "albedoColor",
        "metallic",
        "glossiness",
        "vTangentSpaceParams",
        "vBumpInfos",
        "morphTargetInfluences",
        "morphTargetTextureInfo",
        "morphTargetTextureIndices",
    ];
    addClipPlaneUniforms(uniforms);
    /**
     * This renderer is helpful to fill one of the render target with a geometry buffer.
     */
    class GeometryBufferRenderer {
        /**
         * @internal
         * Sets up internal structures to share outputs with PrePassRenderer
         * This method should only be called by the PrePassRenderer itself
         */
        _linkPrePassRenderer(prePassRenderer) {
            this._linkedWithPrePass = true;
            this._prePassRenderer = prePassRenderer;
            if (this._multiRenderTarget) {
                // prevents clearing of the RT since it's done by prepass
                this._multiRenderTarget.onClearObservable.clear();
                this._multiRenderTarget.onClearObservable.add(() => {
                    // pass
                });
            }
        }
        /**
         * @internal
         * Separates internal structures from PrePassRenderer so the geometry buffer can now operate by itself.
         * This method should only be called by the PrePassRenderer itself
         */
        _unlinkPrePassRenderer() {
            this._linkedWithPrePass = false;
            this._createRenderTargets();
        }
        /**
         * @internal
         * Resets the geometry buffer layout
         */
        _resetLayout() {
            this._enablePosition = false;
            this._enableReflectivity = false;
            this._enableVelocity = false;
            this._attachmentsFromPrePass = [];
        }
        /**
         * @internal
         * Replaces a texture in the geometry buffer renderer
         * Useful when linking textures of the prepass renderer
         */
        _forceTextureType(geometryBufferType, index) {
            if (geometryBufferType === GeometryBufferRenderer.POSITION_TEXTURE_TYPE) {
                this._positionIndex = index;
                this._enablePosition = true;
            }
            else if (geometryBufferType === GeometryBufferRenderer.VELOCITY_TEXTURE_TYPE) {
                this._velocityIndex = index;
                this._enableVelocity = true;
            }
            else if (geometryBufferType === GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE) {
                this._reflectivityIndex = index;
                this._enableReflectivity = true;
            }
            else if (geometryBufferType === GeometryBufferRenderer.DEPTH_TEXTURE_TYPE) {
                this._depthIndex = index;
            }
            else if (geometryBufferType === GeometryBufferRenderer.NORMAL_TEXTURE_TYPE) {
                this._normalIndex = index;
            }
        }
        /**
         * @internal
         * Sets texture attachments
         * Useful when linking textures of the prepass renderer
         */
        _setAttachments(attachments) {
            this._attachmentsFromPrePass = attachments;
        }
        /**
         * @internal
         * Replaces the first texture which is hard coded as a depth texture in the geometry buffer
         * Useful when linking textures of the prepass renderer
         */
        _linkInternalTexture(internalTexture) {
            this._multiRenderTarget.setInternalTexture(internalTexture, 0, false);
        }
        /**
         * Gets the render list (meshes to be rendered) used in the G buffer.
         */
        get renderList() {
            return this._multiRenderTarget.renderList;
        }
        /**
         * Set the render list (meshes to be rendered) used in the G buffer.
         */
        set renderList(meshes) {
            this._multiRenderTarget.renderList = meshes;
        }
        /**
         * Gets whether or not G buffer are supported by the running hardware.
         * This requires draw buffer supports
         */
        get isSupported() {
            return this._multiRenderTarget.isSupported;
        }
        /**
         * Returns the index of the given texture type in the G-Buffer textures array
         * @param textureType The texture type constant. For example GeometryBufferRenderer.POSITION_TEXTURE_INDEX
         * @returns the index of the given texture type in the G-Buffer textures array
         */
        getTextureIndex(textureType) {
            switch (textureType) {
                case GeometryBufferRenderer.POSITION_TEXTURE_TYPE:
                    return this._positionIndex;
                case GeometryBufferRenderer.VELOCITY_TEXTURE_TYPE:
                    return this._velocityIndex;
                case GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE:
                    return this._reflectivityIndex;
                default:
                    return -1;
            }
        }
        /**
         * Gets a boolean indicating if objects positions are enabled for the G buffer.
         */
        get enablePosition() {
            return this._enablePosition;
        }
        /**
         * Sets whether or not objects positions are enabled for the G buffer.
         */
        set enablePosition(enable) {
            this._enablePosition = enable;
            // PrePass handles index and texture links
            if (!this._linkedWithPrePass) {
                this.dispose();
                this._createRenderTargets();
            }
        }
        /**
         * Gets a boolean indicating if objects velocities are enabled for the G buffer.
         */
        get enableVelocity() {
            return this._enableVelocity;
        }
        /**
         * Sets whether or not objects velocities are enabled for the G buffer.
         */
        set enableVelocity(enable) {
            this._enableVelocity = enable;
            if (!enable) {
                this._previousTransformationMatrices = {};
            }
            if (!this._linkedWithPrePass) {
                this.dispose();
                this._createRenderTargets();
            }
            this._scene.needsPreviousWorldMatrices = enable;
        }
        /**
         * Gets a boolean indicating if objects reflectivity are enabled in the G buffer.
         */
        get enableReflectivity() {
            return this._enableReflectivity;
        }
        /**
         * Sets whether or not objects reflectivity are enabled for the G buffer.
         * For Metallic-Roughness workflow with ORM texture, we assume that ORM texture is defined according to the default layout:
         * pbr.useRoughnessFromMetallicTextureAlpha = false;
         * pbr.useRoughnessFromMetallicTextureGreen = true;
         * pbr.useMetallnessFromMetallicTextureBlue = true;
         */
        set enableReflectivity(enable) {
            this._enableReflectivity = enable;
            if (!this._linkedWithPrePass) {
                this.dispose();
                this._createRenderTargets();
            }
        }
        /**
         * Gets the scene associated with the buffer.
         */
        get scene() {
            return this._scene;
        }
        /**
         * Gets the ratio used by the buffer during its creation.
         * How big is the buffer related to the main canvas.
         */
        get ratio() {
            return this._ratio;
        }
        /**
         * Creates a new G Buffer for the scene
         * @param scene The scene the buffer belongs to
         * @param ratio How big is the buffer related to the main canvas (default: 1)
         * @param depthFormat Format of the depth texture (default: 15)
         */
        constructor(scene, ratio = 1, depthFormat = 15) {
            /**
             * Dictionary used to store the previous transformation matrices of each rendered mesh
             * in order to compute objects velocities when enableVelocity is set to "true"
             * @internal
             */
            this._previousTransformationMatrices = {};
            /**
             * Dictionary used to store the previous bones transformation matrices of each rendered mesh
             * in order to compute objects velocities when enableVelocity is set to "true"
             * @internal
             */
            this._previousBonesTransformationMatrices = {};
            /**
             * Array used to store the ignored skinned meshes while computing velocity map (typically used by the motion blur post-process).
             * Avoids computing bones velocities and computes only mesh's velocity itself (position, rotation, scaling).
             */
            this.excludedSkinnedMeshesFromVelocity = [];
            /** Gets or sets a boolean indicating if transparent meshes should be rendered */
            this.renderTransparentMeshes = true;
            this._resizeObserver = null;
            this._enablePosition = false;
            this._enableVelocity = false;
            this._enableReflectivity = false;
            this._clearColor = new Color4(0, 0, 0, 0);
            this._clearDepthColor = new Color4(1e8, 0, 0, 1); // "infinity" value - depth in the depth texture is view.z, not a 0..1 value!
            this._positionIndex = -1;
            this._velocityIndex = -1;
            this._reflectivityIndex = -1;
            this._depthIndex = -1;
            this._normalIndex = -1;
            this._linkedWithPrePass = false;
            /**
             * If set to true (default: false), the depth texture will be cleared with the depth value corresponding to the far plane (1 in normal mode, 0 in reverse depth buffer mode)
             * If set to false, the depth texture is always cleared with 0.
             */
            this.useSpecificClearForDepthTexture = false;
            this._scene = scene;
            this._ratio = ratio;
            this._useUbo = scene.getEngine().supportsUniformBuffers;
            this._depthFormat = depthFormat;
            GeometryBufferRenderer._SceneComponentInitialization(this._scene);
            // Render target
            this._createRenderTargets();
        }
        /**
         * Checks whether everything is ready to render a submesh to the G buffer.
         * @param subMesh the submesh to check readiness for
         * @param useInstances is the mesh drawn using instance or not
         * @returns true if ready otherwise false
         */
        isReady(subMesh, useInstances) {
            const material = subMesh.getMaterial();
            if (material && material.disableDepthWrite) {
                return false;
            }
            const defines = [];
            const attribs = [VertexBuffer.PositionKind, VertexBuffer.NormalKind];
            const mesh = subMesh.getMesh();
            // Alpha test
            if (material) {
                let needUv = false;
                if (material.needAlphaTesting() && material.getAlphaTestTexture()) {
                    defines.push("#define ALPHATEST");
                    defines.push(`#define ALPHATEST_UV${material.getAlphaTestTexture().coordinatesIndex + 1}`);
                    needUv = true;
                }
                if (material.bumpTexture && MaterialFlags.BumpTextureEnabled) {
                    defines.push("#define BUMP");
                    defines.push(`#define BUMP_UV${material.bumpTexture.coordinatesIndex + 1}`);
                    needUv = true;
                }
                if (this._enableReflectivity) {
                    let metallicWorkflow = false;
                    // for PBR materials: cf. https://doc.babylonjs.com/features/featuresDeepDive/materials/using/masterPBR
                    if (material.getClassName() === "PBRMetallicRoughnessMaterial") {
                        // if it is a PBR material in MetallicRoughness Mode:
                        if (material.metallicRoughnessTexture !== null) {
                            defines.push("#define ORMTEXTURE");
                            defines.push(`#define REFLECTIVITY_UV${material.metallicRoughnessTexture.coordinatesIndex + 1}`);
                            defines.push("#define METALLICWORKFLOW");
                            needUv = true;
                            metallicWorkflow = true;
                        }
                        if (material.metallic !== null) {
                            defines.push("#define METALLIC");
                            defines.push("#define METALLICWORKFLOW");
                            metallicWorkflow = true;
                        }
                        if (material.roughness !== null) {
                            defines.push("#define ROUGHNESS");
                            defines.push("#define METALLICWORKFLOW");
                            metallicWorkflow = true;
                        }
                        if (metallicWorkflow) {
                            if (material.baseTexture !== null) {
                                defines.push("#define ALBEDOTEXTURE");
                                defines.push(`#define ALBEDO_UV${material.baseTexture.coordinatesIndex + 1}`);
                                if (material.baseTexture.gammaSpace) {
                                    defines.push("#define GAMMAALBEDO");
                                }
                                needUv = true;
                            }
                            if (material.baseColor !== null) {
                                defines.push("#define ALBEDOCOLOR");
                            }
                        }
                    }
                    else if (material.getClassName() === "PBRSpecularGlossinessMaterial") {
                        // if it is a PBR material in Specular/Glossiness Mode:
                        if (material.specularGlossinessTexture !== null) {
                            defines.push("#define SPECULARGLOSSINESSTEXTURE");
                            defines.push(`#define REFLECTIVITY_UV${material.specularGlossinessTexture.coordinatesIndex + 1}`);
                            needUv = true;
                            if (material.specularGlossinessTexture.gammaSpace) {
                                defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                            }
                        }
                        else {
                            if (material.specularColor !== null) {
                                defines.push("#define REFLECTIVITYCOLOR");
                            }
                        }
                        if (material.glossiness !== null) {
                            defines.push("#define GLOSSINESS");
                        }
                    }
                    else if (material.getClassName() === "PBRMaterial") {
                        // if it is the bigger PBRMaterial
                        if (material.metallicTexture !== null) {
                            defines.push("#define ORMTEXTURE");
                            defines.push(`#define REFLECTIVITY_UV${material.metallicTexture.coordinatesIndex + 1}`);
                            defines.push("#define METALLICWORKFLOW");
                            needUv = true;
                            metallicWorkflow = true;
                        }
                        if (material.metallic !== null) {
                            defines.push("#define METALLIC");
                            defines.push("#define METALLICWORKFLOW");
                            metallicWorkflow = true;
                        }
                        if (material.roughness !== null) {
                            defines.push("#define ROUGHNESS");
                            defines.push("#define METALLICWORKFLOW");
                            metallicWorkflow = true;
                        }
                        if (metallicWorkflow) {
                            if (material.albedoTexture !== null) {
                                defines.push("#define ALBEDOTEXTURE");
                                defines.push(`#define ALBEDO_UV${material.albedoTexture.coordinatesIndex + 1}`);
                                if (material.albedoTexture.gammaSpace) {
                                    defines.push("#define GAMMAALBEDO");
                                }
                                needUv = true;
                            }
                            if (material.albedoColor !== null) {
                                defines.push("#define ALBEDOCOLOR");
                            }
                        }
                        else {
                            // SpecularGlossiness Model
                            if (material.reflectivityTexture !== null) {
                                defines.push("#define SPECULARGLOSSINESSTEXTURE");
                                defines.push(`#define REFLECTIVITY_UV${material.reflectivityTexture.coordinatesIndex + 1}`);
                                if (material.reflectivityTexture.gammaSpace) {
                                    defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                                }
                                needUv = true;
                            }
                            else if (material.reflectivityColor !== null) {
                                defines.push("#define REFLECTIVITYCOLOR");
                            }
                            if (material.microSurface !== null) {
                                defines.push("#define GLOSSINESS");
                            }
                        }
                    }
                    else if (material.getClassName() === "StandardMaterial") {
                        // if StandardMaterial:
                        if (material.specularTexture !== null) {
                            defines.push("#define REFLECTIVITYTEXTURE");
                            defines.push(`#define REFLECTIVITY_UV${material.specularTexture.coordinatesIndex + 1}`);
                            if (material.specularTexture.gammaSpace) {
                                defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                            }
                            needUv = true;
                        }
                        if (material.specularColor !== null) {
                            defines.push("#define REFLECTIVITYCOLOR");
                        }
                    }
                }
                if (needUv) {
                    defines.push("#define NEED_UV");
                    if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                        attribs.push(VertexBuffer.UVKind);
                        defines.push("#define UV1");
                    }
                    if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind)) {
                        attribs.push(VertexBuffer.UV2Kind);
                        defines.push("#define UV2");
                    }
                }
            }
            // PrePass
            if (this._linkedWithPrePass) {
                defines.push("#define PREPASS");
                if (this._depthIndex !== -1) {
                    defines.push("#define DEPTH_INDEX " + this._depthIndex);
                    defines.push("#define PREPASS_DEPTH");
                }
                if (this._normalIndex !== -1) {
                    defines.push("#define NORMAL_INDEX " + this._normalIndex);
                    defines.push("#define PREPASS_NORMAL");
                }
            }
            // Buffers
            if (this._enablePosition) {
                defines.push("#define POSITION");
                defines.push("#define POSITION_INDEX " + this._positionIndex);
            }
            if (this._enableVelocity) {
                defines.push("#define VELOCITY");
                defines.push("#define VELOCITY_INDEX " + this._velocityIndex);
                if (this.excludedSkinnedMeshesFromVelocity.indexOf(mesh) === -1) {
                    defines.push("#define BONES_VELOCITY_ENABLED");
                }
            }
            if (this._enableReflectivity) {
                defines.push("#define REFLECTIVITY");
                defines.push("#define REFLECTIVITY_INDEX " + this._reflectivityIndex);
            }
            // Bones
            if (mesh.useBones && mesh.computeBonesUsingShaders) {
                attribs.push(VertexBuffer.MatricesIndicesKind);
                attribs.push(VertexBuffer.MatricesWeightsKind);
                if (mesh.numBoneInfluencers > 4) {
                    attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                    attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                }
                defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                defines.push("#define BonesPerMesh " + (mesh.skeleton ? mesh.skeleton.bones.length + 1 : 0));
            }
            else {
                defines.push("#define NUM_BONE_INFLUENCERS 0");
            }
            // Morph targets
            const morphTargetManager = mesh.morphTargetManager;
            let numMorphInfluencers = 0;
            if (morphTargetManager) {
                if (morphTargetManager.numInfluencers > 0) {
                    numMorphInfluencers = morphTargetManager.numInfluencers;
                    defines.push("#define MORPHTARGETS");
                    defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
                    if (morphTargetManager.isUsingTextureForTargets) {
                        defines.push("#define MORPHTARGETS_TEXTURE");
                    }
                    MaterialHelper.PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, numMorphInfluencers);
                }
            }
            // Instances
            if (useInstances) {
                defines.push("#define INSTANCES");
                MaterialHelper.PushAttributesForInstances(attribs, this._enableVelocity);
                if (subMesh.getRenderingMesh().hasThinInstances) {
                    defines.push("#define THIN_INSTANCES");
                }
            }
            // Setup textures count
            if (this._linkedWithPrePass) {
                defines.push("#define RENDER_TARGET_COUNT " + this._attachmentsFromPrePass.length);
            }
            else {
                defines.push("#define RENDER_TARGET_COUNT " + this._multiRenderTarget.textures.length);
            }
            prepareStringDefinesForClipPlanes(material, this._scene, defines);
            // Get correct effect
            const engine = this._scene.getEngine();
            const drawWrapper = subMesh._getDrawWrapper(undefined, true);
            const cachedDefines = drawWrapper.defines;
            const join = defines.join("\n");
            if (cachedDefines !== join) {
                drawWrapper.setEffect(engine.createEffect("geometry", {
                    attributes: attribs,
                    uniformsNames: uniforms,
                    samplers: ["diffuseSampler", "bumpSampler", "reflectivitySampler", "albedoSampler", "morphTargets"],
                    defines: join,
                    onCompiled: null,
                    fallbacks: null,
                    onError: null,
                    uniformBuffersNames: ["Scene"],
                    indexParameters: { buffersCount: this._multiRenderTarget.textures.length - 1, maxSimultaneousMorphTargets: numMorphInfluencers },
                }, engine), join);
            }
            return drawWrapper.effect.isReady();
        }
        /**
         * Gets the current underlying G Buffer.
         * @returns the buffer
         */
        getGBuffer() {
            return this._multiRenderTarget;
        }
        /**
         * Gets the number of samples used to render the buffer (anti aliasing).
         */
        get samples() {
            return this._multiRenderTarget.samples;
        }
        /**
         * Sets the number of samples used to render the buffer (anti aliasing).
         */
        set samples(value) {
            this._multiRenderTarget.samples = value;
        }
        /**
         * Disposes the renderer and frees up associated resources.
         */
        dispose() {
            if (this._resizeObserver) {
                const engine = this._scene.getEngine();
                engine.onResizeObservable.remove(this._resizeObserver);
                this._resizeObserver = null;
            }
            this.getGBuffer().dispose();
        }
        _assignRenderTargetIndices() {
            const textureNames = [];
            let count = 2;
            textureNames.push("gBuffer_Depth", "gBuffer_Normal");
            if (this._enablePosition) {
                this._positionIndex = count;
                count++;
                textureNames.push("gBuffer_Position");
            }
            if (this._enableVelocity) {
                this._velocityIndex = count;
                count++;
                textureNames.push("gBuffer_Velocity");
            }
            if (this._enableReflectivity) {
                this._reflectivityIndex = count;
                count++;
                textureNames.push("gBuffer_Reflectivity");
            }
            return [count, textureNames];
        }
        _createRenderTargets() {
            const engine = this._scene.getEngine();
            const [count, textureNames] = this._assignRenderTargetIndices();
            let type = 0;
            if (engine._caps.textureFloat && engine._caps.textureFloatLinearFiltering) {
                type = 1;
            }
            else if (engine._caps.textureHalfFloat && engine._caps.textureHalfFloatLinearFiltering) {
                type = 2;
            }
            this._multiRenderTarget = new MultiRenderTarget("gBuffer", { width: engine.getRenderWidth() * this._ratio, height: engine.getRenderHeight() * this._ratio }, count, this._scene, { generateMipMaps: false, generateDepthTexture: true, defaultType: type, depthTextureFormat: this._depthFormat }, textureNames.concat("gBuffer_DepthBuffer"));
            if (!this.isSupported) {
                return;
            }
            this._multiRenderTarget.wrapU = Texture.CLAMP_ADDRESSMODE;
            this._multiRenderTarget.wrapV = Texture.CLAMP_ADDRESSMODE;
            this._multiRenderTarget.refreshRate = 1;
            this._multiRenderTarget.renderParticles = false;
            this._multiRenderTarget.renderList = null;
            // Depth is always the first texture in the geometry buffer renderer!
            const layoutAttachmentsAll = [true];
            const layoutAttachmentsAllButDepth = [false];
            const layoutAttachmentsDepthOnly = [true];
            for (let i = 1; i < count; ++i) {
                layoutAttachmentsAll.push(true);
                layoutAttachmentsDepthOnly.push(false);
                layoutAttachmentsAllButDepth.push(true);
            }
            const attachmentsAll = engine.buildTextureLayout(layoutAttachmentsAll);
            const attachmentsAllButDepth = engine.buildTextureLayout(layoutAttachmentsAllButDepth);
            const attachmentsDepthOnly = engine.buildTextureLayout(layoutAttachmentsDepthOnly);
            this._multiRenderTarget.onClearObservable.add((engine) => {
                engine.bindAttachments(this.useSpecificClearForDepthTexture ? attachmentsAllButDepth : attachmentsAll);
                engine.clear(this._clearColor, true, true, true);
                if (this.useSpecificClearForDepthTexture) {
                    engine.bindAttachments(attachmentsDepthOnly);
                    engine.clear(this._clearDepthColor, true, true, true);
                }
                engine.bindAttachments(attachmentsAll);
            });
            this._resizeObserver = engine.onResizeObservable.add(() => {
                if (this._multiRenderTarget) {
                    this._multiRenderTarget.resize({ width: engine.getRenderWidth() * this._ratio, height: engine.getRenderHeight() * this._ratio });
                }
            });
            // Custom render function
            const renderSubMesh = (subMesh) => {
                const renderingMesh = subMesh.getRenderingMesh();
                const effectiveMesh = subMesh.getEffectiveMesh();
                const scene = this._scene;
                const engine = scene.getEngine();
                const material = subMesh.getMaterial();
                if (!material) {
                    return;
                }
                effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
                // Velocity
                if (this._enableVelocity && !this._previousTransformationMatrices[effectiveMesh.uniqueId]) {
                    this._previousTransformationMatrices[effectiveMesh.uniqueId] = {
                        world: Matrix.Identity(),
                        viewProjection: scene.getTransformMatrix(),
                    };
                    if (renderingMesh.skeleton) {
                        const bonesTransformations = renderingMesh.skeleton.getTransformMatrices(renderingMesh);
                        this._previousBonesTransformationMatrices[renderingMesh.uniqueId] = this._copyBonesTransformationMatrices(bonesTransformations, new Float32Array(bonesTransformations.length));
                    }
                }
                // Managing instances
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                if (batch.mustReturn) {
                    return;
                }
                const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
                const world = effectiveMesh.getWorldMatrix();
                if (this.isReady(subMesh, hardwareInstancedRendering)) {
                    const drawWrapper = subMesh._getDrawWrapper();
                    if (!drawWrapper) {
                        return;
                    }
                    const effect = drawWrapper.effect;
                    engine.enableEffect(drawWrapper);
                    if (!hardwareInstancedRendering) {
                        renderingMesh._bind(subMesh, effect, material.fillMode);
                    }
                    if (!this._useUbo) {
                        effect.setMatrix("viewProjection", scene.getTransformMatrix());
                        effect.setMatrix("view", scene.getViewMatrix());
                    }
                    else {
                        MaterialHelper.BindSceneUniformBuffer(effect, this._scene.getSceneUniformBuffer());
                        this._scene.finalizeSceneUbo();
                    }
                    let sideOrientation;
                    const instanceDataStorage = renderingMesh._instanceDataStorage;
                    if (!instanceDataStorage.isFrozen && (material.backFaceCulling || renderingMesh.overrideMaterialSideOrientation !== null)) {
                        const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
                        sideOrientation = renderingMesh.overrideMaterialSideOrientation;
                        if (sideOrientation === null) {
                            sideOrientation = material.sideOrientation;
                        }
                        if (mainDeterminant < 0) {
                            sideOrientation = sideOrientation === Material.ClockWiseSideOrientation ? Material.CounterClockWiseSideOrientation : Material.ClockWiseSideOrientation;
                        }
                    }
                    else {
                        sideOrientation = instanceDataStorage.sideOrientation;
                    }
                    material._preBind(drawWrapper, sideOrientation);
                    // Alpha test
                    if (material.needAlphaTesting()) {
                        const alphaTexture = material.getAlphaTestTexture();
                        if (alphaTexture) {
                            effect.setTexture("diffuseSampler", alphaTexture);
                            effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                        }
                    }
                    // Bump
                    if (material.bumpTexture && scene.getEngine().getCaps().standardDerivatives && MaterialFlags.BumpTextureEnabled) {
                        effect.setFloat3("vBumpInfos", material.bumpTexture.coordinatesIndex, 1.0 / material.bumpTexture.level, material.parallaxScaleBias);
                        effect.setMatrix("bumpMatrix", material.bumpTexture.getTextureMatrix());
                        effect.setTexture("bumpSampler", material.bumpTexture);
                        effect.setFloat2("vTangentSpaceParams", material.invertNormalMapX ? -1.0 : 1.0, material.invertNormalMapY ? -1.0 : 1.0);
                    }
                    // Reflectivity
                    if (this._enableReflectivity) {
                        // for PBR materials: cf. https://doc.babylonjs.com/features/featuresDeepDive/materials/using/masterPBR
                        if (material.getClassName() === "PBRMetallicRoughnessMaterial") {
                            // if it is a PBR material in MetallicRoughness Mode:
                            if (material.metallicRoughnessTexture !== null) {
                                effect.setTexture("reflectivitySampler", material.metallicRoughnessTexture);
                                effect.setMatrix("reflectivityMatrix", material.metallicRoughnessTexture.getTextureMatrix());
                            }
                            if (material.metallic !== null) {
                                effect.setFloat("metallic", material.metallic);
                            }
                            if (material.roughness !== null) {
                                effect.setFloat("glossiness", 1.0 - material.roughness);
                            }
                            if (material.baseTexture !== null) {
                                effect.setTexture("albedoSampler", material.baseTexture);
                                effect.setMatrix("albedoMatrix", material.baseTexture.getTextureMatrix());
                            }
                            if (material.baseColor !== null) {
                                effect.setColor3("albedoColor", material.baseColor);
                            }
                        }
                        else if (material.getClassName() === "PBRSpecularGlossinessMaterial") {
                            // if it is a PBR material in Specular/Glossiness Mode:
                            if (material.specularGlossinessTexture !== null) {
                                effect.setTexture("reflectivitySampler", material.specularGlossinessTexture);
                                effect.setMatrix("reflectivityMatrix", material.specularGlossinessTexture.getTextureMatrix());
                            }
                            else {
                                if (material.specularColor !== null) {
                                    effect.setColor3("reflectivityColor", material.specularColor);
                                }
                            }
                            if (material.glossiness !== null) {
                                effect.setFloat("glossiness", material.glossiness);
                            }
                        }
                        else if (material.getClassName() === "PBRMaterial") {
                            // if it is the bigger PBRMaterial
                            if (material.metallicTexture !== null) {
                                effect.setTexture("reflectivitySampler", material.metallicTexture);
                                effect.setMatrix("reflectivityMatrix", material.metallicTexture.getTextureMatrix());
                            }
                            if (material.metallic !== null) {
                                effect.setFloat("metallic", material.metallic);
                            }
                            if (material.roughness !== null) {
                                effect.setFloat("glossiness", 1.0 - material.roughness);
                            }
                            if (material.roughness !== null || material.metallic !== null || material.metallicTexture !== null) {
                                // MetallicRoughness Model
                                if (material.albedoTexture !== null) {
                                    effect.setTexture("albedoSampler", material.albedoTexture);
                                    effect.setMatrix("albedoMatrix", material.albedoTexture.getTextureMatrix());
                                }
                                if (material.albedoColor !== null) {
                                    effect.setColor3("albedoColor", material.albedoColor);
                                }
                            }
                            else {
                                // SpecularGlossiness Model
                                if (material.reflectivityTexture !== null) {
                                    effect.setTexture("reflectivitySampler", material.reflectivityTexture);
                                    effect.setMatrix("reflectivityMatrix", material.reflectivityTexture.getTextureMatrix());
                                }
                                else if (material.reflectivityColor !== null) {
                                    effect.setColor3("reflectivityColor", material.reflectivityColor);
                                }
                                if (material.microSurface !== null) {
                                    effect.setFloat("glossiness", material.microSurface);
                                }
                            }
                        }
                        else if (material.getClassName() === "StandardMaterial") {
                            // if StandardMaterial:
                            if (material.specularTexture !== null) {
                                effect.setTexture("reflectivitySampler", material.specularTexture);
                                effect.setMatrix("reflectivityMatrix", material.specularTexture.getTextureMatrix());
                            }
                            if (material.specularColor !== null) {
                                effect.setColor3("reflectivityColor", material.specularColor);
                            }
                        }
                    }
                    // Clip plane
                    bindClipPlane(effect, material, this._scene);
                    // Bones
                    if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                        effect.setMatrices("mBones", renderingMesh.skeleton.getTransformMatrices(renderingMesh));
                        if (this._enableVelocity) {
                            effect.setMatrices("mPreviousBones", this._previousBonesTransformationMatrices[renderingMesh.uniqueId]);
                        }
                    }
                    // Morph targets
                    MaterialHelper.BindMorphTargetParameters(renderingMesh, effect);
                    if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) {
                        renderingMesh.morphTargetManager._bind(effect);
                    }
                    // Velocity
                    if (this._enableVelocity) {
                        effect.setMatrix("previousWorld", this._previousTransformationMatrices[effectiveMesh.uniqueId].world);
                        effect.setMatrix("previousViewProjection", this._previousTransformationMatrices[effectiveMesh.uniqueId].viewProjection);
                    }
                    if (hardwareInstancedRendering && renderingMesh.hasThinInstances) {
                        effect.setMatrix("world", world);
                    }
                    // Draw
                    renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, w) => {
                        if (!isInstance) {
                            effect.setMatrix("world", w);
                        }
                    });
                }
                // Velocity
                if (this._enableVelocity) {
                    this._previousTransformationMatrices[effectiveMesh.uniqueId].world = world.clone();
                    this._previousTransformationMatrices[effectiveMesh.uniqueId].viewProjection = this._scene.getTransformMatrix().clone();
                    if (renderingMesh.skeleton) {
                        this._copyBonesTransformationMatrices(renderingMesh.skeleton.getTransformMatrices(renderingMesh), this._previousBonesTransformationMatrices[effectiveMesh.uniqueId]);
                    }
                }
            };
            this._multiRenderTarget.customIsReadyFunction = (mesh, refreshRate, preWarm) => {
                if ((preWarm || refreshRate === 0) && mesh.subMeshes) {
                    for (let i = 0; i < mesh.subMeshes.length; ++i) {
                        const subMesh = mesh.subMeshes[i];
                        const material = subMesh.getMaterial();
                        const renderingMesh = subMesh.getRenderingMesh();
                        if (!material) {
                            continue;
                        }
                        const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                        const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
                        if (!this.isReady(subMesh, hardwareInstancedRendering)) {
                            return false;
                        }
                    }
                }
                return true;
            };
            this._multiRenderTarget.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes) => {
                let index;
                if (this._linkedWithPrePass) {
                    if (!this._prePassRenderer.enabled) {
                        return;
                    }
                    this._scene.getEngine().bindAttachments(this._attachmentsFromPrePass);
                }
                if (depthOnlySubMeshes.length) {
                    engine.setColorWrite(false);
                    for (index = 0; index < depthOnlySubMeshes.length; index++) {
                        renderSubMesh(depthOnlySubMeshes.data[index]);
                    }
                    engine.setColorWrite(true);
                }
                for (index = 0; index < opaqueSubMeshes.length; index++) {
                    renderSubMesh(opaqueSubMeshes.data[index]);
                }
                engine.setDepthWrite(false);
                for (index = 0; index < alphaTestSubMeshes.length; index++) {
                    renderSubMesh(alphaTestSubMeshes.data[index]);
                }
                if (this.renderTransparentMeshes) {
                    for (index = 0; index < transparentSubMeshes.length; index++) {
                        renderSubMesh(transparentSubMeshes.data[index]);
                    }
                }
                engine.setDepthWrite(true);
            };
        }
        // Copies the bones transformation matrices into the target array and returns the target's reference
        _copyBonesTransformationMatrices(source, target) {
            for (let i = 0; i < source.length; i++) {
                target[i] = source[i];
            }
            return target;
        }
    }
    /**
     * Constant used to retrieve the depth texture index in the G-Buffer textures array
     * using getIndex(GeometryBufferRenderer.DEPTH_TEXTURE_INDEX)
     */
    GeometryBufferRenderer.DEPTH_TEXTURE_TYPE = 0;
    /**
     * Constant used to retrieve the normal texture index in the G-Buffer textures array
     * using getIndex(GeometryBufferRenderer.NORMAL_TEXTURE_INDEX)
     */
    GeometryBufferRenderer.NORMAL_TEXTURE_TYPE = 1;
    /**
     * Constant used to retrieve the position texture index in the G-Buffer textures array
     * using getIndex(GeometryBufferRenderer.POSITION_TEXTURE_INDEX)
     */
    GeometryBufferRenderer.POSITION_TEXTURE_TYPE = 2;
    /**
     * Constant used to retrieve the velocity texture index in the G-Buffer textures array
     * using getIndex(GeometryBufferRenderer.VELOCITY_TEXTURE_INDEX)
     */
    GeometryBufferRenderer.VELOCITY_TEXTURE_TYPE = 3;
    /**
     * Constant used to retrieve the reflectivity texture index in the G-Buffer textures array
     * using the getIndex(GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE)
     */
    GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE = 4;
    /**
     * @internal
     */
    GeometryBufferRenderer._SceneComponentInitialization = (_) => {
        throw _WarnImport("GeometryBufferRendererSceneComponent");
    };

    Object.defineProperty(Scene.prototype, "geometryBufferRenderer", {
        get: function () {
            return this._geometryBufferRenderer;
        },
        set: function (value) {
            if (value && value.isSupported) {
                this._geometryBufferRenderer = value;
            }
        },
        enumerable: true,
        configurable: true,
    });
    Scene.prototype.enableGeometryBufferRenderer = function (ratio = 1, depthFormat = 15) {
        if (this._geometryBufferRenderer) {
            return this._geometryBufferRenderer;
        }
        this._geometryBufferRenderer = new GeometryBufferRenderer(this, ratio, depthFormat);
        if (!this._geometryBufferRenderer.isSupported) {
            this._geometryBufferRenderer = null;
        }
        return this._geometryBufferRenderer;
    };
    Scene.prototype.disableGeometryBufferRenderer = function () {
        if (!this._geometryBufferRenderer) {
            return;
        }
        this._geometryBufferRenderer.dispose();
        this._geometryBufferRenderer = null;
    };
    /**
     * Defines the Geometry Buffer scene component responsible to manage a G-Buffer useful
     * in several rendering techniques.
     */
    class GeometryBufferRendererSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_GEOMETRYBUFFERRENDERER;
            this.scene = scene;
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER, this, this._gatherRenderTargets);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Nothing to do for this component
        }
        /**
         * Disposes the component and the associated resources
         */
        dispose() {
            // Nothing to do for this component
        }
        _gatherRenderTargets(renderTargets) {
            if (this.scene._geometryBufferRenderer) {
                renderTargets.push(this.scene._geometryBufferRenderer.getGBuffer());
            }
        }
    }
    GeometryBufferRenderer._SceneComponentInitialization = (scene) => {
        // Register the G Buffer component to the scene.
        let component = scene._getComponent(SceneComponentConstants.NAME_GEOMETRYBUFFERRENDERER);
        if (!component) {
            component = new GeometryBufferRendererSceneComponent(scene);
            scene._addComponent(component);
        }
    };

    // Do not edit.
    const name$2o = "outlinePixelShader";
    const shader$2o = `#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
uniform vec4 color;
#ifdef ALPHATEST
varying vec2 vUV;uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
#include<logDepthFragment>
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2o] = shader$2o;

    // Do not edit.
    const name$2p = "outlineVertexShader";
    const shader$2p = `attribute vec3 position;attribute vec3 normal;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
uniform float offset;
#include<instancesDeclaration>
uniform mat4 viewProjection;
#ifdef ALPHATEST
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;vec3 normalUpdated=normal;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
vec3 offsetPosition=positionUpdated+(normalUpdated*offset);
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(offsetPosition,1.0);gl_Position=viewProjection*worldPos;
#ifdef ALPHATEST
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2p] = shader$2p;

    /**
     * Gets the outline renderer associated with the scene
     * @returns a OutlineRenderer
     */
    Scene.prototype.getOutlineRenderer = function () {
        if (!this._outlineRenderer) {
            this._outlineRenderer = new OutlineRenderer(this);
        }
        return this._outlineRenderer;
    };
    Object.defineProperty(Mesh.prototype, "renderOutline", {
        get: function () {
            return this._renderOutline;
        },
        set: function (value) {
            if (value) {
                // Lazy Load the component.
                this.getScene().getOutlineRenderer();
            }
            this._renderOutline = value;
        },
        enumerable: true,
        configurable: true,
    });
    Object.defineProperty(Mesh.prototype, "renderOverlay", {
        get: function () {
            return this._renderOverlay;
        },
        set: function (value) {
            if (value) {
                // Lazy Load the component.
                this.getScene().getOutlineRenderer();
            }
            this._renderOverlay = value;
        },
        enumerable: true,
        configurable: true,
    });
    /**
     * This class is responsible to draw the outline/overlay of meshes.
     * It should not be used directly but through the available method on mesh.
     */
    class OutlineRenderer {
        /**
         * Instantiates a new outline renderer. (There could be only one per scene).
         * @param scene Defines the scene it belongs to
         */
        constructor(scene) {
            /**
             * The name of the component. Each component must have a unique name.
             */
            this.name = SceneComponentConstants.NAME_OUTLINERENDERER;
            /**
             * Defines a zOffset default Factor to prevent zFighting between the overlay and the mesh.
             */
            this.zOffset = 1;
            /**
             * Defines a zOffset default Unit to prevent zFighting between the overlay and the mesh.
             */
            this.zOffsetUnits = 4; // 4 to account for projection a bit by default
            this.scene = scene;
            this._engine = scene.getEngine();
            this.scene._addComponent(this);
            this._passIdForDrawWrapper = [];
            for (let i = 0; i < 4; ++i) {
                this._passIdForDrawWrapper[i] = this._engine.createRenderPassId(`Outline Renderer (${i})`);
            }
        }
        /**
         * Register the component to one instance of a scene.
         */
        register() {
            this.scene._beforeRenderingMeshStage.registerStep(SceneComponentConstants.STEP_BEFORERENDERINGMESH_OUTLINE, this, this._beforeRenderingMesh);
            this.scene._afterRenderingMeshStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERINGMESH_OUTLINE, this, this._afterRenderingMesh);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Nothing to do here.
        }
        /**
         * Disposes the component and the associated resources.
         */
        dispose() {
            for (let i = 0; i < this._passIdForDrawWrapper.length; ++i) {
                this._engine.releaseRenderPassId(this._passIdForDrawWrapper[i]);
            }
        }
        /**
         * Renders the outline in the canvas.
         * @param subMesh Defines the sumesh to render
         * @param batch Defines the batch of meshes in case of instances
         * @param useOverlay Defines if the rendering is for the overlay or the outline
         * @param renderPassId Render pass id to use to render the mesh
         */
        render(subMesh, batch, useOverlay = false, renderPassId) {
            renderPassId = renderPassId !== null && renderPassId !== void 0 ? renderPassId : this._passIdForDrawWrapper[0];
            const scene = this.scene;
            const engine = scene.getEngine();
            const hardwareInstancedRendering = engine.getCaps().instancedArrays &&
                ((batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined) || subMesh.getRenderingMesh().hasThinInstances);
            if (!this.isReady(subMesh, hardwareInstancedRendering, renderPassId)) {
                return;
            }
            const ownerMesh = subMesh.getMesh();
            const replacementMesh = ownerMesh._internalAbstractMeshDataInfo._actAsRegularMesh ? ownerMesh : null;
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = replacementMesh ? replacementMesh : renderingMesh;
            const material = subMesh.getMaterial();
            if (!material || !scene.activeCamera) {
                return;
            }
            const drawWrapper = subMesh._getDrawWrapper(renderPassId);
            const effect = DrawWrapper.GetEffect(drawWrapper);
            engine.enableEffect(drawWrapper);
            // Logarithmic depth
            if (material.useLogarithmicDepth) {
                effect.setFloat("logarithmicDepthConstant", 2.0 / (Math.log(scene.activeCamera.maxZ + 1.0) / Math.LN2));
            }
            effect.setFloat("offset", useOverlay ? 0 : renderingMesh.outlineWidth);
            effect.setColor4("color", useOverlay ? renderingMesh.overlayColor : renderingMesh.outlineColor, useOverlay ? renderingMesh.overlayAlpha : material.alpha);
            effect.setMatrix("viewProjection", scene.getTransformMatrix());
            effect.setMatrix("world", effectiveMesh.getWorldMatrix());
            // Bones
            if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                effect.setMatrices("mBones", renderingMesh.skeleton.getTransformMatrices(renderingMesh));
            }
            if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) {
                renderingMesh.morphTargetManager._bind(effect);
            }
            // Morph targets
            MaterialHelper.BindMorphTargetParameters(renderingMesh, effect);
            if (!hardwareInstancedRendering) {
                renderingMesh._bind(subMesh, effect, material.fillMode);
            }
            // Alpha test
            if (material && material.needAlphaTesting()) {
                const alphaTexture = material.getAlphaTestTexture();
                if (alphaTexture) {
                    effect.setTexture("diffuseSampler", alphaTexture);
                    effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                }
            }
            // Clip plane
            bindClipPlane(effect, material, scene);
            engine.setZOffset(-this.zOffset);
            engine.setZOffsetUnits(-this.zOffsetUnits);
            renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world) => {
                effect.setMatrix("world", world);
            });
            engine.setZOffset(0);
            engine.setZOffsetUnits(0);
        }
        /**
         * Returns whether or not the outline renderer is ready for a given submesh.
         * All the dependencies e.g. submeshes, texture, effect... mus be ready
         * @param subMesh Defines the submesh to check readiness for
         * @param useInstances Defines whether wee are trying to render instances or not
         * @param renderPassId Render pass id to use to render the mesh
         * @returns true if ready otherwise false
         */
        isReady(subMesh, useInstances, renderPassId) {
            renderPassId = renderPassId !== null && renderPassId !== void 0 ? renderPassId : this._passIdForDrawWrapper[0];
            const defines = [];
            const attribs = [VertexBuffer.PositionKind, VertexBuffer.NormalKind];
            const mesh = subMesh.getMesh();
            const material = subMesh.getMaterial();
            if (!material) {
                return false;
            }
            const scene = mesh.getScene();
            // Alpha test
            if (material.needAlphaTesting()) {
                defines.push("#define ALPHATEST");
                if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                    attribs.push(VertexBuffer.UVKind);
                    defines.push("#define UV1");
                }
                if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind)) {
                    attribs.push(VertexBuffer.UV2Kind);
                    defines.push("#define UV2");
                }
            }
            //Logarithmic depth
            if (material.useLogarithmicDepth) {
                defines.push("#define LOGARITHMICDEPTH");
            }
            // Clip planes
            prepareStringDefinesForClipPlanes(material, scene, defines);
            // Bones
            if (mesh.useBones && mesh.computeBonesUsingShaders) {
                attribs.push(VertexBuffer.MatricesIndicesKind);
                attribs.push(VertexBuffer.MatricesWeightsKind);
                if (mesh.numBoneInfluencers > 4) {
                    attribs.push(VertexBuffer.MatricesIndicesExtraKind);
                    attribs.push(VertexBuffer.MatricesWeightsExtraKind);
                }
                defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                defines.push("#define BonesPerMesh " + (mesh.skeleton ? mesh.skeleton.bones.length + 1 : 0));
            }
            else {
                defines.push("#define NUM_BONE_INFLUENCERS 0");
            }
            // Morph targets
            const morphTargetManager = mesh.morphTargetManager;
            let numMorphInfluencers = 0;
            if (morphTargetManager) {
                if (morphTargetManager.numInfluencers > 0) {
                    numMorphInfluencers = morphTargetManager.numInfluencers;
                    defines.push("#define MORPHTARGETS");
                    defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
                    if (morphTargetManager.isUsingTextureForTargets) {
                        defines.push("#define MORPHTARGETS_TEXTURE");
                    }
                    MaterialHelper.PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, numMorphInfluencers);
                }
            }
            // Instances
            if (useInstances) {
                defines.push("#define INSTANCES");
                MaterialHelper.PushAttributesForInstances(attribs);
                if (subMesh.getRenderingMesh().hasThinInstances) {
                    defines.push("#define THIN_INSTANCES");
                }
            }
            // Get correct effect
            const drawWrapper = subMesh._getDrawWrapper(renderPassId, true);
            const cachedDefines = drawWrapper.defines;
            const join = defines.join("\n");
            if (cachedDefines !== join) {
                const uniforms = [
                    "world",
                    "mBones",
                    "viewProjection",
                    "diffuseMatrix",
                    "offset",
                    "color",
                    "logarithmicDepthConstant",
                    "morphTargetInfluences",
                    "morphTargetTextureInfo",
                    "morphTargetTextureIndices",
                ];
                addClipPlaneUniforms(uniforms);
                drawWrapper.setEffect(this.scene.getEngine().createEffect("outline", attribs, uniforms, ["diffuseSampler", "morphTargets"], join, undefined, undefined, undefined, {
                    maxSimultaneousMorphTargets: numMorphInfluencers,
                }), join);
            }
            return drawWrapper.effect.isReady();
        }
        _beforeRenderingMesh(mesh, subMesh, batch) {
            // Outline - step 1
            this._savedDepthWrite = this._engine.getDepthWrite();
            if (mesh.renderOutline) {
                const material = subMesh.getMaterial();
                if (material && material.needAlphaBlendingForMesh(mesh)) {
                    this._engine.cacheStencilState();
                    // Draw only to stencil buffer for the original mesh
                    // The resulting stencil buffer will be used so the outline is not visible inside the mesh when the mesh is transparent
                    this._engine.setDepthWrite(false);
                    this._engine.setColorWrite(false);
                    this._engine.setStencilBuffer(true);
                    this._engine.setStencilOperationPass(7681);
                    this._engine.setStencilFunction(519);
                    this._engine.setStencilMask(OutlineRenderer._StencilReference);
                    this._engine.setStencilFunctionReference(OutlineRenderer._StencilReference);
                    this._engine.stencilStateComposer.useStencilGlobalOnly = true;
                    this.render(subMesh, batch, /* This sets offset to 0 */ true, this._passIdForDrawWrapper[1]);
                    this._engine.setColorWrite(true);
                    this._engine.setStencilFunction(517);
                }
                // Draw the outline using the above stencil if needed to avoid drawing within the mesh
                this._engine.setDepthWrite(false);
                this.render(subMesh, batch, false, this._passIdForDrawWrapper[0]);
                this._engine.setDepthWrite(this._savedDepthWrite);
                if (material && material.needAlphaBlendingForMesh(mesh)) {
                    this._engine.stencilStateComposer.useStencilGlobalOnly = false;
                    this._engine.restoreStencilState();
                }
            }
        }
        _afterRenderingMesh(mesh, subMesh, batch) {
            // Overlay
            if (mesh.renderOverlay) {
                const currentMode = this._engine.getAlphaMode();
                const alphaBlendState = this._engine.alphaState.alphaBlend;
                this._engine.setAlphaMode(2);
                this.render(subMesh, batch, true, this._passIdForDrawWrapper[3]);
                this._engine.setAlphaMode(currentMode);
                this._engine.setDepthWrite(this._savedDepthWrite);
                this._engine.alphaState.alphaBlend = alphaBlendState;
            }
            // Outline - step 2
            if (mesh.renderOutline && this._savedDepthWrite) {
                this._engine.setDepthWrite(true);
                this._engine.setColorWrite(false);
                this.render(subMesh, batch, false, this._passIdForDrawWrapper[2]);
                this._engine.setColorWrite(true);
            }
        }
    }
    /**
     * Stencil value used to avoid outline being seen within the mesh when the mesh is transparent
     */
    OutlineRenderer._StencilReference = 0x04;

    /**
     * A multi render target designed to render the prepass.
     * Prepass is a scene component used to render information in multiple textures
     * alongside with the scene materials rendering.
     * Note : This is an internal class, and you should NOT need to instanciate this.
     * Only the `PrePassRenderer` should instanciate this class.
     * It is more likely that you need a regular `MultiRenderTarget`
     * @internal
     */
    class PrePassRenderTarget extends MultiRenderTarget {
        constructor(name, renderTargetTexture, size, count, scene, options) {
            super(name, size, count, scene, options);
            /**
             * @internal
             */
            this._beforeCompositionPostProcesses = [];
            /**
             * @internal
             */
            this._internalTextureDirty = false;
            /**
             * Is this render target enabled for prepass rendering
             */
            this.enabled = false;
            /**
             * Render target associated with this prePassRenderTarget
             * If this is `null`, it means this prePassRenderTarget is associated with the scene
             */
            this.renderTargetTexture = null;
            this.renderTargetTexture = renderTargetTexture;
        }
        /**
         * Creates a composition effect for this RT
         * @internal
         */
        _createCompositionEffect() {
            this.imageProcessingPostProcess = new ImageProcessingPostProcess("prePassComposition", 1, null, undefined, this._engine);
            this.imageProcessingPostProcess._updateParameters();
        }
        /**
         * Checks that the size of this RT is still adapted to the desired render size.
         * @internal
         */
        _checkSize() {
            const requiredWidth = this._engine.getRenderWidth(true);
            const requiredHeight = this._engine.getRenderHeight(true);
            const width = this.getRenderWidth();
            const height = this.getRenderHeight();
            if (width !== requiredWidth || height !== requiredHeight) {
                this.resize({ width: requiredWidth, height: requiredHeight });
                this._internalTextureDirty = true;
            }
        }
        /**
         * Changes the number of render targets in this MRT
         * Be careful as it will recreate all the data in the new texture.
         * @param count new texture count
         * @param options Specifies texture types and sampling modes for new textures
         * @param textureNames Specifies the names of the textures (optional)
         */
        updateCount(count, options, textureNames) {
            super.updateCount(count, options, textureNames);
            this._internalTextureDirty = true;
        }
        /**
         * Resets the post processes chains applied to this RT.
         * @internal
         */
        _resetPostProcessChain() {
            this._beforeCompositionPostProcesses.length = 0;
        }
        /**
         * Diposes this render target
         */
        dispose() {
            const scene = this._scene;
            super.dispose();
            if (scene && scene.prePassRenderer) {
                const index = scene.prePassRenderer.renderTargets.indexOf(this);
                if (index !== -1) {
                    scene.prePassRenderer.renderTargets.splice(index, 1);
                }
            }
            if (this.imageProcessingPostProcess) {
                this.imageProcessingPostProcess.dispose();
            }
            if (this.renderTargetTexture) {
                this.renderTargetTexture._prePassRenderTarget = null;
            }
            if (this._outputPostProcess) {
                this._outputPostProcess.autoClear = true;
                this._outputPostProcess.restoreDefaultInputTexture();
            }
        }
    }

    /**
     * Renders a pre pass of the scene
     * This means every mesh in the scene will be rendered to a render target texture
     * And then this texture will be composited to the rendering canvas with post processes
     * It is necessary for effects like subsurface scattering or deferred shading
     */
    class PrePassRenderer {
        /**
         * Returns the index of a texture in the multi render target texture array.
         * @param type Texture type
         * @returns The index
         */
        getIndex(type) {
            return this._textureIndices[type];
        }
        /**
         * How many samples are used for MSAA of the scene render target
         */
        get samples() {
            return this.defaultRT.samples;
        }
        set samples(n) {
            this.defaultRT.samples = n;
        }
        /**
         * If set to true (default: false), the depth texture will be cleared with the depth value corresponding to the far plane (1 in normal mode, 0 in reverse depth buffer mode)
         * If set to false, the depth texture is always cleared with 0.
         */
        get useSpecificClearForDepthTexture() {
            return this._useSpecificClearForDepthTexture;
        }
        set useSpecificClearForDepthTexture(value) {
            if (this._useSpecificClearForDepthTexture === value) {
                return;
            }
            this._useSpecificClearForDepthTexture = value;
            this._isDirty = true;
        }
        /**
         * @returns the prepass render target for the rendering pass.
         * If we are currently rendering a render target, it returns the PrePassRenderTarget
         * associated with that render target. Otherwise, it returns the scene default PrePassRenderTarget
         */
        getRenderTarget() {
            return this._currentTarget;
        }
        /**
         * @internal
         * Managed by the scene component
         * @param prePassRenderTarget
         */
        _setRenderTarget(prePassRenderTarget) {
            var _a, _b;
            if (prePassRenderTarget) {
                this._currentTarget = prePassRenderTarget;
            }
            else {
                this._currentTarget = this.defaultRT;
                this._engine.currentRenderPassId = (_b = (_a = this._scene.activeCamera) === null || _a === void 0 ? void 0 : _a.renderPassId) !== null && _b !== void 0 ? _b : this._currentTarget.renderPassId;
            }
        }
        /**
         * Returns true if the currently rendered prePassRenderTarget is the one
         * associated with the scene.
         */
        get currentRTisSceneRT() {
            return this._currentTarget === this.defaultRT;
        }
        _refreshGeometryBufferRendererLink() {
            if (!this.doNotUseGeometryRendererFallback) {
                this._geometryBuffer = this._scene.enableGeometryBufferRenderer();
                if (!this._geometryBuffer) {
                    // Not supported
                    this.doNotUseGeometryRendererFallback = true;
                    return;
                }
                this._geometryBuffer._linkPrePassRenderer(this);
            }
            else {
                if (this._geometryBuffer) {
                    this._geometryBuffer._unlinkPrePassRenderer();
                }
                this._geometryBuffer = null;
                this._scene.disableGeometryBufferRenderer();
            }
        }
        /**
         * Indicates if the prepass is enabled
         */
        get enabled() {
            return this._enabled;
        }
        /**
         * Instantiates a prepass renderer
         * @param scene The scene
         */
        constructor(scene) {
            /**
             * To save performance, we can excluded skinned meshes from the prepass
             */
            this.excludedSkinnedMesh = [];
            /**
             * Force material to be excluded from the prepass
             * Can be useful when `useGeometryBufferFallback` is set to `true`
             * and you don't want a material to show in the effect.
             */
            this.excludedMaterials = [];
            /**
             * Number of textures in the multi render target texture where the scene is directly rendered
             */
            this.mrtCount = 0;
            this._mrtTypes = [];
            this._mrtFormats = [];
            this._mrtLayout = [];
            this._mrtNames = [];
            this._textureIndices = [];
            this._useSpecificClearForDepthTexture = false;
            this._isDirty = true;
            /**
             * Configuration for prepass effects
             */
            this._effectConfigurations = [];
            /**
             * Prevents the PrePassRenderer from using the GeometryBufferRenderer as a fallback
             */
            this.doNotUseGeometryRendererFallback = true;
            /**
             * All the render targets generated by prepass
             */
            this.renderTargets = [];
            this._clearColor = new Color4(0, 0, 0, 0);
            this._clearDepthColor = new Color4(1e8, 0, 0, 1); // "infinity" value - depth in the depth texture is view.z, not a 0..1 value!
            this._enabled = false;
            this._needsCompositionForThisPass = false;
            /**
             * Set to true to disable gamma transform in PrePass.
             * Can be useful in case you already proceed to gamma transform on a material level
             * and your post processes don't need to be in linear color space.
             */
            this.disableGammaTransform = false;
            this._scene = scene;
            this._engine = scene.getEngine();
            let type = 0;
            if (this._engine._caps.textureFloat && this._engine._caps.textureFloatLinearFiltering) {
                type = 1;
            }
            else if (this._engine._caps.textureHalfFloat && this._engine._caps.textureHalfFloatLinearFiltering) {
                type = 2;
            }
            if (type !== 1) {
                for (let i = 0; i < PrePassRenderer.TextureFormats.length; ++i) {
                    if (PrePassRenderer.TextureFormats[i].type === 1) {
                        PrePassRenderer.TextureFormats[5].type = type;
                    }
                }
            }
            PrePassRenderer._SceneComponentInitialization(this._scene);
            this.defaultRT = this._createRenderTarget("sceneprePassRT", null);
            this._currentTarget = this.defaultRT;
        }
        /**
         * Creates a new PrePassRenderTarget
         * This should be the only way to instantiate a `PrePassRenderTarget`
         * @param name Name of the `PrePassRenderTarget`
         * @param renderTargetTexture RenderTarget the `PrePassRenderTarget` will be attached to.
         * Can be `null` if the created `PrePassRenderTarget` is attached to the scene (default framebuffer).
         * @internal
         */
        _createRenderTarget(name, renderTargetTexture) {
            const rt = new PrePassRenderTarget(name, renderTargetTexture, { width: this._engine.getRenderWidth(), height: this._engine.getRenderHeight() }, 0, this._scene, {
                generateMipMaps: false,
                generateStencilBuffer: this._engine.isStencilEnable,
                defaultType: 0,
                types: [],
                drawOnlyOnFirstAttachmentByDefault: true,
            });
            this.renderTargets.push(rt);
            if (this._enabled) {
                // The pre-pass renderer is already enabled, so make sure we create the render target with the correct number of textures
                this._update();
            }
            return rt;
        }
        /**
         * Indicates if rendering a prepass is supported
         */
        get isSupported() {
            return this._scene.getEngine().getCaps().drawBuffersExtension;
        }
        /**
         * Sets the proper output textures to draw in the engine.
         * @param effect The effect that is drawn. It can be or not be compatible with drawing to several output textures.
         * @param subMesh Submesh on which the effect is applied
         */
        bindAttachmentsForEffect(effect, subMesh) {
            const material = subMesh.getMaterial();
            const isPrePassCapable = material && material.isPrePassCapable;
            const excluded = material && this.excludedMaterials.indexOf(material) !== -1;
            if (this.enabled && this._currentTarget.enabled) {
                if (effect._multiTarget && isPrePassCapable && !excluded) {
                    this._engine.bindAttachments(this._multiRenderAttachments);
                }
                else {
                    if (this._engine._currentRenderTarget) {
                        this._engine.bindAttachments(this._defaultAttachments);
                    }
                    else {
                        this._engine.restoreSingleAttachment();
                    }
                    if (this._geometryBuffer && this.currentRTisSceneRT && !excluded) {
                        this._geometryBuffer.renderList.push(subMesh.getRenderingMesh());
                    }
                }
            }
        }
        _reinitializeAttachments() {
            const multiRenderLayout = [];
            const clearLayout = [false];
            const clearDepthLayout = [false];
            const defaultLayout = [true];
            for (let i = 0; i < this.mrtCount; i++) {
                multiRenderLayout.push(true);
                if (i > 0) {
                    if (this._useSpecificClearForDepthTexture && this._mrtLayout[i] === 5) {
                        clearLayout.push(false);
                        clearDepthLayout.push(true);
                    }
                    else {
                        clearLayout.push(true);
                        clearDepthLayout.push(false);
                    }
                    defaultLayout.push(false);
                }
            }
            this._multiRenderAttachments = this._engine.buildTextureLayout(multiRenderLayout);
            this._clearAttachments = this._engine.buildTextureLayout(clearLayout);
            this._clearDepthAttachments = this._engine.buildTextureLayout(clearDepthLayout);
            this._defaultAttachments = this._engine.buildTextureLayout(defaultLayout);
        }
        _resetLayout() {
            for (let i = 0; i < PrePassRenderer.TextureFormats.length; i++) {
                this._textureIndices[PrePassRenderer.TextureFormats[i].purpose] = -1;
            }
            this._textureIndices[4] = 0;
            this._mrtLayout = [4];
            this._mrtTypes = [PrePassRenderer.TextureFormats[4].type];
            this._mrtFormats = [PrePassRenderer.TextureFormats[4].format];
            this._mrtNames = [PrePassRenderer.TextureFormats[4].name];
            this.mrtCount = 1;
        }
        _updateGeometryBufferLayout() {
            this._refreshGeometryBufferRendererLink();
            if (this._geometryBuffer) {
                this._geometryBuffer._resetLayout();
                const texturesActivated = [];
                for (let i = 0; i < this._mrtLayout.length; i++) {
                    texturesActivated.push(false);
                }
                this._geometryBuffer._linkInternalTexture(this.defaultRT.getInternalTexture());
                const matches = [
                    {
                        prePassConstant: 5,
                        geometryBufferConstant: GeometryBufferRenderer.DEPTH_TEXTURE_TYPE,
                    },
                    {
                        prePassConstant: 6,
                        geometryBufferConstant: GeometryBufferRenderer.NORMAL_TEXTURE_TYPE,
                    },
                    {
                        prePassConstant: 1,
                        geometryBufferConstant: GeometryBufferRenderer.POSITION_TEXTURE_TYPE,
                    },
                    {
                        prePassConstant: 3,
                        geometryBufferConstant: GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE,
                    },
                    {
                        prePassConstant: 2,
                        geometryBufferConstant: GeometryBufferRenderer.VELOCITY_TEXTURE_TYPE,
                    },
                ];
                // replace textures in the geometryBuffer RT
                for (let i = 0; i < matches.length; i++) {
                    const index = this._mrtLayout.indexOf(matches[i].prePassConstant);
                    if (index !== -1) {
                        this._geometryBuffer._forceTextureType(matches[i].geometryBufferConstant, index);
                        texturesActivated[index] = true;
                    }
                }
                this._geometryBuffer._setAttachments(this._engine.buildTextureLayout(texturesActivated));
            }
        }
        /**
         * Restores attachments for single texture draw.
         */
        restoreAttachments() {
            if (this.enabled && this._currentTarget.enabled && this._defaultAttachments) {
                if (this._engine._currentRenderTarget) {
                    this._engine.bindAttachments(this._defaultAttachments);
                }
                else {
                    this._engine.restoreSingleAttachment();
                }
            }
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _beforeDraw(camera, faceIndex, layer) {
            // const previousEnabled = this._enabled && this._currentTarget.enabled;
            if (this._isDirty) {
                this._update();
            }
            if (!this._enabled || !this._currentTarget.enabled) {
                return;
            }
            if (this._geometryBuffer) {
                this._geometryBuffer.renderList = [];
            }
            this._setupOutputForThisPass(this._currentTarget, camera);
        }
        _prepareFrame(prePassRenderTarget, faceIndex, layer) {
            if (prePassRenderTarget.renderTargetTexture) {
                prePassRenderTarget.renderTargetTexture._prepareFrame(this._scene, faceIndex, layer, prePassRenderTarget.renderTargetTexture.useCameraPostProcesses);
            }
            else if (this._postProcessesSourceForThisPass.length) {
                this._scene.postProcessManager._prepareFrame();
            }
            else {
                this._engine.restoreDefaultFramebuffer();
            }
        }
        /**
         * Sets an intermediary texture between prepass and postprocesses. This texture
         * will be used as input for post processes
         * @param rt
         * @returns true if there are postprocesses that will use this texture,
         * false if there is no postprocesses - and the function has no effect
         */
        setCustomOutput(rt) {
            const firstPP = this._postProcessesSourceForThisPass[0];
            if (!firstPP) {
                return false;
            }
            firstPP.inputTexture = rt.renderTarget;
            return true;
        }
        _renderPostProcesses(prePassRenderTarget, faceIndex) {
            var _a;
            const firstPP = this._postProcessesSourceForThisPass[0];
            const outputTexture = firstPP ? firstPP.inputTexture : prePassRenderTarget.renderTargetTexture ? prePassRenderTarget.renderTargetTexture.renderTarget : null;
            // Build post process chain for this prepass post draw
            let postProcessChain = this._currentTarget._beforeCompositionPostProcesses;
            if (this._needsCompositionForThisPass) {
                postProcessChain = postProcessChain.concat([this._currentTarget.imageProcessingPostProcess]);
            }
            // Activates and renders the chain
            if (postProcessChain.length) {
                this._scene.postProcessManager._prepareFrame((_a = this._currentTarget.renderTarget) === null || _a === void 0 ? void 0 : _a.texture, postProcessChain);
                this._scene.postProcessManager.directRender(postProcessChain, outputTexture, false, faceIndex);
            }
        }
        /**
         * @internal
         */
        _afterDraw(faceIndex, layer) {
            if (this._enabled && this._currentTarget.enabled) {
                this._prepareFrame(this._currentTarget, faceIndex, layer);
                this._renderPostProcesses(this._currentTarget, faceIndex);
            }
        }
        /**
         * Clears the current prepass render target (in the sense of settings pixels to the scene clear color value)
         * @internal
         */
        _clear() {
            if (this._enabled && this._currentTarget.enabled) {
                this._bindFrameBuffer(this._currentTarget);
                // Clearing other attachment with 0 on all other attachments
                this._engine.bindAttachments(this._clearAttachments);
                this._engine.clear(this._clearColor, true, false, false);
                if (this._useSpecificClearForDepthTexture) {
                    this._engine.bindAttachments(this._clearDepthAttachments);
                    this._engine.clear(this._clearDepthColor, true, false, false);
                }
                // Regular clear color with the scene clear color of the 1st attachment
                this._engine.bindAttachments(this._defaultAttachments);
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _bindFrameBuffer(prePassRenderTarget) {
            if (this._enabled && this._currentTarget.enabled) {
                this._currentTarget._checkSize();
                const internalTexture = this._currentTarget.renderTarget;
                if (internalTexture) {
                    this._engine.bindFramebuffer(internalTexture);
                }
            }
        }
        _setEnabled(enabled) {
            this._enabled = enabled;
        }
        _setRenderTargetEnabled(prePassRenderTarget, enabled) {
            prePassRenderTarget.enabled = enabled;
            if (!enabled) {
                this._unlinkInternalTexture(prePassRenderTarget);
            }
        }
        /**
         * Adds an effect configuration to the prepass render target.
         * If an effect has already been added, it won't add it twice and will return the configuration
         * already present.
         * @param cfg the effect configuration
         * @returns the effect configuration now used by the prepass
         */
        addEffectConfiguration(cfg) {
            // Do not add twice
            for (let i = 0; i < this._effectConfigurations.length; i++) {
                if (this._effectConfigurations[i].name === cfg.name) {
                    return this._effectConfigurations[i];
                }
            }
            this._effectConfigurations.push(cfg);
            return cfg;
        }
        _enable() {
            const previousMrtCount = this.mrtCount;
            for (let i = 0; i < this._effectConfigurations.length; i++) {
                if (this._effectConfigurations[i].enabled) {
                    this._enableTextures(this._effectConfigurations[i].texturesRequired);
                }
            }
            for (let i = 0; i < this.renderTargets.length; i++) {
                if (this.mrtCount !== previousMrtCount || this.renderTargets[i].count !== this.mrtCount) {
                    this.renderTargets[i].updateCount(this.mrtCount, { types: this._mrtTypes, formats: this._mrtFormats }, this._mrtNames.concat("prePass_DepthBuffer"));
                }
                this.renderTargets[i]._resetPostProcessChain();
                for (let j = 0; j < this._effectConfigurations.length; j++) {
                    if (this._effectConfigurations[j].enabled) {
                        // TODO : subsurface scattering has 1 scene-wide effect configuration
                        // solution : do not stock postProcess on effectConfiguration, but in the prepassRenderTarget (hashmap configuration => postProcess)
                        // And call createPostProcess whenever the post process does not exist in the RT
                        if (!this._effectConfigurations[j].postProcess && this._effectConfigurations[j].createPostProcess) {
                            this._effectConfigurations[j].createPostProcess();
                        }
                        if (this._effectConfigurations[j].postProcess) {
                            this.renderTargets[i]._beforeCompositionPostProcesses.push(this._effectConfigurations[j].postProcess);
                        }
                    }
                }
            }
            this._reinitializeAttachments();
            this._setEnabled(true);
            this._updateGeometryBufferLayout();
        }
        _disable() {
            this._setEnabled(false);
            for (let i = 0; i < this.renderTargets.length; i++) {
                this._setRenderTargetEnabled(this.renderTargets[i], false);
            }
            this._resetLayout();
            for (let i = 0; i < this._effectConfigurations.length; i++) {
                this._effectConfigurations[i].enabled = false;
            }
        }
        _getPostProcessesSource(prePassRenderTarget, camera) {
            if (camera) {
                return camera._postProcesses;
            }
            else if (prePassRenderTarget.renderTargetTexture) {
                if (prePassRenderTarget.renderTargetTexture.useCameraPostProcesses) {
                    const camera = prePassRenderTarget.renderTargetTexture.activeCamera ? prePassRenderTarget.renderTargetTexture.activeCamera : this._scene.activeCamera;
                    return camera ? camera._postProcesses : [];
                }
                else if (prePassRenderTarget.renderTargetTexture.postProcesses) {
                    return prePassRenderTarget.renderTargetTexture.postProcesses;
                }
                else {
                    return [];
                }
            }
            else {
                return this._scene.activeCamera ? this._scene.activeCamera._postProcesses : [];
            }
        }
        _setupOutputForThisPass(prePassRenderTarget, camera) {
            // Order is : draw ===> prePassRenderTarget._postProcesses ==> ipp ==> camera._postProcesses
            const secondaryCamera = camera && this._scene.activeCameras && !!this._scene.activeCameras.length && this._scene.activeCameras.indexOf(camera) !== 0;
            this._postProcessesSourceForThisPass = this._getPostProcessesSource(prePassRenderTarget, camera);
            this._postProcessesSourceForThisPass = this._postProcessesSourceForThisPass.filter((pp) => {
                return pp != null;
            });
            this._scene.autoClear = true;
            const cameraHasImageProcessing = this._hasImageProcessing(this._postProcessesSourceForThisPass);
            this._needsCompositionForThisPass = !cameraHasImageProcessing && !this.disableGammaTransform && this._needsImageProcessing() && !secondaryCamera;
            const firstCameraPP = this._getFirstPostProcess(this._postProcessesSourceForThisPass);
            const firstPrePassPP = prePassRenderTarget._beforeCompositionPostProcesses && prePassRenderTarget._beforeCompositionPostProcesses[0];
            let firstPP = null;
            // Setting the scene-wide post process configuration
            this._scene.imageProcessingConfiguration.applyByPostProcess = this._needsCompositionForThisPass || cameraHasImageProcessing;
            // Create composition effect if needed
            if (this._needsCompositionForThisPass && !prePassRenderTarget.imageProcessingPostProcess) {
                prePassRenderTarget._createCompositionEffect();
            }
            // Setting the prePassRenderTarget as input texture of the first PP
            if (firstPrePassPP) {
                firstPP = firstPrePassPP;
            }
            else if (this._needsCompositionForThisPass) {
                firstPP = prePassRenderTarget.imageProcessingPostProcess;
            }
            else if (firstCameraPP) {
                firstPP = firstCameraPP;
            }
            this._bindFrameBuffer(prePassRenderTarget);
            this._linkInternalTexture(prePassRenderTarget, firstPP);
        }
        _linkInternalTexture(prePassRenderTarget, postProcess) {
            if (postProcess) {
                postProcess.autoClear = false;
                postProcess.inputTexture = prePassRenderTarget.renderTarget;
            }
            if (prePassRenderTarget._outputPostProcess !== postProcess) {
                if (prePassRenderTarget._outputPostProcess) {
                    this._unlinkInternalTexture(prePassRenderTarget);
                }
                prePassRenderTarget._outputPostProcess = postProcess;
            }
            if (prePassRenderTarget._internalTextureDirty) {
                this._updateGeometryBufferLayout();
                prePassRenderTarget._internalTextureDirty = false;
            }
        }
        /**
         * @internal
         */
        _unlinkInternalTexture(prePassRenderTarget) {
            if (prePassRenderTarget._outputPostProcess) {
                prePassRenderTarget._outputPostProcess.autoClear = true;
                prePassRenderTarget._outputPostProcess.restoreDefaultInputTexture();
                prePassRenderTarget._outputPostProcess = null;
            }
        }
        _needsImageProcessing() {
            for (let i = 0; i < this._effectConfigurations.length; i++) {
                if (this._effectConfigurations[i].enabled && this._effectConfigurations[i].needsImageProcessing) {
                    return true;
                }
            }
            return false;
        }
        _hasImageProcessing(postProcesses) {
            var _a;
            let isIPPAlreadyPresent = false;
            if (postProcesses) {
                for (let i = 0; i < postProcesses.length; i++) {
                    if (((_a = postProcesses[i]) === null || _a === void 0 ? void 0 : _a.getClassName()) === "ImageProcessingPostProcess") {
                        isIPPAlreadyPresent = true;
                        break;
                    }
                }
            }
            return isIPPAlreadyPresent;
        }
        /**
         * Internal, gets the first post proces.
         * @param postProcesses
         * @returns the first post process to be run on this camera.
         */
        _getFirstPostProcess(postProcesses) {
            for (let ppIndex = 0; ppIndex < postProcesses.length; ppIndex++) {
                if (postProcesses[ppIndex] !== null) {
                    return postProcesses[ppIndex];
                }
            }
            return null;
        }
        /**
         * Marks the prepass renderer as dirty, triggering a check if the prepass is necessary for the next rendering.
         */
        markAsDirty() {
            this._isDirty = true;
        }
        /**
         * Enables a texture on the MultiRenderTarget for prepass
         * @param types
         */
        _enableTextures(types) {
            // For velocity : enable storage of previous matrices for instances
            this._scene.needsPreviousWorldMatrices = false;
            for (let i = 0; i < types.length; i++) {
                const type = types[i];
                if (this._textureIndices[type] === -1) {
                    this._textureIndices[type] = this._mrtLayout.length;
                    this._mrtLayout.push(type);
                    this._mrtTypes.push(PrePassRenderer.TextureFormats[type].type);
                    this._mrtFormats.push(PrePassRenderer.TextureFormats[type].format);
                    this._mrtNames.push(PrePassRenderer.TextureFormats[type].name);
                    this.mrtCount++;
                }
                if (type === 2) {
                    this._scene.needsPreviousWorldMatrices = true;
                }
            }
        }
        /**
         * Makes sure that the prepass renderer is up to date if it has been dirtified.
         */
        update() {
            if (this._isDirty) {
                this._update();
            }
        }
        _update() {
            this._disable();
            let enablePrePass = false;
            this._scene.imageProcessingConfiguration.applyByPostProcess = false;
            if (this._scene._depthPeelingRenderer && this._scene.useOrderIndependentTransparency) {
                this._scene._depthPeelingRenderer.setPrePassRenderer(this);
                enablePrePass = true;
            }
            for (let i = 0; i < this._scene.materials.length; i++) {
                if (this._scene.materials[i].setPrePassRenderer(this)) {
                    enablePrePass = true;
                }
            }
            if (enablePrePass) {
                this._setRenderTargetEnabled(this.defaultRT, true);
            }
            let postProcesses;
            for (let i = 0; i < this.renderTargets.length; i++) {
                if (this.renderTargets[i].renderTargetTexture) {
                    postProcesses = this._getPostProcessesSource(this.renderTargets[i]);
                }
                else {
                    const camera = this._scene.activeCamera;
                    if (!camera) {
                        continue;
                    }
                    postProcesses = camera._postProcesses;
                }
                if (!postProcesses) {
                    continue;
                }
                postProcesses = postProcesses.filter((pp) => {
                    return pp != null;
                });
                if (postProcesses) {
                    for (let j = 0; j < postProcesses.length; j++) {
                        if (postProcesses[j].setPrePassRenderer(this)) {
                            this._setRenderTargetEnabled(this.renderTargets[i], true);
                            enablePrePass = true;
                        }
                    }
                    if (this._hasImageProcessing(postProcesses)) {
                        this._scene.imageProcessingConfiguration.applyByPostProcess = true;
                    }
                }
            }
            this._markAllMaterialsAsPrePassDirty();
            this._isDirty = false;
            if (enablePrePass) {
                this._enable();
            }
        }
        _markAllMaterialsAsPrePassDirty() {
            const materials = this._scene.materials;
            for (let i = 0; i < materials.length; i++) {
                materials[i].markAsDirty(Material.PrePassDirtyFlag);
            }
        }
        /**
         * Disposes the prepass renderer.
         */
        dispose() {
            for (let i = this.renderTargets.length - 1; i >= 0; i--) {
                this.renderTargets[i].dispose();
            }
            for (let i = 0; i < this._effectConfigurations.length; i++) {
                if (this._effectConfigurations[i].dispose) {
                    this._effectConfigurations[i].dispose();
                }
            }
        }
    }
    /**
     * @internal
     */
    PrePassRenderer._SceneComponentInitialization = (_) => {
        throw _WarnImport("PrePassRendererSceneComponent");
    };
    /**
     * Describes the types and formats of the textures used by the pre-pass renderer
     */
    PrePassRenderer.TextureFormats = [
        {
            purpose: 0,
            type: 2,
            format: 5,
            name: "prePass_Irradiance",
        },
        {
            purpose: 1,
            type: 2,
            format: 5,
            name: "prePass_Position",
        },
        {
            purpose: 2,
            type: 0,
            format: 5,
            name: "prePass_Velocity",
        },
        {
            purpose: 3,
            type: 0,
            format: 5,
            name: "prePass_Reflectivity",
        },
        {
            purpose: 4,
            type: 2,
            format: 5,
            name: "prePass_Color",
        },
        {
            purpose: 5,
            type: 1,
            format: 6,
            name: "prePass_Depth",
        },
        {
            purpose: 6,
            type: 2,
            format: 5,
            name: "prePass_Normal",
        },
        {
            purpose: 7,
            type: 0,
            format: 5,
            name: "prePass_Albedo",
        },
    ];

    Object.defineProperty(Scene.prototype, "prePassRenderer", {
        get: function () {
            return this._prePassRenderer;
        },
        set: function (value) {
            if (value && value.isSupported) {
                this._prePassRenderer = value;
            }
        },
        enumerable: true,
        configurable: true,
    });
    Scene.prototype.enablePrePassRenderer = function () {
        if (this._prePassRenderer) {
            return this._prePassRenderer;
        }
        this._prePassRenderer = new PrePassRenderer(this);
        if (!this._prePassRenderer.isSupported) {
            this._prePassRenderer = null;
            Logger.Error("PrePassRenderer needs WebGL 2 support.\n" + "Maybe you tried to use the following features that need the PrePassRenderer :\n" + " + Subsurface Scattering");
        }
        return this._prePassRenderer;
    };
    Scene.prototype.disablePrePassRenderer = function () {
        if (!this._prePassRenderer) {
            return;
        }
        this._prePassRenderer.dispose();
        this._prePassRenderer = null;
    };
    /**
     * Defines the Geometry Buffer scene component responsible to manage a G-Buffer useful
     * in several rendering techniques.
     */
    class PrePassRendererSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_PREPASSRENDERER;
            this.scene = scene;
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._beforeCameraDrawStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERADRAW_PREPASS, this, this._beforeCameraDraw);
            this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_PREPASS, this, this._afterCameraDraw);
            this.scene._beforeRenderTargetDrawStage.registerStep(SceneComponentConstants.STEP_BEFORERENDERTARGETDRAW_PREPASS, this, this._beforeRenderTargetDraw);
            this.scene._afterRenderTargetDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_PREPASS, this, this._afterRenderTargetDraw);
            this.scene._beforeClearStage.registerStep(SceneComponentConstants.STEP_BEFORECLEAR_PREPASS, this, this._beforeClearStage);
            this.scene._beforeRenderTargetClearStage.registerStep(SceneComponentConstants.STEP_BEFORERENDERTARGETCLEAR_PREPASS, this, this._beforeRenderTargetClearStage);
            this.scene._beforeRenderingMeshStage.registerStep(SceneComponentConstants.STEP_BEFORERENDERINGMESH_PREPASS, this, this._beforeRenderingMeshStage);
            this.scene._afterRenderingMeshStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERINGMESH_PREPASS, this, this._afterRenderingMeshStage);
        }
        _beforeRenderTargetDraw(renderTarget, faceIndex, layer) {
            if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
                this.scene.prePassRenderer._setRenderTarget(renderTarget._prePassRenderTarget);
                this.scene.prePassRenderer._beforeDraw(undefined, faceIndex, layer);
            }
        }
        _afterRenderTargetDraw(renderTarget, faceIndex, layer) {
            if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
                this.scene.prePassRenderer._afterDraw(faceIndex, layer);
            }
        }
        _beforeRenderTargetClearStage(renderTarget) {
            if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
                if (!renderTarget._prePassRenderTarget) {
                    renderTarget._prePassRenderTarget = this.scene.prePassRenderer._createRenderTarget(renderTarget.name + "_prePassRTT", renderTarget);
                }
                this.scene.prePassRenderer._setRenderTarget(renderTarget._prePassRenderTarget);
                this.scene.prePassRenderer._clear();
            }
        }
        _beforeCameraDraw(camera) {
            if (this.scene.prePassRenderer) {
                this.scene.prePassRenderer._setRenderTarget(null);
                this.scene.prePassRenderer._beforeDraw(camera);
            }
        }
        _afterCameraDraw() {
            if (this.scene.prePassRenderer) {
                this.scene.prePassRenderer._afterDraw();
            }
        }
        _beforeClearStage() {
            if (this.scene.prePassRenderer) {
                this.scene.prePassRenderer._setRenderTarget(null);
                this.scene.prePassRenderer._clear();
            }
        }
        _beforeRenderingMeshStage(mesh, subMesh, batch, effect) {
            if (!effect) {
                return;
            }
            // Render to MRT
            const scene = mesh.getScene();
            if (scene.prePassRenderer) {
                scene.prePassRenderer.bindAttachmentsForEffect(effect, subMesh);
            }
        }
        _afterRenderingMeshStage(mesh) {
            const scene = mesh.getScene();
            if (scene.prePassRenderer) {
                scene.prePassRenderer.restoreAttachments();
            }
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            // Release textures first
            this.scene.disablePrePassRenderer();
            // Re-enable
            this.scene.enablePrePassRenderer();
        }
        /**
         * Disposes the component and the associated resources
         */
        dispose() {
            this.scene.disablePrePassRenderer();
        }
    }
    PrePassRenderer._SceneComponentInitialization = (scene) => {
        // Register the G Buffer component to the scene.
        let component = scene._getComponent(SceneComponentConstants.NAME_PREPASSRENDERER);
        if (!component) {
            component = new PrePassRendererSceneComponent(scene);
            scene._addComponent(component);
        }
    };

    const settingDefaults = {
        parentChangeBehavior: exports.eParentChangeBehavior.PRESERVE_POSITION,
    };
    const settingsKey = 'KBVIEWER_SETTINGS';
    const savedSettings = localStorage.getItem(settingsKey);
    const settings = savedSettings
        ? { ...settingDefaults, ...JSON.parse(savedSettings) }
        : { ...settingDefaults };
    class SettingsManagerService {
        static get(name) {
            return settings[name];
        }
        static set(name, value) {
            settings[name] = value;
            localStorage.setItem(settingsKey, JSON.stringify(settings));
        }
    }

    /**
     * Creates the VertexData for a Ribbon
     * @param options an object used to set the following optional parameters for the ribbon, required but can be empty
     * * pathArray array of paths, each of which an array of successive Vector3
     * * closeArray creates a seam between the first and the last paths of the pathArray, optional, default false
     * * closePath creates a seam between the first and the last points of each path of the path array, optional, default false
     * * offset a positive integer, only used when pathArray contains a single path (offset = 10 means the point 1 is joined to the point 11), default rounded half size of the pathArray length
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * * invertUV swaps in the U and V coordinates when applying a texture, optional, default false
     * * uvs a linear array, of length 2 * number of vertices, of custom UV values, optional
     * * colors a linear array, of length 4 * number of vertices, of custom color values, optional
     * @param options.pathArray
     * @param options.closeArray
     * @param options.closePath
     * @param options.offset
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.invertUV
     * @param options.uvs
     * @param options.colors
     * @returns the VertexData of the ribbon
     */
    function CreateRibbonVertexData(options) {
        let pathArray = options.pathArray;
        const closeArray = options.closeArray || false;
        const closePath = options.closePath || false;
        const invertUV = options.invertUV || false;
        const defaultOffset = Math.floor(pathArray[0].length / 2);
        let offset = options.offset || defaultOffset;
        offset = offset > defaultOffset ? defaultOffset : Math.floor(offset); // offset max allowed : defaultOffset
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const customUV = options.uvs;
        const customColors = options.colors;
        const positions = [];
        const indices = [];
        const normals = [];
        const uvs = [];
        const us = []; // us[path_id] = [uDist1, uDist2, uDist3 ... ] distances between points on path path_id
        const vs = []; // vs[i] = [vDist1, vDist2, vDist3, ... ] distances between points i of consecutive paths from pathArray
        const uTotalDistance = []; // uTotalDistance[p] : total distance of path p
        const vTotalDistance = []; //  vTotalDistance[i] : total distance between points i of first and last path from pathArray
        let minlg; // minimal length among all paths from pathArray
        const lg = []; // array of path lengths : nb of vertex per path
        const idx = []; // array of path indexes : index of each path (first vertex) in the total vertex number
        let p; // path iterator
        let i; // point iterator
        let j; // point iterator
        // if single path in pathArray
        if (pathArray.length < 2) {
            const ar1 = [];
            const ar2 = [];
            for (i = 0; i < pathArray[0].length - offset; i++) {
                ar1.push(pathArray[0][i]);
                ar2.push(pathArray[0][i + offset]);
            }
            pathArray = [ar1, ar2];
        }
        // positions and horizontal distances (u)
        let idc = 0;
        const closePathCorr = closePath ? 1 : 0; // the final index will be +1 if closePath
        let path;
        let l;
        minlg = pathArray[0].length;
        let vectlg;
        let dist;
        for (p = 0; p < pathArray.length; p++) {
            uTotalDistance[p] = 0;
            us[p] = [0];
            path = pathArray[p];
            l = path.length;
            minlg = minlg < l ? minlg : l;
            j = 0;
            while (j < l) {
                positions.push(path[j].x, path[j].y, path[j].z);
                if (j > 0) {
                    vectlg = path[j].subtract(path[j - 1]).length();
                    dist = vectlg + uTotalDistance[p];
                    us[p].push(dist);
                    uTotalDistance[p] = dist;
                }
                j++;
            }
            if (closePath) {
                // an extra hidden vertex is added in the "positions" array
                j--;
                positions.push(path[0].x, path[0].y, path[0].z);
                vectlg = path[j].subtract(path[0]).length();
                dist = vectlg + uTotalDistance[p];
                us[p].push(dist);
                uTotalDistance[p] = dist;
            }
            lg[p] = l + closePathCorr;
            idx[p] = idc;
            idc += l + closePathCorr;
        }
        // vertical distances (v)
        let path1;
        let path2;
        let vertex1 = null;
        let vertex2 = null;
        for (i = 0; i < minlg + closePathCorr; i++) {
            vTotalDistance[i] = 0;
            vs[i] = [0];
            for (p = 0; p < pathArray.length - 1; p++) {
                path1 = pathArray[p];
                path2 = pathArray[p + 1];
                if (i === minlg) {
                    // closePath
                    vertex1 = path1[0];
                    vertex2 = path2[0];
                }
                else {
                    vertex1 = path1[i];
                    vertex2 = path2[i];
                }
                vectlg = vertex2.subtract(vertex1).length();
                dist = vectlg + vTotalDistance[i];
                vs[i].push(dist);
                vTotalDistance[i] = dist;
            }
            if (closeArray && vertex2 && vertex1) {
                path1 = pathArray[p];
                path2 = pathArray[0];
                if (i === minlg) {
                    // closePath
                    vertex2 = path2[0];
                }
                vectlg = vertex2.subtract(vertex1).length();
                dist = vectlg + vTotalDistance[i];
                vTotalDistance[i] = dist;
            }
        }
        // uvs
        let u;
        let v;
        if (customUV) {
            for (p = 0; p < customUV.length; p++) {
                uvs.push(customUV[p].x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - customUV[p].y : customUV[p].y);
            }
        }
        else {
            for (p = 0; p < pathArray.length; p++) {
                for (i = 0; i < minlg + closePathCorr; i++) {
                    u = uTotalDistance[p] != 0.0 ? us[p][i] / uTotalDistance[p] : 0.0;
                    v = vTotalDistance[i] != 0.0 ? vs[i][p] / vTotalDistance[i] : 0.0;
                    if (invertUV) {
                        uvs.push(v, u);
                    }
                    else {
                        uvs.push(u, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - v : v);
                    }
                }
            }
        }
        // indices
        p = 0; // path index
        let pi = 0; // positions array index
        let l1 = lg[p] - 1; // path1 length
        let l2 = lg[p + 1] - 1; // path2 length
        let min = l1 < l2 ? l1 : l2; // current path stop index
        let shft = idx[1] - idx[0]; // shift
        const path1nb = closeArray ? lg.length : lg.length - 1; // number of path1 to iterate	on
        while (pi <= min && p < path1nb) {
            //  stay under min and don't go over next to last path
            // draw two triangles between path1 (p1) and path2 (p2) : (p1.pi, p2.pi, p1.pi+1) and (p2.pi+1, p1.pi+1, p2.pi) clockwise
            indices.push(pi, pi + shft, pi + 1);
            indices.push(pi + shft + 1, pi + 1, pi + shft);
            pi += 1;
            if (pi === min) {
                // if end of one of two consecutive paths reached, go to next existing path
                p++;
                if (p === lg.length - 1) {
                    // last path of pathArray reached <=> closeArray == true
                    shft = idx[0] - idx[p];
                    l1 = lg[p] - 1;
                    l2 = lg[0] - 1;
                }
                else {
                    shft = idx[p + 1] - idx[p];
                    l1 = lg[p] - 1;
                    l2 = lg[p + 1] - 1;
                }
                pi = idx[p];
                min = l1 < l2 ? l1 + pi : l2 + pi;
            }
        }
        // normals
        VertexData.ComputeNormals(positions, indices, normals);
        if (closePath) {
            // update both the first and last vertex normals to their average value
            let indexFirst = 0;
            let indexLast = 0;
            for (p = 0; p < pathArray.length; p++) {
                indexFirst = idx[p] * 3;
                if (p + 1 < pathArray.length) {
                    indexLast = (idx[p + 1] - 1) * 3;
                }
                else {
                    indexLast = normals.length - 3;
                }
                normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                normals[indexLast] = normals[indexFirst];
                normals[indexLast + 1] = normals[indexFirst + 1];
                normals[indexLast + 2] = normals[indexFirst + 2];
            }
        }
        // sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Colors
        let colors = null;
        if (customColors) {
            colors = new Float32Array(customColors.length * 4);
            for (let c = 0; c < customColors.length; c++) {
                colors[c * 4] = customColors[c].r;
                colors[c * 4 + 1] = customColors[c].g;
                colors[c * 4 + 2] = customColors[c].b;
                colors[c * 4 + 3] = customColors[c].a;
            }
        }
        // Result
        const vertexData = new VertexData();
        const positions32 = new Float32Array(positions);
        const normals32 = new Float32Array(normals);
        const uvs32 = new Float32Array(uvs);
        vertexData.indices = indices;
        vertexData.positions = positions32;
        vertexData.normals = normals32;
        vertexData.uvs = uvs32;
        if (colors) {
            vertexData.set(colors, VertexBuffer.ColorKind);
        }
        if (closePath) {
            vertexData._idx = idx;
        }
        return vertexData;
    }
    /**
     * Creates a ribbon mesh. The ribbon is a parametric shape.  It has no predefined shape. Its final shape will depend on the input parameters
     * * The parameter `pathArray` is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry
     * * The parameter `closeArray` (boolean, default false) creates a seam between the first and the last paths of the path array
     * * The parameter `closePath` (boolean, default false) creates a seam between the first and the last points of each path of the path array
     * * The parameter `offset` (positive integer, default : rounded half size of the pathArray length), is taken in account only if the `pathArray` is containing a single path
     * * It's the offset to join the points from the same path. Ex : offset = 10 means the point 1 is joined to the point 11
     * * The optional parameter `instance` is an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#ribbon
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
     * * The parameter `uvs` is an optional flat array of `Vector2` to update/set each ribbon vertex with its own custom UV values instead of the computed ones
     * * The parameters `colors` is an optional flat array of `Color4` to set/update each ribbon vertex with its own custom color values
     * * Note that if you use the parameters `uvs` or `colors`, the passed arrays must be populated with the right number of elements, it is to say the number of ribbon vertices. Remember that if you set `closePath` to `true`, there's one extra vertex per path in the geometry
     * * Moreover, you can use the parameter `color` with `instance` (to update the ribbon), only if you previously used it at creation time
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.pathArray
     * @param options.closeArray
     * @param options.closePath
     * @param options.offset
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.instance
     * @param options.invertUV
     * @param options.uvs
     * @param options.colors
     * @param scene defines the hosting scene
     * @returns the ribbon mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/ribbon_extra
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     */
    function CreateRibbon(name, options, scene = null) {
        const pathArray = options.pathArray;
        const closeArray = options.closeArray;
        const closePath = options.closePath;
        const sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        const instance = options.instance;
        const updatable = options.updatable;
        if (instance) {
            // existing ribbon instance update
            // positionFunction : ribbon case
            // only pathArray and sideOrientation parameters are taken into account for positions update
            const minimum = TmpVectors.Vector3[0].setAll(Number.MAX_VALUE);
            const maximum = TmpVectors.Vector3[1].setAll(-Number.MAX_VALUE);
            const positionFunction = (positions) => {
                let minlg = pathArray[0].length;
                const mesh = instance;
                let i = 0;
                const ns = mesh._originalBuilderSideOrientation === Mesh.DOUBLESIDE ? 2 : 1;
                for (let si = 1; si <= ns; ++si) {
                    for (let p = 0; p < pathArray.length; ++p) {
                        const path = pathArray[p];
                        const l = path.length;
                        minlg = minlg < l ? minlg : l;
                        for (let j = 0; j < minlg; ++j) {
                            const pathPoint = path[j];
                            positions[i] = pathPoint.x;
                            positions[i + 1] = pathPoint.y;
                            positions[i + 2] = pathPoint.z;
                            minimum.minimizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                            maximum.maximizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                            i += 3;
                        }
                        if (mesh._creationDataStorage && mesh._creationDataStorage.closePath) {
                            const pathPoint = path[0];
                            positions[i] = pathPoint.x;
                            positions[i + 1] = pathPoint.y;
                            positions[i + 2] = pathPoint.z;
                            i += 3;
                        }
                    }
                }
            };
            const positions = instance.getVerticesData(VertexBuffer.PositionKind);
            positionFunction(positions);
            if (instance.hasBoundingInfo) {
                instance.getBoundingInfo().reConstruct(minimum, maximum, instance._worldMatrix);
            }
            else {
                instance.buildBoundingInfo(minimum, maximum, instance._worldMatrix);
            }
            instance.updateVerticesData(VertexBuffer.PositionKind, positions, false, false);
            if (options.colors) {
                const colors = instance.getVerticesData(VertexBuffer.ColorKind);
                for (let c = 0, colorIndex = 0; c < options.colors.length; c++, colorIndex += 4) {
                    const color = options.colors[c];
                    colors[colorIndex] = color.r;
                    colors[colorIndex + 1] = color.g;
                    colors[colorIndex + 2] = color.b;
                    colors[colorIndex + 3] = color.a;
                }
                instance.updateVerticesData(VertexBuffer.ColorKind, colors, false, false);
            }
            if (options.uvs) {
                const uvs = instance.getVerticesData(VertexBuffer.UVKind);
                for (let i = 0; i < options.uvs.length; i++) {
                    uvs[i * 2] = options.uvs[i].x;
                    uvs[i * 2 + 1] = CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - options.uvs[i].y : options.uvs[i].y;
                }
                instance.updateVerticesData(VertexBuffer.UVKind, uvs, false, false);
            }
            if (!instance.areNormalsFrozen || instance.isFacetDataEnabled) {
                const indices = instance.getIndices();
                const normals = instance.getVerticesData(VertexBuffer.NormalKind);
                const params = instance.isFacetDataEnabled ? instance.getFacetDataParameters() : null;
                VertexData.ComputeNormals(positions, indices, normals, params);
                if (instance._creationDataStorage && instance._creationDataStorage.closePath) {
                    let indexFirst = 0;
                    let indexLast = 0;
                    for (let p = 0; p < pathArray.length; p++) {
                        indexFirst = instance._creationDataStorage.idx[p] * 3;
                        if (p + 1 < pathArray.length) {
                            indexLast = (instance._creationDataStorage.idx[p + 1] - 1) * 3;
                        }
                        else {
                            indexLast = normals.length - 3;
                        }
                        normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                        normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                        normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                        normals[indexLast] = normals[indexFirst];
                        normals[indexLast + 1] = normals[indexFirst + 1];
                        normals[indexLast + 2] = normals[indexFirst + 2];
                    }
                }
                if (!instance.areNormalsFrozen) {
                    instance.updateVerticesData(VertexBuffer.NormalKind, normals, false, false);
                }
            }
            return instance;
        }
        else {
            // new ribbon creation
            const ribbon = new Mesh(name, scene);
            ribbon._originalBuilderSideOrientation = sideOrientation;
            ribbon._creationDataStorage = new _CreationDataStorage();
            const vertexData = CreateRibbonVertexData(options);
            if (closePath) {
                ribbon._creationDataStorage.idx = vertexData._idx;
            }
            ribbon._creationDataStorage.closePath = closePath;
            ribbon._creationDataStorage.closeArray = closeArray;
            vertexData.applyToMesh(ribbon, updatable);
            return ribbon;
        }
    }
    VertexData.CreateRibbon = CreateRibbonVertexData;
    Mesh.CreateRibbon = (name, pathArray, closeArray = false, closePath, offset, scene, updatable = false, sideOrientation, instance) => {
        return CreateRibbon(name, {
            pathArray: pathArray,
            closeArray: closeArray,
            closePath: closePath,
            offset: offset,
            updatable: updatable,
            sideOrientation: sideOrientation,
            instance: instance,
        }, scene);
    };

    /**
     * Creates the VertexData of the Disc or regular Polygon
     * @param options an object used to set the following optional parameters for the disc, required but can be empty
     * * radius the radius of the disc, optional default 0.5
     * * tessellation the number of polygon sides, optional, default 64
     * * arc a number from 0 to 1, to create an unclosed polygon based on the fraction of the circumference given by the arc value, optional, default 1
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.radius
     * @param options.tessellation
     * @param options.arc
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the box
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function CreateDiscVertexData(options) {
        const positions = new Array();
        const indices = new Array();
        const normals = new Array();
        const uvs = new Array();
        const radius = options.radius || 0.5;
        const tessellation = options.tessellation || 64;
        const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        // positions and uvs
        positions.push(0, 0, 0); // disc center first
        uvs.push(0.5, 0.5);
        const theta = Math.PI * 2 * arc;
        const step = arc === 1 ? theta / tessellation : theta / (tessellation - 1);
        let a = 0;
        for (let t = 0; t < tessellation; t++) {
            const x = Math.cos(a);
            const y = Math.sin(a);
            const u = (x + 1) / 2;
            const v = (1 - y) / 2;
            positions.push(radius * x, radius * y, 0);
            uvs.push(u, CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
            a += step;
        }
        if (arc === 1) {
            positions.push(positions[3], positions[4], positions[5]); // close the circle
            uvs.push(uvs[2], CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - uvs[3] : uvs[3]);
        }
        //indices
        const vertexNb = positions.length / 3;
        for (let i = 1; i < vertexNb - 1; i++) {
            indices.push(i + 1, 0, i);
        }
        // result
        VertexData.ComputeNormals(positions, indices, normals);
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a plane polygonal mesh.  By default, this is a disc
     * * The parameter `radius` sets the radius size (float) of the polygon (default 0.5)
     * * The parameter `tessellation` sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
     * * You can create an unclosed polygon with the parameter `arc` (positive float, default 1), valued between 0 and 1, what is the ratio of the circumference : 2 x PI x ratio
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.radius
     * @param options.tessellation
     * @param options.arc
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param scene defines the hosting scene
     * @returns the plane polygonal mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#disc-or-regular-polygon
     */
    function CreateDisc(name, options = {}, scene = null) {
        const disc = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        disc._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateDiscVertexData(options);
        vertexData.applyToMesh(disc, options.updatable);
        return disc;
    }
    VertexData.CreateDisc = CreateDiscVertexData;
    Mesh.CreateDisc = (name, radius, tessellation, scene = null, updatable, sideOrientation) => {
        const options = {
            radius,
            tessellation,
            sideOrientation,
            updatable,
        };
        return CreateDisc(name, options, scene);
    };

    /**
     * Creates the VertexData for a tiled plane
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/tiled_plane
     * @param options an object used to set the following optional parameters for the tiled plane, required but can be empty
     * * pattern a limited pattern arrangement depending on the number
     * * size of the box
     * * width of the box, overwrites size
     * * height of the box, overwrites size
     * * tileSize sets the width, height and depth of the tile to the value of size, optional default 1
     * * tileWidth sets the width (x direction) of the tile, overwrites the width set by size, optional, default size
     * * tileHeight sets the height (y direction) of the tile, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * alignHorizontal places whole tiles aligned to the center, left or right of a row
     * * alignVertical places whole tiles aligned to the center, left or right of a column
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * @param options.pattern
     * @param options.tileSize
     * @param options.tileWidth
     * @param options.tileHeight
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.alignHorizontal
     * @param options.alignVertical
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the tiled plane
     */
    function CreateTiledPlaneVertexData(options) {
        const flipTile = options.pattern || Mesh.NO_FLIP;
        const tileWidth = options.tileWidth || options.tileSize || 1;
        const tileHeight = options.tileHeight || options.tileSize || 1;
        const alignH = options.alignHorizontal || 0;
        const alignV = options.alignVertical || 0;
        const width = options.width || options.size || 1;
        const tilesX = Math.floor(width / tileWidth);
        let offsetX = width - tilesX * tileWidth;
        const height = options.height || options.size || 1;
        const tilesY = Math.floor(height / tileHeight);
        let offsetY = height - tilesY * tileHeight;
        const halfWidth = (tileWidth * tilesX) / 2;
        const halfHeight = (tileHeight * tilesY) / 2;
        let adjustX = 0;
        let adjustY = 0;
        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;
        //Part Tiles
        if (offsetX > 0 || offsetY > 0) {
            startX = -halfWidth;
            startY = -halfHeight;
            endX = halfWidth;
            endY = halfHeight;
            switch (alignH) {
                case Mesh.CENTER:
                    offsetX /= 2;
                    startX -= offsetX;
                    endX += offsetX;
                    break;
                case Mesh.LEFT:
                    endX += offsetX;
                    adjustX = -offsetX / 2;
                    break;
                case Mesh.RIGHT:
                    startX -= offsetX;
                    adjustX = offsetX / 2;
                    break;
            }
            switch (alignV) {
                case Mesh.CENTER:
                    offsetY /= 2;
                    startY -= offsetY;
                    endY += offsetY;
                    break;
                case Mesh.BOTTOM:
                    endY += offsetY;
                    adjustY = -offsetY / 2;
                    break;
                case Mesh.TOP:
                    startY -= offsetY;
                    adjustY = offsetY / 2;
                    break;
            }
        }
        const positions = [];
        const normals = [];
        const uvBase = [];
        uvBase[0] = [0, 0, 1, 0, 1, 1, 0, 1];
        uvBase[1] = [0, 0, 1, 0, 1, 1, 0, 1];
        if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
            uvBase[1] = [1, 1, 0, 1, 0, 0, 1, 0];
        }
        if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
            uvBase[1] = [1, 0, 0, 0, 0, 1, 1, 1];
        }
        if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
            uvBase[1] = [0, 1, 1, 1, 1, 0, 0, 0];
        }
        let uvs = [];
        const colors = [];
        const indices = [];
        let index = 0;
        for (let y = 0; y < tilesY; y++) {
            for (let x = 0; x < tilesX; x++) {
                positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                    uvs = uvs.concat(uvBase[((x % 2) + (y % 2)) % 2]);
                }
                else if (flipTile === Mesh.FLIP_ROW || flipTile === Mesh.ROTATE_ROW || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                    uvs = uvs.concat(uvBase[y % 2]);
                }
                else {
                    uvs = uvs.concat(uvBase[0]);
                }
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
                index += 4;
            }
        }
        //Part Tiles
        if (offsetX > 0 || offsetY > 0) {
            const partialBottomRow = offsetY > 0 && (alignV === Mesh.CENTER || alignV === Mesh.TOP);
            const partialTopRow = offsetY > 0 && (alignV === Mesh.CENTER || alignV === Mesh.BOTTOM);
            const partialLeftCol = offsetX > 0 && (alignH === Mesh.CENTER || alignH === Mesh.RIGHT);
            const partialRightCol = offsetX > 0 && (alignH === Mesh.CENTER || alignH === Mesh.LEFT);
            let uvPart = [];
            let a, b, c, d;
            //corners
            if (partialBottomRow && partialLeftCol) {
                //bottom left corner
                positions.push(startX + adjustX, startY + adjustY, 0);
                positions.push(-halfWidth + adjustX, startY + adjustY, 0);
                positions.push(-halfWidth + adjustX, startY + offsetY + adjustY, 0);
                positions.push(startX + adjustX, startY + offsetY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                a = 1 - offsetX / tileWidth;
                b = 1 - offsetY / tileHeight;
                c = 1;
                d = 1;
                uvPart = [a, b, c, b, c, d, a, d];
                if (flipTile === Mesh.ROTATE_ROW) {
                    uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if (flipTile === Mesh.FLIP_ROW) {
                    uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if (flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                    uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                uvs = uvs.concat(uvPart);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
            if (partialBottomRow && partialRightCol) {
                //bottom right corner
                positions.push(halfWidth + adjustX, startY + adjustY, 0);
                positions.push(endX + adjustX, startY + adjustY, 0);
                positions.push(endX + adjustX, startY + offsetY + adjustY, 0);
                positions.push(halfWidth + adjustX, startY + offsetY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                a = 0;
                b = 1 - offsetY / tileHeight;
                c = offsetX / tileWidth;
                d = 1;
                uvPart = [a, b, c, b, c, d, a, d];
                if (flipTile === Mesh.ROTATE_ROW || (flipTile === Mesh.ROTATE_TILE && tilesX % 2 === 0)) {
                    uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if (flipTile === Mesh.FLIP_ROW || (flipTile === Mesh.FLIP_TILE && tilesX % 2 === 0)) {
                    uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if (flipTile === Mesh.FLIP_N_ROTATE_ROW || (flipTile === Mesh.FLIP_N_ROTATE_TILE && tilesX % 2 === 0)) {
                    uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                uvs = uvs.concat(uvPart);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
            if (partialTopRow && partialLeftCol) {
                //top left corner
                positions.push(startX + adjustX, halfHeight + adjustY, 0);
                positions.push(-halfWidth + adjustX, halfHeight + adjustY, 0);
                positions.push(-halfWidth + adjustX, endY + adjustY, 0);
                positions.push(startX + adjustX, endY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                a = 1 - offsetX / tileWidth;
                b = 0;
                c = 1;
                d = offsetY / tileHeight;
                uvPart = [a, b, c, b, c, d, a, d];
                if ((flipTile === Mesh.ROTATE_ROW && tilesY % 2 === 1) || (flipTile === Mesh.ROTATE_TILE && tilesY % 1 === 0)) {
                    uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if ((flipTile === Mesh.FLIP_ROW && tilesY % 2 === 1) || (flipTile === Mesh.FLIP_TILE && tilesY % 2 === 0)) {
                    uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if ((flipTile === Mesh.FLIP_N_ROTATE_ROW && tilesY % 2 === 1) || (flipTile === Mesh.FLIP_N_ROTATE_TILE && tilesY % 2 === 0)) {
                    uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                uvs = uvs.concat(uvPart);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
            if (partialTopRow && partialRightCol) {
                //top right corner
                positions.push(halfWidth + adjustX, halfHeight + adjustY, 0);
                positions.push(endX + adjustX, halfHeight + adjustY, 0);
                positions.push(endX + adjustX, endY + adjustY, 0);
                positions.push(halfWidth + adjustX, endY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                a = 0;
                b = 0;
                c = offsetX / tileWidth;
                d = offsetY / tileHeight;
                uvPart = [a, b, c, b, c, d, a, d];
                if ((flipTile === Mesh.ROTATE_ROW && tilesY % 2 === 1) || (flipTile === Mesh.ROTATE_TILE && (tilesY + tilesX) % 2 === 1)) {
                    uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if ((flipTile === Mesh.FLIP_ROW && tilesY % 2 === 1) || (flipTile === Mesh.FLIP_TILE && (tilesY + tilesX) % 2 === 1)) {
                    uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if ((flipTile === Mesh.FLIP_N_ROTATE_ROW && tilesY % 2 === 1) || (flipTile === Mesh.FLIP_N_ROTATE_TILE && (tilesY + tilesX) % 2 === 1)) {
                    uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                uvs = uvs.concat(uvPart);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
            //part rows
            if (partialBottomRow) {
                const uvBaseBR = [];
                a = 0;
                b = 1 - offsetY / tileHeight;
                c = 1;
                d = 1;
                uvBaseBR[0] = [a, b, c, b, c, d, a, d];
                uvBaseBR[1] = [a, b, c, b, c, d, a, d];
                if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                    uvBaseBR[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                    uvBaseBR[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                    uvBaseBR[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                for (let x = 0; x < tilesX; x++) {
                    positions.push(-halfWidth + x * tileWidth + adjustX, startY + adjustY, 0);
                    positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + adjustY, 0);
                    positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                    positions.push(-halfWidth + x * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                        uvs = uvs.concat(uvBaseBR[(x + 1) % 2]);
                    }
                    else if (flipTile === Mesh.FLIP_ROW || flipTile === Mesh.ROTATE_ROW || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvs = uvs.concat(uvBaseBR[1]);
                    }
                    else {
                        uvs = uvs.concat(uvBaseBR[0]);
                    }
                    colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                    normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
                }
            }
            if (partialTopRow) {
                const uvBaseTR = [];
                a = 0;
                b = 0;
                c = 1;
                d = offsetY / tileHeight;
                uvBaseTR[0] = [a, b, c, b, c, d, a, d];
                uvBaseTR[1] = [a, b, c, b, c, d, a, d];
                if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                    uvBaseTR[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                    uvBaseTR[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                    uvBaseTR[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                for (let x = 0; x < tilesX; x++) {
                    positions.push(-halfWidth + x * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                    positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                    positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY + adjustY, 0);
                    positions.push(-halfWidth + x * tileWidth + adjustX, endY + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                        uvs = uvs.concat(uvBaseTR[(x + tilesY) % 2]);
                    }
                    else if (flipTile === Mesh.FLIP_ROW || flipTile === Mesh.ROTATE_ROW || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvs = uvs.concat(uvBaseTR[tilesY % 2]);
                    }
                    else {
                        uvs = uvs.concat(uvBaseTR[0]);
                    }
                    colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                    normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
                }
            }
            if (partialLeftCol) {
                const uvBaseLC = [];
                a = 1 - offsetX / tileWidth;
                b = 0;
                c = 1;
                d = 1;
                uvBaseLC[0] = [a, b, c, b, c, d, a, d];
                uvBaseLC[1] = [a, b, c, b, c, d, a, d];
                if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                    uvBaseLC[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                    uvBaseLC[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                    uvBaseLC[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                for (let y = 0; y < tilesY; y++) {
                    positions.push(startX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                    positions.push(startX + offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                    positions.push(startX + offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                    positions.push(startX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                        uvs = uvs.concat(uvBaseLC[(y + 1) % 2]);
                    }
                    else if (flipTile === Mesh.FLIP_ROW || flipTile === Mesh.ROTATE_ROW || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvs = uvs.concat(uvBaseLC[y % 2]);
                    }
                    else {
                        uvs = uvs.concat(uvBaseLC[0]);
                    }
                    colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                    normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
                }
            }
            if (partialRightCol) {
                const uvBaseRC = [];
                a = 0;
                b = 0;
                c = offsetX / tileHeight;
                d = 1;
                uvBaseRC[0] = [a, b, c, b, c, d, a, d];
                uvBaseRC[1] = [a, b, c, b, c, d, a, d];
                if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                    uvBaseRC[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                }
                if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                    uvBaseRC[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                }
                if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                    uvBaseRC[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                }
                for (let y = 0; y < tilesY; y++) {
                    positions.push(endX - offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                    positions.push(endX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                    positions.push(endX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                    positions.push(endX - offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                        uvs = uvs.concat(uvBaseRC[(y + tilesX) % 2]);
                    }
                    else if (flipTile === Mesh.FLIP_ROW || flipTile === Mesh.ROTATE_ROW || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvs = uvs.concat(uvBaseRC[y % 2]);
                    }
                    else {
                        uvs = uvs.concat(uvBaseRC[0]);
                    }
                    colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                    normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
                }
            }
        }
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        // sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        const totalColors = sideOrientation === VertexData.DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
        return vertexData;
    }
    /**
     * Creates a tiled plane mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/tiled_plane
     * @param name defines the name of the mesh
     * @param options an object used to set the following optional parameters for the tiled plane, required but can be empty
     * * pattern a limited pattern arrangement depending on the number
     * * size of the box
     * * width of the box, overwrites size
     * * height of the box, overwrites size
     * * tileSize sets the width, height and depth of the tile to the value of size, optional default 1
     * * tileWidth sets the width (x direction) of the tile, overwrites the width set by size, optional, default size
     * * tileHeight sets the height (y direction) of the tile, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * alignHorizontal places whole tiles aligned to the center, left or right of a row
     * * alignVertical places whole tiles aligned to the center, left or right of a column
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.pattern
     * @param options.tileSize
     * @param options.tileWidth
     * @param options.tileHeight
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.alignHorizontal
     * @param options.alignVertical
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the box mesh
     */
    function CreateTiledPlane(name, options, scene = null) {
        const plane = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        plane._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateTiledPlaneVertexData(options);
        vertexData.applyToMesh(plane, options.updatable);
        return plane;
    }
    VertexData.CreateTiledPlane = CreateTiledPlaneVertexData;

    /**
     * Creates the VertexData for a tiled box
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/tiled_box
     * @param options an object used to set the following optional parameters for the tiled box, required but can be empty
     * * pattern sets the rotation or reflection pattern for the tiles,
     * * size of the box
     * * width of the box, overwrites size
     * * height of the box, overwrites size
     * * depth of the box, overwrites size
     * * tileSize sets the size of a tile
     * * tileWidth sets the tile width and overwrites tileSize
     * * tileHeight sets the tile width and overwrites tileSize
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * alignHorizontal places whole tiles aligned to the center, left or right of a row
     * * alignVertical places whole tiles aligned to the center, left or right of a column
     * @param options.pattern
     * @param options.size
     * @param options.width
     * @param options.height
     * @param options.depth
     * @param options.tileSize
     * @param options.tileWidth
     * @param options.tileHeight
     * @param options.faceUV
     * @param options.faceColors
     * @param options.alignHorizontal
     * @param options.alignVertical
     * @param options.sideOrientation
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @returns the VertexData of the TiledBox
     */
    function CreateTiledBoxVertexData(options) {
        const nbFaces = 6;
        const faceUV = options.faceUV || new Array(6);
        const faceColors = options.faceColors;
        const flipTile = options.pattern || Mesh.NO_FLIP;
        const width = options.width || options.size || 1;
        const height = options.height || options.size || 1;
        const depth = options.depth || options.size || 1;
        const tileWidth = options.tileWidth || options.tileSize || 1;
        const tileHeight = options.tileHeight || options.tileSize || 1;
        const alignH = options.alignHorizontal || 0;
        const alignV = options.alignVertical || 0;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        // default face colors and UV if undefined
        for (let f = 0; f < nbFaces; f++) {
            if (faceUV[f] === undefined) {
                faceUV[f] = new Vector4(0, 0, 1, 1);
            }
            if (faceColors && faceColors[f] === undefined) {
                faceColors[f] = new Color4(1, 1, 1, 1);
            }
        }
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        const halfDepth = depth / 2;
        const faceVertexData = [];
        for (let f = 0; f < 2; f++) {
            //front and back
            faceVertexData[f] = CreateTiledPlaneVertexData({
                pattern: flipTile,
                tileWidth: tileWidth,
                tileHeight: tileHeight,
                width: width,
                height: height,
                alignVertical: alignV,
                alignHorizontal: alignH,
                sideOrientation: sideOrientation,
            });
        }
        for (let f = 2; f < 4; f++) {
            //sides
            faceVertexData[f] = CreateTiledPlaneVertexData({
                pattern: flipTile,
                tileWidth: tileWidth,
                tileHeight: tileHeight,
                width: depth,
                height: height,
                alignVertical: alignV,
                alignHorizontal: alignH,
                sideOrientation: sideOrientation,
            });
        }
        let baseAlignV = alignV;
        if (alignV === Mesh.BOTTOM) {
            baseAlignV = Mesh.TOP;
        }
        else if (alignV === Mesh.TOP) {
            baseAlignV = Mesh.BOTTOM;
        }
        for (let f = 4; f < 6; f++) {
            //top and bottom
            faceVertexData[f] = CreateTiledPlaneVertexData({
                pattern: flipTile,
                tileWidth: tileWidth,
                tileHeight: tileHeight,
                width: width,
                height: depth,
                alignVertical: baseAlignV,
                alignHorizontal: alignH,
                sideOrientation: sideOrientation,
            });
        }
        let positions = [];
        let normals = [];
        let uvs = [];
        let indices = [];
        const colors = [];
        const facePositions = [];
        const faceNormals = [];
        const newFaceUV = [];
        let lu = 0;
        let li = 0;
        for (let f = 0; f < nbFaces; f++) {
            const len = faceVertexData[f].positions.length;
            facePositions[f] = [];
            faceNormals[f] = [];
            for (let p = 0; p < len / 3; p++) {
                facePositions[f].push(new Vector3(faceVertexData[f].positions[3 * p], faceVertexData[f].positions[3 * p + 1], faceVertexData[f].positions[3 * p + 2]));
                faceNormals[f].push(new Vector3(faceVertexData[f].normals[3 * p], faceVertexData[f].normals[3 * p + 1], faceVertexData[f].normals[3 * p + 2]));
            }
            // uvs
            lu = faceVertexData[f].uvs.length;
            newFaceUV[f] = [];
            for (let i = 0; i < lu; i += 2) {
                newFaceUV[f][i] = faceUV[f].x + (faceUV[f].z - faceUV[f].x) * faceVertexData[f].uvs[i];
                newFaceUV[f][i + 1] = faceUV[f].y + (faceUV[f].w - faceUV[f].y) * faceVertexData[f].uvs[i + 1];
                if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                    newFaceUV[f][i + 1] = 1.0 - newFaceUV[f][i + 1];
                }
            }
            uvs = uvs.concat(newFaceUV[f]);
            indices = indices.concat(faceVertexData[f].indices.map((x) => x + li));
            li += facePositions[f].length;
            if (faceColors) {
                for (let c = 0; c < 4; c++) {
                    colors.push(faceColors[f].r, faceColors[f].g, faceColors[f].b, faceColors[f].a);
                }
            }
        }
        const vec0 = new Vector3(0, 0, halfDepth);
        const mtrx0 = Matrix.RotationY(Math.PI);
        positions = facePositions[0]
            .map((entry) => Vector3.TransformNormal(entry, mtrx0).add(vec0))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []);
        normals = faceNormals[0]
            .map((entry) => Vector3.TransformNormal(entry, mtrx0))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []);
        positions = positions.concat(facePositions[1]
            .map((entry) => entry.subtract(vec0))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        normals = normals.concat(faceNormals[1].map((entry) => [entry.x, entry.y, entry.z]).reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        const vec2 = new Vector3(halfWidth, 0, 0);
        const mtrx2 = Matrix.RotationY(-Math.PI / 2);
        positions = positions.concat(facePositions[2]
            .map((entry) => Vector3.TransformNormal(entry, mtrx2).add(vec2))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        normals = normals.concat(faceNormals[2]
            .map((entry) => Vector3.TransformNormal(entry, mtrx2))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        const mtrx3 = Matrix.RotationY(Math.PI / 2);
        positions = positions.concat(facePositions[3]
            .map((entry) => Vector3.TransformNormal(entry, mtrx3).subtract(vec2))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        normals = normals.concat(faceNormals[3]
            .map((entry) => Vector3.TransformNormal(entry, mtrx3))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        const vec4 = new Vector3(0, halfHeight, 0);
        const mtrx4 = Matrix.RotationX(Math.PI / 2);
        positions = positions.concat(facePositions[4]
            .map((entry) => Vector3.TransformNormal(entry, mtrx4).add(vec4))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        normals = normals.concat(faceNormals[4]
            .map((entry) => Vector3.TransformNormal(entry, mtrx4))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        const mtrx5 = Matrix.RotationX(-Math.PI / 2);
        positions = positions.concat(facePositions[5]
            .map((entry) => Vector3.TransformNormal(entry, mtrx5).subtract(vec4))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        normals = normals.concat(faceNormals[5]
            .map((entry) => Vector3.TransformNormal(entry, mtrx5))
            .map((entry) => [entry.x, entry.y, entry.z])
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []));
        // sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        if (faceColors) {
            const totalColors = sideOrientation === VertexData.DOUBLESIDE ? colors.concat(colors) : colors;
            vertexData.colors = totalColors;
        }
        return vertexData;
    }
    /**
     * Creates a tiled box mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/tiled_box
     * @param name defines the name of the mesh
     * @param options an object used to set the following optional parameters for the tiled box, required but can be empty
     * * pattern sets the rotation or reflection pattern for the tiles,
     * * size of the box
     * * width of the box, overwrites size
     * * height of the box, overwrites size
     * * depth of the box, overwrites size
     * * tileSize sets the size of a tile
     * * tileWidth sets the tile width and overwrites tileSize
     * * tileHeight sets the tile width and overwrites tileSize
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * alignHorizontal places whole tiles aligned to the center, left or right of a row
     * * alignVertical places whole tiles aligned to the center, left or right of a column
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @param options.pattern
     * @param options.width
     * @param options.height
     * @param options.depth
     * @param options.tileSize
     * @param options.tileWidth
     * @param options.tileHeight
     * @param options.alignHorizontal
     * @param options.alignVertical
     * @param options.faceUV
     * @param options.faceColors
     * @param options.sideOrientation
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the box mesh
     */
    function CreateTiledBox(name, options, scene = null) {
        const box = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        box._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateTiledBoxVertexData(options);
        vertexData.applyToMesh(box, options.updatable);
        return box;
    }
    VertexData.CreateTiledBox = CreateTiledBoxVertexData;

    // based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3D/src/away3d/primitives/TorusKnot.as?spec=svn2473&r=2473
    /**
     * Creates the VertexData for a TorusKnot
     * @param options an object used to set the following optional parameters for the TorusKnot, required but can be empty
     * * radius the radius of the torus knot, optional, default 2
     * * tube the thickness of the tube, optional, default 0.5
     * * radialSegments the number of sides on each tube segments, optional, default 32
     * * tubularSegments the number of tubes to decompose the knot into, optional, default 32
     * * p the number of windings around the z axis, optional,  default 2
     * * q the number of windings around the x axis, optional,  default 3
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.radius
     * @param options.tube
     * @param options.radialSegments
     * @param options.tubularSegments
     * @param options.p
     * @param options.q
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the Torus Knot
     */
    function CreateTorusKnotVertexData(options) {
        const indices = new Array();
        const positions = new Array();
        const normals = new Array();
        const uvs = new Array();
        const radius = options.radius || 2;
        const tube = options.tube || 0.5;
        const radialSegments = options.radialSegments || 32;
        const tubularSegments = options.tubularSegments || 32;
        const p = options.p || 2;
        const q = options.q || 3;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        // Helper
        const getPos = (angle) => {
            const cu = Math.cos(angle);
            const su = Math.sin(angle);
            const quOverP = (q / p) * angle;
            const cs = Math.cos(quOverP);
            const tx = radius * (2 + cs) * 0.5 * cu;
            const ty = radius * (2 + cs) * su * 0.5;
            const tz = radius * Math.sin(quOverP) * 0.5;
            return new Vector3(tx, ty, tz);
        };
        // Vertices
        let i;
        let j;
        for (i = 0; i <= radialSegments; i++) {
            const modI = i % radialSegments;
            const u = (modI / radialSegments) * 2 * p * Math.PI;
            const p1 = getPos(u);
            const p2 = getPos(u + 0.01);
            const tang = p2.subtract(p1);
            let n = p2.add(p1);
            const bitan = Vector3.Cross(tang, n);
            n = Vector3.Cross(bitan, tang);
            bitan.normalize();
            n.normalize();
            for (j = 0; j < tubularSegments; j++) {
                const modJ = j % tubularSegments;
                const v = (modJ / tubularSegments) * 2 * Math.PI;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                positions.push(p1.x + cx * n.x + cy * bitan.x);
                positions.push(p1.y + cx * n.y + cy * bitan.y);
                positions.push(p1.z + cx * n.z + cy * bitan.z);
                uvs.push(i / radialSegments);
                uvs.push(CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - j / tubularSegments : j / tubularSegments);
            }
        }
        for (i = 0; i < radialSegments; i++) {
            for (j = 0; j < tubularSegments; j++) {
                const jNext = (j + 1) % tubularSegments;
                const a = i * tubularSegments + j;
                const b = (i + 1) * tubularSegments + j;
                const c = (i + 1) * tubularSegments + jNext;
                const d = i * tubularSegments + jNext;
                indices.push(d);
                indices.push(b);
                indices.push(a);
                indices.push(d);
                indices.push(c);
                indices.push(b);
            }
        }
        // Normals
        VertexData.ComputeNormals(positions, indices, normals);
        // Sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a torus knot mesh
     * * The parameter `radius` sets the global radius size (float) of the torus knot (default 2)
     * * The parameter `radialSegments` sets the number of sides on each tube segments (positive integer, default 32)
     * * The parameter `tubularSegments` sets the number of tubes to decompose the knot into (positive integer, default 32)
     * * The parameters `p` and `q` are the number of windings on each axis (positive integers, default 2 and 3)
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.radius
     * @param options.tube
     * @param options.radialSegments
     * @param options.tubularSegments
     * @param options.p
     * @param options.q
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param scene defines the hosting scene
     * @returns the torus knot mesh
     * @see  https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#torus-knot
     */
    function CreateTorusKnot(name, options = {}, scene) {
        const torusKnot = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        torusKnot._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateTorusKnotVertexData(options);
        vertexData.applyToMesh(torusKnot, options.updatable);
        return torusKnot;
    }
    VertexData.CreateTorusKnot = CreateTorusKnotVertexData;
    Mesh.CreateTorusKnot = (name, radius, tube, radialSegments, tubularSegments, p, q, scene, updatable, sideOrientation) => {
        const options = {
            radius,
            tube,
            radialSegments,
            tubularSegments,
            p,
            q,
            sideOrientation,
            updatable,
        };
        return CreateTorusKnot(name, options, scene);
    };

    /**
     * Vector2 wth index property
     */
    class IndexedVector2 extends Vector2 {
        constructor(original, 
        /** Index of the vector2 */
        index) {
            super(original.x, original.y);
            this.index = index;
        }
    }
    /**
     * Defines points to create a polygon
     */
    class PolygonPoints {
        constructor() {
            this.elements = new Array();
        }
        add(originalPoints) {
            const result = new Array();
            originalPoints.forEach((point) => {
                const newPoint = new IndexedVector2(point, this.elements.length);
                result.push(newPoint);
                this.elements.push(newPoint);
            });
            return result;
        }
        computeBounds() {
            const lmin = new Vector2(this.elements[0].x, this.elements[0].y);
            const lmax = new Vector2(this.elements[0].x, this.elements[0].y);
            this.elements.forEach((point) => {
                // x
                if (point.x < lmin.x) {
                    lmin.x = point.x;
                }
                else if (point.x > lmax.x) {
                    lmax.x = point.x;
                }
                // y
                if (point.y < lmin.y) {
                    lmin.y = point.y;
                }
                else if (point.y > lmax.y) {
                    lmax.y = point.y;
                }
            });
            return {
                min: lmin,
                max: lmax,
                width: lmax.x - lmin.x,
                height: lmax.y - lmin.y,
            };
        }
    }
    /**
     * Builds a polygon
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/polyMeshBuilder
     */
    class PolygonMeshBuilder {
        _addToepoint(points) {
            for (const p of points) {
                this._epoints.push(p.x, p.y);
            }
        }
        /**
         * Creates a PolygonMeshBuilder
         * @param name name of the builder
         * @param contours Path of the polygon
         * @param scene scene to add to when creating the mesh
         * @param earcutInjection can be used to inject your own earcut reference
         */
        constructor(name, contours, scene, earcutInjection = earcut) {
            this._points = new PolygonPoints();
            this._outlinepoints = new PolygonPoints();
            this._holes = new Array();
            this._epoints = new Array();
            this._eholes = new Array();
            this.bjsEarcut = earcutInjection;
            this._name = name;
            this._scene = scene || EngineStore.LastCreatedScene;
            let points;
            if (contours instanceof Path2) {
                points = contours.getPoints();
            }
            else {
                points = contours;
            }
            this._addToepoint(points);
            this._points.add(points);
            this._outlinepoints.add(points);
            if (typeof this.bjsEarcut === "undefined") {
                Logger.Warn("Earcut was not found, the polygon will not be built.");
            }
        }
        /**
         * Adds a hole within the polygon
         * @param hole Array of points defining the hole
         * @returns this
         */
        addHole(hole) {
            this._points.add(hole);
            const holepoints = new PolygonPoints();
            holepoints.add(hole);
            this._holes.push(holepoints);
            this._eholes.push(this._epoints.length / 2);
            this._addToepoint(hole);
            return this;
        }
        /**
         * Creates the polygon
         * @param updatable If the mesh should be updatable
         * @param depth The depth of the mesh created
         * @param smoothingThreshold Dot product threshold for smoothed normals
         * @returns the created mesh
         */
        build(updatable = false, depth = 0, smoothingThreshold = 2) {
            const result = new Mesh(this._name, this._scene);
            const vertexData = this.buildVertexData(depth, smoothingThreshold);
            result.setVerticesData(VertexBuffer.PositionKind, vertexData.positions, updatable);
            result.setVerticesData(VertexBuffer.NormalKind, vertexData.normals, updatable);
            result.setVerticesData(VertexBuffer.UVKind, vertexData.uvs, updatable);
            result.setIndices(vertexData.indices);
            return result;
        }
        /**
         * Creates the polygon
         * @param depth The depth of the mesh created
         * @param smoothingThreshold Dot product threshold for smoothed normals
         * @returns the created VertexData
         */
        buildVertexData(depth = 0, smoothingThreshold = 2) {
            const result = new VertexData();
            const normals = new Array();
            const positions = new Array();
            const uvs = new Array();
            const bounds = this._points.computeBounds();
            this._points.elements.forEach((p) => {
                normals.push(0, 1.0, 0);
                positions.push(p.x, 0, p.y);
                uvs.push((p.x - bounds.min.x) / bounds.width, (p.y - bounds.min.y) / bounds.height);
            });
            const indices = new Array();
            const res = this.bjsEarcut(this._epoints, this._eholes, 2);
            for (let i = 0; i < res.length; i++) {
                indices.push(res[i]);
            }
            if (depth > 0) {
                const positionscount = positions.length / 3; //get the current pointcount
                this._points.elements.forEach((p) => {
                    //add the elements at the depth
                    normals.push(0, -1.0, 0);
                    positions.push(p.x, -depth, p.y);
                    uvs.push(1 - (p.x - bounds.min.x) / bounds.width, 1 - (p.y - bounds.min.y) / bounds.height);
                });
                const totalCount = indices.length;
                for (let i = 0; i < totalCount; i += 3) {
                    const i0 = indices[i + 0];
                    const i1 = indices[i + 1];
                    const i2 = indices[i + 2];
                    indices.push(i2 + positionscount);
                    indices.push(i1 + positionscount);
                    indices.push(i0 + positionscount);
                }
                //Add the sides
                this._addSide(positions, normals, uvs, indices, bounds, this._outlinepoints, depth, false, smoothingThreshold);
                this._holes.forEach((hole) => {
                    this._addSide(positions, normals, uvs, indices, bounds, hole, depth, true, smoothingThreshold);
                });
            }
            result.indices = indices;
            result.positions = positions;
            result.normals = normals;
            result.uvs = uvs;
            return result;
        }
        /**
         * Adds a side to the polygon
         * @param positions points that make the polygon
         * @param normals normals of the polygon
         * @param uvs uvs of the polygon
         * @param indices indices of the polygon
         * @param bounds bounds of the polygon
         * @param points points of the polygon
         * @param depth depth of the polygon
         * @param flip flip of the polygon
         * @param smoothingThreshold
         */
        _addSide(positions, normals, uvs, indices, bounds, points, depth, flip, smoothingThreshold) {
            let startIndex = positions.length / 3;
            let ulength = 0;
            for (let i = 0; i < points.elements.length; i++) {
                const p = points.elements[i];
                const p1 = points.elements[(i + 1) % points.elements.length];
                positions.push(p.x, 0, p.y);
                positions.push(p.x, -depth, p.y);
                positions.push(p1.x, 0, p1.y);
                positions.push(p1.x, -depth, p1.y);
                const p0 = points.elements[(i + points.elements.length - 1) % points.elements.length];
                const p2 = points.elements[(i + 2) % points.elements.length];
                let vc = new Vector3(-(p1.y - p.y), 0, p1.x - p.x);
                let vp = new Vector3(-(p.y - p0.y), 0, p.x - p0.x);
                let vn = new Vector3(-(p2.y - p1.y), 0, p2.x - p1.x);
                if (!flip) {
                    vc = vc.scale(-1);
                    vp = vp.scale(-1);
                    vn = vn.scale(-1);
                }
                const vc_norm = vc.normalizeToNew();
                let vp_norm = vp.normalizeToNew();
                let vn_norm = vn.normalizeToNew();
                const dotp = Vector3.Dot(vp_norm, vc_norm);
                if (dotp > smoothingThreshold) {
                    if (dotp < Epsilon - 1) {
                        vp_norm = new Vector3(p.x, 0, p.y).subtract(new Vector3(p1.x, 0, p1.y)).normalize();
                    }
                    else {
                        // cheap average weighed by side length
                        vp_norm = vp.add(vc).normalize();
                    }
                }
                else {
                    vp_norm = vc_norm;
                }
                const dotn = Vector3.Dot(vn, vc);
                if (dotn > smoothingThreshold) {
                    if (dotn < Epsilon - 1) {
                        // back to back
                        vn_norm = new Vector3(p1.x, 0, p1.y).subtract(new Vector3(p.x, 0, p.y)).normalize();
                    }
                    else {
                        // cheap average weighed by side length
                        vn_norm = vn.add(vc).normalize();
                    }
                }
                else {
                    vn_norm = vc_norm;
                }
                uvs.push(ulength / bounds.width, 0);
                uvs.push(ulength / bounds.width, 1);
                ulength += vc.length();
                uvs.push(ulength / bounds.width, 0);
                uvs.push(ulength / bounds.width, 1);
                normals.push(vp_norm.x, vp_norm.y, vp_norm.z);
                normals.push(vp_norm.x, vp_norm.y, vp_norm.z);
                normals.push(vn_norm.x, vn_norm.y, vn_norm.z);
                normals.push(vn_norm.x, vn_norm.y, vn_norm.z);
                if (!flip) {
                    indices.push(startIndex);
                    indices.push(startIndex + 1);
                    indices.push(startIndex + 2);
                    indices.push(startIndex + 1);
                    indices.push(startIndex + 3);
                    indices.push(startIndex + 2);
                }
                else {
                    indices.push(startIndex);
                    indices.push(startIndex + 2);
                    indices.push(startIndex + 1);
                    indices.push(startIndex + 1);
                    indices.push(startIndex + 2);
                    indices.push(startIndex + 3);
                }
                startIndex += 4;
            }
        }
    }

    /**
     * Creates the VertexData for an irregular Polygon in the XoZ plane using a mesh built by polygonTriangulation.build()
     * All parameters are provided by CreatePolygon as needed
     * @param polygon a mesh built from polygonTriangulation.build()
     * @param sideOrientation takes the values Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @param fUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * @param fColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * @param frontUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * @param backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param wrp a boolean, default false, when true and fUVs used texture is wrapped around all sides, when false texture is applied side
     * @returns the VertexData of the Polygon
     */
    function CreatePolygonVertexData(polygon, sideOrientation, fUV, fColors, frontUVs, backUVs, wrp) {
        const faceUV = fUV || new Array(3);
        const faceColors = fColors;
        const colors = [];
        const wrap = wrp || false;
        // default face colors and UV if undefined
        for (let f = 0; f < 3; f++) {
            if (faceUV[f] === undefined) {
                faceUV[f] = new Vector4(0, 0, 1, 1);
            }
            if (faceColors && faceColors[f] === undefined) {
                faceColors[f] = new Color4(1, 1, 1, 1);
            }
        }
        const positions = polygon.getVerticesData(VertexBuffer.PositionKind);
        const normals = polygon.getVerticesData(VertexBuffer.NormalKind);
        const uvs = polygon.getVerticesData(VertexBuffer.UVKind);
        const indices = polygon.getIndices();
        const startIndex = positions.length / 9;
        let disp = 0;
        let distX = 0;
        let distZ = 0;
        let dist = 0;
        let totalLen = 0;
        const cumulate = [0];
        if (wrap) {
            for (let idx = startIndex; idx < positions.length / 3; idx += 4) {
                distX = positions[3 * (idx + 2)] - positions[3 * idx];
                distZ = positions[3 * (idx + 2) + 2] - positions[3 * idx + 2];
                dist = Math.sqrt(distX * distX + distZ * distZ);
                totalLen += dist;
                cumulate.push(totalLen);
            }
        }
        // set face colours and textures
        let idx = 0;
        let face = 0;
        for (let index = 0; index < normals.length; index += 3) {
            //Edge Face  no. 1
            if (Math.abs(normals[index + 1]) < 0.001) {
                face = 1;
            }
            //Top Face  no. 0
            if (Math.abs(normals[index + 1] - 1) < 0.001) {
                face = 0;
            }
            //Bottom Face  no. 2
            if (Math.abs(normals[index + 1] + 1) < 0.001) {
                face = 2;
            }
            idx = index / 3;
            if (face === 1) {
                disp = idx - startIndex;
                if (disp % 4 < 1.5) {
                    if (wrap) {
                        uvs[2 * idx] = faceUV[face].x + ((faceUV[face].z - faceUV[face].x) * cumulate[Math.floor(disp / 4)]) / totalLen;
                    }
                    else {
                        uvs[2 * idx] = faceUV[face].x;
                    }
                }
                else {
                    if (wrap) {
                        uvs[2 * idx] = faceUV[face].x + ((faceUV[face].z - faceUV[face].x) * cumulate[Math.floor(disp / 4) + 1]) / totalLen;
                    }
                    else {
                        uvs[2 * idx] = faceUV[face].z;
                    }
                }
                if (disp % 2 === 0) {
                    uvs[2 * idx + 1] = CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - faceUV[face].w : faceUV[face].w;
                }
                else {
                    uvs[2 * idx + 1] = CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - faceUV[face].y : faceUV[face].y;
                }
            }
            else {
                uvs[2 * idx] = (1 - uvs[2 * idx]) * faceUV[face].x + uvs[2 * idx] * faceUV[face].z;
                uvs[2 * idx + 1] = (1 - uvs[2 * idx + 1]) * faceUV[face].y + uvs[2 * idx + 1] * faceUV[face].w;
                if (CompatibilityOptions.UseOpenGLOrientationForUV) {
                    uvs[2 * idx + 1] = 1.0 - uvs[2 * idx + 1];
                }
            }
            if (faceColors) {
                colors.push(faceColors[face].r, faceColors[face].g, faceColors[face].b, faceColors[face].a);
            }
        }
        // sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, frontUVs, backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        if (faceColors) {
            const totalColors = sideOrientation === VertexData.DOUBLESIDE ? colors.concat(colors) : colors;
            vertexData.colors = totalColors;
        }
        return vertexData;
    }
    /**
     * Creates a polygon mesh
     * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh
     * * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
     * * You can set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4)
     * * Remember you can only change the shape positions, not their number when updating a polygon
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.shape
     * @param options.holes
     * @param options.depth
     * @param options.smoothingThreshold
     * @param options.faceUV
     * @param options.faceColors
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.wrap
     * @param scene defines the hosting scene
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns the polygon mesh
     */
    function CreatePolygon(name, options, scene = null, earcutInjection = earcut) {
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        const shape = options.shape;
        const holes = options.holes || [];
        const depth = options.depth || 0;
        const smoothingThreshold = options.smoothingThreshold || 2;
        const contours = [];
        let hole = [];
        for (let i = 0; i < shape.length; i++) {
            contours[i] = new Vector2(shape[i].x, shape[i].z);
        }
        const epsilon = 0.00000001;
        if (contours[0].equalsWithEpsilon(contours[contours.length - 1], epsilon)) {
            contours.pop();
        }
        const polygonTriangulation = new PolygonMeshBuilder(name, contours, scene || EngineStore.LastCreatedScene, earcutInjection);
        for (let hNb = 0; hNb < holes.length; hNb++) {
            hole = [];
            for (let hPoint = 0; hPoint < holes[hNb].length; hPoint++) {
                hole.push(new Vector2(holes[hNb][hPoint].x, holes[hNb][hPoint].z));
            }
            polygonTriangulation.addHole(hole);
        }
        //updatability is set during applyToMesh; setting to true in triangulation build produces errors
        const polygon = polygonTriangulation.build(false, depth, smoothingThreshold);
        polygon._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreatePolygonVertexData(polygon, options.sideOrientation, options.faceUV, options.faceColors, options.frontUVs, options.backUVs, options.wrap);
        vertexData.applyToMesh(polygon, options.updatable);
        return polygon;
    }
    /**
     * Creates an extruded polygon mesh, with depth in the Y direction.
     * * You can set different colors and different images to the top, bottom and extruded side by using the parameters `faceColors` (an array of 3 Color3 elements) and `faceUV` (an array of 3 Vector4 elements)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.shape
     * @param options.holes
     * @param options.depth
     * @param options.faceUV
     * @param options.faceColors
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.wrap
     * @param scene defines the hosting scene
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns the polygon mesh
     */
    function ExtrudePolygon(name, options, scene = null, earcutInjection = earcut) {
        return CreatePolygon(name, options, scene, earcutInjection);
    }
    VertexData.CreatePolygon = CreatePolygonVertexData;
    Mesh.CreatePolygon = (name, shape, scene, holes, updatable, sideOrientation, earcutInjection = earcut) => {
        const options = {
            shape: shape,
            holes: holes,
            updatable: updatable,
            sideOrientation: sideOrientation,
        };
        return CreatePolygon(name, options, scene, earcutInjection);
    };
    Mesh.ExtrudePolygon = (name, shape, depth, scene, holes, updatable, sideOrientation, earcutInjection = earcut) => {
        const options = {
            shape: shape,
            holes: holes,
            depth: depth,
            updatable: updatable,
            sideOrientation: sideOrientation,
        };
        return ExtrudePolygon(name, options, scene, earcutInjection);
    };

    /**
     * Creates an extruded shape mesh. The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
     * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis.
     * * The parameter `path` is a required array of successive Vector3. This is the axis curve the shape is extruded along.
     * * The parameter `rotation` (float, default 0 radians) is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve.
     * * The parameter `scale` (float, default 1) is the value to scale the shape.
     * * The parameter `closeShape` (boolean, default false) closes the shape when true, since v5.0.0.
     * * The parameter `closePath` (boolean, default false) closes the path when true and no caps, since v5.0.0.
     * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
     * * The optional parameter `instance` is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#extruded-shape
     * * Remember you can only change the shape or path point positions, not their number when updating an extruded shape.
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture.
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * * The optional parameter `firstNormal` (Vector3) defines the direction of the first normal of the supplied path. Consider using this for any path that is straight, and particular for paths in the xy plane.
     * * The optional `adjustFrame` (boolean, default false) will cause the internally generated Path3D tangents, normals, and binormals to be adjusted so that a) they are always well-defined, and b) they do not reverse from one path point to the next. This prevents the extruded shape from being flipped and/or rotated with resulting mesh self-intersections. This is primarily useful for straight paths that can reverse direction.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.shape
     * @param options.path
     * @param options.scale
     * @param options.rotation
     * @param options.closeShape
     * @param options.closePath
     * @param options.cap
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.instance
     * @param options.invertUV
     * @param options.firstNormal
     * @param options.adjustFrame
     * @param scene defines the hosting scene
     * @returns the extruded shape mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
     */
    function ExtrudeShape(name, options, scene = null) {
        const path = options.path;
        const shape = options.shape;
        const scale = options.scale || 1;
        const rotation = options.rotation || 0;
        const cap = options.cap === 0 ? 0 : options.cap || Mesh.NO_CAP;
        const updatable = options.updatable;
        const sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        const instance = options.instance || null;
        const invertUV = options.invertUV || false;
        const closeShape = options.closeShape || false;
        const closePath = options.closePath || false;
        return _ExtrudeShapeGeneric(name, shape, path, scale, rotation, null, null, closePath, closeShape, cap, false, scene, updatable ? true : false, sideOrientation, instance, invertUV, options.frontUVs || null, options.backUVs || null, options.firstNormal || null, options.adjustFrame ? true : false);
    }
    /**
     * Creates an custom extruded shape mesh.
     * The custom extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
     * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis.
     * * The parameter `path` is a required array of successive Vector3. This is the axis curve the shape is extruded along.
     * * The parameter `rotationFunction` (JS function) is a custom Javascript function called on each path point. This function is passed the position i of the point in the path and the distance of this point from the beginning of the path
     * * It must returns a float value that will be the rotation in radians applied to the shape on each path point.
     * * The parameter `scaleFunction` (JS function) is a custom Javascript function called on each path point. This function is passed the position i of the point in the path and the distance of this point from the beginning of the path
     * * It must returns a float value that will be the scale value applied to the shape on each path point
     * * The parameter `closeShape` (boolean, default false) closes the shape when true, since v5.0.0.
     * * The parameter `closePath` (boolean, default false) closes the path when true and no caps, since v5.0.0.
     * * The parameter `ribbonClosePath` (boolean, default false) forces the extrusion underlying ribbon to close all the paths in its `pathArray` - depreciated in favor of closeShape
     * * The parameter `ribbonCloseArray` (boolean, default false) forces the extrusion underlying ribbon to close its `pathArray` - depreciated in favor of closePath
     * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
     * * The optional parameter `instance` is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#extruded-shape
     * * Remember you can only change the shape or path point positions, not their number when updating an extruded shape
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * * The optional parameter `firstNormal` (Vector3) defines the direction of the first normal of the supplied path. It should be supplied when the path is in the xy plane, and particularly if these sections are straight, because the underlying Path3D object will pick a normal in the xy plane that causes the extrusion to be collapsed into the plane. This should be used for any path that is straight.
     * * The optional `adjustFrame` (boolean, default false) will cause the internally generated Path3D tangents, normals, and binormals to be adjusted so that a) they are always well-defined, and b) they do not reverse from one path point to the next. This prevents the extruded shape from being flipped and/or rotated with resulting mesh self-intersections. This is primarily useful for straight paths that can reverse direction.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.shape
     * @param options.path
     * @param options.scaleFunction
     * @param options.rotationFunction
     * @param options.ribbonCloseArray
     * @param options.ribbonClosePath
     * @param options.closeShape
     * @param options.closePath
     * @param options.cap
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.instance
     * @param options.invertUV
     * @param options.firstNormal
     * @param options.adjustFrame
     * @param scene defines the hosting scene
     * @returns the custom extruded shape mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#custom-extruded-shapes
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
     */
    function ExtrudeShapeCustom(name, options, scene = null) {
        const path = options.path;
        const shape = options.shape;
        const scaleFunction = options.scaleFunction ||
            (() => {
                return 1;
            });
        const rotationFunction = options.rotationFunction ||
            (() => {
                return 0;
            });
        const ribbonCloseArray = options.closePath || options.ribbonCloseArray || false;
        const ribbonClosePath = options.closeShape || options.ribbonClosePath || false;
        const cap = options.cap === 0 ? 0 : options.cap || Mesh.NO_CAP;
        const updatable = options.updatable;
        const firstNormal = options.firstNormal || null;
        const adjustFrame = options.adjustFrame || false;
        const sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        const instance = options.instance;
        const invertUV = options.invertUV || false;
        return _ExtrudeShapeGeneric(name, shape, path, null, null, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, true, scene, updatable ? true : false, sideOrientation, instance || null, invertUV, options.frontUVs || null, options.backUVs || null, firstNormal, adjustFrame);
    }
    function _ExtrudeShapeGeneric(name, shape, curve, scale, rotation, scaleFunction, rotateFunction, rbCA, rbCP, cap, custom, scene, updtbl, side, instance, invertUV, frontUVs, backUVs, firstNormal, adjustFrame) {
        // extrusion geometry
        const extrusionPathArray = (shape, curve, path3D, shapePaths, scale, rotation, scaleFunction, rotateFunction, cap, custom, adjustFrame) => {
            const tangents = path3D.getTangents();
            const normals = path3D.getNormals();
            const binormals = path3D.getBinormals();
            const distances = path3D.getDistances();
            if (adjustFrame) {
                /* fix tangents,normals, binormals */
                for (let i = 0; i < tangents.length; i++) {
                    if (tangents[i].x == 0 && tangents[i].y == 0 && tangents[i].z == 0) {
                        tangents[i].copyFrom(tangents[i - 1]);
                    }
                    if (normals[i].x == 0 && normals[i].y == 0 && normals[i].z == 0) {
                        normals[i].copyFrom(normals[i - 1]);
                    }
                    if (binormals[i].x == 0 && binormals[i].y == 0 && binormals[i].z == 0) {
                        binormals[i].copyFrom(binormals[i - 1]);
                    }
                    if (i > 0) {
                        let v = tangents[i - 1];
                        if (Vector3.Dot(v, tangents[i]) < 0) {
                            tangents[i].scaleInPlace(-1);
                        }
                        v = normals[i - 1];
                        if (Vector3.Dot(v, normals[i]) < 0) {
                            normals[i].scaleInPlace(-1);
                        }
                        v = binormals[i - 1];
                        if (Vector3.Dot(v, binormals[i]) < 0) {
                            binormals[i].scaleInPlace(-1);
                        }
                    }
                }
            }
            let angle = 0;
            const returnScale = () => {
                return scale !== null ? scale : 1;
            };
            const returnRotation = () => {
                return rotation !== null ? rotation : 0;
            };
            const rotate = custom && rotateFunction ? rotateFunction : returnRotation;
            const scl = custom && scaleFunction ? scaleFunction : returnScale;
            let index = cap === Mesh.NO_CAP || cap === Mesh.CAP_END ? 0 : 2;
            const rotationMatrix = TmpVectors.Matrix[0];
            for (let i = 0; i < curve.length; i++) {
                const shapePath = new Array();
                const angleStep = rotate(i, distances[i]);
                const scaleRatio = scl(i, distances[i]);
                Matrix.RotationAxisToRef(tangents[i], angle, rotationMatrix);
                for (let p = 0; p < shape.length; p++) {
                    const planed = tangents[i].scale(shape[p].z).add(normals[i].scale(shape[p].x)).add(binormals[i].scale(shape[p].y));
                    const rotated = Vector3.Zero();
                    Vector3.TransformCoordinatesToRef(planed, rotationMatrix, rotated);
                    rotated.scaleInPlace(scaleRatio).addInPlace(curve[i]);
                    shapePath[p] = rotated;
                }
                shapePaths[index] = shapePath;
                angle += angleStep;
                index++;
            }
            // cap
            const capPath = (shapePath) => {
                const pointCap = Array();
                const barycenter = Vector3.Zero();
                let i;
                for (i = 0; i < shapePath.length; i++) {
                    barycenter.addInPlace(shapePath[i]);
                }
                barycenter.scaleInPlace(1.0 / shapePath.length);
                for (i = 0; i < shapePath.length; i++) {
                    pointCap.push(barycenter);
                }
                return pointCap;
            };
            switch (cap) {
                case Mesh.NO_CAP:
                    break;
                case Mesh.CAP_START:
                    shapePaths[0] = capPath(shapePaths[2]);
                    shapePaths[1] = shapePaths[2];
                    break;
                case Mesh.CAP_END:
                    shapePaths[index] = shapePaths[index - 1];
                    shapePaths[index + 1] = capPath(shapePaths[index - 1]);
                    break;
                case Mesh.CAP_ALL:
                    shapePaths[0] = capPath(shapePaths[2]);
                    shapePaths[1] = shapePaths[2];
                    shapePaths[index] = shapePaths[index - 1];
                    shapePaths[index + 1] = capPath(shapePaths[index - 1]);
                    break;
            }
            return shapePaths;
        };
        let path3D;
        let pathArray;
        if (instance) {
            // instance update
            const storage = instance._creationDataStorage;
            path3D = firstNormal ? storage.path3D.update(curve, firstNormal) : storage.path3D.update(curve);
            pathArray = extrusionPathArray(shape, curve, storage.path3D, storage.pathArray, scale, rotation, scaleFunction, rotateFunction, storage.cap, custom, adjustFrame);
            instance = CreateRibbon("", { pathArray, closeArray: false, closePath: false, offset: 0, updatable: false, sideOrientation: 0, instance }, scene || undefined);
            return instance;
        }
        // extruded shape creation
        path3D = firstNormal ? new Path3D(curve, firstNormal) : new Path3D(curve);
        const newShapePaths = new Array();
        cap = cap < 0 || cap > 3 ? 0 : cap;
        pathArray = extrusionPathArray(shape, curve, path3D, newShapePaths, scale, rotation, scaleFunction, rotateFunction, cap, custom, adjustFrame);
        const extrudedGeneric = CreateRibbon(name, {
            pathArray: pathArray,
            closeArray: rbCA,
            closePath: rbCP,
            updatable: updtbl,
            sideOrientation: side,
            invertUV: invertUV,
            frontUVs: frontUVs || undefined,
            backUVs: backUVs || undefined,
        }, scene);
        extrudedGeneric._creationDataStorage.pathArray = pathArray;
        extrudedGeneric._creationDataStorage.path3D = path3D;
        extrudedGeneric._creationDataStorage.cap = cap;
        return extrudedGeneric;
    }
    Mesh.ExtrudeShape = (name, shape, path, scale, rotation, cap, scene = null, updatable, sideOrientation, instance) => {
        const options = {
            shape: shape,
            path: path,
            scale: scale,
            rotation: rotation,
            cap: cap === 0 ? 0 : cap || Mesh.NO_CAP,
            sideOrientation: sideOrientation,
            instance: instance,
            updatable: updatable,
        };
        return ExtrudeShape(name, options, scene);
    };
    Mesh.ExtrudeShapeCustom = (name, shape, path, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, scene, updatable, sideOrientation, instance) => {
        const options = {
            shape: shape,
            path: path,
            scaleFunction: scaleFunction,
            rotationFunction: rotationFunction,
            ribbonCloseArray: ribbonCloseArray,
            ribbonClosePath: ribbonClosePath,
            cap: cap === 0 ? 0 : cap || Mesh.NO_CAP,
            sideOrientation: sideOrientation,
            instance: instance,
            updatable: updatable,
        };
        return ExtrudeShapeCustom(name, options, scene);
    };

    /**
     * Creates lathe mesh.
     * The lathe is a shape with a symmetry axis : a 2D model shape is rotated around this axis to design the lathe
     * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
     * * The parameter `radius` (positive float, default 1) is the radius value of the lathe
     * * The parameter `tessellation` (positive integer, default 64) is the side number of the lathe
     * * The parameter `clip` (positive integer, default 0) is the number of sides to not create without effecting the general shape of the sides
     * * The parameter `arc` (positive float, default 1) is the ratio of the lathe. 0.5 builds for instance half a lathe, so an opened shape
     * * The parameter `closed` (boolean, default true) opens/closes the lathe circumference. This should be set to false when used with the parameter "arc"
     * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.shape
     * @param options.radius
     * @param options.tessellation
     * @param options.clip
     * @param options.arc
     * @param options.closed
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.cap
     * @param options.invertUV
     * @param scene defines the hosting scene
     * @returns the lathe mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#lathe
     */
    function CreateLathe(name, options, scene = null) {
        const arc = options.arc ? (options.arc <= 0 || options.arc > 1 ? 1.0 : options.arc) : 1.0;
        const closed = options.closed === undefined ? true : options.closed;
        const shape = options.shape;
        const radius = options.radius || 1;
        const tessellation = options.tessellation || 64;
        const clip = options.clip || 0;
        const updatable = options.updatable;
        const sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        const cap = options.cap || Mesh.NO_CAP;
        const pi2 = Math.PI * 2;
        const paths = new Array();
        const invertUV = options.invertUV || false;
        let i = 0;
        let p = 0;
        const step = (pi2 / tessellation) * arc;
        let rotated;
        let path;
        for (i = 0; i <= tessellation - clip; i++) {
            path = [];
            if (cap == Mesh.CAP_START || cap == Mesh.CAP_ALL) {
                path.push(new Vector3(0, shape[0].y, 0));
                path.push(new Vector3(Math.cos(i * step) * shape[0].x * radius, shape[0].y, Math.sin(i * step) * shape[0].x * radius));
            }
            for (p = 0; p < shape.length; p++) {
                rotated = new Vector3(Math.cos(i * step) * shape[p].x * radius, shape[p].y, Math.sin(i * step) * shape[p].x * radius);
                path.push(rotated);
            }
            if (cap == Mesh.CAP_END || cap == Mesh.CAP_ALL) {
                path.push(new Vector3(Math.cos(i * step) * shape[shape.length - 1].x * radius, shape[shape.length - 1].y, Math.sin(i * step) * shape[shape.length - 1].x * radius));
                path.push(new Vector3(0, shape[shape.length - 1].y, 0));
            }
            paths.push(path);
        }
        // lathe ribbon
        const lathe = CreateRibbon(name, { pathArray: paths, closeArray: closed, sideOrientation: sideOrientation, updatable: updatable, invertUV: invertUV, frontUVs: options.frontUVs, backUVs: options.backUVs }, scene);
        return lathe;
    }
    Mesh.CreateLathe = (name, shape, radius, tessellation, scene, updatable, sideOrientation) => {
        const options = {
            shape: shape,
            radius: radius,
            tessellation: tessellation,
            sideOrientation: sideOrientation,
            updatable: updatable,
        };
        return CreateLathe(name, options, scene);
    };

    /**
     * Creates a tube mesh.
     * The tube is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters
     * * The parameter `path` is a required array of successive Vector3. It is the curve used as the axis of the tube
     * * The parameter `radius` (positive float, default 1) sets the tube radius size
     * * The parameter `tessellation` (positive float, default 64) is the number of sides on the tubular surface
     * * The parameter `radiusFunction` (javascript function, default null) is a vanilla javascript function. If it is not null, it overrides the parameter `radius`
     * * This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path. It must return a radius value (positive float)
     * * The parameter `arc` (positive float, maximum 1, default 1) is the ratio to apply to the tube circumference : 2 x PI x arc
     * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
     * * The optional parameter `instance` is an instance of an existing Tube object to be updated with the passed `pathArray` parameter. The `path`Array HAS to have the SAME number of points as the previous one: https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#tube
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created. The NUMBER of points CAN'T CHANGE, only their positions.
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.path
     * @param options.radius
     * @param options.tessellation
     * @param options.radiusFunction
     * @param options.cap
     * @param options.arc
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.instance
     * @param options.invertUV
     * @param scene defines the hosting scene
     * @returns the tube mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#tube
     */
    function CreateTube(name, options, scene = null) {
        const path = options.path;
        let instance = options.instance;
        let radius = 1.0;
        if (options.radius !== undefined) {
            radius = options.radius;
        }
        else if (instance) {
            radius = instance._creationDataStorage.radius;
        }
        const tessellation = options.tessellation || 64 | 0;
        const radiusFunction = options.radiusFunction || null;
        let cap = options.cap || Mesh.NO_CAP;
        const invertUV = options.invertUV || false;
        const updatable = options.updatable;
        const sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        options.arc = options.arc && (options.arc <= 0.0 || options.arc > 1.0) ? 1.0 : options.arc || 1.0;
        // tube geometry
        const tubePathArray = (path, path3D, circlePaths, radius, tessellation, radiusFunction, cap, arc) => {
            const tangents = path3D.getTangents();
            const normals = path3D.getNormals();
            const distances = path3D.getDistances();
            const pi2 = Math.PI * 2;
            const step = (pi2 / tessellation) * arc;
            const returnRadius = () => radius;
            const radiusFunctionFinal = radiusFunction || returnRadius;
            let circlePath;
            let rad;
            let normal;
            let rotated;
            const rotationMatrix = TmpVectors.Matrix[0];
            let index = cap === Mesh.NO_CAP || cap === Mesh.CAP_END ? 0 : 2;
            for (let i = 0; i < path.length; i++) {
                rad = radiusFunctionFinal(i, distances[i]); // current radius
                circlePath = Array(); // current circle array
                normal = normals[i]; // current normal
                for (let t = 0; t < tessellation; t++) {
                    Matrix.RotationAxisToRef(tangents[i], step * t, rotationMatrix);
                    rotated = circlePath[t] ? circlePath[t] : Vector3.Zero();
                    Vector3.TransformCoordinatesToRef(normal, rotationMatrix, rotated);
                    rotated.scaleInPlace(rad).addInPlace(path[i]);
                    circlePath[t] = rotated;
                }
                circlePaths[index] = circlePath;
                index++;
            }
            // cap
            const capPath = (nbPoints, pathIndex) => {
                const pointCap = Array();
                for (let i = 0; i < nbPoints; i++) {
                    pointCap.push(path[pathIndex]);
                }
                return pointCap;
            };
            switch (cap) {
                case Mesh.NO_CAP:
                    break;
                case Mesh.CAP_START:
                    circlePaths[0] = capPath(tessellation, 0);
                    circlePaths[1] = circlePaths[2].slice(0);
                    break;
                case Mesh.CAP_END:
                    circlePaths[index] = circlePaths[index - 1].slice(0);
                    circlePaths[index + 1] = capPath(tessellation, path.length - 1);
                    break;
                case Mesh.CAP_ALL:
                    circlePaths[0] = capPath(tessellation, 0);
                    circlePaths[1] = circlePaths[2].slice(0);
                    circlePaths[index] = circlePaths[index - 1].slice(0);
                    circlePaths[index + 1] = capPath(tessellation, path.length - 1);
                    break;
            }
            return circlePaths;
        };
        let path3D;
        let pathArray;
        if (instance) {
            // tube update
            const storage = instance._creationDataStorage;
            const arc = options.arc || storage.arc;
            path3D = storage.path3D.update(path);
            pathArray = tubePathArray(path, path3D, storage.pathArray, radius, storage.tessellation, radiusFunction, storage.cap, arc);
            instance = CreateRibbon("", { pathArray: pathArray, instance: instance });
            // Update mode, no need to recreate the storage.
            storage.path3D = path3D;
            storage.pathArray = pathArray;
            storage.arc = arc;
            storage.radius = radius;
            return instance;
        }
        // tube creation
        path3D = new Path3D(path);
        const newPathArray = new Array();
        cap = cap < 0 || cap > 3 ? 0 : cap;
        pathArray = tubePathArray(path, path3D, newPathArray, radius, tessellation, radiusFunction, cap, options.arc);
        const tube = CreateRibbon(name, {
            pathArray: pathArray,
            closePath: true,
            closeArray: false,
            updatable: updatable,
            sideOrientation: sideOrientation,
            invertUV: invertUV,
            frontUVs: options.frontUVs,
            backUVs: options.backUVs,
        }, scene);
        tube._creationDataStorage.pathArray = pathArray;
        tube._creationDataStorage.path3D = path3D;
        tube._creationDataStorage.tessellation = tessellation;
        tube._creationDataStorage.cap = cap;
        tube._creationDataStorage.arc = options.arc;
        tube._creationDataStorage.radius = radius;
        return tube;
    }
    Mesh.CreateTube = (name, path, radius, tessellation, radiusFunction, cap, scene, updatable, sideOrientation, instance) => {
        const options = {
            path: path,
            radius: radius,
            tessellation: tessellation,
            radiusFunction: radiusFunction,
            arc: 1,
            cap: cap,
            updatable: updatable,
            sideOrientation: sideOrientation,
            instance: instance,
        };
        return CreateTube(name, options, scene);
    };

    // inspired from // http://stemkoski.github.io/Three.js/Polyhedra.html
    /**
     * Creates the VertexData for a Polyhedron
     * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
     * * type provided types are:
     *  * 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
     *  * 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
     * * size the size of the IcoSphere, optional default 1
     * * sizeX allows stretching in the x direction, optional, default size
     * * sizeY allows stretching in the y direction, optional, default size
     * * sizeZ allows stretching in the z direction, optional, default size
     * * custom a number that overwrites the type to create from an extended set of polyhedron from https://www.babylonjs-playground.com/#21QRSK#15 with minimised editor
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.type
     * @param options.size
     * @param options.sizeX
     * @param options.sizeY
     * @param options.sizeZ
     * @param options.custom
     * @param options.faceUV
     * @param options.faceColors
     * @param options.flat
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the Polyhedron
     */
    function CreatePolyhedronVertexData(options) {
        // provided polyhedron types :
        // 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
        // 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
        const polyhedra = [];
        polyhedra[0] = {
            vertex: [
                [0, 0, 1.732051],
                [1.632993, 0, -0.5773503],
                [-0.8164966, 1.414214, -0.5773503],
                [-0.8164966, -1.414214, -0.5773503],
            ],
            face: [
                [0, 1, 2],
                [0, 2, 3],
                [0, 3, 1],
                [1, 3, 2],
            ],
        };
        polyhedra[1] = {
            vertex: [
                [0, 0, 1.414214],
                [1.414214, 0, 0],
                [0, 1.414214, 0],
                [-1.414214, 0, 0],
                [0, -1.414214, 0],
                [0, 0, -1.414214],
            ],
            face: [
                [0, 1, 2],
                [0, 2, 3],
                [0, 3, 4],
                [0, 4, 1],
                [1, 4, 5],
                [1, 5, 2],
                [2, 5, 3],
                [3, 5, 4],
            ],
        };
        polyhedra[2] = {
            vertex: [
                [0, 0, 1.070466],
                [0.7136442, 0, 0.7978784],
                [-0.3568221, 0.618034, 0.7978784],
                [-0.3568221, -0.618034, 0.7978784],
                [0.7978784, 0.618034, 0.3568221],
                [0.7978784, -0.618034, 0.3568221],
                [-0.9341724, 0.381966, 0.3568221],
                [0.1362939, 1, 0.3568221],
                [0.1362939, -1, 0.3568221],
                [-0.9341724, -0.381966, 0.3568221],
                [0.9341724, 0.381966, -0.3568221],
                [0.9341724, -0.381966, -0.3568221],
                [-0.7978784, 0.618034, -0.3568221],
                [-0.1362939, 1, -0.3568221],
                [-0.1362939, -1, -0.3568221],
                [-0.7978784, -0.618034, -0.3568221],
                [0.3568221, 0.618034, -0.7978784],
                [0.3568221, -0.618034, -0.7978784],
                [-0.7136442, 0, -0.7978784],
                [0, 0, -1.070466],
            ],
            face: [
                [0, 1, 4, 7, 2],
                [0, 2, 6, 9, 3],
                [0, 3, 8, 5, 1],
                [1, 5, 11, 10, 4],
                [2, 7, 13, 12, 6],
                [3, 9, 15, 14, 8],
                [4, 10, 16, 13, 7],
                [5, 8, 14, 17, 11],
                [6, 12, 18, 15, 9],
                [10, 11, 17, 19, 16],
                [12, 13, 16, 19, 18],
                [14, 15, 18, 19, 17],
            ],
        };
        polyhedra[3] = {
            vertex: [
                [0, 0, 1.175571],
                [1.051462, 0, 0.5257311],
                [0.3249197, 1, 0.5257311],
                [-0.8506508, 0.618034, 0.5257311],
                [-0.8506508, -0.618034, 0.5257311],
                [0.3249197, -1, 0.5257311],
                [0.8506508, 0.618034, -0.5257311],
                [0.8506508, -0.618034, -0.5257311],
                [-0.3249197, 1, -0.5257311],
                [-1.051462, 0, -0.5257311],
                [-0.3249197, -1, -0.5257311],
                [0, 0, -1.175571],
            ],
            face: [
                [0, 1, 2],
                [0, 2, 3],
                [0, 3, 4],
                [0, 4, 5],
                [0, 5, 1],
                [1, 5, 7],
                [1, 7, 6],
                [1, 6, 2],
                [2, 6, 8],
                [2, 8, 3],
                [3, 8, 9],
                [3, 9, 4],
                [4, 9, 10],
                [4, 10, 5],
                [5, 10, 7],
                [6, 7, 11],
                [6, 11, 8],
                [7, 10, 11],
                [8, 11, 9],
                [9, 11, 10],
            ],
        };
        polyhedra[4] = {
            vertex: [
                [0, 0, 1.070722],
                [0.7148135, 0, 0.7971752],
                [-0.104682, 0.7071068, 0.7971752],
                [-0.6841528, 0.2071068, 0.7971752],
                [-0.104682, -0.7071068, 0.7971752],
                [0.6101315, 0.7071068, 0.5236279],
                [1.04156, 0.2071068, 0.1367736],
                [0.6101315, -0.7071068, 0.5236279],
                [-0.3574067, 1, 0.1367736],
                [-0.7888348, -0.5, 0.5236279],
                [-0.9368776, 0.5, 0.1367736],
                [-0.3574067, -1, 0.1367736],
                [0.3574067, 1, -0.1367736],
                [0.9368776, -0.5, -0.1367736],
                [0.7888348, 0.5, -0.5236279],
                [0.3574067, -1, -0.1367736],
                [-0.6101315, 0.7071068, -0.5236279],
                [-1.04156, -0.2071068, -0.1367736],
                [-0.6101315, -0.7071068, -0.5236279],
                [0.104682, 0.7071068, -0.7971752],
                [0.6841528, -0.2071068, -0.7971752],
                [0.104682, -0.7071068, -0.7971752],
                [-0.7148135, 0, -0.7971752],
                [0, 0, -1.070722],
            ],
            face: [
                [0, 2, 3],
                [1, 6, 5],
                [4, 9, 11],
                [7, 15, 13],
                [8, 16, 10],
                [12, 14, 19],
                [17, 22, 18],
                [20, 21, 23],
                [0, 1, 5, 2],
                [0, 3, 9, 4],
                [0, 4, 7, 1],
                [1, 7, 13, 6],
                [2, 5, 12, 8],
                [2, 8, 10, 3],
                [3, 10, 17, 9],
                [4, 11, 15, 7],
                [5, 6, 14, 12],
                [6, 13, 20, 14],
                [8, 12, 19, 16],
                [9, 17, 18, 11],
                [10, 16, 22, 17],
                [11, 18, 21, 15],
                [13, 15, 21, 20],
                [14, 20, 23, 19],
                [16, 19, 23, 22],
                [18, 22, 23, 21],
            ],
        };
        polyhedra[5] = {
            vertex: [
                [0, 0, 1.322876],
                [1.309307, 0, 0.1889822],
                [-0.9819805, 0.8660254, 0.1889822],
                [0.1636634, -1.299038, 0.1889822],
                [0.3273268, 0.8660254, -0.9449112],
                [-0.8183171, -0.4330127, -0.9449112],
            ],
            face: [
                [0, 3, 1],
                [2, 4, 5],
                [0, 1, 4, 2],
                [0, 2, 5, 3],
                [1, 3, 5, 4],
            ],
        };
        polyhedra[6] = {
            vertex: [
                [0, 0, 1.159953],
                [1.013464, 0, 0.5642542],
                [-0.3501431, 0.9510565, 0.5642542],
                [-0.7715208, -0.6571639, 0.5642542],
                [0.6633206, 0.9510565, -0.03144481],
                [0.8682979, -0.6571639, -0.3996071],
                [-1.121664, 0.2938926, -0.03144481],
                [-0.2348831, -1.063314, -0.3996071],
                [0.5181548, 0.2938926, -0.9953061],
                [-0.5850262, -0.112257, -0.9953061],
            ],
            face: [
                [0, 1, 4, 2],
                [0, 2, 6, 3],
                [1, 5, 8, 4],
                [3, 6, 9, 7],
                [5, 7, 9, 8],
                [0, 3, 7, 5, 1],
                [2, 4, 8, 9, 6],
            ],
        };
        polyhedra[7] = {
            vertex: [
                [0, 0, 1.118034],
                [0.8944272, 0, 0.6708204],
                [-0.2236068, 0.8660254, 0.6708204],
                [-0.7826238, -0.4330127, 0.6708204],
                [0.6708204, 0.8660254, 0.2236068],
                [1.006231, -0.4330127, -0.2236068],
                [-1.006231, 0.4330127, 0.2236068],
                [-0.6708204, -0.8660254, -0.2236068],
                [0.7826238, 0.4330127, -0.6708204],
                [0.2236068, -0.8660254, -0.6708204],
                [-0.8944272, 0, -0.6708204],
                [0, 0, -1.118034],
            ],
            face: [
                [0, 1, 4, 2],
                [0, 2, 6, 3],
                [1, 5, 8, 4],
                [3, 6, 10, 7],
                [5, 9, 11, 8],
                [7, 10, 11, 9],
                [0, 3, 7, 9, 5, 1],
                [2, 4, 8, 11, 10, 6],
            ],
        };
        polyhedra[8] = {
            vertex: [
                [-0.729665, 0.670121, 0.319155],
                [-0.655235, -0.29213, -0.754096],
                [-0.093922, -0.607123, 0.537818],
                [0.702196, 0.595691, 0.485187],
                [0.776626, -0.36656, -0.588064],
            ],
            face: [
                [1, 4, 2],
                [0, 1, 2],
                [3, 0, 2],
                [4, 3, 2],
                [4, 1, 0, 3],
            ],
        };
        polyhedra[9] = {
            vertex: [
                [-0.868849, -0.100041, 0.61257],
                [-0.329458, 0.976099, 0.28078],
                [-0.26629, -0.013796, -0.477654],
                [-0.13392, -1.034115, 0.229829],
                [0.738834, 0.707117, -0.307018],
                [0.859683, -0.535264, -0.338508],
            ],
            face: [
                [3, 0, 2],
                [5, 3, 2],
                [4, 5, 2],
                [1, 4, 2],
                [0, 1, 2],
                [0, 3, 5, 4, 1],
            ],
        };
        polyhedra[10] = {
            vertex: [
                [-0.610389, 0.243975, 0.531213],
                [-0.187812, -0.48795, -0.664016],
                [-0.187812, 0.9759, -0.664016],
                [0.187812, -0.9759, 0.664016],
                [0.798201, 0.243975, 0.132803],
            ],
            face: [
                [1, 3, 0],
                [3, 4, 0],
                [3, 1, 4],
                [0, 2, 1],
                [0, 4, 2],
                [2, 4, 1],
            ],
        };
        polyhedra[11] = {
            vertex: [
                [-1.028778, 0.392027, -0.048786],
                [-0.640503, -0.646161, 0.621837],
                [-0.125162, -0.395663, -0.540059],
                [0.004683, 0.888447, -0.651988],
                [0.125161, 0.395663, 0.540059],
                [0.632925, -0.791376, 0.433102],
                [1.031672, 0.157063, -0.354165],
            ],
            face: [
                [3, 2, 0],
                [2, 1, 0],
                [2, 5, 1],
                [0, 4, 3],
                [0, 1, 4],
                [4, 1, 5],
                [2, 3, 6],
                [3, 4, 6],
                [5, 2, 6],
                [4, 5, 6],
            ],
        };
        polyhedra[12] = {
            vertex: [
                [-0.669867, 0.334933, -0.529576],
                [-0.669867, 0.334933, 0.529577],
                [-0.4043, 1.212901, 0],
                [-0.334933, -0.669867, -0.529576],
                [-0.334933, -0.669867, 0.529577],
                [0.334933, 0.669867, -0.529576],
                [0.334933, 0.669867, 0.529577],
                [0.4043, -1.212901, 0],
                [0.669867, -0.334933, -0.529576],
                [0.669867, -0.334933, 0.529577],
            ],
            face: [
                [8, 9, 7],
                [6, 5, 2],
                [3, 8, 7],
                [5, 0, 2],
                [4, 3, 7],
                [0, 1, 2],
                [9, 4, 7],
                [1, 6, 2],
                [9, 8, 5, 6],
                [8, 3, 0, 5],
                [3, 4, 1, 0],
                [4, 9, 6, 1],
            ],
        };
        polyhedra[13] = {
            vertex: [
                [-0.931836, 0.219976, -0.264632],
                [-0.636706, 0.318353, 0.692816],
                [-0.613483, -0.735083, -0.264632],
                [-0.326545, 0.979634, 0],
                [-0.318353, -0.636706, 0.692816],
                [-0.159176, 0.477529, -0.856368],
                [0.159176, -0.477529, -0.856368],
                [0.318353, 0.636706, 0.692816],
                [0.326545, -0.979634, 0],
                [0.613482, 0.735082, -0.264632],
                [0.636706, -0.318353, 0.692816],
                [0.931835, -0.219977, -0.264632],
            ],
            face: [
                [11, 10, 8],
                [7, 9, 3],
                [6, 11, 8],
                [9, 5, 3],
                [2, 6, 8],
                [5, 0, 3],
                [4, 2, 8],
                [0, 1, 3],
                [10, 4, 8],
                [1, 7, 3],
                [10, 11, 9, 7],
                [11, 6, 5, 9],
                [6, 2, 0, 5],
                [2, 4, 1, 0],
                [4, 10, 7, 1],
            ],
        };
        polyhedra[14] = {
            vertex: [
                [-0.93465, 0.300459, -0.271185],
                [-0.838689, -0.260219, -0.516017],
                [-0.711319, 0.717591, 0.128359],
                [-0.710334, -0.156922, 0.080946],
                [-0.599799, 0.556003, -0.725148],
                [-0.503838, -0.004675, -0.969981],
                [-0.487004, 0.26021, 0.48049],
                [-0.460089, -0.750282, -0.512622],
                [-0.376468, 0.973135, -0.325605],
                [-0.331735, -0.646985, 0.084342],
                [-0.254001, 0.831847, 0.530001],
                [-0.125239, -0.494738, -0.966586],
                [0.029622, 0.027949, 0.730817],
                [0.056536, -0.982543, -0.262295],
                [0.08085, 1.087391, 0.076037],
                [0.125583, -0.532729, 0.485984],
                [0.262625, 0.599586, 0.780328],
                [0.391387, -0.726999, -0.716259],
                [0.513854, -0.868287, 0.139347],
                [0.597475, 0.85513, 0.326364],
                [0.641224, 0.109523, 0.783723],
                [0.737185, -0.451155, 0.538891],
                [0.848705, -0.612742, -0.314616],
                [0.976075, 0.365067, 0.32976],
                [1.072036, -0.19561, 0.084927],
            ],
            face: [
                [15, 18, 21],
                [12, 20, 16],
                [6, 10, 2],
                [3, 0, 1],
                [9, 7, 13],
                [2, 8, 4, 0],
                [0, 4, 5, 1],
                [1, 5, 11, 7],
                [7, 11, 17, 13],
                [13, 17, 22, 18],
                [18, 22, 24, 21],
                [21, 24, 23, 20],
                [20, 23, 19, 16],
                [16, 19, 14, 10],
                [10, 14, 8, 2],
                [15, 9, 13, 18],
                [12, 15, 21, 20],
                [6, 12, 16, 10],
                [3, 6, 2, 0],
                [9, 3, 1, 7],
                [9, 15, 12, 6, 3],
                [22, 17, 11, 5, 4, 8, 14, 19, 23, 24],
            ],
        };
        const type = options.type && (options.type < 0 || options.type >= polyhedra.length) ? 0 : options.type || 0;
        const size = options.size;
        const sizeX = options.sizeX || size || 1;
        const sizeY = options.sizeY || size || 1;
        const sizeZ = options.sizeZ || size || 1;
        const data = options.custom || polyhedra[type];
        const nbfaces = data.face.length;
        const faceUV = options.faceUV || new Array(nbfaces);
        const faceColors = options.faceColors;
        const flat = options.flat === undefined ? true : options.flat;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const positions = new Array();
        const indices = new Array();
        const normals = new Array();
        const uvs = new Array();
        const colors = new Array();
        let index = 0;
        let faceIdx = 0; // face cursor in the array "indexes"
        const indexes = new Array();
        let i = 0;
        let f = 0;
        let u, v, ang, x, y, tmp;
        // default face colors and UV if undefined
        if (flat) {
            for (f = 0; f < nbfaces; f++) {
                if (faceColors && faceColors[f] === undefined) {
                    faceColors[f] = new Color4(1, 1, 1, 1);
                }
                if (faceUV && faceUV[f] === undefined) {
                    faceUV[f] = new Vector4(0, 0, 1, 1);
                }
            }
        }
        if (!flat) {
            for (i = 0; i < data.vertex.length; i++) {
                positions.push(data.vertex[i][0] * sizeX, data.vertex[i][1] * sizeY, data.vertex[i][2] * sizeZ);
                uvs.push(0, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 : 0);
            }
            for (f = 0; f < nbfaces; f++) {
                for (i = 0; i < data.face[f].length - 2; i++) {
                    indices.push(data.face[f][0], data.face[f][i + 2], data.face[f][i + 1]);
                }
            }
        }
        else {
            for (f = 0; f < nbfaces; f++) {
                const fl = data.face[f].length; // number of vertices of the current face
                ang = (2 * Math.PI) / fl;
                x = 0.5 * Math.tan(ang / 2);
                y = 0.5;
                // positions, uvs, colors
                for (i = 0; i < fl; i++) {
                    // positions
                    positions.push(data.vertex[data.face[f][i]][0] * sizeX, data.vertex[data.face[f][i]][1] * sizeY, data.vertex[data.face[f][i]][2] * sizeZ);
                    indexes.push(index);
                    index++;
                    // uvs
                    u = faceUV[f].x + (faceUV[f].z - faceUV[f].x) * (0.5 + x);
                    v = faceUV[f].y + (faceUV[f].w - faceUV[f].y) * (y - 0.5);
                    uvs.push(u, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - v : v);
                    tmp = x * Math.cos(ang) - y * Math.sin(ang);
                    y = x * Math.sin(ang) + y * Math.cos(ang);
                    x = tmp;
                    // colors
                    if (faceColors) {
                        colors.push(faceColors[f].r, faceColors[f].g, faceColors[f].b, faceColors[f].a);
                    }
                }
                // indices from indexes
                for (i = 0; i < fl - 2; i++) {
                    indices.push(indexes[0 + faceIdx], indexes[i + 2 + faceIdx], indexes[i + 1 + faceIdx]);
                }
                faceIdx += fl;
            }
        }
        VertexData.ComputeNormals(positions, indices, normals);
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        const vertexData = new VertexData();
        vertexData.positions = positions;
        vertexData.indices = indices;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        if (faceColors && flat) {
            vertexData.colors = colors;
        }
        return vertexData;
    }
    /**
     * Creates a polyhedron mesh
     * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embbeded types. Please refer to the type sheet in the tutorial to choose the wanted type
     * * The parameter `size` (positive float, default 1) sets the polygon size
     * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
     * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overrides the parameter `type`
     * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
     * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
     * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
     * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.type
     * @param options.size
     * @param options.sizeX
     * @param options.sizeY
     * @param options.sizeZ
     * @param options.custom
     * @param options.faceUV
     * @param options.faceColors
     * @param options.flat
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param scene defines the hosting scene
     * @returns the polyhedron mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra
     */
    function CreatePolyhedron(name, options = {}, scene = null) {
        const polyhedron = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        polyhedron._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreatePolyhedronVertexData(options);
        vertexData.applyToMesh(polyhedron, options.updatable);
        return polyhedron;
    }
    /**
     * Class containing static functions to help procedurally build meshes
     * @deprecated use the function directly from the module
     */
    const PolyhedronBuilder = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        CreatePolyhedron,
    };
    VertexData.CreatePolyhedron = CreatePolyhedronVertexData;
    Mesh.CreatePolyhedron = (name, options, scene) => {
        return CreatePolyhedron(name, options, scene);
    };

    /**
     * Creates the VertexData of the IcoSphere
     * @param options an object used to set the following optional parameters for the IcoSphere, required but can be empty
     * * radius the radius of the IcoSphere, optional default 1
     * * radiusX allows stretching in the x direction, optional, default radius
     * * radiusY allows stretching in the y direction, optional, default radius
     * * radiusZ allows stretching in the z direction, optional, default radius
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.radius
     * @param options.radiusX
     * @param options.radiusY
     * @param options.radiusZ
     * @param options.flat
     * @param options.subdivisions
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @returns the VertexData of the IcoSphere
     */
    function CreateIcoSphereVertexData(options) {
        const sideOrientation = options.sideOrientation || VertexData.DEFAULTSIDE;
        const radius = options.radius || 1;
        const flat = options.flat === undefined ? true : options.flat;
        const subdivisions = (options.subdivisions || 4) | 0;
        const radiusX = options.radiusX || radius;
        const radiusY = options.radiusY || radius;
        const radiusZ = options.radiusZ || radius;
        const t = (1 + Math.sqrt(5)) / 2;
        // 12 vertex x,y,z
        const icoVertices = [
            -1,
            t,
            -0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            -1,
            t,
            0,
            1,
            t,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            -1, // v8-11
        ];
        // index of 3 vertex makes a face of icopshere
        const ico_indices = [
            0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 12, 22, 23, 1, 5, 20, 5, 11, 4, 23, 22, 13, 22, 18, 6, 7, 1, 8, 14, 21, 4, 14, 4, 2, 16, 13, 6, 15, 6, 19, 3, 8, 9, 4, 21, 5, 13, 17,
            23, 6, 13, 22, 19, 6, 18, 9, 8, 1,
        ];
        // vertex for uv have aliased position, not for UV
        const vertices_unalias_id = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            // vertex alias
            0,
            2,
            3,
            3,
            3,
            4,
            7,
            8,
            9,
            9,
            10,
            11, // 23: B + 12
        ];
        // uv as integer step (not pixels !)
        const ico_vertexuv = [
            5,
            1,
            3,
            1,
            6,
            4,
            0,
            0,
            5,
            3,
            4,
            2,
            2,
            2,
            4,
            0,
            2,
            0,
            1,
            1,
            6,
            0,
            6,
            2,
            // vertex alias (for same vertex on different faces)
            0,
            4,
            3,
            3,
            4,
            4,
            3,
            1,
            4,
            2,
            4,
            4,
            0,
            2,
            1,
            1,
            2,
            2,
            3,
            3,
            1,
            3,
            2,
            4, // 23: B + 12
        ];
        // Vertices[0, 1, ...9, A, B] : position on UV plane
        // '+' indicate duplicate position to be fixed (3,9:0,2,3,4,7,8,A,B)
        // First island of uv mapping
        // v = 4h          3+  2
        // v = 3h        9+  4
        // v = 2h      9+  5   B
        // v = 1h    9   1   0
        // v = 0h  3   8   7   A
        //     u = 0 1 2 3 4 5 6  *a
        // Second island of uv mapping
        // v = 4h  0+  B+  4+
        // v = 3h    A+  2+
        // v = 2h  7+  6   3+
        // v = 1h    8+  3+
        // v = 0h
        //     u = 0 1 2 3 4 5 6  *a
        // Face layout on texture UV mapping
        // ============
        // \ 4  /\ 16 /   ======
        //  \  /  \  /   /\ 11 /
        //   \/ 7  \/   /  \  /
        //    =======  / 10 \/
        //   /\ 17 /\  =======
        //  /  \  /  \ \ 15 /\
        // / 8  \/ 12 \ \  /  \
        // ============  \/ 6  \
        // \ 18 /\  ============
        //  \  /  \ \ 5  /\ 0  /
        //   \/ 13 \ \  /  \  /
        //   =======  \/ 1  \/
        //       =============
        //      /\ 19 /\  2 /\
        //     /  \  /  \  /  \
        //    / 14 \/ 9  \/  3 \
        //   ===================
        // uv step is u:1 or 0.5, v:cos(30)=sqrt(3)/2, ratio approx is 84/97
        const ustep = 138 / 1024;
        const vstep = 239 / 1024;
        const uoffset = 60 / 1024;
        const voffset = 26 / 1024;
        // Second island should have margin, not to touch the first island
        // avoid any borderline artefact in pixel rounding
        const island_u_offset = -40 / 1024;
        const island_v_offset = +20 / 1024;
        // face is either island 0 or 1 :
        // second island is for faces : [4, 7, 8, 12, 13, 16, 17, 18]
        const island = [
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            1,
            1,
            1,
            0, //  15 - 19
        ];
        const indices = new Array();
        const positions = new Array();
        const normals = new Array();
        const uvs = new Array();
        let current_indice = 0;
        // prepare array of 3 vector (empty) (to be worked in place, shared for each face)
        const face_vertex_pos = new Array(3);
        const face_vertex_uv = new Array(3);
        let v012;
        for (v012 = 0; v012 < 3; v012++) {
            face_vertex_pos[v012] = Vector3.Zero();
            face_vertex_uv[v012] = Vector2.Zero();
        }
        // create all with normals
        for (let face = 0; face < 20; face++) {
            // 3 vertex per face
            for (v012 = 0; v012 < 3; v012++) {
                // look up vertex 0,1,2 to its index in 0 to 11 (or 23 including alias)
                const v_id = ico_indices[3 * face + v012];
                // vertex have 3D position (x,y,z)
                face_vertex_pos[v012].copyFromFloats(icoVertices[3 * vertices_unalias_id[v_id]], icoVertices[3 * vertices_unalias_id[v_id] + 1], icoVertices[3 * vertices_unalias_id[v_id] + 2]);
                // Normalize to get normal
                face_vertex_pos[v012].normalize();
                // uv Coordinates from vertex ID
                face_vertex_uv[v012].copyFromFloats(ico_vertexuv[2 * v_id] * ustep + uoffset + island[face] * island_u_offset, ico_vertexuv[2 * v_id + 1] * vstep + voffset + island[face] * island_v_offset);
            }
            // Subdivide the face (interpolate pos, norm, uv)
            // - pos is linear interpolation, then projected to sphere (converge polyhedron to sphere)
            // - norm is linear interpolation of vertex corner normal
            //   (to be checked if better to re-calc from face vertex, or if approximation is OK ??? )
            // - uv is linear interpolation
            //
            // Topology is as below for sub-divide by 2
            // vertex shown as v0,v1,v2
            // interp index is i1 to progress in range [v0,v1[
            // interp index is i2 to progress in range [v0,v2[
            // face index as  (i1,i2)  for /\  : (i1,i2),(i1+1,i2),(i1,i2+1)
            //            and (i1,i2)' for \/  : (i1+1,i2),(i1+1,i2+1),(i1,i2+1)
            //
            //
            //                    i2    v2
            //                    ^    ^
            //                   /    / \
            //                  /    /   \
            //                 /    /     \
            //                /    / (0,1) \
            //               /    #---------\
            //              /    / \ (0,0)'/ \
            //             /    /   \     /   \
            //            /    /     \   /     \
            //           /    / (0,0) \ / (1,0) \
            //          /    #---------#---------\
            //              v0                    v1
            //
            //              --------------------> i1
            //
            // interp of (i1,i2):
            //  along i2 :  x0=lerp(v0,v2, i2/S) <---> x1=lerp(v1,v2, i2/S)
            //  along i1 :  lerp(x0,x1, i1/(S-i2))
            //
            // centroid of triangle is needed to get help normal computation
            //  (c1,c2) are used for centroid location
            const interp_vertex = (i1, i2, c1, c2) => {
                // vertex is interpolated from
                //   - face_vertex_pos[0..2]
                //   - face_vertex_uv[0..2]
                const pos_x0 = Vector3.Lerp(face_vertex_pos[0], face_vertex_pos[2], i2 / subdivisions);
                const pos_x1 = Vector3.Lerp(face_vertex_pos[1], face_vertex_pos[2], i2 / subdivisions);
                const pos_interp = subdivisions === i2 ? face_vertex_pos[2] : Vector3.Lerp(pos_x0, pos_x1, i1 / (subdivisions - i2));
                pos_interp.normalize();
                let vertex_normal;
                if (flat) {
                    // in flat mode, recalculate normal as face centroid normal
                    const centroid_x0 = Vector3.Lerp(face_vertex_pos[0], face_vertex_pos[2], c2 / subdivisions);
                    const centroid_x1 = Vector3.Lerp(face_vertex_pos[1], face_vertex_pos[2], c2 / subdivisions);
                    vertex_normal = Vector3.Lerp(centroid_x0, centroid_x1, c1 / (subdivisions - c2));
                }
                else {
                    // in smooth mode, recalculate normal from each single vertex position
                    vertex_normal = new Vector3(pos_interp.x, pos_interp.y, pos_interp.z);
                }
                // Vertex normal need correction due to X,Y,Z radius scaling
                vertex_normal.x /= radiusX;
                vertex_normal.y /= radiusY;
                vertex_normal.z /= radiusZ;
                vertex_normal.normalize();
                const uv_x0 = Vector2.Lerp(face_vertex_uv[0], face_vertex_uv[2], i2 / subdivisions);
                const uv_x1 = Vector2.Lerp(face_vertex_uv[1], face_vertex_uv[2], i2 / subdivisions);
                const uv_interp = subdivisions === i2 ? face_vertex_uv[2] : Vector2.Lerp(uv_x0, uv_x1, i1 / (subdivisions - i2));
                positions.push(pos_interp.x * radiusX, pos_interp.y * radiusY, pos_interp.z * radiusZ);
                normals.push(vertex_normal.x, vertex_normal.y, vertex_normal.z);
                uvs.push(uv_interp.x, CompatibilityOptions.UseOpenGLOrientationForUV ? 1.0 - uv_interp.y : uv_interp.y);
                // push each vertex has member of a face
                // Same vertex can belong to multiple face, it is pushed multiple time (duplicate vertex are present)
                indices.push(current_indice);
                current_indice++;
            };
            for (let i2 = 0; i2 < subdivisions; i2++) {
                for (let i1 = 0; i1 + i2 < subdivisions; i1++) {
                    // face : (i1,i2)  for /\  :
                    // interp for : (i1,i2),(i1+1,i2),(i1,i2+1)
                    interp_vertex(i1, i2, i1 + 1.0 / 3, i2 + 1.0 / 3);
                    interp_vertex(i1 + 1, i2, i1 + 1.0 / 3, i2 + 1.0 / 3);
                    interp_vertex(i1, i2 + 1, i1 + 1.0 / 3, i2 + 1.0 / 3);
                    if (i1 + i2 + 1 < subdivisions) {
                        // face : (i1,i2)' for \/  :
                        // interp for (i1+1,i2),(i1+1,i2+1),(i1,i2+1)
                        interp_vertex(i1 + 1, i2, i1 + 2.0 / 3, i2 + 2.0 / 3);
                        interp_vertex(i1 + 1, i2 + 1, i1 + 2.0 / 3, i2 + 2.0 / 3);
                        interp_vertex(i1, i2 + 1, i1 + 2.0 / 3, i2 + 2.0 / 3);
                    }
                }
            }
        }
        // Sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Result
        const vertexData = new VertexData();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
     * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
     * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value of `radius`)
     * * The parameter `subdivisions` sets the number of subdivisions (positive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
     * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.radius
     * @param options.radiusX
     * @param options.radiusY
     * @param options.radiusZ
     * @param options.flat
     * @param options.subdivisions
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.updatable
     * @param scene defines the hosting scene
     * @returns the icosahedron mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra#icosphere
     */
    function CreateIcoSphere(name, options = {}, scene = null) {
        const sphere = new Mesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        sphere._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateIcoSphereVertexData(options);
        vertexData.applyToMesh(sphere, options.updatable);
        return sphere;
    }
    VertexData.CreateIcoSphere = CreateIcoSphereVertexData;
    Mesh.CreateIcoSphere = (name, options, scene) => {
        return CreateIcoSphere(name, options, scene);
    };

    const xpAxis = new Vector3(1, 0, 0);
    const xnAxis = new Vector3(-1, 0, 0);
    const ypAxis = new Vector3(0, 1, 0);
    const ynAxis = new Vector3(0, -1, 0);
    const zpAxis = new Vector3(0, 0, 1);
    const znAxis = new Vector3(0, 0, -1);
    /** @internal */
    class DecalVertex {
        constructor(position = Vector3.Zero(), normal = Vector3.Up(), uv = Vector2.Zero(), vertexIdx = 0, vertexIdxForBones = 0, localPositionOverride = null, localNormalOverride = null, matrixIndicesOverride = null, matrixWeightsOverride = null) {
            this.position = position;
            this.normal = normal;
            this.uv = uv;
            this.vertexIdx = vertexIdx;
            this.vertexIdxForBones = vertexIdxForBones;
            this.localPositionOverride = localPositionOverride;
            this.localNormalOverride = localNormalOverride;
            this.matrixIndicesOverride = matrixIndicesOverride;
            this.matrixWeightsOverride = matrixWeightsOverride;
        }
        clone() {
            var _a, _b, _c, _d;
            return new DecalVertex(this.position.clone(), this.normal.clone(), this.uv.clone(), this.vertexIdx, this.vertexIdxForBones, (_a = this.localPositionOverride) === null || _a === void 0 ? void 0 : _a.slice(), (_b = this.localNormalOverride) === null || _b === void 0 ? void 0 : _b.slice(), (_c = this.matrixIndicesOverride) === null || _c === void 0 ? void 0 : _c.slice(), (_d = this.matrixWeightsOverride) === null || _d === void 0 ? void 0 : _d.slice());
        }
    }
    /**
     * Creates a decal mesh.
     * A decal is a mesh usually applied as a model onto the surface of another mesh. So don't forget the parameter `sourceMesh` depicting the decal
     * * The parameter `position` (Vector3, default `(0, 0, 0)`) sets the position of the decal in World coordinates
     * * The parameter `normal` (Vector3, default `Vector3.Up`) sets the normal of the mesh where the decal is applied onto in World coordinates
     * * The parameter `size` (Vector3, default `(1, 1, 1)`) sets the decal scaling
     * * The parameter `angle` (float in radian, default 0) sets the angle to rotate the decal
     * * The parameter `captureUVS` defines if we need to capture the uvs or compute them
     * * The parameter `cullBackFaces` defines if the back faces should be removed from the decal mesh
     * * The parameter `localMode` defines that the computations should be done with the local mesh coordinates instead of the world space coordinates.
     * *    Use this mode if you want the decal to be parented to the sourceMesh and move/rotate with it.
     * Note: Meshes with morph targets are not supported!
     * @param name defines the name of the mesh
     * @param sourceMesh defines the mesh where the decal must be applied
     * @param options defines the options used to create the mesh
     * @param options.position
     * @param options.normal
     * @param options.size
     * @param options.angle
     * @param options.captureUVS
     * @param options.cullBackFaces
     * @param options.localMode
     * @returns the decal mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/decals
     */
    function CreateDecal(name, sourceMesh, options) {
        var _a, _b, _c, _d;
        const hasSkeleton = !!sourceMesh.skeleton;
        const useLocalComputation = options.localMode || hasSkeleton;
        const meshHasOverridenMaterial = sourceMesh.overrideMaterialSideOrientation !== null && sourceMesh.overrideMaterialSideOrientation !== undefined;
        const indices = sourceMesh.getIndices();
        const positions = hasSkeleton ? sourceMesh.getPositionData(true, true) : sourceMesh.getVerticesData(VertexBuffer.PositionKind);
        const normals = hasSkeleton ? sourceMesh.getNormalsData(true, true) : sourceMesh.getVerticesData(VertexBuffer.NormalKind);
        const localPositions = useLocalComputation ? (hasSkeleton ? sourceMesh.getVerticesData(VertexBuffer.PositionKind) : positions) : null;
        const localNormals = useLocalComputation ? (hasSkeleton ? sourceMesh.getVerticesData(VertexBuffer.NormalKind) : normals) : null;
        const uvs = sourceMesh.getVerticesData(VertexBuffer.UVKind);
        const matIndices = hasSkeleton ? sourceMesh.getVerticesData(VertexBuffer.MatricesIndicesKind) : null;
        const matWeights = hasSkeleton ? sourceMesh.getVerticesData(VertexBuffer.MatricesWeightsKind) : null;
        const matIndicesExtra = hasSkeleton ? sourceMesh.getVerticesData(VertexBuffer.MatricesIndicesExtraKind) : null;
        const matWeightsExtra = hasSkeleton ? sourceMesh.getVerticesData(VertexBuffer.MatricesWeightsExtraKind) : null;
        const position = options.position || Vector3.Zero();
        let normal = options.normal || Vector3.Up();
        const size = options.size || Vector3.One();
        const angle = options.angle || 0;
        // Getting correct rotation
        if (!normal) {
            const target = new Vector3(0, 0, 1);
            const camera = sourceMesh.getScene().activeCamera;
            const cameraWorldTarget = Vector3.TransformCoordinates(target, camera.getWorldMatrix());
            normal = camera.globalPosition.subtract(cameraWorldTarget);
        }
        const yaw = -Math.atan2(normal.z, normal.x) - Math.PI / 2;
        const len = Math.sqrt(normal.x * normal.x + normal.z * normal.z);
        const pitch = Math.atan2(normal.y, len);
        const vertexData = new VertexData();
        vertexData.indices = [];
        vertexData.positions = [];
        vertexData.normals = [];
        vertexData.uvs = [];
        vertexData.matricesIndices = hasSkeleton ? [] : null;
        vertexData.matricesWeights = hasSkeleton ? [] : null;
        vertexData.matricesIndicesExtra = matIndicesExtra ? [] : null;
        vertexData.matricesWeightsExtra = matWeightsExtra ? [] : null;
        let currentVertexDataIndex = 0;
        const extractDecalVector3 = (indexId, transformMatrix) => {
            const result = new DecalVertex();
            if (!indices || !positions || !normals) {
                return result;
            }
            const vertexId = indices[indexId];
            result.vertexIdx = vertexId * 3;
            result.vertexIdxForBones = vertexId * 4;
            // Send vector to decal local world
            result.position = new Vector3(positions[vertexId * 3], positions[vertexId * 3 + 1], positions[vertexId * 3 + 2]);
            Vector3.TransformCoordinatesToRef(result.position, transformMatrix, result.position);
            // Get normal
            result.normal = new Vector3(normals[vertexId * 3], normals[vertexId * 3 + 1], normals[vertexId * 3 + 2]);
            Vector3.TransformNormalToRef(result.normal, transformMatrix, result.normal);
            if (options.captureUVS && uvs) {
                const v = uvs[vertexId * 2 + 1];
                result.uv = new Vector2(uvs[vertexId * 2], CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
            }
            return result;
        };
        const emptyArray = [0, 0, 0, 0];
        // Inspired by https://github.com/mrdoob/three.js/blob/eee231960882f6f3b6113405f524956145148146/examples/js/geometries/DecalGeometry.js
        const clip = (vertices, axis) => {
            if (vertices.length === 0) {
                return vertices;
            }
            const clipSize = 0.5 * Math.abs(Vector3.Dot(size, axis));
            const indexOf = (arr, val, start, num) => {
                for (let i = 0; i < num; ++i) {
                    if (arr[start + i] === val) {
                        return start + i;
                    }
                }
                return -1;
            };
            const clipVertices = (v0, v1) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                const clipFactor = Vector3.GetClipFactor(v0.position, v1.position, axis, clipSize);
                let indices = emptyArray;
                let weights = emptyArray;
                if (matIndices && matWeights) {
                    const mat0Index = v0.matrixIndicesOverride ? 0 : v0.vertexIdxForBones;
                    const v0Indices = (_a = v0.matrixIndicesOverride) !== null && _a !== void 0 ? _a : matIndices;
                    const v0Weights = (_b = v0.matrixWeightsOverride) !== null && _b !== void 0 ? _b : matWeights;
                    const mat1Index = v1.matrixIndicesOverride ? 0 : v1.vertexIdxForBones;
                    const v1Indices = (_c = v1.matrixIndicesOverride) !== null && _c !== void 0 ? _c : matIndices;
                    const v1Weights = (_d = v1.matrixWeightsOverride) !== null && _d !== void 0 ? _d : matWeights;
                    indices = [0, 0, 0, 0];
                    weights = [0, 0, 0, 0];
                    let index = 0;
                    for (let i = 0; i < 4; ++i) {
                        if (v0Weights[mat0Index + i] > 0) {
                            const idx = indexOf(v1Indices, v0Indices[mat0Index + i], mat1Index, 4);
                            indices[index] = v0Indices[mat0Index + i];
                            weights[index] = Scalar.Lerp(v0Weights[mat0Index + i], idx >= 0 ? v1Weights[idx] : 0, clipFactor);
                            index++;
                        }
                    }
                    for (let i = 0; i < 4 && index < 4; ++i) {
                        const ind = v1Indices[mat1Index + i];
                        if (indexOf(v0Indices, ind, mat0Index, 4) !== -1)
                            continue;
                        indices[index] = ind;
                        weights[index] = Scalar.Lerp(0, v1Weights[mat1Index + i], clipFactor);
                        index++;
                    }
                    const sumw = weights[0] + weights[1] + weights[2] + weights[3];
                    weights[0] /= sumw;
                    weights[1] /= sumw;
                    weights[2] /= sumw;
                    weights[3] /= sumw;
                }
                const v0LocalPositionX = v0.localPositionOverride ? v0.localPositionOverride[0] : (_e = localPositions === null || localPositions === void 0 ? void 0 : localPositions[v0.vertexIdx]) !== null && _e !== void 0 ? _e : 0;
                const v0LocalPositionY = v0.localPositionOverride ? v0.localPositionOverride[1] : (_f = localPositions === null || localPositions === void 0 ? void 0 : localPositions[v0.vertexIdx + 1]) !== null && _f !== void 0 ? _f : 0;
                const v0LocalPositionZ = v0.localPositionOverride ? v0.localPositionOverride[2] : (_g = localPositions === null || localPositions === void 0 ? void 0 : localPositions[v0.vertexIdx + 2]) !== null && _g !== void 0 ? _g : 0;
                const v1LocalPositionX = v1.localPositionOverride ? v1.localPositionOverride[0] : (_h = localPositions === null || localPositions === void 0 ? void 0 : localPositions[v1.vertexIdx]) !== null && _h !== void 0 ? _h : 0;
                const v1LocalPositionY = v1.localPositionOverride ? v1.localPositionOverride[1] : (_j = localPositions === null || localPositions === void 0 ? void 0 : localPositions[v1.vertexIdx + 1]) !== null && _j !== void 0 ? _j : 0;
                const v1LocalPositionZ = v1.localPositionOverride ? v1.localPositionOverride[2] : (_k = localPositions === null || localPositions === void 0 ? void 0 : localPositions[v1.vertexIdx + 2]) !== null && _k !== void 0 ? _k : 0;
                const v0LocalNormalX = v0.localNormalOverride ? v0.localNormalOverride[0] : (_l = localNormals === null || localNormals === void 0 ? void 0 : localNormals[v0.vertexIdx]) !== null && _l !== void 0 ? _l : 0;
                const v0LocalNormalY = v0.localNormalOverride ? v0.localNormalOverride[1] : (_m = localNormals === null || localNormals === void 0 ? void 0 : localNormals[v0.vertexIdx + 1]) !== null && _m !== void 0 ? _m : 0;
                const v0LocalNormalZ = v0.localNormalOverride ? v0.localNormalOverride[2] : (_o = localNormals === null || localNormals === void 0 ? void 0 : localNormals[v0.vertexIdx + 2]) !== null && _o !== void 0 ? _o : 0;
                const v1LocalNormalX = v1.localNormalOverride ? v1.localNormalOverride[0] : (_p = localNormals === null || localNormals === void 0 ? void 0 : localNormals[v1.vertexIdx]) !== null && _p !== void 0 ? _p : 0;
                const v1LocalNormalY = v1.localNormalOverride ? v1.localNormalOverride[1] : (_q = localNormals === null || localNormals === void 0 ? void 0 : localNormals[v1.vertexIdx + 1]) !== null && _q !== void 0 ? _q : 0;
                const v1LocalNormalZ = v1.localNormalOverride ? v1.localNormalOverride[2] : (_r = localNormals === null || localNormals === void 0 ? void 0 : localNormals[v1.vertexIdx + 2]) !== null && _r !== void 0 ? _r : 0;
                const interpNormalX = v0LocalNormalX + (v1LocalNormalX - v0LocalNormalX) * clipFactor;
                const interpNormalY = v0LocalNormalY + (v1LocalNormalY - v0LocalNormalY) * clipFactor;
                const interpNormalZ = v0LocalNormalZ + (v1LocalNormalZ - v0LocalNormalZ) * clipFactor;
                const norm = Math.sqrt(interpNormalX * interpNormalX + interpNormalY * interpNormalY + interpNormalZ * interpNormalZ);
                return new DecalVertex(Vector3.Lerp(v0.position, v1.position, clipFactor), Vector3.Lerp(v0.normal, v1.normal, clipFactor).normalize(), Vector2.Lerp(v0.uv, v1.uv, clipFactor), -1, -1, localPositions
                    ? [
                        v0LocalPositionX + (v1LocalPositionX - v0LocalPositionX) * clipFactor,
                        v0LocalPositionY + (v1LocalPositionY - v0LocalPositionY) * clipFactor,
                        v0LocalPositionZ + (v1LocalPositionZ - v0LocalPositionZ) * clipFactor,
                    ]
                    : null, localNormals ? [interpNormalX / norm, interpNormalY / norm, interpNormalZ / norm] : null, indices, weights);
            };
            let clipResult = null;
            if (vertices.length > 3) {
                clipResult = new Array();
            }
            for (let index = 0; index < vertices.length; index += 3) {
                let total = 0;
                let nV1 = null;
                let nV2 = null;
                let nV3 = null;
                let nV4 = null;
                const d1 = Vector3.Dot(vertices[index].position, axis) - clipSize;
                const d2 = Vector3.Dot(vertices[index + 1].position, axis) - clipSize;
                const d3 = Vector3.Dot(vertices[index + 2].position, axis) - clipSize;
                const v1Out = d1 > 0;
                const v2Out = d2 > 0;
                const v3Out = d3 > 0;
                total = (v1Out ? 1 : 0) + (v2Out ? 1 : 0) + (v3Out ? 1 : 0);
                switch (total) {
                    case 0:
                        if (vertices.length > 3) {
                            clipResult.push(vertices[index]);
                            clipResult.push(vertices[index + 1]);
                            clipResult.push(vertices[index + 2]);
                        }
                        else {
                            clipResult = vertices;
                        }
                        break;
                    case 1:
                        clipResult = clipResult !== null && clipResult !== void 0 ? clipResult : new Array();
                        if (v1Out) {
                            nV1 = vertices[index + 1];
                            nV2 = vertices[index + 2];
                            nV3 = clipVertices(vertices[index], nV1);
                            nV4 = clipVertices(vertices[index], nV2);
                        }
                        if (v2Out) {
                            nV1 = vertices[index];
                            nV2 = vertices[index + 2];
                            nV3 = clipVertices(vertices[index + 1], nV1);
                            nV4 = clipVertices(vertices[index + 1], nV2);
                            clipResult.push(nV3);
                            clipResult.push(nV2.clone());
                            clipResult.push(nV1.clone());
                            clipResult.push(nV2.clone());
                            clipResult.push(nV3.clone());
                            clipResult.push(nV4);
                            break;
                        }
                        if (v3Out) {
                            nV1 = vertices[index];
                            nV2 = vertices[index + 1];
                            nV3 = clipVertices(vertices[index + 2], nV1);
                            nV4 = clipVertices(vertices[index + 2], nV2);
                        }
                        if (nV1 && nV2 && nV3 && nV4) {
                            clipResult.push(nV1.clone());
                            clipResult.push(nV2.clone());
                            clipResult.push(nV3);
                            clipResult.push(nV4);
                            clipResult.push(nV3.clone());
                            clipResult.push(nV2.clone());
                        }
                        break;
                    case 2:
                        clipResult = clipResult !== null && clipResult !== void 0 ? clipResult : new Array();
                        if (!v1Out) {
                            nV1 = vertices[index].clone();
                            nV2 = clipVertices(nV1, vertices[index + 1]);
                            nV3 = clipVertices(nV1, vertices[index + 2]);
                            clipResult.push(nV1);
                            clipResult.push(nV2);
                            clipResult.push(nV3);
                        }
                        if (!v2Out) {
                            nV1 = vertices[index + 1].clone();
                            nV2 = clipVertices(nV1, vertices[index + 2]);
                            nV3 = clipVertices(nV1, vertices[index]);
                            clipResult.push(nV1);
                            clipResult.push(nV2);
                            clipResult.push(nV3);
                        }
                        if (!v3Out) {
                            nV1 = vertices[index + 2].clone();
                            nV2 = clipVertices(nV1, vertices[index]);
                            nV3 = clipVertices(nV1, vertices[index + 1]);
                            clipResult.push(nV1);
                            clipResult.push(nV2);
                            clipResult.push(nV3);
                        }
                        break;
                }
            }
            return clipResult;
        };
        const sourceMeshAsMesh = sourceMesh instanceof Mesh ? sourceMesh : null;
        const matrixData = sourceMeshAsMesh === null || sourceMeshAsMesh === void 0 ? void 0 : sourceMeshAsMesh._thinInstanceDataStorage.matrixData;
        const numMatrices = (sourceMeshAsMesh === null || sourceMeshAsMesh === void 0 ? void 0 : sourceMeshAsMesh.thinInstanceCount) || 1;
        const thinInstanceMatrix = TmpVectors.Matrix[0];
        thinInstanceMatrix.copyFrom(Matrix.IdentityReadOnly);
        for (let m = 0; m < numMatrices; ++m) {
            if ((sourceMeshAsMesh === null || sourceMeshAsMesh === void 0 ? void 0 : sourceMeshAsMesh.hasThinInstances) && matrixData) {
                const ofst = m * 16;
                thinInstanceMatrix.setRowFromFloats(0, matrixData[ofst + 0], matrixData[ofst + 1], matrixData[ofst + 2], matrixData[ofst + 3]);
                thinInstanceMatrix.setRowFromFloats(1, matrixData[ofst + 4], matrixData[ofst + 5], matrixData[ofst + 6], matrixData[ofst + 7]);
                thinInstanceMatrix.setRowFromFloats(2, matrixData[ofst + 8], matrixData[ofst + 9], matrixData[ofst + 10], matrixData[ofst + 11]);
                thinInstanceMatrix.setRowFromFloats(3, matrixData[ofst + 12], matrixData[ofst + 13], matrixData[ofst + 14], matrixData[ofst + 15]);
            }
            // Matrix
            const decalWorldMatrix = Matrix.RotationYawPitchRoll(yaw, pitch, angle).multiply(Matrix.Translation(position.x, position.y, position.z));
            const inverseDecalWorldMatrix = Matrix.Invert(decalWorldMatrix);
            const meshWorldMatrix = sourceMesh.getWorldMatrix();
            const transformMatrix = thinInstanceMatrix.multiply(meshWorldMatrix).multiply(inverseDecalWorldMatrix);
            const oneFaceVertices = new Array(3);
            for (let index = 0; index < indices.length; index += 3) {
                let faceVertices = oneFaceVertices;
                faceVertices[0] = extractDecalVector3(index, transformMatrix);
                if (meshHasOverridenMaterial && useLocalComputation) {
                    faceVertices[1] = extractDecalVector3(index + 2, transformMatrix);
                    faceVertices[2] = extractDecalVector3(index + 1, transformMatrix);
                }
                else {
                    faceVertices[1] = extractDecalVector3(index + 1, transformMatrix);
                    faceVertices[2] = extractDecalVector3(index + 2, transformMatrix);
                }
                if (options.cullBackFaces) {
                    // If all the normals of the vertices of the face are pointing away from the view direction we discard the face.
                    // As computations are done in the decal coordinate space, the viewDirection is (0,0,1), so when dot(vertexNormal, -viewDirection) <= 0 the vertex is culled
                    if (-faceVertices[0].normal.z <= 0 && -faceVertices[1].normal.z <= 0 && -faceVertices[2].normal.z <= 0) {
                        continue;
                    }
                }
                // Clip
                faceVertices = clip(faceVertices, xpAxis);
                if (!faceVertices)
                    continue;
                faceVertices = clip(faceVertices, xnAxis);
                if (!faceVertices)
                    continue;
                faceVertices = clip(faceVertices, ypAxis);
                if (!faceVertices)
                    continue;
                faceVertices = clip(faceVertices, ynAxis);
                if (!faceVertices)
                    continue;
                faceVertices = clip(faceVertices, zpAxis);
                if (!faceVertices)
                    continue;
                faceVertices = clip(faceVertices, znAxis);
                if (!faceVertices)
                    continue;
                // Add UVs and get back to world
                for (let vIndex = 0; vIndex < faceVertices.length; vIndex++) {
                    const vertex = faceVertices[vIndex];
                    //TODO check for Int32Array | Uint32Array | Uint16Array
                    vertexData.indices.push(currentVertexDataIndex);
                    if (useLocalComputation) {
                        if (vertex.localPositionOverride) {
                            vertexData.positions[currentVertexDataIndex * 3] = vertex.localPositionOverride[0];
                            vertexData.positions[currentVertexDataIndex * 3 + 1] = vertex.localPositionOverride[1];
                            vertexData.positions[currentVertexDataIndex * 3 + 2] = vertex.localPositionOverride[2];
                        }
                        else if (localPositions) {
                            vertexData.positions[currentVertexDataIndex * 3] = localPositions[vertex.vertexIdx];
                            vertexData.positions[currentVertexDataIndex * 3 + 1] = localPositions[vertex.vertexIdx + 1];
                            vertexData.positions[currentVertexDataIndex * 3 + 2] = localPositions[vertex.vertexIdx + 2];
                        }
                        if (vertex.localNormalOverride) {
                            vertexData.normals[currentVertexDataIndex * 3] = vertex.localNormalOverride[0];
                            vertexData.normals[currentVertexDataIndex * 3 + 1] = vertex.localNormalOverride[1];
                            vertexData.normals[currentVertexDataIndex * 3 + 2] = vertex.localNormalOverride[2];
                        }
                        else if (localNormals) {
                            vertexData.normals[currentVertexDataIndex * 3] = localNormals[vertex.vertexIdx];
                            vertexData.normals[currentVertexDataIndex * 3 + 1] = localNormals[vertex.vertexIdx + 1];
                            vertexData.normals[currentVertexDataIndex * 3 + 2] = localNormals[vertex.vertexIdx + 2];
                        }
                    }
                    else {
                        vertex.position.toArray(vertexData.positions, currentVertexDataIndex * 3);
                        vertex.normal.toArray(vertexData.normals, currentVertexDataIndex * 3);
                    }
                    if (vertexData.matricesIndices && vertexData.matricesWeights) {
                        if (vertex.matrixIndicesOverride) {
                            vertexData.matricesIndices[currentVertexDataIndex * 4] = vertex.matrixIndicesOverride[0];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 1] = vertex.matrixIndicesOverride[1];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 2] = vertex.matrixIndicesOverride[2];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 3] = vertex.matrixIndicesOverride[3];
                        }
                        else {
                            if (matIndices) {
                                vertexData.matricesIndices[currentVertexDataIndex * 4] = matIndices[vertex.vertexIdxForBones];
                                vertexData.matricesIndices[currentVertexDataIndex * 4 + 1] = matIndices[vertex.vertexIdxForBones + 1];
                                vertexData.matricesIndices[currentVertexDataIndex * 4 + 2] = matIndices[vertex.vertexIdxForBones + 2];
                                vertexData.matricesIndices[currentVertexDataIndex * 4 + 3] = matIndices[vertex.vertexIdxForBones + 3];
                            }
                            if (matIndicesExtra && vertexData.matricesIndicesExtra) {
                                vertexData.matricesIndicesExtra[currentVertexDataIndex * 4] = matIndicesExtra[vertex.vertexIdxForBones];
                                vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 1] = matIndicesExtra[vertex.vertexIdxForBones + 1];
                                vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 2] = matIndicesExtra[vertex.vertexIdxForBones + 2];
                                vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 3] = matIndicesExtra[vertex.vertexIdxForBones + 3];
                            }
                        }
                        if (vertex.matrixWeightsOverride) {
                            vertexData.matricesWeights[currentVertexDataIndex * 4] = vertex.matrixWeightsOverride[0];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 1] = vertex.matrixWeightsOverride[1];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 2] = vertex.matrixWeightsOverride[2];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 3] = vertex.matrixWeightsOverride[3];
                        }
                        else {
                            if (matWeights) {
                                vertexData.matricesWeights[currentVertexDataIndex * 4] = matWeights[vertex.vertexIdxForBones];
                                vertexData.matricesWeights[currentVertexDataIndex * 4 + 1] = matWeights[vertex.vertexIdxForBones + 1];
                                vertexData.matricesWeights[currentVertexDataIndex * 4 + 2] = matWeights[vertex.vertexIdxForBones + 2];
                                vertexData.matricesWeights[currentVertexDataIndex * 4 + 3] = matWeights[vertex.vertexIdxForBones + 3];
                            }
                            if (matWeightsExtra && vertexData.matricesWeightsExtra) {
                                vertexData.matricesWeightsExtra[currentVertexDataIndex * 4] = matWeightsExtra[vertex.vertexIdxForBones];
                                vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 1] = matWeightsExtra[vertex.vertexIdxForBones + 1];
                                vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 2] = matWeightsExtra[vertex.vertexIdxForBones + 2];
                                vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 3] = matWeightsExtra[vertex.vertexIdxForBones + 3];
                            }
                        }
                    }
                    if (!options.captureUVS) {
                        vertexData.uvs.push(0.5 + vertex.position.x / size.x);
                        const v = 0.5 + vertex.position.y / size.y;
                        vertexData.uvs.push(CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - v : v);
                    }
                    else {
                        vertex.uv.toArray(vertexData.uvs, currentVertexDataIndex * 2);
                    }
                    currentVertexDataIndex++;
                }
            }
        }
        // Avoid the "Setting vertex data kind 'XXX' with an empty array" warning when calling vertexData.applyToMesh
        if (vertexData.indices.length === 0)
            vertexData.indices = null;
        if (vertexData.positions.length === 0)
            vertexData.positions = null;
        if (vertexData.normals.length === 0)
            vertexData.normals = null;
        if (vertexData.uvs.length === 0)
            vertexData.uvs = null;
        if (((_a = vertexData.matricesIndices) === null || _a === void 0 ? void 0 : _a.length) === 0)
            vertexData.matricesIndices = null;
        if (((_b = vertexData.matricesWeights) === null || _b === void 0 ? void 0 : _b.length) === 0)
            vertexData.matricesWeights = null;
        if (((_c = vertexData.matricesIndicesExtra) === null || _c === void 0 ? void 0 : _c.length) === 0)
            vertexData.matricesIndicesExtra = null;
        if (((_d = vertexData.matricesWeightsExtra) === null || _d === void 0 ? void 0 : _d.length) === 0)
            vertexData.matricesWeightsExtra = null;
        // Return mesh
        const decal = new Mesh(name, sourceMesh.getScene());
        vertexData.applyToMesh(decal);
        if (useLocalComputation) {
            decal.skeleton = sourceMesh.skeleton;
            decal.parent = sourceMesh;
        }
        else {
            decal.position = position.clone();
            decal.rotation = new Vector3(pitch, yaw, angle);
        }
        decal.computeWorldMatrix(true);
        decal.refreshBoundingInfo(true, true);
        return decal;
    }
    Mesh.CreateDecal = (name, sourceMesh, position, normal, size, angle) => {
        const options = {
            position,
            normal,
            size,
            angle,
        };
        return CreateDecal(name, sourceMesh, options);
    };

    /**
     * Scripts based off of https://github.com/maximeq/three-js-capsule-geometry/blob/master/src/CapsuleBufferGeometry.js
     * @param options the constructors options used to shape the mesh.
     * @returns the capsule VertexData
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/capsule
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function CreateCapsuleVertexData(options = {
        subdivisions: 2,
        tessellation: 16,
        height: 1,
        radius: 0.25,
        capSubdivisions: 6,
    }) {
        const subdivisions = Math.max(options.subdivisions ? options.subdivisions : 2, 1) | 0;
        const tessellation = Math.max(options.tessellation ? options.tessellation : 16, 3) | 0;
        const height = Math.max(options.height ? options.height : 1, 0);
        const radius = Math.max(options.radius ? options.radius : 0.25, 0);
        const capDetail = Math.max(options.capSubdivisions ? options.capSubdivisions : 6, 1) | 0;
        const radialSegments = tessellation;
        const heightSegments = subdivisions;
        const radiusTop = Math.max(options.radiusTop ? options.radiusTop : radius, 0);
        const radiusBottom = Math.max(options.radiusBottom ? options.radiusBottom : radius, 0);
        const heightMinusCaps = height - (radiusTop + radiusBottom);
        const thetaStart = 0.0;
        const thetaLength = 2.0 * Math.PI;
        const capsTopSegments = Math.max(options.topCapSubdivisions ? options.topCapSubdivisions : capDetail, 1);
        const capsBottomSegments = Math.max(options.bottomCapSubdivisions ? options.bottomCapSubdivisions : capDetail, 1);
        const alpha = Math.acos((radiusBottom - radiusTop) / height);
        let indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        let index = 0;
        const indexArray = [], halfHeight = heightMinusCaps * 0.5;
        const pi2 = Math.PI * 0.5;
        let x, y;
        const normal = Vector3.Zero();
        const vertex = Vector3.Zero();
        const cosAlpha = Math.cos(alpha);
        const sinAlpha = Math.sin(alpha);
        const coneLength = new Vector2(radiusTop * sinAlpha, halfHeight + radiusTop * cosAlpha)
            .subtract(new Vector2(radiusBottom * sinAlpha, -halfHeight + radiusBottom * cosAlpha))
            .length();
        // Total length for v texture coord
        const vl = radiusTop * alpha + coneLength + radiusBottom * (pi2 - alpha);
        let v = 0;
        for (y = 0; y <= capsTopSegments; y++) {
            const indexRow = [];
            const a = pi2 - alpha * (y / capsTopSegments);
            v += (radiusTop * alpha) / capsTopSegments;
            const cosA = Math.cos(a);
            const sinA = Math.sin(a);
            // calculate the radius of the current row
            const _radius = cosA * radiusTop;
            for (x = 0; x <= radialSegments; x++) {
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = _radius * sinTheta;
                vertex.y = halfHeight + sinA * radiusTop;
                vertex.z = _radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(cosA * sinTheta, sinA, cosA * cosTheta);
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u, CompatibilityOptions.UseOpenGLOrientationForUV ? v / vl : 1 - v / vl);
                // save index of vertex in respective row
                indexRow.push(index);
                // increase index
                index++;
            }
            // now save vertices of the row in our index array
            indexArray.push(indexRow);
        }
        const coneHeight = height - radiusTop - radiusBottom + cosAlpha * radiusTop - cosAlpha * radiusBottom;
        const slope = (sinAlpha * (radiusBottom - radiusTop)) / coneHeight;
        for (y = 1; y <= heightSegments; y++) {
            const indexRow = [];
            v += coneLength / heightSegments;
            // calculate the radius of the current row
            const _radius = sinAlpha * ((y * (radiusBottom - radiusTop)) / heightSegments + radiusTop);
            for (x = 0; x <= radialSegments; x++) {
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = _radius * sinTheta;
                vertex.y = halfHeight + cosAlpha * radiusTop - (y * coneHeight) / heightSegments;
                vertex.z = _radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(sinTheta, slope, cosTheta).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u, CompatibilityOptions.UseOpenGLOrientationForUV ? v / vl : 1 - v / vl);
                // save index of vertex in respective row
                indexRow.push(index);
                // increase index
                index++;
            }
            // now save vertices of the row in our index array
            indexArray.push(indexRow);
        }
        for (y = 1; y <= capsBottomSegments; y++) {
            const indexRow = [];
            const a = pi2 - alpha - (Math.PI - alpha) * (y / capsBottomSegments);
            v += (radiusBottom * alpha) / capsBottomSegments;
            const cosA = Math.cos(a);
            const sinA = Math.sin(a);
            // calculate the radius of the current row
            const _radius = cosA * radiusBottom;
            for (x = 0; x <= radialSegments; x++) {
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = _radius * sinTheta;
                vertex.y = -halfHeight + sinA * radiusBottom;
                vertex.z = _radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(cosA * sinTheta, sinA, cosA * cosTheta);
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u, CompatibilityOptions.UseOpenGLOrientationForUV ? v / vl : 1 - v / vl);
                // save index of vertex in respective row
                indexRow.push(index);
                // increase index
                index++;
            }
            // now save vertices of the row in our index array
            indexArray.push(indexRow);
        }
        // generate indices
        for (x = 0; x < radialSegments; x++) {
            for (y = 0; y < capsTopSegments + heightSegments + capsBottomSegments; y++) {
                // we use the index array to access the correct indices
                const i1 = indexArray[y][x];
                const i2 = indexArray[y + 1][x];
                const i3 = indexArray[y + 1][x + 1];
                const i4 = indexArray[y][x + 1];
                // face one
                indices.push(i1);
                indices.push(i2);
                indices.push(i4);
                // face two
                indices.push(i2);
                indices.push(i3);
                indices.push(i4);
            }
        }
        indices = indices.reverse();
        if (options.orientation && !options.orientation.equals(Vector3.Up())) {
            const m = new Matrix();
            options.orientation
                .clone()
                .scale(Math.PI * 0.5)
                .cross(Vector3.Up())
                .toQuaternion()
                .toRotationMatrix(m);
            const v = Vector3.Zero();
            for (let i = 0; i < vertices.length; i += 3) {
                v.set(vertices[i], vertices[i + 1], vertices[i + 2]);
                Vector3.TransformCoordinatesToRef(v.clone(), m, v);
                vertices[i] = v.x;
                vertices[i + 1] = v.y;
                vertices[i + 2] = v.z;
            }
        }
        const vDat = new VertexData();
        vDat.positions = vertices;
        vDat.normals = normals;
        vDat.uvs = uvs;
        vDat.indices = indices;
        return vDat;
    }
    /**
     * Creates a capsule or a pill mesh
     * @param name defines the name of the mesh
     * @param options The constructors options.
     * @param scene The scene the mesh is scoped to.
     * @returns Capsule Mesh
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function CreateCapsule(name, options = {
        orientation: Vector3.Up(),
        subdivisions: 2,
        tessellation: 16,
        height: 1,
        radius: 0.25,
        capSubdivisions: 6,
        updatable: false,
    }, scene = null) {
        const capsule = new Mesh(name, scene);
        const vertexData = CreateCapsuleVertexData(options);
        vertexData.applyToMesh(capsule, options.updatable);
        return capsule;
    }
    /**
     * Creates a capsule or a pill mesh
     * @param name defines the name of the mesh.
     * @param options the constructors options used to shape the mesh.
     * @param scene defines the scene the mesh is scoped to.
     * @returns the capsule mesh
     * @see https://doc.babylonjs.com/how_to/capsule_shape
     */
    Mesh.CreateCapsule = (name, options, scene) => {
        return CreateCapsule(name, options, scene);
    };
    VertexData.CreateCapsule = CreateCapsuleVertexData;

    /**
     * Class representing an isovector a vector containing 2 INTEGER coordinates
     * x axis is horizontal
     * y axis is 60 deg counter clockwise from positive y axis
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _IsoVector {
        /**
         * Creates a new isovector from the given x and y coordinates
         * @param x defines the first coordinate, must be an integer
         * @param y defines the second coordinate, must be an integer
         */
        constructor(
        /** defines the first coordinate */
        x = 0, 
        /** defines the second coordinate */
        y = 0) {
            this.x = x;
            this.y = y;
            if (x !== Math.floor(x)) {
                Logger.Warn("x is not an integer, floor(x) used");
            }
            if (y !== Math.floor(y)) {
                Logger.Warn("y is not an integer, floor(y) used");
            }
        }
        // Operators
        /**
         * Gets a new IsoVector copied from the IsoVector
         * @returns a new IsoVector
         */
        clone() {
            return new _IsoVector(this.x, this.y);
        }
        /**
         * Rotates one IsoVector 60 degrees counter clockwise about another
         * Please note that this is an in place operation
         * @param other an IsoVector a center of rotation
         * @returns the rotated IsoVector
         */
        rotate60About(other) {
            //other IsoVector
            const x = this.x;
            this.x = other.x + other.y - this.y;
            this.y = x + this.y - other.x;
            return this;
        }
        /**
         * Rotates one IsoVector 60 degrees clockwise about another
         * Please note that this is an in place operation
         * @param other an IsoVector as center of rotation
         * @returns the rotated IsoVector
         */
        rotateNeg60About(other) {
            const x = this.x;
            this.x = x + this.y - other.y;
            this.y = other.x + other.y - x;
            return this;
        }
        /**
         * For an equilateral triangle OAB with O at isovector (0, 0) and A at isovector (m, n)
         * Rotates one IsoVector 120 degrees counter clockwise about the center of the triangle
         * Please note that this is an in place operation
         * @param m integer a measure a Primary triangle of order (m, n) m > n
         * @param n >= 0 integer a measure for a Primary triangle of order (m, n)
         * @returns the rotated IsoVector
         */
        rotate120(m, n) {
            //m, n integers
            if (m !== Math.floor(m)) {
                Logger.Warn("m not an integer only floor(m) used");
            }
            if (n !== Math.floor(n)) {
                Logger.Warn("n not an integer only floor(n) used");
            }
            const x = this.x;
            this.x = m - x - this.y;
            this.y = n + x;
            return this;
        }
        /**
         * For an equilateral triangle OAB with O at isovector (0, 0) and A at isovector (m, n)
         * Rotates one IsoVector 120 degrees clockwise about the center of the triangle
         * Please note that this is an in place operation
         * @param m integer a measure a Primary triangle of order (m, n) m > n
         * @param n >= 0 integer a measure for a Primary triangle of order (m, n)
         * @returns the rotated IsoVector
         */
        rotateNeg120(m, n) {
            //m, n integers
            if (m !== Math.floor(m)) {
                Logger.Warn("m is not an integer, floor(m) used");
            }
            if (n !== Math.floor(n)) {
                Logger.Warn("n is not an integer,   floor(n) used");
            }
            const x = this.x;
            this.x = this.y - n;
            this.y = m + n - x - this.y;
            return this;
        }
        /**
         * Transforms an IsoVector to one in Cartesian 3D space based on an isovector
         * @param origin an IsoVector
         * @param isoGridSize
         * @returns Point as a Vector3
         */
        toCartesianOrigin(origin, isoGridSize) {
            const point = Vector3.Zero();
            point.x = origin.x + 2 * this.x * isoGridSize + this.y * isoGridSize;
            point.y = origin.y + Math.sqrt(3) * this.y * isoGridSize;
            return point;
        }
        // Statics
        /**
         * Gets a new IsoVector(0, 0)
         * @returns a new IsoVector
         */
        static Zero() {
            return new _IsoVector(0, 0);
        }
    }

    /**
     * Class representing data for one face OAB of an equilateral icosahedron
     * When O is the isovector (0, 0), A is isovector (m, n)
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _PrimaryIsoTriangle {
        constructor() {
            this.cartesian = [];
            this.vertices = [];
            this.max = [];
            this.min = [];
            this.closestTo = [];
            this.innerFacets = [];
            this.isoVecsABOB = [];
            this.isoVecsOBOA = [];
            this.isoVecsBAOA = [];
            this.vertexTypes = [];
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.IDATA = new PolyhedronData("icosahedron", "Regular", [
                [0, PHI, -1],
                [-PHI, 1, 0],
                [-1, 0, -PHI],
                [1, 0, -PHI],
                [PHI, 1, 0],
                [0, PHI, 1],
                [-1, 0, PHI],
                [-PHI, -1, 0],
                [0, -PHI, -1],
                [PHI, -1, 0],
                [1, 0, PHI],
                [0, -PHI, 1],
            ], [
                [0, 2, 1],
                [0, 3, 2],
                [0, 4, 3],
                [0, 5, 4],
                [0, 1, 5],
                [7, 6, 1],
                [8, 7, 2],
                [9, 8, 3],
                [10, 9, 4],
                [6, 10, 5],
                [2, 7, 1],
                [3, 8, 2],
                [4, 9, 3],
                [5, 10, 4],
                [1, 6, 5],
                [11, 6, 7],
                [11, 7, 8],
                [11, 8, 9],
                [11, 9, 10],
                [11, 10, 6],
            ]);
        }
        /**
         * Creates the PrimaryIsoTriangle Triangle OAB
         * @param m an integer
         * @param n an integer
         */
        //operators
        setIndices() {
            let indexCount = 12; // 12 vertices already assigned
            const vecToidx = {}; //maps iso-vectors to indexCount;
            const m = this.m;
            const n = this.n;
            let g = m; // hcf of m, n when n != 0
            let m1 = 1;
            let n1 = 0;
            if (n !== 0) {
                g = Scalar.HCF(m, n);
            }
            m1 = m / g;
            n1 = n / g;
            let fr; //face to the right of current face
            let rot; //rotation about which vertex for fr
            let O;
            let A;
            let B;
            const oVec = _IsoVector.Zero();
            const aVec = new _IsoVector(m, n);
            const bVec = new _IsoVector(-n, m + n);
            const oaVec = _IsoVector.Zero();
            const abVec = _IsoVector.Zero();
            const obVec = _IsoVector.Zero();
            let verts = [];
            let idx;
            let idxR;
            let isoId;
            let isoIdR;
            const closestTo = [];
            const vDist = this.vertByDist;
            const matchIdx = (f, fr, isoId, isoIdR) => {
                idx = f + "|" + isoId;
                idxR = fr + "|" + isoIdR;
                if (!(idx in vecToidx || idxR in vecToidx)) {
                    vecToidx[idx] = indexCount;
                    vecToidx[idxR] = indexCount;
                    indexCount++;
                }
                else if (idx in vecToidx && !(idxR in vecToidx)) {
                    vecToidx[idxR] = vecToidx[idx];
                }
                else if (idxR in vecToidx && !(idx in vecToidx)) {
                    vecToidx[idx] = vecToidx[idxR];
                }
                if (vDist[isoId][0] > 2) {
                    closestTo[vecToidx[idx]] = [-vDist[isoId][0], vDist[isoId][1], vecToidx[idx]];
                }
                else {
                    closestTo[vecToidx[idx]] = [verts[vDist[isoId][0]], vDist[isoId][1], vecToidx[idx]];
                }
            };
            this.IDATA.edgematch = [
                [1, "B"],
                [2, "B"],
                [3, "B"],
                [4, "B"],
                [0, "B"],
                [10, "O", 14, "A"],
                [11, "O", 10, "A"],
                [12, "O", 11, "A"],
                [13, "O", 12, "A"],
                [14, "O", 13, "A"],
                [0, "O"],
                [1, "O"],
                [2, "O"],
                [3, "O"],
                [4, "O"],
                [19, "B", 5, "A"],
                [15, "B", 6, "A"],
                [16, "B", 7, "A"],
                [17, "B", 8, "A"],
                [18, "B", 9, "A"],
            ];
            /***edges AB to OB***** rotation about B*/
            for (let f = 0; f < 20; f++) {
                //f current face
                verts = this.IDATA.face[f];
                O = verts[2];
                A = verts[1];
                B = verts[0];
                isoId = oVec.x + "|" + oVec.y;
                idx = f + "|" + isoId;
                if (!(idx in vecToidx)) {
                    vecToidx[idx] = O;
                    closestTo[O] = [verts[vDist[isoId][0]], vDist[isoId][1]];
                }
                isoId = aVec.x + "|" + aVec.y;
                idx = f + "|" + isoId;
                if (!(idx in vecToidx)) {
                    vecToidx[idx] = A;
                    closestTo[A] = [verts[vDist[isoId][0]], vDist[isoId][1]];
                }
                isoId = bVec.x + "|" + bVec.y;
                idx = f + "|" + isoId;
                if (!(idx in vecToidx)) {
                    vecToidx[idx] = B;
                    closestTo[B] = [verts[vDist[isoId][0]], vDist[isoId][1]];
                }
                //for edge vertices
                fr = this.IDATA.edgematch[f][0];
                rot = this.IDATA.edgematch[f][1];
                if (rot === "B") {
                    for (let i = 1; i < g; i++) {
                        abVec.x = m - i * (m1 + n1);
                        abVec.y = n + i * m1;
                        obVec.x = -i * n1;
                        obVec.y = i * (m1 + n1);
                        isoId = abVec.x + "|" + abVec.y;
                        isoIdR = obVec.x + "|" + obVec.y;
                        matchIdx(f, fr, isoId, isoIdR);
                    }
                }
                if (rot === "O") {
                    for (let i = 1; i < g; i++) {
                        obVec.x = -i * n1;
                        obVec.y = i * (m1 + n1);
                        oaVec.x = i * m1;
                        oaVec.y = i * n1;
                        isoId = obVec.x + "|" + obVec.y;
                        isoIdR = oaVec.x + "|" + oaVec.y;
                        matchIdx(f, fr, isoId, isoIdR);
                    }
                }
                fr = this.IDATA.edgematch[f][2];
                rot = this.IDATA.edgematch[f][3];
                if (rot && rot === "A") {
                    for (let i = 1; i < g; i++) {
                        oaVec.x = i * m1;
                        oaVec.y = i * n1;
                        abVec.x = m - (g - i) * (m1 + n1); //reversed for BA
                        abVec.y = n + (g - i) * m1; //reversed for BA
                        isoId = oaVec.x + "|" + oaVec.y;
                        isoIdR = abVec.x + "|" + abVec.y;
                        matchIdx(f, fr, isoId, isoIdR);
                    }
                }
                for (let i = 0; i < this.vertices.length; i++) {
                    isoId = this.vertices[i].x + "|" + this.vertices[i].y;
                    idx = f + "|" + isoId;
                    if (!(idx in vecToidx)) {
                        vecToidx[idx] = indexCount++;
                        if (vDist[isoId][0] > 2) {
                            closestTo[vecToidx[idx]] = [-vDist[isoId][0], vDist[isoId][1], vecToidx[idx]];
                        }
                        else {
                            closestTo[vecToidx[idx]] = [verts[vDist[isoId][0]], vDist[isoId][1], vecToidx[idx]];
                        }
                    }
                }
            }
            this.closestTo = closestTo;
            this.vecToidx = vecToidx;
        }
        calcCoeffs() {
            const m = this.m;
            const n = this.n;
            const thirdR3 = Math.sqrt(3) / 3;
            const LSQD = m * m + n * n + m * n;
            this.coau = (m + n) / LSQD;
            this.cobu = -n / LSQD;
            this.coav = (-thirdR3 * (m - n)) / LSQD;
            this.cobv = (thirdR3 * (2 * m + n)) / LSQD;
        }
        createInnerFacets() {
            const m = this.m;
            const n = this.n;
            for (let y = 0; y < n + m + 1; y++) {
                for (let x = this.min[y]; x < this.max[y] + 1; x++) {
                    if (x < this.max[y] && x < this.max[y + 1] + 1) {
                        this.innerFacets.push(["|" + x + "|" + y, "|" + x + "|" + (y + 1), "|" + (x + 1) + "|" + y]);
                    }
                    if (y > 0 && x < this.max[y - 1] && x + 1 < this.max[y] + 1) {
                        this.innerFacets.push(["|" + x + "|" + y, "|" + (x + 1) + "|" + y, "|" + (x + 1) + "|" + (y - 1)]);
                    }
                }
            }
        }
        edgeVecsABOB() {
            const m = this.m;
            const n = this.n;
            const B = new _IsoVector(-n, m + n);
            for (let y = 1; y < m + n; y++) {
                const point = new _IsoVector(this.min[y], y);
                const prev = new _IsoVector(this.min[y - 1], y - 1);
                const next = new _IsoVector(this.min[y + 1], y + 1);
                const pointR = point.clone();
                const prevR = prev.clone();
                const nextR = next.clone();
                pointR.rotate60About(B);
                prevR.rotate60About(B);
                nextR.rotate60About(B);
                const maxPoint = new _IsoVector(this.max[pointR.y], pointR.y);
                const maxPrev = new _IsoVector(this.max[pointR.y - 1], pointR.y - 1);
                const maxLeftPrev = new _IsoVector(this.max[pointR.y - 1] - 1, pointR.y - 1);
                if (pointR.x !== maxPoint.x || pointR.y !== maxPoint.y) {
                    if (pointR.x !== maxPrev.x) {
                        // type2
                        //up
                        this.vertexTypes.push([1, 0, 0]);
                        this.isoVecsABOB.push([point, maxPrev, maxLeftPrev]);
                        //down
                        this.vertexTypes.push([1, 0, 0]);
                        this.isoVecsABOB.push([point, maxLeftPrev, maxPoint]);
                    }
                    else if (pointR.y === nextR.y) {
                        // type1
                        //up
                        this.vertexTypes.push([1, 1, 0]);
                        this.isoVecsABOB.push([point, prev, maxPrev]);
                        //down
                        this.vertexTypes.push([1, 0, 1]);
                        this.isoVecsABOB.push([point, maxPrev, next]);
                    }
                    else {
                        // type 0
                        //up
                        this.vertexTypes.push([1, 1, 0]);
                        this.isoVecsABOB.push([point, prev, maxPrev]);
                        //down
                        this.vertexTypes.push([1, 0, 0]);
                        this.isoVecsABOB.push([point, maxPrev, maxPoint]);
                    }
                }
            }
        }
        mapABOBtoOBOA() {
            const point = new _IsoVector(0, 0);
            for (let i = 0; i < this.isoVecsABOB.length; i++) {
                const temp = [];
                for (let j = 0; j < 3; j++) {
                    point.x = this.isoVecsABOB[i][j].x;
                    point.y = this.isoVecsABOB[i][j].y;
                    if (this.vertexTypes[i][j] === 0) {
                        point.rotateNeg120(this.m, this.n);
                    }
                    temp.push(point.clone());
                }
                this.isoVecsOBOA.push(temp);
            }
        }
        mapABOBtoBAOA() {
            const point = new _IsoVector(0, 0);
            for (let i = 0; i < this.isoVecsABOB.length; i++) {
                const temp = [];
                for (let j = 0; j < 3; j++) {
                    point.x = this.isoVecsABOB[i][j].x;
                    point.y = this.isoVecsABOB[i][j].y;
                    if (this.vertexTypes[i][j] === 1) {
                        point.rotate120(this.m, this.n);
                    }
                    temp.push(point.clone());
                }
                this.isoVecsBAOA.push(temp);
            }
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        MapToFace(faceNb, geodesicData) {
            const F = this.IDATA.face[faceNb];
            const oidx = F[2];
            const aidx = F[1];
            const bidx = F[0];
            const O = Vector3.FromArray(this.IDATA.vertex[oidx]);
            const A = Vector3.FromArray(this.IDATA.vertex[aidx]);
            const B = Vector3.FromArray(this.IDATA.vertex[bidx]);
            const OA = A.subtract(O);
            const OB = B.subtract(O);
            const x = OA.scale(this.coau).add(OB.scale(this.cobu));
            const y = OA.scale(this.coav).add(OB.scale(this.cobv));
            const mapped = [];
            let idx;
            let tempVec = TmpVectors.Vector3[0];
            for (let i = 0; i < this.cartesian.length; i++) {
                tempVec = x.scale(this.cartesian[i].x).add(y.scale(this.cartesian[i].y)).add(O);
                mapped[i] = [tempVec.x, tempVec.y, tempVec.z];
                idx = faceNb + "|" + this.vertices[i].x + "|" + this.vertices[i].y;
                geodesicData.vertex[this.vecToidx[idx]] = [tempVec.x, tempVec.y, tempVec.z];
            }
        }
        //statics
        /**Creates a primary triangle
         * @internal
         */
        build(m, n) {
            const vertices = new Array();
            const O = _IsoVector.Zero();
            const A = new _IsoVector(m, n);
            const B = new _IsoVector(-n, m + n);
            vertices.push(O, A, B);
            //max internal isoceles triangle vertices
            for (let y = n; y < m + 1; y++) {
                for (let x = 0; x < m + 1 - y; x++) {
                    vertices.push(new _IsoVector(x, y));
                }
            }
            //shared vertices along edges when needed
            if (n > 0) {
                const g = Scalar.HCF(m, n);
                const m1 = m / g;
                const n1 = n / g;
                for (let i = 1; i < g; i++) {
                    vertices.push(new _IsoVector(i * m1, i * n1)); //OA
                    vertices.push(new _IsoVector(-i * n1, i * (m1 + n1))); //OB
                    vertices.push(new _IsoVector(m - i * (m1 + n1), n + i * m1)); // AB
                }
                //lower rows vertices and their rotations
                const ratio = m / n;
                for (let y = 1; y < n; y++) {
                    for (let x = 0; x < y * ratio; x++) {
                        vertices.push(new _IsoVector(x, y));
                        vertices.push(new _IsoVector(x, y).rotate120(m, n));
                        vertices.push(new _IsoVector(x, y).rotateNeg120(m, n));
                    }
                }
            }
            //order vertices by x and then y
            vertices.sort((a, b) => {
                return a.x - b.x;
            });
            vertices.sort((a, b) => {
                return a.y - b.y;
            });
            const min = new Array(m + n + 1);
            const max = new Array(m + n + 1);
            for (let i = 0; i < min.length; i++) {
                min[i] = Infinity;
                max[i] = -Infinity;
            }
            let y = 0;
            let x = 0;
            const len = vertices.length;
            for (let i = 0; i < len; i++) {
                x = vertices[i].x;
                y = vertices[i].y;
                min[y] = Math.min(x, min[y]);
                max[y] = Math.max(x, max[y]);
            }
            //calculates the distance of a vertex from a given primary vertex
            const distFrom = (vert, primVert) => {
                const v = vert.clone();
                if (primVert === "A") {
                    v.rotateNeg120(m, n);
                }
                if (primVert === "B") {
                    v.rotate120(m, n);
                }
                if (v.x < 0) {
                    return v.y;
                }
                return v.x + v.y;
            };
            const cartesian = [];
            const distFromO = [];
            const distFromA = [];
            const distFromB = [];
            const vertByDist = {};
            const vertData = [];
            let closest = -1;
            let dist = -1;
            for (let i = 0; i < len; i++) {
                cartesian[i] = vertices[i].toCartesianOrigin(new _IsoVector(0, 0), 0.5);
                distFromO[i] = distFrom(vertices[i], "O");
                distFromA[i] = distFrom(vertices[i], "A");
                distFromB[i] = distFrom(vertices[i], "B");
                if (distFromO[i] === distFromA[i] && distFromA[i] === distFromB[i]) {
                    closest = 3;
                    dist = distFromO[i];
                }
                else if (distFromO[i] === distFromA[i]) {
                    closest = 4;
                    dist = distFromO[i];
                }
                else if (distFromA[i] === distFromB[i]) {
                    closest = 5;
                    dist = distFromA[i];
                }
                else if (distFromB[i] === distFromO[i]) {
                    closest = 6;
                    dist = distFromO[i];
                }
                if (distFromO[i] < distFromA[i] && distFromO[i] < distFromB[i]) {
                    closest = 2;
                    dist = distFromO[i];
                }
                if (distFromA[i] < distFromO[i] && distFromA[i] < distFromB[i]) {
                    closest = 1;
                    dist = distFromA[i];
                }
                if (distFromB[i] < distFromA[i] && distFromB[i] < distFromO[i]) {
                    closest = 0;
                    dist = distFromB[i];
                }
                vertData.push([closest, dist, vertices[i].x, vertices[i].y]);
            }
            vertData.sort((a, b) => {
                return a[2] - b[2];
            });
            vertData.sort((a, b) => {
                return a[3] - b[3];
            });
            vertData.sort((a, b) => {
                return a[1] - b[1];
            });
            vertData.sort((a, b) => {
                return a[0] - b[0];
            });
            for (let v = 0; v < vertData.length; v++) {
                vertByDist[vertData[v][2] + "|" + vertData[v][3]] = [vertData[v][0], vertData[v][1], v];
            }
            this.m = m;
            this.n = n;
            this.vertices = vertices;
            this.vertByDist = vertByDist;
            this.cartesian = cartesian;
            this.min = min;
            this.max = max;
            return this;
        }
    }
    /** Builds Polyhedron Data
     * @internal
     */
    class PolyhedronData {
        constructor(name, category, vertex, face) {
            this.name = name;
            this.category = category;
            this.vertex = vertex;
            this.face = face;
        }
    }
    /**
     * This class Extends the PolyhedronData Class to provide measures for a Geodesic Polyhedron
     */
    class GeodesicData extends PolyhedronData {
        /**
         * @internal
         */
        innerToData(face, primTri) {
            for (let i = 0; i < primTri.innerFacets.length; i++) {
                this.face.push(primTri.innerFacets[i].map((el) => primTri.vecToidx[face + el]));
            }
        }
        /**
         * @internal
         */
        mapABOBtoDATA(faceNb, primTri) {
            const fr = primTri.IDATA.edgematch[faceNb][0];
            for (let i = 0; i < primTri.isoVecsABOB.length; i++) {
                const temp = [];
                for (let j = 0; j < 3; j++) {
                    if (primTri.vertexTypes[i][j] === 0) {
                        temp.push(faceNb + "|" + primTri.isoVecsABOB[i][j].x + "|" + primTri.isoVecsABOB[i][j].y);
                    }
                    else {
                        temp.push(fr + "|" + primTri.isoVecsABOB[i][j].x + "|" + primTri.isoVecsABOB[i][j].y);
                    }
                }
                this.face.push([primTri.vecToidx[temp[0]], primTri.vecToidx[temp[1]], primTri.vecToidx[temp[2]]]);
            }
        }
        /**
         * @internal
         */
        mapOBOAtoDATA(faceNb, primTri) {
            const fr = primTri.IDATA.edgematch[faceNb][0];
            for (let i = 0; i < primTri.isoVecsOBOA.length; i++) {
                const temp = [];
                for (let j = 0; j < 3; j++) {
                    if (primTri.vertexTypes[i][j] === 1) {
                        temp.push(faceNb + "|" + primTri.isoVecsOBOA[i][j].x + "|" + primTri.isoVecsOBOA[i][j].y);
                    }
                    else {
                        temp.push(fr + "|" + primTri.isoVecsOBOA[i][j].x + "|" + primTri.isoVecsOBOA[i][j].y);
                    }
                }
                this.face.push([primTri.vecToidx[temp[0]], primTri.vecToidx[temp[1]], primTri.vecToidx[temp[2]]]);
            }
        }
        /**
         * @internal
         */
        mapBAOAtoDATA(faceNb, primTri) {
            const fr = primTri.IDATA.edgematch[faceNb][2];
            for (let i = 0; i < primTri.isoVecsBAOA.length; i++) {
                const temp = [];
                for (let j = 0; j < 3; j++) {
                    if (primTri.vertexTypes[i][j] === 1) {
                        temp.push(faceNb + "|" + primTri.isoVecsBAOA[i][j].x + "|" + primTri.isoVecsBAOA[i][j].y);
                    }
                    else {
                        temp.push(fr + "|" + primTri.isoVecsBAOA[i][j].x + "|" + primTri.isoVecsBAOA[i][j].y);
                    }
                }
                this.face.push([primTri.vecToidx[temp[0]], primTri.vecToidx[temp[1]], primTri.vecToidx[temp[2]]]);
            }
        }
        /**
         * @internal
         */
        orderData(primTri) {
            const nearTo = [];
            for (let i = 0; i < 13; i++) {
                nearTo[i] = [];
            }
            const close = primTri.closestTo;
            for (let i = 0; i < close.length; i++) {
                if (close[i][0] > -1) {
                    if (close[i][1] > 0) {
                        nearTo[close[i][0]].push([i, close[i][1]]);
                    }
                }
                else {
                    nearTo[12].push([i, close[i][0]]);
                }
            }
            const near = [];
            for (let i = 0; i < 12; i++) {
                near[i] = i;
            }
            let nearIndex = 12;
            for (let i = 0; i < 12; i++) {
                nearTo[i].sort((a, b) => {
                    return a[1] - b[1];
                });
                for (let j = 0; j < nearTo[i].length; j++) {
                    near[nearTo[i][j][0]] = nearIndex++;
                }
            }
            for (let j = 0; j < nearTo[12].length; j++) {
                near[nearTo[12][j][0]] = nearIndex++;
            }
            for (let i = 0; i < this.vertex.length; i++) {
                this.vertex[i].push(near[i]);
            }
            this.vertex.sort((a, b) => {
                return a[3] - b[3];
            });
            for (let i = 0; i < this.vertex.length; i++) {
                this.vertex[i].pop();
            }
            for (let i = 0; i < this.face.length; i++) {
                for (let j = 0; j < this.face[i].length; j++) {
                    this.face[i][j] = near[this.face[i][j]];
                }
            }
            this.sharedNodes = nearTo[12].length;
            this.poleNodes = this.vertex.length - this.sharedNodes;
        }
        /**
         * @internal
         */
        setOrder(m, faces) {
            const adjVerts = [];
            const dualFaces = [];
            let face = faces.pop();
            dualFaces.push(face);
            let index = this.face[face].indexOf(m);
            index = (index + 2) % 3;
            let v = this.face[face][index];
            adjVerts.push(v);
            let f = 0;
            while (faces.length > 0) {
                face = faces[f];
                if (this.face[face].indexOf(v) > -1) {
                    // v is a vertex of face f
                    index = (this.face[face].indexOf(v) + 1) % 3;
                    v = this.face[face][index];
                    adjVerts.push(v);
                    dualFaces.push(face);
                    faces.splice(f, 1);
                    f = 0;
                }
                else {
                    f++;
                }
            }
            this.adjacentFaces.push(adjVerts);
            return dualFaces;
        }
        /**
         * @internal
         */
        toGoldbergPolyhedronData() {
            const goldbergPolyhedronData = new PolyhedronData("GeoDual", "Goldberg", [], []);
            goldbergPolyhedronData.name = "GD dual";
            const verticesNb = this.vertex.length;
            const map = new Array(verticesNb);
            for (let v = 0; v < verticesNb; v++) {
                map[v] = [];
            }
            for (let f = 0; f < this.face.length; f++) {
                for (let i = 0; i < 3; i++) {
                    map[this.face[f][i]].push(f);
                }
            }
            let cx = 0;
            let cy = 0;
            let cz = 0;
            let face = [];
            let vertex = [];
            this.adjacentFaces = [];
            for (let m = 0; m < map.length; m++) {
                goldbergPolyhedronData.face[m] = this.setOrder(m, map[m].concat([]));
                map[m].forEach((el) => {
                    cx = 0;
                    cy = 0;
                    cz = 0;
                    face = this.face[el];
                    for (let i = 0; i < 3; i++) {
                        vertex = this.vertex[face[i]];
                        cx += vertex[0];
                        cy += vertex[1];
                        cz += vertex[2];
                    }
                    goldbergPolyhedronData.vertex[el] = [cx / 3, cy / 3, cz / 3];
                });
            }
            return goldbergPolyhedronData;
        }
        //statics
        /**Builds the data for a Geodesic Polyhedron from a primary triangle
         * @param primTri the primary triangle
         * @internal
         */
        static BuildGeodesicData(primTri) {
            const geodesicData = new GeodesicData("Geodesic-m-n", "Geodesic", [
                [0, PHI, -1],
                [-PHI, 1, 0],
                [-1, 0, -PHI],
                [1, 0, -PHI],
                [PHI, 1, 0],
                [0, PHI, 1],
                [-1, 0, PHI],
                [-PHI, -1, 0],
                [0, -PHI, -1],
                [PHI, -1, 0],
                [1, 0, PHI],
                [0, -PHI, 1],
            ], []);
            primTri.setIndices();
            primTri.calcCoeffs();
            primTri.createInnerFacets();
            primTri.edgeVecsABOB();
            primTri.mapABOBtoOBOA();
            primTri.mapABOBtoBAOA();
            for (let f = 0; f < primTri.IDATA.face.length; f++) {
                primTri.MapToFace(f, geodesicData);
                geodesicData.innerToData(f, primTri);
                if (primTri.IDATA.edgematch[f][1] === "B") {
                    geodesicData.mapABOBtoDATA(f, primTri);
                }
                if (primTri.IDATA.edgematch[f][1] === "O") {
                    geodesicData.mapOBOAtoDATA(f, primTri);
                }
                if (primTri.IDATA.edgematch[f][3] === "A") {
                    geodesicData.mapBAOAtoDATA(f, primTri);
                }
            }
            geodesicData.orderData(primTri);
            const radius = 1;
            geodesicData.vertex = geodesicData.vertex.map(function (el) {
                const a = el[0];
                const b = el[1];
                const c = el[2];
                const d = Math.sqrt(a * a + b * b + c * c);
                el[0] *= radius / d;
                el[1] *= radius / d;
                el[2] *= radius / d;
                return el;
            });
            return geodesicData;
        }
    }

    /**
     * Creates the Mesh for a Geodesic Polyhedron
     * @see https://en.wikipedia.org/wiki/Geodesic_polyhedron
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra/geodesic_poly
     * @param name defines the name of the mesh
     * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
     * * m number of horizontal steps along an isogrid
     * * n number of angled steps along an isogrid
     * * size the size of the Geodesic, optional default 1
     * * sizeX allows stretching in the x direction, optional, default size
     * * sizeY allows stretching in the y direction, optional, default size
     * * sizeZ allows stretching in the z direction, optional, default size
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param options.n
     * @param options.size
     * @param options.sizeX
     * @param options.sizeY
     * @param options.sizeZ
     * @param options.faceUV
     * @param options.faceColors
     * @param options.flat
     * @param options.updatable
     * @param options.sideOrientation
     * @param options.frontUVs
     * @param options.backUVs
     * @param options.m
     * @param scene defines the hosting scene
     * @returns Geodesic mesh
     */
    function CreateGeodesic(name, options, scene = null) {
        let m = options.m || 1;
        if (m !== Math.floor(m)) {
            Logger.Warn("m not an integer only floor(m) used");
        }
        let n = options.n || 0;
        if (n !== Math.floor(n)) {
            Logger.Warn("n not an integer only floor(n) used");
        }
        if (n > m) {
            const temp = n;
            n = m;
            m = temp;
            Logger.Warn("n > m therefore m and n swapped");
        }
        const primTri = new _PrimaryIsoTriangle();
        primTri.build(m, n);
        const geodesicData = GeodesicData.BuildGeodesicData(primTri);
        const geoOptions = {
            custom: geodesicData,
            size: options.size,
            sizeX: options.sizeX,
            sizeY: options.sizeY,
            sizeZ: options.sizeZ,
            faceUV: options.faceUV,
            faceColors: options.faceColors,
            flat: options.flat,
            updatable: options.updatable,
            sideOrientation: options.sideOrientation,
            frontUVs: options.frontUVs,
            backUVs: options.backUVs,
        };
        const geodesic = CreatePolyhedron(name, geoOptions, scene);
        return geodesic;
    }

    Mesh._GoldbergMeshParser = (parsedMesh, scene) => {
        return GoldbergMesh.Parse(parsedMesh, scene);
    };
    /**
     * Mesh for a Goldberg Polyhedron which is made from 12 pentagonal and the rest hexagonal faces
     * @see https://en.wikipedia.org/wiki/Goldberg_polyhedron
     */
    class GoldbergMesh extends Mesh {
        constructor() {
            super(...arguments);
            /**
             * Defines the specific Goldberg data used in this mesh construction.
             */
            this.goldbergData = {
                faceColors: [],
                faceCenters: [],
                faceZaxis: [],
                faceXaxis: [],
                faceYaxis: [],
                nbSharedFaces: 0,
                nbUnsharedFaces: 0,
                nbFaces: 0,
                nbFacesAtPole: 0,
                adjacentFaces: [],
            };
        }
        /**
         * Gets the related Goldberg face from pole infos
         * @param poleOrShared Defines the pole index or the shared face index if the fromPole parameter is passed in
         * @param fromPole Defines an optional pole index to find the related info from
         * @returns the goldberg face number
         */
        relatedGoldbergFace(poleOrShared, fromPole) {
            if (fromPole === void 0) {
                if (poleOrShared > this.goldbergData.nbUnsharedFaces - 1) {
                    Logger.Warn("Maximum number of unshared faces used");
                    poleOrShared = this.goldbergData.nbUnsharedFaces - 1;
                }
                return this.goldbergData.nbUnsharedFaces + poleOrShared;
            }
            if (poleOrShared > 11) {
                Logger.Warn("Last pole used");
                poleOrShared = 11;
            }
            if (fromPole > this.goldbergData.nbFacesAtPole - 1) {
                Logger.Warn("Maximum number of faces at a pole used");
                fromPole = this.goldbergData.nbFacesAtPole - 1;
            }
            return 12 + poleOrShared * this.goldbergData.nbFacesAtPole + fromPole;
        }
        _changeGoldbergFaceColors(colorRange) {
            for (let i = 0; i < colorRange.length; i++) {
                const min = colorRange[i][0];
                const max = colorRange[i][1];
                const col = colorRange[i][2];
                for (let f = min; f < max + 1; f++) {
                    this.goldbergData.faceColors[f] = col;
                }
            }
            const newCols = [];
            for (let f = 0; f < 12; f++) {
                for (let i = 0; i < 5; i++) {
                    newCols.push(this.goldbergData.faceColors[f].r, this.goldbergData.faceColors[f].g, this.goldbergData.faceColors[f].b, this.goldbergData.faceColors[f].a);
                }
            }
            for (let f = 12; f < this.goldbergData.faceColors.length; f++) {
                for (let i = 0; i < 6; i++) {
                    newCols.push(this.goldbergData.faceColors[f].r, this.goldbergData.faceColors[f].g, this.goldbergData.faceColors[f].b, this.goldbergData.faceColors[f].a);
                }
            }
            return newCols;
        }
        /**
         * Set new goldberg face colors
         * @param colorRange the new color to apply to the mesh
         */
        setGoldbergFaceColors(colorRange) {
            const newCols = this._changeGoldbergFaceColors(colorRange);
            this.setVerticesData(VertexBuffer.ColorKind, newCols);
        }
        /**
         * Updates new goldberg face colors
         * @param colorRange the new color to apply to the mesh
         */
        updateGoldbergFaceColors(colorRange) {
            const newCols = this._changeGoldbergFaceColors(colorRange);
            this.updateVerticesData(VertexBuffer.ColorKind, newCols);
        }
        _changeGoldbergFaceUVs(uvRange) {
            const uvs = this.getVerticesData(VertexBuffer.UVKind);
            for (let i = 0; i < uvRange.length; i++) {
                const min = uvRange[i][0];
                const max = uvRange[i][1];
                const center = uvRange[i][2];
                const radius = uvRange[i][3];
                const angle = uvRange[i][4];
                const points5 = [];
                const points6 = [];
                let u;
                let v;
                for (let p = 0; p < 5; p++) {
                    u = center.x + radius * Math.cos(angle + (p * Math.PI) / 2.5);
                    v = center.y + radius * Math.sin(angle + (p * Math.PI) / 2.5);
                    if (u < 0) {
                        u = 0;
                    }
                    if (u > 1) {
                        u = 1;
                    }
                    points5.push(u, v);
                }
                for (let p = 0; p < 6; p++) {
                    u = center.x + radius * Math.cos(angle + (p * Math.PI) / 3);
                    v = center.y + radius * Math.sin(angle + (p * Math.PI) / 3);
                    if (u < 0) {
                        u = 0;
                    }
                    if (u > 1) {
                        u = 1;
                    }
                    points6.push(u, v);
                }
                for (let f = min; f < Math.min(12, max + 1); f++) {
                    for (let p = 0; p < 5; p++) {
                        uvs[10 * f + 2 * p] = points5[2 * p];
                        uvs[10 * f + 2 * p + 1] = points5[2 * p + 1];
                    }
                }
                for (let f = Math.max(12, min); f < max + 1; f++) {
                    for (let p = 0; p < 6; p++) {
                        //120 + 12 * (f - 12) = 12 * f - 24
                        uvs[12 * f - 24 + 2 * p] = points6[2 * p];
                        uvs[12 * f - 23 + 2 * p] = points6[2 * p + 1];
                    }
                }
            }
            return uvs;
        }
        /**
         * set new goldberg face UVs
         * @param uvRange the new UVs to apply to the mesh
         */
        setGoldbergFaceUVs(uvRange) {
            const newUVs = this._changeGoldbergFaceUVs(uvRange);
            this.setVerticesData(VertexBuffer.UVKind, newUVs);
        }
        /**
         * Updates new goldberg face UVs
         * @param uvRange the new UVs to apply to the mesh
         */
        updateGoldbergFaceUVs(uvRange) {
            const newUVs = this._changeGoldbergFaceUVs(uvRange);
            this.updateVerticesData(VertexBuffer.UVKind, newUVs);
        }
        /**
         * Places a mesh on a particular face of the goldberg polygon
         * @param mesh Defines the mesh to position
         * @param face Defines the face to position onto
         * @param position Defines the position relative to the face we are positioning the mesh onto
         */
        placeOnGoldbergFaceAt(mesh, face, position) {
            const orientation = Vector3.RotationFromAxis(this.goldbergData.faceXaxis[face], this.goldbergData.faceYaxis[face], this.goldbergData.faceZaxis[face]);
            mesh.rotation = orientation;
            mesh.position = this.goldbergData.faceCenters[face]
                .add(this.goldbergData.faceXaxis[face].scale(position.x))
                .add(this.goldbergData.faceYaxis[face].scale(position.y))
                .add(this.goldbergData.faceZaxis[face].scale(position.z));
        }
        /**
         * Serialize current mesh
         * @param serializationObject defines the object which will receive the serialization data
         */
        serialize(serializationObject) {
            super.serialize(serializationObject);
            serializationObject.type = "GoldbergMesh";
            const goldbergData = {};
            goldbergData.adjacentFaces = this.goldbergData.adjacentFaces;
            goldbergData.nbSharedFaces = this.goldbergData.nbSharedFaces;
            goldbergData.nbUnsharedFaces = this.goldbergData.nbUnsharedFaces;
            goldbergData.nbFaces = this.goldbergData.nbFaces;
            goldbergData.nbFacesAtPole = this.goldbergData.nbFacesAtPole;
            if (this.goldbergData.faceColors) {
                goldbergData.faceColors = [];
                for (const color of this.goldbergData.faceColors) {
                    goldbergData.faceColors.push(color.asArray());
                }
            }
            if (this.goldbergData.faceCenters) {
                goldbergData.faceCenters = [];
                for (const vector of this.goldbergData.faceCenters) {
                    goldbergData.faceCenters.push(vector.asArray());
                }
            }
            if (this.goldbergData.faceZaxis) {
                goldbergData.faceZaxis = [];
                for (const vector of this.goldbergData.faceZaxis) {
                    goldbergData.faceZaxis.push(vector.asArray());
                }
            }
            if (this.goldbergData.faceYaxis) {
                goldbergData.faceYaxis = [];
                for (const vector of this.goldbergData.faceYaxis) {
                    goldbergData.faceYaxis.push(vector.asArray());
                }
            }
            if (this.goldbergData.faceXaxis) {
                goldbergData.faceXaxis = [];
                for (const vector of this.goldbergData.faceXaxis) {
                    goldbergData.faceXaxis.push(vector.asArray());
                }
            }
            serializationObject.goldbergData = goldbergData;
        }
        /**
         * Parses a serialized goldberg mesh
         * @param parsedMesh the serialized mesh
         * @param scene the scene to create the goldberg mesh in
         * @returns the created goldberg mesh
         */
        static Parse(parsedMesh, scene) {
            const goldbergData = parsedMesh.goldbergData;
            goldbergData.faceColors = goldbergData.faceColors.map((el) => Color4.FromArray(el));
            goldbergData.faceCenters = goldbergData.faceCenters.map((el) => Vector3.FromArray(el));
            goldbergData.faceZaxis = goldbergData.faceZaxis.map((el) => Vector3.FromArray(el));
            goldbergData.faceXaxis = goldbergData.faceXaxis.map((el) => Vector3.FromArray(el));
            goldbergData.faceYaxis = goldbergData.faceYaxis.map((el) => Vector3.FromArray(el));
            const goldberg = new GoldbergMesh(parsedMesh.name, scene);
            goldberg.goldbergData = goldbergData;
            return goldberg;
        }
    }

    /**
     * Creates the Mesh for a Goldberg Polyhedron
     * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
     * @param goldbergData polyhedronData defining the Goldberg polyhedron
     * @returns GoldbergSphere mesh
     */
    function CreateGoldbergVertexData(options, goldbergData) {
        const size = options.size;
        const sizeX = options.sizeX || size || 1;
        const sizeY = options.sizeY || size || 1;
        const sizeZ = options.sizeZ || size || 1;
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const positions = new Array();
        const indices = new Array();
        const normals = new Array();
        const uvs = new Array();
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for (let v = 0; v < goldbergData.vertex.length; v++) {
            minX = Math.min(minX, goldbergData.vertex[v][0] * sizeX);
            maxX = Math.max(maxX, goldbergData.vertex[v][0] * sizeX);
            minY = Math.min(minY, goldbergData.vertex[v][1] * sizeY);
            maxY = Math.max(maxY, goldbergData.vertex[v][1] * sizeY);
        }
        let index = 0;
        for (let f = 0; f < goldbergData.face.length; f++) {
            const verts = goldbergData.face[f];
            const a = Vector3.FromArray(goldbergData.vertex[verts[0]]);
            const b = Vector3.FromArray(goldbergData.vertex[verts[2]]);
            const c = Vector3.FromArray(goldbergData.vertex[verts[1]]);
            const ba = b.subtract(a);
            const ca = c.subtract(a);
            const norm = Vector3.Cross(ca, ba).normalize();
            for (let v = 0; v < verts.length; v++) {
                normals.push(norm.x, norm.y, norm.z);
                const pdata = goldbergData.vertex[verts[v]];
                positions.push(pdata[0] * sizeX, pdata[1] * sizeY, pdata[2] * sizeZ);
                const vCoord = (pdata[1] * sizeY - minY) / (maxY - minY);
                uvs.push((pdata[0] * sizeX - minX) / (maxX - minX), CompatibilityOptions.UseOpenGLOrientationForUV ? 1 - vCoord : vCoord);
            }
            for (let v = 0; v < verts.length - 2; v++) {
                indices.push(index, index + v + 2, index + v + 1);
            }
            index += verts.length;
        }
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs);
        const vertexData = new VertexData();
        vertexData.positions = positions;
        vertexData.indices = indices;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        return vertexData;
    }
    /**
     * Creates the Mesh for a Goldberg Polyhedron which is made from 12 pentagonal and the rest hexagonal faces
     * @see https://en.wikipedia.org/wiki/Goldberg_polyhedron
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra/goldberg_poly
     * @param name defines the name of the mesh
     * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
     * @param scene defines the hosting scene
     * @returns Goldberg mesh
     */
    function CreateGoldberg(name, options, scene = null) {
        const size = options.size;
        const sizeX = options.sizeX || size || 1;
        const sizeY = options.sizeY || size || 1;
        const sizeZ = options.sizeZ || size || 1;
        let m = options.m || 1;
        if (m !== Math.floor(m)) {
            Logger.Warn("m not an integer only floor(m) used");
        }
        let n = options.n || 0;
        if (n !== Math.floor(n)) {
            Logger.Warn("n not an integer only floor(n) used");
        }
        if (n > m) {
            const temp = n;
            n = m;
            m = temp;
            Logger.Warn("n > m therefore m and n swapped");
        }
        const primTri = new _PrimaryIsoTriangle();
        primTri.build(m, n);
        const geodesicData = GeodesicData.BuildGeodesicData(primTri);
        const goldbergData = geodesicData.toGoldbergPolyhedronData();
        const goldberg = new GoldbergMesh(name, scene);
        options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        goldberg._originalBuilderSideOrientation = options.sideOrientation;
        const vertexData = CreateGoldbergVertexData(options, goldbergData);
        vertexData.applyToMesh(goldberg, options.updatable);
        goldberg.goldbergData.nbSharedFaces = geodesicData.sharedNodes;
        goldberg.goldbergData.nbUnsharedFaces = geodesicData.poleNodes;
        goldberg.goldbergData.adjacentFaces = geodesicData.adjacentFaces;
        goldberg.goldbergData.nbFaces = goldberg.goldbergData.nbSharedFaces + goldberg.goldbergData.nbUnsharedFaces;
        goldberg.goldbergData.nbFacesAtPole = (goldberg.goldbergData.nbUnsharedFaces - 12) / 12;
        for (let f = 0; f < geodesicData.vertex.length; f++) {
            goldberg.goldbergData.faceCenters.push(Vector3.FromArray(geodesicData.vertex[f]));
            goldberg.goldbergData.faceCenters[f].x *= sizeX;
            goldberg.goldbergData.faceCenters[f].y *= sizeY;
            goldberg.goldbergData.faceCenters[f].z *= sizeZ;
            goldberg.goldbergData.faceColors.push(new Color4(1, 1, 1, 1));
        }
        for (let f = 0; f < goldbergData.face.length; f++) {
            const verts = goldbergData.face[f];
            const a = Vector3.FromArray(goldbergData.vertex[verts[0]]);
            const b = Vector3.FromArray(goldbergData.vertex[verts[2]]);
            const c = Vector3.FromArray(goldbergData.vertex[verts[1]]);
            const ba = b.subtract(a);
            const ca = c.subtract(a);
            const norm = Vector3.Cross(ca, ba).normalize();
            const z = Vector3.Cross(ca, norm).normalize();
            goldberg.goldbergData.faceXaxis.push(ca.normalize());
            goldberg.goldbergData.faceYaxis.push(norm);
            goldberg.goldbergData.faceZaxis.push(z);
        }
        return goldberg;
    }

    // Shape functions
    class ShapePath {
        /** Create the ShapePath used to support glyphs */
        constructor(resolution) {
            this._paths = [];
            this._tempPaths = [];
            this._holes = [];
            this._resolution = resolution;
        }
        /** Move the virtual cursor to a coordinate */
        moveTo(x, y) {
            this._currentPath = new Path2(x, y);
            this._tempPaths.push(this._currentPath);
        }
        /** Draw a line from the virtual cursor to a given coordinate */
        lineTo(x, y) {
            this._currentPath.addLineTo(x, y);
        }
        /** Create a quadratic curve from the virtual cursor to a given coordinate */
        quadraticCurveTo(cpx, cpy, x, y) {
            this._currentPath.addQuadraticCurveTo(cpx, cpy, x, y, this._resolution);
        }
        /** Create a bezier curve from the virtual cursor to a given coordinate */
        bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y) {
            this._currentPath.addBezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y, this._resolution);
        }
        /** Extract holes based on CW / CCW */
        extractHoles() {
            for (const path of this._tempPaths) {
                if (path.area() > 0) {
                    this._holes.push(path);
                }
                else {
                    this._paths.push(path);
                }
            }
            if (!this._paths.length && this._holes.length) {
                const temp = this._holes;
                this._holes = this._paths;
                this._paths = temp;
            }
            this._tempPaths.length = 0;
        }
        /** Gets the list of paths */
        get paths() {
            return this._paths;
        }
        /** Gets the list of holes */
        get holes() {
            return this._holes;
        }
    }
    // Utility functions
    function CreateShapePath(char, scale, offsetX, offsetY, resolution, fontData) {
        const glyph = fontData.glyphs[char] || fontData.glyphs["?"];
        if (!glyph) {
            // return if there is no glyph data
            return null;
        }
        const shapePath = new ShapePath(resolution);
        if (glyph.o) {
            const outline = glyph.o.split(" ");
            for (let i = 0, l = outline.length; i < l;) {
                const action = outline[i++];
                switch (action) {
                    case "m": {
                        // moveTo
                        const x = parseInt(outline[i++]) * scale + offsetX;
                        const y = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.moveTo(x, y);
                        break;
                    }
                    case "l": {
                        // lineTo
                        const x = parseInt(outline[i++]) * scale + offsetX;
                        const y = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.lineTo(x, y);
                        break;
                    }
                    case "q": {
                        // quadraticCurveTo
                        const cpx = parseInt(outline[i++]) * scale + offsetX;
                        const cpy = parseInt(outline[i++]) * scale + offsetY;
                        const cpx1 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy1 = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                        break;
                    }
                    case "b": {
                        // bezierCurveTo
                        const cpx = parseInt(outline[i++]) * scale + offsetX;
                        const cpy = parseInt(outline[i++]) * scale + offsetY;
                        const cpx1 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy1 = parseInt(outline[i++]) * scale + offsetY;
                        const cpx2 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy2 = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                        break;
                    }
                }
            }
        }
        // Extract holes (based on clockwise data)
        shapePath.extractHoles();
        return { offsetX: glyph.ha * scale, shapePath: shapePath };
    }
    /**
     * Creates shape paths from a text and font
     * @param text the text
     * @param size size of the font
     * @param resolution resolution of the font
     * @param fontData defines the font data (can be generated with http://gero3.github.io/facetype.js/)
     * @returns array of ShapePath objects
     */
    function CreateTextShapePaths(text, size, resolution, fontData) {
        const chars = Array.from(text);
        const scale = size / fontData.resolution;
        const line_height = (fontData.boundingBox.yMax - fontData.boundingBox.yMin + fontData.underlineThickness) * scale;
        const shapePaths = [];
        let offsetX = 0, offsetY = 0;
        for (let i = 0; i < chars.length; i++) {
            const char = chars[i];
            if (char === "\n") {
                offsetX = 0;
                offsetY -= line_height;
            }
            else {
                const ret = CreateShapePath(char, scale, offsetX, offsetY, resolution, fontData);
                if (ret) {
                    offsetX += ret.offsetX;
                    shapePaths.push(ret.shapePath);
                }
            }
        }
        return shapePaths;
    }
    /**
     * Create a text mesh
     * @param name defines the name of the mesh
     * @param text defines the text to use to build the mesh
     * @param fontData defines the font data (can be generated with http://gero3.github.io/facetype.js/)
     * @param options defines options used to create the mesh
     * @param scene defines the hosting scene
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns a new Mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/text
     */
    function CreateText(name, text, fontData, options = {
        size: 50,
        resolution: 8,
        depth: 1.0,
    }, scene = null, earcutInjection = earcut) {
        // First we need to generate the paths
        const shapePaths = CreateTextShapePaths(text, options.size || 50, options.resolution || 8, fontData);
        // And extrude them
        const meshes = [];
        for (const shapePath of shapePaths) {
            if (!shapePath.paths.length) {
                continue;
            }
            const holes = shapePath.holes.slice(); // Copy it as we will update the copy
            for (const path of shapePath.paths) {
                const holeVectors = [];
                const shapeVectors = [];
                const points = path.getPoints();
                for (const point of points) {
                    shapeVectors.push(new Vector3(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                }
                // Holes
                const localHolesCopy = holes.slice();
                for (const hole of localHolesCopy) {
                    const points = hole.getPoints();
                    let found = false;
                    for (const point of points) {
                        if (path.isPointInside(point)) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        continue;
                    }
                    const holePoints = [];
                    for (const point of points) {
                        holePoints.push(new Vector3(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                    }
                    holeVectors.push(holePoints);
                    // Remove the hole as it was already used
                    holes.splice(holes.indexOf(hole), 1);
                }
                // There is at least a hole but it was unaffected
                if (!holeVectors.length && holes.length) {
                    for (const hole of holes) {
                        const points = hole.getPoints();
                        const holePoints = [];
                        for (const point of points) {
                            holePoints.push(new Vector3(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                        }
                        holeVectors.push(holePoints);
                    }
                }
                // Extrusion!
                const mesh = ExtrudePolygon(name, {
                    shape: shapeVectors,
                    holes: holeVectors.length ? holeVectors : undefined,
                    depth: options.depth || 1.0,
                    sideOrientation: Mesh._GetDefaultSideOrientation(options.sideOrientation || Mesh.DOUBLESIDE),
                }, scene, earcutInjection);
                meshes.push(mesh);
            }
        }
        // Then we can merge everyone into one single mesh
        const newMesh = Mesh.MergeMeshes(meshes, true, true);
        if (newMesh) {
            // Move pivot to center
            const bbox = newMesh === null || newMesh === void 0 ? void 0 : newMesh.getBoundingInfo();
            newMesh.position.x = -(bbox === null || bbox === void 0 ? void 0 : bbox.boundingBox.extendSizeWorld._x);
            newMesh.position.y = -(bbox === null || bbox === void 0 ? void 0 : bbox.boundingBox.extendSizeWorld._y);
            newMesh.position.z = -(bbox === null || bbox === void 0 ? void 0 : bbox.boundingBox.extendSizeWorld._z);
            newMesh.name = name;
            newMesh.rotation.x = -Math.PI / 2;
            newMesh.bakeCurrentTransformIntoVertices();
        }
        return newMesh;
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    /**
     * Class containing static functions to help procedurally build meshes
     */
    const MeshBuilder = {
        CreateBox,
        CreateTiledBox,
        CreateSphere,
        CreateDisc,
        CreateIcoSphere,
        CreateRibbon,
        CreateCylinder,
        CreateTorus,
        CreateTorusKnot,
        CreateLineSystem,
        CreateLines,
        CreateDashedLines,
        ExtrudeShape,
        ExtrudeShapeCustom,
        CreateLathe,
        CreateTiledPlane,
        CreatePlane,
        CreateGround,
        CreateTiledGround,
        CreateGroundFromHeightMap,
        CreatePolygon,
        ExtrudePolygon,
        CreateTube,
        CreatePolyhedron,
        CreateGeodesic,
        CreateGoldberg,
        CreateDecal,
        CreateCapsule,
        CreateText,
    };

    class GuiHelper {
        constructor(scene, highlighter) {
            this.scene = scene;
            this.highlighter = highlighter;
            this.textLabelMap = new Map();
            this.gridSettings = {};
            const cameraPosition = new Vector3();
            scene.registerBeforeRender(() => {
                if (scene.activeCamera && this.textLabelMap.size > 0) {
                    this.textLabelMap.forEach(mesh => {
                        const camera = scene.activeCamera;
                        cameraPosition.copyFrom(getCameraPositionWithOffset(camera));
                        mesh.lookAt(cameraPosition);
                        if (camera.mode !== Camera.ORTHOGRAPHIC_CAMERA) {
                            const size = cameraPosition.subtractInPlace(mesh.position).length() * 0.05;
                            mesh.scaling = mesh.scaling.copyFromFloats(size, size, size);
                        }
                    });
                }
            });
        }
        enableGrid(sceneNode, skipOrigin = false) {
            if (this.gridSettings.gridMesh) {
                return;
            }
            const bgColor = sceneNode === null || sceneNode === void 0 ? void 0 : sceneNode.backgroundColor;
            let bgColor3;
            if (!bgColor) {
                bgColor3 = new Color3(this.scene.clearColor.r, this.scene.clearColor.g, this.scene.clearColor.b);
            }
            else {
                bgColor3 = bgColor.a === 0 ? Color3.Black() : new Color3(bgColor.r, bgColor.g, bgColor.b);
            }
            const gridStepSize = sceneNode.gridStepSize || 1;
            const gridSize = sceneNode.gridSize || 10;
            const gridNormal = sceneNode.gridNormal;
            const gridMajorInterval = sceneNode.gridMajorInterval || 0;
            const strongLineColor = Color4.FromColor3(bgColor3.toLuminance() > 0.5 ? Color3.Black() : Color3.White());
            const lightLineColor = strongLineColor.scale(0.4).add(Color4.FromColor3(bgColor3.scale(0.6)));
            const points = this.calculateGridPoints(gridStepSize, gridSize, gridNormal);
            const pointColors = [];
            const linesPerSide = points.length / 2;
            for (let s = 0; s < 2; s++) {
                for (let i = 0; i < linesPerSide; i++) {
                    if (gridMajorInterval === 0) {
                        pointColors.push([lightLineColor, lightLineColor]);
                    }
                    else if (Math.ceil(i / 2) % gridMajorInterval === 0) {
                        pointColors.push([strongLineColor, strongLineColor]);
                    }
                    else {
                        pointColors.push([lightLineColor, lightLineColor]);
                    }
                }
            }
            if (skipOrigin) {
                points.splice(linesPerSide, 1);
                points.splice(0, 1);
                pointColors.splice(linesPerSide, 1);
                pointColors.splice(0, 1);
            }
            const gridMesh = MeshBuilder.CreateLineSystem('grid', {
                lines: points,
                colors: pointColors,
                updatable: false,
            }, this.scene);
            // gridMesh.color = lineColor.scale(0.4).add(bgColor3.scale(0.6));
            gridMesh.isPickable = false;
            this.gridSettings.gridMesh = gridMesh;
        }
        disableGrid() {
            if (this.gridSettings.gridMesh) {
                this.gridSettings.gridMesh.dispose();
                delete this.gridSettings.gridMesh;
            }
        }
        enableGridAxes(sceneNode) {
            if (this.gridSettings.gridAxesMesh) {
                return;
            }
            // const bgColor = sceneNode.backgroundColor;
            // let bgColor3: Color3;
            // if (!bgColor) {
            //     bgColor3 = new Color3(this.scene.clearColor.r, this.scene.clearColor.g, this.scene.clearColor.b);
            // } else {
            //     bgColor3 = bgColor.a === 0 ? Color3.Black() : new Color3(bgColor.r, bgColor.g, bgColor.b);
            // }
            // const lineColor = bgColor3.toLuminance() > 0.5 ? Color3.Black() : Color3.White();
            const gridStepSize = sceneNode.gridStepSize || 1;
            const gridSize = (sceneNode.gridSize || 10) * gridStepSize;
            const colors = [
                Color4.FromColor3(Color3.Red()),
                Color4.FromColor3(Color3.Green()),
                Color4.FromColor3(Color3.Blue()),
            ];
            const pointsAxes = [
                [new Vector3(-gridSize, 0, 0), new Vector3(gridSize, 0, 0)],
                [new Vector3(0, -gridSize, 0), new Vector3(0, gridSize, 0)],
                [new Vector3(0, 0, -gridSize), new Vector3(0, 0, gridSize)],
            ];
            const pointColors = [
                [colors[0], colors[0]],
                [colors[1], colors[1]],
                [colors[2], colors[2]],
            ];
            const gridMeshAxes = MeshBuilder.CreateLineSystem('gridAxes', {
                lines: pointsAxes,
                updatable: false,
                colors: pointColors,
            }, this.scene);
            gridMeshAxes.isPickable = false;
            this.gridSettings.gridAxesMesh = gridMeshAxes;
            this.createTextLabels([
                { text: 'x', position: new exports.KbVector(gridSize, 0.5, 0), color: colors[0] },
                { text: 'y', position: new exports.KbVector(0.5, gridSize, 0), color: colors[1] },
                { text: 'z', position: new exports.KbVector(0, 0.5, gridSize), color: colors[2] },
            ]);
        }
        disableGridAxes() {
            if (this.gridSettings.gridAxesMesh) {
                this.gridSettings.gridAxesMesh.dispose();
                delete this.gridSettings.gridAxesMesh;
            }
        }
        createTextLabels(items, style = {}) {
            if (!style.font) {
                style.font = 'bold 32px sans-serif';
            }
            items.forEach(label => {
                const font = label.style && label.style.font ? label.style.font : style.font;
                if (!label.id) {
                    label.id = label.text;
                }
                if (this.textLabelMap.has(label.id)) {
                    const labelMesh = this.textLabelMap.get(label.id);
                    labelMesh.position = label.position.toVec3();
                }
                else {
                    // Set height for plane
                    const fontSize = parseInt(font.replace(/\D+(\d+)px.*/, '$1')) || 32;
                    const planeHeight = fontSize / 32;
                    const textureHeight = 2 * fontSize;
                    const ratio = planeHeight / textureHeight;
                    // Use a temporay canvas to calculate the length of the text
                    const temp = document.createElement('canvas');
                    temp.width = 64;
                    temp.height = 64;
                    const tmpctx = temp.getContext('2d');
                    if (tmpctx) {
                        tmpctx.font = font;
                        const textureWidth = tmpctx.measureText(label.text).width + 8;
                        temp.width = 0;
                        temp.height = 0;
                        // Create dynamic texture and write the text
                        const dynamicId = `axisLabel${label.id}`;
                        const planeWidth = textureWidth * ratio;
                        const dynamicTexture = new DynamicTexture(dynamicId + '-labelTexture', { width: textureWidth, height: textureHeight }, this.scene, false);
                        const mat = new StandardMaterial(dynamicId + '-labelMaterial', this.scene);
                        mat.emissiveTexture = dynamicTexture;
                        mat.diffuseTexture = dynamicTexture;
                        mat.sideOrientation = Mesh.BACKSIDE;
                        dynamicTexture.hasAlpha = true;
                        dynamicTexture.drawText(label.text, null, null, font, label.color.toHexString(), 'rgba(0,0,0,0)', true);
                        // Create plane and set dynamic texture as material
                        const plane = MeshBuilder.CreatePlane(dynamicId, { width: planeWidth, height: planeHeight }, this.scene);
                        plane.material = mat;
                        plane.position = label.position.toVec3();
                        plane.isPickable = false;
                        this.textLabelMap.set(label.id, plane);
                    }
                }
            });
        }
        calculateGridPoints(stepSize, gridCount, normal, gridFullSize) {
            const points = [];
            const wV1 = new Vector3(), wV2 = new Vector3(), vStep = new Vector3();
            if (gridFullSize === undefined) {
                gridFullSize = gridCount;
            }
            let uVec;
            let vVec;
            switch (normal) {
                case exports.eAxis.x:
                    uVec = new Vector3(0, stepSize, 0);
                    vVec = new Vector3(0, 0, stepSize);
                    break;
                case exports.eAxis.y:
                    uVec = new Vector3(stepSize, 0, 0);
                    vVec = new Vector3(0, 0, stepSize);
                    break;
                case exports.eAxis.z:
                    uVec = new Vector3(stepSize, 0, 0);
                    vVec = new Vector3(0, stepSize, 0);
                    break;
            }
            wV1.setAll(0).addInPlace(vVec).scaleInPlace(-1).scaleInPlace(gridFullSize);
            wV2.setAll(0).scaleInPlace(-1).addInPlace(vVec).scaleInPlace(gridFullSize);
            for (let i = 0; i < gridCount * 2 + 1; i++) {
                const d = (2 * (i % 2) - 1) * Math.ceil(i / 2);
                vStep.copyFrom(uVec).scaleInPlace(d);
                points.push([wV1.add(vStep), wV2.add(vStep)]);
            }
            wV1.setAll(0).addInPlace(uVec).scaleInPlace(-1).scaleInPlace(gridFullSize);
            wV2.setAll(0).scaleInPlace(-1).addInPlace(uVec).scaleInPlace(gridFullSize);
            for (let i = 0; i < gridCount * 2 + 1; i++) {
                const d = (2 * (i % 2) - 1) * Math.ceil(i / 2);
                vStep.copyFrom(vVec).scaleInPlace(d);
                points.push([wV1.add(vStep), wV2.add(vStep)]);
            }
            return points;
        }
    }

    /*
     * Polyfill for createImageBitmap
     * https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/createImageBitmap
     *
     * Supports CanvasImageSource (img, video, canvas) sources, Blobs, and ImageData.
     *
     * From:
     * - https://dev.to/nektro/createimagebitmap-polyfill-for-safari-and-edge-228
     * - https://gist.github.com/MonsieurV/fb640c29084c171b4444184858a91bc7
     * Updated by:
     * - Yoan Tournade <yoan@ytotech.com>
     * - diachedelic, https://gist.github.com/diachedelic
     * - Paul Ellis, https://pseudosavant.com
     */
    (function createImageBitmapIIFE(global) {
        function isCanvasImageSource(el) {
            const validElements = ['img', 'video', 'canvas'];
            return el && el.tagName && validElements.includes(el.tagName.toLowerCase());
        }
        function idealSize(currentValue, newValue, numerator, denominator) {
            if (typeof newValue === 'number')
                return newValue;
            if (typeof numerator !== 'number' || typeof denominator !== 'number')
                return currentValue;
            return (numerator / denominator) * currentValue;
        }
        if (!('createImageBitmap' in global)) {
            global.createImageBitmap = async function polyfillCreateImageBitmap(data, opts) {
                return new Promise((resolve, reject) => {
                    opts = opts || {};
                    let dataURL;
                    const canvas = document.createElement('canvas');
                    try {
                        const ctx = canvas.getContext('2d');
                        if (data instanceof Blob) {
                            dataURL = URL.createObjectURL(data);
                        }
                        else if (isCanvasImageSource(data)) {
                            const width = data.naturalWidth || data.videoWidth || data.clientWidth || data.width;
                            const height = data.naturalHeight || data.videoHeight || data.clientHeight || data.height;
                            canvas.width = idealSize(width, opts.resizeWidth, opts.resizeHeight, height);
                            canvas.height = idealSize(height, opts.resizeHeight, opts.resizeWidth, width);
                            ctx.drawImage(data, 0, 0, canvas.width, canvas.height);
                            dataURL = canvas.toDataURL();
                        }
                        else if (data instanceof ImageData) {
                            canvas.width = idealSize(data.width, opts.resizeWidth, opts.resizeHeight, data.height);
                            canvas.height = idealSize(data.height, opts.resizeHeight, opts.resizeWidth, data.width);
                            ctx.putImageData(data, 0, 0);
                            dataURL = canvas.toDataURL();
                        }
                        else {
                            reject('createImageBitmap does not handle the provided image source type');
                        }
                        const img = new Image();
                        img.onerror = reject;
                        img.onload = () => resolve(img);
                        img.src = dataURL;
                    }
                    finally {
                        // avoid memory leaks on iOS Safari, see https://stackoverflow.com/a/52586606
                        canvas.width = 0;
                        canvas.height = 0;
                    }
                });
            };
        }
    })(window);

    /**
     * Generic utilities for the babylon scene
     */
    /** returns the x,y pixel position of the node on the canvas */
    function nodeToScreen(bNode, camera) {
        camera = getCamera(camera);
        const nodeWorldPos = bNode.getAbsolutePosition(); // Vector3.TransformCoordinates(bNode.position, bNode.getWorldMatrix());
        return toScreen(nodeWorldPos, camera);
    }
    /** converts screen units */
    function toPixels(viewportUnits, camera) {
        camera = getCamera(camera);
        const canvasRect = camera.getEngine().getRenderingCanvasClientRect();
        return {
            x: viewportUnits.x * canvasRect.width,
            y: viewportUnits.y * canvasRect.height,
        };
    }
    /** returns the screen position as normalized device units a ratio from 0 to 1 */
    function toNDC(worldPos, camera) {
        camera = getCamera(camera);
        const pos = Vector3.Project(worldPos, Matrix.IdentityReadOnly, camera.getTransformationMatrix(), camera.viewport);
        return {
            x: pos.x,
            y: pos.y,
        };
    }
    function toScreen(worldPos, camera) {
        camera = getCamera(camera);
        const scene = camera.getScene();
        const engine = scene.getEngine();
        const pos = Vector3.Project(worldPos, Matrix.IdentityReadOnly, scene.getTransformMatrix(), camera.viewport.toGlobal(engine.getRenderWidth(), engine.getRenderHeight()));
        return {
            x: pos.x,
            y: pos.y,
        };
    }
    function getScreenBoundingBox(node, camera, includeDescendants = true) {
        camera = getCamera(camera);
        const bv = getHierarchyBoundingVectors(node, includeDescendants);
        return boundingVectorsToScreen(bv, camera);
    }
    // export function getBoundingVectors(bNode: AbstractMesh | TransformNode | undefined, scene: Scene, includeDescendants = true) {
    //     let bv: { min: Vector3, max: Vector3 } | undefined;
    //     if (!bNode) {
    //         bv = scene.getWorldExtends();
    //     } else {
    //         bv = bNode.getHierarchyBoundingVectors(true);
    //         if (bv.min.x == Number.MAX_VALUE && bv.min.y == Number.MAX_VALUE && bv.min.z == Number.MAX_VALUE && bv.max.x == -Number.MAX_VALUE && bv.max.y == -Number.MAX_VALUE && bv.max.z == -Number.MAX_VALUE) {
    //             bv = {
    //                 min: bNode.absolutePosition.clone(),
    //                 max: bNode.absolutePosition.clone()
    //             }
    //         }
    //     }
    //     return bv;
    // }
    /**
     * Babylon's getHierarchyBoundingVectors has a bug that surfaces when called on a transformNode that has no real meshes in it's child hierarchy.
     * Use this wrapper instead
     * @param bNode
     * @param includeDescendants
     */
    function getHierarchyBoundingVectors(bNode, includeDescendants = true) {
        let bv = bNode.getHierarchyBoundingVectors(includeDescendants);
        //to handle a babylon bug that returns maxvalues when the node is an empty transformnode
        if (bv.min.x == Number.MAX_VALUE &&
            bv.min.y == Number.MAX_VALUE &&
            bv.min.z == Number.MAX_VALUE &&
            bv.max.x == -Number.MAX_VALUE &&
            bv.max.y == -Number.MAX_VALUE &&
            bv.max.z == -Number.MAX_VALUE) {
            bv = {
                min: bNode.absolutePosition.clone(),
                max: bNode.absolutePosition.clone(),
            };
        }
        return bv;
    }
    function boundingVectorsToScreen(boundingVectors, camera) {
        camera = getCamera(camera);
        const bv = boundingVectors;
        const xs = new Array();
        const ys = new Array();
        for (let i = 0; i < 8; i++) {
            const x = bv[Math.floor(i / 4) ? 'max' : 'min'].x;
            const y = bv[Math.floor(i / 2) % 2 ? 'max' : 'min'].y;
            const z = bv[i % 2 ? 'max' : 'min'].z;
            const v = new Vector3(x, y, z);
            const sp = toNDC(v, camera);
            xs.push(sp.x);
            ys.push(sp.y);
        }
        const minx = Math.min(...xs);
        const maxx = Math.max(...xs);
        const miny = Math.min(...ys);
        const maxy = Math.max(...ys);
        const width = maxx - minx;
        const height = maxy - miny;
        const x = minx + width / 2;
        const y = miny + height / 2;
        const engine = camera.getEngine();
        const canvas = engine.getRenderingCanvas();
        const canvasWidth = canvas.width * engine.getHardwareScalingLevel();
        const canvasHeight = canvas.height * engine.getHardwareScalingLevel();
        return {
            x: x * canvasWidth,
            y: y * canvasHeight,
            top: miny * canvasHeight,
            left: minx * canvasWidth,
            width: width * canvasWidth,
            height: height * canvasHeight,
        };
    }
    function updateMatrixOfAncestorChain(ancestor, child) {
        while (child != ancestor && child instanceof TransformNode) {
            child.computeWorldMatrix(true);
            child = child.parent;
        }
        if (child) {
            child.computeWorldMatrix(true);
        }
    }
    function getCamera(camera) {
        if (camera instanceof WebXRCamera) {
            return camera.rigCameras[0];
        }
        return camera;
    }

    (function (eWorkerTasks) {
        eWorkerTasks["usdConvertGeometry"] = "usdConvertGeometry";
        eWorkerTasks["usdPackage"] = "usdPackageStart";
    })(exports.eWorkerTasks || (exports.eWorkerTasks = {}));
    (function (eKB3DMessageType) {
        eKB3DMessageType["taskStart"] = "taskStart";
        eKB3DMessageType["taskError"] = "taskError";
        eKB3DMessageType["taskProgress"] = "taskProgress";
        eKB3DMessageType["taskComplete"] = "taskComplete";
    })(exports.eKB3DMessageType || (exports.eKB3DMessageType = {}));
    const THREAD_COUNT = 2;
    class Kb3dWorker {
        constructor() {
            this.workerPool = [];
            this.toggle = 0;
            this.requestsInFlight = new Map();
            if (!Kb3dWorker.workerPath) {
                throw Error('Worker Script path not set');
            }
            const workerPath = Kb3dWorker.workerPath;
            const content = `importScripts( "${workerPath}" );`;
            const workerBlobUrl = URL.createObjectURL(new Blob([content], { type: 'text/javascript' }));
            const workerReturnMessage = (event) => {
                if ('task' in event.data) {
                    const data = event.data;
                    const sub = this.requestsInFlight.get(data.taskId);
                    if (sub) {
                        // We have to remove the request from the inflight map first because the sub.next can trigger the dispose
                        // But the sub.complete has to be after the sub.next
                        if (data.type === exports.eKB3DMessageType.taskComplete) {
                            this.requestsInFlight.delete(data.taskId);
                        }
                        if (data.type === exports.eKB3DMessageType.taskError) {
                            sub.error(data.payload);
                        }
                        else {
                            sub.next(data);
                        }
                        if (data.type === exports.eKB3DMessageType.taskComplete) {
                            sub.complete();
                        }
                    }
                }
            };
            for (let i = 0; i < THREAD_COUNT; i++) {
                const newWorker = new Worker(workerBlobUrl);
                newWorker.onmessage = workerReturnMessage;
                this.workerPool.push(newWorker);
            }
            URL.revokeObjectURL(workerBlobUrl);
        }
        startTask(task, taskPayload, transfer) {
            const messagePayload = {
                type: exports.eKB3DMessageType.taskStart,
                task,
                taskId: UUID.generate(),
                payload: taskPayload,
            };
            this.workerPool[this.toggle].postMessage(messagePayload, transfer ? { transfer } : undefined);
            const sub = new Subject();
            this.requestsInFlight.set(messagePayload.taskId, sub);
            this.toggle = (this.toggle + 1) % THREAD_COUNT;
            return sub;
        }
        dispose() {
            this.workerPool.forEach(worker => {
                worker.terminate();
            });
            this.requestsInFlight.forEach(sub => {
                sub.error('Worker Terminated');
                sub.complete();
            });
            this.requestsInFlight.clear();
        }
    }
    Kb3dWorker.workerPath = '';

    var version = '18.5.0';

    /**
     * Tween.js - Licensed under the MIT license
     * https://github.com/tweenjs/tween.js
     * ----------------------------------------------
     *
     * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
     * Thank you all, you're awesome!
     */


    var _Group = function () {
    	this._tweens = {};
    	this._tweensAddedDuringUpdate = {};
    };

    _Group.prototype = {
    	getAll: function () {

    		return Object.keys(this._tweens).map(function (tweenId) {
    			return this._tweens[tweenId];
    		}.bind(this));

    	},

    	removeAll: function () {

    		this._tweens = {};

    	},

    	add: function (tween) {

    		this._tweens[tween.getId()] = tween;
    		this._tweensAddedDuringUpdate[tween.getId()] = tween;

    	},

    	remove: function (tween) {

    		delete this._tweens[tween.getId()];
    		delete this._tweensAddedDuringUpdate[tween.getId()];

    	},

    	update: function (time, preserve) {

    		var tweenIds = Object.keys(this._tweens);

    		if (tweenIds.length === 0) {
    			return false;
    		}

    		time = time !== undefined ? time : TWEEN.now();

    		// Tweens are updated in "batches". If you add a new tween during an
    		// update, then the new tween will be updated in the next batch.
    		// If you remove a tween during an update, it may or may not be updated.
    		// However, if the removed tween was added during the current batch,
    		// then it will not be updated.
    		while (tweenIds.length > 0) {
    			this._tweensAddedDuringUpdate = {};

    			for (var i = 0; i < tweenIds.length; i++) {

    				var tween = this._tweens[tweenIds[i]];

    				if (tween && tween.update(time) === false) {
    					tween._isPlaying = false;

    					if (!preserve) {
    						delete this._tweens[tweenIds[i]];
    					}
    				}
    			}

    			tweenIds = Object.keys(this._tweensAddedDuringUpdate);
    		}

    		return true;

    	}
    };

    var TWEEN = new _Group();

    TWEEN.Group = _Group;
    TWEEN._nextId = 0;
    TWEEN.nextId = function () {
    	return TWEEN._nextId++;
    };


    // Include a performance.now polyfill.
    // In node.js, use process.hrtime.
    if (typeof (self) === 'undefined' && typeof (process) !== 'undefined' && process.hrtime) {
    	TWEEN.now = function () {
    		var time = process.hrtime();

    		// Convert [seconds, nanoseconds] to milliseconds.
    		return time[0] * 1000 + time[1] / 1000000;
    	};
    }
    // In a browser, use self.performance.now if it is available.
    else if (typeof (self) !== 'undefined' &&
             self.performance !== undefined &&
    		 self.performance.now !== undefined) {
    	// This must be bound, because directly assigning this function
    	// leads to an invocation exception in Chrome.
    	TWEEN.now = self.performance.now.bind(self.performance);
    }
    // Use Date.now if it is available.
    else if (Date.now !== undefined) {
    	TWEEN.now = Date.now;
    }
    // Otherwise, use 'new Date().getTime()'.
    else {
    	TWEEN.now = function () {
    		return new Date().getTime();
    	};
    }


    TWEEN.Tween = function (object, group) {
    	this._isPaused = false;
    	this._pauseStart = null;
    	this._object = object;
    	this._valuesStart = {};
    	this._valuesEnd = {};
    	this._valuesStartRepeat = {};
    	this._duration = 1000;
    	this._repeat = 0;
    	this._repeatDelayTime = undefined;
    	this._yoyo = false;
    	this._isPlaying = false;
    	this._reversed = false;
    	this._delayTime = 0;
    	this._startTime = null;
    	this._easingFunction = TWEEN.Easing.Linear.None;
    	this._interpolationFunction = TWEEN.Interpolation.Linear;
    	this._chainedTweens = [];
    	this._onStartCallback = null;
    	this._onStartCallbackFired = false;
    	this._onUpdateCallback = null;
    	this._onRepeatCallback = null;
    	this._onCompleteCallback = null;
    	this._onStopCallback = null;
    	this._group = group || TWEEN;
    	this._id = TWEEN.nextId();

    };

    TWEEN.Tween.prototype = {
    	getId: function () {
    		return this._id;
    	},

    	isPlaying: function () {
    		return this._isPlaying;
    	},

    	isPaused: function () {
    		return this._isPaused;
    	},

    	to: function (properties, duration) {

    		this._valuesEnd = Object.create(properties);

    		if (duration !== undefined) {
    			this._duration = duration;
    		}

    		return this;

    	},

    	duration: function duration(d) {
    		this._duration = d;
    		return this;
    	},

    	start: function (time) {

    		this._group.add(this);

    		this._isPlaying = true;

    		this._isPaused = false;

    		this._onStartCallbackFired = false;

    		this._startTime = time !== undefined ? typeof time === 'string' ? TWEEN.now() + parseFloat(time) : time : TWEEN.now();
    		this._startTime += this._delayTime;

    		for (var property in this._valuesEnd) {

    			// Check if an Array was provided as property value
    			if (this._valuesEnd[property] instanceof Array) {

    				if (this._valuesEnd[property].length === 0) {
    					continue;
    				}

    				// Create a local copy of the Array with the start value at the front
    				this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);

    			}

    			// If `to()` specifies a property that doesn't exist in the source object,
    			// we should not set that property in the object
    			if (this._object[property] === undefined) {
    				continue;
    			}

    			// Save the starting value, but only once.
    			if (typeof(this._valuesStart[property]) === 'undefined') {
    				this._valuesStart[property] = this._object[property];
    			}

    			if ((this._valuesStart[property] instanceof Array) === false) {
    				this._valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
    			}

    			this._valuesStartRepeat[property] = this._valuesStart[property] || 0;

    		}

    		return this;

    	},

    	stop: function () {

    		if (!this._isPlaying) {
    			return this;
    		}

    		this._group.remove(this);

    		this._isPlaying = false;

    		this._isPaused = false;

    		if (this._onStopCallback !== null) {
    			this._onStopCallback(this._object);
    		}

    		this.stopChainedTweens();
    		return this;

    	},

    	end: function () {

    		this.update(Infinity);
    		return this;

    	},

    	pause: function(time) {

    		if (this._isPaused || !this._isPlaying) {
    			return this;
    		}

    		this._isPaused = true;

    		this._pauseStart = time === undefined ? TWEEN.now() : time;

    		this._group.remove(this);

    		return this;

    	},

    	resume: function(time) {

    		if (!this._isPaused || !this._isPlaying) {
    			return this;
    		}

    		this._isPaused = false;

    		this._startTime += (time === undefined ? TWEEN.now() : time)
    			- this._pauseStart;

    		this._pauseStart = 0;

    		this._group.add(this);

    		return this;

    	},

    	stopChainedTweens: function () {

    		for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
    			this._chainedTweens[i].stop();
    		}

    	},

    	group: function (group) {
    		this._group = group;
    		return this;
    	},

    	delay: function (amount) {

    		this._delayTime = amount;
    		return this;

    	},

    	repeat: function (times) {

    		this._repeat = times;
    		return this;

    	},

    	repeatDelay: function (amount) {

    		this._repeatDelayTime = amount;
    		return this;

    	},

    	yoyo: function (yoyo) {

    		this._yoyo = yoyo;
    		return this;

    	},

    	easing: function (easingFunction) {

    		this._easingFunction = easingFunction;
    		return this;

    	},

    	interpolation: function (interpolationFunction) {

    		this._interpolationFunction = interpolationFunction;
    		return this;

    	},

    	chain: function () {

    		this._chainedTweens = arguments;
    		return this;

    	},

    	onStart: function (callback) {

    		this._onStartCallback = callback;
    		return this;

    	},

    	onUpdate: function (callback) {

    		this._onUpdateCallback = callback;
    		return this;

    	},

    	onRepeat: function onRepeat(callback) {

    		this._onRepeatCallback = callback;
    		return this;

    	},

    	onComplete: function (callback) {

    		this._onCompleteCallback = callback;
    		return this;

    	},

    	onStop: function (callback) {

    		this._onStopCallback = callback;
    		return this;

    	},

    	update: function (time) {

    		var property;
    		var elapsed;
    		var value;

    		if (time < this._startTime) {
    			return true;
    		}

    		if (this._onStartCallbackFired === false) {

    			if (this._onStartCallback !== null) {
    				this._onStartCallback(this._object);
    			}

    			this._onStartCallbackFired = true;
    		}

    		elapsed = (time - this._startTime) / this._duration;
    		elapsed = (this._duration === 0 || elapsed > 1) ? 1 : elapsed;

    		value = this._easingFunction(elapsed);

    		for (property in this._valuesEnd) {

    			// Don't update properties that do not exist in the source object
    			if (this._valuesStart[property] === undefined) {
    				continue;
    			}

    			var start = this._valuesStart[property] || 0;
    			var end = this._valuesEnd[property];

    			if (end instanceof Array) {

    				this._object[property] = this._interpolationFunction(end, value);

    			} else {

    				// Parses relative end values with start as base (e.g.: +10, -3)
    				if (typeof (end) === 'string') {

    					if (end.charAt(0) === '+' || end.charAt(0) === '-') {
    						end = start + parseFloat(end);
    					} else {
    						end = parseFloat(end);
    					}
    				}

    				// Protect against non numeric properties.
    				if (typeof (end) === 'number') {
    					this._object[property] = start + (end - start) * value;
    				}

    			}

    		}

    		if (this._onUpdateCallback !== null) {
    			this._onUpdateCallback(this._object, elapsed);
    		}

    		if (elapsed === 1) {

    			if (this._repeat > 0) {

    				if (isFinite(this._repeat)) {
    					this._repeat--;
    				}

    				// Reassign starting values, restart by making startTime = now
    				for (property in this._valuesStartRepeat) {

    					if (typeof (this._valuesEnd[property]) === 'string') {
    						this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
    					}

    					if (this._yoyo) {
    						var tmp = this._valuesStartRepeat[property];

    						this._valuesStartRepeat[property] = this._valuesEnd[property];
    						this._valuesEnd[property] = tmp;
    					}

    					this._valuesStart[property] = this._valuesStartRepeat[property];

    				}

    				if (this._yoyo) {
    					this._reversed = !this._reversed;
    				}

    				if (this._repeatDelayTime !== undefined) {
    					this._startTime = time + this._repeatDelayTime;
    				} else {
    					this._startTime = time + this._delayTime;
    				}

    				if (this._onRepeatCallback !== null) {
    					this._onRepeatCallback(this._object);
    				}

    				return true;

    			} else {

    				if (this._onCompleteCallback !== null) {

    					this._onCompleteCallback(this._object);
    				}

    				for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
    					// Make the chained tweens start exactly at the time they should,
    					// even if the `update()` method was called way past the duration of the tween
    					this._chainedTweens[i].start(this._startTime + this._duration);
    				}

    				return false;

    			}

    		}

    		return true;

    	}
    };


    TWEEN.Easing = {

    	Linear: {

    		None: function (k) {

    			return k;

    		}

    	},

    	Quadratic: {

    		In: function (k) {

    			return k * k;

    		},

    		Out: function (k) {

    			return k * (2 - k);

    		},

    		InOut: function (k) {

    			if ((k *= 2) < 1) {
    				return 0.5 * k * k;
    			}

    			return - 0.5 * (--k * (k - 2) - 1);

    		}

    	},

    	Cubic: {

    		In: function (k) {

    			return k * k * k;

    		},

    		Out: function (k) {

    			return --k * k * k + 1;

    		},

    		InOut: function (k) {

    			if ((k *= 2) < 1) {
    				return 0.5 * k * k * k;
    			}

    			return 0.5 * ((k -= 2) * k * k + 2);

    		}

    	},

    	Quartic: {

    		In: function (k) {

    			return k * k * k * k;

    		},

    		Out: function (k) {

    			return 1 - (--k * k * k * k);

    		},

    		InOut: function (k) {

    			if ((k *= 2) < 1) {
    				return 0.5 * k * k * k * k;
    			}

    			return - 0.5 * ((k -= 2) * k * k * k - 2);

    		}

    	},

    	Quintic: {

    		In: function (k) {

    			return k * k * k * k * k;

    		},

    		Out: function (k) {

    			return --k * k * k * k * k + 1;

    		},

    		InOut: function (k) {

    			if ((k *= 2) < 1) {
    				return 0.5 * k * k * k * k * k;
    			}

    			return 0.5 * ((k -= 2) * k * k * k * k + 2);

    		}

    	},

    	Sinusoidal: {

    		In: function (k) {

    			return 1 - Math.cos(k * Math.PI / 2);

    		},

    		Out: function (k) {

    			return Math.sin(k * Math.PI / 2);

    		},

    		InOut: function (k) {

    			return 0.5 * (1 - Math.cos(Math.PI * k));

    		}

    	},

    	Exponential: {

    		In: function (k) {

    			return k === 0 ? 0 : Math.pow(1024, k - 1);

    		},

    		Out: function (k) {

    			return k === 1 ? 1 : 1 - Math.pow(2, - 10 * k);

    		},

    		InOut: function (k) {

    			if (k === 0) {
    				return 0;
    			}

    			if (k === 1) {
    				return 1;
    			}

    			if ((k *= 2) < 1) {
    				return 0.5 * Math.pow(1024, k - 1);
    			}

    			return 0.5 * (- Math.pow(2, - 10 * (k - 1)) + 2);

    		}

    	},

    	Circular: {

    		In: function (k) {

    			return 1 - Math.sqrt(1 - k * k);

    		},

    		Out: function (k) {

    			return Math.sqrt(1 - (--k * k));

    		},

    		InOut: function (k) {

    			if ((k *= 2) < 1) {
    				return - 0.5 * (Math.sqrt(1 - k * k) - 1);
    			}

    			return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);

    		}

    	},

    	Elastic: {

    		In: function (k) {

    			if (k === 0) {
    				return 0;
    			}

    			if (k === 1) {
    				return 1;
    			}

    			return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);

    		},

    		Out: function (k) {

    			if (k === 0) {
    				return 0;
    			}

    			if (k === 1) {
    				return 1;
    			}

    			return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;

    		},

    		InOut: function (k) {

    			if (k === 0) {
    				return 0;
    			}

    			if (k === 1) {
    				return 1;
    			}

    			k *= 2;

    			if (k < 1) {
    				return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
    			}

    			return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;

    		}

    	},

    	Back: {

    		In: function (k) {

    			var s = 1.70158;

    			return k * k * ((s + 1) * k - s);

    		},

    		Out: function (k) {

    			var s = 1.70158;

    			return --k * k * ((s + 1) * k + s) + 1;

    		},

    		InOut: function (k) {

    			var s = 1.70158 * 1.525;

    			if ((k *= 2) < 1) {
    				return 0.5 * (k * k * ((s + 1) * k - s));
    			}

    			return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);

    		}

    	},

    	Bounce: {

    		In: function (k) {

    			return 1 - TWEEN.Easing.Bounce.Out(1 - k);

    		},

    		Out: function (k) {

    			if (k < (1 / 2.75)) {
    				return 7.5625 * k * k;
    			} else if (k < (2 / 2.75)) {
    				return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
    			} else if (k < (2.5 / 2.75)) {
    				return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
    			} else {
    				return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
    			}

    		},

    		InOut: function (k) {

    			if (k < 0.5) {
    				return TWEEN.Easing.Bounce.In(k * 2) * 0.5;
    			}

    			return TWEEN.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;

    		}

    	}

    };

    TWEEN.Interpolation = {

    	Linear: function (v, k) {

    		var m = v.length - 1;
    		var f = m * k;
    		var i = Math.floor(f);
    		var fn = TWEEN.Interpolation.Utils.Linear;

    		if (k < 0) {
    			return fn(v[0], v[1], f);
    		}

    		if (k > 1) {
    			return fn(v[m], v[m - 1], m - f);
    		}

    		return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);

    	},

    	Bezier: function (v, k) {

    		var b = 0;
    		var n = v.length - 1;
    		var pw = Math.pow;
    		var bn = TWEEN.Interpolation.Utils.Bernstein;

    		for (var i = 0; i <= n; i++) {
    			b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
    		}

    		return b;

    	},

    	CatmullRom: function (v, k) {

    		var m = v.length - 1;
    		var f = m * k;
    		var i = Math.floor(f);
    		var fn = TWEEN.Interpolation.Utils.CatmullRom;

    		if (v[0] === v[m]) {

    			if (k < 0) {
    				i = Math.floor(f = m * (1 + k));
    			}

    			return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);

    		} else {

    			if (k < 0) {
    				return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
    			}

    			if (k > 1) {
    				return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
    			}

    			return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);

    		}

    	},

    	Utils: {

    		Linear: function (p0, p1, t) {

    			return (p1 - p0) * t + p0;

    		},

    		Bernstein: function (n, i) {

    			var fc = TWEEN.Interpolation.Utils.Factorial;

    			return fc(n) / fc(i) / fc(n - i);

    		},

    		Factorial: (function () {

    			var a = [1];

    			return function (n) {

    				var s = 1;

    				if (a[n]) {
    					return a[n];
    				}

    				for (var i = n; i > 1; i--) {
    					s *= i;
    				}

    				a[n] = s;
    				return s;

    			};

    		})(),

    		CatmullRom: function (p0, p1, p2, p3, t) {

    			var v0 = (p2 - p0) * 0.5;
    			var v1 = (p3 - p1) * 0.5;
    			var t2 = t * t;
    			var t3 = t * t2;

    			return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (- 3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;

    		}

    	}

    };
    TWEEN.version = version;

    class AnimationModule {
        constructor(kbViewer, scene) {
            this.kbViewer = kbViewer;
            this.scene = scene;
            this.activeAnimations = new Set();
        }
        get animationsAreRunning() {
            return this.activeAnimations.size > 0;
        }
        queue(a) {
            if (!a.node)
                throw 'node required';
            if (a.toValue == null)
                throw 'value required';
            a = this.applyDefaults(a);
            return new Promise(resolve => {
                const origValue = a.node[a.prop];
                const origValueType = origValue === null || origValue === void 0 ? void 0 : origValue.$type;
                const val = this.valueIn(origValue);
                const toVal = this.valueIn(a.toValue);
                const tween = new TWEEN.Tween(val)
                    .to(toVal, a.duration)
                    .delay(a.delay)
                    .repeat(a.iterations < 0 ? Infinity : a.iterations - 1)
                    .easing(this.getTweenEasingFn(a.easing))
                    .onUpdate(() => {
                    a.node[a.prop] = this.valueOut(val, origValueType);
                })
                    .onComplete(() => {
                    this.activeAnimations.delete(activeAnim);
                    resolve();
                })
                    .start();
                const activeAnim = { animation: a, tween };
                this.activeAnimations.add(activeAnim);
                this.kbViewer.animationWarningsNeedsUpdate.next(this.activeAnimations.size);
            });
        }
        stop(name) {
            if (name != null) {
                const anims = [...this.activeAnimations.values()];
                for (const t of anims.filter(a => name.isEqual(a.animation.name))) {
                    t.tween.stop();
                    this.activeAnimations.delete(t);
                }
            }
        }
        stopAll() {
            for (const a of this.activeAnimations) {
                a.tween.stop();
            }
            this.activeAnimations.clear();
        }
        /** should be called by the render loop */
        update() {
            TWEEN.update(); //update all animations
        }
        applyDefaults(a) {
            return {
                duration: 1000,
                easing: exports.eEasing.linear,
                iterations: 1,
                delay: 0,
                ...a,
            };
        }
        valueIn(val) {
            if (val instanceof exports.KbVector) {
                return val.toObject();
            }
            else if (val instanceof exports.KbColor) {
                return val.toObject();
            }
            else if (val instanceof exports.KbQuaternion) {
                return val.toObject();
            }
            else {
                return { value: val };
            }
        }
        valueOut(val, $type) {
            if (!$type) {
                return val.value;
            }
            else {
                if ($type == Token.KbVector.key) {
                    return exports.KbVector.From(val);
                }
                else if ($type == Token.KbColor.key) {
                    return exports.KbColor.From(val);
                }
                else if ($type == Token.KbQuaternion.key) {
                    return exports.KbQuaternion.From(val);
                }
                else {
                    throw 'unrecognized type';
                }
            }
        }
        getTweenEasingFn(e) {
            const split = e.splitWords().map(s => s.capitalize());
            const inOut = split.length == 3 ? split[1] + split[2] : split.length == 2 ? split[1] : 'None';
            return TWEEN.Easing[split[0]][inOut];
        }
    }

    let anchorIdProvider = 0;
    /**
     * An implementation of the anchor system for WebXR.
     * For further information see https://github.com/immersive-web/anchors/
     */
    class WebXRAnchorSystem extends WebXRAbstractFeature {
        /**
         * Set the reference space to use for anchor creation, when not using a hit test.
         * Will default to the session's reference space if not defined
         */
        set referenceSpaceForFrameAnchors(referenceSpace) {
            this._referenceSpaceForFrameAnchors = referenceSpace;
        }
        /**
         * constructs a new anchor system
         * @param _xrSessionManager an instance of WebXRSessionManager
         * @param _options configuration object for this feature
         */
        constructor(_xrSessionManager, _options = {}) {
            super(_xrSessionManager);
            this._options = _options;
            this._lastFrameDetected = new Set();
            this._trackedAnchors = [];
            this._futureAnchors = [];
            /**
             * Observers registered here will be executed when a new anchor was added to the session
             */
            this.onAnchorAddedObservable = new Observable$1();
            /**
             * Observers registered here will be executed when an anchor was removed from the session
             */
            this.onAnchorRemovedObservable = new Observable$1();
            /**
             * Observers registered here will be executed when an existing anchor updates
             * This can execute N times every frame
             */
            this.onAnchorUpdatedObservable = new Observable$1();
            this._tmpVector = new Vector3();
            this._tmpQuaternion = new Quaternion();
            this.xrNativeFeatureName = "anchors";
        }
        _populateTmpTransformation(position, rotationQuaternion) {
            this._tmpVector.copyFrom(position);
            this._tmpQuaternion.copyFrom(rotationQuaternion);
            if (!this._xrSessionManager.scene.useRightHandedSystem) {
                this._tmpVector.z *= -1;
                this._tmpQuaternion.z *= -1;
                this._tmpQuaternion.w *= -1;
            }
            return {
                position: this._tmpVector,
                rotationQuaternion: this._tmpQuaternion,
            };
        }
        /**
         * Create a new anchor point using a hit test result at a specific point in the scene
         * An anchor is tracked only after it is added to the trackerAnchors in xrFrame. The promise returned here does not yet guaranty that.
         * Use onAnchorAddedObservable to get newly added anchors if you require tracking guaranty.
         *
         * @param hitTestResult The hit test result to use for this anchor creation
         * @param position an optional position offset for this anchor
         * @param rotationQuaternion an optional rotation offset for this anchor
         * @returns A promise that fulfills when babylon has created the corresponding WebXRAnchor object and tracking has begun
         */
        async addAnchorPointUsingHitTestResultAsync(hitTestResult, position = new Vector3(), rotationQuaternion = new Quaternion()) {
            // convert to XR space (right handed) if needed
            this._populateTmpTransformation(position, rotationQuaternion);
            // the matrix that we'll use
            const m = new XRRigidTransform({ x: this._tmpVector.x, y: this._tmpVector.y, z: this._tmpVector.z }, { x: this._tmpQuaternion.x, y: this._tmpQuaternion.y, z: this._tmpQuaternion.z, w: this._tmpQuaternion.w });
            if (!hitTestResult.xrHitResult.createAnchor) {
                this.detach();
                throw new Error("Anchors not enabled in this environment/browser");
            }
            else {
                try {
                    const nativeAnchor = await hitTestResult.xrHitResult.createAnchor(m);
                    return new Promise((resolve, reject) => {
                        this._futureAnchors.push({
                            nativeAnchor,
                            resolved: false,
                            submitted: true,
                            xrTransformation: m,
                            resolve,
                            reject,
                        });
                    });
                }
                catch (error) {
                    throw new Error(error);
                }
            }
        }
        /**
         * Add a new anchor at a specific position and rotation
         * This function will add a new anchor per default in the next available frame. Unless forced, the createAnchor function
         * will be called in the next xrFrame loop to make sure that the anchor can be created correctly.
         * An anchor is tracked only after it is added to the trackerAnchors in xrFrame. The promise returned here does not yet guaranty that.
         * Use onAnchorAddedObservable to get newly added anchors if you require tracking guaranty.
         *
         * @param position the position in which to add an anchor
         * @param rotationQuaternion an optional rotation for the anchor transformation
         * @param forceCreateInCurrentFrame force the creation of this anchor in the current frame. Must be called inside xrFrame loop!
         * @returns A promise that fulfills when babylon has created the corresponding WebXRAnchor object and tracking has begun
         */
        async addAnchorAtPositionAndRotationAsync(position, rotationQuaternion = new Quaternion(), forceCreateInCurrentFrame = false) {
            // convert to XR space (right handed) if needed
            this._populateTmpTransformation(position, rotationQuaternion);
            // the matrix that we'll use
            const xrTransformation = new XRRigidTransform({ x: this._tmpVector.x, y: this._tmpVector.y, z: this._tmpVector.z }, { x: this._tmpQuaternion.x, y: this._tmpQuaternion.y, z: this._tmpQuaternion.z, w: this._tmpQuaternion.w });
            const xrAnchor = forceCreateInCurrentFrame && this.attached && this._xrSessionManager.currentFrame
                ? await this._createAnchorAtTransformation(xrTransformation, this._xrSessionManager.currentFrame)
                : undefined;
            // add the transformation to the future anchors list
            return new Promise((resolve, reject) => {
                this._futureAnchors.push({
                    nativeAnchor: xrAnchor,
                    resolved: false,
                    submitted: false,
                    xrTransformation,
                    resolve,
                    reject,
                });
            });
        }
        /**
         * Get the list of anchors currently being tracked by the system
         */
        get anchors() {
            return this._trackedAnchors;
        }
        /**
         * detach this feature.
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        detach() {
            if (!super.detach()) {
                return false;
            }
            if (!this._options.doNotRemoveAnchorsOnSessionEnded) {
                while (this._trackedAnchors.length) {
                    const toRemove = this._trackedAnchors.pop();
                    if (toRemove) {
                        try {
                            // try to natively remove it as well
                            toRemove.remove();
                        }
                        catch (e) {
                            // no-op
                        }
                        // as the xr frame loop is removed, we need to notify manually
                        this.onAnchorRemovedObservable.notifyObservers(toRemove);
                    }
                }
            }
            return true;
        }
        /**
         * Dispose this feature and all of the resources attached
         */
        dispose() {
            this._futureAnchors.length = 0;
            super.dispose();
            this.onAnchorAddedObservable.clear();
            this.onAnchorRemovedObservable.clear();
            this.onAnchorUpdatedObservable.clear();
        }
        _onXRFrame(frame) {
            if (!this.attached || !frame) {
                return;
            }
            const trackedAnchors = frame.trackedAnchors;
            if (trackedAnchors) {
                const toRemove = this._trackedAnchors
                    .filter((anchor) => !trackedAnchors.has(anchor.xrAnchor))
                    .map((anchor) => {
                    const index = this._trackedAnchors.indexOf(anchor);
                    return index;
                });
                let idxTracker = 0;
                toRemove.forEach((index) => {
                    const anchor = this._trackedAnchors.splice(index - idxTracker, 1)[0];
                    this.onAnchorRemovedObservable.notifyObservers(anchor);
                    idxTracker++;
                });
                // now check for new ones
                trackedAnchors.forEach((xrAnchor) => {
                    if (!this._lastFrameDetected.has(xrAnchor)) {
                        const newAnchor = {
                            id: anchorIdProvider++,
                            xrAnchor: xrAnchor,
                            remove: () => xrAnchor.delete(),
                        };
                        const anchor = this._updateAnchorWithXRFrame(xrAnchor, newAnchor, frame);
                        this._trackedAnchors.push(anchor);
                        this.onAnchorAddedObservable.notifyObservers(anchor);
                        // search for the future anchor promise that matches this
                        const results = this._futureAnchors.filter((futureAnchor) => futureAnchor.nativeAnchor === xrAnchor);
                        const result = results[0];
                        if (result) {
                            result.resolve(anchor);
                            result.resolved = true;
                        }
                    }
                    else {
                        const index = this._findIndexInAnchorArray(xrAnchor);
                        const anchor = this._trackedAnchors[index];
                        try {
                            // anchors update every frame
                            this._updateAnchorWithXRFrame(xrAnchor, anchor, frame);
                            if (anchor.attachedNode) {
                                anchor.attachedNode.rotationQuaternion = anchor.attachedNode.rotationQuaternion || new Quaternion();
                                anchor.transformationMatrix.decompose(anchor.attachedNode.scaling, anchor.attachedNode.rotationQuaternion, anchor.attachedNode.position);
                            }
                            this.onAnchorUpdatedObservable.notifyObservers(anchor);
                        }
                        catch (e) {
                            Tools.Warn(`Anchor could not be updated`);
                        }
                    }
                });
                this._lastFrameDetected = trackedAnchors;
            }
            // process future anchors
            this._futureAnchors.forEach((futureAnchor) => {
                if (!futureAnchor.resolved && !futureAnchor.submitted) {
                    this._createAnchorAtTransformation(futureAnchor.xrTransformation, frame).then((nativeAnchor) => {
                        futureAnchor.nativeAnchor = nativeAnchor;
                    }, (error) => {
                        futureAnchor.resolved = true;
                        futureAnchor.reject(error);
                    });
                    futureAnchor.submitted = true;
                }
            });
        }
        /**
         * avoiding using Array.find for global support.
         * @param xrAnchor the plane to find in the array
         */
        _findIndexInAnchorArray(xrAnchor) {
            for (let i = 0; i < this._trackedAnchors.length; ++i) {
                if (this._trackedAnchors[i].xrAnchor === xrAnchor) {
                    return i;
                }
            }
            return -1;
        }
        _updateAnchorWithXRFrame(xrAnchor, anchor, xrFrame) {
            // matrix
            const pose = xrFrame.getPose(xrAnchor.anchorSpace, this._xrSessionManager.referenceSpace);
            if (pose) {
                const mat = anchor.transformationMatrix || new Matrix();
                Matrix.FromArrayToRef(pose.transform.matrix, 0, mat);
                if (!this._xrSessionManager.scene.useRightHandedSystem) {
                    mat.toggleModelMatrixHandInPlace();
                }
                anchor.transformationMatrix = mat;
                if (!this._options.worldParentNode) ;
                else {
                    mat.multiplyToRef(this._options.worldParentNode.getWorldMatrix(), mat);
                }
            }
            return anchor;
        }
        async _createAnchorAtTransformation(xrTransformation, xrFrame) {
            var _a;
            if (xrFrame.createAnchor) {
                try {
                    return xrFrame.createAnchor(xrTransformation, (_a = this._referenceSpaceForFrameAnchors) !== null && _a !== void 0 ? _a : this._xrSessionManager.referenceSpace);
                }
                catch (error) {
                    throw new Error(error);
                }
            }
            else {
                this.detach();
                throw new Error("Anchors are not enabled in your browser");
            }
        }
    }
    /**
     * The module's name
     */
    WebXRAnchorSystem.Name = WebXRFeatureName.ANCHOR_SYSTEM;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the WebXR specs version
     */
    WebXRAnchorSystem.Version = 1;
    // register the plugin
    WebXRFeaturesManager.AddWebXRFeature(WebXRAnchorSystem.Name, (xrSessionManager, options) => {
        return () => new WebXRAnchorSystem(xrSessionManager, options);
    }, WebXRAnchorSystem.Version);

    /**
     * The currently-working hit-test module.
     * Hit test (or Ray-casting) is used to interact with the real world.
     * For further information read here - https://github.com/immersive-web/hit-test
     *
     * Tested on chrome (mobile) 80.
     */
    class WebXRHitTest extends WebXRAbstractFeature {
        /**
         * Creates a new instance of the hit test feature
         * @param _xrSessionManager an instance of WebXRSessionManager
         * @param options options to use when constructing this feature
         */
        constructor(_xrSessionManager, 
        /**
         * options to use when constructing this feature
         */
        options = {}) {
            super(_xrSessionManager);
            this.options = options;
            this._tmpMat = new Matrix();
            this._tmpPos = new Vector3();
            this._tmpQuat = new Quaternion();
            this._initHitTestSource = (referenceSpace) => {
                if (!referenceSpace) {
                    return;
                }
                const offsetRay = new XRRay(this.options.offsetRay || {});
                const hitTestOptions = {
                    space: this.options.useReferenceSpace ? referenceSpace : this._xrSessionManager.viewerReferenceSpace,
                    offsetRay: offsetRay,
                };
                if (this.options.entityTypes) {
                    hitTestOptions.entityTypes = this.options.entityTypes;
                }
                if (!hitTestOptions.space) {
                    Tools.Warn("waiting for viewer reference space to initialize");
                    return;
                }
                this._xrSessionManager.session.requestHitTestSource(hitTestOptions).then((hitTestSource) => {
                    if (this._xrHitTestSource) {
                        this._xrHitTestSource.cancel();
                    }
                    this._xrHitTestSource = hitTestSource;
                });
            };
            /**
             * When set to true, each hit test will have its own position/rotation objects
             * When set to false, position and rotation objects will be reused for each hit test. It is expected that
             * the developers will clone them or copy them as they see fit.
             */
            this.autoCloneTransformation = false;
            /**
             * Triggered when new babylon (transformed) hit test results are available
             * Note - this will be called when results come back from the device. It can be an empty array!!
             */
            this.onHitTestResultObservable = new Observable$1();
            /**
             * Use this to temporarily pause hit test checks.
             */
            this.paused = false;
            this.xrNativeFeatureName = "hit-test";
            Tools.Warn("Hit test is an experimental and unstable feature.");
        }
        /**
         * attach this feature
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        attach() {
            if (!super.attach()) {
                return false;
            }
            // Feature enabled, but not available
            if (!this._xrSessionManager.session.requestHitTestSource) {
                return false;
            }
            if (!this.options.disablePermanentHitTest) {
                if (this._xrSessionManager.referenceSpace) {
                    this._initHitTestSource(this._xrSessionManager.referenceSpace);
                }
                this._xrSessionManager.onXRReferenceSpaceChanged.add(this._initHitTestSource);
            }
            if (this.options.enableTransientHitTest) {
                const offsetRay = new XRRay(this.options.transientOffsetRay || {});
                this._xrSessionManager.session.requestHitTestSourceForTransientInput({
                    profile: this.options.transientHitTestProfile || "generic-touchscreen",
                    offsetRay,
                    entityTypes: this.options.entityTypes,
                }).then((hitSource) => {
                    this._transientXrHitTestSource = hitSource;
                });
            }
            return true;
        }
        /**
         * detach this feature.
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        detach() {
            if (!super.detach()) {
                return false;
            }
            if (this._xrHitTestSource) {
                this._xrHitTestSource.cancel();
                this._xrHitTestSource = null;
            }
            this._xrSessionManager.onXRReferenceSpaceChanged.removeCallback(this._initHitTestSource);
            if (this._transientXrHitTestSource) {
                this._transientXrHitTestSource.cancel();
                this._transientXrHitTestSource = null;
            }
            return true;
        }
        /**
         * Dispose this feature and all of the resources attached
         */
        dispose() {
            super.dispose();
            this.onHitTestResultObservable.clear();
        }
        _onXRFrame(frame) {
            // make sure we do nothing if (async) not attached
            if (!this.attached || this.paused) {
                return;
            }
            if (this._xrHitTestSource) {
                const results = frame.getHitTestResults(this._xrHitTestSource);
                this._processWebXRHitTestResult(results);
            }
            if (this._transientXrHitTestSource) {
                const hitTestResultsPerInputSource = frame.getHitTestResultsForTransientInput(this._transientXrHitTestSource);
                hitTestResultsPerInputSource.forEach((resultsPerInputSource) => {
                    this._processWebXRHitTestResult(resultsPerInputSource.results, resultsPerInputSource.inputSource);
                });
            }
        }
        _processWebXRHitTestResult(hitTestResults, inputSource) {
            const results = [];
            hitTestResults.forEach((hitTestResult) => {
                const pose = hitTestResult.getPose(this._xrSessionManager.referenceSpace);
                if (!pose) {
                    return;
                }
                const pos = pose.transform.position;
                const quat = pose.transform.orientation;
                this._tmpPos.set(pos.x, pos.y, pos.z);
                this._tmpQuat.set(quat.x, quat.y, quat.z, quat.w);
                Matrix.FromFloat32ArrayToRefScaled(pose.transform.matrix, 0, 1, this._tmpMat);
                if (!this._xrSessionManager.scene.useRightHandedSystem) {
                    this._tmpPos.z *= -1;
                    this._tmpQuat.z *= -1;
                    this._tmpQuat.w *= -1;
                    this._tmpMat.toggleModelMatrixHandInPlace();
                }
                const result = {
                    position: this.autoCloneTransformation ? this._tmpPos.clone() : this._tmpPos,
                    rotationQuaternion: this.autoCloneTransformation ? this._tmpQuat.clone() : this._tmpQuat,
                    transformationMatrix: this.autoCloneTransformation ? this._tmpMat.clone() : this._tmpMat,
                    inputSource: inputSource,
                    isTransient: !!inputSource,
                    xrHitResult: hitTestResult,
                };
                results.push(result);
            });
            this.onHitTestResultObservable.notifyObservers(results);
        }
    }
    /**
     * The module's name
     */
    WebXRHitTest.Name = WebXRFeatureName.HIT_TEST;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the WebXR specs version
     */
    WebXRHitTest.Version = 2;
    //register the plugin versions
    WebXRFeaturesManager.AddWebXRFeature(WebXRHitTest.Name, (xrSessionManager, options) => {
        return () => new WebXRHitTest(xrSessionManager, options);
    }, WebXRHitTest.Version, false);

    let planeIdProvider = 0;
    /**
     * The plane detector is used to detect planes in the real world when in AR
     * For more information see https://github.com/immersive-web/real-world-geometry/
     */
    class WebXRPlaneDetector extends WebXRAbstractFeature {
        /**
         * construct a new Plane Detector
         * @param _xrSessionManager an instance of xr Session manager
         * @param _options configuration to use when constructing this feature
         */
        constructor(_xrSessionManager, _options = {}) {
            super(_xrSessionManager);
            this._options = _options;
            this._detectedPlanes = [];
            this._enabled = false;
            this._lastFrameDetected = new Set();
            /**
             * Observers registered here will be executed when a new plane was added to the session
             */
            this.onPlaneAddedObservable = new Observable$1();
            /**
             * Observers registered here will be executed when a plane is no longer detected in the session
             */
            this.onPlaneRemovedObservable = new Observable$1();
            /**
             * Observers registered here will be executed when an existing plane updates (for example - expanded)
             * This can execute N times every frame
             */
            this.onPlaneUpdatedObservable = new Observable$1();
            this.xrNativeFeatureName = "plane-detection";
            if (this._xrSessionManager.session) {
                this._init();
            }
            else {
                this._xrSessionManager.onXRSessionInit.addOnce(() => {
                    this._init();
                });
            }
        }
        /**
         * detach this feature.
         * Will usually be called by the features manager
         *
         * @returns true if successful.
         */
        detach() {
            if (!super.detach()) {
                return false;
            }
            if (!this._options.doNotRemovePlanesOnSessionEnded) {
                while (this._detectedPlanes.length) {
                    const toRemove = this._detectedPlanes.pop();
                    if (toRemove) {
                        this.onPlaneRemovedObservable.notifyObservers(toRemove);
                    }
                }
            }
            return true;
        }
        /**
         * Dispose this feature and all of the resources attached
         */
        dispose() {
            super.dispose();
            this.onPlaneAddedObservable.clear();
            this.onPlaneRemovedObservable.clear();
            this.onPlaneUpdatedObservable.clear();
        }
        /**
         * Check if the needed objects are defined.
         * This does not mean that the feature is enabled, but that the objects needed are well defined.
         */
        isCompatible() {
            return typeof XRPlane !== "undefined";
        }
        _onXRFrame(frame) {
            var _a;
            if (!this.attached || !this._enabled || !frame) {
                return;
            }
            const detectedPlanes = frame.detectedPlanes || ((_a = frame.worldInformation) === null || _a === void 0 ? void 0 : _a.detectedPlanes);
            if (detectedPlanes) {
                // remove all planes that are not currently detected in the frame
                for (let planeIdx = 0; planeIdx < this._detectedPlanes.length; planeIdx++) {
                    const plane = this._detectedPlanes[planeIdx];
                    if (!detectedPlanes.has(plane.xrPlane)) {
                        this._detectedPlanes.splice(planeIdx--, 1);
                        this.onPlaneRemovedObservable.notifyObservers(plane);
                    }
                }
                // now check for new ones
                detectedPlanes.forEach((xrPlane) => {
                    if (!this._lastFrameDetected.has(xrPlane)) {
                        const newPlane = {
                            id: planeIdProvider++,
                            xrPlane: xrPlane,
                            polygonDefinition: [],
                        };
                        const plane = this._updatePlaneWithXRPlane(xrPlane, newPlane, frame);
                        this._detectedPlanes.push(plane);
                        this.onPlaneAddedObservable.notifyObservers(plane);
                    }
                    else {
                        // updated?
                        if (xrPlane.lastChangedTime === this._xrSessionManager.currentTimestamp) {
                            const index = this._findIndexInPlaneArray(xrPlane);
                            const plane = this._detectedPlanes[index];
                            this._updatePlaneWithXRPlane(xrPlane, plane, frame);
                            this.onPlaneUpdatedObservable.notifyObservers(plane);
                        }
                    }
                });
                this._lastFrameDetected = detectedPlanes;
            }
        }
        _init() {
            const internalInit = () => {
                this._enabled = true;
                if (this._detectedPlanes.length) {
                    this._detectedPlanes.length = 0;
                }
            };
            // Only supported by BabylonNative
            if (!!this._xrSessionManager.isNative && !!this._options.preferredDetectorOptions && !!this._xrSessionManager.session.trySetPreferredPlaneDetectorOptions) {
                this._xrSessionManager.session.trySetPreferredPlaneDetectorOptions(this._options.preferredDetectorOptions);
            }
            if (!this._xrSessionManager.session.updateWorldTrackingState) {
                internalInit();
                return;
            }
            this._xrSessionManager.session.updateWorldTrackingState({ planeDetectionState: { enabled: true } });
            internalInit();
        }
        _updatePlaneWithXRPlane(xrPlane, plane, xrFrame) {
            plane.polygonDefinition = xrPlane.polygon.map((xrPoint) => {
                const rightHandedSystem = this._xrSessionManager.scene.useRightHandedSystem ? 1 : -1;
                return new Vector3(xrPoint.x, xrPoint.y, xrPoint.z * rightHandedSystem);
            });
            // matrix
            const pose = xrFrame.getPose(xrPlane.planeSpace, this._xrSessionManager.referenceSpace);
            if (pose) {
                const mat = plane.transformationMatrix || new Matrix();
                Matrix.FromArrayToRef(pose.transform.matrix, 0, mat);
                if (!this._xrSessionManager.scene.useRightHandedSystem) {
                    mat.toggleModelMatrixHandInPlace();
                }
                plane.transformationMatrix = mat;
                if (this._options.worldParentNode) {
                    mat.multiplyToRef(this._options.worldParentNode.getWorldMatrix(), mat);
                }
            }
            return plane;
        }
        /**
         * avoiding using Array.find for global support.
         * @param xrPlane the plane to find in the array
         */
        _findIndexInPlaneArray(xrPlane) {
            for (let i = 0; i < this._detectedPlanes.length; ++i) {
                if (this._detectedPlanes[i].xrPlane === xrPlane) {
                    return i;
                }
            }
            return -1;
        }
    }
    /**
     * The module's name
     */
    WebXRPlaneDetector.Name = WebXRFeatureName.PLANE_DETECTION;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the WebXR specs version
     */
    WebXRPlaneDetector.Version = 1;
    //register the plugin
    WebXRFeaturesManager.AddWebXRFeature(WebXRPlaneDetector.Name, (xrSessionManager, options) => {
        return () => new WebXRPlaneDetector(xrSessionManager, options);
    }, WebXRPlaneDetector.Version);

    /**
     * Defines a target to use with MorphTargetManager
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/morphTargets
     */
    class MorphTarget {
        /**
         * Gets or sets the influence of this target (ie. its weight in the overall morphing)
         */
        get influence() {
            return this._influence;
        }
        set influence(influence) {
            if (this._influence === influence) {
                return;
            }
            const previous = this._influence;
            this._influence = influence;
            if (this.onInfluenceChanged.hasObservers()) {
                this.onInfluenceChanged.notifyObservers(previous === 0 || influence === 0);
            }
        }
        /**
         * Gets or sets the animation properties override
         */
        get animationPropertiesOverride() {
            if (!this._animationPropertiesOverride && this._scene) {
                return this._scene.animationPropertiesOverride;
            }
            return this._animationPropertiesOverride;
        }
        set animationPropertiesOverride(value) {
            this._animationPropertiesOverride = value;
        }
        /**
         * Creates a new MorphTarget
         * @param name defines the name of the target
         * @param influence defines the influence to use
         * @param scene defines the scene the morphtarget belongs to
         */
        constructor(
        /** defines the name of the target */
        name, influence = 0, scene = null) {
            this.name = name;
            /**
             * Gets or sets the list of animations
             */
            this.animations = new Array();
            this._positions = null;
            this._normals = null;
            this._tangents = null;
            this._uvs = null;
            this._uniqueId = 0;
            /**
             * Observable raised when the influence changes
             */
            this.onInfluenceChanged = new Observable$1();
            /** @internal */
            this._onDataLayoutChanged = new Observable$1();
            this._animationPropertiesOverride = null;
            this._scene = scene || EngineStore.LastCreatedScene;
            this.influence = influence;
            if (this._scene) {
                this._uniqueId = this._scene.getUniqueId();
            }
        }
        /**
         * Gets the unique ID of this manager
         */
        get uniqueId() {
            return this._uniqueId;
        }
        /**
         * Gets a boolean defining if the target contains position data
         */
        get hasPositions() {
            return !!this._positions;
        }
        /**
         * Gets a boolean defining if the target contains normal data
         */
        get hasNormals() {
            return !!this._normals;
        }
        /**
         * Gets a boolean defining if the target contains tangent data
         */
        get hasTangents() {
            return !!this._tangents;
        }
        /**
         * Gets a boolean defining if the target contains texture coordinates data
         */
        get hasUVs() {
            return !!this._uvs;
        }
        /**
         * Affects position data to this target
         * @param data defines the position data to use
         */
        setPositions(data) {
            const hadPositions = this.hasPositions;
            this._positions = data;
            if (hadPositions !== this.hasPositions) {
                this._onDataLayoutChanged.notifyObservers(undefined);
            }
        }
        /**
         * Gets the position data stored in this target
         * @returns a FloatArray containing the position data (or null if not present)
         */
        getPositions() {
            return this._positions;
        }
        /**
         * Affects normal data to this target
         * @param data defines the normal data to use
         */
        setNormals(data) {
            const hadNormals = this.hasNormals;
            this._normals = data;
            if (hadNormals !== this.hasNormals) {
                this._onDataLayoutChanged.notifyObservers(undefined);
            }
        }
        /**
         * Gets the normal data stored in this target
         * @returns a FloatArray containing the normal data (or null if not present)
         */
        getNormals() {
            return this._normals;
        }
        /**
         * Affects tangent data to this target
         * @param data defines the tangent data to use
         */
        setTangents(data) {
            const hadTangents = this.hasTangents;
            this._tangents = data;
            if (hadTangents !== this.hasTangents) {
                this._onDataLayoutChanged.notifyObservers(undefined);
            }
        }
        /**
         * Gets the tangent data stored in this target
         * @returns a FloatArray containing the tangent data (or null if not present)
         */
        getTangents() {
            return this._tangents;
        }
        /**
         * Affects texture coordinates data to this target
         * @param data defines the texture coordinates data to use
         */
        setUVs(data) {
            const hadUVs = this.hasUVs;
            this._uvs = data;
            if (hadUVs !== this.hasUVs) {
                this._onDataLayoutChanged.notifyObservers(undefined);
            }
        }
        /**
         * Gets the texture coordinates data stored in this target
         * @returns a FloatArray containing the texture coordinates data (or null if not present)
         */
        getUVs() {
            return this._uvs;
        }
        /**
         * Clone the current target
         * @returns a new MorphTarget
         */
        clone() {
            const newOne = SerializationHelper.Clone(() => new MorphTarget(this.name, this.influence, this._scene), this);
            newOne._positions = this._positions;
            newOne._normals = this._normals;
            newOne._tangents = this._tangents;
            newOne._uvs = this._uvs;
            return newOne;
        }
        /**
         * Serializes the current target into a Serialization object
         * @returns the serialized object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.name = this.name;
            serializationObject.influence = this.influence;
            serializationObject.positions = Array.prototype.slice.call(this.getPositions());
            if (this.id != null) {
                serializationObject.id = this.id;
            }
            if (this.hasNormals) {
                serializationObject.normals = Array.prototype.slice.call(this.getNormals());
            }
            if (this.hasTangents) {
                serializationObject.tangents = Array.prototype.slice.call(this.getTangents());
            }
            if (this.hasUVs) {
                serializationObject.uvs = Array.prototype.slice.call(this.getUVs());
            }
            // Animations
            SerializationHelper.AppendSerializedAnimations(this, serializationObject);
            return serializationObject;
        }
        /**
         * Returns the string "MorphTarget"
         * @returns "MorphTarget"
         */
        getClassName() {
            return "MorphTarget";
        }
        // Statics
        /**
         * Creates a new target from serialized data
         * @param serializationObject defines the serialized data to use
         * @param scene defines the hosting scene
         * @returns a new MorphTarget
         */
        static Parse(serializationObject, scene) {
            const result = new MorphTarget(serializationObject.name, serializationObject.influence);
            result.setPositions(serializationObject.positions);
            if (serializationObject.id != null) {
                result.id = serializationObject.id;
            }
            if (serializationObject.normals) {
                result.setNormals(serializationObject.normals);
            }
            if (serializationObject.tangents) {
                result.setTangents(serializationObject.tangents);
            }
            if (serializationObject.uvs) {
                result.setUVs(serializationObject.uvs);
            }
            // Animations
            if (serializationObject.animations) {
                for (let animationIndex = 0; animationIndex < serializationObject.animations.length; animationIndex++) {
                    const parsedAnimation = serializationObject.animations[animationIndex];
                    const internalClass = GetClass("BABYLON.Animation");
                    if (internalClass) {
                        result.animations.push(internalClass.Parse(parsedAnimation));
                    }
                }
                if (serializationObject.autoAnimate && scene) {
                    scene.beginAnimation(result, serializationObject.autoAnimateFrom, serializationObject.autoAnimateTo, serializationObject.autoAnimateLoop, serializationObject.autoAnimateSpeed || 1.0);
                }
            }
            return result;
        }
        /**
         * Creates a MorphTarget from mesh data
         * @param mesh defines the source mesh
         * @param name defines the name to use for the new target
         * @param influence defines the influence to attach to the target
         * @returns a new MorphTarget
         */
        static FromMesh(mesh, name, influence) {
            if (!name) {
                name = mesh.name;
            }
            const result = new MorphTarget(name, influence, mesh.getScene());
            result.setPositions(mesh.getVerticesData(VertexBuffer.PositionKind));
            if (mesh.isVerticesDataPresent(VertexBuffer.NormalKind)) {
                result.setNormals(mesh.getVerticesData(VertexBuffer.NormalKind));
            }
            if (mesh.isVerticesDataPresent(VertexBuffer.TangentKind)) {
                result.setTangents(mesh.getVerticesData(VertexBuffer.TangentKind));
            }
            if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
                result.setUVs(mesh.getVerticesData(VertexBuffer.UVKind));
            }
            return result;
        }
    }
    __decorate$1([
        serialize()
    ], MorphTarget.prototype, "id", void 0);

    /**
     * @internal
     */
    class _GLTFUtilities {
        /**
         * Creates a buffer view based on the supplied arguments
         * @param bufferIndex index value of the specified buffer
         * @param byteOffset byte offset value
         * @param byteLength byte length of the bufferView
         * @param byteStride byte distance between conequential elements
         * @param name name of the buffer view
         * @returns bufferView for glTF
         */
        static _CreateBufferView(bufferIndex, byteOffset, byteLength, byteStride, name) {
            const bufferview = { buffer: bufferIndex, byteLength: byteLength };
            if (byteOffset) {
                bufferview.byteOffset = byteOffset;
            }
            if (name) {
                bufferview.name = name;
            }
            if (byteStride) {
                bufferview.byteStride = byteStride;
            }
            return bufferview;
        }
        /**
         * Creates an accessor based on the supplied arguments
         * @param bufferviewIndex The index of the bufferview referenced by this accessor
         * @param name The name of the accessor
         * @param type The type of the accessor
         * @param componentType The datatype of components in the attribute
         * @param count The number of attributes referenced by this accessor
         * @param byteOffset The offset relative to the start of the bufferView in bytes
         * @param min Minimum value of each component in this attribute
         * @param max Maximum value of each component in this attribute
         * @returns accessor for glTF
         */
        static _CreateAccessor(bufferviewIndex, name, type, componentType, count, byteOffset, min, max) {
            const accessor = { name: name, bufferView: bufferviewIndex, componentType: componentType, count: count, type: type };
            if (min != null) {
                accessor.min = min;
            }
            if (max != null) {
                accessor.max = max;
            }
            if (byteOffset != null) {
                accessor.byteOffset = byteOffset;
            }
            return accessor;
        }
        /**
         * Calculates the minimum and maximum values of an array of position floats
         * @param positions Positions array of a mesh
         * @param vertexStart Starting vertex offset to calculate min and max values
         * @param vertexCount Number of vertices to check for min and max values
         * @returns min number array and max number array
         */
        static _CalculateMinMaxPositions(positions, vertexStart, vertexCount) {
            const min = [Infinity, Infinity, Infinity];
            const max = [-Infinity, -Infinity, -Infinity];
            const positionStrideSize = 3;
            let indexOffset;
            let position;
            let vector;
            if (vertexCount) {
                for (let i = vertexStart, length = vertexStart + vertexCount; i < length; ++i) {
                    indexOffset = positionStrideSize * i;
                    position = Vector3.FromArray(positions, indexOffset);
                    vector = position.asArray();
                    for (let j = 0; j < positionStrideSize; ++j) {
                        const num = vector[j];
                        if (num < min[j]) {
                            min[j] = num;
                        }
                        if (num > max[j]) {
                            max[j] = num;
                        }
                        ++indexOffset;
                    }
                }
            }
            return { min, max };
        }
        static _NormalizeTangentFromRef(tangent) {
            const length = Math.sqrt(tangent.x * tangent.x + tangent.y * tangent.y + tangent.z * tangent.z);
            if (length > 0) {
                tangent.x /= length;
                tangent.y /= length;
                tangent.z /= length;
            }
        }
        static _GetDataAccessorElementCount(accessorType) {
            switch (accessorType) {
                case "MAT2" /* AccessorType.MAT2 */:
                    return 4;
                case "MAT3" /* AccessorType.MAT3 */:
                    return 9;
                case "MAT4" /* AccessorType.MAT4 */:
                    return 16;
                case "SCALAR" /* AccessorType.SCALAR */:
                    return 1;
                case "VEC2" /* AccessorType.VEC2 */:
                    return 2;
                case "VEC3" /* AccessorType.VEC3 */:
                    return 3;
                case "VEC4" /* AccessorType.VEC4 */:
                    return 4;
            }
        }
    }

    /**
     * @internal
     * Enum for handling in tangent and out tangent.
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _TangentType;
    (function (_TangentType) {
        /**
         * Specifies that input tangents are used.
         */
        _TangentType[_TangentType["INTANGENT"] = 0] = "INTANGENT";
        /**
         * Specifies that output tangents are used.
         */
        _TangentType[_TangentType["OUTTANGENT"] = 1] = "OUTTANGENT";
    })(_TangentType || (_TangentType = {}));
    /**
     * @internal
     * Utility class for generating glTF animation data from BabylonJS.
     */
    class _GLTFAnimation {
        /**
         * Determine if a node is transformable - ie has properties it should be part of animation of transformation.
         * @param babylonNode the node to test
         * @returns true if can be animated, false otherwise. False if the parameter is null or undefined.
         */
        static _IsTransformable(babylonNode) {
            return babylonNode && (babylonNode instanceof TransformNode || babylonNode instanceof Camera || babylonNode instanceof Light);
        }
        /**
         * @ignore
         *
         * Creates glTF channel animation from BabylonJS animation.
         * @param babylonTransformNode - BabylonJS mesh.
         * @param animation - animation.
         * @param animationChannelTargetPath - The target animation channel.
         * @param useQuaternion - Specifies if quaternions are used.
         * @returns nullable IAnimationData
         */
        static _CreateNodeAnimation(babylonTransformNode, animation, animationChannelTargetPath, useQuaternion, animationSampleRate) {
            if (this._IsTransformable(babylonTransformNode)) {
                const inputs = [];
                const outputs = [];
                const keyFrames = animation.getKeys();
                const minMaxKeyFrames = _GLTFAnimation._CalculateMinMaxKeyFrames(keyFrames);
                const interpolationOrBake = _GLTFAnimation._DeduceInterpolation(keyFrames, animationChannelTargetPath, useQuaternion);
                const interpolation = interpolationOrBake.interpolationType;
                const shouldBakeAnimation = interpolationOrBake.shouldBakeAnimation;
                if (shouldBakeAnimation) {
                    _GLTFAnimation._CreateBakedAnimation(babylonTransformNode, animation, animationChannelTargetPath, minMaxKeyFrames.min, minMaxKeyFrames.max, animation.framePerSecond, animationSampleRate, inputs, outputs, minMaxKeyFrames, useQuaternion);
                }
                else {
                    if (interpolation === "LINEAR" /* AnimationSamplerInterpolation.LINEAR */ || interpolation === "STEP" /* AnimationSamplerInterpolation.STEP */) {
                        _GLTFAnimation._CreateLinearOrStepAnimation(babylonTransformNode, animation, animationChannelTargetPath, inputs, outputs, useQuaternion);
                    }
                    else if (interpolation === "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */) {
                        _GLTFAnimation._CreateCubicSplineAnimation(babylonTransformNode, animation, animationChannelTargetPath, inputs, outputs, useQuaternion);
                    }
                    else {
                        _GLTFAnimation._CreateBakedAnimation(babylonTransformNode, animation, animationChannelTargetPath, minMaxKeyFrames.min, minMaxKeyFrames.max, animation.framePerSecond, animationSampleRate, inputs, outputs, minMaxKeyFrames, useQuaternion);
                    }
                }
                if (inputs.length && outputs.length) {
                    const result = {
                        inputs: inputs,
                        outputs: outputs,
                        samplerInterpolation: interpolation,
                        inputsMin: shouldBakeAnimation ? minMaxKeyFrames.min : Tools.FloatRound(minMaxKeyFrames.min / animation.framePerSecond),
                        inputsMax: shouldBakeAnimation ? minMaxKeyFrames.max : Tools.FloatRound(minMaxKeyFrames.max / animation.framePerSecond),
                    };
                    return result;
                }
            }
            return null;
        }
        static _DeduceAnimationInfo(animation) {
            let animationChannelTargetPath = null;
            let dataAccessorType = "VEC3" /* AccessorType.VEC3 */;
            let useQuaternion = false;
            const property = animation.targetProperty.split(".");
            switch (property[0]) {
                case "scaling": {
                    animationChannelTargetPath = "scale" /* AnimationChannelTargetPath.SCALE */;
                    break;
                }
                case "position": {
                    animationChannelTargetPath = "translation" /* AnimationChannelTargetPath.TRANSLATION */;
                    break;
                }
                case "rotation": {
                    dataAccessorType = "VEC4" /* AccessorType.VEC4 */;
                    animationChannelTargetPath = "rotation" /* AnimationChannelTargetPath.ROTATION */;
                    break;
                }
                case "rotationQuaternion": {
                    dataAccessorType = "VEC4" /* AccessorType.VEC4 */;
                    useQuaternion = true;
                    animationChannelTargetPath = "rotation" /* AnimationChannelTargetPath.ROTATION */;
                    break;
                }
                case "influence": {
                    dataAccessorType = "SCALAR" /* AccessorType.SCALAR */;
                    animationChannelTargetPath = "weights" /* AnimationChannelTargetPath.WEIGHTS */;
                    break;
                }
                default: {
                    Tools.Error(`Unsupported animatable property ${property[0]}`);
                }
            }
            if (animationChannelTargetPath) {
                return { animationChannelTargetPath: animationChannelTargetPath, dataAccessorType: dataAccessorType, useQuaternion: useQuaternion };
            }
            else {
                Tools.Error("animation channel target path and data accessor type could be deduced");
            }
            return null;
        }
        /**
         * @ignore
         * Create node animations from the transform node animations
         * @param babylonNode
         * @param runtimeGLTFAnimation
         * @param idleGLTFAnimations
         * @param nodeMap
         * @param nodes
         * @param binaryWriter
         * @param bufferViews
         * @param accessors
         * @param animationSampleRate
         */
        static _CreateNodeAnimationFromNodeAnimations(babylonNode, runtimeGLTFAnimation, idleGLTFAnimations, nodeMap, nodes, binaryWriter, bufferViews, accessors, animationSampleRate, shouldExportAnimation) {
            let glTFAnimation;
            if (_GLTFAnimation._IsTransformable(babylonNode)) {
                if (babylonNode.animations) {
                    for (const animation of babylonNode.animations) {
                        if (shouldExportAnimation && !shouldExportAnimation(animation)) {
                            continue;
                        }
                        const animationInfo = _GLTFAnimation._DeduceAnimationInfo(animation);
                        if (animationInfo) {
                            glTFAnimation = {
                                name: animation.name,
                                samplers: [],
                                channels: [],
                            };
                            _GLTFAnimation._AddAnimation(`${animation.name}`, animation.hasRunningRuntimeAnimations ? runtimeGLTFAnimation : glTFAnimation, babylonNode, animation, animationInfo.dataAccessorType, animationInfo.animationChannelTargetPath, nodeMap, binaryWriter, bufferViews, accessors, animationInfo.useQuaternion, animationSampleRate);
                            if (glTFAnimation.samplers.length && glTFAnimation.channels.length) {
                                idleGLTFAnimations.push(glTFAnimation);
                            }
                        }
                    }
                }
            }
        }
        /**
         * @ignore
         * Create individual morph animations from the mesh's morph target animation tracks
         * @param babylonNode
         * @param runtimeGLTFAnimation
         * @param idleGLTFAnimations
         * @param nodeMap
         * @param nodes
         * @param binaryWriter
         * @param bufferViews
         * @param accessors
         * @param animationSampleRate
         */
        static _CreateMorphTargetAnimationFromMorphTargetAnimations(babylonNode, runtimeGLTFAnimation, idleGLTFAnimations, nodeMap, nodes, binaryWriter, bufferViews, accessors, animationSampleRate, shouldExportAnimation) {
            let glTFAnimation;
            if (babylonNode instanceof Mesh) {
                const morphTargetManager = babylonNode.morphTargetManager;
                if (morphTargetManager) {
                    for (let i = 0; i < morphTargetManager.numTargets; ++i) {
                        const morphTarget = morphTargetManager.getTarget(i);
                        for (const animation of morphTarget.animations) {
                            if (shouldExportAnimation && !shouldExportAnimation(animation)) {
                                continue;
                            }
                            const combinedAnimation = new Animation(`${animation.name}`, "influence", animation.framePerSecond, animation.dataType, animation.loopMode, animation.enableBlending);
                            const combinedAnimationKeys = [];
                            const animationKeys = animation.getKeys();
                            for (let j = 0; j < animationKeys.length; ++j) {
                                const animationKey = animationKeys[j];
                                for (let k = 0; k < morphTargetManager.numTargets; ++k) {
                                    if (k == i) {
                                        combinedAnimationKeys.push(animationKey);
                                    }
                                    else {
                                        combinedAnimationKeys.push({ frame: animationKey.frame, value: 0 });
                                    }
                                }
                            }
                            combinedAnimation.setKeys(combinedAnimationKeys);
                            const animationInfo = _GLTFAnimation._DeduceAnimationInfo(combinedAnimation);
                            if (animationInfo) {
                                glTFAnimation = {
                                    name: combinedAnimation.name,
                                    samplers: [],
                                    channels: [],
                                };
                                _GLTFAnimation._AddAnimation(animation.name, animation.hasRunningRuntimeAnimations ? runtimeGLTFAnimation : glTFAnimation, babylonNode, combinedAnimation, animationInfo.dataAccessorType, animationInfo.animationChannelTargetPath, nodeMap, binaryWriter, bufferViews, accessors, animationInfo.useQuaternion, animationSampleRate, morphTargetManager.numTargets);
                                if (glTFAnimation.samplers.length && glTFAnimation.channels.length) {
                                    idleGLTFAnimations.push(glTFAnimation);
                                }
                            }
                        }
                    }
                }
            }
        }
        /**
         * @ignore
         * Create node and morph animations from the animation groups
         * @param babylonScene
         * @param glTFAnimations
         * @param nodeMap
         * @param nodes
         * @param binaryWriter
         * @param bufferViews
         * @param accessors
         * @param animationSampleRate
         */
        static _CreateNodeAndMorphAnimationFromAnimationGroups(babylonScene, glTFAnimations, nodeMap, binaryWriter, bufferViews, accessors, animationSampleRate, shouldExportAnimation) {
            var _a;
            let glTFAnimation;
            if (babylonScene.animationGroups) {
                const animationGroups = babylonScene.animationGroups;
                for (const animationGroup of animationGroups) {
                    const morphAnimations = new Map();
                    const sampleAnimations = new Map();
                    const morphAnimationMeshes = new Set();
                    const animationGroupFrameDiff = animationGroup.to - animationGroup.from;
                    glTFAnimation = {
                        name: animationGroup.name,
                        channels: [],
                        samplers: [],
                    };
                    for (let i = 0; i < animationGroup.targetedAnimations.length; ++i) {
                        const targetAnimation = animationGroup.targetedAnimations[i];
                        const target = targetAnimation.target;
                        const animation = targetAnimation.animation;
                        if (shouldExportAnimation && !shouldExportAnimation(animation)) {
                            continue;
                        }
                        if (this._IsTransformable(target) || (target.length === 1 && this._IsTransformable(target[0]))) {
                            const animationInfo = _GLTFAnimation._DeduceAnimationInfo(targetAnimation.animation);
                            if (animationInfo) {
                                const babylonTransformNode = this._IsTransformable(target) ? target : this._IsTransformable(target[0]) ? target[0] : null;
                                if (babylonTransformNode) {
                                    _GLTFAnimation._AddAnimation(`${animation.name}`, glTFAnimation, babylonTransformNode, animation, animationInfo.dataAccessorType, animationInfo.animationChannelTargetPath, nodeMap, binaryWriter, bufferViews, accessors, animationInfo.useQuaternion, animationSampleRate);
                                }
                            }
                        }
                        else if (target instanceof MorphTarget || (target.length === 1 && target[0] instanceof MorphTarget)) {
                            const animationInfo = _GLTFAnimation._DeduceAnimationInfo(targetAnimation.animation);
                            if (animationInfo) {
                                const babylonMorphTarget = target instanceof MorphTarget ? target : target[0];
                                if (babylonMorphTarget) {
                                    const babylonMorphTargetManager = babylonScene.morphTargetManagers.find((morphTargetManager) => {
                                        for (let j = 0; j < morphTargetManager.numTargets; ++j) {
                                            if (morphTargetManager.getTarget(j) === babylonMorphTarget) {
                                                return true;
                                            }
                                        }
                                        return false;
                                    });
                                    if (babylonMorphTargetManager) {
                                        const babylonMesh = babylonScene.meshes.find((mesh) => {
                                            return mesh.morphTargetManager === babylonMorphTargetManager;
                                        });
                                        if (babylonMesh) {
                                            if (!morphAnimations.has(babylonMesh)) {
                                                morphAnimations.set(babylonMesh, new Map());
                                            }
                                            (_a = morphAnimations.get(babylonMesh)) === null || _a === void 0 ? void 0 : _a.set(babylonMorphTarget, animation);
                                            morphAnimationMeshes.add(babylonMesh);
                                            sampleAnimations.set(babylonMesh, animation);
                                        }
                                    }
                                }
                            }
                        }
                        else ;
                    }
                    morphAnimationMeshes.forEach((mesh) => {
                        const morphTargetManager = mesh.morphTargetManager;
                        let combinedAnimationGroup = null;
                        const animationKeys = [];
                        const sampleAnimation = sampleAnimations.get(mesh);
                        const sampleAnimationKeys = sampleAnimation.getKeys();
                        const numAnimationKeys = sampleAnimationKeys.length;
                        /*
                            Due to how glTF expects morph target animation data to be formatted, we need to rearrange the individual morph target animation tracks,
                            such that we have a single animation, where a given keyframe input value has successive output values for each morph target belonging to the manager.
                            See: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations

                            We do this via constructing a new Animation track, and interleaving the frames of each morph target animation track in the current Animation Group
                            We reuse the Babylon Animation data structure for ease of handling export of cubic spline animation keys, and to reuse the
                            existing _GLTFAnimation.AddAnimation codepath with minimal modification, however the constructed Babylon Animation is NOT intended for use in-engine.
                        */
                        for (let i = 0; i < numAnimationKeys; ++i) {
                            for (let j = 0; j < morphTargetManager.numTargets; ++j) {
                                const morphTarget = morphTargetManager.getTarget(j);
                                const animationsByMorphTarget = morphAnimations.get(mesh);
                                if (animationsByMorphTarget) {
                                    const morphTargetAnimation = animationsByMorphTarget.get(morphTarget);
                                    if (morphTargetAnimation) {
                                        if (!combinedAnimationGroup) {
                                            combinedAnimationGroup = new Animation(`${animationGroup.name}_${mesh.name}_MorphWeightAnimation`, "influence", morphTargetAnimation.framePerSecond, Animation.ANIMATIONTYPE_FLOAT, morphTargetAnimation.loopMode, morphTargetAnimation.enableBlending);
                                        }
                                        animationKeys.push(morphTargetAnimation.getKeys()[i]);
                                    }
                                    else {
                                        animationKeys.push({
                                            frame: animationGroup.from + (animationGroupFrameDiff / numAnimationKeys) * i,
                                            value: morphTarget.influence,
                                            inTangent: sampleAnimationKeys[0].inTangent ? 0 : undefined,
                                            outTangent: sampleAnimationKeys[0].outTangent ? 0 : undefined,
                                        });
                                    }
                                }
                            }
                        }
                        combinedAnimationGroup.setKeys(animationKeys);
                        const animationInfo = _GLTFAnimation._DeduceAnimationInfo(combinedAnimationGroup);
                        if (animationInfo) {
                            _GLTFAnimation._AddAnimation(`${animationGroup.name}_${mesh.name}_MorphWeightAnimation`, glTFAnimation, mesh, combinedAnimationGroup, animationInfo.dataAccessorType, animationInfo.animationChannelTargetPath, nodeMap, binaryWriter, bufferViews, accessors, animationInfo.useQuaternion, animationSampleRate, morphTargetManager === null || morphTargetManager === void 0 ? void 0 : morphTargetManager.numTargets);
                        }
                    });
                    if (glTFAnimation.channels.length && glTFAnimation.samplers.length) {
                        glTFAnimations.push(glTFAnimation);
                    }
                }
            }
        }
        static _AddAnimation(name, glTFAnimation, babylonTransformNode, animation, dataAccessorType, animationChannelTargetPath, nodeMap, binaryWriter, bufferViews, accessors, useQuaternion, animationSampleRate, morphAnimationChannels) {
            const animationData = _GLTFAnimation._CreateNodeAnimation(babylonTransformNode, animation, animationChannelTargetPath, useQuaternion, animationSampleRate);
            let bufferView;
            let accessor;
            let keyframeAccessorIndex;
            let dataAccessorIndex;
            let outputLength;
            let animationSampler;
            let animationChannel;
            if (animationData) {
                /*
                 * Now that we have the glTF converted morph target animation data,
                 * we can remove redundant input data so that we have n input frames,
                 * and morphAnimationChannels * n output frames
                 */
                if (morphAnimationChannels) {
                    let index = 0;
                    let currentInput = 0;
                    const newInputs = [];
                    while (animationData.inputs.length > 0) {
                        currentInput = animationData.inputs.shift();
                        if (index % morphAnimationChannels == 0) {
                            newInputs.push(currentInput);
                        }
                        index++;
                    }
                    animationData.inputs = newInputs;
                }
                const nodeIndex = nodeMap[babylonTransformNode.uniqueId];
                // Creates buffer view and accessor for key frames.
                let byteLength = animationData.inputs.length * 4;
                bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, undefined, `${name}  keyframe data view`);
                bufferViews.push(bufferView);
                animationData.inputs.forEach(function (input) {
                    binaryWriter.setFloat32(input);
                });
                accessor = _GLTFUtilities._CreateAccessor(bufferViews.length - 1, `${name}  keyframes`, "SCALAR" /* AccessorType.SCALAR */, 5126 /* AccessorComponentType.FLOAT */, animationData.inputs.length, null, [animationData.inputsMin], [animationData.inputsMax]);
                accessors.push(accessor);
                keyframeAccessorIndex = accessors.length - 1;
                // create bufferview and accessor for keyed values.
                outputLength = animationData.outputs.length;
                byteLength = _GLTFUtilities._GetDataAccessorElementCount(dataAccessorType) * 4 * animationData.outputs.length;
                // check for in and out tangents
                bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, undefined, `${name}  data view`);
                bufferViews.push(bufferView);
                animationData.outputs.forEach(function (output) {
                    output.forEach(function (entry) {
                        binaryWriter.setFloat32(entry);
                    });
                });
                accessor = _GLTFUtilities._CreateAccessor(bufferViews.length - 1, `${name}  data`, dataAccessorType, 5126 /* AccessorComponentType.FLOAT */, outputLength, null, null, null);
                accessors.push(accessor);
                dataAccessorIndex = accessors.length - 1;
                // create sampler
                animationSampler = {
                    interpolation: animationData.samplerInterpolation,
                    input: keyframeAccessorIndex,
                    output: dataAccessorIndex,
                };
                glTFAnimation.samplers.push(animationSampler);
                // create channel
                animationChannel = {
                    sampler: glTFAnimation.samplers.length - 1,
                    target: {
                        node: nodeIndex,
                        path: animationChannelTargetPath,
                    },
                };
                glTFAnimation.channels.push(animationChannel);
            }
        }
        /**
         * Create a baked animation
         * @param babylonTransformNode BabylonJS mesh
         * @param animation BabylonJS animation corresponding to the BabylonJS mesh
         * @param animationChannelTargetPath animation target channel
         * @param minFrame minimum animation frame
         * @param maxFrame maximum animation frame
         * @param fps frames per second of the animation
         * @param sampleRate
         * @param inputs input key frames of the animation
         * @param outputs output key frame data of the animation
         * @param minMaxFrames
         * @param minMaxFrames.min
         * @param minMaxFrames.max
         * @param useQuaternion specifies if quaternions should be used
         */
        static _CreateBakedAnimation(babylonTransformNode, animation, animationChannelTargetPath, minFrame, maxFrame, fps, sampleRate, inputs, outputs, minMaxFrames, useQuaternion) {
            let value;
            const quaternionCache = Quaternion.Identity();
            let previousTime = null;
            let time;
            let maxUsedFrame = null;
            let currKeyFrame = null;
            let nextKeyFrame = null;
            let prevKeyFrame = null;
            let endFrame = null;
            minMaxFrames.min = Tools.FloatRound(minFrame / fps);
            const keyFrames = animation.getKeys();
            for (let i = 0, length = keyFrames.length; i < length; ++i) {
                endFrame = null;
                currKeyFrame = keyFrames[i];
                if (i + 1 < length) {
                    nextKeyFrame = keyFrames[i + 1];
                    if ((currKeyFrame.value.equals && currKeyFrame.value.equals(nextKeyFrame.value)) || currKeyFrame.value === nextKeyFrame.value) {
                        if (i === 0) {
                            // set the first frame to itself
                            endFrame = currKeyFrame.frame;
                        }
                        else {
                            continue;
                        }
                    }
                    else {
                        endFrame = nextKeyFrame.frame;
                    }
                }
                else {
                    // at the last key frame
                    prevKeyFrame = keyFrames[i - 1];
                    if ((currKeyFrame.value.equals && currKeyFrame.value.equals(prevKeyFrame.value)) || currKeyFrame.value === prevKeyFrame.value) {
                        continue;
                    }
                    else {
                        endFrame = maxFrame;
                    }
                }
                if (endFrame) {
                    for (let f = currKeyFrame.frame; f <= endFrame; f += sampleRate) {
                        time = Tools.FloatRound(f / fps);
                        if (time === previousTime) {
                            continue;
                        }
                        previousTime = time;
                        maxUsedFrame = time;
                        const state = {
                            key: 0,
                            repeatCount: 0,
                            loopMode: animation.loopMode,
                        };
                        value = animation._interpolate(f, state);
                        _GLTFAnimation._SetInterpolatedValue(babylonTransformNode, value, time, animation, animationChannelTargetPath, quaternionCache, inputs, outputs, useQuaternion);
                    }
                }
            }
            if (maxUsedFrame) {
                minMaxFrames.max = maxUsedFrame;
            }
        }
        static _ConvertFactorToVector3OrQuaternion(factor, babylonTransformNode, animation, animationChannelTargetPath, useQuaternion) {
            const basePositionRotationOrScale = _GLTFAnimation._GetBasePositionRotationOrScale(babylonTransformNode, animationChannelTargetPath, useQuaternion);
            // handles single component x, y, z or w component animation by using a base property and animating over a component.
            const property = animation.targetProperty.split(".");
            const componentName = property ? property[1] : ""; // x, y, z, or w component
            const value = useQuaternion ? Quaternion.FromArray(basePositionRotationOrScale).normalize() : Vector3.FromArray(basePositionRotationOrScale);
            switch (componentName) {
                case "x":
                case "y":
                case "z": {
                    value[componentName] = factor;
                    break;
                }
                case "w": {
                    value.w = factor;
                    break;
                }
                default: {
                    Tools.Error(`glTFAnimation: Unsupported component name "${componentName}"!`);
                }
            }
            return value;
        }
        static _SetInterpolatedValue(babylonTransformNode, value, time, animation, animationChannelTargetPath, quaternionCache, inputs, outputs, useQuaternion) {
            let cacheValue;
            inputs.push(time);
            if (animationChannelTargetPath === "weights" /* AnimationChannelTargetPath.WEIGHTS */) {
                outputs.push([value]);
                return;
            }
            if (animation.dataType === Animation.ANIMATIONTYPE_FLOAT) {
                value = this._ConvertFactorToVector3OrQuaternion(value, babylonTransformNode, animation, animationChannelTargetPath, useQuaternion);
            }
            if (animationChannelTargetPath === "rotation" /* AnimationChannelTargetPath.ROTATION */) {
                if (useQuaternion) {
                    quaternionCache = value;
                }
                else {
                    cacheValue = value;
                    Quaternion.RotationYawPitchRollToRef(cacheValue.y, cacheValue.x, cacheValue.z, quaternionCache);
                }
                outputs.push(quaternionCache.asArray());
            }
            else {
                // scaling and position animation
                cacheValue = value;
                outputs.push(cacheValue.asArray());
            }
        }
        /**
         * Creates linear animation from the animation key frames
         * @param babylonTransformNode BabylonJS mesh
         * @param animation BabylonJS animation
         * @param animationChannelTargetPath The target animation channel
         * @param inputs Array to store the key frame times
         * @param outputs Array to store the key frame data
         * @param useQuaternion Specifies if quaternions are used in the animation
         */
        static _CreateLinearOrStepAnimation(babylonTransformNode, animation, animationChannelTargetPath, inputs, outputs, useQuaternion) {
            for (const keyFrame of animation.getKeys()) {
                inputs.push(keyFrame.frame / animation.framePerSecond); // keyframes in seconds.
                _GLTFAnimation._AddKeyframeValue(keyFrame, animation, outputs, animationChannelTargetPath, babylonTransformNode, useQuaternion);
            }
        }
        /**
         * Creates cubic spline animation from the animation key frames
         * @param babylonTransformNode BabylonJS mesh
         * @param animation BabylonJS animation
         * @param animationChannelTargetPath The target animation channel
         * @param frameDelta The difference between the last and first frame of the animation
         * @param inputs Array to store the key frame times
         * @param outputs Array to store the key frame data
         * @param useQuaternion Specifies if quaternions are used in the animation
         */
        static _CreateCubicSplineAnimation(babylonTransformNode, animation, animationChannelTargetPath, inputs, outputs, useQuaternion) {
            animation.getKeys().forEach(function (keyFrame) {
                inputs.push(keyFrame.frame / animation.framePerSecond); // keyframes in seconds.
                _GLTFAnimation._AddSplineTangent(_TangentType.INTANGENT, outputs, animationChannelTargetPath, "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */, keyFrame, useQuaternion);
                _GLTFAnimation._AddKeyframeValue(keyFrame, animation, outputs, animationChannelTargetPath, babylonTransformNode, useQuaternion);
                _GLTFAnimation._AddSplineTangent(_TangentType.OUTTANGENT, outputs, animationChannelTargetPath, "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */, keyFrame, useQuaternion);
            });
        }
        static _GetBasePositionRotationOrScale(babylonTransformNode, animationChannelTargetPath, useQuaternion) {
            let basePositionRotationOrScale;
            if (animationChannelTargetPath === "rotation" /* AnimationChannelTargetPath.ROTATION */) {
                if (useQuaternion) {
                    const q = babylonTransformNode.rotationQuaternion;
                    basePositionRotationOrScale = (q !== null && q !== void 0 ? q : Quaternion.Identity()).asArray();
                }
                else {
                    const r = babylonTransformNode.rotation;
                    basePositionRotationOrScale = (r !== null && r !== void 0 ? r : Vector3.Zero()).asArray();
                }
            }
            else if (animationChannelTargetPath === "translation" /* AnimationChannelTargetPath.TRANSLATION */) {
                const p = babylonTransformNode.position;
                basePositionRotationOrScale = (p !== null && p !== void 0 ? p : Vector3.Zero()).asArray();
            }
            else {
                // scale
                const s = babylonTransformNode.scaling;
                basePositionRotationOrScale = (s !== null && s !== void 0 ? s : Vector3.One()).asArray();
            }
            return basePositionRotationOrScale;
        }
        /**
         * Adds a key frame value
         * @param keyFrame
         * @param animation
         * @param outputs
         * @param animationChannelTargetPath
         * @param babylonTransformNode
         * @param useQuaternion
         */
        static _AddKeyframeValue(keyFrame, animation, outputs, animationChannelTargetPath, babylonTransformNode, useQuaternion) {
            let newPositionRotationOrScale;
            const animationType = animation.dataType;
            if (animationType === Animation.ANIMATIONTYPE_VECTOR3) {
                let value = keyFrame.value.asArray();
                if (animationChannelTargetPath === "rotation" /* AnimationChannelTargetPath.ROTATION */) {
                    const array = Vector3.FromArray(value);
                    const rotationQuaternion = Quaternion.RotationYawPitchRoll(array.y, array.x, array.z);
                    value = rotationQuaternion.asArray();
                }
                outputs.push(value); // scale  vector.
            }
            else if (animationType === Animation.ANIMATIONTYPE_FLOAT) {
                if (animationChannelTargetPath === "weights" /* AnimationChannelTargetPath.WEIGHTS */) {
                    outputs.push([keyFrame.value]);
                }
                else {
                    // handles single component x, y, z or w component animation by using a base property and animating over a component.
                    newPositionRotationOrScale = this._ConvertFactorToVector3OrQuaternion(keyFrame.value, babylonTransformNode, animation, animationChannelTargetPath, useQuaternion);
                    if (newPositionRotationOrScale) {
                        if (animationChannelTargetPath === "rotation" /* AnimationChannelTargetPath.ROTATION */) {
                            const posRotScale = useQuaternion
                                ? newPositionRotationOrScale
                                : Quaternion.RotationYawPitchRoll(newPositionRotationOrScale.y, newPositionRotationOrScale.x, newPositionRotationOrScale.z).normalize();
                            outputs.push(posRotScale.asArray());
                        }
                        outputs.push(newPositionRotationOrScale.asArray());
                    }
                }
            }
            else if (animationType === Animation.ANIMATIONTYPE_QUATERNION) {
                outputs.push(keyFrame.value.normalize().asArray());
            }
            else {
                Tools.Error("glTFAnimation: Unsupported key frame values for animation!");
            }
        }
        /**
         * Determine the interpolation based on the key frames
         * @param keyFrames
         * @param animationChannelTargetPath
         * @param useQuaternion
         */
        static _DeduceInterpolation(keyFrames, animationChannelTargetPath, useQuaternion) {
            let interpolationType;
            let shouldBakeAnimation = false;
            let key;
            if (animationChannelTargetPath === "rotation" /* AnimationChannelTargetPath.ROTATION */ && !useQuaternion) {
                return { interpolationType: "LINEAR" /* AnimationSamplerInterpolation.LINEAR */, shouldBakeAnimation: true };
            }
            for (let i = 0, length = keyFrames.length; i < length; ++i) {
                key = keyFrames[i];
                if (key.inTangent || key.outTangent) {
                    if (interpolationType) {
                        if (interpolationType !== "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */) {
                            interpolationType = "LINEAR" /* AnimationSamplerInterpolation.LINEAR */;
                            shouldBakeAnimation = true;
                            break;
                        }
                    }
                    else {
                        interpolationType = "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */;
                    }
                }
                else {
                    if (interpolationType) {
                        if (interpolationType === "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */ ||
                            (key.interpolation && key.interpolation === AnimationKeyInterpolation.STEP && interpolationType !== "STEP" /* AnimationSamplerInterpolation.STEP */)) {
                            interpolationType = "LINEAR" /* AnimationSamplerInterpolation.LINEAR */;
                            shouldBakeAnimation = true;
                            break;
                        }
                    }
                    else {
                        if (key.interpolation && key.interpolation === AnimationKeyInterpolation.STEP) {
                            interpolationType = "STEP" /* AnimationSamplerInterpolation.STEP */;
                        }
                        else {
                            interpolationType = "LINEAR" /* AnimationSamplerInterpolation.LINEAR */;
                        }
                    }
                }
            }
            if (!interpolationType) {
                interpolationType = "LINEAR" /* AnimationSamplerInterpolation.LINEAR */;
            }
            return { interpolationType: interpolationType, shouldBakeAnimation: shouldBakeAnimation };
        }
        /**
         * Adds an input tangent or output tangent to the output data
         * If an input tangent or output tangent is missing, it uses the zero vector or zero quaternion
         * @param babylonTransformNode
         * @param tangentType Specifies which type of tangent to handle (inTangent or outTangent)
         * @param outputs The animation data by keyframe
         * @param animationChannelTargetPath The target animation channel
         * @param interpolation The interpolation type
         * @param keyFrame The key frame with the animation data
         * @param frameDelta Time difference between two frames used to scale the tangent by the frame delta
         * @param useQuaternion Specifies if quaternions are used
         */
        static _AddSplineTangent(tangentType, outputs, animationChannelTargetPath, interpolation, keyFrame, useQuaternion) {
            let tangent;
            const tangentValue = tangentType === _TangentType.INTANGENT ? keyFrame.inTangent : keyFrame.outTangent;
            if (interpolation === "CUBICSPLINE" /* AnimationSamplerInterpolation.CUBICSPLINE */) {
                if (animationChannelTargetPath === "rotation" /* AnimationChannelTargetPath.ROTATION */) {
                    if (tangentValue) {
                        if (useQuaternion) {
                            tangent = tangentValue.asArray();
                        }
                        else {
                            const array = tangentValue;
                            tangent = Quaternion.RotationYawPitchRoll(array.y, array.x, array.z).asArray();
                        }
                    }
                    else {
                        tangent = [0, 0, 0, 0];
                    }
                }
                else if (animationChannelTargetPath === "weights" /* AnimationChannelTargetPath.WEIGHTS */) {
                    if (tangentValue) {
                        tangent = [tangentValue];
                    }
                    else {
                        tangent = [0];
                    }
                }
                else {
                    if (tangentValue) {
                        tangent = tangentValue.asArray();
                    }
                    else {
                        tangent = [0, 0, 0];
                    }
                }
                outputs.push(tangent);
            }
        }
        /**
         * Get the minimum and maximum key frames' frame values
         * @param keyFrames animation key frames
         * @returns the minimum and maximum key frame value
         */
        static _CalculateMinMaxKeyFrames(keyFrames) {
            let min = Infinity;
            let max = -Infinity;
            keyFrames.forEach(function (keyFrame) {
                min = Math.min(min, keyFrame.frame);
                max = Math.max(max, keyFrame.frame);
            });
            return { min: min, max: max };
        }
    }

    /**
     * Class for holding and downloading glTF file data
     */
    class GLTFData {
        /**
         * Initializes the glTF file object
         */
        constructor() {
            this.glTFFiles = {};
        }
        /**
         * Downloads the glTF data as files based on their names and data
         */
        downloadFiles() {
            /**
             * Checks for a matching suffix at the end of a string (for ES5 and lower)
             * @param str Source string
             * @param suffix Suffix to search for in the source string
             * @returns Boolean indicating whether the suffix was found (true) or not (false)
             */
            function endsWith(str, suffix) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }
            for (const key in this.glTFFiles) {
                const link = document.createElement("a");
                document.body.appendChild(link);
                link.setAttribute("type", "hidden");
                link.download = key;
                const blob = this.glTFFiles[key];
                let mimeType;
                if (endsWith(key, ".glb")) {
                    mimeType = { type: "model/gltf-binary" };
                }
                else if (endsWith(key, ".bin")) {
                    mimeType = { type: "application/octet-stream" };
                }
                else if (endsWith(key, ".gltf")) {
                    mimeType = { type: "model/gltf+json" };
                }
                else if (endsWith(key, ".jpeg") || endsWith(key, ".jpg")) {
                    mimeType = { type: "image/jpeg" /* ImageMimeType.JPEG */ };
                }
                else if (endsWith(key, ".png")) {
                    mimeType = { type: "image/png" /* ImageMimeType.PNG */ };
                }
                link.href = window.URL.createObjectURL(new Blob([blob], mimeType));
                link.click();
            }
        }
    }

    ThinEngine.prototype.updateRawTexture = function (texture, data, format, invertY, compression = null, type = 0, useSRGBBuffer = false) {
        if (!texture) {
            return;
        }
        // Babylon's internalSizedFomat but gl's texImage2D internalFormat
        const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
        // Babylon's internalFormat but gl's texImage2D format
        const internalFormat = this._getInternalFormat(format);
        const textureType = this._getWebGLTextureType(type);
        this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
        this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
        if (!this._doNotHandleContextLost) {
            texture._bufferView = data;
            texture.format = format;
            texture.type = type;
            texture.invertY = invertY;
            texture._compression = compression;
        }
        if (texture.width % 4 !== 0) {
            this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1);
        }
        if (compression && data) {
            this._gl.compressedTexImage2D(this._gl.TEXTURE_2D, 0, this.getCaps().s3tc[compression], texture.width, texture.height, 0, data);
        }
        else {
            this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, data);
        }
        if (texture.generateMipMaps) {
            this._gl.generateMipmap(this._gl.TEXTURE_2D);
        }
        this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        //  this.resetTextureCache();
        texture.isReady = true;
    };
    ThinEngine.prototype.createRawTexture = function (data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    creationFlags = 0, useSRGBBuffer = false) {
        const texture = new InternalTexture(this, InternalTextureSource.Raw);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.format = format;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture._compression = compression;
        texture.type = type;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, !generateMipMaps);
        if (!this._doNotHandleContextLost) {
            texture._bufferView = data;
        }
        this.updateRawTexture(texture, data, format, invertY, compression, type, texture._useSRGBBuffer);
        this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
        // Filters
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, filters.mag);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, filters.min);
        if (generateMipMaps) {
            this._gl.generateMipmap(this._gl.TEXTURE_2D);
        }
        this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        this._internalTexturesCache.push(texture);
        return texture;
    };
    ThinEngine.prototype.createRawCubeTexture = function (data, size, format, type, generateMipMaps, invertY, samplingMode, compression = null) {
        const gl = this._gl;
        const texture = new InternalTexture(this, InternalTextureSource.CubeRaw);
        texture.isCube = true;
        texture.format = format;
        texture.type = type;
        if (!this._doNotHandleContextLost) {
            texture._bufferViewArray = data;
        }
        const textureType = this._getWebGLTextureType(type);
        let internalFormat = this._getInternalFormat(format);
        if (internalFormat === gl.RGB) {
            internalFormat = gl.RGBA;
        }
        // Mipmap generation needs a sized internal format that is both color-renderable and texture-filterable
        if (textureType === gl.FLOAT && !this._caps.textureFloatLinearFiltering) {
            generateMipMaps = false;
            samplingMode = 1;
            Logger.Warn("Float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
        }
        else if (textureType === this._gl.HALF_FLOAT_OES && !this._caps.textureHalfFloatLinearFiltering) {
            generateMipMaps = false;
            samplingMode = 1;
            Logger.Warn("Half float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
        }
        else if (textureType === gl.FLOAT && !this._caps.textureFloatRender) {
            generateMipMaps = false;
            Logger.Warn("Render to float textures is not supported. Mipmap generation forced to false.");
        }
        else if (textureType === gl.HALF_FLOAT && !this._caps.colorBufferFloat) {
            generateMipMaps = false;
            Logger.Warn("Render to half float textures is not supported. Mipmap generation forced to false.");
        }
        const width = size;
        const height = width;
        texture.width = width;
        texture.height = height;
        texture.invertY = invertY;
        texture._compression = compression;
        // Double check on POT to generate Mips.
        const isPot = !this.needPOTTextures || (Tools.IsExponentOfTwo(texture.width) && Tools.IsExponentOfTwo(texture.height));
        if (!isPot) {
            generateMipMaps = false;
        }
        // Upload data if needed. The texture won't be ready until then.
        if (data) {
            this.updateRawCubeTexture(texture, data, format, type, invertY, compression);
        }
        else {
            const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
            const level = 0;
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
            for (let faceIndex = 0; faceIndex < 6; faceIndex++) {
                if (compression) {
                    gl.compressedTexImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, this.getCaps().s3tc[compression], texture.width, texture.height, 0, undefined);
                }
                else {
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, null);
                }
            }
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
        }
        this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, texture, true);
        // Filters
        if (data && generateMipMaps) {
            this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
        }
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, filters.min);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.isReady = true;
        return texture;
    };
    ThinEngine.prototype.updateRawCubeTexture = function (texture, data, format, type, invertY, compression = null, level = 0) {
        texture._bufferViewArray = data;
        texture.format = format;
        texture.type = type;
        texture.invertY = invertY;
        texture._compression = compression;
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(type);
        let internalFormat = this._getInternalFormat(format);
        const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
        let needConversion = false;
        if (internalFormat === gl.RGB) {
            internalFormat = gl.RGBA;
            needConversion = true;
        }
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
        if (texture.width % 4 !== 0) {
            gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
        }
        // Data are known to be in +X +Y +Z -X -Y -Z
        for (let faceIndex = 0; faceIndex < 6; faceIndex++) {
            let faceData = data[faceIndex];
            if (compression) {
                gl.compressedTexImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, this.getCaps().s3tc[compression], texture.width, texture.height, 0, faceData);
            }
            else {
                if (needConversion) {
                    faceData = _convertRGBtoRGBATextureData(faceData, texture.width, texture.height, type);
                }
                gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, faceData);
            }
        }
        const isPot = !this.needPOTTextures || (Tools.IsExponentOfTwo(texture.width) && Tools.IsExponentOfTwo(texture.height));
        if (isPot && texture.generateMipMaps && level === 0) {
            this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
        }
        this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
        // this.resetTextureCache();
        texture.isReady = true;
    };
    ThinEngine.prototype.createRawCubeTextureFromUrl = function (url, scene, size, format, type, noMipmap, callback, mipmapGenerator, onLoad = null, onError = null, samplingMode = 3, invertY = false) {
        const gl = this._gl;
        const texture = this.createRawCubeTexture(null, size, format, type, !noMipmap, invertY, samplingMode, null);
        scene === null || scene === void 0 ? void 0 : scene.addPendingData(texture);
        texture.url = url;
        texture.isReady = false;
        this._internalTexturesCache.push(texture);
        const onerror = (request, exception) => {
            scene === null || scene === void 0 ? void 0 : scene.removePendingData(texture);
            if (onError && request) {
                onError(request.status + " " + request.statusText, exception);
            }
        };
        const internalCallback = (data) => {
            const width = texture.width;
            const faceDataArrays = callback(data);
            if (!faceDataArrays) {
                return;
            }
            if (mipmapGenerator) {
                const textureType = this._getWebGLTextureType(type);
                let internalFormat = this._getInternalFormat(format);
                const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
                let needConversion = false;
                if (internalFormat === gl.RGB) {
                    internalFormat = gl.RGBA;
                    needConversion = true;
                }
                this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
                this._unpackFlipY(false);
                const mipData = mipmapGenerator(faceDataArrays);
                for (let level = 0; level < mipData.length; level++) {
                    const mipSize = width >> level;
                    for (let faceIndex = 0; faceIndex < 6; faceIndex++) {
                        let mipFaceData = mipData[level][faceIndex];
                        if (needConversion) {
                            mipFaceData = _convertRGBtoRGBATextureData(mipFaceData, mipSize, mipSize, type);
                        }
                        gl.texImage2D(faceIndex, level, internalSizedFomat, mipSize, mipSize, 0, internalFormat, textureType, mipFaceData);
                    }
                }
                this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
            }
            else {
                this.updateRawCubeTexture(texture, faceDataArrays, format, type, invertY);
            }
            texture.isReady = true;
            // this.resetTextureCache();
            scene === null || scene === void 0 ? void 0 : scene.removePendingData(texture);
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
            if (onLoad) {
                onLoad();
            }
        };
        this._loadFile(url, (data) => {
            internalCallback(data);
        }, undefined, scene === null || scene === void 0 ? void 0 : scene.offlineProvider, true, onerror);
        return texture;
    };
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function _convertRGBtoRGBATextureData(rgbData, width, height, textureType) {
        // Create new RGBA data container.
        let rgbaData;
        let val1 = 1;
        if (textureType === 1) {
            rgbaData = new Float32Array(width * height * 4);
        }
        else if (textureType === 2) {
            rgbaData = new Uint16Array(width * height * 4);
            val1 = 15360; // 15360 is the encoding of 1 in half float
        }
        else if (textureType === 7) {
            rgbaData = new Uint32Array(width * height * 4);
        }
        else {
            rgbaData = new Uint8Array(width * height * 4);
        }
        // Convert each pixel.
        for (let x = 0; x < width; x++) {
            for (let y = 0; y < height; y++) {
                const index = (y * width + x) * 3;
                const newIndex = (y * width + x) * 4;
                // Map Old Value to new value.
                rgbaData[newIndex + 0] = rgbData[index + 0];
                rgbaData[newIndex + 1] = rgbData[index + 1];
                rgbaData[newIndex + 2] = rgbData[index + 2];
                // Add fully opaque alpha channel.
                rgbaData[newIndex + 3] = val1;
            }
        }
        return rgbaData;
    }
    /**
     * Create a function for createRawTexture3D/createRawTexture2DArray
     * @param is3D true for TEXTURE_3D and false for TEXTURE_2D_ARRAY
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function _makeCreateRawTextureFunction(is3D) {
        return function (data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
            const target = is3D ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY;
            const source = is3D ? InternalTextureSource.Raw3D : InternalTextureSource.Raw2DArray;
            const texture = new InternalTexture(this, source);
            texture.baseWidth = width;
            texture.baseHeight = height;
            texture.baseDepth = depth;
            texture.width = width;
            texture.height = height;
            texture.depth = depth;
            texture.format = format;
            texture.type = textureType;
            texture.generateMipMaps = generateMipMaps;
            texture.samplingMode = samplingMode;
            if (is3D) {
                texture.is3D = true;
            }
            else {
                texture.is2DArray = true;
            }
            if (!this._doNotHandleContextLost) {
                texture._bufferView = data;
            }
            if (is3D) {
                this.updateRawTexture3D(texture, data, format, invertY, compression, textureType);
            }
            else {
                this.updateRawTexture2DArray(texture, data, format, invertY, compression, textureType);
            }
            this._bindTextureDirectly(target, texture, true);
            // Filters
            const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
            this._gl.texParameteri(target, this._gl.TEXTURE_MAG_FILTER, filters.mag);
            this._gl.texParameteri(target, this._gl.TEXTURE_MIN_FILTER, filters.min);
            if (generateMipMaps) {
                this._gl.generateMipmap(target);
            }
            this._bindTextureDirectly(target, null);
            this._internalTexturesCache.push(texture);
            return texture;
        };
    }
    ThinEngine.prototype.createRawTexture2DArray = _makeCreateRawTextureFunction(false);
    ThinEngine.prototype.createRawTexture3D = _makeCreateRawTextureFunction(true);
    /**
     * Create a function for updateRawTexture3D/updateRawTexture2DArray
     * @param is3D true for TEXTURE_3D and false for TEXTURE_2D_ARRAY
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function _makeUpdateRawTextureFunction(is3D) {
        return function (texture, data, format, invertY, compression = null, textureType = 0) {
            const target = is3D ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY;
            const internalType = this._getWebGLTextureType(textureType);
            const internalFormat = this._getInternalFormat(format);
            const internalSizedFomat = this._getRGBABufferInternalSizedFormat(textureType, format);
            this._bindTextureDirectly(target, texture, true);
            this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
            if (!this._doNotHandleContextLost) {
                texture._bufferView = data;
                texture.format = format;
                texture.invertY = invertY;
                texture._compression = compression;
            }
            if (texture.width % 4 !== 0) {
                this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1);
            }
            if (compression && data) {
                this._gl.compressedTexImage3D(target, 0, this.getCaps().s3tc[compression], texture.width, texture.height, texture.depth, 0, data);
            }
            else {
                this._gl.texImage3D(target, 0, internalSizedFomat, texture.width, texture.height, texture.depth, 0, internalFormat, internalType, data);
            }
            if (texture.generateMipMaps) {
                this._gl.generateMipmap(target);
            }
            this._bindTextureDirectly(target, null);
            // this.resetTextureCache();
            texture.isReady = true;
        };
    }
    ThinEngine.prototype.updateRawTexture2DArray = _makeUpdateRawTextureFunction(false);
    ThinEngine.prototype.updateRawTexture3D = _makeUpdateRawTextureFunction(true);

    /**
     * Raw texture can help creating a texture directly from an array of data.
     * This can be super useful if you either get the data from an uncompressed source or
     * if you wish to create your texture pixel by pixel.
     */
    class RawTexture extends Texture {
        /**
         * Instantiates a new RawTexture.
         * Raw texture can help creating a texture directly from an array of data.
         * This can be super useful if you either get the data from an uncompressed source or
         * if you wish to create your texture pixel by pixel.
         * @param data define the array of data to use to create the texture (null to create an empty texture)
         * @param width define the width of the texture
         * @param height define the height of the texture
         * @param format define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps define whether mip maps should be generated or not
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
         */
        constructor(data, width, height, 
        /**
         * Define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
         */
        format, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags, useSRGBBuffer) {
            super(null, sceneOrEngine, !generateMipMaps, invertY, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, creationFlags);
            this.format = format;
            if (!this._engine) {
                return;
            }
            if (!this._engine._caps.textureFloatLinearFiltering && type === 1) {
                samplingMode = 1;
            }
            if (!this._engine._caps.textureHalfFloatLinearFiltering && type === 2) {
                samplingMode = 1;
            }
            this._texture = this._engine.createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, null, type, creationFlags !== null && creationFlags !== void 0 ? creationFlags : 0, useSRGBBuffer !== null && useSRGBBuffer !== void 0 ? useSRGBBuffer : false);
            this.wrapU = Texture.CLAMP_ADDRESSMODE;
            this.wrapV = Texture.CLAMP_ADDRESSMODE;
        }
        /**
         * Updates the texture underlying data.
         * @param data Define the new data of the texture
         */
        update(data) {
            this._getEngine().updateRawTexture(this._texture, data, this._texture.format, this._texture.invertY, null, this._texture.type, this._texture._useSRGBBuffer);
        }
        /**
         * Creates a luminance texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @returns the luminance texture
         */
        static CreateLuminanceTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
            return new RawTexture(data, width, height, 1, sceneOrEngine, generateMipMaps, invertY, samplingMode);
        }
        /**
         * Creates a luminance alpha texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @returns the luminance alpha texture
         */
        static CreateLuminanceAlphaTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
            return new RawTexture(data, width, height, 2, sceneOrEngine, generateMipMaps, invertY, samplingMode);
        }
        /**
         * Creates an alpha texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @returns the alpha texture
         */
        static CreateAlphaTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
            return new RawTexture(data, width, height, 0, sceneOrEngine, generateMipMaps, invertY, samplingMode);
        }
        /**
         * Creates a RGB texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
         * @returns the RGB alpha texture
         */
        static CreateRGBTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags = 0, useSRGBBuffer = false) {
            return new RawTexture(data, width, height, 4, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, creationFlags, useSRGBBuffer);
        }
        /**
         * Creates a RGBA texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
         * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
         * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
         * @returns the RGBA texture
         */
        static CreateRGBATexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags = 0, useSRGBBuffer = false) {
            return new RawTexture(data, width, height, 5, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, creationFlags, useSRGBBuffer);
        }
        /**
         * Creates a RGBA storage texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
         * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
         * @returns the RGBA texture
         */
        static CreateRGBAStorageTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, useSRGBBuffer = false) {
            return new RawTexture(data, width, height, 5, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, 1, useSRGBBuffer);
        }
        /**
         * Creates a R texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
         * @returns the R texture
         */
        static CreateRTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, type = 1) {
            return new RawTexture(data, width, height, 6, sceneOrEngine, generateMipMaps, invertY, samplingMode, type);
        }
        /**
         * Creates a R storage texture from some data.
         * @param data Define the texture data
         * @param width Define the width of the texture
         * @param height Define the height of the texture
         * @param sceneOrEngine defines the scene or engine the texture will belong to
         * @param generateMipMaps Define whether or not to create mip maps for the texture
         * @param invertY define if the data should be flipped on Y when uploaded to the GPU
         * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
         * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
         * @returns the R texture
         */
        static CreateRStorageTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = Texture.TRILINEAR_SAMPLINGMODE, type = 1) {
            return new RawTexture(data, width, height, 6, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, 1);
        }
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    /** Defines the cross module used constants to avoid circular dependencies */
    class Constants {
    }
    /** Defines that alpha blending is disabled */
    Constants.ALPHA_DISABLE = 0;
    /** Defines that alpha blending is SRC ALPHA * SRC + DEST */
    Constants.ALPHA_ADD = 1;
    /** Defines that alpha blending is SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */
    Constants.ALPHA_COMBINE = 2;
    /** Defines that alpha blending is DEST - SRC * DEST */
    Constants.ALPHA_SUBTRACT = 3;
    /** Defines that alpha blending is SRC * DEST */
    Constants.ALPHA_MULTIPLY = 4;
    /** Defines that alpha blending is SRC ALPHA * SRC + (1 - SRC) * DEST */
    Constants.ALPHA_MAXIMIZED = 5;
    /** Defines that alpha blending is SRC + DEST */
    Constants.ALPHA_ONEONE = 6;
    /** Defines that alpha blending is SRC + (1 - SRC ALPHA) * DEST */
    Constants.ALPHA_PREMULTIPLIED = 7;
    /**
     * Defines that alpha blending is SRC + (1 - SRC ALPHA) * DEST
     * Alpha will be set to (1 - SRC ALPHA) * DEST ALPHA
     */
    Constants.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
    /** Defines that alpha blending is CST * SRC + (1 - CST) * DEST */
    Constants.ALPHA_INTERPOLATE = 9;
    /**
     * Defines that alpha blending is SRC + (1 - SRC) * DEST
     * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DEST ALPHA
     */
    Constants.ALPHA_SCREENMODE = 10;
    /**
     * Defines that alpha blending is SRC + DST
     * Alpha will be set to SRC ALPHA + DST ALPHA
     */
    Constants.ALPHA_ONEONE_ONEONE = 11;
    /**
     * Defines that alpha blending is SRC * DST ALPHA + DST
     * Alpha will be set to 0
     */
    Constants.ALPHA_ALPHATOCOLOR = 12;
    /**
     * Defines that alpha blending is SRC * (1 - DST) + DST * (1 - SRC)
     */
    Constants.ALPHA_REVERSEONEMINUS = 13;
    /**
     * Defines that alpha blending is SRC + DST * (1 - SRC ALPHA)
     * Alpha will be set to SRC ALPHA + DST ALPHA * (1 - SRC ALPHA)
     */
    Constants.ALPHA_SRC_DSTONEMINUSSRCALPHA = 14;
    /**
     * Defines that alpha blending is SRC + DST
     * Alpha will be set to SRC ALPHA
     */
    Constants.ALPHA_ONEONE_ONEZERO = 15;
    /**
     * Defines that alpha blending is SRC * (1 - DST) + DST * (1 - SRC)
     * Alpha will be set to DST ALPHA
     */
    Constants.ALPHA_EXCLUSION = 16;
    /**
     * Defines that alpha blending is SRC * SRC ALPHA + DST * (1 - SRC ALPHA)
     * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DST ALPHA
     */
    Constants.ALPHA_LAYER_ACCUMULATE = 17;
    /** Defines that alpha blending equation a SUM */
    Constants.ALPHA_EQUATION_ADD = 0;
    /** Defines that alpha blending equation a SUBSTRACTION */
    Constants.ALPHA_EQUATION_SUBSTRACT = 1;
    /** Defines that alpha blending equation a REVERSE SUBSTRACTION */
    Constants.ALPHA_EQUATION_REVERSE_SUBTRACT = 2;
    /** Defines that alpha blending equation a MAX operation */
    Constants.ALPHA_EQUATION_MAX = 3;
    /** Defines that alpha blending equation a MIN operation */
    Constants.ALPHA_EQUATION_MIN = 4;
    /**
     * Defines that alpha blending equation a DARKEN operation:
     * It takes the min of the src and sums the alpha channels.
     */
    Constants.ALPHA_EQUATION_DARKEN = 5;
    /** Defines that the resource is not delayed*/
    Constants.DELAYLOADSTATE_NONE = 0;
    /** Defines that the resource was successfully delay loaded */
    Constants.DELAYLOADSTATE_LOADED = 1;
    /** Defines that the resource is currently delay loading */
    Constants.DELAYLOADSTATE_LOADING = 2;
    /** Defines that the resource is delayed and has not started loading */
    Constants.DELAYLOADSTATE_NOTLOADED = 4;
    // Depth or Stencil test Constants.
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass. i.e. Nothing will be drawn */
    Constants.NEVER = 0x0200;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */
    Constants.ALWAYS = 0x0207;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value */
    Constants.LESS = 0x0201;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value */
    Constants.EQUAL = 0x0202;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value */
    Constants.LEQUAL = 0x0203;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value */
    Constants.GREATER = 0x0204;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value */
    Constants.GEQUAL = 0x0206;
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value */
    Constants.NOTEQUAL = 0x0205;
    // Stencil Actions Constants.
    /** Passed to stencilOperation to specify that stencil value must be kept */
    Constants.KEEP = 0x1e00;
    /** Passed to stencilOperation to specify that stencil value must be zero */
    Constants.ZERO = 0x0000;
    /** Passed to stencilOperation to specify that stencil value must be replaced */
    Constants.REPLACE = 0x1e01;
    /** Passed to stencilOperation to specify that stencil value must be incremented */
    Constants.INCR = 0x1e02;
    /** Passed to stencilOperation to specify that stencil value must be decremented */
    Constants.DECR = 0x1e03;
    /** Passed to stencilOperation to specify that stencil value must be inverted */
    Constants.INVERT = 0x150a;
    /** Passed to stencilOperation to specify that stencil value must be incremented with wrapping */
    Constants.INCR_WRAP = 0x8507;
    /** Passed to stencilOperation to specify that stencil value must be decremented with wrapping */
    Constants.DECR_WRAP = 0x8508;
    /** Texture is not repeating outside of 0..1 UVs */
    Constants.TEXTURE_CLAMP_ADDRESSMODE = 0;
    /** Texture is repeating outside of 0..1 UVs */
    Constants.TEXTURE_WRAP_ADDRESSMODE = 1;
    /** Texture is repeating and mirrored */
    Constants.TEXTURE_MIRROR_ADDRESSMODE = 2;
    /** Flag to create a storage texture */
    Constants.TEXTURE_CREATIONFLAG_STORAGE = 1;
    /** ALPHA */
    Constants.TEXTUREFORMAT_ALPHA = 0;
    /** LUMINANCE */
    Constants.TEXTUREFORMAT_LUMINANCE = 1;
    /** LUMINANCE_ALPHA */
    Constants.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
    /** RGB */
    Constants.TEXTUREFORMAT_RGB = 4;
    /** RGBA */
    Constants.TEXTUREFORMAT_RGBA = 5;
    /** RED */
    Constants.TEXTUREFORMAT_RED = 6;
    /** RED (2nd reference) */
    Constants.TEXTUREFORMAT_R = 6;
    /** RG */
    Constants.TEXTUREFORMAT_RG = 7;
    /** RED_INTEGER */
    Constants.TEXTUREFORMAT_RED_INTEGER = 8;
    /** RED_INTEGER (2nd reference) */
    Constants.TEXTUREFORMAT_R_INTEGER = 8;
    /** RG_INTEGER */
    Constants.TEXTUREFORMAT_RG_INTEGER = 9;
    /** RGB_INTEGER */
    Constants.TEXTUREFORMAT_RGB_INTEGER = 10;
    /** RGBA_INTEGER */
    Constants.TEXTUREFORMAT_RGBA_INTEGER = 11;
    /** BGRA */
    Constants.TEXTUREFORMAT_BGRA = 12;
    /** Depth 24 bits + Stencil 8 bits */
    Constants.TEXTUREFORMAT_DEPTH24_STENCIL8 = 13;
    /** Depth 32 bits float */
    Constants.TEXTUREFORMAT_DEPTH32_FLOAT = 14;
    /** Depth 16 bits */
    Constants.TEXTUREFORMAT_DEPTH16 = 15;
    /** Depth 24 bits */
    Constants.TEXTUREFORMAT_DEPTH24 = 16;
    /** Depth 24 bits unorm + Stencil 8 bits */
    Constants.TEXTUREFORMAT_DEPTH24UNORM_STENCIL8 = 17;
    /** Depth 32 bits float + Stencil 8 bits */
    Constants.TEXTUREFORMAT_DEPTH32FLOAT_STENCIL8 = 18;
    /** Stencil 8 bits */
    Constants.TEXTUREFORMAT_STENCIL8 = 19;
    /** Compressed BC7 */
    Constants.TEXTUREFORMAT_COMPRESSED_RGBA_BPTC_UNORM = 36492;
    /** Compressed BC7 (SRGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_BPTC_UNORM = 36493;
    /** Compressed BC6 unsigned float */
    Constants.TEXTUREFORMAT_COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT = 36495;
    /** Compressed BC6 signed float */
    Constants.TEXTUREFORMAT_COMPRESSED_RGB_BPTC_SIGNED_FLOAT = 36494;
    /** Compressed BC3 */
    Constants.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT5 = 33779;
    /** Compressed BC3 (SRGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919;
    /** Compressed BC2 */
    Constants.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT3 = 33778;
    /** Compressed BC2 (SRGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918;
    /** Compressed BC1 (RGBA) */
    Constants.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT1 = 33777;
    /** Compressed BC1 (RGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_RGB_S3TC_DXT1 = 33776;
    /** Compressed BC1 (SRGB+A) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917;
    /** Compressed BC1 (SRGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916;
    /** Compressed ASTC 4x4 */
    Constants.TEXTUREFORMAT_COMPRESSED_RGBA_ASTC_4x4 = 37808;
    /** Compressed ASTC 4x4 (SRGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = 37840;
    /** Compressed ETC1 (RGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_RGB_ETC1_WEBGL = 36196;
    /** Compressed ETC2 (RGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_RGB8_ETC2 = 37492;
    /** Compressed ETC2 (SRGB) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB8_ETC2 = 37493;
    /** Compressed ETC2 (RGB+A1) */
    Constants.TEXTUREFORMAT_COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494;
    /** Compressed ETC2 (SRGB+A1)*/
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495;
    /** Compressed ETC2 (RGB+A) */
    Constants.TEXTUREFORMAT_COMPRESSED_RGBA8_ETC2_EAC = 37496;
    /** Compressed ETC2 (SRGB+1) */
    Constants.TEXTUREFORMAT_COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497;
    /** UNSIGNED_BYTE */
    Constants.TEXTURETYPE_UNSIGNED_BYTE = 0;
    /** UNSIGNED_BYTE (2nd reference) */
    Constants.TEXTURETYPE_UNSIGNED_INT = 0;
    /** FLOAT */
    Constants.TEXTURETYPE_FLOAT = 1;
    /** HALF_FLOAT */
    Constants.TEXTURETYPE_HALF_FLOAT = 2;
    /** BYTE */
    Constants.TEXTURETYPE_BYTE = 3;
    /** SHORT */
    Constants.TEXTURETYPE_SHORT = 4;
    /** UNSIGNED_SHORT */
    Constants.TEXTURETYPE_UNSIGNED_SHORT = 5;
    /** INT */
    Constants.TEXTURETYPE_INT = 6;
    /** UNSIGNED_INT */
    Constants.TEXTURETYPE_UNSIGNED_INTEGER = 7;
    /** UNSIGNED_SHORT_4_4_4_4 */
    Constants.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
    /** UNSIGNED_SHORT_5_5_5_1 */
    Constants.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
    /** UNSIGNED_SHORT_5_6_5 */
    Constants.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
    /** UNSIGNED_INT_2_10_10_10_REV */
    Constants.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
    /** UNSIGNED_INT_24_8 */
    Constants.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
    /** UNSIGNED_INT_10F_11F_11F_REV */
    Constants.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
    /** UNSIGNED_INT_5_9_9_9_REV */
    Constants.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
    /** FLOAT_32_UNSIGNED_INT_24_8_REV */
    Constants.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
    /** UNDEFINED */
    Constants.TEXTURETYPE_UNDEFINED = 16;
    /** 2D Texture target*/
    Constants.TEXTURE_2D = 3553;
    /** 2D Array Texture target */
    Constants.TEXTURE_2D_ARRAY = 35866;
    /** Cube Map Texture target */
    Constants.TEXTURE_CUBE_MAP = 34067;
    /** Cube Map Array Texture target */
    Constants.TEXTURE_CUBE_MAP_ARRAY = 0xdeadbeef;
    /** 3D Texture target */
    Constants.TEXTURE_3D = 32879;
    /** nearest is mag = nearest and min = nearest and no mip */
    Constants.TEXTURE_NEAREST_SAMPLINGMODE = 1;
    /** mag = nearest and min = nearest and mip = none */
    Constants.TEXTURE_NEAREST_NEAREST = 1;
    /** Bilinear is mag = linear and min = linear and no mip */
    Constants.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
    /** mag = linear and min = linear and mip = none */
    Constants.TEXTURE_LINEAR_LINEAR = 2;
    /** Trilinear is mag = linear and min = linear and mip = linear */
    Constants.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
    /** Trilinear is mag = linear and min = linear and mip = linear */
    Constants.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
    /** mag = nearest and min = nearest and mip = nearest */
    Constants.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
    /** mag = nearest and min = linear and mip = nearest */
    Constants.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
    /** mag = nearest and min = linear and mip = linear */
    Constants.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
    /** mag = nearest and min = linear and mip = none */
    Constants.TEXTURE_NEAREST_LINEAR = 7;
    /** nearest is mag = nearest and min = nearest and mip = linear */
    Constants.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
    /** mag = linear and min = nearest and mip = nearest */
    Constants.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
    /** mag = linear and min = nearest and mip = linear */
    Constants.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
    /** Bilinear is mag = linear and min = linear and mip = nearest */
    Constants.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
    /** mag = linear and min = nearest and mip = none */
    Constants.TEXTURE_LINEAR_NEAREST = 12;
    /** Explicit coordinates mode */
    Constants.TEXTURE_EXPLICIT_MODE = 0;
    /** Spherical coordinates mode */
    Constants.TEXTURE_SPHERICAL_MODE = 1;
    /** Planar coordinates mode */
    Constants.TEXTURE_PLANAR_MODE = 2;
    /** Cubic coordinates mode */
    Constants.TEXTURE_CUBIC_MODE = 3;
    /** Projection coordinates mode */
    Constants.TEXTURE_PROJECTION_MODE = 4;
    /** Skybox coordinates mode */
    Constants.TEXTURE_SKYBOX_MODE = 5;
    /** Inverse Cubic coordinates mode */
    Constants.TEXTURE_INVCUBIC_MODE = 6;
    /** Equirectangular coordinates mode */
    Constants.TEXTURE_EQUIRECTANGULAR_MODE = 7;
    /** Equirectangular Fixed coordinates mode */
    Constants.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
    /** Equirectangular Fixed Mirrored coordinates mode */
    Constants.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
    /** Offline (baking) quality for texture filtering */
    Constants.TEXTURE_FILTERING_QUALITY_OFFLINE = 4096;
    /** High quality for texture filtering */
    Constants.TEXTURE_FILTERING_QUALITY_HIGH = 64;
    /** Medium quality for texture filtering */
    Constants.TEXTURE_FILTERING_QUALITY_MEDIUM = 16;
    /** Low quality for texture filtering */
    Constants.TEXTURE_FILTERING_QUALITY_LOW = 8;
    // Texture rescaling mode
    /** Defines that texture rescaling will use a floor to find the closer power of 2 size */
    Constants.SCALEMODE_FLOOR = 1;
    /** Defines that texture rescaling will look for the nearest power of 2 size */
    Constants.SCALEMODE_NEAREST = 2;
    /** Defines that texture rescaling will use a ceil to find the closer power of 2 size */
    Constants.SCALEMODE_CEILING = 3;
    /**
     * The dirty texture flag value
     */
    Constants.MATERIAL_TextureDirtyFlag = 1;
    /**
     * The dirty light flag value
     */
    Constants.MATERIAL_LightDirtyFlag = 2;
    /**
     * The dirty fresnel flag value
     */
    Constants.MATERIAL_FresnelDirtyFlag = 4;
    /**
     * The dirty attribute flag value
     */
    Constants.MATERIAL_AttributesDirtyFlag = 8;
    /**
     * The dirty misc flag value
     */
    Constants.MATERIAL_MiscDirtyFlag = 16;
    /**
     * The dirty prepass flag value
     */
    Constants.MATERIAL_PrePassDirtyFlag = 32;
    /**
     * The all dirty flag value
     */
    Constants.MATERIAL_AllDirtyFlag = 63;
    /**
     * Returns the triangle fill mode
     */
    Constants.MATERIAL_TriangleFillMode = 0;
    /**
     * Returns the wireframe mode
     */
    Constants.MATERIAL_WireFrameFillMode = 1;
    /**
     * Returns the point fill mode
     */
    Constants.MATERIAL_PointFillMode = 2;
    /**
     * Returns the point list draw mode
     */
    Constants.MATERIAL_PointListDrawMode = 3;
    /**
     * Returns the line list draw mode
     */
    Constants.MATERIAL_LineListDrawMode = 4;
    /**
     * Returns the line loop draw mode
     */
    Constants.MATERIAL_LineLoopDrawMode = 5;
    /**
     * Returns the line strip draw mode
     */
    Constants.MATERIAL_LineStripDrawMode = 6;
    /**
     * Returns the triangle strip draw mode
     */
    Constants.MATERIAL_TriangleStripDrawMode = 7;
    /**
     * Returns the triangle fan draw mode
     */
    Constants.MATERIAL_TriangleFanDrawMode = 8;
    /**
     * Stores the clock-wise side orientation
     */
    Constants.MATERIAL_ClockWiseSideOrientation = 0;
    /**
     * Stores the counter clock-wise side orientation
     */
    Constants.MATERIAL_CounterClockWiseSideOrientation = 1;
    /**
     * Nothing
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_NothingTrigger = 0;
    /**
     * On pick
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnPickTrigger = 1;
    /**
     * On left pick
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnLeftPickTrigger = 2;
    /**
     * On right pick
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnRightPickTrigger = 3;
    /**
     * On center pick
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnCenterPickTrigger = 4;
    /**
     * On pick down
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnPickDownTrigger = 5;
    /**
     * On double pick
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnDoublePickTrigger = 6;
    /**
     * On pick up
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnPickUpTrigger = 7;
    /**
     * On pick out.
     * This trigger will only be raised if you also declared a OnPickDown
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnPickOutTrigger = 16;
    /**
     * On long press
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnLongPressTrigger = 8;
    /**
     * On pointer over
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnPointerOverTrigger = 9;
    /**
     * On pointer out
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnPointerOutTrigger = 10;
    /**
     * On every frame
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnEveryFrameTrigger = 11;
    /**
     * On intersection enter
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnIntersectionEnterTrigger = 12;
    /**
     * On intersection exit
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnIntersectionExitTrigger = 13;
    /**
     * On key down
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnKeyDownTrigger = 14;
    /**
     * On key up
     * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
     */
    Constants.ACTION_OnKeyUpTrigger = 15;
    /**
     * Billboard mode will only apply to Y axis
     */
    Constants.PARTICLES_BILLBOARDMODE_Y = 2;
    /**
     * Billboard mode will apply to all axes
     */
    Constants.PARTICLES_BILLBOARDMODE_ALL = 7;
    /**
     * Special billboard mode where the particle will be biilboard to the camera but rotated to align with direction
     */
    Constants.PARTICLES_BILLBOARDMODE_STRETCHED = 8;
    /**
     * Special billboard mode where the particle will be billboard to the camera but only around the axis of the direction of particle emission
     */
    Constants.PARTICLES_BILLBOARDMODE_STRETCHED_LOCAL = 9;
    /** Default culling strategy : this is an exclusion test and it's the more accurate.
     *  Test order :
     *  Is the bounding sphere outside the frustum ?
     *  If not, are the bounding box vertices outside the frustum ?
     *  It not, then the cullable object is in the frustum.
     */
    Constants.MESHES_CULLINGSTRATEGY_STANDARD = 0;
    /** Culling strategy : Bounding Sphere Only.
     *  This is an exclusion test. It's faster than the standard strategy because the bounding box is not tested.
     *  It's also less accurate than the standard because some not visible objects can still be selected.
     *  Test : is the bounding sphere outside the frustum ?
     *  If not, then the cullable object is in the frustum.
     */
    Constants.MESHES_CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
    /** Culling strategy : Optimistic Inclusion.
     *  This in an inclusion test first, then the standard exclusion test.
     *  This can be faster when a cullable object is expected to be almost always in the camera frustum.
     *  This could also be a little slower than the standard test when the tested object center is not the frustum but one of its bounding box vertex is still inside.
     *  Anyway, it's as accurate as the standard strategy.
     *  Test :
     *  Is the cullable object bounding sphere center in the frustum ?
     *  If not, apply the default culling strategy.
     */
    Constants.MESHES_CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
    /** Culling strategy : Optimistic Inclusion then Bounding Sphere Only.
     *  This in an inclusion test first, then the bounding sphere only exclusion test.
     *  This can be the fastest test when a cullable object is expected to be almost always in the camera frustum.
     *  This could also be a little slower than the BoundingSphereOnly strategy when the tested object center is not in the frustum but its bounding sphere still intersects it.
     *  It's less accurate than the standard strategy and as accurate as the BoundingSphereOnly strategy.
     *  Test :
     *  Is the cullable object bounding sphere center in the frustum ?
     *  If not, apply the Bounding Sphere Only strategy. No Bounding Box is tested here.
     */
    Constants.MESHES_CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
    /**
     * No logging while loading
     */
    Constants.SCENELOADER_NO_LOGGING = 0;
    /**
     * Minimal logging while loading
     */
    Constants.SCENELOADER_MINIMAL_LOGGING = 1;
    /**
     * Summary logging while loading
     */
    Constants.SCENELOADER_SUMMARY_LOGGING = 2;
    /**
     * Detailed logging while loading
     */
    Constants.SCENELOADER_DETAILED_LOGGING = 3;
    /**
     * Constant used to retrieve the irradiance texture index in the textures array in the prepass
     * using getIndex(Constants.PREPASS_IRRADIANCE_TEXTURE_TYPE)
     */
    Constants.PREPASS_IRRADIANCE_TEXTURE_TYPE = 0;
    /**
     * Constant used to retrieve the position texture index in the textures array in the prepass
     * using getIndex(Constants.PREPASS_POSITION_TEXTURE_INDEX)
     */
    Constants.PREPASS_POSITION_TEXTURE_TYPE = 1;
    /**
     * Constant used to retrieve the velocity texture index in the textures array in the prepass
     * using getIndex(Constants.PREPASS_VELOCITY_TEXTURE_INDEX)
     */
    Constants.PREPASS_VELOCITY_TEXTURE_TYPE = 2;
    /**
     * Constant used to retrieve the reflectivity texture index in the textures array in the prepass
     * using the getIndex(Constants.PREPASS_REFLECTIVITY_TEXTURE_TYPE)
     */
    Constants.PREPASS_REFLECTIVITY_TEXTURE_TYPE = 3;
    /**
     * Constant used to retrieve the lit color texture index in the textures array in the prepass
     * using the getIndex(Constants.PREPASS_COLOR_TEXTURE_TYPE)
     */
    Constants.PREPASS_COLOR_TEXTURE_TYPE = 4;
    /**
     * Constant used to retrieve depth index in the textures array in the prepass
     * using the getIndex(Constants.PREPASS_DEPTH_TEXTURE_TYPE)
     */
    Constants.PREPASS_DEPTH_TEXTURE_TYPE = 5;
    /**
     * Constant used to retrieve normal index in the textures array in the prepass
     * using the getIndex(Constants.PREPASS_NORMAL_TEXTURE_TYPE)
     */
    Constants.PREPASS_NORMAL_TEXTURE_TYPE = 6;
    /**
     * Constant used to retrieve albedo index in the textures array in the prepass
     * using the getIndex(Constants.PREPASS_ALBEDO_SQRT_TEXTURE_TYPE)
     */
    Constants.PREPASS_ALBEDO_SQRT_TEXTURE_TYPE = 7;
    /** Flag to create a readable buffer (the buffer can be the source of a copy) */
    Constants.BUFFER_CREATIONFLAG_READ = 1;
    /** Flag to create a writable buffer (the buffer can be the destination of a copy) */
    Constants.BUFFER_CREATIONFLAG_WRITE = 2;
    /** Flag to create a readable and writable buffer */
    Constants.BUFFER_CREATIONFLAG_READWRITE = 3;
    /** Flag to create a buffer suitable to be used as a uniform buffer */
    Constants.BUFFER_CREATIONFLAG_UNIFORM = 4;
    /** Flag to create a buffer suitable to be used as a vertex buffer */
    Constants.BUFFER_CREATIONFLAG_VERTEX = 8;
    /** Flag to create a buffer suitable to be used as an index buffer */
    Constants.BUFFER_CREATIONFLAG_INDEX = 16;
    /** Flag to create a buffer suitable to be used as a storage buffer */
    Constants.BUFFER_CREATIONFLAG_STORAGE = 32;
    /**
     * Prefixes used by the engine for sub mesh draw wrappers
     */
    /** @internal */
    Constants.RENDERPASS_MAIN = 0;
    /**
     * Constant used as key code for Alt key
     */
    Constants.INPUT_ALT_KEY = 18;
    /**
     * Constant used as key code for Ctrl key
     */
    Constants.INPUT_CTRL_KEY = 17;
    /**
     * Constant used as key code for Meta key (Left Win, Left Cmd)
     */
    Constants.INPUT_META_KEY1 = 91;
    /**
     * Constant used as key code for Meta key (Right Win)
     */
    Constants.INPUT_META_KEY2 = 92;
    /**
     * Constant used as key code for Meta key (Right Win, Right Cmd)
     */
    Constants.INPUT_META_KEY3 = 93;
    /**
     * Constant used as key code for Shift key
     */
    Constants.INPUT_SHIFT_KEY = 16;
    /** Standard snapshot rendering. In this mode, some form of dynamic behavior is possible (for eg, uniform buffers are still updated) */
    Constants.SNAPSHOTRENDERING_STANDARD = 0;
    /** Fast snapshot rendering. In this mode, everything is static and only some limited form of dynamic behaviour is possible */
    Constants.SNAPSHOTRENDERING_FAST = 1;
    /**
     * This is the default projection mode used by the cameras.
     * It helps recreating a feeling of perspective and better appreciate depth.
     * This is the best way to simulate real life cameras.
     */
    Constants.PERSPECTIVE_CAMERA = 0;
    /**
     * This helps creating camera with an orthographic mode.
     * Orthographic is commonly used in engineering as a means to produce object specifications that communicate dimensions unambiguously, each line of 1 unit length (cm, meter..whatever) will appear to have the same length everywhere on the drawing. This allows the drafter to dimension only a subset of lines and let the reader know that other lines of that length on the drawing are also that length in reality. Every parallel line in the drawing is also parallel in the object.
     */
    Constants.ORTHOGRAPHIC_CAMERA = 1;
    /**
     * This is the default FOV mode for perspective cameras.
     * This setting aligns the upper and lower bounds of the viewport to the upper and lower bounds of the camera frustum.
     */
    Constants.FOVMODE_VERTICAL_FIXED = 0;
    /**
     * This setting aligns the left and right bounds of the viewport to the left and right bounds of the camera frustum.
     */
    Constants.FOVMODE_HORIZONTAL_FIXED = 1;
    /**
     * This specifies there is no need for a camera rig.
     * Basically only one eye is rendered corresponding to the camera.
     */
    Constants.RIG_MODE_NONE = 0;
    /**
     * Simulates a camera Rig with one blue eye and one red eye.
     * This can be use with 3d blue and red glasses.
     */
    Constants.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
    /**
     * Defines that both eyes of the camera will be rendered side by side with a parallel target.
     */
    Constants.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
    /**
     * Defines that both eyes of the camera will be rendered side by side with a none parallel target.
     */
    Constants.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
    /**
     * Defines that both eyes of the camera will be rendered over under each other.
     */
    Constants.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
    /**
     * Defines that both eyes of the camera will be rendered on successive lines interlaced for passive 3d monitors.
     */
    Constants.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
    /**
     * Defines that both eyes of the camera should be renderered in a VR mode (carbox).
     */
    Constants.RIG_MODE_VR = 20;
    /**
     * Defines that both eyes of the camera should be renderered in a VR mode (webVR).
     */
    Constants.RIG_MODE_WEBVR = 21;
    /**
     * Custom rig mode allowing rig cameras to be populated manually with any number of cameras
     */
    Constants.RIG_MODE_CUSTOM = 22;
    /**
     * Maximum number of uv sets supported
     */
    Constants.MAX_SUPPORTED_UV_SETS = 6;
    /**
     * GL constants
     */
    /** Alpha blend equation: ADD */
    Constants.GL_ALPHA_EQUATION_ADD = 0x8006;
    /** Alpha equation: MIN */
    Constants.GL_ALPHA_EQUATION_MIN = 0x8007;
    /** Alpha equation: MAX */
    Constants.GL_ALPHA_EQUATION_MAX = 0x8008;
    /** Alpha equation: SUBTRACT */
    Constants.GL_ALPHA_EQUATION_SUBTRACT = 0x800a;
    /** Alpha equation: REVERSE_SUBTRACT */
    Constants.GL_ALPHA_EQUATION_REVERSE_SUBTRACT = 0x800b;
    /** Alpha blend function: SRC */
    Constants.GL_ALPHA_FUNCTION_SRC = 0x0300;
    /** Alpha blend function: ONE_MINUS_SRC */
    Constants.GL_ALPHA_FUNCTION_ONE_MINUS_SRC_COLOR = 0x0301;
    /** Alpha blend function: SRC_ALPHA */
    Constants.GL_ALPHA_FUNCTION_SRC_ALPHA = 0x0302;
    /** Alpha blend function: ONE_MINUS_SRC_ALPHA */
    Constants.GL_ALPHA_FUNCTION_ONE_MINUS_SRC_ALPHA = 0x0303;
    /** Alpha blend function: DST_ALPHA */
    Constants.GL_ALPHA_FUNCTION_DST_ALPHA = 0x0304;
    /** Alpha blend function: ONE_MINUS_DST_ALPHA */
    Constants.GL_ALPHA_FUNCTION_ONE_MINUS_DST_ALPHA = 0x0305;
    /** Alpha blend function: ONE_MINUS_DST */
    Constants.GL_ALPHA_FUNCTION_DST_COLOR = 0x0306;
    /** Alpha blend function: ONE_MINUS_DST */
    Constants.GL_ALPHA_FUNCTION_ONE_MINUS_DST_COLOR = 0x0307;
    /** Alpha blend function: SRC_ALPHA_SATURATED */
    Constants.GL_ALPHA_FUNCTION_SRC_ALPHA_SATURATED = 0x0308;
    /** Alpha blend function: CONSTANT */
    Constants.GL_ALPHA_FUNCTION_CONSTANT_COLOR = 0x8001;
    /** Alpha blend function: ONE_MINUS_CONSTANT */
    Constants.GL_ALPHA_FUNCTION_ONE_MINUS_CONSTANT_COLOR = 0x8002;
    /** Alpha blend function: CONSTANT_ALPHA */
    Constants.GL_ALPHA_FUNCTION_CONSTANT_ALPHA = 0x8003;
    /** Alpha blend function: ONE_MINUS_CONSTANT_ALPHA */
    Constants.GL_ALPHA_FUNCTION_ONE_MINUS_CONSTANT_ALPHA = 0x8004;
    /** URL to the snippet server. Points to the public snippet server by default */
    Constants.SnippetUrl = "https://snippet.babylonjs.com";

    function getFileExtensionFromMimeType(mimeType) {
        switch (mimeType) {
            case "image/jpeg" /* ImageMimeType.JPEG */:
                return ".jpg";
            case "image/png" /* ImageMimeType.PNG */:
                return ".png";
            case "image/webp" /* ImageMimeType.WEBP */:
                return ".webp";
        }
    }
    /**
     * Utility methods for working with glTF material conversion properties.  This class should only be used internally
     * @internal
     */
    class _GLTFMaterialExporter {
        constructor(exporter) {
            /**
             * Mapping to store textures
             */
            this._textureMap = {};
            // Mapping of internal textures to images to avoid exporting duplicate images.
            this._internalTextureToImage = {};
            this._textureMap = {};
            this._exporter = exporter;
        }
        /**
         * Specifies if two colors are approximately equal in value
         * @param color1 first color to compare to
         * @param color2 second color to compare to
         * @param epsilon threshold value
         */
        static _FuzzyEquals(color1, color2, epsilon) {
            return Scalar.WithinEpsilon(color1.r, color2.r, epsilon) && Scalar.WithinEpsilon(color1.g, color2.g, epsilon) && Scalar.WithinEpsilon(color1.b, color2.b, epsilon);
        }
        /**
         * Gets the materials from a Babylon scene and converts them to glTF materials
         * @param exportMaterials
         * @param mimeType texture mime type
         * @param hasTextureCoords specifies if texture coordinates are present on the material
         */
        _convertMaterialsToGLTFAsync(exportMaterials, mimeType, hasTextureCoords) {
            const promises = [];
            exportMaterials.forEach((material) => {
                if (material.getClassName() === "StandardMaterial") {
                    promises.push(this._convertStandardMaterialAsync(material, mimeType, hasTextureCoords));
                }
                else if (material.getClassName().indexOf("PBR") !== -1) {
                    promises.push(this._convertPBRMaterialAsync(material, mimeType, hasTextureCoords));
                }
                else {
                    Tools.Warn(`Unsupported material type: ${material.name}`);
                }
            });
            return Promise.all(promises).then(() => {
                /* do nothing */
            });
        }
        /**
         * Makes a copy of the glTF material without the texture parameters
         * @param originalMaterial original glTF material
         * @returns glTF material without texture parameters
         */
        _stripTexturesFromMaterial(originalMaterial) {
            const newMaterial = {};
            if (originalMaterial) {
                newMaterial.name = originalMaterial.name;
                newMaterial.doubleSided = originalMaterial.doubleSided;
                newMaterial.alphaMode = originalMaterial.alphaMode;
                newMaterial.alphaCutoff = originalMaterial.alphaCutoff;
                newMaterial.emissiveFactor = originalMaterial.emissiveFactor;
                const originalPBRMetallicRoughness = originalMaterial.pbrMetallicRoughness;
                if (originalPBRMetallicRoughness) {
                    newMaterial.pbrMetallicRoughness = {};
                    newMaterial.pbrMetallicRoughness.baseColorFactor = originalPBRMetallicRoughness.baseColorFactor;
                    newMaterial.pbrMetallicRoughness.metallicFactor = originalPBRMetallicRoughness.metallicFactor;
                    newMaterial.pbrMetallicRoughness.roughnessFactor = originalPBRMetallicRoughness.roughnessFactor;
                }
            }
            return newMaterial;
        }
        /**
         * Specifies if the material has any texture parameters present
         * @param material glTF Material
         * @returns boolean specifying if texture parameters are present
         */
        _hasTexturesPresent(material) {
            var _a;
            if (material.emissiveTexture || material.normalTexture || material.occlusionTexture) {
                return true;
            }
            const pbrMat = material.pbrMetallicRoughness;
            if (pbrMat) {
                if (pbrMat.baseColorTexture || pbrMat.metallicRoughnessTexture) {
                    return true;
                }
            }
            if (material.extensions) {
                for (const extension in material.extensions) {
                    const extensionObject = material.extensions[extension];
                    if (extensionObject) {
                        return (_a = extensionObject.hasTextures) === null || _a === void 0 ? void 0 : _a.call(extensionObject);
                    }
                }
            }
            return false;
        }
        _getTextureInfo(babylonTexture) {
            if (babylonTexture) {
                const textureUid = babylonTexture.uid;
                if (textureUid in this._textureMap) {
                    return this._textureMap[textureUid];
                }
            }
            return null;
        }
        /**
         * Converts a Babylon StandardMaterial to a glTF Metallic Roughness Material
         * @param babylonStandardMaterial
         * @returns glTF Metallic Roughness Material representation
         */
        _convertToGLTFPBRMetallicRoughness(babylonStandardMaterial) {
            // Defines a cubic bezier curve where x is specular power and y is roughness
            const P0 = new Vector2(0, 1);
            const P1 = new Vector2(0, 0.1);
            const P2 = new Vector2(0, 0.1);
            const P3 = new Vector2(1300, 0.1);
            /**
             * Given the control points, solve for x based on a given t for a cubic bezier curve
             * @param t a value between 0 and 1
             * @param p0 first control point
             * @param p1 second control point
             * @param p2 third control point
             * @param p3 fourth control point
             * @returns number result of cubic bezier curve at the specified t
             */
            function cubicBezierCurve(t, p0, p1, p2, p3) {
                return (1 - t) * (1 - t) * (1 - t) * p0 + 3 * (1 - t) * (1 - t) * t * p1 + 3 * (1 - t) * t * t * p2 + t * t * t * p3;
            }
            /**
             * Evaluates a specified specular power value to determine the appropriate roughness value,
             * based on a pre-defined cubic bezier curve with specular on the abscissa axis (x-axis)
             * and roughness on the ordinant axis (y-axis)
             * @param specularPower specular power of standard material
             * @returns Number representing the roughness value
             */
            function solveForRoughness(specularPower) {
                // Given P0.x = 0, P1.x = 0, P2.x = 0
                //   x = t * t * t * P3.x
                //   t = (x / P3.x)^(1/3)
                const t = Math.pow(specularPower / P3.x, 0.333333);
                return cubicBezierCurve(t, P0.y, P1.y, P2.y, P3.y);
            }
            const diffuse = babylonStandardMaterial.diffuseColor.toLinearSpace(babylonStandardMaterial.getScene().getEngine().useExactSrgbConversions).scale(0.5);
            const opacity = babylonStandardMaterial.alpha;
            const specularPower = Scalar.Clamp(babylonStandardMaterial.specularPower, 0, _GLTFMaterialExporter._MaxSpecularPower);
            const roughness = solveForRoughness(specularPower);
            const glTFPbrMetallicRoughness = {
                baseColorFactor: [diffuse.r, diffuse.g, diffuse.b, opacity],
                metallicFactor: 0,
                roughnessFactor: roughness,
            };
            return glTFPbrMetallicRoughness;
        }
        /**
         * Computes the metallic factor
         * @param diffuse diffused value
         * @param specular specular value
         * @param oneMinusSpecularStrength one minus the specular strength
         * @returns metallic value
         */
        static _SolveMetallic(diffuse, specular, oneMinusSpecularStrength) {
            if (specular < this._DielectricSpecular.r) {
                this._DielectricSpecular;
                return 0;
            }
            const a = this._DielectricSpecular.r;
            const b = (diffuse * oneMinusSpecularStrength) / (1.0 - this._DielectricSpecular.r) + specular - 2.0 * this._DielectricSpecular.r;
            const c = this._DielectricSpecular.r - specular;
            const D = b * b - 4.0 * a * c;
            return Scalar.Clamp((-b + Math.sqrt(D)) / (2.0 * a), 0, 1);
        }
        /**
         * Sets the glTF alpha mode to a glTF material from the Babylon Material
         * @param glTFMaterial glTF material
         * @param babylonMaterial Babylon material
         */
        static _SetAlphaMode(glTFMaterial, babylonMaterial) {
            if (babylonMaterial.needAlphaBlending()) {
                glTFMaterial.alphaMode = "BLEND" /* MaterialAlphaMode.BLEND */;
            }
            else if (babylonMaterial.needAlphaTesting()) {
                glTFMaterial.alphaMode = "MASK" /* MaterialAlphaMode.MASK */;
                glTFMaterial.alphaCutoff = babylonMaterial.alphaCutOff;
            }
        }
        /**
         * Converts a Babylon Standard Material to a glTF Material
         * @param babylonStandardMaterial BJS Standard Material
         * @param mimeType mime type to use for the textures
         * @param hasTextureCoords specifies if texture coordinates are present on the submesh to determine if textures should be applied
         */
        _convertStandardMaterialAsync(babylonStandardMaterial, mimeType, hasTextureCoords) {
            const materialMap = this._exporter._materialMap;
            const materials = this._exporter._materials;
            const promises = [];
            const pbrMetallicRoughness = this._convertToGLTFPBRMetallicRoughness(babylonStandardMaterial);
            const material = { name: babylonStandardMaterial.name };
            if (babylonStandardMaterial.backFaceCulling != null && !babylonStandardMaterial.backFaceCulling) {
                if (!babylonStandardMaterial.twoSidedLighting) {
                    Tools.Warn(babylonStandardMaterial.name + ": Back-face culling disabled and two-sided lighting disabled is not supported in glTF.");
                }
                material.doubleSided = true;
            }
            if (hasTextureCoords) {
                if (babylonStandardMaterial.diffuseTexture) {
                    promises.push(this._exportTextureAsync(babylonStandardMaterial.diffuseTexture, mimeType).then((textureInfo) => {
                        if (textureInfo) {
                            pbrMetallicRoughness.baseColorTexture = textureInfo;
                        }
                    }));
                }
                const bumpTexture = babylonStandardMaterial.bumpTexture;
                if (bumpTexture) {
                    promises.push(this._exportTextureAsync(bumpTexture, mimeType).then((textureInfo) => {
                        if (textureInfo) {
                            material.normalTexture = textureInfo;
                            if (bumpTexture.level !== 1) {
                                material.normalTexture.scale = bumpTexture.level;
                            }
                        }
                    }));
                }
                if (babylonStandardMaterial.emissiveTexture) {
                    material.emissiveFactor = [1.0, 1.0, 1.0];
                    promises.push(this._exportTextureAsync(babylonStandardMaterial.emissiveTexture, mimeType).then((textureInfo) => {
                        if (textureInfo) {
                            material.emissiveTexture = textureInfo;
                        }
                    }));
                }
                if (babylonStandardMaterial.ambientTexture) {
                    promises.push(this._exportTextureAsync(babylonStandardMaterial.ambientTexture, mimeType).then((textureInfo) => {
                        if (textureInfo) {
                            const occlusionTexture = {
                                index: textureInfo.index,
                            };
                            material.occlusionTexture = occlusionTexture;
                        }
                    }));
                }
            }
            if (babylonStandardMaterial.alpha < 1.0 || babylonStandardMaterial.opacityTexture) {
                if (babylonStandardMaterial.alphaMode === Constants.ALPHA_COMBINE) {
                    material.alphaMode = "BLEND" /* MaterialAlphaMode.BLEND */;
                }
                else {
                    Tools.Warn(babylonStandardMaterial.name + ": glTF 2.0 does not support alpha mode: " + babylonStandardMaterial.alphaMode.toString());
                }
            }
            if (babylonStandardMaterial.emissiveColor && !_GLTFMaterialExporter._FuzzyEquals(babylonStandardMaterial.emissiveColor, Color3.Black(), _GLTFMaterialExporter._Epsilon)) {
                material.emissiveFactor = babylonStandardMaterial.emissiveColor.asArray();
            }
            material.pbrMetallicRoughness = pbrMetallicRoughness;
            _GLTFMaterialExporter._SetAlphaMode(material, babylonStandardMaterial);
            materials.push(material);
            materialMap[babylonStandardMaterial.uniqueId] = materials.length - 1;
            return this._finishMaterial(promises, material, babylonStandardMaterial, mimeType);
        }
        _finishMaterial(promises, glTFMaterial, babylonMaterial, mimeType) {
            return Promise.all(promises).then(() => {
                const textures = this._exporter._extensionsPostExportMaterialAdditionalTextures("exportMaterial", glTFMaterial, babylonMaterial);
                let tasks = null;
                for (const texture of textures) {
                    if (!tasks) {
                        tasks = [];
                    }
                    tasks.push(this._exportTextureAsync(texture, mimeType));
                }
                if (!tasks) {
                    tasks = [Promise.resolve(null)];
                }
                return Promise.all(tasks).then(() => {
                    const extensionWork = this._exporter._extensionsPostExportMaterialAsync("exportMaterial", glTFMaterial, babylonMaterial);
                    if (!extensionWork) {
                        return glTFMaterial;
                    }
                    return extensionWork.then(() => glTFMaterial);
                });
            });
        }
        /**
         * Converts an image typed array buffer to a base64 image
         * @param buffer typed array buffer
         * @param width width of the image
         * @param height height of the image
         * @param mimeType mimetype of the image
         * @returns base64 image string
         */
        async _getImageDataAsync(buffer, width, height, mimeType) {
            const textureType = Constants.TEXTURETYPE_UNSIGNED_INT;
            const hostingScene = this._exporter._babylonScene;
            const engine = hostingScene.getEngine();
            // Create a temporary texture with the texture buffer data
            const tempTexture = engine.createRawTexture(buffer, width, height, Constants.TEXTUREFORMAT_RGBA, false, true, Texture.NEAREST_SAMPLINGMODE, null, textureType);
            await TextureTools.ApplyPostProcess("pass", tempTexture, hostingScene, textureType, Constants.TEXTURE_NEAREST_SAMPLINGMODE, Constants.TEXTUREFORMAT_RGBA);
            const data = await engine._readTexturePixels(tempTexture, width, height);
            return (await DumpTools.DumpDataAsync(width, height, data, mimeType, undefined, true, true));
        }
        /**
         * Generates a white texture based on the specified width and height
         * @param width width of the texture in pixels
         * @param height height of the texture in pixels
         * @param scene babylonjs scene
         * @returns white texture
         */
        _createWhiteTexture(width, height, scene) {
            const data = new Uint8Array(width * height * 4);
            for (let i = 0; i < data.length; i = i + 4) {
                data[i] = data[i + 1] = data[i + 2] = data[i + 3] = 0xff;
            }
            const rawTexture = RawTexture.CreateRGBATexture(data, width, height, scene);
            return rawTexture;
        }
        /**
         * Resizes the two source textures to the same dimensions.  If a texture is null, a default white texture is generated.  If both textures are null, returns null
         * @param texture1 first texture to resize
         * @param texture2 second texture to resize
         * @param scene babylonjs scene
         * @returns resized textures or null
         */
        _resizeTexturesToSameDimensions(texture1, texture2, scene) {
            const texture1Size = texture1 ? texture1.getSize() : { width: 0, height: 0 };
            const texture2Size = texture2 ? texture2.getSize() : { width: 0, height: 0 };
            let resizedTexture1;
            let resizedTexture2;
            if (texture1Size.width < texture2Size.width) {
                if (texture1 && texture1 instanceof Texture) {
                    resizedTexture1 = TextureTools.CreateResizedCopy(texture1, texture2Size.width, texture2Size.height, true);
                }
                else {
                    resizedTexture1 = this._createWhiteTexture(texture2Size.width, texture2Size.height, scene);
                }
                resizedTexture2 = texture2;
            }
            else if (texture1Size.width > texture2Size.width) {
                if (texture2 && texture2 instanceof Texture) {
                    resizedTexture2 = TextureTools.CreateResizedCopy(texture2, texture1Size.width, texture1Size.height, true);
                }
                else {
                    resizedTexture2 = this._createWhiteTexture(texture1Size.width, texture1Size.height, scene);
                }
                resizedTexture1 = texture1;
            }
            else {
                resizedTexture1 = texture1;
                resizedTexture2 = texture2;
            }
            return {
                texture1: resizedTexture1,
                texture2: resizedTexture2,
            };
        }
        /**
         * Converts an array of pixels to a Float32Array
         * Throws an error if the pixel format is not supported
         * @param pixels - array buffer containing pixel values
         * @returns Float32 of pixels
         */
        _convertPixelArrayToFloat32(pixels) {
            if (pixels instanceof Uint8Array) {
                const length = pixels.length;
                const buffer = new Float32Array(pixels.length);
                for (let i = 0; i < length; ++i) {
                    buffer[i] = pixels[i] / 255;
                }
                return buffer;
            }
            else if (pixels instanceof Float32Array) {
                return pixels;
            }
            else {
                throw new Error("Unsupported pixel format!");
            }
        }
        /**
         * Convert Specular Glossiness Textures to Metallic Roughness
         * See link below for info on the material conversions from PBR Metallic/Roughness and Specular/Glossiness
         * @link https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Archived/KHR_materials_pbrSpecularGlossiness/examples/convert-between-workflows-.js/babylon.pbrUtilities.js
         * @param diffuseTexture texture used to store diffuse information
         * @param specularGlossinessTexture texture used to store specular and glossiness information
         * @param factors specular glossiness material factors
         * @param mimeType the mime type to use for the texture
         * @returns pbr metallic roughness interface or null
         */
        async _convertSpecularGlossinessTexturesToMetallicRoughnessAsync(diffuseTexture, specularGlossinessTexture, factors, mimeType) {
            var _a;
            const promises = new Array();
            if (!(diffuseTexture || specularGlossinessTexture)) {
                return Promise.reject("_ConvertSpecularGlosinessTexturesToMetallicRoughness: diffuse and specular glossiness textures are not defined!");
            }
            const scene = diffuseTexture ? diffuseTexture.getScene() : specularGlossinessTexture ? specularGlossinessTexture.getScene() : null;
            if (scene) {
                const resizedTextures = this._resizeTexturesToSameDimensions(diffuseTexture, specularGlossinessTexture, scene);
                const diffuseSize = (_a = resizedTextures.texture1) === null || _a === void 0 ? void 0 : _a.getSize();
                let diffuseBuffer;
                let specularGlossinessBuffer;
                const width = diffuseSize.width;
                const height = diffuseSize.height;
                const diffusePixels = await resizedTextures.texture1.readPixels();
                const specularPixels = await resizedTextures.texture2.readPixels();
                if (diffusePixels) {
                    diffuseBuffer = this._convertPixelArrayToFloat32(diffusePixels);
                }
                else {
                    return Promise.reject("Failed to retrieve pixels from diffuse texture!");
                }
                if (specularPixels) {
                    specularGlossinessBuffer = this._convertPixelArrayToFloat32(specularPixels);
                }
                else {
                    return Promise.reject("Failed to retrieve pixels from specular glossiness texture!");
                }
                const byteLength = specularGlossinessBuffer.byteLength;
                const metallicRoughnessBuffer = new Uint8Array(byteLength);
                const baseColorBuffer = new Uint8Array(byteLength);
                const strideSize = 4;
                const maxBaseColor = Color3.Black();
                let maxMetallic = 0;
                let maxRoughness = 0;
                for (let h = 0; h < height; ++h) {
                    for (let w = 0; w < width; ++w) {
                        const offset = (width * h + w) * strideSize;
                        const diffuseColor = new Color3(diffuseBuffer[offset], diffuseBuffer[offset + 1], diffuseBuffer[offset + 2])
                            .toLinearSpace(scene.getEngine().useExactSrgbConversions)
                            .multiply(factors.diffuseColor);
                        const specularColor = new Color3(specularGlossinessBuffer[offset], specularGlossinessBuffer[offset + 1], specularGlossinessBuffer[offset + 2])
                            .toLinearSpace(scene.getEngine().useExactSrgbConversions)
                            .multiply(factors.specularColor);
                        const glossiness = specularGlossinessBuffer[offset + 3] * factors.glossiness;
                        const specularGlossiness = {
                            diffuseColor: diffuseColor,
                            specularColor: specularColor,
                            glossiness: glossiness,
                        };
                        const metallicRoughness = this._convertSpecularGlossinessToMetallicRoughness(specularGlossiness);
                        maxBaseColor.r = Math.max(maxBaseColor.r, metallicRoughness.baseColor.r);
                        maxBaseColor.g = Math.max(maxBaseColor.g, metallicRoughness.baseColor.g);
                        maxBaseColor.b = Math.max(maxBaseColor.b, metallicRoughness.baseColor.b);
                        maxMetallic = Math.max(maxMetallic, metallicRoughness.metallic);
                        maxRoughness = Math.max(maxRoughness, metallicRoughness.roughness);
                        baseColorBuffer[offset] = metallicRoughness.baseColor.r * 255;
                        baseColorBuffer[offset + 1] = metallicRoughness.baseColor.g * 255;
                        baseColorBuffer[offset + 2] = metallicRoughness.baseColor.b * 255;
                        baseColorBuffer[offset + 3] = resizedTextures.texture1.hasAlpha ? diffuseBuffer[offset + 3] * 255 : 255;
                        metallicRoughnessBuffer[offset] = 0;
                        metallicRoughnessBuffer[offset + 1] = metallicRoughness.roughness * 255;
                        metallicRoughnessBuffer[offset + 2] = metallicRoughness.metallic * 255;
                        metallicRoughnessBuffer[offset + 3] = 255;
                    }
                }
                // Retrieves the metallic roughness factors from the maximum texture values.
                const metallicRoughnessFactors = {
                    baseColor: maxBaseColor,
                    metallic: maxMetallic,
                    roughness: maxRoughness,
                };
                let writeOutMetallicRoughnessTexture = false;
                let writeOutBaseColorTexture = false;
                for (let h = 0; h < height; ++h) {
                    for (let w = 0; w < width; ++w) {
                        const destinationOffset = (width * h + w) * strideSize;
                        baseColorBuffer[destinationOffset] /= metallicRoughnessFactors.baseColor.r > _GLTFMaterialExporter._Epsilon ? metallicRoughnessFactors.baseColor.r : 1;
                        baseColorBuffer[destinationOffset + 1] /= metallicRoughnessFactors.baseColor.g > _GLTFMaterialExporter._Epsilon ? metallicRoughnessFactors.baseColor.g : 1;
                        baseColorBuffer[destinationOffset + 2] /= metallicRoughnessFactors.baseColor.b > _GLTFMaterialExporter._Epsilon ? metallicRoughnessFactors.baseColor.b : 1;
                        const linearBaseColorPixel = Color3.FromInts(baseColorBuffer[destinationOffset], baseColorBuffer[destinationOffset + 1], baseColorBuffer[destinationOffset + 2]);
                        const sRGBBaseColorPixel = linearBaseColorPixel.toGammaSpace(scene.getEngine().useExactSrgbConversions);
                        baseColorBuffer[destinationOffset] = sRGBBaseColorPixel.r * 255;
                        baseColorBuffer[destinationOffset + 1] = sRGBBaseColorPixel.g * 255;
                        baseColorBuffer[destinationOffset + 2] = sRGBBaseColorPixel.b * 255;
                        if (!_GLTFMaterialExporter._FuzzyEquals(sRGBBaseColorPixel, Color3.White(), _GLTFMaterialExporter._Epsilon)) {
                            writeOutBaseColorTexture = true;
                        }
                        metallicRoughnessBuffer[destinationOffset + 1] /=
                            metallicRoughnessFactors.roughness > _GLTFMaterialExporter._Epsilon ? metallicRoughnessFactors.roughness : 1;
                        metallicRoughnessBuffer[destinationOffset + 2] /= metallicRoughnessFactors.metallic > _GLTFMaterialExporter._Epsilon ? metallicRoughnessFactors.metallic : 1;
                        const metallicRoughnessPixel = Color3.FromInts(255, metallicRoughnessBuffer[destinationOffset + 1], metallicRoughnessBuffer[destinationOffset + 2]);
                        if (!_GLTFMaterialExporter._FuzzyEquals(metallicRoughnessPixel, Color3.White(), _GLTFMaterialExporter._Epsilon)) {
                            writeOutMetallicRoughnessTexture = true;
                        }
                    }
                }
                if (writeOutMetallicRoughnessTexture) {
                    promises.push(this._getImageDataAsync(metallicRoughnessBuffer, width, height, mimeType).then((data) => {
                        metallicRoughnessFactors.metallicRoughnessTextureData = data;
                    }));
                }
                if (writeOutBaseColorTexture) {
                    promises.push(this._getImageDataAsync(baseColorBuffer, width, height, mimeType).then((data) => {
                        metallicRoughnessFactors.baseColorTextureData = data;
                    }));
                }
                return Promise.all(promises).then(() => {
                    return metallicRoughnessFactors;
                });
            }
            else {
                return Promise.reject("_ConvertSpecularGlossinessTexturesToMetallicRoughness: Scene from textures is missing!");
            }
        }
        /**
         * Converts specular glossiness material properties to metallic roughness
         * @param specularGlossiness interface with specular glossiness material properties
         * @returns interface with metallic roughness material properties
         */
        _convertSpecularGlossinessToMetallicRoughness(specularGlossiness) {
            const diffusePerceivedBrightness = this._getPerceivedBrightness(specularGlossiness.diffuseColor);
            const specularPerceivedBrightness = this._getPerceivedBrightness(specularGlossiness.specularColor);
            const oneMinusSpecularStrength = 1 - this._getMaxComponent(specularGlossiness.specularColor);
            const metallic = _GLTFMaterialExporter._SolveMetallic(diffusePerceivedBrightness, specularPerceivedBrightness, oneMinusSpecularStrength);
            const baseColorFromDiffuse = specularGlossiness.diffuseColor.scale(oneMinusSpecularStrength / (1.0 - _GLTFMaterialExporter._DielectricSpecular.r) / Math.max(1 - metallic, _GLTFMaterialExporter._Epsilon));
            const baseColorFromSpecular = specularGlossiness.specularColor
                .subtract(_GLTFMaterialExporter._DielectricSpecular.scale(1 - metallic))
                .scale(1 / Math.max(metallic, _GLTFMaterialExporter._Epsilon));
            let baseColor = Color3.Lerp(baseColorFromDiffuse, baseColorFromSpecular, metallic * metallic);
            baseColor = baseColor.clampToRef(0, 1, baseColor);
            const metallicRoughness = {
                baseColor: baseColor,
                metallic: metallic,
                roughness: 1 - specularGlossiness.glossiness,
            };
            return metallicRoughness;
        }
        /**
         * Calculates the surface reflectance, independent of lighting conditions
         * @param color Color source to calculate brightness from
         * @returns number representing the perceived brightness, or zero if color is undefined
         */
        _getPerceivedBrightness(color) {
            if (color) {
                return Math.sqrt(0.299 * color.r * color.r + 0.587 * color.g * color.g + 0.114 * color.b * color.b);
            }
            return 0;
        }
        /**
         * Returns the maximum color component value
         * @param color
         * @returns maximum color component value, or zero if color is null or undefined
         */
        _getMaxComponent(color) {
            if (color) {
                return Math.max(color.r, Math.max(color.g, color.b));
            }
            return 0;
        }
        /**
         * Convert a PBRMaterial (Metallic/Roughness) to Metallic Roughness factors
         * @param babylonPBRMaterial BJS PBR Metallic Roughness Material
         * @param mimeType mime type to use for the textures
         * @param glTFPbrMetallicRoughness glTF PBR Metallic Roughness interface
         * @param hasTextureCoords specifies if texture coordinates are present on the submesh to determine if textures should be applied
         * @returns glTF PBR Metallic Roughness factors
         */
        _convertMetalRoughFactorsToMetallicRoughnessAsync(babylonPBRMaterial, mimeType, glTFPbrMetallicRoughness, hasTextureCoords) {
            const promises = [];
            const baseColor = babylonPBRMaterial._albedoColor;
            const metallic = babylonPBRMaterial._metallic;
            const roughness = babylonPBRMaterial._roughness;
            const metallicRoughness = {
                baseColor: baseColor,
                metallic: metallic,
                roughness: roughness,
            };
            if (hasTextureCoords) {
                const albedoTexture = babylonPBRMaterial._albedoTexture;
                if (albedoTexture) {
                    promises.push(this._exportTextureAsync(babylonPBRMaterial._albedoTexture, mimeType).then((glTFTexture) => {
                        if (glTFTexture) {
                            glTFPbrMetallicRoughness.baseColorTexture = glTFTexture;
                        }
                    }));
                }
                const metallicTexture = babylonPBRMaterial._metallicTexture;
                if (metallicTexture) {
                    promises.push(this._exportTextureAsync(metallicTexture, mimeType).then((glTFTexture) => {
                        if (glTFTexture) {
                            glTFPbrMetallicRoughness.metallicRoughnessTexture = glTFTexture;
                        }
                    }));
                }
            }
            return Promise.all(promises).then(() => {
                return metallicRoughness;
            });
        }
        _getTextureSampler(texture) {
            const sampler = {};
            if (!texture || !(texture instanceof Texture)) {
                return sampler;
            }
            const wrapS = this._getGLTFTextureWrapMode(texture.wrapU);
            if (wrapS !== 10497 /* TextureWrapMode.REPEAT */) {
                sampler.wrapS = wrapS;
            }
            const wrapT = this._getGLTFTextureWrapMode(texture.wrapV);
            if (wrapT !== 10497 /* TextureWrapMode.REPEAT */) {
                sampler.wrapT = wrapT;
            }
            switch (texture.samplingMode) {
                case Texture.LINEAR_LINEAR: {
                    sampler.magFilter = 9729 /* TextureMagFilter.LINEAR */;
                    sampler.minFilter = 9729 /* TextureMinFilter.LINEAR */;
                    break;
                }
                case Texture.LINEAR_NEAREST: {
                    sampler.magFilter = 9729 /* TextureMagFilter.LINEAR */;
                    sampler.minFilter = 9728 /* TextureMinFilter.NEAREST */;
                    break;
                }
                case Texture.NEAREST_LINEAR: {
                    sampler.magFilter = 9728 /* TextureMagFilter.NEAREST */;
                    sampler.minFilter = 9729 /* TextureMinFilter.LINEAR */;
                    break;
                }
                case Texture.NEAREST_LINEAR_MIPLINEAR: {
                    sampler.magFilter = 9728 /* TextureMagFilter.NEAREST */;
                    sampler.minFilter = 9987 /* TextureMinFilter.LINEAR_MIPMAP_LINEAR */;
                    break;
                }
                case Texture.NEAREST_NEAREST: {
                    sampler.magFilter = 9728 /* TextureMagFilter.NEAREST */;
                    sampler.minFilter = 9728 /* TextureMinFilter.NEAREST */;
                    break;
                }
                case Texture.NEAREST_LINEAR_MIPNEAREST: {
                    sampler.magFilter = 9728 /* TextureMagFilter.NEAREST */;
                    sampler.minFilter = 9985 /* TextureMinFilter.LINEAR_MIPMAP_NEAREST */;
                    break;
                }
                case Texture.LINEAR_NEAREST_MIPNEAREST: {
                    sampler.magFilter = 9729 /* TextureMagFilter.LINEAR */;
                    sampler.minFilter = 9984 /* TextureMinFilter.NEAREST_MIPMAP_NEAREST */;
                    break;
                }
                case Texture.LINEAR_NEAREST_MIPLINEAR: {
                    sampler.magFilter = 9729 /* TextureMagFilter.LINEAR */;
                    sampler.minFilter = 9986 /* TextureMinFilter.NEAREST_MIPMAP_LINEAR */;
                    break;
                }
                case Texture.NEAREST_NEAREST_MIPLINEAR: {
                    sampler.magFilter = 9728 /* TextureMagFilter.NEAREST */;
                    sampler.minFilter = 9986 /* TextureMinFilter.NEAREST_MIPMAP_LINEAR */;
                    break;
                }
                case Texture.LINEAR_LINEAR_MIPLINEAR: {
                    sampler.magFilter = 9729 /* TextureMagFilter.LINEAR */;
                    sampler.minFilter = 9987 /* TextureMinFilter.LINEAR_MIPMAP_LINEAR */;
                    break;
                }
                case Texture.LINEAR_LINEAR_MIPNEAREST: {
                    sampler.magFilter = 9729 /* TextureMagFilter.LINEAR */;
                    sampler.minFilter = 9985 /* TextureMinFilter.LINEAR_MIPMAP_NEAREST */;
                    break;
                }
                case Texture.NEAREST_NEAREST_MIPNEAREST: {
                    sampler.magFilter = 9728 /* TextureMagFilter.NEAREST */;
                    sampler.minFilter = 9984 /* TextureMinFilter.NEAREST_MIPMAP_NEAREST */;
                    break;
                }
            }
            return sampler;
        }
        _getGLTFTextureWrapMode(wrapMode) {
            switch (wrapMode) {
                case Texture.WRAP_ADDRESSMODE: {
                    return 10497 /* TextureWrapMode.REPEAT */;
                }
                case Texture.CLAMP_ADDRESSMODE: {
                    return 33071 /* TextureWrapMode.CLAMP_TO_EDGE */;
                }
                case Texture.MIRROR_ADDRESSMODE: {
                    return 33648 /* TextureWrapMode.MIRRORED_REPEAT */;
                }
                default: {
                    Tools.Error(`Unsupported Texture Wrap Mode ${wrapMode}!`);
                    return 10497 /* TextureWrapMode.REPEAT */;
                }
            }
        }
        /**
         * Convert a PBRMaterial (Specular/Glossiness) to Metallic Roughness factors
         * @param babylonPBRMaterial BJS PBR Metallic Roughness Material
         * @param mimeType mime type to use for the textures
         * @param glTFPbrMetallicRoughness glTF PBR Metallic Roughness interface
         * @param hasTextureCoords specifies if texture coordinates are present on the submesh to determine if textures should be applied
         * @returns glTF PBR Metallic Roughness factors
         */
        _convertSpecGlossFactorsToMetallicRoughnessAsync(babylonPBRMaterial, mimeType, pbrMetallicRoughness, hasTextureCoords) {
            return Promise.resolve().then(() => {
                const specGloss = {
                    diffuseColor: babylonPBRMaterial._albedoColor,
                    specularColor: babylonPBRMaterial._reflectivityColor,
                    glossiness: babylonPBRMaterial._microSurface,
                };
                const albedoTexture = babylonPBRMaterial._albedoTexture;
                const reflectivityTexture = babylonPBRMaterial._reflectivityTexture;
                const useMicrosurfaceFromReflectivityMapAlpha = babylonPBRMaterial._useMicroSurfaceFromReflectivityMapAlpha;
                if (reflectivityTexture && !useMicrosurfaceFromReflectivityMapAlpha) {
                    return Promise.reject("_ConvertPBRMaterial: Glossiness values not included in the reflectivity texture are currently not supported");
                }
                if ((albedoTexture || reflectivityTexture) && hasTextureCoords) {
                    const samplerIndex = this._exportTextureSampler(albedoTexture || reflectivityTexture);
                    return this._convertSpecularGlossinessTexturesToMetallicRoughnessAsync(albedoTexture, reflectivityTexture, specGloss, mimeType).then((metallicRoughnessFactors) => {
                        const textures = this._exporter._textures;
                        if (metallicRoughnessFactors.baseColorTextureData) {
                            const imageIndex = this._exportImage(`baseColor${textures.length}`, mimeType, metallicRoughnessFactors.baseColorTextureData);
                            pbrMetallicRoughness.baseColorTexture = this._exportTextureInfo(imageIndex, samplerIndex, albedoTexture === null || albedoTexture === void 0 ? void 0 : albedoTexture.coordinatesIndex);
                        }
                        if (metallicRoughnessFactors.metallicRoughnessTextureData) {
                            const imageIndex = this._exportImage(`metallicRoughness${textures.length}`, mimeType, metallicRoughnessFactors.metallicRoughnessTextureData);
                            pbrMetallicRoughness.metallicRoughnessTexture = this._exportTextureInfo(imageIndex, samplerIndex, reflectivityTexture === null || reflectivityTexture === void 0 ? void 0 : reflectivityTexture.coordinatesIndex);
                        }
                        return metallicRoughnessFactors;
                    });
                }
                else {
                    return this._convertSpecularGlossinessToMetallicRoughness(specGloss);
                }
            });
        }
        /**
         * Converts a Babylon PBR Base Material to a glTF Material
         * @param babylonPBRMaterial BJS PBR Base Material
         * @param mimeType mime type to use for the textures
         * @param hasTextureCoords specifies if texture coordinates are present on the submesh to determine if textures should be applied
         */
        _convertPBRMaterialAsync(babylonPBRMaterial, mimeType, hasTextureCoords) {
            const glTFPbrMetallicRoughness = {};
            const glTFMaterial = {
                name: babylonPBRMaterial.name,
            };
            const useMetallicRoughness = babylonPBRMaterial.isMetallicWorkflow();
            if (useMetallicRoughness) {
                const albedoColor = babylonPBRMaterial._albedoColor;
                const alpha = babylonPBRMaterial.alpha;
                if (albedoColor) {
                    glTFPbrMetallicRoughness.baseColorFactor = [albedoColor.r, albedoColor.g, albedoColor.b, alpha];
                }
                return this._convertMetalRoughFactorsToMetallicRoughnessAsync(babylonPBRMaterial, mimeType, glTFPbrMetallicRoughness, hasTextureCoords).then((metallicRoughness) => {
                    return this._setMetallicRoughnessPbrMaterial(metallicRoughness, babylonPBRMaterial, glTFMaterial, glTFPbrMetallicRoughness, mimeType, hasTextureCoords);
                });
            }
            else {
                return this._convertSpecGlossFactorsToMetallicRoughnessAsync(babylonPBRMaterial, mimeType, glTFPbrMetallicRoughness, hasTextureCoords).then((metallicRoughness) => {
                    return this._setMetallicRoughnessPbrMaterial(metallicRoughness, babylonPBRMaterial, glTFMaterial, glTFPbrMetallicRoughness, mimeType, hasTextureCoords);
                });
            }
        }
        _setMetallicRoughnessPbrMaterial(metallicRoughness, babylonPBRMaterial, glTFMaterial, glTFPbrMetallicRoughness, mimeType, hasTextureCoords) {
            const materialMap = this._exporter._materialMap;
            const materials = this._exporter._materials;
            const promises = [];
            if (metallicRoughness) {
                _GLTFMaterialExporter._SetAlphaMode(glTFMaterial, babylonPBRMaterial);
                if (!(_GLTFMaterialExporter._FuzzyEquals(metallicRoughness.baseColor, Color3.White(), _GLTFMaterialExporter._Epsilon) &&
                    babylonPBRMaterial.alpha >= _GLTFMaterialExporter._Epsilon)) {
                    glTFPbrMetallicRoughness.baseColorFactor = [metallicRoughness.baseColor.r, metallicRoughness.baseColor.g, metallicRoughness.baseColor.b, babylonPBRMaterial.alpha];
                }
                if (metallicRoughness.metallic != null && metallicRoughness.metallic !== 1) {
                    glTFPbrMetallicRoughness.metallicFactor = metallicRoughness.metallic;
                }
                if (metallicRoughness.roughness != null && metallicRoughness.roughness !== 1) {
                    glTFPbrMetallicRoughness.roughnessFactor = metallicRoughness.roughness;
                }
                if (babylonPBRMaterial.backFaceCulling != null && !babylonPBRMaterial.backFaceCulling) {
                    if (!babylonPBRMaterial._twoSidedLighting) {
                        Tools.Warn(babylonPBRMaterial.name + ": Back-face culling disabled and two-sided lighting disabled is not supported in glTF.");
                    }
                    glTFMaterial.doubleSided = true;
                }
                if (hasTextureCoords) {
                    const bumpTexture = babylonPBRMaterial._bumpTexture;
                    if (bumpTexture) {
                        const promise = this._exportTextureAsync(bumpTexture, mimeType).then((glTFTexture) => {
                            if (glTFTexture) {
                                glTFMaterial.normalTexture = glTFTexture;
                                if (bumpTexture.level !== 1) {
                                    glTFMaterial.normalTexture.scale = bumpTexture.level;
                                }
                            }
                        });
                        promises.push(promise);
                    }
                    const ambientTexture = babylonPBRMaterial._ambientTexture;
                    if (ambientTexture) {
                        const promise = this._exportTextureAsync(ambientTexture, mimeType).then((glTFTexture) => {
                            if (glTFTexture) {
                                const occlusionTexture = {
                                    index: glTFTexture.index,
                                    texCoord: glTFTexture.texCoord,
                                    extensions: glTFTexture.extensions,
                                };
                                glTFMaterial.occlusionTexture = occlusionTexture;
                                const ambientTextureStrength = babylonPBRMaterial._ambientTextureStrength;
                                if (ambientTextureStrength) {
                                    occlusionTexture.strength = ambientTextureStrength;
                                }
                            }
                        });
                        promises.push(promise);
                    }
                    const emissiveTexture = babylonPBRMaterial._emissiveTexture;
                    if (emissiveTexture) {
                        const promise = this._exportTextureAsync(emissiveTexture, mimeType).then((glTFTexture) => {
                            if (glTFTexture) {
                                glTFMaterial.emissiveTexture = glTFTexture;
                            }
                        });
                        promises.push(promise);
                    }
                }
                const emissiveColor = babylonPBRMaterial._emissiveColor;
                if (!_GLTFMaterialExporter._FuzzyEquals(emissiveColor, Color3.Black(), _GLTFMaterialExporter._Epsilon)) {
                    glTFMaterial.emissiveFactor = emissiveColor.asArray();
                }
                glTFMaterial.pbrMetallicRoughness = glTFPbrMetallicRoughness;
                materials.push(glTFMaterial);
                materialMap[babylonPBRMaterial.uniqueId] = materials.length - 1;
            }
            return this._finishMaterial(promises, glTFMaterial, babylonPBRMaterial, mimeType);
        }
        _getPixelsFromTexture(babylonTexture) {
            const pixels = babylonTexture.textureType === Constants.TEXTURETYPE_UNSIGNED_INT
                ? babylonTexture.readPixels()
                : babylonTexture.readPixels();
            return pixels;
        }
        /**
         * Extracts a texture from a Babylon texture into file data and glTF data
         * @param babylonTexture Babylon texture to extract
         * @param mimeType Mime Type of the babylonTexture
         * @returns glTF texture info, or null if the texture format is not supported
         */
        _exportTextureAsync(babylonTexture, mimeType) {
            const extensionPromise = this._exporter._extensionsPreExportTextureAsync("exporter", babylonTexture, mimeType);
            if (!extensionPromise) {
                return this._exportTextureInfoAsync(babylonTexture, mimeType);
            }
            return extensionPromise.then((texture) => {
                if (!texture) {
                    return this._exportTextureInfoAsync(babylonTexture, mimeType);
                }
                return this._exportTextureInfoAsync(texture, mimeType);
            });
        }
        async _exportTextureInfoAsync(babylonTexture, mimeType) {
            const textureUid = babylonTexture.uid;
            if (!(textureUid in this._textureMap)) {
                const pixels = await this._getPixelsFromTexture(babylonTexture);
                if (!pixels) {
                    return null;
                }
                const samplerIndex = this._exportTextureSampler(babylonTexture);
                // Preserve texture mime type if defined
                const textureMimeType = babylonTexture.mimeType;
                if (textureMimeType) {
                    switch (textureMimeType) {
                        case "image/jpeg":
                        case "image/png":
                        case "image/webp":
                            mimeType = textureMimeType;
                            break;
                        default:
                            Tools.Warn(`Unsupported media type: ${textureMimeType}`);
                            break;
                    }
                }
                const internalTextureToImage = this._internalTextureToImage;
                const internalTextureUniqueId = babylonTexture.getInternalTexture().uniqueId;
                internalTextureToImage[internalTextureUniqueId] || (internalTextureToImage[internalTextureUniqueId] = {});
                let imageIndexPromise = internalTextureToImage[internalTextureUniqueId][mimeType];
                if (imageIndexPromise === undefined) {
                    const size = babylonTexture.getSize();
                    imageIndexPromise = (async () => {
                        const data = await this._getImageDataAsync(pixels, size.width, size.height, mimeType);
                        return this._exportImage(babylonTexture.name, mimeType, data);
                    })();
                    internalTextureToImage[internalTextureUniqueId][mimeType] = imageIndexPromise;
                }
                const textureInfo = this._exportTextureInfo(await imageIndexPromise, samplerIndex, babylonTexture.coordinatesIndex);
                this._textureMap[textureUid] = textureInfo;
                this._exporter._extensionsPostExportTextures("exporter", this._textureMap[textureUid], babylonTexture);
            }
            return this._textureMap[textureUid];
        }
        _exportImage(name, mimeType, data) {
            const imageData = this._exporter._imageData;
            const baseName = name.replace(/\.\/|\/|\.\\|\\/g, "_");
            const extension = getFileExtensionFromMimeType(mimeType);
            let fileName = baseName + extension;
            if (fileName in imageData) {
                fileName = `${baseName}_${Tools.RandomId()}${extension}`;
            }
            imageData[fileName] = {
                data: data,
                mimeType: mimeType,
            };
            const images = this._exporter._images;
            images.push({
                name: name,
                uri: fileName,
            });
            return images.length - 1;
        }
        _exportTextureInfo(imageIndex, samplerIndex, coordinatesIndex) {
            const textures = this._exporter._textures;
            let textureIndex = textures.findIndex((t) => t.sampler == samplerIndex && t.source === imageIndex);
            if (textureIndex === -1) {
                textureIndex = textures.length;
                textures.push({
                    source: imageIndex,
                    sampler: samplerIndex,
                });
            }
            const textureInfo = { index: textureIndex };
            if (coordinatesIndex) {
                textureInfo.texCoord = coordinatesIndex;
            }
            return textureInfo;
        }
        _exportTextureSampler(texture) {
            const sampler = this._getTextureSampler(texture);
            // if a pre-existing sampler with identical parameters exists, then reuse the previous sampler
            const samplers = this._exporter._samplers;
            const samplerIndex = samplers.findIndex((s) => s.minFilter === sampler.minFilter && s.magFilter === sampler.magFilter && s.wrapS === sampler.wrapS && s.wrapT === sampler.wrapT);
            if (samplerIndex !== -1) {
                return samplerIndex;
            }
            samplers.push(sampler);
            return samplers.length - 1;
        }
    }
    /**
     * Represents the dielectric specular values for R, G and B
     */
    _GLTFMaterialExporter._DielectricSpecular = new Color3(0.04, 0.04, 0.04);
    /**
     * Allows the maximum specular power to be defined for material calculations
     */
    _GLTFMaterialExporter._MaxSpecularPower = 1024;
    /**
     * Numeric tolerance value
     */
    _GLTFMaterialExporter._Epsilon = 1e-6;

    // Matrix that converts handedness on the X-axis.
    const convertHandednessMatrix = Matrix.Compose(new Vector3(-1, 1, 1), Quaternion.Identity(), Vector3.Zero());
    function isNoopNode(node, useRightHandedSystem) {
        if (!(node instanceof TransformNode)) {
            return false;
        }
        // Transform
        if (useRightHandedSystem) {
            const matrix = node.getWorldMatrix();
            if (!matrix.isIdentity()) {
                return false;
            }
        }
        else {
            const matrix = node.getWorldMatrix().multiplyToRef(convertHandednessMatrix, TmpVectors.Matrix[0]);
            if (!matrix.isIdentity()) {
                return false;
            }
        }
        // Geometry
        if ((node instanceof Mesh && node.geometry) || (node instanceof InstancedMesh && node.sourceMesh.geometry)) {
            return false;
        }
        return true;
    }
    function convertNodeHandedness(node) {
        const translation = Vector3.FromArrayToRef(node.translation || [0, 0, 0], 0, TmpVectors.Vector3[0]);
        const rotation = Quaternion.FromArrayToRef(node.rotation || [0, 0, 0, 1], 0, TmpVectors.Quaternion[0]);
        const scale = Vector3.FromArrayToRef(node.scale || [1, 1, 1], 0, TmpVectors.Vector3[1]);
        const matrix = Matrix.ComposeToRef(scale, rotation, translation, TmpVectors.Matrix[0]).multiplyToRef(convertHandednessMatrix, TmpVectors.Matrix[0]);
        matrix.decompose(scale, rotation, translation);
        if (translation.equalsToFloats(0, 0, 0)) {
            delete node.translation;
        }
        else {
            node.translation = translation.asArray();
        }
        if (Quaternion.IsIdentity(rotation)) {
            delete node.rotation;
        }
        else {
            node.rotation = rotation.asArray();
        }
        if (scale.equalsToFloats(1, 1, 1)) {
            delete node.scale;
        }
        else {
            node.scale = scale.asArray();
        }
    }
    /**
     * Converts Babylon Scene into glTF 2.0.
     * @internal
     */
    class _Exporter {
        _applyExtension(node, extensions, index, actionAsync) {
            if (index >= extensions.length) {
                return Promise.resolve(node);
            }
            const currentPromise = actionAsync(extensions[index], node);
            if (!currentPromise) {
                return this._applyExtension(node, extensions, index + 1, actionAsync);
            }
            return currentPromise.then((newNode) => this._applyExtension(newNode, extensions, index + 1, actionAsync));
        }
        _applyExtensions(node, actionAsync) {
            const extensions = [];
            for (const name of _Exporter._ExtensionNames) {
                extensions.push(this._extensions[name]);
            }
            return this._applyExtension(node, extensions, 0, actionAsync);
        }
        _extensionsPreExportTextureAsync(context, babylonTexture, mimeType) {
            return this._applyExtensions(babylonTexture, (extension, node) => extension.preExportTextureAsync && extension.preExportTextureAsync(context, node, mimeType));
        }
        _extensionsPostExportMeshPrimitiveAsync(context, meshPrimitive, babylonSubMesh, binaryWriter) {
            return this._applyExtensions(meshPrimitive, (extension, node) => extension.postExportMeshPrimitiveAsync && extension.postExportMeshPrimitiveAsync(context, node, babylonSubMesh, binaryWriter));
        }
        _extensionsPostExportNodeAsync(context, node, babylonNode, nodeMap, binaryWriter) {
            return this._applyExtensions(node, (extension, node) => extension.postExportNodeAsync && extension.postExportNodeAsync(context, node, babylonNode, nodeMap, binaryWriter));
        }
        _extensionsPostExportMaterialAsync(context, material, babylonMaterial) {
            return this._applyExtensions(material, (extension, node) => extension.postExportMaterialAsync && extension.postExportMaterialAsync(context, node, babylonMaterial));
        }
        _extensionsPostExportMaterialAdditionalTextures(context, material, babylonMaterial) {
            const output = [];
            for (const name of _Exporter._ExtensionNames) {
                const extension = this._extensions[name];
                if (extension.postExportMaterialAdditionalTextures) {
                    output.push(...extension.postExportMaterialAdditionalTextures(context, material, babylonMaterial));
                }
            }
            return output;
        }
        _extensionsPostExportTextures(context, textureInfo, babylonTexture) {
            for (const name of _Exporter._ExtensionNames) {
                const extension = this._extensions[name];
                if (extension.postExportTexture) {
                    extension.postExportTexture(context, textureInfo, babylonTexture);
                }
            }
        }
        _forEachExtensions(action) {
            for (const name of _Exporter._ExtensionNames) {
                const extension = this._extensions[name];
                if (extension.enabled) {
                    action(extension);
                }
            }
        }
        _extensionsOnExporting() {
            this._forEachExtensions((extension) => {
                if (extension.wasUsed) {
                    if (this._glTF.extensionsUsed == null) {
                        this._glTF.extensionsUsed = [];
                    }
                    if (this._glTF.extensionsUsed.indexOf(extension.name) === -1) {
                        this._glTF.extensionsUsed.push(extension.name);
                    }
                    if (extension.required) {
                        if (this._glTF.extensionsRequired == null) {
                            this._glTF.extensionsRequired = [];
                        }
                        if (this._glTF.extensionsRequired.indexOf(extension.name) === -1) {
                            this._glTF.extensionsRequired.push(extension.name);
                        }
                    }
                    if (this._glTF.extensions == null) {
                        this._glTF.extensions = {};
                    }
                    if (extension.onExporting) {
                        extension.onExporting();
                    }
                }
            });
        }
        /**
         * Load glTF serializer extensions
         */
        _loadExtensions() {
            for (const name of _Exporter._ExtensionNames) {
                const extension = _Exporter._ExtensionFactories[name](this);
                this._extensions[name] = extension;
            }
        }
        /**
         * Creates a glTF Exporter instance, which can accept optional exporter options
         * @param babylonScene Babylon scene object
         * @param options Options to modify the behavior of the exporter
         */
        constructor(babylonScene, options) {
            this._extensions = {};
            this._glTF = {
                asset: { generator: `Babylon.js v${Engine.Version}`, version: "2.0" },
            };
            babylonScene = babylonScene || EngineStore.LastCreatedScene;
            if (!babylonScene) {
                return;
            }
            this._babylonScene = babylonScene;
            this._bufferViews = [];
            this._accessors = [];
            this._meshes = [];
            this._scenes = [];
            this._cameras = [];
            this._nodes = [];
            this._images = [];
            this._materials = [];
            this._materialMap = [];
            this._textures = [];
            this._samplers = [];
            this._skins = [];
            this._animations = [];
            this._imageData = {};
            this._orderedImageData = [];
            this._options = options || {};
            this._animationSampleRate = this._options.animationSampleRate || 1 / 60;
            this._glTFMaterialExporter = new _GLTFMaterialExporter(this);
            this._loadExtensions();
        }
        dispose() {
            for (const extensionKey in this._extensions) {
                const extension = this._extensions[extensionKey];
                extension.dispose();
            }
        }
        get options() {
            return this._options;
        }
        /**
         * Registers a glTF exporter extension
         * @param name Name of the extension to export
         * @param factory The factory function that creates the exporter extension
         */
        static RegisterExtension(name, factory) {
            if (_Exporter.UnregisterExtension(name)) {
                Tools.Warn(`Extension with the name ${name} already exists`);
            }
            _Exporter._ExtensionFactories[name] = factory;
            _Exporter._ExtensionNames.push(name);
        }
        /**
         * Un-registers an exporter extension
         * @param name The name fo the exporter extension
         * @returns A boolean indicating whether the extension has been un-registered
         */
        static UnregisterExtension(name) {
            if (!_Exporter._ExtensionFactories[name]) {
                return false;
            }
            delete _Exporter._ExtensionFactories[name];
            const index = _Exporter._ExtensionNames.indexOf(name);
            if (index !== -1) {
                _Exporter._ExtensionNames.splice(index, 1);
            }
            return true;
        }
        _reorderIndicesBasedOnPrimitiveMode(submesh, primitiveMode, babylonIndices, byteOffset, binaryWriter) {
            switch (primitiveMode) {
                case Material.TriangleFillMode: {
                    if (!byteOffset) {
                        byteOffset = 0;
                    }
                    for (let i = submesh.indexStart, length = submesh.indexStart + submesh.indexCount; i < length; i = i + 3) {
                        const index = byteOffset + i * 4;
                        // swap the second and third indices
                        const secondIndex = binaryWriter.getUInt32(index + 4);
                        const thirdIndex = binaryWriter.getUInt32(index + 8);
                        binaryWriter.setUInt32(thirdIndex, index + 4);
                        binaryWriter.setUInt32(secondIndex, index + 8);
                    }
                    break;
                }
                case Material.TriangleFanDrawMode: {
                    for (let i = submesh.indexStart + submesh.indexCount - 1, start = submesh.indexStart; i >= start; --i) {
                        binaryWriter.setUInt32(babylonIndices[i], byteOffset);
                        byteOffset += 4;
                    }
                    break;
                }
                case Material.TriangleStripDrawMode: {
                    if (submesh.indexCount >= 3) {
                        binaryWriter.setUInt32(babylonIndices[submesh.indexStart + 2], byteOffset + 4);
                        binaryWriter.setUInt32(babylonIndices[submesh.indexStart + 1], byteOffset + 8);
                    }
                    break;
                }
            }
        }
        /**
         * Reorders the vertex attribute data based on the primitive mode.  This is necessary when indices are not available and the winding order is
         * clock-wise during export to glTF
         * @param submesh BabylonJS submesh
         * @param primitiveMode Primitive mode of the mesh
         * @param vertexBufferKind The type of vertex attribute
         * @param meshAttributeArray The vertex attribute data
         * @param byteOffset The offset to the binary data
         * @param binaryWriter The binary data for the glTF file
         */
        _reorderVertexAttributeDataBasedOnPrimitiveMode(submesh, primitiveMode, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter) {
            switch (primitiveMode) {
                case Material.TriangleFillMode: {
                    this._reorderTriangleFillMode(submesh, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter);
                    break;
                }
                case Material.TriangleStripDrawMode: {
                    this._reorderTriangleStripDrawMode(submesh, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter);
                    break;
                }
                case Material.TriangleFanDrawMode: {
                    this._reorderTriangleFanMode(submesh, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter);
                    break;
                }
            }
        }
        /**
         * Reorders the vertex attributes in the correct triangle mode order .  This is necessary when indices are not available and the winding order is
         * clock-wise during export to glTF
         * @param submesh BabylonJS submesh
         * @param vertexBufferKind The type of vertex attribute
         * @param meshAttributeArray The vertex attribute data
         * @param byteOffset The offset to the binary data
         * @param binaryWriter The binary data for the glTF file
         */
        _reorderTriangleFillMode(submesh, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter) {
            const vertexBuffer = this._getVertexBufferFromMesh(vertexBufferKind, submesh.getMesh());
            if (vertexBuffer) {
                const stride = vertexBuffer.byteStride / VertexBuffer.GetTypeByteLength(vertexBuffer.type);
                if (submesh.verticesCount % 3 !== 0) {
                    Tools.Error("The submesh vertices for the triangle fill mode is not divisible by 3!");
                }
                else {
                    const vertexData = [];
                    let index = 0;
                    switch (vertexBufferKind) {
                        case VertexBuffer.PositionKind:
                        case VertexBuffer.NormalKind: {
                            for (let x = submesh.verticesStart; x < submesh.verticesStart + submesh.verticesCount; x = x + 3) {
                                index = x * stride;
                                vertexData.push(Vector3.FromArray(meshAttributeArray, index));
                                vertexData.push(Vector3.FromArray(meshAttributeArray, index + 2 * stride));
                                vertexData.push(Vector3.FromArray(meshAttributeArray, index + stride));
                            }
                            break;
                        }
                        case VertexBuffer.TangentKind: {
                            for (let x = submesh.verticesStart; x < submesh.verticesStart + submesh.verticesCount; x = x + 3) {
                                index = x * stride;
                                vertexData.push(Vector4.FromArray(meshAttributeArray, index));
                                vertexData.push(Vector4.FromArray(meshAttributeArray, index + 2 * stride));
                                vertexData.push(Vector4.FromArray(meshAttributeArray, index + stride));
                            }
                            break;
                        }
                        case VertexBuffer.ColorKind: {
                            const size = vertexBuffer.getSize();
                            for (let x = submesh.verticesStart; x < submesh.verticesStart + submesh.verticesCount; x = x + size) {
                                index = x * stride;
                                if (size === 4) {
                                    vertexData.push(Vector4.FromArray(meshAttributeArray, index));
                                    vertexData.push(Vector4.FromArray(meshAttributeArray, index + 2 * stride));
                                    vertexData.push(Vector4.FromArray(meshAttributeArray, index + stride));
                                }
                                else {
                                    vertexData.push(Vector3.FromArray(meshAttributeArray, index));
                                    vertexData.push(Vector3.FromArray(meshAttributeArray, index + 2 * stride));
                                    vertexData.push(Vector3.FromArray(meshAttributeArray, index + stride));
                                }
                            }
                            break;
                        }
                        case VertexBuffer.UVKind:
                        case VertexBuffer.UV2Kind: {
                            for (let x = submesh.verticesStart; x < submesh.verticesStart + submesh.verticesCount; x = x + 3) {
                                index = x * stride;
                                vertexData.push(Vector2.FromArray(meshAttributeArray, index));
                                vertexData.push(Vector2.FromArray(meshAttributeArray, index + 2 * stride));
                                vertexData.push(Vector2.FromArray(meshAttributeArray, index + stride));
                            }
                            break;
                        }
                        default: {
                            Tools.Error(`Unsupported Vertex Buffer type: ${vertexBufferKind}`);
                        }
                    }
                    this._writeVertexAttributeData(vertexData, byteOffset, vertexBufferKind, binaryWriter);
                }
            }
            else {
                Tools.Warn(`reorderTriangleFillMode: Vertex Buffer Kind ${vertexBufferKind} not present!`);
            }
        }
        /**
         * Reorders the vertex attributes in the correct triangle strip order.  This is necessary when indices are not available and the winding order is
         * clock-wise during export to glTF
         * @param submesh BabylonJS submesh
         * @param vertexBufferKind The type of vertex attribute
         * @param meshAttributeArray The vertex attribute data
         * @param byteOffset The offset to the binary data
         * @param binaryWriter The binary data for the glTF file
         */
        _reorderTriangleStripDrawMode(submesh, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter) {
            const vertexBuffer = this._getVertexBufferFromMesh(vertexBufferKind, submesh.getMesh());
            if (vertexBuffer) {
                const stride = vertexBuffer.byteStride / VertexBuffer.GetTypeByteLength(vertexBuffer.type);
                const vertexData = [];
                let index = 0;
                switch (vertexBufferKind) {
                    case VertexBuffer.PositionKind:
                    case VertexBuffer.NormalKind: {
                        index = submesh.verticesStart;
                        vertexData.push(Vector3.FromArray(meshAttributeArray, index + 2 * stride));
                        vertexData.push(Vector3.FromArray(meshAttributeArray, index + stride));
                        break;
                    }
                    case VertexBuffer.TangentKind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexData.push(Vector4.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    case VertexBuffer.ColorKind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexBuffer.getSize() === 4
                                ? vertexData.push(Vector4.FromArray(meshAttributeArray, index))
                                : vertexData.push(Vector3.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    case VertexBuffer.UVKind:
                    case VertexBuffer.UV2Kind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexData.push(Vector2.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    default: {
                        Tools.Error(`Unsupported Vertex Buffer type: ${vertexBufferKind}`);
                    }
                }
                this._writeVertexAttributeData(vertexData, byteOffset + 12, vertexBufferKind, binaryWriter);
            }
            else {
                Tools.Warn(`reorderTriangleStripDrawMode: Vertex buffer kind ${vertexBufferKind} not present!`);
            }
        }
        /**
         * Reorders the vertex attributes in the correct triangle fan order.  This is necessary when indices are not available and the winding order is
         * clock-wise during export to glTF
         * @param submesh BabylonJS submesh
         * @param vertexBufferKind The type of vertex attribute
         * @param meshAttributeArray The vertex attribute data
         * @param byteOffset The offset to the binary data
         * @param binaryWriter The binary data for the glTF file
         */
        _reorderTriangleFanMode(submesh, vertexBufferKind, meshAttributeArray, byteOffset, binaryWriter) {
            const vertexBuffer = this._getVertexBufferFromMesh(vertexBufferKind, submesh.getMesh());
            if (vertexBuffer) {
                const stride = vertexBuffer.byteStride / VertexBuffer.GetTypeByteLength(vertexBuffer.type);
                const vertexData = [];
                let index = 0;
                switch (vertexBufferKind) {
                    case VertexBuffer.PositionKind:
                    case VertexBuffer.NormalKind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexData.push(Vector3.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    case VertexBuffer.TangentKind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexData.push(Vector4.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    case VertexBuffer.ColorKind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexData.push(Vector4.FromArray(meshAttributeArray, index));
                            vertexBuffer.getSize() === 4
                                ? vertexData.push(Vector4.FromArray(meshAttributeArray, index))
                                : vertexData.push(Vector3.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    case VertexBuffer.UVKind:
                    case VertexBuffer.UV2Kind: {
                        for (let x = submesh.verticesStart + submesh.verticesCount - 1; x >= submesh.verticesStart; --x) {
                            index = x * stride;
                            vertexData.push(Vector2.FromArray(meshAttributeArray, index));
                        }
                        break;
                    }
                    default: {
                        Tools.Error(`Unsupported Vertex Buffer type: ${vertexBufferKind}`);
                    }
                }
                this._writeVertexAttributeData(vertexData, byteOffset, vertexBufferKind, binaryWriter);
            }
            else {
                Tools.Warn(`reorderTriangleFanMode: Vertex buffer kind ${vertexBufferKind} not present!`);
            }
        }
        /**
         * Writes the vertex attribute data to binary
         * @param vertices The vertices to write to the binary writer
         * @param byteOffset The offset into the binary writer to overwrite binary data
         * @param vertexAttributeKind The vertex attribute type
         * @param binaryWriter The writer containing the binary data
         */
        _writeVertexAttributeData(vertices, byteOffset, vertexAttributeKind, binaryWriter) {
            for (const vertex of vertices) {
                if (vertexAttributeKind === VertexBuffer.NormalKind) {
                    vertex.normalize();
                }
                else if (vertexAttributeKind === VertexBuffer.TangentKind && vertex instanceof Vector4) {
                    _GLTFUtilities._NormalizeTangentFromRef(vertex);
                }
                for (const component of vertex.asArray()) {
                    binaryWriter.setFloat32(component, byteOffset);
                    byteOffset += 4;
                }
            }
        }
        /**
         * Writes mesh attribute data to a data buffer
         * Returns the bytelength of the data
         * @param vertexBufferKind Indicates what kind of vertex data is being passed in
         * @param attributeComponentKind
         * @param meshAttributeArray Array containing the attribute data
         * @param stride Specifies the space between data
         * @param binaryWriter The buffer to write the binary data to
         * @param babylonTransformNode
         */
        _writeAttributeData(vertexBufferKind, attributeComponentKind, meshAttributeArray, stride, binaryWriter, babylonTransformNode) {
            let vertexAttributes = [];
            let index;
            switch (vertexBufferKind) {
                case VertexBuffer.PositionKind: {
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        const vertexData = Vector3.FromArray(meshAttributeArray, index);
                        vertexAttributes.push(vertexData.asArray());
                    }
                    break;
                }
                case VertexBuffer.NormalKind: {
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        const vertexData = Vector3.FromArray(meshAttributeArray, index);
                        vertexAttributes.push(vertexData.normalize().asArray());
                    }
                    break;
                }
                case VertexBuffer.TangentKind: {
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        const vertexData = Vector4.FromArray(meshAttributeArray, index);
                        _GLTFUtilities._NormalizeTangentFromRef(vertexData);
                        vertexAttributes.push(vertexData.asArray());
                    }
                    break;
                }
                case VertexBuffer.ColorKind: {
                    const meshMaterial = babylonTransformNode.material;
                    const convertToLinear = meshMaterial ? meshMaterial.getClassName() === "StandardMaterial" : true;
                    const vertexData = stride === 3 ? new Color3() : new Color4();
                    const useExactSrgbConversions = this._babylonScene.getEngine().useExactSrgbConversions;
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        if (stride === 3) {
                            Color3.FromArrayToRef(meshAttributeArray, index, vertexData);
                            if (convertToLinear) {
                                vertexData.toLinearSpaceToRef(vertexData, useExactSrgbConversions);
                            }
                        }
                        else {
                            Color4.FromArrayToRef(meshAttributeArray, index, vertexData);
                            if (convertToLinear) {
                                vertexData.toLinearSpaceToRef(vertexData, useExactSrgbConversions);
                            }
                        }
                        vertexAttributes.push(vertexData.asArray());
                    }
                    break;
                }
                case VertexBuffer.UVKind:
                case VertexBuffer.UV2Kind: {
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        const vertexData = Vector2.FromArray(meshAttributeArray, index);
                        vertexAttributes.push(vertexData.asArray());
                    }
                    break;
                }
                case VertexBuffer.MatricesIndicesKind:
                case VertexBuffer.MatricesIndicesExtraKind: {
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        const vertexData = Vector4.FromArray(meshAttributeArray, index);
                        vertexAttributes.push(vertexData.asArray());
                    }
                    break;
                }
                case VertexBuffer.MatricesWeightsKind:
                case VertexBuffer.MatricesWeightsExtraKind: {
                    for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
                        index = k * stride;
                        const vertexData = Vector4.FromArray(meshAttributeArray, index);
                        vertexAttributes.push(vertexData.asArray());
                    }
                    break;
                }
                default: {
                    Tools.Warn("Unsupported Vertex Buffer Type: " + vertexBufferKind);
                    vertexAttributes = [];
                }
            }
            let writeBinaryFunc;
            switch (attributeComponentKind) {
                case 5121 /* AccessorComponentType.UNSIGNED_BYTE */: {
                    writeBinaryFunc = binaryWriter.setUInt8.bind(binaryWriter);
                    break;
                }
                case 5123 /* AccessorComponentType.UNSIGNED_SHORT */: {
                    writeBinaryFunc = binaryWriter.setUInt16.bind(binaryWriter);
                    break;
                }
                case 5125 /* AccessorComponentType.UNSIGNED_INT */: {
                    writeBinaryFunc = binaryWriter.setUInt32.bind(binaryWriter);
                    break;
                }
                case 5126 /* AccessorComponentType.FLOAT */: {
                    writeBinaryFunc = binaryWriter.setFloat32.bind(binaryWriter);
                    break;
                }
                default: {
                    Tools.Warn("Unsupported Attribute Component kind: " + attributeComponentKind);
                    return;
                }
            }
            for (const vertexAttribute of vertexAttributes) {
                for (const component of vertexAttribute) {
                    writeBinaryFunc(component);
                }
            }
        }
        /**
         * Writes mesh attribute data to a data buffer
         * Returns the bytelength of the data
         * @param vertexBufferKind Indicates what kind of vertex data is being passed in
         * @param attributeComponentKind
         * @param meshPrimitive
         * @param morphTarget
         * @param meshAttributeArray Array containing the attribute data
         * @param morphTargetAttributeArray
         * @param stride Specifies the space between data
         * @param binaryWriter The buffer to write the binary data to
         * @param minMax
         */
        writeMorphTargetAttributeData(vertexBufferKind, attributeComponentKind, meshPrimitive, meshAttributeArray, morphTargetAttributeArray, stride, binaryWriter, minMax) {
            let vertexAttributes = [];
            let index;
            let difference = new Vector3();
            let difference4 = new Vector4(0, 0, 0, 0);
            switch (vertexBufferKind) {
                case VertexBuffer.PositionKind: {
                    for (let k = meshPrimitive.verticesStart; k < meshPrimitive.verticesCount; ++k) {
                        index = meshPrimitive.indexStart + k * stride;
                        const vertexData = Vector3.FromArray(meshAttributeArray, index);
                        const morphData = Vector3.FromArray(morphTargetAttributeArray, index);
                        difference = morphData.subtractToRef(vertexData, difference);
                        if (minMax) {
                            minMax.min.copyFromFloats(Math.min(difference.x, minMax.min.x), Math.min(difference.y, minMax.min.y), Math.min(difference.z, minMax.min.z));
                            minMax.max.copyFromFloats(Math.max(difference.x, minMax.max.x), Math.max(difference.y, minMax.max.y), Math.max(difference.z, minMax.max.z));
                        }
                        vertexAttributes.push(difference.asArray());
                    }
                    break;
                }
                case VertexBuffer.NormalKind: {
                    for (let k = meshPrimitive.verticesStart; k < meshPrimitive.verticesCount; ++k) {
                        index = meshPrimitive.indexStart + k * stride;
                        const vertexData = Vector3.FromArray(meshAttributeArray, index).normalize();
                        const morphData = Vector3.FromArray(morphTargetAttributeArray, index).normalize();
                        difference = morphData.subtractToRef(vertexData, difference);
                        vertexAttributes.push(difference.asArray());
                    }
                    break;
                }
                case VertexBuffer.TangentKind: {
                    for (let k = meshPrimitive.verticesStart; k < meshPrimitive.verticesCount; ++k) {
                        index = meshPrimitive.indexStart + k * (stride + 1);
                        const vertexData = Vector4.FromArray(meshAttributeArray, index);
                        _GLTFUtilities._NormalizeTangentFromRef(vertexData);
                        const morphData = Vector4.FromArray(morphTargetAttributeArray, index);
                        _GLTFUtilities._NormalizeTangentFromRef(morphData);
                        difference4 = morphData.subtractToRef(vertexData, difference4);
                        vertexAttributes.push([difference4.x, difference4.y, difference4.z]);
                    }
                    break;
                }
                default: {
                    Tools.Warn("Unsupported Vertex Buffer Type: " + vertexBufferKind);
                    vertexAttributes = [];
                }
            }
            let writeBinaryFunc;
            switch (attributeComponentKind) {
                case 5121 /* AccessorComponentType.UNSIGNED_BYTE */: {
                    writeBinaryFunc = binaryWriter.setUInt8.bind(binaryWriter);
                    break;
                }
                case 5123 /* AccessorComponentType.UNSIGNED_SHORT */: {
                    writeBinaryFunc = binaryWriter.setUInt16.bind(binaryWriter);
                    break;
                }
                case 5125 /* AccessorComponentType.UNSIGNED_INT */: {
                    writeBinaryFunc = binaryWriter.setUInt32.bind(binaryWriter);
                    break;
                }
                case 5126 /* AccessorComponentType.FLOAT */: {
                    writeBinaryFunc = binaryWriter.setFloat32.bind(binaryWriter);
                    break;
                }
                default: {
                    Tools.Warn("Unsupported Attribute Component kind: " + attributeComponentKind);
                    return;
                }
            }
            for (const vertexAttribute of vertexAttributes) {
                for (const component of vertexAttribute) {
                    writeBinaryFunc(component);
                }
            }
        }
        /**
         * Generates glTF json data
         * @param shouldUseGlb Indicates whether the json should be written for a glb file
         * @param glTFPrefix Text to use when prefixing a glTF file
         * @param prettyPrint Indicates whether the json file should be pretty printed (true) or not (false)
         * @returns json data as string
         */
        _generateJSON(shouldUseGlb, glTFPrefix, prettyPrint) {
            const buffer = { byteLength: this._totalByteLength };
            let imageName;
            let imageData;
            let bufferView;
            let byteOffset = this._totalByteLength;
            if (buffer.byteLength) {
                this._glTF.buffers = [buffer];
            }
            if (this._nodes && this._nodes.length) {
                this._glTF.nodes = this._nodes;
            }
            if (this._meshes && this._meshes.length) {
                this._glTF.meshes = this._meshes;
            }
            if (this._scenes && this._scenes.length) {
                this._glTF.scenes = this._scenes;
                this._glTF.scene = 0;
            }
            if (this._cameras && this._cameras.length) {
                this._glTF.cameras = this._cameras;
            }
            if (this._bufferViews && this._bufferViews.length) {
                this._glTF.bufferViews = this._bufferViews;
            }
            if (this._accessors && this._accessors.length) {
                this._glTF.accessors = this._accessors;
            }
            if (this._animations && this._animations.length) {
                this._glTF.animations = this._animations;
            }
            if (this._materials && this._materials.length) {
                this._glTF.materials = this._materials;
            }
            if (this._textures && this._textures.length) {
                this._glTF.textures = this._textures;
            }
            if (this._samplers && this._samplers.length) {
                this._glTF.samplers = this._samplers;
            }
            if (this._skins && this._skins.length) {
                this._glTF.skins = this._skins;
            }
            if (this._images && this._images.length) {
                if (!shouldUseGlb) {
                    this._glTF.images = this._images;
                }
                else {
                    this._glTF.images = [];
                    this._images.forEach((image) => {
                        if (image.uri) {
                            imageData = this._imageData[image.uri];
                            this._orderedImageData.push(imageData);
                            imageName = image.uri.split(".")[0] + " image";
                            bufferView = _GLTFUtilities._CreateBufferView(0, byteOffset, imageData.data.byteLength, undefined, imageName);
                            byteOffset += imageData.data.byteLength;
                            this._bufferViews.push(bufferView);
                            image.bufferView = this._bufferViews.length - 1;
                            image.name = imageName;
                            image.mimeType = imageData.mimeType;
                            image.uri = undefined;
                            if (!this._glTF.images) {
                                this._glTF.images = [];
                            }
                            this._glTF.images.push(image);
                        }
                    });
                    // Replace uri with bufferview and mime type for glb
                    buffer.byteLength = byteOffset;
                }
            }
            if (!shouldUseGlb) {
                buffer.uri = glTFPrefix + ".bin";
            }
            const jsonText = prettyPrint ? JSON.stringify(this._glTF, null, 2) : JSON.stringify(this._glTF);
            return jsonText;
        }
        /**
         * Generates data for .gltf and .bin files based on the glTF prefix string
         * @param glTFPrefix Text to use when prefixing a glTF file
         * @param dispose Dispose the exporter
         * @returns GLTFData with glTF file data
         */
        _generateGLTFAsync(glTFPrefix, dispose = true) {
            return this._generateBinaryAsync().then((binaryBuffer) => {
                this._extensionsOnExporting();
                const jsonText = this._generateJSON(false, glTFPrefix, true);
                const bin = new Blob([binaryBuffer], { type: "application/octet-stream" });
                const glTFFileName = glTFPrefix + ".gltf";
                const glTFBinFile = glTFPrefix + ".bin";
                const container = new GLTFData();
                container.glTFFiles[glTFFileName] = jsonText;
                container.glTFFiles[glTFBinFile] = bin;
                if (this._imageData) {
                    for (const image in this._imageData) {
                        container.glTFFiles[image] = new Blob([this._imageData[image].data], { type: this._imageData[image].mimeType });
                    }
                }
                if (dispose) {
                    this.dispose();
                }
                return container;
            });
        }
        /**
         * Creates a binary buffer for glTF
         * @returns array buffer for binary data
         */
        _generateBinaryAsync() {
            const binaryWriter = new _BinaryWriter(4);
            return this._createSceneAsync(binaryWriter).then(() => {
                if (this._localEngine) {
                    this._localEngine.dispose();
                }
                return binaryWriter.getArrayBuffer();
            });
        }
        /**
         * Pads the number to a multiple of 4
         * @param num number to pad
         * @returns padded number
         */
        _getPadding(num) {
            const remainder = num % 4;
            const padding = remainder === 0 ? remainder : 4 - remainder;
            return padding;
        }
        /**
         * @internal
         */
        _generateGLBAsync(glTFPrefix, dispose = true) {
            return this._generateBinaryAsync().then((binaryBuffer) => {
                this._extensionsOnExporting();
                const jsonText = this._generateJSON(true);
                const glbFileName = glTFPrefix + ".glb";
                const headerLength = 12;
                const chunkLengthPrefix = 8;
                let jsonLength = jsonText.length;
                let encodedJsonText;
                let imageByteLength = 0;
                // make use of TextEncoder when available
                if (typeof TextEncoder !== "undefined") {
                    const encoder = new TextEncoder();
                    encodedJsonText = encoder.encode(jsonText);
                    jsonLength = encodedJsonText.length;
                }
                for (let i = 0; i < this._orderedImageData.length; ++i) {
                    imageByteLength += this._orderedImageData[i].data.byteLength;
                }
                const jsonPadding = this._getPadding(jsonLength);
                const binPadding = this._getPadding(binaryBuffer.byteLength);
                const imagePadding = this._getPadding(imageByteLength);
                const byteLength = headerLength + 2 * chunkLengthPrefix + jsonLength + jsonPadding + binaryBuffer.byteLength + binPadding + imageByteLength + imagePadding;
                //header
                const headerBuffer = new ArrayBuffer(headerLength);
                const headerBufferView = new DataView(headerBuffer);
                headerBufferView.setUint32(0, 0x46546c67, true); //glTF
                headerBufferView.setUint32(4, 2, true); // version
                headerBufferView.setUint32(8, byteLength, true); // total bytes in file
                //json chunk
                const jsonChunkBuffer = new ArrayBuffer(chunkLengthPrefix + jsonLength + jsonPadding);
                const jsonChunkBufferView = new DataView(jsonChunkBuffer);
                jsonChunkBufferView.setUint32(0, jsonLength + jsonPadding, true);
                jsonChunkBufferView.setUint32(4, 0x4e4f534a, true);
                //json chunk bytes
                const jsonData = new Uint8Array(jsonChunkBuffer, chunkLengthPrefix);
                // if TextEncoder was available, we can simply copy the encoded array
                if (encodedJsonText) {
                    jsonData.set(encodedJsonText);
                }
                else {
                    const blankCharCode = "_".charCodeAt(0);
                    for (let i = 0; i < jsonLength; ++i) {
                        const charCode = jsonText.charCodeAt(i);
                        // if the character doesn't fit into a single UTF-16 code unit, just put a blank character
                        if (charCode != jsonText.codePointAt(i)) {
                            jsonData[i] = blankCharCode;
                        }
                        else {
                            jsonData[i] = charCode;
                        }
                    }
                }
                //json padding
                const jsonPaddingView = new Uint8Array(jsonChunkBuffer, chunkLengthPrefix + jsonLength);
                for (let i = 0; i < jsonPadding; ++i) {
                    jsonPaddingView[i] = 0x20;
                }
                //binary chunk
                const binaryChunkBuffer = new ArrayBuffer(chunkLengthPrefix);
                const binaryChunkBufferView = new DataView(binaryChunkBuffer);
                binaryChunkBufferView.setUint32(0, binaryBuffer.byteLength + imageByteLength + imagePadding, true);
                binaryChunkBufferView.setUint32(4, 0x004e4942, true);
                // binary padding
                const binPaddingBuffer = new ArrayBuffer(binPadding);
                const binPaddingView = new Uint8Array(binPaddingBuffer);
                for (let i = 0; i < binPadding; ++i) {
                    binPaddingView[i] = 0;
                }
                const imagePaddingBuffer = new ArrayBuffer(imagePadding);
                const imagePaddingView = new Uint8Array(imagePaddingBuffer);
                for (let i = 0; i < imagePadding; ++i) {
                    imagePaddingView[i] = 0;
                }
                const glbData = [headerBuffer, jsonChunkBuffer, binaryChunkBuffer, binaryBuffer];
                // binary data
                for (let i = 0; i < this._orderedImageData.length; ++i) {
                    glbData.push(this._orderedImageData[i].data);
                }
                glbData.push(binPaddingBuffer);
                glbData.push(imagePaddingBuffer);
                const glbFile = new Blob(glbData, { type: "application/octet-stream" });
                const container = new GLTFData();
                container.glTFFiles[glbFileName] = glbFile;
                if (this._localEngine != null) {
                    this._localEngine.dispose();
                }
                if (dispose) {
                    this.dispose();
                }
                return container;
            });
        }
        /**
         * Sets the TRS for each node
         * @param node glTF Node for storing the transformation data
         * @param babylonTransformNode Babylon mesh used as the source for the transformation data
         */
        _setNodeTransformation(node, babylonTransformNode) {
            if (!babylonTransformNode.getPivotPoint().equalsToFloats(0, 0, 0)) {
                Tools.Warn("Pivot points are not supported in the glTF serializer");
            }
            if (!babylonTransformNode.position.equalsToFloats(0, 0, 0)) {
                node.translation = babylonTransformNode.position.asArray();
            }
            if (!babylonTransformNode.scaling.equalsToFloats(1, 1, 1)) {
                node.scale = babylonTransformNode.scaling.asArray();
            }
            const rotationQuaternion = Quaternion.RotationYawPitchRoll(babylonTransformNode.rotation.y, babylonTransformNode.rotation.x, babylonTransformNode.rotation.z);
            if (babylonTransformNode.rotationQuaternion) {
                rotationQuaternion.multiplyInPlace(babylonTransformNode.rotationQuaternion);
            }
            if (!Quaternion.IsIdentity(rotationQuaternion)) {
                node.rotation = rotationQuaternion.normalize().asArray();
            }
        }
        _setCameraTransformation(node, babylonCamera) {
            if (!babylonCamera.position.equalsToFloats(0, 0, 0)) {
                node.translation = babylonCamera.position.asArray();
            }
            const rotationQuaternion = babylonCamera.rotationQuaternion; // we target the local transformation if one.
            if (rotationQuaternion && !Quaternion.IsIdentity(rotationQuaternion)) {
                node.rotation = rotationQuaternion.normalize().asArray();
            }
        }
        _getVertexBufferFromMesh(attributeKind, bufferMesh) {
            if (bufferMesh.isVerticesDataPresent(attributeKind, true)) {
                const vertexBuffer = bufferMesh.getVertexBuffer(attributeKind, true);
                if (vertexBuffer) {
                    return vertexBuffer;
                }
            }
            return null;
        }
        /**
         * Creates a bufferview based on the vertices type for the Babylon mesh
         * @param kind Indicates the type of vertices data
         * @param attributeComponentKind Indicates the numerical type used to store the data
         * @param babylonTransformNode The Babylon mesh to get the vertices data from
         * @param binaryWriter The buffer to write the bufferview data to
         * @param byteStride
         */
        _createBufferViewKind(kind, attributeComponentKind, babylonTransformNode, binaryWriter, byteStride) {
            const bufferMesh = babylonTransformNode instanceof Mesh
                ? babylonTransformNode
                : babylonTransformNode instanceof InstancedMesh
                    ? babylonTransformNode.sourceMesh
                    : null;
            if (bufferMesh) {
                const vertexBuffer = bufferMesh.getVertexBuffer(kind, true);
                const vertexData = bufferMesh.getVerticesData(kind, undefined, undefined, true);
                if (vertexBuffer && vertexData) {
                    const typeByteLength = VertexBuffer.GetTypeByteLength(attributeComponentKind);
                    const byteLength = vertexData.length * typeByteLength;
                    const bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, byteStride, kind + " - " + bufferMesh.name);
                    this._bufferViews.push(bufferView);
                    this._writeAttributeData(kind, attributeComponentKind, vertexData, byteStride / typeByteLength, binaryWriter, babylonTransformNode);
                }
            }
        }
        /**
         * Creates a bufferview based on the vertices type for the Babylon mesh
         * @param babylonSubMesh The Babylon submesh that the morph target is applied to
         * @param meshPrimitive
         * @param babylonMorphTarget the morph target to be exported
         * @param binaryWriter The buffer to write the bufferview data to
         */
        _setMorphTargetAttributes(babylonSubMesh, meshPrimitive, babylonMorphTarget, binaryWriter) {
            if (babylonMorphTarget) {
                if (!meshPrimitive.targets) {
                    meshPrimitive.targets = [];
                }
                const target = {};
                const mesh = babylonSubMesh.getMesh();
                if (babylonMorphTarget.hasNormals) {
                    const vertexNormals = mesh.getVerticesData(VertexBuffer.NormalKind, undefined, undefined, true);
                    const morphNormals = babylonMorphTarget.getNormals();
                    const count = babylonSubMesh.verticesCount;
                    const byteStride = 12; // 3 x 4 byte floats
                    const byteLength = count * byteStride;
                    const bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, byteStride, babylonMorphTarget.name + "_NORMAL");
                    this._bufferViews.push(bufferView);
                    const bufferViewIndex = this._bufferViews.length - 1;
                    const accessor = _GLTFUtilities._CreateAccessor(bufferViewIndex, babylonMorphTarget.name + " - " + "NORMAL", "VEC3" /* AccessorType.VEC3 */, 5126 /* AccessorComponentType.FLOAT */, count, 0, null, null);
                    this._accessors.push(accessor);
                    target.NORMAL = this._accessors.length - 1;
                    this.writeMorphTargetAttributeData(VertexBuffer.NormalKind, 5126 /* AccessorComponentType.FLOAT */, babylonSubMesh, vertexNormals, morphNormals, byteStride / 4, binaryWriter);
                }
                if (babylonMorphTarget.hasPositions) {
                    const vertexPositions = mesh.getVerticesData(VertexBuffer.PositionKind, undefined, undefined, true);
                    const morphPositions = babylonMorphTarget.getPositions();
                    const count = babylonSubMesh.verticesCount;
                    const byteStride = 12; // 3 x 4 byte floats
                    const byteLength = count * byteStride;
                    const bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, byteStride, babylonMorphTarget.name + "_POSITION");
                    this._bufferViews.push(bufferView);
                    const bufferViewIndex = this._bufferViews.length - 1;
                    const minMax = { min: new Vector3(Infinity, Infinity, Infinity), max: new Vector3(-Infinity, -Infinity, -Infinity) };
                    const accessor = _GLTFUtilities._CreateAccessor(bufferViewIndex, babylonMorphTarget.name + " - " + "POSITION", "VEC3" /* AccessorType.VEC3 */, 5126 /* AccessorComponentType.FLOAT */, count, 0, null, null);
                    this._accessors.push(accessor);
                    target.POSITION = this._accessors.length - 1;
                    this.writeMorphTargetAttributeData(VertexBuffer.PositionKind, 5126 /* AccessorComponentType.FLOAT */, babylonSubMesh, vertexPositions, morphPositions, byteStride / 4, binaryWriter, minMax);
                    accessor.min = minMax.min.asArray();
                    accessor.max = minMax.max.asArray();
                }
                if (babylonMorphTarget.hasTangents) {
                    const vertexTangents = mesh.getVerticesData(VertexBuffer.TangentKind, undefined, undefined, true);
                    const morphTangents = babylonMorphTarget.getTangents();
                    const count = babylonSubMesh.verticesCount;
                    const byteStride = 12; // 3 x 4 byte floats
                    const byteLength = count * byteStride;
                    const bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, byteStride, babylonMorphTarget.name + "_NORMAL");
                    this._bufferViews.push(bufferView);
                    const bufferViewIndex = this._bufferViews.length - 1;
                    const accessor = _GLTFUtilities._CreateAccessor(bufferViewIndex, babylonMorphTarget.name + " - " + "TANGENT", "VEC3" /* AccessorType.VEC3 */, 5126 /* AccessorComponentType.FLOAT */, count, 0, null, null);
                    this._accessors.push(accessor);
                    target.TANGENT = this._accessors.length - 1;
                    this.writeMorphTargetAttributeData(VertexBuffer.TangentKind, 5126 /* AccessorComponentType.FLOAT */, babylonSubMesh, vertexTangents, morphTangents, byteStride / 4, binaryWriter);
                }
                meshPrimitive.targets.push(target);
            }
        }
        /**
         * The primitive mode of the Babylon mesh
         * @param babylonMesh The BabylonJS mesh
         */
        _getMeshPrimitiveMode(babylonMesh) {
            if (babylonMesh instanceof LinesMesh) {
                return Material.LineListDrawMode;
            }
            if (babylonMesh instanceof InstancedMesh || babylonMesh instanceof Mesh) {
                const baseMesh = babylonMesh instanceof Mesh ? babylonMesh : babylonMesh.sourceMesh;
                if (typeof baseMesh.overrideRenderingFillMode === "number") {
                    return baseMesh.overrideRenderingFillMode;
                }
            }
            return babylonMesh.material ? babylonMesh.material.fillMode : Material.TriangleFillMode;
        }
        /**
         * Sets the primitive mode of the glTF mesh primitive
         * @param meshPrimitive glTF mesh primitive
         * @param primitiveMode The primitive mode
         */
        _setPrimitiveMode(meshPrimitive, primitiveMode) {
            switch (primitiveMode) {
                case Material.TriangleFillMode: {
                    // glTF defaults to using Triangle Mode
                    break;
                }
                case Material.TriangleStripDrawMode: {
                    meshPrimitive.mode = 5 /* MeshPrimitiveMode.TRIANGLE_STRIP */;
                    break;
                }
                case Material.TriangleFanDrawMode: {
                    meshPrimitive.mode = 6 /* MeshPrimitiveMode.TRIANGLE_FAN */;
                    break;
                }
                case Material.PointListDrawMode: {
                    meshPrimitive.mode = 0 /* MeshPrimitiveMode.POINTS */;
                    break;
                }
                case Material.PointFillMode: {
                    meshPrimitive.mode = 0 /* MeshPrimitiveMode.POINTS */;
                    break;
                }
                case Material.LineLoopDrawMode: {
                    meshPrimitive.mode = 2 /* MeshPrimitiveMode.LINE_LOOP */;
                    break;
                }
                case Material.LineListDrawMode: {
                    meshPrimitive.mode = 1 /* MeshPrimitiveMode.LINES */;
                    break;
                }
                case Material.LineStripDrawMode: {
                    meshPrimitive.mode = 3 /* MeshPrimitiveMode.LINE_STRIP */;
                    break;
                }
            }
        }
        /**
         * Sets the vertex attribute accessor based of the glTF mesh primitive
         * @param meshPrimitive glTF mesh primitive
         * @param attributeKind vertex attribute
         * @returns boolean specifying if uv coordinates are present
         */
        _setAttributeKind(meshPrimitive, attributeKind) {
            switch (attributeKind) {
                case VertexBuffer.PositionKind: {
                    meshPrimitive.attributes.POSITION = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.NormalKind: {
                    meshPrimitive.attributes.NORMAL = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.ColorKind: {
                    meshPrimitive.attributes.COLOR_0 = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.TangentKind: {
                    meshPrimitive.attributes.TANGENT = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.UVKind: {
                    meshPrimitive.attributes.TEXCOORD_0 = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.UV2Kind: {
                    meshPrimitive.attributes.TEXCOORD_1 = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.MatricesIndicesKind: {
                    meshPrimitive.attributes.JOINTS_0 = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.MatricesIndicesExtraKind: {
                    meshPrimitive.attributes.JOINTS_1 = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.MatricesWeightsKind: {
                    meshPrimitive.attributes.WEIGHTS_0 = this._accessors.length - 1;
                    break;
                }
                case VertexBuffer.MatricesWeightsExtraKind: {
                    meshPrimitive.attributes.WEIGHTS_1 = this._accessors.length - 1;
                    break;
                }
                default: {
                    Tools.Warn("Unsupported Vertex Buffer Type: " + attributeKind);
                }
            }
        }
        /**
         * Sets data for the primitive attributes of each submesh
         * @param mesh glTF Mesh object to store the primitive attribute information
         * @param babylonTransformNode Babylon mesh to get the primitive attribute data from
         * @param binaryWriter Buffer to write the attribute data to
         */
        _setPrimitiveAttributesAsync(mesh, babylonTransformNode, binaryWriter) {
            const promises = [];
            let bufferMesh = null;
            let bufferView;
            let minMax;
            if (babylonTransformNode instanceof Mesh) {
                bufferMesh = babylonTransformNode;
            }
            else if (babylonTransformNode instanceof InstancedMesh) {
                bufferMesh = babylonTransformNode.sourceMesh;
            }
            const attributeData = [
                { kind: VertexBuffer.PositionKind, accessorType: "VEC3" /* AccessorType.VEC3 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 12 },
                { kind: VertexBuffer.NormalKind, accessorType: "VEC3" /* AccessorType.VEC3 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 12 },
                { kind: VertexBuffer.ColorKind, accessorType: "VEC4" /* AccessorType.VEC4 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 16 },
                { kind: VertexBuffer.TangentKind, accessorType: "VEC4" /* AccessorType.VEC4 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 16 },
                { kind: VertexBuffer.UVKind, accessorType: "VEC2" /* AccessorType.VEC2 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 8 },
                { kind: VertexBuffer.UV2Kind, accessorType: "VEC2" /* AccessorType.VEC2 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 8 },
                { kind: VertexBuffer.MatricesIndicesKind, accessorType: "VEC4" /* AccessorType.VEC4 */, accessorComponentType: 5123 /* AccessorComponentType.UNSIGNED_SHORT */, byteStride: 8 },
                { kind: VertexBuffer.MatricesIndicesExtraKind, accessorType: "VEC4" /* AccessorType.VEC4 */, accessorComponentType: 5123 /* AccessorComponentType.UNSIGNED_SHORT */, byteStride: 8 },
                { kind: VertexBuffer.MatricesWeightsKind, accessorType: "VEC4" /* AccessorType.VEC4 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 16 },
                { kind: VertexBuffer.MatricesWeightsExtraKind, accessorType: "VEC4" /* AccessorType.VEC4 */, accessorComponentType: 5126 /* AccessorComponentType.FLOAT */, byteStride: 16 },
            ];
            if (bufferMesh) {
                let indexBufferViewIndex = null;
                const primitiveMode = this._getMeshPrimitiveMode(bufferMesh);
                const vertexAttributeBufferViews = {};
                const morphTargetManager = bufferMesh.morphTargetManager;
                // For each BabylonMesh, create bufferviews for each 'kind'
                for (const attribute of attributeData) {
                    const attributeKind = attribute.kind;
                    const attributeComponentKind = attribute.accessorComponentType;
                    if (bufferMesh.isVerticesDataPresent(attributeKind, true)) {
                        const vertexBuffer = this._getVertexBufferFromMesh(attributeKind, bufferMesh);
                        attribute.byteStride = vertexBuffer
                            ? vertexBuffer.getSize() * VertexBuffer.GetTypeByteLength(attribute.accessorComponentType)
                            : VertexBuffer.DeduceStride(attributeKind) * 4;
                        if (attribute.byteStride === 12) {
                            attribute.accessorType = "VEC3" /* AccessorType.VEC3 */;
                        }
                        this._createBufferViewKind(attributeKind, attributeComponentKind, babylonTransformNode, binaryWriter, attribute.byteStride);
                        attribute.bufferViewIndex = this._bufferViews.length - 1;
                        vertexAttributeBufferViews[attributeKind] = attribute.bufferViewIndex;
                    }
                }
                if (bufferMesh.getTotalIndices()) {
                    const indices = bufferMesh.getIndices();
                    if (indices) {
                        const byteLength = indices.length * 4;
                        bufferView = _GLTFUtilities._CreateBufferView(0, binaryWriter.getByteOffset(), byteLength, undefined, "Indices - " + bufferMesh.name);
                        this._bufferViews.push(bufferView);
                        indexBufferViewIndex = this._bufferViews.length - 1;
                        for (let k = 0, length = indices.length; k < length; ++k) {
                            binaryWriter.setUInt32(indices[k]);
                        }
                    }
                }
                if (bufferMesh.subMeshes) {
                    // go through all mesh primitives (submeshes)
                    for (const submesh of bufferMesh.subMeshes) {
                        let babylonMaterial = submesh.getMaterial() || bufferMesh.getScene().defaultMaterial;
                        let materialIndex = null;
                        if (babylonMaterial) {
                            if (bufferMesh instanceof LinesMesh) {
                                // get the color from the lines mesh and set it in the material
                                const material = {
                                    name: bufferMesh.name + " material",
                                };
                                if (!bufferMesh.color.equals(Color3.White()) || bufferMesh.alpha < 1) {
                                    material.pbrMetallicRoughness = {
                                        baseColorFactor: bufferMesh.color.asArray().concat([bufferMesh.alpha]),
                                    };
                                }
                                this._materials.push(material);
                                materialIndex = this._materials.length - 1;
                            }
                            else if (babylonMaterial instanceof MultiMaterial) {
                                const subMaterial = babylonMaterial.subMaterials[submesh.materialIndex];
                                if (subMaterial) {
                                    babylonMaterial = subMaterial;
                                    materialIndex = this._materialMap[babylonMaterial.uniqueId];
                                }
                            }
                            else {
                                materialIndex = this._materialMap[babylonMaterial.uniqueId];
                            }
                        }
                        const glTFMaterial = materialIndex != null ? this._materials[materialIndex] : null;
                        const meshPrimitive = { attributes: {} };
                        this._setPrimitiveMode(meshPrimitive, primitiveMode);
                        for (const attribute of attributeData) {
                            const attributeKind = attribute.kind;
                            if ((attributeKind === VertexBuffer.UVKind || attributeKind === VertexBuffer.UV2Kind) && !this._options.exportUnusedUVs) {
                                if (!glTFMaterial || !this._glTFMaterialExporter._hasTexturesPresent(glTFMaterial)) {
                                    continue;
                                }
                            }
                            const vertexData = bufferMesh.getVerticesData(attributeKind, undefined, undefined, true);
                            if (vertexData) {
                                const vertexBuffer = this._getVertexBufferFromMesh(attributeKind, bufferMesh);
                                if (vertexBuffer) {
                                    const stride = vertexBuffer.getSize();
                                    const bufferViewIndex = attribute.bufferViewIndex;
                                    if (bufferViewIndex != undefined) {
                                        // check to see if bufferviewindex has a numeric value assigned.
                                        minMax = { min: null, max: null };
                                        if (attributeKind == VertexBuffer.PositionKind) {
                                            minMax = _GLTFUtilities._CalculateMinMaxPositions(vertexData, 0, vertexData.length / stride);
                                        }
                                        const accessor = _GLTFUtilities._CreateAccessor(bufferViewIndex, attributeKind + " - " + babylonTransformNode.name, attribute.accessorType, attribute.accessorComponentType, vertexData.length / stride, 0, minMax.min, minMax.max);
                                        this._accessors.push(accessor);
                                        this._setAttributeKind(meshPrimitive, attributeKind);
                                    }
                                }
                            }
                        }
                        if (indexBufferViewIndex) {
                            // Create accessor
                            const accessor = _GLTFUtilities._CreateAccessor(indexBufferViewIndex, "indices - " + babylonTransformNode.name, "SCALAR" /* AccessorType.SCALAR */, 5125 /* AccessorComponentType.UNSIGNED_INT */, submesh.indexCount, submesh.indexStart * 4, null, null);
                            this._accessors.push(accessor);
                            meshPrimitive.indices = this._accessors.length - 1;
                        }
                        if (materialIndex != null && Object.keys(meshPrimitive.attributes).length > 0) {
                            const sideOrientation = bufferMesh.overrideMaterialSideOrientation !== null ? bufferMesh.overrideMaterialSideOrientation : babylonMaterial.sideOrientation;
                            if (sideOrientation === (this._babylonScene.useRightHandedSystem ? Material.ClockWiseSideOrientation : Material.CounterClockWiseSideOrientation)) {
                                let byteOffset = indexBufferViewIndex != null ? this._bufferViews[indexBufferViewIndex].byteOffset : null;
                                if (byteOffset == null) {
                                    byteOffset = 0;
                                }
                                let babylonIndices = null;
                                if (indexBufferViewIndex != null) {
                                    babylonIndices = bufferMesh.getIndices();
                                }
                                if (babylonIndices) {
                                    this._reorderIndicesBasedOnPrimitiveMode(submesh, primitiveMode, babylonIndices, byteOffset, binaryWriter);
                                }
                                else {
                                    for (const attribute of attributeData) {
                                        const vertexData = bufferMesh.getVerticesData(attribute.kind, undefined, undefined, true);
                                        if (vertexData) {
                                            const byteOffset = this._bufferViews[vertexAttributeBufferViews[attribute.kind]].byteOffset || 0;
                                            this._reorderVertexAttributeDataBasedOnPrimitiveMode(submesh, primitiveMode, attribute.kind, vertexData, byteOffset, binaryWriter);
                                        }
                                    }
                                }
                            }
                            meshPrimitive.material = materialIndex;
                        }
                        if (morphTargetManager) {
                            let target;
                            for (let i = 0; i < morphTargetManager.numTargets; ++i) {
                                target = morphTargetManager.getTarget(i);
                                this._setMorphTargetAttributes(submesh, meshPrimitive, target, binaryWriter);
                            }
                        }
                        mesh.primitives.push(meshPrimitive);
                        this._extensionsPostExportMeshPrimitiveAsync("postExport", meshPrimitive, submesh, binaryWriter);
                        promises.push();
                    }
                }
            }
            return Promise.all(promises).then(() => {
                /* do nothing */
            });
        }
        /**
         * Creates a glTF scene based on the array of meshes
         * Returns the the total byte offset
         * @param babylonScene Babylon scene to get the mesh data from
         * @param binaryWriter Buffer to write binary data to
         */
        _createSceneAsync(binaryWriter) {
            var _a;
            const scene = { nodes: [] };
            let glTFNodeIndex;
            let glTFNode;
            let directDescendents;
            const nodes = [...this._babylonScene.transformNodes, ...this._babylonScene.meshes, ...this._babylonScene.lights, ...this._babylonScene.cameras];
            const removedRootNodes = new Set();
            // Scene metadata
            if (this._babylonScene.metadata) {
                if (this._options.metadataSelector) {
                    scene.extras = this._options.metadataSelector(this._babylonScene.metadata);
                }
                else if (this._babylonScene.metadata.gltf) {
                    scene.extras = this._babylonScene.metadata.gltf.extras;
                }
            }
            // Remove no-op root nodes
            if (((_a = this._options.removeNoopRootNodes) !== null && _a !== void 0 ? _a : true) && !this._options.includeCoordinateSystemConversionNodes) {
                for (const rootNode of this._babylonScene.rootNodes) {
                    if (isNoopNode(rootNode, this._babylonScene.useRightHandedSystem)) {
                        removedRootNodes.add(rootNode);
                        // Exclude the node from list of nodes to export
                        nodes.splice(nodes.indexOf(rootNode), 1);
                    }
                }
            }
            // Export babylon cameras to glTFCamera
            const cameraMap = new Map();
            this._babylonScene.cameras.forEach((camera) => {
                if (!this._options.shouldExportNode || this._options.shouldExportNode(camera)) {
                    const glTFCamera = {
                        type: camera.mode === Camera.PERSPECTIVE_CAMERA ? "perspective" /* CameraType.PERSPECTIVE */ : "orthographic" /* CameraType.ORTHOGRAPHIC */,
                    };
                    if (camera.name) {
                        glTFCamera.name = camera.name;
                    }
                    if (glTFCamera.type === "perspective" /* CameraType.PERSPECTIVE */) {
                        glTFCamera.perspective = {
                            aspectRatio: camera.getEngine().getAspectRatio(camera),
                            yfov: camera.fovMode === Camera.FOVMODE_VERTICAL_FIXED ? camera.fov : camera.fov * camera.getEngine().getAspectRatio(camera),
                            znear: camera.minZ,
                            zfar: camera.maxZ,
                        };
                    }
                    else if (glTFCamera.type === "orthographic" /* CameraType.ORTHOGRAPHIC */) {
                        const halfWidth = camera.orthoLeft && camera.orthoRight ? 0.5 * (camera.orthoRight - camera.orthoLeft) : camera.getEngine().getRenderWidth() * 0.5;
                        const halfHeight = camera.orthoBottom && camera.orthoTop ? 0.5 * (camera.orthoTop - camera.orthoBottom) : camera.getEngine().getRenderHeight() * 0.5;
                        glTFCamera.orthographic = {
                            xmag: halfWidth,
                            ymag: halfHeight,
                            znear: camera.minZ,
                            zfar: camera.maxZ,
                        };
                    }
                    cameraMap.set(camera, this._cameras.length);
                    this._cameras.push(glTFCamera);
                }
            });
            const [exportNodes, exportMaterials] = this._getExportNodes(nodes);
            return this._glTFMaterialExporter._convertMaterialsToGLTFAsync(exportMaterials, "image/png" /* ImageMimeType.PNG */, true).then(() => {
                return this._createNodeMapAndAnimationsAsync(exportNodes, binaryWriter).then((nodeMap) => {
                    return this._createSkinsAsync(nodeMap, binaryWriter).then((skinMap) => {
                        this._nodeMap = nodeMap;
                        this._totalByteLength = binaryWriter.getByteOffset();
                        if (this._totalByteLength == undefined) {
                            throw new Error("undefined byte length!");
                        }
                        // Build Hierarchy with the node map.
                        for (const babylonNode of nodes) {
                            glTFNodeIndex = this._nodeMap[babylonNode.uniqueId];
                            if (glTFNodeIndex !== undefined) {
                                glTFNode = this._nodes[glTFNodeIndex];
                                if (babylonNode.metadata) {
                                    if (this._options.metadataSelector) {
                                        glTFNode.extras = this._options.metadataSelector(babylonNode.metadata);
                                    }
                                    else if (babylonNode.metadata.gltf) {
                                        glTFNode.extras = babylonNode.metadata.gltf.extras;
                                    }
                                }
                                if (babylonNode instanceof Camera) {
                                    glTFNode.camera = cameraMap.get(babylonNode);
                                }
                                if (this._options.shouldExportNode && !this._options.shouldExportNode(babylonNode)) {
                                    Tools.Log("Omitting " + babylonNode.name + " from scene.");
                                }
                                else {
                                    if (!babylonNode.parent && !this._babylonScene.useRightHandedSystem) {
                                        convertNodeHandedness(glTFNode);
                                    }
                                    if (!babylonNode.parent || removedRootNodes.has(babylonNode.parent)) {
                                        scene.nodes.push(glTFNodeIndex);
                                    }
                                }
                                if (babylonNode instanceof Mesh) {
                                    if (babylonNode.skeleton) {
                                        glTFNode.skin = skinMap[babylonNode.skeleton.uniqueId];
                                    }
                                }
                                directDescendents = babylonNode.getDescendants(true);
                                if (!glTFNode.children && directDescendents && directDescendents.length) {
                                    const children = [];
                                    for (const descendent of directDescendents) {
                                        if (this._nodeMap[descendent.uniqueId] != null) {
                                            children.push(this._nodeMap[descendent.uniqueId]);
                                        }
                                    }
                                    if (children.length) {
                                        glTFNode.children = children;
                                    }
                                }
                            }
                        }
                        if (scene.nodes.length) {
                            this._scenes.push(scene);
                        }
                    });
                });
            });
        }
        /**
         * Getting the nodes and materials that would be exported.
         * @param nodes Babylon transform nodes
         * @returns Array of nodes which would be exported.
         * @returns Set of materials which would be exported.
         */
        _getExportNodes(nodes) {
            const exportNodes = [];
            const exportMaterials = new Set();
            for (const babylonNode of nodes) {
                if (!this._options.shouldExportNode || this._options.shouldExportNode(babylonNode)) {
                    exportNodes.push(babylonNode);
                    const babylonMesh = babylonNode;
                    if (babylonMesh.subMeshes && babylonMesh.subMeshes.length > 0) {
                        const material = babylonMesh.material || babylonMesh.getScene().defaultMaterial;
                        if (material instanceof MultiMaterial) {
                            for (const subMaterial of material.subMaterials) {
                                if (subMaterial) {
                                    exportMaterials.add(subMaterial);
                                }
                            }
                        }
                        else {
                            exportMaterials.add(material);
                        }
                    }
                }
                else {
                    `Excluding node ${babylonNode.name}`;
                }
            }
            return [exportNodes, exportMaterials];
        }
        /**
         * Creates a mapping of Node unique id to node index and handles animations
         * @param nodes Babylon transform nodes
         * @param binaryWriter Buffer to write binary data to
         * @returns Node mapping of unique id to index
         */
        _createNodeMapAndAnimationsAsync(nodes, binaryWriter) {
            let promiseChain = Promise.resolve();
            const nodeMap = {};
            let nodeIndex;
            const runtimeGLTFAnimation = {
                name: "runtime animations",
                channels: [],
                samplers: [],
            };
            const idleGLTFAnimations = [];
            for (const babylonNode of nodes) {
                promiseChain = promiseChain.then(() => {
                    return this._createNodeAsync(babylonNode, binaryWriter).then((node) => {
                        const promise = this._extensionsPostExportNodeAsync("createNodeAsync", node, babylonNode, nodeMap, binaryWriter);
                        if (promise == null) {
                            Tools.Warn(`Not exporting node ${babylonNode.name}`);
                            return Promise.resolve();
                        }
                        else {
                            return promise.then((node) => {
                                if (!node) {
                                    return;
                                }
                                this._nodes.push(node);
                                nodeIndex = this._nodes.length - 1;
                                nodeMap[babylonNode.uniqueId] = nodeIndex;
                                if (!this._babylonScene.animationGroups.length) {
                                    _GLTFAnimation._CreateMorphTargetAnimationFromMorphTargetAnimations(babylonNode, runtimeGLTFAnimation, idleGLTFAnimations, nodeMap, this._nodes, binaryWriter, this._bufferViews, this._accessors, this._animationSampleRate, this._options.shouldExportAnimation);
                                    if (babylonNode.animations.length) {
                                        _GLTFAnimation._CreateNodeAnimationFromNodeAnimations(babylonNode, runtimeGLTFAnimation, idleGLTFAnimations, nodeMap, this._nodes, binaryWriter, this._bufferViews, this._accessors, this._animationSampleRate, this._options.shouldExportAnimation);
                                    }
                                }
                            });
                        }
                    });
                });
            }
            return promiseChain.then(() => {
                if (runtimeGLTFAnimation.channels.length && runtimeGLTFAnimation.samplers.length) {
                    this._animations.push(runtimeGLTFAnimation);
                }
                idleGLTFAnimations.forEach((idleGLTFAnimation) => {
                    if (idleGLTFAnimation.channels.length && idleGLTFAnimation.samplers.length) {
                        this._animations.push(idleGLTFAnimation);
                    }
                });
                if (this._babylonScene.animationGroups.length) {
                    _GLTFAnimation._CreateNodeAndMorphAnimationFromAnimationGroups(this._babylonScene, this._animations, nodeMap, binaryWriter, this._bufferViews, this._accessors, this._animationSampleRate, this._options.shouldExportAnimation);
                }
                return nodeMap;
            });
        }
        /**
         * Creates a glTF node from a Babylon mesh
         * @param babylonNode Source Babylon mesh
         * @param binaryWriter Buffer for storing geometry data
         * @returns glTF node
         */
        _createNodeAsync(babylonNode, binaryWriter) {
            return Promise.resolve().then(() => {
                // create node to hold translation/rotation/scale and the mesh
                const node = {};
                // create mesh
                const mesh = { primitives: [] };
                if (babylonNode.name) {
                    node.name = babylonNode.name;
                }
                if (babylonNode instanceof TransformNode) {
                    // Set transformation
                    this._setNodeTransformation(node, babylonNode);
                    if (babylonNode instanceof Mesh) {
                        const morphTargetManager = babylonNode.morphTargetManager;
                        if (morphTargetManager && morphTargetManager.numTargets > 0) {
                            mesh.weights = [];
                            for (let i = 0; i < morphTargetManager.numTargets; ++i) {
                                mesh.weights.push(morphTargetManager.getTarget(i).influence);
                            }
                        }
                    }
                    return this._setPrimitiveAttributesAsync(mesh, babylonNode, binaryWriter).then(() => {
                        if (mesh.primitives.length) {
                            this._meshes.push(mesh);
                            node.mesh = this._meshes.length - 1;
                        }
                        return node;
                    });
                }
                else if (babylonNode instanceof Camera) {
                    this._setCameraTransformation(node, babylonNode);
                    return node;
                }
                else {
                    return node;
                }
            });
        }
        /**
         * Creates a glTF skin from a Babylon skeleton
         * @param babylonScene Babylon Scene
         * @param nodeMap Babylon transform nodes
         * @param binaryWriter Buffer to write binary data to
         * @returns Node mapping of unique id to index
         */
        _createSkinsAsync(nodeMap, binaryWriter) {
            var _a;
            const promiseChain = Promise.resolve();
            const skinMap = {};
            for (const skeleton of this._babylonScene.skeletons) {
                if (skeleton.bones.length <= 0) {
                    continue;
                }
                // create skin
                const skin = { joints: [] };
                const inverseBindMatrices = [];
                const boneIndexMap = {};
                let maxBoneIndex = -1;
                for (let i = 0; i < skeleton.bones.length; ++i) {
                    const bone = skeleton.bones[i];
                    const boneIndex = (_a = bone.getIndex()) !== null && _a !== void 0 ? _a : i;
                    if (boneIndex !== -1) {
                        boneIndexMap[boneIndex] = bone;
                        if (boneIndex > maxBoneIndex) {
                            maxBoneIndex = boneIndex;
                        }
                    }
                }
                for (let boneIndex = 0; boneIndex <= maxBoneIndex; ++boneIndex) {
                    const bone = boneIndexMap[boneIndex];
                    inverseBindMatrices.push(bone.getInvertedAbsoluteTransform());
                    const transformNode = bone.getTransformNode();
                    if (transformNode && nodeMap[transformNode.uniqueId] !== null && nodeMap[transformNode.uniqueId] !== undefined) {
                        skin.joints.push(nodeMap[transformNode.uniqueId]);
                    }
                    else {
                        Tools.Warn("Exporting a bone without a linked transform node is currently unsupported");
                    }
                }
                if (skin.joints.length > 0) {
                    // create buffer view for inverse bind matrices
                    const byteStride = 64; // 4 x 4 matrix of 32 bit float
                    const byteLength = inverseBindMatrices.length * byteStride;
                    const bufferViewOffset = binaryWriter.getByteOffset();
                    const bufferView = _GLTFUtilities._CreateBufferView(0, bufferViewOffset, byteLength, undefined, "InverseBindMatrices" + " - " + skeleton.name);
                    this._bufferViews.push(bufferView);
                    const bufferViewIndex = this._bufferViews.length - 1;
                    const bindMatrixAccessor = _GLTFUtilities._CreateAccessor(bufferViewIndex, "InverseBindMatrices" + " - " + skeleton.name, "MAT4" /* AccessorType.MAT4 */, 5126 /* AccessorComponentType.FLOAT */, inverseBindMatrices.length, null, null, null);
                    const inverseBindAccessorIndex = this._accessors.push(bindMatrixAccessor) - 1;
                    skin.inverseBindMatrices = inverseBindAccessorIndex;
                    this._skins.push(skin);
                    skinMap[skeleton.uniqueId] = this._skins.length - 1;
                    inverseBindMatrices.forEach((mat) => {
                        mat.m.forEach((cell) => {
                            binaryWriter.setFloat32(cell);
                        });
                    });
                }
            }
            return promiseChain.then(() => {
                return skinMap;
            });
        }
    }
    _Exporter._ExtensionNames = new Array();
    _Exporter._ExtensionFactories = {};
    /**
     * @internal
     *
     * Stores glTF binary data.  If the array buffer byte length is exceeded, it doubles in size dynamically
     */
    class _BinaryWriter {
        /**
         * Initialize binary writer with an initial byte length
         * @param byteLength Initial byte length of the array buffer
         */
        constructor(byteLength) {
            this._arrayBuffer = new ArrayBuffer(byteLength);
            this._dataView = new DataView(this._arrayBuffer);
            this._byteOffset = 0;
        }
        /**
         * Resize the array buffer to the specified byte length
         * @param byteLength
         */
        _resizeBuffer(byteLength) {
            const newBuffer = new ArrayBuffer(byteLength);
            const copyOldBufferSize = Math.min(this._arrayBuffer.byteLength, byteLength);
            const oldUint8Array = new Uint8Array(this._arrayBuffer, 0, copyOldBufferSize);
            const newUint8Array = new Uint8Array(newBuffer);
            newUint8Array.set(oldUint8Array, 0);
            this._arrayBuffer = newBuffer;
            this._dataView = new DataView(this._arrayBuffer);
            return newBuffer;
        }
        /**
         * Get an array buffer with the length of the byte offset
         * @returns ArrayBuffer resized to the byte offset
         */
        getArrayBuffer() {
            return this._resizeBuffer(this.getByteOffset());
        }
        /**
         * Get the byte offset of the array buffer
         * @returns byte offset
         */
        getByteOffset() {
            if (this._byteOffset == undefined) {
                throw new Error("Byte offset is undefined!");
            }
            return this._byteOffset;
        }
        /**
         * Stores an UInt8 in the array buffer
         * @param entry
         * @param byteOffset If defined, specifies where to set the value as an offset.
         */
        setUInt8(entry, byteOffset) {
            if (byteOffset != null) {
                if (byteOffset < this._byteOffset) {
                    this._dataView.setUint8(byteOffset, entry);
                }
                else {
                    Tools.Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
                }
            }
            else {
                if (this._byteOffset + 1 > this._arrayBuffer.byteLength) {
                    this._resizeBuffer(this._arrayBuffer.byteLength * 2);
                }
                this._dataView.setUint8(this._byteOffset, entry);
                this._byteOffset += 1;
            }
        }
        /**
         * Stores an UInt16 in the array buffer
         * @param entry
         * @param byteOffset If defined, specifies where to set the value as an offset.
         */
        setUInt16(entry, byteOffset) {
            if (byteOffset != null) {
                if (byteOffset < this._byteOffset) {
                    this._dataView.setUint16(byteOffset, entry, true);
                }
                else {
                    Tools.Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
                }
            }
            else {
                if (this._byteOffset + 2 > this._arrayBuffer.byteLength) {
                    this._resizeBuffer(this._arrayBuffer.byteLength * 2);
                }
                this._dataView.setUint16(this._byteOffset, entry, true);
                this._byteOffset += 2;
            }
        }
        /**
         * Gets an UInt32 in the array buffer
         * @param byteOffset If defined, specifies where to set the value as an offset.
         */
        getUInt32(byteOffset) {
            if (byteOffset < this._byteOffset) {
                return this._dataView.getUint32(byteOffset, true);
            }
            else {
                Tools.Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
                throw new Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
            }
        }
        getVector3Float32FromRef(vector3, byteOffset) {
            if (byteOffset + 8 > this._byteOffset) {
                Tools.Error(`BinaryWriter: byteoffset is greater than the current binary buffer length!`);
            }
            else {
                vector3.x = this._dataView.getFloat32(byteOffset, true);
                vector3.y = this._dataView.getFloat32(byteOffset + 4, true);
                vector3.z = this._dataView.getFloat32(byteOffset + 8, true);
            }
        }
        setVector3Float32FromRef(vector3, byteOffset) {
            if (byteOffset + 8 > this._byteOffset) {
                Tools.Error(`BinaryWriter: byteoffset is greater than the current binary buffer length!`);
            }
            else {
                this._dataView.setFloat32(byteOffset, vector3.x, true);
                this._dataView.setFloat32(byteOffset + 4, vector3.y, true);
                this._dataView.setFloat32(byteOffset + 8, vector3.z, true);
            }
        }
        getVector4Float32FromRef(vector4, byteOffset) {
            if (byteOffset + 12 > this._byteOffset) {
                Tools.Error(`BinaryWriter: byteoffset is greater than the current binary buffer length!`);
            }
            else {
                vector4.x = this._dataView.getFloat32(byteOffset, true);
                vector4.y = this._dataView.getFloat32(byteOffset + 4, true);
                vector4.z = this._dataView.getFloat32(byteOffset + 8, true);
                vector4.w = this._dataView.getFloat32(byteOffset + 12, true);
            }
        }
        setVector4Float32FromRef(vector4, byteOffset) {
            if (byteOffset + 12 > this._byteOffset) {
                Tools.Error(`BinaryWriter: byteoffset is greater than the current binary buffer length!`);
            }
            else {
                this._dataView.setFloat32(byteOffset, vector4.x, true);
                this._dataView.setFloat32(byteOffset + 4, vector4.y, true);
                this._dataView.setFloat32(byteOffset + 8, vector4.z, true);
                this._dataView.setFloat32(byteOffset + 12, vector4.w, true);
            }
        }
        /**
         * Stores a Float32 in the array buffer
         * @param entry
         * @param byteOffset
         */
        setFloat32(entry, byteOffset) {
            if (isNaN(entry)) {
                Tools.Error("Invalid data being written!");
            }
            if (byteOffset != null) {
                if (byteOffset < this._byteOffset) {
                    this._dataView.setFloat32(byteOffset, entry, true);
                }
                else {
                    Tools.Error("BinaryWriter: byteoffset is greater than the current binary length!");
                }
            }
            if (this._byteOffset + 4 > this._arrayBuffer.byteLength) {
                this._resizeBuffer(this._arrayBuffer.byteLength * 2);
            }
            this._dataView.setFloat32(this._byteOffset, entry, true);
            this._byteOffset += 4;
        }
        /**
         * Stores an UInt32 in the array buffer
         * @param entry
         * @param byteOffset If defined, specifies where to set the value as an offset.
         */
        setUInt32(entry, byteOffset) {
            if (byteOffset != null) {
                if (byteOffset < this._byteOffset) {
                    this._dataView.setUint32(byteOffset, entry, true);
                }
                else {
                    Tools.Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
                }
            }
            else {
                if (this._byteOffset + 4 > this._arrayBuffer.byteLength) {
                    this._resizeBuffer(this._arrayBuffer.byteLength * 2);
                }
                this._dataView.setUint32(this._byteOffset, entry, true);
                this._byteOffset += 4;
            }
        }
        /**
         * Stores an Int16 in the array buffer
         * @param entry
         * @param byteOffset If defined, specifies where to set the value as an offset.
         */
        setInt16(entry, byteOffset) {
            if (byteOffset != null) {
                if (byteOffset < this._byteOffset) {
                    this._dataView.setInt16(byteOffset, entry, true);
                }
                else {
                    Tools.Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
                }
            }
            else {
                if (this._byteOffset + 2 > this._arrayBuffer.byteLength) {
                    this._resizeBuffer(this._arrayBuffer.byteLength * 2);
                }
                this._dataView.setInt16(this._byteOffset, entry, true);
                this._byteOffset += 2;
            }
        }
        /**
         * Stores a byte in the array buffer
         * @param entry
         * @param byteOffset If defined, specifies where to set the value as an offset.
         */
        setByte(entry, byteOffset) {
            if (byteOffset != null) {
                if (byteOffset < this._byteOffset) {
                    this._dataView.setInt8(byteOffset, entry);
                }
                else {
                    Tools.Error("BinaryWriter: byteoffset is greater than the current binary buffer length!");
                }
            }
            else {
                if (this._byteOffset + 1 > this._arrayBuffer.byteLength) {
                    this._resizeBuffer(this._arrayBuffer.byteLength * 2);
                }
                this._dataView.setInt8(this._byteOffset, entry);
                this._byteOffset++;
            }
        }
    }

    /**
     * Class for generating glTF data from a Babylon scene.
     */
    class GLTF2Export {
        /**
         * Exports the geometry of the scene to .gltf file format asynchronously
         * @param scene Babylon scene with scene hierarchy information
         * @param filePrefix File prefix to use when generating the glTF file
         * @param options Exporter options
         * @returns Returns an object with a .gltf file and associates texture names
         * as keys and their data and paths as values
         */
        static GLTFAsync(scene, filePrefix, options) {
            return scene.whenReadyAsync().then(() => {
                const glTFPrefix = filePrefix.replace(/\.[^/.]+$/, "");
                const gltfGenerator = new _Exporter(scene, options);
                return gltfGenerator._generateGLTFAsync(glTFPrefix);
            });
        }
        static _PreExportAsync(scene, options) {
            return Promise.resolve().then(() => {
                if (options && options.exportWithoutWaitingForScene) {
                    return Promise.resolve();
                }
                else {
                    return scene.whenReadyAsync();
                }
            });
        }
        static _PostExportAsync(scene, glTFData, options) {
            return Promise.resolve().then(() => {
                if (options && options.exportWithoutWaitingForScene) {
                    return glTFData;
                }
                else {
                    return glTFData;
                }
            });
        }
        /**
         * Exports the geometry of the scene to .glb file format asychronously
         * @param scene Babylon scene with scene hierarchy information
         * @param filePrefix File prefix to use when generating glb file
         * @param options Exporter options
         * @returns Returns an object with a .glb filename as key and data as value
         */
        static GLBAsync(scene, filePrefix, options) {
            return this._PreExportAsync(scene, options).then(() => {
                const glTFPrefix = filePrefix.replace(/\.[^/.]+$/, "");
                const gltfGenerator = new _Exporter(scene, options);
                return gltfGenerator._generateGLBAsync(glTFPrefix).then((glTFData) => {
                    return this._PostExportAsync(scene, glTFData, options);
                });
            });
        }
    }

    const NAME = "KHR_texture_transform";
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_texture_transform {
        constructor() {
            /** Name of this extension */
            this.name = NAME;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            /** Reference to the glTF exporter */
            this._wasUsed = false;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportTexture(context, textureInfo, babylonTexture) {
            const canUseExtension = babylonTexture &&
                ((babylonTexture.uAng === 0 && babylonTexture.wAng === 0 && babylonTexture.vAng === 0) ||
                    (babylonTexture.uRotationCenter === 0 && babylonTexture.vRotationCenter === 0));
            if (canUseExtension) {
                const textureTransform = {};
                let transformIsRequired = false;
                if (babylonTexture.uOffset !== 0 || babylonTexture.vOffset !== 0) {
                    textureTransform.offset = [babylonTexture.uOffset, babylonTexture.vOffset];
                    transformIsRequired = true;
                }
                if (babylonTexture.uScale !== 1 || babylonTexture.vScale !== 1) {
                    textureTransform.scale = [babylonTexture.uScale, babylonTexture.vScale];
                    transformIsRequired = true;
                }
                if (babylonTexture.wAng !== 0) {
                    textureTransform.rotation = -babylonTexture.wAng;
                    transformIsRequired = true;
                }
                if (babylonTexture.coordinatesIndex !== 0) {
                    textureTransform.texCoord = babylonTexture.coordinatesIndex;
                    transformIsRequired = true;
                }
                if (!transformIsRequired) {
                    return;
                }
                this._wasUsed = true;
                if (!textureInfo.extensions) {
                    textureInfo.extensions = {};
                }
                textureInfo.extensions[NAME] = textureTransform;
            }
        }
        preExportTextureAsync(context, babylonTexture) {
            return new Promise((resolve, reject) => {
                const scene = babylonTexture.getScene();
                if (!scene) {
                    reject(`${context}: "scene" is not defined for Babylon texture ${babylonTexture.name}!`);
                    return;
                }
                /*
                 * The KHR_texture_transform schema only supports w rotation around the origin.
                 * See https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_texture_transform#gltf-schema-updates.
                 */
                if (babylonTexture.uAng !== 0 || babylonTexture.vAng !== 0) {
                    Tools.Warn(`${context}: Texture ${babylonTexture.name} with rotation in the u or v axis is not supported in glTF.`);
                    resolve(null);
                }
                else if (babylonTexture.wAng !== 0 && (babylonTexture.uRotationCenter !== 0 || babylonTexture.vRotationCenter !== 0)) {
                    Tools.Warn(`${context}: Texture ${babylonTexture.name} with rotation not centered at the origin cannot be exported with ${NAME}`);
                    resolve(null);
                }
                else {
                    resolve(babylonTexture);
                }
            });
        }
    }
    _Exporter.RegisterExtension(NAME, () => new KHR_texture_transform());

    const NAME$1 = "KHR_lights_punctual";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/master/extensions/2.0/Khronos/KHR_lights_punctual/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_lights_punctual {
        /**
         * @internal
         */
        constructor(exporter) {
            /** The name of this extension. */
            this.name = NAME$1;
            /** Defines whether this extension is enabled. */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._exporter = exporter;
        }
        /** @internal */
        dispose() {
            this._lights = null;
        }
        /** @internal */
        get wasUsed() {
            return !!this._lights;
        }
        /** @internal */
        onExporting() {
            this._exporter._glTF.extensions[NAME$1] = this._lights;
        }
        /**
         * Define this method to modify the default behavior when exporting a node
         * @param context The context when exporting the node
         * @param node glTF node
         * @param babylonNode BabylonJS node
         * @param nodeMap Node mapping of unique id to glTF node index
         * @returns nullable INode promise
         */
        postExportNodeAsync(context, node, babylonNode, nodeMap) {
            return new Promise((resolve) => {
                if (node && babylonNode instanceof ShadowLight) {
                    let light;
                    const lightType = babylonNode.getTypeID() == Light.LIGHTTYPEID_POINTLIGHT
                        ? "point" /* KHRLightsPunctual_LightType.POINT */
                        : babylonNode.getTypeID() == Light.LIGHTTYPEID_DIRECTIONALLIGHT
                            ? "directional" /* KHRLightsPunctual_LightType.DIRECTIONAL */
                            : babylonNode.getTypeID() == Light.LIGHTTYPEID_SPOTLIGHT
                                ? "spot" /* KHRLightsPunctual_LightType.SPOT */
                                : null;
                    if (lightType == null) {
                        Logger.Warn(`${context}: Light ${babylonNode.name} is not supported in ${NAME$1}`);
                    }
                    else {
                        if (!babylonNode.position.equalsToFloats(0, 0, 0)) {
                            node.translation = babylonNode.position.asArray();
                        }
                        if (lightType !== "point" /* KHRLightsPunctual_LightType.POINT */) {
                            const localAxis = babylonNode.direction;
                            const yaw = -Math.atan2(localAxis.z, localAxis.x) + Math.PI / 2;
                            const len = Math.sqrt(localAxis.x * localAxis.x + localAxis.z * localAxis.z);
                            const pitch = -Math.atan2(localAxis.y, len);
                            const lightRotationQuaternion = Quaternion.RotationYawPitchRoll(yaw + Math.PI, pitch, 0);
                            if (!Quaternion.IsIdentity(lightRotationQuaternion)) {
                                node.rotation = lightRotationQuaternion.asArray();
                            }
                        }
                        if (babylonNode.falloffType !== Light.FALLOFF_GLTF) {
                            Logger.Warn(`${context}: Light falloff for ${babylonNode.name} does not match the ${NAME$1} specification!`);
                        }
                        light = {
                            type: lightType,
                        };
                        if (!babylonNode.diffuse.equals(Color3.White())) {
                            light.color = babylonNode.diffuse.asArray();
                        }
                        if (babylonNode.intensity !== 1.0) {
                            light.intensity = babylonNode.intensity;
                        }
                        if (babylonNode.range !== Number.MAX_VALUE) {
                            light.range = babylonNode.range;
                        }
                        if (lightType === "spot" /* KHRLightsPunctual_LightType.SPOT */) {
                            const babylonSpotLight = babylonNode;
                            if (babylonSpotLight.angle !== Math.PI / 2.0) {
                                if (light.spot == null) {
                                    light.spot = {};
                                }
                                light.spot.outerConeAngle = babylonSpotLight.angle / 2.0;
                            }
                            if (babylonSpotLight.innerAngle !== 0) {
                                if (light.spot == null) {
                                    light.spot = {};
                                }
                                light.spot.innerConeAngle = babylonSpotLight.innerAngle / 2.0;
                            }
                        }
                        this._lights || (this._lights = {
                            lights: [],
                        });
                        this._lights.lights.push(light);
                        const lightReference = {
                            light: this._lights.lights.length - 1,
                        };
                        // Avoid duplicating the Light's parent node if possible.
                        const parentBabylonNode = babylonNode.parent;
                        if (parentBabylonNode && parentBabylonNode.getChildren().length == 1) {
                            const parentNode = this._exporter._nodes[nodeMap[parentBabylonNode.uniqueId]];
                            if (parentNode) {
                                const parentTranslation = Vector3.FromArrayToRef(parentNode.translation || [0, 0, 0], 0, TmpVectors.Vector3[0]);
                                const parentRotation = Quaternion.FromArrayToRef(parentNode.rotation || [0, 0, 0, 1], 0, TmpVectors.Quaternion[0]);
                                const parentScale = Vector3.FromArrayToRef(parentNode.scale || [1, 1, 1], 0, TmpVectors.Vector3[1]);
                                const parentMatrix = Matrix.ComposeToRef(parentScale, parentRotation, parentTranslation, TmpVectors.Matrix[0]);
                                const translation = Vector3.FromArrayToRef(node.translation || [0, 0, 0], 0, TmpVectors.Vector3[2]);
                                const rotation = Quaternion.FromArrayToRef(node.rotation || [0, 0, 0, 1], 0, TmpVectors.Quaternion[1]);
                                const matrix = Matrix.ComposeToRef(Vector3.OneReadOnly, rotation, translation, TmpVectors.Matrix[1]);
                                parentMatrix.multiplyToRef(matrix, matrix);
                                matrix.decompose(parentScale, parentRotation, parentTranslation);
                                if (parentTranslation.equalsToFloats(0, 0, 0)) {
                                    delete parentNode.translation;
                                }
                                else {
                                    parentNode.translation = parentTranslation.asArray();
                                }
                                if (Quaternion.IsIdentity(parentRotation)) {
                                    delete parentNode.rotation;
                                }
                                else {
                                    parentNode.rotation = parentRotation.asArray();
                                }
                                if (parentScale.equalsToFloats(1, 1, 1)) {
                                    delete parentNode.scale;
                                }
                                else {
                                    parentNode.scale = parentScale.asArray();
                                }
                                parentNode.extensions || (parentNode.extensions = {});
                                parentNode.extensions[NAME$1] = lightReference;
                                // Do not export the original node
                                resolve(null);
                                return;
                            }
                        }
                        node.extensions || (node.extensions = {});
                        node.extensions[NAME$1] = lightReference;
                    }
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$1, (exporter) => new KHR_lights_punctual(exporter));

    const NAME$2 = "KHR_materials_clearcoat";
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_clearcoat {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$2;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            const additionalTextures = [];
            if (babylonMaterial instanceof PBRBaseMaterial) {
                if (babylonMaterial.clearCoat.isEnabled) {
                    if (babylonMaterial.clearCoat.texture) {
                        additionalTextures.push(babylonMaterial.clearCoat.texture);
                    }
                    if (!babylonMaterial.clearCoat.useRoughnessFromMainTexture && babylonMaterial.clearCoat.textureRoughness) {
                        additionalTextures.push(babylonMaterial.clearCoat.textureRoughness);
                    }
                    if (babylonMaterial.clearCoat.bumpTexture) {
                        additionalTextures.push(babylonMaterial.clearCoat.bumpTexture);
                    }
                    return additionalTextures;
                }
            }
            return [];
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                if (babylonMaterial instanceof PBRBaseMaterial) {
                    if (!babylonMaterial.clearCoat.isEnabled) {
                        resolve(node);
                        return;
                    }
                    this._wasUsed = true;
                    node.extensions = node.extensions || {};
                    const clearCoatTextureInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.clearCoat.texture);
                    let clearCoatTextureRoughnessInfo;
                    if (babylonMaterial.clearCoat.useRoughnessFromMainTexture) {
                        clearCoatTextureRoughnessInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.clearCoat.texture);
                    }
                    else {
                        clearCoatTextureRoughnessInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.clearCoat.textureRoughness);
                    }
                    if (babylonMaterial.clearCoat.isTintEnabled) {
                        Tools.Warn(`Clear Color tint is not supported for glTF export. Ignoring for: ${babylonMaterial.name}`);
                    }
                    if (babylonMaterial.clearCoat.remapF0OnInterfaceChange) {
                        Tools.Warn(`Clear Color F0 remapping is not supported for glTF export. Ignoring for: ${babylonMaterial.name}`);
                    }
                    const clearCoatNormalTextureInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.clearCoat.bumpTexture);
                    const clearCoatInfo = {
                        clearcoatFactor: babylonMaterial.clearCoat.intensity,
                        clearcoatTexture: clearCoatTextureInfo !== null && clearCoatTextureInfo !== void 0 ? clearCoatTextureInfo : undefined,
                        clearcoatRoughnessFactor: babylonMaterial.clearCoat.roughness,
                        clearcoatRoughnessTexture: clearCoatTextureRoughnessInfo !== null && clearCoatTextureRoughnessInfo !== void 0 ? clearCoatTextureRoughnessInfo : undefined,
                        clearcoatNormalTexture: clearCoatNormalTextureInfo !== null && clearCoatNormalTextureInfo !== void 0 ? clearCoatNormalTextureInfo : undefined,
                        hasTextures: () => {
                            return clearCoatInfo.clearcoatTexture !== null || clearCoatInfo.clearcoatRoughnessTexture !== null || clearCoatInfo.clearcoatRoughnessTexture !== null;
                        },
                    };
                    node.extensions[NAME$2] = clearCoatInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$2, (exporter) => new KHR_materials_clearcoat(exporter));

    const NAME$3 = "KHR_materials_iridescence";
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_iridescence {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$3;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            const additionalTextures = [];
            if (babylonMaterial instanceof PBRBaseMaterial) {
                if (babylonMaterial.iridescence.isEnabled) {
                    if (babylonMaterial.iridescence.texture) {
                        additionalTextures.push(babylonMaterial.iridescence.texture);
                    }
                    if (babylonMaterial.iridescence.thicknessTexture && babylonMaterial.iridescence.thicknessTexture !== babylonMaterial.iridescence.texture) {
                        additionalTextures.push(babylonMaterial.iridescence.thicknessTexture);
                    }
                    return additionalTextures;
                }
            }
            return [];
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                if (babylonMaterial instanceof PBRBaseMaterial) {
                    if (!babylonMaterial.iridescence.isEnabled) {
                        resolve(node);
                        return;
                    }
                    this._wasUsed = true;
                    node.extensions = node.extensions || {};
                    const iridescenceTextureInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.iridescence.texture);
                    const iridescenceThicknessTextureInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.iridescence.thicknessTexture);
                    const iridescenceInfo = {
                        iridescenceFactor: babylonMaterial.iridescence.intensity,
                        iridescenceIor: babylonMaterial.iridescence.indexOfRefraction,
                        iridescenceThicknessMinimum: babylonMaterial.iridescence.minimumThickness,
                        iridescenceThicknessMaximum: babylonMaterial.iridescence.maximumThickness,
                        iridescenceTexture: iridescenceTextureInfo !== null && iridescenceTextureInfo !== void 0 ? iridescenceTextureInfo : undefined,
                        iridescenceThicknessTexture: iridescenceThicknessTextureInfo !== null && iridescenceThicknessTextureInfo !== void 0 ? iridescenceThicknessTextureInfo : undefined,
                        hasTextures: () => {
                            return iridescenceInfo.iridescenceTexture !== null || iridescenceInfo.iridescenceThicknessTexture !== null;
                        },
                    };
                    node.extensions[NAME$3] = iridescenceInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$3, (exporter) => new KHR_materials_iridescence(exporter));

    const NAME$4 = "KHR_materials_anisotropy";
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_anisotropy {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$4;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            const additionalTextures = [];
            if (babylonMaterial instanceof PBRBaseMaterial) {
                if (babylonMaterial.anisotropy.isEnabled && !babylonMaterial.anisotropy.legacy) {
                    if (babylonMaterial.anisotropy.texture) {
                        additionalTextures.push(babylonMaterial.anisotropy.texture);
                    }
                    return additionalTextures;
                }
            }
            return [];
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                if (babylonMaterial instanceof PBRBaseMaterial) {
                    if (!babylonMaterial.anisotropy.isEnabled || babylonMaterial.anisotropy.legacy) {
                        resolve(node);
                        return;
                    }
                    this._wasUsed = true;
                    node.extensions = node.extensions || {};
                    const anisotropyTextureInfo = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.anisotropy.texture);
                    const anisotropyInfo = {
                        anisotropyStrength: babylonMaterial.anisotropy.intensity,
                        anisotropyRotation: babylonMaterial.anisotropy.angle,
                        anisotropyTexture: anisotropyTextureInfo !== null && anisotropyTextureInfo !== void 0 ? anisotropyTextureInfo : undefined,
                        hasTextures: () => {
                            return anisotropyInfo.anisotropyTexture !== null;
                        },
                    };
                    node.extensions[NAME$4] = anisotropyInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$4, (exporter) => new KHR_materials_anisotropy(exporter));

    const NAME$5 = "KHR_materials_sheen";
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_sheen {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$5;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            if (babylonMaterial instanceof PBRMaterial) {
                if (babylonMaterial.sheen.isEnabled && babylonMaterial.sheen.texture) {
                    return [babylonMaterial.sheen.texture];
                }
            }
            return [];
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                var _a, _b, _c, _d;
                if (babylonMaterial instanceof PBRMaterial) {
                    if (!babylonMaterial.sheen.isEnabled) {
                        resolve(node);
                        return;
                    }
                    this._wasUsed = true;
                    if (node.extensions == null) {
                        node.extensions = {};
                    }
                    const sheenInfo = {
                        sheenColorFactor: babylonMaterial.sheen.color.asArray(),
                        sheenRoughnessFactor: (_a = babylonMaterial.sheen.roughness) !== null && _a !== void 0 ? _a : 0,
                        hasTextures: () => {
                            return sheenInfo.sheenColorTexture !== null || sheenInfo.sheenRoughnessTexture !== null;
                        },
                    };
                    if (babylonMaterial.sheen.texture) {
                        sheenInfo.sheenColorTexture = (_b = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.sheen.texture)) !== null && _b !== void 0 ? _b : undefined;
                    }
                    if (babylonMaterial.sheen.textureRoughness && !babylonMaterial.sheen.useRoughnessFromMainTexture) {
                        sheenInfo.sheenRoughnessTexture = (_c = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.sheen.textureRoughness)) !== null && _c !== void 0 ? _c : undefined;
                    }
                    else if (babylonMaterial.sheen.texture && babylonMaterial.sheen.useRoughnessFromMainTexture) {
                        sheenInfo.sheenRoughnessTexture = (_d = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.sheen.texture)) !== null && _d !== void 0 ? _d : undefined;
                    }
                    node.extensions[NAME$5] = sheenInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$5, (exporter) => new KHR_materials_sheen(exporter));

    const NAME$6 = "KHR_materials_unlit";
    /**
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_unlit {
        constructor() {
            /** Name of this extension */
            this.name = NAME$6;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
        }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        dispose() { }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                let unlitMaterial = false;
                if (babylonMaterial instanceof PBRMaterial) {
                    unlitMaterial = babylonMaterial.unlit;
                }
                else if (babylonMaterial instanceof StandardMaterial) {
                    unlitMaterial = babylonMaterial.disableLighting;
                }
                if (unlitMaterial) {
                    this._wasUsed = true;
                    if (node.extensions == null) {
                        node.extensions = {};
                    }
                    node.extensions[NAME$6] = {};
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$6, () => new KHR_materials_unlit());

    const NAME$7 = "KHR_materials_ior";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_materials_ior/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_ior {
        constructor() {
            /** Name of this extension */
            this.name = NAME$7;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        _isExtensionEnabled(mat) {
            // This extension must not be used on a material that also uses KHR_materials_unlit
            if (mat.unlit) {
                return false;
            }
            return mat.indexOfRefraction != undefined && mat.indexOfRefraction != 1.5; // 1.5 is normative default value.
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                if (babylonMaterial instanceof PBRMaterial && this._isExtensionEnabled(babylonMaterial)) {
                    this._wasUsed = true;
                    const iorInfo = {
                        ior: babylonMaterial.indexOfRefraction,
                    };
                    node.extensions = node.extensions || {};
                    node.extensions[NAME$7] = iorInfo;
                }
                resolve(node);
            });
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _Exporter.RegisterExtension(NAME$7, (exporter) => new KHR_materials_ior());

    const NAME$8 = "KHR_materials_specular";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_materials_specular/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_specular {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$8;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            const additionalTextures = [];
            if (babylonMaterial instanceof PBRMaterial) {
                if (this._isExtensionEnabled(babylonMaterial)) {
                    if (babylonMaterial.metallicReflectanceTexture) {
                        additionalTextures.push(babylonMaterial.metallicReflectanceTexture);
                    }
                    if (babylonMaterial.reflectanceTexture) {
                        additionalTextures.push(babylonMaterial.reflectanceTexture);
                    }
                    return additionalTextures;
                }
            }
            return additionalTextures;
        }
        _isExtensionEnabled(mat) {
            // This extension must not be used on a material that also uses KHR_materials_unlit
            if (mat.unlit) {
                return false;
            }
            return ((mat.metallicF0Factor != undefined && mat.metallicF0Factor != 1.0) ||
                (mat.metallicReflectanceColor != undefined && !mat.metallicReflectanceColor.equalsFloats(1.0, 1.0, 1.0)) ||
                this._hasTexturesExtension(mat));
        }
        _hasTexturesExtension(mat) {
            return mat.metallicReflectanceTexture != null || mat.reflectanceTexture != null;
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                var _a, _b;
                if (babylonMaterial instanceof PBRMaterial && this._isExtensionEnabled(babylonMaterial)) {
                    this._wasUsed = true;
                    node.extensions = node.extensions || {};
                    const metallicReflectanceTexture = (_a = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.metallicReflectanceTexture)) !== null && _a !== void 0 ? _a : undefined;
                    const reflectanceTexture = (_b = this._exporter._glTFMaterialExporter._getTextureInfo(babylonMaterial.reflectanceTexture)) !== null && _b !== void 0 ? _b : undefined;
                    const metallicF0Factor = babylonMaterial.metallicF0Factor == 1.0 ? undefined : babylonMaterial.metallicF0Factor;
                    const metallicReflectanceColor = babylonMaterial.metallicReflectanceColor.equalsFloats(1.0, 1.0, 1.0)
                        ? undefined
                        : babylonMaterial.metallicReflectanceColor.asArray();
                    const specularInfo = {
                        specularFactor: metallicF0Factor,
                        specularTexture: metallicReflectanceTexture,
                        specularColorFactor: metallicReflectanceColor,
                        specularColorTexture: reflectanceTexture,
                        hasTextures: () => {
                            return this._hasTexturesExtension(babylonMaterial);
                        },
                    };
                    node.extensions[NAME$8] = specularInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$8, (exporter) => new KHR_materials_specular(exporter));

    const NAME$9 = "KHR_materials_volume";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_materials_volume/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_volume {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$9;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            const additionalTextures = [];
            if (babylonMaterial instanceof PBRMaterial) {
                if (this._isExtensionEnabled(babylonMaterial)) {
                    if (babylonMaterial.subSurface.thicknessTexture) {
                        additionalTextures.push(babylonMaterial.subSurface.thicknessTexture);
                    }
                    return additionalTextures;
                }
            }
            return additionalTextures;
        }
        _isExtensionEnabled(mat) {
            // This extension must not be used on a material that also uses KHR_materials_unlit
            if (mat.unlit) {
                return false;
            }
            const subs = mat.subSurface;
            // this extension requires either the KHR_materials_transmission or KHR_materials_translucency extensions.
            if (!subs.isRefractionEnabled && !subs.isTranslucencyEnabled) {
                return false;
            }
            return ((subs.maximumThickness != undefined && subs.maximumThickness != 0) ||
                (subs.tintColorAtDistance != undefined && subs.tintColorAtDistance != Number.POSITIVE_INFINITY) ||
                (subs.tintColor != undefined && subs.tintColor != Color3.White()) ||
                this._hasTexturesExtension(mat));
        }
        _hasTexturesExtension(mat) {
            return mat.subSurface.thicknessTexture != null;
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                var _a;
                if (babylonMaterial instanceof PBRMaterial && this._isExtensionEnabled(babylonMaterial)) {
                    this._wasUsed = true;
                    const subs = babylonMaterial.subSurface;
                    const thicknessFactor = subs.maximumThickness == 0 ? undefined : subs.maximumThickness;
                    const thicknessTexture = (_a = this._exporter._glTFMaterialExporter._getTextureInfo(subs.thicknessTexture)) !== null && _a !== void 0 ? _a : undefined;
                    const attenuationDistance = subs.tintColorAtDistance == Number.POSITIVE_INFINITY ? undefined : subs.tintColorAtDistance;
                    const attenuationColor = subs.tintColor.equalsFloats(1.0, 1.0, 1.0) ? undefined : subs.tintColor.asArray();
                    const volumeInfo = {
                        thicknessFactor: thicknessFactor,
                        thicknessTexture: thicknessTexture,
                        attenuationDistance: attenuationDistance,
                        attenuationColor: attenuationColor,
                        hasTextures: () => {
                            return this._hasTexturesExtension(babylonMaterial);
                        },
                    };
                    node.extensions = node.extensions || {};
                    node.extensions[NAME$9] = volumeInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$9, (exporter) => new KHR_materials_volume(exporter));

    const NAME$a = "KHR_materials_transmission";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_materials_transmission/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_transmission {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$a;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAdditionalTextures(context, node, babylonMaterial) {
            const additionalTextures = [];
            if (babylonMaterial instanceof PBRMaterial) {
                if (this._isExtensionEnabled(babylonMaterial)) {
                    if (babylonMaterial.subSurface.thicknessTexture) {
                        additionalTextures.push(babylonMaterial.subSurface.thicknessTexture);
                    }
                    return additionalTextures;
                }
            }
            return additionalTextures;
        }
        _isExtensionEnabled(mat) {
            // This extension must not be used on a material that also uses KHR_materials_unlit
            if (mat.unlit) {
                return false;
            }
            const subs = mat.subSurface;
            return (subs.isRefractionEnabled && subs.refractionIntensity != undefined && subs.refractionIntensity != 0) || this._hasTexturesExtension(mat);
        }
        _hasTexturesExtension(mat) {
            return mat.subSurface.refractionIntensityTexture != null;
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                var _a;
                if (babylonMaterial instanceof PBRMaterial && this._isExtensionEnabled(babylonMaterial)) {
                    this._wasUsed = true;
                    const subs = babylonMaterial.subSurface;
                    const transmissionFactor = subs.refractionIntensity === 0 ? undefined : subs.refractionIntensity;
                    const transmissionTexture = (_a = this._exporter._glTFMaterialExporter._getTextureInfo(subs.refractionIntensityTexture)) !== null && _a !== void 0 ? _a : undefined;
                    const volumeInfo = {
                        transmissionFactor: transmissionFactor,
                        transmissionTexture: transmissionTexture,
                        hasTextures: () => {
                            return this._hasTexturesExtension(babylonMaterial);
                        },
                    };
                    node.extensions = node.extensions || {};
                    node.extensions[NAME$a] = volumeInfo;
                }
                resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$a, (exporter) => new KHR_materials_transmission(exporter));

    Mesh.prototype.thinInstanceAdd = function (matrix, refresh = true) {
        if (!this.getScene().getEngine().getCaps().instancedArrays) {
            Logger.Error("Thin Instances are not supported on this device as Instanced Array extension not supported");
            return -1;
        }
        this._thinInstanceUpdateBufferSize("matrix", Array.isArray(matrix) ? matrix.length : 1);
        const index = this._thinInstanceDataStorage.instancesCount;
        if (Array.isArray(matrix)) {
            for (let i = 0; i < matrix.length; ++i) {
                this.thinInstanceSetMatrixAt(this._thinInstanceDataStorage.instancesCount++, matrix[i], i === matrix.length - 1 && refresh);
            }
        }
        else {
            this.thinInstanceSetMatrixAt(this._thinInstanceDataStorage.instancesCount++, matrix, refresh);
        }
        return index;
    };
    Mesh.prototype.thinInstanceAddSelf = function (refresh = true) {
        return this.thinInstanceAdd(Matrix.IdentityReadOnly, refresh);
    };
    Mesh.prototype.thinInstanceRegisterAttribute = function (kind, stride) {
        // preserve backward compatibility
        if (kind === VertexBuffer.ColorKind) {
            kind = VertexBuffer.ColorInstanceKind;
        }
        this.removeVerticesData(kind);
        this._thinInstanceInitializeUserStorage();
        this._userThinInstanceBuffersStorage.strides[kind] = stride;
        this._userThinInstanceBuffersStorage.sizes[kind] = stride * Math.max(32, this._thinInstanceDataStorage.instancesCount); // Initial size
        this._userThinInstanceBuffersStorage.data[kind] = new Float32Array(this._userThinInstanceBuffersStorage.sizes[kind]);
        this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new VertexBuffer(this.getEngine(), this._userThinInstanceBuffersStorage.data[kind], kind, true, false, stride, true);
        this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
    };
    Mesh.prototype.thinInstanceSetMatrixAt = function (index, matrix, refresh = true) {
        if (!this._thinInstanceDataStorage.matrixData || index >= this._thinInstanceDataStorage.instancesCount) {
            return false;
        }
        const matrixData = this._thinInstanceDataStorage.matrixData;
        matrix.copyToArray(matrixData, index * 16);
        if (this._thinInstanceDataStorage.worldMatrices) {
            this._thinInstanceDataStorage.worldMatrices[index] = matrix;
        }
        if (refresh) {
            this.thinInstanceBufferUpdated("matrix");
            if (!this.doNotSyncBoundingInfo) {
                this.thinInstanceRefreshBoundingInfo(false);
            }
        }
        return true;
    };
    Mesh.prototype.thinInstanceSetAttributeAt = function (kind, index, value, refresh = true) {
        // preserve backward compatibility
        if (kind === VertexBuffer.ColorKind) {
            kind = VertexBuffer.ColorInstanceKind;
        }
        if (!this._userThinInstanceBuffersStorage || !this._userThinInstanceBuffersStorage.data[kind] || index >= this._thinInstanceDataStorage.instancesCount) {
            return false;
        }
        this._thinInstanceUpdateBufferSize(kind, 0); // make sur the buffer for the kind attribute is big enough
        this._userThinInstanceBuffersStorage.data[kind].set(value, index * this._userThinInstanceBuffersStorage.strides[kind]);
        if (refresh) {
            this.thinInstanceBufferUpdated(kind);
        }
        return true;
    };
    Object.defineProperty(Mesh.prototype, "thinInstanceCount", {
        get: function () {
            return this._thinInstanceDataStorage.instancesCount;
        },
        set: function (value) {
            var _a, _b;
            const matrixData = (_a = this._thinInstanceDataStorage.matrixData) !== null && _a !== void 0 ? _a : (_b = this.source) === null || _b === void 0 ? void 0 : _b._thinInstanceDataStorage.matrixData;
            const numMaxInstances = matrixData ? matrixData.length / 16 : 0;
            if (value <= numMaxInstances) {
                this._thinInstanceDataStorage.instancesCount = value;
            }
        },
        enumerable: true,
        configurable: true,
    });
    Mesh.prototype._thinInstanceCreateMatrixBuffer = function (kind, buffer, staticBuffer = false) {
        // preserve backward compatibility
        if (kind === VertexBuffer.ColorKind) {
            kind = VertexBuffer.ColorInstanceKind;
        }
        const matrixBuffer = new Buffer$1(this.getEngine(), buffer, !staticBuffer, 16, false, true);
        for (let i = 0; i < 4; i++) {
            this.setVerticesBuffer(matrixBuffer.createVertexBuffer(kind + i, i * 4, 4));
        }
        return matrixBuffer;
    };
    Mesh.prototype.thinInstanceSetBuffer = function (kind, buffer, stride = 0, staticBuffer = false) {
        var _a, _b, _c;
        stride = stride || 16;
        if (kind === "matrix") {
            (_a = this._thinInstanceDataStorage.matrixBuffer) === null || _a === void 0 ? void 0 : _a.dispose();
            this._thinInstanceDataStorage.matrixBuffer = null;
            this._thinInstanceDataStorage.matrixBufferSize = buffer ? buffer.length : 32 * stride;
            this._thinInstanceDataStorage.matrixData = buffer;
            this._thinInstanceDataStorage.worldMatrices = null;
            if (buffer !== null) {
                this._thinInstanceDataStorage.instancesCount = buffer.length / stride;
                this._thinInstanceDataStorage.matrixBuffer = this._thinInstanceCreateMatrixBuffer("world", buffer, staticBuffer);
                if (!this.doNotSyncBoundingInfo) {
                    this.thinInstanceRefreshBoundingInfo(false);
                }
            }
            else {
                this._thinInstanceDataStorage.instancesCount = 0;
                if (!this.doNotSyncBoundingInfo) {
                    // mesh has no more thin instances, so need to recompute the bounding box because it's the regular mesh that will now be displayed
                    this.refreshBoundingInfo();
                }
            }
        }
        else if (kind === "previousMatrix") {
            (_b = this._thinInstanceDataStorage.previousMatrixBuffer) === null || _b === void 0 ? void 0 : _b.dispose();
            this._thinInstanceDataStorage.previousMatrixBuffer = null;
            this._thinInstanceDataStorage.previousMatrixData = buffer;
            if (buffer !== null) {
                this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", buffer, staticBuffer);
            }
        }
        else {
            // color for instanced mesh is ColorInstanceKind and not ColorKind because of native that needs to do the differenciation
            // hot switching kind here to preserve backward compatibility
            if (kind === VertexBuffer.ColorKind) {
                kind = VertexBuffer.ColorInstanceKind;
            }
            if (buffer === null) {
                if ((_c = this._userThinInstanceBuffersStorage) === null || _c === void 0 ? void 0 : _c.data[kind]) {
                    this.removeVerticesData(kind);
                    delete this._userThinInstanceBuffersStorage.data[kind];
                    delete this._userThinInstanceBuffersStorage.strides[kind];
                    delete this._userThinInstanceBuffersStorage.sizes[kind];
                    delete this._userThinInstanceBuffersStorage.vertexBuffers[kind];
                }
            }
            else {
                this._thinInstanceInitializeUserStorage();
                this._userThinInstanceBuffersStorage.data[kind] = buffer;
                this._userThinInstanceBuffersStorage.strides[kind] = stride;
                this._userThinInstanceBuffersStorage.sizes[kind] = buffer.length;
                this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new VertexBuffer(this.getEngine(), buffer, kind, !staticBuffer, false, stride, true);
                this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
            }
        }
    };
    Mesh.prototype.thinInstanceBufferUpdated = function (kind) {
        var _a, _b, _c;
        if (kind === "matrix") {
            (_a = this._thinInstanceDataStorage.matrixBuffer) === null || _a === void 0 ? void 0 : _a.updateDirectly(this._thinInstanceDataStorage.matrixData, 0, this._thinInstanceDataStorage.instancesCount);
        }
        else if (kind === "previousMatrix") {
            (_b = this._thinInstanceDataStorage.previousMatrixBuffer) === null || _b === void 0 ? void 0 : _b.updateDirectly(this._thinInstanceDataStorage.previousMatrixData, 0, this._thinInstanceDataStorage.instancesCount);
        }
        else {
            // preserve backward compatibility
            if (kind === VertexBuffer.ColorKind) {
                kind = VertexBuffer.ColorInstanceKind;
            }
            if ((_c = this._userThinInstanceBuffersStorage) === null || _c === void 0 ? void 0 : _c.vertexBuffers[kind]) {
                this._userThinInstanceBuffersStorage.vertexBuffers[kind].updateDirectly(this._userThinInstanceBuffersStorage.data[kind], 0);
            }
        }
    };
    Mesh.prototype.thinInstancePartialBufferUpdate = function (kind, data, offset) {
        var _a;
        if (kind === "matrix") {
            if (this._thinInstanceDataStorage.matrixBuffer) {
                this._thinInstanceDataStorage.matrixBuffer.updateDirectly(data, offset);
            }
        }
        else {
            // preserve backward compatibility
            if (kind === VertexBuffer.ColorKind) {
                kind = VertexBuffer.ColorInstanceKind;
            }
            if ((_a = this._userThinInstanceBuffersStorage) === null || _a === void 0 ? void 0 : _a.vertexBuffers[kind]) {
                this._userThinInstanceBuffersStorage.vertexBuffers[kind].updateDirectly(data, offset);
            }
        }
    };
    Mesh.prototype.thinInstanceGetWorldMatrices = function () {
        if (!this._thinInstanceDataStorage.matrixData || !this._thinInstanceDataStorage.matrixBuffer) {
            return [];
        }
        const matrixData = this._thinInstanceDataStorage.matrixData;
        if (!this._thinInstanceDataStorage.worldMatrices) {
            this._thinInstanceDataStorage.worldMatrices = new Array();
            for (let i = 0; i < this._thinInstanceDataStorage.instancesCount; ++i) {
                this._thinInstanceDataStorage.worldMatrices[i] = Matrix.FromArray(matrixData, i * 16);
            }
        }
        return this._thinInstanceDataStorage.worldMatrices;
    };
    Mesh.prototype.thinInstanceRefreshBoundingInfo = function (forceRefreshParentInfo = false, applySkeleton = false, applyMorph = false) {
        if (!this._thinInstanceDataStorage.matrixData || !this._thinInstanceDataStorage.matrixBuffer) {
            return;
        }
        const vectors = this._thinInstanceDataStorage.boundingVectors;
        if (forceRefreshParentInfo || !this.rawBoundingInfo) {
            vectors.length = 0;
            this.refreshBoundingInfo(applySkeleton, applyMorph);
            const boundingInfo = this.getBoundingInfo();
            this.rawBoundingInfo = new BoundingInfo(boundingInfo.minimum, boundingInfo.maximum);
        }
        const boundingInfo = this.getBoundingInfo();
        const matrixData = this._thinInstanceDataStorage.matrixData;
        if (vectors.length === 0) {
            for (let v = 0; v < boundingInfo.boundingBox.vectors.length; ++v) {
                vectors.push(boundingInfo.boundingBox.vectors[v].clone());
            }
        }
        TmpVectors.Vector3[0].setAll(Number.POSITIVE_INFINITY); // min
        TmpVectors.Vector3[1].setAll(Number.NEGATIVE_INFINITY); // max
        for (let i = 0; i < this._thinInstanceDataStorage.instancesCount; ++i) {
            Matrix.FromArrayToRef(matrixData, i * 16, TmpVectors.Matrix[0]);
            for (let v = 0; v < vectors.length; ++v) {
                Vector3.TransformCoordinatesToRef(vectors[v], TmpVectors.Matrix[0], TmpVectors.Vector3[2]);
                TmpVectors.Vector3[0].minimizeInPlace(TmpVectors.Vector3[2]);
                TmpVectors.Vector3[1].maximizeInPlace(TmpVectors.Vector3[2]);
            }
        }
        boundingInfo.reConstruct(TmpVectors.Vector3[0], TmpVectors.Vector3[1]);
        this._updateBoundingInfo();
    };
    Mesh.prototype._thinInstanceUpdateBufferSize = function (kind, numInstances = 1) {
        var _a, _b, _c;
        // preserve backward compatibility
        if (kind === VertexBuffer.ColorKind) {
            kind = VertexBuffer.ColorInstanceKind;
        }
        const kindIsMatrix = kind === "matrix";
        if (!kindIsMatrix && (!this._userThinInstanceBuffersStorage || !this._userThinInstanceBuffersStorage.strides[kind])) {
            return;
        }
        const stride = kindIsMatrix ? 16 : this._userThinInstanceBuffersStorage.strides[kind];
        const currentSize = kindIsMatrix ? this._thinInstanceDataStorage.matrixBufferSize : this._userThinInstanceBuffersStorage.sizes[kind];
        let data = kindIsMatrix ? this._thinInstanceDataStorage.matrixData : this._userThinInstanceBuffersStorage.data[kind];
        const bufferSize = (this._thinInstanceDataStorage.instancesCount + numInstances) * stride;
        let newSize = currentSize;
        while (newSize < bufferSize) {
            newSize *= 2;
        }
        if (!data || currentSize != newSize) {
            if (!data) {
                data = new Float32Array(newSize);
            }
            else {
                const newData = new Float32Array(newSize);
                newData.set(data, 0);
                data = newData;
            }
            if (kindIsMatrix) {
                (_a = this._thinInstanceDataStorage.matrixBuffer) === null || _a === void 0 ? void 0 : _a.dispose();
                this._thinInstanceDataStorage.matrixBuffer = this._thinInstanceCreateMatrixBuffer("world", data, false);
                this._thinInstanceDataStorage.matrixData = data;
                this._thinInstanceDataStorage.matrixBufferSize = newSize;
                if (this._scene.needsPreviousWorldMatrices && !this._thinInstanceDataStorage.previousMatrixData) {
                    (_b = this._thinInstanceDataStorage.previousMatrixBuffer) === null || _b === void 0 ? void 0 : _b.dispose();
                    this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", data, false);
                }
            }
            else {
                (_c = this._userThinInstanceBuffersStorage.vertexBuffers[kind]) === null || _c === void 0 ? void 0 : _c.dispose();
                this._userThinInstanceBuffersStorage.data[kind] = data;
                this._userThinInstanceBuffersStorage.sizes[kind] = newSize;
                this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new VertexBuffer(this.getEngine(), data, kind, true, false, stride, true);
                this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
            }
        }
    };
    Mesh.prototype._thinInstanceInitializeUserStorage = function () {
        if (!this._userThinInstanceBuffersStorage) {
            this._userThinInstanceBuffersStorage = {
                data: {},
                sizes: {},
                vertexBuffers: {},
                strides: {},
            };
        }
    };
    Mesh.prototype._disposeThinInstanceSpecificData = function () {
        var _a;
        if ((_a = this._thinInstanceDataStorage) === null || _a === void 0 ? void 0 : _a.matrixBuffer) {
            this._thinInstanceDataStorage.matrixBuffer.dispose();
            this._thinInstanceDataStorage.matrixBuffer = null;
        }
    };

    const NAME$b = "EXT_mesh_gpu_instancing";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Vendor/EXT_mesh_gpu_instancing/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class EXT_mesh_gpu_instancing {
        constructor(exporter) {
            /** Name of this extension */
            this.name = NAME$b;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
            this._exporter = exporter;
        }
        dispose() { }
        /** @internal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportNodeAsync(context, node, babylonNode, nodeMap, binaryWriter) {
            return new Promise((resolve) => {
                if (node && babylonNode instanceof Mesh) {
                    if (babylonNode.hasThinInstances && binaryWriter) {
                        this._wasUsed = true;
                        const noTranslation = Vector3.Zero();
                        const noRotation = Quaternion.Identity();
                        const noScale = Vector3.One();
                        // retreive all the instance world matrix
                        const matrix = babylonNode.thinInstanceGetWorldMatrices();
                        const iwt = TmpVectors.Vector3[2];
                        const iwr = TmpVectors.Quaternion[1];
                        const iws = TmpVectors.Vector3[3];
                        let hasAnyInstanceWorldTranslation = false;
                        let hasAnyInstanceWorldRotation = false;
                        let hasAnyInstanceWorldScale = false;
                        // prepare temp buffers
                        const translationBuffer = new Float32Array(babylonNode.thinInstanceCount * 3);
                        const rotationBuffer = new Float32Array(babylonNode.thinInstanceCount * 4);
                        const scaleBuffer = new Float32Array(babylonNode.thinInstanceCount * 3);
                        let i = 0;
                        for (const m of matrix) {
                            m.decompose(iws, iwr, iwt);
                            // fill the temp buffer
                            translationBuffer.set(iwt.asArray(), i * 3);
                            rotationBuffer.set(iwr.normalize().asArray(), i * 4); // ensure the quaternion is normalized
                            scaleBuffer.set(iws.asArray(), i * 3);
                            // this is where we decide if there is any transformation
                            hasAnyInstanceWorldTranslation = hasAnyInstanceWorldTranslation || !iwt.equalsWithEpsilon(noTranslation);
                            hasAnyInstanceWorldRotation = hasAnyInstanceWorldRotation || !iwr.equalsWithEpsilon(noRotation);
                            hasAnyInstanceWorldScale = hasAnyInstanceWorldScale || !iws.equalsWithEpsilon(noScale);
                            i++;
                        }
                        const extension = {
                            attributes: {},
                        };
                        // do we need to write TRANSLATION ?
                        if (hasAnyInstanceWorldTranslation) {
                            extension.attributes["TRANSLATION"] = this._buildAccessor(translationBuffer, "VEC3" /* AccessorType.VEC3 */, babylonNode.thinInstanceCount, binaryWriter, 5126 /* AccessorComponentType.FLOAT */);
                        }
                        // do we need to write ROTATION ?
                        if (hasAnyInstanceWorldRotation) {
                            const componentType = 5126 /* AccessorComponentType.FLOAT */; // we decided to stay on FLOAT for now see https://github.com/BabylonJS/Babylon.js/pull/12495
                            extension.attributes["ROTATION"] = this._buildAccessor(rotationBuffer, "VEC4" /* AccessorType.VEC4 */, babylonNode.thinInstanceCount, binaryWriter, componentType);
                        }
                        // do we need to write SCALE ?
                        if (hasAnyInstanceWorldScale) {
                            extension.attributes["SCALE"] = this._buildAccessor(scaleBuffer, "VEC3" /* AccessorType.VEC3 */, babylonNode.thinInstanceCount, binaryWriter, 5126 /* AccessorComponentType.FLOAT */);
                        }
                        /* eslint-enable @typescript-eslint/naming-convention*/
                        node.extensions = node.extensions || {};
                        node.extensions[NAME$b] = extension;
                    }
                }
                resolve(node);
            });
        }
        _buildAccessor(buffer, type, count, binaryWriter, componentType) {
            // write the buffer
            const bufferOffset = binaryWriter.getByteOffset();
            switch (componentType) {
                case 5126 /* AccessorComponentType.FLOAT */: {
                    for (let i = 0; i != buffer.length; i++) {
                        binaryWriter.setFloat32(buffer[i]);
                    }
                    break;
                }
                case 5120 /* AccessorComponentType.BYTE */: {
                    for (let i = 0; i != buffer.length; i++) {
                        binaryWriter.setByte(buffer[i] * 127);
                    }
                    break;
                }
                case 5122 /* AccessorComponentType.SHORT */: {
                    for (let i = 0; i != buffer.length; i++) {
                        binaryWriter.setInt16(buffer[i] * 32767);
                    }
                    break;
                }
            }
            // build the buffer view
            const bv = { buffer: 0, byteOffset: bufferOffset, byteLength: buffer.length * VertexBuffer.GetTypeByteLength(componentType) };
            const bufferViewIndex = this._exporter._bufferViews.length;
            this._exporter._bufferViews.push(bv);
            // finally build the accessor
            const accessorIndex = this._exporter._accessors.length;
            const accessor = {
                bufferView: bufferViewIndex,
                componentType: componentType,
                count: count,
                type: type,
                normalized: componentType == 5120 /* AccessorComponentType.BYTE */ || componentType == 5122 /* AccessorComponentType.SHORT */,
            };
            this._exporter._accessors.push(accessor);
            return accessorIndex;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _Exporter.RegisterExtension(NAME$b, (exporter) => new EXT_mesh_gpu_instancing(exporter));

    const NAME$c = "KHR_materials_emissive_strength";
    /**
     * [Specification](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class KHR_materials_emissive_strength {
        constructor() {
            /** Name of this extension */
            this.name = NAME$c;
            /** Defines whether this extension is enabled */
            this.enabled = true;
            /** Defines whether this extension is required */
            this.required = false;
            this._wasUsed = false;
        }
        dispose() { }
        /** @interal */
        get wasUsed() {
            return this._wasUsed;
        }
        postExportMaterialAsync(context, node, babylonMaterial) {
            return new Promise((resolve) => {
                if (!(babylonMaterial instanceof PBRMaterial)) {
                    return resolve(node);
                }
                const emissiveColor = babylonMaterial.emissiveColor.asArray();
                const tempEmissiveStrength = Math.max(...emissiveColor);
                if (tempEmissiveStrength > 1) {
                    this._wasUsed = true;
                    node.extensions || (node.extensions = {});
                    const emissiveStrengthInfo = {
                        emissiveStrength: tempEmissiveStrength,
                    };
                    // Normalize each value of the emissive factor to have a max value of 1
                    const newEmissiveFactor = babylonMaterial.emissiveColor.scale(1 / emissiveStrengthInfo.emissiveStrength);
                    node.emissiveFactor = newEmissiveFactor.asArray();
                    node.extensions[NAME$c] = emissiveStrengthInfo;
                }
                return resolve(node);
            });
        }
    }
    _Exporter.RegisterExtension(NAME$c, (exporter) => new KHR_materials_emissive_strength());

    class GLTFKb3dExporter {
        constructor(scene) {
            this.scene = scene;
            this._glbExportOptions = {
                shouldExportNode: n => this.shouldExportNode(n),
            };
        }
        /** generates the current scene into a glb file and returns an object url for it */
        generateGlb(filename = 'scene') {
            return GLTF2Export.GLBAsync(this.scene, filename, this._glbExportOptions).then(glbData => {
                return this.createGlbBlob(glbData);
            });
        }
        exportGlb(filename = 'scene') {
            return GLTF2Export.GLBAsync(this.scene, filename, this._glbExportOptions).then(glbData => {
                const dispose = this.downloadBlob(`${filename}.glb`, this.createGlbBlob(glbData));
                setTimeout(() => dispose());
            });
        }
        exportGltf(filename = 'scene') {
            return GLTF2Export.GLTFAsync(this.scene, filename, this._glbExportOptions).then(glbData => {
                const disposeFuncs = [];
                for (const key in glbData.glTFFiles) {
                    const blob = glbData.glTFFiles[key];
                    let mimeType;
                    if (endsWith(key, '.glb')) {
                        mimeType = { type: 'model/gltf-binary' };
                    }
                    else if (endsWith(key, '.bin')) {
                        mimeType = { type: 'application/octet-stream' };
                    }
                    else if (endsWith(key, '.gltf')) {
                        mimeType = { type: 'model/gltf+json' };
                    }
                    else if (endsWith(key, '.jpeg') || endsWith(key, '.jpg')) {
                        mimeType = { type: 'image/jpeg' /* ImageMimeType.JPEG */ };
                    }
                    else if (endsWith(key, '.png')) {
                        mimeType = { type: 'image/png' /* ImageMimeType.PNG */ };
                    }
                    disposeFuncs.push(this.downloadBlob(key, new Blob([blob], mimeType)));
                }
                setTimeout(() => disposeFuncs.forEach(dispose => dispose()));
            });
            function endsWith(str, suffix) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }
        }
        shouldExportNode(node) {
            const kb3dNode = getByDynamicId(node.id);
            if (kb3dNode instanceof exports.Connector) {
                return false;
            }
            else if (kb3dNode instanceof exports.ViewpointNode) {
                return false;
            }
            return kb3dNode != null;
        }
        createGlbBlob(glbData) {
            //we're expecting one file since it's a GLB
            const key = Object.keys(glbData.glTFFiles)[0];
            const blob = glbData.glTFFiles[key];
            const mimeType = { type: 'model/gltf-binary' };
            return new Blob([blob], mimeType);
        }
        downloadBlob(fileName, blob) {
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.setAttribute('type', 'hidden');
            link.download = fileName;
            link.href = window.URL.createObjectURL(blob);
            link.click();
            return dispose;
            function dispose() {
                window.URL.revokeObjectURL(link.href);
                link.remove();
            }
        }
    }

    /**
     * This represents a color grading texture. This acts as a lookup table LUT, useful during post process
     * It can help converting any input color in a desired output one. This can then be used to create effects
     * from sepia, black and white to sixties or futuristic rendering...
     *
     * The only supported format is currently 3dl.
     * More information on LUT: https://en.wikipedia.org/wiki/3D_lookup_table
     */
    class ColorGradingTexture extends BaseTexture {
        /**
         * Instantiates a ColorGradingTexture from the following parameters.
         *
         * @param url The location of the color grading data (currently only supporting 3dl)
         * @param sceneOrEngine The scene or engine the texture will be used in
         * @param onLoad defines a callback triggered when the texture has been loaded
         */
        constructor(url, sceneOrEngine, onLoad = null) {
            super(sceneOrEngine);
            if (!url) {
                return;
            }
            this._textureMatrix = Matrix.Identity();
            this.name = url;
            this.url = url;
            this._onLoad = onLoad;
            this._texture = this._getFromCache(url, true);
            if (!this._texture) {
                const scene = this.getScene();
                if (scene) {
                    if (!scene.useDelayedTextureLoading) {
                        this._loadTexture();
                    }
                    else {
                        this.delayLoadState = 4;
                    }
                }
                else {
                    this._loadTexture();
                }
            }
            else {
                this._triggerOnLoad();
            }
        }
        /**
         * Fires the onload event from the constructor if requested.
         */
        _triggerOnLoad() {
            if (this._onLoad) {
                this._onLoad();
            }
        }
        /**
         * Returns the texture matrix used in most of the material.
         * This is not used in color grading but keep for troubleshooting purpose (easily swap diffuse by colorgrading to look in).
         */
        getTextureMatrix() {
            return this._textureMatrix;
        }
        /**
         * Occurs when the file being loaded is a .3dl LUT file.
         */
        _load3dlTexture() {
            const engine = this._getEngine();
            let texture;
            if (!engine._features.support3DTextures) {
                texture = engine.createRawTexture(null, 1, 1, 5, false, false, 2, null, 0);
            }
            else {
                texture = engine.createRawTexture3D(null, 1, 1, 1, 5, false, false, 2, null, 0);
            }
            this._texture = texture;
            this._texture.isReady = false;
            this.isCube = false;
            this.is3D = engine._features.support3DTextures;
            this.wrapU = 0;
            this.wrapV = 0;
            this.wrapR = 0;
            this.anisotropicFilteringLevel = 1;
            const callback = (text) => {
                if (typeof text !== "string") {
                    return;
                }
                let data = null;
                let tempData = null;
                let line;
                const lines = text.split("\n");
                let size = 0, pixelIndexW = 0, pixelIndexH = 0, pixelIndexSlice = 0;
                let maxColor = 0;
                for (let i = 0; i < lines.length; i++) {
                    line = lines[i];
                    if (!ColorGradingTexture._NoneEmptyLineRegex.test(line)) {
                        continue;
                    }
                    if (line.indexOf("#") === 0) {
                        continue;
                    }
                    const words = line.split(" ");
                    if (size === 0) {
                        // Number of space + one
                        size = words.length;
                        data = new Uint8Array(size * size * size * 4); // volume texture of side size and rgb 8
                        tempData = new Float32Array(size * size * size * 4);
                        continue;
                    }
                    if (size != 0) {
                        const r = Math.max(parseInt(words[0]), 0);
                        const g = Math.max(parseInt(words[1]), 0);
                        const b = Math.max(parseInt(words[2]), 0);
                        maxColor = Math.max(r, maxColor);
                        maxColor = Math.max(g, maxColor);
                        maxColor = Math.max(b, maxColor);
                        const pixelStorageIndex = (pixelIndexW + pixelIndexSlice * size + pixelIndexH * size * size) * 4;
                        if (tempData) {
                            tempData[pixelStorageIndex + 0] = r;
                            tempData[pixelStorageIndex + 1] = g;
                            tempData[pixelStorageIndex + 2] = b;
                        }
                        // Keep for reference in case of back compat problems.
                        // pixelIndexSlice++;
                        // if (pixelIndexSlice % size == 0) {
                        //     pixelIndexH++;
                        //     pixelIndexSlice = 0;
                        //     if (pixelIndexH % size == 0) {
                        //         pixelIndexW++;
                        //         pixelIndexH = 0;
                        //     }
                        // }
                        pixelIndexH++;
                        if (pixelIndexH % size == 0) {
                            pixelIndexSlice++;
                            pixelIndexH = 0;
                            if (pixelIndexSlice % size == 0) {
                                pixelIndexW++;
                                pixelIndexSlice = 0;
                            }
                        }
                    }
                }
                if (tempData && data) {
                    for (let i = 0; i < tempData.length; i++) {
                        if (i > 0 && (i + 1) % 4 === 0) {
                            data[i] = 255;
                        }
                        else {
                            const value = tempData[i];
                            data[i] = (value / maxColor) * 255;
                        }
                    }
                }
                if (texture.is3D) {
                    texture.updateSize(size, size, size);
                    engine.updateRawTexture3D(texture, data, 5, false);
                }
                else {
                    texture.updateSize(size * size, size);
                    engine.updateRawTexture(texture, data, 5, false);
                }
                texture.isReady = true;
                this._triggerOnLoad();
            };
            const scene = this.getScene();
            if (scene) {
                scene._loadFile(this.url, callback);
            }
            else {
                engine._loadFile(this.url, callback);
            }
            return this._texture;
        }
        /**
         * Starts the loading process of the texture.
         */
        _loadTexture() {
            if (this.url && this.url.toLocaleLowerCase().indexOf(".3dl") == this.url.length - 4) {
                this._load3dlTexture();
            }
        }
        /**
         * Clones the color grading texture.
         */
        clone() {
            const newTexture = new ColorGradingTexture(this.url, this.getScene() || this._getEngine());
            // Base texture
            newTexture.level = this.level;
            return newTexture;
        }
        /**
         * Called during delayed load for textures.
         */
        delayLoad() {
            if (this.delayLoadState !== 4) {
                return;
            }
            this.delayLoadState = 1;
            this._texture = this._getFromCache(this.url, true);
            if (!this._texture) {
                this._loadTexture();
            }
        }
        /**
         * Parses a color grading texture serialized by Babylon.
         * @param parsedTexture The texture information being parsedTexture
         * @param scene The scene to load the texture in
         * @returns A color grading texture
         */
        static Parse(parsedTexture, scene) {
            let texture = null;
            if (parsedTexture.name && !parsedTexture.isRenderTarget) {
                texture = new ColorGradingTexture(parsedTexture.name, scene);
                texture.name = parsedTexture.name;
                texture.level = parsedTexture.level;
            }
            return texture;
        }
        /**
         * Serializes the LUT texture to json format.
         */
        serialize() {
            if (!this.name) {
                return null;
            }
            const serializationObject = {};
            serializationObject.name = this.name;
            serializationObject.level = this.level;
            serializationObject.customType = "BABYLON.ColorGradingTexture";
            return serializationObject;
        }
    }
    /**
     * Empty line regex stored for GC.
     */
    ColorGradingTexture._NoneEmptyLineRegex = /\S+/;
    RegisterClass("BABYLON.ColorGradingTexture", ColorGradingTexture);

    /**
     * Helper class useful to convert panorama picture to their cubemap representation in 6 faces.
     */
    class PanoramaToCubeMapTools {
        /**
         * Converts a panorama stored in RGB right to left up to down format into a cubemap (6 faces).
         *
         * @param float32Array The source data.
         * @param inputWidth The width of the input panorama.
         * @param inputHeight The height of the input panorama.
         * @param size The willing size of the generated cubemap (each faces will be size * size pixels)
         * @returns The cubemap data
         */
        static ConvertPanoramaToCubemap(float32Array, inputWidth, inputHeight, size, supersample = false) {
            if (!float32Array) {
                throw "ConvertPanoramaToCubemap: input cannot be null";
            }
            if (float32Array.length != inputWidth * inputHeight * 3) {
                throw "ConvertPanoramaToCubemap: input size is wrong";
            }
            const textureFront = this.CreateCubemapTexture(size, this.FACE_FRONT, float32Array, inputWidth, inputHeight, supersample);
            const textureBack = this.CreateCubemapTexture(size, this.FACE_BACK, float32Array, inputWidth, inputHeight, supersample);
            const textureLeft = this.CreateCubemapTexture(size, this.FACE_LEFT, float32Array, inputWidth, inputHeight, supersample);
            const textureRight = this.CreateCubemapTexture(size, this.FACE_RIGHT, float32Array, inputWidth, inputHeight, supersample);
            const textureUp = this.CreateCubemapTexture(size, this.FACE_UP, float32Array, inputWidth, inputHeight, supersample);
            const textureDown = this.CreateCubemapTexture(size, this.FACE_DOWN, float32Array, inputWidth, inputHeight, supersample);
            return {
                front: textureFront,
                back: textureBack,
                left: textureLeft,
                right: textureRight,
                up: textureUp,
                down: textureDown,
                size: size,
                type: 1,
                format: 4,
                gammaSpace: false,
            };
        }
        static CreateCubemapTexture(texSize, faceData, float32Array, inputWidth, inputHeight, supersample = false) {
            const buffer = new ArrayBuffer(texSize * texSize * 4 * 3);
            const textureArray = new Float32Array(buffer);
            // If supersampling, determine number of samples needed when source texture width is divided for 4 cube faces
            const samples = supersample ? Math.max(1, Math.round(inputWidth / 4 / texSize)) : 1;
            const sampleFactor = 1 / samples;
            const sampleFactorSqr = sampleFactor * sampleFactor;
            const rotDX1 = faceData[1].subtract(faceData[0]).scale(sampleFactor / texSize);
            const rotDX2 = faceData[3].subtract(faceData[2]).scale(sampleFactor / texSize);
            const dy = 1 / texSize;
            let fy = 0;
            for (let y = 0; y < texSize; y++) {
                for (let sy = 0; sy < samples; sy++) {
                    let xv1 = faceData[0];
                    let xv2 = faceData[2];
                    for (let x = 0; x < texSize; x++) {
                        for (let sx = 0; sx < samples; sx++) {
                            const v = xv2.subtract(xv1).scale(fy).add(xv1);
                            v.normalize();
                            const color = this.CalcProjectionSpherical(v, float32Array, inputWidth, inputHeight);
                            // 3 channels per pixels
                            textureArray[y * texSize * 3 + x * 3 + 0] += color.r * sampleFactorSqr;
                            textureArray[y * texSize * 3 + x * 3 + 1] += color.g * sampleFactorSqr;
                            textureArray[y * texSize * 3 + x * 3 + 2] += color.b * sampleFactorSqr;
                            xv1 = xv1.add(rotDX1);
                            xv2 = xv2.add(rotDX2);
                        }
                    }
                    fy += dy * sampleFactor;
                }
            }
            return textureArray;
        }
        static CalcProjectionSpherical(vDir, float32Array, inputWidth, inputHeight) {
            let theta = Math.atan2(vDir.z, vDir.x);
            const phi = Math.acos(vDir.y);
            while (theta < -Math.PI) {
                theta += 2 * Math.PI;
            }
            while (theta > Math.PI) {
                theta -= 2 * Math.PI;
            }
            let dx = theta / Math.PI;
            const dy = phi / Math.PI;
            // recenter.
            dx = dx * 0.5 + 0.5;
            let px = Math.round(dx * inputWidth);
            if (px < 0) {
                px = 0;
            }
            else if (px >= inputWidth) {
                px = inputWidth - 1;
            }
            let py = Math.round(dy * inputHeight);
            if (py < 0) {
                py = 0;
            }
            else if (py >= inputHeight) {
                py = inputHeight - 1;
            }
            const inputY = inputHeight - py - 1;
            const r = float32Array[inputY * inputWidth * 3 + px * 3 + 0];
            const g = float32Array[inputY * inputWidth * 3 + px * 3 + 1];
            const b = float32Array[inputY * inputWidth * 3 + px * 3 + 2];
            return {
                r: r,
                g: g,
                b: b,
            };
        }
    }
    PanoramaToCubeMapTools.FACE_LEFT = [new Vector3(-1.0, -1.0, -1.0), new Vector3(1.0, -1.0, -1.0), new Vector3(-1.0, 1.0, -1.0), new Vector3(1.0, 1.0, -1.0)];
    PanoramaToCubeMapTools.FACE_RIGHT = [new Vector3(1.0, -1.0, 1.0), new Vector3(-1.0, -1.0, 1.0), new Vector3(1.0, 1.0, 1.0), new Vector3(-1.0, 1.0, 1.0)];
    PanoramaToCubeMapTools.FACE_FRONT = [new Vector3(1.0, -1.0, -1.0), new Vector3(1.0, -1.0, 1.0), new Vector3(1.0, 1.0, -1.0), new Vector3(1.0, 1.0, 1.0)];
    PanoramaToCubeMapTools.FACE_BACK = [new Vector3(-1.0, -1.0, 1.0), new Vector3(-1.0, -1.0, -1.0), new Vector3(-1.0, 1.0, 1.0), new Vector3(-1.0, 1.0, -1.0)];
    PanoramaToCubeMapTools.FACE_DOWN = [new Vector3(1.0, 1.0, -1.0), new Vector3(1.0, 1.0, 1.0), new Vector3(-1.0, 1.0, -1.0), new Vector3(-1.0, 1.0, 1.0)];
    PanoramaToCubeMapTools.FACE_UP = [new Vector3(-1.0, -1.0, -1.0), new Vector3(-1.0, -1.0, 1.0), new Vector3(1.0, -1.0, -1.0), new Vector3(1.0, -1.0, 1.0)];

    // Do not edit.
    const name$2q = "hdrFilteringVertexShader";
    const shader$2q = `attribute vec2 position;varying vec3 direction;uniform vec3 up;uniform vec3 right;uniform vec3 front;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
mat3 view=mat3(up,right,front);direction=view*vec3(position,1.0);gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2q] = shader$2q;

    // Do not edit.
    const name$2r = "hdrFilteringPixelShader";
    const shader$2r = `#include<helperFunctions>
#include<importanceSampling>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
uniform float alphaG;uniform samplerCube inputTexture;uniform vec2 vFilteringInfo;uniform float hdrScale;varying vec3 direction;void main() {vec3 color=radiance(alphaG,inputTexture,direction,vFilteringInfo);gl_FragColor=vec4(color*hdrScale,1.0);}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2r] = shader$2r;

    /**
     * Filters HDR maps to get correct renderings of PBR reflections
     */
    class HDRFiltering {
        /**
         * Instantiates HDR filter for reflection maps
         *
         * @param engine Thin engine
         * @param options Options
         */
        constructor(engine, options = {}) {
            this._lodGenerationOffset = 0;
            this._lodGenerationScale = 0.8;
            /**
             * Quality switch for prefiltering. Should be set to `4096` unless
             * you care about baking speed.
             */
            this.quality = 4096;
            /**
             * Scales pixel intensity for the input HDR map.
             */
            this.hdrScale = 1;
            // pass
            this._engine = engine;
            this.hdrScale = options.hdrScale || this.hdrScale;
            this.quality = options.quality || this.quality;
        }
        _createRenderTarget(size) {
            let textureType = 0;
            if (this._engine.getCaps().textureHalfFloatRender) {
                textureType = 2;
            }
            else if (this._engine.getCaps().textureFloatRender) {
                textureType = 1;
            }
            const rtWrapper = this._engine.createRenderTargetCubeTexture(size, {
                format: 5,
                type: textureType,
                createMipMaps: true,
                generateMipMaps: false,
                generateDepthBuffer: false,
                generateStencilBuffer: false,
                samplingMode: 1,
            });
            this._engine.updateTextureWrappingMode(rtWrapper.texture, 0, 0, 0);
            this._engine.updateTextureSamplingMode(3, rtWrapper.texture, true);
            return rtWrapper;
        }
        _prefilterInternal(texture) {
            const width = texture.getSize().width;
            const mipmapsCount = Scalar.ILog2(width) + 1;
            const effect = this._effectWrapper.effect;
            const outputTexture = this._createRenderTarget(width);
            this._effectRenderer.saveStates();
            this._effectRenderer.setViewport();
            const intTexture = texture.getInternalTexture();
            if (intTexture) {
                // Just in case generate fresh clean mips.
                this._engine.updateTextureSamplingMode(3, intTexture, true);
            }
            this._effectRenderer.applyEffectWrapper(this._effectWrapper);
            const directions = [
                [new Vector3(0, 0, -1), new Vector3(0, -1, 0), new Vector3(1, 0, 0)],
                [new Vector3(0, 0, 1), new Vector3(0, -1, 0), new Vector3(-1, 0, 0)],
                [new Vector3(1, 0, 0), new Vector3(0, 0, 1), new Vector3(0, 1, 0)],
                [new Vector3(1, 0, 0), new Vector3(0, 0, -1), new Vector3(0, -1, 0)],
                [new Vector3(1, 0, 0), new Vector3(0, -1, 0), new Vector3(0, 0, 1)],
                [new Vector3(-1, 0, 0), new Vector3(0, -1, 0), new Vector3(0, 0, -1)], // NegativeZ
            ];
            effect.setFloat("hdrScale", this.hdrScale);
            effect.setFloat2("vFilteringInfo", texture.getSize().width, mipmapsCount);
            effect.setTexture("inputTexture", texture);
            for (let face = 0; face < 6; face++) {
                effect.setVector3("up", directions[face][0]);
                effect.setVector3("right", directions[face][1]);
                effect.setVector3("front", directions[face][2]);
                for (let lod = 0; lod < mipmapsCount; lod++) {
                    this._engine.bindFramebuffer(outputTexture, face, undefined, undefined, true, lod);
                    this._effectRenderer.applyEffectWrapper(this._effectWrapper);
                    let alpha = Math.pow(2, (lod - this._lodGenerationOffset) / this._lodGenerationScale) / width;
                    if (lod === 0) {
                        alpha = 0;
                    }
                    effect.setFloat("alphaG", alpha);
                    this._effectRenderer.draw();
                }
            }
            // Cleanup
            this._effectRenderer.restoreStates();
            this._engine.restoreDefaultFramebuffer();
            this._engine._releaseTexture(texture._texture);
            // Internal Swap
            const type = outputTexture.texture.type;
            const format = outputTexture.texture.format;
            outputTexture._swapAndDie(texture._texture);
            texture._texture.type = type;
            texture._texture.format = format;
            // New settings
            texture.gammaSpace = false;
            texture.lodGenerationOffset = this._lodGenerationOffset;
            texture.lodGenerationScale = this._lodGenerationScale;
            texture._prefiltered = true;
            return texture;
        }
        _createEffect(texture, onCompiled) {
            const defines = [];
            if (texture.gammaSpace) {
                defines.push("#define GAMMA_INPUT");
            }
            defines.push("#define NUM_SAMPLES " + this.quality + "u"); // unsigned int
            const effectWrapper = new EffectWrapper({
                engine: this._engine,
                name: "hdrFiltering",
                vertexShader: "hdrFiltering",
                fragmentShader: "hdrFiltering",
                samplerNames: ["inputTexture"],
                uniformNames: ["vSampleDirections", "vWeights", "up", "right", "front", "vFilteringInfo", "hdrScale", "alphaG"],
                useShaderStore: true,
                defines,
                onCompiled: onCompiled,
            });
            return effectWrapper;
        }
        /**
         * Get a value indicating if the filter is ready to be used
         * @param texture Texture to filter
         * @returns true if the filter is ready
         */
        isReady(texture) {
            return texture.isReady() && this._effectWrapper.effect.isReady();
        }
        /**
         * Prefilters a cube texture to have mipmap levels representing roughness values.
         * Prefiltering will be invoked at the end of next rendering pass.
         * This has to be done once the map is loaded, and has not been prefiltered by a third party software.
         * See http://blog.selfshadow.com/publications/s2013-shading-course/karis/s2013_pbs_epic_notes_v2.pdf for more information
         * @param texture Texture to filter
         * @param onFinished Callback when filtering is done
         * @returns Promise called when prefiltering is done
         */
        prefilter(texture, onFinished = null) {
            if (!this._engine._features.allowTexturePrefiltering) {
                Logger.Warn("HDR prefiltering is not available in WebGL 1., you can use real time filtering instead.");
                return Promise.reject("HDR prefiltering is not available in WebGL 1., you can use real time filtering instead.");
            }
            return new Promise((resolve) => {
                this._effectRenderer = new EffectRenderer(this._engine);
                this._effectWrapper = this._createEffect(texture);
                this._effectWrapper.effect.executeWhenCompiled(() => {
                    this._prefilterInternal(texture);
                    this._effectRenderer.dispose();
                    this._effectWrapper.dispose();
                    resolve();
                    if (onFinished) {
                        onFinished();
                    }
                });
            });
        }
    }

    /**
     * This groups tools to convert HDR texture to native colors array.
     */
    class HDRTools {
        static _Ldexp(mantissa, exponent) {
            if (exponent > 1023) {
                return mantissa * Math.pow(2, 1023) * Math.pow(2, exponent - 1023);
            }
            if (exponent < -1074) {
                return mantissa * Math.pow(2, -1074) * Math.pow(2, exponent + 1074);
            }
            return mantissa * Math.pow(2, exponent);
        }
        static _Rgbe2float(float32array, red, green, blue, exponent, index) {
            if (exponent > 0) {
                /*nonzero pixel*/
                exponent = this._Ldexp(1.0, exponent - (128 + 8));
                float32array[index + 0] = red * exponent;
                float32array[index + 1] = green * exponent;
                float32array[index + 2] = blue * exponent;
            }
            else {
                float32array[index + 0] = 0;
                float32array[index + 1] = 0;
                float32array[index + 2] = 0;
            }
        }
        static _ReadStringLine(uint8array, startIndex) {
            let line = "";
            let character = "";
            for (let i = startIndex; i < uint8array.length - startIndex; i++) {
                character = String.fromCharCode(uint8array[i]);
                if (character == "\n") {
                    break;
                }
                line += character;
            }
            return line;
        }
        /**
         * Reads header information from an RGBE texture stored in a native array.
         * More information on this format are available here:
         * https://en.wikipedia.org/wiki/RGBE_image_format
         *
         * @param uint8array The binary file stored in  native array.
         * @returns The header information.
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static RGBE_ReadHeader(uint8array) {
            let height = 0;
            let width = 0;
            let line = this._ReadStringLine(uint8array, 0);
            if (line[0] != "#" || line[1] != "?") {
                throw "Bad HDR Format.";
            }
            let endOfHeader = false;
            let findFormat = false;
            let lineIndex = 0;
            do {
                lineIndex += line.length + 1;
                line = this._ReadStringLine(uint8array, lineIndex);
                if (line == "FORMAT=32-bit_rle_rgbe") {
                    findFormat = true;
                }
                else if (line.length == 0) {
                    endOfHeader = true;
                }
            } while (!endOfHeader);
            if (!findFormat) {
                throw "HDR Bad header format, unsupported FORMAT";
            }
            lineIndex += line.length + 1;
            line = this._ReadStringLine(uint8array, lineIndex);
            const sizeRegexp = /^-Y (.*) \+X (.*)$/g;
            const match = sizeRegexp.exec(line);
            // TODO. Support +Y and -X if needed.
            if (!match || match.length < 3) {
                throw "HDR Bad header format, no size";
            }
            width = parseInt(match[2]);
            height = parseInt(match[1]);
            if (width < 8 || width > 0x7fff) {
                throw "HDR Bad header format, unsupported size";
            }
            lineIndex += line.length + 1;
            return {
                height: height,
                width: width,
                dataPosition: lineIndex,
            };
        }
        /**
         * Returns the cubemap information (each faces texture data) extracted from an RGBE texture.
         * This RGBE texture needs to store the information as a panorama.
         *
         * More information on this format are available here:
         * https://en.wikipedia.org/wiki/RGBE_image_format
         *
         * @param buffer The binary file stored in an array buffer.
         * @param size The expected size of the extracted cubemap.
         * @returns The Cube Map information.
         */
        static GetCubeMapTextureData(buffer, size, supersample = false) {
            const uint8array = new Uint8Array(buffer);
            const hdrInfo = this.RGBE_ReadHeader(uint8array);
            const data = this.RGBE_ReadPixels(uint8array, hdrInfo);
            const cubeMapData = PanoramaToCubeMapTools.ConvertPanoramaToCubemap(data, hdrInfo.width, hdrInfo.height, size, supersample);
            return cubeMapData;
        }
        /**
         * Returns the pixels data extracted from an RGBE texture.
         * This pixels will be stored left to right up to down in the R G B order in one array.
         *
         * More information on this format are available here:
         * https://en.wikipedia.org/wiki/RGBE_image_format
         *
         * @param uint8array The binary file stored in an array buffer.
         * @param hdrInfo The header information of the file.
         * @returns The pixels data in RGB right to left up to down order.
         */
        // eslint-disable-next-line @typescript-eslint/naming-convention
        static RGBE_ReadPixels(uint8array, hdrInfo) {
            return this._RGBEReadPixelsRLE(uint8array, hdrInfo);
        }
        static _RGBEReadPixelsRLE(uint8array, hdrInfo) {
            let num_scanlines = hdrInfo.height;
            const scanline_width = hdrInfo.width;
            let a, b, c, d, count;
            let dataIndex = hdrInfo.dataPosition;
            let index = 0, endIndex = 0, i = 0;
            const scanLineArrayBuffer = new ArrayBuffer(scanline_width * 4); // four channel R G B E
            const scanLineArray = new Uint8Array(scanLineArrayBuffer);
            // 3 channels of 4 bytes per pixel in float.
            const resultBuffer = new ArrayBuffer(hdrInfo.width * hdrInfo.height * 4 * 3);
            const resultArray = new Float32Array(resultBuffer);
            // read in each successive scanline
            while (num_scanlines > 0) {
                a = uint8array[dataIndex++];
                b = uint8array[dataIndex++];
                c = uint8array[dataIndex++];
                d = uint8array[dataIndex++];
                if (a != 2 || b != 2 || c & 0x80 || hdrInfo.width < 8 || hdrInfo.width > 32767) {
                    return this._RGBEReadPixelsNOTRLE(uint8array, hdrInfo);
                }
                if (((c << 8) | d) != scanline_width) {
                    throw "HDR Bad header format, wrong scan line width";
                }
                index = 0;
                // read each of the four channels for the scanline into the buffer
                for (i = 0; i < 4; i++) {
                    endIndex = (i + 1) * scanline_width;
                    while (index < endIndex) {
                        a = uint8array[dataIndex++];
                        b = uint8array[dataIndex++];
                        if (a > 128) {
                            // a run of the same value
                            count = a - 128;
                            if (count == 0 || count > endIndex - index) {
                                throw "HDR Bad Format, bad scanline data (run)";
                            }
                            while (count-- > 0) {
                                scanLineArray[index++] = b;
                            }
                        }
                        else {
                            // a non-run
                            count = a;
                            if (count == 0 || count > endIndex - index) {
                                throw "HDR Bad Format, bad scanline data (non-run)";
                            }
                            scanLineArray[index++] = b;
                            if (--count > 0) {
                                for (let j = 0; j < count; j++) {
                                    scanLineArray[index++] = uint8array[dataIndex++];
                                }
                            }
                        }
                    }
                }
                // now convert data from buffer into floats
                for (i = 0; i < scanline_width; i++) {
                    a = scanLineArray[i];
                    b = scanLineArray[i + scanline_width];
                    c = scanLineArray[i + 2 * scanline_width];
                    d = scanLineArray[i + 3 * scanline_width];
                    this._Rgbe2float(resultArray, a, b, c, d, (hdrInfo.height - num_scanlines) * scanline_width * 3 + i * 3);
                }
                num_scanlines--;
            }
            return resultArray;
        }
        static _RGBEReadPixelsNOTRLE(uint8array, hdrInfo) {
            // this file is not run length encoded
            // read values sequentially
            let num_scanlines = hdrInfo.height;
            const scanline_width = hdrInfo.width;
            let a, b, c, d, i;
            let dataIndex = hdrInfo.dataPosition;
            // 3 channels of 4 bytes per pixel in float.
            const resultBuffer = new ArrayBuffer(hdrInfo.width * hdrInfo.height * 4 * 3);
            const resultArray = new Float32Array(resultBuffer);
            // read in each successive scanline
            while (num_scanlines > 0) {
                for (i = 0; i < hdrInfo.width; i++) {
                    a = uint8array[dataIndex++];
                    b = uint8array[dataIndex++];
                    c = uint8array[dataIndex++];
                    d = uint8array[dataIndex++];
                    this._Rgbe2float(resultArray, a, b, c, d, (hdrInfo.height - num_scanlines) * scanline_width * 3 + i * 3);
                }
                num_scanlines--;
            }
            return resultArray;
        }
    }

    /**
     * This represents a texture coming from an HDR input.
     *
     * The only supported format is currently panorama picture stored in RGBE format.
     * Example of such files can be found on Poly Haven: https://polyhaven.com/hdris
     */
    class HDRCubeTexture extends BaseTexture {
        /**
         * Sets whether or not the texture is blocking during loading.
         */
        set isBlocking(value) {
            this._isBlocking = value;
        }
        /**
         * Gets whether or not the texture is blocking during loading.
         */
        get isBlocking() {
            return this._isBlocking;
        }
        /**
         * Sets texture matrix rotation angle around Y axis in radians.
         */
        set rotationY(value) {
            this._rotationY = value;
            this.setReflectionTextureMatrix(Matrix.RotationY(this._rotationY));
        }
        /**
         * Gets texture matrix rotation angle around Y axis radians.
         */
        get rotationY() {
            return this._rotationY;
        }
        /**
         * Gets or sets the size of the bounding box associated with the cube texture
         * When defined, the cubemap will switch to local mode
         * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
         * @example https://www.babylonjs-playground.com/#RNASML
         */
        set boundingBoxSize(value) {
            if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) {
                return;
            }
            this._boundingBoxSize = value;
            const scene = this.getScene();
            if (scene) {
                scene.markAllMaterialsAsDirty(1);
            }
        }
        get boundingBoxSize() {
            return this._boundingBoxSize;
        }
        /**
         * Instantiates an HDRTexture from the following parameters.
         *
         * @param url The location of the HDR raw data (Panorama stored in RGBE format)
         * @param sceneOrEngine The scene or engine the texture will be used in
         * @param size The cubemap desired size (the more it increases the longer the generation will be)
         * @param noMipmap Forces to not generate the mipmap if true
         * @param generateHarmonics Specifies whether you want to extract the polynomial harmonics during the generation process
         * @param gammaSpace Specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space)
         * @param prefilterOnLoad Prefilters HDR texture to allow use of this texture as a PBR reflection texture.
         * @param onLoad
         * @param onError
         */
        constructor(url, sceneOrEngine, size, noMipmap = false, generateHarmonics = true, gammaSpace = false, prefilterOnLoad = false, onLoad = null, onError = null, supersample = false) {
            var _a;
            super(sceneOrEngine);
            this._generateHarmonics = true;
            this._onError = null;
            this._isBlocking = true;
            this._rotationY = 0;
            /**
             * Gets or sets the center of the bounding box associated with the cube texture
             * It must define where the camera used to render the texture was set
             */
            this.boundingBoxPosition = Vector3.Zero();
            /**
             * Observable triggered once the texture has been loaded.
             */
            this.onLoadObservable = new Observable$1();
            if (!url) {
                return;
            }
            this._coordinatesMode = Texture.CUBIC_MODE;
            this.name = url;
            this.url = url;
            this.hasAlpha = false;
            this.isCube = true;
            this._textureMatrix = Matrix.Identity();
            this._prefilterOnLoad = prefilterOnLoad;
            this._onLoad = () => {
                this.onLoadObservable.notifyObservers(this);
                if (onLoad) {
                    onLoad();
                }
            };
            this._onError = onError;
            this.gammaSpace = gammaSpace;
            this._noMipmap = noMipmap;
            this._size = size;
            this._supersample = supersample;
            this._generateHarmonics = generateHarmonics;
            this._texture = this._getFromCache(url, this._noMipmap, undefined, undefined, undefined, this.isCube);
            if (!this._texture) {
                if (!((_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.useDelayedTextureLoading)) {
                    this._loadTexture();
                }
                else {
                    this.delayLoadState = 4;
                }
            }
            else {
                if (this._texture.isReady) {
                    Tools.SetImmediate(() => this._onLoad());
                }
                else {
                    this._texture.onLoadedObservable.add(this._onLoad);
                }
            }
        }
        /**
         * Get the current class name of the texture useful for serialization or dynamic coding.
         * @returns "HDRCubeTexture"
         */
        getClassName() {
            return "HDRCubeTexture";
        }
        /**
         * Occurs when the file is raw .hdr file.
         */
        _loadTexture() {
            const engine = this._getEngine();
            const caps = engine.getCaps();
            let textureType = 0;
            if (caps.textureFloat && caps.textureFloatLinearFiltering) {
                textureType = 1;
            }
            else if (caps.textureHalfFloat && caps.textureHalfFloatLinearFiltering) {
                textureType = 2;
            }
            const callback = (buffer) => {
                this.lodGenerationOffset = 0.0;
                this.lodGenerationScale = 0.8;
                // Extract the raw linear data.
                const data = HDRTools.GetCubeMapTextureData(buffer, this._size, this._supersample);
                // Generate harmonics if needed.
                if (this._generateHarmonics) {
                    const sphericalPolynomial = CubeMapToSphericalPolynomialTools.ConvertCubeMapToSphericalPolynomial(data);
                    this.sphericalPolynomial = sphericalPolynomial;
                }
                const results = [];
                let byteArray = null;
                let shortArray = null;
                // Push each faces.
                for (let j = 0; j < 6; j++) {
                    // Create fallback array
                    if (textureType === 2) {
                        shortArray = new Uint16Array(this._size * this._size * 3);
                    }
                    else if (textureType === 0) {
                        // 3 channels of 1 bytes per pixel in bytes.
                        byteArray = new Uint8Array(this._size * this._size * 3);
                    }
                    const dataFace = data[HDRCubeTexture._FacesMapping[j]];
                    // If special cases.
                    if (this.gammaSpace || shortArray || byteArray) {
                        for (let i = 0; i < this._size * this._size; i++) {
                            // Put in gamma space if requested.
                            if (this.gammaSpace) {
                                dataFace[i * 3 + 0] = Math.pow(dataFace[i * 3 + 0], ToGammaSpace);
                                dataFace[i * 3 + 1] = Math.pow(dataFace[i * 3 + 1], ToGammaSpace);
                                dataFace[i * 3 + 2] = Math.pow(dataFace[i * 3 + 2], ToGammaSpace);
                            }
                            // Convert to half float texture for fallback.
                            if (shortArray) {
                                shortArray[i * 3 + 0] = ToHalfFloat(dataFace[i * 3 + 0]);
                                shortArray[i * 3 + 1] = ToHalfFloat(dataFace[i * 3 + 1]);
                                shortArray[i * 3 + 2] = ToHalfFloat(dataFace[i * 3 + 2]);
                            }
                            // Convert to int texture for fallback.
                            if (byteArray) {
                                let r = Math.max(dataFace[i * 3 + 0] * 255, 0);
                                let g = Math.max(dataFace[i * 3 + 1] * 255, 0);
                                let b = Math.max(dataFace[i * 3 + 2] * 255, 0);
                                // May use luminance instead if the result is not accurate.
                                const max = Math.max(Math.max(r, g), b);
                                if (max > 255) {
                                    const scale = 255 / max;
                                    r *= scale;
                                    g *= scale;
                                    b *= scale;
                                }
                                byteArray[i * 3 + 0] = r;
                                byteArray[i * 3 + 1] = g;
                                byteArray[i * 3 + 2] = b;
                            }
                        }
                    }
                    if (shortArray) {
                        results.push(shortArray);
                    }
                    else if (byteArray) {
                        results.push(byteArray);
                    }
                    else {
                        results.push(dataFace);
                    }
                }
                return results;
            };
            if (engine._features.allowTexturePrefiltering && this._prefilterOnLoad) {
                const previousOnLoad = this._onLoad;
                const hdrFiltering = new HDRFiltering(engine);
                this._onLoad = () => {
                    hdrFiltering.prefilter(this, previousOnLoad);
                };
            }
            this._texture = engine.createRawCubeTextureFromUrl(this.url, this.getScene(), this._size, 4, textureType, this._noMipmap, callback, null, this._onLoad, this._onError);
        }
        clone() {
            const newTexture = new HDRCubeTexture(this.url, this.getScene() || this._getEngine(), this._size, this._noMipmap, this._generateHarmonics, this.gammaSpace);
            // Base texture
            newTexture.level = this.level;
            newTexture.wrapU = this.wrapU;
            newTexture.wrapV = this.wrapV;
            newTexture.coordinatesIndex = this.coordinatesIndex;
            newTexture.coordinatesMode = this.coordinatesMode;
            return newTexture;
        }
        // Methods
        delayLoad() {
            if (this.delayLoadState !== 4) {
                return;
            }
            this.delayLoadState = 1;
            this._texture = this._getFromCache(this.url, this._noMipmap);
            if (!this._texture) {
                this._loadTexture();
            }
        }
        /**
         * Get the texture reflection matrix used to rotate/transform the reflection.
         * @returns the reflection matrix
         */
        getReflectionTextureMatrix() {
            return this._textureMatrix;
        }
        /**
         * Set the texture reflection matrix used to rotate/transform the reflection.
         * @param value Define the reflection matrix to set
         */
        setReflectionTextureMatrix(value) {
            var _a;
            this._textureMatrix = value;
            if (value.updateFlag === this._textureMatrix.updateFlag) {
                return;
            }
            if (value.isIdentity() !== this._textureMatrix.isIdentity()) {
                (_a = this.getScene()) === null || _a === void 0 ? void 0 : _a.markAllMaterialsAsDirty(1, (mat) => mat.getActiveTextures().indexOf(this) !== -1);
            }
        }
        /**
         * Dispose the texture and release its associated resources.
         */
        dispose() {
            this.onLoadObservable.clear();
            super.dispose();
        }
        /**
         * Parses a JSON representation of an HDR Texture in order to create the texture
         * @param parsedTexture Define the JSON representation
         * @param scene Define the scene the texture should be created in
         * @param rootUrl Define the root url in case we need to load relative dependencies
         * @returns the newly created texture after parsing
         */
        static Parse(parsedTexture, scene, rootUrl) {
            let texture = null;
            if (parsedTexture.name && !parsedTexture.isRenderTarget) {
                texture = new HDRCubeTexture(rootUrl + parsedTexture.name, scene, parsedTexture.size, parsedTexture.noMipmap, parsedTexture.generateHarmonics, parsedTexture.useInGammaSpace);
                texture.name = parsedTexture.name;
                texture.hasAlpha = parsedTexture.hasAlpha;
                texture.level = parsedTexture.level;
                texture.coordinatesMode = parsedTexture.coordinatesMode;
                texture.isBlocking = parsedTexture.isBlocking;
            }
            if (texture) {
                if (parsedTexture.boundingBoxPosition) {
                    texture.boundingBoxPosition = Vector3.FromArray(parsedTexture.boundingBoxPosition);
                }
                if (parsedTexture.boundingBoxSize) {
                    texture.boundingBoxSize = Vector3.FromArray(parsedTexture.boundingBoxSize);
                }
                if (parsedTexture.rotationY) {
                    texture.rotationY = parsedTexture.rotationY;
                }
            }
            return texture;
        }
        serialize() {
            if (!this.name) {
                return null;
            }
            const serializationObject = {};
            serializationObject.name = this.name;
            serializationObject.hasAlpha = this.hasAlpha;
            serializationObject.isCube = true;
            serializationObject.level = this.level;
            serializationObject.size = this._size;
            serializationObject.coordinatesMode = this.coordinatesMode;
            serializationObject.useInGammaSpace = this.gammaSpace;
            serializationObject.generateHarmonics = this._generateHarmonics;
            serializationObject.customType = "BABYLON.HDRCubeTexture";
            serializationObject.noMipmap = this._noMipmap;
            serializationObject.isBlocking = this._isBlocking;
            serializationObject.rotationY = this._rotationY;
            return serializationObject;
        }
    }
    HDRCubeTexture._FacesMapping = ["right", "left", "up", "down", "front", "back"];
    RegisterClass("BABYLON.HDRCubeTexture", HDRCubeTexture);

    ThinEngine.prototype.updateVideoTexture = function (texture, video, invertY) {
        if (!texture || texture._isDisabled) {
            return;
        }
        const glformat = this._getInternalFormat(texture.format);
        const internalFormat = this._getRGBABufferInternalSizedFormat(0, texture.format);
        const wasPreviouslyBound = this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
        this._unpackFlipY(!invertY); // Video are upside down by default
        try {
            // Testing video texture support
            if (this._videoTextureSupported === undefined) {
                // clear old errors just in case.
                this._gl.getError();
                this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, video);
                if (this._gl.getError() !== 0) {
                    this._videoTextureSupported = false;
                }
                else {
                    this._videoTextureSupported = true;
                }
            }
            // Copy video through the current working canvas if video texture is not supported
            if (!this._videoTextureSupported) {
                if (!texture._workingCanvas) {
                    texture._workingCanvas = this.createCanvas(texture.width, texture.height);
                    const context = texture._workingCanvas.getContext("2d");
                    if (!context) {
                        throw new Error("Unable to get 2d context");
                    }
                    texture._workingContext = context;
                    texture._workingCanvas.width = texture.width;
                    texture._workingCanvas.height = texture.height;
                }
                texture._workingContext.clearRect(0, 0, texture.width, texture.height);
                texture._workingContext.drawImage(video, 0, 0, video.videoWidth, video.videoHeight, 0, 0, texture.width, texture.height);
                this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, texture._workingCanvas);
            }
            else {
                this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, video);
            }
            if (texture.generateMipMaps) {
                this._gl.generateMipmap(this._gl.TEXTURE_2D);
            }
            if (!wasPreviouslyBound) {
                this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
            }
            //    this.resetTextureCache();
            texture.isReady = true;
        }
        catch (ex) {
            // Something unexpected
            // Let's disable the texture
            texture._isDisabled = true;
        }
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ThinEngine.prototype.createExternalTexture = function (video) {
        return null;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ThinEngine.prototype.setExternalTexture = function (name, texture) {
        throw new Error("setExternalTexture: This engine does not support external textures!");
    };

    //private static _TYPE_NO_DATA = 0;
    const _TYPE_INDEXED = 1;
    const _TYPE_RGB = 2;
    const _TYPE_GREY = 3;
    const _TYPE_RLE_INDEXED = 9;
    const _TYPE_RLE_RGB = 10;
    const _TYPE_RLE_GREY = 11;
    const _ORIGIN_MASK = 0x30;
    const _ORIGIN_SHIFT = 0x04;
    const _ORIGIN_BL = 0x00;
    const _ORIGIN_BR = 0x01;
    const _ORIGIN_UL = 0x02;
    const _ORIGIN_UR = 0x03;
    /**
     * Gets the header of a TGA file
     * @param data defines the TGA data
     * @returns the header
     */
    function GetTGAHeader(data) {
        let offset = 0;
        const header = {
            id_length: data[offset++],
            colormap_type: data[offset++],
            image_type: data[offset++],
            colormap_index: data[offset++] | (data[offset++] << 8),
            colormap_length: data[offset++] | (data[offset++] << 8),
            colormap_size: data[offset++],
            origin: [data[offset++] | (data[offset++] << 8), data[offset++] | (data[offset++] << 8)],
            width: data[offset++] | (data[offset++] << 8),
            height: data[offset++] | (data[offset++] << 8),
            pixel_size: data[offset++],
            flags: data[offset++],
        };
        return header;
    }
    /**
     * Uploads TGA content to a Babylon Texture
     * @internal
     */
    function UploadContent(texture, data) {
        // Not enough data to contain header ?
        if (data.length < 19) {
            Logger.Error("Unable to load TGA file - Not enough data to contain header");
            return;
        }
        // Read Header
        let offset = 18;
        const header = GetTGAHeader(data);
        // Assume it's a valid Targa file.
        if (header.id_length + offset > data.length) {
            Logger.Error("Unable to load TGA file - Not enough data");
            return;
        }
        // Skip not needed data
        offset += header.id_length;
        let use_rle = false;
        let use_pal = false;
        let use_grey = false;
        // Get some informations.
        switch (header.image_type) {
            case _TYPE_RLE_INDEXED:
                use_rle = true;
            // eslint-disable-next-line no-fallthrough
            case _TYPE_INDEXED:
                use_pal = true;
                break;
            case _TYPE_RLE_RGB:
                use_rle = true;
            // eslint-disable-next-line no-fallthrough
            case _TYPE_RGB:
                // use_rgb = true;
                break;
            case _TYPE_RLE_GREY:
                use_rle = true;
            // eslint-disable-next-line no-fallthrough
            case _TYPE_GREY:
                use_grey = true;
                break;
        }
        let pixel_data;
        // var numAlphaBits = header.flags & 0xf;
        const pixel_size = header.pixel_size >> 3;
        const pixel_total = header.width * header.height * pixel_size;
        // Read palettes
        let palettes;
        if (use_pal) {
            palettes = data.subarray(offset, (offset += header.colormap_length * (header.colormap_size >> 3)));
        }
        // Read LRE
        if (use_rle) {
            pixel_data = new Uint8Array(pixel_total);
            let c, count, i;
            let localOffset = 0;
            const pixels = new Uint8Array(pixel_size);
            while (offset < pixel_total && localOffset < pixel_total) {
                c = data[offset++];
                count = (c & 0x7f) + 1;
                // RLE pixels
                if (c & 0x80) {
                    // Bind pixel tmp array
                    for (i = 0; i < pixel_size; ++i) {
                        pixels[i] = data[offset++];
                    }
                    // Copy pixel array
                    for (i = 0; i < count; ++i) {
                        pixel_data.set(pixels, localOffset + i * pixel_size);
                    }
                    localOffset += pixel_size * count;
                }
                // Raw pixels
                else {
                    count *= pixel_size;
                    for (i = 0; i < count; ++i) {
                        pixel_data[localOffset + i] = data[offset++];
                    }
                    localOffset += count;
                }
            }
        }
        // RAW Pixels
        else {
            pixel_data = data.subarray(offset, (offset += use_pal ? header.width * header.height : pixel_total));
        }
        // Load to texture
        let x_start, y_start, x_step, y_step, y_end, x_end;
        switch ((header.flags & _ORIGIN_MASK) >> _ORIGIN_SHIFT) {
            default:
            case _ORIGIN_UL:
                x_start = 0;
                x_step = 1;
                x_end = header.width;
                y_start = 0;
                y_step = 1;
                y_end = header.height;
                break;
            case _ORIGIN_BL:
                x_start = 0;
                x_step = 1;
                x_end = header.width;
                y_start = header.height - 1;
                y_step = -1;
                y_end = -1;
                break;
            case _ORIGIN_UR:
                x_start = header.width - 1;
                x_step = -1;
                x_end = -1;
                y_start = 0;
                y_step = 1;
                y_end = header.height;
                break;
            case _ORIGIN_BR:
                x_start = header.width - 1;
                x_step = -1;
                x_end = -1;
                y_start = header.height - 1;
                y_step = -1;
                y_end = -1;
                break;
        }
        // Load the specify method
        const func = "_getImageData" + (use_grey ? "Grey" : "") + header.pixel_size + "bits";
        const imageData = TGATools[func](header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end);
        const engine = texture.getEngine();
        engine._uploadDataToTextureDirectly(texture, imageData);
    }
    /**
     * @internal
     */
    function _getImageData8bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
        const image = pixel_data, colormap = palettes;
        const width = header.width, height = header.height;
        let color, i = 0, x, y;
        const imageData = new Uint8Array(width * height * 4);
        for (y = y_start; y !== y_end; y += y_step) {
            for (x = x_start; x !== x_end; x += x_step, i++) {
                color = image[i];
                imageData[(x + width * y) * 4 + 3] = 255;
                imageData[(x + width * y) * 4 + 2] = colormap[color * 3 + 0];
                imageData[(x + width * y) * 4 + 1] = colormap[color * 3 + 1];
                imageData[(x + width * y) * 4 + 0] = colormap[color * 3 + 2];
            }
        }
        return imageData;
    }
    /**
     * @internal
     */
    function _getImageData16bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
        const image = pixel_data;
        const width = header.width, height = header.height;
        let color, i = 0, x, y;
        const imageData = new Uint8Array(width * height * 4);
        for (y = y_start; y !== y_end; y += y_step) {
            for (x = x_start; x !== x_end; x += x_step, i += 2) {
                color = image[i + 0] + (image[i + 1] << 8); // Inversed ?
                const r = ((((color & 0x7c00) >> 10) * 255) / 0x1f) | 0;
                const g = ((((color & 0x03e0) >> 5) * 255) / 0x1f) | 0;
                const b = (((color & 0x001f) * 255) / 0x1f) | 0;
                imageData[(x + width * y) * 4 + 0] = r;
                imageData[(x + width * y) * 4 + 1] = g;
                imageData[(x + width * y) * 4 + 2] = b;
                imageData[(x + width * y) * 4 + 3] = color & 0x8000 ? 0 : 255;
            }
        }
        return imageData;
    }
    /**
     * @internal
     */
    function _getImageData24bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
        const image = pixel_data;
        const width = header.width, height = header.height;
        let i = 0, x, y;
        const imageData = new Uint8Array(width * height * 4);
        for (y = y_start; y !== y_end; y += y_step) {
            for (x = x_start; x !== x_end; x += x_step, i += 3) {
                imageData[(x + width * y) * 4 + 3] = 255;
                imageData[(x + width * y) * 4 + 2] = image[i + 0];
                imageData[(x + width * y) * 4 + 1] = image[i + 1];
                imageData[(x + width * y) * 4 + 0] = image[i + 2];
            }
        }
        return imageData;
    }
    /**
     * @internal
     */
    function _getImageData32bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
        const image = pixel_data;
        const width = header.width, height = header.height;
        let i = 0, x, y;
        const imageData = new Uint8Array(width * height * 4);
        for (y = y_start; y !== y_end; y += y_step) {
            for (x = x_start; x !== x_end; x += x_step, i += 4) {
                imageData[(x + width * y) * 4 + 2] = image[i + 0];
                imageData[(x + width * y) * 4 + 1] = image[i + 1];
                imageData[(x + width * y) * 4 + 0] = image[i + 2];
                imageData[(x + width * y) * 4 + 3] = image[i + 3];
            }
        }
        return imageData;
    }
    /**
     * @internal
     */
    function _getImageDataGrey8bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
        const image = pixel_data;
        const width = header.width, height = header.height;
        let color, i = 0, x, y;
        const imageData = new Uint8Array(width * height * 4);
        for (y = y_start; y !== y_end; y += y_step) {
            for (x = x_start; x !== x_end; x += x_step, i++) {
                color = image[i];
                imageData[(x + width * y) * 4 + 0] = color;
                imageData[(x + width * y) * 4 + 1] = color;
                imageData[(x + width * y) * 4 + 2] = color;
                imageData[(x + width * y) * 4 + 3] = 255;
            }
        }
        return imageData;
    }
    /**
     * @internal
     */
    function _getImageDataGrey16bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
        const image = pixel_data;
        const width = header.width, height = header.height;
        let i = 0, x, y;
        const imageData = new Uint8Array(width * height * 4);
        for (y = y_start; y !== y_end; y += y_step) {
            for (x = x_start; x !== x_end; x += x_step, i += 2) {
                imageData[(x + width * y) * 4 + 0] = image[i + 0];
                imageData[(x + width * y) * 4 + 1] = image[i + 0];
                imageData[(x + width * y) * 4 + 2] = image[i + 0];
                imageData[(x + width * y) * 4 + 3] = image[i + 1];
            }
        }
        return imageData;
    }
    /**
     * Based on jsTGALoader - Javascript loader for TGA file
     * By Vincent Thibault
     * @see http://blog.robrowser.com/javascript-tga-loader.html
     */
    const TGATools = {
        /**
         * Gets the header of a TGA file
         * @param data defines the TGA data
         * @returns the header
         */
        GetTGAHeader,
        /**
         * Uploads TGA content to a Babylon Texture
         * @internal
         */
        UploadContent,
        /** @internal */
        _getImageData8bits,
        /** @internal */
        _getImageData16bits,
        /** @internal */
        _getImageData24bits,
        /** @internal */
        _getImageData32bits,
        /** @internal */
        _getImageDataGrey8bits,
        /** @internal */
        _getImageDataGrey16bits,
    };

    /**
     * Implementation of the TGA Texture Loader.
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _TGATextureLoader {
        constructor() {
            /**
             * Defines whether the loader supports cascade loading the different faces.
             */
            this.supportCascades = false;
        }
        /**
         * This returns if the loader support the current file information.
         * @param extension defines the file extension of the file being loaded
         * @returns true if the loader can load the specified file
         */
        canLoad(extension) {
            return extension.endsWith(".tga");
        }
        /**
         * Uploads the cube texture data to the WebGL texture. It has already been bound.
         */
        loadCubeData() {
            throw ".env not supported in Cube.";
        }
        /**
         * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param callback defines the method to call once ready to upload
         */
        loadData(data, texture, callback) {
            const bytes = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
            const header = GetTGAHeader(bytes);
            callback(header.width, header.height, texture.generateMipMaps, false, () => {
                UploadContent(texture, bytes);
            });
        }
    }
    // Register the loader.
    Engine._TextureLoaders.push(new _TGATextureLoader());

    /**
     * Implementation of the HDR Texture Loader.
     * @internal
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _HDRTextureLoader {
        constructor() {
            /**
             * Defines whether the loader supports cascade loading the different faces.
             */
            this.supportCascades = false;
        }
        /**
         * This returns if the loader support the current file information.
         * @param extension defines the file extension of the file being loaded
         * @returns true if the loader can load the specified file
         */
        canLoad(extension) {
            return extension.endsWith(".hdr");
        }
        /**
         * Uploads the cube texture data to the WebGL texture. It has already been bound.
         */
        loadCubeData() {
            throw ".env not supported in Cube.";
        }
        /**
         * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param callback defines the method to call once ready to upload
         */
        loadData(data, texture, callback) {
            const uint8array = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
            const hdrInfo = HDRTools.RGBE_ReadHeader(uint8array);
            const pixelsDataRGB32 = HDRTools.RGBE_ReadPixels(uint8array, hdrInfo);
            const pixels = hdrInfo.width * hdrInfo.height;
            const pixelsDataRGBA32 = new Float32Array(pixels * 4);
            for (let i = 0; i < pixels; i += 1) {
                pixelsDataRGBA32[i * 4] = pixelsDataRGB32[i * 3];
                pixelsDataRGBA32[i * 4 + 1] = pixelsDataRGB32[i * 3 + 1];
                pixelsDataRGBA32[i * 4 + 2] = pixelsDataRGB32[i * 3 + 2];
                pixelsDataRGBA32[i * 4 + 3] = 1;
            }
            callback(hdrInfo.width, hdrInfo.height, texture.generateMipMaps, false, () => {
                const engine = texture.getEngine();
                texture.type = 1;
                texture.format = 5;
                texture._gammaSpace = false;
                engine._uploadDataToTextureDirectly(texture, pixelsDataRGBA32);
            });
        }
    }
    // Register the loader.
    Engine._TextureLoaders.push(new _HDRTextureLoader());

    /**
     * @internal
     * Enum of basis transcoder formats
     */
    var BASIS_FORMATS;
    (function (BASIS_FORMATS) {
        BASIS_FORMATS[BASIS_FORMATS["cTFETC1"] = 0] = "cTFETC1";
        BASIS_FORMATS[BASIS_FORMATS["cTFETC2"] = 1] = "cTFETC2";
        BASIS_FORMATS[BASIS_FORMATS["cTFBC1"] = 2] = "cTFBC1";
        BASIS_FORMATS[BASIS_FORMATS["cTFBC3"] = 3] = "cTFBC3";
        BASIS_FORMATS[BASIS_FORMATS["cTFBC4"] = 4] = "cTFBC4";
        BASIS_FORMATS[BASIS_FORMATS["cTFBC5"] = 5] = "cTFBC5";
        BASIS_FORMATS[BASIS_FORMATS["cTFBC7"] = 6] = "cTFBC7";
        BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC1_4_RGB"] = 8] = "cTFPVRTC1_4_RGB";
        BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC1_4_RGBA"] = 9] = "cTFPVRTC1_4_RGBA";
        BASIS_FORMATS[BASIS_FORMATS["cTFASTC_4x4"] = 10] = "cTFASTC_4x4";
        BASIS_FORMATS[BASIS_FORMATS["cTFATC_RGB"] = 11] = "cTFATC_RGB";
        BASIS_FORMATS[BASIS_FORMATS["cTFATC_RGBA_INTERPOLATED_ALPHA"] = 12] = "cTFATC_RGBA_INTERPOLATED_ALPHA";
        BASIS_FORMATS[BASIS_FORMATS["cTFRGBA32"] = 13] = "cTFRGBA32";
        BASIS_FORMATS[BASIS_FORMATS["cTFRGB565"] = 14] = "cTFRGB565";
        BASIS_FORMATS[BASIS_FORMATS["cTFBGR565"] = 15] = "cTFBGR565";
        BASIS_FORMATS[BASIS_FORMATS["cTFRGBA4444"] = 16] = "cTFRGBA4444";
        BASIS_FORMATS[BASIS_FORMATS["cTFFXT1_RGB"] = 17] = "cTFFXT1_RGB";
        BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC2_4_RGB"] = 18] = "cTFPVRTC2_4_RGB";
        BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC2_4_RGBA"] = 19] = "cTFPVRTC2_4_RGBA";
        BASIS_FORMATS[BASIS_FORMATS["cTFETC2_EAC_R11"] = 20] = "cTFETC2_EAC_R11";
        BASIS_FORMATS[BASIS_FORMATS["cTFETC2_EAC_RG11"] = 21] = "cTFETC2_EAC_RG11";
    })(BASIS_FORMATS || (BASIS_FORMATS = {}));
    /**
     * Used to load .Basis files
     * See https://github.com/BinomialLLC/basis_universal/tree/master/webgl
     */
    const BasisToolsOptions = {
        /**
         * URL to use when loading the basis transcoder
         */
        JSModuleURL: "https://cdn.babylonjs.com/basisTranscoder/1/basis_transcoder.js",
        /**
         * URL to use when loading the wasm module for the transcoder
         */
        WasmModuleURL: "https://cdn.babylonjs.com/basisTranscoder/1/basis_transcoder.wasm",
    };
    /**
     * Get the internal format to be passed to texImage2D corresponding to the .basis format value
     * @param basisFormat format chosen from GetSupportedTranscodeFormat
     * @param engine
     * @returns internal format corresponding to the Basis format
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const GetInternalFormatFromBasisFormat = (basisFormat, engine) => {
        let format;
        switch (basisFormat) {
            case BASIS_FORMATS.cTFETC1:
                format = 36196;
                break;
            case BASIS_FORMATS.cTFBC1:
                format = 33776;
                break;
            case BASIS_FORMATS.cTFBC4:
                format = 33779;
                break;
            case BASIS_FORMATS.cTFASTC_4x4:
                format = 37808;
                break;
            case BASIS_FORMATS.cTFETC2:
                format = 37496;
                break;
            case BASIS_FORMATS.cTFBC7:
                format = 36492;
                break;
        }
        if (format === undefined) {
            throw "The chosen Basis transcoder format is not currently supported";
        }
        return format;
    };
    let _WorkerPromise = null;
    let _Worker = null;
    let _actionId = 0;
    const _IgnoreSupportedFormats = false;
    const _CreateWorkerAsync = () => {
        if (!_WorkerPromise) {
            _WorkerPromise = new Promise((res, reject) => {
                if (_Worker) {
                    res(_Worker);
                }
                else {
                    Tools.LoadFileAsync(BasisToolsOptions.WasmModuleURL)
                        .then((wasmBinary) => {
                        if (typeof URL !== "function") {
                            return reject("Basis transcoder requires an environment with a URL constructor");
                        }
                        const workerBlobUrl = URL.createObjectURL(new Blob([`(${workerFunc$1})()`], { type: "application/javascript" }));
                        _Worker = new Worker(workerBlobUrl);
                        const initHandler = (msg) => {
                            if (msg.data.action === "init") {
                                _Worker.removeEventListener("message", initHandler);
                                res(_Worker);
                            }
                            else if (msg.data.action === "error") {
                                reject(msg.data.error || "error initializing worker");
                            }
                        };
                        _Worker.addEventListener("message", initHandler);
                        _Worker.postMessage({ action: "init", url: BasisToolsOptions.JSModuleURL, wasmBinary: wasmBinary });
                    })
                        .catch(reject);
                }
            });
        }
        return _WorkerPromise;
    };
    /**
     * Transcodes a loaded image file to compressed pixel data
     * @param data image data to transcode
     * @param config configuration options for the transcoding
     * @returns a promise resulting in the transcoded image
     */
    const TranscodeAsync = (data, config) => {
        const dataView = data instanceof ArrayBuffer ? new Uint8Array(data) : data;
        return new Promise((res, rej) => {
            _CreateWorkerAsync().then(() => {
                const actionId = _actionId++;
                const messageHandler = (msg) => {
                    if (msg.data.action === "transcode" && msg.data.id === actionId) {
                        _Worker.removeEventListener("message", messageHandler);
                        if (!msg.data.success) {
                            rej("Transcode is not supported on this device");
                        }
                        else {
                            res(msg.data);
                        }
                    }
                };
                _Worker.addEventListener("message", messageHandler);
                const dataViewCopy = new Uint8Array(dataView.byteLength);
                dataViewCopy.set(new Uint8Array(dataView.buffer, dataView.byteOffset, dataView.byteLength));
                _Worker.postMessage({ action: "transcode", id: actionId, imageData: dataViewCopy, config: config, ignoreSupportedFormats: _IgnoreSupportedFormats }, [
                    dataViewCopy.buffer,
                ]);
            }, (error) => {
                rej(error);
            });
        });
    };
    /**
     * Binds a texture according to its underlying target.
     * @param texture texture to bind
     * @param engine the engine to bind the texture in
     */
    const BindTexture = (texture, engine) => {
        var _a, _b;
        let target = (_a = engine._gl) === null || _a === void 0 ? void 0 : _a.TEXTURE_2D;
        if (texture.isCube) {
            target = (_b = engine._gl) === null || _b === void 0 ? void 0 : _b.TEXTURE_CUBE_MAP;
        }
        engine._bindTextureDirectly(target, texture, true);
    };
    /**
     * Loads a texture from the transcode result
     * @param texture texture load to
     * @param transcodeResult the result of transcoding the basis file to load from
     */
    const LoadTextureFromTranscodeResult = (texture, transcodeResult) => {
        const engine = texture.getEngine();
        for (let i = 0; i < transcodeResult.fileInfo.images.length; i++) {
            const rootImage = transcodeResult.fileInfo.images[i].levels[0];
            texture._invertVScale = texture.invertY;
            if (transcodeResult.format === -1 || transcodeResult.format === BASIS_FORMATS.cTFRGB565) {
                // No compatable compressed format found, fallback to RGB
                texture.type = 10;
                texture.format = 4;
                if (engine._features.basisNeedsPOT && (Scalar.Log2(rootImage.width) % 1 !== 0 || Scalar.Log2(rootImage.height) % 1 !== 0)) {
                    // Create non power of two texture
                    const source = new InternalTexture(engine, InternalTextureSource.Temp);
                    texture._invertVScale = texture.invertY;
                    source.type = 10;
                    source.format = 4;
                    // Fallback requires aligned width/height
                    source.width = (rootImage.width + 3) & ~3;
                    source.height = (rootImage.height + 3) & ~3;
                    BindTexture(source, engine);
                    engine._uploadDataToTextureDirectly(source, new Uint16Array(rootImage.transcodedPixels.buffer), i, 0, 4, true);
                    // Resize to power of two
                    engine._rescaleTexture(source, texture, engine.scenes[0], engine._getInternalFormat(4), () => {
                        engine._releaseTexture(source);
                        BindTexture(texture, engine);
                    });
                }
                else {
                    // Fallback is already inverted
                    texture._invertVScale = !texture.invertY;
                    // Upload directly
                    texture.width = (rootImage.width + 3) & ~3;
                    texture.height = (rootImage.height + 3) & ~3;
                    texture.samplingMode = 2;
                    BindTexture(texture, engine);
                    engine._uploadDataToTextureDirectly(texture, new Uint16Array(rootImage.transcodedPixels.buffer), i, 0, 4, true);
                }
            }
            else {
                texture.width = rootImage.width;
                texture.height = rootImage.height;
                texture.generateMipMaps = transcodeResult.fileInfo.images[i].levels.length > 1;
                const format = BasisTools.GetInternalFormatFromBasisFormat(transcodeResult.format, engine);
                texture.format = format;
                BindTexture(texture, engine);
                // Upload all mip levels in the file
                transcodeResult.fileInfo.images[i].levels.forEach((level, index) => {
                    engine._uploadCompressedDataToTextureDirectly(texture, format, level.width, level.height, level.transcodedPixels, i, index);
                });
                if (engine._features.basisNeedsPOT && (Scalar.Log2(texture.width) % 1 !== 0 || Scalar.Log2(texture.height) % 1 !== 0)) {
                    Tools.Warn("Loaded .basis texture width and height are not a power of two. Texture wrapping will be set to Texture.CLAMP_ADDRESSMODE as other modes are not supported with non power of two dimensions in webGL 1.");
                    texture._cachedWrapU = Texture.CLAMP_ADDRESSMODE;
                    texture._cachedWrapV = Texture.CLAMP_ADDRESSMODE;
                }
            }
        }
    };
    /**
     * Used to load .Basis files
     * See https://github.com/BinomialLLC/basis_universal/tree/master/webgl
     */
    const BasisTools = {
        /**
         * URL to use when loading the basis transcoder
         */
        JSModuleURL: BasisToolsOptions.JSModuleURL,
        /**
         * URL to use when loading the wasm module for the transcoder
         */
        WasmModuleURL: BasisToolsOptions.WasmModuleURL,
        /**
         * Get the internal format to be passed to texImage2D corresponding to the .basis format value
         * @param basisFormat format chosen from GetSupportedTranscodeFormat
         * @returns internal format corresponding to the Basis format
         */
        GetInternalFormatFromBasisFormat,
        /**
         * Transcodes a loaded image file to compressed pixel data
         * @param data image data to transcode
         * @param config configuration options for the transcoding
         * @returns a promise resulting in the transcoded image
         */
        TranscodeAsync,
        /**
         * Loads a texture from the transcode result
         * @param texture texture load to
         * @param transcodeResult the result of transcoding the basis file to load from
         */
        LoadTextureFromTranscodeResult,
    };
    function workerFunc$1() {
        const _BASIS_FORMAT = {
            cTFETC1: 0,
            cTFETC2: 1,
            cTFBC1: 2,
            cTFBC3: 3,
            cTFBC4: 4,
            cTFBC5: 5,
            cTFBC7: 6,
            cTFPVRTC1_4_RGB: 8,
            cTFPVRTC1_4_RGBA: 9,
            cTFASTC_4x4: 10,
            cTFATC_RGB: 11,
            cTFATC_RGBA_INTERPOLATED_ALPHA: 12,
            cTFRGBA32: 13,
            cTFRGB565: 14,
            cTFBGR565: 15,
            cTFRGBA4444: 16,
            cTFFXT1_RGB: 17,
            cTFPVRTC2_4_RGB: 18,
            cTFPVRTC2_4_RGBA: 19,
            cTFETC2_EAC_R11: 20,
            cTFETC2_EAC_RG11: 21,
        };
        let transcoderModulePromise = null;
        onmessage = (event) => {
            if (event.data.action === "init") {
                // Load the transcoder if it hasn't been yet
                if (!transcoderModulePromise) {
                    // make sure we loaded the script correctly
                    try {
                        importScripts(event.data.url);
                    }
                    catch (e) {
                        postMessage({ action: "error", error: e });
                    }
                    transcoderModulePromise = BASIS({
                        // Override wasm binary
                        wasmBinary: event.data.wasmBinary,
                    });
                }
                if (transcoderModulePromise !== null) {
                    transcoderModulePromise.then((m) => {
                        BASIS = m;
                        m.initializeBasis();
                        postMessage({ action: "init" });
                    });
                }
            }
            else if (event.data.action === "transcode") {
                // Transcode the basis image and return the resulting pixels
                const config = event.data.config;
                const imgData = event.data.imageData;
                const loadedFile = new BASIS.BasisFile(imgData);
                const fileInfo = GetFileInfo(loadedFile);
                let format = event.data.ignoreSupportedFormats ? null : GetSupportedTranscodeFormat(event.data.config, fileInfo);
                let needsConversion = false;
                if (format === null) {
                    needsConversion = true;
                    format = fileInfo.hasAlpha ? _BASIS_FORMAT.cTFBC3 : _BASIS_FORMAT.cTFBC1;
                }
                // Begin transcode
                let success = true;
                if (!loadedFile.startTranscoding()) {
                    success = false;
                }
                const buffers = [];
                for (let imageIndex = 0; imageIndex < fileInfo.images.length; imageIndex++) {
                    if (!success) {
                        break;
                    }
                    const image = fileInfo.images[imageIndex];
                    if (config.loadSingleImage === undefined || config.loadSingleImage === imageIndex) {
                        let mipCount = image.levels.length;
                        if (config.loadMipmapLevels === false) {
                            mipCount = 1;
                        }
                        for (let levelIndex = 0; levelIndex < mipCount; levelIndex++) {
                            const levelInfo = image.levels[levelIndex];
                            const pixels = TranscodeLevel(loadedFile, imageIndex, levelIndex, format, needsConversion);
                            if (!pixels) {
                                success = false;
                                break;
                            }
                            levelInfo.transcodedPixels = pixels;
                            buffers.push(levelInfo.transcodedPixels.buffer);
                        }
                    }
                }
                // Close file
                loadedFile.close();
                loadedFile.delete();
                if (needsConversion) {
                    format = -1;
                }
                if (!success) {
                    postMessage({ action: "transcode", success: success, id: event.data.id });
                }
                else {
                    postMessage({ action: "transcode", success: success, id: event.data.id, fileInfo: fileInfo, format: format }, buffers);
                }
            }
        };
        /**
         * Detects the supported transcode format for the file
         * @param config transcode config
         * @param fileInfo info about the file
         * @returns the chosed format or null if none are supported
         */
        function GetSupportedTranscodeFormat(config, fileInfo) {
            let format = null;
            if (config.supportedCompressionFormats) {
                if (config.supportedCompressionFormats.astc) {
                    format = _BASIS_FORMAT.cTFASTC_4x4;
                }
                else if (config.supportedCompressionFormats.bc7) {
                    format = _BASIS_FORMAT.cTFBC7;
                }
                else if (config.supportedCompressionFormats.s3tc) {
                    format = fileInfo.hasAlpha ? _BASIS_FORMAT.cTFBC3 : _BASIS_FORMAT.cTFBC1;
                }
                else if (config.supportedCompressionFormats.pvrtc) {
                    format = fileInfo.hasAlpha ? _BASIS_FORMAT.cTFPVRTC1_4_RGBA : _BASIS_FORMAT.cTFPVRTC1_4_RGB;
                }
                else if (config.supportedCompressionFormats.etc2) {
                    format = _BASIS_FORMAT.cTFETC2;
                }
                else if (config.supportedCompressionFormats.etc1) {
                    format = _BASIS_FORMAT.cTFETC1;
                }
                else {
                    format = _BASIS_FORMAT.cTFRGB565;
                }
            }
            return format;
        }
        /**
         * Retrieves information about the basis file eg. dimensions
         * @param basisFile the basis file to get the info from
         * @returns information about the basis file
         */
        function GetFileInfo(basisFile) {
            const hasAlpha = basisFile.getHasAlpha();
            const imageCount = basisFile.getNumImages();
            const images = [];
            for (let i = 0; i < imageCount; i++) {
                const imageInfo = {
                    levels: [],
                };
                const levelCount = basisFile.getNumLevels(i);
                for (let level = 0; level < levelCount; level++) {
                    const levelInfo = {
                        width: basisFile.getImageWidth(i, level),
                        height: basisFile.getImageHeight(i, level),
                    };
                    imageInfo.levels.push(levelInfo);
                }
                images.push(imageInfo);
            }
            const info = { hasAlpha, images };
            return info;
        }
        function TranscodeLevel(loadedFile, imageIndex, levelIndex, format, convertToRgb565) {
            const dstSize = loadedFile.getImageTranscodedSizeInBytes(imageIndex, levelIndex, format);
            let dst = new Uint8Array(dstSize);
            if (!loadedFile.transcodeImage(dst, imageIndex, levelIndex, format, 1, 0)) {
                return null;
            }
            // If no supported format is found, load as dxt and convert to rgb565
            if (convertToRgb565) {
                const alignedWidth = (loadedFile.getImageWidth(imageIndex, levelIndex) + 3) & ~3;
                const alignedHeight = (loadedFile.getImageHeight(imageIndex, levelIndex) + 3) & ~3;
                dst = ConvertDxtToRgb565(dst, 0, alignedWidth, alignedHeight);
            }
            return dst;
        }
        /**
         * From https://github.com/BinomialLLC/basis_universal/blob/master/webgl/texture/dxt-to-rgb565.js
         * An unoptimized version of dxtToRgb565.  Also, the floating
         * point math used to compute the colors actually results in
         * slightly different colors compared to hardware DXT decoders.
         * @param src dxt src pixels
         * @param srcByteOffset offset for the start of src
         * @param  width aligned width of the image
         * @param  height aligned height of the image
         * @returns the converted pixels
         */
        function ConvertDxtToRgb565(src, srcByteOffset, width, height) {
            const c = new Uint16Array(4);
            const dst = new Uint16Array(width * height);
            const blockWidth = width / 4;
            const blockHeight = height / 4;
            for (let blockY = 0; blockY < blockHeight; blockY++) {
                for (let blockX = 0; blockX < blockWidth; blockX++) {
                    const i = srcByteOffset + 8 * (blockY * blockWidth + blockX);
                    c[0] = src[i] | (src[i + 1] << 8);
                    c[1] = src[i + 2] | (src[i + 3] << 8);
                    c[2] =
                        ((2 * (c[0] & 0x1f) + 1 * (c[1] & 0x1f)) / 3) |
                            (((2 * (c[0] & 0x7e0) + 1 * (c[1] & 0x7e0)) / 3) & 0x7e0) |
                            (((2 * (c[0] & 0xf800) + 1 * (c[1] & 0xf800)) / 3) & 0xf800);
                    c[3] =
                        ((2 * (c[1] & 0x1f) + 1 * (c[0] & 0x1f)) / 3) |
                            (((2 * (c[1] & 0x7e0) + 1 * (c[0] & 0x7e0)) / 3) & 0x7e0) |
                            (((2 * (c[1] & 0xf800) + 1 * (c[0] & 0xf800)) / 3) & 0xf800);
                    for (let row = 0; row < 4; row++) {
                        const m = src[i + 4 + row];
                        let dstI = (blockY * 4 + row) * width + blockX * 4;
                        dst[dstI++] = c[m & 0x3];
                        dst[dstI++] = c[(m >> 2) & 0x3];
                        dst[dstI++] = c[(m >> 4) & 0x3];
                        dst[dstI++] = c[(m >> 6) & 0x3];
                    }
                }
            }
            return dst;
        }
    }
    Object.defineProperty(BasisTools, "JSModuleURL", {
        get: function () {
            return BasisToolsOptions.JSModuleURL;
        },
        set: function (value) {
            BasisToolsOptions.JSModuleURL = value;
        },
    });
    Object.defineProperty(BasisTools, "WasmModuleURL", {
        get: function () {
            return BasisToolsOptions.WasmModuleURL;
        },
        set: function (value) {
            BasisToolsOptions.WasmModuleURL = value;
        },
    });

    /**
     * Loader for .basis file format
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    class _BasisTextureLoader {
        constructor() {
            /**
             * Defines whether the loader supports cascade loading the different faces.
             */
            this.supportCascades = false;
        }
        /**
         * This returns if the loader support the current file information.
         * @param extension defines the file extension of the file being loaded
         * @returns true if the loader can load the specified file
         */
        canLoad(extension) {
            return extension.endsWith(".basis");
        }
        /**
         * Uploads the cube texture data to the WebGL texture. It has already been bound.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param createPolynomials will be true if polynomials have been requested
         * @param onLoad defines the callback to trigger once the texture is ready
         * @param onError defines the callback to trigger in case of error
         */
        loadCubeData(data, texture, createPolynomials, onLoad, onError) {
            if (Array.isArray(data)) {
                return;
            }
            const caps = texture.getEngine().getCaps();
            const transcodeConfig = {
                supportedCompressionFormats: {
                    etc1: caps.etc1 ? true : false,
                    s3tc: caps.s3tc ? true : false,
                    pvrtc: caps.pvrtc ? true : false,
                    etc2: caps.etc2 ? true : false,
                    astc: caps.astc ? true : false,
                    bc7: caps.bptc ? true : false,
                },
            };
            TranscodeAsync(data, transcodeConfig)
                .then((result) => {
                const hasMipmap = result.fileInfo.images[0].levels.length > 1 && texture.generateMipMaps;
                LoadTextureFromTranscodeResult(texture, result);
                texture.getEngine()._setCubeMapTextureParams(texture, hasMipmap);
                texture.isReady = true;
                texture.onLoadedObservable.notifyObservers(texture);
                texture.onLoadedObservable.clear();
                if (onLoad) {
                    onLoad();
                }
            })
                .catch((err) => {
                const errorMessage = "Failed to transcode Basis file, transcoding may not be supported on this device";
                Tools.Warn(errorMessage);
                texture.isReady = true;
                if (onError) {
                    onError(err);
                }
            });
        }
        /**
         * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
         * @param data contains the texture data
         * @param texture defines the BabylonJS internal texture
         * @param callback defines the method to call once ready to upload
         */
        loadData(data, texture, callback) {
            const caps = texture.getEngine().getCaps();
            const transcodeConfig = {
                supportedCompressionFormats: {
                    etc1: caps.etc1 ? true : false,
                    s3tc: caps.s3tc ? true : false,
                    pvrtc: caps.pvrtc ? true : false,
                    etc2: caps.etc2 ? true : false,
                    astc: caps.astc ? true : false,
                    bc7: caps.bptc ? true : false,
                },
            };
            TranscodeAsync(data, transcodeConfig)
                .then((result) => {
                const rootImage = result.fileInfo.images[0].levels[0];
                const hasMipmap = result.fileInfo.images[0].levels.length > 1 && texture.generateMipMaps;
                callback(rootImage.width, rootImage.height, hasMipmap, result.format !== -1, () => {
                    LoadTextureFromTranscodeResult(texture, result);
                });
            })
                .catch((err) => {
                Tools.Warn("Failed to transcode Basis file, transcoding may not be supported on this device");
                Tools.Warn(`Failed to transcode Basis file: ${err}`);
                callback(0, 0, false, false, () => { }, true);
            });
        }
    }
    // Register the loader.
    Engine._TextureLoaders.push(new _BasisTextureLoader());

    // Do not edit.
    const name$2s = "noisePixelShader";
    const shader$2s = `uniform float brightness;uniform float persistence;uniform float timeScale;varying vec2 vUV;vec2 hash22(vec2 p)
{p=p*mat2(127.1,311.7,269.5,183.3);p=-1.0+2.0*fract(sin(p)*43758.5453123);return sin(p*6.283+timeScale);}
float interpolationNoise(vec2 p)
{vec2 pi=floor(p);vec2 pf=p-pi;vec2 w=pf*pf*(3.-2.*pf);float f00=dot(hash22(pi+vec2(.0,.0)),pf-vec2(.0,.0));float f01=dot(hash22(pi+vec2(.0,1.)),pf-vec2(.0,1.));float f10=dot(hash22(pi+vec2(1.0,0.)),pf-vec2(1.0,0.));float f11=dot(hash22(pi+vec2(1.0,1.)),pf-vec2(1.0,1.));float xm1=mix(f00,f10,w.x);float xm2=mix(f01,f11,w.x);float ym=mix(xm1,xm2,w.y); 
return ym;}
float perlinNoise2D(float x,float y)
{float sum=0.0;float frequency=0.0;float amplitude=0.0;for(int i=0; i<OCTAVES; i++)
{frequency=pow(2.0,float(i));amplitude=pow(persistence,float(i));sum=sum+interpolationNoise(vec2(x*frequency,y*frequency))*amplitude;}
return sum;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float x=abs(vUV.x);float y=abs(vUV.y);float noise=brightness+(1.0-brightness)*perlinNoise2D(x,y);gl_FragColor=vec4(noise,noise,noise,1.0);}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2s] = shader$2s;

    /**
     * Class used to generate noise procedural textures
     */
    class NoiseProceduralTexture extends ProceduralTexture {
        /**
         * Creates a new NoiseProceduralTexture
         * @param name defines the name fo the texture
         * @param size defines the size of the texture (default is 256)
         * @param scene defines the hosting scene
         * @param fallbackTexture defines the texture to use if the NoiseProceduralTexture can't be created
         * @param generateMipMaps defines if mipmaps must be generated (true by default)
         */
        constructor(name, size = 256, scene = EngineStore.LastCreatedScene, fallbackTexture, generateMipMaps) {
            super(name, size, "noise", scene, fallbackTexture, generateMipMaps);
            /** Gets or sets the start time (default is 0) */
            this.time = 0.0;
            /** Gets or sets a value between 0 and 1 indicating the overall brightness of the texture (default is 0.2) */
            this.brightness = 0.2;
            /** Defines the number of octaves to process */
            this.octaves = 3;
            /** Defines the level of persistence (0.8 by default) */
            this.persistence = 0.8;
            /** Gets or sets animation speed factor (default is 1) */
            this.animationSpeedFactor = 1;
            this.autoClear = false;
            this._updateShaderUniforms();
        }
        _updateShaderUniforms() {
            const scene = this.getScene();
            if (!scene) {
                return;
            }
            this.time += scene.getAnimationRatio() * this.animationSpeedFactor * 0.01;
            this.setFloat("brightness", this.brightness);
            this.setFloat("persistence", this.persistence);
            this.setFloat("timeScale", this.time);
        }
        _getDefines() {
            return "#define OCTAVES " + (this.octaves | 0);
        }
        /**
         * Generate the current state of the procedural texture
         * @param useCameraPostProcess
         */
        render(useCameraPostProcess) {
            this._updateShaderUniforms();
            super.render(useCameraPostProcess);
        }
        /**
         * Serializes this noise procedural texture
         * @returns a serialized noise procedural texture object
         */
        serialize() {
            const serializationObject = {};
            serializationObject.customType = "BABYLON.NoiseProceduralTexture";
            serializationObject.brightness = this.brightness;
            serializationObject.octaves = this.octaves;
            serializationObject.persistence = this.persistence;
            serializationObject.animationSpeedFactor = this.animationSpeedFactor;
            serializationObject.size = this.getSize().width;
            serializationObject.generateMipMaps = this._generateMipMaps;
            serializationObject.time = this.time;
            return serializationObject;
        }
        /**
         * Clone the texture.
         * @returns the cloned texture
         */
        clone() {
            const textureSize = this.getSize();
            const newTexture = new NoiseProceduralTexture(this.name, textureSize.width, this.getScene(), this._fallbackTexture ? this._fallbackTexture : undefined, this._generateMipMaps);
            // Base texture
            newTexture.hasAlpha = this.hasAlpha;
            newTexture.level = this.level;
            // RenderTarget Texture
            newTexture.coordinatesMode = this.coordinatesMode;
            // Noise Specifics
            newTexture.brightness = this.brightness;
            newTexture.octaves = this.octaves;
            newTexture.persistence = this.persistence;
            newTexture.animationSpeedFactor = this.animationSpeedFactor;
            newTexture.time = this.time;
            return newTexture;
        }
        /**
         * Creates a NoiseProceduralTexture from parsed noise procedural texture data
         * @param parsedTexture defines parsed texture data
         * @param scene defines the current scene
         * @returns a parsed NoiseProceduralTexture
         */
        static Parse(parsedTexture, scene) {
            var _a;
            const texture = new NoiseProceduralTexture(parsedTexture.name, parsedTexture.size, scene, undefined, parsedTexture.generateMipMaps);
            texture.brightness = parsedTexture.brightness;
            texture.octaves = parsedTexture.octaves;
            texture.persistence = parsedTexture.persistence;
            texture.animationSpeedFactor = parsedTexture.animationSpeedFactor;
            texture.time = (_a = parsedTexture.time) !== null && _a !== void 0 ? _a : 0;
            return texture;
        }
    }
    RegisterClass("BABYLON.NoiseProceduralTexture", NoiseProceduralTexture);

    /**
     * Creates a refraction texture used by refraction channel of the standard material.
     * It is like a mirror but to see through a material.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#refractiontexture
     */
    class RefractionTexture extends RenderTargetTexture {
        /**
         * Creates a refraction texture used by refraction channel of the standard material.
         * It is like a mirror but to see through a material.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#refraction
         * @param name Define the texture name
         * @param size Define the size of the underlying texture
         * @param scene Define the scene the refraction belongs to
         * @param generateMipMaps Define if we need to generate mips level for the refraction
         */
        constructor(name, size, scene, generateMipMaps) {
            super(name, size, scene, generateMipMaps, true);
            /**
             * Define the reflection plane we want to use. The refractionPlane is usually set to the constructed refractor.
             * It is possible to directly set the refractionPlane by directly using a Plane(a, b, c, d) where a, b and c give the plane normal vector (a, b, c) and d is a scalar displacement from the refractionPlane to the origin. However in all but the very simplest of situations it is more straight forward to set it to the refractor as stated in the doc.
             * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#refraction
             */
            this.refractionPlane = new Plane(0, 1, 0, 1);
            /**
             * Define how deep under the surface we should see.
             */
            this.depth = 2.0;
            this.onBeforeRenderObservable.add(() => {
                this.getScene().clipPlane = this.refractionPlane;
            });
            this.onAfterRenderObservable.add(() => {
                this.getScene().clipPlane = null;
            });
        }
        /**
         * Clone the refraction texture.
         * @returns the cloned texture
         */
        clone() {
            const scene = this.getScene();
            if (!scene) {
                return this;
            }
            const textureSize = this.getSize();
            const newTexture = new RefractionTexture(this.name, textureSize.width, scene, this._generateMipMaps);
            // Base texture
            newTexture.hasAlpha = this.hasAlpha;
            newTexture.level = this.level;
            // Refraction Texture
            newTexture.refractionPlane = this.refractionPlane.clone();
            if (this.renderList) {
                newTexture.renderList = this.renderList.slice(0);
            }
            newTexture.depth = this.depth;
            return newTexture;
        }
        /**
         * Serialize the texture to a JSON representation you could use in Parse later on
         * @returns the serialized JSON representation
         */
        serialize() {
            if (!this.name) {
                return null;
            }
            const serializationObject = super.serialize();
            serializationObject.mirrorPlane = this.refractionPlane.asArray();
            serializationObject.depth = this.depth;
            return serializationObject;
        }
    }

    // DEFLATE is a complex format; to read this code, you should probably check the RFC first:
    // https://tools.ietf.org/html/rfc1951
    // You may also wish to take a look at the guide I made about this program:
    // https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
    // Some of the following code is similar to that of UZIP.js:
    // https://github.com/photopea/UZIP.js
    // However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
    // Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
    // is better for memory in most engines (I *think*).
    var ch2 = {};
    var wk = (function (c, id, msg, transfer, cb) {
        var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
            c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
        ], { type: 'text/javascript' }))));
        w.onmessage = function (e) {
            var d = e.data, ed = d.$e$;
            if (ed) {
                var err = new Error(ed[0]);
                err['code'] = ed[1];
                err.stack = ed[2];
                cb(err, null);
            }
            else
                cb(null, d);
        };
        w.postMessage(msg, transfer);
        return w;
    });

    // aliases for shorter compressed code (most minifers don't do this)
    var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
    // fixed length extra bits
    var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
    // fixed distance extra bits
    // see fleb note
    var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
    // code length index map
    var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
    // get base, reverse index map from extra bits
    var freb = function (eb, start) {
        var b = new u16(31);
        for (var i = 0; i < 31; ++i) {
            b[i] = start += 1 << eb[i - 1];
        }
        // numbers here are at max 18 bits
        var r = new u32(b[30]);
        for (var i = 1; i < 30; ++i) {
            for (var j = b[i]; j < b[i + 1]; ++j) {
                r[j] = ((j - b[i]) << 5) | i;
            }
        }
        return [b, r];
    };
    var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
    // we can ignore the fact that the other numbers are wrong; they never happen anyway
    fl[28] = 258, revfl[258] = 28;
    var _b = freb(fdeb, 0), revfd = _b[1];
    // map of value to reverse (assuming 16 bits)
    var rev = new u16(32768);
    for (var i = 0; i < 32768; ++i) {
        // reverse table algorithm from SO
        var x = ((i & 0xAAAA) >>> 1) | ((i & 0x5555) << 1);
        x = ((x & 0xCCCC) >>> 2) | ((x & 0x3333) << 2);
        x = ((x & 0xF0F0) >>> 4) | ((x & 0x0F0F) << 4);
        rev[i] = (((x & 0xFF00) >>> 8) | ((x & 0x00FF) << 8)) >>> 1;
    }
    // create huffman tree from u8 "map": index -> code length for code index
    // mb (max bits) must be at most 15
    // TODO: optimize/split up?
    var hMap = (function (cd, mb, r) {
        var s = cd.length;
        // index
        var i = 0;
        // u16 "map": index -> # of codes with bit length = index
        var l = new u16(mb);
        // length of cd must be 288 (total # of codes)
        for (; i < s; ++i) {
            if (cd[i])
                ++l[cd[i] - 1];
        }
        // u16 "map": index -> minimum code for bit length = index
        var le = new u16(mb);
        for (i = 0; i < mb; ++i) {
            le[i] = (le[i - 1] + l[i - 1]) << 1;
        }
        var co;
        if (r) {
            // u16 "map": index -> number of actual bits, symbol for code
            co = new u16(1 << mb);
            // bits to remove for reverser
            var rvb = 15 - mb;
            for (i = 0; i < s; ++i) {
                // ignore 0 lengths
                if (cd[i]) {
                    // num encoding both symbol and bits read
                    var sv = (i << 4) | cd[i];
                    // free bits
                    var r_1 = mb - cd[i];
                    // start value
                    var v = le[cd[i] - 1]++ << r_1;
                    // m is end value
                    for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                        // every 16 bit value starting with the code yields the same result
                        co[rev[v] >>> rvb] = sv;
                    }
                }
            }
        }
        else {
            co = new u16(s);
            for (i = 0; i < s; ++i) {
                if (cd[i]) {
                    co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
                }
            }
        }
        return co;
    });
    // fixed length tree
    var flt = new u8(288);
    for (var i = 0; i < 144; ++i)
        flt[i] = 8;
    for (var i = 144; i < 256; ++i)
        flt[i] = 9;
    for (var i = 256; i < 280; ++i)
        flt[i] = 7;
    for (var i = 280; i < 288; ++i)
        flt[i] = 8;
    // fixed distance tree
    var fdt = new u8(32);
    for (var i = 0; i < 32; ++i)
        fdt[i] = 5;
    // fixed length map
    var flm = /*#__PURE__*/ hMap(flt, 9, 0);
    // fixed distance map
    var fdm = /*#__PURE__*/ hMap(fdt, 5, 0);
    // get end of byte
    var shft = function (p) { return ((p + 7) / 8) | 0; };
    // typed array slice - allows garbage collector to free original reference,
    // while being more compatible than .slice
    var slc = function (v, s, e) {
        if (s == null || s < 0)
            s = 0;
        if (e == null || e > v.length)
            e = v.length;
        // can't use .constructor in case user-supplied
        var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
        n.set(v.subarray(s, e));
        return n;
    };
    // error codes
    var ec = [
        'unexpected EOF',
        'invalid block type',
        'invalid length/literal',
        'invalid distance',
        'stream finished',
        'no stream handler',
        ,
        'no callback',
        'invalid UTF-8 data',
        'extra field too long',
        'date not in range 1980-2099',
        'filename too long',
        'stream finishing',
        'invalid zip data'
        // determined by unknown compression method
    ];
    var err = function (ind, msg, nt) {
        var e = new Error(msg || ec[ind]);
        e.code = ind;
        if (Error.captureStackTrace)
            Error.captureStackTrace(e, err);
        if (!nt)
            throw e;
        return e;
    };
    // starting at p, write the minimum number of bits that can hold v to d
    var wbits = function (d, p, v) {
        v <<= p & 7;
        var o = (p / 8) | 0;
        d[o] |= v;
        d[o + 1] |= v >>> 8;
    };
    // starting at p, write the minimum number of bits (>8) that can hold v to d
    var wbits16 = function (d, p, v) {
        v <<= p & 7;
        var o = (p / 8) | 0;
        d[o] |= v;
        d[o + 1] |= v >>> 8;
        d[o + 2] |= v >>> 16;
    };
    // creates code lengths from a frequency table
    var hTree = function (d, mb) {
        // Need extra info to make a tree
        var t = [];
        for (var i = 0; i < d.length; ++i) {
            if (d[i])
                t.push({ s: i, f: d[i] });
        }
        var s = t.length;
        var t2 = t.slice();
        if (!s)
            return [et, 0];
        if (s == 1) {
            var v = new u8(t[0].s + 1);
            v[t[0].s] = 1;
            return [v, 1];
        }
        t.sort(function (a, b) { return a.f - b.f; });
        // after i2 reaches last ind, will be stopped
        // freq must be greater than largest possible number of symbols
        t.push({ s: -1, f: 25001 });
        var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
        t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
        // efficient algorithm from UZIP.js
        // i0 is lookbehind, i2 is lookahead - after processing two low-freq
        // symbols that combined have high freq, will start processing i2 (high-freq,
        // non-composite) symbols instead
        // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
        while (i1 != s - 1) {
            l = t[t[i0].f < t[i2].f ? i0++ : i2++];
            r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
            t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
        }
        var maxSym = t2[0].s;
        for (var i = 1; i < s; ++i) {
            if (t2[i].s > maxSym)
                maxSym = t2[i].s;
        }
        // code lengths
        var tr = new u16(maxSym + 1);
        // max bits in tree
        var mbt = ln(t[i1 - 1], tr, 0);
        if (mbt > mb) {
            // more algorithms from UZIP.js
            // TODO: find out how this code works (debt)
            //  ind    debt
            var i = 0, dt = 0;
            //    left            cost
            var lft = mbt - mb, cst = 1 << lft;
            t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
            for (; i < s; ++i) {
                var i2_1 = t2[i].s;
                if (tr[i2_1] > mb) {
                    dt += cst - (1 << (mbt - tr[i2_1]));
                    tr[i2_1] = mb;
                }
                else
                    break;
            }
            dt >>>= lft;
            while (dt > 0) {
                var i2_2 = t2[i].s;
                if (tr[i2_2] < mb)
                    dt -= 1 << (mb - tr[i2_2]++ - 1);
                else
                    ++i;
            }
            for (; i >= 0 && dt; --i) {
                var i2_3 = t2[i].s;
                if (tr[i2_3] == mb) {
                    --tr[i2_3];
                    ++dt;
                }
            }
            mbt = mb;
        }
        return [new u8(tr), mbt];
    };
    // get the max length and assign length codes
    var ln = function (n, l, d) {
        return n.s == -1
            ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
            : (l[n.s] = d);
    };
    // length codes generation
    var lc = function (c) {
        var s = c.length;
        // Note that the semicolon was intentional
        while (s && !c[--s])
            ;
        var cl = new u16(++s);
        //  ind      num         streak
        var cli = 0, cln = c[0], cls = 1;
        var w = function (v) { cl[cli++] = v; };
        for (var i = 1; i <= s; ++i) {
            if (c[i] == cln && i != s)
                ++cls;
            else {
                if (!cln && cls > 2) {
                    for (; cls > 138; cls -= 138)
                        w(32754);
                    if (cls > 2) {
                        w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                        cls = 0;
                    }
                }
                else if (cls > 3) {
                    w(cln), --cls;
                    for (; cls > 6; cls -= 6)
                        w(8304);
                    if (cls > 2)
                        w(((cls - 3) << 5) | 8208), cls = 0;
                }
                while (cls--)
                    w(cln);
                cls = 1;
                cln = c[i];
            }
        }
        return [cl.subarray(0, cli), s];
    };
    // calculate the length of output from tree, code lengths
    var clen = function (cf, cl) {
        var l = 0;
        for (var i = 0; i < cl.length; ++i)
            l += cf[i] * cl[i];
        return l;
    };
    // writes a fixed block
    // returns the new bit pos
    var wfblk = function (out, pos, dat) {
        // no need to write 00 as type: TypedArray defaults to 0
        var s = dat.length;
        var o = shft(pos + 2);
        out[o] = s & 255;
        out[o + 1] = s >>> 8;
        out[o + 2] = out[o] ^ 255;
        out[o + 3] = out[o + 1] ^ 255;
        for (var i = 0; i < s; ++i)
            out[o + i + 4] = dat[i];
        return (o + 4 + s) * 8;
    };
    // writes a block
    var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
        wbits(out, p++, final);
        ++lf[256];
        var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
        var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
        var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
        var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
        var lcfreq = new u16(19);
        for (var i = 0; i < lclt.length; ++i)
            lcfreq[lclt[i] & 31]++;
        for (var i = 0; i < lcdt.length; ++i)
            lcfreq[lcdt[i] & 31]++;
        var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
        var nlcc = 19;
        for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
            ;
        var flen = (bl + 5) << 3;
        var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
        var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
        if (flen <= ftlen && flen <= dtlen)
            return wfblk(out, p, dat.subarray(bs, bs + bl));
        var lm, ll, dm, dl;
        wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
        if (dtlen < ftlen) {
            lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
            var llm = hMap(lct, mlcb, 0);
            wbits(out, p, nlc - 257);
            wbits(out, p + 5, ndc - 1);
            wbits(out, p + 10, nlcc - 4);
            p += 14;
            for (var i = 0; i < nlcc; ++i)
                wbits(out, p + 3 * i, lct[clim[i]]);
            p += 3 * nlcc;
            var lcts = [lclt, lcdt];
            for (var it = 0; it < 2; ++it) {
                var clct = lcts[it];
                for (var i = 0; i < clct.length; ++i) {
                    var len = clct[i] & 31;
                    wbits(out, p, llm[len]), p += lct[len];
                    if (len > 15)
                        wbits(out, p, (clct[i] >>> 5) & 127), p += clct[i] >>> 12;
                }
            }
        }
        else {
            lm = flm, ll = flt, dm = fdm, dl = fdt;
        }
        for (var i = 0; i < li; ++i) {
            if (syms[i] > 255) {
                var len = (syms[i] >>> 18) & 31;
                wbits16(out, p, lm[len + 257]), p += ll[len + 257];
                if (len > 7)
                    wbits(out, p, (syms[i] >>> 23) & 31), p += fleb[len];
                var dst = syms[i] & 31;
                wbits16(out, p, dm[dst]), p += dl[dst];
                if (dst > 3)
                    wbits16(out, p, (syms[i] >>> 5) & 8191), p += fdeb[dst];
            }
            else {
                wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
            }
        }
        wbits16(out, p, lm[256]);
        return p + ll[256];
    };
    // deflate options (nice << 13) | chain
    var deo = /*#__PURE__*/ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
    // empty
    var et = /*#__PURE__*/ new u8(0);
    // compresses data into a raw DEFLATE buffer
    var dflt = function (dat, lvl, plvl, pre, post, lst) {
        var s = dat.length;
        var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
        // writing to this writes to the output buffer
        var w = o.subarray(pre, o.length - post);
        var pos = 0;
        if (!lvl || s < 8) {
            for (var i = 0; i <= s; i += 65535) {
                // end
                var e = i + 65535;
                if (e >= s) {
                    // write final block
                    w[pos >> 3] = lst;
                }
                pos = wfblk(w, pos + 1, dat.subarray(i, e));
            }
        }
        else {
            var opt = deo[lvl - 1];
            var n = opt >>> 13, c = opt & 8191;
            var msk_1 = (1 << plvl) - 1;
            //    prev 2-byte val map    curr 2-byte val map
            var prev = new u16(32768), head = new u16(msk_1 + 1);
            var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
            var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
            // 24576 is an arbitrary number of maximum symbols per block
            // 424 buffer for last block
            var syms = new u32(25000);
            // length/literal freq   distance freq
            var lf = new u16(288), df = new u16(32);
            //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
            var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
            for (; i < s; ++i) {
                // hash value
                // deopt when i > s - 3 - at end, deopt acceptable
                var hv = hsh(i);
                // index mod 32768    previous index mod
                var imod = i & 32767, pimod = head[hv];
                prev[imod] = pimod;
                head[hv] = imod;
                // We always should modify head and prev, but only add symbols if
                // this data is not yet processed ("wait" for wait index)
                if (wi <= i) {
                    // bytes remaining
                    var rem = s - i;
                    if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                        pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                        li = lc_1 = eb = 0, bs = i;
                        for (var j = 0; j < 286; ++j)
                            lf[j] = 0;
                        for (var j = 0; j < 30; ++j)
                            df[j] = 0;
                    }
                    //  len    dist   chain
                    var l = 2, d = 0, ch_1 = c, dif = (imod - pimod) & 32767;
                    if (rem > 2 && hv == hsh(i - dif)) {
                        var maxn = Math.min(n, rem) - 1;
                        var maxd = Math.min(32767, i);
                        // max possible length
                        // not capped at dif because decompressors implement "rolling" index population
                        var ml = Math.min(258, rem);
                        while (dif <= maxd && --ch_1 && imod != pimod) {
                            if (dat[i + l] == dat[i + l - dif]) {
                                var nl = 0;
                                for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                    ;
                                if (nl > l) {
                                    l = nl, d = dif;
                                    // break out early when we reach "nice" (we are satisfied enough)
                                    if (nl > maxn)
                                        break;
                                    // now, find the rarest 2-byte sequence within this
                                    // length of literals and search for that instead.
                                    // Much faster than just using the start
                                    var mmd = Math.min(dif, nl - 2);
                                    var md = 0;
                                    for (var j = 0; j < mmd; ++j) {
                                        var ti = (i - dif + j + 32768) & 32767;
                                        var pti = prev[ti];
                                        var cd = (ti - pti + 32768) & 32767;
                                        if (cd > md)
                                            md = cd, pimod = ti;
                                    }
                                }
                            }
                            // check the previous match
                            imod = pimod, pimod = prev[imod];
                            dif += (imod - pimod + 32768) & 32767;
                        }
                    }
                    // d will be nonzero only when a match was found
                    if (d) {
                        // store both dist and len data in one Uint32
                        // Make sure this is recognized as a len/dist with 28th bit (2^28)
                        syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                        var lin = revfl[l] & 31, din = revfd[d] & 31;
                        eb += fleb[lin] + fdeb[din];
                        ++lf[257 + lin];
                        ++df[din];
                        wi = i + l;
                        ++lc_1;
                    }
                    else {
                        syms[li++] = dat[i];
                        ++lf[dat[i]];
                    }
                }
            }
            pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
            // this is the easiest way to avoid needing to maintain state
            if (!lst && pos & 7)
                pos = wfblk(w, pos + 1, et);
        }
        return slc(o, 0, pre + shft(pos) + post);
    };
    // CRC32 table
    var crct = /*#__PURE__*/ (function () {
        var t = new Int32Array(256);
        for (var i = 0; i < 256; ++i) {
            var c = i, k = 9;
            while (--k)
                c = ((c & 1) && -306674912) ^ (c >>> 1);
            t[i] = c;
        }
        return t;
    })();
    // CRC32
    var crc = function () {
        var c = -1;
        return {
            p: function (d) {
                // closures have awful performance
                var cr = c;
                for (var i = 0; i < d.length; ++i)
                    cr = crct[(cr & 255) ^ d[i]] ^ (cr >>> 8);
                c = cr;
            },
            d: function () { return ~c; }
        };
    };
    // deflate with opts
    var dopt = function (dat, opt, pre, post, st) {
        return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : (12 + opt.mem), pre, post, !st);
    };
    // Walmart object spread
    var mrg = function (a, b) {
        var o = {};
        for (var k in a)
            o[k] = a[k];
        for (var k in b)
            o[k] = b[k];
        return o;
    };
    // worker clone
    // This is possibly the craziest part of the entire codebase, despite how simple it may seem.
    // The only parameter to this function is a closure that returns an array of variables outside of the function scope.
    // We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
    // We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
    // The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
    // This took me three weeks to figure out how to do.
    var wcln = function (fn, fnStr, td) {
        var dt = fn();
        var st = fn.toString();
        var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
        for (var i = 0; i < dt.length; ++i) {
            var v = dt[i], k = ks[i];
            if (typeof v == 'function') {
                fnStr += ';' + k + '=';
                var st_1 = v.toString();
                if (v.prototype) {
                    // for global objects
                    if (st_1.indexOf('[native code]') != -1) {
                        var spInd = st_1.indexOf(' ', 8) + 1;
                        fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                    }
                    else {
                        fnStr += st_1;
                        for (var t in v.prototype)
                            fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                    }
                }
                else
                    fnStr += st_1;
            }
            else
                td[k] = v;
        }
        return [fnStr, td];
    };
    var ch = [];
    // clone bufs
    var cbfs = function (v) {
        var tl = [];
        for (var k in v) {
            if (v[k] instanceof u8 || v[k] instanceof u16 || v[k] instanceof u32)
                tl.push((v[k] = new v[k].constructor(v[k])).buffer);
        }
        return tl;
    };
    // use a worker to execute code
    var wrkr = function (fns, init, id, cb) {
        var _a;
        if (!ch[id]) {
            var fnStr = '', td_1 = {}, m = fns.length - 1;
            for (var i = 0; i < m; ++i)
                _a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
            ch[id] = wcln(fns[m], fnStr, td_1);
        }
        var td = mrg({}, ch[id][1]);
        return wk(ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
    };
    var bDflt = function () { return [u8, u16, u32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf]; };
    // post buf
    var pbf = function (msg) { return postMessage(msg, [msg.buffer]); };
    // async helper
    var cbify = function (dat, opts, fns, init, id, cb) {
        var w = wrkr(fns, init, id, function (err, dat) {
            w.terminate();
            cb(err, dat);
        });
        w.postMessage([dat, opts], opts.consume ? [dat.buffer] : []);
        return function () { w.terminate(); };
    };
    // write bytes
    var wbytes = function (d, b, v) {
        for (; v; ++b)
            d[b] = v, v >>>= 8;
    };
    function deflate(data, opts, cb) {
        if (!cb)
            cb = opts, opts = {};
        if (typeof cb != 'function')
            err(7);
        return cbify(data, opts, [
            bDflt,
        ], function (ev) { return pbf(deflateSync(ev.data[0], ev.data[1])); }, 0, cb);
    }
    /**
     * Compresses data with DEFLATE without any wrapper
     * @param data The data to compress
     * @param opts The compression options
     * @returns The deflated version of the data
     */
    function deflateSync(data, opts) {
        return dopt(data, opts || {}, 0, 0);
    }
    // flatten a directory structure
    var fltn = function (d, p, t, o) {
        for (var k in d) {
            var val = d[k], n = p + k;
            if (val instanceof u8)
                t[n] = [val, o];
            else if (Array.isArray(val))
                t[n] = [val[0], mrg(o, val[1])];
            else
                fltn(val, n + '/', t, o);
        }
    };
    // text encoder
    var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
    // text decoder
    var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
    // text decoder stream
    var tds = 0;
    try {
        td.decode(et, { stream: true });
        tds = 1;
    }
    catch (e) { }
    /**
     * Converts a string into a Uint8Array for use with compression/decompression methods
     * @param str The string to encode
     * @param latin1 Whether or not to interpret the data as Latin-1. This should
     *               not need to be true unless decoding a binary string.
     * @returns The string encoded in UTF-8/Latin-1 binary
     */
    function strToU8(str, latin1) {
        if (latin1) {
            var ar_1 = new u8(str.length);
            for (var i = 0; i < str.length; ++i)
                ar_1[i] = str.charCodeAt(i);
            return ar_1;
        }
        if (te)
            return te.encode(str);
        var l = str.length;
        var ar = new u8(str.length + (str.length >> 1));
        var ai = 0;
        var w = function (v) { ar[ai++] = v; };
        for (var i = 0; i < l; ++i) {
            if (ai + 5 > ar.length) {
                var n = new u8(ai + 8 + ((l - i) << 1));
                n.set(ar);
                ar = n;
            }
            var c = str.charCodeAt(i);
            if (c < 128 || latin1)
                w(c);
            else if (c < 2048)
                w(192 | (c >> 6)), w(128 | (c & 63));
            else if (c > 55295 && c < 57344)
                c = 65536 + (c & 1023 << 10) | (str.charCodeAt(++i) & 1023),
                    w(240 | (c >> 18)), w(128 | ((c >> 12) & 63)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
            else
                w(224 | (c >> 12)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
        }
        return slc(ar, 0, ai);
    }
    // extra field length
    var exfl = function (ex) {
        var le = 0;
        if (ex) {
            for (var k in ex) {
                var l = ex[k].length;
                if (l > 65535)
                    err(9);
                le += l + 4;
            }
        }
        return le;
    };
    // write zip header
    var wzh = function (d, b, f, fn, u, c, ce, co) {
        var fl = fn.length, ex = f.extra, col = co && co.length;
        var exl = exfl(ex);
        wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
        if (ce != null)
            d[b++] = 20, d[b++] = f.os;
        d[b] = 20, b += 2; // spec compliance? what's that?
        d[b++] = (f.flag << 1) | (c == null && 8), d[b++] = u && 8;
        d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
        var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
        if (y < 0 || y > 119)
            err(10);
        wbytes(d, b, (y << 25) | ((dt.getMonth() + 1) << 21) | (dt.getDate() << 16) | (dt.getHours() << 11) | (dt.getMinutes() << 5) | (dt.getSeconds() >>> 1)), b += 4;
        if (c != null) {
            wbytes(d, b, f.crc);
            wbytes(d, b + 4, c);
            wbytes(d, b + 8, f.size);
        }
        wbytes(d, b + 12, fl);
        wbytes(d, b + 14, exl), b += 16;
        if (ce != null) {
            wbytes(d, b, col);
            wbytes(d, b + 6, f.attrs);
            wbytes(d, b + 10, ce), b += 14;
        }
        d.set(fn, b);
        b += fl;
        if (exl) {
            for (var k in ex) {
                var exf = ex[k], l = exf.length;
                wbytes(d, b, +k);
                wbytes(d, b + 2, l);
                d.set(exf, b + 4), b += 4 + l;
            }
        }
        if (col)
            d.set(co, b), b += col;
        return b;
    };
    // write zip footer (end of central directory)
    var wzf = function (o, b, c, d, e) {
        wbytes(o, b, 0x6054B50); // skip disk
        wbytes(o, b + 8, c);
        wbytes(o, b + 10, c);
        wbytes(o, b + 12, d);
        wbytes(o, b + 16, e);
    };
    function zip(data, opts, cb) {
        if (!cb)
            cb = opts, opts = {};
        if (typeof cb != 'function')
            err(7);
        var r = {};
        fltn(data, '', r, opts);
        var k = Object.keys(r);
        var lft = k.length, o = 0, tot = 0;
        var slft = lft, files = new Array(lft);
        var term = [];
        var tAll = function () {
            for (var i = 0; i < term.length; ++i)
                term[i]();
        };
        var cbd = function (a, b) {
            mt(function () { cb(a, b); });
        };
        mt(function () { cbd = cb; });
        var cbf = function () {
            var out = new u8(tot + 22), oe = o, cdl = tot - o;
            tot = 0;
            for (var i = 0; i < slft; ++i) {
                var f = files[i];
                try {
                    var l = f.c.length;
                    wzh(out, tot, f, f.f, f.u, l);
                    var badd = 30 + f.f.length + exfl(f.extra);
                    var loc = tot + badd;
                    out.set(f.c, loc);
                    wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
                }
                catch (e) {
                    return cbd(e, null);
                }
            }
            wzf(out, o, files.length, cdl, oe);
            cbd(null, out);
        };
        if (!lft)
            cbf();
        var _loop_1 = function (i) {
            var fn = k[i];
            var _a = r[fn], file = _a[0], p = _a[1];
            var c = crc(), size = file.length;
            c.p(file);
            var f = strToU8(fn), s = f.length;
            var com = p.comment, m = com && strToU8(com), ms = m && m.length;
            var exl = exfl(p.extra);
            var compression = p.level == 0 ? 0 : 8;
            var cbl = function (e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                }
                else {
                    var l = d.length;
                    files[i] = mrg(p, {
                        size: size,
                        crc: c.d(),
                        c: d,
                        f: f,
                        m: m,
                        u: s != fn.length || (m && (com.length != ms)),
                        compression: compression
                    });
                    o += 30 + s + exl + l;
                    tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                    if (!--lft)
                        cbf();
                }
            };
            if (s > 65535)
                cbl(err(11, 0, 1), null);
            if (!compression)
                cbl(null, file);
            else if (size < 160000) {
                try {
                    cbl(null, deflateSync(file, p));
                }
                catch (e) {
                    cbl(e, null);
                }
            }
            else
                term.push(deflate(file, p, cbl));
        };
        // Cannot use lft because it can decrease
        for (var i = 0; i < slft; ++i) {
            _loop_1(i);
        }
        return tAll;
    }
    var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function (fn) { fn(); };

    class USDZConverter {
        parse(scene, sceneNode, useWorker = false) {
            return Promise.reject();
        }
        convertGeometry(payload) {
            const meshObject = this.buildGeometryFromBuffers(payload);
            return buildUSDAFile(payload.options, meshObject);
        }
        zipUSDZFiles(files) {
            return new Promise((resolve, reject) => {
                zip(files, {
                    level: 0,
                }, (err, res) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        const blob = new Blob([res.buffer], { type: 'model/vnd.usdz+zip' });
                        resolve(blob);
                    }
                });
            });
        }
        buildGeometryFromBuffers(payload) {
            const positions = payload.vertexBuffers[VertexBuffer.PositionKind];
            if (!positions) {
                throw 'No indices in geometry';
            }
            const vertexCount = Math.floor(positions.length / 3);
            return buildGeometryFromData(payload.indices, vertexCount, positions, payload.vertexBuffers[VertexBuffer.NormalKind], payload.vertexBuffers[VertexBuffer.UVKind]);
        }
        buildGeometryFromObject(geometry) {
            const indices = geometry.getIndices();
            const vertexCount = geometry.getTotalVertices();
            const positions = geometry.getVerticesData(VertexBuffer.PositionKind);
            if (!indices) {
                throw 'No indices in geometry';
            }
            if (!positions) {
                throw 'No indices in geometry';
            }
            return buildGeometryFromData(indices, vertexCount, positions, geometry.getVerticesData(VertexBuffer.NormalKind), geometry.getVerticesData(VertexBuffer.UVKind));
        }
    }
    const PRECISION = 7;
    function buildHeader(opts) {
        return `#usda 1.0
(
    customLayerData = {
        string creator = "KB3D USDZConverter"
    }
    metersPerUnit = ${1 / opts.unitsPerMeter}
    upAxis = "Y"
)
`;
    }
    function buildUSDAFile(opts, dataToInsert) {
        let output = buildHeader(opts);
        output += dataToInsert;
        return strToU8(output);
    }
    // Xform
    function buildXform(object, geometry, material, appendFileName = '') {
        const name = 'Object__' + escapeGUID(object.id) + appendFileName;
        const worldMatrix = object.computeWorldMatrix(true);
        const transform = buildMatrix(worldMatrix);
        if (worldMatrix.determinant() < 0) {
            console.warn('USDZConverter: USDZ does not support negative scales', object);
        }
        return `def Xform "${name}" (
    prepend references = @./geometries/Geometry__${escapeGUID(geometry.id)}${appendFileName}.usd@</Geometry>
)
{
    matrix4d xformOp:transform = ${transform}
    uniform token[] xformOpOrder = ["xformOp:transform"]
    rel material:binding = </Materials/Material__${escapeGUID(material.id)}>
}
`;
    }
    function buildMatrix(matrix) {
        const array = matrix.toArray();
        return `( ${buildMatrixRow(array, 0)}, ${buildMatrixRow(array, 4)}, ${buildMatrixRow(array, 8)}, ${buildMatrixRow(array, 12)} )`;
    }
    function buildMatrixRow(array, offset) {
        return `(${array[offset + 0]}, ${array[offset + 1]}, ${array[offset + 2]}, ${array[offset + 3]})`;
    } // Mesh
    function buildGeometryFromData(indices, verticesCount, positions, normals, uvs) {
        const vertexCounts = Array(Math.floor(indices.length / 3))
            .fill(3)
            .join(', ');
        const name = 'Geometry';
        return `
def "Geometry"
{
    def Mesh "${name}"
    {
        int[] faceVertexCounts = [${vertexCounts}]
        int[] faceVertexIndices = [${stringifyIntArray(indices)}]
        normal3f[] normals = [${buildVector3Array(normals, verticesCount)}] (
            interpolation = "vertex"
        )
        point3f[] points = [${buildVector3Array(positions, verticesCount)}]
        float2[] primvars:st = [${buildVector2Array(uvs, verticesCount)}] (
            interpolation = "vertex"
        )
        uniform token subdivisionScheme = "none"
        uniform token orientation = "leftHanded"
    }
}
`;
    }
    function buildVector3Array(data, count) {
        let res = '';
        if (!data) {
            console.warn('USDZConverter: Data missing.');
            for (let i = 0; i < count; i++) {
                res += '(0, 0, 0), ';
            }
            return res;
        }
        return stringifyFloatArray(data, count, 3);
    }
    function buildVector2Array(data, count) {
        let res = '';
        if (!data) {
            console.warn('USDZConverter: Data missing.');
            for (let i = 0; i < count; i++) {
                res += '(0, 0), ';
            }
            return res;
        }
        return stringifyFloatArray(data, count, 2);
    }
    function stringifyIntArray(data) {
        const count = data.length;
        let res = '';
        for (let i = 0; i < count; i++) {
            res += `${data[i]}, `;
        }
        return res.slice(0, -2);
    }
    function stringifyFloatArray(data, count, perStruc) {
        let res = '';
        if (perStruc === 2) {
            for (let i = 0; i < count; i++) {
                res += `(${data[i * 2].toPrecision(PRECISION)}, ${data[i * 2 + 1].toPrecision(PRECISION)}), `;
            }
        }
        else if (perStruc === 3) {
            for (let i = 0; i < count; i++) {
                res += `(${data[i * 3].toPrecision(PRECISION)}, ${data[i * 3 + 1].toPrecision(PRECISION)}, ${data[i * 3 + 2].toPrecision(PRECISION)}), `;
            }
        }
        else {
            throw Error('Not supported');
        }
        return res.slice(0, -2);
    }
    function escapeGUID(guid) {
        return guid.replace(/[-\s]+/g, '_');
    }

    const canvasResize = document.createElement('canvas');
    class USDZBabylonConverter extends USDZConverter {
        parse(scene, sceneNode, useWorker = false) {
            const toCleanup = [];
            const files = {};
            const modelFileName = 'model.usda'; // model file should be first in USDZ archive so we init it here
            files[modelFileName] = new Uint8Array(0);
            let output = buildHeader(sceneNode);
            const materials = {};
            const textures = {};
            const conversionWorker = useWorker ? new Kb3dWorker() : null;
            const asyncGenerators = [];
            scene.meshes.forEach(mesh => {
                if (mesh instanceof Mesh &&
                    mesh.isEnabled() &&
                    mesh.visibility > 0 &&
                    mesh.geometry &&
                    !(mesh instanceof LinesMesh) &&
                    // for filtering out skyboxes
                    !mesh.infiniteDistance) {
                    let subMeshes;
                    let geometries;
                    let meshMaterials;
                    const baseGeometry = mesh.geometry;
                    if (mesh.subMeshes && mesh.subMeshes.length > 1) {
                        const splitGeometryByMaterialId = new Map();
                        const baseVertexData = VertexData.ExtractFromGeometry(baseGeometry);
                        mesh.subMeshes.forEach((subMesh, index) => {
                            const subMeshMaterial = subMesh.getMaterial();
                            if (subMeshMaterial) {
                                let vertexData = splitGeometryByMaterialId.get(subMeshMaterial);
                                if (!vertexData) {
                                    vertexData = { indices: [], positions: [], normals: [], uvs: [] };
                                    splitGeometryByMaterialId.set(subMeshMaterial, vertexData);
                                }
                                // Add polygons from this submesh to the mesh for this material
                                let newIdx = vertexData.indices.length;
                                const endIndex = subMesh.indexStart + subMesh.indexCount;
                                for (let i = subMesh.indexStart; i < endIndex; i++) {
                                    if (baseVertexData.indices && baseVertexData.indices[i] !== undefined) {
                                        const oldIdx = baseVertexData.indices[i];
                                        vertexData.indices.push(newIdx);
                                        const i2 = oldIdx * 2;
                                        const i3 = oldIdx * 3;
                                        if (baseVertexData.positions &&
                                            typeof baseVertexData.positions[i3] !== 'undefined') {
                                            vertexData.positions.push(baseVertexData.positions[i3], baseVertexData.positions[i3 + 1], baseVertexData.positions[i3 + 2]);
                                        }
                                        if (baseVertexData.normals && typeof baseVertexData.normals[i3] !== 'undefined') {
                                            vertexData.normals.push(baseVertexData.normals[i3], baseVertexData.normals[i3 + 1], baseVertexData.normals[i3 + 2]);
                                        }
                                        if (baseVertexData.uvs && typeof baseVertexData.uvs[i2] !== 'undefined') {
                                            vertexData.uvs.push(baseVertexData.uvs[i2], baseVertexData.uvs[i2 + 1]);
                                        }
                                        newIdx++;
                                    }
                                }
                            }
                            return null;
                        });
                        subMeshes = [];
                        geometries = [];
                        meshMaterials = [];
                        splitGeometryByMaterialId.forEach((vertexData, material) => {
                            if (material instanceof PBRMaterial) {
                                const newMesh = mesh.clone();
                                newMesh.id = mesh.id + '__' + material.id;
                                newMesh.material = material;
                                const newVertexData = new VertexData();
                                newVertexData.indices = vertexData.indices;
                                newVertexData.positions = vertexData.positions;
                                newVertexData.normals = vertexData.normals;
                                newVertexData.uvs = vertexData.uvs;
                                const newGeometry = Geometry.CreateGeometryForMesh(newMesh);
                                newGeometry.id = `sub-${newMesh.id}`;
                                newVertexData.applyToGeometry(newGeometry);
                                subMeshes.push(newMesh);
                                geometries.push(newGeometry);
                                meshMaterials.push(material);
                                toCleanup.push(newGeometry, newMesh);
                            }
                            else {
                                console.warn(`USDZExporter: No PBR material on submesh`);
                            }
                        });
                    }
                    else {
                        subMeshes = [mesh];
                        geometries = [baseGeometry];
                        if (mesh.material instanceof PBRMaterial) {
                            meshMaterials = [mesh.material];
                        }
                        else {
                            meshMaterials = [];
                            console.warn('USDZExporter: No PBR material on mesh');
                        }
                    }
                    for (let i = 0; i < geometries.length; i++) {
                        const subMesh = subMeshes[i];
                        const geometry = geometries[i];
                        const meshMaterial = meshMaterials[i];
                        if (!subMesh || !geometry || !meshMaterial) {
                            continue;
                        }
                        // const appendFileName = `__${i}`;
                        const geometryFileName = 'geometries/Geometry__' + escapeGUID(geometry.id) + '.usd';
                        if (!(geometryFileName in files)) {
                            if (conversionWorker) {
                                const geometryData = buildGeometryTransferrable({ unitsPerMeter: sceneNode.unitsPerMeter, xrAllowScaling: sceneNode.xrAllowScaling }, geometry);
                                if (geometryData) {
                                    asyncGenerators.push(conversionWorker
                                        .startTask(exports.eWorkerTasks.usdConvertGeometry, geometryData.payload, geometryData.transfer)
                                        .pipe(take(1), map(res => {
                                        files[geometryFileName] = res.payload.file;
                                    }))
                                        .toPromise());
                                }
                            }
                            else {
                                const meshObject = this.buildGeometryFromObject(geometry);
                                files[geometryFileName] = buildUSDAFile(sceneNode, meshObject);
                            }
                        }
                        if (!(meshMaterial.id in meshMaterial)) {
                            materials[meshMaterial.id] = meshMaterial;
                        }
                        output += buildXform(subMesh, geometry, meshMaterial);
                    }
                }
            });
            output += buildMaterials(materials, textures);
            files[modelFileName] = strToU8(output);
            const textureGenerators = [];
            for (const id in textures) {
                const texture = textures[id];
                const color = id.match(/[0-9A-F]{6}$/);
                const color3 = color && color.length === 1 ? Color3.FromHexString(`#${color[0]}`) : undefined;
                const isRGBA = texture.hasAlpha;
                textureGenerators.push(() => processImageData(texture, isRGBA ? 'image/png' : 'image/jpeg', color3)
                    .then(blob => {
                    if (blob) {
                        return blob.arrayBuffer();
                    }
                })
                    .then(buffer => {
                    if (buffer) {
                        files[`textures/Texture__${id}.${isRGBA ? 'png' : 'jpg'}`] = new Uint8Array(buffer);
                    }
                }));
            } // 64 byte alignment
            // https://github.com/101arrowz/fflate/issues/39#issuecomment-777263109
            return Promise.all([processSequentially(asyncGenerators), processSequentially(textureGenerators)])
                .then(() => {
                let offset = 0;
                for (const filename in files) {
                    const file = files[filename];
                    const headerSize = 34 + filename.length;
                    offset += headerSize;
                    const offsetMod64 = offset & 63;
                    if (offsetMod64 !== 4) {
                        const padLength = 64 - offsetMod64;
                        const padding = new Uint8Array(padLength);
                        files[filename] = [
                            file,
                            {
                                extra: {
                                    12345: padding,
                                },
                            },
                        ];
                    }
                    offset = file.length;
                }
                if (conversionWorker) {
                    const transfer = [];
                    for (const fileName in files) {
                        const file = files[fileName];
                        if (file instanceof Uint8Array) {
                            transfer.push(file.buffer);
                        }
                        else {
                            transfer.push(file[0].buffer);
                        }
                    }
                    return conversionWorker
                        .startTask(exports.eWorkerTasks.usdPackage, files, transfer)
                        .pipe(take(1), map(res => {
                        canvasResize.width = 0;
                        canvasResize.height = 0;
                        conversionWorker.dispose();
                        return res.payload;
                    }))
                        .toPromise();
                }
                else {
                    return this.zipUSDZFiles(files);
                }
            })
                .then(res => {
                toCleanup.forEach(item => item.dispose());
                return res;
            });
        }
    }
    async function processSequentially(cbs) {
        const result = [];
        for (const cb of cbs) {
            if (cb instanceof Promise) {
                result.push(await cb);
            }
            else {
                result.push(await cb());
            }
        }
        return result;
    }
    function processImageData(texture, mimeType, color) {
        if (texture instanceof DynamicTexture) {
            const context = texture.getContext();
            const targetTexureSize = getBinClampedSize(context.canvas.width, context.canvas.height);
            canvasResize.width = targetTexureSize;
            canvasResize.height = targetTexureSize;
            const resizeContext = canvasResize.getContext('2d');
            const canvas = context.canvas;
            if (!(canvas instanceof HTMLCanvasElement)) {
                throw Error('texture does not have a canvas');
            }
            resizeContext.drawImage(canvas, 0, 0, targetTexureSize, targetTexureSize);
            if (color) {
                const imagedata = resizeContext.getImageData(0, 0, targetTexureSize, targetTexureSize);
                const data = imagedata.data;
                for (let i = 0; i < data.length; i += 4) {
                    data[i + 0] = data[i + 0] * color.r;
                    data[i + 1] = data[i + 1] * color.g;
                    data[i + 2] = data[i + 2] * color.b;
                }
                resizeContext.putImageData(imagedata, 0, 0);
            }
            return canvasToBlob(canvasResize, mimeType);
        }
        else {
            const size = texture.getSize();
            const dataPromise = texture.readPixels();
            if (!dataPromise) {
                return Promise.resolve(undefined);
            }
            return dataPromise.then(data => {
                if (data instanceof Float32Array || data instanceof Float64Array) {
                    for (let i = 0; i < data.length; i += 4) {
                        data[i + 0] = data[i + 0] * 255;
                        data[i + 1] = data[i + 1] * 255;
                        data[i + 2] = data[i + 2] * 255;
                        data[i + 3] = data[i + 3] * 255;
                    }
                }
                let targetTexureSize = getBinClampedSize(size.width, size.height);
                if (targetTexureSize > 1024) {
                    targetTexureSize = 1024;
                }
                canvasResize.width = targetTexureSize;
                canvasResize.height = targetTexureSize;
                const pxLength = targetTexureSize * targetTexureSize;
                const resizedData = new Uint8ClampedArray(pxLength * 4);
                if (targetTexureSize !== size.width || targetTexureSize !== size.height) {
                    const widthRatio = size.width / targetTexureSize;
                    const heightRatio = size.height / targetTexureSize;
                    // in the interest of speed, just downscale with nearest neighbor algorithm instead of averaging pixels.
                    for (let i = 0; i < pxLength; i++) {
                        const x = i % targetTexureSize;
                        // Y must be flipped for USDZ output
                        const y = Math.floor(targetTexureSize - i / targetTexureSize);
                        const targetIndex = (Math.floor(x * widthRatio) + Math.floor(y * heightRatio) * size.width) * 4;
                        const destIndex = i * 4;
                        resizedData[destIndex + 0] = data[targetIndex + 0];
                        resizedData[destIndex + 1] = data[targetIndex + 1];
                        resizedData[destIndex + 2] = data[targetIndex + 2];
                        resizedData[destIndex + 3] = data[targetIndex + 3];
                    }
                }
                else {
                    const lastLineOffset = (targetTexureSize - 1) * targetTexureSize;
                    for (let y = 0; y < targetTexureSize / 2; y++) {
                        const yOffset = y * targetTexureSize;
                        const yOffsetTarget = lastLineOffset - yOffset;
                        for (let x = 0; x < targetTexureSize; x++) {
                            const offset = (yOffset + x) * 4;
                            const offsetTarget = (yOffsetTarget + x) * 4;
                            resizedData[offset] = data[offsetTarget];
                            resizedData[offset + 1] = data[offsetTarget + 1];
                            resizedData[offset + 2] = data[offsetTarget + 2];
                            resizedData[offset + 3] = data[offsetTarget + 3];
                            resizedData[offsetTarget] = data[offset];
                            resizedData[offsetTarget + 1] = data[offset + 1];
                            resizedData[offsetTarget + 2] = data[offset + 2];
                            resizedData[offsetTarget + 3] = data[offset + 3];
                        }
                    }
                }
                if (color) {
                    for (let i = 0; i < resizedData.length; i += 4) {
                        resizedData[i + 0] = resizedData[i + 0] * color.r;
                        resizedData[i + 1] = resizedData[i + 1] * color.g;
                        resizedData[i + 2] = resizedData[i + 2] * color.b;
                    }
                }
                const imageData = new ImageData(resizedData, targetTexureSize, targetTexureSize);
                const resizeContext = canvasResize.getContext('2d');
                resizeContext.putImageData(imageData, 0, 0);
                return canvasToBlob(canvasResize, mimeType);
            });
        }
    }
    function canvasToBlob(canvasResize, mimeType) {
        return new Promise((resolve, reject) => {
            canvasResize.toBlob(result => {
                if (result) {
                    resolve(result);
                }
                reject('Could not generate texture');
            }, mimeType, 1);
        });
    }
    function buildMaterials(materials, textures) {
        const array = [];
        for (const uuid in materials) {
            const material = materials[uuid];
            array.push(buildMaterial(material, textures));
        }
        return `def "Materials"
{
${array.join('')}
}
`;
    }
    function buildMaterial(material, textures) {
        // https://graphics.pixar.com/usd/docs/UsdPreviewSurface-Proposal.html
        const pad = '            ';
        const inputs = [];
        const samplers = [];
        const materialId = escapeGUID(material.id);
        const newV = new Vector3();
        const tMatrix = new Matrix();
        const t2Matrix = new Matrix();
        const t3Matrix = new Matrix();
        function buildTexture(texture, mapType, color) {
            if (texture instanceof Texture) {
                const textureName = escapeGUID(texture.name);
                const parsedTextureId = textureName + (color ? '__' + color.toHexString().substring(1) : '');
                textures[parsedTextureId] = texture;
                const angleDeg = (texture.wAng * 180) / Math.PI;
                // USD doesn't seem to have a good way to apply a matrix to a texture. But we can use the rotation and scale straight,
                // and grab the translation off of the babylon texture matrix. The matrix includes the rotation pivot related translation
                // which is nasty to calculate without a matrix and USD doesn't support UV Pivot
                const textureMatrix = texture.getTextureMatrix().m;
                Matrix.RotationYawPitchRollToRef(texture.vAng, texture.uAng, texture.wAng, tMatrix);
                Matrix.ScalingToRef(texture.uScale, texture.vScale, 1, t2Matrix);
                tMatrix.multiplyToRef(t2Matrix, t3Matrix);
                t3Matrix.invert();
                Vector3.TransformCoordinatesFromFloatsToRef(textureMatrix[8], textureMatrix[9], 0, t3Matrix, newV);
                return `
        def Shader "Transform2d_${mapType}" (
            sdrMetadata = {
                string role = "math"
            }
        )
        {
            uniform token info:id = "UsdTransform2d"
            float2 inputs:in.connect = </Materials/Material__${materialId}/uvReader_st.outputs:result>
            float2 inputs:scale = (${texture.uScale}, ${texture.vScale})
            float2 inputs:translation = (${newV.x}, ${newV.y})
            float inputs:rotation = ${angleDeg.toPrecision(PRECISION)}
            float2 outputs:result
        }
        def Shader "Texture__${textureName}_${mapType}"
        {
            uniform token info:id = "UsdUVTexture"
            asset inputs:file = @./textures/Texture__${parsedTextureId}.${texture.hasAlpha ? 'png' : 'jpg'}@
            float2 inputs:st.connect = </Materials/Material__${materialId}/Transform2d_${mapType}.outputs:result>
            token inputs:wrapS = "repeat"
            token inputs:wrapT = "repeat"
            float outputs:r
            float outputs:g
            float outputs:b
            ${texture.hasAlpha ? 'float outputs:a' : ''}
            float3 outputs:rgb
        }`;
            }
            return '';
        }
        if (material.albedoTexture) {
            inputs.push(`${pad}color3f inputs:diffuseColor.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.albedoTexture.name)}_diffuse.outputs:rgb>`);
            samplers.push(buildTexture(material.albedoTexture, 'diffuse', material.albedoColor));
        }
        else {
            inputs.push(`${pad}color3f inputs:diffuseColor = ${buildColor(material.albedoColor)}`);
        }
        if (material.emissiveTexture) {
            inputs.push(`${pad}color3f inputs:emissiveColor.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.emissiveTexture.name)}_emissive.outputs:rgb>`);
            samplers.push(buildTexture(material.emissiveTexture, 'emissive'));
        }
        else if (material.emissiveColor.toLuminance() > 0) {
            inputs.push(`${pad}color3f inputs:emissiveColor = ${buildColor(material.emissiveColor)}`);
        }
        if (material.bumpTexture) {
            inputs.push(`${pad}normal3f inputs:normal.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.bumpTexture.name)}_normal.outputs:rgb>`);
            samplers.push(buildTexture(material.bumpTexture, 'normal'));
        }
        if (material.ambientTexture !== null) {
            inputs.push(`${pad}float inputs:occlusion.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.ambientTexture.name)}_occlusion.outputs:r>`);
            samplers.push(buildTexture(material.ambientTexture, 'occlusion'));
        }
        if (material.microSurfaceTexture !== null && material.roughness === 1) {
            inputs.push(`${pad}float inputs:roughness.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.microSurfaceTexture.name)}_roughness.outputs:g>`);
            samplers.push(buildTexture(material.microSurfaceTexture, 'roughness'));
        }
        else {
            inputs.push(`${pad}float inputs:roughness = ${material.roughness}`);
        }
        if (material.metallicTexture !== null && material.metallic === 1) {
            inputs.push(`${pad}float inputs:metallic.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.metallicTexture.name)}_metallic.outputs:b>`);
            samplers.push(buildTexture(material.metallicTexture, 'metallic'));
        }
        else {
            inputs.push(`${pad}float inputs:metallic = ${material.metallic}`);
        }
        if (material.opacityTexture !== null) {
            inputs.push(`${pad}float inputs:opacity.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.opacityTexture.name)}_opacity.outputs:r>`);
            inputs.push(`${pad}float inputs:opacityThreshold = 0.0001`);
            samplers.push(buildTexture(material.opacityTexture, 'opacity'));
        }
        else if (material.albedoTexture && material.albedoTexture.hasAlpha) {
            inputs.push(`${pad}float inputs:opacity.connect = </Materials/Material__${materialId}/Texture__${escapeGUID(material.albedoTexture.name)}_diffuse.outputs:a>`);
            inputs.push(`${pad}float inputs:opacityThreshold = 0.0001`);
        }
        else {
            inputs.push(`${pad}float inputs:opacity = ${material.alpha}`);
        }
        if (material.clearCoat && material.clearCoat.isEnabled) {
            inputs.push(`${pad}float inputs:clearcoat = ${material.clearCoat.intensity}`);
            inputs.push(`${pad}float inputs:clearcoatRoughness = ${material.clearCoat.roughness}`);
            // TODO More properties?
        }
        inputs.push(`${pad}float inputs:ior = ${material.indexOfRefraction}`);
        // TODO More properties?
        return `
    def Material "Material__${materialId}"
    {
        def Shader "PreviewSurface"
        {
            uniform token info:id = "UsdPreviewSurface"
${inputs.join('\n')}
            int inputs:useSpecularWorkflow = 0
            token outputs:surface
        }
        token outputs:surface.connect = </Materials/Material__${materialId}/PreviewSurface.outputs:surface>
        token inputs:frame:stPrimvarName = "st"
        def Shader "uvReader_st"
        {
            uniform token info:id = "UsdPrimvarReader_float2"
            token inputs:varname.connect = </Materials/Material__${materialId}.inputs:frame:stPrimvarName>
            float2 inputs:fallback = (0.0, 0.0)
            float2 outputs:result
        }
${samplers.join('\n')}
    }
`;
    }
    function buildGeometryTransferrable(options, geometry) {
        const transfer = [];
        const geometryBuffers = geometry.getVertexBuffers();
        const indices = geometry.getIndices();
        if (geometryBuffers && indices) {
            const vertexBuffers = Object.keys(geometryBuffers).reduce((res, type) => {
                const data = geometryBuffers[type].getData();
                if ('buffer' in data) {
                    res[type] = data;
                    transfer.push(res[type].slice().buffer);
                }
                else if (data instanceof ArrayBuffer || 'length' in data) {
                    res[type] = new Float32Array(data);
                    transfer.push(res[type].buffer);
                }
                else {
                    console.warn('Unsupported geometry');
                }
                return res;
            }, {});
            const indexBuffer = Array.isArray(indices) ? new Uint32Array(indices) : indices;
            transfer.push(indexBuffer.slice().buffer);
            const result = {
                payload: {
                    options,
                    id: geometry.id,
                    indices: indexBuffer,
                    vertexBuffers,
                },
                transfer,
            };
            return result;
        }
    }
    function buildColor(color) {
        return `(${color.r}, ${color.g}, ${color.b})`;
    }

    class XrHitTester {
        constructor(sessionMgr) {
            this.sessionMgr = sessionMgr;
            /** temp variables for saving memory while processing hit results */
            this._tmpPos = new Vector3();
            this._tmpMat = new Matrix();
            this._tmpQuat = new Quaternion();
        }
        initialize(offsetRay) {
            const session = this.sessionMgr.session;
            //setup initial hit testing source
            if (session) {
                return session.requestHitTestSource({
                    space: this.sessionMgr.viewerReferenceSpace,
                    offsetRay: offsetRay,
                }).then(hitSource => {
                    return (this.source = hitSource);
                });
            }
        }
        getHitResult(frame) {
            if (!this.source)
                return;
            const hits = frame.getHitTestResults(this.source);
            if (!hits.length)
                return;
            const hit = hits[0]; //only concentrate on the first hit... might want to reconsider this later
            return XrHitTester.FromXRHitTestResult(hit, this.sessionMgr.referenceSpace);
            // // Check that the y-coordinate of the normal is large enough that the normal
            // // is pointing up.
            // return hitMatrix hitMatrix.elements[5] > 0.75 ?
            //     hitPosition.setFromMatrixPosition(hitMatrix) :
            //     null;
        }
        static FromXRHitTestResult(hit, refSpace) {
            const pose = hit.getPose(refSpace);
            if (pose == null)
                return;
            const xrpos = pose.transform.position;
            const xrquat = pose.transform.orientation;
            const mat = new Matrix();
            Matrix.FromFloat32ArrayToRefScaled(pose.transform.matrix, 0, 1, mat);
            return {
                position: new Vector3(xrpos.x, xrpos.y, xrpos.z),
                rotation: new Quaternion(xrquat.x, xrquat.y, xrquat.z, xrquat.w),
                matrix: mat,
                xrResult: hit,
            };
        }
        dispose() {
            if (this.source) {
                this.source.cancel();
                this.source = undefined;
            }
        }
    }

    /**
     * Manages shadow generators and their association with lights and meshes that participate
     */
    class ShadowManager {
        constructor(_bbCache) {
            this._bbCache = _bbCache;
            this.generatorMap = new Map();
            /** the meshes that are casting shadows.  The mesh renderer adds and removes them from this list as their boolean flag is changed */
            this.casters = new Set();
            /** the meshes that are receiving shadows.  The mesh renderer adds and removes them from this list as their boolean flag is changed */
            this.receivers = new Set();
            /**
             * Stores the calculated shadow projection matrix for directional lights.  This cache is invalidated when
             * the root scene bounding box has changed or meshes change their casting / receiving flags.
             *
             * By default, babylon calculates the projection matrix of the shadows on every frame.
             * To be more efficient, we cache the projection matrix until something that warrants updating it happens.
             */
            this.projectionMatrixCache = new Map();
            this._bbCache.rootBoundingBoxChanged.subscribe(bbInfo => {
                //invalidate our projection matrix cache
                this.projectionMatrixCache.clear();
            });
        }
        /**
         * Add a shadow generator for the given light.  Should only be called when the light.generatesShadows is set to true
         * @param light
         */
        add(light, shadowResolution) {
            let sg = this.get(light);
            if (!sg) {
                sg = new ShadowGenerator(ShadowManager.convertShadowResultion(shadowResolution), light);
                this.generatorMap.set(light, sg);
                this.addAllCastersToGenerator(sg);
                if (light instanceof DirectionalLight) {
                    /**
                     * Directional lights are tricky, as their light shadow fulstrum needs to be the optimal size for the shadows to look good.
                     * The built-in calculation of the projection matrix does not account for meshes that are receiving shadows.  So we override
                     * the calculation here.  It also gives us a way to cache and increase performance.
                     */
                    light.autoUpdateExtends = false;
                    light.autoCalcShadowZBounds = false;
                    light.customProjectionMatrixBuilder = (viewMatrix, renderList, matrix) => {
                        return this.customProjectionMatrixBuilder(light, viewMatrix, renderList, matrix);
                    };
                }
            }
            return sg;
        }
        /**
         * Get the shadow generator for a specific light (if it has one)
         * @param light
         */
        get(light) {
            return this.generatorMap.get(light);
        }
        /** Remove the shadow generator for the given light */
        remove(light) {
            const sg = this.get(light);
            light.customProjectionMatrixBuilder = undefined;
            if (sg) {
                this.generatorMap.delete(light);
                sg.dispose();
            }
        }
        /**
         * Adds a mesh as a shadow caster.  Should only be called by the mesh renderer when the meshNode.castShadows flag is changed to true
         */
        addCaster(mesh) {
            if (!this.casters.has(mesh)) {
                this.casters.add(mesh);
                for (const sg of this.generatorMap.values()) {
                    sg.addShadowCaster(mesh);
                }
                this.projectionMatrixCache.clear();
            }
        }
        /**
         * Removes a mesh as a shadow caster.  Should only be called by the mesh renderer when the meshNode.castShadows flag is changed to false
         */
        removeCaster(mesh) {
            if (this.casters.has(mesh)) {
                this.casters.delete(mesh);
                for (const sg of this.generatorMap.values()) {
                    sg.removeShadowCaster(mesh);
                }
                this.projectionMatrixCache.clear();
            }
        }
        /**
         * Adds/removes the mesh as a shadow caster
         * @param mesh
         * @param value
         */
        toggleCaster(mesh, value) {
            if (value) {
                this.addCaster(mesh);
            }
            else {
                this.removeCaster(mesh);
            }
        }
        addAllCastersToGenerator(sg) {
            for (const c of this.casters.values()) {
                sg.addShadowCaster(c);
            }
        }
        addReceiver(mesh) {
            if (!this.receivers.has(mesh)) {
                this.receivers.add(mesh);
                this.projectionMatrixCache.clear();
            }
        }
        removeReceiver(mesh) {
            if (this.receivers.has(mesh)) {
                this.receivers.delete(mesh);
                this.projectionMatrixCache.clear();
            }
        }
        toggleReceiver(mesh, value) {
            if (value) {
                this.addReceiver(mesh);
            }
            else {
                this.removeReceiver(mesh);
            }
        }
        dispose() {
            this.projectionMatrixCache.clear();
            for (const light of this.generatorMap.keys()) {
                this.remove(light);
            }
        }
        clearProjectMatrixCache() {
            this.projectionMatrixCache.clear();
        }
        /**
         * Directional lights are tricky, as their light shadow fulstrum needs to be the optimal size for the shadows to look good.
         * The built-in calculation of the projection matrix does not account for meshes that are receiving shadows.  So we override
         * the calculation here.  It also gives us a way to cache and increase performance.
         *
         * This is based on the built-in DirectionalLight.prototype._setDefaultAutoExtendShadowProjectionMatrix
         * but with these additions:
         * * caching of the projection matrix
         * * inclusion of shadow receivers in the box calculation so shadows are not chopped off with PCSS
         * * uses the shadowOrthoScale of the light to increase the minZ/maxZ range to avoid z-fighting on planes at one of the extents of the box
         */
        customProjectionMatrixBuilder(light, viewMatrix, renderList, matrix) {
            if (this.projectionMatrixCache.has(light)) {
                matrix.copyFrom(this.projectionMatrixCache.get(light));
            }
            else {
                const allMeshes = new Set([...this.casters, ...this.receivers]);
                const shadowOrthoScale = light.shadowOrthoScale;
                let orthoLeft = Number.MAX_VALUE;
                let orthoRight = Number.MIN_VALUE;
                let orthoTop = Number.MIN_VALUE;
                let orthoBottom = Number.MAX_VALUE;
                let shadowMinZ = Number.MAX_VALUE;
                let shadowMaxZ = Number.MIN_VALUE;
                const tempVector3 = Vector3.Zero();
                //loop through each caster/reciever to build up the fulstrum box
                for (const m of allMeshes) {
                    if (m.isEnabled(true)) {
                        const node = getByDynamicId(m.id);
                        let bbInfo;
                        if (node) {
                            bbInfo = this._bbCache.get(node);
                        }
                        if (bbInfo) {
                            const boundingBox = bbInfo.boundingInfo.boundingBox;
                            for (let index = 0; index < boundingBox.vectorsWorld.length; index++) {
                                Vector3.TransformCoordinatesToRef(boundingBox.vectorsWorld[index], viewMatrix, tempVector3);
                                if (tempVector3.x < orthoLeft) {
                                    orthoLeft = tempVector3.x;
                                }
                                if (tempVector3.y < orthoBottom) {
                                    orthoBottom = tempVector3.y;
                                }
                                if (tempVector3.x > orthoRight) {
                                    orthoRight = tempVector3.x;
                                }
                                if (tempVector3.y > orthoTop) {
                                    orthoTop = tempVector3.y;
                                }
                                if (tempVector3.z < shadowMinZ) {
                                    shadowMinZ = tempVector3.z;
                                }
                                if (tempVector3.z > shadowMaxZ) {
                                    shadowMaxZ = tempVector3.z;
                                }
                            }
                        }
                    }
                }
                const xOffset = orthoRight - orthoLeft;
                const yOffset = orthoTop - orthoBottom;
                /** for exponential blur, it works way better when the max z is alot larger than the scene to get soft shadows */
                const sg = this.get(light);
                if (sg.filter == ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP) {
                    shadowMaxZ = shadowMaxZ * 50;
                }
                const zOffset = shadowMaxZ - shadowMinZ;
                Matrix.OrthoOffCenterLHToRef(orthoLeft - xOffset * shadowOrthoScale, orthoRight + xOffset * shadowOrthoScale, orthoBottom - yOffset * shadowOrthoScale, orthoTop + yOffset * shadowOrthoScale, 
                /**
                 * Babylon does not account for the orthoScale when calculating minZ/maxZ, which leads to shadow z fighting on planes receiving shadows.
                 * So here we change this behavior to offset by the scale just like left/right/top/bottom
                 */
                shadowMinZ - zOffset * shadowOrthoScale, shadowMaxZ + zOffset * shadowOrthoScale, matrix);
                this.projectionMatrixCache.set(light, matrix);
                // console.count("shadow manager processed");
            }
        }
        static convertShadowResultion(r) {
            switch (r) {
                case exports.eShadowResolution.low:
                    return 512;
                case exports.eShadowResolution.medium:
                    return 1024;
                case exports.eShadowResolution.high:
                    return 2048;
            }
        }
        static convertShadowFilter(f) {
            switch (f) {
                case exports.eShadowFilter.none:
                    return ShadowGenerator.FILTER_NONE;
                case exports.eShadowFilter.simple:
                    return ShadowGenerator.FILTER_PCF;
                case exports.eShadowFilter.advanced:
                    return ShadowGenerator.FILTER_PCSS;
            }
        }
    }

    class XrLight extends DirectionalLight {
        constructor(v, scene) {
            super('xrLight', new Vector3(0, -3, 0), scene);
            this.v = v;
            this.scene = scene;
            this._originalLightEnabledMap = new Map();
            //turn all existing lights off and save their setting
            for (const l of scene.lights) {
                if (l !== this) {
                    this._originalLightEnabledMap.set(l, l.isEnabled(false));
                    l.setEnabled(false);
                }
            }
            this.position = this.direction.negate();
            this.intensity = 0.5;
            this._shadowManager = new ShadowManager(this.v.bbCache);
            this._sg = this._shadowManager.add(this, exports.eShadowResolution.low);
            this._sg.setDarkness(0.3);
            this._sg.filter = ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP;
            // this._sg.blurBoxOffset = 10;
            // this._sg.blurScale = 2;
            this._sg.useKernelBlur = true;
            this._sg.blurKernel = 64; //64;
            this._sg.blurScale = 2;
            /**
             * Add all meshes from the scene to the shadow caster.
             * This includes the shadow plane so that extents are auto calculated to include it
             */
            const rootNode = this.v.rendererManager.sceneRenderer.get3d(this.v.sceneNode);
            for (const m of rootNode.getChildMeshes(false)) {
                if (m.name == 'xrShadowPlane') {
                    this._shadowManager.addReceiver(m);
                }
                else {
                    this._shadowManager.addCaster(m);
                }
                // console.log(`adding mesh '${m.name}' to shadow generator`);
            }
        }
        setDirection(x, y, z) {
            this.direction.set(x, y, z);
            this.position = this.direction.negate();
            this._shadowManager.clearProjectMatrixCache();
        }
        dispose() {
            for (const [l, e] of this._originalLightEnabledMap) {
                l.setEnabled(e);
            }
            this._originalLightEnabledMap.clear();
            if (this._shadowManager)
                this._shadowManager.dispose();
            this._shadowManager = undefined;
            this._sg = undefined;
            super.dispose();
        }
    }

    const SEGMENTS = 12;
    const RADIUS = 0.05;
    const DELTA_PHI = Math.PI / (2 * SEGMENTS);
    const LINE_WIDTH = 0.02;
    const FRAME_RATE = 1 / 0.3;
    class XrMarker extends Mesh {
        constructor(v, scene, naturalScale) {
            super('xrMarker', scene);
            this.v = v;
            this.scene = scene;
            this.naturalScale = naturalScale;
            this.subscription = new Subscription();
            if (!XrMarker.MarkerMaterial) {
                const m = (XrMarker.MarkerMaterial = new StandardMaterial('xrMarkerMaterial', this.scene));
                m.emissiveColor = Color3.White();
                m.disableLighting = true;
                m.backFaceCulling = false;
                m.alpha = 0.5;
            }
            this.material = XrMarker.MarkerMaterial;
            this.resize();
        }
        place(rootNode) {
            this.setParent(rootNode);
            this.rotation.set(0, 0, 0);
            this._placed = true;
            this.resize();
            this.hide();
            this.subscription.add(this.v.bbCache.rootBoundingBoxChanged.subscribe(bb => {
                this.resizeToBoundingBox(this.v.bbCache.getWorld(this.v.sceneNode));
            }));
        }
        show() {
            this.animateVisibility(1, EasingFunction.EASINGMODE_EASEIN);
        }
        hide() {
            this.animateVisibility(0, EasingFunction.EASINGMODE_EASEOUT);
        }
        animateVisibility(to, easingFunction) {
            const a = new Animation('hide', 'visibility', FRAME_RATE, Animation.ANIMATIONTYPE_FLOAT);
            a.setKeys([
                {
                    frame: 0,
                    value: this.visibility,
                },
                {
                    frame: 1,
                    value: to,
                },
            ]);
            const easing = new SineEase();
            easing.setEasingMode(easingFunction);
            a.setEasingFunction(easing);
            this.scene.stopAnimation(this);
            this.scene.beginDirectAnimation(this, [a], 0, 1, false);
        }
        resize() {
            const bb = this.v.bbCache.get(this.v.sceneNode);
            if (bb) {
                this.resizeToBoundingBox(bb);
            }
        }
        resizeToBoundingBox(bb) {
            let deltaZ;
            let deltaX;
            if (!this._placed) {
                deltaX = (bb.max.x - bb.min.x) * this.naturalScale;
                deltaZ = (bb.max.z - bb.min.z) * this.naturalScale;
                this._lineWidth = LINE_WIDTH;
                this._radius = RADIUS;
            }
            else {
                deltaX = bb.max.x - bb.min.x;
                deltaZ = bb.max.z - bb.min.z;
                this._lineWidth = LINE_WIDTH / this.naturalScale;
                this._radius = RADIUS / this.naturalScale;
            }
            const vertexData = this.getVertexData(deltaX, deltaZ);
            vertexData.applyToMesh(this, true);
            if (this._placed) {
                //it's in the root node now, so center to the root node local bb
                this.position.set(bb.center.x, 0, bb.center.z);
            }
        }
        getVertexData(xSize, zSize) {
            const vertices = [];
            const indices = [];
            const normals = [];
            const x = xSize / 2;
            const z = zSize / 2;
            this.addCorner(vertices, x, z);
            this.addCorner(vertices, -x, z);
            this.addCorner(vertices, -x, -z);
            this.addCorner(vertices, x, -z);
            const numVertices = vertices.length / 3;
            for (let i = 0; i < numVertices - 2; i += 2) {
                indices.push(i, i + 1, i + 3, i, i + 3, i + 2);
            }
            const i = numVertices - 2;
            indices.push(i, i + 1, 1, i, 1, 0);
            VertexData.ComputeNormals(vertices, indices, normals);
            const vdata = new VertexData();
            vdata.indices = indices;
            vdata.positions = vertices;
            vdata.normals = normals;
            return vdata;
        }
        addCorner(vertices, cornerX, cornerZ) {
            let phi = cornerX > 0 ? (cornerZ > 0 ? 0 : -Math.PI / 2) : cornerZ > 0 ? Math.PI / 2 : Math.PI;
            for (let i = 0; i <= SEGMENTS; ++i) {
                vertices.push(cornerX + (this._radius - this._lineWidth) * Math.cos(phi), 0, cornerZ + (this._radius - this._lineWidth) * Math.sin(phi), cornerX + this._radius * Math.cos(phi), 0, cornerZ + this._radius * Math.sin(phi));
                phi += DELTA_PHI;
            }
        }
        dispose() {
            this.subscription.unsubscribe();
            super.dispose();
        }
    }

    // Do not edit.
    const name$2t = "imageProcessingCompatibility";
    const shader$2t = `#ifdef IMAGEPROCESSINGPOSTPROCESS
gl_FragColor.rgb=pow(gl_FragColor.rgb,vec3(2.2));
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2t] = shader$2t;

    // Do not edit.
    const name$2u = "shadowOnlyPixelShader";
    const shader$2u = `precision highp float;uniform vec4 vEyePosition;uniform float alpha;uniform vec3 shadowColor;varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#include<helperFunctions>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<clipPlaneFragmentDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=vec3(1.0,1.0,1.0);
#endif
vec3 diffuseBase=vec3(0.,0.,0.);lightingInfo info;float shadow=1.;float glossiness=0.;
#include<lightFragment>[0..1]
vec4 color=vec4(shadowColor,(1.0-clamp(shadow,0.,1.))*alpha);
#include<fogFragment>
gl_FragColor=color;
#include<imageProcessingCompatibility>
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2u] = shader$2u;

    // Do not edit.
    const name$2v = "shadowOnlyVertexShader";
    const shader$2v = `precision highp float;attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
uniform mat4 view;uniform mat4 viewProjection;
#ifdef POINTSIZE
uniform float pointSize;
#endif
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#ifdef VERTEXCOLOR
varying vec4 vColor;
#endif
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(position,1.0);gl_Position=viewProjection*worldPos;vPositionW=vec3(worldPos);
#ifdef NORMAL
vNormalW=normalize(vec3(finalWorld*vec4(normal,0.0)));
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
#define CUSTOM_VERTEX_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2v] = shader$2v;

    class ShadowOnlyMaterialDefines extends MaterialDefines {
        constructor() {
            super();
            this.CLIPPLANE = false;
            this.CLIPPLANE2 = false;
            this.CLIPPLANE3 = false;
            this.CLIPPLANE4 = false;
            this.CLIPPLANE5 = false;
            this.CLIPPLANE6 = false;
            this.POINTSIZE = false;
            this.FOG = false;
            this.NORMAL = false;
            this.NUM_BONE_INFLUENCERS = 0;
            this.BonesPerMesh = 0;
            this.INSTANCES = false;
            this.IMAGEPROCESSINGPOSTPROCESS = false;
            this.SKIPFINALCOLORCLAMP = false;
            this.rebuild();
        }
    }
    class ShadowOnlyMaterial extends PushMaterial {
        constructor(name, scene) {
            super(name, scene);
            this._needAlphaBlending = true;
            this.shadowColor = Color3.Black();
        }
        needAlphaBlending() {
            return this._needAlphaBlending;
        }
        needAlphaTesting() {
            return false;
        }
        getAlphaTestTexture() {
            return null;
        }
        get activeLight() {
            return this._activeLight;
        }
        set activeLight(light) {
            this._activeLight = light;
        }
        _getFirstShadowLightForMesh(mesh) {
            for (const light of mesh.lightSources) {
                if (light.shadowEnabled) {
                    return light;
                }
            }
            return null;
        }
        // Methods
        isReadyForSubMesh(mesh, subMesh, useInstances) {
            var _a;
            if (this.isFrozen) {
                if (subMesh.effect && subMesh.effect._wasPreviouslyReady && subMesh.effect._wasPreviouslyUsingInstances === useInstances) {
                    return true;
                }
            }
            if (!subMesh.materialDefines) {
                subMesh.materialDefines = new ShadowOnlyMaterialDefines();
            }
            const defines = subMesh.materialDefines;
            const scene = this.getScene();
            if (this._isReadyForSubMesh(subMesh)) {
                return true;
            }
            const engine = scene.getEngine();
            // Ensure that active light is the first shadow light
            if (this._activeLight) {
                for (const light of mesh.lightSources) {
                    if (light.shadowEnabled) {
                        if (this._activeLight === light) {
                            break; // We are good
                        }
                        const lightPosition = mesh.lightSources.indexOf(this._activeLight);
                        if (lightPosition !== -1) {
                            mesh.lightSources.splice(lightPosition, 1);
                            mesh.lightSources.splice(0, 0, this._activeLight);
                        }
                        break;
                    }
                }
            }
            MaterialHelper.PrepareDefinesForFrameBoundValues(scene, engine, this, defines, useInstances ? true : false);
            MaterialHelper.PrepareDefinesForMisc(mesh, scene, false, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh), defines);
            defines._needNormals = MaterialHelper.PrepareDefinesForLights(scene, mesh, defines, false, 1);
            const shadowGenerator = (_a = this._getFirstShadowLightForMesh(mesh)) === null || _a === void 0 ? void 0 : _a.getShadowGenerator();
            this._needAlphaBlending = true;
            if (shadowGenerator && shadowGenerator.getClassName && shadowGenerator.getClassName() === "CascadedShadowGenerator") {
                const csg = shadowGenerator;
                this._needAlphaBlending = !csg.autoCalcDepthBounds;
            }
            // Attribs
            MaterialHelper.PrepareDefinesForAttributes(mesh, defines, false, true);
            // Get correct effect
            if (defines.isDirty) {
                defines.markAsProcessed();
                scene.resetCachedMaterial();
                // Fallbacks
                const fallbacks = new EffectFallbacks();
                if (defines.FOG) {
                    fallbacks.addFallback(1, "FOG");
                }
                MaterialHelper.HandleFallbacksForShadows(defines, fallbacks, 1);
                if (defines.NUM_BONE_INFLUENCERS > 0) {
                    fallbacks.addCPUSkinningFallback(0, mesh);
                }
                defines.IMAGEPROCESSINGPOSTPROCESS = scene.imageProcessingConfiguration.applyByPostProcess;
                //Attributes
                const attribs = [VertexBuffer.PositionKind];
                if (defines.NORMAL) {
                    attribs.push(VertexBuffer.NormalKind);
                }
                MaterialHelper.PrepareAttributesForBones(attribs, mesh, defines, fallbacks);
                MaterialHelper.PrepareAttributesForInstances(attribs, defines);
                const shaderName = "shadowOnly";
                const join = defines.toString();
                const uniforms = ["world", "view", "viewProjection", "vEyePosition", "vLightsType", "vFogInfos", "vFogColor", "pointSize", "alpha", "shadowColor", "mBones"];
                const samplers = new Array();
                const uniformBuffers = new Array();
                addClipPlaneUniforms(uniforms);
                MaterialHelper.PrepareUniformsAndSamplersList({
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: defines,
                    maxSimultaneousLights: 1,
                });
                subMesh.setEffect(scene.getEngine().createEffect(shaderName, {
                    attributes: attribs,
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: join,
                    fallbacks: fallbacks,
                    onCompiled: this.onCompiled,
                    onError: this.onError,
                    indexParameters: { maxSimultaneousLights: 1 },
                }, engine), defines, this._materialContext);
            }
            if (!subMesh.effect || !subMesh.effect.isReady()) {
                return false;
            }
            defines._renderId = scene.getRenderId();
            subMesh.effect._wasPreviouslyReady = true;
            subMesh.effect._wasPreviouslyUsingInstances = !!useInstances;
            return true;
        }
        bindForSubMesh(world, mesh, subMesh) {
            const scene = this.getScene();
            const defines = subMesh.materialDefines;
            if (!defines) {
                return;
            }
            const effect = subMesh.effect;
            if (!effect) {
                return;
            }
            this._activeEffect = effect;
            // Matrices
            this.bindOnlyWorldMatrix(world);
            this._activeEffect.setMatrix("viewProjection", scene.getTransformMatrix());
            // Bones
            MaterialHelper.BindBonesParameters(mesh, this._activeEffect);
            if (this._mustRebind(scene, effect)) {
                // Clip plane
                bindClipPlane(effect, this, scene);
                // Point size
                if (this.pointsCloud) {
                    this._activeEffect.setFloat("pointSize", this.pointSize);
                }
                this._activeEffect.setFloat("alpha", this.alpha);
                this._activeEffect.setColor3("shadowColor", this.shadowColor);
                scene.bindEyePosition(effect);
            }
            // Lights
            if (scene.lightsEnabled) {
                MaterialHelper.BindLights(scene, mesh, this._activeEffect, defines, 1);
                const light = this._getFirstShadowLightForMesh(mesh);
                if (light) {
                    // Make sure the uniforms for this light will be rebound for other materials using this light when rendering the current frame.
                    // Indeed, there is an optimization in Light that binds the light uniforms only once per frame for a given light (if using ubo).
                    // Doing this way assumes that all uses of this light are the same, meaning all parameters passed to Light._bindLlight
                    // are the same, notably useSpecular. However, isReadyForSubMesh (see above) is passing false for this parameter, which may not be
                    // the value the other materials may pass.
                    light._renderId = -1;
                }
            }
            // View
            if ((scene.fogEnabled && mesh.applyFog && scene.fogMode !== Scene.FOGMODE_NONE) || defines["SHADOWCSM0"]) {
                this._activeEffect.setMatrix("view", scene.getViewMatrix());
            }
            // Fog
            MaterialHelper.BindFogParameters(scene, mesh, this._activeEffect);
            this._afterBind(mesh, this._activeEffect);
        }
        clone(name) {
            return SerializationHelper.Clone(() => new ShadowOnlyMaterial(name, this.getScene()), this);
        }
        serialize() {
            const serializationObject = super.serialize();
            serializationObject.customType = "BABYLON.ShadowOnlyMaterial";
            return serializationObject;
        }
        getClassName() {
            return "ShadowOnlyMaterial";
        }
        // Statics
        static Parse(source, scene, rootUrl) {
            return SerializationHelper.Parse(() => new ShadowOnlyMaterial(source.name, scene), source, scene, rootUrl);
        }
    }
    RegisterClass("BABYLON.ShadowOnlyMaterial", ShadowOnlyMaterial);

    /** padding in size to make enough space for shadow blur */
    const SIZE_RATIO = 4;
    class XrShadowPlane extends Mesh {
        constructor(v, scene) {
            super('xrShadowPlane', scene);
            this.v = v;
            this.scene = scene;
            this.subscription = new Subscription();
            this.receiveShadows = true;
            this.isPickable = false;
            this.shadowMaterial = new ShadowOnlyMaterial('xrShadowMaterial', scene);
            this.shadowMaterial.alpha = 0.4;
            this.material = this.shadowMaterial;
            // this.material = v.rendererManager.material.defaultMaterial;
            this.setEnabled(false);
        }
        place(rootNode) {
            this.setParent(rootNode);
            const bbCache = this.v.bbCache;
            const bb = bbCache.get(this.v.sceneNode);
            if (bb) {
                this.resize(bb);
                this.setEnabled(true);
                this.subscription.add(bbCache.rootBoundingBoxChanged.subscribe(newBb => {
                    this.resize(bb);
                }));
            }
        }
        resize(bb) {
            const width = (bb.max.x - bb.min.x) * SIZE_RATIO;
            const height = (bb.max.z - bb.min.z) * SIZE_RATIO;
            const vertexData = VertexData.CreatePlane({
                width,
                height,
                sideOrientation: 0,
            });
            //bake in a 90 degree rotation so it's flat on the ground
            const rotMatrix = new Matrix();
            Quaternion.FromEulerAngles(Math.PI / 2, 0, 0).toRotationMatrix(rotMatrix);
            vertexData.transform(rotMatrix);
            vertexData.applyToMesh(this, true);
            this.position.set(bb.center.x, 0, bb.center.z);
        }
        dispose() {
            this.subscription.unsubscribe();
            super.dispose();
            if (this.shadowMaterial)
                this.shadowMaterial.dispose();
        }
    }

    class XrTransientHitTester {
        constructor(sessionMgr) {
            this.sessionMgr = sessionMgr;
        }
        initialize(offsetRay) {
            const session = this.sessionMgr.session;
            return session.requestHitTestSourceForTransientInput({
                profile: 'generic-touchscreen',
                offsetRay: offsetRay,
            }).then(hitSource => {
                return (this.source = hitSource);
            });
        }
        getFingers(frame) {
            if (!this.source)
                return [];
            const fingers = frame.getHitTestResultsForTransientInput(this.source);
            if (!fingers.length)
                return [];
            const convertedFingers = new Array();
            for (const f of fingers) {
                const r = {
                    inputSource: f.inputSource,
                    results: [],
                };
                convertedFingers.push(r);
                for (const hit of f.results) {
                    const convertedHit = XrHitTester.FromXRHitTestResult(hit, this.sessionMgr.referenceSpace);
                    if (convertedHit)
                        r.results.push(convertedHit);
                }
            }
            return convertedFingers;
        }
        dispose() {
            if (this.source) {
                this.source.cancel();
                this.source = undefined;
            }
        }
    }

    // interface XRSystem extends EventTarget {
    //     requestSession(mode: XRSessionMode, options?: XRSessionInit): Promise<XRSession>;
    //     isSessionSupported(mode: XRSessionMode): Promise<boolean>;
    // }
    // declare global {
    //     interface Navigator {
    //         xr?: XRSystem;
    //     }
    // }
    var eXrState;
    (function (eXrState) {
        eXrState[eXrState["searchingForHit"] = 0] = "searchingForHit";
        eXrState[eXrState["initialPlacement"] = 1] = "initialPlacement";
        eXrState[eXrState["placed"] = 2] = "placed";
    })(eXrState || (eXrState = {}));
    const ROTATION_RATE = 1.5;
    const SCALE_SNAP = 1.2;
    class Xr {
        constructor(v, scene) {
            this.v = v;
            this.scene = scene;
            this.onSessionEnd = new Subject();
            this._state = eXrState.searchingForHit;
            this._goalScale = 0;
            this._goalYaw = 0;
            this._lastScalar = 0;
            this._scaleSnapHigh = SCALE_SNAP;
            this._scaleSnapLow = 1 / SCALE_SNAP;
            this._naturalScale = 1;
            this._wasJustPlaced = false;
            this._lightingEstimationCount = 0;
            this.onSelectStart = (event) => {
                var _a;
                if (this._state == eXrState.initialPlacement) {
                    this.placeModel();
                    this._state = eXrState.placed;
                    this._initialHitTester.dispose();
                    this._initialHitTester = undefined;
                    this._transientHitTester = new XrTransientHitTester(this._sessionMgr);
                    this._transientHitTester.initialize();
                    this._wasJustPlaced = true;
                }
                else if (this._state == eXrState.placed) {
                    const fingers = (_a = this._transientHitTester) === null || _a === void 0 ? void 0 : _a.getFingers(this._lastFrame);
                    if ((fingers === null || fingers === void 0 ? void 0 : fingers.length) === 1) {
                        /** for one finger we do a hit test on kb3d to see if they pressed the model */
                        this._selectStartScreenPos = this.screenNdcToPixels(event.inputSource.gamepad.axes); //get the screen coordinates of the finger press
                        const pickInfo = this.pick(this._selectStartScreenPos);
                        if (pickInfo) {
                            // console.log({ pickInfo });
                            this._isTranslating = true;
                            this._dragNodeStartPos = this._rootNode.position.clone();
                            // this._dragNodeStartScreenPos = toScreen(this._rootNode.absolutePosition, this.getRigCamera());
                            // this._fingerStartScreenPos = this.screenNdcToPixels(fingers[0].inputSource.gamepad!.axes);
                            const dragHitTester = new XrTransientHitTester(this._sessionMgr);
                            const offset = this._dragNodeStartPos.subtract(pickInfo.pickedPoint.toVec3());
                            // console.log({nodePos: this._dragNodeStartPos, pickedPoint: pickInfo.pickedPoint});
                            const offsetRay = new XRRay(offset);
                            dragHitTester.initialize(offsetRay).then(() => {
                                this._dragHitTester = dragHitTester;
                            });
                        }
                        else {
                            this._isRotating = true;
                            this._goalYaw = this._rootNode.rotation.y;
                            this._lastScalar = event.inputSource.gamepad.axes[0];
                        }
                        //simulate pointer down observable
                        const args = this.v.interaction.getKb3dPointerArgs({
                            type: PointerEventTypes.POINTERDOWN,
                            event: new PointerEvent('pointerdown', { pointerId: event.inputSource.gamepad.id }),
                            pickInfo: pickInfo,
                        });
                        this.v.interaction.handlePointerDown(args);
                        this._marker.show();
                    }
                    else if ((fingers === null || fingers === void 0 ? void 0 : fingers.length) === 2 && this.v.sceneNode.xrAllowScaling) {
                        this._isScaling = true;
                        this._lastScalar = this.getFingerSeparation(fingers) / this._rootNode.scaling.x;
                        this._marker.show();
                    }
                }
            };
            this.onSelectEnd = (event) => {
                var _a;
                this._isTranslating = false;
                this._isRotating = false;
                this._isScaling = false;
                if (this._dragHitTester) {
                    this._dragHitTester.dispose();
                }
                this._dragHitTester = undefined;
                this._fingerStartPos = undefined;
                //simulate pointer up observable
                const fingers = (_a = this._transientHitTester) === null || _a === void 0 ? void 0 : _a.getFingers(this._lastFrame);
                const screenCoord = this.screenNdcToPixels(event.inputSource.gamepad.axes); //get the screen coordinates of the finger press
                const pickInfo = this.pick(screenCoord);
                const args = this.v.interaction.getKb3dPointerArgs({
                    type: PointerEventTypes.POINTERUP,
                    event: new PointerEvent('pointerup', { pointerId: event.inputSource.gamepad.id }),
                    pickInfo: pickInfo,
                });
                this.v.interaction.handlePointerUp(args);
                //simulate the pointer tap observable if the input hasn't moved much
                if (this._state == eXrState.placed) {
                    if ((fingers === null || fingers === void 0 ? void 0 : fingers.length) === 1 && !this._wasJustPlaced) {
                        const deltaScreen = Vector2.Distance(this._selectStartScreenPos || screenCoord, screenCoord);
                        if (deltaScreen < 5) {
                            const args = this.v.interaction.getKb3dPointerArgs({
                                type: PointerEventTypes.POINTERTAP,
                                event: new PointerEvent('pointertap', { pointerId: event.inputSource.gamepad.id }),
                                pickInfo: pickInfo,
                            });
                            this.v.interaction.handleClick(args);
                        }
                    }
                    this._marker.hide();
                    this._wasJustPlaced = false;
                }
            };
        }
        startSession(mode, refSpaceType, overlayElem) {
            var _a, _b;
            const xrInitOptions = {
                optionalFeatures: ['light-estimation'],
                requiredFeatures: ['hit-test'],
            };
            if (overlayElem) {
                overlayElem.addEventListener('beforexrselect', ev => {
                    if (ev.target != overlayElem) {
                        ev.preventDefault();
                    }
                });
                (_a = xrInitOptions.optionalFeatures) === null || _a === void 0 ? void 0 : _a.push('dom-overlay');
                xrInitOptions.domOverlay = {
                    root: overlayElem,
                };
            }
            if (refSpaceType !== 'viewer' && refSpaceType !== 'local') {
                (_b = xrInitOptions.optionalFeatures) === null || _b === void 0 ? void 0 : _b.push(refSpaceType);
            }
            this._naturalScale = 1 / this.v.sceneNode.unitsPerMeter;
            this._sessionMgr = new WebXRSessionManager(this.scene);
            this._sessionMgr.onXRSessionEnded.addOnce(() => this.sessionEnded());
            this._xrCamera = new WebXRCamera('', this.scene, this._sessionMgr);
            return this._sessionMgr
                .initializeAsync()
                .then(() => {
                this._renderTarget = this._sessionMgr.getWebXRRenderTarget();
                return this._sessionMgr.initializeSessionAsync(mode, xrInitOptions).then(() => {
                    this._session = this._sessionMgr.session;
                });
            })
                .then(() => {
                return this._sessionMgr.setReferenceSpaceTypeAsync(refSpaceType).then(refSpace => {
                    this._refSpace = refSpace;
                });
            })
                .then(() => {
                return this._renderTarget.initializeXRLayerAsync(this._sessionMgr.session);
            })
                .then(() => {
                return this._sessionMgr.updateRenderState({
                    depthFar: this._xrCamera.maxZ,
                    depthNear: this._xrCamera.minZ,
                    baseLayer: this._renderTarget.xrLayer,
                });
            })
                .then(() => {
                this._rootNode = this.v.rendererManager.sceneRenderer.get3d(this.v.sceneNode); //get the root transform node for our scene... this is what we will move to position the scene in AR
                this._rootNode.setEnabled(false);
                //subscribe to render loop
                this._sessionMgr.onXRFrameObservable.add((frame) => this.onXRFrame(frame));
                this._sessionMgr.runXRRenderLoop(); //start the render loop
                this._originalSceneCamera = this.scene.activeCamera;
                this.scene.activeCamera = this._xrCamera; //this line is important
                this.scene.autoClear = false;
                this._xrCamera.compensateOnFirstFrame = false;
                this._originalBackground = this.v.sceneNode.background;
                this.v.sceneNode.background = exports.eBackground.transparent;
                //add xr input handlers
                this._session.addEventListener('selectstart', this.onSelectStart);
                this._session.addEventListener('selectend', this.onSelectEnd);
                this._initialHitTester = new XrHitTester(this._sessionMgr);
                return this._initialHitTester.initialize();
            });
        }
        endSession() {
            if (this._sessionMgr) {
                this.sessionEndingPromise = this._sessionMgr.exitXRAsync();
                return this.sessionEndingPromise;
            }
            else {
                return Promise.resolve();
            }
        }
        sessionEnded() {
            if (this.sessionEndingPromise) {
                this.sessionEndingPromise.then(() => {
                    this.sessionEndingPromise = undefined;
                    this.sessionEnded();
                });
            }
            else {
                this._session.removeEventListener('selectstart', this.onSelectStart);
                this._session.removeEventListener('selectend', this.onSelectEnd);
                if (this._xrCamera)
                    this._xrCamera.dispose();
                if (this._sessionMgr)
                    this._sessionMgr.dispose();
                if (this._renderTarget)
                    this._renderTarget.dispose();
                if (this._initialHitTester)
                    this._initialHitTester.dispose();
                if (this._marker)
                    this._marker.dispose();
                if (this._light)
                    this._light.dispose();
                if (this._shadow)
                    this._shadow.dispose();
                if (this._originalSceneCamera) {
                    this.scene.activeCamera = this._originalSceneCamera;
                }
                this.scene.autoClear = true;
                this.v.sceneNode.background = this._originalBackground || exports.eBackground.transparent;
                this._rootNode.scaling = Vector3.One();
                this._rootNode.rotation = Vector3.Zero();
                this._rootNode.position = Vector3.Zero();
                this._rootNode.setEnabled(true);
                this.onSessionEnd.next();
            }
        }
        onXRFrame(frame) {
            this._lastFrame = frame;
            //console.log(`user height: ${this._xrCamera.realWorldHeight}`);
            this._viewerPose = frame.getViewerPose(this._sessionMgr.referenceSpace);
            this.placeInitialMarker(frame);
            this.processInput(frame);
            this.setSceneTransform();
            this.runLightingEstimation(frame);
        }
        runLightingEstimation(frame) {
            if (this._lightProbe) {
                this._lightingEstimationCount++;
                if (this._lightingEstimationCount == 30) {
                    this._lightingEstimationCount = 0;
                    const estimate = frame.getLightEstimate(this._lightProbe);
                    // const probePose = frame.getPose(this._lightProbe.probeSpace, this._refSpace);
                    // console.log({probePose});
                    // console.log({ lightEstimate: estimate });
                    if (estimate && this._light) {
                        const direction = new Vector3(estimate.primaryLightDirection.x, estimate.primaryLightDirection.y, estimate.primaryLightDirection.z);
                        direction.negateInPlace();
                        this._light.setDirection(direction.x, direction.y, direction.z);
                        const intensity = Math.max(1.0, Math.max(estimate.primaryLightIntensity.x, Math.max(estimate.primaryLightIntensity.y, estimate.primaryLightIntensity.z)));
                        this._light.specular.set(estimate.primaryLightIntensity.x / intensity, estimate.primaryLightIntensity.y / intensity, estimate.primaryLightIntensity.z / intensity);
                        this._light.diffuse.set(estimate.primaryLightIntensity.x / intensity, estimate.primaryLightIntensity.y / intensity, estimate.primaryLightIntensity.z / intensity);
                        this._light.intensity = intensity;
                    }
                }
            }
        }
        placeInitialMarker(frame) {
            if (this._state == eXrState.searchingForHit || this._state == eXrState.initialPlacement) {
                const hit = this._initialHitTester.getHitResult(frame);
                if (!hit)
                    return;
                if (this._state == eXrState.searchingForHit) {
                    if (!this._marker) {
                        this._marker = new XrMarker(this.v, this.scene, this._naturalScale);
                        this._marker.setEnabled(true);
                    }
                    this._state = eXrState.initialPlacement; //we got our first hit so we change state
                }
                if (this._state == eXrState.initialPlacement) {
                    const quat = new Quaternion();
                    hit.matrix.decompose(this._marker.scaling, quat, this._marker.position);
                    this._marker.rotation = quat.toEulerAngles();
                    // console.log(JSON.stringify({ markerPosition: this._marker.position }));
                }
            }
        }
        processInput(frame) {
            if (this._state == eXrState.placed && (this._isTranslating || this._isRotating || this._isScaling)) {
                const fingers = this._transientHitTester.getFingers(frame);
                if (this._isScaling) {
                    if (fingers.length < 2) {
                        //the user removed their 2nd finger, so the scale is cancelled
                        this._isScaling = false;
                    }
                    else {
                        const separation = this.getFingerSeparation(fingers);
                        const scale = separation / this._lastScalar;
                        this._goalScale =
                            scale < this._scaleSnapHigh && scale > this._scaleSnapLow ? this._naturalScale : scale;
                    }
                }
                else if (fingers.length === 2 && this.v.sceneNode.xrAllowScaling) {
                    // happens when translating or rotating and another finger was added.  We switch to scaling in this instance
                    this._isTranslating = false;
                    this._isRotating = false;
                    this._isScaling = true;
                    const scale = this._rootNode.scaling.x;
                    this._lastScalar = this.getFingerSeparation(fingers) / scale;
                }
                else if (this._isRotating) {
                    const inputSource = fingers[0].inputSource;
                    const dragX = inputSource.gamepad.axes[0];
                    this._goalYaw += (dragX - this._lastScalar) * ROTATION_RATE;
                    this._lastScalar = dragX;
                }
                else if (this._isTranslating) {
                    if (fingers.length > 0 && this._dragHitTester) {
                        const dragFingers = this._dragHitTester.getFingers(frame);
                        if (dragFingers.length && dragFingers[0].results.length) {
                            const dragFinger = dragFingers[0];
                            const dragFingerResult = dragFinger.results[0];
                            if (!this._fingerStartPos)
                                this._fingerStartPos = dragFingerResult.position;
                            const deltaPos = dragFingerResult.position.subtract(this._fingerStartPos);
                            this._goalPosition = this._dragNodeStartPos.add(deltaPos);
                        }
                    }
                }
            }
        }
        placeModel() {
            this._goalPosition = this._marker.position.clone();
            this._goalYaw = this._marker.rotation.y;
            this._goalScale = this._naturalScale;
            this._scaleSnapHigh = this._naturalScale * SCALE_SNAP;
            this._scaleSnapLow = this._naturalScale / SCALE_SNAP;
            //we now add the marker to the root node so it can scale and move with the model
            this._marker.place(this._rootNode);
            if (this.v.sceneNode.xrAddShadow) {
                this._shadow = new XrShadowPlane(this.v, this.scene);
                this._shadow.place(this._rootNode);
                this._light = new XrLight(this.v, this.scene);
                if (this.v.sceneNode.xrLightingEstimation && this._session.requestLightProbe) {
                    this._session.requestLightProbe().then(lp => (this._lightProbe = lp));
                }
            }
            this._rootNode.setEnabled(true);
            //this._marker.setEnabled(false);
            this._state = eXrState.placed;
        }
        /** does a pick of the kb3d scene (NOT a webxr hit test).  Accepts x/y as screen pixel coordinates */
        pick(screenCoord) {
            /**
             * The WebXRCamera in babylon appears to be for reference only, and it's position/rotation
             * are updated on each frame to be the same as the viewer pose from XR.
             *
             * However, the forward ray from the WebXRCamera is not what we would expect, it's pointing
             * in exactly the opposite direction.  However, inside the WebXRCamera are rig cameras (only 1
             * in the case of AR) who are responsible for actually doing the babylon rendering.  The rig
             * camera direction is what we would expect.  For now we are using the rig camera to do
             * the picking, but we should keep an eye on this part as new babylon/webxr releases come out,
             *  as something seems amiss.
             */
            const hardwareScale = this.scene.getEngine().getHardwareScalingLevel();
            /** adjust by hardware scale as webxr does not support it, but the pick routine uses it */
            const pickInfo = this.v.interaction.pick(screenCoord.x * hardwareScale, screenCoord.y * hardwareScale, this.getRigCamera());
            return pickInfo;
        }
        getFingerSeparation(fingers) {
            const firstFinger = fingers[0].inputSource.gamepad.axes;
            const secondFinger = fingers[1].inputSource.gamepad.axes;
            const deltaX = secondFinger[0] - firstFinger[0];
            const deltaY = secondFinger[1] - firstFinger[1];
            return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        }
        /** set's the transforms of the scene to the goal values */
        setSceneTransform() {
            if (this._state == eXrState.placed) {
                let invalidateRootBoundingBox = false;
                if (this._rootNode.scaling.x != this._goalScale) {
                    this._rootNode.scaling = new Vector3(this._goalScale, this._goalScale, this._goalScale);
                    invalidateRootBoundingBox = true;
                }
                if (this._rootNode.rotation.y != this._goalYaw) {
                    this._rootNode.rotation.y = this._goalYaw; // = Quaternion.FromEulerAngles(0, this._goalYaw, 0);
                    // this._marker.rotation.y = this._goalYaw;
                    invalidateRootBoundingBox = true;
                }
                if (this._goalPosition &&
                    !this._goalPosition.equalsToFloats(this._rootNode.position.x, this._rootNode.position.y, this._rootNode.position.z)) {
                    this._rootNode.position.set(this._goalPosition.x, this._goalPosition.y, this._goalPosition.z);
                    //this._marker.position.set(this._goalPosition.x, this._goalPosition.y, this._goalPosition.z);
                    invalidateRootBoundingBox = true;
                }
                if (invalidateRootBoundingBox) {
                    this.v.bbCache.invalidate(this.v.sceneNode);
                }
            }
        }
        getRigCamera() {
            const rigCamera = this._xrCamera.rigCameras[0];
            return rigCamera;
        }
        screenNdcToPixels(axes) {
            const canvas = this.scene.getEngine().getRenderingCanvas();
            //need to convert NDC units to pixels
            const x = (axes[0] + 1) * (canvas.width / 2);
            const y = (axes[1] + 1) * (canvas.height / 2);
            return new Vector2(x, y);
        }
        screenPixelsToNdc(pos) {
            const canvas = this.scene.getEngine().getRenderingCanvas();
            return {
                x: pos.x / (canvas.width / 2) - 1,
                y: pos.y / (canvas.height / 2) - 2,
            };
        }
    }

    const IS_IOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); //https://stackoverflow.com/a/58065241
    const IS_ANDROID = /android/i.test(navigator.userAgent);
    class AR {
        constructor(v, scene) {
            this.v = v;
            this.scene = scene;
            this.isDebug = false;
            this.xrActive = false;
            this.xrLoading = false;
            this.onSessionEnd = new Subject();
            this.isDebug = !!v.options.debugMode;
            this.gltfExporter = new GLTFKb3dExporter(scene);
        }
        toggle() {
            if (this.xrActive) {
                return this.end();
            }
            else {
                return this.start();
            }
        }
        start(overlayElem, onEnterFunc) {
            // Have to use a callback because android should run this after entering XR, but ios must run it before entering XR
            if (!onEnterFunc) {
                onEnterFunc = () => Promise.resolve();
            }
            const _onEnterFunc = onEnterFunc;
            if (IS_ANDROID) {
                return this.startWebXR(overlayElem).then(() => _onEnterFunc());
            }
            else if (IS_IOS || this.isDebug) {
                const usdz = new USDZBabylonConverter();
                if (this.v.sceneNode) {
                    const self = this;
                    return this.v
                        .whenAssetsLoaded()
                        .then(() => _onEnterFunc())
                        .then(() => this.v.forceAndWaitForNextRender())
                        .then(() => usdz.parse(this.scene, this.v.sceneNode, true))
                        .then(res => {
                        const a = document.createElement('a');
                        if (a.relList.supports('ar') || this.isDebug) {
                            if (self.currentObjectUrl) {
                                window.URL.revokeObjectURL(self.currentObjectUrl);
                                self.currentObjectUrl = undefined;
                            }
                            self.currentObjectUrl = window.URL.createObjectURL(res);
                            const img = document.createElement('img');
                            img.src = '/images/ar_ios.png';
                            a.appendChild(img);
                            document.body.appendChild(a);
                            a.href = self.currentObjectUrl;
                            a.download = 'test.usdz';
                            a.rel = 'ar';
                            // Fire XR Exit right away on iOS since the USDZ is already generated and static now
                            // So, whatever scene changes they want when the user exits AR should already be in the browser
                            this.xrActive = false;
                            this.xrLoading = false;
                            this.onSessionEnd.next();
                            setTimeout(() => {
                                a.click();
                                setTimeout(() => {
                                    document.body.removeChild(a);
                                }, 0);
                            }, 50);
                            return undefined;
                        }
                        return Promise.reject('Your device does not support AR.');
                    });
                }
                else {
                    return Promise.reject('Scene not initialized');
                }
            }
            return Promise.reject('Your device does not support AR.');
        }
        end() {
            if (IS_ANDROID) {
                return this.endWebXr();
            }
            else if (IS_IOS) {
                if (this.currentObjectUrl) {
                    URL.revokeObjectURL(this.currentObjectUrl);
                }
                //TODO usdz
            }
            return Promise.resolve();
        }
        startWebXR(overlayElem) {
            this._xr = new Xr(this.v, this.scene);
            this._xr.onSessionEnd.pipe(first()).subscribe(() => {
                this.xrActive = false;
                this.xrLoading = false;
                this.onSessionEnd.next();
            });
            this.xrLoading = true;
            return this._xr.startSession('immersive-ar', 'local-floor', overlayElem).then(() => {
                this.xrActive = true;
                this.xrLoading = false;
            });
        }
        endWebXr() {
            if (this._xr) {
                return this._xr.endSession();
            }
            else {
                return Promise.resolve();
            }
        }
        /**
         * Takes a URL to a USDZ file and sets the appropriate fields so that Safari
         * iOS can intent to their AR Quick Look.
         */
        startIosQuickLook(usdzSrc, canScale) {
            const anchor = document.createElement('a');
            anchor.setAttribute('rel', 'ar');
            anchor.appendChild(document.createElement('img'));
            const modelUrl = new URL(usdzSrc, self.location.toString());
            if (!canScale) {
                modelUrl.hash = 'allowsContentScaling=0';
            }
            anchor.setAttribute('href', modelUrl.toString());
            anchor.click();
        }
    }

    function toBoundingBoxInfo(binfo) {
        return {
            boundingInfo: binfo,
            min: exports.KbVector.FromVec3(binfo.minimum),
            max: exports.KbVector.FromVec3(binfo.maximum),
            center: exports.KbVector.FromVec3(binfo.boundingBox.center),
        };
    }
    const MAX_DIGESTS = 30;
    class BoundingBoxCache {
        constructor(v) {
            this.v = v;
            this.boundingBoxInvalidated = new Subject();
            this.rootBoundingBoxChanged = new Subject();
            this._digestCount = 0;
            this._db = new Map();
            this._watchedNodes = new Map();
            this._changedNodes = new Set(); //stored dynamic id's of changed nodes
        }
        watchForChanges(node) {
            let subject = this._watchedNodes.get(node._dynamicId);
            if (!subject) {
                subject = new BehaviorSubject(undefined);
                this._watchedNodes.set(node._dynamicId, subject);
            }
            const _subject = subject;
            // This is using an internal implementation of rxjs, hence the any. But this is the only way we can add teardown logic.
            const observable = new Observable(s => {
                s.next();
                return () => {
                    setTimeout(() => {
                        if (_subject.observers.length === 0) {
                            _subject.complete();
                            this._watchedNodes.delete(node._dynamicId);
                        }
                    });
                };
            });
            return observable.pipe(mergeMap(() => _subject));
        }
        refreshAndGet(node) {
            this._db.delete(node._dynamicId);
            return this.get(node);
        }
        get(node) {
            if (node && node.visible) {
                let bb = this._db.get(node._dynamicId);
                if (!bb) {
                    let bbInfo;
                    const bnode = this.v.rendererManager.mesh.get3d(node);
                    if (node instanceof exports.MeshNode) {
                        if (bnode) {
                            bbInfo = bnode.getBoundingInfo();
                        }
                    }
                    else {
                        const childNodes = node.getSpaceChildren();
                        const min = {};
                        const max = {};
                        let empty = true;
                        for (const c of childNodes) {
                            const cbb = this.get(c);
                            // If cbb is undefined, that means the child node is not visible or doesn't exist
                            if (cbb) {
                                empty = false;
                                const parentMin = cbb.min.toVec3();
                                const parentMax = cbb.max.toVec3();
                                const childBNode = this.v.rendererManager.mesh.get3d(c);
                                if (childBNode) {
                                    const mat = Matrix.Compose(childBNode.scaling, childBNode.rotationQuaternion, childBNode.position);
                                    Vector3.TransformCoordinatesToRef(parentMin, mat, parentMin);
                                    Vector3.TransformCoordinatesToRef(parentMax, mat, parentMax);
                                }
                                if (min.x == null)
                                    min.x = parentMin.x;
                                if (min.y == null)
                                    min.y = parentMin.y;
                                if (min.z == null)
                                    min.z = parentMin.z;
                                if (max.x == null)
                                    max.x = parentMax.x;
                                if (max.y == null)
                                    max.y = parentMax.y;
                                if (max.z == null)
                                    max.z = parentMax.z;
                                min.x = Math.min(min.x, parentMin.x, parentMax.x);
                                min.y = Math.min(min.y, parentMin.y, parentMax.y);
                                min.z = Math.min(min.z, parentMin.z, parentMax.z);
                                max.x = Math.max(max.x, parentMin.x, parentMax.x);
                                max.y = Math.max(max.y, parentMin.y, parentMax.y);
                                max.z = Math.max(max.z, parentMin.z, parentMax.z);
                            }
                        }
                        if (empty) {
                            return undefined; //don't consider empty groups
                        }
                        bbInfo = new BoundingInfo(new Vector3(min.x || 0, min.y || 0, min.z || 0), new Vector3(max.x || 0, max.y || 0, max.z || 0));
                    }
                    if (bbInfo) {
                        bb = toBoundingBoxInfo(bbInfo);
                        this._db.set(node._dynamicId, bb);
                    }
                }
                return bb;
            }
            else {
                return undefined;
            }
        }
        invalidate(node) {
            if (node) {
                //when a node is invalidated, all of it's ancestors need to be invalidated
                let n = node;
                while (n && n instanceof exports.SpaceNode) {
                    this._changedNodes.add(n._dynamicId);
                    n = n._parent;
                }
            }
        }
        update() {
            var _a, _b;
            let boundingBoxesStable = true;
            if (this._changedNodes.size === 0) {
                return;
            }
            if (!this.v.userIsInteracting()) {
                this._digestCount++;
            }
            const watchersToUpdateAndClear = new Map();
            for (const dynamicId of this._changedNodes) {
                const n = getByDynamicId(dynamicId);
                if (!n) {
                    continue;
                }
                const externalWatchers = (_a = n._manager) === null || _a === void 0 ? void 0 : _a.boundingboxChangeHandlers.getByKey(n);
                const hasRootWatchers = this.v.sceneNode._dynamicId === n._dynamicId && this.rootBoundingBoxChanged.observers.length > 0;
                const hasWatchers = this._watchedNodes.has(n._dynamicId) || (externalWatchers !== undefined && externalWatchers.length > 0);
                const oldBoundingBox = this._db.get(n._dynamicId);
                this._db.delete(n._dynamicId);
                this.boundingBoxInvalidated.next(n);
                if (!hasWatchers && !hasRootWatchers) {
                    continue;
                }
                const bbInfo = this.get(n);
                const boundingBoxChanged = !boundingBoxesMatch(bbInfo, oldBoundingBox);
                const bbWatchersSubject = this._watchedNodes.get(n._dynamicId);
                if (boundingBoxChanged) {
                    boundingBoxesStable = false;
                }
                if (bbWatchersSubject) {
                    bbWatchersSubject.next(bbInfo);
                }
                if (externalWatchers && bbInfo) {
                    for (const w of externalWatchers) {
                        const once = w.mode === 'once';
                        // Always call the handler if the mode is 'once', because it will be expecting an update regardless of whether it changed or not.
                        // For persistent watchers, only call it if the bb actually changed.
                        if (boundingBoxChanged && !once) {
                            w.handler(bbInfo);
                        }
                        if (once) {
                            watchersToUpdateAndClear.set(n, w);
                        }
                    }
                }
                if (hasRootWatchers && bbInfo && boundingBoxChanged) {
                    this.rootBoundingBoxChanged.next(bbInfo);
                }
            }
            if (boundingBoxesStable && this._digestCount > 3) {
                this._changedNodes.clear();
                for (const [node, watcher] of watchersToUpdateAndClear.entries()) {
                    const bbInfo = this.get(node);
                    if (bbInfo) {
                        watcher.handler(bbInfo);
                    }
                    (_b = node._manager) === null || _b === void 0 ? void 0 : _b.boundingboxChangeHandlers.deleteByKeyValue(node, watcher);
                }
                watchersToUpdateAndClear.clear();
                this._digestCount = 0;
            }
            else if (!boundingBoxesStable && this._digestCount > MAX_DIGESTS) {
                console.error('Bounding box digest cycle exceeded, but the meshes are not consistent');
                this._changedNodes.clear();
                watchersToUpdateAndClear.clear();
                this._digestCount = 0;
            }
        }
        /**
         * Gets the world bounding box for the specified node.
         * Be aware that this call is not cached, so use accordingly for performance reasons
         * @param node
         */
        getWorld(node) {
            if (node && node.visible) {
                const bb = this.get(node);
                if (!bb) {
                    return null;
                }
                const bnode = this.v.rendererManager.mesh.get3d(node);
                const bbInfo = new BoundingInfo(new Vector3(bb.min.x || 0, bb.min.y || 0, bb.min.z || 0), new Vector3(bb.max.x || 0, bb.max.y || 0, bb.max.z || 0), bnode === null || bnode === void 0 ? void 0 : bnode.getWorldMatrix());
                return {
                    boundingInfo: bbInfo,
                    min: exports.KbVector.FromVec3(bbInfo.boundingBox.minimumWorld),
                    max: exports.KbVector.FromVec3(bbInfo.boundingBox.maximumWorld),
                    center: exports.KbVector.FromVec3(bbInfo.boundingBox.centerWorld),
                };
            }
            return null;
        }
        dispose() {
            this._db.clear();
            this._watchedNodes.forEach(subject => {
                subject.complete();
            });
            this._watchedNodes.clear();
        }
    }
    function boundingBoxesMatch(a, b) {
        if (!a && !b) {
            return true;
        }
        if (!a || !b) {
            return false;
        }
        return a.center.equal(b.center) && a.min.equal(b.min) && a.max.equal(b.max);
    }

    Object.defineProperty(exports.KbVector.prototype, 'toVec3', {
        enumerable: false,
        writable: true,
        value: function (ref) {
            // add ref option
            if (!ref) {
                ref = new Vector3();
            }
            return this ? ref.copyFromFloats(this.x, this.y, this.z) : ref.setAll(0);
        },
    });
    Object.defineProperty(exports.KbVector, 'FromVec3', {
        enumerable: false,
        writable: true,
        value: function (vector) {
            return new exports.KbVector(vector.x, vector.y, vector.z);
        },
    });
    Object.defineProperty(exports.KbQuaternion.prototype, 'toQuat', {
        enumerable: false,
        writable: true,
        value: function () {
            return this ? new Quaternion(this.x, this.y, this.z, this.w) : new Quaternion(0, 0, 0, 1);
        },
    });
    Object.defineProperty(exports.KbQuaternion, 'FromQuat', {
        enumerable: false,
        writable: true,
        value: function (q) {
            return new exports.KbQuaternion(q.x, q.y, q.z, q.w);
        },
    });
    Object.defineProperty(exports.KbColor.prototype, 'toColor3', {
        enumerable: false,
        writable: true,
        value: function () {
            return this ? new Color3(this.r, this.g, this.b) : Color3.Black();
        },
    });
    Object.defineProperty(exports.KbColor.prototype, 'toColor4', {
        enumerable: false,
        writable: true,
        value: function () {
            return this ? new Color4(this.r, this.g, this.b, this.a) : new Color4(0, 0, 0, 0);
        },
    });

    class BoundingBoxRelativeHelper {
        static convertRelativeToAbsolute(c, bb, position) {
            if (!position) {
                position = c.position;
            }
            if (isSketchControlPoint(c)) {
                return new Vector3(((position.x + 1) / 2) * bb.max.x + bb.min.x, ((position.y + 1) / 2) * bb.max.y + bb.min.y, ((position.z + 1) / 2) * bb.max.z + bb.min.z);
            }
            else {
                return new Vector3(bb.center.x + (position.x * Math.abs(bb.max.x - bb.min.x)) / 2, bb.center.y + (position.y * Math.abs(bb.max.y - bb.min.y)) / 2, bb.center.z + (position.z * Math.abs(bb.max.z - bb.min.z)) / 2);
            }
        }
        static convertAbsoluteToRelative(c, bb, position) {
            if (!position) {
                position = c.position;
            }
            if (isSketchControlPoint(c)) {
                return new Vector3(((position.x - bb.min.x) / bb.max.x) * 2 - 1, ((position.y - bb.min.y) / bb.max.y) * 2 - 1, ((position.z - bb.min.z) / bb.max.z) * 2 - 1);
            }
            else {
                return new Vector3(((position.x - bb.center.x) * 2) / Math.abs(bb.max.x - bb.min.x), ((position.y - bb.center.y) * 2) / Math.abs(bb.max.y - bb.min.y), ((position.z - bb.center.z) * 2) / Math.abs(bb.max.z - bb.min.z));
            }
        }
        static convertRelativeDirectionToAbsolute(c, direction, bb) {
            if (isSketchControlPoint(c)) {
                return new Vector3(direction.x * (bb.min.x - bb.max.x), direction.y * (bb.min.y - bb.max.y), direction.z * (bb.min.z - bb.max.z));
            }
            else {
                return new Vector3(direction.x, direction.y, direction.z);
            }
        }
        static convertAbsoluteDirectionToRelative(c, direction, bb) {
            if (isSketchControlPoint(c)) {
                return new Vector3(direction.x / (bb.min.x - bb.max.x), direction.y / (bb.min.y - bb.max.y), direction.z / (bb.min.z - bb.max.z));
            }
            else {
                return new Vector3(direction.x, direction.y, direction.z);
            }
        }
    }
    class BoundingBoxRelativeHelperKbVector {
        static convertRelativeToAbsolute(c, bb, position) {
            return exports.KbVector.FromVec3(BoundingBoxRelativeHelper.convertRelativeToAbsolute(c, bb, position));
        }
        static convertAbsoluteToRelative(c, bb, position) {
            return exports.KbVector.FromVec3(BoundingBoxRelativeHelper.convertAbsoluteToRelative(c, bb, position));
        }
        static convertRelativeDirectionToAbsolute(c, direction, bb) {
            return exports.KbVector.FromVec3(BoundingBoxRelativeHelper.convertRelativeDirectionToAbsolute(c, direction, bb));
        }
        static convertAbsoluteDirectionToRelative(c, direction, bb) {
            return exports.KbVector.FromVec3(BoundingBoxRelativeHelper.convertAbsoluteDirectionToRelative(c, direction, bb));
        }
    }

    (function (eSideOrientationBabylonMap) {
        eSideOrientationBabylonMap[eSideOrientationBabylonMap["frontSide"] = 0] = "frontSide";
        eSideOrientationBabylonMap[eSideOrientationBabylonMap["backSide"] = 1] = "backSide";
        eSideOrientationBabylonMap[eSideOrientationBabylonMap["doubleSide"] = 2] = "doubleSide";
    })(exports.eSideOrientationBabylonMap || (exports.eSideOrientationBabylonMap = {}));
    (function (eUvMapAxisBabylonMap) {
        eUvMapAxisBabylonMap[eUvMapAxisBabylonMap["x"] = 0] = "x";
        eUvMapAxisBabylonMap[eUvMapAxisBabylonMap["y"] = 1] = "y";
        eUvMapAxisBabylonMap[eUvMapAxisBabylonMap["z"] = 2] = "z";
    })(exports.eUvMapAxisBabylonMap || (exports.eUvMapAxisBabylonMap = {}));
    (function (eUvModeBabylonMap) {
        eUvModeBabylonMap[eUvModeBabylonMap["planar"] = 0] = "planar";
        eUvModeBabylonMap[eUvModeBabylonMap["box"] = 1] = "box";
        eUvModeBabylonMap[eUvModeBabylonMap["cylindrical"] = 2] = "cylindrical";
        eUvModeBabylonMap[eUvModeBabylonMap["spherical"] = 3] = "spherical";
    })(exports.eUvModeBabylonMap || (exports.eUvModeBabylonMap = {}));
    (function (eAlphaModeBabylonMap) {
        eAlphaModeBabylonMap[eAlphaModeBabylonMap["disable"] = 0] = "disable";
        eAlphaModeBabylonMap[eAlphaModeBabylonMap["add"] = 1] = "add";
        eAlphaModeBabylonMap[eAlphaModeBabylonMap["combine"] = 2] = "combine";
        eAlphaModeBabylonMap[eAlphaModeBabylonMap["subtract"] = 3] = "subtract";
        eAlphaModeBabylonMap[eAlphaModeBabylonMap["multiply"] = 4] = "multiply";
    })(exports.eAlphaModeBabylonMap || (exports.eAlphaModeBabylonMap = {}));

    function convertHdrToEnv(hdrFile, hdrSize) {
        return new Observable(subject => {
            const dataUri = URL.createObjectURL(hdrFile);
            const canvas = document.createElement('canvas');
            const dummyEngine = new Engine(canvas, true, {
                premultipliedAlpha: false,
            });
            const env = new HDRCubeTexture(dataUri, dummyEngine, hdrSize, false, true, false, true, () => {
                EnvironmentTextureTools.CreateEnvTextureAsync(env).then(buffer => {
                    URL.revokeObjectURL(dataUri);
                    dummyEngine.dispose();
                    subject.next(new Blob([buffer]));
                    subject.complete();
                });
            });
        });
        // return new Promise((resolve, reject) => {
        //     const env = new HDRCubeTexture(
        //         "textures/environment.hdr",
        //         scene,
        //         hdrSize,
        //         false,
        //         true,
        //         false,
        //         true,
        //         () => {
        //             console.log("environment loaded");
        //             EnvironmentTextureTools
        //                 .CreateEnvTextureAsync(env)
        //                 .then((buffer) => {
        //                     console.log(buffer);
        //                     console.log('success');
        //                     resolve(new Blob([buffer]));
        //                 })
        //         }
        //     );
        // });
    }

    function createLightVisualization(light, scene, color) {
        let lightPositionGizmo;
        if (!color) {
            color = Color3.Yellow();
        }
        if (light instanceof HemisphericLight) {
            lightPositionGizmo = SphereBuilder.CreateSphere('lightPositionMarker', { diameter: 0.75, slice: 0.5, segments: 6 }, scene);
            const coloredMaterial = new StandardMaterial('', scene);
            coloredMaterial.wireframe = true;
            coloredMaterial.emissiveColor = color;
            lightPositionGizmo.material = coloredMaterial;
        }
        else if (light instanceof SpotLight) {
            lightPositionGizmo = CylinderBuilder.CreateCylinder('lightPositionCone', { diameterTop: 0.5, height: 0.5, diameterBottom: 0, tessellation: 12 }, scene);
            lightPositionGizmo.position.y = 0.25;
            lightPositionGizmo.bakeCurrentTransformIntoVertices();
            const coloredMaterial = new StandardMaterial('', scene);
            coloredMaterial.wireframe = true;
            coloredMaterial.emissiveColor = color;
            lightPositionGizmo.material = coloredMaterial;
        }
        else if (light instanceof DirectionalLight) {
            const gizmoOffset = 1;
            lightPositionGizmo = GroundBuilder.CreateGround('lightPositionPlane', {
                height: 1.5,
                width: 1.5,
                subdivisions: 1,
            }, scene);
            const cone = CylinderBuilder.CreateCylinder('cylinder', { diameterTop: 0, height: 0.075, diameterBottom: 0.0375, tessellation: 96 }, scene);
            const line = CylinderBuilder.CreateCylinder('cylinder', { diameterTop: 0.005, height: 0.5, diameterBottom: 0.005, tessellation: 96 }, scene);
            const coloredMaterial = new StandardMaterial('', scene);
            coloredMaterial.wireframe = true;
            coloredMaterial.emissiveColor = color;
            lightPositionGizmo.material = coloredMaterial;
            cone.material = coloredMaterial;
            line.material = coloredMaterial;
            //cone.rotation.x = Math.PI / 2;
            lightPositionGizmo.position.y = -gizmoOffset;
            lightPositionGizmo.bakeCurrentTransformIntoVertices();
            cone.parent = lightPositionGizmo;
            line.parent = lightPositionGizmo;
            cone.position.y = 0.275 - gizmoOffset;
            line.position.y = -gizmoOffset;
            //line.rotation.x = Math.PI / 2;
        }
        else {
            // PointLight
            lightPositionGizmo = SphereBuilder.CreateSphere('lightPositionMarker', { diameter: 0.1 }, scene);
            const coloredMaterial = new StandardMaterial('', scene);
            coloredMaterial.emissiveColor = color;
            lightPositionGizmo.material = coloredMaterial;
        }
        lightPositionGizmo.isPickable = false;
        lightPositionGizmo.setEnabled(true);
        return lightPositionGizmo;
    }

    class Quad {
        constructor(capacity = 4) {
            this.capacity = capacity;
            this.points = new Array();
        }
    }
    class Boundary {
        constructor(xmin, xmax, ymin, ymax) {
            this.xmin = xmin;
            this.xmax = xmax;
            this.ymin = ymin;
            this.ymax = ymax;
        }
        boundaryContains(point) {
            return this.xmin <= point.x && this.xmax >= point.x && this.ymin <= point.y && this.ymax >= point.y;
        }
        intersects(b) {
            if (this.xmin >= b.xmax || b.xmin >= this.xmax || this.ymin >= b.ymax || b.ymin >= this.ymax) {
                return false;
            }
            return true;
        }
        get halfPoint() {
            return {
                x: this.xmin + this.width / 2,
                y: this.ymin + this.height / 2,
            };
        }
        get width() {
            return this.xmax - this.xmin;
        }
        get height() {
            return this.ymax - this.ymin;
        }
    }
    class QuadTree extends Boundary {
        constructor(o) {
            super(o.xmin, o.xmax, o.ymin, o.ymax);
            this.o = o;
            this.items = new Array();
            this.size = 0;
            this.duplicatesMap = {};
            this._divided = false;
            this.xSelector = o.xSelector;
            this.ySelector = o.ySelector;
            this.capacity = o.capacity;
            if (o.items) {
                for (const item of o.items)
                    this.add(item);
            }
        }
        get divided() {
            return this._divided;
        }
        get quads() {
            const arr = Array();
            if (this.nw)
                arr.push(this.nw);
            if (this.ne)
                arr.push(this.ne);
            if (this.sw)
                arr.push(this.sw);
            if (this.se)
                arr.push(this.se);
            return arr;
        }
        find(point, radius) {
            const b = new Boundary(point.x - radius, point.x + radius, point.y - radius, point.y + radius);
            const results = this.findByBoundary(b);
            //sort by proximity
            results.sortBy(r => r.proximity);
            return results;
        }
        findByBoundary(boundary) {
            const results = new Array();
            if (!this.intersects(boundary)) {
                return results;
            }
            if (this.divided) {
                for (const q of this.quads) {
                    results.push(...q.findByBoundary(boundary));
                }
            }
            else {
                //check items at this level
                for (const i of this.items) {
                    if (boundary.boundaryContains(this.itemPoint(i))) {
                        results.push(this.getWithProximity(i, boundary.halfPoint));
                    }
                }
            }
            return results;
        }
        getWithProximity(item, searchPoint) {
            const itemPoint = this.itemPoint(item);
            return {
                item: item,
                proximity: Math.sqrt(Math.pow(searchPoint.x - itemPoint.x, 2) + Math.pow(searchPoint.y - itemPoint.y, 2)),
            };
        }
        positionKey(point) {
            return point.x + ',' + point.y;
        }
        add(item) {
            const point = this.itemPoint(item);
            const key = this.positionKey(point);
            if (!this.boundaryContains(point)) {
                return false;
            }
            // If there is another point in this quad with the **exact** same position, add it to this quad as well.
            // This may result in overfilling the quad but there's no other way to handle exact duplicate points
            if (this.duplicatesMap[key]) {
                this.items.push(item);
                return true;
            }
            //if there is space for it, and no sub-divisions, add it to this quad
            if (this.size < this.o.capacity && !this.divided) {
                this.items.push(item);
                this.duplicatesMap[key] = item;
                this.size++;
                return true;
            }
            if (!this.divided) {
                this.subdivide();
            }
            for (const q of this.quads) {
                if (q.add(item))
                    return true;
            }
            throw Error('unexpected error creating quadtree');
        }
        subdivide() {
            // No need to check y, if x is infinitesimally small then y is as well
            if (this.xmax - this.xmin <= Number.EPSILON * 2) {
                throw Error('unexpected error creating quadtree. Not enough granularity');
            }
            this.nw = this.createDivision({
                items: this.items,
                xmin: this.xmin,
                xmax: this.halfPoint.x,
                ymin: this.ymin,
                ymax: this.halfPoint.y,
            });
            this.ne = this.createDivision({
                items: this.items,
                xmin: this.halfPoint.x + Number.EPSILON,
                xmax: this.xmax,
                ymin: this.ymin,
                ymax: this.halfPoint.y,
            });
            this.sw = this.createDivision({
                items: this.items,
                xmin: this.xmin,
                xmax: this.halfPoint.x,
                ymin: this.halfPoint.y + Number.EPSILON,
                ymax: this.ymax,
            });
            this.se = this.createDivision({
                items: this.items,
                xmin: this.halfPoint.x + Number.EPSILON,
                xmax: this.xmax,
                ymin: this.halfPoint.y + Number.EPSILON,
                ymax: this.ymax,
            });
            this.items.clear();
            this.size = 0;
            this._divided = true;
        }
        itemPoint(item) {
            return {
                x: this.xSelector(item),
                y: this.ySelector(item),
            };
        }
        createDivision(options) {
            return new QuadTree({
                ...this.o,
                ...options,
            });
        }
    }

    // @ts-nocheck third party library
    /* eslint-disable */
    function earcut$1(data, holeIndices, dim) {
        dim = dim || 2;
        var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev)
            return triangles;
        var minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles)
            outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for (var i = dim; i < outerLen; i += dim) {
                x = data[i];
                y = data[i + 1];
                if (x < minX)
                    minX = x;
                if (y < minY)
                    minY = y;
                if (x > maxX)
                    maxX = x;
                if (y > maxY)
                    maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
    // create a circular doubly linked list from polygon points in the specified winding order
    function linkedList(data, start, end, dim, clockwise) {
        var i, last;
        if (clockwise === signedArea(data, start, end, dim) > 0) {
            for (i = start; i < end; i += dim)
                last = insertNode(i, data[i], data[i + 1], last);
        }
        else {
            for (i = end - dim; i >= start; i -= dim)
                last = insertNode(i, data[i], data[i + 1], last);
        }
        if (last && equals(last, last.next)) {
            removeNode(last);
            last = last.next;
        }
        return last;
    }
    // eliminate colinear or duplicate points
    function filterPoints(start, end) {
        if (!start)
            return start;
        if (!end)
            end = start;
        var p = start, again;
        do {
            again = false;
            if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
                removeNode(p);
                p = end = p.prev;
                if (p === p.next)
                    break;
                again = true;
            }
            else {
                p = p.next;
            }
        } while (again || p !== end);
        return end;
    }
    // main ear slicing loop which triangulates a polygon (given as a linked list)
    function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
        if (!ear)
            return;
        // interlink polygon nodes in z-order
        if (!pass && invSize)
            indexCurve(ear, minX, minY, invSize);
        var stop = ear, prev, next;
        // iterate through ears, slicing them one by one
        while (ear.prev !== ear.next) {
            prev = ear.prev;
            next = ear.next;
            if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
                // cut off the triangle
                triangles.push((prev.i / dim) | 0);
                triangles.push((ear.i / dim) | 0);
                triangles.push((next.i / dim) | 0);
                removeNode(ear);
                // skipping the next vertex leads to less sliver triangles
                ear = next.next;
                stop = next.next;
                continue;
            }
            ear = next;
            // if we looped through the whole remaining polygon and can't find any more ears
            if (ear === stop) {
                // try filtering points and slicing again
                if (!pass) {
                    earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
                    // if this didn't work, try curing all small self-intersections locally
                }
                else if (pass === 1) {
                    ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                    earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
                    // as a last resort, try splitting the remaining polygon into two
                }
                else if (pass === 2) {
                    splitEarcut(ear, triangles, dim, minX, minY, invSize);
                }
                break;
            }
        }
    }
    // check whether a polygon node forms a valid ear with adjacent nodes
    function isEar(ear) {
        var a = ear.prev, b = ear, c = ear.next;
        if (area(a, b, c) >= 0)
            return false; // reflex, can't be an ear
        // now make sure we don't have other points inside the potential ear
        var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
        // triangle bbox; min & max are calculated like this for speed
        var x0 = ax < bx ? (ax < cx ? ax : cx) : bx < cx ? bx : cx, y0 = ay < by ? (ay < cy ? ay : cy) : by < cy ? by : cy, x1 = ax > bx ? (ax > cx ? ax : cx) : bx > cx ? bx : cx, y1 = ay > by ? (ay > cy ? ay : cy) : by > cy ? by : cy;
        var p = c.next;
        while (p !== a) {
            if (p.x >= x0 &&
                p.x <= x1 &&
                p.y >= y0 &&
                p.y <= y1 &&
                pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) &&
                area(p.prev, p, p.next) >= 0)
                return false;
            p = p.next;
        }
        return true;
    }
    function isEarHashed(ear, minX, minY, invSize) {
        var a = ear.prev, b = ear, c = ear.next;
        if (area(a, b, c) >= 0)
            return false; // reflex, can't be an ear
        var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
        // triangle bbox; min & max are calculated like this for speed
        var x0 = ax < bx ? (ax < cx ? ax : cx) : bx < cx ? bx : cx, y0 = ay < by ? (ay < cy ? ay : cy) : by < cy ? by : cy, x1 = ax > bx ? (ax > cx ? ax : cx) : bx > cx ? bx : cx, y1 = ay > by ? (ay > cy ? ay : cy) : by > cy ? by : cy;
        // z-order range for the current triangle bbox;
        var minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
        var p = ear.prevZ, n = ear.nextZ;
        // look for points inside the triangle in both directions
        while (p && p.z >= minZ && n && n.z <= maxZ) {
            if (p.x >= x0 &&
                p.x <= x1 &&
                p.y >= y0 &&
                p.y <= y1 &&
                p !== a &&
                p !== c &&
                pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) &&
                area(p.prev, p, p.next) >= 0)
                return false;
            p = p.prevZ;
            if (n.x >= x0 &&
                n.x <= x1 &&
                n.y >= y0 &&
                n.y <= y1 &&
                n !== a &&
                n !== c &&
                pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) &&
                area(n.prev, n, n.next) >= 0)
                return false;
            n = n.nextZ;
        }
        // look for remaining points in decreasing z-order
        while (p && p.z >= minZ) {
            if (p.x >= x0 &&
                p.x <= x1 &&
                p.y >= y0 &&
                p.y <= y1 &&
                p !== a &&
                p !== c &&
                pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) &&
                area(p.prev, p, p.next) >= 0)
                return false;
            p = p.prevZ;
        }
        // look for remaining points in increasing z-order
        while (n && n.z <= maxZ) {
            if (n.x >= x0 &&
                n.x <= x1 &&
                n.y >= y0 &&
                n.y <= y1 &&
                n !== a &&
                n !== c &&
                pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) &&
                area(n.prev, n, n.next) >= 0)
                return false;
            n = n.nextZ;
        }
        return true;
    }
    // go through all polygon nodes and cure small local self-intersections
    function cureLocalIntersections(start, triangles, dim) {
        var p = start;
        do {
            var a = p.prev, b = p.next.next;
            if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
                triangles.push((a.i / dim) | 0);
                triangles.push((p.i / dim) | 0);
                triangles.push((b.i / dim) | 0);
                // remove two nodes involved
                removeNode(p);
                removeNode(p.next);
                p = start = b;
            }
            p = p.next;
        } while (p !== start);
        return filterPoints(p);
    }
    // try splitting polygon into two and triangulate them independently
    function splitEarcut(start, triangles, dim, minX, minY, invSize) {
        // look for a valid diagonal that divides the polygon into two
        var a = start;
        do {
            var b = a.next.next;
            while (b !== a.prev) {
                if (a.i !== b.i && isValidDiagonal(a, b)) {
                    // split the polygon in two by the diagonal
                    var c = splitPolygon(a, b);
                    // filter colinear points around the cuts
                    a = filterPoints(a, a.next);
                    c = filterPoints(c, c.next);
                    // run earcut on each half
                    earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                    earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                    return;
                }
                b = b.next;
            }
            a = a.next;
        } while (a !== start);
    }
    // link every hole into the outer loop, producing a single-ring polygon without holes
    function eliminateHoles(data, holeIndices, outerNode, dim) {
        var queue = [], i, len, start, end, list;
        for (i = 0, len = holeIndices.length; i < len; i++) {
            start = holeIndices[i] * dim;
            end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            list = linkedList(data, start, end, dim, false);
            if (list === list.next)
                list.steiner = true;
            queue.push(getLeftmost(list));
        }
        queue.sort(compareX);
        // process holes from left to right
        for (i = 0; i < queue.length; i++) {
            outerNode = eliminateHole(queue[i], outerNode);
        }
        return outerNode;
    }
    function compareX(a, b) {
        return a.x - b.x;
    }
    // find a bridge between vertices that connects hole with an outer ring and and link it
    function eliminateHole(hole, outerNode) {
        var bridge = findHoleBridge(hole, outerNode);
        if (!bridge) {
            return outerNode;
        }
        var bridgeReverse = splitPolygon(bridge, hole);
        // filter collinear points around the cuts
        filterPoints(bridgeReverse, bridgeReverse.next);
        return filterPoints(bridge, bridge.next);
    }
    // David Eberly's algorithm for finding a bridge between hole and outer polygon
    function findHoleBridge(hole, outerNode) {
        var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
        // find a segment intersected by a ray from the hole's leftmost point to the left;
        // segment's endpoint with lesser x will be potential connection point
        do {
            if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
                var x = p.x + ((hy - p.y) * (p.next.x - p.x)) / (p.next.y - p.y);
                if (x <= hx && x > qx) {
                    qx = x;
                    m = p.x < p.next.x ? p : p.next;
                    if (x === hx)
                        return m; // hole touches outer segment; pick leftmost endpoint
                }
            }
            p = p.next;
        } while (p !== outerNode);
        if (!m)
            return null;
        // look for points inside the triangle of hole point, segment intersection and endpoint;
        // if there are no points found, we have a valid connection;
        // otherwise choose the point of the minimum angle with the ray as connection point
        var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
        p = m;
        do {
            if (hx >= p.x &&
                p.x >= mx &&
                hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
                tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
                if (locallyInside(p, hole) &&
                    (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                    m = p;
                    tanMin = tan;
                }
            }
            p = p.next;
        } while (p !== stop);
        return m;
    }
    // whether sector in vertex m contains sector in vertex p in the same coordinates
    function sectorContainsSector(m, p) {
        return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
    }
    // interlink polygon nodes in z-order
    function indexCurve(start, minX, minY, invSize) {
        var p = start;
        do {
            if (p.z === 0)
                p.z = zOrder(p.x, p.y, minX, minY, invSize);
            p.prevZ = p.prev;
            p.nextZ = p.next;
            p = p.next;
        } while (p !== start);
        p.prevZ.nextZ = null;
        p.prevZ = null;
        sortLinked(p);
    }
    // Simon Tatham's linked list merge sort algorithm
    // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
    function sortLinked(list) {
        var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
        do {
            p = list;
            list = null;
            tail = null;
            numMerges = 0;
            while (p) {
                numMerges++;
                q = p;
                pSize = 0;
                for (i = 0; i < inSize; i++) {
                    pSize++;
                    q = q.nextZ;
                    if (!q)
                        break;
                }
                qSize = inSize;
                while (pSize > 0 || (qSize > 0 && q)) {
                    if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                        e = p;
                        p = p.nextZ;
                        pSize--;
                    }
                    else {
                        e = q;
                        q = q.nextZ;
                        qSize--;
                    }
                    if (tail)
                        tail.nextZ = e;
                    else
                        list = e;
                    e.prevZ = tail;
                    tail = e;
                }
                p = q;
            }
            tail.nextZ = null;
            inSize *= 2;
        } while (numMerges > 1);
        return list;
    }
    // z-order of a point given coords and inverse of the longer side of data bbox
    function zOrder(x, y, minX, minY, invSize) {
        // coords are transformed into non-negative 15-bit integer range
        x = ((x - minX) * invSize) | 0;
        y = ((y - minY) * invSize) | 0;
        x = (x | (x << 8)) & 0x00ff00ff;
        x = (x | (x << 4)) & 0x0f0f0f0f;
        x = (x | (x << 2)) & 0x33333333;
        x = (x | (x << 1)) & 0x55555555;
        y = (y | (y << 8)) & 0x00ff00ff;
        y = (y | (y << 4)) & 0x0f0f0f0f;
        y = (y | (y << 2)) & 0x33333333;
        y = (y | (y << 1)) & 0x55555555;
        return x | (y << 1);
    }
    // find the leftmost node of a polygon ring
    function getLeftmost(start) {
        var p = start, leftmost = start;
        do {
            if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y))
                leftmost = p;
            p = p.next;
        } while (p !== start);
        return leftmost;
    }
    // check if a point lies within a convex triangle
    function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
        return ((cx - px) * (ay - py) >= (ax - px) * (cy - py) &&
            (ax - px) * (by - py) >= (bx - px) * (ay - py) &&
            (bx - px) * (cy - py) >= (cx - px) * (by - py));
    }
    // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
    function isValidDiagonal(a, b) {
        return (a.next.i !== b.i &&
            a.prev.i !== b.i &&
            !intersectsPolygon(a, b) && // dones't intersect other edges
            ((locallyInside(a, b) &&
                locallyInside(b, a) &&
                middleInside(a, b) && // locally visible
                (area(a.prev, a, b.prev) || area(a, b.prev, b))) || // does not create opposite-facing sectors
                (equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0))); // special zero-length case
    }
    // signed area of a triangle
    function area(p, q, r) {
        return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
    }
    // check if two points are equal
    function equals(p1, p2) {
        return p1.x === p2.x && p1.y === p2.y;
    }
    // check if two segments intersect
    function intersects(p1, q1, p2, q2) {
        var o1 = sign(area(p1, q1, p2));
        var o2 = sign(area(p1, q1, q2));
        var o3 = sign(area(p2, q2, p1));
        var o4 = sign(area(p2, q2, q1));
        if (o1 !== o2 && o3 !== o4)
            return true; // general case
        if (o1 === 0 && onSegment(p1, p2, q1))
            return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
        if (o2 === 0 && onSegment(p1, q2, q1))
            return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
        if (o3 === 0 && onSegment(p2, p1, q2))
            return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
        if (o4 === 0 && onSegment(p2, q1, q2))
            return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
        return false;
    }
    // for collinear points p, q, r, check if point q lies on segment pr
    function onSegment(p, q, r) {
        return (q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y));
    }
    function sign(num) {
        return num > 0 ? 1 : num < 0 ? -1 : 0;
    }
    // check if a polygon diagonal intersects any polygon segments
    function intersectsPolygon(a, b) {
        var p = a;
        do {
            if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b))
                return true;
            p = p.next;
        } while (p !== a);
        return false;
    }
    // check if a polygon diagonal is locally inside the polygon
    function locallyInside(a, b) {
        return area(a.prev, a, a.next) < 0
            ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0
            : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
    }
    // check if the middle point of a polygon diagonal is inside the polygon
    function middleInside(a, b) {
        var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
        do {
            if (p.y > py !== p.next.y > py &&
                p.next.y !== p.y &&
                px < ((p.next.x - p.x) * (py - p.y)) / (p.next.y - p.y) + p.x)
                inside = !inside;
            p = p.next;
        } while (p !== a);
        return inside;
    }
    // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
    // if one belongs to the outer ring and another to a hole, it merges it into a single ring
    function splitPolygon(a, b) {
        var a2 = new Node$1(a.i, a.x, a.y), b2 = new Node$1(b.i, b.x, b.y), an = a.next, bp = b.prev;
        a.next = b;
        b.prev = a;
        a2.next = an;
        an.prev = a2;
        b2.next = a2;
        a2.prev = b2;
        bp.next = b2;
        b2.prev = bp;
        return b2;
    }
    // create a node and optionally link it with previous one (in a circular doubly linked list)
    function insertNode(i, x, y, last) {
        var p = new Node$1(i, x, y);
        if (!last) {
            p.prev = p;
            p.next = p;
        }
        else {
            p.next = last.next;
            p.prev = last;
            last.next.prev = p;
            last.next = p;
        }
        return p;
    }
    function removeNode(p) {
        p.next.prev = p.prev;
        p.prev.next = p.next;
        if (p.prevZ)
            p.prevZ.nextZ = p.nextZ;
        if (p.nextZ)
            p.nextZ.prevZ = p.prevZ;
    }
    function Node$1(i, x, y) {
        // vertex index in coordinates array
        this.i = i;
        // vertex coordinates
        this.x = x;
        this.y = y;
        // previous and next vertex nodes in a polygon ring
        this.prev = null;
        this.next = null;
        // z-order curve value
        this.z = 0;
        // previous and next nodes in z-order
        this.prevZ = null;
        this.nextZ = null;
        // indicates whether this is a steiner point
        this.steiner = false;
    }
    // return a percentage difference between the polygon area and its triangulation area;
    // used to verify correctness of triangulation
    earcut$1.deviation = function (data, holeIndices, dim, triangles) {
        var hasHoles = holeIndices && holeIndices.length;
        var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
        if (hasHoles) {
            for (var i = 0, len = holeIndices.length; i < len; i++) {
                var start = holeIndices[i] * dim;
                var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                polygonArea -= Math.abs(signedArea(data, start, end, dim));
            }
        }
        var trianglesArea = 0;
        for (i = 0; i < triangles.length; i += 3) {
            var a = triangles[i] * dim;
            var b = triangles[i + 1] * dim;
            var c = triangles[i + 2] * dim;
            trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
        }
        return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
    };
    function signedArea(data, start, end, dim) {
        var sum = 0;
        for (var i = start, j = end - dim; i < end; i += dim) {
            sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
            j = i;
        }
        return sum;
    }
    // turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
    earcut$1.flatten = function (data) {
        var dim = data[0][0].length, result = { vertices: [], holes: [], dimensions: dim }, holeIndex = 0;
        for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].length; j++) {
                for (var d = 0; d < dim; d++)
                    result.vertices.push(data[i][j][d]);
            }
            if (i > 0) {
                holeIndex += data[i - 1].length;
                result.holes.push(holeIndex);
            }
        }
        return result;
    };

    class SubmeshVertexData extends VertexData {
        constructor() {
            super();
            this.indices = null;
            this.positions = null;
            this.normals = null;
            this.tangents = null;
            this.submeshData = null;
        }
        /**
         * @param kbGeometry the kbGeometry to copy the vertex data from.
         * Note that this copipes the vertex data by reference, so mutating the data WILL modify the kbGeometry.
         */
        static FromGeometry(kbGeometry) {
            const result = new SubmeshVertexData();
            result.indices = kbGeometry.indices || null;
            result.positions = kbGeometry.positions || null;
            result.normals = kbGeometry.normals || null;
            result.tangents = kbGeometry.tangents || null;
            result.uvs = kbGeometry.uvs || null;
            result.submeshData = [
                {
                    materialIndex: 0,
                    verticesStart: 0,
                    verticesCount: kbGeometry.positions ? kbGeometry.positions.length / 3 : 0,
                    indexStart: 0,
                    indexCount: kbGeometry.indices ? kbGeometry.indices.length : 0,
                },
            ];
            return result;
        }
        static ExtractFromMesh(mesh, copyWhenShared, forceCopy) {
            const result = new SubmeshVertexData();
            const vertexData = super.ExtractFromMesh(mesh, copyWhenShared, forceCopy);
            SubmeshVertexData.CopyToRef(vertexData, result);
            if (mesh.subMeshes) {
                result.submeshData = extractSubmeshData(mesh.subMeshes);
            }
            if (mesh.metadata && mesh.metadata['paths']) {
                result.paths = copyWhenShared ? mesh.metadata['paths'].slice() : mesh.metadata['paths'];
            }
            if (mesh.metadata && mesh.metadata['holes']) {
                result.holes = copyWhenShared ? mesh.metadata['holes'].slice() : mesh.metadata['holes'];
            }
            return result;
        }
        static CopyToRef(source, target) {
            target.positions = source.positions || null;
            if ('paths' in source) {
                target.paths = source.paths || null;
            }
            if ('holes' in source) {
                target.holes = source.holes || null;
            }
            target.normals = source.normals || null;
            target.tangents = source.tangents || null;
            target.uvs = source.uvs || null;
            target.uvs2 = source.uvs2 || null;
            target.uvs3 = source.uvs3 || null;
            target.uvs4 = source.uvs4 || null;
            target.uvs5 = source.uvs5 || null;
            target.uvs6 = source.uvs6 || null;
            target.colors = source.colors || null;
            target.matricesIndices = source.matricesIndices || null;
            target.matricesWeights = source.matricesWeights || null;
            target.matricesIndicesExtra = source.matricesIndicesExtra || null;
            target.matricesWeightsExtra = source.matricesWeightsExtra || null;
            target.indices = source.indices || null;
            target.submeshData = source.submeshData;
        }
        static ExtendToRef(source, target) {
            if (source.positions !== undefined)
                target.positions = source.positions;
            if ('paths' in source && source.paths !== undefined)
                target.paths = source.paths;
            if ('holes' in source && source.holes !== undefined)
                target.holes = source.holes;
            if (source.normals !== undefined)
                target.normals = source.normals;
            if (source.tangents !== undefined)
                target.tangents = source.tangents;
            if (source.uvs !== undefined)
                target.uvs = source.uvs;
            if (source.uvs2 !== undefined)
                target.uvs2 = source.uvs2;
            if (source.uvs3 !== undefined)
                target.uvs3 = source.uvs3;
            if (source.uvs4 !== undefined)
                target.uvs4 = source.uvs4;
            if (source.uvs5 !== undefined)
                target.uvs5 = source.uvs5;
            if (source.uvs6 !== undefined)
                target.uvs6 = source.uvs6;
            if (source.colors !== undefined)
                target.colors = source.colors;
            if (source.matricesIndices !== undefined)
                target.matricesIndices = source.matricesIndices;
            if (source.matricesWeights !== undefined)
                target.matricesWeights = source.matricesWeights;
            if (source.matricesIndicesExtra !== undefined)
                target.matricesIndicesExtra = source.matricesIndicesExtra;
            if (source.matricesWeightsExtra !== undefined)
                target.matricesWeightsExtra = source.matricesWeightsExtra;
            if (source.indices !== undefined)
                target.indices = source.indices;
            if (source.submeshData !== undefined) {
                target.submeshData = source.submeshData;
            }
        }
        deepClone() {
            const result = new SubmeshVertexData();
            result.indices = this.indices ? this.indices.slice() : null;
            result.positions = this.positions ? this.positions.slice() : null;
            result.paths = this.paths ? this.paths.slice() : null;
            result.holes = this.holes ? this.holes.slice() : null;
            result.normals = this.normals ? this.normals.slice() : null;
            result.tangents = this.tangents ? this.tangents.slice() : null;
            result.uvs = this.uvs ? this.uvs.slice() : null;
            result.submeshData = this.submeshData ? JSON.parse(JSON.stringify(this.submeshData)) : undefined;
            return result;
        }
        shallowClone() {
            const result = new SubmeshVertexData();
            SubmeshVertexData.CopyToRef(this, result);
            return result;
        }
        copyFrom(source) {
            SubmeshVertexData.CopyToRef(source, this);
        }
        merge(others, use32BitsIndices, forceCloneIndices, mergeMaterialIds, enableCompletion) {
            if (!Array.isArray(others)) {
                others = [others];
            }
            let pathIdxOffset = this.paths ? this.paths.length : 0;
            let segmentIdxOffset = 0;
            let vertexIdxOffset = this.positions ? this.positions.length / 3 : 0;
            const newPaths = [];
            const newHoles = [];
            if (this.paths) {
                for (let i = 2; i < this.paths.length; i += 2) {
                    if (this.paths[i] !== this.paths[i - 1]) {
                        segmentIdxOffset++;
                    }
                }
                if (this.holes) {
                    segmentIdxOffset -= this.holes.length / 2;
                }
                segmentIdxOffset++;
            }
            others.map(other => {
                if (other.holes) {
                    for (let i = 0; i < other.holes.length; i += 2) {
                        newHoles.push(other.holes[i] + segmentIdxOffset, other.holes[i + 1] + pathIdxOffset);
                    }
                    segmentIdxOffset -= other.holes.length / 2;
                }
                if (other.paths) {
                    for (let i = 0; i < other.paths.length; i++) {
                        newPaths.push(other.paths[i] + vertexIdxOffset);
                    }
                    for (let i = 2; i < other.paths.length; i += 2) {
                        if (other.paths[i] !== other.paths[i - 1]) {
                            segmentIdxOffset++;
                        }
                    }
                    segmentIdxOffset++;
                }
                vertexIdxOffset += other.positions ? other.positions.length / 3 : 0;
                pathIdxOffset += other.paths ? other.paths.length : 0;
            });
            super.merge(others, use32BitsIndices, true, mergeMaterialIds, enableCompletion);
            if (newHoles.length) {
                if (!this.holes) {
                    this.holes = new Int32Array();
                }
                if ('push' in this.holes) {
                    for (let i = 0; i < newHoles.length; i++) {
                        this.holes.push(newHoles[i]);
                    }
                }
                else {
                    const newArr = new Int32Array(this.holes.length + newHoles.length);
                    newArr.set(this.holes);
                    newArr.set(newHoles, this.holes.length);
                    this.holes = newArr;
                }
            }
            if (newPaths.length) {
                if (!this.paths) {
                    this.paths = new Int32Array();
                }
                if ('push' in this.paths) {
                    for (let i = 0; i < newPaths.length; i++) {
                        this.paths.push(newPaths[i]);
                    }
                }
                else {
                    const newArr = new Int32Array(this.paths.length + newPaths.length);
                    newArr.set(this.paths);
                    newArr.set(newPaths, this.paths.length);
                    this.paths = newArr;
                }
            }
            return this;
        }
        applyToMesh(mesh, updatable = true, writeSubmeshes = true) {
            if (!this.submeshData && writeSubmeshes && mesh.subMeshes && mesh.subMeshes.length > 1) {
                this.submeshData = extractSubmeshData(mesh.subMeshes);
            }
            const result = super.applyToMesh(mesh, updatable);
            if (this.paths) {
                if (!mesh.metadata) {
                    mesh.metadata = {};
                }
                mesh.metadata['paths'] = this.paths.slice();
            }
            if (this.holes) {
                if (!mesh.metadata) {
                    mesh.metadata = {};
                }
                mesh.metadata['holes'] = this.holes.slice();
            }
            if (mesh.geometry) {
                // Applying geometry doesn't remove vertex types if they are unset so remove them manually
                if (!this.normals) {
                    mesh.geometry.removeVerticesData(VertexBuffer.NormalKind);
                }
                if (!this.uvs) {
                    mesh.geometry.removeVerticesData(VertexBuffer.UVKind);
                }
            }
            if (writeSubmeshes) {
                if (this.submeshData) {
                    mesh.subMeshes = [];
                    this.submeshData.forEach(submesh => {
                        // SubMeshes add themselves to the mesh
                        new SubMesh(submesh.materialIndex, submesh.verticesStart, submesh.verticesCount, submesh.indexStart, submesh.indexCount, mesh);
                    });
                }
            }
            else {
                this.submeshData = extractSubmeshData(mesh.subMeshes);
            }
            return result;
        }
    }
    function extractSubmeshData(subMeshes) {
        return subMeshes.map(submesh => {
            return {
                materialIndex: submesh.materialIndex,
                verticesStart: submesh.verticesStart,
                verticesCount: submesh.verticesCount,
                indexStart: submesh.indexStart,
                indexCount: submesh.indexCount,
            };
        });
    }
    /**
     * @param vertexData
     * @returns null if geometry is valid, string if invalid
     */
    function verifyGeometry(vertexData) {
        let outputError = null;
        if (vertexData.indices && vertexData.positions && vertexData.indices.length > 0) {
            const indicesCount = vertexData.indices.length;
            const vertexCount = vertexData.positions.length / 3;
            if (vertexData.submeshData) {
                vertexData.submeshData.forEach(submesh => {
                    if (submesh.indexStart + submesh.indexCount > indicesCount ||
                        submesh.verticesStart + submesh.verticesCount > vertexCount) {
                        outputError = 'submeshes';
                    }
                });
            }
            if (!outputError) {
                const c = vertexData.indices.length;
                let maxVertex = -1;
                for (let i = 0; i < c; i++) {
                    maxVertex = Math.max(maxVertex, vertexData.indices[i]);
                }
                if (maxVertex > vertexData.positions.length / 3) {
                    outputError = 'vertices';
                }
            }
        }
        return outputError;
    }
    function getPolygonNormal(_points) {
        const normal = Vector3.Zero();
        if (!_points) {
            return normal;
        }
        if (typeof _points[0] === 'number') {
            const points = _points;
            if (points.length < 9) {
                return normal;
            }
            const p1 = Vector3.Zero();
            const p2 = Vector3.Zero();
            let i = 0;
            while (p1.length() === 0 && points.length > i + 5) {
                p1.set(points[i + 3], points[i + 4], points[i + 5]);
                p1.subtractFromFloatsToRef(points[i], points[i + 1], points[i + 2], p1);
                i += 3;
            }
            p2.set(points[i], points[i + 1], points[i + 2]);
            while (normal.length() === 0 && points.length > i + 3) {
                p2.set(points[i + 3], points[i + 4], points[i + 5]);
                p2.subtractFromFloatsToRef(points[i], points[i + 1], points[i + 2], p2);
                Vector3.CrossToRef(p1, p2, normal);
                i += 3;
            }
        }
        else {
            const points = _points;
            if (points.length < 3) {
                return normal;
            }
            const p1 = Vector3.Zero();
            const p2 = Vector3.Zero();
            let i = 0;
            while (p1.length() === 0 && points.length > i + 1) {
                p1.copyFrom(points[i + 1]);
                p1.subtractInPlace(points[i]);
                i++;
            }
            while (normal.length() === 0 && points.length > i + 1) {
                p2.copyFrom(points[i + 1]);
                p2.subtractInPlace(points[i]);
                Vector3.CrossToRef(p1, p2, normal);
                i++;
            }
        }
        return normal.normalize();
    }

    const MAX_BEZIER_STEPS = 10;
    const BEZIER_STEP_SIZE = 20.0;
    const GLYPH_COORDS_SCALE = 0.0005;
    const IDENTITY_Q = Quaternion.Identity();
    // class for converting path commands into point data
    class TextMeshPolygon {
        constructor() {
            this.points = [];
            this.children = [];
            this.area = 0.0;
        }
        distance(p1, p2) {
            const dx = p1.x - p2.x, dy = p1.y - p2.y;
            return Math.sqrt(dx * dx + dy * dy);
        }
        lerp(p1, p2, t) {
            return { x: (1 - t) * p1.x + t * p2.x, y: (1 - t) * p1.y + t * p2.y };
        }
        cross(p1, p2) {
            return p1.x * p2.y - p1.y * p2.x;
        }
        moveTo(p) {
            this.points.push(p);
        }
        lineTo(p) {
            this.points.push(p);
        }
        close() {
            let cur = this.points[this.points.length - 1];
            this.points.forEach(next => {
                this.area += 0.5 * this.cross(cur, next);
                cur = next;
            });
        }
        conicTo(p, p1) {
            const p0 = this.points[this.points.length - 1];
            const dist = this.distance(p0, p1) + this.distance(p1, p);
            const steps = Math.max(2, Math.min(MAX_BEZIER_STEPS, dist / BEZIER_STEP_SIZE));
            for (let i = 1; i <= steps; ++i) {
                const t = i / steps;
                this.points.push(this.lerp(this.lerp(p0, p1, t), this.lerp(p1, p, t), t));
            }
        }
        cubicTo(p, p1, p2) {
            const p0 = this.points[this.points.length - 1];
            const dist = this.distance(p0, p1) + this.distance(p1, p2) + this.distance(p2, p);
            const steps = Math.max(2, Math.min(MAX_BEZIER_STEPS, dist / BEZIER_STEP_SIZE));
            for (let i = 1; i <= steps; ++i) {
                const t = i / steps;
                const a = this.lerp(this.lerp(p0, p1, t), this.lerp(p1, p2, t), t);
                const b = this.lerp(this.lerp(p1, p2, t), this.lerp(p2, p, t), t);
                this.points.push(this.lerp(a, b, t));
            }
        }
        inside(p) {
            const epsilon = 1e-6;
            let count = 0, cur = this.points[this.points.length - 1];
            this.points.forEach(next => {
                const p0 = cur.y < next.y ? cur : next;
                const p1 = cur.y < next.y ? next : cur;
                if (p0.y < p.y + epsilon && p1.y > p.y + epsilon) {
                    if ((p1.x - p0.x) * (p.y - p0.y) > (p.x - p0.x) * (p1.y - p0.y)) {
                        count++;
                    }
                }
                cur = next;
            });
            return count % 2 !== 0;
        }
    }
    class TextMeshFont {
        constructor(name, font, scene) {
            this.font = font;
            this.scene = scene;
            this.glyphs = {};
            this.font = font;
            this.glyphsParent = new Mesh(name, scene);
        }
        createGlyph(ch) {
            if (this.glyphs[ch]) {
                return this.glyphs[ch];
            }
            const glyph = this.font.charToGlyph(ch);
            if (!glyph || !glyph.advanceWidth) {
                return undefined;
            }
            this.glyphs[ch] = {
                index: glyph.index,
                advanceWidth: glyph.advanceWidth,
                boundingBox: glyph.getBoundingBox(),
            };
            const glyphDef = this.glyphs[ch];
            if (!glyph.path || !glyph.path.commands || !glyph.path.commands.length) {
                return glyphDef;
            }
            const polys = [];
            glyph.path.commands.forEach(command => {
                const { type, x, y, x1, y1, x2, y2 } = command;
                switch (type) {
                    case 'M':
                        polys.push(new TextMeshPolygon());
                        polys[polys.length - 1].moveTo({ x, y });
                        break;
                    case 'L':
                        polys[polys.length - 1].moveTo({ x, y });
                        break;
                    case 'C':
                        polys[polys.length - 1].cubicTo({ x, y }, { x: x1, y: y1 }, { x: x2, y: y2 });
                        break;
                    case 'Q':
                        polys[polys.length - 1].conicTo({ x, y }, { x: x1, y: y1 });
                        break;
                    case 'Z':
                        polys[polys.length - 1].close();
                        break;
                }
            });
            // sort contours by descending area
            polys.sort((a, b) => Math.abs(b.area) - Math.abs(a.area));
            // classify contours to find holes and their 'parents'
            const root = [];
            for (let i = 0; i < polys.length; ++i) {
                let parent = null;
                for (let j = i - 1; j >= 0; --j) {
                    // a contour is a hole if it is inside its parent and has different winding
                    if (polys[j].inside(polys[i].points[0]) && polys[i].area * polys[j].area < 0) {
                        parent = polys[j];
                        break;
                    }
                }
                if (parent) {
                    parent.children.push(polys[i]);
                }
                else {
                    root.push(polys[i]);
                }
            }
            const totalPoints = polys.reduce((sum, p) => sum + p.points.length, 0);
            const vertexData = new Float32Array(totalPoints * 2);
            let vertexCount = 0;
            let pathSegmentCount = 0;
            const indices = [];
            const paths = [];
            const holePaths = [];
            function process(poly) {
                // construct input for earcut
                const coords = [];
                const holes = [];
                const n = poly.points.length - 1;
                for (let i = 0; i < n; ++i) {
                    const { x, y } = poly.points[n - i];
                    if (i > 0) {
                        const idx = coords.length / 2;
                        paths.push(vertexCount + idx - 1, vertexCount + idx);
                    }
                    coords.push(x, y);
                }
                const parentSegmentIdx = pathSegmentCount;
                poly.children.forEach((child, i) => {
                    // children's children are new, separate shapes
                    child.children.forEach(process);
                    // idx 0 of a hole is the segment index of the segment the hole is inside. each separate poly is a separate segment
                    holePaths.push(parentSegmentIdx, paths.length);
                    holes.push(coords.length / 2);
                    const n = child.points.length - 1;
                    for (let i = 0; i < n; ++i) {
                        const { x, y } = child.points[i];
                        if (i > 0) {
                            const idx = coords.length / 2;
                            paths.push(idx - 1, idx);
                        }
                        coords.push(x, y);
                    }
                    pathSegmentCount++;
                });
                // add vertex data
                vertexData.set(coords, vertexCount * 2);
                // add index data
                earcut$1(coords, holes).forEach(i => {
                    indices.push(i + vertexCount);
                });
                vertexCount += coords.length / 2;
                pathSegmentCount++;
            }
            root.forEach(process);
            const meshdata = new SubmeshVertexData();
            const vertices = [];
            const normals = [];
            for (let i = 0; i < vertexCount; i++) {
                vertices.push(vertexData[i * 2] * GLYPH_COORDS_SCALE);
                vertices.push(vertexData[i * 2 + 1] * GLYPH_COORDS_SCALE);
                vertices.push(0);
                normals.push(0);
                normals.push(0);
                normals.push(1);
            }
            const flipIndices = [];
            for (let i = 0; i < indices.length; i += 3) {
                flipIndices.push(indices[i], indices[i + 2], indices[i + 1]);
            }
            meshdata.positions = vertices;
            meshdata.indices = flipIndices;
            meshdata.normals = normals;
            meshdata.paths = paths;
            meshdata.holes = holePaths;
            glyphDef.vertexData = meshdata;
            return glyphDef;
        }
    }
    class TextMeshVertexData {
        constructor(textMeshFont) {
            this.textMeshFont = textMeshFont;
            this.instances = {};
        }
        getText(text, fontSize = 1, charSpacing = 1, radius = 0) {
            radius = radius / fontSize;
            const scaleMatrix = Matrix.Compose(new Vector3(fontSize, fontSize, 1), IDENTITY_Q, Vector3.ZeroReadOnly);
            const vertexData = new SubmeshVertexData();
            const pos = Vector3.Zero();
            const transformMatrix = Matrix.Identity();
            const generatedVertices = [];
            for (let i = 0; i < text.length; i++) {
                const ch1 = text[i];
                if (ch1 === '\n') {
                    pos.x = 0;
                    pos.y -= 1.1;
                    continue;
                }
                transformMatrix.setTranslation(pos);
                const ch2 = text[i + 1];
                const g = this.textMeshFont.createGlyph(ch1);
                if (!g) {
                    continue;
                }
                let advance = g.advanceWidth;
                if (g.vertexData) {
                    generatedVertices.push({
                        data: g.vertexData.deepClone(),
                        transform: transformMatrix.clone(),
                        center: (advance / 2 + g.boundingBox.x1) * GLYPH_COORDS_SCALE,
                    });
                }
                if (advance) {
                    if (ch2 && this.textMeshFont.glyphs[ch2]) {
                        const kern = this.textMeshFont.font.getKerningValue(g.index, this.textMeshFont.glyphs[ch2].index);
                        if (kern) {
                            advance += kern;
                        }
                    }
                    pos.x += (advance - g.boundingBox.x2 + g.boundingBox.x2 * charSpacing) * GLYPH_COORDS_SCALE;
                }
            }
            if (generatedVertices.length > 0) {
                const centerTransform = Matrix.Compose(Vector3.OneReadOnly, IDENTITY_Q, pos.scale(-0.5));
                for (const generatedVertexData of generatedVertices) {
                    const transform = generatedVertexData.transform;
                    transform.multiplyToRef(centerTransform, transform);
                    // Add curve to text
                    if (radius !== 0) {
                        const baseOffset = transform.getTranslation();
                        const angle = (baseOffset.x + generatedVertexData.center) / radius;
                        const pivotMatrix = Matrix.Compose(Vector3.OneReadOnly, IDENTITY_Q, new Vector3(generatedVertexData.center, -radius, 0));
                        const rotMatrix = Matrix.Compose(Vector3.OneReadOnly, Quaternion.RotationAxis(new Vector3(0, 0, -1), angle), Vector3.ZeroReadOnly);
                        const curveTransform = pivotMatrix.clone().invert();
                        curveTransform.multiplyToRef(rotMatrix, curveTransform);
                        curveTransform.multiplyToRef(pivotMatrix, curveTransform);
                        curveTransform.setTranslation(curveTransform.getTranslation().addInPlaceFromFloats(-generatedVertexData.center, 0, 0));
                        transform.copyFrom(curveTransform);
                    }
                    transform.multiplyToRef(scaleMatrix, transform);
                    generatedVertexData.data.transform(transform);
                }
                vertexData.copyFrom(generatedVertices[0].data);
                if (generatedVertices.length > 1) {
                    vertexData.merge(generatedVertices.slice(1).map(generatedVertexData => generatedVertexData.data));
                }
            }
            // const calcW = this.textMeshFont.font.getAdvanceWidth(text) * GLYPH_COORDS_SCALE;
            // if (vertexData.positions) {
            //     const max = Vector3.Zero();
            //     for (let i = 0; i < vertexData.positions.length; i += 3) {
            //         const p = vertexData.positions;
            //         max.x = Math.max(max.x, p[i]);
            //         max.y = Math.max(max.y, p[i + 1]);
            //         max.z = Math.max(max.z, p[i + 2]);
            //     }
            //     const centerTransform = Matrix.Compose(Vector3.OneReadOnly, Quaternion.Identity(), max.scale(-0.5));
            //     vertexData.transform(centerTransform);
            // }
            return vertexData;
        }
    }

    /**
     * Creates a hemisphere mesh
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param options.segments
     * @param options.diameter
     * @param options.sideOrientation
     * @param scene defines the hosting scene
     * @returns the hemisphere mesh
     */
    function CreateHemisphere(name, options = {}, scene) {
        if (!options.diameter) {
            options.diameter = 1;
        }
        if (!options.segments) {
            options.segments = 16;
        }
        const halfSphere = CreateSphere("", { slice: 0.5, diameter: options.diameter, segments: options.segments }, scene);
        const disc = CreateDisc("", { radius: options.diameter / 2, tessellation: options.segments * 3 + (4 - options.segments) }, scene);
        disc.rotation.x = -Math.PI / 2;
        disc.parent = halfSphere;
        const merged = Mesh.MergeMeshes([disc, halfSphere], true);
        merged.name = name;
        return merged;
    }
    /**
     * Creates a hemispheric light
     * @param name
     * @param segments
     * @param diameter
     * @param scene
     */
    Mesh.CreateHemisphere = (name, segments, diameter, scene) => {
        const options = {
            segments: segments,
            diameter: diameter,
        };
        return CreateHemisphere(name, options, scene);
    };

    /**
     * Material types for GreasedLine
     * {@link https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/greased_line#materialtype}
     */
    var GreasedLineMeshMaterialType;
    (function (GreasedLineMeshMaterialType) {
        /**
         * StandardMaterial
         */
        GreasedLineMeshMaterialType[GreasedLineMeshMaterialType["MATERIAL_TYPE_STANDARD"] = 0] = "MATERIAL_TYPE_STANDARD";
        /**
         * PBR Material
         */
        GreasedLineMeshMaterialType[GreasedLineMeshMaterialType["MATERIAL_TYPE_PBR"] = 1] = "MATERIAL_TYPE_PBR";
    })(GreasedLineMeshMaterialType || (GreasedLineMeshMaterialType = {}));
    /**
     * Color blending mode of the @see GreasedLineMaterial and the base material
     * {@link https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/greased_line#colormode}
     */
    var GreasedLineMeshColorMode;
    (function (GreasedLineMeshColorMode) {
        /**
         * Color blending mode SET
         */
        GreasedLineMeshColorMode[GreasedLineMeshColorMode["COLOR_MODE_SET"] = 0] = "COLOR_MODE_SET";
        /**
         * Color blending mode ADD
         */
        GreasedLineMeshColorMode[GreasedLineMeshColorMode["COLOR_MODE_ADD"] = 1] = "COLOR_MODE_ADD";
        /**
         * Color blending mode ADD
         */
        GreasedLineMeshColorMode[GreasedLineMeshColorMode["COLOR_MODE_MULTIPLY"] = 2] = "COLOR_MODE_MULTIPLY";
    })(GreasedLineMeshColorMode || (GreasedLineMeshColorMode = {}));
    /**
     * Color distribution type of the @see colors.
     * {@link https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/greased_line#colordistributiontype}
     *
     */
    var GreasedLineMeshColorDistributionType;
    (function (GreasedLineMeshColorDistributionType) {
        /**
         * Colors distributed between segments of the line
         */
        GreasedLineMeshColorDistributionType[GreasedLineMeshColorDistributionType["COLOR_DISTRIBUTION_TYPE_SEGMENT"] = 0] = "COLOR_DISTRIBUTION_TYPE_SEGMENT";
        /**
         * Colors distributed along the line ingoring the segments
         */
        GreasedLineMeshColorDistributionType[GreasedLineMeshColorDistributionType["COLOR_DISTRIBUTION_TYPE_LINE"] = 1] = "COLOR_DISTRIBUTION_TYPE_LINE";
    })(GreasedLineMeshColorDistributionType || (GreasedLineMeshColorDistributionType = {}));
    /**
     * @internal
     */
    class MaterialGreasedLineDefines extends MaterialDefines {
        constructor() {
            super(...arguments);
            /**
             * The material has a color option specified
             */
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.GREASED_LINE_HAS_COLOR = false;
            /**
             * The material's size attenuation optiom
             */
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.GREASED_LINE_SIZE_ATTENUATION = false;
            /**
             * The type of color distribution is set to line this value equals to true.
             */
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE = false;
            /**
             * True if scene is in right handed coordinate system.
             */
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.GREASED_LNE_RIGHT_HANDED_COORDINATE_SYSTEM = false;
        }
    }
    /**
     * GreasedLinePluginMaterial for GreasedLineMesh
     */
    class GreasedLinePluginMaterial extends MaterialPluginBase {
        constructor(material, _scene, options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            options = options || {
                color: GreasedLinePluginMaterial.DEFAULT_COLOR,
            };
            const defines = new MaterialGreasedLineDefines();
            defines.GREASED_LINE_HAS_COLOR = !!options.color;
            defines.GREASED_LINE_SIZE_ATTENUATION = (_a = options.sizeAttenuation) !== null && _a !== void 0 ? _a : false;
            defines.GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE = options.colorDistributionType === GreasedLineMeshColorDistributionType.COLOR_DISTRIBUTION_TYPE_LINE;
            defines.GREASED_LNE_RIGHT_HANDED_COORDINATE_SYSTEM = _scene.useRightHandedSystem;
            super(material, GreasedLinePluginMaterial.GREASED_LINE_MATERIAL_NAME, 200, defines);
            this._scene = _scene;
            this._scene = (_b = this._scene) !== null && _b !== void 0 ? _b : material.getScene();
            this._engine = this._scene.getEngine();
            this.visibility = (_c = options.visibility) !== null && _c !== void 0 ? _c : 1;
            this.useDash = (_d = options.useDash) !== null && _d !== void 0 ? _d : false;
            this.dashRatio = (_e = options.dashRatio) !== null && _e !== void 0 ? _e : 0.5;
            this.dashOffset = (_f = options.dashOffset) !== null && _f !== void 0 ? _f : 0;
            this.width = options.width ? options.width : options.sizeAttenuation ? GreasedLinePluginMaterial.DEFAULT_WIDTH_ATTENUATED : GreasedLinePluginMaterial.DEFAULT_WIDTH;
            this._sizeAttenuation = (_g = options.sizeAttenuation) !== null && _g !== void 0 ? _g : false;
            this.colorMode = (_h = options.colorMode) !== null && _h !== void 0 ? _h : GreasedLineMeshColorMode.COLOR_MODE_SET;
            this._color = (_j = options.color) !== null && _j !== void 0 ? _j : null;
            this.useColors = (_k = options.useColors) !== null && _k !== void 0 ? _k : false;
            this._colorsDistributionType = (_l = options.colorDistributionType) !== null && _l !== void 0 ? _l : GreasedLineMeshColorDistributionType.COLOR_DISTRIBUTION_TYPE_SEGMENT;
            this.colorsSampling = (_m = options.colorsSampling) !== null && _m !== void 0 ? _m : RawTexture.NEAREST_NEAREST;
            this._colors = (_o = options.colors) !== null && _o !== void 0 ? _o : null;
            this.dashCount = (_p = options.dashCount) !== null && _p !== void 0 ? _p : 1; // calculate the _dashArray value, call the setter
            this.resolution = (_q = options.resolution) !== null && _q !== void 0 ? _q : new Vector2(this._engine.getRenderWidth(), this._engine.getRenderHeight()); // calculate aspect call the setter
            if (this._colors) {
                this._createColorsTexture(`${material.name}-colors-texture`, this._colors);
            }
            else {
                this._color = (_r = this._color) !== null && _r !== void 0 ? _r : GreasedLinePluginMaterial.DEFAULT_COLOR;
                GreasedLinePluginMaterial._PrepareEmptyColorsTexture(_scene);
            }
            this._enable(true); // always enabled
        }
        /**
         * Get the shader attributes
         * @param attributes array which will be filled with the attributes
         */
        getAttributes(attributes) {
            attributes.push("grl_offsets");
            attributes.push("grl_previousAndSide");
            attributes.push("grl_nextAndCounters");
            attributes.push("grl_widths");
            attributes.push("grl_colorPointers");
        }
        /**
         * Get the shader samplers
         * @param samplers
         */
        getSamplers(samplers) {
            samplers.push("grl_colors");
        }
        /**
         * Get the shader textures
         * @param activeTextures
         */
        getActiveTextures(activeTextures) {
            if (this._colorsTexture) {
                activeTextures.push(this._colorsTexture);
            }
        }
        /**
         * Get the shader uniforms
         * @returns uniforms
         */
        getUniforms() {
            const ubo = [
                { name: "grl_projection", size: 16, type: "mat4" },
                { name: "grl_singleColor", size: 3, type: "vec3" },
                { name: "grl_aspect_resolution_lineWidth", size: 4, type: "vec4" },
                { name: "grl_dashOptions", size: 4, type: "vec4" },
                { name: "grl_colorMode_visibility_colorsWidth_useColors", size: 4, type: "vec4" },
            ];
            return {
                ubo,
                vertex: `
                uniform vec4 grl_aspect_resolution_lineWidth;
                uniform mat4 grl_projection;
                `,
                fragment: `
                uniform vec4 grl_dashOptions;
                uniform vec4 grl_colorMode_visibility_colorsWidth_useColors;
                uniform vec3 grl_singleColor;
                `,
            };
        }
        // only getter, it doesn't make sense to use this plugin on a mesh other than GreasedLineMesh
        // and it doesn't make sense to disable it on the mesh
        get isEnabled() {
            return true;
        }
        /**
         * Bind the uniform buffer
         * @param uniformBuffer
         */
        bindForSubMesh(uniformBuffer) {
            var _a;
            const activeCamera = this._scene.activeCamera;
            if (activeCamera) {
                const projection = activeCamera.getProjectionMatrix();
                uniformBuffer.updateMatrix("grl_projection", projection);
            }
            else {
                throw Error("GreasedLinePluginMaterial requires an active camera.");
            }
            const resolutionLineWidth = TmpVectors.Vector4[0];
            resolutionLineWidth.x = this._aspect;
            resolutionLineWidth.y = this._resolution.x;
            resolutionLineWidth.z = this._resolution.y;
            resolutionLineWidth.w = this.width;
            uniformBuffer.updateVector4("grl_aspect_resolution_lineWidth", resolutionLineWidth);
            const dashOptions = TmpVectors.Vector4[0];
            dashOptions.x = GreasedLinePluginMaterial._BooleanToNumber(this.useDash);
            dashOptions.y = this._dashArray;
            dashOptions.z = this.dashOffset;
            dashOptions.w = this.dashRatio;
            uniformBuffer.updateVector4("grl_dashOptions", dashOptions);
            const colorModeVisibilityColorsWidthUseColors = TmpVectors.Vector4[1];
            colorModeVisibilityColorsWidthUseColors.x = this.colorMode;
            colorModeVisibilityColorsWidthUseColors.y = this.visibility;
            colorModeVisibilityColorsWidthUseColors.z = this._colorsTexture ? this._colorsTexture.getSize().width : 0;
            colorModeVisibilityColorsWidthUseColors.w = GreasedLinePluginMaterial._BooleanToNumber(this.useColors);
            uniformBuffer.updateVector4("grl_colorMode_visibility_colorsWidth_useColors", colorModeVisibilityColorsWidthUseColors);
            if (this._color) {
                uniformBuffer.updateColor3("grl_singleColor", this._color);
            }
            uniformBuffer.setTexture("grl_colors", (_a = this._colorsTexture) !== null && _a !== void 0 ? _a : GreasedLinePluginMaterial._EmptyColorsTexture);
        }
        /**
         * Prepare the defines
         * @param defines
         * @param _scene
         * @param _mesh
         */
        prepareDefines(defines, _scene, _mesh) {
            var _a;
            defines.GREASED_LINE_HAS_COLOR = !!this._color;
            defines.GREASED_LINE_SIZE_ATTENUATION = (_a = this._sizeAttenuation) !== null && _a !== void 0 ? _a : false;
            defines.GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE = this._colorsDistributionType === GreasedLineMeshColorDistributionType.COLOR_DISTRIBUTION_TYPE_LINE;
            defines.GREASED_LNE_RIGHT_HANDED_COORDINATE_SYSTEM = _scene.useRightHandedSystem;
        }
        /**
         * Get the class name
         * @returns class name
         */
        getClassName() {
            return GreasedLinePluginMaterial.GREASED_LINE_MATERIAL_NAME;
        }
        /**
         * Get shader code
         * @param shaderType vertex/fragment
         * @returns shader code
         */
        getCustomCode(shaderType) {
            if (shaderType === "vertex") {
                return {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    CUSTOM_VERTEX_DEFINITIONS: `
                    attribute vec4 grl_previousAndSide;
                    attribute vec4 grl_nextAndCounters;
                    attribute float grl_widths;
                    attribute vec3 grl_offsets;
                    attribute float grl_colorPointers;

                    varying float grlCounters;
                    varying float grlColorPointer;

                    vec2 grlFix( vec4 i, float aspect ) {
                        vec2 res = i.xy / i.w;
                        res.x *= aspect;
                        return res;
                    }
                `,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    CUSTOM_VERTEX_UPDATE_POSITION: `
                    vec3 grlPositionOffset = grl_offsets;
                    positionUpdated += grlPositionOffset;
                `,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    CUSTOM_VERTEX_MAIN_END: `

                    float grlAspect = grl_aspect_resolution_lineWidth.x;
                    float grlBaseWidth = grl_aspect_resolution_lineWidth.w;

                    grlColorPointer = grl_colorPointers;

                    vec3 grlPrevious = grl_previousAndSide.xyz;
                    float grlSide = grl_previousAndSide.w;

                    vec3 grlNext = grl_nextAndCounters.xyz;
                    grlCounters = grl_nextAndCounters.w;


                    mat4 grlMatrix = viewProjection * world;
                    vec4 grlFinalPosition = grlMatrix * vec4( positionUpdated , 1.0 );
                    vec4 grlPrevPos = grlMatrix * vec4( grlPrevious + grlPositionOffset, 1.0 );
                    vec4 grlNextPos = grlMatrix * vec4( grlNext + grlPositionOffset, 1.0 );

                    vec2 grlCurrentP = grlFix( grlFinalPosition, grlAspect );
                    vec2 grlPrevP = grlFix( grlPrevPos, grlAspect );
                    vec2 grlNextP = grlFix( grlNextPos, grlAspect );

                    float grlWidth = grlBaseWidth * grl_widths;

                    vec2 grlDir;
                    if( grlNextP == grlCurrentP ) grlDir = normalize( grlCurrentP - grlPrevP );
                    else if( grlPrevP == grlCurrentP ) grlDir = normalize( grlNextP - grlCurrentP );
                    else {
                        vec2 grlDir1 = normalize( grlCurrentP - grlPrevP );
                        vec2 grlDir2 = normalize( grlNextP - grlCurrentP );
                        grlDir = normalize( grlDir1 + grlDir2 );
                    }
                    vec4 grlNormal = vec4( -grlDir.y, grlDir.x, 0., 1. );
                    #ifdef GREASED_LNE_RIGHT_HANDED_COORDINATE_SYSTEM
                        grlNormal.xy *= -.5 * grlWidth;
                    #else
                        grlNormal.xy *= .5 * grlWidth;
                    #endif
                    grlNormal *= grl_projection;
                    #ifdef GREASED_LINE_SIZE_ATTENUATION
                        grlNormal.xy *= grlFinalPosition.w;
                        grlNormal.xy /= ( vec4( grl_aspect_resolution_lineWidth.yz, 0., 1. ) * grl_projection ).xy;
                    #endif
                    grlFinalPosition.xy += grlNormal.xy * grlSide;
                    gl_Position = grlFinalPosition;

                    vPositionW = vec3(grlFinalPosition);

                `,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    "!gl_Position\\=viewProjection\\*worldPos;": "//", // remove
                };
            }
            if (shaderType === "fragment") {
                return {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    CUSTOM_FRAGMENT_DEFINITIONS: `
                    varying float grlCounters;
                    varying float grlColorPointer;
                    uniform sampler2D grl_colors;
                `,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    CUSTOM_FRAGMENT_MAIN_END: `
                    float grlColorMode = grl_colorMode_visibility_colorsWidth_useColors.x;
                    float grlVisibility = grl_colorMode_visibility_colorsWidth_useColors.y;
                    float grlColorsWidth = grl_colorMode_visibility_colorsWidth_useColors.z;
                    float grlUseColors = grl_colorMode_visibility_colorsWidth_useColors.w;

                    float grlUseDash = grl_dashOptions.x;
                    float grlDashArray = grl_dashOptions.y;
                    float grlDashOffset = grl_dashOptions.z;
                    float grlDashRatio = grl_dashOptions.w;

                    gl_FragColor.a *= step(grlCounters, grlVisibility);
                    if( gl_FragColor.a == 0. ) discard;

                    if(grlUseDash == 1.){
                        gl_FragColor.a *= ceil(mod(grlCounters + grlDashOffset, grlDashArray) - (grlDashArray * grlDashRatio));
                        if (gl_FragColor.a == 0.) discard;
                    }

                    #ifdef GREASED_LINE_HAS_COLOR
                        if (grlColorMode == ${GreasedLineMeshColorMode.COLOR_MODE_SET}.) {
                            gl_FragColor.rgb = grl_singleColor;
                        } else if (grlColorMode == ${GreasedLineMeshColorMode.COLOR_MODE_ADD}.) {
                            gl_FragColor.rgb += grl_singleColor;
                        } else if (grlColorMode == ${GreasedLineMeshColorMode.COLOR_MODE_MULTIPLY}.) {
                            gl_FragColor.rgb *= grl_singleColor;
                        }
                    #else
                        if (grlUseColors == 1.) {
                            #ifdef GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE
                                vec4 grlColor = texture2D(grl_colors, vec2(grlCounters, 0.), 0.);
                            #else
                                vec4 grlColor = texture2D(grl_colors, vec2(grlColorPointer/grlColorsWidth, 0.), 0.);
                            #endif
                            if (grlColorMode == ${GreasedLineMeshColorMode.COLOR_MODE_SET}.) {
                                gl_FragColor = grlColor;
                            } else if (grlColorMode == ${GreasedLineMeshColorMode.COLOR_MODE_ADD}.) {
                                gl_FragColor += grlColor;
                            } else if (grlColorMode == ${GreasedLineMeshColorMode.COLOR_MODE_MULTIPLY}.) {
                                gl_FragColor *= grlColor;
                            }
                        }
                    #endif
                `,
                };
            }
            return null;
        }
        /**
         * Converts boolean to number.
         * @param bool
         * @returns 1 if true, 0 if false.
         */
        static _BooleanToNumber(bool) {
            return bool ? 1 : 0;
        }
        /**
         * Converts an array of Color3 to Uint8Array
         * @param colors Arrray of Color3
         * @returns Uin8Array of colors [r, g, b, a, r, g, b, a, ...]
         */
        static _Color3toRGBAUint8(colors) {
            const colorTable = new Uint8Array(colors.length * 4);
            for (let i = 0, j = 0; i < colors.length; i++) {
                colorTable[j++] = colors[i].r * 255;
                colorTable[j++] = colors[i].g * 255;
                colorTable[j++] = colors[i].b * 255;
                colorTable[j++] = 255;
            }
            return colorTable;
        }
        /**
         * Creates a RawTexture from an RGBA color array and sets it on the plugin material instance.
         * @param name name of the texture
         * @param colors Uint8Array of colors
         */
        _createColorsTexture(name, colors) {
            const colorsArray = GreasedLinePluginMaterial._Color3toRGBAUint8(colors);
            this._colorsTexture = new RawTexture(colorsArray, colors.length, 1, Engine.TEXTUREFORMAT_RGBA, this._scene, false, true, this.colorsSampling);
            this._colorsTexture.name = name;
        }
        /**
         * Disposes the plugin material.
         */
        dispose() {
            var _a;
            (_a = this._colorsTexture) === null || _a === void 0 ? void 0 : _a.dispose();
            super.dispose();
        }
        /**
         * Returns the colors used to colorize the line
         */
        get colors() {
            return this._colors;
        }
        /**
         * Sets the colors used to colorize the line
         */
        set colors(value) {
            this.setColors(value);
        }
        /**
         * Creates or updates the colors texture
         * @param colors color table RGBA
         * @param lazy if lazy, the colors are not updated
         * @param forceUpdate force creation of a new texture
         * @returns
         */
        setColors(colors, lazy = false, forceUpdate = false) {
            var _a, _b, _c, _d;
            const origColorsCount = (_b = (_a = this._colors) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
            this._colors = colors;
            if (colors === null || colors.length === 0) {
                (_c = this._colorsTexture) === null || _c === void 0 ? void 0 : _c.dispose();
                return;
            }
            if (lazy && !forceUpdate) {
                return;
            }
            if (this._colorsTexture && origColorsCount === colors.length && !forceUpdate) {
                const colorArray = GreasedLinePluginMaterial._Color3toRGBAUint8(colors);
                this._colorsTexture.update(colorArray);
            }
            else {
                (_d = this._colorsTexture) === null || _d === void 0 ? void 0 : _d.dispose();
                this._createColorsTexture(`${this._material.name}-colors-texture`, colors);
            }
        }
        /**
         * Updates the material. Use when material created in lazy mode.
         */
        updateLazy() {
            if (this._colors) {
                this.setColors(this._colors, false, true);
            }
        }
        /**
         * Gets the number of dashes in the line
         */
        get dashCount() {
            return this._dashCount;
        }
        /**
         * Sets the number of dashes in the line
         * @param value dash
         */
        set dashCount(value) {
            this._dashCount = value;
            this._dashArray = 1 / value;
        }
        /**
         * False means 1 unit in width = 1 unit on scene, true means 1 unit in width is reduced on the screen to make better looking lines
         */
        get sizeAttenuation() {
            return this._sizeAttenuation;
        }
        /**
         * Turn on/off attenuation of the width option and widths array.
         * @param value false means 1 unit in width = 1 unit on scene, true means 1 unit in width is reduced on the screen to make better looking lines
         */
        set sizeAttenuation(value) {
            this._sizeAttenuation = value;
            this.markAllDefinesAsDirty();
        }
        /**
         * Gets the color of the line
         */
        get color() {
            return this.color;
        }
        /**
         * Sets the color of the line
         * @param value Color3 or null to clear the color. You need to clear the color if you use colors and useColors = true
         */
        set color(value) {
            this.setColor(value);
        }
        /**
         * Sets the color of the line. If set the whole line will be mixed with this color according to the colorMode option.
         * @param value color
         */
        setColor(value, doNotMarkDirty = false) {
            if ((this._color === null && value !== null) || (this._color !== null && value === null)) {
                this._color = value;
                !doNotMarkDirty && this.markAllDefinesAsDirty();
            }
            else {
                this._color = value;
            }
        }
        /**
         * Gets the color distributiopn type
         */
        get colorsDistributionType() {
            return this._colorsDistributionType;
        }
        /**
         * Sets the color distribution type
         * @see GreasedLineMeshColorDistributionType
         * @param value color distribution type
         */
        set colorsDistributionType(value) {
            this._colorsDistributionType = value;
            this.markAllDefinesAsDirty();
        }
        /**
         * Gets the resolution
         */
        get resolution() {
            return this._resolution;
        }
        /**
         * Sets the resolution
         * @param value resolution of the screen for GreasedLine
         */
        set resolution(value) {
            this._aspect = value.x / value.y;
            this._resolution = value;
        }
        /**
         * Serializes this plugin material
         * @returns serializationObjec
         */
        serialize() {
            const serializationObject = super.serialize();
            const greasedLineMaterialOptions = {
                colorDistributionType: this._colorsDistributionType,
                colorsSampling: this.colorsSampling,
                colorMode: this.colorMode,
                dashCount: this._dashCount,
                dashOffset: this.dashOffset,
                dashRatio: this.dashRatio,
                resolution: this._resolution,
                sizeAttenuation: this._sizeAttenuation,
                useColors: this.useColors,
                useDash: this.useDash,
                visibility: this.visibility,
                width: this.width,
            };
            this._colors && (greasedLineMaterialOptions.colors = this._colors);
            this._color && (greasedLineMaterialOptions.color = this._color);
            serializationObject.greasedLineMaterialOptions = greasedLineMaterialOptions;
            return serializationObject;
        }
        /**
         * Parses a serialized objects
         * @param source serialized object
         * @param scene scene
         * @param rootUrl root url for textures
         */
        parse(source, scene, rootUrl) {
            var _a;
            super.parse(source, scene, rootUrl);
            const greasedLineMaterialOptions = source.greasedLineMaterialOptions;
            (_a = this._colorsTexture) === null || _a === void 0 ? void 0 : _a.dispose();
            if (greasedLineMaterialOptions.colors) {
                this._createColorsTexture(`${this._material.name}-colors-texture`, greasedLineMaterialOptions.colors);
            }
            else {
                GreasedLinePluginMaterial._PrepareEmptyColorsTexture(scene);
            }
            greasedLineMaterialOptions.color && this.setColor(greasedLineMaterialOptions.color, true);
            greasedLineMaterialOptions.colorDistributionType && (this.colorsDistributionType = greasedLineMaterialOptions.colorDistributionType);
            greasedLineMaterialOptions.colorsSampling && (this.colorsSampling = greasedLineMaterialOptions.colorsSampling);
            greasedLineMaterialOptions.colorMode && (this.colorMode = greasedLineMaterialOptions.colorMode);
            greasedLineMaterialOptions.useColors && (this.useColors = greasedLineMaterialOptions.useColors);
            greasedLineMaterialOptions.visibility && (this.visibility = greasedLineMaterialOptions.visibility);
            greasedLineMaterialOptions.useDash && (this.useDash = greasedLineMaterialOptions.useDash);
            greasedLineMaterialOptions.dashCount && (this.dashCount = greasedLineMaterialOptions.dashCount);
            greasedLineMaterialOptions.dashRatio && (this.dashRatio = greasedLineMaterialOptions.dashRatio);
            greasedLineMaterialOptions.dashOffset && (this.dashOffset = greasedLineMaterialOptions.dashOffset);
            greasedLineMaterialOptions.width && (this.width = greasedLineMaterialOptions.width);
            greasedLineMaterialOptions.sizeAttenuation && (this.sizeAttenuation = greasedLineMaterialOptions.sizeAttenuation);
            greasedLineMaterialOptions.resolution && (this.resolution = greasedLineMaterialOptions.resolution);
            this.markAllDefinesAsDirty();
        }
        /**
         * A minimum size texture for the colors sampler2D when there is no colors texture defined yet.
         * For fast switching using the useColors property without the need to use defines.
         * @param scene Scene
         */
        static _PrepareEmptyColorsTexture(scene) {
            if (!this._EmptyColorsTexture) {
                const colorsArray = new Uint8Array(4);
                this._EmptyColorsTexture = new RawTexture(colorsArray, 1, 1, Engine.TEXTUREFORMAT_RGBA, scene, false, false, RawTexture.NEAREST_NEAREST);
                this._EmptyColorsTexture.name = "grlEmptyColorsTexture";
            }
        }
    }
    /**
     * Plugin name
     */
    GreasedLinePluginMaterial.GREASED_LINE_MATERIAL_NAME = "GreasedLinePluginMaterial";
    /**
     * Default line color for newly created lines
     */
    GreasedLinePluginMaterial.DEFAULT_COLOR = Color3.White();
    /**
     * Default line width when sizeAttenuation is true
     */
    GreasedLinePluginMaterial.DEFAULT_WIDTH_ATTENUATED = 1;
    /**
     * Defaule line width
     */
    GreasedLinePluginMaterial.DEFAULT_WIDTH = 0.1;
    RegisterClass(`BABYLON.${GreasedLinePluginMaterial.GREASED_LINE_MATERIAL_NAME}`, GreasedLinePluginMaterial);

    /**
     * Tool functions for GreasedLine
     */
    class GreasedLineTools {
        /**
         * Omit zero length lines predicate for the MeshesToLines function
         * @param p1 point1 position of the face
         * @param p2 point2 position of the face
         * @param p3 point3 position of the face
         * @returns
         */
        static OmitZeroLengthPredicate(p1, p2, p3) {
            return p1.lengthSquared() === 0 && p2.lengthSquared() === 0 && p3.lengthSquared() === 0;
        }
        /**
         * Gets mesh triangles as line positions
         * @param meshes array of meshes
         * @param omitZeroLengthLines do not generate a line when the distance if the vertices in the triangle equals to zero
         * @returns array of arrays of points
         */
        static MeshesToLines(meshes, predicate) {
            const points = [];
            meshes.forEach((m, meshIndex) => {
                const vertices = m.getVerticesData(VertexBuffer.PositionKind);
                const indices = m.getIndices();
                if (vertices && indices) {
                    for (let i = 0, ii = 0; i < indices.length; i++) {
                        const vi1 = indices[ii++] * 3;
                        const vi2 = indices[ii++] * 3;
                        const vi3 = indices[ii++] * 3;
                        const p1 = new Vector3(vertices[vi1], vertices[vi1 + 1], vertices[vi1 + 2]);
                        const p2 = new Vector3(vertices[vi2], vertices[vi2 + 1], vertices[vi2 + 2]);
                        const p3 = new Vector3(vertices[vi3], vertices[vi3 + 1], vertices[vi3 + 2]);
                        if (predicate) {
                            const pointsFromPredicate = predicate(p1, p2, p3, i, vi1, m, meshIndex, vertices, indices);
                            pointsFromPredicate && points.push(pointsFromPredicate);
                        }
                        else {
                            points.push([p1, p2, p3, p1]);
                        }
                    }
                }
            });
            return points;
        }
        /**
         * Converts number coordinates to Vector3s
         * @param points number array of x, y, z, x, y z, ... coordinates
         * @returns Vector3 array
         */
        static ToVector3Array(points) {
            const array = [];
            for (let i = 0; i < points.length; i += 3) {
                array.push(new Vector3(points[i], points[i + 1], points[i + 2]));
            }
            return array;
        }
        /**
         * Gets a number array from a Vector3 array.
         * You can you for example to convert your Vector3[] offsets to the required number[] for the offsets option.
         * @param points Vector3 array
         * @returns an array of x, y, z coordinates as numbers [x, y, z, x, y, z, x, y, z, ....]
         */
        static ToNumberArray(points) {
            return points.flatMap((v) => [v.x, v.y, v.z]);
        }
        /**
         * Calculates the sum of points of every line and the number of points in each line.
         * This function is useful when you are drawing multiple lines in one mesh and you want
         * to know the counts. For example for creating an offsets table.
         * @param points point array
         * @returns points count info
         */
        static GetPointsCountInfo(points) {
            const counts = new Array(points.length);
            let total = 0;
            for (let n = points.length; n--;) {
                counts[n] = points[n].length / 3;
                total += counts[n];
            }
            return { total, counts };
        }
        /**
         * Gets the length of the line counting all it's segments length
         * @param data array of line points
         * @returns length of the line
         */
        static GetLineLength(data) {
            if (data.length === 0) {
                return 0;
            }
            let points;
            if (typeof data[0] === "number") {
                points = GreasedLineTools.ToVector3Array(data);
            }
            else {
                points = data;
            }
            const tmp = TmpVectors.Vector3[0];
            let length = 0;
            for (let index = 0; index < points.length - 1; index++) {
                const point1 = points[index];
                const point2 = points[index + 1];
                length += point2.subtractToRef(point1, tmp).length();
            }
            return length;
        }
        /**
         * Divides a segment into smaller segments.
         * A segment is a part of the line between it's two points.
         * @param point1 first point of the line
         * @param point2 second point of the line
         * @param segmentCount number of segments we want to have in the divided line
         * @returns
         */
        static SegmentizeSegmentByCount(point1, point2, segmentCount) {
            const dividedLinePoints = [];
            const diff = point2.subtract(point1);
            const divisor = TmpVectors.Vector3[0];
            divisor.setAll(segmentCount);
            const segmentVector = TmpVectors.Vector3[1];
            diff.divideToRef(divisor, segmentVector);
            let nextPoint = point1.clone();
            dividedLinePoints.push(nextPoint);
            for (let index = 0; index < segmentCount; index++) {
                nextPoint = nextPoint.clone();
                dividedLinePoints.push(nextPoint.addInPlace(segmentVector));
            }
            return dividedLinePoints;
        }
        /**
         * Divides a line into segments.
         * A segment is a part of the line between it's two points.
         * @param what line points
         * @param segmentLength length of each segment of the resulting line (distance between two line points)
         * @returns line point
         */
        static SegmentizeLineBySegmentLength(what, segmentLength) {
            const subLines = what[0] instanceof Vector3 ? GreasedLineTools.GetLineSegments(what) : what;
            const points = [];
            subLines.forEach((s) => {
                if (s.length > segmentLength) {
                    const segments = GreasedLineTools.SegmentizeSegmentByCount(s.point1, s.point2, Math.ceil(s.length / segmentLength));
                    segments.forEach((seg) => {
                        points.push(seg);
                    });
                }
                else {
                    points.push(s.point1);
                    points.push(s.point2);
                }
            });
            return points;
        }
        /**
         * Divides a line into segments.
         * A segment is a part of the line between it's two points.
         * @param what line points
         * @param segmentCount number of segments
         * @returns line point
         */
        static SegmentizeLineBySegmentCount(what, segmentCount) {
            const segmentLength = GreasedLineTools.GetLineLength(what) / segmentCount;
            return GreasedLineTools.SegmentizeLineBySegmentLength(what, segmentLength);
        }
        /**
         * Gets line segments.
         * A segment is a part of the line between it's two points.
         * @param points line points
         * @returns segments information of the line segment including starting point, ending point and the distance between them
         */
        static GetLineSegments(points) {
            const segments = [];
            for (let index = 0; index < points.length - 1; index++) {
                const point1 = points[index];
                const point2 = points[index + 1];
                const length = point2.subtract(point1).length();
                segments.push({ point1, point2, length });
            }
            return segments;
        }
        /**
         * Gets the minimum and the maximum length of a line segment in the line.
         * A segment is a part of the line between it's two points.
         * @param points line points
         * @returns
         */
        static GetMinMaxSegmentLength(points) {
            const subLines = GreasedLineTools.GetLineSegments(points);
            const sorted = subLines.sort((s) => s.length);
            return {
                min: sorted[0].length,
                max: sorted[sorted.length - 1].length,
            };
        }
        /**
         * Finds the last visible position in world space of the line according to the visibility parameter
         * @param lineSegments segments of the line
         * @param lineLength total length of the line
         * @param visbility normalized value of visibility
         * @returns world space coordinate of the last visible piece of the line
         */
        static GetPositionOnLineByVisibility(lineSegments, lineLength, visbility, localSpace = false) {
            const lengthVisibilityRatio = lineLength * visbility;
            let sumSegmentLengths = 0;
            let segmentIndex = 0;
            const lineSegmentsLength = lineSegments.length;
            for (let i = 0; i < lineSegmentsLength; i++) {
                if (lengthVisibilityRatio <= sumSegmentLengths + lineSegments[i].length) {
                    segmentIndex = i;
                    break;
                }
                sumSegmentLengths += lineSegments[i].length;
            }
            const s = (lengthVisibilityRatio - sumSegmentLengths) / lineSegments[segmentIndex].length;
            lineSegments[segmentIndex].point2.subtractToRef(lineSegments[segmentIndex].point1, TmpVectors.Vector3[0]);
            TmpVectors.Vector3[1] = TmpVectors.Vector3[0].multiplyByFloats(s, s, s);
            if (!localSpace) {
                TmpVectors.Vector3[1].addInPlace(lineSegments[segmentIndex].point1);
            }
            return TmpVectors.Vector3[1].clone();
        }
        /**
         * Creates lines in a shape of circle/arc.
         * A segment is a part of the line between it's two points.
         * @param radiusX radiusX of the circle
         * @param segments number of segments in the circle
         * @param z z coordinate of the points. Defaults to 0.
         * @param radiusY radiusY of the circle - you can draw an oval if using different values
         * @param segmentAngle angle offset of the segments. Defaults to Math.PI * 2 / segments. Change this value to draw a part of the circle.
         * @returns line points
         */
        static GetCircleLinePoints(radiusX, segments, z = 0, radiusY = radiusX, segmentAngle = (Math.PI * 2) / segments) {
            const points = [];
            for (let i = 0; i <= segments; i++) {
                points.push(new Vector3(Math.cos(i * segmentAngle) * radiusX, Math.sin(i * segmentAngle) * radiusY, z));
            }
            return points;
        }
        /**
         * Gets line points in a shape of a bezier curve
         * @param p0 bezier point0
         * @param p1 bezier point1
         * @param p2 bezier point2
         * @param segments number of segments in the curve
         * @returns
         */
        static GetBezierLinePoints(p0, p1, p2, segments) {
            return Curve3.CreateQuadraticBezier(p0, p1, p2, segments)
                .getPoints()
                .flatMap((v) => [v.x, v.y, v.z]);
        }
        /**
         *
         * @param position position of the arrow cap (mainly you want to create a triangle, set widthUp and widthDown to the same value and omit widthStartUp and widthStartDown)
         * @param direction direction which the arrow points to
         * @param length length (size) of the arrow cap itself
         * @param widthUp the arrow width above the line
         * @param widthDown the arrow width belove the line
         * @param widthStartUp the arrow width at the start of the arrow above the line. In most scenarios this is 0.
         * @param widthStartDown the arrow width at the start of the arrow below the line. In most scenarios this is 0.
         * @returns
         */
        static GetArrowCap(position, direction, length, widthUp, widthDown, widthStartUp = 0, widthStartDown = 0) {
            const points = [position.clone(), position.add(direction.multiplyByFloats(length, length, length))];
            const widths = [widthUp, widthDown, widthStartUp, widthStartDown];
            return {
                points,
                widths,
            };
        }
        /**
         * Gets 3D positions of points from a text and font
         * @param text Text
         * @param size Size of the font
         * @param resolution Resolution of the font
         * @param fontData defines the font data (can be generated with http://gero3.github.io/facetype.js/)
         * @param z z coordinate
         * @param includeInner include the inner parts of the font in the result. Default true. If false, only the outlines will be returned.
         * @returns number[][] of 3D positions
         */
        static GetPointsFromText(text, size, resolution, fontData, z = 0, includeInner = true) {
            const allPoints = [];
            const shapePaths = CreateTextShapePaths(text, size, resolution, fontData);
            for (const sp of shapePaths) {
                for (const p of sp.paths) {
                    const points = [];
                    const points2d = p.getPoints();
                    for (const p2d of points2d) {
                        points.push(p2d.x, p2d.y, z);
                    }
                    allPoints.push(points);
                }
                if (includeInner) {
                    for (const h of sp.holes) {
                        const holes = [];
                        const points2d = h.getPoints();
                        for (const p2d of points2d) {
                            holes.push(p2d.x, p2d.y, z);
                        }
                        allPoints.push(holes);
                    }
                }
            }
            return allPoints;
        }
    }

    Mesh._GreasedLineMeshParser = (parsedMesh, scene) => {
        return GreasedLineMesh.Parse(parsedMesh, scene);
    };
    /**
     * GreasedLine
     */
    class GreasedLineMesh extends Mesh {
        constructor(name, scene, _options) {
            var _a, _b, _c, _d;
            super(name, scene, null, null, false, false);
            this.name = name;
            this._options = _options;
            this._lazy = false;
            this._updatable = false;
            /**
             * Treshold used to pick the mesh
             */
            this.intersectionThreshold = 0.1;
            this._lazy = (_a = _options.lazy) !== null && _a !== void 0 ? _a : false;
            this._updatable = (_b = _options.updatable) !== null && _b !== void 0 ? _b : false;
            this._vertexPositions = [];
            this._indices = [];
            this._uvs = [];
            this._points = [];
            this._colorPointers = (_c = _options.colorPointers) !== null && _c !== void 0 ? _c : [];
            this._widths = (_d = _options.widths) !== null && _d !== void 0 ? _d : new Array(_options.points.length).fill(1);
            this._previousAndSide = [];
            this._nextAndCounters = [];
            if (_options.points) {
                this.addPoints(GreasedLineMesh.ConvertPoints(_options.points));
            }
        }
        /**
         * "GreasedLineMesh"
         * @returns "GreasedLineMesh"
         */
        getClassName() {
            return "GreasedLineMesh";
        }
        /**
         * Converts GreasedLinePoints to number[][]
         * @param points GreasedLinePoints
         * @returns number[][] with x, y, z coordinates of the points, like [[x, y, z, x, y, z, ...], [x, y, z, ...]]
         */
        static ConvertPoints(points) {
            if (points.length && Array.isArray(points) && typeof points[0] === "number") {
                return [points];
            }
            else if (points.length && Array.isArray(points[0]) && typeof points[0][0] === "number") {
                return points;
            }
            else if (points.length && !Array.isArray(points[0]) && points[0] instanceof Vector3) {
                const positions = [];
                for (let j = 0; j < points.length; j++) {
                    const p = points[j];
                    positions.push(p.x, p.y, p.z);
                }
                return [positions];
            }
            else if (points.length > 0 && Array.isArray(points[0]) && points[0].length > 0 && points[0][0] instanceof Vector3) {
                const positions = [];
                const vectorPoints = points;
                vectorPoints.forEach((p) => {
                    positions.push(p.flatMap((p2) => [p2.x, p2.y, p2.z]));
                });
                return positions;
            }
            else if (points instanceof Float32Array) {
                return [Array.from(points)];
            }
            else if (points.length && points[0] instanceof Float32Array) {
                const positions = [];
                points.forEach((p) => {
                    positions.push(Array.from(p));
                });
                return positions;
            }
            return [];
        }
        /**
         * Updated a lazy line. Rerenders the line and updates boundinfo as well.
         */
        updateLazy() {
            var _a;
            this.setPoints(this._points);
            if (!this._options.colorPointers) {
                this._updateColorPointers();
            }
            this._createVertexBuffers();
            this.refreshBoundingInfo();
            (_a = this.greasedLineMaterial) === null || _a === void 0 ? void 0 : _a.updateLazy();
        }
        /**
         * Dispose the line and it's resources
         */
        dispose() {
            super.dispose();
        }
        /**
         *
         * @returns true if the mesh was created in lazy mode
         */
        isLazy() {
            return this._lazy;
        }
        /**
         * Return the the points offsets
         */
        get offsets() {
            return this._offsets;
        }
        /**
         * Sets point offests
         * @param offsets offset table [x,y,z, x,y,z, ....]
         */
        set offsets(offsets) {
            this._offsets = offsets;
            if (!this._offsetsBuffer) {
                this._createOffsetsBuffer(offsets);
            }
            else {
                this._offsetsBuffer && this._offsetsBuffer.update(offsets);
            }
        }
        /**
         * Gets widths at each line point like [widthLower, widthUpper, widthLower, widthUpper, ...]
         */
        get widths() {
            return this._widths;
        }
        /**
         * Sets widths at each line point
         * @param widths width table [widthLower, widthUpper, widthLower, widthUpper ...]
         */
        set widths(widths) {
            this._widths = widths;
            if (!this._lazy) {
                this._widthsBuffer && this._widthsBuffer.update(widths);
            }
        }
        /**
         * Gets the color pointer. Each vertex need a color pointer. These color pointers points to the colors in the color table @see colors
         */
        get colorPointers() {
            return this._colorPointers;
        }
        /**
         * Sets the color pointer
         * @param colorPointers array of color pointer in the colors array. One pointer for every vertex is needed.
         */
        set colorPointers(colorPointers) {
            this._colorPointers = colorPointers;
            if (!this._lazy) {
                this._colorPointersBuffer && this._colorPointersBuffer.update(colorPointers);
            }
        }
        /**
         * Gets the pluginMaterial associated with line
         */
        get greasedLineMaterial() {
            var _a, _b;
            return (_b = (_a = this.material) === null || _a === void 0 ? void 0 : _a.pluginManager) === null || _b === void 0 ? void 0 : _b.getPlugin(GreasedLinePluginMaterial.GREASED_LINE_MATERIAL_NAME);
        }
        /**
         * Return copy the points.
         */
        get points() {
            const pointsCopy = [];
            DeepCopier.DeepCopy(this._points, pointsCopy);
            return pointsCopy;
        }
        /**
         * Adds new points to the line. It doesn't rerenders the line if in lazy mode.
         * @param points points table
         */
        addPoints(points) {
            for (const p of points) {
                this._points.push(p);
            }
            if (!this._lazy) {
                this.setPoints(this._points);
            }
        }
        _updateColorPointers() {
            let colorPointer = 0;
            this._colorPointers = [];
            this._points.forEach((p) => {
                for (let jj = 0; jj < p.length; jj += 3) {
                    this._colorPointers.push(colorPointer);
                    this._colorPointers.push(colorPointer++);
                }
            });
        }
        /**
         * Sets line points and rerenders the line.
         * @param points points table
         */
        setPoints(points) {
            this._points = points;
            this._options.points = points;
            this._initGreasedLine();
            let indiceOffset = 0;
            points.forEach((p) => {
                var _a;
                const counters = [];
                const positions = [];
                const indices = [];
                const totalLength = GreasedLineTools.GetLineLength(p);
                for (let j = 0, jj = 0; jj < p.length; j++, jj += 3) {
                    const partialLine = p.slice(0, jj + 3);
                    const partialLineLength = GreasedLineTools.GetLineLength(partialLine);
                    const c = partialLineLength / totalLength;
                    positions.push(p[jj], p[jj + 1], p[jj + 2]);
                    positions.push(p[jj], p[jj + 1], p[jj + 2]);
                    counters.push(c);
                    counters.push(c);
                    if (jj < p.length - 3) {
                        const n = j * 2 + indiceOffset;
                        indices.push(n, n + 1, n + 2);
                        indices.push(n + 2, n + 1, n + 3);
                    }
                }
                indiceOffset += (p.length / 3) * 2;
                const previous = [];
                const next = [];
                const side = [];
                let uvs = [];
                this._preprocess(positions, previous, next, side, uvs);
                for (const vp of positions) {
                    this._vertexPositions.push(vp);
                }
                for (const i of indices) {
                    this._indices.push(i);
                }
                for (let i = 0; i < side.length; i++) {
                    this._previousAndSide.push(previous[i * 3], previous[i * 3 + 1], previous[i * 3 + 2], side[i]);
                    this._nextAndCounters.push(next[i * 3], next[i * 3 + 1], next[i * 3 + 2], counters[i]);
                }
                uvs = (_a = this._options.uvs) !== null && _a !== void 0 ? _a : uvs;
                for (const uv of uvs) {
                    this._uvs.push(uv);
                }
            });
            if (!this._lazy) {
                if (!this._options.colorPointers) {
                    this._updateColorPointers();
                }
                this._createVertexBuffers();
                this.refreshBoundingInfo();
            }
        }
        _createLineOptions() {
            const lineOptions = {
                points: this._points,
                colorPointers: this._colorPointers,
                lazy: this._lazy,
                updatable: this._updatable,
                uvs: this._uvs,
                widths: this._widths,
            };
            return lineOptions;
        }
        /**
         * Clones the GreasedLineMesh.
         * @param name new line name
         * @param newParent new parent node
         * @returns cloned line
         */
        clone(name = `${this.name}-cloned`, newParent) {
            const lineOptions = this._createLineOptions();
            const deepCopiedLineOptions = {};
            DeepCopier.DeepCopy(lineOptions, deepCopiedLineOptions, ["instance"]);
            const cloned = new GreasedLineMesh(name, this._scene, deepCopiedLineOptions);
            if (newParent) {
                cloned.parent = newParent;
            }
            cloned.material = this.material;
            return cloned;
        }
        /**
         * Serializes this GreasedLineMesh
         * @param serializationObject object to write serialization to
         */
        serialize(serializationObject) {
            super.serialize(serializationObject);
            serializationObject.type = this.getClassName();
            serializationObject.lineOptions = this._createLineOptions();
        }
        /**
         * Parses a serialized GreasedLineMesh
         * @param parsedMesh the serialized GreasedLineMesh
         * @param scene the scene to create the GreasedLineMesh in
         * @returns the created GreasedLineMesh
         */
        static Parse(parsedMesh, scene) {
            const lineOptions = parsedMesh.lineOptions;
            const name = parsedMesh.name;
            const result = new GreasedLineMesh(name, scene, lineOptions);
            return result;
        }
        /**
         * Checks whether a ray is intersecting this GreasedLineMesh
         * @param ray ray to check the intersection of this mesh with
         * @param fastCheck not supported
         * @param trianglePredicate not supported
         * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
         * @param worldToUse not supported
         * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
         * @returns the picking info
         */
        intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
            const pickingInfo = new PickingInfo();
            const intersections = this.findAllIntersections(ray, fastCheck, trianglePredicate, onlyBoundingInfo, worldToUse, skipBoundingInfo, true);
            if ((intersections === null || intersections === void 0 ? void 0 : intersections.length) === 1) {
                const intersection = intersections[0];
                pickingInfo.hit = true;
                pickingInfo.distance = intersection.distance;
                pickingInfo.ray = ray;
                pickingInfo.pickedMesh = this;
                pickingInfo.pickedPoint = intersection.point;
            }
            return pickingInfo;
        }
        /**
         * Gets all intersections of a ray and the line
         * @param ray Ray to check the intersection of this mesh with
         * @param _fastCheck not supported
         * @param _trianglePredicate not supported
         * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
         * @param _worldToUse not supported
         * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
         * @param firstOnly If true, the first and only intersection is immediatelly returned if found
         * @returns intersection(s)
         */
        findAllIntersections(ray, _fastCheck, _trianglePredicate, onlyBoundingInfo = false, _worldToUse, skipBoundingInfo = false, firstOnly = false) {
            var _a, _b;
            if (onlyBoundingInfo && !skipBoundingInfo && ray.intersectsSphere(this._boundingSphere, this.intersectionThreshold) === false) {
                return;
            }
            const indices = this.getIndices();
            const positions = this.getVerticesData(VertexBuffer.PositionKind);
            const widths = this._widths;
            const lineWidth = (_b = (_a = this.greasedLineMaterial) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 1;
            const intersects = [];
            if (indices && positions && widths) {
                let i = 0, l = 0;
                for (i = 0, l = indices.length - 1; i < l; i += 3) {
                    const a = indices[i];
                    const b = indices[i + 1];
                    GreasedLineMesh._V_START.fromArray(positions, a * 3);
                    GreasedLineMesh._V_END.fromArray(positions, b * 3);
                    if (this._offsets) {
                        GreasedLineMesh._V_OFFSET_START.fromArray(this._offsets, a * 3);
                        GreasedLineMesh._V_OFFSET_END.fromArray(this._offsets, b * 3);
                        GreasedLineMesh._V_START.addInPlace(GreasedLineMesh._V_OFFSET_START);
                        GreasedLineMesh._V_END.addInPlace(GreasedLineMesh._V_OFFSET_END);
                    }
                    const iFloored = Math.floor(i / 3);
                    const width = widths[iFloored] !== undefined ? widths[iFloored] : 1;
                    const precision = (this.intersectionThreshold * (lineWidth * width)) / 2;
                    const distance = ray.intersectionSegment(GreasedLineMesh._V_START, GreasedLineMesh._V_END, precision);
                    if (distance !== -1) {
                        intersects.push({
                            distance: distance,
                            point: ray.direction.normalize().multiplyByFloats(distance, distance, distance).add(ray.origin),
                        });
                        if (firstOnly) {
                            return intersects;
                        }
                    }
                }
                i = l;
            }
            return intersects;
        }
        _initGreasedLine() {
            this._vertexPositions = [];
            this._previousAndSide = [];
            this._nextAndCounters = [];
            this._indices = [];
            this._uvs = [];
        }
        get _boundingSphere() {
            return this.getBoundingInfo().boundingSphere;
        }
        static _CompareV3(positionIdx1, positionIdx2, positions) {
            const arrayIdx1 = positionIdx1 * 6;
            const arrayIdx2 = positionIdx2 * 6;
            return positions[arrayIdx1] === positions[arrayIdx2] && positions[arrayIdx1 + 1] === positions[arrayIdx2 + 1] && positions[arrayIdx1 + 2] === positions[arrayIdx2 + 2];
        }
        static _CopyV3(positionIdx, positions) {
            const arrayIdx = positionIdx * 6;
            return [positions[arrayIdx], positions[arrayIdx + 1], positions[arrayIdx + 2]];
        }
        _preprocess(positions, previous, next, side, uvs) {
            const l = positions.length / 6;
            let v = [];
            if (GreasedLineMesh._CompareV3(0, l - 1, positions)) {
                v = GreasedLineMesh._CopyV3(l - 2, positions);
            }
            else {
                v = GreasedLineMesh._CopyV3(0, positions);
            }
            previous.push(v[0], v[1], v[2]);
            previous.push(v[0], v[1], v[2]);
            for (let j = 0; j < l; j++) {
                side.push(1);
                side.push(-1);
                // uvs
                if (!this._options.uvs) {
                    uvs.push(j / (l - 1), 0);
                    uvs.push(j / (l - 1), 1);
                }
                if (j < l - 1) {
                    v = GreasedLineMesh._CopyV3(j, positions);
                    previous.push(v[0], v[1], v[2]);
                    previous.push(v[0], v[1], v[2]);
                }
                if (j > 0) {
                    v = GreasedLineMesh._CopyV3(j, positions);
                    next.push(v[0], v[1], v[2]);
                    next.push(v[0], v[1], v[2]);
                }
            }
            if (GreasedLineMesh._CompareV3(l - 1, 0, positions)) {
                v = GreasedLineMesh._CopyV3(1, positions);
            }
            else {
                v = GreasedLineMesh._CopyV3(l - 1, positions);
            }
            next.push(v[0], v[1], v[2]);
            next.push(v[0], v[1], v[2]);
            return {
                previous,
                next,
                uvs,
                side,
            };
        }
        _createVertexBuffers() {
            const vertexData = new VertexData();
            vertexData.positions = this._vertexPositions;
            vertexData.indices = this._indices;
            vertexData.uvs = this._uvs;
            vertexData.applyToMesh(this, this._options.updatable);
            const engine = this._scene.getEngine();
            const previousAndSideBuffer = new Buffer$1(engine, this._previousAndSide, false, 4);
            this.setVerticesBuffer(previousAndSideBuffer.createVertexBuffer("grl_previousAndSide", 0, 4));
            const nextAndCountersBuffer = new Buffer$1(engine, this._nextAndCounters, false, 4);
            this.setVerticesBuffer(nextAndCountersBuffer.createVertexBuffer("grl_nextAndCounters", 0, 4));
            const widthBuffer = new Buffer$1(engine, this._widths, this._updatable, 1);
            this.setVerticesBuffer(widthBuffer.createVertexBuffer("grl_widths", 0, 1));
            this._widthsBuffer = widthBuffer;
            const colorPointersBuffer = new Buffer$1(engine, this._colorPointers, this._updatable, 1);
            this.setVerticesBuffer(colorPointersBuffer.createVertexBuffer("grl_colorPointers", 0, 1));
            this._colorPointersBuffer = colorPointersBuffer;
        }
        _createOffsetsBuffer(offsets) {
            const engine = this._scene.getEngine();
            const offsetBuffer = new Buffer$1(engine, offsets, this._updatable, 3);
            this.setVerticesBuffer(offsetBuffer.createVertexBuffer("grl_offsets", 0, 3));
            this._offsetsBuffer = offsetBuffer;
        }
    }
    GreasedLineMesh._V_START = new Vector3();
    GreasedLineMesh._V_END = new Vector3();
    GreasedLineMesh._V_OFFSET_START = new Vector3();
    GreasedLineMesh._V_OFFSET_END = new Vector3();

    /**
     * How are the colors distributed along the color table
     * {@link https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/greased_line#colors-and-colordistribution}
     */
    var GreasedLineMeshColorDistribution;
    (function (GreasedLineMeshColorDistribution) {
        /**
         * Do no modify the color table
         */
        GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_NONE"] = 0] = "COLOR_DISTRIBUTION_NONE";
        /**
         * Repeat the colors until the color table is full
         */
        GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_REPEAT"] = 1] = "COLOR_DISTRIBUTION_REPEAT";
        /**
         * Distribute the colors evenly through the color table
         */
        GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_EVEN"] = 2] = "COLOR_DISTRIBUTION_EVEN";
        /**
         * Put the colors to start of the color table a fill the rest with the default color
         */
        GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_START"] = 3] = "COLOR_DISTRIBUTION_START";
        /**
         * Put the colors to the end of the color table and fill the rest with the default color
         */
        GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_END"] = 4] = "COLOR_DISTRIBUTION_END";
        /**
         * Put the colors to start and to the end of the color table and fill the gap between with the default color
         */
        GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_START_END"] = 5] = "COLOR_DISTRIBUTION_START_END";
    })(GreasedLineMeshColorDistribution || (GreasedLineMeshColorDistribution = {}));
    /**
     * How are the widths distributed along the width table
     * {@link https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/greased_line#widths-and-widthdistribution}
     */
    var GreasedLineMeshWidthDistribution;
    (function (GreasedLineMeshWidthDistribution) {
        /**
         * Do no modify the width table
         */
        GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_NONE"] = 0] = "WIDTH_DISTRIBUTION_NONE";
        /**
         * Repeat the widths until the width table is full
         */
        GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_REPEAT"] = 1] = "WIDTH_DISTRIBUTION_REPEAT";
        /**
         * Distribute the widths evenly through the width table
         */
        GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_EVEN"] = 2] = "WIDTH_DISTRIBUTION_EVEN";
        /**
         * Put the widths to start of the width table a fill the rest with the default width
         */
        GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_START"] = 3] = "WIDTH_DISTRIBUTION_START";
        /**
         * Put the widths to the end of the width table and fill the rest with the default width
         */
        GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_END"] = 4] = "WIDTH_DISTRIBUTION_END";
        /**
         * Put the widths to start and to the end of the width table and fill the gap between with the default width
         */
        GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_START_END"] = 5] = "WIDTH_DISTRIBUTION_START_END";
    })(GreasedLineMeshWidthDistribution || (GreasedLineMeshWidthDistribution = {}));

    const pWorking = new Vector3();
    const p1 = new Vector3();
    const p2 = new Vector3();
    const p3 = new Vector3();
    const uv1 = new Vector2();
    const uv2 = new Vector2();
    const uv3 = new Vector2();
    const workingUv = new Vector2();
    const workingUv2 = new Vector2();
    const working1 = new Vector3();
    class UVMapHelper {
        generateUVMapInPlace(vertexData, feature, indexList) {
            const newControlPointMap = {};
            const axis = feature.projectionAxis.toVec3();
            const rotation = rotationToVector(axis, new Vector3(0, 1, 0));
            rotation.multiplyInPlace(Quaternion.RotationAxis(new Vector3(0, 1, 0), (feature.angle / 180) * Math.PI));
            // const matrixRotation = new Matrix();
            // Matrix.FromQuaternionToRef(rotation, matrixRotation);
            const transformMatrix = Matrix.Compose(feature.scale ? feature.scale.toVec3() : Vector3.One(), rotation, Vector3.Zero());
            const transformMatrixInv = Matrix.Invert(transformMatrix);
            if (!vertexData.positions) {
                throw Error('No vertex positions on mesh');
            }
            if (!vertexData.indices) {
                throw Error('No vertex indices on mesh');
            }
            const geometryPositions = vertexData.positions;
            const geometryIndices = vertexData.indices;
            const controlPointCount = geometryPositions.length / 3;
            const newUvs = vertexData.uvs && vertexData.uvs.length === controlPointCount * 2
                ? new Float32Array(vertexData.uvs)
                : new Float32Array(controlPointCount * 2);
            const appendVertexData = {
                positions: [],
                normals: [],
                uvs: [],
            };
            const nbFaces = indexList ? indexList.length / 3 : geometryIndices.length / 3;
            const touchedControlPoints = new Int8Array(controlPointCount);
            if (indexList) {
                indexList.forEach(index => {
                    touchedControlPoints[geometryIndices[index]] = 1;
                });
            }
            const outputUvs = [uv1, uv2, uv3];
            for (let i = 0; i < nbFaces; i++) {
                /** here we generate the new UVs */
                let i1;
                let i2;
                let i3;
                if (indexList) {
                    i1 = indexList[i * 3];
                    i2 = indexList[i * 3 + 1];
                    i3 = indexList[i * 3 + 2];
                }
                else {
                    i1 = i * 3;
                    i2 = i * 3 + 1;
                    i3 = i * 3 + 2;
                }
                const v1 = geometryIndices[i1];
                const v2 = geometryIndices[i2];
                const v3 = geometryIndices[i3];
                if (feature.mode === exports.eUvMode.useExisting) {
                    if (vertexData.uvs) {
                        const angle = (feature.angle / 180) * Math.PI;
                        const vertices = [v1, v2, v3];
                        for (let i = 0; i < 3; i++) {
                            const uvIdx = vertices[i] * 2;
                            const u = vertexData.uvs[uvIdx] - 0.5;
                            const v = vertexData.uvs[uvIdx + 1] - 0.5;
                            let newU = u * Math.cos(angle) - v * Math.sin(angle) + 0.5;
                            let newV = u * Math.sin(angle) + v * Math.cos(angle) + 0.5;
                            newU = newU * feature.uTile + feature.uOffset;
                            newV = newV * feature.vTile + feature.vOffset;
                            outputUvs[i].copyFromFloats(newU, newV);
                        }
                    }
                }
                else {
                    const start = v1 * 3;
                    p1.copyFromFloats(geometryPositions[start], geometryPositions[start + 1], geometryPositions[start + 2]);
                    const start2 = v2 * 3;
                    p2.copyFromFloats(geometryPositions[start2], geometryPositions[start2 + 1], geometryPositions[start2 + 2]);
                    const start3 = v3 * 3;
                    p3.copyFromFloats(geometryPositions[start3], geometryPositions[start3 + 1], geometryPositions[start3 + 2]);
                    const normal = computeNormal([p1, p2, p3]);
                    applyMatrix4(normal, transformMatrixInv);
                    if (feature.center) {
                        const center = feature.center.toVec3();
                        p1.subtractInPlace(center);
                        p2.subtractInPlace(center);
                        p3.subtractInPlace(center);
                    }
                    this.updateFaceUVMapToRef(normal, p1, feature, transformMatrixInv, uv1);
                    this.updateFaceUVMapToRef(normal, p2, feature, transformMatrixInv, uv2);
                    this.updateFaceUVMapToRef(normal, p3, feature, transformMatrixInv, uv3);
                    /**
                     * Find the UV at the midpoint position between each edge of the polygon.
                     * This should closely match the midpoints of the generated vertex UVs.If it does not, we must wrap the UVs at that edge to avoid a UV seam.
                     * The tolerance is an arbitrary number to avoid artifacts. If wrapping is occuring when it shouldn't, increase this number.
                     * If wrapping is not occurring when it should, reduce it.
                     * As you try to wrap a uv on polygons that are not arranged in a good way to accept them (i.e wrap a sphere onto a 8-vertex cube), the error will become significant.
                     */
                    const tolerance = 0.05;
                    working1.copyFrom(p1);
                    this.updateFaceUVMapToRef(normal, working1.addInPlace(p2).scaleInPlace(0.5), feature, transformMatrixInv, workingUv);
                    workingUv2.copyFrom(uv1);
                    workingUv2.addInPlace(uv2).scaleInPlace(0.5);
                    workingUv.subtractInPlace(workingUv2);
                    if (Math.abs(workingUv.x % 1) > tolerance) {
                        if (uv1.x > uv2.x)
                            uv1.x -= 1;
                        else
                            uv2.x -= 1;
                    }
                    if (Math.abs(workingUv.y % 1) > tolerance) {
                        if (uv1.y > uv2.y)
                            uv1.y -= 1;
                        else
                            uv2.y -= 1;
                    }
                    if (uv2.x >= 0 && uv2.y >= 0) {
                        working1.copyFrom(p2);
                        this.updateFaceUVMapToRef(normal, working1.addInPlace(p3).scaleInPlace(0.5), feature, transformMatrixInv, workingUv);
                        workingUv2.copyFrom(uv2);
                        workingUv2.addInPlace(uv3).scaleInPlace(0.5);
                        workingUv.subtractInPlace(workingUv2);
                        if (Math.abs(workingUv.x % 1) > tolerance) {
                            if (uv2.x > uv3.x)
                                uv2.x -= 1;
                            else
                                uv3.x -= 1;
                        }
                        if (Math.abs(workingUv.y % 1) > tolerance) {
                            if (uv2.y > uv3.y)
                                uv2.y -= 1;
                            else
                                uv3.y -= 1;
                        }
                    }
                    if (uv1.x >= 0 && uv1.y >= 0 && uv3.x >= 0 && uv3.y >= 0) {
                        working1.copyFrom(p1);
                        this.updateFaceUVMapToRef(normal, working1.addInPlace(p3).scaleInPlace(0.5), feature, transformMatrixInv, workingUv);
                        workingUv2.copyFrom(uv1);
                        workingUv2.addInPlace(uv3).scaleInPlace(0.5);
                        workingUv.subtractInPlace(workingUv2);
                        if (Math.abs(workingUv.x % 1) > tolerance) {
                            if (uv1.x > uv3.x)
                                uv1.x -= 1;
                            else
                                uv3.x -= 1;
                        }
                        if (Math.abs(workingUv.y % 1) > tolerance) {
                            if (uv1.y > uv3.y)
                                uv1.y -= 1;
                            else
                                uv3.y -= 1;
                        }
                    }
                }
                /** Done generating the new UVs, stored in uv1, uv2 and uv3 for this polygon */
                if (touchedControlPoints[v1]) {
                    expandControlPoints(i1, v1, uv1);
                }
                else {
                    newUvs[v1 * 2] = uv1.x;
                    newUvs[v1 * 2 + 1] = uv1.y;
                }
                if (touchedControlPoints[v2]) {
                    expandControlPoints(i2, v2, uv2);
                }
                else {
                    newUvs[v2 * 2] = uv2.x;
                    newUvs[v2 * 2 + 1] = uv2.y;
                }
                if (touchedControlPoints[v3]) {
                    expandControlPoints(i3, v3, uv3);
                }
                else {
                    newUvs[v3 * 2] = uv3.x;
                    newUvs[v3 * 2 + 1] = uv3.y;
                }
                touchedControlPoints[v1] = 1;
                touchedControlPoints[v2] = 1;
                touchedControlPoints[v3] = 1;
            }
            if (appendVertexData.positions.length > 0) {
                const newPositions = new Float32Array(vertexData.positions.length + appendVertexData.positions.length);
                newPositions.set(vertexData.positions);
                newPositions.set(appendVertexData.positions, vertexData.positions.length);
                vertexData.positions = newPositions;
            }
            if (vertexData.normals && appendVertexData.normals.length > 0) {
                const newNormals = new Float32Array(vertexData.normals.length + appendVertexData.normals.length);
                newNormals.set(vertexData.normals);
                newNormals.set(appendVertexData.normals, vertexData.normals.length);
                vertexData.normals = newNormals;
            }
            if (appendVertexData.uvs.length > 0) {
                const newUvsTyped = new Float32Array(newUvs.length + appendVertexData.uvs.length);
                newUvsTyped.set(newUvs);
                newUvsTyped.set(appendVertexData.uvs, newUvs.length);
                vertexData.uvs = newUvsTyped;
            }
            else {
                vertexData.uvs = new Float32Array(newUvs);
            }
            return vertexData;
            function expandControlPoints(index, vertexIndex, newUv) {
                if (newUvs[vertexIndex * 2] !== newUv.x || newUvs[vertexIndex * 2 + 1] !== newUv.y) {
                    if (!vertexData.positions || !vertexData.indices) {
                        throw Error('Invalid geometry: positions or indices are null');
                    }
                    const indices = vertexData.indices;
                    const positions = vertexData.positions;
                    const normals = vertexData.normals;
                    const key = positions[vertexIndex * 3].toPrecision(6) +
                        ',' +
                        positions[vertexIndex * 3 + 1].toPrecision(6) +
                        ',' +
                        positions[vertexIndex * 3 + 2].toPrecision(6) +
                        '_' +
                        (normals
                            ? normals[vertexIndex * 3].toPrecision(6) +
                                ',' +
                                normals[vertexIndex * 3 + 1].toPrecision(6) +
                                ',' +
                                normals[vertexIndex * 3 + 2].toPrecision(6) +
                                '_'
                            : '') +
                        newUv.x.toPrecision(6) +
                        ',' +
                        newUv.y.toPrecision(6);
                    if (newControlPointMap[key]) {
                        indices[index] = newControlPointMap[key];
                    }
                    else {
                        const newVertexIndex = (positions.length + appendVertexData.positions.length) / 3;
                        indices[index] = newVertexIndex;
                        appendVertexData.positions.push(...positions.slice(vertexIndex * 3, vertexIndex * 3 + 3));
                        if (vertexData.normals) {
                            appendVertexData.normals.push(...vertexData.normals.slice(vertexIndex * 3, vertexIndex * 3 + 3));
                        }
                        appendVertexData.uvs.push(newUv.x, newUv.y);
                        if (vertexData.submeshData) {
                            for (let i = 0; i < vertexData.submeshData.length; i++) {
                                const submeshData = vertexData.submeshData[i];
                                if (submeshData.verticesStart <= vertexIndex &&
                                    submeshData.verticesStart + submeshData.verticesCount > vertexIndex) {
                                    submeshData.verticesCount += 1;
                                }
                                else if (submeshData.verticesStart > vertexIndex) {
                                    submeshData.verticesStart += 1;
                                }
                            }
                        }
                        newControlPointMap[key] = newVertexIndex;
                    }
                }
            }
        }
        computeAutoFitSize(mesh) {
            const boundingBox = mesh.getBoundingInfo().boundingBox;
            //const center = boundingBox.center;
            const max = boundingBox.maximum;
            const min = boundingBox.minimum;
            return new exports.KbVector(max.x - min.x, max.y - min.y, max.z - min.z);
        }
        updateFaceUVMapToRef(faceNormal, position, feat, transformMatrixInv, uv) {
            pWorking.copyFrom(position);
            applyMatrix4(pWorking, transformMatrixInv);
            switch (feat.mode) {
                case exports.eUvMode.planar:
                    this.planarUVMap(pWorking, uv);
                    break;
                case exports.eUvMode.box:
                    this.boxUVMap(pWorking, faceNormal, uv);
                    break;
                case exports.eUvMode.cylindrical:
                    this.cylindricalUVMap(pWorking, uv);
                    break;
                case exports.eUvMode.spherical:
                    this.sphericalUVMap(pWorking, uv);
                    break;
                case exports.eUvMode.useExisting:
                    //don't do anything so that existing UVs of mesh are being used instead
                    break;
                default:
                    uv.set(0, 0);
                    break;
            }
            if (feat.uTile && feat.uTile !== 1) {
                uv.x *= feat.uTile;
            }
            if (feat.vTile && feat.vTile !== 1) {
                uv.y *= feat.vTile;
            }
            return uv;
        }
        planarUVMap(vertex, uv) {
            let u = vertex.x;
            let v = -vertex.z;
            u = u + 0.5;
            v = v + 0.5;
            uv.set(u, v);
            return uv;
        }
        cylindricalUVMap(vertex, uv) {
            let lon;
            if (vertex.x === 0 && vertex.z === 0) {
                lon = 0;
            }
            else {
                lon = Math.atan2(vertex.x, vertex.z);
                if (lon < 0) {
                    lon += Math.PI * 2;
                }
            }
            const t = vertex.y + 0.5;
            lon = lon / (Math.PI * 2);
            uv.set(lon, t);
            return uv;
        }
        boxUVMap(vertex, normal, uv) {
            let s = 0, t = 0;
            const x = vertex.x, y = vertex.y, z = vertex.z;
            const nx = Math.abs(normal.x), ny = Math.abs(normal.y), nz = Math.abs(normal.z);
            if (nx >= ny && nx >= nz) {
                s = -z + 0.5;
                t = y + 0.5;
            }
            if (ny >= nx && ny >= nz) {
                s = x + 0.5;
                t = -z + 0.5;
            }
            if (nz >= nx && nz >= ny) {
                s = x + 0.5;
                t = y + 0.5;
            }
            // not sure what this is for but it screws up the mapping and flips the uv's halfway through
            // if (normal.x < 0) {
            //     s = -s + 1
            // }
            // if (normal.y < 0) {
            //     s = -s + 1
            // }
            // if (normal.z < 0) {
            //     s = -s + 1
            // }
            uv.set(s, t);
            return uv;
        }
        sphericalUVMap(vertex, uv) {
            const newVertex = vertex.clone();
            const lonlat = xyzToLongitudeLatitude(newVertex.x, -newVertex.y, newVertex.z);
            const lon = lonlat.lon / (Math.PI * 2);
            const lat = 0.5 - lonlat.lat / Math.PI;
            uv.set(lon, lat);
            return uv;
            function xyzToLongitudeLatitude(x, y, z) {
                let lo, la;
                const EPSILON = 1e-6;
                if (Math.abs(x) < EPSILON && Math.abs(z) < EPSILON) {
                    lo = 0;
                    if (Math.abs(y) < EPSILON) {
                        la = 0;
                    }
                    else {
                        la = y < 0 ? -(Math.PI / 2) : Math.PI / 2;
                    }
                }
                else {
                    lo = Math.atan2(x, z);
                    if (lo < 0) {
                        lo += Math.PI * 2;
                    }
                    const h = Math.sqrt(x * x + z * z);
                    la = Math.atan2(y, h);
                }
                return {
                    lon: lo,
                    lat: la,
                };
            }
        }
    }
    function createUvMapVisualization(uvMap, scene, color) {
        let uvMapVisualization;
        if (!color) {
            color = Color3.Yellow();
        }
        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;
        if (uvMap.mode === exports.eUvMode.spherical) {
            uvMapVisualization = CreateSphere('UvMapSphere', { segments: 6 }, scene);
        }
        else if (uvMap.mode === exports.eUvMode.cylindrical) {
            uvMapVisualization = CreateCylinder('UvMapCylinder', { tessellation: 10 }, scene);
        }
        else if (uvMap.mode === exports.eUvMode.box) {
            uvMapVisualization = CreateBox('UvBox', {}, scene);
        }
        else if (uvMap.mode === exports.eUvMode.planar) {
            uvMapVisualization = CreatePlane('mirrorPlane', {}, scene);
            uvMapVisualization.rotation = new Vector3(Math.PI / 2, 0, 0);
            uvMapVisualization.bakeCurrentTransformIntoVertices();
        }
        else {
            uvMapVisualization = CreatePlane('mirrorPlane', {}, scene);
            uvMapVisualization.bakeCurrentTransformIntoVertices();
            uvMapVisualization.setEnabled(false);
        }
        uvMapVisualization.material = coloredMaterial;
        return uvMapVisualization;
    }

    function removeVerticesFromAll(vertexGroups, startIndex, endIndex) {
        for (let i = 0; i < vertexGroups.length; i++) {
            const vertexGroup = vertexGroups[i];
            if (vertexGroupsIntersect(vertexGroup, startIndex, endIndex)) {
                const result = excludeVertices(vertexGroup, startIndex, endIndex);
                vertexGroups.splice(i, 1, ...result);
            }
        }
    }
    function mergeVerticesIntoAll(vertexGroups, newVertex) {
        vertexGroups.push(newVertex);
        vertexGroups.sort((a, b) => a.startIndex - b.startIndex);
        for (let i = 0; i < vertexGroups.length; i++) {
            const vertexGroup = vertexGroups[i];
            const nextVertexGroup = vertexGroups[i + 1];
            if (nextVertexGroup && nextVertexGroup.startIndex < vertexGroup.endIndex) {
                const mergedVertexGroup = { ...vertexGroup, endIndex: nextVertexGroup.endIndex };
                vertexGroups.splice(i, 2, mergedVertexGroup);
                i--;
            }
        }
    }
    function excludeVertices(vertexGroup, startIndex, endIndex) {
        if (vertexGroupsIntersect(vertexGroup, startIndex, endIndex)) {
            const result = [];
            // Maintain the selections of either side of the current vertex
            if (startIndex > vertexGroup.startIndex) {
                result.push({
                    ...vertexGroup,
                    endIndex: startIndex,
                });
            }
            if (endIndex < vertexGroup.endIndex) {
                result.push({
                    ...vertexGroup,
                    startIndex: endIndex,
                });
            }
            return result;
        }
        else {
            return [vertexGroup];
        }
    }
    function mergeVertices(vertexGroup, newVertex) {
        const result = [];
        const newVertexGroup = { ...vertexGroup };
        const startIndex = newVertex.startIndex;
        const endIndex = newVertex.endIndex;
        if (vertexGroupsIntersect(vertexGroup, startIndex, endIndex)) {
            // Maintain the selections of either side of the current vertex
            if (startIndex < vertexGroup.startIndex) {
                newVertexGroup.startIndex = startIndex;
            }
            if (endIndex > vertexGroup.endIndex) {
                newVertexGroup.endIndex = endIndex;
            }
            result.push(newVertexGroup);
        }
        else {
            if (startIndex > vertexGroup.startIndex) {
                result.push(newVertexGroup, newVertex);
            }
            else {
                result.push(newVertex, newVertexGroup);
            }
        }
        return result;
    }
    function vertexGroupsIntersect(vertexGroup, startIndex, endIndex) {
        return startIndex <= vertexGroup.endIndex && endIndex >= vertexGroup.startIndex;
    }

    function createViewpointVisualization(viewpoint, scene, color) {
        if (!color) {
            color = Color3.Green();
        }
        let targetPositionMarker;
        const viewpointPositionGizmo = MeshBuilder.CreateCylinder('cameraGizmoLens', { diameterTop: 0.3, height: 0.2, diameterBottom: 0.2, tessellation: 8 }, scene);
        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;
        viewpointPositionGizmo.material = coloredMaterial;
        const lightPositionGizmoBox = MeshBuilder.CreateBox('cameraGizmoBody', { size: 0.4 }, scene);
        lightPositionGizmoBox.setParent(viewpointPositionGizmo);
        lightPositionGizmoBox.position = new Vector3(0, -0.3, 0);
        lightPositionGizmoBox.material = coloredMaterial;
        viewpointPositionGizmo.isPickable = false;
        viewpointPositionGizmo.setEnabled(true);
        if (viewpoint.type === exports.eViewpointType.orbit && viewpoint.targetMode === exports.eViewpointTargetMode.point) {
            targetPositionMarker = MeshBuilder.CreateSphere('viewpointTargetMarker', { diameter: 0.15 }, scene);
            const coloredMaterial = new StandardMaterial('', scene);
            coloredMaterial.emissiveColor = color;
            targetPositionMarker.material = coloredMaterial;
            targetPositionMarker.isPickable = false;
            targetPositionMarker.setEnabled(true);
        }
        return { viewpointPositionGizmo, targetPositionMarker };
    }

    /** The maxiumum amount of allowed time to spend in a single render cycle, to avoid locking the browser */
    const MAX_RENDER_TIME = 20000;
    class Renderer {
        constructor(viewer, scene) {
            this.viewer = viewer;
            this.scene = scene;
            this.babylonMap = new Map();
        }
        /**
         * Determines whether the given node should be handled by this renderer.  Can be
         * overriden for special behavior
         */
        handlesNode(node) {
            return instanceOf(node, this.modelToken);
        }
        update3d(node) {
            this.update3dInternal(node);
            if (this.viewer.options.validator) {
                this.viewer.options.validator.validateNode(node);
            }
        }
        delete3d(node) {
            const o = this.babylonMap.get(node._dynamicId);
            if (o) {
                if (o instanceof Material) {
                    o.dispose(true, true);
                }
                else {
                    o.dispose();
                }
            }
            this.babylonMap.delete(node._dynamicId);
            SyncService.nodeDeletionProcessed(node);
        }
        get3d(node) {
            return this.babylonMap.get(node._dynamicId);
        }
        set3d(node, babylonObject) {
            this.babylonMap.set(node._dynamicId, babylonObject);
        }
        getChanges(node) {
            const isNew = this.get3d(node) == null;
            const changes = new Map(node.changes);
            if (isNew) {
                for (const prop in node) {
                    changes.set(prop, node[prop]);
                }
            }
            return changes;
        }
        dispose() {
            this.babylonMap.clear();
        }
    }

    const TEXT_RESOLUTION = 128;
    class AnnotationRenderer extends Renderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene);
            this.viewer = viewer;
            this.scene = scene;
            this.rendererManager = rendererManager;
            this.modelToken = Token.AnnotationNode;
            this.annotationStore = new Map();
            this.billboards = new Map();
            this.utilityLayer = viewer.utilityLayer;
            scene.registerBeforeRender(() => {
                if (scene.activeCamera && this.billboards.size > 0) {
                    this.billboards.forEach(meshInfo => {
                        const camera = scene.activeCamera;
                        meshInfo.rootMesh.lookAt(getCameraPositionWithOffset(camera), 0, Math.PI / 2);
                        if (meshInfo.rootMesh.parent) {
                            if (!meshInfo.rootMesh.rotationQuaternion) {
                                meshInfo.rootMesh.rotationQuaternion = Quaternion.Identity();
                            }
                            const parentRotation = meshInfo.rootMesh.parent.computeWorldMatrix().getRotationMatrix();
                            parentRotation.invert();
                            const parentRotationQuat = Quaternion.FromRotationMatrix(parentRotation);
                            meshInfo.rootMesh.rotationQuaternion = parentRotationQuat.multiplyInPlace(meshInfo.rootMesh.rotationQuaternion);
                        }
                    });
                }
            });
        }
        update3dInternal(node) {
            var _a, _b, _c, _d;
            let annotationInfo = this.annotationStore.get(node._dynamicId);
            if (!annotationInfo) {
                annotationInfo = {
                    positionNeedsUpdate: false,
                    textNeedsUpdate: false,
                    lineNeedsUpdate: false,
                };
                this.annotationStore.set(node._dynamicId, annotationInfo);
            }
            if (annotationInfo.meshInfo && node.changes.has('keepOnTop')) {
                this.delete3d(node, true);
                annotationInfo.meshInfo = undefined;
                annotationInfo.positionNeedsUpdate = true;
                annotationInfo.textNeedsUpdate = true;
                annotationInfo.lineNeedsUpdate = true;
            }
            const scene = node.keepOnTop ? this.utilityLayer.utilityLayerScene : this.scene;
            if ((!annotationInfo.meshInfo && node.enabled && node.targetId) ||
                (node.changes.hasAny('isPickable') && node.enabled && node.targetId)) {
                if (annotationInfo.meshInfo) {
                    annotationInfo.meshInfo = undefined;
                }
                annotationInfo.meshInfo = createAnnotationTextModels(node, scene);
                // Put the annotation on the parent scene so the scene visibility affects the node
                if (node._parentScene) {
                    const parentSceneMesh = this.viewer.getRendererNode(node._parentScene);
                    annotationInfo.meshInfo.rootMesh.setParent(parentSceneMesh);
                }
                this.set3d(node, annotationInfo.meshInfo.rootMesh);
            }
            const meshInfo = annotationInfo.meshInfo;
            // Set position of annotation
            if (node.changes.hasAny('targetId', 'offset', 'billboard', 'horizontalBoxAlign', 'verticalBoxAlign')) {
                annotationInfo.positionNeedsUpdate = true;
            }
            if (node.changes.hasAny('color', 'lineStyle')) {
                annotationInfo.lineNeedsUpdate = true;
            }
            if (node.changes.hasAny('fontFamily', 'fontSize', 'lineSpacing', 'label', 'color', 'preloadFontStylesheet', 'horizontalTextAlign')) {
                annotationInfo.textNeedsUpdate = true;
            }
            if (meshInfo) {
                if (node.changes.hasAny('enabled', 'billboard', 'keepOnTop')) {
                    if (node.enabled && node.billboard) {
                        this.billboards.set(node._dynamicId, meshInfo);
                    }
                    else {
                        this.billboards.delete(node._dynamicId);
                    }
                }
                let needsFont = false;
                if (node.preloadFontStylesheet && node.fontFamily) {
                    const fontService = node._manager.getService(Token.FontService);
                    if (!fontService.readyFonts.has(node.fontFamily)) {
                        needsFont = true;
                        fontService.loadFont(node.preloadFontStylesheet, [node.fontFamily]).then(resultFonts => {
                            if (resultFonts.length > 0) {
                                node.setPropertyIsModified('fontFamily', true);
                            }
                        });
                    }
                }
                if (node.enabled && node.targetId && !needsFont) {
                    const color = node.color.toColor4();
                    if (annotationInfo.positionNeedsUpdate) {
                        let targetNode;
                        if (node.targetId && node._manager) {
                            const manager = node._manager;
                            targetNode = manager.getById(node.targetId);
                        }
                        if (annotationInfo.boundingInfo &&
                            annotationInfo.boundingInfo.targetNode._dynamicId !== (targetNode === null || targetNode === void 0 ? void 0 : targetNode._dynamicId)) {
                            annotationInfo.boundingInfo.subscription.unsubscribe();
                        }
                        if (targetNode) {
                            if (targetNode instanceof exports.Connector) {
                                // Only supporting connectors for now
                                if (targetNode._parent) {
                                    annotationInfo.boundingInfo = {
                                        targetNode: targetNode,
                                        subscription: this.viewer.bbCache
                                            .watchForChanges(targetNode._parent)
                                            .subscribe(() => {
                                            node.setPropertyIsModified('targetId', true);
                                        }),
                                    };
                                }
                            }
                            const transform = this.updatePositionFromAnnotation(node, targetNode, meshInfo);
                            if (transform) {
                                meshInfo.rootMesh.position = transform.position;
                                // The annotation plane mesh position doesn't update in certain situations when the parent transform is moved,
                                // so we have to manually update the world matrix
                                meshInfo.rootMesh.getChildMeshes().forEach(mesh => mesh.computeWorldMatrix(true));
                                meshInfo.textContainer.rotationQuaternion = transform.textRotation;
                                if (!node.billboard) {
                                    meshInfo.rootMesh.rotationQuaternion = transform.rotation;
                                }
                                if (transform && transform.offset && transform.lineOffset && node.offset.length() > 0) {
                                    const basePoint = transform.position.subtract(transform.offset);
                                    meshInfo.line = {
                                        points: [basePoint, basePoint.add(transform.lineOffset)],
                                        updatable: true,
                                        colors: [color, color],
                                        instance: (_a = meshInfo.line) === null || _a === void 0 ? void 0 : _a.instance,
                                    };
                                    // If the line is not getting rebuilt, then just update the line position
                                    if (!annotationInfo.lineNeedsUpdate) {
                                        meshInfo.line.instance = drawLine(node, meshInfo.line, 1, scene);
                                    }
                                }
                                else {
                                    if ((_b = meshInfo.line) === null || _b === void 0 ? void 0 : _b.instance) {
                                        meshInfo.line.instance.dispose();
                                    }
                                    meshInfo.line = undefined;
                                }
                            }
                            annotationInfo.positionNeedsUpdate = false;
                        }
                    }
                    if (annotationInfo.lineNeedsUpdate) {
                        if (meshInfo.line) {
                            if (meshInfo.line.instance) {
                                meshInfo.line.instance.dispose();
                                meshInfo.line.instance = undefined;
                            }
                            meshInfo.line.colors = [];
                            for (let i = 0; i < meshInfo.line.points.length; i++) {
                                meshInfo.line.colors.push(color);
                            }
                            meshInfo.line.instance = drawLine(node, meshInfo.line, 1, scene);
                            if (meshInfo.line.instance && node._parentScene) {
                                const parentSceneMesh = this.viewer.getRendererNode(node._parentScene);
                                meshInfo.line.instance.parent = parentSceneMesh;
                            }
                            annotationInfo.lineNeedsUpdate = false;
                        }
                    }
                    if (annotationInfo.textNeedsUpdate) {
                        updateAnnotationText(node, meshInfo.textMesh, meshInfo.textMaterial, this.scene.getEngine().webGLVersion < 2);
                        annotationInfo.textNeedsUpdate = false;
                    }
                }
                const enabled = node.enabled && !!node.targetId;
                if (meshInfo.rootMesh.isEnabled() !== enabled) {
                    meshInfo.rootMesh.setEnabled(enabled);
                    (_d = (_c = meshInfo.line) === null || _c === void 0 ? void 0 : _c.instance) === null || _d === void 0 ? void 0 : _d.setEnabled(enabled);
                }
            }
        }
        dispose() {
            this.billboards.clear();
            this.annotationStore.clear();
            super.dispose();
        }
        delete3d(node, keepInStore = false) {
            var _a;
            const annotationModels = this.annotationStore.get(node._dynamicId);
            if (annotationModels && annotationModels.meshInfo) {
                annotationModels.meshInfo.rootMesh.dispose();
                if ((_a = annotationModels.meshInfo.line) === null || _a === void 0 ? void 0 : _a.instance) {
                    annotationModels.meshInfo.line.instance.dispose();
                }
            }
            if (!keepInStore) {
                this.annotationStore.delete(node._dynamicId);
                this.billboards.delete(node._dynamicId);
            }
            super.delete3d(node);
        }
        updatePositionFromAnnotation(node, targetNode, meshInfo) {
            let newPosition;
            let newDirection;
            let newAngle;
            // Only supporting connectors for now, but could support direct mesh targets in the future
            if (targetNode instanceof exports.Connector) {
                newPosition = getPositionFromConnnector(targetNode, this.rendererManager, node._parentScene);
                newDirection = targetNode.direction.toVec3();
                newAngle = targetNode.angle;
            }
            if (newPosition && newDirection && newAngle !== undefined) {
                const newOffset = node.offset.toVec3();
                if (meshInfo) {
                    const newPivot = new Vector3(0, 0, 0);
                    if (node.horizontalBoxAlign == 'left') {
                        meshInfo.rootMesh.getPivotPoint();
                        newOffset.x += meshInfo.textMesh.scaling.x / 2;
                        newPivot.x -= meshInfo.textMesh.scaling.x / 2;
                    }
                    else if (node.horizontalBoxAlign == 'right') {
                        newOffset.x -= meshInfo.textMesh.scaling.x / 2;
                        newPivot.x += meshInfo.textMesh.scaling.x / 2;
                    }
                    if (node.verticalBoxAlign == 'top') {
                        newOffset.z += meshInfo.textMesh.scaling.z / 2;
                        newPivot.z -= meshInfo.textMesh.scaling.z / 2;
                    }
                    else if (node.verticalBoxAlign == 'bottom') {
                        newOffset.z -= meshInfo.textMesh.scaling.z / 2;
                        newPivot.z += meshInfo.textMesh.scaling.z / 2;
                    }
                    meshInfo.rootMesh.setPivotPoint(newPivot);
                }
                const transform = calculateTransform(newPosition, newDirection, newAngle, newOffset, node.offset.toVec3());
                return transform;
            }
        }
    }
    function createAnnotationTextModels(node, scene, isPickable = false) {
        const containerMesh = new TransformNode(node._dynamicId, scene);
        //Create plane
        const plane = PlaneBuilder.CreatePlane(`${node._dynamicId}_plane`, {
            width: 1,
            height: 1,
            frontUVs: new Vector4(1, 0, 0, 1),
            backUVs: new Vector4(0, 0, 1, 1),
            sideOrientation: Mesh.DOUBLESIDE,
            sourcePlane: new Plane(0, 1, 0, 0),
        }, scene);
        const planeContainer = new TransformNode(`${node._dynamicId}_planeContainer`);
        const dynamicTexture = new DynamicTexture(`${node._dynamicId}_planeTexture`, { width: TEXT_RESOLUTION, height: TEXT_RESOLUTION }, scene, true);
        dynamicTexture.isBlocking = false;
        dynamicTexture.hasAlpha = true;
        //create material
        const mat = new PBRMaterial(`${node._dynamicId}_mat`, scene);
        if (node.keepOnTop) {
            mat.emissiveColor = Color3.White();
        }
        mat.albedoTexture = dynamicTexture;
        mat.useAlphaFromAlbedoTexture = true;
        mat.backFaceCulling = true;
        mat.zOffset = -1;
        mat.albedoColor = Color3.White();
        mat.roughness = 1;
        mat.metallic = 0;
        //apply material
        plane.material = mat;
        plane.parent = planeContainer;
        planeContainer.parent = containerMesh;
        plane.isPickable = isPickable || node.isPickable;
        const annotationModels = {
            textMesh: plane,
            textContainer: planeContainer,
            textMaterial: mat,
            rootMesh: containerMesh,
            billboard: node.billboard,
            positionNeedsUpdate: false,
            textNeedsUpdate: false,
        };
        return annotationModels;
    }
    function updateAnnotationText(node, mesh, textMaterial, webgl1Context, defaultValue = ' ', values = {}) {
        const mat = textMaterial;
        const dynamicTexture = mat.albedoTexture;
        const fontFamily = node.fontFamily || 'Arial';
        const labelSize = node.fontSize;
        const labelText = evalHandlebarString(node.label || defaultValue, values);
        const textGap = node.lineSpacing;
        const textColor = node.color.toColor3().toLinearSpace();
        if (node.keepOnTop) {
            mat.emissiveColor = textColor;
        }
        // Determine the space needed for the text
        const ctx = dynamicTexture.getContext();
        ctx.font = TEXT_RESOLUTION + 'px ' + fontFamily;
        const labelStats = getMultiLineStats(labelText, ctx);
        const textWidth = labelStats.maximumWidth;
        const textHeight = labelStats.maximumHeight;
        const labelArray = labelStats.labelArray;
        const lineWidths = labelStats.lineWidths;
        labelArray.reverse();
        lineWidths.reverse();
        const totalCanvasHeight = (textHeight + textGap) * labelArray.length - textGap;
        ctx.clearRect(0 - textWidth / 2, 0, textWidth / 2, totalCanvasHeight);
        //ctx.clearRect(0, 0, textWidth, totalCanvasHeight);
        let heightRatioChange = 1;
        if (labelArray.length > 1) {
            heightRatioChange = totalCanvasHeight / textHeight;
        }
        mesh.scaling = new Vector3((textWidth / textHeight) * labelSize, labelSize * heightRatioChange, 1);
        let textBaseline = 'bottom';
        if (labelStats.maximumDescent > 0) {
            textBaseline = 'alphabetic';
        }
        let drawFont;
        if (webgl1Context) {
            let textureSize = getBinClampedSize(textWidth, totalCanvasHeight, 'ceil');
            if (textureSize > 2048) {
                textureSize = 2048;
            }
            dynamicTexture.scaleTo(textureSize, textureSize);
            ctx.scale(textureSize / textWidth, textureSize / totalCanvasHeight);
            drawFont = TEXT_RESOLUTION + 'px ' + fontFamily;
        }
        else {
            dynamicTexture.scaleTo(textWidth, totalCanvasHeight);
            drawFont = TEXT_RESOLUTION + 'px ' + fontFamily;
        }
        ctx.font = drawFont;
        if (ctx instanceof CanvasRenderingContext2D) {
            ctx.textBaseline = textBaseline;
        }
        ctx.fillStyle = textColor.toHexString();
        let drawHeight = totalCanvasHeight;
        for (let i = 0; i < labelArray.length; i++) {
            const lineWidth = lineWidths[i];
            //ctx.fillStyle = 'rgb(132,244,235, 0.3)';
            //ctx.fillRect(0, 0, textWidth, (textHeight + textGap) * labelArray.length - textGap);
            //rightAllign
            if (node.horizontalTextAlign === 'right') {
                ctx.fillText(labelArray[i], textWidth - lineWidth, drawHeight - labelStats.maximumDescent);
            }
            //leftAllign
            else if (node.horizontalTextAlign === 'left') {
                ctx.fillText(labelArray[i], 0, drawHeight - labelStats.maximumDescent);
            }
            else {
                //centered:
                ctx.fillText(labelArray[i], textWidth / 2 - lineWidth / 2, drawHeight - labelStats.maximumDescent);
            }
            drawHeight = drawHeight - textHeight - textGap;
        }
        // reset the context
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        dynamicTexture.update(true);
    }
    function getPositionFromConnnector(targetNode, rendererManager, relativeToScene) {
        const targetMesh = rendererManager.connector.get3d(targetNode);
        if (targetMesh) {
            targetMesh.computeWorldMatrix(true);
            const result = targetMesh.absolutePosition.clone();
            if (relativeToScene) {
                const sceneMesh = rendererManager.viewer.getRendererNode(relativeToScene);
                if (sceneMesh) {
                    // console.log('pre', newPosition, newDirection, newAngle);
                    const transform = sceneMesh.getWorldMatrix().clone();
                    transform.invert();
                    return Vector3.TransformCoordinates(result, transform);
                }
            }
            return result;
        }
        return Vector3.Zero();
    }
    function calculateTransform(position, direction, angle, offset, lineOffset) {
        const newPosition = position.clone();
        const newRotation = rotationToVector(direction);
        const textRotation = Quaternion.RotationAxis(Vector3.Up(), (angle - 90) * (Math.PI / 180));
        let offsetWithTransform;
        let lineOffsetWithTransform;
        if (offset) {
            offsetWithTransform = transformVectorWithQuat(offset, newRotation);
            newPosition.addInPlace(offsetWithTransform);
        }
        if (lineOffset) {
            lineOffsetWithTransform = transformVectorWithQuat(lineOffset, newRotation);
        }
        return {
            position: newPosition,
            rotation: newRotation,
            textRotation: textRotation,
            offset: offsetWithTransform,
            lineOffset: lineOffsetWithTransform,
        };
    }
    function drawLine(node, lineInfo, lineLength, scene, distance) {
        if (lineInfo && node.lineStyle !== exports.eAnnotationLineStyle.none) {
            let linesMesh;
            if (node.lineStyle === exports.eAnnotationLineStyle.solid) {
                linesMesh = MeshBuilder.CreateLines(`${node._dynamicId}_line`, lineInfo, scene);
            }
            else {
                lineInfo.dashNb = lineLength * 30;
                if (node.lineStyle === exports.eAnnotationLineStyle.dashed) {
                    lineInfo.gapSize = 4;
                    lineInfo.dashSize = 6;
                    if (distance) {
                        // lineInfo.gapSize *= distance;
                        // lineInfo.dashSize *= distance;
                        lineInfo.dashNb = (lineInfo.dashNb / distance) * 1.5;
                    }
                }
                else {
                    lineInfo.gapSize = 6;
                    lineInfo.dashSize = 1;
                }
                linesMesh = MeshBuilder.CreateDashedLines(`${node._dynamicId}_line`, lineInfo, scene);
                linesMesh.color = node.color.toColor3();
            }
            lineInfo.instance = linesMesh;
            lineInfo.instance.isPickable = false;
            return linesMesh;
        }
    }
    function evalHandlebarString(label, values) {
        if (!label.match(/\{.*\}/)) {
            return label;
        }
        const array = label.matchAll(/\{([\d\w+\-*/]+)\}/g);
        let exp = array.next();
        while (!exp.done) {
            let mathExp = exp.value[1];
            for (const key in values) {
                mathExp = mathExp.replace(key, values[key]);
            }
            if (mathExp.match(/\d/)) {
                // Strip all invalid math expression characters
                mathExp = mathExp.replace(/[^0-9.+*/-]/g, '');
                const numberVal = mathEval(mathExp);
                label = label.replace(exp.value[0], roundToPlaces(numberVal, 0.01).toString(10));
            }
            else {
                label = label.replace(exp.value[0], mathExp);
            }
            exp = array.next();
        }
        return label;
    }
    function getMultiLineStats(label, ctx) {
        // 402 is a florin and 96 is a backtick, generally the tallest and highest characters.
        const fullStringTextSize = ctx.measureText(label + String.fromCharCode(402, 71, 95, 96, 103));
        const substrings = label.split('\\n').map(label => label.trim());
        const lineWidths = [];
        let maximumWidth = 0;
        let maximumHeight = 0;
        let maximumDescent = 0;
        substrings.forEach(string => {
            if (string.length > maximumWidth) {
                maximumWidth = string.length;
            }
            const textSize = ctx.measureText(string);
            if (textSize.actualBoundingBoxLeft !== undefined && textSize.actualBoundingBoxRight !== undefined) {
                const textWidth = Math.abs(textSize.actualBoundingBoxLeft) + Math.abs(textSize.actualBoundingBoxRight);
                if (textWidth > maximumWidth) {
                    maximumWidth = textWidth;
                }
                lineWidths.push(textWidth);
            }
            else {
                if (textSize.width > maximumWidth) {
                    maximumWidth = textSize.width;
                }
                lineWidths.push(textSize.width);
            }
        });
        // The render puppetteer browser does not have fontBoundingBoxAscent or Descent.
        // That would be a better way to measure text for consistency. When upgrading puppeteer see if we can use fontBoundingBoxAscent
        if (fullStringTextSize.actualBoundingBoxAscent !== undefined &&
            fullStringTextSize.actualBoundingBoxDescent !== undefined) {
            maximumHeight =
                Math.abs(fullStringTextSize.actualBoundingBoxAscent) +
                    Math.abs(fullStringTextSize.actualBoundingBoxDescent);
            maximumDescent = fullStringTextSize.actualBoundingBoxDescent;
        }
        if (maximumHeight === 0) {
            maximumHeight = TEXT_RESOLUTION;
        }
        const result = {
            labelArray: substrings,
            lineWidths,
            maximumHeight,
            maximumWidth,
            maximumDescent,
        };
        return result;
    }
    let loopCount = 0;
    function mathEval(exp) {
        loopCount++;
        if (loopCount > 1000) {
            console.warn('escaped infinite loop in math evaluator');
            return NaN;
        }
        if (!exp.match(/\D/)) {
            return parseFloat(exp);
        }
        let result;
        if (exp.match(/\+/)) {
            const parts = exp.split('+').reverse();
            result = mathEval(parts.pop());
            while (parts.length > 0) {
                result += mathEval(parts.pop());
            }
        }
        else if (exp.match(/-/)) {
            const parts = exp.split('-').reverse();
            result = mathEval(parts.pop());
            while (parts.length > 0) {
                result -= mathEval(parts.pop());
            }
        }
        else if (exp.match(/\*/)) {
            const parts = exp.split('*').reverse();
            result = mathEval(parts.pop());
            while (parts.length > 0) {
                result *= mathEval(parts.pop());
            }
        }
        else if (exp.match(/\//)) {
            const parts = exp.split('/').reverse();
            result = mathEval(parts.pop());
            while (parts.length > 0) {
                result /= mathEval(parts.pop());
            }
        }
        else {
            result = parseFloat(exp);
        }
        return result;
    }

    /**
     * Move line position calculation to private function so it can be called from bbSubscription
     * Move text font family creation stuff to common function and call it from here with midpoint of line
     * Store the line mesh in annotationStore, just recreate it from the private function when something changes
     */
    class DimensionRenderer extends Renderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene);
            this.viewer = viewer;
            this.scene = scene;
            this.rendererManager = rendererManager;
            this.modelToken = Token.DimensionNode;
            this.watchPosition = new Map();
            this.dimensionStore = new Map();
            this.billboards = new Map();
            this.utilityLayer = viewer.utilityLayer;
            scene.registerBeforeRender(() => {
                if (scene.activeCamera && this.dimensionStore.size > 0) {
                    this.billboards.forEach(meshInfo => {
                        const camera = scene.activeCamera;
                        meshInfo.rootMesh.lookAt(getCameraPositionWithOffset(camera), 0, Math.PI / 2);
                    });
                }
            });
        }
        update3dInternal(node) {
            var _a, _b, _c;
            let dimensionInfo = this.dimensionStore.get(node._dynamicId);
            if (!dimensionInfo) {
                dimensionInfo = {
                    positionNeedsUpdate: false,
                    textNeedsUpdate: false,
                    lineNeedsUpdate: false,
                    canCreate: false,
                };
                this.dimensionStore.set(node._dynamicId, dimensionInfo);
            }
            const rootMesh = (_a = dimensionInfo.meshInfo) === null || _a === void 0 ? void 0 : _a.rootMesh;
            if (rootMesh && node.scaleWithCamera) {
                if (!node.scaleWithCamera) {
                    this.viewer.camera.clearMaintainedNodeScreenSize(rootMesh);
                }
                else {
                    this.viewer.camera.maintainNodeScreenSize(rootMesh, (dist, mode) => {
                        if (dimensionInfo && dimensionInfo.meshInfo && node.lineStyle === exports.eAnnotationLineStyle.dashed) {
                            this.updateLineFromCamera(node, dimensionInfo.meshInfo, scene, dist);
                        }
                    });
                }
            }
            if (dimensionInfo.meshInfo && node.changes.has('keepOnTop')) {
                this.delete3d(node, true);
                dimensionInfo.meshInfo = undefined;
                dimensionInfo.positionNeedsUpdate = true;
                dimensionInfo.textNeedsUpdate = true;
                dimensionInfo.lineNeedsUpdate = true;
            }
            const scene = node.keepOnTop ? this.utilityLayer.utilityLayerScene : this.scene;
            if (!dimensionInfo.meshInfo && node.enabled && node.targetId) {
                dimensionInfo.meshInfo = {
                    ...createAnnotationTextModels(node, scene, this.viewer.options.editorMode),
                    line: {
                        points: [],
                        colors: [],
                        updatable: true,
                    },
                    lineCap: {
                        lines: [],
                        colors: [],
                        updatable: true,
                    },
                    distance: 0,
                };
                // Put the dimensions on the parent scene so the scene visibility affects the node
                if (node._parentScene) {
                    const parentSceneMesh = this.viewer.getRendererNode(node._parentScene);
                    dimensionInfo.meshInfo.rootMesh.setParent(parentSceneMesh);
                }
                this.set3d(node, dimensionInfo.meshInfo.rootMesh);
            }
            const meshInfo = dimensionInfo.meshInfo;
            // Set position of annotation
            if (node.changes.hasAny('enabled', 'targetId', 'target2Id', 'offset', 'billboard', 'labelOffset', 'axis', 'dimensionGap')) {
                dimensionInfo.positionNeedsUpdate = true;
            }
            if (node.changes.hasAny('color', 'lineStyle', 'lineCapStyle')) {
                dimensionInfo.lineNeedsUpdate = true;
            }
            if (node.changes.hasAny('fontFamily', 'fontSize', 'label', 'color', 'targetId', 'target2Id', 'dimensionUnitPrecision')) {
                dimensionInfo.textNeedsUpdate = true;
            }
            if (meshInfo) {
                if (node.changes.hasAny('enabled', 'billboard', 'keepOnTop')) {
                    if (node.enabled && node.billboard) {
                        this.billboards.set(node._dynamicId, meshInfo);
                    }
                    else {
                        this.billboards.delete(node._dynamicId);
                    }
                }
                if (node.enabled) {
                    if (dimensionInfo.positionNeedsUpdate || dimensionInfo.lineNeedsUpdate) {
                        dimensionInfo.canCreate = this.updateDimensionControlPoints(node, dimensionInfo);
                        // If the line is not getting rebuilt, then just update the line position
                        if (dimensionInfo.canCreate && !dimensionInfo.lineNeedsUpdate) {
                            meshInfo.line.instance = drawLine(node, meshInfo.line, 1, scene);
                            meshInfo.lineCap.instance = MeshBuilder.CreateLineSystem(`${node._dynamicId}_lineCap`, meshInfo.lineCap, scene);
                        }
                        dimensionInfo.positionNeedsUpdate = false;
                    }
                    if (dimensionInfo.canCreate) {
                        if (dimensionInfo.lineNeedsUpdate) {
                            if (meshInfo.line.instance) {
                                meshInfo.line.instance.dispose();
                                delete meshInfo.line.instance;
                            }
                            if (meshInfo.lineCap.instance) {
                                meshInfo.lineCap.instance.dispose();
                                delete meshInfo.lineCap.instance;
                            }
                            this.updateDimensionLineColor(node, meshInfo.line, meshInfo.lineCap);
                            meshInfo.line.instance = drawLine(node, meshInfo.line, meshInfo.distance, scene);
                            if (node.lineCapStyle !== exports.eDimensionLineCapStyle.none) {
                                const lineCapsMesh = MeshBuilder.CreateLineSystem(`${node._dynamicId}_lineCap`, meshInfo.lineCap, scene);
                                if (!meshInfo.lineCap.instance) {
                                    meshInfo.lineCap.instance = lineCapsMesh;
                                }
                            }
                            // Put the lines on the parent scene so they get it's visibility properties
                            if (node._parentScene) {
                                const parentSceneMesh = this.viewer.getRendererNode(node._parentScene);
                                if (meshInfo.line.instance) {
                                    meshInfo.line.instance.parent = parentSceneMesh;
                                }
                                if (meshInfo.lineCap.instance) {
                                    meshInfo.lineCap.instance.parent = parentSceneMesh;
                                }
                            }
                            dimensionInfo.lineNeedsUpdate = false;
                        }
                        if (dimensionInfo.textNeedsUpdate) {
                            let distanceDefaultVal;
                            if (node._parentScene &&
                                node._parentScene.dimensionUnitScalar &&
                                node.dimensionUnitPrecision !== undefined) {
                                let distance = node._parentScene.dimensionUnitScalar * meshInfo.distance;
                                const precisionMultiplier = Math.pow(10, Math.abs(node.dimensionUnitPrecision));
                                distance =
                                    Math.round((distance + Number.EPSILON) * precisionMultiplier) / precisionMultiplier;
                                distanceDefaultVal = distance + (node._parentScene.dimensionUnitSymbol || '');
                            }
                            else {
                                let distance = meshInfo.distance;
                                const precisionMultiplier = Math.pow(10, Math.abs(node.dimensionUnitPrecision));
                                distance =
                                    Math.round((distance + Number.EPSILON) * precisionMultiplier) / precisionMultiplier;
                                distanceDefaultVal = distance.toString(10);
                            }
                            updateAnnotationText(node, meshInfo.textMesh, meshInfo.textMaterial, this.scene.getEngine().webGLVersion < 2, distanceDefaultVal, { v: meshInfo.distance });
                            dimensionInfo.textNeedsUpdate = false;
                        }
                    }
                }
                if (meshInfo.rootMesh.isEnabled() !== node.enabled) {
                    meshInfo.rootMesh.setEnabled(node.enabled);
                    (_b = meshInfo.line.instance) === null || _b === void 0 ? void 0 : _b.setEnabled(node.enabled);
                    (_c = meshInfo.lineCap.instance) === null || _c === void 0 ? void 0 : _c.setEnabled(node.enabled);
                }
            }
        }
        delete3d(node, keepInStore = false) {
            const dimensionModels = this.dimensionStore.get(node._dynamicId);
            if (dimensionModels === null || dimensionModels === void 0 ? void 0 : dimensionModels.meshInfo) {
                this.deleteLine(dimensionModels.meshInfo);
            }
            if (!keepInStore) {
                this.dimensionStore.delete(node._dynamicId);
                this.billboards.delete(node._dynamicId);
            }
            super.delete3d(node);
        }
        dispose() {
            this.billboards.clear();
            this.dimensionStore.clear();
            super.dispose();
        }
        deleteLine(dimensionModels) {
            if (dimensionModels.line.instance) {
                dimensionModels.line.instance.dispose();
                delete dimensionModels.line.instance;
            }
            if (dimensionModels.lineCap.instance) {
                dimensionModels.lineCap.instance.dispose();
                delete dimensionModels.lineCap.instance;
            }
        }
        updateLine(dimensionInfo, node, meshInfo, scene) {
            dimensionInfo.canCreate = this.updateDimensionControlPoints(node, dimensionInfo);
            // If the line is not getting rebuilt, then just update the line position
            if (dimensionInfo.canCreate && !dimensionInfo.lineNeedsUpdate) {
                meshInfo.line.instance = drawLine(node, meshInfo.line, 1, scene);
                meshInfo.lineCap.instance = MeshBuilder.CreateLineSystem(`${node._dynamicId}_lineCap`, meshInfo.lineCap, scene);
            }
            dimensionInfo.positionNeedsUpdate = false;
            if (dimensionInfo.canCreate) {
                if (dimensionInfo.lineNeedsUpdate) {
                    if (meshInfo.line.instance) {
                        meshInfo.line.instance.dispose();
                        delete meshInfo.line.instance;
                    }
                    if (meshInfo.lineCap.instance) {
                        meshInfo.lineCap.instance.dispose();
                        delete meshInfo.lineCap.instance;
                    }
                    this.updateDimensionLineColor(node, meshInfo.line, meshInfo.lineCap);
                    meshInfo.line.instance = drawLine(node, meshInfo.line, meshInfo.distance, scene);
                    if (node.lineCapStyle !== exports.eDimensionLineCapStyle.none) {
                        const lineCapsMesh = MeshBuilder.CreateLineSystem(`${node._dynamicId}_lineCap`, meshInfo.lineCap, scene);
                        if (!meshInfo.lineCap.instance) {
                            meshInfo.lineCap.instance = lineCapsMesh;
                        }
                    }
                    // Put the lines on the parent scene so they get it's visibility properties
                    if (node._parentScene) {
                        const parentSceneMesh = this.viewer.getRendererNode(node._parentScene);
                        if (meshInfo.line.instance) {
                            meshInfo.line.instance.parent = parentSceneMesh;
                        }
                        if (meshInfo.lineCap.instance) {
                            meshInfo.lineCap.instance.parent = parentSceneMesh;
                        }
                    }
                    dimensionInfo.lineNeedsUpdate = false;
                }
                if (dimensionInfo.textNeedsUpdate) {
                    let distanceDefaultVal;
                    if (node._parentScene &&
                        node._parentScene.dimensionUnitScalar &&
                        node.dimensionUnitPrecision !== undefined) {
                        let distance = node._parentScene.dimensionUnitScalar * meshInfo.distance;
                        const precisionMultiplier = Math.pow(10, Math.abs(node.dimensionUnitPrecision));
                        distance = Math.round((distance + Number.EPSILON) * precisionMultiplier) / precisionMultiplier;
                        distanceDefaultVal = distance + (node._parentScene.dimensionUnitSymbol || '');
                    }
                    else {
                        let distance = meshInfo.distance;
                        const precisionMultiplier = Math.pow(10, Math.abs(node.dimensionUnitPrecision));
                        distance = Math.round((distance + Number.EPSILON) * precisionMultiplier) / precisionMultiplier;
                        distanceDefaultVal = distance.toString(10);
                    }
                    updateAnnotationText(node, meshInfo.textMesh, meshInfo.textMaterial, this.scene.getEngine().webGLVersion < 2, distanceDefaultVal, { v: meshInfo.distance });
                    dimensionInfo.textNeedsUpdate = false;
                }
            }
        }
        updateLineFromCamera(node, meshInfo, scene, distance) {
            if (meshInfo.line.instance) {
                meshInfo.line.instance.dispose();
                delete meshInfo.line.instance;
            }
            this.updateDimensionLineColor(node, meshInfo.line, meshInfo.lineCap);
            meshInfo.line.instance = drawLine(node, meshInfo.line, 1, scene, distance); //CreateDashedLines('lines', meshInfo.line);
            if (node._parentScene) {
                const parentSceneMesh = this.viewer.getRendererNode(node._parentScene);
                if (meshInfo.line.instance) {
                    meshInfo.line.instance.parent = parentSceneMesh;
                }
                if (meshInfo.lineCap.instance) {
                    meshInfo.lineCap.instance.parent = parentSceneMesh;
                }
            }
        }
        updateDimensionControlPoints(node, dimensionInfo) {
            if (!dimensionInfo.meshInfo) {
                return false;
            }
            const dimensionModel = dimensionInfo.meshInfo;
            const lineOptions = dimensionModel.line;
            const annotationMesh = dimensionModel.rootMesh;
            let target1;
            let target2;
            if (node.targetId && node.target2Id && node._manager) {
                const manager = node._manager;
                target1 = manager.getById(node.targetId);
                target2 = manager.getById(node.target2Id);
            }
            if (dimensionInfo.boundingInfo &&
                (dimensionInfo.boundingInfo.targetNode._dynamicId !== (target1 === null || target1 === void 0 ? void 0 : target1._dynamicId) ||
                    dimensionInfo.boundingInfo.targetNode2._dynamicId !== (target2 === null || target2 === void 0 ? void 0 : target2._dynamicId))) {
                dimensionInfo.boundingInfo.subscription.unsubscribe();
                dimensionInfo.boundingInfo = undefined;
            }
            if (target1 && target2) {
                let position1;
                let position2;
                let direction;
                let angleAdjustment = 0;
                // Only supporting connectors for now, but could support direct mesh targets in the future
                if (target1 instanceof exports.Connector && target2 instanceof exports.Connector) {
                    position1 = getPositionFromConnnector(target1, this.rendererManager, node._parentScene);
                    position2 = getPositionFromConnnector(target2, this.rendererManager, node._parentScene);
                    direction = target1.direction.toVec3().normalize();
                    angleAdjustment = target1.angle;
                    if (target1._parent && target2._parent) {
                        dimensionInfo.boundingInfo = {
                            targetNode: target1,
                            targetNode2: target2,
                            subscription: merge(this.viewer.bbCache.watchForChanges(target1._parent), this.viewer.bbCache.watchForChanges(target2._parent)).subscribe(() => {
                                node.setPropertyIsModified('targetId', true);
                                node.setPropertyIsModified('target2Id', true);
                            }),
                        };
                    }
                }
                if (position1 && position2 && direction) {
                    /** Calculate the dimension line */
                    const offset = node.offset.toVec3();
                    const startConnector = calculateTransform(position1, direction, angleAdjustment, offset);
                    const endConnector = calculateTransform(position2, direction, angleAdjustment, offset);
                    const dimensionLine = endConnector.position.subtract(startConnector.position);
                    const startPostion = startConnector.position;
                    // Depending on the dimension axis, just use the
                    let endPosition;
                    if (node.axis === exports.eDimensionAxis.free) {
                        endPosition = endConnector.position;
                    }
                    else {
                        if (node.axis === exports.eDimensionAxis.x) {
                            endPosition = startPostion.add(dimensionLine.multiply(new Vector3(1, 0, 0)));
                        }
                        else if (node.axis === exports.eDimensionAxis.y) {
                            endPosition = startPostion.add(dimensionLine.multiply(new Vector3(0, 1, 0)));
                        }
                        else {
                            endPosition = startPostion.add(dimensionLine.multiply(new Vector3(0, 0, 1)));
                        }
                    }
                    const rectifiedDimensionLine = endPosition.subtract(startPostion);
                    const lineDirectionCross = Vector3.Cross(rectifiedDimensionLine, direction).normalize();
                    lineOptions.points = [startPostion, endPosition];
                    dimensionModel.distance = rectifiedDimensionLine.length();
                    annotationMesh.position = startPostion.add(endPosition).scaleInPlace(0.5);
                    annotationMesh.position.addInPlace(transformVectorWithQuat(node.labelOffset.toVec3(), startConnector.rotation));
                    dimensionModel.textContainer.rotationQuaternion = startConnector.textRotation;
                    if (!node.billboard) {
                        annotationMesh.rotationQuaternion = rotationToVector(lineDirectionCross);
                    }
                    /** Calculate the line caps */
                    const capSize = direction.scale(node.fontSize / 3);
                    const lineToStartConnector = direction.scale(Vector3.Dot(transformVectorWithQuat(offset, startConnector.rotation), direction) *
                        (1 - node.dimensionGap));
                    const endOffset = node.axis === exports.eDimensionAxis.free
                        ? transformVectorWithQuat(offset, startConnector.rotation)
                        : endPosition.subtract(position2);
                    const lineToEndConnector = direction.scale(Vector3.Dot(endOffset, direction) * (1 - node.dimensionGap));
                    dimensionModel.lineCap.lines = [];
                    if (node.lineCapStyle !== exports.eDimensionLineCapStyle.none) {
                        dimensionModel.lineCap.lines = [
                            [startPostion.subtract(lineToStartConnector), startPostion, startPostion.add(capSize)],
                            [endPosition.subtract(lineToEndConnector), endPosition, endPosition.add(capSize)],
                        ];
                    }
                    if (node.lineCapStyle === exports.eDimensionLineCapStyle.arrow) {
                        const capArrowOffset = rectifiedDimensionLine.normalizeToNew().scaleInPlace(capSize.length());
                        dimensionModel.lineCap.lines.push([
                            startPostion.subtract(capSize).addInPlace(capArrowOffset),
                            startPostion,
                            startPostion.add(capSize).addInPlace(capArrowOffset),
                        ], [
                            endPosition.subtract(capSize).subtractInPlace(capArrowOffset),
                            endPosition,
                            endPosition.add(capSize).subtractInPlace(capArrowOffset),
                        ]);
                    }
                    return true;
                }
            }
            return false;
        }
        updateDimensionLineColor(node, lineOptions, lineCapOptions) {
            const color = node.color.toColor4();
            lineOptions.colors = [];
            for (let i = 0; i < lineOptions.points.length; i++) {
                lineOptions.colors.push(color);
            }
            lineCapOptions.colors = [];
            for (let i = 0; i < 4; i++) {
                const lineColor = [];
                lineCapOptions.colors.push(lineColor);
                for (let j = 0; j < 3; j++) {
                    lineColor.push(color);
                }
            }
        }
    }
    function getDimensionLinePoints(node, rendererManager) {
        if (node.targetId && node.target2Id && node._manager) {
            const manager = node._manager;
            const target1 = manager.getById(node.targetId);
            const target2 = manager.getById(node.target2Id);
            let position1;
            let position2;
            let direction;
            if (target1 instanceof exports.Connector && target2 instanceof exports.Connector) {
                position1 = getPositionFromConnnector(target1, rendererManager, node._parentScene);
                position2 = getPositionFromConnnector(target2, rendererManager, node._parentScene);
                direction = target1.direction.toVec3();
            }
            if (position1 && position2 && direction) {
                const lineStart = calculateTransform(position1, direction, 0, node.offset.toVec3());
                const lineEnd = calculateTransform(position2, direction, 0, node.offset.toVec3());
                return [lineStart.position, lineEnd.position];
            }
        }
        return undefined;
    }

    const CONNECTOR_DIAM = 0.1;
    class ConnectorRenderer extends Renderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene);
            this.rendererManager = rendererManager;
            this.layers = new Map();
            this.subscriptionMap = new Map();
            this.controlPointScaleRatio = 0.24;
            this.modelToken = Token.Connector;
            this.layers.set('real', {
                template: null,
                map: this.babylonMap,
                scene,
                withArrows: !!viewer.options.editorMode,
                visibility: 1.0,
                pickable: !!viewer.options.editorMode,
                parts: new Map(),
            });
            this.layers.set('utility', {
                template: null,
                map: new Map(),
                scene: viewer.utilityLayer.utilityLayerScene,
                withArrows: !!viewer.options.editorMode,
                visibility: 0.3,
                pickable: false,
                parts: new Map(),
            });
        }
        handlesNode(node) {
            return instanceOf(node, Token.Connector);
        }
        update3dInternal(c, forceScreenScale = false) {
            /**
             * enabled, but not visible
             * enabled and visible
             * not enabled
             */
            const mesh = this.getMesh(c, this.layers.get('real'));
            const realLayer = this.layers.get('real');
            const utilityLayer = this.layers.get('utility');
            const utilityMesh = this.getMesh(c, this.layers.get('utility'));
            const realParts = realLayer.parts.get(c._dynamicId);
            const utilityParts = utilityLayer.parts.get(c._dynamicId);
            if (this.viewer.options.editorMode) {
                this.viewer.camera.maintainNodeScreenSize(mesh, dist => {
                    var _a, _b, _c, _d, _e, _f;
                    const scaledSize = dist * this.controlPointScaleRatio;
                    realParts === null || realParts === void 0 ? void 0 : realParts.mesh.scaling.set(scaledSize, scaledSize, scaledSize);
                    (_a = realParts === null || realParts === void 0 ? void 0 : realParts.handleContainer) === null || _a === void 0 ? void 0 : _a.scaling.set(1 / scaledSize, 1 / scaledSize, 1 / scaledSize);
                    (_b = realParts === null || realParts === void 0 ? void 0 : realParts.directionHandle1) === null || _b === void 0 ? void 0 : _b.scaling.set(scaledSize, scaledSize, scaledSize);
                    (_c = realParts === null || realParts === void 0 ? void 0 : realParts.directionHandle2) === null || _c === void 0 ? void 0 : _c.scaling.set(scaledSize, scaledSize, scaledSize);
                    utilityParts === null || utilityParts === void 0 ? void 0 : utilityParts.mesh.scaling.set(scaledSize, scaledSize, scaledSize);
                    (_d = utilityParts === null || utilityParts === void 0 ? void 0 : utilityParts.handleContainer) === null || _d === void 0 ? void 0 : _d.scaling.set(1 / scaledSize, 1 / scaledSize, 1 / scaledSize);
                    (_e = utilityParts === null || utilityParts === void 0 ? void 0 : utilityParts.directionHandle1) === null || _e === void 0 ? void 0 : _e.scaling.set(scaledSize, scaledSize, scaledSize);
                    (_f = utilityParts === null || utilityParts === void 0 ? void 0 : utilityParts.directionHandle2) === null || _f === void 0 ? void 0 : _f.scaling.set(scaledSize, scaledSize, scaledSize);
                });
            }
            const changes = this.getChanges(c);
            if (changes.has('_isPickable')) {
                mesh.isPickable = c._isPickable;
            }
            if (changes.has('positionZeroToOne') || changes.has('_sketchControlPoints')) {
                if (c.positionMode === exports.eConnectorPositionMode.moveAlongSketch) {
                    if (c instanceof exports.Connector) {
                        //this.updatePositionMoveAlongSketch(c);
                        this.updatePosition(c);
                        this.updateDirection(c);
                    }
                }
            }
            if (changes.has('position') || changes.has('positionMode')) {
                const bb = c._parent instanceof exports.SpaceNode ? this.viewer.bbCache.get(c._parent) : undefined;
                this.updatePosition(c, bb);
                /**
                 * subscribe to bounding box changes of the parent to know that
                 * we need to invalidate the position of the connector if applicable
                 */
                if (changes.has('positionMode')) {
                    if (c.positionMode == exports.eConnectorPositionMode.boundingBox) {
                        this.addSubscription(c);
                    }
                    else {
                        this.removeSubscription(c);
                    }
                }
            }
            if (changes.hasAny('direction', 'angle')) {
                this.updateDirection(c);
                this.updatePosition(c);
            }
            if (changes.hasAny('enabled', '_visible')) {
                if (c.enabled && c._visible) {
                    mesh.setEnabled(true);
                    utilityMesh.setEnabled(true);
                }
                else {
                    mesh.setEnabled(false);
                    utilityMesh.setEnabled(false);
                }
            }
            if (changes.has('_selected')) {
                if (c._selected) {
                    mesh.material = this.getSelectedMaterial(this.layers.get('real').withArrows);
                }
                else {
                    mesh.material = this.getConnectorMaterial(this.layers.get('real').withArrows);
                }
                utilityMesh.material = mesh.material;
            }
            return { mesh, utilityMesh };
        }
        addSubscription(c) {
            if (c._parent instanceof exports.SpaceNode) {
                const mesh = c._parent;
                if (!this.subscriptionMap.has(c)) {
                    this.subscriptionMap.set(c, this.viewer.bbCache.watchForChanges(mesh).subscribe(bbInfo => {
                        c.setPropertyIsModified('position', true); // Trigger changes on mates and everything using that connector
                        this.updatePosition(c, bbInfo);
                        this.updateScale(c);
                    }));
                }
            }
        }
        removeSubscription(c) {
            const s = this.subscriptionMap.get(c);
            if (s) {
                s.unsubscribe();
                this.subscriptionMap.delete(c);
            }
        }
        updatePosition(c, bb) {
            const mesh = this.getMesh(c, this.layers.get('real'));
            const utilityMesh = this.getMesh(c, this.layers.get('utility'));
            if (c.positionMode == exports.eConnectorPositionMode.moveAlongSketch) {
                if (c instanceof exports.Connector) {
                    const newPosition = this.updatePositionMoveAlongSketch(c);
                    if (newPosition) {
                        mesh.position = utilityMesh.position = newPosition;
                    }
                }
            }
            else if (c.positionMode == exports.eConnectorPositionMode.absolute) {
                mesh.position = utilityMesh.position = c.position.toVec3();
            }
            else if (c.positionMode == exports.eConnectorPositionMode.boundingBox) {
                if (!bb) {
                    bb = c._parent instanceof exports.SpaceNode ? this.viewer.bbCache.get(c._parent) : undefined;
                }
                if (bb) {
                    mesh.position = BoundingBoxRelativeHelper.convertRelativeToAbsolute(c, bb);
                }
                else {
                    mesh.position = new Vector3(c.position.x, c.position.y, c.position.z);
                }
                utilityMesh.position = mesh.position;
            }
            if (isTrackedClass(c)) {
                this.rendererManager.referenceProcessor.triggerChangesOnReferencers(c);
            }
        }
        updateDirection(c) {
            const mesh = this.getMesh(c, this.layers.get('real'));
            const utilityMesh = this.getMesh(c, this.layers.get('utility'));
            if (c.positionMode === exports.eConnectorPositionMode.moveAlongSketch) {
                if (c instanceof exports.Connector) {
                    let newDirection = this.updateDirectionMoveAlongSketch(c);
                    if (newDirection) {
                        newDirection = newDirection.normalize();
                        if (c._parent instanceof exports.SketchNode) {
                            const normal = c._parent.normal;
                            const normalVector = new Vector3(1, 0, 0);
                            if (normal === exports.eAxis.y) {
                                normalVector.set(0, 1, 0);
                            }
                            else if (normal === exports.eAxis.z) {
                                normalVector.set(0, 0, 1);
                            }
                            if (mesh.parent instanceof TransformNode) {
                                const connectorDirection = newDirection;
                                const angleRot = Quaternion.RotationAxis(connectorDirection, toRadians(c.angle));
                                const angleRotMatrix = new Matrix();
                                angleRot.toRotationMatrix(angleRotMatrix);
                                const parentDirection = Vector3.TransformCoordinates(normalVector, angleRotMatrix);
                                const crossProduct = Vector3.Cross(connectorDirection, parentDirection);
                                // prettier-ignore
                                const matrix = Matrix.FromArray([connectorDirection.x, connectorDirection.y, connectorDirection.z, 0,
                                    parentDirection.x, parentDirection.y, parentDirection.z, 0,
                                    crossProduct.x, crossProduct.y, crossProduct.z, 0,
                                    0, 0, 0, 1,
                                ]);
                                const newQuaternion = Quaternion.FromRotationMatrix(matrix);
                                mesh.rotationQuaternion = utilityMesh.rotationQuaternion = newQuaternion;
                            }
                        }
                    }
                }
            }
            else {
                /**
                 * treat the positive x axis as the direction vector,
                 * and the angle around that axis defined by the y axis.
                 *
                 * See Dragger.connect for a more in depth explanation
                 */
                const deltaBtwXaxisAndDirection = getRotationBtwVectors(Axis.X, c.direction.toVec3().normalize());
                const angleRot = Quaternion.RotationAxis(Axis.X, toRadians(c.angle));
                mesh.rotationQuaternion = utilityMesh.rotationQuaternion = deltaBtwXaxisAndDirection.multiply(angleRot);
            }
            this.updateScale(c);
        }
        /**
         * connector meshes are children of their parent mesh, meaning they will scale
         * with any of their ancestor meshes or groups.
         * To counteract this we inverse their world scale.
         * WARNING! this technique does not work well when an ancestor has a non-uniform scale
         * @param c
         */
        updateScale(c) {
            if (this.layers.get('real').map.get(c._dynamicId)) {
                //this could get called at any time, make sure the mesh already exists
                const mesh = this.getMesh(c, this.layers.get('real'));
                const utilityMesh = this.getMesh(c, this.layers.get('utility'));
                mesh.scaling = Vector3.One();
                mesh.computeWorldMatrix(true);
                if (mesh.parent instanceof TransformNode) {
                    const worldScale = mesh.parent.absoluteScaling;
                    const numerator = (this.viewer.sceneNode.connectorSize || CONNECTOR_DIAM) / CONNECTOR_DIAM;
                    const transformMatrix = Matrix.Scaling(numerator / worldScale.x, numerator / worldScale.y, numerator / worldScale.z);
                    mesh.setPreTransformMatrix(transformMatrix);
                    utilityMesh.setPreTransformMatrix(transformMatrix);
                    if (isTrackedClass(c)) {
                        this.rendererManager.referenceProcessor.triggerChangesOnReferencers(c);
                    }
                }
            }
        }
        updatePositionMoveAlongSketch(connector) {
            const node = connector._parent;
            const result = new Vector3(0, 0, 0);
            if (node instanceof exports.SketchNode) {
                const sketchLength = node.getSketchLength();
                const posZeroToOne = connector.positionZeroToOne;
                let trackedLength = 0;
                let targetNotFound = true;
                node.paths.forEach(path => {
                    let lastPosition = null;
                    let lastLength = 0;
                    path._points.forEach(point => {
                        if (!lastPosition) {
                            lastPosition = point;
                        }
                        else {
                            const currentPos = point;
                            const distance = Math.sqrt(Math.pow(lastPosition.x - currentPos.x, 2) +
                                Math.pow(lastPosition.y - currentPos.y, 2) +
                                Math.pow(lastPosition.z - currentPos.z, 2));
                            lastLength = trackedLength;
                            trackedLength += distance;
                            const distanceBetweenPoints = trackedLength - lastLength;
                            const distanceFromP1toTarget = posZeroToOne * sketchLength - lastLength;
                            const percentageBetween2Points = distanceFromP1toTarget / distanceBetweenPoints;
                            const vectorBetween2Points = new exports.KbVector(currentPos.x - lastPosition.x, currentPos.y - lastPosition.y, currentPos.z - lastPosition.z);
                            if (trackedLength > posZeroToOne * sketchLength && targetNotFound) {
                                const calculatedPosition = vectorBetween2Points
                                    .scale(percentageBetween2Points)
                                    .add(lastPosition);
                                result.set(calculatedPosition.x, calculatedPosition.y, calculatedPosition.z);
                                targetNotFound = false;
                            }
                            lastPosition = currentPos;
                        }
                    });
                    if (posZeroToOne === 1) {
                        const path = node.paths[node.paths.length - 1];
                        const controlPoint = path._points[path._points.length - 1];
                        result.set(controlPoint.x, controlPoint.y, controlPoint.z);
                    }
                });
            }
            return result;
        }
        updateDirectionMoveAlongSketch(connector) {
            const node = connector._parent;
            const result = new Vector3(0, 0, 0);
            if (node instanceof exports.SketchNode) {
                const sketchLength = node.getSketchLength();
                const posZeroToOne = connector.positionZeroToOne;
                let trackedLength = 0;
                let targetNotFound = true;
                let lastPathVector = null;
                let nextPathVector = null;
                node.paths.forEach(path => {
                    let lastPosition = null;
                    let lastLength = 0;
                    path._points.forEach(point => {
                        if (!lastPosition) {
                            lastPosition = point;
                        }
                        else {
                            const currentPos = point;
                            if (lastPosition) {
                                const index = path._points.indexOf(lastPosition) + 1;
                                const index2 = index + 1;
                                if (index !== path._points.length) {
                                    const nextPosition = path._points[index];
                                    if (index2 !== path._points.length) {
                                        const nextNextPosition = path._points[index2];
                                        nextPathVector = new exports.KbVector(nextNextPosition.x - nextPosition.x, nextNextPosition.y - nextPosition.y, nextNextPosition.z - nextPosition.z).normalize();
                                    }
                                }
                            }
                            const distance = Math.sqrt(Math.pow(lastPosition.x - currentPos.x, 2) +
                                Math.pow(lastPosition.y - currentPos.y, 2) +
                                Math.pow(lastPosition.z - currentPos.z, 2));
                            lastLength = trackedLength;
                            trackedLength += distance;
                            const distanceBetweenPoints = trackedLength - lastLength;
                            const distanceFromP1toTarget = posZeroToOne * sketchLength - lastLength;
                            const percentageBetween2Points = distanceFromP1toTarget / distanceBetweenPoints;
                            const vectorBetween2Points = new exports.KbVector(currentPos.x - lastPosition.x, currentPos.y - lastPosition.y, currentPos.z - lastPosition.z);
                            if (trackedLength > posZeroToOne * sketchLength && targetNotFound) {
                                let calculatedDirection = null;
                                if (!connector.interpolateDirection) {
                                    calculatedDirection = vectorBetween2Points.normalize();
                                }
                                else {
                                    if (!lastPathVector) {
                                        if (nextPathVector) {
                                            calculatedDirection = vectorBetween2Points
                                                .normalize()
                                                .scale(1 - percentageBetween2Points)
                                                .add(nextPathVector
                                                .normalize()
                                                .add(vectorBetween2Points.normalize())
                                                .normalize()
                                                .scale(percentageBetween2Points))
                                                .normalize();
                                        }
                                        else {
                                            calculatedDirection = vectorBetween2Points.normalize();
                                        }
                                    }
                                    else if (!nextPathVector) {
                                        calculatedDirection = lastPathVector
                                            .scale(1 - percentageBetween2Points)
                                            .add(vectorBetween2Points.scale(1 + percentageBetween2Points))
                                            .scale(1 / 2)
                                            .normalize();
                                    }
                                    else {
                                        if (percentageBetween2Points <= 0.5) {
                                            calculatedDirection = lastPathVector
                                                .normalize()
                                                .add(vectorBetween2Points.normalize())
                                                .normalize()
                                                .scale(1 - percentageBetween2Points * 2)
                                                .add(vectorBetween2Points.scale(percentageBetween2Points * 2))
                                                .normalize();
                                        }
                                        else {
                                            calculatedDirection = vectorBetween2Points
                                                .normalize()
                                                .scale(1 - (percentageBetween2Points - 0.5) * 2)
                                                .add(nextPathVector
                                                .normalize()
                                                .add(vectorBetween2Points.normalize())
                                                .normalize()
                                                .scale((percentageBetween2Points - 0.5) * 2))
                                                .normalize();
                                        }
                                    }
                                }
                                targetNotFound = false;
                                result.set(calculatedDirection.x, calculatedDirection.y, calculatedDirection.z);
                            }
                            lastPathVector = vectorBetween2Points;
                            lastPosition = currentPos;
                        }
                    });
                });
                if (posZeroToOne === 1) {
                    if (posZeroToOne === 1) {
                        const path = node.paths[node.paths.length - 1];
                        const currentPos = path._points[path._points.length - 1];
                        const lastPosition = path._points[path._points.length - 2];
                        const vectorBetween2Points = new exports.KbVector(currentPos.x - lastPosition.x, currentPos.y - lastPosition.y, currentPos.z - lastPosition.z).normalize();
                        result.set(vectorBetween2Points.x, vectorBetween2Points.y, vectorBetween2Points.z);
                    }
                }
            }
            return result;
        }
        getMesh(c, layer) {
            let mesh = layer.map.get(c._dynamicId);
            if (!mesh) {
                if (!layer.template) {
                    layer.template = this.createMeshTemplate(layer);
                }
                mesh = layer.template.clone(c._dynamicId); // layer.template.createInstance(c._dynamicId);
                mesh.id = c._dynamicId;
                const parentNode = c._parent;
                if (parentNode && parentNode instanceof exports.SpaceNode) {
                    const parent3d = this.viewer.getRendererNode(parentNode);
                    if (parent3d) {
                        mesh.setParent(parent3d);
                    }
                    else {
                        console.warn(`mesh not found for ${parentNode.name}`);
                    }
                }
                mesh.isPickable = layer.pickable;
                mesh.position = Vector3.Zero();
                mesh.rotationQuaternion = Quaternion.Identity();
                layer.map.set(c._dynamicId, mesh);
                layer.parts.set(c._dynamicId, {
                    mesh,
                });
            }
            return mesh;
        }
        createMeshTemplate(layer) {
            const ball = CreateSphereVertexData({
                segments: 8,
                diameter: CONNECTOR_DIAM,
            });
            if (layer.withArrows) {
                const arrowHead = CreateCylinderVertexData({
                    diameterTop: 0,
                    height: CONNECTOR_DIAM / 2,
                    diameterBottom: CONNECTOR_DIAM / 4,
                    tessellation: 6,
                });
                arrowHead.transform(Matrix.Compose(Vector3.One(), Quaternion.FromEulerAngles(Math.PI / 2, 0, 0), new Vector3(0, 0, CONNECTOR_DIAM * 1.75)));
                const arrowShaft = CreateCylinderVertexData({
                    diameterTop: CONNECTOR_DIAM / 10,
                    height: CONNECTOR_DIAM,
                    diameterBottom: CONNECTOR_DIAM / 10,
                    tessellation: 6,
                });
                arrowShaft.transform(Matrix.Compose(Vector3.One(), Quaternion.FromEulerAngles(Math.PI / 2, 0, 0), new Vector3(0, 0, CONNECTOR_DIAM)));
                ball.merge(arrowHead).merge(arrowShaft);
            }
            const mesh = new Mesh('', layer.scene);
            ball.applyToMesh(mesh, false); //updateable false
            if (layer.withArrows) {
                //let ballHalf1 = new SubMesh(0, 0, 231, 0, 600, mesh);
                new SubMesh(1, 0, 231, 0, 600, mesh); // ball half 2
            }
            mesh.rotation.y = Math.PI / 2;
            mesh.bakeCurrentTransformIntoVertices();
            mesh.position = Vector3.Zero();
            mesh.material = this.getConnectorMaterial(layer.withArrows);
            mesh.visibility = layer.visibility;
            mesh.setEnabled(false);
            return mesh;
        }
        delete3d(c) {
            const utilityLayer = this.layers.get('utility');
            const utilityMesh = utilityLayer.map.get(c._dynamicId);
            if (utilityMesh) {
                utilityMesh.dispose();
                utilityLayer.map.delete(c._dynamicId);
            }
            this.removeSubscription(c);
            super.delete3d(c);
        }
        getConnectorMaterial(twoTone) {
            if (!this.connectorMaterial) {
                if (twoTone) {
                    const m1 = new StandardMaterial('connectorMaterial0', this.scene);
                    m1.emissiveColor = exports.KbColor.KbmaxOrange().toColor3();
                    m1.disableLighting = true;
                    const m2 = new StandardMaterial('connectorMaterial1', this.scene);
                    m2.emissiveColor = new Color3(0, 101 / 255, 1); //new Color3(226/255, 101/255, 29/255);// KbColor.KbmaxBlue().toColor3();
                    m2.disableLighting = true;
                    const m = new MultiMaterial('connectorMaterial', this.scene);
                    m.subMaterials.push(m1, m2);
                    this.connectorMaterial = m;
                }
                else {
                    const m = new StandardMaterial('connectorMaterial', this.scene);
                    m.emissiveColor = this.viewer.highlightColor.toColor3();
                    m.disableLighting = true;
                    this.connectorMaterial = m;
                }
            }
            return this.connectorMaterial;
        }
        getSelectedMaterial(withArrows) {
            if (!this.selectedMaterial) {
                this.selectedMaterial = this.getConnectorMaterial(withArrows);
                if (withArrows) {
                    const m1 = new StandardMaterial('connectorSelectedMaterial0', this.scene);
                    m1.emissiveColor = new Color3(254 / 255, 233 / 255, 7 / 255);
                    m1.disableLighting = true;
                    const m2 = new StandardMaterial('connectorSelectedMaterial1', this.scene);
                    m2.emissiveColor = new Color3(2 / 255, 251 / 255, 248 / 255);
                    m2.disableLighting = true;
                    const m = new MultiMaterial('connectorSelectedMaterial', this.scene);
                    m.subMaterials.push(m1, m2);
                    this.selectedMaterial = m;
                }
                else {
                    const m = new StandardMaterial('connectorSelectedMaterial', this.scene);
                    m.emissiveColor = this.viewer.options.highlightColor.toColor3();
                    m.disableLighting = true;
                    this.selectedMaterial = m;
                }
            }
            return this.selectedMaterial;
        }
        dispose() {
            super.dispose();
            for (const [, layer] of this.layers) {
                if (layer.template) {
                    layer.template.dispose();
                }
                layer.map.clear();
            }
            if (this.connectorMaterial) {
                this.connectorMaterial.dispose();
            }
        }
    }

    class FeatureRenderer extends Renderer {
        constructor() {
            super(...arguments);
            this.vertexDataCache = new Map();
        }
        updateMeshGeometryCache(feature, vertexData, vertexDataChanges) {
            const self = this;
            const newVertexData = {};
            // Grab the properties in the mesh vertex that are needed for the feature
            // Only swap out the properties in the old vertex data with the stored copy if they have NOT been affected by another vertex
            if (feature.affectedBy) {
                const cachedData = this.vertexDataCache.get(feature._dynamicId);
                feature.affectedBy.forEach(affectedBy => {
                    var _a, _b, _c, _d, _e, _f;
                    if (affectedBy === exports.eMeshChangeTypes.VertexIndices) {
                        if (vertexDataChanges.indices === null) {
                            newVertexData.indices = null;
                            clearVertexDataCache('indices');
                        }
                        else if (vertexDataChanges.indices) {
                            newVertexData.indices = vertexDataChanges.indices.slice();
                            updateVertexDataCache('indices', vertexDataChanges.indices);
                        }
                        else if (cachedData) {
                            newVertexData.indices = (_a = cachedData.indices) === null || _a === void 0 ? void 0 : _a.slice();
                        }
                        else {
                            newVertexData.indices = vertexData.indices.slice();
                            updateVertexDataCache('indices', vertexData.indices);
                        }
                        if (vertexDataChanges.paths === null) {
                            newVertexData.paths = null;
                            clearVertexDataCache('paths');
                        }
                        else if (vertexDataChanges.paths) {
                            newVertexData.paths = vertexDataChanges.paths.slice();
                            updateVertexDataCache('paths', vertexDataChanges.paths);
                        }
                        else if (cachedData) {
                            newVertexData.paths = (_b = cachedData.paths) === null || _b === void 0 ? void 0 : _b.slice();
                        }
                        else {
                            if (vertexData.paths) {
                                newVertexData.paths = vertexData.paths.slice();
                                updateVertexDataCache('paths', vertexData.paths);
                            }
                            else {
                                newVertexData.paths = null;
                            }
                        }
                        if (vertexDataChanges.holes === null) {
                            newVertexData.holes = null;
                            clearVertexDataCache('holes');
                        }
                        else if (vertexDataChanges.holes) {
                            newVertexData.holes = vertexDataChanges.holes.slice();
                            updateVertexDataCache('holes', vertexDataChanges.holes);
                        }
                        else if (cachedData) {
                            newVertexData.holes = (_c = cachedData.holes) === null || _c === void 0 ? void 0 : _c.slice();
                        }
                        else {
                            if (vertexData.holes) {
                                newVertexData.holes = vertexData.holes.slice();
                                updateVertexDataCache('holes', vertexData.holes);
                            }
                            else {
                                newVertexData.holes = null;
                            }
                        }
                    }
                    if (affectedBy === exports.eMeshChangeTypes.VertexPositions) {
                        if (vertexDataChanges.positions === null) {
                            newVertexData.positions = null;
                            clearVertexDataCache('positions');
                        }
                        else if (vertexDataChanges.positions) {
                            newVertexData.positions = vertexDataChanges.positions.slice();
                            updateVertexDataCache('positions', vertexDataChanges.positions);
                        }
                        else if (cachedData) {
                            newVertexData.positions = (_d = cachedData.positions) === null || _d === void 0 ? void 0 : _d.slice(); // compiler complains about the slice generic type for some reason
                        }
                        else {
                            if (!vertexData.positions) {
                                throw Error('Invalid geometry: positions is null');
                            }
                            newVertexData.positions = vertexData.positions.slice();
                            updateVertexDataCache('positions', vertexData.positions);
                        }
                    }
                    if (affectedBy === exports.eMeshChangeTypes.VertexNormals) {
                        if (vertexDataChanges.normals === null) {
                            newVertexData.normals = null;
                            clearVertexDataCache('normals');
                        }
                        else if (vertexDataChanges.normals) {
                            newVertexData.normals = vertexDataChanges.normals.slice();
                            updateVertexDataCache('normals', vertexDataChanges.normals);
                        }
                        else if (cachedData) {
                            newVertexData.normals = (_e = cachedData.normals) === null || _e === void 0 ? void 0 : _e.slice();
                        }
                        else {
                            if (vertexData.normals) {
                                newVertexData.normals = vertexData.normals.slice();
                                updateVertexDataCache('normals', vertexData.normals);
                            }
                            else {
                                newVertexData.normals = null;
                            }
                        }
                    }
                    if (affectedBy === exports.eMeshChangeTypes.VertexUvs) {
                        if (vertexDataChanges.uvs === null) {
                            newVertexData.uvs = null;
                            clearVertexDataCache('uvs');
                        }
                        else if (vertexDataChanges.uvs) {
                            newVertexData.uvs = vertexDataChanges.uvs.slice();
                            updateVertexDataCache('uvs', vertexDataChanges.uvs);
                        }
                        else if (cachedData) {
                            newVertexData.uvs = (_f = cachedData.uvs) === null || _f === void 0 ? void 0 : _f.slice();
                        }
                        else {
                            if (vertexData.uvs) {
                                newVertexData.uvs = vertexData.uvs.slice();
                                updateVertexDataCache('uvs', vertexData.uvs);
                            }
                            else {
                                newVertexData.uvs = null;
                            }
                        }
                    }
                    if (affectedBy === exports.eMeshChangeTypes.Submeshes) {
                        if (vertexDataChanges.submeshData === null) {
                            newVertexData.submeshData = null;
                            clearVertexDataCache('submeshData');
                        }
                        else if (vertexDataChanges.submeshData) {
                            newVertexData.submeshData = JSON.parse(JSON.stringify(vertexDataChanges.submeshData));
                            updateVertexDataCache('submeshData', JSON.parse(JSON.stringify(vertexDataChanges.submeshData)));
                        }
                        else if (cachedData) {
                            const cachedSubmeshes = cachedData.submeshData;
                            newVertexData.submeshData = cachedSubmeshes
                                ? JSON.parse(JSON.stringify(cachedSubmeshes))
                                : undefined;
                        }
                        else {
                            if (vertexData.submeshData) {
                                newVertexData.submeshData = JSON.parse(JSON.stringify(vertexData.submeshData));
                                updateVertexDataCache('submeshData', JSON.parse(JSON.stringify(vertexData.submeshData)));
                            }
                            else {
                                newVertexData.submeshData = null;
                            }
                        }
                    }
                });
            }
            function clearVertexDataCache(prop) {
                const vertexDataCache = self.vertexDataCache.get(feature._dynamicId);
                if (vertexDataCache) {
                    delete vertexDataCache[prop];
                }
            }
            function updateVertexDataCache(prop, value) {
                if (!value) {
                    throw Error('invalid geometry does not have ' + prop);
                }
                let vertexDataCache = self.vertexDataCache.get(feature._dynamicId);
                if (!vertexDataCache) {
                    vertexDataCache = {};
                    self.vertexDataCache.set(feature._dynamicId, vertexDataCache);
                }
                if (typeof value.slice !== 'function') {
                    throw Error('fixme: how do I clone this property?');
                }
                vertexDataCache[prop] = value.slice(); // Need to make sure everything is cloned when inserted into the cache
            }
            return newVertexData;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            return this.updateMeshGeometryCache(feature, vertexData, vertexDataChanges);
        }
        delete3d(node, preserveCache) {
            if (!preserveCache) {
                this.vertexDataCache.delete(node._dynamicId);
            }
            const t3d = this.get3d(node);
            if (t3d) {
                super.delete3d(node);
            }
            else {
                SyncService.nodeDeletionProcessed(node);
            }
        }
        clearCache(features) {
            if (features) {
                features.forEach(feature => {
                    this.vertexDataCache.delete(feature._dynamicId);
                });
            }
            else {
                this.vertexDataCache.clear();
            }
        }
        dispose() {
            super.dispose();
            this.clearCache();
        }
    }

    class MoveVerticesRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.MoveVerticesFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const parentMesh = feature._parent;
            if (parentMesh && newVertexData.positions && newVertexData.positions.length > 0) {
                const newMeshVertexPositions = newVertexData.positions;
                if (feature.vertexIndices && feature.vertexIndices.length > 0) {
                    let pivot;
                    let rotationQuaternion;
                    let scaleVector;
                    if (feature.rotationAngle !== 0 && !feature.rotationAxis.equal({ x: 0, y: 0, z: 0 })) {
                        rotationQuaternion = Quaternion.RotationAxis(feature.rotationAxis.toVec3(), (feature.rotationAngle / 180) * Math.PI);
                    }
                    if (!feature.scale.equal({ x: 1, y: 1, z: 1 })) {
                        scaleVector = feature.scale.toVec3();
                    }
                    // Calculate vertex center if needed
                    if (rotationQuaternion || scaleVector) {
                        if (feature.center === exports.eFeatureCenter.meshPivotPoint) {
                            pivot = parentMesh.pivot.toVec3();
                        }
                        else {
                            // Calculate vertices barycenter
                            pivot = Vector3.Zero();
                            const currentMeshVertexPositions = newVertexData.positions;
                            if (currentMeshVertexPositions) {
                                feature.vertexIndices.forEach(idx => {
                                    pivot.x += currentMeshVertexPositions[idx * 3];
                                    pivot.y += currentMeshVertexPositions[idx * 3 + 1];
                                    pivot.z += currentMeshVertexPositions[idx * 3 + 2];
                                });
                                pivot.scaleInPlace(1 / feature.vertexIndices.length);
                            }
                        }
                    }
                    const vertexPosition = new Vector3();
                    feature.vertexIndices.forEach(index => {
                        newMeshVertexPositions[index * 3] += feature.translation.x;
                        newMeshVertexPositions[index * 3 + 1] += feature.translation.y;
                        newMeshVertexPositions[index * 3 + 2] += feature.translation.z;
                        if (pivot && (rotationQuaternion || scaleVector)) {
                            vertexPosition.copyFromFloats(newMeshVertexPositions[index * 3] - pivot.x, newMeshVertexPositions[index * 3 + 1] - pivot.y, newMeshVertexPositions[index * 3 + 2] - pivot.z);
                            if (rotationQuaternion) {
                                vertexPosition.rotateByQuaternionToRef(rotationQuaternion, vertexPosition);
                            }
                            if (scaleVector) {
                                vertexPosition.multiplyInPlace(scaleVector);
                            }
                            vertexPosition.addInPlace(pivot);
                            newMeshVertexPositions[index * 3] = vertexPosition.x;
                            newMeshVertexPositions[index * 3 + 1] = vertexPosition.y;
                            newMeshVertexPositions[index * 3 + 2] = vertexPosition.z;
                        }
                    });
                }
            }
            return newVertexData;
        }
        update3dInternal() { }
    }

    class NormalSmoothingRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.NormalSmoothingFeature;
            this.vertexNeighbors = new Map();
            this.planeNormals = new Map();
            this.vectorA = new Vector3();
            this.vectorB = new Vector3();
            this.vectorC = new Vector3();
            this.normalVector = new Vector3();
            this.totalSelectedIndices = 0;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            let vertexGroups = [];
            //if no faces are selected, select all faces to smooth entire mesh.
            if (feature.vertexGroups.length === 0 && newVertexData.indices) {
                for (let i = 0; i < newVertexData.indices.length; i += 6) {
                    vertexGroups.push({ startIndex: i, endIndex: i + 6 });
                }
            }
            else {
                vertexGroups = feature.vertexGroups.sort((groupA, groupB) => groupA.startIndex - groupB.startIndex);
            }
            if (newVertexData.indices) {
                const planeNormal = new Vector3();
                let normals;
                let positions;
                let uvs;
                let indices;
                const newPositions = [];
                const newNormals = [];
                const newUvs = [];
                const submeshDataArray = [];
                if (newVertexData.normals) {
                    normals = newVertexData.normals;
                }
                else if (vertexData.normals) {
                    normals = Array.from(vertexData.normals);
                }
                else {
                    normals = [];
                }
                if (newVertexData.positions) {
                    positions = newVertexData.positions;
                }
                else if (vertexData.positions) {
                    positions = Array.from(vertexData.positions);
                }
                else {
                    positions = [];
                }
                if (newVertexData.uvs) {
                    uvs = newVertexData.uvs;
                }
                else if (vertexData.uvs) {
                    uvs = Array.from(vertexData.uvs);
                }
                else {
                    uvs = [];
                }
                if (newVertexData.indices) {
                    indices = newVertexData.indices;
                }
                else if (vertexData.indices) {
                    indices = Array.from(vertexData.indices);
                }
                else {
                    indices = [];
                }
                this.vertexNeighbors.clear();
                this.planeNormals.clear();
                this.totalSelectedIndices = 0;
                vertexGroups.forEach(vertexGroup => {
                    this.totalSelectedIndices += vertexGroup.endIndex - vertexGroup.startIndex;
                });
                if (feature.smooth) {
                    //looping through the vertex groups and finding all the neighboring faces
                    vertexGroups.forEach(vertexGroup => {
                        const planeCoordinates = [];
                        const planePositions = [];
                        for (let i = vertexGroup.startIndex; i < vertexGroup.endIndex; i++) {
                            if (positions && indices) {
                                let key = '';
                                for (let j = 0; j < 3; j++) {
                                    const vertexIndex = indices[i];
                                    const coordinate = positions[vertexIndex * 3 + j];
                                    planePositions.push(coordinate);
                                    if (j == 2) {
                                        planeCoordinates.push([...planePositions]);
                                        planePositions.clear();
                                    }
                                    key += String(coordinate);
                                }
                                if (planeCoordinates.length == 3) {
                                    this.calculateNormalToRef(planeCoordinates, planeNormal);
                                    this.planeNormals.set(Math.floor(i / 3), planeNormal.asArray());
                                    planeCoordinates.clear();
                                }
                                let neighbor = this.vertexNeighbors.get(key);
                                if (neighbor) {
                                    neighbor.push(i);
                                    this.vertexNeighbors.set(key, neighbor);
                                }
                                else {
                                    neighbor = [];
                                    neighbor.push(i);
                                    this.vertexNeighbors.set(key, neighbor);
                                }
                            }
                        }
                    });
                    this.vertexNeighbors.forEach(position => {
                        const newNormal = this.calculateSmoothedUnitVector(position);
                        position.forEach(index => {
                            if (normals && indices) {
                                for (let i = 0; i < 3; i++) {
                                    normals[indices[index] * 3 + i] = newNormal[i];
                                }
                            }
                        });
                    });
                }
                else {
                    //looping through the selected faces to get the face normals
                    vertexGroups.forEach(vertexGroup => {
                        const planeCoordinates = [];
                        const planePositions = [];
                        for (let i = vertexGroup.startIndex; i < vertexGroup.endIndex; i++) {
                            if (positions && indices) {
                                for (let j = 0; j < 3; j++) {
                                    const vertexIndex = indices[i];
                                    const coordinate = positions[vertexIndex * 3 + j];
                                    planePositions.push(coordinate);
                                    if (j == 2) {
                                        planeCoordinates.push([...planePositions]);
                                        planePositions.clear();
                                    }
                                }
                                if (planeCoordinates.length == 3) {
                                    this.calculateNormalToRef(planeCoordinates, planeNormal);
                                    const planeNormalArray = this.calculateUnitVector(planeNormal.asArray());
                                    this.planeNormals.set(i, planeNormalArray);
                                    this.planeNormals.set(i - 1, planeNormalArray);
                                    this.planeNormals.set(i - 2, planeNormalArray);
                                    planeCoordinates.clear();
                                }
                            }
                        }
                    });
                    //looping through it again to change/add the normals
                    let totalVertices = 0;
                    if (positions) {
                        totalVertices = positions.length / 3;
                    }
                    const visitedVertices = [];
                    vertexGroups.forEach(vertexGroup => {
                        for (let i = vertexGroup.startIndex; i < vertexGroup.endIndex; i++) {
                            const vertex = indices[i];
                            const planeNormal = this.planeNormals.get(i);
                            const currentNormal = [];
                            const currentPosition = [];
                            const currentUv = [];
                            for (let i = 0; i < 3; i++) {
                                currentNormal.push(normals[vertex * 3 + i]);
                                currentPosition.push(positions[vertex * 3 + i]);
                            }
                            for (let i = 0; i < 2; i++) {
                                currentUv.push(uvs[vertex * 2 + i]);
                            }
                            //vertex is already visited, therefor we add a new one.
                            //else: replace the existing vertex
                            if (visitedVertices[vertex]) {
                                for (let i = 0; i < 3; i++) {
                                    if (planeNormal) {
                                        newNormals.push(planeNormal[i]);
                                        newPositions.push(currentPosition[i]);
                                    }
                                }
                                for (let i = 0; i < 2; i++) {
                                    newUvs.push(currentUv[i]);
                                }
                                indices[i] = totalVertices;
                                totalVertices += 1;
                                //handling submesh data
                                if (vertexData.submeshData) {
                                    for (let i = 0; i < vertexData.submeshData.length; i++) {
                                        const submeshData = vertexData.submeshData[i];
                                        if (submeshData.verticesStart <= vertex &&
                                            submeshData.verticesStart + submeshData.verticesCount > vertex) {
                                            submeshData.verticesCount += 1;
                                        }
                                        else if (submeshData.verticesStart > vertex) {
                                            submeshData.verticesStart += 1;
                                        }
                                        submeshData.indexCount = (positions.length + newPositions.length) / 3;
                                        submeshDataArray[i] = submeshData;
                                    }
                                }
                            }
                            else {
                                visitedVertices[vertex] = true;
                                if (planeNormal) {
                                    for (let i = 0; i < 3; i++) {
                                        normals[vertex * 3 + i] = planeNormal[i];
                                    }
                                }
                            }
                        }
                    });
                    const resultPositions = new Float32Array(positions.length + newPositions.length);
                    resultPositions.set(positions);
                    resultPositions.set(newPositions, positions.length);
                    const resultNormals = new Float32Array(normals.length + newNormals.length);
                    resultNormals.set(normals);
                    resultNormals.set(newNormals, normals.length);
                    const resultUvs = new Float32Array(uvs.length + newUvs.length);
                    resultUvs.set(uvs);
                    resultUvs.set(newUvs, uvs.length);
                    newVertexData.positions = resultPositions;
                    newVertexData.normals = resultNormals;
                    newVertexData.uvs = resultUvs;
                    newVertexData.indices = indices;
                    newVertexData.submeshData = submeshDataArray;
                }
            }
            this.viewer.updateNormalSmoothingWarnings(feature, this.totalSelectedIndices / 3, false);
            return newVertexData;
        }
        update3dInternal() { }
        delete3d(node, preserveCache) {
            this.viewer.updateNormalSmoothingWarnings(node, 0, true);
            super.delete3d(node);
        }
        //Formula for normal of a plane: (vectorA-VectorB) x (VectorB-VectorC)
        calculateNormalToRef(coordinates, normalVector) {
            Vector3.FromArrayToRef(coordinates[0], 0, this.vectorA);
            Vector3.FromArrayToRef(coordinates[1], 0, this.vectorB);
            Vector3.FromArrayToRef(coordinates[2], 0, this.vectorC);
            this.vectorA.subtractInPlace(this.vectorB);
            this.vectorB.subtractInPlace(this.vectorC);
            return Vector3.CrossToRef(this.vectorB, this.vectorA, normalVector);
        }
        calculateSmoothedUnitVector(vertices) {
            let result = [];
            vertices.forEach(vertex => {
                const normalVector = this.planeNormals.get(Math.floor(vertex / 3));
                if (normalVector) {
                    result = addArrays(result, normalVector);
                }
            });
            return this.calculateUnitVector(result);
        }
        calculateUnitVector(vector) {
            let divider = 0;
            const result = [];
            vector.forEach(element => {
                divider += element * element;
            });
            divider = Math.sqrt(divider);
            vector.forEach(element => {
                result.push(element / divider);
            });
            return result;
        }
    }

    /**
     * Represents one particle of a solid particle system.
     */
    class SolidParticle {
        /**
         * Particle BoundingInfo object
         * @returns a BoundingInfo
         */
        getBoundingInfo() {
            return this._boundingInfo;
        }
        /**
         * Returns true if there is already a bounding info
         */
        get hasBoundingInfo() {
            return this._boundingInfo !== null;
        }
        /**
         * Creates a Solid Particle object.
         * Don't create particles manually, use instead the Solid Particle System internal tools like _addParticle()
         * @param particleIndex (integer) is the particle index in the Solid Particle System pool.
         * @param particleId (integer) is the particle identifier. Unless some particles are removed from the SPS, it's the same value than the particle idx.
         * @param positionIndex (integer) is the starting index of the particle vertices in the SPS "positions" array.
         * @param indiceIndex (integer) is the starting index of the particle indices in the SPS "indices" array.
         * @param model (ModelShape) is a reference to the model shape on what the particle is designed.
         * @param shapeId (integer) is the model shape identifier in the SPS.
         * @param idxInShape (integer) is the index of the particle in the current model (ex: the 10th box of addShape(box, 30))
         * @param sps defines the sps it is associated to
         * @param modelBoundingInfo is the reference to the model BoundingInfo used for intersection computations.
         * @param materialIndex is the particle material identifier (integer) when the MultiMaterials are enabled in the SPS.
         */
        constructor(particleIndex, particleId, positionIndex, indiceIndex, model, shapeId, idxInShape, sps, modelBoundingInfo = null, materialIndex = null) {
            /**
             * particle global index
             */
            this.idx = 0;
            /**
             * particle identifier
             */
            this.id = 0;
            /**
             * The color of the particle
             */
            this.color = new Color4(1.0, 1.0, 1.0, 1.0);
            /**
             * The world space position of the particle.
             */
            this.position = Vector3.Zero();
            /**
             * The world space rotation of the particle. (Not use if rotationQuaternion is set)
             */
            this.rotation = Vector3.Zero();
            /**
             * The scaling of the particle.
             */
            this.scaling = Vector3.One();
            /**
             * The uvs of the particle.
             */
            this.uvs = new Vector4(0.0, 0.0, 1.0, 1.0);
            /**
             * The current speed of the particle.
             */
            this.velocity = Vector3.Zero();
            /**
             * The pivot point in the particle local space.
             */
            this.pivot = Vector3.Zero();
            /**
             * Must the particle be translated from its pivot point in its local space ?
             * In this case, the pivot point is set at the origin of the particle local space and the particle is translated.
             * Default : false
             */
            this.translateFromPivot = false;
            /**
             * Is the particle active or not ?
             */
            this.alive = true;
            /**
             * Is the particle visible or not ?
             */
            this.isVisible = true;
            /**
             * Index of this particle in the global "positions" array (Internal use)
             * @internal
             */
            this._pos = 0;
            /**
             * @internal Index of this particle in the global "indices" array (Internal use)
             */
            this._ind = 0;
            /**
             * ModelShape id of this particle
             */
            this.shapeId = 0;
            /**
             * Index of the particle in its shape id
             */
            this.idxInShape = 0;
            /**
             * @internal Still set as invisible in order to skip useless computations (Internal use)
             */
            this._stillInvisible = false;
            /**
             * @internal Last computed particle rotation matrix
             */
            this._rotationMatrix = [1.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0];
            /**
             * Parent particle Id, if any.
             * Default null.
             */
            this.parentId = null;
            /**
             * The particle material identifier (integer) when MultiMaterials are enabled in the SPS.
             */
            this.materialIndex = null;
            /**
             * Custom object or properties.
             */
            this.props = null;
            /**
             * The culling strategy to use to check whether the solid particle must be culled or not when using isInFrustum().
             * The possible values are :
             * - AbstractMesh.CULLINGSTRATEGY_STANDARD
             * - AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
             * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
             * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
             * The default value for solid particles is AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
             * Please read each static variable documentation in the class AbstractMesh to get details about the culling process.
             * */
            this.cullingStrategy = AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;
            /**
             * @internal Internal global position in the SPS.
             */
            this._globalPosition = Vector3.Zero();
            this.idx = particleIndex;
            this.id = particleId;
            this._pos = positionIndex;
            this._ind = indiceIndex;
            this._model = model;
            this.shapeId = shapeId;
            this.idxInShape = idxInShape;
            this._sps = sps;
            if (modelBoundingInfo) {
                this._modelBoundingInfo = modelBoundingInfo;
                this._boundingInfo = new BoundingInfo(modelBoundingInfo.minimum, modelBoundingInfo.maximum);
            }
            if (materialIndex !== null) {
                this.materialIndex = materialIndex;
            }
        }
        /**
         * Copies the particle property values into the existing target : position, rotation, scaling, uvs, colors, pivot, parent, visibility, alive
         * @param target the particle target
         * @returns the current particle
         */
        copyToRef(target) {
            target.position.copyFrom(this.position);
            target.rotation.copyFrom(this.rotation);
            if (this.rotationQuaternion) {
                if (target.rotationQuaternion) {
                    target.rotationQuaternion.copyFrom(this.rotationQuaternion);
                }
                else {
                    target.rotationQuaternion = this.rotationQuaternion.clone();
                }
            }
            target.scaling.copyFrom(this.scaling);
            if (this.color) {
                if (target.color) {
                    target.color.copyFrom(this.color);
                }
                else {
                    target.color = this.color.clone();
                }
            }
            target.uvs.copyFrom(this.uvs);
            target.velocity.copyFrom(this.velocity);
            target.pivot.copyFrom(this.pivot);
            target.translateFromPivot = this.translateFromPivot;
            target.alive = this.alive;
            target.isVisible = this.isVisible;
            target.parentId = this.parentId;
            target.cullingStrategy = this.cullingStrategy;
            if (this.materialIndex !== null) {
                target.materialIndex = this.materialIndex;
            }
            return this;
        }
        /**
         * Legacy support, changed scale to scaling
         */
        get scale() {
            return this.scaling;
        }
        /**
         * Legacy support, changed scale to scaling
         */
        set scale(scale) {
            this.scaling = scale;
        }
        /**
         * Legacy support, changed quaternion to rotationQuaternion
         */
        get quaternion() {
            return this.rotationQuaternion;
        }
        /**
         * Legacy support, changed quaternion to rotationQuaternion
         */
        set quaternion(q) {
            this.rotationQuaternion = q;
        }
        /**
         * Returns a boolean. True if the particle intersects another particle or another mesh, else false.
         * The intersection is computed on the particle bounding sphere and Axis Aligned Bounding Box (AABB)
         * @param target is the object (solid particle or mesh) what the intersection is computed against.
         * @returns true if it intersects
         */
        intersectsMesh(target) {
            if (!this._boundingInfo || !target.hasBoundingInfo) {
                return false;
            }
            if (this._sps._bSphereOnly) {
                return BoundingSphere.Intersects(this._boundingInfo.boundingSphere, target.getBoundingInfo().boundingSphere);
            }
            return this._boundingInfo.intersects(target.getBoundingInfo(), false);
        }
        /**
         * Returns `true` if the solid particle is within the frustum defined by the passed array of planes.
         * A particle is in the frustum if its bounding box intersects the frustum
         * @param frustumPlanes defines the frustum to test
         * @returns true if the particle is in the frustum planes
         */
        isInFrustum(frustumPlanes) {
            return this._boundingInfo !== null && this._boundingInfo.isInFrustum(frustumPlanes, this.cullingStrategy);
        }
        /**
         * get the rotation matrix of the particle
         * @internal
         */
        getRotationMatrix(m) {
            let quaternion;
            if (this.rotationQuaternion) {
                quaternion = this.rotationQuaternion;
            }
            else {
                quaternion = TmpVectors.Quaternion[0];
                const rotation = this.rotation;
                Quaternion.RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, quaternion);
            }
            quaternion.toRotationMatrix(m);
        }
    }
    /**
     * Represents the shape of the model used by one particle of a solid particle system.
     * SPS internal tool, don't use it manually.
     */
    class ModelShape {
        /**
         * Get or set the shapeId
         * @deprecated Please use shapeId instead
         */
        get shapeID() {
            return this.shapeId;
        }
        set shapeID(shapeID) {
            this.shapeId = shapeID;
        }
        /**
         * Creates a ModelShape object. This is an internal simplified reference to a mesh used as for a model to replicate particles from by the SPS.
         * SPS internal tool, don't use it manually.
         * @internal
         */
        constructor(id, shape, indices, normals, colors, shapeUV, posFunction, vtxFunction, material) {
            /**
             * length of the shape in the model indices array (internal use)
             * @internal
             */
            this._indicesLength = 0;
            this.shapeId = id;
            this._shape = shape;
            this._indices = indices;
            this._indicesLength = indices.length;
            this._shapeUV = shapeUV;
            this._shapeColors = colors;
            this._normals = normals;
            this._positionFunction = posFunction;
            this._vertexFunction = vtxFunction;
            this._material = material;
        }
    }
    /**
     * Represents a Depth Sorted Particle in the solid particle system.
     * @internal
     */
    class DepthSortedParticle {
        /**
         * Creates a new sorted particle
         * @param idx
         * @param ind
         * @param indLength
         * @param materialIndex
         */
        constructor(idx, ind, indLength, materialIndex) {
            /**
             * Particle index
             */
            this.idx = 0;
            /**
             * Index of the particle in the "indices" array
             */
            this.ind = 0;
            /**
             * Length of the particle shape in the "indices" array
             */
            this.indicesLength = 0;
            /**
             * Squared distance from the particle to the camera
             */
            this.sqDistance = 0.0;
            /**
             * Material index when used with MultiMaterials
             */
            this.materialIndex = 0;
            this.idx = idx;
            this.ind = ind;
            this.indicesLength = indLength;
            this.materialIndex = materialIndex;
        }
    }
    /**
     * Represents a solid particle vertex
     */
    class SolidParticleVertex {
        /**
         * Creates a new solid particle vertex
         */
        constructor() {
            this.position = Vector3.Zero();
            this.color = new Color4(1.0, 1.0, 1.0, 1.0);
            this.uv = Vector2.Zero();
        }
        // Getters and Setters for back-compatibility
        /** Vertex x coordinate */
        get x() {
            return this.position.x;
        }
        set x(val) {
            this.position.x = val;
        }
        /** Vertex y coordinate */
        get y() {
            return this.position.y;
        }
        set y(val) {
            this.position.y = val;
        }
        /** Vertex z coordinate */
        get z() {
            return this.position.z;
        }
        set z(val) {
            this.position.z = val;
        }
    }

    /**
     * The SPS is a single updatable mesh. The solid particles are simply separate parts or faces of this big mesh.
     *As it is just a mesh, the SPS has all the same properties than any other BJS mesh : not more, not less. It can be scaled, rotated, translated, enlighted, textured, moved, etc.

     * The SPS is also a particle system. It provides some methods to manage the particles.
     * However it is behavior agnostic. This means it has no emitter, no particle physics, no particle recycler. You have to implement your own behavior.
     *
     * Full documentation here : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_intro
     */
    class SolidParticleSystem {
        /**
         * Creates a SPS (Solid Particle System) object.
         * @param name (String) is the SPS name, this will be the underlying mesh name.
         * @param scene (Scene) is the scene in which the SPS is added.
         * @param options defines the options of the sps e.g.
         * * updatable (optional boolean, default true) : if the SPS must be updatable or immutable.
         * * isPickable (optional boolean, default false) : if the solid particles must be pickable.
         * * enableDepthSort (optional boolean, default false) : if the solid particles must be sorted in the geometry according to their distance to the camera.
         * * useModelMaterial (optional boolean, default false) : if the model materials must be used to create the SPS multimaterial. This enables the multimaterial supports of the SPS.
         * * enableMultiMaterial (optional boolean, default false) : if the solid particles can be given different materials.
         * * expandable (optional boolean, default false) : if particles can still be added after the initial SPS mesh creation.
         * * particleIntersection (optional boolean, default false) : if the solid particle intersections must be computed.
         * * boundingSphereOnly (optional boolean, default false) : if the particle intersection must be computed only with the bounding sphere (no bounding box computation, so faster).
         * * bSphereRadiusFactor (optional float, default 1.0) : a number to multiply the bounding sphere radius by in order to reduce it for instance.
         * * computeBoundingBox (optional boolean, default false): if the bounding box of the entire SPS will be computed (for occlusion detection, for example). If it is false, the bounding box will be the bounding box of the first particle.
         * * autoFixFaceOrientation (optional boolean, default false): if the particle face orientations will be flipped for transformations that change orientation (scale (-1, 1, 1), for example)
         * @param options.updatable
         * @param options.isPickable
         * @param options.enableDepthSort
         * @param options.particleIntersection
         * @param options.boundingSphereOnly
         * @param options.bSphereRadiusFactor
         * @param options.expandable
         * @param options.useModelMaterial
         * @param options.enableMultiMaterial
         * @param options.computeBoundingBox
         * @param options.autoFixFaceOrientation
         * @example bSphereRadiusFactor = 1.0 / Math.sqrt(3.0) => the bounding sphere exactly matches a spherical mesh.
         */
        constructor(name, scene, options) {
            /**
             *  The SPS array of Solid Particle objects. Just access each particle as with any classic array.
             *  Example : var p = SPS.particles[i];
             */
            this.particles = new Array();
            /**
             * The SPS total number of particles. Read only. Use SPS.counter instead if you need to set your own value.
             */
            this.nbParticles = 0;
            /**
             * If the particles must ever face the camera (default false). Useful for planar particles.
             */
            this.billboard = false;
            /**
             * Recompute normals when adding a shape
             */
            this.recomputeNormals = false;
            /**
             * This a counter ofr your own usage. It's not set by any SPS functions.
             */
            this.counter = 0;
            /**
             * This empty object is intended to store some SPS specific or temporary values in order to lower the Garbage Collector activity.
             * Please read : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/optimize_sps#limit-garbage-collection
             */
            this.vars = {};
            /**
             * If the particle intersection must be computed only with the bounding sphere (no bounding box computation, so faster). (Internal use only)
             * @internal
             */
            this._bSphereOnly = false;
            /**
             * A number to multiply the bounding sphere radius by in order to reduce it for instance. (Internal use only)
             * @internal
             */
            this._bSphereRadiusFactor = 1.0;
            this._positions = new Array();
            this._indices = new Array();
            this._normals = new Array();
            this._colors = new Array();
            this._uvs = new Array();
            this._index = 0; // indices index
            this._updatable = true;
            this._pickable = false;
            this._isVisibilityBoxLocked = false;
            this._alwaysVisible = false;
            this._depthSort = false;
            this._expandable = false;
            this._shapeCounter = 0;
            this._copy = new SolidParticle(0, 0, 0, 0, null, 0, 0, this);
            this._color = new Color4(0, 0, 0, 0);
            this._computeParticleColor = true;
            this._computeParticleTexture = true;
            this._computeParticleRotation = true;
            this._computeParticleVertex = false;
            this._computeBoundingBox = false;
            this._autoFixFaceOrientation = false;
            this._depthSortParticles = true;
            this._mustUnrotateFixedNormals = false;
            this._particlesIntersect = false;
            this._needs32Bits = false;
            this._isNotBuilt = true;
            this._lastParticleId = 0;
            this._idxOfId = []; // array : key = particle.id / value = particle.idx
            this._multimaterialEnabled = false;
            this._useModelMaterial = false;
            this._depthSortFunction = (p1, p2) => p2.sqDistance - p1.sqDistance;
            this._materialSortFunction = (p1, p2) => p1.materialIndex - p2.materialIndex;
            this._autoUpdateSubMeshes = false;
            this._recomputeInvisibles = false;
            this.name = name;
            this._scene = scene || EngineStore.LastCreatedScene;
            this._camera = scene.activeCamera;
            this._pickable = options ? options.isPickable : false;
            this._depthSort = options ? options.enableDepthSort : false;
            this._multimaterialEnabled = options ? options.enableMultiMaterial : false;
            this._useModelMaterial = options ? options.useModelMaterial : false;
            this._multimaterialEnabled = this._useModelMaterial ? true : this._multimaterialEnabled;
            this._expandable = options ? options.expandable : false;
            this._particlesIntersect = options ? options.particleIntersection : false;
            this._bSphereOnly = options ? options.boundingSphereOnly : false;
            this._bSphereRadiusFactor = options && options.bSphereRadiusFactor ? options.bSphereRadiusFactor : 1.0;
            this._computeBoundingBox = (options === null || options === void 0 ? void 0 : options.computeBoundingBox) ? options.computeBoundingBox : false;
            this._autoFixFaceOrientation = (options === null || options === void 0 ? void 0 : options.autoFixFaceOrientation) ? options.autoFixFaceOrientation : false;
            if (options && options.updatable !== undefined) {
                this._updatable = options.updatable;
            }
            else {
                this._updatable = true;
            }
            if (this._pickable) {
                this.pickedBySubMesh = [[]];
                this.pickedParticles = this.pickedBySubMesh[0];
            }
            if (this._depthSort || this._multimaterialEnabled) {
                this.depthSortedParticles = [];
            }
            if (this._multimaterialEnabled) {
                this._multimaterial = new MultiMaterial(this.name + "MultiMaterial", this._scene);
                this._materials = [];
                this._materialIndexesById = {};
            }
            this._tmpVertex = new SolidParticleVertex();
        }
        /**
         * Builds the SPS underlying mesh. Returns a standard Mesh.
         * If no model shape was added to the SPS, the returned mesh is just a single triangular plane.
         * @returns the created mesh
         */
        buildMesh() {
            if (!this._isNotBuilt && this.mesh) {
                return this.mesh;
            }
            if (this.nbParticles === 0 && !this.mesh) {
                const triangle = CreateDisc("", { radius: 1, tessellation: 3 }, this._scene);
                this.addShape(triangle, 1);
                triangle.dispose();
            }
            this._indices32 = this._needs32Bits ? new Uint32Array(this._indices) : new Uint16Array(this._indices);
            this._positions32 = new Float32Array(this._positions);
            this._uvs32 = new Float32Array(this._uvs);
            this._colors32 = new Float32Array(this._colors);
            if (!this.mesh) {
                // in case it's already expanded
                const mesh = new Mesh(this.name, this._scene);
                this.mesh = mesh;
            }
            if (!this._updatable && this._multimaterialEnabled) {
                this._sortParticlesByMaterial(); // this may reorder the indices32
            }
            if (this.recomputeNormals) {
                VertexData.ComputeNormals(this._positions32, this._indices32, this._normals);
            }
            this._normals32 = new Float32Array(this._normals);
            this._fixedNormal32 = new Float32Array(this._normals);
            if (this._mustUnrotateFixedNormals) {
                // the particles could be created already rotated in the mesh with a positionFunction
                this._unrotateFixedNormals();
            }
            const vertexData = new VertexData();
            vertexData.indices = this._depthSort ? this._indices : this._indices32;
            vertexData.set(this._positions32, VertexBuffer.PositionKind);
            vertexData.set(this._normals32, VertexBuffer.NormalKind);
            if (this._uvs32.length > 0) {
                vertexData.set(this._uvs32, VertexBuffer.UVKind);
            }
            if (this._colors32.length > 0) {
                vertexData.set(this._colors32, VertexBuffer.ColorKind);
            }
            vertexData.applyToMesh(this.mesh, this._updatable);
            this.mesh.isPickable = this._pickable;
            if (this._pickable) {
                let faceId = 0;
                for (let p = 0; p < this.nbParticles; p++) {
                    const part = this.particles[p];
                    const lind = part._model._indicesLength;
                    for (let i = 0; i < lind; i++) {
                        const f = i % 3;
                        if (f == 0) {
                            const pickedData = { idx: part.idx, faceId: faceId };
                            this.pickedParticles[faceId] = pickedData;
                            faceId++;
                        }
                    }
                }
            }
            if (this._multimaterialEnabled) {
                this.setMultiMaterial(this._materials);
            }
            if (!this._expandable) {
                // free memory
                if (!this._depthSort && !this._multimaterialEnabled && !this._autoFixFaceOrientation) {
                    this._indices = null;
                }
                this._positions = null;
                this._normals = null;
                this._uvs = null;
                this._colors = null;
                if (!this._updatable) {
                    this.particles.length = 0;
                }
            }
            this._isNotBuilt = false;
            this.recomputeNormals = false;
            this._recomputeInvisibles = true;
            return this.mesh;
        }
        /**
         * Digests the mesh and generates as many solid particles in the system as wanted. Returns the SPS.
         * These particles will have the same geometry than the mesh parts and will be positioned at the same localisation than the mesh original places.
         * Thus the particles generated from `digest()` have their property `position` set yet.
         * @param mesh ( Mesh ) is the mesh to be digested
         * @param options {facetNb} (optional integer, default 1) is the number of mesh facets per particle, this parameter is overridden by the parameter `number` if any
         * {delta} (optional integer, default 0) is the random extra number of facets per particle , each particle will have between `facetNb` and `facetNb + delta` facets
         * {number} (optional positive integer) is the wanted number of particles : each particle is built with `mesh_total_facets / number` facets
         * {storage} (optional existing array) is an array where the particles will be stored for a further use instead of being inserted in the SPS.
         * @param options.facetNb
         * @param options.number
         * @param options.delta
         * @param options.storage
         * @returns the current SPS
         */
        digest(mesh, options) {
            let size = (options && options.facetNb) || 1;
            let number = (options && options.number) || 0;
            let delta = (options && options.delta) || 0;
            const meshPos = mesh.getVerticesData(VertexBuffer.PositionKind);
            const meshInd = mesh.getIndices();
            const meshUV = mesh.getVerticesData(VertexBuffer.UVKind);
            const meshCol = mesh.getVerticesData(VertexBuffer.ColorKind);
            const meshNor = mesh.getVerticesData(VertexBuffer.NormalKind);
            const storage = options && options.storage ? options.storage : null;
            let f = 0; // facet counter
            const totalFacets = meshInd.length / 3; // a facet is a triangle, so 3 indices
            // compute size from number
            if (number) {
                number = number > totalFacets ? totalFacets : number;
                size = Math.round(totalFacets / number);
                delta = 0;
            }
            else {
                size = size > totalFacets ? totalFacets : size;
            }
            const facetPos = []; // submesh positions
            const facetNor = [];
            const facetInd = []; // submesh indices
            const facetUV = []; // submesh UV
            const facetCol = []; // submesh colors
            const barycenter = Vector3.Zero();
            const sizeO = size;
            while (f < totalFacets) {
                size = sizeO + Math.floor((1 + delta) * Math.random());
                if (f > totalFacets - size) {
                    size = totalFacets - f;
                }
                // reset temp arrays
                facetPos.length = 0;
                facetNor.length = 0;
                facetInd.length = 0;
                facetUV.length = 0;
                facetCol.length = 0;
                // iterate over "size" facets
                let fi = 0;
                for (let j = f * 3; j < (f + size) * 3; j++) {
                    facetInd.push(fi);
                    const i = meshInd[j];
                    const i3 = i * 3;
                    facetPos.push(meshPos[i3], meshPos[i3 + 1], meshPos[i3 + 2]);
                    facetNor.push(meshNor[i3], meshNor[i3 + 1], meshNor[i3 + 2]);
                    if (meshUV) {
                        const i2 = i * 2;
                        facetUV.push(meshUV[i2], meshUV[i2 + 1]);
                    }
                    if (meshCol) {
                        const i4 = i * 4;
                        facetCol.push(meshCol[i4], meshCol[i4 + 1], meshCol[i4 + 2], meshCol[i4 + 3]);
                    }
                    fi++;
                }
                // create a model shape for each single particle
                let idx = this.nbParticles;
                const shape = this._posToShape(facetPos);
                const shapeUV = this._uvsToShapeUV(facetUV);
                const shapeInd = facetInd.slice();
                const shapeCol = facetCol.slice();
                const shapeNor = facetNor.slice();
                // compute the barycenter of the shape
                barycenter.copyFromFloats(0, 0, 0);
                let v;
                for (v = 0; v < shape.length; v++) {
                    barycenter.addInPlace(shape[v]);
                }
                barycenter.scaleInPlace(1 / shape.length);
                // shift the shape from its barycenter to the origin
                // and compute the BBox required for intersection.
                const minimum = new Vector3(Infinity, Infinity, Infinity);
                const maximum = new Vector3(-Infinity, -Infinity, -Infinity);
                for (v = 0; v < shape.length; v++) {
                    shape[v].subtractInPlace(barycenter);
                    minimum.minimizeInPlaceFromFloats(shape[v].x, shape[v].y, shape[v].z);
                    maximum.maximizeInPlaceFromFloats(shape[v].x, shape[v].y, shape[v].z);
                }
                let bInfo;
                if (this._particlesIntersect) {
                    bInfo = new BoundingInfo(minimum, maximum);
                }
                let material = null;
                if (this._useModelMaterial) {
                    material = mesh.material ? mesh.material : this._setDefaultMaterial();
                }
                const modelShape = new ModelShape(this._shapeCounter, shape, shapeInd, shapeNor, shapeCol, shapeUV, null, null, material);
                // add the particle in the SPS
                const currentPos = this._positions.length;
                const currentInd = this._indices.length;
                this._meshBuilder(this._index, currentInd, shape, this._positions, shapeInd, this._indices, facetUV, this._uvs, shapeCol, this._colors, shapeNor, this._normals, idx, 0, null, modelShape);
                this._addParticle(idx, this._lastParticleId, currentPos, currentInd, modelShape, this._shapeCounter, 0, bInfo, storage);
                // initialize the particle position
                this.particles[this.nbParticles].position.addInPlace(barycenter);
                if (!storage) {
                    this._index += shape.length;
                    idx++;
                    this.nbParticles++;
                    this._lastParticleId++;
                }
                this._shapeCounter++;
                f += size;
            }
            this._isNotBuilt = true; // buildMesh() is now expected for setParticles() to work
            return this;
        }
        /**
         * Unrotate the fixed normals in case the mesh was built with pre-rotated particles, ex : use of positionFunction in addShape()
         * @internal
         */
        _unrotateFixedNormals() {
            let index = 0;
            let idx = 0;
            const tmpNormal = TmpVectors.Vector3[0];
            const quaternion = TmpVectors.Quaternion[0];
            const invertedRotMatrix = TmpVectors.Matrix[0];
            for (let p = 0; p < this.particles.length; p++) {
                const particle = this.particles[p];
                const shape = particle._model._shape;
                // computing the inverse of the rotation matrix from the quaternion
                // is equivalent to computing the matrix of the inverse quaternion, i.e of the conjugate quaternion
                if (particle.rotationQuaternion) {
                    particle.rotationQuaternion.conjugateToRef(quaternion);
                }
                else {
                    const rotation = particle.rotation;
                    Quaternion.RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, quaternion);
                    quaternion.conjugateInPlace();
                }
                quaternion.toRotationMatrix(invertedRotMatrix);
                for (let pt = 0; pt < shape.length; pt++) {
                    idx = index + pt * 3;
                    Vector3.TransformNormalFromFloatsToRef(this._normals32[idx], this._normals32[idx + 1], this._normals32[idx + 2], invertedRotMatrix, tmpNormal);
                    tmpNormal.toArray(this._fixedNormal32, idx);
                }
                index = idx + 3;
            }
        }
        /**
         * Resets the temporary working copy particle
         * @internal
         */
        _resetCopy() {
            const copy = this._copy;
            copy.position.setAll(0);
            copy.rotation.setAll(0);
            copy.rotationQuaternion = null;
            copy.scaling.setAll(1);
            copy.uvs.copyFromFloats(0.0, 0.0, 1.0, 1.0);
            copy.color = null;
            copy.translateFromPivot = false;
            copy.shapeId = 0;
            copy.materialIndex = null;
        }
        /**
         * Inserts the shape model geometry in the global SPS mesh by updating the positions, indices, normals, colors, uvs arrays
         * @param p the current index in the positions array to be updated
         * @param ind the current index in the indices array
         * @param shape a Vector3 array, the shape geometry
         * @param positions the positions array to be updated
         * @param meshInd the shape indices array
         * @param indices the indices array to be updated
         * @param meshUV the shape uv array
         * @param uvs the uv array to be updated
         * @param meshCol the shape color array
         * @param colors the color array to be updated
         * @param meshNor the shape normals array
         * @param normals the normals array to be updated
         * @param idx the particle index
         * @param idxInShape the particle index in its shape
         * @param options the addShape() method  passed options
         * @param model
         * @model the particle model
         * @internal
         */
        _meshBuilder(p, ind, shape, positions, meshInd, indices, meshUV, uvs, meshCol, colors, meshNor, normals, idx, idxInShape, options, model) {
            let i;
            let u = 0;
            let c = 0;
            let n = 0;
            this._resetCopy();
            const copy = this._copy;
            const storeApart = options && options.storage ? true : false;
            copy.idx = idx;
            copy.idxInShape = idxInShape;
            copy.shapeId = model.shapeId;
            if (this._useModelMaterial) {
                const materialId = model._material.uniqueId;
                const materialIndexesById = this._materialIndexesById;
                if (!Object.prototype.hasOwnProperty.call(materialIndexesById, materialId)) {
                    materialIndexesById[materialId] = this._materials.length;
                    this._materials.push(model._material);
                }
                const matIdx = materialIndexesById[materialId];
                copy.materialIndex = matIdx;
            }
            if (options && options.positionFunction) {
                // call to custom positionFunction
                options.positionFunction(copy, idx, idxInShape);
                this._mustUnrotateFixedNormals = true;
            }
            // in case the particle geometry must NOT be inserted in the SPS mesh geometry
            if (storeApart) {
                return copy;
            }
            const rotMatrix = TmpVectors.Matrix[0];
            const tmpVertex = this._tmpVertex;
            const tmpVector = tmpVertex.position;
            const tmpColor = tmpVertex.color;
            const tmpUV = tmpVertex.uv;
            const tmpRotated = TmpVectors.Vector3[1];
            const pivotBackTranslation = TmpVectors.Vector3[2];
            const scaledPivot = TmpVectors.Vector3[3];
            Matrix.IdentityToRef(rotMatrix);
            copy.getRotationMatrix(rotMatrix);
            copy.pivot.multiplyToRef(copy.scaling, scaledPivot);
            if (copy.translateFromPivot) {
                pivotBackTranslation.setAll(0.0);
            }
            else {
                pivotBackTranslation.copyFrom(scaledPivot);
            }
            const someVertexFunction = options && options.vertexFunction;
            for (i = 0; i < shape.length; i++) {
                tmpVector.copyFrom(shape[i]);
                if (copy.color) {
                    tmpColor.copyFrom(copy.color);
                }
                if (meshUV) {
                    tmpUV.copyFromFloats(meshUV[u], meshUV[u + 1]);
                }
                if (someVertexFunction) {
                    options.vertexFunction(copy, tmpVertex, i);
                }
                tmpVector.multiplyInPlace(copy.scaling).subtractInPlace(scaledPivot);
                Vector3.TransformCoordinatesToRef(tmpVector, rotMatrix, tmpRotated);
                tmpRotated.addInPlace(pivotBackTranslation).addInPlace(copy.position);
                positions.push(tmpRotated.x, tmpRotated.y, tmpRotated.z);
                if (meshUV) {
                    const copyUvs = copy.uvs;
                    uvs.push((copyUvs.z - copyUvs.x) * tmpUV.x + copyUvs.x, (copyUvs.w - copyUvs.y) * tmpUV.y + copyUvs.y);
                    u += 2;
                }
                if (copy.color) {
                    this._color.copyFrom(tmpColor);
                }
                else {
                    const color = this._color;
                    if (meshCol && meshCol[c] !== undefined) {
                        color.r = meshCol[c];
                        color.g = meshCol[c + 1];
                        color.b = meshCol[c + 2];
                        color.a = meshCol[c + 3];
                    }
                    else {
                        color.r = 1.0;
                        color.g = 1.0;
                        color.b = 1.0;
                        color.a = 1.0;
                    }
                }
                colors.push(this._color.r, this._color.g, this._color.b, this._color.a);
                c += 4;
                if (!this.recomputeNormals && meshNor) {
                    Vector3.TransformNormalFromFloatsToRef(meshNor[n], meshNor[n + 1], meshNor[n + 2], rotMatrix, tmpVector);
                    normals.push(tmpVector.x, tmpVector.y, tmpVector.z);
                    n += 3;
                }
            }
            for (i = 0; i < meshInd.length; i++) {
                const current_ind = p + meshInd[i];
                indices.push(current_ind);
                if (current_ind > 65535) {
                    this._needs32Bits = true;
                }
            }
            if (this._depthSort || this._multimaterialEnabled) {
                const matIndex = copy.materialIndex !== null ? copy.materialIndex : 0;
                this.depthSortedParticles.push(new DepthSortedParticle(idx, ind, meshInd.length, matIndex));
            }
            return copy;
        }
        /**
         * Returns a shape Vector3 array from positions float array
         * @param positions float array
         * @returns a vector3 array
         * @internal
         */
        _posToShape(positions) {
            const shape = [];
            for (let i = 0; i < positions.length; i += 3) {
                shape.push(Vector3.FromArray(positions, i));
            }
            return shape;
        }
        /**
         * Returns a shapeUV array from a float uvs (array deep copy)
         * @param uvs as a float array
         * @returns a shapeUV array
         * @internal
         */
        _uvsToShapeUV(uvs) {
            const shapeUV = [];
            if (uvs) {
                for (let i = 0; i < uvs.length; i++) {
                    shapeUV.push(uvs[i]);
                }
            }
            return shapeUV;
        }
        /**
         * Adds a new particle object in the particles array
         * @param idx particle index in particles array
         * @param id particle id
         * @param idxpos positionIndex : the starting index of the particle vertices in the SPS "positions" array
         * @param idxind indiceIndex : he starting index of the particle indices in the SPS "indices" array
         * @param model particle ModelShape object
         * @param shapeId model shape identifier
         * @param idxInShape index of the particle in the current model
         * @param bInfo model bounding info object
         * @param storage target storage array, if any
         * @internal
         */
        _addParticle(idx, id, idxpos, idxind, model, shapeId, idxInShape, bInfo = null, storage = null) {
            const sp = new SolidParticle(idx, id, idxpos, idxind, model, shapeId, idxInShape, this, bInfo);
            const target = storage ? storage : this.particles;
            target.push(sp);
            return sp;
        }
        /**
         * Adds some particles to the SPS from the model shape. Returns the shape id.
         * Please read the doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/immutable_sps
         * @param mesh is any Mesh object that will be used as a model for the solid particles.
         * @param nb (positive integer) the number of particles to be created from this model
         * @param options {positionFunction} is an optional javascript function to called for each particle on SPS creation.
         * {vertexFunction} is an optional javascript function to called for each vertex of each particle on SPS creation
         * {storage} (optional existing array) is an array where the particles will be stored for a further use instead of being inserted in the SPS.
         * @param options.positionFunction
         * @param options.vertexFunction
         * @param options.storage
         * @returns the number of shapes in the system
         */
        addShape(mesh, nb, options) {
            const meshPos = mesh.getVerticesData(VertexBuffer.PositionKind);
            const meshInd = mesh.getIndices();
            const meshUV = mesh.getVerticesData(VertexBuffer.UVKind);
            const meshCol = mesh.getVerticesData(VertexBuffer.ColorKind);
            const meshNor = mesh.getVerticesData(VertexBuffer.NormalKind);
            this.recomputeNormals = meshNor ? false : true;
            const indices = Array.from(meshInd);
            const shapeNormals = Array.from(meshNor);
            const shapeColors = meshCol ? Array.from(meshCol) : [];
            const storage = options && options.storage ? options.storage : null;
            let bbInfo = null;
            if (this._particlesIntersect) {
                bbInfo = mesh.getBoundingInfo();
            }
            const shape = this._posToShape(meshPos);
            const shapeUV = this._uvsToShapeUV(meshUV);
            const posfunc = options ? options.positionFunction : null;
            const vtxfunc = options ? options.vertexFunction : null;
            let material = null;
            if (this._useModelMaterial) {
                material = mesh.material ? mesh.material : this._setDefaultMaterial();
            }
            const modelShape = new ModelShape(this._shapeCounter, shape, indices, shapeNormals, shapeColors, shapeUV, posfunc, vtxfunc, material);
            // particles
            for (let i = 0; i < nb; i++) {
                this._insertNewParticle(this.nbParticles, i, modelShape, shape, meshInd, meshUV, meshCol, meshNor, bbInfo, storage, options);
            }
            this._shapeCounter++;
            this._isNotBuilt = true; // buildMesh() call is now expected for setParticles() to work
            return this._shapeCounter - 1;
        }
        /**
         * Rebuilds a particle back to its just built status : if needed, recomputes the custom positions and vertices
         * @internal
         */
        _rebuildParticle(particle, reset = false) {
            this._resetCopy();
            const copy = this._copy;
            if (particle._model._positionFunction) {
                // recall to stored custom positionFunction
                particle._model._positionFunction(copy, particle.idx, particle.idxInShape);
            }
            const rotMatrix = TmpVectors.Matrix[0];
            const tmpVertex = TmpVectors.Vector3[0];
            const tmpRotated = TmpVectors.Vector3[1];
            const pivotBackTranslation = TmpVectors.Vector3[2];
            const scaledPivot = TmpVectors.Vector3[3];
            copy.getRotationMatrix(rotMatrix);
            particle.pivot.multiplyToRef(particle.scaling, scaledPivot);
            if (copy.translateFromPivot) {
                pivotBackTranslation.copyFromFloats(0.0, 0.0, 0.0);
            }
            else {
                pivotBackTranslation.copyFrom(scaledPivot);
            }
            const shape = particle._model._shape;
            for (let pt = 0; pt < shape.length; pt++) {
                tmpVertex.copyFrom(shape[pt]);
                if (particle._model._vertexFunction) {
                    particle._model._vertexFunction(copy, tmpVertex, pt); // recall to stored vertexFunction
                }
                tmpVertex.multiplyInPlace(copy.scaling).subtractInPlace(scaledPivot);
                Vector3.TransformCoordinatesToRef(tmpVertex, rotMatrix, tmpRotated);
                tmpRotated
                    .addInPlace(pivotBackTranslation)
                    .addInPlace(copy.position)
                    .toArray(this._positions32, particle._pos + pt * 3);
            }
            if (reset) {
                particle.position.setAll(0.0);
                particle.rotation.setAll(0.0);
                particle.rotationQuaternion = null;
                particle.scaling.setAll(1.0);
                particle.uvs.setAll(0.0);
                particle.pivot.setAll(0.0);
                particle.translateFromPivot = false;
                particle.parentId = null;
            }
        }
        /**
         * Rebuilds the whole mesh and updates the VBO : custom positions and vertices are recomputed if needed.
         * @param reset boolean, default false : if the particles must be reset at position and rotation zero, scaling 1, color white, initial UVs and not parented.
         * @returns the SPS.
         */
        rebuildMesh(reset = false) {
            for (let p = 0; p < this.particles.length; p++) {
                this._rebuildParticle(this.particles[p], reset);
            }
            this.mesh.updateVerticesData(VertexBuffer.PositionKind, this._positions32, false, false);
            return this;
        }
        /** Removes the particles from the start-th to the end-th included from an expandable SPS (required).
         *  Returns an array with the removed particles.
         *  If the number of particles to remove is lower than zero or greater than the global remaining particle number, then an empty array is returned.
         *  The SPS can't be empty so at least one particle needs to remain in place.
         *  Under the hood, the VertexData array, so the VBO buffer, is recreated each call.
         * @param start index of the first particle to remove
         * @param end index of the last particle to remove (included)
         * @returns an array populated with the removed particles
         */
        removeParticles(start, end) {
            const nb = end - start + 1;
            if (!this._expandable || nb <= 0 || nb >= this.nbParticles || !this._updatable) {
                return [];
            }
            const particles = this.particles;
            const currentNb = this.nbParticles;
            if (end < currentNb - 1) {
                // update the particle indexes in the positions array in case they're remaining particles after the last removed
                const firstRemaining = end + 1;
                const shiftPos = particles[firstRemaining]._pos - particles[start]._pos;
                const shifInd = particles[firstRemaining]._ind - particles[start]._ind;
                for (let i = firstRemaining; i < currentNb; i++) {
                    const part = particles[i];
                    part._pos -= shiftPos;
                    part._ind -= shifInd;
                }
            }
            const removed = particles.splice(start, nb);
            this._positions.length = 0;
            this._indices.length = 0;
            this._colors.length = 0;
            this._uvs.length = 0;
            this._normals.length = 0;
            this._index = 0;
            this._idxOfId.length = 0;
            if (this._depthSort || this._multimaterialEnabled) {
                this.depthSortedParticles = [];
            }
            let ind = 0;
            const particlesLength = particles.length;
            for (let p = 0; p < particlesLength; p++) {
                const particle = particles[p];
                const model = particle._model;
                const shape = model._shape;
                const modelIndices = model._indices;
                const modelNormals = model._normals;
                const modelColors = model._shapeColors;
                const modelUVs = model._shapeUV;
                particle.idx = p;
                this._idxOfId[particle.id] = p;
                this._meshBuilder(this._index, ind, shape, this._positions, modelIndices, this._indices, modelUVs, this._uvs, modelColors, this._colors, modelNormals, this._normals, particle.idx, particle.idxInShape, null, model);
                this._index += shape.length;
                ind += modelIndices.length;
            }
            this.nbParticles -= nb;
            this._isNotBuilt = true; // buildMesh() call is now expected for setParticles() to work
            return removed;
        }
        /**
         * Inserts some pre-created particles in the solid particle system so that they can be managed by setParticles().
         * @param solidParticleArray an array populated with Solid Particles objects
         * @returns the SPS
         */
        insertParticlesFromArray(solidParticleArray) {
            if (!this._expandable) {
                return this;
            }
            let idxInShape = 0;
            let currentShapeId = solidParticleArray[0].shapeId;
            const nb = solidParticleArray.length;
            for (let i = 0; i < nb; i++) {
                const sp = solidParticleArray[i];
                const model = sp._model;
                const shape = model._shape;
                const meshInd = model._indices;
                const meshUV = model._shapeUV;
                const meshCol = model._shapeColors;
                const meshNor = model._normals;
                const noNor = meshNor ? false : true;
                this.recomputeNormals = noNor || this.recomputeNormals;
                const bbInfo = sp.getBoundingInfo();
                const newPart = this._insertNewParticle(this.nbParticles, idxInShape, model, shape, meshInd, meshUV, meshCol, meshNor, bbInfo, null, null);
                sp.copyToRef(newPart);
                idxInShape++;
                if (currentShapeId != sp.shapeId) {
                    currentShapeId = sp.shapeId;
                    idxInShape = 0;
                }
            }
            this._isNotBuilt = true; // buildMesh() call is now expected for setParticles() to work
            return this;
        }
        /**
         * Creates a new particle and modifies the SPS mesh geometry :
         * - calls _meshBuilder() to increase the SPS mesh geometry step by step
         * - calls _addParticle() to populate the particle array
         * factorized code from addShape() and insertParticlesFromArray()
         * @param idx particle index in the particles array
         * @param i particle index in its shape
         * @param modelShape particle ModelShape object
         * @param shape shape vertex array
         * @param meshInd shape indices array
         * @param meshUV shape uv array
         * @param meshCol shape color array
         * @param meshNor shape normals array
         * @param bbInfo shape bounding info
         * @param storage target particle storage
         * @param options
         * @options addShape() passed options
         * @internal
         */
        _insertNewParticle(idx, i, modelShape, shape, meshInd, meshUV, meshCol, meshNor, bbInfo, storage, options) {
            const currentPos = this._positions.length;
            const currentInd = this._indices.length;
            const currentCopy = this._meshBuilder(this._index, currentInd, shape, this._positions, meshInd, this._indices, meshUV, this._uvs, meshCol, this._colors, meshNor, this._normals, idx, i, options, modelShape);
            let sp = null;
            if (this._updatable) {
                sp = this._addParticle(this.nbParticles, this._lastParticleId, currentPos, currentInd, modelShape, this._shapeCounter, i, bbInfo, storage);
                sp.position.copyFrom(currentCopy.position);
                sp.rotation.copyFrom(currentCopy.rotation);
                if (currentCopy.rotationQuaternion) {
                    if (sp.rotationQuaternion) {
                        sp.rotationQuaternion.copyFrom(currentCopy.rotationQuaternion);
                    }
                    else {
                        sp.rotationQuaternion = currentCopy.rotationQuaternion.clone();
                    }
                }
                if (currentCopy.color) {
                    if (sp.color) {
                        sp.color.copyFrom(currentCopy.color);
                    }
                    else {
                        sp.color = currentCopy.color.clone();
                    }
                }
                sp.scaling.copyFrom(currentCopy.scaling);
                sp.uvs.copyFrom(currentCopy.uvs);
                if (currentCopy.materialIndex !== null) {
                    sp.materialIndex = currentCopy.materialIndex;
                }
                if (this.expandable) {
                    this._idxOfId[sp.id] = sp.idx;
                }
            }
            if (!storage) {
                this._index += shape.length;
                this.nbParticles++;
                this._lastParticleId++;
            }
            return sp;
        }
        /**
         *  Sets all the particles : this method actually really updates the mesh according to the particle positions, rotations, colors, textures, etc.
         *  This method calls `updateParticle()` for each particle of the SPS.
         *  For an animated SPS, it is usually called within the render loop.
         * This methods does nothing if called on a non updatable or not yet built SPS. Example : buildMesh() not called after having added or removed particles from an expandable SPS.
         * @param start The particle index in the particle array where to start to compute the particle property values _(default 0)_
         * @param end The particle index in the particle array where to stop to compute the particle property values _(default nbParticle - 1)_
         * @param update If the mesh must be finally updated on this call after all the particle computations _(default true)_
         * @returns the SPS.
         */
        setParticles(start = 0, end = this.nbParticles - 1, update = true) {
            if (!this._updatable || this._isNotBuilt) {
                return this;
            }
            // custom beforeUpdate
            this.beforeUpdateParticles(start, end, update);
            const rotMatrix = TmpVectors.Matrix[0];
            const invertedMatrix = TmpVectors.Matrix[1];
            const mesh = this.mesh;
            const colors32 = this._colors32;
            const positions32 = this._positions32;
            const normals32 = this._normals32;
            const uvs32 = this._uvs32;
            const indices32 = this._indices32;
            const indices = this._indices;
            const fixedNormal32 = this._fixedNormal32;
            const depthSortParticles = this._depthSort && this._depthSortParticles;
            const tempVectors = TmpVectors.Vector3;
            const camAxisX = tempVectors[5].copyFromFloats(1.0, 0.0, 0.0);
            const camAxisY = tempVectors[6].copyFromFloats(0.0, 1.0, 0.0);
            const camAxisZ = tempVectors[7].copyFromFloats(0.0, 0.0, 1.0);
            const minimum = tempVectors[8].setAll(Number.MAX_VALUE);
            const maximum = tempVectors[9].setAll(-Number.MAX_VALUE);
            const camInvertedPosition = tempVectors[10].setAll(0);
            const tmpVertex = this._tmpVertex;
            const tmpVector = tmpVertex.position;
            const tmpColor = tmpVertex.color;
            const tmpUV = tmpVertex.uv;
            // cases when the World Matrix is to be computed first
            if (this.billboard || this._depthSort) {
                this.mesh.computeWorldMatrix(true);
                this.mesh._worldMatrix.invertToRef(invertedMatrix);
            }
            // if the particles will always face the camera
            if (this.billboard) {
                // compute the camera position and un-rotate it by the current mesh rotation
                const tmpVector0 = tempVectors[0];
                this._camera.getDirectionToRef(Axis.Z, tmpVector0);
                Vector3.TransformNormalToRef(tmpVector0, invertedMatrix, camAxisZ);
                camAxisZ.normalize();
                // same for camera up vector extracted from the cam view matrix
                const view = this._camera.getViewMatrix(true);
                Vector3.TransformNormalFromFloatsToRef(view.m[1], view.m[5], view.m[9], invertedMatrix, camAxisY);
                Vector3.CrossToRef(camAxisY, camAxisZ, camAxisX);
                camAxisY.normalize();
                camAxisX.normalize();
            }
            // if depthSort, compute the camera global position in the mesh local system
            if (this._depthSort) {
                Vector3.TransformCoordinatesToRef(this._camera.globalPosition, invertedMatrix, camInvertedPosition); // then un-rotate the camera
            }
            Matrix.IdentityToRef(rotMatrix);
            let idx = 0; // current position index in the global array positions32
            let index = 0; // position start index in the global array positions32 of the current particle
            let colidx = 0; // current color index in the global array colors32
            let colorIndex = 0; // color start index in the global array colors32 of the current particle
            let uvidx = 0; // current uv index in the global array uvs32
            let uvIndex = 0; // uv start index in the global array uvs32 of the current particle
            let pt = 0; // current index in the particle model shape
            if (this.mesh.isFacetDataEnabled) {
                this._computeBoundingBox = true;
            }
            end = end >= this.nbParticles ? this.nbParticles - 1 : end;
            if (this._computeBoundingBox) {
                if (start != 0 || end != this.nbParticles - 1) {
                    // only some particles are updated, then use the current existing BBox basis. Note : it can only increase.
                    const boundingInfo = this.mesh.getBoundingInfo();
                    if (boundingInfo) {
                        minimum.copyFrom(boundingInfo.minimum);
                        maximum.copyFrom(boundingInfo.maximum);
                    }
                }
            }
            // particle loop
            index = this.particles[start]._pos;
            const vpos = (index / 3) | 0;
            colorIndex = vpos * 4;
            uvIndex = vpos * 2;
            for (let p = start; p <= end; p++) {
                const particle = this.particles[p];
                // call to custom user function to update the particle properties
                this.updateParticle(particle);
                const shape = particle._model._shape;
                const shapeUV = particle._model._shapeUV;
                const particleRotationMatrix = particle._rotationMatrix;
                const particlePosition = particle.position;
                const particleRotation = particle.rotation;
                const particleScaling = particle.scaling;
                const particleGlobalPosition = particle._globalPosition;
                // camera-particle distance for depth sorting
                if (depthSortParticles) {
                    const dsp = this.depthSortedParticles[p];
                    dsp.idx = particle.idx;
                    dsp.ind = particle._ind;
                    dsp.indicesLength = particle._model._indicesLength;
                    dsp.sqDistance = Vector3.DistanceSquared(particle.position, camInvertedPosition);
                }
                // skip the computations for inactive or already invisible particles
                if (!particle.alive || (particle._stillInvisible && !particle.isVisible && !this._recomputeInvisibles)) {
                    // increment indexes for the next particle
                    pt = shape.length;
                    index += pt * 3;
                    colorIndex += pt * 4;
                    uvIndex += pt * 2;
                    continue;
                }
                if (particle.isVisible) {
                    particle._stillInvisible = false; // un-mark permanent invisibility
                    const scaledPivot = tempVectors[12];
                    particle.pivot.multiplyToRef(particleScaling, scaledPivot);
                    // particle rotation matrix
                    if (this.billboard) {
                        particleRotation.x = 0.0;
                        particleRotation.y = 0.0;
                    }
                    if (this._computeParticleRotation || this.billboard) {
                        particle.getRotationMatrix(rotMatrix);
                    }
                    const particleHasParent = particle.parentId !== null;
                    if (particleHasParent) {
                        const parent = this.getParticleById(particle.parentId);
                        if (parent) {
                            const parentRotationMatrix = parent._rotationMatrix;
                            const parentGlobalPosition = parent._globalPosition;
                            const rotatedY = particlePosition.x * parentRotationMatrix[1] + particlePosition.y * parentRotationMatrix[4] + particlePosition.z * parentRotationMatrix[7];
                            const rotatedX = particlePosition.x * parentRotationMatrix[0] + particlePosition.y * parentRotationMatrix[3] + particlePosition.z * parentRotationMatrix[6];
                            const rotatedZ = particlePosition.x * parentRotationMatrix[2] + particlePosition.y * parentRotationMatrix[5] + particlePosition.z * parentRotationMatrix[8];
                            particleGlobalPosition.x = parentGlobalPosition.x + rotatedX;
                            particleGlobalPosition.y = parentGlobalPosition.y + rotatedY;
                            particleGlobalPosition.z = parentGlobalPosition.z + rotatedZ;
                            if (this._computeParticleRotation || this.billboard) {
                                const rotMatrixValues = rotMatrix.m;
                                particleRotationMatrix[0] =
                                    rotMatrixValues[0] * parentRotationMatrix[0] + rotMatrixValues[1] * parentRotationMatrix[3] + rotMatrixValues[2] * parentRotationMatrix[6];
                                particleRotationMatrix[1] =
                                    rotMatrixValues[0] * parentRotationMatrix[1] + rotMatrixValues[1] * parentRotationMatrix[4] + rotMatrixValues[2] * parentRotationMatrix[7];
                                particleRotationMatrix[2] =
                                    rotMatrixValues[0] * parentRotationMatrix[2] + rotMatrixValues[1] * parentRotationMatrix[5] + rotMatrixValues[2] * parentRotationMatrix[8];
                                particleRotationMatrix[3] =
                                    rotMatrixValues[4] * parentRotationMatrix[0] + rotMatrixValues[5] * parentRotationMatrix[3] + rotMatrixValues[6] * parentRotationMatrix[6];
                                particleRotationMatrix[4] =
                                    rotMatrixValues[4] * parentRotationMatrix[1] + rotMatrixValues[5] * parentRotationMatrix[4] + rotMatrixValues[6] * parentRotationMatrix[7];
                                particleRotationMatrix[5] =
                                    rotMatrixValues[4] * parentRotationMatrix[2] + rotMatrixValues[5] * parentRotationMatrix[5] + rotMatrixValues[6] * parentRotationMatrix[8];
                                particleRotationMatrix[6] =
                                    rotMatrixValues[8] * parentRotationMatrix[0] + rotMatrixValues[9] * parentRotationMatrix[3] + rotMatrixValues[10] * parentRotationMatrix[6];
                                particleRotationMatrix[7] =
                                    rotMatrixValues[8] * parentRotationMatrix[1] + rotMatrixValues[9] * parentRotationMatrix[4] + rotMatrixValues[10] * parentRotationMatrix[7];
                                particleRotationMatrix[8] =
                                    rotMatrixValues[8] * parentRotationMatrix[2] + rotMatrixValues[9] * parentRotationMatrix[5] + rotMatrixValues[10] * parentRotationMatrix[8];
                            }
                        }
                        else {
                            // in case the parent were removed at some moment
                            particle.parentId = null;
                        }
                    }
                    else {
                        particleGlobalPosition.x = particlePosition.x;
                        particleGlobalPosition.y = particlePosition.y;
                        particleGlobalPosition.z = particlePosition.z;
                        if (this._computeParticleRotation || this.billboard) {
                            const rotMatrixValues = rotMatrix.m;
                            particleRotationMatrix[0] = rotMatrixValues[0];
                            particleRotationMatrix[1] = rotMatrixValues[1];
                            particleRotationMatrix[2] = rotMatrixValues[2];
                            particleRotationMatrix[3] = rotMatrixValues[4];
                            particleRotationMatrix[4] = rotMatrixValues[5];
                            particleRotationMatrix[5] = rotMatrixValues[6];
                            particleRotationMatrix[6] = rotMatrixValues[8];
                            particleRotationMatrix[7] = rotMatrixValues[9];
                            particleRotationMatrix[8] = rotMatrixValues[10];
                        }
                    }
                    const pivotBackTranslation = tempVectors[11];
                    if (particle.translateFromPivot) {
                        pivotBackTranslation.setAll(0.0);
                    }
                    else {
                        pivotBackTranslation.copyFrom(scaledPivot);
                    }
                    // particle vertex loop
                    for (pt = 0; pt < shape.length; pt++) {
                        idx = index + pt * 3;
                        colidx = colorIndex + pt * 4;
                        uvidx = uvIndex + pt * 2;
                        const iu = 2 * pt;
                        const iv = iu + 1;
                        tmpVector.copyFrom(shape[pt]);
                        if (this._computeParticleColor && particle.color) {
                            tmpColor.copyFrom(particle.color);
                        }
                        if (this._computeParticleTexture) {
                            tmpUV.copyFromFloats(shapeUV[iu], shapeUV[iv]);
                        }
                        if (this._computeParticleVertex) {
                            this.updateParticleVertex(particle, tmpVertex, pt);
                        }
                        // positions
                        const vertexX = tmpVector.x * particleScaling.x - scaledPivot.x;
                        const vertexY = tmpVector.y * particleScaling.y - scaledPivot.y;
                        const vertexZ = tmpVector.z * particleScaling.z - scaledPivot.z;
                        let rotatedX = vertexX * particleRotationMatrix[0] + vertexY * particleRotationMatrix[3] + vertexZ * particleRotationMatrix[6];
                        let rotatedY = vertexX * particleRotationMatrix[1] + vertexY * particleRotationMatrix[4] + vertexZ * particleRotationMatrix[7];
                        let rotatedZ = vertexX * particleRotationMatrix[2] + vertexY * particleRotationMatrix[5] + vertexZ * particleRotationMatrix[8];
                        rotatedX += pivotBackTranslation.x;
                        rotatedY += pivotBackTranslation.y;
                        rotatedZ += pivotBackTranslation.z;
                        const px = (positions32[idx] = particleGlobalPosition.x + camAxisX.x * rotatedX + camAxisY.x * rotatedY + camAxisZ.x * rotatedZ);
                        const py = (positions32[idx + 1] = particleGlobalPosition.y + camAxisX.y * rotatedX + camAxisY.y * rotatedY + camAxisZ.y * rotatedZ);
                        const pz = (positions32[idx + 2] = particleGlobalPosition.z + camAxisX.z * rotatedX + camAxisY.z * rotatedY + camAxisZ.z * rotatedZ);
                        if (this._computeBoundingBox) {
                            minimum.minimizeInPlaceFromFloats(px, py, pz);
                            maximum.maximizeInPlaceFromFloats(px, py, pz);
                        }
                        // normals : if the particles can't be morphed then just rotate the normals, what is much more faster than ComputeNormals()
                        if (!this._computeParticleVertex) {
                            const normalx = fixedNormal32[idx];
                            const normaly = fixedNormal32[idx + 1];
                            const normalz = fixedNormal32[idx + 2];
                            const rotatedx = normalx * particleRotationMatrix[0] + normaly * particleRotationMatrix[3] + normalz * particleRotationMatrix[6];
                            const rotatedy = normalx * particleRotationMatrix[1] + normaly * particleRotationMatrix[4] + normalz * particleRotationMatrix[7];
                            const rotatedz = normalx * particleRotationMatrix[2] + normaly * particleRotationMatrix[5] + normalz * particleRotationMatrix[8];
                            normals32[idx] = camAxisX.x * rotatedx + camAxisY.x * rotatedy + camAxisZ.x * rotatedz;
                            normals32[idx + 1] = camAxisX.y * rotatedx + camAxisY.y * rotatedy + camAxisZ.y * rotatedz;
                            normals32[idx + 2] = camAxisX.z * rotatedx + camAxisY.z * rotatedy + camAxisZ.z * rotatedz;
                        }
                        if (this._computeParticleColor && particle.color) {
                            const colors32 = this._colors32;
                            colors32[colidx] = tmpColor.r;
                            colors32[colidx + 1] = tmpColor.g;
                            colors32[colidx + 2] = tmpColor.b;
                            colors32[colidx + 3] = tmpColor.a;
                        }
                        if (this._computeParticleTexture) {
                            const uvs = particle.uvs;
                            uvs32[uvidx] = tmpUV.x * (uvs.z - uvs.x) + uvs.x;
                            uvs32[uvidx + 1] = tmpUV.y * (uvs.w - uvs.y) + uvs.y;
                        }
                    }
                }
                // particle just set invisible : scaled to zero and positioned at the origin
                else {
                    particle._stillInvisible = true; // mark the particle as invisible
                    for (pt = 0; pt < shape.length; pt++) {
                        idx = index + pt * 3;
                        colidx = colorIndex + pt * 4;
                        uvidx = uvIndex + pt * 2;
                        positions32[idx] = positions32[idx + 1] = positions32[idx + 2] = 0;
                        normals32[idx] = normals32[idx + 1] = normals32[idx + 2] = 0;
                        if (this._computeParticleColor && particle.color) {
                            const color = particle.color;
                            colors32[colidx] = color.r;
                            colors32[colidx + 1] = color.g;
                            colors32[colidx + 2] = color.b;
                            colors32[colidx + 3] = color.a;
                        }
                        if (this._computeParticleTexture) {
                            const uvs = particle.uvs;
                            uvs32[uvidx] = shapeUV[pt * 2] * (uvs.z - uvs.x) + uvs.x;
                            uvs32[uvidx + 1] = shapeUV[pt * 2 + 1] * (uvs.w - uvs.y) + uvs.y;
                        }
                    }
                }
                // if the particle intersections must be computed : update the bbInfo
                if (this._particlesIntersect) {
                    const bInfo = particle.getBoundingInfo();
                    const bBox = bInfo.boundingBox;
                    const bSphere = bInfo.boundingSphere;
                    const modelBoundingInfo = particle._modelBoundingInfo;
                    if (!this._bSphereOnly) {
                        // place, scale and rotate the particle bbox within the SPS local system, then update it
                        const modelBoundingInfoVectors = modelBoundingInfo.boundingBox.vectors;
                        const tempMin = tempVectors[1];
                        const tempMax = tempVectors[2];
                        tempMin.setAll(Number.MAX_VALUE);
                        tempMax.setAll(-Number.MAX_VALUE);
                        for (let b = 0; b < 8; b++) {
                            const scaledX = modelBoundingInfoVectors[b].x * particleScaling.x;
                            const scaledY = modelBoundingInfoVectors[b].y * particleScaling.y;
                            const scaledZ = modelBoundingInfoVectors[b].z * particleScaling.z;
                            const rotatedX = scaledX * particleRotationMatrix[0] + scaledY * particleRotationMatrix[3] + scaledZ * particleRotationMatrix[6];
                            const rotatedY = scaledX * particleRotationMatrix[1] + scaledY * particleRotationMatrix[4] + scaledZ * particleRotationMatrix[7];
                            const rotatedZ = scaledX * particleRotationMatrix[2] + scaledY * particleRotationMatrix[5] + scaledZ * particleRotationMatrix[8];
                            const x = particlePosition.x + camAxisX.x * rotatedX + camAxisY.x * rotatedY + camAxisZ.x * rotatedZ;
                            const y = particlePosition.y + camAxisX.y * rotatedX + camAxisY.y * rotatedY + camAxisZ.y * rotatedZ;
                            const z = particlePosition.z + camAxisX.z * rotatedX + camAxisY.z * rotatedY + camAxisZ.z * rotatedZ;
                            tempMin.minimizeInPlaceFromFloats(x, y, z);
                            tempMax.maximizeInPlaceFromFloats(x, y, z);
                        }
                        bBox.reConstruct(tempMin, tempMax, mesh._worldMatrix);
                    }
                    // place and scale the particle bouding sphere in the SPS local system, then update it
                    const minBbox = modelBoundingInfo.minimum.multiplyToRef(particleScaling, tempVectors[1]);
                    const maxBbox = modelBoundingInfo.maximum.multiplyToRef(particleScaling, tempVectors[2]);
                    const bSphereCenter = maxBbox.addToRef(minBbox, tempVectors[3]).scaleInPlace(0.5).addInPlace(particleGlobalPosition);
                    const halfDiag = maxBbox.subtractToRef(minBbox, tempVectors[4]).scaleInPlace(0.5 * this._bSphereRadiusFactor);
                    const bSphereMinBbox = bSphereCenter.subtractToRef(halfDiag, tempVectors[1]);
                    const bSphereMaxBbox = bSphereCenter.addToRef(halfDiag, tempVectors[2]);
                    bSphere.reConstruct(bSphereMinBbox, bSphereMaxBbox, mesh._worldMatrix);
                }
                // increment indexes for the next particle
                index = idx + 3;
                colorIndex = colidx + 4;
                uvIndex = uvidx + 2;
            }
            // if the VBO must be updated
            if (update) {
                if (this._computeParticleColor) {
                    const vb = mesh.getVertexBuffer(VertexBuffer.ColorKind);
                    if (vb && !mesh.isPickable) {
                        vb.updateDirectly(colors32, 0);
                    }
                    else {
                        mesh.updateVerticesData(VertexBuffer.ColorKind, colors32, false, false);
                    }
                }
                if (this._computeParticleTexture) {
                    const vb = mesh.getVertexBuffer(VertexBuffer.UVKind);
                    if (vb && !mesh.isPickable) {
                        vb.updateDirectly(uvs32, 0);
                    }
                    else {
                        mesh.updateVerticesData(VertexBuffer.UVKind, uvs32, false, false);
                    }
                }
                const vbp = mesh.getVertexBuffer(VertexBuffer.PositionKind);
                if (vbp && !mesh.isPickable) {
                    vbp.updateDirectly(positions32, 0);
                }
                else {
                    mesh.updateVerticesData(VertexBuffer.PositionKind, positions32, false, false);
                }
                if (!mesh.areNormalsFrozen || mesh.isFacetDataEnabled) {
                    if (this._computeParticleVertex || mesh.isFacetDataEnabled) {
                        // recompute the normals only if the particles can be morphed, update then also the normal reference array _fixedNormal32[]
                        const params = mesh.isFacetDataEnabled ? mesh.getFacetDataParameters() : null;
                        VertexData.ComputeNormals(positions32, indices32, normals32, params);
                        for (let i = 0; i < normals32.length; i++) {
                            fixedNormal32[i] = normals32[i];
                        }
                    }
                    if (!mesh.areNormalsFrozen) {
                        const vb = mesh.getVertexBuffer(VertexBuffer.NormalKind);
                        if (vb && !mesh.isPickable) {
                            vb.updateDirectly(normals32, 0);
                        }
                        else {
                            mesh.updateVerticesData(VertexBuffer.NormalKind, normals32, false, false);
                        }
                    }
                }
                if (depthSortParticles) {
                    const depthSortedParticles = this.depthSortedParticles;
                    depthSortedParticles.sort(this._depthSortFunction);
                    const dspl = depthSortedParticles.length;
                    let sid = 0;
                    let faceId = 0;
                    for (let sorted = 0; sorted < dspl; sorted++) {
                        const sortedParticle = depthSortedParticles[sorted];
                        const lind = sortedParticle.indicesLength;
                        const sind = sortedParticle.ind;
                        for (let i = 0; i < lind; i++) {
                            indices32[sid] = indices[sind + i];
                            sid++;
                            if (this._pickable) {
                                const f = i % 3;
                                if (f == 0) {
                                    const pickedData = this.pickedParticles[faceId];
                                    pickedData.idx = sortedParticle.idx;
                                    pickedData.faceId = faceId;
                                    faceId++;
                                }
                            }
                        }
                    }
                }
                if (this._autoFixFaceOrientation) {
                    let particleInd = 0;
                    for (let particleIdx = 0; particleIdx < this.particles.length; particleIdx++) {
                        const particle = depthSortParticles ? this.particles[this.depthSortedParticles[particleIdx].idx] : this.particles[particleIdx];
                        const flipFaces = particle.scale.x * particle.scale.y * particle.scale.z < 0;
                        if (flipFaces) {
                            for (let faceInd = 0; faceInd < particle._model._indicesLength; faceInd += 3) {
                                const tmp = indices[particle._ind + faceInd];
                                indices32[particleInd + faceInd] = indices[particle._ind + faceInd + 1];
                                indices32[particleInd + faceInd + 1] = tmp;
                            }
                        }
                        particleInd += particle._model._indicesLength;
                    }
                }
                if (depthSortParticles || this._autoFixFaceOrientation) {
                    mesh.updateIndices(indices32);
                }
            }
            if (this._computeBoundingBox) {
                if (mesh.hasBoundingInfo) {
                    mesh.getBoundingInfo().reConstruct(minimum, maximum, mesh._worldMatrix);
                }
                else {
                    mesh.buildBoundingInfo(minimum, maximum, mesh._worldMatrix);
                }
            }
            if (this._autoUpdateSubMeshes) {
                this.computeSubMeshes();
            }
            this._recomputeInvisibles = false;
            this.afterUpdateParticles(start, end, update);
            return this;
        }
        /**
         * Disposes the SPS.
         */
        dispose() {
            this.mesh.dispose();
            this.vars = null;
            // drop references to internal big arrays for the GC
            this._positions = null;
            this._indices = null;
            this._normals = null;
            this._uvs = null;
            this._colors = null;
            this._indices32 = null;
            this._positions32 = null;
            this._normals32 = null;
            this._fixedNormal32 = null;
            this._uvs32 = null;
            this._colors32 = null;
            this.pickedParticles = null;
            this.pickedBySubMesh = null;
            this._materials = null;
            this._materialIndexes = null;
            this._indicesByMaterial = null;
            this._idxOfId = null;
        }
        /** Returns an object {idx: number faceId: number} for the picked particle from the passed pickingInfo object.
         * idx is the particle index in the SPS
         * faceId is the picked face index counted within this particle.
         * Returns null if the pickInfo can't identify a picked particle.
         * @param pickingInfo (PickingInfo object)
         * @returns {idx: number, faceId: number} or null
         */
        pickedParticle(pickingInfo) {
            if (pickingInfo.hit) {
                const subMesh = pickingInfo.subMeshId;
                const faceId = pickingInfo.faceId - this.mesh.subMeshes[subMesh].indexStart / 3;
                const picked = this.pickedBySubMesh;
                if (picked[subMesh] && picked[subMesh][faceId]) {
                    return picked[subMesh][faceId];
                }
            }
            return null;
        }
        /**
         * Returns a SolidParticle object from its identifier : particle.id
         * @param id (integer) the particle Id
         * @returns the searched particle or null if not found in the SPS.
         */
        getParticleById(id) {
            const p = this.particles[id];
            if (p && p.id == id) {
                return p;
            }
            const particles = this.particles;
            const idx = this._idxOfId[id];
            if (idx !== undefined) {
                return particles[idx];
            }
            let i = 0;
            const nb = this.nbParticles;
            while (i < nb) {
                const particle = particles[i];
                if (particle.id == id) {
                    return particle;
                }
                i++;
            }
            return null;
        }
        /**
         * Returns a new array populated with the particles having the passed shapeId.
         * @param shapeId (integer) the shape identifier
         * @returns a new solid particle array
         */
        getParticlesByShapeId(shapeId) {
            const ref = [];
            this.getParticlesByShapeIdToRef(shapeId, ref);
            return ref;
        }
        /**
         * Populates the passed array "ref" with the particles having the passed shapeId.
         * @param shapeId the shape identifier
         * @returns the SPS
         * @param ref
         */
        getParticlesByShapeIdToRef(shapeId, ref) {
            ref.length = 0;
            for (let i = 0; i < this.nbParticles; i++) {
                const p = this.particles[i];
                if (p.shapeId == shapeId) {
                    ref.push(p);
                }
            }
            return this;
        }
        /**
         * Computes the required SubMeshes according the materials assigned to the particles.
         * @returns the solid particle system.
         * Does nothing if called before the SPS mesh is built.
         */
        computeSubMeshes() {
            if (!this.mesh || !this._multimaterialEnabled) {
                return this;
            }
            const depthSortedParticles = this.depthSortedParticles;
            if (this.particles.length > 0) {
                for (let p = 0; p < this.particles.length; p++) {
                    const part = this.particles[p];
                    if (!part.materialIndex) {
                        part.materialIndex = 0;
                    }
                    const sortedPart = depthSortedParticles[p];
                    sortedPart.materialIndex = part.materialIndex;
                    sortedPart.ind = part._ind;
                    sortedPart.indicesLength = part._model._indicesLength;
                    sortedPart.idx = part.idx;
                }
            }
            this._sortParticlesByMaterial();
            const indicesByMaterial = this._indicesByMaterial;
            const materialIndexes = this._materialIndexes;
            const mesh = this.mesh;
            mesh.subMeshes = [];
            const vcount = mesh.getTotalVertices();
            for (let m = 0; m < materialIndexes.length; m++) {
                const start = indicesByMaterial[m];
                const count = indicesByMaterial[m + 1] - start;
                const matIndex = materialIndexes[m];
                new SubMesh(matIndex, 0, vcount, start, count, mesh);
            }
            return this;
        }
        /**
         * Sorts the solid particles by material when MultiMaterial is enabled.
         * Updates the indices32 array.
         * Updates the indicesByMaterial array.
         * Updates the mesh indices array.
         * @returns the SPS
         * @internal
         */
        _sortParticlesByMaterial() {
            const indicesByMaterial = [0];
            this._indicesByMaterial = indicesByMaterial;
            const materialIndexes = [];
            this._materialIndexes = materialIndexes;
            const depthSortedParticles = this.depthSortedParticles;
            depthSortedParticles.sort(this._materialSortFunction);
            const length = depthSortedParticles.length;
            const indices32 = this._indices32;
            const indices = this._indices;
            let subMeshIndex = 0;
            let subMeshFaceId = 0;
            let sid = 0;
            let lastMatIndex = depthSortedParticles[0].materialIndex;
            materialIndexes.push(lastMatIndex);
            if (this._pickable) {
                this.pickedBySubMesh = [[]];
                this.pickedParticles = this.pickedBySubMesh[0];
            }
            for (let sorted = 0; sorted < length; sorted++) {
                const sortedPart = depthSortedParticles[sorted];
                const lind = sortedPart.indicesLength;
                const sind = sortedPart.ind;
                if (sortedPart.materialIndex !== lastMatIndex) {
                    lastMatIndex = sortedPart.materialIndex;
                    indicesByMaterial.push(sid);
                    materialIndexes.push(lastMatIndex);
                    if (this._pickable) {
                        subMeshIndex++;
                        this.pickedBySubMesh[subMeshIndex] = [];
                        subMeshFaceId = 0;
                    }
                }
                let faceId = 0;
                for (let i = 0; i < lind; i++) {
                    indices32[sid] = indices[sind + i];
                    if (this._pickable) {
                        const f = i % 3;
                        if (f == 0) {
                            const pickedData = this.pickedBySubMesh[subMeshIndex][subMeshFaceId];
                            if (pickedData) {
                                pickedData.idx = sortedPart.idx;
                                pickedData.faceId = faceId;
                            }
                            else {
                                this.pickedBySubMesh[subMeshIndex][subMeshFaceId] = { idx: sortedPart.idx, faceId: faceId };
                            }
                            subMeshFaceId++;
                            faceId++;
                        }
                    }
                    sid++;
                }
            }
            indicesByMaterial.push(indices32.length); // add the last number to ease the indices start/count values for subMeshes creation
            if (this._updatable) {
                this.mesh.updateIndices(indices32);
            }
            return this;
        }
        /**
         * Sets the material indexes by id materialIndexesById[id] = materialIndex
         * @internal
         */
        _setMaterialIndexesById() {
            this._materialIndexesById = {};
            for (let i = 0; i < this._materials.length; i++) {
                const id = this._materials[i].uniqueId;
                this._materialIndexesById[id] = i;
            }
        }
        /**
         * Returns an array with unique values of Materials from the passed array
         * @param array the material array to be checked and filtered
         * @internal
         */
        _filterUniqueMaterialId(array) {
            const filtered = array.filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });
            return filtered;
        }
        /**
         * Sets a new Standard Material as _defaultMaterial if not already set.
         * @internal
         */
        _setDefaultMaterial() {
            if (!this._defaultMaterial) {
                this._defaultMaterial = new StandardMaterial(this.name + "DefaultMaterial", this._scene);
            }
            return this._defaultMaterial;
        }
        /**
         * Visibility helper : Recomputes the visible size according to the mesh bounding box
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
         * @returns the SPS.
         */
        refreshVisibleSize() {
            if (!this._isVisibilityBoxLocked) {
                this.mesh.refreshBoundingInfo();
            }
            return this;
        }
        /**
         * Visibility helper : Sets the size of a visibility box, this sets the underlying mesh bounding box.
         * @param size the size (float) of the visibility box
         * note : this doesn't lock the SPS mesh bounding box.
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
         */
        setVisibilityBox(size) {
            const vis = size / 2;
            this.mesh.buildBoundingInfo(new Vector3(-vis, -vis, -vis), new Vector3(vis, vis, vis));
        }
        /**
         * Gets whether the SPS as always visible or not
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
         */
        get isAlwaysVisible() {
            return this._alwaysVisible;
        }
        /**
         * Sets the SPS as always visible or not
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
         */
        set isAlwaysVisible(val) {
            this._alwaysVisible = val;
            this.mesh.alwaysSelectAsActiveMesh = val;
        }
        /**
         * Sets the SPS visibility box as locked or not. This enables/disables the underlying mesh bounding box updates.
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
         */
        set isVisibilityBoxLocked(val) {
            this._isVisibilityBoxLocked = val;
            const boundingInfo = this.mesh.getBoundingInfo();
            boundingInfo.isLocked = val;
        }
        /**
         * Gets if the SPS visibility box as locked or not. This enables/disables the underlying mesh bounding box updates.
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
         */
        get isVisibilityBoxLocked() {
            return this._isVisibilityBoxLocked;
        }
        /**
         * Tells to `setParticles()` to compute the particle rotations or not.
         * Default value : true. The SPS is faster when it's set to false.
         * Note : the particle rotations aren't stored values, so setting `computeParticleRotation` to false will prevents the particle to rotate.
         */
        set computeParticleRotation(val) {
            this._computeParticleRotation = val;
        }
        /**
         * Tells to `setParticles()` to compute the particle colors or not.
         * Default value : true. The SPS is faster when it's set to false.
         * Note : the particle colors are stored values, so setting `computeParticleColor` to false will keep yet the last colors set.
         */
        set computeParticleColor(val) {
            this._computeParticleColor = val;
        }
        set computeParticleTexture(val) {
            this._computeParticleTexture = val;
        }
        /**
         * Tells to `setParticles()` to call the vertex function for each vertex of each particle, or not.
         * Default value : false. The SPS is faster when it's set to false.
         * Note : the particle custom vertex positions aren't stored values.
         */
        set computeParticleVertex(val) {
            this._computeParticleVertex = val;
        }
        /**
         * Tells to `setParticles()` to compute or not the mesh bounding box when computing the particle positions.
         */
        set computeBoundingBox(val) {
            this._computeBoundingBox = val;
        }
        /**
         * Tells to `setParticles()` to sort or not the distance between each particle and the camera.
         * Skipped when `enableDepthSort` is set to `false` (default) at construction time.
         * Default : `true`
         */
        set depthSortParticles(val) {
            this._depthSortParticles = val;
        }
        /**
         * Gets if `setParticles()` computes the particle rotations or not.
         * Default value : true. The SPS is faster when it's set to false.
         * Note : the particle rotations aren't stored values, so setting `computeParticleRotation` to false will prevents the particle to rotate.
         */
        get computeParticleRotation() {
            return this._computeParticleRotation;
        }
        /**
         * Gets if `setParticles()` computes the particle colors or not.
         * Default value : true. The SPS is faster when it's set to false.
         * Note : the particle colors are stored values, so setting `computeParticleColor` to false will keep yet the last colors set.
         */
        get computeParticleColor() {
            return this._computeParticleColor;
        }
        /**
         * Gets if `setParticles()` computes the particle textures or not.
         * Default value : true. The SPS is faster when it's set to false.
         * Note : the particle textures are stored values, so setting `computeParticleTexture` to false will keep yet the last colors set.
         */
        get computeParticleTexture() {
            return this._computeParticleTexture;
        }
        /**
         * Gets if `setParticles()` calls the vertex function for each vertex of each particle, or not.
         * Default value : false. The SPS is faster when it's set to false.
         * Note : the particle custom vertex positions aren't stored values.
         */
        get computeParticleVertex() {
            return this._computeParticleVertex;
        }
        /**
         * Gets if `setParticles()` computes or not the mesh bounding box when computing the particle positions.
         */
        get computeBoundingBox() {
            return this._computeBoundingBox;
        }
        /**
         * Gets if `setParticles()` sorts or not the distance between each particle and the camera.
         * Skipped when `enableDepthSort` is set to `false` (default) at construction time.
         * Default : `true`
         */
        get depthSortParticles() {
            return this._depthSortParticles;
        }
        /**
         * Gets if the SPS is created as expandable at construction time.
         * Default : `false`
         */
        get expandable() {
            return this._expandable;
        }
        /**
         * Gets if the SPS supports the Multi Materials
         */
        get multimaterialEnabled() {
            return this._multimaterialEnabled;
        }
        /**
         * Gets if the SPS uses the model materials for its own multimaterial.
         */
        get useModelMaterial() {
            return this._useModelMaterial;
        }
        /**
         * The SPS used material array.
         */
        get materials() {
            return this._materials;
        }
        /**
         * Sets the SPS MultiMaterial from the passed materials.
         * Note : the passed array is internally copied and not used then by reference.
         * @param materials an array of material objects. This array indexes are the materialIndex values of the particles.
         */
        setMultiMaterial(materials) {
            this._materials = this._filterUniqueMaterialId(materials);
            this._setMaterialIndexesById();
            if (this._multimaterial) {
                this._multimaterial.dispose();
            }
            this._multimaterial = new MultiMaterial(this.name + "MultiMaterial", this._scene);
            for (let m = 0; m < this._materials.length; m++) {
                this._multimaterial.subMaterials.push(this._materials[m]);
            }
            this.computeSubMeshes();
            this.mesh.material = this._multimaterial;
        }
        /**
         * The SPS computed multimaterial object
         */
        get multimaterial() {
            return this._multimaterial;
        }
        set multimaterial(mm) {
            this._multimaterial = mm;
        }
        /**
         * If the subMeshes must be updated on the next call to setParticles()
         */
        get autoUpdateSubMeshes() {
            return this._autoUpdateSubMeshes;
        }
        set autoUpdateSubMeshes(val) {
            this._autoUpdateSubMeshes = val;
        }
        // =======================================================================
        // Particle behavior logic
        // these following methods may be overwritten by the user to fit his needs
        /**
         * This function does nothing. It may be overwritten to set all the particle first values.
         * The SPS doesn't call this function, you may have to call it by your own.
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/manage_sps_particles
         */
        initParticles() { }
        /**
         * This function does nothing. It may be overwritten to recycle a particle.
         * The SPS doesn't call this function, you may have to call it by your own.
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/manage_sps_particles
         * @param particle The particle to recycle
         * @returns the recycled particle
         */
        recycleParticle(particle) {
            return particle;
        }
        /**
         * Updates a particle : this function should  be overwritten by the user.
         * It is called on each particle by `setParticles()`. This is the place to code each particle behavior.
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/manage_sps_particles
         * @example : just set a particle position or velocity and recycle conditions
         * @param particle The particle to update
         * @returns the updated particle
         */
        updateParticle(particle) {
            return particle;
        }
        /**
         * Updates a vertex of a particle : it can be overwritten by the user.
         * This will be called on each vertex particle by `setParticles()` if `computeParticleVertex` is set to true only.
         * @param particle the current particle
         * @param vertex the current vertex of the current particle : a SolidParticleVertex object
         * @param pt the index of the current vertex in the particle shape
         * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_vertices
         * @example : just set a vertex particle position or color
         * @returns the sps
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateParticleVertex(particle, vertex, pt) {
            return this;
        }
        /**
         * This will be called before any other treatment by `setParticles()` and will be passed three parameters.
         * This does nothing and may be overwritten by the user.
         * @param start the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
         * @param stop the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
         * @param update the boolean update value actually passed to setParticles()
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeUpdateParticles(start, stop, update) { }
        /**
         * This will be called  by `setParticles()` after all the other treatments and just before the actual mesh update.
         * This will be passed three parameters.
         * This does nothing and may be overwritten by the user.
         * @param start the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
         * @param stop the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
         * @param update the boolean update value actually passed to setParticles()
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        afterUpdateParticles(start, stop, update) { }
    }

    /** This will mutate the mesh geometry. Only use this on temp/intermediate mesh data */
    function ensureNormalsExist(mesh) {
        if (!mesh.getVerticesData(VertexBuffer.NormalKind)) {
            mesh.createNormals(true);
            mesh.convertToFlatShadedMesh();
        }
    }

    const patternStore = new Map();
    const identityRotation = Quaternion.Identity();
    class PatternRenderer extends FeatureRenderer {
        update3dInternal() { }
        updateMeshGeometry(feature, vertexData, vertexDataChanges, setParticlePositionFunc) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const meshNode = feature._parent;
            const mesh = this.viewer.getRendererNode(meshNode);
            if (mesh) {
                /** See line 156 */
                // let _pattern = patternStore.get(meshNode._dynamicId);
                let _pattern = null;
                // If there are no enabled pattern features before this one, update the pattern shape as some geometry may have changed
                if (!_pattern) {
                    const meshUpdated = new Mesh('patternTempGeometry');
                    meshUpdated.setEnabled(false);
                    const tempVertexData = new SubmeshVertexData();
                    tempVertexData.copyFrom(newVertexData);
                    tempVertexData.applyToMesh(meshUpdated, false);
                    ensureNormalsExist(meshUpdated);
                    const sps = new SolidParticleSystem(`${mesh.id}_${feature._dynamicId}`, this.scene, {
                        enableDepthSort: true,
                        enableMultiMaterial: true,
                        expandable: true,
                    });
                    if (feature) {
                        if (feature.meshId) {
                            const sketchNode = this.viewer.getNode(feature.meshId);
                            if (sketchNode instanceof exports.SketchNode) {
                                let distance = feature.distance;
                                if (distance <= 0) {
                                    distance = 1;
                                }
                                const positionArray = this.getPositionArray(sketchNode, feature.distance, feature.addEndMesh);
                                sps.addShape(meshUpdated, positionArray.length);
                                sps.counter = positionArray.length;
                                feature.count = positionArray.length;
                                const sketchPosition = sketchNode.position.toVec3();
                                sps.initParticles = () => {
                                    for (let p = 0; p < sps.counter; p++) {
                                        const particle = sps.particles[p];
                                        particle.position = positionArray[p].add(sketchPosition);
                                    }
                                };
                            }
                        }
                        else {
                            sps.addShape(meshUpdated, feature.count + 1);
                            sps.initParticles = () => {
                                for (let p = 0; p < sps.nbParticles; p++) {
                                    const particle = sps.particles[p];
                                    if (particle.rotationQuaternion) {
                                        particle.rotationQuaternion.copyFrom(identityRotation);
                                    }
                                    else {
                                        particle.rotationQuaternion = Quaternion.Identity();
                                    }
                                    particle.position.setAll(0);
                                }
                            };
                        }
                    }
                    const newPattern = {
                        sps,
                        size: 1,
                        featureUpdaters: new Map(),
                        sourceNode: meshNode,
                        needsUpdate: true,
                        needsRebuild: true,
                        needsSubmeshRebuild: true,
                        shape: meshUpdated,
                    };
                    sps.updateParticle = particle => {
                        // Process the last update function as it will call the prior ones recursively
                        const updates = newPattern.featureUpdaters.values();
                        const update = updates.next().value;
                        update(particle, updates);
                        // Do we need this?
                        // particle.scaling.copyFrom(mesh.scaling);
                        return particle;
                    };
                    patternStore.set(meshNode._dynamicId, newPattern);
                    _pattern = newPattern;
                }
                const pattern = _pattern;
                pattern.needsUpdate = true;
                pattern.featureUpdaters.set(feature._dynamicId, (particle, iterator, index) => {
                    if (feature.enabled) {
                        const particleIndex = particle.idx;
                        if (particleIndex >= pattern.size) {
                            particle.isVisible = false;
                            return;
                        }
                        if (!particle.isVisible) {
                            particle.isVisible = true;
                        }
                        const featureItemIndex = index !== undefined ? index : particleIndex;
                        const i = featureItemIndex % feature.count;
                        if (i > 0 && setParticlePositionFunc) {
                            setParticlePositionFunc(i, particle);
                        }
                        const nextUpdateFunction = iterator.next().value;
                        if (nextUpdateFunction) {
                            nextUpdateFunction(particle, iterator, Math.floor(featureItemIndex / feature.count));
                        }
                    }
                });
                pattern.size = Array.from(pattern.featureUpdaters.keys()).reduce((result, featureId) => {
                    const feature = meshNode.features.find(feature => feature._dynamicId === featureId);
                    return result * feature.count;
                }, 1);
                if (!pattern.needsRebuild &&
                    (vertexDataChanges.indices || vertexDataChanges.positions || vertexDataChanges.uvs)) {
                    /**
                     * If the shape of the mesh changed, then we have to remove and re-add every particle to recompute the geometry.
                     * Potential optimization here is to only recompute vertex positions if the vertex count is the same,
                     * and only do the following expensive operation if the vertex count (indices?) changes.
                     */
                    const currentSize = pattern.sps.nbParticles;
                    pattern.sps.addShape(pattern.shape, Math.max(pattern.size, pattern.sps.nbParticles));
                    pattern.sps.removeParticles(0, currentSize - 1);
                    pattern.needsRebuild = true;
                }
                else if (pattern.sps.nbParticles < pattern.size) {
                    // If we don't have enough particles to complete the pattern, expand the SPS as needed
                    pattern.sps.addShape(pattern.shape, pattern.size - pattern.sps.nbParticles);
                    pattern.needsRebuild = true;
                }
                if (vertexDataChanges.submeshData) {
                    pattern.needsSubmeshRebuild = true;
                }
                /**
                 * We are removing the pattern feature combination system because it was causing a lot of issues around the cache, with enabling/disabling and reordering features.
                 * In the future we will just add multi-direction properties into the pattern feature instead.
                 */
                // const nextFeature = meshNode.features[thisIndex + 1];
                // if (!nextFeature || !(nextFeature instanceof PatternFeature)) {
                this.processParticleSystem(pattern, newVertexData); // mutates newVertexData
                patternStore.delete(meshNode._dynamicId); // Delete the pattern since we are done processing it
                // }
            }
            return newVertexData;
        }
        processParticleSystem(pattern, resultVertexData) {
            if (!pattern.needsUpdate) {
                return;
            }
            // Shrink the particle system if there are way too many particles (more than 50% too many)
            // We don't want to shrink unless necessary beca use there's a performance hit to rebuilding the mesh
            if (pattern.sps.nbParticles - pattern.size > pattern.size / 2) {
                pattern.sps.removeParticles(pattern.size, pattern.sps.nbParticles - 1);
                pattern.needsRebuild = true;
            }
            pattern.sps.initParticles();
            if (!pattern.resultMesh || pattern.needsRebuild) {
                pattern.resultMesh = pattern.sps.buildMesh();
                pattern.needsRebuild = false;
                pattern.needsSubmeshRebuild = true;
                pattern.resultMesh.setEnabled(false);
            }
            pattern.sps.computeBoundingBox = true;
            pattern.sps.setParticles();
            const totalIndicesSourceCount = resultVertexData.indices.length;
            const totalVerticesSourceCount = resultVertexData.positions.length / 3;
            const newVertexData = VertexData.ExtractFromMesh(pattern.resultMesh);
            resultVertexData.indices = newVertexData.indices;
            resultVertexData.positions = newVertexData.positions;
            if (newVertexData.normals) {
                resultVertexData.normals = newVertexData.normals;
            }
            if (resultVertexData.uvs && newVertexData.uvs) {
                // Don't add UVs if UVs never existed
                resultVertexData.uvs = newVertexData.uvs;
            }
            // If the source mesh has submeshes, then we need to update them
            if (resultVertexData.submeshData) {
                const submeshesToClone = resultVertexData.submeshData.slice(1);
                const totalIndicesResultCount = resultVertexData.indices.length;
                const totalVerticesResultCount = resultVertexData.positions.length / 3;
                // resultMeshCsg.dispose();
                const baseMaterialIndex = resultVertexData.submeshData[0].materialIndex;
                resultVertexData.submeshData = [];
                resultVertexData.submeshData.push({
                    materialIndex: baseMaterialIndex,
                    verticesStart: 0,
                    verticesCount: totalVerticesResultCount,
                    indexStart: 0,
                    indexCount: totalIndicesResultCount,
                });
                const spsPatternSize = totalVerticesResultCount / totalVerticesSourceCount;
                if (submeshesToClone.length > 0) {
                    submeshesToClone.forEach(subMesh => {
                        for (let i = 0; i < spsPatternSize; i++) {
                            resultVertexData.submeshData.push({
                                materialIndex: subMesh.materialIndex,
                                verticesStart: subMesh.verticesStart + i * totalVerticesSourceCount,
                                verticesCount: subMesh.verticesCount,
                                indexStart: subMesh.indexStart + i * totalIndicesSourceCount,
                                indexCount: subMesh.indexCount,
                            });
                        }
                    });
                }
            }
        }
        getPositionArray(node, distance, addEndMesh) {
            const result = [];
            const sketchLength = node.getSketchLength();
            const numberOfMeshes = sketchLength / distance;
            const percentagePoints = [];
            for (let i = 0; i < numberOfMeshes; i++) {
                percentagePoints.push((1 / numberOfMeshes) * i);
            }
            percentagePoints.forEach(point => {
                result.push(this.getIntervalPosition(node, point));
            });
            if (addEndMesh) {
                const lastPath = node.paths[node.paths.length - 1];
                const lastPoint = lastPath._points[lastPath._points.length - 1];
                const lastPointVec3 = new Vector3(lastPoint.x, lastPoint.y, lastPoint.z);
                result.push(lastPointVec3);
            }
            return result;
        }
        getIntervalPosition(node, posZeroToOne) {
            const result = new Vector3(0, 0, 0);
            const sketchLength = node.getSketchLength();
            let trackedLength = 0;
            let targetNotFound = true;
            node.paths.forEach(path => {
                let lastPosition = null;
                let lastLength = 0;
                path._points.forEach(point => {
                    if (!lastPosition) {
                        lastPosition = point;
                    }
                    else {
                        const currentPos = point;
                        const distance = Math.sqrt(Math.pow(lastPosition.x - currentPos.x, 2) +
                            Math.pow(lastPosition.y - currentPos.y, 2) +
                            Math.pow(lastPosition.z - currentPos.z, 2));
                        lastLength = trackedLength;
                        trackedLength += distance;
                        const distanceBetweenPoints = trackedLength - lastLength;
                        const distanceFromP1toTarget = posZeroToOne * sketchLength - lastLength;
                        const percentageBetween2Points = distanceFromP1toTarget / distanceBetweenPoints;
                        const vectorBetween2Points = new exports.KbVector(currentPos.x - lastPosition.x, currentPos.y - lastPosition.y, currentPos.z - lastPosition.z);
                        if (trackedLength > posZeroToOne * sketchLength && targetNotFound) {
                            const calculatedPosition = vectorBetween2Points
                                .scale(percentageBetween2Points)
                                .add(lastPosition);
                            result.set(calculatedPosition.x, calculatedPosition.y, calculatedPosition.z);
                            targetNotFound = false;
                        }
                        lastPosition = currentPos;
                    }
                });
                if (posZeroToOne === 1) {
                    const path = node.paths[node.paths.length - 1];
                    const controlPoint = path._points[path._points.length - 1];
                    result.set(controlPoint.x, controlPoint.y, controlPoint.z);
                }
            });
            return result;
        }
        delete3d(feature, preserveCache) {
            patternStore.forEach((pattern, meshNode) => {
                if (pattern.featureUpdaters.has(feature._dynamicId)) {
                    pattern.featureUpdaters.delete(feature._dynamicId);
                }
                if (pattern.featureUpdaters.size === 0) {
                    patternStore.delete(meshNode);
                }
            });
            super.delete3d(feature, preserveCache);
        }
        dispose() {
            super.dispose();
            patternStore.clear();
        }
    }

    const uvHelper = new UVMapHelper();
    const multiMaterialUseCount = new Map();
    const featureMappings = new Map();
    class SubmeshRenderer extends FeatureRenderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene);
            this.rendererManager = rendererManager;
            this.modelToken = Token.SubmeshFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const submeshFeatureMapping = featureMappings.get(feature._dynamicId);
            if (!submeshFeatureMapping) {
                console.warn(`INFO: Submesh mapping not found for ${feature.name}`);
                return newVertexData;
            }
            if (!newVertexData.submeshData) {
                newVertexData.submeshData = [];
            }
            if (submeshFeatureMapping.multiMaterialIndex) {
                const verticesCount = (vertexDataChanges.positions || newVertexData.positions).length / 3;
                const indicesCount = (vertexDataChanges.indices || newVertexData.indices).length;
                for (let i = 0; i < feature.vertexGroups.length; i++) {
                    const vertexGroup = feature.vertexGroups[i];
                    const newSubmesh = {
                        materialIndex: submeshFeatureMapping.multiMaterialIndex,
                        verticesStart: 0,
                        verticesCount: verticesCount,
                        indexStart: vertexGroup.startIndex,
                        indexCount: Math.min(vertexGroup.endIndex, indicesCount) - vertexGroup.startIndex,
                    };
                    const existingIndex = newVertexData.submeshData.findIndex(existingSubmesh => existingSubmesh.materialIndex === newSubmesh.materialIndex &&
                        existingSubmesh.verticesStart === newSubmesh.verticesStart &&
                        existingSubmesh.verticesCount === newSubmesh.verticesCount &&
                        existingSubmesh.indexStart === newSubmesh.indexStart &&
                        existingSubmesh.indexCount === newSubmesh.indexCount);
                    if (existingIndex >= 0) {
                        newVertexData.submeshData.splice(existingIndex, 1);
                    }
                    newVertexData.submeshData.push(newSubmesh);
                }
            }
            // Calculate UV maps if that is enabled on this feature
            if (feature.uvMapping) {
                const uvMapVertexes = [];
                for (let i = 0; i < feature.vertexGroups.length; i++) {
                    const vertexGroup = feature.vertexGroups[i];
                    for (let i = vertexGroup.startIndex; i < vertexGroup.endIndex; i++) {
                        uvMapVertexes.push(i);
                    }
                }
                if (uvMapVertexes.length > 0) {
                    let existingUvs = [];
                    if (newVertexData.uvs) {
                        existingUvs = [...newVertexData.uvs];
                    }
                    uvHelper.generateUVMapInPlace(newVertexData, feature, uvMapVertexes);
                    // for projection mode "use existing", only apply the new uvs to the selected faces of the submesh
                    if (feature.mode === exports.eUvMode.useExisting) {
                        feature.vertexGroups.forEach(vertexGroup => {
                            for (let i = vertexGroup.startIndex; i < vertexGroup.endIndex; i++) {
                                if (newVertexData.indices && newVertexData.uvs) {
                                    existingUvs[newVertexData.indices[i] * 2] =
                                        newVertexData.uvs[newVertexData.indices[i] * 2];
                                    existingUvs[newVertexData.indices[i] * 2 + 1] =
                                        newVertexData.uvs[newVertexData.indices[i] * 2 + 1];
                                }
                            }
                        });
                        newVertexData.uvs = existingUvs;
                    }
                }
            }
            return newVertexData;
        }
        update3dInternal(feature) {
            let _submeshFeatureMapping = featureMappings.get(feature._dynamicId);
            if (feature.changes.has('materialId') || !_submeshFeatureMapping) {
                const meshNode = feature._parent;
                const mesh = this.viewer.getRendererNode(meshNode);
                if (!mesh) {
                    return;
                }
                if (!_submeshFeatureMapping) {
                    _submeshFeatureMapping = {};
                    featureMappings.set(feature._dynamicId, _submeshFeatureMapping);
                }
                const submeshFeatureMapping = _submeshFeatureMapping;
                if (feature.materialId) {
                    if (!(mesh.material instanceof MultiMaterial)) {
                        const multiMaterial = new MultiMaterial(meshNode._dynamicId, this.scene);
                        if (mesh.material) {
                            multiMaterial.subMaterials[0] = mesh.material;
                        }
                        else if (!mesh.material) {
                            // If a submesh multimaterial has a null material at index 0, it causes shadows to not work
                            multiMaterial.subMaterials[0] = this.rendererManager.material.defaultMaterial;
                        }
                        submeshFeatureMapping.multiMaterial = multiMaterial;
                        multiMaterialUseCount.set(multiMaterial, 0);
                        mesh.material = multiMaterial;
                    }
                    else {
                        submeshFeatureMapping.multiMaterial = mesh.material;
                    }
                    this.rendererManager.mesh.fetchMaterialNode(meshNode, feature.materialId).then(materialNode => {
                        // The material may have changed on the mesh, so we have to re-fetch the reference just in case.
                        if (!(mesh.material instanceof MultiMaterial)) {
                            throw Error('Another script has removed the multimaterial on a mesh');
                        }
                        const multiMaterial = mesh.material;
                        if (multiMaterial !== submeshFeatureMapping.multiMaterial) {
                            console.warn(`Submesh feature ${feature.name} lost reference to a multimaterial. Possible memory leak?`);
                            submeshFeatureMapping.multiMaterial = multiMaterial;
                        }
                        // If the material is already part of the submaterials, do nothing
                        const existingSubmaterialIndex = multiMaterial.subMaterials.findIndex(material => (material === null || material === void 0 ? void 0 : material.id) === materialNode._dynamicId);
                        if ((submeshFeatureMapping === null || submeshFeatureMapping === void 0 ? void 0 : submeshFeatureMapping.multiMaterialIndex) === existingSubmaterialIndex) {
                            return;
                        }
                        else if (existingSubmaterialIndex > -1) {
                            submeshFeatureMapping.multiMaterialIndex = existingSubmaterialIndex;
                            // Triggers change on this feature so the feature stack refreshes with the material index on this submesh
                            feature.setPropertyIsModified('vertexGroups', true);
                        }
                        else {
                            // init the material if the node is showing
                            if (meshNode.visible) {
                                materialNode.init();
                            }
                            const material = this.viewer.getRendererNode(materialNode);
                            if (!material) {
                                throw Error('Material could not be found in renderer. Has the material been created?');
                            }
                            submeshFeatureMapping.multiMaterialIndex = multiMaterial.subMaterials.length;
                            multiMaterial.subMaterials.push(material);
                            multiMaterialUseCount.set(multiMaterial, (multiMaterialUseCount.get(multiMaterial) || 0) + 1);
                            // Triggers change on this feature so the feature stack refreshes with the material index on this submesh
                            feature.setPropertyIsModified('vertexGroups', true);
                        }
                    }, err => {
                        feature.materialId = '';
                    });
                }
            }
        }
        delete3d(feature, preserveCache) {
            if (!preserveCache) {
                const submeshFeatureMapping = featureMappings.get(feature._dynamicId);
                if (submeshFeatureMapping && submeshFeatureMapping.multiMaterial) {
                    const multiMaterial = submeshFeatureMapping.multiMaterial;
                    const count = multiMaterialUseCount.get(multiMaterial);
                    if (count !== undefined) {
                        if (count <= 1) {
                            const meshNode = feature._parent;
                            const mesh = this.viewer.getRendererNode(meshNode);
                            if (mesh) {
                                mesh.material = multiMaterial.getSubMaterial(0);
                            }
                            multiMaterialUseCount.delete(multiMaterial);
                            multiMaterial.dispose(true, true, false);
                        }
                        else {
                            multiMaterialUseCount.set(multiMaterial, count - 1);
                        }
                    }
                }
                featureMappings.delete(feature._dynamicId);
            }
            super.delete3d(feature, preserveCache);
        }
    }

    const uvHelper$1 = new UVMapHelper();
    class UvMapRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.UvMapFeature;
            this.babylonUvPreviewsMap = new Map();
            this.previewLayer = this.viewer.utilityLayer;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            uvHelper$1.generateUVMapInPlace(newVertexData, feature);
            return newVertexData;
        }
        updatePreviewMesh(feature) {
            let visualizationMesh = this.babylonUvPreviewsMap.get(feature.id);
            const scene = this.previewLayer.utilityLayerScene;
            if (!visualizationMesh) {
                visualizationMesh = createUvMapVisualization(feature, scene, Color3.Yellow());
                visualizationMesh.isPickable = false;
                this.babylonUvPreviewsMap.set(feature.id, visualizationMesh);
            }
            else {
                this.deletePreview3d(feature);
                visualizationMesh = createUvMapVisualization(feature, scene, Color3.Yellow());
                visualizationMesh.isPickable = false;
                this.babylonUvPreviewsMap.set(feature.id, visualizationMesh);
            }
            let meshPosition = visualizationMesh.getAbsolutePosition();
            if (feature._parent) {
                const featureParent = this.viewer.getRendererNode(feature._parent);
                meshPosition = featureParent.getAbsolutePosition();
            }
            meshPosition.add(feature.center.toVec3());
            meshPosition.addInPlace(feature.center.toVec3());
            visualizationMesh.position.set(meshPosition.x, meshPosition.y, meshPosition.z);
            //visualizationMesh.project;
            const newNormal = new Vector3();
            newNormal.set(feature.projectionAxis.x, feature.projectionAxis.y, feature.projectionAxis.z);
            visualizationMesh.rotationQuaternion = Quaternion.RotationAxis(newNormal, (feature.angle / 180) * Math.PI);
            visualizationMesh.rotationQuaternion = visualizationMesh.rotationQuaternion.multiply(rotationToVector(newNormal));
            visualizationMesh.scaling.set(feature.scale.x, feature.scale.y, feature.scale.z);
        }
        update3dInternal(feature) {
            const visualizationMesh = this.babylonUvPreviewsMap.get(feature.id);
            visualizationMesh === null || visualizationMesh === void 0 ? void 0 : visualizationMesh.setEnabled(feature._previewMaterialVisible);
            // change visibility here
            if (feature._previewMaterialVisible) {
                this.updatePreviewMesh(feature);
            }
        }
        delete3d(feature) {
            this.deletePreview3d(feature);
            super.delete3d(feature);
        }
        deletePreview3d(feature) {
            const previewMesh = this.babylonUvPreviewsMap.get(feature.id);
            if (previewMesh) {
                previewMesh.dispose();
            }
            this.babylonUvPreviewsMap.delete(feature.id);
        }
    }

    class LightRenderer extends Renderer {
        set showPreviews(show) {
            this.showAllLightPreviews = show;
            this.babylonMap.forEach(light => {
                this.updatePreviewMesh(light);
            });
        }
        constructor(viewer, scene, shadowManager) {
            super(viewer, scene);
            this.shadowManager = shadowManager;
            this.babylonLightPreviewsMap = new Map();
            this.modelToken = Token.LightNode;
            this.showAllLightPreviews = false;
            this.gizmoLayer = this.viewer.utilityLayer;
        }
        update3dInternal(node) {
            var _a;
            if (!node._parent && ((_a = node._parentScene) === null || _a === void 0 ? void 0 : _a.isNested())) {
                //don't render global lights in nested scenes
                return;
            }
            let light = this.get3d(node);
            const changes = this.getChanges(node);
            if (!light) {
                if (node instanceof exports.PointLightNode) {
                    light = new PointLight(node._dynamicId, node.position.toVec3(), this.scene);
                }
                else if (node instanceof exports.HemisphericLightNode) {
                    light = new HemisphericLight(node._dynamicId, node.direction.toVec3(), this.scene);
                }
                else if (node instanceof exports.SpotLightNode) {
                    light = new SpotLight(node._dynamicId, node.position.toVec3(), node.direction.toVec3(), (node.coneAngle * Math.PI) / 180, 2, this.scene);
                    light.exponent = 2;
                }
                else if (node instanceof exports.DirectionalLightNode) {
                    light = new DirectionalLight(node._dynamicId, node.direction.toVec3(), this.scene);
                }
                this.set3d(node, light);
            }
            const pLight = light;
            if (changes.has('visible')) {
                // Can be falsy so need to check the map
                pLight.setEnabled(node.visible);
            }
            if (changes.has('intensity')) {
                // Can be falsy so need to check the map
                pLight.intensity = node.intensity;
            }
            if (changes.has('color')) {
                pLight.specular = node.color.toColor3();
                pLight.diffuse = node.color.toColor3();
            }
            if (changes.has('_parent')) {
                if (node._parent) {
                    pLight.parent = this.viewer.getRendererNode(node._parent);
                }
                else {
                    pLight.parent = null;
                }
            }
            let lightRotation;
            if (node.useEuler) {
                lightRotation = Quaternion.FromEulerAngles(toRadians(node.eulerRotation.x), toRadians(node.eulerRotation.y), toRadians(node.eulerRotation.z));
            }
            else {
                lightRotation = Quaternion.RotationAxis(node.rotationAxis.toVec3(), toRadians(node.rotationAngle));
            }
            const rotationChanged = changes.hasAny('useEuler', 'eulerRotation', 'rotationAxis', 'rotationAngle');
            if (node instanceof exports.PointLightNode) {
                const pLight = light;
                if (changes.has('position')) {
                    pLight.position = node.position.toVec3();
                }
            }
            else if (node instanceof exports.HemisphericLightNode) {
                const pLight = light;
                if (changes.has('direction') || rotationChanged) {
                    pLight.direction = this.rotateDirection(node.direction.toVec3(), lightRotation);
                }
                if (changes.has('groundColor')) {
                    pLight.groundColor = node.groundColor.toColor3();
                }
            }
            else if (node instanceof exports.SpotLightNode) {
                const pLight = light;
                if (changes.has('position')) {
                    pLight.position = node.position.toVec3();
                }
                if (changes.has('direction') || rotationChanged) {
                    pLight.direction = this.rotateDirection(node.direction.toVec3(), lightRotation);
                }
                if (changes.has('coneAngle')) {
                    pLight.angle = (node.coneAngle * Math.PI) / 180;
                }
            }
            else if (node instanceof exports.DirectionalLightNode) {
                const pLight = light;
                // pLight.position = new Vector3(0, 5, 0);
                if (changes.has('direction') || rotationChanged) {
                    pLight.direction = this.rotateDirection(node.direction.toVec3(), lightRotation);
                    //for directional lights, we hardcode the position to be negative direction for shadows
                    pLight.position = pLight.direction.clone().negate();
                }
            }
            if (node instanceof ShadowLightNode) {
                const shadowLightNode = node;
                const shadowLight = light;
                let sg = this.shadowManager.get(shadowLight);
                let justCreated = false;
                if (changes.has('generatesShadows')) {
                    if (shadowLightNode.generatesShadows) {
                        sg = this.shadowManager.add(shadowLight, shadowLightNode.shadowResolution);
                        shadowLight.shadowEnabled = true;
                        justCreated = true;
                        changes.set('shadowFilter', shadowLightNode.shadowFilter);
                        changes.set('shadowQuality', shadowLightNode.shadowQuality);
                    }
                    else {
                        if (sg) {
                            shadowLight.shadowEnabled = false;
                            this.shadowManager.remove(shadowLight);
                            sg = undefined;
                        }
                    }
                }
                //if the resolution is changed, and the shadow generator wasn't just created, we need to recreate it
                if (changes.has('shadowResolution') && sg && !justCreated) {
                    this.shadowManager.remove(shadowLight);
                    sg = this.shadowManager.add(shadowLight, shadowLightNode.shadowResolution);
                    changes.set('shadowFilter', shadowLightNode.shadowFilter);
                    changes.set('shadowQuality', shadowLightNode.shadowQuality);
                    changes.set('processTransparency', shadowLightNode.processTransparency);
                }
                if (sg) {
                    if (changes.has('shadowFilter')) {
                        sg.filter = ShadowManager.convertShadowFilter(shadowLightNode.shadowFilter);
                    }
                    if (changes.has('processTransparency')) {
                        sg.transparencyShadow = shadowLightNode.processTransparency;
                        sg.enableSoftTransparentShadow = shadowLightNode.processTransparency;
                    }
                    if (changes.has('shadowQuality')) {
                        sg.filteringQuality = ShadowGenerator[`QUALITY_${shadowLightNode.shadowQuality.toUpperCase()}`];
                    }
                    //need to update projection matrix if direction has been changed
                    if (changes.hasAny('direction', 'position')) {
                        this.shadowManager.clearProjectMatrixCache();
                    }
                }
            }
            if (changes.has('_selected')) {
                if (!pLight.metadata) {
                    pLight.metadata = {};
                }
                pLight.metadata.selected = node._selected;
            }
            this.viewer.updateLightWarnings();
            this.updatePreviewMesh(pLight);
        }
        delete3d(node) {
            if (this.babylonLightPreviewsMap) {
                const lightPositionGizmo = this.babylonLightPreviewsMap.get(node._dynamicId);
                if (!lightPositionGizmo) {
                    throw Error('Light gizmo not found for light ' + node.id);
                }
                lightPositionGizmo.dispose();
                this.babylonLightPreviewsMap.delete(node._dynamicId);
            }
            this.shadowManager.remove(this.get3d(node)); //remove also disposes the shadow generator if it exists
            super.delete3d(node);
            this.viewer.updateLightWarnings();
        }
        updatePreviewMesh(light) {
            let lightPositionGizmo = this.babylonLightPreviewsMap.get(light.id);
            const scene = this.gizmoLayer.utilityLayerScene;
            if (!lightPositionGizmo) {
                lightPositionGizmo = createLightVisualization(light, scene, Color3.Yellow());
                lightPositionGizmo.isPickable = false;
                this.babylonLightPreviewsMap.set(light.id, lightPositionGizmo);
            }
            if (this.showAllLightPreviews) {
                lightPositionGizmo.setEnabled(light.metadata.selected || light.isEnabled());
            }
            else {
                lightPositionGizmo.setEnabled(light.metadata.selected);
            }
            if (light instanceof HemisphericLight) {
                lightPositionGizmo.rotationQuaternion = rotationToVector(light.direction);
            }
            else if (light instanceof SpotLight) {
                lightPositionGizmo.position = this.getLightPosition(light);
                lightPositionGizmo.rotationQuaternion = rotationToVector(light.direction);
                lightPositionGizmo.scaling.set(Math.sin(light.angle / 2), Math.cos(light.angle / 2), Math.sin(light.angle / 2));
            }
            else if (light instanceof DirectionalLight) {
                lightPositionGizmo.rotationQuaternion = rotationToVector(light.direction);
            }
            else if (light instanceof PointLight) {
                lightPositionGizmo.position = this.getLightPosition(light);
            }
        }
        rotateDirection(direction, rotation) {
            direction.rotateByQuaternionToRef(rotation, direction);
            return direction;
        }
        getLightPosition(light) {
            return light.parent
                ? Vector3.TransformCoordinates(light.position, light.parent.computeWorldMatrix(true).clone())
                : light.position;
        }
    }

    class MateRenderer extends Renderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.MateNode;
        }
        update3dInternal(node) { }
        delete3d(node) {
            SyncService.nodeDeletionProcessed(node);
        }
    }

    AbstractScene.prototype.removeReflectionProbe = function (toRemove) {
        if (!this.reflectionProbes) {
            return -1;
        }
        const index = this.reflectionProbes.indexOf(toRemove);
        if (index !== -1) {
            this.reflectionProbes.splice(index, 1);
        }
        return index;
    };
    AbstractScene.prototype.addReflectionProbe = function (newReflectionProbe) {
        if (!this.reflectionProbes) {
            this.reflectionProbes = [];
        }
        this.reflectionProbes.push(newReflectionProbe);
    };
    /**
     * Class used to generate realtime reflection / refraction cube textures
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/reflectionProbes
     */
    class ReflectionProbe {
        /**
         * Creates a new reflection probe
         * @param name defines the name of the probe
         * @param size defines the texture resolution (for each face)
         * @param scene defines the hosting scene
         * @param generateMipMaps defines if mip maps should be generated automatically (true by default)
         * @param useFloat defines if HDR data (float data) should be used to store colors (false by default)
         * @param linearSpace defines if the probe should be generated in linear space or not (false by default)
         */
        constructor(
        /** defines the name of the probe */
        name, size, scene, generateMipMaps = true, useFloat = false, linearSpace = false) {
            this.name = name;
            this._viewMatrix = Matrix.Identity();
            this._target = Vector3.Zero();
            this._add = Vector3.Zero();
            this._invertYAxis = false;
            /** Gets or sets probe position (center of the cube map) */
            this.position = Vector3.Zero();
            /**
             * Gets or sets an object used to store user defined information for the reflection probe.
             */
            this.metadata = null;
            /** @internal */
            this._parentContainer = null;
            this._scene = scene;
            if (scene.getEngine().supportsUniformBuffers) {
                this._sceneUBOs = [];
                for (let i = 0; i < 6; ++i) {
                    this._sceneUBOs.push(scene.createSceneUniformBuffer(`Scene for Reflection Probe (name "${name}") face #${i}`));
                }
            }
            // Create the scene field if not exist.
            if (!this._scene.reflectionProbes) {
                this._scene.reflectionProbes = new Array();
            }
            this._scene.reflectionProbes.push(this);
            let textureType = 0;
            if (useFloat) {
                const caps = this._scene.getEngine().getCaps();
                if (caps.textureHalfFloatRender) {
                    textureType = 2;
                }
                else if (caps.textureFloatRender) {
                    textureType = 1;
                }
            }
            this._renderTargetTexture = new RenderTargetTexture(name, size, scene, generateMipMaps, true, textureType, true);
            this._renderTargetTexture.gammaSpace = !linearSpace;
            this._renderTargetTexture.invertZ = scene.useRightHandedSystem;
            const useReverseDepthBuffer = scene.getEngine().useReverseDepthBuffer;
            this._renderTargetTexture.onBeforeRenderObservable.add((faceIndex) => {
                if (this._sceneUBOs) {
                    scene.setSceneUniformBuffer(this._sceneUBOs[faceIndex]);
                    scene.getSceneUniformBuffer().unbindEffect();
                }
                switch (faceIndex) {
                    case 0:
                        this._add.copyFromFloats(1, 0, 0);
                        break;
                    case 1:
                        this._add.copyFromFloats(-1, 0, 0);
                        break;
                    case 2:
                        this._add.copyFromFloats(0, this._invertYAxis ? 1 : -1, 0);
                        break;
                    case 3:
                        this._add.copyFromFloats(0, this._invertYAxis ? -1 : 1, 0);
                        break;
                    case 4:
                        this._add.copyFromFloats(0, 0, scene.useRightHandedSystem ? -1 : 1);
                        break;
                    case 5:
                        this._add.copyFromFloats(0, 0, scene.useRightHandedSystem ? 1 : -1);
                        break;
                }
                if (this._attachedMesh) {
                    this.position.copyFrom(this._attachedMesh.getAbsolutePosition());
                }
                this.position.addToRef(this._add, this._target);
                const lookAtFunction = scene.useRightHandedSystem ? Matrix.LookAtRHToRef : Matrix.LookAtLHToRef;
                const perspectiveFunction = scene.useRightHandedSystem ? Matrix.PerspectiveFovRH : Matrix.PerspectiveFovLH;
                lookAtFunction(this.position, this._target, Vector3.Up(), this._viewMatrix);
                if (scene.activeCamera) {
                    this._projectionMatrix = perspectiveFunction(Math.PI / 2, 1, useReverseDepthBuffer ? scene.activeCamera.maxZ : scene.activeCamera.minZ, useReverseDepthBuffer ? scene.activeCamera.minZ : scene.activeCamera.maxZ, this._scene.getEngine().isNDCHalfZRange);
                    scene.setTransformMatrix(this._viewMatrix, this._projectionMatrix);
                    if (scene.activeCamera.isRigCamera && !this._renderTargetTexture.activeCamera) {
                        this._renderTargetTexture.activeCamera = scene.activeCamera.rigParent || null;
                    }
                }
                scene._forcedViewPosition = this.position;
            });
            let currentApplyByPostProcess;
            this._renderTargetTexture.onBeforeBindObservable.add(() => {
                var _a, _b;
                this._currentSceneUBO = scene.getSceneUniformBuffer();
                (_b = (_a = scene.getEngine())._debugPushGroup) === null || _b === void 0 ? void 0 : _b.call(_a, `reflection probe generation for ${name}`, 1);
                currentApplyByPostProcess = this._scene.imageProcessingConfiguration.applyByPostProcess;
                if (linearSpace) {
                    scene.imageProcessingConfiguration.applyByPostProcess = true;
                }
            });
            this._renderTargetTexture.onAfterUnbindObservable.add(() => {
                var _a, _b;
                scene.imageProcessingConfiguration.applyByPostProcess = currentApplyByPostProcess;
                scene._forcedViewPosition = null;
                if (this._sceneUBOs) {
                    scene.setSceneUniformBuffer(this._currentSceneUBO);
                }
                scene.updateTransformMatrix(true);
                (_b = (_a = scene.getEngine())._debugPopGroup) === null || _b === void 0 ? void 0 : _b.call(_a, 1);
            });
        }
        /** Gets or sets the number of samples to use for multi-sampling (0 by default). Required WebGL2 */
        get samples() {
            return this._renderTargetTexture.samples;
        }
        set samples(value) {
            this._renderTargetTexture.samples = value;
        }
        /** Gets or sets the refresh rate to use (on every frame by default) */
        get refreshRate() {
            return this._renderTargetTexture.refreshRate;
        }
        set refreshRate(value) {
            this._renderTargetTexture.refreshRate = value;
        }
        /**
         * Gets the hosting scene
         * @returns a Scene
         */
        getScene() {
            return this._scene;
        }
        /** Gets the internal CubeTexture used to render to */
        get cubeTexture() {
            return this._renderTargetTexture;
        }
        /** Gets the list of meshes to render */
        get renderList() {
            return this._renderTargetTexture.renderList;
        }
        /**
         * Attach the probe to a specific mesh (Rendering will be done from attached mesh's position)
         * @param mesh defines the mesh to attach to
         */
        attachToMesh(mesh) {
            this._attachedMesh = mesh;
        }
        /**
         * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups
         * @param renderingGroupId The rendering group id corresponding to its index
         * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
         */
        setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil) {
            this._renderTargetTexture.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil);
        }
        /**
         * Clean all associated resources
         */
        dispose() {
            const index = this._scene.reflectionProbes.indexOf(this);
            if (index !== -1) {
                // Remove from the scene if found
                this._scene.reflectionProbes.splice(index, 1);
            }
            if (this._parentContainer) {
                const index = this._parentContainer.reflectionProbes.indexOf(this);
                if (index > -1) {
                    this._parentContainer.reflectionProbes.splice(index, 1);
                }
                this._parentContainer = null;
            }
            if (this._renderTargetTexture) {
                this._renderTargetTexture.dispose();
                this._renderTargetTexture = null;
            }
            if (this._sceneUBOs) {
                for (const ubo of this._sceneUBOs) {
                    ubo.dispose();
                }
                this._sceneUBOs = [];
            }
        }
        /**
         * Converts the reflection probe information to a readable string for debug purpose.
         * @param fullDetails Supports for multiple levels of logging within scene loading
         * @returns the human readable reflection probe info
         */
        toString(fullDetails) {
            let ret = "Name: " + this.name;
            if (fullDetails) {
                ret += ", position: " + this.position.toString();
                if (this._attachedMesh) {
                    ret += ", attached mesh: " + this._attachedMesh.name;
                }
            }
            return ret;
        }
        /**
         * Get the class name of the refection probe.
         * @returns "ReflectionProbe"
         */
        getClassName() {
            return "ReflectionProbe";
        }
        /**
         * Serialize the reflection probe to a JSON representation we can easily use in the respective Parse function.
         * @returns The JSON representation of the texture
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this, this._renderTargetTexture.serialize());
            serializationObject.isReflectionProbe = true;
            serializationObject.metadata = this.metadata;
            return serializationObject;
        }
        /**
         * Parse the JSON representation of a reflection probe in order to recreate the reflection probe in the given scene.
         * @param parsedReflectionProbe Define the JSON representation of the reflection probe
         * @param scene Define the scene the parsed reflection probe should be instantiated in
         * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
         * @returns The parsed reflection probe if successful
         */
        static Parse(parsedReflectionProbe, scene, rootUrl) {
            let reflectionProbe = null;
            if (scene.reflectionProbes) {
                for (let index = 0; index < scene.reflectionProbes.length; index++) {
                    const rp = scene.reflectionProbes[index];
                    if (rp.name === parsedReflectionProbe.name) {
                        reflectionProbe = rp;
                        break;
                    }
                }
            }
            reflectionProbe = SerializationHelper.Parse(() => reflectionProbe || new ReflectionProbe(parsedReflectionProbe.name, parsedReflectionProbe.renderTargetSize, scene, parsedReflectionProbe._generateMipMaps), parsedReflectionProbe, scene, rootUrl);
            reflectionProbe.cubeTexture._waitingRenderList = parsedReflectionProbe.renderList;
            if (parsedReflectionProbe._attachedMesh) {
                reflectionProbe.attachToMesh(scene.getMeshById(parsedReflectionProbe._attachedMesh));
            }
            if (parsedReflectionProbe.metadata) {
                reflectionProbe.metadata = parsedReflectionProbe.metadata;
            }
            return reflectionProbe;
        }
    }
    __decorate$1([
        serializeAsMeshReference()
    ], ReflectionProbe.prototype, "_attachedMesh", void 0);
    __decorate$1([
        serializeAsVector3()
    ], ReflectionProbe.prototype, "position", void 0);

    // Performance Code from Babylon 5.0. Remove once upgrade to Babylon 5.0 is merged
    Object.defineProperty(BaseTexture.prototype, 'hasAlpha', {
        get: function () {
            return this._hasAlpha;
        },
        set: function (value) {
            const self = this;
            if (this._hasAlpha === value) {
                return;
            }
            this._hasAlpha = value;
            if (this._scene) {
                this._scene.markAllMaterialsAsDirty(Constants.MATERIAL_TextureDirtyFlag, function (mat) {
                    return mat.hasTexture(self);
                });
            }
        },
        enumerable: false,
        configurable: true,
    });
    class MaterialRenderer extends Renderer {
        get defaultMaterial() {
            return this._defaultMaterial;
        }
        constructor(viewer, scene, textureRenderer) {
            super(viewer, scene);
            this.textureRenderer = textureRenderer;
            this._globalMaterialCache = new Map();
            this.orphanedMeshes = new Map();
            //keyed by the connector id of which the reflection probe is attached to
            this.reflectionProbeMap = new Map();
            this.reflectedMeshes = new Map();
            //key is the ConnectorId of the reflection probe, String[] is the ids of the meshes using the material;
            this.meshesUsingReflectionMaterial = new Map();
            this.modelToken = Token.MaterialNode;
            this._defaultMaterial = new PBRMaterial('default material', scene);
            this._defaultMaterial.albedoColor = new Color3(0.5, 0.5, 0.5);
            this._defaultMaterial.alphaMode = Engine.ALPHA_COMBINE;
            this._defaultMaterial.metallic = 0;
            this._defaultMaterial.roughness = 1;
        }
        get renderMode() {
            return this._renderMode;
        }
        set renderMode(mode) {
            this._renderMode = mode;
            this.babylonMap.forEach(material => {
                this.setRenderModeOnMaterial(material, mode);
            });
            this.setRenderModeOnMaterial(this._defaultMaterial, mode);
        }
        getAllDefinedMaterials() {
            return Array.from(this.babylonMap.values());
        }
        getGlobalMaterial(dynamicId) {
            if (!this._globalMaterialManager) {
                return undefined;
            }
            else {
                return this._globalMaterialManager.getById(dynamicId);
            }
        }
        delete3d(node) {
            this.textureRenderer.materialDeleted(node);
            const material = this.get3d(node);
            if (material instanceof PBRMaterial) {
                const orphanedMeshes = material.getBindedMeshes();
                this.orphanedMeshes.set(node.id, orphanedMeshes);
            }
            this.viewer.materialWarningsNeedsUpdate.next();
            return super.delete3d(node);
        }
        loadGlobalMaterial(materialId, managerServices) {
            if (!this._globalMaterialManager) {
                this._globalMaterialManager = new Kb3dManager({ services: managerServices });
            }
            const matService = this._globalMaterialManager.getService(Token.MaterialService);
            if (this._globalMaterialCache.has(materialId)) {
                return this._globalMaterialCache.get(materialId);
            }
            else {
                const obs = matService
                    .getMaterialById(materialId)
                    .pipe(map(imaterial => {
                    if (imaterial) {
                        let matNode = this._globalMaterialManager.getById(materialId);
                        const newMatNode = this._globalMaterialManager.deserialize(imaterial.data);
                        // If the material has already been added to the scene, just update it.
                        if (matNode) {
                            this._globalMaterialManager.assign(matNode, newMatNode);
                            // We have to re-initialize the material to reload the texture
                            if (matNode._initialized) {
                                matNode._initialized = false;
                                matNode.init();
                            }
                        }
                        else {
                            matNode = newMatNode;
                            matNode._dynamicId = matNode.id; // Each global material is unique
                            this._globalMaterialManager.register(matNode);
                            //now create the material in babylon by rendering it
                            this.update3d(matNode);
                        }
                        return matNode;
                    }
                    return undefined;
                }))
                    .pipe(shareReplay(1));
                this._globalMaterialCache.set(materialId, obs);
                return obs;
            }
        }
        update3dInternal(node) {
            let material = this.get3d(node);
            let _changes = node.changes;
            // since the texture are nested in the material we have to refresh the texture in the material individually
            if (instanceOf(node, Token.AdvancedMaterialNode)) {
                let changes = _changes;
                let pbrAdvMaterial = material;
                if (!pbrAdvMaterial) {
                    material = pbrAdvMaterial = new PBRMaterial(node._dynamicId, this.scene);
                    material.name = node.name;
                    material.id = node._dynamicId;
                    const meshesToBind = this.orphanedMeshes.get(node.id);
                    if (meshesToBind) {
                        const _pbrAdvMaterial = pbrAdvMaterial;
                        meshesToBind.forEach(mesh => {
                            mesh.material = _pbrAdvMaterial;
                        });
                    }
                    changes = _changes = new Map(Object.entries(node));
                    changes.set('textures', node.textures);
                    /** hardcode the alphaMode because the material always overrides the engine setting and we need proper alpha for dragging effects */
                    material.alphaMode = Engine.ALPHA_COMBINE;
                    material.useParallax = false;
                    // Logarithmic depth is a good concept but is buggy. Maybe try again later.
                    // material.useLogarithmicDepth = true;
                    material.useLightmapAsShadowmap = true;
                    material.enableSpecularAntiAliasing = true;
                    material.forceDepthWrite = true;
                    pbrAdvMaterial.transparencyMode = Material.MATERIAL_ALPHABLEND;
                    material.useMetallnessFromMetallicTextureBlue = false;
                    material.useMicroSurfaceFromReflectivityMapAlpha = false;
                    material.useRoughnessFromMetallicTextureGreen = false;
                    this.setRenderModeOnMaterial(material, this.renderMode);
                    this.set3d(node, pbrAdvMaterial);
                }
                if (changes.has('probePositionTargetId')) {
                    this.updateReflectionProbes();
                }
                if (changes.hasAny('probePositionTargetId', 'subsurfaceReflectionEnabled', 'reflectionType')) {
                    //if (node.reflectionType === eReflectionType.probe) {
                    if (!node.probePositionTargetId || !node.subsurfaceReflectionEnabled) {
                        if (pbrAdvMaterial) {
                            pbrAdvMaterial.reflectionTexture = null;
                        }
                    }
                    else {
                        if (node.reflectionType === exports.eReflectionType.probe) {
                            if (node.probePositionTargetId && pbrAdvMaterial) {
                                let reflectionProbe = this.reflectionProbeMap.get(node.probePositionTargetId);
                                if (!reflectionProbe || reflectionProbe instanceof MirrorTexture) {
                                    reflectionProbe = new ReflectionProbe(node.probePositionTargetId, 512, this.scene);
                                    this.reflectionProbeMap.set(node.probePositionTargetId, reflectionProbe);
                                    const exceptions = this.meshesUsingReflectionMaterial.get(node.probePositionTargetId);
                                    this.reflectedMeshes.forEach(mesh => {
                                        var _a;
                                        if (reflectionProbe && reflectionProbe.renderList) {
                                            if (!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.contains(mesh.id))) {
                                                (_a = reflectionProbe.renderList) === null || _a === void 0 ? void 0 : _a.push(mesh);
                                            }
                                        }
                                    });
                                    const sceneBackground = this.scene.meshes.find(obj => {
                                        return obj.id === 'hdrSkyBox';
                                    });
                                    if (reflectionProbe && reflectionProbe.renderList && sceneBackground) {
                                        reflectionProbe.renderList.push(sceneBackground);
                                    }
                                }
                                const connector = this.viewer.getNode(node.probePositionTargetId);
                                if (connector instanceof exports.Connector) {
                                    const connectorMesh = this.viewer.getRendererNode(connector);
                                    reflectionProbe.attachToMesh(connectorMesh);
                                }
                                if (pbrAdvMaterial) {
                                    reflectionProbe.cubeTexture.invertZ = false;
                                    pbrAdvMaterial.reflectionTexture = reflectionProbe.cubeTexture;
                                }
                            }
                        }
                        else {
                            if (node.probePositionTargetId && pbrAdvMaterial) {
                                let reflectionProbe = this.reflectionProbeMap.get(node.probePositionTargetId);
                                let noPlane = false;
                                if (reflectionProbe && reflectionProbe instanceof MirrorTexture) {
                                    if (!reflectionProbe.mirrorPlane) {
                                        noPlane = true;
                                    }
                                }
                                if (!reflectionProbe || reflectionProbe instanceof MirrorTexture || noPlane) {
                                    reflectionProbe = new ReflectionProbe(node.probePositionTargetId, 512, this.scene);
                                    this.reflectionProbeMap.set(node.probePositionTargetId, reflectionProbe);
                                    const exceptions = this.meshesUsingReflectionMaterial.get(node.probePositionTargetId);
                                    this.reflectedMeshes.forEach(mesh => {
                                        var _a;
                                        if (reflectionProbe && reflectionProbe.renderList) {
                                            if (!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.contains(mesh.id))) {
                                                (_a = reflectionProbe.renderList) === null || _a === void 0 ? void 0 : _a.push(mesh);
                                            }
                                        }
                                    });
                                    const sceneBackground = this.scene.meshes.find(obj => {
                                        return obj.id === 'hdrSkyBox';
                                    });
                                    if (reflectionProbe && reflectionProbe.renderList && sceneBackground) {
                                        reflectionProbe.renderList.push(sceneBackground);
                                    }
                                }
                                const mirrorTexture = new MirrorTexture('mirrorTexture', 1024, this.scene);
                                const connector = this.viewer.getNode(node.probePositionTargetId);
                                let position = new Vector3(0, 0, 0);
                                if (connector &&
                                    connector instanceof exports.Connector &&
                                    connector._parent &&
                                    connector._parent instanceof exports.SpaceNode) {
                                    const connectorMesh = this.viewer.getRendererNode(connector._parent);
                                    if (connectorMesh) {
                                        const normal = Vector3.TransformCoordinates(connector.direction.toVec3().scale(-1), connectorMesh.getWorldMatrix().getRotationMatrix());
                                        position = connectorMesh.absolutePosition;
                                        const reflector = Plane.FromPositionAndNormal(position, normal);
                                        mirrorTexture.mirrorPlane = reflector;
                                        mirrorTexture.renderList = reflectionProbe.renderList;
                                    }
                                }
                                if (pbrAdvMaterial) {
                                    mirrorTexture.invertZ = false;
                                    mirrorTexture.adaptiveBlurKernel = node.roughness * 100;
                                    pbrAdvMaterial.reflectionTexture = mirrorTexture;
                                }
                            }
                        }
                    }
                }
                if (changes.has('hasTransparency')) {
                    pbrAdvMaterial.useAlphaFromAlbedoTexture = node.hasTransparency;
                    this.textureRenderer.setTransparency(node, node.hasTransparency);
                }
                if (changes.has('directIntensity'))
                    pbrAdvMaterial.directIntensity = node.directIntensity;
                if (changes.has('emissiveIntensity'))
                    pbrAdvMaterial.emissiveIntensity = node.emissiveIntensity;
                if (changes.has('environmentIntensity'))
                    pbrAdvMaterial.environmentIntensity = node.environmentIntensity;
                if (changes.has('specularIntensity'))
                    pbrAdvMaterial.specularIntensity = node.specularIntensity;
                if (changes.has('ambientTextureStrength')) {
                    pbrAdvMaterial.ambientTextureStrength = node.ambientTextureStrength || 1;
                }
                if (changes.has('ambientColor')) {
                    pbrAdvMaterial.ambientColor = new Color3(node.ambientColor.r, node.ambientColor.g, node.ambientColor.b).toLinearSpace();
                }
                if (changes.has('albedoColor')) {
                    pbrAdvMaterial.albedoColor = new Color3(node.albedoColor.r, node.albedoColor.g, node.albedoColor.b).toLinearSpace();
                }
                if (changes.has('specularColor')) {
                    pbrAdvMaterial.reflectivityColor = new Color3(node.specularColor.r, node.specularColor.g, node.specularColor.b).toLinearSpace();
                }
                if (changes.has('reflectionColor')) {
                    pbrAdvMaterial.reflectionColor = new Color3(node.reflectionColor.r, node.reflectionColor.g, node.reflectionColor.b).toLinearSpace();
                }
                if (changes.has('microSurface'))
                    pbrAdvMaterial.microSurface = node.microSurface;
                if (changes.has('useSpecularOverAlpha'))
                    pbrAdvMaterial.useSpecularOverAlpha = node.useSpecularOverAlpha;
                if (changes.has('useRadianceOverAlpha'))
                    pbrAdvMaterial.useRadianceOverAlpha = node.useRadianceOverAlpha;
                if (changes.has('textures') || changes.has('doubleSided') || changes.has('hasTransparency')) {
                    // Only enable the material transparency handling if necessary
                    if ((node.hasTransparency && node.doubleSided) ||
                        node.textures.find(texture => texture.channel === exports.eTextureChannel.opacity)) {
                        // These properties are necessary to ensure that partial transparency self-blending works correctly. There is a performace impact.
                        pbrAdvMaterial.separateCullingPass = true;
                        pbrAdvMaterial.transparencyMode = Material.MATERIAL_ALPHABLEND;
                        // Refraction test
                        // let renderTarget = new RefractionTexture("rt", 1024, this.scene, true);
                        // renderTarget.renderListPredicate = (mesh) => {
                        //     return mesh.name === 'hdrSkyBox'; // mesh.material === pbrAdvMaterial && mesh.isEnabled();
                        // }
                        // renderTarget.lodGenerationScale = 0.5;
                        // renderTarget.depth = 1;
                        // pbrAdvMaterial.refractionTexture = renderTarget;
                        // renderTarget.refractionPlane = new Plane(0, 0, 0, 0);
                        // pbrAdvMaterial.subSurface.useAlbedoToTintRefraction = true
                        // pbrAdvMaterial.subSurface.indexOfRefraction = 1.5;
                        // pbrAdvMaterial.subSurface.isTranslucencyEnabled = true;
                        // pbrAdvMaterial.subSurface.linkRefractionWithTransparency = true;
                    }
                    else {
                        pbrAdvMaterial.separateCullingPass = false;
                        pbrAdvMaterial.transparencyMode = null;
                    }
                }
                if (changes.has('anisotropicIntensity'))
                    pbrAdvMaterial.anisotropy.intensity = node.anisotropicIntensity;
                if (changes.has('anisotropicDirection')) {
                    pbrAdvMaterial.anisotropy.direction = new Vector2(node.anisotropicDirection.x, node.anisotropicDirection.y);
                }
                if (changes.has('anisotropyEnabled')) {
                    pbrAdvMaterial.anisotropy.isEnabled = node.anisotropyEnabled;
                    if (node.anisotropyEnabled) {
                        const tangentTexture = node.textures.find(texture => texture.channel === exports.eTextureChannel.anisotropyTangent);
                        if (tangentTexture && isTrackedClass(tangentTexture)) {
                            tangentTexture.isModified = true;
                        }
                    }
                    else {
                        pbrAdvMaterial.anisotropy.texture = null;
                    }
                }
                if (changes.has('clearcoatIntensity'))
                    pbrAdvMaterial.clearCoat.intensity = node.clearcoatIntensity;
                if (changes.has('clearcoatTintEnabled'))
                    pbrAdvMaterial.clearCoat.isTintEnabled = node.clearcoatTintEnabled;
                if (changes.has('clearcoatTintIntensity')) {
                    pbrAdvMaterial.clearCoat.tintThickness = node.clearcoatTintIntensity;
                }
                if (changes.has('clearcoatTintColor')) {
                    pbrAdvMaterial.clearCoat.tintColor = node.clearcoatTintColor.toColor3();
                }
                if (changes.has('clearcoatEnabled')) {
                    pbrAdvMaterial.clearCoat.isEnabled = node.clearcoatEnabled;
                    if (node.clearcoatEnabled) {
                        const clearcoatNormalTexture = node.textures.find(texture => texture.channel === exports.eTextureChannel.clearCoatNormal);
                        if (clearcoatNormalTexture && isTrackedClass(clearcoatNormalTexture)) {
                            clearcoatNormalTexture.isModified = true;
                        }
                    }
                    else {
                        pbrAdvMaterial.clearCoat.bumpTexture = null;
                    }
                }
                if (changes.has('subsurfaceThickness')) {
                    pbrAdvMaterial.subSurface.minimumThickness = node.subsurfaceThickness;
                }
                if (changes.has('subsurfaceTintColor')) {
                    pbrAdvMaterial.subSurface.tintColor = node.subsurfaceTintColor.toColor3();
                }
                if (changes.has('subsurfaceUseAlbedoForTintColor')) {
                    pbrAdvMaterial.subSurface.useAlbedoToTintRefraction = node.subsurfaceUseAlbedoForTintColor;
                }
                if (changes.has('subsurfaceRefractionEnabled')) {
                    pbrAdvMaterial.subSurface.isRefractionEnabled = node.subsurfaceRefractionEnabled;
                }
                if (changes.has('subsurfaceRefractionIntensity')) {
                    pbrAdvMaterial.subSurface.refractionIntensity = node.subsurfaceRefractionIntensity;
                }
                if (changes.has('subsurfaceRefractionIndex')) {
                    pbrAdvMaterial.subSurface.indexOfRefraction = node.subsurfaceRefractionIndex;
                }
                if (changes.has('subsurfaceRefractionLinkTransparency')) {
                    pbrAdvMaterial.subSurface.linkRefractionWithTransparency = node.subsurfaceRefractionLinkTransparency;
                }
                if (changes.has('subsurfaceTranslucencyEnabled')) {
                    pbrAdvMaterial.subSurface.isTranslucencyEnabled = node.subsurfaceTranslucencyEnabled;
                }
                if (changes.has('subsurfaceTranslucencyIntensity')) {
                    pbrAdvMaterial.subSurface.translucencyIntensity = node.subsurfaceTranslucencyIntensity;
                }
                if (changes.hasAny('subsurfaceRefractionEnabled', 'subsurfaceTranslucencyEnabled', 'probePositionTargetId')) {
                    if (!node.probePositionTargetId || !node.subsurfaceRefractionEnabled) {
                        pbrAdvMaterial.refractionTexture = null;
                    }
                    else {
                        let refractionProbe = this.reflectionProbeMap.get(node.probePositionTargetId);
                        if (!refractionProbe) {
                            refractionProbe = new ReflectionProbe(node.probePositionTargetId, 512, this.scene);
                            const connector = this.viewer.getNode(node.probePositionTargetId);
                            if (connector instanceof exports.Connector) {
                                const connectorMesh = this.viewer.getRendererNode(connector);
                                refractionProbe.attachToMesh(connectorMesh);
                                this.reflectionProbeMap.set(node.probePositionTargetId, refractionProbe);
                            }
                            const exceptions = this.meshesUsingReflectionMaterial.get(node.probePositionTargetId);
                            this.reflectedMeshes.forEach(mesh => {
                                var _a;
                                if (refractionProbe && refractionProbe.renderList) {
                                    if (!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.contains(mesh.id))) {
                                        (_a = refractionProbe.renderList) === null || _a === void 0 ? void 0 : _a.push(mesh);
                                    }
                                }
                            });
                            const sceneBackground = this.scene.meshes.find(obj => {
                                return obj.id === 'hdrSkyBox';
                            });
                            if (refractionProbe && refractionProbe.renderList && sceneBackground) {
                                refractionProbe.renderList.push(sceneBackground);
                            }
                        }
                        const refractionTexture = new RefractionTexture('refractionTexture', 1024, this.scene);
                        const connector = this.viewer.getNode(node.probePositionTargetId);
                        let position = new Vector3(0, 0, 0);
                        if (connector &&
                            connector instanceof exports.Connector &&
                            connector._parent &&
                            connector._parent instanceof exports.SpaceNode) {
                            const connectorMesh = this.viewer.getRendererNode(connector._parent);
                            if (connectorMesh) {
                                const normal = Vector3.TransformCoordinates(connector.direction.toVec3(), connectorMesh.getWorldMatrix().getRotationMatrix());
                                position = connectorMesh.absolutePosition;
                                const reflector = Plane.FromPositionAndNormal(position, normal);
                                refractionTexture.refractionPlane = reflector;
                                refractionTexture.renderList = refractionProbe.renderList;
                                refractionTexture.depth = node.subsurfaceRefractionIndex;
                            }
                        }
                        if (pbrAdvMaterial) {
                            refractionTexture.invertZ = false;
                            pbrAdvMaterial.refractionTexture = refractionTexture;
                        }
                    }
                    if (node.subsurfaceRefractionEnabled || node.subsurfaceTranslucencyEnabled) {
                        if (!pbrAdvMaterial.subSurface.thicknessTexture) {
                            const subsurfaceThicknessTexture = node.textures.find(texture => texture.channel === exports.eTextureChannel.subsurfaceThickness);
                            if (subsurfaceThicknessTexture && isTrackedClass(subsurfaceThicknessTexture)) {
                                subsurfaceThicknessTexture.isModified = true;
                            }
                        }
                    }
                    else {
                        pbrAdvMaterial.subSurface.thicknessTexture = null;
                    }
                }
                if (changes.has('workflowMode')) {
                    if (node.workflowMode === exports.eMaterialWorkflow.metallicRoughness) {
                        pbrAdvMaterial.metallic = node.metallic;
                        pbrAdvMaterial.roughness = node.roughness;
                    }
                    else {
                        /* Remove the metallic texture if workflow is not metallic-roughness, otherwise metallic-roughness gets used */
                        pbrAdvMaterial.metallicTexture = undefined;
                        pbrAdvMaterial.metallic = null;
                        pbrAdvMaterial.roughness = null;
                    }
                    if (pbrAdvMaterial.reflectionTexture && pbrAdvMaterial.reflectionTexture instanceof MirrorTexture) {
                        if (node.roughness !== 0) {
                            pbrAdvMaterial.reflectionTexture.adaptiveBlurKernel = node.roughness * 100;
                        }
                        else {
                            //When setting the adaptiveBlurKernel to 0 we get very odd behavior.
                            pbrAdvMaterial.reflectionTexture.adaptiveBlurKernel = 0.000001;
                        }
                    }
                }
                else if (node.workflowMode === exports.eMaterialWorkflow.metallicRoughness) {
                    if (changes.has('metallic'))
                        pbrAdvMaterial.metallic = node.metallic;
                    if (changes.has('roughness')) {
                        pbrAdvMaterial.roughness = node.roughness;
                        if (pbrAdvMaterial.reflectionTexture && pbrAdvMaterial.reflectionTexture instanceof MirrorTexture) {
                            if (node.roughness !== 0) {
                                pbrAdvMaterial.reflectionTexture.adaptiveBlurKernel = node.roughness * 100;
                            }
                            else {
                                //When setting the adaptiveBlurKernel to 0 we get very odd behavior.
                                pbrAdvMaterial.reflectionTexture.adaptiveBlurKernel = 0.000001;
                            }
                        }
                    }
                }
            }
            if (material) {
                const changes = _changes;
                if (changes.has('alpha'))
                    material.alpha = node.alpha;
                if (changes.has('zOffset'))
                    material.zOffset = node.zOffset || 0;
                if (changes.has('doubleSided')) {
                    material.backFaceCulling = !node.doubleSided;
                    material.twoSidedLighting = !!node.doubleSided;
                }
                if (changes.has('emissiveColor')) {
                    if (node.emissiveColor) {
                        material.emissiveColor = new Color3(node.emissiveColor.r, node.emissiveColor.g, node.emissiveColor.b);
                    }
                    else {
                        material.emissiveColor = Color3.Black();
                    }
                }
                // Wireframe mode for debugging geometry
                // if(true || node.viewMode === eMaterialViewMode.wireframe) {
                //     material.wireframe = true;
                //     material.emissiveColor = Color3.Red();
                // }
            }
            this.viewer.materialWarningsNeedsUpdate.next();
        }
        setRenderModeOnMaterial(material, mode) {
            if (mode === exports.eRenderMode.wireframe) {
                material.pointsCloud = false;
                material.wireframe = true;
            }
            else if (mode === exports.eRenderMode.hiddenEdges) {
                material.wireframe = false;
                material.pointsCloud = true;
            }
            else {
                material.pointsCloud = false;
                material.wireframe = false;
            }
        }
        getNumberOfMaterialRef(sceneNode, materialNode) {
            const allMeshes = sceneNode.filterByType(...Token.MeshTokens);
            let nrefs = 0;
            for (const m of allMeshes) {
                if (m.materialId == materialNode._dynamicId)
                    nrefs++;
            }
            return nrefs;
        }
        updateReflectionProbes() {
            var _a, _b;
            this.meshesUsingReflectionMaterial.clear();
            (_a = this.viewer.sceneNode._manager) === null || _a === void 0 ? void 0 : _a.getAllNodes().forEach(mesh => {
                var _a;
                if (mesh instanceof exports.MeshNode) {
                    if (mesh.materialId) {
                        const material = (_a = mesh._manager) === null || _a === void 0 ? void 0 : _a.getById(mesh.materialId);
                        if (material && material instanceof exports.MaterialNode && material.probePositionTargetId) {
                            let exceptionList = this.meshesUsingReflectionMaterial.get(material.probePositionTargetId);
                            if (!exceptionList) {
                                exceptionList = [mesh._dynamicId];
                            }
                            else {
                                exceptionList.push(mesh._dynamicId);
                            }
                            this.meshesUsingReflectionMaterial.set(material.probePositionTargetId, exceptionList);
                        }
                    }
                }
            });
            const sceneBackground = this.scene.meshes.filter(obj => {
                return obj.id === 'hdrSkyBox';
            });
            for (const keyValuePair of this.reflectionProbeMap) {
                const reflectionProbe = keyValuePair[1];
                const connectorId = keyValuePair[0];
                (_b = reflectionProbe.renderList) === null || _b === void 0 ? void 0 : _b.clear();
                const exceptions = this.meshesUsingReflectionMaterial.get(connectorId);
                this.reflectedMeshes.forEach(mesh => {
                    var _a;
                    if (!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.contains(mesh.id))) {
                        (_a = reflectionProbe.renderList) === null || _a === void 0 ? void 0 : _a.push(mesh);
                    }
                });
                if (reflectionProbe && reflectionProbe.renderList) {
                    reflectionProbe.renderList.push(sceneBackground[0]);
                }
            }
        }
    }

    /**
     * Class containing static functions to help procedurally build meshes
     */
    class CylinderBuilder$1 {
        /**
         * Creates a torus mesh
         * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
         * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
         * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
         * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/Cylinderover_basic_elements#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
         * @param name defines the name of the mesh
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns the torus mesh
         * @see https://doc.babylonjs.com/how_to/set_shapes#torus
         */
        static CreateCylinder(name, options, scene) {
            const Cylinder = new Mesh(name, scene);
            options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
            Cylinder._originalBuilderSideOrientation = options.sideOrientation;
            const vertexData = createCylinder(options);
            vertexData.applyToMesh(Cylinder, options.updatable);
            return Cylinder;
            function createCylinder(options) {
                const height = options.height || 2;
                let diameterTop = options.diameterTop === 0 ? 0 : options.diameterTop || options.diameter || 1;
                let diameterBottom = options.diameterBottom === 0 ? 0 : options.diameterBottom || options.diameter || 1;
                diameterTop = diameterTop || 0.00001; // Prevent broken normals
                diameterBottom = diameterBottom || 0.00001; // Prevent broken normals
                const tessellation = options.tessellation || 24;
                const subdivisions = options.subdivisions || 1;
                const hasRings = options.hasRings ? true : false;
                const enclose = options.enclose ? true : false;
                const cap = options.cap === 0 ? 0 : options.cap || Mesh.CAP_ALL;
                const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
                const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
                const faceUV = options.faceUV || new Array(3);
                const faceColors = options.faceColors;
                // default face colors and UV if undefined
                const quadNb = arc !== 1 && enclose ? 2 : 0;
                const ringNb = hasRings ? subdivisions : 1;
                const surfaceNb = 2 + (1 + quadNb) * ringNb;
                let f;
                for (f = 0; f < surfaceNb; f++) {
                    if (faceColors && faceColors[f] === undefined) {
                        faceColors[f] = new Color4(1, 1, 1, 1);
                    }
                }
                for (f = 0; f < surfaceNb; f++) {
                    if (faceUV && faceUV[f] === undefined) {
                        faceUV[f] = new Vector4(0, 0, 1, 1);
                    }
                }
                const indices = new Array();
                const positions = new Array();
                const normals = new Array();
                const uvs = new Array();
                const colors = new Array();
                const angle_step = (Math.PI * 2 * arc) / tessellation;
                let angle;
                let h;
                let radius;
                const tan = (diameterBottom - diameterTop) / 2 / height;
                const ringVertex = Vector3.Zero();
                const ringNormal = Vector3.Zero();
                const ringFirstVertex = Vector3.Zero();
                const ringFirstNormal = Vector3.Zero();
                const quadNormal = Vector3.Zero();
                const Y = Axis.Y;
                // positions, normals, uvs
                let i;
                let j;
                let r;
                let ringIdx = 1;
                let s = 1; // surface index
                let cs = 0;
                let v = 0;
                for (i = 0; i <= subdivisions; i++) {
                    h = i / subdivisions;
                    radius = (h * (diameterTop - diameterBottom) + diameterBottom) / 2;
                    ringIdx = hasRings && i !== 0 && i !== subdivisions ? 2 : 1;
                    for (r = 0; r < ringIdx; r++) {
                        if (hasRings) {
                            s += r;
                        }
                        if (enclose) {
                            s += 2 * r;
                        }
                        for (j = 0; j <= tessellation; j++) {
                            angle = j * angle_step;
                            // position
                            ringVertex.x = Math.cos(-angle) * radius;
                            ringVertex.y = -height / 2 + h * height;
                            ringVertex.z = Math.sin(-angle) * radius;
                            // normal
                            if (diameterTop === 0 && i === subdivisions) {
                                // if no top cap, reuse former normals
                                ringNormal.x = normals[normals.length - (tessellation + 1) * 3];
                                ringNormal.y = normals[normals.length - (tessellation + 1) * 3 + 1];
                                ringNormal.z = normals[normals.length - (tessellation + 1) * 3 + 2];
                            }
                            else {
                                ringNormal.x = ringVertex.x;
                                ringNormal.z = ringVertex.z;
                                ringNormal.y = Math.sqrt(ringNormal.x * ringNormal.x + ringNormal.z * ringNormal.z) * tan;
                                ringNormal.normalize();
                            }
                            // keep first ring vertex values for enclose
                            if (j === 0) {
                                ringFirstVertex.copyFrom(ringVertex);
                                ringFirstNormal.copyFrom(ringNormal);
                            }
                            positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                            normals.push(ringNormal.x, ringNormal.y, ringNormal.z);
                            if (hasRings) {
                                v = cs !== s ? faceUV[s].y : faceUV[s].w;
                            }
                            else {
                                v = faceUV[s].y + (faceUV[s].w - faceUV[s].y) * h;
                            }
                            uvs.push(faceUV[s].x + ((faceUV[s].z - faceUV[s].x) * j) / tessellation, v);
                            if (faceColors) {
                                colors.push(faceColors[s].r, faceColors[s].g, faceColors[s].b, faceColors[s].a);
                            }
                        }
                        // if enclose, add four vertices and their dedicated normals
                        if (arc !== 1 && enclose) {
                            positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                            positions.push(0, ringVertex.y, 0);
                            positions.push(0, ringVertex.y, 0);
                            positions.push(ringFirstVertex.x, ringFirstVertex.y, ringFirstVertex.z);
                            Vector3.CrossToRef(Y, ringNormal, quadNormal);
                            quadNormal.normalize();
                            normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                            Vector3.CrossToRef(ringFirstNormal, Y, quadNormal);
                            quadNormal.normalize();
                            normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                            if (hasRings) {
                                v = cs !== s ? faceUV[s + 1].y : faceUV[s + 1].w;
                            }
                            else {
                                v = faceUV[s + 1].y + (faceUV[s + 1].w - faceUV[s + 1].y) * h;
                            }
                            uvs.push(faceUV[s + 1].x, v);
                            uvs.push(faceUV[s + 1].z, v);
                            if (hasRings) {
                                v = cs !== s ? faceUV[s + 2].y : faceUV[s + 2].w;
                            }
                            else {
                                v = faceUV[s + 2].y + (faceUV[s + 2].w - faceUV[s + 2].y) * h;
                            }
                            uvs.push(faceUV[s + 2].x, v);
                            uvs.push(faceUV[s + 2].z, v);
                            if (faceColors) {
                                colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                                colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                                colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                                colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                            }
                        }
                        if (cs !== s) {
                            cs = s;
                        }
                    }
                }
                // indices
                const e = arc !== 1 && enclose ? tessellation + 4 : tessellation; // correction of number of iteration if enclose
                let sI;
                i = 0;
                for (sI = 0; sI < subdivisions; sI++) {
                    let i0 = 0;
                    let i1 = 0;
                    let i2 = 0;
                    let i3 = 0;
                    for (j = 0; j < tessellation; j++) {
                        i0 = i * (e + 1) + j; // top left
                        i1 = (i + 1) * (e + 1) + j; // bottom left
                        i2 = i * (e + 1) + (j + 1); // top right
                        i3 = (i + 1) * (e + 1) + (j + 1); // bottom right
                        indices.push(i0, i1, i2);
                        indices.push(i3, i2, i1);
                    }
                    if (arc !== 1 && enclose) {
                        // if enclose, add two quads
                        indices.push(i0 + 2, i1 + 2, i2 + 2);
                        indices.push(i3 + 2, i2 + 2, i1 + 2);
                        indices.push(i0 + 4, i1 + 4, i2 + 4);
                        indices.push(i3 + 4, i2 + 4, i1 + 4);
                    }
                    else if (arc === 1) {
                        indices.push(i2, i3, i * (e + 1));
                        indices.push((i + 1) * (e + 1), i * (e + 1), i3);
                    }
                    i = hasRings ? i + 2 : i + 1;
                }
                // Caps
                const createCylinderCap = (isTop) => {
                    const radius = isTop ? diameterTop / 2 : diameterBottom / 2;
                    if (radius === 0) {
                        return;
                    }
                    // Cap positions, normals & uvs
                    let angle;
                    let circleVector;
                    let i;
                    const u = isTop ? faceUV[surfaceNb - 1] : faceUV[0];
                    let c = null;
                    if (faceColors) {
                        c = isTop ? faceColors[surfaceNb - 1] : faceColors[0];
                    }
                    // cap center
                    const vbase = positions.length / 3;
                    const offset = isTop ? height / 2 : -height / 2;
                    const center = new Vector3(0, offset, 0);
                    positions.push(center.x, center.y, center.z);
                    normals.push(0, isTop ? 1 : -1, 0);
                    uvs.push(u.x + (u.z - u.x) * 0.5, u.y + (u.w - u.y) * 0.5);
                    if (c) {
                        colors.push(c.r, c.g, c.b, c.a);
                    }
                    const textureScale = new Vector2(0.5, 0.5);
                    for (i = 0; i <= tessellation; i++) {
                        angle = i * angle_step;
                        const cos = Math.cos(-angle);
                        const sin = Math.sin(-angle);
                        circleVector = new Vector3(cos * radius, offset, sin * radius);
                        const textureCoordinate = new Vector2(cos * textureScale.x + 0.5, sin * textureScale.y + 0.5);
                        positions.push(circleVector.x, circleVector.y, circleVector.z);
                        normals.push(0, isTop ? 1 : -1, 0);
                        uvs.push(u.x + (u.z - u.x) * textureCoordinate.x, u.y + (u.w - u.y) * textureCoordinate.y);
                        if (c) {
                            colors.push(c.r, c.g, c.b, c.a);
                        }
                    }
                    // Cap indices
                    for (i = 0; i < tessellation; i++) {
                        if (!isTop) {
                            indices.push(vbase);
                            indices.push(vbase + (i + 1));
                            indices.push(vbase + (i + 2));
                        }
                        else {
                            indices.push(vbase);
                            indices.push(vbase + (i + 2));
                            indices.push(vbase + (i + 1));
                        }
                    }
                    // Close the loop
                    if (arc === 1) {
                        if (!isTop) {
                            indices.push(vbase, vbase + tessellation + 1, vbase + 1);
                        }
                        else {
                            indices.push(vbase, vbase + 1, vbase + tessellation + 1);
                        }
                    }
                };
                // add caps to geometry based on cap parameter
                if (cap === Mesh.CAP_START || cap === Mesh.CAP_ALL) {
                    createCylinderCap(false);
                }
                if (cap === Mesh.CAP_END || cap === Mesh.CAP_ALL) {
                    createCylinderCap(true);
                }
                // Sides
                VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
                const vertexData = new VertexData();
                vertexData.indices = indices;
                vertexData.positions = positions;
                vertexData.normals = normals;
                vertexData.uvs = uvs;
                if (faceColors) {
                    vertexData.colors = colors;
                }
                return vertexData;
            }
        }
    }

    /**
     * Class containing static functions to help procedurally build meshes
     */
    class DiscBuilder {
        /**
         * Creates a torus mesh
         * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
         * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
         * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
         * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
         * @param name defines the name of the mesh
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns the torus mesh
         * @see https://doc.babylonjs.com/how_to/set_shapes#torus
         */
        static CreateDisc(name, options, scene) {
            const disc = new Mesh(name, scene);
            options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
            disc._originalBuilderSideOrientation = options.sideOrientation;
            const vertexData = createDisc(options);
            vertexData.applyToMesh(disc, options.updatable);
            return disc;
            function createDisc(options) {
                const positions = new Array();
                const indices = new Array();
                const normals = new Array();
                const uvs = new Array();
                const radius = options.radius || 0.5;
                const tessellation = options.tessellation || 64;
                const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
                const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
                // positions and uvs
                positions.push(0, 0, 0); // disc center first
                uvs.push(0.5, 0.5);
                const theta = Math.PI * 2 * arc;
                const step = theta / tessellation;
                for (let a = 0; arc === 1 ? a < theta : a <= theta; a += step) {
                    const x = Math.cos(a);
                    const y = Math.sin(a);
                    const u = (x + 1) / 2;
                    const v = (1 - y) / 2;
                    positions.push(radius * x, radius * y, 0);
                    uvs.push(u, v);
                }
                //indices
                const vertexNb = positions.length / 3;
                for (let i = 1; i < vertexNb - 1; i++) {
                    indices.push(i + 1, 0, i);
                }
                if (arc === 1) {
                    indices.push(1, 0, vertexNb - 1); // close the circle
                }
                // result
                VertexData.ComputeNormals(positions, indices, normals);
                VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
                const vertexData = new VertexData();
                vertexData.indices = indices;
                vertexData.positions = positions;
                vertexData.normals = normals;
                vertexData.uvs = uvs;
                return vertexData;
            }
        }
    }

    /**
     * Class containing static functions to help procedurally build meshes
     */
    class PlaneBuilder$1 {
        /**
         * Creates a torus mesh
         * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
         * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
         * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
         * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
         * @param name defines the name of the mesh
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns the torus mesh
         * @see https://doc.babylonjs.com/how_to/set_shapes#torus
         */
        static CreatePlane(name, options, scene) {
            const plane = new Mesh(name, scene);
            options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
            const flipTile = options.pattern || Mesh.NO_FLIP;
            const tileWidth = options.tileWidth || options.tileSize || 1;
            const tileHeight = options.tileHeight || options.tileSize || 1;
            const alignH = options.alignHorizontal || 0;
            const alignV = options.alignVertical || 0;
            const width = options.width || options.size || 1;
            const tilesX = Math.floor(width / tileWidth);
            let offsetX = width - tilesX * tileWidth;
            const height = options.height || options.size || 1;
            const tilesY = Math.floor(height / tileHeight);
            let offsetY = height - tilesY * tileHeight;
            const halfWidth = (tileWidth * tilesX) / 2;
            const halfHeight = (tileHeight * tilesY) / 2;
            const indices = [];
            const positions = [];
            const normals = new Float32Array(tilesX * tilesY * 12);
            const colorSetArray = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            const normalSetArray = [0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1];
            const colorSet = Float32Array.from(colorSetArray);
            const normalSet = Float32Array.from(normalSetArray);
            let adjustX = 0;
            let adjustY = 0;
            let startX = 0;
            let startY = 0;
            let endX = 0;
            let endY = 0;
            //Part Tiles
            if (offsetX > 0 || offsetY > 0) {
                startX = -halfWidth;
                startY = -halfHeight;
                endX = halfWidth;
                endY = halfHeight;
                switch (alignH) {
                    case Mesh.CENTER:
                        offsetX /= 2;
                        startX -= offsetX;
                        endX += offsetX;
                        break;
                    case Mesh.LEFT:
                        endX += offsetX;
                        adjustX = -offsetX / 2;
                        break;
                    case Mesh.RIGHT:
                        startX -= offsetX;
                        adjustX = offsetX / 2;
                        break;
                }
                switch (alignV) {
                    case Mesh.CENTER:
                        offsetY /= 2;
                        startY -= offsetY;
                        endY += offsetY;
                        break;
                    case Mesh.BOTTOM:
                        endY += offsetY;
                        adjustY = -offsetY / 2;
                        break;
                    case Mesh.TOP:
                        startY -= offsetY;
                        adjustY = offsetY / 2;
                        break;
                }
            }
            const uvBase = [];
            uvBase[0] = [0, 0, 1, 0, 1, 1, 0, 1];
            uvBase[1] = [0, 0, 1, 0, 1, 1, 0, 1];
            if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                uvBase[1] = [1, 1, 0, 1, 0, 0, 1, 0];
            }
            if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                uvBase[1] = [1, 0, 0, 0, 0, 1, 1, 1];
            }
            if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                uvBase[1] = [0, 1, 1, 1, 1, 0, 0, 0];
            }
            const uvs = new Float32Array(tilesY * tilesX * 8);
            const colors = new Float32Array(tilesY * tilesX * 16);
            let index = 0;
            for (let y = 0; y < tilesY; y++) {
                for (let x = 0; x < tilesX; x++) {
                    positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                    positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                    positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                    positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    if (flipTile === Mesh.FLIP_TILE ||
                        flipTile === Mesh.ROTATE_TILE ||
                        flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                        uvs.set(uvBase[((x % 2) + (y % 2)) % 2], index * 2);
                    }
                    else if (flipTile === Mesh.FLIP_ROW ||
                        flipTile === Mesh.ROTATE_ROW ||
                        flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvs.set(uvBase[y % 2], index * 2);
                    }
                    else {
                        uvs.set(uvBase[0], index * 2);
                    }
                    colors.set(colorSet, index * 4);
                    normals.set(normalSet, index * 3);
                    index += 4;
                }
            }
            //Part Tiles
            if (offsetX > 0 || offsetY > 0) {
                const partialBottomRow = offsetY > 0 && (alignV === Mesh.CENTER || alignV === Mesh.TOP);
                const partialTopRow = offsetY > 0 && (alignV === Mesh.CENTER || alignV === Mesh.BOTTOM);
                const partialLeftCol = offsetX > 0 && (alignH === Mesh.CENTER || alignH === Mesh.RIGHT);
                const partialRightCol = offsetX > 0 && (alignH === Mesh.CENTER || alignH === Mesh.LEFT);
                let uvPart = [];
                let a, b, c, d;
                //corners
                if (partialBottomRow && partialLeftCol) {
                    //bottom left corner
                    positions.push(startX + adjustX, startY + adjustY, 0);
                    positions.push(-halfWidth + adjustX, startY + adjustY, 0);
                    positions.push(-halfWidth + adjustX, startY + offsetY + adjustY, 0);
                    positions.push(startX + adjustX, startY + offsetY + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    a = 1 - offsetX / tileWidth;
                    b = 1 - offsetY / tileHeight;
                    c = 1;
                    d = 1;
                    uvPart = [a, b, c, b, c, d, a, d];
                    if (flipTile === Mesh.ROTATE_ROW) {
                        uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if (flipTile === Mesh.FLIP_ROW) {
                        uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if (flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    uvs.set(uvPart, index * 2);
                    uvs.set(uvPart, index);
                    colors.set(colorSet, index * 4);
                    normals.set(normalSet, index * 3);
                }
                if (partialBottomRow && partialRightCol) {
                    //bottom right corner
                    positions.push(halfWidth + adjustX, startY + adjustY, 0);
                    positions.push(endX + adjustX, startY + adjustY, 0);
                    positions.push(endX + adjustX, startY + offsetY + adjustY, 0);
                    positions.push(halfWidth + adjustX, startY + offsetY + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    a = 0;
                    b = 1 - offsetY / tileHeight;
                    c = offsetX / tileWidth;
                    d = 1;
                    uvPart = [a, b, c, b, c, d, a, d];
                    if (flipTile === Mesh.ROTATE_ROW || (flipTile === Mesh.ROTATE_TILE && tilesX % 2 === 0)) {
                        uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if (flipTile === Mesh.FLIP_ROW || (flipTile === Mesh.FLIP_TILE && tilesX % 2 === 0)) {
                        uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if (flipTile === Mesh.FLIP_N_ROTATE_ROW || (flipTile === Mesh.FLIP_N_ROTATE_TILE && tilesX % 2 === 0)) {
                        uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    uvs.set(uvPart, index * 2);
                    colors.set(colorSet, index * 4);
                    normals.set(normalSet, index * 3);
                }
                if (partialTopRow && partialLeftCol) {
                    //top left corner
                    positions.push(startX + adjustX, halfHeight + adjustY, 0);
                    positions.push(-halfWidth + adjustX, halfHeight + adjustY, 0);
                    positions.push(-halfWidth + adjustX, endY + adjustY, 0);
                    positions.push(startX + adjustX, endY + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    a = 1 - offsetX / tileWidth;
                    b = 0;
                    c = 1;
                    d = offsetY / tileHeight;
                    uvPart = [a, b, c, b, c, d, a, d];
                    if ((flipTile === Mesh.ROTATE_ROW && tilesY % 2 === 1) ||
                        (flipTile === Mesh.ROTATE_TILE && tilesY % 1 === 0)) {
                        uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if ((flipTile === Mesh.FLIP_ROW && tilesY % 2 === 1) ||
                        (flipTile === Mesh.FLIP_TILE && tilesY % 2 === 0)) {
                        uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if ((flipTile === Mesh.FLIP_N_ROTATE_ROW && tilesY % 2 === 1) ||
                        (flipTile === Mesh.FLIP_N_ROTATE_TILE && tilesY % 2 === 0)) {
                        uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    uvs.set(uvPart, index * 2);
                    colors.set(colorSet, index * 4);
                    normals.set(normalSet, index * 3);
                }
                if (partialTopRow && partialRightCol) {
                    //top right corner
                    positions.push(halfWidth + adjustX, halfHeight + adjustY, 0);
                    positions.push(endX + adjustX, halfHeight + adjustY, 0);
                    positions.push(endX + adjustX, endY + adjustY, 0);
                    positions.push(halfWidth + adjustX, endY + adjustY, 0);
                    indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                    index += 4;
                    a = 0;
                    b = 0;
                    c = offsetX / tileWidth;
                    d = offsetY / tileHeight;
                    uvPart = [a, b, c, b, c, d, a, d];
                    if ((flipTile === Mesh.ROTATE_ROW && tilesY % 2 === 1) ||
                        (flipTile === Mesh.ROTATE_TILE && (tilesY + tilesX) % 2 === 1)) {
                        uvPart = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if ((flipTile === Mesh.FLIP_ROW && tilesY % 2 === 1) ||
                        (flipTile === Mesh.FLIP_TILE && (tilesY + tilesX) % 2 === 1)) {
                        uvPart = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if ((flipTile === Mesh.FLIP_N_ROTATE_ROW && tilesY % 2 === 1) ||
                        (flipTile === Mesh.FLIP_N_ROTATE_TILE && (tilesY + tilesX) % 2 === 1)) {
                        uvPart = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    uvs.set(uvPart, index * 2);
                    colors.set(colorSet, index * 4);
                    normals.set(normalSet, index * 3);
                }
                //part rows
                if (partialBottomRow) {
                    const uvBaseBR = [];
                    a = 0;
                    b = 1 - offsetY / tileHeight;
                    c = 1;
                    d = 1;
                    uvBaseBR[0] = [a, b, c, b, c, d, a, d];
                    uvBaseBR[1] = [a, b, c, b, c, d, a, d];
                    if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                        uvBaseBR[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                        uvBaseBR[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvBaseBR[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    for (let x = 0; x < tilesX; x++) {
                        positions.push(-halfWidth + x * tileWidth + adjustX, startY + adjustY, 0);
                        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + adjustY, 0);
                        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                        positions.push(-halfWidth + x * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                        indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                        index += 4;
                        if (flipTile === Mesh.FLIP_TILE ||
                            flipTile === Mesh.ROTATE_TILE ||
                            flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                            uvs.set(uvBaseBR[(x + 1) % 2], index * 2);
                        }
                        else if (flipTile === Mesh.FLIP_ROW ||
                            flipTile === Mesh.ROTATE_ROW ||
                            flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                            uvs.set(uvBaseBR[1], index * 2);
                        }
                        else {
                            uvs.set(uvBaseBR[0], index * 2);
                        }
                        colors.set(colorSet, index * 4);
                        normals.set(normalSet, index * 3);
                    }
                }
                if (partialTopRow) {
                    const uvBaseTR = [];
                    a = 0;
                    b = 0;
                    c = 1;
                    d = offsetY / tileHeight;
                    uvBaseTR[0] = [a, b, c, b, c, d, a, d];
                    uvBaseTR[1] = [a, b, c, b, c, d, a, d];
                    if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                        uvBaseTR[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                        uvBaseTR[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvBaseTR[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    for (let x = 0; x < tilesX; x++) {
                        positions.push(-halfWidth + x * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY + adjustY, 0);
                        positions.push(-halfWidth + x * tileWidth + adjustX, endY + adjustY, 0);
                        indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                        index += 4;
                        if (flipTile === Mesh.FLIP_TILE ||
                            flipTile === Mesh.ROTATE_TILE ||
                            flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                            uvs.set(uvBaseTR[(x + tilesY) % 2], index * 2);
                        }
                        else if (flipTile === Mesh.FLIP_ROW ||
                            flipTile === Mesh.ROTATE_ROW ||
                            flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                            uvs.set(uvBaseTR[tilesY % 2], index * 2);
                        }
                        else {
                            uvs.set(uvBaseTR[0], index * 2);
                        }
                        colors.set(colorSet, index * 4);
                        normals.set(normalSet, index * 3);
                    }
                }
                if (partialLeftCol) {
                    const uvBaseLC = [];
                    a = 1 - offsetX / tileWidth;
                    b = 0;
                    c = 1;
                    d = 1;
                    uvBaseLC[0] = [a, b, c, b, c, d, a, d];
                    uvBaseLC[1] = [a, b, c, b, c, d, a, d];
                    if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                        uvBaseLC[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                        uvBaseLC[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvBaseLC[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    for (let y = 0; y < tilesY; y++) {
                        positions.push(startX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                        positions.push(startX + offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                        positions.push(startX + offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                        positions.push(startX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                        indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                        index += 4;
                        if (flipTile === Mesh.FLIP_TILE ||
                            flipTile === Mesh.ROTATE_TILE ||
                            flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                            uvs.set(uvBaseLC[(y + 1) % 2], index * 2);
                        }
                        else if (flipTile === Mesh.FLIP_ROW ||
                            flipTile === Mesh.ROTATE_ROW ||
                            flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                            uvs.set(uvBaseLC[y % 2], index * 2);
                        }
                        else {
                            uvs.set(uvBaseLC[0], index * 2);
                        }
                        colors.set(colorSet, index * 4);
                        normals.set(normalSet, index * 3);
                    }
                }
                if (partialRightCol) {
                    const uvBaseRC = [];
                    a = 0;
                    b = 0;
                    c = offsetX / tileHeight;
                    d = 1;
                    uvBaseRC[0] = [a, b, c, b, c, d, a, d];
                    uvBaseRC[1] = [a, b, c, b, c, d, a, d];
                    if (flipTile === Mesh.ROTATE_TILE || flipTile === Mesh.ROTATE_ROW) {
                        uvBaseRC[1] = [1 - a, 1 - b, 1 - c, 1 - b, 1 - c, 1 - d, 1 - a, 1 - d];
                    }
                    if (flipTile === Mesh.FLIP_TILE || flipTile === Mesh.FLIP_ROW) {
                        uvBaseRC[1] = [1 - a, b, 1 - c, b, 1 - c, d, 1 - a, d];
                    }
                    if (flipTile === Mesh.FLIP_N_ROTATE_TILE || flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                        uvBaseRC[1] = [a, 1 - b, c, 1 - b, c, 1 - d, a, 1 - d];
                    }
                    for (let y = 0; y < tilesY; y++) {
                        positions.push(endX - offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                        positions.push(endX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                        positions.push(endX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                        positions.push(endX - offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                        indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                        index += 4;
                        if (flipTile === Mesh.FLIP_TILE ||
                            flipTile === Mesh.ROTATE_TILE ||
                            flipTile === Mesh.FLIP_N_ROTATE_TILE) {
                            uvs.set(uvBaseRC[(y + tilesX) % 2], index * 2);
                        }
                        else if (flipTile === Mesh.FLIP_ROW ||
                            flipTile === Mesh.ROTATE_ROW ||
                            flipTile === Mesh.FLIP_N_ROTATE_ROW) {
                            uvs.set(uvBaseRC[y % 2], index * 2);
                        }
                        else {
                            uvs.set(uvBaseRC[0], index * 2);
                        }
                        colors.set(colorSet, index * 4);
                        normals.set(normalSet, index * 3);
                    }
                }
            }
            //reverse V values since old PlaneBuilder built them that way
            for (let i = 0; i < uvs.length / 2; i++) {
                uvs[i * 2 + 1] = 1 - uvs[i * 2 + 1];
            }
            const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
            // sides
            VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
            // Result
            const vertexData = new VertexData();
            vertexData.indices = indices;
            vertexData.positions = positions;
            vertexData.normals = normals;
            vertexData.uvs = uvs;
            vertexData.applyToMesh(plane, options.updatable);
            return plane;
        }
    }

    /**
     * Class containing static functions to help procedurally build meshes
     */
    class SphereBuilder$1 {
        /**
         * Creates a torus mesh
         * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
         * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
         * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
         * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
         * @param name defines the name of the mesh
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns the torus mesh
         * @see https://doc.babylonjs.com/how_to/set_shapes#torus
         */
        static CreateSphere(name, options, scene) {
            const sphere = new Mesh(name, scene);
            options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
            sphere._originalBuilderSideOrientation = options.sideOrientation;
            const vertexData = createSphere(options);
            vertexData.applyToMesh(sphere, options.updatable);
            return sphere;
            function createSphere(options) {
                const segments = options.segments || 32;
                const diameterX = options.diameterX || options.diameter || 1;
                const diameterY = options.diameterY || options.diameter || 1;
                const diameterZ = options.diameterZ || options.diameter || 1;
                const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
                const sliceStart = options.sliceStart && (options.sliceStart < 0 || options.sliceStart > 1) ? 0 : options.sliceStart || 0;
                let slice = options.slice && options.slice <= 0 ? 1.0 : options.slice || 1.0;
                const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
                if (slice + sliceStart > 1) {
                    slice = 1 - sliceStart;
                }
                const radius = new Vector3(diameterX / 2, diameterY / 2, diameterZ / 2);
                const totalZRotationSteps = 2 + segments;
                const totalYRotationSegments = 2 * totalZRotationSteps;
                const totalYRotationSteps = totalYRotationSegments + 1;
                const indices = [];
                const positions = [];
                const normals = [];
                const uvs = [];
                for (let zRotationStep = 0; zRotationStep <= totalZRotationSteps; zRotationStep++) {
                    const normalizedZ = zRotationStep / totalZRotationSteps;
                    const angleZ = normalizedZ * Math.PI * slice + sliceStart * Math.PI;
                    for (let yRotationStep = 0; yRotationStep < totalYRotationSteps; yRotationStep++) {
                        const normalizedY = yRotationStep / totalYRotationSegments;
                        const angleY = normalizedY * Math.PI * 2 * arc;
                        const rotationZ = Matrix.RotationZ(-angleZ);
                        const rotationY = Matrix.RotationY(angleY);
                        const afterRotZ = Vector3.TransformCoordinates(Vector3.Up(), rotationZ);
                        const complete = Vector3.TransformCoordinates(afterRotZ, rotationY);
                        const vertex = complete.multiply(radius);
                        const normal = complete.divide(radius).normalize();
                        positions.push(vertex.x, vertex.y, vertex.z);
                        normals.push(normal.x, normal.y, normal.z);
                        uvs.push(normalizedY, 1 - normalizedZ);
                        if (yRotationStep < totalYRotationSegments || arc === 1) {
                            const nextYStep = (yRotationStep + 1) % totalYRotationSteps;
                            if (sliceStart === 0 && zRotationStep === 0) {
                                indices.push(0); // C
                                indices.push(nextYStep); // B
                                indices.push(yRotationStep); // A
                            }
                            else if (zRotationStep > 0) {
                                indices.push((zRotationStep - 1) * totalYRotationSteps + yRotationStep); // C
                                indices.push(zRotationStep * totalYRotationSteps + nextYStep); // B
                                indices.push(zRotationStep * totalYRotationSteps + yRotationStep); // A
                                indices.push((zRotationStep - 1) * totalYRotationSteps + yRotationStep); // C
                                indices.push((zRotationStep - 1) * totalYRotationSteps + nextYStep); // D
                                indices.push(zRotationStep * totalYRotationSteps + nextYStep); // B
                            }
                        }
                    }
                }
                // Sides
                VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
                // Result
                const vertexData = new VertexData();
                vertexData.indices = indices;
                vertexData.positions = positions;
                vertexData.normals = normals;
                vertexData.uvs = uvs;
                return vertexData;
            }
        }
    }

    /**
     * Class containing static functions to help procedurally build meshes
     */
    class TorusBuilder {
        /**
         * Creates a torus mesh
         * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
         * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
         * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
         * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
         * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
         * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
         * @param name defines the name of the mesh
         * @param options defines the options used to create the mesh
         * @param scene defines the hosting scene
         * @returns the torus mesh
         * @see https://doc.babylonjs.com/how_to/set_shapes#torus
         */
        static CreateTorus(name, options, scene) {
            const torus = new Mesh(name, scene);
            options.sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
            torus._originalBuilderSideOrientation = options.sideOrientation;
            const vertexData = createTorus(options);
            vertexData.applyToMesh(torus, options.updatable);
            return torus;
            function createTorus(options) {
                const indices = [];
                const positions = [];
                const normals = [];
                const uvs = [];
                const diameter = options.diameter || 1;
                const thickness = options.thickness || 0.5;
                const tessellation = options.tessellation || 12;
                const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
                let slice = options.slice && options.slice <= 0 ? 1.0 : options.slice || 1.0;
                const sliceStart = options.sliceStart && (options.sliceStart < 0 || options.sliceStart > 1) ? 0 : options.sliceStart || 0;
                const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
                if (slice + sliceStart > 1) {
                    slice = 1 - sliceStart;
                }
                const outerSegments = Math.ceil(tessellation * arc * Math.PI); // Need more segments for the torus circumference
                const innerSegments = Math.ceil(tessellation * slice);
                const closedRing = arc === 1; // handle float errors
                const closedTube = slice === 1;
                const lastOuterRing = outerSegments + 1;
                const lastTubeSection = innerSegments + 1;
                for (let i = 0; i < lastOuterRing; i++) {
                    const u = i / outerSegments;
                    const outerAngle = u * (arc * Math.PI * 2) - Math.PI / 2;
                    const transform = Matrix.Translation(diameter / 2, 0, 0).multiply(Matrix.RotationY(outerAngle));
                    for (let j = 0; j < lastTubeSection; j++) {
                        const v = 1 - j / innerSegments;
                        const innerAngle = (j / innerSegments) * (Math.PI * 2 * slice) + Math.PI * 2 * sliceStart;
                        const dx = Math.cos(innerAngle);
                        const dy = Math.sin(innerAngle);
                        // Create a vertex.
                        let normal = new Vector3(dx, dy, 0);
                        let position = normal.scale(thickness / 2);
                        const textureCoordinate = new Vector2(u, v);
                        position = Vector3.TransformCoordinates(position, transform);
                        normal = Vector3.TransformNormal(normal, transform);
                        positions.push(position.x, position.y, position.z);
                        normals.push(normal.x, normal.y, normal.z);
                        uvs.push(textureCoordinate.x, textureCoordinate.y);
                        if ((i < outerSegments || closedRing) && (j < innerSegments || closedTube)) {
                            // And create indices for two triangles.
                            const nextI = (i + 1) % lastOuterRing;
                            const nextJ = (j + 1) % lastTubeSection;
                            indices.push(i * lastTubeSection + j); // A
                            indices.push(i * lastTubeSection + nextJ); // B
                            indices.push(nextI * lastTubeSection + j); // C
                            indices.push(i * lastTubeSection + nextJ); // B
                            indices.push(nextI * lastTubeSection + nextJ); // D
                            indices.push(nextI * lastTubeSection + j); // C
                        }
                    }
                }
                // Sides
                VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
                // Result
                const vertexData = new VertexData();
                vertexData.indices = indices;
                vertexData.positions = positions;
                vertexData.normals = normals;
                vertexData.uvs = uvs;
                return vertexData;
            }
        }
    }

    function parseSketchGeometry(vertexData) {
        const segments = [];
        const holes = new Map();
        if (vertexData && vertexData.positions && vertexData.paths) {
            const paths = vertexData.paths;
            const holeIndices = new Map();
            if (vertexData.holes) {
                for (let i = 0; i < vertexData.holes.length; i += 2) {
                    holeIndices.set(vertexData.holes[i + 1], vertexData.holes[i]);
                }
            }
            let i = 0;
            let currentHole = null;
            while (i < paths.length) {
                const positions = vertexData.positions;
                const segmentPoints = [];
                currentHole = holeIndices.has(i) ? holeIndices.get(i) : null;
                for (; i < paths.length; i += 2) {
                    segmentPoints.push(Vector3.FromArray(positions, paths[i] * 3));
                    if (paths[i + 2] !== paths[i + 1]) {
                        segmentPoints.push(Vector3.FromArray(positions, paths[i + 1] * 3));
                        i += 2;
                        break;
                    }
                }
                if (segmentPoints.length > 1) {
                    if (currentHole !== null) {
                        let currentHolePoints = holes.get(currentHole);
                        if (!currentHolePoints) {
                            currentHolePoints = [];
                            holes.set(currentHole, currentHolePoints);
                        }
                        currentHolePoints.push(segmentPoints);
                    }
                    else {
                        segments.push(segmentPoints);
                    }
                }
            }
        }
        return { segments, holes };
    }
    function createSketchPointForEditor(manager, path, insertIndex) {
        if (!path._parent) {
            throw new Error('Cannot create a sketch point for a path that has no parent sketch');
        }
        const sketch = path._parent;
        const c = manager.create(Token.SketchControlPoint);
        c.name = 'Control Point';
        while (path.controlPoints.find(ec => ec.name === c.name)) {
            c.name = appendOrIncrementNumber(c.name);
        }
        let previousControlPoint;
        if (!insertIndex) {
            // If insert index is zero or undefined, determine the previous control point and use its position for the new control point
            if (path.controlPoints.length > 0 && insertIndex === undefined) {
                previousControlPoint = path.controlPoints[path.controlPoints.length - 1];
            }
            else {
                const currentPathIndex = sketch.paths.findIndex(p => p._dynamicId === path._dynamicId);
                if (currentPathIndex > 0) {
                    const previousPath = sketch.paths[currentPathIndex - 1];
                    if (previousPath.controlPoints.length > 0) {
                        previousControlPoint = previousPath.controlPoints[previousPath.controlPoints.length - 1];
                    }
                }
            }
        }
        else {
            previousControlPoint = path.controlPoints[insertIndex];
        }
        const sketchNormal = getSketchNormalVector3(sketch.normal);
        // determine the axis making up the sketch plane so we can make sure the direction vectors are on the sketch plane
        let axis1;
        if (sketchNormal.equalsWithEpsilon(Vector3.Forward()) || sketchNormal.equalsWithEpsilon(Vector3.Backward())) {
            axis1 = Vector3.Up();
        }
        else {
            axis1 = Vector3.Cross(sketchNormal, Vector3.Forward());
        }
        const axis2 = Vector3.Cross(sketchNormal, axis1);
        if (previousControlPoint) {
            // if therre is a previous control point, project its direction onto the sketch plane
            c.position = previousControlPoint.position.clone();
            const rawDirection = previousControlPoint.direction.toVec3();
            const projectedDirection = axis1
                .scale(Vector3.Dot(axis1, rawDirection))
                .add(axis2.scale(Vector3.Dot(axis2, rawDirection)));
            c.direction = exports.KbVector.FromVec3(projectedDirection);
        }
        else {
            // if this is the first control point, just pick a direction vector on the sketch plane
            c.direction = exports.KbVector.FromVec3(axis1);
        }
        c.direction2 = c.direction.scale(-1);
        if (insertIndex === undefined) {
            path.controlPoints.push(c);
        }
        else {
            path.controlPoints.splice(insertIndex, 0, c);
        }
        for (const eC of path.controlPoints) {
            eC._expanded = false;
        }
        c._visible = true;
        c._expanded = true;
        return c;
    }
    function getSketchNormalVector3(normal) {
        let planeNormal;
        switch (normal) {
            case exports.eAxis.x:
                planeNormal = Vector3.Right();
                break;
            case exports.eAxis.y:
                planeNormal = Vector3.Up();
                break;
            case exports.eAxis.z:
                planeNormal = Vector3.Forward();
                break;
            default:
                planeNormal = normal.toVec3();
        }
        planeNormal.normalize();
        return planeNormal;
    }
    function projectOnNodeAxis(node, x, y) {
        switch (node.normal) {
            case exports.eAxis.y:
                return new exports.KbVector(x, 0, -y);
            case exports.eAxis.z:
                return new exports.KbVector(-x, y, 0);
            default:
                return new exports.KbVector(0, y, x);
        }
    }
    function axisToVector3(axis) {
        switch (axis) {
            case exports.eAxis.y:
                return Vector3.Up();
            case exports.eAxis.z:
                return Vector3.Forward();
            default:
                return Vector3.Right();
        }
    }
    /**
     * returns the vertices in the order of positionVectors in sequence, followed by holePositions in sequence!
     * Indices will have to be recalculated if the vertex data is replaced with the results of this function.
     */
    function fillSketchPolygon(positionVectors, flipNormals, sketchNativeNormal, holePositions) {
        const sketchNormal = getPolygonNormal(positionVectors);
        if (flipNormals) {
            sketchNormal.scaleInPlace(-1);
        }
        // const geometryNormal = sketchNormal.scale(-1);
        const segmentPositions = [];
        let segmentIndices = [];
        for (let i = 0; i < positionVectors.length; i++) {
            const point = positionVectors[i];
            segmentPositions.push(point.x, point.y, point.z);
        }
        const holes = [];
        if (holePositions) {
            for (let i = 0; i < holePositions.length; i++) {
                const hole = holePositions[i];
                holes.push(segmentPositions.length / 3);
                for (let i = 0; i < hole.length; i++) {
                    const point = hole[i];
                    segmentPositions.push(point.x, point.y, point.z);
                }
            }
        }
        if (Math.abs(Vector3.Dot(sketchNormal, Vector3.UpReadOnly)) > 0.95) {
            const flatPositions = new Float32Array((segmentPositions.length * 2) / 3);
            const xAxis = Vector3.Cross(sketchNormal, new Vector3(0, 0, 1));
            const yAxis = Vector3.Cross(sketchNormal, xAxis);
            const working = new Vector3();
            for (let i = 0; i < segmentPositions.length; i += 3) {
                working.set(segmentPositions[i], segmentPositions[i + 1], segmentPositions[i + 2]);
                flatPositions.set([Vector3.Dot(working, xAxis), Vector3.Dot(working, yAxis)], (i * 2) / 3);
            }
            const faceNormal = calculateFaceNormalFromFloats(flatPositions, 2);
            if (Vector3.Dot(faceNormal, Vector3.RightHandedForwardReadOnly) < 0) {
                for (let i = 0; i < flatPositions.length; i += 2) {
                    const tmp = flatPositions[i];
                    flatPositions[i] = flatPositions[i + 1];
                    flatPositions[i + 1] = tmp;
                }
                // geometryNormal.scaleInPlace(-1);
            }
            segmentIndices = earcut$1(flatPositions, holes, 2);
        }
        else {
            segmentIndices = earcut$1(segmentPositions, holes, 3);
            // Flip the geometry if needed so that it faces the same direction as the faces because earcut isn't aware of the 3d space
            const faceNormal = calculateFaceNormal(positionVectors);
            // If the rotation handedness is opposite the primary sketch vector, then flip the sketch path
            if (Vector3.Dot(faceNormal, sketchNativeNormal) < 0) {
                for (let i = 0; i < segmentIndices.length; i += 3) {
                    const tmp = segmentIndices[i];
                    segmentIndices[i] = segmentIndices[i + 2];
                    segmentIndices[i + 2] = tmp;
                }
                // geometryNormal.scaleInPlace(-1);
            }
        }
        const segmentNormals = [];
        const geometryNormal = calculateFaceNormal(positionVectors);
        if (flipNormals) {
            geometryNormal.scaleInPlace(-1);
        }
        let totalVectorCount = positionVectors.length;
        if (holePositions) {
            totalVectorCount += holePositions.flat().length;
        }
        for (let i = 0; i < totalVectorCount; i++) {
            segmentNormals.push(geometryNormal.x, geometryNormal.y, geometryNormal.z);
        }
        const segmentUvs = [];
        for (let i = 0; i < totalVectorCount; i++) {
            segmentUvs.push(0, 0);
        }
        return {
            normals: segmentNormals,
            positions: segmentPositions,
            indices: segmentIndices,
            uvs: segmentUvs,
        };
    }
    function calculateFaceNormal(positionVectors) {
        const v1 = Vector3.Zero();
        const v2 = Vector3.Zero();
        const barycenter = Vector3.Zero();
        for (let i = 0; i < positionVectors.length; i++) {
            barycenter.addInPlace(positionVectors[i]);
        }
        barycenter.scaleInPlace(1 / positionVectors.length);
        const pathHandedness = Vector3.Zero();
        if (positionVectors.length > 1) {
            for (let iP = 0; iP < positionVectors.length - 1; iP++) {
                const point1 = positionVectors[iP];
                v1.copyFromFloats(point1.x, point1.y, point1.z);
                v1.subtractInPlace(barycenter);
                const point2 = positionVectors[iP + 1];
                v2.copyFromFloats(point2.x, point2.y, point2.z);
                v2.subtractInPlace(barycenter);
                pathHandedness.addInPlace(Vector3.Cross(v1, v2));
            }
            return pathHandedness.normalize();
        }
        return Vector3.Zero();
    }
    function calculateFaceNormalFromFloats(points, dim) {
        const v1 = Vector3.Zero();
        const v2 = Vector3.Zero();
        const barycenter = Vector3.Zero();
        for (let i = 0; i < points.length; i += dim) {
            barycenter.addInPlaceFromFloats(points[i], points[i + 1], dim === 3 ? points[i + 2] : 0);
        }
        barycenter.scaleInPlace(3 / points.length);
        const pathHandedness = Vector3.Zero();
        if (points.length > 3) {
            for (let i = 0; i < points.length - dim; i += dim) {
                v1.copyFromFloats(points[i], points[i + 1], dim === 3 ? points[i + 2] : 0);
                v1.subtractInPlace(barycenter);
                v2.copyFromFloats(points[i + dim], points[i + dim + 1], dim === 3 ? points[i + dim + 2] : 0);
                v2.subtractInPlace(barycenter);
                pathHandedness.addInPlace(Vector3.Cross(v1, v2));
            }
            return pathHandedness.normalize();
        }
        return Vector3.Zero();
    }

    /**
     * https://opentype.js.org v1.3.4 | (c) Frederik De Bleser and other contributors | MIT License | Uses tiny-inflate by Devon Govett and string.prototype.codepointat polyfill by Mathias Bynens
     */

    /*! https://mths.be/codepointat v0.2.0 by @mathias */
    if (!String.prototype.codePointAt) {
    	(function() {
    		var defineProperty = (function() {
    			// IE 8 only supports `Object.defineProperty` on DOM elements
    			try {
    				var object = {};
    				var $defineProperty = Object.defineProperty;
    				var result = $defineProperty(object, object, object) && $defineProperty;
    			} catch(error) {}
    			return result;
    		}());
    		var codePointAt = function(position) {
    			if (this == null) {
    				throw TypeError();
    			}
    			var string = String(this);
    			var size = string.length;
    			// `ToInteger`
    			var index = position ? Number(position) : 0;
    			if (index != index) { // better `isNaN`
    				index = 0;
    			}
    			// Account for out-of-bounds indices:
    			if (index < 0 || index >= size) {
    				return undefined;
    			}
    			// Get the first code unit
    			var first = string.charCodeAt(index);
    			var second;
    			if ( // check if it’s the start of a surrogate pair
    				first >= 0xD800 && first <= 0xDBFF && // high surrogate
    				size > index + 1 // there is a next code unit
    			) {
    				second = string.charCodeAt(index + 1);
    				if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
    					// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    					return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    				}
    			}
    			return first;
    		};
    		if (defineProperty) {
    			defineProperty(String.prototype, 'codePointAt', {
    				'value': codePointAt,
    				'configurable': true,
    				'writable': true
    			});
    		} else {
    			String.prototype.codePointAt = codePointAt;
    		}
    	}());
    }

    var TINF_OK = 0;
    var TINF_DATA_ERROR = -3;

    function Tree() {
      this.table = new Uint16Array(16);   /* table of code length counts */
      this.trans = new Uint16Array(288);  /* code -> symbol translation table */
    }

    function Data(source, dest) {
      this.source = source;
      this.sourceIndex = 0;
      this.tag = 0;
      this.bitcount = 0;
      
      this.dest = dest;
      this.destLen = 0;
      
      this.ltree = new Tree();  /* dynamic length/symbol tree */
      this.dtree = new Tree();  /* dynamic distance tree */
    }

    /* --------------------------------------------------- *
     * -- uninitialized global data (static structures) -- *
     * --------------------------------------------------- */

    var sltree = new Tree();
    var sdtree = new Tree();

    /* extra bits and base tables for length codes */
    var length_bits = new Uint8Array(30);
    var length_base = new Uint16Array(30);

    /* extra bits and base tables for distance codes */
    var dist_bits = new Uint8Array(30);
    var dist_base = new Uint16Array(30);

    /* special ordering of code length codes */
    var clcidx = new Uint8Array([
      16, 17, 18, 0, 8, 7, 9, 6,
      10, 5, 11, 4, 12, 3, 13, 2,
      14, 1, 15
    ]);

    /* used by tinf_decode_trees, avoids allocations every call */
    var code_tree = new Tree();
    var lengths = new Uint8Array(288 + 32);

    /* ----------------------- *
     * -- utility functions -- *
     * ----------------------- */

    /* build extra bits and base tables */
    function tinf_build_bits_base(bits, base, delta, first) {
      var i, sum;

      /* build bits table */
      for (i = 0; i < delta; ++i) { bits[i] = 0; }
      for (i = 0; i < 30 - delta; ++i) { bits[i + delta] = i / delta | 0; }

      /* build base table */
      for (sum = first, i = 0; i < 30; ++i) {
        base[i] = sum;
        sum += 1 << bits[i];
      }
    }

    /* build the fixed huffman trees */
    function tinf_build_fixed_trees(lt, dt) {
      var i;

      /* build fixed length tree */
      for (i = 0; i < 7; ++i) { lt.table[i] = 0; }

      lt.table[7] = 24;
      lt.table[8] = 152;
      lt.table[9] = 112;

      for (i = 0; i < 24; ++i) { lt.trans[i] = 256 + i; }
      for (i = 0; i < 144; ++i) { lt.trans[24 + i] = i; }
      for (i = 0; i < 8; ++i) { lt.trans[24 + 144 + i] = 280 + i; }
      for (i = 0; i < 112; ++i) { lt.trans[24 + 144 + 8 + i] = 144 + i; }

      /* build fixed distance tree */
      for (i = 0; i < 5; ++i) { dt.table[i] = 0; }

      dt.table[5] = 32;

      for (i = 0; i < 32; ++i) { dt.trans[i] = i; }
    }

    /* given an array of code lengths, build a tree */
    var offs = new Uint16Array(16);

    function tinf_build_tree(t, lengths, off, num) {
      var i, sum;

      /* clear code length count table */
      for (i = 0; i < 16; ++i) { t.table[i] = 0; }

      /* scan symbol lengths, and sum code length counts */
      for (i = 0; i < num; ++i) { t.table[lengths[off + i]]++; }

      t.table[0] = 0;

      /* compute offset table for distribution sort */
      for (sum = 0, i = 0; i < 16; ++i) {
        offs[i] = sum;
        sum += t.table[i];
      }

      /* create code->symbol translation table (symbols sorted by code) */
      for (i = 0; i < num; ++i) {
        if (lengths[off + i]) { t.trans[offs[lengths[off + i]]++] = i; }
      }
    }

    /* ---------------------- *
     * -- decode functions -- *
     * ---------------------- */

    /* get one bit from source stream */
    function tinf_getbit(d) {
      /* check if tag is empty */
      if (!d.bitcount--) {
        /* load next tag */
        d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
      }

      /* shift bit out of tag */
      var bit = d.tag & 1;
      d.tag >>>= 1;

      return bit;
    }

    /* read a num bit value from a stream and add base */
    function tinf_read_bits(d, num, base) {
      if (!num)
        { return base; }

      while (d.bitcount < 24) {
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
      }

      var val = d.tag & (0xffff >>> (16 - num));
      d.tag >>>= num;
      d.bitcount -= num;
      return val + base;
    }

    /* given a data stream and a tree, decode a symbol */
    function tinf_decode_symbol(d, t) {
      while (d.bitcount < 24) {
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
      }
      
      var sum = 0, cur = 0, len = 0;
      var tag = d.tag;

      /* get more bits while code value is above sum */
      do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;

        sum += t.table[len];
        cur -= t.table[len];
      } while (cur >= 0);
      
      d.tag = tag;
      d.bitcount -= len;

      return t.trans[sum + cur];
    }

    /* given a data stream, decode dynamic trees from it */
    function tinf_decode_trees(d, lt, dt) {
      var hlit, hdist, hclen;
      var i, num, length;

      /* get 5 bits HLIT (257-286) */
      hlit = tinf_read_bits(d, 5, 257);

      /* get 5 bits HDIST (1-32) */
      hdist = tinf_read_bits(d, 5, 1);

      /* get 4 bits HCLEN (4-19) */
      hclen = tinf_read_bits(d, 4, 4);

      for (i = 0; i < 19; ++i) { lengths[i] = 0; }

      /* read code lengths for code length alphabet */
      for (i = 0; i < hclen; ++i) {
        /* get 3 bits code length (0-7) */
        var clen = tinf_read_bits(d, 3, 0);
        lengths[clcidx[i]] = clen;
      }

      /* build code length tree */
      tinf_build_tree(code_tree, lengths, 0, 19);

      /* decode code lengths for the dynamic trees */
      for (num = 0; num < hlit + hdist;) {
        var sym = tinf_decode_symbol(d, code_tree);

        switch (sym) {
          case 16:
            /* copy previous code length 3-6 times (read 2 bits) */
            var prev = lengths[num - 1];
            for (length = tinf_read_bits(d, 2, 3); length; --length) {
              lengths[num++] = prev;
            }
            break;
          case 17:
            /* repeat code length 0 for 3-10 times (read 3 bits) */
            for (length = tinf_read_bits(d, 3, 3); length; --length) {
              lengths[num++] = 0;
            }
            break;
          case 18:
            /* repeat code length 0 for 11-138 times (read 7 bits) */
            for (length = tinf_read_bits(d, 7, 11); length; --length) {
              lengths[num++] = 0;
            }
            break;
          default:
            /* values 0-15 represent the actual code lengths */
            lengths[num++] = sym;
            break;
        }
      }

      /* build dynamic trees */
      tinf_build_tree(lt, lengths, 0, hlit);
      tinf_build_tree(dt, lengths, hlit, hdist);
    }

    /* ----------------------------- *
     * -- block inflate functions -- *
     * ----------------------------- */

    /* given a stream and two trees, inflate a block of data */
    function tinf_inflate_block_data(d, lt, dt) {
      while (1) {
        var sym = tinf_decode_symbol(d, lt);

        /* check for end of block */
        if (sym === 256) {
          return TINF_OK;
        }

        if (sym < 256) {
          d.dest[d.destLen++] = sym;
        } else {
          var length, dist, offs;
          var i;

          sym -= 257;

          /* possibly get more bits from length code */
          length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

          dist = tinf_decode_symbol(d, dt);

          /* possibly get more bits from distance code */
          offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

          /* copy match */
          for (i = offs; i < offs + length; ++i) {
            d.dest[d.destLen++] = d.dest[i];
          }
        }
      }
    }

    /* inflate an uncompressed block of data */
    function tinf_inflate_uncompressed_block(d) {
      var length, invlength;
      var i;
      
      /* unread from bitbuffer */
      while (d.bitcount > 8) {
        d.sourceIndex--;
        d.bitcount -= 8;
      }

      /* get length */
      length = d.source[d.sourceIndex + 1];
      length = 256 * length + d.source[d.sourceIndex];

      /* get one's complement of length */
      invlength = d.source[d.sourceIndex + 3];
      invlength = 256 * invlength + d.source[d.sourceIndex + 2];

      /* check length */
      if (length !== (~invlength & 0x0000ffff))
        { return TINF_DATA_ERROR; }

      d.sourceIndex += 4;

      /* copy block */
      for (i = length; i; --i)
        { d.dest[d.destLen++] = d.source[d.sourceIndex++]; }

      /* make sure we start next block on a byte boundary */
      d.bitcount = 0;

      return TINF_OK;
    }

    /* inflate stream from source to dest */
    function tinf_uncompress(source, dest) {
      var d = new Data(source, dest);
      var bfinal, btype, res;

      do {
        /* read final block flag */
        bfinal = tinf_getbit(d);

        /* read block type (2 bits) */
        btype = tinf_read_bits(d, 2, 0);

        /* decompress block */
        switch (btype) {
          case 0:
            /* decompress uncompressed block */
            res = tinf_inflate_uncompressed_block(d);
            break;
          case 1:
            /* decompress block with fixed huffman trees */
            res = tinf_inflate_block_data(d, sltree, sdtree);
            break;
          case 2:
            /* decompress block with dynamic huffman trees */
            tinf_decode_trees(d, d.ltree, d.dtree);
            res = tinf_inflate_block_data(d, d.ltree, d.dtree);
            break;
          default:
            res = TINF_DATA_ERROR;
        }

        if (res !== TINF_OK)
          { throw new Error('Data error'); }

      } while (!bfinal);

      if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function')
          { return d.dest.slice(0, d.destLen); }
        else
          { return d.dest.subarray(0, d.destLen); }
      }
      
      return d.dest;
    }

    /* -------------------- *
     * -- initialization -- *
     * -------------------- */

    /* build fixed huffman trees */
    tinf_build_fixed_trees(sltree, sdtree);

    /* build extra bits and base tables */
    tinf_build_bits_base(length_bits, length_base, 4, 3);
    tinf_build_bits_base(dist_bits, dist_base, 2, 1);

    /* fix a special case */
    length_bits[28] = 0;
    length_base[28] = 258;

    var tinyInflate = tinf_uncompress;

    // The Bounding Box object

    function derive(v0, v1, v2, v3, t) {
        return Math.pow(1 - t, 3) * v0 +
            3 * Math.pow(1 - t, 2) * t * v1 +
            3 * (1 - t) * Math.pow(t, 2) * v2 +
            Math.pow(t, 3) * v3;
    }
    /**
     * A bounding box is an enclosing box that describes the smallest measure within which all the points lie.
     * It is used to calculate the bounding box of a glyph or text path.
     *
     * On initialization, x1/y1/x2/y2 will be NaN. Check if the bounding box is empty using `isEmpty()`.
     *
     * @exports opentype.BoundingBox
     * @class
     * @constructor
     */
    function BoundingBox$1() {
        this.x1 = Number.NaN;
        this.y1 = Number.NaN;
        this.x2 = Number.NaN;
        this.y2 = Number.NaN;
    }

    /**
     * Returns true if the bounding box is empty, that is, no points have been added to the box yet.
     */
    BoundingBox$1.prototype.isEmpty = function() {
        return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
    };

    /**
     * Add the point to the bounding box.
     * The x1/y1/x2/y2 coordinates of the bounding box will now encompass the given point.
     * @param {number} x - The X coordinate of the point.
     * @param {number} y - The Y coordinate of the point.
     */
    BoundingBox$1.prototype.addPoint = function(x, y) {
        if (typeof x === 'number') {
            if (isNaN(this.x1) || isNaN(this.x2)) {
                this.x1 = x;
                this.x2 = x;
            }
            if (x < this.x1) {
                this.x1 = x;
            }
            if (x > this.x2) {
                this.x2 = x;
            }
        }
        if (typeof y === 'number') {
            if (isNaN(this.y1) || isNaN(this.y2)) {
                this.y1 = y;
                this.y2 = y;
            }
            if (y < this.y1) {
                this.y1 = y;
            }
            if (y > this.y2) {
                this.y2 = y;
            }
        }
    };

    /**
     * Add a X coordinate to the bounding box.
     * This extends the bounding box to include the X coordinate.
     * This function is used internally inside of addBezier.
     * @param {number} x - The X coordinate of the point.
     */
    BoundingBox$1.prototype.addX = function(x) {
        this.addPoint(x, null);
    };

    /**
     * Add a Y coordinate to the bounding box.
     * This extends the bounding box to include the Y coordinate.
     * This function is used internally inside of addBezier.
     * @param {number} y - The Y coordinate of the point.
     */
    BoundingBox$1.prototype.addY = function(y) {
        this.addPoint(null, y);
    };

    /**
     * Add a Bézier curve to the bounding box.
     * This extends the bounding box to include the entire Bézier.
     * @param {number} x0 - The starting X coordinate.
     * @param {number} y0 - The starting Y coordinate.
     * @param {number} x1 - The X coordinate of the first control point.
     * @param {number} y1 - The Y coordinate of the first control point.
     * @param {number} x2 - The X coordinate of the second control point.
     * @param {number} y2 - The Y coordinate of the second control point.
     * @param {number} x - The ending X coordinate.
     * @param {number} y - The ending Y coordinate.
     */
    BoundingBox$1.prototype.addBezier = function(x0, y0, x1, y1, x2, y2, x, y) {
        // This code is based on http://nishiohirokazu.blogspot.com/2009/06/how-to-calculate-bezier-curves-bounding.html
        // and https://github.com/icons8/svg-path-bounding-box

        var p0 = [x0, y0];
        var p1 = [x1, y1];
        var p2 = [x2, y2];
        var p3 = [x, y];

        this.addPoint(x0, y0);
        this.addPoint(x, y);

        for (var i = 0; i <= 1; i++) {
            var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            var c = 3 * p1[i] - 3 * p0[i];

            if (a === 0) {
                if (b === 0) { continue; }
                var t = -c / b;
                if (0 < t && t < 1) {
                    if (i === 0) { this.addX(derive(p0[i], p1[i], p2[i], p3[i], t)); }
                    if (i === 1) { this.addY(derive(p0[i], p1[i], p2[i], p3[i], t)); }
                }
                continue;
            }

            var b2ac = Math.pow(b, 2) - 4 * c * a;
            if (b2ac < 0) { continue; }
            var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
            if (0 < t1 && t1 < 1) {
                if (i === 0) { this.addX(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
                if (i === 1) { this.addY(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
            }
            var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
            if (0 < t2 && t2 < 1) {
                if (i === 0) { this.addX(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
                if (i === 1) { this.addY(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
            }
        }
    };

    /**
     * Add a quadratic curve to the bounding box.
     * This extends the bounding box to include the entire quadratic curve.
     * @param {number} x0 - The starting X coordinate.
     * @param {number} y0 - The starting Y coordinate.
     * @param {number} x1 - The X coordinate of the control point.
     * @param {number} y1 - The Y coordinate of the control point.
     * @param {number} x - The ending X coordinate.
     * @param {number} y - The ending Y coordinate.
     */
    BoundingBox$1.prototype.addQuad = function(x0, y0, x1, y1, x, y) {
        var cp1x = x0 + 2 / 3 * (x1 - x0);
        var cp1y = y0 + 2 / 3 * (y1 - y0);
        var cp2x = cp1x + 1 / 3 * (x - x0);
        var cp2y = cp1y + 1 / 3 * (y - y0);
        this.addBezier(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y);
    };

    // Geometric objects

    /**
     * A bézier path containing a set of path commands similar to a SVG path.
     * Paths can be drawn on a context using `draw`.
     * @exports opentype.Path
     * @class
     * @constructor
     */
    function Path() {
        this.commands = [];
        this.fill = 'black';
        this.stroke = null;
        this.strokeWidth = 1;
    }

    /**
     * @param  {number} x
     * @param  {number} y
     */
    Path.prototype.moveTo = function(x, y) {
        this.commands.push({
            type: 'M',
            x: x,
            y: y
        });
    };

    /**
     * @param  {number} x
     * @param  {number} y
     */
    Path.prototype.lineTo = function(x, y) {
        this.commands.push({
            type: 'L',
            x: x,
            y: y
        });
    };

    /**
     * Draws cubic curve
     * @function
     * curveTo
     * @memberof opentype.Path.prototype
     * @param  {number} x1 - x of control 1
     * @param  {number} y1 - y of control 1
     * @param  {number} x2 - x of control 2
     * @param  {number} y2 - y of control 2
     * @param  {number} x - x of path point
     * @param  {number} y - y of path point
     */

    /**
     * Draws cubic curve
     * @function
     * bezierCurveTo
     * @memberof opentype.Path.prototype
     * @param  {number} x1 - x of control 1
     * @param  {number} y1 - y of control 1
     * @param  {number} x2 - x of control 2
     * @param  {number} y2 - y of control 2
     * @param  {number} x - x of path point
     * @param  {number} y - y of path point
     * @see curveTo
     */
    Path.prototype.curveTo = Path.prototype.bezierCurveTo = function(x1, y1, x2, y2, x, y) {
        this.commands.push({
            type: 'C',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            x: x,
            y: y
        });
    };

    /**
     * Draws quadratic curve
     * @function
     * quadraticCurveTo
     * @memberof opentype.Path.prototype
     * @param  {number} x1 - x of control
     * @param  {number} y1 - y of control
     * @param  {number} x - x of path point
     * @param  {number} y - y of path point
     */

    /**
     * Draws quadratic curve
     * @function
     * quadTo
     * @memberof opentype.Path.prototype
     * @param  {number} x1 - x of control
     * @param  {number} y1 - y of control
     * @param  {number} x - x of path point
     * @param  {number} y - y of path point
     */
    Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function(x1, y1, x, y) {
        this.commands.push({
            type: 'Q',
            x1: x1,
            y1: y1,
            x: x,
            y: y
        });
    };

    /**
     * Closes the path
     * @function closePath
     * @memberof opentype.Path.prototype
     */

    /**
     * Close the path
     * @function close
     * @memberof opentype.Path.prototype
     */
    Path.prototype.close = Path.prototype.closePath = function() {
        this.commands.push({
            type: 'Z'
        });
    };

    /**
     * Add the given path or list of commands to the commands of this path.
     * @param  {Array} pathOrCommands - another opentype.Path, an opentype.BoundingBox, or an array of commands.
     */
    Path.prototype.extend = function(pathOrCommands) {
        if (pathOrCommands.commands) {
            pathOrCommands = pathOrCommands.commands;
        } else if (pathOrCommands instanceof BoundingBox$1) {
            var box = pathOrCommands;
            this.moveTo(box.x1, box.y1);
            this.lineTo(box.x2, box.y1);
            this.lineTo(box.x2, box.y2);
            this.lineTo(box.x1, box.y2);
            this.close();
            return;
        }

        Array.prototype.push.apply(this.commands, pathOrCommands);
    };

    /**
     * Calculate the bounding box of the path.
     * @returns {opentype.BoundingBox}
     */
    Path.prototype.getBoundingBox = function() {
        var box = new BoundingBox$1();

        var startX = 0;
        var startY = 0;
        var prevX = 0;
        var prevY = 0;
        for (var i = 0; i < this.commands.length; i++) {
            var cmd = this.commands[i];
            switch (cmd.type) {
                case 'M':
                    box.addPoint(cmd.x, cmd.y);
                    startX = prevX = cmd.x;
                    startY = prevY = cmd.y;
                    break;
                case 'L':
                    box.addPoint(cmd.x, cmd.y);
                    prevX = cmd.x;
                    prevY = cmd.y;
                    break;
                case 'Q':
                    box.addQuad(prevX, prevY, cmd.x1, cmd.y1, cmd.x, cmd.y);
                    prevX = cmd.x;
                    prevY = cmd.y;
                    break;
                case 'C':
                    box.addBezier(prevX, prevY, cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
                    prevX = cmd.x;
                    prevY = cmd.y;
                    break;
                case 'Z':
                    prevX = startX;
                    prevY = startY;
                    break;
                default:
                    throw new Error('Unexpected path command ' + cmd.type);
            }
        }
        if (box.isEmpty()) {
            box.addPoint(0, 0);
        }
        return box;
    };

    /**
     * Draw the path to a 2D context.
     * @param {CanvasRenderingContext2D} ctx - A 2D drawing context.
     */
    Path.prototype.draw = function(ctx) {
        ctx.beginPath();
        for (var i = 0; i < this.commands.length; i += 1) {
            var cmd = this.commands[i];
            if (cmd.type === 'M') {
                ctx.moveTo(cmd.x, cmd.y);
            } else if (cmd.type === 'L') {
                ctx.lineTo(cmd.x, cmd.y);
            } else if (cmd.type === 'C') {
                ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
            } else if (cmd.type === 'Q') {
                ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
            } else if (cmd.type === 'Z') {
                ctx.closePath();
            }
        }

        if (this.fill) {
            ctx.fillStyle = this.fill;
            ctx.fill();
        }

        if (this.stroke) {
            ctx.strokeStyle = this.stroke;
            ctx.lineWidth = this.strokeWidth;
            ctx.stroke();
        }
    };

    /**
     * Convert the Path to a string of path data instructions
     * See http://www.w3.org/TR/SVG/paths.html#PathData
     * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
     * @return {string}
     */
    Path.prototype.toPathData = function(decimalPlaces) {
        decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;

        function floatToString(v) {
            if (Math.round(v) === v) {
                return '' + Math.round(v);
            } else {
                return v.toFixed(decimalPlaces);
            }
        }

        function packValues() {
            var arguments$1 = arguments;

            var s = '';
            for (var i = 0; i < arguments.length; i += 1) {
                var v = arguments$1[i];
                if (v >= 0 && i > 0) {
                    s += ' ';
                }

                s += floatToString(v);
            }

            return s;
        }

        var d = '';
        for (var i = 0; i < this.commands.length; i += 1) {
            var cmd = this.commands[i];
            if (cmd.type === 'M') {
                d += 'M' + packValues(cmd.x, cmd.y);
            } else if (cmd.type === 'L') {
                d += 'L' + packValues(cmd.x, cmd.y);
            } else if (cmd.type === 'C') {
                d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
            } else if (cmd.type === 'Q') {
                d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
            } else if (cmd.type === 'Z') {
                d += 'Z';
            }
        }

        return d;
    };

    /**
     * Convert the path to an SVG <path> element, as a string.
     * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
     * @return {string}
     */
    Path.prototype.toSVG = function(decimalPlaces) {
        var svg = '<path d="';
        svg += this.toPathData(decimalPlaces);
        svg += '"';
        if (this.fill && this.fill !== 'black') {
            if (this.fill === null) {
                svg += ' fill="none"';
            } else {
                svg += ' fill="' + this.fill + '"';
            }
        }

        if (this.stroke) {
            svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
        }

        svg += '/>';
        return svg;
    };

    /**
     * Convert the path to a DOM element.
     * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
     * @return {SVGPathElement}
     */
    Path.prototype.toDOMElement = function(decimalPlaces) {
        var temporaryPath = this.toPathData(decimalPlaces);
        var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

        newPath.setAttribute('d', temporaryPath);

        return newPath;
    };

    // Run-time checking of preconditions.

    function fail(message) {
        throw new Error(message);
    }

    // Precondition function that checks if the given predicate is true.
    // If not, it will throw an error.
    function argument(predicate, message) {
        if (!predicate) {
            fail(message);
        }
    }
    var check = { fail: fail, argument: argument, assert: argument };

    // Data types used in the OpenType font file.

    var LIMIT16 = 32768; // The limit at which a 16-bit number switches signs == 2^15
    var LIMIT32 = 2147483648; // The limit at which a 32-bit number switches signs == 2 ^ 31

    /**
     * @exports opentype.decode
     * @class
     */
    var decode = {};
    /**
     * @exports opentype.encode
     * @class
     */
    var encode = {};
    /**
     * @exports opentype.sizeOf
     * @class
     */
    var sizeOf = {};

    // Return a function that always returns the same value.
    function constant(v) {
        return function() {
            return v;
        };
    }

    // OpenType data types //////////////////////////////////////////////////////

    /**
     * Convert an 8-bit unsigned integer to a list of 1 byte.
     * @param {number}
     * @returns {Array}
     */
    encode.BYTE = function(v) {
        check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
        return [v];
    };
    /**
     * @constant
     * @type {number}
     */
    sizeOf.BYTE = constant(1);

    /**
     * Convert a 8-bit signed integer to a list of 1 byte.
     * @param {string}
     * @returns {Array}
     */
    encode.CHAR = function(v) {
        return [v.charCodeAt(0)];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.CHAR = constant(1);

    /**
     * Convert an ASCII string to a list of bytes.
     * @param {string}
     * @returns {Array}
     */
    encode.CHARARRAY = function(v) {
        if (typeof v === 'undefined') {
            v = '';
            console.warn('Undefined CHARARRAY encountered and treated as an empty string. This is probably caused by a missing glyph name.');
        }
        var b = [];
        for (var i = 0; i < v.length; i += 1) {
            b[i] = v.charCodeAt(i);
        }

        return b;
    };

    /**
     * @param {Array}
     * @returns {number}
     */
    sizeOf.CHARARRAY = function(v) {
        if (typeof v === 'undefined') {
            return 0;
        }
        return v.length;
    };

    /**
     * Convert a 16-bit unsigned integer to a list of 2 bytes.
     * @param {number}
     * @returns {Array}
     */
    encode.USHORT = function(v) {
        return [(v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.USHORT = constant(2);

    /**
     * Convert a 16-bit signed integer to a list of 2 bytes.
     * @param {number}
     * @returns {Array}
     */
    encode.SHORT = function(v) {
        // Two's complement
        if (v >= LIMIT16) {
            v = -(2 * LIMIT16 - v);
        }

        return [(v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.SHORT = constant(2);

    /**
     * Convert a 24-bit unsigned integer to a list of 3 bytes.
     * @param {number}
     * @returns {Array}
     */
    encode.UINT24 = function(v) {
        return [(v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.UINT24 = constant(3);

    /**
     * Convert a 32-bit unsigned integer to a list of 4 bytes.
     * @param {number}
     * @returns {Array}
     */
    encode.ULONG = function(v) {
        return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.ULONG = constant(4);

    /**
     * Convert a 32-bit unsigned integer to a list of 4 bytes.
     * @param {number}
     * @returns {Array}
     */
    encode.LONG = function(v) {
        // Two's complement
        if (v >= LIMIT32) {
            v = -(2 * LIMIT32 - v);
        }

        return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.LONG = constant(4);

    encode.FIXED = encode.ULONG;
    sizeOf.FIXED = sizeOf.ULONG;

    encode.FWORD = encode.SHORT;
    sizeOf.FWORD = sizeOf.SHORT;

    encode.UFWORD = encode.USHORT;
    sizeOf.UFWORD = sizeOf.USHORT;

    /**
     * Convert a 32-bit Apple Mac timestamp integer to a list of 8 bytes, 64-bit timestamp.
     * @param {number}
     * @returns {Array}
     */
    encode.LONGDATETIME = function(v) {
        return [0, 0, 0, 0, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.LONGDATETIME = constant(8);

    /**
     * Convert a 4-char tag to a list of 4 bytes.
     * @param {string}
     * @returns {Array}
     */
    encode.TAG = function(v) {
        check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
        return [v.charCodeAt(0),
                v.charCodeAt(1),
                v.charCodeAt(2),
                v.charCodeAt(3)];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.TAG = constant(4);

    // CFF data types ///////////////////////////////////////////////////////////

    encode.Card8 = encode.BYTE;
    sizeOf.Card8 = sizeOf.BYTE;

    encode.Card16 = encode.USHORT;
    sizeOf.Card16 = sizeOf.USHORT;

    encode.OffSize = encode.BYTE;
    sizeOf.OffSize = sizeOf.BYTE;

    encode.SID = encode.USHORT;
    sizeOf.SID = sizeOf.USHORT;

    // Convert a numeric operand or charstring number to a variable-size list of bytes.
    /**
     * Convert a numeric operand or charstring number to a variable-size list of bytes.
     * @param {number}
     * @returns {Array}
     */
    encode.NUMBER = function(v) {
        if (v >= -107 && v <= 107) {
            return [v + 139];
        } else if (v >= 108 && v <= 1131) {
            v = v - 108;
            return [(v >> 8) + 247, v & 0xFF];
        } else if (v >= -1131 && v <= -108) {
            v = -v - 108;
            return [(v >> 8) + 251, v & 0xFF];
        } else if (v >= -32768 && v <= 32767) {
            return encode.NUMBER16(v);
        } else {
            return encode.NUMBER32(v);
        }
    };

    /**
     * @param {number}
     * @returns {number}
     */
    sizeOf.NUMBER = function(v) {
        return encode.NUMBER(v).length;
    };

    /**
     * Convert a signed number between -32768 and +32767 to a three-byte value.
     * This ensures we always use three bytes, but is not the most compact format.
     * @param {number}
     * @returns {Array}
     */
    encode.NUMBER16 = function(v) {
        return [28, (v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.NUMBER16 = constant(3);

    /**
     * Convert a signed number between -(2^31) and +(2^31-1) to a five-byte value.
     * This is useful if you want to be sure you always use four bytes,
     * at the expense of wasting a few bytes for smaller numbers.
     * @param {number}
     * @returns {Array}
     */
    encode.NUMBER32 = function(v) {
        return [29, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
    };

    /**
     * @constant
     * @type {number}
     */
    sizeOf.NUMBER32 = constant(5);

    /**
     * @param {number}
     * @returns {Array}
     */
    encode.REAL = function(v) {
        var value = v.toString();

        // Some numbers use an epsilon to encode the value. (e.g. JavaScript will store 0.0000001 as 1e-7)
        // This code converts it back to a number without the epsilon.
        var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
        if (m) {
            var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
            value = (Math.round(v * epsilon) / epsilon).toString();
        }

        var nibbles = '';
        for (var i = 0, ii = value.length; i < ii; i += 1) {
            var c = value[i];
            if (c === 'e') {
                nibbles += value[++i] === '-' ? 'c' : 'b';
            } else if (c === '.') {
                nibbles += 'a';
            } else if (c === '-') {
                nibbles += 'e';
            } else {
                nibbles += c;
            }
        }

        nibbles += (nibbles.length & 1) ? 'f' : 'ff';
        var out = [30];
        for (var i$1 = 0, ii$1 = nibbles.length; i$1 < ii$1; i$1 += 2) {
            out.push(parseInt(nibbles.substr(i$1, 2), 16));
        }

        return out;
    };

    /**
     * @param {number}
     * @returns {number}
     */
    sizeOf.REAL = function(v) {
        return encode.REAL(v).length;
    };

    encode.NAME = encode.CHARARRAY;
    sizeOf.NAME = sizeOf.CHARARRAY;

    encode.STRING = encode.CHARARRAY;
    sizeOf.STRING = sizeOf.CHARARRAY;

    /**
     * @param {DataView} data
     * @param {number} offset
     * @param {number} numBytes
     * @returns {string}
     */
    decode.UTF8 = function(data, offset, numBytes) {
        var codePoints = [];
        var numChars = numBytes;
        for (var j = 0; j < numChars; j++, offset += 1) {
            codePoints[j] = data.getUint8(offset);
        }

        return String.fromCharCode.apply(null, codePoints);
    };

    /**
     * @param {DataView} data
     * @param {number} offset
     * @param {number} numBytes
     * @returns {string}
     */
    decode.UTF16 = function(data, offset, numBytes) {
        var codePoints = [];
        var numChars = numBytes / 2;
        for (var j = 0; j < numChars; j++, offset += 2) {
            codePoints[j] = data.getUint16(offset);
        }

        return String.fromCharCode.apply(null, codePoints);
    };

    /**
     * Convert a JavaScript string to UTF16-BE.
     * @param {string}
     * @returns {Array}
     */
    encode.UTF16 = function(v) {
        var b = [];
        for (var i = 0; i < v.length; i += 1) {
            var codepoint = v.charCodeAt(i);
            b[b.length] = (codepoint >> 8) & 0xFF;
            b[b.length] = codepoint & 0xFF;
        }

        return b;
    };

    /**
     * @param {string}
     * @returns {number}
     */
    sizeOf.UTF16 = function(v) {
        return v.length * 2;
    };

    // Data for converting old eight-bit Macintosh encodings to Unicode.
    // This representation is optimized for decoding; encoding is slower
    // and needs more memory. The assumption is that all opentype.js users
    // want to open fonts, but saving a font will be comparatively rare
    // so it can be more expensive. Keyed by IANA character set name.
    //
    // Python script for generating these strings:
    //
    //     s = u''.join([chr(c).decode('mac_greek') for c in range(128, 256)])
    //     print(s.encode('utf-8'))
    /**
     * @private
     */
    var eightBitMacEncodings = {
        'x-mac-croatian':  // Python: 'mac_croatian'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø' +
        '¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
        'x-mac-cyrillic':  // Python: 'mac_cyrillic'
        'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњ' +
        'јЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю',
        'x-mac-gaelic': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæø' +
        'ṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ',
        'x-mac-greek':  // Python: 'mac_greek'
        'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩ' +
        'άΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ\u00AD',
        'x-mac-icelandic':  // Python: 'mac_iceland'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        'x-mac-inuit': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
        'ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗ' +
        'ᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł',
        'x-mac-ce':  // Python: 'mac_latin2'
        'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅ' +
        'ņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
        macintosh:  // Python: 'mac_roman'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        'x-mac-romanian':  // Python: 'mac_romanian'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        'x-mac-turkish':  // Python: 'mac_turkish'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ'
    };

    /**
     * Decodes an old-style Macintosh string. Returns either a Unicode JavaScript
     * string, or 'undefined' if the encoding is unsupported. For example, we do
     * not support Chinese, Japanese or Korean because these would need large
     * mapping tables.
     * @param {DataView} dataView
     * @param {number} offset
     * @param {number} dataLength
     * @param {string} encoding
     * @returns {string}
     */
    decode.MACSTRING = function(dataView, offset, dataLength, encoding) {
        var table = eightBitMacEncodings[encoding];
        if (table === undefined) {
            return undefined;
        }

        var result = '';
        for (var i = 0; i < dataLength; i++) {
            var c = dataView.getUint8(offset + i);
            // In all eight-bit Mac encodings, the characters 0x00..0x7F are
            // mapped to U+0000..U+007F; we only need to look up the others.
            if (c <= 0x7F) {
                result += String.fromCharCode(c);
            } else {
                result += table[c & 0x7F];
            }
        }

        return result;
    };

    // Helper function for encode.MACSTRING. Returns a dictionary for mapping
    // Unicode character codes to their 8-bit MacOS equivalent. This table
    // is not exactly a super cheap data structure, but we do not care because
    // encoding Macintosh strings is only rarely needed in typical applications.
    var macEncodingTableCache = typeof WeakMap === 'function' && new WeakMap();
    var macEncodingCacheKeys;
    var getMacEncodingTable = function (encoding) {
        // Since we use encoding as a cache key for WeakMap, it has to be
        // a String object and not a literal. And at least on NodeJS 2.10.1,
        // WeakMap requires that the same String instance is passed for cache hits.
        if (!macEncodingCacheKeys) {
            macEncodingCacheKeys = {};
            for (var e in eightBitMacEncodings) {
                /*jshint -W053 */  // Suppress "Do not use String as a constructor."
                macEncodingCacheKeys[e] = new String(e);
            }
        }

        var cacheKey = macEncodingCacheKeys[encoding];
        if (cacheKey === undefined) {
            return undefined;
        }

        // We can't do "if (cache.has(key)) {return cache.get(key)}" here:
        // since garbage collection may run at any time, it could also kick in
        // between the calls to cache.has() and cache.get(). In that case,
        // we would return 'undefined' even though we do support the encoding.
        if (macEncodingTableCache) {
            var cachedTable = macEncodingTableCache.get(cacheKey);
            if (cachedTable !== undefined) {
                return cachedTable;
            }
        }

        var decodingTable = eightBitMacEncodings[encoding];
        if (decodingTable === undefined) {
            return undefined;
        }

        var encodingTable = {};
        for (var i = 0; i < decodingTable.length; i++) {
            encodingTable[decodingTable.charCodeAt(i)] = i + 0x80;
        }

        if (macEncodingTableCache) {
            macEncodingTableCache.set(cacheKey, encodingTable);
        }

        return encodingTable;
    };

    /**
     * Encodes an old-style Macintosh string. Returns a byte array upon success.
     * If the requested encoding is unsupported, or if the input string contains
     * a character that cannot be expressed in the encoding, the function returns
     * 'undefined'.
     * @param {string} str
     * @param {string} encoding
     * @returns {Array}
     */
    encode.MACSTRING = function(str, encoding) {
        var table = getMacEncodingTable(encoding);
        if (table === undefined) {
            return undefined;
        }

        var result = [];
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);

            // In all eight-bit Mac encodings, the characters 0x00..0x7F are
            // mapped to U+0000..U+007F; we only need to look up the others.
            if (c >= 0x80) {
                c = table[c];
                if (c === undefined) {
                    // str contains a Unicode character that cannot be encoded
                    // in the requested encoding.
                    return undefined;
                }
            }
            result[i] = c;
            // result.push(c);
        }

        return result;
    };

    /**
     * @param {string} str
     * @param {string} encoding
     * @returns {number}
     */
    sizeOf.MACSTRING = function(str, encoding) {
        var b = encode.MACSTRING(str, encoding);
        if (b !== undefined) {
            return b.length;
        } else {
            return 0;
        }
    };

    // Helper for encode.VARDELTAS
    function isByteEncodable(value) {
        return value >= -128 && value <= 127;
    }

    // Helper for encode.VARDELTAS
    function encodeVarDeltaRunAsZeroes(deltas, pos, result) {
        var runLength = 0;
        var numDeltas = deltas.length;
        while (pos < numDeltas && runLength < 64 && deltas[pos] === 0) {
            ++pos;
            ++runLength;
        }
        result.push(0x80 | (runLength - 1));
        return pos;
    }

    // Helper for encode.VARDELTAS
    function encodeVarDeltaRunAsBytes(deltas, offset, result) {
        var runLength = 0;
        var numDeltas = deltas.length;
        var pos = offset;
        while (pos < numDeltas && runLength < 64) {
            var value = deltas[pos];
            if (!isByteEncodable(value)) {
                break;
            }

            // Within a byte-encoded run of deltas, a single zero is best
            // stored literally as 0x00 value. However, if we have two or
            // more zeroes in a sequence, it is better to start a new run.
            // Fore example, the sequence of deltas [15, 15, 0, 15, 15]
            // becomes 6 bytes (04 0F 0F 00 0F 0F) when storing the zero
            // within the current run, but 7 bytes (01 0F 0F 80 01 0F 0F)
            // when starting a new run.
            if (value === 0 && pos + 1 < numDeltas && deltas[pos + 1] === 0) {
                break;
            }

            ++pos;
            ++runLength;
        }
        result.push(runLength - 1);
        for (var i = offset; i < pos; ++i) {
            result.push((deltas[i] + 256) & 0xff);
        }
        return pos;
    }

    // Helper for encode.VARDELTAS
    function encodeVarDeltaRunAsWords(deltas, offset, result) {
        var runLength = 0;
        var numDeltas = deltas.length;
        var pos = offset;
        while (pos < numDeltas && runLength < 64) {
            var value = deltas[pos];

            // Within a word-encoded run of deltas, it is easiest to start
            // a new run (with a different encoding) whenever we encounter
            // a zero value. For example, the sequence [0x6666, 0, 0x7777]
            // needs 7 bytes when storing the zero inside the current run
            // (42 66 66 00 00 77 77), and equally 7 bytes when starting a
            // new run (40 66 66 80 40 77 77).
            if (value === 0) {
                break;
            }

            // Within a word-encoded run of deltas, a single value in the
            // range (-128..127) should be encoded within the current run
            // because it is more compact. For example, the sequence
            // [0x6666, 2, 0x7777] becomes 7 bytes when storing the value
            // literally (42 66 66 00 02 77 77), but 8 bytes when starting
            // a new run (40 66 66 00 02 40 77 77).
            if (isByteEncodable(value) && pos + 1 < numDeltas && isByteEncodable(deltas[pos + 1])) {
                break;
            }

            ++pos;
            ++runLength;
        }
        result.push(0x40 | (runLength - 1));
        for (var i = offset; i < pos; ++i) {
            var val = deltas[i];
            result.push(((val + 0x10000) >> 8) & 0xff, (val + 0x100) & 0xff);
        }
        return pos;
    }

    /**
     * Encode a list of variation adjustment deltas.
     *
     * Variation adjustment deltas are used in ‘gvar’ and ‘cvar’ tables.
     * They indicate how points (in ‘gvar’) or values (in ‘cvar’) get adjusted
     * when generating instances of variation fonts.
     *
     * @see https://www.microsoft.com/typography/otspec/gvar.htm
     * @see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6gvar.html
     * @param {Array}
     * @return {Array}
     */
    encode.VARDELTAS = function(deltas) {
        var pos = 0;
        var result = [];
        while (pos < deltas.length) {
            var value = deltas[pos];
            if (value === 0) {
                pos = encodeVarDeltaRunAsZeroes(deltas, pos, result);
            } else if (value >= -128 && value <= 127) {
                pos = encodeVarDeltaRunAsBytes(deltas, pos, result);
            } else {
                pos = encodeVarDeltaRunAsWords(deltas, pos, result);
            }
        }
        return result;
    };

    // Convert a list of values to a CFF INDEX structure.
    // The values should be objects containing name / type / value.
    /**
     * @param {Array} l
     * @returns {Array}
     */
    encode.INDEX = function(l) {
        //var offset, offsets, offsetEncoder, encodedOffsets, encodedOffset, data,
        //    i, v;
        // Because we have to know which data type to use to encode the offsets,
        // we have to go through the values twice: once to encode the data and
        // calculate the offsets, then again to encode the offsets using the fitting data type.
        var offset = 1; // First offset is always 1.
        var offsets = [offset];
        var data = [];
        for (var i = 0; i < l.length; i += 1) {
            var v = encode.OBJECT(l[i]);
            Array.prototype.push.apply(data, v);
            offset += v.length;
            offsets.push(offset);
        }

        if (data.length === 0) {
            return [0, 0];
        }

        var encodedOffsets = [];
        var offSize = (1 + Math.floor(Math.log(offset) / Math.log(2)) / 8) | 0;
        var offsetEncoder = [undefined, encode.BYTE, encode.USHORT, encode.UINT24, encode.ULONG][offSize];
        for (var i$1 = 0; i$1 < offsets.length; i$1 += 1) {
            var encodedOffset = offsetEncoder(offsets[i$1]);
            Array.prototype.push.apply(encodedOffsets, encodedOffset);
        }

        return Array.prototype.concat(encode.Card16(l.length),
                               encode.OffSize(offSize),
                               encodedOffsets,
                               data);
    };

    /**
     * @param {Array}
     * @returns {number}
     */
    sizeOf.INDEX = function(v) {
        return encode.INDEX(v).length;
    };

    /**
     * Convert an object to a CFF DICT structure.
     * The keys should be numeric.
     * The values should be objects containing name / type / value.
     * @param {Object} m
     * @returns {Array}
     */
    encode.DICT = function(m) {
        var d = [];
        var keys = Object.keys(m);
        var length = keys.length;

        for (var i = 0; i < length; i += 1) {
            // Object.keys() return string keys, but our keys are always numeric.
            var k = parseInt(keys[i], 0);
            var v = m[k];
            // Value comes before the key.
            d = d.concat(encode.OPERAND(v.value, v.type));
            d = d.concat(encode.OPERATOR(k));
        }

        return d;
    };

    /**
     * @param {Object}
     * @returns {number}
     */
    sizeOf.DICT = function(m) {
        return encode.DICT(m).length;
    };

    /**
     * @param {number}
     * @returns {Array}
     */
    encode.OPERATOR = function(v) {
        if (v < 1200) {
            return [v];
        } else {
            return [12, v - 1200];
        }
    };

    /**
     * @param {Array} v
     * @param {string}
     * @returns {Array}
     */
    encode.OPERAND = function(v, type) {
        var d = [];
        if (Array.isArray(type)) {
            for (var i = 0; i < type.length; i += 1) {
                check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
                d = d.concat(encode.OPERAND(v[i], type[i]));
            }
        } else {
            if (type === 'SID') {
                d = d.concat(encode.NUMBER(v));
            } else if (type === 'offset') {
                // We make it easy for ourselves and always encode offsets as
                // 4 bytes. This makes offset calculation for the top dict easier.
                d = d.concat(encode.NUMBER32(v));
            } else if (type === 'number') {
                d = d.concat(encode.NUMBER(v));
            } else if (type === 'real') {
                d = d.concat(encode.REAL(v));
            } else {
                throw new Error('Unknown operand type ' + type);
                // FIXME Add support for booleans
            }
        }

        return d;
    };

    encode.OP = encode.BYTE;
    sizeOf.OP = sizeOf.BYTE;

    // memoize charstring encoding using WeakMap if available
    var wmm = typeof WeakMap === 'function' && new WeakMap();

    /**
     * Convert a list of CharString operations to bytes.
     * @param {Array}
     * @returns {Array}
     */
    encode.CHARSTRING = function(ops) {
        // See encode.MACSTRING for why we don't do "if (wmm && wmm.has(ops))".
        if (wmm) {
            var cachedValue = wmm.get(ops);
            if (cachedValue !== undefined) {
                return cachedValue;
            }
        }

        var d = [];
        var length = ops.length;

        for (var i = 0; i < length; i += 1) {
            var op = ops[i];
            d = d.concat(encode[op.type](op.value));
        }

        if (wmm) {
            wmm.set(ops, d);
        }

        return d;
    };

    /**
     * @param {Array}
     * @returns {number}
     */
    sizeOf.CHARSTRING = function(ops) {
        return encode.CHARSTRING(ops).length;
    };

    // Utility functions ////////////////////////////////////////////////////////

    /**
     * Convert an object containing name / type / value to bytes.
     * @param {Object}
     * @returns {Array}
     */
    encode.OBJECT = function(v) {
        var encodingFunction = encode[v.type];
        check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
        return encodingFunction(v.value);
    };

    /**
     * @param {Object}
     * @returns {number}
     */
    sizeOf.OBJECT = function(v) {
        var sizeOfFunction = sizeOf[v.type];
        check.argument(sizeOfFunction !== undefined, 'No sizeOf function for type ' + v.type);
        return sizeOfFunction(v.value);
    };

    /**
     * Convert a table object to bytes.
     * A table contains a list of fields containing the metadata (name, type and default value).
     * The table itself has the field values set as attributes.
     * @param {opentype.Table}
     * @returns {Array}
     */
    encode.TABLE = function(table) {
        var d = [];
        var length = table.fields.length;
        var subtables = [];
        var subtableOffsets = [];

        for (var i = 0; i < length; i += 1) {
            var field = table.fields[i];
            var encodingFunction = encode[field.type];
            check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type + ' (' + field.name + ')');
            var value = table[field.name];
            if (value === undefined) {
                value = field.value;
            }

            var bytes = encodingFunction(value);

            if (field.type === 'TABLE') {
                subtableOffsets.push(d.length);
                d = d.concat([0, 0]);
                subtables.push(bytes);
            } else {
                d = d.concat(bytes);
            }
        }

        for (var i$1 = 0; i$1 < subtables.length; i$1 += 1) {
            var o = subtableOffsets[i$1];
            var offset = d.length;
            check.argument(offset < 65536, 'Table ' + table.tableName + ' too big.');
            d[o] = offset >> 8;
            d[o + 1] = offset & 0xff;
            d = d.concat(subtables[i$1]);
        }

        return d;
    };

    /**
     * @param {opentype.Table}
     * @returns {number}
     */
    sizeOf.TABLE = function(table) {
        var numBytes = 0;
        var length = table.fields.length;

        for (var i = 0; i < length; i += 1) {
            var field = table.fields[i];
            var sizeOfFunction = sizeOf[field.type];
            check.argument(sizeOfFunction !== undefined, 'No sizeOf function for field type ' + field.type + ' (' + field.name + ')');
            var value = table[field.name];
            if (value === undefined) {
                value = field.value;
            }

            numBytes += sizeOfFunction(value);

            // Subtables take 2 more bytes for offsets.
            if (field.type === 'TABLE') {
                numBytes += 2;
            }
        }

        return numBytes;
    };

    encode.RECORD = encode.TABLE;
    sizeOf.RECORD = sizeOf.TABLE;

    // Merge in a list of bytes.
    encode.LITERAL = function(v) {
        return v;
    };

    sizeOf.LITERAL = function(v) {
        return v.length;
    };

    // Table metadata

    /**
     * @exports opentype.Table
     * @class
     * @param {string} tableName
     * @param {Array} fields
     * @param {Object} options
     * @constructor
     */
    function Table(tableName, fields, options) {
        // For coverage tables with coverage format 2, we do not want to add the coverage data directly to the table object,
        // as this will result in wrong encoding order of the coverage data on serialization to bytes.
        // The fallback of using the field values directly when not present on the table is handled in types.encode.TABLE() already.
        if (fields.length && (fields[0].name !== 'coverageFormat' || fields[0].value === 1)) {
            for (var i = 0; i < fields.length; i += 1) {
                var field = fields[i];
                this[field.name] = field.value;
            }
        }

        this.tableName = tableName;
        this.fields = fields;
        if (options) {
            var optionKeys = Object.keys(options);
            for (var i$1 = 0; i$1 < optionKeys.length; i$1 += 1) {
                var k = optionKeys[i$1];
                var v = options[k];
                if (this[k] !== undefined) {
                    this[k] = v;
                }
            }
        }
    }

    /**
     * Encodes the table and returns an array of bytes
     * @return {Array}
     */
    Table.prototype.encode = function() {
        return encode.TABLE(this);
    };

    /**
     * Get the size of the table.
     * @return {number}
     */
    Table.prototype.sizeOf = function() {
        return sizeOf.TABLE(this);
    };

    /**
     * @private
     */
    function ushortList(itemName, list, count) {
        if (count === undefined) {
            count = list.length;
        }
        var fields = new Array(list.length + 1);
        fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
        for (var i = 0; i < list.length; i++) {
            fields[i + 1] = {name: itemName + i, type: 'USHORT', value: list[i]};
        }
        return fields;
    }

    /**
     * @private
     */
    function tableList(itemName, records, itemCallback) {
        var count = records.length;
        var fields = new Array(count + 1);
        fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
        for (var i = 0; i < count; i++) {
            fields[i + 1] = {name: itemName + i, type: 'TABLE', value: itemCallback(records[i], i)};
        }
        return fields;
    }

    /**
     * @private
     */
    function recordList(itemName, records, itemCallback) {
        var count = records.length;
        var fields = [];
        fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
        for (var i = 0; i < count; i++) {
            fields = fields.concat(itemCallback(records[i], i));
        }
        return fields;
    }

    // Common Layout Tables

    /**
     * @exports opentype.Coverage
     * @class
     * @param {opentype.Table}
     * @constructor
     * @extends opentype.Table
     */
    function Coverage(coverageTable) {
        if (coverageTable.format === 1) {
            Table.call(this, 'coverageTable',
                [{name: 'coverageFormat', type: 'USHORT', value: 1}]
                .concat(ushortList('glyph', coverageTable.glyphs))
            );
        } else if (coverageTable.format === 2) {
            Table.call(this, 'coverageTable',
                [{name: 'coverageFormat', type: 'USHORT', value: 2}]
                .concat(recordList('rangeRecord', coverageTable.ranges, function(RangeRecord) {
                    return [
                        {name: 'startGlyphID', type: 'USHORT', value: RangeRecord.start},
                        {name: 'endGlyphID', type: 'USHORT', value: RangeRecord.end},
                        {name: 'startCoverageIndex', type: 'USHORT', value: RangeRecord.index} ];
                }))
            );
        } else {
            check.assert(false, 'Coverage format must be 1 or 2.');
        }
    }
    Coverage.prototype = Object.create(Table.prototype);
    Coverage.prototype.constructor = Coverage;

    function ScriptList(scriptListTable) {
        Table.call(this, 'scriptListTable',
            recordList('scriptRecord', scriptListTable, function(scriptRecord, i) {
                var script = scriptRecord.script;
                var defaultLangSys = script.defaultLangSys;
                check.assert(!!defaultLangSys, 'Unable to write GSUB: script ' + scriptRecord.tag + ' has no default language system.');
                return [
                    {name: 'scriptTag' + i, type: 'TAG', value: scriptRecord.tag},
                    {name: 'script' + i, type: 'TABLE', value: new Table('scriptTable', [
                        {name: 'defaultLangSys', type: 'TABLE', value: new Table('defaultLangSys', [
                            {name: 'lookupOrder', type: 'USHORT', value: 0},
                            {name: 'reqFeatureIndex', type: 'USHORT', value: defaultLangSys.reqFeatureIndex}]
                            .concat(ushortList('featureIndex', defaultLangSys.featureIndexes)))}
                        ].concat(recordList('langSys', script.langSysRecords, function(langSysRecord, i) {
                            var langSys = langSysRecord.langSys;
                            return [
                                {name: 'langSysTag' + i, type: 'TAG', value: langSysRecord.tag},
                                {name: 'langSys' + i, type: 'TABLE', value: new Table('langSys', [
                                    {name: 'lookupOrder', type: 'USHORT', value: 0},
                                    {name: 'reqFeatureIndex', type: 'USHORT', value: langSys.reqFeatureIndex}
                                    ].concat(ushortList('featureIndex', langSys.featureIndexes)))}
                            ];
                        })))}
                ];
            })
        );
    }
    ScriptList.prototype = Object.create(Table.prototype);
    ScriptList.prototype.constructor = ScriptList;

    /**
     * @exports opentype.FeatureList
     * @class
     * @param {opentype.Table}
     * @constructor
     * @extends opentype.Table
     */
    function FeatureList(featureListTable) {
        Table.call(this, 'featureListTable',
            recordList('featureRecord', featureListTable, function(featureRecord, i) {
                var feature = featureRecord.feature;
                return [
                    {name: 'featureTag' + i, type: 'TAG', value: featureRecord.tag},
                    {name: 'feature' + i, type: 'TABLE', value: new Table('featureTable', [
                        {name: 'featureParams', type: 'USHORT', value: feature.featureParams} ].concat(ushortList('lookupListIndex', feature.lookupListIndexes)))}
                ];
            })
        );
    }
    FeatureList.prototype = Object.create(Table.prototype);
    FeatureList.prototype.constructor = FeatureList;

    /**
     * @exports opentype.LookupList
     * @class
     * @param {opentype.Table}
     * @param {Object}
     * @constructor
     * @extends opentype.Table
     */
    function LookupList(lookupListTable, subtableMakers) {
        Table.call(this, 'lookupListTable', tableList('lookup', lookupListTable, function(lookupTable) {
            var subtableCallback = subtableMakers[lookupTable.lookupType];
            check.assert(!!subtableCallback, 'Unable to write GSUB lookup type ' + lookupTable.lookupType + ' tables.');
            return new Table('lookupTable', [
                {name: 'lookupType', type: 'USHORT', value: lookupTable.lookupType},
                {name: 'lookupFlag', type: 'USHORT', value: lookupTable.lookupFlag}
            ].concat(tableList('subtable', lookupTable.subtables, subtableCallback)));
        }));
    }
    LookupList.prototype = Object.create(Table.prototype);
    LookupList.prototype.constructor = LookupList;

    // Record = same as Table, but inlined (a Table has an offset and its data is further in the stream)
    // Don't use offsets inside Records (probable bug), only in Tables.
    var table = {
        Table: Table,
        Record: Table,
        Coverage: Coverage,
        ScriptList: ScriptList,
        FeatureList: FeatureList,
        LookupList: LookupList,
        ushortList: ushortList,
        tableList: tableList,
        recordList: recordList,
    };

    // Parsing utility functions

    // Retrieve an unsigned byte from the DataView.
    function getByte(dataView, offset) {
        return dataView.getUint8(offset);
    }

    // Retrieve an unsigned 16-bit short from the DataView.
    // The value is stored in big endian.
    function getUShort(dataView, offset) {
        return dataView.getUint16(offset, false);
    }

    // Retrieve a signed 16-bit short from the DataView.
    // The value is stored in big endian.
    function getShort(dataView, offset) {
        return dataView.getInt16(offset, false);
    }

    // Retrieve an unsigned 32-bit long from the DataView.
    // The value is stored in big endian.
    function getULong(dataView, offset) {
        return dataView.getUint32(offset, false);
    }

    // Retrieve a 32-bit signed fixed-point number (16.16) from the DataView.
    // The value is stored in big endian.
    function getFixed(dataView, offset) {
        var decimal = dataView.getInt16(offset, false);
        var fraction = dataView.getUint16(offset + 2, false);
        return decimal + fraction / 65535;
    }

    // Retrieve a 4-character tag from the DataView.
    // Tags are used to identify tables.
    function getTag(dataView, offset) {
        var tag = '';
        for (var i = offset; i < offset + 4; i += 1) {
            tag += String.fromCharCode(dataView.getInt8(i));
        }

        return tag;
    }

    // Retrieve an offset from the DataView.
    // Offsets are 1 to 4 bytes in length, depending on the offSize argument.
    function getOffset(dataView, offset, offSize) {
        var v = 0;
        for (var i = 0; i < offSize; i += 1) {
            v <<= 8;
            v += dataView.getUint8(offset + i);
        }

        return v;
    }

    // Retrieve a number of bytes from start offset to the end offset from the DataView.
    function getBytes(dataView, startOffset, endOffset) {
        var bytes = [];
        for (var i = startOffset; i < endOffset; i += 1) {
            bytes.push(dataView.getUint8(i));
        }

        return bytes;
    }

    // Convert the list of bytes to a string.
    function bytesToString(bytes) {
        var s = '';
        for (var i = 0; i < bytes.length; i += 1) {
            s += String.fromCharCode(bytes[i]);
        }

        return s;
    }

    var typeOffsets = {
        byte: 1,
        uShort: 2,
        short: 2,
        uLong: 4,
        fixed: 4,
        longDateTime: 8,
        tag: 4
    };

    // A stateful parser that changes the offset whenever a value is retrieved.
    // The data is a DataView.
    function Parser(data, offset) {
        this.data = data;
        this.offset = offset;
        this.relativeOffset = 0;
    }

    Parser.prototype.parseByte = function() {
        var v = this.data.getUint8(this.offset + this.relativeOffset);
        this.relativeOffset += 1;
        return v;
    };

    Parser.prototype.parseChar = function() {
        var v = this.data.getInt8(this.offset + this.relativeOffset);
        this.relativeOffset += 1;
        return v;
    };

    Parser.prototype.parseCard8 = Parser.prototype.parseByte;

    Parser.prototype.parseUShort = function() {
        var v = this.data.getUint16(this.offset + this.relativeOffset);
        this.relativeOffset += 2;
        return v;
    };

    Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
    Parser.prototype.parseSID = Parser.prototype.parseUShort;
    Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;

    Parser.prototype.parseShort = function() {
        var v = this.data.getInt16(this.offset + this.relativeOffset);
        this.relativeOffset += 2;
        return v;
    };

    Parser.prototype.parseF2Dot14 = function() {
        var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
        this.relativeOffset += 2;
        return v;
    };

    Parser.prototype.parseULong = function() {
        var v = getULong(this.data, this.offset + this.relativeOffset);
        this.relativeOffset += 4;
        return v;
    };

    Parser.prototype.parseOffset32 = Parser.prototype.parseULong;

    Parser.prototype.parseFixed = function() {
        var v = getFixed(this.data, this.offset + this.relativeOffset);
        this.relativeOffset += 4;
        return v;
    };

    Parser.prototype.parseString = function(length) {
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        var string = '';
        this.relativeOffset += length;
        for (var i = 0; i < length; i++) {
            string += String.fromCharCode(dataView.getUint8(offset + i));
        }

        return string;
    };

    Parser.prototype.parseTag = function() {
        return this.parseString(4);
    };

    // LONGDATETIME is a 64-bit integer.
    // JavaScript and unix timestamps traditionally use 32 bits, so we
    // only take the last 32 bits.
    // + Since until 2038 those bits will be filled by zeros we can ignore them.
    Parser.prototype.parseLongDateTime = function() {
        var v = getULong(this.data, this.offset + this.relativeOffset + 4);
        // Subtract seconds between 01/01/1904 and 01/01/1970
        // to convert Apple Mac timestamp to Standard Unix timestamp
        v -= 2082844800;
        this.relativeOffset += 8;
        return v;
    };

    Parser.prototype.parseVersion = function(minorBase) {
        var major = getUShort(this.data, this.offset + this.relativeOffset);

        // How to interpret the minor version is very vague in the spec. 0x5000 is 5, 0x1000 is 1
        // Default returns the correct number if minor = 0xN000 where N is 0-9
        // Set minorBase to 1 for tables that use minor = N where N is 0-9
        var minor = getUShort(this.data, this.offset + this.relativeOffset + 2);
        this.relativeOffset += 4;
        if (minorBase === undefined) { minorBase = 0x1000; }
        return major + minor / minorBase / 10;
    };

    Parser.prototype.skip = function(type, amount) {
        if (amount === undefined) {
            amount = 1;
        }

        this.relativeOffset += typeOffsets[type] * amount;
    };

    ///// Parsing lists and records ///////////////////////////////

    // Parse a list of 32 bit unsigned integers.
    Parser.prototype.parseULongList = function(count) {
        if (count === undefined) { count = this.parseULong(); }
        var offsets = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            offsets[i] = dataView.getUint32(offset);
            offset += 4;
        }

        this.relativeOffset += count * 4;
        return offsets;
    };

    // Parse a list of 16 bit unsigned integers. The length of the list can be read on the stream
    // or provided as an argument.
    Parser.prototype.parseOffset16List =
    Parser.prototype.parseUShortList = function(count) {
        if (count === undefined) { count = this.parseUShort(); }
        var offsets = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            offsets[i] = dataView.getUint16(offset);
            offset += 2;
        }

        this.relativeOffset += count * 2;
        return offsets;
    };

    // Parses a list of 16 bit signed integers.
    Parser.prototype.parseShortList = function(count) {
        var list = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            list[i] = dataView.getInt16(offset);
            offset += 2;
        }

        this.relativeOffset += count * 2;
        return list;
    };

    // Parses a list of bytes.
    Parser.prototype.parseByteList = function(count) {
        var list = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            list[i] = dataView.getUint8(offset++);
        }

        this.relativeOffset += count;
        return list;
    };

    /**
     * Parse a list of items.
     * Record count is optional, if omitted it is read from the stream.
     * itemCallback is one of the Parser methods.
     */
    Parser.prototype.parseList = function(count, itemCallback) {
        if (!itemCallback) {
            itemCallback = count;
            count = this.parseUShort();
        }
        var list = new Array(count);
        for (var i = 0; i < count; i++) {
            list[i] = itemCallback.call(this);
        }
        return list;
    };

    Parser.prototype.parseList32 = function(count, itemCallback) {
        if (!itemCallback) {
            itemCallback = count;
            count = this.parseULong();
        }
        var list = new Array(count);
        for (var i = 0; i < count; i++) {
            list[i] = itemCallback.call(this);
        }
        return list;
    };

    /**
     * Parse a list of records.
     * Record count is optional, if omitted it is read from the stream.
     * Example of recordDescription: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
     */
    Parser.prototype.parseRecordList = function(count, recordDescription) {
        // If the count argument is absent, read it in the stream.
        if (!recordDescription) {
            recordDescription = count;
            count = this.parseUShort();
        }
        var records = new Array(count);
        var fields = Object.keys(recordDescription);
        for (var i = 0; i < count; i++) {
            var rec = {};
            for (var j = 0; j < fields.length; j++) {
                var fieldName = fields[j];
                var fieldType = recordDescription[fieldName];
                rec[fieldName] = fieldType.call(this);
            }
            records[i] = rec;
        }
        return records;
    };

    Parser.prototype.parseRecordList32 = function(count, recordDescription) {
        // If the count argument is absent, read it in the stream.
        if (!recordDescription) {
            recordDescription = count;
            count = this.parseULong();
        }
        var records = new Array(count);
        var fields = Object.keys(recordDescription);
        for (var i = 0; i < count; i++) {
            var rec = {};
            for (var j = 0; j < fields.length; j++) {
                var fieldName = fields[j];
                var fieldType = recordDescription[fieldName];
                rec[fieldName] = fieldType.call(this);
            }
            records[i] = rec;
        }
        return records;
    };

    // Parse a data structure into an object
    // Example of description: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
    Parser.prototype.parseStruct = function(description) {
        if (typeof description === 'function') {
            return description.call(this);
        } else {
            var fields = Object.keys(description);
            var struct = {};
            for (var j = 0; j < fields.length; j++) {
                var fieldName = fields[j];
                var fieldType = description[fieldName];
                struct[fieldName] = fieldType.call(this);
            }
            return struct;
        }
    };

    /**
     * Parse a GPOS valueRecord
     * https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#value-record
     * valueFormat is optional, if omitted it is read from the stream.
     */
    Parser.prototype.parseValueRecord = function(valueFormat) {
        if (valueFormat === undefined) {
            valueFormat = this.parseUShort();
        }
        if (valueFormat === 0) {
            // valueFormat2 in kerning pairs is most often 0
            // in this case return undefined instead of an empty object, to save space
            return;
        }
        var valueRecord = {};

        if (valueFormat & 0x0001) { valueRecord.xPlacement = this.parseShort(); }
        if (valueFormat & 0x0002) { valueRecord.yPlacement = this.parseShort(); }
        if (valueFormat & 0x0004) { valueRecord.xAdvance = this.parseShort(); }
        if (valueFormat & 0x0008) { valueRecord.yAdvance = this.parseShort(); }

        // Device table (non-variable font) / VariationIndex table (variable font) not supported
        // https://docs.microsoft.com/fr-fr/typography/opentype/spec/chapter2#devVarIdxTbls
        if (valueFormat & 0x0010) { valueRecord.xPlaDevice = undefined; this.parseShort(); }
        if (valueFormat & 0x0020) { valueRecord.yPlaDevice = undefined; this.parseShort(); }
        if (valueFormat & 0x0040) { valueRecord.xAdvDevice = undefined; this.parseShort(); }
        if (valueFormat & 0x0080) { valueRecord.yAdvDevice = undefined; this.parseShort(); }

        return valueRecord;
    };

    /**
     * Parse a list of GPOS valueRecords
     * https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#value-record
     * valueFormat and valueCount are read from the stream.
     */
    Parser.prototype.parseValueRecordList = function() {
        var valueFormat = this.parseUShort();
        var valueCount = this.parseUShort();
        var values = new Array(valueCount);
        for (var i = 0; i < valueCount; i++) {
            values[i] = this.parseValueRecord(valueFormat);
        }
        return values;
    };

    Parser.prototype.parsePointer = function(description) {
        var structOffset = this.parseOffset16();
        if (structOffset > 0) {
            // NULL offset => return undefined
            return new Parser(this.data, this.offset + structOffset).parseStruct(description);
        }
        return undefined;
    };

    Parser.prototype.parsePointer32 = function(description) {
        var structOffset = this.parseOffset32();
        if (structOffset > 0) {
            // NULL offset => return undefined
            return new Parser(this.data, this.offset + structOffset).parseStruct(description);
        }
        return undefined;
    };

    /**
     * Parse a list of offsets to lists of 16-bit integers,
     * or a list of offsets to lists of offsets to any kind of items.
     * If itemCallback is not provided, a list of list of UShort is assumed.
     * If provided, itemCallback is called on each item and must parse the item.
     * See examples in tables/gsub.js
     */
    Parser.prototype.parseListOfLists = function(itemCallback) {
        var offsets = this.parseOffset16List();
        var count = offsets.length;
        var relativeOffset = this.relativeOffset;
        var list = new Array(count);
        for (var i = 0; i < count; i++) {
            var start = offsets[i];
            if (start === 0) {
                // NULL offset
                // Add i as owned property to list. Convenient with assert.
                list[i] = undefined;
                continue;
            }
            this.relativeOffset = start;
            if (itemCallback) {
                var subOffsets = this.parseOffset16List();
                var subList = new Array(subOffsets.length);
                for (var j = 0; j < subOffsets.length; j++) {
                    this.relativeOffset = start + subOffsets[j];
                    subList[j] = itemCallback.call(this);
                }
                list[i] = subList;
            } else {
                list[i] = this.parseUShortList();
            }
        }
        this.relativeOffset = relativeOffset;
        return list;
    };

    ///// Complex tables parsing //////////////////////////////////

    // Parse a coverage table in a GSUB, GPOS or GDEF table.
    // https://www.microsoft.com/typography/OTSPEC/chapter2.htm
    // parser.offset must point to the start of the table containing the coverage.
    Parser.prototype.parseCoverage = function() {
        var startOffset = this.offset + this.relativeOffset;
        var format = this.parseUShort();
        var count = this.parseUShort();
        if (format === 1) {
            return {
                format: 1,
                glyphs: this.parseUShortList(count)
            };
        } else if (format === 2) {
            var ranges = new Array(count);
            for (var i = 0; i < count; i++) {
                ranges[i] = {
                    start: this.parseUShort(),
                    end: this.parseUShort(),
                    index: this.parseUShort()
                };
            }
            return {
                format: 2,
                ranges: ranges
            };
        }
        throw new Error('0x' + startOffset.toString(16) + ': Coverage format must be 1 or 2.');
    };

    // Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
    // https://www.microsoft.com/typography/OTSPEC/chapter2.htm
    Parser.prototype.parseClassDef = function() {
        var startOffset = this.offset + this.relativeOffset;
        var format = this.parseUShort();
        if (format === 1) {
            return {
                format: 1,
                startGlyph: this.parseUShort(),
                classes: this.parseUShortList()
            };
        } else if (format === 2) {
            return {
                format: 2,
                ranges: this.parseRecordList({
                    start: Parser.uShort,
                    end: Parser.uShort,
                    classId: Parser.uShort
                })
            };
        }
        throw new Error('0x' + startOffset.toString(16) + ': ClassDef format must be 1 or 2.');
    };

    ///// Static methods ///////////////////////////////////
    // These convenience methods can be used as callbacks and should be called with "this" context set to a Parser instance.

    Parser.list = function(count, itemCallback) {
        return function() {
            return this.parseList(count, itemCallback);
        };
    };

    Parser.list32 = function(count, itemCallback) {
        return function() {
            return this.parseList32(count, itemCallback);
        };
    };

    Parser.recordList = function(count, recordDescription) {
        return function() {
            return this.parseRecordList(count, recordDescription);
        };
    };

    Parser.recordList32 = function(count, recordDescription) {
        return function() {
            return this.parseRecordList32(count, recordDescription);
        };
    };

    Parser.pointer = function(description) {
        return function() {
            return this.parsePointer(description);
        };
    };

    Parser.pointer32 = function(description) {
        return function() {
            return this.parsePointer32(description);
        };
    };

    Parser.tag = Parser.prototype.parseTag;
    Parser.byte = Parser.prototype.parseByte;
    Parser.uShort = Parser.offset16 = Parser.prototype.parseUShort;
    Parser.uShortList = Parser.prototype.parseUShortList;
    Parser.uLong = Parser.offset32 = Parser.prototype.parseULong;
    Parser.uLongList = Parser.prototype.parseULongList;
    Parser.struct = Parser.prototype.parseStruct;
    Parser.coverage = Parser.prototype.parseCoverage;
    Parser.classDef = Parser.prototype.parseClassDef;

    ///// Script, Feature, Lookup lists ///////////////////////////////////////////////
    // https://www.microsoft.com/typography/OTSPEC/chapter2.htm

    var langSysTable = {
        reserved: Parser.uShort,
        reqFeatureIndex: Parser.uShort,
        featureIndexes: Parser.uShortList
    };

    Parser.prototype.parseScriptList = function() {
        return this.parsePointer(Parser.recordList({
            tag: Parser.tag,
            script: Parser.pointer({
                defaultLangSys: Parser.pointer(langSysTable),
                langSysRecords: Parser.recordList({
                    tag: Parser.tag,
                    langSys: Parser.pointer(langSysTable)
                })
            })
        })) || [];
    };

    Parser.prototype.parseFeatureList = function() {
        return this.parsePointer(Parser.recordList({
            tag: Parser.tag,
            feature: Parser.pointer({
                featureParams: Parser.offset16,
                lookupListIndexes: Parser.uShortList
            })
        })) || [];
    };

    Parser.prototype.parseLookupList = function(lookupTableParsers) {
        return this.parsePointer(Parser.list(Parser.pointer(function() {
            var lookupType = this.parseUShort();
            check.argument(1 <= lookupType && lookupType <= 9, 'GPOS/GSUB lookup type ' + lookupType + ' unknown.');
            var lookupFlag = this.parseUShort();
            var useMarkFilteringSet = lookupFlag & 0x10;
            return {
                lookupType: lookupType,
                lookupFlag: lookupFlag,
                subtables: this.parseList(Parser.pointer(lookupTableParsers[lookupType])),
                markFilteringSet: useMarkFilteringSet ? this.parseUShort() : undefined
            };
        }))) || [];
    };

    Parser.prototype.parseFeatureVariationsList = function() {
        return this.parsePointer32(function() {
            var majorVersion = this.parseUShort();
            var minorVersion = this.parseUShort();
            check.argument(majorVersion === 1 && minorVersion < 1, 'GPOS/GSUB feature variations table unknown.');
            var featureVariations = this.parseRecordList32({
                conditionSetOffset: Parser.offset32,
                featureTableSubstitutionOffset: Parser.offset32
            });
            return featureVariations;
        }) || [];
    };

    var parse = {
        getByte: getByte,
        getCard8: getByte,
        getUShort: getUShort,
        getCard16: getUShort,
        getShort: getShort,
        getULong: getULong,
        getFixed: getFixed,
        getTag: getTag,
        getOffset: getOffset,
        getBytes: getBytes,
        bytesToString: bytesToString,
        Parser: Parser,
    };

    // The `cmap` table stores the mappings from characters to glyphs.

    function parseCmapTableFormat12(cmap, p) {
        //Skip reserved.
        p.parseUShort();

        // Length in bytes of the sub-tables.
        cmap.length = p.parseULong();
        cmap.language = p.parseULong();

        var groupCount;
        cmap.groupCount = groupCount = p.parseULong();
        cmap.glyphIndexMap = {};

        for (var i = 0; i < groupCount; i += 1) {
            var startCharCode = p.parseULong();
            var endCharCode = p.parseULong();
            var startGlyphId = p.parseULong();

            for (var c = startCharCode; c <= endCharCode; c += 1) {
                cmap.glyphIndexMap[c] = startGlyphId;
                startGlyphId++;
            }
        }
    }

    function parseCmapTableFormat4(cmap, p, data, start, offset) {
        // Length in bytes of the sub-tables.
        cmap.length = p.parseUShort();
        cmap.language = p.parseUShort();

        // segCount is stored x 2.
        var segCount;
        cmap.segCount = segCount = p.parseUShort() >> 1;

        // Skip searchRange, entrySelector, rangeShift.
        p.skip('uShort', 3);

        // The "unrolled" mapping from character codes to glyph indices.
        cmap.glyphIndexMap = {};
        var endCountParser = new parse.Parser(data, start + offset + 14);
        var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
        var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
        var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
        var glyphIndexOffset = start + offset + 16 + segCount * 8;
        for (var i = 0; i < segCount - 1; i += 1) {
            var glyphIndex = (void 0);
            var endCount = endCountParser.parseUShort();
            var startCount = startCountParser.parseUShort();
            var idDelta = idDeltaParser.parseShort();
            var idRangeOffset = idRangeOffsetParser.parseUShort();
            for (var c = startCount; c <= endCount; c += 1) {
                if (idRangeOffset !== 0) {
                    // The idRangeOffset is relative to the current position in the idRangeOffset array.
                    // Take the current offset in the idRangeOffset array.
                    glyphIndexOffset = (idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2);

                    // Add the value of the idRangeOffset, which will move us into the glyphIndex array.
                    glyphIndexOffset += idRangeOffset;

                    // Then add the character index of the current segment, multiplied by 2 for USHORTs.
                    glyphIndexOffset += (c - startCount) * 2;
                    glyphIndex = parse.getUShort(data, glyphIndexOffset);
                    if (glyphIndex !== 0) {
                        glyphIndex = (glyphIndex + idDelta) & 0xFFFF;
                    }
                } else {
                    glyphIndex = (c + idDelta) & 0xFFFF;
                }

                cmap.glyphIndexMap[c] = glyphIndex;
            }
        }
    }

    // Parse the `cmap` table. This table stores the mappings from characters to glyphs.
    // There are many available formats, but we only support the Windows format 4 and 12.
    // This function returns a `CmapEncoding` object or null if no supported format could be found.
    function parseCmapTable(data, start) {
        var cmap = {};
        cmap.version = parse.getUShort(data, start);
        check.argument(cmap.version === 0, 'cmap table version should be 0.');

        // The cmap table can contain many sub-tables, each with their own format.
        // We're only interested in a "platform 0" (Unicode format) and "platform 3" (Windows format) table.
        cmap.numTables = parse.getUShort(data, start + 2);
        var offset = -1;
        for (var i = cmap.numTables - 1; i >= 0; i -= 1) {
            var platformId = parse.getUShort(data, start + 4 + (i * 8));
            var encodingId = parse.getUShort(data, start + 4 + (i * 8) + 2);
            if ((platformId === 3 && (encodingId === 0 || encodingId === 1 || encodingId === 10)) ||
                (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 2 || encodingId === 3 || encodingId === 4))) {
                offset = parse.getULong(data, start + 4 + (i * 8) + 4);
                break;
            }
        }

        if (offset === -1) {
            // There is no cmap table in the font that we support.
            throw new Error('No valid cmap sub-tables found.');
        }

        var p = new parse.Parser(data, start + offset);
        cmap.format = p.parseUShort();

        if (cmap.format === 12) {
            parseCmapTableFormat12(cmap, p);
        } else if (cmap.format === 4) {
            parseCmapTableFormat4(cmap, p, data, start, offset);
        } else {
            throw new Error('Only format 4 and 12 cmap tables are supported (found format ' + cmap.format + ').');
        }

        return cmap;
    }

    function addSegment(t, code, glyphIndex) {
        t.segments.push({
            end: code,
            start: code,
            delta: -(code - glyphIndex),
            offset: 0,
            glyphIndex: glyphIndex
        });
    }

    function addTerminatorSegment(t) {
        t.segments.push({
            end: 0xFFFF,
            start: 0xFFFF,
            delta: 1,
            offset: 0
        });
    }

    // Make cmap table, format 4 by default, 12 if needed only
    function makeCmapTable(glyphs) {
        // Plan 0 is the base Unicode Plan but emojis, for example are on another plan, and needs cmap 12 format (with 32bit)
        var isPlan0Only = true;
        var i;

        // Check if we need to add cmap format 12 or if format 4 only is fine
        for (i = glyphs.length - 1; i > 0; i -= 1) {
            var g = glyphs.get(i);
            if (g.unicode > 65535) {
                console.log('Adding CMAP format 12 (needed!)');
                isPlan0Only = false;
                break;
            }
        }

        var cmapTable = [
            {name: 'version', type: 'USHORT', value: 0},
            {name: 'numTables', type: 'USHORT', value: isPlan0Only ? 1 : 2},

            // CMAP 4 header
            {name: 'platformID', type: 'USHORT', value: 3},
            {name: 'encodingID', type: 'USHORT', value: 1},
            {name: 'offset', type: 'ULONG', value: isPlan0Only ? 12 : (12 + 8)}
        ];

        if (!isPlan0Only)
            { cmapTable = cmapTable.concat([
                // CMAP 12 header
                {name: 'cmap12PlatformID', type: 'USHORT', value: 3}, // We encode only for PlatformID = 3 (Windows) because it is supported everywhere
                {name: 'cmap12EncodingID', type: 'USHORT', value: 10},
                {name: 'cmap12Offset', type: 'ULONG', value: 0}
            ]); }

        cmapTable = cmapTable.concat([
            // CMAP 4 Subtable
            {name: 'format', type: 'USHORT', value: 4},
            {name: 'cmap4Length', type: 'USHORT', value: 0},
            {name: 'language', type: 'USHORT', value: 0},
            {name: 'segCountX2', type: 'USHORT', value: 0},
            {name: 'searchRange', type: 'USHORT', value: 0},
            {name: 'entrySelector', type: 'USHORT', value: 0},
            {name: 'rangeShift', type: 'USHORT', value: 0}
        ]);

        var t = new table.Table('cmap', cmapTable);

        t.segments = [];
        for (i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            for (var j = 0; j < glyph.unicodes.length; j += 1) {
                addSegment(t, glyph.unicodes[j], i);
            }

            t.segments = t.segments.sort(function (a, b) {
                return a.start - b.start;
            });
        }

        addTerminatorSegment(t);

        var segCount = t.segments.length;
        var segCountToRemove = 0;

        // CMAP 4
        // Set up parallel segment arrays.
        var endCounts = [];
        var startCounts = [];
        var idDeltas = [];
        var idRangeOffsets = [];
        var glyphIds = [];

        // CMAP 12
        var cmap12Groups = [];

        // Reminder this loop is not following the specification at 100%
        // The specification -> find suites of characters and make a group
        // Here we're doing one group for each letter
        // Doing as the spec can save 8 times (or more) space
        for (i = 0; i < segCount; i += 1) {
            var segment = t.segments[i];

            // CMAP 4
            if (segment.end <= 65535 && segment.start <= 65535) {
                endCounts = endCounts.concat({name: 'end_' + i, type: 'USHORT', value: segment.end});
                startCounts = startCounts.concat({name: 'start_' + i, type: 'USHORT', value: segment.start});
                idDeltas = idDeltas.concat({name: 'idDelta_' + i, type: 'SHORT', value: segment.delta});
                idRangeOffsets = idRangeOffsets.concat({name: 'idRangeOffset_' + i, type: 'USHORT', value: segment.offset});
                if (segment.glyphId !== undefined) {
                    glyphIds = glyphIds.concat({name: 'glyph_' + i, type: 'USHORT', value: segment.glyphId});
                }
            } else {
                // Skip Unicode > 65535 (16bit unsigned max) for CMAP 4, will be added in CMAP 12
                segCountToRemove += 1;
            }

            // CMAP 12
            // Skip Terminator Segment
            if (!isPlan0Only && segment.glyphIndex !== undefined) {
                cmap12Groups = cmap12Groups.concat({name: 'cmap12Start_' + i, type: 'ULONG', value: segment.start});
                cmap12Groups = cmap12Groups.concat({name: 'cmap12End_' + i, type: 'ULONG', value: segment.end});
                cmap12Groups = cmap12Groups.concat({name: 'cmap12Glyph_' + i, type: 'ULONG', value: segment.glyphIndex});
            }
        }

        // CMAP 4 Subtable
        t.segCountX2 = (segCount - segCountToRemove) * 2;
        t.searchRange = Math.pow(2, Math.floor(Math.log((segCount - segCountToRemove)) / Math.log(2))) * 2;
        t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
        t.rangeShift = t.segCountX2 - t.searchRange;

        t.fields = t.fields.concat(endCounts);
        t.fields.push({name: 'reservedPad', type: 'USHORT', value: 0});
        t.fields = t.fields.concat(startCounts);
        t.fields = t.fields.concat(idDeltas);
        t.fields = t.fields.concat(idRangeOffsets);
        t.fields = t.fields.concat(glyphIds);

        t.cmap4Length = 14 + // Subtable header
            endCounts.length * 2 +
            2 + // reservedPad
            startCounts.length * 2 +
            idDeltas.length * 2 +
            idRangeOffsets.length * 2 +
            glyphIds.length * 2;

        if (!isPlan0Only) {
            // CMAP 12 Subtable
            var cmap12Length = 16 + // Subtable header
                cmap12Groups.length * 4;

            t.cmap12Offset = 12 + (2 * 2) + 4 + t.cmap4Length;
            t.fields = t.fields.concat([
                {name: 'cmap12Format', type: 'USHORT', value: 12},
                {name: 'cmap12Reserved', type: 'USHORT', value: 0},
                {name: 'cmap12Length', type: 'ULONG', value: cmap12Length},
                {name: 'cmap12Language', type: 'ULONG', value: 0},
                {name: 'cmap12nGroups', type: 'ULONG', value: cmap12Groups.length / 3}
            ]);

            t.fields = t.fields.concat(cmap12Groups);
        }

        return t;
    }

    var cmap = { parse: parseCmapTable, make: makeCmapTable };

    // Glyph encoding

    var cffStandardStrings = [
        '.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
        'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
        'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
        'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
        'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
        'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
        'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling',
        'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft',
        'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph',
        'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand',
        'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring',
        'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE',
        'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu',
        'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn',
        'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright',
        'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex',
        'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex',
        'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute',
        'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute',
        'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute',
        'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave',
        'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior',
        'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', '266 ff', 'onedotenleader',
        'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle',
        'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior',
        'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior',
        'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl',
        'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
        'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
        'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
        'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall',
        'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall',
        'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall',
        'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds',
        'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior',
        'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior',
        'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior',
        'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall',
        'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall',
        'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall',
        'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall',
        'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000',
        '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];

    var cffStandardEncoding = [
        '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
        '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
        'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
        'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
        'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
        'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
        'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
        'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '',
        '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
        'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle',
        'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger',
        'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright',
        'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde',
        'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron',
        'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '',
        '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '',
        'lslash', 'oslash', 'oe', 'germandbls'];

    var cffExpertEncoding = [
        '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
        '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior',
        'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader',
        'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle',
        'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon',
        'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior',
        'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior',
        'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl',
        'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
        'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
        'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
        'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '',
        '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
        'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall',
        'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior',
        '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters',
        'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '',
        '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior',
        'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior',
        'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior',
        'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall',
        'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall',
        'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall',
        'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall',
        'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall',
        'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

    var standardNames = [
        '.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent',
        'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash',
        'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less',
        'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
        'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright',
        'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
        'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde',
        'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave',
        'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis',
        'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis',
        'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section',
        'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal',
        'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation',
        'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown',
        'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright',
        'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft',
        'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction',
        'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase',
        'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute',
        'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex',
        'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut',
        'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth',
        'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior',
        'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla',
        'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

    /**
     * This is the encoding used for fonts created from scratch.
     * It loops through all glyphs and finds the appropriate unicode value.
     * Since it's linear time, other encodings will be faster.
     * @exports opentype.DefaultEncoding
     * @class
     * @constructor
     * @param {opentype.Font}
     */
    function DefaultEncoding(font) {
        this.font = font;
    }

    DefaultEncoding.prototype.charToGlyphIndex = function(c) {
        var code = c.codePointAt(0);
        var glyphs = this.font.glyphs;
        if (glyphs) {
            for (var i = 0; i < glyphs.length; i += 1) {
                var glyph = glyphs.get(i);
                for (var j = 0; j < glyph.unicodes.length; j += 1) {
                    if (glyph.unicodes[j] === code) {
                        return i;
                    }
                }
            }
        }
        return null;
    };

    /**
     * @exports opentype.CmapEncoding
     * @class
     * @constructor
     * @param {Object} cmap - a object with the cmap encoded data
     */
    function CmapEncoding(cmap) {
        this.cmap = cmap;
    }

    /**
     * @param  {string} c - the character
     * @return {number} The glyph index.
     */
    CmapEncoding.prototype.charToGlyphIndex = function(c) {
        return this.cmap.glyphIndexMap[c.codePointAt(0)] || 0;
    };

    /**
     * @exports opentype.CffEncoding
     * @class
     * @constructor
     * @param {string} encoding - The encoding
     * @param {Array} charset - The character set.
     */
    function CffEncoding(encoding, charset) {
        this.encoding = encoding;
        this.charset = charset;
    }

    /**
     * @param  {string} s - The character
     * @return {number} The index.
     */
    CffEncoding.prototype.charToGlyphIndex = function(s) {
        var code = s.codePointAt(0);
        var charName = this.encoding[code];
        return this.charset.indexOf(charName);
    };

    /**
     * @exports opentype.GlyphNames
     * @class
     * @constructor
     * @param {Object} post
     */
    function GlyphNames(post) {
        switch (post.version) {
            case 1:
                this.names = standardNames.slice();
                break;
            case 2:
                this.names = new Array(post.numberOfGlyphs);
                for (var i = 0; i < post.numberOfGlyphs; i++) {
                    if (post.glyphNameIndex[i] < standardNames.length) {
                        this.names[i] = standardNames[post.glyphNameIndex[i]];
                    } else {
                        this.names[i] = post.names[post.glyphNameIndex[i] - standardNames.length];
                    }
                }

                break;
            case 2.5:
                this.names = new Array(post.numberOfGlyphs);
                for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                    this.names[i$1] = standardNames[i$1 + post.glyphNameIndex[i$1]];
                }

                break;
            case 3:
                this.names = [];
                break;
            default:
                this.names = [];
                break;
        }
    }

    /**
     * Gets the index of a glyph by name.
     * @param  {string} name - The glyph name
     * @return {number} The index
     */
    GlyphNames.prototype.nameToGlyphIndex = function(name) {
        return this.names.indexOf(name);
    };

    /**
     * @param  {number} gid
     * @return {string}
     */
    GlyphNames.prototype.glyphIndexToName = function(gid) {
        return this.names[gid];
    };

    function addGlyphNamesAll(font) {
        var glyph;
        var glyphIndexMap = font.tables.cmap.glyphIndexMap;
        var charCodes = Object.keys(glyphIndexMap);

        for (var i = 0; i < charCodes.length; i += 1) {
            var c = charCodes[i];
            var glyphIndex = glyphIndexMap[c];
            glyph = font.glyphs.get(glyphIndex);
            glyph.addUnicode(parseInt(c));
        }

        for (var i$1 = 0; i$1 < font.glyphs.length; i$1 += 1) {
            glyph = font.glyphs.get(i$1);
            if (font.cffEncoding) {
                if (font.isCIDFont) {
                    glyph.name = 'gid' + i$1;
                } else {
                    glyph.name = font.cffEncoding.charset[i$1];
                }
            } else if (font.glyphNames.names) {
                glyph.name = font.glyphNames.glyphIndexToName(i$1);
            }
        }
    }

    function addGlyphNamesToUnicodeMap(font) {
        font._IndexToUnicodeMap = {};

        var glyphIndexMap = font.tables.cmap.glyphIndexMap;
        var charCodes = Object.keys(glyphIndexMap);

        for (var i = 0; i < charCodes.length; i += 1) {
            var c = charCodes[i];
            var glyphIndex = glyphIndexMap[c];
            if (font._IndexToUnicodeMap[glyphIndex] === undefined) {
                font._IndexToUnicodeMap[glyphIndex] = {
                    unicodes: [parseInt(c)]
                };
            } else {
                font._IndexToUnicodeMap[glyphIndex].unicodes.push(parseInt(c));
            }
        }
    }

    /**
     * @alias opentype.addGlyphNames
     * @param {opentype.Font}
     * @param {Object}
     */
    function addGlyphNames(font, opt) {
        if (opt.lowMemory) {
            addGlyphNamesToUnicodeMap(font);
        } else {
            addGlyphNamesAll(font);
        }
    }

    // Drawing utility functions.

    // Draw a line on the given context from point `x1,y1` to point `x2,y2`.
    function line(ctx, x1, y1, x2, y2) {
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
    }

    var draw = { line: line };

    // The Glyph object
    // import glyf from './tables/glyf' Can't be imported here, because it's a circular dependency

    function getPathDefinition(glyph, path) {
        var _path = path || new Path();
        return {
            configurable: true,

            get: function() {
                if (typeof _path === 'function') {
                    _path = _path();
                }

                return _path;
            },

            set: function(p) {
                _path = p;
            }
        };
    }
    /**
     * @typedef GlyphOptions
     * @type Object
     * @property {string} [name] - The glyph name
     * @property {number} [unicode]
     * @property {Array} [unicodes]
     * @property {number} [xMin]
     * @property {number} [yMin]
     * @property {number} [xMax]
     * @property {number} [yMax]
     * @property {number} [advanceWidth]
     */

    // A Glyph is an individual mark that often corresponds to a character.
    // Some glyphs, such as ligatures, are a combination of many characters.
    // Glyphs are the basic building blocks of a font.
    //
    // The `Glyph` class contains utility methods for drawing the path and its points.
    /**
     * @exports opentype.Glyph
     * @class
     * @param {GlyphOptions}
     * @constructor
     */
    function Glyph(options) {
        // By putting all the code on a prototype function (which is only declared once)
        // we reduce the memory requirements for larger fonts by some 2%
        this.bindConstructorValues(options);
    }

    /**
     * @param  {GlyphOptions}
     */
    Glyph.prototype.bindConstructorValues = function(options) {
        this.index = options.index || 0;

        // These three values cannot be deferred for memory optimization:
        this.name = options.name || null;
        this.unicode = options.unicode || undefined;
        this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];

        // But by binding these values only when necessary, we reduce can
        // the memory requirements by almost 3% for larger fonts.
        if ('xMin' in options) {
            this.xMin = options.xMin;
        }

        if ('yMin' in options) {
            this.yMin = options.yMin;
        }

        if ('xMax' in options) {
            this.xMax = options.xMax;
        }

        if ('yMax' in options) {
            this.yMax = options.yMax;
        }

        if ('advanceWidth' in options) {
            this.advanceWidth = options.advanceWidth;
        }

        // The path for a glyph is the most memory intensive, and is bound as a value
        // with a getter/setter to ensure we actually do path parsing only once the
        // path is actually needed by anything.
        Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
    };

    /**
     * @param {number}
     */
    Glyph.prototype.addUnicode = function(unicode) {
        if (this.unicodes.length === 0) {
            this.unicode = unicode;
        }

        this.unicodes.push(unicode);
    };

    /**
     * Calculate the minimum bounding box for this glyph.
     * @return {opentype.BoundingBox}
     */
    Glyph.prototype.getBoundingBox = function() {
        return this.path.getBoundingBox();
    };

    /**
     * Convert the glyph to a Path we can draw on a drawing context.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {Object=} options - xScale, yScale to stretch the glyph.
     * @param  {opentype.Font} if hinting is to be used, the font
     * @return {opentype.Path}
     */
    Glyph.prototype.getPath = function(x, y, fontSize, options, font) {
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 72;
        var commands;
        var hPoints;
        if (!options) { options = { }; }
        var xScale = options.xScale;
        var yScale = options.yScale;

        if (options.hinting && font && font.hinting) {
            // in case of hinting, the hinting engine takes care
            // of scaling the points (not the path) before hinting.
            hPoints = this.path && font.hinting.exec(this, fontSize);
            // in case the hinting engine failed hPoints is undefined
            // and thus reverts to plain rending
        }

        if (hPoints) {
            // Call font.hinting.getCommands instead of `glyf.getPath(hPoints).commands` to avoid a circular dependency
            commands = font.hinting.getCommands(hPoints);
            x = Math.round(x);
            y = Math.round(y);
            // TODO in case of hinting xyScaling is not yet supported
            xScale = yScale = 1;
        } else {
            commands = this.path.commands;
            var scale = 1 / (this.path.unitsPerEm || 1000) * fontSize;
            if (xScale === undefined) { xScale = scale; }
            if (yScale === undefined) { yScale = scale; }
        }

        var p = new Path();
        for (var i = 0; i < commands.length; i += 1) {
            var cmd = commands[i];
            if (cmd.type === 'M') {
                p.moveTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
            } else if (cmd.type === 'L') {
                p.lineTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
            } else if (cmd.type === 'Q') {
                p.quadraticCurveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
                                   x + (cmd.x * xScale), y + (-cmd.y * yScale));
            } else if (cmd.type === 'C') {
                p.curveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
                          x + (cmd.x2 * xScale), y + (-cmd.y2 * yScale),
                          x + (cmd.x * xScale), y + (-cmd.y * yScale));
            } else if (cmd.type === 'Z') {
                p.closePath();
            }
        }

        return p;
    };

    /**
     * Split the glyph into contours.
     * This function is here for backwards compatibility, and to
     * provide raw access to the TrueType glyph outlines.
     * @return {Array}
     */
    Glyph.prototype.getContours = function() {
        if (this.points === undefined) {
            return [];
        }

        var contours = [];
        var currentContour = [];
        for (var i = 0; i < this.points.length; i += 1) {
            var pt = this.points[i];
            currentContour.push(pt);
            if (pt.lastPointOfContour) {
                contours.push(currentContour);
                currentContour = [];
            }
        }

        check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
        return contours;
    };

    /**
     * Calculate the xMin/yMin/xMax/yMax/lsb/rsb for a Glyph.
     * @return {Object}
     */
    Glyph.prototype.getMetrics = function() {
        var commands = this.path.commands;
        var xCoords = [];
        var yCoords = [];
        for (var i = 0; i < commands.length; i += 1) {
            var cmd = commands[i];
            if (cmd.type !== 'Z') {
                xCoords.push(cmd.x);
                yCoords.push(cmd.y);
            }

            if (cmd.type === 'Q' || cmd.type === 'C') {
                xCoords.push(cmd.x1);
                yCoords.push(cmd.y1);
            }

            if (cmd.type === 'C') {
                xCoords.push(cmd.x2);
                yCoords.push(cmd.y2);
            }
        }

        var metrics = {
            xMin: Math.min.apply(null, xCoords),
            yMin: Math.min.apply(null, yCoords),
            xMax: Math.max.apply(null, xCoords),
            yMax: Math.max.apply(null, yCoords),
            leftSideBearing: this.leftSideBearing
        };

        if (!isFinite(metrics.xMin)) {
            metrics.xMin = 0;
        }

        if (!isFinite(metrics.xMax)) {
            metrics.xMax = this.advanceWidth;
        }

        if (!isFinite(metrics.yMin)) {
            metrics.yMin = 0;
        }

        if (!isFinite(metrics.yMax)) {
            metrics.yMax = 0;
        }

        metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
        return metrics;
    };

    /**
     * Draw the glyph on the given context.
     * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {Object=} options - xScale, yScale to stretch the glyph.
     */
    Glyph.prototype.draw = function(ctx, x, y, fontSize, options) {
        this.getPath(x, y, fontSize, options).draw(ctx);
    };

    /**
     * Draw the points of the glyph.
     * On-curve points will be drawn in blue, off-curve points will be drawn in red.
     * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     */
    Glyph.prototype.drawPoints = function(ctx, x, y, fontSize) {
        function drawCircles(l, x, y, scale) {
            ctx.beginPath();
            for (var j = 0; j < l.length; j += 1) {
                ctx.moveTo(x + (l[j].x * scale), y + (l[j].y * scale));
                ctx.arc(x + (l[j].x * scale), y + (l[j].y * scale), 2, 0, Math.PI * 2, false);
            }

            ctx.closePath();
            ctx.fill();
        }

        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 24;
        var scale = 1 / this.path.unitsPerEm * fontSize;

        var blueCircles = [];
        var redCircles = [];
        var path = this.path;
        for (var i = 0; i < path.commands.length; i += 1) {
            var cmd = path.commands[i];
            if (cmd.x !== undefined) {
                blueCircles.push({x: cmd.x, y: -cmd.y});
            }

            if (cmd.x1 !== undefined) {
                redCircles.push({x: cmd.x1, y: -cmd.y1});
            }

            if (cmd.x2 !== undefined) {
                redCircles.push({x: cmd.x2, y: -cmd.y2});
            }
        }

        ctx.fillStyle = 'blue';
        drawCircles(blueCircles, x, y, scale);
        ctx.fillStyle = 'red';
        drawCircles(redCircles, x, y, scale);
    };

    /**
     * Draw lines indicating important font measurements.
     * Black lines indicate the origin of the coordinate system (point 0,0).
     * Blue lines indicate the glyph bounding box.
     * Green line indicates the advance width of the glyph.
     * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     */
    Glyph.prototype.drawMetrics = function(ctx, x, y, fontSize) {
        var scale;
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 24;
        scale = 1 / this.path.unitsPerEm * fontSize;
        ctx.lineWidth = 1;

        // Draw the origin
        ctx.strokeStyle = 'black';
        draw.line(ctx, x, -10000, x, 10000);
        draw.line(ctx, -10000, y, 10000, y);

        // This code is here due to memory optimization: by not using
        // defaults in the constructor, we save a notable amount of memory.
        var xMin = this.xMin || 0;
        var yMin = this.yMin || 0;
        var xMax = this.xMax || 0;
        var yMax = this.yMax || 0;
        var advanceWidth = this.advanceWidth || 0;

        // Draw the glyph box
        ctx.strokeStyle = 'blue';
        draw.line(ctx, x + (xMin * scale), -10000, x + (xMin * scale), 10000);
        draw.line(ctx, x + (xMax * scale), -10000, x + (xMax * scale), 10000);
        draw.line(ctx, -10000, y + (-yMin * scale), 10000, y + (-yMin * scale));
        draw.line(ctx, -10000, y + (-yMax * scale), 10000, y + (-yMax * scale));

        // Draw the advance width
        ctx.strokeStyle = 'green';
        draw.line(ctx, x + (advanceWidth * scale), -10000, x + (advanceWidth * scale), 10000);
    };

    // The GlyphSet object

    // Define a property on the glyph that depends on the path being loaded.
    function defineDependentProperty(glyph, externalName, internalName) {
        Object.defineProperty(glyph, externalName, {
            get: function() {
                // Request the path property to make sure the path is loaded.
                glyph.path; // jshint ignore:line
                return glyph[internalName];
            },
            set: function(newValue) {
                glyph[internalName] = newValue;
            },
            enumerable: true,
            configurable: true
        });
    }

    /**
     * A GlyphSet represents all glyphs available in the font, but modelled using
     * a deferred glyph loader, for retrieving glyphs only once they are absolutely
     * necessary, to keep the memory footprint down.
     * @exports opentype.GlyphSet
     * @class
     * @param {opentype.Font}
     * @param {Array}
     */
    function GlyphSet(font, glyphs) {
        this.font = font;
        this.glyphs = {};
        if (Array.isArray(glyphs)) {
            for (var i = 0; i < glyphs.length; i++) {
                var glyph = glyphs[i];
                glyph.path.unitsPerEm = font.unitsPerEm;
                this.glyphs[i] = glyph;
            }
        }

        this.length = (glyphs && glyphs.length) || 0;
    }

    /**
     * @param  {number} index
     * @return {opentype.Glyph}
     */
    GlyphSet.prototype.get = function(index) {
        // this.glyphs[index] is 'undefined' when low memory mode is on. glyph is pushed on request only.
        if (this.glyphs[index] === undefined) {
            this.font._push(index);
            if (typeof this.glyphs[index] === 'function') {
                this.glyphs[index] = this.glyphs[index]();
            }

            var glyph = this.glyphs[index];
            var unicodeObj = this.font._IndexToUnicodeMap[index];

            if (unicodeObj) {
                for (var j = 0; j < unicodeObj.unicodes.length; j++)
                    { glyph.addUnicode(unicodeObj.unicodes[j]); }
            }

            if (this.font.cffEncoding) {
                if (this.font.isCIDFont) {
                    glyph.name = 'gid' + index;
                } else {
                    glyph.name = this.font.cffEncoding.charset[index];
                }
            } else if (this.font.glyphNames.names) {
                glyph.name = this.font.glyphNames.glyphIndexToName(index);
            }

            this.glyphs[index].advanceWidth = this.font._hmtxTableData[index].advanceWidth;
            this.glyphs[index].leftSideBearing = this.font._hmtxTableData[index].leftSideBearing;
        } else {
            if (typeof this.glyphs[index] === 'function') {
                this.glyphs[index] = this.glyphs[index]();
            }
        }

        return this.glyphs[index];
    };

    /**
     * @param  {number} index
     * @param  {Object}
     */
    GlyphSet.prototype.push = function(index, loader) {
        this.glyphs[index] = loader;
        this.length++;
    };

    /**
     * @alias opentype.glyphLoader
     * @param  {opentype.Font} font
     * @param  {number} index
     * @return {opentype.Glyph}
     */
    function glyphLoader(font, index) {
        return new Glyph({index: index, font: font});
    }

    /**
     * Generate a stub glyph that can be filled with all metadata *except*
     * the "points" and "path" properties, which must be loaded only once
     * the glyph's path is actually requested for text shaping.
     * @alias opentype.ttfGlyphLoader
     * @param  {opentype.Font} font
     * @param  {number} index
     * @param  {Function} parseGlyph
     * @param  {Object} data
     * @param  {number} position
     * @param  {Function} buildPath
     * @return {opentype.Glyph}
     */
    function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
        return function() {
            var glyph = new Glyph({index: index, font: font});

            glyph.path = function() {
                parseGlyph(glyph, data, position);
                var path = buildPath(font.glyphs, glyph);
                path.unitsPerEm = font.unitsPerEm;
                return path;
            };

            defineDependentProperty(glyph, 'xMin', '_xMin');
            defineDependentProperty(glyph, 'xMax', '_xMax');
            defineDependentProperty(glyph, 'yMin', '_yMin');
            defineDependentProperty(glyph, 'yMax', '_yMax');

            return glyph;
        };
    }
    /**
     * @alias opentype.cffGlyphLoader
     * @param  {opentype.Font} font
     * @param  {number} index
     * @param  {Function} parseCFFCharstring
     * @param  {string} charstring
     * @return {opentype.Glyph}
     */
    function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
        return function() {
            var glyph = new Glyph({index: index, font: font});

            glyph.path = function() {
                var path = parseCFFCharstring(font, glyph, charstring);
                path.unitsPerEm = font.unitsPerEm;
                return path;
            };

            return glyph;
        };
    }

    var glyphset = { GlyphSet: GlyphSet, glyphLoader: glyphLoader, ttfGlyphLoader: ttfGlyphLoader, cffGlyphLoader: cffGlyphLoader };

    // The `CFF` table contains the glyph outlines in PostScript format.

    // Custom equals function that can also check lists.
    function equals$1(a, b) {
        if (a === b) {
            return true;
        } else if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) {
                return false;
            }

            for (var i = 0; i < a.length; i += 1) {
                if (!equals$1(a[i], b[i])) {
                    return false;
                }
            }

            return true;
        } else {
            return false;
        }
    }

    // Subroutines are encoded using the negative half of the number space.
    // See type 2 chapter 4.7 "Subroutine operators".
    function calcCFFSubroutineBias(subrs) {
        var bias;
        if (subrs.length < 1240) {
            bias = 107;
        } else if (subrs.length < 33900) {
            bias = 1131;
        } else {
            bias = 32768;
        }

        return bias;
    }

    // Parse a `CFF` INDEX array.
    // An index array consists of a list of offsets, then a list of objects at those offsets.
    function parseCFFIndex(data, start, conversionFn) {
        var offsets = [];
        var objects = [];
        var count = parse.getCard16(data, start);
        var objectOffset;
        var endOffset;
        if (count !== 0) {
            var offsetSize = parse.getByte(data, start + 2);
            objectOffset = start + ((count + 1) * offsetSize) + 2;
            var pos = start + 3;
            for (var i = 0; i < count + 1; i += 1) {
                offsets.push(parse.getOffset(data, pos, offsetSize));
                pos += offsetSize;
            }

            // The total size of the index array is 4 header bytes + the value of the last offset.
            endOffset = objectOffset + offsets[count];
        } else {
            endOffset = start + 2;
        }

        for (var i$1 = 0; i$1 < offsets.length - 1; i$1 += 1) {
            var value = parse.getBytes(data, objectOffset + offsets[i$1], objectOffset + offsets[i$1 + 1]);
            if (conversionFn) {
                value = conversionFn(value);
            }

            objects.push(value);
        }

        return {objects: objects, startOffset: start, endOffset: endOffset};
    }

    function parseCFFIndexLowMemory(data, start) {
        var offsets = [];
        var count = parse.getCard16(data, start);
        var objectOffset;
        var endOffset;
        if (count !== 0) {
            var offsetSize = parse.getByte(data, start + 2);
            objectOffset = start + ((count + 1) * offsetSize) + 2;
            var pos = start + 3;
            for (var i = 0; i < count + 1; i += 1) {
                offsets.push(parse.getOffset(data, pos, offsetSize));
                pos += offsetSize;
            }

            // The total size of the index array is 4 header bytes + the value of the last offset.
            endOffset = objectOffset + offsets[count];
        } else {
            endOffset = start + 2;
        }

        return {offsets: offsets, startOffset: start, endOffset: endOffset};
    }
    function getCffIndexObject(i, offsets, data, start, conversionFn) {
        var count = parse.getCard16(data, start);
        var objectOffset = 0;
        if (count !== 0) {
            var offsetSize = parse.getByte(data, start + 2);
            objectOffset = start + ((count + 1) * offsetSize) + 2;
        }

        var value = parse.getBytes(data, objectOffset + offsets[i], objectOffset + offsets[i + 1]);
        if (conversionFn) {
            value = conversionFn(value);
        }
        return value;
    }

    // Parse a `CFF` DICT real value.
    function parseFloatOperand(parser) {
        var s = '';
        var eof = 15;
        var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
        while (true) {
            var b = parser.parseByte();
            var n1 = b >> 4;
            var n2 = b & 15;

            if (n1 === eof) {
                break;
            }

            s += lookup[n1];

            if (n2 === eof) {
                break;
            }

            s += lookup[n2];
        }

        return parseFloat(s);
    }

    // Parse a `CFF` DICT operand.
    function parseOperand(parser, b0) {
        var b1;
        var b2;
        var b3;
        var b4;
        if (b0 === 28) {
            b1 = parser.parseByte();
            b2 = parser.parseByte();
            return b1 << 8 | b2;
        }

        if (b0 === 29) {
            b1 = parser.parseByte();
            b2 = parser.parseByte();
            b3 = parser.parseByte();
            b4 = parser.parseByte();
            return b1 << 24 | b2 << 16 | b3 << 8 | b4;
        }

        if (b0 === 30) {
            return parseFloatOperand(parser);
        }

        if (b0 >= 32 && b0 <= 246) {
            return b0 - 139;
        }

        if (b0 >= 247 && b0 <= 250) {
            b1 = parser.parseByte();
            return (b0 - 247) * 256 + b1 + 108;
        }

        if (b0 >= 251 && b0 <= 254) {
            b1 = parser.parseByte();
            return -(b0 - 251) * 256 - b1 - 108;
        }

        throw new Error('Invalid b0 ' + b0);
    }

    // Convert the entries returned by `parseDict` to a proper dictionary.
    // If a value is a list of one, it is unpacked.
    function entriesToObject(entries) {
        var o = {};
        for (var i = 0; i < entries.length; i += 1) {
            var key = entries[i][0];
            var values = entries[i][1];
            var value = (void 0);
            if (values.length === 1) {
                value = values[0];
            } else {
                value = values;
            }

            if (o.hasOwnProperty(key) && !isNaN(o[key])) {
                throw new Error('Object ' + o + ' already has key ' + key);
            }

            o[key] = value;
        }

        return o;
    }

    // Parse a `CFF` DICT object.
    // A dictionary contains key-value pairs in a compact tokenized format.
    function parseCFFDict(data, start, size) {
        start = start !== undefined ? start : 0;
        var parser = new parse.Parser(data, start);
        var entries = [];
        var operands = [];
        size = size !== undefined ? size : data.length;

        while (parser.relativeOffset < size) {
            var op = parser.parseByte();

            // The first byte for each dict item distinguishes between operator (key) and operand (value).
            // Values <= 21 are operators.
            if (op <= 21) {
                // Two-byte operators have an initial escape byte of 12.
                if (op === 12) {
                    op = 1200 + parser.parseByte();
                }

                entries.push([op, operands]);
                operands = [];
            } else {
                // Since the operands (values) come before the operators (keys), we store all operands in a list
                // until we encounter an operator.
                operands.push(parseOperand(parser, op));
            }
        }

        return entriesToObject(entries);
    }

    // Given a String Index (SID), return the value of the string.
    // Strings below index 392 are standard CFF strings and are not encoded in the font.
    function getCFFString(strings, index) {
        if (index <= 390) {
            index = cffStandardStrings[index];
        } else {
            index = strings[index - 391];
        }

        return index;
    }

    // Interpret a dictionary and return a new dictionary with readable keys and values for missing entries.
    // This function takes `meta` which is a list of objects containing `operand`, `name` and `default`.
    function interpretDict(dict, meta, strings) {
        var newDict = {};
        var value;

        // Because we also want to include missing values, we start out from the meta list
        // and lookup values in the dict.
        for (var i = 0; i < meta.length; i += 1) {
            var m = meta[i];

            if (Array.isArray(m.type)) {
                var values = [];
                values.length = m.type.length;
                for (var j = 0; j < m.type.length; j++) {
                    value = dict[m.op] !== undefined ? dict[m.op][j] : undefined;
                    if (value === undefined) {
                        value = m.value !== undefined && m.value[j] !== undefined ? m.value[j] : null;
                    }
                    if (m.type[j] === 'SID') {
                        value = getCFFString(strings, value);
                    }
                    values[j] = value;
                }
                newDict[m.name] = values;
            } else {
                value = dict[m.op];
                if (value === undefined) {
                    value = m.value !== undefined ? m.value : null;
                }

                if (m.type === 'SID') {
                    value = getCFFString(strings, value);
                }
                newDict[m.name] = value;
            }
        }

        return newDict;
    }

    // Parse the CFF header.
    function parseCFFHeader(data, start) {
        var header = {};
        header.formatMajor = parse.getCard8(data, start);
        header.formatMinor = parse.getCard8(data, start + 1);
        header.size = parse.getCard8(data, start + 2);
        header.offsetSize = parse.getCard8(data, start + 3);
        header.startOffset = start;
        header.endOffset = start + 4;
        return header;
    }

    var TOP_DICT_META = [
        {name: 'version', op: 0, type: 'SID'},
        {name: 'notice', op: 1, type: 'SID'},
        {name: 'copyright', op: 1200, type: 'SID'},
        {name: 'fullName', op: 2, type: 'SID'},
        {name: 'familyName', op: 3, type: 'SID'},
        {name: 'weight', op: 4, type: 'SID'},
        {name: 'isFixedPitch', op: 1201, type: 'number', value: 0},
        {name: 'italicAngle', op: 1202, type: 'number', value: 0},
        {name: 'underlinePosition', op: 1203, type: 'number', value: -100},
        {name: 'underlineThickness', op: 1204, type: 'number', value: 50},
        {name: 'paintType', op: 1205, type: 'number', value: 0},
        {name: 'charstringType', op: 1206, type: 'number', value: 2},
        {
            name: 'fontMatrix',
            op: 1207,
            type: ['real', 'real', 'real', 'real', 'real', 'real'],
            value: [0.001, 0, 0, 0.001, 0, 0]
        },
        {name: 'uniqueId', op: 13, type: 'number'},
        {name: 'fontBBox', op: 5, type: ['number', 'number', 'number', 'number'], value: [0, 0, 0, 0]},
        {name: 'strokeWidth', op: 1208, type: 'number', value: 0},
        {name: 'xuid', op: 14, type: [], value: null},
        {name: 'charset', op: 15, type: 'offset', value: 0},
        {name: 'encoding', op: 16, type: 'offset', value: 0},
        {name: 'charStrings', op: 17, type: 'offset', value: 0},
        {name: 'private', op: 18, type: ['number', 'offset'], value: [0, 0]},
        {name: 'ros', op: 1230, type: ['SID', 'SID', 'number']},
        {name: 'cidFontVersion', op: 1231, type: 'number', value: 0},
        {name: 'cidFontRevision', op: 1232, type: 'number', value: 0},
        {name: 'cidFontType', op: 1233, type: 'number', value: 0},
        {name: 'cidCount', op: 1234, type: 'number', value: 8720},
        {name: 'uidBase', op: 1235, type: 'number'},
        {name: 'fdArray', op: 1236, type: 'offset'},
        {name: 'fdSelect', op: 1237, type: 'offset'},
        {name: 'fontName', op: 1238, type: 'SID'}
    ];

    var PRIVATE_DICT_META = [
        {name: 'subrs', op: 19, type: 'offset', value: 0},
        {name: 'defaultWidthX', op: 20, type: 'number', value: 0},
        {name: 'nominalWidthX', op: 21, type: 'number', value: 0}
    ];

    // Parse the CFF top dictionary. A CFF table can contain multiple fonts, each with their own top dictionary.
    // The top dictionary contains the essential metadata for the font, together with the private dictionary.
    function parseCFFTopDict(data, strings) {
        var dict = parseCFFDict(data, 0, data.byteLength);
        return interpretDict(dict, TOP_DICT_META, strings);
    }

    // Parse the CFF private dictionary. We don't fully parse out all the values, only the ones we need.
    function parseCFFPrivateDict(data, start, size, strings) {
        var dict = parseCFFDict(data, start, size);
        return interpretDict(dict, PRIVATE_DICT_META, strings);
    }

    // Returns a list of "Top DICT"s found using an INDEX list.
    // Used to read both the usual high-level Top DICTs and also the FDArray
    // discovered inside CID-keyed fonts.  When a Top DICT has a reference to
    // a Private DICT that is read and saved into the Top DICT.
    //
    // In addition to the expected/optional values as outlined in TOP_DICT_META
    // the following values might be saved into the Top DICT.
    //
    //    _subrs []        array of local CFF subroutines from Private DICT
    //    _subrsBias       bias value computed from number of subroutines
    //                      (see calcCFFSubroutineBias() and parseCFFCharstring())
    //    _defaultWidthX   default widths for CFF characters
    //    _nominalWidthX   bias added to width embedded within glyph description
    //
    //    _privateDict     saved copy of parsed Private DICT from Top DICT
    function gatherCFFTopDicts(data, start, cffIndex, strings) {
        var topDictArray = [];
        for (var iTopDict = 0; iTopDict < cffIndex.length; iTopDict += 1) {
            var topDictData = new DataView(new Uint8Array(cffIndex[iTopDict]).buffer);
            var topDict = parseCFFTopDict(topDictData, strings);
            topDict._subrs = [];
            topDict._subrsBias = 0;
            topDict._defaultWidthX = 0;
            topDict._nominalWidthX = 0;
            var privateSize = topDict.private[0];
            var privateOffset = topDict.private[1];
            if (privateSize !== 0 && privateOffset !== 0) {
                var privateDict = parseCFFPrivateDict(data, privateOffset + start, privateSize, strings);
                topDict._defaultWidthX = privateDict.defaultWidthX;
                topDict._nominalWidthX = privateDict.nominalWidthX;
                if (privateDict.subrs !== 0) {
                    var subrOffset = privateOffset + privateDict.subrs;
                    var subrIndex = parseCFFIndex(data, subrOffset + start);
                    topDict._subrs = subrIndex.objects;
                    topDict._subrsBias = calcCFFSubroutineBias(topDict._subrs);
                }
                topDict._privateDict = privateDict;
            }
            topDictArray.push(topDict);
        }
        return topDictArray;
    }

    // Parse the CFF charset table, which contains internal names for all the glyphs.
    // This function will return a list of glyph names.
    // See Adobe TN #5176 chapter 13, "Charsets".
    function parseCFFCharset(data, start, nGlyphs, strings) {
        var sid;
        var count;
        var parser = new parse.Parser(data, start);

        // The .notdef glyph is not included, so subtract 1.
        nGlyphs -= 1;
        var charset = ['.notdef'];

        var format = parser.parseCard8();
        if (format === 0) {
            for (var i = 0; i < nGlyphs; i += 1) {
                sid = parser.parseSID();
                charset.push(getCFFString(strings, sid));
            }
        } else if (format === 1) {
            while (charset.length <= nGlyphs) {
                sid = parser.parseSID();
                count = parser.parseCard8();
                for (var i$1 = 0; i$1 <= count; i$1 += 1) {
                    charset.push(getCFFString(strings, sid));
                    sid += 1;
                }
            }
        } else if (format === 2) {
            while (charset.length <= nGlyphs) {
                sid = parser.parseSID();
                count = parser.parseCard16();
                for (var i$2 = 0; i$2 <= count; i$2 += 1) {
                    charset.push(getCFFString(strings, sid));
                    sid += 1;
                }
            }
        } else {
            throw new Error('Unknown charset format ' + format);
        }

        return charset;
    }

    // Parse the CFF encoding data. Only one encoding can be specified per font.
    // See Adobe TN #5176 chapter 12, "Encodings".
    function parseCFFEncoding(data, start, charset) {
        var code;
        var enc = {};
        var parser = new parse.Parser(data, start);
        var format = parser.parseCard8();
        if (format === 0) {
            var nCodes = parser.parseCard8();
            for (var i = 0; i < nCodes; i += 1) {
                code = parser.parseCard8();
                enc[code] = i;
            }
        } else if (format === 1) {
            var nRanges = parser.parseCard8();
            code = 1;
            for (var i$1 = 0; i$1 < nRanges; i$1 += 1) {
                var first = parser.parseCard8();
                var nLeft = parser.parseCard8();
                for (var j = first; j <= first + nLeft; j += 1) {
                    enc[j] = code;
                    code += 1;
                }
            }
        } else {
            throw new Error('Unknown encoding format ' + format);
        }

        return new CffEncoding(enc, charset);
    }

    // Take in charstring code and return a Glyph object.
    // The encoding is described in the Type 2 Charstring Format
    // https://www.microsoft.com/typography/OTSPEC/charstr2.htm
    function parseCFFCharstring(font, glyph, code) {
        var c1x;
        var c1y;
        var c2x;
        var c2y;
        var p = new Path();
        var stack = [];
        var nStems = 0;
        var haveWidth = false;
        var open = false;
        var x = 0;
        var y = 0;
        var subrs;
        var subrsBias;
        var defaultWidthX;
        var nominalWidthX;
        if (font.isCIDFont) {
            var fdIndex = font.tables.cff.topDict._fdSelect[glyph.index];
            var fdDict = font.tables.cff.topDict._fdArray[fdIndex];
            subrs = fdDict._subrs;
            subrsBias = fdDict._subrsBias;
            defaultWidthX = fdDict._defaultWidthX;
            nominalWidthX = fdDict._nominalWidthX;
        } else {
            subrs = font.tables.cff.topDict._subrs;
            subrsBias = font.tables.cff.topDict._subrsBias;
            defaultWidthX = font.tables.cff.topDict._defaultWidthX;
            nominalWidthX = font.tables.cff.topDict._nominalWidthX;
        }
        var width = defaultWidthX;

        function newContour(x, y) {
            if (open) {
                p.closePath();
            }

            p.moveTo(x, y);
            open = true;
        }

        function parseStems() {
            var hasWidthArg;

            // The number of stem operators on the stack is always even.
            // If the value is uneven, that means a width is specified.
            hasWidthArg = stack.length % 2 !== 0;
            if (hasWidthArg && !haveWidth) {
                width = stack.shift() + nominalWidthX;
            }

            nStems += stack.length >> 1;
            stack.length = 0;
            haveWidth = true;
        }

        function parse(code) {
            var b1;
            var b2;
            var b3;
            var b4;
            var codeIndex;
            var subrCode;
            var jpx;
            var jpy;
            var c3x;
            var c3y;
            var c4x;
            var c4y;

            var i = 0;
            while (i < code.length) {
                var v = code[i];
                i += 1;
                switch (v) {
                    case 1: // hstem
                        parseStems();
                        break;
                    case 3: // vstem
                        parseStems();
                        break;
                    case 4: // vmoveto
                        if (stack.length > 1 && !haveWidth) {
                            width = stack.shift() + nominalWidthX;
                            haveWidth = true;
                        }

                        y += stack.pop();
                        newContour(x, y);
                        break;
                    case 5: // rlineto
                        while (stack.length > 0) {
                            x += stack.shift();
                            y += stack.shift();
                            p.lineTo(x, y);
                        }

                        break;
                    case 6: // hlineto
                        while (stack.length > 0) {
                            x += stack.shift();
                            p.lineTo(x, y);
                            if (stack.length === 0) {
                                break;
                            }

                            y += stack.shift();
                            p.lineTo(x, y);
                        }

                        break;
                    case 7: // vlineto
                        while (stack.length > 0) {
                            y += stack.shift();
                            p.lineTo(x, y);
                            if (stack.length === 0) {
                                break;
                            }

                            x += stack.shift();
                            p.lineTo(x, y);
                        }

                        break;
                    case 8: // rrcurveto
                        while (stack.length > 0) {
                            c1x = x + stack.shift();
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        }

                        break;
                    case 10: // callsubr
                        codeIndex = stack.pop() + subrsBias;
                        subrCode = subrs[codeIndex];
                        if (subrCode) {
                            parse(subrCode);
                        }

                        break;
                    case 11: // return
                        return;
                    case 12: // flex operators
                        v = code[i];
                        i += 1;
                        switch (v) {
                            case 35: // flex
                                // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 dx6 dy6 fd flex (12 35) |-
                                c1x = x   + stack.shift();    // dx1
                                c1y = y   + stack.shift();    // dy1
                                c2x = c1x + stack.shift();    // dx2
                                c2y = c1y + stack.shift();    // dy2
                                jpx = c2x + stack.shift();    // dx3
                                jpy = c2y + stack.shift();    // dy3
                                c3x = jpx + stack.shift();    // dx4
                                c3y = jpy + stack.shift();    // dy4
                                c4x = c3x + stack.shift();    // dx5
                                c4y = c3y + stack.shift();    // dy5
                                x = c4x   + stack.shift();    // dx6
                                y = c4y   + stack.shift();    // dy6
                                stack.shift();                // flex depth
                                p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                                p.curveTo(c3x, c3y, c4x, c4y, x, y);
                                break;
                            case 34: // hflex
                                // |- dx1 dx2 dy2 dx3 dx4 dx5 dx6 hflex (12 34) |-
                                c1x = x   + stack.shift();    // dx1
                                c1y = y;                      // dy1
                                c2x = c1x + stack.shift();    // dx2
                                c2y = c1y + stack.shift();    // dy2
                                jpx = c2x + stack.shift();    // dx3
                                jpy = c2y;                    // dy3
                                c3x = jpx + stack.shift();    // dx4
                                c3y = c2y;                    // dy4
                                c4x = c3x + stack.shift();    // dx5
                                c4y = y;                      // dy5
                                x = c4x + stack.shift();      // dx6
                                p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                                p.curveTo(c3x, c3y, c4x, c4y, x, y);
                                break;
                            case 36: // hflex1
                                // |- dx1 dy1 dx2 dy2 dx3 dx4 dx5 dy5 dx6 hflex1 (12 36) |-
                                c1x = x   + stack.shift();    // dx1
                                c1y = y   + stack.shift();    // dy1
                                c2x = c1x + stack.shift();    // dx2
                                c2y = c1y + stack.shift();    // dy2
                                jpx = c2x + stack.shift();    // dx3
                                jpy = c2y;                    // dy3
                                c3x = jpx + stack.shift();    // dx4
                                c3y = c2y;                    // dy4
                                c4x = c3x + stack.shift();    // dx5
                                c4y = c3y + stack.shift();    // dy5
                                x = c4x + stack.shift();      // dx6
                                p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                                p.curveTo(c3x, c3y, c4x, c4y, x, y);
                                break;
                            case 37: // flex1
                                // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 d6 flex1 (12 37) |-
                                c1x = x   + stack.shift();    // dx1
                                c1y = y   + stack.shift();    // dy1
                                c2x = c1x + stack.shift();    // dx2
                                c2y = c1y + stack.shift();    // dy2
                                jpx = c2x + stack.shift();    // dx3
                                jpy = c2y + stack.shift();    // dy3
                                c3x = jpx + stack.shift();    // dx4
                                c3y = jpy + stack.shift();    // dy4
                                c4x = c3x + stack.shift();    // dx5
                                c4y = c3y + stack.shift();    // dy5
                                if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
                                    x = c4x + stack.shift();
                                } else {
                                    y = c4y + stack.shift();
                                }

                                p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                                p.curveTo(c3x, c3y, c4x, c4y, x, y);
                                break;
                            default:
                                console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
                                stack.length = 0;
                        }
                        break;
                    case 14: // endchar
                        if (stack.length > 0 && !haveWidth) {
                            width = stack.shift() + nominalWidthX;
                            haveWidth = true;
                        }

                        if (open) {
                            p.closePath();
                            open = false;
                        }

                        break;
                    case 18: // hstemhm
                        parseStems();
                        break;
                    case 19: // hintmask
                    case 20: // cntrmask
                        parseStems();
                        i += (nStems + 7) >> 3;
                        break;
                    case 21: // rmoveto
                        if (stack.length > 2 && !haveWidth) {
                            width = stack.shift() + nominalWidthX;
                            haveWidth = true;
                        }

                        y += stack.pop();
                        x += stack.pop();
                        newContour(x, y);
                        break;
                    case 22: // hmoveto
                        if (stack.length > 1 && !haveWidth) {
                            width = stack.shift() + nominalWidthX;
                            haveWidth = true;
                        }

                        x += stack.pop();
                        newContour(x, y);
                        break;
                    case 23: // vstemhm
                        parseStems();
                        break;
                    case 24: // rcurveline
                        while (stack.length > 2) {
                            c1x = x + stack.shift();
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        }

                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                        break;
                    case 25: // rlinecurve
                        while (stack.length > 6) {
                            x += stack.shift();
                            y += stack.shift();
                            p.lineTo(x, y);
                        }

                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        break;
                    case 26: // vvcurveto
                        if (stack.length % 2) {
                            x += stack.shift();
                        }

                        while (stack.length > 0) {
                            c1x = x;
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x;
                            y = c2y + stack.shift();
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        }

                        break;
                    case 27: // hhcurveto
                        if (stack.length % 2) {
                            y += stack.shift();
                        }

                        while (stack.length > 0) {
                            c1x = x + stack.shift();
                            c1y = y;
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y;
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        }

                        break;
                    case 28: // shortint
                        b1 = code[i];
                        b2 = code[i + 1];
                        stack.push(((b1 << 24) | (b2 << 16)) >> 16);
                        i += 2;
                        break;
                    case 29: // callgsubr
                        codeIndex = stack.pop() + font.gsubrsBias;
                        subrCode = font.gsubrs[codeIndex];
                        if (subrCode) {
                            parse(subrCode);
                        }

                        break;
                    case 30: // vhcurveto
                        while (stack.length > 0) {
                            c1x = x;
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + (stack.length === 1 ? stack.shift() : 0);
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                            if (stack.length === 0) {
                                break;
                            }

                            c1x = x + stack.shift();
                            c1y = y;
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            y = c2y + stack.shift();
                            x = c2x + (stack.length === 1 ? stack.shift() : 0);
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        }

                        break;
                    case 31: // hvcurveto
                        while (stack.length > 0) {
                            c1x = x + stack.shift();
                            c1y = y;
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            y = c2y + stack.shift();
                            x = c2x + (stack.length === 1 ? stack.shift() : 0);
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                            if (stack.length === 0) {
                                break;
                            }

                            c1x = x;
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + (stack.length === 1 ? stack.shift() : 0);
                            p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        }

                        break;
                    default:
                        if (v < 32) {
                            console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
                        } else if (v < 247) {
                            stack.push(v - 139);
                        } else if (v < 251) {
                            b1 = code[i];
                            i += 1;
                            stack.push((v - 247) * 256 + b1 + 108);
                        } else if (v < 255) {
                            b1 = code[i];
                            i += 1;
                            stack.push(-(v - 251) * 256 - b1 - 108);
                        } else {
                            b1 = code[i];
                            b2 = code[i + 1];
                            b3 = code[i + 2];
                            b4 = code[i + 3];
                            i += 4;
                            stack.push(((b1 << 24) | (b2 << 16) | (b3 << 8) | b4) / 65536);
                        }
                }
            }
        }

        parse(code);

        glyph.advanceWidth = width;
        return p;
    }

    function parseCFFFDSelect(data, start, nGlyphs, fdArrayCount) {
        var fdSelect = [];
        var fdIndex;
        var parser = new parse.Parser(data, start);
        var format = parser.parseCard8();
        if (format === 0) {
            // Simple list of nGlyphs elements
            for (var iGid = 0; iGid < nGlyphs; iGid++) {
                fdIndex = parser.parseCard8();
                if (fdIndex >= fdArrayCount) {
                    throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
                }
                fdSelect.push(fdIndex);
            }
        } else if (format === 3) {
            // Ranges
            var nRanges = parser.parseCard16();
            var first = parser.parseCard16();
            if (first !== 0) {
                throw new Error('CFF Table CID Font FDSelect format 3 range has bad initial GID ' + first);
            }
            var next;
            for (var iRange = 0; iRange < nRanges; iRange++) {
                fdIndex = parser.parseCard8();
                next = parser.parseCard16();
                if (fdIndex >= fdArrayCount) {
                    throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
                }
                if (next > nGlyphs) {
                    throw new Error('CFF Table CID Font FDSelect format 3 range has bad GID ' + next);
                }
                for (; first < next; first++) {
                    fdSelect.push(fdIndex);
                }
                first = next;
            }
            if (next !== nGlyphs) {
                throw new Error('CFF Table CID Font FDSelect format 3 range has bad final GID ' + next);
            }
        } else {
            throw new Error('CFF Table CID Font FDSelect table has unsupported format ' + format);
        }
        return fdSelect;
    }

    // Parse the `CFF` table, which contains the glyph outlines in PostScript format.
    function parseCFFTable(data, start, font, opt) {
        font.tables.cff = {};
        var header = parseCFFHeader(data, start);
        var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
        var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
        var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
        var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
        font.gsubrs = globalSubrIndex.objects;
        font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);

        var topDictArray = gatherCFFTopDicts(data, start, topDictIndex.objects, stringIndex.objects);
        if (topDictArray.length !== 1) {
            throw new Error('CFF table has too many fonts in \'FontSet\' - count of fonts NameIndex.length = ' + topDictArray.length);
        }

        var topDict = topDictArray[0];
        font.tables.cff.topDict = topDict;

        if (topDict._privateDict) {
            font.defaultWidthX = topDict._privateDict.defaultWidthX;
            font.nominalWidthX = topDict._privateDict.nominalWidthX;
        }

        if (topDict.ros[0] !== undefined && topDict.ros[1] !== undefined) {
            font.isCIDFont = true;
        }

        if (font.isCIDFont) {
            var fdArrayOffset = topDict.fdArray;
            var fdSelectOffset = topDict.fdSelect;
            if (fdArrayOffset === 0 || fdSelectOffset === 0) {
                throw new Error('Font is marked as a CID font, but FDArray and/or FDSelect information is missing');
            }
            fdArrayOffset += start;
            var fdArrayIndex = parseCFFIndex(data, fdArrayOffset);
            var fdArray = gatherCFFTopDicts(data, start, fdArrayIndex.objects, stringIndex.objects);
            topDict._fdArray = fdArray;
            fdSelectOffset += start;
            topDict._fdSelect = parseCFFFDSelect(data, fdSelectOffset, font.numGlyphs, fdArray.length);
        }

        var privateDictOffset = start + topDict.private[1];
        var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict.private[0], stringIndex.objects);
        font.defaultWidthX = privateDict.defaultWidthX;
        font.nominalWidthX = privateDict.nominalWidthX;

        if (privateDict.subrs !== 0) {
            var subrOffset = privateDictOffset + privateDict.subrs;
            var subrIndex = parseCFFIndex(data, subrOffset);
            font.subrs = subrIndex.objects;
            font.subrsBias = calcCFFSubroutineBias(font.subrs);
        } else {
            font.subrs = [];
            font.subrsBias = 0;
        }

        // Offsets in the top dict are relative to the beginning of the CFF data, so add the CFF start offset.
        var charStringsIndex;
        if (opt.lowMemory) {
            charStringsIndex = parseCFFIndexLowMemory(data, start + topDict.charStrings);
            font.nGlyphs = charStringsIndex.offsets.length;
        } else {
            charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
            font.nGlyphs = charStringsIndex.objects.length;
        }

        var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
        if (topDict.encoding === 0) {
            // Standard encoding
            font.cffEncoding = new CffEncoding(cffStandardEncoding, charset);
        } else if (topDict.encoding === 1) {
            // Expert encoding
            font.cffEncoding = new CffEncoding(cffExpertEncoding, charset);
        } else {
            font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
        }

        // Prefer the CMAP encoding to the CFF encoding.
        font.encoding = font.encoding || font.cffEncoding;

        font.glyphs = new glyphset.GlyphSet(font);
        if (opt.lowMemory) {
            font._push = function(i) {
                var charString = getCffIndexObject(i, charStringsIndex.offsets, data, start + topDict.charStrings);
                font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
            };
        } else {
            for (var i = 0; i < font.nGlyphs; i += 1) {
                var charString = charStringsIndex.objects[i];
                font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
            }
        }
    }

    // Convert a string to a String ID (SID).
    // The list of strings is modified in place.
    function encodeString(s, strings) {
        var sid;

        // Is the string in the CFF standard strings?
        var i = cffStandardStrings.indexOf(s);
        if (i >= 0) {
            sid = i;
        }

        // Is the string already in the string index?
        i = strings.indexOf(s);
        if (i >= 0) {
            sid = i + cffStandardStrings.length;
        } else {
            sid = cffStandardStrings.length + strings.length;
            strings.push(s);
        }

        return sid;
    }

    function makeHeader() {
        return new table.Record('Header', [
            {name: 'major', type: 'Card8', value: 1},
            {name: 'minor', type: 'Card8', value: 0},
            {name: 'hdrSize', type: 'Card8', value: 4},
            {name: 'major', type: 'Card8', value: 1}
        ]);
    }

    function makeNameIndex(fontNames) {
        var t = new table.Record('Name INDEX', [
            {name: 'names', type: 'INDEX', value: []}
        ]);
        t.names = [];
        for (var i = 0; i < fontNames.length; i += 1) {
            t.names.push({name: 'name_' + i, type: 'NAME', value: fontNames[i]});
        }

        return t;
    }

    // Given a dictionary's metadata, create a DICT structure.
    function makeDict(meta, attrs, strings) {
        var m = {};
        for (var i = 0; i < meta.length; i += 1) {
            var entry = meta[i];
            var value = attrs[entry.name];
            if (value !== undefined && !equals$1(value, entry.value)) {
                if (entry.type === 'SID') {
                    value = encodeString(value, strings);
                }

                m[entry.op] = {name: entry.name, type: entry.type, value: value};
            }
        }

        return m;
    }

    // The Top DICT houses the global font attributes.
    function makeTopDict(attrs, strings) {
        var t = new table.Record('Top DICT', [
            {name: 'dict', type: 'DICT', value: {}}
        ]);
        t.dict = makeDict(TOP_DICT_META, attrs, strings);
        return t;
    }

    function makeTopDictIndex(topDict) {
        var t = new table.Record('Top DICT INDEX', [
            {name: 'topDicts', type: 'INDEX', value: []}
        ]);
        t.topDicts = [{name: 'topDict_0', type: 'TABLE', value: topDict}];
        return t;
    }

    function makeStringIndex(strings) {
        var t = new table.Record('String INDEX', [
            {name: 'strings', type: 'INDEX', value: []}
        ]);
        t.strings = [];
        for (var i = 0; i < strings.length; i += 1) {
            t.strings.push({name: 'string_' + i, type: 'STRING', value: strings[i]});
        }

        return t;
    }

    function makeGlobalSubrIndex() {
        // Currently we don't use subroutines.
        return new table.Record('Global Subr INDEX', [
            {name: 'subrs', type: 'INDEX', value: []}
        ]);
    }

    function makeCharsets(glyphNames, strings) {
        var t = new table.Record('Charsets', [
            {name: 'format', type: 'Card8', value: 0}
        ]);
        for (var i = 0; i < glyphNames.length; i += 1) {
            var glyphName = glyphNames[i];
            var glyphSID = encodeString(glyphName, strings);
            t.fields.push({name: 'glyph_' + i, type: 'SID', value: glyphSID});
        }

        return t;
    }

    function glyphToOps(glyph) {
        var ops = [];
        var path = glyph.path;
        ops.push({name: 'width', type: 'NUMBER', value: glyph.advanceWidth});
        var x = 0;
        var y = 0;
        for (var i = 0; i < path.commands.length; i += 1) {
            var dx = (void 0);
            var dy = (void 0);
            var cmd = path.commands[i];
            if (cmd.type === 'Q') {
                // CFF only supports bézier curves, so convert the quad to a bézier.
                var _13 = 1 / 3;
                var _23 = 2 / 3;

                // We're going to create a new command so we don't change the original path.
                // Since all coordinates are relative, we round() them ASAP to avoid propagating errors.
                cmd = {
                    type: 'C',
                    x: cmd.x,
                    y: cmd.y,
                    x1: Math.round(_13 * x + _23 * cmd.x1),
                    y1: Math.round(_13 * y + _23 * cmd.y1),
                    x2: Math.round(_13 * cmd.x + _23 * cmd.x1),
                    y2: Math.round(_13 * cmd.y + _23 * cmd.y1)
                };
            }

            if (cmd.type === 'M') {
                dx = Math.round(cmd.x - x);
                dy = Math.round(cmd.y - y);
                ops.push({name: 'dx', type: 'NUMBER', value: dx});
                ops.push({name: 'dy', type: 'NUMBER', value: dy});
                ops.push({name: 'rmoveto', type: 'OP', value: 21});
                x = Math.round(cmd.x);
                y = Math.round(cmd.y);
            } else if (cmd.type === 'L') {
                dx = Math.round(cmd.x - x);
                dy = Math.round(cmd.y - y);
                ops.push({name: 'dx', type: 'NUMBER', value: dx});
                ops.push({name: 'dy', type: 'NUMBER', value: dy});
                ops.push({name: 'rlineto', type: 'OP', value: 5});
                x = Math.round(cmd.x);
                y = Math.round(cmd.y);
            } else if (cmd.type === 'C') {
                var dx1 = Math.round(cmd.x1 - x);
                var dy1 = Math.round(cmd.y1 - y);
                var dx2 = Math.round(cmd.x2 - cmd.x1);
                var dy2 = Math.round(cmd.y2 - cmd.y1);
                dx = Math.round(cmd.x - cmd.x2);
                dy = Math.round(cmd.y - cmd.y2);
                ops.push({name: 'dx1', type: 'NUMBER', value: dx1});
                ops.push({name: 'dy1', type: 'NUMBER', value: dy1});
                ops.push({name: 'dx2', type: 'NUMBER', value: dx2});
                ops.push({name: 'dy2', type: 'NUMBER', value: dy2});
                ops.push({name: 'dx', type: 'NUMBER', value: dx});
                ops.push({name: 'dy', type: 'NUMBER', value: dy});
                ops.push({name: 'rrcurveto', type: 'OP', value: 8});
                x = Math.round(cmd.x);
                y = Math.round(cmd.y);
            }

            // Contours are closed automatically.
        }

        ops.push({name: 'endchar', type: 'OP', value: 14});
        return ops;
    }

    function makeCharStringsIndex(glyphs) {
        var t = new table.Record('CharStrings INDEX', [
            {name: 'charStrings', type: 'INDEX', value: []}
        ]);

        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            var ops = glyphToOps(glyph);
            t.charStrings.push({name: glyph.name, type: 'CHARSTRING', value: ops});
        }

        return t;
    }

    function makePrivateDict(attrs, strings) {
        var t = new table.Record('Private DICT', [
            {name: 'dict', type: 'DICT', value: {}}
        ]);
        t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
        return t;
    }

    function makeCFFTable(glyphs, options) {
        var t = new table.Table('CFF ', [
            {name: 'header', type: 'RECORD'},
            {name: 'nameIndex', type: 'RECORD'},
            {name: 'topDictIndex', type: 'RECORD'},
            {name: 'stringIndex', type: 'RECORD'},
            {name: 'globalSubrIndex', type: 'RECORD'},
            {name: 'charsets', type: 'RECORD'},
            {name: 'charStringsIndex', type: 'RECORD'},
            {name: 'privateDict', type: 'RECORD'}
        ]);

        var fontScale = 1 / options.unitsPerEm;
        // We use non-zero values for the offsets so that the DICT encodes them.
        // This is important because the size of the Top DICT plays a role in offset calculation,
        // and the size shouldn't change after we've written correct offsets.
        var attrs = {
            version: options.version,
            fullName: options.fullName,
            familyName: options.familyName,
            weight: options.weightName,
            fontBBox: options.fontBBox || [0, 0, 0, 0],
            fontMatrix: [fontScale, 0, 0, fontScale, 0, 0],
            charset: 999,
            encoding: 0,
            charStrings: 999,
            private: [0, 999]
        };

        var privateAttrs = {};

        var glyphNames = [];
        var glyph;

        // Skip first glyph (.notdef)
        for (var i = 1; i < glyphs.length; i += 1) {
            glyph = glyphs.get(i);
            glyphNames.push(glyph.name);
        }

        var strings = [];

        t.header = makeHeader();
        t.nameIndex = makeNameIndex([options.postScriptName]);
        var topDict = makeTopDict(attrs, strings);
        t.topDictIndex = makeTopDictIndex(topDict);
        t.globalSubrIndex = makeGlobalSubrIndex();
        t.charsets = makeCharsets(glyphNames, strings);
        t.charStringsIndex = makeCharStringsIndex(glyphs);
        t.privateDict = makePrivateDict(privateAttrs, strings);

        // Needs to come at the end, to encode all custom strings used in the font.
        t.stringIndex = makeStringIndex(strings);

        var startOffset = t.header.sizeOf() +
            t.nameIndex.sizeOf() +
            t.topDictIndex.sizeOf() +
            t.stringIndex.sizeOf() +
            t.globalSubrIndex.sizeOf();
        attrs.charset = startOffset;

        // We use the CFF standard encoding; proper encoding will be handled in cmap.
        attrs.encoding = 0;
        attrs.charStrings = attrs.charset + t.charsets.sizeOf();
        attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();

        // Recreate the Top DICT INDEX with the correct offsets.
        topDict = makeTopDict(attrs, strings);
        t.topDictIndex = makeTopDictIndex(topDict);

        return t;
    }

    var cff = { parse: parseCFFTable, make: makeCFFTable };

    // The `head` table contains global information about the font.

    // Parse the header `head` table
    function parseHeadTable(data, start) {
        var head = {};
        var p = new parse.Parser(data, start);
        head.version = p.parseVersion();
        head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
        head.checkSumAdjustment = p.parseULong();
        head.magicNumber = p.parseULong();
        check.argument(head.magicNumber === 0x5F0F3CF5, 'Font header has wrong magic number.');
        head.flags = p.parseUShort();
        head.unitsPerEm = p.parseUShort();
        head.created = p.parseLongDateTime();
        head.modified = p.parseLongDateTime();
        head.xMin = p.parseShort();
        head.yMin = p.parseShort();
        head.xMax = p.parseShort();
        head.yMax = p.parseShort();
        head.macStyle = p.parseUShort();
        head.lowestRecPPEM = p.parseUShort();
        head.fontDirectionHint = p.parseShort();
        head.indexToLocFormat = p.parseShort();
        head.glyphDataFormat = p.parseShort();
        return head;
    }

    function makeHeadTable(options) {
        // Apple Mac timestamp epoch is 01/01/1904 not 01/01/1970
        var timestamp = Math.round(new Date().getTime() / 1000) + 2082844800;
        var createdTimestamp = timestamp;

        if (options.createdTimestamp) {
            createdTimestamp = options.createdTimestamp + 2082844800;
        }

        return new table.Table('head', [
            {name: 'version', type: 'FIXED', value: 0x00010000},
            {name: 'fontRevision', type: 'FIXED', value: 0x00010000},
            {name: 'checkSumAdjustment', type: 'ULONG', value: 0},
            {name: 'magicNumber', type: 'ULONG', value: 0x5F0F3CF5},
            {name: 'flags', type: 'USHORT', value: 0},
            {name: 'unitsPerEm', type: 'USHORT', value: 1000},
            {name: 'created', type: 'LONGDATETIME', value: createdTimestamp},
            {name: 'modified', type: 'LONGDATETIME', value: timestamp},
            {name: 'xMin', type: 'SHORT', value: 0},
            {name: 'yMin', type: 'SHORT', value: 0},
            {name: 'xMax', type: 'SHORT', value: 0},
            {name: 'yMax', type: 'SHORT', value: 0},
            {name: 'macStyle', type: 'USHORT', value: 0},
            {name: 'lowestRecPPEM', type: 'USHORT', value: 0},
            {name: 'fontDirectionHint', type: 'SHORT', value: 2},
            {name: 'indexToLocFormat', type: 'SHORT', value: 0},
            {name: 'glyphDataFormat', type: 'SHORT', value: 0}
        ], options);
    }

    var head = { parse: parseHeadTable, make: makeHeadTable };

    // The `hhea` table contains information for horizontal layout.

    // Parse the horizontal header `hhea` table
    function parseHheaTable(data, start) {
        var hhea = {};
        var p = new parse.Parser(data, start);
        hhea.version = p.parseVersion();
        hhea.ascender = p.parseShort();
        hhea.descender = p.parseShort();
        hhea.lineGap = p.parseShort();
        hhea.advanceWidthMax = p.parseUShort();
        hhea.minLeftSideBearing = p.parseShort();
        hhea.minRightSideBearing = p.parseShort();
        hhea.xMaxExtent = p.parseShort();
        hhea.caretSlopeRise = p.parseShort();
        hhea.caretSlopeRun = p.parseShort();
        hhea.caretOffset = p.parseShort();
        p.relativeOffset += 8;
        hhea.metricDataFormat = p.parseShort();
        hhea.numberOfHMetrics = p.parseUShort();
        return hhea;
    }

    function makeHheaTable(options) {
        return new table.Table('hhea', [
            {name: 'version', type: 'FIXED', value: 0x00010000},
            {name: 'ascender', type: 'FWORD', value: 0},
            {name: 'descender', type: 'FWORD', value: 0},
            {name: 'lineGap', type: 'FWORD', value: 0},
            {name: 'advanceWidthMax', type: 'UFWORD', value: 0},
            {name: 'minLeftSideBearing', type: 'FWORD', value: 0},
            {name: 'minRightSideBearing', type: 'FWORD', value: 0},
            {name: 'xMaxExtent', type: 'FWORD', value: 0},
            {name: 'caretSlopeRise', type: 'SHORT', value: 1},
            {name: 'caretSlopeRun', type: 'SHORT', value: 0},
            {name: 'caretOffset', type: 'SHORT', value: 0},
            {name: 'reserved1', type: 'SHORT', value: 0},
            {name: 'reserved2', type: 'SHORT', value: 0},
            {name: 'reserved3', type: 'SHORT', value: 0},
            {name: 'reserved4', type: 'SHORT', value: 0},
            {name: 'metricDataFormat', type: 'SHORT', value: 0},
            {name: 'numberOfHMetrics', type: 'USHORT', value: 0}
        ], options);
    }

    var hhea = { parse: parseHheaTable, make: makeHheaTable };

    // The `hmtx` table contains the horizontal metrics for all glyphs.

    function parseHmtxTableAll(data, start, numMetrics, numGlyphs, glyphs) {
        var advanceWidth;
        var leftSideBearing;
        var p = new parse.Parser(data, start);
        for (var i = 0; i < numGlyphs; i += 1) {
            // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
            if (i < numMetrics) {
                advanceWidth = p.parseUShort();
                leftSideBearing = p.parseShort();
            }

            var glyph = glyphs.get(i);
            glyph.advanceWidth = advanceWidth;
            glyph.leftSideBearing = leftSideBearing;
        }
    }

    function parseHmtxTableOnLowMemory(font, data, start, numMetrics, numGlyphs) {
        font._hmtxTableData = {};

        var advanceWidth;
        var leftSideBearing;
        var p = new parse.Parser(data, start);
        for (var i = 0; i < numGlyphs; i += 1) {
            // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
            if (i < numMetrics) {
                advanceWidth = p.parseUShort();
                leftSideBearing = p.parseShort();
            }

            font._hmtxTableData[i] = {
                advanceWidth: advanceWidth,
                leftSideBearing: leftSideBearing
            };
        }
    }

    // Parse the `hmtx` table, which contains the horizontal metrics for all glyphs.
    // This function augments the glyph array, adding the advanceWidth and leftSideBearing to each glyph.
    function parseHmtxTable(font, data, start, numMetrics, numGlyphs, glyphs, opt) {
        if (opt.lowMemory)
            { parseHmtxTableOnLowMemory(font, data, start, numMetrics, numGlyphs); }
        else
            { parseHmtxTableAll(data, start, numMetrics, numGlyphs, glyphs); }
    }

    function makeHmtxTable(glyphs) {
        var t = new table.Table('hmtx', []);
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            var advanceWidth = glyph.advanceWidth || 0;
            var leftSideBearing = glyph.leftSideBearing || 0;
            t.fields.push({name: 'advanceWidth_' + i, type: 'USHORT', value: advanceWidth});
            t.fields.push({name: 'leftSideBearing_' + i, type: 'SHORT', value: leftSideBearing});
        }

        return t;
    }

    var hmtx = { parse: parseHmtxTable, make: makeHmtxTable };

    // The `ltag` table stores IETF BCP-47 language tags. It allows supporting

    function makeLtagTable(tags) {
        var result = new table.Table('ltag', [
            {name: 'version', type: 'ULONG', value: 1},
            {name: 'flags', type: 'ULONG', value: 0},
            {name: 'numTags', type: 'ULONG', value: tags.length}
        ]);

        var stringPool = '';
        var stringPoolOffset = 12 + tags.length * 4;
        for (var i = 0; i < tags.length; ++i) {
            var pos = stringPool.indexOf(tags[i]);
            if (pos < 0) {
                pos = stringPool.length;
                stringPool += tags[i];
            }

            result.fields.push({name: 'offset ' + i, type: 'USHORT', value: stringPoolOffset + pos});
            result.fields.push({name: 'length ' + i, type: 'USHORT', value: tags[i].length});
        }

        result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});
        return result;
    }

    function parseLtagTable(data, start) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseULong();
        check.argument(tableVersion === 1, 'Unsupported ltag table version.');
        // The 'ltag' specification does not define any flags; skip the field.
        p.skip('uLong', 1);
        var numTags = p.parseULong();

        var tags = [];
        for (var i = 0; i < numTags; i++) {
            var tag = '';
            var offset = start + p.parseUShort();
            var length = p.parseUShort();
            for (var j = offset; j < offset + length; ++j) {
                tag += String.fromCharCode(data.getInt8(j));
            }

            tags.push(tag);
        }

        return tags;
    }

    var ltag = { make: makeLtagTable, parse: parseLtagTable };

    // The `maxp` table establishes the memory requirements for the font.

    // Parse the maximum profile `maxp` table.
    function parseMaxpTable(data, start) {
        var maxp = {};
        var p = new parse.Parser(data, start);
        maxp.version = p.parseVersion();
        maxp.numGlyphs = p.parseUShort();
        if (maxp.version === 1.0) {
            maxp.maxPoints = p.parseUShort();
            maxp.maxContours = p.parseUShort();
            maxp.maxCompositePoints = p.parseUShort();
            maxp.maxCompositeContours = p.parseUShort();
            maxp.maxZones = p.parseUShort();
            maxp.maxTwilightPoints = p.parseUShort();
            maxp.maxStorage = p.parseUShort();
            maxp.maxFunctionDefs = p.parseUShort();
            maxp.maxInstructionDefs = p.parseUShort();
            maxp.maxStackElements = p.parseUShort();
            maxp.maxSizeOfInstructions = p.parseUShort();
            maxp.maxComponentElements = p.parseUShort();
            maxp.maxComponentDepth = p.parseUShort();
        }

        return maxp;
    }

    function makeMaxpTable(numGlyphs) {
        return new table.Table('maxp', [
            {name: 'version', type: 'FIXED', value: 0x00005000},
            {name: 'numGlyphs', type: 'USHORT', value: numGlyphs}
        ]);
    }

    var maxp = { parse: parseMaxpTable, make: makeMaxpTable };

    // The `name` naming table.

    // NameIDs for the name table.
    var nameTableNames = [
        'copyright',              // 0
        'fontFamily',             // 1
        'fontSubfamily',          // 2
        'uniqueID',               // 3
        'fullName',               // 4
        'version',                // 5
        'postScriptName',         // 6
        'trademark',              // 7
        'manufacturer',           // 8
        'designer',               // 9
        'description',            // 10
        'manufacturerURL',        // 11
        'designerURL',            // 12
        'license',                // 13
        'licenseURL',             // 14
        'reserved',               // 15
        'preferredFamily',        // 16
        'preferredSubfamily',     // 17
        'compatibleFullName',     // 18
        'sampleText',             // 19
        'postScriptFindFontName', // 20
        'wwsFamily',              // 21
        'wwsSubfamily'            // 22
    ];

    var macLanguages = {
        0: 'en',
        1: 'fr',
        2: 'de',
        3: 'it',
        4: 'nl',
        5: 'sv',
        6: 'es',
        7: 'da',
        8: 'pt',
        9: 'no',
        10: 'he',
        11: 'ja',
        12: 'ar',
        13: 'fi',
        14: 'el',
        15: 'is',
        16: 'mt',
        17: 'tr',
        18: 'hr',
        19: 'zh-Hant',
        20: 'ur',
        21: 'hi',
        22: 'th',
        23: 'ko',
        24: 'lt',
        25: 'pl',
        26: 'hu',
        27: 'es',
        28: 'lv',
        29: 'se',
        30: 'fo',
        31: 'fa',
        32: 'ru',
        33: 'zh',
        34: 'nl-BE',
        35: 'ga',
        36: 'sq',
        37: 'ro',
        38: 'cz',
        39: 'sk',
        40: 'si',
        41: 'yi',
        42: 'sr',
        43: 'mk',
        44: 'bg',
        45: 'uk',
        46: 'be',
        47: 'uz',
        48: 'kk',
        49: 'az-Cyrl',
        50: 'az-Arab',
        51: 'hy',
        52: 'ka',
        53: 'mo',
        54: 'ky',
        55: 'tg',
        56: 'tk',
        57: 'mn-CN',
        58: 'mn',
        59: 'ps',
        60: 'ks',
        61: 'ku',
        62: 'sd',
        63: 'bo',
        64: 'ne',
        65: 'sa',
        66: 'mr',
        67: 'bn',
        68: 'as',
        69: 'gu',
        70: 'pa',
        71: 'or',
        72: 'ml',
        73: 'kn',
        74: 'ta',
        75: 'te',
        76: 'si',
        77: 'my',
        78: 'km',
        79: 'lo',
        80: 'vi',
        81: 'id',
        82: 'tl',
        83: 'ms',
        84: 'ms-Arab',
        85: 'am',
        86: 'ti',
        87: 'om',
        88: 'so',
        89: 'sw',
        90: 'rw',
        91: 'rn',
        92: 'ny',
        93: 'mg',
        94: 'eo',
        128: 'cy',
        129: 'eu',
        130: 'ca',
        131: 'la',
        132: 'qu',
        133: 'gn',
        134: 'ay',
        135: 'tt',
        136: 'ug',
        137: 'dz',
        138: 'jv',
        139: 'su',
        140: 'gl',
        141: 'af',
        142: 'br',
        143: 'iu',
        144: 'gd',
        145: 'gv',
        146: 'ga',
        147: 'to',
        148: 'el-polyton',
        149: 'kl',
        150: 'az',
        151: 'nn'
    };

    // MacOS language ID → MacOS script ID
    //
    // Note that the script ID is not sufficient to determine what encoding
    // to use in TrueType files. For some languages, MacOS used a modification
    // of a mainstream script. For example, an Icelandic name would be stored
    // with smRoman in the TrueType naming table, but the actual encoding
    // is a special Icelandic version of the normal Macintosh Roman encoding.
    // As another example, Inuktitut uses an 8-bit encoding for Canadian Aboriginal
    // Syllables but MacOS had run out of available script codes, so this was
    // done as a (pretty radical) "modification" of Ethiopic.
    //
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
    var macLanguageToScript = {
        0: 0,  // langEnglish → smRoman
        1: 0,  // langFrench → smRoman
        2: 0,  // langGerman → smRoman
        3: 0,  // langItalian → smRoman
        4: 0,  // langDutch → smRoman
        5: 0,  // langSwedish → smRoman
        6: 0,  // langSpanish → smRoman
        7: 0,  // langDanish → smRoman
        8: 0,  // langPortuguese → smRoman
        9: 0,  // langNorwegian → smRoman
        10: 5,  // langHebrew → smHebrew
        11: 1,  // langJapanese → smJapanese
        12: 4,  // langArabic → smArabic
        13: 0,  // langFinnish → smRoman
        14: 6,  // langGreek → smGreek
        15: 0,  // langIcelandic → smRoman (modified)
        16: 0,  // langMaltese → smRoman
        17: 0,  // langTurkish → smRoman (modified)
        18: 0,  // langCroatian → smRoman (modified)
        19: 2,  // langTradChinese → smTradChinese
        20: 4,  // langUrdu → smArabic
        21: 9,  // langHindi → smDevanagari
        22: 21,  // langThai → smThai
        23: 3,  // langKorean → smKorean
        24: 29,  // langLithuanian → smCentralEuroRoman
        25: 29,  // langPolish → smCentralEuroRoman
        26: 29,  // langHungarian → smCentralEuroRoman
        27: 29,  // langEstonian → smCentralEuroRoman
        28: 29,  // langLatvian → smCentralEuroRoman
        29: 0,  // langSami → smRoman
        30: 0,  // langFaroese → smRoman (modified)
        31: 4,  // langFarsi → smArabic (modified)
        32: 7,  // langRussian → smCyrillic
        33: 25,  // langSimpChinese → smSimpChinese
        34: 0,  // langFlemish → smRoman
        35: 0,  // langIrishGaelic → smRoman (modified)
        36: 0,  // langAlbanian → smRoman
        37: 0,  // langRomanian → smRoman (modified)
        38: 29,  // langCzech → smCentralEuroRoman
        39: 29,  // langSlovak → smCentralEuroRoman
        40: 0,  // langSlovenian → smRoman (modified)
        41: 5,  // langYiddish → smHebrew
        42: 7,  // langSerbian → smCyrillic
        43: 7,  // langMacedonian → smCyrillic
        44: 7,  // langBulgarian → smCyrillic
        45: 7,  // langUkrainian → smCyrillic (modified)
        46: 7,  // langByelorussian → smCyrillic
        47: 7,  // langUzbek → smCyrillic
        48: 7,  // langKazakh → smCyrillic
        49: 7,  // langAzerbaijani → smCyrillic
        50: 4,  // langAzerbaijanAr → smArabic
        51: 24,  // langArmenian → smArmenian
        52: 23,  // langGeorgian → smGeorgian
        53: 7,  // langMoldavian → smCyrillic
        54: 7,  // langKirghiz → smCyrillic
        55: 7,  // langTajiki → smCyrillic
        56: 7,  // langTurkmen → smCyrillic
        57: 27,  // langMongolian → smMongolian
        58: 7,  // langMongolianCyr → smCyrillic
        59: 4,  // langPashto → smArabic
        60: 4,  // langKurdish → smArabic
        61: 4,  // langKashmiri → smArabic
        62: 4,  // langSindhi → smArabic
        63: 26,  // langTibetan → smTibetan
        64: 9,  // langNepali → smDevanagari
        65: 9,  // langSanskrit → smDevanagari
        66: 9,  // langMarathi → smDevanagari
        67: 13,  // langBengali → smBengali
        68: 13,  // langAssamese → smBengali
        69: 11,  // langGujarati → smGujarati
        70: 10,  // langPunjabi → smGurmukhi
        71: 12,  // langOriya → smOriya
        72: 17,  // langMalayalam → smMalayalam
        73: 16,  // langKannada → smKannada
        74: 14,  // langTamil → smTamil
        75: 15,  // langTelugu → smTelugu
        76: 18,  // langSinhalese → smSinhalese
        77: 19,  // langBurmese → smBurmese
        78: 20,  // langKhmer → smKhmer
        79: 22,  // langLao → smLao
        80: 30,  // langVietnamese → smVietnamese
        81: 0,  // langIndonesian → smRoman
        82: 0,  // langTagalog → smRoman
        83: 0,  // langMalayRoman → smRoman
        84: 4,  // langMalayArabic → smArabic
        85: 28,  // langAmharic → smEthiopic
        86: 28,  // langTigrinya → smEthiopic
        87: 28,  // langOromo → smEthiopic
        88: 0,  // langSomali → smRoman
        89: 0,  // langSwahili → smRoman
        90: 0,  // langKinyarwanda → smRoman
        91: 0,  // langRundi → smRoman
        92: 0,  // langNyanja → smRoman
        93: 0,  // langMalagasy → smRoman
        94: 0,  // langEsperanto → smRoman
        128: 0,  // langWelsh → smRoman (modified)
        129: 0,  // langBasque → smRoman
        130: 0,  // langCatalan → smRoman
        131: 0,  // langLatin → smRoman
        132: 0,  // langQuechua → smRoman
        133: 0,  // langGuarani → smRoman
        134: 0,  // langAymara → smRoman
        135: 7,  // langTatar → smCyrillic
        136: 4,  // langUighur → smArabic
        137: 26,  // langDzongkha → smTibetan
        138: 0,  // langJavaneseRom → smRoman
        139: 0,  // langSundaneseRom → smRoman
        140: 0,  // langGalician → smRoman
        141: 0,  // langAfrikaans → smRoman
        142: 0,  // langBreton → smRoman (modified)
        143: 28,  // langInuktitut → smEthiopic (modified)
        144: 0,  // langScottishGaelic → smRoman (modified)
        145: 0,  // langManxGaelic → smRoman (modified)
        146: 0,  // langIrishGaelicScript → smRoman (modified)
        147: 0,  // langTongan → smRoman
        148: 6,  // langGreekAncient → smRoman
        149: 0,  // langGreenlandic → smRoman
        150: 0,  // langAzerbaijanRoman → smRoman
        151: 0   // langNynorsk → smRoman
    };

    // While Microsoft indicates a region/country for all its language
    // IDs, we omit the region code if it's equal to the "most likely
    // region subtag" according to Unicode CLDR. For scripts, we omit
    // the subtag if it is equal to the Suppress-Script entry in the
    // IANA language subtag registry for IETF BCP 47.
    //
    // For example, Microsoft states that its language code 0x041A is
    // Croatian in Croatia. We transform this to the BCP 47 language code 'hr'
    // and not 'hr-HR' because Croatia is the default country for Croatian,
    // according to Unicode CLDR. As another example, Microsoft states
    // that 0x101A is Croatian (Latin) in Bosnia-Herzegovina. We transform
    // this to 'hr-BA' and not 'hr-Latn-BA' because Latin is the default script
    // for the Croatian language, according to IANA.
    //
    // http://www.unicode.org/cldr/charts/latest/supplemental/likely_subtags.html
    // http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
    var windowsLanguages = {
        0x0436: 'af',
        0x041C: 'sq',
        0x0484: 'gsw',
        0x045E: 'am',
        0x1401: 'ar-DZ',
        0x3C01: 'ar-BH',
        0x0C01: 'ar',
        0x0801: 'ar-IQ',
        0x2C01: 'ar-JO',
        0x3401: 'ar-KW',
        0x3001: 'ar-LB',
        0x1001: 'ar-LY',
        0x1801: 'ary',
        0x2001: 'ar-OM',
        0x4001: 'ar-QA',
        0x0401: 'ar-SA',
        0x2801: 'ar-SY',
        0x1C01: 'aeb',
        0x3801: 'ar-AE',
        0x2401: 'ar-YE',
        0x042B: 'hy',
        0x044D: 'as',
        0x082C: 'az-Cyrl',
        0x042C: 'az',
        0x046D: 'ba',
        0x042D: 'eu',
        0x0423: 'be',
        0x0845: 'bn',
        0x0445: 'bn-IN',
        0x201A: 'bs-Cyrl',
        0x141A: 'bs',
        0x047E: 'br',
        0x0402: 'bg',
        0x0403: 'ca',
        0x0C04: 'zh-HK',
        0x1404: 'zh-MO',
        0x0804: 'zh',
        0x1004: 'zh-SG',
        0x0404: 'zh-TW',
        0x0483: 'co',
        0x041A: 'hr',
        0x101A: 'hr-BA',
        0x0405: 'cs',
        0x0406: 'da',
        0x048C: 'prs',
        0x0465: 'dv',
        0x0813: 'nl-BE',
        0x0413: 'nl',
        0x0C09: 'en-AU',
        0x2809: 'en-BZ',
        0x1009: 'en-CA',
        0x2409: 'en-029',
        0x4009: 'en-IN',
        0x1809: 'en-IE',
        0x2009: 'en-JM',
        0x4409: 'en-MY',
        0x1409: 'en-NZ',
        0x3409: 'en-PH',
        0x4809: 'en-SG',
        0x1C09: 'en-ZA',
        0x2C09: 'en-TT',
        0x0809: 'en-GB',
        0x0409: 'en',
        0x3009: 'en-ZW',
        0x0425: 'et',
        0x0438: 'fo',
        0x0464: 'fil',
        0x040B: 'fi',
        0x080C: 'fr-BE',
        0x0C0C: 'fr-CA',
        0x040C: 'fr',
        0x140C: 'fr-LU',
        0x180C: 'fr-MC',
        0x100C: 'fr-CH',
        0x0462: 'fy',
        0x0456: 'gl',
        0x0437: 'ka',
        0x0C07: 'de-AT',
        0x0407: 'de',
        0x1407: 'de-LI',
        0x1007: 'de-LU',
        0x0807: 'de-CH',
        0x0408: 'el',
        0x046F: 'kl',
        0x0447: 'gu',
        0x0468: 'ha',
        0x040D: 'he',
        0x0439: 'hi',
        0x040E: 'hu',
        0x040F: 'is',
        0x0470: 'ig',
        0x0421: 'id',
        0x045D: 'iu',
        0x085D: 'iu-Latn',
        0x083C: 'ga',
        0x0434: 'xh',
        0x0435: 'zu',
        0x0410: 'it',
        0x0810: 'it-CH',
        0x0411: 'ja',
        0x044B: 'kn',
        0x043F: 'kk',
        0x0453: 'km',
        0x0486: 'quc',
        0x0487: 'rw',
        0x0441: 'sw',
        0x0457: 'kok',
        0x0412: 'ko',
        0x0440: 'ky',
        0x0454: 'lo',
        0x0426: 'lv',
        0x0427: 'lt',
        0x082E: 'dsb',
        0x046E: 'lb',
        0x042F: 'mk',
        0x083E: 'ms-BN',
        0x043E: 'ms',
        0x044C: 'ml',
        0x043A: 'mt',
        0x0481: 'mi',
        0x047A: 'arn',
        0x044E: 'mr',
        0x047C: 'moh',
        0x0450: 'mn',
        0x0850: 'mn-CN',
        0x0461: 'ne',
        0x0414: 'nb',
        0x0814: 'nn',
        0x0482: 'oc',
        0x0448: 'or',
        0x0463: 'ps',
        0x0415: 'pl',
        0x0416: 'pt',
        0x0816: 'pt-PT',
        0x0446: 'pa',
        0x046B: 'qu-BO',
        0x086B: 'qu-EC',
        0x0C6B: 'qu',
        0x0418: 'ro',
        0x0417: 'rm',
        0x0419: 'ru',
        0x243B: 'smn',
        0x103B: 'smj-NO',
        0x143B: 'smj',
        0x0C3B: 'se-FI',
        0x043B: 'se',
        0x083B: 'se-SE',
        0x203B: 'sms',
        0x183B: 'sma-NO',
        0x1C3B: 'sms',
        0x044F: 'sa',
        0x1C1A: 'sr-Cyrl-BA',
        0x0C1A: 'sr',
        0x181A: 'sr-Latn-BA',
        0x081A: 'sr-Latn',
        0x046C: 'nso',
        0x0432: 'tn',
        0x045B: 'si',
        0x041B: 'sk',
        0x0424: 'sl',
        0x2C0A: 'es-AR',
        0x400A: 'es-BO',
        0x340A: 'es-CL',
        0x240A: 'es-CO',
        0x140A: 'es-CR',
        0x1C0A: 'es-DO',
        0x300A: 'es-EC',
        0x440A: 'es-SV',
        0x100A: 'es-GT',
        0x480A: 'es-HN',
        0x080A: 'es-MX',
        0x4C0A: 'es-NI',
        0x180A: 'es-PA',
        0x3C0A: 'es-PY',
        0x280A: 'es-PE',
        0x500A: 'es-PR',

        // Microsoft has defined two different language codes for
        // “Spanish with modern sorting” and “Spanish with traditional
        // sorting”. This makes sense for collation APIs, and it would be
        // possible to express this in BCP 47 language tags via Unicode
        // extensions (eg., es-u-co-trad is Spanish with traditional
        // sorting). However, for storing names in fonts, the distinction
        // does not make sense, so we give “es” in both cases.
        0x0C0A: 'es',
        0x040A: 'es',

        0x540A: 'es-US',
        0x380A: 'es-UY',
        0x200A: 'es-VE',
        0x081D: 'sv-FI',
        0x041D: 'sv',
        0x045A: 'syr',
        0x0428: 'tg',
        0x085F: 'tzm',
        0x0449: 'ta',
        0x0444: 'tt',
        0x044A: 'te',
        0x041E: 'th',
        0x0451: 'bo',
        0x041F: 'tr',
        0x0442: 'tk',
        0x0480: 'ug',
        0x0422: 'uk',
        0x042E: 'hsb',
        0x0420: 'ur',
        0x0843: 'uz-Cyrl',
        0x0443: 'uz',
        0x042A: 'vi',
        0x0452: 'cy',
        0x0488: 'wo',
        0x0485: 'sah',
        0x0478: 'ii',
        0x046A: 'yo'
    };

    // Returns a IETF BCP 47 language code, for example 'zh-Hant'
    // for 'Chinese in the traditional script'.
    function getLanguageCode(platformID, languageID, ltag) {
        switch (platformID) {
            case 0:  // Unicode
                if (languageID === 0xFFFF) {
                    return 'und';
                } else if (ltag) {
                    return ltag[languageID];
                }

                break;

            case 1:  // Macintosh
                return macLanguages[languageID];

            case 3:  // Windows
                return windowsLanguages[languageID];
        }

        return undefined;
    }

    var utf16 = 'utf-16';

    // MacOS script ID → encoding. This table stores the default case,
    // which can be overridden by macLanguageEncodings.
    var macScriptEncodings = {
        0: 'macintosh',           // smRoman
        1: 'x-mac-japanese',      // smJapanese
        2: 'x-mac-chinesetrad',   // smTradChinese
        3: 'x-mac-korean',        // smKorean
        6: 'x-mac-greek',         // smGreek
        7: 'x-mac-cyrillic',      // smCyrillic
        9: 'x-mac-devanagai',     // smDevanagari
        10: 'x-mac-gurmukhi',     // smGurmukhi
        11: 'x-mac-gujarati',     // smGujarati
        12: 'x-mac-oriya',        // smOriya
        13: 'x-mac-bengali',      // smBengali
        14: 'x-mac-tamil',        // smTamil
        15: 'x-mac-telugu',       // smTelugu
        16: 'x-mac-kannada',      // smKannada
        17: 'x-mac-malayalam',    // smMalayalam
        18: 'x-mac-sinhalese',    // smSinhalese
        19: 'x-mac-burmese',      // smBurmese
        20: 'x-mac-khmer',        // smKhmer
        21: 'x-mac-thai',         // smThai
        22: 'x-mac-lao',          // smLao
        23: 'x-mac-georgian',     // smGeorgian
        24: 'x-mac-armenian',     // smArmenian
        25: 'x-mac-chinesesimp',  // smSimpChinese
        26: 'x-mac-tibetan',      // smTibetan
        27: 'x-mac-mongolian',    // smMongolian
        28: 'x-mac-ethiopic',     // smEthiopic
        29: 'x-mac-ce',           // smCentralEuroRoman
        30: 'x-mac-vietnamese',   // smVietnamese
        31: 'x-mac-extarabic'     // smExtArabic
    };

    // MacOS language ID → encoding. This table stores the exceptional
    // cases, which override macScriptEncodings. For writing MacOS naming
    // tables, we need to emit a MacOS script ID. Therefore, we cannot
    // merge macScriptEncodings into macLanguageEncodings.
    //
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
    var macLanguageEncodings = {
        15: 'x-mac-icelandic',    // langIcelandic
        17: 'x-mac-turkish',      // langTurkish
        18: 'x-mac-croatian',     // langCroatian
        24: 'x-mac-ce',           // langLithuanian
        25: 'x-mac-ce',           // langPolish
        26: 'x-mac-ce',           // langHungarian
        27: 'x-mac-ce',           // langEstonian
        28: 'x-mac-ce',           // langLatvian
        30: 'x-mac-icelandic',    // langFaroese
        37: 'x-mac-romanian',     // langRomanian
        38: 'x-mac-ce',           // langCzech
        39: 'x-mac-ce',           // langSlovak
        40: 'x-mac-ce',           // langSlovenian
        143: 'x-mac-inuit',       // langInuktitut
        146: 'x-mac-gaelic'       // langIrishGaelicScript
    };

    function getEncoding(platformID, encodingID, languageID) {
        switch (platformID) {
            case 0:  // Unicode
                return utf16;

            case 1:  // Apple Macintosh
                return macLanguageEncodings[languageID] || macScriptEncodings[encodingID];

            case 3:  // Microsoft Windows
                if (encodingID === 1 || encodingID === 10) {
                    return utf16;
                }

                break;
        }

        return undefined;
    }

    // Parse the naming `name` table.
    // FIXME: Format 1 additional fields are not supported yet.
    // ltag is the content of the `ltag' table, such as ['en', 'zh-Hans', 'de-CH-1904'].
    function parseNameTable(data, start, ltag) {
        var name = {};
        var p = new parse.Parser(data, start);
        var format = p.parseUShort();
        var count = p.parseUShort();
        var stringOffset = p.offset + p.parseUShort();
        for (var i = 0; i < count; i++) {
            var platformID = p.parseUShort();
            var encodingID = p.parseUShort();
            var languageID = p.parseUShort();
            var nameID = p.parseUShort();
            var property = nameTableNames[nameID] || nameID;
            var byteLength = p.parseUShort();
            var offset = p.parseUShort();
            var language = getLanguageCode(platformID, languageID, ltag);
            var encoding = getEncoding(platformID, encodingID, languageID);
            if (encoding !== undefined && language !== undefined) {
                var text = (void 0);
                if (encoding === utf16) {
                    text = decode.UTF16(data, stringOffset + offset, byteLength);
                } else {
                    text = decode.MACSTRING(data, stringOffset + offset, byteLength, encoding);
                }

                if (text) {
                    var translations = name[property];
                    if (translations === undefined) {
                        translations = name[property] = {};
                    }

                    translations[language] = text;
                }
            }
        }

        var langTagCount = 0;
        if (format === 1) {
            // FIXME: Also handle Microsoft's 'name' table 1.
            langTagCount = p.parseUShort();
        }

        return name;
    }

    // {23: 'foo'} → {'foo': 23}
    // ['bar', 'baz'] → {'bar': 0, 'baz': 1}
    function reverseDict(dict) {
        var result = {};
        for (var key in dict) {
            result[dict[key]] = parseInt(key);
        }

        return result;
    }

    function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
        return new table.Record('NameRecord', [
            {name: 'platformID', type: 'USHORT', value: platformID},
            {name: 'encodingID', type: 'USHORT', value: encodingID},
            {name: 'languageID', type: 'USHORT', value: languageID},
            {name: 'nameID', type: 'USHORT', value: nameID},
            {name: 'length', type: 'USHORT', value: length},
            {name: 'offset', type: 'USHORT', value: offset}
        ]);
    }

    // Finds the position of needle in haystack, or -1 if not there.
    // Like String.indexOf(), but for arrays.
    function findSubArray(needle, haystack) {
        var needleLength = needle.length;
        var limit = haystack.length - needleLength + 1;

        loop:
        for (var pos = 0; pos < limit; pos++) {
            for (; pos < limit; pos++) {
                for (var k = 0; k < needleLength; k++) {
                    if (haystack[pos + k] !== needle[k]) {
                        continue loop;
                    }
                }

                return pos;
            }
        }

        return -1;
    }

    function addStringToPool(s, pool) {
        var offset = findSubArray(s, pool);
        if (offset < 0) {
            offset = pool.length;
            var i = 0;
            var len = s.length;
            for (; i < len; ++i) {
                pool.push(s[i]);
            }

        }

        return offset;
    }

    function makeNameTable(names, ltag) {
        var nameID;
        var nameIDs = [];

        var namesWithNumericKeys = {};
        var nameTableIds = reverseDict(nameTableNames);
        for (var key in names) {
            var id = nameTableIds[key];
            if (id === undefined) {
                id = key;
            }

            nameID = parseInt(id);

            if (isNaN(nameID)) {
                throw new Error('Name table entry "' + key + '" does not exist, see nameTableNames for complete list.');
            }

            namesWithNumericKeys[nameID] = names[key];
            nameIDs.push(nameID);
        }

        var macLanguageIds = reverseDict(macLanguages);
        var windowsLanguageIds = reverseDict(windowsLanguages);

        var nameRecords = [];
        var stringPool = [];

        for (var i = 0; i < nameIDs.length; i++) {
            nameID = nameIDs[i];
            var translations = namesWithNumericKeys[nameID];
            for (var lang in translations) {
                var text = translations[lang];

                // For MacOS, we try to emit the name in the form that was introduced
                // in the initial version of the TrueType spec (in the late 1980s).
                // However, this can fail for various reasons: the requested BCP 47
                // language code might not have an old-style Mac equivalent;
                // we might not have a codec for the needed character encoding;
                // or the name might contain characters that cannot be expressed
                // in the old-style Macintosh encoding. In case of failure, we emit
                // the name in a more modern fashion (Unicode encoding with BCP 47
                // language tags) that is recognized by MacOS 10.5, released in 2009.
                // If fonts were only read by operating systems, we could simply
                // emit all names in the modern form; this would be much easier.
                // However, there are many applications and libraries that read
                // 'name' tables directly, and these will usually only recognize
                // the ancient form (silently skipping the unrecognized names).
                var macPlatform = 1;  // Macintosh
                var macLanguage = macLanguageIds[lang];
                var macScript = macLanguageToScript[macLanguage];
                var macEncoding = getEncoding(macPlatform, macScript, macLanguage);
                var macName = encode.MACSTRING(text, macEncoding);
                if (macName === undefined) {
                    macPlatform = 0;  // Unicode
                    macLanguage = ltag.indexOf(lang);
                    if (macLanguage < 0) {
                        macLanguage = ltag.length;
                        ltag.push(lang);
                    }

                    macScript = 4;  // Unicode 2.0 and later
                    macName = encode.UTF16(text);
                }

                var macNameOffset = addStringToPool(macName, stringPool);
                nameRecords.push(makeNameRecord(macPlatform, macScript, macLanguage,
                                                nameID, macName.length, macNameOffset));

                var winLanguage = windowsLanguageIds[lang];
                if (winLanguage !== undefined) {
                    var winName = encode.UTF16(text);
                    var winNameOffset = addStringToPool(winName, stringPool);
                    nameRecords.push(makeNameRecord(3, 1, winLanguage,
                                                    nameID, winName.length, winNameOffset));
                }
            }
        }

        nameRecords.sort(function(a, b) {
            return ((a.platformID - b.platformID) ||
                    (a.encodingID - b.encodingID) ||
                    (a.languageID - b.languageID) ||
                    (a.nameID - b.nameID));
        });

        var t = new table.Table('name', [
            {name: 'format', type: 'USHORT', value: 0},
            {name: 'count', type: 'USHORT', value: nameRecords.length},
            {name: 'stringOffset', type: 'USHORT', value: 6 + nameRecords.length * 12}
        ]);

        for (var r = 0; r < nameRecords.length; r++) {
            t.fields.push({name: 'record_' + r, type: 'RECORD', value: nameRecords[r]});
        }

        t.fields.push({name: 'strings', type: 'LITERAL', value: stringPool});
        return t;
    }

    var _name = { parse: parseNameTable, make: makeNameTable };

    // The `OS/2` table contains metrics required in OpenType fonts.

    var unicodeRanges = [
        {begin: 0x0000, end: 0x007F}, // Basic Latin
        {begin: 0x0080, end: 0x00FF}, // Latin-1 Supplement
        {begin: 0x0100, end: 0x017F}, // Latin Extended-A
        {begin: 0x0180, end: 0x024F}, // Latin Extended-B
        {begin: 0x0250, end: 0x02AF}, // IPA Extensions
        {begin: 0x02B0, end: 0x02FF}, // Spacing Modifier Letters
        {begin: 0x0300, end: 0x036F}, // Combining Diacritical Marks
        {begin: 0x0370, end: 0x03FF}, // Greek and Coptic
        {begin: 0x2C80, end: 0x2CFF}, // Coptic
        {begin: 0x0400, end: 0x04FF}, // Cyrillic
        {begin: 0x0530, end: 0x058F}, // Armenian
        {begin: 0x0590, end: 0x05FF}, // Hebrew
        {begin: 0xA500, end: 0xA63F}, // Vai
        {begin: 0x0600, end: 0x06FF}, // Arabic
        {begin: 0x07C0, end: 0x07FF}, // NKo
        {begin: 0x0900, end: 0x097F}, // Devanagari
        {begin: 0x0980, end: 0x09FF}, // Bengali
        {begin: 0x0A00, end: 0x0A7F}, // Gurmukhi
        {begin: 0x0A80, end: 0x0AFF}, // Gujarati
        {begin: 0x0B00, end: 0x0B7F}, // Oriya
        {begin: 0x0B80, end: 0x0BFF}, // Tamil
        {begin: 0x0C00, end: 0x0C7F}, // Telugu
        {begin: 0x0C80, end: 0x0CFF}, // Kannada
        {begin: 0x0D00, end: 0x0D7F}, // Malayalam
        {begin: 0x0E00, end: 0x0E7F}, // Thai
        {begin: 0x0E80, end: 0x0EFF}, // Lao
        {begin: 0x10A0, end: 0x10FF}, // Georgian
        {begin: 0x1B00, end: 0x1B7F}, // Balinese
        {begin: 0x1100, end: 0x11FF}, // Hangul Jamo
        {begin: 0x1E00, end: 0x1EFF}, // Latin Extended Additional
        {begin: 0x1F00, end: 0x1FFF}, // Greek Extended
        {begin: 0x2000, end: 0x206F}, // General Punctuation
        {begin: 0x2070, end: 0x209F}, // Superscripts And Subscripts
        {begin: 0x20A0, end: 0x20CF}, // Currency Symbol
        {begin: 0x20D0, end: 0x20FF}, // Combining Diacritical Marks For Symbols
        {begin: 0x2100, end: 0x214F}, // Letterlike Symbols
        {begin: 0x2150, end: 0x218F}, // Number Forms
        {begin: 0x2190, end: 0x21FF}, // Arrows
        {begin: 0x2200, end: 0x22FF}, // Mathematical Operators
        {begin: 0x2300, end: 0x23FF}, // Miscellaneous Technical
        {begin: 0x2400, end: 0x243F}, // Control Pictures
        {begin: 0x2440, end: 0x245F}, // Optical Character Recognition
        {begin: 0x2460, end: 0x24FF}, // Enclosed Alphanumerics
        {begin: 0x2500, end: 0x257F}, // Box Drawing
        {begin: 0x2580, end: 0x259F}, // Block Elements
        {begin: 0x25A0, end: 0x25FF}, // Geometric Shapes
        {begin: 0x2600, end: 0x26FF}, // Miscellaneous Symbols
        {begin: 0x2700, end: 0x27BF}, // Dingbats
        {begin: 0x3000, end: 0x303F}, // CJK Symbols And Punctuation
        {begin: 0x3040, end: 0x309F}, // Hiragana
        {begin: 0x30A0, end: 0x30FF}, // Katakana
        {begin: 0x3100, end: 0x312F}, // Bopomofo
        {begin: 0x3130, end: 0x318F}, // Hangul Compatibility Jamo
        {begin: 0xA840, end: 0xA87F}, // Phags-pa
        {begin: 0x3200, end: 0x32FF}, // Enclosed CJK Letters And Months
        {begin: 0x3300, end: 0x33FF}, // CJK Compatibility
        {begin: 0xAC00, end: 0xD7AF}, // Hangul Syllables
        {begin: 0xD800, end: 0xDFFF}, // Non-Plane 0 *
        {begin: 0x10900, end: 0x1091F}, // Phoenicia
        {begin: 0x4E00, end: 0x9FFF}, // CJK Unified Ideographs
        {begin: 0xE000, end: 0xF8FF}, // Private Use Area (plane 0)
        {begin: 0x31C0, end: 0x31EF}, // CJK Strokes
        {begin: 0xFB00, end: 0xFB4F}, // Alphabetic Presentation Forms
        {begin: 0xFB50, end: 0xFDFF}, // Arabic Presentation Forms-A
        {begin: 0xFE20, end: 0xFE2F}, // Combining Half Marks
        {begin: 0xFE10, end: 0xFE1F}, // Vertical Forms
        {begin: 0xFE50, end: 0xFE6F}, // Small Form Variants
        {begin: 0xFE70, end: 0xFEFF}, // Arabic Presentation Forms-B
        {begin: 0xFF00, end: 0xFFEF}, // Halfwidth And Fullwidth Forms
        {begin: 0xFFF0, end: 0xFFFF}, // Specials
        {begin: 0x0F00, end: 0x0FFF}, // Tibetan
        {begin: 0x0700, end: 0x074F}, // Syriac
        {begin: 0x0780, end: 0x07BF}, // Thaana
        {begin: 0x0D80, end: 0x0DFF}, // Sinhala
        {begin: 0x1000, end: 0x109F}, // Myanmar
        {begin: 0x1200, end: 0x137F}, // Ethiopic
        {begin: 0x13A0, end: 0x13FF}, // Cherokee
        {begin: 0x1400, end: 0x167F}, // Unified Canadian Aboriginal Syllabics
        {begin: 0x1680, end: 0x169F}, // Ogham
        {begin: 0x16A0, end: 0x16FF}, // Runic
        {begin: 0x1780, end: 0x17FF}, // Khmer
        {begin: 0x1800, end: 0x18AF}, // Mongolian
        {begin: 0x2800, end: 0x28FF}, // Braille Patterns
        {begin: 0xA000, end: 0xA48F}, // Yi Syllables
        {begin: 0x1700, end: 0x171F}, // Tagalog
        {begin: 0x10300, end: 0x1032F}, // Old Italic
        {begin: 0x10330, end: 0x1034F}, // Gothic
        {begin: 0x10400, end: 0x1044F}, // Deseret
        {begin: 0x1D000, end: 0x1D0FF}, // Byzantine Musical Symbols
        {begin: 0x1D400, end: 0x1D7FF}, // Mathematical Alphanumeric Symbols
        {begin: 0xFF000, end: 0xFFFFD}, // Private Use (plane 15)
        {begin: 0xFE00, end: 0xFE0F}, // Variation Selectors
        {begin: 0xE0000, end: 0xE007F}, // Tags
        {begin: 0x1900, end: 0x194F}, // Limbu
        {begin: 0x1950, end: 0x197F}, // Tai Le
        {begin: 0x1980, end: 0x19DF}, // New Tai Lue
        {begin: 0x1A00, end: 0x1A1F}, // Buginese
        {begin: 0x2C00, end: 0x2C5F}, // Glagolitic
        {begin: 0x2D30, end: 0x2D7F}, // Tifinagh
        {begin: 0x4DC0, end: 0x4DFF}, // Yijing Hexagram Symbols
        {begin: 0xA800, end: 0xA82F}, // Syloti Nagri
        {begin: 0x10000, end: 0x1007F}, // Linear B Syllabary
        {begin: 0x10140, end: 0x1018F}, // Ancient Greek Numbers
        {begin: 0x10380, end: 0x1039F}, // Ugaritic
        {begin: 0x103A0, end: 0x103DF}, // Old Persian
        {begin: 0x10450, end: 0x1047F}, // Shavian
        {begin: 0x10480, end: 0x104AF}, // Osmanya
        {begin: 0x10800, end: 0x1083F}, // Cypriot Syllabary
        {begin: 0x10A00, end: 0x10A5F}, // Kharoshthi
        {begin: 0x1D300, end: 0x1D35F}, // Tai Xuan Jing Symbols
        {begin: 0x12000, end: 0x123FF}, // Cuneiform
        {begin: 0x1D360, end: 0x1D37F}, // Counting Rod Numerals
        {begin: 0x1B80, end: 0x1BBF}, // Sundanese
        {begin: 0x1C00, end: 0x1C4F}, // Lepcha
        {begin: 0x1C50, end: 0x1C7F}, // Ol Chiki
        {begin: 0xA880, end: 0xA8DF}, // Saurashtra
        {begin: 0xA900, end: 0xA92F}, // Kayah Li
        {begin: 0xA930, end: 0xA95F}, // Rejang
        {begin: 0xAA00, end: 0xAA5F}, // Cham
        {begin: 0x10190, end: 0x101CF}, // Ancient Symbols
        {begin: 0x101D0, end: 0x101FF}, // Phaistos Disc
        {begin: 0x102A0, end: 0x102DF}, // Carian
        {begin: 0x1F030, end: 0x1F09F}  // Domino Tiles
    ];

    function getUnicodeRange(unicode) {
        for (var i = 0; i < unicodeRanges.length; i += 1) {
            var range = unicodeRanges[i];
            if (unicode >= range.begin && unicode < range.end) {
                return i;
            }
        }

        return -1;
    }

    // Parse the OS/2 and Windows metrics `OS/2` table
    function parseOS2Table(data, start) {
        var os2 = {};
        var p = new parse.Parser(data, start);
        os2.version = p.parseUShort();
        os2.xAvgCharWidth = p.parseShort();
        os2.usWeightClass = p.parseUShort();
        os2.usWidthClass = p.parseUShort();
        os2.fsType = p.parseUShort();
        os2.ySubscriptXSize = p.parseShort();
        os2.ySubscriptYSize = p.parseShort();
        os2.ySubscriptXOffset = p.parseShort();
        os2.ySubscriptYOffset = p.parseShort();
        os2.ySuperscriptXSize = p.parseShort();
        os2.ySuperscriptYSize = p.parseShort();
        os2.ySuperscriptXOffset = p.parseShort();
        os2.ySuperscriptYOffset = p.parseShort();
        os2.yStrikeoutSize = p.parseShort();
        os2.yStrikeoutPosition = p.parseShort();
        os2.sFamilyClass = p.parseShort();
        os2.panose = [];
        for (var i = 0; i < 10; i++) {
            os2.panose[i] = p.parseByte();
        }

        os2.ulUnicodeRange1 = p.parseULong();
        os2.ulUnicodeRange2 = p.parseULong();
        os2.ulUnicodeRange3 = p.parseULong();
        os2.ulUnicodeRange4 = p.parseULong();
        os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
        os2.fsSelection = p.parseUShort();
        os2.usFirstCharIndex = p.parseUShort();
        os2.usLastCharIndex = p.parseUShort();
        os2.sTypoAscender = p.parseShort();
        os2.sTypoDescender = p.parseShort();
        os2.sTypoLineGap = p.parseShort();
        os2.usWinAscent = p.parseUShort();
        os2.usWinDescent = p.parseUShort();
        if (os2.version >= 1) {
            os2.ulCodePageRange1 = p.parseULong();
            os2.ulCodePageRange2 = p.parseULong();
        }

        if (os2.version >= 2) {
            os2.sxHeight = p.parseShort();
            os2.sCapHeight = p.parseShort();
            os2.usDefaultChar = p.parseUShort();
            os2.usBreakChar = p.parseUShort();
            os2.usMaxContent = p.parseUShort();
        }

        return os2;
    }

    function makeOS2Table(options) {
        return new table.Table('OS/2', [
            {name: 'version', type: 'USHORT', value: 0x0003},
            {name: 'xAvgCharWidth', type: 'SHORT', value: 0},
            {name: 'usWeightClass', type: 'USHORT', value: 0},
            {name: 'usWidthClass', type: 'USHORT', value: 0},
            {name: 'fsType', type: 'USHORT', value: 0},
            {name: 'ySubscriptXSize', type: 'SHORT', value: 650},
            {name: 'ySubscriptYSize', type: 'SHORT', value: 699},
            {name: 'ySubscriptXOffset', type: 'SHORT', value: 0},
            {name: 'ySubscriptYOffset', type: 'SHORT', value: 140},
            {name: 'ySuperscriptXSize', type: 'SHORT', value: 650},
            {name: 'ySuperscriptYSize', type: 'SHORT', value: 699},
            {name: 'ySuperscriptXOffset', type: 'SHORT', value: 0},
            {name: 'ySuperscriptYOffset', type: 'SHORT', value: 479},
            {name: 'yStrikeoutSize', type: 'SHORT', value: 49},
            {name: 'yStrikeoutPosition', type: 'SHORT', value: 258},
            {name: 'sFamilyClass', type: 'SHORT', value: 0},
            {name: 'bFamilyType', type: 'BYTE', value: 0},
            {name: 'bSerifStyle', type: 'BYTE', value: 0},
            {name: 'bWeight', type: 'BYTE', value: 0},
            {name: 'bProportion', type: 'BYTE', value: 0},
            {name: 'bContrast', type: 'BYTE', value: 0},
            {name: 'bStrokeVariation', type: 'BYTE', value: 0},
            {name: 'bArmStyle', type: 'BYTE', value: 0},
            {name: 'bLetterform', type: 'BYTE', value: 0},
            {name: 'bMidline', type: 'BYTE', value: 0},
            {name: 'bXHeight', type: 'BYTE', value: 0},
            {name: 'ulUnicodeRange1', type: 'ULONG', value: 0},
            {name: 'ulUnicodeRange2', type: 'ULONG', value: 0},
            {name: 'ulUnicodeRange3', type: 'ULONG', value: 0},
            {name: 'ulUnicodeRange4', type: 'ULONG', value: 0},
            {name: 'achVendID', type: 'CHARARRAY', value: 'XXXX'},
            {name: 'fsSelection', type: 'USHORT', value: 0},
            {name: 'usFirstCharIndex', type: 'USHORT', value: 0},
            {name: 'usLastCharIndex', type: 'USHORT', value: 0},
            {name: 'sTypoAscender', type: 'SHORT', value: 0},
            {name: 'sTypoDescender', type: 'SHORT', value: 0},
            {name: 'sTypoLineGap', type: 'SHORT', value: 0},
            {name: 'usWinAscent', type: 'USHORT', value: 0},
            {name: 'usWinDescent', type: 'USHORT', value: 0},
            {name: 'ulCodePageRange1', type: 'ULONG', value: 0},
            {name: 'ulCodePageRange2', type: 'ULONG', value: 0},
            {name: 'sxHeight', type: 'SHORT', value: 0},
            {name: 'sCapHeight', type: 'SHORT', value: 0},
            {name: 'usDefaultChar', type: 'USHORT', value: 0},
            {name: 'usBreakChar', type: 'USHORT', value: 0},
            {name: 'usMaxContext', type: 'USHORT', value: 0}
        ], options);
    }

    var os2 = { parse: parseOS2Table, make: makeOS2Table, unicodeRanges: unicodeRanges, getUnicodeRange: getUnicodeRange };

    // The `post` table stores additional PostScript information, such as glyph names.

    // Parse the PostScript `post` table
    function parsePostTable(data, start) {
        var post = {};
        var p = new parse.Parser(data, start);
        post.version = p.parseVersion();
        post.italicAngle = p.parseFixed();
        post.underlinePosition = p.parseShort();
        post.underlineThickness = p.parseShort();
        post.isFixedPitch = p.parseULong();
        post.minMemType42 = p.parseULong();
        post.maxMemType42 = p.parseULong();
        post.minMemType1 = p.parseULong();
        post.maxMemType1 = p.parseULong();
        switch (post.version) {
            case 1:
                post.names = standardNames.slice();
                break;
            case 2:
                post.numberOfGlyphs = p.parseUShort();
                post.glyphNameIndex = new Array(post.numberOfGlyphs);
                for (var i = 0; i < post.numberOfGlyphs; i++) {
                    post.glyphNameIndex[i] = p.parseUShort();
                }

                post.names = [];
                for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                    if (post.glyphNameIndex[i$1] >= standardNames.length) {
                        var nameLength = p.parseChar();
                        post.names.push(p.parseString(nameLength));
                    }
                }

                break;
            case 2.5:
                post.numberOfGlyphs = p.parseUShort();
                post.offset = new Array(post.numberOfGlyphs);
                for (var i$2 = 0; i$2 < post.numberOfGlyphs; i$2++) {
                    post.offset[i$2] = p.parseChar();
                }

                break;
        }
        return post;
    }

    function makePostTable() {
        return new table.Table('post', [
            {name: 'version', type: 'FIXED', value: 0x00030000},
            {name: 'italicAngle', type: 'FIXED', value: 0},
            {name: 'underlinePosition', type: 'FWORD', value: 0},
            {name: 'underlineThickness', type: 'FWORD', value: 0},
            {name: 'isFixedPitch', type: 'ULONG', value: 0},
            {name: 'minMemType42', type: 'ULONG', value: 0},
            {name: 'maxMemType42', type: 'ULONG', value: 0},
            {name: 'minMemType1', type: 'ULONG', value: 0},
            {name: 'maxMemType1', type: 'ULONG', value: 0}
        ]);
    }

    var post = { parse: parsePostTable, make: makePostTable };

    // The `GSUB` table contains ligatures, among other things.

    var subtableParsers = new Array(9);         // subtableParsers[0] is unused

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#SS
    subtableParsers[1] = function parseLookup1() {
        var start = this.offset + this.relativeOffset;
        var substFormat = this.parseUShort();
        if (substFormat === 1) {
            return {
                substFormat: 1,
                coverage: this.parsePointer(Parser.coverage),
                deltaGlyphId: this.parseUShort()
            };
        } else if (substFormat === 2) {
            return {
                substFormat: 2,
                coverage: this.parsePointer(Parser.coverage),
                substitute: this.parseOffset16List()
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': lookup type 1 format must be 1 or 2.');
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#MS
    subtableParsers[2] = function parseLookup2() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Multiple Substitution Subtable identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            sequences: this.parseListOfLists()
        };
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#AS
    subtableParsers[3] = function parseLookup3() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Alternate Substitution Subtable identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            alternateSets: this.parseListOfLists()
        };
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#LS
    subtableParsers[4] = function parseLookup4() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB ligature table identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            ligatureSets: this.parseListOfLists(function() {
                return {
                    ligGlyph: this.parseUShort(),
                    components: this.parseUShortList(this.parseUShort() - 1)
                };
            })
        };
    };

    var lookupRecordDesc = {
        sequenceIndex: Parser.uShort,
        lookupListIndex: Parser.uShort
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CSF
    subtableParsers[5] = function parseLookup5() {
        var start = this.offset + this.relativeOffset;
        var substFormat = this.parseUShort();

        if (substFormat === 1) {
            return {
                substFormat: substFormat,
                coverage: this.parsePointer(Parser.coverage),
                ruleSets: this.parseListOfLists(function() {
                    var glyphCount = this.parseUShort();
                    var substCount = this.parseUShort();
                    return {
                        input: this.parseUShortList(glyphCount - 1),
                        lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 2) {
            return {
                substFormat: substFormat,
                coverage: this.parsePointer(Parser.coverage),
                classDef: this.parsePointer(Parser.classDef),
                classSets: this.parseListOfLists(function() {
                    var glyphCount = this.parseUShort();
                    var substCount = this.parseUShort();
                    return {
                        classes: this.parseUShortList(glyphCount - 1),
                        lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 3) {
            var glyphCount = this.parseUShort();
            var substCount = this.parseUShort();
            return {
                substFormat: substFormat,
                coverages: this.parseList(glyphCount, Parser.pointer(Parser.coverage)),
                lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': lookup type 5 format must be 1, 2 or 3.');
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CC
    subtableParsers[6] = function parseLookup6() {
        var start = this.offset + this.relativeOffset;
        var substFormat = this.parseUShort();
        if (substFormat === 1) {
            return {
                substFormat: 1,
                coverage: this.parsePointer(Parser.coverage),
                chainRuleSets: this.parseListOfLists(function() {
                    return {
                        backtrack: this.parseUShortList(),
                        input: this.parseUShortList(this.parseShort() - 1),
                        lookahead: this.parseUShortList(),
                        lookupRecords: this.parseRecordList(lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 2) {
            return {
                substFormat: 2,
                coverage: this.parsePointer(Parser.coverage),
                backtrackClassDef: this.parsePointer(Parser.classDef),
                inputClassDef: this.parsePointer(Parser.classDef),
                lookaheadClassDef: this.parsePointer(Parser.classDef),
                chainClassSet: this.parseListOfLists(function() {
                    return {
                        backtrack: this.parseUShortList(),
                        input: this.parseUShortList(this.parseShort() - 1),
                        lookahead: this.parseUShortList(),
                        lookupRecords: this.parseRecordList(lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 3) {
            return {
                substFormat: 3,
                backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
                inputCoverage: this.parseList(Parser.pointer(Parser.coverage)),
                lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
                lookupRecords: this.parseRecordList(lookupRecordDesc)
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': lookup type 6 format must be 1, 2 or 3.');
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#ES
    subtableParsers[7] = function parseLookup7() {
        // Extension Substitution subtable
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Extension Substitution subtable identifier-format must be 1');
        var extensionLookupType = this.parseUShort();
        var extensionParser = new Parser(this.data, this.offset + this.parseULong());
        return {
            substFormat: 1,
            lookupType: extensionLookupType,
            extension: subtableParsers[extensionLookupType].call(extensionParser)
        };
    };

    // https://www.microsoft.com/typography/OTSPEC/GSUB.htm#RCCS
    subtableParsers[8] = function parseLookup8() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            substitutes: this.parseUShortList()
        };
    };

    // https://www.microsoft.com/typography/OTSPEC/gsub.htm
    function parseGsubTable(data, start) {
        start = start || 0;
        var p = new Parser(data, start);
        var tableVersion = p.parseVersion(1);
        check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GSUB table version.');
        if (tableVersion === 1) {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers)
            };
        } else {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers),
                variations: p.parseFeatureVariationsList()
            };
        }

    }

    // GSUB Writing //////////////////////////////////////////////
    var subtableMakers = new Array(9);

    subtableMakers[1] = function makeLookup1(subtable) {
        if (subtable.substFormat === 1) {
            return new table.Table('substitutionTable', [
                {name: 'substFormat', type: 'USHORT', value: 1},
                {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)},
                {name: 'deltaGlyphID', type: 'USHORT', value: subtable.deltaGlyphId}
            ]);
        } else {
            return new table.Table('substitutionTable', [
                {name: 'substFormat', type: 'USHORT', value: 2},
                {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
            ].concat(table.ushortList('substitute', subtable.substitute)));
        }
    };

    subtableMakers[2] = function makeLookup2(subtable) {
        check.assert(subtable.substFormat === 1, 'Lookup type 2 substFormat must be 1.');
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 1},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
        ].concat(table.tableList('seqSet', subtable.sequences, function(sequenceSet) {
            return new table.Table('sequenceSetTable', table.ushortList('sequence', sequenceSet));
        })));
    };

    subtableMakers[3] = function makeLookup3(subtable) {
        check.assert(subtable.substFormat === 1, 'Lookup type 3 substFormat must be 1.');
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 1},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
        ].concat(table.tableList('altSet', subtable.alternateSets, function(alternateSet) {
            return new table.Table('alternateSetTable', table.ushortList('alternate', alternateSet));
        })));
    };

    subtableMakers[4] = function makeLookup4(subtable) {
        check.assert(subtable.substFormat === 1, 'Lookup type 4 substFormat must be 1.');
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 1},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
        ].concat(table.tableList('ligSet', subtable.ligatureSets, function(ligatureSet) {
            return new table.Table('ligatureSetTable', table.tableList('ligature', ligatureSet, function(ligature) {
                return new table.Table('ligatureTable',
                    [{name: 'ligGlyph', type: 'USHORT', value: ligature.ligGlyph}]
                    .concat(table.ushortList('component', ligature.components, ligature.components.length + 1))
                );
            }));
        })));
    };

    subtableMakers[6] = function makeLookup6(subtable) {
        if (subtable.substFormat === 1) {
            var returnTable = new table.Table('chainContextTable', [
                {name: 'substFormat', type: 'USHORT', value: subtable.substFormat},
                {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
            ].concat(table.tableList('chainRuleSet', subtable.chainRuleSets, function(chainRuleSet) {
                return new table.Table('chainRuleSetTable', table.tableList('chainRule', chainRuleSet, function(chainRule) {
                    var tableData = table.ushortList('backtrackGlyph', chainRule.backtrack, chainRule.backtrack.length)
                        .concat(table.ushortList('inputGlyph', chainRule.input, chainRule.input.length + 1))
                        .concat(table.ushortList('lookaheadGlyph', chainRule.lookahead, chainRule.lookahead.length))
                        .concat(table.ushortList('substitution', [], chainRule.lookupRecords.length));

                    chainRule.lookupRecords.forEach(function (record, i) {
                        tableData = tableData
                            .concat({name: 'sequenceIndex' + i, type: 'USHORT', value: record.sequenceIndex})
                            .concat({name: 'lookupListIndex' + i, type: 'USHORT', value: record.lookupListIndex});
                    });
                    return new table.Table('chainRuleTable', tableData);
                }));
            })));
            return returnTable;
        } else if (subtable.substFormat === 2) {
            check.assert(false, 'lookup type 6 format 2 is not yet supported.');
        } else if (subtable.substFormat === 3) {
            var tableData = [
                {name: 'substFormat', type: 'USHORT', value: subtable.substFormat} ];

            tableData.push({name: 'backtrackGlyphCount', type: 'USHORT', value: subtable.backtrackCoverage.length});
            subtable.backtrackCoverage.forEach(function (coverage, i) {
                tableData.push({name: 'backtrackCoverage' + i, type: 'TABLE', value: new table.Coverage(coverage)});
            });
            tableData.push({name: 'inputGlyphCount', type: 'USHORT', value: subtable.inputCoverage.length});
            subtable.inputCoverage.forEach(function (coverage, i) {
                tableData.push({name: 'inputCoverage' + i, type: 'TABLE', value: new table.Coverage(coverage)});
            });
            tableData.push({name: 'lookaheadGlyphCount', type: 'USHORT', value: subtable.lookaheadCoverage.length});
            subtable.lookaheadCoverage.forEach(function (coverage, i) {
                tableData.push({name: 'lookaheadCoverage' + i, type: 'TABLE', value: new table.Coverage(coverage)});
            });

            tableData.push({name: 'substitutionCount', type: 'USHORT', value: subtable.lookupRecords.length});
            subtable.lookupRecords.forEach(function (record, i) {
                tableData = tableData
                    .concat({name: 'sequenceIndex' + i, type: 'USHORT', value: record.sequenceIndex})
                    .concat({name: 'lookupListIndex' + i, type: 'USHORT', value: record.lookupListIndex});
            });

            var returnTable$1 = new table.Table('chainContextTable', tableData);

            return returnTable$1;
        }

        check.assert(false, 'lookup type 6 format must be 1, 2 or 3.');
    };

    function makeGsubTable(gsub) {
        return new table.Table('GSUB', [
            {name: 'version', type: 'ULONG', value: 0x10000},
            {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gsub.scripts)},
            {name: 'features', type: 'TABLE', value: new table.FeatureList(gsub.features)},
            {name: 'lookups', type: 'TABLE', value: new table.LookupList(gsub.lookups, subtableMakers)}
        ]);
    }

    var gsub = { parse: parseGsubTable, make: makeGsubTable };

    // The `GPOS` table contains kerning pairs, among other things.

    // Parse the metadata `meta` table.
    // https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6meta.html
    function parseMetaTable(data, start) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseULong();
        check.argument(tableVersion === 1, 'Unsupported META table version.');
        p.parseULong(); // flags - currently unused and set to 0
        p.parseULong(); // tableOffset
        var numDataMaps = p.parseULong();

        var tags = {};
        for (var i = 0; i < numDataMaps; i++) {
            var tag = p.parseTag();
            var dataOffset = p.parseULong();
            var dataLength = p.parseULong();
            var text = decode.UTF8(data, start + dataOffset, dataLength);

            tags[tag] = text;
        }
        return tags;
    }

    function makeMetaTable(tags) {
        var numTags = Object.keys(tags).length;
        var stringPool = '';
        var stringPoolOffset = 16 + numTags * 12;

        var result = new table.Table('meta', [
            {name: 'version', type: 'ULONG', value: 1},
            {name: 'flags', type: 'ULONG', value: 0},
            {name: 'offset', type: 'ULONG', value: stringPoolOffset},
            {name: 'numTags', type: 'ULONG', value: numTags}
        ]);

        for (var tag in tags) {
            var pos = stringPool.length;
            stringPool += tags[tag];

            result.fields.push({name: 'tag ' + tag, type: 'TAG', value: tag});
            result.fields.push({name: 'offset ' + tag, type: 'ULONG', value: stringPoolOffset + pos});
            result.fields.push({name: 'length ' + tag, type: 'ULONG', value: tags[tag].length});
        }

        result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});

        return result;
    }

    var meta = { parse: parseMetaTable, make: makeMetaTable };

    // The `sfnt` wrapper provides organization for the tables in the font.

    function log2(v) {
        return Math.log(v) / Math.log(2) | 0;
    }

    function computeCheckSum(bytes) {
        while (bytes.length % 4 !== 0) {
            bytes.push(0);
        }

        var sum = 0;
        for (var i = 0; i < bytes.length; i += 4) {
            sum += (bytes[i] << 24) +
                (bytes[i + 1] << 16) +
                (bytes[i + 2] << 8) +
                (bytes[i + 3]);
        }

        sum %= Math.pow(2, 32);
        return sum;
    }

    function makeTableRecord(tag, checkSum, offset, length) {
        return new table.Record('Table Record', [
            {name: 'tag', type: 'TAG', value: tag !== undefined ? tag : ''},
            {name: 'checkSum', type: 'ULONG', value: checkSum !== undefined ? checkSum : 0},
            {name: 'offset', type: 'ULONG', value: offset !== undefined ? offset : 0},
            {name: 'length', type: 'ULONG', value: length !== undefined ? length : 0}
        ]);
    }

    function makeSfntTable(tables) {
        var sfnt = new table.Table('sfnt', [
            {name: 'version', type: 'TAG', value: 'OTTO'},
            {name: 'numTables', type: 'USHORT', value: 0},
            {name: 'searchRange', type: 'USHORT', value: 0},
            {name: 'entrySelector', type: 'USHORT', value: 0},
            {name: 'rangeShift', type: 'USHORT', value: 0}
        ]);
        sfnt.tables = tables;
        sfnt.numTables = tables.length;
        var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
        sfnt.searchRange = 16 * highestPowerOf2;
        sfnt.entrySelector = log2(highestPowerOf2);
        sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;

        var recordFields = [];
        var tableFields = [];

        var offset = sfnt.sizeOf() + (makeTableRecord().sizeOf() * sfnt.numTables);
        while (offset % 4 !== 0) {
            offset += 1;
            tableFields.push({name: 'padding', type: 'BYTE', value: 0});
        }

        for (var i = 0; i < tables.length; i += 1) {
            var t = tables[i];
            check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
            var tableLength = t.sizeOf();
            var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
            recordFields.push({name: tableRecord.tag + ' Table Record', type: 'RECORD', value: tableRecord});
            tableFields.push({name: t.tableName + ' table', type: 'RECORD', value: t});
            offset += tableLength;
            check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
            while (offset % 4 !== 0) {
                offset += 1;
                tableFields.push({name: 'padding', type: 'BYTE', value: 0});
            }
        }

        // Table records need to be sorted alphabetically.
        recordFields.sort(function(r1, r2) {
            if (r1.value.tag > r2.value.tag) {
                return 1;
            } else {
                return -1;
            }
        });

        sfnt.fields = sfnt.fields.concat(recordFields);
        sfnt.fields = sfnt.fields.concat(tableFields);
        return sfnt;
    }

    // Get the metrics for a character. If the string has more than one character
    // this function returns metrics for the first available character.
    // You can provide optional fallback metrics if no characters are available.
    function metricsForChar(font, chars, notFoundMetrics) {
        for (var i = 0; i < chars.length; i += 1) {
            var glyphIndex = font.charToGlyphIndex(chars[i]);
            if (glyphIndex > 0) {
                var glyph = font.glyphs.get(glyphIndex);
                return glyph.getMetrics();
            }
        }

        return notFoundMetrics;
    }

    function average(vs) {
        var sum = 0;
        for (var i = 0; i < vs.length; i += 1) {
            sum += vs[i];
        }

        return sum / vs.length;
    }

    // Convert the font object to a SFNT data structure.
    // This structure contains all the necessary tables and metadata to create a binary OTF file.
    function fontToSfntTable(font) {
        var xMins = [];
        var yMins = [];
        var xMaxs = [];
        var yMaxs = [];
        var advanceWidths = [];
        var leftSideBearings = [];
        var rightSideBearings = [];
        var firstCharIndex;
        var lastCharIndex = 0;
        var ulUnicodeRange1 = 0;
        var ulUnicodeRange2 = 0;
        var ulUnicodeRange3 = 0;
        var ulUnicodeRange4 = 0;

        for (var i = 0; i < font.glyphs.length; i += 1) {
            var glyph = font.glyphs.get(i);
            var unicode = glyph.unicode | 0;

            if (isNaN(glyph.advanceWidth)) {
                throw new Error('Glyph ' + glyph.name + ' (' + i + '): advanceWidth is not a number.');
            }

            if (firstCharIndex > unicode || firstCharIndex === undefined) {
                // ignore .notdef char
                if (unicode > 0) {
                    firstCharIndex = unicode;
                }
            }

            if (lastCharIndex < unicode) {
                lastCharIndex = unicode;
            }

            var position = os2.getUnicodeRange(unicode);
            if (position < 32) {
                ulUnicodeRange1 |= 1 << position;
            } else if (position < 64) {
                ulUnicodeRange2 |= 1 << position - 32;
            } else if (position < 96) {
                ulUnicodeRange3 |= 1 << position - 64;
            } else if (position < 123) {
                ulUnicodeRange4 |= 1 << position - 96;
            } else {
                throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
            }
            // Skip non-important characters.
            if (glyph.name === '.notdef') { continue; }
            var metrics = glyph.getMetrics();
            xMins.push(metrics.xMin);
            yMins.push(metrics.yMin);
            xMaxs.push(metrics.xMax);
            yMaxs.push(metrics.yMax);
            leftSideBearings.push(metrics.leftSideBearing);
            rightSideBearings.push(metrics.rightSideBearing);
            advanceWidths.push(glyph.advanceWidth);
        }

        var globals = {
            xMin: Math.min.apply(null, xMins),
            yMin: Math.min.apply(null, yMins),
            xMax: Math.max.apply(null, xMaxs),
            yMax: Math.max.apply(null, yMaxs),
            advanceWidthMax: Math.max.apply(null, advanceWidths),
            advanceWidthAvg: average(advanceWidths),
            minLeftSideBearing: Math.min.apply(null, leftSideBearings),
            maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
            minRightSideBearing: Math.min.apply(null, rightSideBearings)
        };
        globals.ascender = font.ascender;
        globals.descender = font.descender;

        var headTable = head.make({
            flags: 3, // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
            unitsPerEm: font.unitsPerEm,
            xMin: globals.xMin,
            yMin: globals.yMin,
            xMax: globals.xMax,
            yMax: globals.yMax,
            lowestRecPPEM: 3,
            createdTimestamp: font.createdTimestamp
        });

        var hheaTable = hhea.make({
            ascender: globals.ascender,
            descender: globals.descender,
            advanceWidthMax: globals.advanceWidthMax,
            minLeftSideBearing: globals.minLeftSideBearing,
            minRightSideBearing: globals.minRightSideBearing,
            xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
            numberOfHMetrics: font.glyphs.length
        });

        var maxpTable = maxp.make(font.glyphs.length);

        var os2Table = os2.make(Object.assign({
            xAvgCharWidth: Math.round(globals.advanceWidthAvg),
            usFirstCharIndex: firstCharIndex,
            usLastCharIndex: lastCharIndex,
            ulUnicodeRange1: ulUnicodeRange1,
            ulUnicodeRange2: ulUnicodeRange2,
            ulUnicodeRange3: ulUnicodeRange3,
            ulUnicodeRange4: ulUnicodeRange4,
            // See http://typophile.com/node/13081 for more info on vertical metrics.
            // We get metrics for typical characters (such as "x" for xHeight).
            // We provide some fallback characters if characters are unavailable: their
            // ordering was chosen experimentally.
            sTypoAscender: globals.ascender,
            sTypoDescender: globals.descender,
            sTypoLineGap: 0,
            usWinAscent: globals.yMax,
            usWinDescent: Math.abs(globals.yMin),
            ulCodePageRange1: 1, // FIXME: hard-code Latin 1 support for now
            sxHeight: metricsForChar(font, 'xyvw', {yMax: Math.round(globals.ascender / 2)}).yMax,
            sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
            usDefaultChar: font.hasChar(' ') ? 32 : 0, // Use space as the default character, if available.
            usBreakChar: font.hasChar(' ') ? 32 : 0, // Use space as the break character, if available.
        }, font.tables.os2));

        var hmtxTable = hmtx.make(font.glyphs);
        var cmapTable = cmap.make(font.glyphs);

        var englishFamilyName = font.getEnglishName('fontFamily');
        var englishStyleName = font.getEnglishName('fontSubfamily');
        var englishFullName = englishFamilyName + ' ' + englishStyleName;
        var postScriptName = font.getEnglishName('postScriptName');
        if (!postScriptName) {
            postScriptName = englishFamilyName.replace(/\s/g, '') + '-' + englishStyleName;
        }

        var names = {};
        for (var n in font.names) {
            names[n] = font.names[n];
        }

        if (!names.uniqueID) {
            names.uniqueID = {en: font.getEnglishName('manufacturer') + ':' + englishFullName};
        }

        if (!names.postScriptName) {
            names.postScriptName = {en: postScriptName};
        }

        if (!names.preferredFamily) {
            names.preferredFamily = font.names.fontFamily;
        }

        if (!names.preferredSubfamily) {
            names.preferredSubfamily = font.names.fontSubfamily;
        }

        var languageTags = [];
        var nameTable = _name.make(names, languageTags);
        var ltagTable = (languageTags.length > 0 ? ltag.make(languageTags) : undefined);

        var postTable = post.make();
        var cffTable = cff.make(font.glyphs, {
            version: font.getEnglishName('version'),
            fullName: englishFullName,
            familyName: englishFamilyName,
            weightName: englishStyleName,
            postScriptName: postScriptName,
            unitsPerEm: font.unitsPerEm,
            fontBBox: [0, globals.yMin, globals.ascender, globals.advanceWidthMax]
        });

        var metaTable = (font.metas && Object.keys(font.metas).length > 0) ? meta.make(font.metas) : undefined;

        // The order does not matter because makeSfntTable() will sort them.
        var tables = [headTable, hheaTable, maxpTable, os2Table, nameTable, cmapTable, postTable, cffTable, hmtxTable];
        if (ltagTable) {
            tables.push(ltagTable);
        }
        // Optional tables
        if (font.tables.gsub) {
            tables.push(gsub.make(font.tables.gsub));
        }
        if (metaTable) {
            tables.push(metaTable);
        }

        var sfntTable = makeSfntTable(tables);

        // Compute the font's checkSum and store it in head.checkSumAdjustment.
        var bytes = sfntTable.encode();
        var checkSum = computeCheckSum(bytes);
        var tableFields = sfntTable.fields;
        var checkSumAdjusted = false;
        for (var i$1 = 0; i$1 < tableFields.length; i$1 += 1) {
            if (tableFields[i$1].name === 'head table') {
                tableFields[i$1].value.checkSumAdjustment = 0xB1B0AFBA - checkSum;
                checkSumAdjusted = true;
                break;
            }
        }

        if (!checkSumAdjusted) {
            throw new Error('Could not find head table with checkSum to adjust.');
        }

        return sfntTable;
    }

    var sfnt = { make: makeSfntTable, fontToTable: fontToSfntTable, computeCheckSum: computeCheckSum };

    // The Layout object is the prototype of Substitution objects, and provides

    function searchTag(arr, tag) {
        /* jshint bitwise: false */
        var imin = 0;
        var imax = arr.length - 1;
        while (imin <= imax) {
            var imid = (imin + imax) >>> 1;
            var val = arr[imid].tag;
            if (val === tag) {
                return imid;
            } else if (val < tag) {
                imin = imid + 1;
            } else { imax = imid - 1; }
        }
        // Not found: return -1-insertion point
        return -imin - 1;
    }

    function binSearch(arr, value) {
        /* jshint bitwise: false */
        var imin = 0;
        var imax = arr.length - 1;
        while (imin <= imax) {
            var imid = (imin + imax) >>> 1;
            var val = arr[imid];
            if (val === value) {
                return imid;
            } else if (val < value) {
                imin = imid + 1;
            } else { imax = imid - 1; }
        }
        // Not found: return -1-insertion point
        return -imin - 1;
    }

    // binary search in a list of ranges (coverage, class definition)
    function searchRange(ranges, value) {
        // jshint bitwise: false
        var range;
        var imin = 0;
        var imax = ranges.length - 1;
        while (imin <= imax) {
            var imid = (imin + imax) >>> 1;
            range = ranges[imid];
            var start = range.start;
            if (start === value) {
                return range;
            } else if (start < value) {
                imin = imid + 1;
            } else { imax = imid - 1; }
        }
        if (imin > 0) {
            range = ranges[imin - 1];
            if (value > range.end) { return 0; }
            return range;
        }
    }

    /**
     * @exports opentype.Layout
     * @class
     */
    function Layout(font, tableName) {
        this.font = font;
        this.tableName = tableName;
    }

    Layout.prototype = {

        /**
         * Binary search an object by "tag" property
         * @instance
         * @function searchTag
         * @memberof opentype.Layout
         * @param  {Array} arr
         * @param  {string} tag
         * @return {number}
         */
        searchTag: searchTag,

        /**
         * Binary search in a list of numbers
         * @instance
         * @function binSearch
         * @memberof opentype.Layout
         * @param  {Array} arr
         * @param  {number} value
         * @return {number}
         */
        binSearch: binSearch,

        /**
         * Get or create the Layout table (GSUB, GPOS etc).
         * @param  {boolean} create - Whether to create a new one.
         * @return {Object} The GSUB or GPOS table.
         */
        getTable: function(create) {
            var layout = this.font.tables[this.tableName];
            if (!layout && create) {
                layout = this.font.tables[this.tableName] = this.createDefaultTable();
            }
            return layout;
        },

        /**
         * Returns all scripts in the substitution table.
         * @instance
         * @return {Array}
         */
        getScriptNames: function() {
            var layout = this.getTable();
            if (!layout) { return []; }
            return layout.scripts.map(function(script) {
                return script.tag;
            });
        },

        /**
         * Returns the best bet for a script name.
         * Returns 'DFLT' if it exists.
         * If not, returns 'latn' if it exists.
         * If neither exist, returns undefined.
         */
        getDefaultScriptName: function() {
            var layout = this.getTable();
            if (!layout) { return; }
            var hasLatn = false;
            for (var i = 0; i < layout.scripts.length; i++) {
                var name = layout.scripts[i].tag;
                if (name === 'DFLT') { return name; }
                if (name === 'latn') { hasLatn = true; }
            }
            if (hasLatn) { return 'latn'; }
        },

        /**
         * Returns all LangSysRecords in the given script.
         * @instance
         * @param {string} [script='DFLT']
         * @param {boolean} create - forces the creation of this script table if it doesn't exist.
         * @return {Object} An object with tag and script properties.
         */
        getScriptTable: function(script, create) {
            var layout = this.getTable(create);
            if (layout) {
                script = script || 'DFLT';
                var scripts = layout.scripts;
                var pos = searchTag(layout.scripts, script);
                if (pos >= 0) {
                    return scripts[pos].script;
                } else if (create) {
                    var scr = {
                        tag: script,
                        script: {
                            defaultLangSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []},
                            langSysRecords: []
                        }
                    };
                    scripts.splice(-1 - pos, 0, scr);
                    return scr.script;
                }
            }
        },

        /**
         * Returns a language system table
         * @instance
         * @param {string} [script='DFLT']
         * @param {string} [language='dlft']
         * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
         * @return {Object}
         */
        getLangSysTable: function(script, language, create) {
            var scriptTable = this.getScriptTable(script, create);
            if (scriptTable) {
                if (!language || language === 'dflt' || language === 'DFLT') {
                    return scriptTable.defaultLangSys;
                }
                var pos = searchTag(scriptTable.langSysRecords, language);
                if (pos >= 0) {
                    return scriptTable.langSysRecords[pos].langSys;
                } else if (create) {
                    var langSysRecord = {
                        tag: language,
                        langSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []}
                    };
                    scriptTable.langSysRecords.splice(-1 - pos, 0, langSysRecord);
                    return langSysRecord.langSys;
                }
            }
        },

        /**
         * Get a specific feature table.
         * @instance
         * @param {string} [script='DFLT']
         * @param {string} [language='dlft']
         * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
         * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
         * @return {Object}
         */
        getFeatureTable: function(script, language, feature, create) {
            var langSysTable = this.getLangSysTable(script, language, create);
            if (langSysTable) {
                var featureRecord;
                var featIndexes = langSysTable.featureIndexes;
                var allFeatures = this.font.tables[this.tableName].features;
                // The FeatureIndex array of indices is in arbitrary order,
                // even if allFeatures is sorted alphabetically by feature tag.
                for (var i = 0; i < featIndexes.length; i++) {
                    featureRecord = allFeatures[featIndexes[i]];
                    if (featureRecord.tag === feature) {
                        return featureRecord.feature;
                    }
                }
                if (create) {
                    var index = allFeatures.length;
                    // Automatic ordering of features would require to shift feature indexes in the script list.
                    check.assert(index === 0 || feature >= allFeatures[index - 1].tag, 'Features must be added in alphabetical order.');
                    featureRecord = {
                        tag: feature,
                        feature: { params: 0, lookupListIndexes: [] }
                    };
                    allFeatures.push(featureRecord);
                    featIndexes.push(index);
                    return featureRecord.feature;
                }
            }
        },

        /**
         * Get the lookup tables of a given type for a script/language/feature.
         * @instance
         * @param {string} [script='DFLT']
         * @param {string} [language='dlft']
         * @param {string} feature - 4-letter feature code
         * @param {number} lookupType - 1 to 9
         * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
         * @return {Object[]}
         */
        getLookupTables: function(script, language, feature, lookupType, create) {
            var featureTable = this.getFeatureTable(script, language, feature, create);
            var tables = [];
            if (featureTable) {
                var lookupTable;
                var lookupListIndexes = featureTable.lookupListIndexes;
                var allLookups = this.font.tables[this.tableName].lookups;
                // lookupListIndexes are in no particular order, so use naive search.
                for (var i = 0; i < lookupListIndexes.length; i++) {
                    lookupTable = allLookups[lookupListIndexes[i]];
                    if (lookupTable.lookupType === lookupType) {
                        tables.push(lookupTable);
                    }
                }
                if (tables.length === 0 && create) {
                    lookupTable = {
                        lookupType: lookupType,
                        lookupFlag: 0,
                        subtables: [],
                        markFilteringSet: undefined
                    };
                    var index = allLookups.length;
                    allLookups.push(lookupTable);
                    lookupListIndexes.push(index);
                    return [lookupTable];
                }
            }
            return tables;
        },

        /**
         * Find a glyph in a class definition table
         * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#class-definition-table
         * @param {object} classDefTable - an OpenType Layout class definition table
         * @param {number} glyphIndex - the index of the glyph to find
         * @returns {number} -1 if not found
         */
        getGlyphClass: function(classDefTable, glyphIndex) {
            switch (classDefTable.format) {
                case 1:
                    if (classDefTable.startGlyph <= glyphIndex && glyphIndex < classDefTable.startGlyph + classDefTable.classes.length) {
                        return classDefTable.classes[glyphIndex - classDefTable.startGlyph];
                    }
                    return 0;
                case 2:
                    var range = searchRange(classDefTable.ranges, glyphIndex);
                    return range ? range.classId : 0;
            }
        },

        /**
         * Find a glyph in a coverage table
         * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#coverage-table
         * @param {object} coverageTable - an OpenType Layout coverage table
         * @param {number} glyphIndex - the index of the glyph to find
         * @returns {number} -1 if not found
         */
        getCoverageIndex: function(coverageTable, glyphIndex) {
            switch (coverageTable.format) {
                case 1:
                    var index = binSearch(coverageTable.glyphs, glyphIndex);
                    return index >= 0 ? index : -1;
                case 2:
                    var range = searchRange(coverageTable.ranges, glyphIndex);
                    return range ? range.index + glyphIndex - range.start : -1;
            }
        },

        /**
         * Returns the list of glyph indexes of a coverage table.
         * Format 1: the list is stored raw
         * Format 2: compact list as range records.
         * @instance
         * @param  {Object} coverageTable
         * @return {Array}
         */
        expandCoverage: function(coverageTable) {
            if (coverageTable.format === 1) {
                return coverageTable.glyphs;
            } else {
                var glyphs = [];
                var ranges = coverageTable.ranges;
                for (var i = 0; i < ranges.length; i++) {
                    var range = ranges[i];
                    var start = range.start;
                    var end = range.end;
                    for (var j = start; j <= end; j++) {
                        glyphs.push(j);
                    }
                }
                return glyphs;
            }
        }

    };

    // The Position object provides utility methods to manipulate

    /**
     * @exports opentype.Position
     * @class
     * @extends opentype.Layout
     * @param {opentype.Font}
     * @constructor
     */
    function Position(font) {
        Layout.call(this, font, 'gpos');
    }

    Position.prototype = Layout.prototype;

    /**
     * Init some data for faster and easier access later.
     */
    Position.prototype.init = function() {
        var script = this.getDefaultScriptName();
        this.defaultKerningTables = this.getKerningTables(script);
    };

    /**
     * Find a glyph pair in a list of lookup tables of type 2 and retrieve the xAdvance kerning value.
     *
     * @param {integer} leftIndex - left glyph index
     * @param {integer} rightIndex - right glyph index
     * @returns {integer}
     */
    Position.prototype.getKerningValue = function(kerningLookups, leftIndex, rightIndex) {
        for (var i = 0; i < kerningLookups.length; i++) {
            var subtables = kerningLookups[i].subtables;
            for (var j = 0; j < subtables.length; j++) {
                var subtable = subtables[j];
                var covIndex = this.getCoverageIndex(subtable.coverage, leftIndex);
                if (covIndex < 0) { continue; }
                switch (subtable.posFormat) {
                    case 1:
                        // Search Pair Adjustment Positioning Format 1
                        var pairSet = subtable.pairSets[covIndex];
                        for (var k = 0; k < pairSet.length; k++) {
                            var pair = pairSet[k];
                            if (pair.secondGlyph === rightIndex) {
                                return pair.value1 && pair.value1.xAdvance || 0;
                            }
                        }
                        break;      // left glyph found, not right glyph - try next subtable
                    case 2:
                        // Search Pair Adjustment Positioning Format 2
                        var class1 = this.getGlyphClass(subtable.classDef1, leftIndex);
                        var class2 = this.getGlyphClass(subtable.classDef2, rightIndex);
                        var pair$1 = subtable.classRecords[class1][class2];
                        return pair$1.value1 && pair$1.value1.xAdvance || 0;
                }
            }
        }
        return 0;
    };

    /**
     * List all kerning lookup tables.
     *
     * @param {string} [script='DFLT'] - use font.position.getDefaultScriptName() for a better default value
     * @param {string} [language='dflt']
     * @return {object[]} The list of kerning lookup tables (may be empty), or undefined if there is no GPOS table (and we should use the kern table)
     */
    Position.prototype.getKerningTables = function(script, language) {
        if (this.font.tables.gpos) {
            return this.getLookupTables(script, language, 'kern', 2);
        }
    };

    // The Substitution object provides utility methods to manipulate

    /**
     * @exports opentype.Substitution
     * @class
     * @extends opentype.Layout
     * @param {opentype.Font}
     * @constructor
     */
    function Substitution(font) {
        Layout.call(this, font, 'gsub');
    }

    // Check if 2 arrays of primitives are equal.
    function arraysEqual(ar1, ar2) {
        var n = ar1.length;
        if (n !== ar2.length) { return false; }
        for (var i = 0; i < n; i++) {
            if (ar1[i] !== ar2[i]) { return false; }
        }
        return true;
    }

    // Find the first subtable of a lookup table in a particular format.
    function getSubstFormat(lookupTable, format, defaultSubtable) {
        var subtables = lookupTable.subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            if (subtable.substFormat === format) {
                return subtable;
            }
        }
        if (defaultSubtable) {
            subtables.push(defaultSubtable);
            return defaultSubtable;
        }
        return undefined;
    }

    Substitution.prototype = Layout.prototype;

    /**
     * Create a default GSUB table.
     * @return {Object} gsub - The GSUB table.
     */
    Substitution.prototype.createDefaultTable = function() {
        // Generate a default empty GSUB table with just a DFLT script and dflt lang sys.
        return {
            version: 1,
            scripts: [{
                tag: 'DFLT',
                script: {
                    defaultLangSys: { reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: [] },
                    langSysRecords: []
                }
            }],
            features: [],
            lookups: []
        };
    };

    /**
     * List all single substitutions (lookup type 1) for a given script, language, and feature.
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     * @param {string} feature - 4-character feature name ('aalt', 'salt', 'ss01'...)
     * @return {Array} substitutions - The list of substitutions.
     */
    Substitution.prototype.getSingle = function(feature, script, language) {
        var substitutions = [];
        var lookupTables = this.getLookupTables(script, language, feature, 1);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this.expandCoverage(subtable.coverage);
                var j = (void 0);
                if (subtable.substFormat === 1) {
                    var delta = subtable.deltaGlyphId;
                    for (j = 0; j < glyphs.length; j++) {
                        var glyph = glyphs[j];
                        substitutions.push({ sub: glyph, by: glyph + delta });
                    }
                } else {
                    var substitute = subtable.substitute;
                    for (j = 0; j < glyphs.length; j++) {
                        substitutions.push({ sub: glyphs[j], by: substitute[j] });
                    }
                }
            }
        }
        return substitutions;
    };

    /**
     * List all multiple substitutions (lookup type 2) for a given script, language, and feature.
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     * @param {string} feature - 4-character feature name ('ccmp', 'stch')
     * @return {Array} substitutions - The list of substitutions.
     */
    Substitution.prototype.getMultiple = function(feature, script, language) {
        var substitutions = [];
        var lookupTables = this.getLookupTables(script, language, feature, 2);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this.expandCoverage(subtable.coverage);
                var j = (void 0);

                for (j = 0; j < glyphs.length; j++) {
                    var glyph = glyphs[j];
                    var replacements = subtable.sequences[j];
                    substitutions.push({ sub: glyph, by: replacements });
                }
            }
        }
        return substitutions;
    };

    /**
     * List all alternates (lookup type 3) for a given script, language, and feature.
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     * @param {string} feature - 4-character feature name ('aalt', 'salt'...)
     * @return {Array} alternates - The list of alternates
     */
    Substitution.prototype.getAlternates = function(feature, script, language) {
        var alternates = [];
        var lookupTables = this.getLookupTables(script, language, feature, 3);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this.expandCoverage(subtable.coverage);
                var alternateSets = subtable.alternateSets;
                for (var j = 0; j < glyphs.length; j++) {
                    alternates.push({ sub: glyphs[j], by: alternateSets[j] });
                }
            }
        }
        return alternates;
    };

    /**
     * List all ligatures (lookup type 4) for a given script, language, and feature.
     * The result is an array of ligature objects like { sub: [ids], by: id }
     * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     * @return {Array} ligatures - The list of ligatures.
     */
    Substitution.prototype.getLigatures = function(feature, script, language) {
        var ligatures = [];
        var lookupTables = this.getLookupTables(script, language, feature, 4);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this.expandCoverage(subtable.coverage);
                var ligatureSets = subtable.ligatureSets;
                for (var j = 0; j < glyphs.length; j++) {
                    var startGlyph = glyphs[j];
                    var ligSet = ligatureSets[j];
                    for (var k = 0; k < ligSet.length; k++) {
                        var lig = ligSet[k];
                        ligatures.push({
                            sub: [startGlyph].concat(lig.components),
                            by: lig.ligGlyph
                        });
                    }
                }
            }
        }
        return ligatures;
    };

    /**
     * Add or modify a single substitution (lookup type 1)
     * Format 2, more flexible, is always used.
     * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
     * @param {Object} substitution - { sub: id, by: id } (format 1 is not supported)
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     */
    Substitution.prototype.addSingle = function(feature, substitution, script, language) {
        var lookupTable = this.getLookupTables(script, language, feature, 1, true)[0];
        var subtable = getSubstFormat(lookupTable, 2, {                // lookup type 1 subtable, format 2, coverage format 1
            substFormat: 2,
            coverage: {format: 1, glyphs: []},
            substitute: []
        });
        check.assert(subtable.coverage.format === 1, 'Single: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = substitution.sub;
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos < 0) {
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.substitute.splice(pos, 0, 0);
        }
        subtable.substitute[pos] = substitution.by;
    };

    /**
     * Add or modify a multiple substitution (lookup type 2)
     * @param {string} feature - 4-letter feature name ('ccmp', 'stch')
     * @param {Object} substitution - { sub: id, by: [id] } for format 2.
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     */
    Substitution.prototype.addMultiple = function(feature, substitution, script, language) {
        check.assert(substitution.by instanceof Array && substitution.by.length > 1, 'Multiple: "by" must be an array of two or more ids');
        var lookupTable = this.getLookupTables(script, language, feature, 2, true)[0];
        var subtable = getSubstFormat(lookupTable, 1, {                // lookup type 2 subtable, format 1, coverage format 1
            substFormat: 1,
            coverage: {format: 1, glyphs: []},
            sequences: []
        });
        check.assert(subtable.coverage.format === 1, 'Multiple: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = substitution.sub;
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos < 0) {
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.sequences.splice(pos, 0, 0);
        }
        subtable.sequences[pos] = substitution.by;
    };

    /**
     * Add or modify an alternate substitution (lookup type 3)
     * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
     * @param {Object} substitution - { sub: id, by: [ids] }
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     */
    Substitution.prototype.addAlternate = function(feature, substitution, script, language) {
        var lookupTable = this.getLookupTables(script, language, feature, 3, true)[0];
        var subtable = getSubstFormat(lookupTable, 1, {                // lookup type 3 subtable, format 1, coverage format 1
            substFormat: 1,
            coverage: {format: 1, glyphs: []},
            alternateSets: []
        });
        check.assert(subtable.coverage.format === 1, 'Alternate: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = substitution.sub;
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos < 0) {
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.alternateSets.splice(pos, 0, 0);
        }
        subtable.alternateSets[pos] = substitution.by;
    };

    /**
     * Add a ligature (lookup type 4)
     * Ligatures with more components must be stored ahead of those with fewer components in order to be found
     * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
     * @param {Object} ligature - { sub: [ids], by: id }
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     */
    Substitution.prototype.addLigature = function(feature, ligature, script, language) {
        var lookupTable = this.getLookupTables(script, language, feature, 4, true)[0];
        var subtable = lookupTable.subtables[0];
        if (!subtable) {
            subtable = {                // lookup type 4 subtable, format 1, coverage format 1
                substFormat: 1,
                coverage: { format: 1, glyphs: [] },
                ligatureSets: []
            };
            lookupTable.subtables[0] = subtable;
        }
        check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = ligature.sub[0];
        var ligComponents = ligature.sub.slice(1);
        var ligatureTable = {
            ligGlyph: ligature.by,
            components: ligComponents
        };
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos >= 0) {
            // ligatureSet already exists
            var ligatureSet = subtable.ligatureSets[pos];
            for (var i = 0; i < ligatureSet.length; i++) {
                // If ligature already exists, return.
                if (arraysEqual(ligatureSet[i].components, ligComponents)) {
                    return;
                }
            }
            // ligature does not exist: add it.
            ligatureSet.push(ligatureTable);
        } else {
            // Create a new ligatureSet and add coverage for the first glyph.
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.ligatureSets.splice(pos, 0, [ligatureTable]);
        }
    };

    /**
     * List all feature data for a given script and language.
     * @param {string} feature - 4-letter feature name
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     * @return {Array} substitutions - The list of substitutions.
     */
    Substitution.prototype.getFeature = function(feature, script, language) {
        if (/ss\d\d/.test(feature)) {
            // ss01 - ss20
            return this.getSingle(feature, script, language);
        }
        switch (feature) {
            case 'aalt':
            case 'salt':
                return this.getSingle(feature, script, language)
                        .concat(this.getAlternates(feature, script, language));
            case 'dlig':
            case 'liga':
            case 'rlig':
                return this.getLigatures(feature, script, language);
            case 'ccmp':
                return this.getMultiple(feature, script, language)
                    .concat(this.getLigatures(feature, script, language));
            case 'stch':
                return this.getMultiple(feature, script, language);
        }
        return undefined;
    };

    /**
     * Add a substitution to a feature for a given script and language.
     * @param {string} feature - 4-letter feature name
     * @param {Object} sub - the substitution to add (an object like { sub: id or [ids], by: id or [ids] })
     * @param {string} [script='DFLT']
     * @param {string} [language='dflt']
     */
    Substitution.prototype.add = function(feature, sub, script, language) {
        if (/ss\d\d/.test(feature)) {
            // ss01 - ss20
            return this.addSingle(feature, sub, script, language);
        }
        switch (feature) {
            case 'aalt':
            case 'salt':
                if (typeof sub.by === 'number') {
                    return this.addSingle(feature, sub, script, language);
                }
                return this.addAlternate(feature, sub, script, language);
            case 'dlig':
            case 'liga':
            case 'rlig':
                return this.addLigature(feature, sub, script, language);
            case 'ccmp':
                if (sub.by instanceof Array) {
                    return this.addMultiple(feature, sub, script, language);
                }
                return this.addLigature(feature, sub, script, language);
        }
        return undefined;
    };

    function isBrowser() {
        return typeof window !== 'undefined';
    }

    function arrayBufferToNodeBuffer(ab) {
        var buffer = new Buffer(ab.byteLength);
        var view = new Uint8Array(ab);
        for (var i = 0; i < buffer.length; ++i) {
            buffer[i] = view[i];
        }

        return buffer;
    }

    function checkArgument(expression, message) {
        if (!expression) {
            throw message;
        }
    }

    // The `glyf` table describes the glyphs in TrueType outline format.

    // Parse the coordinate data for a glyph.
    function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
        var v;
        if ((flag & shortVectorBitMask) > 0) {
            // The coordinate is 1 byte long.
            v = p.parseByte();
            // The `same` bit is re-used for short values to signify the sign of the value.
            if ((flag & sameBitMask) === 0) {
                v = -v;
            }

            v = previousValue + v;
        } else {
            //  The coordinate is 2 bytes long.
            // If the `same` bit is set, the coordinate is the same as the previous coordinate.
            if ((flag & sameBitMask) > 0) {
                v = previousValue;
            } else {
                // Parse the coordinate as a signed 16-bit delta value.
                v = previousValue + p.parseShort();
            }
        }

        return v;
    }

    // Parse a TrueType glyph.
    function parseGlyph(glyph, data, start) {
        var p = new parse.Parser(data, start);
        glyph.numberOfContours = p.parseShort();
        glyph._xMin = p.parseShort();
        glyph._yMin = p.parseShort();
        glyph._xMax = p.parseShort();
        glyph._yMax = p.parseShort();
        var flags;
        var flag;

        if (glyph.numberOfContours > 0) {
            // This glyph is not a composite.
            var endPointIndices = glyph.endPointIndices = [];
            for (var i = 0; i < glyph.numberOfContours; i += 1) {
                endPointIndices.push(p.parseUShort());
            }

            glyph.instructionLength = p.parseUShort();
            glyph.instructions = [];
            for (var i$1 = 0; i$1 < glyph.instructionLength; i$1 += 1) {
                glyph.instructions.push(p.parseByte());
            }

            var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
            flags = [];
            for (var i$2 = 0; i$2 < numberOfCoordinates; i$2 += 1) {
                flag = p.parseByte();
                flags.push(flag);
                // If bit 3 is set, we repeat this flag n times, where n is the next byte.
                if ((flag & 8) > 0) {
                    var repeatCount = p.parseByte();
                    for (var j = 0; j < repeatCount; j += 1) {
                        flags.push(flag);
                        i$2 += 1;
                    }
                }
            }

            check.argument(flags.length === numberOfCoordinates, 'Bad flags.');

            if (endPointIndices.length > 0) {
                var points = [];
                var point;
                // X/Y coordinates are relative to the previous point, except for the first point which is relative to 0,0.
                if (numberOfCoordinates > 0) {
                    for (var i$3 = 0; i$3 < numberOfCoordinates; i$3 += 1) {
                        flag = flags[i$3];
                        point = {};
                        point.onCurve = !!(flag & 1);
                        point.lastPointOfContour = endPointIndices.indexOf(i$3) >= 0;
                        points.push(point);
                    }

                    var px = 0;
                    for (var i$4 = 0; i$4 < numberOfCoordinates; i$4 += 1) {
                        flag = flags[i$4];
                        point = points[i$4];
                        point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
                        px = point.x;
                    }

                    var py = 0;
                    for (var i$5 = 0; i$5 < numberOfCoordinates; i$5 += 1) {
                        flag = flags[i$5];
                        point = points[i$5];
                        point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
                        py = point.y;
                    }
                }

                glyph.points = points;
            } else {
                glyph.points = [];
            }
        } else if (glyph.numberOfContours === 0) {
            glyph.points = [];
        } else {
            glyph.isComposite = true;
            glyph.points = [];
            glyph.components = [];
            var moreComponents = true;
            while (moreComponents) {
                flags = p.parseUShort();
                var component = {
                    glyphIndex: p.parseUShort(),
                    xScale: 1,
                    scale01: 0,
                    scale10: 0,
                    yScale: 1,
                    dx: 0,
                    dy: 0
                };
                if ((flags & 1) > 0) {
                    // The arguments are words
                    if ((flags & 2) > 0) {
                        // values are offset
                        component.dx = p.parseShort();
                        component.dy = p.parseShort();
                    } else {
                        // values are matched points
                        component.matchedPoints = [p.parseUShort(), p.parseUShort()];
                    }

                } else {
                    // The arguments are bytes
                    if ((flags & 2) > 0) {
                        // values are offset
                        component.dx = p.parseChar();
                        component.dy = p.parseChar();
                    } else {
                        // values are matched points
                        component.matchedPoints = [p.parseByte(), p.parseByte()];
                    }
                }

                if ((flags & 8) > 0) {
                    // We have a scale
                    component.xScale = component.yScale = p.parseF2Dot14();
                } else if ((flags & 64) > 0) {
                    // We have an X / Y scale
                    component.xScale = p.parseF2Dot14();
                    component.yScale = p.parseF2Dot14();
                } else if ((flags & 128) > 0) {
                    // We have a 2x2 transformation
                    component.xScale = p.parseF2Dot14();
                    component.scale01 = p.parseF2Dot14();
                    component.scale10 = p.parseF2Dot14();
                    component.yScale = p.parseF2Dot14();
                }

                glyph.components.push(component);
                moreComponents = !!(flags & 32);
            }
            if (flags & 0x100) {
                // We have instructions
                glyph.instructionLength = p.parseUShort();
                glyph.instructions = [];
                for (var i$6 = 0; i$6 < glyph.instructionLength; i$6 += 1) {
                    glyph.instructions.push(p.parseByte());
                }
            }
        }
    }

    // Transform an array of points and return a new array.
    function transformPoints(points, transform) {
        var newPoints = [];
        for (var i = 0; i < points.length; i += 1) {
            var pt = points[i];
            var newPt = {
                x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
                y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
                onCurve: pt.onCurve,
                lastPointOfContour: pt.lastPointOfContour
            };
            newPoints.push(newPt);
        }

        return newPoints;
    }

    function getContours(points) {
        var contours = [];
        var currentContour = [];
        for (var i = 0; i < points.length; i += 1) {
            var pt = points[i];
            currentContour.push(pt);
            if (pt.lastPointOfContour) {
                contours.push(currentContour);
                currentContour = [];
            }
        }

        check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
        return contours;
    }

    // Convert the TrueType glyph outline to a Path.
    function getPath(points) {
        var p = new Path();
        if (!points) {
            return p;
        }

        var contours = getContours(points);

        for (var contourIndex = 0; contourIndex < contours.length; ++contourIndex) {
            var contour = contours[contourIndex];

            var prev = null;
            var curr = contour[contour.length - 1];
            var next = contour[0];

            if (curr.onCurve) {
                p.moveTo(curr.x, curr.y);
            } else {
                if (next.onCurve) {
                    p.moveTo(next.x, next.y);
                } else {
                    // If both first and last points are off-curve, start at their middle.
                    var start = {x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5};
                    p.moveTo(start.x, start.y);
                }
            }

            for (var i = 0; i < contour.length; ++i) {
                prev = curr;
                curr = next;
                next = contour[(i + 1) % contour.length];

                if (curr.onCurve) {
                    // This is a straight line.
                    p.lineTo(curr.x, curr.y);
                } else {
                    var prev2 = prev;
                    var next2 = next;

                    if (!prev.onCurve) {
                        prev2 = { x: (curr.x + prev.x) * 0.5, y: (curr.y + prev.y) * 0.5 };
                    }

                    if (!next.onCurve) {
                        next2 = { x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5 };
                    }

                    p.quadraticCurveTo(curr.x, curr.y, next2.x, next2.y);
                }
            }

            p.closePath();
        }
        return p;
    }

    function buildPath(glyphs, glyph) {
        if (glyph.isComposite) {
            for (var j = 0; j < glyph.components.length; j += 1) {
                var component = glyph.components[j];
                var componentGlyph = glyphs.get(component.glyphIndex);
                // Force the ttfGlyphLoader to parse the glyph.
                componentGlyph.getPath();
                if (componentGlyph.points) {
                    var transformedPoints = (void 0);
                    if (component.matchedPoints === undefined) {
                        // component positioned by offset
                        transformedPoints = transformPoints(componentGlyph.points, component);
                    } else {
                        // component positioned by matched points
                        if ((component.matchedPoints[0] > glyph.points.length - 1) ||
                            (component.matchedPoints[1] > componentGlyph.points.length - 1)) {
                            throw Error('Matched points out of range in ' + glyph.name);
                        }
                        var firstPt = glyph.points[component.matchedPoints[0]];
                        var secondPt = componentGlyph.points[component.matchedPoints[1]];
                        var transform = {
                            xScale: component.xScale, scale01: component.scale01,
                            scale10: component.scale10, yScale: component.yScale,
                            dx: 0, dy: 0
                        };
                        secondPt = transformPoints([secondPt], transform)[0];
                        transform.dx = firstPt.x - secondPt.x;
                        transform.dy = firstPt.y - secondPt.y;
                        transformedPoints = transformPoints(componentGlyph.points, transform);
                    }
                    glyph.points = glyph.points.concat(transformedPoints);
                }
            }
        }

        return getPath(glyph.points);
    }

    function parseGlyfTableAll(data, start, loca, font) {
        var glyphs = new glyphset.GlyphSet(font);

        // The last element of the loca table is invalid.
        for (var i = 0; i < loca.length - 1; i += 1) {
            var offset = loca[i];
            var nextOffset = loca[i + 1];
            if (offset !== nextOffset) {
                glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
            } else {
                glyphs.push(i, glyphset.glyphLoader(font, i));
            }
        }

        return glyphs;
    }

    function parseGlyfTableOnLowMemory(data, start, loca, font) {
        var glyphs = new glyphset.GlyphSet(font);

        font._push = function(i) {
            var offset = loca[i];
            var nextOffset = loca[i + 1];
            if (offset !== nextOffset) {
                glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
            } else {
                glyphs.push(i, glyphset.glyphLoader(font, i));
            }
        };

        return glyphs;
    }

    // Parse all the glyphs according to the offsets from the `loca` table.
    function parseGlyfTable(data, start, loca, font, opt) {
        if (opt.lowMemory)
            { return parseGlyfTableOnLowMemory(data, start, loca, font); }
        else
            { return parseGlyfTableAll(data, start, loca, font); }
    }

    var glyf = { getPath: getPath, parse: parseGlyfTable};

    /* A TrueType font hinting interpreter.
    *
    * (c) 2017 Axel Kittenberger
    *
    * This interpreter has been implemented according to this documentation:
    * https://developer.apple.com/fonts/TrueType-Reference-Manual/RM05/Chap5.html
    *
    * According to the documentation F24DOT6 values are used for pixels.
    * That means calculation is 1/64 pixel accurate and uses integer operations.
    * However, Javascript has floating point operations by default and only
    * those are available. One could make a case to simulate the 1/64 accuracy
    * exactly by truncating after every division operation
    * (for example with << 0) to get pixel exactly results as other TrueType
    * implementations. It may make sense since some fonts are pixel optimized
    * by hand using DELTAP instructions. The current implementation doesn't
    * and rather uses full floating point precision.
    *
    * xScale, yScale and rotation is currently ignored.
    *
    * A few non-trivial instructions are missing as I didn't encounter yet
    * a font that used them to test a possible implementation.
    *
    * Some fonts seem to use undocumented features regarding the twilight zone.
    * Only some of them are implemented as they were encountered.
    *
    * The exports.DEBUG statements are removed on the minified distribution file.
    */

    var instructionTable;
    var exec;
    var execGlyph;
    var execComponent;

    /*
    * Creates a hinting object.
    *
    * There ought to be exactly one
    * for each truetype font that is used for hinting.
    */
    function Hinting(font) {
        // the font this hinting object is for
        this.font = font;

        this.getCommands = function (hPoints) {
            return glyf.getPath(hPoints).commands;
        };

        // cached states
        this._fpgmState  =
        this._prepState  =
            undefined;

        // errorState
        // 0 ... all okay
        // 1 ... had an error in a glyf,
        //       continue working but stop spamming
        //       the console
        // 2 ... error at prep, stop hinting at this ppem
        // 3 ... error at fpeg, stop hinting for this font at all
        this._errorState = 0;
    }

    /*
    * Not rounding.
    */
    function roundOff(v) {
        return v;
    }

    /*
    * Rounding to grid.
    */
    function roundToGrid(v) {
        //Rounding in TT is supposed to "symmetrical around zero"
        return Math.sign(v) * Math.round(Math.abs(v));
    }

    /*
    * Rounding to double grid.
    */
    function roundToDoubleGrid(v) {
        return Math.sign(v) * Math.round(Math.abs(v * 2)) / 2;
    }

    /*
    * Rounding to half grid.
    */
    function roundToHalfGrid(v) {
        return Math.sign(v) * (Math.round(Math.abs(v) + 0.5) - 0.5);
    }

    /*
    * Rounding to up to grid.
    */
    function roundUpToGrid(v) {
        return Math.sign(v) * Math.ceil(Math.abs(v));
    }

    /*
    * Rounding to down to grid.
    */
    function roundDownToGrid(v) {
        return Math.sign(v) * Math.floor(Math.abs(v));
    }

    /*
    * Super rounding.
    */
    var roundSuper = function (v) {
        var period = this.srPeriod;
        var phase = this.srPhase;
        var threshold = this.srThreshold;
        var sign = 1;

        if (v < 0) {
            v = -v;
            sign = -1;
        }

        v += threshold - phase;

        v = Math.trunc(v / period) * period;

        v += phase;

        // according to http://xgridfit.sourceforge.net/round.html
        if (v < 0) { return phase * sign; }

        return v * sign;
    };

    /*
    * Unit vector of x-axis.
    */
    var xUnitVector = {
        x: 1,

        y: 0,

        axis: 'x',

        // Gets the projected distance between two points.
        // o1/o2 ... if true, respective original position is used.
        distance: function (p1, p2, o1, o2) {
            return (o1 ? p1.xo : p1.x) - (o2 ? p2.xo : p2.x);
        },

        // Moves point p so the moved position has the same relative
        // position to the moved positions of rp1 and rp2 than the
        // original positions had.
        //
        // See APPENDIX on INTERPOLATE at the bottom of this file.
        interpolate: function (p, rp1, rp2, pv) {
            var do1;
            var do2;
            var doa1;
            var doa2;
            var dm1;
            var dm2;
            var dt;

            if (!pv || pv === this) {
                do1 = p.xo - rp1.xo;
                do2 = p.xo - rp2.xo;
                dm1 = rp1.x - rp1.xo;
                dm2 = rp2.x - rp2.xo;
                doa1 = Math.abs(do1);
                doa2 = Math.abs(do2);
                dt = doa1 + doa2;

                if (dt === 0) {
                    p.x = p.xo + (dm1 + dm2) / 2;
                    return;
                }

                p.x = p.xo + (dm1 * doa2 + dm2 * doa1) / dt;
                return;
            }

            do1 = pv.distance(p, rp1, true, true);
            do2 = pv.distance(p, rp2, true, true);
            dm1 = pv.distance(rp1, rp1, false, true);
            dm2 = pv.distance(rp2, rp2, false, true);
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;

            if (dt === 0) {
                xUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
                return;
            }

            xUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
        },

        // Slope of line normal to this
        normalSlope: Number.NEGATIVE_INFINITY,

        // Sets the point 'p' relative to point 'rp'
        // by the distance 'd'.
        //
        // See APPENDIX on SETRELATIVE at the bottom of this file.
        //
        // p   ... point to set
        // rp  ... reference point
        // d   ... distance on projection vector
        // pv  ... projection vector (undefined = this)
        // org ... if true, uses the original position of rp as reference.
        setRelative: function (p, rp, d, pv, org) {
            if (!pv || pv === this) {
                p.x = (org ? rp.xo : rp.x) + d;
                return;
            }

            var rpx = org ? rp.xo : rp.x;
            var rpy = org ? rp.yo : rp.y;
            var rpdx = rpx + d * pv.x;
            var rpdy = rpy + d * pv.y;

            p.x = rpdx + (p.y - rpdy) / pv.normalSlope;
        },

        // Slope of vector line.
        slope: 0,

        // Touches the point p.
        touch: function (p) {
            p.xTouched = true;
        },

        // Tests if a point p is touched.
        touched: function (p) {
            return p.xTouched;
        },

        // Untouches the point p.
        untouch: function (p) {
            p.xTouched = false;
        }
    };

    /*
    * Unit vector of y-axis.
    */
    var yUnitVector = {
        x: 0,

        y: 1,

        axis: 'y',

        // Gets the projected distance between two points.
        // o1/o2 ... if true, respective original position is used.
        distance: function (p1, p2, o1, o2) {
            return (o1 ? p1.yo : p1.y) - (o2 ? p2.yo : p2.y);
        },

        // Moves point p so the moved position has the same relative
        // position to the moved positions of rp1 and rp2 than the
        // original positions had.
        //
        // See APPENDIX on INTERPOLATE at the bottom of this file.
        interpolate: function (p, rp1, rp2, pv) {
            var do1;
            var do2;
            var doa1;
            var doa2;
            var dm1;
            var dm2;
            var dt;

            if (!pv || pv === this) {
                do1 = p.yo - rp1.yo;
                do2 = p.yo - rp2.yo;
                dm1 = rp1.y - rp1.yo;
                dm2 = rp2.y - rp2.yo;
                doa1 = Math.abs(do1);
                doa2 = Math.abs(do2);
                dt = doa1 + doa2;

                if (dt === 0) {
                    p.y = p.yo + (dm1 + dm2) / 2;
                    return;
                }

                p.y = p.yo + (dm1 * doa2 + dm2 * doa1) / dt;
                return;
            }

            do1 = pv.distance(p, rp1, true, true);
            do2 = pv.distance(p, rp2, true, true);
            dm1 = pv.distance(rp1, rp1, false, true);
            dm2 = pv.distance(rp2, rp2, false, true);
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;

            if (dt === 0) {
                yUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
                return;
            }

            yUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
        },

        // Slope of line normal to this.
        normalSlope: 0,

        // Sets the point 'p' relative to point 'rp'
        // by the distance 'd'
        //
        // See APPENDIX on SETRELATIVE at the bottom of this file.
        //
        // p   ... point to set
        // rp  ... reference point
        // d   ... distance on projection vector
        // pv  ... projection vector (undefined = this)
        // org ... if true, uses the original position of rp as reference.
        setRelative: function (p, rp, d, pv, org) {
            if (!pv || pv === this) {
                p.y = (org ? rp.yo : rp.y) + d;
                return;
            }

            var rpx = org ? rp.xo : rp.x;
            var rpy = org ? rp.yo : rp.y;
            var rpdx = rpx + d * pv.x;
            var rpdy = rpy + d * pv.y;

            p.y = rpdy + pv.normalSlope * (p.x - rpdx);
        },

        // Slope of vector line.
        slope: Number.POSITIVE_INFINITY,

        // Touches the point p.
        touch: function (p) {
            p.yTouched = true;
        },

        // Tests if a point p is touched.
        touched: function (p) {
            return p.yTouched;
        },

        // Untouches the point p.
        untouch: function (p) {
            p.yTouched = false;
        }
    };

    Object.freeze(xUnitVector);
    Object.freeze(yUnitVector);

    /*
    * Creates a unit vector that is not x- or y-axis.
    */
    function UnitVector(x, y) {
        this.x = x;
        this.y = y;
        this.axis = undefined;
        this.slope = y / x;
        this.normalSlope = -x / y;
        Object.freeze(this);
    }

    /*
    * Gets the projected distance between two points.
    * o1/o2 ... if true, respective original position is used.
    */
    UnitVector.prototype.distance = function(p1, p2, o1, o2) {
        return (
            this.x * xUnitVector.distance(p1, p2, o1, o2) +
            this.y * yUnitVector.distance(p1, p2, o1, o2)
        );
    };

    /*
    * Moves point p so the moved position has the same relative
    * position to the moved positions of rp1 and rp2 than the
    * original positions had.
    *
    * See APPENDIX on INTERPOLATE at the bottom of this file.
    */
    UnitVector.prototype.interpolate = function(p, rp1, rp2, pv) {
        var dm1;
        var dm2;
        var do1;
        var do2;
        var doa1;
        var doa2;
        var dt;

        do1 = pv.distance(p, rp1, true, true);
        do2 = pv.distance(p, rp2, true, true);
        dm1 = pv.distance(rp1, rp1, false, true);
        dm2 = pv.distance(rp2, rp2, false, true);
        doa1 = Math.abs(do1);
        doa2 = Math.abs(do2);
        dt = doa1 + doa2;

        if (dt === 0) {
            this.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
            return;
        }

        this.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
    };

    /*
    * Sets the point 'p' relative to point 'rp'
    * by the distance 'd'
    *
    * See APPENDIX on SETRELATIVE at the bottom of this file.
    *
    * p   ...  point to set
    * rp  ... reference point
    * d   ... distance on projection vector
    * pv  ... projection vector (undefined = this)
    * org ... if true, uses the original position of rp as reference.
    */
    UnitVector.prototype.setRelative = function(p, rp, d, pv, org) {
        pv = pv || this;

        var rpx = org ? rp.xo : rp.x;
        var rpy = org ? rp.yo : rp.y;
        var rpdx = rpx + d * pv.x;
        var rpdy = rpy + d * pv.y;

        var pvns = pv.normalSlope;
        var fvs = this.slope;

        var px = p.x;
        var py = p.y;

        p.x = (fvs * px - pvns * rpdx + rpdy - py) / (fvs - pvns);
        p.y = fvs * (p.x - px) + py;
    };

    /*
    * Touches the point p.
    */
    UnitVector.prototype.touch = function(p) {
        p.xTouched = true;
        p.yTouched = true;
    };

    /*
    * Returns a unit vector with x/y coordinates.
    */
    function getUnitVector(x, y) {
        var d = Math.sqrt(x * x + y * y);

        x /= d;
        y /= d;

        if (x === 1 && y === 0) { return xUnitVector; }
        else if (x === 0 && y === 1) { return yUnitVector; }
        else { return new UnitVector(x, y); }
    }

    /*
    * Creates a point in the hinting engine.
    */
    function HPoint(
        x,
        y,
        lastPointOfContour,
        onCurve
    ) {
        this.x = this.xo = Math.round(x * 64) / 64; // hinted x value and original x-value
        this.y = this.yo = Math.round(y * 64) / 64; // hinted y value and original y-value

        this.lastPointOfContour = lastPointOfContour;
        this.onCurve = onCurve;
        this.prevPointOnContour = undefined;
        this.nextPointOnContour = undefined;
        this.xTouched = false;
        this.yTouched = false;

        Object.preventExtensions(this);
    }

    /*
    * Returns the next touched point on the contour.
    *
    * v  ... unit vector to test touch axis.
    */
    HPoint.prototype.nextTouched = function(v) {
        var p = this.nextPointOnContour;

        while (!v.touched(p) && p !== this) { p = p.nextPointOnContour; }

        return p;
    };

    /*
    * Returns the previous touched point on the contour
    *
    * v  ... unit vector to test touch axis.
    */
    HPoint.prototype.prevTouched = function(v) {
        var p = this.prevPointOnContour;

        while (!v.touched(p) && p !== this) { p = p.prevPointOnContour; }

        return p;
    };

    /*
    * The zero point.
    */
    var HPZero = Object.freeze(new HPoint(0, 0));

    /*
    * The default state of the interpreter.
    *
    * Note: Freezing the defaultState and then deriving from it
    * makes the V8 Javascript engine going awkward,
    * so this is avoided, albeit the defaultState shouldn't
    * ever change.
    */
    var defaultState = {
        cvCutIn: 17 / 16,    // control value cut in
        deltaBase: 9,
        deltaShift: 0.125,
        loop: 1,             // loops some instructions
        minDis: 1,           // minimum distance
        autoFlip: true
    };

    /*
    * The current state of the interpreter.
    *
    * env  ... 'fpgm' or 'prep' or 'glyf'
    * prog ... the program
    */
    function State(env, prog) {
        this.env = env;
        this.stack = [];
        this.prog = prog;

        switch (env) {
            case 'glyf' :
                this.zp0 = this.zp1 = this.zp2 = 1;
                this.rp0 = this.rp1 = this.rp2 = 0;
                /* fall through */
            case 'prep' :
                this.fv = this.pv = this.dpv = xUnitVector;
                this.round = roundToGrid;
        }
    }

    /*
    * Executes a glyph program.
    *
    * This does the hinting for each glyph.
    *
    * Returns an array of moved points.
    *
    * glyph: the glyph to hint
    * ppem: the size the glyph is rendered for
    */
    Hinting.prototype.exec = function(glyph, ppem) {
        if (typeof ppem !== 'number') {
            throw new Error('Point size is not a number!');
        }

        // Received a fatal error, don't do any hinting anymore.
        if (this._errorState > 2) { return; }

        var font = this.font;
        var prepState = this._prepState;

        if (!prepState || prepState.ppem !== ppem) {
            var fpgmState = this._fpgmState;

            if (!fpgmState) {
                // Executes the fpgm state.
                // This is used by fonts to define functions.
                State.prototype = defaultState;

                fpgmState =
                this._fpgmState =
                    new State('fpgm', font.tables.fpgm);

                fpgmState.funcs = [ ];
                fpgmState.font = font;

                if (exports.DEBUG) {
                    console.log('---EXEC FPGM---');
                    fpgmState.step = -1;
                }

                try {
                    exec(fpgmState);
                } catch (e) {
                    console.log('Hinting error in FPGM:' + e);
                    this._errorState = 3;
                    return;
                }
            }

            // Executes the prep program for this ppem setting.
            // This is used by fonts to set cvt values
            // depending on to be rendered font size.

            State.prototype = fpgmState;
            prepState =
            this._prepState =
                new State('prep', font.tables.prep);

            prepState.ppem = ppem;

            // Creates a copy of the cvt table
            // and scales it to the current ppem setting.
            var oCvt = font.tables.cvt;
            if (oCvt) {
                var cvt = prepState.cvt = new Array(oCvt.length);
                var scale = ppem / font.unitsPerEm;
                for (var c = 0; c < oCvt.length; c++) {
                    cvt[c] = oCvt[c] * scale;
                }
            } else {
                prepState.cvt = [];
            }

            if (exports.DEBUG) {
                console.log('---EXEC PREP---');
                prepState.step = -1;
            }

            try {
                exec(prepState);
            } catch (e) {
                if (this._errorState < 2) {
                    console.log('Hinting error in PREP:' + e);
                }
                this._errorState = 2;
            }
        }

        if (this._errorState > 1) { return; }

        try {
            return execGlyph(glyph, prepState);
        } catch (e) {
            if (this._errorState < 1) {
                console.log('Hinting error:' + e);
                console.log('Note: further hinting errors are silenced');
            }
            this._errorState = 1;
            return undefined;
        }
    };

    /*
    * Executes the hinting program for a glyph.
    */
    execGlyph = function(glyph, prepState) {
        // original point positions
        var xScale = prepState.ppem / prepState.font.unitsPerEm;
        var yScale = xScale;
        var components = glyph.components;
        var contours;
        var gZone;
        var state;

        State.prototype = prepState;
        if (!components) {
            state = new State('glyf', glyph.instructions);
            if (exports.DEBUG) {
                console.log('---EXEC GLYPH---');
                state.step = -1;
            }
            execComponent(glyph, state, xScale, yScale);
            gZone = state.gZone;
        } else {
            var font = prepState.font;
            gZone = [];
            contours = [];
            for (var i = 0; i < components.length; i++) {
                var c = components[i];
                var cg = font.glyphs.get(c.glyphIndex);

                state = new State('glyf', cg.instructions);

                if (exports.DEBUG) {
                    console.log('---EXEC COMP ' + i + '---');
                    state.step = -1;
                }

                execComponent(cg, state, xScale, yScale);
                // appends the computed points to the result array
                // post processes the component points
                var dx = Math.round(c.dx * xScale);
                var dy = Math.round(c.dy * yScale);
                var gz = state.gZone;
                var cc = state.contours;
                for (var pi = 0; pi < gz.length; pi++) {
                    var p = gz[pi];
                    p.xTouched = p.yTouched = false;
                    p.xo = p.x = p.x + dx;
                    p.yo = p.y = p.y + dy;
                }

                var gLen = gZone.length;
                gZone.push.apply(gZone, gz);
                for (var j = 0; j < cc.length; j++) {
                    contours.push(cc[j] + gLen);
                }
            }

            if (glyph.instructions && !state.inhibitGridFit) {
                // the composite has instructions on its own
                state = new State('glyf', glyph.instructions);

                state.gZone = state.z0 = state.z1 = state.z2 = gZone;

                state.contours = contours;

                // note: HPZero cannot be used here, since
                //       the point might be modified
                gZone.push(
                    new HPoint(0, 0),
                    new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
                );

                if (exports.DEBUG) {
                    console.log('---EXEC COMPOSITE---');
                    state.step = -1;
                }

                exec(state);

                gZone.length -= 2;
            }
        }

        return gZone;
    };

    /*
    * Executes the hinting program for a component of a multi-component glyph
    * or of the glyph itself for a non-component glyph.
    */
    execComponent = function(glyph, state, xScale, yScale)
    {
        var points = glyph.points || [];
        var pLen = points.length;
        var gZone = state.gZone = state.z0 = state.z1 = state.z2 = [];
        var contours = state.contours = [];

        // Scales the original points and
        // makes copies for the hinted points.
        var cp; // current point
        for (var i = 0; i < pLen; i++) {
            cp = points[i];

            gZone[i] = new HPoint(
                cp.x * xScale,
                cp.y * yScale,
                cp.lastPointOfContour,
                cp.onCurve
            );
        }

        // Chain links the contours.
        var sp; // start point
        var np; // next point

        for (var i$1 = 0; i$1 < pLen; i$1++) {
            cp = gZone[i$1];

            if (!sp) {
                sp = cp;
                contours.push(i$1);
            }

            if (cp.lastPointOfContour) {
                cp.nextPointOnContour = sp;
                sp.prevPointOnContour = cp;
                sp = undefined;
            } else {
                np = gZone[i$1 + 1];
                cp.nextPointOnContour = np;
                np.prevPointOnContour = cp;
            }
        }

        if (state.inhibitGridFit) { return; }

        if (exports.DEBUG) {
            console.log('PROCESSING GLYPH', state.stack);
            for (var i$2 = 0; i$2 < pLen; i$2++) {
                console.log(i$2, gZone[i$2].x, gZone[i$2].y);
            }
        }

        gZone.push(
            new HPoint(0, 0),
            new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
        );

        exec(state);

        // Removes the extra points.
        gZone.length -= 2;

        if (exports.DEBUG) {
            console.log('FINISHED GLYPH', state.stack);
            for (var i$3 = 0; i$3 < pLen; i$3++) {
                console.log(i$3, gZone[i$3].x, gZone[i$3].y);
            }
        }
    };

    /*
    * Executes the program loaded in state.
    */
    exec = function(state) {
        var prog = state.prog;

        if (!prog) { return; }

        var pLen = prog.length;
        var ins;

        for (state.ip = 0; state.ip < pLen; state.ip++) {
            if (exports.DEBUG) { state.step++; }
            ins = instructionTable[prog[state.ip]];

            if (!ins) {
                throw new Error(
                    'unknown instruction: 0x' +
                    Number(prog[state.ip]).toString(16)
                );
            }

            ins(state);

            // very extensive debugging for each step
            /*
            if (exports.DEBUG) {
                var da;
                if (state.gZone) {
                    da = [];
                    for (let i = 0; i < state.gZone.length; i++)
                    {
                        da.push(i + ' ' +
                            state.gZone[i].x * 64 + ' ' +
                            state.gZone[i].y * 64 + ' ' +
                            (state.gZone[i].xTouched ? 'x' : '') +
                            (state.gZone[i].yTouched ? 'y' : '')
                        );
                    }
                    console.log('GZ', da);
                }

                if (state.tZone) {
                    da = [];
                    for (let i = 0; i < state.tZone.length; i++) {
                        da.push(i + ' ' +
                            state.tZone[i].x * 64 + ' ' +
                            state.tZone[i].y * 64 + ' ' +
                            (state.tZone[i].xTouched ? 'x' : '') +
                            (state.tZone[i].yTouched ? 'y' : '')
                        );
                    }
                    console.log('TZ', da);
                }

                if (state.stack.length > 10) {
                    console.log(
                        state.stack.length,
                        '...', state.stack.slice(state.stack.length - 10)
                    );
                } else {
                    console.log(state.stack.length, state.stack);
                }
            }
            */
        }
    };

    /*
    * Initializes the twilight zone.
    *
    * This is only done if a SZPx instruction
    * refers to the twilight zone.
    */
    function initTZone(state)
    {
        var tZone = state.tZone = new Array(state.gZone.length);

        // no idea if this is actually correct...
        for (var i = 0; i < tZone.length; i++)
        {
            tZone[i] = new HPoint(0, 0);
        }
    }

    /*
    * Skips the instruction pointer ahead over an IF/ELSE block.
    * handleElse .. if true breaks on matching ELSE
    */
    function skip(state, handleElse)
    {
        var prog = state.prog;
        var ip = state.ip;
        var nesting = 1;
        var ins;

        do {
            ins = prog[++ip];
            if (ins === 0x58) // IF
                { nesting++; }
            else if (ins === 0x59) // EIF
                { nesting--; }
            else if (ins === 0x40) // NPUSHB
                { ip += prog[ip + 1] + 1; }
            else if (ins === 0x41) // NPUSHW
                { ip += 2 * prog[ip + 1] + 1; }
            else if (ins >= 0xB0 && ins <= 0xB7) // PUSHB
                { ip += ins - 0xB0 + 1; }
            else if (ins >= 0xB8 && ins <= 0xBF) // PUSHW
                { ip += (ins - 0xB8 + 1) * 2; }
            else if (handleElse && nesting === 1 && ins === 0x1B) // ELSE
                { break; }
        } while (nesting > 0);

        state.ip = ip;
    }

    /*----------------------------------------------------------*
    *          And then a lot of instructions...                *
    *----------------------------------------------------------*/

    // SVTCA[a] Set freedom and projection Vectors To Coordinate Axis
    // 0x00-0x01
    function SVTCA(v, state) {
        if (exports.DEBUG) { console.log(state.step, 'SVTCA[' + v.axis + ']'); }

        state.fv = state.pv = state.dpv = v;
    }

    // SPVTCA[a] Set Projection Vector to Coordinate Axis
    // 0x02-0x03
    function SPVTCA(v, state) {
        if (exports.DEBUG) { console.log(state.step, 'SPVTCA[' + v.axis + ']'); }

        state.pv = state.dpv = v;
    }

    // SFVTCA[a] Set Freedom Vector to Coordinate Axis
    // 0x04-0x05
    function SFVTCA(v, state) {
        if (exports.DEBUG) { console.log(state.step, 'SFVTCA[' + v.axis + ']'); }

        state.fv = v;
    }

    // SPVTL[a] Set Projection Vector To Line
    // 0x06-0x07
    function SPVTL(a, state) {
        var stack = state.stack;
        var p2i = stack.pop();
        var p1i = stack.pop();
        var p2 = state.z2[p2i];
        var p1 = state.z1[p1i];

        if (exports.DEBUG) { console.log('SPVTL[' + a + ']', p2i, p1i); }

        var dx;
        var dy;

        if (!a) {
            dx = p1.x - p2.x;
            dy = p1.y - p2.y;
        } else {
            dx = p2.y - p1.y;
            dy = p1.x - p2.x;
        }

        state.pv = state.dpv = getUnitVector(dx, dy);
    }

    // SFVTL[a] Set Freedom Vector To Line
    // 0x08-0x09
    function SFVTL(a, state) {
        var stack = state.stack;
        var p2i = stack.pop();
        var p1i = stack.pop();
        var p2 = state.z2[p2i];
        var p1 = state.z1[p1i];

        if (exports.DEBUG) { console.log('SFVTL[' + a + ']', p2i, p1i); }

        var dx;
        var dy;

        if (!a) {
            dx = p1.x - p2.x;
            dy = p1.y - p2.y;
        } else {
            dx = p2.y - p1.y;
            dy = p1.x - p2.x;
        }

        state.fv = getUnitVector(dx, dy);
    }

    // SPVFS[] Set Projection Vector From Stack
    // 0x0A
    function SPVFS(state) {
        var stack = state.stack;
        var y = stack.pop();
        var x = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

        state.pv = state.dpv = getUnitVector(x, y);
    }

    // SFVFS[] Set Freedom Vector From Stack
    // 0x0B
    function SFVFS(state) {
        var stack = state.stack;
        var y = stack.pop();
        var x = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

        state.fv = getUnitVector(x, y);
    }

    // GPV[] Get Projection Vector
    // 0x0C
    function GPV(state) {
        var stack = state.stack;
        var pv = state.pv;

        if (exports.DEBUG) { console.log(state.step, 'GPV[]'); }

        stack.push(pv.x * 0x4000);
        stack.push(pv.y * 0x4000);
    }

    // GFV[] Get Freedom Vector
    // 0x0C
    function GFV(state) {
        var stack = state.stack;
        var fv = state.fv;

        if (exports.DEBUG) { console.log(state.step, 'GFV[]'); }

        stack.push(fv.x * 0x4000);
        stack.push(fv.y * 0x4000);
    }

    // SFVTPV[] Set Freedom Vector To Projection Vector
    // 0x0E
    function SFVTPV(state) {
        state.fv = state.pv;

        if (exports.DEBUG) { console.log(state.step, 'SFVTPV[]'); }
    }

    // ISECT[] moves point p to the InterSECTion of two lines
    // 0x0F
    function ISECT(state)
    {
        var stack = state.stack;
        var pa0i = stack.pop();
        var pa1i = stack.pop();
        var pb0i = stack.pop();
        var pb1i = stack.pop();
        var pi = stack.pop();
        var z0 = state.z0;
        var z1 = state.z1;
        var pa0 = z0[pa0i];
        var pa1 = z0[pa1i];
        var pb0 = z1[pb0i];
        var pb1 = z1[pb1i];
        var p = state.z2[pi];

        if (exports.DEBUG) { console.log('ISECT[], ', pa0i, pa1i, pb0i, pb1i, pi); }

        // math from
        // en.wikipedia.org/wiki/Line%E2%80%93line_intersection#Given_two_points_on_each_line

        var x1 = pa0.x;
        var y1 = pa0.y;
        var x2 = pa1.x;
        var y2 = pa1.y;
        var x3 = pb0.x;
        var y3 = pb0.y;
        var x4 = pb1.x;
        var y4 = pb1.y;

        var div = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        var f1 = x1 * y2 - y1 * x2;
        var f2 = x3 * y4 - y3 * x4;

        p.x = (f1 * (x3 - x4) - f2 * (x1 - x2)) / div;
        p.y = (f1 * (y3 - y4) - f2 * (y1 - y2)) / div;
    }

    // SRP0[] Set Reference Point 0
    // 0x10
    function SRP0(state) {
        state.rp0 = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SRP0[]', state.rp0); }
    }

    // SRP1[] Set Reference Point 1
    // 0x11
    function SRP1(state) {
        state.rp1 = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SRP1[]', state.rp1); }
    }

    // SRP1[] Set Reference Point 2
    // 0x12
    function SRP2(state) {
        state.rp2 = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SRP2[]', state.rp2); }
    }

    // SZP0[] Set Zone Pointer 0
    // 0x13
    function SZP0(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SZP0[]', n); }

        state.zp0 = n;

        switch (n) {
            case 0:
                if (!state.tZone) { initTZone(state); }
                state.z0 = state.tZone;
                break;
            case 1 :
                state.z0 = state.gZone;
                break;
            default :
                throw new Error('Invalid zone pointer');
        }
    }

    // SZP1[] Set Zone Pointer 1
    // 0x14
    function SZP1(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SZP1[]', n); }

        state.zp1 = n;

        switch (n) {
            case 0:
                if (!state.tZone) { initTZone(state); }
                state.z1 = state.tZone;
                break;
            case 1 :
                state.z1 = state.gZone;
                break;
            default :
                throw new Error('Invalid zone pointer');
        }
    }

    // SZP2[] Set Zone Pointer 2
    // 0x15
    function SZP2(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SZP2[]', n); }

        state.zp2 = n;

        switch (n) {
            case 0:
                if (!state.tZone) { initTZone(state); }
                state.z2 = state.tZone;
                break;
            case 1 :
                state.z2 = state.gZone;
                break;
            default :
                throw new Error('Invalid zone pointer');
        }
    }

    // SZPS[] Set Zone PointerS
    // 0x16
    function SZPS(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SZPS[]', n); }

        state.zp0 = state.zp1 = state.zp2 = n;

        switch (n) {
            case 0:
                if (!state.tZone) { initTZone(state); }
                state.z0 = state.z1 = state.z2 = state.tZone;
                break;
            case 1 :
                state.z0 = state.z1 = state.z2 = state.gZone;
                break;
            default :
                throw new Error('Invalid zone pointer');
        }
    }

    // SLOOP[] Set LOOP variable
    // 0x17
    function SLOOP(state) {
        state.loop = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SLOOP[]', state.loop); }
    }

    // RTG[] Round To Grid
    // 0x18
    function RTG(state) {
        if (exports.DEBUG) { console.log(state.step, 'RTG[]'); }

        state.round = roundToGrid;
    }

    // RTHG[] Round To Half Grid
    // 0x19
    function RTHG(state) {
        if (exports.DEBUG) { console.log(state.step, 'RTHG[]'); }

        state.round = roundToHalfGrid;
    }

    // SMD[] Set Minimum Distance
    // 0x1A
    function SMD(state) {
        var d = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SMD[]', d); }

        state.minDis = d / 0x40;
    }

    // ELSE[] ELSE clause
    // 0x1B
    function ELSE(state) {
        // This instruction has been reached by executing a then branch
        // so it just skips ahead until matching EIF.
        //
        // In case the IF was negative the IF[] instruction already
        // skipped forward over the ELSE[]

        if (exports.DEBUG) { console.log(state.step, 'ELSE[]'); }

        skip(state, false);
    }

    // JMPR[] JuMP Relative
    // 0x1C
    function JMPR(state) {
        var o = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'JMPR[]', o); }

        // A jump by 1 would do nothing.
        state.ip += o - 1;
    }

    // SCVTCI[] Set Control Value Table Cut-In
    // 0x1D
    function SCVTCI(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SCVTCI[]', n); }

        state.cvCutIn = n / 0x40;
    }

    // DUP[] DUPlicate top stack element
    // 0x20
    function DUP(state) {
        var stack = state.stack;

        if (exports.DEBUG) { console.log(state.step, 'DUP[]'); }

        stack.push(stack[stack.length - 1]);
    }

    // POP[] POP top stack element
    // 0x21
    function POP(state) {
        if (exports.DEBUG) { console.log(state.step, 'POP[]'); }

        state.stack.pop();
    }

    // CLEAR[] CLEAR the stack
    // 0x22
    function CLEAR(state) {
        if (exports.DEBUG) { console.log(state.step, 'CLEAR[]'); }

        state.stack.length = 0;
    }

    // SWAP[] SWAP the top two elements on the stack
    // 0x23
    function SWAP(state) {
        var stack = state.stack;

        var a = stack.pop();
        var b = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SWAP[]'); }

        stack.push(a);
        stack.push(b);
    }

    // DEPTH[] DEPTH of the stack
    // 0x24
    function DEPTH(state) {
        var stack = state.stack;

        if (exports.DEBUG) { console.log(state.step, 'DEPTH[]'); }

        stack.push(stack.length);
    }

    // LOOPCALL[] LOOPCALL function
    // 0x2A
    function LOOPCALL(state) {
        var stack = state.stack;
        var fn = stack.pop();
        var c = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'LOOPCALL[]', fn, c); }

        // saves callers program
        var cip = state.ip;
        var cprog = state.prog;

        state.prog = state.funcs[fn];

        // executes the function
        for (var i = 0; i < c; i++) {
            exec(state);

            if (exports.DEBUG) { console.log(
                ++state.step,
                i + 1 < c ? 'next loopcall' : 'done loopcall',
                i
            ); }
        }

        // restores the callers program
        state.ip = cip;
        state.prog = cprog;
    }

    // CALL[] CALL function
    // 0x2B
    function CALL(state) {
        var fn = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'CALL[]', fn); }

        // saves callers program
        var cip = state.ip;
        var cprog = state.prog;

        state.prog = state.funcs[fn];

        // executes the function
        exec(state);

        // restores the callers program
        state.ip = cip;
        state.prog = cprog;

        if (exports.DEBUG) { console.log(++state.step, 'returning from', fn); }
    }

    // CINDEX[] Copy the INDEXed element to the top of the stack
    // 0x25
    function CINDEX(state) {
        var stack = state.stack;
        var k = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'CINDEX[]', k); }

        // In case of k == 1, it copies the last element after popping
        // thus stack.length - k.
        stack.push(stack[stack.length - k]);
    }

    // MINDEX[] Move the INDEXed element to the top of the stack
    // 0x26
    function MINDEX(state) {
        var stack = state.stack;
        var k = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'MINDEX[]', k); }

        stack.push(stack.splice(stack.length - k, 1)[0]);
    }

    // FDEF[] Function DEFinition
    // 0x2C
    function FDEF(state) {
        if (state.env !== 'fpgm') { throw new Error('FDEF not allowed here'); }
        var stack = state.stack;
        var prog = state.prog;
        var ip = state.ip;

        var fn = stack.pop();
        var ipBegin = ip;

        if (exports.DEBUG) { console.log(state.step, 'FDEF[]', fn); }

        while (prog[++ip] !== 0x2D){ }

        state.ip = ip;
        state.funcs[fn] = prog.slice(ipBegin + 1, ip);
    }

    // MDAP[a] Move Direct Absolute Point
    // 0x2E-0x2F
    function MDAP(round, state) {
        var pi = state.stack.pop();
        var p = state.z0[pi];
        var fv = state.fv;
        var pv = state.pv;

        if (exports.DEBUG) { console.log(state.step, 'MDAP[' + round + ']', pi); }

        var d = pv.distance(p, HPZero);

        if (round) { d = state.round(d); }

        fv.setRelative(p, HPZero, d, pv);
        fv.touch(p);

        state.rp0 = state.rp1 = pi;
    }

    // IUP[a] Interpolate Untouched Points through the outline
    // 0x30
    function IUP(v, state) {
        var z2 = state.z2;
        var pLen = z2.length - 2;
        var cp;
        var pp;
        var np;

        if (exports.DEBUG) { console.log(state.step, 'IUP[' + v.axis + ']'); }

        for (var i = 0; i < pLen; i++) {
            cp = z2[i]; // current point

            // if this point has been touched go on
            if (v.touched(cp)) { continue; }

            pp = cp.prevTouched(v);

            // no point on the contour has been touched?
            if (pp === cp) { continue; }

            np = cp.nextTouched(v);

            if (pp === np) {
                // only one point on the contour has been touched
                // so simply moves the point like that

                v.setRelative(cp, cp, v.distance(pp, pp, false, true), v, true);
            }

            v.interpolate(cp, pp, np, v);
        }
    }

    // SHP[] SHift Point using reference point
    // 0x32-0x33
    function SHP(a, state) {
        var stack = state.stack;
        var rpi = a ? state.rp1 : state.rp2;
        var rp = (a ? state.z0 : state.z1)[rpi];
        var fv = state.fv;
        var pv = state.pv;
        var loop = state.loop;
        var z2 = state.z2;

        while (loop--)
        {
            var pi = stack.pop();
            var p = z2[pi];

            var d = pv.distance(rp, rp, false, true);
            fv.setRelative(p, p, d, pv);
            fv.touch(p);

            if (exports.DEBUG) {
                console.log(
                    state.step,
                    (state.loop > 1 ?
                       'loop ' + (state.loop - loop) + ': ' :
                       ''
                    ) +
                    'SHP[' + (a ? 'rp1' : 'rp2') + ']', pi
                );
            }
        }

        state.loop = 1;
    }

    // SHC[] SHift Contour using reference point
    // 0x36-0x37
    function SHC(a, state) {
        var stack = state.stack;
        var rpi = a ? state.rp1 : state.rp2;
        var rp = (a ? state.z0 : state.z1)[rpi];
        var fv = state.fv;
        var pv = state.pv;
        var ci = stack.pop();
        var sp = state.z2[state.contours[ci]];
        var p = sp;

        if (exports.DEBUG) { console.log(state.step, 'SHC[' + a + ']', ci); }

        var d = pv.distance(rp, rp, false, true);

        do {
            if (p !== rp) { fv.setRelative(p, p, d, pv); }
            p = p.nextPointOnContour;
        } while (p !== sp);
    }

    // SHZ[] SHift Zone using reference point
    // 0x36-0x37
    function SHZ(a, state) {
        var stack = state.stack;
        var rpi = a ? state.rp1 : state.rp2;
        var rp = (a ? state.z0 : state.z1)[rpi];
        var fv = state.fv;
        var pv = state.pv;

        var e = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SHZ[' + a + ']', e); }

        var z;
        switch (e) {
            case 0 : z = state.tZone; break;
            case 1 : z = state.gZone; break;
            default : throw new Error('Invalid zone');
        }

        var p;
        var d = pv.distance(rp, rp, false, true);
        var pLen = z.length - 2;
        for (var i = 0; i < pLen; i++)
        {
            p = z[i];
            fv.setRelative(p, p, d, pv);
            //if (p !== rp) fv.setRelative(p, p, d, pv);
        }
    }

    // SHPIX[] SHift point by a PIXel amount
    // 0x38
    function SHPIX(state) {
        var stack = state.stack;
        var loop = state.loop;
        var fv = state.fv;
        var d = stack.pop() / 0x40;
        var z2 = state.z2;

        while (loop--) {
            var pi = stack.pop();
            var p = z2[pi];

            if (exports.DEBUG) {
                console.log(
                    state.step,
                    (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                    'SHPIX[]', pi, d
                );
            }

            fv.setRelative(p, p, d);
            fv.touch(p);
        }

        state.loop = 1;
    }

    // IP[] Interpolate Point
    // 0x39
    function IP(state) {
        var stack = state.stack;
        var rp1i = state.rp1;
        var rp2i = state.rp2;
        var loop = state.loop;
        var rp1 = state.z0[rp1i];
        var rp2 = state.z1[rp2i];
        var fv = state.fv;
        var pv = state.dpv;
        var z2 = state.z2;

        while (loop--) {
            var pi = stack.pop();
            var p = z2[pi];

            if (exports.DEBUG) {
                console.log(
                    state.step,
                    (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                    'IP[]', pi, rp1i, '<->', rp2i
                );
            }

            fv.interpolate(p, rp1, rp2, pv);

            fv.touch(p);
        }

        state.loop = 1;
    }

    // MSIRP[a] Move Stack Indirect Relative Point
    // 0x3A-0x3B
    function MSIRP(a, state) {
        var stack = state.stack;
        var d = stack.pop() / 64;
        var pi = stack.pop();
        var p = state.z1[pi];
        var rp0 = state.z0[state.rp0];
        var fv = state.fv;
        var pv = state.pv;

        fv.setRelative(p, rp0, d, pv);
        fv.touch(p);

        if (exports.DEBUG) { console.log(state.step, 'MSIRP[' + a + ']', d, pi); }

        state.rp1 = state.rp0;
        state.rp2 = pi;
        if (a) { state.rp0 = pi; }
    }

    // ALIGNRP[] Align to reference point.
    // 0x3C
    function ALIGNRP(state) {
        var stack = state.stack;
        var rp0i = state.rp0;
        var rp0 = state.z0[rp0i];
        var loop = state.loop;
        var fv = state.fv;
        var pv = state.pv;
        var z1 = state.z1;

        while (loop--) {
            var pi = stack.pop();
            var p = z1[pi];

            if (exports.DEBUG) {
                console.log(
                    state.step,
                    (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                    'ALIGNRP[]', pi
                );
            }

            fv.setRelative(p, rp0, 0, pv);
            fv.touch(p);
        }

        state.loop = 1;
    }

    // RTG[] Round To Double Grid
    // 0x3D
    function RTDG(state) {
        if (exports.DEBUG) { console.log(state.step, 'RTDG[]'); }

        state.round = roundToDoubleGrid;
    }

    // MIAP[a] Move Indirect Absolute Point
    // 0x3E-0x3F
    function MIAP(round, state) {
        var stack = state.stack;
        var n = stack.pop();
        var pi = stack.pop();
        var p = state.z0[pi];
        var fv = state.fv;
        var pv = state.pv;
        var cv = state.cvt[n];

        if (exports.DEBUG) {
            console.log(
                state.step,
                'MIAP[' + round + ']',
                n, '(', cv, ')', pi
            );
        }

        var d = pv.distance(p, HPZero);

        if (round) {
            if (Math.abs(d - cv) < state.cvCutIn) { d = cv; }

            d = state.round(d);
        }

        fv.setRelative(p, HPZero, d, pv);

        if (state.zp0 === 0) {
            p.xo = p.x;
            p.yo = p.y;
        }

        fv.touch(p);

        state.rp0 = state.rp1 = pi;
    }

    // NPUSB[] PUSH N Bytes
    // 0x40
    function NPUSHB(state) {
        var prog = state.prog;
        var ip = state.ip;
        var stack = state.stack;

        var n = prog[++ip];

        if (exports.DEBUG) { console.log(state.step, 'NPUSHB[]', n); }

        for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

        state.ip = ip;
    }

    // NPUSHW[] PUSH N Words
    // 0x41
    function NPUSHW(state) {
        var ip = state.ip;
        var prog = state.prog;
        var stack = state.stack;
        var n = prog[++ip];

        if (exports.DEBUG) { console.log(state.step, 'NPUSHW[]', n); }

        for (var i = 0; i < n; i++) {
            var w = (prog[++ip] << 8) | prog[++ip];
            if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
            stack.push(w);
        }

        state.ip = ip;
    }

    // WS[] Write Store
    // 0x42
    function WS(state) {
        var stack = state.stack;
        var store = state.store;

        if (!store) { store = state.store = []; }

        var v = stack.pop();
        var l = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'WS', v, l); }

        store[l] = v;
    }

    // RS[] Read Store
    // 0x43
    function RS(state) {
        var stack = state.stack;
        var store = state.store;

        var l = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'RS', l); }

        var v = (store && store[l]) || 0;

        stack.push(v);
    }

    // WCVTP[] Write Control Value Table in Pixel units
    // 0x44
    function WCVTP(state) {
        var stack = state.stack;

        var v = stack.pop();
        var l = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'WCVTP', v, l); }

        state.cvt[l] = v / 0x40;
    }

    // RCVT[] Read Control Value Table entry
    // 0x45
    function RCVT(state) {
        var stack = state.stack;
        var cvte = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'RCVT', cvte); }

        stack.push(state.cvt[cvte] * 0x40);
    }

    // GC[] Get Coordinate projected onto the projection vector
    // 0x46-0x47
    function GC(a, state) {
        var stack = state.stack;
        var pi = stack.pop();
        var p = state.z2[pi];

        if (exports.DEBUG) { console.log(state.step, 'GC[' + a + ']', pi); }

        stack.push(state.dpv.distance(p, HPZero, a, false) * 0x40);
    }

    // MD[a] Measure Distance
    // 0x49-0x4A
    function MD(a, state) {
        var stack = state.stack;
        var pi2 = stack.pop();
        var pi1 = stack.pop();
        var p2 = state.z1[pi2];
        var p1 = state.z0[pi1];
        var d = state.dpv.distance(p1, p2, a, a);

        if (exports.DEBUG) { console.log(state.step, 'MD[' + a + ']', pi2, pi1, '->', d); }

        state.stack.push(Math.round(d * 64));
    }

    // MPPEM[] Measure Pixels Per EM
    // 0x4B
    function MPPEM(state) {
        if (exports.DEBUG) { console.log(state.step, 'MPPEM[]'); }
        state.stack.push(state.ppem);
    }

    // FLIPON[] set the auto FLIP Boolean to ON
    // 0x4D
    function FLIPON(state) {
        if (exports.DEBUG) { console.log(state.step, 'FLIPON[]'); }
        state.autoFlip = true;
    }

    // LT[] Less Than
    // 0x50
    function LT(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'LT[]', e2, e1); }

        stack.push(e1 < e2 ? 1 : 0);
    }

    // LTEQ[] Less Than or EQual
    // 0x53
    function LTEQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'LTEQ[]', e2, e1); }

        stack.push(e1 <= e2 ? 1 : 0);
    }

    // GTEQ[] Greater Than
    // 0x52
    function GT(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'GT[]', e2, e1); }

        stack.push(e1 > e2 ? 1 : 0);
    }

    // GTEQ[] Greater Than or EQual
    // 0x53
    function GTEQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'GTEQ[]', e2, e1); }

        stack.push(e1 >= e2 ? 1 : 0);
    }

    // EQ[] EQual
    // 0x54
    function EQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'EQ[]', e2, e1); }

        stack.push(e2 === e1 ? 1 : 0);
    }

    // NEQ[] Not EQual
    // 0x55
    function NEQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'NEQ[]', e2, e1); }

        stack.push(e2 !== e1 ? 1 : 0);
    }

    // ODD[] ODD
    // 0x56
    function ODD(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'ODD[]', n); }

        stack.push(Math.trunc(n) % 2 ? 1 : 0);
    }

    // EVEN[] EVEN
    // 0x57
    function EVEN(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'EVEN[]', n); }

        stack.push(Math.trunc(n) % 2 ? 0 : 1);
    }

    // IF[] IF test
    // 0x58
    function IF(state) {
        var test = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'IF[]', test); }

        // if test is true it just continues
        // if not the ip is skipped until matching ELSE or EIF
        if (!test) {
            skip(state, true);

            if (exports.DEBUG) { console.log(state.step,  'EIF[]'); }
        }
    }

    // EIF[] End IF
    // 0x59
    function EIF(state) {
        // this can be reached normally when
        // executing an else branch.
        // -> just ignore it

        if (exports.DEBUG) { console.log(state.step, 'EIF[]'); }
    }

    // AND[] logical AND
    // 0x5A
    function AND(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'AND[]', e2, e1); }

        stack.push(e2 && e1 ? 1 : 0);
    }

    // OR[] logical OR
    // 0x5B
    function OR(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'OR[]', e2, e1); }

        stack.push(e2 || e1 ? 1 : 0);
    }

    // NOT[] logical NOT
    // 0x5C
    function NOT(state) {
        var stack = state.stack;
        var e = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'NOT[]', e); }

        stack.push(e ? 0 : 1);
    }

    // DELTAP1[] DELTA exception P1
    // DELTAP2[] DELTA exception P2
    // DELTAP3[] DELTA exception P3
    // 0x5D, 0x71, 0x72
    function DELTAP123(b, state) {
        var stack = state.stack;
        var n = stack.pop();
        var fv = state.fv;
        var pv = state.pv;
        var ppem = state.ppem;
        var base = state.deltaBase + (b - 1) * 16;
        var ds = state.deltaShift;
        var z0 = state.z0;

        if (exports.DEBUG) { console.log(state.step, 'DELTAP[' + b + ']', n, stack); }

        for (var i = 0; i < n; i++) {
            var pi = stack.pop();
            var arg = stack.pop();
            var appem = base + ((arg & 0xF0) >> 4);
            if (appem !== ppem) { continue; }

            var mag = (arg & 0x0F) - 8;
            if (mag >= 0) { mag++; }
            if (exports.DEBUG) { console.log(state.step, 'DELTAPFIX', pi, 'by', mag * ds); }

            var p = z0[pi];
            fv.setRelative(p, p, mag * ds, pv);
        }
    }

    // SDB[] Set Delta Base in the graphics state
    // 0x5E
    function SDB(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SDB[]', n); }

        state.deltaBase = n;
    }

    // SDS[] Set Delta Shift in the graphics state
    // 0x5F
    function SDS(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SDS[]', n); }

        state.deltaShift = Math.pow(0.5, n);
    }

    // ADD[] ADD
    // 0x60
    function ADD(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'ADD[]', n2, n1); }

        stack.push(n1 + n2);
    }

    // SUB[] SUB
    // 0x61
    function SUB(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SUB[]', n2, n1); }

        stack.push(n1 - n2);
    }

    // DIV[] DIV
    // 0x62
    function DIV(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'DIV[]', n2, n1); }

        stack.push(n1 * 64 / n2);
    }

    // MUL[] MUL
    // 0x63
    function MUL(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'MUL[]', n2, n1); }

        stack.push(n1 * n2 / 64);
    }

    // ABS[] ABSolute value
    // 0x64
    function ABS(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'ABS[]', n); }

        stack.push(Math.abs(n));
    }

    // NEG[] NEGate
    // 0x65
    function NEG(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'NEG[]', n); }

        stack.push(-n);
    }

    // FLOOR[] FLOOR
    // 0x66
    function FLOOR(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'FLOOR[]', n); }

        stack.push(Math.floor(n / 0x40) * 0x40);
    }

    // CEILING[] CEILING
    // 0x67
    function CEILING(state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'CEILING[]', n); }

        stack.push(Math.ceil(n / 0x40) * 0x40);
    }

    // ROUND[ab] ROUND value
    // 0x68-0x6B
    function ROUND(dt, state) {
        var stack = state.stack;
        var n = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'ROUND[]'); }

        stack.push(state.round(n / 0x40) * 0x40);
    }

    // WCVTF[] Write Control Value Table in Funits
    // 0x70
    function WCVTF(state) {
        var stack = state.stack;
        var v = stack.pop();
        var l = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'WCVTF[]', v, l); }

        state.cvt[l] = v * state.ppem / state.font.unitsPerEm;
    }

    // DELTAC1[] DELTA exception C1
    // DELTAC2[] DELTA exception C2
    // DELTAC3[] DELTA exception C3
    // 0x73, 0x74, 0x75
    function DELTAC123(b, state) {
        var stack = state.stack;
        var n = stack.pop();
        var ppem = state.ppem;
        var base = state.deltaBase + (b - 1) * 16;
        var ds = state.deltaShift;

        if (exports.DEBUG) { console.log(state.step, 'DELTAC[' + b + ']', n, stack); }

        for (var i = 0; i < n; i++) {
            var c = stack.pop();
            var arg = stack.pop();
            var appem = base + ((arg & 0xF0) >> 4);
            if (appem !== ppem) { continue; }

            var mag = (arg & 0x0F) - 8;
            if (mag >= 0) { mag++; }

            var delta = mag * ds;

            if (exports.DEBUG) { console.log(state.step, 'DELTACFIX', c, 'by', delta); }

            state.cvt[c] += delta;
        }
    }

    // SROUND[] Super ROUND
    // 0x76
    function SROUND(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'SROUND[]', n); }

        state.round = roundSuper;

        var period;

        switch (n & 0xC0) {
            case 0x00:
                period = 0.5;
                break;
            case 0x40:
                period = 1;
                break;
            case 0x80:
                period = 2;
                break;
            default:
                throw new Error('invalid SROUND value');
        }

        state.srPeriod = period;

        switch (n & 0x30) {
            case 0x00:
                state.srPhase = 0;
                break;
            case 0x10:
                state.srPhase = 0.25 * period;
                break;
            case 0x20:
                state.srPhase = 0.5  * period;
                break;
            case 0x30:
                state.srPhase = 0.75 * period;
                break;
            default: throw new Error('invalid SROUND value');
        }

        n &= 0x0F;

        if (n === 0) { state.srThreshold = 0; }
        else { state.srThreshold = (n / 8 - 0.5) * period; }
    }

    // S45ROUND[] Super ROUND 45 degrees
    // 0x77
    function S45ROUND(state) {
        var n = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'S45ROUND[]', n); }

        state.round = roundSuper;

        var period;

        switch (n & 0xC0) {
            case 0x00:
                period = Math.sqrt(2) / 2;
                break;
            case 0x40:
                period = Math.sqrt(2);
                break;
            case 0x80:
                period = 2 * Math.sqrt(2);
                break;
            default:
                throw new Error('invalid S45ROUND value');
        }

        state.srPeriod = period;

        switch (n & 0x30) {
            case 0x00:
                state.srPhase = 0;
                break;
            case 0x10:
                state.srPhase = 0.25 * period;
                break;
            case 0x20:
                state.srPhase = 0.5  * period;
                break;
            case 0x30:
                state.srPhase = 0.75 * period;
                break;
            default:
                throw new Error('invalid S45ROUND value');
        }

        n &= 0x0F;

        if (n === 0) { state.srThreshold = 0; }
        else { state.srThreshold = (n / 8 - 0.5) * period; }
    }

    // ROFF[] Round Off
    // 0x7A
    function ROFF(state) {
        if (exports.DEBUG) { console.log(state.step, 'ROFF[]'); }

        state.round = roundOff;
    }

    // RUTG[] Round Up To Grid
    // 0x7C
    function RUTG(state) {
        if (exports.DEBUG) { console.log(state.step, 'RUTG[]'); }

        state.round = roundUpToGrid;
    }

    // RDTG[] Round Down To Grid
    // 0x7D
    function RDTG(state) {
        if (exports.DEBUG) { console.log(state.step, 'RDTG[]'); }

        state.round = roundDownToGrid;
    }

    // SCANCTRL[] SCAN conversion ConTRoL
    // 0x85
    function SCANCTRL(state) {
        var n = state.stack.pop();

        // ignored by opentype.js

        if (exports.DEBUG) { console.log(state.step, 'SCANCTRL[]', n); }
    }

    // SDPVTL[a] Set Dual Projection Vector To Line
    // 0x86-0x87
    function SDPVTL(a, state) {
        var stack = state.stack;
        var p2i = stack.pop();
        var p1i = stack.pop();
        var p2 = state.z2[p2i];
        var p1 = state.z1[p1i];

        if (exports.DEBUG) { console.log(state.step, 'SDPVTL[' + a + ']', p2i, p1i); }

        var dx;
        var dy;

        if (!a) {
            dx = p1.x - p2.x;
            dy = p1.y - p2.y;
        } else {
            dx = p2.y - p1.y;
            dy = p1.x - p2.x;
        }

        state.dpv = getUnitVector(dx, dy);
    }

    // GETINFO[] GET INFOrmation
    // 0x88
    function GETINFO(state) {
        var stack = state.stack;
        var sel = stack.pop();
        var r = 0;

        if (exports.DEBUG) { console.log(state.step, 'GETINFO[]', sel); }

        // v35 as in no subpixel hinting
        if (sel & 0x01) { r = 35; }

        // TODO rotation and stretch currently not supported
        // and thus those GETINFO are always 0.

        // opentype.js is always gray scaling
        if (sel & 0x20) { r |= 0x1000; }

        stack.push(r);
    }

    // ROLL[] ROLL the top three stack elements
    // 0x8A
    function ROLL(state) {
        var stack = state.stack;
        var a = stack.pop();
        var b = stack.pop();
        var c = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'ROLL[]'); }

        stack.push(b);
        stack.push(a);
        stack.push(c);
    }

    // MAX[] MAXimum of top two stack elements
    // 0x8B
    function MAX(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'MAX[]', e2, e1); }

        stack.push(Math.max(e1, e2));
    }

    // MIN[] MINimum of top two stack elements
    // 0x8C
    function MIN(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'MIN[]', e2, e1); }

        stack.push(Math.min(e1, e2));
    }

    // SCANTYPE[] SCANTYPE
    // 0x8D
    function SCANTYPE(state) {
        var n = state.stack.pop();
        // ignored by opentype.js
        if (exports.DEBUG) { console.log(state.step, 'SCANTYPE[]', n); }
    }

    // INSTCTRL[] INSTCTRL
    // 0x8D
    function INSTCTRL(state) {
        var s = state.stack.pop();
        var v = state.stack.pop();

        if (exports.DEBUG) { console.log(state.step, 'INSTCTRL[]', s, v); }

        switch (s) {
            case 1 : state.inhibitGridFit = !!v; return;
            case 2 : state.ignoreCvt = !!v; return;
            default: throw new Error('invalid INSTCTRL[] selector');
        }
    }

    // PUSHB[abc] PUSH Bytes
    // 0xB0-0xB7
    function PUSHB(n, state) {
        var stack = state.stack;
        var prog = state.prog;
        var ip = state.ip;

        if (exports.DEBUG) { console.log(state.step, 'PUSHB[' + n + ']'); }

        for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

        state.ip = ip;
    }

    // PUSHW[abc] PUSH Words
    // 0xB8-0xBF
    function PUSHW(n, state) {
        var ip = state.ip;
        var prog = state.prog;
        var stack = state.stack;

        if (exports.DEBUG) { console.log(state.ip, 'PUSHW[' + n + ']'); }

        for (var i = 0; i < n; i++) {
            var w = (prog[++ip] << 8) | prog[++ip];
            if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
            stack.push(w);
        }

        state.ip = ip;
    }

    // MDRP[abcde] Move Direct Relative Point
    // 0xD0-0xEF
    // (if indirect is 0)
    //
    // and
    //
    // MIRP[abcde] Move Indirect Relative Point
    // 0xE0-0xFF
    // (if indirect is 1)

    function MDRP_MIRP(indirect, setRp0, keepD, ro, dt, state) {
        var stack = state.stack;
        var cvte = indirect && stack.pop();
        var pi = stack.pop();
        var rp0i = state.rp0;
        var rp = state.z0[rp0i];
        var p = state.z1[pi];

        var md = state.minDis;
        var fv = state.fv;
        var pv = state.dpv;
        var od; // original distance
        var d; // moving distance
        var sign; // sign of distance
        var cv;

        d = od = pv.distance(p, rp, true, true);
        sign = d >= 0 ? 1 : -1; // Math.sign would be 0 in case of 0

        // TODO consider autoFlip
        d = Math.abs(d);

        if (indirect) {
            cv = state.cvt[cvte];

            if (ro && Math.abs(d - cv) < state.cvCutIn) { d = cv; }
        }

        if (keepD && d < md) { d = md; }

        if (ro) { d = state.round(d); }

        fv.setRelative(p, rp, sign * d, pv);
        fv.touch(p);

        if (exports.DEBUG) {
            console.log(
                state.step,
                (indirect ? 'MIRP[' : 'MDRP[') +
                (setRp0 ? 'M' : 'm') +
                (keepD ? '>' : '_') +
                (ro ? 'R' : '_') +
                (dt === 0 ? 'Gr' : (dt === 1 ? 'Bl' : (dt === 2 ? 'Wh' : ''))) +
                ']',
                indirect ?
                    cvte + '(' + state.cvt[cvte] + ',' +  cv + ')' :
                    '',
                pi,
                '(d =', od, '->', sign * d, ')'
            );
        }

        state.rp1 = state.rp0;
        state.rp2 = pi;
        if (setRp0) { state.rp0 = pi; }
    }

    /*
    * The instruction table.
    */
    instructionTable = [
        /* 0x00 */ SVTCA.bind(undefined, yUnitVector),
        /* 0x01 */ SVTCA.bind(undefined, xUnitVector),
        /* 0x02 */ SPVTCA.bind(undefined, yUnitVector),
        /* 0x03 */ SPVTCA.bind(undefined, xUnitVector),
        /* 0x04 */ SFVTCA.bind(undefined, yUnitVector),
        /* 0x05 */ SFVTCA.bind(undefined, xUnitVector),
        /* 0x06 */ SPVTL.bind(undefined, 0),
        /* 0x07 */ SPVTL.bind(undefined, 1),
        /* 0x08 */ SFVTL.bind(undefined, 0),
        /* 0x09 */ SFVTL.bind(undefined, 1),
        /* 0x0A */ SPVFS,
        /* 0x0B */ SFVFS,
        /* 0x0C */ GPV,
        /* 0x0D */ GFV,
        /* 0x0E */ SFVTPV,
        /* 0x0F */ ISECT,
        /* 0x10 */ SRP0,
        /* 0x11 */ SRP1,
        /* 0x12 */ SRP2,
        /* 0x13 */ SZP0,
        /* 0x14 */ SZP1,
        /* 0x15 */ SZP2,
        /* 0x16 */ SZPS,
        /* 0x17 */ SLOOP,
        /* 0x18 */ RTG,
        /* 0x19 */ RTHG,
        /* 0x1A */ SMD,
        /* 0x1B */ ELSE,
        /* 0x1C */ JMPR,
        /* 0x1D */ SCVTCI,
        /* 0x1E */ undefined,   // TODO SSWCI
        /* 0x1F */ undefined,   // TODO SSW
        /* 0x20 */ DUP,
        /* 0x21 */ POP,
        /* 0x22 */ CLEAR,
        /* 0x23 */ SWAP,
        /* 0x24 */ DEPTH,
        /* 0x25 */ CINDEX,
        /* 0x26 */ MINDEX,
        /* 0x27 */ undefined,   // TODO ALIGNPTS
        /* 0x28 */ undefined,
        /* 0x29 */ undefined,   // TODO UTP
        /* 0x2A */ LOOPCALL,
        /* 0x2B */ CALL,
        /* 0x2C */ FDEF,
        /* 0x2D */ undefined,   // ENDF (eaten by FDEF)
        /* 0x2E */ MDAP.bind(undefined, 0),
        /* 0x2F */ MDAP.bind(undefined, 1),
        /* 0x30 */ IUP.bind(undefined, yUnitVector),
        /* 0x31 */ IUP.bind(undefined, xUnitVector),
        /* 0x32 */ SHP.bind(undefined, 0),
        /* 0x33 */ SHP.bind(undefined, 1),
        /* 0x34 */ SHC.bind(undefined, 0),
        /* 0x35 */ SHC.bind(undefined, 1),
        /* 0x36 */ SHZ.bind(undefined, 0),
        /* 0x37 */ SHZ.bind(undefined, 1),
        /* 0x38 */ SHPIX,
        /* 0x39 */ IP,
        /* 0x3A */ MSIRP.bind(undefined, 0),
        /* 0x3B */ MSIRP.bind(undefined, 1),
        /* 0x3C */ ALIGNRP,
        /* 0x3D */ RTDG,
        /* 0x3E */ MIAP.bind(undefined, 0),
        /* 0x3F */ MIAP.bind(undefined, 1),
        /* 0x40 */ NPUSHB,
        /* 0x41 */ NPUSHW,
        /* 0x42 */ WS,
        /* 0x43 */ RS,
        /* 0x44 */ WCVTP,
        /* 0x45 */ RCVT,
        /* 0x46 */ GC.bind(undefined, 0),
        /* 0x47 */ GC.bind(undefined, 1),
        /* 0x48 */ undefined,   // TODO SCFS
        /* 0x49 */ MD.bind(undefined, 0),
        /* 0x4A */ MD.bind(undefined, 1),
        /* 0x4B */ MPPEM,
        /* 0x4C */ undefined,   // TODO MPS
        /* 0x4D */ FLIPON,
        /* 0x4E */ undefined,   // TODO FLIPOFF
        /* 0x4F */ undefined,   // TODO DEBUG
        /* 0x50 */ LT,
        /* 0x51 */ LTEQ,
        /* 0x52 */ GT,
        /* 0x53 */ GTEQ,
        /* 0x54 */ EQ,
        /* 0x55 */ NEQ,
        /* 0x56 */ ODD,
        /* 0x57 */ EVEN,
        /* 0x58 */ IF,
        /* 0x59 */ EIF,
        /* 0x5A */ AND,
        /* 0x5B */ OR,
        /* 0x5C */ NOT,
        /* 0x5D */ DELTAP123.bind(undefined, 1),
        /* 0x5E */ SDB,
        /* 0x5F */ SDS,
        /* 0x60 */ ADD,
        /* 0x61 */ SUB,
        /* 0x62 */ DIV,
        /* 0x63 */ MUL,
        /* 0x64 */ ABS,
        /* 0x65 */ NEG,
        /* 0x66 */ FLOOR,
        /* 0x67 */ CEILING,
        /* 0x68 */ ROUND.bind(undefined, 0),
        /* 0x69 */ ROUND.bind(undefined, 1),
        /* 0x6A */ ROUND.bind(undefined, 2),
        /* 0x6B */ ROUND.bind(undefined, 3),
        /* 0x6C */ undefined,   // TODO NROUND[ab]
        /* 0x6D */ undefined,   // TODO NROUND[ab]
        /* 0x6E */ undefined,   // TODO NROUND[ab]
        /* 0x6F */ undefined,   // TODO NROUND[ab]
        /* 0x70 */ WCVTF,
        /* 0x71 */ DELTAP123.bind(undefined, 2),
        /* 0x72 */ DELTAP123.bind(undefined, 3),
        /* 0x73 */ DELTAC123.bind(undefined, 1),
        /* 0x74 */ DELTAC123.bind(undefined, 2),
        /* 0x75 */ DELTAC123.bind(undefined, 3),
        /* 0x76 */ SROUND,
        /* 0x77 */ S45ROUND,
        /* 0x78 */ undefined,   // TODO JROT[]
        /* 0x79 */ undefined,   // TODO JROF[]
        /* 0x7A */ ROFF,
        /* 0x7B */ undefined,
        /* 0x7C */ RUTG,
        /* 0x7D */ RDTG,
        /* 0x7E */ POP, // actually SANGW, supposed to do only a pop though
        /* 0x7F */ POP, // actually AA, supposed to do only a pop though
        /* 0x80 */ undefined,   // TODO FLIPPT
        /* 0x81 */ undefined,   // TODO FLIPRGON
        /* 0x82 */ undefined,   // TODO FLIPRGOFF
        /* 0x83 */ undefined,
        /* 0x84 */ undefined,
        /* 0x85 */ SCANCTRL,
        /* 0x86 */ SDPVTL.bind(undefined, 0),
        /* 0x87 */ SDPVTL.bind(undefined, 1),
        /* 0x88 */ GETINFO,
        /* 0x89 */ undefined,   // TODO IDEF
        /* 0x8A */ ROLL,
        /* 0x8B */ MAX,
        /* 0x8C */ MIN,
        /* 0x8D */ SCANTYPE,
        /* 0x8E */ INSTCTRL,
        /* 0x8F */ undefined,
        /* 0x90 */ undefined,
        /* 0x91 */ undefined,
        /* 0x92 */ undefined,
        /* 0x93 */ undefined,
        /* 0x94 */ undefined,
        /* 0x95 */ undefined,
        /* 0x96 */ undefined,
        /* 0x97 */ undefined,
        /* 0x98 */ undefined,
        /* 0x99 */ undefined,
        /* 0x9A */ undefined,
        /* 0x9B */ undefined,
        /* 0x9C */ undefined,
        /* 0x9D */ undefined,
        /* 0x9E */ undefined,
        /* 0x9F */ undefined,
        /* 0xA0 */ undefined,
        /* 0xA1 */ undefined,
        /* 0xA2 */ undefined,
        /* 0xA3 */ undefined,
        /* 0xA4 */ undefined,
        /* 0xA5 */ undefined,
        /* 0xA6 */ undefined,
        /* 0xA7 */ undefined,
        /* 0xA8 */ undefined,
        /* 0xA9 */ undefined,
        /* 0xAA */ undefined,
        /* 0xAB */ undefined,
        /* 0xAC */ undefined,
        /* 0xAD */ undefined,
        /* 0xAE */ undefined,
        /* 0xAF */ undefined,
        /* 0xB0 */ PUSHB.bind(undefined, 1),
        /* 0xB1 */ PUSHB.bind(undefined, 2),
        /* 0xB2 */ PUSHB.bind(undefined, 3),
        /* 0xB3 */ PUSHB.bind(undefined, 4),
        /* 0xB4 */ PUSHB.bind(undefined, 5),
        /* 0xB5 */ PUSHB.bind(undefined, 6),
        /* 0xB6 */ PUSHB.bind(undefined, 7),
        /* 0xB7 */ PUSHB.bind(undefined, 8),
        /* 0xB8 */ PUSHW.bind(undefined, 1),
        /* 0xB9 */ PUSHW.bind(undefined, 2),
        /* 0xBA */ PUSHW.bind(undefined, 3),
        /* 0xBB */ PUSHW.bind(undefined, 4),
        /* 0xBC */ PUSHW.bind(undefined, 5),
        /* 0xBD */ PUSHW.bind(undefined, 6),
        /* 0xBE */ PUSHW.bind(undefined, 7),
        /* 0xBF */ PUSHW.bind(undefined, 8),
        /* 0xC0 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 0),
        /* 0xC1 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 1),
        /* 0xC2 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 2),
        /* 0xC3 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 3),
        /* 0xC4 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 0),
        /* 0xC5 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 1),
        /* 0xC6 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 2),
        /* 0xC7 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 3),
        /* 0xC8 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 0),
        /* 0xC9 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 1),
        /* 0xCA */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 2),
        /* 0xCB */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 3),
        /* 0xCC */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 0),
        /* 0xCD */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 1),
        /* 0xCE */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 2),
        /* 0xCF */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 3),
        /* 0xD0 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 0),
        /* 0xD1 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 1),
        /* 0xD2 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 2),
        /* 0xD3 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 3),
        /* 0xD4 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 0),
        /* 0xD5 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 1),
        /* 0xD6 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 2),
        /* 0xD7 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 3),
        /* 0xD8 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 0),
        /* 0xD9 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 1),
        /* 0xDA */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 2),
        /* 0xDB */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 3),
        /* 0xDC */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 0),
        /* 0xDD */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 1),
        /* 0xDE */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 2),
        /* 0xDF */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 3),
        /* 0xE0 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 0),
        /* 0xE1 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 1),
        /* 0xE2 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 2),
        /* 0xE3 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 3),
        /* 0xE4 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 0),
        /* 0xE5 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 1),
        /* 0xE6 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 2),
        /* 0xE7 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 3),
        /* 0xE8 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 0),
        /* 0xE9 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 1),
        /* 0xEA */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 2),
        /* 0xEB */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 3),
        /* 0xEC */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 0),
        /* 0xED */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 1),
        /* 0xEE */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 2),
        /* 0xEF */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 3),
        /* 0xF0 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 0),
        /* 0xF1 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 1),
        /* 0xF2 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 2),
        /* 0xF3 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 3),
        /* 0xF4 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 0),
        /* 0xF5 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 1),
        /* 0xF6 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 2),
        /* 0xF7 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 3),
        /* 0xF8 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 0),
        /* 0xF9 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 1),
        /* 0xFA */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 2),
        /* 0xFB */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 3),
        /* 0xFC */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 0),
        /* 0xFD */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 1),
        /* 0xFE */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 2),
        /* 0xFF */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 3)
    ];

    /*****************************
      Mathematical Considerations
    ******************************

    fv ... refers to freedom vector
    pv ... refers to projection vector
    rp ... refers to reference point
    p  ... refers to to point being operated on
    d  ... refers to distance

    SETRELATIVE:
    ============

    case freedom vector == x-axis:
    ------------------------------

                            (pv)
                         .-'
                  rpd .-'
                   .-*
              d .-'90°'
             .-'       '
          .-'           '
       *-'               ' b
      rp                  '
                           '
                            '
                p *----------*-------------- (fv)
                              pm

      rpdx = rpx + d * pv.x
      rpdy = rpy + d * pv.y

      equation of line b

       y - rpdy = pvns * (x- rpdx)

       y = p.y

       x = rpdx + ( p.y - rpdy ) / pvns


    case freedom vector == y-axis:
    ------------------------------

        * pm
        |\
        | \
        |  \
        |   \
        |    \
        |     \
        |      \
        |       \
        |        \
        |         \ b
        |          \
        |           \
        |            \    .-' (pv)
        |         90° \.-'
        |           .-'* rpd
        |        .-'
        *     *-'  d
        p     rp

      rpdx = rpx + d * pv.x
      rpdy = rpy + d * pv.y

      equation of line b:
               pvns ... normal slope to pv

       y - rpdy = pvns * (x - rpdx)

       x = p.x

       y = rpdy +  pvns * (p.x - rpdx)



    generic case:
    -------------


                                  .'(fv)
                                .'
                              .* pm
                            .' !
                          .'    .
                        .'      !
                      .'         . b
                    .'           !
                   *              .
                  p               !
                             90°   .    ... (pv)
                               ...-*-'''
                      ...---'''    rpd
             ...---'''   d
       *--'''
      rp

        rpdx = rpx + d * pv.x
        rpdy = rpy + d * pv.y

     equation of line b:
        pvns... normal slope to pv

        y - rpdy = pvns * (x - rpdx)

     equation of freedom vector line:
        fvs ... slope of freedom vector (=fy/fx)

        y - py = fvs * (x - px)


      on pm both equations are true for same x/y

        y - rpdy = pvns * (x - rpdx)

        y - py = fvs * (x - px)

      form to y and set equal:

        pvns * (x - rpdx) + rpdy = fvs * (x - px) + py

      expand:

        pvns * x - pvns * rpdx + rpdy = fvs * x - fvs * px + py

      switch:

        fvs * x - fvs * px + py = pvns * x - pvns * rpdx + rpdy

      solve for x:

        fvs * x - pvns * x = fvs * px - pvns * rpdx - py + rpdy



              fvs * px - pvns * rpdx + rpdy - py
        x =  -----------------------------------
                     fvs - pvns

      and:

        y = fvs * (x - px) + py



    INTERPOLATE:
    ============

    Examples of point interpolation.

    The weight of the movement of the reference point gets bigger
    the further the other reference point is away, thus the safest
    option (that is avoiding 0/0 divisions) is to weight the
    original distance of the other point by the sum of both distances.

    If the sum of both distances is 0, then move the point by the
    arithmetic average of the movement of both reference points.




               (+6)
        rp1o *---->*rp1
             .     .                          (+12)
             .     .                  rp2o *---------->* rp2
             .     .                       .           .
             .     .                       .           .
             .    10          20           .           .
             |.........|...................|           .
                   .   .                               .
                   .   . (+8)                          .
                    po *------>*p                      .
                   .           .                       .
                   .    12     .          24           .
                   |...........|.......................|
                                      36


    -------



               (+10)
        rp1o *-------->*rp1
             .         .                      (-10)
             .         .              rp2 *<---------* rpo2
             .         .                   .         .
             .         .                   .         .
             .    10   .          30       .         .
             |.........|.............................|
                       .                   .
                       . (+5)              .
                    po *--->* p            .
                       .    .              .
                       .    .   20         .
                       |....|..............|
                         5        15


    -------


               (+10)
        rp1o *-------->*rp1
             .         .
             .         .
        rp2o *-------->*rp2


                                   (+10)
                              po *-------->* p

    -------


               (+10)
        rp1o *-------->*rp1
             .         .
             .         .(+30)
        rp2o *---------------------------->*rp2


                                            (+25)
                              po *----------------------->* p



    vim: set ts=4 sw=4 expandtab:
    *****/

    /**
     * Converts a string into a list of tokens.
     */

    /**
     * Create a new token
     * @param {string} char a single char
     */
    function Token$1(char) {
        this.char = char;
        this.state = {};
        this.activeState = null;
    }

    /**
     * Create a new context range
     * @param {number} startIndex range start index
     * @param {number} endOffset range end index offset
     * @param {string} contextName owner context name
     */
    function ContextRange(startIndex, endOffset, contextName) {
        this.contextName = contextName;
        this.startIndex = startIndex;
        this.endOffset = endOffset;
    }

    /**
     * Check context start and end
     * @param {string} contextName a unique context name
     * @param {function} checkStart a predicate function the indicates a context's start
     * @param {function} checkEnd a predicate function the indicates a context's end
     */
    function ContextChecker(contextName, checkStart, checkEnd) {
        this.contextName = contextName;
        this.openRange = null;
        this.ranges = [];
        this.checkStart = checkStart;
        this.checkEnd = checkEnd;
    }

    /**
     * @typedef ContextParams
     * @type Object
     * @property {array} context context items
     * @property {number} currentIndex current item index
     */

    /**
     * Create a context params
     * @param {array} context a list of items
     * @param {number} currentIndex current item index
     */
    function ContextParams(context, currentIndex) {
        this.context = context;
        this.index = currentIndex;
        this.length = context.length;
        this.current = context[currentIndex];
        this.backtrack = context.slice(0, currentIndex);
        this.lookahead = context.slice(currentIndex + 1);
    }

    /**
     * Create an event instance
     * @param {string} eventId event unique id
     */
    function Event(eventId) {
        this.eventId = eventId;
        this.subscribers = [];
    }

    /**
     * Initialize a core events and auto subscribe required event handlers
     * @param {any} events an object that enlists core events handlers
     */
    function initializeCoreEvents(events) {
        var this$1 = this;

        var coreEvents = [
            'start', 'end', 'next', 'newToken', 'contextStart',
            'contextEnd', 'insertToken', 'removeToken', 'removeRange',
            'replaceToken', 'replaceRange', 'composeRUD', 'updateContextsRanges'
        ];

        coreEvents.forEach(function (eventId) {
            Object.defineProperty(this$1.events, eventId, {
                value: new Event(eventId)
            });
        });

        if (!!events) {
            coreEvents.forEach(function (eventId) {
                var event = events[eventId];
                if (typeof event === 'function') {
                    this$1.events[eventId].subscribe(event);
                }
            });
        }
        var requiresContextUpdate = [
            'insertToken', 'removeToken', 'removeRange',
            'replaceToken', 'replaceRange', 'composeRUD'
        ];
        requiresContextUpdate.forEach(function (eventId) {
            this$1.events[eventId].subscribe(
                this$1.updateContextsRanges
            );
        });
    }

    /**
     * Converts a string into a list of tokens
     * @param {any} events tokenizer core events
     */
    function Tokenizer(events) {
        this.tokens = [];
        this.registeredContexts = {};
        this.contextCheckers = [];
        this.events = {};
        this.registeredModifiers = [];

        initializeCoreEvents.call(this, events);
    }

    /**
     * Sets the state of a token, usually called by a state modifier.
     * @param {string} key state item key
     * @param {any} value state item value
     */
    Token$1.prototype.setState = function(key, value) {
        this.state[key] = value;
        this.activeState = { key: key, value: this.state[key] };
        return this.activeState;
    };

    Token$1.prototype.getState = function (stateId) {
        return this.state[stateId] || null;
    };

    /**
     * Checks if an index exists in the tokens list.
     * @param {number} index token index
     */
    Tokenizer.prototype.inboundIndex = function(index) {
        return index >= 0 && index < this.tokens.length;
    };

    /**
     * Compose and apply a list of operations (replace, update, delete)
     * @param {array} RUDs replace, update and delete operations
     * TODO: Perf. Optimization (lengthBefore === lengthAfter ? dispatch once)
     */
    Tokenizer.prototype.composeRUD = function (RUDs) {
        var this$1 = this;

        var silent = true;
        var state = RUDs.map(function (RUD) { return (
            this$1[RUD[0]].apply(this$1, RUD.slice(1).concat(silent))
        ); });
        var hasFAILObject = function (obj) { return (
            typeof obj === 'object' &&
            obj.hasOwnProperty('FAIL')
        ); };
        if (state.every(hasFAILObject)) {
            return {
                FAIL: "composeRUD: one or more operations hasn't completed successfully",
                report: state.filter(hasFAILObject)
            };
        }
        this.dispatch('composeRUD', [state.filter(function (op) { return !hasFAILObject(op); })]);
    };

    /**
     * Replace a range of tokens with a list of tokens
     * @param {number} startIndex range start index
     * @param {number} offset range offset
     * @param {token} tokens a list of tokens to replace
     * @param {boolean} silent dispatch events and update context ranges
     */
    Tokenizer.prototype.replaceRange = function (startIndex, offset, tokens, silent) {
        offset = offset !== null ? offset : this.tokens.length;
        var isTokenType = tokens.every(function (token) { return token instanceof Token$1; });
        if (!isNaN(startIndex) && this.inboundIndex(startIndex) && isTokenType) {
            var replaced = this.tokens.splice.apply(
                this.tokens, [startIndex, offset].concat(tokens)
            );
            if (!silent) { this.dispatch('replaceToken', [startIndex, offset, tokens]); }
            return [replaced, tokens];
        } else {
            return { FAIL: 'replaceRange: invalid tokens or startIndex.' };
        }
    };

    /**
     * Replace a token with another token
     * @param {number} index token index
     * @param {token} token a token to replace
     * @param {boolean} silent dispatch events and update context ranges
     */
    Tokenizer.prototype.replaceToken = function (index, token, silent) {
        if (!isNaN(index) && this.inboundIndex(index) && token instanceof Token$1) {
            var replaced = this.tokens.splice(index, 1, token);
            if (!silent) { this.dispatch('replaceToken', [index, token]); }
            return [replaced[0], token];
        } else {
            return { FAIL: 'replaceToken: invalid token or index.' };
        }
    };

    /**
     * Removes a range of tokens
     * @param {number} startIndex range start index
     * @param {number} offset range offset
     * @param {boolean} silent dispatch events and update context ranges
     */
    Tokenizer.prototype.removeRange = function(startIndex, offset, silent) {
        offset = !isNaN(offset) ? offset : this.tokens.length;
        var tokens = this.tokens.splice(startIndex, offset);
        if (!silent) { this.dispatch('removeRange', [tokens, startIndex, offset]); }
        return tokens;
    };

    /**
     * Remove a token at a certain index
     * @param {number} index token index
     * @param {boolean} silent dispatch events and update context ranges
     */
    Tokenizer.prototype.removeToken = function(index, silent) {
        if (!isNaN(index) && this.inboundIndex(index)) {
            var token = this.tokens.splice(index, 1);
            if (!silent) { this.dispatch('removeToken', [token, index]); }
            return token;
        } else {
            return { FAIL: 'removeToken: invalid token index.' };
        }
    };

    /**
     * Insert a list of tokens at a certain index
     * @param {array} tokens a list of tokens to insert
     * @param {number} index insert the list of tokens at index
     * @param {boolean} silent dispatch events and update context ranges
     */
    Tokenizer.prototype.insertToken = function (tokens, index, silent) {
        var tokenType = tokens.every(
            function (token) { return token instanceof Token$1; }
        );
        if (tokenType) {
            this.tokens.splice.apply(
                this.tokens, [index, 0].concat(tokens)
            );
            if (!silent) { this.dispatch('insertToken', [tokens, index]); }
            return tokens;
        } else {
            return { FAIL: 'insertToken: invalid token(s).' };
        }
    };

    /**
     * A state modifier that is called on 'newToken' event
     * @param {string} modifierId state modifier id
     * @param {function} condition a predicate function that returns true or false
     * @param {function} modifier a function to update token state
     */
    Tokenizer.prototype.registerModifier = function(modifierId, condition, modifier) {
        this.events.newToken.subscribe(function(token, contextParams) {
            var conditionParams = [token, contextParams];
            var canApplyModifier = (
                condition === null ||
                condition.apply(this, conditionParams) === true
            );
            var modifierParams = [token, contextParams];
            if (canApplyModifier) {
                var newStateValue = modifier.apply(this, modifierParams);
                token.setState(modifierId, newStateValue);
            }
        });
        this.registeredModifiers.push(modifierId);
    };

    /**
     * Subscribe a handler to an event
     * @param {function} eventHandler an event handler function
     */
    Event.prototype.subscribe = function (eventHandler) {
        if (typeof eventHandler === 'function') {
            return ((this.subscribers.push(eventHandler)) - 1);
        } else {
            return { FAIL: ("invalid '" + (this.eventId) + "' event handler")};
        }
    };

    /**
     * Unsubscribe an event handler
     * @param {string} subsId subscription id
     */
    Event.prototype.unsubscribe = function (subsId) {
        this.subscribers.splice(subsId, 1);
    };

    /**
     * Sets context params current value index
     * @param {number} index context params current value index
     */
    ContextParams.prototype.setCurrentIndex = function(index) {
        this.index = index;
        this.current = this.context[index];
        this.backtrack = this.context.slice(0, index);
        this.lookahead = this.context.slice(index + 1);
    };

    /**
     * Get an item at an offset from the current value
     * example (current value is 3):
     *  1    2   [3]   4    5   |   items values
     * -2   -1    0    1    2   |   offset values
     * @param {number} offset an offset from current value index
     */
    ContextParams.prototype.get = function (offset) {
        switch (true) {
            case (offset === 0):
                return this.current;
            case (offset < 0 && Math.abs(offset) <= this.backtrack.length):
                return this.backtrack.slice(offset)[0];
            case (offset > 0 && offset <= this.lookahead.length):
                return this.lookahead[offset - 1];
            default:
                return null;
        }
    };

    /**
     * Converts a context range into a string value
     * @param {contextRange} range a context range
     */
    Tokenizer.prototype.rangeToText = function (range) {
        if (range instanceof ContextRange) {
            return (
                this.getRangeTokens(range)
                    .map(function (token) { return token.char; }).join('')
            );
        }
    };

    /**
     * Converts all tokens into a string
     */
    Tokenizer.prototype.getText = function () {
        return this.tokens.map(function (token) { return token.char; }).join('');
    };

    /**
     * Get a context by name
     * @param {string} contextName context name to get
     */
    Tokenizer.prototype.getContext = function (contextName) {
        var context = this.registeredContexts[contextName];
        return !!context ? context : null;
    };

    /**
     * Subscribes a new event handler to an event
     * @param {string} eventName event name to subscribe to
     * @param {function} eventHandler a function to be invoked on event
     */
    Tokenizer.prototype.on = function(eventName, eventHandler) {
        var event = this.events[eventName];
        if (!!event) {
            return event.subscribe(eventHandler);
        } else {
            return null;
        }
    };

    /**
     * Dispatches an event
     * @param {string} eventName event name
     * @param {any} args event handler arguments
     */
    Tokenizer.prototype.dispatch = function(eventName, args) {
        var this$1 = this;

        var event = this.events[eventName];
        if (event instanceof Event) {
            event.subscribers.forEach(function (subscriber) {
                subscriber.apply(this$1, args || []);
            });
        }
    };

    /**
     * Register a new context checker
     * @param {string} contextName a unique context name
     * @param {function} contextStartCheck a predicate function that returns true on context start
     * @param {function} contextEndCheck  a predicate function that returns true on context end
     * TODO: call tokenize on registration to update context ranges with the new context.
     */
    Tokenizer.prototype.registerContextChecker = function(contextName, contextStartCheck, contextEndCheck) {
        if (!!this.getContext(contextName)) { return {
            FAIL:
            ("context name '" + contextName + "' is already registered.")
        }; }
        if (typeof contextStartCheck !== 'function') { return {
            FAIL:
            "missing context start check."
        }; }
        if (typeof contextEndCheck !== 'function') { return {
            FAIL:
            "missing context end check."
        }; }
        var contextCheckers = new ContextChecker(
            contextName, contextStartCheck, contextEndCheck
        );
        this.registeredContexts[contextName] = contextCheckers;
        this.contextCheckers.push(contextCheckers);
        return contextCheckers;
    };

    /**
     * Gets a context range tokens
     * @param {contextRange} range a context range
     */
    Tokenizer.prototype.getRangeTokens = function(range) {
        var endIndex = range.startIndex + range.endOffset;
        return [].concat(
            this.tokens
                .slice(range.startIndex, endIndex)
        );
    };

    /**
     * Gets the ranges of a context
     * @param {string} contextName context name
     */
    Tokenizer.prototype.getContextRanges = function(contextName) {
        var context = this.getContext(contextName);
        if (!!context) {
            return context.ranges;
        } else {
            return { FAIL: ("context checker '" + contextName + "' is not registered.") };
        }
    };

    /**
     * Resets context ranges to run context update
     */
    Tokenizer.prototype.resetContextsRanges = function () {
        var registeredContexts = this.registeredContexts;
        for (var contextName in registeredContexts) {
            if (registeredContexts.hasOwnProperty(contextName)) {
                var context = registeredContexts[contextName];
                context.ranges = [];
            }
        }
    };

    /**
     * Updates context ranges
     */
    Tokenizer.prototype.updateContextsRanges = function () {
        this.resetContextsRanges();
        var chars = this.tokens.map(function (token) { return token.char; });
        for (var i = 0; i < chars.length; i++) {
            var contextParams = new ContextParams(chars, i);
            this.runContextCheck(contextParams);
        }
        this.dispatch('updateContextsRanges', [this.registeredContexts]);
    };

    /**
     * Sets the end offset of an open range
     * @param {number} offset range end offset
     * @param {string} contextName context name
     */
    Tokenizer.prototype.setEndOffset = function (offset, contextName) {
        var startIndex = this.getContext(contextName).openRange.startIndex;
        var range = new ContextRange(startIndex, offset, contextName);
        var ranges = this.getContext(contextName).ranges;
        range.rangeId = contextName + "." + (ranges.length);
        ranges.push(range);
        this.getContext(contextName).openRange = null;
        return range;
    };

    /**
     * Runs a context check on the current context
     * @param {contextParams} contextParams current context params
     */
    Tokenizer.prototype.runContextCheck = function(contextParams) {
        var this$1 = this;

        var index = contextParams.index;
        this.contextCheckers.forEach(function (contextChecker) {
            var contextName = contextChecker.contextName;
            var openRange = this$1.getContext(contextName).openRange;
            if (!openRange && contextChecker.checkStart(contextParams)) {
                openRange = new ContextRange(index, null, contextName);
                this$1.getContext(contextName).openRange = openRange;
                this$1.dispatch('contextStart', [contextName, index]);
            }
            if (!!openRange && contextChecker.checkEnd(contextParams)) {
                var offset = (index - openRange.startIndex) + 1;
                var range = this$1.setEndOffset(offset, contextName);
                this$1.dispatch('contextEnd', [contextName, range]);
            }
        });
    };

    /**
     * Converts a text into a list of tokens
     * @param {string} text a text to tokenize
     */
    Tokenizer.prototype.tokenize = function (text) {
        this.tokens = [];
        this.resetContextsRanges();
        var chars = Array.from(text);
        this.dispatch('start');
        for (var i = 0; i < chars.length; i++) {
            var char = chars[i];
            var contextParams = new ContextParams(chars, i);
            this.dispatch('next', [contextParams]);
            this.runContextCheck(contextParams);
            var token = new Token$1(char);
            this.tokens.push(token);
            this.dispatch('newToken', [token, contextParams]);
        }
        this.dispatch('end', [this.tokens]);
        return this.tokens;
    };

    // ╭─┄┄┄────────────────────────┄─────────────────────────────────────────────╮
    // ┊ Character Class Assertions ┊ Checks if a char belongs to a certain class ┊
    // ╰─╾──────────────────────────┄─────────────────────────────────────────────╯
    // jscs:disable maximumLineLength
    /**
     * Check if a char is Arabic
     * @param {string} c a single char
     */
    function isArabicChar(c) {
        return /[\u0600-\u065F\u066A-\u06D2\u06FA-\u06FF]/.test(c);
    }

    /**
     * Check if a char is an isolated arabic char
     * @param {string} c a single char
     */
    function isIsolatedArabicChar(char) {
        return /[\u0630\u0690\u0621\u0631\u0661\u0671\u0622\u0632\u0672\u0692\u06C2\u0623\u0673\u0693\u06C3\u0624\u0694\u06C4\u0625\u0675\u0695\u06C5\u06E5\u0676\u0696\u06C6\u0627\u0677\u0697\u06C7\u0648\u0688\u0698\u06C8\u0689\u0699\u06C9\u068A\u06CA\u066B\u068B\u06CB\u068C\u068D\u06CD\u06FD\u068E\u06EE\u06FE\u062F\u068F\u06CF\u06EF]/.test(char);
    }

    /**
     * Check if a char is an Arabic Tashkeel char
     * @param {string} c a single char
     */
    function isTashkeelArabicChar(char) {
        return /[\u0600-\u0605\u060C-\u060E\u0610-\u061B\u061E\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED]/.test(char);
    }

    /**
     * Check if a char is Latin
     * @param {string} c a single char
     */
    function isLatinChar(c) {
        return /[A-z]/.test(c);
    }

    /**
     * Check if a char is whitespace char
     * @param {string} c a single char
     */
    function isWhiteSpace(c) {
        return /\s/.test(c);
    }

    /**
     * Query a feature by some of it's properties to lookup a glyph substitution.
     */

    /**
     * Create feature query instance
     * @param {Font} font opentype font instance
     */
    function FeatureQuery(font) {
        this.font = font;
        this.features = {};
    }

    /**
     * @typedef SubstitutionAction
     * @type Object
     * @property {number} id substitution type
     * @property {string} tag feature tag
     * @property {any} substitution substitution value(s)
     */

    /**
     * Create a substitution action instance
     * @param {SubstitutionAction} action
     */
    function SubstitutionAction(action) {
        this.id = action.id;
        this.tag = action.tag;
        this.substitution = action.substitution;
    }

    /**
     * Lookup a coverage table
     * @param {number} glyphIndex glyph index
     * @param {CoverageTable} coverage coverage table
     */
    function lookupCoverage(glyphIndex, coverage) {
        if (!glyphIndex) { return -1; }
        switch (coverage.format) {
            case 1:
                return coverage.glyphs.indexOf(glyphIndex);

            case 2:
                var ranges = coverage.ranges;
                for (var i = 0; i < ranges.length; i++) {
                    var range = ranges[i];
                    if (glyphIndex >= range.start && glyphIndex <= range.end) {
                        var offset = glyphIndex - range.start;
                        return range.index + offset;
                    }
                }
                break;
            default:
                return -1; // not found
        }
        return -1;
    }

    /**
     * Handle a single substitution - format 1
     * @param {ContextParams} contextParams context params to lookup
     */
    function singleSubstitutionFormat1(glyphIndex, subtable) {
        var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
        if (substituteIndex === -1) { return null; }
        return glyphIndex + subtable.deltaGlyphId;
    }

    /**
     * Handle a single substitution - format 2
     * @param {ContextParams} contextParams context params to lookup
     */
    function singleSubstitutionFormat2(glyphIndex, subtable) {
        var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
        if (substituteIndex === -1) { return null; }
        return subtable.substitute[substituteIndex];
    }

    /**
     * Lookup a list of coverage tables
     * @param {any} coverageList a list of coverage tables
     * @param {ContextParams} contextParams context params to lookup
     */
    function lookupCoverageList(coverageList, contextParams) {
        var lookupList = [];
        for (var i = 0; i < coverageList.length; i++) {
            var coverage = coverageList[i];
            var glyphIndex = contextParams.current;
            glyphIndex = Array.isArray(glyphIndex) ? glyphIndex[0] : glyphIndex;
            var lookupIndex = lookupCoverage(glyphIndex, coverage);
            if (lookupIndex !== -1) {
                lookupList.push(lookupIndex);
            }
        }
        if (lookupList.length !== coverageList.length) { return -1; }
        return lookupList;
    }

    /**
     * Handle chaining context substitution - format 3
     * @param {ContextParams} contextParams context params to lookup
     */
    function chainingSubstitutionFormat3(contextParams, subtable) {
        var lookupsCount = (
            subtable.inputCoverage.length +
            subtable.lookaheadCoverage.length +
            subtable.backtrackCoverage.length
        );
        if (contextParams.context.length < lookupsCount) { return []; }
        // INPUT LOOKUP //
        var inputLookups = lookupCoverageList(
            subtable.inputCoverage, contextParams
        );
        if (inputLookups === -1) { return []; }
        // LOOKAHEAD LOOKUP //
        var lookaheadOffset = subtable.inputCoverage.length - 1;
        if (contextParams.lookahead.length < subtable.lookaheadCoverage.length) { return []; }
        var lookaheadContext = contextParams.lookahead.slice(lookaheadOffset);
        while (lookaheadContext.length && isTashkeelArabicChar(lookaheadContext[0].char)) {
            lookaheadContext.shift();
        }
        var lookaheadParams = new ContextParams(lookaheadContext, 0);
        var lookaheadLookups = lookupCoverageList(
            subtable.lookaheadCoverage, lookaheadParams
        );
        // BACKTRACK LOOKUP //
        var backtrackContext = [].concat(contextParams.backtrack);
        backtrackContext.reverse();
        while (backtrackContext.length && isTashkeelArabicChar(backtrackContext[0].char)) {
            backtrackContext.shift();
        }
        if (backtrackContext.length < subtable.backtrackCoverage.length) { return []; }
        var backtrackParams = new ContextParams(backtrackContext, 0);
        var backtrackLookups = lookupCoverageList(
            subtable.backtrackCoverage, backtrackParams
        );
        var contextRulesMatch = (
            inputLookups.length === subtable.inputCoverage.length &&
            lookaheadLookups.length === subtable.lookaheadCoverage.length &&
            backtrackLookups.length === subtable.backtrackCoverage.length
        );
        var substitutions = [];
        if (contextRulesMatch) {
            for (var i = 0; i < subtable.lookupRecords.length; i++) {
                var lookupRecord = subtable.lookupRecords[i];
                var lookupListIndex = lookupRecord.lookupListIndex;
                var lookupTable = this.getLookupByIndex(lookupListIndex);
                for (var s = 0; s < lookupTable.subtables.length; s++) {
                    var subtable$1 = lookupTable.subtables[s];
                    var lookup = this.getLookupMethod(lookupTable, subtable$1);
                    var substitutionType = this.getSubstitutionType(lookupTable, subtable$1);
                    if (substitutionType === '12') {
                        for (var n = 0; n < inputLookups.length; n++) {
                            var glyphIndex = contextParams.get(n);
                            var substitution = lookup(glyphIndex);
                            if (substitution) { substitutions.push(substitution); }
                        }
                    }
                }
            }
        }
        return substitutions;
    }

    /**
     * Handle ligature substitution - format 1
     * @param {ContextParams} contextParams context params to lookup
     */
    function ligatureSubstitutionFormat1(contextParams, subtable) {
        // COVERAGE LOOKUP //
        var glyphIndex = contextParams.current;
        var ligSetIndex = lookupCoverage(glyphIndex, subtable.coverage);
        if (ligSetIndex === -1) { return null; }
        // COMPONENTS LOOKUP
        // (!) note, components are ordered in the written direction.
        var ligature;
        var ligatureSet = subtable.ligatureSets[ligSetIndex];
        for (var s = 0; s < ligatureSet.length; s++) {
            ligature = ligatureSet[s];
            for (var l = 0; l < ligature.components.length; l++) {
                var lookaheadItem = contextParams.lookahead[l];
                var component = ligature.components[l];
                if (lookaheadItem !== component) { break; }
                if (l === ligature.components.length - 1) { return ligature; }
            }
        }
        return null;
    }

    /**
     * Handle decomposition substitution - format 1
     * @param {number} glyphIndex glyph index
     * @param {any} subtable subtable
     */
    function decompositionSubstitutionFormat1(glyphIndex, subtable) {
        var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
        if (substituteIndex === -1) { return null; }
        return subtable.sequences[substituteIndex];
    }

    /**
     * Get default script features indexes
     */
    FeatureQuery.prototype.getDefaultScriptFeaturesIndexes = function () {
        var scripts = this.font.tables.gsub.scripts;
        for (var s = 0; s < scripts.length; s++) {
            var script = scripts[s];
            if (script.tag === 'DFLT') { return (
                script.script.defaultLangSys.featureIndexes
            ); }
        }
        return [];
    };

    /**
     * Get feature indexes of a specific script
     * @param {string} scriptTag script tag
     */
    FeatureQuery.prototype.getScriptFeaturesIndexes = function(scriptTag) {
        var tables = this.font.tables;
        if (!tables.gsub) { return []; }
        if (!scriptTag) { return this.getDefaultScriptFeaturesIndexes(); }
        var scripts = this.font.tables.gsub.scripts;
        for (var i = 0; i < scripts.length; i++) {
            var script = scripts[i];
            if (script.tag === scriptTag && script.script.defaultLangSys) {
                return script.script.defaultLangSys.featureIndexes;
            } else {
                var langSysRecords = script.langSysRecords;
                if (!!langSysRecords) {
                    for (var j = 0; j < langSysRecords.length; j++) {
                        var langSysRecord = langSysRecords[j];
                        if (langSysRecord.tag === scriptTag) {
                            var langSys = langSysRecord.langSys;
                            return langSys.featureIndexes;
                        }
                    }
                }
            }
        }
        return this.getDefaultScriptFeaturesIndexes();
    };

    /**
     * Map a feature tag to a gsub feature
     * @param {any} features gsub features
     * @param {string} scriptTag script tag
     */
    FeatureQuery.prototype.mapTagsToFeatures = function (features, scriptTag) {
        var tags = {};
        for (var i = 0; i < features.length; i++) {
            var tag = features[i].tag;
            var feature = features[i].feature;
            tags[tag] = feature;
        }
        this.features[scriptTag].tags = tags;
    };

    /**
     * Get features of a specific script
     * @param {string} scriptTag script tag
     */
    FeatureQuery.prototype.getScriptFeatures = function (scriptTag) {
        var features = this.features[scriptTag];
        if (this.features.hasOwnProperty(scriptTag)) { return features; }
        var featuresIndexes = this.getScriptFeaturesIndexes(scriptTag);
        if (!featuresIndexes) { return null; }
        var gsub = this.font.tables.gsub;
        features = featuresIndexes.map(function (index) { return gsub.features[index]; });
        this.features[scriptTag] = features;
        this.mapTagsToFeatures(features, scriptTag);
        return features;
    };

    /**
     * Get substitution type
     * @param {any} lookupTable lookup table
     * @param {any} subtable subtable
     */
    FeatureQuery.prototype.getSubstitutionType = function(lookupTable, subtable) {
        var lookupType = lookupTable.lookupType.toString();
        var substFormat = subtable.substFormat.toString();
        return lookupType + substFormat;
    };

    /**
     * Get lookup method
     * @param {any} lookupTable lookup table
     * @param {any} subtable subtable
     */
    FeatureQuery.prototype.getLookupMethod = function(lookupTable, subtable) {
        var this$1 = this;

        var substitutionType = this.getSubstitutionType(lookupTable, subtable);
        switch (substitutionType) {
            case '11':
                return function (glyphIndex) { return singleSubstitutionFormat1.apply(
                    this$1, [glyphIndex, subtable]
                ); };
            case '12':
                return function (glyphIndex) { return singleSubstitutionFormat2.apply(
                    this$1, [glyphIndex, subtable]
                ); };
            case '63':
                return function (contextParams) { return chainingSubstitutionFormat3.apply(
                    this$1, [contextParams, subtable]
                ); };
            case '41':
                return function (contextParams) { return ligatureSubstitutionFormat1.apply(
                    this$1, [contextParams, subtable]
                ); };
            case '21':
                return function (glyphIndex) { return decompositionSubstitutionFormat1.apply(
                    this$1, [glyphIndex, subtable]
                ); };
            default:
                throw new Error(
                    "lookupType: " + (lookupTable.lookupType) + " - " +
                    "substFormat: " + (subtable.substFormat) + " " +
                    "is not yet supported"
                );
        }
    };

    /**
     * [ LOOKUP TYPES ]
     * -------------------------------
     * Single                        1;
     * Multiple                      2;
     * Alternate                     3;
     * Ligature                      4;
     * Context                       5;
     * ChainingContext               6;
     * ExtensionSubstitution         7;
     * ReverseChainingContext        8;
     * -------------------------------
     *
     */

    /**
     * @typedef FQuery
     * @type Object
     * @param {string} tag feature tag
     * @param {string} script feature script
     * @param {ContextParams} contextParams context params
     */

    /**
     * Lookup a feature using a query parameters
     * @param {FQuery} query feature query
     */
    FeatureQuery.prototype.lookupFeature = function (query) {
        var contextParams = query.contextParams;
        var currentIndex = contextParams.index;
        var feature = this.getFeature({
            tag: query.tag, script: query.script
        });
        if (!feature) { return new Error(
            "font '" + (this.font.names.fullName.en) + "' " +
            "doesn't support feature '" + (query.tag) + "' " +
            "for script '" + (query.script) + "'."
        ); }
        var lookups = this.getFeatureLookups(feature);
        var substitutions = [].concat(contextParams.context);
        for (var l = 0; l < lookups.length; l++) {
            var lookupTable = lookups[l];
            var subtables = this.getLookupSubtables(lookupTable);
            for (var s = 0; s < subtables.length; s++) {
                var subtable = subtables[s];
                var substType = this.getSubstitutionType(lookupTable, subtable);
                var lookup = this.getLookupMethod(lookupTable, subtable);
                var substitution = (void 0);
                switch (substType) {
                    case '11':
                        substitution = lookup(contextParams.current);
                        if (substitution) {
                            substitutions.splice(currentIndex, 1, new SubstitutionAction({
                                id: 11, tag: query.tag, substitution: substitution
                            }));
                        }
                        break;
                    case '12':
                        substitution = lookup(contextParams.current);
                        if (substitution) {
                            substitutions.splice(currentIndex, 1, new SubstitutionAction({
                                id: 12, tag: query.tag, substitution: substitution
                            }));
                        }
                        break;
                    case '63':
                        substitution = lookup(contextParams);
                        if (Array.isArray(substitution) && substitution.length) {
                            substitutions.splice(currentIndex, 1, new SubstitutionAction({
                                id: 63, tag: query.tag, substitution: substitution
                            }));
                        }
                        break;
                    case '41':
                        substitution = lookup(contextParams);
                        if (substitution) {
                            substitutions.splice(currentIndex, 1, new SubstitutionAction({
                                id: 41, tag: query.tag, substitution: substitution
                            }));
                        }
                        break;
                    case '21':
                        substitution = lookup(contextParams.current);
                        if (substitution) {
                            substitutions.splice(currentIndex, 1, new SubstitutionAction({
                                id: 21, tag: query.tag, substitution: substitution
                            }));
                        }
                        break;
                }
                contextParams = new ContextParams(substitutions, currentIndex);
                if (Array.isArray(substitution) && !substitution.length) { continue; }
                substitution = null;
            }
        }
        return substitutions.length ? substitutions : null;
    };

    /**
     * Checks if a font supports a specific features
     * @param {FQuery} query feature query object
     */
    FeatureQuery.prototype.supports = function (query) {
        if (!query.script) { return false; }
        this.getScriptFeatures(query.script);
        var supportedScript = this.features.hasOwnProperty(query.script);
        if (!query.tag) { return supportedScript; }
        var supportedFeature = (
            this.features[query.script].some(function (feature) { return feature.tag === query.tag; })
        );
        return supportedScript && supportedFeature;
    };

    /**
     * Get lookup table subtables
     * @param {any} lookupTable lookup table
     */
    FeatureQuery.prototype.getLookupSubtables = function (lookupTable) {
        return lookupTable.subtables || null;
    };

    /**
     * Get lookup table by index
     * @param {number} index lookup table index
     */
    FeatureQuery.prototype.getLookupByIndex = function (index) {
        var lookups = this.font.tables.gsub.lookups;
        return lookups[index] || null;
    };

    /**
     * Get lookup tables for a feature
     * @param {string} feature
     */
    FeatureQuery.prototype.getFeatureLookups = function (feature) {
        // TODO: memoize
        return feature.lookupListIndexes.map(this.getLookupByIndex.bind(this));
    };

    /**
     * Query a feature by it's properties
     * @param {any} query an object that describes the properties of a query
     */
    FeatureQuery.prototype.getFeature = function getFeature(query) {
        if (!this.font) { return { FAIL: "No font was found"}; }
        if (!this.features.hasOwnProperty(query.script)) {
            this.getScriptFeatures(query.script);
        }
        var scriptFeatures = this.features[query.script];
        if (!scriptFeatures) { return (
            { FAIL: ("No feature for script " + (query.script))}
        ); }
        if (!scriptFeatures.tags[query.tag]) { return null; }
        return this.features[query.script].tags[query.tag];
    };

    /**
     * Arabic word context checkers
     */

    function arabicWordStartCheck(contextParams) {
        var char = contextParams.current;
        var prevChar = contextParams.get(-1);
        return (
            // ? arabic first char
            (prevChar === null && isArabicChar(char)) ||
            // ? arabic char preceded with a non arabic char
            (!isArabicChar(prevChar) && isArabicChar(char))
        );
    }

    function arabicWordEndCheck(contextParams) {
        var nextChar = contextParams.get(1);
        return (
            // ? last arabic char
            (nextChar === null) ||
            // ? next char is not arabic
            (!isArabicChar(nextChar))
        );
    }

    var arabicWordCheck = {
        startCheck: arabicWordStartCheck,
        endCheck: arabicWordEndCheck
    };

    /**
     * Arabic sentence context checkers
     */

    function arabicSentenceStartCheck(contextParams) {
        var char = contextParams.current;
        var prevChar = contextParams.get(-1);
        return (
            // ? an arabic char preceded with a non arabic char
            (isArabicChar(char) || isTashkeelArabicChar(char)) &&
            !isArabicChar(prevChar)
        );
    }

    function arabicSentenceEndCheck(contextParams) {
        var nextChar = contextParams.get(1);
        switch (true) {
            case nextChar === null:
                return true;
            case (!isArabicChar(nextChar) && !isTashkeelArabicChar(nextChar)):
                var nextIsWhitespace = isWhiteSpace(nextChar);
                if (!nextIsWhitespace) { return true; }
                if (nextIsWhitespace) {
                    var arabicCharAhead = false;
                    arabicCharAhead = (
                        contextParams.lookahead.some(
                            function (c) { return isArabicChar(c) || isTashkeelArabicChar(c); }
                        )
                    );
                    if (!arabicCharAhead) { return true; }
                }
                break;
            default:
                return false;
        }
    }

    var arabicSentenceCheck = {
        startCheck: arabicSentenceStartCheck,
        endCheck: arabicSentenceEndCheck
    };

    /**
     * Apply single substitution format 1
     * @param {Array} substitutions substitutions
     * @param {any} tokens a list of tokens
     * @param {number} index token index
     */
    function singleSubstitutionFormat1$1(action, tokens, index) {
        tokens[index].setState(action.tag, action.substitution);
    }

    /**
     * Apply single substitution format 2
     * @param {Array} substitutions substitutions
     * @param {any} tokens a list of tokens
     * @param {number} index token index
     */
    function singleSubstitutionFormat2$1(action, tokens, index) {
        tokens[index].setState(action.tag, action.substitution);
    }

    /**
     * Apply chaining context substitution format 3
     * @param {Array} substitutions substitutions
     * @param {any} tokens a list of tokens
     * @param {number} index token index
     */
    function chainingSubstitutionFormat3$1(action, tokens, index) {
        action.substitution.forEach(function (subst, offset) {
            var token = tokens[index + offset];
            token.setState(action.tag, subst);
        });
    }

    /**
     * Apply ligature substitution format 1
     * @param {Array} substitutions substitutions
     * @param {any} tokens a list of tokens
     * @param {number} index token index
     */
    function ligatureSubstitutionFormat1$1(action, tokens, index) {
        var token = tokens[index];
        token.setState(action.tag, action.substitution.ligGlyph);
        var compsCount = action.substitution.components.length;
        for (var i = 0; i < compsCount; i++) {
            token = tokens[index + i + 1];
            token.setState('deleted', true);
        }
    }

    /**
     * Supported substitutions
     */
    var SUBSTITUTIONS = {
        11: singleSubstitutionFormat1$1,
        12: singleSubstitutionFormat2$1,
        63: chainingSubstitutionFormat3$1,
        41: ligatureSubstitutionFormat1$1
    };

    /**
     * Apply substitutions to a list of tokens
     * @param {Array} substitutions substitutions
     * @param {any} tokens a list of tokens
     * @param {number} index token index
     */
    function applySubstitution(action, tokens, index) {
        if (action instanceof SubstitutionAction && SUBSTITUTIONS[action.id]) {
            SUBSTITUTIONS[action.id](action, tokens, index);
        }
    }

    /**
     * Apply Arabic presentation forms to a range of tokens
     */

    /**
     * Check if a char can be connected to it's preceding char
     * @param {ContextParams} charContextParams context params of a char
     */
    function willConnectPrev(charContextParams) {
        var backtrack = [].concat(charContextParams.backtrack);
        for (var i = backtrack.length - 1; i >= 0; i--) {
            var prevChar = backtrack[i];
            var isolated = isIsolatedArabicChar(prevChar);
            var tashkeel = isTashkeelArabicChar(prevChar);
            if (!isolated && !tashkeel) { return true; }
            if (isolated) { return false; }
        }
        return false;
    }

    /**
     * Check if a char can be connected to it's proceeding char
     * @param {ContextParams} charContextParams context params of a char
     */
    function willConnectNext(charContextParams) {
        if (isIsolatedArabicChar(charContextParams.current)) { return false; }
        for (var i = 0; i < charContextParams.lookahead.length; i++) {
            var nextChar = charContextParams.lookahead[i];
            var tashkeel = isTashkeelArabicChar(nextChar);
            if (!tashkeel) { return true; }
        }
        return false;
    }

    /**
     * Apply arabic presentation forms to a list of tokens
     * @param {ContextRange} range a range of tokens
     */
    function arabicPresentationForms(range) {
        var this$1 = this;

        var script = 'arab';
        var tags = this.featuresTags[script];
        var tokens = this.tokenizer.getRangeTokens(range);
        if (tokens.length === 1) { return; }
        var contextParams = new ContextParams(
            tokens.map(function (token) { return token.getState('glyphIndex'); }
        ), 0);
        var charContextParams = new ContextParams(
            tokens.map(function (token) { return token.char; }
        ), 0);
        tokens.forEach(function (token, index) {
            if (isTashkeelArabicChar(token.char)) { return; }
            contextParams.setCurrentIndex(index);
            charContextParams.setCurrentIndex(index);
            var CONNECT = 0; // 2 bits 00 (10: can connect next) (01: can connect prev)
            if (willConnectPrev(charContextParams)) { CONNECT |= 1; }
            if (willConnectNext(charContextParams)) { CONNECT |= 2; }
            var tag;
            switch (CONNECT) {
                case 1: (tag = 'fina'); break;
                case 2: (tag = 'init'); break;
                case 3: (tag = 'medi'); break;
            }
            if (tags.indexOf(tag) === -1) { return; }
            var substitutions = this$1.query.lookupFeature({
                tag: tag, script: script, contextParams: contextParams
            });
            if (substitutions instanceof Error) { return console.info(substitutions.message); }
            substitutions.forEach(function (action, index) {
                if (action instanceof SubstitutionAction) {
                    applySubstitution(action, tokens, index);
                    contextParams.context[index] = action.substitution;
                }
            });
        });
    }

    /**
     * Apply Arabic required ligatures feature to a range of tokens
     */

    /**
     * Update context params
     * @param {any} tokens a list of tokens
     * @param {number} index current item index
     */
    function getContextParams(tokens, index) {
        var context = tokens.map(function (token) { return token.activeState.value; });
        return new ContextParams(context, index || 0);
    }

    /**
     * Apply Arabic required ligatures to a context range
     * @param {ContextRange} range a range of tokens
     */
    function arabicRequiredLigatures(range) {
        var this$1 = this;

        var script = 'arab';
        var tokens = this.tokenizer.getRangeTokens(range);
        var contextParams = getContextParams(tokens);
        contextParams.context.forEach(function (glyphIndex, index) {
            contextParams.setCurrentIndex(index);
            var substitutions = this$1.query.lookupFeature({
                tag: 'rlig', script: script, contextParams: contextParams
            });
            if (substitutions.length) {
                substitutions.forEach(
                    function (action) { return applySubstitution(action, tokens, index); }
                );
                contextParams = getContextParams(tokens);
            }
        });
    }

    /**
     * Latin word context checkers
     */

    function latinWordStartCheck(contextParams) {
        var char = contextParams.current;
        var prevChar = contextParams.get(-1);
        return (
            // ? latin first char
            (prevChar === null && isLatinChar(char)) ||
            // ? latin char preceded with a non latin char
            (!isLatinChar(prevChar) && isLatinChar(char))
        );
    }

    function latinWordEndCheck(contextParams) {
        var nextChar = contextParams.get(1);
        return (
            // ? last latin char
            (nextChar === null) ||
            // ? next char is not latin
            (!isLatinChar(nextChar))
        );
    }

    var latinWordCheck = {
        startCheck: latinWordStartCheck,
        endCheck: latinWordEndCheck
    };

    /**
     * Apply Latin ligature feature to a range of tokens
     */

    /**
     * Update context params
     * @param {any} tokens a list of tokens
     * @param {number} index current item index
     */
    function getContextParams$1(tokens, index) {
        var context = tokens.map(function (token) { return token.activeState.value; });
        return new ContextParams(context, index || 0);
    }

    /**
     * Apply Arabic required ligatures to a context range
     * @param {ContextRange} range a range of tokens
     */
    function latinLigature(range) {
        var this$1 = this;

        var script = 'latn';
        var tokens = this.tokenizer.getRangeTokens(range);
        var contextParams = getContextParams$1(tokens);
        contextParams.context.forEach(function (glyphIndex, index) {
            contextParams.setCurrentIndex(index);
            var substitutions = this$1.query.lookupFeature({
                tag: 'liga', script: script, contextParams: contextParams
            });
            if (substitutions.length) {
                substitutions.forEach(
                    function (action) { return applySubstitution(action, tokens, index); }
                );
                contextParams = getContextParams$1(tokens);
            }
        });
    }

    /**
     * Infer bidirectional properties for a given text and apply
     * the corresponding layout rules.
     */

    /**
     * Create Bidi. features
     * @param {string} baseDir text base direction. value either 'ltr' or 'rtl'
     */
    function Bidi(baseDir) {
        this.baseDir = baseDir || 'ltr';
        this.tokenizer = new Tokenizer();
        this.featuresTags = {};
    }

    /**
     * Sets Bidi text
     * @param {string} text a text input
     */
    Bidi.prototype.setText = function (text) {
        this.text = text;
    };

    /**
     * Store essential context checks:
     * arabic word check for applying gsub features
     * arabic sentence check for adjusting arabic layout
     */
    Bidi.prototype.contextChecks = ({
        latinWordCheck: latinWordCheck,
        arabicWordCheck: arabicWordCheck,
        arabicSentenceCheck: arabicSentenceCheck
    });

    /**
     * Register arabic word check
     */
    function registerContextChecker(checkId) {
        var check = this.contextChecks[(checkId + "Check")];
        return this.tokenizer.registerContextChecker(
            checkId, check.startCheck, check.endCheck
        );
    }

    /**
     * Perform pre tokenization procedure then
     * tokenize text input
     */
    function tokenizeText() {
        registerContextChecker.call(this, 'latinWord');
        registerContextChecker.call(this, 'arabicWord');
        registerContextChecker.call(this, 'arabicSentence');
        return this.tokenizer.tokenize(this.text);
    }

    /**
     * Reverse arabic sentence layout
     * TODO: check base dir before applying adjustments - priority low
     */
    function reverseArabicSentences() {
        var this$1 = this;

        var ranges = this.tokenizer.getContextRanges('arabicSentence');
        ranges.forEach(function (range) {
            var rangeTokens = this$1.tokenizer.getRangeTokens(range);
            this$1.tokenizer.replaceRange(
                range.startIndex,
                range.endOffset,
                rangeTokens.reverse()
            );
        });
    }

    /**
     * Register supported features tags
     * @param {script} script script tag
     * @param {Array} tags features tags list
     */
    Bidi.prototype.registerFeatures = function (script, tags) {
        var this$1 = this;

        var supportedTags = tags.filter(
            function (tag) { return this$1.query.supports({script: script, tag: tag}); }
        );
        if (!this.featuresTags.hasOwnProperty(script)) {
            this.featuresTags[script] = supportedTags;
        } else {
            this.featuresTags[script] =
            this.featuresTags[script].concat(supportedTags);
        }
    };

    /**
     * Apply GSUB features
     * @param {Array} tagsList a list of features tags
     * @param {string} script a script tag
     * @param {Font} font opentype font instance
     */
    Bidi.prototype.applyFeatures = function (font, features) {
        if (!font) { throw new Error(
            'No valid font was provided to apply features'
        ); }
        if (!this.query) { this.query = new FeatureQuery(font); }
        for (var f = 0; f < features.length; f++) {
            var feature = features[f];
            if (!this.query.supports({script: feature.script})) { continue; }
            this.registerFeatures(feature.script, feature.tags);
        }
    };

    /**
     * Register a state modifier
     * @param {string} modifierId state modifier id
     * @param {function} condition a predicate function that returns true or false
     * @param {function} modifier a modifier function to set token state
     */
    Bidi.prototype.registerModifier = function (modifierId, condition, modifier) {
        this.tokenizer.registerModifier(modifierId, condition, modifier);
    };

    /**
     * Check if 'glyphIndex' is registered
     */
    function checkGlyphIndexStatus() {
        if (this.tokenizer.registeredModifiers.indexOf('glyphIndex') === -1) {
            throw new Error(
                'glyphIndex modifier is required to apply ' +
                'arabic presentation features.'
            );
        }
    }

    /**
     * Apply arabic presentation forms features
     */
    function applyArabicPresentationForms() {
        var this$1 = this;

        var script = 'arab';
        if (!this.featuresTags.hasOwnProperty(script)) { return; }
        checkGlyphIndexStatus.call(this);
        var ranges = this.tokenizer.getContextRanges('arabicWord');
        ranges.forEach(function (range) {
            arabicPresentationForms.call(this$1, range);
        });
    }

    /**
     * Apply required arabic ligatures
     */
    function applyArabicRequireLigatures() {
        var this$1 = this;

        var script = 'arab';
        if (!this.featuresTags.hasOwnProperty(script)) { return; }
        var tags = this.featuresTags[script];
        if (tags.indexOf('rlig') === -1) { return; }
        checkGlyphIndexStatus.call(this);
        var ranges = this.tokenizer.getContextRanges('arabicWord');
        ranges.forEach(function (range) {
            arabicRequiredLigatures.call(this$1, range);
        });
    }

    /**
     * Apply required arabic ligatures
     */
    function applyLatinLigatures() {
        var this$1 = this;

        var script = 'latn';
        if (!this.featuresTags.hasOwnProperty(script)) { return; }
        var tags = this.featuresTags[script];
        if (tags.indexOf('liga') === -1) { return; }
        checkGlyphIndexStatus.call(this);
        var ranges = this.tokenizer.getContextRanges('latinWord');
        ranges.forEach(function (range) {
            latinLigature.call(this$1, range);
        });
    }

    /**
     * Check if a context is registered
     * @param {string} contextId context id
     */
    Bidi.prototype.checkContextReady = function (contextId) {
        return !!this.tokenizer.getContext(contextId);
    };

    /**
     * Apply features to registered contexts
     */
    Bidi.prototype.applyFeaturesToContexts = function () {
        if (this.checkContextReady('arabicWord')) {
            applyArabicPresentationForms.call(this);
            applyArabicRequireLigatures.call(this);
        }
        if (this.checkContextReady('latinWord')) {
            applyLatinLigatures.call(this);
        }
        if (this.checkContextReady('arabicSentence')) {
            reverseArabicSentences.call(this);
        }
    };

    /**
     * process text input
     * @param {string} text an input text
     */
    Bidi.prototype.processText = function(text) {
        if (!this.text || this.text !== text) {
            this.setText(text);
            tokenizeText.call(this);
            this.applyFeaturesToContexts();
        }
    };

    /**
     * Process a string of text to identify and adjust
     * bidirectional text entities.
     * @param {string} text input text
     */
    Bidi.prototype.getBidiText = function (text) {
        this.processText(text);
        return this.tokenizer.getText();
    };

    /**
     * Get the current state index of each token
     * @param {text} text an input text
     */
    Bidi.prototype.getTextGlyphs = function (text) {
        this.processText(text);
        var indexes = [];
        for (var i = 0; i < this.tokenizer.tokens.length; i++) {
            var token = this.tokenizer.tokens[i];
            if (token.state.deleted) { continue; }
            var index = token.activeState.value;
            indexes.push(Array.isArray(index) ? index[0] : index);
        }
        return indexes;
    };

    // The Font object

    /**
     * @typedef FontOptions
     * @type Object
     * @property {Boolean} empty - whether to create a new empty font
     * @property {string} familyName
     * @property {string} styleName
     * @property {string=} fullName
     * @property {string=} postScriptName
     * @property {string=} designer
     * @property {string=} designerURL
     * @property {string=} manufacturer
     * @property {string=} manufacturerURL
     * @property {string=} license
     * @property {string=} licenseURL
     * @property {string=} version
     * @property {string=} description
     * @property {string=} copyright
     * @property {string=} trademark
     * @property {Number} unitsPerEm
     * @property {Number} ascender
     * @property {Number} descender
     * @property {Number} createdTimestamp
     * @property {string=} weightClass
     * @property {string=} widthClass
     * @property {string=} fsSelection
     */

    /**
     * A Font represents a loaded OpenType font file.
     * It contains a set of glyphs and methods to draw text on a drawing context,
     * or to get a path representing the text.
     * @exports opentype.Font
     * @class
     * @param {FontOptions}
     * @constructor
     */
    function Font(options) {
        options = options || {};
        options.tables = options.tables || {};

        if (!options.empty) {
            // Check that we've provided the minimum set of names.
            checkArgument(options.familyName, 'When creating a new Font object, familyName is required.');
            checkArgument(options.styleName, 'When creating a new Font object, styleName is required.');
            checkArgument(options.unitsPerEm, 'When creating a new Font object, unitsPerEm is required.');
            checkArgument(options.ascender, 'When creating a new Font object, ascender is required.');
            checkArgument(options.descender <= 0, 'When creating a new Font object, negative descender value is required.');

            // OS X will complain if the names are empty, so we put a single space everywhere by default.
            this.names = {
                fontFamily: {en: options.familyName || ' '},
                fontSubfamily: {en: options.styleName || ' '},
                fullName: {en: options.fullName || options.familyName + ' ' + options.styleName},
                // postScriptName may not contain any whitespace
                postScriptName: {en: options.postScriptName || (options.familyName + options.styleName).replace(/\s/g, '')},
                designer: {en: options.designer || ' '},
                designerURL: {en: options.designerURL || ' '},
                manufacturer: {en: options.manufacturer || ' '},
                manufacturerURL: {en: options.manufacturerURL || ' '},
                license: {en: options.license || ' '},
                licenseURL: {en: options.licenseURL || ' '},
                version: {en: options.version || 'Version 0.1'},
                description: {en: options.description || ' '},
                copyright: {en: options.copyright || ' '},
                trademark: {en: options.trademark || ' '}
            };
            this.unitsPerEm = options.unitsPerEm || 1000;
            this.ascender = options.ascender;
            this.descender = options.descender;
            this.createdTimestamp = options.createdTimestamp;
            this.tables = Object.assign(options.tables, {
                os2: Object.assign({
                    usWeightClass: options.weightClass || this.usWeightClasses.MEDIUM,
                    usWidthClass: options.widthClass || this.usWidthClasses.MEDIUM,
                    fsSelection: options.fsSelection || this.fsSelectionValues.REGULAR,
                }, options.tables.os2)
            });
        }

        this.supported = true; // Deprecated: parseBuffer will throw an error if font is not supported.
        this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
        this.encoding = new DefaultEncoding(this);
        this.position = new Position(this);
        this.substitution = new Substitution(this);
        this.tables = this.tables || {};

        // needed for low memory mode only.
        this._push = null;
        this._hmtxTableData = {};

        Object.defineProperty(this, 'hinting', {
            get: function() {
                if (this._hinting) { return this._hinting; }
                if (this.outlinesFormat === 'truetype') {
                    return (this._hinting = new Hinting(this));
                }
            }
        });
    }

    /**
     * Check if the font has a glyph for the given character.
     * @param  {string}
     * @return {Boolean}
     */
    Font.prototype.hasChar = function(c) {
        return this.encoding.charToGlyphIndex(c) !== null;
    };

    /**
     * Convert the given character to a single glyph index.
     * Note that this function assumes that there is a one-to-one mapping between
     * the given character and a glyph; for complex scripts this might not be the case.
     * @param  {string}
     * @return {Number}
     */
    Font.prototype.charToGlyphIndex = function(s) {
        return this.encoding.charToGlyphIndex(s);
    };

    /**
     * Convert the given character to a single Glyph object.
     * Note that this function assumes that there is a one-to-one mapping between
     * the given character and a glyph; for complex scripts this might not be the case.
     * @param  {string}
     * @return {opentype.Glyph}
     */
    Font.prototype.charToGlyph = function(c) {
        var glyphIndex = this.charToGlyphIndex(c);
        var glyph = this.glyphs.get(glyphIndex);
        if (!glyph) {
            // .notdef
            glyph = this.glyphs.get(0);
        }

        return glyph;
    };

    /**
     * Update features
     * @param {any} options features options
     */
    Font.prototype.updateFeatures = function (options) {
        // TODO: update all features options not only 'latn'.
        return this.defaultRenderOptions.features.map(function (feature) {
            if (feature.script === 'latn') {
                return {
                    script: 'latn',
                    tags: feature.tags.filter(function (tag) { return options[tag]; })
                };
            } else {
                return feature;
            }
        });
    };

    /**
     * Convert the given text to a list of Glyph objects.
     * Note that there is no strict one-to-one mapping between characters and
     * glyphs, so the list of returned glyphs can be larger or smaller than the
     * length of the given string.
     * @param  {string}
     * @param  {GlyphRenderOptions} [options]
     * @return {opentype.Glyph[]}
     */
    Font.prototype.stringToGlyphs = function(s, options) {
        var this$1 = this;


        var bidi = new Bidi();

        // Create and register 'glyphIndex' state modifier
        var charToGlyphIndexMod = function (token) { return this$1.charToGlyphIndex(token.char); };
        bidi.registerModifier('glyphIndex', null, charToGlyphIndexMod);

        // roll-back to default features
        var features = options ?
        this.updateFeatures(options.features) :
        this.defaultRenderOptions.features;

        bidi.applyFeatures(this, features);

        var indexes = bidi.getTextGlyphs(s);

        var length = indexes.length;

        // convert glyph indexes to glyph objects
        var glyphs = new Array(length);
        var notdef = this.glyphs.get(0);
        for (var i = 0; i < length; i += 1) {
            glyphs[i] = this.glyphs.get(indexes[i]) || notdef;
        }
        return glyphs;
    };

    /**
     * @param  {string}
     * @return {Number}
     */
    Font.prototype.nameToGlyphIndex = function(name) {
        return this.glyphNames.nameToGlyphIndex(name);
    };

    /**
     * @param  {string}
     * @return {opentype.Glyph}
     */
    Font.prototype.nameToGlyph = function(name) {
        var glyphIndex = this.nameToGlyphIndex(name);
        var glyph = this.glyphs.get(glyphIndex);
        if (!glyph) {
            // .notdef
            glyph = this.glyphs.get(0);
        }

        return glyph;
    };

    /**
     * @param  {Number}
     * @return {String}
     */
    Font.prototype.glyphIndexToName = function(gid) {
        if (!this.glyphNames.glyphIndexToName) {
            return '';
        }

        return this.glyphNames.glyphIndexToName(gid);
    };

    /**
     * Retrieve the value of the kerning pair between the left glyph (or its index)
     * and the right glyph (or its index). If no kerning pair is found, return 0.
     * The kerning value gets added to the advance width when calculating the spacing
     * between glyphs.
     * For GPOS kerning, this method uses the default script and language, which covers
     * most use cases. To have greater control, use font.position.getKerningValue .
     * @param  {opentype.Glyph} leftGlyph
     * @param  {opentype.Glyph} rightGlyph
     * @return {Number}
     */
    Font.prototype.getKerningValue = function(leftGlyph, rightGlyph) {
        leftGlyph = leftGlyph.index || leftGlyph;
        rightGlyph = rightGlyph.index || rightGlyph;
        var gposKerning = this.position.defaultKerningTables;
        if (gposKerning) {
            return this.position.getKerningValue(gposKerning, leftGlyph, rightGlyph);
        }
        // "kern" table
        return this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0;
    };

    /**
     * @typedef GlyphRenderOptions
     * @type Object
     * @property {string} [script] - script used to determine which features to apply. By default, 'DFLT' or 'latn' is used.
     *                               See https://www.microsoft.com/typography/otspec/scripttags.htm
     * @property {string} [language='dflt'] - language system used to determine which features to apply.
     *                                        See https://www.microsoft.com/typography/developers/opentype/languagetags.aspx
     * @property {boolean} [kerning=true] - whether to include kerning values
     * @property {object} [features] - OpenType Layout feature tags. Used to enable or disable the features of the given script/language system.
     *                                 See https://www.microsoft.com/typography/otspec/featuretags.htm
     */
    Font.prototype.defaultRenderOptions = {
        kerning: true,
        features: [
            /**
             * these 4 features are required to render Arabic text properly
             * and shouldn't be turned off when rendering arabic text.
             */
            { script: 'arab', tags: ['init', 'medi', 'fina', 'rlig'] },
            { script: 'latn', tags: ['liga', 'rlig'] }
        ]
    };

    /**
     * Helper function that invokes the given callback for each glyph in the given text.
     * The callback gets `(glyph, x, y, fontSize, options)`.* @param  {string} text
     * @param {string} text - The text to apply.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {GlyphRenderOptions=} options
     * @param  {Function} callback
     */
    Font.prototype.forEachGlyph = function(text, x, y, fontSize, options, callback) {
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 72;
        options = Object.assign({}, this.defaultRenderOptions, options);
        var fontScale = 1 / this.unitsPerEm * fontSize;
        var glyphs = this.stringToGlyphs(text, options);
        var kerningLookups;
        if (options.kerning) {
            var script = options.script || this.position.getDefaultScriptName();
            kerningLookups = this.position.getKerningTables(script, options.language);
        }
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs[i];
            callback.call(this, glyph, x, y, fontSize, options);
            if (glyph.advanceWidth) {
                x += glyph.advanceWidth * fontScale;
            }

            if (options.kerning && i < glyphs.length - 1) {
                // We should apply position adjustment lookups in a more generic way.
                // Here we only use the xAdvance value.
                var kerningValue = kerningLookups ?
                      this.position.getKerningValue(kerningLookups, glyph.index, glyphs[i + 1].index) :
                      this.getKerningValue(glyph, glyphs[i + 1]);
                x += kerningValue * fontScale;
            }

            if (options.letterSpacing) {
                x += options.letterSpacing * fontSize;
            } else if (options.tracking) {
                x += (options.tracking / 1000) * fontSize;
            }
        }
        return x;
    };

    /**
     * Create a Path object that represents the given text.
     * @param  {string} text - The text to create.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {GlyphRenderOptions=} options
     * @return {opentype.Path}
     */
    Font.prototype.getPath = function(text, x, y, fontSize, options) {
        var fullPath = new Path();
        this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
            var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
            fullPath.extend(glyphPath);
        });
        return fullPath;
    };

    /**
     * Create an array of Path objects that represent the glyphs of a given text.
     * @param  {string} text - The text to create.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {GlyphRenderOptions=} options
     * @return {opentype.Path[]}
     */
    Font.prototype.getPaths = function(text, x, y, fontSize, options) {
        var glyphPaths = [];
        this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
            var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
            glyphPaths.push(glyphPath);
        });

        return glyphPaths;
    };

    /**
     * Returns the advance width of a text.
     *
     * This is something different than Path.getBoundingBox() as for example a
     * suffixed whitespace increases the advanceWidth but not the bounding box
     * or an overhanging letter like a calligraphic 'f' might have a quite larger
     * bounding box than its advance width.
     *
     * This corresponds to canvas2dContext.measureText(text).width
     *
     * @param  {string} text - The text to create.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {GlyphRenderOptions=} options
     * @return advance width
     */
    Font.prototype.getAdvanceWidth = function(text, fontSize, options) {
        return this.forEachGlyph(text, 0, 0, fontSize, options, function() {});
    };

    /**
     * Draw the text on the given drawing context.
     * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
     * @param  {string} text - The text to create.
     * @param  {number} [x=0] - Horizontal position of the beginning of the text.
     * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param  {GlyphRenderOptions=} options
     */
    Font.prototype.draw = function(ctx, text, x, y, fontSize, options) {
        this.getPath(text, x, y, fontSize, options).draw(ctx);
    };

    /**
     * Draw the points of all glyphs in the text.
     * On-curve points will be drawn in blue, off-curve points will be drawn in red.
     * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
     * @param {string} text - The text to create.
     * @param {number} [x=0] - Horizontal position of the beginning of the text.
     * @param {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param {GlyphRenderOptions=} options
     */
    Font.prototype.drawPoints = function(ctx, text, x, y, fontSize, options) {
        this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
            glyph.drawPoints(ctx, gX, gY, gFontSize);
        });
    };

    /**
     * Draw lines indicating important font measurements for all glyphs in the text.
     * Black lines indicate the origin of the coordinate system (point 0,0).
     * Blue lines indicate the glyph bounding box.
     * Green line indicates the advance width of the glyph.
     * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
     * @param {string} text - The text to create.
     * @param {number} [x=0] - Horizontal position of the beginning of the text.
     * @param {number} [y=0] - Vertical position of the *baseline* of the text.
     * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
     * @param {GlyphRenderOptions=} options
     */
    Font.prototype.drawMetrics = function(ctx, text, x, y, fontSize, options) {
        this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
            glyph.drawMetrics(ctx, gX, gY, gFontSize);
        });
    };

    /**
     * @param  {string}
     * @return {string}
     */
    Font.prototype.getEnglishName = function(name) {
        var translations = this.names[name];
        if (translations) {
            return translations.en;
        }
    };

    /**
     * Validate
     */
    Font.prototype.validate = function() {
        var _this = this;

        function assert(predicate, message) {
        }

        function assertNamePresent(name) {
            var englishName = _this.getEnglishName(name);
            assert(englishName && englishName.trim().length > 0);
        }

        // Identification information
        assertNamePresent('fontFamily');
        assertNamePresent('weightName');
        assertNamePresent('manufacturer');
        assertNamePresent('copyright');
        assertNamePresent('version');

        // Dimension information
        assert(this.unitsPerEm > 0);
    };

    /**
     * Convert the font object to a SFNT data structure.
     * This structure contains all the necessary tables and metadata to create a binary OTF file.
     * @return {opentype.Table}
     */
    Font.prototype.toTables = function() {
        return sfnt.fontToTable(this);
    };
    /**
     * @deprecated Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.
     */
    Font.prototype.toBuffer = function() {
        console.warn('Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.');
        return this.toArrayBuffer();
    };
    /**
     * Converts a `opentype.Font` into an `ArrayBuffer`
     * @return {ArrayBuffer}
     */
    Font.prototype.toArrayBuffer = function() {
        var sfntTable = this.toTables();
        var bytes = sfntTable.encode();
        var buffer = new ArrayBuffer(bytes.length);
        var intArray = new Uint8Array(buffer);
        for (var i = 0; i < bytes.length; i++) {
            intArray[i] = bytes[i];
        }

        return buffer;
    };

    /**
     * Initiate a download of the OpenType font.
     */
    Font.prototype.download = function(fileName) {
        var familyName = this.getEnglishName('fontFamily');
        var styleName = this.getEnglishName('fontSubfamily');
        fileName = fileName || familyName.replace(/\s/g, '') + '-' + styleName + '.otf';
        var arrayBuffer = this.toArrayBuffer();

        if (isBrowser()) {
            window.URL = window.URL || window.webkitURL;

            if (window.URL) {
                var dataView = new DataView(arrayBuffer);
                var blob = new Blob([dataView], {type: 'font/opentype'});

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;

                var event = document.createEvent('MouseEvents');
                event.initEvent('click', true, false);
                link.dispatchEvent(event);
            } else {
                console.warn('Font file could not be downloaded. Try using a different browser.');
            }
        } else {
            var fs = require('fs');
            var buffer = arrayBufferToNodeBuffer(arrayBuffer);
            fs.writeFileSync(fileName, buffer);
        }
    };
    /**
     * @private
     */
    Font.prototype.fsSelectionValues = {
        ITALIC:              0x001, //1
        UNDERSCORE:          0x002, //2
        NEGATIVE:            0x004, //4
        OUTLINED:            0x008, //8
        STRIKEOUT:           0x010, //16
        BOLD:                0x020, //32
        REGULAR:             0x040, //64
        USER_TYPO_METRICS:   0x080, //128
        WWS:                 0x100, //256
        OBLIQUE:             0x200  //512
    };

    /**
     * @private
     */
    Font.prototype.usWidthClasses = {
        ULTRA_CONDENSED: 1,
        EXTRA_CONDENSED: 2,
        CONDENSED: 3,
        SEMI_CONDENSED: 4,
        MEDIUM: 5,
        SEMI_EXPANDED: 6,
        EXPANDED: 7,
        EXTRA_EXPANDED: 8,
        ULTRA_EXPANDED: 9
    };

    /**
     * @private
     */
    Font.prototype.usWeightClasses = {
        THIN: 100,
        EXTRA_LIGHT: 200,
        LIGHT: 300,
        NORMAL: 400,
        MEDIUM: 500,
        SEMI_BOLD: 600,
        BOLD: 700,
        EXTRA_BOLD: 800,
        BLACK:    900
    };

    // The `fvar` table stores font variation axes and instances.

    function addName(name, names) {
        var nameString = JSON.stringify(name);
        var nameID = 256;
        for (var nameKey in names) {
            var n = parseInt(nameKey);
            if (!n || n < 256) {
                continue;
            }

            if (JSON.stringify(names[nameKey]) === nameString) {
                return n;
            }

            if (nameID <= n) {
                nameID = n + 1;
            }
        }

        names[nameID] = name;
        return nameID;
    }

    function makeFvarAxis(n, axis, names) {
        var nameID = addName(axis.name, names);
        return [
            {name: 'tag_' + n, type: 'TAG', value: axis.tag},
            {name: 'minValue_' + n, type: 'FIXED', value: axis.minValue << 16},
            {name: 'defaultValue_' + n, type: 'FIXED', value: axis.defaultValue << 16},
            {name: 'maxValue_' + n, type: 'FIXED', value: axis.maxValue << 16},
            {name: 'flags_' + n, type: 'USHORT', value: 0},
            {name: 'nameID_' + n, type: 'USHORT', value: nameID}
        ];
    }

    function parseFvarAxis(data, start, names) {
        var axis = {};
        var p = new parse.Parser(data, start);
        axis.tag = p.parseTag();
        axis.minValue = p.parseFixed();
        axis.defaultValue = p.parseFixed();
        axis.maxValue = p.parseFixed();
        p.skip('uShort', 1);  // reserved for flags; no values defined
        axis.name = names[p.parseUShort()] || {};
        return axis;
    }

    function makeFvarInstance(n, inst, axes, names) {
        var nameID = addName(inst.name, names);
        var fields = [
            {name: 'nameID_' + n, type: 'USHORT', value: nameID},
            {name: 'flags_' + n, type: 'USHORT', value: 0}
        ];

        for (var i = 0; i < axes.length; ++i) {
            var axisTag = axes[i].tag;
            fields.push({
                name: 'axis_' + n + ' ' + axisTag,
                type: 'FIXED',
                value: inst.coordinates[axisTag] << 16
            });
        }

        return fields;
    }

    function parseFvarInstance(data, start, axes, names) {
        var inst = {};
        var p = new parse.Parser(data, start);
        inst.name = names[p.parseUShort()] || {};
        p.skip('uShort', 1);  // reserved for flags; no values defined

        inst.coordinates = {};
        for (var i = 0; i < axes.length; ++i) {
            inst.coordinates[axes[i].tag] = p.parseFixed();
        }

        return inst;
    }

    function makeFvarTable(fvar, names) {
        var result = new table.Table('fvar', [
            {name: 'version', type: 'ULONG', value: 0x10000},
            {name: 'offsetToData', type: 'USHORT', value: 0},
            {name: 'countSizePairs', type: 'USHORT', value: 2},
            {name: 'axisCount', type: 'USHORT', value: fvar.axes.length},
            {name: 'axisSize', type: 'USHORT', value: 20},
            {name: 'instanceCount', type: 'USHORT', value: fvar.instances.length},
            {name: 'instanceSize', type: 'USHORT', value: 4 + fvar.axes.length * 4}
        ]);
        result.offsetToData = result.sizeOf();

        for (var i = 0; i < fvar.axes.length; i++) {
            result.fields = result.fields.concat(makeFvarAxis(i, fvar.axes[i], names));
        }

        for (var j = 0; j < fvar.instances.length; j++) {
            result.fields = result.fields.concat(makeFvarInstance(j, fvar.instances[j], fvar.axes, names));
        }

        return result;
    }

    function parseFvarTable(data, start, names) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseULong();
        check.argument(tableVersion === 0x00010000, 'Unsupported fvar table version.');
        var offsetToData = p.parseOffset16();
        // Skip countSizePairs.
        p.skip('uShort', 1);
        var axisCount = p.parseUShort();
        var axisSize = p.parseUShort();
        var instanceCount = p.parseUShort();
        var instanceSize = p.parseUShort();

        var axes = [];
        for (var i = 0; i < axisCount; i++) {
            axes.push(parseFvarAxis(data, start + offsetToData + i * axisSize, names));
        }

        var instances = [];
        var instanceStart = start + offsetToData + axisCount * axisSize;
        for (var j = 0; j < instanceCount; j++) {
            instances.push(parseFvarInstance(data, instanceStart + j * instanceSize, axes, names));
        }

        return {axes: axes, instances: instances};
    }

    var fvar = { make: makeFvarTable, parse: parseFvarTable };

    // The `GDEF` table contains various glyph properties

    var attachList = function() {
        return {
            coverage: this.parsePointer(Parser.coverage),
            attachPoints: this.parseList(Parser.pointer(Parser.uShortList))
        };
    };

    var caretValue = function() {
        var format = this.parseUShort();
        check.argument(format === 1 || format === 2 || format === 3,
            'Unsupported CaretValue table version.');
        if (format === 1) {
            return { coordinate: this.parseShort() };
        } else if (format === 2) {
            return { pointindex: this.parseShort() };
        } else if (format === 3) {
            // Device / Variation Index tables unsupported
            return { coordinate: this.parseShort() };
        }
    };

    var ligGlyph = function() {
        return this.parseList(Parser.pointer(caretValue));
    };

    var ligCaretList = function() {
        return {
            coverage: this.parsePointer(Parser.coverage),
            ligGlyphs: this.parseList(Parser.pointer(ligGlyph))
        };
    };

    var markGlyphSets = function() {
        this.parseUShort(); // Version
        return this.parseList(Parser.pointer(Parser.coverage));
    };

    function parseGDEFTable(data, start) {
        start = start || 0;
        var p = new Parser(data, start);
        var tableVersion = p.parseVersion(1);
        check.argument(tableVersion === 1 || tableVersion === 1.2 || tableVersion === 1.3,
            'Unsupported GDEF table version.');
        var gdef = {
            version: tableVersion,
            classDef: p.parsePointer(Parser.classDef),
            attachList: p.parsePointer(attachList),
            ligCaretList: p.parsePointer(ligCaretList),
            markAttachClassDef: p.parsePointer(Parser.classDef)
        };
        if (tableVersion >= 1.2) {
            gdef.markGlyphSets = p.parsePointer(markGlyphSets);
        }
        return gdef;
    }
    var gdef = { parse: parseGDEFTable };

    // The `GPOS` table contains kerning pairs, among other things.

    var subtableParsers$1 = new Array(10);         // subtableParsers[0] is unused

    // https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#lookup-type-1-single-adjustment-positioning-subtable
    // this = Parser instance
    subtableParsers$1[1] = function parseLookup1() {
        var start = this.offset + this.relativeOffset;
        var posformat = this.parseUShort();
        if (posformat === 1) {
            return {
                posFormat: 1,
                coverage: this.parsePointer(Parser.coverage),
                value: this.parseValueRecord()
            };
        } else if (posformat === 2) {
            return {
                posFormat: 2,
                coverage: this.parsePointer(Parser.coverage),
                values: this.parseValueRecordList()
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': GPOS lookup type 1 format must be 1 or 2.');
    };

    // https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#lookup-type-2-pair-adjustment-positioning-subtable
    subtableParsers$1[2] = function parseLookup2() {
        var start = this.offset + this.relativeOffset;
        var posFormat = this.parseUShort();
        check.assert(posFormat === 1 || posFormat === 2, '0x' + start.toString(16) + ': GPOS lookup type 2 format must be 1 or 2.');
        var coverage = this.parsePointer(Parser.coverage);
        var valueFormat1 = this.parseUShort();
        var valueFormat2 = this.parseUShort();
        if (posFormat === 1) {
            // Adjustments for Glyph Pairs
            return {
                posFormat: posFormat,
                coverage: coverage,
                valueFormat1: valueFormat1,
                valueFormat2: valueFormat2,
                pairSets: this.parseList(Parser.pointer(Parser.list(function() {
                    return {        // pairValueRecord
                        secondGlyph: this.parseUShort(),
                        value1: this.parseValueRecord(valueFormat1),
                        value2: this.parseValueRecord(valueFormat2)
                    };
                })))
            };
        } else if (posFormat === 2) {
            var classDef1 = this.parsePointer(Parser.classDef);
            var classDef2 = this.parsePointer(Parser.classDef);
            var class1Count = this.parseUShort();
            var class2Count = this.parseUShort();
            return {
                // Class Pair Adjustment
                posFormat: posFormat,
                coverage: coverage,
                valueFormat1: valueFormat1,
                valueFormat2: valueFormat2,
                classDef1: classDef1,
                classDef2: classDef2,
                class1Count: class1Count,
                class2Count: class2Count,
                classRecords: this.parseList(class1Count, Parser.list(class2Count, function() {
                    return {
                        value1: this.parseValueRecord(valueFormat1),
                        value2: this.parseValueRecord(valueFormat2)
                    };
                }))
            };
        }
    };

    subtableParsers$1[3] = function parseLookup3() { return { error: 'GPOS Lookup 3 not supported' }; };
    subtableParsers$1[4] = function parseLookup4() { return { error: 'GPOS Lookup 4 not supported' }; };
    subtableParsers$1[5] = function parseLookup5() { return { error: 'GPOS Lookup 5 not supported' }; };
    subtableParsers$1[6] = function parseLookup6() { return { error: 'GPOS Lookup 6 not supported' }; };
    subtableParsers$1[7] = function parseLookup7() { return { error: 'GPOS Lookup 7 not supported' }; };
    subtableParsers$1[8] = function parseLookup8() { return { error: 'GPOS Lookup 8 not supported' }; };
    subtableParsers$1[9] = function parseLookup9() { return { error: 'GPOS Lookup 9 not supported' }; };

    // https://docs.microsoft.com/en-us/typography/opentype/spec/gpos
    function parseGposTable(data, start) {
        start = start || 0;
        var p = new Parser(data, start);
        var tableVersion = p.parseVersion(1);
        check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GPOS table version ' + tableVersion);

        if (tableVersion === 1) {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers$1)
            };
        } else {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers$1),
                variations: p.parseFeatureVariationsList()
            };
        }

    }

    // GPOS Writing //////////////////////////////////////////////
    // NOT SUPPORTED
    var subtableMakers$1 = new Array(10);

    function makeGposTable(gpos) {
        return new table.Table('GPOS', [
            {name: 'version', type: 'ULONG', value: 0x10000},
            {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gpos.scripts)},
            {name: 'features', type: 'TABLE', value: new table.FeatureList(gpos.features)},
            {name: 'lookups', type: 'TABLE', value: new table.LookupList(gpos.lookups, subtableMakers$1)}
        ]);
    }

    var gpos = { parse: parseGposTable, make: makeGposTable };

    // The `kern` table contains kerning pairs.

    function parseWindowsKernTable(p) {
        var pairs = {};
        // Skip nTables.
        p.skip('uShort');
        var subtableVersion = p.parseUShort();
        check.argument(subtableVersion === 0, 'Unsupported kern sub-table version.');
        // Skip subtableLength, subtableCoverage
        p.skip('uShort', 2);
        var nPairs = p.parseUShort();
        // Skip searchRange, entrySelector, rangeShift.
        p.skip('uShort', 3);
        for (var i = 0; i < nPairs; i += 1) {
            var leftIndex = p.parseUShort();
            var rightIndex = p.parseUShort();
            var value = p.parseShort();
            pairs[leftIndex + ',' + rightIndex] = value;
        }
        return pairs;
    }

    function parseMacKernTable(p) {
        var pairs = {};
        // The Mac kern table stores the version as a fixed (32 bits) but we only loaded the first 16 bits.
        // Skip the rest.
        p.skip('uShort');
        var nTables = p.parseULong();
        //check.argument(nTables === 1, 'Only 1 subtable is supported (got ' + nTables + ').');
        if (nTables > 1) {
            console.warn('Only the first kern subtable is supported.');
        }
        p.skip('uLong');
        var coverage = p.parseUShort();
        var subtableVersion = coverage & 0xFF;
        p.skip('uShort');
        if (subtableVersion === 0) {
            var nPairs = p.parseUShort();
            // Skip searchRange, entrySelector, rangeShift.
            p.skip('uShort', 3);
            for (var i = 0; i < nPairs; i += 1) {
                var leftIndex = p.parseUShort();
                var rightIndex = p.parseUShort();
                var value = p.parseShort();
                pairs[leftIndex + ',' + rightIndex] = value;
            }
        }
        return pairs;
    }

    // Parse the `kern` table which contains kerning pairs.
    function parseKernTable(data, start) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseUShort();
        if (tableVersion === 0) {
            return parseWindowsKernTable(p);
        } else if (tableVersion === 1) {
            return parseMacKernTable(p);
        } else {
            throw new Error('Unsupported kern table version (' + tableVersion + ').');
        }
    }

    var kern = { parse: parseKernTable };

    // The `loca` table stores the offsets to the locations of the glyphs in the font.

    // Parse the `loca` table. This table stores the offsets to the locations of the glyphs in the font,
    // relative to the beginning of the glyphData table.
    // The number of glyphs stored in the `loca` table is specified in the `maxp` table (under numGlyphs)
    // The loca table has two versions: a short version where offsets are stored as uShorts, and a long
    // version where offsets are stored as uLongs. The `head` table specifies which version to use
    // (under indexToLocFormat).
    function parseLocaTable(data, start, numGlyphs, shortVersion) {
        var p = new parse.Parser(data, start);
        var parseFn = shortVersion ? p.parseUShort : p.parseULong;
        // There is an extra entry after the last index element to compute the length of the last glyph.
        // That's why we use numGlyphs + 1.
        var glyphOffsets = [];
        for (var i = 0; i < numGlyphs + 1; i += 1) {
            var glyphOffset = parseFn.call(p);
            if (shortVersion) {
                // The short table version stores the actual offset divided by 2.
                glyphOffset *= 2;
            }

            glyphOffsets.push(glyphOffset);
        }

        return glyphOffsets;
    }

    var loca = { parse: parseLocaTable };

    // Table Directory Entries //////////////////////////////////////////////
    /**
     * Parses OpenType table entries.
     * @param  {DataView}
     * @param  {Number}
     * @return {Object[]}
     */
    function parseOpenTypeTableEntries(data, numTables) {
        var tableEntries = [];
        var p = 12;
        for (var i = 0; i < numTables; i += 1) {
            var tag = parse.getTag(data, p);
            var checksum = parse.getULong(data, p + 4);
            var offset = parse.getULong(data, p + 8);
            var length = parse.getULong(data, p + 12);
            tableEntries.push({tag: tag, checksum: checksum, offset: offset, length: length, compression: false});
            p += 16;
        }

        return tableEntries;
    }

    /**
     * Parses WOFF table entries.
     * @param  {DataView}
     * @param  {Number}
     * @return {Object[]}
     */
    function parseWOFFTableEntries(data, numTables) {
        var tableEntries = [];
        var p = 44; // offset to the first table directory entry.
        for (var i = 0; i < numTables; i += 1) {
            var tag = parse.getTag(data, p);
            var offset = parse.getULong(data, p + 4);
            var compLength = parse.getULong(data, p + 8);
            var origLength = parse.getULong(data, p + 12);
            var compression = (void 0);
            if (compLength < origLength) {
                compression = 'WOFF';
            } else {
                compression = false;
            }

            tableEntries.push({tag: tag, offset: offset, compression: compression,
                compressedLength: compLength, length: origLength});
            p += 20;
        }

        return tableEntries;
    }

    /**
     * @typedef TableData
     * @type Object
     * @property {DataView} data - The DataView
     * @property {number} offset - The data offset.
     */

    /**
     * @param  {DataView}
     * @param  {Object}
     * @return {TableData}
     */
    function uncompressTable(data, tableEntry) {
        if (tableEntry.compression === 'WOFF') {
            var inBuffer = new Uint8Array(data.buffer, tableEntry.offset + 2, tableEntry.compressedLength - 2);
            var outBuffer = new Uint8Array(tableEntry.length);
            tinyInflate(inBuffer, outBuffer);
            if (outBuffer.byteLength !== tableEntry.length) {
                throw new Error('Decompression error: ' + tableEntry.tag + ' decompressed length doesn\'t match recorded length');
            }

            var view = new DataView(outBuffer.buffer, 0);
            return {data: view, offset: 0};
        } else {
            return {data: data, offset: tableEntry.offset};
        }
    }

    // Public API ///////////////////////////////////////////////////////////

    /**
     * Parse the OpenType file data (as an ArrayBuffer) and return a Font object.
     * Throws an error if the font could not be parsed.
     * @param  {ArrayBuffer}
     * @param  {Object} opt - options for parsing
     * @return {opentype.Font}
     */
    function parseBuffer(buffer, opt) {
        opt = (opt === undefined || opt === null) ?  {} : opt;

        var indexToLocFormat;
        var ltagTable;

        // Since the constructor can also be called to create new fonts from scratch, we indicate this
        // should be an empty font that we'll fill with our own data.
        var font = new Font({empty: true});

        // OpenType fonts use big endian byte ordering.
        // We can't rely on typed array view types, because they operate with the endianness of the host computer.
        // Instead we use DataViews where we can specify endianness.
        var data = new DataView(buffer, 0);
        var numTables;
        var tableEntries = [];
        var signature = parse.getTag(data, 0);
        if (signature === String.fromCharCode(0, 1, 0, 0) || signature === 'true' || signature === 'typ1') {
            font.outlinesFormat = 'truetype';
            numTables = parse.getUShort(data, 4);
            tableEntries = parseOpenTypeTableEntries(data, numTables);
        } else if (signature === 'OTTO') {
            font.outlinesFormat = 'cff';
            numTables = parse.getUShort(data, 4);
            tableEntries = parseOpenTypeTableEntries(data, numTables);
        } else if (signature === 'wOFF') {
            var flavor = parse.getTag(data, 4);
            if (flavor === String.fromCharCode(0, 1, 0, 0)) {
                font.outlinesFormat = 'truetype';
            } else if (flavor === 'OTTO') {
                font.outlinesFormat = 'cff';
            } else {
                throw new Error('Unsupported OpenType flavor ' + signature);
            }

            numTables = parse.getUShort(data, 12);
            tableEntries = parseWOFFTableEntries(data, numTables);
        } else {
            throw new Error('Unsupported OpenType signature ' + signature);
        }

        var cffTableEntry;
        var fvarTableEntry;
        var glyfTableEntry;
        var gdefTableEntry;
        var gposTableEntry;
        var gsubTableEntry;
        var hmtxTableEntry;
        var kernTableEntry;
        var locaTableEntry;
        var nameTableEntry;
        var metaTableEntry;
        var p;

        for (var i = 0; i < numTables; i += 1) {
            var tableEntry = tableEntries[i];
            var table = (void 0);
            switch (tableEntry.tag) {
                case 'cmap':
                    table = uncompressTable(data, tableEntry);
                    font.tables.cmap = cmap.parse(table.data, table.offset);
                    font.encoding = new CmapEncoding(font.tables.cmap);
                    break;
                case 'cvt ' :
                    table = uncompressTable(data, tableEntry);
                    p = new parse.Parser(table.data, table.offset);
                    font.tables.cvt = p.parseShortList(tableEntry.length / 2);
                    break;
                case 'fvar':
                    fvarTableEntry = tableEntry;
                    break;
                case 'fpgm' :
                    table = uncompressTable(data, tableEntry);
                    p = new parse.Parser(table.data, table.offset);
                    font.tables.fpgm = p.parseByteList(tableEntry.length);
                    break;
                case 'head':
                    table = uncompressTable(data, tableEntry);
                    font.tables.head = head.parse(table.data, table.offset);
                    font.unitsPerEm = font.tables.head.unitsPerEm;
                    indexToLocFormat = font.tables.head.indexToLocFormat;
                    break;
                case 'hhea':
                    table = uncompressTable(data, tableEntry);
                    font.tables.hhea = hhea.parse(table.data, table.offset);
                    font.ascender = font.tables.hhea.ascender;
                    font.descender = font.tables.hhea.descender;
                    font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
                    break;
                case 'hmtx':
                    hmtxTableEntry = tableEntry;
                    break;
                case 'ltag':
                    table = uncompressTable(data, tableEntry);
                    ltagTable = ltag.parse(table.data, table.offset);
                    break;
                case 'maxp':
                    table = uncompressTable(data, tableEntry);
                    font.tables.maxp = maxp.parse(table.data, table.offset);
                    font.numGlyphs = font.tables.maxp.numGlyphs;
                    break;
                case 'name':
                    nameTableEntry = tableEntry;
                    break;
                case 'OS/2':
                    table = uncompressTable(data, tableEntry);
                    font.tables.os2 = os2.parse(table.data, table.offset);
                    break;
                case 'post':
                    table = uncompressTable(data, tableEntry);
                    font.tables.post = post.parse(table.data, table.offset);
                    font.glyphNames = new GlyphNames(font.tables.post);
                    break;
                case 'prep' :
                    table = uncompressTable(data, tableEntry);
                    p = new parse.Parser(table.data, table.offset);
                    font.tables.prep = p.parseByteList(tableEntry.length);
                    break;
                case 'glyf':
                    glyfTableEntry = tableEntry;
                    break;
                case 'loca':
                    locaTableEntry = tableEntry;
                    break;
                case 'CFF ':
                    cffTableEntry = tableEntry;
                    break;
                case 'kern':
                    kernTableEntry = tableEntry;
                    break;
                case 'GDEF':
                    gdefTableEntry = tableEntry;
                    break;
                case 'GPOS':
                    gposTableEntry = tableEntry;
                    break;
                case 'GSUB':
                    gsubTableEntry = tableEntry;
                    break;
                case 'meta':
                    metaTableEntry = tableEntry;
                    break;
            }
        }

        var nameTable = uncompressTable(data, nameTableEntry);
        font.tables.name = _name.parse(nameTable.data, nameTable.offset, ltagTable);
        font.names = font.tables.name;

        if (glyfTableEntry && locaTableEntry) {
            var shortVersion = indexToLocFormat === 0;
            var locaTable = uncompressTable(data, locaTableEntry);
            var locaOffsets = loca.parse(locaTable.data, locaTable.offset, font.numGlyphs, shortVersion);
            var glyfTable = uncompressTable(data, glyfTableEntry);
            font.glyphs = glyf.parse(glyfTable.data, glyfTable.offset, locaOffsets, font, opt);
        } else if (cffTableEntry) {
            var cffTable = uncompressTable(data, cffTableEntry);
            cff.parse(cffTable.data, cffTable.offset, font, opt);
        } else {
            throw new Error('Font doesn\'t contain TrueType or CFF outlines.');
        }

        var hmtxTable = uncompressTable(data, hmtxTableEntry);
        hmtx.parse(font, hmtxTable.data, hmtxTable.offset, font.numberOfHMetrics, font.numGlyphs, font.glyphs, opt);
        addGlyphNames(font, opt);

        if (kernTableEntry) {
            var kernTable = uncompressTable(data, kernTableEntry);
            font.kerningPairs = kern.parse(kernTable.data, kernTable.offset);
        } else {
            font.kerningPairs = {};
        }

        if (gdefTableEntry) {
            var gdefTable = uncompressTable(data, gdefTableEntry);
            font.tables.gdef = gdef.parse(gdefTable.data, gdefTable.offset);
        }

        if (gposTableEntry) {
            var gposTable = uncompressTable(data, gposTableEntry);
            font.tables.gpos = gpos.parse(gposTable.data, gposTable.offset);
            font.position.init();
        }

        if (gsubTableEntry) {
            var gsubTable = uncompressTable(data, gsubTableEntry);
            font.tables.gsub = gsub.parse(gsubTable.data, gsubTable.offset);
        }

        if (fvarTableEntry) {
            var fvarTable = uncompressTable(data, fvarTableEntry);
            font.tables.fvar = fvar.parse(fvarTable.data, fvarTable.offset, font.names);
        }

        if (metaTableEntry) {
            var metaTable = uncompressTable(data, metaTableEntry);
            font.tables.meta = meta.parse(metaTable.data, metaTable.offset);
            font.metas = font.tables.meta;
        }

        return font;
    }

    const primitiveShapeProperties = new Set([
        'height',
        'width',
        'depth',
        'radius',
        'radiusTop',
        'radiusBottom',
        'thickness',
        'arc',
        'latitudeStart',
        'latitudeSlice',
        'tessellation',
        'subdivisions',
        'capMode',
        'segments',
    ]);
    const PIVOT_GIZMO_SCALE = 0.33;
    const capModeMap = {
        [exports.eCylinderCap.both]: Mesh.CAP_ALL,
        [exports.eCylinderCap.start]: Mesh.CAP_START,
        [exports.eCylinderCap.end]: Mesh.CAP_END,
        [exports.eCylinderCap.none]: Mesh.NO_CAP,
    };
    const textMeshFonts = new Map();
    // const lineColor = new Color4(1, 1, 1);
    // const selectedLineColor = new Color4(1, 0, 0);
    class MeshRenderer extends Renderer {
        constructor(viewer, scene, rendererManager, shadowManager) {
            super(viewer, scene);
            this.rendererManager = rendererManager;
            this.shadowManager = shadowManager;
            this.disposed = new Subject();
            this.pivotGizmos = new Map();
            this.sketchPreviews = new Map();
            this.sketchTracings = new Map();
            this.sketchPlanePreviews = new Map();
            this.modelToken = Token.SpaceNode;
            this.utilityLayer = viewer.utilityLayer;
            const tempVector = new Vector3();
            viewer.afterRender.pipe(takeUntil(this.disposed)).subscribe(() => {
                let dist;
                const camera = this.utilityLayer.utilityLayerScene.activeCamera;
                this.pivotGizmos.forEach(gizmo => {
                    if (camera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                        dist = ((camera.orthoRight || 0) - (camera.orthoLeft || 0)) / 2;
                    }
                    else {
                        const cameraPosition = camera.globalPosition;
                        gizmo.position.subtractToRef(cameraPosition, tempVector);
                        dist = tempVector.length() * PIVOT_GIZMO_SCALE;
                    }
                    gizmo.scaling.set(dist, dist, dist);
                });
            });
        }
        handlesNode(node) {
            return isMeshNode(node) || isMeshGroupNode(node) || (isSceneNode(node) && node.isNested());
        }
        setRenderMode(mode, sceneNode) {
            this.renderMode = mode;
            this.babylonMap.forEach(mesh => {
                if (mesh instanceof Mesh) {
                    this.setRenderModeOnMesh(mesh, sceneNode);
                }
            });
        }
        dispose() {
            super.dispose();
            this.pivotGizmos.forEach(gizmo => {
                gizmo.dispose();
            });
            this.pivotGizmos.clear();
            this.disposed.next();
        }
        loadNewGeometry(node) {
            node._loading = node.geometryId;
            const meshService = node._manager.getService(Token.MeshService);
            meshService.hydrateGeometry(node).then(() => {
                node._loading = null;
                this.invalidateBoundingBox(node);
            });
        }
        parentsVisible(node) {
            while (node._parent && node._parent instanceof exports.SpaceNode) {
                if (!node._parent.visible) {
                    return false;
                }
                node = node._parent;
            }
            return true;
        }
        update3dInternal(node) {
            const isNewMesh = !this.get3d(node);
            if (isCustomMeshNode(node)) {
                if (node.visible &&
                    this.parentsVisible(node) &&
                    node.hasGeometry &&
                    !node._geometry &&
                    !node.geometryLoaded &&
                    !node._loading) {
                    this.loadNewGeometry(node);
                }
            }
            const mesh = this.createOrUpdateMesh(node);
            const pivotGizmo = this.pivotGizmos.get(node._dynamicId);
            if (node._selected && mesh instanceof Mesh && !this.viewer.highlighter.has(node)) {
                this.viewer.highlighter.add(node, exports.KbColor.Red());
                if (pivotGizmo) {
                    pivotGizmo.setEnabled(true);
                }
            }
            else if (!node._selected && mesh instanceof Mesh && this.viewer.highlighter.has(node)) {
                this.viewer.highlighter.remove(node);
                if (pivotGizmo) {
                    pivotGizmo.setEnabled(false);
                }
            }
            if (node instanceof exports.SketchNode) {
                if (node._selected && node.visible) {
                    const oldPreview = this.sketchPlanePreviews.get(node.id);
                    if (oldPreview) {
                        oldPreview.dispose();
                    }
                    const mesh = this.createSketchPlaneVisualization(node);
                    if (node.visible && mesh) {
                        this.sketchPlanePreviews.set(node.id, mesh);
                    }
                    else {
                        mesh === null || mesh === void 0 ? void 0 : mesh.dispose();
                        this.sketchPlanePreviews.delete(node.id);
                    }
                }
                else if (!node._selected || !node.visible) {
                    const SketchPlancePreviewMesh = this.sketchPlanePreviews.get(node.id);
                    SketchPlancePreviewMesh === null || SketchPlancePreviewMesh === void 0 ? void 0 : SketchPlancePreviewMesh.dispose();
                    this.sketchPlanePreviews.delete(node.id);
                }
            }
            if (!mesh) {
                throw Error('Could not create mesh');
            }
            if (isNewMesh || node.changes.has('_parent')) {
                this.updateParentMeshFromNode(node, mesh, isNewMesh);
            }
        }
        rebuildBaseGeometry(node, preTransformChanged = false) {
            const mesh = this.get3d(node);
            if (mesh && mesh instanceof Mesh) {
                let meshVertexData = null;
                if (isPrimitiveMeshNode(node)) {
                    const newMesh = this.createPrimitiveMesh(node);
                    meshVertexData = SubmeshVertexData.ExtractFromMesh(newMesh);
                    newMesh.dispose();
                    if (isDefined(node.uvOverrides)) {
                        this.setBabylonUvData(node.uvOverrides, meshVertexData);
                    }
                    if (node instanceof exports.MeshNode && meshVertexData) {
                        // Always pretransform primitives as they are always rebuilt from scratch
                        this.preTransformVertices(meshVertexData, node);
                    }
                }
                else if (isCustomMeshNode(node)) {
                    // If custom geometry does not have a geometry, don't do anything. Return null.
                    if (node._geometry && node._geometry.positions) {
                        meshVertexData = this.getMeshVertexData(node);
                    }
                }
                else if (isSketchNode(node)) {
                    meshVertexData = this.buildSketchGeometry(node);
                }
                else if (isTextNode(node) && isTrackedClass(node)) {
                    meshVertexData = this.buildTextGeometry(node);
                }
                else {
                    throw Error('geometry needs to be recalculated but mesh is not a valid primitive or custom mesh');
                }
                return meshVertexData;
            }
            return null;
        }
        buildSketchGeometry(node) {
            const result = new SubmeshVertexData();
            const positionVectors = [];
            let pathSegmentIndices = [];
            // Keep track of the path groups so we can match the hole paths with the groups in the vertex data
            // The key is the path group key, and the value is the indices of the generated polygons that are part of that path
            // One connected path may have multiple sketch paths because it requires different types of curves
            const pathGroupKeys = new Map();
            const holePathsReferencingKeys = [];
            let currentPath;
            let lastPoint;
            for (let i = 0; i < node.paths.length; i++) {
                const path = node.paths[i];
                if (path._points && path._points.length > 0) {
                    let thisPoint;
                    for (let iP = 0; iP < path._points.length; iP++) {
                        const { x, y, z } = path._points[iP];
                        thisPoint = new Vector3(x, y, z);
                        // Separate paths that don't have a shared start/end to different logical paths
                        if (!lastPoint || !thisPoint.equals(lastPoint)) {
                            if (iP === 0 || !currentPath) {
                                if (!pathGroupKeys.has(path.pathGroupKey)) {
                                    pathGroupKeys.set(path.pathGroupKey, pathSegmentIndices.length);
                                }
                                if (path.holeForPathGroup) {
                                    holePathsReferencingKeys[pathSegmentIndices.length] = path.holeForPathGroup;
                                }
                                currentPath = [];
                                pathSegmentIndices.push(currentPath);
                            }
                            currentPath.push(positionVectors.length);
                            positionVectors.push(thisPoint);
                        }
                        lastPoint = thisPoint;
                    }
                }
            }
            if (positionVectors.length === 0 || pathSegmentIndices.length === 0) {
                return null;
            }
            const positions = [];
            const indices = [];
            const normals = [];
            const paths = [];
            if (node.flipPath) {
                pathSegmentIndices.reverse();
                pathSegmentIndices.forEach(segment => segment.reverse());
            }
            const primaryNormal = axisToVector3(node.normal);
            // /**
            //  * We want the sketch to always "face" in the positive direction of the axis for consistency
            //  * Otherwise it's indeterminate which way the sketch will face and makes the sketch hard to manage
            //  * because it depends on the handed-ness of the points (clockwise or counter-clockwise)
            //  */
            pathSegmentIndices.forEach(segment => {
                const segmentPositions = [];
                for (let i = 0; i < segment.length; i++) {
                    const point = positionVectors[segment[i]];
                    segmentPositions.push(point);
                }
                // However, don't flip non-closed paths because it makes no sense and may be a drive curve
                const closedPath = (segmentPositions.length > 1 &&
                    segmentPositions[0].equalsWithEpsilon(segmentPositions[segmentPositions.length - 1])) ||
                    node.closePath;
                if (closedPath) {
                    const faceNormal = calculateFaceNormal(segmentPositions);
                    // If the rotation handedness is opposite the primary sketch vector, then flip the sketch path
                    if (Vector3.Dot(faceNormal, primaryNormal) < 0) {
                        segment.reverse();
                    }
                }
            });
            // Parse the holes and match them to their parent polygons
            const holesByPathsWithIndices = [];
            pathSegmentIndices.forEach((segment, idx) => {
                if (!holePathsReferencingKeys[idx]) {
                    return;
                }
                const parentPathIndex = pathGroupKeys.get(holePathsReferencingKeys[idx]);
                if (parentPathIndex === undefined) {
                    return;
                }
                // This segment is a hole
                if (!holesByPathsWithIndices[parentPathIndex]) {
                    holesByPathsWithIndices[parentPathIndex] = [];
                }
                holesByPathsWithIndices[parentPathIndex].push(segment);
            });
            if (node.addFace) {
                // We have to reorder the segment indices because the vertex position order gets modified by the face fill
                // Due to holes needing be be defined alongside the parent polygons
                const reorderedPathSegmentIndices = [];
                let positionPointer = 0;
                pathSegmentIndices.forEach((segment, idx) => {
                    // Skip holes in the loop since they are processed with their parent polygons
                    if (holePathsReferencingKeys[idx]) {
                        return;
                    }
                    const segmentPositions = [];
                    const segmentIndices = [];
                    for (let i = 0; i < segment.length; i++) {
                        const point = positionVectors[segment[i]];
                        segmentPositions.push(point);
                        segmentIndices.push(positionPointer);
                        positionPointer++;
                    }
                    reorderedPathSegmentIndices.push(segmentIndices);
                    const holesPositions = [];
                    if (holesByPathsWithIndices[idx]) {
                        for (let hi = 0; hi < holesByPathsWithIndices[idx].length; hi++) {
                            const hole = holesByPathsWithIndices[idx][hi];
                            const holeData = [];
                            const holeIndices = [];
                            for (let i = 0; i < hole.length; i++) {
                                const point = positionVectors[hole[i]];
                                holeData.push(point);
                                holeIndices.push(positionPointer);
                                positionPointer++;
                            }
                            holesPositions.push(holeData);
                            reorderedPathSegmentIndices.push(holeIndices);
                        }
                    }
                    const newMeshVertices = fillSketchPolygon(segmentPositions, node.flipPath, primaryNormal, holesPositions);
                    // Fix the indices to point at the right vertices
                    const startIndex = positions.length / 3;
                    for (let i = 0; i < newMeshVertices.indices.length; i++) {
                        newMeshVertices.indices[i] += startIndex;
                    }
                    indices.push(...newMeshVertices.indices);
                    positions.push(...newMeshVertices.positions);
                    normals.push(...newMeshVertices.normals);
                });
                //const normals = new Float32Array(positionVectors.length * 3);
                const uvs = new Float32Array(positionVectors.length * 2);
                uvs.fill(0);
                result.positions = new Float32Array(positions);
                result.indices = new Uint16Array(indices);
                result.normals = new Float32Array(normals);
                result.uvs = uvs;
                pathSegmentIndices = reorderedPathSegmentIndices;
            }
            else {
                const positions = new Float32Array(positionVectors.length * 3);
                for (let i = 0; i < positionVectors.length; i++) {
                    const point = positionVectors[i];
                    positions.set([point.x, point.y, point.z], i * 3);
                }
                result.positions = positions;
            }
            const indexMapToGrouped = [];
            let i = 0;
            pathSegmentIndices.forEach((segment, indexOfPath) => {
                // Skip holes since they are processed later
                if (holePathsReferencingKeys[indexOfPath]) {
                    return;
                }
                indexMapToGrouped[indexOfPath] = i;
                for (let i = 1; i < segment.length; i++) {
                    paths.push(segment[i - 1], segment[i]);
                }
                if (segment.length > 2 && node.closePath) {
                    paths.push(segment[segment.length - 1], segment[0]);
                }
                i++;
            });
            const holes = [];
            pathSegmentIndices.forEach((segment, indexOfPath) => {
                // Add holes after the regular polys
                if (!holePathsReferencingKeys[indexOfPath]) {
                    return;
                }
                const parentPathIndex = pathGroupKeys.get(holePathsReferencingKeys[indexOfPath]);
                if (parentPathIndex === undefined) {
                    return;
                }
                holes.push(indexMapToGrouped[parentPathIndex], paths.length);
                for (let i = 1; i < segment.length; i++) {
                    paths.push(segment[i - 1], segment[i]);
                }
                if (segment.length > 2 && node.closePath) {
                    paths.push(segment[segment.length - 1], segment[0]);
                }
            });
            result.paths = new Uint16Array(paths);
            result.holes = new Uint16Array(holes);
            node._sketchPoints = new Float32Array(result.positions);
            let counter = -1;
            const startingPoints = [];
            //for loop building the starting points array which stores sketchControlPoints at the start of a line segment
            for (let i = 0; i < node.paths.length; i++) {
                const path = node.paths[i];
                let lastPoint;
                if (path._points && path._points.length > 0) {
                    let thisPoint;
                    for (let iP = 0; iP < path._points.length; iP++) {
                        const { x, y, z } = path._points[iP];
                        thisPoint = new Vector3(x, y, z);
                        startingPoints.push(counter);
                        if (!lastPoint || !thisPoint.equals(lastPoint)) {
                            if (iP === 0 || !currentPath) {
                                startingPoints.pop();
                            }
                        }
                        lastPoint = thisPoint;
                        counter++;
                    }
                }
            }
            node._lineSegmentStartingPoints = startingPoints;
            node.calculatedBoundingBox = this.calculateSketchBoundingBox(node);
            return result;
        }
        updateSketchPreview(sketchNode, vertexData, mesh) {
            var _a;
            const previewMesh = this.sketchPreviews.get(sketchNode._dynamicId);
            const { segments } = parseSketchGeometry(vertexData);
            if (segments.length > 0) {
                const baseColor = ((_a = sketchNode._rootScene) === null || _a === void 0 ? void 0 : _a.edgeColor)
                    ? sketchNode._rootScene.edgeColor.toColor4()
                    : new Color4(1, 1, 1, 1);
                const colors = [];
                segments.forEach(segmentPoints => {
                    const segmentColors = [];
                    colors.push(segmentColors);
                    segmentPoints.forEach(() => {
                        segmentColors.push(baseColor);
                    });
                });
                const lineColor = colors.length > 0 ? colors : undefined;
                if (previewMesh &&
                    !sketchNode.changes.has('addFace') &&
                    !sketchNode.changes.has('paths') &&
                    !sketchNode.changes.has('closePath')) {
                    MeshBuilder.CreateLineSystem(`${sketchNode._dynamicId}_preview`, {
                        lines: segments,
                        instance: previewMesh,
                        colors: lineColor,
                        updatable: true,
                    }, this.scene);
                }
                else {
                    if (previewMesh) {
                        previewMesh.dispose();
                    }
                    const newPreviewMesh = MeshBuilder.CreateLineSystem(`${sketchNode._dynamicId}_preview`, {
                        lines: segments,
                        colors: lineColor,
                        updatable: true,
                    }, this.scene);
                    this.sketchPreviews.set(sketchNode._dynamicId, newPreviewMesh);
                    newPreviewMesh.parent = mesh;
                    newPreviewMesh.enableEdgesRendering();
                    newPreviewMesh.edgesColor = baseColor;
                    this.viewer.camera.maintainNodeScreenSize(newPreviewMesh, (dist, mode) => {
                        if (mode === Camera.PERSPECTIVE_CAMERA) {
                            newPreviewMesh.edgesWidth = dist * 0.25;
                        }
                        else {
                            newPreviewMesh.edgesWidth = 4;
                        }
                    });
                }
            }
            else if (previewMesh) {
                previewMesh.dispose();
                this.sketchPreviews.delete(sketchNode._dynamicId);
            }
        }
        updateSketchTracing(sketchNode, vertexData, mesh) {
            const previewMesh = this.sketchTracings.get(sketchNode._dynamicId);
            const sketchColor = sketchNode.pathColor.toColor4();
            if (sketchNode.tracePath) {
                if (previewMesh) {
                    previewMesh.dispose();
                }
                //create/update drawings
                const linePoints = [];
                sketchNode.paths.forEach(path => {
                    path._points.forEach(point => {
                        linePoints.push(new Vector3(point.x, point.y, point.z));
                    });
                });
                if (sketchNode.closePath) {
                    const point = sketchNode.paths[0]._points[0];
                    linePoints.push(new Vector3(point.x, point.y, point.z));
                }
                const lines = Mesh.CreateLines('lines', linePoints, this.scene, true);
                lines.enableEdgesRendering();
                lines.edgesWidth = sketchNode.lineThickness;
                lines.edgesColor = sketchColor;
                this.sketchTracings.set(sketchNode._dynamicId, lines);
            }
            else {
                if (previewMesh || (previewMesh && sketchNode.tracePath === false)) {
                    previewMesh.dispose();
                    this.sketchTracings.delete(sketchNode._dynamicId);
                }
            }
        }
        buildTextGeometry(node) {
            const fontService = node._manager.getService(Token.FontService);
            if (!node.fontFile || !node.text) {
                return null;
            }
            if (!fontService.readyFonts.has(node.fontFile)) {
                fontService.loadFontByFile(node.fontFile).then(resultData => {
                    const fontBuffer = resultData;
                    if (fontBuffer) {
                        node.setPropertyIsModified('fontFile', true);
                    }
                });
                return null;
            }
            else {
                let vertexDataBuilder = textMeshFonts.get(node.fontFile);
                if (!vertexDataBuilder) {
                    const fontBuffer = fontService.readyFonts.get(node.fontFile);
                    const openTypeFont = parseBuffer(fontBuffer);
                    const font = new TextMeshFont(node.fontFile, openTypeFont, this.scene);
                    vertexDataBuilder = new TextMeshVertexData(font);
                    textMeshFonts.set(node.fontFile, vertexDataBuilder);
                }
                return vertexDataBuilder.getText(node.text, node.fontSize, node.charSpacing, node.curveRadius);
            }
        }
        getMeshGeometry(node) {
            const mesh = this.get3d(node);
            if (mesh && mesh instanceof Mesh && mesh._geometry) {
                const geometry = SubmeshVertexData.ExtractFromMesh(mesh);
                // // Make sure the geometry is valid and actually has some geometry in it so consumers of this function don't have to deep check.
                // if(!geometry.indices || !geometry.positions || geometry.indices.length === 0) {
                //     return null;
                // }
                return geometry;
            }
            return null;
        }
        fetchMaterialNode(meshNode, materialId) {
            var _a;
            const localMaterial = (_a = meshNode._manager) === null || _a === void 0 ? void 0 : _a.getById(materialId); //find the material if it's local
            return new Promise((resolve, reject) => {
                if (localMaterial) {
                    //it's a local material
                    resolve(localMaterial);
                }
                else {
                    // Not a local material, so it's a global or library material
                    this.rendererManager.material
                        .loadGlobalMaterial(materialId, meshNode._manager.services)
                        .pipe(take(1))
                        .subscribe(globalLibMaterial => {
                        if (!globalLibMaterial) {
                            console.warn(`Cannot find global material ${materialId} on node ${meshNode.name} (${meshNode.id})`);
                            reject('could not load global material');
                        }
                        else {
                            resolve(globalLibMaterial);
                        }
                    });
                }
            });
        }
        setRenderModeOnMesh(mesh, sceneNode) {
            const mode = this.renderMode;
            if (mesh.geometry) {
                if (mode === exports.eRenderMode.edge || mode === exports.eRenderMode.hiddenEdges) {
                    mesh.enableEdgesRendering(sceneNode.edgeDisplayTolerance);
                    mesh.renderOutline = true;
                    mesh.edgesWidth = sceneNode.edgeWidth;
                    mesh.edgesColor = sceneNode.edgeColor.toColor4();
                    mesh.outlineWidth = sceneNode.edgeWidth / 100;
                    mesh.outlineColor = sceneNode.edgeColor.toColor3();
                    // Another option for the hidden edges renderer but results in render artifacts especially when meshes go on top of each other.
                    // if (mode === eRenderMode.hiddenEdges) {
                    //     mesh.metadata = { ...mesh.metadata, visibility: mesh.visibility };
                    //     mesh.visibility = 0.001;
                    // }
                }
                else {
                    // mesh.visibility = mesh.metadata?.visibility || 1;
                    mesh.renderOutline = false;
                    mesh.disableEdgesRendering();
                }
            }
        }
        getMeshVertexData(node) {
            if (!node._geometry) {
                throw Error('Cannot get vertex data because mesh has no geometry');
            }
            let meshVertexData = SubmeshVertexData.FromGeometry(node._geometry);
            meshVertexData = this.preTransformVertices(meshVertexData, node, node._geometry);
            return meshVertexData;
        }
        preTransformVertices(meshVertexData, node, cachedGeometry) {
            if (node.preTransform && node.preTransform.length !== 16) {
                throw Error('invalid pretransform array ');
            }
            // If pretransform is not set on the node, the transform we want is the identity matrix (no change from original)
            const transform = node.preTransform ? Matrix.FromArray(node.preTransform) : Matrix.Identity();
            // Check if the geometry has a transform applied
            const existingTransform = cachedGeometry === null || cachedGeometry === void 0 ? void 0 : cachedGeometry._hasTransform;
            // If the geometry has already been transformed, then we have to undo that transform to get the correct transform
            // Starting with the invert matrix of the existing transform will cancel out the existing transform and result in the original mesh
            if (existingTransform) {
                Matrix.FromArray(existingTransform).invert().multiplyToRef(transform, transform);
            }
            // If the transform we want (taking the existing transform into account) is the identity matrix, do nothing and return the geometry
            if (!transform.isIdentity()) {
                if (existingTransform) {
                    // If the geometry has already been transformed, don't overwrite the transform so we don't repeatedly transform it
                    meshVertexData = meshVertexData.deepClone();
                }
                else if (cachedGeometry) {
                    // If the geoemtry has no existing transform, set the hasTransform property since it will get mutated with the new transform.
                    cachedGeometry._hasTransform = node.preTransform;
                }
                meshVertexData.transform(transform);
            }
            return meshVertexData;
        }
        updateParentMeshFromNode(node, targetNode, isNewMesh) {
            const parentNode = node._parent;
            if (parentNode && parentNode instanceof exports.SpaceNode) {
                const isRootScene = parentNode instanceof exports.SceneNode && !parentNode.isNested();
                const parent3d = isRootScene
                    ? this.rendererManager.sceneRenderer.get3d(parentNode)
                    : this.get3d(parentNode);
                if (parent3d) {
                    if (targetNode instanceof Mesh) {
                        targetNode.setParent(parent3d);
                    }
                    else {
                        targetNode.parent = parent3d;
                    }
                }
                else {
                    console.error(`Could not find mesh by ID ${parentNode.id} in scene!`);
                }
            }
            else {
                return; // if the node has no parent, it's not part of the scene anymore
            }
            if (isNewMesh ||
                SettingsManagerService.get('parentChangeBehavior') === exports.eParentChangeBehavior.PRESERVE_PROPERTY) {
                this.updateMeshTransform(node, targetNode, null);
            }
            else {
                node.position = exports.KbVector.FromVec3(targetNode.position);
                if (targetNode.rotationQuaternion) {
                    node.useEuler = false;
                    node.setRotationQuaternion(new exports.KbQuaternion(targetNode.rotationQuaternion.x, targetNode.rotationQuaternion.y, targetNode.rotationQuaternion.z, targetNode.rotationQuaternion.w));
                }
                else if (node.eulerRotation) {
                    node.useEuler = true;
                    node.eulerRotation = new exports.KbVector(targetNode.rotation.x, targetNode.rotation.y, targetNode.rotation.z);
                }
                node.scaling = targetNode.scaling.x;
            }
            this.invalidateBoundingBox(parentNode); //invalidate parent node in the bounding box cache as now it has a new child
        }
        recursiveLoadChildMeshGeometry(node) {
            const children = node.getChildren();
            children.forEach(child => {
                if (child instanceof exports.SpaceNode && child.visible) {
                    if (child instanceof exports.CustomMeshNode && isTrackedClass(child)) {
                        if (child.hasGeometry && !child._geometry && !child.geometryLoaded && !child._loading) {
                            this.loadNewGeometry(child);
                        }
                    }
                    else {
                        this.recursiveLoadChildMeshGeometry(child);
                    }
                }
            });
        }
        createOrUpdateMesh(node, otherMesh) {
            let mesh;
            if (otherMesh) {
                mesh = otherMesh;
            }
            else {
                mesh = this.get3d(node);
            }
            const changes = node.changes;
            let allChanges = false;
            let meshVerticesNeedReset = false;
            if (!mesh) {
                // New Mesh
                allChanges = true;
                if (isMeshNode(node))
                    changes.set('features', node.features);
                if (isMeshGroupNode(node) || isSceneNode(node)) {
                    mesh = new TransformNode(node._dynamicId, this.scene);
                }
                else {
                    const newMesh = (mesh = new Mesh(node._dynamicId, this.scene));
                    if (isCustomMeshNode(node) && isTrackedClass(node) && node._geometry) {
                        this.setBabylonVertexData(node, newMesh);
                    }
                    else {
                        meshVerticesNeedReset = true;
                    }
                }
                mesh.scaling = Vector3.One();
                mesh.name = node.name;
                mesh.id = node._dynamicId;
                this.set3d(node, mesh);
            }
            else if (isCustomMeshNode(node) && changes.has('geometryId') && node._loading !== node.geometryId) {
                // Only load new geometry if the geometry hasn't just changed
                this.loadNewGeometry(node);
            }
            else if (isCustomMeshNode(node) && isTrackedClass(node) && node._geometry && node.changes.has('_geometry')) {
                // If we're changing the geometry, we always need to (re)apply all mesh properties
                // to the mesh as the new geometry won't have the right properties
                allChanges = true;
                changes.set('features', node.features);
            }
            if (allChanges ||
                changes.hasAny('position', 'useEuler', 'eulerRotation', 'rotationAxis', 'rotationAngle', 'pivot', 'scaling', '_showPivot')) {
                this.updateMeshTransform(node, mesh, allChanges ? null : changes);
                if (isMeshNode(node)) {
                    this.rendererManager.material.reflectedMeshes.set(node._dynamicId, mesh);
                }
                this.rendererManager.material.updateReflectionProbes();
            }
            if (changes.has('scaling')) {
                this.updateConnectorScaling(node);
            }
            const pivotGizmo = this.pivotGizmos.get(node._dynamicId);
            if (allChanges || changes.has('visible')) {
                mesh.setEnabled(!!node.visible);
                this.viewer.polygonTracker.next();
                this.viewer.warningTracker.next();
                if (pivotGizmo) {
                    pivotGizmo.setEnabled(!!node.visible);
                }
                this.invalidateBoundingBox(node);
                // If a group node is made visible and it has a child node that has geometry load it now
                if (node.visible && node instanceof exports.MeshGroupNode) {
                    let parentNode = node._parent;
                    let allParentsVisible = true;
                    while (parentNode) {
                        if (!parentNode.visible) {
                            allParentsVisible = false;
                            break;
                        }
                        parentNode = parentNode._parent;
                    }
                    if (allParentsVisible) {
                        this.recursiveLoadChildMeshGeometry(node);
                    }
                }
            }
            if (mesh instanceof Mesh) {
                const meshNode = node;
                mesh.isBlocker = false;
                if (allChanges || changes.has('receiveShadows')) {
                    mesh.receiveShadows = !!meshNode.receiveShadows;
                    this.shadowManager.toggleReceiver(mesh, !!meshNode.receiveShadows);
                }
                if (changes.has('isPickable')) {
                    if (meshNode.isPickable !== undefined) {
                        mesh.isPickable = meshNode.isPickable;
                    }
                    else {
                        mesh.isPickable = true;
                    }
                }
                if (allChanges || changes.has('castShadows'))
                    this.shadowManager.toggleCaster(mesh, !!meshNode.castShadows);
                if (allChanges || changes.has('checkCollisions'))
                    mesh.checkCollisions = !!meshNode.checkCollisions;
                if (allChanges || changes.has('flipSurfaceOrientation')) {
                    if (meshNode.flipSurfaceOrientation) {
                        mesh.overrideMaterialSideOrientation = Mesh.BACKSIDE;
                    }
                    else {
                        mesh.overrideMaterialSideOrientation = Mesh.FRONTSIDE;
                    }
                }
                if (this.renderMode !== exports.eRenderMode.hiddenEdges) {
                    if (allChanges || changes.has('opacity')) {
                        mesh.visibility = meshNode.opacity == null ? 1 : meshNode.opacity;
                    }
                }
                const warningTracker = {
                    name: meshNode.name,
                    isEnabled: meshNode.visible,
                    castShadows: meshNode.castShadows || false,
                    receiveShadows: meshNode.receiveShadows || false,
                    polygonNumber: meshNode._polygonCount || 0,
                    featureNumber: node.features.length,
                };
                this.viewer.MeshWarningTracker.set(mesh.id, warningTracker);
                // Material
                if (allChanges || changes.has('materialId') || changes.has('visible')) {
                    const _mesh = mesh;
                    // If the material is a multimaterial, make sure all the material nodes making it up are initialized
                    if (meshNode.visible && mesh.material instanceof MultiMaterial) {
                        mesh.material.subMaterials.forEach(material => {
                            if (material) {
                                const localMaterial = getByDynamicId(material.id, false);
                                if (localMaterial) {
                                    localMaterial.init();
                                }
                                else {
                                    // Global material ?
                                    const globalMaterial = this.rendererManager.material.getGlobalMaterial(material.id);
                                    if (globalMaterial) {
                                        globalMaterial.init();
                                    }
                                }
                            }
                        });
                    }
                    if (meshNode.materialId) {
                        this.fetchMaterialNode(meshNode, meshNode.materialId).then(materialNode => {
                            if (meshNode.visible) {
                                this.setMaterialOnMesh(meshNode, _mesh, materialNode);
                            }
                        }, () => {
                            meshNode.materialId = undefined;
                        });
                    }
                    else {
                        if (mesh.material instanceof MultiMaterial) {
                            mesh.material.subMaterials[0] = this.rendererManager.material.defaultMaterial;
                            mesh.material.forceCompilation(mesh); // If you don't do this webgl vomits errors because we invalidated the cache
                        }
                        else {
                            mesh.material = this.rendererManager.material.defaultMaterial;
                        }
                    }
                    if (isMeshNode(node)) {
                        this.rendererManager.material.reflectedMeshes.set(node._dynamicId, mesh);
                    }
                    this.rendererManager.material.updateReflectionProbes();
                }
                let sketchNode;
                let updateSketchDrawing = false;
                // For primitives, recalculate the mesh if the shape properties changed
                if (isPrimitiveMeshNode(meshNode)) {
                    if (allChanges) {
                        meshVerticesNeedReset = true;
                    }
                    else {
                        meshNode.changes.forEach((_, key) => {
                            if (primitiveShapeProperties.has(key)) {
                                meshVerticesNeedReset = true;
                            }
                        });
                    }
                }
                else if (isCustomMeshNode(meshNode) && isTrackedClass(meshNode)) {
                    meshVerticesNeedReset = meshNode.changes.has('_geometry') && !!meshNode._geometry;
                }
                else if (isSketchNode(meshNode) && isTrackedClass(meshNode)) {
                    sketchNode = meshNode;
                    meshVerticesNeedReset = sketchNode.changes.hasAny('paths', 'addFace', 'flipPath', 'clonePath', 'closePath', '_previewVisible');
                    updateSketchDrawing = sketchNode.changes.hasAny('paths', 'addFace', 'flipPath', 'clonePath', 'closePath', '_previewVisible', 'lineThickness', 'pathColor', 'tracePath');
                    if (sketchNode.changes.hasAny('boundingXOverride', 'boundingYOverride', 'boundingZOverride')) {
                        sketchNode._boundingBoxChanges.next(sketchNode.getBoundingBox());
                    }
                }
                else if (isTextNode(meshNode) && isTrackedClass(meshNode)) {
                    meshVerticesNeedReset = meshNode.changes.hasAny('text', 'fontSize', 'curveRadius', 'charSpacing', 'fontFile');
                }
                let preTransformChanged = false;
                if (allChanges || changes.hasAny('features', 'preTransform')) {
                    meshVerticesNeedReset = true;
                    preTransformChanged = !(allChanges || changes.has('_geometry')); // If geometry has changed, then the geometry was just loaded
                }
                // Features or shape properties have been changed, we have to recalculate original geometry and reprocess features on top
                if (allChanges || changes.has('uvOverrides') || meshVerticesNeedReset || updateSketchDrawing) {
                    const meshVertexData = this.rebuildBaseGeometry(node, preTransformChanged);
                    if (meshVertexData) {
                        // This call should also apply the new vertex data.
                        this.rendererManager.features.resetMeshGeometry(meshNode, null, meshVertexData);
                    }
                    else {
                        if (mesh.geometry) {
                            // If mesh geometry is set, the mesh was previously initialized but now is being generated with no geometry so we should destroy the old geometry
                            // Failing to do so will cause Babylon geometry issues
                            mesh.dispose();
                            this.delete3d(node);
                        }
                    }
                    if (sketchNode && sketchNode._previewVisible) {
                        this.updateSketchPreview(sketchNode, meshVertexData, mesh);
                    }
                    if (sketchNode && sketchNode.tracePath && updateSketchDrawing) {
                        if (sketchNode) {
                            this.updateSketchTracing(sketchNode, meshVertexData, mesh);
                        }
                    }
                }
                // If this is a sketch, see if we need to show a preview of it
                if (sketchNode && sketchNode.changes.has('_previewVisible')) {
                    const previewMesh = this.sketchPreviews.get(meshNode._dynamicId);
                    if (previewMesh) {
                        previewMesh.setEnabled(sketchNode._previewVisible);
                    }
                }
                this.viewer.meshWarningsNeedsUpdate.next();
            }
            return mesh;
        }
        updateMeshTransform(node, mesh, changes // null means all changes
        ) {
            const pivot = node.pivot.toVec3();
            const originOffset = pivot.scale(-1);
            const newPosition = node.position.toVec3();
            let newRotation;
            if (node.useEuler) {
                newRotation = Quaternion.FromEulerAngles(toRadians(node.eulerRotation.x), toRadians(node.eulerRotation.y), toRadians(node.eulerRotation.z));
            }
            else {
                newRotation = Quaternion.RotationAxis(node.rotationAxis.toVec3(), toRadians(node.rotationAngle));
            }
            const rotationMatrix = new Matrix();
            newRotation.toRotationMatrix(rotationMatrix);
            Vector3.TransformCoordinatesToRef(originOffset, rotationMatrix, originOffset);
            mesh.rotationQuaternion = newRotation;
            const scalingMatrix = Matrix.Scaling(node.scaling, node.scaling, node.scaling);
            Vector3.TransformCoordinatesToRef(originOffset, scalingMatrix, originOffset);
            mesh.scaling = new Vector3().setAll(node.scaling);
            newPosition.addInPlace(originOffset).addInPlace(pivot);
            if (!mesh.position.equals(newPosition)) {
                mesh.position = newPosition;
            }
            this.rendererManager.features.transformChanged(node);
            this.invalidateBoundingBox(!changes || changes.has('scaling') ? node : node._parent); //scaling, changes current node, but all others only change the parent
            if (node._showPivot) {
                let pivotGizmo = this.pivotGizmos.get(node._dynamicId);
                if (!pivotGizmo) {
                    pivotGizmo = SphereBuilder.CreateSphere('pivotSphere', { diameter: 0.05 }, this.utilityLayer.utilityLayerScene);
                    const coloredMaterial = new StandardMaterial('', this.utilityLayer.utilityLayerScene);
                    coloredMaterial.emissiveColor = Color3.Red();
                    pivotGizmo.material = coloredMaterial;
                    this.pivotGizmos.set(node._dynamicId, pivotGizmo);
                }
                if (!pivotGizmo.isEnabled()) {
                    pivotGizmo.setEnabled(true);
                }
                const worldPivot = pivot.add(node.position.toVec3());
                if (mesh.parent) {
                    const transform = mesh.parent.computeWorldMatrix(true);
                    Vector3.TransformCoordinatesToRef(worldPivot, transform, worldPivot);
                }
                pivotGizmo.position = worldPivot;
            }
            else {
                const pivotGizmo = this.pivotGizmos.get(node._dynamicId);
                if (pivotGizmo && pivotGizmo.isEnabled()) {
                    pivotGizmo.setEnabled(false);
                }
            }
            return mesh;
        }
        createPrimitiveMesh(node) {
            if (!isPrimitiveMeshNode(node))
                throw Error('Primitive not set');
            if (isBoxMesh(node)) {
                if (node.tessellation <= 1) {
                    return MeshBuilder.CreateBox(node._dynamicId, {
                        height: node.height,
                        width: node.width,
                        depth: node.depth,
                        sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                        updatable: true,
                    }, this.scene);
                }
                else {
                    return MeshBuilder.CreateTiledBox(node._dynamicId, {
                        height: node.height,
                        width: node.width,
                        depth: node.depth,
                        sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                        updatable: true,
                        tileSize: 1 / node.tessellation,
                    }, this.scene);
                }
            }
            else if (isSphereMesh(node)) {
                return SphereBuilder$1.CreateSphere(node._dynamicId, {
                    segments: node.tessellation,
                    diameter: node.radius * 2,
                    arc: node.arc / 360,
                    sliceStart: node.latitudeStart / 180,
                    slice: node.latitudeSlice / 180,
                    sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                    updatable: true,
                }, this.scene);
            }
            else if (isCylinderMesh(node)) {
                return CylinderBuilder$1.CreateCylinder(node._dynamicId, {
                    height: node.height,
                    diameter: node.radius * 2,
                    tessellation: node.tessellation,
                    subdivisions: node.subdivisions,
                    hasRings: node.subdivisions > 1,
                    cap: capModeMap[node.capMode],
                    sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                    arc: node.arc / 360,
                    updatable: true,
                }, this.scene);
            }
            else if (isConeMesh(node)) {
                return MeshBuilder.CreateCylinder(node._dynamicId, {
                    height: node.height,
                    diameterTop: node.radiusTop * 2,
                    diameterBottom: node.radiusBottom * 2,
                    tessellation: node.tessellation,
                    sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                    updatable: true,
                }, this.scene);
            }
            else if (isTorusMesh(node)) {
                return TorusBuilder.CreateTorus(node._dynamicId, {
                    diameter: node.radius * 2,
                    thickness: node.thickness,
                    tessellation: node.tessellation,
                    sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                    arc: node.arc / 360,
                    sliceStart: node.latitudeStart / 360,
                    slice: node.latitudeSlice / 360,
                    updatable: true,
                }, this.scene);
            }
            else if (isPlaneMesh(node)) {
                const mesh = PlaneBuilder$1.CreatePlane(node._dynamicId, {
                    width: node.width,
                    height: node.depth,
                    tileHeight: node.depth / node.segments,
                    tileWidth: node.width / node.segments,
                    sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                    updatable: true,
                }, this.scene);
                mesh.rotation.x = Math.PI / 2;
                mesh.bakeCurrentTransformIntoVertices();
                return mesh;
            }
            else if (isDiscMesh(node)) {
                return DiscBuilder.CreateDisc(node._dynamicId, {
                    radius: node.radius,
                    tessellation: node.tessellation,
                    sideOrientation: exports.eSideOrientationBabylonMap[node.sideOrientation],
                    updatable: true,
                }, this.scene);
            }
            else {
                throw Error('Mesh primitive not implemented');
            }
        }
        setBabylonVertexData(kbMesh, mesh, preserveSubmeshes = true) {
            if (!kbMesh._geometry) {
                return;
            }
            const vertexData = this.getMeshVertexData(kbMesh);
            const invalid = verifyGeometry(vertexData);
            if (invalid) {
                console.error(`Invalid or corrupted geometry in mesh ${kbMesh.name}. The ${invalid} are invalid.`);
            }
            else {
                vertexData.applyToMesh(mesh, true, preserveSubmeshes);
                kbMesh._polygonCount = mesh.getTotalIndices() / 3;
                kbMesh._verticesCount = mesh.getTotalVertices();
                this.viewer.polygonTracker.next();
                this.viewer.warningTracker.next();
            }
            this.setRenderModeOnMesh(mesh, kbMesh._rootScene);
            if (mesh.isFacetDataEnabled) {
                mesh.updateFacetData();
            }
        }
        setBabylonUvData(uvData, vertexData) {
            if (uvData.uvs) {
                vertexData.uvs = uvData.uvs;
            }
            if (uvData.uv2s) {
                vertexData.uvs2 = uvData.uv2s;
            }
            if (uvData.uv3s) {
                vertexData.uvs3 = uvData.uv3s;
            }
            if (uvData.uv4s) {
                vertexData.uvs4 = uvData.uv4s;
            }
            if (uvData.uv5s) {
                vertexData.uvs5 = uvData.uv5s;
            }
            if (uvData.uv6s) {
                vertexData.uvs6 = uvData.uv6s;
            }
            return vertexData;
        }
        setMaterialOnMesh(meshNode, babylonMesh, materialNode) {
            if (meshNode.visible) {
                materialNode.init();
            }
            const material = this.rendererManager.material.get3d(materialNode);
            if (!material) {
                throw Error('Material could not be found in renderer. Has the material been created?');
            }
            // If the mesh already has a material and it's a multimaterial, then update the material on index 0
            // Which is reserved for the "base" material.
            if (babylonMesh.material instanceof MultiMaterial) {
                babylonMesh.material.subMaterials[0] = material;
                babylonMesh.material.forceCompilation(babylonMesh);
            }
            else if (!babylonMesh.material || babylonMesh.material.id != materialNode._dynamicId) {
                babylonMesh.material = material;
            }
        }
        invalidateBoundingBox(node) {
            if (node) {
                this.viewer.bbCache.invalidate(node);
            }
        }
        delete3d(node) {
            if (isSketchNode(node)) {
                node._boundingBoxChanges.complete();
            }
            const bnode = this.get3d(node);
            if (bnode && bnode instanceof Mesh) {
                this.viewer.MeshWarningTracker.delete(bnode.id);
                this.shadowManager.removeCaster(bnode);
                this.shadowManager.removeReceiver(bnode);
                if (bnode.material instanceof MultiMaterial) {
                    bnode.material.dispose(true, true, false); // multimaterials are 1:1 with meshes
                }
            }
            this.rendererManager.material.reflectedMeshes.delete(node._dynamicId);
            this.rendererManager.material.updateReflectionProbes();
            this.viewer.meshWarningsNeedsUpdate.next();
            super.delete3d(node);
            this.viewer.polygonTracker.next();
            this.viewer.warningTracker.next();
        }
        createSketchPlaneVisualization(sketch) {
            const color = Color3.Yellow();
            const boundingBox = sketch.calculatedBoundingBox;
            let squareSize = 3;
            let calculatedSize = 0;
            let boundingBoxCenter = new Vector3(0, 0, 0);
            if (boundingBox) {
                boundingBoxCenter = boundingBox.center.clone();
                calculatedSize = boundingBox.minimum.subtract(boundingBox.maximum).length();
            }
            if (calculatedSize > squareSize) {
                squareSize = calculatedSize * 1;
            }
            const coloredMaterial = new StandardMaterial('', this.scene);
            coloredMaterial.wireframe = true;
            coloredMaterial.emissiveColor = color;
            const sketchPlaneVisualization = CreatePlane('mirrorPlane', { size: squareSize }, this.scene);
            const sketchMesh = this.viewer.getRendererNode(sketch);
            if (sketchMesh) {
                const translation = sketchMesh.computeWorldMatrix();
                const position = Vector3.TransformCoordinates(boundingBoxCenter, translation);
                sketchPlaneVisualization.position = new Vector3(position.x, position.y, position.z);
                const sketchNormal = new Vector3(0, 0, 0);
                if (sketch.normal === exports.eAxis.x) {
                    sketchNormal.set(1, 0, 0);
                }
                else if (sketch.normal === exports.eAxis.y) {
                    sketchNormal.set(0, 1, 0);
                }
                else {
                    sketchNormal.set(0, 0, 1);
                }
                const rotationVector = Vector3.TransformCoordinates(sketchNormal, sketchMesh.computeWorldMatrix().getRotationMatrix());
                rotationVector.z = rotationVector.z * -1;
                const resultQuaternion = new Quaternion();
                Quaternion.FromUnitVectorsToRef(rotationVector, new Vector3(0, 0, 1), resultQuaternion);
                sketchPlaneVisualization.rotationQuaternion = resultQuaternion;
                //uvMapVisualization.rotation = Vector3.RotationFromAxis()
                sketchPlaneVisualization.material = coloredMaterial;
                sketchPlaneVisualization.bakeCurrentTransformIntoVertices();
                return sketchPlaneVisualization;
            }
            else {
                console.warn('Sketch visualization plane cannot be generated, please check direction and position of sketchpoints.');
                return null;
            }
        }
        updateConnectorScaling(node) {
            if (node instanceof exports.SketchNode) {
                node.paths.forEach(path => {
                    path.controlPoints.forEach(controlPoint => {
                        this.viewer.rendererManager.controlPointRenderer.updateScale(controlPoint);
                    });
                });
            }
            else {
                if (node.connectors) {
                    node.connectors.forEach(connector => {
                        this.viewer.rendererManager.connector.updateScale(connector);
                    });
                }
                const childNodes = node.getChildren();
                if (childNodes) {
                    childNodes.forEach(child => {
                        if (child instanceof exports.SpaceNode) {
                            this.updateConnectorScaling(child);
                        }
                    });
                }
            }
        }
        calculateSketchBoundingBox(node) {
            const firstPoint = node.paths[0]._points[0];
            const minVector = new Vector3(firstPoint.x, firstPoint.y, firstPoint.z);
            const maxVector = new Vector3(firstPoint.x, firstPoint.y, firstPoint.z);
            node.paths.forEach(path => {
                path._points.forEach(point => {
                    if (point.x < minVector.x) {
                        minVector.x = point.x;
                    }
                    if (point.y < minVector.y) {
                        minVector.y = point.y;
                    }
                    if (point.z < minVector.z) {
                        minVector.z = point.z;
                    }
                    if (point.x > maxVector.x) {
                        maxVector.x = point.x;
                    }
                    if (point.y > maxVector.y) {
                        maxVector.y = point.y;
                    }
                    if (point.z > maxVector.z) {
                        maxVector.z = point.z;
                    }
                });
            });
            return new BoundingBox(minVector, maxVector);
        }
    }

    class PathRenderer extends Renderer {
        constructor(viewer, scene) {
            super(viewer, scene);
            this.viewer = viewer;
            this.scene = scene;
            this.modelToken = Token.SketchPath;
        }
        update3dInternal(node) { }
    }

    // function limitFPE(val: number) {
    //     return Math.round((val + Number.EPSILON) * 100000000) / 100000000;
    // }
    // function roundQuaterion(q: Quaternion) {
    //     return new Quaternion(limitFPE(q.x), limitFPE(q.y), limitFPE(q.z), limitFPE(q.w));
    // }
    function mateControlPointToConnector(mate, c1Mesh, controlPointMesh) {
        let grandParentContainerWorldMatrixInv;
        if (controlPointMesh.parent) {
            grandParentContainerWorldMatrixInv = controlPointMesh.parent.computeWorldMatrix(true).clone().invert();
        }
        else {
            grandParentContainerWorldMatrixInv = Matrix.IdentityReadOnly;
        }
        const targetTransformMatrix = c1Mesh.computeWorldMatrix().clone();
        targetTransformMatrix.multiplyToRef(grandParentContainerWorldMatrixInv, targetTransformMatrix);
        const position = new Vector3();
        const direction = new Vector3();
        targetTransformMatrix.decompose(undefined, undefined, position);
        Vector3.TransformNormalFromFloatsToRef(-1.0, 0, 0, targetTransformMatrix, direction);
        if (!mate.flip) {
            direction.scaleInPlace(-1);
        }
        direction.normalize();
        return {
            position,
            direction,
        };
    }
    const flipMatrix = new Matrix();
    Quaternion.RotationAxis(Axis.Y, toRadians(180)).toRotationMatrix(flipMatrix);
    function mateConnectors(mate, followerMesh, c1Mesh, c2Mesh) {
        updateMatrixOfAncestorChain(followerMesh, c2Mesh);
        c1Mesh.computeWorldMatrix(true);
        let mateOffset = Vector3.Zero();
        let worldDelta = Vector3.Zero(); //the translation that c2 would need to make to get to it's new position
        if (mate.mateType == exports.eMateType.ball) {
            /**
             * Ball Mate
             * -move c2 until it's in the same position as c1
             * In the future this could be made more intelligent by rotating a node to satisfy this mate and another ball or slider mate
             */
            worldDelta = c1Mesh.getAbsolutePosition().subtract(c2Mesh.getAbsolutePosition());
        }
        else {
            /**
             * Aligning direction vectors
             * ------------------------------------------------
             * Easiest way to think about this:
             * Connectors have a direction vector, and an angle of rotation around the direction vector.
             * The connector meshes are rotated by the renderer such that the positive X axis is pointing
             * in the direction of the direction vector.  And the angle vector will be pointing in the direction
             * of the y axis.
             *
             * We want the world transformation matrix of the second connector to match the world transform of the first connector (optionally flipped).
             * The math for calculating the world matrix of a connector can be written as:
             *      <local transform matrix of connector> * <local transform matrix of connector parent> * <world transform matrix of grandparent, or identity matrix>
             * We are trying to solve for the local transform matrix of the connector parent so the full world transform matches the transform of the first connector,
             * so we can rewrite the equation as:
             *      <local transform matrix of connector parent> = <INVERSE local transform matrix of connector> * <world transform of first connector> * <INVERSE world transform matrix of grandparent, or identity matrix>
             *
             * Then we apply the result matrix to the connector parent.
             */
            const t = new Vector3();
            const r = new Quaternion();
            const s = new Vector3();
            c1Mesh.computeWorldMatrix(true).decompose(s, r, t);
            if (mate.offsetAngle && mate.offsetAngle !== 0) {
                const angleOffsetQ = Quaternion.RotationAxis(Axis.X, (mate.offsetAngle * Math.PI) / 180);
                r.multiplyInPlace(angleOffsetQ);
            }
            const targetWorldTransformMatrix = Matrix.Compose(followerMesh.scaling, r, t);
            const currentWorldTransformMatrix = c2Mesh.computeWorldMatrix(true).clone();
            if (!mate.flip) {
                flipMatrix.multiplyToRef(targetWorldTransformMatrix, targetWorldTransformMatrix);
            }
            const c2LocalTransform = Matrix.Compose(c2Mesh.scaling, c2Mesh.rotationQuaternion, c2Mesh.position);
            let grandParentContainerWorldMatrix;
            if (followerMesh.parent) {
                grandParentContainerWorldMatrix = followerMesh.parent.computeWorldMatrix(true).clone();
            }
            else {
                grandParentContainerWorldMatrix = Matrix.IdentityReadOnly;
            }
            const grandParentContainerWorldMatrixInv = grandParentContainerWorldMatrix.clone().invert();
            let calculatedTargetWorldTransform;
            if (mate.mateType.equalsAny(exports.eMateType.revolute, exports.eMateType.cylindrical)) {
                /**
                 * For these types of mates, the objective is to match the direction vectors but allow the angle to float freely.
                 * What this means in practice is that we have to split the quaternion into a swing and a twist component.
                 * The swing component will rotate the direction vector to point the right way, along a rotation axis equal to the cross product of the X axis and the direction vector,
                 * and the twist component will rotate the mesh around the direction vector to match the desired angles. We then throw away the "new" twist angle and use the original twist angle.
                 * For this to work it's necessary to ensure that the same rotation axis is used for both the swing rotation of the target and the swing rotation of the current, if the directions match.
                 * Otherwise the twist angles won't be referring to the same thing.
                 */
                const targetQ = Quaternion.FromRotationMatrix(targetWorldTransformMatrix.getRotationMatrix());
                const currentQ = Quaternion.FromRotationMatrix(currentWorldTransformMatrix.getRotationMatrix());
                const targetDirection = Vector3.TransformNormal(Axis.X, targetWorldTransformMatrix).normalize();
                const currentDirection = c2Mesh.right;
                // At direction vectors close to or equal to the X axis, the twist angle becomes heavily affected by floating point errors, so we avoid loops by not updating the rotation if the direction vectors are close to each other.
                if (currentDirection.add(targetDirection).length() > 0.0001) {
                    const targetST = decomposeSwingTwist(targetQ, targetDirection.scale(-1));
                    const currentST = decomposeSwingTwist(currentQ, currentDirection);
                    const targetRotationNew = targetST.swing.multiply(currentST.twist);
                    calculatedTargetWorldTransform = Matrix.Compose(followerMesh.scaling, targetRotationNew, t);
                }
            }
            else if (mate.mateType.equalsAny(exports.eMateType.fastened, exports.eMateType.planar, exports.eMateType.slider)) {
                calculatedTargetWorldTransform = targetWorldTransformMatrix;
            }
            if (calculatedTargetWorldTransform) {
                const followerMeshTransformMatrix = c2LocalTransform.clone().invert();
                followerMeshTransformMatrix.multiplyToRef(calculatedTargetWorldTransform, followerMeshTransformMatrix);
                followerMeshTransformMatrix.multiplyToRef(grandParentContainerWorldMatrixInv, followerMeshTransformMatrix);
                const resultFollowerRotMatrix = followerMeshTransformMatrix.getRotationMatrix();
                {
                    followerMesh.rotationQuaternion = Quaternion.FromRotationMatrix(resultFollowerRotMatrix);
                    updateMatrixOfAncestorChain(followerMesh, c2Mesh); //update world matrix after having just rotated follower mesh
                }
            }
            if (mate.mateType == exports.eMateType.fastened || mate.mateType == exports.eMateType.revolute) {
                //translate so the connectors line up
                worldDelta = c1Mesh.getAbsolutePosition().subtract(c2Mesh.getAbsolutePosition());
                mateOffset = new Vector3(mate.offsetX, mate.offsetY, mate.offsetZ);
            }
            else if (mate.mateType == exports.eMateType.planar) {
                /**
                 * Planar Mate
                 * - define a plane at the position of c1, with a normal in the direction of c1
                 * - make a ray from c2 in the direction of c2, and try to intersect the c1 plane
                 * - if it doesn't intersect, flip it and try again
                 * - the intersection of the ray and plane is the new position of c2 (not considering offset)
                 */
                const c1PlaneNormal = Axis.X.rotateByQuaternionToRef(c1Mesh.absoluteRotationQuaternion, Vector3.Zero());
                const c1Plane = Plane.FromPositionAndNormal(c1Mesh.getAbsolutePosition(), c1PlaneNormal);
                const c2Direction = Axis.X.rotateByQuaternionToRef(c2Mesh.absoluteRotationQuaternion, Vector3.Zero());
                const ray = new Ray(c2Mesh.getAbsolutePosition(), c2Direction);
                let distance = ray.intersectsPlane(c1Plane);
                if (distance == null) {
                    //if it doesn't intersect try flipping it
                    ray.direction.negateInPlace();
                    distance = ray.intersectsPlane(c1Plane);
                }
                worldDelta = ray.direction.scale(distance);
                mateOffset = new Vector3(mate.offsetX, 0, 0); //only use the x component for planar mates
            }
            else if (mate.mateType == exports.eMateType.slider || mate.mateType == exports.eMateType.cylindrical) {
                /**
                 * Slider Mate
                 * - define a plane at the position of c2, with a normal in the direction of c2
                 * - make a ray from c1 in the direction of c1, and try to intersect the c2 plane
                 * - if it doesn't intersect, flip it and try again
                 * - the intersection of the ray and plane is the new position of c2 (not considering offset)
                 */
                const c1Pos = c1Mesh.getAbsolutePosition();
                const c2Pos = c2Mesh.getAbsolutePosition();
                const c2PlaneNormal = c2Mesh.getDirection(Axis.X).normalize();
                const c2Plane = Plane.FromPositionAndNormal(c2Pos, c2PlaneNormal);
                const c1Direction = c1Mesh.getDirection(Axis.X).normalize();
                const ray = new Ray(c1Pos, c1Direction);
                let distance = ray.intersectsPlane(c2Plane);
                if (distance == null) {
                    //if it doesn't intersect try flipping it
                    ray.direction.negateInPlace();
                    distance = ray.intersectsPlane(c2Plane);
                }
                worldDelta = ray.direction.scale(distance).add(c1Pos).subtract(c2Pos);
                mateOffset = new Vector3(0, mate.offsetY, mate.offsetZ); //don't use the x component for slider mates
            }
            else if (mate.mateType == exports.eMateType.parallel) ;
        }
        /**
         * now we process the offset and set the position of c2 parent node
         */
        if (!mate.flip)
            mateOffset.negateInPlace();
        if (mate._swap)
            mateOffset.y = -mateOffset.y;
        const worldOffset = mateOffset.rotateByQuaternionToRef(c1Mesh.absoluteRotationQuaternion, Vector3.Zero());
        const totalOffset = worldOffset.add(worldDelta);
        const newAbsPos = followerMesh.getAbsolutePosition().add(totalOffset);
        followerMesh.setAbsolutePosition(newAbsPos);
        followerMesh.computeWorldMatrix(true);
    }
    /**
       Decompose the rotation on to 2 parts.
       1. Twist - rotation around the "direction" vector
       2. Swing - rotation around axis that is perpendicular to "direction" vector
       The rotation can be composed back by
       rotation = swing * twist

       has singularity in case of swing_rotation close to 180 degrees rotation.
       if the input quaternion is of non-unit length, the outputs are non-unit as well
       otherwise, outputs are both unit
    */
    function decomposeSwingTwist(rotation, _direction) {
        // Ensure the direction vector is normalized
        const direction = _direction.clone().normalize();
        const twist = new Quaternion();
        const swing = new Quaternion();
        // Alternate code with indeterminate swing axis
        // const ra = new Vector3(rotation.x, rotation.y, rotation.z);
        // const p = direction.scale(Vector3.Dot(ra, direction));
        // twist.set(p.x, p.y, p.z, rotation.w);
        // twist.normalize();
        // rotation.multiplyToRef(twist.conjugate(), swing);
        rotationToVectorToRef(direction, Axis.X, swing);
        swing.conjugate().multiplyToRef(rotation, twist);
        return { twist, swing };
    }

    (function (ConstraintType) {
        ConstraintType[ConstraintType["Sphere"] = 0] = "Sphere";
        ConstraintType[ConstraintType["Line"] = 1] = "Line";
        ConstraintType[ConstraintType["Plane"] = 2] = "Plane";
        ConstraintType[ConstraintType["Fixed"] = 3] = "Fixed";
        ConstraintType[ConstraintType["None"] = 4] = "None";
    })(exports.ConstraintType || (exports.ConstraintType = {}));
    function sortMates(validMates) {
        const fixed = new Set();
        const primes = new Set();
        const nodeMap = getNodeMap(validMates);
        //parent/child relationships are also a kind of edge in our graph, so add them
        for (const [node] of nodeMap) {
            if (node instanceof exports.SpaceNode) {
                if (node.fixed) {
                    fixed.add(node);
                }
                else if (node._primeMover) {
                    primes.add(node);
                }
                for (const ancestor of node.getAncestors()) {
                    if (nodeMap.has(ancestor)) {
                        nodeMap.add(node, {
                            target: ancestor,
                            constraint: { type: exports.ConstraintType.None, properties: undefined },
                        });
                        nodeMap.add(ancestor, {
                            target: node,
                            constraint: { type: exports.ConstraintType.Fixed, properties: undefined },
                        });
                    }
                }
            }
        }
        /**
         * * starting with primes, recurse through.  Then move to non-primes, ignoring those already visited.
         */
        const visitedNodes = new Set();
        const visitedMates = new Set();
        const nodePath = new Set();
        const matePath = new Set();
        const sorted = new Set();
        const cycles = new Array();
        const overConstrained = new Array();
        for (const n of [...fixed, ...primes, ...nodeMap.keys()]) {
            recurseMateChain(nodeMap, visitedNodes, visitedMates, nodePath, matePath, sorted, cycles, overConstrained, n);
        }
        //remove overconstrained mates from sorted so they don't get processed
        for (const m of overConstrained) {
            sorted.delete(m);
        }
        return {
            sorted,
            cycles,
            overConstrained,
        };
    }
    /**
     * Gets the nodes that are connected to the given through a chain of mates
     */
    function getNodeChain(node, validMates) {
        const nodeMap = getNodeMap(validMates);
        const visitedNodes = new Set();
        const visitedMates = new Set();
        const nodePath = new Set();
        const matePath = new Set();
        const sorted = new Set();
        const cycles = new Array();
        const overConstrained = new Array();
        recurseMateChain(nodeMap, visitedNodes, visitedMates, nodePath, matePath, sorted, cycles, overConstrained, node);
        visitedNodes.delete(node);
        return visitedNodes;
    }
    function getNodeMap(validMates) {
        const nodeMap = new ArrayMap();
        for (const mate of validMates) {
            const c1 = mate.getC1();
            const c2 = mate.getC2();
            let c1Parent = c1 === null || c1 === void 0 ? void 0 : c1.getSpaceParent();
            let c2Parent = c2 === null || c2 === void 0 ? void 0 : c2.getSpaceParent();
            if (c1 && isSketchControlPoint(c1)) {
                c1Parent = c1;
            }
            if (c2 && isSketchControlPoint(c2)) {
                c2Parent = c2;
            }
            if (c1 && c2 && c1Parent && c2Parent) {
                const constraint = { type: exports.ConstraintType.Fixed, properties: undefined };
                // TODO [RO] - Later on we can add more constraint types here based on mate type (CPQ-3881)
                //if (isConstrainingConnector(c1) && isConstrainingConnector(c2)) {
                // constraint = { type: ConstraintType.Fixed, properties: undefined };
                // } else {
                //     constraint = { type: ConstraintType.None, properties: undefined };
                // }
                nodeMap.add(c1Parent, { target: c2Parent, mate, constraint });
                nodeMap.add(c2Parent, { target: c1Parent, mate, constraint });
            }
        }
        return nodeMap;
    }
    function recurseMateChain(nodeMap, visitedNodes, visitedMates, nodePath, matePath, sorted, cycles, overConstrained, node, mate, sourceEdge, isOverconstrained = false) {
        if (!sourceEdge || sourceEdge.constraint.type === exports.ConstraintType.Fixed) {
            if (nodePath.has(node)) {
                const cycle = [...matePath];
                if (mate) {
                    cycle.push(mate);
                }
                cycles.push(cycle);
            }
            if (visitedNodes.has(node)) {
                return;
            }
        }
        visitedNodes.add(node);
        nodePath.add(node);
        if (mate) {
            matePath.add(mate);
            visitedMates.add(mate);
            sorted.add(mate);
            const c1 = mate.getC1();
            const c2 = mate.getC2();
            /** Move along sketch connectors should always be the connector 1, because they can't be moved (they are read only) */
            if (c2.positionMode === exports.eConnectorPositionMode.moveAlongSketch) {
                mate._swap = true;
            }
            /** Control points are always follower meshes */
            else if (isConnector(c1) && isSketchControlPoint(c2)) {
                mate._swap = false;
            }
            else if (isConnector(c2) && isSketchControlPoint(c1)) {
                mate._swap = true;
            }
            else {
                /** mate needs to have c1/c2 swapped if we got here in the opposite direction */
                mate._swap = c1._parent === node;
            }
        }
        // If the source edge is fixed, we recurse through the node because all the node's connectors will be shifting.
        // If the source edge is not fixed, we stop here because only the mated connector will move
        // [RO] TODO eventually we will have to rethink this logic to support more constraint types (CPQ-3881)
        if (!sourceEdge || sourceEdge.constraint.type === exports.ConstraintType.Fixed) {
            for (const edge of nodeMap.get(node)) {
                if (!edge.mate || !visitedMates.has(edge.mate)) {
                    if (edge.target instanceof exports.SpaceNode &&
                        edge.target.fixed &&
                        edge.constraint.type !== exports.ConstraintType.None) {
                        isOverconstrained = true;
                    }
                    recurseMateChain(nodeMap, visitedNodes, visitedMates, nodePath, matePath, sorted, cycles, overConstrained, edge.target, edge.mate, edge, isOverconstrained);
                }
            }
        }
        nodePath.delete(node);
        if (mate) {
            matePath.delete(mate);
            if (isOverconstrained) {
                overConstrained.push(mate);
            }
            visitedMates.delete(mate);
        }
    }

    class Processor {
        constructor() {
            this.afterCleanupTasks = [];
        }
        beforeRender() { }
        beforeDeletions(deletions) { }
        afterDeletions(deletions) { }
        beforeUpdates(changes) { }
        afterUpdates(changes) { }
        afterCleanup(func) {
            this.afterCleanupTasks.push(func);
        }
        doAfterCleanup() {
            this.afterCleanupTasks.forEach(task => task());
            this.afterCleanupTasks.clear();
        }
        dispose() { }
    }

    const CYCLE_ERROR_START = 'Cycle detected:  ';
    class MateProcessor extends Processor {
        constructor(viewer, scene, connectorRenderer, controlPointRenderer, referenceProcessor) {
            super();
            this.viewer = viewer;
            this.scene = scene;
            this.connectorRenderer = connectorRenderer;
            this.controlPointRenderer = controlPointRenderer;
            this.referenceProcessor = referenceProcessor;
        }
        beforeRender() {
            this.rebuildDependencies = false;
        }
        beforeDeletions(deletions) {
            const mateDeletions = deletions.get(Token.MateNode);
            const connectorDeletions = deletions.get(Token.Connector);
            this.rebuildDependencies =
                this.rebuildDependencies || mateDeletions.length > 0 || connectorDeletions.length > 0;
        }
        beforeUpdates(changes) {
            //determine if mate dependencies need to be rebuilt
            const mateChanges = changes.get(Token.MateNode);
            const connectorChanges = changes.get(Token.Connector);
            const meshChanges = changes.get(Token.SpaceNode);
            this.rebuildDependencies =
                this.rebuildDependencies ||
                    mateChanges.some(m => m.changes.hasAny('connector1', 'connector2', 'enabled')) ||
                    connectorChanges.some(c => c.changes.has('enabled')) ||
                    meshChanges.some(c => c.changes.hasAny('fixed', '_primeMover'));
            /**
             * Mates need to be reprocessed if:
             * * the mate itself was changed
             * * connector1 of the node was changed
             * * parent node of connector1 was changed
             * * any ancestor space node of the parent node was changed
             * * any parent graph dependency node mate or it's parents were changed
             */
        }
        afterUpdates(changes) {
            if (this.rebuildDependencies) {
                this.buildDependencies();
            }
            if (this.sortedMates) {
                if (changes.has(Token.MateNode) ||
                    changes.has(Token.SpaceNode) ||
                    changes.has(Token.Connector) ||
                    changes.has(Token.Feature)) {
                    for (const mate of this.sortedMates) {
                        //don't process the last mate in a cycle
                        if (!this.cycles || !this.cycles.some(c => c.last() === mate)) {
                            this.processMate(mate);
                        }
                    }
                }
            }
        }
        dispose() {
            if (this.sortedMates)
                this.sortedMates.clear();
            if (this.cycles)
                this.cycles.clear();
        }
        processMate(mate) {
            let c1 = mate.getC1();
            let c2 = mate.getC2();
            /**
             * If the sorter determined we need to swap the connectors.
             * */
            if (mate._swap || c2.positionMode === exports.eConnectorPositionMode.moveAlongSketch) {
                const temp = c1;
                c1 = c2;
                c2 = temp;
            }
            const c1Mesh = this.getConnectorMesh(c1);
            const c2Mesh = this.getConnectorMesh(c2);
            const followerNode = c2._parent;
            const followerMesh = this.viewer.rendererManager.mesh.get3d(followerNode);
            if (!c1Mesh || !c2Mesh)
                return;
            /**
             * Move along sketch connectors cannot be moved, because their position is being set by the sketch itself. They can only be used
             * to determine the position of other connectors. Moving them will cause an immediate overconstraint condition
             */
            if (c2.positionMode === exports.eConnectorPositionMode.moveAlongSketch) {
                return;
            }
            if (isSketchControlPoint(c2)) {
                const cp = c2;
                this.viewer.pauseRenderWhile(() => {
                    const nodeWithTransform = mateControlPointToConnector(mate, c1Mesh, c2Mesh);
                    const d1 = nodeWithTransform.direction.scale(cp.direction.length());
                    const d2 = cp.direction2 ? nodeWithTransform.direction.scale(cp.direction2.length()) : undefined;
                    if (!nodeWithTransform.position.equalsWithEpsilon(cp.position.toVec3()) ||
                        !d1.equalsWithEpsilon(cp.direction.toVec3()) ||
                        (cp.direction2 && d2 && !d2.equalsWithEpsilon(cp.direction2.toVec3()))) {
                        this.afterCleanup(() => {
                            cp.position = exports.KbVector.FromVec3(nodeWithTransform.position);
                            cp.direction = exports.KbVector.FromVec3(d1);
                            if (cp.direction2 && d2) {
                                cp.direction2 = exports.KbVector.FromVec3(d2);
                            }
                        });
                    }
                });
            }
            else if (followerMesh) {
                this.viewer.pauseRenderWhile(() => {
                    const originalFollowerMeshAbsPos = followerMesh.getAbsolutePosition();
                    const originalFollowerMeshAbsQuat = followerMesh.absoluteRotationQuaternion.clone();
                    const originalFollowerMeshLocalPos = followerMesh.position.clone();
                    const originalFollowerMeshLocalQuat = followerMesh.rotationQuaternion.clone();
                    mateConnectors(mate, followerMesh, c1Mesh, c2Mesh);
                    /** update real kb3d nodes with new transform info */
                    if (!originalFollowerMeshLocalPos.equalsWithEpsilon(followerMesh.position) ||
                        !originalFollowerMeshLocalQuat.equalsWithEpsilon(followerMesh.rotationQuaternion)) {
                        followerNode.trackChanges(false);
                        followerNode.setRotationQuaternion(exports.KbQuaternion.FromQuat(followerMesh.rotationQuaternion));
                        followerNode.position = exports.KbVector.FromVec3(followerMesh.position);
                        followerNode.trackChanges(true);
                        this.referenceProcessor.triggerChangesOnReferencers(followerNode, new Map([['position', null]]));
                    }
                    /** invalidate bounding box of parent if follower mesh actually moved */
                    if (!originalFollowerMeshAbsPos.equalsWithEpsilon(followerMesh.getAbsolutePosition()) ||
                        !originalFollowerMeshAbsQuat.equalsWithEpsilon(followerMesh.absoluteRotationQuaternion)) {
                        this.viewer.bbCache.invalidate(c2.getSpaceParent());
                    }
                    //console.log(`mate '${mate.name} processed`);
                });
            }
        }
        getConnectorMesh(c) {
            if (isSketchControlPoint(c)) {
                return this.controlPointRenderer.get3d(c);
            }
            else if (isConnector(c)) {
                return this.connectorRenderer.get3d(c);
            }
        }
        buildDependencies() {
            const mates = this.getValidMates();
            const sortResult = sortMates(mates);
            this.sortedMates = sortResult.sorted;
            this.cycles = sortResult.cycles;
            const validator = this.viewer.options.validator;
            for (const cycle of sortResult.cycles) {
                const err = `${CYCLE_ERROR_START}${cycle.map(n => n.name).join(' -> ')}`;
                if (validator) {
                    for (const cm of cycle) {
                        validator.addError(cm, '', err);
                    }
                }
                else {
                    console.warn(err);
                }
            }
            if (validator) {
                for (const om of sortResult.overConstrained) {
                    validator.addError(om, '', `Cannot have more than one fixed node in the mate chain`);
                }
            }
            else {
                if (sortResult.overConstrained.length) {
                    console.warn(`Mates overconstrained: [${sortResult.overConstrained.map(n => n.name).join(', ')}]`);
                }
            }
        }
        /**
         * gets all mates (including those in nested scenes)
         * that are enabled, and have valid references to connectors
         */
        getValidMates() {
            const rootScene = this.viewer.sceneNode;
            const mates = new Array();
            const validator = this.viewer.options.validator;
            rootScene.runOnAllScenes(s => {
                const sceneMates = s._manager.getByToken(Token.MateNode);
                for (const m of sceneMates) {
                    if (m.isActive()) {
                        mates.push(m);
                    }
                    //regardless, clear out cycle validation
                    if (validator) {
                        validator.clearProp(m, '');
                    }
                }
            });
            return mates;
        }
    }

    class CircularPatternRenderer extends PatternRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.CircularPatternFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const featurePivot = feature.pivot.toVec3();
            const featureAxis = feature.axis.toVec3();
            // Don't allow a zero vector for an axis because it will blow up the math
            if (featureAxis.equalsToFloats(0, 0, 0)) {
                featureAxis.set(0, 1, 0);
            }
            const featureArc = (feature.arc * Math.PI) / 180 / feature.count;
            const workingQuaternion = Quaternion.Identity();
            return super.updateMeshGeometry(feature, vertexData, vertexDataChanges, (idx, particle) => {
                particle.pivot = featurePivot;
                Quaternion.RotationAxisToRef(featureAxis, featureArc * idx, workingQuaternion);
                particle.rotationQuaternion.multiplyInPlace(workingQuaternion);
            });
        }
    }

    class DeleteFacesRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.DeleteFacesFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            if (newVertexData.indices && feature.vertexGroups.length > 0) {
                const vertexGroups = feature.vertexGroups.sort((groupA, groupB) => groupA.startIndex - groupB.startIndex);
                const newIndices = new Int32Array(newVertexData.indices);
                let currReadIndex = 0;
                vertexGroups.forEach(vertexGroup => {
                    for (let i = Math.max(vertexGroup.startIndex, currReadIndex); i < Math.min(vertexGroup.endIndex, newIndices.length); i++) {
                        newIndices[i] = -1;
                    }
                    currReadIndex = vertexGroup.endIndex;
                });
                // We need to remove submeshes targetting the indices that are being removed as well
                if (newVertexData.submeshData) {
                    newVertexData.submeshData.forEach(submeshData => {
                        const indexStart = submeshData.indexStart;
                        for (let i = 0; i < indexStart; i++) {
                            if (newIndices[i] === -1) {
                                submeshData.indexStart--;
                            }
                        }
                        const indexCount = submeshData.indexCount;
                        for (let i = 0; i < indexCount; i++) {
                            const index = indexStart + i;
                            if (newIndices[index] === -1) {
                                submeshData.indexCount--;
                            }
                        }
                    });
                }
                newVertexData.indices = newIndices.filter(index => index !== -1);
            }
            return newVertexData;
        }
        update3dInternal() { }
    }

    class DisplacementMapRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.DisplacementMapFeature;
            this.textureCanvas = document.createElement('canvas');
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const textureRenderer = this.viewer.rendererManager.textures;
            if (feature.textures && feature.textures.length > 0) {
                //create context
                const context = this.textureCanvas.getContext('2d', {
                    willReadFrequently: true,
                });
                const strength = 1;
                const hasTransparency = false;
                const textureLayers = textureRenderer.getActiveLayers(feature, exports.eTextureChannel.albedo).filter(node => {
                    const renderer = textureRenderer.getRenderer(node);
                    return renderer.textureHasContent(node);
                });
                if (context) {
                    const baseImageSize = textureRenderer
                        .getRenderer(feature.textures[0])
                        .getNativeSize(feature.textures[0]);
                    const parameters = { strength, hasTransparency, nativeSize: baseImageSize };
                    if (this.scene.getEngine().webGLVersion < 2) {
                        const clampedSize = getBinClampedSize(baseImageSize.width, baseImageSize.height);
                        context.canvas.width = clampedSize;
                        context.canvas.height = clampedSize;
                    }
                    else {
                        if (feature.textures[0]) {
                            context.canvas.width = baseImageSize.width;
                            context.canvas.height = baseImageSize.height;
                        }
                    }
                    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
                    const paintedImage = textureRenderer.paintTextureOnCanvas(textureLayers, context, parameters);
                    const tempVertexData = new SubmeshVertexData();
                    tempVertexData.copyFrom(newVertexData);
                    if (tempVertexData.uvs) {
                        const n = tempVertexData.uvs.length;
                        for (let i = 1; i < n; i += 2) {
                            tempVertexData.uvs[i] = 1 - tempVertexData.uvs[i];
                        }
                        const mesh = this.viewer.getRendererNode(feature._parent);
                        const meshUpdated = new Mesh('ExistingMesh');
                        tempVertexData.applyToMesh(meshUpdated, true);
                        ensureNormalsExist(meshUpdated);
                        const imageData = paintedImage === null || paintedImage === void 0 ? void 0 : paintedImage.getImageData(0, 0, this.textureCanvas.width, this.textureCanvas.height, mesh);
                        if (imageData) {
                            this.displace(imageData, feature.minDisplacement, feature.maxDisplacement, meshUpdated);
                        }
                        const meshVertexData = VertexData.ExtractFromMesh(meshUpdated);
                        newVertexData.positions = meshVertexData.positions;
                        newVertexData.normals = meshVertexData.normals;
                        meshUpdated.dispose();
                    }
                }
            }
            return newVertexData;
        }
        update3dInternal() { }
        displace(context, minDisplacement, maxDisplacement, parentMesh) {
            const uInt8Array = new Uint8Array(context.data);
            parentMesh.applyDisplacementMapFromBuffer(uInt8Array, context.width, context.height, minDisplacement, maxDisplacement);
        }
    }

    const xztoxy = Matrix.FromArray([1, 0, 0, 0, 0, 0, -1, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    class ExtrudeRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.ExtrudeFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const parentMesh = feature._parent;
            if (parentMesh &&
                newVertexData.positions &&
                newVertexData.positions.length &&
                // paths are used by parseSketchGeometry
                newVertexData.paths &&
                newVertexData.paths.length > 0 &&
                feature.size !== 0) {
                const { segments, holes } = parseSketchGeometry(newVertexData);
                const extrudedMeshes = [];
                for (let i = 0; i < segments.length; i++) {
                    const shape = segments[i];
                    const shapeHoles = holes.get(i);
                    const sketch = feature._parent && isSketchNode(feature._parent) ? feature._parent : undefined;
                    const sketchNormal = sketch ? axisToVector3(sketch.normal) : Vector3.Zero();
                    if (sketch && sketch.normal !== exports.eAxis.z) {
                        sketchNormal.scaleInPlace(-1);
                    }
                    const rotToZ = rotationToVector(sketchNormal, new Vector3(0, 0, 1));
                    const pathTransformToZ = new Matrix();
                    const pathTransformToZInv = new Matrix();
                    rotToZ.toRotationMatrix(pathTransformToZ);
                    pathTransformToZ.invertToRef(pathTransformToZInv);
                    for (let i = 0; i < shape.length; i++) {
                        Vector3.TransformCoordinatesToRef(shape[i], pathTransformToZ, shape[i]);
                    }
                    const shape2d = shape.map(point => new Vector2(point.x, point.y));
                    const builder = new PolygonMeshBuilder(feature._dynamicId, shape2d, this.scene, earcut$1);
                    if (shapeHoles) {
                        shapeHoles.forEach(holePoints => {
                            for (let i = 0; i < holePoints.length; i++) {
                                Vector3.TransformCoordinatesToRef(holePoints[i], pathTransformToZ, holePoints[i]);
                            }
                            const hole2d = holePoints.map(point => new Vector2(point.x, point.y));
                            builder.addHole(hole2d);
                        });
                    }
                    const extruded = builder.build(true, Math.abs(feature.size), 0.9);
                    xztoxy.multiplyToRef(pathTransformToZInv, pathTransformToZInv);
                    extruded.bakeTransformIntoVertices(pathTransformToZInv);
                    extrudedMeshes.push(extruded);
                }
                const extrudedAll = Mesh.MergeMeshes(extrudedMeshes, true);
                if (extrudedAll) {
                    applyExtrusion(newVertexData, extrudedAll, false);
                    extrudedAll.dispose();
                }
            }
            return newVertexData;
        }
        getSketchShape(positions) {
            const shape = [];
            for (let i = 0; i < positions.length; i += 3) {
                const newPoint = new Vector3(positions[i], positions[i + 1], positions[i + 2]);
                if (shape.length === 0 || !shape[shape.length - 1].equals(newPoint)) {
                    shape.push(newPoint);
                }
            }
            return shape;
        }
        update3dInternal() { }
    }
    function applyExtrusion(newVertexData, extruded, reverse = false) {
        if (extruded.geometry) {
            // Store the indices used for the extrude so that they can be merged into the new geometry
            const newIndices = extruded.geometry.getIndices(false, true);
            const newNormals = extruded.geometry.getVerticesData(VertexBuffer.NormalKind, false, true);
            const newUvs = extruded.geometry.getVerticesData(VertexBuffer.UVKind, false, true);
            const newPositions = extruded.geometry.getVerticesData(VertexBuffer.PositionKind, false, true);
            if (newPositions && reverse) {
                for (let i = 2; i < newPositions.length; i += 3) {
                    newPositions[i] = -newPositions[i];
                }
            }
            normalizeGeometry(newVertexData);
            if (!newVertexData.indices) {
                newVertexData.indices = newIndices;
            }
            else if (newIndices) {
                const concatArr = new Int32Array(newVertexData.indices.length + newIndices.length);
                concatArr.set(newVertexData.indices);
                if (newVertexData.positions) {
                    const pushAmount = newVertexData.positions.length / 3;
                    for (let i = 0; i < newIndices.length; i++) {
                        newIndices[i] += pushAmount;
                    }
                }
                concatArr.set(newIndices, newVertexData.indices.length);
                newVertexData.indices = concatArr;
            }
            if (!newVertexData.positions) {
                newVertexData.positions = newPositions;
            }
            else if (newPositions) {
                const concatArr = new Float32Array(newVertexData.positions.length + newPositions.length);
                concatArr.set(newVertexData.positions);
                concatArr.set(newPositions, newVertexData.positions.length);
                newVertexData.positions = concatArr;
            }
            if (!newVertexData.normals) {
                newVertexData.normals = newNormals;
            }
            else if (newNormals) {
                const concatArr = new Float32Array(newVertexData.normals.length + newNormals.length);
                concatArr.set(newVertexData.normals);
                concatArr.set(newNormals, newVertexData.normals.length);
                newVertexData.normals = concatArr;
            }
            if (!newVertexData.uvs) {
                newVertexData.uvs = newUvs;
            }
            else if (newUvs) {
                const concatArr = new Float32Array(newVertexData.uvs.length + newUvs.length);
                concatArr.set(newVertexData.uvs);
                concatArr.set(newUvs, newVertexData.uvs.length);
                newVertexData.uvs = concatArr;
            }
            const baseMaterialIndex = newVertexData.submeshData ? newVertexData.submeshData[0].materialIndex : 0;
            const totalIndicesResultCount = newVertexData.indices.length;
            const totalVerticesResultCount = newVertexData.positions.length / 3;
            newVertexData.submeshData = [];
            newVertexData.submeshData.push({
                materialIndex: baseMaterialIndex,
                verticesStart: 0,
                verticesCount: totalVerticesResultCount,
                indexStart: 0,
                indexCount: totalIndicesResultCount,
            });
        }
    }
    function normalizeGeometry(newVertexData) {
        if (!newVertexData.indices) {
            // If there are no indices, throw away existing vertices because they won't be used
            newVertexData.positions = null;
            newVertexData.normals = null;
            newVertexData.uvs = null;
        }
        else {
            const indices = newVertexData.indices;
            let maxIdx = 0;
            for (let i = 0; i < indices.length; i++) {
                if (maxIdx < indices[i]) {
                    maxIdx = indices[i];
                }
            }
            const usedVertexLength = maxIdx + 1;
            const positions = new Float32Array(usedVertexLength * 3);
            const normals = new Float32Array(usedVertexLength * 3);
            const uvs = new Float32Array(usedVertexLength * 2);
            if (newVertexData.positions) {
                if (Array.isArray(newVertexData.positions)) {
                    positions.set(newVertexData.positions.slice(0, positions.length));
                }
                else {
                    positions.set(newVertexData.positions.subarray(0, positions.length));
                }
            }
            if (newVertexData.normals) {
                if (Array.isArray(newVertexData.normals)) {
                    normals.set(newVertexData.normals.slice(0, normals.length));
                }
                else {
                    normals.set(newVertexData.normals.subarray(0, normals.length));
                }
            }
            if (newVertexData.uvs) {
                if (Array.isArray(newVertexData.uvs)) {
                    uvs.set(newVertexData.uvs.slice(0, uvs.length));
                }
                else {
                    uvs.set(newVertexData.uvs.subarray(0, uvs.length));
                }
            }
            newVertexData.positions = positions;
            newVertexData.normals = normals;
            newVertexData.uvs = uvs;
        }
    }

    /**
     * Unique ID when we import meshes from Babylon to CSG
     */
    let currentCSGMeshId = 0;
    /**
     * Represents a vertex of a polygon. Use your own vertex class instead of this
     * one to provide additional features like texture coordinates and vertex
     * colors. Custom vertex classes need to provide a `pos` property and `clone()`,
     * `flip()`, and `interpolate()` methods that behave analogous to the ones
     * defined by `BABYLON.CSG.Vertex`. This class provides `normal` so convenience
     * functions like `BABYLON.CSG.sphere()` can return a smooth vertex normal, but `normal`
     * is not used anywhere else.
     * Same goes for uv, it allows to keep the original vertex uv coordinates of the 2 meshes
     */
    class Vertex {
        /**
         * Initializes the vertex
         * @param pos The position of the vertex
         * @param normal The normal of the vertex
         * @param uv The texture coordinate of the vertex
         * @param vertColor The RGBA color of the vertex
         */
        constructor(
        /**
         * The position of the vertex
         */
        pos, 
        /**
         * The normal of the vertex
         */
        normal, 
        /**
         * The texture coordinate of the vertex
         */
        uv, 
        /**
         * The texture coordinate of the vertex
         */
        vertColor) {
            this.pos = pos;
            this.normal = normal;
            this.uv = uv;
            this.vertColor = vertColor;
        }
        /**
         * Make a clone, or deep copy, of the vertex
         * @returns A new Vertex
         */
        clone() {
            var _a, _b;
            return new Vertex(this.pos.clone(), this.normal.clone(), (_a = this.uv) === null || _a === void 0 ? void 0 : _a.clone(), (_b = this.vertColor) === null || _b === void 0 ? void 0 : _b.clone());
        }
        /**
         * Invert all orientation-specific data (e.g. vertex normal). Called when the
         * orientation of a polygon is flipped.
         */
        flip() {
            this.normal = this.normal.scale(-1);
        }
        /**
         * Create a new vertex between this vertex and `other` by linearly
         * interpolating all properties using a parameter of `t`. Subclasses should
         * override this to interpolate additional properties.
         * @param other the vertex to interpolate against
         * @param t The factor used to linearly interpolate between the vertices
         */
        interpolate(other, t) {
            return new Vertex(Vector3.Lerp(this.pos, other.pos, t), Vector3.Lerp(this.normal, other.normal, t), this.uv && other.uv ? Vector2.Lerp(this.uv, other.uv, t) : undefined, this.vertColor && other.vertColor ? Color4.Lerp(this.vertColor, other.vertColor, t) : undefined);
        }
    }
    /**
     * Represents a plane in 3D space.
     */
    class Plane$1 {
        /**
         * Initializes the plane
         * @param normal The normal for the plane
         * @param w
         */
        constructor(normal, w) {
            this.normal = normal;
            this.w = w;
        }
        /**
         * Construct a plane from three points
         * @param a Point a
         * @param b Point b
         * @param c Point c
         */
        static FromPoints(a, b, c) {
            const v0 = c.subtract(a);
            const v1 = b.subtract(a);
            if (v0.lengthSquared() === 0 || v1.lengthSquared() === 0) {
                return null;
            }
            const n = Vector3.Normalize(Vector3.Cross(v0, v1));
            return new Plane$1(n, Vector3.Dot(n, a));
        }
        /**
         * Clone, or make a deep copy of the plane
         * @returns a new Plane
         */
        clone() {
            return new Plane$1(this.normal.clone(), this.w);
        }
        /**
         * Flip the face of the plane
         */
        flip() {
            this.normal.scaleInPlace(-1);
            this.w = -this.w;
        }
        /**
         * Split `polygon` by this plane if needed, then put the polygon or polygon
         * fragments in the appropriate lists. Coplanar polygons go into either
        `* coplanarFront` or `coplanarBack` depending on their orientation with
         * respect to this plane. Polygons in front or in back of this plane go into
         * either `front` or `back`
         * @param polygon The polygon to be split
         * @param coplanarFront Will contain polygons coplanar with the plane that are oriented to the front of the plane
         * @param coplanarBack Will contain polygons coplanar with the plane that are oriented to the back of the plane
         * @param front Will contain the polygons in front of the plane
         * @param back Will contain the polygons begind the plane
         */
        splitPolygon(polygon, coplanarFront, coplanarBack, front, back) {
            const COPLANAR = 0;
            const FRONT = 1;
            const BACK = 2;
            const SPANNING = 3;
            // Classify each point as well as the entire polygon into one of the above
            // four classes.
            let polygonType = 0;
            const types = [];
            let i;
            let t;
            for (i = 0; i < polygon.vertices.length; i++) {
                t = Vector3.Dot(this.normal, polygon.vertices[i].pos) - this.w;
                const type = t < -Plane$1.EPSILON ? BACK : t > Plane$1.EPSILON ? FRONT : COPLANAR;
                polygonType |= type;
                types.push(type);
            }
            // Put the polygon in the correct list, splitting it when necessary
            switch (polygonType) {
                case COPLANAR:
                    (Vector3.Dot(this.normal, polygon.plane.normal) > 0 ? coplanarFront : coplanarBack).push(polygon);
                    break;
                case FRONT:
                    front.push(polygon);
                    break;
                case BACK:
                    back.push(polygon);
                    break;
                case SPANNING: {
                    const f = [], b = [];
                    for (i = 0; i < polygon.vertices.length; i++) {
                        const j = (i + 1) % polygon.vertices.length;
                        const ti = types[i], tj = types[j];
                        const vi = polygon.vertices[i], vj = polygon.vertices[j];
                        if (ti !== BACK) {
                            f.push(vi);
                        }
                        if (ti !== FRONT) {
                            b.push(ti !== BACK ? vi.clone() : vi);
                        }
                        if ((ti | tj) === SPANNING) {
                            t = (this.w - Vector3.Dot(this.normal, vi.pos)) / Vector3.Dot(this.normal, vj.pos.subtract(vi.pos));
                            const v = vi.interpolate(vj, t);
                            f.push(v);
                            b.push(v.clone());
                        }
                    }
                    let poly;
                    if (f.length >= 3) {
                        poly = new Polygon(f, polygon.shared);
                        if (poly.plane) {
                            front.push(poly);
                        }
                    }
                    if (b.length >= 3) {
                        poly = new Polygon(b, polygon.shared);
                        if (poly.plane) {
                            back.push(poly);
                        }
                    }
                    break;
                }
            }
        }
    }
    /**
     * `CSG.Plane.EPSILON` is the tolerance used by `splitPolygon()` to decide if a
     * point is on the plane
     */
    Plane$1.EPSILON = 1e-5;
    /**
     * Represents a convex polygon. The vertices used to initialize a polygon must
     * be coplanar and form a convex loop.
     *
     * Each convex polygon has a `shared` property, which is shared between all
     * polygons that are clones of each other or were split from the same polygon.
     * This can be used to define per-polygon properties (such as surface color)
     */
    class Polygon {
        /**
         * Initializes the polygon
         * @param vertices The vertices of the polygon
         * @param shared The properties shared across all polygons
         */
        constructor(vertices, shared) {
            this.vertices = vertices;
            this.shared = shared;
            this.plane = Plane$1.FromPoints(vertices[0].pos, vertices[1].pos, vertices[2].pos);
        }
        /**
         * Clones, or makes a deep copy, or the polygon
         */
        clone() {
            const vertices = this.vertices.map((v) => v.clone());
            return new Polygon(vertices, this.shared);
        }
        /**
         * Flips the faces of the polygon
         */
        flip() {
            this.vertices.reverse().map((v) => {
                v.flip();
            });
            this.plane.flip();
        }
    }
    /**
     * Holds a node in a BSP tree. A BSP tree is built from a collection of polygons
     * by picking a polygon to split along. That polygon (and all other coplanar
     * polygons) are added directly to that node and the other polygons are added to
     * the front and/or back subtrees. This is not a leafy BSP tree since there is
     * no distinction between internal and leaf nodes
     */
    class Node$2 {
        /**
         * Initializes the node
         * @param polygons A collection of polygons held in the node
         */
        constructor(polygons) {
            this._plane = null;
            this._front = null;
            this._back = null;
            this._polygons = new Array();
            if (polygons) {
                this.build(polygons);
            }
        }
        /**
         * Clones, or makes a deep copy, of the node
         * @returns The cloned node
         */
        clone() {
            const node = new Node$2();
            node._plane = this._plane && this._plane.clone();
            node._front = this._front && this._front.clone();
            node._back = this._back && this._back.clone();
            node._polygons = this._polygons.map((p) => p.clone());
            return node;
        }
        /**
         * Convert solid space to empty space and empty space to solid space
         */
        invert() {
            for (let i = 0; i < this._polygons.length; i++) {
                this._polygons[i].flip();
            }
            if (this._plane) {
                this._plane.flip();
            }
            if (this._front) {
                this._front.invert();
            }
            if (this._back) {
                this._back.invert();
            }
            const temp = this._front;
            this._front = this._back;
            this._back = temp;
        }
        /**
         * Recursively remove all polygons in `polygons` that are inside this BSP
         * tree.
         * @param polygons Polygons to remove from the BSP
         * @returns Polygons clipped from the BSP
         */
        clipPolygons(polygons) {
            if (!this._plane) {
                return polygons.slice();
            }
            let front = new Array(), back = new Array();
            for (let i = 0; i < polygons.length; i++) {
                this._plane.splitPolygon(polygons[i], front, back, front, back);
            }
            if (this._front) {
                front = this._front.clipPolygons(front);
            }
            if (this._back) {
                back = this._back.clipPolygons(back);
            }
            else {
                back = [];
            }
            return front.concat(back);
        }
        /**
         * Remove all polygons in this BSP tree that are inside the other BSP tree
         * `bsp`.
         * @param bsp BSP containing polygons to remove from this BSP
         */
        clipTo(bsp) {
            this._polygons = bsp.clipPolygons(this._polygons);
            if (this._front) {
                this._front.clipTo(bsp);
            }
            if (this._back) {
                this._back.clipTo(bsp);
            }
        }
        /**
         * Return a list of all polygons in this BSP tree
         * @returns List of all polygons in this BSP tree
         */
        allPolygons() {
            let polygons = this._polygons.slice();
            if (this._front) {
                polygons = polygons.concat(this._front.allPolygons());
            }
            if (this._back) {
                polygons = polygons.concat(this._back.allPolygons());
            }
            return polygons;
        }
        /**
         * Build a BSP tree out of `polygons`. When called on an existing tree, the
         * new polygons are filtered down to the bottom of the tree and become new
         * nodes there. Each set of polygons is partitioned using the first polygon
         * (no heuristic is used to pick a good split)
         * @param polygons Polygons used to construct the BSP tree
         */
        build(polygons) {
            if (!polygons.length) {
                return;
            }
            if (!this._plane) {
                this._plane = polygons[0].plane.clone();
            }
            const front = new Array(), back = new Array();
            for (let i = 0; i < polygons.length; i++) {
                this._plane.splitPolygon(polygons[i], this._polygons, this._polygons, front, back);
            }
            if (front.length) {
                if (!this._front) {
                    this._front = new Node$2();
                }
                this._front.build(front);
            }
            if (back.length) {
                if (!this._back) {
                    this._back = new Node$2();
                }
                this._back.build(back);
            }
        }
    }
    /**
     * Class for building Constructive Solid Geometry
     */
    class CSG {
        constructor() {
            this._polygons = new Array();
        }
        /**
         * Convert the Mesh to CSG
         * @param mesh The Mesh to convert to CSG
         * @param absolute If true, the final (local) matrix transformation is set to the identity and not to that of `mesh`. It can help when dealing with right-handed meshes (default: false)
         * @returns A new CSG from the Mesh
         */
        static FromMesh(mesh, absolute = false) {
            let vertex, normal, uv = undefined, position, vertColor = undefined, polygon, vertices;
            const polygons = new Array();
            let matrix, meshPosition, meshRotation, meshRotationQuaternion = null, meshScaling;
            let invertWinding = false;
            if (mesh instanceof Mesh) {
                mesh.computeWorldMatrix(true);
                matrix = mesh.getWorldMatrix();
                meshPosition = mesh.position.clone();
                meshRotation = mesh.rotation.clone();
                if (mesh.rotationQuaternion) {
                    meshRotationQuaternion = mesh.rotationQuaternion.clone();
                }
                meshScaling = mesh.scaling.clone();
                if (mesh.material && absolute) {
                    invertWinding = mesh.material.sideOrientation === 0;
                }
            }
            else {
                throw "BABYLON.CSG: Wrong Mesh type, must be BABYLON.Mesh";
            }
            const indices = mesh.getIndices(), positions = mesh.getVerticesData(VertexBuffer.PositionKind), normals = mesh.getVerticesData(VertexBuffer.NormalKind), uvs = mesh.getVerticesData(VertexBuffer.UVKind), vertColors = mesh.getVerticesData(VertexBuffer.ColorKind);
            const subMeshes = mesh.subMeshes;
            for (let sm = 0, sml = subMeshes.length; sm < sml; sm++) {
                for (let i = subMeshes[sm].indexStart, il = subMeshes[sm].indexCount + subMeshes[sm].indexStart; i < il; i += 3) {
                    vertices = [];
                    for (let j = 0; j < 3; j++) {
                        const indexIndices = j === 0 ? i + j : invertWinding ? i + 3 - j : i + j;
                        const sourceNormal = new Vector3(normals[indices[indexIndices] * 3], normals[indices[indexIndices] * 3 + 1], normals[indices[indexIndices] * 3 + 2]);
                        if (uvs) {
                            uv = new Vector2(uvs[indices[indexIndices] * 2], uvs[indices[indexIndices] * 2 + 1]);
                        }
                        if (vertColors) {
                            vertColor = new Color4(vertColors[indices[indexIndices] * 4], vertColors[indices[indexIndices] * 4 + 1], vertColors[indices[indexIndices] * 4 + 2], vertColors[indices[indexIndices] * 4 + 3]);
                        }
                        const sourcePosition = new Vector3(positions[indices[indexIndices] * 3], positions[indices[indexIndices] * 3 + 1], positions[indices[indexIndices] * 3 + 2]);
                        position = Vector3.TransformCoordinates(sourcePosition, matrix);
                        normal = Vector3.TransformNormal(sourceNormal, matrix);
                        vertex = new Vertex(position, normal, uv, vertColor);
                        vertices.push(vertex);
                    }
                    polygon = new Polygon(vertices, { subMeshId: sm, meshId: currentCSGMeshId, materialIndex: subMeshes[sm].materialIndex });
                    // To handle the case of degenerated triangle
                    // polygon.plane == null <=> the polygon does not represent 1 single plane <=> the triangle is degenerated
                    if (polygon.plane) {
                        polygons.push(polygon);
                    }
                }
            }
            const csg = CSG._FromPolygons(polygons);
            csg.matrix = absolute ? Matrix.Identity() : matrix;
            csg.position = absolute ? Vector3.Zero() : meshPosition;
            csg.rotation = absolute ? Vector3.Zero() : meshRotation;
            csg.scaling = absolute ? Vector3.One() : meshScaling;
            csg.rotationQuaternion = absolute && meshRotationQuaternion ? Quaternion.Identity() : meshRotationQuaternion;
            currentCSGMeshId++;
            return csg;
        }
        /**
         * Construct a CSG solid from a list of `CSG.Polygon` instances.
         * @param polygons Polygons used to construct a CSG solid
         */
        static _FromPolygons(polygons) {
            const csg = new CSG();
            csg._polygons = polygons;
            return csg;
        }
        /**
         * Clones, or makes a deep copy, of the CSG
         * @returns A new CSG
         */
        clone() {
            const csg = new CSG();
            csg._polygons = this._polygons.map((p) => p.clone());
            csg.copyTransformAttributes(this);
            return csg;
        }
        /**
         * Unions this CSG with another CSG
         * @param csg The CSG to union against this CSG
         * @returns The unioned CSG
         */
        union(csg) {
            const a = new Node$2(this.clone()._polygons);
            const b = new Node$2(csg.clone()._polygons);
            a.clipTo(b);
            b.clipTo(a);
            b.invert();
            b.clipTo(a);
            b.invert();
            a.build(b.allPolygons());
            return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
        }
        /**
         * Unions this CSG with another CSG in place
         * @param csg The CSG to union against this CSG
         */
        unionInPlace(csg) {
            const a = new Node$2(this._polygons);
            const b = new Node$2(csg._polygons);
            a.clipTo(b);
            b.clipTo(a);
            b.invert();
            b.clipTo(a);
            b.invert();
            a.build(b.allPolygons());
            this._polygons = a.allPolygons();
        }
        /**
         * Subtracts this CSG with another CSG
         * @param csg The CSG to subtract against this CSG
         * @returns A new CSG
         */
        subtract(csg) {
            const a = new Node$2(this.clone()._polygons);
            const b = new Node$2(csg.clone()._polygons);
            a.invert();
            a.clipTo(b);
            b.clipTo(a);
            b.invert();
            b.clipTo(a);
            b.invert();
            a.build(b.allPolygons());
            a.invert();
            return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
        }
        /**
         * Subtracts this CSG with another CSG in place
         * @param csg The CSG to subtract against this CSG
         */
        subtractInPlace(csg) {
            const a = new Node$2(this._polygons);
            const b = new Node$2(csg._polygons);
            a.invert();
            a.clipTo(b);
            b.clipTo(a);
            b.invert();
            b.clipTo(a);
            b.invert();
            a.build(b.allPolygons());
            a.invert();
            this._polygons = a.allPolygons();
        }
        /**
         * Intersect this CSG with another CSG
         * @param csg The CSG to intersect against this CSG
         * @returns A new CSG
         */
        intersect(csg) {
            const a = new Node$2(this.clone()._polygons);
            const b = new Node$2(csg.clone()._polygons);
            a.invert();
            b.clipTo(a);
            b.invert();
            a.clipTo(b);
            b.clipTo(a);
            a.build(b.allPolygons());
            a.invert();
            return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
        }
        /**
         * Intersects this CSG with another CSG in place
         * @param csg The CSG to intersect against this CSG
         */
        intersectInPlace(csg) {
            const a = new Node$2(this._polygons);
            const b = new Node$2(csg._polygons);
            a.invert();
            b.clipTo(a);
            b.invert();
            a.clipTo(b);
            b.clipTo(a);
            a.build(b.allPolygons());
            a.invert();
            this._polygons = a.allPolygons();
        }
        /**
         * Return a new CSG solid with solid and empty space switched. This solid is
         * not modified.
         * @returns A new CSG solid with solid and empty space switched
         */
        inverse() {
            const csg = this.clone();
            csg.inverseInPlace();
            return csg;
        }
        /**
         * Inverses the CSG in place
         */
        inverseInPlace() {
            this._polygons.map((p) => {
                p.flip();
            });
        }
        /**
         * This is used to keep meshes transformations so they can be restored
         * when we build back a Babylon Mesh
         * NB : All CSG operations are performed in world coordinates
         * @param csg The CSG to copy the transform attributes from
         * @returns This CSG
         */
        copyTransformAttributes(csg) {
            this.matrix = csg.matrix;
            this.position = csg.position;
            this.rotation = csg.rotation;
            this.scaling = csg.scaling;
            this.rotationQuaternion = csg.rotationQuaternion;
            return this;
        }
        /**
         * Build Raw mesh from CSG
         * Coordinates here are in world space
         * @param name The name of the mesh geometry
         * @param scene The Scene
         * @param keepSubMeshes Specifies if the submeshes should be kept
         * @returns A new Mesh
         */
        buildMeshGeometry(name, scene, keepSubMeshes) {
            const matrix = this.matrix.clone();
            matrix.invert();
            const mesh = new Mesh(name, scene);
            const vertices = [];
            const indices = [];
            const normals = [];
            let uvs = null;
            let vertColors = null;
            const vertex = Vector3.Zero();
            const normal = Vector3.Zero();
            const uv = Vector2.Zero();
            const vertColor = new Color4(0, 0, 0, 0);
            const polygons = this._polygons;
            const polygonIndices = [0, 0, 0];
            let polygon;
            const vertice_dict = {};
            let vertex_idx;
            let currentIndex = 0;
            const subMeshDict = {};
            let subMeshObj;
            if (keepSubMeshes) {
                // Sort Polygons, since subMeshes are indices range
                polygons.sort((a, b) => {
                    if (a.shared.meshId === b.shared.meshId) {
                        return a.shared.subMeshId - b.shared.subMeshId;
                    }
                    else {
                        return a.shared.meshId - b.shared.meshId;
                    }
                });
            }
            for (let i = 0, il = polygons.length; i < il; i++) {
                polygon = polygons[i];
                // Building SubMeshes
                if (!subMeshDict[polygon.shared.meshId]) {
                    subMeshDict[polygon.shared.meshId] = {};
                }
                if (!subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId]) {
                    subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId] = {
                        indexStart: +Infinity,
                        indexEnd: -Infinity,
                        materialIndex: polygon.shared.materialIndex,
                    };
                }
                subMeshObj = subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId];
                for (let j = 2, jl = polygon.vertices.length; j < jl; j++) {
                    polygonIndices[0] = 0;
                    polygonIndices[1] = j - 1;
                    polygonIndices[2] = j;
                    for (let k = 0; k < 3; k++) {
                        vertex.copyFrom(polygon.vertices[polygonIndices[k]].pos);
                        normal.copyFrom(polygon.vertices[polygonIndices[k]].normal);
                        if (polygon.vertices[polygonIndices[k]].uv) {
                            if (!uvs) {
                                uvs = [];
                            }
                            uv.copyFrom(polygon.vertices[polygonIndices[k]].uv);
                        }
                        if (polygon.vertices[polygonIndices[k]].vertColor) {
                            if (!vertColors) {
                                vertColors = [];
                            }
                            vertColor.copyFrom(polygon.vertices[polygonIndices[k]].vertColor);
                        }
                        const localVertex = Vector3.TransformCoordinates(vertex, matrix);
                        const localNormal = Vector3.TransformNormal(normal, matrix);
                        vertex_idx = vertice_dict[localVertex.x + "," + localVertex.y + "," + localVertex.z];
                        let areUvsDifferent = false;
                        if (uvs && !(uvs[vertex_idx * 2] === uv.x || uvs[vertex_idx * 2 + 1] === uv.y)) {
                            areUvsDifferent = true;
                        }
                        let areColorsDifferent = false;
                        if (vertColors &&
                            !(vertColors[vertex_idx * 4] === vertColor.r ||
                                vertColors[vertex_idx * 4 + 1] === vertColor.g ||
                                vertColors[vertex_idx * 4 + 2] === vertColor.b ||
                                vertColors[vertex_idx * 4 + 3] === vertColor.a)) {
                            areColorsDifferent = true;
                        }
                        // Check if 2 points can be merged
                        if (!(typeof vertex_idx !== "undefined" &&
                            normals[vertex_idx * 3] === localNormal.x &&
                            normals[vertex_idx * 3 + 1] === localNormal.y &&
                            normals[vertex_idx * 3 + 2] === localNormal.z) ||
                            areUvsDifferent ||
                            areColorsDifferent) {
                            vertices.push(localVertex.x, localVertex.y, localVertex.z);
                            if (uvs) {
                                uvs.push(uv.x, uv.y);
                            }
                            normals.push(normal.x, normal.y, normal.z);
                            if (vertColors) {
                                vertColors.push(vertColor.r, vertColor.g, vertColor.b, vertColor.a);
                            }
                            vertex_idx = vertice_dict[localVertex.x + "," + localVertex.y + "," + localVertex.z] = vertices.length / 3 - 1;
                        }
                        indices.push(vertex_idx);
                        subMeshObj.indexStart = Math.min(currentIndex, subMeshObj.indexStart);
                        subMeshObj.indexEnd = Math.max(currentIndex, subMeshObj.indexEnd);
                        currentIndex++;
                    }
                }
            }
            mesh.setVerticesData(VertexBuffer.PositionKind, vertices);
            mesh.setVerticesData(VertexBuffer.NormalKind, normals);
            if (uvs) {
                mesh.setVerticesData(VertexBuffer.UVKind, uvs);
            }
            if (vertColors) {
                mesh.setVerticesData(VertexBuffer.ColorKind, vertColors);
            }
            mesh.setIndices(indices, null);
            if (keepSubMeshes) {
                // We offset the materialIndex by the previous number of materials in the CSG mixed meshes
                let materialIndexOffset = 0, materialMaxIndex;
                mesh.subMeshes = new Array();
                for (const m in subMeshDict) {
                    materialMaxIndex = -1;
                    for (const sm in subMeshDict[m]) {
                        subMeshObj = subMeshDict[m][sm];
                        SubMesh.CreateFromIndices(subMeshObj.materialIndex + materialIndexOffset, subMeshObj.indexStart, subMeshObj.indexEnd - subMeshObj.indexStart + 1, mesh);
                        materialMaxIndex = Math.max(subMeshObj.materialIndex, materialMaxIndex);
                    }
                    materialIndexOffset += ++materialMaxIndex;
                }
            }
            return mesh;
        }
        /**
         * Build Mesh from CSG taking material and transforms into account
         * @param name The name of the Mesh
         * @param material The material of the Mesh
         * @param scene The Scene
         * @param keepSubMeshes Specifies if submeshes should be kept
         * @returns The new Mesh
         */
        toMesh(name, material = null, scene, keepSubMeshes) {
            const mesh = this.buildMeshGeometry(name, scene, keepSubMeshes);
            mesh.material = material;
            mesh.position.copyFrom(this.position);
            mesh.rotation.copyFrom(this.rotation);
            if (this.rotationQuaternion) {
                mesh.rotationQuaternion = this.rotationQuaternion.clone();
            }
            mesh.scaling.copyFrom(this.scaling);
            mesh.computeWorldMatrix(true);
            return mesh;
        }
    }

    function createJoinGeometryVisualization(targetMesh, scene, color) {
        const visualization = targetMesh;
        if (!color) {
            color = Color3.Yellow();
        }
        const coloredMaterial = new StandardMaterial('', scene);
        //coloredMaterial.alpha = 0.5;
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;
        visualization.material = coloredMaterial;
        return visualization;
    }

    const joinedMeshes = new Map();
    class JoinGeometryRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.JoinGeometryFeature;
            this.bbSubscriptions = new Map();
            this.targetMeshVisualizationMap = new Map();
            this.parentMeshVisualizationMap = new Map();
            this.previewLayer = this.viewer.utilityLayer;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const targetMesh = joinedMeshes.get(feature._dynamicId);
            const thisMesh = this.viewer.getRendererNode(feature._parent);
            if (targetMesh instanceof Mesh &&
                thisMesh instanceof Mesh &&
                targetMesh.geometry &&
                targetMesh.geometry.getTotalIndices() > 0 &&
                targetMesh != thisMesh) {
                const workingVertexData = vertexData.shallowClone();
                const tempMesh = new Mesh('csg-temp');
                tempMesh.doNotSerialize = true;
                SubmeshVertexData.CopyToRef(newVertexData, workingVertexData);
                if (!workingVertexData.positions || !workingVertexData.indices) {
                    throw 'Invalid geometry';
                }
                const targetTransform = thisMesh.computeWorldMatrix(true);
                workingVertexData.applyToMesh(tempMesh);
                let previewMesh = this.parentMeshVisualizationMap.get(feature.id);
                if (!previewMesh) {
                    const newMeshInstance = new Mesh('preview-mesh');
                    newMeshInstance.doNotSerialize = true;
                    workingVertexData.applyToMesh(newMeshInstance);
                    this.parentMeshVisualizationMap.set(feature.id, newMeshInstance);
                    if (newMeshInstance instanceof Mesh) {
                        previewMesh = createJoinGeometryVisualization(newMeshInstance, this.previewLayer.utilityLayerScene, Color3.Yellow());
                        this.parentMeshVisualizationMap.set(feature.id, previewMesh);
                        previewMesh.setEnabled(false);
                        if (feature._parent) {
                            const featureParentMesh = this.viewer.getRendererNode(feature._parent);
                            newMeshInstance.position.addInPlace(featureParentMesh.absolutePosition);
                        }
                    }
                }
                ensureNormalsExist(tempMesh);
                const resultCsg = CSG.FromMesh(tempMesh);
                const targetMeshMatchTransform = targetMesh.clone();
                const targetMeshTransform = targetMeshMatchTransform.computeWorldMatrix(true);
                targetMeshMatchTransform.parent = null;
                targetTransform.invert();
                targetMeshTransform.multiplyToRef(targetTransform, targetMeshTransform);
                targetMeshMatchTransform.rotationQuaternion = new Quaternion();
                targetMeshTransform.decompose(targetMeshMatchTransform.scaling, targetMeshMatchTransform.rotationQuaternion, targetMeshMatchTransform.position);
                try {
                    const opCsg = CSG.FromMesh(targetMeshMatchTransform);
                    if (feature.joinType === exports.eJoinType.cut) {
                        resultCsg.subtractInPlace(opCsg);
                    }
                    else if (feature.joinType === exports.eJoinType.intersect) {
                        resultCsg.intersectInPlace(opCsg);
                    }
                    else if (feature.joinType === exports.eJoinType.union) {
                        resultCsg.unionInPlace(opCsg);
                    }
                }
                catch (e) {
                    console.warn('Could not merge geometry for join ' + feature.name, e);
                    return newVertexData;
                }
                if (resultCsg) {
                    const resultMeshCsg = resultCsg.toMesh('temp2', null, undefined, true);
                    const resultVertexData = SubmeshVertexData.ExtractFromMesh(resultMeshCsg);
                    newVertexData.positions = resultVertexData.positions;
                    if (newVertexData.normals) {
                        newVertexData.normals = resultVertexData.normals;
                    }
                    if (newVertexData.uvs) {
                        newVertexData.uvs = resultVertexData.uvs;
                    }
                    newVertexData.indices = resultVertexData.indices;
                    // Sometimes the CSG will add another material to the multiMaterial to represent the cut face. Change that material to be the base material, otherwise it will be black.
                    const existingMaterials = new Set();
                    // get a list of all the materials that are already in the multiMaterial
                    if (newVertexData.submeshData) {
                        newVertexData.submeshData.forEach(submeshData => {
                            existingMaterials.add(submeshData.materialIndex);
                        });
                    }
                    if (resultVertexData.submeshData) {
                        resultVertexData.submeshData.forEach(submeshData => {
                            if (!existingMaterials.has(submeshData.materialIndex)) {
                                submeshData.materialIndex = 0;
                            }
                        });
                    }
                    newVertexData.submeshData = resultVertexData.submeshData;
                    resultMeshCsg.dispose();
                }
                tempMesh.dispose();
                targetMeshMatchTransform.dispose();
            }
            return newVertexData;
        }
        updatePreviewMesh(node) {
            let featureInstance = this.targetMeshVisualizationMap.get(node.id);
            const scene = this.previewLayer.utilityLayerScene;
            const targetMesh = joinedMeshes.get(node._dynamicId);
            if (targetMesh && !featureInstance) {
                featureInstance = createJoinGeometryVisualization(targetMesh.clone(), scene, Color3.Yellow());
                featureInstance.isPickable = false;
                featureInstance.setEnabled(false);
                this.targetMeshVisualizationMap.set(node.id, featureInstance);
                return featureInstance;
            }
            else if (targetMesh) {
                this.deleteTargetMeshVisualization(node);
                featureInstance = createJoinGeometryVisualization(targetMesh.clone(), scene, Color3.Yellow());
                featureInstance.isPickable = false;
                featureInstance.setEnabled(false);
                this.targetMeshVisualizationMap.set(node.id, featureInstance);
                return featureInstance;
            }
        }
        update3dInternal(feature) {
            var _a;
            if (feature.changes.hasAny('meshId', 'enabled')) {
                const existingSubscription = this.bbSubscriptions.get(feature._dynamicId);
                if (existingSubscription) {
                    existingSubscription.unsubscribe();
                }
                if (feature.enabled) {
                    const targetMeshNode = (_a = feature._manager) === null || _a === void 0 ? void 0 : _a.getById(feature.meshId);
                    if (targetMeshNode && targetMeshNode instanceof exports.MeshNode) {
                        // if this is a custom mesh node and the geometry isn't loaded, we have to load it
                        if (targetMeshNode instanceof exports.CustomMeshNode &&
                            targetMeshNode.hasGeometry &&
                            !targetMeshNode.geometryLoaded) {
                            this.viewer.rendererManager.mesh.loadNewGeometry(targetMeshNode);
                        }
                        const targetMesh = this.viewer.getRendererNode(targetMeshNode);
                        if (targetMesh instanceof Mesh && feature._parent) {
                            joinedMeshes.set(feature._dynamicId, targetMesh);
                            this.bbSubscriptions.set(feature._dynamicId, 
                            // TODO This should also watch the parent group for positional changes, otherwise the join won't update when the feature's parent mesh moves.
                            // But watch out for infinite loops
                            this.viewer.bbCache.watchForChanges(targetMeshNode).subscribe(() => {
                                feature.setPropertyIsModified('meshId', true);
                            }));
                        }
                        else {
                            console.warn('Could not create CSG for join geometry');
                        }
                    }
                }
            }
            let featureInstance = this.targetMeshVisualizationMap.get(feature.id);
            const originalMesh = this.parentMeshVisualizationMap.get(feature.id);
            if (feature._previewVisible) {
                featureInstance = this.updatePreviewMesh(feature);
            }
            if (feature._previewVisible && feature.enabled) {
                if (feature.joinType === exports.eJoinType.cut) {
                    originalMesh === null || originalMesh === void 0 ? void 0 : originalMesh.setEnabled(false);
                    featureInstance === null || featureInstance === void 0 ? void 0 : featureInstance.setEnabled(true);
                }
                else if (feature.joinType === exports.eJoinType.intersect) {
                    originalMesh === null || originalMesh === void 0 ? void 0 : originalMesh.setEnabled(true);
                    featureInstance === null || featureInstance === void 0 ? void 0 : featureInstance.setEnabled(true);
                }
                else {
                    originalMesh === null || originalMesh === void 0 ? void 0 : originalMesh.setEnabled(false);
                    featureInstance === null || featureInstance === void 0 ? void 0 : featureInstance.setEnabled(false);
                }
            }
            else {
                originalMesh === null || originalMesh === void 0 ? void 0 : originalMesh.setEnabled(false);
                featureInstance === null || featureInstance === void 0 ? void 0 : featureInstance.setEnabled(false);
            }
        }
        delete3d(feature, preserveCache) {
            var _a;
            if (!preserveCache) {
                joinedMeshes.delete(feature._dynamicId);
            }
            (_a = this.bbSubscriptions.get(feature._dynamicId)) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this.bbSubscriptions.delete(feature._dynamicId);
            this.deleteTargetMeshVisualization(feature);
            const targetMeshCopy = this.parentMeshVisualizationMap.get(feature.id);
            targetMeshCopy === null || targetMeshCopy === void 0 ? void 0 : targetMeshCopy.dispose(false, true);
            this.parentMeshVisualizationMap.delete(feature.id);
            super.delete3d(feature);
        }
        deleteTargetMeshVisualization(feature) {
            const previewMesh = this.targetMeshVisualizationMap.get(feature.id);
            previewMesh === null || previewMesh === void 0 ? void 0 : previewMesh.dispose(false, true);
            this.targetMeshVisualizationMap.delete(feature.id);
        }
        dispose() {
            this.bbSubscriptions.forEach(s => {
                s.unsubscribe();
            });
            this.bbSubscriptions.clear();
            joinedMeshes.clear();
            super.dispose();
        }
    }

    class LinearPatternRenderer extends PatternRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.LinearPatternFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const featureTranslation = feature.translation.toVec3();
            const workingVector = Vector3.Zero();
            return super.updateMeshGeometry(feature, vertexData, vertexDataChanges, (idx, particle) => {
                if (!feature.meshId) {
                    workingVector.copyFrom(featureTranslation).scaleInPlace(idx);
                }
                particle.position.addInPlace(workingVector);
            });
        }
    }

    function createMirrorVisualization(mirror, scene, color) {
        if (!color) {
            color = Color3.Yellow();
        }
        const mirrorVisualization = MeshBuilder.CreatePlane('mirrorPlane', {}, scene);
        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;
        mirrorVisualization.material = coloredMaterial;
        mirrorVisualization.isPickable = false;
        mirrorVisualization.setEnabled(true);
        return mirrorVisualization;
    }

    class SliceFeatureRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.SliceFeature;
            this.previewLayer = this.viewer.utilityLayer;
            this.babylonMirrorPreviewsMap = new Map();
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            if (newVertexData.positions &&
                newVertexData.positions.length > 0 &&
                newVertexData.indices &&
                newVertexData.indices.length > 0) {
                const positions = newVertexData.positions;
                const normals = newVertexData.normals;
                const uvs = newVertexData.uvs;
                const indices = newVertexData.indices;
                const triCount = indices.length / 3;
                const positionsCount = positions.length / 3;
                const planeNormal = feature.normal.toVec3();
                const planePoint = feature.intersect.toVec3();
                const newPositions = [];
                const newNormals = [];
                const newUvs = [];
                const newIndices = [];
                const preSliceSubmeshes = newVertexData.submeshData;
                const newSubmeshes = preSliceSubmeshes.map(submesh => ({ ...submesh }));
                const edgeSplits = []; // which vertices are part of how many edges being split
                const edgeStart = Vector3.Zero();
                const edgeDir = Vector3.Zero();
                const workingVector = Vector3.Zero();
                let j;
                for (let i = 0; i < triCount; i++) {
                    let hit = 0;
                    let d = 0;
                    let vertexIndex = -1;
                    for (j = 0; j < 3; j++) {
                        const iA = j, iB = (j + 1) % 3;
                        const vA = indices[i * 3 + iA], vB = indices[i * 3 + iB];
                        if (vertexIndex === -1) {
                            vertexIndex = vA;
                        }
                        edgeStart.set(positions[vA * 3], positions[vA * 3 + 1], positions[vA * 3 + 2]);
                        edgeStart.subtractFromFloatsToRef(positions[vB * 3], positions[vB * 3 + 1], positions[vB * 3 + 2], edgeDir);
                        edgeDir.scaleInPlace(-1);
                        const lnDot = Vector3.Dot(planeNormal, edgeDir);
                        if (lnDot === 0) {
                            continue;
                        }
                        planePoint.subtractToRef(edgeStart, workingVector);
                        d = Vector3.Dot(workingVector, planeNormal) / lnDot;
                        // Expect floating point errors. don't want unnecessary tiny triangles
                        // If d is between 0 and 1, then the plane hit the edge
                        if (d > 1e-12 && d < 1 - 1e-12) {
                            hit++;
                            edgeSplits[iA] = (edgeSplits[iA] || 0) + 1;
                            edgeSplits[iB] = (edgeSplits[iB] || 0) + 1;
                            edgeDir.scaleInPlace(d);
                            edgeStart.addToRef(edgeDir, workingVector);
                            newPositions.push(workingVector.x, workingVector.y, workingVector.z);
                            if (normals) {
                                workingVector.set(normals[vA * 3], normals[vA * 3 + 1], normals[vA * 3 + 2]);
                                workingVector.scaleInPlace(1 - d);
                                workingVector.addInPlaceFromFloats(normals[vB * 3] * d, normals[vB * 3 + 1] * d, normals[vB * 3 + 2] * d);
                                newNormals.push(workingVector.x, workingVector.y, workingVector.z);
                            }
                            if (uvs) {
                                workingVector.set(uvs[vA * 2], uvs[vA * 2 + 1], 0);
                                workingVector.scaleInPlace(1 - d);
                                workingVector.addInPlaceFromFloats(uvs[vB * 2] * d, uvs[vB * 2 + 1] * d, 0);
                                newUvs.push(workingVector.x, workingVector.y);
                            }
                        }
                    }
                    if (hit) {
                        // divide the triangle here
                        if (hit === 1) {
                            const split = positionsCount - 1 + newPositions.length / 3;
                            if (!edgeSplits[0]) {
                                newIndices.push(indices[i * 3], indices[i * 3 + 1], split, indices[i * 3], split, indices[i * 3 + 2]);
                            }
                            else if (!edgeSplits[1]) {
                                newIndices.push(indices[i * 3], indices[i * 3 + 1], split, indices[i * 3 + 1], indices[i * 3 + 2], split);
                            }
                            else {
                                newIndices.push(indices[i * 3], split, indices[i * 3 + 2], indices[i * 3 + 1], indices[i * 3 + 2], split);
                            }
                            newSubmeshes.forEach((submeshData, sI) => {
                                const preSliceSubmesh = preSliceSubmeshes[sI];
                                if (preSliceSubmesh.indexStart <= i * 3 &&
                                    preSliceSubmesh.indexStart + preSliceSubmesh.indexCount > i * 3) {
                                    submeshData.indexCount += 3;
                                }
                                else if (preSliceSubmesh.indexStart > i * 3) {
                                    submeshData.indexStart += 3;
                                }
                            });
                        }
                        if (hit === 2) {
                            const aSplit = positionsCount - 1 + newPositions.length / 3 - 1, bSplit = positionsCount - 1 + newPositions.length / 3;
                            newIndices.push(indices[i * 3]);
                            newIndices.push(aSplit);
                            newIndices.push(bSplit);
                            if (edgeSplits[0] === 2) {
                                newIndices.push(indices[i * 3 + 1], bSplit, aSplit, indices[i * 3 + 2], bSplit, indices[i * 3 + 1]);
                            }
                            else if (edgeSplits[1] === 2) {
                                newIndices.push(indices[i * 3 + 2], indices[i * 3], bSplit, indices[i * 3 + 1], bSplit, aSplit);
                            }
                            else {
                                newIndices.push(indices[i * 3 + 1], aSplit, indices[i * 3], indices[i * 3 + 2], bSplit, aSplit);
                            }
                            newSubmeshes.forEach((submeshData, sI) => {
                                const preSliceSubmesh = preSliceSubmeshes[sI];
                                if (preSliceSubmesh.indexStart <= i * 3 &&
                                    preSliceSubmesh.indexStart + preSliceSubmesh.indexCount > i * 3) {
                                    submeshData.indexCount += 6;
                                }
                                else if (preSliceSubmesh.indexStart > i * 3) {
                                    submeshData.indexStart += 6;
                                }
                            });
                        }
                        edgeSplits.clear();
                        hit = 0;
                    }
                    else {
                        // if(feature.removeGeometry && d > 1 - 1e-12) {
                        //     // If this face is in front of the face relative to the face normal, cull it
                        //     newSubmeshes.forEach(submeshData => {
                        //         if(submeshData.indexStart <= i && submeshData.indexStart + submeshData.indexCount > i) {
                        //             submeshData.indexCount -= 3;
                        //         } else if(submeshData.indexStart > i) {
                        //             submeshData.indexStart -= 3;
                        //         }
                        //     });
                        //     continue;
                        // } else {
                        //     console.log(d);
                        // }
                        newIndices.push(indices[i * 3], indices[i * 3 + 1], indices[i * 3 + 2]);
                    }
                    // Update the vertices the submeshes are targetting
                    if (vertexIndex !== -1 && hit > 0) {
                        newSubmeshes.forEach(submeshData => {
                            if (submeshData.verticesStart <= vertexIndex &&
                                submeshData.verticesStart + submeshData.verticesCount > vertexIndex) {
                                submeshData.verticesCount += hit;
                            }
                            else if (submeshData.verticesStart > vertexIndex) {
                                submeshData.verticesStart += hit;
                            }
                        });
                    }
                }
                newVertexData.indices = new Int32Array(newIndices);
                newVertexData.positions = new Float32Array(positions.length + newPositions.length);
                newVertexData.positions.set(positions);
                newVertexData.positions.set(newPositions, positions.length);
                if (normals) {
                    newVertexData.normals = new Float32Array(normals.length + newNormals.length);
                    newVertexData.normals.set(normals);
                    newVertexData.normals.set(newNormals, normals.length);
                }
                if (uvs) {
                    newVertexData.uvs = new Float32Array(uvs.length + newUvs.length);
                    newVertexData.uvs.set(uvs);
                    newVertexData.uvs.set(newUvs, uvs.length);
                }
                // Remove geometry on one side of the plane if the removeGeometry flag is true
                const baseGeometryVertexLength = positions.length / 3;
                if (feature.removeGeometry) {
                    const indices = newVertexData.indices;
                    const positions = newVertexData.positions;
                    const normals = newVertexData.normals;
                    const uvs = newVertexData.uvs;
                    const newIndices = new Int32Array(indices.length);
                    const newPositions = new Float32Array(positions.length);
                    const newNormals = new Float32Array((normals === null || normals === void 0 ? void 0 : normals.length) || 0);
                    const newUvs = new Float32Array((uvs === null || uvs === void 0 ? void 0 : uvs.length) || 0);
                    const triCount = indices.length / 3;
                    const vertexCount = positions.length / 3;
                    const newPositionIndex = new Int32Array(vertexCount);
                    // Keep track of how many positions we've used
                    let position = 0;
                    for (let i = 0; i < vertexCount; i++) {
                        workingVector.set(positions[i * 3], positions[i * 3 + 1], positions[i * 3 + 2]);
                        workingVector.subtractInPlace(planePoint);
                        const d = Vector3.Dot(workingVector, planeNormal);
                        // Don't remove new vertices that were created from the slice, those are guaranteed to be good
                        if (i < baseGeometryVertexLength && d > 1e-12) {
                            // Mark the original indices that have been removed so we can update the index array
                            newPositionIndex[i] = -1;
                        }
                        else {
                            // Copy over the vertex data we need and mark what new index they will have
                            newPositionIndex[i] = position;
                            newPositions[position * 3] = positions[i * 3];
                            newPositions[position * 3 + 1] = positions[i * 3 + 1];
                            newPositions[position * 3 + 2] = positions[i * 3 + 2];
                            if (normals) {
                                newNormals[position * 3] = normals[i * 3];
                                newNormals[position * 3 + 1] = normals[i * 3 + 1];
                                newNormals[position * 3 + 2] = normals[i * 3 + 2];
                            }
                            if (uvs) {
                                newUvs[position * 2] = uvs[i * 2];
                                newUvs[position * 2 + 1] = uvs[i * 2 + 1];
                            }
                            position++;
                        }
                    }
                    // Trim off unused parts of the vertex arrays
                    newVertexData.positions = newPositions.subarray(0, position * 3);
                    if (normals) {
                        newVertexData.normals = newNormals.subarray(0, position * 3);
                    }
                    if (uvs) {
                        newVertexData.uvs = newUvs.subarray(0, position * 2);
                    }
                    position = 0;
                    const originalSubmeshes = newSubmeshes.map(submesh => ({ ...submesh }));
                    for (let i = 0; i < triCount; i++) {
                        // If all of the positions in this triangle are being kept, add the triangle
                        // The indices of the vertexes are changing so we need to use the value that we calculated prior
                        if (newPositionIndex[indices[i * 3]] >= 0 &&
                            newPositionIndex[indices[i * 3 + 1]] >= 0 &&
                            newPositionIndex[indices[i * 3 + 2]] >= 0) {
                            newIndices[position * 3] = newPositionIndex[indices[i * 3]];
                            newIndices[position * 3 + 1] = newPositionIndex[indices[i * 3 + 1]];
                            newIndices[position * 3 + 2] = newPositionIndex[indices[i * 3 + 2]];
                            position++;
                        }
                        else {
                            newSubmeshes.forEach((submeshData, sI) => {
                                const originalSubmesh = originalSubmeshes[sI];
                                if (originalSubmesh.indexStart <= i * 3 &&
                                    originalSubmesh.indexStart + originalSubmesh.indexCount > i * 3) {
                                    submeshData.indexCount -= 3;
                                }
                                else if (originalSubmesh.indexStart > i * 3) {
                                    submeshData.indexStart -= 3;
                                }
                            });
                        }
                    }
                    // Update the vertex values on the submeshes as well
                    for (let i = 0; i < newPositionIndex.length; i++) {
                        if (newPositionIndex[i] === -1) {
                            newSubmeshes.forEach(submeshData => {
                                if (submeshData.verticesStart <= i &&
                                    submeshData.verticesStart + submeshData.verticesCount > i) {
                                    submeshData.verticesCount--;
                                }
                                else if (submeshData.verticesStart > i) {
                                    submeshData.verticesStart--;
                                }
                            });
                        }
                    }
                    newVertexData.indices = newIndices.subarray(0, position * 3);
                }
                newVertexData.submeshData = newSubmeshes;
            }
            return newVertexData;
        }
        updatePreviewMesh(feature) {
            const scene = this.previewLayer.utilityLayerScene;
            let visualizationPlane = this.babylonMirrorPreviewsMap.get(feature.id);
            if (!visualizationPlane) {
                visualizationPlane = createMirrorVisualization(feature, scene);
                visualizationPlane.isPickable = false;
                this.babylonMirrorPreviewsMap.set(feature.id, visualizationPlane);
            }
            const currentNormal = new Vector3();
            currentNormal.set(0, 0, 1);
            const newNormal = new Vector3();
            newNormal.set(feature.normal.x, feature.normal.y, feature.normal.z);
            visualizationPlane.rotationQuaternion = rotationToVector(newNormal, currentNormal);
            let parentBoundingBox = undefined;
            if (feature._parent) {
                parentBoundingBox = this.viewer.getMeshBoundingBox(feature._parent);
            }
            if (parentBoundingBox) {
                const scale = parentBoundingBox.minWorld.subtract(parentBoundingBox.maxWorld).length();
                visualizationPlane.scaling.set(scale, scale, scale);
            }
            if (feature._parent) {
                const featureParent = this.viewer.getRendererNode(feature._parent);
                const meshPosition = featureParent.getAbsolutePosition();
                meshPosition.addInPlace(feature.intersect.toVec3());
                visualizationPlane.position.set(meshPosition.x, meshPosition.y, meshPosition.z);
            }
        }
        update3dInternal(node) {
            const visualizationPlane = this.babylonMirrorPreviewsMap.get(node.id);
            if (node._previewVisible) {
                this.updatePreviewMesh(node);
                if (node.enabled) {
                    visualizationPlane === null || visualizationPlane === void 0 ? void 0 : visualizationPlane.setEnabled(true);
                }
            }
            else {
                visualizationPlane === null || visualizationPlane === void 0 ? void 0 : visualizationPlane.setEnabled(false);
            }
        }
        delete3d(node) {
            if (this.babylonMirrorPreviewsMap) {
                const featureInstance = this.babylonMirrorPreviewsMap.get(node.id);
                if (featureInstance) {
                    featureInstance.dispose(false, true);
                }
                this.babylonMirrorPreviewsMap.delete(node.id);
            }
            super.delete3d(node);
        }
    }

    class MirrorFeatureRenderer extends SliceFeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.MirrorFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            if (newVertexData.positions &&
                newVertexData.positions.length > 0 &&
                newVertexData.indices &&
                newVertexData.indices.length > 0) {
                const positions = newVertexData.positions;
                const normals = newVertexData.normals;
                const uvs = newVertexData.uvs;
                const indices = newVertexData.indices;
                const newIndices = new Int32Array(indices.length);
                const newPositions = new Float32Array(positions.length);
                const newNormals = new Float32Array((normals === null || normals === void 0 ? void 0 : normals.length) || 0);
                const workingVector = Vector3.Zero();
                const planeNormal = feature.normal.toVec3().normalize();
                const planeIntersect = feature.intersect.toVec3();
                const vertexCount = positions.length / 3;
                for (let i = 0; i < vertexCount; i++) {
                    const idx = i * 3;
                    workingVector.set(positions[idx], positions[idx + 1], positions[idx + 2]);
                    workingVector.subtractInPlace(planeIntersect);
                    let d = Vector3.Dot(workingVector, planeNormal);
                    planeNormal.scaleAndAddToRef(-2 * d, workingVector);
                    newPositions[idx] = workingVector.x + planeIntersect.x;
                    newPositions[idx + 1] = workingVector.y + planeIntersect.y;
                    newPositions[idx + 2] = workingVector.z + planeIntersect.z;
                    if (normals) {
                        workingVector.set(normals[idx], normals[idx + 1], normals[idx + 2]);
                        d = Vector3.Dot(workingVector, planeNormal);
                        planeNormal.scaleAndAddToRef(-2 * d, workingVector);
                        newNormals[idx] = workingVector.x;
                        newNormals[idx + 1] = workingVector.y;
                        newNormals[idx + 2] = workingVector.z;
                    }
                }
                // Flip the direction of the triangles so that the normals face the right way
                const triCount = indices.length / 3;
                for (let i = 0; i < triCount; i++) {
                    const idx = i * 3;
                    if (feature.cloneGeometry) {
                        newIndices[idx] = vertexCount + indices[idx + 2];
                        newIndices[idx + 1] = vertexCount + indices[idx + 1];
                        newIndices[idx + 2] = vertexCount + indices[idx];
                    }
                    else {
                        newIndices[idx] = indices[idx + 2];
                        newIndices[idx + 1] = indices[idx + 1];
                        newIndices[idx + 2] = indices[idx];
                    }
                }
                if (feature.cloneGeometry) {
                    const combinedIndices = new Int32Array(indices.length * 2);
                    const combinedPositions = new Float32Array(positions.length * 2);
                    const combinedNormals = new Float32Array(((normals === null || normals === void 0 ? void 0 : normals.length) || 0) * 2);
                    const combinedUvs = new Float32Array(((uvs === null || uvs === void 0 ? void 0 : uvs.length) || 0) * 2);
                    const combinedSubmeshes = [];
                    combinedIndices.set(indices);
                    combinedIndices.set(newIndices, indices.length);
                    combinedPositions.set(positions);
                    combinedPositions.set(newPositions, positions.length);
                    if (normals) {
                        combinedNormals.set(normals);
                        combinedNormals.set(newNormals, normals.length);
                    }
                    if (uvs) {
                        combinedUvs.set(uvs);
                        combinedUvs.set(uvs, uvs.length);
                    }
                    if (newVertexData.submeshData) {
                        newVertexData.submeshData.forEach(submesh => {
                            const newSubmesh = {
                                ...submesh,
                                verticesStart: submesh.verticesStart + vertexCount,
                                indexStart: submesh.indexStart + indices.length,
                            };
                            combinedSubmeshes.push(submesh, newSubmesh);
                        });
                    }
                    newVertexData.indices = combinedIndices;
                    newVertexData.positions = combinedPositions;
                    if (normals) {
                        newVertexData.normals = combinedNormals;
                    }
                    if (uvs) {
                        newVertexData.uvs = combinedUvs;
                    }
                    newVertexData.submeshData = combinedSubmeshes;
                }
                else {
                    newVertexData.indices = newIndices;
                    newVertexData.positions = newPositions;
                    if (normals) {
                        newVertexData.normals = newNormals;
                    }
                }
            }
            return newVertexData;
        }
    }

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    var t=function(r,e){return (t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,r){t.__proto__=r;}||function(t,r){for(var e in r)Object.prototype.hasOwnProperty.call(r,e)&&(t[e]=r[e]);})(r,e)};function r(r,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function i(){this.constructor=r;}t(r,e),r.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i);}function e(t){var r="";Array.isArray(t)||(t=[t]);for(var e=0;e<t.length;e++){var i=t[e];if(i.type===_.CLOSE_PATH)r+="z";else if(i.type===_.HORIZ_LINE_TO)r+=(i.relative?"h":"H")+i.x;else if(i.type===_.VERT_LINE_TO)r+=(i.relative?"v":"V")+i.y;else if(i.type===_.MOVE_TO)r+=(i.relative?"m":"M")+i.x+" "+i.y;else if(i.type===_.LINE_TO)r+=(i.relative?"l":"L")+i.x+" "+i.y;else if(i.type===_.CURVE_TO)r+=(i.relative?"c":"C")+i.x1+" "+i.y1+" "+i.x2+" "+i.y2+" "+i.x+" "+i.y;else if(i.type===_.SMOOTH_CURVE_TO)r+=(i.relative?"s":"S")+i.x2+" "+i.y2+" "+i.x+" "+i.y;else if(i.type===_.QUAD_TO)r+=(i.relative?"q":"Q")+i.x1+" "+i.y1+" "+i.x+" "+i.y;else if(i.type===_.SMOOTH_QUAD_TO)r+=(i.relative?"t":"T")+i.x+" "+i.y;else {if(i.type!==_.ARC)throw new Error('Unexpected command type "'+i.type+'" at index '+e+".");r+=(i.relative?"a":"A")+i.rX+" "+i.rY+" "+i.xRot+" "+ +i.lArcFlag+" "+ +i.sweepFlag+" "+i.x+" "+i.y;}}return r}function i$1(t,r){var e=t[0],i=t[1];return [e*Math.cos(r)-i*Math.sin(r),e*Math.sin(r)+i*Math.cos(r)]}function a(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];for(var e=0;e<t.length;e++)if("number"!=typeof t[e])throw new Error("assertNumbers arguments["+e+"] is not a number. "+typeof t[e]+" == typeof "+t[e]);return !0}var n=Math.PI;function o(t,r,e){t.lArcFlag=0===t.lArcFlag?0:1,t.sweepFlag=0===t.sweepFlag?0:1;var a=t.rX,o=t.rY,s=t.x,u=t.y;a=Math.abs(t.rX),o=Math.abs(t.rY);var h=i$1([(r-s)/2,(e-u)/2],-t.xRot/180*n),c=h[0],y=h[1],p=Math.pow(c,2)/Math.pow(a,2)+Math.pow(y,2)/Math.pow(o,2);1<p&&(a*=Math.sqrt(p),o*=Math.sqrt(p)),t.rX=a,t.rY=o;var m=Math.pow(a,2)*Math.pow(y,2)+Math.pow(o,2)*Math.pow(c,2),O=(t.lArcFlag!==t.sweepFlag?1:-1)*Math.sqrt(Math.max(0,(Math.pow(a,2)*Math.pow(o,2)-m)/m)),l=a*y/o*O,T=-o*c/a*O,v=i$1([l,T],t.xRot/180*n);t.cX=v[0]+(r+s)/2,t.cY=v[1]+(e+u)/2,t.phi1=Math.atan2((y-T)/o,(c-l)/a),t.phi2=Math.atan2((-y-T)/o,(-c-l)/a),0===t.sweepFlag&&t.phi2>t.phi1&&(t.phi2-=2*n),1===t.sweepFlag&&t.phi2<t.phi1&&(t.phi2+=2*n),t.phi1*=180/n,t.phi2*=180/n;}function s(t,r,e){a(t,r,e);var i=t*t+r*r-e*e;if(0>i)return [];if(0===i)return [[t*e/(t*t+r*r),r*e/(t*t+r*r)]];var n=Math.sqrt(i);return [[(t*e+r*n)/(t*t+r*r),(r*e-t*n)/(t*t+r*r)],[(t*e-r*n)/(t*t+r*r),(r*e+t*n)/(t*t+r*r)]]}var u,h=Math.PI/180;function c(t,r,e){return (1-e)*t+e*r}function y(t,r,e,i){return t+Math.cos(i/180*n)*r+Math.sin(i/180*n)*e}function p(t,r,e,i){var a=1e-6,n=r-t,o=e-r,s=3*n+3*(i-e)-6*o,u=6*(o-n),h=3*n;return Math.abs(s)<a?[-h/u]:function(t,r,e){void 0===e&&(e=1e-6);var i=t*t/4-r;if(i<-e)return [];if(i<=e)return [-t/2];var a=Math.sqrt(i);return [-t/2-a,-t/2+a]}(u/s,h/s,a)}function m(t,r,e,i,a){var n=1-a;return t*(n*n*n)+r*(3*n*n*a)+e*(3*n*a*a)+i*(a*a*a)}!function(t){function r(){return u((function(t,r,e){return t.relative&&(void 0!==t.x1&&(t.x1+=r),void 0!==t.y1&&(t.y1+=e),void 0!==t.x2&&(t.x2+=r),void 0!==t.y2&&(t.y2+=e),void 0!==t.x&&(t.x+=r),void 0!==t.y&&(t.y+=e),t.relative=!1),t}))}function e(){var t=NaN,r=NaN,e=NaN,i=NaN;return u((function(a,n,o){return a.type&_.SMOOTH_CURVE_TO&&(a.type=_.CURVE_TO,t=isNaN(t)?n:t,r=isNaN(r)?o:r,a.x1=a.relative?n-t:2*n-t,a.y1=a.relative?o-r:2*o-r),a.type&_.CURVE_TO?(t=a.relative?n+a.x2:a.x2,r=a.relative?o+a.y2:a.y2):(t=NaN,r=NaN),a.type&_.SMOOTH_QUAD_TO&&(a.type=_.QUAD_TO,e=isNaN(e)?n:e,i=isNaN(i)?o:i,a.x1=a.relative?n-e:2*n-e,a.y1=a.relative?o-i:2*o-i),a.type&_.QUAD_TO?(e=a.relative?n+a.x1:a.x1,i=a.relative?o+a.y1:a.y1):(e=NaN,i=NaN),a}))}function n(){var t=NaN,r=NaN;return u((function(e,i,a){if(e.type&_.SMOOTH_QUAD_TO&&(e.type=_.QUAD_TO,t=isNaN(t)?i:t,r=isNaN(r)?a:r,e.x1=e.relative?i-t:2*i-t,e.y1=e.relative?a-r:2*a-r),e.type&_.QUAD_TO){t=e.relative?i+e.x1:e.x1,r=e.relative?a+e.y1:e.y1;var n=e.x1,o=e.y1;e.type=_.CURVE_TO,e.x1=((e.relative?0:i)+2*n)/3,e.y1=((e.relative?0:a)+2*o)/3,e.x2=(e.x+2*n)/3,e.y2=(e.y+2*o)/3;}else t=NaN,r=NaN;return e}))}function u(t){var r=0,e=0,i=NaN,a=NaN;return function(n){if(isNaN(i)&&!(n.type&_.MOVE_TO))throw new Error("path must start with moveto");var o=t(n,r,e,i,a);return n.type&_.CLOSE_PATH&&(r=i,e=a),void 0!==n.x&&(r=n.relative?r+n.x:n.x),void 0!==n.y&&(e=n.relative?e+n.y:n.y),n.type&_.MOVE_TO&&(i=r,a=e),o}}function O(t,r,e,i,n,o){return a(t,r,e,i,n,o),u((function(a,s,u,h){var c=a.x1,y=a.x2,p=a.relative&&!isNaN(h),m=void 0!==a.x?a.x:p?0:s,O=void 0!==a.y?a.y:p?0:u;function l(t){return t*t}a.type&_.HORIZ_LINE_TO&&0!==r&&(a.type=_.LINE_TO,a.y=a.relative?0:u),a.type&_.VERT_LINE_TO&&0!==e&&(a.type=_.LINE_TO,a.x=a.relative?0:s),void 0!==a.x&&(a.x=a.x*t+O*e+(p?0:n)),void 0!==a.y&&(a.y=m*r+a.y*i+(p?0:o)),void 0!==a.x1&&(a.x1=a.x1*t+a.y1*e+(p?0:n)),void 0!==a.y1&&(a.y1=c*r+a.y1*i+(p?0:o)),void 0!==a.x2&&(a.x2=a.x2*t+a.y2*e+(p?0:n)),void 0!==a.y2&&(a.y2=y*r+a.y2*i+(p?0:o));var T=t*i-r*e;if(void 0!==a.xRot&&(1!==t||0!==r||0!==e||1!==i))if(0===T)delete a.rX,delete a.rY,delete a.xRot,delete a.lArcFlag,delete a.sweepFlag,a.type=_.LINE_TO;else {var v=a.xRot*Math.PI/180,f=Math.sin(v),N=Math.cos(v),x=1/l(a.rX),d=1/l(a.rY),E=l(N)*x+l(f)*d,A=2*f*N*(x-d),C=l(f)*x+l(N)*d,M=E*i*i-A*r*i+C*r*r,R=A*(t*i+r*e)-2*(E*e*i+C*t*r),g=E*e*e-A*t*e+C*t*t,I=(Math.atan2(R,M-g)+Math.PI)%Math.PI/2,S=Math.sin(I),L=Math.cos(I);a.rX=Math.abs(T)/Math.sqrt(M*l(L)+R*S*L+g*l(S)),a.rY=Math.abs(T)/Math.sqrt(M*l(S)-R*S*L+g*l(L)),a.xRot=180*I/Math.PI;}return void 0!==a.sweepFlag&&0>T&&(a.sweepFlag=+!a.sweepFlag),a}))}function l(){return function(t){var r={};for(var e in t)r[e]=t[e];return r}}t.ROUND=function(t){function r(r){return Math.round(r*t)/t}return void 0===t&&(t=1e13),a(t),function(t){return void 0!==t.x1&&(t.x1=r(t.x1)),void 0!==t.y1&&(t.y1=r(t.y1)),void 0!==t.x2&&(t.x2=r(t.x2)),void 0!==t.y2&&(t.y2=r(t.y2)),void 0!==t.x&&(t.x=r(t.x)),void 0!==t.y&&(t.y=r(t.y)),void 0!==t.rX&&(t.rX=r(t.rX)),void 0!==t.rY&&(t.rY=r(t.rY)),t}},t.TO_ABS=r,t.TO_REL=function(){return u((function(t,r,e){return t.relative||(void 0!==t.x1&&(t.x1-=r),void 0!==t.y1&&(t.y1-=e),void 0!==t.x2&&(t.x2-=r),void 0!==t.y2&&(t.y2-=e),void 0!==t.x&&(t.x-=r),void 0!==t.y&&(t.y-=e),t.relative=!0),t}))},t.NORMALIZE_HVZ=function(t,r,e){return void 0===t&&(t=!0),void 0===r&&(r=!0),void 0===e&&(e=!0),u((function(i,a,n,o,s){if(isNaN(o)&&!(i.type&_.MOVE_TO))throw new Error("path must start with moveto");return r&&i.type&_.HORIZ_LINE_TO&&(i.type=_.LINE_TO,i.y=i.relative?0:n),e&&i.type&_.VERT_LINE_TO&&(i.type=_.LINE_TO,i.x=i.relative?0:a),t&&i.type&_.CLOSE_PATH&&(i.type=_.LINE_TO,i.x=i.relative?o-a:o,i.y=i.relative?s-n:s),i.type&_.ARC&&(0===i.rX||0===i.rY)&&(i.type=_.LINE_TO,delete i.rX,delete i.rY,delete i.xRot,delete i.lArcFlag,delete i.sweepFlag),i}))},t.NORMALIZE_ST=e,t.QT_TO_C=n,t.INFO=u,t.SANITIZE=function(t){void 0===t&&(t=0),a(t);var r=NaN,e=NaN,i=NaN,n=NaN;return u((function(a,o,s,u,h){var c=Math.abs,y=!1,p=0,m=0;if(a.type&_.SMOOTH_CURVE_TO&&(p=isNaN(r)?0:o-r,m=isNaN(e)?0:s-e),a.type&(_.CURVE_TO|_.SMOOTH_CURVE_TO)?(r=a.relative?o+a.x2:a.x2,e=a.relative?s+a.y2:a.y2):(r=NaN,e=NaN),a.type&_.SMOOTH_QUAD_TO?(i=isNaN(i)?o:2*o-i,n=isNaN(n)?s:2*s-n):a.type&_.QUAD_TO?(i=a.relative?o+a.x1:a.x1,n=a.relative?s+a.y1:a.y2):(i=NaN,n=NaN),a.type&_.LINE_COMMANDS||a.type&_.ARC&&(0===a.rX||0===a.rY||!a.lArcFlag)||a.type&_.CURVE_TO||a.type&_.SMOOTH_CURVE_TO||a.type&_.QUAD_TO||a.type&_.SMOOTH_QUAD_TO){var O=void 0===a.x?0:a.relative?a.x:a.x-o,l=void 0===a.y?0:a.relative?a.y:a.y-s;p=isNaN(i)?void 0===a.x1?p:a.relative?a.x:a.x1-o:i-o,m=isNaN(n)?void 0===a.y1?m:a.relative?a.y:a.y1-s:n-s;var T=void 0===a.x2?0:a.relative?a.x:a.x2-o,v=void 0===a.y2?0:a.relative?a.y:a.y2-s;c(O)<=t&&c(l)<=t&&c(p)<=t&&c(m)<=t&&c(T)<=t&&c(v)<=t&&(y=!0);}return a.type&_.CLOSE_PATH&&c(o-u)<=t&&c(s-h)<=t&&(y=!0),y?[]:a}))},t.MATRIX=O,t.ROTATE=function(t,r,e){void 0===r&&(r=0),void 0===e&&(e=0),a(t,r,e);var i=Math.sin(t),n=Math.cos(t);return O(n,i,-i,n,r-r*n+e*i,e-r*i-e*n)},t.TRANSLATE=function(t,r){return void 0===r&&(r=0),a(t,r),O(1,0,0,1,t,r)},t.SCALE=function(t,r){return void 0===r&&(r=t),a(t,r),O(t,0,0,r,0,0)},t.SKEW_X=function(t){return a(t),O(1,0,Math.atan(t),1,0,0)},t.SKEW_Y=function(t){return a(t),O(1,Math.atan(t),0,1,0,0)},t.X_AXIS_SYMMETRY=function(t){return void 0===t&&(t=0),a(t),O(-1,0,0,1,t,0)},t.Y_AXIS_SYMMETRY=function(t){return void 0===t&&(t=0),a(t),O(1,0,0,-1,0,t)},t.A_TO_C=function(){return u((function(t,r,e){return _.ARC===t.type?function(t,r,e){var a,n,s,u;t.cX||o(t,r,e);for(var y=Math.min(t.phi1,t.phi2),p=Math.max(t.phi1,t.phi2)-y,m=Math.ceil(p/90),O=new Array(m),l=r,T=e,v=0;v<m;v++){var f=c(t.phi1,t.phi2,v/m),N=c(t.phi1,t.phi2,(v+1)/m),x=N-f,d=4/3*Math.tan(x*h/4),E=[Math.cos(f*h)-d*Math.sin(f*h),Math.sin(f*h)+d*Math.cos(f*h)],A=E[0],C=E[1],M=[Math.cos(N*h),Math.sin(N*h)],R=M[0],g=M[1],I=[R+d*Math.sin(N*h),g-d*Math.cos(N*h)],S=I[0],L=I[1];O[v]={relative:t.relative,type:_.CURVE_TO};var H=function(r,e){var a=i$1([r*t.rX,e*t.rY],t.xRot),n=a[0],o=a[1];return [t.cX+n,t.cY+o]};a=H(A,C),O[v].x1=a[0],O[v].y1=a[1],n=H(S,L),O[v].x2=n[0],O[v].y2=n[1],s=H(R,g),O[v].x=s[0],O[v].y=s[1],t.relative&&(O[v].x1-=l,O[v].y1-=T,O[v].x2-=l,O[v].y2-=T,O[v].x-=l,O[v].y-=T),l=(u=[O[v].x,O[v].y])[0],T=u[1];}return O}(t,t.relative?0:r,t.relative?0:e):t}))},t.ANNOTATE_ARCS=function(){return u((function(t,r,e){return t.relative&&(r=0,e=0),_.ARC===t.type&&o(t,r,e),t}))},t.CLONE=l,t.CALCULATE_BOUNDS=function(){var t=function(t){var r={};for(var e in t)r[e]=t[e];return r},i=r(),a=n(),h=e(),c=u((function(r,e,n){var u=h(a(i(t(r))));function O(t){t>c.maxX&&(c.maxX=t),t<c.minX&&(c.minX=t);}function l(t){t>c.maxY&&(c.maxY=t),t<c.minY&&(c.minY=t);}if(u.type&_.DRAWING_COMMANDS&&(O(e),l(n)),u.type&_.HORIZ_LINE_TO&&O(u.x),u.type&_.VERT_LINE_TO&&l(u.y),u.type&_.LINE_TO&&(O(u.x),l(u.y)),u.type&_.CURVE_TO){O(u.x),l(u.y);for(var T=0,v=p(e,u.x1,u.x2,u.x);T<v.length;T++){0<(w=v[T])&&1>w&&O(m(e,u.x1,u.x2,u.x,w));}for(var f=0,N=p(n,u.y1,u.y2,u.y);f<N.length;f++){0<(w=N[f])&&1>w&&l(m(n,u.y1,u.y2,u.y,w));}}if(u.type&_.ARC){O(u.x),l(u.y),o(u,e,n);for(var x=u.xRot/180*Math.PI,d=Math.cos(x)*u.rX,E=Math.sin(x)*u.rX,A=-Math.sin(x)*u.rY,C=Math.cos(x)*u.rY,M=u.phi1<u.phi2?[u.phi1,u.phi2]:-180>u.phi2?[u.phi2+360,u.phi1+360]:[u.phi2,u.phi1],R=M[0],g=M[1],I=function(t){var r=t[0],e=t[1],i=180*Math.atan2(e,r)/Math.PI;return i<R?i+360:i},S=0,L=s(A,-d,0).map(I);S<L.length;S++){(w=L[S])>R&&w<g&&O(y(u.cX,d,A,w));}for(var H=0,U=s(C,-E,0).map(I);H<U.length;H++){var w;(w=U[H])>R&&w<g&&l(y(u.cY,E,C,w));}}return r}));return c.minX=1/0,c.maxX=-1/0,c.minY=1/0,c.maxY=-1/0,c};}(u||(u={}));var O,l=function(){function t(){}return t.prototype.round=function(t){return this.transform(u.ROUND(t))},t.prototype.toAbs=function(){return this.transform(u.TO_ABS())},t.prototype.toRel=function(){return this.transform(u.TO_REL())},t.prototype.normalizeHVZ=function(t,r,e){return this.transform(u.NORMALIZE_HVZ(t,r,e))},t.prototype.normalizeST=function(){return this.transform(u.NORMALIZE_ST())},t.prototype.qtToC=function(){return this.transform(u.QT_TO_C())},t.prototype.aToC=function(){return this.transform(u.A_TO_C())},t.prototype.sanitize=function(t){return this.transform(u.SANITIZE(t))},t.prototype.translate=function(t,r){return this.transform(u.TRANSLATE(t,r))},t.prototype.scale=function(t,r){return this.transform(u.SCALE(t,r))},t.prototype.rotate=function(t,r,e){return this.transform(u.ROTATE(t,r,e))},t.prototype.matrix=function(t,r,e,i,a,n){return this.transform(u.MATRIX(t,r,e,i,a,n))},t.prototype.skewX=function(t){return this.transform(u.SKEW_X(t))},t.prototype.skewY=function(t){return this.transform(u.SKEW_Y(t))},t.prototype.xSymmetry=function(t){return this.transform(u.X_AXIS_SYMMETRY(t))},t.prototype.ySymmetry=function(t){return this.transform(u.Y_AXIS_SYMMETRY(t))},t.prototype.annotateArcs=function(){return this.transform(u.ANNOTATE_ARCS())},t}(),T=function(t){return " "===t||"\t"===t||"\r"===t||"\n"===t},v=function(t){return "0".charCodeAt(0)<=t.charCodeAt(0)&&t.charCodeAt(0)<="9".charCodeAt(0)},f=function(t){function e(){var r=t.call(this)||this;return r.curNumber="",r.curCommandType=-1,r.curCommandRelative=!1,r.canParseCommandOrComma=!0,r.curNumberHasExp=!1,r.curNumberHasExpDigits=!1,r.curNumberHasDecimal=!1,r.curArgs=[],r}return r(e,t),e.prototype.finish=function(t){if(void 0===t&&(t=[]),this.parse(" ",t),0!==this.curArgs.length||!this.canParseCommandOrComma)throw new SyntaxError("Unterminated command at the path end.");return t},e.prototype.parse=function(t,r){var e=this;void 0===r&&(r=[]);for(var i=function(t){r.push(t),e.curArgs.length=0,e.canParseCommandOrComma=!0;},a=0;a<t.length;a++){var n=t[a],o=!(this.curCommandType!==_.ARC||3!==this.curArgs.length&&4!==this.curArgs.length||1!==this.curNumber.length||"0"!==this.curNumber&&"1"!==this.curNumber),s=v(n)&&("0"===this.curNumber&&"0"===n||o);if(!v(n)||s)if("e"!==n&&"E"!==n)if("-"!==n&&"+"!==n||!this.curNumberHasExp||this.curNumberHasExpDigits)if("."!==n||this.curNumberHasExp||this.curNumberHasDecimal||o){if(this.curNumber&&-1!==this.curCommandType){var u=Number(this.curNumber);if(isNaN(u))throw new SyntaxError("Invalid number ending at "+a);if(this.curCommandType===_.ARC)if(0===this.curArgs.length||1===this.curArgs.length){if(0>u)throw new SyntaxError('Expected positive number, got "'+u+'" at index "'+a+'"')}else if((3===this.curArgs.length||4===this.curArgs.length)&&"0"!==this.curNumber&&"1"!==this.curNumber)throw new SyntaxError('Expected a flag, got "'+this.curNumber+'" at index "'+a+'"');this.curArgs.push(u),this.curArgs.length===N[this.curCommandType]&&(_.HORIZ_LINE_TO===this.curCommandType?i({type:_.HORIZ_LINE_TO,relative:this.curCommandRelative,x:u}):_.VERT_LINE_TO===this.curCommandType?i({type:_.VERT_LINE_TO,relative:this.curCommandRelative,y:u}):this.curCommandType===_.MOVE_TO||this.curCommandType===_.LINE_TO||this.curCommandType===_.SMOOTH_QUAD_TO?(i({type:this.curCommandType,relative:this.curCommandRelative,x:this.curArgs[0],y:this.curArgs[1]}),_.MOVE_TO===this.curCommandType&&(this.curCommandType=_.LINE_TO)):this.curCommandType===_.CURVE_TO?i({type:_.CURVE_TO,relative:this.curCommandRelative,x1:this.curArgs[0],y1:this.curArgs[1],x2:this.curArgs[2],y2:this.curArgs[3],x:this.curArgs[4],y:this.curArgs[5]}):this.curCommandType===_.SMOOTH_CURVE_TO?i({type:_.SMOOTH_CURVE_TO,relative:this.curCommandRelative,x2:this.curArgs[0],y2:this.curArgs[1],x:this.curArgs[2],y:this.curArgs[3]}):this.curCommandType===_.QUAD_TO?i({type:_.QUAD_TO,relative:this.curCommandRelative,x1:this.curArgs[0],y1:this.curArgs[1],x:this.curArgs[2],y:this.curArgs[3]}):this.curCommandType===_.ARC&&i({type:_.ARC,relative:this.curCommandRelative,rX:this.curArgs[0],rY:this.curArgs[1],xRot:this.curArgs[2],lArcFlag:this.curArgs[3],sweepFlag:this.curArgs[4],x:this.curArgs[5],y:this.curArgs[6]})),this.curNumber="",this.curNumberHasExpDigits=!1,this.curNumberHasExp=!1,this.curNumberHasDecimal=!1,this.canParseCommandOrComma=!0;}if(!T(n))if(","===n&&this.canParseCommandOrComma)this.canParseCommandOrComma=!1;else if("+"!==n&&"-"!==n&&"."!==n)if(s)this.curNumber=n,this.curNumberHasDecimal=!1;else {if(0!==this.curArgs.length)throw new SyntaxError("Unterminated command at index "+a+".");if(!this.canParseCommandOrComma)throw new SyntaxError('Unexpected character "'+n+'" at index '+a+". Command cannot follow comma");if(this.canParseCommandOrComma=!1,"z"!==n&&"Z"!==n)if("h"===n||"H"===n)this.curCommandType=_.HORIZ_LINE_TO,this.curCommandRelative="h"===n;else if("v"===n||"V"===n)this.curCommandType=_.VERT_LINE_TO,this.curCommandRelative="v"===n;else if("m"===n||"M"===n)this.curCommandType=_.MOVE_TO,this.curCommandRelative="m"===n;else if("l"===n||"L"===n)this.curCommandType=_.LINE_TO,this.curCommandRelative="l"===n;else if("c"===n||"C"===n)this.curCommandType=_.CURVE_TO,this.curCommandRelative="c"===n;else if("s"===n||"S"===n)this.curCommandType=_.SMOOTH_CURVE_TO,this.curCommandRelative="s"===n;else if("q"===n||"Q"===n)this.curCommandType=_.QUAD_TO,this.curCommandRelative="q"===n;else if("t"===n||"T"===n)this.curCommandType=_.SMOOTH_QUAD_TO,this.curCommandRelative="t"===n;else {if("a"!==n&&"A"!==n)throw new SyntaxError('Unexpected character "'+n+'" at index '+a+".");this.curCommandType=_.ARC,this.curCommandRelative="a"===n;}else r.push({type:_.CLOSE_PATH}),this.canParseCommandOrComma=!0,this.curCommandType=-1;}else this.curNumber=n,this.curNumberHasDecimal="."===n;}else this.curNumber+=n,this.curNumberHasDecimal=!0;else this.curNumber+=n;else this.curNumber+=n,this.curNumberHasExp=!0;else this.curNumber+=n,this.curNumberHasExpDigits=this.curNumberHasExp;}return r},e.prototype.transform=function(t){return Object.create(this,{parse:{value:function(r,e){void 0===e&&(e=[]);for(var i=0,a=Object.getPrototypeOf(this).parse.call(this,r);i<a.length;i++){var n=a[i],o=t(n);Array.isArray(o)?e.push.apply(e,o):e.push(o);}return e}}})},e}(l),_=function(t){function i(r){var e=t.call(this)||this;return e.commands="string"==typeof r?i.parse(r):r,e}return r(i,t),i.prototype.encode=function(){return i.encode(this.commands)},i.prototype.getBounds=function(){var t=u.CALCULATE_BOUNDS();return this.transform(t),t},i.prototype.transform=function(t){for(var r=[],e=0,i=this.commands;e<i.length;e++){var a=t(i[e]);Array.isArray(a)?r.push.apply(r,a):r.push(a);}return this.commands=r,this},i.encode=function(t){return e(t)},i.parse=function(t){var r=new f,e=[];return r.parse(t,e),r.finish(e),e},i.CLOSE_PATH=1,i.MOVE_TO=2,i.HORIZ_LINE_TO=4,i.VERT_LINE_TO=8,i.LINE_TO=16,i.CURVE_TO=32,i.SMOOTH_CURVE_TO=64,i.QUAD_TO=128,i.SMOOTH_QUAD_TO=256,i.ARC=512,i.LINE_COMMANDS=i.LINE_TO|i.HORIZ_LINE_TO|i.VERT_LINE_TO,i.DRAWING_COMMANDS=i.HORIZ_LINE_TO|i.VERT_LINE_TO|i.LINE_TO|i.CURVE_TO|i.SMOOTH_CURVE_TO|i.QUAD_TO|i.SMOOTH_QUAD_TO|i.ARC,i}(l),N=((O={})[_.MOVE_TO]=2,O[_.LINE_TO]=2,O[_.HORIZ_LINE_TO]=1,O[_.VERT_LINE_TO]=1,O[_.CLOSE_PATH]=0,O[_.QUAD_TO]=4,O[_.SMOOTH_QUAD_TO]=2,O[_.CURVE_TO]=6,O[_.SMOOTH_CURVE_TO]=4,O[_.ARC]=7,O);

    class PathParser extends _ {
        constructor(path) {
            super(path
                // Fix spaces after signs.
                .replace(/([+\-.])\s+/gm, '$1')
                // Remove invalid part.
                .replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ''));
            this.control = new Vector2(0, 0);
            this.start = new Vector2(0, 0);
            this.current = new Vector2(0, 0);
            this.command = null;
            this.commands = this.commands;
            this.i = -1;
            this.previousCommand = null;
            this.points = [];
            this.angles = [];
        }
        reset() {
            this.i = -1;
            this.command = null;
            this.previousCommand = null;
            this.start = new Vector2(0, 0);
            this.control = new Vector2(0, 0);
            this.current = new Vector2(0, 0);
            this.points = [];
            this.angles = [];
        }
        isEnd() {
            const { i, commands } = this;
            return i >= commands.length - 1;
        }
        next() {
            const command = this.commands[++this.i];
            this.previousCommand = this.command;
            this.command = command;
            return command;
        }
        getPoint(xProp = 'x', yProp = 'y') {
            if (this.command) {
                const x = parseInt(xProp);
                const y = parseInt(yProp);
                const point = new Vector2(x, y);
                return this.makeAbsolute(point);
            }
        }
        getAsControlPoint(xProp, yProp) {
            const point = this.getPoint(xProp, yProp);
            if (point) {
                this.control = point;
            }
            return point;
        }
        getAsCurrentPoint(xProp, yProp) {
            const point = this.getPoint(xProp, yProp);
            if (point) {
                this.current = point;
            }
            return point;
        }
        getReflectedControlPoint() {
            let previousCommand = null;
            if (this.previousCommand) {
                previousCommand = this.previousCommand.type;
            }
            if (previousCommand !== _.CURVE_TO &&
                previousCommand !== _.SMOOTH_CURVE_TO &&
                previousCommand !== _.QUAD_TO &&
                previousCommand !== _.SMOOTH_QUAD_TO) {
                return this.current;
            }
            // reflect point
            const { current: { x: cx, y: cy }, control: { x: ox, y: oy }, } = this;
            const point = new Vector2(2 * cx - ox, 2 * cy - oy);
            return point;
        }
        makeAbsolute(point) {
            if (this.command && 'relative' in this.command && this.command.relative) {
                const { x, y } = this.current;
                point.x += x;
                point.y += y;
            }
            return point;
        }
        addMarker(point, from, priorTo) {
            const { points, angles } = this;
            // if the last angle isn't filled in because we didn't have this point yet ...
            if (priorTo && angles.length > 0 && !angles[angles.length - 1]) {
                angles[angles.length - 1] = this.angleBetweenPoints(points[points.length - 1], priorTo);
            }
            this.addMarkerAngle(point, from ? this.angleBetweenPoints(from, point) : null);
        }
        addMarkerAngle(point, angle) {
            this.points.push(point);
            this.angles.push(angle);
        }
        angleBetweenPoints(point1, point2) {
            return Math.atan2(point2.y - point1.y, point2.x - point1.x);
        }
        getMarkerPoints() {
            return this.points;
        }
        getMarkerAngles() {
            const { angles } = this;
            const len = angles.length;
            for (let i = 0; i < len; i++) {
                if (!angles[i]) {
                    for (let j = i + 1; j < len; j++) {
                        if (angles[j]) {
                            angles[i] = angles[j];
                            break;
                        }
                    }
                }
            }
            return angles;
        }
    }

    class PathHandler {
        get currentPosition() {
            return this._currentPosition || this.initialPosition;
        }
        constructor(sketchNode, scaleDivider, nodeManager) {
            this.sketchNode = sketchNode;
            this.scaleDivider = scaleDivider;
            this.initialPosition = new exports.KbVector(0, 0, 0);
            this.stubPath = { id: 'stub' };
            this.nodeManager = nodeManager;
        }
        parseTrace(commands) {
            const newPaths = [];
            if (!this.sketchNode || commands.length === 0) {
                return [];
            }
            const first = commands[0];
            if (first.type !== 'M') {
                this.pathM(newPaths, {
                    type: PathParser.MOVE_TO,
                    relative: false,
                    x: first.x1,
                    y: first.y1,
                });
            }
            for (let i = 0; i < commands.length; i++) {
                const command = commands[i];
                const commonPathCommand = {
                    relative: false,
                    x: command.x2,
                    y: command.y2,
                    x1: command.x3 || -1,
                    y1: command.y3 || -1,
                };
                switch (command.type) {
                    case 'M': {
                        const pathCommand = {
                            ...commonPathCommand,
                            type: PathParser.MOVE_TO,
                        };
                        this.pathM(newPaths, pathCommand);
                        break;
                    }
                    case 'L': {
                        const pathCommand = {
                            ...commonPathCommand,
                            type: PathParser.LINE_TO,
                        };
                        this.pathL(newPaths, pathCommand);
                        break;
                    }
                    case 'Q': {
                        if (!command.x3 || !command.y3) {
                            console.warn('Q command without x3 or y3');
                        }
                        else {
                            const pathCommand = {
                                ...commonPathCommand,
                                type: PathParser.QUAD_TO,
                                x: command.x3,
                                y: command.y3,
                                x1: command.x2,
                                y1: command.y2,
                            };
                            this.pathQ(newPaths, pathCommand);
                        }
                        break;
                    }
                    /** imagetracer does not return C, S, or T paths
                     *
                    case 'C': {
                        const pathCommand: CommandC = {
                            ...commonPathCommand,
                            type: PathParser.CURVE_TO,
                        };
                        this.pathC(newPaths, pathCommand);
                        break;
                    }
                    case 'S': {
                        const pathCommand: CommandS = {
                            ...commonPathCommand,
                            type: PathParser.SMOOTH_CURVE_TO,
                        };
                        this.pathS(newPaths, pathCommand);
                        break;
                    }
                    case 'T': {
                        const pathCommand: CommandT = {
                            ...commonPathCommand,
                            type: PathParser.SMOOTH_QUAD_TO,
                        };
                        this.pathT(newPaths, pathCommand);
                        break;
                    }
                    */
                    case 'Z': {
                        this.pathZ(newPaths);
                    }
                }
            }
            return this.reprojectPaths(newPaths.filter(path => path !== this.stubPath));
        }
        parsePath(path) {
            this.pathParser = new PathParser(path);
            this.pathParser.reset();
            if (!this.sketchNode) {
                return [];
            }
            const newPaths = [];
            while (!this.pathParser.isEnd()) {
                switch (this.pathParser.next().type) {
                    case PathParser.MOVE_TO:
                        this.pathM(newPaths);
                        break;
                    case PathParser.LINE_TO:
                        this.pathL(newPaths);
                        break;
                    case PathParser.HORIZ_LINE_TO:
                        this.pathL(newPaths);
                        break;
                    case PathParser.VERT_LINE_TO:
                        this.pathL(newPaths);
                        break;
                    case PathParser.CURVE_TO:
                        this.pathC(newPaths);
                        break;
                    case PathParser.SMOOTH_CURVE_TO:
                        this.pathS(newPaths);
                        break;
                    case PathParser.QUAD_TO:
                        this.pathQ(newPaths);
                        break;
                    case PathParser.SMOOTH_QUAD_TO:
                        this.pathT(newPaths);
                        break;
                    case PathParser.ARC:
                        console.warn('ARC not implemented');
                        this.pathA(newPaths);
                        break;
                    case PathParser.CLOSE_PATH:
                        this.pathZ(newPaths);
                        break;
                }
            }
            return this.reprojectPaths(newPaths.filter(path => path !== this.stubPath));
        }
        reprojectPaths(paths) {
            paths.forEach(path => {
                path.controlPoints.forEach(cp => {
                    cp.position = projectOnNodeAxis(this.sketchNode, cp.position.x, cp.position.y);
                    cp.direction = projectOnNodeAxis(this.sketchNode, cp.direction.x, cp.direction.y);
                    if (cp.direction2) {
                        cp.direction2 = projectOnNodeAxis(this.sketchNode, cp.direction2.x, cp.direction2.y);
                    }
                });
            });
            return paths;
        }
        checkIfNewPathNeeded(paths, desiredPathType) {
            let activePath = paths[paths.length - 1];
            if (!activePath || activePath === this.stubPath || activePath.type !== desiredPathType) {
                if (activePath === this.stubPath) {
                    paths.pop();
                }
                activePath = this.addNewPath(paths, desiredPathType);
                const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
                if (!this._currentPosition) {
                    console.warn('new path created with no moveto command');
                }
                newControlPoint.position = this.currentPosition;
                activePath.controlPoints.push(newControlPoint);
                newControlPoint.direction2 = new exports.KbVector(0, 0, 0);
            }
            return activePath;
        }
        pathM(paths, command) {
            const { pathParser } = this;
            let x = 0;
            let y = 0;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                x = command.x / this.scaleDivider;
                y = (command.y * -1) / this.scaleDivider;
                if (command.relative && this.currentPosition) {
                    x = x + this.currentPosition.x;
                    y = y + this.currentPosition.y;
                }
                this._currentPosition = new exports.KbVector(x, y, 0);
                this.initialPosition = this._currentPosition;
                paths.push(this.stubPath);
            }
        }
        pathL(paths, command) {
            const { pathParser } = this;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                let x;
                let y;
                //these 2 if checks need to happen because pathL could be a horizontal or vertical line and therefore not have one of the coordinates.
                if ('x' in command) {
                    x = command.x / this.scaleDivider;
                }
                if ('y' in command) {
                    y = (command.y * -1) / this.scaleDivider;
                }
                const activePath = this.checkIfNewPathNeeded(paths, exports.eSketchPathType.points);
                if (command.relative && activePath) {
                    if (x !== undefined) {
                        x = x + this.currentPosition.x;
                    }
                    if (y !== undefined) {
                        y = y + this.currentPosition.y;
                    }
                }
                if (x === undefined) {
                    // V case
                    x = this.currentPosition.x || 0;
                }
                if (y === undefined) {
                    // H case
                    y = this.currentPosition.y || 0;
                }
                const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = new exports.KbVector(x, y, 0);
                this._currentPosition = newControlPoint.position;
                activePath.controlPoints.push(newControlPoint);
            }
        }
        pathC(paths, command) {
            const { pathParser } = this;
            let x = 0;
            let y = 0;
            let x1 = 0;
            let y1 = 0;
            let x2 = 0;
            let y2 = 0;
            let lastControlPoint = undefined;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                x = command.x / this.scaleDivider;
                y = (command.y * -1) / this.scaleDivider;
                x1 = command.x1 / this.scaleDivider;
                y1 = (command.y1 * -1) / this.scaleDivider;
                x2 = command.x2 / this.scaleDivider;
                y2 = (command.y2 * -1) / this.scaleDivider;
                const activePath = this.checkIfNewPathNeeded(paths, exports.eSketchPathType.cubicBezier);
                lastControlPoint = activePath.controlPoints[activePath.controlPoints.length - 1];
                if (command.relative) {
                    x = x + this.currentPosition.x;
                    y = y + this.currentPosition.y;
                    x1 = x1 + this.currentPosition.x;
                    y1 = y1 + this.currentPosition.y;
                    x2 = x2 + this.currentPosition.x;
                    y2 = y2 + this.currentPosition.y;
                }
                if (lastControlPoint) {
                    lastControlPoint.direction = new exports.KbVector(x1 - lastControlPoint.position.x, y1 - lastControlPoint.position.y, 0);
                }
                const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = new exports.KbVector(x, y, 0);
                this._currentPosition = newControlPoint.position;
                newControlPoint.direction2 = new exports.KbVector(x2 - x, y2 - y, 0);
                activePath.controlPoints.push(newControlPoint);
            }
        }
        pathS(paths, command) {
            var _a;
            const { pathParser } = this;
            let x = 0;
            let y = 0;
            let x2 = 0;
            let y2 = 0;
            let lastControlPoint = undefined;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                x = command.x / this.scaleDivider;
                y = (command.y * -1) / this.scaleDivider;
                x2 = command.x2 / this.scaleDivider;
                y2 = (command.y2 * -1) / this.scaleDivider;
                const activePath = this.checkIfNewPathNeeded(paths, exports.eSketchPathType.cubicBezier);
                lastControlPoint = activePath.controlPoints[activePath.controlPoints.length - 1];
                lastControlPoint.direction = new exports.KbVector(0, 0, 0);
                if (command.relative) {
                    x = x + this.currentPosition.x;
                    y = y + this.currentPosition.y;
                    x2 = x2 + this.currentPosition.x;
                    y2 = y2 + this.currentPosition.y;
                }
                const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = new exports.KbVector(x, y, 0);
                if (lastControlPoint && lastControlPoint.direction2) {
                    lastControlPoint.direction = (_a = lastControlPoint.direction2) === null || _a === void 0 ? void 0 : _a.scale(-1);
                    newControlPoint.direction2 = new exports.KbVector(x2 - x, y2 - y, 0);
                }
                this._currentPosition = newControlPoint.position;
                activePath.controlPoints.push(newControlPoint);
                return activePath;
            }
        }
        pathQ(paths, command) {
            const { pathParser } = this;
            let x = 0;
            let y = 0;
            let x1 = 0;
            let y1 = 0;
            let lastControlPoint = undefined;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                x = command.x / this.scaleDivider;
                y = (command.y * -1) / this.scaleDivider;
                x1 = command.x1 / this.scaleDivider;
                y1 = (command.y1 * -1) / this.scaleDivider;
                const activePath = this.checkIfNewPathNeeded(paths, exports.eSketchPathType.quadraticBezier);
                lastControlPoint = activePath.controlPoints[activePath.controlPoints.length - 1];
                if (command.relative) {
                    x = x + this.currentPosition.x;
                    y = y + this.currentPosition.y;
                    x1 = x1 + this.currentPosition.x;
                    y1 = y1 + this.currentPosition.y;
                }
                if (lastControlPoint) {
                    lastControlPoint.direction = new exports.KbVector(x1 - lastControlPoint.position.x, y1 - lastControlPoint.position.y, 0);
                }
                const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = new exports.KbVector(x, y, 0);
                this._currentPosition = newControlPoint.position;
                activePath.controlPoints.push(newControlPoint);
            }
        }
        pathT(paths, command) {
            const { pathParser } = this;
            let x = 0;
            let y = 0;
            let lastControlPoint = undefined;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                x = command.x / this.scaleDivider;
                y = (command.y * -1) / this.scaleDivider;
                const activePath = this.checkIfNewPathNeeded(paths, exports.eSketchPathType.quadraticBezier);
                lastControlPoint = activePath.controlPoints[activePath.controlPoints.length - 1];
                lastControlPoint.direction = new exports.KbVector(0, 0, 0);
                if (command.relative) {
                    x = x + this.currentPosition.x;
                    y = y + this.currentPosition.y;
                }
                const secondLastControlPoint = activePath.controlPoints[activePath.controlPoints.length - 2];
                const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = new exports.KbVector(x, y, 0);
                this._currentPosition = newControlPoint.position;
                activePath.controlPoints.push(newControlPoint);
                if (lastControlPoint && secondLastControlPoint && secondLastControlPoint) {
                    lastControlPoint.direction = this.calculateReflection(secondLastControlPoint.direction, secondLastControlPoint, lastControlPoint);
                }
            }
        }
        //Path A needs further implementing
        pathA(paths, command) {
            const { pathParser } = this;
            if (!command && pathParser.command) {
                command = pathParser.command;
            }
            if (command) {
                // const cX = command.cX;
                // const cY = command.cY;
                // const rX = command.rX;
                // const rY = command.rY;
                let x = command.x;
                let y = command.y;
                if (command.relative) {
                    x = x + this.currentPosition.x;
                    y = y + this.currentPosition.y;
                }
                // const xAxisRotation = command.xRot;
                // const largeArcFlag = command.lArcFlag;
                // const sweepFlag = command.sweepFlag;
                this._currentPosition = new exports.KbVector(x, y, 0);
            }
        }
        pathZ(paths) {
            const activePath = this.checkIfNewPathNeeded(paths, exports.eSketchPathType.points);
            const x = this.initialPosition.x;
            const y = this.initialPosition.y;
            const newControlPoint = this.nodeManager.create(Token.SketchControlPoint);
            newControlPoint.position = new exports.KbVector(x, y, 0);
            this._currentPosition = undefined;
            activePath.controlPoints.push(newControlPoint);
            return activePath;
        }
        addNewPath(paths, pathType) {
            const newPath = this.nodeManager.create(Token.SketchPath);
            newPath.name = 'Path';
            newPath._expanded = true;
            paths.push(newPath);
            if (pathType) {
                newPath.type = pathType;
            }
            return newPath;
        }
        calculateReflection(vector, controlPoint, controlPoint2) {
            const n = controlPoint2.position.subtract(controlPoint.position).normalize();
            return vector.subtract(n.scale(2 * vector.dotProduct(n))).scale(-1);
        }
    }

    const VERSION_NUMBER = "0.2.1";
    const PATHSCAN_COMBINED_LOOKUP = [
      [[-1, -1, -1, -1], [-1, -1, -1, -1], [-1, -1, -1, -1], [-1, -1, -1, -1]],
      [[0, 1, 0, -1], [-1, -1, -1, -1], [-1, -1, -1, -1], [0, 2, -1, 0]],
      [[-1, -1, -1, -1], [-1, -1, -1, -1], [0, 1, 0, -1], [0, 0, 1, 0]],
      [[0, 0, 1, 0], [-1, -1, -1, -1], [0, 2, -1, 0], [-1, -1, -1, -1]],
      [[-1, -1, -1, -1], [0, 0, 1, 0], [0, 3, 0, 1], [-1, -1, -1, -1]],
      [[13, 3, 0, 1], [13, 2, -1, 0], [7, 1, 0, -1], [7, 0, 1, 0]],
      [[-1, -1, -1, -1], [0, 1, 0, -1], [-1, -1, -1, -1], [0, 3, 0, 1]],
      [[0, 3, 0, 1], [0, 2, -1, 0], [-1, -1, -1, -1], [-1, -1, -1, -1]],
      [[0, 3, 0, 1], [0, 2, -1, 0], [-1, -1, -1, -1], [-1, -1, -1, -1]],
      [[-1, -1, -1, -1], [0, 1, 0, -1], [-1, -1, -1, -1], [0, 3, 0, 1]],
      [[11, 1, 0, -1], [14, 0, 1, 0], [14, 3, 0, 1], [11, 2, -1, 0]],
      [[-1, -1, -1, -1], [0, 0, 1, 0], [0, 3, 0, 1], [-1, -1, -1, -1]],
      [[0, 0, 1, 0], [-1, -1, -1, -1], [0, 2, -1, 0], [-1, -1, -1, -1]],
      [[-1, -1, -1, -1], [-1, -1, -1, -1], [0, 1, 0, -1], [0, 0, 1, 0]],
      [[0, 1, 0, -1], [-1, -1, -1, -1], [-1, -1, -1, -1], [0, 2, -1, 0]],
      [[-1, -1, -1, -1], [-1, -1, -1, -1], [-1, -1, -1, -1], [-1, -1, -1, -1]]
    ];
    const SPECPALETTE = [
      { r: 0, g: 0, b: 0, a: 255 },
      { r: 128, g: 128, b: 128, a: 255 },
      { r: 0, g: 0, b: 128, a: 255 },
      { r: 64, g: 64, b: 128, a: 255 },
      { r: 192, g: 192, b: 192, a: 255 },
      { r: 255, g: 255, b: 255, a: 255 },
      { r: 128, g: 128, b: 192, a: 255 },
      { r: 0, g: 0, b: 192, a: 255 },
      { r: 128, g: 0, b: 0, a: 255 },
      { r: 128, g: 64, b: 64, a: 255 },
      { r: 128, g: 0, b: 128, a: 255 },
      { r: 168, g: 168, b: 168, a: 255 },
      { r: 192, g: 128, b: 128, a: 255 },
      { r: 192, g: 0, b: 0, a: 255 },
      { r: 255, g: 255, b: 255, a: 255 },
      { r: 0, g: 128, b: 0, a: 255 }
    ];
    const GKS = [
      [0.27901, 0.44198, 0.27901],
      [0.135336, 0.228569, 0.272192, 0.228569, 0.135336],
      [0.086776, 0.136394, 0.178908, 0.195843, 0.178908, 0.136394, 0.086776],
      [0.063327, 0.093095, 0.122589, 0.144599, 0.152781, 0.144599, 0.122589, 0.093095, 0.063327],
      [0.049692, 0.069304, 0.089767, 0.107988, 0.120651, 0.125194, 0.120651, 0.107988, 0.089767, 0.069304, 0.049692]
    ];

    const OPTION_PRESETS = {
      default: {
        corsenabled: false,
        ltres: 1,
        qtres: 1,
        pathomit: 8,
        rightangleenhance: true,
        colorsampling: 2,
        numberofcolors: 16,
        mincolorratio: 0,
        colorquantcycles: 3,
        layering: 0,
        strokewidth: 1,
        linefilter: false,
        scale: 1,
        roundcoords: 1,
        viewbox: false,
        desc: false,
        lcpr: 0,
        qcpr: 0,
        blurradius: 0,
        blurdelta: 20
      },
      posterized1: { colorsampling: 0, numberofcolors: 2 },
      posterized2: { numberofcolors: 4, blurradius: 5 },
      curvy: { ltres: 0.01, linefilter: true, rightangleenhance: false },
      sharp: { qtres: 0.01, linefilter: false },
      detailed: { pathomit: 0, roundcoords: 2, ltres: 0.5, qtres: 0.5, numberofcolors: 64 },
      smoothed: { blurradius: 5, blurdelta: 64 },
      grayscale: { colorsampling: 0, colorquantcycles: 1, numberofcolors: 7 },
      fixedpalette: { colorsampling: 0, colorquantcycles: 1, numberofcolors: 27 },
      randomsampling1: { colorsampling: 1, numberofcolors: 8 },
      randomsampling2: { colorsampling: 1, numberofcolors: 64 },
      artistic1: { colorsampling: 0, colorquantcycles: 1, pathomit: 0, blurradius: 5, blurdelta: 64, ltres: 0.01, linefilter: true, numberofcolors: 16, strokewidth: 2 },
      artistic2: { qtres: 0.01, colorsampling: 0, colorquantcycles: 1, numberofcolors: 4, strokewidth: 0 },
      artistic3: { qtres: 10, ltres: 10, numberofcolors: 8 },
      artistic4: { qtres: 10, ltres: 10, numberofcolors: 64, blurradius: 5, blurdelta: 256, strokewidth: 2 },
      posterized3: {
        ltres: 1,
        qtres: 1,
        pathomit: 20,
        rightangleenhance: true,
        colorsampling: 0,
        numberofcolors: 3,
        mincolorratio: 0,
        colorquantcycles: 3,
        blurradius: 3,
        blurdelta: 20,
        strokewidth: 0,
        linefilter: false,
        roundcoords: 1,
        pal: [{ r: 0, g: 0, b: 100, a: 255 }, { r: 255, g: 255, b: 255, a: 255 }]
      }
    };

    function generatePalette(numberOfColors) {
      const palette = [];
      let rcnt;
      let gcnt;
      let bcnt;
      if (numberOfColors < 8) {
        const graystep = Math.floor(255 / (numberOfColors - 1));
        for (let i = 0; i < numberOfColors; i++)
          palette.push({ r: i * graystep, g: i * graystep, b: i * graystep, a: 255 });
      } else {
        const colorqnum = Math.floor(Math.pow(numberOfColors, 1 / 3));
        const colorstep = Math.floor(255 / (colorqnum - 1));
        const rndnum = numberOfColors - colorqnum * colorqnum * colorqnum;
        for (rcnt = 0; rcnt < colorqnum; rcnt++) {
          for (gcnt = 0; gcnt < colorqnum; gcnt++) {
            for (bcnt = 0; bcnt < colorqnum; bcnt++)
              palette.push({ r: rcnt * colorstep, g: gcnt * colorstep, b: bcnt * colorstep, a: 255 });
          }
        }
        for (rcnt = 0; rcnt < rndnum; rcnt++)
          palette.push({ r: Math.floor(Math.random() * 255), g: Math.floor(Math.random() * 255), b: Math.floor(Math.random() * 255), a: Math.floor(Math.random() * 255) });
      }
      return palette;
    }
    function samplePalette(numberOfColors, imageData) {
      let idx;
      const palette = [];
      for (let i = 0; i < numberOfColors; i++) {
        idx = Math.floor(Math.random() * imageData.data.length / 4) * 4;
        palette.push({ r: imageData.data[idx], g: imageData.data[idx + 1], b: imageData.data[idx + 2], a: imageData.data[idx + 3] });
      }
      return palette;
    }
    function samplePaletteByGrid(numberOfColors, imageData) {
      let idx;
      const palette = [];
      const ni = Math.ceil(Math.sqrt(numberOfColors));
      const nj = Math.ceil(numberOfColors / ni);
      const vx = imageData.width / (ni + 1);
      const vy = imageData.height / (nj + 1);
      for (let j = 0; j < nj; j++) {
        for (let i = 0; i < ni; i++) {
          if (palette.length === numberOfColors) {
            break;
          } else {
            idx = Math.floor((j + 1) * vy * imageData.width + (i + 1) * vx) * 4;
            palette.push({ r: imageData.data[idx], g: imageData.data[idx + 1], b: imageData.data[idx + 2], a: imageData.data[idx + 3] });
          }
        }
      }
      return palette;
    }

    function blur(imageData, radius, delta) {
      let i, j, k, d, idx, racc, gacc, bacc, aacc, wacc;
      const imageData2 = new ImageData(imageData.width, imageData.height);
      radius = Math.floor(radius);
      if (radius < 1)
        return imageData;
      if (radius > 5)
        radius = 5;
      delta = Math.abs(delta);
      if (delta > 1024)
        delta = 1024;
      const thisgk = GKS[radius - 1];
      for (j = 0; j < imageData.height; j++) {
        for (i = 0; i < imageData.width; i++) {
          racc = 0;
          gacc = 0;
          bacc = 0;
          aacc = 0;
          wacc = 0;
          for (k = -radius; k < radius + 1; k++) {
            if (i + k > 0 && i + k < imageData.width) {
              idx = (j * imageData.width + i + k) * 4;
              racc += imageData.data[idx] * thisgk[k + radius];
              gacc += imageData.data[idx + 1] * thisgk[k + radius];
              bacc += imageData.data[idx + 2] * thisgk[k + radius];
              aacc += imageData.data[idx + 3] * thisgk[k + radius];
              wacc += thisgk[k + radius];
            }
          }
          idx = (j * imageData.width + i) * 4;
          imageData2.data[idx] = Math.floor(racc / wacc);
          imageData2.data[idx + 1] = Math.floor(gacc / wacc);
          imageData2.data[idx + 2] = Math.floor(bacc / wacc);
          imageData2.data[idx + 3] = Math.floor(aacc / wacc);
        }
      }
      const himageData = new Uint8ClampedArray(imageData2.data);
      for (j = 0; j < imageData.height; j++) {
        for (i = 0; i < imageData.width; i++) {
          racc = 0;
          gacc = 0;
          bacc = 0;
          aacc = 0;
          wacc = 0;
          for (k = -radius; k < radius + 1; k++) {
            if (j + k > 0 && j + k < imageData.height) {
              idx = ((j + k) * imageData.width + i) * 4;
              racc += himageData[idx] * thisgk[k + radius];
              gacc += himageData[idx + 1] * thisgk[k + radius];
              bacc += himageData[idx + 2] * thisgk[k + radius];
              aacc += himageData[idx + 3] * thisgk[k + radius];
              wacc += thisgk[k + radius];
            }
          }
          idx = (j * imageData.width + i) * 4;
          imageData2.data[idx] = Math.floor(racc / wacc);
          imageData2.data[idx + 1] = Math.floor(gacc / wacc);
          imageData2.data[idx + 2] = Math.floor(bacc / wacc);
          imageData2.data[idx + 3] = Math.floor(aacc / wacc);
        }
      }
      for (j = 0; j < imageData.height; j++) {
        for (i = 0; i < imageData.width; i++) {
          idx = (j * imageData.width + i) * 4;
          d = Math.abs(imageData2.data[idx] - imageData.data[idx]) + Math.abs(imageData2.data[idx + 1] - imageData.data[idx + 1]) + Math.abs(imageData2.data[idx + 2] - imageData.data[idx + 2]) + Math.abs(imageData2.data[idx + 3] - imageData.data[idx + 3]);
          if (d > delta) {
            imageData2.data[idx] = imageData.data[idx];
            imageData2.data[idx + 1] = imageData.data[idx + 1];
            imageData2.data[idx + 2] = imageData.data[idx + 2];
            imageData2.data[idx + 3] = imageData.data[idx + 3];
          }
        }
      }
      return imageData2;
    }

    function getDirection(x1, y1, x2, y2) {
      let result = 8;
      if (x1 < x2) {
        if (y1 < y2)
          result = 1;
        else if (y1 > y2)
          result = 7;
        else
          result = 0;
      } else if (x1 > x2) {
        if (y1 < y2)
          result = 3;
        else if (y1 > y2)
          result = 5;
        else
          result = 4;
      } else {
        if (y1 < y2)
          result = 2;
        else if (y1 > y2)
          result = 6;
        else
          result = 8;
      }
      return result;
    }
    const roundToDec = (val, places = void 0) => +val.toFixed(places);
    function colorQuantization(imageData, options) {
      const arr = [];
      let idx = 0;
      let cd;
      let cdl;
      let ci;
      const paletteacc = [];
      const pixelnum = imageData.width * imageData.height;
      let i;
      let j;
      let k;
      let cnt;
      let palette;
      let imageDataCache = imageData.data;
      if (imageDataCache.length < pixelnum * 4) {
        const newImageData = new Uint8ClampedArray(pixelnum * 4);
        for (let pxcnt = 0; pxcnt < pixelnum; pxcnt++) {
          newImageData[pxcnt * 4] = imageDataCache[pxcnt * 3];
          newImageData[pxcnt * 4 + 1] = imageDataCache[pxcnt * 3 + 1];
          newImageData[pxcnt * 4 + 2] = imageDataCache[pxcnt * 3 + 2];
          newImageData[pxcnt * 4 + 3] = 255;
        }
        imageDataCache = newImageData;
      }
      for (j = 0; j < imageData.height + 2; j++) {
        arr[j] = [];
        for (i = 0; i < imageData.width + 2; i++)
          arr[j][i] = -1;
      }
      if (options.pal)
        palette = options.pal;
      else if (options.colorsampling === 0)
        palette = generatePalette(options.numberofcolors);
      else if (options.colorsampling === 1)
        palette = samplePalette(options.numberofcolors, imageData);
      else
        palette = samplePaletteByGrid(options.numberofcolors, imageData);
      if (options.blurradius > 0)
        imageData = blur(imageData, options.blurradius, options.blurdelta);
      for (cnt = 0; cnt < options.colorquantcycles; cnt++) {
        if (cnt > 0) {
          for (k = 0; k < palette.length; k++) {
            if (paletteacc[k].n > 0) {
              palette[k] = {
                r: Math.floor(paletteacc[k].r / paletteacc[k].n),
                g: Math.floor(paletteacc[k].g / paletteacc[k].n),
                b: Math.floor(paletteacc[k].b / paletteacc[k].n),
                a: Math.floor(paletteacc[k].a / paletteacc[k].n)
              };
            }
            if (paletteacc[k].n / pixelnum < options.mincolorratio && cnt < options.colorquantcycles - 1) {
              palette[k] = {
                r: Math.floor(Math.random() * 255),
                g: Math.floor(Math.random() * 255),
                b: Math.floor(Math.random() * 255),
                a: Math.floor(Math.random() * 255)
              };
            }
          }
        }
        for (i = 0; i < palette.length; i++)
          paletteacc[i] = { r: 0, g: 0, b: 0, a: 0, n: 0 };
        for (j = 0; j < imageData.height; j++) {
          for (i = 0; i < imageData.width; i++) {
            idx = (j * imageData.width + i) * 4;
            ci = 0;
            cdl = 1024;
            for (k = 0; k < palette.length; k++) {
              cd = (palette[k].r > imageDataCache[idx] ? palette[k].r - imageDataCache[idx] : imageDataCache[idx] - palette[k].r) + (palette[k].g > imageDataCache[idx + 1] ? palette[k].g - imageDataCache[idx + 1] : imageDataCache[idx + 1] - palette[k].g) + (palette[k].b > imageDataCache[idx + 2] ? palette[k].b - imageDataCache[idx + 2] : imageDataCache[idx + 2] - palette[k].b) + (palette[k].a > imageDataCache[idx + 3] ? palette[k].a - imageDataCache[idx + 3] : imageDataCache[idx + 3] - palette[k].a);
              if (cd < cdl) {
                cdl = cd;
                ci = k;
              }
            }
            paletteacc[ci].r += imageDataCache[idx];
            paletteacc[ci].g += imageDataCache[idx + 1];
            paletteacc[ci].b += imageDataCache[idx + 2];
            paletteacc[ci].a += imageDataCache[idx + 3];
            paletteacc[ci].n++;
            arr[j + 1][i + 1] = ci;
          }
        }
      }
      return { array: arr, palette };
    }
    const toRgbaStr = (c) => `rgba(${c.r},${c.g},${c.b},${c.a})`;

    function svgPathString(tracedata, lnum, pathnum, options) {
      const layer = tracedata.layers[lnum];
      const smp = layer[pathnum];
      let str = "";
      let pcnt;
      if (options.linefilter && smp.segments.length < 3)
        return str;
      str = `<path ${options.desc ? `desc="l ${lnum} p ${pathnum}" ` : ""}${toSvgColorStr(tracedata.palette[lnum], options)}d="`;
      if (options.roundcoords === -1) {
        str += `M ${smp.segments[0].x1 * options.scale} ${smp.segments[0].y1 * options.scale} `;
        for (pcnt = 0; pcnt < smp.segments.length; pcnt++) {
          str += `${smp.segments[pcnt].type} ${smp.segments[pcnt].x2 * options.scale} ${smp.segments[pcnt].y2 * options.scale} `;
          if (smp.segments[pcnt].hasOwnProperty("x3"))
            str += `${smp.segments[pcnt].x3 * options.scale} ${smp.segments[pcnt].y3 * options.scale} `;
        }
        str += "Z ";
      } else {
        str += `M ${roundToDec(smp.segments[0].x1 * options.scale, options.roundcoords)} ${roundToDec(smp.segments[0].y1 * options.scale, options.roundcoords)} `;
        for (pcnt = 0; pcnt < smp.segments.length; pcnt++) {
          str += `${smp.segments[pcnt].type} ${roundToDec(smp.segments[pcnt].x2 * options.scale, options.roundcoords)} ${roundToDec(smp.segments[pcnt].y2 * options.scale, options.roundcoords)} `;
          if (smp.segments[pcnt].hasOwnProperty("x3"))
            str += `${roundToDec(smp.segments[pcnt].x3 * options.scale, options.roundcoords)} ${roundToDec(smp.segments[pcnt].y3 * options.scale, options.roundcoords)} `;
        }
        str += "Z ";
      }
      for (let hcnt = 0; hcnt < smp.holechildren.length; hcnt++) {
        const hsmp = layer[smp.holechildren[hcnt]];
        if (options.roundcoords === -1) {
          if (hsmp.segments[hsmp.segments.length - 1].hasOwnProperty("x3"))
            str += `M ${hsmp.segments[hsmp.segments.length - 1].x3 * options.scale} ${hsmp.segments[hsmp.segments.length - 1].y3 * options.scale} `;
          else
            str += `M ${hsmp.segments[hsmp.segments.length - 1].x2 * options.scale} ${hsmp.segments[hsmp.segments.length - 1].y2 * options.scale} `;
          for (pcnt = hsmp.segments.length - 1; pcnt >= 0; pcnt--) {
            str += `${hsmp.segments[pcnt].type} `;
            if (hsmp.segments[pcnt].hasOwnProperty("x3"))
              str += `${hsmp.segments[pcnt].x2 * options.scale} ${hsmp.segments[pcnt].y2 * options.scale} `;
            str += `${hsmp.segments[pcnt].x1 * options.scale} ${hsmp.segments[pcnt].y1 * options.scale} `;
          }
        } else {
          if (hsmp.segments[hsmp.segments.length - 1].hasOwnProperty("x3"))
            str += `M ${roundToDec(hsmp.segments[hsmp.segments.length - 1].x3 * options.scale)} ${roundToDec(hsmp.segments[hsmp.segments.length - 1].y3 * options.scale)} `;
          else
            str += `M ${roundToDec(hsmp.segments[hsmp.segments.length - 1].x2 * options.scale)} ${roundToDec(hsmp.segments[hsmp.segments.length - 1].y2 * options.scale)} `;
          for (pcnt = hsmp.segments.length - 1; pcnt >= 0; pcnt--) {
            str += `${hsmp.segments[pcnt].type} `;
            if (hsmp.segments[pcnt].hasOwnProperty("x3"))
              str += `${roundToDec(hsmp.segments[pcnt].x2 * options.scale)} ${roundToDec(hsmp.segments[pcnt].y2 * options.scale)} `;
            str += `${roundToDec(hsmp.segments[pcnt].x1 * options.scale)} ${roundToDec(hsmp.segments[pcnt].y1 * options.scale)} `;
          }
        }
        str += "Z ";
      }
      str += '" />';
      if (options.lcpr || options.qcpr) {
        for (pcnt = 0; pcnt < smp.segments.length; pcnt++) {
          if (smp.segments[pcnt].hasOwnProperty("x3") && options.qcpr) {
            str += `<circle cx="${smp.segments[pcnt].x2 * options.scale}" cy="${smp.segments[pcnt].y2 * options.scale}" r="${options.qcpr}" fill="cyan" stroke-width="${options.qcpr * 0.2}" stroke="black" />`;
            str += `<circle cx="${smp.segments[pcnt].x3 * options.scale}" cy="${smp.segments[pcnt].y3 * options.scale}" r="${options.qcpr}" fill="white" stroke-width="${options.qcpr * 0.2}" stroke="black" />`;
            str += `<line x1="${smp.segments[pcnt].x1 * options.scale}" y1="${smp.segments[pcnt].y1 * options.scale}" x2="${smp.segments[pcnt].x2 * options.scale}" y2="${smp.segments[pcnt].y2 * options.scale}" stroke-width="${options.qcpr * 0.2}" stroke="cyan" />`;
            str += `<line x1="${smp.segments[pcnt].x2 * options.scale}" y1="${smp.segments[pcnt].y2 * options.scale}" x2="${smp.segments[pcnt].x3 * options.scale}" y2="${smp.segments[pcnt].y3 * options.scale}" stroke-width="${options.qcpr * 0.2}" stroke="cyan" />`;
          }
          if (!smp.segments[pcnt].hasOwnProperty("x3") && options.lcpr)
            str += `<circle cx="${smp.segments[pcnt].x2 * options.scale}" cy="${smp.segments[pcnt].y2 * options.scale}" r="${options.lcpr}" fill="white" stroke-width="${options.lcpr * 0.2}" stroke="black" />`;
        }
        for (let hcnt = 0; hcnt < smp.holechildren.length; hcnt++) {
          const hsmp = layer[smp.holechildren[hcnt]];
          for (pcnt = 0; pcnt < hsmp.segments.length; pcnt++) {
            if (hsmp.segments[pcnt].hasOwnProperty("x3") && options.qcpr) {
              str += `<circle cx="${hsmp.segments[pcnt].x2 * options.scale}" cy="${hsmp.segments[pcnt].y2 * options.scale}" r="${options.qcpr}" fill="cyan" stroke-width="${options.qcpr * 0.2}" stroke="black" />`;
              str += `<circle cx="${hsmp.segments[pcnt].x3 * options.scale}" cy="${hsmp.segments[pcnt].y3 * options.scale}" r="${options.qcpr}" fill="white" stroke-width="${options.qcpr * 0.2}" stroke="black" />`;
              str += `<line x1="${hsmp.segments[pcnt].x1 * options.scale}" y1="${hsmp.segments[pcnt].y1 * options.scale}" x2="${hsmp.segments[pcnt].x2 * options.scale}" y2="${hsmp.segments[pcnt].y2 * options.scale}" stroke-width="${options.qcpr * 0.2}" stroke="cyan" />`;
              str += `<line x1="${hsmp.segments[pcnt].x2 * options.scale}" y1="${hsmp.segments[pcnt].y2 * options.scale}" x2="${hsmp.segments[pcnt].x3 * options.scale}" y2="${hsmp.segments[pcnt].y3 * options.scale}" stroke-width="${options.qcpr * 0.2}" stroke="cyan" />`;
            }
            if (!hsmp.segments[pcnt].hasOwnProperty("x3") && options.lcpr)
              str += `<circle cx="${hsmp.segments[pcnt].x2 * options.scale}" cy="${hsmp.segments[pcnt].y2 * options.scale}" r="${options.lcpr}" fill="white" stroke-width="${options.lcpr * 0.2}" stroke="black" />`;
          }
        }
      }
      return str;
    }
    function toSvgColorStr(c, options) {
      return `fill="rgb(${c.r},${c.g},${c.b})" stroke="rgb(${c.r},${c.g},${c.b})" stroke-width="${options.strokewidth}" opacity="${c.a / 255}" `;
    }
    function fitSeq(path, ltres, qtres, seqstart, seqend) {
      if (seqend > path.points.length || seqend < 0)
        return [];
      let errorpoint = seqstart;
      let errorval = 0;
      let curvepass = true;
      let px;
      let py;
      let dist2;
      let tl = seqend - seqstart;
      if (tl < 0)
        tl += path.points.length;
      const vx = (path.points[seqend].x - path.points[seqstart].x) / tl;
      const vy = (path.points[seqend].y - path.points[seqstart].y) / tl;
      let pcnt = (seqstart + 1) % path.points.length;
      let pl;
      while (pcnt !== seqend) {
        pl = pcnt - seqstart;
        if (pl < 0)
          pl += path.points.length;
        px = path.points[seqstart].x + vx * pl;
        py = path.points[seqstart].y + vy * pl;
        dist2 = (path.points[pcnt].x - px) * (path.points[pcnt].x - px) + (path.points[pcnt].y - py) * (path.points[pcnt].y - py);
        if (dist2 > ltres)
          curvepass = false;
        if (dist2 > errorval) {
          errorpoint = pcnt;
          errorval = dist2;
        }
        pcnt = (pcnt + 1) % path.points.length;
      }
      if (curvepass)
        return [{ type: "L", x1: path.points[seqstart].x, y1: path.points[seqstart].y, x2: path.points[seqend].x, y2: path.points[seqend].y }];
      const fitpoint = errorpoint;
      curvepass = true;
      errorval = 0;
      let t = (fitpoint - seqstart) / tl;
      let t1 = (1 - t) * (1 - t);
      let t2 = 2 * (1 - t) * t;
      let t3 = t * t;
      const cpx = (t1 * path.points[seqstart].x + t3 * path.points[seqend].x - path.points[fitpoint].x) / -t2;
      const cpy = (t1 * path.points[seqstart].y + t3 * path.points[seqend].y - path.points[fitpoint].y) / -t2;
      pcnt = seqstart + 1;
      while (pcnt !== seqend) {
        t = (pcnt - seqstart) / tl;
        t1 = (1 - t) * (1 - t);
        t2 = 2 * (1 - t) * t;
        t3 = t * t;
        px = t1 * path.points[seqstart].x + t2 * cpx + t3 * path.points[seqend].x;
        py = t1 * path.points[seqstart].y + t2 * cpy + t3 * path.points[seqend].y;
        dist2 = (path.points[pcnt].x - px) * (path.points[pcnt].x - px) + (path.points[pcnt].y - py) * (path.points[pcnt].y - py);
        if (dist2 > qtres)
          curvepass = false;
        if (dist2 > errorval) {
          errorpoint = pcnt;
          errorval = dist2;
        }
        pcnt = (pcnt + 1) % path.points.length;
      }
      if (curvepass)
        return [{ type: "Q", x1: path.points[seqstart].x, y1: path.points[seqstart].y, x2: cpx, y2: cpy, x3: path.points[seqend].x, y3: path.points[seqend].y }];
      const splitpoint = fitpoint;
      return fitSeq(path, ltres, qtres, seqstart, splitpoint).concat(fitSeq(path, ltres, qtres, splitpoint, seqend));
    }
    function boundingBoxIncludes(parentbbox, childbbox) {
      return parentbbox[0] < childbbox[0] && parentbbox[1] < childbbox[1] && parentbbox[2] > childbbox[2] && parentbbox[3] > childbbox[3];
    }
    function pointInPoly(p, pa) {
      let isin = false;
      for (let i = 0, j = pa.length - 1; i < pa.length; j = i++) {
        isin = pa[i].y > p.y !== pa[j].y > p.y && p.x < (pa[j].x - pa[i].x) * (p.y - pa[i].y) / (pa[j].y - pa[i].y) + pa[i].x ? !isin : isin;
      }
      return isin;
    }
    function getSvgString(tracedata, options) {
      const w = tracedata.width * options.scale;
      const h = tracedata.height * options.scale;
      let svgstr = `<svg ${options.viewbox ? `viewBox="0 0 ${w} ${h}" ` : `width="${w}" height="${h}" `}version="1.1" xmlns="http://www.w3.org/2000/svg" desc="Created with imagetracer.js version ${VERSION_NUMBER}" >`;
      for (let lcnt = 0; lcnt < tracedata.layers.length; lcnt++) {
        for (let pcnt = 0; pcnt < tracedata.layers[lcnt].length; pcnt++) {
          if (!tracedata.layers[lcnt][pcnt].isholepath)
            svgstr += svgPathString(tracedata, lcnt, pcnt, options);
        }
      }
      svgstr += "</svg>";
      return svgstr;
    }

    function testRightAngle(path, idx1, idx2, idx3, idx4, idx5) {
      return path.points[idx3].x === path.points[idx1].x && path.points[idx3].x === path.points[idx2].x && path.points[idx3].y === path.points[idx4].y && path.points[idx3].y === path.points[idx5].y || path.points[idx3].y === path.points[idx1].y && path.points[idx3].y === path.points[idx2].y && path.points[idx3].x === path.points[idx4].x && path.points[idx3].x === path.points[idx5].x;
    }
    function pathScan(arr, pathomit) {
      const paths = [];
      let pacnt = 0;
      let pcnt = 0;
      let px = 0;
      let py = 0;
      const w = arr[0].length;
      const h = arr.length;
      let dir = 0;
      let pathfinished = true;
      let holepath = false;
      let lookuprow;
      for (let j = 0; j < h; j++) {
        for (let i = 0; i < w; i++) {
          if (arr[j][i] === 4 || arr[j][i] === 11) {
            px = i;
            py = j;
            paths[pacnt] = {};
            paths[pacnt].points = [];
            paths[pacnt].boundingbox = [px, py, px, py];
            paths[pacnt].holechildren = [];
            pathfinished = false;
            pcnt = 0;
            holepath = arr[j][i] === 11;
            dir = 1;
            while (!pathfinished) {
              paths[pacnt].points[pcnt] = {};
              paths[pacnt].points[pcnt].x = px - 1;
              paths[pacnt].points[pcnt].y = py - 1;
              paths[pacnt].points[pcnt].t = arr[py][px];
              if (px - 1 < paths[pacnt].boundingbox[0])
                paths[pacnt].boundingbox[0] = px - 1;
              if (px - 1 > paths[pacnt].boundingbox[2])
                paths[pacnt].boundingbox[2] = px - 1;
              if (py - 1 < paths[pacnt].boundingbox[1])
                paths[pacnt].boundingbox[1] = py - 1;
              if (py - 1 > paths[pacnt].boundingbox[3])
                paths[pacnt].boundingbox[3] = py - 1;
              lookuprow = PATHSCAN_COMBINED_LOOKUP[arr[py][px]][dir];
              arr[py][px] = lookuprow[0];
              dir = lookuprow[1];
              px += lookuprow[2];
              py += lookuprow[3];
              if (px - 1 === paths[pacnt].points[0].x && py - 1 === paths[pacnt].points[0].y) {
                pathfinished = true;
                if (paths[pacnt].points.length < pathomit) {
                  paths.pop();
                } else {
                  paths[pacnt].isholepath = !!holepath;
                  if (holepath) {
                    let parentidx = 0;
                    let parentbbox = [-1, -1, w + 1, h + 1];
                    for (let parentcnt = 0; parentcnt < pacnt; parentcnt++) {
                      if (!paths[parentcnt].isholepath && boundingBoxIncludes(paths[parentcnt].boundingbox, paths[pacnt].boundingbox) && boundingBoxIncludes(parentbbox, paths[parentcnt].boundingbox) && pointInPoly(paths[pacnt].points[0], paths[parentcnt].points)) {
                        parentidx = parentcnt;
                        parentbbox = paths[parentcnt].boundingbox;
                      }
                    }
                    paths[parentidx].holechildren.push(pacnt);
                  }
                  pacnt++;
                }
              }
              pcnt++;
            }
          }
        }
      }
      return paths;
    }
    function batchPathScan(layers, pathomit) {
      const bpaths = [];
      for (let k = 0; k < layers.length; k++)
        bpaths[k] = pathScan(layers[k], pathomit);
      return bpaths;
    }
    function tracePath(path, ltres, qtres) {
      let pcnt = 0;
      let segtype1;
      let segtype2;
      let seqend;
      const smp = {
        segments: [],
        boundingbox: path.boundingbox,
        holechildren: path.holechildren,
        isholepath: path.isholepath
      };
      while (pcnt < path.points.length) {
        segtype1 = path.points[pcnt].linesegment;
        segtype2 = -1;
        seqend = pcnt + 1;
        while ((path.points[seqend].linesegment === segtype1 || path.points[seqend].linesegment === segtype2 || segtype2 === -1) && seqend < path.points.length - 1) {
          if (path.points[seqend].linesegment !== segtype1 && segtype2 === -1)
            segtype2 = path.points[seqend].linesegment;
          seqend++;
        }
        if (seqend === path.points.length - 1)
          seqend = 0;
        smp.segments = smp.segments.concat(fitSeq(path, ltres, qtres, pcnt, seqend));
        if (seqend > 0)
          pcnt = seqend;
        else
          pcnt = path.points.length;
      }
      return smp;
    }
    function batchTracePaths(internodepaths, ltres, qtres) {
      const btracedpaths = [];
      for (let k = 0; k < internodepaths.length; k++)
        btracedpaths.push(tracePath(internodepaths[k], ltres, qtres));
      return btracedpaths;
    }

    function batchInterNodes(bpaths, options) {
      const binternodes = [];
      for (let k = 0; k < bpaths.length; k++)
        binternodes[k] = interNodes(bpaths[k], options);
      return binternodes;
    }
    function interNodes(paths, options) {
      const ins = [];
      let palen = 0;
      let nextidx = 0;
      let nextidx2 = 0;
      let previdx = 0;
      let previdx2 = 0;
      let pacnt;
      let pcnt;
      for (pacnt = 0; pacnt < paths.length; pacnt++) {
        ins[pacnt] = {};
        ins[pacnt].points = [];
        ins[pacnt].boundingbox = paths[pacnt].boundingbox;
        ins[pacnt].holechildren = paths[pacnt].holechildren;
        ins[pacnt].isholepath = paths[pacnt].isholepath;
        palen = paths[pacnt].points.length;
        for (pcnt = 0; pcnt < palen; pcnt++) {
          nextidx = (pcnt + 1) % palen;
          nextidx2 = (pcnt + 2) % palen;
          previdx = (pcnt - 1 + palen) % palen;
          previdx2 = (pcnt - 2 + palen) % palen;
          if (options.rightangleenhance && testRightAngle(paths[pacnt], previdx2, previdx, pcnt, nextidx, nextidx2)) {
            if (ins[pacnt].points.length > 0) {
              ins[pacnt].points[ins[pacnt].points.length - 1].linesegment = getDirection(ins[pacnt].points[ins[pacnt].points.length - 1].x, ins[pacnt].points[ins[pacnt].points.length - 1].y, paths[pacnt].points[pcnt].x, paths[pacnt].points[pcnt].y);
            }
            ins[pacnt].points.push({
              x: paths[pacnt].points[pcnt].x,
              y: paths[pacnt].points[pcnt].y,
              linesegment: getDirection(paths[pacnt].points[pcnt].x, paths[pacnt].points[pcnt].y, (paths[pacnt].points[pcnt].x + paths[pacnt].points[nextidx].x) / 2, (paths[pacnt].points[pcnt].y + paths[pacnt].points[nextidx].y) / 2)
            });
          }
          ins[pacnt].points.push({
            x: (paths[pacnt].points[pcnt].x + paths[pacnt].points[nextidx].x) / 2,
            y: (paths[pacnt].points[pcnt].y + paths[pacnt].points[nextidx].y) / 2,
            linesegment: getDirection((paths[pacnt].points[pcnt].x + paths[pacnt].points[nextidx].x) / 2, (paths[pacnt].points[pcnt].y + paths[pacnt].points[nextidx].y) / 2, (paths[pacnt].points[nextidx].x + paths[pacnt].points[nextidx2].x) / 2, (paths[pacnt].points[nextidx].y + paths[pacnt].points[nextidx2].y) / 2)
          });
        }
      }
      return ins;
    }

    function batchTraceLayers(binternodes, ltres, qtres) {
      const btbis = [];
      for (let k = 0; k < binternodes.length; k++)
        btbis[k] = batchTracePaths(binternodes[k], ltres, qtres);
      return btbis;
    }
    function layering(ii) {
      const layers = [];
      let val = 0;
      const ah = ii.array.length;
      const aw = ii.array[0].length;
      let n1;
      let n2;
      let n3;
      let n4;
      let n5;
      let n6;
      let n7;
      let n8;
      let i;
      let j;
      let k;
      for (k = 0; k < ii.palette.length; k++) {
        layers[k] = [];
        for (j = 0; j < ah; j++) {
          layers[k][j] = [];
          for (i = 0; i < aw; i++)
            layers[k][j][i] = 0;
        }
      }
      for (j = 1; j < ah - 1; j++) {
        for (i = 1; i < aw - 1; i++) {
          val = ii.array[j][i];
          n1 = ii.array[j - 1][i - 1] === val ? 1 : 0;
          n2 = ii.array[j - 1][i] === val ? 1 : 0;
          n3 = ii.array[j - 1][i + 1] === val ? 1 : 0;
          n4 = ii.array[j][i - 1] === val ? 1 : 0;
          n5 = ii.array[j][i + 1] === val ? 1 : 0;
          n6 = ii.array[j + 1][i - 1] === val ? 1 : 0;
          n7 = ii.array[j + 1][i] === val ? 1 : 0;
          n8 = ii.array[j + 1][i + 1] === val ? 1 : 0;
          layers[val][j + 1][i + 1] = 1 + n5 * 2 + n8 * 4 + n7 * 8;
          if (!n4)
            layers[val][j + 1][i] = 0 + 2 + n7 * 4 + n6 * 8;
          if (!n2)
            layers[val][j][i + 1] = 0 + n3 * 2 + n5 * 4 + 8;
          if (!n1)
            layers[val][j][i] = 0 + n2 * 2 + 4 + n4 * 8;
        }
      }
      return layers;
    }
    function layeringStep(ii, cnum) {
      const layer = [];
      const ah = ii.array.length;
      const aw = ii.array[0].length;
      let i;
      let j;
      for (j = 0; j < ah; j++) {
        layer[j] = [];
        for (i = 0; i < aw; i++)
          layer[j][i] = 0;
      }
      for (j = 1; j < ah; j++) {
        for (i = 1; i < aw; i++) {
          layer[j][i] = (ii.array[j - 1][i - 1] === cnum ? 1 : 0) + (ii.array[j - 1][i] === cnum ? 2 : 0) + (ii.array[j][i - 1] === cnum ? 8 : 0) + (ii.array[j][i] === cnum ? 4 : 0);
        }
      }
      return layer;
    }
    function drawLayers(layers, palette, scale = 1, parentid) {
      let w, h, i, j;
      let div;
      if (parentid) {
        div = document.getElementById(parentid);
        if (!div) {
          div = document.createElement("div");
          div.id = parentid;
          document.body.appendChild(div);
        }
      } else {
        div = document.createElement("div");
        document.body.appendChild(div);
      }
      for (const layer of layers) {
        w = layer[0].length;
        h = layer.length;
        const canvas = document.createElement("canvas");
        canvas.width = w * scale;
        canvas.height = h * scale;
        const context = canvas.getContext("2d");
        for (j = 0; j < h; j++) {
          for (i = 0; i < w; i++) {
            context.fillStyle = toRgbaStr(palette[layer[j][i] % palette.length]);
            context.fillRect(i * scale, j * scale, scale, scale);
          }
        }
        div.appendChild(canvas);
      }
    }

    class ImageTracer {
      constructor() {
        this.versionnumber = VERSION_NUMBER;
        this.optionpresets = OPTION_PRESETS;
      }
      checkOptions(options) {
        if (options === void 0)
          return { ...this.optionpresets.default };
        if (typeof options === "string") {
          const presetName = options;
          const preset = this.optionpresets[presetName];
          return { ...this.optionpresets.default, ...preset || {} };
        }
        if (typeof options === "object") {
          return { ...this.optionpresets.default, ...options };
        }
        throw new Error(`Unknown Option Type: ${typeof options}`);
      }
      async imageToSVG(url, options) {
        options = this.checkOptions(options);
        const canvas = await this.loadImage(url, options);
        return this.imageDataToSVG(this.getImgdata(canvas), options);
      }
      getImgdata(canvas) {
        const context = canvas.getContext("2d");
        return context.getImageData(0, 0, canvas.width, canvas.height);
      }
      loadImage(url, options) {
        return new Promise((resolve) => {
          const img = new Image();
          if (options && options.corsenabled)
            img.crossOrigin = "Anonymous";
          img.src = url;
          img.onload = function() {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const context = canvas.getContext("2d");
            context?.drawImage(img, 0, 0);
            resolve(canvas);
          };
        });
      }
      imageDataToSVG(imgd, options) {
        options = this.checkOptions(options);
        const td = this.imageDataToTracedata(imgd, options);
        return getSvgString(td, options);
      }
      async imageToTracedata(url, options) {
        options = this.checkOptions(options);
        const canvas = await this.loadImage(url, options);
        return this.imageDataToTracedata(this.getImgdata(canvas), options);
      }
      imageDataToTracedata(imgd, options) {
        options = this.checkOptions(options);
        let tracedata;
        const ii = colorQuantization(imgd, options);
        if (options.layering === 0) {
          tracedata = {
            layers: [],
            palette: ii.palette,
            width: ii.array[0].length - 2,
            height: ii.array.length - 2
          };
          for (let colornum = 0; colornum < ii.palette.length; colornum++) {
            const tracedlayer = batchTracePaths(interNodes(pathScan(layeringStep(ii, colornum), options.pathomit), options), options.ltres, options.qtres);
            tracedata.layers.push(tracedlayer);
          }
        } else {
          const ls = layering(ii);
          if (options.layercontainerid)
            drawLayers(ls, SPECPALETTE, options.scale, options.layercontainerid);
          const bps = batchPathScan(ls, options.pathomit);
          const bis = batchInterNodes(bps, options);
          tracedata = {
            layers: batchTraceLayers(bis, options.ltres, options.qtres),
            palette: ii.palette,
            width: imgd.width,
            height: imgd.height
          };
        }
        return tracedata;
      }
      appendSVGString(svgstr, parentid) {
        let div;
        if (parentid) {
          div = document.getElementById(parentid);
          if (!div) {
            div = document.createElement("div");
            div.id = parentid;
            document.body.appendChild(div);
          }
        } else {
          div = document.createElement("div");
          document.body.appendChild(div);
        }
        div.innerHTML += svgstr;
      }
    }
    const imageTracer = new ImageTracer();

    function getLocator(source, options) {
        if (options === void 0) { options = {}; }
        var offsetLine = options.offsetLine || 0;
        var offsetColumn = options.offsetColumn || 0;
        var originalLines = source.split('\n');
        var start = 0;
        var lineRanges = originalLines.map(function (line, i) {
            var end = start + line.length + 1;
            var range = { start: start, end: end, line: i };
            start = end;
            return range;
        });
        var i = 0;
        function rangeContains(range, index) {
            return range.start <= index && index < range.end;
        }
        function getLocation(range, index) {
            return { line: offsetLine + range.line, column: offsetColumn + index - range.start, character: index };
        }
        function locate(search, startIndex) {
            if (typeof search === 'string') {
                search = source.indexOf(search, startIndex || 0);
            }
            var range = lineRanges[i];
            var d = search >= range.end ? 1 : -1;
            while (range) {
                if (rangeContains(range, search))
                    return getLocation(range, search);
                i += d;
                range = lineRanges[i];
            }
        }
        return locate;
    }
    function locate(source, search, options) {
        if (typeof options === 'number') {
            throw new Error('locate takes a { startIndex, offsetLine, offsetColumn } object as the third argument');
        }
        return getLocator(source, options)(search, options && options.startIndex);
    }

    var validNameCharacters = /[a-zA-Z0-9:_-]/;
    var whitespace = /[\s\t\r\n]/;
    var quotemark = /['"]/;

    function repeat(str, i) {
    	var result = '';
    	while (i--) { result += str; }
    	return result;
    }

    function parse$1(source) {
    	var header = '';
    	var stack = [];

    	var state = metadata;
    	var currentElement = null;
    	var root = null;

    	function error(message) {
    		var ref = locate(source, i);
    		var line = ref.line;
    		var column = ref.column;
    		var before = source.slice(0, i);
    		var beforeLine = /(^|\n).*$/.exec(before)[0].replace(/\t/g, '  ');
    		var after = source.slice(i);
    		var afterLine = /.*(\n|$)/.exec(after)[0];

    		var snippet = "" + beforeLine + afterLine + "\n" + (repeat(' ', beforeLine.length)) + "^";

    		throw new Error(
    			(message + " (" + line + ":" + column + "). If this is valid SVG, it's probably a bug in svg-parser. Please raise an issue at https://github.com/Rich-Harris/svg-parser/issues – thanks!\n\n" + snippet)
    		);
    	}

    	function metadata() {
    		while ((i < source.length && source[i] !== '<') || !validNameCharacters.test(source[i + 1])) {
    			header += source[i++];
    		}

    		return neutral();
    	}

    	function neutral() {
    		var text = '';
    		while (i < source.length && source[i] !== '<') { text += source[i++]; }

    		if (/\S/.test(text)) {
    			currentElement.children.push({ type: 'text', value: text });
    		}

    		if (source[i] === '<') {
    			return tag;
    		}

    		return neutral;
    	}

    	function tag() {
    		var char = source[i];

    		if (char === '?') { return neutral; } // <?xml...

    		if (char === '!') {
    			if (source.slice(i + 1, i + 3) === '--') { return comment; }
    			if (source.slice(i + 1, i + 8) === '[CDATA[') { return cdata; }
    			if (/doctype/i.test(source.slice(i + 1, i + 8))) { return neutral; }
    		}

    		if (char === '/') { return closingTag; }

    		var tagName = getName();

    		var element = {
    			type: 'element',
    			tagName: tagName,
    			properties: {},
    			children: []
    		};

    		if (currentElement) {
    			currentElement.children.push(element);
    		} else {
    			root = element;
    		}

    		var attribute;
    		while (i < source.length && (attribute = getAttribute())) {
    			element.properties[attribute.name] = attribute.value;
    		}

    		var selfClosing = false;

    		if (source[i] === '/') {
    			i += 1;
    			selfClosing = true;
    		}

    		if (source[i] !== '>') {
    			error('Expected >');
    		}

    		if (!selfClosing) {
    			currentElement = element;
    			stack.push(element);
    		}

    		return neutral;
    	}

    	function comment() {
    		var index = source.indexOf('-->', i);
    		if (!~index) { error('expected -->'); }

    		i = index + 2;
    		return neutral;
    	}

    	function cdata() {
    		var index = source.indexOf(']]>', i);
    		if (!~index) { error('expected ]]>'); }

    		currentElement.children.push(source.slice(i + 7, index));

    		i = index + 2;
    		return neutral;
    	}

    	function closingTag() {
    		var tagName = getName();

    		if (!tagName) { error('Expected tag name'); }

    		if (tagName !== currentElement.tagName) {
    			error(("Expected closing tag </" + tagName + "> to match opening tag <" + (currentElement.tagName) + ">"));
    		}

    		allowSpaces();

    		if (source[i] !== '>') {
    			error('Expected >');
    		}

    		stack.pop();
    		currentElement = stack[stack.length - 1];

    		return neutral;
    	}

    	function getName() {
    		var name = '';
    		while (i < source.length && validNameCharacters.test(source[i])) { name += source[i++]; }

    		return name;
    	}

    	function getAttribute() {
    		if (!whitespace.test(source[i])) { return null; }
    		allowSpaces();

    		var name = getName();
    		if (!name) { return null; }

    		var value = true;

    		allowSpaces();
    		if (source[i] === '=') {
    			i += 1;
    			allowSpaces();

    			value = getAttributeValue();
    			if (!isNaN(value) && value.trim() !== '') { value = +value; } // TODO whitelist numeric attributes?
    		}

    		return { name: name, value: value };
    	}

    	function getAttributeValue() {
    		return quotemark.test(source[i]) ? getQuotedAttributeValue() : getUnquotedAttributeValue();
    	}

    	function getUnquotedAttributeValue() {
    		var value = '';
    		do {
    			var char = source[i];
    			if (char === ' ' || char === '>' || char === '/') {
    				return value;
    			}

    			value += char;
    			i += 1;
    		} while (i < source.length);

    		return value;
    	}

    	function getQuotedAttributeValue() {
    		var quotemark = source[i++];

    		var value = '';
    		var escaped = false;

    		while (i < source.length) {
    			var char = source[i++];
    			if (char === quotemark && !escaped) {
    				return value;
    			}

    			if (char === '\\' && !escaped) {
    				escaped = true;
    			}

    			value += escaped ? ("\\" + char) : char;
    			escaped = false;
    		}
    	}

    	function allowSpaces() {
    		while (i < source.length && whitespace.test(source[i])) { i += 1; }
    	}

    	var i = metadata.length;
    	while (i < source.length) {
    		if (!state) { error('Unexpected character'); }
    		state = state();
    		i += 1;
    	}

    	if (state !== neutral) {
    		error('Unexpected end of input');
    	}

    	if (root.tagName === 'svg') { root.metadata = header; }
    	return {
    		type: 'root',
    		children: [root]
    	};
    }

    class SvgConverter {
        static overwriteSketchWithSvg(node, data) {
            const decover = new TextDecoder();
            node.paths.clear();
            const header = data.slice(0, 100);
            header.arrayBuffer().then(buffer => {
                const headerText = decover.decode(buffer);
                if (headerText.search(/JFIF/) !== -1 || headerText.search(/PNG/) !== -1) {
                    // is raster
                    const dataUrl = URL.createObjectURL(data);
                    const options = {
                        qtres: 0.1,
                        pathomit: 16,
                        numberofcolors: 2,
                    };
                    const nodeManager = node._manager;
                    if (!nodeManager) {
                        throw Error('no node manager');
                    }
                    imageTracer.imageToTracedata(dataUrl, options).then((trace) => {
                        if (trace.palette && trace.palette.length > 1) {
                            const pathParser = new PathHandler(node, SvgConverter.calculateScaleDivider([0, 0, trace.width, trace.height]), nodeManager);
                            const paletteStrengths = trace.palette.map((color, idx) => ({
                                idx,
                                strength: getPaletteColorStrength(color),
                            }));
                            paletteStrengths.sort((a, b) => a.strength - b.strength);
                            const bgIdx = paletteStrengths[0].idx;
                            trace.layers.splice(bgIdx, 1);
                            const primaryLayers = trace.layers.flat();
                            const pathsCreated = [];
                            // Convert layers to sketchPaths
                            primaryLayers.forEach((layer, layerIndex) => {
                                const newPaths = pathParser.parseTrace(layer.segments);
                                const pathGroupKey = 'tracedPath' + layerIndex;
                                pathsCreated[layerIndex] = newPaths;
                                newPaths.forEach(path => {
                                    path.pathGroupKey = pathGroupKey;
                                });
                                node.paths.push(...newPaths);
                            });
                            // Convert layers to holes
                            primaryLayers.forEach((layer, layerIndex) => {
                                if (layer.holechildren) {
                                    layer.holechildren.forEach(holeLayerIdx => {
                                        const pathSet = pathsCreated[holeLayerIdx];
                                        if (pathSet) {
                                            pathSet.forEach(path => {
                                                path.holeForPathGroup = 'tracedPath' + layerIndex;
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                else {
                    data.text().then(svgText => {
                        const parsedSVG = parse$1(svgText);
                        SvgConverter.parseSvgRecursively(node, parsedSVG);
                    });
                }
            });
        }
        static findSvgViewBox(svg) {
            for (let i = 0; i < svg.children.length; i++) {
                const child = svg.children[i];
                if (typeof child === 'string') {
                    return undefined;
                }
                else if (child.tagName === 'svg' && 'properties' in child) {
                    return getViewBoxFromSvgElement(child);
                }
            }
            function getViewBoxFromSvgElement(elem) {
                var _a, _b, _c;
                if (typeof ((_a = elem.properties) === null || _a === void 0 ? void 0 : _a.viewBox) === 'string' && elem.properties.viewBox) {
                    return elem.properties.viewBox.split(' ').map(int => parseInt(int));
                }
                if (((_b = elem.properties) === null || _b === void 0 ? void 0 : _b.width) && ((_c = elem.properties) === null || _c === void 0 ? void 0 : _c.height)) {
                    const width = elem.properties.width;
                    const height = elem.properties.height;
                    return [
                        0,
                        0,
                        typeof width === 'string' ? parseInt(width) : width,
                        typeof height === 'string' ? parseInt(height) : height,
                    ];
                }
            }
        }
        static parseSvgRecursively(node, svg, viewBox) {
            if (!viewBox) {
                viewBox = SvgConverter.findSvgViewBox(svg) || [0, 0, 100, 100];
            }
            if (svg.children) {
                const nodeManager = node._manager;
                if (!nodeManager) {
                    throw Error('no node manager');
                }
                for (let i = 0; i < svg.children.length; i++) {
                    const child = svg.children[i];
                    if (child.tagName === 'path' && child.properties) {
                        const pathParser = new PathHandler(node, SvgConverter.calculateScaleDivider(viewBox), nodeManager);
                        const newPaths = pathParser.parsePath(child.properties.d);
                        node.paths.push(...newPaths);
                        //call actual parser
                    }
                    else if (child.tagName === 'rect' && child.properties) {
                        SvgConverter.createRectangle(node, child, viewBox);
                    }
                    else if (child.tagName === 'circle' && child.properties) {
                        SvgConverter.createCircle(node, child, viewBox);
                    }
                    else if (child.tagName === 'polyline' && child.properties) {
                        SvgConverter.createPolyLine(node, child, viewBox);
                    }
                    else if (child.tagName === 'line' && child.properties) {
                        SvgConverter.createLine(node, child, viewBox);
                    }
                    else if (child.tagName === 'polygon' && child.properties) {
                        SvgConverter.createPolyLine(node, child, viewBox, true);
                    }
                    SvgConverter.parseSvgRecursively(node, child, viewBox);
                    nameGeneratedPaths(node);
                }
            }
        }
        static removeBackGroundOnConvertedSVG(children) {
            const parent = children[0];
            const newChildren = parent.children;
            const resultChildren = [];
            newChildren.forEach(child => {
                if (child && child.properties) {
                    if ('opacity' in child.properties) {
                        if (child.properties.opacity == 1) {
                            resultChildren.push(child);
                        }
                    }
                }
            });
            newChildren.clear();
            resultChildren.forEach(child => {
                newChildren.push(child);
            });
            // if (svg.children) {
            //     console.log(svg.children.length);
            //     for (let i = 0; i < svg.children.length; i++) {
            //         const child = svg.children[i] as ElementNode;
            //         if (child.properties) {
            //             if (child.properties.opacity) {
            //                 if (Number(child.properties.opacity) < 1) {
            //                     console.log('Not a valid path');
            //                     svg.children.remove(child);
            //                 } else {
            //                     console.log('valid path:', child);
            //                 }
            //             }
            //         }
            //         this.removeBackGroundOnConvertedSVG(child);
            //     }
            // }
        }
        // static projectSketchOnNormal(node: SketchNode) {
        //     node.paths.forEach(path => {
        //         path.controlPoints.forEach(point => {
        //             if (node.normal === eAxis.y) {
        //                 point.position = new KbVector(point.position.x, 0, point.position.y);
        //                 point.direction = new KbVector(point.direction.x, 0, point.direction.y);
        //                 if (point.direction2) {
        //                     point.direction2 = new KbVector(point.direction2.x, 0, point.direction2.y);
        //                 }
        //             } else if (node.normal === eAxis.x) {
        //                 point.position = new KbVector(0, point.position.y, point.position.x);
        //                 point.direction = new KbVector(0, point.direction.y, point.direction.x);
        //                 if (point.direction2) {
        //                     point.direction2 = new KbVector(0, point.direction2.y, point.direction2.x);
        //                 }
        //             }
        //         });
        //     });
        // }
        static calculateScaleDivider(viewbox) {
            if (viewbox) {
                const width = viewbox[2];
                const height = viewbox[3];
                if (width > height) {
                    return width;
                }
                else {
                    return height;
                }
            }
            else {
                return 1;
            }
        }
        static addNewPath(node, pathType) {
            const nodeManager = node._manager;
            if (!nodeManager) {
                throw Error('no node manager');
            }
            const newPath = nodeManager.create(Token.SketchPath);
            if (newPath) {
                newPath.name = 'Path';
                newPath._expanded = true;
                if (pathType) {
                    newPath.type = pathType;
                }
                node.paths.push(newPath);
            }
            return newPath;
        }
        static createRectangle(node, element, viewbox) {
            const nodeManager = node._manager;
            if (!nodeManager) {
                throw Error('no node manager');
            }
            const scaleDivider = SvgConverter.calculateScaleDivider(viewbox);
            if (!element.properties) {
                return;
            }
            const x = element.properties.x / scaleDivider;
            const y = (element.properties.y / scaleDivider) * -1;
            const rx = element.properties.rx / scaleDivider;
            const ry = (element.properties.ry / scaleDivider) * -1;
            const width = element.properties.width / scaleDivider;
            const height = (element.properties.height / scaleDivider) * -1;
            let newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.points);
            if (rx && ry) {
                const newControlPoint = nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = projectOnNodeAxis(node, x, y + ry);
                newPath.controlPoints.push(newControlPoint);
                const newControlPoint2 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint2.position = projectOnNodeAxis(node, x, y + height - ry);
                newPath.controlPoints.push(newControlPoint2);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.quadraticBezier);
                const newControlPoint3 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint3.position = projectOnNodeAxis(node, x, y + height - ry);
                newControlPoint3.direction = projectOnNodeAxis(node, 0, ry);
                newPath.controlPoints.push(newControlPoint3);
                const newControlPoint4 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint4.position = projectOnNodeAxis(node, x + rx, y + height);
                newPath.controlPoints.push(newControlPoint4);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.points);
                const newControlPoint5 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint5.position = projectOnNodeAxis(node, x + rx, y + height);
                newPath.controlPoints.push(newControlPoint5);
                const newControlPoint6 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint6.position = projectOnNodeAxis(node, width + x - rx, y + height);
                newPath.controlPoints.push(newControlPoint6);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.quadraticBezier);
                const newControlPoint7 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint7.position = projectOnNodeAxis(node, width + x - rx, y + height);
                newControlPoint7.direction = projectOnNodeAxis(node, -ry, 0);
                newPath.controlPoints.push(newControlPoint7);
                const newControlPoint8 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint8.position = projectOnNodeAxis(node, width + x, y + height - ry);
                newPath.controlPoints.push(newControlPoint8);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.points);
                const newControlPoint9 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint9.position = projectOnNodeAxis(node, width + x, y + height - ry);
                newPath.controlPoints.push(newControlPoint9);
                const newControlPoint10 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint10.position = projectOnNodeAxis(node, width + x, y + ry);
                newPath.controlPoints.push(newControlPoint10);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.quadraticBezier);
                const newControlPoint11 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint11.position = projectOnNodeAxis(node, width + x, y + ry);
                newControlPoint11.direction = projectOnNodeAxis(node, 0, -ry);
                newPath.controlPoints.push(newControlPoint11);
                const newControlPoint12 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint12.position = projectOnNodeAxis(node, width + x - rx, y);
                newPath.controlPoints.push(newControlPoint12);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.points);
                const newControlPoint13 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint13.position = projectOnNodeAxis(node, width + x - rx, y);
                newPath.controlPoints.push(newControlPoint13);
                const newControlPoint14 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint14.position = projectOnNodeAxis(node, x + rx, y);
                newPath.controlPoints.push(newControlPoint14);
                newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.quadraticBezier);
                const newControlPoint15 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint15.position = projectOnNodeAxis(node, x + rx, y);
                newControlPoint15.direction = projectOnNodeAxis(node, ry, 0);
                newPath.controlPoints.push(newControlPoint15);
                const newControlPoint16 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint16.position = projectOnNodeAxis(node, x, y + ry);
                newPath.controlPoints.push(newControlPoint16);
            }
            else {
                const newControlPoint = nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = projectOnNodeAxis(node, x, y);
                newPath.controlPoints.push(newControlPoint);
                const newControlPoint2 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint2.position = projectOnNodeAxis(node, x, y + height);
                newPath.controlPoints.push(newControlPoint2);
                const newControlPoint3 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint3.position = projectOnNodeAxis(node, x + width, y + height);
                newPath.controlPoints.push(newControlPoint3);
                const newControlPoint4 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint4.position = projectOnNodeAxis(node, x + width, y);
                newPath.controlPoints.push(newControlPoint4);
                const newControlPoint5 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint5.position = projectOnNodeAxis(node, x, y);
                newPath.controlPoints.push(newControlPoint5);
            }
        }
        static createCircle(node, element, viewbox) {
            const nodeManager = node._manager;
            if (!nodeManager) {
                throw Error('no node manager');
            }
            const scaleDivider = SvgConverter.calculateScaleDivider(viewbox);
            if (element.properties) {
                const cx = element.properties.cx / scaleDivider;
                const cy = (element.properties.cy / scaleDivider) * -1;
                const radius = element.properties.r / scaleDivider;
                const newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.centerRadiusCircle);
                const newControlPoint = nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = projectOnNodeAxis(node, cx, cy);
                newControlPoint.direction = new exports.KbVector(0, 0, 1);
                newPath.controlPoints.push(newControlPoint);
                const newControlPoint2 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint2.position = projectOnNodeAxis(node, cx + radius, cy);
                newPath.controlPoints.push(newControlPoint2);
            }
        }
        static createLine(node, element, viewbox) {
            const nodeManager = node._manager;
            if (!nodeManager) {
                throw Error('no node manager');
            }
            const scaleDivider = SvgConverter.calculateScaleDivider(viewbox);
            if (element.properties) {
                const newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.points);
                const x1 = element.properties.x1 / scaleDivider;
                const y1 = (element.properties.y1 / scaleDivider) * -1;
                const x2 = element.properties.x2 / scaleDivider;
                const y2 = (element.properties.y2 / scaleDivider) * -1;
                const newControlPoint = nodeManager.create(Token.SketchControlPoint);
                newControlPoint.position = projectOnNodeAxis(node, x1, y1);
                newPath.controlPoints.push(newControlPoint);
                const newControlPoint2 = nodeManager.create(Token.SketchControlPoint);
                newControlPoint2.position = projectOnNodeAxis(node, x2, y2);
                newPath.controlPoints.push(newControlPoint2);
            }
        }
        static createPolyLine(node, element, viewbox, closePath = false) {
            const nodeManager = node._manager;
            if (!nodeManager) {
                throw Error('no node manager');
            }
            const scaleDivider = SvgConverter.calculateScaleDivider(viewbox);
            if (element.properties) {
                const newPath = SvgConverter.addNewPath(node, exports.eSketchPathType.points);
                const points = element.properties.points.replace(',', ' ').split(' ');
                for (let i = 0; i < points.length; i = i + 2) {
                    const newControlPoint = nodeManager.create(Token.SketchControlPoint);
                    newControlPoint.position = new exports.KbVector(parseInt(points[i]) / scaleDivider, (parseInt(points[i + 1]) / scaleDivider) * -1, 0);
                    newPath.controlPoints.push(newControlPoint);
                }
                if (closePath) {
                    const newControlPoint = nodeManager.create(Token.SketchControlPoint);
                    newControlPoint.position = new exports.KbVector(parseInt(points[0]) / scaleDivider, (parseInt(points[1]) / scaleDivider) * -1, 0);
                    newPath.controlPoints.push(newControlPoint);
                }
            }
        }
    }
    function nameGeneratedPaths(node) {
        let counter = 0;
        node.paths.forEach(path => {
            if (counter > 0) {
                path.name = 'Path ' + counter.toString();
            }
            counter++;
        });
    }
    function getPaletteColorStrength(color) {
        const saturation = Math.max(color.r, color.g, color.b) - Math.min(color.r, color.g, color.b);
        return color.a * 255 + saturation;
    }

    class CompatibilityOptions$1 {
    }
    /**
     * Creates the VertexData for a Ribbon
     * @param options an object used to set the following optional parameters for the ribbon, required but can be empty
     * * pathArray array of paths, each of which an array of successive Vector3
     * * closeArray creates a seam between the first and the last paths of the pathArray, optional, default false
     * * closePath creates a seam between the first and the last points of each path of the path array, optional, default false
     * * offset a positive integer, only used when pathArray contains a single path (offset = 10 means the point 1 is joined to the point 11), default rounded half size of the pathArray length
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * * invertUV swaps in the U and V coordinates when applying a texture, optional, default false
     * * uvs a linear array, of length 2 * number of vertices, of custom UV values, optional
     * * colors a linear array, of length 4 * number of vertices, of custom color values, optional
     * @returns the VertexData of the ribbon
     */
    function CreateRibbonVertexData$1(options) {
        let pathArray = options.pathArray;
        const closeArray = options.closeArray || false;
        const closePath = options.closePath || false;
        const invertUV = options.invertUV || false;
        const defaultOffset = Math.floor(pathArray[0].length / 2);
        let offset = options.offset || defaultOffset;
        offset = offset > defaultOffset ? defaultOffset : Math.floor(offset); // offset max allowed : defaultOffset
        const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || VertexData.DEFAULTSIDE;
        const customUV = options.uvs;
        const customColors = options.colors;
        const positions = [];
        const indices = [];
        const normals = [];
        const uvs = [];
        const us = []; // us[path_id] = [uDist1, uDist2, uDist3 ... ] distances between points on path path_id
        const vs = []; // vs[i] = [vDist1, vDist2, vDist3, ... ] distances between points i of consecutive paths from pathArray
        const uTotalDistance = []; // uTotalDistance[p] : total distance of path p
        const vTotalDistance = []; //  vTotalDistance[i] : total distance between points i of first and last path from pathArray
        let minlg; // minimal length among all paths from pathArray
        const lg = []; // array of path lengths : nb of vertex per path
        const idx = []; // array of path indexes : index of each path (first vertex) in the total vertex number
        let p; // path iterator
        let i; // point iterator
        let j; // point iterator
        // if single path in pathArray
        if (pathArray.length < 2) {
            const ar1 = [];
            const ar2 = [];
            for (i = 0; i < pathArray[0].length - offset; i++) {
                ar1.push(pathArray[0][i]);
                ar2.push(pathArray[0][i + offset]);
            }
            pathArray = [ar1, ar2];
        }
        // positions and horizontal distances (u)
        let idc = 0;
        const closePathCorr = closePath ? 1 : 0; // the final index will be +1 if closePath
        const closeArrayCorr = closeArray ? 1 : 0;
        let path;
        let l;
        minlg = pathArray[0].length;
        let vectlg;
        let dist;
        for (p = 0; p < pathArray.length + closeArrayCorr; p++) {
            uTotalDistance[p] = 0;
            us[p] = [0];
            path = p === pathArray.length ? pathArray[0] : pathArray[p];
            l = path.length;
            minlg = minlg < l ? minlg : l;
            j = 0;
            while (j < l) {
                positions.push(path[j].x, path[j].y, path[j].z);
                if (j > 0) {
                    vectlg = path[j].subtract(path[j - 1]).length();
                    dist = vectlg + uTotalDistance[p];
                    us[p].push(dist);
                    uTotalDistance[p] = dist;
                }
                j++;
            }
            if (closePath) {
                // an extra hidden vertex is added in the "positions" array
                j--;
                positions.push(path[0].x, path[0].y, path[0].z);
                vectlg = path[j].subtract(path[0]).length();
                dist = vectlg + uTotalDistance[p];
                us[p].push(dist);
                uTotalDistance[p] = dist;
            }
            lg[p] = l + closePathCorr;
            idx[p] = idc;
            idc += l + closePathCorr;
        }
        // vertical distances (v)
        let path1;
        let path2;
        let vertex1 = null;
        let vertex2 = null;
        for (i = 0; i < minlg + closePathCorr; i++) {
            vTotalDistance[i] = 0;
            vs[i] = [0];
            for (p = 0; p < pathArray.length - 1 + closeArrayCorr; p++) {
                path1 = pathArray[p];
                path2 = p === pathArray.length - 1 ? pathArray[0] : pathArray[p + 1];
                if (i === minlg) {
                    // closePath
                    vertex1 = path1[0];
                    vertex2 = path2[0];
                }
                else {
                    vertex1 = path1[i];
                    vertex2 = path2[i];
                }
                vectlg = vertex2.subtract(vertex1).length();
                dist = vectlg + vTotalDistance[i];
                vs[i].push(dist);
                vTotalDistance[i] = dist;
            }
        }
        // uvs
        let u;
        let v;
        if (customUV) {
            for (p = 0; p < customUV.length; p++) {
                uvs.push(customUV[p].x, CompatibilityOptions$1.useOpenGLOrientationForUV ? 1.0 - customUV[p].y : customUV[p].y);
            }
        }
        else {
            for (p = 0; p < pathArray.length + closeArrayCorr; p++) {
                for (i = 0; i < minlg + closePathCorr; i++) {
                    u = uTotalDistance[p] != 0.0 ? us[p][i] / uTotalDistance[p] : 0.0;
                    v = vTotalDistance[i] != 0.0 ? vs[i][p] / vTotalDistance[i] : 0.0;
                    if (invertUV) {
                        uvs.push(v, u);
                    }
                    else {
                        uvs.push(u, CompatibilityOptions$1.useOpenGLOrientationForUV ? 1.0 - v : v);
                    }
                }
            }
        }
        // indices
        p = 0; // path index
        let pi = 0; // positions array index
        let l1 = lg[p] - 1; // path1 length
        let l2 = lg[p + 1] - 1; // path2 length
        let min = l1 < l2 ? l1 : l2; // current path stop index
        let shft = idx[1] - idx[0]; // shift
        const path1nb = lg.length - 1; // number of path1 to iterate on
        while (pi <= min && p < path1nb) {
            //  stay under min and don't go over next to last path
            // draw two triangles between path1 (p1) and path2 (p2) : (p1.pi, p2.pi, p1.pi+1) and (p2.pi+1, p1.pi+1, p2.pi) clockwise
            indices.push(pi, pi + shft, pi + 1);
            indices.push(pi + shft + 1, pi + 1, pi + shft);
            pi += 1;
            if (pi === min) {
                // if end of one of two consecutive paths reached, go to next existing path
                p++;
                shft = idx[p + 1] - idx[p];
                l1 = lg[p] - 1;
                l2 = lg[p + 1] - 1;
                pi = idx[p];
                min = l1 < l2 ? l1 + pi : l2 + pi;
            }
        }
        // normals
        VertexData.ComputeNormals(positions, indices, normals);
        if (closePath) {
            // update both the first and last vertex normals to their average value
            let indexFirst = 0;
            let indexLast = 0;
            for (p = 0; p < pathArray.length; p++) {
                indexFirst = idx[p] * 3;
                if (p + 1 < pathArray.length) {
                    indexLast = (idx[p + 1] - 1) * 3;
                }
                else {
                    indexLast = normals.length - 3;
                }
                normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                const l = Math.sqrt(normals[indexFirst] * normals[indexFirst] +
                    normals[indexFirst + 1] * normals[indexFirst + 1] +
                    normals[indexFirst + 2] * normals[indexFirst + 2]);
                normals[indexFirst] /= l;
                normals[indexFirst + 1] /= l;
                normals[indexFirst + 2] /= l;
                normals[indexLast] = normals[indexFirst];
                normals[indexLast + 1] = normals[indexFirst + 1];
                normals[indexLast + 2] = normals[indexFirst + 2];
            }
        }
        if (closeArray) {
            let indexFirst = idx[0] * 3;
            let indexLast = idx[pathArray.length] * 3;
            for (i = 0; i < minlg + closePathCorr; i++) {
                normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                const l = Math.sqrt(normals[indexFirst] * normals[indexFirst] +
                    normals[indexFirst + 1] * normals[indexFirst + 1] +
                    normals[indexFirst + 2] * normals[indexFirst + 2]);
                normals[indexFirst] /= l;
                normals[indexFirst + 1] /= l;
                normals[indexFirst + 2] /= l;
                normals[indexLast] = normals[indexFirst];
                normals[indexLast + 1] = normals[indexFirst + 1];
                normals[indexLast + 2] = normals[indexFirst + 2];
                indexFirst += 3;
                indexLast += 3;
            }
        }
        // sides
        VertexData._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
        // Colors
        let colors = null;
        if (customColors) {
            colors = new Float32Array(customColors.length * 4);
            for (let c = 0; c < customColors.length; c++) {
                colors[c * 4] = customColors[c].r;
                colors[c * 4 + 1] = customColors[c].g;
                colors[c * 4 + 2] = customColors[c].b;
                colors[c * 4 + 3] = customColors[c].a;
            }
        }
        // Result
        const vertexData = new VertexData();
        const positions32 = new Float32Array(positions);
        const normals32 = new Float32Array(normals);
        const uvs32 = new Float32Array(uvs);
        vertexData.indices = indices;
        vertexData.positions = positions32;
        vertexData.normals = normals32;
        vertexData.uvs = uvs32;
        if (colors) {
            vertexData.set(colors, VertexBuffer.ColorKind);
        }
        if (closePath) {
            vertexData._idx = idx;
        }
        return vertexData;
    }
    /**
     * Creates a ribbon mesh. The ribbon is a parametric shape.  It has no predefined shape. Its final shape will depend on the input parameters
     * * The parameter `pathArray` is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry
     * * The parameter `closeArray` (boolean, default false) creates a seam between the first and the last paths of the path array
     * * The parameter `closePath` (boolean, default false) creates a seam between the first and the last points of each path of the path array
     * * The parameter `offset` (positive integer, default : rounded half size of the pathArray length), is taken in account only if the `pathArray` is containing a single path
     * * It's the offset to join the points from the same path. Ex : offset = 10 means the point 1 is joined to the point 11
     * * The optional parameter `instance` is an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter : https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#ribbon
     * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
     * * The parameter `uvs` is an optional flat array of `Vector2` to update/set each ribbon vertex with its own custom UV values instead of the computed ones
     * * The parameters `colors` is an optional flat array of `Color4` to set/update each ribbon vertex with its own custom color values
     * * Note that if you use the parameters `uvs` or `colors`, the passed arrays must be populated with the right number of elements, it is to say the number of ribbon vertices. Remember that if you set `closePath` to `true`, there's one extra vertex per path in the geometry
     * * Moreover, you can use the parameter `color` with `instance` (to update the ribbon), only if you previously used it at creation time
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param scene defines the hosting scene
     * @returns the ribbon mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/ribbon_extra
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     */
    function CreateMiteredRibbon(name, options, scene = null) {
        const pathArray = options.pathArray;
        const closeArray = options.closeArray;
        const closePath = options.closePath;
        const cap = options.cap === 0 ? 0 : options.cap || Mesh.NO_CAP;
        const sideOrientation = Mesh._GetDefaultSideOrientation(options.sideOrientation);
        const instance = options.instance;
        const updatable = options.updatable;
        if (instance) {
            // existing ribbon instance update
            // positionFunction : ribbon case
            // only pathArray and sideOrientation parameters are taken into account for positions update
            const minimum = TmpVectors.Vector3[0].setAll(Number.MAX_VALUE);
            const maximum = TmpVectors.Vector3[1].setAll(-Number.MAX_VALUE);
            const positionFunction = (positions) => {
                let minlg = pathArray[0].length;
                const mesh = instance;
                let i = 0;
                const ns = mesh._originalBuilderSideOrientation === Mesh.DOUBLESIDE ? 2 : 1;
                for (let si = 1; si <= ns; ++si) {
                    for (let p = 0; p < pathArray.length; ++p) {
                        const path = pathArray[p];
                        const l = path.length;
                        minlg = minlg < l ? minlg : l;
                        for (let j = 0; j < minlg; ++j) {
                            const pathPoint = path[j];
                            positions[i] = pathPoint.x;
                            positions[i + 1] = pathPoint.y;
                            positions[i + 2] = pathPoint.z;
                            minimum.minimizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                            maximum.maximizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                            i += 3;
                        }
                        if (mesh._creationDataStorage && mesh._creationDataStorage.closePath) {
                            const pathPoint = path[0];
                            positions[i] = pathPoint.x;
                            positions[i + 1] = pathPoint.y;
                            positions[i + 2] = pathPoint.z;
                            i += 3;
                        }
                    }
                }
            };
            const positions = instance.getVerticesData(VertexBuffer.PositionKind);
            positionFunction(positions);
            if (instance.hasBoundingInfo) {
                instance.getBoundingInfo().reConstruct(minimum, maximum, instance._worldMatrix);
            }
            else {
                instance.buildBoundingInfo(minimum, maximum, instance._worldMatrix);
            }
            instance.updateVerticesData(VertexBuffer.PositionKind, positions, false, false);
            if (options.colors) {
                const colors = instance.getVerticesData(VertexBuffer.ColorKind);
                for (let c = 0, colorIndex = 0; c < options.colors.length; c++, colorIndex += 4) {
                    const color = options.colors[c];
                    colors[colorIndex] = color.r;
                    colors[colorIndex + 1] = color.g;
                    colors[colorIndex + 2] = color.b;
                    colors[colorIndex + 3] = color.a;
                }
                instance.updateVerticesData(VertexBuffer.ColorKind, colors, false, false);
            }
            if (options.uvs) {
                const uvs = instance.getVerticesData(VertexBuffer.UVKind);
                for (let i = 0; i < options.uvs.length; i++) {
                    uvs[i * 2] = options.uvs[i].x;
                    uvs[i * 2 + 1] = CompatibilityOptions$1.useOpenGLOrientationForUV
                        ? 1.0 - options.uvs[i].y
                        : options.uvs[i].y;
                }
                instance.updateVerticesData(VertexBuffer.UVKind, uvs, false, false);
            }
            if (!instance.areNormalsFrozen || instance.isFacetDataEnabled) {
                const indices = instance.getIndices();
                const normals = instance.getVerticesData(VertexBuffer.NormalKind);
                const params = instance.isFacetDataEnabled ? instance.getFacetDataParameters() : null;
                VertexData.ComputeNormals(positions, indices, normals, params);
                if (instance._creationDataStorage && instance._creationDataStorage.closePath) {
                    let indexFirst = 0;
                    let indexLast = 0;
                    for (let p = 0; p < pathArray.length; p++) {
                        indexFirst = instance._creationDataStorage.idx[p] * 3;
                        if (p + 1 < pathArray.length) {
                            indexLast = (instance._creationDataStorage.idx[p + 1] - 1) * 3;
                        }
                        else {
                            indexLast = normals.length - 3;
                        }
                        normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                        normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                        normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                        normals[indexLast] = normals[indexFirst];
                        normals[indexLast + 1] = normals[indexFirst + 1];
                        normals[indexLast + 2] = normals[indexFirst + 2];
                    }
                }
                if (!instance.areNormalsFrozen) {
                    instance.updateVerticesData(VertexBuffer.NormalKind, normals, false, false);
                }
            }
            return instance;
        }
        else {
            // new ribbon creation
            const ribbon = new Mesh(name, scene);
            ribbon._originalBuilderSideOrientation = sideOrientation;
            ribbon._creationDataStorage = new _CreationDataStorage();
            const vertexData = CreateRibbonVertexData$1(options);
            if (closePath) {
                ribbon._creationDataStorage.idx = vertexData._idx;
            }
            ribbon._creationDataStorage.closePath = closePath;
            ribbon._creationDataStorage.closeArray = closeArray;
            vertexData.applyToMesh(ribbon, updatable);
            createLineCaps(pathArray, cap, name, ribbon, vertexData);
            return ribbon;
        }
    }
    function createLineCaps(pathArray, cap, featureId, ribbon, vertexData) {
        const startCap = [];
        const endCap = [];
        let startCapVectors = [];
        let endCapVectors = [];
        const resultVectors = [];
        const resultCaps = [];
        pathArray.forEach(path => {
            if (path[0]) {
                const vector = path[0];
                startCapVectors.push(path[0]);
                startCap.push(vector.x, vector.y, vector.z);
            }
            if (path[path.length - 1]) {
                const vector = path[path.length - 1];
                endCapVectors.push(path[path.length - 1]);
                endCap.push(vector.x, vector.y, vector.z);
            }
        });
        //check to see if the handedness of the endCap is correct. Otherwise, flip it
        if (startCapVectors.length > 0) {
            const faceNormal = calculateFaceNormal(startCapVectors);
            const firstPath = pathArray[0];
            if (firstPath.length >= 2) {
                const firstPoint = firstPath[0];
                const secondPoint = firstPath[1];
                const sketchNativeNormal = secondPoint.subtract(firstPoint);
                // If the rotation handedness is opposite the primary sketch vector, then flip the sketch path
                if (Vector3.Dot(faceNormal, sketchNativeNormal) < 0) {
                    startCapVectors = reverseHandednessOfPositions(startCapVectors);
                }
            }
        }
        //check to see if the handedness of the endCap is correct. Otherwise, flip it
        if (endCapVectors.length > 0) {
            const faceNormal = calculateFaceNormal(endCapVectors);
            const lastPath = pathArray[pathArray.length - 1];
            if (lastPath.length >= 2) {
                const lastPoint = lastPath[lastPath.length - 1];
                const secondLastPoint = lastPath[lastPath.length - 2];
                const sketchNativeNormal = lastPoint.subtract(secondLastPoint);
                // If the rotation handedness is opposite the primary sketch vector, then flip the sketch path
                if (Vector3.Dot(faceNormal, sketchNativeNormal) < 0) {
                    endCapVectors = reverseHandednessOfPositions(endCapVectors);
                }
            }
        }
        if (cap === Mesh.CAP_START) {
            const startCapIndices = earcut$1(startCap, [], 3);
            resultCaps.push(startCapIndices);
            resultVectors.push(startCapVectors, []);
        }
        else if (cap === Mesh.CAP_END) {
            const endCapIndices = earcut$1(endCap, [], 3);
            resultCaps.push(endCapIndices);
            resultVectors.push([], endCapVectors);
        }
        else if (cap === Mesh.CAP_ALL) {
            const startCapIndices = earcut$1(startCap, [], 3);
            resultCaps.push(startCapIndices);
            const endCapIndices = earcut$1(endCap, [], 3);
            //offset the endCapIndices otherwise they are the same as the startCapIndices
            for (let i = 0; i < endCapIndices.length; i++) {
                endCapIndices[i] = endCapIndices[i] + startCapVectors.length;
            }
            resultCaps.push(endCapIndices);
            resultVectors.push(startCapVectors, endCapVectors);
        }
        const newVertexData = combineVertexDataWithCaps(vertexData, resultCaps, resultVectors);
        newVertexData.applyToMesh(ribbon, true);
        return resultCaps;
    }
    function combineVertexDataWithCaps(baseVertexData, capMeshIndices, capMeshPositions) {
        var _a, _b, _c, _d;
        const totalBasePositions = ((_a = baseVertexData.positions) === null || _a === void 0 ? void 0 : _a.length) || 0;
        const totalBaseNormals = ((_b = baseVertexData.normals) === null || _b === void 0 ? void 0 : _b.length) || 0;
        const totalBaseUvs = ((_c = baseVertexData.uvs) === null || _c === void 0 ? void 0 : _c.length) || 0;
        const totalBaseIndices = ((_d = baseVertexData.indices) === null || _d === void 0 ? void 0 : _d.length) || 0;
        const newPositions = [];
        const newNormals = [];
        const newUvs = [];
        const newIndices = [];
        const startCapPositions = capMeshPositions[0];
        const endCapPositions = capMeshPositions[1];
        capMeshIndices.forEach(meshIndices => {
            meshIndices.forEach(index => {
                const newIndex = index + totalBasePositions / 3;
                newIndices.push(newIndex);
            });
        });
        if (startCapPositions && startCapPositions.length !== 0) {
            const normal = calculateFaceNormal(startCapPositions);
            startCapPositions.forEach(position => {
                newPositions.push(position.x, position.y, position.z);
                newNormals.push(normal.x, normal.y, normal.z);
            });
            const generatedUvs = generateUvsForCaps(startCapPositions);
            newUvs.push(...generatedUvs);
        }
        if (endCapPositions && endCapPositions.length !== 0) {
            const normal = calculateFaceNormal(endCapPositions);
            endCapPositions.forEach(position => {
                newPositions.push(position.x, position.y, position.z);
                newNormals.push(normal.x, normal.y, normal.z);
            });
            const generatedUvs = generateUvsForCaps(endCapPositions);
            newUvs.push(...generatedUvs);
        }
        const newVertexData = new VertexData();
        newVertexData.positions = newPositions;
        newVertexData.normals = newNormals;
        newVertexData.indices = newIndices;
        const combinedPositionsArray = new Float32Array(totalBasePositions + newPositions.length);
        const combinedNormalsArray = new Float32Array(totalBaseNormals + newNormals.length);
        const combinedUvsArray = new Float32Array((combinedPositionsArray.length / 3) * 2);
        const combinedIndicesArray = new Uint16Array(totalBaseIndices + newIndices.length);
        if (baseVertexData.positions) {
            combinedPositionsArray.set(baseVertexData.positions);
            combinedPositionsArray.set(newPositions, totalBasePositions);
            baseVertexData.positions = combinedPositionsArray;
        }
        if (baseVertexData.normals) {
            combinedNormalsArray.set(baseVertexData.normals);
            combinedNormalsArray.set(newNormals, totalBaseNormals);
            baseVertexData.normals = combinedNormalsArray;
        }
        if (baseVertexData.uvs) {
            combinedUvsArray.set(baseVertexData.uvs);
            combinedUvsArray.set(newUvs, totalBaseUvs);
            baseVertexData.uvs = combinedUvsArray;
        }
        if (baseVertexData.indices) {
            combinedIndicesArray.set(baseVertexData.indices);
            combinedIndicesArray.set(newIndices, totalBaseIndices);
            baseVertexData.indices = combinedIndicesArray;
        }
        return baseVertexData;
    }
    function reverseHandednessOfPositions(positionsArray) {
        const reversedArray = [];
        positionsArray.forEach(position => {
            reversedArray.unshift(position);
        });
        return reversedArray;
    }
    function generateUvsForCaps(positions) {
        const newUvs = [];
        const operationVectors = findDistinctVectors(positions);
        if (operationVectors) {
            const vector1 = operationVectors[0];
            const vector2 = operationVectors[1];
            const vector3 = operationVectors[2];
            //xp1 is the capNormal
            if (vector1 && vector2 && vector3) {
                const xp1 = vector1.cross(vector2.subtract(vector3));
                const xp2 = vector1.subtract(vector2).cross(xp1);
                const normalizedXp3 = xp1.cross(xp2).normalize();
                const normalizedXp2 = xp2.normalize();
                positions.forEach(position => {
                    const u = Vector3.Dot(position, normalizedXp2);
                    const v = Vector3.Dot(position, normalizedXp3);
                    newUvs.push(u, v);
                });
            }
        }
        else {
            positions.forEach(position => {
                newUvs.push(0, 0);
            });
        }
        return newUvs;
    }
    function findDistinctVectors(vectors) {
        let vector1 = Vector3.Zero();
        let vector2 = Vector3.Zero();
        let vector3 = Vector3.Zero();
        for (let i = 0; i < vectors.length; i++) {
            let isZeroVector = false;
            if (vectors[i].x === 0 && vectors[i].y === 0 && vectors[i].z === 0) {
                isZeroVector = true;
            }
            if (!isZeroVector) {
                vector1 = vectors[i];
                break;
            }
        }
        for (let i = 0; i < vectors.length; i++) {
            let isZeroVector = false;
            if (vectors[i].x === 0 && vectors[i].y === 0 && vectors[i].z === 0) {
                isZeroVector = true;
            }
            if (!isZeroVector && vectors[i] !== vector1) {
                vector2 = vectors[i];
                break;
            }
        }
        for (let i = 0; i < vectors.length; i++) {
            if (vectors[i] !== vector2 && vectors[i] !== vector1) {
                vector3 = vectors[i];
                break;
            }
        }
        return [vector1, vector2, vector3];
    }
    VertexData.CreateRibbon = CreateRibbonVertexData$1;
    Mesh.CreateRibbon = (name, pathArray, closeArray = false, closePath, offset, scene, updatable = false, sideOrientation, instance) => {
        return CreateMiteredRibbon(name, {
            pathArray: pathArray,
            closeArray: closeArray,
            closePath: closePath,
            offset: offset,
            updatable: updatable,
            sideOrientation: sideOrientation,
            instance: instance,
        }, scene);
    };

    //const capMap: Map<string, Mesh[]> = new Map();
    class SweepRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.SweepFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            var _a;
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            let parentMesh;
            if (feature._parent) {
                parentMesh = this.viewer.getRendererNode(feature._parent);
            }
            let pathPoints = [];
            let targetPathNode;
            let pathMesh;
            if (feature.path) {
                targetPathNode = (_a = feature._manager) === null || _a === void 0 ? void 0 : _a.getById(feature.path);
            }
            if (targetPathNode) {
                pathMesh = this.viewer.getRendererNode(targetPathNode);
                const pathVertexData = SubmeshVertexData.ExtractFromMesh(pathMesh);
                const { segments } = parseSketchGeometry(pathVertexData);
                if (segments.length > 0) {
                    pathPoints = segments[0];
                }
            }
            if (parentMesh &&
                targetPathNode &&
                pathMesh &&
                newVertexData.positions &&
                newVertexData.positions.length > 0 &&
                pathPoints.length > 1) {
                const { segments } = parseSketchGeometry(newVertexData);
                const extrudedMeshes = [];
                for (let i = 0; i < segments.length; i++) {
                    const shape = segments[i];
                    // Transform the path and the profile sketch into world space so we can combine them without worrying about local transforms
                    const pathTransform = pathMesh.computeWorldMatrix();
                    const sketchTransform = parentMesh.computeWorldMatrix();
                    for (let i = 0; i < pathPoints.length; i++) {
                        Vector3.TransformCoordinatesToRef(pathPoints[i], pathTransform, pathPoints[i]);
                    }
                    for (let i = 0; i < shape.length; i++) {
                        Vector3.TransformCoordinatesToRef(shape[i], sketchTransform, shape[i]);
                    }
                    // Determine the vector to use as the primary direction of the extrusion
                    const pathPrimaryVector = Vector3.Zero();
                    let j = 0;
                    while (pathPrimaryVector.length() === 0) {
                        j++;
                        pathPrimaryVector.copyFrom(pathPoints[j]).subtractInPlace(pathPoints[0]);
                    }
                    // Calculate the matrix to move the sketch path primary direction to be perpindicular to the XY plane for consistent behavior
                    const rotToZ = rotationToVector(new Vector3(0, 0, 1), pathPrimaryVector);
                    const pathTransformToZ = new Matrix();
                    const pathTransformToZInv = new Matrix();
                    rotToZ.toRotationMatrix(pathTransformToZ);
                    Matrix.Compose(Vector3.One(), Quaternion.Identity(), pathPoints[0].scale(-1)).multiplyToRef(pathTransformToZ, pathTransformToZ);
                    pathTransformToZ.invertToRef(pathTransformToZInv);
                    // Transform both the path and the extrusion shape with the same matrix so the
                    // shape and the path are positioned the same as before in relation to each other
                    // but oriented to be extruded out of the XY plane, in the Z direction
                    for (let i = 0; i < pathPoints.length; i++) {
                        Vector3.TransformCoordinatesToRef(pathPoints[i], pathTransformToZ, pathPoints[i]);
                    }
                    for (let i = 0; i < shape.length; i++) {
                        Vector3.TransformCoordinatesToRef(shape[i], pathTransformToZ, shape[i]);
                        // Project the extrude shape onto the XY plane so that it's perfecly perpindicular to the sweep path
                        shape[i].set(shape[i].x, shape[i].y, 0);
                    }
                    const extrudeOptions = {
                        shape,
                        path: pathPoints,
                        updatable: false,
                        cap: Mesh.NO_CAP,
                        closeShape: false,
                        // firstNormal: sketchNormal, this property is added in a future version of babylon
                    };
                    if (feature.capEnd && feature.capStart) {
                        extrudeOptions.cap = Mesh.CAP_ALL;
                        extrudeOptions.closeShape = true;
                    }
                    else if (feature.capStart) {
                        extrudeOptions.cap = Mesh.CAP_START;
                        extrudeOptions.closeShape = true;
                    }
                    else if (feature.capEnd) {
                        extrudeOptions.cap = Mesh.CAP_END;
                        extrudeOptions.closeShape = true;
                    }
                    // Perform the extrusion of the shape defined along the XY plane, to the path oriented to coincide with the Z+ axis
                    let extruded;
                    if (feature.mitredExtrusion) {
                        extrudeOptions.closeShape = false;
                        extruded = this.mitredExtrude(feature._dynamicId, extrudeOptions, this.scene);
                    }
                    else {
                        extruded = MeshBuilder.ExtrudeShape(feature._dynamicId, extrudeOptions, this.scene);
                    }
                    // Rotate the resulting extruded shape to match the orientation of the original shape profile
                    sketchTransform.invert();
                    pathTransformToZInv.multiplyToRef(sketchTransform, pathTransformToZInv);
                    extruded.bakeTransformIntoVertices(pathTransformToZInv);
                    extrudedMeshes.push(extruded);
                }
                const extrudedAll = Mesh.MergeMeshes(extrudedMeshes, true);
                if (extrudedAll) {
                    applyExtrusion(newVertexData, extrudedAll, false);
                    extrudedAll.dispose();
                }
            }
            return newVertexData;
        }
        update3dInternal() { }
        mitredExtrude(featureId, options, scene) {
            const shape = options.shape;
            const path = options.path;
            const closed = options.closeShape || false;
            const nbPoints = path.length;
            const line = Vector3.Zero();
            const nextLine = Vector3.Zero();
            let axisX = Vector3.Zero();
            let axisY = Vector3.Zero();
            let axisZ = Vector3.Zero();
            let nextAxisX = Vector3.Zero();
            let nextAxisY = Vector3.Zero();
            let nextAxisZ = Vector3.Zero();
            let startPoint = Vector3.Zero();
            const nextStartPoint = Vector3.Zero();
            const bisector = Vector3.Zero();
            let distance = 0;
            let ray;
            const allPaths = [];
            // Note that the sketch will always be rotated such that the profile is in the XY plane
            const up = Vector3.Up();
            for (let s = 0; s < shape.length; s++) {
                path[1].subtractToRef(path[0], line);
                axisZ = line.clone().normalize();
                axisX = Vector3.Cross(Vector3.Up(), axisZ).normalize();
                axisY = Vector3.Cross(axisZ, axisX);
                startPoint = path[0].add(axisX.scale(shape[s].x)).add(axisY.scale(shape[s].y));
                const ribbonPath = [startPoint.clone()];
                for (let p = 0; p < nbPoints - 2; p++) {
                    path[p + 2].subtractToRef(path[p + 1], nextLine);
                    nextAxisZ = nextLine.clone().normalize();
                    nextAxisX = Vector3.Cross(up, nextAxisZ).normalize();
                    nextAxisY = Vector3.Cross(nextAxisZ, nextAxisX);
                    nextAxisZ.subtractToRef(axisZ, bisector);
                    const planeParallel = Vector3.Cross(nextAxisZ, axisZ);
                    const planeNormal = Vector3.Cross(planeParallel, bisector);
                    const plane = Plane.FromPositionAndNormal(path[p + 1], planeNormal);
                    ray = new Ray(startPoint, axisZ);
                    distance = ray.intersectsPlane(plane) || 0;
                    startPoint.addToRef(axisZ.scale(distance), nextStartPoint);
                    ribbonPath.push(nextStartPoint.clone());
                    axisX = nextAxisX.clone();
                    axisY = nextAxisY.clone();
                    axisZ = nextAxisZ.clone();
                    startPoint = nextStartPoint.clone();
                }
                // Last Point
                if (closed) {
                    path[0].subtractToRef(path[nbPoints - 1], nextLine);
                    nextAxisZ = nextLine.clone().normalize();
                    nextAxisX = Vector3.Cross(up, nextAxisZ).normalize();
                    nextAxisY = Vector3.Cross(nextAxisZ, nextAxisX);
                    nextAxisZ.subtractToRef(axisZ, bisector);
                    const closedPlaneParallel = Vector3.Cross(nextAxisZ, axisZ);
                    const closedPlaneNormal = Vector3.Cross(closedPlaneParallel, bisector);
                    const closedPlane = Plane.FromPositionAndNormal(path[nbPoints - 1], closedPlaneNormal);
                    ray = new Ray(startPoint, axisZ);
                    distance = ray.intersectsPlane(closedPlane) || 0;
                    startPoint.addToRef(axisZ.scale(distance), nextStartPoint);
                    ribbonPath.push(nextStartPoint.clone());
                    axisX = nextAxisX.clone();
                    axisY = nextAxisY.clone();
                    axisZ = nextAxisZ.clone();
                    startPoint = nextStartPoint.clone();
                    path[1].subtractToRef(path[0], nextLine);
                    nextAxisZ = nextLine.clone().normalize();
                    nextAxisX = Vector3.Cross(up, nextAxisZ).normalize();
                    nextAxisY = Vector3.Cross(nextAxisZ, nextAxisX);
                    nextAxisZ.subtractToRef(axisZ, bisector);
                    const planeParallel = Vector3.Cross(nextAxisZ, axisZ);
                    const planeNormal = Vector3.Cross(planeParallel, bisector);
                    const plane = Plane.FromPositionAndNormal(path[0], planeNormal);
                    ray = new Ray(startPoint, axisZ);
                    distance = ray.intersectsPlane(plane) || 0;
                    startPoint.addToRef(axisZ.scale(distance), nextStartPoint);
                    ribbonPath.shift();
                    ribbonPath.unshift(nextStartPoint.clone());
                }
                else {
                    const planeNormal = axisZ;
                    const plane = Plane.FromPositionAndNormal(path[nbPoints - 1], planeNormal);
                    ray = new Ray(startPoint, axisZ);
                    const distance = ray.intersectsPlane(plane) || 0;
                    startPoint.addToRef(axisZ.scale(distance), nextStartPoint);
                    ribbonPath.push(nextStartPoint.clone());
                }
                allPaths.push(ribbonPath);
            }
            const ribbon = CreateMiteredRibbon(featureId, {
                pathArray: allPaths,
                sideOrientation: Mesh.DOUBLESIDE,
                closeArray: false,
                closePath: false,
                cap: options.cap,
            }, scene);
            return ribbon;
        }
    }

    class TransformRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.TransformFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const parentMesh = feature._parent;
            if (parentMesh && newVertexData.positions && newVertexData.positions.length > 0) {
                const newMeshVertexPositions = newVertexData.positions;
                const indexCount = newMeshVertexPositions.length / 3;
                const pivot = parentMesh.pivot.toVec3();
                const vertexPosition = new Vector3();
                let scaleVector;
                if (!feature.scale.equal({ x: 1, y: 1, z: 1 })) {
                    scaleVector = feature.scale.toVec3();
                }
                for (let i = 0; i < indexCount; i++) {
                    if (pivot && scaleVector) {
                        vertexPosition.copyFromFloats(newMeshVertexPositions[i * 3] - pivot.x, newMeshVertexPositions[i * 3 + 1] - pivot.y, newMeshVertexPositions[i * 3 + 2] - pivot.z);
                        if (scaleVector) {
                            vertexPosition.multiplyInPlace(scaleVector);
                        }
                        vertexPosition.addInPlace(pivot);
                        newMeshVertexPositions[i * 3] = vertexPosition.x;
                        newMeshVertexPositions[i * 3 + 1] = vertexPosition.y;
                        newMeshVertexPositions[i * 3 + 2] = vertexPosition.z;
                    }
                }
            }
            return newVertexData;
        }
        update3dInternal() { }
    }

    class WeldVerticesRenderer extends FeatureRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.WeldVerticesFeature;
        }
        updateMeshGeometry(feature, vertexData, vertexDataChanges) {
            const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
            const parentMesh = feature._parent;
            const indices = newVertexData.indices;
            let positions = newVertexData.positions;
            let normals = newVertexData.normals;
            let uvs = newVertexData.uvs;
            const positionAverage = [0, 0, 0];
            const normalsAverage = [0, 0, 0];
            const uvAverage = [0, 0];
            const selectedIndices = [];
            const selectedVertices = [];
            const selectedIndicesArray = [];
            const vertexVisited = [];
            const indicesResult = [];
            const submeshDataArray = [];
            if (parentMesh && newVertexData.positions && newVertexData.positions.length > 0) {
                if (newVertexData.positions) {
                    positions = newVertexData.positions;
                }
                else if (vertexData.positions) {
                    positions = Array.from(vertexData.positions);
                }
                else {
                    positions = [];
                }
                if (newVertexData.normals) {
                    normals = newVertexData.normals;
                }
                else if (vertexData.normals) {
                    normals = Array.from(vertexData.normals);
                }
                if (newVertexData.uvs) {
                    uvs = newVertexData.uvs;
                }
                else if (vertexData.uvs) {
                    uvs = Array.from(vertexData.uvs);
                }
                if (feature.vertexIndices && feature.vertexIndices.length > 0) {
                    //creating sparse array to see which vertices are selected
                    for (let i = 0; i < feature.vertexIndices.length; i++) {
                        selectedIndicesArray[feature.vertexIndices[i]] = true;
                    }
                    if (indices) {
                        //Looping through indices and checking which indices are touched by the selected vertices
                        for (let j = 0; j < (indices === null || indices === void 0 ? void 0 : indices.length); j++) {
                            if (selectedIndicesArray[indices[j]]) {
                                selectedIndices.push(j);
                                if (!vertexVisited[indices[j]]) {
                                    selectedVertices.push(j);
                                    vertexVisited[indices[j]] = true;
                                }
                            }
                        }
                    }
                    //averaging all selected positions of the vertex
                    for (let i = 0; i < selectedVertices.length; i++) {
                        if (indices) {
                            const vertex = indices[selectedVertices[i]];
                            for (let j = 0; j < 3; j++) {
                                positionAverage[j] = positionAverage[j] + positions[vertex * 3 + j];
                                if (normals) {
                                    normalsAverage[j] = normalsAverage[j] + normals[vertex * 3 + j];
                                }
                                if (j != 2 && uvs) {
                                    uvAverage[j] = uvAverage[j] + uvs[vertex * 2 + j];
                                }
                            }
                        }
                    }
                    for (let i = 0; i < 3; i++) {
                        positionAverage[i] = positionAverage[i] / selectedVertices.length;
                        normalsAverage[i] = normalsAverage[i] / selectedVertices.length;
                        if (i != 2) {
                            uvAverage[i] = uvAverage[i] / selectedVertices.length;
                        }
                    }
                    //setting one vertex to calculated average position
                    if (indices) {
                        const targetIndex = indices[selectedVertices[0]];
                        for (let i = 0; i < 3; i++) {
                            positions[targetIndex * 3 + i] = positionAverage[i];
                            if (normals) {
                                normals[targetIndex * 3 + i] = normalsAverage[i];
                            }
                            if (i != 2 && uvs) {
                                uvs[targetIndex * 2 + i] = uvAverage[i];
                            }
                        }
                        //setting all selectedIndices to targetIndex with new position
                        for (let i = 0; i < selectedIndices.length; i++) {
                            indices[selectedIndices[i]] = targetIndex;
                        }
                        //looping through indices and pruning out polygons that make up invalid geometry
                        for (let i = 0; i < indices.length; i = i + 3) {
                            if (indices[i] != indices[i + 1] &&
                                indices[i] != indices[i + 2] &&
                                indices[i + 1] != indices[i + 2]) {
                                indicesResult.push(indices[i]);
                                indicesResult.push(indices[i + 1]);
                                indicesResult.push(indices[i + 2]);
                            }
                        }
                        //handling submesh data
                        if (vertexData.submeshData) {
                            for (let i = 0; i < vertexData.submeshData.length; i++) {
                                const submeshData = vertexData.submeshData[i];
                                submeshData.indexCount = indicesResult.length;
                                submeshDataArray[i] = submeshData;
                            }
                        }
                    }
                }
                newVertexData.positions = positions;
                newVertexData.indices = indicesResult;
                newVertexData.uvs = uvs;
                newVertexData.normals = normals;
                newVertexData.submeshData = submeshDataArray;
            }
            return newVertexData;
        }
        update3dInternal() { }
    }

    class FeatureStackRenderer extends Renderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene);
            this.rendererManager = rendererManager;
            this.queuedGeometryToReset = new Map();
            this.queuedFeaturesToProcess = new Map(); // index of feature to start recalculation at
            this.processedFeatures = new Map();
            this.featureOrder = new Map();
            this.renderers = new Map();
            this.modelToken = Token.Feature;
            const moveVertices = new MoveVerticesRenderer(viewer, scene);
            this.renderers.set(Token.MoveVerticesFeature, moveVertices);
            const weldVertices = new WeldVerticesRenderer(viewer, scene);
            this.renderers.set(Token.WeldVerticesFeature, weldVertices);
            const displacementMap = new DisplacementMapRenderer(viewer, scene);
            this.renderers.set(Token.DisplacementMapFeature, displacementMap);
            const uvMaps = new UvMapRenderer(viewer, scene);
            this.renderers.set(Token.UvMapFeature, uvMaps);
            const submeshes = new SubmeshRenderer(viewer, scene, rendererManager);
            this.renderers.set(Token.SubmeshFeature, submeshes);
            const linearPatterns = new LinearPatternRenderer(viewer, scene);
            this.renderers.set(Token.LinearPatternFeature, linearPatterns);
            const circularPatterns = new CircularPatternRenderer(viewer, scene);
            this.renderers.set(Token.CircularPatternFeature, circularPatterns);
            const joinGeometry = new JoinGeometryRenderer(viewer, scene);
            this.renderers.set(Token.JoinGeometryFeature, joinGeometry);
            const deleteFaces = new DeleteFacesRenderer(viewer, scene);
            this.renderers.set(Token.DeleteFacesFeature, deleteFaces);
            const normalSmoothing = new NormalSmoothingRenderer(viewer, scene);
            this.renderers.set(Token.NormalSmoothingFeature, normalSmoothing);
            const slice = new SliceFeatureRenderer(viewer, scene);
            this.renderers.set(Token.SliceFeature, slice);
            const mirror = new MirrorFeatureRenderer(viewer, scene);
            this.renderers.set(Token.MirrorFeature, mirror);
            const transform = new TransformRenderer(viewer, scene);
            this.renderers.set(Token.TransformFeature, transform);
            const extrude = new ExtrudeRenderer(viewer, scene);
            this.renderers.set(Token.ExtrudeFeature, extrude);
            const sweep = new SweepRenderer(viewer, scene);
            this.renderers.set(Token.SweepFeature, sweep);
        }
        forceRebuildGeometry(meshNode, vertexData) {
            if (!this.processedFeatures.has(meshNode._dynamicId)) {
                if (vertexData) {
                    this.applyNewVertexData(meshNode, {}, vertexData);
                }
                return;
            }
            if (!vertexData) {
                vertexData = this.rendererManager.mesh.rebuildBaseGeometry(meshNode);
            }
            this.queuedGeometryToReset.set(meshNode._dynamicId, vertexData);
            const allChanges = new Set(meshNode.features.map((_, i) => i));
            this.queuedFeaturesToProcess.set(meshNode, allChanges);
            const movedIndex = this.getMovedFeatureIndex(meshNode);
            this.updateFeatureOrder(meshNode);
            if (movedIndex !== undefined && movedIndex >= 0) {
                this.recursivelyUpdateFeatureVisibility([meshNode.features[movedIndex]], meshNode.features, []);
            }
            this.update3dGeometry(0, meshNode);
            this.renderers.forEach(renderer => {
                renderer.clearCache(meshNode.features);
            });
        }
        resetMeshGeometry(meshNode, dataTypes, vertexData, hasFeatureToUpdate = false) {
            var _a;
            if (!vertexData) {
                vertexData = this.rendererManager.mesh.rebuildBaseGeometry(meshNode);
            }
            if (vertexData) {
                let newGeometry;
                if (!dataTypes) {
                    newGeometry = vertexData;
                }
                else {
                    // If the feature that changed affects aspects of a geometry, reset those aspects so we can recalculate them with
                    // this or any other features that affected that aspect
                    newGeometry = this.queuedGeometryToReset.get(meshNode._dynamicId) || {};
                    // Null means that the vertex data specifically doesn't have those geometries, so they will be cleared
                    if (!newGeometry.positions && hasChange(dataTypes, exports.eMeshChangeTypes.VertexPositions)) {
                        newGeometry.positions = vertexData.positions || null;
                    }
                    if (!newGeometry.normals && hasChange(dataTypes, exports.eMeshChangeTypes.VertexNormals)) {
                        newGeometry.normals = vertexData.normals || null;
                    }
                    if (!newGeometry.uvs && hasChange(dataTypes, exports.eMeshChangeTypes.VertexUvs)) {
                        newGeometry.uvs = vertexData.uvs || null;
                    }
                    if (!newGeometry.indices && hasChange(dataTypes, exports.eMeshChangeTypes.VertexIndices)) {
                        newGeometry.indices = vertexData.indices || null;
                    }
                    if (!newGeometry.submeshData && hasChange(dataTypes, exports.eMeshChangeTypes.Submeshes)) {
                        newGeometry.submeshData = vertexData.submeshData || null;
                    }
                }
                this.queuedGeometryToReset.set(meshNode._dynamicId, newGeometry);
                // If a feature affects a geometry element that is being reset, then it will need to be recalculated
                for (let i = 0; i < meshNode.features.length; i++) {
                    const feature = meshNode.features[i];
                    // If this geometry hasn't been flagged for recalculation, see if it needs to be
                    if (!((_a = this.queuedFeaturesToProcess.get(meshNode)) === null || _a === void 0 ? void 0 : _a.has(i)) &&
                        feature.affects &&
                        featureIsAffected(feature.affects, newGeometry)) {
                        hasFeatureToUpdate = true;
                        this.queueGeometryUpdate(meshNode, i);
                        this.resetMeshGeometry(meshNode, feature.affects, vertexData, hasFeatureToUpdate);
                    }
                }
                // If there are no features to be recalculated but we need to reset some mesh geometry, then do that directly.
                if (!hasFeatureToUpdate && Object.getOwnPropertyNames(newGeometry).length > 0) {
                    const existingVertexData = this.rendererManager.mesh.getMeshGeometry(meshNode) || vertexData;
                    this.queuedGeometryToReset.delete(meshNode._dynamicId);
                    this.applyNewVertexData(meshNode, newGeometry, existingVertexData);
                }
            }
            this.updateFeatureOrder(meshNode);
        }
        transformChanged(meshNode) {
            // If the transform on a mesh changes, any features that depend on the transform need to be updated
            for (let i = 0; i < meshNode.features.length; i++) {
                const feature = meshNode.features[i];
                if (feature.affectedBy && feature.affectedBy.has(exports.eMeshChangeTypes.Transform)) {
                    this.queueGeometryUpdate(meshNode, i);
                }
            }
        }
        queueGeometryUpdate(meshNode, index) {
            let currentChanges = this.queuedFeaturesToProcess.get(meshNode);
            if (!currentChanges) {
                currentChanges = new Set();
                this.queuedFeaturesToProcess.set(meshNode, currentChanges);
            }
            currentChanges.add(index === undefined ? 0 : index);
        }
        update3dInternal(feature) {
            if (isTrackedClass(feature)) {
                if (!feature.enabled || feature._suppressed) {
                    if (feature.changes.has('enabled') || feature.changes.has('_suppressed')) {
                        this.delete3d(feature, true);
                    }
                    return;
                }
                const index = this.getFeatureIndexOnParent(feature);
                if (index > -1) {
                    this.queueGeometryUpdate(feature._parent, index);
                }
                // Process all of the feature's non-geometry effects
                const renderer = this.renderers.get(Token.withKey(feature.$type));
                if (!renderer) {
                    throw Error('no renderer for feature');
                }
                renderer.update3d(feature);
            }
        }
        update3dGeometry(renderStartTime = 0, node) {
            if (!node) {
                for (const node of this.queuedFeaturesToProcess.keys()) {
                    if (node instanceof exports.MeshNode) {
                        this.update3dGeometry(renderStartTime || performance.now(), node);
                    }
                }
                return;
            }
            if (this.queuedFeaturesToProcess.has(node) && (!(node instanceof exports.CustomMeshNode) || node.geometryLoaded)) {
                const queuedFeatureToProcess = this.queuedFeaturesToProcess.get(node);
                const startFeatureIndex = Math.min(...Array.from(queuedFeatureToProcess.values()));
                // There is a known issue here where the VertexData.ExtractFromMesh function does not contain the updated vertices from mesh.updateVerticesData yet.
                // There is probably some kind of cache that is not updated if VertexData.ExtractFromMesh runs in the same frame
                let vertexDataCurrent = this.rendererManager.mesh.getMeshGeometry(node);
                const vertexDataNew = this.queuedGeometryToReset.has(node._dynamicId)
                    ? this.queuedGeometryToReset.get(node._dynamicId)
                    : {};
                // If the whole mesh is being reset, it may be a new mesh without geometry, so we can use the entire vertexDataNew.
                // If the mesh renderer asks the feature renderer for updates, it will not apply the geometry on its own so we have to make sure it happens here.
                // This is done to prevent applying geometry to the mesh multiple times, which is expensive for very large geometry.
                if (!vertexDataCurrent && vertexDataNew instanceof SubmeshVertexData) {
                    vertexDataCurrent = vertexDataNew.shallowClone();
                }
                if (!vertexDataCurrent) {
                    this.queuedFeaturesToProcess.delete(node);
                    this.queuedGeometryToReset.delete(node._dynamicId);
                    return;
                }
                for (let i = startFeatureIndex; i < node.features.length; i++) {
                    const renderTime = performance.now() - renderStartTime;
                    if (renderTime > this.rendererManager.maxRenderTime) {
                        // store the progress of this feature stack to continue processing next frame
                        console.warn(`Feature processing time exceeded ${renderTime}ms, skipping ${this.queuedFeaturesToProcess.size} features this frame`);
                        queuedFeatureToProcess.clear();
                        queuedFeatureToProcess.add(i);
                        this.queuedGeometryToReset.set(node._dynamicId, vertexDataNew);
                        return;
                    }
                    const feature = node.features[i];
                    const renderer = this.renderers.get(Token.withKey(feature.$type));
                    if (!renderer) {
                        throw Error('no renderer for feature');
                    }
                    if (!feature.enabled || feature._suppressed) {
                        // If the feature is not enabled, then we don't process it, but we still want to update the feature's geometry cache
                        // Otherwise when the feature is enabled later it might not have the right data.
                        renderer.updateMeshGeometryCache(feature, vertexDataCurrent, vertexDataNew);
                        continue;
                    }
                    // Always process the features that were modified
                    let processThisFeature = queuedFeatureToProcess.has(i);
                    // Figure out if a property this feature is affected by was modified this cycle
                    if (!processThisFeature && feature.affectedBy) {
                        processThisFeature = featureIsAffected(feature.affectedBy, vertexDataNew);
                    }
                    if (isTrackedClass(feature)) {
                        if (processThisFeature) {
                            // Process all of the features geometry effects
                            const resultVertexData = renderer.updateMeshGeometry(feature, vertexDataCurrent, vertexDataNew);
                            if (feature.affects) {
                                feature.affects.forEach(affects => {
                                    if (affects === exports.eMeshChangeTypes.VertexPositions) {
                                        vertexDataNew.positions = resultVertexData.positions || null;
                                    }
                                    if (affects === exports.eMeshChangeTypes.VertexNormals) {
                                        vertexDataNew.normals = resultVertexData.normals || null;
                                    }
                                    if (affects === exports.eMeshChangeTypes.VertexUvs) {
                                        vertexDataNew.uvs = resultVertexData.uvs || null;
                                    }
                                    if (affects === exports.eMeshChangeTypes.VertexIndices) {
                                        vertexDataNew.indices = resultVertexData.indices || null;
                                    }
                                    if (affects === exports.eMeshChangeTypes.Submeshes) {
                                        vertexDataNew.submeshData = resultVertexData.submeshData || null;
                                    }
                                });
                            }
                        }
                    }
                }
                if (vertexDataNew.submeshData) {
                    if (!vertexDataCurrent.positions) {
                        throw Error('Invalid geometry: positions is null');
                    }
                    const submeshData = vertexDataNew.submeshData.filter(s => s.materialIndex !== 0);
                    const baseSubmeshes = calculateBaseSubmeshes(vertexDataCurrent, vertexDataNew, submeshData);
                    const verticesCount = (vertexDataNew.positions || vertexDataCurrent.positions).length / 3;
                    submeshData.unshift(...baseSubmeshes.map(bs => ({
                        materialIndex: 0,
                        verticesStart: 0,
                        verticesCount: verticesCount,
                        indexStart: bs.indexStart,
                        indexCount: bs.indexCount,
                    })));
                    vertexDataNew.submeshData = submeshData;
                }
                if (Object.getOwnPropertyNames(vertexDataNew).length > 0) {
                    this.applyNewVertexData(node, vertexDataNew, vertexDataCurrent);
                }
            }
            this.queuedFeaturesToProcess.delete(node);
            this.queuedGeometryToReset.delete(node._dynamicId);
            this.processedFeatures.set(node._dynamicId, true);
        }
        getMovedFeatureIndex(mesh) {
            const oldArray = this.featureOrder.get(mesh._dynamicId);
            if (oldArray) {
                if (oldArray.length !== mesh.features.length) {
                    return -1;
                }
                for (let i = 0; i < oldArray.length; i++) {
                    const newArrayId = mesh.features[i]._dynamicId;
                    if (oldArray[i] !== newArrayId) {
                        return i;
                    }
                }
            }
            else {
                return -1;
            }
        }
        updateFeatureOrder(mesh) {
            const features = [];
            mesh.features.forEach(feature => {
                features.push(feature._dynamicId);
            });
            this.featureOrder.set(mesh._dynamicId, features);
        }
        recursivelyUpdateFeatureVisibility(affectedFeatures, features, disabledFeatures) {
            if (affectedFeatures.length === 0) {
                disabledFeatures.forEach(feature => {
                    console.warn('The feature named', feature.name, 'got disabled due to a possible breaking change in the feature stack.');
                });
                return;
            }
            const newAffectedFeatures = [];
            affectedFeatures.forEach(affectedFeature => {
                var _a;
                const featureIndex = getFeatureIndex(affectedFeature, features);
                if (featureIndex >= 0) {
                    for (let i = featureIndex; i < features.length; i++) {
                        const feature = features[i];
                        if (feature.enabled) {
                            (_a = affectedFeature.affects) === null || _a === void 0 ? void 0 : _a.forEach(affector => {
                                if (feature.dependsOn && feature.dependsOn.has(affector)) {
                                    feature.enabled = false;
                                    disabledFeatures.push(feature);
                                    feature._disableFeatureStackChange = true;
                                    newAffectedFeatures.push(feature);
                                }
                            });
                        }
                    }
                }
            });
            this.recursivelyUpdateFeatureVisibility(newAffectedFeatures, features, disabledFeatures);
            function getFeatureIndex(feature, features) {
                for (let i = 0; i < features.length; i++) {
                    if (features[i] === feature) {
                        return i;
                    }
                }
                return -1;
            }
        }
        applyNewVertexData(node, vertexDataNew, vertexDataCurrent) {
            const mesh = this.viewer.getRendererNode(node);
            SubmeshVertexData.ExtendToRef(vertexDataNew, vertexDataCurrent);
            const invalid = verifyGeometry(vertexDataCurrent);
            if (invalid) {
                console.error(`Invalid or corrupted geometry output after feature processing in mesh ${node.name}. The ${invalid} are invalid.`);
            }
            else {
                vertexDataCurrent.applyToMesh(mesh);
                node._polygonCount = mesh.getTotalIndices() / 3;
                node._verticesCount = mesh.getTotalVertices();
                this.viewer.polygonTracker.next();
                this.viewer.warningTracker.next();
            }
            this.rendererManager.mesh.setRenderModeOnMesh(mesh, node._rootScene);
            this.viewer.bbCache.invalidate(node);
        }
        delete3d(feature, preserveCache) {
            const meshNode = feature._parent;
            if (meshNode && feature.affects) {
                this.resetMeshGeometry(meshNode, feature.affects);
            }
            const renderer = this.renderers.get(Token.withKey(feature.$type));
            if (!renderer) {
                throw Error('no renderer for feature');
            }
            renderer.delete3d(feature, preserveCache);
        }
        dispose() {
            this.queuedFeaturesToProcess.clear();
            this.renderers.forEach(renderer => renderer.dispose());
            super.dispose();
        }
        getFeatureIndexOnParent(feature) {
            if (feature._parent) {
                const index = feature._parent.features.findIndex(f => f._dynamicId === feature._dynamicId);
                if (index > -1) {
                    return index;
                }
            }
            return -1;
        }
    }
    function calculateBaseSubmeshes(vertexDataCurrent, vertexDataNew, submeshData) {
        submeshData.sort((a, b) => a.indexStart - b.indexStart);
        const indicesCount = (vertexDataNew.indices || vertexDataCurrent.indices).length;
        const baseSubmeshes = [
            {
                indexStart: 0,
                indexCount: indicesCount,
            },
        ];
        submeshData.forEach(submesh => {
            const lastSubmesh = baseSubmeshes[baseSubmeshes.length - 1];
            if (lastSubmesh) {
                if (submesh.indexStart <= lastSubmesh.indexStart &&
                    submesh.indexStart + submesh.indexCount > lastSubmesh.indexStart) {
                    lastSubmesh.indexStart = submesh.indexStart + submesh.indexCount;
                    lastSubmesh.indexCount = indicesCount - lastSubmesh.indexStart;
                    if (lastSubmesh.indexCount <= 0) {
                        baseSubmeshes.splice(-1, 1);
                    }
                }
                else if (submesh.indexStart > lastSubmesh.indexStart) {
                    lastSubmesh.indexCount = submesh.indexStart - lastSubmesh.indexStart;
                    const remainingIndexCount = indicesCount - (submesh.indexStart + submesh.indexCount);
                    if (remainingIndexCount > 0) {
                        baseSubmeshes.push({
                            indexStart: submesh.indexStart + submesh.indexCount,
                            indexCount: remainingIndexCount,
                        });
                    }
                }
            }
        });
        return baseSubmeshes;
    }
    function featureIsAffected(affected, vertexDataNew) {
        let result = false;
        affected.forEach(affectedBy => {
            if (affectedBy === exports.eMeshChangeTypes.VertexPositions) {
                if (vertexDataNew.positions) {
                    result = true; // Process the feature if a property it's affected by was changed this cycle
                }
            }
            if (affectedBy === exports.eMeshChangeTypes.VertexNormals) {
                if (vertexDataNew.normals) {
                    result = true; // Process the feature if a property it's affected by was changed this cycle
                }
            }
            if (affectedBy === exports.eMeshChangeTypes.VertexUvs) {
                if (vertexDataNew.uvs) {
                    result = true; // See above
                }
            }
            if (affectedBy === exports.eMeshChangeTypes.VertexIndices) {
                if (vertexDataNew.indices) {
                    result = true; // See above
                }
            }
            if (affectedBy === exports.eMeshChangeTypes.Submeshes) {
                if (vertexDataNew.submeshData) {
                    result = true; // See above
                }
            }
        });
        return result;
    }
    function hasChange(set, changeType) {
        return set.has(changeType);
    }

    const getMeshName = {
        handles: (dynamicId) => `${dynamicId}_handles`,
        handleBar: (dynamicId) => `${dynamicId}_handleBar`,
        directionHandle1: (dynamicId) => `${dynamicId}_directionHandle1`,
        directionHandle2: (dynamicId) => `${dynamicId}_directionHandle2`,
    };
    class SketchControlPointRenderer extends ConnectorRenderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene, rendererManager);
            this.controlPointScaleRatio = 0.12;
            this.modelToken = Token.SketchControlPoint;
            this.layers.forEach(layer => {
                layer.parts = new Map();
            });
        }
        handlesNode(node) {
            return instanceOf(node, Token.SketchControlPoint);
        }
        update3dInternal(c) {
            const realLayer = this.layers.get('real');
            const utilityLayer = this.layers.get('utility');
            const { mesh, utilityMesh } = super.update3dInternal(c, true);
            if (c._parent instanceof exports.SketchPath) {
                const realParts = realLayer.parts.get(c._dynamicId);
                const utilityParts = utilityLayer.parts.get(c._dynamicId);
                if (c.changes.hasAny('direction', 'direction2')) {
                    if (realParts) {
                        updateHandles(realParts, c, c._parent);
                    }
                    if (utilityParts) {
                        updateHandles(utilityParts, c, c._parent);
                    }
                }
            }
            return { mesh, utilityMesh };
            function updateHandles(parts, controlPoint, path) {
                var _a, _b;
                let enableHandle1, enableHandle2;
                switch (path.type) {
                    case exports.eSketchPathType.arcThrough3Points:
                    case exports.eSketchPathType.points:
                    case exports.eSketchPathType.centerRadiusCircle:
                    case exports.eSketchPathType.catmullRom:
                        enableHandle1 = false;
                        enableHandle2 = false;
                        break;
                    case exports.eSketchPathType.quadraticBezier:
                    case exports.eSketchPathType.hermite:
                        // Don't show handles on the ends of the path since that handle does nothing
                        enableHandle1 =
                            path.controlPoints.findIndex(cp => cp._dynamicId === controlPoint._dynamicId) <
                                path.controlPoints.length - 1;
                        enableHandle2 = false;
                        break;
                    default:
                        // Don't show handles on the ends of the path since that handle does nothing
                        enableHandle1 =
                            path.controlPoints.findIndex(cp => cp._dynamicId === controlPoint._dynamicId) <
                                path.controlPoints.length - 1;
                        enableHandle2 = path.controlPoints.findIndex(cp => cp._dynamicId === controlPoint._dynamicId) > 0;
                }
                if (parts.directionHandle1 && c.direction.length() > 0) {
                    parts.directionHandle1.position = c.direction.toVec3();
                }
                if (parts.directionHandle2 && c.direction2 && c.direction2.length() > 0) {
                    parts.directionHandle2.position = c.direction2.toVec3();
                }
                (_a = parts.directionHandle1) === null || _a === void 0 ? void 0 : _a.setEnabled(enableHandle1);
                (_b = parts.directionHandle2) === null || _b === void 0 ? void 0 : _b.setEnabled(enableHandle2);
                if (parts.handleBar) {
                    parts.handleBar.setEnabled(true);
                    parts.handleBar = MeshBuilder.CreateDashedLines(getMeshName.handleBar(c._dynamicId), {
                        points: [
                            enableHandle1 ? c.direction.toVec3() : Vector3.Zero(),
                            Vector3.Zero(),
                            enableHandle2 && c.direction2 ? c.direction2.toVec3() : Vector3.Zero(),
                        ],
                        updatable: true,
                        instance: parts.handleBar,
                    });
                }
            }
        }
        delete3d(c) {
            const mesh = this.getMesh(c, this.layers.get('real'));
            const utilityMesh = this.getMesh(c, this.layers.get('utility'));
            this.viewer.camera.clearMaintainedNodeScreenSize(mesh);
            if (utilityMesh) {
                this.viewer.camera.clearMaintainedNodeScreenSize(utilityMesh);
            }
            super.delete3d(c);
            const sketchPath = c._parent;
            if (sketchPath && isTrackedClass(sketchPath)) {
                sketchPath.setPropertyIsModified('controlPoints', true);
            }
        }
        updateDirection(c) {
            const realLayer = this.layers.get('real');
            const utilityLayer = this.layers.get('utility');
            const mesh = this.getMesh(c, realLayer);
            const utilityMesh = this.getMesh(c, utilityLayer);
            const deltaBtwXaxisAndDirection = getRotationBtwVectors(Axis.X, this.getRelativeDirection(c, c.direction).normalize());
            const angleRot = Quaternion.RotationAxis(Axis.X, toRadians(c.angle));
            mesh.rotationQuaternion = utilityMesh.rotationQuaternion = deltaBtwXaxisAndDirection.multiply(angleRot);
            const realParts = realLayer.parts.get(c._dynamicId);
            const utilityParts = utilityLayer.parts.get(c._dynamicId);
            if (realParts === null || realParts === void 0 ? void 0 : realParts.handleContainer) {
                const invTransform = Matrix.Compose(Vector3.One(), mesh.rotationQuaternion, Vector3.Zero());
                invTransform.invert();
                invTransform.decomposeToTransformNode(realParts.handleContainer);
                if (utilityParts === null || utilityParts === void 0 ? void 0 : utilityParts.handleContainer) {
                    invTransform.decomposeToTransformNode(utilityParts.handleContainer);
                }
            }
            this.updateScale(c);
        }
        updatePosition(c, bb) {
            const mesh = this.getMesh(c, this.layers.get('real'));
            const utilityMesh = this.getMesh(c, this.layers.get('utility'));
            mesh.position = this.getControlPointAbsPosition(c, bb);
            if (utilityMesh) {
                utilityMesh.position = mesh.position;
            }
            const sketchPath = c._parent;
            if (sketchPath && isTrackedClass(sketchPath)) {
                sketchPath.setPropertyIsModified('controlPoints', true);
            }
        }
        getControlPointAbsPosition(c, bb) {
            var _a;
            if (c.positionMode == exports.eConnectorPositionMode.boundingBox) {
                if (!bb) {
                    bb = (_a = c.getSketch()) === null || _a === void 0 ? void 0 : _a.getBoundingBox();
                }
                if (bb) {
                    return BoundingBoxRelativeHelper.convertRelativeToAbsolute(c, bb);
                }
                else {
                    return new Vector3(c.position.x, c.position.y, c.position.z);
                }
            }
            else {
                return c.position.toVec3();
            }
        }
        getRelativeDirection(c, direction, bb) {
            var _a;
            if (c.positionMode === exports.eConnectorPositionMode.absolute) {
                return direction.toVec3();
            }
            else {
                if (!bb) {
                    bb = (_a = c.getSketch()) === null || _a === void 0 ? void 0 : _a.getBoundingBox();
                }
                if (!bb) {
                    return Vector3.Zero();
                }
                return BoundingBoxRelativeHelper.convertRelativeDirectionToAbsolute(c, direction, bb);
            }
        }
        getMesh(c, layer) {
            var _a;
            let mesh = layer.map.get(c._dynamicId);
            if (!mesh) {
                if (!layer.template) {
                    layer.template = this.createMeshTemplate(layer);
                }
                mesh = layer.template.clone(c._dynamicId); // layer.template.createInstance(c._dynamicId);
                mesh.id = c._dynamicId;
                const [handleContainer] = mesh.getChildren();
                const [directionHandle1, directionHandle2, _handleBar] = handleContainer.getChildMeshes(true);
                const handleBar = _handleBar;
                handleBar.makeGeometryUnique();
                handleContainer.id = getMeshName.handles(c._dynamicId);
                directionHandle1.id = getMeshName.directionHandle1(c._dynamicId);
                directionHandle2.id = getMeshName.directionHandle2(c._dynamicId);
                const parentNode = (_a = c._parent) === null || _a === void 0 ? void 0 : _a._parent;
                if (parentNode && parentNode instanceof exports.SpaceNode) {
                    const parent3d = this.viewer.getRendererNode(parentNode);
                    if (parent3d) {
                        mesh.setParent(parent3d);
                    }
                }
                mesh.isPickable = layer.pickable;
                mesh.position = Vector3.Zero();
                mesh.rotationQuaternion = Quaternion.Identity();
                layer.map.set(c._dynamicId, mesh);
                layer.parts.set(c._dynamicId, {
                    mesh,
                    handleContainer: handleContainer,
                    directionHandle1,
                    directionHandle2,
                    handleBar: handleBar,
                });
            }
            return mesh;
        }
        createMeshTemplate(layer) {
            var _a;
            const mesh = super.createMeshTemplate(layer);
            const handleContainer = new TransformNode('', this.scene);
            const handleBall = CreateSphere('handle1', {
                segments: 4,
                diameter: CONNECTOR_DIAM / 2,
            });
            handleBall.setParent(handleContainer);
            const m = new StandardMaterial('controlPointMaterial', this.scene);
            m.emissiveColor = this.viewer.highlightColor.toColor3();
            m.disableLighting = true;
            handleBall.material = m;
            const handle1 = handleBall;
            const handle2 = handleBall.clone('handle2', handleContainer, true);
            handle1.setEnabled(false);
            handle2.setEnabled(false);
            const baseColor = ((_a = this.viewer.sceneNode) === null || _a === void 0 ? void 0 : _a.edgeColor)
                ? this.viewer.sceneNode.edgeColor.toColor3()
                : Color3.White();
            const handleBar = MeshBuilder.CreateDashedLines('handleBar', {
                points: [Vector3.Up(), Vector3.Zero(), Vector3.Down()],
                updatable: true,
                dashSize: 1,
                gapSize: 1,
                dashNb: 30,
            });
            handleBar.color = baseColor;
            handleBar.isPickable = false;
            // const handleBarMaterial = new StandardMaterial('controlPointHandleBarMaterial', this.scene);
            // handleBarMaterial.emissiveColor = this.viewer.sceneNode?.edgeColor ? this.viewer.sceneNode.edgeColor.toColor3() : Color3.White();
            // handleBar.material = handleBarMaterial;
            handleBar.setParent(handleContainer);
            handleContainer.setParent(mesh);
            return mesh;
        }
        addSubscription(c) {
            const sketch = c.getSketch();
            if (sketch && !this.subscriptionMap.has(c)) {
                this.subscriptionMap.set(c, sketch._boundingBoxChanges.subscribe(bbInfo => {
                    this.updatePosition(c, bbInfo);
                    this.updateScale(c);
                }));
            }
        }
    }

    class ReferenceProcessor extends Processor {
        constructor(viewer) {
            super();
            this.viewer = viewer;
            /**
             * referencedNodeId => ( referencedByNodeId => referencedByNode )
             *
             * Any node that is in a nested scene will be keyed by the nested scene ID.
             * If the node is not in a nested scene (or there is no nesting), then the node will be keyed by the bare node id.
             * This applies to the referencedNodeId and the referencedByNodeId.
             * */
            this.referencesTo = new Map();
            this.orphanedReferences = new Map();
        }
        beforeDeletions(deletions) {
            const rootScene = this.viewer.sceneNode;
            if (!rootScene || !rootScene._manager) {
                return;
            }
            const rootManager = rootScene._manager;
            deletions.all().forEach(node => {
                var _a;
                if (!node._manager) {
                    return;
                }
                let nodeId = node.id;
                if ((_a = node._parentScene) === null || _a === void 0 ? void 0 : _a.isNested()) {
                    nodeId = rootScene.getNestedPathTo(node);
                }
                const referenceTo = this.referencesTo.get(nodeId);
                if (referenceTo && referenceTo.size > 0) {
                    referenceTo.forEach((opts, referencedById) => {
                        const referencedBy = rootManager.getById(referencedById);
                        if (referencedBy && referencedBy[opts.referencePropertyName] === nodeId) {
                            this.orphanedReferences.set(nodeId, {
                                referencedBy,
                                propName: opts.referencePropertyName,
                                referenceId: referencedBy[opts.referencePropertyName],
                            });
                            referencedBy[opts.referencePropertyName] = undefined;
                        }
                    });
                }
            });
        }
        getReferencesTo() {
            return this.referencesTo;
        }
        beforeUpdates(changes) {
            const rootScene = this.viewer.sceneNode;
            if (!rootScene || !rootScene._manager) {
                return;
            }
            changes.all().forEach(node => {
                var _a;
                let nodeId = node.id;
                if ((_a = node._parentScene) === null || _a === void 0 ? void 0 : _a.isNested()) {
                    nodeId = rootScene.getNestedPathTo(node);
                }
                const orphanedReference = this.orphanedReferences.get(nodeId);
                if (orphanedReference) {
                    orphanedReference.referencedBy[orphanedReference.propName] = orphanedReference.referenceId;
                }
            });
        }
        afterUpdates(changes) {
            const rootScene = this.viewer.sceneNode;
            if (!rootScene || !rootScene._manager) {
                return;
            }
            changes.all().forEach(node => {
                var _a, _b, _c;
                if (!node._manager) {
                    return;
                }
                const changedNodeManager = node._manager;
                // This block is for managing/updating the node reference
                // First, check nodes referencing other nodes for updates
                if (node.nodeReferences) {
                    const targettingProperties = node.nodeReferences.keys();
                    for (const _prop of targettingProperties) {
                        const property = _prop;
                        const referenceSettings = node.nodeReferences.get(_prop);
                        // If a node's references were changed, update all the references.
                        if (node.changes.has(property)) {
                            if (node[property] && typeof node[property] !== 'string') {
                                console.error(`Non-string id reference value found on ${node.name} property ${property}`);
                            }
                            // First, remove the node from the previous target node's referencing nodes set
                            if (node.originalValues.has(property)) {
                                const originalReferencedNodeId = node.originalValues.get(property);
                                if (originalReferencedNodeId) {
                                    // Figure out the original target node's key
                                    let originalReferencedNodeKey = originalReferencedNodeId;
                                    const originalReferencedNode = changedNodeManager.getById(originalReferencedNodeId);
                                    if ((_a = originalReferencedNode === null || originalReferencedNode === void 0 ? void 0 : originalReferencedNode._parentScene) === null || _a === void 0 ? void 0 : _a.isNested()) {
                                        originalReferencedNodeKey = rootScene.getNestedPathTo(originalReferencedNode);
                                    }
                                    const referencedBy = this.referencesTo.get(originalReferencedNodeKey);
                                    if (referencedBy) {
                                        let nestedPathIdSource = node.id;
                                        if ((_b = node._parentScene) === null || _b === void 0 ? void 0 : _b.isNested()) {
                                            nestedPathIdSource = rootScene.getNestedPathTo(node);
                                        }
                                        referencedBy.delete(nestedPathIdSource);
                                    }
                                }
                            }
                            // Set up the new references or delete the reference from entry if the reference was cleared
                            if (node[property]) {
                                const targetNode = node._manager.getById(node[property]);
                                if (targetNode) {
                                    if (targetNode instanceof referenceSettings.classRef) {
                                        let nestedPathIdTarget = node[property];
                                        let nestedPathIdSource = node.id;
                                        const isNestedSource = ((_c = node._parentScene) === null || _c === void 0 ? void 0 : _c.isNested()) || false;
                                        if (nestedPathIdTarget.startsWith('@')) {
                                            const nestedTargetNode = changedNodeManager.getById(nestedPathIdTarget);
                                            if (nestedTargetNode) {
                                                nestedPathIdTarget = rootScene.getNestedPathTo(nestedTargetNode);
                                            }
                                        }
                                        else if (isNestedSource) {
                                            // If source node is in a nested scene and the target node id is not a nested path, that means that
                                            // the nested node is targetting a node in it's own scene. But we need to use
                                            // a nested path because there could be multiple instances of the nested node's scene
                                            nestedPathIdTarget = rootScene.getNestedPathTo(targetNode);
                                        }
                                        if (isNestedSource) {
                                            nestedPathIdSource = rootScene.getNestedPathTo(node);
                                        }
                                        let referencedBy = this.referencesTo.get(nestedPathIdTarget);
                                        if (!referencedBy) {
                                            referencedBy = new Map();
                                            this.referencesTo.set(nestedPathIdTarget, referencedBy);
                                        }
                                        referencedBy.set(nestedPathIdSource, {
                                            limitKeys: referenceSettings.limitKeys,
                                            ref: node,
                                            referencePropertyName: property,
                                        });
                                    }
                                    else {
                                        console.warn(`Node ${node.name} property ${property} is not referencing a ${referenceSettings.classRef}`);
                                    }
                                }
                            }
                        }
                    }
                }
            });
            // Next, check nodes being referenced by other nodes to see if the other nodes will need to be updated
            changes.all().forEach(node => {
                this.triggerChangesOnReferencers(node);
            });
        }
        triggerChangesOnReferencers(node, changes) {
            const changeMap = changes || new Map(node.changes);
            if (changeMap.size > 0) {
                this.afterCleanup(() => {
                    this.triggerChangesOnReferencersSync(node, changeMap);
                });
            }
        }
        triggerChangesOnReferencersSync(node, changes, transformationPropagation) {
            var _a;
            const rootScene = this.viewer.sceneNode;
            if (!rootScene || !rootScene._manager) {
                return;
            }
            const rootManager = rootScene._manager;
            let nodeId = node.id;
            if ((_a = node._parentScene) === null || _a === void 0 ? void 0 : _a.isNested()) {
                nodeId = rootScene.getNestedPathTo(node);
            }
            const referenceTo = this.referencesTo.get(nodeId);
            if (referenceTo) {
                referenceTo.forEach((referenceSettings, referencedById) => {
                    const referencedBy = rootManager.getById(referencedById);
                    if (referencedBy && isTrackedClass(referencedBy)) {
                        if (!referenceSettings.limitKeys ||
                            transformationPropagation ||
                            changes.hasAny(...referenceSettings.limitKeys)) {
                            referencedBy.setPropertyIsModified(referenceSettings.referencePropertyName, true);
                        }
                    }
                });
            }
            // For transformation changes, propagate to the children because the children will also get moved without passing through the change tracker
            // This avoids needing a secondary watcher for node position
            if (node instanceof exports.SpaceNode &&
                changes.hasAny('position', 'eulerRotation', 'rotationAngle', 'rotationAxis', 'pivot', 'scaling')) {
                const children = node.getChildren();
                for (let i = 0; i < children.length; i++) {
                    // Always trigger changes on children because they may have different property names
                    this.triggerChangesOnReferencersSync(children[i], changes, true);
                }
            }
        }
        dispose() {
            this.referencesTo.clear();
        }
    }

    /**
     * Processor to calculate the bounding box of a sketch, since it is determined by the path defined within.
     * Must run after the mate processor because mates can move sketch points and change the bounding box.
     */
    class SketchProcessor extends Processor {
        constructor(controlPointRenderer) {
            super();
            this.controlPointRenderer = controlPointRenderer;
        }
        beforeRender() { }
        beforeDeletions(deletions) {
            // Update paths that need to be updated
            if (deletions.has(Token.SketchPath)) {
                const sketchPaths = deletions.get(Token.SketchPath);
                sketchPaths.forEach(p => this.updatePath(p));
            }
            if (deletions.has(Token.SketchControlPoint) || deletions.has(Token.SketchPath)) {
                const sketchPathChanges = deletions.get(Token.SketchPath);
                const sketchControlPointChanges = deletions.get(Token.SketchControlPoint);
                const sketchesToUpdate = new Map();
                sketchPathChanges.forEach(node => {
                    const sketch = node._parent;
                    if (sketch) {
                        if (!sketchesToUpdate.has(sketch._dynamicId)) {
                            sketchesToUpdate.set(sketch._dynamicId, sketch);
                        }
                    }
                });
                sketchControlPointChanges.forEach(node => {
                    const sketch = node.getSketch();
                    if (sketch) {
                        if (!sketchesToUpdate.has(sketch._dynamicId)) {
                            sketchesToUpdate.set(sketch._dynamicId, sketch);
                        }
                    }
                });
                sketchesToUpdate.forEach(this.calculateSketchBounds);
            }
        }
        beforeUpdates(changes) {
            // Update paths that need to be updated
            if (changes.has(Token.SketchPath)) {
                const sketchPaths = changes.get(Token.SketchPath);
                sketchPaths.forEach(p => this.updatePath(p));
            }
            // Update the sketch bounding box with the path control points within it that are absolute positioned
            if (changes.has(Token.SketchControlPoint)) {
                const sketchControlPointChanges = changes.get(Token.SketchControlPoint);
                const sketchesToUpdate = new Map();
                sketchControlPointChanges.forEach(node => {
                    if (node.changes.hasAny('position', 'positionMode')) {
                        const sketch = node.getSketch();
                        if (sketch) {
                            if (!sketchesToUpdate.has(sketch._dynamicId)) {
                                sketchesToUpdate.set(sketch._dynamicId, sketch);
                            }
                        }
                    }
                });
                sketchesToUpdate.forEach(this.calculateSketchBounds);
            }
        }
        afterUpdates(changes) {
            if (changes.has(Token.SketchControlPoint)) {
                const sketchControlPointChanges = changes.get(Token.SketchControlPoint);
                sketchControlPointChanges.forEach(node => {
                    const sketch = node.getSketch();
                    if (sketch) {
                        this.afterCleanup(() => {
                            sketch.paths.forEach(path => {
                                if (isTrackedClass(path)) {
                                    this.updatePath(path, true);
                                }
                            });
                            sketch.connectors.forEach(connector => {
                                if (connector.positionMode === exports.eConnectorPositionMode.moveAlongSketch) {
                                    if (connector._parent instanceof exports.SketchNode) {
                                        connector._sketchControlPoints = this.getControlPoints(connector._parent);
                                    }
                                }
                            });
                        });
                    }
                });
            }
        }
        calculateSketchBounds(sketch) {
            const controlPoints = sketch.paths.flatMap(path => path.controlPoints);
            let min;
            let max;
            controlPoints.forEach(controlPoint => {
                if (controlPoint.positionMode === exports.eConnectorPositionMode.absolute) {
                    const position = controlPoint.position;
                    if (!min) {
                        min = position.toVec3();
                    }
                    max = position.toVec3();
                }
            });
            if (min && max) {
                sketch._boundingBoxMin = exports.KbVector.FromVec3(min);
                sketch._boundingBoxMax = exports.KbVector.FromVec3(max);
            }
            else {
                sketch._boundingBoxMin = exports.KbVector.Zero();
                sketch._boundingBoxMax = exports.KbVector.Zero();
            }
            sketch._boundingBoxChanges.next(sketch.getBoundingBox());
        }
        updatePath(path, force) {
            var _a;
            let points;
            if (force ||
                path.changes.hasAny('controlPoints', 'tessellation', 'type', 'holeForPathGroup', 'pathGroupKey') ||
                !((_a = path._points) === null || _a === void 0 ? void 0 : _a.length)) {
                points = this.buildSketchPoints(path);
                path._points = points;
                const parent = path._parent;
                if (parent instanceof exports.SketchNode && isTrackedClass(parent)) {
                    parent.setPropertyIsModified('paths', true);
                }
            }
            else if (path.changes.has('_selected')) {
                const parent = path._parent;
                if (parent instanceof exports.SketchNode && isTrackedClass(parent)) {
                    parent.setPropertyIsModified('paths', true);
                }
            }
        }
        buildSketchPoints(path) {
            const points = [];
            if (!path._parent) {
                return points;
            }
            const bb = path._parent.getBoundingBox();
            switch (path.type) {
                case exports.eSketchPathType.catmullRom: {
                    const positions = path.controlPoints.map(v => this.getPointPosition(v));
                    if (positions.length > 2) {
                        const curve = Curve3.CreateCatmullRomSpline(positions, path.tessellation, false);
                        points.push(...curve.getPoints());
                    }
                    else {
                        points.push(...positions);
                    }
                    break;
                }
                case exports.eSketchPathType.hermite: {
                    for (let i = 0; i + 1 < path.controlPoints.length; i++) {
                        const start = path.controlPoints[i], end = path.controlPoints[i + 1];
                        const p0 = this.getPointPosition(start);
                        const p1 = this.getPointPosition(end);
                        const d0 = this.getPointDirection(start, bb);
                        const d1 = this.getPointDirection(end, bb);
                        const curve = Curve3.CreateHermiteSpline(p0, d0, p1, d1, path.tessellation);
                        points.push(...curve.getPoints());
                    }
                    break;
                }
                case exports.eSketchPathType.cubicBezier: {
                    for (let i = 0; i + 1 < path.controlPoints.length; i++) {
                        const start = path.controlPoints[i], end = path.controlPoints[i + 1];
                        const direction2 = this.getPointDirection2(end, bb);
                        if (direction2) {
                            const p0 = this.getPointPosition(start);
                            const p3 = this.getPointPosition(end);
                            if (p0.equals(p3)) {
                                continue;
                            }
                            const p1 = p0.add(this.getPointDirection(start, bb));
                            const p2 = p3.add(direction2);
                            const curve = Curve3.CreateCubicBezier(p0, p1, p2, p3, path.tessellation);
                            points.push(...curve.getPoints());
                        }
                    }
                    break;
                }
                case exports.eSketchPathType.quadraticBezier: {
                    const controlPoint = new Vector3();
                    for (let i = 0; i + 1 < path.controlPoints.length; i++) {
                        const start = path.controlPoints[i], end = path.controlPoints[i + 1];
                        const p0 = this.getPointPosition(start);
                        const p2 = this.getPointPosition(end);
                        if (p0.equals(p2)) {
                            continue;
                        }
                        p0.addToRef(this.getPointDirection(start, bb), controlPoint);
                        const curve = Curve3.CreateQuadraticBezier(p0, controlPoint, p2, path.tessellation);
                        points.push(...curve.getPoints());
                    }
                    break;
                }
                case exports.eSketchPathType.centerRadiusCircle: {
                    if (path.controlPoints.length >= 2) {
                        const [p0, p1] = path.controlPoints.slice(0, 2).map(cp => this.getPointPosition(cp));
                        const normal = this.getPointDirection(path.controlPoints[0], bb).normalize();
                        const p2 = Vector3.Cross(p0.subtract(p1), normal).addInPlace(p0);
                        const curve = Curve3.ArcThru3Points(p0.scale(2).subtractInPlace(p1), p1, p2, path.tessellation * 2, false, true);
                        points.push(...curve.getPoints());
                    }
                    break;
                }
                case exports.eSketchPathType.arcThrough3Points: {
                    if (path.controlPoints.length >= 3) {
                        const [p0, p1, p2] = path.controlPoints.slice(0, 3).map(cp => this.getPointPosition(cp));
                        const curve = Curve3.ArcThru3Points(p0, p1, p2, path.tessellation, false, false);
                        points.push(...curve.getPoints());
                    }
                    break;
                }
                default: {
                    path.controlPoints.forEach(point => {
                        points.push(this.getPointPosition(point));
                    });
                }
            }
            // /**
            //  * We want the sketch to always "face" in the positive direction of the axis for consistency
            //  * Otherwise it's indeterminate which way the sketch will face and makes the sketch hard to manage
            //  * because it depends on the handed-ness of the points (clockwise or counter-clockwise)
            //  */
            // const primaryNormal = axisToVector3(path._parent.normal);
            // const faceNormal = calculateFaceNormal(points);
            // if (Vector3.Dot(faceNormal, primaryNormal) < 0) {
            //     points.reverse();
            // }
            return points;
        }
        getPointPosition(point) {
            return this.controlPointRenderer.getControlPointAbsPosition(point);
        }
        getPointDirection(point, bb) {
            return this.controlPointRenderer.getRelativeDirection(point, point.direction, bb);
        }
        getPointDirection2(point, bb) {
            if (!point.direction2) {
                return undefined;
            }
            else {
                return this.controlPointRenderer.getRelativeDirection(point, point.direction2, bb);
            }
        }
        getControlPoints(node) {
            const controlPoints = [];
            node.paths.forEach(path => {
                path._points.forEach(point => {
                    controlPoints.push(point);
                });
            });
            return controlPoints;
        }
    }

    /**
     * PostProcessRenderPipeline
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
     */
    class PostProcessRenderPipeline {
        /**
         * Gets pipeline name
         */
        get name() {
            return this._name;
        }
        /** Gets the list of attached cameras */
        get cameras() {
            return this._cameras;
        }
        /**
         * Initializes a PostProcessRenderPipeline
         * @param _engine engine to add the pipeline to
         * @param name name of the pipeline
         */
        constructor(_engine, name) {
            this._engine = _engine;
            this._name = name;
            this._renderEffects = {};
            this._renderEffectsForIsolatedPass = new Array();
            this._cameras = [];
        }
        /**
         * Gets the class name
         * @returns "PostProcessRenderPipeline"
         */
        getClassName() {
            return "PostProcessRenderPipeline";
        }
        /**
         * If all the render effects in the pipeline are supported
         */
        get isSupported() {
            for (const renderEffectName in this._renderEffects) {
                if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
                    if (!this._renderEffects[renderEffectName].isSupported) {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * Adds an effect to the pipeline
         * @param renderEffect the effect to add
         */
        addEffect(renderEffect) {
            this._renderEffects[renderEffect._name] = renderEffect;
        }
        // private
        /** @internal */
        _rebuild() { }
        /**
         * @internal
         */
        _enableEffect(renderEffectName, cameras) {
            const renderEffects = this._renderEffects[renderEffectName];
            if (!renderEffects) {
                return;
            }
            renderEffects._enable(Tools.MakeArray(cameras || this._cameras));
        }
        /**
         * @internal
         */
        _disableEffect(renderEffectName, cameras) {
            const renderEffects = this._renderEffects[renderEffectName];
            if (!renderEffects) {
                return;
            }
            renderEffects._disable(Tools.MakeArray(cameras || this._cameras));
        }
        /**
         * @internal
         */
        _attachCameras(cameras, unique) {
            const cams = Tools.MakeArray(cameras || this._cameras);
            if (!cams) {
                return;
            }
            const indicesToDelete = [];
            let i;
            for (i = 0; i < cams.length; i++) {
                const camera = cams[i];
                if (!camera) {
                    continue;
                }
                if (this._cameras.indexOf(camera) === -1) {
                    this._cameras.push(camera);
                }
                else if (unique) {
                    indicesToDelete.push(i);
                }
            }
            for (i = 0; i < indicesToDelete.length; i++) {
                cams.splice(indicesToDelete[i], 1);
            }
            for (const renderEffectName in this._renderEffects) {
                if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
                    this._renderEffects[renderEffectName]._attachCameras(cams);
                }
            }
        }
        /**
         * @internal
         */
        _detachCameras(cameras) {
            const cams = Tools.MakeArray(cameras || this._cameras);
            if (!cams) {
                return;
            }
            for (const renderEffectName in this._renderEffects) {
                if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
                    this._renderEffects[renderEffectName]._detachCameras(cams);
                }
            }
            for (let i = 0; i < cams.length; i++) {
                this._cameras.splice(this._cameras.indexOf(cams[i]), 1);
            }
        }
        /** @internal */
        _update() {
            for (const renderEffectName in this._renderEffects) {
                if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
                    this._renderEffects[renderEffectName]._update();
                }
            }
            for (let i = 0; i < this._cameras.length; i++) {
                if (!this._cameras[i]) {
                    continue;
                }
                const cameraName = this._cameras[i].name;
                if (this._renderEffectsForIsolatedPass[cameraName]) {
                    this._renderEffectsForIsolatedPass[cameraName]._update();
                }
            }
        }
        /** @internal */
        _reset() {
            this._renderEffects = {};
            this._renderEffectsForIsolatedPass = new Array();
        }
        _enableMSAAOnFirstPostProcess(sampleCount) {
            if (!this._engine._features.supportMSAA) {
                return false;
            }
            // Set samples of the very first post process to 4 to enable native anti-aliasing in browsers that support webGL 2.0 (See: https://github.com/BabylonJS/Babylon.js/issues/3754)
            const effectKeys = Object.keys(this._renderEffects);
            if (effectKeys.length > 0) {
                const postProcesses = this._renderEffects[effectKeys[0]].getPostProcesses();
                if (postProcesses) {
                    postProcesses[0].samples = sampleCount;
                }
            }
            return true;
        }
        /**
         * Sets the required values to the prepass renderer.
         * @param prePassRenderer defines the prepass renderer to setup.
         * @returns true if the pre pass is needed.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setPrePassRenderer(prePassRenderer) {
            // Do Nothing by default
            return false;
        }
        /**
         * Disposes of the pipeline
         */
        dispose() {
            // Must be implemented by children
        }
    }
    __decorate$1([
        serialize()
    ], PostProcessRenderPipeline.prototype, "_name", void 0);

    /**
     * This represents a set of one or more post processes in Babylon.
     * A post process can be used to apply a shader to a texture after it is rendered.
     * @example https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
     */
    class PostProcessRenderEffect {
        /**
         * Instantiates a post process render effect.
         * A post process can be used to apply a shader to a texture after it is rendered.
         * @param engine The engine the effect is tied to
         * @param name The name of the effect
         * @param getPostProcesses A function that returns a set of post processes which the effect will run in order to be run.
         * @param singleInstance False if this post process can be run on multiple cameras. (default: true)
         */
        constructor(engine, name, getPostProcesses, singleInstance) {
            this._name = name;
            this._singleInstance = singleInstance || true;
            this._getPostProcesses = getPostProcesses;
            this._cameras = {};
            this._indicesForCamera = {};
            this._postProcesses = {};
        }
        /**
         * Checks if all the post processes in the effect are supported.
         */
        get isSupported() {
            for (const index in this._postProcesses) {
                if (Object.prototype.hasOwnProperty.call(this._postProcesses, index)) {
                    const pps = this._postProcesses[index];
                    for (let ppIndex = 0; ppIndex < pps.length; ppIndex++) {
                        if (!pps[ppIndex].isSupported) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        /**
         * Updates the current state of the effect
         * @internal
         */
        _update() { }
        /**
         * Attaches the effect on cameras
         * @param cameras The camera to attach to.
         * @internal
         */
        _attachCameras(cameras) {
            let cameraKey;
            const cams = Tools.MakeArray(cameras || this._cameras);
            if (!cams) {
                return;
            }
            for (let i = 0; i < cams.length; i++) {
                const camera = cams[i];
                if (!camera) {
                    continue;
                }
                const cameraName = camera.name;
                if (this._singleInstance) {
                    cameraKey = 0;
                }
                else {
                    cameraKey = cameraName;
                }
                if (!this._postProcesses[cameraKey]) {
                    const postProcess = this._getPostProcesses();
                    if (postProcess) {
                        this._postProcesses[cameraKey] = Array.isArray(postProcess) ? postProcess : [postProcess];
                    }
                }
                if (!this._indicesForCamera[cameraName]) {
                    this._indicesForCamera[cameraName] = [];
                }
                this._postProcesses[cameraKey].forEach((postProcess) => {
                    const index = camera.attachPostProcess(postProcess);
                    this._indicesForCamera[cameraName].push(index);
                });
                if (!this._cameras[cameraName]) {
                    this._cameras[cameraName] = camera;
                }
            }
        }
        /**
         * Detaches the effect on cameras
         * @param cameras The camera to detach from.
         * @internal
         */
        _detachCameras(cameras) {
            const cams = Tools.MakeArray(cameras || this._cameras);
            if (!cams) {
                return;
            }
            for (let i = 0; i < cams.length; i++) {
                const camera = cams[i];
                const cameraName = camera.name;
                const postProcesses = this._postProcesses[this._singleInstance ? 0 : cameraName];
                if (postProcesses) {
                    postProcesses.forEach((postProcess) => {
                        camera.detachPostProcess(postProcess);
                    });
                }
                if (this._cameras[cameraName]) {
                    this._cameras[cameraName] = null;
                }
                delete this._indicesForCamera[cameraName];
            }
        }
        /**
         * Enables the effect on given cameras
         * @param cameras The camera to enable.
         * @internal
         */
        _enable(cameras) {
            const cams = Tools.MakeArray(cameras || this._cameras);
            if (!cams) {
                return;
            }
            for (let i = 0; i < cams.length; i++) {
                const camera = cams[i];
                const cameraName = camera.name;
                const cameraKey = this._singleInstance ? 0 : cameraName;
                for (let j = 0; j < this._indicesForCamera[cameraName].length; j++) {
                    const index = this._indicesForCamera[cameraName][j];
                    const postProcess = camera._postProcesses[index];
                    if (postProcess === undefined || postProcess === null) {
                        cams[i].attachPostProcess(this._postProcesses[cameraKey][j], index);
                    }
                }
            }
        }
        /**
         * Disables the effect on the given cameras
         * @param cameras The camera to disable.
         * @internal
         */
        _disable(cameras) {
            const cams = Tools.MakeArray(cameras || this._cameras);
            if (!cams) {
                return;
            }
            for (let i = 0; i < cams.length; i++) {
                const camera = cams[i];
                const cameraName = camera.name;
                this._postProcesses[this._singleInstance ? 0 : cameraName].forEach((postProcess) => {
                    camera.detachPostProcess(postProcess);
                });
            }
        }
        /**
         * Gets a list of the post processes contained in the effect.
         * @param camera The camera to get the post processes on.
         * @returns The list of the post processes in the effect.
         */
        getPostProcesses(camera) {
            if (this._singleInstance) {
                return this._postProcesses[0];
            }
            else {
                if (!camera) {
                    return null;
                }
                return this._postProcesses[camera.name];
            }
        }
    }

    /**
     * PostProcessRenderPipelineManager class
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
     */
    class PostProcessRenderPipelineManager {
        /**
         * Initializes a PostProcessRenderPipelineManager
         * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
         */
        constructor() {
            this._renderPipelines = {};
        }
        /**
         * Gets the list of supported render pipelines
         */
        get supportedPipelines() {
            const result = [];
            for (const renderPipelineName in this._renderPipelines) {
                if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
                    const pipeline = this._renderPipelines[renderPipelineName];
                    if (pipeline.isSupported) {
                        result.push(pipeline);
                    }
                }
            }
            return result;
        }
        /**
         * Adds a pipeline to the manager
         * @param renderPipeline The pipeline to add
         */
        addPipeline(renderPipeline) {
            this._renderPipelines[renderPipeline._name] = renderPipeline;
        }
        /**
         * Remove the pipeline from the manager
         * @param renderPipelineName the name of the pipeline to remove
         */
        removePipeline(renderPipelineName) {
            delete this._renderPipelines[renderPipelineName];
        }
        /**
         * Attaches a camera to the pipeline
         * @param renderPipelineName The name of the pipeline to attach to
         * @param cameras the camera to attach
         * @param unique if the camera can be attached multiple times to the pipeline
         */
        attachCamerasToRenderPipeline(renderPipelineName, cameras, unique = false) {
            const renderPipeline = this._renderPipelines[renderPipelineName];
            if (!renderPipeline) {
                return;
            }
            renderPipeline._attachCameras(cameras, unique);
        }
        /**
         * Detaches a camera from the pipeline
         * @param renderPipelineName The name of the pipeline to detach from
         * @param cameras the camera to detach
         */
        detachCamerasFromRenderPipeline(renderPipelineName, cameras) {
            const renderPipeline = this._renderPipelines[renderPipelineName];
            if (!renderPipeline) {
                return;
            }
            renderPipeline._detachCameras(cameras);
        }
        /**
         * Enables an effect by name on a pipeline
         * @param renderPipelineName the name of the pipeline to enable the effect in
         * @param renderEffectName the name of the effect to enable
         * @param cameras the cameras that the effect should be enabled on
         */
        enableEffectInPipeline(renderPipelineName, renderEffectName, cameras) {
            const renderPipeline = this._renderPipelines[renderPipelineName];
            if (!renderPipeline) {
                return;
            }
            renderPipeline._enableEffect(renderEffectName, cameras);
        }
        /**
         * Disables an effect by name on a pipeline
         * @param renderPipelineName the name of the pipeline to disable the effect in
         * @param renderEffectName the name of the effect to disable
         * @param cameras the cameras that the effect should be disabled on
         */
        disableEffectInPipeline(renderPipelineName, renderEffectName, cameras) {
            const renderPipeline = this._renderPipelines[renderPipelineName];
            if (!renderPipeline) {
                return;
            }
            renderPipeline._disableEffect(renderEffectName, cameras);
        }
        /**
         * Updates the state of all contained render pipelines and disposes of any non supported pipelines
         */
        update() {
            for (const renderPipelineName in this._renderPipelines) {
                if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
                    const pipeline = this._renderPipelines[renderPipelineName];
                    if (!pipeline.isSupported) {
                        pipeline.dispose();
                        delete this._renderPipelines[renderPipelineName];
                    }
                    else {
                        pipeline._update();
                    }
                }
            }
        }
        /** @internal */
        _rebuild() {
            for (const renderPipelineName in this._renderPipelines) {
                if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
                    const pipeline = this._renderPipelines[renderPipelineName];
                    pipeline._rebuild();
                }
            }
        }
        /**
         * Disposes of the manager and pipelines
         */
        dispose() {
            for (const renderPipelineName in this._renderPipelines) {
                if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
                    const pipeline = this._renderPipelines[renderPipelineName];
                    pipeline.dispose();
                }
            }
        }
    }

    Object.defineProperty(Scene.prototype, "postProcessRenderPipelineManager", {
        get: function () {
            if (!this._postProcessRenderPipelineManager) {
                // Register the G Buffer component to the scene.
                let component = this._getComponent(SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER);
                if (!component) {
                    component = new PostProcessRenderPipelineManagerSceneComponent(this);
                    this._addComponent(component);
                }
                this._postProcessRenderPipelineManager = new PostProcessRenderPipelineManager();
            }
            return this._postProcessRenderPipelineManager;
        },
        enumerable: true,
        configurable: true,
    });
    /**
     * Defines the Render Pipeline scene component responsible to rendering pipelines
     */
    class PostProcessRenderPipelineManagerSceneComponent {
        /**
         * Creates a new instance of the component for the given scene
         * @param scene Defines the scene to register the component in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER;
            this.scene = scene;
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER, this, this._gatherRenderTargets);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            if (this.scene._postProcessRenderPipelineManager) {
                this.scene._postProcessRenderPipelineManager._rebuild();
            }
        }
        /**
         * Disposes the component and the associated resources
         */
        dispose() {
            if (this.scene._postProcessRenderPipelineManager) {
                this.scene._postProcessRenderPipelineManager.dispose();
            }
        }
        _gatherRenderTargets() {
            if (this.scene._postProcessRenderPipelineManager) {
                this.scene._postProcessRenderPipelineManager.update();
            }
        }
    }

    // Do not edit.
    const name$2w = "chromaticAberrationPixelShader";
    const shader$2w = `uniform sampler2D textureSampler; 
uniform float chromatic_aberration;uniform float radialIntensity;uniform vec2 direction;uniform vec2 centerPosition;uniform float screen_width;uniform float screen_height;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec2 centered_screen_pos=vec2(vUV.x-centerPosition.x,vUV.y-centerPosition.y);vec2 directionOfEffect=direction;if(directionOfEffect.x==0. && directionOfEffect.y==0.){directionOfEffect=normalize(centered_screen_pos);}
float radius2=centered_screen_pos.x*centered_screen_pos.x
+ centered_screen_pos.y*centered_screen_pos.y;float radius=sqrt(radius2);vec4 original=texture2D(textureSampler,vUV);vec3 ref_indices=vec3(-0.3,0.0,0.3);float ref_shiftX=chromatic_aberration*pow(radius,radialIntensity)*directionOfEffect.x/screen_width;float ref_shiftY=chromatic_aberration*pow(radius,radialIntensity)*directionOfEffect.y/screen_height;vec2 ref_coords_r=vec2(vUV.x+ref_indices.r*ref_shiftX,vUV.y+ref_indices.r*ref_shiftY*0.5);vec2 ref_coords_g=vec2(vUV.x+ref_indices.g*ref_shiftX,vUV.y+ref_indices.g*ref_shiftY*0.5);vec2 ref_coords_b=vec2(vUV.x+ref_indices.b*ref_shiftX,vUV.y+ref_indices.b*ref_shiftY*0.5);original.r=texture2D(textureSampler,ref_coords_r).r;original.g=texture2D(textureSampler,ref_coords_g).g;original.b=texture2D(textureSampler,ref_coords_b).b;original.a=clamp(texture2D(textureSampler,ref_coords_r).a+texture2D(textureSampler,ref_coords_g).a+texture2D(textureSampler,ref_coords_b).a,0.,1.);gl_FragColor=original;}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2w] = shader$2w;

    // Do not edit.
    const name$2x = "lensHighlightsPixelShader";
    const shader$2x = `uniform sampler2D textureSampler; 
uniform float gain;uniform float threshold;uniform float screen_width;uniform float screen_height;varying vec2 vUV;vec4 highlightColor(vec4 color) {vec4 highlight=color;float luminance=dot(highlight.rgb,vec3(0.2125,0.7154,0.0721));float lum_threshold;if (threshold>1.0) { lum_threshold=0.94+0.01*threshold; }
else { lum_threshold=0.5+0.44*threshold; }
luminance=clamp((luminance-lum_threshold)*(1.0/(1.0-lum_threshold)),0.0,1.0);highlight*=luminance*gain;highlight.a=1.0;return highlight;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 original=texture2D(textureSampler,vUV);if (gain==-1.0) {gl_FragColor=vec4(0.0,0.0,0.0,1.0);return;}
float w=2.0/screen_width;float h=2.0/screen_height;float weight=1.0;vec4 blurred=vec4(0.0,0.0,0.0,0.0);
#ifdef PENTAGON
blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.84*w,0.43*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.48*w,-1.29*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.61*w,1.51*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.55*w,-0.74*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.71*w,-0.52*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.94*w,1.59*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.40*w,-1.87*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.62*w,1.16*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.09*w,0.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.46*w,-1.71*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.08*w,2.42*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.85*w,-1.89*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.89*w,0.16*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.29*w,1.88*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.40*w,-2.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.54*w,2.26*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.60*w,-0.61*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.31*w,-1.30*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.83*w,2.53*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.12*w,-2.48*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.60*w,1.11*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.82*w,0.99*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.50*w,-2.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.85*w,3.33*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.94*w,-1.92*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.27*w,-0.53*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.95*w,2.48*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.23*w,-3.04*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.17*w,2.05*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.97*w,-0.04*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.25*w,-2.00*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.31*w,3.08*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.94*w,-2.59*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.37*w,0.64*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-3.13*w,1.93*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.03*w,-3.65*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.60*w,3.17*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-3.14*w,-1.19*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.00*w,-1.19*h)));
#else
blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.85*w,0.36*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.52*w,-1.14*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.46*w,1.42*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.46*w,-0.83*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.79*w,-0.42*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.11*w,1.62*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.29*w,-2.07*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.69*w,1.39*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.28*w,0.12*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.65*w,-1.69*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.08*w,2.44*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.63*w,-1.90*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.55*w,0.31*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.13*w,1.52*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.56*w,-2.61*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.38*w,2.34*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.64*w,-0.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.53*w,-1.21*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.06*w,2.63*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.00*w,-2.69*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.59*w,1.32*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.82*w,0.78*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.57*w,-2.50*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.54*w,2.93*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.39*w,-1.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.01*w,-0.28*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.04*w,2.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.02*w,-3.05*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.09*w,2.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-3.07*w,-0.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.44*w,-1.90*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.52*w,3.05*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.68*w,-2.61*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.01*w,0.79*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.76*w,1.46*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.05*w,-2.94*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.21*w,2.88*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.84*w,-1.30*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.98*w,-0.96*h)));
#endif
blurred/=39.0;gl_FragColor=blurred;}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2x] = shader$2x;

    // Do not edit.
    const name$2y = "depthOfFieldPixelShader";
    const shader$2y = `uniform sampler2D textureSampler;uniform sampler2D highlightsSampler;uniform sampler2D depthSampler;uniform sampler2D grainSampler;uniform float grain_amount;uniform bool blur_noise;uniform float screen_width;uniform float screen_height;uniform float distortion;uniform bool dof_enabled;uniform float screen_distance; 
uniform float aperture;uniform float darken;uniform float edge_blur;uniform bool highlights;uniform float near;uniform float far;varying vec2 vUV;
#define PI 3.14159265
#define TWOPI 6.28318530
#define inverse_focal_length 0.1 
vec2 centered_screen_pos;vec2 distorted_coords;float radius2;float radius;vec2 rand(vec2 co)
{float noise1=(fract(sin(dot(co,vec2(12.9898,78.233)))*43758.5453));float noise2=(fract(sin(dot(co,vec2(12.9898,78.233)*2.0))*43758.5453));return clamp(vec2(noise1,noise2),0.0,1.0);}
vec2 getDistortedCoords(vec2 coords) {if (distortion==0.0) { return coords; }
vec2 direction=1.0*normalize(centered_screen_pos);vec2 dist_coords=vec2(0.5,0.5);dist_coords.x=0.5+direction.x*radius2*1.0;dist_coords.y=0.5+direction.y*radius2*1.0;float dist_amount=clamp(distortion*0.23,0.0,1.0);dist_coords=mix(coords,dist_coords,dist_amount);return dist_coords;}
float sampleScreen(inout vec4 color,in vec2 offset,in float weight) {vec2 coords=distorted_coords;float angle=rand(coords*100.0).x*TWOPI;coords+=vec2(offset.x*cos(angle)-offset.y*sin(angle),offset.x*sin(angle)+offset.y*cos(angle));color+=texture2D(textureSampler,coords)*weight;return weight;}
float getBlurLevel(float size) {return min(3.0,ceil(size/1.0));}
vec4 getBlurColor(float size) {vec4 col=texture2D(textureSampler,distorted_coords);float blur_level=getBlurLevel(size);float w=(size/screen_width);float h=(size/screen_height);float total_weight=1.0;vec2 sample_coords;total_weight+=sampleScreen(col,vec2(-0.50*w,0.24*h),0.93);total_weight+=sampleScreen(col,vec2(0.30*w,-0.75*h),0.90);total_weight+=sampleScreen(col,vec2(0.36*w,0.96*h),0.87);total_weight+=sampleScreen(col,vec2(-1.08*w,-0.55*h),0.85);total_weight+=sampleScreen(col,vec2(1.33*w,-0.37*h),0.83);total_weight+=sampleScreen(col,vec2(-0.82*w,1.31*h),0.80);total_weight+=sampleScreen(col,vec2(-0.31*w,-1.67*h),0.78);total_weight+=sampleScreen(col,vec2(1.47*w,1.11*h),0.76);total_weight+=sampleScreen(col,vec2(-1.97*w,0.19*h),0.74);total_weight+=sampleScreen(col,vec2(1.42*w,-1.57*h),0.72);if (blur_level>1.0) {total_weight+=sampleScreen(col,vec2(0.01*w,2.25*h),0.70);total_weight+=sampleScreen(col,vec2(-1.62*w,-1.74*h),0.67);total_weight+=sampleScreen(col,vec2(2.49*w,0.20*h),0.65);total_weight+=sampleScreen(col,vec2(-2.07*w,1.61*h),0.63);total_weight+=sampleScreen(col,vec2(0.46*w,-2.70*h),0.61);total_weight+=sampleScreen(col,vec2(1.55*w,2.40*h),0.59);total_weight+=sampleScreen(col,vec2(-2.88*w,-0.75*h),0.56);total_weight+=sampleScreen(col,vec2(2.73*w,-1.44*h),0.54);total_weight+=sampleScreen(col,vec2(-1.08*w,3.02*h),0.52);total_weight+=sampleScreen(col,vec2(-1.28*w,-3.05*h),0.49);}
if (blur_level>2.0) {total_weight+=sampleScreen(col,vec2(3.11*w,1.43*h),0.46);total_weight+=sampleScreen(col,vec2(-3.36*w,1.08*h),0.44);total_weight+=sampleScreen(col,vec2(1.80*w,-3.16*h),0.41);total_weight+=sampleScreen(col,vec2(0.83*w,3.65*h),0.38);total_weight+=sampleScreen(col,vec2(-3.16*w,-2.19*h),0.34);total_weight+=sampleScreen(col,vec2(3.92*w,-0.53*h),0.31);total_weight+=sampleScreen(col,vec2(-2.59*w,3.12*h),0.26);total_weight+=sampleScreen(col,vec2(-0.20*w,-4.15*h),0.22);total_weight+=sampleScreen(col,vec2(3.02*w,3.00*h),0.15);}
col/=total_weight; 
if (darken>0.0) {col.rgb*=clamp(0.3,1.0,1.05-size*0.5*darken);}
return col;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{centered_screen_pos=vec2(vUV.x-0.5,vUV.y-0.5);radius2=centered_screen_pos.x*centered_screen_pos.x+centered_screen_pos.y*centered_screen_pos.y;radius=sqrt(radius2);distorted_coords=getDistortedCoords(vUV); 
vec2 texels_coords=vec2(vUV.x*screen_width,vUV.y*screen_height); 
float depth=texture2D(depthSampler,distorted_coords).r; 
float distance=near+(far-near)*depth; 
vec4 color=texture2D(textureSampler,vUV); 
float coc=abs(aperture*(screen_distance*(inverse_focal_length-1.0/distance)-1.0));if (dof_enabled==false || coc<0.07) { coc=0.0; }
float edge_blur_amount=0.0;if (edge_blur>0.0) {edge_blur_amount=clamp((radius*2.0-1.0+0.15*edge_blur)*1.5,0.0,1.0)*1.3;}
float blur_amount=max(edge_blur_amount,coc);if (blur_amount==0.0) {gl_FragColor=texture2D(textureSampler,distorted_coords);}
else {gl_FragColor=getBlurColor(blur_amount*1.7);if (highlights) {gl_FragColor.rgb+=clamp(coc,0.0,1.0)*texture2D(highlightsSampler,distorted_coords).rgb;}
if (blur_noise) {vec2 noise=rand(distorted_coords)*0.01*blur_amount;vec2 blurred_coord=vec2(distorted_coords.x+noise.x,distorted_coords.y+noise.y);gl_FragColor=0.04*texture2D(textureSampler,blurred_coord)+0.96*gl_FragColor;}}
if (grain_amount>0.0) {vec4 grain_color=texture2D(grainSampler,texels_coords*0.003);gl_FragColor.rgb+=(-0.5+grain_color.rgb)*0.30*grain_amount;}}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2y] = shader$2y;

    /**
     * BABYLON.JS Chromatic Aberration GLSL Shader
     * Author: Olivier Guyot
     * Separates very slightly R, G and B colors on the edges of the screen
     * Inspired by Francois Tarlier & Martins Upitis
     */
    class LensRenderingPipeline extends PostProcessRenderPipeline {
        /**
         * @constructor
         *
         * Effect parameters are as follow:
         * {
         *      chromatic_aberration: number;       // from 0 to x (1 for realism)
         *      edge_blur: number;                  // from 0 to x (1 for realism)
         *      distortion: number;                 // from 0 to x (1 for realism), note that this will effect the pointer position precision
         *      grain_amount: number;               // from 0 to 1
         *      grain_texture: BABYLON.Texture;     // texture to use for grain effect; if unset, use random B&W noise
         *      dof_focus_distance: number;         // depth-of-field: focus distance; unset to disable (disabled by default)
         *      dof_aperture: number;               // depth-of-field: focus blur bias (default: 1)
         *      dof_darken: number;                 // depth-of-field: darken that which is out of focus (from 0 to 1, disabled by default)
         *      dof_pentagon: boolean;              // depth-of-field: makes a pentagon-like "bokeh" effect
         *      dof_gain: number;                   // depth-of-field: highlights gain; unset to disable (disabled by default)
         *      dof_threshold: number;              // depth-of-field: highlights threshold (default: 1)
         *      blur_noise: boolean;                // add a little bit of noise to the blur (default: true)
         * }
         * Note: if an effect parameter is unset, effect is disabled
         *
         * @param name The rendering pipeline name
         * @param parameters - An object containing all parameters (see above)
         * @param scene The scene linked to this pipeline
         * @param ratio The size of the postprocesses (0.5 means that your postprocess will have a width = canvas.width 0.5 and a height = canvas.height 0.5)
         * @param cameras The array of cameras that the rendering pipeline will be attached to
         */
        constructor(name, parameters, scene, ratio = 1.0, cameras) {
            super(scene.getEngine(), name);
            // Lens effects can be of the following:
            // - chromatic aberration (slight shift of RGB colors)
            // - blur on the edge of the lens
            // - lens distortion
            // - depth-of-field blur & highlights enhancing
            // - depth-of-field 'bokeh' effect (shapes appearing in blurred areas)
            // - grain effect (noise or custom texture)
            // Two additional texture samplers are needed:
            // - depth map (for depth-of-field)
            // - grain texture
            /**
             * @ignore
             * The chromatic aberration PostProcess id in the pipeline
             */
            this.LensChromaticAberrationEffect = "LensChromaticAberrationEffect";
            /**
             * @ignore
             * The highlights enhancing PostProcess id in the pipeline
             */
            this.HighlightsEnhancingEffect = "HighlightsEnhancingEffect";
            /**
             * @ignore
             * The depth-of-field PostProcess id in the pipeline
             */
            this.LensDepthOfFieldEffect = "LensDepthOfFieldEffect";
            this._pentagonBokehIsEnabled = false;
            this._scene = scene;
            // Fetch texture samplers
            this._depthTexture = scene.enableDepthRenderer().getDepthMap(); // Force depth renderer "on"
            if (parameters.grain_texture) {
                this._grainTexture = parameters.grain_texture;
            }
            else {
                this._createGrainTexture();
            }
            // save parameters
            this._edgeBlur = parameters.edge_blur ? parameters.edge_blur : 0;
            this._grainAmount = parameters.grain_amount ? parameters.grain_amount : 0;
            this._chromaticAberration = parameters.chromatic_aberration ? parameters.chromatic_aberration : 0;
            this._distortion = parameters.distortion ? parameters.distortion : 0;
            this._highlightsGain = parameters.dof_gain !== undefined ? parameters.dof_gain : -1;
            this._highlightsThreshold = parameters.dof_threshold ? parameters.dof_threshold : 1;
            this._dofDistance = parameters.dof_focus_distance !== undefined ? parameters.dof_focus_distance : -1;
            this._dofAperture = parameters.dof_aperture ? parameters.dof_aperture : 1;
            this._dofDarken = parameters.dof_darken ? parameters.dof_darken : 0;
            this._dofPentagon = parameters.dof_pentagon !== undefined ? parameters.dof_pentagon : true;
            this._blurNoise = parameters.blur_noise !== undefined ? parameters.blur_noise : true;
            // Create effects
            this._createChromaticAberrationPostProcess(ratio);
            this._createHighlightsPostProcess(ratio);
            this._createDepthOfFieldPostProcess(ratio / 4);
            // Set up pipeline
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.LensChromaticAberrationEffect, () => {
                return this._chromaticAberrationPostProcess;
            }, true));
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.HighlightsEnhancingEffect, () => {
                return this._highlightsPostProcess;
            }, true));
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.LensDepthOfFieldEffect, () => {
                return this._depthOfFieldPostProcess;
            }, true));
            if (this._highlightsGain === -1) {
                this._disableEffect(this.HighlightsEnhancingEffect, null);
            }
            // Finish
            scene.postProcessRenderPipelineManager.addPipeline(this);
            if (cameras) {
                scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(name, cameras);
            }
        }
        /**
         * Get the class name
         * @returns "LensRenderingPipeline"
         */
        getClassName() {
            return "LensRenderingPipeline";
        }
        // Properties
        /**
         * Gets associated scene
         */
        get scene() {
            return this._scene;
        }
        /**
         * Gets or sets the edge blur
         */
        get edgeBlur() {
            return this._edgeBlur;
        }
        set edgeBlur(value) {
            this.setEdgeBlur(value);
        }
        /**
         * Gets or sets the grain amount
         */
        get grainAmount() {
            return this._grainAmount;
        }
        set grainAmount(value) {
            this.setGrainAmount(value);
        }
        /**
         * Gets or sets the chromatic aberration amount
         */
        get chromaticAberration() {
            return this._chromaticAberration;
        }
        set chromaticAberration(value) {
            this.setChromaticAberration(value);
        }
        /**
         * Gets or sets the depth of field aperture
         */
        get dofAperture() {
            return this._dofAperture;
        }
        set dofAperture(value) {
            this.setAperture(value);
        }
        /**
         * Gets or sets the edge distortion
         */
        get edgeDistortion() {
            return this._distortion;
        }
        set edgeDistortion(value) {
            this.setEdgeDistortion(value);
        }
        /**
         * Gets or sets the depth of field distortion
         */
        get dofDistortion() {
            return this._dofDistance;
        }
        set dofDistortion(value) {
            this.setFocusDistance(value);
        }
        /**
         * Gets or sets the darken out of focus amount
         */
        get darkenOutOfFocus() {
            return this._dofDarken;
        }
        set darkenOutOfFocus(value) {
            this.setDarkenOutOfFocus(value);
        }
        /**
         * Gets or sets a boolean indicating if blur noise is enabled
         */
        get blurNoise() {
            return this._blurNoise;
        }
        set blurNoise(value) {
            this._blurNoise = value;
        }
        /**
         * Gets or sets a boolean indicating if pentagon bokeh is enabled
         */
        get pentagonBokeh() {
            return this._pentagonBokehIsEnabled;
        }
        set pentagonBokeh(value) {
            if (value) {
                this.enablePentagonBokeh();
            }
            else {
                this.disablePentagonBokeh();
            }
        }
        /**
         * Gets or sets the highlight grain amount
         */
        get highlightsGain() {
            return this._highlightsGain;
        }
        set highlightsGain(value) {
            this.setHighlightsGain(value);
        }
        /**
         * Gets or sets the highlight threshold
         */
        get highlightsThreshold() {
            return this._highlightsThreshold;
        }
        set highlightsThreshold(value) {
            this.setHighlightsThreshold(value);
        }
        // public methods (self explanatory)
        /**
         * Sets the amount of blur at the edges
         * @param amount blur amount
         */
        setEdgeBlur(amount) {
            this._edgeBlur = amount;
        }
        /**
         * Sets edge blur to 0
         */
        disableEdgeBlur() {
            this._edgeBlur = 0;
        }
        /**
         * Sets the amount of grain
         * @param amount Amount of grain
         */
        setGrainAmount(amount) {
            this._grainAmount = amount;
        }
        /**
         * Set grain amount to 0
         */
        disableGrain() {
            this._grainAmount = 0;
        }
        /**
         * Sets the chromatic aberration amount
         * @param amount amount of chromatic aberration
         */
        setChromaticAberration(amount) {
            this._chromaticAberration = amount;
        }
        /**
         * Sets chromatic aberration amount to 0
         */
        disableChromaticAberration() {
            this._chromaticAberration = 0;
        }
        /**
         * Sets the EdgeDistortion amount
         * @param amount amount of EdgeDistortion
         */
        setEdgeDistortion(amount) {
            this._distortion = amount;
        }
        /**
         * Sets edge distortion to 0
         */
        disableEdgeDistortion() {
            this._distortion = 0;
        }
        /**
         * Sets the FocusDistance amount
         * @param amount amount of FocusDistance
         */
        setFocusDistance(amount) {
            this._dofDistance = amount;
        }
        /**
         * Disables depth of field
         */
        disableDepthOfField() {
            this._dofDistance = -1;
        }
        /**
         * Sets the Aperture amount
         * @param amount amount of Aperture
         */
        setAperture(amount) {
            this._dofAperture = amount;
        }
        /**
         * Sets the DarkenOutOfFocus amount
         * @param amount amount of DarkenOutOfFocus
         */
        setDarkenOutOfFocus(amount) {
            this._dofDarken = amount;
        }
        /**
         * Creates a pentagon bokeh effect
         */
        enablePentagonBokeh() {
            this._highlightsPostProcess.updateEffect("#define PENTAGON\n");
            this._pentagonBokehIsEnabled = true;
        }
        /**
         * Disables the pentagon bokeh effect
         */
        disablePentagonBokeh() {
            this._pentagonBokehIsEnabled = false;
            this._highlightsPostProcess.updateEffect();
        }
        /**
         * Enables noise blur
         */
        enableNoiseBlur() {
            this._blurNoise = true;
        }
        /**
         * Disables noise blur
         */
        disableNoiseBlur() {
            this._blurNoise = false;
        }
        /**
         * Sets the HighlightsGain amount
         * @param amount amount of HighlightsGain
         */
        setHighlightsGain(amount) {
            this._highlightsGain = amount;
        }
        /**
         * Sets the HighlightsThreshold amount
         * @param amount amount of HighlightsThreshold
         */
        setHighlightsThreshold(amount) {
            if (this._highlightsGain === -1) {
                this._highlightsGain = 1.0;
            }
            this._highlightsThreshold = amount;
        }
        /**
         * Disables highlights
         */
        disableHighlights() {
            this._highlightsGain = -1;
        }
        /**
         * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
         * @param disableDepthRender If the scene's depth rendering should be disabled (default: false)
         */
        dispose(disableDepthRender = false) {
            this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._scene.cameras);
            this._chromaticAberrationPostProcess = null;
            this._highlightsPostProcess = null;
            this._depthOfFieldPostProcess = null;
            this._grainTexture.dispose();
            if (disableDepthRender) {
                this._scene.disableDepthRenderer();
            }
        }
        // colors shifting and distortion
        _createChromaticAberrationPostProcess(ratio) {
            this._chromaticAberrationPostProcess = new PostProcess("LensChromaticAberration", "chromaticAberration", ["chromatic_aberration", "screen_width", "screen_height", "direction", "radialIntensity", "centerPosition"], // uniforms
            [], // samplers
            ratio, null, Texture.TRILINEAR_SAMPLINGMODE, this._scene.getEngine(), false);
            this._chromaticAberrationPostProcess.onApply = (effect) => {
                effect.setFloat("chromatic_aberration", this._chromaticAberration);
                effect.setFloat("screen_width", this._scene.getEngine().getRenderWidth());
                effect.setFloat("screen_height", this._scene.getEngine().getRenderHeight());
                effect.setFloat("radialIntensity", 1);
                effect.setFloat2("direction", 17, 17);
                effect.setFloat2("centerPosition", 0.5, 0.5);
            };
        }
        // highlights enhancing
        _createHighlightsPostProcess(ratio) {
            this._highlightsPostProcess = new PostProcess("LensHighlights", "lensHighlights", ["gain", "threshold", "screen_width", "screen_height"], // uniforms
            [], // samplers
            ratio, null, Texture.TRILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, this._dofPentagon ? "#define PENTAGON\n" : "");
            this._highlightsPostProcess.externalTextureSamplerBinding = true;
            this._highlightsPostProcess.onApply = (effect) => {
                effect.setFloat("gain", this._highlightsGain);
                effect.setFloat("threshold", this._highlightsThreshold);
                effect.setTextureFromPostProcess("textureSampler", this._chromaticAberrationPostProcess);
                effect.setFloat("screen_width", this._scene.getEngine().getRenderWidth());
                effect.setFloat("screen_height", this._scene.getEngine().getRenderHeight());
            };
        }
        // colors shifting and distortion
        _createDepthOfFieldPostProcess(ratio) {
            this._depthOfFieldPostProcess = new PostProcess("LensDepthOfField", "depthOfField", [
                "grain_amount",
                "blur_noise",
                "screen_width",
                "screen_height",
                "distortion",
                "dof_enabled",
                "screen_distance",
                "aperture",
                "darken",
                "edge_blur",
                "highlights",
                "near",
                "far",
            ], ["depthSampler", "grainSampler", "highlightsSampler"], ratio, null, Texture.TRILINEAR_SAMPLINGMODE, this._scene.getEngine(), false);
            this._depthOfFieldPostProcess.externalTextureSamplerBinding = true;
            this._depthOfFieldPostProcess.onApply = (effect) => {
                effect.setTexture("depthSampler", this._depthTexture);
                effect.setTexture("grainSampler", this._grainTexture);
                effect.setTextureFromPostProcess("textureSampler", this._highlightsPostProcess);
                effect.setTextureFromPostProcess("highlightsSampler", this._depthOfFieldPostProcess);
                effect.setFloat("grain_amount", this._grainAmount);
                effect.setBool("blur_noise", this._blurNoise);
                effect.setFloat("screen_width", this._scene.getEngine().getRenderWidth());
                effect.setFloat("screen_height", this._scene.getEngine().getRenderHeight());
                effect.setFloat("distortion", this._distortion);
                effect.setBool("dof_enabled", this._dofDistance !== -1);
                effect.setFloat("screen_distance", 1.0 / (0.1 - 1.0 / this._dofDistance));
                effect.setFloat("aperture", this._dofAperture);
                effect.setFloat("darken", this._dofDarken);
                effect.setFloat("edge_blur", this._edgeBlur);
                effect.setBool("highlights", this._highlightsGain !== -1);
                if (this._scene.activeCamera) {
                    effect.setFloat("near", this._scene.activeCamera.minZ);
                    effect.setFloat("far", this._scene.activeCamera.maxZ);
                }
            };
        }
        // creates a black and white random noise texture, 512x512
        _createGrainTexture() {
            const size = 512;
            this._grainTexture = new DynamicTexture("LensNoiseTexture", size, this._scene, false, Texture.BILINEAR_SAMPLINGMODE);
            this._grainTexture.wrapU = Texture.WRAP_ADDRESSMODE;
            this._grainTexture.wrapV = Texture.WRAP_ADDRESSMODE;
            const context = this._grainTexture.getContext();
            const rand = (min, max) => {
                return Math.random() * (max - min) + min;
            };
            let value;
            for (let x = 0; x < size; x++) {
                for (let y = 0; y < size; y++) {
                    value = Math.floor(rand(0.42, 0.58) * 255);
                    context.fillStyle = "rgb(" + value + ", " + value + ", " + value + ")";
                    context.fillRect(x, y, 1, 1);
                }
            }
            this._grainTexture.update(false);
        }
    }

    /**
     * Contains all parameters needed for the prepass to perform
     * screen space subsurface scattering
     */
    class SSAO2Configuration {
        constructor() {
            /**
             * Is subsurface enabled
             */
            this.enabled = false;
            /**
             * Name of the configuration
             */
            this.name = "ssao2";
            /**
             * Textures that should be present in the MRT for this effect to work
             */
            this.texturesRequired = [6, 5];
        }
    }

    // Do not edit.
    const name$2z = "ssao2PixelShader";
    const shader$2z = `precision highp float;uniform sampler2D textureSampler;varying vec2 vUV;
#ifdef SSAO
float scales[16]=float[16](
0.1,
0.11406250000000001,
0.131640625,
0.15625,
0.187890625,
0.2265625,
0.272265625,
0.325,
0.384765625,
0.4515625,
0.525390625,
0.60625,
0.694140625,
0.7890625,
0.891015625,
1.0
);uniform float near;uniform float radius;uniform sampler2D depthSampler;uniform sampler2D randomSampler;uniform sampler2D normalSampler;uniform float randTextureTiles;uniform float samplesFactor;uniform vec3 sampleSphere[SAMPLES];uniform float totalStrength;uniform float base;uniform float xViewport;uniform float yViewport;uniform mat3 depthProjection;uniform float maxZ;uniform float minZAspect;uniform vec2 texelSize;uniform mat4 projection;void main()
{vec3 random=textureLod(randomSampler,vUV*randTextureTiles,0.0).rgb;float depth=textureLod(depthSampler,vUV,0.0).r;float depthSign=depth/abs(depth);depth=depth*depthSign;vec3 normal=textureLod(normalSampler,vUV,0.0).rgb;float occlusion=0.0;float correctedRadius=min(radius,minZAspect*depth/near);vec3 vViewRay=vec3((vUV.x*2.0-1.0)*xViewport,(vUV.y*2.0-1.0)*yViewport,depthSign);vec3 vDepthFactor=depthProjection*vec3(1.0,1.0,depth);vec3 origin=vViewRay*vDepthFactor;vec3 rvec=random*2.0-1.0;rvec.z=0.0;float dotProduct=dot(rvec,normal);rvec=1.0-abs(dotProduct)>1e-2 ? rvec : vec3(-rvec.y,0.0,rvec.x);vec3 tangent=normalize(rvec-normal*dot(rvec,normal));vec3 bitangent=cross(normal,tangent);mat3 tbn=mat3(tangent,bitangent,normal);float difference;for (int i=0; i<SAMPLES; ++i) {vec3 samplePosition=scales[(i+int(random.x*16.0)) % 16]*tbn*sampleSphere[(i+int(random.y*16.0)) % 16];samplePosition=samplePosition*correctedRadius+origin;vec4 offset=vec4(samplePosition,1.0);offset=projection*offset;offset.xyz/=offset.w;offset.xy=offset.xy*0.5+0.5;if (offset.x<0.0 || offset.y<0.0 || offset.x>1.0 || offset.y>1.0) {continue;}
float sampleDepth=abs(textureLod(depthSampler,offset.xy,0.0).r);difference=depthSign*samplePosition.z-sampleDepth;float rangeCheck=1.0-smoothstep(correctedRadius*0.5,correctedRadius,difference);occlusion+=step(EPSILON,difference)*rangeCheck;}
occlusion=occlusion*(1.0-smoothstep(maxZ*0.75,maxZ,depth));float ao=1.0-totalStrength*occlusion*samplesFactor;float result=clamp(ao+base,0.0,1.0);gl_FragColor=vec4(vec3(result),1.0);}
#endif
#ifdef BLUR
uniform float outSize;uniform float soften;uniform float tolerance;uniform int samples;
#ifndef BLUR_BYPASS
uniform sampler2D depthSampler;
#ifdef BLUR_LEGACY
#define inline
float blur13Bilateral(sampler2D image,vec2 uv,vec2 step) {float result=0.0;vec2 off1=vec2(1.411764705882353)*step;vec2 off2=vec2(3.2941176470588234)*step;vec2 off3=vec2(5.176470588235294)*step;float compareDepth=abs(textureLod(depthSampler,uv,0.0).r);float sampleDepth;float weight;float weightSum=30.0;result+=textureLod(image,uv,0.0).r*30.0;sampleDepth=abs(textureLod(depthSampler,uv+off1,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+= weight;result+=textureLod(image,uv+off1,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv-off1,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+= weight;result+=textureLod(image,uv-off1,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv+off2,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv+off2,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv-off2,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv-off2,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv+off3,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv+off3,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv-off3,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv-off3,0.0).r*weight;return result/weightSum;}
#endif
#endif
void main()
{float result=0.0;
#ifdef BLUR_BYPASS
result=textureLod(textureSampler,vUV,0.0).r;
#else
#ifdef BLUR_H
vec2 step=vec2(1.0/outSize,0.0);
#else
vec2 step=vec2(0.0,1.0/outSize);
#endif
#ifdef BLUR_LEGACY
result=blur13Bilateral(textureSampler,vUV,step);
#else
float compareDepth=abs(textureLod(depthSampler,vUV,0.0).r);float weightSum=0.0;for (int i=-samples; i<samples; i+=2)
{vec2 samplePos=vUV+step*(float(i)+0.5);float sampleDepth=abs(textureLod(depthSampler,samplePos,0.0).r);float falloff=smoothstep(0.0,
float(samples),
float(samples)-abs(float(i))*soften);float minDivider=tolerance*0.5+0.003;float weight=falloff/( minDivider+abs(compareDepth-sampleDepth));result+=textureLod(textureSampler,samplePos,0.0).r*weight;weightSum+=weight;}
result/=weightSum;
#endif
#endif
gl_FragColor.rgb=vec3(result);gl_FragColor.a=1.0;}
#endif
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2z] = shader$2z;

    // Do not edit.
    const name$2A = "ssaoCombinePixelShader";
    const shader$2A = `uniform sampler2D textureSampler;uniform sampler2D originalColor;uniform vec4 viewport;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
vec4 ssaoColor=texture2D(textureSampler,viewport.xy+vUV*viewport.zw);vec4 sceneColor=texture2D(originalColor,vUV);gl_FragColor=sceneColor*ssaoColor;
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2A] = shader$2A;

    /**
     * Render pipeline to produce ssao effect
     */
    class SSAO2RenderingPipeline extends PostProcessRenderPipeline {
        /**
         * Used in SSAO calculations to compensate for accuracy issues with depth values. Default 0.02.
         *
         * Normally you do not need to change this value, but you can experiment with it if you get a lot of in false self-occlusion on flat surfaces when using fewer than 16 samples. Useful range is normally [0..0.1] but higher values is allowed.
         */
        set epsilon(n) {
            this._epsilon = n;
            this._ssaoPostProcess.updateEffect(this._getDefinesForSSAO());
        }
        get epsilon() {
            return this._epsilon;
        }
        /**
         * Number of samples used for the SSAO calculations. Default value is 8.
         */
        set samples(n) {
            this._samples = n;
            this._ssaoPostProcess.updateEffect(this._getDefinesForSSAO());
            this._sampleSphere = this._generateHemisphere();
        }
        get samples() {
            return this._samples;
        }
        /**
         * Number of samples to use for antialiasing.
         */
        set textureSamples(n) {
            this._textureSamples = n;
            if (this._prePassRenderer) {
                this._prePassRenderer.samples = n;
            }
            else {
                this._originalColorPostProcess.samples = n;
            }
        }
        get textureSamples() {
            return this._textureSamples;
        }
        get _geometryBufferRenderer() {
            if (!this._forceGeometryBuffer) {
                return null;
            }
            return this._scene.geometryBufferRenderer;
        }
        get _prePassRenderer() {
            if (this._forceGeometryBuffer) {
                return null;
            }
            return this._scene.prePassRenderer;
        }
        /**
         * Skips the denoising (blur) stage of the SSAO calculations.
         *
         * Useful to temporarily set while experimenting with the other SSAO2 settings.
         */
        set bypassBlur(b) {
            const defines = this._getDefinesForBlur(this.expensiveBlur, b);
            const samplers = this._getSamplersForBlur(b);
            this._blurHPostProcess.updateEffect(defines.h, null, samplers);
            this._blurVPostProcess.updateEffect(defines.v, null, samplers);
            this._bypassBlur = b;
        }
        get bypassBlur() {
            return this._bypassBlur;
        }
        /**
         * Enables the configurable bilateral denoising (blurring) filter. Default is true.
         * Set to false to instead use a legacy bilateral filter that can't be configured.
         *
         * The denoising filter runs after the SSAO calculations and is a very important step. Both options results in a so called bilateral being used, but the "expensive" one can be
         * configured in several ways to fit your scene.
         */
        set expensiveBlur(b) {
            const defines = this._getDefinesForBlur(b, this._bypassBlur);
            this._blurHPostProcess.updateEffect(defines.h);
            this._blurVPostProcess.updateEffect(defines.v);
            this._expensiveBlur = b;
        }
        get expensiveBlur() {
            return this._expensiveBlur;
        }
        /**
         *  Support test.
         */
        static get IsSupported() {
            const engine = EngineStore.LastCreatedEngine;
            if (!engine) {
                return false;
            }
            return engine._features.supportSSAO2;
        }
        /**
         * Gets active scene
         */
        get scene() {
            return this._scene;
        }
        /**
         * @constructor
         * @param name The rendering pipeline name
         * @param scene The scene linked to this pipeline
         * @param ratio The size of the postprocesses. Can be a number shared between passes or an object for more precision: { ssaoRatio: 0.5, blurRatio: 1.0 }
         * @param cameras The array of cameras that the rendering pipeline will be attached to
         * @param forceGeometryBuffer Set to true if you want to use the legacy geometry buffer renderer
         * @param textureType The texture type used by the different post processes created by SSAO (default: 0)
         */
        constructor(name, scene, ratio, cameras, forceGeometryBuffer = false, textureType = 0) {
            super(scene.getEngine(), name);
            // Members
            /**
             * @ignore
             * The PassPostProcess id in the pipeline that contains the original scene color
             */
            this.SSAOOriginalSceneColorEffect = "SSAOOriginalSceneColorEffect";
            /**
             * @ignore
             * The SSAO PostProcess id in the pipeline
             */
            this.SSAORenderEffect = "SSAORenderEffect";
            /**
             * @ignore
             * The horizontal blur PostProcess id in the pipeline
             */
            this.SSAOBlurHRenderEffect = "SSAOBlurHRenderEffect";
            /**
             * @ignore
             * The vertical blur PostProcess id in the pipeline
             */
            this.SSAOBlurVRenderEffect = "SSAOBlurVRenderEffect";
            /**
             * @ignore
             * The PostProcess id in the pipeline that combines the SSAO-Blur output with the original scene color (SSAOOriginalSceneColorEffect)
             */
            this.SSAOCombineRenderEffect = "SSAOCombineRenderEffect";
            /**
             * The output strength of the SSAO post-process. Default value is 1.0.
             */
            this.totalStrength = 1.0;
            /**
             * Maximum depth value to still render AO. A smooth falloff makes the dimming more natural, so there will be no abrupt shading change.
             */
            this.maxZ = 100.0;
            /**
             * In order to save performances, SSAO radius is clamped on close geometry. This ratio changes by how much.
             */
            this.minZAspect = 0.2;
            this._epsilon = 0.02;
            this._samples = 8;
            this._textureSamples = 1;
            /**
             * Force rendering the geometry through geometry buffer.
             */
            this._forceGeometryBuffer = false;
            /**
             * The radius around the analyzed pixel used by the SSAO post-process. Default value is 2.0
             */
            this.radius = 2.0;
            /**
             * The base color of the SSAO post-process
             * The final result is "base + ssao" between [0, 1]
             */
            this.base = 0;
            this._bypassBlur = false;
            this._expensiveBlur = true;
            /**
             * The number of samples the bilateral filter uses in both dimensions when denoising the SSAO calculations. Default value is 16.
             *
             * A higher value should result in smoother shadows but will use more processing time in the shaders.
             *
             * A high value can cause the shadows to get to blurry or create visible artifacts (bands) near sharp details in the geometry. The artifacts can sometimes be mitigated by increasing the bilateralSoften setting.
             */
            this.bilateralSamples = 16;
            /**
             * Controls the shape of the denoising kernel used by the bilateral filter. Default value is 0.
             *
             * By default the bilateral filter acts like a box-filter, treating all samples on the same depth with equal weights. This is effective to maximize the denoising effect given a limited set of samples. However, it also often results in visible ghosting around sharp shadow regions and can spread out lines over large areas so they are no longer visible.
             *
             * Increasing this setting will make the filter pay less attention to samples further away from the center sample, reducing many artifacts but at the same time increasing noise.
             *
             * Useful value range is [0..1].
             */
            this.bilateralSoften = 0;
            /**
             * How forgiving the bilateral denoiser should be when rejecting samples. Default value is 0.
             *
             * A higher value results in the bilateral filter being more forgiving and thus doing a better job at denoising slanted and curved surfaces, but can lead to shadows spreading out around corners or between objects that are close to each other depth wise.
             *
             * Useful value range is normally [0..1], but higher values are allowed.
             */
            this.bilateralTolerance = 0;
            this._bits = new Uint32Array(1);
            this._scene = scene;
            this._ratio = ratio;
            this._textureType = textureType;
            this._forceGeometryBuffer = forceGeometryBuffer;
            if (!this.isSupported) {
                Logger.Error("The current engine does not support SSAO 2.");
                return;
            }
            const ssaoRatio = this._ratio.ssaoRatio || ratio;
            const blurRatio = this._ratio.blurRatio || ratio;
            // Set up assets
            if (this._forceGeometryBuffer) {
                scene.enableGeometryBufferRenderer();
            }
            else {
                scene.enablePrePassRenderer();
            }
            this._createRandomTexture();
            this._originalColorPostProcess = new PassPostProcess("SSAOOriginalSceneColor", 1.0, null, Texture.BILINEAR_SAMPLINGMODE, scene.getEngine(), undefined, this._textureType);
            this._originalColorPostProcess.samples = this.textureSamples;
            this._createSSAOPostProcess(1.0, textureType);
            this._createBlurPostProcess(ssaoRatio, blurRatio, this._textureType);
            this._createSSAOCombinePostProcess(blurRatio, this._textureType);
            // Set up pipeline
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.SSAOOriginalSceneColorEffect, () => {
                return this._originalColorPostProcess;
            }, true));
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.SSAORenderEffect, () => {
                return this._ssaoPostProcess;
            }, true));
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.SSAOBlurHRenderEffect, () => {
                return this._blurHPostProcess;
            }, true));
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.SSAOBlurVRenderEffect, () => {
                return this._blurVPostProcess;
            }, true));
            this.addEffect(new PostProcessRenderEffect(scene.getEngine(), this.SSAOCombineRenderEffect, () => {
                return this._ssaoCombinePostProcess;
            }, true));
            // Finish
            scene.postProcessRenderPipelineManager.addPipeline(this);
            if (cameras) {
                scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(name, cameras);
            }
        }
        // Public Methods
        /**
         * Get the class name
         * @returns "SSAO2RenderingPipeline"
         */
        getClassName() {
            return "SSAO2RenderingPipeline";
        }
        /**
         * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
         * @param disableGeometryBufferRenderer
         */
        dispose(disableGeometryBufferRenderer = false) {
            for (let i = 0; i < this._scene.cameras.length; i++) {
                const camera = this._scene.cameras[i];
                this._originalColorPostProcess.dispose(camera);
                this._ssaoPostProcess.dispose(camera);
                this._blurHPostProcess.dispose(camera);
                this._blurVPostProcess.dispose(camera);
                this._ssaoCombinePostProcess.dispose(camera);
            }
            this._randomTexture.dispose();
            if (disableGeometryBufferRenderer) {
                this._scene.disableGeometryBufferRenderer();
            }
            this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._scene.cameras);
            super.dispose();
        }
        // Private Methods
        /** @internal */
        _rebuild() {
            super._rebuild();
        }
        _getSamplersForBlur(disabled) {
            return disabled ? ["textureSampler"] : ["textureSampler", "depthSampler"];
        }
        _getDefinesForBlur(bilateral, disabled) {
            let define = "#define BLUR\n";
            if (disabled) {
                define += "#define BLUR_BYPASS\n";
            }
            if (!bilateral) {
                define += "#define BLUR_LEGACY\n";
            }
            return { h: define + "#define BLUR_H\n", v: define };
        }
        _createBlurPostProcess(ssaoRatio, blurRatio, textureType) {
            const defines = this._getDefinesForBlur(this.expensiveBlur, this.bypassBlur);
            const samplers = this._getSamplersForBlur(this.bypassBlur);
            this._blurHPostProcess = this._createBlurFilter("BlurH", samplers, ssaoRatio, defines.h, textureType, true);
            this._blurVPostProcess = this._createBlurFilter("BlurV", samplers, blurRatio, defines.v, textureType, false);
        }
        _createBlurFilter(name, samplers, ratio, defines, textureType, horizontal) {
            const blurFilter = new PostProcess(name, "ssao2", ["outSize", "samples", "soften", "tolerance"], samplers, ratio, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, defines, textureType);
            blurFilter.onApply = (effect) => {
                if (!this._scene.activeCamera) {
                    return;
                }
                const ssaoCombineSize = horizontal ? this._ssaoCombinePostProcess.width : this._ssaoCombinePostProcess.height;
                const originalColorSize = horizontal ? this._originalColorPostProcess.width : this._originalColorPostProcess.height;
                effect.setFloat("outSize", ssaoCombineSize > 0 ? ssaoCombineSize : originalColorSize);
                effect.setInt("samples", this.bilateralSamples);
                effect.setFloat("soften", this.bilateralSoften);
                effect.setFloat("tolerance", this.bilateralTolerance);
                if (this._geometryBufferRenderer) {
                    effect.setTexture("depthSampler", this._geometryBufferRenderer.getGBuffer().textures[0]);
                }
                else if (this._prePassRenderer) {
                    effect.setTexture("depthSampler", this._prePassRenderer.getRenderTarget().textures[this._prePassRenderer.getIndex(5)]);
                }
            };
            blurFilter.samples = this.textureSamples;
            return blurFilter;
        }
        //Van der Corput radical inverse
        _radicalInverse_VdC(i) {
            this._bits[0] = i;
            this._bits[0] = ((this._bits[0] << 16) | (this._bits[0] >> 16)) >>> 0;
            this._bits[0] = ((this._bits[0] & 0x55555555) << 1) | (((this._bits[0] & 0xaaaaaaaa) >>> 1) >>> 0);
            this._bits[0] = ((this._bits[0] & 0x33333333) << 2) | (((this._bits[0] & 0xcccccccc) >>> 2) >>> 0);
            this._bits[0] = ((this._bits[0] & 0x0f0f0f0f) << 4) | (((this._bits[0] & 0xf0f0f0f0) >>> 4) >>> 0);
            this._bits[0] = ((this._bits[0] & 0x00ff00ff) << 8) | (((this._bits[0] & 0xff00ff00) >>> 8) >>> 0);
            return this._bits[0] * 2.3283064365386963e-10; // / 0x100000000 or / 4294967296
        }
        _hammersley(i, n) {
            return [i / n, this._radicalInverse_VdC(i)];
        }
        _hemisphereSample_uniform(u, v) {
            const phi = v * 2.0 * Math.PI;
            // rejecting samples that are close to tangent plane to avoid z-fighting artifacts
            const cosTheta = 1.0 - u * 0.85;
            const sinTheta = Math.sqrt(1.0 - cosTheta * cosTheta);
            return new Vector3(Math.cos(phi) * sinTheta, Math.sin(phi) * sinTheta, cosTheta);
        }
        _generateHemisphere() {
            const numSamples = this.samples;
            const result = [];
            let vector;
            let i = 0;
            while (i < numSamples) {
                if (numSamples < 16) {
                    vector = this._hemisphereSample_uniform(Math.random(), Math.random());
                }
                else {
                    const rand = this._hammersley(i, numSamples);
                    vector = this._hemisphereSample_uniform(rand[0], rand[1]);
                }
                result.push(vector.x, vector.y, vector.z);
                i++;
            }
            return result;
        }
        _getDefinesForSSAO() {
            const defines = `#define SSAO\n#define SAMPLES ${this.samples}\n#define EPSILON ${this.epsilon.toFixed(4)}`;
            return defines;
        }
        _createSSAOPostProcess(ratio, textureType) {
            this._sampleSphere = this._generateHemisphere();
            const defines = this._getDefinesForSSAO();
            const samplers = ["randomSampler", "depthSampler", "normalSampler"];
            this._ssaoPostProcess = new PostProcess("ssao2", "ssao2", [
                "sampleSphere",
                "samplesFactor",
                "randTextureTiles",
                "totalStrength",
                "radius",
                "base",
                "range",
                "projection",
                "near",
                "texelSize",
                "xViewport",
                "yViewport",
                "maxZ",
                "minZAspect",
                "depthProjection",
            ], samplers, ratio, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, defines, textureType);
            this._ssaoPostProcess.onApply = (effect) => {
                var _a, _b, _c, _d;
                if (!this._scene.activeCamera) {
                    return;
                }
                effect.setArray3("sampleSphere", this._sampleSphere);
                effect.setFloat("randTextureTiles", 32.0);
                effect.setFloat("samplesFactor", 1 / this.samples);
                effect.setFloat("totalStrength", this.totalStrength);
                effect.setFloat2("texelSize", 1 / this._ssaoPostProcess.width, 1 / this._ssaoPostProcess.height);
                effect.setFloat("radius", this.radius);
                effect.setFloat("maxZ", this.maxZ);
                effect.setFloat("minZAspect", this.minZAspect);
                effect.setFloat("base", this.base);
                effect.setFloat("near", this._scene.activeCamera.minZ);
                if (this._scene.activeCamera.mode === Camera.PERSPECTIVE_CAMERA) {
                    effect.setMatrix3x3("depthProjection", SSAO2RenderingPipeline.PERSPECTIVE_DEPTH_PROJECTION);
                    effect.setFloat("xViewport", Math.tan(this._scene.activeCamera.fov / 2) * this._scene.getEngine().getAspectRatio(this._scene.activeCamera, true));
                    effect.setFloat("yViewport", Math.tan(this._scene.activeCamera.fov / 2));
                }
                else {
                    const halfWidth = this._scene.getEngine().getRenderWidth() / 2.0;
                    const halfHeight = this._scene.getEngine().getRenderHeight() / 2.0;
                    const orthoLeft = (_a = this._scene.activeCamera.orthoLeft) !== null && _a !== void 0 ? _a : -halfWidth;
                    const orthoRight = (_b = this._scene.activeCamera.orthoRight) !== null && _b !== void 0 ? _b : halfWidth;
                    const orthoBottom = (_c = this._scene.activeCamera.orthoBottom) !== null && _c !== void 0 ? _c : -halfHeight;
                    const orthoTop = (_d = this._scene.activeCamera.orthoTop) !== null && _d !== void 0 ? _d : halfHeight;
                    effect.setMatrix3x3("depthProjection", SSAO2RenderingPipeline.ORTHO_DEPTH_PROJECTION);
                    effect.setFloat("xViewport", (orthoRight - orthoLeft) * 0.5);
                    effect.setFloat("yViewport", (orthoTop - orthoBottom) * 0.5);
                }
                effect.setMatrix("projection", this._scene.getProjectionMatrix());
                if (this._geometryBufferRenderer) {
                    effect.setTexture("depthSampler", this._geometryBufferRenderer.getGBuffer().textures[0]);
                    effect.setTexture("normalSampler", this._geometryBufferRenderer.getGBuffer().textures[1]);
                }
                else if (this._prePassRenderer) {
                    effect.setTexture("depthSampler", this._prePassRenderer.getRenderTarget().textures[this._prePassRenderer.getIndex(5)]);
                    effect.setTexture("normalSampler", this._prePassRenderer.getRenderTarget().textures[this._prePassRenderer.getIndex(6)]);
                }
                effect.setTexture("randomSampler", this._randomTexture);
            };
            this._ssaoPostProcess.samples = this.textureSamples;
            if (!this._forceGeometryBuffer) {
                this._ssaoPostProcess._prePassEffectConfiguration = new SSAO2Configuration();
            }
        }
        _createSSAOCombinePostProcess(ratio, textureType) {
            this._ssaoCombinePostProcess = new PostProcess("ssaoCombine", "ssaoCombine", [], ["originalColor", "viewport"], ratio, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, undefined, textureType);
            this._ssaoCombinePostProcess.onApply = (effect) => {
                const viewport = this._scene.activeCamera.viewport;
                effect.setVector4("viewport", TmpVectors.Vector4[0].copyFromFloats(viewport.x, viewport.y, viewport.width, viewport.height));
                effect.setTextureFromPostProcessOutput("originalColor", this._originalColorPostProcess);
            };
            this._ssaoCombinePostProcess.samples = this.textureSamples;
        }
        _createRandomTexture() {
            const size = 128;
            this._randomTexture = new DynamicTexture("SSAORandomTexture", size, this._scene, false, Texture.BILINEAR_SAMPLINGMODE);
            this._randomTexture.wrapU = Texture.WRAP_ADDRESSMODE;
            this._randomTexture.wrapV = Texture.WRAP_ADDRESSMODE;
            const context = this._randomTexture.getContext();
            const rand = (min, max) => {
                return Math.random() * (max - min) + min;
            };
            const randVector = Vector3.Zero();
            for (let x = 0; x < size; x++) {
                for (let y = 0; y < size; y++) {
                    randVector.x = rand(0.0, 1.0);
                    randVector.y = rand(0.0, 1.0);
                    randVector.z = 0.0;
                    randVector.normalize();
                    randVector.scaleInPlace(255);
                    randVector.x = Math.floor(randVector.x);
                    randVector.y = Math.floor(randVector.y);
                    context.fillStyle = "rgb(" + randVector.x + ", " + randVector.y + ", " + randVector.z + ")";
                    context.fillRect(x, y, 1, 1);
                }
            }
            this._randomTexture.update(false);
        }
        /**
         * Serialize the rendering pipeline (Used when exporting)
         * @returns the serialized object
         */
        serialize() {
            const serializationObject = SerializationHelper.Serialize(this);
            serializationObject.customType = "SSAO2RenderingPipeline";
            return serializationObject;
        }
        /**
         * Parse the serialized pipeline
         * @param source Source pipeline.
         * @param scene The scene to load the pipeline to.
         * @param rootUrl The URL of the serialized pipeline.
         * @returns An instantiated pipeline from the serialized object.
         */
        static Parse(source, scene, rootUrl) {
            return SerializationHelper.Parse(() => new SSAO2RenderingPipeline(source._name, scene, source._ratio, undefined, source._forceGeometryBuffer, source._textureType), source, scene, rootUrl);
        }
    }
    SSAO2RenderingPipeline.ORTHO_DEPTH_PROJECTION = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    SSAO2RenderingPipeline.PERSPECTIVE_DEPTH_PROJECTION = [0, 0, 0, 0, 0, 0, 1, 1, 1];
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "totalStrength", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "maxZ", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "minZAspect", void 0);
    __decorate$1([
        serialize("epsilon")
    ], SSAO2RenderingPipeline.prototype, "_epsilon", void 0);
    __decorate$1([
        serialize("samples")
    ], SSAO2RenderingPipeline.prototype, "_samples", void 0);
    __decorate$1([
        serialize("textureSamples")
    ], SSAO2RenderingPipeline.prototype, "_textureSamples", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "_forceGeometryBuffer", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "_ratio", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "_textureType", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "radius", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "base", void 0);
    __decorate$1([
        serialize("bypassBlur")
    ], SSAO2RenderingPipeline.prototype, "_bypassBlur", void 0);
    __decorate$1([
        serialize("expensiveBlur")
    ], SSAO2RenderingPipeline.prototype, "_expensiveBlur", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "bilateralSamples", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "bilateralSoften", void 0);
    __decorate$1([
        serialize()
    ], SSAO2RenderingPipeline.prototype, "bilateralTolerance", void 0);
    RegisterClass("BABYLON.SSAO2RenderingPipeline", SSAO2RenderingPipeline);

    // Do not edit.
    const name$2B = "fxaaPixelShader";
    const shader$2B = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
uniform sampler2D textureSampler;uniform vec2 texelSize;varying vec2 vUV;varying vec2 sampleCoordS;varying vec2 sampleCoordE;varying vec2 sampleCoordN;varying vec2 sampleCoordW;varying vec2 sampleCoordNW;varying vec2 sampleCoordSE;varying vec2 sampleCoordNE;varying vec2 sampleCoordSW;const float fxaaQualitySubpix=1.0;const float fxaaQualityEdgeThreshold=0.166;const float fxaaQualityEdgeThresholdMin=0.0833;const vec3 kLumaCoefficients=vec3(0.2126,0.7152,0.0722);
#define FxaaLuma(rgba) dot(rgba.rgb,kLumaCoefficients)
void main(){vec2 posM;posM.x=vUV.x;posM.y=vUV.y;vec4 rgbyM=TEXTUREFUNC(textureSampler,vUV,0.0);float lumaM=FxaaLuma(rgbyM);float lumaS=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordS,0.0));float lumaE=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordE,0.0));float lumaN=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordN,0.0));float lumaW=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordW,0.0));float maxSM=max(lumaS,lumaM);float minSM=min(lumaS,lumaM);float maxESM=max(lumaE,maxSM);float minESM=min(lumaE,minSM);float maxWN=max(lumaN,lumaW);float minWN=min(lumaN,lumaW);float rangeMax=max(maxWN,maxESM);float rangeMin=min(minWN,minESM);float rangeMaxScaled=rangeMax*fxaaQualityEdgeThreshold;float range=rangeMax-rangeMin;float rangeMaxClamped=max(fxaaQualityEdgeThresholdMin,rangeMaxScaled);
#ifndef MALI
if(range<rangeMaxClamped) 
{gl_FragColor=rgbyM;return;}
#endif
float lumaNW=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordNW,0.0));float lumaSE=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordSE,0.0));float lumaNE=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordNE,0.0));float lumaSW=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordSW,0.0));float lumaNS=lumaN+lumaS;float lumaWE=lumaW+lumaE;float subpixRcpRange=1.0/range;float subpixNSWE=lumaNS+lumaWE;float edgeHorz1=(-2.0*lumaM)+lumaNS;float edgeVert1=(-2.0*lumaM)+lumaWE;float lumaNESE=lumaNE+lumaSE;float lumaNWNE=lumaNW+lumaNE;float edgeHorz2=(-2.0*lumaE)+lumaNESE;float edgeVert2=(-2.0*lumaN)+lumaNWNE;float lumaNWSW=lumaNW+lumaSW;float lumaSWSE=lumaSW+lumaSE;float edgeHorz4=(abs(edgeHorz1)*2.0)+abs(edgeHorz2);float edgeVert4=(abs(edgeVert1)*2.0)+abs(edgeVert2);float edgeHorz3=(-2.0*lumaW)+lumaNWSW;float edgeVert3=(-2.0*lumaS)+lumaSWSE;float edgeHorz=abs(edgeHorz3)+edgeHorz4;float edgeVert=abs(edgeVert3)+edgeVert4;float subpixNWSWNESE=lumaNWSW+lumaNESE;float lengthSign=texelSize.x;bool horzSpan=edgeHorz>=edgeVert;float subpixA=subpixNSWE*2.0+subpixNWSWNESE;if (!horzSpan)
{lumaN=lumaW;}
if (!horzSpan) 
{lumaS=lumaE;}
if (horzSpan) 
{lengthSign=texelSize.y;}
float subpixB=(subpixA*(1.0/12.0))-lumaM;float gradientN=lumaN-lumaM;float gradientS=lumaS-lumaM;float lumaNN=lumaN+lumaM;float lumaSS=lumaS+lumaM;bool pairN=abs(gradientN)>=abs(gradientS);float gradient=max(abs(gradientN),abs(gradientS));if (pairN)
{lengthSign=-lengthSign;}
float subpixC=clamp(abs(subpixB)*subpixRcpRange,0.0,1.0);vec2 posB;posB.x=posM.x;posB.y=posM.y;vec2 offNP;offNP.x=(!horzSpan) ? 0.0 : texelSize.x;offNP.y=(horzSpan) ? 0.0 : texelSize.y;if (!horzSpan) 
{posB.x+=lengthSign*0.5;}
if (horzSpan)
{posB.y+=lengthSign*0.5;}
vec2 posN;posN.x=posB.x-offNP.x*1.5;posN.y=posB.y-offNP.y*1.5;vec2 posP;posP.x=posB.x+offNP.x*1.5;posP.y=posB.y+offNP.y*1.5;float subpixD=((-2.0)*subpixC)+3.0;float lumaEndN=FxaaLuma(TEXTUREFUNC(textureSampler,posN,0.0));float subpixE=subpixC*subpixC;float lumaEndP=FxaaLuma(TEXTUREFUNC(textureSampler,posP,0.0));if (!pairN) 
{lumaNN=lumaSS;}
float gradientScaled=gradient*1.0/4.0;float lumaMM=lumaM-lumaNN*0.5;float subpixF=subpixD*subpixE;bool lumaMLTZero=lumaMM<0.0;lumaEndN-=lumaNN*0.5;lumaEndP-=lumaNN*0.5;bool doneN=abs(lumaEndN)>=gradientScaled;bool doneP=abs(lumaEndP)>=gradientScaled;if (!doneN) 
{posN.x-=offNP.x*3.0;}
if (!doneN) 
{posN.y-=offNP.y*3.0;}
bool doneNP=(!doneN) || (!doneP);if (!doneP) 
{posP.x+=offNP.x*3.0;}
if (!doneP)
{posP.y+=offNP.y*3.0;}
if (doneNP)
{if (!doneN) lumaEndN=FxaaLuma(TEXTUREFUNC(textureSampler,posN.xy,0.0));if (!doneP) lumaEndP=FxaaLuma(TEXTUREFUNC(textureSampler,posP.xy,0.0));if (!doneN) lumaEndN=lumaEndN-lumaNN*0.5;if (!doneP) lumaEndP=lumaEndP-lumaNN*0.5;doneN=abs(lumaEndN)>=gradientScaled;doneP=abs(lumaEndP)>=gradientScaled;if (!doneN) posN.x-=offNP.x*12.0;if (!doneN) posN.y-=offNP.y*12.0;doneNP=(!doneN) || (!doneP);if (!doneP) posP.x+=offNP.x*12.0;if (!doneP) posP.y+=offNP.y*12.0;}
float dstN=posM.x-posN.x;float dstP=posP.x-posM.x;if (!horzSpan)
{dstN=posM.y-posN.y;}
if (!horzSpan) 
{dstP=posP.y-posM.y;}
bool goodSpanN=(lumaEndN<0.0) != lumaMLTZero;float spanLength=(dstP+dstN);bool goodSpanP=(lumaEndP<0.0) != lumaMLTZero;float spanLengthRcp=1.0/spanLength;bool directionN=dstN<dstP;float dst=min(dstN,dstP);bool goodSpan=directionN ? goodSpanN : goodSpanP;float subpixG=subpixF*subpixF;float pixelOffset=(dst*(-spanLengthRcp))+0.5;float subpixH=subpixG*fxaaQualitySubpix;float pixelOffsetGood=goodSpan ? pixelOffset : 0.0;float pixelOffsetSubpix=max(pixelOffsetGood,subpixH);if (!horzSpan)
{posM.x+=pixelOffsetSubpix*lengthSign;}
if (horzSpan)
{posM.y+=pixelOffsetSubpix*lengthSign;}
#ifdef MALI
if(range<rangeMaxClamped) 
{gl_FragColor=rgbyM;}
else
{gl_FragColor=TEXTUREFUNC(textureSampler,posM,0.0);}
#else
gl_FragColor=TEXTUREFUNC(textureSampler,posM,0.0);
#endif
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2B] = shader$2B;

    // Do not edit.
    const name$2C = "fxaaVertexShader";
    const shader$2C = `attribute vec2 position;uniform vec2 texelSize;varying vec2 vUV;varying vec2 sampleCoordS;varying vec2 sampleCoordE;varying vec2 sampleCoordN;varying vec2 sampleCoordW;varying vec2 sampleCoordNW;varying vec2 sampleCoordSE;varying vec2 sampleCoordNE;varying vec2 sampleCoordSW;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=(position*madd+madd);sampleCoordS=vUV+vec2( 0.0,1.0)*texelSize;sampleCoordE=vUV+vec2( 1.0,0.0)*texelSize;sampleCoordN=vUV+vec2( 0.0,-1.0)*texelSize;sampleCoordW=vUV+vec2(-1.0,0.0)*texelSize;sampleCoordNW=vUV+vec2(-1.0,-1.0)*texelSize;sampleCoordSE=vUV+vec2( 1.0,1.0)*texelSize;sampleCoordNE=vUV+vec2( 1.0,-1.0)*texelSize;sampleCoordSW=vUV+vec2(-1.0,1.0)*texelSize;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2C] = shader$2C;

    /**
     * Fxaa post process
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#fxaa
     */
    class FxaaPostProcess extends PostProcess {
        /**
         * Gets a string identifying the name of the class
         * @returns "FxaaPostProcess" string
         */
        getClassName() {
            return "FxaaPostProcess";
        }
        constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0) {
            super(name, "fxaa", ["texelSize"], null, options, camera, samplingMode || Texture.BILINEAR_SAMPLINGMODE, engine, reusable, null, textureType, "fxaa", undefined, true);
            const defines = this._getDefines();
            this.updateEffect(defines);
            this.onApplyObservable.add((effect) => {
                const texelSize = this.texelSize;
                effect.setFloat2("texelSize", texelSize.x, texelSize.y);
            });
        }
        _getDefines() {
            const engine = this.getEngine();
            if (!engine) {
                return null;
            }
            const glInfo = engine.getGlInfo();
            if (glInfo && glInfo.renderer && glInfo.renderer.toLowerCase().indexOf("mali") > -1) {
                return "#define MALI 1\n";
            }
            return null;
        }
        /**
         * @internal
         */
        static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
            return SerializationHelper.Parse(() => {
                return new FxaaPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
            }, parsedPostProcess, scene, rootUrl);
        }
    }
    RegisterClass("BABYLON.FxaaPostProcess", FxaaPostProcess);

    const SKYBOX_SIZE = 1000;
    const SamplingModeMap = {
        [exports.eTextureSamplingMode.nearest]: Texture.NEAREST_SAMPLINGMODE,
        [exports.eTextureSamplingMode.bilinear]: Texture.BILINEAR_SAMPLINGMODE,
        [exports.eTextureSamplingMode.trilinear]: Texture.TRILINEAR_SAMPLINGMODE,
    };
    class SceneRenderer extends Renderer {
        constructor(viewer, scene, gui, renderManager) {
            super(viewer, scene);
            this.gui = gui;
            this.renderManager = renderManager;
            this.yVector = new Vector3(0, 1, 0);
            this.modelToken = Token.SceneNode;
        }
        handlesNode(node) {
            return isSceneNode(node) && !node.isNested();
        }
        update3dInternal(node) {
            var _a;
            this.processEnvironment(node);
            //we create a transform node that ends up holding all space nodes in the scene
            //this creates parity with nested scenes and gives us something to transform in WebXR without re-parenting anything
            let tnode = this.get3d(node);
            if (!tnode) {
                tnode = new TransformNode(node._dynamicId, this.scene);
                this.set3d(node, tnode);
                if (!this.viewer.options.forceDisablePostProcess && this.scene.activeCamera) {
                    if (node.enableFxaaPostProcess) {
                        this.fxaaPostProcess = new FxaaPostProcess('fxaa', 1.0, this.scene.activeCamera, Texture.BILINEAR_SAMPLINGMODE, this.scene.getEngine());
                    }
                    if (node.enableLensEffectsPostProcess) {
                        this.lensEffectPostProcess = new LensRenderingPipeline('lens', {
                            edge_blur: 0.5,
                            chromatic_aberration: 0.5,
                            distortion: 0,
                            dof_focus_distance: 200,
                            dof_aperture: 5.0,
                            grain_amount: 0.1,
                            dof_pentagon: true,
                            dof_gain: 1.0,
                            dof_threshold: 1.0,
                            dof_darken: 0,
                        }, this.scene, 1.0, [this.scene.activeCamera]);
                    }
                    if (node.enableSSAOPostProcess) {
                        this.ssaoPostProcess = new SSAO2RenderingPipeline('ssaopipeline', this.scene, 0.75);
                    }
                }
            }
            if (node.changes.has('enableDeferredSceneUpdates')) {
                this.renderManager.maxRenderTime =
                    node.enableDeferredSceneUpdates && !this.viewer.options.editorMode ? 20 : 20000;
            }
            if (node.changes.has('textureSamplingMode')) {
                const samplingMode = SamplingModeMap[node.textureSamplingMode];
                const materials = this.renderManager.material.getAllDefinedMaterials();
                materials.forEach(material => {
                    material.getActiveTextures().forEach(texture => {
                        if (texture) {
                            texture.updateSamplingMode(samplingMode);
                        }
                    });
                });
            }
            if (node.changes.has('backgroundColor') || node.changes.has('background')) {
                if (node.background == exports.eBackground.color) {
                    this.scene.clearColor = node.backgroundColor.toColor4();
                }
                else {
                    this.scene.clearColor = new Color4(0, 0, 0, 0);
                }
            }
            if (node.changes.has('ambientColor')) {
                this.scene.ambientColor = node.ambientColor.toColor3();
            }
            if (node.changes.hasAny('renderMode', 'edgeWidth', 'edgeColor', 'edgeDisplayTolerance')) {
                this.viewer.setRenderMode(node.renderMode);
            }
            if (node.changes.has('enableHoverEffects')) {
                this.scene.constantlyUpdateMeshUnderPointer = node.enableHoverEffects;
            }
            if (node.changes.has('connectorSize')) {
                for (const c of node.getAllConnectors()) {
                    this.viewer.rendererManager.connector.updateScale(c);
                }
                for (const c of node.getAllSketchControlPoints()) {
                    this.viewer.rendererManager.controlPointRenderer.updateScale(c);
                }
            }
            if (node.changes.hasAny('dimensionUnitScalar', 'dimensionUnitSymbol')) {
                node.annotations.forEach(annotationNode => {
                    if (isTrackedClass(annotationNode)) {
                        annotationNode.isModified = true;
                    }
                });
            }
            let gridNeedsRebuild = false;
            if (node.changes.hasAny('_forceGrid', 'gridSize', 'gridNormal', 'gridStepSize', 'gridMajorInterval', 'backgroundColor')) {
                if (node._forceGrid || node.enableGrid) {
                    this.gui.disableGrid();
                    gridNeedsRebuild = true;
                }
                if (node._forceGrid || node.enableGridAxes) {
                    this.gui.disableGridAxes();
                    gridNeedsRebuild = true;
                }
            }
            if (gridNeedsRebuild || node.changes.has('enableGrid')) {
                if (node._forceGrid || node.enableGrid) {
                    this.gui.enableGrid(node, node._forceGrid || node.enableGridAxes);
                }
                else {
                    this.gui.disableGrid();
                }
            }
            if (gridNeedsRebuild || node.changes.has('enableGridAxes')) {
                if (node._forceGrid || node.enableGridAxes) {
                    this.gui.enableGridAxes(node);
                }
                else {
                    this.gui.disableGridAxes();
                }
            }
            if (((_a = node._rootScene) === null || _a === void 0 ? void 0 : _a._dynamicId) === node._dynamicId) {
                const eventPayload = Object.fromEntries(node.changes);
                if (this.viewer.canvas) {
                    this.viewer.canvas.dispatchEvent(new CustomEvent('kb3d.scenePropertyChange', { detail: eventPayload, bubbles: true }));
                }
            }
        }
        processEnvironment(node) {
            var _a;
            if (node.changes.has('environment') || node.changes.has('background') || node.changes.has('environmentBlur')) {
                const matService = (_a = node._manager) === null || _a === void 0 ? void 0 : _a.getService(Token.MaterialService);
                if (!matService) {
                    throw Error('Cannot fetch environment material');
                }
                let path;
                if (node.background === exports.eBackground.environment) {
                    if (node.environmentBlur < 0.15) {
                        path = matService.getAbsoluteEnvironmentPath(node.environment, 3);
                    }
                    else {
                        path = matService.getAbsoluteEnvironmentPath(node.environment, 1);
                    }
                }
                else {
                    path = matService.getAbsoluteEnvironmentPath(node.environment, 0);
                }
                if (path !== '' && this._envTexturePath !== path) {
                    this._envTexturePath = path;
                    if (this._envTexture) {
                        this._envTexture.dispose();
                    }
                    let texture = undefined;
                    if (path.match(/\.dds(\?.*)?$/) || path.match(/\.env(\?.*)?$/)) {
                        texture = CubeTexture.CreateFromPrefilteredData(path, this.scene);
                    }
                    else if (path.match(/\.hdr(\?.*)?$/)) {
                        texture = new HDRCubeTexture(path, this.scene, 128);
                    }
                    if (texture != null) {
                        texture.gammaSpace = false;
                        this.scene.environmentTexture = texture;
                        this._envTexture = texture;
                    }
                    else {
                        this.scene.environmentTexture = null;
                    }
                }
            }
            if ((node.changes.has('background') || node.changes.has('environment')) &&
                node.background == exports.eBackground.environment &&
                this._envTexture) {
                if (!this.skybox) {
                    this.skybox = this.scene.createDefaultSkybox(this._envTexture, true, SKYBOX_SIZE, node.environmentBlur);
                }
                else if (node.changes.has('environment')) {
                    const skyMat = this.skybox.material;
                    skyMat.reflectionTexture = this._envTexture.clone();
                    skyMat.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
                }
            }
            if (node.changes.has('background') && node.background != exports.eBackground.environment) {
                if (this.skybox) {
                    this.skybox.dispose();
                    this.skybox = null;
                }
            }
            if (node.changes.has('environmentBlur')) {
                if (this.skybox) {
                    const skyMat = this.skybox.material;
                    skyMat.microSurface = 1.0 - node.environmentBlur;
                }
            }
            if (node.changes.has('environmentIntensity')) {
                this.scene.environmentIntensity = node.environmentIntensity;
            }
            if (node.changes.has('environmentRotation') && this.scene.environmentTexture) {
                if (this.scene.environmentTexture instanceof CubeTexture ||
                    this.scene.environmentTexture instanceof HDRCubeTexture) {
                    this.scene.environmentTexture.rotationY = (node.environmentRotation * Math.PI) / 180;
                    if (this.skybox) {
                        this.skybox.rotationQuaternion = Quaternion.RotationAxis(this.yVector, (node.environmentRotation * Math.PI) / 180);
                    }
                }
            }
        }
        dispose() {
            super.dispose();
            if (this._envTexture) {
                this._envTexture.dispose();
            }
            if (this.skybox) {
                this.skybox.dispose();
            }
            if (this.ssaoPostProcess) {
                this.ssaoPostProcess.dispose();
            }
            if (this.lensEffectPostProcess) {
                this.lensEffectPostProcess.dispose();
            }
            if (this.fxaaPostProcess) {
                this.fxaaPostProcess.dispose();
            }
        }
        getSkyBox() {
            return this.skybox;
        }
    }

    const blendModeMap = {
        [exports.eTextureBlendMode.normal]: 'source-over',
        [exports.eTextureBlendMode.multiply]: 'multiply',
        [exports.eTextureBlendMode.screen]: 'screen',
        [exports.eTextureBlendMode.overlay]: 'overlay',
        [exports.eTextureBlendMode.darken]: 'darken',
        [exports.eTextureBlendMode.lighten]: 'lighten',
        [exports.eTextureBlendMode.hue]: 'hue',
        [exports.eTextureBlendMode.saturation]: 'saturation',
        [exports.eTextureBlendMode.color]: 'color',
        [exports.eTextureBlendMode.luminosity]: 'luminosity',
        [exports.eTextureBlendMode.difference]: 'difference',
        [exports.eTextureBlendMode.mask]: 'destination-in',
        [exports.eTextureBlendMode.vector]: 'kb3d-vector', // special blending mode
    };
    const workingCanvases = [];
    /** Make sure to dispose the canvas after use! Otherwise you'll get a memory leak! */
    function getWorkingCanvas(width, height) {
        let canvas;
        for (let i = 0; i < workingCanvases.length; i++) {
            if (workingCanvases[i].width === 1) {
                canvas = workingCanvases[i];
                break;
            }
        }
        if (!canvas) {
            canvas = document.createElement('canvas');
            workingCanvases.push(canvas);
        }
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', {
            willReadFrequently: true,
        });
        context.clearRect(0, 0, canvas.width, canvas.height);
        return canvas;
    }
    function disposeWorkingCanvas(canvas) {
        canvas.width = 1;
        canvas.height = 1;
    }
    class TextureLayerRenderer extends Renderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.TextureLayer;
        }
        paintTexture(texture, context, parameters, operations) { }
        getNativeSize(texture) {
            return { width: 1, height: 1 };
        }
        update3dInternal(node) {
            this.viewer.updateTextureWarnings();
        }
        textureHasContent(node) {
            return false;
        }
        calculateOffsetAndDimensions(texture, ctxWidth, ctxHeight, sourceWidth, sourceHeight) {
            let offsetX = texture.uOffset * ctxWidth, offsetY = texture.vOffset * ctxHeight, drawHeight = sourceHeight, drawWidth = sourceWidth;
            switch (texture.verticalFit) {
                case exports.eTextureFit.contain:
                    if (sourceHeight < ctxHeight) {
                        break;
                    }
                // falls through
                case exports.eTextureFit.stretch:
                    drawHeight = ctxHeight;
            }
            switch (texture.horizontalFit) {
                case exports.eTextureFit.contain:
                    if (sourceWidth < ctxWidth) {
                        break;
                    }
                // falls through
                case exports.eTextureFit.stretch:
                    drawWidth = ctxWidth;
            }
            if (texture.maintainAspect) {
                const minRatio = Math.min(drawWidth / sourceWidth, drawHeight / sourceHeight);
                drawWidth = minRatio * sourceWidth;
                drawHeight = minRatio * sourceHeight;
            }
            switch (texture.verticalAlign) {
                // left is offset with no adjustment
                case exports.eTextureVerticalAlign.bottom:
                    offsetY += ctxHeight - drawHeight;
                    break;
                case exports.eTextureVerticalAlign.middle:
                    offsetY += (ctxHeight - drawHeight) / 2;
                    break;
            }
            switch (texture.horizontalAlign) {
                // top is offset with no adjustment
                case exports.eTextureHorizontalAlign.right:
                    offsetX += ctxWidth - drawWidth;
                    break;
                case exports.eTextureHorizontalAlign.center:
                    offsetX += (ctxWidth - drawWidth) / 2;
                    break;
            }
            return {
                offsetX,
                offsetY,
                drawHeight,
                drawWidth,
            };
        }
        drawInBlendedContext(texture, context, parameters, cb, operations) {
            if (operations.mask) {
                const maskingCtx = operations.mask.context;
                delete operations.mask;
                // Transfer transform from context to masking context to mask what is drawn
                const transform = context.getTransform();
                maskingCtx.setTransform(transform);
                context.setTransform(1, 0, 0, 1, 0, 0);
                maskingCtx.globalCompositeOperation = 'source-in';
                cb(maskingCtx);
                maskingCtx.setTransform(1, 0, 0, 1, 0, 0);
                this.drawInBlendedContext(texture, context, parameters, ctx => {
                    ctx.drawImage(maskingCtx.canvas, 0, 0, ctx.canvas.width, ctx.canvas.height);
                }, operations);
            }
            else if (Object.keys(operations).length > 0) {
                const tempCanvas = getWorkingCanvas(context.canvas.width, context.canvas.height);
                const tempContext = tempCanvas.getContext('2d');
                cb(tempContext);
                this.filterImageInPlace(tempCanvas, operations);
                this.drawInBlendedContext(texture, context, parameters, ctx => {
                    ctx.drawImage(tempCanvas, 0, 0, ctx.canvas.width, ctx.canvas.height);
                    disposeWorkingCanvas(tempCanvas);
                }, operations);
            }
            else {
                context.globalAlpha = texture.strength / parameters.strength;
                switch (texture.blendMode) {
                    case exports.eTextureBlendMode.vector: {
                        const tempCanvas = getWorkingCanvas(context.canvas.width, context.canvas.height);
                        const tempContext = tempCanvas.getContext('2d');
                        cb(tempContext);
                        const srcData = tempContext.getImageData(0, 0, context.canvas.width, context.canvas.height).data;
                        const dstImageData = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
                        const dstData = dstImageData.data;
                        const v1 = Vector3.Zero();
                        const v2 = Vector3.Zero();
                        const alphaScale = context.globalAlpha / 255;
                        for (let i = 0, n = srcData.length; i < n; i += 4) {
                            v1.copyFromFloats(dstData[i] / 128 - 1, dstData[i + 1] / 128 - 1, dstData[i + 2] / 256 - 0.5);
                            v2.copyFromFloats(srcData[i] / 128 - 1, srcData[i + 1] / 128 - 1, srcData[i + 2] / 256 - 0.5);
                            v2.scaleInPlace(srcData[i + 3] * alphaScale);
                            v1.addInPlace(v2);
                            v1.normalize();
                            dstData[i] = (v1.x + 1) * 128;
                            dstData[i + 1] = (v1.y + 1) * 128;
                            dstData[i + 2] = (v1.z + 1) * 128;
                            dstData[i + 3] = 255;
                        }
                        tempContext.putImageData(dstImageData, 0, 0);
                        context.drawImage(tempCanvas, 0, 0, context.canvas.width, context.canvas.height);
                        disposeWorkingCanvas(tempCanvas);
                        break;
                    }
                    default: {
                        context.globalCompositeOperation = blendModeMap[texture.blendMode] || 'source-over';
                        cb(context);
                        context.globalCompositeOperation = 'source-over';
                    }
                }
                context.globalAlpha = 1;
            }
        }
        filterImageInPlace(buffer, operations) {
            const ctx = buffer.getContext('2d');
            const width = buffer.width;
            const height = buffer.height;
            if (Object.keys(operations).length === 0) {
                return buffer;
            }
            if (operations.colorize) {
                const tempCanvas = getWorkingCanvas(width, height);
                const tmpCtx = tempCanvas.getContext('2d');
                const color = operations.colorize.color;
                delete operations.colorize;
                tmpCtx.globalCompositeOperation = 'source-over';
                tmpCtx.fillStyle = `rgb(${color.r * 255}, ${color.g * 255}, ${color.b * 255})`;
                tmpCtx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                tmpCtx.globalCompositeOperation = 'luminosity';
                tmpCtx.drawImage(buffer, 0, 0);
                tmpCtx.globalCompositeOperation = 'destination-in';
                tmpCtx.drawImage(buffer, 0, 0);
                ctx.drawImage(tempCanvas, 0, 0);
                disposeWorkingCanvas(tempCanvas);
            }
            if (Object.keys(operations).length === 0) {
                return buffer;
            }
            const imgData = ctx.getImageData(0, 0, width, height);
            const data = imgData.data;
            if (operations.normalRotate) {
                const rotateAngle = -1 * operations.normalRotate.angle;
                delete operations.normalRotate;
                const cosA = Math.cos((rotateAngle * Math.PI) / 180);
                const sinA = Math.sin((rotateAngle * Math.PI) / 180);
                for (let i = 0, n = data.length; i < n; i += 4) {
                    const x1 = data[i] / 128 - 1;
                    const y1 = data[i + 1] / 128 - 1;
                    const x2 = cosA * x1 - sinA * y1;
                    const y2 = sinA * x1 + cosA * y1;
                    data[i] = (x2 + 1) * 128;
                    data[i + 1] = (y2 + 1) * 128;
                }
            }
            if (operations.flipNormalsRg) {
                delete operations.flipNormalsRg;
                for (let i = 0, n = data.length; i < n; i += 4) {
                    const r = data[i];
                    data[i] = data[i + 1];
                    data[i + 1] = r;
                }
            }
            ctx.putImageData(imgData, 0, 0);
            return buffer;
        }
        drawSourceToCanvas(texture, source, // | CanvasImageSource,
        context, parameters, operations) {
            var _a, _b;
            let width = source.width, height = source.height;
            const ctxWidth = context.canvas.width, ctxHeight = context.canvas.height;
            const ctxPerfScale = { width: context.canvas.width / parameters.nativeSize.width, height: context.canvas.height / parameters.nativeSize.height };
            if (texture.colorize) {
                operations.colorize = { color: texture.colorize };
            }
            const firstTextureLayer = ((_a = texture._parent) === null || _a === void 0 ? void 0 : _a.textures.filter(t => t.channel === texture.channel && t.enabled).findIndex(t => t === texture)) === 0;
            if (texture.wAngle && texture.channel === exports.eTextureChannel.normal && !firstTextureLayer) {
                operations.normalRotate = { angle: texture.wAngle };
            }
            if (texture instanceof exports.FileTextureLayer &&
                texture.flipNormalsRg &&
                texture.channel === exports.eTextureChannel.normal) {
                operations.flipNormalsRg = true;
            }
            if (!firstTextureLayer) {
                const originalTransform = context.getTransform();
                const drawAt = this.calculateOffsetAndDimensions(texture, ctxWidth, ctxHeight, width, height);
                const pivotX = texture.uPivot * ctxWidth, pivotY = texture.vPivot * ctxHeight;
                if (texture.tile) {
                    let patternCanvas;
                    let patternAttempt;
                    // In the case of stretch modes, the draw image size will differ from the native size so we have to redraw it first
                    // iOS is unable to draw ImageBitmaps to patterns, so we have to try/catch for iOS
                    if (drawAt.drawWidth === width && drawAt.drawHeight === height) {
                        try {
                            patternAttempt = context.createPattern(source, 'repeat');
                        }
                        catch (e) {
                            // Do nothing, fallback below
                        }
                    }
                    if (!patternAttempt) {
                        patternCanvas = getWorkingCanvas(drawAt.drawWidth, drawAt.drawHeight);
                        const patternContext = patternCanvas.getContext('2d');
                        patternContext.drawImage(source, 0, 0, drawAt.drawWidth, drawAt.drawHeight);
                        width = drawAt.drawWidth;
                        height = drawAt.drawHeight;
                        patternAttempt = context.createPattern(patternCanvas, 'repeat');
                    }
                    const pattern = patternAttempt;
                    // Initial canvas transformations for angle and scaling
                    context.translate(pivotX, pivotY);
                    //if legacy mode enabled
                    if (texture._parent &&
                        texture._parent instanceof exports.MaterialNode &&
                        texture._parent.legacyTextureStacking === false) {
                        context.scale(texture.uScale * ctxPerfScale.width, texture.vScale * ctxPerfScale.height);
                        context.rotate((texture.wAngle * Math.PI) / 180);
                    }
                    else {
                        context.rotate((texture.wAngle * Math.PI) / 180);
                        context.scale(texture.uScale * ctxPerfScale.width, texture.vScale * ctxPerfScale.height);
                        if ((texture.uScale !== 1 || texture.vScale !== 1) && texture.wAngle !== 0) {
                            console.warn(`Texture scale and angle are both altered on the texture layer "${texture.name}" with legacy mode enabled on the material "${(_b = texture._parent) === null || _b === void 0 ? void 0 : _b.name}". The order of operations for scale and angle are now reversed on new materials. Please disable legacy mode on this material and adjust the texture stack properties as needed to preserve the desired behavior when legacy mode is deprecated.`);
                        }
                    }
                    // Remove extra offset since the image will be tiled anyways
                    drawAt.offsetX = drawAt.offsetX % width;
                    drawAt.offsetY = drawAt.offsetY % height;
                    // Initially set the draw size to cover the canvas
                    let drawWidth = (ctxWidth - drawAt.offsetX) / texture.uScale;
                    let drawHeight = (ctxHeight - drawAt.offsetY) / texture.vScale;
                    // If the offset is greater than zero there will be a gap on the top or the left so we have to move the context over one tile
                    if (drawAt.offsetX > 0) {
                        context.translate(-width, 0);
                        drawWidth += width;
                    }
                    if (drawAt.offsetY > 0) {
                        context.translate(0, -height);
                        drawHeight += height;
                    }
                    // add the offset and remove the pivot from earlier that was used to get the correct rotation and scaling matrix parts
                    context.translate(drawAt.offsetX - pivotX, drawAt.offsetY - pivotY);
                    // If the texture was scaled with a pivot, we need to draw the image larger to make sure there are no gaps
                    if ((texture.uPivot !== 0 || texture.vPivot !== 0) && (texture.uScale !== 1 || texture.vScale !== 1)) {
                        const scaleOffsetU = Math.abs(Math.ceil(texture.uPivot / texture.uScale)) * width;
                        const scaleOffsetV = Math.abs(Math.ceil(texture.vPivot / texture.vScale)) * height;
                        if (scaleOffsetU !== 0 || scaleOffsetV !== 0) {
                            context.translate(-scaleOffsetU, -scaleOffsetV);
                            drawWidth += scaleOffsetU * 2;
                            drawHeight += scaleOffsetV * 2;
                        }
                    }
                    // If the texture was rotated, we need to draw the image larger to make sure there are no gaps
                    if (texture.wAngle !== 0) {
                        const rotateOffsetU = Math.ceil(texture.uPivot / texture.uScale) * width;
                        const rotateOffsetV = Math.ceil(texture.vPivot / texture.vScale) * height;
                        if (rotateOffsetU > 0 || rotateOffsetV > 0) {
                            context.translate(-rotateOffsetU, -rotateOffsetV);
                            drawWidth += rotateOffsetU * 2;
                            drawHeight += rotateOffsetV * 2;
                        }
                    }
                    this.drawInBlendedContext(texture, context, parameters, innerContext => {
                        innerContext.fillStyle = pattern;
                        // Note that any rectangle start point outside of the box will not be rendered so all image transforms must be done on the canvas context
                        innerContext.fillRect(0, 0, drawWidth, drawHeight);
                        if (patternCanvas) {
                            disposeWorkingCanvas(patternCanvas);
                        }
                    }, operations);
                }
                else {
                    context.translate(pivotX, pivotY);
                    context.scale(texture.uScale * ctxPerfScale.width, texture.vScale * ctxPerfScale.height);
                    context.rotate((texture.wAngle * Math.PI) / 180);
                    context.translate(-pivotX, -pivotY);
                    this.drawInBlendedContext(texture, context, parameters, innerContext => {
                        innerContext.drawImage(source, drawAt.offsetX, drawAt.offsetY, drawAt.drawWidth, drawAt.drawHeight);
                    }, operations);
                    if (texture._visualize) {
                        context.strokeStyle = '#00FF00';
                        context.strokeRect(texture.uOffset * ctxWidth, texture.vOffset * ctxHeight, ctxWidth, ctxHeight);
                    }
                }
                // reset the context
                context.setTransform(originalTransform);
            }
            else {
                // this block will never need to be masked because the layers using a clipping mask will never be the first layer
                if (Object.keys(operations).length > 0) {
                    if (source instanceof HTMLCanvasElement) {
                        source = this.filterImageInPlace(source, operations);
                    }
                    else {
                        const tempCanvas = getWorkingCanvas(width, height);
                        const tempCtx = tempCanvas.getContext('2d');
                        tempCtx.drawImage(source, 0, 0);
                        source = this.filterImageInPlace(tempCanvas, operations);
                    }
                }
                context.drawImage(source, 0, 0, ctxWidth, ctxHeight);
            }
            return context;
        }
    }

    class ColorFillTextureLayerRenderer extends TextureLayerRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.ColorFillTextureLayer;
        }
        paintTexture(texture, context, parameters, operations) {
            this.drawInBlendedContext(texture, context, parameters, innerContext => {
                innerContext.fillStyle = texture.color.cssString();
                innerContext.fillRect(0, 0, innerContext.canvas.width, innerContext.canvas.height);
            }, operations);
        }
        textureHasContent() {
            return true;
        }
        getNativeSize(texture) {
            const width = texture.width, height = texture.height;
            if (texture.wAngle !== 0) {
                return getRotatedDimensions(width, height, texture.wAngle);
            }
            else {
                return { width, height };
            }
        }
        update3dInternal(node) {
            super.update3dInternal(node);
        }
    }

    class FileTextureLayerRenderer extends TextureLayerRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.FileTextureLayer;
        }
        paintTexture(texture, context, parameters, operations) {
            if (texture._buffer) {
                return this.drawSourceToCanvas(texture, texture._buffer, context, parameters, operations);
            }
        }
        textureHasContent(node) {
            return node.path !== '';
        }
        getNativeSize(texture) {
            if (texture._buffer) {
                const width = Math.max(texture._buffer.width, 1), height = Math.max(texture._buffer.height, 1);
                if (texture.wAngle !== 0) {
                    return getRotatedDimensions(width, height, texture.wAngle);
                }
                else {
                    return { width, height };
                }
            }
            return { width: 1, height: 1 };
        }
        update3dInternal(node) {
            if (((node.changes.has('height') || node.changes.has('width')) && node.path.endsWith('.svg')) ||
                node.changes.has('path') ||
                (node.changes.has('enabled') && !node._buffer) ||
                node.changes.has('_init')) {
                node._needsImageUpdate = true;
            }
            if (node._needsImageUpdate && node.enabled && node.path && node._init) {
                this.loadTextureBuffer(node);
            }
            super.update3dInternal(node);
        }
        loadTextureBuffer(node) {
            if (node._parent instanceof exports.MaterialNode || node._parent instanceof exports.DisplacementMapFeature) {
                node._needsImageUpdate = false;
                if (node._buffer) {
                    node.trackChanges(false);
                    node._buffer = undefined; // Remove the buffer so the texture stack doesn't think the image is already loaded if the image was changed
                    node.trackChanges(true);
                }
                const originalPath = node.path;
                node._parent._materialService.getTextureImage(node).subscribe(resp => {
                    if (node.path !== originalPath) {
                        // If another code path modified the texture since we started loading, ignore the update.
                        // There is abort code in the texture image handler as well but not once the texture is loaded and is being processed.
                        return;
                    }
                    node._buffer = resp.bitmap;
                    node._bufferSource = resp.url;
                });
            }
            else {
                console.warn('Texure is not attached to a material node. Cannot load texture image bitmap.');
            }
        }
    }

    function base64ArrayBuffer(arrayBuffer) {
        let base64 = '';
        const encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        const bytes = new Uint8Array(arrayBuffer);
        const byteLength = bytes.byteLength;
        const byteRemainder = byteLength % 3;
        const mainLength = byteLength - byteRemainder;
        let a, b, c, d;
        let chunk;
        // Main loop deals with bytes in chunks of 3
        for (let i = 0; i < mainLength; i = i + 3) {
            // Combine the three bytes into a single integer
            chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
            // Use bitmasks to extract 6-bit segments from the triplet
            a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
            b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
            c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
            d = chunk & 63; // 63       = 2^6 - 1
            // Convert the raw binary segments to the appropriate ASCII encoding
            base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
        }
        // Deal with the remaining bytes and padding
        if (byteRemainder == 1) {
            chunk = bytes[mainLength];
            a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2
            // Set the 4 least significant bits to zero
            b = (chunk & 3) << 4; // 3   = 2^2 - 1
            base64 += encodings[a] + encodings[b] + '==';
        }
        else if (byteRemainder == 2) {
            chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];
            a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
            b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4
            // Set the 2 least significant bits to zero
            c = (chunk & 15) << 2; // 15    = 2^4 - 1
            base64 += encodings[a] + encodings[b] + encodings[c] + '=';
        }
        return base64;
    }

    class SvgTextureLayerRenderer extends TextureLayerRenderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.FileTextureLayer;
            this.imageElement = document.createElement('img');
            this.svgHelpers = new Map();
        }
        paintTexture(texture, context, parameters, operations) {
            const helper = this.svgHelpers.get(texture._dynamicId);
            if (texture._raster &&
                helper &&
                context.canvas.width === helper.renderedWidth &&
                context.canvas.height === helper.renderedHeight) {
                return this.drawSourceToCanvas(texture, texture._raster, context, parameters, operations);
            }
            else {
                let fontLoadPromise;
                if (texture.preloadFontStylesheet) {
                    const fontFacesFound = [...texture.svgXml.matchAll(/font-family\s*[=:]\s*["'](.+?)["']/g)];
                    const fontsToLoad = [];
                    for (const match of fontFacesFound) {
                        fontsToLoad.push(match[1]);
                    }
                    if (fontsToLoad.length > 0) {
                        const manager = this.viewer.sceneNode._manager;
                        const fontService = manager.getService(Token.FontService);
                        fontLoadPromise = fontService.loadFontData(texture.preloadFontStylesheet, fontsToLoad);
                    }
                    else {
                        fontLoadPromise = Promise.resolve();
                    }
                }
                else {
                    fontLoadPromise = Promise.resolve();
                }
                fontLoadPromise
                    .then(result => this.generateSvg(texture, context.canvas.width, context.canvas.height, result || undefined))
                    .then(bitmap => {
                    if (bitmap) {
                        texture._raster = bitmap;
                    }
                })
                    .catch(() => {
                    // Don't need to do anything
                });
            }
        }
        textureHasContent(node) {
            return !!node.svgXml;
        }
        getNativeSize(texture) {
            const width = texture.width, height = texture.height;
            if (texture.wAngle !== 0) {
                return getRotatedDimensions(width, height, texture.wAngle);
            }
            else {
                return { width, height };
            }
        }
        update3dInternal(node) {
            if (node.changes.has('svgXml') ||
                node.changes.has('width') ||
                node.changes.has('height') ||
                node.changes.has('preloadFontStylesheet')) {
                node._raster = undefined;
            }
            super.update3dInternal(node);
        }
        generateSvg(texture, width, height, embedFonts) {
            if (texture.svgXml !== '' && width > 0 && height > 0) {
                let helper = this.svgHelpers.get(texture._dynamicId);
                if (!helper) {
                    helper = {
                        imgElement: document.createElement('img'),
                        renderedHeight: height,
                        renderedWidth: width,
                    };
                    this.svgHelpers.set(texture._dynamicId, helper);
                }
                else {
                    helper.renderedHeight = height;
                    helper.renderedWidth = width;
                }
                try {
                    const imageElement = this.svgHelpers.get(texture._dynamicId).imgElement;
                    let svgString = texture.svgXml;
                    // Adding svg required tags
                    if (!svgString.match(/<!DOCTYPE/)) {
                        svgString =
                            `<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">` +
                                svgString;
                    }
                    if (!svgString.match(/<\?xml/)) {
                        svgString = `<?xml version="1.0" encoding="UTF-8"?>` + svgString;
                    }
                    if (!svgString.match(/<svg [^>]*xmlns=[^>]*>/)) {
                        svgString = svgString.replace(/<svg /, '<svg xmlns="http://www.w3.org/2000/svg" ');
                    }
                    const match = svgString.match(/<svg[\s\S]*?>/m);
                    if (!match) {
                        console.warn('Invalid SVG');
                        return Promise.reject();
                    }
                    else {
                        if (embedFonts) {
                            let fontStyles = '';
                            for (const fontFamily in embedFonts) {
                                const arrayBuffer = embedFonts[fontFamily];
                                fontStyles += `       
@font-face {
    font-family: "${fontFamily}";
    src: url("data:application/font-woff;charset=utf-8;base64,${base64ArrayBuffer(arrayBuffer)}");
}
                                `;
                            }
                            const offset = (match.index || 0) + match[0].length;
                            svgString =
                                svgString.substring(0, offset) +
                                    `<style type="text/css">${fontStyles}</style>` +
                                    svgString.substring(offset);
                        }
                        const blobUrl = URL.createObjectURL(new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' }));
                        imageElement.src = blobUrl;
                        const generateImagePromise = imageElement.decode().then(() => {
                            // Don't use the img element from the closure so it can get garbage collected if this function isn't called!
                            // There's no way to explicitly dispose of a DOM element
                            const loadedImageElement = this.svgHelpers.get(texture._dynamicId).imgElement;
                            // Figure out what resolution to actually draw the SVG at to fit within the envelope
                            const scaled = scaleImagePreserveAspect(width, height, loadedImageElement.naturalWidth, loadedImageElement.naturalHeight);
                            return createImageBitmap(loadedImageElement, {
                                resizeWidth: scaled.drawWidth,
                                resizeHeight: scaled.drawHeight,
                            });
                        }, err => {
                            console.warn('Could not decode SVG XML: ', svgString);
                        });
                        this.viewer.deferSceneReady(generateImagePromise);
                        return generateImagePromise;
                    }
                }
                catch (e) {
                    console.warn('Could not generate SVG Texture: ', e);
                    Promise.reject(e);
                }
            }
            return Promise.reject();
        }
        delete3d(node) {
            const helper = this.svgHelpers.get(node._dynamicId);
            if (helper) {
                this.svgHelpers.delete(node._dynamicId);
            }
            super.delete3d(node);
        }
    }

    const textureChannelMap = {
        // General
        [exports.eTextureChannel.emissive]: 'emissiveTexture',
        [exports.eTextureChannel.ambientOcclusion]: 'lightmapTexture',
        // PBR
        [exports.eTextureChannel.albedo]: 'albedoTexture',
        [exports.eTextureChannel.normal]: 'bumpTexture',
        [exports.eTextureChannel.ambient]: 'ambientTexture',
        [exports.eTextureChannel.opacity]: 'opacityTexture',
        [exports.eTextureChannel.metallic]: 'metallicTexture',
        [exports.eTextureChannel.reflection]: 'reflectionTexture',
        [exports.eTextureChannel.specular]: 'reflectivityTexture',
        [exports.eTextureChannel.roughness]: 'microSurfaceTexture',
        [exports.eTextureChannel.glossiness]: 'microSurfaceTexture',
        [exports.eTextureChannel.anisotropyTangent]: ['anisotropy', 'texture'],
        [exports.eTextureChannel.clearCoatNormal]: ['clearCoat', 'bumpTexture'],
        [exports.eTextureChannel.subsurfaceThickness]: ['subSurface', 'thicknessTexture'],
    };
    const maskingCanvas = document.createElement('canvas');
    class TextureStackRenderer extends Renderer {
        constructor(viewer, scene, rendererManager) {
            super(viewer, scene);
            this.rendererManager = rendererManager;
            this.modelToken = Token.TextureLayer;
            this.queuedTexturesToProcess = new Map();
            this.queueSize = new Subject();
            this.renderers = new Map();
            this.noMipMapFallback = false;
            this.updateTextureStackRequest = new Subject();
            this.deferCalled = false;
            const fileTexture = new FileTextureLayerRenderer(viewer, scene);
            const svgTexture = new SvgTextureLayerRenderer(viewer, scene);
            const colorTexture = new ColorFillTextureLayerRenderer(viewer, scene);
            this.renderers.set(Token.FileTextureLayer, fileTexture);
            this.renderers.set(Token.SvgTextureLayer, svgTexture);
            this.renderers.set(Token.ColorFillTextureLayer, colorTexture);
            /**
             * See render.ts comment - this delay must be added to the render as a change can take up to this delay time to be displayed.
             * We don't want to repeatedly processes texture changes coming in quick succession, which often happens if there are many textures being loaded at once.
             * */
            const throttleDebounceTime = 800;
            merge(this.updateTextureStackRequest.pipe(throttleTime(throttleDebounceTime)), this.updateTextureStackRequest.pipe(debounceTime(throttleDebounceTime))).subscribe(() => {
                this.updateTextureStacksExec();
            });
            // This code works for forcing intel gpus to not use mipmaps, but some scenes don't have artifacting issues and need mipmaps. So
            // In the future we can introduce a scene setting to enable the intel fallback
            // if (this.viewer.glInfo.match(/Intel.*Iris.*Xe/)) {
            //     this.noMipMapFallback = true;
            // }
        }
        materialDeleted(node) {
            for (const channel in exports.eTextureChannel) {
                const textureId = this.getTexture3dId(node, channel);
                const texture = this.babylonMap.get(textureId);
                if (texture) {
                    this.disposeTexture(texture);
                    this.babylonMap.delete(this.getTexture3dId(node, channel));
                }
                this.babylonMap.delete(textureId);
            }
        }
        /** This should only be called from the editor. Has a very heavy performance impact. */
        forceRebuildTexture(materialNode, channel) {
            if (channel) {
                this.resetTextureStack(materialNode, channel);
            }
            else {
                for (const channel in exports.eTextureChannel) {
                    this.resetTextureStack(materialNode, channel);
                }
            }
            this.updateTextureStacksInternal(materialNode);
        }
        resetTextureStack(texturedNode, channel, setParameters) {
            let material;
            let materialNode;
            if (isMaterialNode(texturedNode)) {
                materialNode = texturedNode;
                if (!materialNode._initialized) {
                    return;
                }
                material = this.rendererManager.material.get3d(materialNode);
                if (!material) {
                    // There might not be a material in babylon if the material was deleted prior to this renderer running.
                    // console.warn(`material not generated from ${materialNode.name}`);
                    return;
                }
            }
            const hasTextureInChannel = !!texturedNode.textures.find(t => t.channel === channel);
            if (!hasTextureInChannel) {
                return;
            }
            let channelsToProcess = this.queuedTexturesToProcess.get(texturedNode);
            if (!channelsToProcess) {
                channelsToProcess = new Map();
                this.queuedTexturesToProcess.set(texturedNode, channelsToProcess);
            }
            // Here we don't want to filter out textures with no data because they cam still be used to set the canvas size
            const textureLayers = this.getActiveLayers(texturedNode, channel);
            // Register that the channel needs to be processed.
            // Figure out the highest strength among the texture layers so we can
            // calculate the strength of each one as a fraction of that.
            let channelStrength = 0;
            textureLayers.forEach(textureLayer => {
                channelStrength = Math.max(channelStrength, textureLayer.strength);
            });
            const existingProcess = channelsToProcess.get(channel);
            const propName3d = textureChannelMap[channel];
            const nativeSize = { width: 0, height: 0 };
            if (material && materialNode) {
                // Reset the material to re-run the texture stack (or clear the texture if there are no textures anymore)
                if (textureLayers.length === 0) {
                    // If no textures are using this channel anymore, then remove it from the material
                    if (Array.isArray(propName3d)) {
                        const res = getObjectPropertyAtPath(material, propName3d, false);
                        if (res.obj && res.obj[res.prop]) {
                            const texture = res.obj[res.prop];
                            if (texture instanceof Texture) {
                                this.disposeTexture(texture);
                                res.obj[res.prop] = null;
                                this.babylonMap.delete(this.getTexture3dId(materialNode, channel));
                            }
                        }
                    }
                    else {
                        if (material && material[propName3d]) {
                            material[propName3d].dispose();
                            material[propName3d] = null;
                            this.babylonMap.delete(this.getTexture3dId(materialNode, channel));
                        }
                    }
                }
                else {
                    const texture = this.getTexture(materialNode, channel);
                    if (texture instanceof DynamicTexture) {
                        const context = texture.getContext();
                        const tagetSize = this.calculateDynamicTextureSize(textureLayers[0]);
                        nativeSize.width = tagetSize.width / tagetSize.scalingW;
                        nativeSize.height = tagetSize.height / tagetSize.scalingH;
                        context.canvas.width = tagetSize.width;
                        context.canvas.height = tagetSize.height;
                        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
                    }
                }
            }
            channelsToProcess.set(channel, {
                strength: channelStrength,
                hasTransparency: materialNode ? materialNode.hasTransparency : false,
                ...(existingProcess || {}),
                ...(setParameters || {}),
                nativeSize,
            });
        }
        calculateDynamicTextureSize(texture) {
            const baseImageSize = this.getRenderer(texture).getNativeSize(texture);
            const targetContextSize = { ...baseImageSize };
            // on ios use small textures for all non-albedo textures to save on memory
            if (isIOS() && texture.channel !== exports.eTextureChannel.albedo) {
                targetContextSize.width = Math.min(128, targetContextSize.width);
                targetContextSize.height = Math.min(128, targetContextSize.height);
            }
            if (this.scene.getEngine().webGLVersion < 2) {
                const clampedSize = getBinClampedSize(targetContextSize.width, targetContextSize.height);
                targetContextSize.width = clampedSize;
                targetContextSize.height = clampedSize;
            }
            return {
                width: targetContextSize.width,
                height: targetContextSize.height,
                scalingW: targetContextSize.width / baseImageSize.width,
                scalingH: targetContextSize.height / baseImageSize.height,
            };
        }
        update3dInternal(feature) {
            if (isTrackedClass(feature)) {
                if (!feature.enabled || feature._suppressed) {
                    if (feature.changes.has('enabled') || feature.changes.has('_suppressed')) {
                        this.delete3d(feature);
                    }
                    return;
                }
                const renderer = this.renderers.get(Token.withKey(feature.$type));
                if (!renderer) {
                    throw Error('no renderer for feature');
                }
                if (feature._parent && isFeatureNode(feature._parent)) {
                    feature.init(feature._parent);
                }
                renderer.update3d(feature);
                if (feature._parent && isFeatureNode(feature._parent) && isTrackedClass(feature._parent)) {
                    feature._parent.setPropertyIsModified('textures', true);
                }
                if (feature._parent) {
                    this.resetTextureStack(feature._parent, feature.channel);
                }
            }
        }
        updateTextureStacks() {
            if (!this.deferCalled && this.queuedTexturesToProcess.size > 0) {
                const queueLive = this.queueSize.pipe(takeWhile(size => size > 0));
                const p = queueLive.toPromise();
                this.viewer.deferSceneReady(p);
                this.deferCalled = true;
            }
            for (const node of this.queuedTexturesToProcess.keys()) {
                if (isFeatureNode(node) || node._initialized) {
                    for (const texture of node.textures) {
                        if (!texture._init) {
                            texture.init(node);
                        }
                    }
                }
            }
            this.updateTextureStackRequest.next();
        }
        updateTextureStacksExec() {
            this.queueSize.next(this.queuedTexturesToProcess.size);
            for (const node of this.queuedTexturesToProcess.keys()) {
                this.updateTextureStacksInternal(node);
                if (this.queuedTexturesToProcess.size > 0) {
                    this.updateTextureStacks();
                }
                // Low perf code to prevent iOS from erroring out. Doesn't seem necessary for now
                // return;
                // End low perf code
            }
            this.queueSize.next(this.queuedTexturesToProcess.size);
        }
        updateTextureStacksInternal(node) {
            if (this.queuedTexturesToProcess.has(node)) {
                if (isMaterialNode(node)) {
                    const channels = this.queuedTexturesToProcess.get(node);
                    const material = this.rendererManager.material.get3d(node);
                    if (!channels || !material) {
                        return;
                    }
                    // Process texture stack
                    channels.forEach((parameters, channel) => {
                        // Put the texture in the right place on the material
                        const propName3d = textureChannelMap[channel];
                        if (instanceOf(node, Token.AdvancedMaterialNode)) {
                            if (node.workflowMode === exports.eMaterialWorkflow.metallicRoughness &&
                                channel === exports.eTextureChannel.glossiness) {
                                return;
                            }
                            else if (node.workflowMode === exports.eMaterialWorkflow.specularGlossiness &&
                                channel === exports.eTextureChannel.roughness) {
                                return;
                            }
                        }
                        const texture = this.getTexture(node, channel);
                        // If texture is undefined, that means that there is a missing setting/layers that means we don't need a texture for this channel
                        if (texture) {
                            // Paint the image onto the texture
                            // We don't want to count layers with no content in the stack, like file textures with no file or svg textures with no data
                            const textureLayers = this.getActiveLayers(node, channel).filter(node => {
                                const renderer = this.getRenderer(node);
                                return renderer.textureHasContent(node);
                            });
                            if (textureLayers.length > 0) {
                                // Put the texture in the right place on the material if it's not already
                                if (Array.isArray(propName3d)) {
                                    const res = getObjectPropertyAtPath(material, propName3d);
                                    if (res.obj[res.prop] !== texture) {
                                        res.obj[res.prop] = texture;
                                    }
                                }
                                else {
                                    if (material[propName3d] !== texture) {
                                        material[propName3d] = texture;
                                    }
                                }
                                if (texture instanceof DynamicTexture) {
                                    const context = texture.getContext();
                                    if (!(context instanceof CanvasRenderingContext2D)) {
                                        throw Error('Unexpected rendering context');
                                    }
                                    if (channel !== exports.eTextureChannel.albedo) {
                                        // Fill texture with color that makes sense depending on the texture channel
                                        switch (channel) {
                                            case exports.eTextureChannel.normal: {
                                                context.fillStyle = 'rgb(128, 128, 255)';
                                                break;
                                            }
                                            case exports.eTextureChannel.opacity:
                                            case exports.eTextureChannel.ambient:
                                            case exports.eTextureChannel.ambientOcclusion: {
                                                context.fillStyle = 'rgb(255, 255, 255)';
                                                break;
                                            }
                                            default: {
                                                context.fillStyle = 'rgb(0, 0, 0)';
                                                break;
                                            }
                                        }
                                        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
                                    }
                                    this.paintTextureOnCanvas(textureLayers, context, parameters);
                                    updateTextureProps(texture, parameters);
                                    texture.update(true); // invertY
                                }
                                else {
                                    // If texture is not a dynamic texture, then it's a basic texture and there is only one texture layer. We just have to make sure the path is correct
                                    const fileTextureLayer = textureLayers[0];
                                    if (!(fileTextureLayer instanceof exports.FileTextureLayer)) {
                                        throw Error('Unexpected texture type');
                                    }
                                    else {
                                        if (fileTextureLayer._parent instanceof exports.MaterialNode) {
                                            const path = fileTextureLayer._bufferSource || '';
                                            if (texture.url !== path && fileTextureLayer._buffer) {
                                                texture.updateURL(path, (fileTextureLayer._buffer || null));
                                            }
                                        }
                                        updateTextureProps(texture, parameters);
                                    }
                                }
                            }
                        }
                    });
                }
                else {
                    if (isTrackedClass(node)) {
                        node.setPropertyIsModified('textures', true);
                        this.queuedTexturesToProcess.delete(node);
                        return;
                    }
                }
            }
            if (isMaterialNode(node) && isTrackedClass(node)) {
                this.applyUvProperties(node);
            }
            else {
                throw Error('Material is not being tracked');
            }
            this.queuedTexturesToProcess.delete(node);
            function updateTextureProps(texture, parameters) {
                texture.level = parameters.strength;
                texture.hasAlpha = parameters.hasTransparency;
            }
        }
        delete3d(feature) {
            if (feature._parent) {
                this.resetTextureStack(feature._parent, feature.channel);
            }
            const renderer = this.renderers.get(Token.withKey(feature.$type));
            if (!renderer) {
                throw Error('no renderer for feature');
            }
            renderer.delete3d(feature);
        }
        get3d(texture) {
            if (!texture._parent) {
                return undefined;
            }
            if (texture._parent instanceof exports.MaterialNode) {
                return this.babylonMap.get(this.getTexture3dId(texture._parent, texture.channel));
            }
        }
        set3d(texture, babylonObject) {
            if (texture._parent) {
                if (texture._parent instanceof exports.MaterialNode) {
                    this.babylonMap.set(this.getTexture3dId(texture._parent, texture.channel), babylonObject);
                }
            }
        }
        dispose() {
            this.queuedTexturesToProcess.clear();
            this.renderers.forEach(renderer => renderer.dispose());
            this.updateTextureStackRequest.complete();
            super.dispose();
        }
        setTransparency(materialNode, hasTransparency) {
            // TODO: limit this to only albedo textures for now. Will need testing.
            this.resetTextureStack(materialNode, exports.eTextureChannel.albedo, { hasTransparency });
        }
        applyUvProperties(materialNode) {
            const material = this.rendererManager.material.get3d(materialNode);
            if (material) {
                for (const channel in textureChannelMap) {
                    const firstTextureLayer = materialNode.textures.find(t => t.channel === channel);
                    const propName3d = textureChannelMap[channel];
                    let texture;
                    if (Array.isArray(propName3d)) {
                        const res = getObjectPropertyAtPath(material, propName3d);
                        texture = res.obj[res.prop];
                    }
                    else {
                        texture = material[propName3d];
                    }
                    if (texture && firstTextureLayer) {
                        if (!(texture instanceof Texture)) {
                            throw Error(propName3d.toString() + ' is not a texture');
                        }
                        texture.uOffset = firstTextureLayer.uOffset;
                        texture.vOffset = firstTextureLayer.vOffset;
                        texture.uScale = firstTextureLayer.uScale;
                        texture.vScale = firstTextureLayer.vScale;
                        texture.uAng = (firstTextureLayer.uAngle * Math.PI) / 180;
                        texture.vAng = (firstTextureLayer.vAngle * Math.PI) / 180;
                        texture.wAng = (firstTextureLayer.wAngle * Math.PI) / 180;
                        texture.uRotationCenter = firstTextureLayer.uPivot;
                        texture.vRotationCenter = firstTextureLayer.vPivot;
                        texture.wRotationCenter = firstTextureLayer.wPivot;
                        // if (firstTextureLayer.uWrap === eTextureWrapAddressMode.clamp) {
                        //     texture.wrapU = Texture.CLAMP_ADDRESSMODE;
                        // } else {
                        //     texture.wrapU = Texture.WRAP_ADDRESSMODE;
                        // }
                        // if (firstTextureLayer.vWrap === eTextureWrapAddressMode.clamp) {
                        //     texture.wrapV = Texture.CLAMP_ADDRESSMODE;
                        // } else {
                        //     texture.wrapV = Texture.WRAP_ADDRESSMODE;
                        // }
                        // For some reason wrap addressmode is not getting converted correctly. Repeat is the safer option so
                        // Let's hardcode repeat for now
                        texture.wrapU = Texture.WRAP_ADDRESSMODE;
                        texture.wrapV = Texture.WRAP_ADDRESSMODE;
                        if (!(texture instanceof DynamicTexture)) {
                            texture.vScale *= -1;
                        }
                    }
                }
            }
        }
        paintTextureOnCanvas(textureLayers, context, parameters) {
            let clippingTexture = null;
            for (let i = 0; i < textureLayers.length; i++) {
                if (!textureLayers[i]._init) {
                    continue;
                }
                const textureLayer = textureLayers[i];
                const renderer = this.getRenderer(textureLayer);
                // Continue clipping with the same texture as long as useClippingMask is true.
                // When there's a texture that's not clipping, that can potentially be a new clipping mask.
                if (!textureLayer.useClippingMask) {
                    clippingTexture = null;
                }
                const maskingCtx = maskingCanvas.getContext('2d', {
                    willReadFrequently: true,
                });
                if (textureLayers[i + 1] && textureLayers[i + 1].useClippingMask && !clippingTexture) {
                    maskingCanvas.width = context.canvas.width;
                    maskingCanvas.height = context.canvas.height;
                    clippingTexture = textureLayer;
                }
                else if (textureLayer.useClippingMask && clippingTexture) {
                    const clippingTextureRenderer = this.getRenderer(clippingTexture);
                    maskingCtx.clearRect(0, 0, maskingCanvas.width, maskingCanvas.height);
                    clippingTextureRenderer.paintTexture(clippingTexture, maskingCtx, { strength: 1, hasTransparency: true, nativeSize: parameters.nativeSize }, {});
                    // The clipped image will be scaled already, so we want to avoid double scaling the clipped images
                    // Thus set the native size to the canvas size here
                    renderer.paintTexture(textureLayer, context, { ...parameters, nativeSize: { width: context.canvas.width, height: context.canvas.height } }, {
                        mask: { context: maskingCtx },
                    });
                }
                else {
                    renderer.paintTexture(textureLayer, context, parameters, {});
                }
            }
            return context;
        }
        getActiveLayers(materialNode, channel, includeSupressed = false) {
            return materialNode.textures.filter(texture => texture.channel === channel && texture.enabled && (includeSupressed || !texture._suppressed));
        }
        getRenderer(textureLayer) {
            const renderer = this.renderers.get(Token.withKey(textureLayer.$type));
            if (!renderer) {
                throw Error('no renderer for texture layer');
            }
            return renderer;
        }
        canUseSimpleTexture(activeLayers) {
            if (activeLayers.length === 1) {
                const layer = activeLayers[0];
                return layer instanceof exports.FileTextureLayer;
            }
            return false;
        }
        disposeTexture(texture) {
            texture.dispose();
        }
        getTexture3dId(node, channel) {
            return `${node._dynamicId}_${channel}`;
        }
        getTexture(node, channel) {
            const rootScene = this.viewer.sceneNode;
            const activeLayers = this.getActiveLayers(node, channel, true);
            const canUseSimpleTexture = this.canUseSimpleTexture(activeLayers);
            let texture = this.babylonMap.get(this.getTexture3dId(node, channel));
            const originalTexture = texture;
            if (originalTexture) {
                if (originalTexture instanceof DynamicTexture && canUseSimpleTexture) {
                    this.disposeTexture(originalTexture);
                }
                else if (activeLayers.length > 1 && !(texture instanceof DynamicTexture)) {
                    this.disposeTexture(originalTexture);
                }
                else {
                    return originalTexture;
                }
            }
            if (canUseSimpleTexture) {
                const fileTexture = activeLayers[0];
                if (fileTexture.path && fileTexture._buffer && fileTexture._parent instanceof exports.MaterialNode) {
                    texture = new Texture(fileTexture._bufferSource || '', this.scene, this.noMipMapFallback, false, SamplingModeMap[rootScene.textureSamplingMode], null, null, fileTexture._buffer);
                    texture.name = this.getTexture3dId(node, channel);
                }
                else {
                    return undefined;
                }
            }
            else {
                texture = new DynamicTexture(this.getTexture3dId(node, channel), 256, this.scene, !this.noMipMapFallback, SamplingModeMap[rootScene.textureSamplingMode]);
            }
            texture.homogeneousRotationInUVTransform = true;
            this.babylonMap.set(this.getTexture3dId(node, channel), texture);
            // set initial values
            if (originalTexture) {
                texture.hasAlpha = originalTexture.hasAlpha;
                texture.level = originalTexture.level;
                texture.getAlphaFromRGB = originalTexture.getAlphaFromRGB;
            }
            else {
                texture.hasAlpha = false;
                if (channel === exports.eTextureChannel.opacity) {
                    texture.getAlphaFromRGB = true;
                }
                else {
                    texture.getAlphaFromRGB = false;
                }
                texture.level = 1;
            }
            texture.coordinatesIndex = 0;
            texture.coordinatesMode = 0;
            texture.anisotropicFilteringLevel = 4;
            if (texture instanceof Texture) {
                texture.uOffset = 0; // Define an offset on the texture to offset the u coordinates of the UVs
                texture.vOffset = 0; // Define an offset on the texture to offset the v coordinates of the UVs
                texture.uScale = -1; // Define an offset on the texture to scale the u coordinates of the UVs
                texture.vScale = 1; // Define an offset on the texture to scale the v coordinates of the UVs
                texture.uAng = 0; // Define an offset on the texture to rotate around the u coordinates of the UVs
                texture.vAng = 0; // Define an offset on the texture to rotate around the v coordinates of the UVs
                texture.wAng = 0; // Define an offset on the texture to rotate around the w coordinates of the UVs (in case of 3d texture)
                texture.uRotationCenter = 0.5; // Defines the center of rotation (U)
                texture.vRotationCenter = 0.5; // Defines the center of rotation (V)
                texture.wRotationCenter = 0.5; // Defin
                texture.isBlocking = false;
            }
            return texture;
        }
    }
    function getObjectPropertyAtPath(_obj, path, throwOnNotFound = true) {
        let obj = _obj;
        const propPath = path.slice().reverse();
        while (propPath.length > 1 && obj) {
            const prop = propPath.pop();
            if (prop in obj) {
                obj = obj[prop];
            }
            else {
                obj = null;
            }
        }
        if (throwOnNotFound && !obj) {
            throw Error('Texture property not found for ' + path.toString());
        }
        return { obj, prop: propPath[0] };
    }

    class ViewpointRenderer extends Renderer {
        constructor() {
            super(...arguments);
            this.modelToken = Token.ViewpointNode;
        }
        update3dInternal(node) { }
    }

    let unprocessedChangesCount = 0;
    class ChangeMap extends ArrayMap {
    }
    class RendererManager {
        getRenderMode() {
            return this.material.renderMode;
        }
        /** Do not use this function directly. Call setRenderMode on the viewer instead so the correct sceneNode is used. */
        setRenderMode(mode, sceneNode, force) {
            if (force) {
                this.forcedRenderingMode = mode;
            }
            this.material.renderMode = this.forcedRenderingMode || mode;
            this.mesh.setRenderMode(this.forcedRenderingMode || mode, sceneNode);
        }
        constructor(viewer, scene) {
            this.viewer = viewer;
            this.scene = scene;
            this.deferredChanges = [];
            this.maxRenderTime = MAX_RENDER_TIME;
            this.processors = new Array();
            this.shadowManager = new ShadowManager(viewer.bbCache);
            this.sceneRenderer = new SceneRenderer(viewer, scene, viewer.gui, this);
            this.textures = new TextureStackRenderer(viewer, scene, this);
            this.material = new MaterialRenderer(viewer, scene, this.textures);
            this.light = new LightRenderer(viewer, scene, this.shadowManager);
            this.viewpoint = new ViewpointRenderer(viewer, scene);
            this.mesh = new MeshRenderer(viewer, scene, this, this.shadowManager);
            this.features = new FeatureStackRenderer(viewer, scene, this);
            this.connector = new ConnectorRenderer(viewer, scene, this);
            this.controlPointRenderer = new SketchControlPointRenderer(viewer, scene, this);
            this.annotation = new AnnotationRenderer(viewer, scene, this);
            this.dimension = new DimensionRenderer(viewer, scene, this);
            this.mate = new MateRenderer(viewer, scene);
            this.path = new PathRenderer(viewer, scene);
            // Order is important here, it defines the order in which renderers will be run
            this.renderers = new Set([
                this.sceneRenderer,
                this.material,
                this.textures,
                this.viewpoint,
                this.path,
                this.mesh,
                this.light,
                this.features,
                this.connector,
                this.controlPointRenderer,
                this.annotation,
                this.dimension,
                this.mate,
            ]);
            this.referenceProcessor = new ReferenceProcessor(viewer);
            this.mateProcessor = new MateProcessor(viewer, scene, this.connector, this.controlPointRenderer, this.referenceProcessor);
            this.sketchProcessor = new SketchProcessor(this.controlPointRenderer);
            this.processors.push(this.mateProcessor);
            this.processors.push(this.referenceProcessor);
            this.processors.push(this.sketchProcessor);
        }
        isStable() {
            return (!SyncService.hasChanges &&
                this.features.queuedFeaturesToProcess.size === 0 &&
                this.textures.queuedTexturesToProcess.size === 0);
        }
        render() {
            let changes;
            if (this.deferredChanges.length > 0) {
                changes = this.getChangeMap(this.deferredChanges);
            }
            else {
                for (const p of this.processors) {
                    p.beforeRender();
                }
                // run deletions first
                const deletions = this.getChangeMap(SyncService.getDeletedNodes(), true);
                for (const p of this.processors) {
                    p.beforeDeletions(deletions);
                }
                this.runChanges(deletions, (renderer, change) => renderer.delete3d(change));
                for (const p of this.processors) {
                    p.afterDeletions(deletions);
                }
                //then run updates
                const newChanges = SyncService.getChangedNodes();
                changes = this.getChangeMap(newChanges);
                for (const p of this.processors) {
                    p.beforeUpdates(changes);
                }
                changes = this.getChangeMap(SyncService.getChangedNodes()); //need to update changes in case processors added any
            }
            const allChangesByDid = new Map(changes.all().map(change => {
                return [change._dynamicId, change];
            }));
            const allChangeCount = allChangesByDid.size;
            const processedChangeMap = this.runChanges(changes, (renderer, change) => {
                renderer.update3d(change);
            });
            const processedChanges = processedChangeMap.all();
            processedChanges.forEach(change => {
                allChangesByDid.delete(change._dynamicId);
            });
            this.deferredChanges = Array.from(allChangesByDid.values());
            const skipCount = allChangeCount - processedChanges.length;
            // For now we are processing all changes becuase it causes unpredictable behavior.
            // The heaviest part of the render cycle is the geometry features processing.
            // if (processedChanges.length > 0 || skipCount > 0) {
            //     console.log('processed ' + processedChanges.length + ' changes, skipped ' + skipCount + ' changes');
            // }
            // Don't run the geometry and texture stack processing until all changes have been processed
            if (skipCount === 0) {
                this.features.update3dGeometry();
                this.textures.updateTextureStacks();
            }
            for (const p of this.processors)
                p.afterUpdates(processedChangeMap);
            for (const n of processedChanges) {
                n.commitChanges();
            }
            for (const p of this.processors)
                p.doAfterCleanup();
            // Output a console warning if there are a lot of changes not being processed, as this could indicate a problem with changes not being processed.
            const unchangedNodes = SyncService.getChangedNodes();
            if (unchangedNodes.length > 0) {
                unprocessedChangesCount++;
                if (unprocessedChangesCount > 1000) {
                    unprocessedChangesCount = 0;
                    console.warn('Scene stabilization is taking longer than expected.');
                    for (const n of unchangedNodes) {
                        if (n._rootScene._dynamicId !== this.viewer.sceneNode._dynamicId) {
                            n.commitChanges();
                            console.warn(`node ${n.name} (${n.id}) is from a different, non-active scene instance. Clearing the change.`);
                        }
                    }
                }
            }
        }
        /** runs a change map in order */
        runChanges(changes, action) {
            const processedChanges = new ChangeMap();
            const renderStart = performance.now();
            for (const renderer of this.renderers) {
                const changeList = changes.get(renderer.modelToken);
                for (const change of changeList) {
                    action(renderer, change);
                    processedChanges.add(renderer.modelToken, change);
                }
            }
            const renderTime = performance.now() - renderStart;
            if (renderTime > 50) {
                console.warn(`Change cycle took ${renderTime}ms`);
            }
            return processedChanges;
        }
        getChangeMap(nodes, includeOrphaned = false) {
            var _a;
            const changes = new ChangeMap();
            for (const n of nodes) {
                if ((((_a = n._rootScene) === null || _a === void 0 ? void 0 : _a._dynamicId) === this.viewer.sceneNode._dynamicId && n._level > -1) ||
                    includeOrphaned ||
                    this.isGlobalMaterialOrTexture(n) //global/library material nodes held outside of graph
                ) {
                    const renderer = this.renderers.find(r => r.handlesNode(n));
                    if (!renderer)
                        throw 'unknown node type';
                    changes.add(renderer.modelToken, n);
                }
                else if (n._rootScene == null) {
                    // Clear changes on nodes that are not in any scene tree
                    n.commitChanges();
                }
            }
            changes.get(Token.SpaceNode).sortBy(m => m._level); //sort meshes by level first
            return changes;
        }
        disposeAll() {
            this.shadowManager.dispose();
            for (const processor of this.processors)
                processor.dispose();
            for (const renderer of this.renderers)
                renderer.dispose();
        }
        isGlobalMaterialOrTexture(n) {
            let mat = n;
            if (n instanceof exports.TextureLayer)
                mat = n._parent;
            return mat instanceof exports.MaterialNode && mat.location != exports.eMaterialLocation.local;
        }
    }

    /**
     * We are overriding the default mouse wheet input for the arc rotate camera here because
     * the default one does not act correctly when zoomed in close to the target:  it
     * calculates the inertia based on the radius at the time the event happens.  The result
     * is that zooming in is fast than zooming out.  They had a misguided attempt at fixing
     * that here:  https://github.com/BabylonJS/Babylon.js/issues/6215 but it is inadequate.
     * See comments below for where we changed the code
     */
    class KbArcRotateCameraMouseWheelInput {
        constructor() {
            this.wheelPrecision = 3.0;
            this.wheelDeltaPercentage = 0;
        }
        computeDeltaFromMouseWheelLegacyEvent(mouseWheelDelta, radius) {
            let delta = 0;
            const wheelDelta = mouseWheelDelta * 0.01 * this.wheelDeltaPercentage * radius;
            if (mouseWheelDelta > 0) {
                delta = wheelDelta / (1.0 + this.wheelDeltaPercentage);
            }
            else {
                delta = wheelDelta * (1.0 + this.wheelDeltaPercentage);
            }
            return delta;
        }
        attachControl(noPreventDefault) {
            this._wheel = (p, s) => {
                if (p.type !== PointerEventTypes.POINTERWHEEL) {
                    return;
                }
                const event = p.event;
                let delta = 0;
                const mouseWheelLegacyEvent = event;
                let wheelDelta = 0;
                if (mouseWheelLegacyEvent.wheelDelta) {
                    wheelDelta = mouseWheelLegacyEvent.wheelDelta;
                }
                else {
                    wheelDelta = -(event.deltaY || event.detail || 0) * 60;
                }
                if (this.wheelDeltaPercentage) {
                    delta = this.computeDeltaFromMouseWheelLegacyEvent(wheelDelta, this.camera.radius);
                    // If zooming in, estimate the target radius and use that to compute the delta for inertia
                    // this will stop multiple scroll events zooming in from adding too much inertia
                    //if (delta > 0) {  //KB Note:  their misguided attempt at fixing the problem only affected zoom in, when it should affect both, so we commented this line out
                    let estimatedTargetRadius = this.camera.radius;
                    let targetInertia = this.camera.inertialRadiusOffset + delta;
                    for (let i = 0; i < 20 && Math.abs(targetInertia) > this.camera.speed * Epsilon; i++) {
                        //KB Note:  fixed the lower limit where it opts out to match the camera's own intertial calculation
                        estimatedTargetRadius -= targetInertia;
                        targetInertia *= this.camera.inertia;
                    }
                    estimatedTargetRadius = Scalar.Clamp(estimatedTargetRadius, 0, Number.MAX_VALUE);
                    delta = this.computeDeltaFromMouseWheelLegacyEvent(wheelDelta, estimatedTargetRadius);
                    //}
                }
                else {
                    delta = wheelDelta / (this.wheelPrecision * 40);
                }
                if (delta) {
                    this.camera.inertialRadiusOffset += delta;
                }
                if (event.preventDefault) {
                    if (!noPreventDefault) {
                        event.preventDefault();
                    }
                }
            };
            this._observer = this.camera.getScene().onPointerObservable.add(this._wheel, PointerEventTypes.POINTERWHEEL);
        }
        detachControl() {
            if (this._observer) {
                this.camera.getScene().onPointerObservable.remove(this._observer);
                this._observer = null;
                this._wheel = null;
            }
        }
        getClassName() {
            return 'KbArcRotateCameraMouseWheelInput';
        }
        getSimpleName() {
            return 'mousewheel';
        }
    }

    /** Arc Rotate Camera (orbit camera) modified to offset the screen position on pan and keep the orbit target in the same position */
    class KbArcRotateCamera extends ArcRotateCamera {
        constructor(name, alpha, beta, radius, target, scene, setActiveOnSceneIfNoneActive) {
            super(name, alpha, beta, radius, target, scene, setActiveOnSceneIfNoneActive);
            this.scene = scene;
            this.inertialOffsetPanningX = 0;
            this.inertialOffsetPanningY = 0;
            this.inertialOrthoZoom = 0;
            this.clientInfo = {
                mouseX: 0,
                mouseY: 0,
                screenLeft: 0,
                screenTop: 0,
                screenWidth: 0,
                screenHeight: 0,
            };
            this.lockRotation = false;
            this.lockPanning = false;
            this.lockZoom = false;
            this.limitMinimumTargetDistance = false;
            this._orthoWidth = 0;
            //replace the wheel input with our own
            this.inputs.removeByType('ArcRotateCameraMouseWheelInput');
            this.inputs.add(new KbArcRotateCameraMouseWheelInput());
            this.updateClient();
        }
        get orthoWidth() {
            return this._orthoWidth;
        }
        set orthoWidth(val) {
            this._orthoWidth = this.clampOrthoWidth(val);
            this.updateOrthographicPosition();
        }
        orthoFit(sizeX, sizeY) {
            if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                const ratio = this.clientInfo.screenHeight / this.clientInfo.screenWidth;
                if (sizeX * ratio < sizeY) {
                    this.orthoWidth = sizeY / ratio;
                }
                else {
                    this.orthoWidth = sizeX;
                }
            }
        }
        update() {
            if (this.scene.activeCamera !== this) {
                return;
            }
            let startZoomLevel;
            if (!this.targetScreenOffset) {
                this.targetScreenOffset = new Vector2(0, 0);
            }
            if (this.lockRotation && (this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0)) {
                this.inertialPanningX = this.inertialAlphaOffset;
                this.inertialPanningY = -this.inertialBetaOffset;
                this.inertialAlphaOffset = this.inertialBetaOffset = 0;
            }
            if (this.inertialPanningX !== 0 || this.inertialPanningY !== 0) {
                if (!this.lockPanning) {
                    this.inertialOffsetPanningX = this.inertialPanningX;
                    this.inertialOffsetPanningY = this.inertialPanningY;
                }
                this.inertialPanningX = 0;
                this.inertialPanningY = 0;
            }
            if (this.lockZoom && this.inertialRadiusOffset !== 0) {
                this.inertialRadiusOffset = 0;
            }
            if (this.inertialRadiusOffset !== 0) {
                if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                    this.inertialOrthoZoom = this.inertialRadiusOffset;
                    this.inertialRadiusOffset = 0;
                }
                else {
                    startZoomLevel = this.radius;
                    //this.inertialRadiusOffset = 0;  //override so we have full control over the zoom
                    //if (this.inertialRadiusOffset < .001) this.inertialRadiusOffset = .001;
                }
            }
            if (this.inertialOrthoZoom !== 0) {
                startZoomLevel = this.orthoWidth;
            }
            super.update();
            if (this.inertialOffsetPanningX !== 0 || this.inertialOffsetPanningY !== 0) {
                let offset;
                if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                    offset = new Vector2(this.inertialOffsetPanningX * this.orthoWidth, this.inertialOffsetPanningY * this.orthoWidth);
                }
                else {
                    offset = new Vector2(this.inertialOffsetPanningX * this.radius, this.inertialOffsetPanningY * this.radius);
                }
                this.targetScreenOffset.subtractInPlace(offset);
                this.inertialOffsetPanningX *= this.panningInertia;
                this.inertialOffsetPanningY *= this.panningInertia;
            }
            if (this.inertialOrthoZoom !== 0) {
                this.orthoWidth = this.orthoWidth - this.inertialOrthoZoom * this.orthoWidth;
                this.inertialOrthoZoom *= this.panningInertia;
            }
            if (Math.abs(this.inertialOffsetPanningX) < this.speed * Epsilon) {
                this.inertialOffsetPanningX = 0;
            }
            if (Math.abs(this.inertialOffsetPanningY) < this.speed * Epsilon) {
                this.inertialOffsetPanningY = 0;
            }
            if (Math.abs(this.inertialOrthoZoom) < this.speed * Epsilon) {
                this.inertialOrthoZoom = 0;
            }
            // When zooming, adjust the camera pan so you zoom into your mouse position, as long as pan is enabled
            if (!this.lockPanning && startZoomLevel !== undefined) {
                if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                    const zoomChange = (startZoomLevel - this.orthoWidth) / 2;
                    this.targetScreenOffset.x -= zoomChange * this.clientInfo.mouseX;
                    this.targetScreenOffset.y += zoomChange * this.clientInfo.mouseY;
                }
                else {
                    const gamma = Math.tan(this.fov / 2);
                    const zoomChange = startZoomLevel - this.radius;
                    const shiftX = zoomChange * gamma * this.clientInfo.mouseX;
                    const shiftY = zoomChange * gamma * this.clientInfo.mouseY;
                    this.targetScreenOffset.x -= shiftX;
                    this.targetScreenOffset.y += shiftY;
                }
            }
        }
        updateClient() {
            const canvas = this.getEngine().getRenderingCanvas();
            if (!canvas) {
                return;
            }
            const clientRect = canvas.getBoundingClientRect();
            this.clientInfo.screenWidth = clientRect.width;
            this.clientInfo.screenHeight = clientRect.height;
            this.clientInfo.screenLeft = clientRect.left;
            this.clientInfo.screenTop = clientRect.top;
            if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                this.updateOrthographicPosition();
                this.panningSensibility = clientRect.width;
            }
            else {
                const focalLength = clientRect.height / (2 * Math.tan(this.fov / 2));
                this.panningSensibility = focalLength;
            }
            return canvas;
        }
        attachControl(noPreventDefault = false) {
            super.attachControl(noPreventDefault, true);
            if (this.disposeListeners) {
                this.disposeListeners();
            }
            const updateMousePosition = (event) => {
                this.clientInfo.mouseX =
                    ((event.clientX - this.clientInfo.screenLeft) * 2) / this.clientInfo.screenWidth - 1;
                this.clientInfo.mouseY =
                    ((event.clientY - this.clientInfo.screenTop) * 2) / this.clientInfo.screenHeight - 1;
            };
            const canvas = this.updateClient();
            const updateClientWrap = () => this.updateClient();
            if (canvas) {
                window.addEventListener('resize', updateClientWrap);
                canvas.addEventListener('mousemove', updateMousePosition);
                this.disposeListeners = () => {
                    window.removeEventListener('resize', updateClientWrap);
                    canvas.removeEventListener('mousemove', updateMousePosition);
                    this.disposeListeners = undefined;
                };
            }
        }
        _checkLimits() {
            super._checkLimits();
            if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                this.orthoWidth = this.clampOrthoWidth(this.orthoWidth);
            }
        }
        clampOrthoWidth(val) {
            if (this.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                if (this.lowerRadiusLimit != null && val < this.lowerRadiusLimit) {
                    val = this.lowerRadiusLimit;
                }
                if (this.upperRadiusLimit != null && val > this.upperRadiusLimit) {
                    val = this.upperRadiusLimit;
                }
            }
            return val;
        }
        dispose() {
            super.dispose();
            if (this.disposeListeners) {
                this.disposeListeners();
            }
        }
        updateOrthographicPosition() {
            if (this.clientInfo) {
                const ratio = this.clientInfo.screenHeight / this.clientInfo.screenWidth;
                this.orthoRight = this.orthoWidth / 2;
                this.orthoLeft = -this.orthoWidth / 2;
                this.orthoTop = (this.orthoWidth * ratio) / 2;
                this.orthoBottom = (-this.orthoWidth * ratio) / 2;
            }
        }
    }

    const ANIMATION_FPS = 30;
    var eCameraType;
    (function (eCameraType) {
        eCameraType[eCameraType["Universal"] = 0] = "Universal";
        eCameraType[eCameraType["ArcRotate"] = 1] = "ArcRotate";
    })(eCameraType || (eCameraType = {}));
    (function (eCameraOrientation) {
        eCameraOrientation["perspective"] = "perspective";
        eCameraOrientation["front"] = "front";
        eCameraOrientation["left"] = "left";
        eCameraOrientation["back"] = "back";
        eCameraOrientation["right"] = "right";
        eCameraOrientation["top"] = "top";
        eCameraOrientation["bottom"] = "bottom";
    })(exports.eCameraOrientation || (exports.eCameraOrientation = {}));
    class CameraTools {
        get cameraMoving() {
            const camera = this.scene.activeCamera;
            if (this._activeAnimation) {
                return true;
            }
            if (camera instanceof KbArcRotateCamera) {
                return (Math.abs(camera.inertialRadiusOffset) > 0 ||
                    Math.abs(camera.inertialAlphaOffset) > 0 ||
                    Math.abs(camera.inertialBetaOffset) > 0 ||
                    Math.abs(camera.inertialOffsetPanningX) > 0 ||
                    Math.abs(camera.inertialOffsetPanningY) > 0 ||
                    Math.abs(camera.inertialOrthoZoom) > 0);
            }
            if (camera instanceof UniversalCamera) {
                return (Math.abs(camera.cameraDirection.x) > 0 ||
                    Math.abs(camera.cameraDirection.y) > 0 ||
                    Math.abs(camera.cameraDirection.z) > 0 ||
                    Math.abs(camera.cameraRotation.x) > 0 ||
                    Math.abs(camera.cameraRotation.y) > 0);
            }
            return false;
        }
        constructor(scene, canvas, kbViewer) {
            this.scene = scene;
            this.canvas = canvas;
            this.kbViewer = kbViewer;
            this._lastOrientation = exports.eCameraOrientation.perspective;
            this.minVector = new Vector3(0, 0, 0);
            this.maxVector = new Vector3(0, 0, 0);
            this.objectsToScaleWithDistance = new Map();
            this._beforeRender = () => {
                if (this._cameraSettingsChange && scene.activeCamera && this.cameraMoving) {
                    const camera = scene.activeCamera;
                    const changeList = {};
                    copyCameraStateIntoViewpoint(changeList, camera);
                    this._cameraSettingsChange.next(changeList);
                }
            };
            scene.registerBeforeRender(this._beforeRender);
            kbViewer.viewChanged.subscribe(() => {
                const camera = scene.activeCamera;
                if (camera) {
                    if (camera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                        const dist = ((camera.orthoRight || 0) - (camera.orthoLeft || 0)) * 0.6;
                        this.objectsToScaleWithDistance.forEach((param, item) => {
                            if (item.isDisposed()) {
                                this.objectsToScaleWithDistance.delete(item);
                                return;
                            }
                            if (typeof param === 'function') {
                                param(dist, camera.mode);
                            }
                            else {
                                const scaledSize = param * dist;
                                item.scaling.set(scaledSize, scaledSize, scaledSize);
                            }
                        });
                    }
                    else {
                        let cameraPosition;
                        if (camera instanceof WebXRCamera && camera.globalPosition) {
                            cameraPosition = camera.globalPosition;
                        }
                        else if (camera instanceof ArcRotateCamera) {
                            cameraPosition = getCameraPositionWithOffset(camera);
                        }
                        else {
                            cameraPosition = camera.globalPosition;
                        }
                        this.objectsToScaleWithDistance.forEach((param, item) => {
                            if (item.isDisposed()) {
                                this.objectsToScaleWithDistance.delete(item);
                                return;
                            }
                            const dist = item.absolutePosition.subtract(cameraPosition).length();
                            if (typeof param === 'function') {
                                param(dist, camera.mode);
                            }
                            else {
                                const scaledSize = dist * param;
                                item.scaling.set(scaledSize, scaledSize, scaledSize);
                            }
                        });
                    }
                }
            });
            this.activeCamera = {
                get position() {
                    return scene.activeCamera ? exports.KbVector.FromVec3(scene.activeCamera.position) : exports.KbVector.Zero();
                },
                set position(vector) {
                    if (scene.activeCamera) {
                        if (scene.activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA &&
                            scene.activeCamera instanceof ArcRotateCamera) {
                            const target = scene.activeCamera.target;
                            scene.activeCamera.position = vector
                                .toVec3()
                                .subtract(target)
                                .normalize()
                                .scale(5000)
                                .add(target);
                        }
                        else {
                            scene.activeCamera.position = vector.toVec3();
                        }
                    }
                },
                get targetPoint() {
                    return scene.activeCamera instanceof ArcRotateCamera
                        ? exports.KbVector.FromVec3(scene.activeCamera.target)
                        : exports.KbVector.Zero();
                },
                set targetPoint(vector) {
                    scene.activeCamera instanceof ArcRotateCamera && (scene.activeCamera.target = vector.toVec3());
                },
                get rotation() {
                    return scene.activeCamera instanceof UniversalCamera
                        ? exports.KbVector.FromVec3(scene.activeCamera.rotation)
                        : exports.KbVector.Zero();
                },
                set rotation(vector) {
                    scene.activeCamera instanceof UniversalCamera && (scene.activeCamera.rotation = vector.toVec3());
                },
                get offsetX() {
                    return scene.activeCamera instanceof ArcRotateCamera ? scene.activeCamera.targetScreenOffset.x : 0;
                },
                set offsetX(offset) {
                    scene.activeCamera instanceof ArcRotateCamera && (scene.activeCamera.targetScreenOffset.x = offset);
                },
                get offsetY() {
                    return scene.activeCamera instanceof ArcRotateCamera ? scene.activeCamera.targetScreenOffset.y : 0;
                },
                set offsetY(offset) {
                    scene.activeCamera instanceof ArcRotateCamera && (scene.activeCamera.targetScreenOffset.y = offset);
                },
                get projection() {
                    if (!scene.activeCamera) {
                        return undefined;
                    }
                    return scene.activeCamera.mode === Camera.PERSPECTIVE_CAMERA
                        ? exports.eViewpointProjection.perspective
                        : exports.eViewpointProjection.orthographic;
                },
                set projection(projection) {
                    scene.activeCamera &&
                        (scene.activeCamera.mode =
                            projection === exports.eViewpointProjection.perspective
                                ? Camera.PERSPECTIVE_CAMERA
                                : Camera.ORTHOGRAPHIC_CAMERA);
                },
                get fov() {
                    if (!scene.activeCamera) {
                        return 50;
                    }
                    return scene.activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA
                        ? scene.activeCamera.orthoRight - scene.activeCamera.orthoLeft
                        : (scene.activeCamera.fov * 180) / Math.PI;
                },
                set fov(fov) {
                    if (!scene.activeCamera) {
                        return;
                    }
                    if (scene.activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA &&
                        scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.orthoWidth = fov;
                    }
                    else {
                        scene.activeCamera.fov = (fov * Math.PI) / 180;
                    }
                },
                get allowOrbit() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return !scene.activeCamera.lockRotation;
                    }
                    else if (scene.activeCamera instanceof UniversalCamera) {
                        return !!scene.activeCamera.inputs.attached.mouse;
                    }
                    return false;
                },
                set allowOrbit(allow) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.lockRotation = !allow;
                    }
                    else if (scene.activeCamera instanceof UniversalCamera) {
                        scene.activeCamera.inputs.clear();
                        enableFreeLook(scene.activeCamera);
                    }
                },
                get allowPan() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return !scene.activeCamera.lockPanning;
                    }
                    else if (scene.activeCamera instanceof UniversalCamera) {
                        return !!scene.activeCamera.inputs.attached.keyboard;
                    }
                    return false;
                },
                set allowPan(allow) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.lockPanning = !allow;
                    }
                    else if (scene.activeCamera instanceof UniversalCamera) {
                        scene.activeCamera.inputs.clear();
                        enableFreeMove(scene.activeCamera);
                    }
                },
                get allowZoom() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return !scene.activeCamera.lockZoom;
                    }
                    return false;
                },
                set allowZoom(allow) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.lockZoom = !allow;
                    }
                },
                get limitMinimumTargetDistance() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return scene.activeCamera.limitMinimumTargetDistance;
                    }
                    return false;
                },
                set limitMinimumTargetDistance(allow) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.limitMinimumTargetDistance = !allow;
                    }
                },
                get minTargetDistance() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return scene.activeCamera.lowerRadiusLimit || defaults.ViewpointNode.minTargetDistance;
                    }
                    return defaults.ViewpointNode.minTargetDistance;
                },
                set minTargetDistance(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.lowerRadiusLimit = value;
                    }
                },
                get maxTargetDistance() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return scene.activeCamera.upperRadiusLimit || defaults.ViewpointNode.maxTargetDistance;
                    }
                    return defaults.ViewpointNode.maxTargetDistance;
                },
                set maxTargetDistance(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.upperRadiusLimit = value;
                    }
                },
                get orbitAxis() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return exports.KbVector.FromVec3(scene.activeCamera.upVector);
                    }
                    return exports.KbVector.From(defaults.ViewpointNode.orbitAxis);
                },
                set orbitAxis(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.upVector = value.toVec3();
                    }
                },
                get limitMinLatitude() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return ((scene.activeCamera.lowerBetaLimit || 0) * 180) / Math.PI;
                    }
                    return defaults.ViewpointNode.limitMinLatitude;
                },
                set limitMinLatitude(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.lowerBetaLimit = (value * Math.PI) / 180;
                    }
                },
                get limitMaxLatitude() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return (((typeof scene.activeCamera.upperBetaLimit === 'number'
                            ? scene.activeCamera.upperBetaLimit
                            : Math.PI) *
                            180) /
                            Math.PI);
                    }
                    return defaults.ViewpointNode.limitMaxLatitude;
                },
                set limitMaxLatitude(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.upperBetaLimit = (value * Math.PI) / 180;
                    }
                },
                get limitMinLongitude() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return scene.activeCamera.lowerAlphaLimit
                            ? (scene.activeCamera.lowerAlphaLimit * 180) / Math.PI
                            : defaults.ViewpointNode.limitMinLongitude;
                    }
                    return defaults.ViewpointNode.limitMinLongitude;
                },
                set limitMinLongitude(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.lowerAlphaLimit = (value * Math.PI) / 180;
                    }
                },
                get limitMaxLongitude() {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        return scene.activeCamera.upperAlphaLimit
                            ? (scene.activeCamera.upperAlphaLimit * 180) / Math.PI
                            : defaults.ViewpointNode.limitMinLongitude;
                    }
                    return defaults.ViewpointNode.limitMinLongitude;
                },
                set limitMaxLongitude(value) {
                    if (scene.activeCamera instanceof KbArcRotateCamera) {
                        scene.activeCamera.upperAlphaLimit = (value * Math.PI) / 180;
                    }
                },
            };
        }
        dispose() {
            this.scene.unregisterBeforeRender(this._beforeRender);
        }
        setPipeline(pipeline) {
            this.activePipeline = pipeline;
            if (this.scene.activeCamera) {
                this.applyScenePostProcesses(this.scene.activeCamera);
            }
        }
        /** Frames the current active camera to fit the provided mesh node
         * @param node The node to fit on the screen
         * @param padding If provided, pads the node by a percentage of the node's size.
         */
        frameCamera(node, options, camera) {
            const _options = {
                rotate: false,
                pan: true,
                padding: 1,
                zoom: true,
                ...(options || {}),
            };
            const activeCamera = camera || this.scene.activeCamera;
            if (!activeCamera) {
                throw Error('No active camera');
            }
            const bounding = this.kbViewer.bbCache.getWorld(node);
            if (!bounding || bounding.boundingInfo.diagonalLength === 0) {
                return; // no op if the bounding box doesn't exist
            }
            else {
                const childrenBounding = this.kbViewer.sceneNode.getChildren();
                const maxVector = bounding.boundingInfo.boundingBox.maximum;
                const minVector = bounding.boundingInfo.boundingBox.minimum;
                childrenBounding.forEach(element => {
                    var _a, _b;
                    if ((element instanceof exports.AnnotationNode && element.enabled) ||
                        (element instanceof exports.DimensionNode && element.enabled)) {
                        let nodeInfo;
                        if (element instanceof exports.AnnotationNode) {
                            nodeInfo = this.kbViewer.rendererManager.annotation.annotationStore.get(element._dynamicId);
                        }
                        if (element instanceof exports.DimensionNode) {
                            nodeInfo = this.kbViewer.rendererManager.dimension.dimensionStore.get(element._dynamicId);
                        }
                        const minBoundingBox = (_a = nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.meshInfo) === null || _a === void 0 ? void 0 : _a.textContainer.getHierarchyBoundingVectors().min;
                        const maxBoundingBox = (_b = nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.meshInfo) === null || _b === void 0 ? void 0 : _b.textContainer.getHierarchyBoundingVectors().max;
                        if (minBoundingBox && minBoundingBox.x < minVector.x) {
                            minVector.x = minBoundingBox.x;
                        }
                        if (minBoundingBox && minBoundingBox.y < minVector.y) {
                            minVector.y = minBoundingBox.y;
                        }
                        if (minBoundingBox && minBoundingBox.z < minVector.z) {
                            minVector.z = minBoundingBox.z;
                        }
                        if (maxBoundingBox && maxBoundingBox.x > maxVector.x) {
                            maxVector.x = maxBoundingBox.x;
                        }
                        if (maxBoundingBox && maxBoundingBox.y > maxVector.y) {
                            maxVector.y = maxBoundingBox.y;
                        }
                        if (maxBoundingBox && maxBoundingBox.z > maxVector.z) {
                            maxVector.z = maxBoundingBox.z;
                        }
                    }
                });
                this.minVector.set(minVector.x, minVector.y, minVector.z);
                this.maxVector.set(maxVector.x, maxVector.y, maxVector.z);
                bounding.boundingInfo.boundingBox.reConstruct(this.minVector, this.maxVector, bounding.boundingInfo.boundingBox.getWorldMatrix());
                const bbCenter = bounding.center.toVec3();
                const bbCorners = bounding.boundingInfo.boundingBox.vectorsWorld;
                if (activeCamera instanceof UniversalCamera) {
                    activeCamera.setTarget(bbCenter);
                }
                else if (activeCamera instanceof KbArcRotateCamera) {
                    if (_options.rotate) {
                        activeCamera.setTarget(bbCenter);
                        if (_options.pan) {
                            activeCamera.targetScreenOffset.set(0, 0);
                        }
                    }
                    else if (_options.pan) {
                        const cameraRay = activeCamera.getForwardRay();
                        const cameraProjectionTargetPlane = Plane.FromPositionAndNormal(bbCenter, cameraRay.direction);
                        const cameraDistance = cameraRay.intersectsPlane(cameraProjectionTargetPlane);
                        const cameraProjectionTargetPoint = cameraRay.origin.add(cameraRay.direction.scale(cameraDistance));
                        const cameraPositionWorldOffset = cameraProjectionTargetPoint.subtract(bbCenter);
                        const planeProjectionX = Vector3.Cross(cameraRay.direction, Vector3.Up()).normalize();
                        const planeProjectionY = Vector3.Cross(cameraRay.direction, planeProjectionX).normalize();
                        const bbCenterOffset = new Vector2(Vector3.Dot(cameraPositionWorldOffset, planeProjectionX), -Vector3.Dot(cameraPositionWorldOffset, planeProjectionY));
                        activeCamera.targetScreenOffset.copyFrom(bbCenterOffset);
                    }
                    if (_options.zoom) {
                        const clientRect = this.canvas.getBoundingClientRect();
                        const ratio = clientRect.height / clientRect.width;
                        const cameraRay = activeCamera.getForwardRay();
                        const xAxis = Vector3.Cross(cameraRay.direction, Vector3.Up()).normalize();
                        const yAxis = Vector3.Cross(cameraRay.direction, xAxis).normalize();
                        const cameraTruePosition = cameraRay.origin
                            .add(xAxis.scale(-activeCamera.targetScreenOffset.x))
                            .add(yAxis.scale(activeCamera.targetScreenOffset.y));
                        const cameraTrueTarget = activeCamera.target
                            .add(xAxis.scale(-activeCamera.targetScreenOffset.x))
                            .add(yAxis.scale(activeCamera.targetScreenOffset.y));
                        const xPlane = Plane.FromPositionAndNormal(cameraTruePosition, yAxis);
                        const yPlane = Plane.FromPositionAndNormal(cameraTruePosition, xAxis);
                        const padding = 1 + _options.padding / 100;
                        if (activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                            let maxX = 0, maxY = 0;
                            bbCorners.forEach(bbCorner => {
                                const xO = xPlane.signedDistanceTo(bbCorner) * padding;
                                maxX = Math.max(maxX, Math.abs(xO));
                                const yO = yPlane.signedDistanceTo(bbCorner) * padding;
                                maxY = Math.max(maxY, Math.abs(yO));
                            });
                            // The calculated distance is the maximum distance from the centerline to the bounding box corner. So double it to get the total width/height
                            activeCamera.orthoFit(maxY * 2, maxX * 2);
                        }
                        else {
                            let desiredDistance = 0;
                            const fovH = 2 * Math.atan(Math.tan(activeCamera.fov / 2) / ratio);
                            const thV = Math.tan(activeCamera.fov / 2);
                            const thH = Math.tan(fovH / 2);
                            bbCorners.forEach(bbCorner => {
                                const xO = xPlane.signedDistanceTo(bbCorner) * padding;
                                const xP = bbCorner.subtract(cameraTrueTarget).subtract(yAxis.scale(xO));
                                const xA = Math.abs(xO) / thV;
                                const xR = Vector3.Dot(xP, cameraRay.direction.scale(-1)) + xA;
                                desiredDistance = Math.max(desiredDistance, xR);
                                const yO = yPlane.signedDistanceTo(bbCorner) * padding;
                                const yP = bbCorner.subtract(cameraTrueTarget).subtract(xAxis.scale(yO));
                                const yA = Math.abs(yO) / thH;
                                const yR = Vector3.Dot(yP, cameraRay.direction.scale(-1)) + yA;
                                desiredDistance = Math.max(desiredDistance, yR);
                            });
                            activeCamera.radius = Math.max(desiredDistance, 0.001);
                        }
                    }
                }
                this.kbViewer.fireViewChangedOnNextRender(); //render loop won't pick up that the view changed, because no kb3d nodes changes, so we must update it explicitly
            }
        }
        getScreenPositionOfNode(node) {
            if (!this.scene.activeCamera) {
                throw Error('No active camera');
            }
            const bNode = this.kbViewer.getRendererNode(node);
            if (bNode) {
                return nodeToScreen(bNode, this.scene.activeCamera);
            }
        }
        getScreenBoundingBoxOfNode(node) {
            if (!this.scene.activeCamera) {
                throw Error('No active camera');
            }
            const bNode = this.kbViewer.getRendererNode(node);
            if (bNode) {
                return getScreenBoundingBox(bNode, this.scene.activeCamera, true);
            }
        }
        moveCameraToViewpoint(viewpoint) {
            const newCamera = this.createCameraFromViewpoint(viewpoint);
            this._activateCamera(newCamera);
        }
        animateToViewpoint(viewpoint, options) {
            if (!this.scene.activeCamera) {
                throw Error('No active camera');
            }
            let activeCamera = this.scene.activeCamera;
            const _options = {
                duration: 1000,
                ...(options || {}),
            };
            const endFrame = 30 * (_options.duration / 1000);
            const animations = [];
            const ease = new SineEase();
            ease.setEasingMode(SineEase.EASINGMODE_EASEINOUT);
            const circEaseOut = new CircleEase();
            circEaseOut.setEasingMode(CircleEase.EASINGMODE_EASEOUT);
            // Create the new viewpoint converted to an arc rotate camera so we can tween arc rotate properties
            // The arc rotate cameras are easier to animate between nicely.
            const newCameraTarget = this.createCameraFromViewpoint(viewpoint, eCameraType.ArcRotate);
            const newCamera = this.createCameraFromViewpoint(viewpoint);
            if (_options.frame && newCamera instanceof ArcRotateCamera) {
                const target = _options.frameTarget || viewpoint._parentScene;
                if (!target) {
                    throw Error('Cannot frame camera, no target node to frame');
                }
                else {
                    this.frameCamera(target, _options.frameOptions || {}, newCameraTarget);
                    this.frameCamera(target, _options.frameOptions || {}, newCamera);
                }
            }
            if (activeCamera instanceof ArcRotateCamera) {
                if (Math.abs(activeCamera.alpha) > Math.PI * 2) {
                    activeCamera.alpha = activeCamera.alpha % (Math.PI * 2);
                }
            }
            if (activeCamera instanceof UniversalCamera && viewpoint.type != exports.eViewpointType.firstPerson) {
                const orbitRotation = activeCamera.rotationQuaternion
                    ? activeCamera.rotationQuaternion.toEulerAngles()
                    : activeCamera.rotation;
                const ray = activeCamera.getForwardRay(newCameraTarget.radius);
                // If the current camera is a universal camera, convert it to an arc rotate camera as well/
                // The arc rotate target position is placed from the camera at the same distance as the destination viewpoint's target
                activeCamera = new KbArcRotateCamera('temporaryCamera', -(orbitRotation.y + Math.PI / 2), Math.PI / 2 - orbitRotation.x, ray.length, ray.direction.scale(ray.length).add(ray.origin), this.scene);
                activeCamera.fov = this.scene.activeCamera.fov;
                this._activateCamera(activeCamera);
            }
            if (!newCameraTarget) {
                throw Error('Could not create new camera');
            }
            if (activeCamera instanceof UniversalCamera && viewpoint.type === exports.eViewpointType.firstPerson) {
                const targetRotation = new Vector3(0, 0, 0);
                const targetPosition = new Vector3(viewpoint.position.x, viewpoint.position.y, viewpoint.position.z);
                targetRotation.y = (viewpoint.rotation.y * Math.PI) / 180;
                targetRotation.x = (viewpoint.rotation.x * Math.PI) / 180;
                targetRotation.z = (viewpoint.rotation.z * Math.PI) / 180;
                let activeAlpha = activeCamera.rotation.y;
                let targetAlpha = (viewpoint.rotation.y * Math.PI) / 180;
                let arc = 0;
                //Normalizing values to be between -PI and PI
                activeAlpha = normalizeRotation(activeAlpha);
                targetAlpha = normalizeRotation(targetAlpha);
                //calculating shortest arc and seeing if it crosses zero
                //if it does, change the target vector to account for expected direction of animation
                if (activeAlpha > targetAlpha) {
                    arc = activeAlpha - targetAlpha;
                }
                else {
                    arc = targetAlpha - activeAlpha;
                }
                if (arc > Math.PI) {
                    if (activeAlpha < targetAlpha) {
                        targetRotation.y = targetRotation.y - 2 * Math.PI;
                    }
                    else {
                        targetRotation.y = targetRotation.y + 2 * Math.PI;
                    }
                }
                const translateRotation = new Animation('translateCameraRotation', 'rotation', ANIMATION_FPS, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translateRotation.setKeys([
                    { frame: 0, value: activeCamera.rotation },
                    { frame: endFrame, value: targetRotation },
                ]);
                const translatePosition = new Animation('translateCameraPosition', 'position', ANIMATION_FPS, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translatePosition.setKeys([
                    { frame: 0, value: activeCamera.position },
                    { frame: endFrame, value: targetPosition },
                ]);
                const translateFov = new Animation('translateCameraFOV', 'fov', ANIMATION_FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translateFov.setKeys([
                    { frame: 0, value: activeCamera.fov },
                    { frame: endFrame, value: (viewpoint.fov / 180) * Math.PI },
                ]);
                translateRotation.setEasingFunction(ease);
                translatePosition.setEasingFunction(ease);
                translateFov.setEasingFunction(ease);
                animations.push(translateRotation);
                animations.push(translatePosition);
                animations.push(translateFov);
            }
            else if (newCameraTarget instanceof ArcRotateCamera && activeCamera instanceof ArcRotateCamera) {
                // When rotating between two arc rotate cameras, rotate around the target while animating the target
                if (!activeCamera.target.equals(newCameraTarget.target)) {
                    const translateTarget = new Animation('translateCameraTarget', 'target', ANIMATION_FPS, Animation.ANIMATIONTYPE_VECTOR3, Animation.ANIMATIONLOOPMODE_CONSTANT);
                    translateTarget.setKeys([
                        { frame: 0, value: activeCamera.target },
                        { frame: endFrame, value: newCameraTarget.target },
                    ]);
                    animations.push(translateTarget);
                }
                const translateA = new Animation('translateCameraA', 'alpha', ANIMATION_FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
                let crossesZero = false;
                let arc = 0;
                let shortestArc = 0;
                //Normalizing values to be between -PI and PI
                activeCamera.alpha = normalizeRotation(activeCamera.alpha);
                newCameraTarget.alpha = normalizeRotation(newCameraTarget.alpha);
                //calculating shortest arc between two cameras
                if (activeCamera.alpha > newCameraTarget.alpha) {
                    arc = activeCamera.alpha - newCameraTarget.alpha;
                }
                else {
                    arc = newCameraTarget.alpha - activeCamera.alpha;
                }
                if (arc > Math.PI) {
                    shortestArc = 2 * Math.PI - arc;
                    crossesZero = true;
                }
                //altering newCameraTarget to take shortest path
                if (newCameraTarget.alpha > 0 && crossesZero) {
                    newCameraTarget.alpha = activeCamera.alpha - shortestArc;
                }
                else if (newCameraTarget.alpha < 0 && crossesZero) {
                    newCameraTarget.alpha = activeCamera.alpha + shortestArc;
                }
                translateA.setKeys([
                    { frame: 0, value: activeCamera.alpha },
                    { frame: endFrame, value: newCameraTarget.alpha },
                ]);
                const translateB = new Animation('translateCameraB', 'beta', ANIMATION_FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translateB.setKeys([
                    { frame: 0, value: activeCamera.beta },
                    { frame: endFrame, value: newCameraTarget.beta },
                ]);
                const translateR = new Animation('translateCameraR', 'radius', ANIMATION_FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translateR.setKeys([
                    { frame: 0, value: activeCamera.radius },
                    { frame: endFrame, value: newCameraTarget.radius },
                ]);
                const translateOffset = new Animation('translateCameraOffset', 'targetScreenOffset', ANIMATION_FPS, Animation.ANIMATIONTYPE_VECTOR2, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translateOffset.setKeys([
                    { frame: 0, value: activeCamera.targetScreenOffset },
                    { frame: endFrame, value: newCameraTarget.targetScreenOffset },
                ]);
                const translateFov = new Animation('translateCameraFOV', 'fov', ANIMATION_FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
                translateFov.setKeys([
                    { frame: 0, value: activeCamera.fov },
                    { frame: endFrame, value: newCameraTarget.fov },
                ]);
                if (activeCamera instanceof KbArcRotateCamera &&
                    activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA &&
                    newCameraTarget.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                    const translateOrthoWidth = new Animation('translateOrthoWidth', 'orthoWidth', ANIMATION_FPS, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CONSTANT);
                    translateOrthoWidth.setKeys([
                        { frame: 0, value: activeCamera.orthoWidth },
                        { frame: endFrame, value: newCameraTarget.orthoWidth },
                    ]);
                    translateOrthoWidth.setEasingFunction(ease);
                    animations.push(translateOrthoWidth);
                }
                translateA.setEasingFunction(ease);
                translateB.setEasingFunction(ease);
                translateR.setEasingFunction(ease);
                translateOffset.setEasingFunction(ease);
                translateFov.setEasingFunction(circEaseOut);
                animations.push(translateA);
                animations.push(translateB);
                animations.push(translateR);
                animations.push(translateOffset);
                animations.push(translateFov);
            }
            animations.forEach(animation => {
                activeCamera.animations.push(animation);
            });
            return new Promise(resolve => {
                this._activeAnimation = this.scene.beginAnimation(activeCamera, 0, endFrame, false, 1, () => {
                    // on end of animation
                    delete this._activeAnimation;
                    this._activateCamera(newCamera);
                    resolve();
                });
            });
        }
        storeCameraSettings() {
            if (!this.scene.activeCamera) {
                throw Error('No active camera');
            }
            this._storedViewpoint = new exports.ViewpointNode();
            const camera = this.scene.activeCamera;
            copyCameraStateIntoViewpoint(this._storedViewpoint, camera);
        }
        restoreCameraSettings() {
            if (this._storedViewpoint) {
                this.moveCameraToViewpoint(this._storedViewpoint);
            }
            else {
                console.warn('No stored camera settings to restore');
            }
        }
        watch() {
            this._cameraSettingsChange = new Subject();
            return this._cameraSettingsChange.pipe(finalize(() => {
                delete this._cameraSettingsChange;
            }), share());
        }
        maintainNodeScreenSize(renderedNode, relativeSize) {
            this.objectsToScaleWithDistance.set(renderedNode, relativeSize);
        }
        clearMaintainedNodeScreenSize(renderedNode) {
            this.objectsToScaleWithDistance.delete(renderedNode);
        }
        _activateCamera(newCamera) {
            this.scene.cameras.forEach(camera => {
                if (camera !== newCamera) {
                    /**
                     * Don't dispose the whole camera because that goes too hard and disposes all the render target textures and
                     * post processes which messes things up for the next camera that's reusing those things. Instead, just dispose the
                     * parts of the camera we don't need.
                     */
                    camera.onViewMatrixChangedObservable.clear();
                    camera.onProjectionMatrixChangedObservable.clear();
                    camera.onAfterCheckInputsObservable.clear();
                    camera.onRestoreStateObservable.clear();
                    // Inputs
                    if (camera.inputs) {
                        camera.inputs.clear();
                    }
                    // Animations
                    this.scene.stopAnimation(camera);
                    // Remove from scene
                    this.scene.removeCamera(camera);
                    this.scene.getEngine().releaseRenderPassId(camera.renderPassId);
                }
            });
            this.scene.customRenderTargets.forEach(rtt => {
                rtt.activeCamera = newCamera;
            });
            this.applyScenePostProcesses(newCamera);
            newCamera.attachControl(false);
            this.scene.activeCamera = newCamera;
        }
        applyScenePostProcesses(camera) {
            if (this.activePipeline) {
                this.scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this.activePipeline.name, camera);
            }
        }
        createCameraFromViewpoint(viewpoint, convertToCameraType) {
            const viewer = this.kbViewer;
            const bbCache = this.kbViewer.bbCache;
            const sceneNode = this.kbViewer.sceneNode;
            if (this.disposePreviousCamera && !this.disposePreviousCamera.isStopped) {
                this.disposePreviousCamera.next();
                this.disposePreviousCamera.complete();
            }
            const dispose = (this.disposePreviousCamera = new Subject());
            switch (viewpoint.type) {
                case exports.eViewpointType.orbit:
                case exports.eViewpointType.overhead:
                    if (convertToCameraType === eCameraType.Universal) {
                        const universalCamera = new UniversalCamera(viewpoint.id, viewpoint.position.toVec3(), this.scene);
                        // this should be set in the setCommonViewpointProperties
                        // const direction = viewpoint.targetPoint!.subtract(viewpoint.position).toVec3();
                        // universalCamera.rotation = rotationToVector(direction).toEulerAngles();
                        applyViewpointProperties(viewpoint, universalCamera);
                        return universalCamera;
                    }
                    else {
                        const arcRotateCamera = new KbArcRotateCamera(viewpoint.id, 0, 0, 0, viewpoint.targetPoint ? viewpoint.targetPoint.toVec3() : Vector3.Zero(), this.scene);
                        applyViewpointProperties(viewpoint, arcRotateCamera);
                        // overhead camera overrides target
                        if (viewpoint.type === exports.eViewpointType.overhead) {
                            arcRotateCamera.lockRotation = true;
                            arcRotateCamera.target = new Vector3(viewpoint.position.x, 0, viewpoint.position.z);
                        }
                        return arcRotateCamera;
                    }
                case exports.eViewpointType.firstPerson:
                    //case eViewpointType.fixedPosition:
                    if (convertToCameraType === eCameraType.ArcRotate) {
                        const arcRotateCamera = new KbArcRotateCamera(viewpoint.id, 0, 0, 0, viewpoint.position.toVec3(), this.scene);
                        const orbitRotation = viewpoint.rotation.toVec3().scale(Math.PI / 180);
                        applyViewpointProperties(viewpoint, arcRotateCamera);
                        arcRotateCamera.alpha = orbitRotation.y - Math.PI / 2;
                        arcRotateCamera.beta = Math.PI / 2 - orbitRotation.x;
                        arcRotateCamera.radius = 0.0001;
                        return arcRotateCamera;
                    }
                    else {
                        const universalCamera = new UniversalCamera(viewpoint.id, viewpoint.position.toVec3(), this.scene);
                        applyViewpointProperties(viewpoint, universalCamera);
                        return universalCamera;
                    }
            }
            return null;
            function applyViewpointProperties(viewpoint, camera) {
                if (viewpoint.projection === exports.eViewpointProjection.orthographic) {
                    camera.mode = Camera.ORTHOGRAPHIC_CAMERA;
                    camera.maxZ = 200000;
                    if (camera instanceof ArcRotateCamera) {
                        camera.orthoWidth = viewpoint.fov || 8;
                        camera.wheelPrecision = 60;
                        camera.pinchPrecision = 60;
                        camera.setPosition(viewpoint.position.toVec3().subtract(camera.target).normalize().scale(5000).add(camera.target));
                    }
                }
                else if (viewpoint.projection === exports.eViewpointProjection.perspective) {
                    camera.mode = Camera.PERSPECTIVE_CAMERA;
                    camera.fov = (viewpoint.fov * Math.PI) / 180;
                    if (camera instanceof ArcRotateCamera) {
                        camera.wheelDeltaPercentage = 0.01;
                        //camera.wheelPrecision = 10;
                        camera.speed = 0.0001;
                        camera.lowerRadiusLimit = 0.0001;
                        camera.pinchDeltaPercentage = 0.001;
                        camera.setPosition(viewpoint.position.toVec3());
                    }
                }
                if (camera instanceof ArcRotateCamera) {
                    if (!viewpoint.allowOrbit) {
                        camera.lockRotation = true;
                    }
                    if (!viewpoint.allowPan) {
                        camera.lockPanning = true;
                    }
                    if (!viewpoint.allowZoom) {
                        camera.lockZoom = true;
                    }
                    camera.useFramingBehavior = false;
                    camera.targetScreenOffset.x = viewpoint.offsetX;
                    camera.targetScreenOffset.y = viewpoint.offsetY;
                    if (viewpoint.limitMinimumTargetDistance) {
                        viewer.bbCache.rootBoundingBoxChanged
                            .pipe(takeUntil(dispose))
                            .pipe(startWith(null))
                            .subscribe(() => {
                            const bounding = viewer.bbCache.getWorld(sceneNode);
                            if (bounding) {
                                const minVector = new Vector3(bounding.min.x, bounding.min.y, bounding.min.z);
                                const maxVector = new Vector3(bounding.max.x, bounding.max.y, bounding.max.z);
                                const boundingSphere = new BoundingSphere(minVector, maxVector);
                                camera.lowerRadiusLimit = boundingSphere.radiusWorld;
                            }
                            else {
                                camera.lowerRadiusLimit = viewpoint.minTargetDistance;
                            }
                        });
                    }
                    else {
                        camera.lowerRadiusLimit = viewpoint.minTargetDistance;
                    }
                    camera.upperRadiusLimit = viewpoint.maxTargetDistance;
                    if (viewpoint.orbitAxis) {
                        const upVector = viewpoint.orbitAxis.toVec3();
                        if (upVector.length() === 0) {
                            upVector.set(0, 1, 0);
                        }
                        camera.upVector = upVector;
                    }
                    if (viewpoint.limitLngOrbit) {
                        camera.lowerAlphaLimit = (viewpoint.limitMinLongitude * Math.PI) / 180;
                        camera.upperAlphaLimit = (viewpoint.limitMaxLongitude * Math.PI) / 180;
                    }
                    else {
                        camera.lowerAlphaLimit = null;
                        camera.upperAlphaLimit = null;
                    }
                    if (viewpoint.limitLatOrbit) {
                        camera.lowerBetaLimit = (viewpoint.limitMinLatitude * Math.PI) / 180;
                        camera.upperBetaLimit = (viewpoint.limitMaxLatitude * Math.PI) / 180;
                    }
                    else {
                        camera.lowerBetaLimit = 0.001;
                        camera.upperBetaLimit = Math.PI - 0.001;
                    }
                }
                else if (camera instanceof UniversalCamera) {
                    // // For fixed rotation, only allow targeting the camera with the mouse and disable movement.
                    // if (viewpoint.type === eViewpointType.fixedPosition) {
                    //     camera.inputs.clear();
                    //     camera.inputs.addMouse();
                    // }
                    camera.inputs.clear();
                    if (viewpoint.allowPan) {
                        enableFreeMove(camera);
                    }
                    if (viewpoint.allowOrbit) {
                        enableFreeLook(camera);
                    }
                }
                if (viewpoint.targetMode === exports.eViewpointTargetMode.point) {
                    camera.setTarget(viewpoint.targetPoint.toVec3());
                }
                else if (viewpoint.targetMode === exports.eViewpointTargetMode.mesh) {
                    const targetMeshNode = viewpoint._manager.getById(viewpoint.targetMeshId);
                    if (targetMeshNode) {
                        // TODO: When updating to babylon 5.0, use targetHost property for targetting mesh
                        bbCache.rootBoundingBoxChanged.pipe(takeUntil(dispose)).subscribe(() => {
                            const bbInfo = bbCache.getWorld(targetMeshNode);
                            if (bbInfo) {
                                camera.setTarget(bbInfo.center.toVec3());
                            }
                        });
                    }
                }
                else {
                    // rotation
                    if (camera instanceof ArcRotateCamera) {
                        camera.alpha = (viewpoint.rotation.y * Math.PI) / 180; // yaw = longitude
                        camera.beta = (viewpoint.rotation.x * Math.PI) / 180; // pitch = latitude
                    }
                    else {
                        camera.rotation = viewpoint.rotation.toVec3().scale(Math.PI / 180);
                    }
                }
                bbCache
                    .watchForChanges(sceneNode)
                    .pipe(takeUntil(dispose))
                    .subscribe(bbInfo => {
                    var _a;
                    if (bbInfo && bbInfo.boundingInfo.diagonalLength > 0) {
                        const cameraDistance = bbInfo.boundingInfo.diagonalLength * 2;
                        /**
                         * This piece of code is very important. if the maxZ is too small, things will disappear as you zoom out.
                         * If the maxZ is too large, the camera will not have enough buffer and
                         * all kinds of things get messed up - clicking doesn't work, you start getting z-fighting.
                         * Smallest the maxZ should be "10" due to the grid.
                         * However ortho camera should be double that because calculations are made from half of the frame
                         * And perspective camera should also take the camera distance into account (but have some sane multiplier based on the mesh size)
                         */
                        // should we set the minZ here as well, or just hard code it?
                        if (viewpoint.projection === exports.eViewpointProjection.orthographic &&
                            camera instanceof ArcRotateCamera) {
                            camera.setPosition(camera.position
                                .subtract(camera.target)
                                .normalize()
                                .scale(cameraDistance)
                                .add(camera.target));
                            camera.maxZ = Math.max(cameraDistance, 10) * 2;
                        }
                        else if (camera instanceof ArcRotateCamera && camera.upperRadiusLimit) {
                            camera.maxZ = Math.max(Math.max(cameraDistance, 10) * 16, camera.upperRadiusLimit + cameraDistance);
                        }
                        else {
                            camera.maxZ = Math.max(cameraDistance, 10) * 16;
                        }
                        // If maxZ is too high then it breaks clicking because the unprojected rays start returning NaN/Infinity
                        if (camera.maxZ > 200000) {
                            camera.maxZ = 200000;
                        }
                        if ((_a = viewer.rendererManager.sceneRenderer) === null || _a === void 0 ? void 0 : _a.skybox) {
                            // need to resize skybox if it exists, otherwise it will get clipped
                            const scale = camera.maxZ / 2 / SKYBOX_SIZE;
                            viewer.rendererManager.sceneRenderer.skybox.scaling = new Vector3(scale, scale, scale);
                        }
                    }
                });
                camera.onDisposeObservable.add(() => {
                    dispose.next();
                    dispose.complete();
                });
                camera.minZ = 0.01; // hack the camera minz until we have a more automated way to set it
                camera.doNotSerialize = true;
            }
        }
        orient(orientation) {
            const bbCache = this.kbViewer.bbCache;
            if (this._lastOrientation === exports.eCameraOrientation.perspective) {
                this._lastPerspectivePosition = exports.KbVector.From(this.scene.activeCamera.position);
            }
            //get a viewpoint representing the current camera settings
            const viewpoint = new exports.ViewpointNode();
            const camera = this.scene.activeCamera;
            copyCameraStateIntoViewpoint(viewpoint, camera);
            let targetPoint = exports.KbVector.Zero();
            if (viewpoint.targetMode == exports.eViewpointTargetMode.point) {
                targetPoint = viewpoint.targetPoint;
            }
            else if (viewpoint.targetMode == exports.eViewpointTargetMode.mesh) {
                const targetMeshNode = this.kbViewer.sceneNode._manager.getById(viewpoint.targetMeshId);
                if (targetMeshNode) {
                    const bbInfo = bbCache.getWorld(targetMeshNode);
                    if (bbInfo) {
                        targetPoint = bbInfo.center;
                    }
                }
            }
            let distance = viewpoint.position.subtract(targetPoint).length();
            let newPos = targetPoint.toObject();
            if (orientation == exports.eCameraOrientation.top) {
                newPos.y += distance;
            }
            else if (orientation == exports.eCameraOrientation.front) {
                newPos.z += distance;
            }
            else if (orientation == exports.eCameraOrientation.left) {
                newPos.x -= distance;
            }
            else if (orientation == exports.eCameraOrientation.back) {
                newPos.z -= distance;
            }
            else if (orientation == exports.eCameraOrientation.right) {
                newPos.x += distance;
            }
            else if (orientation == exports.eCameraOrientation.bottom) {
                newPos.y -= distance;
            }
            else if (orientation == exports.eCameraOrientation.perspective) {
                const lastLength = this._lastPerspectivePosition.length();
                const ratio = distance / lastLength;
                newPos = this._lastPerspectivePosition.scale(ratio);
            }
            viewpoint.position = exports.KbVector.From(newPos);
            if (orientation != exports.eCameraOrientation.perspective) {
                viewpoint.projection = exports.eViewpointProjection.orthographic;
                viewpoint.allowOrbit = false;
            }
            else {
                viewpoint.projection = exports.eViewpointProjection.perspective;
                viewpoint.allowOrbit = true;
            }
            if (this._lastOrientation === exports.eCameraOrientation.perspective &&
                orientation !== exports.eCameraOrientation.perspective) {
                //switching to orthographic so we need to deal with fov
                viewpoint.fov = 2 * distance * Math.tan(toRadians(viewpoint.fov / 2));
            }
            else if (this._lastOrientation !== exports.eCameraOrientation.perspective &&
                orientation === exports.eCameraOrientation.perspective) {
                const orthoWidth = viewpoint.fov; //in orthographic, fov is the ortho width
                distance = orthoWidth / (2 * Math.tan(toRadians(defaults.ViewpointNode.fov / 2)));
                viewpoint.position = this._lastPerspectivePosition.scale(distance / this._lastPerspectivePosition.length());
                viewpoint.fov = defaults.ViewpointNode.fov;
            }
            viewpoint.offsetX = 0;
            viewpoint.offsetY = 0;
            this.moveCameraToViewpoint(viewpoint);
            this.frameCamera(this.kbViewer.sceneNode, {
                rotate: false,
                pan: true,
                zoom: false,
            });
            this._lastOrientation = orientation;
        }
    }
    function enableFreeLook(camera) {
        camera.inputs.addMouse();
    }
    function enableFreeMove(camera) {
        camera.inputs.addKeyboard();
        camera.inputs.addTouch();
    }
    function copyCameraStateIntoViewpoint(viewpoint, camera) {
        let normalizedPosition = camera.position;
        // If this is an orthographic camera, the real position is set very far away to prevent clipping. So normalize the position so the biggest dimension is 5.
        if (camera instanceof ArcRotateCamera && camera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
            normalizedPosition = normalizedPosition.subtract(camera.position).normalize().add(camera.position);
            if (normalizedPosition.length() > 0) {
                const scale = Math.max(...normalizedPosition.asArray().map(dim => Math.abs(dim)));
                normalizedPosition = Vector3.FromArray(normalizedPosition.asArray().map(dim => Math.round((dim / scale) * 500) / 100));
            }
        }
        if (camera instanceof FreeCamera) {
            const rotDegrees = camera.rotation.scale(180 / Math.PI);
            viewpoint.rotation = exports.KbVector.FromVec3(rotDegrees);
        }
        viewpoint.position = exports.KbVector.FromVec3(normalizedPosition);
        viewpoint.offsetX = camera instanceof KbArcRotateCamera ? camera.targetScreenOffset.x : 0;
        viewpoint.offsetY = camera instanceof KbArcRotateCamera ? camera.targetScreenOffset.y : 0;
        viewpoint.fov =
            camera.mode === Camera.ORTHOGRAPHIC_CAMERA
                ? camera.orthoRight - camera.orthoLeft
                : (camera.fov * 180) / Math.PI;
        viewpoint.projection =
            camera.mode === Camera.ORTHOGRAPHIC_CAMERA
                ? exports.eViewpointProjection.orthographic
                : exports.eViewpointProjection.perspective;
    }
    function normalizeRotation(alpha) {
        const oneRotation = Math.PI * 2;
        const rotations = Math.floor(alpha / oneRotation);
        const radiansToRemove = rotations > 1 ? rotations * oneRotation : 0;
        const normalizedRotation = alpha - radiansToRemove;
        return normalizedRotation;
    }

    /**
     * Class used to store a cell in an octree
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimizeOctrees
     */
    class OctreeBlock {
        /**
         * Creates a new block
         * @param minPoint defines the minimum vector (in world space) of the block's bounding box
         * @param maxPoint defines the maximum vector (in world space) of the block's bounding box
         * @param capacity defines the maximum capacity of this block (if capacity is reached the block will be split into sub blocks)
         * @param depth defines the current depth of this block in the octree
         * @param maxDepth defines the maximal depth allowed (beyond this value, the capacity is ignored)
         * @param creationFunc defines a callback to call when an element is added to the block
         */
        constructor(minPoint, maxPoint, capacity, depth, maxDepth, creationFunc) {
            /**
             * Gets the content of the current block
             */
            this.entries = new Array();
            this._boundingVectors = new Array();
            this._capacity = capacity;
            this._depth = depth;
            this._maxDepth = maxDepth;
            this._creationFunc = creationFunc;
            this._minPoint = minPoint;
            this._maxPoint = maxPoint;
            this._boundingVectors.push(minPoint.clone());
            this._boundingVectors.push(maxPoint.clone());
            this._boundingVectors.push(minPoint.clone());
            this._boundingVectors[2].x = maxPoint.x;
            this._boundingVectors.push(minPoint.clone());
            this._boundingVectors[3].y = maxPoint.y;
            this._boundingVectors.push(minPoint.clone());
            this._boundingVectors[4].z = maxPoint.z;
            this._boundingVectors.push(maxPoint.clone());
            this._boundingVectors[5].z = minPoint.z;
            this._boundingVectors.push(maxPoint.clone());
            this._boundingVectors[6].x = minPoint.x;
            this._boundingVectors.push(maxPoint.clone());
            this._boundingVectors[7].y = minPoint.y;
        }
        // Property
        /**
         * Gets the maximum capacity of this block (if capacity is reached the block will be split into sub blocks)
         */
        get capacity() {
            return this._capacity;
        }
        /**
         * Gets the minimum vector (in world space) of the block's bounding box
         */
        get minPoint() {
            return this._minPoint;
        }
        /**
         * Gets the maximum vector (in world space) of the block's bounding box
         */
        get maxPoint() {
            return this._maxPoint;
        }
        // Methods
        /**
         * Add a new element to this block
         * @param entry defines the element to add
         */
        addEntry(entry) {
            if (this.blocks) {
                for (let index = 0; index < this.blocks.length; index++) {
                    const block = this.blocks[index];
                    block.addEntry(entry);
                }
                return;
            }
            this._creationFunc(entry, this);
            if (this.entries.length > this.capacity && this._depth < this._maxDepth) {
                this.createInnerBlocks();
            }
        }
        /**
         * Remove an element from this block
         * @param entry defines the element to remove
         */
        removeEntry(entry) {
            if (this.blocks) {
                for (let index = 0; index < this.blocks.length; index++) {
                    const block = this.blocks[index];
                    block.removeEntry(entry);
                }
                return;
            }
            const entryIndex = this.entries.indexOf(entry);
            if (entryIndex > -1) {
                this.entries.splice(entryIndex, 1);
            }
        }
        /**
         * Add an array of elements to this block
         * @param entries defines the array of elements to add
         */
        addEntries(entries) {
            for (let index = 0; index < entries.length; index++) {
                const mesh = entries[index];
                this.addEntry(mesh);
            }
        }
        /**
         * Test if the current block intersects the frustum planes and if yes, then add its content to the selection array
         * @param frustumPlanes defines the frustum planes to test
         * @param selection defines the array to store current content if selection is positive
         * @param allowDuplicate defines if the selection array can contains duplicated entries
         */
        select(frustumPlanes, selection, allowDuplicate) {
            if (BoundingBox.IsInFrustum(this._boundingVectors, frustumPlanes)) {
                if (this.blocks) {
                    for (let index = 0; index < this.blocks.length; index++) {
                        const block = this.blocks[index];
                        block.select(frustumPlanes, selection, allowDuplicate);
                    }
                    return;
                }
                if (allowDuplicate) {
                    selection.concat(this.entries);
                }
                else {
                    selection.concatWithNoDuplicate(this.entries);
                }
            }
        }
        /**
         * Test if the current block intersect with the given bounding sphere and if yes, then add its content to the selection array
         * @param sphereCenter defines the bounding sphere center
         * @param sphereRadius defines the bounding sphere radius
         * @param selection defines the array to store current content if selection is positive
         * @param allowDuplicate defines if the selection array can contains duplicated entries
         */
        intersects(sphereCenter, sphereRadius, selection, allowDuplicate) {
            if (BoundingBox.IntersectsSphere(this._minPoint, this._maxPoint, sphereCenter, sphereRadius)) {
                if (this.blocks) {
                    for (let index = 0; index < this.blocks.length; index++) {
                        const block = this.blocks[index];
                        block.intersects(sphereCenter, sphereRadius, selection, allowDuplicate);
                    }
                    return;
                }
                if (allowDuplicate) {
                    selection.concat(this.entries);
                }
                else {
                    selection.concatWithNoDuplicate(this.entries);
                }
            }
        }
        /**
         * Test if the current block intersect with the given ray and if yes, then add its content to the selection array
         * @param ray defines the ray to test with
         * @param selection defines the array to store current content if selection is positive
         */
        intersectsRay(ray, selection) {
            if (ray.intersectsBoxMinMax(this._minPoint, this._maxPoint)) {
                if (this.blocks) {
                    for (let index = 0; index < this.blocks.length; index++) {
                        const block = this.blocks[index];
                        block.intersectsRay(ray, selection);
                    }
                    return;
                }
                selection.concatWithNoDuplicate(this.entries);
            }
        }
        /**
         * Subdivide the content into child blocks (this block will then be empty)
         */
        createInnerBlocks() {
            OctreeBlock._CreateBlocks(this._minPoint, this._maxPoint, this.entries, this._capacity, this._depth, this._maxDepth, this, this._creationFunc);
            this.entries.splice(0);
        }
        /**
         * @internal
         */
        static _CreateBlocks(worldMin, worldMax, entries, maxBlockCapacity, currentDepth, maxDepth, target, creationFunc) {
            target.blocks = new Array();
            const blockSize = new Vector3((worldMax.x - worldMin.x) / 2, (worldMax.y - worldMin.y) / 2, (worldMax.z - worldMin.z) / 2);
            // Segmenting space
            for (let x = 0; x < 2; x++) {
                for (let y = 0; y < 2; y++) {
                    for (let z = 0; z < 2; z++) {
                        const localMin = worldMin.add(blockSize.multiplyByFloats(x, y, z));
                        const localMax = worldMin.add(blockSize.multiplyByFloats(x + 1, y + 1, z + 1));
                        const block = new OctreeBlock(localMin, localMax, maxBlockCapacity, currentDepth + 1, maxDepth, creationFunc);
                        block.addEntries(entries);
                        target.blocks.push(block);
                    }
                }
            }
        }
    }

    /**
     * Octrees are a really powerful data structure that can quickly select entities based on space coordinates.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimizeOctrees
     */
    class Octree {
        /**
         * Creates a octree
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimizeOctrees
         * @param creationFunc function to be used to instantiate the octree
         * @param maxBlockCapacity defines the maximum number of meshes you want on your octree's leaves (default: 64)
         * @param maxDepth defines the maximum depth (sub-levels) for your octree. Default value is 2, which means 8 8 8 = 512 blocks :) (This parameter takes precedence over capacity.)
         */
        constructor(creationFunc, maxBlockCapacity, 
        /** Defines the maximum depth (sub-levels) for your octree. Default value is 2, which means 8 8 8 = 512 blocks :) (This parameter takes precedence over capacity.) */
        maxDepth = 2) {
            this.maxDepth = maxDepth;
            /**
             * Content stored in the octree
             */
            this.dynamicContent = new Array();
            this._maxBlockCapacity = maxBlockCapacity || 64;
            this._selectionContent = new SmartArrayNoDuplicate(1024);
            this._creationFunc = creationFunc;
        }
        // Methods
        /**
         * Updates the octree by adding blocks for the passed in meshes within the min and max world parameters
         * @param worldMin worldMin for the octree blocks var blockSize = new Vector3((worldMax.x - worldMin.x) / 2, (worldMax.y - worldMin.y) / 2, (worldMax.z - worldMin.z) / 2);
         * @param worldMax worldMax for the octree blocks var blockSize = new Vector3((worldMax.x - worldMin.x) / 2, (worldMax.y - worldMin.y) / 2, (worldMax.z - worldMin.z) / 2);
         * @param entries meshes to be added to the octree blocks
         */
        update(worldMin, worldMax, entries) {
            OctreeBlock._CreateBlocks(worldMin, worldMax, entries, this._maxBlockCapacity, 0, this.maxDepth, this, this._creationFunc);
        }
        /**
         * Adds a mesh to the octree
         * @param entry Mesh to add to the octree
         */
        addMesh(entry) {
            for (let index = 0; index < this.blocks.length; index++) {
                const block = this.blocks[index];
                block.addEntry(entry);
            }
        }
        /**
         * Remove an element from the octree
         * @param entry defines the element to remove
         */
        removeMesh(entry) {
            for (let index = 0; index < this.blocks.length; index++) {
                const block = this.blocks[index];
                block.removeEntry(entry);
            }
        }
        /**
         * Selects an array of meshes within the frustum
         * @param frustumPlanes The frustum planes to use which will select all meshes within it
         * @param allowDuplicate If duplicate objects are allowed in the resulting object array
         * @returns array of meshes within the frustum
         */
        select(frustumPlanes, allowDuplicate) {
            this._selectionContent.reset();
            for (let index = 0; index < this.blocks.length; index++) {
                const block = this.blocks[index];
                block.select(frustumPlanes, this._selectionContent, allowDuplicate);
            }
            if (allowDuplicate) {
                this._selectionContent.concat(this.dynamicContent);
            }
            else {
                this._selectionContent.concatWithNoDuplicate(this.dynamicContent);
            }
            return this._selectionContent;
        }
        /**
         * Test if the octree intersect with the given bounding sphere and if yes, then add its content to the selection array
         * @param sphereCenter defines the bounding sphere center
         * @param sphereRadius defines the bounding sphere radius
         * @param allowDuplicate defines if the selection array can contains duplicated entries
         * @returns an array of objects that intersect the sphere
         */
        intersects(sphereCenter, sphereRadius, allowDuplicate) {
            this._selectionContent.reset();
            for (let index = 0; index < this.blocks.length; index++) {
                const block = this.blocks[index];
                block.intersects(sphereCenter, sphereRadius, this._selectionContent, allowDuplicate);
            }
            if (allowDuplicate) {
                this._selectionContent.concat(this.dynamicContent);
            }
            else {
                this._selectionContent.concatWithNoDuplicate(this.dynamicContent);
            }
            return this._selectionContent;
        }
        /**
         * Test if the octree intersect with the given ray and if yes, then add its content to resulting array
         * @param ray defines the ray to test with
         * @returns array of intersected objects
         */
        intersectsRay(ray) {
            this._selectionContent.reset();
            for (let index = 0; index < this.blocks.length; index++) {
                const block = this.blocks[index];
                block.intersectsRay(ray, this._selectionContent);
            }
            this._selectionContent.concatWithNoDuplicate(this.dynamicContent);
            return this._selectionContent;
        }
    }
    /**
     * Adds a mesh into the octree block if it intersects the block
     * @param entry
     * @param block
     */
    Octree.CreationFuncForMeshes = (entry, block) => {
        const boundingInfo = entry.getBoundingInfo();
        if (!entry.isBlocked && boundingInfo.boundingBox.intersectsMinMax(block.minPoint, block.maxPoint)) {
            block.entries.push(entry);
        }
    };
    /**
     * Adds a submesh into the octree block if it intersects the block
     * @param entry
     * @param block
     */
    Octree.CreationFuncForSubMeshes = (entry, block) => {
        const boundingInfo = entry.getBoundingInfo();
        if (boundingInfo.boundingBox.intersectsMinMax(block.minPoint, block.maxPoint)) {
            block.entries.push(entry);
        }
    };

    const CLICK_THRESHOLD = 8;
    class Dragger {
        constructor(viewer, scene) {
            this.viewer = viewer;
            this.scene = scene;
            this._externalConnectors = new Map(); //connectors out in the scene that are not part of what is being dragged
            this._dragConnectors = new Map(); //connectors that are children of what is being dragged
            this._dragConnectorsByDynamicId = new Map(); //the drag connectors stored by their dynamic id
            this._dropPreviewConnectors = new Map(); //the drop preview is a clone of the dragNode, this tracks the connector meshes in the drop preview
            this._dragFriends = new Set();
            this._dragFriendMeshes = new Array();
            this._dragFriendConnectors = new Set();
            this._matedConnectors = new Set();
        }
        startDrag(pointerArgs, draggable, onComplete) {
            var _a;
            let totalMoved = 0;
            let lastX;
            let lastY;
            this._pointerObserver = this.scene.onPointerObservable.add(p => {
                switch (p.type) {
                    case PointerEventTypes.POINTERMOVE: {
                        let movX = 0;
                        let movY = 0;
                        if (typeof lastX === 'undefined' || typeof lastY === 'undefined') {
                            lastX = p.event.offsetX;
                            lastY = p.event.offsetY;
                        }
                        else {
                            movX = Math.abs(lastX - p.event.offsetX);
                            movY = Math.abs(lastY - p.event.offsetY);
                        }
                        totalMoved += Math.sqrt(movX * movX + movY * movY);
                        if (totalMoved > CLICK_THRESHOLD) {
                            this.startDragCommit(pointerArgs, draggable, onComplete);
                            this.dragging(p);
                        }
                        break;
                    }
                    case PointerEventTypes.POINTERUP: {
                        if (totalMoved > CLICK_THRESHOLD) {
                            this.dropped(p);
                        }
                        this.scene.onPointerObservable.remove(this._pointerObserver);
                        this._pointerObserver = undefined;
                        break;
                    }
                }
            });
            (_a = this.scene.activeCamera) === null || _a === void 0 ? void 0 : _a.detachControl();
        }
        startDragCommit(pointerArgs, draggable, onComplete) {
            if (!this._draggable) {
                this._connectorRenderer = this.viewer.rendererManager.connector;
                this._dragNode = pointerArgs.sourceNode;
                this._dragNodeStartPosition = this._dragNode.position.clone();
                this._dragMesh = this.viewer.rendererManager.mesh.get3d(this._dragNode);
                if (this._dragMesh.parent) {
                    this._dragNodeInverseTransform = this._dragMesh.parent
                        .computeWorldMatrix(true)
                        .clone()
                        .setTranslation(Vector3.Zero())
                        .invert();
                }
                this._draggable = draggable;
                if (this._draggable.connectionMode == null)
                    this._draggable.connectionMode = exports.eConnectionMode.none;
                if (this._draggable.connectionType == null)
                    this._draggable.connectionType = exports.eMateType.fastened;
                if (this._draggable.connectRadius == null) {
                    if (this._draggable.connectionMode == exports.eConnectionMode.screen) {
                        this._draggable.connectRadius = 5; //5 pixels
                    }
                    else {
                        this._draggable.connectRadius = 0.3; //3d units
                    }
                }
                if (this._draggable.dragOpacity == null)
                    this._draggable.dragOpacity = 0.7;
                this._onComplete = onComplete;
                this.setupDragSurface(pointerArgs);
                if (this._draggable.dragStart) {
                    this._draggable.dragStart(this.getDragArgs(pointerArgs, this._dragNodeStartPosition, this._dragMesh.rotationQuaternion));
                }
                this.setupDragFriends();
                this.setupConnectors();
                this.setOpacity(this._draggable.dragOpacity, this._dragMesh, ...this._dragFriendMeshes);
            }
        }
        dragging(p) {
            // this._dragNode._dragging = true;
            const newConnection = this.findConnection();
            //let connectionChanged = !this.connectionsAreEqual(newConnection, this._activeConnection);
            this._activeConnection = newConnection;
            if (this._activeConnection) {
                //if (connectionChanged) { //don't bother processing the connection if it's the same
                this.showDropPreview(this._activeConnection);
                //}
            }
            else {
                this.hideDropPreview();
            }
            this.processDragPosition(p, this._draggable.dragging);
        }
        applyDragResultToNode(node, dragArgs, applyEuler) {
            node.position = dragArgs.newPos;
            // If euler rotation was changed, apply the changed euler rotation. If not, then apply the quaternion rotation regardless of whether it was changed.
            if (applyEuler) {
                node.eulerRotation = dragArgs.newRotationEuler;
                const newKbQuat = exports.KbQuaternion.FromYawPitchRoll(dragArgs.newRotationEuler);
                dragArgs.newRotationAngle = newKbQuat.getAngle();
                dragArgs.newRotationAxis = newKbQuat.getAxis();
                node.rotationAxis = dragArgs.newRotationAxis;
                node.rotationAngle = dragArgs.newRotationAngle;
            }
            else {
                node.rotationAxis = dragArgs.newRotationAxis;
                node.rotationAngle = dragArgs.newRotationAngle;
                node.eulerRotation = exports.KbQuaternion.FromRotationAxis(dragArgs.newRotationAxis, dragArgs.newRotationAngle).toEuler();
            }
        }
        dropped(p) {
            this._dragNode._primeMover = false;
            const complete = new Promise(resolve => {
                if (this._activeConnection) {
                    this._activeConnection.otherConnector._parent._primeMover = true;
                    this.connect(this._activeConnection, this._dragMesh);
                    // let newRotation = KbVector.FromVec3(this._dragMesh.rotation);
                    const dragArgs = {
                        ...this.getDragArgs(p, this._dragMesh.position, this._dragMesh.rotationQuaternion),
                        connection: this._activeConnection,
                    };
                    if (this._draggable.withMates) {
                        dragArgs.mate = this.viewer.sceneNode._manager.create(Token.MateNode, {
                            connector1: this.viewer.sceneNode.getNestedPathTo(dragArgs.connection.otherConnector),
                            connector2: this.viewer.sceneNode.getNestedPathTo(dragArgs.connection.dragConnector),
                            mateType: this._draggable.connectionType,
                        });
                    }
                    const previousEuler = dragArgs.newRotationEuler.clone();
                    this.applyDragResultToNode(this._dragNode, dragArgs, !previousEuler.equal(dragArgs.newRotationEuler));
                    if (dragArgs.mate) {
                        this.viewer.sceneNode.mates.push(dragArgs.mate);
                    }
                    this.viewer.forceAndWaitForNextRender().then(() => {
                        if (this._draggable.dropped) {
                            this._draggable.dropped(dragArgs);
                            if (!dragArgs.allow) {
                                console.warn('Cannot disallow dropping when using connectors, use canConnect handler instead');
                            }
                        }
                        resolve();
                    });
                }
                else {
                    this.processDragPosition(p, this._draggable.dragging);
                    this.processDragPosition(p, this._draggable.dropped);
                    resolve();
                }
            });
            complete.then(() => {
                var _a;
                this.toggleAllConnectors(false);
                this.resetOpacity(this._dragMesh, ...this._dragFriendMeshes);
                (_a = this.scene.activeCamera) === null || _a === void 0 ? void 0 : _a.attachControl(this.viewer.canvas);
                if (this._onComplete)
                    this._onComplete();
                this.disposeDropPreview();
                this._onComplete = undefined;
                this._dragNode = undefined;
                this._dragMesh = undefined;
                this._draggable = undefined;
                this._dragPlane = undefined;
                this._dragSurfaces = undefined;
                this._onComplete = undefined;
                if (this._externalConnectors)
                    this._externalConnectors.clear();
                if (this._dragConnectors)
                    this._dragConnectors.clear();
                if (this._dragConnectorsByDynamicId)
                    this._dragConnectorsByDynamicId.clear();
                if (this._dropPreviewConnectors)
                    this._dropPreviewConnectors.clear();
                this._oct = undefined;
                this._quadTree = undefined;
                if (this._quadTree)
                    this._quadTree.items;
                this._dropPreview = undefined;
                this._activeConnection = undefined;
                this._connectorRenderer = undefined;
                if (this._dragFriends)
                    this._dragFriends.clear();
                if (this._dragFriendMeshes)
                    this._dragFriendMeshes.clear();
                if (this._dragFriendConnectors)
                    this._dragFriendConnectors.clear();
                if (this._matedConnectors)
                    this._matedConnectors.clear();
            });
        }
        processDragPosition(p, event) {
            const newMouseIntersect = this.intersectPointerToDragSurface(p);
            if (newMouseIntersect) {
                let newPos;
                if (this._draggable.disableOffset || this._draggable.mode == exports.eDragMode.surface) {
                    newPos = exports.KbVector.FromVec3(newMouseIntersect);
                }
                else {
                    if (this._startMouseIntersect) {
                        const delta = newMouseIntersect.subtract(this._startMouseIntersect);
                        if (this._dragNodeInverseTransform) {
                            Vector3.TransformCoordinatesToRef(delta, this._dragNodeInverseTransform, delta);
                        }
                        newPos = this._dragNodeStartPosition.add(delta);
                    }
                    else {
                        newPos = this._dragNodeStartPosition;
                        this._startMouseIntersect = newMouseIntersect;
                    }
                }
                const dragArgs = this.getDragArgs(p, newPos, this._dragMesh.rotationQuaternion);
                const previousEuler = dragArgs.newRotationEuler.clone();
                if (event) {
                    event(dragArgs);
                }
                if (dragArgs.allow) {
                    this.applyDragResultToNode(this._dragNode, dragArgs, !previousEuler.equal(dragArgs.newRotationEuler));
                }
                return dragArgs;
            }
            return undefined;
        }
        setupDragSurface(p) {
            const d = this._draggable;
            const manager = this._dragNode._manager;
            if (d.mode == exports.eDragMode.plane) {
                // d.planeOrigin = p.pickedPoint!; // d.planeOrigin || this._dragNode.position;
                /** intersection plane is defined by the pickedPoint and the plane normal */
                d.planeNormal = d.planeNormal || new exports.KbVector(0, 1, 0);
                this._dragPlane = Plane.FromPositionAndNormal(p.pickInfo.pickedPoint, d.planeNormal.toVec3());
            }
            else if (d.mode == exports.eDragMode.free) {
                const cameraDirection = this.scene.activeCamera.position.subtract(this._dragMesh.getAbsolutePosition());
                this._dragPlane = Plane.FromPositionAndNormal(this._dragNode.position.toVec3(), cameraDirection);
            }
            else if (d.mode == exports.eDragMode.surface) {
                const surfaceIds = Array.isArray(d.surfaceNodes) ? d.surfaceNodes : [d.surfaceNodes];
                this._dragSurfaces =
                    surfaceIds.map(sn => { var _a; return sn && ((_a = manager.getById(sn)) === null || _a === void 0 ? void 0 : _a._dynamicId); }).filter(sn => sn != null) ||
                        [];
            }
        }
        intersectPointerToDragSurface(p) {
            return this.intersectDragSurface(p.pickInfo.ray);
        }
        intersectDragSurface(ray) {
            switch (this._draggable.mode) {
                case exports.eDragMode.plane:
                case exports.eDragMode.free: {
                    const distance = ray.intersectsPlane(this._dragPlane);
                    if (distance != null) {
                        return ray.direction.scale(distance).add(ray.origin);
                    }
                    break;
                }
                case exports.eDragMode.surface: {
                    const surfacePick = this.scene.pickWithRay(ray, mesh => {
                        return this._dragSurfaces.some(sn => mesh.id == sn);
                    });
                    if (surfacePick && surfacePick.pickedPoint) {
                        return surfacePick.pickedPoint;
                    }
                    break;
                }
            }
            return undefined;
        }
        getDragArgs(p, newPos, newRotation) {
            var _a, _b;
            const newKbRotation = exports.KbQuaternion.FromQuat(newRotation || Quaternion.Identity());
            return {
                dragNode: this._dragNode,
                startPos: this._dragNodeStartPosition,
                allow: true,
                u: ((_a = p.pickInfo) === null || _a === void 0 ? void 0 : _a.bu) || 0.5,
                v: ((_b = p.pickInfo) === null || _b === void 0 ? void 0 : _b.bv) || 0.5,
                newPos: newPos instanceof Vector3 ? exports.KbVector.FromVec3(newPos) : newPos,
                newRotationAxis: newKbRotation.getAxis(),
                newRotationAngle: newKbRotation.getAngle(),
                newRotationEuler: newKbRotation.toEuler(),
            };
        }
        findConnection() {
            if (this._draggable.connectionMode != exports.eConnectionMode.none) {
                const potentialConnectors = new Array();
                for (const [dragConnector, dragConnectorMesh] of this._dragConnectors) {
                    const dragConPos = dragConnectorMesh.getAbsolutePosition();
                    for (const p of this.intersectOctree(dragConPos)) {
                        potentialConnectors.push({
                            ...p,
                            dragConnector,
                            dragConnectorMesh,
                        });
                    }
                }
                if (this._draggable.connectionMode == exports.eConnectionMode.world) {
                    potentialConnectors.sortBy(p => p.proximity);
                }
                else {
                    potentialConnectors.sortBy(p => p.distanceToCamera);
                }
                for (const p of potentialConnectors) {
                    const otherConnector = getByDynamicId(p.otherMesh.id);
                    const a = {
                        dragConnector: p.dragConnector,
                        otherConnector: otherConnector,
                        dragNode: p.dragConnector._parent,
                        otherNode: otherConnector._parent,
                        allow: true,
                        // Private properties below, don't expose to Snap
                        dragConnectorMesh: p.dragConnectorMesh,
                        otherConnectorMesh: p.otherMesh,
                    };
                    if (this._draggable.canConnect) {
                        this._draggable.canConnect(a);
                    }
                    if (a.allow) {
                        return a;
                    }
                }
            }
        }
        connectionsAreEqual(c1, c2) {
            return ((!c1 && !c2) || (c1 && c2 && c1.dragConnector == c2.dragConnector && c1.otherConnector == c2.otherConnector));
        }
        setupConnectors() {
            if (this._draggable.connectionMode != exports.eConnectionMode.none) {
                const externalConnectorMeshes = new Set();
                for (const c of this.viewer.sceneNode.getAllConnectors()) {
                    if (!this._dragFriendConnectors.has(c) &&
                        (!this._draggable.withMates || !this._matedConnectors.has(c)) &&
                        this.parentsEnabled(c)) {
                        let mesh = this.getConnectorMesh(c);
                        if (!mesh) {
                            this._connectorRenderer.update3d(c);
                            mesh = this.getConnectorMesh(c);
                        }
                        externalConnectorMeshes.add(mesh);
                        this._externalConnectors.set(c, mesh);
                    }
                }
                const dragConnectors = this._dragNode
                    .filterNodes(n => isSpaceNode(n) && n.visible, true, false)
                    .selectMany(n => n.connectors);
                for (const c of dragConnectors) {
                    //remove the drag connectors from the outside connectors
                    if (this._externalConnectors.has(c)) {
                        const mesh = this._externalConnectors.get(c);
                        this._dragConnectors.set(c, mesh);
                        this._dragConnectorsByDynamicId.set(c._dynamicId, c);
                        this._externalConnectors.delete(c);
                        externalConnectorMeshes.delete(mesh);
                    }
                }
                this.toggleAllConnectors(true);
                if (this._draggable.connectionMode == exports.eConnectionMode.world) {
                    //create an octree for holding the connectors
                    this._oct = new Octree(Octree.CreationFuncForMeshes, 64, 2);
                    //get the bounding extents of all the external connectors to contain the octree volume
                    const boundingVectors = this.scene.getWorldExtends(m => externalConnectorMeshes.has(m));
                    //update the octree with the connector meshes
                    this._oct.update(boundingVectors.min, boundingVectors.max, [...externalConnectorMeshes]);
                }
                else {
                    //screen mode
                    const extConnectorPositions = new Array();
                    externalConnectorMeshes.forEach(m => {
                        extConnectorPositions.push({
                            mesh: m,
                            pos: toScreen(m.getAbsolutePosition(), this.scene.activeCamera),
                        });
                    });
                    const engine = this.scene.getEngine();
                    this._quadTree = new QuadTree({
                        items: extConnectorPositions,
                        xSelector: d => d.pos.x,
                        ySelector: d => d.pos.y,
                        capacity: 4,
                        xmin: 0,
                        xmax: engine.getRenderWidth(),
                        ymin: 0,
                        ymax: engine.getRenderHeight(),
                    });
                }
            }
        }
        parentsEnabled(item) {
            while (item._parent && item._parent instanceof exports.SpaceNode) {
                if (!item._parent.visible) {
                    return false;
                }
                item = item._parent;
            }
            return true;
        }
        setupDragFriends() {
            const activeMates = this.viewer.getActiveMates();
            for (const mate of activeMates) {
                const c1 = mate.getC1();
                if (c1 && isConnector(c1))
                    this._matedConnectors.add(c1);
                const c2 = mate.getC2();
                if (c2 && isConnector(c2))
                    this._matedConnectors.add(c2);
            }
            this._dragFriends = getNodeChain(this._dragNode, activeMates);
            this._dragFriends.forEach(friend => {
                if (!(friend instanceof exports.SpaceNode)) {
                    this._dragFriends.delete(friend);
                }
            });
            for (const friendNode of this._dragFriends) {
                if (friendNode instanceof exports.SpaceNode) {
                    friendNode._primeMover = false;
                    const friendMesh = this.viewer.rendererManager.mesh.get3d(friendNode);
                    if (friendMesh) {
                        this._dragFriendMeshes.push(friendMesh);
                    }
                    const connectors = friendNode.filterByType(Token.Connector);
                    for (const c of connectors)
                        this._dragFriendConnectors.add(c);
                }
            }
            this._dragNode._primeMover = true;
        }
        getConnectorMesh(c) {
            return this._connectorRenderer.get3d(c);
        }
        toggleAllConnectors(show) {
            if (this._draggable.showConnectors) {
                for (const [c] of this._externalConnectors) {
                    c._visible = show;
                }
                for (const [c] of this._dragConnectors) {
                    c._visible = show;
                }
            }
        }
        intersectOctree(v) {
            let potentials = new Array();
            if (this._draggable.connectionMode == exports.eConnectionMode.world) {
                const bpotentials = this._oct.intersects(v, this._draggable.connectRadius, false);
                bpotentials.forEach(p => {
                    const proximity = p.getAbsolutePosition().subtract(v).length();
                    if (proximity < this._draggable.connectRadius) {
                        potentials.push({ otherMesh: p, proximity });
                    }
                });
                //potentials.sortBy(p => p.proximity);
            }
            else {
                //screen mode
                const screenPos = toScreen(v, this.scene.activeCamera);
                potentials = this._quadTree.find(screenPos, this._draggable.connectRadius).map(p => {
                    return {
                        otherMesh: p.item.mesh,
                        proximity: p.proximity,
                        distanceToCamera: Vector3.Distance(this.scene.activeCamera.position, p.item.mesh.getAbsolutePosition()),
                    };
                });
                //potentials.sortBy(i => i.distanceToCamera);
                // let ray = this.scene.createPickingRay(screenPos.x, screenPos.y, Matrix.Identity(), this.scene.activeCamera);
                // let bpotentials = this._oct.intersectsRay(ray);
                // bpotentials.forEach(p => {
                //     let potentialScreenPos = toScreen(p.getAbsolutePosition(), this.scene.activeCamera!);
                //     let screenProximity = Math.sqrt(Math.pow(screenPos.x - potentialScreenPos.x, 2) + Math.pow(screenPos.y - potentialScreenPos.y, 2));
                //     let realProximity = p.getAbsolutePosition().subtract(v).length();
                //     console.log({ screenProximity, realProximity });
                //     if (screenProximity < this._draggable.connectRadius!) {
                //         potentials.push({ mesh: p, proximity: screenProximity });
                //     }
                // });
                // potentials.sortBy(p => p.proximity);
            }
            return potentials;
        }
        showDropPreview(c) {
            if (!this._dropPreview) {
                /**
                 * for the drop preview, we get the drag node and any other nodes that are connected to it through mates
                 * and clone them, put them in a transformNode, and then that transform node becomes the drop preview
                 */
                this._dropPreview = new TransformNode('_droppreview', this.viewer.scene);
                this._dropPreview.position = Vector3.Zero();
                this._dropPreview.rotationQuaternion = Quaternion.Identity();
                this._dropPreview.computeWorldMatrix(true);
                const dragMeshTransform = this._dragMesh.computeWorldMatrix(true).getRotationMatrix();
                dragMeshTransform.invert();
                for (const friendMesh of [this._dragMesh, ...this._dragFriendMeshes]) {
                    createDragPreview(friendMesh, this._dropPreview, this);
                }
                this._dropPreview.setPreTransformMatrix(dragMeshTransform);
            }
            else {
                //line drop preview back up with the source models as they might have rotated
                if (this._draggable.connectionType != exports.eMateType.fastened) {
                    this.connect({
                        dragConnector: c.dragConnector,
                        otherConnector: c.dragConnector,
                        otherConnectorMesh: c.dragConnectorMesh,
                        dragConnectorMesh: this._dropPreviewConnectors.get(c.dragConnector), //pass in the drop preview connector mesh
                    }, this._dropPreview, exports.eMateType.fastened, true);
                }
            }
            this.connect({
                ...c,
                dragConnectorMesh: this._dropPreviewConnectors.get(c.dragConnector), //pass in the drop preview connector mesh
            }, this._dropPreview);
            this._dropPreview.setEnabled(true);
            //hide the drag node
            this._dragMesh.setEnabled(false);
            for (const friend of this._dragFriendMeshes)
                friend.setEnabled(false);
            function createDragPreview(mesh, parent, self) {
                const clonedMeshGroup = mesh.clone(mesh.id + '_dropPreview', mesh.parent, true);
                if (clonedMeshGroup) {
                    clonedMeshGroup.setPivotMatrix(Matrix.Identity());
                    // Cloning does not copy the pretransform matrix over so we have to do that manually
                    // Otherwise the connector meshes scaling does not get applied to the preview meshes
                    clonedMeshGroup.setEnabled(mesh.isEnabled());
                    if (c instanceof Mesh && mesh instanceof Mesh) {
                        c.setPreTransformMatrix(mesh.getPivotMatrix());
                    }
                    clonedMeshGroup.setParent(parent); // setting the parent with setParent will make the node stay in the same absolute position.
                    const children = mesh.getChildren(child => child instanceof TransformNode, true);
                    children.forEach(child => {
                        createDragPreview(child, clonedMeshGroup, self);
                    });
                    clonedMeshGroup.metadata = {}; // babylon metadata refers to same instance of object after cloning so we clear it out
                    const kbnode = getByDynamicId(mesh.id);
                    if (kbnode && kbnode instanceof exports.Connector) {
                        const connector = kbnode;
                        self._dropPreviewConnectors.set(connector, clonedMeshGroup);
                        clonedMeshGroup.setEnabled(connector._visible); //connector.enabled && !!this._draggable.showConnectors);
                    }
                    else {
                        self.setOpacity(self._draggable.dragOpacity, clonedMeshGroup);
                    }
                }
            }
        }
        connect(c, followerMesh, mateType = this._draggable.connectionType, flip = false) {
            this.viewer.pauseRenderWhile(() => {
                mateConnectors({
                    mateType: mateType,
                    flip: flip,
                    offsetX: 0,
                    offsetY: 0,
                    offsetZ: 0,
                }, followerMesh, c.otherConnectorMesh, c.dragConnectorMesh);
            });
        }
        hideDropPreview() {
            if (this._dropPreview)
                this._dropPreview.setEnabled(false);
            this._dragMesh.setEnabled(true); //show the drag node again
            if (this._dragFriendMeshes) {
                for (const friend of this._dragFriendMeshes) {
                    friend.setEnabled(getByDynamicId(friend.id).visible);
                }
            }
        }
        disposeDropPreview() {
            this.hideDropPreview();
            if (this._dropPreview)
                this._dropPreview.dispose();
            if (this._dragFriendMeshes)
                this._dragFriendMeshes.clear();
            if (this._dragFriends)
                this._dragFriends.clear();
        }
        getConnectorLocalPoint(connector) {
            if (connector.positionMode == exports.eConnectorPositionMode.absolute) {
                return connector.position;
            }
        }
        setOpacity(value, ...nodes) {
            if (this.shouldSetOpacity()) {
                for (const node of nodes) {
                    for (const m of this.getAllMeshes(node, m => !(m instanceof InstancedMesh))) {
                        //set opacity of all non-connector meshes being dragged
                        if (!m.metadata) {
                            m.metadata = {};
                        }
                        m.metadata.originalVisibility = m.visibility;
                        m.visibility = value;
                    }
                }
            }
        }
        resetOpacity(...nodes) {
            for (const node of nodes) {
                for (const m of this.getAllMeshes(node, m => !(m instanceof InstancedMesh))) {
                    //set opacity of all non-connector meshes being dragged
                    if (m.metadata && m.metadata.originalVisibility !== undefined) {
                        m.visibility = m.metadata.originalVisibility;
                        delete m.metadata.originalVisibility;
                    }
                }
            }
        }
        shouldSetOpacity() {
            return this._draggable.connectionMode != exports.eConnectionMode.none && this._draggable.showConnectors; // && this._dragConnectors.size ;
        }
        /**get's all child meshes and includes the given node if it's a mesh */
        getAllMeshes(node, predicate) {
            const meshes = new Set(node.getChildMeshes(false, predicate));
            if (node instanceof AbstractMesh)
                meshes.add(node);
            return meshes;
        }
    }

    /**
     * Class for generating OBJ data from a Babylon scene.
     */
    class OBJExport {
        /**
         * Exports the geometry of a Mesh array in .OBJ file format (text)
         * @param mesh defines the list of meshes to serialize
         * @param materials defines if materials should be exported
         * @param matlibname defines the name of the associated mtl file
         * @param globalposition defines if the exported positions are globals or local to the exported mesh
         * @returns the OBJ content
         */
        static OBJ(mesh, materials, matlibname, globalposition) {
            const output = [];
            let v = 1;
            // keep track of uv index in case mixed meshes are passed in
            let textureV = 1;
            if (materials) {
                if (!matlibname) {
                    matlibname = "mat";
                }
                output.push("mtllib " + matlibname + ".mtl");
            }
            for (let j = 0; j < mesh.length; j++) {
                output.push("g object" + j);
                output.push("o object_" + j);
                //Uses the position of the item in the scene, to the file (this back to normal in the end)
                let inverseTransform = null;
                if (globalposition) {
                    const transform = mesh[j].computeWorldMatrix(true);
                    inverseTransform = new Matrix();
                    transform.invertToRef(inverseTransform);
                    mesh[j].bakeTransformIntoVertices(transform);
                }
                //TODO: submeshes (groups)
                //TODO: smoothing groups (s 1, s off);
                if (materials) {
                    const mat = mesh[j].material;
                    if (mat) {
                        output.push("usemtl " + mat.id);
                    }
                }
                const g = mesh[j].geometry;
                if (!g) {
                    Tools.Warn("No geometry is present on the mesh");
                    continue;
                }
                const trunkVerts = g.getVerticesData("position");
                const trunkNormals = g.getVerticesData("normal");
                const trunkUV = g.getVerticesData("uv");
                const trunkFaces = g.getIndices();
                let currentV = 0;
                let currentTextureV = 0;
                if (!trunkVerts || !trunkFaces) {
                    Tools.Warn("There are no position vertices or indices on the mesh!");
                    continue;
                }
                for (let i = 0; i < trunkVerts.length; i += 3) {
                    // Babylon.js default is left handed, while OBJ default is right handed
                    // Need to invert Z vertices unless Babylon is set to use a right handed system
                    if (mesh[0].getScene().useRightHandedSystem) {
                        output.push("v " + trunkVerts[i] + " " + trunkVerts[i + 1] + " " + trunkVerts[i + 2]);
                    }
                    else {
                        output.push("v " + trunkVerts[i] + " " + trunkVerts[i + 1] + " " + -trunkVerts[i + 2]);
                    }
                    currentV++;
                }
                if (trunkNormals != null) {
                    for (let i = 0; i < trunkNormals.length; i += 3) {
                        output.push("vn " + trunkNormals[i] + " " + trunkNormals[i + 1] + " " + trunkNormals[i + 2]);
                    }
                }
                if (trunkUV != null) {
                    for (let i = 0; i < trunkUV.length; i += 2) {
                        output.push("vt " + trunkUV[i] + " " + trunkUV[i + 1]);
                        currentTextureV++;
                    }
                }
                for (let i = 0; i < trunkFaces.length; i += 3) {
                    const indices = [String(trunkFaces[i + 2] + v), String(trunkFaces[i + 1] + v), String(trunkFaces[i] + v)];
                    const textureIndices = [String(trunkFaces[i + 2] + textureV), String(trunkFaces[i + 1] + textureV), String(trunkFaces[i] + textureV)];
                    const blanks = ["", "", ""];
                    const facePositions = indices;
                    const faceUVs = trunkUV != null ? textureIndices : blanks;
                    const faceNormals = trunkNormals != null ? indices : blanks;
                    output.push("f " +
                        facePositions[0] +
                        "/" +
                        faceUVs[0] +
                        "/" +
                        faceNormals[0] +
                        " " +
                        facePositions[1] +
                        "/" +
                        faceUVs[1] +
                        "/" +
                        faceNormals[1] +
                        " " +
                        facePositions[2] +
                        "/" +
                        faceUVs[2] +
                        "/" +
                        faceNormals[2]);
                }
                //back de previous matrix, to not change the original mesh in the scene
                if (globalposition && inverseTransform) {
                    mesh[j].bakeTransformIntoVertices(inverseTransform);
                }
                v += currentV;
                textureV += currentTextureV;
            }
            const text = output.join("\n");
            return text;
        }
        /**
         * Exports the material(s) of a mesh in .MTL file format (text)
         * @param mesh defines the mesh to extract the material from
         * @returns the mtl content
         */
        //TODO: Export the materials of mesh array
        static MTL(mesh) {
            const output = [];
            const m = mesh.material;
            output.push("newmtl mat1");
            output.push("  Ns " + m.specularPower.toFixed(4));
            output.push("  Ni 1.5000");
            output.push("  d " + m.alpha.toFixed(4));
            output.push("  Tr 0.0000");
            output.push("  Tf 1.0000 1.0000 1.0000");
            output.push("  illum 2");
            output.push("  Ka " + m.ambientColor.r.toFixed(4) + " " + m.ambientColor.g.toFixed(4) + " " + m.ambientColor.b.toFixed(4));
            output.push("  Kd " + m.diffuseColor.r.toFixed(4) + " " + m.diffuseColor.g.toFixed(4) + " " + m.diffuseColor.b.toFixed(4));
            output.push("  Ks " + m.specularColor.r.toFixed(4) + " " + m.specularColor.g.toFixed(4) + " " + m.specularColor.b.toFixed(4));
            output.push("  Ke " + m.emissiveColor.r.toFixed(4) + " " + m.emissiveColor.g.toFixed(4) + " " + m.emissiveColor.b.toFixed(4));
            //TODO: uv scale, offset, wrap
            //TODO: UV mirrored in Blender? second UV channel? lightMap? reflection textures?
            const uvscale = "";
            if (m.ambientTexture) {
                output.push("  map_Ka " + uvscale + m.ambientTexture.name);
            }
            if (m.diffuseTexture) {
                output.push("  map_Kd " + uvscale + m.diffuseTexture.name);
                //TODO: alpha testing, opacity in diffuse texture alpha channel (diffuseTexture.hasAlpha -> map_d)
            }
            if (m.specularTexture) {
                output.push("  map_Ks " + uvscale + m.specularTexture.name);
                /* TODO: glossiness = specular highlight component is in alpha channel of specularTexture. (???)
                if (m.useGlossinessFromSpecularMapAlpha)  {
                    output.push("  map_Ns "+uvscale + m.specularTexture.name);
                }
                */
            }
            /* TODO: emissive texture not in .MAT format (???)
            if (m.emissiveTexture) {
                output.push("  map_d "+uvscale+m.emissiveTexture.name);
            }
            */
            if (m.bumpTexture) {
                output.push("  map_bump -imfchan z " + uvscale + m.bumpTexture.name);
            }
            if (m.opacityTexture) {
                output.push("  map_d " + uvscale + m.opacityTexture.name);
            }
            const text = output.join("\n");
            return text;
        }
    }

    class ObjKb3dExporter {
        constructor(scene, rendererManager) {
            this.scene = scene;
            this.rendererManager = rendererManager;
        }
        /** generates the current scene into a glb file and returns an object url for it */
        generateObj(meshNode) {
            let meshes;
            if (!meshNode) {
                meshes = this.scene.meshes.filter(this.shouldExportMesh);
            }
            else {
                const mesh = this.rendererManager.mesh.get3d(meshNode);
                if (mesh && mesh instanceof Mesh) {
                    meshes = [mesh];
                }
                else {
                    return null;
                }
            }
            return OBJExport.OBJ(meshes, false, undefined, meshes.length > 1);
        }
        exportObj(filename = 'scene', meshNode) {
            const objData = this.generateObj(meshNode);
            if (objData) {
                const blob = this.createObjBlob(objData);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.setAttribute('type', 'hidden');
                link.download = `${filename}.obj`;
                link.href = window.URL.createObjectURL(blob);
                link.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(link.href);
                    link.remove();
                });
            }
        }
        shouldExportMesh(mesh) {
            return mesh instanceof Mesh && mesh.isVisible && mesh.isEnabled() && !!getByDynamicId(mesh.id);
        }
        createObjBlob(objData) {
            const mimeType = { type: 'text/plain' };
            return new Blob([objData], mimeType);
        }
    }

    // Do not edit.
    const name$2D = "boundingBoxRendererFragmentDeclaration";
    const shader$2D = `uniform vec4 color;
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2D] = shader$2D;

    // Do not edit.
    const name$2E = "boundingBoxRendererUboDeclaration";
    const shader$2E = `#ifdef WEBGL2
uniform vec4 color;uniform mat4 world;uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
#else
layout(std140,column_major) uniform;uniform BoundingBoxRenderer {vec4 color;mat4 world;mat4 viewProjection;mat4 viewProjectionR;};
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2E] = shader$2E;

    // Do not edit.
    const name$2F = "boundingBoxRendererPixelShader";
    const shader$2F = `#include<__decl__boundingBoxRendererFragment>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2F] = shader$2F;

    // Do not edit.
    const name$2G = "boundingBoxRendererVertexDeclaration";
    const shader$2G = `uniform mat4 world;uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
`;
    // Sideeffect
    ShaderStore.IncludesShadersStore[name$2G] = shader$2G;

    // Do not edit.
    const name$2H = "boundingBoxRendererVertexShader";
    const shader$2H = `attribute vec3 position;
#include<__decl__boundingBoxRendererVertex>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec4 worldPos=world*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#define CUSTOM_VERTEX_MAIN_END
}
`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2H] = shader$2H;

    Object.defineProperty(Scene.prototype, "forceShowBoundingBoxes", {
        get: function () {
            return this._forceShowBoundingBoxes || false;
        },
        set: function (value) {
            this._forceShowBoundingBoxes = value;
            // Lazyly creates a BB renderer if needed.
            if (value) {
                this.getBoundingBoxRenderer();
            }
        },
        enumerable: true,
        configurable: true,
    });
    Scene.prototype.getBoundingBoxRenderer = function () {
        if (!this._boundingBoxRenderer) {
            this._boundingBoxRenderer = new BoundingBoxRenderer(this);
        }
        return this._boundingBoxRenderer;
    };
    Object.defineProperty(AbstractMesh.prototype, "showBoundingBox", {
        get: function () {
            return this._showBoundingBox || false;
        },
        set: function (value) {
            this._showBoundingBox = value;
            // Lazyly creates a BB renderer if needed.
            if (value) {
                this.getScene().getBoundingBoxRenderer();
            }
        },
        enumerable: true,
        configurable: true,
    });
    /**
     * Component responsible of rendering the bounding box of the meshes in a scene.
     * This is usually used through the mesh.showBoundingBox or the scene.forceShowBoundingBoxes properties
     */
    class BoundingBoxRenderer {
        /**
         * Instantiates a new bounding box renderer in a scene.
         * @param scene the scene the  renderer renders in
         */
        constructor(scene) {
            /**
             * The component name helpful to identify the component in the list of scene components.
             */
            this.name = SceneComponentConstants.NAME_BOUNDINGBOXRENDERER;
            /**
             * Color of the bounding box lines placed in front of an object
             */
            this.frontColor = new Color3(1, 1, 1);
            /**
             * Color of the bounding box lines placed behind an object
             */
            this.backColor = new Color3(0.1, 0.1, 0.1);
            /**
             * Defines if the renderer should show the back lines or not
             */
            this.showBackLines = true;
            /**
             * Observable raised before rendering a bounding box
             */
            this.onBeforeBoxRenderingObservable = new Observable$1();
            /**
             * Observable raised after rendering a bounding box
             */
            this.onAfterBoxRenderingObservable = new Observable$1();
            /**
             * Observable raised after resources are created
             */
            this.onResourcesReadyObservable = new Observable$1();
            /**
             * When false, no bounding boxes will be rendered
             */
            this.enabled = true;
            /**
             * @internal
             */
            this.renderList = new SmartArray(32);
            this._vertexBuffers = {};
            this._fillIndexBuffer = null;
            this._fillIndexData = null;
            this.scene = scene;
            scene._addComponent(this);
            this._uniformBufferFront = new UniformBuffer(this.scene.getEngine(), undefined, undefined, "BoundingBoxRendererFront", !this.scene.getEngine().isWebGPU);
            this._buildUniformLayout(this._uniformBufferFront);
            this._uniformBufferBack = new UniformBuffer(this.scene.getEngine(), undefined, undefined, "BoundingBoxRendererBack", !this.scene.getEngine().isWebGPU);
            this._buildUniformLayout(this._uniformBufferBack);
        }
        _buildUniformLayout(ubo) {
            ubo.addUniform("color", 4);
            ubo.addUniform("world", 16);
            ubo.addUniform("viewProjection", 16);
            ubo.addUniform("viewProjectionR", 16);
            ubo.create();
        }
        /**
         * Registers the component in a given scene
         */
        register() {
            this.scene._beforeEvaluateActiveMeshStage.registerStep(SceneComponentConstants.STEP_BEFOREEVALUATEACTIVEMESH_BOUNDINGBOXRENDERER, this, this.reset);
            this.scene._preActiveMeshStage.registerStep(SceneComponentConstants.STEP_PREACTIVEMESH_BOUNDINGBOXRENDERER, this, this._preActiveMesh);
            this.scene._evaluateSubMeshStage.registerStep(SceneComponentConstants.STEP_EVALUATESUBMESH_BOUNDINGBOXRENDERER, this, this._evaluateSubMesh);
            this.scene._afterRenderingGroupDrawStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERINGGROUPDRAW_BOUNDINGBOXRENDERER, this, this.render);
        }
        _evaluateSubMesh(mesh, subMesh) {
            if (mesh.showSubMeshesBoundingBox) {
                const boundingInfo = subMesh.getBoundingInfo();
                if (boundingInfo !== null && boundingInfo !== undefined) {
                    boundingInfo.boundingBox._tag = mesh.renderingGroupId;
                    this.renderList.push(boundingInfo.boundingBox);
                }
            }
        }
        _preActiveMesh(mesh) {
            if (mesh.showBoundingBox || this.scene.forceShowBoundingBoxes) {
                const boundingInfo = mesh.getBoundingInfo();
                boundingInfo.boundingBox._tag = mesh.renderingGroupId;
                this.renderList.push(boundingInfo.boundingBox);
            }
        }
        _prepareResources() {
            if (this._colorShader) {
                return;
            }
            this._colorShader = new ShaderMaterial("colorShader", this.scene, "boundingBoxRenderer", {
                attributes: [VertexBuffer.PositionKind],
                uniforms: ["world", "viewProjection", "viewProjectionR", "color"],
                uniformBuffers: ["BoundingBoxRenderer"],
            }, false);
            this._colorShader.doNotSerialize = true;
            this._colorShader.reservedDataStore = {
                hidden: true,
            };
            this._colorShaderForOcclusionQuery = new ShaderMaterial("colorShaderOccQuery", this.scene, "boundingBoxRenderer", {
                attributes: [VertexBuffer.PositionKind],
                uniforms: ["world", "viewProjection", "viewProjectionR", "color"],
                uniformBuffers: ["BoundingBoxRenderer"],
            }, true);
            this._colorShaderForOcclusionQuery.doNotSerialize = true;
            this._colorShaderForOcclusionQuery.reservedDataStore = {
                hidden: true,
            };
            const engine = this.scene.getEngine();
            const boxdata = CreateBoxVertexData({ size: 1.0 });
            this._vertexBuffers[VertexBuffer.PositionKind] = new VertexBuffer(engine, boxdata.positions, VertexBuffer.PositionKind, false);
            this._createIndexBuffer();
            this._fillIndexData = boxdata.indices;
            this.onResourcesReadyObservable.notifyObservers(this);
        }
        _createIndexBuffer() {
            const engine = this.scene.getEngine();
            this._indexBuffer = engine.createIndexBuffer([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 7, 1, 6, 2, 5, 3, 4]);
        }
        /**
         * Rebuilds the elements related to this component in case of
         * context lost for instance.
         */
        rebuild() {
            const vb = this._vertexBuffers[VertexBuffer.PositionKind];
            if (vb) {
                vb._rebuild();
            }
            this._createIndexBuffer();
        }
        /**
         * @internal
         */
        reset() {
            this.renderList.reset();
        }
        /**
         * Render the bounding boxes of a specific rendering group
         * @param renderingGroupId defines the rendering group to render
         */
        render(renderingGroupId) {
            var _a, _b;
            if (this.renderList.length === 0 || !this.enabled) {
                return;
            }
            this._prepareResources();
            if (!this._colorShader.isReady()) {
                return;
            }
            const engine = this.scene.getEngine();
            engine.setDepthWrite(false);
            const transformMatrix = this.scene.getTransformMatrix();
            for (let boundingBoxIndex = 0; boundingBoxIndex < this.renderList.length; boundingBoxIndex++) {
                const boundingBox = this.renderList.data[boundingBoxIndex];
                if (boundingBox._tag !== renderingGroupId) {
                    continue;
                }
                this._createWrappersForBoundingBox(boundingBox);
                this.onBeforeBoxRenderingObservable.notifyObservers(boundingBox);
                const min = boundingBox.minimum;
                const max = boundingBox.maximum;
                const diff = max.subtract(min);
                const median = min.add(diff.scale(0.5));
                const worldMatrix = Matrix.Scaling(diff.x, diff.y, diff.z).multiply(Matrix.Translation(median.x, median.y, median.z)).multiply(boundingBox.getWorldMatrix());
                const useReverseDepthBuffer = engine.useReverseDepthBuffer;
                if (this.showBackLines) {
                    const drawWrapperBack = (_a = boundingBox._drawWrapperBack) !== null && _a !== void 0 ? _a : this._colorShader._getDrawWrapper();
                    this._colorShader._preBind(drawWrapperBack);
                    engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._colorShader.getEffect());
                    // Back
                    if (useReverseDepthBuffer) {
                        engine.setDepthFunctionToLessOrEqual();
                    }
                    else {
                        engine.setDepthFunctionToGreaterOrEqual();
                    }
                    this._uniformBufferBack.bindToEffect(drawWrapperBack.effect, "BoundingBoxRenderer");
                    this._uniformBufferBack.updateColor4("color", this.backColor, 1);
                    this._uniformBufferBack.updateMatrix("world", worldMatrix);
                    this._uniformBufferBack.updateMatrix("viewProjection", transformMatrix);
                    this._uniformBufferBack.update();
                    // Draw order
                    engine.drawElementsType(Material.LineListDrawMode, 0, 24);
                }
                const drawWrapperFront = (_b = boundingBox._drawWrapperFront) !== null && _b !== void 0 ? _b : this._colorShader._getDrawWrapper();
                this._colorShader._preBind(drawWrapperFront);
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._colorShader.getEffect());
                // Front
                if (useReverseDepthBuffer) {
                    engine.setDepthFunctionToGreater();
                }
                else {
                    engine.setDepthFunctionToLess();
                }
                this._uniformBufferFront.bindToEffect(drawWrapperFront.effect, "BoundingBoxRenderer");
                this._uniformBufferFront.updateColor4("color", this.frontColor, 1);
                this._uniformBufferFront.updateMatrix("world", worldMatrix);
                this._uniformBufferFront.updateMatrix("viewProjection", transformMatrix);
                this._uniformBufferFront.update();
                // Draw order
                engine.drawElementsType(Material.LineListDrawMode, 0, 24);
                this.onAfterBoxRenderingObservable.notifyObservers(boundingBox);
            }
            this._colorShader.unbind();
            engine.setDepthFunctionToLessOrEqual();
            engine.setDepthWrite(true);
        }
        _createWrappersForBoundingBox(boundingBox) {
            if (!boundingBox._drawWrapperFront) {
                const engine = this.scene.getEngine();
                boundingBox._drawWrapperFront = new DrawWrapper(engine);
                boundingBox._drawWrapperBack = new DrawWrapper(engine);
                boundingBox._drawWrapperFront.setEffect(this._colorShader.getEffect());
                boundingBox._drawWrapperBack.setEffect(this._colorShader.getEffect());
            }
        }
        /**
         * In case of occlusion queries, we can render the occlusion bounding box through this method
         * @param mesh Define the mesh to render the occlusion bounding box for
         */
        renderOcclusionBoundingBox(mesh) {
            const engine = this.scene.getEngine();
            if (this._renderPassIdForOcclusionQuery === undefined) {
                this._renderPassIdForOcclusionQuery = engine.createRenderPassId(`Render pass for occlusion query`);
            }
            const currentRenderPassId = engine.currentRenderPassId;
            engine.currentRenderPassId = this._renderPassIdForOcclusionQuery;
            this._prepareResources();
            const subMesh = mesh.subMeshes[0];
            if (!this._colorShaderForOcclusionQuery.isReady(mesh, undefined, subMesh) || !mesh.hasBoundingInfo) {
                engine.currentRenderPassId = currentRenderPassId;
                return;
            }
            if (!this._fillIndexBuffer) {
                this._fillIndexBuffer = engine.createIndexBuffer(this._fillIndexData);
            }
            const useReverseDepthBuffer = engine.useReverseDepthBuffer;
            engine.setDepthWrite(false);
            engine.setColorWrite(false);
            const boundingBox = mesh.getBoundingInfo().boundingBox;
            const min = boundingBox.minimum;
            const max = boundingBox.maximum;
            const diff = max.subtract(min);
            const median = min.add(diff.scale(0.5));
            const worldMatrix = Matrix.Scaling(diff.x, diff.y, diff.z).multiply(Matrix.Translation(median.x, median.y, median.z)).multiply(boundingBox.getWorldMatrix());
            const drawWrapper = subMesh._drawWrapper;
            this._colorShaderForOcclusionQuery._preBind(drawWrapper);
            engine.bindBuffers(this._vertexBuffers, this._fillIndexBuffer, drawWrapper.effect);
            if (useReverseDepthBuffer) {
                engine.setDepthFunctionToGreater();
            }
            else {
                engine.setDepthFunctionToLess();
            }
            this.scene.resetCachedMaterial();
            this._uniformBufferFront.bindToEffect(drawWrapper.effect, "BoundingBoxRenderer");
            this._uniformBufferFront.updateMatrix("world", worldMatrix);
            this._uniformBufferFront.updateMatrix("viewProjection", this.scene.getTransformMatrix());
            this._uniformBufferFront.update();
            engine.drawElementsType(Material.TriangleFillMode, 0, 36);
            this._colorShaderForOcclusionQuery.unbind();
            engine.setDepthFunctionToLessOrEqual();
            engine.setDepthWrite(true);
            engine.setColorWrite(true);
            engine.currentRenderPassId = currentRenderPassId;
        }
        /**
         * Dispose and release the resources attached to this renderer.
         */
        dispose() {
            if (this._renderPassIdForOcclusionQuery !== undefined) {
                this.scene.getEngine().releaseRenderPassId(this._renderPassIdForOcclusionQuery);
                this._renderPassIdForOcclusionQuery = undefined;
            }
            if (!this._colorShader) {
                return;
            }
            this.onBeforeBoxRenderingObservable.clear();
            this.onAfterBoxRenderingObservable.clear();
            this.onResourcesReadyObservable.clear();
            this.renderList.dispose();
            this._colorShader.dispose();
            this._colorShaderForOcclusionQuery.dispose();
            this._uniformBufferFront.dispose();
            this._uniformBufferBack.dispose();
            const buffer = this._vertexBuffers[VertexBuffer.PositionKind];
            if (buffer) {
                buffer.dispose();
                this._vertexBuffers[VertexBuffer.PositionKind] = null;
            }
            this.scene.getEngine()._releaseBuffer(this._indexBuffer);
            if (this._fillIndexBuffer) {
                this.scene.getEngine()._releaseBuffer(this._fillIndexBuffer);
                this._fillIndexBuffer = null;
            }
        }
    }

    /**
     * Class containing a set of static utilities functions for managing Pivots
     * @internal
     */
    class PivotTools {
        /**
         * @internal
         */
        static _RemoveAndStorePivotPoint(mesh) {
            if (mesh && PivotTools._PivotCached === 0) {
                // Save old pivot and set pivot to 0,0,0
                mesh.getPivotPointToRef(PivotTools._OldPivotPoint);
                PivotTools._PivotPostMultiplyPivotMatrix = mesh._postMultiplyPivotMatrix;
                if (!PivotTools._OldPivotPoint.equalsToFloats(0, 0, 0)) {
                    mesh.setPivotMatrix(Matrix.IdentityReadOnly);
                    PivotTools._OldPivotPoint.subtractToRef(mesh.getPivotPoint(), PivotTools._PivotTranslation);
                    PivotTools._PivotTmpVector.copyFromFloats(1, 1, 1);
                    PivotTools._PivotTmpVector.subtractInPlace(mesh.scaling);
                    PivotTools._PivotTmpVector.multiplyInPlace(PivotTools._PivotTranslation);
                    mesh.position.addInPlace(PivotTools._PivotTmpVector);
                }
            }
            PivotTools._PivotCached++;
        }
        /**
         * @internal
         */
        static _RestorePivotPoint(mesh) {
            if (mesh && !PivotTools._OldPivotPoint.equalsToFloats(0, 0, 0) && PivotTools._PivotCached === 1) {
                mesh.setPivotPoint(PivotTools._OldPivotPoint);
                mesh._postMultiplyPivotMatrix = PivotTools._PivotPostMultiplyPivotMatrix;
                PivotTools._PivotTmpVector.copyFromFloats(1, 1, 1);
                PivotTools._PivotTmpVector.subtractInPlace(mesh.scaling);
                PivotTools._PivotTmpVector.multiplyInPlace(PivotTools._PivotTranslation);
                mesh.position.subtractInPlace(PivotTools._PivotTmpVector);
            }
            this._PivotCached--;
        }
    }
    // Stores the state of the pivot cache (_oldPivotPoint, _pivotTranslation)
    // store/remove pivot point should only be applied during their outermost calls
    PivotTools._PivotCached = 0;
    PivotTools._OldPivotPoint = new Vector3();
    PivotTools._PivotTranslation = new Vector3();
    PivotTools._PivotTmpVector = new Vector3();
    PivotTools._PivotPostMultiplyPivotMatrix = false;

    /**
     * A behavior that when attached to a mesh will allow the mesh to be dragged around the screen based on pointer events
     */
    class PointerDragBehavior {
        /**
         * Get or set the currentDraggingPointerId
         * @deprecated Please use currentDraggingPointerId instead
         */
        get currentDraggingPointerID() {
            return this.currentDraggingPointerId;
        }
        set currentDraggingPointerID(currentDraggingPointerID) {
            this.currentDraggingPointerId = currentDraggingPointerID;
        }
        /**
         *  If the drag behavior will react to drag events (Default: true)
         */
        set enabled(value) {
            if (value != this._enabled) {
                this.onEnabledObservable.notifyObservers(value);
            }
            this._enabled = value;
        }
        get enabled() {
            return this._enabled;
        }
        /**
         * Gets the options used by the behavior
         */
        get options() {
            return this._options;
        }
        /**
         * Sets the options used by the behavior
         */
        set options(options) {
            this._options = options;
        }
        /**
         * Creates a pointer drag behavior that can be attached to a mesh
         * @param options The drag axis or normal of the plane that will be dragged across. If no options are specified the drag plane will always face the ray's origin (eg. camera)
         * @param options.dragAxis
         * @param options.dragPlaneNormal
         */
        constructor(options) {
            this._useAlternatePickedPointAboveMaxDragAngleDragSpeed = -1.1;
            this._activeDragButton = -1;
            /**
             * The maximum tolerated angle between the drag plane and dragging pointer rays to trigger pointer events. Set to 0 to allow any angle (default: 0)
             */
            this.maxDragAngle = 0;
            /**
             * Butttons that can be used to initiate a drag
             */
            this.dragButtons = [0, 1, 2];
            /**
             * @internal
             */
            this._useAlternatePickedPointAboveMaxDragAngle = false;
            /**
             * The id of the pointer that is currently interacting with the behavior (-1 when no pointer is active)
             */
            this.currentDraggingPointerId = -1;
            /**
             * If the behavior is currently in a dragging state
             */
            this.dragging = false;
            /**
             * The distance towards the target drag position to move each frame. This can be useful to avoid jitter. Set this to 1 for no delay. (Default: 0.2)
             */
            this.dragDeltaRatio = 0.2;
            /**
             * If the drag plane orientation should be updated during the dragging (Default: true)
             */
            this.updateDragPlane = true;
            // Debug mode will display drag planes to help visualize behavior
            this._debugMode = false;
            this._moving = false;
            /**
             *  Fires each time the attached mesh is dragged with the pointer
             *  * delta between last drag position and current drag position in world space
             *  * dragDistance along the drag axis
             *  * dragPlaneNormal normal of the current drag plane used during the drag
             *  * dragPlanePoint in world space where the drag intersects the drag plane
             *
             *  (if validatedDrag is used, the position of the attached mesh might not equal dragPlanePoint)
             */
            this.onDragObservable = new Observable$1();
            /**
             *  Fires each time a drag begins (eg. mouse down on mesh)
             *  * dragPlanePoint in world space where the drag intersects the drag plane
             *
             *  (if validatedDrag is used, the position of the attached mesh might not equal dragPlanePoint)
             */
            this.onDragStartObservable = new Observable$1();
            /**
             *  Fires each time a drag ends (eg. mouse release after drag)
             *  * dragPlanePoint in world space where the drag intersects the drag plane
             *
             *  (if validatedDrag is used, the position of the attached mesh might not equal dragPlanePoint)
             */
            this.onDragEndObservable = new Observable$1();
            /**
             *  Fires each time behavior enabled state changes
             */
            this.onEnabledObservable = new Observable$1();
            /**
             *  If the attached mesh should be moved when dragged
             */
            this.moveAttached = true;
            this._enabled = true;
            /**
             * If pointer events should start and release the drag (Default: true)
             */
            this.startAndReleaseDragOnPointerEvents = true;
            /**
             * If camera controls should be detached during the drag
             */
            this.detachCameraControls = true;
            /**
             * If set, the drag plane/axis will be rotated based on the attached mesh's world rotation (Default: true)
             */
            this.useObjectOrientationForDragging = true;
            /**
             * Predicate to determine if it is valid to move the object to a new position when it is moved
             * @param targetPosition
             */
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.validateDrag = (targetPosition) => {
                return true;
            };
            this._tmpVector = new Vector3(0, 0, 0);
            this._alternatePickedPoint = new Vector3(0, 0, 0);
            this._worldDragAxis = new Vector3(0, 0, 0);
            this._targetPosition = new Vector3(0, 0, 0);
            this._attachedToElement = false;
            this._startDragRay = new Ray(new Vector3(), new Vector3());
            this._lastPointerRay = {};
            this._dragDelta = new Vector3();
            // Variables to avoid instantiation in the below method
            this._pointA = new Vector3(0, 0, 0);
            this._pointC = new Vector3(0, 0, 0);
            this._localAxis = new Vector3(0, 0, 0);
            this._lookAt = new Vector3(0, 0, 0);
            this._options = options ? options : {};
            let optionCount = 0;
            if (this._options.dragAxis) {
                optionCount++;
            }
            if (this._options.dragPlaneNormal) {
                optionCount++;
            }
            if (optionCount > 1) {
                throw "Multiple drag modes specified in dragBehavior options. Only one expected";
            }
        }
        /**
         *  The name of the behavior
         */
        get name() {
            return "PointerDrag";
        }
        /**
         *  Initializes the behavior
         */
        init() { }
        /**
         * Attaches the drag behavior the passed in mesh
         * @param ownerNode The mesh that will be dragged around once attached
         * @param predicate Predicate to use for pick filtering
         */
        attach(ownerNode, predicate) {
            this._scene = ownerNode.getScene();
            ownerNode.isNearGrabbable = true;
            this.attachedNode = ownerNode;
            // Initialize drag plane to not interfere with existing scene
            if (!PointerDragBehavior._PlaneScene) {
                if (this._debugMode) {
                    PointerDragBehavior._PlaneScene = this._scene;
                }
                else {
                    PointerDragBehavior._PlaneScene = new Scene(this._scene.getEngine(), { virtual: true });
                    PointerDragBehavior._PlaneScene.detachControl();
                    this._scene.onDisposeObservable.addOnce(() => {
                        PointerDragBehavior._PlaneScene.dispose();
                        PointerDragBehavior._PlaneScene = null;
                    });
                }
            }
            this._dragPlane = CreatePlane("pointerDragPlane", { size: this._debugMode ? 1 : 10000, updatable: false, sideOrientation: Mesh.DOUBLESIDE }, PointerDragBehavior._PlaneScene);
            // State of the drag
            this.lastDragPosition = new Vector3(0, 0, 0);
            const pickPredicate = predicate
                ? predicate
                : (m) => {
                    return this.attachedNode == m || m.isDescendantOf(this.attachedNode);
                };
            this._pointerObserver = this._scene.onPointerObservable.add((pointerInfo) => {
                if (!this.enabled) {
                    // If behavior is disabled before releaseDrag is ever called, call it now.
                    if (this._attachedToElement) {
                        this.releaseDrag();
                    }
                    return;
                }
                if (pointerInfo.type == PointerEventTypes.POINTERDOWN) {
                    if (this.startAndReleaseDragOnPointerEvents &&
                        !this.dragging &&
                        pointerInfo.pickInfo &&
                        pointerInfo.pickInfo.hit &&
                        pointerInfo.pickInfo.pickedMesh &&
                        pointerInfo.pickInfo.pickedPoint &&
                        pointerInfo.pickInfo.ray &&
                        pickPredicate(pointerInfo.pickInfo.pickedMesh)) {
                        if (this._activeDragButton === -1 && this.dragButtons.indexOf(pointerInfo.event.button) !== -1) {
                            this._activeDragButton = pointerInfo.event.button;
                            this._activePointerInfo = pointerInfo;
                            this._startDrag(pointerInfo.event.pointerId, pointerInfo.pickInfo.ray, pointerInfo.pickInfo.pickedPoint);
                        }
                    }
                }
                else if (pointerInfo.type == PointerEventTypes.POINTERUP) {
                    if (this.startAndReleaseDragOnPointerEvents &&
                        this.currentDraggingPointerId == pointerInfo.event.pointerId &&
                        (this._activeDragButton === pointerInfo.event.button || this._activeDragButton === -1)) {
                        this.releaseDrag();
                    }
                }
                else if (pointerInfo.type == PointerEventTypes.POINTERMOVE) {
                    const pointerId = pointerInfo.event.pointerId;
                    // If drag was started with anyMouseID specified, set pointerID to the next mouse that moved
                    if (this.currentDraggingPointerId === PointerDragBehavior._AnyMouseId && pointerId !== PointerDragBehavior._AnyMouseId) {
                        const evt = pointerInfo.event;
                        const isMouseEvent = evt.pointerType === "mouse" || (!this._scene.getEngine().hostInformation.isMobile && evt instanceof MouseEvent);
                        if (isMouseEvent) {
                            if (this._lastPointerRay[this.currentDraggingPointerId]) {
                                this._lastPointerRay[pointerId] = this._lastPointerRay[this.currentDraggingPointerId];
                                delete this._lastPointerRay[this.currentDraggingPointerId];
                            }
                            this.currentDraggingPointerId = pointerId;
                        }
                    }
                    // Keep track of last pointer ray, this is used simulating the start of a drag in startDrag()
                    if (!this._lastPointerRay[pointerId]) {
                        this._lastPointerRay[pointerId] = new Ray(new Vector3(), new Vector3());
                    }
                    if (pointerInfo.pickInfo && pointerInfo.pickInfo.ray) {
                        this._lastPointerRay[pointerId].origin.copyFrom(pointerInfo.pickInfo.ray.origin);
                        this._lastPointerRay[pointerId].direction.copyFrom(pointerInfo.pickInfo.ray.direction);
                        if (this.currentDraggingPointerId == pointerId && this.dragging) {
                            this._moveDrag(pointerInfo.pickInfo.ray);
                        }
                    }
                }
            });
            this._beforeRenderObserver = this._scene.onBeforeRenderObservable.add(() => {
                if (this._moving && this.moveAttached) {
                    let needMatrixUpdate = false;
                    PivotTools._RemoveAndStorePivotPoint(this.attachedNode);
                    // Slowly move mesh to avoid jitter
                    this._targetPosition.subtractToRef(this.attachedNode.absolutePosition, this._tmpVector);
                    this._tmpVector.scaleInPlace(this.dragDeltaRatio);
                    this.attachedNode.getAbsolutePosition().addToRef(this._tmpVector, this._tmpVector);
                    if (this.validateDrag(this._tmpVector)) {
                        this.attachedNode.setAbsolutePosition(this._tmpVector);
                        needMatrixUpdate = true;
                    }
                    PivotTools._RestorePivotPoint(this.attachedNode);
                    if (needMatrixUpdate) {
                        this.attachedNode.computeWorldMatrix();
                    }
                }
            });
        }
        /**
         * Force release the drag action by code.
         */
        releaseDrag() {
            if (this.dragging) {
                this.dragging = false;
                this.onDragEndObservable.notifyObservers({ dragPlanePoint: this.lastDragPosition, pointerId: this.currentDraggingPointerId, pointerInfo: this._activePointerInfo });
            }
            this.currentDraggingPointerId = -1;
            this._activeDragButton = -1;
            this._activePointerInfo = null;
            this._moving = false;
            // Reattach camera controls
            if (this.detachCameraControls && this._attachedToElement && this._scene.activeCamera && !this._scene.activeCamera.leftCamera) {
                if (this._scene.activeCamera.getClassName() === "ArcRotateCamera") {
                    const arcRotateCamera = this._scene.activeCamera;
                    arcRotateCamera.attachControl(arcRotateCamera.inputs ? arcRotateCamera.inputs.noPreventDefault : true, arcRotateCamera._useCtrlForPanning, arcRotateCamera._panningMouseButton);
                }
                else {
                    this._scene.activeCamera.attachControl(this._scene.activeCamera.inputs ? this._scene.activeCamera.inputs.noPreventDefault : true);
                }
                this._attachedToElement = false;
            }
        }
        /**
         * Simulates the start of a pointer drag event on the behavior
         * @param pointerId pointerID of the pointer that should be simulated (Default: Any mouse pointer ID)
         * @param fromRay initial ray of the pointer to be simulated (Default: Ray from camera to attached mesh)
         * @param startPickedPoint picked point of the pointer to be simulated (Default: attached mesh position)
         */
        startDrag(pointerId = PointerDragBehavior._AnyMouseId, fromRay, startPickedPoint) {
            this._startDrag(pointerId, fromRay, startPickedPoint);
            let lastRay = this._lastPointerRay[pointerId];
            if (pointerId === PointerDragBehavior._AnyMouseId) {
                lastRay = this._lastPointerRay[Object.keys(this._lastPointerRay)[0]];
            }
            if (lastRay) {
                // if there was a last pointer ray drag the object there
                this._moveDrag(lastRay);
            }
        }
        _startDrag(pointerId, fromRay, startPickedPoint) {
            if (!this._scene.activeCamera || this.dragging || !this.attachedNode) {
                return;
            }
            PivotTools._RemoveAndStorePivotPoint(this.attachedNode);
            // Create start ray from the camera to the object
            if (fromRay) {
                this._startDragRay.direction.copyFrom(fromRay.direction);
                this._startDragRay.origin.copyFrom(fromRay.origin);
            }
            else {
                this._startDragRay.origin.copyFrom(this._scene.activeCamera.position);
                this.attachedNode.getWorldMatrix().getTranslationToRef(this._tmpVector);
                this._tmpVector.subtractToRef(this._scene.activeCamera.position, this._startDragRay.direction);
            }
            this._updateDragPlanePosition(this._startDragRay, startPickedPoint ? startPickedPoint : this._tmpVector);
            const pickedPoint = this._pickWithRayOnDragPlane(this._startDragRay);
            if (pickedPoint) {
                this.dragging = true;
                this.currentDraggingPointerId = pointerId;
                this.lastDragPosition.copyFrom(pickedPoint);
                this.onDragStartObservable.notifyObservers({ dragPlanePoint: pickedPoint, pointerId: this.currentDraggingPointerId, pointerInfo: this._activePointerInfo });
                this._targetPosition.copyFrom(this.attachedNode.getAbsolutePosition());
                // Detatch camera controls
                if (this.detachCameraControls && this._scene.activeCamera && this._scene.activeCamera.inputs && !this._scene.activeCamera.leftCamera) {
                    if (this._scene.activeCamera.inputs.attachedToElement) {
                        this._scene.activeCamera.detachControl();
                        this._attachedToElement = true;
                    }
                    else {
                        this._attachedToElement = false;
                    }
                }
            }
            else {
                this.releaseDrag();
            }
            PivotTools._RestorePivotPoint(this.attachedNode);
        }
        _moveDrag(ray) {
            this._moving = true;
            const pickedPoint = this._pickWithRayOnDragPlane(ray);
            if (pickedPoint) {
                PivotTools._RemoveAndStorePivotPoint(this.attachedNode);
                if (this.updateDragPlane) {
                    this._updateDragPlanePosition(ray, pickedPoint);
                }
                let dragLength = 0;
                // depending on the drag mode option drag accordingly
                if (this._options.dragAxis) {
                    // Convert local drag axis to world if useObjectOrientationForDragging
                    this.useObjectOrientationForDragging
                        ? Vector3.TransformCoordinatesToRef(this._options.dragAxis, this.attachedNode.getWorldMatrix().getRotationMatrix(), this._worldDragAxis)
                        : this._worldDragAxis.copyFrom(this._options.dragAxis);
                    // Project delta drag from the drag plane onto the drag axis
                    pickedPoint.subtractToRef(this.lastDragPosition, this._tmpVector);
                    dragLength = Vector3.Dot(this._tmpVector, this._worldDragAxis);
                    this._worldDragAxis.scaleToRef(dragLength, this._dragDelta);
                }
                else {
                    dragLength = this._dragDelta.length();
                    pickedPoint.subtractToRef(this.lastDragPosition, this._dragDelta);
                }
                this._targetPosition.addInPlace(this._dragDelta);
                this.onDragObservable.notifyObservers({
                    dragDistance: dragLength,
                    delta: this._dragDelta,
                    dragPlanePoint: pickedPoint,
                    dragPlaneNormal: this._dragPlane.forward,
                    pointerId: this.currentDraggingPointerId,
                    pointerInfo: this._activePointerInfo,
                });
                this.lastDragPosition.copyFrom(pickedPoint);
                PivotTools._RestorePivotPoint(this.attachedNode);
            }
        }
        _pickWithRayOnDragPlane(ray) {
            if (!ray) {
                return null;
            }
            // Calculate angle between plane normal and ray
            let angle = Math.acos(Vector3.Dot(this._dragPlane.forward, ray.direction));
            // Correct if ray is casted from oposite side
            if (angle > Math.PI / 2) {
                angle = Math.PI - angle;
            }
            // If the angle is too perpendicular to the plane pick another point on the plane where it is looking
            if (this.maxDragAngle > 0 && angle > this.maxDragAngle) {
                if (this._useAlternatePickedPointAboveMaxDragAngle) {
                    // Invert ray direction along the towards object axis
                    this._tmpVector.copyFrom(ray.direction);
                    this.attachedNode.absolutePosition.subtractToRef(ray.origin, this._alternatePickedPoint);
                    this._alternatePickedPoint.normalize();
                    this._alternatePickedPoint.scaleInPlace(this._useAlternatePickedPointAboveMaxDragAngleDragSpeed * Vector3.Dot(this._alternatePickedPoint, this._tmpVector));
                    this._tmpVector.addInPlace(this._alternatePickedPoint);
                    // Project resulting vector onto the drag plane and add it to the attached nodes absolute position to get a picked point
                    const dot = Vector3.Dot(this._dragPlane.forward, this._tmpVector);
                    this._dragPlane.forward.scaleToRef(-dot, this._alternatePickedPoint);
                    this._alternatePickedPoint.addInPlace(this._tmpVector);
                    this._alternatePickedPoint.addInPlace(this.attachedNode.absolutePosition);
                    return this._alternatePickedPoint;
                }
                else {
                    return null;
                }
            }
            const pickResult = PointerDragBehavior._PlaneScene.pickWithRay(ray, (m) => {
                return m == this._dragPlane;
            });
            if (pickResult && pickResult.hit && pickResult.pickedMesh && pickResult.pickedPoint) {
                return pickResult.pickedPoint;
            }
            else {
                return null;
            }
        }
        // Position the drag plane based on the attached mesh position, for single axis rotate the plane along the axis to face the camera
        _updateDragPlanePosition(ray, dragPlanePosition) {
            this._pointA.copyFrom(dragPlanePosition);
            if (this._options.dragAxis) {
                this.useObjectOrientationForDragging
                    ? Vector3.TransformCoordinatesToRef(this._options.dragAxis, this.attachedNode.getWorldMatrix().getRotationMatrix(), this._localAxis)
                    : this._localAxis.copyFrom(this._options.dragAxis);
                // Calculate plane normal that is the cross product of local axis and (eye-dragPlanePosition)
                ray.origin.subtractToRef(this._pointA, this._pointC);
                this._pointC.normalize();
                if (Math.abs(Vector3.Dot(this._localAxis, this._pointC)) > 0.999) {
                    // the drag axis is colinear with the (eye to position) ray. The cross product will give jittered values.
                    // A new axis vector need to be computed
                    if (Math.abs(Vector3.Dot(Vector3.UpReadOnly, this._pointC)) > 0.999) {
                        this._lookAt.copyFrom(Vector3.Right());
                    }
                    else {
                        this._lookAt.copyFrom(Vector3.UpReadOnly);
                    }
                }
                else {
                    Vector3.CrossToRef(this._localAxis, this._pointC, this._lookAt);
                    // Get perpendicular line from previous result and drag axis to adjust lineB to be perpendicular to camera
                    Vector3.CrossToRef(this._localAxis, this._lookAt, this._lookAt);
                    this._lookAt.normalize();
                }
                this._dragPlane.position.copyFrom(this._pointA);
                this._pointA.addToRef(this._lookAt, this._lookAt);
                this._dragPlane.lookAt(this._lookAt);
            }
            else if (this._options.dragPlaneNormal) {
                this.useObjectOrientationForDragging
                    ? Vector3.TransformCoordinatesToRef(this._options.dragPlaneNormal, this.attachedNode.getWorldMatrix().getRotationMatrix(), this._localAxis)
                    : this._localAxis.copyFrom(this._options.dragPlaneNormal);
                this._dragPlane.position.copyFrom(this._pointA);
                this._pointA.addToRef(this._localAxis, this._lookAt);
                this._dragPlane.lookAt(this._lookAt);
            }
            else {
                this._dragPlane.position.copyFrom(this._pointA);
                this._dragPlane.lookAt(ray.origin);
            }
            // Update the position of the drag plane so it doesn't get out of sync with the node (eg. when moving back and forth quickly)
            this._dragPlane.position.copyFrom(this.attachedNode.getAbsolutePosition());
            this._dragPlane.computeWorldMatrix(true);
        }
        /**
         *  Detaches the behavior from the mesh
         */
        detach() {
            this._lastPointerRay = {};
            if (this.attachedNode) {
                this.attachedNode.isNearGrabbable = false;
            }
            if (this._pointerObserver) {
                this._scene.onPointerObservable.remove(this._pointerObserver);
            }
            if (this._beforeRenderObserver) {
                this._scene.onBeforeRenderObservable.remove(this._beforeRenderObserver);
            }
            if (this._dragPlane) {
                this._dragPlane.dispose();
            }
            this.releaseDrag();
        }
    }
    PointerDragBehavior._AnyMouseId = -2;

    /**
     * Single plane rotation gizmo
     */
    class KbAxisMorphGizmo {
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */
        set scaleRatio(value) {
            this._scaleRatio = value;
        }
        get scaleRatio() {
            return this._scaleRatio;
        }
        set gizmoPosition(value) {
            this._rootMesh.position = value;
        }
        get gizmoPosition() {
            return this._rootMesh.position;
        }
        /**
         * Creates a PlaneRotationGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param color The color of the gizmo
         * @param tessellation Amount of tessellation to be used when creating rotation circles
         */
        constructor(color = Color3.Gray(), gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer, tessellation = 24) {
            this.gizmoLayer = gizmoLayer;
            this.dragActive = false;
            this.direction = new Vector3();
            this._pointerObserver = null;
            this._tempVector = new Vector3();
            this._updateQuat = new Quaternion();
            this._scaleRatio = 1;
            /**
             * Rotation distance in radians that the gizmo will snap to (Default: 0)
             */
            this.snapDistance = 0;
            /**
             * Event that fires each time the gizmo snaps to a new location.
             * * snapDistance is the the change in distance
             */
            this.updateObservable = new Observable$1();
            this._rootMesh = new Mesh('gizmoRootNode', gizmoLayer.utilityLayerScene);
            // Create Material
            const coloredMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            coloredMaterial.emissiveColor = color;
            const wireframeMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            wireframeMaterial.emissiveColor = color;
            wireframeMaterial.alpha = 0.4;
            // coloredMaterial.diffuseColor = color;
            // coloredMaterial.specularColor = color.subtract(new Color3(0.1, 0.1, 0.1));
            const hoverMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            hoverMaterial.emissiveColor = color.add(new Color3(0.3, 0.3, 0.3));
            wireframeMaterial.alpha = 0.6;
            // hoverMaterial.diffuseColor = color.add(new Color3(0.3, 0.3, 0.3));
            // Build mesh to hold axis line
            this.axisMesh = new AbstractMesh('', gizmoLayer.utilityLayerScene);
            this.axisMesh.rotationQuaternion = Quaternion.Identity();
            const line = CylinderBuilder.CreateCylinder('', { diameterTop: 0.01, height: 0.3, diameterBottom: 0.01, tessellation }, gizmoLayer.utilityLayerScene);
            line.material = coloredMaterial;
            line.position.y = 0.375;
            const line2 = CylinderBuilder.CreateCylinder('', { diameterTop: 0.005, height: 0.9, diameterBottom: 0.005, tessellation }, gizmoLayer.utilityLayerScene);
            line2.material = coloredMaterial;
            line2.position.y = -0.225;
            const sphereMesh = SphereBuilder.CreateSphere('', { segments: tessellation, diameter: 0.45 }, gizmoLayer.utilityLayerScene);
            sphereMesh.material = wireframeMaterial;
            this.axisMesh.isPickable = false;
            this.axisMesh.addChild(line);
            this.axisMesh.addChild(line2);
            sphereMesh.addChild(this.axisMesh);
            sphereMesh.scaling.scaleInPlace(1 / 3);
            this._rootMesh.addChild(sphereMesh);
            let lastDragPosition = null;
            // Add drag behavior to handle events when the gizmo is dragged
            this.dragBehavior = new PointerDragBehavior();
            this.dragBehavior.moveAttached = false;
            this.dragBehavior.onDragStartObservable.add(() => {
                this.dragActive = true;
            });
            this.dragBehavior.onDragObservable.add(event => {
                // activeCamera.getForwardRayToRef(forwardRay, 1);
                // const cameraDirection = forwardRay.direction;
                // cameraDirection.rotateByQuaternionToRef(parentMesh.rotationQuaternion!, cameraDirection);
                // cameraDirection.addToRef(event.delta, targetDirection);
                // rotationToVectorToRef(targetDirection, cameraDirection, this._updateQuat);
                // parentMesh.rotationQuaternion!.multiplyInPlace(this._updateQuat);
                // this.updateObservable.notifyObservers({ delta: this._updateQuat });
            });
            this.dragBehavior.onDragEndObservable.add(() => {
                this.dragActive = false;
            });
            this._rootMesh.addBehavior(this.dragBehavior);
            this.dragBehavior.enabled = true;
            this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add(pointerInfo => {
                const isHovered = pointerInfo.pickInfo &&
                    this._rootMesh.getChildMeshes().indexOf(pointerInfo.pickInfo.pickedMesh) != -1;
                sphereMesh.material = isHovered ? hoverMaterial : wireframeMaterial;
                if (pointerInfo.pickInfo && isHovered) {
                    const point = pointerInfo.pickInfo.pickedPoint;
                    if (point) {
                        point.subtractInPlace(this._rootMesh.position);
                        switch (pointerInfo.type) {
                            case PointerEventTypes.POINTERDOWN:
                                lastDragPosition = point.clone();
                                break;
                            case PointerEventTypes.POINTERMOVE:
                                if (lastDragPosition && this.dragActive) {
                                    rotationToVectorToRef(point, lastDragPosition, this._updateQuat);
                                    lastDragPosition.copyFrom(point);
                                    // console.log(point, this._updateQuat);
                                    this.direction.rotateByQuaternionToRef(this._updateQuat, this.direction);
                                    this.updateObservable.notifyObservers({ delta: this._updateQuat });
                                }
                                break;
                        }
                    }
                }
            });
            // let light = gizmoLayer._getSharedGizmoLight();
            // light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes(false));
            this._beforeRenderObserver = this.gizmoLayer.utilityLayerScene.onBeforeRenderObservable.add(() => {
                this._update();
            });
        }
        _update() {
            var _a;
            if (this.direction) {
                this.axisMesh.rotationQuaternion = rotationToVector(this.direction);
            }
            const activeCamera = this.gizmoLayer.utilityLayerScene.activeCamera;
            let cameraPosition = activeCamera.globalPosition;
            if (activeCamera.devicePosition) {
                cameraPosition = activeCamera.devicePosition;
            }
            this._rootMesh.position.subtractToRef(cameraPosition, this._tempVector);
            const dist = this._tempVector.length() * this.scaleRatio;
            this._rootMesh.scaling.set(dist, dist, dist);
            // Account for handedness, similar to Matrix.decompose
            if (((_a = this.gizmoLayer.originalScene.meshes[0]) === null || _a === void 0 ? void 0 : _a._getWorldMatrixDeterminant()) < 0) {
                this._rootMesh.scaling.y *= -1;
            }
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
            this._rootMesh.dispose();
            this.dragBehavior.detach();
            if (this._beforeRenderObserver) {
                this.gizmoLayer.utilityLayerScene.onBeforeRenderObservable.remove(this._beforeRenderObserver);
            }
        }
    }

    /**
     * Anchor options where the Gizmo can be positioned in relation to its anchored node
     */
    var GizmoAnchorPoint;
    (function (GizmoAnchorPoint) {
        /** The origin of the attached node */
        GizmoAnchorPoint[GizmoAnchorPoint["Origin"] = 0] = "Origin";
        /** The pivot point of the attached node*/
        GizmoAnchorPoint[GizmoAnchorPoint["Pivot"] = 1] = "Pivot";
    })(GizmoAnchorPoint || (GizmoAnchorPoint = {}));
    /**
     * Coordinates mode: Local or World. Defines how axis is aligned: either on world axis or transform local axis
     */
    var GizmoCoordinatesMode;
    (function (GizmoCoordinatesMode) {
        GizmoCoordinatesMode[GizmoCoordinatesMode["World"] = 0] = "World";
        GizmoCoordinatesMode[GizmoCoordinatesMode["Local"] = 1] = "Local";
    })(GizmoCoordinatesMode || (GizmoCoordinatesMode = {}));
    /**
     * Renders gizmos on top of an existing scene which provide controls for position, rotation, etc.
     */
    class Gizmo {
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */
        set scaleRatio(value) {
            this._scaleRatio = value;
        }
        get scaleRatio() {
            return this._scaleRatio;
        }
        /**
         * True when the mouse pointer is hovered a gizmo mesh
         */
        get isHovered() {
            return this._isHovered;
        }
        /**
         * Mesh that the gizmo will be attached to. (eg. on a drag gizmo the mesh that will be dragged)
         * * When set, interactions will be enabled
         */
        get attachedMesh() {
            return this._attachedMesh;
        }
        set attachedMesh(value) {
            this._attachedMesh = value;
            if (value) {
                this._attachedNode = value;
            }
            this._rootMesh.setEnabled(value ? true : false);
            this._attachedNodeChanged(value);
        }
        /**
         * Node that the gizmo will be attached to. (eg. on a drag gizmo the mesh, bone or NodeTransform that will be dragged)
         * * When set, interactions will be enabled
         */
        get attachedNode() {
            return this._attachedNode;
        }
        set attachedNode(value) {
            this._attachedNode = value;
            this._attachedMesh = null;
            this._rootMesh.setEnabled(value ? true : false);
            this._attachedNodeChanged(value);
        }
        /**
         * Disposes and replaces the current meshes in the gizmo with the specified mesh
         * @param mesh The mesh to replace the default mesh of the gizmo
         */
        setCustomMesh(mesh) {
            if (mesh.getScene() != this.gizmoLayer.utilityLayerScene) {
                throw "When setting a custom mesh on a gizmo, the custom meshes scene must be the same as the gizmos (eg. gizmo.gizmoLayer.utilityLayerScene)";
            }
            this._rootMesh.getChildMeshes().forEach((c) => {
                c.dispose();
            });
            mesh.parent = this._rootMesh;
            this._customMeshSet = true;
        }
        /**
         * If set the gizmo's rotation will be updated to match the attached mesh each frame (Default: true)
         * NOTE: This is only possible for meshes with uniform scaling, as otherwise it's not possible to decompose the rotation
         */
        set updateGizmoRotationToMatchAttachedMesh(value) {
            this._updateGizmoRotationToMatchAttachedMesh = value;
        }
        get updateGizmoRotationToMatchAttachedMesh() {
            return this._updateGizmoRotationToMatchAttachedMesh;
        }
        /**
         * If set the gizmo's position will be updated to match the attached mesh each frame (Default: true)
         */
        set updateGizmoPositionToMatchAttachedMesh(value) {
            this._updateGizmoPositionToMatchAttachedMesh = value;
        }
        get updateGizmoPositionToMatchAttachedMesh() {
            return this._updateGizmoPositionToMatchAttachedMesh;
        }
        /**
         * Defines where the gizmo will be positioned if `updateGizmoPositionToMatchAttachedMesh` is enabled.
         * (Default: GizmoAnchorPoint.Origin)
         */
        set anchorPoint(value) {
            this._anchorPoint = value;
        }
        get anchorPoint() {
            return this._anchorPoint;
        }
        /**
         * Set the coordinate system to use. By default it's local.
         * But it's possible for a user to tweak so its local for translation and world for rotation.
         * In that case, setting the coordinate system will change `updateGizmoRotationToMatchAttachedMesh` and `updateGizmoPositionToMatchAttachedMesh`
         */
        set coordinatesMode(coordinatesMode) {
            this._coordinatesMode = coordinatesMode;
            const local = coordinatesMode == GizmoCoordinatesMode.Local;
            this.updateGizmoRotationToMatchAttachedMesh = local;
            this.updateGizmoPositionToMatchAttachedMesh = local;
        }
        get coordinatesMode() {
            return this._coordinatesMode;
        }
        /**
         * When set, the gizmo will always appear the same size no matter where the camera is (default: true)
         */
        set updateScale(value) {
            this._updateScale = value;
        }
        get updateScale() {
            return this._updateScale;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _attachedNodeChanged(value) { }
        /**
         * Creates a gizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         */
        constructor(
        /** The utility layer the gizmo will be added to */
        gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer) {
            this.gizmoLayer = gizmoLayer;
            this._attachedMesh = null;
            this._attachedNode = null;
            this._customRotationQuaternion = null;
            /**
             * Ratio for the scale of the gizmo (Default: 1)
             */
            this._scaleRatio = 1;
            /**
             * boolean updated by pointermove when a gizmo mesh is hovered
             */
            this._isHovered = false;
            /**
             * If a custom mesh has been set (Default: false)
             */
            this._customMeshSet = false;
            this._updateGizmoRotationToMatchAttachedMesh = true;
            this._updateGizmoPositionToMatchAttachedMesh = true;
            this._anchorPoint = GizmoAnchorPoint.Origin;
            this._updateScale = true;
            this._coordinatesMode = GizmoCoordinatesMode.Local;
            this._interactionsEnabled = true;
            this._rightHandtoLeftHandMatrix = Matrix.RotationY(Math.PI);
            this._rootMesh = new Mesh("gizmoRootNode", gizmoLayer.utilityLayerScene);
            this._rootMesh.rotationQuaternion = Quaternion.Identity();
            this._beforeRenderObserver = this.gizmoLayer.utilityLayerScene.onBeforeRenderObservable.add(() => {
                this._update();
            });
        }
        /**
         * posture that the gizmo will be display
         * When set null, default value will be used (Quaternion(0, 0, 0, 1))
         */
        get customRotationQuaternion() {
            return this._customRotationQuaternion;
        }
        set customRotationQuaternion(customRotationQuaternion) {
            this._customRotationQuaternion = customRotationQuaternion;
        }
        /**
         * Updates the gizmo to match the attached mesh's position/rotation
         */
        _update() {
            if (this.attachedNode) {
                let effectiveNode = this.attachedNode;
                if (this.attachedMesh) {
                    effectiveNode = this.attachedMesh || this.attachedNode;
                }
                // Position
                if (this.updateGizmoPositionToMatchAttachedMesh) {
                    if (this.anchorPoint == GizmoAnchorPoint.Pivot && effectiveNode.getAbsolutePivotPoint) {
                        const position = effectiveNode.getAbsolutePivotPoint();
                        this._rootMesh.position.copyFrom(position);
                    }
                    else {
                        const row = effectiveNode.getWorldMatrix().getRow(3);
                        const position = row ? row.toVector3() : new Vector3(0, 0, 0);
                        this._rootMesh.position.copyFrom(position);
                    }
                }
                // Rotation
                if (this.updateGizmoRotationToMatchAttachedMesh) {
                    const supportedNode = effectiveNode._isMesh ||
                        effectiveNode.getClassName() === "AbstractMesh" ||
                        effectiveNode.getClassName() === "TransformNode" ||
                        effectiveNode.getClassName() === "InstancedMesh";
                    const transformNode = supportedNode ? effectiveNode : undefined;
                    effectiveNode.getWorldMatrix().decompose(undefined, this._rootMesh.rotationQuaternion, undefined, Gizmo.PreserveScaling ? transformNode : undefined);
                }
                else {
                    if (this._customRotationQuaternion) {
                        this._rootMesh.rotationQuaternion.copyFrom(this._customRotationQuaternion);
                    }
                    else {
                        this._rootMesh.rotationQuaternion.set(0, 0, 0, 1);
                    }
                }
                // Scale
                if (this.updateScale) {
                    const activeCamera = this.gizmoLayer.utilityLayerScene.activeCamera;
                    let cameraPosition = activeCamera.globalPosition;
                    if (activeCamera.devicePosition) {
                        cameraPosition = activeCamera.devicePosition;
                    }
                    this._rootMesh.position.subtractToRef(cameraPosition, TmpVectors.Vector3[0]);
                    let scale = this.scaleRatio;
                    if (activeCamera.mode == Camera.ORTHOGRAPHIC_CAMERA) {
                        if (activeCamera.orthoTop && activeCamera.orthoBottom) {
                            const orthoHeight = activeCamera.orthoTop - activeCamera.orthoBottom;
                            scale *= orthoHeight;
                        }
                    }
                    else {
                        const camForward = activeCamera.getScene().useRightHandedSystem ? Vector3.RightHandedForwardReadOnly : Vector3.LeftHandedForwardReadOnly;
                        const direction = activeCamera.getDirection(camForward);
                        scale *= Vector3.Dot(TmpVectors.Vector3[0], direction);
                    }
                    this._rootMesh.scaling.setAll(scale);
                    // Account for handedness, similar to Matrix.decompose
                    if (effectiveNode._getWorldMatrixDeterminant() < 0 && !Gizmo.PreserveScaling) {
                        this._rootMesh.scaling.y *= -1;
                    }
                }
                else {
                    this._rootMesh.scaling.setAll(this.scaleRatio);
                }
            }
        }
        /**
         * Handle position/translation when using an attached node using pivot
         */
        _handlePivot() {
            const attachedNodeTransform = this._attachedNode;
            // check there is an active pivot for the TransformNode attached
            if (attachedNodeTransform.isUsingPivotMatrix && attachedNodeTransform.isUsingPivotMatrix() && attachedNodeTransform.position) {
                // When a TransformNode has an active pivot, even without parenting,
                // translation from the world matrix is different from TransformNode.position.
                // Pivot works like a virtual parent that's using the node orientation.
                // As the world matrix is transformed by the gizmo and then decomposed to TRS
                // its translation part must be set to the Node's position.
                attachedNodeTransform.getWorldMatrix().setTranslation(attachedNodeTransform.position);
            }
        }
        /**
         * computes the rotation/scaling/position of the transform once the Node world matrix has changed.
         */
        _matrixChanged() {
            if (!this._attachedNode) {
                return;
            }
            if (this._attachedNode._isCamera) {
                const camera = this._attachedNode;
                let worldMatrix;
                let worldMatrixUC;
                if (camera.parent) {
                    const parentInv = TmpVectors.Matrix[1];
                    camera.parent._worldMatrix.invertToRef(parentInv);
                    this._attachedNode._worldMatrix.multiplyToRef(parentInv, TmpVectors.Matrix[0]);
                    worldMatrix = TmpVectors.Matrix[0];
                }
                else {
                    worldMatrix = this._attachedNode._worldMatrix;
                }
                if (camera.getScene().useRightHandedSystem) {
                    // avoid desync with RH matrix computation. Otherwise, rotation of PI around Y axis happens each frame resulting in axis flipped because worldMatrix is computed as inverse of viewMatrix.
                    this._rightHandtoLeftHandMatrix.multiplyToRef(worldMatrix, TmpVectors.Matrix[1]);
                    worldMatrixUC = TmpVectors.Matrix[1];
                }
                else {
                    worldMatrixUC = worldMatrix;
                }
                worldMatrixUC.decompose(TmpVectors.Vector3[1], TmpVectors.Quaternion[0], TmpVectors.Vector3[0]);
                const inheritsTargetCamera = this._attachedNode.getClassName() === "FreeCamera" ||
                    this._attachedNode.getClassName() === "FlyCamera" ||
                    this._attachedNode.getClassName() === "ArcFollowCamera" ||
                    this._attachedNode.getClassName() === "TargetCamera" ||
                    this._attachedNode.getClassName() === "TouchCamera" ||
                    this._attachedNode.getClassName() === "UniversalCamera";
                if (inheritsTargetCamera) {
                    const targetCamera = this._attachedNode;
                    targetCamera.rotation = TmpVectors.Quaternion[0].toEulerAngles();
                    if (targetCamera.rotationQuaternion) {
                        targetCamera.rotationQuaternion.copyFrom(TmpVectors.Quaternion[0]);
                        targetCamera.rotationQuaternion.normalize();
                    }
                }
                camera.position.copyFrom(TmpVectors.Vector3[0]);
            }
            else if (this._attachedNode._isMesh ||
                this._attachedNode.getClassName() === "AbstractMesh" ||
                this._attachedNode.getClassName() === "TransformNode" ||
                this._attachedNode.getClassName() === "InstancedMesh") {
                const transform = this._attachedNode;
                if (transform.parent) {
                    const parentInv = TmpVectors.Matrix[0];
                    const localMat = TmpVectors.Matrix[1];
                    transform.parent.getWorldMatrix().invertToRef(parentInv);
                    this._attachedNode.getWorldMatrix().multiplyToRef(parentInv, localMat);
                    localMat.decompose(TmpVectors.Vector3[0], TmpVectors.Quaternion[0], transform.position, Gizmo.PreserveScaling ? transform : undefined);
                }
                else {
                    this._attachedNode._worldMatrix.decompose(TmpVectors.Vector3[0], TmpVectors.Quaternion[0], transform.position, Gizmo.PreserveScaling ? transform : undefined);
                }
                TmpVectors.Vector3[0].scaleInPlace(1.0 / transform.scalingDeterminant);
                transform.scaling.copyFrom(TmpVectors.Vector3[0]);
                if (!transform.billboardMode) {
                    if (transform.rotationQuaternion) {
                        transform.rotationQuaternion.copyFrom(TmpVectors.Quaternion[0]);
                        transform.rotationQuaternion.normalize();
                    }
                    else {
                        transform.rotation = TmpVectors.Quaternion[0].toEulerAngles();
                    }
                }
            }
            else if (this._attachedNode.getClassName() === "Bone") {
                const bone = this._attachedNode;
                const parent = bone.getParent();
                if (parent) {
                    const invParent = TmpVectors.Matrix[0];
                    const boneLocalMatrix = TmpVectors.Matrix[1];
                    parent.getFinalMatrix().invertToRef(invParent);
                    bone.getFinalMatrix().multiplyToRef(invParent, boneLocalMatrix);
                    const lmat = bone.getLocalMatrix();
                    lmat.copyFrom(boneLocalMatrix);
                }
                else {
                    const lmat = bone.getLocalMatrix();
                    lmat.copyFrom(bone.getFinalMatrix());
                }
                bone.markAsDirty();
            }
            else {
                const light = this._attachedNode;
                if (light.getTypeID) {
                    const type = light.getTypeID();
                    if (type === Light.LIGHTTYPEID_DIRECTIONALLIGHT || type === Light.LIGHTTYPEID_SPOTLIGHT || type === Light.LIGHTTYPEID_POINTLIGHT) {
                        const parent = light.parent;
                        if (parent) {
                            const invParent = TmpVectors.Matrix[0];
                            const nodeLocalMatrix = TmpVectors.Matrix[1];
                            parent.getWorldMatrix().invertToRef(invParent);
                            light.getWorldMatrix().multiplyToRef(invParent, nodeLocalMatrix);
                            nodeLocalMatrix.decompose(undefined, TmpVectors.Quaternion[0], TmpVectors.Vector3[0]);
                        }
                        else {
                            this._attachedNode._worldMatrix.decompose(undefined, TmpVectors.Quaternion[0], TmpVectors.Vector3[0]);
                        }
                        // setter doesn't copy values. Need a new Vector3
                        light.position = new Vector3(TmpVectors.Vector3[0].x, TmpVectors.Vector3[0].y, TmpVectors.Vector3[0].z);
                        if (light.direction) {
                            light.direction = new Vector3(light.direction.x, light.direction.y, light.direction.z);
                        }
                    }
                }
            }
        }
        /**
         * refresh gizmo mesh material
         * @param gizmoMeshes
         * @param material material to apply
         */
        _setGizmoMeshMaterial(gizmoMeshes, material) {
            if (gizmoMeshes) {
                gizmoMeshes.forEach((m) => {
                    m.material = material;
                    if (m.color) {
                        m.color = material.diffuseColor;
                    }
                });
            }
        }
        /**
         * Subscribes to pointer up, down, and hover events. Used for responsive gizmos.
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param gizmoAxisCache Gizmo axis definition used for reactive gizmo UI
         * @returns {Observer<PointerInfo>} pointerObserver
         */
        static GizmoAxisPointerObserver(gizmoLayer, gizmoAxisCache) {
            let dragging = false;
            const pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo) => {
                var _a, _b;
                if (pointerInfo.pickInfo) {
                    // On Hover Logic
                    if (pointerInfo.type === PointerEventTypes.POINTERMOVE) {
                        if (dragging) {
                            return;
                        }
                        gizmoAxisCache.forEach((cache) => {
                            var _a, _b;
                            if (cache.colliderMeshes && cache.gizmoMeshes) {
                                const isHovered = ((_a = cache.colliderMeshes) === null || _a === void 0 ? void 0 : _a.indexOf((_b = pointerInfo === null || pointerInfo === void 0 ? void 0 : pointerInfo.pickInfo) === null || _b === void 0 ? void 0 : _b.pickedMesh)) != -1;
                                const material = cache.dragBehavior.enabled ? (isHovered || cache.active ? cache.hoverMaterial : cache.material) : cache.disableMaterial;
                                cache.gizmoMeshes.forEach((m) => {
                                    m.material = material;
                                    if (m.color) {
                                        m.color = material.diffuseColor;
                                    }
                                });
                            }
                        });
                    }
                    // On Mouse Down
                    if (pointerInfo.type === PointerEventTypes.POINTERDOWN) {
                        // If user Clicked Gizmo
                        if (gizmoAxisCache.has((_a = pointerInfo.pickInfo.pickedMesh) === null || _a === void 0 ? void 0 : _a.parent)) {
                            dragging = true;
                            const statusMap = gizmoAxisCache.get((_b = pointerInfo.pickInfo.pickedMesh) === null || _b === void 0 ? void 0 : _b.parent);
                            statusMap.active = true;
                            gizmoAxisCache.forEach((cache) => {
                                var _a, _b;
                                const isHovered = ((_a = cache.colliderMeshes) === null || _a === void 0 ? void 0 : _a.indexOf((_b = pointerInfo === null || pointerInfo === void 0 ? void 0 : pointerInfo.pickInfo) === null || _b === void 0 ? void 0 : _b.pickedMesh)) != -1;
                                const material = (isHovered || cache.active) && cache.dragBehavior.enabled ? cache.hoverMaterial : cache.disableMaterial;
                                cache.gizmoMeshes.forEach((m) => {
                                    m.material = material;
                                    if (m.color) {
                                        m.color = material.diffuseColor;
                                    }
                                });
                            });
                        }
                    }
                    // On Mouse Up
                    if (pointerInfo.type === PointerEventTypes.POINTERUP) {
                        gizmoAxisCache.forEach((cache) => {
                            cache.active = false;
                            dragging = false;
                            cache.gizmoMeshes.forEach((m) => {
                                m.material = cache.dragBehavior.enabled ? cache.material : cache.disableMaterial;
                                if (m.color) {
                                    m.color = cache.material.diffuseColor;
                                }
                            });
                        });
                    }
                }
            });
            return pointerObserver;
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            this._rootMesh.dispose();
            if (this._beforeRenderObserver) {
                this.gizmoLayer.utilityLayerScene.onBeforeRenderObservable.remove(this._beforeRenderObserver);
            }
        }
    }
    /**
     * When enabled, any gizmo operation will perserve scaling sign. Default is off.
     * Only valid for TransformNode derived classes (Mesh, AbstractMesh, ...)
     */
    Gizmo.PreserveScaling = false;

    /**
     * Renders gizmos on top of an existing scene which provide controls for position, rotation, etc.
     */
    const AUTO_MESH_NAME = '_autoGizmoMesh';
    class KbGizmo extends Gizmo {
        updateGizmoPosition() {
            this._update();
        }
        attachTo(node) { }
        get attachedMesh() {
            return super.attachedMesh;
        }
        set attachedMesh(m) {
            if (m) {
                super.attachedMesh = m;
            }
        }
        get visibility() {
            return this._rootMesh.visibility;
        }
        set visibility(visibility) {
            this._rootMesh.setEnabled(visibility === 1);
        }
        attachMeshAtNodeSpace(scene, target, positionSpaceTransform) {
            if (!this.attachedMesh) {
                this.attachedMesh = new Mesh(AUTO_MESH_NAME, scene);
            }
            let translation;
            const rotation = Quaternion.Identity();
            const scale = Vector3.One();
            translation = target instanceof exports.SpaceNode ? target.position.toVec3() : target.toVec3();
            if (positionSpaceTransform) {
                translation = Vector3.TransformCoordinates(translation, positionSpaceTransform);
                positionSpaceTransform.decompose(scale, rotation);
            }
            this.attachedMesh.position = translation;
            this.attachedMesh.rotationQuaternion = rotation;
            this.attachedMesh.scaling = scale;
            return this.attachedMesh;
        }
        _update() {
            if (this.attachedMesh) {
                const _tempVector = new Vector3();
                const _tmpMatrix = new Matrix();
                if (this.updateGizmoRotationToMatchAttachedMesh) {
                    if (!this._rootMesh.rotationQuaternion) {
                        this._rootMesh.rotationQuaternion = Quaternion.RotationYawPitchRoll(this._rootMesh.rotation.y, this._rootMesh.rotation.x, this._rootMesh.rotation.z);
                    }
                    // Remove scaling before getting rotation matrix to get rotation matrix unmodified by scale
                    _tempVector.copyFrom(this.attachedMesh.scaling);
                    if (this.attachedMesh.scaling.x < 0) {
                        this.attachedMesh.scaling.x *= -1;
                    }
                    if (this.attachedMesh.scaling.y < 0) {
                        this.attachedMesh.scaling.y *= -1;
                    }
                    if (this.attachedMesh.scaling.z < 0) {
                        this.attachedMesh.scaling.z *= -1;
                    }
                    this.attachedMesh.computeWorldMatrix().getRotationMatrixToRef(_tmpMatrix);
                    this.attachedMesh.scaling.copyFrom(_tempVector);
                    this.attachedMesh.computeWorldMatrix();
                    Quaternion.FromRotationMatrixToRef(_tmpMatrix, this._rootMesh.rotationQuaternion);
                }
                // else if (this._rootMesh.rotationQuaternion) {
                //     this._rootMesh.rotationQuaternion.set(0, 0, 0, 1);
                // }
                if (this.updateGizmoPositionToMatchAttachedMesh) {
                    this._rootMesh.position.copyFrom(this.attachedMesh.absolutePosition);
                }
                if (this.updateScale && this.gizmoLayer.utilityLayerScene.activeCamera && this.attachedMesh) {
                    let dist;
                    const camera = this.gizmoLayer.utilityLayerScene.activeCamera;
                    if (camera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                        dist = ((camera.orthoRight || 0) - (camera.orthoLeft || 0)) / 2;
                    }
                    else {
                        let cameraPosition;
                        if (camera instanceof WebXRCamera && camera.globalPosition) {
                            cameraPosition = camera.globalPosition;
                        }
                        else if (camera instanceof ArcRotateCamera) {
                            cameraPosition = getCameraPositionWithOffset(camera);
                        }
                        else {
                            cameraPosition = camera.globalPosition;
                        }
                        this._rootMesh.position.subtractToRef(cameraPosition, _tempVector);
                        dist = _tempVector.length() * this.scaleRatio;
                    }
                    this._rootMesh.scaling.set(dist, dist, dist);
                }
                const pivot = this.attachedMesh.getPivotPoint();
                //let absolutePosition = this.attachedMesh.absolutePosition;
                // Absolute position is getting skewed because of the pivot point; need to get position without the rotation
                // if (pivot.length() > 0 && this.attachedMesh.rotationQuaternion) {
                //     var m = new Matrix();
                //     this.attachedMesh.rotationQuaternion.toRotationMatrix(m);
                //     absolutePosition = Vector3.TransformCoordinates(absolutePosition, m)
                // }
                // if (pivot.length() > 0) {
                //     absolutePosition = Vector3.Zero();
                // }
                this._rootMesh.position.copyFrom(Vector3.TransformCoordinates(pivot, this.attachedMesh.getWorldMatrix()));
            }
        }
    }

    /**
     * Single plane rotation gizmo
     */
    class KbPlaneRotationGizmo extends KbGizmo {
        /**
         * Creates a PlaneRotationGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param planeNormal The normal of the plane which the gizmo will be able to rotate on
         * @param color The color of the gizmo
         * @param tessellation Amount of tessellation to be used when creating rotation circles
         */
        constructor(planeNormal, color = Color3.Gray(), gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer, tessellation = 32) {
            super(gizmoLayer);
            this._pointerObserver = null;
            /**
             * Rotation distance in radians that the gizmo will snap to (Default: 0)
             */
            this.snapDistance = 0;
            /**
             * Event that fires each time the gizmo snaps to a new location.
             * * snapDistance is the the change in distance
             */
            this.onSnapObservable = new Observable$1();
            this.updateObservable = new Observable$1();
            // Create Material
            const coloredMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            coloredMaterial.emissiveColor = color;
            // coloredMaterial.diffuseColor = color;
            // coloredMaterial.specularColor = color.subtract(new Color3(0.1, 0.1, 0.1));
            const hoverMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            hoverMaterial.emissiveColor = color.add(new Color3(0.3, 0.3, 0.3));
            // hoverMaterial.diffuseColor = color.add(new Color3(0.3, 0.3, 0.3));
            // Build mesh on root node
            const parentMesh = new AbstractMesh('', gizmoLayer.utilityLayerScene);
            const drag = Mesh.CreateTorus('', 0.6, 0.045, tessellation, gizmoLayer.utilityLayerScene);
            drag.visibility = 0;
            const rotationMesh = Mesh.CreateTorus('', 0.6, 0.01, tessellation, gizmoLayer.utilityLayerScene);
            rotationMesh.material = coloredMaterial;
            // Position arrow pointing in its drag axis
            rotationMesh.rotation.x = Math.PI / 2;
            drag.rotation.x = Math.PI / 2;
            parentMesh.addChild(rotationMesh);
            parentMesh.addChild(drag);
            parentMesh.lookAt(this._rootMesh.position.add(planeNormal));
            this.rotationMesh = parentMesh;
            this._rootMesh.addChild(parentMesh);
            parentMesh.scaling.scaleInPlace(1 / 3);
            // Add drag behavior to handle events when the gizmo is dragged
            this.dragBehavior = new PointerDragBehavior({ dragPlaneNormal: planeNormal });
            this.dragBehavior.moveAttached = false;
            this.dragBehavior.maxDragAngle = (Math.PI * 9) / 20;
            this.dragBehavior._useAlternatePickedPointAboveMaxDragAngle = true;
            this._rootMesh.addBehavior(this.dragBehavior);
            const lastDragPosition = new Vector3();
            this.dragBehavior.onDragStartObservable.add(e => {
                if (this.attachedMesh) {
                    lastDragPosition.copyFrom(e.dragPlanePoint);
                }
            });
            const rotationMatrix = new Matrix();
            const planeNormalTowardsCamera = new Vector3();
            let localPlaneNormalTowardsCamera = new Vector3();
            const tmpSnapEvent = { snapDistance: 0 };
            let currentSnapDragDistance = 0;
            const tmpMatrix = new Matrix();
            const tmpVector = new Vector3();
            const amountToRotate = new Quaternion();
            this.dragBehavior.onDragObservable.add(event => {
                if (this.attachedMesh) {
                    if (!this.attachedMesh.rotationQuaternion) {
                        this.attachedMesh.rotationQuaternion = Quaternion.RotationYawPitchRoll(this.attachedMesh.rotation.y, this.attachedMesh.rotation.x, this.attachedMesh.rotation.z);
                    }
                    // Remove parent priort to rotating
                    const attachedMeshParent = this.attachedMesh.parent;
                    if (attachedMeshParent) {
                        this.attachedMesh.setParent(null);
                    }
                    // Calc angle over full 360 degree (https://stackoverflow.com/questions/43493711/the-angle-between-two-3d-vectors-with-a-result-range-0-360)
                    const pivot = this.attachedMesh.getPivotPoint();
                    const attachedMeshPosition = this.attachedMesh.absolutePosition.add(pivot);
                    const newVector = event.dragPlanePoint.subtract(attachedMeshPosition).normalize();
                    const originalVector = lastDragPosition.subtract(attachedMeshPosition).normalize();
                    const cross = Vector3.Cross(newVector, originalVector);
                    const dot = Vector3.Dot(newVector, originalVector);
                    let angle = Math.atan2(cross.length(), dot);
                    planeNormalTowardsCamera.copyFrom(planeNormal);
                    localPlaneNormalTowardsCamera.copyFrom(planeNormal);
                    if (this.updateGizmoRotationToMatchAttachedMesh) {
                        this.attachedMesh.rotationQuaternion.toRotationMatrix(rotationMatrix);
                        localPlaneNormalTowardsCamera = Vector3.TransformCoordinates(planeNormalTowardsCamera, rotationMatrix);
                    }
                    // Flip up vector depending on which side the camera is on
                    if (gizmoLayer.utilityLayerScene.activeCamera) {
                        const camVec = gizmoLayer.utilityLayerScene.activeCamera.position.subtract(this.attachedMesh.position);
                        if (Vector3.Dot(camVec, localPlaneNormalTowardsCamera) > 0) {
                            planeNormalTowardsCamera.scaleInPlace(-1);
                            localPlaneNormalTowardsCamera.scaleInPlace(-1);
                        }
                    }
                    const halfCircleSide = Vector3.Dot(localPlaneNormalTowardsCamera, cross) > 0.0;
                    if (halfCircleSide) {
                        angle = -angle;
                    }
                    // Snapping logic
                    let snapped = false;
                    if (this.snapDistance != 0) {
                        currentSnapDragDistance += angle;
                        if (Math.abs(currentSnapDragDistance) > this.snapDistance) {
                            let dragSteps = Math.floor(Math.abs(currentSnapDragDistance) / this.snapDistance);
                            if (currentSnapDragDistance < 0) {
                                dragSteps *= -1;
                            }
                            currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                            angle = this.snapDistance * dragSteps;
                            snapped = true;
                        }
                        else {
                            angle = 0;
                        }
                    }
                    // If the mesh has a parent, convert needed world rotation to local rotation
                    tmpMatrix.reset();
                    if (this.attachedMesh.parent) {
                        this.attachedMesh.parent.computeWorldMatrix().invertToRef(tmpMatrix);
                        tmpMatrix.getRotationMatrixToRef(tmpMatrix);
                        Vector3.TransformCoordinatesToRef(planeNormalTowardsCamera, tmpMatrix, planeNormalTowardsCamera);
                    }
                    // Convert angle and axis to quaternion (http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm)
                    const quaternionCoefficient = Math.sin(angle / 2);
                    amountToRotate.set(planeNormalTowardsCamera.x * quaternionCoefficient, planeNormalTowardsCamera.y * quaternionCoefficient, planeNormalTowardsCamera.z * quaternionCoefficient, Math.cos(angle / 2));
                    // If the meshes local scale is inverted (eg. loaded gltf file parent with z scale of -1) the rotation needs to be inverted on the y axis
                    if (tmpMatrix.determinant() > 0) {
                        amountToRotate.toEulerAnglesToRef(tmpVector);
                        Quaternion.RotationYawPitchRollToRef(tmpVector.y, -tmpVector.x, -tmpVector.z, amountToRotate);
                    }
                    if (this.updateGizmoRotationToMatchAttachedMesh) {
                        // Rotate selected mesh quaternion over fixed axis
                        this.attachedMesh.rotationQuaternion.multiplyToRef(amountToRotate, this.attachedMesh.rotationQuaternion);
                    }
                    else {
                        // Rotate selected mesh quaternion over rotated axis
                        amountToRotate.multiplyToRef(this.attachedMesh.rotationQuaternion, this.attachedMesh.rotationQuaternion);
                    }
                    this.updateObservable.notifyObservers({ delta: amountToRotate, deltaAngle: angle });
                    lastDragPosition.copyFrom(event.dragPlanePoint);
                    if (snapped) {
                        tmpSnapEvent.snapDistance = angle;
                        this.onSnapObservable.notifyObservers(tmpSnapEvent);
                    }
                    // Restore parent
                    if (attachedMeshParent) {
                        this.attachedMesh.setParent(attachedMeshParent);
                    }
                }
            });
            this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add(pointerInfo => {
                if (this._customMeshSet) {
                    return;
                }
                const isHovered = pointerInfo.pickInfo &&
                    this._rootMesh.getChildMeshes().indexOf(pointerInfo.pickInfo.pickedMesh) != -1;
                const material = isHovered ? hoverMaterial : coloredMaterial;
                this._rootMesh.getChildMeshes().forEach(m => {
                    m.material = material;
                    if (m.color) {
                        m.color = material.diffuseColor;
                    }
                });
            });
            // var light = gizmoLayer._getSharedGizmoLight();
            // light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes(false));
        }
        _attachedMeshChanged(value) {
            if (this.dragBehavior) {
                this.dragBehavior.enabled = value ? true : false;
            }
            // if (value) {
            //     this.rotationMesh.setPivotPoint(Vector3.Zero(), Space.LOCAL);
            // }
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            this.onSnapObservable.clear();
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
            this.dragBehavior.detach();
            super.dispose();
        }
    }

    const tessellation = 32;
    /**
     * TODO
     * Copy in plane rotation gizmo code here and change it to use a sphere and click projection on the sphere
     * Convert it to return an axis
     * Edit code in here to return an axis and angle
     * update gizmo tools code to hook to this gizmo
     * remove the vector option from the original rotation gizmo (now the euler rotation gizmo), simplify code
     */
    /**
     * Gizmo that enables rotating a mesh along 3 axis
     */
    class KbAxisAngleGizmo extends KbGizmo {
        attachTo(target, positionSpace, placementOffset) {
            if (positionSpace) {
                this._positionSpace = this.kbViewer.getRendererNode(positionSpace);
            }
            this._updateGizmoPosition(target, placementOffset);
        }
        updateGizmoPosition(changeTarget, placementOffset) {
            // Need to wait for the next frame because this can be called before the babylon object is actually updated
            this.kbViewer.onNextFrame(() => {
                this._updateGizmoPosition(changeTarget, placementOffset);
            });
        }
        _updateGizmoPosition(changeTarget, placementOffset) {
            var _a;
            // Maintain the placement offset if it is not provided later, so this can be called from other contexts to update based on external changes
            if (!placementOffset && this.placementOffset) {
                placementOffset = this.placementOffset;
            }
            else if (placementOffset) {
                this.placementOffset = placementOffset;
            }
            const positionSpaceTransform = (_a = this._positionSpace) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
            if (changeTarget) {
                changeTarget.toVec3(this.targetAxis);
                // If target is a vector, then we want to rotate it as a direction, so set the gizmo position to the origin to calculations are done from there
                // But store the position as the offset because we want the gizmo itself to be visually placed on the position space origin
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, placementOffset || exports.KbVector.Zero(), positionSpaceTransform);
                if (this.attachedMesh) {
                    this.gizmoOffset = exports.KbVector.FromVec3(this.attachedMesh.position);
                    this.attachedMesh.position = Vector3.Zero();
                    this.attachedMesh.computeWorldMatrix(true);
                }
                const targetAxisTransformed = this.targetAxis.clone();
                if (positionSpaceTransform) {
                    Vector3.TransformCoordinatesToRef(this.targetAxis, positionSpaceTransform.getRotationMatrix(), targetAxisTransformed);
                }
                this.axisGizmo.direction.copyFrom(targetAxisTransformed);
            }
            if (this.gizmoOffset && this.attachedMesh) {
                this.attachedMesh.position.copyFrom(this.gizmoOffset.toVec3());
                this.axisGizmo.gizmoPosition.copyFrom(this.gizmoOffset.toVec3());
                // if (placementOffset) {
                //     this.axisGizmo.gizmoPosition.addInPlace(placementOffset.toVec3());
                // }
            }
            // if (positionSpaceTransform) {
            //     Vector3.TransformCoordinatesToRef(this.axisGizmo.gizmoPosition, positionSpaceTransform, this.axisGizmo.gizmoPosition);
            // }
            super.updateGizmoPosition();
        }
        get attachedMesh() {
            return super.attachedMesh;
        }
        set attachedMesh(mesh) {
            super.attachedMesh = mesh;
            if (mesh) {
                const angleMesh = new Mesh('', this.gizmoLayer.utilityLayerScene);
                mesh.addChild(angleMesh);
                if (this.angleGizmo) {
                    this.angleGizmo.attachedMesh = angleMesh;
                }
                angleMesh.lookAt(this.targetAxis);
                angleMesh.setPivotPoint(mesh.getPivotPoint(), Space.WORLD);
            }
            else if (this.angleGizmo) {
                this.angleGizmo.attachedMesh = null;
            }
        }
        /**
         * Creates a RotationGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param tessellation Amount of tessellation to be used when creating rotation circles
         */
        constructor(kbViewer, gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer, disableAngle = false) {
            super(gizmoLayer);
            this.kbViewer = kbViewer;
            this.targetAxis = new Vector3();
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onDragStartObservable = new Observable$1();
            /** Fires an event when any of it's sub gizmos are released from dragging */
            this.onDragObservable = new Observable$1();
            this.onDragEndObservable = new Observable$1();
            this.updateGizmoRotationToMatchAttachedMesh = true;
            this.axisGizmo = new KbAxisMorphGizmo(Color3.Green().scale(0.5), gizmoLayer, tessellation);
            if (!disableAngle) {
                this.angleGizmo = new KbPlaneRotationGizmo(new Vector3(0, 0, 1), Color3.Green().scale(0.5), gizmoLayer, tessellation);
                this.angleGizmo.updateGizmoPositionToMatchAttachedMesh = true;
            }
            const zeroVector = Vector3.Zero();
            const tempVector = Vector3.Zero();
            const tempVector2 = Vector3.Zero();
            let positionSpaceTransform;
            this.axisChange = Vector3.Zero();
            this.angleChange = 0;
            // Relay drag events
            [this.axisGizmo, this.angleGizmo].forEach(gizmo => {
                if (gizmo) {
                    gizmo.dragBehavior.onDragStartObservable.add(() => {
                        this.onDragStartObservable.notifyObservers();
                        this.axisChange = Vector3.Zero();
                        this.angleChange = 0;
                        if (!positionSpaceTransform && this._positionSpace) {
                            positionSpaceTransform = this._positionSpace
                                .computeWorldMatrix(true)
                                .getRotationMatrix()
                                .clone()
                                .invert();
                        }
                    });
                    gizmo.dragBehavior.onDragEndObservable.add(() => {
                        this.onDragEndObservable.notifyObservers({
                            deltaAxis: this.axisChange,
                            deltaAngle: this.angleChange,
                        });
                    });
                }
            });
            this.axisGizmo.updateObservable.add(event => {
                tempVector.copyFrom(this.targetAxis);
                // if (positionSpaceTransform) {
                //     Vector3.TransformCoordinatesToRef(tempVector, positionSpaceTransform, tempVector);
                // }
                tempVector.rotateByQuaternionToRef(event.delta, tempVector2);
                // if (positionSpaceTransform) {
                //     Vector3.TransformCoordinatesToRef(tempVector2, positionSpaceTransform.clone().invert(), tempVector2);
                // }
                tempVector2.subtractToRef(this.targetAxis, tempVector2);
                this.targetAxis.addInPlace(tempVector2);
                this.axisChange.addInPlace(tempVector2);
                this.onDragObservable.notifyObservers({ deltaAxis: tempVector2, deltaAngle: 0 });
                if (this.angleGizmo && this.angleGizmo.attachedMesh) {
                    this.angleGizmo.attachedMesh.lookAt(positionSpaceTransform
                        ? Vector3.TransformCoordinates(this.targetAxis, positionSpaceTransform)
                        : this.targetAxis);
                }
            });
            if (this.angleGizmo) {
                this.angleGizmo.updateObservable.add(event => {
                    this.angleChange -= event.deltaAngle;
                    this.onDragObservable.notifyObservers({ deltaAxis: zeroVector, deltaAngle: -event.deltaAngle });
                });
            }
            this.attachedMesh = null;
        }
        /**
         * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */
        set snapDistance(value) {
            if (this.axisGizmo) {
                this.axisGizmo.snapDistance = value;
            }
            if (this.angleGizmo) {
                this.angleGizmo.snapDistance = value;
            }
        }
        get snapDistance() {
            return this.axisGizmo.snapDistance;
        }
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */
        set scaleRatio(value) {
            if (this.axisGizmo) {
                this.axisGizmo.scaleRatio = value;
            }
            if (this.angleGizmo) {
                this.angleGizmo.scaleRatio = value;
            }
        }
        get scaleRatio() {
            return this.axisGizmo.scaleRatio;
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            if (this.axisGizmo) {
                this.axisGizmo.dispose();
            }
            if (this.angleGizmo) {
                this.angleGizmo.dispose();
            }
            this.onDragStartObservable.clear();
            this.onDragEndObservable.clear();
        }
        /**
         * CustomMeshes are not supported by this gizmo
         * @param mesh The mesh to replace the default mesh of the gizmo
         */
        setCustomMesh(mesh) {
            Logger.Error('Custom meshes are not supported on this gizmo, please set the custom meshes on the gizmos contained within this one (gizmo.xGizmo, gizmo.angleGizmo, gizmo.zGizmo)');
        }
    }

    const meshFaceInfo = new Map();
    class MeshFaceEngine {
        constructor(kbViewer) {
            this.kbViewer = kbViewer;
            this.bbCache = kbViewer.bbCache;
        }
        initialize(node) {
            let meshNode;
            let mesh;
            if (node instanceof exports.Kb3dObject) {
                mesh = this.kbViewer.getRendererNode(node);
                meshNode = node;
            }
            else {
                mesh = node;
                meshNode = getByDynamicId(node.id);
            }
            if (mesh instanceof Mesh && mesh.geometry) {
                this.bbCache
                    .watchForChanges(meshNode)
                    .pipe(take(1))
                    .subscribe(() => {
                    meshFaceInfo.delete(meshNode._dynamicId);
                });
                return this.updateNodeGeometry(mesh);
            }
        }
        getMeshFaces(node) {
            let result = meshFaceInfo.get(node instanceof exports.Kb3dObject ? node._dynamicId : node.id);
            if (!result) {
                result = this.initialize(node);
            }
            return result;
        }
        /**
         * @param selection array of selected faces to expand from
         * @param limitAngle angle to limit selection to. If undefined, function will expand by 1 polygon
         */
        expandSelection(selection, node, limitAngle) {
            const faceInfo = this.getMeshFaces(node);
            const faceNormals = faceInfo.faceNormals;
            const selectedFaceIds = [];
            const newSelection = [];
            if (limitAngle !== undefined) {
                limitAngle = (limitAngle * Math.PI) / 180;
            }
            const v1 = new Vector3(), v2 = new Vector3();
            if (!faceInfo) {
                return selection;
            }
            for (let i = 0; i < selection.length; i++) {
                selectedFaceIds[selection[i]] = true;
            }
            for (let i = 0; i < selection.length; i++) {
                const faceId = selection[i];
                v1.copyFromFloats(faceNormals[faceId * 3], faceNormals[faceId * 3 + 1], faceNormals[faceId * 3 + 2]);
                recursiveExpandSelection(faceId, 1, v1);
            }
            for (const faceId in selectedFaceIds) {
                newSelection.push(parseInt(faceId, 10));
            }
            return newSelection;
            function recursiveExpandSelection(faceId, iterCount, normal) {
                const neighbors = faceInfo.faceNeighbors[faceId];
                if (limitAngle === undefined && iterCount <= 0) {
                    return;
                }
                for (let i = 0; i < neighbors.length; i++) {
                    const adjacentFaceId = neighbors[i];
                    if (!selectedFaceIds[adjacentFaceId]) {
                        if (limitAngle !== undefined) {
                            v2.copyFromFloats(faceNormals[adjacentFaceId * 3], faceNormals[adjacentFaceId * 3 + 1], faceNormals[adjacentFaceId * 3 + 2]);
                            if (Math.abs(Math.acos(Math.round(Vector3.Dot(normal, v2) * 1000000) / 1000000)) <= limitAngle) {
                                // deal with FP Errors
                                selectedFaceIds[adjacentFaceId] = true;
                                recursiveExpandSelection(adjacentFaceId, iterCount - 1, normal);
                            }
                        }
                        else {
                            selectedFaceIds[adjacentFaceId] = true;
                            recursiveExpandSelection(adjacentFaceId, iterCount - 1, normal);
                        }
                    }
                }
            }
        }
        updateNodeGeometry(mesh) {
            if (mesh.geometry) {
                const indices = mesh.geometry.getIndices();
                const positions = mesh.geometry.getVerticesData(VertexBuffer.PositionKind);
                const v1 = new Vector3();
                const v2 = new Vector3();
                const v3 = new Vector3();
                const v4 = new Vector3();
                if (indices && positions) {
                    const facesByEdges = {};
                    /** Sets of three faces by index adjacent to each face by index */
                    const faceNeighbors = [];
                    /** Sets of xyz scalars making up the face normals */
                    const faceNormals = [];
                    const facePositions = [];
                    const trianglesCount = indices.length / 3;
                    for (let triId = 0; triId < trianglesCount; triId++) {
                        const triOffset = triId * 3;
                        // Get the triangle position vertices
                        v1.copyFromFloats(positions[indices[triOffset] * 3], positions[indices[triOffset] * 3 + 1], positions[indices[triOffset] * 3 + 2]);
                        v2.copyFromFloats(positions[indices[triOffset + 1] * 3], positions[indices[triOffset + 1] * 3 + 1], positions[indices[triOffset + 1] * 3 + 2]);
                        v3.copyFromFloats(positions[indices[triOffset + 2] * 3], positions[indices[triOffset + 2] * 3 + 1], positions[indices[triOffset + 2] * 3 + 2]);
                        // Calculate the centroid of each face
                        v4.setAll(0);
                        v4.addInPlace(v1).addInPlace(v2).addInPlace(v3);
                        v4.scaleInPlace(1 / 3);
                        facePositions.push(v4.x, v4.y, v4.z);
                        // Get two of the triangle edges
                        v1.subtractInPlace(v2);
                        v2.subtractInPlace(v3);
                        // Get the triangle face normal with the two edges.
                        // Note that this is not the geometry normal, but the position-based face normal
                        Vector3.CrossToRef(v1, v2, v4);
                        const faceNormal = v4;
                        faceNormal.normalize();
                        faceNormals.push(faceNormal.x, faceNormal.y, faceNormal.z);
                        // Now we need to consolidate what triangles are next to each other by organizing them by edges
                        for (let i = 0; i < 3; i++) {
                            const idx1 = indices[triOffset + i];
                            const idx2 = indices[triOffset + ((i + 1) % 3)];
                            // This is not going to work for geometry seams like on cylinders.
                            // Possibly change from index ids to a representation of the vertex position
                            const edgeId = idx1 > idx2 ? `${idx1}-${idx2}` : `${idx2}-${idx1}`;
                            if (!facesByEdges[edgeId]) {
                                facesByEdges[edgeId] = [];
                            }
                            facesByEdges[edgeId].push(triId);
                        }
                    }
                    // Now we go through the edges and register the neighbors for each triangle
                    for (const edgeId in facesByEdges) {
                        const faces = facesByEdges[edgeId];
                        if (!faceNeighbors[faces[0]]) {
                            faceNeighbors[faces[0]] = [];
                        }
                        // Some edges may only have one face if the face is on the edge of the geometry
                        if (faces.length > 1) {
                            if (!faceNeighbors[faces[1]]) {
                                faceNeighbors[faces[1]] = [];
                            }
                            faceNeighbors[faces[0]].push(faces[1]);
                            faceNeighbors[faces[1]].push(faces[0]);
                        }
                    }
                    const result = {
                        faceCount: trianglesCount,
                        faceNeighbors,
                        facePositions,
                        faceNormals,
                    };
                    meshFaceInfo.set(mesh.id, result);
                    return result;
                }
            }
        }
    }

    (function (eMarqueeSelectMode) {
        eMarqueeSelectMode[eMarqueeSelectMode["Facets"] = 0] = "Facets";
        eMarqueeSelectMode[eMarqueeSelectMode["Vertices"] = 1] = "Vertices";
    })(exports.eMarqueeSelectMode || (exports.eMarqueeSelectMode = {}));
    class Interaction {
        constructor(kbViewer, scene, highlighter) {
            this.kbViewer = kbViewer;
            this.scene = scene;
            this.highlighter = highlighter;
            this.onClick$ = new Subject();
            this.onFacetClick$ = new Subject();
            this.onDoubleClick$ = new Subject();
            this.onPointerMove$ = new Subject();
            this.onPointerDown$ = new Subject();
            this.onPointerUp$ = new Subject();
            this.onKeyboard$ = new Subject();
            this.onMarqueeSelect = null;
            this.pointerIsDown = false;
            this.dragInProgress = false;
            this.selectionTolerance = 0;
            this.cameraFacingDirection = new Vector3();
            this.meshFaceEngine = new MeshFaceEngine(kbViewer);
            this.onClick = this.onClick$.asObservable();
            this.onFacetClick = this.onFacetClick$.asObservable();
            this.onDoubleClick = this.onDoubleClick$.asObservable();
            this.onPointerMove = this.onPointerMove$.asObservable();
            this.onPointerDown = this.onPointerDown$.asObservable();
            this.onPointerUp = this.onPointerUp$.asObservable();
            this.onKeyboard = this.onKeyboard$.asObservable();
            this.attachScene(scene);
        }
        attachScene(scene, utilityLayer = false) {
            scene.onPointerObservable.add(p => {
                const args = this.getKb3dPointerArgs(p);
                switch (p.type) {
                    case PointerEventTypes.POINTERDOWN:
                        this.handlePointerDown(args);
                        break;
                    case PointerEventTypes.POINTERUP:
                        this.handlePointerUp(args);
                        break;
                    case PointerEventTypes.POINTERMOVE:
                        this.handleMove(args);
                        break;
                    // case PointerEventTypes.POINTERWHEEL:
                    //     console.log("POINTER WHEEL");
                    //     break;
                    // case PointerEventTypes.POINTERPICK:
                    //     console.log("POINTER PICK");
                    //     break;
                    case PointerEventTypes.POINTERTAP:
                        this.handleClick(args);
                        break;
                    case PointerEventTypes.POINTERDOUBLETAP:
                        this.handleDoubleClick(args);
                        break;
                }
            });
            scene.onKeyboardObservable.add(k => {
                const args = this.getKeyboardArgs(k);
                switch (k.type) {
                    case KeyboardEventTypes.KEYDOWN:
                        this.handleKeyboard(args);
                }
            });
        }
        setSelectionTolerance(tolerance) {
            this.selectionTolerance = tolerance;
        }
        setSelectionCulling(enabled) {
            if (this.marqueeSelectOptions) {
                this.marqueeSelectOptions.cullSelection = enabled;
            }
        }
        enableMarqueeSelect(meshNode, mode, options) {
            const mesh = this.kbViewer.getRendererNode(meshNode);
            if (mesh instanceof Mesh) {
                this.onMarqueeSelect = new Subject();
                this.marqueeSelectOptions = {
                    cullSelection: false,
                    onlyOnShiftPress: true,
                    startX: 0,
                    startY: 0,
                    mode,
                    mesh,
                    ...(options || {}),
                };
                return this.onMarqueeSelect.asObservable().pipe(distinctUntilChanged((prev, curr) => {
                    if (prev.selectedFaces.length !== curr.selectedFaces.length ||
                        prev.vertexList.length !== curr.vertexList.length) {
                        return false;
                    }
                    for (let i = 0; i < curr.selectedFaces.length; i++) {
                        if (curr.selectedFaces[i] !== prev.selectedFaces[i]) {
                            return false;
                        }
                    }
                    for (let i = 0; i < curr.vertexList.length; i++) {
                        if (curr.vertexList[i] !== prev.vertexList[i]) {
                            return false;
                        }
                    }
                    return true;
                }));
            }
            return EMPTY;
        }
        disableMarqueeSelect() {
            if (this.onMarqueeSelect) {
                this.onMarqueeSelect.complete();
            }
            this.onMarqueeSelect = null;
        }
        /** Do a hit test of the scene using x,y screen pixel coordinates */
        pick(x, y, camera) {
            const pickInfo = this.scene.pick(x, y, undefined, undefined, camera);
            if (pickInfo && pickInfo.hit) {
                const info = { ...pickInfo };
                this.fillKb3dPickInfo(pickInfo, info);
                return info;
            }
            return undefined;
        }
        handleClickTypeEvent(args, handlerType) {
            // For debugging
            // if (args.pickInfo?.ray) {
            //     RayHelper.CreateAndShow(args.pickInfo.ray, this.scene, new Color3(1, 1, 0.1));
            // }
            if (args.targetNode) {
                //bubble up event, calling any handlers that have been applied to the nodes
                let h = this.getNextNodeHandlers(args.targetNode, handlerType);
                while (h) {
                    let propagate = false;
                    args.sourceNode = h.node;
                    for (const handler of h.handlers) {
                        handler(args);
                        if (args.propagate)
                            propagate = true;
                    }
                    if (!propagate)
                        break;
                    h = this.getNextNodeHandlers(h.node._parent, handlerType);
                }
            }
            else {
                //there was no clicked mesh, but if there is a handler on the root scene node, we trigger that
                const handlers = this.getHandlerMap(this.kbViewer.sceneNode, handlerType).getByKey(this.kbViewer.sceneNode);
                if (handlers) {
                    args.targetNode = args.sourceNode = this.kbViewer.sceneNode;
                    for (const handler of handlers) {
                        handler(args);
                    }
                }
            }
        }
        handleClick(args) {
            var _a;
            this.handleClickTypeEvent(args, exports.eHandler.click);
            // trigger the normal generic observable
            this.onClick$.next(args);
            // if there is an observer on the facet click, then send the facet data there
            if (this.onFacetClick$.observers.length > 0) {
                if (((_a = args.pickInfo) === null || _a === void 0 ? void 0 : _a.pickedMesh) && args.pickInfo.pickedMesh instanceof Mesh) {
                    const pickedMesh = args.pickInfo.pickedMesh;
                    const selectedTriangle = args.pickInfo.faceId;
                    const faceInfo = this.meshFaceEngine.getMeshFaces(pickedMesh);
                    if (faceInfo) {
                        let selection = [];
                        if (this.selectionTolerance >= 0) {
                            selection = this.meshFaceEngine.expandSelection([selectedTriangle], pickedMesh, this.selectionTolerance);
                        }
                        else {
                            selection = [selectedTriangle];
                        }
                        const facetArgs = {
                            ...args,
                            altKey: args.event.altKey,
                            selectedFaces: selection,
                        };
                        this.onFacetClick$.next(facetArgs);
                    }
                }
            }
        }
        handleDoubleClick(args) {
            this.handleClickTypeEvent(args, exports.eHandler.doubleClick);
            //trigger the normal generic observable
            this.onDoubleClick$.next(args);
        }
        handleMove(args) {
            if (!this.pointerIsDown && this.kbViewer.sceneNode && this.kbViewer.sceneNode.enableHoverEffects) {
                if (args.targetNode) {
                    const clicks = this.getNextClickHandlers(args.targetNode);
                    const draggables = this.getNextDraggables(args.targetNode);
                    if (clicks || draggables) {
                        const n = (clicks === null || clicks === void 0 ? void 0 : clicks.node) || (draggables === null || draggables === void 0 ? void 0 : draggables.node);
                        this.highlighter.hover(n);
                    }
                }
                else {
                    this.highlighter.clearHover();
                }
            }
            if (this.scene.activeCamera instanceof KbArcRotateCamera && this.pointerIsDown && this.onMarqueeSelect) {
                if (!this.marqueeSelectOptions.onlyOnShiftPress || args.shiftKey) {
                    args.event.preventDefault();
                    args.event.stopPropagation();
                    this.handleMarquee(args, this.scene.activeCamera);
                }
                else {
                    this.unlockCamera();
                }
            }
            this.onPointerMove$.next(args);
        }
        handlePointerDown(args) {
            var _a;
            this.pointerIsDown = true;
            if (this.onMarqueeSelect) {
                if (!this.marqueeSelectOptions.onlyOnShiftPress || args.shiftKey) {
                    this.marqueeSelectOptions.startX = args.canvasX || 0;
                    this.marqueeSelectOptions.startY = args.canvasY || 0;
                    this.marqueeSelectOptions.startRay =
                        ((_a = this.scene.pick(args.canvasX, args.canvasY, undefined, undefined, this.scene.activeCamera)) === null || _a === void 0 ? void 0 : _a.ray) ||
                            undefined;
                    if (this.kbViewer.uiOverlay) {
                        const selectBox = document.createElement('div');
                        selectBox.style.position = 'absolute';
                        selectBox.style.border = '1px dashed white';
                        selectBox.style.background = 'rgba(128, 128, 128, 0.1)';
                        selectBox.style.opacity = '0.5';
                        this.kbViewer.uiOverlay.appendChild(selectBox);
                        this.marqueeSelectOptions.selectBox = selectBox;
                    }
                    this.cameraFacingDirection = this.scene.activeCamera.getForwardRay().direction;
                    if (!this.marqueeSelectOptions.mesh.isFacetDataEnabled &&
                        this.marqueeSelectOptions.mode === exports.eMarqueeSelectMode.Facets) {
                        const normals = this.marqueeSelectOptions.mesh.getVerticesData(VertexBuffer.NormalKind);
                        if (!normals) {
                            this.marqueeSelectOptions.mesh.setVerticesData(VertexBuffer.NormalKind, new Float32Array(this.marqueeSelectOptions.mesh.getTotalVertices() * 3));
                        }
                    }
                }
            }
            else if (args.targetNode) {
                const d = this.getNextDraggables(args.targetNode);
                if (d) {
                    this.highlighter.clearHover();
                    args.sourceNode = d.node;
                    const dragger = new Dragger(this.kbViewer, this.scene);
                    this.dragInProgress = true;
                    dragger.startDrag(args, d.handlers[0], () => {
                        this.dragInProgress = false;
                    });
                }
            }
            this.onPointerDown$.next(args);
        }
        unlockCamera() {
            var _a;
            (_a = this.scene.activeCamera) === null || _a === void 0 ? void 0 : _a.attachControl(this.kbViewer.canvas);
        }
        handlePointerUp(args) {
            var _a;
            this.pointerIsDown = false;
            if (this.marqueeSelectOptions && this.marqueeSelectOptions.selectBox) {
                (_a = this.kbViewer.uiOverlay) === null || _a === void 0 ? void 0 : _a.removeChild(this.marqueeSelectOptions.selectBox);
                delete this.marqueeSelectOptions.selectBox;
            }
            this.unlockCamera();
            this.onPointerUp$.next(args);
        }
        handleKeyboard(args) {
            this.onKeyboard$.next(args);
        }
        handleMarquee(args, activeCamera) {
            var _a;
            const mouseX = args.canvasX || 0;
            const mouseY = args.canvasY || 0;
            activeCamera.detachControl();
            if (this.marqueeSelectOptions.selectBox) {
                this.marqueeSelectOptions.selectBox.style.left = Math.min(this.marqueeSelectOptions.startX, mouseX) + 'px';
                this.marqueeSelectOptions.selectBox.style.top = Math.min(this.marqueeSelectOptions.startY, mouseY) + 'px';
                this.marqueeSelectOptions.selectBox.style.width =
                    Math.abs(this.marqueeSelectOptions.startX - mouseX) + 'px';
                this.marqueeSelectOptions.selectBox.style.height =
                    Math.abs(this.marqueeSelectOptions.startY - mouseY) + 'px';
            }
            let topOrigin;
            let leftOrigin;
            let rightOrigin;
            let bottomOrigin;
            let topNormal;
            let leftNormal;
            let rightNormal;
            let bottomNormal;
            const m = Matrix.Identity();
            const boxL = Math.min(this.marqueeSelectOptions.startX, mouseX);
            const boxR = Math.max(this.marqueeSelectOptions.startX, mouseX);
            const boxT = Math.min(this.marqueeSelectOptions.startY, mouseY);
            const boxB = Math.max(this.marqueeSelectOptions.startY, mouseY);
            if (activeCamera.mode === Camera.ORTHOGRAPHIC_CAMERA) {
                // ORTHOGRAPHIC CAMERA
                const forwardDirection = activeCamera.getForwardRay().direction;
                const sideDirection = Vector3.Cross(forwardDirection, Vector3.Up());
                topNormal = Vector3.Cross(forwardDirection, sideDirection);
                leftNormal = sideDirection;
                rightNormal = sideDirection.scale(-1);
                bottomNormal = Vector3.Cross(sideDirection, forwardDirection);
                topOrigin = this.scene.createPickingRay(boxL, boxT, m, activeCamera).origin;
                leftOrigin = this.scene.createPickingRay(boxL, boxT, m, activeCamera).origin;
                rightOrigin = this.scene.createPickingRay(boxR, boxB, m, activeCamera).origin;
                bottomOrigin = this.scene.createPickingRay(boxR, boxB, m, activeCamera).origin;
            }
            else {
                // PERSPECTIVE CAMERA
                // Assemble the 4 planes of the marquee select
                const origin = ((_a = this.marqueeSelectOptions.startRay) === null || _a === void 0 ? void 0 : _a.origin) || activeCamera.position;
                topOrigin = origin;
                leftOrigin = origin;
                rightOrigin = origin;
                bottomOrigin = origin;
                const topLeft = this.scene.createPickingRay(boxL, boxT, m, activeCamera).direction;
                const topRight = this.scene.createPickingRay(boxR, boxT, m, activeCamera).direction;
                const botLeft = this.scene.createPickingRay(boxL, boxB, m, activeCamera).direction;
                const botRight = this.scene.createPickingRay(boxR, boxB, m, activeCamera).direction;
                if (topLeft && topRight && botLeft && botRight) {
                    // Normals of the planes are equal to the cross product of the two vectors that define the plane
                    topNormal = Vector3.Cross(topLeft, topRight);
                    leftNormal = Vector3.Cross(botLeft, topLeft);
                    rightNormal = Vector3.Cross(topRight, botRight);
                    bottomNormal = Vector3.Cross(botRight, botLeft);
                }
            }
            if (topNormal && leftNormal && rightNormal && bottomNormal) {
                const mesh = this.marqueeSelectOptions.mesh;
                const fP = new Vector3();
                const fN = new Vector3();
                if (this.marqueeSelectOptions.mode === exports.eMarqueeSelectMode.Facets) {
                    const faceInfo = this.meshFaceEngine.getMeshFaces(mesh);
                    const transform = mesh.computeWorldMatrix();
                    const n = faceInfo.faceCount;
                    const res = [];
                    for (let i = 0; i < n; i++) {
                        Vector3.TransformCoordinatesFromFloatsToRef(faceInfo.facePositions[i * 3], faceInfo.facePositions[i * 3 + 1], faceInfo.facePositions[i * 3 + 2], transform, fP);
                        if (this.marqueeSelectOptions.cullSelection) {
                            Vector3.TransformCoordinatesFromFloatsToRef(faceInfo.faceNormals[i * 3], faceInfo.faceNormals[i * 3 + 1], faceInfo.faceNormals[i * 3 + 2], transform, fN);
                        }
                        if ((!this.marqueeSelectOptions.cullSelection || Vector3.Dot(this.cameraFacingDirection, fN) > 0) &&
                            pointPlaneSizeToRef(topNormal, topOrigin, fP) >= 0 &&
                            pointPlaneSizeToRef(leftNormal, leftOrigin, fP) >= 0 &&
                            pointPlaneSizeToRef(rightNormal, rightOrigin, fP) >= 0 &&
                            pointPlaneSizeToRef(bottomNormal, bottomOrigin, fP) >= 0) {
                            res.push(i);
                        }
                    }
                    this.onMarqueeSelect.next({
                        ...args,
                        altKey: args.event.altKey,
                        vertexList: [],
                        selectedFaces: res,
                    });
                }
                else if (this.marqueeSelectOptions.mode === exports.eMarqueeSelectMode.Vertices) {
                    const vertexPositions = mesh.getVerticesData(VertexBuffer.PositionKind);
                    const transform = mesh.getWorldMatrix();
                    const res = [];
                    if (vertexPositions) {
                        const n = vertexPositions.length / 3;
                        for (let i = 0; i < n; i++) {
                            fP.copyFromFloats(vertexPositions[i * 3], vertexPositions[i * 3 + 1], vertexPositions[i * 3 + 2]);
                            Vector3.TransformCoordinatesToRef(fP, transform, fP);
                            if ((!this.marqueeSelectOptions.cullSelection ||
                                Vector3.Dot(this.cameraFacingDirection, mesh.getFacetNormal(i))) &&
                                pointPlaneSizeToRef(topNormal, topOrigin, fP) >= 0 &&
                                pointPlaneSizeToRef(leftNormal, leftOrigin, fP) >= 0 &&
                                pointPlaneSizeToRef(rightNormal, rightOrigin, fP) >= 0 &&
                                pointPlaneSizeToRef(bottomNormal, bottomOrigin, fP) >= 0) {
                                res.push(i);
                            }
                        }
                        mesh.getIndices();
                        this.onMarqueeSelect.next({
                            ...args,
                            altKey: args.event.altKey,
                            vertexList: res,
                            selectedFaces: [],
                        });
                    }
                }
            }
            function pointPlaneSizeToRef(normal, origin, point) {
                return normal.x * (point.x - origin.x) + normal.y * (point.y - origin.y) + normal.z * (point.z - origin.z);
            }
        }
        getKb3dPointerArgs(p) {
            const args = {
                ...p,
                pickInfo: p.pickInfo,
                propagate: false,
                pointerType: p.event.pointerType,
                button: p.event.button,
                ctrlKey: p.event.ctrlKey || p.event.metaKey,
                shiftKey: p.event.shiftKey,
                canvasX: p.event.offsetX,
                canvasY: p.event.offsetY,
                getNormal: () => {
                    if (p.pickInfo) {
                        const normal = p.pickInfo.getNormal();
                        return normal ? exports.KbVector.FromVec3(normal) : undefined;
                    }
                    return undefined;
                },
            };
            if (p.pickInfo) {
                this.fillKb3dPickInfo(p.pickInfo, args);
            }
            return args;
        }
        fillKb3dPickInfo(b, k) {
            k.u = b.bu;
            k.v = b.bv;
            if (b.pickedPoint)
                k.pickedPoint = exports.KbVector.FromVec3(b.pickedPoint);
            if (b.pickedMesh) {
                // recurse up the tree until we find something, or return undefined
                let pickedMesh = b.pickedMesh;
                k.targetNode = getByDynamicId(pickedMesh.id);
                while (!k.targetNode && pickedMesh.parent) {
                    pickedMesh = pickedMesh.parent;
                    k.targetNode = getByDynamicId(pickedMesh.id);
                }
                if (b.pickedPoint) {
                    k.meshPoint = exports.KbVector.FromVec3(Vector3.TransformCoordinates(b.pickedPoint, b.pickedMesh.getWorldMatrix().clone().invert()));
                }
            }
        }
        getKeyboardArgs(k) {
            const event = k.event;
            const args = {
                ...k,
                key: event.key,
                keyCode: event.keyCode,
                altKey: event.altKey,
                ctrlKey: event.ctrlKey || event.metaKey,
                shiftKey: event.shiftKey,
                repeat: event.repeat,
            };
            return args;
        }
        /**
         * scans the given node and ancestors to find the first node with a click handler and returns
         * the node and it's handlers
         */
        getNextNodeHandlers(node, handlerType) {
            //bubble up event, calling any handlers that have been applied to the nodes
            let handlers = new Array();
            while (node && node._manager) {
                const hmap = this.getHandlerMap(node, handlerType);
                handlers = hmap.getByKey(node);
                //if this is a scene node, then we also have to look in the parent scene manager for click events on this item
                if (instanceOf(node, Token.SceneNode) && node.isNested() && node._parent && node._parent._manager) {
                    handlers.push(...this.getHandlerMap(node._parent, handlerType).getByKey(node));
                }
                if (handlers && handlers.length) {
                    break;
                }
                node = node._parent;
            }
            return node ? { node, handlers } : undefined;
        }
        getHandlerMap(node, type) {
            const m = node._manager;
            if (type == exports.eHandler.click)
                return m.clickHandlers;
            else if (type == exports.eHandler.draggable)
                return m.draggables;
            else if (type == exports.eHandler.doubleClick)
                return m.doubleClickHandlers;
            else
                throw 'unrecognized handler type';
        }
        getNextClickHandlers(node) {
            return this.getNextNodeHandlers(node, exports.eHandler.click);
        }
        getNextDoubleClickHandlers(node) {
            return this.getNextNodeHandlers(node, exports.eHandler.doubleClick);
        }
        getNextDraggables(node) {
            return this.getNextNodeHandlers(node, exports.eHandler.draggable);
        }
    }

    const dbSubmeshes = new Map();
    /**
     * Gizmo that enables moving vertices on a mesh.
     */
    class KbFacetSelectGizmo extends KbGizmo {
        get attachedMesh() {
            return this.__attachedMesh;
        }
        set attachedMesh(mesh) {
            if (mesh && !(mesh instanceof Mesh)) {
                throw Error('facet select gizmo must be attached to a mesh with geometry');
            }
            this.__attachedMesh = mesh;
        }
        /**
         * Creates a PositionGizmo
         * @param camera The camera being used for the scene. Used for positioning the particles so they line up with the vertices
         * @param gizmoLayer The utility layer the gizmo will be added to
         */
        constructor(kbViewer, scene) {
            super(kbViewer.utilityLayer);
            this.kbViewer = kbViewer;
            this.scene = scene;
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onSelectionChange = new Observable$1();
            this.__attachedMesh = null;
            this.currentSelection = new Map();
            this.selectionsEnabled = false;
            this.highlightOpacity = 0.75;
            this.meshFaceEngine = new MeshFaceEngine(kbViewer);
            this.utilLayer = kbViewer.utilityLayer;
            this.attachedMesh = null;
        }
        attachTo(target) {
            this.__attachedNode = target;
            const aMesh = this.kbViewer.getRendererNode(target);
            if (!aMesh) {
                throw Error('Could not find mesh in scene to attach gizmo');
            }
            if (!(aMesh instanceof Mesh)) {
                throw Error('facet select gizmo must be attached to a mesh with geometry');
            }
            const mesh = aMesh;
            this.attachedMesh = mesh;
            // Clean up old marquee
            if (this.disposeSubject) {
                this.disposeSubject.next();
                this.disposeSubject.complete();
            }
            this.disposeSubject = new Subject();
            this.kbViewer.interaction.onFacetClick.pipe(takeUntil(this.disposeSubject)).subscribe(event => {
                if (!this.selectionsEnabled) {
                    return;
                }
                event.selectedFaces.sort();
                if (event.ctrlKey) {
                    // Add selections
                    for (let i = 0; i < event.selectedFaces.length; i++) {
                        this.currentSelection.set(event.selectedFaces[i], null);
                    }
                }
                else if (event.altKey) {
                    // Remove selections
                    for (let i = 0; i < event.selectedFaces.length; i++) {
                        this.currentSelection.delete(event.selectedFaces[i]);
                    }
                }
                else {
                    this.currentSelection.clear();
                    for (let i = 0; i < event.selectedFaces.length; i++) {
                        this.currentSelection.set(event.selectedFaces[i], null);
                    }
                }
                const result = this.getVertexGroups(this.currentSelection.keys());
                this.visualizeSubmesh(mesh, result, exports.KbColor.Red());
                this.onSelectionChange.notifyObservers({ selectedFacets: result });
            });
        }
        updateGizmoPosition() {
            this.kbViewer.forceAndWaitForNextRender().then(() => {
                if (this.__attachedMesh) {
                    const result = this.getVertexGroups(this.currentSelection.keys());
                    this.visualizeSubmesh(this.__attachedMesh, result, exports.KbColor.Red(), true);
                }
            });
        }
        selectFacetGroups(selection) {
            selection.forEach(vertexGroup => {
                if (vertexGroup.startIndex === undefined || vertexGroup.endIndex === undefined) {
                    throw Error('corrupt vertex group');
                }
                const startFacet = Math.round(vertexGroup.startIndex / 3);
                const endFacet = Math.ceil(vertexGroup.endIndex / 3);
                for (let i = startFacet; i < endFacet; i++) {
                    this.currentSelection.set(i, null);
                }
            });
            this.updateGizmoPosition();
        }
        enableSelectionChange() {
            this.selectionsEnabled = true;
            if (this.__attachedNode) {
                this.kbViewer.interaction
                    .enableMarqueeSelect(this.__attachedNode, exports.eMarqueeSelectMode.Facets)
                    .pipe(takeUntil(this.disposeSubject))
                    .subscribe(event => {
                    if (this.selectionsEnabled &&
                        this.__attachedMesh &&
                        event.selectedFaces &&
                        event.selectedFaces.length > 0) {
                        if (event.ctrlKey) {
                            // Add selections
                            for (let i = 0; i < event.selectedFaces.length; i++) {
                                this.currentSelection.set(event.selectedFaces[i], null);
                            }
                        }
                        else if (event.altKey) {
                            // Remove selections
                            for (let i = 0; i < event.selectedFaces.length; i++) {
                                this.currentSelection.delete(event.selectedFaces[i]);
                            }
                        }
                        else {
                            this.currentSelection.clear();
                            for (let i = 0; i < event.selectedFaces.length; i++) {
                                this.currentSelection.set(event.selectedFaces[i], null);
                            }
                        }
                        const result = this.getVertexGroups(this.currentSelection.keys());
                        this.visualizeSubmesh(this.__attachedMesh, result, exports.KbColor.Red());
                        this.onSelectionChange.notifyObservers({ selectedFacets: result });
                    }
                });
            }
        }
        disableSelectionChange() {
            this.selectionsEnabled = false;
            this.kbViewer.interaction.disableMarqueeSelect();
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            if (this.__attachedNode) {
                this.kbViewer.highlighter.remove(this.__attachedNode);
            }
            if (this.__attachedMesh) {
                const submeshInfo = dbSubmeshes.get(this.__attachedMesh.id);
                submeshInfo === null || submeshInfo === void 0 ? void 0 : submeshInfo.visualizationMesh.setEnabled(false);
            }
        }
        /**
         * CustomMeshes are not supported by this gizmo
         * @param mesh The mesh to replace the default mesh of the gizmo
         */
        setCustomMesh(mesh) {
            Logger.Error('Custom meshes are not supported on this gizmo.');
        }
        setBackfaceCulling(enable) {
            this.kbViewer.interaction.setSelectionCulling(enable);
        }
        setTolerance(tolerance) {
            this.kbViewer.interaction.setSelectionTolerance(tolerance);
        }
        expandSelection(tolerance) {
            if (this.attachedMesh instanceof Mesh) {
                const currentSelection = Array.from(this.currentSelection.keys());
                const newSelection = this.meshFaceEngine.expandSelection(currentSelection, this.attachedMesh, tolerance);
                for (let i = 0; i < newSelection.length; i++) {
                    this.currentSelection.set(newSelection[i], null);
                }
                const result = this.getVertexGroups(this.currentSelection.keys());
                this.visualizeSubmesh(this.attachedMesh, result, exports.KbColor.Red());
                this.onSelectionChange.notifyObservers({ selectedFacets: result });
            }
        }
        setVisualization(opacity) {
            const submeshInfo = dbSubmeshes.get(this.attachedMesh.id);
            if (submeshInfo && submeshInfo.visualizationMesh.material instanceof MultiMaterial) {
                submeshInfo.highlightMaterial.alpha = opacity;
            }
            this.highlightOpacity = opacity;
        }
        getVertexGroups(faceIds) {
            const result = [];
            for (const faceId of faceIds) {
                if (result.length > 0 && result[result.length - 1].endIndex === faceId * 3) {
                    result[result.length - 1].endIndex += 3;
                }
                else {
                    result.push({
                        startIndex: faceId * 3,
                        endIndex: (faceId + 1) * 3,
                    });
                }
            }
            return result;
        }
        visualizeSubmesh(node, vertices, color, geometryNeedsUpdate) {
            if (node instanceof Mesh && node.geometry) {
                let submeshInfo = dbSubmeshes.get(node.id);
                let highlightMaterial;
                const utilityLayerScene = this.utilLayer.utilityLayerScene;
                if (submeshInfo) {
                    highlightMaterial = submeshInfo.highlightMaterial;
                }
                if (submeshInfo && geometryNeedsUpdate) {
                    submeshInfo.visualizationMesh.dispose();
                    submeshInfo = undefined;
                }
                if (!submeshInfo) {
                    const multiMaterial = new MultiMaterial(`submeshVisualizationMat_${node.id}`, utilityLayerScene);
                    const transparantMaterial = new StandardMaterial(`submeshVisualizationMat1_${node.id}`, utilityLayerScene);
                    transparantMaterial.alpha = 0;
                    multiMaterial.subMaterials.push(transparantMaterial);
                    if (!highlightMaterial) {
                        highlightMaterial = new StandardMaterial(`submeshVisualizationMat2_${node.id}`, utilityLayerScene);
                        highlightMaterial.emissiveColor = (color === null || color === void 0 ? void 0 : color.toColor3()) || exports.KbColor.KbmaxOrange().toColor3();
                        highlightMaterial.alpha = this.highlightOpacity;
                    }
                    multiMaterial.subMaterials.push(highlightMaterial);
                    submeshInfo = {
                        visualizationMesh: new Mesh(`submeshVisualization_${node.id}`, utilityLayerScene, null, node, true),
                        highlightMaterial,
                        vertices,
                    };
                    submeshInfo.visualizationMesh.makeGeometryUnique();
                    submeshInfo.visualizationMesh.material = multiMaterial;
                    submeshInfo.visualizationMesh.isPickable = false;
                    dbSubmeshes.set(node.id, submeshInfo);
                }
                else {
                    submeshInfo.visualizationMesh.setEnabled(true);
                }
                const vMesh = submeshInfo.visualizationMesh;
                const totalIndices = node.geometry.getTotalIndices();
                const totalVertices = node.geometry.getTotalVertices();
                vMesh.subMeshes = [];
                new SubMesh(0, 0, totalVertices, 0, totalIndices, vMesh);
                vertices.forEach(indexGroup => {
                    if (indexGroup.startIndex === undefined || indexGroup.endIndex === undefined) {
                        throw Error('Missing submesh information');
                    }
                    new SubMesh(1, 0, totalVertices, indexGroup.startIndex, indexGroup.endIndex - indexGroup.startIndex, vMesh);
                });
            }
        }
    }

    /**
     * Gizmo that enables dragging and rotating lights
     */
    class KbLightGizmo extends KbGizmo {
        attachTo(lightNode) {
            const light = this.kbViewer.getRendererNode(lightNode);
            if (!light) {
                console.warn('could not find light in scene');
                return;
            }
            this._attachedLight = lightNode;
            if (this.posGizmo) {
                this.posGizmo.dispose();
            }
            if (this.rotGizmo) {
                this.rotGizmo.dispose();
            }
            const _helperMesh = (this._helperMesh = new AbstractMesh('', this.gizmoLayer.utilityLayerScene));
            _helperMesh.rotationQuaternion = Quaternion.Identity();
            const lightVisual = this.updatePreviewMesh(light);
            _helperMesh.addChild(lightVisual);
        }
        /**
         * Creates a PositionGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         */
        constructor(kbViewer, gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer) {
            super(gizmoLayer);
            this.kbViewer = kbViewer;
            this.attachedMesh = null;
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            if (this.posGizmo) {
                this.posGizmo.dispose();
            }
            if (this.rotGizmo) {
                this.rotGizmo.dispose();
            }
            if (this._helperMesh) {
                this._helperMesh.dispose();
            }
            if (this.lightPositionGizmo) {
                this.lightPositionGizmo.dispose();
            }
            delete this._attachedLight;
        }
        updateGizmoPosition(lightNode) {
            if (!lightNode) {
                return;
            }
            const light = this.kbViewer.getRendererNode(lightNode);
            if (light) {
                if (!this._attachedLight || lightNode._dynamicId !== this._attachedLight._dynamicId) {
                    this.attachTo(lightNode);
                }
                else {
                    this.updatePreviewMesh(light);
                }
            }
        }
        updatePreviewMesh(light) {
            const scene = this.gizmoLayer.utilityLayerScene;
            if (!this.lightPositionGizmo) {
                this.lightPositionGizmo = createLightVisualization(light, scene);
            }
            if (light instanceof SpotLight || light instanceof PointLight) {
                this.lightPositionGizmo.position = light.parent
                    ? Vector3.TransformCoordinates(light.position, light.parent.computeWorldMatrix(true).clone().invert())
                    : light.position;
            }
            return this.lightPositionGizmo;
        }
    }

    /**
     * Single axis drag gizmo
     */
    class KbAxisDragGizmo extends KbGizmo {
        /** @hidden */
        static _CreateArrow(scene, material) {
            const arrow = new TransformNode('arrow', scene);
            const cylinder = CylinderBuilder.CreateCylinder('cylinder', { diameterTop: 0, height: 0.075, diameterBottom: 0.0375, tessellation: 12 }, scene);
            const line = CylinderBuilder.CreateCylinder('cylinder', { diameterTop: 0.01, height: 0.275, diameterBottom: 0.01, tessellation: 6 }, scene);
            const drag = CylinderBuilder.CreateCylinder('cylinder', { diameterTop: 0.06, height: 0.4, diameterBottom: 0.06, tessellation: 6 }, scene);
            line.material = material;
            cylinder.parent = arrow;
            line.parent = arrow;
            drag.parent = arrow;
            // Position arrow pointing in its drag axis
            cylinder.material = material;
            cylinder.rotation.x = Math.PI / 2;
            cylinder.position.z += 0.3;
            line.position.z += 0.275 / 2;
            line.rotation.x = Math.PI / 2;
            drag.position.z += 0.4 / 2;
            drag.rotation = line.rotation;
            drag.visibility = 0;
            return arrow;
        }
        /** @hidden */
        static _CreateArrowInstance(scene, arrow) {
            const instance = new TransformNode('arrow', scene);
            for (const mesh of arrow.getChildMeshes()) {
                const childInstance = mesh.createInstance(mesh.name);
                childInstance.parent = instance;
            }
            return instance;
        }
        /**
         * Creates an AxisDragGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param dragAxis The axis which the gizmo will be able to drag on
         * @param color The color of the gizmo
         */
        constructor(dragAxis, color = Color3.Gray(), gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer) {
            super(gizmoLayer);
            this._pointerObserver = null;
            /**
             * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
             */
            this.snapDistance = 0;
            /**
             * Event that fires each time the gizmo snaps to a new location.
             * * snapDistance is the the change in distance
             */
            this.onSnapObservable = new Observable$1();
            this.updateObservable = new Observable$1();
            // Create Material
            const coloredMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            coloredMaterial.emissiveColor = color;
            // coloredMaterial.diffuseColor = color;
            // coloredMaterial.specularColor = color.subtract(new Color3(0.1, 0.1, 0.1));
            const hoverMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            hoverMaterial.emissiveColor = color.add(new Color3(0.3, 0.3, 0.3));
            // hoverMaterial.diffuseColor = color.add(new Color3(0.3, 0.3, 0.3));
            // Build mesh on root node
            const arrow = KbAxisDragGizmo._CreateArrow(gizmoLayer.utilityLayerScene, coloredMaterial);
            arrow.lookAt(this._rootMesh.position.add(dragAxis));
            arrow.scaling.scaleInPlace(1 / 3);
            arrow.parent = this._rootMesh;
            let currentSnapDragDistance = 0;
            const tmpVector = new Vector3();
            const tmpSnapEvent = { snapDistance: 0 };
            // Add drag behavior to handle events when the gizmo is dragged
            this.dragBehavior = new PointerDragBehavior({ dragAxis: dragAxis });
            this.dragBehavior.moveAttached = false;
            this._rootMesh.addBehavior(this.dragBehavior);
            const localDelta = new Vector3();
            const tmpMatrix = new Matrix();
            this.dragBehavior.onDragObservable.add(event => {
                if (this.attachedMesh) {
                    // Convert delta to local translation if it has a parent
                    if (this.attachedMesh.parent) {
                        this.attachedMesh.parent.computeWorldMatrix().invertToRef(tmpMatrix);
                        tmpMatrix.setTranslationFromFloats(0, 0, 0);
                        Vector3.TransformCoordinatesToRef(event.delta, tmpMatrix, localDelta);
                    }
                    else {
                        localDelta.copyFrom(event.delta);
                    }
                    // Snapping logic
                    if (this.snapDistance == 0) {
                        this.attachedMesh.position.addInPlace(localDelta);
                        this.updateObservable.notifyObservers({ delta: localDelta });
                    }
                    else {
                        currentSnapDragDistance += event.dragDistance;
                        if (Math.abs(currentSnapDragDistance) > this.snapDistance) {
                            const dragSteps = Math.floor(Math.abs(currentSnapDragDistance) / this.snapDistance);
                            currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                            localDelta.normalizeToRef(tmpVector);
                            tmpVector.scaleInPlace(this.snapDistance * dragSteps);
                            this.attachedMesh.position.addInPlace(tmpVector);
                            tmpSnapEvent.snapDistance = this.snapDistance * dragSteps;
                            this.updateObservable.notifyObservers({ delta: tmpVector });
                            this.onSnapObservable.notifyObservers(tmpSnapEvent);
                        }
                    }
                }
            });
            this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add(pointerInfo => {
                if (this._customMeshSet) {
                    return;
                }
                const isHovered = pointerInfo.pickInfo &&
                    this._rootMesh.getChildMeshes().indexOf(pointerInfo.pickInfo.pickedMesh) != -1;
                const material = isHovered ? hoverMaterial : coloredMaterial;
                this._rootMesh.getChildMeshes().forEach(m => {
                    m.material = material;
                    if (m.color) {
                        m.color = material.diffuseColor;
                    }
                });
            });
        }
        _attachedMeshChanged(value) {
            if (this.dragBehavior) {
                this.dragBehavior.enabled = value ? true : false;
            }
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            this.onSnapObservable.clear();
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
            this.dragBehavior.detach();
            super.dispose();
        }
    }

    /**
     * Gizmo that enables dragging a mesh along 3 axis
     */
    class KbPositionGizmo extends KbGizmo {
        attachTo(target, positionSpace, orientGizmo) {
            if (orientGizmo) {
                this.xGizmo.updateGizmoRotationToMatchAttachedMesh = false;
                this.yGizmo.updateGizmoRotationToMatchAttachedMesh = false;
                this.zGizmo.updateGizmoRotationToMatchAttachedMesh = false;
                this.xGizmo._rootMesh.rotationQuaternion = orientGizmo;
                this.yGizmo._rootMesh.rotationQuaternion = orientGizmo;
                this.zGizmo._rootMesh.rotationQuaternion = orientGizmo;
            }
            if (!positionSpace && target instanceof exports.SpaceNode && target._parent) {
                positionSpace = target._parent;
            }
            if (positionSpace) {
                this._positionSpace = this.kbViewer.getRendererNode(positionSpace);
            }
            if (target instanceof exports.SpaceNode) {
                this._attachedSpaceNode = target;
                this._updateGizmoPosition();
            }
            else {
                this._updateGizmoPosition(target);
            }
        }
        updateGizmoPosition(changeTarget) {
            // Need to wait for the next frame because this can be called before the babylon object is actually updated
            this.kbViewer.onNextFrame(() => {
                this._updateGizmoPosition(changeTarget);
            });
        }
        _updateGizmoPosition(changeTarget) {
            var _a;
            const positionSpaceTransform = (_a = this._positionSpace) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
            if (changeTarget) {
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, changeTarget, positionSpaceTransform);
            }
            else if (this._attachedSpaceNode) {
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, this._attachedSpaceNode, positionSpaceTransform);
            }
            super.updateGizmoPosition();
        }
        get attachedMesh() {
            if (this.xGizmo) {
                return this.xGizmo.attachedMesh;
            }
            else if (this.yGizmo) {
                return this.yGizmo.attachedMesh;
            }
            else {
                return this.zGizmo.attachedMesh;
            }
        }
        set attachedMesh(mesh) {
            if (this.xGizmo) {
                this.xGizmo.attachedMesh = mesh;
            }
            if (this.yGizmo) {
                this.yGizmo.attachedMesh = mesh;
            }
            if (this.zGizmo) {
                this.zGizmo.attachedMesh = mesh;
            }
            if (mesh) {
                this._rootMesh.rotationQuaternion = mesh.rotationQuaternion
                    ? mesh.rotationQuaternion
                    : mesh.rotation.toQuaternion();
                this._rootMesh.position = mesh.position;
                this._rootMesh.setPivotPoint(mesh.getPivotPoint(), Space.WORLD);
            }
        }
        get visibility() {
            return this.xGizmo.visibility;
        }
        set visibility(visibility) {
            if (this.xGizmo) {
                this.xGizmo.visibility = visibility;
                this.yGizmo.visibility = visibility;
                this.zGizmo.visibility = visibility;
            }
        }
        /**
         * Creates a PositionGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         */
        constructor(kbViewer, gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer, axisVisibility) {
            super(gizmoLayer);
            this.kbViewer = kbViewer;
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onDragStartObservable = new Observable$1();
            /** Fires an event while any of it's sub gizmos are dragged */
            this.onDragObservable = new Observable$1();
            /** Fires an event when any of it's sub gizmos are released from dragging */
            this.onDragEndObservable = new Observable$1();
            this.positionChange = Vector3.Zero();
            let activeGizmos = [];
            if (axisVisibility) {
                if (axisVisibility[0]) {
                    this.xGizmo = new KbAxisDragGizmo(new Vector3(1, 0, 0), Color3.Red().scale(0.5), gizmoLayer);
                    this.xGizmo.updateGizmoRotationToMatchAttachedMesh = axisVisibility[0];
                    this.xGizmo.updateGizmoPositionToMatchAttachedMesh = axisVisibility[0];
                    activeGizmos.push(this.xGizmo);
                }
                if (axisVisibility[1]) {
                    this.yGizmo = new KbAxisDragGizmo(new Vector3(0, 1, 0), Color3.Green().scale(0.5), gizmoLayer);
                    this.yGizmo.updateGizmoRotationToMatchAttachedMesh = axisVisibility[1];
                    this.yGizmo.updateGizmoPositionToMatchAttachedMesh = axisVisibility[1];
                    activeGizmos.push(this.yGizmo);
                }
                if (axisVisibility[2]) {
                    this.zGizmo = new KbAxisDragGizmo(new Vector3(0, 0, 1), Color3.Blue().scale(0.5), gizmoLayer);
                    this.zGizmo.updateGizmoRotationToMatchAttachedMesh = axisVisibility[2];
                    this.zGizmo.updateGizmoPositionToMatchAttachedMesh = axisVisibility[2];
                    activeGizmos.push(this.zGizmo);
                }
            }
            else {
                this.xGizmo = new KbAxisDragGizmo(new Vector3(1, 0, 0), Color3.Red().scale(0.5), gizmoLayer);
                this.yGizmo = new KbAxisDragGizmo(new Vector3(0, 1, 0), Color3.Green().scale(0.5), gizmoLayer);
                this.zGizmo = new KbAxisDragGizmo(new Vector3(0, 0, 1), Color3.Blue().scale(0.5), gizmoLayer);
                this.xGizmo.updateGizmoRotationToMatchAttachedMesh = true;
                this.yGizmo.updateGizmoRotationToMatchAttachedMesh = true;
                this.zGizmo.updateGizmoRotationToMatchAttachedMesh = true;
                this.xGizmo.updateGizmoPositionToMatchAttachedMesh = true;
                this.yGizmo.updateGizmoPositionToMatchAttachedMesh = true;
                this.zGizmo.updateGizmoPositionToMatchAttachedMesh = true;
                activeGizmos = [this.xGizmo, this.yGizmo, this.zGizmo];
            }
            // Relay drag events
            activeGizmos.forEach(gizmo => {
                gizmo.dragBehavior.onDragStartObservable.add(() => {
                    this.onDragStartObservable.notifyObservers();
                    this.positionChange.setAll(0);
                });
                gizmo.updateObservable.add(event => {
                    // transform the rotation to be in local space, the gizmos return global space movements
                    const transform = new Matrix();
                    this.attachedMesh.computeWorldMatrix(true).invertToRef(transform);
                    transform.setTranslation(Vector3.Zero());
                    const { delta } = event;
                    const result = Vector3.TransformCoordinates(delta, transform);
                    // squish floating point errors that look gross in the output
                    if (Math.abs(result.x) < 0.00000001)
                        result.x = 0;
                    if (Math.abs(result.y) < 0.00000001)
                        result.y = 0;
                    if (Math.abs(result.z) < 0.00000001)
                        result.z = 0;
                    this.positionChange.addInPlace(result);
                    this.onDragObservable.notifyObservers({ delta: result });
                });
                gizmo.dragBehavior.onDragEndObservable.add(() => {
                    this.onDragEndObservable.notifyObservers({ delta: this.positionChange });
                });
            });
            this.attachedMesh = null;
        }
        /**
         * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */
        set snapDistance(value) {
            if (this.xGizmo) {
                this.xGizmo.snapDistance = value;
            }
            if (this.yGizmo) {
                this.yGizmo.snapDistance = value;
            }
            if (this.zGizmo) {
                this.zGizmo.snapDistance = value;
            }
        }
        get snapDistance() {
            if (this.xGizmo) {
                return this.xGizmo.snapDistance;
            }
            else if (this.yGizmo) {
                return this.yGizmo.snapDistance;
            }
            else {
                return this.zGizmo.snapDistance;
            }
        }
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */
        set scaleRatio(value) {
            if (this.xGizmo) {
                this.xGizmo.scaleRatio = value;
            }
            if (this.yGizmo) {
                this.yGizmo.scaleRatio = value;
            }
            if (this.zGizmo) {
                this.zGizmo.scaleRatio = value;
            }
        }
        get scaleRatio() {
            if (this.xGizmo) {
                return this.xGizmo.scaleRatio;
            }
            else if (this.yGizmo) {
                return this.yGizmo.scaleRatio;
            }
            else {
                return this.zGizmo.scaleRatio;
            }
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            if (this.xGizmo) {
                this.xGizmo.dispose();
            }
            if (this.yGizmo) {
                this.yGizmo.dispose();
            }
            if (this.zGizmo) {
                this.zGizmo.dispose();
            }
            this.onDragStartObservable.clear();
            this.onDragEndObservable.clear();
            if (this.attachedMesh && this.attachedMesh.name === AUTO_MESH_NAME) {
                this.attachedMesh.dispose();
            }
        }
        /**
         * CustomMeshes are not supported by this gizmo
         * @param mesh The mesh to replace the default mesh of the gizmo
         */
        setCustomMesh(mesh) {
            Logger.Error('Custom meshes are not supported on this gizmo, please set the custom meshes on the gizmos contained within this one (gizmo.xGizmo, gizmo.yGizmo, gizmo.zGizmo)');
        }
    }

    const tessellation$1 = 32;
    /**
     * Gizmo that enables rotating a mesh along 3 axis
     */
    class KbRotationGizmo extends KbGizmo {
        attachTo(target, positionSpace, placementOffset) {
            if (!positionSpace && target instanceof exports.SpaceNode && target._parent) {
                positionSpace = target._parent;
            }
            if (positionSpace) {
                this._positionSpace = this.kbViewer.getRendererNode(positionSpace);
            }
            if (target instanceof exports.SpaceNode) {
                this._attachedSpaceNode = target;
                this._updateGizmoPosition();
            }
            else {
                this._updateGizmoPosition(target, placementOffset);
            }
        }
        updateGizmoPosition(changeTarget, placementOffset) {
            // Need to wait for the next frame because this can be called before the babylon object is actually updated
            this.kbViewer.onNextFrame(() => {
                this._updateGizmoPosition(changeTarget, placementOffset);
            });
        }
        _updateGizmoPosition(changeTarget, placementOffset) {
            var _a, _b;
            const positionSpaceTransform = (_a = this._positionSpace) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
            if (changeTarget) {
                // If target is a vector, then we want to rotate it as a direction, so set the gizmo position to the origin to calculations are done from there
                // But store the position as the offset because we want the gizmo itself to be visually placed on the position space origin
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, placementOffset || exports.KbVector.Zero(), positionSpaceTransform);
                const corr = rotationToVector(changeTarget.toVec3(), Vector3.Up());
                this.gizmoOffset = exports.KbVector.FromVec3(this.attachedMesh.position);
                this.attachedMesh.position = Vector3.Zero();
                (_b = this.attachedMesh.rotationQuaternion) === null || _b === void 0 ? void 0 : _b.multiplyInPlace(corr);
                this.attachedMesh.computeWorldMatrix(true);
            }
            else if (this._attachedSpaceNode) {
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, this._attachedSpaceNode.position.add(this._attachedSpaceNode.pivot), positionSpaceTransform);
                let currentRotation;
                // Rotation gizmo should be rotated to match the current rotation if the target is a node
                if (this._attachedSpaceNode.useEuler) {
                    currentRotation = this._attachedSpaceNode.eulerRotation
                        .toVec3()
                        .scale(Math.PI / 180)
                        .toQuaternion();
                }
                else {
                    currentRotation = rotationToVector(this._attachedSpaceNode.rotationAxis.toVec3());
                }
                this.attachedMesh.rotationQuaternion = (positionSpaceTransform
                    ? Quaternion.FromRotationMatrix(positionSpaceTransform.getRotationMatrix())
                    : Quaternion.Identity()).multiply(currentRotation);
            }
            this.gizmoOffset && this.attachedMesh.position.addInPlace(this.gizmoOffset.toVec3());
            super.updateGizmoPosition();
        }
        get attachedMesh() {
            return (this.xGizmo || this.yGizmo || this.zGizmo).attachedMesh;
        }
        set attachedMesh(mesh) {
            if (this.xGizmo) {
                this.xGizmo.attachedMesh = mesh;
            }
            if (this.yGizmo) {
                this.yGizmo.attachedMesh = mesh;
            }
            if (this.zGizmo) {
                this.zGizmo.attachedMesh = mesh;
            }
            if (mesh) {
                this._rootMesh.setPivotPoint(mesh.getPivotPoint(), Space.WORLD);
            }
        }
        /**
         * Creates a RotationGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param tessellation Amount of tessellation to be used when creating rotation circles
         */
        constructor(kbViewer, gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer, axes, axisVisibility) {
            super(gizmoLayer);
            this.kbViewer = kbViewer;
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onDragStartObservable = new Observable$1();
            /** Fires an event when any of it's sub gizmos are released from dragging */
            this.onDragObservable = new Observable$1();
            this.onDragEndObservable = new Observable$1();
            let activeGizmos = [];
            if (axisVisibility) {
                if (axisVisibility[0]) {
                    this.xGizmo = new KbPlaneRotationGizmo(new Vector3(1, 0, 0), Color3.Red().scale(0.5), gizmoLayer, tessellation$1);
                    this.xGizmo.updateGizmoRotationToMatchAttachedMesh = axisVisibility[0];
                    this.xGizmo.updateGizmoPositionToMatchAttachedMesh = axisVisibility[0];
                    activeGizmos.push(this.xGizmo);
                }
                if (axisVisibility[1]) {
                    this.yGizmo = new KbPlaneRotationGizmo(new Vector3(0, 1, 0), Color3.Green().scale(0.5), gizmoLayer, tessellation$1);
                    this.yGizmo.updateGizmoRotationToMatchAttachedMesh = axisVisibility[1];
                    this.yGizmo.updateGizmoPositionToMatchAttachedMesh = axisVisibility[1];
                    activeGizmos.push(this.yGizmo);
                }
                if (axisVisibility[2]) {
                    this.zGizmo = new KbPlaneRotationGizmo(new Vector3(0, 0, 1), Color3.Blue().scale(0.5), gizmoLayer, tessellation$1);
                    this.zGizmo.updateGizmoRotationToMatchAttachedMesh = axisVisibility[2];
                    this.zGizmo.updateGizmoPositionToMatchAttachedMesh = axisVisibility[2];
                    activeGizmos.push(this.zGizmo);
                }
            }
            else {
                this.updateGizmoRotationToMatchAttachedMesh = true;
                if (!axes || axes.x) {
                    this.xGizmo = new KbPlaneRotationGizmo(new Vector3(1, 0, 0), Color3.Red().scale(0.5), gizmoLayer, tessellation$1);
                    this.xGizmo.updateGizmoRotationToMatchAttachedMesh = true;
                    this.xGizmo.updateGizmoPositionToMatchAttachedMesh = true;
                }
                if (!axes || axes.y) {
                    this.yGizmo = new KbPlaneRotationGizmo(new Vector3(0, 1, 0), Color3.Green().scale(0.5), gizmoLayer, tessellation$1);
                    this.yGizmo.updateGizmoRotationToMatchAttachedMesh = true;
                    this.yGizmo.updateGizmoPositionToMatchAttachedMesh = true;
                }
                if (!axes || axes.z) {
                    this.zGizmo = new KbPlaneRotationGizmo(new Vector3(0, 0, 1), Color3.Blue().scale(0.5), gizmoLayer, tessellation$1);
                    this.zGizmo.updateGizmoRotationToMatchAttachedMesh = true;
                    this.zGizmo.updateGizmoPositionToMatchAttachedMesh = true;
                }
                activeGizmos = [this.xGizmo, this.yGizmo, this.zGizmo];
            }
            this.rotationChange = Quaternion.Identity();
            // Relay drag events
            activeGizmos.forEach(gizmo => {
                if (gizmo) {
                    gizmo.dragBehavior.onDragStartObservable.add(() => {
                        this.onDragStartObservable.notifyObservers();
                        this.rotationChange = Quaternion.Identity();
                    });
                    gizmo.updateObservable.add(event => {
                        this.rotationChange.multiplyInPlace(event.delta);
                        this.onDragObservable.notifyObservers({ delta: event.delta });
                    });
                    gizmo.dragBehavior.onDragEndObservable.add(() => {
                        this.onDragEndObservable.notifyObservers({ delta: this.rotationChange });
                    });
                }
            });
            this.attachedMesh = null;
        }
        /**
         * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */
        set snapDistance(value) {
            if (this.xGizmo) {
                this.xGizmo.snapDistance = value;
            }
            if (this.yGizmo) {
                this.yGizmo.snapDistance = value;
            }
            if (this.zGizmo) {
                this.zGizmo.snapDistance = value;
            }
        }
        get snapDistance() {
            return (this.xGizmo || this.yGizmo || this.zGizmo).snapDistance;
        }
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */
        set scaleRatio(value) {
            if (this.xGizmo) {
                this.xGizmo.scaleRatio = value;
            }
            if (this.yGizmo) {
                this.yGizmo.scaleRatio = value;
            }
            if (this.zGizmo) {
                this.zGizmo.scaleRatio = value;
            }
        }
        get scaleRatio() {
            return (this.xGizmo || this.yGizmo || this.zGizmo).scaleRatio;
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            if (this.xGizmo) {
                this.xGizmo.dispose();
            }
            if (this.yGizmo) {
                this.yGizmo.dispose();
            }
            if (this.zGizmo) {
                this.zGizmo.dispose();
            }
            this.onDragStartObservable.clear();
            this.onDragEndObservable.clear();
        }
        /**
         * CustomMeshes are not supported by this gizmo
         * @param mesh The mesh to replace the default mesh of the gizmo
         */
        setCustomMesh(mesh) {
            Logger.Error('Custom meshes are not supported on this gizmo, please set the custom meshes on the gizmos contained within this one (gizmo.xGizmo, gizmo.yGizmo, gizmo.zGizmo)');
        }
    }

    /**
     * Single axis scale gizmo
     */
    class KbAxisScaleGizmo extends KbGizmo {
        /**
         * Creates an AxisScaleGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         * @param dragAxis The axis which the gizmo will be able to scale on
         * @param color The color of the gizmo
         */
        constructor(dragAxis, color = Color3.Gray(), gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer) {
            super(gizmoLayer);
            this._pointerObserver = null;
            /**
             * Scale distance in babylon units that the gizmo will snap to when dragged (Default: 0)
             */
            this.snapDistance = 0;
            /**
             * Event that fires each time the gizmo snaps to a new location.
             * * snapDistance is the the change in distance
             */
            this.onSnapObservable = new Observable$1();
            this.updateObservable = new Observable$1();
            /**
             * If the scaling operation should be done on all axis (default: false)
             */
            this.uniformScaling = false;
            // Create Material
            this._coloredMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            this._coloredMaterial.disableLighting = true;
            this._coloredMaterial.emissiveColor = color;
            // this._coloredMaterial.diffuseColor = color;
            // this._coloredMaterial.specularColor = color.subtract(new Color3(0.1, 0.1, 0.1));
            const hoverMaterial = new StandardMaterial('', gizmoLayer.utilityLayerScene);
            hoverMaterial.disableLighting = true;
            hoverMaterial.emissiveColor = color.add(new Color3(0.3, 0.3, 0.3));
            // hoverMaterial.diffuseColor = color.add(new Color3(0.3, 0.3, 0.3));
            // Build mesh on root node
            const arrow = new AbstractMesh('', gizmoLayer.utilityLayerScene);
            const arrowMesh = BoxBuilder.CreateBox('yPosMesh', { size: 0.4 }, gizmoLayer.utilityLayerScene);
            const arrowTail = CylinderBuilder.CreateCylinder('cylinder', { diameterTop: 0.005, height: 0.275, diameterBottom: 0.005, tessellation: 96 }, gizmoLayer.utilityLayerScene);
            arrowTail.material = this._coloredMaterial;
            arrow.addChild(arrowMesh);
            arrow.addChild(arrowTail);
            // Position arrow pointing in its drag axis
            arrowMesh.scaling.scaleInPlace(0.1);
            arrowMesh.material = this._coloredMaterial;
            arrowMesh.rotation.x = Math.PI / 2;
            arrowMesh.position.z += 0.3;
            arrowTail.position.z += 0.275 / 2;
            arrowTail.rotation.x = Math.PI / 2;
            arrow.lookAt(this._rootMesh.position.add(dragAxis));
            this._rootMesh.addChild(arrow);
            arrow.scaling.scaleInPlace(1 / 3);
            // Add drag behavior to handle events when the gizmo is dragged
            this.dragBehavior = new PointerDragBehavior({ dragAxis: dragAxis });
            this.dragBehavior.moveAttached = false;
            this._rootMesh.addBehavior(this.dragBehavior);
            let currentSnapDragDistance = 0;
            const tmpVector = new Vector3();
            const tmpSnapEvent = { snapDistance: 0 };
            this.dragBehavior.onDragObservable.add(event => {
                if (this.attachedMesh) {
                    // Drag strength is modified by the scale of the gizmo (eg. for small objects like boombox the strength will be increased to match the behavior of larger objects)
                    const dragStrength = event.dragDistance * ((this.scaleRatio * 8) / this._rootMesh.scaling.length());
                    // Snapping logic
                    let snapped = false;
                    let dragSteps = 0;
                    if (this.uniformScaling) {
                        this.attachedMesh.scaling.normalizeToRef(tmpVector);
                        if (tmpVector.y < 0) {
                            tmpVector.scaleInPlace(-1);
                        }
                    }
                    else {
                        tmpVector.copyFrom(dragAxis);
                    }
                    if (this.snapDistance == 0) {
                        tmpVector.scaleToRef(dragStrength, tmpVector);
                    }
                    else {
                        currentSnapDragDistance += dragStrength;
                        if (Math.abs(currentSnapDragDistance) > this.snapDistance) {
                            dragSteps = Math.floor(Math.abs(currentSnapDragDistance) / this.snapDistance);
                            if (currentSnapDragDistance < 0) {
                                dragSteps *= -1;
                            }
                            currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                            tmpVector.scaleToRef(this.snapDistance * dragSteps, tmpVector);
                            snapped = true;
                        }
                        else {
                            tmpVector.scaleInPlace(0);
                        }
                    }
                    this.attachedMesh.scaling.addInPlace(tmpVector);
                    this.updateObservable.notifyObservers({ delta: tmpVector });
                    if (snapped) {
                        tmpSnapEvent.snapDistance = this.snapDistance * dragSteps;
                        this.onSnapObservable.notifyObservers(tmpSnapEvent);
                    }
                }
            });
            this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add(pointerInfo => {
                if (this._customMeshSet) {
                    return;
                }
                const isHovered = pointerInfo.pickInfo &&
                    this._rootMesh.getChildMeshes().indexOf(pointerInfo.pickInfo.pickedMesh) != -1;
                const material = isHovered ? hoverMaterial : this._coloredMaterial;
                this._rootMesh.getChildMeshes().forEach(m => {
                    m.material = material;
                    if (m.color) {
                        m.color = material.diffuseColor;
                    }
                });
            });
            // var light = gizmoLayer._getSharedGizmoLight();
            // light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes());
        }
        _attachedMeshChanged(value) {
            if (this.dragBehavior) {
                this.dragBehavior.enabled = value ? true : false;
            }
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            this.onSnapObservable.clear();
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
            this.dragBehavior.detach();
            super.dispose();
        }
        /**
         * Disposes and replaces the current meshes in the gizmo with the specified mesh
         * @param mesh The mesh to replace the default mesh of the gizmo
         * @param useGizmoMaterial If the gizmo's default material should be used (default: false)
         */
        setCustomMesh(mesh, useGizmoMaterial = false) {
            super.setCustomMesh(mesh);
            if (useGizmoMaterial) {
                this._rootMesh.getChildMeshes().forEach(m => {
                    m.material = this._coloredMaterial;
                    if (m.color) {
                        m.color = this._coloredMaterial.diffuseColor;
                    }
                });
                this._customMeshSet = false;
            }
        }
    }

    /**
     * Gizmo that enables scaling a mesh along 3 axis
     */
    class KbScaleGizmo extends KbGizmo {
        attachTo(target, positionSpace) {
            if (!positionSpace && target instanceof exports.SpaceNode && target._parent) {
                positionSpace = target._parent;
            }
            if (positionSpace) {
                this._positionSpace = this.kbViewer.getRendererNode(positionSpace);
            }
            if (target instanceof exports.SpaceNode) {
                this._attachedSpaceNode = target;
                this._updateGizmoPosition();
            }
            else {
                this._updateGizmoPosition(target);
            }
        }
        updateGizmoPosition(changeTarget) {
            // Need to wait for the next frame because this can be called before the babylon object is actually updated
            this.kbViewer.onNextFrame(() => {
                this._updateGizmoPosition(changeTarget);
            });
        }
        _updateGizmoPosition(changeTarget) {
            var _a;
            const positionSpaceTransform = (_a = this._positionSpace) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
            if (changeTarget) {
                // If target is a vector, then we want to rotate it as a direction, so set the gizmo position to the origin to calculations are done from there
                // But store the position as the offset because we want the gizmo itself to be visually placed on the position space origin
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, changeTarget, positionSpaceTransform);
                this.gizmoOffset = exports.KbVector.FromVec3(this.attachedMesh.position);
            }
            else if (this._attachedSpaceNode) {
                this.attachMeshAtNodeSpace(this.gizmoLayer.utilityLayerScene, this._attachedSpaceNode, positionSpaceTransform);
                // Put the gizmo in the same position as the pivot, in world space
                this.attachedMesh.position.addInPlace(this._attachedSpaceNode.pivot.toVec3());
            }
            super.updateGizmoPosition();
        }
        get attachedMesh() {
            return this.xGizmo.attachedMesh;
        }
        set attachedMesh(mesh) {
            if (this.xGizmo) {
                this.xGizmo.attachedMesh = mesh;
                this.yGizmo.attachedMesh = mesh;
                this.zGizmo.attachedMesh = mesh;
                this.uniformScaleGizmo.attachedMesh = mesh;
            }
        }
        /**
         * Creates a ScaleGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         */
        constructor(kbViewer, gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer) {
            super(gizmoLayer);
            this.kbViewer = kbViewer;
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onDragStartObservable = new Observable$1();
            /** Fires an event while any of it's sub gizmos are dragged */
            this.onDragObservable = new Observable$1();
            /** Fires an event when any of it's sub gizmos are released from dragging */
            this.onDragEndObservable = new Observable$1();
            this.scaleChange = Vector3.Zero();
            this.xGizmo = new KbAxisScaleGizmo(new Vector3(1, 0, 0), Color3.Red().scale(0.5), gizmoLayer);
            this.yGizmo = new KbAxisScaleGizmo(new Vector3(0, 1, 0), Color3.Green().scale(0.5), gizmoLayer);
            this.zGizmo = new KbAxisScaleGizmo(new Vector3(0, 0, 1), Color3.Blue().scale(0.5), gizmoLayer);
            // Create uniform scale gizmo
            this.uniformScaleGizmo = new KbAxisScaleGizmo(new Vector3(0, 1, 0), Color3.Yellow().scale(0.5), gizmoLayer);
            this.uniformScaleGizmo.updateGizmoRotationToMatchAttachedMesh = false;
            this.uniformScaleGizmo.uniformScaling = true;
            const uniformScalingMesh = PolyhedronBuilder.CreatePolyhedron('', { type: 1 }, this.uniformScaleGizmo.gizmoLayer.utilityLayerScene);
            uniformScalingMesh.scaling.scaleInPlace(0.03);
            uniformScalingMesh.visibility = 0;
            const octahedron = PolyhedronBuilder.CreatePolyhedron('', { type: 1 }, this.uniformScaleGizmo.gizmoLayer.utilityLayerScene);
            octahedron.scaling.scaleInPlace(0.007);
            uniformScalingMesh.addChild(octahedron);
            this.uniformScaleGizmo.setCustomMesh(uniformScalingMesh, true);
            // var light = gizmoLayer._getSharedGizmoLight();
            // light.includedOnlyMeshes = light.includedOnlyMeshes.concat(octahedron);
            // Relay drag events
            [this.xGizmo, this.yGizmo, this.zGizmo, this.uniformScaleGizmo].forEach(gizmo => {
                gizmo.dragBehavior.onDragStartObservable.add(() => {
                    this.onDragStartObservable.notifyObservers();
                    this.scaleChange.setAll(0);
                });
                gizmo.updateObservable.add(event => {
                    this.scaleChange.addInPlace(event.delta);
                    this.onDragObservable.notifyObservers({ delta: event.delta });
                });
                gizmo.dragBehavior.onDragEndObservable.add(() => {
                    this.onDragEndObservable.notifyObservers({ delta: this.scaleChange });
                });
            });
            this.attachedMesh = null;
        }
        set updateGizmoRotationToMatchAttachedMesh(value) {
            if (!value) {
                Logger.Warn('Setting updateGizmoRotationToMatchAttachedMesh = false on scaling gizmo is not supported.');
            }
            if (this.xGizmo) {
                this.xGizmo.updateGizmoRotationToMatchAttachedMesh = value;
                this.yGizmo.updateGizmoRotationToMatchAttachedMesh = value;
                this.zGizmo.updateGizmoRotationToMatchAttachedMesh = value;
            }
        }
        get updateGizmoRotationToMatchAttachedMesh() {
            return this.xGizmo.updateGizmoRotationToMatchAttachedMesh;
        }
        /**
         * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */
        set snapDistance(value) {
            if (this.xGizmo) {
                this.xGizmo.snapDistance = value;
                this.yGizmo.snapDistance = value;
                this.zGizmo.snapDistance = value;
                this.uniformScaleGizmo.snapDistance = value;
            }
        }
        get snapDistance() {
            return this.xGizmo.snapDistance;
        }
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */
        set scaleRatio(value) {
            if (this.xGizmo) {
                this.xGizmo.scaleRatio = value;
                this.yGizmo.scaleRatio = value;
                this.zGizmo.scaleRatio = value;
                this.uniformScaleGizmo.scaleRatio = value;
            }
        }
        get scaleRatio() {
            return this.xGizmo.scaleRatio;
        }
        /**
         * Disposes of the gizmo
         */
        dispose() {
            this.xGizmo.dispose();
            this.yGizmo.dispose();
            this.zGizmo.dispose();
            this.uniformScaleGizmo.dispose();
            this.onDragStartObservable.clear();
            this.onDragEndObservable.clear();
        }
    }

    /** Class used to store color4 gradient */
    class ColorGradient {
        /**
         * Creates a new color4 gradient
         * @param gradient gets or sets the gradient value (between 0 and 1)
         * @param color1 gets or sets first associated color
         * @param color2 gets or sets first second color
         */
        constructor(
        /**
         * Gets or sets the gradient value (between 0 and 1)
         */
        gradient, 
        /**
         * Gets or sets first associated color
         */
        color1, 
        /**
         * Gets or sets second associated color
         */
        color2) {
            this.gradient = gradient;
            this.color1 = color1;
            this.color2 = color2;
        }
        /**
         * Will get a color picked randomly between color1 and color2.
         * If color2 is undefined then color1 will be used
         * @param result defines the target Color4 to store the result in
         */
        getColorToRef(result) {
            if (!this.color2) {
                result.copyFrom(this.color1);
                return;
            }
            Color4.LerpToRef(this.color1, this.color2, Math.random(), result);
        }
    }
    /** Class used to store color 3 gradient */
    class Color3Gradient {
        /**
         * Creates a new color3 gradient
         * @param gradient gets or sets the gradient value (between 0 and 1)
         * @param color gets or sets associated color
         */
        constructor(
        /**
         * Gets or sets the gradient value (between 0 and 1)
         */
        gradient, 
        /**
         * Gets or sets the associated color
         */
        color) {
            this.gradient = gradient;
            this.color = color;
        }
    }
    /** Class used to store factor gradient */
    class FactorGradient {
        /**
         * Creates a new factor gradient
         * @param gradient gets or sets the gradient value (between 0 and 1)
         * @param factor1 gets or sets first associated factor
         * @param factor2 gets or sets second associated factor
         */
        constructor(
        /**
         * Gets or sets the gradient value (between 0 and 1)
         */
        gradient, 
        /**
         * Gets or sets first associated factor
         */
        factor1, 
        /**
         * Gets or sets second associated factor
         */
        factor2) {
            this.gradient = gradient;
            this.factor1 = factor1;
            this.factor2 = factor2;
        }
        /**
         * Will get a number picked randomly between factor1 and factor2.
         * If factor2 is undefined then factor1 will be used
         * @returns the picked number
         */
        getFactor() {
            if (this.factor2 === undefined || this.factor2 === this.factor1) {
                return this.factor1;
            }
            return this.factor1 + (this.factor2 - this.factor1) * Math.random();
        }
    }
    /**
     * Helper used to simplify some generic gradient tasks
     */
    class GradientHelper {
        /**
         * Gets the current gradient from an array of IValueGradient
         * @param ratio defines the current ratio to get
         * @param gradients defines the array of IValueGradient
         * @param updateFunc defines the callback function used to get the final value from the selected gradients
         */
        static GetCurrentGradient(ratio, gradients, updateFunc) {
            // Use last index if over
            if (gradients[0].gradient > ratio) {
                updateFunc(gradients[0], gradients[0], 1.0);
                return;
            }
            for (let gradientIndex = 0; gradientIndex < gradients.length - 1; gradientIndex++) {
                const currentGradient = gradients[gradientIndex];
                const nextGradient = gradients[gradientIndex + 1];
                if (ratio >= currentGradient.gradient && ratio <= nextGradient.gradient) {
                    const scale = (ratio - currentGradient.gradient) / (nextGradient.gradient - currentGradient.gradient);
                    updateFunc(currentGradient, nextGradient, scale);
                    return;
                }
            }
            // Use last index if over
            const lastIndex = gradients.length - 1;
            updateFunc(gradients[lastIndex], gradients[lastIndex], 1.0);
        }
    }

    /**
     * A particle represents one of the element emitted by a particle system.
     * This is mainly define by its coordinates, direction, velocity and age.
     */
    class Particle {
        /**
         * Creates a new instance Particle
         * @param particleSystem the particle system the particle belongs to
         */
        constructor(
        /**
         * The particle system the particle belongs to.
         */
        particleSystem) {
            this.particleSystem = particleSystem;
            /**
             * The world position of the particle in the scene.
             */
            this.position = Vector3.Zero();
            /**
             * The world direction of the particle in the scene.
             */
            this.direction = Vector3.Zero();
            /**
             * The color of the particle.
             */
            this.color = new Color4(0, 0, 0, 0);
            /**
             * The color change of the particle per step.
             */
            this.colorStep = new Color4(0, 0, 0, 0);
            /**
             * Defines how long will the life of the particle be.
             */
            this.lifeTime = 1.0;
            /**
             * The current age of the particle.
             */
            this.age = 0;
            /**
             * The current size of the particle.
             */
            this.size = 0;
            /**
             * The current scale of the particle.
             */
            this.scale = new Vector2(1, 1);
            /**
             * The current angle of the particle.
             */
            this.angle = 0;
            /**
             * Defines how fast is the angle changing.
             */
            this.angularSpeed = 0;
            /**
             * Defines the cell index used by the particle to be rendered from a sprite.
             */
            this.cellIndex = 0;
            /** @internal */
            this._attachedSubEmitters = null;
            /** @internal */
            this._currentColor1 = new Color4(0, 0, 0, 0);
            /** @internal */
            this._currentColor2 = new Color4(0, 0, 0, 0);
            /** @internal */
            this._currentSize1 = 0;
            /** @internal */
            this._currentSize2 = 0;
            /** @internal */
            this._currentAngularSpeed1 = 0;
            /** @internal */
            this._currentAngularSpeed2 = 0;
            /** @internal */
            this._currentVelocity1 = 0;
            /** @internal */
            this._currentVelocity2 = 0;
            /** @internal */
            this._currentLimitVelocity1 = 0;
            /** @internal */
            this._currentLimitVelocity2 = 0;
            /** @internal */
            this._currentDrag1 = 0;
            /** @internal */
            this._currentDrag2 = 0;
            this.id = Particle._Count++;
            if (!this.particleSystem.isAnimationSheetEnabled) {
                return;
            }
            this._updateCellInfoFromSystem();
        }
        _updateCellInfoFromSystem() {
            this.cellIndex = this.particleSystem.startSpriteCellID;
        }
        /**
         * Defines how the sprite cell index is updated for the particle
         */
        updateCellIndex() {
            let offsetAge = this.age;
            let changeSpeed = this.particleSystem.spriteCellChangeSpeed;
            if (this.particleSystem.spriteRandomStartCell) {
                if (this._randomCellOffset === undefined) {
                    this._randomCellOffset = Math.random() * this.lifeTime;
                }
                if (changeSpeed === 0) {
                    // Special case when speed = 0 meaning we want to stay on initial cell
                    changeSpeed = 1;
                    offsetAge = this._randomCellOffset;
                }
                else {
                    offsetAge += this._randomCellOffset;
                }
            }
            const dist = this._initialEndSpriteCellID - this._initialStartSpriteCellID;
            let ratio;
            if (this._initialSpriteCellLoop) {
                ratio = Scalar.Clamp(((offsetAge * changeSpeed) % this.lifeTime) / this.lifeTime);
            }
            else {
                ratio = Scalar.Clamp((offsetAge * changeSpeed) / this.lifeTime);
            }
            this.cellIndex = (this._initialStartSpriteCellID + ratio * dist) | 0;
        }
        /**
         * @internal
         */
        _inheritParticleInfoToSubEmitter(subEmitter) {
            if (subEmitter.particleSystem.emitter.position) {
                const emitterMesh = subEmitter.particleSystem.emitter;
                emitterMesh.position.copyFrom(this.position);
                if (subEmitter.inheritDirection) {
                    const temp = TmpVectors.Vector3[0];
                    this.direction.normalizeToRef(temp);
                    emitterMesh.setDirection(temp, 0, Math.PI / 2);
                }
            }
            else {
                const emitterPosition = subEmitter.particleSystem.emitter;
                emitterPosition.copyFrom(this.position);
            }
            // Set inheritedVelocityOffset to be used when new particles are created
            this.direction.scaleToRef(subEmitter.inheritedVelocityAmount / 2, TmpVectors.Vector3[0]);
            subEmitter.particleSystem._inheritedVelocityOffset.copyFrom(TmpVectors.Vector3[0]);
        }
        /** @internal */
        _inheritParticleInfoToSubEmitters() {
            if (this._attachedSubEmitters && this._attachedSubEmitters.length > 0) {
                this._attachedSubEmitters.forEach((subEmitter) => {
                    this._inheritParticleInfoToSubEmitter(subEmitter);
                });
            }
        }
        /** @internal */
        _reset() {
            this.age = 0;
            this.id = Particle._Count++;
            this._currentColorGradient = null;
            this._currentSizeGradient = null;
            this._currentAngularSpeedGradient = null;
            this._currentVelocityGradient = null;
            this._currentLimitVelocityGradient = null;
            this._currentDragGradient = null;
            this.cellIndex = this.particleSystem.startSpriteCellID;
            this._randomCellOffset = undefined;
        }
        /**
         * Copy the properties of particle to another one.
         * @param other the particle to copy the information to.
         */
        copyTo(other) {
            other.position.copyFrom(this.position);
            if (this._initialDirection) {
                if (other._initialDirection) {
                    other._initialDirection.copyFrom(this._initialDirection);
                }
                else {
                    other._initialDirection = this._initialDirection.clone();
                }
            }
            else {
                other._initialDirection = null;
            }
            other.direction.copyFrom(this.direction);
            if (this._localPosition) {
                if (other._localPosition) {
                    other._localPosition.copyFrom(this._localPosition);
                }
                else {
                    other._localPosition = this._localPosition.clone();
                }
            }
            other.color.copyFrom(this.color);
            other.colorStep.copyFrom(this.colorStep);
            other.lifeTime = this.lifeTime;
            other.age = this.age;
            other._randomCellOffset = this._randomCellOffset;
            other.size = this.size;
            other.scale.copyFrom(this.scale);
            other.angle = this.angle;
            other.angularSpeed = this.angularSpeed;
            other.particleSystem = this.particleSystem;
            other.cellIndex = this.cellIndex;
            other.id = this.id;
            other._attachedSubEmitters = this._attachedSubEmitters;
            if (this._currentColorGradient) {
                other._currentColorGradient = this._currentColorGradient;
                other._currentColor1.copyFrom(this._currentColor1);
                other._currentColor2.copyFrom(this._currentColor2);
            }
            if (this._currentSizeGradient) {
                other._currentSizeGradient = this._currentSizeGradient;
                other._currentSize1 = this._currentSize1;
                other._currentSize2 = this._currentSize2;
            }
            if (this._currentAngularSpeedGradient) {
                other._currentAngularSpeedGradient = this._currentAngularSpeedGradient;
                other._currentAngularSpeed1 = this._currentAngularSpeed1;
                other._currentAngularSpeed2 = this._currentAngularSpeed2;
            }
            if (this._currentVelocityGradient) {
                other._currentVelocityGradient = this._currentVelocityGradient;
                other._currentVelocity1 = this._currentVelocity1;
                other._currentVelocity2 = this._currentVelocity2;
            }
            if (this._currentLimitVelocityGradient) {
                other._currentLimitVelocityGradient = this._currentLimitVelocityGradient;
                other._currentLimitVelocity1 = this._currentLimitVelocity1;
                other._currentLimitVelocity2 = this._currentLimitVelocity2;
            }
            if (this._currentDragGradient) {
                other._currentDragGradient = this._currentDragGradient;
                other._currentDrag1 = this._currentDrag1;
                other._currentDrag2 = this._currentDrag2;
            }
            if (this.particleSystem.isAnimationSheetEnabled) {
                other._initialStartSpriteCellID = this._initialStartSpriteCellID;
                other._initialEndSpriteCellID = this._initialEndSpriteCellID;
                other._initialSpriteCellLoop = this._initialSpriteCellLoop;
            }
            if (this.particleSystem.useRampGradients) {
                if (other.remapData && this.remapData) {
                    other.remapData.copyFrom(this.remapData);
                }
                else {
                    other.remapData = new Vector4(0, 0, 0, 0);
                }
            }
            if (this._randomNoiseCoordinates1) {
                if (other._randomNoiseCoordinates1) {
                    other._randomNoiseCoordinates1.copyFrom(this._randomNoiseCoordinates1);
                    other._randomNoiseCoordinates2.copyFrom(this._randomNoiseCoordinates2);
                }
                else {
                    other._randomNoiseCoordinates1 = this._randomNoiseCoordinates1.clone();
                    other._randomNoiseCoordinates2 = this._randomNoiseCoordinates2.clone();
                }
            }
        }
    }
    Particle._Count = 0;

    /**
     * Type of sub emitter
     */
    var SubEmitterType;
    (function (SubEmitterType) {
        /**
         * Attached to the particle over it's lifetime
         */
        SubEmitterType[SubEmitterType["ATTACHED"] = 0] = "ATTACHED";
        /**
         * Created when the particle dies
         */
        SubEmitterType[SubEmitterType["END"] = 1] = "END";
    })(SubEmitterType || (SubEmitterType = {}));
    /**
     * Sub emitter class used to emit particles from an existing particle
     */
    class SubEmitter {
        /**
         * Creates a sub emitter
         * @param particleSystem the particle system to be used by the sub emitter
         */
        constructor(
        /**
         * the particle system to be used by the sub emitter
         */
        particleSystem) {
            this.particleSystem = particleSystem;
            /**
             * Type of the submitter (Default: END)
             */
            this.type = SubEmitterType.END;
            /**
             * If the particle should inherit the direction from the particle it's attached to. (+Y will face the direction the particle is moving) (Default: false)
             * Note: This only is supported when using an emitter of type Mesh
             */
            this.inheritDirection = false;
            /**
             * How much of the attached particles speed should be added to the sub emitted particle (default: 0)
             */
            this.inheritedVelocityAmount = 0;
            // Create mesh as emitter to support rotation
            if (!particleSystem.emitter || !particleSystem.emitter.dispose) {
                const internalClass = GetClass("BABYLON.AbstractMesh");
                particleSystem.emitter = new internalClass("SubemitterSystemEmitter", particleSystem.getScene());
                particleSystem._disposeEmitterOnDispose = true;
            }
        }
        /**
         * Clones the sub emitter
         * @returns the cloned sub emitter
         */
        clone() {
            // Clone particle system
            let emitter = this.particleSystem.emitter;
            if (!emitter) {
                emitter = new Vector3();
            }
            else if (emitter instanceof Vector3) {
                emitter = emitter.clone();
            }
            else if (emitter.getClassName().indexOf("Mesh") !== -1) {
                const internalClass = GetClass("BABYLON.Mesh");
                emitter = new internalClass("", emitter.getScene());
                emitter.isVisible = false;
            }
            const clone = new SubEmitter(this.particleSystem.clone(this.particleSystem.name, emitter));
            // Clone properties
            clone.particleSystem.name += "Clone";
            clone.type = this.type;
            clone.inheritDirection = this.inheritDirection;
            clone.inheritedVelocityAmount = this.inheritedVelocityAmount;
            clone.particleSystem._disposeEmitterOnDispose = true;
            clone.particleSystem.disposeOnStop = true;
            return clone;
        }
        /**
         * Serialize current object to a JSON object
         * @param serializeTexture defines if the texture must be serialized as well
         * @returns the serialized object
         */
        serialize(serializeTexture = false) {
            const serializationObject = {};
            serializationObject.type = this.type;
            serializationObject.inheritDirection = this.inheritDirection;
            serializationObject.inheritedVelocityAmount = this.inheritedVelocityAmount;
            serializationObject.particleSystem = this.particleSystem.serialize(serializeTexture);
            return serializationObject;
        }
        /**
         * @internal
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        static _ParseParticleSystem(system, sceneOrEngine, rootUrl, doNotStart = false) {
            throw _WarnImport("ParseParticle");
        }
        /**
         * Creates a new SubEmitter from a serialized JSON version
         * @param serializationObject defines the JSON object to read from
         * @param sceneOrEngine defines the hosting scene or the hosting engine
         * @param rootUrl defines the rootUrl for data loading
         * @returns a new SubEmitter
         */
        static Parse(serializationObject, sceneOrEngine, rootUrl) {
            const system = serializationObject.particleSystem;
            const subEmitter = new SubEmitter(SubEmitter._ParseParticleSystem(system, sceneOrEngine, rootUrl, true));
            subEmitter.type = serializationObject.type;
            subEmitter.inheritDirection = serializationObject.inheritDirection;
            subEmitter.inheritedVelocityAmount = serializationObject.inheritedVelocityAmount;
            subEmitter.particleSystem._isSubEmitter = true;
            return subEmitter;
        }
        /** Release associated resources */
        dispose() {
            this.particleSystem.dispose();
        }
    }

    // Do not edit.
    const name$2I = "particlesPixelShader";
    const shader$2I = `#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
varying vec2 vUV;varying vec4 vColor;uniform vec4 textureMask;uniform sampler2D diffuseSampler;
#include<clipPlaneFragmentDeclaration>
#include<imageProcessingDeclaration>
#include<logDepthDeclaration>
#include<helperFunctions>
#include<imageProcessingFunctions>
#ifdef RAMPGRADIENT
varying vec4 remapRanges;uniform sampler2D rampSampler;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec4 textureColor=texture2D(diffuseSampler,vUV);vec4 baseColor=(textureColor*textureMask+(vec4(1.,1.,1.,1.)-textureMask))*vColor;
#ifdef RAMPGRADIENT
float alpha=baseColor.a;float remappedColorIndex=clamp((alpha-remapRanges.x)/remapRanges.y,0.0,1.0);vec4 rampColor=texture2D(rampSampler,vec2(1.0-remappedColorIndex,0.));baseColor.rgb*=rampColor.rgb;float finalAlpha=baseColor.a;baseColor.a=clamp((alpha*rampColor.a-remapRanges.z)/remapRanges.w,0.0,1.0);
#endif
#ifdef BLENDMULTIPLYMODE
float sourceAlpha=vColor.a*textureColor.a;baseColor.rgb=baseColor.rgb*sourceAlpha+vec3(1.0)*(1.0-sourceAlpha);
#endif
#include<logDepthFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
baseColor.rgb=toLinearSpace(baseColor.rgb);
#else
#ifdef IMAGEPROCESSING
baseColor.rgb=toLinearSpace(baseColor.rgb);baseColor=applyImageProcessing(baseColor);
#endif
#endif
gl_FragColor=baseColor;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2I] = shader$2I;

    // Do not edit.
    const name$2J = "particlesVertexShader";
    const shader$2J = `attribute vec3 position;attribute vec4 color;attribute float angle;attribute vec2 size;
#ifdef ANIMATESHEET
attribute float cellIndex;
#endif
#ifndef BILLBOARD
attribute vec3 direction;
#endif
#ifdef BILLBOARDSTRETCHED
attribute vec3 direction;
#endif
#ifdef RAMPGRADIENT
attribute vec4 remapData;
#endif
attribute vec2 offset;uniform mat4 view;uniform mat4 projection;uniform vec2 translationPivot;
#ifdef ANIMATESHEET
uniform vec3 particlesInfos; 
#endif
varying vec2 vUV;varying vec4 vColor;varying vec3 vPositionW;
#ifdef RAMPGRADIENT
varying vec4 remapRanges;
#endif
#if defined(BILLBOARD) && !defined(BILLBOARDY) && !defined(BILLBOARDSTRETCHED)
uniform mat4 invView;
#endif
#include<clipPlaneVertexDeclaration>
#include<logDepthDeclaration>
#ifdef BILLBOARD
uniform vec3 eyePosition;
#endif
vec3 rotate(vec3 yaxis,vec3 rotatedCorner) {vec3 xaxis=normalize(cross(vec3(0.,1.0,0.),yaxis));vec3 zaxis=normalize(cross(yaxis,xaxis));vec3 row0=vec3(xaxis.x,xaxis.y,xaxis.z);vec3 row1=vec3(yaxis.x,yaxis.y,yaxis.z);vec3 row2=vec3(zaxis.x,zaxis.y,zaxis.z);mat3 rotMatrix= mat3(row0,row1,row2);vec3 alignedCorner=rotMatrix*rotatedCorner;return position+alignedCorner;}
#ifdef BILLBOARDSTRETCHED
vec3 rotateAlign(vec3 toCamera,vec3 rotatedCorner) {vec3 normalizedToCamera=normalize(toCamera);vec3 normalizedCrossDirToCamera=normalize(cross(normalize(direction),normalizedToCamera));vec3 row0=vec3(normalizedCrossDirToCamera.x,normalizedCrossDirToCamera.y,normalizedCrossDirToCamera.z);vec3 row2=vec3(normalizedToCamera.x,normalizedToCamera.y,normalizedToCamera.z);
#ifdef BILLBOARDSTRETCHED_LOCAL
vec3 row1=direction;
#else
vec3 crossProduct=normalize(cross(normalizedToCamera,normalizedCrossDirToCamera));vec3 row1=vec3(crossProduct.x,crossProduct.y,crossProduct.z);
#endif
mat3 rotMatrix= mat3(row0,row1,row2);vec3 alignedCorner=rotMatrix*rotatedCorner;return position+alignedCorner;}
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec2 cornerPos;cornerPos=(vec2(offset.x-0.5,offset.y -0.5)-translationPivot)*size+translationPivot;
#ifdef BILLBOARD
vec3 rotatedCorner;
#ifdef BILLBOARDY
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.z=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.y=0.;vec3 yaxis=position-eyePosition;yaxis.y=0.;vPositionW=rotate(normalize(yaxis),rotatedCorner);vec3 viewPos=(view*vec4(vPositionW,1.0)).xyz;
#elif defined(BILLBOARDSTRETCHED)
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;vec3 toCamera=position-eyePosition;vPositionW=rotateAlign(toCamera,rotatedCorner);vec3 viewPos=(view*vec4(vPositionW,1.0)).xyz;
#else
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;vec3 viewPos=(view*vec4(position,1.0)).xyz+rotatedCorner;vPositionW=(invView*vec4(viewPos,1)).xyz;
#endif
#ifdef RAMPGRADIENT
remapRanges=remapData;
#endif
gl_Position=projection*vec4(viewPos,1.0);
#else
vec3 rotatedCorner;rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.z=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.y=0.;vec3 yaxis=normalize(direction);vPositionW=rotate(yaxis,rotatedCorner);gl_Position=projection*view*vec4(vPositionW,1.0);
#endif
vColor=color;
#ifdef ANIMATESHEET
float rowOffset=floor(cellIndex*particlesInfos.z);float columnOffset=cellIndex-rowOffset/particlesInfos.z;vec2 uvScale=particlesInfos.xy;vec2 uvOffset=vec2(offset.x ,1.0-offset.y);vUV=(uvOffset+vec2(columnOffset,rowOffset))*uvScale;
#else
vUV=offset;
#endif
#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
vec4 worldPos=vec4(vPositionW,1.0);
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}`;
    // Sideeffect
    ShaderStore.ShadersStore[name$2J] = shader$2J;

    /**
     * This represents a particle system in Babylon.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * Particles can take different shapes while emitted like box, sphere, cone or you can write your custom function.
     * @example https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro
     */
    class ParticleSystem extends BaseParticleSystem {
        /**
         * Sets a callback that will be triggered when the system is disposed
         */
        set onDispose(callback) {
            if (this._onDisposeObserver) {
                this.onDisposeObservable.remove(this._onDisposeObserver);
            }
            this._onDisposeObserver = this.onDisposeObservable.add(callback);
        }
        /** Gets or sets a boolean indicating that ramp gradients must be used
         * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro#ramp-gradients
         */
        get useRampGradients() {
            return this._useRampGradients;
        }
        set useRampGradients(value) {
            if (this._useRampGradients === value) {
                return;
            }
            this._useRampGradients = value;
            this._resetEffect();
        }
        //end of Sub-emitter
        /**
         * Gets the current list of active particles
         */
        get particles() {
            return this._particles;
        }
        /**
         * Gets the number of particles active at the same time.
         * @returns The number of active particles.
         */
        getActiveCount() {
            return this._particles.length;
        }
        /**
         * Returns the string "ParticleSystem"
         * @returns a string containing the class name
         */
        getClassName() {
            return "ParticleSystem";
        }
        /**
         * Gets a boolean indicating that the system is stopping
         * @returns true if the system is currently stopping
         */
        isStopping() {
            return this._stopped && this.isAlive();
        }
        /**
         * Gets the custom effect used to render the particles
         * @param blendMode Blend mode for which the effect should be retrieved
         * @returns The effect
         */
        getCustomEffect(blendMode = 0) {
            var _a, _b;
            return (_b = (_a = this._customWrappers[blendMode]) === null || _a === void 0 ? void 0 : _a.effect) !== null && _b !== void 0 ? _b : this._customWrappers[0].effect;
        }
        _getCustomDrawWrapper(blendMode = 0) {
            var _a;
            return (_a = this._customWrappers[blendMode]) !== null && _a !== void 0 ? _a : this._customWrappers[0];
        }
        /**
         * Sets the custom effect used to render the particles
         * @param effect The effect to set
         * @param blendMode Blend mode for which the effect should be set
         */
        setCustomEffect(effect, blendMode = 0) {
            this._customWrappers[blendMode] = new DrawWrapper(this._engine);
            this._customWrappers[blendMode].effect = effect;
            if (this._customWrappers[blendMode].drawContext) {
                this._customWrappers[blendMode].drawContext.useInstancing = this._useInstancing;
            }
        }
        /**
         * Observable that will be called just before the particles are drawn
         */
        get onBeforeDrawParticlesObservable() {
            if (!this._onBeforeDrawParticlesObservable) {
                this._onBeforeDrawParticlesObservable = new Observable$1();
            }
            return this._onBeforeDrawParticlesObservable;
        }
        /**
         * Gets the name of the particle vertex shader
         */
        get vertexShaderName() {
            return "particles";
        }
        /**
         * Gets the vertex buffers used by the particle system
         */
        get vertexBuffers() {
            return this._vertexBuffers;
        }
        /**
         * Gets the index buffer used by the particle system (or null if no index buffer is used (if _useInstancing=true))
         */
        get indexBuffer() {
            return this._indexBuffer;
        }
        /**
         * Instantiates a particle system.
         * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
         * @param name The name of the particle system
         * @param capacity The max number of particles alive at the same time
         * @param sceneOrEngine The scene the particle system belongs to or the engine to use if no scene
         * @param customEffect a custom effect used to change the way particles are rendered by default
         * @param isAnimationSheetEnabled Must be true if using a spritesheet to animate the particles texture
         * @param epsilon Offset used to render the particles
         */
        constructor(name, capacity, sceneOrEngine, customEffect = null, isAnimationSheetEnabled = false, epsilon = 0.01) {
            super(name);
            this._emitterInverseWorldMatrix = Matrix.Identity();
            /**
             * @internal
             */
            this._inheritedVelocityOffset = new Vector3();
            /**
             * An event triggered when the system is disposed
             */
            this.onDisposeObservable = new Observable$1();
            /**
             * An event triggered when the system is stopped
             */
            this.onStoppedObservable = new Observable$1();
            this._particles = new Array();
            this._stockParticles = new Array();
            this._newPartsExcess = 0;
            this._vertexBuffers = {};
            this._scaledColorStep = new Color4(0, 0, 0, 0);
            this._colorDiff = new Color4(0, 0, 0, 0);
            this._scaledDirection = Vector3.Zero();
            this._scaledGravity = Vector3.Zero();
            this._currentRenderId = -1;
            this._useInstancing = false;
            this._started = false;
            this._stopped = false;
            this._actualFrame = 0;
            /** @internal */
            this._currentEmitRate1 = 0;
            /** @internal */
            this._currentEmitRate2 = 0;
            /** @internal */
            this._currentStartSize1 = 0;
            /** @internal */
            this._currentStartSize2 = 0;
            /** Indicates that the update of particles is done in the animate function */
            this.updateInAnimate = true;
            this._rawTextureWidth = 256;
            this._useRampGradients = false;
            /**
             * @internal
             * If the particle systems emitter should be disposed when the particle system is disposed
             */
            this._disposeEmitterOnDispose = false;
            /**
             * Specifies if the particles are updated in emitter local space or world space
             */
            this.isLocal = false;
            /** Indicates that the particle system is CPU based */
            this.isGPU = false;
            /** @internal */
            this._onBeforeDrawParticlesObservable = null;
            // start of sub system methods
            /**
             * "Recycles" one of the particle by copying it back to the "stock" of particles and removing it from the active list.
             * Its lifetime will start back at 0.
             * @param particle
             */
            this.recycleParticle = (particle) => {
                // move particle from activeParticle list to stock particles
                const lastParticle = this._particles.pop();
                if (lastParticle !== particle) {
                    lastParticle.copyTo(particle);
                }
                this._stockParticles.push(lastParticle);
            };
            this._createParticle = () => {
                let particle;
                if (this._stockParticles.length !== 0) {
                    particle = this._stockParticles.pop();
                    particle._reset();
                }
                else {
                    particle = new Particle(this);
                }
                // Attach emitters
                if (this._subEmitters && this._subEmitters.length > 0) {
                    const subEmitters = this._subEmitters[Math.floor(Math.random() * this._subEmitters.length)];
                    particle._attachedSubEmitters = [];
                    subEmitters.forEach((subEmitter) => {
                        if (subEmitter.type === SubEmitterType.ATTACHED) {
                            const newEmitter = subEmitter.clone();
                            particle._attachedSubEmitters.push(newEmitter);
                            newEmitter.particleSystem.start();
                        }
                    });
                }
                return particle;
            };
            this._emitFromParticle = (particle) => {
                if (!this._subEmitters || this._subEmitters.length === 0) {
                    return;
                }
                const templateIndex = Math.floor(Math.random() * this._subEmitters.length);
                this._subEmitters[templateIndex].forEach((subEmitter) => {
                    if (subEmitter.type === SubEmitterType.END) {
                        const subSystem = subEmitter.clone();
                        particle._inheritParticleInfoToSubEmitter(subSystem);
                        subSystem.particleSystem._rootParticleSystem = this;
                        this.activeSubSystems.push(subSystem.particleSystem);
                        subSystem.particleSystem.start();
                    }
                });
            };
            this._capacity = capacity;
            this._epsilon = epsilon;
            this._isAnimationSheetEnabled = isAnimationSheetEnabled;
            if (!sceneOrEngine || sceneOrEngine.getClassName() === "Scene") {
                this._scene = sceneOrEngine || EngineStore.LastCreatedScene;
                this._engine = this._scene.getEngine();
                this.uniqueId = this._scene.getUniqueId();
                this._scene.particleSystems.push(this);
            }
            else {
                this._engine = sceneOrEngine;
                this.defaultProjectionMatrix = Matrix.PerspectiveFovLH(0.8, 1, 0.1, 100, this._engine.isNDCHalfZRange);
            }
            if (this._engine.getCaps().vertexArrayObject) {
                this._vertexArrayObject = null;
            }
            // Setup the default processing configuration to the scene.
            this._attachImageProcessingConfiguration(null);
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this._customWrappers = { 0: new DrawWrapper(this._engine) };
            this._customWrappers[0].effect = customEffect;
            this._drawWrappers = [];
            this._useInstancing = this._engine.getCaps().instancedArrays;
            this._createIndexBuffer();
            this._createVertexBuffers();
            // Default emitter type
            this.particleEmitterType = new BoxParticleEmitter();
            let noiseTextureData = null;
            // Update
            this.updateFunction = (particles) => {
                var _a;
                let noiseTextureSize = null;
                if (this.noiseTexture) {
                    // We need to get texture data back to CPU
                    noiseTextureSize = this.noiseTexture.getSize();
                    (_a = this.noiseTexture.getContent()) === null || _a === void 0 ? void 0 : _a.then((data) => {
                        noiseTextureData = data;
                    });
                }
                const sameParticleArray = particles === this._particles;
                for (let index = 0; index < particles.length; index++) {
                    const particle = particles[index];
                    let scaledUpdateSpeed = this._scaledUpdateSpeed;
                    const previousAge = particle.age;
                    particle.age += scaledUpdateSpeed;
                    // Evaluate step to death
                    if (particle.age > particle.lifeTime) {
                        const diff = particle.age - previousAge;
                        const oldDiff = particle.lifeTime - previousAge;
                        scaledUpdateSpeed = (oldDiff * scaledUpdateSpeed) / diff;
                        particle.age = particle.lifeTime;
                    }
                    const ratio = particle.age / particle.lifeTime;
                    // Color
                    if (this._colorGradients && this._colorGradients.length > 0) {
                        GradientHelper.GetCurrentGradient(ratio, this._colorGradients, (currentGradient, nextGradient, scale) => {
                            if (currentGradient !== particle._currentColorGradient) {
                                particle._currentColor1.copyFrom(particle._currentColor2);
                                nextGradient.getColorToRef(particle._currentColor2);
                                particle._currentColorGradient = currentGradient;
                            }
                            Color4.LerpToRef(particle._currentColor1, particle._currentColor2, scale, particle.color);
                        });
                    }
                    else {
                        particle.colorStep.scaleToRef(scaledUpdateSpeed, this._scaledColorStep);
                        particle.color.addInPlace(this._scaledColorStep);
                        if (particle.color.a < 0) {
                            particle.color.a = 0;
                        }
                    }
                    // Angular speed
                    if (this._angularSpeedGradients && this._angularSpeedGradients.length > 0) {
                        GradientHelper.GetCurrentGradient(ratio, this._angularSpeedGradients, (currentGradient, nextGradient, scale) => {
                            if (currentGradient !== particle._currentAngularSpeedGradient) {
                                particle._currentAngularSpeed1 = particle._currentAngularSpeed2;
                                particle._currentAngularSpeed2 = nextGradient.getFactor();
                                particle._currentAngularSpeedGradient = currentGradient;
                            }
                            particle.angularSpeed = Scalar.Lerp(particle._currentAngularSpeed1, particle._currentAngularSpeed2, scale);
                        });
                    }
                    particle.angle += particle.angularSpeed * scaledUpdateSpeed;
                    // Direction
                    let directionScale = scaledUpdateSpeed;
                    /// Velocity
                    if (this._velocityGradients && this._velocityGradients.length > 0) {
                        GradientHelper.GetCurrentGradient(ratio, this._velocityGradients, (currentGradient, nextGradient, scale) => {
                            if (currentGradient !== particle._currentVelocityGradient) {
                                particle._currentVelocity1 = particle._currentVelocity2;
                                particle._currentVelocity2 = nextGradient.getFactor();
                                particle._currentVelocityGradient = currentGradient;
                            }
                            directionScale *= Scalar.Lerp(particle._currentVelocity1, particle._currentVelocity2, scale);
                        });
                    }
                    particle.direction.scaleToRef(directionScale, this._scaledDirection);
                    /// Limit velocity
                    if (this._limitVelocityGradients && this._limitVelocityGradients.length > 0) {
                        GradientHelper.GetCurrentGradient(ratio, this._limitVelocityGradients, (currentGradient, nextGradient, scale) => {
                            if (currentGradient !== particle._currentLimitVelocityGradient) {
                                particle._currentLimitVelocity1 = particle._currentLimitVelocity2;
                                particle._currentLimitVelocity2 = nextGradient.getFactor();
                                particle._currentLimitVelocityGradient = currentGradient;
                            }
                            const limitVelocity = Scalar.Lerp(particle._currentLimitVelocity1, particle._currentLimitVelocity2, scale);
                            const currentVelocity = particle.direction.length();
                            if (currentVelocity > limitVelocity) {
                                particle.direction.scaleInPlace(this.limitVelocityDamping);
                            }
                        });
                    }
                    /// Drag
                    if (this._dragGradients && this._dragGradients.length > 0) {
                        GradientHelper.GetCurrentGradient(ratio, this._dragGradients, (currentGradient, nextGradient, scale) => {
                            if (currentGradient !== particle._currentDragGradient) {
                                particle._currentDrag1 = particle._currentDrag2;
                                particle._currentDrag2 = nextGradient.getFactor();
                                particle._currentDragGradient = currentGradient;
                            }
                            const drag = Scalar.Lerp(particle._currentDrag1, particle._currentDrag2, scale);
                            this._scaledDirection.scaleInPlace(1.0 - drag);
                        });
                    }
                    if (this.isLocal && particle._localPosition) {
                        particle._localPosition.addInPlace(this._scaledDirection);
                        Vector3.TransformCoordinatesToRef(particle._localPosition, this._emitterWorldMatrix, particle.position);
                    }
                    else {
                        particle.position.addInPlace(this._scaledDirection);
                    }
                    // Noise
                    if (noiseTextureData && noiseTextureSize && particle._randomNoiseCoordinates1) {
                        const fetchedColorR = this._fetchR(particle._randomNoiseCoordinates1.x, particle._randomNoiseCoordinates1.y, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                        const fetchedColorG = this._fetchR(particle._randomNoiseCoordinates1.z, particle._randomNoiseCoordinates2.x, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                        const fetchedColorB = this._fetchR(particle._randomNoiseCoordinates2.y, particle._randomNoiseCoordinates2.z, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                        const force = TmpVectors.Vector3[0];
                        const scaledForce = TmpVectors.Vector3[1];
                        force.copyFromFloats((2 * fetchedColorR - 1) * this.noiseStrength.x, (2 * fetchedColorG - 1) * this.noiseStrength.y, (2 * fetchedColorB - 1) * this.noiseStrength.z);
                        force.scaleToRef(scaledUpdateSpeed, scaledForce);
                        particle.direction.addInPlace(scaledForce);
                    }
                    // Gravity
                    this.gravity.scaleToRef(scaledUpdateSpeed, this._scaledGravity);
                    particle.direction.addInPlace(this._scaledGravity);
                    // Size
                    if (this._sizeGradients && this._sizeGradients.length > 0) {
                        GradientHelper.GetCurrentGradient(ratio, this._sizeGradients, (currentGradient, nextGradient, scale) => {
                            if (currentGradient !== particle._currentSizeGradient) {
                                particle._currentSize1 = particle._currentSize2;
                                particle._currentSize2 = nextGradient.getFactor();
                                particle._currentSizeGradient = currentGradient;
                            }
                            particle.size = Scalar.Lerp(particle._currentSize1, particle._currentSize2, scale);
                        });
                    }
                    // Remap data
                    if (this._useRampGradients) {
                        if (this._colorRemapGradients && this._colorRemapGradients.length > 0) {
                            GradientHelper.GetCurrentGradient(ratio, this._colorRemapGradients, (currentGradient, nextGradient, scale) => {
                                const min = Scalar.Lerp(currentGradient.factor1, nextGradient.factor1, scale);
                                const max = Scalar.Lerp(currentGradient.factor2, nextGradient.factor2, scale);
                                particle.remapData.x = min;
                                particle.remapData.y = max - min;
                            });
                        }
                        if (this._alphaRemapGradients && this._alphaRemapGradients.length > 0) {
                            GradientHelper.GetCurrentGradient(ratio, this._alphaRemapGradients, (currentGradient, nextGradient, scale) => {
                                const min = Scalar.Lerp(currentGradient.factor1, nextGradient.factor1, scale);
                                const max = Scalar.Lerp(currentGradient.factor2, nextGradient.factor2, scale);
                                particle.remapData.z = min;
                                particle.remapData.w = max - min;
                            });
                        }
                    }
                    if (this._isAnimationSheetEnabled) {
                        particle.updateCellIndex();
                    }
                    // Update the position of the attached sub-emitters to match their attached particle
                    particle._inheritParticleInfoToSubEmitters();
                    if (particle.age >= particle.lifeTime) {
                        // Recycle by swapping with last particle
                        this._emitFromParticle(particle);
                        if (particle._attachedSubEmitters) {
                            particle._attachedSubEmitters.forEach((subEmitter) => {
                                subEmitter.particleSystem.disposeOnStop = true;
                                subEmitter.particleSystem.stop();
                            });
                            particle._attachedSubEmitters = null;
                        }
                        this.recycleParticle(particle);
                        if (sameParticleArray) {
                            index--;
                        }
                        continue;
                    }
                }
            };
        }
        _addFactorGradient(factorGradients, gradient, factor, factor2) {
            const newGradient = new FactorGradient(gradient, factor, factor2);
            factorGradients.push(newGradient);
            factorGradients.sort((a, b) => {
                if (a.gradient < b.gradient) {
                    return -1;
                }
                else if (a.gradient > b.gradient) {
                    return 1;
                }
                return 0;
            });
        }
        _removeFactorGradient(factorGradients, gradient) {
            if (!factorGradients) {
                return;
            }
            let index = 0;
            for (const factorGradient of factorGradients) {
                if (factorGradient.gradient === gradient) {
                    factorGradients.splice(index, 1);
                    break;
                }
                index++;
            }
        }
        /**
         * Adds a new life time gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the life time factor to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addLifeTimeGradient(gradient, factor, factor2) {
            if (!this._lifeTimeGradients) {
                this._lifeTimeGradients = [];
            }
            this._addFactorGradient(this._lifeTimeGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific life time gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeLifeTimeGradient(gradient) {
            this._removeFactorGradient(this._lifeTimeGradients, gradient);
            return this;
        }
        /**
         * Adds a new size gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the size factor to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addSizeGradient(gradient, factor, factor2) {
            if (!this._sizeGradients) {
                this._sizeGradients = [];
            }
            this._addFactorGradient(this._sizeGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific size gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeSizeGradient(gradient) {
            this._removeFactorGradient(this._sizeGradients, gradient);
            return this;
        }
        /**
         * Adds a new color remap gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param min defines the color remap minimal range
         * @param max defines the color remap maximal range
         * @returns the current particle system
         */
        addColorRemapGradient(gradient, min, max) {
            if (!this._colorRemapGradients) {
                this._colorRemapGradients = [];
            }
            this._addFactorGradient(this._colorRemapGradients, gradient, min, max);
            return this;
        }
        /**
         * Remove a specific color remap gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeColorRemapGradient(gradient) {
            this._removeFactorGradient(this._colorRemapGradients, gradient);
            return this;
        }
        /**
         * Adds a new alpha remap gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param min defines the alpha remap minimal range
         * @param max defines the alpha remap maximal range
         * @returns the current particle system
         */
        addAlphaRemapGradient(gradient, min, max) {
            if (!this._alphaRemapGradients) {
                this._alphaRemapGradients = [];
            }
            this._addFactorGradient(this._alphaRemapGradients, gradient, min, max);
            return this;
        }
        /**
         * Remove a specific alpha remap gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeAlphaRemapGradient(gradient) {
            this._removeFactorGradient(this._alphaRemapGradients, gradient);
            return this;
        }
        /**
         * Adds a new angular speed gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the angular speed  to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addAngularSpeedGradient(gradient, factor, factor2) {
            if (!this._angularSpeedGradients) {
                this._angularSpeedGradients = [];
            }
            this._addFactorGradient(this._angularSpeedGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific angular speed gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeAngularSpeedGradient(gradient) {
            this._removeFactorGradient(this._angularSpeedGradients, gradient);
            return this;
        }
        /**
         * Adds a new velocity gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the velocity to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addVelocityGradient(gradient, factor, factor2) {
            if (!this._velocityGradients) {
                this._velocityGradients = [];
            }
            this._addFactorGradient(this._velocityGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific velocity gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeVelocityGradient(gradient) {
            this._removeFactorGradient(this._velocityGradients, gradient);
            return this;
        }
        /**
         * Adds a new limit velocity gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the limit velocity value to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addLimitVelocityGradient(gradient, factor, factor2) {
            if (!this._limitVelocityGradients) {
                this._limitVelocityGradients = [];
            }
            this._addFactorGradient(this._limitVelocityGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific limit velocity gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeLimitVelocityGradient(gradient) {
            this._removeFactorGradient(this._limitVelocityGradients, gradient);
            return this;
        }
        /**
         * Adds a new drag gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the drag value to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addDragGradient(gradient, factor, factor2) {
            if (!this._dragGradients) {
                this._dragGradients = [];
            }
            this._addFactorGradient(this._dragGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific drag gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeDragGradient(gradient) {
            this._removeFactorGradient(this._dragGradients, gradient);
            return this;
        }
        /**
         * Adds a new emit rate gradient (please note that this will only work if you set the targetStopDuration property)
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the emit rate value to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addEmitRateGradient(gradient, factor, factor2) {
            if (!this._emitRateGradients) {
                this._emitRateGradients = [];
            }
            this._addFactorGradient(this._emitRateGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific emit rate gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeEmitRateGradient(gradient) {
            this._removeFactorGradient(this._emitRateGradients, gradient);
            return this;
        }
        /**
         * Adds a new start size gradient (please note that this will only work if you set the targetStopDuration property)
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param factor defines the start size value to affect to the specified gradient
         * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
         * @returns the current particle system
         */
        addStartSizeGradient(gradient, factor, factor2) {
            if (!this._startSizeGradients) {
                this._startSizeGradients = [];
            }
            this._addFactorGradient(this._startSizeGradients, gradient, factor, factor2);
            return this;
        }
        /**
         * Remove a specific start size gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeStartSizeGradient(gradient) {
            this._removeFactorGradient(this._startSizeGradients, gradient);
            return this;
        }
        _createRampGradientTexture() {
            if (!this._rampGradients || !this._rampGradients.length || this._rampGradientsTexture || !this._scene) {
                return;
            }
            const data = new Uint8Array(this._rawTextureWidth * 4);
            const tmpColor = TmpColors.Color3[0];
            for (let x = 0; x < this._rawTextureWidth; x++) {
                const ratio = x / this._rawTextureWidth;
                GradientHelper.GetCurrentGradient(ratio, this._rampGradients, (currentGradient, nextGradient, scale) => {
                    Color3.LerpToRef(currentGradient.color, nextGradient.color, scale, tmpColor);
                    data[x * 4] = tmpColor.r * 255;
                    data[x * 4 + 1] = tmpColor.g * 255;
                    data[x * 4 + 2] = tmpColor.b * 255;
                    data[x * 4 + 3] = 255;
                });
            }
            this._rampGradientsTexture = RawTexture.CreateRGBATexture(data, this._rawTextureWidth, 1, this._scene, false, false, 1);
        }
        /**
         * Gets the current list of ramp gradients.
         * You must use addRampGradient and removeRampGradient to update this list
         * @returns the list of ramp gradients
         */
        getRampGradients() {
            return this._rampGradients;
        }
        /** Force the system to rebuild all gradients that need to be resync */
        forceRefreshGradients() {
            this._syncRampGradientTexture();
        }
        _syncRampGradientTexture() {
            if (!this._rampGradients) {
                return;
            }
            this._rampGradients.sort((a, b) => {
                if (a.gradient < b.gradient) {
                    return -1;
                }
                else if (a.gradient > b.gradient) {
                    return 1;
                }
                return 0;
            });
            if (this._rampGradientsTexture) {
                this._rampGradientsTexture.dispose();
                this._rampGradientsTexture = null;
            }
            this._createRampGradientTexture();
        }
        /**
         * Adds a new ramp gradient used to remap particle colors
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param color defines the color to affect to the specified gradient
         * @returns the current particle system
         */
        addRampGradient(gradient, color) {
            if (!this._rampGradients) {
                this._rampGradients = [];
            }
            const rampGradient = new Color3Gradient(gradient, color);
            this._rampGradients.push(rampGradient);
            this._syncRampGradientTexture();
            return this;
        }
        /**
         * Remove a specific ramp gradient
         * @param gradient defines the gradient to remove
         * @returns the current particle system
         */
        removeRampGradient(gradient) {
            this._removeGradientAndTexture(gradient, this._rampGradients, this._rampGradientsTexture);
            this._rampGradientsTexture = null;
            if (this._rampGradients && this._rampGradients.length > 0) {
                this._createRampGradientTexture();
            }
            return this;
        }
        /**
         * Adds a new color gradient
         * @param gradient defines the gradient to use (between 0 and 1)
         * @param color1 defines the color to affect to the specified gradient
         * @param color2 defines an additional color used to define a range ([color, color2]) with main color to pick the final color from
         * @returns this particle system
         */
        addColorGradient(gradient, color1, color2) {
            if (!this._colorGradients) {
                this._colorGradients = [];
            }
            const colorGradient = new ColorGradient(gradient, color1, color2);
            this._colorGradients.push(colorGradient);
            this._colorGradients.sort((a, b) => {
                if (a.gradient < b.gradient) {
                    return -1;
                }
                else if (a.gradient > b.gradient) {
                    return 1;
                }
                return 0;
            });
            return this;
        }
        /**
         * Remove a specific color gradient
         * @param gradient defines the gradient to remove
         * @returns this particle system
         */
        removeColorGradient(gradient) {
            if (!this._colorGradients) {
                return this;
            }
            let index = 0;
            for (const colorGradient of this._colorGradients) {
                if (colorGradient.gradient === gradient) {
                    this._colorGradients.splice(index, 1);
                    break;
                }
                index++;
            }
            return this;
        }
        /**
         * Resets the draw wrappers cache
         */
        resetDrawCache() {
            for (const drawWrappers of this._drawWrappers) {
                if (drawWrappers) {
                    for (const drawWrapper of drawWrappers) {
                        drawWrapper === null || drawWrapper === void 0 ? void 0 : drawWrapper.dispose();
                    }
                }
            }
            this._drawWrappers = [];
        }
        _fetchR(u, v, width, height, pixels) {
            u = Math.abs(u) * 0.5 + 0.5;
            v = Math.abs(v) * 0.5 + 0.5;
            const wrappedU = (u * width) % width | 0;
            const wrappedV = (v * height) % height | 0;
            const position = (wrappedU + wrappedV * width) * 4;
            return pixels[position] / 255;
        }
        _reset() {
            this._resetEffect();
        }
        _resetEffect() {
            if (this._vertexBuffer) {
                this._vertexBuffer.dispose();
                this._vertexBuffer = null;
            }
            if (this._spriteBuffer) {
                this._spriteBuffer.dispose();
                this._spriteBuffer = null;
            }
            if (this._vertexArrayObject) {
                this._engine.releaseVertexArrayObject(this._vertexArrayObject);
                this._vertexArrayObject = null;
            }
            this._createVertexBuffers();
        }
        _createVertexBuffers() {
            this._vertexBufferSize = this._useInstancing ? 10 : 12;
            if (this._isAnimationSheetEnabled) {
                this._vertexBufferSize += 1;
            }
            if (!this._isBillboardBased || this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED || this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL) {
                this._vertexBufferSize += 3;
            }
            if (this._useRampGradients) {
                this._vertexBufferSize += 4;
            }
            const engine = this._engine;
            const vertexSize = this._vertexBufferSize * (this._useInstancing ? 1 : 4);
            this._vertexData = new Float32Array(this._capacity * vertexSize);
            this._vertexBuffer = new Buffer$1(engine, this._vertexData, true, vertexSize);
            let dataOffset = 0;
            const positions = this._vertexBuffer.createVertexBuffer(VertexBuffer.PositionKind, dataOffset, 3, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers[VertexBuffer.PositionKind] = positions;
            dataOffset += 3;
            const colors = this._vertexBuffer.createVertexBuffer(VertexBuffer.ColorKind, dataOffset, 4, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers[VertexBuffer.ColorKind] = colors;
            dataOffset += 4;
            const options = this._vertexBuffer.createVertexBuffer("angle", dataOffset, 1, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["angle"] = options;
            dataOffset += 1;
            const size = this._vertexBuffer.createVertexBuffer("size", dataOffset, 2, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["size"] = size;
            dataOffset += 2;
            if (this._isAnimationSheetEnabled) {
                const cellIndexBuffer = this._vertexBuffer.createVertexBuffer("cellIndex", dataOffset, 1, this._vertexBufferSize, this._useInstancing);
                this._vertexBuffers["cellIndex"] = cellIndexBuffer;
                dataOffset += 1;
            }
            if (!this._isBillboardBased || this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED || this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL) {
                const directionBuffer = this._vertexBuffer.createVertexBuffer("direction", dataOffset, 3, this._vertexBufferSize, this._useInstancing);
                this._vertexBuffers["direction"] = directionBuffer;
                dataOffset += 3;
            }
            if (this._useRampGradients) {
                const rampDataBuffer = this._vertexBuffer.createVertexBuffer("remapData", dataOffset, 4, this._vertexBufferSize, this._useInstancing);
                this._vertexBuffers["remapData"] = rampDataBuffer;
                dataOffset += 4;
            }
            let offsets;
            if (this._useInstancing) {
                const spriteData = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]);
                this._spriteBuffer = new Buffer$1(engine, spriteData, false, 2);
                offsets = this._spriteBuffer.createVertexBuffer("offset", 0, 2);
            }
            else {
                offsets = this._vertexBuffer.createVertexBuffer("offset", dataOffset, 2, this._vertexBufferSize, this._useInstancing);
                dataOffset += 2;
            }
            this._vertexBuffers["offset"] = offsets;
            this.resetDrawCache();
        }
        _createIndexBuffer() {
            if (this._useInstancing) {
                return;
            }
            const indices = [];
            let index = 0;
            for (let count = 0; count < this._capacity; count++) {
                indices.push(index);
                indices.push(index + 1);
                indices.push(index + 2);
                indices.push(index);
                indices.push(index + 2);
                indices.push(index + 3);
                index += 4;
            }
            this._indexBuffer = this._engine.createIndexBuffer(indices);
        }
        /**
         * Gets the maximum number of particles active at the same time.
         * @returns The max number of active particles.
         */
        getCapacity() {
            return this._capacity;
        }
        /**
         * Gets whether there are still active particles in the system.
         * @returns True if it is alive, otherwise false.
         */
        isAlive() {
            return this._alive;
        }
        /**
         * Gets if the system has been started. (Note: this will still be true after stop is called)
         * @returns True if it has been started, otherwise false.
         */
        isStarted() {
            return this._started;
        }
        _prepareSubEmitterInternalArray() {
            this._subEmitters = new Array();
            if (this.subEmitters) {
                this.subEmitters.forEach((subEmitter) => {
                    if (subEmitter instanceof ParticleSystem) {
                        this._subEmitters.push([new SubEmitter(subEmitter)]);
                    }
                    else if (subEmitter instanceof SubEmitter) {
                        this._subEmitters.push([subEmitter]);
                    }
                    else if (subEmitter instanceof Array) {
                        this._subEmitters.push(subEmitter);
                    }
                });
            }
        }
        /**
         * Starts the particle system and begins to emit
         * @param delay defines the delay in milliseconds before starting the system (this.startDelay by default)
         */
        start(delay = this.startDelay) {
            var _a;
            if (!this.targetStopDuration && this._hasTargetStopDurationDependantGradient()) {
                throw "Particle system started with a targetStopDuration dependant gradient (eg. startSizeGradients) but no targetStopDuration set";
            }
            if (delay) {
                setTimeout(() => {
                    this.start(0);
                }, delay);
                return;
            }
            // Convert the subEmitters field to the constant type field _subEmitters
            this._prepareSubEmitterInternalArray();
            this._started = true;
            this._stopped = false;
            this._actualFrame = 0;
            if (this._subEmitters && this._subEmitters.length != 0) {
                this.activeSubSystems = new Array();
            }
            // Reset emit gradient so it acts the same on every start
            if (this._emitRateGradients) {
                if (this._emitRateGradients.length > 0) {
                    this._currentEmitRateGradient = this._emitRateGradients[0];
                    this._currentEmitRate1 = this._currentEmitRateGradient.getFactor();
                    this._currentEmitRate2 = this._currentEmitRate1;
                }
                if (this._emitRateGradients.length > 1) {
                    this._currentEmitRate2 = this._emitRateGradients[1].getFactor();
                }
            }
            // Reset start size gradient so it acts the same on every start
            if (this._startSizeGradients) {
                if (this._startSizeGradients.length > 0) {
                    this._currentStartSizeGradient = this._startSizeGradients[0];
                    this._currentStartSize1 = this._currentStartSizeGradient.getFactor();
                    this._currentStartSize2 = this._currentStartSize1;
                }
                if (this._startSizeGradients.length > 1) {
                    this._currentStartSize2 = this._startSizeGradients[1].getFactor();
                }
            }
            if (this.preWarmCycles) {
                if (((_a = this.emitter) === null || _a === void 0 ? void 0 : _a.getClassName().indexOf("Mesh")) !== -1) {
                    this.emitter.computeWorldMatrix(true);
                }
                const noiseTextureAsProcedural = this.noiseTexture;
                if (noiseTextureAsProcedural && noiseTextureAsProcedural.onGeneratedObservable) {
                    noiseTextureAsProcedural.onGeneratedObservable.addOnce(() => {
                        setTimeout(() => {
                            for (let index = 0; index < this.preWarmCycles; index++) {
                                this.animate(true);
                                noiseTextureAsProcedural.render();
                            }
                        });
                    });
                }
                else {
                    for (let index = 0; index < this.preWarmCycles; index++) {
                        this.animate(true);
                    }
                }
            }
            // Animations
            if (this.beginAnimationOnStart && this.animations && this.animations.length > 0 && this._scene) {
                this._scene.beginAnimation(this, this.beginAnimationFrom, this.beginAnimationTo, this.beginAnimationLoop);
            }
        }
        /**
         * Stops the particle system.
         * @param stopSubEmitters if true it will stop the current system and all created sub-Systems if false it will stop the current root system only, this param is used by the root particle system only. the default value is true.
         */
        stop(stopSubEmitters = true) {
            if (this._stopped) {
                return;
            }
            this.onStoppedObservable.notifyObservers(this);
            this._stopped = true;
            if (stopSubEmitters) {
                this._stopSubEmitters();
            }
        }
        // animation sheet
        /**
         * Remove all active particles
         */
        reset() {
            this._stockParticles.length = 0;
            this._particles.length = 0;
        }
        /**
         * @internal (for internal use only)
         */
        _appendParticleVertex(index, particle, offsetX, offsetY) {
            let offset = index * this._vertexBufferSize;
            this._vertexData[offset++] = particle.position.x + this.worldOffset.x;
            this._vertexData[offset++] = particle.position.y + this.worldOffset.y;
            this._vertexData[offset++] = particle.position.z + this.worldOffset.z;
            this._vertexData[offset++] = particle.color.r;
            this._vertexData[offset++] = particle.color.g;
            this._vertexData[offset++] = particle.color.b;
            this._vertexData[offset++] = particle.color.a;
            this._vertexData[offset++] = particle.angle;
            this._vertexData[offset++] = particle.scale.x * particle.size;
            this._vertexData[offset++] = particle.scale.y * particle.size;
            if (this._isAnimationSheetEnabled) {
                this._vertexData[offset++] = particle.cellIndex;
            }
            if (!this._isBillboardBased) {
                if (particle._initialDirection) {
                    let initialDirection = particle._initialDirection;
                    if (this.isLocal) {
                        Vector3.TransformNormalToRef(initialDirection, this._emitterWorldMatrix, TmpVectors.Vector3[0]);
                        initialDirection = TmpVectors.Vector3[0];
                    }
                    if (initialDirection.x === 0 && initialDirection.z === 0) {
                        initialDirection.x = 0.001;
                    }
                    this._vertexData[offset++] = initialDirection.x;
                    this._vertexData[offset++] = initialDirection.y;
                    this._vertexData[offset++] = initialDirection.z;
                }
                else {
                    let direction = particle.direction;
                    if (this.isLocal) {
                        Vector3.TransformNormalToRef(direction, this._emitterWorldMatrix, TmpVectors.Vector3[0]);
                        direction = TmpVectors.Vector3[0];
                    }
                    if (direction.x === 0 && direction.z === 0) {
                        direction.x = 0.001;
                    }
                    this._vertexData[offset++] = direction.x;
                    this._vertexData[offset++] = direction.y;
                    this._vertexData[offset++] = direction.z;
                }
            }
            else if (this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED || this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL) {
                this._vertexData[offset++] = particle.direction.x;
                this._vertexData[offset++] = particle.direction.y;
                this._vertexData[offset++] = particle.direction.z;
            }
            if (this._useRampGradients && particle.remapData) {
                this._vertexData[offset++] = particle.remapData.x;
                this._vertexData[offset++] = particle.remapData.y;
                this._vertexData[offset++] = particle.remapData.z;
                this._vertexData[offset++] = particle.remapData.w;
            }
            if (!this._useInstancing) {
                if (this._isAnimationSheetEnabled) {
                    if (offsetX === 0) {
                        offsetX = this._epsilon;
                    }
                    else if (offsetX === 1) {
                        offsetX = 1 - this._epsilon;
                    }
                    if (offsetY === 0) {
                        offsetY = this._epsilon;
                    }
                    else if (offsetY === 1) {
                        offsetY = 1 - this._epsilon;
                    }
                }
                this._vertexData[offset++] = offsetX;
                this._vertexData[offset++] = offsetY;
            }
        }
        _stopSubEmitters() {
            if (!this.activeSubSystems) {
                return;
            }
            this.activeSubSystems.forEach((subSystem) => {
                subSystem.stop(true);
            });
            this.activeSubSystems = new Array();
        }
        _removeFromRoot() {
            if (!this._rootParticleSystem) {
                return;
            }
            const index = this._rootParticleSystem.activeSubSystems.indexOf(this);
            if (index !== -1) {
                this._rootParticleSystem.activeSubSystems.splice(index, 1);
            }
            this._rootParticleSystem = null;
        }
        // End of sub system methods
        _update(newParticles) {
            // Update current
            this._alive = this._particles.length > 0;
            if (this.emitter.position) {
                const emitterMesh = this.emitter;
                this._emitterWorldMatrix = emitterMesh.getWorldMatrix();
            }
            else {
                const emitterPosition = this.emitter;
                this._emitterWorldMatrix = Matrix.Translation(emitterPosition.x, emitterPosition.y, emitterPosition.z);
            }
            this._emitterWorldMatrix.invertToRef(this._emitterInverseWorldMatrix);
            this.updateFunction(this._particles);
            // Add new ones
            let particle;
            for (let index = 0; index < newParticles; index++) {
                if (this._particles.length === this._capacity) {
                    break;
                }
                particle = this._createParticle();
                this._particles.push(particle);
                // Life time
                if (this.targetStopDuration && this._lifeTimeGradients && this._lifeTimeGradients.length > 0) {
                    const ratio = Scalar.Clamp(this._actualFrame / this.targetStopDuration);
                    GradientHelper.GetCurrentGradient(ratio, this._lifeTimeGradients, (currentGradient, nextGradient) => {
                        const factorGradient1 = currentGradient;
                        const factorGradient2 = nextGradient;
                        const lifeTime1 = factorGradient1.getFactor();
                        const lifeTime2 = factorGradient2.getFactor();
                        const gradient = (ratio - factorGradient1.gradient) / (factorGradient2.gradient - factorGradient1.gradient);
                        particle.lifeTime = Scalar.Lerp(lifeTime1, lifeTime2, gradient);
                    });
                }
                else {
                    particle.lifeTime = Scalar.RandomRange(this.minLifeTime, this.maxLifeTime);
                }
                // Emitter
                const emitPower = Scalar.RandomRange(this.minEmitPower, this.maxEmitPower);
                if (this.startPositionFunction) {
                    this.startPositionFunction(this._emitterWorldMatrix, particle.position, particle, this.isLocal);
                }
                else {
                    this.particleEmitterType.startPositionFunction(this._emitterWorldMatrix, particle.position, particle, this.isLocal);
                }
                if (this.isLocal) {
                    if (!particle._localPosition) {
                        particle._localPosition = particle.position.clone();
                    }
                    else {
                        particle._localPosition.copyFrom(particle.position);
                    }
                    Vector3.TransformCoordinatesToRef(particle._localPosition, this._emitterWorldMatrix, particle.position);
                }
                if (this.startDirectionFunction) {
                    this.startDirectionFunction(this._emitterWorldMatrix, particle.direction, particle, this.isLocal);
                }
                else {
                    this.particleEmitterType.startDirectionFunction(this._emitterWorldMatrix, particle.direction, particle, this.isLocal, this._emitterInverseWorldMatrix);
                }
                if (emitPower === 0) {
                    if (!particle._initialDirection) {
                        particle._initialDirection = particle.direction.clone();
                    }
                    else {
                        particle._initialDirection.copyFrom(particle.direction);
                    }
                }
                else {
                    particle._initialDirection = null;
                }
                particle.direction.scaleInPlace(emitPower);
                // Size
                if (!this._sizeGradients || this._sizeGradients.length === 0) {
                    particle.size = Scalar.RandomRange(this.minSize, this.maxSize);
                }
                else {
                    particle._currentSizeGradient = this._sizeGradients[0];
                    particle._currentSize1 = particle._currentSizeGradient.getFactor();
                    particle.size = particle._currentSize1;
                    if (this._sizeGradients.length > 1) {
                        particle._currentSize2 = this._sizeGradients[1].getFactor();
                    }
                    else {
                        particle._currentSize2 = particle._currentSize1;
                    }
                }
                // Size and scale
                particle.scale.copyFromFloats(Scalar.RandomRange(this.minScaleX, this.maxScaleX), Scalar.RandomRange(this.minScaleY, this.maxScaleY));
                // Adjust scale by start size
                if (this._startSizeGradients && this._startSizeGradients[0] && this.targetStopDuration) {
                    const ratio = this._actualFrame / this.targetStopDuration;
                    GradientHelper.GetCurrentGradient(ratio, this._startSizeGradients, (currentGradient, nextGradient, scale) => {
                        if (currentGradient !== this._currentStartSizeGradient) {
                            this._currentStartSize1 = this._currentStartSize2;
                            this._currentStartSize2 = nextGradient.getFactor();
                            this._currentStartSizeGradient = currentGradient;
                        }
                        const value = Scalar.Lerp(this._currentStartSize1, this._currentStartSize2, scale);
                        particle.scale.scaleInPlace(value);
                    });
                }
                // Angle
                if (!this._angularSpeedGradients || this._angularSpeedGradients.length === 0) {
                    particle.angularSpeed = Scalar.RandomRange(this.minAngularSpeed, this.maxAngularSpeed);
                }
                else {
                    particle._currentAngularSpeedGradient = this._angularSpeedGradients[0];
                    particle.angularSpeed = particle._currentAngularSpeedGradient.getFactor();
                    particle._currentAngularSpeed1 = particle.angularSpeed;
                    if (this._angularSpeedGradients.length > 1) {
                        particle._currentAngularSpeed2 = this._angularSpeedGradients[1].getFactor();
                    }
                    else {
                        particle._currentAngularSpeed2 = particle._currentAngularSpeed1;
                    }
                }
                particle.angle = Scalar.RandomRange(this.minInitialRotation, this.maxInitialRotation);
                // Velocity
                if (this._velocityGradients && this._velocityGradients.length > 0) {
                    particle._currentVelocityGradient = this._velocityGradients[0];
                    particle._currentVelocity1 = particle._currentVelocityGradient.getFactor();
                    if (this._velocityGradients.length > 1) {
                        particle._currentVelocity2 = this._velocityGradients[1].getFactor();
                    }
                    else {
                        particle._currentVelocity2 = particle._currentVelocity1;
                    }
                }
                // Limit velocity
                if (this._limitVelocityGradients && this._limitVelocityGradients.length > 0) {
                    particle._currentLimitVelocityGradient = this._limitVelocityGradients[0];
                    particle._currentLimitVelocity1 = particle._currentLimitVelocityGradient.getFactor();
                    if (this._limitVelocityGradients.length > 1) {
                        particle._currentLimitVelocity2 = this._limitVelocityGradients[1].getFactor();
                    }
                    else {
                        particle._currentLimitVelocity2 = particle._currentLimitVelocity1;
                    }
                }
                // Drag
                if (this._dragGradients && this._dragGradients.length > 0) {
                    particle._currentDragGradient = this._dragGradients[0];
                    particle._currentDrag1 = particle._currentDragGradient.getFactor();
                    if (this._dragGradients.length > 1) {
                        particle._currentDrag2 = this._dragGradients[1].getFactor();
                    }
                    else {
                        particle._currentDrag2 = particle._currentDrag1;
                    }
                }
                // Color
                if (!this._colorGradients || this._colorGradients.length === 0) {
                    const step = Scalar.RandomRange(0, 1.0);
                    Color4.LerpToRef(this.color1, this.color2, step, particle.color);
                    this.colorDead.subtractToRef(particle.color, this._colorDiff);
                    this._colorDiff.scaleToRef(1.0 / particle.lifeTime, particle.colorStep);
                }
                else {
                    particle._currentColorGradient = this._colorGradients[0];
                    particle._currentColorGradient.getColorToRef(particle.color);
                    particle._currentColor1.copyFrom(particle.color);
                    if (this._colorGradients.length > 1) {
                        this._colorGradients[1].getColorToRef(particle._currentColor2);
                    }
                    else {
                        particle._currentColor2.copyFrom(particle.color);
                    }
                }
                // Sheet
                if (this._isAnimationSheetEnabled) {
                    particle._initialStartSpriteCellID = this.startSpriteCellID;
                    particle._initialEndSpriteCellID = this.endSpriteCellID;
                    particle._initialSpriteCellLoop = this.spriteCellLoop;
                }
                // Inherited Velocity
                particle.direction.addInPlace(this._inheritedVelocityOffset);
                // Ramp
                if (this._useRampGradients) {
                    particle.remapData = new Vector4(0, 1, 0, 1);
                }
                // Noise texture coordinates
                if (this.noiseTexture) {
                    if (particle._randomNoiseCoordinates1) {
                        particle._randomNoiseCoordinates1.copyFromFloats(Math.random(), Math.random(), Math.random());
                        particle._randomNoiseCoordinates2.copyFromFloats(Math.random(), Math.random(), Math.random());
                    }
                    else {
                        particle._randomNoiseCoordinates1 = new Vector3(Math.random(), Math.random(), Math.random());
                        particle._randomNoiseCoordinates2 = new Vector3(Math.random(), Math.random(), Math.random());
                    }
                }
                // Update the position of the attached sub-emitters to match their attached particle
                particle._inheritParticleInfoToSubEmitters();
            }
        }
        /**
         * @internal
         */
        static _GetAttributeNamesOrOptions(isAnimationSheetEnabled = false, isBillboardBased = false, useRampGradients = false) {
            const attributeNamesOrOptions = [VertexBuffer.PositionKind, VertexBuffer.ColorKind, "angle", "offset", "size"];
            if (isAnimationSheetEnabled) {
                attributeNamesOrOptions.push("cellIndex");
            }
            if (!isBillboardBased) {
                attributeNamesOrOptions.push("direction");
            }
            if (useRampGradients) {
                attributeNamesOrOptions.push("remapData");
            }
            return attributeNamesOrOptions;
        }
        /**
         * @internal
         */
        static _GetEffectCreationOptions(isAnimationSheetEnabled = false, useLogarithmicDepth = false) {
            const effectCreationOption = ["invView", "view", "projection", "textureMask", "translationPivot", "eyePosition"];
            addClipPlaneUniforms(effectCreationOption);
            if (isAnimationSheetEnabled) {
                effectCreationOption.push("particlesInfos");
            }
            if (useLogarithmicDepth) {
                effectCreationOption.push("logarithmicDepthConstant");
            }
            return effectCreationOption;
        }
        /**
         * Fill the defines array according to the current settings of the particle system
         * @param defines Array to be updated
         * @param blendMode blend mode to take into account when updating the array
         */
        fillDefines(defines, blendMode) {
            if (this._scene) {
                prepareStringDefinesForClipPlanes(this, this._scene, defines);
            }
            if (this._isAnimationSheetEnabled) {
                defines.push("#define ANIMATESHEET");
            }
            if (this.useLogarithmicDepth) {
                defines.push("#define LOGARITHMICDEPTH");
            }
            if (blendMode === ParticleSystem.BLENDMODE_MULTIPLY) {
                defines.push("#define BLENDMULTIPLYMODE");
            }
            if (this._useRampGradients) {
                defines.push("#define RAMPGRADIENT");
            }
            if (this._isBillboardBased) {
                defines.push("#define BILLBOARD");
                switch (this.billboardMode) {
                    case ParticleSystem.BILLBOARDMODE_Y:
                        defines.push("#define BILLBOARDY");
                        break;
                    case ParticleSystem.BILLBOARDMODE_STRETCHED:
                    case ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL:
                        defines.push("#define BILLBOARDSTRETCHED");
                        if (this.billboardMode === ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL) {
                            defines.push("#define BILLBOARDSTRETCHED_LOCAL");
                        }
                        break;
                    case ParticleSystem.BILLBOARDMODE_ALL:
                        defines.push("#define BILLBOARDMODE_ALL");
                        break;
                }
            }
            if (this._imageProcessingConfiguration) {
                this._imageProcessingConfiguration.prepareDefines(this._imageProcessingConfigurationDefines);
                defines.push(this._imageProcessingConfigurationDefines.toString());
            }
        }
        /**
         * Fill the uniforms, attributes and samplers arrays according to the current settings of the particle system
         * @param uniforms Uniforms array to fill
         * @param attributes Attributes array to fill
         * @param samplers Samplers array to fill
         */
        fillUniformsAttributesAndSamplerNames(uniforms, attributes, samplers) {
            attributes.push(...ParticleSystem._GetAttributeNamesOrOptions(this._isAnimationSheetEnabled, this._isBillboardBased && this.billboardMode !== ParticleSystem.BILLBOARDMODE_STRETCHED && this.billboardMode !== ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL, this._useRampGradients));
            uniforms.push(...ParticleSystem._GetEffectCreationOptions(this._isAnimationSheetEnabled, this.useLogarithmicDepth));
            samplers.push("diffuseSampler", "rampSampler");
            if (this._imageProcessingConfiguration) {
                ImageProcessingConfiguration.PrepareUniforms(uniforms, this._imageProcessingConfigurationDefines);
                ImageProcessingConfiguration.PrepareSamplers(samplers, this._imageProcessingConfigurationDefines);
            }
        }
        /**
         * @internal
         */
        _getWrapper(blendMode) {
            const customWrapper = this._getCustomDrawWrapper(blendMode);
            if (customWrapper === null || customWrapper === void 0 ? void 0 : customWrapper.effect) {
                return customWrapper;
            }
            const defines = [];
            this.fillDefines(defines, blendMode);
            // Effect
            const currentRenderPassId = this._engine._features.supportRenderPasses ? this._engine.currentRenderPassId : 0;
            let drawWrappers = this._drawWrappers[currentRenderPassId];
            if (!drawWrappers) {
                drawWrappers = this._drawWrappers[currentRenderPassId] = [];
            }
            let drawWrapper = drawWrappers[blendMode];
            if (!drawWrapper) {
                drawWrapper = new DrawWrapper(this._engine);
                if (drawWrapper.drawContext) {
                    drawWrapper.drawContext.useInstancing = this._useInstancing;
                }
                drawWrappers[blendMode] = drawWrapper;
            }
            const join = defines.join("\n");
            if (drawWrapper.defines !== join) {
                const attributesNamesOrOptions = [];
                const effectCreationOption = [];
                const samplers = [];
                this.fillUniformsAttributesAndSamplerNames(effectCreationOption, attributesNamesOrOptions, samplers);
                drawWrapper.setEffect(this._engine.createEffect("particles", attributesNamesOrOptions, effectCreationOption, samplers, join), join);
            }
            return drawWrapper;
        }
        /**
         * Animates the particle system for the current frame by emitting new particles and or animating the living ones.
         * @param preWarmOnly will prevent the system from updating the vertex buffer (default is false)
         */
        animate(preWarmOnly = false) {
            var _a;
            if (!this._started) {
                return;
            }
            if (!preWarmOnly && this._scene) {
                // Check
                if (!this.isReady()) {
                    return;
                }
                if (this._currentRenderId === this._scene.getFrameId()) {
                    return;
                }
                this._currentRenderId = this._scene.getFrameId();
            }
            this._scaledUpdateSpeed = this.updateSpeed * (preWarmOnly ? this.preWarmStepOffset : ((_a = this._scene) === null || _a === void 0 ? void 0 : _a.getAnimationRatio()) || 1);
            // Determine the number of particles we need to create
            let newParticles;
            if (this.manualEmitCount > -1) {
                newParticles = this.manualEmitCount;
                this._newPartsExcess = 0;
                this.manualEmitCount = 0;
            }
            else {
                let rate = this.emitRate;
                if (this._emitRateGradients && this._emitRateGradients.length > 0 && this.targetStopDuration) {
                    const ratio = this._actualFrame / this.targetStopDuration;
                    GradientHelper.GetCurrentGradient(ratio, this._emitRateGradients, (currentGradient, nextGradient, scale) => {
                        if (currentGradient !== this._currentEmitRateGradient) {
                            this._currentEmitRate1 = this._currentEmitRate2;
                            this._currentEmitRate2 = nextGradient.getFactor();
                            this._currentEmitRateGradient = currentGradient;
                        }
                        rate = Scalar.Lerp(this._currentEmitRate1, this._currentEmitRate2, scale);
                    });
                }
                newParticles = (rate * this._scaledUpdateSpeed) >> 0;
                this._newPartsExcess += rate * this._scaledUpdateSpeed - newParticles;
            }
            if (this._newPartsExcess > 1.0) {
                newParticles += this._newPartsExcess >> 0;
                this._newPartsExcess -= this._newPartsExcess >> 0;
            }
            this._alive = false;
            if (!this._stopped) {
                this._actualFrame += this._scaledUpdateSpeed;
                if (this.targetStopDuration && this._actualFrame >= this.targetStopDuration) {
                    this.stop();
                }
            }
            else {
                newParticles = 0;
            }
            this._update(newParticles);
            // Stopped?
            if (this._stopped) {
                if (!this._alive) {
                    this._started = false;
                    if (this.onAnimationEnd) {
                        this.onAnimationEnd();
                    }
                    if (this.disposeOnStop && this._scene) {
                        this._scene._toBeDisposed.push(this);
                    }
                }
            }
            if (!preWarmOnly) {
                // Update VBO
                let offset = 0;
                for (let index = 0; index < this._particles.length; index++) {
                    const particle = this._particles[index];
                    this._appendParticleVertices(offset, particle);
                    offset += this._useInstancing ? 1 : 4;
                }
                if (this._vertexBuffer) {
                    this._vertexBuffer.updateDirectly(this._vertexData, 0, this._particles.length);
                }
            }
            if (this.manualEmitCount === 0 && this.disposeOnStop) {
                this.stop();
            }
        }
        _appendParticleVertices(offset, particle) {
            this._appendParticleVertex(offset++, particle, 0, 0);
            if (!this._useInstancing) {
                this._appendParticleVertex(offset++, particle, 1, 0);
                this._appendParticleVertex(offset++, particle, 1, 1);
                this._appendParticleVertex(offset++, particle, 0, 1);
            }
        }
        /**
         * Rebuilds the particle system.
         */
        rebuild() {
            var _a, _b;
            if (this._engine.getCaps().vertexArrayObject) {
                this._vertexArrayObject = null;
            }
            this._createIndexBuffer();
            (_a = this._spriteBuffer) === null || _a === void 0 ? void 0 : _a._rebuild();
            (_b = this._vertexBuffer) === null || _b === void 0 ? void 0 : _b._rebuild();
            for (const key in this._vertexBuffers) {
                this._vertexBuffers[key]._rebuild();
            }
            this.resetDrawCache();
        }
        /**
         * Is this system ready to be used/rendered
         * @returns true if the system is ready
         */
        isReady() {
            if (!this.emitter || (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.isReady()) || !this.particleTexture || !this.particleTexture.isReady()) {
                return false;
            }
            if (this.blendMode !== ParticleSystem.BLENDMODE_MULTIPLYADD) {
                if (!this._getWrapper(this.blendMode).effect.isReady()) {
                    return false;
                }
            }
            else {
                if (!this._getWrapper(ParticleSystem.BLENDMODE_MULTIPLY).effect.isReady()) {
                    return false;
                }
                if (!this._getWrapper(ParticleSystem.BLENDMODE_ADD).effect.isReady()) {
                    return false;
                }
            }
            return true;
        }
        _render(blendMode) {
            var _a, _b;
            const drawWrapper = this._getWrapper(blendMode);
            const effect = drawWrapper.effect;
            const engine = this._engine;
            // Render
            engine.enableEffect(drawWrapper);
            const viewMatrix = (_a = this.defaultViewMatrix) !== null && _a !== void 0 ? _a : this._scene.getViewMatrix();
            effect.setTexture("diffuseSampler", this.particleTexture);
            effect.setMatrix("view", viewMatrix);
            effect.setMatrix("projection", (_b = this.defaultProjectionMatrix) !== null && _b !== void 0 ? _b : this._scene.getProjectionMatrix());
            if (this._isAnimationSheetEnabled && this.particleTexture) {
                const baseSize = this.particleTexture.getBaseSize();
                effect.setFloat3("particlesInfos", this.spriteCellWidth / baseSize.width, this.spriteCellHeight / baseSize.height, this.spriteCellWidth / baseSize.width);
            }
            effect.setVector2("translationPivot", this.translationPivot);
            effect.setFloat4("textureMask", this.textureMask.r, this.textureMask.g, this.textureMask.b, this.textureMask.a);
            if (this._isBillboardBased && this._scene) {
                const camera = this._scene.activeCamera;
                effect.setVector3("eyePosition", camera.globalPosition);
            }
            if (this._rampGradientsTexture) {
                if (!this._rampGradients || !this._rampGradients.length) {
                    this._rampGradientsTexture.dispose();
                    this._rampGradientsTexture = null;
                }
                effect.setTexture("rampSampler", this._rampGradientsTexture);
            }
            const defines = effect.defines;
            if (this._scene) {
                bindClipPlane(effect, this, this._scene);
            }
            if (defines.indexOf("#define BILLBOARDMODE_ALL") >= 0) {
                viewMatrix.invertToRef(TmpVectors.Matrix[0]);
                effect.setMatrix("invView", TmpVectors.Matrix[0]);
            }
            if (this._vertexArrayObject !== undefined) {
                if (!this._vertexArrayObject) {
                    this._vertexArrayObject = this._engine.recordVertexArrayObject(this._vertexBuffers, this._indexBuffer, effect);
                }
                this._engine.bindVertexArrayObject(this._vertexArrayObject, this._indexBuffer);
            }
            else {
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
            }
            // Log. depth
            if (this.useLogarithmicDepth && this._scene) {
                MaterialHelper.BindLogDepth(defines, effect, this._scene);
            }
            // image processing
            if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) {
                this._imageProcessingConfiguration.bind(effect);
            }
            // Draw order
            switch (blendMode) {
                case ParticleSystem.BLENDMODE_ADD:
                    engine.setAlphaMode(1);
                    break;
                case ParticleSystem.BLENDMODE_ONEONE:
                    engine.setAlphaMode(6);
                    break;
                case ParticleSystem.BLENDMODE_STANDARD:
                    engine.setAlphaMode(2);
                    break;
                case ParticleSystem.BLENDMODE_MULTIPLY:
                    engine.setAlphaMode(4);
                    break;
            }
            if (this._onBeforeDrawParticlesObservable) {
                this._onBeforeDrawParticlesObservable.notifyObservers(effect);
            }
            if (this._useInstancing) {
                engine.drawArraysType(7, 0, 4, this._particles.length);
            }
            else {
                engine.drawElementsType(0, 0, this._particles.length * 6);
            }
            return this._particles.length;
        }
        /**
         * Renders the particle system in its current state.
         * @returns the current number of particles
         */
        render() {
            // Check
            if (!this.isReady() || !this._particles.length) {
                return 0;
            }
            const engine = this._engine;
            if (engine.setState) {
                engine.setState(false);
                if (this.forceDepthWrite) {
                    engine.setDepthWrite(true);
                }
            }
            let outparticles = 0;
            if (this.blendMode === ParticleSystem.BLENDMODE_MULTIPLYADD) {
                outparticles = this._render(ParticleSystem.BLENDMODE_MULTIPLY) + this._render(ParticleSystem.BLENDMODE_ADD);
            }
            else {
                outparticles = this._render(this.blendMode);
            }
            this._engine.unbindInstanceAttributes();
            this._engine.setAlphaMode(0);
            return outparticles;
        }
        /**
         * Disposes the particle system and free the associated resources
         * @param disposeTexture defines if the particle texture must be disposed as well (true by default)
         */
        dispose(disposeTexture = true) {
            this.resetDrawCache();
            if (this._vertexBuffer) {
                this._vertexBuffer.dispose();
                this._vertexBuffer = null;
            }
            if (this._spriteBuffer) {
                this._spriteBuffer.dispose();
                this._spriteBuffer = null;
            }
            if (this._indexBuffer) {
                this._engine._releaseBuffer(this._indexBuffer);
                this._indexBuffer = null;
            }
            if (this._vertexArrayObject) {
                this._engine.releaseVertexArrayObject(this._vertexArrayObject);
                this._vertexArrayObject = null;
            }
            if (disposeTexture && this.particleTexture) {
                this.particleTexture.dispose();
                this.particleTexture = null;
            }
            if (disposeTexture && this.noiseTexture) {
                this.noiseTexture.dispose();
                this.noiseTexture = null;
            }
            if (this._rampGradientsTexture) {
                this._rampGradientsTexture.dispose();
                this._rampGradientsTexture = null;
            }
            this._removeFromRoot();
            if (this.subEmitters && !this._subEmitters) {
                this._prepareSubEmitterInternalArray();
            }
            if (this._subEmitters && this._subEmitters.length) {
                for (let index = 0; index < this._subEmitters.length; index++) {
                    for (const subEmitter of this._subEmitters[index]) {
                        subEmitter.dispose();
                    }
                }
                this._subEmitters = [];
                this.subEmitters = [];
            }
            if (this._disposeEmitterOnDispose && this.emitter && this.emitter.dispose) {
                this.emitter.dispose(true);
            }
            if (this._onBeforeDrawParticlesObservable) {
                this._onBeforeDrawParticlesObservable.clear();
            }
            // Remove from scene
            if (this._scene) {
                const index = this._scene.particleSystems.indexOf(this);
                if (index > -1) {
                    this._scene.particleSystems.splice(index, 1);
                }
                this._scene._activeParticleSystems.dispose();
            }
            // Callback
            this.onDisposeObservable.notifyObservers(this);
            this.onDisposeObservable.clear();
            this.onStoppedObservable.clear();
            this.reset();
        }
        // Clone
        /**
         * Clones the particle system.
         * @param name The name of the cloned object
         * @param newEmitter The new emitter to use
         * @param cloneTexture Also clone the textures if true
         * @returns the cloned particle system
         */
        clone(name, newEmitter, cloneTexture = false) {
            const custom = Object.assign({}, this._customWrappers);
            let program = null;
            const engine = this._engine;
            if (engine.createEffectForParticles) {
                if (this.customShader != null) {
                    program = this.customShader;
                    const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
                    const effect = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines);
                    if (!custom[0]) {
                        this.setCustomEffect(effect, 0);
                    }
                    else {
                        custom[0].effect = effect;
                    }
                }
            }
            const serialization = this.serialize(cloneTexture);
            const result = ParticleSystem.Parse(serialization, this._scene || this._engine, this._rootUrl);
            result.name = name;
            result.customShader = program;
            result._customWrappers = custom;
            if (newEmitter === undefined) {
                newEmitter = this.emitter;
            }
            if (this.noiseTexture) {
                result.noiseTexture = this.noiseTexture.clone();
            }
            result.emitter = newEmitter;
            if (!this.preventAutoStart) {
                result.start();
            }
            return result;
        }
        /**
         * Serializes the particle system to a JSON object
         * @param serializeTexture defines if the texture must be serialized as well
         * @returns the JSON object
         */
        serialize(serializeTexture = false) {
            const serializationObject = {};
            ParticleSystem._Serialize(serializationObject, this, serializeTexture);
            serializationObject.textureMask = this.textureMask.asArray();
            serializationObject.customShader = this.customShader;
            serializationObject.preventAutoStart = this.preventAutoStart;
            // SubEmitters
            if (this.subEmitters) {
                serializationObject.subEmitters = [];
                if (!this._subEmitters) {
                    this._prepareSubEmitterInternalArray();
                }
                for (const subs of this._subEmitters) {
                    const cell = [];
                    for (const sub of subs) {
                        cell.push(sub.serialize(serializeTexture));
                    }
                    serializationObject.subEmitters.push(cell);
                }
            }
            return serializationObject;
        }
        /**
         * @internal
         */
        static _Serialize(serializationObject, particleSystem, serializeTexture) {
            serializationObject.name = particleSystem.name;
            serializationObject.id = particleSystem.id;
            serializationObject.capacity = particleSystem.getCapacity();
            serializationObject.disposeOnStop = particleSystem.disposeOnStop;
            serializationObject.manualEmitCount = particleSystem.manualEmitCount;
            // Emitter
            if (particleSystem.emitter.position) {
                const emitterMesh = particleSystem.emitter;
                serializationObject.emitterId = emitterMesh.id;
            }
            else {
                const emitterPosition = particleSystem.emitter;
                serializationObject.emitter = emitterPosition.asArray();
            }
            // Emitter
            if (particleSystem.particleEmitterType) {
                serializationObject.particleEmitterType = particleSystem.particleEmitterType.serialize();
            }
            if (particleSystem.particleTexture) {
                if (serializeTexture) {
                    serializationObject.texture = particleSystem.particleTexture.serialize();
                }
                else {
                    serializationObject.textureName = particleSystem.particleTexture.name;
                    serializationObject.invertY = !!particleSystem.particleTexture._invertY;
                }
            }
            serializationObject.isLocal = particleSystem.isLocal;
            // Animations
            SerializationHelper.AppendSerializedAnimations(particleSystem, serializationObject);
            serializationObject.beginAnimationOnStart = particleSystem.beginAnimationOnStart;
            serializationObject.beginAnimationFrom = particleSystem.beginAnimationFrom;
            serializationObject.beginAnimationTo = particleSystem.beginAnimationTo;
            serializationObject.beginAnimationLoop = particleSystem.beginAnimationLoop;
            // Particle system
            serializationObject.startDelay = particleSystem.startDelay;
            serializationObject.renderingGroupId = particleSystem.renderingGroupId;
            serializationObject.isBillboardBased = particleSystem.isBillboardBased;
            serializationObject.billboardMode = particleSystem.billboardMode;
            serializationObject.minAngularSpeed = particleSystem.minAngularSpeed;
            serializationObject.maxAngularSpeed = particleSystem.maxAngularSpeed;
            serializationObject.minSize = particleSystem.minSize;
            serializationObject.maxSize = particleSystem.maxSize;
            serializationObject.minScaleX = particleSystem.minScaleX;
            serializationObject.maxScaleX = particleSystem.maxScaleX;
            serializationObject.minScaleY = particleSystem.minScaleY;
            serializationObject.maxScaleY = particleSystem.maxScaleY;
            serializationObject.minEmitPower = particleSystem.minEmitPower;
            serializationObject.maxEmitPower = particleSystem.maxEmitPower;
            serializationObject.minLifeTime = particleSystem.minLifeTime;
            serializationObject.maxLifeTime = particleSystem.maxLifeTime;
            serializationObject.emitRate = particleSystem.emitRate;
            serializationObject.gravity = particleSystem.gravity.asArray();
            serializationObject.noiseStrength = particleSystem.noiseStrength.asArray();
            serializationObject.color1 = particleSystem.color1.asArray();
            serializationObject.color2 = particleSystem.color2.asArray();
            serializationObject.colorDead = particleSystem.colorDead.asArray();
            serializationObject.updateSpeed = particleSystem.updateSpeed;
            serializationObject.targetStopDuration = particleSystem.targetStopDuration;
            serializationObject.blendMode = particleSystem.blendMode;
            serializationObject.preWarmCycles = particleSystem.preWarmCycles;
            serializationObject.preWarmStepOffset = particleSystem.preWarmStepOffset;
            serializationObject.minInitialRotation = particleSystem.minInitialRotation;
            serializationObject.maxInitialRotation = particleSystem.maxInitialRotation;
            serializationObject.startSpriteCellID = particleSystem.startSpriteCellID;
            serializationObject.spriteCellLoop = particleSystem.spriteCellLoop;
            serializationObject.endSpriteCellID = particleSystem.endSpriteCellID;
            serializationObject.spriteCellChangeSpeed = particleSystem.spriteCellChangeSpeed;
            serializationObject.spriteCellWidth = particleSystem.spriteCellWidth;
            serializationObject.spriteCellHeight = particleSystem.spriteCellHeight;
            serializationObject.spriteRandomStartCell = particleSystem.spriteRandomStartCell;
            serializationObject.isAnimationSheetEnabled = particleSystem.isAnimationSheetEnabled;
            serializationObject.useLogarithmicDepth = particleSystem.useLogarithmicDepth;
            const colorGradients = particleSystem.getColorGradients();
            if (colorGradients) {
                serializationObject.colorGradients = [];
                for (const colorGradient of colorGradients) {
                    const serializedGradient = {
                        gradient: colorGradient.gradient,
                        color1: colorGradient.color1.asArray(),
                    };
                    if (colorGradient.color2) {
                        serializedGradient.color2 = colorGradient.color2.asArray();
                    }
                    else {
                        serializedGradient.color2 = colorGradient.color1.asArray();
                    }
                    serializationObject.colorGradients.push(serializedGradient);
                }
            }
            const rampGradients = particleSystem.getRampGradients();
            if (rampGradients) {
                serializationObject.rampGradients = [];
                for (const rampGradient of rampGradients) {
                    const serializedGradient = {
                        gradient: rampGradient.gradient,
                        color: rampGradient.color.asArray(),
                    };
                    serializationObject.rampGradients.push(serializedGradient);
                }
                serializationObject.useRampGradients = particleSystem.useRampGradients;
            }
            const colorRemapGradients = particleSystem.getColorRemapGradients();
            if (colorRemapGradients) {
                serializationObject.colorRemapGradients = [];
                for (const colorRemapGradient of colorRemapGradients) {
                    const serializedGradient = {
                        gradient: colorRemapGradient.gradient,
                        factor1: colorRemapGradient.factor1,
                    };
                    if (colorRemapGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = colorRemapGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = colorRemapGradient.factor1;
                    }
                    serializationObject.colorRemapGradients.push(serializedGradient);
                }
            }
            const alphaRemapGradients = particleSystem.getAlphaRemapGradients();
            if (alphaRemapGradients) {
                serializationObject.alphaRemapGradients = [];
                for (const alphaRemapGradient of alphaRemapGradients) {
                    const serializedGradient = {
                        gradient: alphaRemapGradient.gradient,
                        factor1: alphaRemapGradient.factor1,
                    };
                    if (alphaRemapGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = alphaRemapGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = alphaRemapGradient.factor1;
                    }
                    serializationObject.alphaRemapGradients.push(serializedGradient);
                }
            }
            const sizeGradients = particleSystem.getSizeGradients();
            if (sizeGradients) {
                serializationObject.sizeGradients = [];
                for (const sizeGradient of sizeGradients) {
                    const serializedGradient = {
                        gradient: sizeGradient.gradient,
                        factor1: sizeGradient.factor1,
                    };
                    if (sizeGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = sizeGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = sizeGradient.factor1;
                    }
                    serializationObject.sizeGradients.push(serializedGradient);
                }
            }
            const angularSpeedGradients = particleSystem.getAngularSpeedGradients();
            if (angularSpeedGradients) {
                serializationObject.angularSpeedGradients = [];
                for (const angularSpeedGradient of angularSpeedGradients) {
                    const serializedGradient = {
                        gradient: angularSpeedGradient.gradient,
                        factor1: angularSpeedGradient.factor1,
                    };
                    if (angularSpeedGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = angularSpeedGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = angularSpeedGradient.factor1;
                    }
                    serializationObject.angularSpeedGradients.push(serializedGradient);
                }
            }
            const velocityGradients = particleSystem.getVelocityGradients();
            if (velocityGradients) {
                serializationObject.velocityGradients = [];
                for (const velocityGradient of velocityGradients) {
                    const serializedGradient = {
                        gradient: velocityGradient.gradient,
                        factor1: velocityGradient.factor1,
                    };
                    if (velocityGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = velocityGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = velocityGradient.factor1;
                    }
                    serializationObject.velocityGradients.push(serializedGradient);
                }
            }
            const dragGradients = particleSystem.getDragGradients();
            if (dragGradients) {
                serializationObject.dragGradients = [];
                for (const dragGradient of dragGradients) {
                    const serializedGradient = {
                        gradient: dragGradient.gradient,
                        factor1: dragGradient.factor1,
                    };
                    if (dragGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = dragGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = dragGradient.factor1;
                    }
                    serializationObject.dragGradients.push(serializedGradient);
                }
            }
            const emitRateGradients = particleSystem.getEmitRateGradients();
            if (emitRateGradients) {
                serializationObject.emitRateGradients = [];
                for (const emitRateGradient of emitRateGradients) {
                    const serializedGradient = {
                        gradient: emitRateGradient.gradient,
                        factor1: emitRateGradient.factor1,
                    };
                    if (emitRateGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = emitRateGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = emitRateGradient.factor1;
                    }
                    serializationObject.emitRateGradients.push(serializedGradient);
                }
            }
            const startSizeGradients = particleSystem.getStartSizeGradients();
            if (startSizeGradients) {
                serializationObject.startSizeGradients = [];
                for (const startSizeGradient of startSizeGradients) {
                    const serializedGradient = {
                        gradient: startSizeGradient.gradient,
                        factor1: startSizeGradient.factor1,
                    };
                    if (startSizeGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = startSizeGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = startSizeGradient.factor1;
                    }
                    serializationObject.startSizeGradients.push(serializedGradient);
                }
            }
            const lifeTimeGradients = particleSystem.getLifeTimeGradients();
            if (lifeTimeGradients) {
                serializationObject.lifeTimeGradients = [];
                for (const lifeTimeGradient of lifeTimeGradients) {
                    const serializedGradient = {
                        gradient: lifeTimeGradient.gradient,
                        factor1: lifeTimeGradient.factor1,
                    };
                    if (lifeTimeGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = lifeTimeGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = lifeTimeGradient.factor1;
                    }
                    serializationObject.lifeTimeGradients.push(serializedGradient);
                }
            }
            const limitVelocityGradients = particleSystem.getLimitVelocityGradients();
            if (limitVelocityGradients) {
                serializationObject.limitVelocityGradients = [];
                for (const limitVelocityGradient of limitVelocityGradients) {
                    const serializedGradient = {
                        gradient: limitVelocityGradient.gradient,
                        factor1: limitVelocityGradient.factor1,
                    };
                    if (limitVelocityGradient.factor2 !== undefined) {
                        serializedGradient.factor2 = limitVelocityGradient.factor2;
                    }
                    else {
                        serializedGradient.factor2 = limitVelocityGradient.factor1;
                    }
                    serializationObject.limitVelocityGradients.push(serializedGradient);
                }
                serializationObject.limitVelocityDamping = particleSystem.limitVelocityDamping;
            }
            if (particleSystem.noiseTexture) {
                serializationObject.noiseTexture = particleSystem.noiseTexture.serialize();
            }
        }
        /**
         * @internal
         */
        static _Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl) {
            var _a, _b, _c;
            let scene;
            if (sceneOrEngine instanceof ThinEngine) {
                scene = null;
            }
            else {
                scene = sceneOrEngine;
            }
            const internalClass = GetClass("BABYLON.Texture");
            if (internalClass && scene) {
                // Texture
                if (parsedParticleSystem.texture) {
                    particleSystem.particleTexture = internalClass.Parse(parsedParticleSystem.texture, scene, rootUrl);
                }
                else if (parsedParticleSystem.textureName) {
                    particleSystem.particleTexture = new internalClass(rootUrl + parsedParticleSystem.textureName, scene, false, parsedParticleSystem.invertY !== undefined ? parsedParticleSystem.invertY : true);
                    particleSystem.particleTexture.name = parsedParticleSystem.textureName;
                }
            }
            // Emitter
            if (!parsedParticleSystem.emitterId && parsedParticleSystem.emitterId !== 0 && parsedParticleSystem.emitter === undefined) {
                particleSystem.emitter = Vector3.Zero();
            }
            else if (parsedParticleSystem.emitterId && scene) {
                particleSystem.emitter = scene.getLastMeshById(parsedParticleSystem.emitterId);
            }
            else {
                particleSystem.emitter = Vector3.FromArray(parsedParticleSystem.emitter);
            }
            particleSystem.isLocal = !!parsedParticleSystem.isLocal;
            // Misc.
            if (parsedParticleSystem.renderingGroupId !== undefined) {
                particleSystem.renderingGroupId = parsedParticleSystem.renderingGroupId;
            }
            if (parsedParticleSystem.isBillboardBased !== undefined) {
                particleSystem.isBillboardBased = parsedParticleSystem.isBillboardBased;
            }
            if (parsedParticleSystem.billboardMode !== undefined) {
                particleSystem.billboardMode = parsedParticleSystem.billboardMode;
            }
            if (parsedParticleSystem.useLogarithmicDepth !== undefined) {
                particleSystem.useLogarithmicDepth = parsedParticleSystem.useLogarithmicDepth;
            }
            // Animations
            if (parsedParticleSystem.animations) {
                for (let animationIndex = 0; animationIndex < parsedParticleSystem.animations.length; animationIndex++) {
                    const parsedAnimation = parsedParticleSystem.animations[animationIndex];
                    const internalClass = GetClass("BABYLON.Animation");
                    if (internalClass) {
                        particleSystem.animations.push(internalClass.Parse(parsedAnimation));
                    }
                }
                particleSystem.beginAnimationOnStart = parsedParticleSystem.beginAnimationOnStart;
                particleSystem.beginAnimationFrom = parsedParticleSystem.beginAnimationFrom;
                particleSystem.beginAnimationTo = parsedParticleSystem.beginAnimationTo;
                particleSystem.beginAnimationLoop = parsedParticleSystem.beginAnimationLoop;
            }
            if (parsedParticleSystem.autoAnimate && scene) {
                scene.beginAnimation(particleSystem, parsedParticleSystem.autoAnimateFrom, parsedParticleSystem.autoAnimateTo, parsedParticleSystem.autoAnimateLoop, parsedParticleSystem.autoAnimateSpeed || 1.0);
            }
            // Particle system
            particleSystem.startDelay = parsedParticleSystem.startDelay | 0;
            particleSystem.minAngularSpeed = parsedParticleSystem.minAngularSpeed;
            particleSystem.maxAngularSpeed = parsedParticleSystem.maxAngularSpeed;
            particleSystem.minSize = parsedParticleSystem.minSize;
            particleSystem.maxSize = parsedParticleSystem.maxSize;
            if (parsedParticleSystem.minScaleX) {
                particleSystem.minScaleX = parsedParticleSystem.minScaleX;
                particleSystem.maxScaleX = parsedParticleSystem.maxScaleX;
                particleSystem.minScaleY = parsedParticleSystem.minScaleY;
                particleSystem.maxScaleY = parsedParticleSystem.maxScaleY;
            }
            if (parsedParticleSystem.preWarmCycles !== undefined) {
                particleSystem.preWarmCycles = parsedParticleSystem.preWarmCycles;
                particleSystem.preWarmStepOffset = parsedParticleSystem.preWarmStepOffset;
            }
            if (parsedParticleSystem.minInitialRotation !== undefined) {
                particleSystem.minInitialRotation = parsedParticleSystem.minInitialRotation;
                particleSystem.maxInitialRotation = parsedParticleSystem.maxInitialRotation;
            }
            particleSystem.minLifeTime = parsedParticleSystem.minLifeTime;
            particleSystem.maxLifeTime = parsedParticleSystem.maxLifeTime;
            particleSystem.minEmitPower = parsedParticleSystem.minEmitPower;
            particleSystem.maxEmitPower = parsedParticleSystem.maxEmitPower;
            particleSystem.emitRate = parsedParticleSystem.emitRate;
            particleSystem.gravity = Vector3.FromArray(parsedParticleSystem.gravity);
            if (parsedParticleSystem.noiseStrength) {
                particleSystem.noiseStrength = Vector3.FromArray(parsedParticleSystem.noiseStrength);
            }
            particleSystem.color1 = Color4.FromArray(parsedParticleSystem.color1);
            particleSystem.color2 = Color4.FromArray(parsedParticleSystem.color2);
            particleSystem.colorDead = Color4.FromArray(parsedParticleSystem.colorDead);
            particleSystem.updateSpeed = parsedParticleSystem.updateSpeed;
            particleSystem.targetStopDuration = parsedParticleSystem.targetStopDuration;
            particleSystem.blendMode = parsedParticleSystem.blendMode;
            if (parsedParticleSystem.colorGradients) {
                for (const colorGradient of parsedParticleSystem.colorGradients) {
                    particleSystem.addColorGradient(colorGradient.gradient, Color4.FromArray(colorGradient.color1), colorGradient.color2 ? Color4.FromArray(colorGradient.color2) : undefined);
                }
            }
            if (parsedParticleSystem.rampGradients) {
                for (const rampGradient of parsedParticleSystem.rampGradients) {
                    particleSystem.addRampGradient(rampGradient.gradient, Color3.FromArray(rampGradient.color));
                }
                particleSystem.useRampGradients = parsedParticleSystem.useRampGradients;
            }
            if (parsedParticleSystem.colorRemapGradients) {
                for (const colorRemapGradient of parsedParticleSystem.colorRemapGradients) {
                    particleSystem.addColorRemapGradient(colorRemapGradient.gradient, colorRemapGradient.factor1 !== undefined ? colorRemapGradient.factor1 : colorRemapGradient.factor, colorRemapGradient.factor2);
                }
            }
            if (parsedParticleSystem.alphaRemapGradients) {
                for (const alphaRemapGradient of parsedParticleSystem.alphaRemapGradients) {
                    particleSystem.addAlphaRemapGradient(alphaRemapGradient.gradient, alphaRemapGradient.factor1 !== undefined ? alphaRemapGradient.factor1 : alphaRemapGradient.factor, alphaRemapGradient.factor2);
                }
            }
            if (parsedParticleSystem.sizeGradients) {
                for (const sizeGradient of parsedParticleSystem.sizeGradients) {
                    particleSystem.addSizeGradient(sizeGradient.gradient, sizeGradient.factor1 !== undefined ? sizeGradient.factor1 : sizeGradient.factor, sizeGradient.factor2);
                }
            }
            if (parsedParticleSystem.angularSpeedGradients) {
                for (const angularSpeedGradient of parsedParticleSystem.angularSpeedGradients) {
                    particleSystem.addAngularSpeedGradient(angularSpeedGradient.gradient, angularSpeedGradient.factor1 !== undefined ? angularSpeedGradient.factor1 : angularSpeedGradient.factor, angularSpeedGradient.factor2);
                }
            }
            if (parsedParticleSystem.velocityGradients) {
                for (const velocityGradient of parsedParticleSystem.velocityGradients) {
                    particleSystem.addVelocityGradient(velocityGradient.gradient, velocityGradient.factor1 !== undefined ? velocityGradient.factor1 : velocityGradient.factor, velocityGradient.factor2);
                }
            }
            if (parsedParticleSystem.dragGradients) {
                for (const dragGradient of parsedParticleSystem.dragGradients) {
                    particleSystem.addDragGradient(dragGradient.gradient, dragGradient.factor1 !== undefined ? dragGradient.factor1 : dragGradient.factor, dragGradient.factor2);
                }
            }
            if (parsedParticleSystem.emitRateGradients) {
                for (const emitRateGradient of parsedParticleSystem.emitRateGradients) {
                    particleSystem.addEmitRateGradient(emitRateGradient.gradient, emitRateGradient.factor1 !== undefined ? emitRateGradient.factor1 : emitRateGradient.factor, emitRateGradient.factor2);
                }
            }
            if (parsedParticleSystem.startSizeGradients) {
                for (const startSizeGradient of parsedParticleSystem.startSizeGradients) {
                    particleSystem.addStartSizeGradient(startSizeGradient.gradient, startSizeGradient.factor1 !== undefined ? startSizeGradient.factor1 : startSizeGradient.factor, startSizeGradient.factor2);
                }
            }
            if (parsedParticleSystem.lifeTimeGradients) {
                for (const lifeTimeGradient of parsedParticleSystem.lifeTimeGradients) {
                    particleSystem.addLifeTimeGradient(lifeTimeGradient.gradient, lifeTimeGradient.factor1 !== undefined ? lifeTimeGradient.factor1 : lifeTimeGradient.factor, lifeTimeGradient.factor2);
                }
            }
            if (parsedParticleSystem.limitVelocityGradients) {
                for (const limitVelocityGradient of parsedParticleSystem.limitVelocityGradients) {
                    particleSystem.addLimitVelocityGradient(limitVelocityGradient.gradient, limitVelocityGradient.factor1 !== undefined ? limitVelocityGradient.factor1 : limitVelocityGradient.factor, limitVelocityGradient.factor2);
                }
                particleSystem.limitVelocityDamping = parsedParticleSystem.limitVelocityDamping;
            }
            if (parsedParticleSystem.noiseTexture && scene) {
                const internalClass = GetClass("BABYLON.ProceduralTexture");
                particleSystem.noiseTexture = internalClass.Parse(parsedParticleSystem.noiseTexture, scene, rootUrl);
            }
            // Emitter
            let emitterType;
            if (parsedParticleSystem.particleEmitterType) {
                switch (parsedParticleSystem.particleEmitterType.type) {
                    case "SphereParticleEmitter":
                        emitterType = new SphereParticleEmitter();
                        break;
                    case "SphereDirectedParticleEmitter":
                        emitterType = new SphereDirectedParticleEmitter();
                        break;
                    case "ConeEmitter":
                    case "ConeParticleEmitter":
                        emitterType = new ConeParticleEmitter();
                        break;
                    case "CylinderParticleEmitter":
                        emitterType = new CylinderParticleEmitter();
                        break;
                    case "CylinderDirectedParticleEmitter":
                        emitterType = new CylinderDirectedParticleEmitter();
                        break;
                    case "HemisphericParticleEmitter":
                        emitterType = new HemisphericParticleEmitter();
                        break;
                    case "PointParticleEmitter":
                        emitterType = new PointParticleEmitter();
                        break;
                    case "MeshParticleEmitter":
                        emitterType = new MeshParticleEmitter();
                        break;
                    case "BoxEmitter":
                    case "BoxParticleEmitter":
                    default:
                        emitterType = new BoxParticleEmitter();
                        break;
                }
                emitterType.parse(parsedParticleSystem.particleEmitterType, scene);
            }
            else {
                emitterType = new BoxParticleEmitter();
                emitterType.parse(parsedParticleSystem, scene);
            }
            particleSystem.particleEmitterType = emitterType;
            // Animation sheet
            particleSystem.startSpriteCellID = parsedParticleSystem.startSpriteCellID;
            particleSystem.endSpriteCellID = parsedParticleSystem.endSpriteCellID;
            particleSystem.spriteCellLoop = (_a = parsedParticleSystem.spriteCellLoop) !== null && _a !== void 0 ? _a : true;
            particleSystem.spriteCellWidth = parsedParticleSystem.spriteCellWidth;
            particleSystem.spriteCellHeight = parsedParticleSystem.spriteCellHeight;
            particleSystem.spriteCellChangeSpeed = parsedParticleSystem.spriteCellChangeSpeed;
            particleSystem.spriteRandomStartCell = parsedParticleSystem.spriteRandomStartCell;
            particleSystem.disposeOnStop = (_b = parsedParticleSystem.disposeOnStop) !== null && _b !== void 0 ? _b : false;
            particleSystem.manualEmitCount = (_c = parsedParticleSystem.manualEmitCount) !== null && _c !== void 0 ? _c : -1;
        }
        /**
         * Parses a JSON object to create a particle system.
         * @param parsedParticleSystem The JSON object to parse
         * @param sceneOrEngine The scene or the engine to create the particle system in
         * @param rootUrl The root url to use to load external dependencies like texture
         * @param doNotStart Ignore the preventAutoStart attribute and does not start
         * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
         * @returns the Parsed particle system
         */
        static Parse(parsedParticleSystem, sceneOrEngine, rootUrl, doNotStart = false, capacity) {
            const name = parsedParticleSystem.name;
            let custom = null;
            let program = null;
            let engine;
            let scene;
            if (sceneOrEngine instanceof ThinEngine) {
                engine = sceneOrEngine;
            }
            else {
                scene = sceneOrEngine;
                engine = scene.getEngine();
            }
            if (parsedParticleSystem.customShader && engine.createEffectForParticles) {
                program = parsedParticleSystem.customShader;
                const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
                custom = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines);
            }
            const particleSystem = new ParticleSystem(name, capacity || parsedParticleSystem.capacity, sceneOrEngine, custom, parsedParticleSystem.isAnimationSheetEnabled);
            particleSystem.customShader = program;
            particleSystem._rootUrl = rootUrl;
            if (parsedParticleSystem.id) {
                particleSystem.id = parsedParticleSystem.id;
            }
            // SubEmitters
            if (parsedParticleSystem.subEmitters) {
                particleSystem.subEmitters = [];
                for (const cell of parsedParticleSystem.subEmitters) {
                    const cellArray = [];
                    for (const sub of cell) {
                        cellArray.push(SubEmitter.Parse(sub, sceneOrEngine, rootUrl));
                    }
                    particleSystem.subEmitters.push(cellArray);
                }
            }
            ParticleSystem._Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl);
            if (parsedParticleSystem.textureMask) {
                particleSystem.textureMask = Color4.FromArray(parsedParticleSystem.textureMask);
            }
            // Auto start
            if (parsedParticleSystem.preventAutoStart) {
                particleSystem.preventAutoStart = parsedParticleSystem.preventAutoStart;
            }
            if (!doNotStart && !particleSystem.preventAutoStart) {
                particleSystem.start();
            }
            return particleSystem;
        }
    }
    /**
     * Billboard mode will only apply to Y axis
     */
    ParticleSystem.BILLBOARDMODE_Y = 2;
    /**
     * Billboard mode will apply to all axes
     */
    ParticleSystem.BILLBOARDMODE_ALL = 7;
    /**
     * Special billboard mode where the particle will be biilboard to the camera but rotated to align with direction
     */
    ParticleSystem.BILLBOARDMODE_STRETCHED = 8;
    /**
     * Special billboard mode where the particle will be billboard to the camera but only around the axis of the direction of particle emission
     */
    ParticleSystem.BILLBOARDMODE_STRETCHED_LOCAL = 9;
    SubEmitter._ParseParticleSystem = ParticleSystem.Parse;

    /**
     * Gizmo that enables moving vertices on a mesh.
     */
    class KbVertexSelectGizmo extends KbGizmo {
        get attachedMesh() {
            return this.__attachedMesh;
        }
        set attachedMesh(mesh) {
            this.__attachedMesh = mesh;
            if (this.particleSystem) {
                this.particleSystem.dispose();
                this.particleSystem = undefined;
            }
            if (mesh) {
                this.drawVertices(mesh);
            }
        }
        constructor(kbViewer, scene) {
            super(kbViewer.utilityLayer);
            this.kbViewer = kbViewer;
            this.scene = scene;
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onSelectionChange = new Observable$1();
            this.vertexTracker = new Subject();
            this.particleScale = 0.005;
            this.redrawVertices = false;
            this.__attachedMesh = null;
            this.selectedVertices = new Map();
            this.vertexSelectedColor = new Color4(0.4, 1, 0, 0.5);
            this.vertexUnSelectedColor = new Color4(0, 0.2, 1, 0.5);
            this.vertexTransparentColor = new Color4(0, 0, 0, 0);
            this.verticesUtilLayer = kbViewer.utilityLayer;
            this.attachedMesh = null;
        }
        attachTo(target) {
            const mesh = this.kbViewer.getRendererNode(target);
            if (!mesh) {
                throw Error('Could not find mesh in scene to attach gizmo');
            }
            this.attachedMesh = mesh;
            // Clean up old marquee
            if (this.disposeMarquee) {
                this.disposeMarquee.next();
                this.disposeMarquee.complete();
            }
            this.disposeMarquee = new Subject();
            let selectionMode = null;
            this.kbViewer.interaction
                .enableMarqueeSelect(target, exports.eMarqueeSelectMode.Vertices)
                .pipe(takeUntil(this.disposeMarquee))
                .subscribe(event => {
                if (selectionMode || event.vertexList.length > 0) {
                    const vertices = event.vertexList;
                    // If user is making a new selection, set the selection mode based on modifier keys
                    if (selectionMode === null) {
                        if (event.ctrlKey) {
                            selectionMode = 'add';
                        }
                        else if (event.altKey) {
                            selectionMode = 'remove';
                        }
                        else {
                            selectionMode = 'new';
                        }
                    }
                    if (selectionMode === 'new') {
                        this.selectedVertices.clear();
                    }
                    if (selectionMode === 'remove') {
                        vertices.forEach(vertex => this.selectedVertices.delete(vertex));
                    }
                    else {
                        vertices.forEach(vertex => this.selectedVertices.set(vertex, null));
                    }
                    this.redraw();
                    this.emitSelectionChange();
                }
            });
            this.kbViewer.interaction.onPointerUp.pipe(takeUntil(this.disposeMarquee)).subscribe(() => {
                selectionMode = null;
            });
        }
        updateParticleScale(scale) {
            this.particleScale = scale;
            this.redraw();
        }
        updateGizmoPosition() {
            this.kbViewer.forceAndWaitForNextRender().then(() => {
                var _a;
                if (this.__attachedMesh) {
                    this.currentMeshVertexPositions = (_a = this.__attachedMesh
                        .getVerticesData(VertexBuffer.PositionKind)) === null || _a === void 0 ? void 0 : _a.slice();
                    if (!this.currentMeshVertexPositions) {
                        return;
                    }
                    this.redraw();
                }
            });
        }
        dispose() {
            if (this.particleSystem) {
                this.particleSystem.dispose();
                this.particleSystem = undefined;
            }
            this.disposeMarquee.next();
            this.disposeMarquee.complete();
            this.kbViewer.interaction.disableMarqueeSelect();
        }
        setCustomMesh(mesh) {
            Logger.Error('Custom meshes are not supported on this gizmo.');
        }
        selectVertices(vertexIndices) {
            this.selectedVertices.clear();
            vertexIndices.forEach(vertex => this.selectedVertices.set(vertex, null));
            this.redraw();
            this.emitSelectionChange();
        }
        enableSelectionChange() {
            this.selectionsEnabled = true;
            this.redraw();
        }
        disableSelectionChange() {
            this.selectionsEnabled = false;
            this.redraw();
            this.vertexTracker.complete();
        }
        getBarycenter(indices) {
            let x = 0, y = 0, z = 0;
            const currentMeshVertexPositions = this.currentMeshVertexPositions;
            if (currentMeshVertexPositions) {
                indices.forEach(idx => {
                    x += currentMeshVertexPositions[idx * 3];
                    y += currentMeshVertexPositions[idx * 3 + 1];
                    z += currentMeshVertexPositions[idx * 3 + 2];
                });
            }
            return new exports.KbVector(x / indices.length, y / indices.length, z / indices.length);
        }
        redraw() {
            this.vertexTracker.next(this.selectedVertices.size.toString());
            if (this.particleSystem && this.saveAnimate) {
                this.particleSystem.animate = this.saveAnimate;
                this.redrawVertices = true;
            }
        }
        emitSelectionChange() {
            this.onSelectionChange.notifyObservers({ selectedIndices: Array.from(this.selectedVertices.keys()) });
        }
        drawVertices(targetMesh) {
            var _a;
            if (!this.currentMeshVertexPositions) {
                this.currentMeshVertexPositions = (_a = targetMesh.getVerticesData(VertexBuffer.PositionKind)) === null || _a === void 0 ? void 0 : _a.slice();
            }
            if (!this.currentMeshVertexPositions) {
                return;
            }
            const vertexCount = this.currentMeshVertexPositions.length / 3;
            this.particleSystem = new ParticleSystem('vertexSelectParticleSystem', vertexCount, this.verticesUtilLayer.utilityLayerScene);
            const camera = this.scene.activeCamera instanceof ArcRotateCamera ? this.scene.activeCamera : null;
            const cameraDistance = Vector3.Zero();
            const cameraPosition = Vector3.Zero();
            this.saveAnimate = this.particleSystem.animate.bind(this.particleSystem);
            let particleIdx = 0;
            this.particleSystem.startPositionFunction = (worldMatrix, positionToUpdate, particle) => {
                particleIdx += 3;
                const vertexPositions = this.currentMeshVertexPositions;
                Vector3.TransformCoordinatesFromFloatsToRef(vertexPositions[particleIdx], vertexPositions[particleIdx + 1], vertexPositions[particleIdx + 2], worldMatrix, positionToUpdate);
            };
            const transform = targetMesh.computeWorldMatrix(true);
            this.particleSystem.updateFunction = particles => {
                let particlesToProcess = false;
                if (camera) {
                    cameraPosition.copyFrom(getCameraPositionWithOffset(camera));
                }
                for (let i = 0; i < particles.length; i++) {
                    const particle = particles[i];
                    const vertexPositions = this.currentMeshVertexPositions;
                    if (vertexPositions && (particle.age === 0 || this.redrawVertices)) {
                        Vector3.TransformCoordinatesFromFloatsToRef(vertexPositions[i * 3], vertexPositions[i * 3 + 1], vertexPositions[i * 3 + 2], transform, particle.position);
                        particle.age = 1;
                        if (this.selectedVertices.has(i)) {
                            particle.color = this.vertexSelectedColor;
                        }
                        else {
                            if (this.selectionsEnabled) {
                                particle.color = this.vertexUnSelectedColor;
                            }
                            else {
                                particle.color = this.vertexTransparentColor;
                            }
                        }
                        if (!particlesToProcess) {
                            particlesToProcess = true;
                        }
                    }
                    if (camera) {
                        cameraPosition.subtractToRef(particle.position, cameraDistance);
                        particle.size = (this.particleScale - 0.001) * cameraDistance.length();
                    }
                    else {
                        particle.size = this.particleScale - 0.004;
                    }
                }
                this.redrawVertices = false;
                // If there are a large number of particles, kill the updating function for performance
                if (particles.length && particles.length > 10000 && !particlesToProcess && this.particleSystem) {
                    // stable
                    this.particleSystem.stop();
                    this.particleSystem.animate = () => void 0;
                }
            };
            const colorArray = new Uint8Array(3);
            for (let i = 0; i < colorArray.length; i += 3) {
                colorArray[i] = 225;
                colorArray[i + 1] = 225;
                colorArray[i + 2] = 225;
            }
            this.particleSystem.emitter = targetMesh;
            this.particleSystem.minSize = this.particleScale;
            this.particleSystem.maxSize = this.particleScale;
            this.particleSystem.disposeOnStop = false;
            this.particleSystem.particleTexture = RawTexture.CreateRGBTexture(colorArray, 1, 1, this.verticesUtilLayer.utilityLayerScene);
            this.particleSystem.manualEmitCount = vertexCount;
            // this.particleSystem.emitRate
            this.particleSystem.start();
        }
    }

    /**
     * Gizmo that enables dragging and rotating lights
     */
    class KbViewpointGizmo extends KbGizmo {
        attachTo(viewpoint) {
            var _a;
            // Get rid of any old gizmos
            if (this.posGizmo) {
                this.posGizmo.dispose();
                this.posGizmo = undefined;
            }
            if (this.targetGizmo) {
                this.targetGizmo.dispose();
                this.targetGizmo = undefined;
            }
            if (this.rotGizmo) {
                this.rotGizmo.dispose();
                this.rotGizmo = undefined;
            }
            // Create mesh to attach gizmos to, and the camera preview visualization attached to that mesh
            this._visualMesh = new AbstractMesh('', this.gizmoLayer.utilityLayerScene);
            const { targetPositionMarker, viewpointPositionGizmo } = createViewpointVisualization(viewpoint, this.gizmoLayer.utilityLayerScene);
            this._visualMesh.addChild(viewpointPositionGizmo);
            // Always create the position gizmo
            this.posGizmo = new KbPositionGizmo(this.kbViewer, this.gizmoLayer);
            this.previousTargetMode = viewpoint.targetMode;
            // Determine which gizmos to show. No extra gizmos for overhead camera (only position)
            // For the target point type viewpoint, make a separate mesh to hold the position gizmo
            if (viewpoint.type === exports.eViewpointType.overhead) {
                viewpointPositionGizmo.scaling = new Vector3(1, -1, 1);
                viewpointPositionGizmo.bakeCurrentTransformIntoVertices();
            }
            else {
                if (viewpoint.targetMode === exports.eViewpointTargetMode.rotation) {
                    this.rotGizmo = new KbRotationGizmo(this.kbViewer, this.gizmoLayer, { x: true, y: true, z: false });
                    // The first person camera is oriented pointing parallel to the +Z axis
                    if (viewpoint.type == exports.eViewpointType.firstPerson) {
                        viewpointPositionGizmo.rotate(Vector3.Right(), Math.PI / 2);
                        viewpointPositionGizmo.bakeCurrentTransformIntoVertices();
                    }
                }
                else if (viewpoint.targetMode === exports.eViewpointTargetMode.point) {
                    this._gizmoMesh = new AbstractMesh('', this.gizmoLayer.utilityLayerScene);
                    this._targetVisualMesh = new AbstractMesh('', this.gizmoLayer.utilityLayerScene);
                    if (targetPositionMarker) {
                        (_a = this._targetVisualMesh) === null || _a === void 0 ? void 0 : _a.addChild(targetPositionMarker);
                    }
                    this.targetGizmo = new KbPositionGizmo(this.kbViewer, this.gizmoLayer);
                }
            }
            if (!this._gizmoMesh) {
                this._gizmoMesh = this._visualMesh;
            }
            else {
                this._visualMesh.isPickable = false;
            }
            this.updateHelperMeshes(viewpoint);
            // Set up event handlers on the gizmos
            if (this.posGizmo) {
                this.posGizmo.attachedMesh = this._gizmoMesh;
                const positionChange = Vector3.Zero();
                this.posGizmo.onDragStartObservable.add(event => {
                    positionChange.setAll(0);
                    this.onDragStartObservable.notifyObservers();
                });
                this.posGizmo.onDragObservable.add(event => {
                    var _a;
                    if (this._gizmoMesh !== this._visualMesh) {
                        (_a = this._visualMesh) === null || _a === void 0 ? void 0 : _a.position.addInPlace(event.delta);
                    }
                    positionChange.addInPlace(event.delta);
                    this.onDragObservable.notifyObservers({ deltaPos: event.delta });
                    this.updateHelperMeshDirectionToRotation(this._attachedViewpoint);
                });
                this.posGizmo.onDragEndObservable.add(event => {
                    this.onDragEndObservable.notifyObservers({ deltaPos: positionChange });
                });
            }
            if (this.targetGizmo) {
                this.targetGizmo.attachedMesh = this._targetVisualMesh;
                const targetChange = Vector3.Zero();
                this.targetGizmo.onDragStartObservable.add(event => {
                    targetChange.setAll(0);
                    this.onDragStartObservable.notifyObservers();
                });
                this.targetGizmo.onDragObservable.add(event => {
                    targetChange.addInPlace(event.delta);
                    this.onDragObservable.notifyObservers({ deltaTargetPos: event.delta });
                    this.updateHelperMeshDirectionToRotation(this._attachedViewpoint);
                });
                this.targetGizmo.onDragEndObservable.add(event => {
                    this.onDragEndObservable.notifyObservers({ deltaTargetPos: targetChange });
                });
            }
            if (this.rotGizmo) {
                this.rotGizmo.attachedMesh = this._visualMesh;
                let rotationChange = this._visualMesh.rotationQuaternion || Quaternion.Identity();
                this.rotGizmo.onDragStartObservable.add(event => {
                    this.onDragStartObservable.notifyObservers();
                    rotationChange = Quaternion.Identity();
                });
                this.rotGizmo.onDragObservable.add(event => {
                    const { delta } = event;
                    rotationChange.multiplyInPlace(delta);
                    this.onDragObservable.notifyObservers({ deltaRotation: delta });
                });
                this.rotGizmo.onDragEndObservable.add(() => {
                    this.onDragEndObservable.notifyObservers({ deltaRotation: rotationChange });
                });
            }
            this._attachedViewpoint = viewpoint;
        }
        updateGizmoPosition(viewpointNode) {
            if (viewpointNode && viewpointNode !== this._attachedViewpoint) {
                this._attachedViewpoint = viewpointNode;
            }
            // If the target mode changed, rebuild the gizmo
            if (this._attachedViewpoint && this.previousTargetMode !== this._attachedViewpoint.targetMode) {
                const viewpoint = this._attachedViewpoint;
                this.dispose(true);
                this.attachTo(viewpoint);
            }
            else {
                if (this._attachedViewpoint) {
                    this.updateHelperMeshes(this._attachedViewpoint);
                }
                super.updateGizmoPosition();
            }
        }
        updateHelperMeshes(viewpoint) {
            if (!this._visualMesh || !this._gizmoMesh) {
                return;
            }
            this._visualMesh.position = viewpoint.position.toVec3();
            this._gizmoMesh.position = viewpoint.position.toVec3();
            if (this._targetVisualMesh) {
                this._targetVisualMesh.position = viewpoint.targetPoint.toVec3();
            }
            if (viewpoint.targetMode === exports.eViewpointTargetMode.rotation) {
                const eulerRot = viewpoint.rotation.toVec3().scale(Math.PI / 180);
                this._visualMesh.rotationQuaternion = Quaternion.FromEulerVector(eulerRot);
            }
            else {
                this.updateHelperMeshDirectionToRotation(viewpoint);
            }
        }
        updateHelperMeshDirectionToRotation(viewpoint, delta) {
            if (!this._visualMesh) {
                return;
            }
            if (!delta) {
                delta = Vector3.Zero();
            }
            const _visualMesh = this._visualMesh;
            if (viewpoint.targetMode !== exports.eViewpointTargetMode.rotation) {
                let direction;
                if (this._targetVisualMesh) {
                    direction = this._targetVisualMesh.position.subtract(_visualMesh.position);
                }
                else {
                    // mesh
                    const targetMeshNode = viewpoint._manager.getById(viewpoint.targetMeshId);
                    if (targetMeshNode) {
                        direction = targetMeshNode.position.subtract(viewpoint.position).toVec3();
                    }
                    else {
                        direction = Vector3.Zero();
                    }
                }
                const rotation = rotationToVector(direction);
                _visualMesh.rotationQuaternion = rotation;
                // This code is for fixing the rotation of the camera gizmo so that the x axis is always in the XZ plane (keeping the camera model level with the horizon.)
                // But, it is not working quite right.
                // _visualMesh.computeWorldMatrix(true);
                // let newXAxis = _visualMesh.getDirection(Vector3.Right());
                // const correction = rotationToVector(direction.cross(Vector3.Up()), newXAxis);
                // _visualMesh.rotationQuaternion = _visualMesh.rotationQuaternion.multiply(correction);
            }
        }
        /**
         * Creates a PositionGizmo
         * @param gizmoLayer The utility layer the gizmo will be added to
         */
        constructor(kbViewer, gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer) {
            super(gizmoLayer);
            this.kbViewer = kbViewer;
            /** Fires an event when any of it's sub gizmos are dragged */
            this.onDragStartObservable = new Observable$1();
            /** Fires an event while any of it's sub gizmos are dragged */
            this.onDragObservable = new Observable$1();
            /** Fires an event when any of it's sub gizmos are released from dragging */
            this.onDragEndObservable = new Observable$1();
            this.attachedMesh = null;
        }
        /**
         * Disposes of the gizmo
         */
        dispose(recreate) {
            if (this.posGizmo) {
                this.posGizmo.dispose();
            }
            if (this.rotGizmo) {
                this.rotGizmo.dispose();
            }
            if (this.targetGizmo) {
                this.targetGizmo.dispose();
            }
            if (this._visualMesh) {
                this._visualMesh.dispose();
            }
            if (this._targetVisualMesh) {
                this._targetVisualMesh.dispose();
            }
            if (this.viewpointPositionGizmo) {
                this.viewpointPositionGizmo.dispose();
            }
            if (!recreate) {
                this.onDragStartObservable.clear();
                this.onDragEndObservable.clear();
                delete this._attachedViewpoint;
            }
        }
    }

    /**
     * Manages the various gizmos and their connections to the scene meshes.
     * Keeps track of what gizmo is active and the selected meshes to put the gizmos on.
     * @param scene The root scene on which the utility/gizmo layer will be placed.
     * @param camera The camera being used. Required by some gizmos for displaying them correctly
     */
    const PREVIEW_NAME = '__UV_PREVIEW_MATERIAL__';
    class GizmoTools {
        constructor(scene, kbViewer) {
            this.kbViewer = kbViewer;
            this.activeGizmoSettings = [];
            this.dragging = false;
            this.uvMapStoredMaterials = new Map();
            this.scene = scene;
            this.gizmoLayer = kbViewer.utilityLayer;
            this.gizmoLayer.utilityLayerScene.useRightHandedSystem = true;
        }
        selectLight(lightNode) {
            const lightGizmo = new KbLightGizmo(this.kbViewer, this.gizmoLayer);
            const updatePosition = new Subject();
            const updateDirection = new Subject();
            const totalDeltaPosition = new Subject();
            this.activeGizmoSettings.push({
                subjects: [updatePosition, updateDirection, totalDeltaPosition],
                gizmo: lightGizmo,
            });
            lightGizmo.attachTo(lightNode);
            this.dragging = false;
            return {
                updateLightGizmo: (node) => {
                    lightGizmo.updateGizmoPosition(node);
                },
            };
        }
        selectViewpoint(viewpoint) {
            const viewpointGizmo = new KbViewpointGizmo(this.kbViewer, this.gizmoLayer);
            viewpointGizmo.attachTo(viewpoint);
            const updatePosition = new Subject();
            const updateTargetPosition = new Subject();
            const updateRotation = new Subject();
            const totalDeltaPosition = new Subject();
            const totalDeltaTargetPosition = new Subject();
            const totalDeltaRotation = new Subject();
            this.activeGizmoSettings.push({
                subjects: [
                    updatePosition,
                    updateTargetPosition,
                    updateRotation,
                    totalDeltaPosition,
                    totalDeltaTargetPosition,
                    totalDeltaRotation,
                ],
                gizmo: viewpointGizmo,
            });
            this.dragging = false;
            const totalDeltaPositionQueue = Vector3.Zero();
            const totalDeltaTargetPositionQueue = Vector3.Zero();
            const totalDeltaRotationQueue = Quaternion.Identity();
            viewpointGizmo.onDragStartObservable.add(() => {
                this.dragging = true;
            });
            viewpointGizmo.onDragObservable.add(event => {
                if (this.dragging) {
                    if (event.deltaPos) {
                        updatePosition.next(exports.KbVector.FromVec3(event.deltaPos));
                        totalDeltaPositionQueue.addInPlace(event.deltaPos);
                    }
                    if (event.deltaTargetPos) {
                        updateTargetPosition.next(exports.KbVector.FromVec3(event.deltaTargetPos));
                        totalDeltaTargetPositionQueue.addInPlace(event.deltaTargetPos);
                    }
                    if (event.deltaRotation) {
                        updateRotation.next(exports.KbVector.FromVec3(event.deltaRotation.toEulerAngles().scale(180 / Math.PI)));
                        totalDeltaRotationQueue.multiplyInPlace(event.deltaRotation);
                    }
                }
            });
            viewpointGizmo.onDragEndObservable.add(() => {
                if (this.dragging) {
                    this.dragging = false;
                    if (!totalDeltaPositionQueue.equalsToFloats(0, 0, 0)) {
                        totalDeltaPosition.next(exports.KbVector.FromVec3(totalDeltaPositionQueue));
                        totalDeltaPositionQueue.setAll(0);
                    }
                    else if (!totalDeltaTargetPositionQueue.equalsToFloats(0, 0, 0)) {
                        totalDeltaTargetPosition.next(exports.KbVector.FromVec3(totalDeltaTargetPositionQueue));
                        totalDeltaTargetPositionQueue.setAll(0);
                    }
                    else if (!totalDeltaRotationQueue.equals(Quaternion.Identity())) {
                        totalDeltaRotation.next(exports.KbVector.FromVec3(totalDeltaRotationQueue.toEulerAngles().scale(180 / Math.PI)));
                        totalDeltaRotationQueue.copyFrom(Quaternion.Identity());
                    }
                }
            });
            return {
                updatePosition: updatePosition.asObservable(),
                updateTargetPosition: updateTargetPosition.asObservable(),
                updateRotation: updateRotation.asObservable(),
                totalDeltaPosition: totalDeltaPosition.asObservable(),
                totalDeltaTargetPosition: totalDeltaTargetPosition.asObservable(),
                totalDeltaRotation: totalDeltaRotation.asObservable(),
                updateViewpointGizmo: (node) => {
                    viewpointGizmo.updateGizmoPosition(node);
                },
            };
        }
        position(target, positionSpace, axisVisibility, orientGizmo) {
            const positionGizmo = new KbPositionGizmo(this.kbViewer, this.gizmoLayer, axisVisibility);
            positionGizmo.attachTo(target, positionSpace, orientGizmo);
            const updatePosition = new Subject();
            const totalDelta = new Subject();
            this.activeGizmoSettings.push({
                subjects: [updatePosition, totalDelta],
                gizmo: positionGizmo,
            });
            this.dragging = false;
            let totalDeltaQueue = Vector3.Zero();
            positionGizmo.onDragStartObservable.add(() => {
                this.dragging = true;
            });
            positionGizmo.onDragObservable.add(event => {
                if (this.dragging) {
                    totalDeltaQueue.addInPlace(event.delta);
                    updatePosition.next(exports.KbVector.FromVec3(event.delta));
                }
            });
            positionGizmo.onDragEndObservable.add(() => {
                if (this.dragging) {
                    totalDelta.next(exports.KbVector.FromVec3(totalDeltaQueue));
                    totalDeltaQueue = Vector3.Zero();
                    this.dragging = false;
                }
            });
            return {
                update: updatePosition.asObservable(),
                totalDelta: totalDelta.asObservable(),
                updateGizmoPosition: (update) => positionGizmo.updateGizmoPosition(update),
                dispose: () => this.clearGizmo(positionGizmo),
            };
        }
        rotateAxisAngle(target, positionSpace, options) {
            const updateAxisAngle = new Subject();
            const totalDelta = new Subject();
            const totalDeltaQueue = { axis: Vector3.Zero(), angle: 0 };
            const axisAngleGizmo = new KbAxisAngleGizmo(this.kbViewer, this.gizmoLayer, options === null || options === void 0 ? void 0 : options.disableAngle);
            axisAngleGizmo.attachTo(target, positionSpace, options === null || options === void 0 ? void 0 : options.placementOffset);
            this.activeGizmoSettings.push({
                subjects: [updateAxisAngle, totalDelta],
                gizmo: axisAngleGizmo,
            });
            this.dragging = false;
            axisAngleGizmo.onDragStartObservable.add(() => {
                this.dragging = true;
            });
            axisAngleGizmo.onDragObservable.add(event => {
                if (this.dragging) {
                    const angle = (event.deltaAngle * 180) / Math.PI;
                    totalDeltaQueue.axis.addInPlace(event.deltaAxis);
                    totalDeltaQueue.angle += angle;
                    updateAxisAngle.next({ axis: exports.KbVector.FromVec3(event.deltaAxis), angle });
                }
            });
            axisAngleGizmo.onDragEndObservable.add(() => {
                if (this.dragging) {
                    totalDelta.next({ axis: exports.KbVector.FromVec3(totalDeltaQueue.axis), angle: totalDeltaQueue.angle });
                    totalDeltaQueue.axis = Vector3.Zero();
                    totalDeltaQueue.angle = 0;
                    this.dragging = false;
                }
            });
            return {
                update: updateAxisAngle.asObservable(),
                totalDelta: totalDelta.asObservable(),
                updateGizmoPosition: (updateAxis, updatePosition) => axisAngleGizmo.updateGizmoPosition(updateAxis, updatePosition),
                dispose: () => this.clearGizmo(axisAngleGizmo),
            };
        }
        /**
         * Creates a rotation gizmo that can rotate many items
         * nodes will be rotated and repositioned in space if the center of rotation is not equal to the position
         * vectors will be repositioned in space as if each vector is the position of a point
         */
        rotate(targets, positionSpace, placementOffset, axisVisibility) {
            var _a, _b;
            let gizmoOffset = Vector3.Zero();
            // Get the transform matrix to get the world space rotation and coordinates of the node we are rotating
            let positionTransform;
            if (positionSpace) {
                positionTransform = (_a = this.kbViewer.getRendererNode(positionSpace)) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
            }
            else if (targets[0] instanceof exports.SpaceNode && targets[0]._parent) {
                positionTransform = (_b = this.kbViewer.getRendererNode(targets[0]._parent)) === null || _b === void 0 ? void 0 : _b.computeWorldMatrix(true);
            }
            const rotationGizmo = new KbRotationGizmo(this.kbViewer, this.gizmoLayer, undefined, axisVisibility);
            if (targets.length === 1) {
                const target = targets[0];
                rotationGizmo.attachTo(target, positionSpace, placementOffset);
            }
            else {
                // If multiple targets are selected, put the pivot in the average of the positions
                // Maybe enhance this to use bounding box later, if that's important...
                const pivot = targets
                    .reduce((result, current) => {
                    return result.add(current instanceof exports.SpaceNode ? current.position : current);
                }, exports.KbVector.Zero())
                    .scale(1 / targets.length);
                rotationGizmo.attachTo(exports.KbVector.Zero(), undefined, pivot);
            }
            const update = new Subject();
            const totalDelta = new Subject();
            this.activeGizmoSettings.push({
                subjects: [update, totalDelta],
                gizmo: rotationGizmo,
            });
            this.dragging = false;
            let totalDeltaQueue = {
                rotation: Quaternion.Identity(),
                position: Vector3.Zero(),
                axisTranslate: Vector3.Zero(),
            };
            // Set up caches for the positions and rotations of the nodes because it's not guaranteed that they will be updated by reference
            // And as you drag the nodes these values will change and the gizmos won't be dragging in the right direction anymore
            const positions = targets.map(target => target instanceof exports.SpaceNode ? target.position.toVec3() : target.toVec3());
            const axes = targets.map(target => (target instanceof exports.SpaceNode ? target.rotationAxis.toVec3() : null));
            const quaternionCache = targets.map(target => target instanceof exports.SpaceNode
                ? Quaternion.FromEulerVector(target.eulerRotation.toVec3().scale(Math.PI / 180))
                : Quaternion.Identity());
            // Get the current pivot which will always be where the gizmo is located (minus the offset which just visually offsets the gizmo position)
            let gizmoPosition = rotationGizmo.attachedMesh.position;
            rotationGizmo.onDragStartObservable.add(() => {
                this.dragging = true;
                if (rotationGizmo.gizmoOffset) {
                    gizmoOffset = rotationGizmo.gizmoOffset.toVec3();
                }
                if (gizmoOffset) {
                    gizmoPosition = gizmoPosition.subtract(gizmoOffset);
                }
            });
            rotationGizmo.onDragObservable.add(event => {
                if (this.dragging) {
                    const result = [];
                    const rotationMatrix = new Matrix();
                    const gizmoRotation = rotationGizmo.attachedMesh.rotationQuaternion || Quaternion.Identity();
                    // Get the true world space rotation in the case that the gizmo is rotated
                    // The gizmos output their rotation deltas in local space
                    const meshSpaceRotation = gizmoRotation.multiply(event.delta).multiply(gizmoRotation.conjugate());
                    meshSpaceRotation.toRotationMatrix(rotationMatrix);
                    const worldTransformMatrix = new Matrix();
                    event.delta.toRotationMatrix(worldTransformMatrix);
                    worldTransformMatrix.multiplyToRef(rotationGizmo.attachedMesh.computeWorldMatrix(), worldTransformMatrix);
                    // Inverse the position transform to rotate the delta back into local "positionSpace" space
                    const positionTransformInv = positionTransform === null || positionTransform === void 0 ? void 0 : positionTransform.clone().invert();
                    positions.forEach((position, index) => {
                        var _a;
                        let positionDelta;
                        let axisDelta;
                        const target = targets[index];
                        const axis = axes[index];
                        // If the node is a space node, then rotate it around the pivot to get the updated position
                        if (target instanceof exports.SpaceNode) {
                            // Treat the pivot point as the center of the node so the node rotates around the pivot point
                            let worldNodePivot = target.pivot.toVec3();
                            const nodeTransform = (_a = this.kbViewer.getRendererNode(target)) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
                            if (nodeTransform) {
                                worldNodePivot = Vector3.TransformCoordinates(worldNodePivot, nodeTransform);
                            }
                            positionDelta = Vector3.TransformCoordinates(worldNodePivot.subtract(gizmoPosition), rotationMatrix)
                                .add(gizmoPosition)
                                .subtract(worldNodePivot);
                            // If the node is a vector, then it's a direction vector, so we want to rotate it as if the vector started from the origin.
                            // So don't rotate around the pivot point. The updated position will actually be the updated direction.
                        }
                        else {
                            positionDelta = Vector3.TransformCoordinates(position, rotationMatrix).subtract(position);
                        }
                        if (axis) {
                            axisDelta = Vector3.TransformCoordinates(axis.length() === 0 ? new Vector3(0, 1, 0) : axis, rotationMatrix).subtract(axis);
                            axis.addInPlace(axisDelta);
                        }
                        // Rotate the delta vector into local "positionSpace" space
                        if (positionTransformInv) {
                            positionDelta = Vector3.TransformCoordinates(positionDelta, positionTransformInv.getRotationMatrix());
                        }
                        // Update the position cache by reference (make sure this position variable isn't shadowed)
                        position.addInPlace(positionDelta);
                        totalDeltaQueue.position.addInPlace(positionDelta);
                        if (axisDelta) {
                            totalDeltaQueue.axisTranslate.addInPlace(axisDelta);
                        }
                        // Get the rotation delta by converting the previous quaternion rotation to euler, rotating to the new position, and getting euler angles of that.
                        // This is necessary because it we output the plain quaternion delta euler, the euler rotation order could result
                        // In an incorrect rotation if there are other euler angles being rotated first
                        const previousAngle = quaternionCache[index].toEulerAngles();
                        quaternionCache[index].multiplyInPlace(event.delta);
                        const newAngle = quaternionCache[index].toEulerAngles();
                        totalDeltaQueue.rotation.multiplyInPlace(event.delta);
                        result.push({
                            position: exports.KbVector.FromVec3(positionDelta),
                            rotation: exports.KbVector.FromVec3(newAngle.subtract(previousAngle).scale(180 / Math.PI)),
                            worldTransformMatrix: worldTransformMatrix,
                            axisTranslate: axisDelta ? exports.KbVector.FromVec3(axisDelta) : exports.KbVector.Zero(),
                        });
                    });
                    update.next(result);
                }
            });
            rotationGizmo.onDragEndObservable.add(() => {
                if (this.dragging) {
                    totalDelta.next({
                        rotation: exports.KbVector.FromVec3(totalDeltaQueue.rotation.toEulerAngles().scale(180 / Math.PI)),
                        position: exports.KbVector.FromVec3(totalDeltaQueue.position),
                        axisTranslate: exports.KbVector.FromVec3(totalDeltaQueue.axisTranslate),
                    });
                    totalDeltaQueue = {
                        rotation: Quaternion.Identity(),
                        position: Vector3.Zero(),
                        axisTranslate: Vector3.Zero(),
                    };
                    this.dragging = false;
                }
            });
            return {
                update: update.asObservable(),
                totalDelta: totalDelta.asObservable(),
                updateGizmoPosition: (update, offset) => rotationGizmo.updateGizmoPosition(update, offset),
                dispose: () => this.clearGizmo(rotationGizmo),
            };
        }
        scale(targets, positionSpace) {
            // if (targets.length === 0) {
            //     return {
            //         update: empty(),
            //         totalDelta: empty(),
            //     };
            // }
            var _a, _b;
            const scaleGizmo = new KbScaleGizmo(this.kbViewer, this.gizmoLayer);
            if (targets.length === 1) {
                const target = targets[0];
                scaleGizmo.attachTo(target, positionSpace);
            }
            else {
                // If multiple targets are selected, put the pivot in the average of the positions
                // Maybe enhance this to use bounding box later, if that's important...
                const pivot = targets
                    .reduce((result, current) => {
                    return result.add(current instanceof exports.SpaceNode ? current.position : current);
                }, exports.KbVector.Zero())
                    .scale(1 / targets.length);
                scaleGizmo.attachTo(pivot, positionSpace);
            }
            const update = new Subject();
            const totalDelta = new Subject();
            this.activeGizmoSettings.push({
                subjects: [update, totalDelta],
                gizmo: scaleGizmo,
            });
            this.dragging = false;
            let totalDeltaQueue = Vector3.Zero();
            let positionTransform;
            // Get the transform matrix to get the world space rotation and coordinates of the node we are scaling
            if (positionSpace) {
                positionTransform = (_a = this.kbViewer.getRendererNode(positionSpace)) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
            }
            else if (targets[0] instanceof exports.SpaceNode && targets[0]._parent) {
                positionTransform = (_b = this.kbViewer.getRendererNode(targets[0]._parent)) === null || _b === void 0 ? void 0 : _b.computeWorldMatrix(true);
            }
            // Get the current pivot which will always be where the gizmo is located
            let gizmoPosition = scaleGizmo.attachedMesh.position;
            scaleGizmo.onDragStartObservable.add(() => {
                this.dragging = true;
                if (scaleGizmo.gizmoOffset) {
                    gizmoPosition = gizmoPosition.subtract(scaleGizmo.gizmoOffset.toVec3());
                }
            });
            scaleGizmo.onDragObservable.add(event => {
                if (this.dragging) {
                    const result = [];
                    targets.forEach(target => {
                        var _a;
                        let positionDelta;
                        // If the node is a space node, then rotate it around the pivot to get the updated position
                        if (target instanceof exports.SpaceNode) {
                            // Treat the pivot point as the center of the node so the node rotates around the pivot point
                            let worldNodePivot = target.pivot.toVec3();
                            const nodeTransform = (_a = this.kbViewer.getRendererNode(target)) === null || _a === void 0 ? void 0 : _a.computeWorldMatrix(true);
                            if (nodeTransform) {
                                worldNodePivot = Vector3.TransformCoordinates(worldNodePivot, nodeTransform);
                            }
                            positionDelta = worldNodePivot
                                .subtract(gizmoPosition)
                                .multiply(event.delta)
                                .add(gizmoPosition)
                                .subtract(worldNodePivot);
                            // If the node is a vector, then it's a direction vector, so we want to rotate it as if the vector started from the origin.
                            // So don't rotate around the pivot point. The updated position will actually be the updated direction.
                        }
                        else {
                            // Transform the node position to world space because the pivot and gizmo will be in world space as well
                            let worldPosition = target.toVec3();
                            if (positionTransform) {
                                worldPosition = Vector3.TransformCoordinates(worldPosition, positionTransform);
                            }
                            positionDelta = worldPosition.multiply(event.delta).subtract(worldPosition);
                        }
                        totalDeltaQueue.addInPlace(event.delta);
                        result.push({
                            position: exports.KbVector.FromVec3(positionDelta),
                            scaling: exports.KbVector.FromVec3(event.delta),
                        });
                    });
                    update.next(result);
                }
            });
            scaleGizmo.onDragEndObservable.add(() => {
                if (this.dragging) {
                    totalDelta.next(exports.KbVector.FromVec3(totalDeltaQueue));
                    totalDeltaQueue = Vector3.Zero();
                    this.dragging = false;
                }
            });
            return {
                update: update.asObservable(),
                totalDelta: totalDelta.asObservable(),
                updateGizmoPosition: (update) => scaleGizmo.updateGizmoPosition(update),
                dispose: () => this.clearGizmo(scaleGizmo),
            };
        }
        selectVertices(target, selectedVertices) {
            const vertexSelectionGizmo = new KbVertexSelectGizmo(this.kbViewer, this.scene);
            vertexSelectionGizmo.attachTo(target);
            const update = new Subject();
            this.activeGizmoSettings.push({
                subjects: [update],
                gizmo: vertexSelectionGizmo,
            });
            if (selectedVertices) {
                vertexSelectionGizmo.selectVertices(selectedVertices);
            }
            this.dragging = false;
            vertexSelectionGizmo.onSelectionChange.add(result => {
                if (result) {
                    update.next({
                        vertexIndices: result.selectedIndices,
                    });
                }
            });
            return {
                update: update.asObservable(),
                vertexTracker: vertexSelectionGizmo.vertexTracker,
                updateGizmoPositions: () => vertexSelectionGizmo.updateGizmoPosition(),
                updateParticleScale: (scale) => vertexSelectionGizmo.updateParticleScale(scale),
                disableSelectionChange: () => vertexSelectionGizmo.disableSelectionChange(),
                enableSelectionChange: () => vertexSelectionGizmo.enableSelectionChange(),
                getBarycenter: (indices) => vertexSelectionGizmo.getBarycenter(indices),
                dispose: () => this.clearGizmo(vertexSelectionGizmo),
            };
        }
        selectFacets(target, selectedVertices) {
            const facetSelectionGizmo = new KbFacetSelectGizmo(this.kbViewer, this.scene);
            facetSelectionGizmo.attachTo(target);
            const update = new Subject();
            this.activeGizmoSettings.push({
                subjects: [update],
                gizmo: facetSelectionGizmo,
            });
            if (selectedVertices) {
                facetSelectionGizmo.selectFacetGroups(selectedVertices);
            }
            this.dragging = false;
            facetSelectionGizmo.onSelectionChange.add(result => {
                if (result) {
                    update.next({
                        selectedFacets: result.selectedFacets,
                    });
                }
            });
            return {
                update: update.asObservable(),
                updateGizmoPositions: () => facetSelectionGizmo.updateGizmoPosition(),
                disableSelectionChange: () => facetSelectionGizmo.disableSelectionChange(),
                enableSelectionChange: () => facetSelectionGizmo.enableSelectionChange(),
                dispose: () => this.clearGizmo(facetSelectionGizmo),
                setBackfaceCulling: (enabled) => facetSelectionGizmo.setBackfaceCulling(enabled),
                setTolerance: (tolerance) => facetSelectionGizmo.setTolerance(tolerance),
                setVisualization: (opacity) => facetSelectionGizmo.setVisualization(opacity),
                expandSelection: (tolerance) => facetSelectionGizmo.expandSelection(tolerance),
            };
        }
        clearGizmo(gizmo) {
            if (gizmo) {
                const index = this.activeGizmoSettings.findIndex(g => g.gizmo === gizmo);
                if (index >= 0) {
                    const gizmoSettings = this.activeGizmoSettings[index];
                    gizmoSettings.subjects.forEach(subject => subject.complete());
                    gizmoSettings.gizmo.dispose();
                    this.activeGizmoSettings.splice(index, 1);
                }
            }
            else {
                this.activeGizmoSettings.forEach(gizmoSettings => {
                    gizmoSettings.subjects.forEach(subject => subject.complete());
                    gizmoSettings.gizmo.dispose();
                });
                this.activeGizmoSettings = [];
            }
        }
        updateGizmoPositions() {
            if (!this.dragging) {
                this.activeGizmoSettings.forEach(gizmoSettings => {
                    gizmoSettings.gizmo.updateGizmoPosition();
                });
            }
        }
        showUvMapMaterial(target) {
            if (target._showMaterial && target._previewMaterialVisible) {
                if (target._parent) {
                    const mesh = this.kbViewer.getRendererNode(target._parent);
                    if (mesh instanceof Mesh) {
                        if (mesh.material != null && mesh.material.name != PREVIEW_NAME) {
                            const previousMaterial = mesh.material;
                            this.uvMapStoredMaterials.set(target.id, previousMaterial);
                        }
                        if (!this.previewMaterial) {
                            this.previewMaterial = new PBRMaterial(PREVIEW_NAME, this.kbViewer.scene);
                            const previewTexture = new Texture('/assets/images/uv_colorgrid.png', this.kbViewer.scene);
                            this.previewMaterial.albedoTexture = previewTexture;
                            this.previewMaterial.albedoColor = Color3.White();
                            this.previewMaterial.metallic = 0;
                            this.previewMaterial.roughness = 1;
                        }
                        mesh.material = this.previewMaterial;
                    }
                }
            }
            else {
                if (target._parent) {
                    const mesh = this.kbViewer.getRendererNode(target._parent);
                    if (mesh instanceof Mesh) {
                        const storedMaterial = this.uvMapStoredMaterials.get(target.id);
                        if (storedMaterial) {
                            mesh.material = storedMaterial;
                        }
                    }
                }
            }
        }
        // Bounding mesh code is not used right now, but it may be useful when we are doing mates
        // private calculateBoundingBox(nodes: TransformNode[]) {
        //     const meshes = nodes.filter<Mesh>((node): node is Mesh => node instanceof Mesh);
        //     meshes.forEach(mesh => mesh.computeWorldMatrix(true));
        //     if (meshes.length === 0) {
        //         return {
        //             pivot: Vector3.Zero(),
        //             boundingInfo: new BoundingInfo(Vector3.Zero(), Vector3.Zero())
        //         };
        //     }
        //     let boundingInfo = meshes[0].getBoundingInfo();
        //     let minimumWorld = boundingInfo.boundingBox.minimumWorld;
        //     let maximumWorld = boundingInfo.boundingBox.maximumWorld;
        //     for (let i = 1; i < meshes.length; i++) {
        //         let boundingInfo = meshes[i].getBoundingInfo();
        //         minimumWorld = Vector3.Minimize(minimumWorld, boundingInfo.boundingBox.minimumWorld);
        //         maximumWorld = Vector3.Maximize(maximumWorld, boundingInfo.boundingBox.maximumWorld);
        //     }
        //     let bounding = new BoundingInfo(minimumWorld, maximumWorld);
        //     let middlePivot = new Vector3(bounding.boundingBox.center.x, bounding.boundingBox.center.y, bounding.boundingBox.center.z);
        //     return {
        //         pivot: middlePivot,
        //         boundingInfo: bounding
        //     };
        // }
        // private displayKbBoundingBox(mesh: Mesh) {
        //     let oMesh: Mesh & { kbBoundingBox?: boundingBoxGeometry };
        //     oMesh = mesh;
        //     var bbNode: boundingBoxGeometry;
        //     if (this.currentSelectedMeshes.length === 0) {
        //         if (oMesh.kbBoundingBox) {
        //             oMesh.kbBoundingBox.wireFrame.dispose();
        //             delete oMesh.kbBoundingBox;
        //         }
        //         return;
        //     }
        //     // if the mesh is resized/rotated/something we need to recalculate the bounding box
        //     mesh.computeWorldMatrix(true);
        //     mesh.refreshBoundingInfo();
        //     mesh.refreshBoundingInfo = (applySkeleton?: boolean) => {
        //         return mesh;
        //     };
        //     const center = mesh.getBoundingInfo().boundingBox.centerWorld.clone();
        //     const diagonalLen = mesh.getBoundingInfo().diagonalLength;
        //     const min = mesh.getBoundingInfo().boundingBox.minimumWorld;
        //     const max = mesh.getBoundingInfo().boundingBox.maximumWorld;
        //     const d = max.subtract(min);
        //     const bOffset = 0.02;
        //     d.x += bOffset;
        //     d.y += bOffset;
        //     d.z += bOffset;
        //     // calculate the position of the bounding box vertices
        //     const v1 = new Vector3(center.x - d.x / 2, center.y + d.y / 2, center.z + d.z / 2);
        //     const v2 = new Vector3(center.x + d.x / 2, center.y + d.y / 2, center.z + d.z / 2);
        //     const v3 = new Vector3(center.x - d.x / 2, center.y - d.y / 2, center.z + d.z / 2);
        //     const v4 = new Vector3(center.x + d.x / 2, center.y - d.y / 2, center.z + d.z / 2);
        //     const v5 = new Vector3(center.x - d.x / 2, center.y + d.y / 2, center.z - d.z / 2);
        //     const v6 = new Vector3(center.x + d.x / 2, center.y + d.y / 2, center.z - d.z / 2);
        //     const v7 = new Vector3(center.x - d.x / 2, center.y - d.y / 2, center.z - d.z / 2);
        //     const v8 = new Vector3(center.x + d.x / 2, center.y - d.y / 2, center.z - d.z / 2);
        //     const lines = Mesh.CreateLines(KBMAXPREFIX + "boundingBox", [
        //         v1, v2,
        //         v1, v3,
        //         v3, v4,
        //         v4, v2,
        //         v2, v6,
        //         v6, v5,
        //         v5, v7,
        //         v7, v8,
        //         v8, v6,
        //         v8, v4,
        //         v3, v7,
        //         v5, v1
        //     ], this.gizmoLayer.utilityLayerScene);
        //     lines.color = new Color3(1, 1, 1);
        //     lines.isPickable = false;
        //     if (oMesh.kbBoundingBox) {
        //         // the bounding box exists so it must be recalculated and repositioned
        //         bbNode = oMesh.kbBoundingBox;
        //         bbNode.wireFrame.dispose(); // it is easier to recreate it then reposition it
        //         bbNode.wireFrame = lines;
        //     }
        //     else {
        //         // the bounding box does not exist, so it must be created
        //         bbNode = new boundingBoxGeometry(lines);
        //     }
        //     oMesh.kbBoundingBox = bbNode; // force to attach the current boundingBox
        // }
        filterToChangedValues(vector) {
            return {
                x: vector.x ? vector.x : undefined,
                y: vector.y ? vector.y : undefined,
                z: vector.z ? vector.z : undefined,
                w: 'w' in vector ? vector.w : undefined,
            };
        }
    }
    // class boundingBoxGeometry {
    //     mateHelper1?: Mesh;
    //     mateHelper2?: Mesh;
    //     mateHelper3?: Mesh;
    //     mateHelper4?: Mesh;
    //     mateHelper5?: Mesh;
    //     mateHelper6?: Mesh;
    //     wireFrame: Mesh;
    //     constructor(wireFrame: Mesh) {
    //         this.wireFrame = wireFrame;
    //     }
    // }

    function bakeMeshTransform(node) {
        const newTransform = computeLocalTransform(node);
        if (node.preTransform) {
            if (node.preTransform.length !== 16) {
                throw Error('invalid pretransform array ');
            }
            const preTransform = Matrix.FromArray(node.preTransform);
            preTransform.multiplyToRef(newTransform, newTransform);
        }
        node.preTransform = Array.from(newTransform.toArray());
        node.pivot = exports.KbVector.Zero();
        node.position = exports.KbVector.Zero();
        node.scaling = 1;
        node.rotationAngle = 0;
        node.rotationAxis = new exports.KbVector(0, 1, 0);
        node.eulerRotation = exports.KbVector.Zero();
        return node;
    }

    const DefaultSketchOptions = {
        faceCamera: true,
        snapSize: 0.5,
    };
    let activeHitPoint;
    let sketchPlaneIntersect;
    class SketchEditor {
        constructor(kbViewer, scene, defaultHighlightColor) {
            this.kbViewer = kbViewer;
            this.scene = scene;
            this.defaultHighlightColor = defaultHighlightColor;
            this.mouseUp = new Subject();
            this.end = new Subject();
            this.sketchPoints = [];
        }
        updateActiveOptions(options) {
            if (this.currentOptions) {
                for (const prop in options) {
                    // @ts-expect-error typing not smart enough to know that option objects are the same
                    this.currentOptions[prop] = options[prop];
                }
            }
        }
        start(sketch) {
            let origin = exports.KbVector.Zero();
            for (let i = 0; i < sketch.paths.length; i++) {
                const path = sketch.paths[i];
                if (path.controlPoints.length > 0) {
                    origin = path.controlPoints[0].position;
                    break;
                }
            }
            return this.startOnPlane(sketch, {
                normal: sketch.normal,
                intersect: origin,
            }, undefined, true);
        }
        startOnPlane(sketch, plane, userOptions, useSketchNormal = false) {
            this.activeSketch = sketch;
            sketchPlaneIntersect = plane.intersect;
            const currentCanvas = this.kbViewer.canvas;
            const options = { ...DefaultSketchOptions, ...userOptions };
            this.currentOptions = options;
            this.sketchPoints = sketch.paths.reduce((result, path) => {
                for (const point of path.controlPoints) {
                    point._visible = true;
                    result.push(point);
                }
                return result;
            }, []);
            const previewVisibleOriginal = sketch._previewVisible;
            sketch._previewVisible = true;
            let planeNormal = getSketchNormalVector3(plane.normal);
            if (useSketchNormal) {
                const sketchNode = this.kbViewer.getRendererNode(sketch);
                if (sketchNode) {
                    const matrix = sketchNode.getWorldMatrix().getRotationMatrix();
                    planeNormal = Vector3.TransformCoordinates(planeNormal, matrix);
                }
            }
            const planeIntersect = plane.intersect.toVec3();
            const sketchPlane = Plane.FromPositionAndNormal(planeIntersect, planeNormal);
            const originalCamera = this.scene.activeCamera;
            let sketchCamera;
            if (options.faceCamera) {
                originalCamera.detachControl();
                // camera.storeCameraSettings();
                // const viewpoint = new ViewpointNode()
                // camera.moveCameraToViewpoint(viewpoint);
                sketchCamera = new KbArcRotateCamera('sketchEditorView', 0, 0, 10, planeIntersect, this.scene);
                sketchCamera.mode = Camera.ORTHOGRAPHIC_CAMERA;
                sketchCamera.lockRotation = true;
                sketchCamera.wheelPrecision = 60;
                sketchCamera.pinchPrecision = 60;
                switch (plane.normal) {
                    case exports.eAxis.x:
                    case exports.eAxis.z:
                        sketchCamera.upVector = Vector3.Up();
                        break;
                    case exports.eAxis.y:
                        sketchCamera.upVector = Vector3.Backward();
                        break;
                    default:
                        sketchCamera.upVector = Vector3.Cross(planeNormal, planeNormal.equalsToFloats(0, 1, 0) ? Vector3.Right() : Vector3.Up());
                }
                sketchCamera.setPosition(planeNormal.scale(5000).add(planeIntersect));
                sketchCamera.orthoFit(10, 10);
                this.scene.activeCamera = sketchCamera;
                currentCanvas.focus();
                sketchCamera.attachControl();
                this.kbViewer.viewChanged.next();
            }
            const currentCamera = this.scene.activeCamera;
            let dragObjects = [];
            let lastMousePosition = null;
            const sketchParent = sketch._parent ? this.kbViewer.getRendererNode(sketch._parent) : undefined;
            this.kbViewer.interaction.onPointerDown.pipe(takeUntil(this.end)).subscribe(e => {
                if (e.button === 0 && e.pickInfo && e.pickInfo.ray) {
                    const deletedPoints = [];
                    const ray = e.pickInfo.ray;
                    lastMousePosition = getPointOnPlane(ray);
                    if (lastMousePosition) {
                        roundVectorToPlaces(lastMousePosition, options.snapSize);
                    }
                    const v1 = new Vector3(-1, -1, -1), v2 = new Vector3(1, 1, 1), collisionSphere = new BoundingSphere(v1, v2);
                    const r = CONNECTOR_DIAM / 2;
                    for (let i = 0; i < this.sketchPoints.length; i++) {
                        const point = this.sketchPoints[i];
                        const pointRendered = this.kbViewer.getRendererNode(point);
                        if (!pointRendered || pointRendered.isDisposed()) {
                            this.sketchPoints.splice(i, 1);
                            i--;
                            continue;
                        }
                        const cpCenter = pointRendered.position.clone();
                        const cpHandle1 = cpCenter.add(point.direction.toVec3());
                        const cpHandle2 = point.direction2 ? cpCenter.add(point.direction2.toVec3()) : undefined;
                        if (sketchParent) {
                            const matrix = sketchParent.computeWorldMatrix();
                            Vector3.TransformCoordinatesToRef(cpCenter, matrix, cpCenter);
                            Vector3.TransformCoordinatesToRef(cpHandle1, matrix, cpHandle1);
                            if (cpHandle2) {
                                Vector3.TransformCoordinatesToRef(cpHandle2, matrix, cpHandle2);
                            }
                        }
                        v1.copyFrom(cpCenter).addInPlaceFromFloats(-r, -r, -r);
                        v2.copyFrom(cpCenter).addInPlaceFromFloats(r, r, r);
                        collisionSphere.reConstruct(v1, v2);
                        let hit = ray.intersectsSphere(collisionSphere);
                        let handle = 'position';
                        if (!hit) {
                            v1.copyFrom(cpHandle1).addInPlaceFromFloats(-r, -r, -r);
                            v2.copyFrom(cpHandle1).addInPlaceFromFloats(r, r, r);
                            collisionSphere.reConstruct(v1, v2);
                            hit = ray.intersectsSphere(collisionSphere);
                            handle = 'direction';
                        }
                        if (!hit && cpHandle2) {
                            v1.copyFrom(cpHandle2).addInPlaceFromFloats(-r, -r, -r);
                            v2.copyFrom(cpHandle2).addInPlaceFromFloats(r, r, r);
                            collisionSphere.reConstruct(v1, v2);
                            hit = ray.intersectsSphere(collisionSphere);
                            handle = 'direction2';
                        }
                        if (hit) {
                            dragObjects.push({ point, handle });
                            // If ctrl key is held down, allow dragging just one point so you can separate paths
                            if (e.ctrlKey) {
                                break;
                            }
                        }
                    }
                    deletedPoints.forEach(point => {
                        const index = this.sketchPoints.findIndex(ec => ec.id === point.id);
                        this.sketchPoints.splice(index, 1);
                    });
                    // If both direction handles and positions are hit, only drag the positions and leave the handles alone
                    if (dragObjects.find(d => d.handle === 'position')) {
                        dragObjects = dragObjects.filter(d => d.handle === 'position');
                    }
                    if (dragObjects.length === 0) {
                        activeHitPoint = undefined;
                    }
                    else {
                        activeHitPoint = dragObjects[0].point;
                        currentCamera.detachControl();
                    }
                }
            });
            this.kbViewer.interaction.onPointerUp.pipe(takeUntil(this.end)).subscribe(e => {
                dragObjects = [];
                this.mouseUp.next();
                currentCamera.attachControl(currentCanvas);
            });
            this.kbViewer.interaction.onPointerMove.pipe(takeUntil(this.end)).subscribe(e => {
                if (dragObjects.length > 0 && e.pickInfo && e.pickInfo.ray) {
                    const ray = e.pickInfo.ray;
                    const intersect = getPointOnPlane(ray);
                    if (intersect) {
                        if (sketchParent) {
                            const transformInv = sketchParent.computeWorldMatrix().clone().invert();
                            Vector3.TransformCoordinatesToRef(intersect, transformInv, intersect);
                        }
                        roundVectorToPlaces(intersect, options.snapSize);
                        dragObjects.forEach(dragObject => {
                            if (dragObject.handle === 'position') {
                                roundVectorToPlaces(intersect, options.snapSize);
                                dragObject.point.position = exports.KbVector.FromVec3(intersect);
                            }
                            else {
                                const movement = intersect.subtract(dragObject.point.position.toVec3());
                                roundVectorToPlaces(intersect, options.snapSize);
                                if (dragObject.handle === 'direction') {
                                    dragObject.point.direction = exports.KbVector.FromVec3(movement);
                                }
                                else if (dragObject.point.direction2) {
                                    dragObject.point.direction2 = exports.KbVector.FromVec3(movement);
                                }
                            }
                        });
                    }
                }
            });
            this.kbViewer.interaction.onClick.pipe(takeUntil(this.end)).subscribe(e => {
                if (dragObjects.length === 0 && e.pickInfo) {
                    if (e.button === 2 && e.canvasX && e.canvasY) {
                        if (e.pickInfo.pickedMesh instanceof LinesMesh && e.pickInfo.pickedPoint) {
                            this.kbViewer.rightClickMenu.showContextMenu(e.canvasX, e.canvasY, this.getRightClickButtonsForLines(sketch, e.pickInfo.faceId, e.pickInfo.pickedPoint));
                        }
                        else if (e.pickInfo.pickedMesh instanceof Mesh) {
                            const kb3dNode = getByDynamicId(e.pickInfo.pickedMesh.id);
                            if (kb3dNode instanceof exports.SketchControlPoint) {
                                activeHitPoint = kb3dNode;
                                this.kbViewer.rightClickMenu.showContextMenu(e.canvasX, e.canvasY, this.getRightClickButtons());
                            }
                        }
                    }
                    else if (e.button === 0 && e.pickInfo.ray) {
                        if (this.kbViewer.rightClickMenu.isOpen()) {
                            this.kbViewer.rightClickMenu.hideContextMenu();
                            return;
                        }
                        const ray = e.pickInfo.ray;
                        const intersect = getPointOnPlane(ray);
                        if (intersect) {
                            const manager = sketch._manager;
                            roundVectorToPlaces(intersect, options.snapSize);
                            let lastPath = sketch.paths.length > 0 ? sketch.paths[sketch.paths.length - 1] : undefined;
                            if (!lastPath) {
                                lastPath = manager.create(Token.SketchPath);
                                lastPath.name = 'Path';
                                sketch.addChildren(lastPath);
                            }
                            const c = createSketchPointForEditor(manager, lastPath);
                            if (sketch._parent instanceof exports.SpaceNode) {
                                const rendererNode = this.kbViewer.getRendererNode(sketch);
                                if (rendererNode) {
                                    Vector3.TransformCoordinatesToRef(intersect, rendererNode.computeWorldMatrix().clone().invert(), intersect);
                                }
                                c.position = exports.KbVector.FromVec3(intersect);
                            }
                            this.sketchPoints.push(c);
                        }
                    }
                }
            });
            this.end.pipe(take(1)).subscribe(() => {
                if (!previewVisibleOriginal) {
                    sketch.paths.forEach(path => {
                        for (const point of path.controlPoints) {
                            point._visible = false;
                        }
                    });
                }
                originalCamera.attachControl(currentCanvas);
                this.scene.activeCamera = originalCamera;
                if (sketchCamera) {
                    sketchCamera.dispose();
                }
                sketch._previewVisible = previewVisibleOriginal;
            });
            function getPointOnPlane(ray) {
                const d = ray.intersectsPlane(sketchPlane);
                if (typeof d === 'number') {
                    return ray.origin.add(ray.direction.scale(d));
                }
                return null;
            }
        }
        clear() {
            this.end.next();
            this.kbViewer.rightClickMenu.hideContextMenu();
            this.currentOptions = undefined;
            this.activeSketch = undefined;
        }
        dispose() {
            this.kbViewer.rightClickMenu.hideContextMenu();
            this.end.next();
            this.end.complete();
            this.mouseUp.complete();
            this.activeSketch = undefined;
        }
        deleteSketchPoint() {
            if (this.kbViewer.sceneNode._manager && activeHitPoint) {
                const path = activeHitPoint._parent;
                const targetPoint = activeHitPoint;
                if (path instanceof exports.SketchPath) {
                    const index = path.controlPoints.findIndex(ec => ec.id === targetPoint.id);
                    path.controlPoints.splice(index, 1);
                }
            }
        }
        deleteSketchPath() {
            if (this.kbViewer.sceneNode._manager && activeHitPoint) {
                if (this.activeSketch) {
                    const sketch = this.activeSketch;
                    const targetPoint = activeHitPoint;
                    sketch.paths.forEach(path => {
                        if (path instanceof exports.SketchPath) {
                            const index = path.controlPoints.findIndex(ec => { var _a; return ec._dynamicId === ((_a = targetPoint._parent) === null || _a === void 0 ? void 0 : _a._dynamicId); });
                            sketch.paths.splice(index, 1);
                        }
                    });
                }
            }
        }
        separateSketchNode(sketchpathType) {
            var _a, _b;
            if (this.kbViewer.sceneNode._manager && activeHitPoint) {
                // let targetControlPoint: SketchControlPoint | undefined;
                const manager = this.kbViewer.sceneNode._manager;
                if (this.activeSketch) {
                    const sketch = this.activeSketch;
                    const targetPoint = activeHitPoint;
                    for (let pathIndex = 0; pathIndex < sketch.paths.length; pathIndex++) {
                        const path = sketch.paths[pathIndex];
                        const cpIndex = path.controlPoints.findIndex(ec => ec._dynamicId === targetPoint._dynamicId);
                        if (cpIndex === -1) {
                            continue;
                        }
                        if (path.type === sketchpathType) {
                            return;
                        }
                        if (path.controlPoints.length === 1 && sketchpathType === exports.eSketchPathType.arcThrough3Points) {
                            const newControlPoint2 = createSketchPointForEditor(manager, path);
                            const newControlPoint3 = createSketchPointForEditor(manager, path);
                            let sketchNormal = new Vector3(1, 0, 0);
                            if (sketch.normal === exports.eAxis.y) {
                                sketchNormal = new Vector3(0, 1, 0);
                            }
                            else if (sketch.normal === exports.eAxis.z) {
                                sketchNormal = new Vector3(0, 0, 1);
                            }
                            const controlPointMesh = this.kbViewer.getRendererNode(sketch.paths[pathIndex].controlPoints[0]);
                            const pointOnePosition = sketchNormal.cross(sketchPlaneIntersect.toVec3().subtract(controlPointMesh.getAbsolutePosition()));
                            newControlPoint2.position = new exports.KbVector(pointOnePosition.x, pointOnePosition.y, pointOnePosition.z);
                            const pointTwoPosition = sketchNormal.cross(pointOnePosition.subtract(controlPointMesh.getAbsolutePosition()));
                            newControlPoint3.position = new exports.KbVector(pointTwoPosition.x, pointTwoPosition.y, pointTwoPosition.z);
                            path._expanded = true;
                            path.type = sketchpathType;
                            this.sketchPoints.push(newControlPoint2);
                            this.sketchPoints.push(newControlPoint3);
                            break;
                        }
                        else if (cpIndex === 0 && ((_a = sketch.paths[pathIndex - 1]) === null || _a === void 0 ? void 0 : _a.type) === sketchpathType) {
                            // If an adjacent path has the same path type as the one we're making, we'll just add the control point to it
                            // Previous path matching case
                            const cp = path.controlPoints.shift();
                            sketch.paths[pathIndex - 1].controlPoints.push(cp.clone());
                            break;
                        }
                        else if (
                        // Next path matching case
                        cpIndex === path.controlPoints.length - 1 &&
                            ((_b = sketch.paths[pathIndex + 1]) === null || _b === void 0 ? void 0 : _b.type) === sketchpathType) {
                            const cp = path.controlPoints.pop();
                            sketch.paths[pathIndex + 1].controlPoints.push(cp.clone());
                            break;
                        }
                        else if (path.controlPoints.length > 1) {
                            let selectedControlPoints;
                            let previousPath;
                            let selectedPath;
                            let nextPath;
                            if (cpIndex === 0) {
                                selectedPath = path;
                            }
                            else {
                                previousPath = path;
                                selectedControlPoints = Array.from(previousPath.controlPoints.splice(cpIndex, path.controlPoints.length - cpIndex));
                                selectedPath = manager.create(Token.SketchPath);
                                sketch.paths.splice(pathIndex + 1, 0, selectedPath);
                                selectedPath.name = 'Path';
                                selectedControlPoints.reverse();
                                while (selectedControlPoints.length > 0) {
                                    const cp = manager.clone(selectedControlPoints.pop());
                                    cp._visible = true;
                                    selectedPath.controlPoints.push(cp);
                                    this.sketchPoints.push(cp);
                                }
                            }
                            if (selectedPath.controlPoints.length > 2) {
                                let nextPathPoints;
                                if (sketchpathType == exports.eSketchPathType.arcThrough3Points &&
                                    selectedPath.controlPoints.length > 3) {
                                    nextPathPoints = Array.from(selectedPath.controlPoints.splice(3, selectedPath.controlPoints.length - 3));
                                }
                                else {
                                    nextPathPoints = Array.from(selectedPath.controlPoints.splice(1, selectedPath.controlPoints.length - 1));
                                }
                                nextPath = manager.create(Token.SketchPath);
                                sketch.paths.splice(pathIndex + 2, 0, nextPath);
                                nextPath.name = 'Path';
                                nextPathPoints.reverse();
                                while (nextPathPoints.length > 0) {
                                    const cp = manager.clone(nextPathPoints.pop());
                                    cp._visible = true;
                                    nextPath.controlPoints.push(cp);
                                    this.sketchPoints.push(cp);
                                }
                            }
                            selectedPath._expanded = true;
                            selectedPath.type = sketchpathType;
                            if (previousPath) {
                                const match = manager.clone(selectedPath.controlPoints[0]);
                                match._visible = true;
                                previousPath.controlPoints.push(match);
                                this.sketchPoints.push(match);
                            }
                            if (nextPath && nextPath.controlPoints.length > 0) {
                                const match = manager.clone(nextPath.controlPoints[0]);
                                match._visible = true;
                                selectedPath.controlPoints.push(match);
                                this.sketchPoints.push(match);
                            }
                            break;
                        }
                    }
                }
            }
        }
        addSketchNodeOnPath(node, faceId, pickedPoint) {
            const index = node._lineSegmentStartingPoints[faceId];
            let counter = 0;
            const manager = node._manager;
            for (let pathIndex = 0; pathIndex < node.paths.length; pathIndex++) {
                const path = node.paths[pathIndex];
                for (let cpIndex = 0; cpIndex < node.paths.length; cpIndex++) {
                    const controlPoint = path.controlPoints[cpIndex];
                    if (counter === index) {
                        const spliceIndex = path.controlPoints.indexOf(controlPoint);
                        const sketchControlPoint = manager.create(Token.SketchControlPoint);
                        sketchControlPoint.position = exports.KbVector.FromVec3(pickedPoint);
                        path.controlPoints.splice(spliceIndex + 1, 0, sketchControlPoint);
                        sketchControlPoint._visible = true;
                        sketchControlPoint._expanded = true;
                        this.sketchPoints.push(sketchControlPoint);
                        return;
                    }
                    counter++;
                }
            }
        }
        getRightClickButtons() {
            return [
                { label: 'delete node', callback: () => this.deleteSketchPoint() },
                { label: 'delete path', callback: () => this.deleteSketchPath() },
                { label: 'convert to cubic bezier', callback: () => this.separateSketchNode(exports.eSketchPathType.cubicBezier) },
                {
                    label: 'convert to quadratic bezier',
                    callback: () => this.separateSketchNode(exports.eSketchPathType.quadraticBezier),
                },
                { label: 'convert to hermite', callback: () => this.separateSketchNode(exports.eSketchPathType.hermite) },
                { label: 'convert to catmullrom', callback: () => this.separateSketchNode(exports.eSketchPathType.catmullRom) },
                { label: 'convert to points', callback: () => this.separateSketchNode(exports.eSketchPathType.points) },
                {
                    label: 'arc through 3 points',
                    callback: () => this.separateSketchNode(exports.eSketchPathType.arcThrough3Points),
                },
            ];
        }
        getRightClickButtonsForLines(node, faceId, pickedPoint) {
            return [
                {
                    label: 'add point on line',
                    callback: () => this.addSketchNodeOnPath(node, faceId, pickedPoint),
                },
            ];
        }
    }

    function downloadBlob(blob, filename = 'download') {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'download';
        const clickHandler = () => {
            setTimeout(() => {
                URL.revokeObjectURL(url);
                a.removeEventListener('click', clickHandler);
            }, 150);
        };
        a.addEventListener('click', clickHandler, false);
        a.click();
    }
    function dataURLtoBlob(dataurl) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    (function (eSnapshotType) {
        eSnapshotType["image"] = "image";
        eSnapshotType["blob"] = "blob";
        eSnapshotType["dataUrl"] = "dataUrl";
    })(exports.eSnapshotType || (exports.eSnapshotType = {}));
    class SnapshotModule {
        constructor(v, scene) {
            this.v = v;
            this.scene = scene;
        }
        take(args) {
            if (args.dataType == exports.eSnapshotType.image) {
                return this.download(args);
            }
            else if (args.dataType == exports.eSnapshotType.blob) {
                return this.takeAsBlob(args);
            }
            else {
                return this.takeAsDataUrl(args);
            }
        }
        takeAsDataUrl(args) {
            //set the viewpoint
            let viewpointSet = false;
            if (args.viewpoint) {
                const viewpoint = this.v.sceneNode._manager.getNodeByIdOrName(args.viewpoint);
                if (!viewpoint) {
                    throw `Could not find viewpoint ${args.viewpoint} for snapshot`;
                }
                else {
                    this.v.camera.storeCameraSettings();
                    this.v.camera.moveCameraToViewpoint(viewpoint);
                    viewpointSet = true;
                }
            }
            return this.v
                .whenAssetsLoaded()
                .then(() => {
                if (args.frameCamera) {
                    this.v.camera.frameCamera(this.v.sceneNode, {
                        padding: args.framePadding,
                    });
                }
                return this.v.forceAndWaitForNextRender().then(() => {
                    return this.v.forceAndWaitForNextRender();
                });
            })
                .then(() => {
                const engine = this.v.scene.getEngine();
                const mimeType = args.mimeType || 'image/png';
                const snapshotCanvas = document.createElement('canvas');
                snapshotCanvas.width = args.width;
                snapshotCanvas.height = args.height;
                const renderContext = snapshotCanvas.getContext('2d');
                const ratio = engine.getRenderWidth() / engine.getRenderHeight();
                let newWidth = args.width;
                let newHeight = newWidth / ratio;
                if (newHeight > args.height) {
                    newHeight = args.height;
                    newWidth = newHeight * ratio;
                }
                const offsetX = Math.max(0, args.width - newWidth) / 2;
                const offsetY = Math.max(0, args.height - newHeight) / 2;
                const renderingCanvas = engine.getRenderingCanvas();
                if (renderContext && renderingCanvas) {
                    renderContext.drawImage(renderingCanvas, offsetX, offsetY, newWidth, newHeight);
                }
                const dataUrl = snapshotCanvas.toDataURL(mimeType);
                if (viewpointSet) {
                    this.v.camera.restoreCameraSettings();
                }
                snapshotCanvas.width = 0;
                snapshotCanvas.height = 0;
                return dataUrl;
            });
        }
        takeAsBlob(args) {
            return this.takeAsDataUrl(args).then(dataUrl => dataURLtoBlob(dataUrl));
        }
        download(args) {
            return this.takeAsBlob(args).then(blob => downloadBlob(blob, args.filename));
        }
    }

    var maskFragmentShader = "precision highp float;\r\n        \r\nuniform vec4 lineColor;\r\n\r\nvoid main(void) {\r\n    gl_FragColor = lineColor;\r\n}";

    var maskVertexShader = "precision highp float;\r\n // Attributes\r\nattribute vec3 position;\r\n// Uniforms\r\nuniform mat4 worldViewProjection;\r\nvoid main(void) {\r\n    gl_Position = worldViewProjection * vec4(position, 1.0);\r\n}\r\n\r\n";

    var outlineFragmentShader = "#ifdef GL_ES\r\nprecision highp float;\r\n#endif\r\n\r\n// Samplers\r\nvarying vec2 vUV;\r\nuniform sampler2D textureSampler;\r\nuniform sampler2D maskSampler;\r\n\r\n// Parameters\r\nuniform vec2 screenSize;\r\nuniform float threshold;\r\nuniform float lineWidth;\r\nuniform bool debug;\r\n\r\nvoid main(void) \r\n{\r\n    // Calculating how far away to check pixels for different colors to determine whether to draw an outline pixel\r\n    float dx = (1.0 / screenSize.x) * lineWidth;\r\n    float dy = (1.0 / screenSize.y) * lineWidth;\r\n\r\n    float xMin = dx * 0.5;\r\n    float xMax = 1. - dx * 0.5;\r\n    float yMin = dy * 0.5;\r\n    float yMax = 1. - dy * 0.5;\r\n\r\n    float right = clamp(vUV.x + dx, xMin, xMax);\r\n    float left = clamp(vUV.x - dx, xMin, xMax);\r\n    float top = clamp(vUV.y + dy, yMin, yMax);\r\n    float bottom = clamp(vUV.y - dy, yMin, yMax);\r\n\r\n    // calculating the uvs corresponsing to the pixels from the step above\r\n    vec2 uvCenter = vUV;\r\n    vec2 uvLeft   = vec2(left, uvCenter.y);\r\n    vec2 uvRight  = vec2(right, uvCenter.y);\r\n    vec2 uvTop    = vec2(uvCenter.x, top);\r\n    vec2 uvBottom = vec2(uvCenter.x, bottom);\r\n    vec2 uvTopLeft   = vec2(left, top);\r\n    vec2 uvTopRight  = vec2(right, top);\r\n    vec2 uvBottomLeft = vec2(left, bottom);\r\n    vec2 uvBottomRight = vec2(right, bottom);\r\n\r\n    // getting the colors of the pixels at the 4 corners of our check box\r\n    vec4 mCenter   = texture2D(maskSampler, uvCenter);\r\n    vec4 mleft    = texture2D(maskSampler, uvLeft);\r\n    vec4 mRight    = texture2D(maskSampler, uvRight);\r\n    vec4 mTop      = texture2D(maskSampler, uvTop);\r\n    vec4 mBottom      = texture2D(maskSampler, uvBottom);\r\n    vec4 mTopleft    = texture2D(maskSampler, uvTopLeft);\r\n    vec4 mTopRight    = texture2D(maskSampler, uvTopRight);\r\n    vec4 mBottomLeft      = texture2D(maskSampler, uvBottomLeft);\r\n    vec4 mBottomRight      = texture2D(maskSampler, uvBottomRight);\r\n\r\n    // getting the difference in colors between the center pixel and the other pixels\r\n    vec4 dL  = abs(mCenter - mleft);\r\n    vec4 dR  = abs(mCenter - mRight);\r\n    vec4 dT  = abs(mCenter - mTop);\r\n    vec4 dB  = abs(mCenter - mBottom);\r\n    vec4 dTL  = abs(mCenter - mTopleft);\r\n    vec4 dTR  = abs(mCenter - mTopRight);\r\n    vec4 dBL  = abs(mCenter - mBottomLeft);\r\n    vec4 dBR  = abs(mCenter - mBottomRight);\r\n\r\n    // getting the maximum difference from the center pixel to any of the other pixels\r\n    vec4 totalD = max(dT, dR);\r\n    totalD = max(totalD, dB);\r\n    totalD = max(totalD, dL);\r\n    totalD = max(totalD, dTL);\r\n    totalD = max(totalD, dTR);\r\n    totalD = max(totalD, dBL);\r\n    totalD = max(totalD, dBR);\r\n\r\n    float delta = length(totalD) * mCenter.a;\r\n    if(delta < threshold) {\r\n        delta = 0.0;\r\n    }\r\n\r\n    if (debug == true) {\r\n        gl_FragColor = texture2D(maskSampler, vUV);\r\n    } else {\r\n        // if(delta > threshold) {\r\n        //     gl_FragColor = texture2D(maskSampler, vUV);\r\n        // } else {\r\n        //     gl_FragColor = texture2D(textureSampler, vUV);\r\n        // }\r\n        // Merge the real scene output with the outline\r\n        vec4 albedoColor = texture2D(textureSampler, vUV);\r\n        gl_FragColor = mCenter.rgba * delta + albedoColor * (1.0 - delta);\r\n        // gl_FragColor = mCenter.rgba * delta;\r\n    }\r\n}";

    Effect.ShadersStore['customMaskVertexShader'] = maskVertexShader;
    Effect.ShadersStore['customMaskFragmentShader'] = maskFragmentShader;
    Effect.ShadersStore['simpleOutlineFragmentShader'] = outlineFragmentShader;
    class Highlighter {
        constructor(kbViewer, scene, defaultHighlightColor, cameraManager) {
            this.kbViewer = kbViewer;
            this.scene = scene;
            this.defaultHighlightColor = defaultHighlightColor;
            this.colorMap = new Map();
            this.nodeColors = new Map();
            this.highlighterDb = new Map();
            this.engine = scene.getEngine();
            this.highlightPipeline = new PostProcessRenderPipeline(this.engine, 'highlightPipeline');
            this.renderTarget = new RenderTargetTexture('Highlight render target', 1024, scene, { samples: 2 });
            this.renderTarget.renderList = [];
            this.renderTarget.clearColor = new Color4(0, 0, 0, 0);
            scene.customRenderTargets.push(this.renderTarget);
            this.postProcess = new PostProcess('Highlighter post process', 'simpleOutline', ['screenSize', 'threshold', 'lineWidth', 'debug'], ['maskSampler'], 1.0, null, undefined, this.engine, true);
            // This may help with the highlight separating from the scene meshes, if we can ge the highlight to combine with the scene
            // this.postProcess.autoClear = false;
            // this.postProcess.alphaMode = Engine.ALPHA_COMBINE;
            this.postProcess.samples = 4;
            this.postProcess.onApply = effect => {
                effect.setFloat2('screenSize', this.postProcess.width, this.postProcess.height);
                effect.setFloat('threshold', 0.3);
                effect.setFloat('lineWidth', 4.0);
                effect.setBool('debug', false);
                effect.setTexture('maskSampler', this.renderTarget);
                window.enableHighlightDebug = () => {
                    enableHighlightDebug(effect);
                };
            };
            const highlightEffect = new PostProcessRenderEffect(this.engine, 'highlightEffect', () => [this.postProcess], false);
            this.highlightPipeline.addEffect(highlightEffect);
            this.scene.postProcessRenderPipelineManager.addPipeline(this.highlightPipeline);
            cameraManager.setPipeline(this.highlightPipeline);
            function enableHighlightDebug(effect) {
                effect.setBool('debug', true);
            }
        }
        has(node) {
            return this.highlighterDb.has(node._dynamicId);
        }
        add(node, color = this.defaultHighlightColor) {
            this.startPostProcess();
            const renderNode = this.kbViewer.getRendererNode(node);
            this.highlighterDb.set(node._dynamicId, color);
            this.addHighlightToRendered(renderNode, color);
        }
        remove(node) {
            var _a;
            if (this.highlighterDb.has(node._dynamicId)) {
                const renderNode = this.kbViewer.getRendererNode(node);
                if (((_a = this.activeHover) === null || _a === void 0 ? void 0 : _a._dynamicId) !== node._dynamicId) {
                    // Don't remove the highlight from a hover. Once the hover clears the highlight will be cleared.
                    this.removeHighlightFromRendered(renderNode);
                    this.highlighterDb.delete(node._dynamicId);
                }
            }
        }
        hover(node) {
            if (node != this.activeHover) {
                this.startPostProcess();
                this.clearHover();
                this.activeHover = node;
                const renderNode = this.kbViewer.getRendererNode(node);
                this.addHighlightToRendered(renderNode, this.defaultHighlightColor);
                this.kbViewer.canvas.style.cursor = 'pointer';
                this.scene.defaultCursor = 'pointer';
                this.kbViewer.forceRenderOnNextFrame = true;
            }
        }
        clearHover() {
            if (this.activeHover) {
                const renderNode = this.kbViewer.getRendererNode(this.activeHover);
                this.removeHighlightFromRendered(renderNode);
                //if the node had a highlight previously, restore it
                if (this.highlighterDb.has(this.activeHover._dynamicId)) {
                    const color = this.highlighterDb.get(this.activeHover._dynamicId);
                    this.addHighlightToRendered(renderNode, color);
                }
                // const targets = renderNode instanceof AbstractMesh ? [renderNode] : renderNode.getChildMeshes();
                // for (const target of targets) {
                //     if (this.highlighterDb.has(target)) {
                //         const color = this.highlighterDb.get(target)!;
                //         this.addHighlightToRendered(target, color);
                //     }
                // }
                this.activeHover = undefined;
                this.kbViewer.canvas.style.cursor = 'default';
                this.scene.defaultCursor = 'default';
                this.kbViewer.forceRenderOnNextFrame = true;
            }
        }
        clearAll() {
            this.colorMap.forEach(entry => {
                this.renderTarget.setMaterialForRendering(Array.from(entry.meshes), undefined);
            });
            if (this.renderTarget.renderList) {
                while (this.renderTarget.renderList.length > 0) {
                    this.renderTarget.renderList.pop();
                }
            }
            this.nodeColors.clear();
            this.highlighterDb.clear();
            this.colorMap.clear();
            this.activeHover = undefined;
        }
        addHighlightToRendered(node, color) {
            var _a;
            const targets = node instanceof AbstractMesh ? [node] : node.getChildMeshes();
            for (const renderNode of targets) {
                if (((_a = this.renderTarget.renderList) === null || _a === void 0 ? void 0 : _a.contains(renderNode)) === false) {
                    if (!this.renderTarget.renderList) {
                        this.renderTarget.renderList = [];
                    }
                    this.renderTarget.renderList.push(renderNode);
                }
                let colorMapKey = '';
                if (color) {
                    colorMapKey = this.colorToString(color);
                }
                else {
                    colorMapKey = this.colorToString(this.defaultHighlightColor);
                }
                this.addNodeToColorMap(colorMapKey, renderNode, color);
                this.nodeColors.set(renderNode, colorMapKey);
            }
        }
        removeHighlightFromRendered(node) {
            var _a;
            const targets = node instanceof AbstractMesh ? [node] : node.getChildMeshes();
            for (const renderNode of targets) {
                const colorKey = this.nodeColors.get(renderNode);
                (_a = this.renderTarget.renderList) === null || _a === void 0 ? void 0 : _a.remove(renderNode);
                if (colorKey) {
                    this.removeNodeFromColorMap(colorKey, renderNode);
                    this.nodeColors.delete(renderNode);
                }
            }
        }
        addNodeToColorMap(colorMapKey, node, color) {
            let colorMapEntry = this.colorMap.get(colorMapKey);
            if (!colorMapEntry) {
                const newShader = new ShaderMaterial('customMaskMat_' + colorMapKey, this.scene, 'customMask', {
                    attributes: ['position', 'uv'],
                    uniforms: ['worldViewProjection', 'color', 'lineColor'],
                });
                if (color) {
                    newShader.setColor4('lineColor', color.toColor4());
                }
                else {
                    newShader.setColor4('lineColor', this.defaultHighlightColor.toColor4());
                }
                colorMapEntry = {
                    material: newShader,
                    meshes: new Set(),
                };
            }
            colorMapEntry.meshes.add(node);
            this.renderTarget.setMaterialForRendering(Array.from(colorMapEntry.meshes), colorMapEntry.material);
        }
        removeNodeFromColorMap(colorMapKey, node) {
            const colorMapEntry = this.colorMap.get(colorMapKey);
            if (colorMapEntry) {
                colorMapEntry.meshes.delete(node);
                this.renderTarget.setMaterialForRendering(node, undefined);
            }
        }
        colorToString(color) {
            return color.cssString();
        }
        startPostProcess() { }
    }

    class RightClickMenu {
        constructor(viewer, scene) {
            this.viewer = viewer;
            this.scene = scene;
            this.contextMenuOpen = false;
        }
        isOpen() {
            return this.contextMenuOpen;
        }
        showContextMenu(xPosition, yPosition, buttons) {
            this.createContextMenu(xPosition, yPosition, buttons);
            if (this.viewer.uiOverlay && this.contextmenu) {
                this.viewer.container.appendChild(this.contextmenu);
                this.contextMenuOpen = true;
            }
        }
        hideContextMenu() {
            if (this.contextmenu) {
                this.contextmenu.style.display = 'none';
                this.contextMenuOpen = false;
            }
        }
        createContextMenu(xPosition, yPosition, buttons) {
            var _a;
            //const buttons = [];
            if (this.contextmenu && this.viewer.container.contains(this.contextmenu)) {
                (_a = this.viewer.container) === null || _a === void 0 ? void 0 : _a.removeChild(this.contextmenu);
            }
            const contextMenu = document.createElement('div');
            contextMenu.style.position = 'absolute';
            contextMenu.style.top = yPosition.toString() + 'px';
            contextMenu.style.left = (xPosition + 10).toString() + 'px';
            contextMenu.style.width = 'auto';
            contextMenu.style.height = 'auto';
            contextMenu.style.zIndex = '2';
            contextMenu.addEventListener('click', e => {
                if (e.button === 2) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            });
            document.addEventListener('click', e => {
                if (e.button != 2) {
                    this.hideContextMenu();
                }
            });
            document.addEventListener('wheel', e => {
                this.hideContextMenu();
            });
            contextMenu.addEventListener('scroll', e => {
                if (this.contextmenu) {
                    this.contextmenu.style.display = 'none';
                }
            });
            this.contextmenu = contextMenu;
            buttons.forEach(button => {
                var _a;
                const newButton = document.createElement('div');
                newButton.innerText = button.label;
                newButton.addEventListener('click', e => {
                    button.callback();
                    this.hideContextMenu();
                });
                (_a = this.contextmenu) === null || _a === void 0 ? void 0 : _a.appendChild(newButton);
                newButton.style.zIndex = '100000';
                newButton.style.color = 'white';
                newButton.style.background = 'rgba(36,36,36,255)';
                newButton.style.cursor = 'pointer';
                newButton.style.padding = '10px';
                newButton.addEventListener('mouseover', e => {
                    newButton.style.background = 'rgba(61,61,61,255)';
                });
                newButton.addEventListener('mouseout', e => {
                    newButton.style.background = 'rgba(36,36,36,255)';
                });
            });
        }
    }

    const FADE_TIME = 300;
    /**
     * Applcation class for the viewer, to contain all of the initializers and hooks and connect the modules and 3d engine.
     * @param canvasElement An HTML DOM <canvas> element that the viewer will be attached to
     */
    class KbViewer {
        constructor(options) {
            this.forceRenderOnNextFrame = false;
            this.pauseRender = false;
            this.MeshWarningTracker = new Map();
            this.normalSmoothingWarnings = new Map();
            /** Events / Observables */
            /** observable for tracking when something changed that could affect the position of a node on the screen */
            this.viewChanged = new Subject();
            this.afterRender = new Subject();
            this.fpsTracker = new Subject();
            this.polygonTracker = new Subject();
            this.warningTracker = new Subject();
            this.meshWarningsNeedsUpdate = new Subject();
            this.materialWarningsNeedsUpdate = new Subject();
            this.animationWarningsNeedsUpdate = new Subject();
            this.disposed = false;
            this.forceRunRenderer = false;
            this.isDevEnvironment = false;
            /** tracks babylon nodes who are being tracked for positions (hotspots) */
            this.positionTrackedNodes = new Map();
            this.nextFrameCallbacks = [];
            this._renderLoopRunning = false;
            this.allAssetsLoaded = false;
            /** tracks any additional promises that renders and load spinners should wait for */
            this.additionalLoadBlockers = [];
            this.options = {
                highlightColor: exports.KbColor.KbmaxOrange(),
                editorMode: false,
                forceDisablePostProcess: false,
                enableScreenshots: false,
                debugMode: false,
                webworkerPath: '/worker3d.js',
                ...options,
            };
            if (typeof window !== 'undefined' && options.webworkerPath && !options.webworkerPath.startsWith('http')) {
                this.options.webworkerPath = `${window.location.protocol}//${window.location.host}${this.options.webworkerPath}`;
            }
            Kb3dWorker.workerPath = this.options.webworkerPath;
            // Create canvas and engine.
            this.container = options.container;
            this.canvas = this.createCanvas();
            // Anti-aliasing=true (second parameter) causes the canvas to not get cleared on iOS 15.4. Warrants testing in future iOS updates.
            const iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
            this.engine = new Engine(this.canvas, !iOS, { stencil: true, preserveDrawingBuffer: this.options.enableScreenshots }, true); //set adaptToDeviceRatio to true, and let the hardware scaling optimizer take over from there
            this.engine.setAlphaMode(Engine.ALPHA_COMBINE);
            this.glInfo = this.engine.getGlInfo();
            // eslint-disable-next-line no-console
            console.log('WebGL Renderer', this.glInfo.vendor, this.glInfo.renderer, this.glInfo.version);
            // Create the scene.
            const scene = this.createScene();
            this.scene = scene;
            this.scene.hoverCursor = 'pointer';
            this.utilityLayer = new UtilityLayerRenderer(this.scene);
            this.utilityLayer.utilityLayerScene.useRightHandedSystem = true;
            this.utilityLayer.processAllEvents = true;
            this.camera = new CameraTools(this.scene, this.canvas, this);
            this.bbCache = new BoundingBoxCache(this);
            // var hdrTexture = CubeTexture.CreateFromPrefilteredData('/assets/environments/environment.dds', scene);
            // hdrTexture.gammaSpace = false;
            // scene.environmentTexture = hdrTexture;
            this.highlightColor = options.highlightColor || exports.KbColor.KbmaxOrange();
            this.gizmos = new GizmoTools(scene, this);
            this.rightClickMenu = new RightClickMenu(this, this.scene);
            this.animation = new AnimationModule(this, this.scene);
            this.highlighter = new Highlighter(this, this.scene, this.highlightColor, this.camera);
            this.interaction = new Interaction(this, this.scene, this.highlighter);
            this.sketchEditor = new SketchEditor(this, this.scene, this.highlightColor);
            this.gui = new GuiHelper(scene, this.highlighter);
            this.ar = new AR(this, scene);
            this.snapshot = new SnapshotModule(this, scene);
            this.rendererManager = new RendererManager(this, scene);
            this.interaction.attachScene(this.utilityLayer.utilityLayerScene, true);
            this.gltfExporter = new GLTFKb3dExporter(scene);
            this.objExporter = new ObjKb3dExporter(scene, this.rendererManager);
        }
        get settings() {
            return SettingsManagerService;
        }
        setRenderMode(mode, force) {
            this.rendererManager.setRenderMode(mode, this.sceneNode, force);
        }
        loadScene(o) {
            if (!o.sceneNode._manager) {
                throw 'sceneNode must be constructed with a manager';
            }
            this.sceneNode = o.sceneNode;
            this.manager = o.sceneNode._manager;
            this.isDevEnvironment = this.manager.isDevEnvironment;
            const loadingExperience = o.loadingExperience || this.sceneNode.loadingExperience;
            this.createLoadingExperience(loadingExperience, this.sceneNode.loadingImagePath);
            let viewpoint = o.viewpoint ||
                (o.sceneNode.viewpointId ? this.manager.getById(o.sceneNode.viewpointId) : undefined);
            if (!viewpoint) {
                viewpoint = this.manager.create(Token.ViewpointNode);
                viewpoint.type = exports.eViewpointType.orbit;
                viewpoint.targetMode = exports.eViewpointTargetMode.point;
                viewpoint.position = new exports.KbVector(3, 3, 3);
                viewpoint.targetPoint = exports.KbVector.Zero();
            }
            this.camera.moveCameraToViewpoint(viewpoint);
            // Start render loop.
            this.startRender();
            // The canvas/window resize event handler.
            // window.addEventListener('resize', () => {
            //     if (!this.ar.xrLoading && !this.ar.xrActive) { //don't mess with the AR canvas resize
            //         this.engine.resize();
            //         this.viewChanged.next();
            //     }
            // });
            const promises = [this.whenAssetsLoaded()];
            if (o.deferLoadingPromise)
                promises.push(o.deferLoadingPromise);
            return Promise.all(promises).then(() => {
                var _a;
                const http = (_a = this.sceneNode._manager) === null || _a === void 0 ? void 0 : _a.getService(Token.HttpService);
                let frame = true;
                if (this.sceneNode.viewpointId)
                    frame = this.sceneNode.frameViewpoint;
                if (o.frameViewpoint != null)
                    frame = o.frameViewpoint;
                if (frame) {
                    this.camera.frameCamera(this.sceneNode);
                }
                this.hideLoadingExperience();
                // Wait for everything to be loaded and processed before trying to optimize scene because the scene optimizer watches the FPS and we want the state to be stable
                // Disable the graphics optimization (for example when rendering)
                if (!this.options.forceDisableGraphicsOptimization) {
                    this.waitForNextKb3dRender().then(() => {
                        this.optimizeScene(this.scene);
                    });
                }
                this.meshWarningsNeedsUpdate
                    .pipe(throttleTime(1000, undefined, { leading: true, trailing: true }))
                    .subscribe(() => {
                    this.updateMeshWarnings();
                    this.updateTextureWarnings();
                });
                this.materialWarningsNeedsUpdate
                    .pipe(throttleTime(15000, undefined, { leading: true, trailing: false }))
                    .subscribe(() => {
                    this.updateMaterialWarnings();
                });
                this.animationWarningsNeedsUpdate.subscribe(value => {
                    this.updateAnimationWarnings(value);
                });
                this.updateTextureWarnings();
                this.updateLightWarnings();
                this.updateMaterialWarnings();
                if (http) {
                    http.executeDeferredCalls();
                }
            });
        }
        getNode(id) {
            return this.manager.getById(id);
        }
        getRendererNode(n) {
            if (isSceneNode(n) && n.isNested() === false) {
                return this.rendererManager.sceneRenderer.get3d(n);
            }
            else if (isSceneNode(n) && n.isNested()) {
                return this.rendererManager.mesh.get3d(n);
            }
            else if (isLightNode(n)) {
                return this.rendererManager.light.get3d(n);
            }
            else if (isSpaceNode(n)) {
                return this.rendererManager.mesh.get3d(n);
            }
            else if (isMaterialNode(n)) {
                return this.rendererManager.material.get3d(n);
            }
            else if (isConnector(n)) {
                return this.rendererManager.connector.get3d(n);
            }
            else if (isSketchControlPoint(n)) {
                return this.rendererManager.controlPointRenderer.get3d(n);
            }
            else if (isTextureLayer(n)) {
                return this.rendererManager.textures.get3d(n);
            }
            return undefined;
        }
        getFPS() {
            return this.engine.getFps().toFixed();
        }
        getWarnings() {
            return this.warningMessages;
        }
        getMeshBoundingBox(node, vertexGroups) {
            let mesh = this.rendererManager.mesh.get3d(node);
            let newMesh;
            if (vertexGroups) {
                const newIndices = [];
                const newPositions = [];
                let indices;
                let positions;
                if (mesh instanceof Mesh && mesh.geometry) {
                    positions = mesh.geometry.getVerticesData(VertexBuffer.PositionKind);
                    indices = mesh.geometry.getIndices();
                }
                else {
                    indices = [];
                    positions = [];
                }
                for (let i = 0; i < vertexGroups.length; i++) {
                    const vertexGroup = vertexGroups[i];
                    if (vertexGroup && vertexGroup.startIndex && vertexGroup.endIndex) {
                        for (let j = vertexGroup.startIndex; j < vertexGroup.endIndex; j++) {
                            newIndices.push(indices[j]);
                            for (let k = 0; k < 3; k++) {
                                newPositions[indices[j] * 3 + k] = positions[indices[j] * 3 + k];
                            }
                        }
                    }
                }
                newMesh = new Mesh('temp mesh', this.scene, mesh === null || mesh === void 0 ? void 0 : mesh.parent);
                const newVertexData = new VertexData();
                newVertexData.indices = newIndices;
                newVertexData.positions = newPositions;
                newVertexData.applyToMesh(newMesh, true);
                newMesh.visibility = 0;
            }
            if (newMesh) {
                mesh = newMesh;
            }
            if (mesh && mesh instanceof AbstractMesh) {
                const boundingBox = mesh.getBoundingInfo().boundingBox;
                newMesh === null || newMesh === void 0 ? void 0 : newMesh.dispose();
                return {
                    maximum: boundingBox.maximum,
                    minimum: boundingBox.minimum,
                    center: boundingBox.center,
                    minWorld: boundingBox.minimumWorld,
                    maxWorld: boundingBox.maximumWorld,
                };
            }
        }
        updateLightWarnings() {
            let totalSpotLights = 0;
            let totalPointLights = 0;
            let shadowCastingLights = 0;
            let tempWarning = '';
            this.lightsWarningMessages = [];
            this.scene.lights.forEach(light => {
                if (light.isEnabled()) {
                    if (light instanceof SpotLight) {
                        totalSpotLights += 1;
                    }
                    else if (light instanceof PointLight) {
                        totalPointLights += 1;
                    }
                    if (light.shadowEnabled) {
                        shadowCastingLights += 1;
                    }
                }
            });
            if (totalSpotLights + totalPointLights > 10) {
                tempWarning = `Performance Warning: The number of spotlights (${totalSpotLights}) and/or pointlights (${totalPointLights}) is higher than recommended for optimal performance.`;
                this.lightsWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
            if (shadowCastingLights > 4) {
                tempWarning = `Performance Warning: The number of shadow casting lights (${shadowCastingLights}) is higher than recommended for optimal performance.`;
                this.lightsWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
            this.updateWarnings();
        }
        updateTextureWarnings() {
            const bigTextures2048 = new Map();
            const bigTextures4096 = new Map();
            let tempWarning = '';
            this.textureWarningMessages = [];
            this.sceneNode.meshes.forEach(node => {
                const mesh = this.getRendererNode(node);
                let textures = [];
                if (mesh instanceof AbstractMesh && mesh.isEnabled()) {
                    if (mesh.material instanceof MultiMaterial) {
                        mesh.material.subMaterials.forEach(subMaterial => {
                            const subMaterialTextures = subMaterial === null || subMaterial === void 0 ? void 0 : subMaterial.getActiveTextures();
                            if (subMaterialTextures) {
                                subMaterialTextures.forEach(texture => {
                                    if (texture instanceof Texture) {
                                        textures.push(texture);
                                    }
                                });
                            }
                        });
                    }
                    else if (mesh.material instanceof Material) {
                        textures = mesh.material.getActiveTextures();
                    }
                }
                if (textures) {
                    textures.forEach(texture => {
                        const textureSize = Math.max(texture.getSize().height, texture.getSize().width);
                        if (texture instanceof Texture) {
                            if (textureSize > 4096) {
                                bigTextures4096.set(texture.uniqueId, texture);
                                bigTextures2048.set(texture.uniqueId, texture);
                            }
                            else if (textureSize > 2048) {
                                bigTextures2048.set(texture.uniqueId, texture);
                            }
                        }
                    });
                }
            });
            if (bigTextures4096.size > 4) {
                tempWarning = `Warning, number of textures with resolutions over 4096 (${bigTextures4096.size}) is higher than recommended for optimal performance.`;
                this.textureWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
            else if (bigTextures2048.size > 20) {
                tempWarning = `Warning, number of textures with resolutions over 2048 (${bigTextures2048.size}) is higher than recommended for optimal performance.`;
                this.textureWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
            this.updateWarnings();
        }
        updateMeshWarnings() {
            this.totalPolygons = this.recursiveGetPolygons(this.sceneNode).polygons;
            let meshCastAndReceiveShadows = 0;
            let tempWarning = '';
            this.meshWarningMessages = [];
            this.MeshWarningTracker.forEach(mesh => {
                if (mesh.isEnabled) {
                    if (mesh.featureNumber > 15) {
                        tempWarning = `Performance Warning: The number of features on ${mesh.name} is higher than recommended for optimal performance.`;
                        this.meshWarningMessages.push(tempWarning);
                        if (this.isDevEnvironment) {
                            console.warn(tempWarning);
                        }
                    }
                    if (mesh.castShadows && mesh.receiveShadows) {
                        meshCastAndReceiveShadows += 1;
                    }
                }
            });
            if (this.totalPolygons > 500000) {
                tempWarning = `Performance Warning: Polygon count of ${this.totalPolygons} is higher than recommended for optimal performance.`;
                this.meshWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
            if (meshCastAndReceiveShadows > 10) {
                tempWarning = `Performance Warning: The number of meshes that cast and receive shadows (${meshCastAndReceiveShadows}) is higher than recommended for optimal performance.`;
                this.meshWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
            this.updateWarnings();
        }
        updateNormalSmoothingWarnings(feature, polygonCount, removed) {
            var _a;
            if (removed) {
                this.normalSmoothingWarnings.delete(feature.id);
            }
            else {
                if (polygonCount > 100000 && feature.enabled) {
                    const warning = `Performance Warning: Too many polygons (${polygonCount}) are selected inside "${feature.name}" on "${(_a = feature._parent) === null || _a === void 0 ? void 0 : _a.name}".`;
                    this.normalSmoothingWarnings.set(feature.id, warning);
                    if (this.isDevEnvironment) {
                        console.warn(warning);
                    }
                }
                else {
                    this.normalSmoothingWarnings.delete(feature.id);
                }
            }
            this.updateWarnings;
        }
        updateMaterialWarnings() {
            let tempWarning = '';
            const localMaterialCount = this.getLocalMaterialsRecursive(this.sceneNode);
            this.materialWarningMessages = [];
            if (localMaterialCount > 20) {
                tempWarning = `Performance Warning: The number of local materials (${localMaterialCount}) is higher than recommended for optimal performance.`;
                this.materialWarningMessages.push(tempWarning);
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
        }
        updateAnimationWarnings(activeAnimations) {
            let tempWarning = '';
            if (activeAnimations > 1) {
                tempWarning = `Performance Warning: More than 1 animation (${activeAnimations}) is active at the same instance.`;
                if (this.isDevEnvironment) {
                    console.warn(tempWarning);
                }
            }
        }
        updateWarnings() {
            const tempArray = [];
            if (this.lightsWarningMessages && this.lightsWarningMessages.length > 0) {
                this.lightsWarningMessages.forEach(warning => {
                    tempArray.push(warning);
                });
            }
            if (this.textureWarningMessages && this.textureWarningMessages.length > 0) {
                this.textureWarningMessages.forEach(warning => {
                    tempArray.push(warning);
                });
            }
            if (this.meshWarningMessages && this.meshWarningMessages.length > 0) {
                this.meshWarningMessages.forEach(warning => {
                    tempArray.push(warning);
                });
            }
            if (this.materialWarningMessages && this.materialWarningMessages.length > 0) {
                this.materialWarningMessages.forEach(warning => {
                    tempArray.push(warning);
                });
            }
            if (this.normalSmoothingWarnings && this.normalSmoothingWarnings.size > 0) {
                this.normalSmoothingWarnings.forEach(warning => {
                    tempArray.push(warning);
                });
            }
            if (tempArray.length === 0) {
                tempArray.push('No warnings to display.');
            }
            this.warningMessages = tempArray;
            this.warningTracker.next();
        }
        extractMeshGeometry(node) {
            const mesh = this.rendererManager.mesh.get3d(node);
            if (mesh && mesh instanceof Mesh && mesh.geometry) {
                const newGeometry = new exports.KbGeometry();
                newGeometry.indices = new Uint32Array(mesh.geometry.getIndices() || []);
                newGeometry.positions = new Float32Array(mesh.geometry.getVerticesData(VertexBuffer.PositionKind) || []);
                if (newGeometry.indices.length === 0 || newGeometry.positions.length === 0) {
                    return null;
                }
                const normals = mesh.geometry.getVerticesData(VertexBuffer.NormalKind);
                if (normals) {
                    newGeometry.normals = new Float32Array(normals);
                }
                const tangents = mesh.geometry.getVerticesData(VertexBuffer.TangentKind);
                if (tangents) {
                    newGeometry.tangents = new Float32Array(tangents);
                }
                const uvs = mesh.geometry.getVerticesData(VertexBuffer.UVKind);
                if (uvs) {
                    newGeometry.uvs = new Float32Array(uvs);
                }
                return newGeometry;
            }
        }
        applySvgToSketch(node, data) {
            return SvgConverter.overwriteSketchWithSvg(node, data);
        }
        draggingEvent(mousePosition) {
            let lastPickedMesh;
            const dragOver = new Subject();
            mousePosition.subscribe(position => {
                const pickInfo = this.interaction.pick(position.x, position.y);
                const mesh = pickInfo === null || pickInfo === void 0 ? void 0 : pickInfo.targetNode;
                if (lastPickedMesh !== mesh) {
                    if (lastPickedMesh) {
                        this.highlighter.remove(lastPickedMesh);
                    }
                    if (mesh) {
                        this.highlighter.add(mesh, exports.KbColor.Green());
                    }
                    dragOver.next(mesh);
                    lastPickedMesh = mesh;
                }
            }, () => { }, () => {
                if (lastPickedMesh) {
                    this.highlighter.remove(lastPickedMesh);
                    dragOver.complete();
                }
            });
            return dragOver.asObservable();
        }
        dispose() {
            this.disposed = true;
            this.positionTrackedNodes.clear();
            this.rendererManager.disposeAll();
            this.scene.dispose();
            this.engine.dispose();
            this.camera.dispose();
            this.manager.dispose();
            this.bbCache.dispose();
            this.sketchEditor.dispose();
            if (this.canvas) {
                this.container.removeChild(this.canvas);
                delete this.canvas;
            }
            if (this.uiOverlay) {
                this.container.removeChild(this.uiOverlay);
                delete this.uiOverlay;
            }
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                delete this.resizeObserver;
            }
            this.fpsTracker.complete();
            this.polygonTracker.complete();
            this.warningTracker.complete();
            this.meshWarningsNeedsUpdate.complete();
            this.materialWarningsNeedsUpdate.complete();
            this.animationWarningsNeedsUpdate.complete();
        }
        getScreenPositionOfNode(node) {
            const bNode = this.rendererManager.mesh.get3d(node);
            if (bNode) {
                return nodeToScreen(bNode, this.scene.activeCamera);
            }
        }
        getScreenBoundingBoxOfNode(node) {
            const bNode = this.rendererManager.mesh.get3d(node);
            if (bNode) {
                return getScreenBoundingBox(bNode, this.scene.activeCamera, true);
            }
        }
        getBabylonJson() {
            return JSON.stringify(SceneSerializer.Serialize(this.scene), null, 2);
        }
        exportGlb() {
            var _a;
            return this.gltfExporter.exportGlb((_a = this.sceneNode) === null || _a === void 0 ? void 0 : _a.name);
        }
        exportObj(meshNode) {
            var _a;
            const fileName = meshNode ? meshNode.name : (_a = this.sceneNode) === null || _a === void 0 ? void 0 : _a.name;
            return this.objExporter.exportObj(fileName, meshNode);
        }
        //returns an object containing the polygons and vertices withing the selected node
        recursiveGetPolygons(node) {
            if (node.visible == false) {
                return { polygons: 0, vertices: 0 };
            }
            if (node instanceof exports.MeshNode) {
                return { polygons: node._polygonCount || 0, vertices: node._verticesCount || 0 };
            }
            const result = { polygons: 0, vertices: 0 };
            const children = node.getChildren();
            children.forEach(child => {
                if (child instanceof exports.MeshNode || child instanceof exports.MeshGroupNode) {
                    const childData = this.recursiveGetPolygons(child);
                    result.polygons += childData.polygons;
                    result.vertices += childData.vertices;
                }
            });
            return result;
        }
        //call with null
        onNextFrame(func) {
            this.nextFrameCallbacks.push(func);
        }
        userIsInteracting() {
            return this.interaction.pointerIsDown || this.gizmos.dragging;
        }
        /** runs the kb3d renderers.  Called before the babylon render */
        preRender() {
            // If this kb viewer instance is disposed, exit the render loop
            if (this.disposed) {
                return;
            }
            this.bbCache.update(); //update watchers of the bbcache of everything that changed since the last frame
            this.animation.update(); //update all animations.  This can result in changes, so should be called before the check for changes
            if (!this.rendererManager.isStable()) {
                /** nodes must be processed in a specific order.  For example, materials must be processed before meshes,
                 *  or a new material wouldn't exist yet in babylon when the mesh renderer tries to apply it.
                 */
                const hasChanges = SyncService.hasChanges;
                this.rendererManager.render();
                this.gizmos.updateGizmoPositions();
                //if there were changes, force a babylon render asap to keep responsive
                if (hasChanges) {
                    this.forceRenderOnNextFrame = true;
                }
                this.viewChanged.next();
                while (this.nextFrameCallbacks.length > 0) {
                    this.nextFrameCallbacks.pop()();
                }
                nextTick();
            }
        }
        startRender() {
            if (!this._renderLoopRunning) {
                this._renderLoopRunning = true;
                let frameCount = 0;
                // Run the render loop.
                this.engine.runRenderLoop(() => {
                    this.preRender();
                    let skipped = true;
                    if (!this.pauseRender) {
                        frameCount++;
                        if (this.forceRunRenderer ||
                            this.forceRenderOnNextFrame ||
                            this.userIsInteracting() ||
                            this.camera.cameraMoving ||
                            this.animation.animationsAreRunning ||
                            this.ar.xrActive) {
                            this.scene.render();
                            this.forceRenderOnNextFrame = false;
                            this.viewChanged.next();
                            skipped = false;
                        }
                        else if (frameCount > 10) {
                            this.scene.render();
                            skipped = false;
                        }
                        if (frameCount > 10) {
                            frameCount = 0;
                            this.fpsTracker.next(this.getFPS());
                        }
                        this.afterRender.next({ skipped });
                    }
                });
            }
        }
        stopRender() {
            this.engine.stopRenderLoop();
            this._renderLoopRunning = false;
        }
        createCanvas() {
            const canvas = document.createElement('canvas');
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            canvas.style.outline = 'none';
            canvas.style.opacity = '0';
            canvas.style.transition = `opacity ${FADE_TIME}ms linear`;
            this.container.appendChild(canvas);
            if (!this.container.style.position) {
                this.container.style.position = 'relative';
            }
            this.uiOverlay = this.createOverlay();
            this.container.appendChild(this.uiOverlay);
            this.resizeObserver = new ResizeObserver(() => this.resize());
            this.resizeObserver.observe(canvas);
            return canvas;
        }
        createOverlay() {
            const overlay = document.createElement('div');
            overlay.style.position = 'absolute';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.pointerEvents = 'none';
            return overlay;
        }
        createLoadingExperience(loadingExperience, loadingImagePath) {
            if (loadingExperience == exports.eLoadingExperience.image) {
                const matService = this.manager.getService(Token.MaterialService);
                this.loadingOverlay = this.createOverlay();
                this.loadingOverlay.style.opacity = '0';
                this.loadingOverlay.style.transition = `opacity ${FADE_TIME}ms linear`;
                const img = document.createElement('img');
                img.style.position = 'absolute';
                img.style.width = '100%';
                img.style.height = '100%';
                img.style.backgroundSize = 'auto 100%';
                img.style.backgroundRepeat = 'no-repeat';
                img.style.backgroundPosition = 'center';
                img.style.backgroundColor = 'transparent';
                img.style.backgroundImage = `url('${matService.getAbsoluteTexturePath(loadingImagePath)}')`;
                this.loadingOverlay.appendChild(img);
                this.container.appendChild(this.loadingOverlay);
                this.loadingOverlay.style.opacity = '1';
            }
            else if (loadingExperience == exports.eLoadingExperience.fade) ;
            else if (loadingExperience == exports.eLoadingExperience.spinner) {
                this.loadingOverlay = this.createOverlay();
                this.loadingOverlay.style.opacity = '0';
                this.loadingOverlay.style.transition = `opacity ${FADE_TIME}ms linear`;
                this.loadingOverlay.style.display = 'flex';
                this.loadingOverlay.style.alignItems = 'center';
                this.loadingOverlay.style.justifyContent = 'center';
                this.loadingOverlay.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" class="kb-svg-spinner" viewBox="0 0 50 50">
                <circle cx="50%" cy="50%" r="20" fill="none"  />
                <circle cx="50%" cy="50%" r="20" fill="none"  />
                <circle cx="50%" cy="50%" r="20" fill="none"  />
            </svg>`;
                this.container.appendChild(this.loadingOverlay);
                this.loadingOverlay.style.opacity = '1';
            }
            else {
                this.canvas.style.opacity = '1';
            }
        }
        hideLoadingExperience() {
            if (this.loadingOverlay) {
                this.loadingOverlay.style.opacity = '0';
                setTimeout(() => {
                    var _a;
                    (_a = this.loadingOverlay) === null || _a === void 0 ? void 0 : _a.remove();
                    this.loadingOverlay = undefined;
                }, FADE_TIME);
            }
            this.canvas.style.opacity = '1';
        }
        resize() {
            if (!this.ar || (!this.ar.xrLoading && !this.ar.xrActive)) {
                //don't mess with the AR canvas resize
                this.engine.resize();
                this.fireViewChangedOnNextRender();
            }
        }
        optimizeScene(scene) {
            if (this.sceneNode.enableSceneOptimization) {
                this.forceRunRenderer = true; // Run renderer until optimizer is done optimizing
                const sceneOptimizerOptions = new SceneOptimizerOptions(30, 2000);
                let priority = 0;
                sceneOptimizerOptions.addCustomOptimization(function () {
                    console.warn('Low scene performance detected - disabling 3d features to improve performance.');
                    return true;
                }, function () {
                    return 'custom optimization to throw console warning when optimizer needs to run.';
                }, priority);
                sceneOptimizerOptions.optimizations.push(new ShadowsOptimization(priority));
                sceneOptimizerOptions.optimizations.push(new LensFlaresOptimization(priority));
                // Next priority
                priority++;
                sceneOptimizerOptions.optimizations.push(new PostProcessesOptimization(priority));
                sceneOptimizerOptions.optimizations.push(new ParticlesOptimization(priority));
                priority++;
                sceneOptimizerOptions.optimizations.push(new TextureOptimization(priority, 256));
                priority++;
                sceneOptimizerOptions.optimizations.push(new RenderTargetsOptimization(priority));
                // Don't scale the resolution when in editor mode because it affects usability
                if (!this.options.editorMode) {
                    priority++;
                    sceneOptimizerOptions.optimizations.push(new HardwareScalingOptimization(priority, 4));
                }
                const sceneOptimizer = new SceneOptimizer(scene, sceneOptimizerOptions, false);
                sceneOptimizer.onSuccessObservable.add(() => {
                    this.startSceneRenderAutoStop(scene, this.engine);
                    // Run optimizer in improvement mode in case the scene speeds up later
                    new SceneOptimizer(scene, sceneOptimizerOptions, false, true);
                });
                sceneOptimizer.onFailureObservable.add(() => this.startSceneRenderAutoStop(scene, this.engine));
                sceneOptimizer.start();
            }
        }
        createScene() {
            // Create a basic BJS Scene object.
            const scene = new Scene(this.engine);
            scene.useRightHandedSystem = true;
            scene.clearColor = new Color4(0, 0, 0, 0); //default background to transparent
            // Create a FreeCamera, and set its position to (x:0, y:5, z:-10).
            //this.m_camera = new FreeCamera('camera1', new Vector3(0, 5, -10), this.m_scene);
            //scene.createDefaultCameraOrLight(true, true, true);
            this.createDefaultEnv();
            return scene;
        }
        startSceneRenderAutoStop(scene, engine) {
            this.forceRunRenderer = false;
        }
        createDefaultEnv() {
            if (!this.scene) {
                return;
            }
            const helper = this.scene.createDefaultEnvironment({
                skyboxSize: 500,
                groundShadowLevel: 0.5,
            });
            if (helper !== null && helper.skybox !== null && helper.ground !== null) {
                helper.setMainColor(Color3.Gray());
                helper.rootMesh.position.y = -5;
                helper.skybox.isPickable = false;
                helper.rootMesh.isPickable = false;
                helper.ground.isPickable = false;
                //helper.rootMesh.name = KbViewer.KBMAXPREFIX + helper.rootMesh.name;
                //helper.skybox.name = KbViewer.KBMAXPREFIX + helper.skybox.name;
                for (let i = 0; i < this.scene.meshes.length; i++) {
                    this.scene.meshes[i].name = KBMAXPREFIX + this.scene.meshes[i].name;
                    this.scene.meshes[i].id = KBMAXPREFIX + this.scene.meshes[i].id;
                }
            }
        }
        pauseRenderWhile(action) {
            this.pauseRender = true;
            action();
            this.pauseRender = false;
        }
        /**
         * returns a promise that is resolved when the following has happened:
         * * the scene graph is fully loaded
         * * at least one pass through the render loop since the scene has been loaded has completed
         * * any server assets in flight (meshes, textures) have been received and processed
         */
        whenAssetsLoaded(waitForMaterials = true) {
            if (!this.sceneNode) {
                throw Error('a scene needs to be loaded into the viewer to wait for assets');
            }
            const promise = new Promise((resolve, reject) => {
                var _a, _b;
                const http = (_a = this.sceneNode._manager) === null || _a === void 0 ? void 0 : _a.getService(Token.HttpService);
                const materialService = (_b = this.sceneNode._manager) === null || _b === void 0 ? void 0 : _b.getService(Token.MaterialService);
                if (!http) {
                    throw Error('HTTP API service could not be initialized');
                }
                if (!materialService) {
                    throw Error('Material service could not be initialized');
                }
                this.forceAndWaitForNextRender().then(() => {
                    const promises = [
                        ...http.trackedAssetCalls,
                        ...this.additionalLoadBlockers,
                        this.scene.whenReadyAsync(),
                    ];
                    if (waitForMaterials) {
                        promises.push(...materialService.trackedAssetCalls);
                    }
                    Promise.all(promises).finally(() => {
                        // now wait for a render loop and make sure no new loading blockers were added since the last batch
                        this.forceAndWaitForNextRender().then(() => {
                            if (http.trackedAssetCalls.length ||
                                this.additionalLoadBlockers.length ||
                                (waitForMaterials && materialService.trackedAssetCalls.length) ||
                                !this.scene.isReady() ||
                                !this.rendererManager.isStable()) {
                                return this.whenAssetsLoaded(waitForMaterials).finally(() => {
                                    resolve();
                                });
                            }
                            else {
                                resolve();
                            }
                        });
                    });
                });
            });
            return promise;
        }
        deferSceneReady(promise) {
            promise.then(() => {
                this.additionalLoadBlockers = this.additionalLoadBlockers.filter(somePromise => somePromise !== promise);
            });
            this.additionalLoadBlockers.push(promise);
        }
        /**
         * Returns a promise that resolves when the next kb3d render processing has happened.
         * Note that this does not necessarily mean that the babylon render has happened!
         * If you want to wait for both, see forceAndWaitForNextRender
         */
        waitForNextKb3dRender() {
            return this.afterRender.pipe(take(1)).toPromise();
        }
        forceAndWaitForNextRender() {
            this.forceRenderOnNextFrame = true;
            return this.waitForNextKb3dRender();
        }
        async waitForStableRender(timeout = 5000) {
            const start = performance.now();
            await this.forceAndWaitForNextRender();
            while (!this.rendererManager.isStable()) {
                await this.forceAndWaitForNextRender();
                if (performance.now() - start > timeout) {
                    console.error(`waiting for stable render took longer than timeout of ${timeout}ms, unblocking loading`);
                    return false;
                }
            }
            return true;
        }
        fireViewChangedOnNextRender() {
            this.forceAndWaitForNextRender().then(() => {
                this.viewChanged.next();
            });
        }
        getActiveMates() {
            const mates = new Array();
            this.sceneNode.runOnAllScenes(s => {
                mates.push(...s._manager.getByToken(Token.MateNode).filter(m => m.isActive()));
            });
            return mates;
        }
        nodesIntersect(node1, node2) {
            const bb1 = this.bbCache.getWorld(node1);
            const bb2 = this.bbCache.getWorld(node2);
            if (bb1 && bb2) {
                return bb1.boundingInfo.intersects(bb2.boundingInfo, false);
            }
            return false;
        }
        getReferenceNodes(dynamicId) {
            var _a;
            const result = [];
            const references = this.rendererManager.referenceProcessor.getReferencesTo();
            if (references.has(dynamicId)) {
                const ids = (_a = references.get(dynamicId)) === null || _a === void 0 ? void 0 : _a.keys();
                if (ids) {
                    for (const key of ids) {
                        result.push(this.manager.getById(key));
                    }
                }
                return result;
            }
            else {
                return [];
            }
        }
        getLocalMaterialsRecursive(node) {
            let result = 0;
            if (!node.scenes) {
                return node.materials.length | 0;
            }
            else {
                node.scenes.forEach(scene => {
                    result += this.getLocalMaterialsRecursive(scene);
                });
                result += node.materials.length;
            }
            return result;
        }
        getTransformSpaceDifference(originNode, destinationNode) {
            const originMesh = this.getRendererNode(originNode);
            const destinationMesh = this.getRendererNode(destinationNode);
            const result = {
                scale: Vector3.One(),
                rotationQuaternion: new Quaternion(),
                translation: Vector3.Zero(),
            };
            if (!destinationMesh) {
                const resultMatrix = originMesh.getWorldMatrix();
                resultMatrix.decompose(result.scale, result.rotationQuaternion, result.translation);
            }
            else if (originMesh && destinationMesh) {
                const originMatrix = originMesh.getWorldMatrix();
                const destinationMatrix = destinationMesh.getWorldMatrix().clone();
                destinationMatrix.invert();
                const resultMatrix = originMatrix.multiply(destinationMatrix);
                resultMatrix.decompose(result.scale, result.rotationQuaternion, result.translation);
            }
            else {
                return null;
            }
            return {
                scale: result.scale.x,
                rotationQuaternion: exports.KbQuaternion.FromQuat(result.rotationQuaternion),
                translation: exports.KbVector.FromVec3(result.translation),
            };
        }
        centerMeshToOrigin(node) {
            const boundingBox = this.getMeshBoundingBox(node);
            const center = boundingBox === null || boundingBox === void 0 ? void 0 : boundingBox.maxWorld.add(boundingBox.minWorld);
            if (center) {
                center === null || center === void 0 ? void 0 : center.scaleInPlace(-0.5);
                const result = new exports.KbVector(center.x, center.y, center.z);
                return result;
            }
            else {
                return new exports.KbVector(0, 0, 0);
            }
        }
    }

    function kb3dTest() {
        let map = new SetMap();
        map.add('A', 'B', 'C');
        map.add('B', 'C', 'D');
        map.add('C', 'E');
        map.add('D', 'E', 'F');
        map.add('E');
        map.add('F');
        map.add('G', 'F', 'E');
        topologicalSort(map, s => s);
        map = new SetMap();
        map.add('0', '1', '2');
        map.add('1', '2');
        map.add('2', '0', '3');
        map.add('3');
        topologicalSort(map, s => s);
        map = new SetMap();
        map.add('2');
        map.add('3', '8', '10');
        map.add('5', '11');
        map.add('7', '8', '11');
        map.add('8', '9');
        map.add('9');
        map.add('10');
        map.add('11', '2', '9', '10');
        topologicalSort(map, s => s);
        const kbViewer = new KbViewer({ container: document.getElementById('viewer-div') });
        let manager = new Kb3dManager({ assetRoot: '' }); //default services automatically used
        let sceneNode = manager.create(Token.SceneNode);
        sceneNode.backgroundColor = new exports.KbColor(0.9, 0.9, 0.9, 1);
        sceneNode.enableHoverEffects = true;
        kbViewer.loadScene({ sceneNode });
        const group = manager.create(Token.MeshGroupNode);
        const box = manager.create(Token.BoxNode);
        const boxId = box.id;
        group.meshes.push(box);
        // let blah = manager.getById(boxId);
        // let db = manager.getAll().map(n => { return { id: n.id, name: n.name, type: n.$type }; });
        // alert(JSON.stringify(db, null, 2));
        // sceneNode.meshes.push(group);
        // db = manager.getAll().map(n => { return { id: n.id, name: n.name, type: n.$type }; });
        // alert(JSON.stringify(db, null, 2));
        // setTimeout(() => {
        //     sceneNode.meshes.remove(group);
        //     db = manager.getAll().map(n => { return { id: n.id, name: n.name, type: n.$type }; });
        //     alert(JSON.stringify(db, null, 2));
        // }, 500);
        //sceneNode.meshes.push(box);
        // function animate(time: number) {
        //     requestAnimationFrame(animate);
        //     TWEEN.update(time);
        // }
        // requestAnimationFrame(animate);
        // let pos = { x: box.position.x, y: box.position.y, z: box.position.z };
        // const anim = new TWEEN.Tween(pos)
        //     .to({ x: 3, y: 0, z: 0 }, 5000)
        //     .onUpdate(() => {
        //         box.position = KbVector.From(pos);
        //     })
        //     .start();
        // let group = manager.create(Token.MeshGroupNode);
        // group.rotation = new KbVector(0, 0, 0);
        // sceneNode.meshes.push(group);
        // let box = manager.create(Token.BoxNode);
        // let boxId = box.id;
        // box.materialId = "bricks01";
        // group.meshes.push(box);
        // let conn1 = manager.create(Token.Connector, {
        //     positionMode: eConnectorPositionMode.boundingBox,
        //     position: new KbVector(0, 1, 1),
        //     direction: new KbVector(0, 0, 1)
        // });
        // box.features.push(conn1);
        // let mat = manager.create(Token.AdvancedMaterialNode, {
        //     albedoColor: new KbColor(1, 0, 0),
        //     backFaceCulling: false
        // });
        // sceneNode.materials.push(mat);
        // box.materialId = mat.id;
        // let sphere = manager.create(Token.SphereNode, {
        //     diameter: 1,
        //     position: new KbVector(2, 0,0)
        // });
        // group.meshes.push(sphere);
        // let box2 = manager.create(Token.BoxNode);
        // sceneNode.meshes.push(box2);
        // box2.position = new KbVector(0, 0, 3);
        // box2.width = 2;
        // let conn3 = manager.create(Token.Connector, {
        //     positionMode: eConnectorPositionMode.absolute,
        //     position: new KbVector(0, 0, -0.5),
        //     direction: new KbVector(0, 0, -1),
        //     angle: 0
        // });
        // let conn4 = manager.create(Token.Connector, {
        //     positionMode: eConnectorPositionMode.absolute,
        //     position: new KbVector(1, 0, 0),
        //     direction: new KbVector(1, 0, 0),
        //     angle: 30
        // });
        // let conn5 = manager.create(Token.Connector, {
        //     positionMode: eConnectorPositionMode.absolute,
        //     position: new KbVector(0, .5, 0),
        //     direction: new KbVector(0, 1, 0),
        //     angle: 0
        // });
        // box2.features.push(conn3);
        // box2.features.push(conn4);
        // box2.features.push(conn5);
        // manager.draggables.add(group.id, "blah", {
        //     mode: eDragMode.free,
        //     //surfaceNodes: [sphere.id, sphere2.id],
        //     planeNormal: new KbVector(0, 1, 0),
        //     // planeOrigin: new KbVector(0,0,0),
        //     //disableOffset: false,
        //     connectionMode: eConnectionMode.screen,
        //     showConnectors: true,
        //     connectRadius: 10,
        //     dragOpacity: .3,
        //     dragStart: (a) => {
        //     },
        //     dragging: (a) => {
        //     },
        //     dropped: (a) => {
        //     },
        //     // canConnect: (a) => {
        //     //     a.
        //     // }
        // });
        // kbViewer.interaction.onPointerUp.subscribe(p => {
        //     console.log(kbViewer.getScreenPositionOfNode(box));
        //     console.log(kbViewer.getScreenBoundingBoxOfNode(box));
        // });
        const light = manager.create(Token.DirectionalLightNode);
        sceneNode.lights.push(light);
        // let mat = manager.create(tok.AdvancedMaterialNode, {
        //     albedoColor: new KbColor(252, 0, 0)
        // });
        // sceneNode.materials.push(mat);
        // box.materialId = mat.id;
        //box.materialId = "4454a0e3-e1e4-42d4-aea5-6915681bfc12";
        // for (let row = 0; row < 10; row++){
        //     for (let col = 0; col < 10; col++) {
        //         let nested = manager.nestScene(sceneNode);
        //         nested.name = "nested" + row;
        //         let nestedManager = nested._manager as Kb3dManager;
        //         let nestedBox = nestedManager.create(tok.BoxNode);
        //         nestedBox.name = "nestedBox" + row;
        //         if (row % 2 > 0) {
        //             nestedBox.materialId = "rock01";
        //         } else {
        //             nestedBox.materialId = "bricks01";
        //         }
        //         nested.meshes.push(nestedBox);
        //         nested.position = new KbVector(row * 1.5, col * 1.5, 0);
        //     }
        // }
        kbViewer.interaction.onClick.subscribe(p => {
            console.log(p);
        });
        kbViewer.interaction.onKeyboard.subscribe(k => {
            console.log(k);
        });
        const btnAnimate = document.getElementById('btnAnimate');
        if (btnAnimate) {
            btnAnimate.onclick = () => {
                kbViewer.animation
                    .queue({
                    name: 'a1',
                    node: box,
                    prop: 'position',
                    toValue: new exports.KbVector(10, 0, 0),
                    duration: 1000,
                    easing: exports.eEasing.quadraticIn,
                })
                    .then(() => {
                    return kbViewer.animation.queue({
                        name: 'a2',
                        node: box,
                        prop: 'rotation',
                        toValue: new exports.KbVector(box.eulerRotation.x + 720, 0, 0),
                        duration: 1000,
                    });
                })
                    .then(() => {
                    return kbViewer.animation.queue({
                        name: 'a3',
                        node: box,
                        prop: 'position',
                        toValue: new exports.KbVector(0, 0, 0),
                        duration: 1000,
                        easing: exports.eEasing.quadraticOut,
                    });
                });
            };
        }
        const btnStop = document.getElementById('btnStop');
        if (btnStop) {
            btnStop.onclick = () => {
                kbViewer.animation.stop('a1');
            };
        }
        const txtJson = document.getElementById('txtJson');
        const txtCounter = document.getElementById('txtCounter');
        const btnToJson = document.getElementById('btnToJson');
        if (btnToJson) {
            btnToJson.onclick = () => {
                txtJson.value = manager.serializeToJson(sceneNode, { prettyPrint: true });
                updateJsonLength();
            };
        }
        const btnToFullJson = document.getElementById('btnToFullJson');
        if (btnToFullJson) {
            btnToFullJson.onclick = () => {
                txtJson.value = manager.serializeToJson(sceneNode, { omitDefaultValues: false, prettyPrint: true });
                updateJsonLength();
            };
        }
        const btnFromJson = document.getElementById('btnFromJson');
        if (btnFromJson) {
            btnFromJson.onclick = () => {
                manager = new Kb3dManager();
                const jsonObject = JSON.parse(txtJson.value);
                sceneNode = manager.create(Token.SceneNode, jsonObject);
                kbViewer.loadScene({ sceneNode });
            };
        }
        const btnBabylonJson = document.getElementById('btnBabylonJson');
        if (btnBabylonJson) {
            btnBabylonJson.onclick = () => {
                txtJson.value = kbViewer.getBabylonJson();
            };
        }
        const btnWidth = document.getElementById('btnWidth');
        if (btnWidth) {
            btnWidth.onclick = () => {
                box.depth = box.depth + 1;
            };
        }
        const btnMaterialColor = document.getElementById('btnMaterialColor');
        if (btnMaterialColor) {
            btnMaterialColor.onclick = () => {
                //mat.albedoColor = new KbColor(0, 0, 252);
            };
        }
        // let btnToggleVisible = document.getElementById("btnToggleVisible");
        // if (btnToggleVisible) {
        //     btnToggleVisible.onclick = () => {
        //         box.visible = !box.visible;
        //     };
        // }
        const btnSaveMesh = document.getElementById('btnSaveMesh');
        if (btnSaveMesh) {
            btnSaveMesh.onclick = () => {
                const myArray = new ArrayBuffer(512);
                const longInt8View = new Uint8Array(myArray);
                // generate some data
                for (let i = 0; i < longInt8View.length; i++) {
                    longInt8View[i] = i % 256;
                }
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/meshes/72b7487f-2ab2-4faf-b034-a1178feeb191', false);
                xhr.send(myArray);
            };
        }
        const btnGetSavedMesh = document.getElementById('btnGetSavedMesh');
        if (btnGetSavedMesh) {
            btnGetSavedMesh.onclick = () => {
                const oReq = new XMLHttpRequest();
                oReq.open('GET', '/api/meshes/72b7487f-2ab2-4faf-b034-a1178feeb191', true);
                oReq.responseType = 'arraybuffer';
                oReq.onload = function (oEvent) {
                    const arrayBuffer = oReq.response; // Note: not oReq.responseText
                    if (arrayBuffer) {
                        const byteArray = new Uint8Array(arrayBuffer);
                        for (let i = 0; i < byteArray.byteLength; i++) {
                            // do something with each byte in the array
                            console.log(byteArray[i]);
                        }
                    }
                };
                oReq.send(null);
            };
        }
        const updateJsonLength = () => {
            txtCounter.innerHTML = new TextEncoder().encode(txtJson.value).length.toString() + ' bytes';
        };
    }

    const kb3dEnums = _kb3dEnums;

    exports.ABORTED = ABORTED;
    exports.ALL_CHANGES = ALL_CHANGES;
    exports.ALL_GEOMETRY = ALL_GEOMETRY;
    exports.AR = AR;
    exports.AUTO_MESH_NAME = AUTO_MESH_NAME;
    exports.AnimationModule = AnimationModule;
    exports.AnnotationRenderer = AnnotationRenderer;
    exports.ArrayMap = ArrayMap;
    exports.BaseKb3dModel = BaseKb3dModel;
    exports.Boundary = Boundary;
    exports.BoundingBoxCache = BoundingBoxCache;
    exports.BoundingBoxRelativeHelper = BoundingBoxRelativeHelperKbVector;
    exports.CONNECTOR_DIAM = CONNECTOR_DIAM;
    exports.CameraTools = CameraTools;
    exports.ChangeMap = ChangeMap;
    exports.ColorFillTextureLayerRenderer = ColorFillTextureLayerRenderer;
    exports.ConnectorRenderer = ConnectorRenderer;
    exports.DimensionRenderer = DimensionRenderer;
    exports.Dragger = Dragger;
    exports.Enumerable = Enumerable;
    exports.FileTextureLayerRenderer = FileTextureLayerRenderer;
    exports.FontService = FontService;
    exports.GLTFKb3dExporter = GLTFKb3dExporter;
    exports.GizmoTools = GizmoTools;
    exports.GuiHelper = GuiHelper;
    exports.HandlerMap = HandlerMap;
    exports.HttpService = HttpService;
    exports.Ignore = Ignore;
    exports.IgnoreChanges = IgnoreChanges;
    exports.IgnoreHistory = IgnoreHistory;
    exports.Inject = Inject;
    exports.Interaction = Interaction;
    exports.KBMAXPREFIX = KBMAXPREFIX;
    exports.Kb3dManager = Kb3dManager;
    exports.Kb3dModel = Kb3dModel;
    exports.Kb3dModels = Kb3dModels;
    exports.Kb3dService = Kb3dService;
    exports.Kb3dWorker = Kb3dWorker;
    exports.KbAxisDragGizmo = KbAxisDragGizmo;
    exports.KbAxisScaleGizmo = KbAxisScaleGizmo;
    exports.KbGizmo = KbGizmo;
    exports.KbLightGizmo = KbLightGizmo;
    exports.KbPlaneRotationGizmo = KbPlaneRotationGizmo;
    exports.KbPositionGizmo = KbPositionGizmo;
    exports.KbRotationGizmo = KbRotationGizmo;
    exports.KbScaleGizmo = KbScaleGizmo;
    exports.KbVertexSelectGizmo = KbVertexSelectGizmo;
    exports.KbViewer = KbViewer;
    exports.KbViewpointGizmo = KbViewpointGizmo;
    exports.LOCAL_ENVIRONMENT_DOMAIN = LOCAL_ENVIRONMENT_DOMAIN;
    exports.LibraryEnvironments = LibraryEnvironments;
    exports.LibraryEnvironmentsMap = LibraryEnvironmentsMap;
    exports.LibraryMaterials = LibraryMaterials;
    exports.LibraryMaterialsByCategory = LibraryMaterialsByCategory;
    exports.LightRenderer = LightRenderer;
    exports.MateProcessor = MateProcessor;
    exports.MateRenderer = MateRenderer;
    exports.MaterialRenderer = MaterialRenderer;
    exports.MeshRenderer = MeshRenderer;
    exports.MeshService = MeshService;
    exports.MoveVerticesRenderer = MoveVerticesRenderer;
    exports.NEW_GEOMETRY = NEW_GEOMETRY;
    exports.NodeReference = NodeReference;
    exports.NormalSmoothingRenderer = NormalSmoothingRenderer;
    exports.ObjKb3dExporter = ObjKb3dExporter;
    exports.PRECISION = PRECISION;
    exports.PathHandler = PathHandler;
    exports.PathParser = PathParser;
    exports.PathRenderer = PathRenderer;
    exports.PatternFeature = PatternFeature;
    exports.PatternRenderer = PatternRenderer;
    exports.Processor = Processor;
    exports.Quad = Quad;
    exports.QuadTree = QuadTree;
    exports.RendererManager = RendererManager;
    exports.SKYBOX_SIZE = SKYBOX_SIZE;
    exports.SamplingModeMap = SamplingModeMap;
    exports.SceneRenderer = SceneRenderer;
    exports.SetMap = SetMap;
    exports.ShadowLightNode = ShadowLightNode;
    exports.SketchEditor = SketchEditor;
    exports.SnapshotModule = SnapshotModule;
    exports.SubmeshRenderer = SubmeshRenderer;
    exports.SvgConverter = SvgConverter;
    exports.SvgTextureLayerRenderer = SvgTextureLayerRenderer;
    exports.SyncService = SyncService;
    exports.TagArrayMap = TagArrayMap;
    exports.TextMeshFont = TextMeshFont;
    exports.TextMeshVertexData = TextMeshVertexData;
    exports.TextureLayerRenderer = TextureLayerRenderer;
    exports.Token = Token;
    exports.TrackChanges = TrackChanges;
    exports.TrackChangesNode = TrackChangesNode;
    exports.USDZConverter = USDZConverter;
    exports.UUID = UUID;
    exports.UVMapHelper = UVMapHelper;
    exports.UvMapRenderer = UvMapRenderer;
    exports.Validator = Validator;
    exports.ViewpointRenderer = ViewpointRenderer;
    exports.absoluteUrlRegex = absoluteUrlRegex;
    exports.addArrays = addArrays;
    exports.appendOrIncrementNumber = appendOrIncrementNumber;
    exports.applyMatrix4 = applyMatrix4;
    exports.applyTransformToSpace = applyTransformToSpace;
    exports.applyTransformToVector = applyTransformToVector;
    exports.axisToVector3 = axisToVector3;
    exports.bakeMeshTransform = bakeMeshTransform;
    exports.boundingVectorsToScreen = boundingVectorsToScreen;
    exports.buildHeader = buildHeader;
    exports.buildUSDAFile = buildUSDAFile;
    exports.buildXform = buildXform;
    exports.calculateFaceNormal = calculateFaceNormal;
    exports.calculateFaceNormalFromFloats = calculateFaceNormalFromFloats;
    exports.calculateTransform = calculateTransform;
    exports.changesProcessed = changesProcessed;
    exports.computeLocalTransform = computeLocalTransform;
    exports.computeNormal = computeNormal;
    exports.convertHdrToEnv = convertHdrToEnv;
    exports.createAnnotationTextModels = createAnnotationTextModels;
    exports.createLightVisualization = createLightVisualization;
    exports.createSketchPointForEditor = createSketchPointForEditor;
    exports.createUvMapVisualization = createUvMapVisualization;
    exports.createViewpointVisualization = createViewpointVisualization;
    exports.defaults = defaults;
    exports.degreeToRadian = degreeToRadian;
    exports.drawLine = drawLine;
    exports.escapeGUID = escapeGUID;
    exports.excludeVertices = excludeVertices;
    exports.fillSketchPolygon = fillSketchPolygon;
    exports.getByDynamicId = getByDynamicId;
    exports.getCameraPositionWithOffset = getCameraPositionWithOffset;
    exports.getConstructorParamsForModel = getConstructorParamsForModel;
    exports.getDimensionLinePoints = getDimensionLinePoints;
    exports.getHierarchyBoundingVectors = getHierarchyBoundingVectors;
    exports.getNodeChain = getNodeChain;
    exports.getNodeMap = getNodeMap;
    exports.getPositionFromConnnector = getPositionFromConnnector;
    exports.getRotationBtwVectors = getRotationBtwVectors;
    exports.getScreenBoundingBox = getScreenBoundingBox;
    exports.getSketchNormalVector3 = getSketchNormalVector3;
    exports.getToken = getToken;
    exports.guidRegex = guidRegex;
    exports.history = history;
    exports.injectParameters = injectParameters;
    exports.instanceOf = instanceOf;
    exports.instanceOfAny = instanceOfAny;
    exports.isAbsoluteUrl = isAbsoluteUrl;
    exports.isAnnotation = isAnnotation;
    exports.isBoxMesh = isBoxMesh;
    exports.isCircularPattern = isCircularPattern;
    exports.isConeMesh = isConeMesh;
    exports.isConnector = isConnector;
    exports.isCustomMeshNode = isCustomMeshNode;
    exports.isCylinderMesh = isCylinderMesh;
    exports.isDefined = isDefined;
    exports.isDiscMesh = isDiscMesh;
    exports.isFeatureNode = isFeatureNode;
    exports.isGuid = isGuid;
    exports.isInstanceOf = isInstanceOf;
    exports.isLightNode = isLightNode;
    exports.isLinearPattern = isLinearPattern;
    exports.isMate = isMate;
    exports.isMaterialNode = isMaterialNode;
    exports.isMeshGroupNode = isMeshGroupNode;
    exports.isMeshNode = isMeshNode;
    exports.isObject = isObject$1;
    exports.isPattern = isPattern;
    exports.isPickable = isPickable;
    exports.isPlaneMesh = isPlaneMesh;
    exports.isPrimitiveMeshNode = isPrimitiveMeshNode;
    exports.isSceneNode = isSceneNode;
    exports.isSketchControlPoint = isSketchControlPoint;
    exports.isSketchNode = isSketchNode;
    exports.isSpaceNode = isSpaceNode;
    exports.isSphereMesh = isSphereMesh;
    exports.isSubmesh = isSubmesh;
    exports.isTextNode = isTextNode;
    exports.isTextureLayer = isTextureLayer;
    exports.isTorusMesh = isTorusMesh;
    exports.isTrackedArray = isTrackedArray;
    exports.isTrackedClass = isTrackedClass;
    exports.isTrackedInstance = isTrackedInstance;
    exports.isTrackedInstanceOfAny = isTrackedInstanceOfAny;
    exports.isTrackedMeshNode = isTrackedMeshNode;
    exports.isViewpointNode = isViewpointNode;
    exports.kb3dEnums = kb3dEnums;
    exports.kb3dTest = kb3dTest;
    exports.makeRotationAxis = makeRotationAxis;
    exports.mathClamp = mathClamp;
    exports.mergeVertices = mergeVertices;
    exports.mergeVerticesIntoAll = mergeVerticesIntoAll;
    exports.multiplyScalar = multiplyScalar;
    exports.nextTick = nextTick;
    exports.nodeToScreen = nodeToScreen;
    exports.ofToken = ofToken;
    exports.omitUndefinedElements = omitUndefinedElements;
    exports.parseSketchGeometry = parseSketchGeometry;
    exports.projectOnNodeAxis = projectOnNodeAxis;
    exports.removeVerticesFromAll = removeVerticesFromAll;
    exports.rotationToVector = rotationToVector;
    exports.rotationToVectorToRef = rotationToVectorToRef;
    exports.roundToPlaces = roundToPlaces;
    exports.roundVectorToPlaces = roundVectorToPlaces;
    exports.sortMates = sortMates;
    exports.toBoundingBoxInfo = toBoundingBoxInfo;
    exports.toNDC = toNDC;
    exports.toPixels = toPixels;
    exports.toRadians = toRadians;
    exports.toScreen = toScreen;
    exports.transformVectorWithQuat = transformVectorWithQuat;
    exports.updateAnnotationText = updateAnnotationText;
    exports.updateMatrixOfAncestorChain = updateMatrixOfAncestorChain;

    return exports;

}({}));
//# sourceMappingURL=viewer.js.map
